
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire86ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire86ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1avo5", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $0d9f127fca17d02e$export$a4ad2735b021c132; });
$parcel$export(module.exports, "filters", function () { return $0d9f127fca17d02e$export$82462a21aead86ed; });
$parcel$export(module.exports, "utils", function () { return (parcelRequire("csytw")); });
/*!
 * pixi.js - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * pixi.js is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ parcelRequire("b3cpf");

var $csytw = parcelRequire("csytw");

var $aZdrZ = parcelRequire("aZdrZ");

var $5q3yV = parcelRequire("5q3yV");

var $7DxQ2 = parcelRequire("7DxQ2");

var $klOfb = parcelRequire("klOfb");

var $3bQv9 = parcelRequire("3bQv9");

var $kXE1p = parcelRequire("kXE1p");

var $ejo0r = parcelRequire("ejo0r");

var $9eyo7 = parcelRequire("9eyo7");

var $1WkLv = parcelRequire("1WkLv");

var $kfhEp = parcelRequire("kfhEp");

var $eQ8XE = parcelRequire("eQ8XE");

var $hnGDn = parcelRequire("hnGDn");

var $3YyWq = parcelRequire("3YyWq");

var $9RO7y = parcelRequire("9RO7y");

var $1vBjL = parcelRequire("1vBjL");

var $aPxof = parcelRequire("aPxof");

var $68QeL = parcelRequire("68QeL");

var $a3TLq = parcelRequire("a3TLq");

var $arZq0 = parcelRequire("arZq0");
parcelRequire("aqTFY");
parcelRequire("1xfIs");
parcelRequire("60K84");

var $P8XPi = parcelRequire("P8XPi");

var $8t5Gy = parcelRequire("8t5Gy");

var $gwPoJ = parcelRequire("gwPoJ");

var $6qzqq = parcelRequire("6qzqq");

var $9Tsx3 = parcelRequire("9Tsx3");

var $eUwg9 = parcelRequire("eUwg9");

var $6fZag = parcelRequire("6fZag");

var $7Bs2Z = parcelRequire("7Bs2Z");

var $d3fD1 = parcelRequire("d3fD1");

var $9Pi8W = parcelRequire("9Pi8W");

var $ezJmd = parcelRequire("ezJmd");
// Install renderer plugins
(0, $klOfb.Renderer).registerPlugin('accessibility', (0, $aZdrZ.AccessibilityManager));
(0, $klOfb.Renderer).registerPlugin('extract', (0, $3bQv9.Extract));
(0, $klOfb.Renderer).registerPlugin('interaction', (0, $5q3yV.InteractionManager));
(0, $klOfb.Renderer).registerPlugin('particle', (0, $9eyo7.ParticleRenderer));
(0, $klOfb.Renderer).registerPlugin('prepare', (0, $1WkLv.Prepare));
(0, $klOfb.Renderer).registerPlugin('batch', (0, $klOfb.BatchRenderer));
(0, $klOfb.Renderer).registerPlugin('tilingSprite', (0, $eQ8XE.TilingSpriteRenderer));
// Install loader plugins
(0, $kXE1p.Loader).registerPlugin((0, $hnGDn.BitmapFontLoader));
(0, $kXE1p.Loader).registerPlugin((0, $ejo0r.CompressedTextureLoader));
(0, $kXE1p.Loader).registerPlugin((0, $ejo0r.DDSLoader));
(0, $kXE1p.Loader).registerPlugin((0, $ejo0r.KTXLoader));
(0, $kXE1p.Loader).registerPlugin((0, $kfhEp.SpritesheetLoader));
// Install application plugins
(0, $7DxQ2.Application).registerPlugin((0, $3YyWq.TickerPlugin));
(0, $7DxQ2.Application).registerPlugin((0, $kXE1p.AppLoaderPlugin));
/**
 * String of the current PIXI version.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name VERSION
 * @type {string}
 */ var $0d9f127fca17d02e$export$a4ad2735b021c132 = '6.2.2';
/**
 * @namespace PIXI
 */ /**
 * This namespace contains WebGL-only display filters that can be applied
 * to DisplayObjects using the {@link PIXI.DisplayObject#filters filters} property.
 *
 * Since PixiJS only had a handful of built-in filters, additional filters
 * can be downloaded {@link https://github.com/pixijs/pixi-filters here} from the
 * PixiJS Filters repository.
 *
 * All filters must extend {@link PIXI.Filter}.
 *
 * @example
 * // Create a new application
 * const app = new PIXI.Application();
 *
 * // Draw a green rectangle
 * const rect = new PIXI.Graphics()
 *     .beginFill(0x00ff00)
 *     .drawRect(40, 40, 200, 200);
 *
 * // Add a blur filter
 * rect.filters = [new PIXI.filters.BlurFilter()];
 *
 * // Display rectangle
 * app.stage.addChild(rect);
 * document.body.appendChild(app.view);
 * @namespace PIXI.filters
 */ var $0d9f127fca17d02e$export$82462a21aead86ed = {
    AlphaFilter: (0, $9RO7y.AlphaFilter),
    BlurFilter: (0, $1vBjL.BlurFilter),
    BlurFilterPass: (0, $1vBjL.BlurFilterPass),
    ColorMatrixFilter: (0, $aPxof.ColorMatrixFilter),
    DisplacementFilter: (0, $68QeL.DisplacementFilter),
    FXAAFilter: (0, $a3TLq.FXAAFilter),
    NoiseFilter: (0, $arZq0.NoiseFilter)
};
$parcel$exportWildcard(module.exports, $aZdrZ);
$parcel$exportWildcard(module.exports, $5q3yV);
$parcel$exportWildcard(module.exports, $7DxQ2);
$parcel$exportWildcard(module.exports, $klOfb);
$parcel$exportWildcard(module.exports, $3bQv9);
$parcel$exportWildcard(module.exports, $kXE1p);
$parcel$exportWildcard(module.exports, $ejo0r);
$parcel$exportWildcard(module.exports, $9eyo7);
$parcel$exportWildcard(module.exports, $1WkLv);
$parcel$exportWildcard(module.exports, $kfhEp);
$parcel$exportWildcard(module.exports, $eQ8XE);
$parcel$exportWildcard(module.exports, $hnGDn);
$parcel$exportWildcard(module.exports, $3YyWq);
$parcel$exportWildcard(module.exports, $P8XPi);
$parcel$exportWildcard(module.exports, $8t5Gy);
$parcel$exportWildcard(module.exports, $gwPoJ);
$parcel$exportWildcard(module.exports, $6qzqq);
$parcel$exportWildcard(module.exports, $9Tsx3);
$parcel$exportWildcard(module.exports, $eUwg9);
$parcel$exportWildcard(module.exports, $6fZag);
$parcel$exportWildcard(module.exports, $7Bs2Z);
$parcel$exportWildcard(module.exports, $d3fD1);
$parcel$exportWildcard(module.exports, $9Pi8W);
$parcel$exportWildcard(module.exports, $ezJmd);

});
parcelRegister("b3cpf", function(module, exports) {
/*!
 * @pixi/polyfill - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/polyfill is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $3CbAe = parcelRequire("3CbAe");

var $4yvvI = parcelRequire("4yvvI");
// Support for IE 9 - 11 which does not include Promises
if (!self.Promise) self.Promise = (0, $3CbAe.default);
// References:
if (!Object.assign) Object.assign = (0, (/*@__PURE__*/$parcel$interopDefault($4yvvI)));
// References:
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// https://gist.github.com/1579671
// http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
// https://gist.github.com/timhall/4078614
// https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/requestAnimationFrame
// Expected to be used with Browserfiy
// Browserify automatically detects the use of `global` and passes the
// correct reference of `global`, `self`, and finally `window`
var $80b99927c6fa7733$var$ONE_FRAME_TIME = 16;
// Date.now
if (!(Date.now && Date.prototype.getTime)) Date.now = function now() {
    return new Date().getTime();
};
// performance.now
if (!(self.performance && self.performance.now)) {
    var $80b99927c6fa7733$var$startTime_1 = Date.now();
    if (!self.performance) self.performance = {};
    self.performance.now = function() {
        return Date.now() - $80b99927c6fa7733$var$startTime_1;
    };
}
// requestAnimationFrame
var $80b99927c6fa7733$var$lastTime = Date.now();
var $80b99927c6fa7733$var$vendors = [
    'ms',
    'moz',
    'webkit',
    'o'
];
for(var $80b99927c6fa7733$var$x = 0; $80b99927c6fa7733$var$x < $80b99927c6fa7733$var$vendors.length && !self.requestAnimationFrame; ++$80b99927c6fa7733$var$x){
    var $80b99927c6fa7733$var$p = $80b99927c6fa7733$var$vendors[$80b99927c6fa7733$var$x];
    self.requestAnimationFrame = self[$80b99927c6fa7733$var$p + "RequestAnimationFrame"];
    self.cancelAnimationFrame = self[$80b99927c6fa7733$var$p + "CancelAnimationFrame"] || self[$80b99927c6fa7733$var$p + "CancelRequestAnimationFrame"];
}
if (!self.requestAnimationFrame) self.requestAnimationFrame = function(callback) {
    if (typeof callback !== 'function') throw new TypeError(callback + "is not a function");
    var currentTime = Date.now();
    var delay = $80b99927c6fa7733$var$ONE_FRAME_TIME + $80b99927c6fa7733$var$lastTime - currentTime;
    if (delay < 0) delay = 0;
    $80b99927c6fa7733$var$lastTime = currentTime;
    return self.setTimeout(function() {
        $80b99927c6fa7733$var$lastTime = Date.now();
        callback(performance.now());
    }, delay);
};
if (!self.cancelAnimationFrame) self.cancelAnimationFrame = function(id) {
    return clearTimeout(id);
};
// References:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
if (!Math.sign) Math.sign = function mathSign(x) {
    x = Number(x);
    if (x === 0 || isNaN(x)) return x;
    return x > 0 ? 1 : -1;
};
// References:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
if (!Number.isInteger) Number.isInteger = function numberIsInteger(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};
if (!self.ArrayBuffer) self.ArrayBuffer = Array;
if (!self.Float32Array) self.Float32Array = Array;
if (!self.Uint32Array) self.Uint32Array = Array;
if (!self.Uint16Array) self.Uint16Array = Array;
if (!self.Uint8Array) self.Uint8Array = Array;
if (!self.Int32Array) self.Int32Array = Array;

});
parcelRegister("3CbAe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a1de7efecb34b29$export$2e2bcd8739ae039; });

var $jBtjJ = parcelRequire("jBtjJ");

var $7X2wb = parcelRequire("7X2wb");

var $91Y7A = parcelRequire("91Y7A");
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $2a1de7efecb34b29$var$setTimeoutFunc = setTimeout;
function $2a1de7efecb34b29$var$isArray(x) {
    return Boolean(x && typeof x.length !== 'undefined');
}
function $2a1de7efecb34b29$var$noop() {}
// Polyfill for Function.prototype.bind
function $2a1de7efecb34b29$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $2a1de7efecb34b29$var$Promise(fn) {
    if (!(this instanceof $2a1de7efecb34b29$var$Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $2a1de7efecb34b29$var$doResolve(fn, this);
}
function $2a1de7efecb34b29$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $2a1de7efecb34b29$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $2a1de7efecb34b29$var$resolve : $2a1de7efecb34b29$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $2a1de7efecb34b29$var$reject(deferred.promise, e);
            return;
        }
        $2a1de7efecb34b29$var$resolve(deferred.promise, ret);
    });
}
function $2a1de7efecb34b29$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
        if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
            var then = newValue.then;
            if (newValue instanceof $2a1de7efecb34b29$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $2a1de7efecb34b29$var$finale(self);
                return;
            } else if (typeof then === 'function') {
                $2a1de7efecb34b29$var$doResolve($2a1de7efecb34b29$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $2a1de7efecb34b29$var$finale(self);
    } catch (e) {
        $2a1de7efecb34b29$var$reject(self, e);
    }
}
function $2a1de7efecb34b29$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $2a1de7efecb34b29$var$finale(self);
}
function $2a1de7efecb34b29$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $2a1de7efecb34b29$var$Promise._immediateFn(function() {
        if (!self._handled) $2a1de7efecb34b29$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$2a1de7efecb34b29$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $2a1de7efecb34b29$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $2a1de7efecb34b29$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $2a1de7efecb34b29$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $2a1de7efecb34b29$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $2a1de7efecb34b29$var$reject(self, ex);
    }
}
$2a1de7efecb34b29$var$Promise.prototype['catch'] = function(onRejected) {
    return this.then(null, onRejected);
};
$2a1de7efecb34b29$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($2a1de7efecb34b29$var$noop);
    $2a1de7efecb34b29$var$handle(this, new $2a1de7efecb34b29$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$2a1de7efecb34b29$var$Promise.prototype['finally'] = (0, $jBtjJ.default);
$2a1de7efecb34b29$var$Promise.all = function(arr) {
    return new $2a1de7efecb34b29$var$Promise(function(resolve, reject) {
        if (!$2a1de7efecb34b29$var$isArray(arr)) return reject(new TypeError('Promise.all accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === 'object' || typeof val === 'function')) {
                    var then = val.then;
                    if (typeof then === 'function') {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$2a1de7efecb34b29$var$Promise.any = (0, $91Y7A.default);
$2a1de7efecb34b29$var$Promise.allSettled = (0, $7X2wb.default);
$2a1de7efecb34b29$var$Promise.resolve = function(value) {
    if (value && typeof value === 'object' && value.constructor === $2a1de7efecb34b29$var$Promise) return value;
    return new $2a1de7efecb34b29$var$Promise(function(resolve) {
        resolve(value);
    });
};
$2a1de7efecb34b29$var$Promise.reject = function(value) {
    return new $2a1de7efecb34b29$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$2a1de7efecb34b29$var$Promise.race = function(arr) {
    return new $2a1de7efecb34b29$var$Promise(function(resolve, reject) {
        if (!$2a1de7efecb34b29$var$isArray(arr)) return reject(new TypeError('Promise.race accepts an array'));
        for(var i = 0, len = arr.length; i < len; i++)$2a1de7efecb34b29$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$2a1de7efecb34b29$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === 'function' && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $2a1de7efecb34b29$var$setTimeoutFunc(fn, 0);
};
$2a1de7efecb34b29$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
};
var $2a1de7efecb34b29$export$2e2bcd8739ae039 = $2a1de7efecb34b29$var$Promise;

});
parcelRegister("jBtjJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e45836d5f36de5a2$export$2e2bcd8739ae039; });
/**
 * @this {Promise}
 */ function $e45836d5f36de5a2$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $e45836d5f36de5a2$export$2e2bcd8739ae039 = $e45836d5f36de5a2$var$finallyConstructor;

});

parcelRegister("7X2wb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c9fff1b0ad3d7f0$export$2e2bcd8739ae039; });
function $5c9fff1b0ad3d7f0$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError(typeof arr + ' ' + arr + ' is not iterable(cannot read property Symbol(Symbol.iterator))'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === 'object' || typeof val === 'function')) {
                var then = val.then;
                if (typeof then === 'function') {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: 'rejected',
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: 'fulfilled',
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $5c9fff1b0ad3d7f0$export$2e2bcd8739ae039 = $5c9fff1b0ad3d7f0$var$allSettled;

});

parcelRegister("91Y7A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6932d7e814bb72d7$export$2e2bcd8739ae039; });
/**
 * @constructor
 */ function $6932d7e814bb72d7$var$AggregateError(errors, message) {
    this.name = 'AggregateError', this.errors = errors;
    this.message = message || '';
}
$6932d7e814bb72d7$var$AggregateError.prototype = Error.prototype;
function $6932d7e814bb72d7$var$any(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== 'undefined')) return reject(new TypeError('Promise.any accepts an array'));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return reject();
        var rejectionReasons = [];
        for(var i = 0; i < args.length; i++)try {
            P.resolve(args[i]).then(resolve).catch(function(error) {
                rejectionReasons.push(error);
                if (rejectionReasons.length === args.length) reject(new $6932d7e814bb72d7$var$AggregateError(rejectionReasons, 'All promises were rejected'));
            });
        } catch (ex) {
            reject(ex);
        }
    });
}
var $6932d7e814bb72d7$export$2e2bcd8739ae039 = $6932d7e814bb72d7$var$any;

});


parcelRegister("4yvvI", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $3512c7c00a4083d8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3512c7c00a4083d8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $3512c7c00a4083d8$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $3512c7c00a4083d8$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $3512c7c00a4083d8$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $3512c7c00a4083d8$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $3512c7c00a4083d8$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($3512c7c00a4083d8$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($3512c7c00a4083d8$var$getOwnPropertySymbols) {
            symbols = $3512c7c00a4083d8$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($3512c7c00a4083d8$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("csytw", function(module, exports) {

$parcel$export(module.exports, "url", function () { return $9122d79b52dc54f0$export$128fa18b7194ef; });
$parcel$export(module.exports, "skipHello", function () { return $9122d79b52dc54f0$export$702210f86367d7ed; });
$parcel$export(module.exports, "sayHello", function () { return $9122d79b52dc54f0$export$2c6a96c059a06e7c; });
$parcel$export(module.exports, "isWebGLSupported", function () { return $9122d79b52dc54f0$export$83dc396b76015322; });
$parcel$export(module.exports, "hex2rgb", function () { return $9122d79b52dc54f0$export$858a46ce014e0e87; });
$parcel$export(module.exports, "hex2string", function () { return $9122d79b52dc54f0$export$7a57339af2222169; });
$parcel$export(module.exports, "string2hex", function () { return $9122d79b52dc54f0$export$f6a774610dbc2f6; });
$parcel$export(module.exports, "rgb2hex", function () { return $9122d79b52dc54f0$export$883528fb0afa7177; });
$parcel$export(module.exports, "premultiplyBlendMode", function () { return $9122d79b52dc54f0$export$799d0d31e2f4c737; });
$parcel$export(module.exports, "correctBlendMode", function () { return $9122d79b52dc54f0$export$3d793623cb0d1905; });
$parcel$export(module.exports, "premultiplyRgba", function () { return $9122d79b52dc54f0$export$4fa4eaa2922d1869; });
$parcel$export(module.exports, "premultiplyTint", function () { return $9122d79b52dc54f0$export$1ddadce6229d3efd; });
$parcel$export(module.exports, "premultiplyTintToRgba", function () { return $9122d79b52dc54f0$export$c75351d34304eb8c; });
$parcel$export(module.exports, "createIndicesForQuads", function () { return $9122d79b52dc54f0$export$c56148e1bec42281; });
$parcel$export(module.exports, "getBufferType", function () { return $9122d79b52dc54f0$export$adf72b506413cb57; });
$parcel$export(module.exports, "interleaveTypedArrays", function () { return $9122d79b52dc54f0$export$1ce3e224e969bb24; });
$parcel$export(module.exports, "nextPow2", function () { return $9122d79b52dc54f0$export$f0d90cf68bd426eb; });
$parcel$export(module.exports, "isPow2", function () { return $9122d79b52dc54f0$export$eb50b9c078eb6ae7; });
$parcel$export(module.exports, "log2", function () { return $9122d79b52dc54f0$export$b9fae0bba9d9094d; });
$parcel$export(module.exports, "removeItems", function () { return $9122d79b52dc54f0$export$8d47c0e1ce445404; });
$parcel$export(module.exports, "sign", function () { return $9122d79b52dc54f0$export$c5552dfdbc7cec71; });
$parcel$export(module.exports, "uid", function () { return $9122d79b52dc54f0$export$e2a22331486dcca0; });
$parcel$export(module.exports, "deprecation", function () { return $9122d79b52dc54f0$export$afd31d834b512e89; });
$parcel$export(module.exports, "ProgramCache", function () { return $9122d79b52dc54f0$export$d47c7e291d8b6e2c; });
$parcel$export(module.exports, "TextureCache", function () { return $9122d79b52dc54f0$export$4254ab7c0971430e; });
$parcel$export(module.exports, "BaseTextureCache", function () { return $9122d79b52dc54f0$export$cec649a143d060b1; });
$parcel$export(module.exports, "destroyTextureCache", function () { return $9122d79b52dc54f0$export$b5c9bc385f713d5a; });
$parcel$export(module.exports, "clearTextureCache", function () { return $9122d79b52dc54f0$export$3ee9cef7c9878d34; });
$parcel$export(module.exports, "CanvasRenderTarget", function () { return $9122d79b52dc54f0$export$525943d4c7cdfa38; });
$parcel$export(module.exports, "trimCanvas", function () { return $9122d79b52dc54f0$export$658947b9914dd428; });
$parcel$export(module.exports, "DATA_URI", function () { return $9122d79b52dc54f0$export$dbafa72958753fce; });
$parcel$export(module.exports, "decomposeDataUri", function () { return $9122d79b52dc54f0$export$672224f9983ff723; });
$parcel$export(module.exports, "determineCrossOrigin", function () { return $9122d79b52dc54f0$export$292083da55c5b406; });
$parcel$export(module.exports, "getResolutionOfUrl", function () { return $9122d79b52dc54f0$export$8695ab2f322d2637; });
$parcel$export(module.exports, "isMobile", function () { return (parcelRequire("ezJmd")).isMobile; });
$parcel$export(module.exports, "EventEmitter", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6p5EE")))); });
$parcel$export(module.exports, "earcut", function () { return (/*@__PURE__*/$parcel$interopDefault((parcelRequire("fPquT")))); });
/*!
 * @pixi/utils - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/utils is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $ezJmd = parcelRequire("ezJmd");

var $6p5EE = parcelRequire("6p5EE");

var $fPquT = parcelRequire("fPquT");

var $hH01d = parcelRequire("hH01d");

var $P8XPi = parcelRequire("P8XPi");
/**
 * This file contains redeclared types for Node `url` and `querystring` modules. These modules
 * don't provide their own typings but instead are a part of the full Node typings. The purpose of
 * this file is to redeclare the required types to avoid having the whole Node types as a
 * dependency.
 */ var $9122d79b52dc54f0$export$128fa18b7194ef = {
    parse: (0, $hH01d.parse),
    format: (0, $hH01d.format),
    resolve: (0, $hH01d.resolve)
};
/**
 * The prefix that denotes a URL is for a retina asset.
 *
 * @static
 * @name RETINA_PREFIX
 * @memberof PIXI.settings
 * @type {RegExp}
 * @default /@([0-9\.]+)x/
 * @example `@2x`
 */ (0, $ezJmd.settings).RETINA_PREFIX = /@([0-9\.]+)x/;
/**
 * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported` function.
 * If set to true, a WebGL renderer can fail to be created if the browser thinks there could be performance issues when
 * using WebGL.
 *
 * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many scenarios as possible.
 * However, some users may have a poor experience, for example, if a user has a gpu or driver version blacklisted by the
 * browser.
 *
 * If your application requires high performance rendering, you may wish to set this to false.
 * We recommend one of two options if you decide to set this flag to false:
 *
 * 1: Use the `pixi.js-legacy` package, which includes a Canvas renderer as a fallback in case high performance WebGL is
 *    not supported.
 *
 * 2: Call `isWebGLSupported` (which if found in the PIXI.utils package) in your code before attempting to create a PixiJS
 *    renderer, and show an error message to the user if the function returns false, explaining that their device & browser
 *    combination does not support high performance WebGL.
 *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
 *
 * @static
 * @name FAIL_IF_MAJOR_PERFORMANCE_CAVEAT
 * @memberof PIXI.settings
 * @type {boolean}
 * @default false
 */ (0, $ezJmd.settings).FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = false;
var $9122d79b52dc54f0$var$saidHello = false;
var $9122d79b52dc54f0$var$VERSION = '6.2.2';
/**
 * Skips the hello message of renderers that are created after this is run.
 *
 * @function skipHello
 * @memberof PIXI.utils
 */ function $9122d79b52dc54f0$export$702210f86367d7ed() {
    $9122d79b52dc54f0$var$saidHello = true;
}
/**
 * Logs out the version and renderer information for this running instance of PIXI.
 * If you don't want to see this message you can run `PIXI.utils.skipHello()` before
 * creating your renderer. Keep in mind that doing that will forever make you a jerk face.
 *
 * @static
 * @function sayHello
 * @memberof PIXI.utils
 * @param {string} type - The string renderer type to log.
 */ function $9122d79b52dc54f0$export$2c6a96c059a06e7c(type) {
    var _a;
    if ($9122d79b52dc54f0$var$saidHello) return;
    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
        var args = [
            "\n %c %c %c PixiJS " + $9122d79b52dc54f0$var$VERSION + " - \u2730 " + type + " \u2730  %c  %c  http://www.pixijs.com/  %c %c \u2665%c\u2665%c\u2665 \n\n",
            'background: #ff66a5; padding:5px 0;',
            'background: #ff66a5; padding:5px 0;',
            'color: #ff66a5; background: #030307; padding:5px 0;',
            'background: #ff66a5; padding:5px 0;',
            'background: #ffc3dc; padding:5px 0;',
            'background: #ff66a5; padding:5px 0;',
            'color: #ff2424; background: #fff; padding:5px 0;',
            'color: #ff2424; background: #fff; padding:5px 0;',
            'color: #ff2424; background: #fff; padding:5px 0;'
        ];
        (_a = self.console).log.apply(_a, args);
    } else if (self.console) self.console.log("PixiJS " + $9122d79b52dc54f0$var$VERSION + " - " + type + " - http://www.pixijs.com/");
    $9122d79b52dc54f0$var$saidHello = true;
}
var $9122d79b52dc54f0$var$supported;
/**
 * Helper for checking for WebGL support.
 *
 * @memberof PIXI.utils
 * @function isWebGLSupported
 * @return {boolean} Is WebGL supported.
 */ function $9122d79b52dc54f0$export$83dc396b76015322() {
    if (typeof $9122d79b52dc54f0$var$supported === 'undefined') $9122d79b52dc54f0$var$supported = function supported() {
        var contextOptions = {
            stencil: true,
            failIfMajorPerformanceCaveat: (0, $ezJmd.settings).FAIL_IF_MAJOR_PERFORMANCE_CAVEAT
        };
        try {
            if (!self.WebGLRenderingContext) return false;
            var canvas = document.createElement('canvas');
            var gl = canvas.getContext('webgl', contextOptions) || canvas.getContext('experimental-webgl', contextOptions);
            var success = !!(gl && gl.getContextAttributes().stencil);
            if (gl) {
                var loseContext = gl.getExtension('WEBGL_lose_context');
                if (loseContext) loseContext.loseContext();
            }
            gl = null;
            return success;
        } catch (e) {
            return false;
        }
    }();
    return $9122d79b52dc54f0$var$supported;
}
var $9122d79b52dc54f0$var$aliceblue = "#f0f8ff";
var $9122d79b52dc54f0$var$antiquewhite = "#faebd7";
var $9122d79b52dc54f0$var$aqua = "#00ffff";
var $9122d79b52dc54f0$var$aquamarine = "#7fffd4";
var $9122d79b52dc54f0$var$azure = "#f0ffff";
var $9122d79b52dc54f0$var$beige = "#f5f5dc";
var $9122d79b52dc54f0$var$bisque = "#ffe4c4";
var $9122d79b52dc54f0$var$black = "#000000";
var $9122d79b52dc54f0$var$blanchedalmond = "#ffebcd";
var $9122d79b52dc54f0$var$blue = "#0000ff";
var $9122d79b52dc54f0$var$blueviolet = "#8a2be2";
var $9122d79b52dc54f0$var$brown = "#a52a2a";
var $9122d79b52dc54f0$var$burlywood = "#deb887";
var $9122d79b52dc54f0$var$cadetblue = "#5f9ea0";
var $9122d79b52dc54f0$var$chartreuse = "#7fff00";
var $9122d79b52dc54f0$var$chocolate = "#d2691e";
var $9122d79b52dc54f0$var$coral = "#ff7f50";
var $9122d79b52dc54f0$var$cornflowerblue = "#6495ed";
var $9122d79b52dc54f0$var$cornsilk = "#fff8dc";
var $9122d79b52dc54f0$var$crimson = "#dc143c";
var $9122d79b52dc54f0$var$cyan = "#00ffff";
var $9122d79b52dc54f0$var$darkblue = "#00008b";
var $9122d79b52dc54f0$var$darkcyan = "#008b8b";
var $9122d79b52dc54f0$var$darkgoldenrod = "#b8860b";
var $9122d79b52dc54f0$var$darkgray = "#a9a9a9";
var $9122d79b52dc54f0$var$darkgreen = "#006400";
var $9122d79b52dc54f0$var$darkgrey = "#a9a9a9";
var $9122d79b52dc54f0$var$darkkhaki = "#bdb76b";
var $9122d79b52dc54f0$var$darkmagenta = "#8b008b";
var $9122d79b52dc54f0$var$darkolivegreen = "#556b2f";
var $9122d79b52dc54f0$var$darkorange = "#ff8c00";
var $9122d79b52dc54f0$var$darkorchid = "#9932cc";
var $9122d79b52dc54f0$var$darkred = "#8b0000";
var $9122d79b52dc54f0$var$darksalmon = "#e9967a";
var $9122d79b52dc54f0$var$darkseagreen = "#8fbc8f";
var $9122d79b52dc54f0$var$darkslateblue = "#483d8b";
var $9122d79b52dc54f0$var$darkslategray = "#2f4f4f";
var $9122d79b52dc54f0$var$darkslategrey = "#2f4f4f";
var $9122d79b52dc54f0$var$darkturquoise = "#00ced1";
var $9122d79b52dc54f0$var$darkviolet = "#9400d3";
var $9122d79b52dc54f0$var$deeppink = "#ff1493";
var $9122d79b52dc54f0$var$deepskyblue = "#00bfff";
var $9122d79b52dc54f0$var$dimgray = "#696969";
var $9122d79b52dc54f0$var$dimgrey = "#696969";
var $9122d79b52dc54f0$var$dodgerblue = "#1e90ff";
var $9122d79b52dc54f0$var$firebrick = "#b22222";
var $9122d79b52dc54f0$var$floralwhite = "#fffaf0";
var $9122d79b52dc54f0$var$forestgreen = "#228b22";
var $9122d79b52dc54f0$var$fuchsia = "#ff00ff";
var $9122d79b52dc54f0$var$gainsboro = "#dcdcdc";
var $9122d79b52dc54f0$var$ghostwhite = "#f8f8ff";
var $9122d79b52dc54f0$var$goldenrod = "#daa520";
var $9122d79b52dc54f0$var$gold = "#ffd700";
var $9122d79b52dc54f0$var$gray = "#808080";
var $9122d79b52dc54f0$var$green = "#008000";
var $9122d79b52dc54f0$var$greenyellow = "#adff2f";
var $9122d79b52dc54f0$var$grey = "#808080";
var $9122d79b52dc54f0$var$honeydew = "#f0fff0";
var $9122d79b52dc54f0$var$hotpink = "#ff69b4";
var $9122d79b52dc54f0$var$indianred = "#cd5c5c";
var $9122d79b52dc54f0$var$indigo = "#4b0082";
var $9122d79b52dc54f0$var$ivory = "#fffff0";
var $9122d79b52dc54f0$var$khaki = "#f0e68c";
var $9122d79b52dc54f0$var$lavenderblush = "#fff0f5";
var $9122d79b52dc54f0$var$lavender = "#e6e6fa";
var $9122d79b52dc54f0$var$lawngreen = "#7cfc00";
var $9122d79b52dc54f0$var$lemonchiffon = "#fffacd";
var $9122d79b52dc54f0$var$lightblue = "#add8e6";
var $9122d79b52dc54f0$var$lightcoral = "#f08080";
var $9122d79b52dc54f0$var$lightcyan = "#e0ffff";
var $9122d79b52dc54f0$var$lightgoldenrodyellow = "#fafad2";
var $9122d79b52dc54f0$var$lightgray = "#d3d3d3";
var $9122d79b52dc54f0$var$lightgreen = "#90ee90";
var $9122d79b52dc54f0$var$lightgrey = "#d3d3d3";
var $9122d79b52dc54f0$var$lightpink = "#ffb6c1";
var $9122d79b52dc54f0$var$lightsalmon = "#ffa07a";
var $9122d79b52dc54f0$var$lightseagreen = "#20b2aa";
var $9122d79b52dc54f0$var$lightskyblue = "#87cefa";
var $9122d79b52dc54f0$var$lightslategray = "#778899";
var $9122d79b52dc54f0$var$lightslategrey = "#778899";
var $9122d79b52dc54f0$var$lightsteelblue = "#b0c4de";
var $9122d79b52dc54f0$var$lightyellow = "#ffffe0";
var $9122d79b52dc54f0$var$lime = "#00ff00";
var $9122d79b52dc54f0$var$limegreen = "#32cd32";
var $9122d79b52dc54f0$var$linen = "#faf0e6";
var $9122d79b52dc54f0$var$magenta = "#ff00ff";
var $9122d79b52dc54f0$var$maroon = "#800000";
var $9122d79b52dc54f0$var$mediumaquamarine = "#66cdaa";
var $9122d79b52dc54f0$var$mediumblue = "#0000cd";
var $9122d79b52dc54f0$var$mediumorchid = "#ba55d3";
var $9122d79b52dc54f0$var$mediumpurple = "#9370db";
var $9122d79b52dc54f0$var$mediumseagreen = "#3cb371";
var $9122d79b52dc54f0$var$mediumslateblue = "#7b68ee";
var $9122d79b52dc54f0$var$mediumspringgreen = "#00fa9a";
var $9122d79b52dc54f0$var$mediumturquoise = "#48d1cc";
var $9122d79b52dc54f0$var$mediumvioletred = "#c71585";
var $9122d79b52dc54f0$var$midnightblue = "#191970";
var $9122d79b52dc54f0$var$mintcream = "#f5fffa";
var $9122d79b52dc54f0$var$mistyrose = "#ffe4e1";
var $9122d79b52dc54f0$var$moccasin = "#ffe4b5";
var $9122d79b52dc54f0$var$navajowhite = "#ffdead";
var $9122d79b52dc54f0$var$navy = "#000080";
var $9122d79b52dc54f0$var$oldlace = "#fdf5e6";
var $9122d79b52dc54f0$var$olive = "#808000";
var $9122d79b52dc54f0$var$olivedrab = "#6b8e23";
var $9122d79b52dc54f0$var$orange = "#ffa500";
var $9122d79b52dc54f0$var$orangered = "#ff4500";
var $9122d79b52dc54f0$var$orchid = "#da70d6";
var $9122d79b52dc54f0$var$palegoldenrod = "#eee8aa";
var $9122d79b52dc54f0$var$palegreen = "#98fb98";
var $9122d79b52dc54f0$var$paleturquoise = "#afeeee";
var $9122d79b52dc54f0$var$palevioletred = "#db7093";
var $9122d79b52dc54f0$var$papayawhip = "#ffefd5";
var $9122d79b52dc54f0$var$peachpuff = "#ffdab9";
var $9122d79b52dc54f0$var$peru = "#cd853f";
var $9122d79b52dc54f0$var$pink = "#ffc0cb";
var $9122d79b52dc54f0$var$plum = "#dda0dd";
var $9122d79b52dc54f0$var$powderblue = "#b0e0e6";
var $9122d79b52dc54f0$var$purple = "#800080";
var $9122d79b52dc54f0$var$rebeccapurple = "#663399";
var $9122d79b52dc54f0$var$red = "#ff0000";
var $9122d79b52dc54f0$var$rosybrown = "#bc8f8f";
var $9122d79b52dc54f0$var$royalblue = "#4169e1";
var $9122d79b52dc54f0$var$saddlebrown = "#8b4513";
var $9122d79b52dc54f0$var$salmon = "#fa8072";
var $9122d79b52dc54f0$var$sandybrown = "#f4a460";
var $9122d79b52dc54f0$var$seagreen = "#2e8b57";
var $9122d79b52dc54f0$var$seashell = "#fff5ee";
var $9122d79b52dc54f0$var$sienna = "#a0522d";
var $9122d79b52dc54f0$var$silver = "#c0c0c0";
var $9122d79b52dc54f0$var$skyblue = "#87ceeb";
var $9122d79b52dc54f0$var$slateblue = "#6a5acd";
var $9122d79b52dc54f0$var$slategray = "#708090";
var $9122d79b52dc54f0$var$slategrey = "#708090";
var $9122d79b52dc54f0$var$snow = "#fffafa";
var $9122d79b52dc54f0$var$springgreen = "#00ff7f";
var $9122d79b52dc54f0$var$steelblue = "#4682b4";
var $9122d79b52dc54f0$var$tan = "#d2b48c";
var $9122d79b52dc54f0$var$teal = "#008080";
var $9122d79b52dc54f0$var$thistle = "#d8bfd8";
var $9122d79b52dc54f0$var$tomato = "#ff6347";
var $9122d79b52dc54f0$var$turquoise = "#40e0d0";
var $9122d79b52dc54f0$var$violet = "#ee82ee";
var $9122d79b52dc54f0$var$wheat = "#f5deb3";
var $9122d79b52dc54f0$var$white = "#ffffff";
var $9122d79b52dc54f0$var$whitesmoke = "#f5f5f5";
var $9122d79b52dc54f0$var$yellow = "#ffff00";
var $9122d79b52dc54f0$var$yellowgreen = "#9acd32";
var $9122d79b52dc54f0$var$cssColorNames = {
    aliceblue: $9122d79b52dc54f0$var$aliceblue,
    antiquewhite: $9122d79b52dc54f0$var$antiquewhite,
    aqua: $9122d79b52dc54f0$var$aqua,
    aquamarine: $9122d79b52dc54f0$var$aquamarine,
    azure: $9122d79b52dc54f0$var$azure,
    beige: $9122d79b52dc54f0$var$beige,
    bisque: $9122d79b52dc54f0$var$bisque,
    black: $9122d79b52dc54f0$var$black,
    blanchedalmond: $9122d79b52dc54f0$var$blanchedalmond,
    blue: $9122d79b52dc54f0$var$blue,
    blueviolet: $9122d79b52dc54f0$var$blueviolet,
    brown: $9122d79b52dc54f0$var$brown,
    burlywood: $9122d79b52dc54f0$var$burlywood,
    cadetblue: $9122d79b52dc54f0$var$cadetblue,
    chartreuse: $9122d79b52dc54f0$var$chartreuse,
    chocolate: $9122d79b52dc54f0$var$chocolate,
    coral: $9122d79b52dc54f0$var$coral,
    cornflowerblue: $9122d79b52dc54f0$var$cornflowerblue,
    cornsilk: $9122d79b52dc54f0$var$cornsilk,
    crimson: $9122d79b52dc54f0$var$crimson,
    cyan: $9122d79b52dc54f0$var$cyan,
    darkblue: $9122d79b52dc54f0$var$darkblue,
    darkcyan: $9122d79b52dc54f0$var$darkcyan,
    darkgoldenrod: $9122d79b52dc54f0$var$darkgoldenrod,
    darkgray: $9122d79b52dc54f0$var$darkgray,
    darkgreen: $9122d79b52dc54f0$var$darkgreen,
    darkgrey: $9122d79b52dc54f0$var$darkgrey,
    darkkhaki: $9122d79b52dc54f0$var$darkkhaki,
    darkmagenta: $9122d79b52dc54f0$var$darkmagenta,
    darkolivegreen: $9122d79b52dc54f0$var$darkolivegreen,
    darkorange: $9122d79b52dc54f0$var$darkorange,
    darkorchid: $9122d79b52dc54f0$var$darkorchid,
    darkred: $9122d79b52dc54f0$var$darkred,
    darksalmon: $9122d79b52dc54f0$var$darksalmon,
    darkseagreen: $9122d79b52dc54f0$var$darkseagreen,
    darkslateblue: $9122d79b52dc54f0$var$darkslateblue,
    darkslategray: $9122d79b52dc54f0$var$darkslategray,
    darkslategrey: $9122d79b52dc54f0$var$darkslategrey,
    darkturquoise: $9122d79b52dc54f0$var$darkturquoise,
    darkviolet: $9122d79b52dc54f0$var$darkviolet,
    deeppink: $9122d79b52dc54f0$var$deeppink,
    deepskyblue: $9122d79b52dc54f0$var$deepskyblue,
    dimgray: $9122d79b52dc54f0$var$dimgray,
    dimgrey: $9122d79b52dc54f0$var$dimgrey,
    dodgerblue: $9122d79b52dc54f0$var$dodgerblue,
    firebrick: $9122d79b52dc54f0$var$firebrick,
    floralwhite: $9122d79b52dc54f0$var$floralwhite,
    forestgreen: $9122d79b52dc54f0$var$forestgreen,
    fuchsia: $9122d79b52dc54f0$var$fuchsia,
    gainsboro: $9122d79b52dc54f0$var$gainsboro,
    ghostwhite: $9122d79b52dc54f0$var$ghostwhite,
    goldenrod: $9122d79b52dc54f0$var$goldenrod,
    gold: $9122d79b52dc54f0$var$gold,
    gray: $9122d79b52dc54f0$var$gray,
    green: $9122d79b52dc54f0$var$green,
    greenyellow: $9122d79b52dc54f0$var$greenyellow,
    grey: $9122d79b52dc54f0$var$grey,
    honeydew: $9122d79b52dc54f0$var$honeydew,
    hotpink: $9122d79b52dc54f0$var$hotpink,
    indianred: $9122d79b52dc54f0$var$indianred,
    indigo: $9122d79b52dc54f0$var$indigo,
    ivory: $9122d79b52dc54f0$var$ivory,
    khaki: $9122d79b52dc54f0$var$khaki,
    lavenderblush: $9122d79b52dc54f0$var$lavenderblush,
    lavender: $9122d79b52dc54f0$var$lavender,
    lawngreen: $9122d79b52dc54f0$var$lawngreen,
    lemonchiffon: $9122d79b52dc54f0$var$lemonchiffon,
    lightblue: $9122d79b52dc54f0$var$lightblue,
    lightcoral: $9122d79b52dc54f0$var$lightcoral,
    lightcyan: $9122d79b52dc54f0$var$lightcyan,
    lightgoldenrodyellow: $9122d79b52dc54f0$var$lightgoldenrodyellow,
    lightgray: $9122d79b52dc54f0$var$lightgray,
    lightgreen: $9122d79b52dc54f0$var$lightgreen,
    lightgrey: $9122d79b52dc54f0$var$lightgrey,
    lightpink: $9122d79b52dc54f0$var$lightpink,
    lightsalmon: $9122d79b52dc54f0$var$lightsalmon,
    lightseagreen: $9122d79b52dc54f0$var$lightseagreen,
    lightskyblue: $9122d79b52dc54f0$var$lightskyblue,
    lightslategray: $9122d79b52dc54f0$var$lightslategray,
    lightslategrey: $9122d79b52dc54f0$var$lightslategrey,
    lightsteelblue: $9122d79b52dc54f0$var$lightsteelblue,
    lightyellow: $9122d79b52dc54f0$var$lightyellow,
    lime: $9122d79b52dc54f0$var$lime,
    limegreen: $9122d79b52dc54f0$var$limegreen,
    linen: $9122d79b52dc54f0$var$linen,
    magenta: $9122d79b52dc54f0$var$magenta,
    maroon: $9122d79b52dc54f0$var$maroon,
    mediumaquamarine: $9122d79b52dc54f0$var$mediumaquamarine,
    mediumblue: $9122d79b52dc54f0$var$mediumblue,
    mediumorchid: $9122d79b52dc54f0$var$mediumorchid,
    mediumpurple: $9122d79b52dc54f0$var$mediumpurple,
    mediumseagreen: $9122d79b52dc54f0$var$mediumseagreen,
    mediumslateblue: $9122d79b52dc54f0$var$mediumslateblue,
    mediumspringgreen: $9122d79b52dc54f0$var$mediumspringgreen,
    mediumturquoise: $9122d79b52dc54f0$var$mediumturquoise,
    mediumvioletred: $9122d79b52dc54f0$var$mediumvioletred,
    midnightblue: $9122d79b52dc54f0$var$midnightblue,
    mintcream: $9122d79b52dc54f0$var$mintcream,
    mistyrose: $9122d79b52dc54f0$var$mistyrose,
    moccasin: $9122d79b52dc54f0$var$moccasin,
    navajowhite: $9122d79b52dc54f0$var$navajowhite,
    navy: $9122d79b52dc54f0$var$navy,
    oldlace: $9122d79b52dc54f0$var$oldlace,
    olive: $9122d79b52dc54f0$var$olive,
    olivedrab: $9122d79b52dc54f0$var$olivedrab,
    orange: $9122d79b52dc54f0$var$orange,
    orangered: $9122d79b52dc54f0$var$orangered,
    orchid: $9122d79b52dc54f0$var$orchid,
    palegoldenrod: $9122d79b52dc54f0$var$palegoldenrod,
    palegreen: $9122d79b52dc54f0$var$palegreen,
    paleturquoise: $9122d79b52dc54f0$var$paleturquoise,
    palevioletred: $9122d79b52dc54f0$var$palevioletred,
    papayawhip: $9122d79b52dc54f0$var$papayawhip,
    peachpuff: $9122d79b52dc54f0$var$peachpuff,
    peru: $9122d79b52dc54f0$var$peru,
    pink: $9122d79b52dc54f0$var$pink,
    plum: $9122d79b52dc54f0$var$plum,
    powderblue: $9122d79b52dc54f0$var$powderblue,
    purple: $9122d79b52dc54f0$var$purple,
    rebeccapurple: $9122d79b52dc54f0$var$rebeccapurple,
    red: $9122d79b52dc54f0$var$red,
    rosybrown: $9122d79b52dc54f0$var$rosybrown,
    royalblue: $9122d79b52dc54f0$var$royalblue,
    saddlebrown: $9122d79b52dc54f0$var$saddlebrown,
    salmon: $9122d79b52dc54f0$var$salmon,
    sandybrown: $9122d79b52dc54f0$var$sandybrown,
    seagreen: $9122d79b52dc54f0$var$seagreen,
    seashell: $9122d79b52dc54f0$var$seashell,
    sienna: $9122d79b52dc54f0$var$sienna,
    silver: $9122d79b52dc54f0$var$silver,
    skyblue: $9122d79b52dc54f0$var$skyblue,
    slateblue: $9122d79b52dc54f0$var$slateblue,
    slategray: $9122d79b52dc54f0$var$slategray,
    slategrey: $9122d79b52dc54f0$var$slategrey,
    snow: $9122d79b52dc54f0$var$snow,
    springgreen: $9122d79b52dc54f0$var$springgreen,
    steelblue: $9122d79b52dc54f0$var$steelblue,
    tan: $9122d79b52dc54f0$var$tan,
    teal: $9122d79b52dc54f0$var$teal,
    thistle: $9122d79b52dc54f0$var$thistle,
    tomato: $9122d79b52dc54f0$var$tomato,
    turquoise: $9122d79b52dc54f0$var$turquoise,
    violet: $9122d79b52dc54f0$var$violet,
    wheat: $9122d79b52dc54f0$var$wheat,
    white: $9122d79b52dc54f0$var$white,
    whitesmoke: $9122d79b52dc54f0$var$whitesmoke,
    yellow: $9122d79b52dc54f0$var$yellow,
    yellowgreen: $9122d79b52dc54f0$var$yellowgreen
};
/**
 * Converts a hexadecimal color number to an [R, G, B] array of normalized floats (numbers from 0.0 to 1.0).
 *
 * @example
 * PIXI.utils.hex2rgb(0xffffff); // returns [1, 1, 1]
 * @memberof PIXI.utils
 * @function hex2rgb
 * @param {number} hex - The hexadecimal number to convert
 * @param  {number[]} [out=[]] - If supplied, this array will be used rather than returning a new one
 * @return {number[]} An array representing the [R, G, B] of the color where all values are floats.
 */ function $9122d79b52dc54f0$export$858a46ce014e0e87(hex, out) {
    if (out === void 0) out = [];
    out[0] = (hex >> 16 & 0xFF) / 255;
    out[1] = (hex >> 8 & 0xFF) / 255;
    out[2] = (hex & 0xFF) / 255;
    return out;
}
/**
 * Converts a hexadecimal color number to a string.
 *
 * @example
 * PIXI.utils.hex2string(0xffffff); // returns "#ffffff"
 * @memberof PIXI.utils
 * @function hex2string
 * @param {number} hex - Number in hex (e.g., `0xffffff`)
 * @return {string} The string color (e.g., `"#ffffff"`).
 */ function $9122d79b52dc54f0$export$7a57339af2222169(hex) {
    var hexString = hex.toString(16);
    hexString = '000000'.substr(0, 6 - hexString.length) + hexString;
    return "#" + hexString;
}
/**
 * Converts a string to a hexadecimal color number.
 * It can handle:
 *  hex strings starting with #: "#ffffff"
 *  hex strings starting with 0x: "0xffffff"
 *  hex strings without prefix: "ffffff"
 *  css colors: "black"
 *
 * @example
 * PIXI.utils.string2hex("#ffffff"); // returns 0xffffff
 * @memberof PIXI.utils
 * @function string2hex
 * @param {string} string - The string color (e.g., `"#ffffff"`)
 * @return {number} Number in hexadecimal.
 */ function $9122d79b52dc54f0$export$f6a774610dbc2f6(string) {
    if (typeof string === 'string') {
        string = $9122d79b52dc54f0$var$cssColorNames[string.toLowerCase()] || string;
        if (string[0] === '#') string = string.substr(1);
    }
    return parseInt(string, 16);
}
/**
 * Converts a color as an [R, G, B] array of normalized floats to a hexadecimal number.
 *
 * @example
 * PIXI.utils.rgb2hex([1, 1, 1]); // returns 0xffffff
 * @memberof PIXI.utils
 * @function rgb2hex
 * @param {number[]} rgb - Array of numbers where all values are normalized floats from 0.0 to 1.0.
 * @return {number} Number in hexadecimal.
 */ function $9122d79b52dc54f0$export$883528fb0afa7177(rgb) {
    return (rgb[0] * 255 << 16) + (rgb[1] * 255 << 8) + (rgb[2] * 255 | 0);
}
/**
 * Corrects PixiJS blend, takes premultiplied alpha into account
 *
 * @memberof PIXI.utils
 * @function mapPremultipliedBlendModes
 * @private
 * @return {Array<number[]>} Mapped modes.
 */ function $9122d79b52dc54f0$var$mapPremultipliedBlendModes() {
    var pm = [];
    var npm = [];
    for(var i = 0; i < 32; i++){
        pm[i] = i;
        npm[i] = i;
    }
    pm[(0, $P8XPi.BLEND_MODES).NORMAL_NPM] = (0, $P8XPi.BLEND_MODES).NORMAL;
    pm[(0, $P8XPi.BLEND_MODES).ADD_NPM] = (0, $P8XPi.BLEND_MODES).ADD;
    pm[(0, $P8XPi.BLEND_MODES).SCREEN_NPM] = (0, $P8XPi.BLEND_MODES).SCREEN;
    npm[(0, $P8XPi.BLEND_MODES).NORMAL] = (0, $P8XPi.BLEND_MODES).NORMAL_NPM;
    npm[(0, $P8XPi.BLEND_MODES).ADD] = (0, $P8XPi.BLEND_MODES).ADD_NPM;
    npm[(0, $P8XPi.BLEND_MODES).SCREEN] = (0, $P8XPi.BLEND_MODES).SCREEN_NPM;
    var array = [];
    array.push(npm);
    array.push(pm);
    return array;
}
/**
 * maps premultiply flag and blendMode to adjusted blendMode
 * @memberof PIXI.utils
 * @const premultiplyBlendMode
 * @type {Array<number[]>}
 */ var $9122d79b52dc54f0$export$799d0d31e2f4c737 = $9122d79b52dc54f0$var$mapPremultipliedBlendModes();
/**
 * changes blendMode according to texture format
 *
 * @memberof PIXI.utils
 * @function correctBlendMode
 * @param {number} blendMode - supposed blend mode
 * @param {boolean} premultiplied - whether source is premultiplied
 * @returns {number} true blend mode for this texture
 */ function $9122d79b52dc54f0$export$3d793623cb0d1905(blendMode, premultiplied) {
    return $9122d79b52dc54f0$export$799d0d31e2f4c737[premultiplied ? 1 : 0][blendMode];
}
/**
 * combines rgb and alpha to out array
 *
 * @memberof PIXI.utils
 * @function premultiplyRgba
 * @param {Float32Array|number[]} rgb - input rgb
 * @param {number} alpha - alpha param
 * @param {Float32Array} [out] - output
 * @param {boolean} [premultiply=true] - do premultiply it
 * @returns {Float32Array} vec4 rgba
 */ function $9122d79b52dc54f0$export$4fa4eaa2922d1869(rgb, alpha, out, premultiply) {
    out = out || new Float32Array(4);
    if (premultiply || premultiply === undefined) {
        out[0] = rgb[0] * alpha;
        out[1] = rgb[1] * alpha;
        out[2] = rgb[2] * alpha;
    } else {
        out[0] = rgb[0];
        out[1] = rgb[1];
        out[2] = rgb[2];
    }
    out[3] = alpha;
    return out;
}
/**
 * premultiplies tint
 *
 * @memberof PIXI.utils
 * @function premultiplyTint
 * @param {number} tint - integer RGB
 * @param {number} alpha - floating point alpha (0.0-1.0)
 * @returns {number} tint multiplied by alpha
 */ function $9122d79b52dc54f0$export$1ddadce6229d3efd(tint, alpha) {
    if (alpha === 1.0) return (alpha * 255 << 24) + tint;
    if (alpha === 0.0) return 0;
    var R = tint >> 16 & 0xFF;
    var G = tint >> 8 & 0xFF;
    var B = tint & 0xFF;
    R = R * alpha + 0.5 | 0;
    G = G * alpha + 0.5 | 0;
    B = B * alpha + 0.5 | 0;
    return (alpha * 255 << 24) + (R << 16) + (G << 8) + B;
}
/**
 * converts integer tint and float alpha to vec4 form, premultiplies by default
 *
 * @memberof PIXI.utils
 * @function premultiplyTintToRgba
 * @param {number} tint - input tint
 * @param {number} alpha - alpha param
 * @param {Float32Array} [out] - output
 * @param {boolean} [premultiply=true] - do premultiply it
 * @returns {Float32Array} vec4 rgba
 */ function $9122d79b52dc54f0$export$c75351d34304eb8c(tint, alpha, out, premultiply) {
    out = out || new Float32Array(4);
    out[0] = (tint >> 16 & 0xFF) / 255.0;
    out[1] = (tint >> 8 & 0xFF) / 255.0;
    out[2] = (tint & 0xFF) / 255.0;
    if (premultiply || premultiply === undefined) {
        out[0] *= alpha;
        out[1] *= alpha;
        out[2] *= alpha;
    }
    out[3] = alpha;
    return out;
}
/**
 * Generic Mask Stack data structure
 *
 * @memberof PIXI.utils
 * @function createIndicesForQuads
 * @param {number} size - Number of quads
 * @param {Uint16Array|Uint32Array} [outBuffer] - Buffer for output, length has to be `6 * size`
 * @return {Uint16Array|Uint32Array} - Resulting index buffer
 */ function $9122d79b52dc54f0$export$c56148e1bec42281(size, outBuffer) {
    if (outBuffer === void 0) outBuffer = null;
    // the total number of indices in our array, there are 6 points per quad.
    var totalIndices = size * 6;
    outBuffer = outBuffer || new Uint16Array(totalIndices);
    if (outBuffer.length !== totalIndices) throw new Error("Out buffer length is incorrect, got " + outBuffer.length + " and expected " + totalIndices);
    // fill the indices with the quads to draw
    for(var i = 0, j = 0; i < totalIndices; i += 6, j += 4){
        outBuffer[i + 0] = j + 0;
        outBuffer[i + 1] = j + 1;
        outBuffer[i + 2] = j + 2;
        outBuffer[i + 3] = j + 0;
        outBuffer[i + 4] = j + 2;
        outBuffer[i + 5] = j + 3;
    }
    return outBuffer;
}
function $9122d79b52dc54f0$export$adf72b506413cb57(array) {
    if (array.BYTES_PER_ELEMENT === 4) {
        if (array instanceof Float32Array) return 'Float32Array';
        else if (array instanceof Uint32Array) return 'Uint32Array';
        return 'Int32Array';
    } else if (array.BYTES_PER_ELEMENT === 2) {
        if (array instanceof Uint16Array) return 'Uint16Array';
    } else if (array.BYTES_PER_ELEMENT === 1) {
        if (array instanceof Uint8Array) return 'Uint8Array';
    }
    // TODO map out the rest of the array elements!
    return null;
}
/* eslint-disable object-shorthand */ var $9122d79b52dc54f0$var$map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array
};
function $9122d79b52dc54f0$export$1ce3e224e969bb24(arrays, sizes) {
    var outSize = 0;
    var stride = 0;
    var views = {};
    for(var i = 0; i < arrays.length; i++){
        stride += sizes[i];
        outSize += arrays[i].length;
    }
    var buffer = new ArrayBuffer(outSize * 4);
    var out = null;
    var littleOffset = 0;
    for(var i = 0; i < arrays.length; i++){
        var size = sizes[i];
        var array = arrays[i];
        /*
        @todo This is unsafe casting but consistent with how the code worked previously. Should it stay this way
              or should and `getBufferTypeUnsafe` function be exposed that throws an Error if unsupported type is passed?
         */ var type = $9122d79b52dc54f0$export$adf72b506413cb57(array);
        if (!views[type]) views[type] = new $9122d79b52dc54f0$var$map[type](buffer);
        out = views[type];
        for(var j = 0; j < array.length; j++){
            var indexStart = (j / size | 0) * stride + littleOffset;
            var index = j % size;
            out[indexStart + index] = array[j];
        }
        littleOffset += size;
    }
    return new Float32Array(buffer);
}
// Taken from the bit-twiddle package
/**
 * Rounds to next power of two.
 *
 * @function nextPow2
 * @memberof PIXI.utils
 * @param {number} v - input value
 * @return {number}
 */ function $9122d79b52dc54f0$export$f0d90cf68bd426eb(v) {
    v += v === 0 ? 1 : 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
}
/**
 * Checks if a number is a power of two.
 *
 * @function isPow2
 * @memberof PIXI.utils
 * @param {number} v - input value
 * @return {boolean} `true` if value is power of two
 */ function $9122d79b52dc54f0$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
/**
 * Computes ceil of log base 2
 *
 * @function log2
 * @memberof PIXI.utils
 * @param {number} v - input value
 * @return {number} logarithm base 2
 */ function $9122d79b52dc54f0$export$b9fae0bba9d9094d(v) {
    var r = (v > 0xFFFF ? 1 : 0) << 4;
    v >>>= r;
    var shift = (v > 0xFF ? 1 : 0) << 3;
    v >>>= shift;
    r |= shift;
    shift = (v > 0xF ? 1 : 0) << 2;
    v >>>= shift;
    r |= shift;
    shift = (v > 0x3 ? 1 : 0) << 1;
    v >>>= shift;
    r |= shift;
    return r | v >> 1;
}
/**
 * Remove items from a javascript array without generating garbage
 *
 * @function removeItems
 * @memberof PIXI.utils
 * @param {Array<any>} arr - Array to remove elements from
 * @param {number} startIdx - starting index
 * @param {number} removeCount - how many to remove
 */ function $9122d79b52dc54f0$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    var length = arr.length;
    var i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    var len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}
/**
 * Returns sign of number
 *
 * @memberof PIXI.utils
 * @function sign
 * @param {number} n - the number to check the sign of
 * @returns {number} 0 if `n` is 0, -1 if `n` is negative, 1 if `n` is positive
 */ function $9122d79b52dc54f0$export$c5552dfdbc7cec71(n) {
    if (n === 0) return 0;
    return n < 0 ? -1 : 1;
}
var $9122d79b52dc54f0$var$nextUid = 0;
/**
 * Gets the next unique identifier
 *
 * @memberof PIXI.utils
 * @function uid
 * @return {number} The next unique identifier to use.
 */ function $9122d79b52dc54f0$export$e2a22331486dcca0() {
    return ++$9122d79b52dc54f0$var$nextUid;
}
// A map of warning messages already fired
var $9122d79b52dc54f0$var$warnings = {};
/**
 * Helper for warning developers about deprecated features & settings.
 * A stack track for warnings is given; useful for tracking-down where
 * deprecated methods/properties/classes are being used within the code.
 *
 * @memberof PIXI.utils
 * @function deprecation
 * @param {string} version - The version where the feature became deprecated
 * @param {string} message - Message should include what is deprecated, where, and the new solution
 * @param {number} [ignoreDepth=3] - The number of steps to ignore at the top of the error stack
 *        this is mostly to ignore internal deprecation calls.
 */ function $9122d79b52dc54f0$export$afd31d834b512e89(version, message, ignoreDepth) {
    if (ignoreDepth === void 0) ignoreDepth = 3;
    // Ignore duplicat
    if ($9122d79b52dc54f0$var$warnings[message]) return;
    /* eslint-disable no-console */ var stack = new Error().stack;
    // Handle IE < 10 and Safari < 6
    if (typeof stack === 'undefined') console.warn('PixiJS Deprecation Warning: ', message + "\nDeprecated since v" + version);
    else {
        // chop off the stack trace which includes PixiJS internal calls
        stack = stack.split('\n').splice(ignoreDepth).join('\n');
        if (console.groupCollapsed) {
            console.groupCollapsed('%cPixiJS Deprecation Warning: %c%s', 'color:#614108;background:#fffbe6', 'font-weight:normal;color:#614108;background:#fffbe6', message + "\nDeprecated since v" + version);
            console.warn(stack);
            console.groupEnd();
        } else {
            console.warn('PixiJS Deprecation Warning: ', message + "\nDeprecated since v" + version);
            console.warn(stack);
        }
    }
    /* eslint-enable no-console */ $9122d79b52dc54f0$var$warnings[message] = true;
}
/**
 * @todo Describe property usage
 *
 * @static
 * @name ProgramCache
 * @memberof PIXI.utils
 * @type {Object}
 */ var $9122d79b52dc54f0$export$d47c7e291d8b6e2c = {};
/**
 * @todo Describe property usage
 *
 * @static
 * @name TextureCache
 * @memberof PIXI.utils
 * @type {Object}
 */ var $9122d79b52dc54f0$export$4254ab7c0971430e = Object.create(null);
/**
 * @todo Describe property usage
 *
 * @static
 * @name BaseTextureCache
 * @memberof PIXI.utils
 * @type {Object}
 */ var $9122d79b52dc54f0$export$cec649a143d060b1 = Object.create(null);
/**
 * Destroys all texture in the cache
 *
 * @memberof PIXI.utils
 * @function destroyTextureCache
 */ function $9122d79b52dc54f0$export$b5c9bc385f713d5a() {
    var key;
    for(key in $9122d79b52dc54f0$export$4254ab7c0971430e)$9122d79b52dc54f0$export$4254ab7c0971430e[key].destroy();
    for(key in $9122d79b52dc54f0$export$cec649a143d060b1)$9122d79b52dc54f0$export$cec649a143d060b1[key].destroy();
}
/**
 * Removes all textures from cache, but does not destroy them
 *
 * @memberof PIXI.utils
 * @function clearTextureCache
 */ function $9122d79b52dc54f0$export$3ee9cef7c9878d34() {
    var key;
    for(key in $9122d79b52dc54f0$export$4254ab7c0971430e)delete $9122d79b52dc54f0$export$4254ab7c0971430e[key];
    for(key in $9122d79b52dc54f0$export$cec649a143d060b1)delete $9122d79b52dc54f0$export$cec649a143d060b1[key];
}
/**
 * Creates a Canvas element of the given size to be used as a target for rendering to.
 *
 * @class
 * @memberof PIXI.utils
 */ var $9122d79b52dc54f0$export$525943d4c7cdfa38 = /** @class */ function() {
    /**
     * @param width - the width for the newly created canvas
     * @param height - the height for the newly created canvas
     * @param {number} [resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the canvas
     */ function CanvasRenderTarget(width, height, resolution) {
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d');
        this.resolution = resolution || (0, $ezJmd.settings).RESOLUTION;
        this.resize(width, height);
    }
    /**
     * Clears the canvas that was created by the CanvasRenderTarget class.
     *
     * @private
     */ CanvasRenderTarget.prototype.clear = function() {
        this.context.setTransform(1, 0, 0, 1, 0, 0);
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    };
    /**
     * Resizes the canvas to the specified width and height.
     *
     * @param desiredWidth - the desired width of the canvas
     * @param desiredHeight - the desired height of the canvas
     */ CanvasRenderTarget.prototype.resize = function(desiredWidth, desiredHeight) {
        this.canvas.width = Math.round(desiredWidth * this.resolution);
        this.canvas.height = Math.round(desiredHeight * this.resolution);
    };
    /** Destroys this canvas. */ CanvasRenderTarget.prototype.destroy = function() {
        this.context = null;
        this.canvas = null;
    };
    Object.defineProperty(CanvasRenderTarget.prototype, "width", {
        /**
         * The width of the canvas buffer in pixels.
         *
         * @member {number}
         */ get: function() {
            return this.canvas.width;
        },
        set: function(val) {
            this.canvas.width = Math.round(val);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasRenderTarget.prototype, "height", {
        /**
         * The height of the canvas buffer in pixels.
         *
         * @member {number}
         */ get: function() {
            return this.canvas.height;
        },
        set: function(val) {
            this.canvas.height = Math.round(val);
        },
        enumerable: false,
        configurable: true
    });
    return CanvasRenderTarget;
}();
/**
 * Trim transparent borders from a canvas
 *
 * @memberof PIXI.utils
 * @function trimCanvas
 * @param {HTMLCanvasElement} canvas - the canvas to trim
 * @returns {object} Trim data
 */ function $9122d79b52dc54f0$export$658947b9914dd428(canvas) {
    // https://gist.github.com/remy/784508
    var width = canvas.width;
    var height = canvas.height;
    var context = canvas.getContext('2d');
    var imageData = context.getImageData(0, 0, width, height);
    var pixels = imageData.data;
    var len = pixels.length;
    var bound = {
        top: null,
        left: null,
        right: null,
        bottom: null
    };
    var data = null;
    var i;
    var x;
    var y;
    for(i = 0; i < len; i += 4)if (pixels[i + 3] !== 0) {
        x = i / 4 % width;
        y = ~~(i / 4 / width);
        if (bound.top === null) bound.top = y;
        if (bound.left === null) bound.left = x;
        else if (x < bound.left) bound.left = x;
        if (bound.right === null) bound.right = x + 1;
        else if (bound.right < x) bound.right = x + 1;
        if (bound.bottom === null) bound.bottom = y;
        else if (bound.bottom < y) bound.bottom = y;
    }
    if (bound.top !== null) {
        width = bound.right - bound.left;
        height = bound.bottom - bound.top + 1;
        data = context.getImageData(bound.left, bound.top, width, height);
    }
    return {
        height: height,
        width: width,
        data: data
    };
}
/**
 * Regexp for data URI.
 * Based on: {@link https://github.com/ragingwind/data-uri-regex}
 *
 * @static
 * @constant {RegExp|string} DATA_URI
 * @memberof PIXI
 * @example data:image/png;base64
 */ var $9122d79b52dc54f0$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
/**
 * @memberof PIXI.utils
 * @interface DecomposedDataUri
 */ /**
 * type, eg. `image`
 * @memberof PIXI.utils.DecomposedDataUri#
 * @member {string} mediaType
 */ /**
 * Sub type, eg. `png`
 * @memberof PIXI.utils.DecomposedDataUri#
 * @member {string} subType
 */ /**
 * @memberof PIXI.utils.DecomposedDataUri#
 * @member {string} charset
 */ /**
 * Data encoding, eg. `base64`
 * @memberof PIXI.utils.DecomposedDataUri#
 * @member {string} encoding
 */ /**
 * The actual data
 * @memberof PIXI.utils.DecomposedDataUri#
 * @member {string} data
 */ /**
 * Split a data URI into components. Returns undefined if
 * parameter `dataUri` is not a valid data URI.
 *
 * @memberof PIXI.utils
 * @function decomposeDataUri
 * @param {string} dataUri - the data URI to check
 * @return {PIXI.utils.DecomposedDataUri|undefined} The decomposed data uri or undefined
 */ function $9122d79b52dc54f0$export$672224f9983ff723(dataUri) {
    var dataUriMatch = $9122d79b52dc54f0$export$dbafa72958753fce.exec(dataUri);
    if (dataUriMatch) return {
        mediaType: dataUriMatch[1] ? dataUriMatch[1].toLowerCase() : undefined,
        subType: dataUriMatch[2] ? dataUriMatch[2].toLowerCase() : undefined,
        charset: dataUriMatch[3] ? dataUriMatch[3].toLowerCase() : undefined,
        encoding: dataUriMatch[4] ? dataUriMatch[4].toLowerCase() : undefined,
        data: dataUriMatch[5]
    };
    return undefined;
}
var $9122d79b52dc54f0$var$tempAnchor;
/**
 * Sets the `crossOrigin` property for this resource based on if the url
 * for this resource is cross-origin. If crossOrigin was manually set, this
 * function does nothing.
 * Nipped from the resource loader!
 *
 * @ignore
 * @param {string} url - The url to test.
 * @param {object} [loc=window.location] - The location object to test against.
 * @return {string} The crossOrigin value to use (or empty string for none).
 */ function $9122d79b52dc54f0$export$292083da55c5b406(url$1, loc) {
    if (loc === void 0) loc = self.location;
    // data: and javascript: urls are considered same-origin
    if (url$1.indexOf('data:') === 0) return '';
    // default is window.location
    loc = loc || self.location;
    if (!$9122d79b52dc54f0$var$tempAnchor) $9122d79b52dc54f0$var$tempAnchor = document.createElement('a');
    // let the browser determine the full href for the url of this resource and then
    // parse with the node url lib, we can't use the properties of the anchor element
    // because they don't work in IE9 :(
    $9122d79b52dc54f0$var$tempAnchor.href = url$1;
    var parsedUrl = $9122d79b52dc54f0$export$128fa18b7194ef.parse($9122d79b52dc54f0$var$tempAnchor.href);
    var samePort = !parsedUrl.port && loc.port === '' || parsedUrl.port === loc.port;
    // if cross origin
    if (parsedUrl.hostname !== loc.hostname || !samePort || parsedUrl.protocol !== loc.protocol) return 'anonymous';
    return '';
}
/**
 * get the resolution / device pixel ratio of an asset by looking for the prefix
 * used by spritesheets and image urls
 *
 * @memberof PIXI.utils
 * @function getResolutionOfUrl
 * @param {string} url - the image path
 * @param {number} [defaultValue=1] - the defaultValue if no filename prefix is set.
 * @return {number} resolution / device pixel ratio of an asset
 */ function $9122d79b52dc54f0$export$8695ab2f322d2637(url, defaultValue) {
    var resolution = (0, $ezJmd.settings).RETINA_PREFIX.exec(url);
    if (resolution) return parseFloat(resolution[1]);
    return defaultValue !== undefined ? defaultValue : 1;
}

});
parcelRegister("ezJmd", function(module, exports) {

$parcel$export(module.exports, "isMobile", function () { return $a9c7849af2339627$export$d0a8044dce8ff2fc; });
$parcel$export(module.exports, "settings", function () { return $a9c7849af2339627$export$a5a6e0b888b2c992; });
/*!
 * @pixi/settings - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/settings is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ parcelRequire("d99R2");
var $cHiip = parcelRequire("cHiip");
// The ESM/CJS versions of ismobilejs only
var $a9c7849af2339627$export$d0a8044dce8ff2fc = (0, $cHiip.default)(self.navigator);
/**
 * The maximum recommended texture units to use.
 * In theory the bigger the better, and for desktop we'll use as many as we can.
 * But some mobile devices slow down if there is to many branches in the shader.
 * So in practice there seems to be a sweet spot size that varies depending on the device.
 *
 * In v4, all mobile devices were limited to 4 texture units because for this.
 * In v5, we allow all texture units to be used on modern Apple or Android devices.
 *
 * @private
 * @param {number} max
 * @returns {number}
 */ function $a9c7849af2339627$var$maxRecommendedTextures(max) {
    var allowMax = true;
    if ($a9c7849af2339627$export$d0a8044dce8ff2fc.tablet || $a9c7849af2339627$export$d0a8044dce8ff2fc.phone) {
        if ($a9c7849af2339627$export$d0a8044dce8ff2fc.apple.device) {
            var match = navigator.userAgent.match(/OS (\d+)_(\d+)?/);
            if (match) {
                var majorVersion = parseInt(match[1], 10);
                // Limit texture units on devices below iOS 11, which will be older hardware
                if (majorVersion < 11) allowMax = false;
            }
        }
        if ($a9c7849af2339627$export$d0a8044dce8ff2fc.android.device) {
            var match = navigator.userAgent.match(/Android\s([0-9.]*)/);
            if (match) {
                var majorVersion = parseInt(match[1], 10);
                // Limit texture units on devices below Android 7 (Nougat), which will be older hardware
                if (majorVersion < 7) allowMax = false;
            }
        }
    }
    return allowMax ? max : 4;
}
/**
 * Uploading the same buffer multiple times in a single frame can cause performance issues.
 * Apparent on iOS so only check for that at the moment
 * This check may become more complex if this issue pops up elsewhere.
 *
 * @private
 * @returns {boolean}
 */ function $a9c7849af2339627$var$canUploadSameBuffer() {
    return !$a9c7849af2339627$export$d0a8044dce8ff2fc.apple.device;
}
/*!
 * @pixi/constants - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/constants is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * Different types of environments for WebGL.
 *
 * @static
 * @memberof PIXI
 * @name ENV
 * @enum {number}
 * @property {number} WEBGL_LEGACY - Used for older v1 WebGL devices. PixiJS will aim to ensure compatibility
 *  with older / less advanced devices. If you experience unexplained flickering prefer this environment.
 * @property {number} WEBGL - Version 1 of WebGL
 * @property {number} WEBGL2 - Version 2 of WebGL
 */ var $a9c7849af2339627$var$ENV;
(function(ENV) {
    ENV[ENV["WEBGL_LEGACY"] = 0] = "WEBGL_LEGACY";
    ENV[ENV["WEBGL"] = 1] = "WEBGL";
    ENV[ENV["WEBGL2"] = 2] = "WEBGL2";
})($a9c7849af2339627$var$ENV || ($a9c7849af2339627$var$ENV = {}));
/**
 * Constant to identify the Renderer Type.
 *
 * @static
 * @memberof PIXI
 * @name RENDERER_TYPE
 * @enum {number}
 * @property {number} UNKNOWN - Unknown render type.
 * @property {number} WEBGL - WebGL render type.
 * @property {number} CANVAS - Canvas render type.
 */ var $a9c7849af2339627$var$RENDERER_TYPE;
(function(RENDERER_TYPE) {
    RENDERER_TYPE[RENDERER_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
    RENDERER_TYPE[RENDERER_TYPE["WEBGL"] = 1] = "WEBGL";
    RENDERER_TYPE[RENDERER_TYPE["CANVAS"] = 2] = "CANVAS";
})($a9c7849af2339627$var$RENDERER_TYPE || ($a9c7849af2339627$var$RENDERER_TYPE = {}));
/**
 * Bitwise OR of masks that indicate the buffers to be cleared.
 *
 * @static
 * @memberof PIXI
 * @name BUFFER_BITS
 * @enum {number}
 * @property {number} COLOR - Indicates the buffers currently enabled for color writing.
 * @property {number} DEPTH - Indicates the depth buffer.
 * @property {number} STENCIL - Indicates the stencil buffer.
 */ var $a9c7849af2339627$var$BUFFER_BITS;
(function(BUFFER_BITS) {
    BUFFER_BITS[BUFFER_BITS["COLOR"] = 16384] = "COLOR";
    BUFFER_BITS[BUFFER_BITS["DEPTH"] = 256] = "DEPTH";
    BUFFER_BITS[BUFFER_BITS["STENCIL"] = 1024] = "STENCIL";
})($a9c7849af2339627$var$BUFFER_BITS || ($a9c7849af2339627$var$BUFFER_BITS = {}));
/**
 * Various blend modes supported by PIXI.
 *
 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
 * Anything else will silently act like NORMAL.
 *
 * @memberof PIXI
 * @name BLEND_MODES
 * @enum {number}
 * @property {number} NORMAL
 * @property {number} ADD
 * @property {number} MULTIPLY
 * @property {number} SCREEN
 * @property {number} OVERLAY
 * @property {number} DARKEN
 * @property {number} LIGHTEN
 * @property {number} COLOR_DODGE
 * @property {number} COLOR_BURN
 * @property {number} HARD_LIGHT
 * @property {number} SOFT_LIGHT
 * @property {number} DIFFERENCE
 * @property {number} EXCLUSION
 * @property {number} HUE
 * @property {number} SATURATION
 * @property {number} COLOR
 * @property {number} LUMINOSITY
 * @property {number} NORMAL_NPM
 * @property {number} ADD_NPM
 * @property {number} SCREEN_NPM
 * @property {number} NONE
 * @property {number} SRC_IN
 * @property {number} SRC_OUT
 * @property {number} SRC_ATOP
 * @property {number} DST_OVER
 * @property {number} DST_IN
 * @property {number} DST_OUT
 * @property {number} DST_ATOP
 * @property {number} SUBTRACT
 * @property {number} SRC_OVER
 * @property {number} ERASE
 * @property {number} XOR
 */ var $a9c7849af2339627$var$BLEND_MODES;
(function(BLEND_MODES) {
    BLEND_MODES[BLEND_MODES["NORMAL"] = 0] = "NORMAL";
    BLEND_MODES[BLEND_MODES["ADD"] = 1] = "ADD";
    BLEND_MODES[BLEND_MODES["MULTIPLY"] = 2] = "MULTIPLY";
    BLEND_MODES[BLEND_MODES["SCREEN"] = 3] = "SCREEN";
    BLEND_MODES[BLEND_MODES["OVERLAY"] = 4] = "OVERLAY";
    BLEND_MODES[BLEND_MODES["DARKEN"] = 5] = "DARKEN";
    BLEND_MODES[BLEND_MODES["LIGHTEN"] = 6] = "LIGHTEN";
    BLEND_MODES[BLEND_MODES["COLOR_DODGE"] = 7] = "COLOR_DODGE";
    BLEND_MODES[BLEND_MODES["COLOR_BURN"] = 8] = "COLOR_BURN";
    BLEND_MODES[BLEND_MODES["HARD_LIGHT"] = 9] = "HARD_LIGHT";
    BLEND_MODES[BLEND_MODES["SOFT_LIGHT"] = 10] = "SOFT_LIGHT";
    BLEND_MODES[BLEND_MODES["DIFFERENCE"] = 11] = "DIFFERENCE";
    BLEND_MODES[BLEND_MODES["EXCLUSION"] = 12] = "EXCLUSION";
    BLEND_MODES[BLEND_MODES["HUE"] = 13] = "HUE";
    BLEND_MODES[BLEND_MODES["SATURATION"] = 14] = "SATURATION";
    BLEND_MODES[BLEND_MODES["COLOR"] = 15] = "COLOR";
    BLEND_MODES[BLEND_MODES["LUMINOSITY"] = 16] = "LUMINOSITY";
    BLEND_MODES[BLEND_MODES["NORMAL_NPM"] = 17] = "NORMAL_NPM";
    BLEND_MODES[BLEND_MODES["ADD_NPM"] = 18] = "ADD_NPM";
    BLEND_MODES[BLEND_MODES["SCREEN_NPM"] = 19] = "SCREEN_NPM";
    BLEND_MODES[BLEND_MODES["NONE"] = 20] = "NONE";
    BLEND_MODES[BLEND_MODES["SRC_OVER"] = 0] = "SRC_OVER";
    BLEND_MODES[BLEND_MODES["SRC_IN"] = 21] = "SRC_IN";
    BLEND_MODES[BLEND_MODES["SRC_OUT"] = 22] = "SRC_OUT";
    BLEND_MODES[BLEND_MODES["SRC_ATOP"] = 23] = "SRC_ATOP";
    BLEND_MODES[BLEND_MODES["DST_OVER"] = 24] = "DST_OVER";
    BLEND_MODES[BLEND_MODES["DST_IN"] = 25] = "DST_IN";
    BLEND_MODES[BLEND_MODES["DST_OUT"] = 26] = "DST_OUT";
    BLEND_MODES[BLEND_MODES["DST_ATOP"] = 27] = "DST_ATOP";
    BLEND_MODES[BLEND_MODES["ERASE"] = 26] = "ERASE";
    BLEND_MODES[BLEND_MODES["SUBTRACT"] = 28] = "SUBTRACT";
    BLEND_MODES[BLEND_MODES["XOR"] = 29] = "XOR";
})($a9c7849af2339627$var$BLEND_MODES || ($a9c7849af2339627$var$BLEND_MODES = {}));
/**
 * Various webgl draw modes. These can be used to specify which GL drawMode to use
 * under certain situations and renderers.
 *
 * @memberof PIXI
 * @static
 * @name DRAW_MODES
 * @enum {number}
 * @property {number} POINTS
 * @property {number} LINES
 * @property {number} LINE_LOOP
 * @property {number} LINE_STRIP
 * @property {number} TRIANGLES
 * @property {number} TRIANGLE_STRIP
 * @property {number} TRIANGLE_FAN
 */ var $a9c7849af2339627$var$DRAW_MODES;
(function(DRAW_MODES) {
    DRAW_MODES[DRAW_MODES["POINTS"] = 0] = "POINTS";
    DRAW_MODES[DRAW_MODES["LINES"] = 1] = "LINES";
    DRAW_MODES[DRAW_MODES["LINE_LOOP"] = 2] = "LINE_LOOP";
    DRAW_MODES[DRAW_MODES["LINE_STRIP"] = 3] = "LINE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLES"] = 4] = "TRIANGLES";
    DRAW_MODES[DRAW_MODES["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
})($a9c7849af2339627$var$DRAW_MODES || ($a9c7849af2339627$var$DRAW_MODES = {}));
/**
 * Various GL texture/resources formats.
 *
 * @memberof PIXI
 * @static
 * @name FORMATS
 * @enum {number}
 * @property {number} RGBA=6408
 * @property {number} RGB=6407
 * @property {number} RG=33319
 * @property {number} RED=6403
 * @property {number} RGBA_INTEGER=36249
 * @property {number} RGB_INTEGER=36248
 * @property {number} RG_INTEGER=33320
 * @property {number} RED_INTEGER=36244
 * @property {number} ALPHA=6406
 * @property {number} LUMINANCE=6409
 * @property {number} LUMINANCE_ALPHA=6410
 * @property {number} DEPTH_COMPONENT=6402
 * @property {number} DEPTH_STENCIL=34041
 */ var $a9c7849af2339627$var$FORMATS;
(function(FORMATS) {
    FORMATS[FORMATS["RGBA"] = 6408] = "RGBA";
    FORMATS[FORMATS["RGB"] = 6407] = "RGB";
    FORMATS[FORMATS["RG"] = 33319] = "RG";
    FORMATS[FORMATS["RED"] = 6403] = "RED";
    FORMATS[FORMATS["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    FORMATS[FORMATS["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    FORMATS[FORMATS["RG_INTEGER"] = 33320] = "RG_INTEGER";
    FORMATS[FORMATS["RED_INTEGER"] = 36244] = "RED_INTEGER";
    FORMATS[FORMATS["ALPHA"] = 6406] = "ALPHA";
    FORMATS[FORMATS["LUMINANCE"] = 6409] = "LUMINANCE";
    FORMATS[FORMATS["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    FORMATS[FORMATS["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    FORMATS[FORMATS["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
})($a9c7849af2339627$var$FORMATS || ($a9c7849af2339627$var$FORMATS = {}));
/**
 * Various GL target types.
 *
 * @memberof PIXI
 * @static
 * @name TARGETS
 * @enum {number}
 * @property {number} TEXTURE_2D=3553
 * @property {number} TEXTURE_CUBE_MAP=34067
 * @property {number} TEXTURE_2D_ARRAY=35866
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_X=34069
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_X=34070
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Y=34071
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Y=34072
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Z=34073
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Z=34074
 */ var $a9c7849af2339627$var$TARGETS;
(function(TARGETS) {
    TARGETS[TARGETS["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    TARGETS[TARGETS["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
})($a9c7849af2339627$var$TARGETS || ($a9c7849af2339627$var$TARGETS = {}));
/**
 * Various GL data format types.
 *
 * @memberof PIXI
 * @static
 * @name TYPES
 * @enum {number}
 * @property {number} UNSIGNED_BYTE=5121
 * @property {number} UNSIGNED_SHORT=5123
 * @property {number} UNSIGNED_SHORT_5_6_5=33635
 * @property {number} UNSIGNED_SHORT_4_4_4_4=32819
 * @property {number} UNSIGNED_SHORT_5_5_5_1=32820
 * @property {number} UNSIGNED_INT=5125
 * @property {number} UNSIGNED_INT_10F_11F_11F_REV=35899
 * @property {number} UNSIGNED_INT_2_10_10_10_REV=33640
 * @property {number} UNSIGNED_INT_24_8=34042
 * @property {number} UNSIGNED_INT_5_9_9_9_REV=35902
 * @property {number} BYTE=5120
 * @property {number} SHORT=5122
 * @property {number} INT=5124
 * @property {number} FLOAT=5126
 * @property {number} FLOAT_32_UNSIGNED_INT_24_8_REV=36269
 * @property {number} HALF_FLOAT=36193
 */ var $a9c7849af2339627$var$TYPES;
(function(TYPES) {
    TYPES[TYPES["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    TYPES[TYPES["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    TYPES[TYPES["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    TYPES[TYPES["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    TYPES[TYPES["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    TYPES[TYPES["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    TYPES[TYPES["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    TYPES[TYPES["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    TYPES[TYPES["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    TYPES[TYPES["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    TYPES[TYPES["BYTE"] = 5120] = "BYTE";
    TYPES[TYPES["SHORT"] = 5122] = "SHORT";
    TYPES[TYPES["INT"] = 5124] = "INT";
    TYPES[TYPES["FLOAT"] = 5126] = "FLOAT";
    TYPES[TYPES["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    TYPES[TYPES["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
})($a9c7849af2339627$var$TYPES || ($a9c7849af2339627$var$TYPES = {}));
/**
 * Various sampler types. Correspond to `sampler`, `isampler`, `usampler` GLSL types respectively.
 * WebGL1 works only with FLOAT.
 *
 * @memberof PIXI
 * @static
 * @name SAMPLER_TYPES
 * @enum {number}
 * @property {number} FLOAT=0
 * @property {number} INT=1
 * @property {number} UINT=2
 */ var $a9c7849af2339627$var$SAMPLER_TYPES;
(function(SAMPLER_TYPES) {
    SAMPLER_TYPES[SAMPLER_TYPES["FLOAT"] = 0] = "FLOAT";
    SAMPLER_TYPES[SAMPLER_TYPES["INT"] = 1] = "INT";
    SAMPLER_TYPES[SAMPLER_TYPES["UINT"] = 2] = "UINT";
})($a9c7849af2339627$var$SAMPLER_TYPES || ($a9c7849af2339627$var$SAMPLER_TYPES = {}));
/**
 * The scale modes that are supported by pixi.
 *
 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
 *
 * @memberof PIXI
 * @static
 * @name SCALE_MODES
 * @enum {number}
 * @property {number} LINEAR Smooth scaling
 * @property {number} NEAREST Pixelating scaling
 */ var $a9c7849af2339627$var$SCALE_MODES;
(function(SCALE_MODES) {
    SCALE_MODES[SCALE_MODES["NEAREST"] = 0] = "NEAREST";
    SCALE_MODES[SCALE_MODES["LINEAR"] = 1] = "LINEAR";
})($a9c7849af2339627$var$SCALE_MODES || ($a9c7849af2339627$var$SCALE_MODES = {}));
/**
 * The wrap modes that are supported by pixi.
 *
 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
 * If the texture is non power of two then clamp will be used regardless as WebGL can
 * only use REPEAT if the texture is po2.
 *
 * This property only affects WebGL.
 *
 * @name WRAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} CLAMP - The textures uvs are clamped
 * @property {number} REPEAT - The texture uvs tile and repeat
 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
 */ var $a9c7849af2339627$var$WRAP_MODES;
(function(WRAP_MODES) {
    WRAP_MODES[WRAP_MODES["CLAMP"] = 33071] = "CLAMP";
    WRAP_MODES[WRAP_MODES["REPEAT"] = 10497] = "REPEAT";
    WRAP_MODES[WRAP_MODES["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
})($a9c7849af2339627$var$WRAP_MODES || ($a9c7849af2339627$var$WRAP_MODES = {}));
/**
 * Mipmap filtering modes that are supported by pixi.
 *
 * The {@link PIXI.settings.MIPMAP_TEXTURES} affects default texture filtering.
 * Mipmaps are generated for a baseTexture if its `mipmap` field is `ON`,
 * or its `POW2` and texture dimensions are powers of 2.
 * Due to platform restriction, `ON` option will work like `POW2` for webgl-1.
 *
 * This property only affects WebGL.
 *
 * @name MIPMAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} OFF - No mipmaps
 * @property {number} POW2 - Generate mipmaps if texture dimensions are pow2
 * @property {number} ON - Always generate mipmaps
 * @property {number} ON_MANUAL - Use mipmaps, but do not auto-generate them; this is used with a resource
 *   that supports buffering each level-of-detail.
 */ var $a9c7849af2339627$var$MIPMAP_MODES;
(function(MIPMAP_MODES) {
    MIPMAP_MODES[MIPMAP_MODES["OFF"] = 0] = "OFF";
    MIPMAP_MODES[MIPMAP_MODES["POW2"] = 1] = "POW2";
    MIPMAP_MODES[MIPMAP_MODES["ON"] = 2] = "ON";
    MIPMAP_MODES[MIPMAP_MODES["ON_MANUAL"] = 3] = "ON_MANUAL";
})($a9c7849af2339627$var$MIPMAP_MODES || ($a9c7849af2339627$var$MIPMAP_MODES = {}));
/**
 * How to treat textures with premultiplied alpha
 *
 * @name ALPHA_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NO_PREMULTIPLIED_ALPHA - Source is not premultiplied, leave it like that.
 *  Option for compressed and data textures that are created from typed arrays.
 * @property {number} PREMULTIPLY_ON_UPLOAD - Source is not premultiplied, premultiply on upload.
 *  Default option, used for all loaded images.
 * @property {number} PREMULTIPLIED_ALPHA - Source is already premultiplied
 *  Example: spine atlases with `_pma` suffix.
 * @property {number} NPM - Alias for NO_PREMULTIPLIED_ALPHA.
 * @property {number} UNPACK - Default option, alias for PREMULTIPLY_ON_UPLOAD.
 * @property {number} PMA - Alias for PREMULTIPLIED_ALPHA.
 */ var $a9c7849af2339627$var$ALPHA_MODES;
(function(ALPHA_MODES) {
    ALPHA_MODES[ALPHA_MODES["NPM"] = 0] = "NPM";
    ALPHA_MODES[ALPHA_MODES["UNPACK"] = 1] = "UNPACK";
    ALPHA_MODES[ALPHA_MODES["PMA"] = 2] = "PMA";
    ALPHA_MODES[ALPHA_MODES["NO_PREMULTIPLIED_ALPHA"] = 0] = "NO_PREMULTIPLIED_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ON_UPLOAD"] = 1] = "PREMULTIPLY_ON_UPLOAD";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ALPHA"] = 2] = "PREMULTIPLY_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLIED_ALPHA"] = 2] = "PREMULTIPLIED_ALPHA";
})($a9c7849af2339627$var$ALPHA_MODES || ($a9c7849af2339627$var$ALPHA_MODES = {}));
/**
 * Configure whether filter textures are cleared after binding.
 *
 * Filter textures need not be cleared if the filter does not use pixel blending. {@link CLEAR_MODES.BLIT} will detect
 * this and skip clearing as an optimization.
 *
 * @name CLEAR_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} BLEND - Do not clear the filter texture. The filter's output will blend on top of the output texture.
 * @property {number} CLEAR - Always clear the filter texture.
 * @property {number} BLIT - Clear only if {@link FilterSystem.forceClear} is set or if the filter uses pixel blending.
 * @property {number} NO - Alias for BLEND, same as `false` in earlier versions
 * @property {number} YES - Alias for CLEAR, same as `true` in earlier versions
 * @property {number} AUTO - Alias for BLIT
 */ var $a9c7849af2339627$var$CLEAR_MODES;
(function(CLEAR_MODES) {
    CLEAR_MODES[CLEAR_MODES["NO"] = 0] = "NO";
    CLEAR_MODES[CLEAR_MODES["YES"] = 1] = "YES";
    CLEAR_MODES[CLEAR_MODES["AUTO"] = 2] = "AUTO";
    CLEAR_MODES[CLEAR_MODES["BLEND"] = 0] = "BLEND";
    CLEAR_MODES[CLEAR_MODES["CLEAR"] = 1] = "CLEAR";
    CLEAR_MODES[CLEAR_MODES["BLIT"] = 2] = "BLIT";
})($a9c7849af2339627$var$CLEAR_MODES || ($a9c7849af2339627$var$CLEAR_MODES = {}));
/**
 * The gc modes that are supported by pixi.
 *
 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
 * used for a specified period of time they will be removed from the GPU. They will of course
 * be uploaded again when they are required. This is a silent behind the scenes process that
 * should ensure that the GPU does not  get filled up.
 *
 * Handy for mobile devices!
 * This property only affects WebGL.
 *
 * @name GC_MODES
 * @enum {number}
 * @static
 * @memberof PIXI
 * @property {number} AUTO - Garbage collection will happen periodically automatically
 * @property {number} MANUAL - Garbage collection will need to be called manually
 */ var $a9c7849af2339627$var$GC_MODES;
(function(GC_MODES) {
    GC_MODES[GC_MODES["AUTO"] = 0] = "AUTO";
    GC_MODES[GC_MODES["MANUAL"] = 1] = "MANUAL";
})($a9c7849af2339627$var$GC_MODES || ($a9c7849af2339627$var$GC_MODES = {}));
/**
 * Constants that specify float precision in shaders.
 *
 * @name PRECISION
 * @memberof PIXI
 * @constant
 * @static
 * @enum {string}
 * @property {string} LOW='lowp'
 * @property {string} MEDIUM='mediump'
 * @property {string} HIGH='highp'
 */ var $a9c7849af2339627$var$PRECISION;
(function(PRECISION) {
    PRECISION["LOW"] = "lowp";
    PRECISION["MEDIUM"] = "mediump";
    PRECISION["HIGH"] = "highp";
})($a9c7849af2339627$var$PRECISION || ($a9c7849af2339627$var$PRECISION = {}));
/**
 * Constants for mask implementations.
 * We use `type` suffix because it leads to very different behaviours
 *
 * @name MASK_TYPES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - Mask is ignored
 * @property {number} SCISSOR - Scissor mask, rectangle on screen, cheap
 * @property {number} STENCIL - Stencil mask, 1-bit, medium, works only if renderer supports stencil
 * @property {number} SPRITE - Mask that uses SpriteMaskFilter, uses temporary RenderTexture
 */ var $a9c7849af2339627$var$MASK_TYPES;
(function(MASK_TYPES) {
    MASK_TYPES[MASK_TYPES["NONE"] = 0] = "NONE";
    MASK_TYPES[MASK_TYPES["SCISSOR"] = 1] = "SCISSOR";
    MASK_TYPES[MASK_TYPES["STENCIL"] = 2] = "STENCIL";
    MASK_TYPES[MASK_TYPES["SPRITE"] = 3] = "SPRITE";
})($a9c7849af2339627$var$MASK_TYPES || ($a9c7849af2339627$var$MASK_TYPES = {}));
/**
 * Constants for multi-sampling antialiasing.
 *
 * @see PIXI.Framebuffer#multisample
 *
 * @name MSAA_QUALITY
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - No multisampling for this renderTexture
 * @property {number} LOW - Try 2 samples
 * @property {number} MEDIUM - Try 4 samples
 * @property {number} HIGH - Try 8 samples
 */ var $a9c7849af2339627$var$MSAA_QUALITY;
(function(MSAA_QUALITY) {
    MSAA_QUALITY[MSAA_QUALITY["NONE"] = 0] = "NONE";
    MSAA_QUALITY[MSAA_QUALITY["LOW"] = 2] = "LOW";
    MSAA_QUALITY[MSAA_QUALITY["MEDIUM"] = 4] = "MEDIUM";
    MSAA_QUALITY[MSAA_QUALITY["HIGH"] = 8] = "HIGH";
})($a9c7849af2339627$var$MSAA_QUALITY || ($a9c7849af2339627$var$MSAA_QUALITY = {}));
/**
 * Constants for various buffer types in Pixi
 *
 * @see PIXI.BUFFER_TYPE
 *
 * @name BUFFER_TYPE
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} ELEMENT_ARRAY_BUFFER - buffer type for using as an index buffer
 * @property {number} ARRAY_BUFFER - buffer type for using attribute data
 * @property {number} UNIFORM_BUFFER - the buffer type is for uniform buffer objects
 */ var $a9c7849af2339627$var$BUFFER_TYPE;
(function(BUFFER_TYPE) {
    BUFFER_TYPE[BUFFER_TYPE["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    BUFFER_TYPE[BUFFER_TYPE["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    // NOT YET SUPPORTED
    BUFFER_TYPE[BUFFER_TYPE["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
})($a9c7849af2339627$var$BUFFER_TYPE || ($a9c7849af2339627$var$BUFFER_TYPE = {}));
/**
 * User's customizable globals for overriding the default PIXI settings, such
 * as a renderer's default resolution, framerate, float precision, etc.
 * @example
 * // Use the native window resolution as the default resolution
 * // will support high-density displays when rendering
 * PIXI.settings.RESOLUTION = window.devicePixelRatio;
 *
 * // Disable interpolation when scaling, will make texture be pixelated
 * PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
 * @namespace PIXI.settings
 */ var $a9c7849af2339627$export$a5a6e0b888b2c992 = {
    /**
     * If set to true WebGL will attempt make textures mimpaped by default.
     * Mipmapping will only succeed if the base texture uploaded has power of two dimensions.
     *
     * @static
     * @name MIPMAP_TEXTURES
     * @memberof PIXI.settings
     * @type {PIXI.MIPMAP_MODES}
     * @default PIXI.MIPMAP_MODES.POW2
     */ MIPMAP_TEXTURES: $a9c7849af2339627$var$MIPMAP_MODES.POW2,
    /**
     * Default anisotropic filtering level of textures.
     * Usually from 0 to 16
     *
     * @static
     * @name ANISOTROPIC_LEVEL
     * @memberof PIXI.settings
     * @type {number}
     * @default 0
     */ ANISOTROPIC_LEVEL: 0,
    /**
     * Default resolution / device pixel ratio of the renderer.
     *
     * @static
     * @name RESOLUTION
     * @memberof PIXI.settings
     * @type {number}
     * @default 1
     */ RESOLUTION: 1,
    /**
     * Default filter resolution.
     *
     * @static
     * @name FILTER_RESOLUTION
     * @memberof PIXI.settings
     * @type {number}
     * @default 1
     */ FILTER_RESOLUTION: 1,
    /**
     * Default filter samples.
     *
     * @static
     * @name FILTER_MULTISAMPLE
     * @memberof PIXI.settings
     * @type {PIXI.MSAA_QUALITY}
     * @default PIXI.MSAA_QUALITY.NONE
     */ FILTER_MULTISAMPLE: $a9c7849af2339627$var$MSAA_QUALITY.NONE,
    /**
     * The maximum textures that this device supports.
     *
     * @static
     * @name SPRITE_MAX_TEXTURES
     * @memberof PIXI.settings
     * @type {number}
     * @default 32
     */ SPRITE_MAX_TEXTURES: $a9c7849af2339627$var$maxRecommendedTextures(32),
    // TODO: maybe change to SPRITE.BATCH_SIZE: 2000
    // TODO: maybe add PARTICLE.BATCH_SIZE: 15000
    /**
     * The default sprite batch size.
     *
     * The default aims to balance desktop and mobile devices.
     *
     * @static
     * @name SPRITE_BATCH_SIZE
     * @memberof PIXI.settings
     * @type {number}
     * @default 4096
     */ SPRITE_BATCH_SIZE: 4096,
    /**
     * The default render options if none are supplied to {@link PIXI.Renderer}
     * or {@link PIXI.CanvasRenderer}.
     *
     * @static
     * @name RENDER_OPTIONS
     * @memberof PIXI.settings
     * @type {object}
     * @property {HTMLCanvasElement} view=null
     * @property {boolean} antialias=false
     * @property {boolean} autoDensity=false
     * @property {boolean} useContextAlpha=true
     * @property {number} backgroundColor=0x000000
     * @property {number} backgroundAlpha=1
     * @property {boolean} clearBeforeRender=true
     * @property {boolean} preserveDrawingBuffer=false
     * @property {number} width=800
     * @property {number} height=600
     * @property {boolean} legacy=false
     */ RENDER_OPTIONS: {
        view: null,
        antialias: false,
        autoDensity: false,
        backgroundColor: 0x000000,
        backgroundAlpha: 1,
        useContextAlpha: true,
        clearBeforeRender: true,
        preserveDrawingBuffer: false,
        width: 800,
        height: 600,
        legacy: false
    },
    /**
     * Default Garbage Collection mode.
     *
     * @static
     * @name GC_MODE
     * @memberof PIXI.settings
     * @type {PIXI.GC_MODES}
     * @default PIXI.GC_MODES.AUTO
     */ GC_MODE: $a9c7849af2339627$var$GC_MODES.AUTO,
    /**
     * Default Garbage Collection max idle.
     *
     * @static
     * @name GC_MAX_IDLE
     * @memberof PIXI.settings
     * @type {number}
     * @default 3600
     */ GC_MAX_IDLE: 3600,
    /**
     * Default Garbage Collection maximum check count.
     *
     * @static
     * @name GC_MAX_CHECK_COUNT
     * @memberof PIXI.settings
     * @type {number}
     * @default 600
     */ GC_MAX_CHECK_COUNT: 600,
    /**
     * Default wrap modes that are supported by pixi.
     *
     * @static
     * @name WRAP_MODE
     * @memberof PIXI.settings
     * @type {PIXI.WRAP_MODES}
     * @default PIXI.WRAP_MODES.CLAMP
     */ WRAP_MODE: $a9c7849af2339627$var$WRAP_MODES.CLAMP,
    /**
     * Default scale mode for textures.
     *
     * @static
     * @name SCALE_MODE
     * @memberof PIXI.settings
     * @type {PIXI.SCALE_MODES}
     * @default PIXI.SCALE_MODES.LINEAR
     */ SCALE_MODE: $a9c7849af2339627$var$SCALE_MODES.LINEAR,
    /**
     * Default specify float precision in vertex shader.
     *
     * @static
     * @name PRECISION_VERTEX
     * @memberof PIXI.settings
     * @type {PIXI.PRECISION}
     * @default PIXI.PRECISION.HIGH
     */ PRECISION_VERTEX: $a9c7849af2339627$var$PRECISION.HIGH,
    /**
     * Default specify float precision in fragment shader.
     * iOS is best set at highp due to https://github.com/pixijs/pixi.js/issues/3742
     *
     * @static
     * @name PRECISION_FRAGMENT
     * @memberof PIXI.settings
     * @type {PIXI.PRECISION}
     * @default PIXI.PRECISION.MEDIUM
     */ PRECISION_FRAGMENT: $a9c7849af2339627$export$d0a8044dce8ff2fc.apple.device ? $a9c7849af2339627$var$PRECISION.HIGH : $a9c7849af2339627$var$PRECISION.MEDIUM,
    /**
     * Can we upload the same buffer in a single frame?
     *
     * @static
     * @name CAN_UPLOAD_SAME_BUFFER
     * @memberof PIXI.settings
     * @type {boolean}
     */ CAN_UPLOAD_SAME_BUFFER: $a9c7849af2339627$var$canUploadSameBuffer(),
    /**
     * Enables bitmap creation before image load. This feature is experimental.
     *
     * @static
     * @name CREATE_IMAGE_BITMAP
     * @memberof PIXI.settings
     * @type {boolean}
     * @default false
     */ CREATE_IMAGE_BITMAP: false,
    /**
     * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
     * Advantages can include sharper image quality (like text) and faster rendering on canvas.
     * The main disadvantage is movement of objects may appear less smooth.
     *
     * @static
     * @constant
     * @memberof PIXI.settings
     * @type {boolean}
     * @default false
     */ ROUND_PIXELS: false
};

});
parcelRegister("d99R2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("cHiip")).default; });

var $cHiip = parcelRequire("cHiip");

});
parcelRegister("cHiip", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93e7b15c28b6d528$export$2e2bcd8739ae039; });
var $93e7b15c28b6d528$var$appleIphone = /iPhone/i;
var $93e7b15c28b6d528$var$appleIpod = /iPod/i;
var $93e7b15c28b6d528$var$appleTablet = /iPad/i;
var $93e7b15c28b6d528$var$appleUniversal = /\biOS-universal(?:.+)Mac\b/i;
var $93e7b15c28b6d528$var$androidPhone = /\bAndroid(?:.+)Mobile\b/i;
var $93e7b15c28b6d528$var$androidTablet = /Android/i;
var $93e7b15c28b6d528$var$amazonPhone = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i;
var $93e7b15c28b6d528$var$amazonTablet = /Silk/i;
var $93e7b15c28b6d528$var$windowsPhone = /Windows Phone/i;
var $93e7b15c28b6d528$var$windowsTablet = /\bWindows(?:.+)ARM\b/i;
var $93e7b15c28b6d528$var$otherBlackBerry = /BlackBerry/i;
var $93e7b15c28b6d528$var$otherBlackBerry10 = /BB10/i;
var $93e7b15c28b6d528$var$otherOpera = /Opera Mini/i;
var $93e7b15c28b6d528$var$otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
var $93e7b15c28b6d528$var$otherFirefox = /Mobile(?:.+)Firefox\b/i;
var $93e7b15c28b6d528$var$isAppleTabletOnIos13 = function(navigator1) {
    return typeof navigator1 !== 'undefined' && navigator1.platform === 'MacIntel' && typeof navigator1.maxTouchPoints === 'number' && navigator1.maxTouchPoints > 1 && typeof MSStream === 'undefined';
};
function $93e7b15c28b6d528$var$createMatch(userAgent) {
    return function(regex) {
        return regex.test(userAgent);
    };
}
function $93e7b15c28b6d528$export$2e2bcd8739ae039(param) {
    var nav = {
        userAgent: '',
        platform: '',
        maxTouchPoints: 0
    };
    if (!param && typeof navigator !== 'undefined') nav = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        maxTouchPoints: navigator.maxTouchPoints || 0
    };
    else if (typeof param === 'string') nav.userAgent = param;
    else if (param && param.userAgent) nav = {
        userAgent: param.userAgent,
        platform: param.platform,
        maxTouchPoints: param.maxTouchPoints || 0
    };
    var userAgent = nav.userAgent;
    var tmp = userAgent.split('[FBAN');
    if (typeof tmp[1] !== 'undefined') userAgent = tmp[0];
    tmp = userAgent.split('Twitter');
    if (typeof tmp[1] !== 'undefined') userAgent = tmp[0];
    var match = $93e7b15c28b6d528$var$createMatch(userAgent);
    var result = {
        apple: {
            phone: match($93e7b15c28b6d528$var$appleIphone) && !match($93e7b15c28b6d528$var$windowsPhone),
            ipod: match($93e7b15c28b6d528$var$appleIpod),
            tablet: !match($93e7b15c28b6d528$var$appleIphone) && (match($93e7b15c28b6d528$var$appleTablet) || $93e7b15c28b6d528$var$isAppleTabletOnIos13(nav)) && !match($93e7b15c28b6d528$var$windowsPhone),
            universal: match($93e7b15c28b6d528$var$appleUniversal),
            device: (match($93e7b15c28b6d528$var$appleIphone) || match($93e7b15c28b6d528$var$appleIpod) || match($93e7b15c28b6d528$var$appleTablet) || match($93e7b15c28b6d528$var$appleUniversal) || $93e7b15c28b6d528$var$isAppleTabletOnIos13(nav)) && !match($93e7b15c28b6d528$var$windowsPhone)
        },
        amazon: {
            phone: match($93e7b15c28b6d528$var$amazonPhone),
            tablet: !match($93e7b15c28b6d528$var$amazonPhone) && match($93e7b15c28b6d528$var$amazonTablet),
            device: match($93e7b15c28b6d528$var$amazonPhone) || match($93e7b15c28b6d528$var$amazonTablet)
        },
        android: {
            phone: !match($93e7b15c28b6d528$var$windowsPhone) && match($93e7b15c28b6d528$var$amazonPhone) || !match($93e7b15c28b6d528$var$windowsPhone) && match($93e7b15c28b6d528$var$androidPhone),
            tablet: !match($93e7b15c28b6d528$var$windowsPhone) && !match($93e7b15c28b6d528$var$amazonPhone) && !match($93e7b15c28b6d528$var$androidPhone) && (match($93e7b15c28b6d528$var$amazonTablet) || match($93e7b15c28b6d528$var$androidTablet)),
            device: !match($93e7b15c28b6d528$var$windowsPhone) && (match($93e7b15c28b6d528$var$amazonPhone) || match($93e7b15c28b6d528$var$amazonTablet) || match($93e7b15c28b6d528$var$androidPhone) || match($93e7b15c28b6d528$var$androidTablet)) || match(/\bokhttp\b/i)
        },
        windows: {
            phone: match($93e7b15c28b6d528$var$windowsPhone),
            tablet: match($93e7b15c28b6d528$var$windowsTablet),
            device: match($93e7b15c28b6d528$var$windowsPhone) || match($93e7b15c28b6d528$var$windowsTablet)
        },
        other: {
            blackberry: match($93e7b15c28b6d528$var$otherBlackBerry),
            blackberry10: match($93e7b15c28b6d528$var$otherBlackBerry10),
            opera: match($93e7b15c28b6d528$var$otherOpera),
            firefox: match($93e7b15c28b6d528$var$otherFirefox),
            chrome: match($93e7b15c28b6d528$var$otherChrome),
            device: match($93e7b15c28b6d528$var$otherBlackBerry) || match($93e7b15c28b6d528$var$otherBlackBerry10) || match($93e7b15c28b6d528$var$otherOpera) || match($93e7b15c28b6d528$var$otherFirefox) || match($93e7b15c28b6d528$var$otherChrome)
        },
        any: false,
        phone: false,
        tablet: false
    };
    result.any = result.apple.device || result.android.device || result.windows.device || result.other.device;
    result.phone = result.apple.phone || result.android.phone || result.windows.phone;
    result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
    return result;
}

});



parcelRegister("6p5EE", function(module, exports) {
'use strict';
var $4a9976ca6ebf6735$var$has = Object.prototype.hasOwnProperty, $4a9976ca6ebf6735$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $4a9976ca6ebf6735$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $4a9976ca6ebf6735$var$Events().__proto__) $4a9976ca6ebf6735$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $4a9976ca6ebf6735$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $4a9976ca6ebf6735$var$EE(fn, context || emitter, once), evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $4a9976ca6ebf6735$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $4a9976ca6ebf6735$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $4a9976ca6ebf6735$var$EventEmitter() {
    this._events = new $4a9976ca6ebf6735$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($4a9976ca6ebf6735$var$has.call(events, name)) names.push($4a9976ca6ebf6735$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $4a9976ca6ebf6735$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $4a9976ca6ebf6735$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
        if (this._events[evt]) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        this._events = new $4a9976ca6ebf6735$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$4a9976ca6ebf6735$var$EventEmitter.prototype.off = $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener;
$4a9976ca6ebf6735$var$EventEmitter.prototype.addListener = $4a9976ca6ebf6735$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$4a9976ca6ebf6735$var$EventEmitter.prefixed = $4a9976ca6ebf6735$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$4a9976ca6ebf6735$var$EventEmitter.EventEmitter = $4a9976ca6ebf6735$var$EventEmitter;
module.exports = $4a9976ca6ebf6735$var$EventEmitter;

});

parcelRegister("fPquT", function(module, exports) {
'use strict';
module.exports = $b8602c4416cfa89b$var$earcut;
module.exports.default = $b8602c4416cfa89b$var$earcut;
function $b8602c4416cfa89b$var$earcut(data, holeIndices, dim) {
    dim = dim || 2;
    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = $b8602c4416cfa89b$var$linkedList(data, 0, outerLen, dim, true), triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    var minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = $b8602c4416cfa89b$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];
        for(var i = dim; i < outerLen; i += dim){
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $b8602c4416cfa89b$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $b8602c4416cfa89b$var$linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === $b8602c4416cfa89b$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $b8602c4416cfa89b$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $b8602c4416cfa89b$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $b8602c4416cfa89b$var$equals(last, last.next)) {
        $b8602c4416cfa89b$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $b8602c4416cfa89b$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($b8602c4416cfa89b$var$equals(p, p.next) || $b8602c4416cfa89b$var$area(p.prev, p, p.next) === 0)) {
            $b8602c4416cfa89b$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $b8602c4416cfa89b$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $b8602c4416cfa89b$var$indexCurve(ear, minX, minY, invSize);
    var stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $b8602c4416cfa89b$var$isEarHashed(ear, minX, minY, invSize) : $b8602c4416cfa89b$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $b8602c4416cfa89b$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $b8602c4416cfa89b$var$earcutLinked($b8602c4416cfa89b$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $b8602c4416cfa89b$var$cureLocalIntersections($b8602c4416cfa89b$var$filterPoints(ear), triangles, dim);
                $b8602c4416cfa89b$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $b8602c4416cfa89b$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $b8602c4416cfa89b$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($b8602c4416cfa89b$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    var p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $b8602c4416cfa89b$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $b8602c4416cfa89b$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $b8602c4416cfa89b$var$isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($b8602c4416cfa89b$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    var minZ = $b8602c4416cfa89b$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $b8602c4416cfa89b$var$zOrder(x1, y1, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $b8602c4416cfa89b$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $b8602c4416cfa89b$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $b8602c4416cfa89b$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $b8602c4416cfa89b$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $b8602c4416cfa89b$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $b8602c4416cfa89b$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $b8602c4416cfa89b$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $b8602c4416cfa89b$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $b8602c4416cfa89b$var$cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$b8602c4416cfa89b$var$equals(a, b) && $b8602c4416cfa89b$var$intersects(a, p, p.next, b) && $b8602c4416cfa89b$var$locallyInside(a, b) && $b8602c4416cfa89b$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $b8602c4416cfa89b$var$removeNode(p);
            $b8602c4416cfa89b$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $b8602c4416cfa89b$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $b8602c4416cfa89b$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $b8602c4416cfa89b$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $b8602c4416cfa89b$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $b8602c4416cfa89b$var$filterPoints(a, a.next);
                c = $b8602c4416cfa89b$var$filterPoints(c, c.next);
                // run earcut on each half
                $b8602c4416cfa89b$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $b8602c4416cfa89b$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $b8602c4416cfa89b$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [], i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $b8602c4416cfa89b$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($b8602c4416cfa89b$var$getLeftmost(list));
    }
    queue.sort($b8602c4416cfa89b$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $b8602c4416cfa89b$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $b8602c4416cfa89b$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $b8602c4416cfa89b$var$eliminateHole(hole, outerNode) {
    var bridge = $b8602c4416cfa89b$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    var bridgeReverse = $b8602c4416cfa89b$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $b8602c4416cfa89b$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $b8602c4416cfa89b$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $b8602c4416cfa89b$var$findHoleBridge(hole, outerNode) {
    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $b8602c4416cfa89b$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($b8602c4416cfa89b$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $b8602c4416cfa89b$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $b8602c4416cfa89b$var$sectorContainsSector(m, p) {
    return $b8602c4416cfa89b$var$area(m.prev, m, p.prev) < 0 && $b8602c4416cfa89b$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $b8602c4416cfa89b$var$indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = $b8602c4416cfa89b$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $b8602c4416cfa89b$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $b8602c4416cfa89b$var$sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $b8602c4416cfa89b$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $b8602c4416cfa89b$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $b8602c4416cfa89b$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $b8602c4416cfa89b$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$b8602c4416cfa89b$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($b8602c4416cfa89b$var$locallyInside(a, b) && $b8602c4416cfa89b$var$locallyInside(b, a) && $b8602c4416cfa89b$var$middleInside(a, b) && // locally visible
    ($b8602c4416cfa89b$var$area(a.prev, a, b.prev) || $b8602c4416cfa89b$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $b8602c4416cfa89b$var$equals(a, b) && $b8602c4416cfa89b$var$area(a.prev, a, a.next) > 0 && $b8602c4416cfa89b$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $b8602c4416cfa89b$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $b8602c4416cfa89b$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $b8602c4416cfa89b$var$intersects(p1, q1, p2, q2) {
    var o1 = $b8602c4416cfa89b$var$sign($b8602c4416cfa89b$var$area(p1, q1, p2));
    var o2 = $b8602c4416cfa89b$var$sign($b8602c4416cfa89b$var$area(p1, q1, q2));
    var o3 = $b8602c4416cfa89b$var$sign($b8602c4416cfa89b$var$area(p2, q2, p1));
    var o4 = $b8602c4416cfa89b$var$sign($b8602c4416cfa89b$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $b8602c4416cfa89b$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $b8602c4416cfa89b$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $b8602c4416cfa89b$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $b8602c4416cfa89b$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $b8602c4416cfa89b$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $b8602c4416cfa89b$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $b8602c4416cfa89b$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $b8602c4416cfa89b$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $b8602c4416cfa89b$var$locallyInside(a, b) {
    return $b8602c4416cfa89b$var$area(a.prev, a, a.next) < 0 ? $b8602c4416cfa89b$var$area(a, b, a.next) >= 0 && $b8602c4416cfa89b$var$area(a, a.prev, b) >= 0 : $b8602c4416cfa89b$var$area(a, b, a.prev) < 0 || $b8602c4416cfa89b$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $b8602c4416cfa89b$var$middleInside(a, b) {
    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $b8602c4416cfa89b$var$splitPolygon(a, b) {
    var a2 = new $b8602c4416cfa89b$var$Node(a.i, a.x, a.y), b2 = new $b8602c4416cfa89b$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $b8602c4416cfa89b$var$insertNode(i, x, y, last) {
    var p = new $b8602c4416cfa89b$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $b8602c4416cfa89b$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $b8602c4416cfa89b$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
$b8602c4416cfa89b$var$earcut.deviation = function(data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var polygonArea = Math.abs($b8602c4416cfa89b$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
        var start = holeIndices[i] * dim;
        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($b8602c4416cfa89b$var$signedArea(data, start, end, dim));
    }
    var trianglesArea = 0;
    for(i = 0; i < triangles.length; i += 3){
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function $b8602c4416cfa89b$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
$b8602c4416cfa89b$var$earcut.flatten = function(data) {
    var dim = data[0][0].length, result = {
        vertices: [],
        holes: [],
        dimensions: dim
    }, holeIndex = 0;
    for(var i = 0; i < data.length; i++){
        for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};

});

parcelRegister("hH01d", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $9Wff9 = parcelRequire("9Wff9");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $5iXBv = parcelRequire("5iXBv");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $5iXBv.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $9Wff9.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $5iXBv.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $5iXBv.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("9Wff9", function(module, exports) {
/*! https://mths.be/punycode v1.4.1 by @mathias */ (function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("5iXBv", function(module, exports) {
'use strict';

var $88Tjm = parcelRequire("88Tjm");

var $1vzis = parcelRequire("1vzis");

var $aYeQo = parcelRequire("aYeQo");
module.exports = {
    formats: $aYeQo,
    parse: $1vzis,
    stringify: $88Tjm
};

});
parcelRegister("88Tjm", function(module, exports) {
'use strict';

var $aLN2C = parcelRequire("aLN2C");

var $6fzSR = parcelRequire("6fzSR");

var $aYeQo = parcelRequire("aYeQo");
var $5ed9f9c214c4a8f4$var$has = Object.prototype.hasOwnProperty;
var $5ed9f9c214c4a8f4$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $5ed9f9c214c4a8f4$var$isArray = Array.isArray;
var $5ed9f9c214c4a8f4$var$push = Array.prototype.push;
var $5ed9f9c214c4a8f4$var$pushToArray = function(arr, valueOrArray) {
    $5ed9f9c214c4a8f4$var$push.apply(arr, $5ed9f9c214c4a8f4$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $5ed9f9c214c4a8f4$var$toISO = Date.prototype.toISOString;
var $5ed9f9c214c4a8f4$var$defaultFormat = $aYeQo.default;
var $5ed9f9c214c4a8f4$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $6fzSR.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $5ed9f9c214c4a8f4$var$defaultFormat,
    formatter: $aYeQo.formatters[$5ed9f9c214c4a8f4$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $5ed9f9c214c4a8f4$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $5ed9f9c214c4a8f4$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $5ed9f9c214c4a8f4$var$sentinel = {};
var $5ed9f9c214c4a8f4$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($5ed9f9c214c4a8f4$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($5ed9f9c214c4a8f4$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $5ed9f9c214c4a8f4$var$isArray(obj)) obj = $6fzSR.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $5ed9f9c214c4a8f4$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($5ed9f9c214c4a8f4$var$isNonNullishPrimitive(obj) || $6fzSR.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $5ed9f9c214c4a8f4$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $5ed9f9c214c4a8f4$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $5ed9f9c214c4a8f4$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $6fzSR.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($5ed9f9c214c4a8f4$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $5ed9f9c214c4a8f4$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $5ed9f9c214c4a8f4$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $5ed9f9c214c4a8f4$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $aLN2C();
        valueSideChannel.set($5ed9f9c214c4a8f4$var$sentinel, sideChannel);
        $5ed9f9c214c4a8f4$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $5ed9f9c214c4a8f4$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $5ed9f9c214c4a8f4$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $5ed9f9c214c4a8f4$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $5ed9f9c214c4a8f4$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $aYeQo.default;
    if (typeof opts.format !== 'undefined') {
        if (!$5ed9f9c214c4a8f4$var$has.call($aYeQo.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $aYeQo.formatters[format];
    var filter = $5ed9f9c214c4a8f4$var$defaults.filter;
    if (typeof opts.filter === 'function' || $5ed9f9c214c4a8f4$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $5ed9f9c214c4a8f4$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $5ed9f9c214c4a8f4$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $5ed9f9c214c4a8f4$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $5ed9f9c214c4a8f4$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $5ed9f9c214c4a8f4$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $5ed9f9c214c4a8f4$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $5ed9f9c214c4a8f4$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $5ed9f9c214c4a8f4$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $5ed9f9c214c4a8f4$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $5ed9f9c214c4a8f4$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $5ed9f9c214c4a8f4$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $5ed9f9c214c4a8f4$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $5ed9f9c214c4a8f4$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $5ed9f9c214c4a8f4$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $5ed9f9c214c4a8f4$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($5ed9f9c214c4a8f4$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $5ed9f9c214c4a8f4$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $aLN2C();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $5ed9f9c214c4a8f4$var$pushToArray(keys, $5ed9f9c214c4a8f4$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("aLN2C", function(module, exports) {
'use strict';

var $eDiIz = parcelRequire("eDiIz");

var $5reXs = parcelRequire("5reXs");

var $2h55P = parcelRequire("2h55P");

var $Sth43 = parcelRequire("Sth43");

var $4mZ6l = parcelRequire("4mZ6l");
var $7d7455b7eca66e61$var$makeChannel = $4mZ6l || $Sth43 || $2h55P;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eDiIz('Side channel does not contain ' + $5reXs(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $7d7455b7eca66e61$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("eDiIz", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("5reXs", function(module, exports) {
var $3f5b13b16a751ddf$var$hasMap = typeof Map === 'function' && Map.prototype;
var $3f5b13b16a751ddf$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $3f5b13b16a751ddf$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $3f5b13b16a751ddf$var$mapSize = $3f5b13b16a751ddf$var$hasMap && $3f5b13b16a751ddf$var$mapSizeDescriptor && typeof $3f5b13b16a751ddf$var$mapSizeDescriptor.get === 'function' ? $3f5b13b16a751ddf$var$mapSizeDescriptor.get : null;
var $3f5b13b16a751ddf$var$mapForEach = $3f5b13b16a751ddf$var$hasMap && Map.prototype.forEach;
var $3f5b13b16a751ddf$var$hasSet = typeof Set === 'function' && Set.prototype;
var $3f5b13b16a751ddf$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $3f5b13b16a751ddf$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $3f5b13b16a751ddf$var$setSize = $3f5b13b16a751ddf$var$hasSet && $3f5b13b16a751ddf$var$setSizeDescriptor && typeof $3f5b13b16a751ddf$var$setSizeDescriptor.get === 'function' ? $3f5b13b16a751ddf$var$setSizeDescriptor.get : null;
var $3f5b13b16a751ddf$var$setForEach = $3f5b13b16a751ddf$var$hasSet && Set.prototype.forEach;
var $3f5b13b16a751ddf$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $3f5b13b16a751ddf$var$weakMapHas = $3f5b13b16a751ddf$var$hasWeakMap ? WeakMap.prototype.has : null;
var $3f5b13b16a751ddf$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $3f5b13b16a751ddf$var$weakSetHas = $3f5b13b16a751ddf$var$hasWeakSet ? WeakSet.prototype.has : null;
var $3f5b13b16a751ddf$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $3f5b13b16a751ddf$var$weakRefDeref = $3f5b13b16a751ddf$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $3f5b13b16a751ddf$var$booleanValueOf = Boolean.prototype.valueOf;
var $3f5b13b16a751ddf$var$objectToString = Object.prototype.toString;
var $3f5b13b16a751ddf$var$functionToString = Function.prototype.toString;
var $3f5b13b16a751ddf$var$$match = String.prototype.match;
var $3f5b13b16a751ddf$var$$slice = String.prototype.slice;
var $3f5b13b16a751ddf$var$$replace = String.prototype.replace;
var $3f5b13b16a751ddf$var$$toUpperCase = String.prototype.toUpperCase;
var $3f5b13b16a751ddf$var$$toLowerCase = String.prototype.toLowerCase;
var $3f5b13b16a751ddf$var$$test = RegExp.prototype.test;
var $3f5b13b16a751ddf$var$$concat = Array.prototype.concat;
var $3f5b13b16a751ddf$var$$join = Array.prototype.join;
var $3f5b13b16a751ddf$var$$arrSlice = Array.prototype.slice;
var $3f5b13b16a751ddf$var$$floor = Math.floor;
var $3f5b13b16a751ddf$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $3f5b13b16a751ddf$var$gOPS = Object.getOwnPropertySymbols;
var $3f5b13b16a751ddf$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $3f5b13b16a751ddf$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $3f5b13b16a751ddf$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $3f5b13b16a751ddf$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $3f5b13b16a751ddf$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $3f5b13b16a751ddf$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $3f5b13b16a751ddf$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $3f5b13b16a751ddf$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$3f5b13b16a751ddf$var$$floor(-num) : $3f5b13b16a751ddf$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $3f5b13b16a751ddf$var$$slice.call(str, intStr.length + 1);
            return $3f5b13b16a751ddf$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $3f5b13b16a751ddf$var$$replace.call($3f5b13b16a751ddf$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $3f5b13b16a751ddf$var$$replace.call(str, sepRegex, '$&_');
}

var $5Io6y = parcelRequire("5Io6y");
var $3f5b13b16a751ddf$var$inspectCustom = $5Io6y.custom;
var $3f5b13b16a751ddf$var$inspectSymbol = $3f5b13b16a751ddf$var$isSymbol($3f5b13b16a751ddf$var$inspectCustom) ? $3f5b13b16a751ddf$var$inspectCustom : null;
var $3f5b13b16a751ddf$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $3f5b13b16a751ddf$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($3f5b13b16a751ddf$var$has(opts, 'quoteStyle') && !$3f5b13b16a751ddf$var$has($3f5b13b16a751ddf$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($3f5b13b16a751ddf$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $3f5b13b16a751ddf$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($3f5b13b16a751ddf$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($3f5b13b16a751ddf$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $3f5b13b16a751ddf$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $3f5b13b16a751ddf$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $3f5b13b16a751ddf$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $3f5b13b16a751ddf$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $3f5b13b16a751ddf$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($3f5b13b16a751ddf$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $3f5b13b16a751ddf$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($3f5b13b16a751ddf$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$3f5b13b16a751ddf$var$isRegExp(obj)) {
        var name = $3f5b13b16a751ddf$var$nameOf(obj);
        var keys = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $3f5b13b16a751ddf$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($3f5b13b16a751ddf$var$isSymbol(obj)) {
        var symString = $3f5b13b16a751ddf$var$hasShammedSymbols ? $3f5b13b16a751ddf$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $3f5b13b16a751ddf$var$symToString.call(obj);
        return typeof obj === 'object' && !$3f5b13b16a751ddf$var$hasShammedSymbols ? $3f5b13b16a751ddf$var$markBoxed(symString) : symString;
    }
    if ($3f5b13b16a751ddf$var$isElement(obj)) {
        var s = '<' + $3f5b13b16a751ddf$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $3f5b13b16a751ddf$var$wrapQuotes($3f5b13b16a751ddf$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $3f5b13b16a751ddf$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($3f5b13b16a751ddf$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        if (indent && !$3f5b13b16a751ddf$var$singleLineValues(xs)) return '[' + $3f5b13b16a751ddf$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $3f5b13b16a751ddf$var$$join.call(xs, ', ') + ' ]';
    }
    if ($3f5b13b16a751ddf$var$isError(obj)) {
        var parts = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$3f5b13b16a751ddf$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $3f5b13b16a751ddf$var$$join.call($3f5b13b16a751ddf$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $3f5b13b16a751ddf$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($3f5b13b16a751ddf$var$inspectSymbol && typeof obj[$3f5b13b16a751ddf$var$inspectSymbol] === 'function' && $5Io6y) return $5Io6y(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($3f5b13b16a751ddf$var$isMap(obj)) {
        var mapParts = [];
        if ($3f5b13b16a751ddf$var$mapForEach) $3f5b13b16a751ddf$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $3f5b13b16a751ddf$var$collectionOf('Map', $3f5b13b16a751ddf$var$mapSize.call(obj), mapParts, indent);
    }
    if ($3f5b13b16a751ddf$var$isSet(obj)) {
        var setParts = [];
        if ($3f5b13b16a751ddf$var$setForEach) $3f5b13b16a751ddf$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $3f5b13b16a751ddf$var$collectionOf('Set', $3f5b13b16a751ddf$var$setSize.call(obj), setParts, indent);
    }
    if ($3f5b13b16a751ddf$var$isWeakMap(obj)) return $3f5b13b16a751ddf$var$weakCollectionOf('WeakMap');
    if ($3f5b13b16a751ddf$var$isWeakSet(obj)) return $3f5b13b16a751ddf$var$weakCollectionOf('WeakSet');
    if ($3f5b13b16a751ddf$var$isWeakRef(obj)) return $3f5b13b16a751ddf$var$weakCollectionOf('WeakRef');
    if ($3f5b13b16a751ddf$var$isNumber(obj)) return $3f5b13b16a751ddf$var$markBoxed(inspect(Number(obj)));
    if ($3f5b13b16a751ddf$var$isBigInt(obj)) return $3f5b13b16a751ddf$var$markBoxed(inspect($3f5b13b16a751ddf$var$bigIntValueOf.call(obj)));
    if ($3f5b13b16a751ddf$var$isBoolean(obj)) return $3f5b13b16a751ddf$var$markBoxed($3f5b13b16a751ddf$var$booleanValueOf.call(obj));
    if ($3f5b13b16a751ddf$var$isString(obj)) return $3f5b13b16a751ddf$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$3f5b13b16a751ddf$var$isDate(obj) && !$3f5b13b16a751ddf$var$isRegExp(obj)) {
        var ys = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        var isPlainObject = $3f5b13b16a751ddf$var$gPO ? $3f5b13b16a751ddf$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $3f5b13b16a751ddf$var$toStringTag && Object(obj) === obj && $3f5b13b16a751ddf$var$toStringTag in obj ? $3f5b13b16a751ddf$var$$slice.call($3f5b13b16a751ddf$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $3f5b13b16a751ddf$var$$join.call($3f5b13b16a751ddf$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $3f5b13b16a751ddf$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $3f5b13b16a751ddf$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $3f5b13b16a751ddf$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $3f5b13b16a751ddf$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $3f5b13b16a751ddf$var$quote(s) {
    return $3f5b13b16a751ddf$var$$replace.call(String(s), /"/g, '&quot;');
}
function $3f5b13b16a751ddf$var$canTrustToString(obj) {
    return !$3f5b13b16a751ddf$var$toStringTag || !(typeof obj === 'object' && ($3f5b13b16a751ddf$var$toStringTag in obj || typeof obj[$3f5b13b16a751ddf$var$toStringTag] !== 'undefined'));
}
function $3f5b13b16a751ddf$var$isArray(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Array]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isDate(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Date]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isRegExp(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object RegExp]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isError(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Error]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isString(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object String]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isNumber(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Number]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
function $3f5b13b16a751ddf$var$isBoolean(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === '[object Boolean]' && $3f5b13b16a751ddf$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $3f5b13b16a751ddf$var$isSymbol(obj) {
    if ($3f5b13b16a751ddf$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$3f5b13b16a751ddf$var$symToString) return false;
    try {
        $3f5b13b16a751ddf$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$3f5b13b16a751ddf$var$bigIntValueOf) return false;
    try {
        $3f5b13b16a751ddf$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $3f5b13b16a751ddf$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $3f5b13b16a751ddf$var$has(obj, key) {
    return $3f5b13b16a751ddf$var$hasOwn.call(obj, key);
}
function $3f5b13b16a751ddf$var$toStr(obj) {
    return $3f5b13b16a751ddf$var$objectToString.call(obj);
}
function $3f5b13b16a751ddf$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $3f5b13b16a751ddf$var$$match.call($3f5b13b16a751ddf$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $3f5b13b16a751ddf$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $3f5b13b16a751ddf$var$isMap(x) {
    if (!$3f5b13b16a751ddf$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$mapSize.call(x);
        try {
            $3f5b13b16a751ddf$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isWeakMap(x) {
    if (!$3f5b13b16a751ddf$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$weakMapHas.call(x, $3f5b13b16a751ddf$var$weakMapHas);
        try {
            $3f5b13b16a751ddf$var$weakSetHas.call(x, $3f5b13b16a751ddf$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isWeakRef(x) {
    if (!$3f5b13b16a751ddf$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isSet(x) {
    if (!$3f5b13b16a751ddf$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$setSize.call(x);
        try {
            $3f5b13b16a751ddf$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isWeakSet(x) {
    if (!$3f5b13b16a751ddf$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $3f5b13b16a751ddf$var$weakSetHas.call(x, $3f5b13b16a751ddf$var$weakSetHas);
        try {
            $3f5b13b16a751ddf$var$weakMapHas.call(x, $3f5b13b16a751ddf$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $3f5b13b16a751ddf$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $3f5b13b16a751ddf$var$inspectString($3f5b13b16a751ddf$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $3f5b13b16a751ddf$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $3f5b13b16a751ddf$var$$replace.call($3f5b13b16a751ddf$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $3f5b13b16a751ddf$var$lowbyte);
    return $3f5b13b16a751ddf$var$wrapQuotes(s, 'single', opts);
}
function $3f5b13b16a751ddf$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $3f5b13b16a751ddf$var$$toUpperCase.call(n.toString(16));
}
function $3f5b13b16a751ddf$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $3f5b13b16a751ddf$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $3f5b13b16a751ddf$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $3f5b13b16a751ddf$var$indentedJoin(entries, indent) : $3f5b13b16a751ddf$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $3f5b13b16a751ddf$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($3f5b13b16a751ddf$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $3f5b13b16a751ddf$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $3f5b13b16a751ddf$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $3f5b13b16a751ddf$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $3f5b13b16a751ddf$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $3f5b13b16a751ddf$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect) {
    var isArr = $3f5b13b16a751ddf$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $3f5b13b16a751ddf$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $3f5b13b16a751ddf$var$gOPS === 'function' ? $3f5b13b16a751ddf$var$gOPS(obj) : [];
    var symMap;
    if ($3f5b13b16a751ddf$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$3f5b13b16a751ddf$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($3f5b13b16a751ddf$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($3f5b13b16a751ddf$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $3f5b13b16a751ddf$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($3f5b13b16a751ddf$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("5Io6y", function(module, exports) {
"use strict";

});


parcelRegister("2h55P", function(module, exports) {
'use strict';

var $5reXs = parcelRequire("5reXs");

var $eDiIz = parcelRequire("eDiIz");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $1a811eae018032cc$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $1a811eae018032cc$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $1a811eae018032cc$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $1a811eae018032cc$var$listSet = function(objects, key, value) {
    var node = $1a811eae018032cc$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $1a811eae018032cc$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$1a811eae018032cc$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $1a811eae018032cc$var$listDelete = function(objects, key) {
    if (objects) return $1a811eae018032cc$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eDiIz('Side channel does not contain ' + $5reXs(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $1a811eae018032cc$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $1a811eae018032cc$var$listGet($o, key);
        },
        has: function(key) {
            return $1a811eae018032cc$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $1a811eae018032cc$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("Sth43", function(module, exports) {
'use strict';

var $avqmt = parcelRequire("avqmt");

var $bhqNG = parcelRequire("bhqNG");

var $5reXs = parcelRequire("5reXs");

var $eDiIz = parcelRequire("eDiIz");
var $0a3bc083529cac57$var$$Map = $avqmt('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $0a3bc083529cac57$var$$mapGet = $bhqNG('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $0a3bc083529cac57$var$$mapSet = $bhqNG('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $0a3bc083529cac57$var$$mapHas = $bhqNG('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $0a3bc083529cac57$var$$mapDelete = $bhqNG('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $0a3bc083529cac57$var$$mapSize = $bhqNG('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$0a3bc083529cac57$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eDiIz('Side channel does not contain ' + $5reXs(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $0a3bc083529cac57$var$$mapDelete($m, key);
                if ($0a3bc083529cac57$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $0a3bc083529cac57$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $0a3bc083529cac57$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $0a3bc083529cac57$var$$Map();
            $0a3bc083529cac57$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("avqmt", function(module, exports) {
'use strict';
var $7a613f7503e09dde$var$undefined1;

var $7KrI3 = parcelRequire("7KrI3");

var $ki6v4 = parcelRequire("ki6v4");

var $6ZF4E = parcelRequire("6ZF4E");

var $jFaeR = parcelRequire("jFaeR");

var $aNqH3 = parcelRequire("aNqH3");

var $iOgL8 = parcelRequire("iOgL8");

var $eDiIz = parcelRequire("eDiIz");

var $guz3A = parcelRequire("guz3A");

var $db7xm = parcelRequire("db7xm");

var $gKnEJ = parcelRequire("gKnEJ");

var $42MO3 = parcelRequire("42MO3");

var $daBYy = parcelRequire("daBYy");

var $7VgwK = parcelRequire("7VgwK");

var $6GICW = parcelRequire("6GICW");

var $lj3GK = parcelRequire("lj3GK");
var $7a613f7503e09dde$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $7a613f7503e09dde$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $7a613f7503e09dde$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $crSdH = parcelRequire("crSdH");

var $4jAFO = parcelRequire("4jAFO");
var $7a613f7503e09dde$var$throwTypeError = function() {
    throw new $eDiIz();
};
var $7a613f7503e09dde$var$ThrowTypeError = $crSdH ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $7a613f7503e09dde$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $crSdH(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $7a613f7503e09dde$var$throwTypeError;
        }
    }
}() : $7a613f7503e09dde$var$throwTypeError;

var $7a613f7503e09dde$var$hasSymbols = (parcelRequire("5CmBX"))();

var $agKAf = parcelRequire("agKAf");

var $e351b = parcelRequire("e351b");

var $kF6dV = parcelRequire("kF6dV");

var $hsI1I = parcelRequire("hsI1I");

var $9RlYm = parcelRequire("9RlYm");
var $7a613f7503e09dde$var$needsEval = {};
var $7a613f7503e09dde$var$TypedArray = typeof Uint8Array === 'undefined' || !$agKAf ? undefined : $agKAf(Uint8Array);
var $7a613f7503e09dde$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $agKAf ? $agKAf([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $7a613f7503e09dde$var$needsEval,
    '%AsyncGenerator%': $7a613f7503e09dde$var$needsEval,
    '%AsyncGeneratorFunction%': $7a613f7503e09dde$var$needsEval,
    '%AsyncIteratorPrototype%': $7a613f7503e09dde$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $ki6v4,
    '%eval%': eval,
    '%EvalError%': $6ZF4E,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $7a613f7503e09dde$var$$Function,
    '%GeneratorFunction%': $7a613f7503e09dde$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $agKAf ? $agKAf($agKAf([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$7a613f7503e09dde$var$hasSymbols || !$agKAf ? undefined : $agKAf(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $7KrI3,
    '%Object.getOwnPropertyDescriptor%': $crSdH,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $jFaeR,
    '%ReferenceError%': $aNqH3,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$7a613f7503e09dde$var$hasSymbols || !$agKAf ? undefined : $agKAf(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $7a613f7503e09dde$var$hasSymbols && $agKAf ? $agKAf(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $7a613f7503e09dde$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $iOgL8,
    '%ThrowTypeError%': $7a613f7503e09dde$var$ThrowTypeError,
    '%TypedArray%': $7a613f7503e09dde$var$TypedArray,
    '%TypeError%': $eDiIz,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $guz3A,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9RlYm,
    '%Function.prototype.apply%': $hsI1I,
    '%Object.defineProperty%': $4jAFO,
    '%Object.getPrototypeOf%': $e351b,
    '%Math.abs%': $db7xm,
    '%Math.floor%': $gKnEJ,
    '%Math.max%': $42MO3,
    '%Math.min%': $daBYy,
    '%Math.pow%': $7VgwK,
    '%Math.round%': $6GICW,
    '%Math.sign%': $lj3GK,
    '%Reflect.getPrototypeOf%': $kF6dV
};
if ($agKAf) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $7a613f7503e09dde$var$errorProto = $agKAf($agKAf(e));
    $7a613f7503e09dde$var$INTRINSICS['%Error.prototype%'] = $7a613f7503e09dde$var$errorProto;
}
var $7a613f7503e09dde$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $7a613f7503e09dde$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $agKAf) value = $agKAf(gen.prototype);
    }
    $7a613f7503e09dde$var$INTRINSICS[name] = value;
    return value;
};
var $7a613f7503e09dde$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $7Dte4 = parcelRequire("7Dte4");
var $7a613f7503e09dde$var$$concat = $a7ABz.call($9RlYm, Array.prototype.concat);
var $7a613f7503e09dde$var$$spliceApply = $a7ABz.call($hsI1I, Array.prototype.splice);
var $7a613f7503e09dde$var$$replace = $a7ABz.call($9RlYm, String.prototype.replace);
var $7a613f7503e09dde$var$$strSlice = $a7ABz.call($9RlYm, String.prototype.slice);
var $7a613f7503e09dde$var$$exec = $a7ABz.call($9RlYm, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $7a613f7503e09dde$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $7a613f7503e09dde$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $7a613f7503e09dde$var$stringToPath = function stringToPath(string) {
    var first = $7a613f7503e09dde$var$$strSlice(string, 0, 1);
    var last = $7a613f7503e09dde$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $iOgL8('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $iOgL8('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $7a613f7503e09dde$var$$replace(string, $7a613f7503e09dde$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $7a613f7503e09dde$var$$replace(subString, $7a613f7503e09dde$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $7a613f7503e09dde$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7Dte4($7a613f7503e09dde$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $7a613f7503e09dde$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicName)) {
        var value = $7a613f7503e09dde$var$INTRINSICS[intrinsicName];
        if (value === $7a613f7503e09dde$var$needsEval) value = $7a613f7503e09dde$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eDiIz('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $iOgL8('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eDiIz('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eDiIz('"allowMissing" argument must be a boolean');
    if ($7a613f7503e09dde$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $iOgL8('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $7a613f7503e09dde$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $7a613f7503e09dde$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $7a613f7503e09dde$var$$spliceApply(parts, $7a613f7503e09dde$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $7a613f7503e09dde$var$$strSlice(part, 0, 1);
        var last = $7a613f7503e09dde$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $iOgL8('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicRealName)) value = $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eDiIz('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($crSdH && i + 1 >= parts.length) {
                var desc = $crSdH(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7Dte4(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("7KrI3", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("ki6v4", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("6ZF4E", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("jFaeR", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("aNqH3", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("iOgL8", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("guz3A", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("db7xm", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("gKnEJ", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("42MO3", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("daBYy", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("7VgwK", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("6GICW", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("lj3GK", function(module, exports) {
'use strict';

var $jhjZ6 = parcelRequire("jhjZ6");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($jhjZ6(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("jhjZ6", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("crSdH", function(module, exports) {
'use strict';

var $gRO4r = parcelRequire("gRO4r");
var $9102109fbf1ea315$require$$gOPD = $gRO4r;
if ($9102109fbf1ea315$require$$gOPD) try {
    $9102109fbf1ea315$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $9102109fbf1ea315$require$$gOPD = null;
}
module.exports = $9102109fbf1ea315$require$$gOPD;

});
parcelRegister("gRO4r", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("4jAFO", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $3245625cab00454b$var$$defineProperty = Object.defineProperty || false;
if ($3245625cab00454b$var$$defineProperty) try {
    $3245625cab00454b$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $3245625cab00454b$var$$defineProperty = false;
}
module.exports = $3245625cab00454b$var$$defineProperty;

});

parcelRegister("5CmBX", function(module, exports) {
'use strict';
var $41720a79fda68d9e$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $fNdnD = parcelRequire("fNdnD");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $41720a79fda68d9e$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $41720a79fda68d9e$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $fNdnD();
};

});
parcelRegister("fNdnD", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("agKAf", function(module, exports) {
'use strict';

var $kF6dV = parcelRequire("kF6dV");

var $e351b = parcelRequire("e351b");

var $lMT7N = parcelRequire("lMT7N");
/** @type {import('.')} */ module.exports = $kF6dV ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $kF6dV(O);
} : $e351b ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $e351b(O);
} : $lMT7N ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $lMT7N(O);
} : null;

});
parcelRegister("kF6dV", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("e351b", function(module, exports) {
'use strict';

var $7KrI3 = parcelRequire("7KrI3");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $7KrI3.getPrototypeOf || null;

});

parcelRegister("lMT7N", function(module, exports) {
'use strict';

var $csNIY = parcelRequire("csNIY");

var $crSdH = parcelRequire("crSdH");
var $fdc8d75150bf6587$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $fdc8d75150bf6587$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $fdc8d75150bf6587$var$desc = !!$fdc8d75150bf6587$var$hasProtoAccessor && $crSdH && $crSdH(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $fdc8d75150bf6587$var$$Object = Object;
var $fdc8d75150bf6587$var$$getPrototypeOf = $fdc8d75150bf6587$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $fdc8d75150bf6587$var$desc && typeof $fdc8d75150bf6587$var$desc.get === 'function' ? $csNIY([
    $fdc8d75150bf6587$var$desc.get
]) : typeof $fdc8d75150bf6587$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $fdc8d75150bf6587$var$$getPrototypeOf(value == null ? value : $fdc8d75150bf6587$var$$Object(value));
} : false;

});
parcelRegister("csNIY", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $eDiIz = parcelRequire("eDiIz");

var $9RlYm = parcelRequire("9RlYm");

var $2Y4BE = parcelRequire("2Y4BE");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eDiIz('a function is required');
    return $2Y4BE($a7ABz, $9RlYm, args);
};

});
parcelRegister("a7ABz", function(module, exports) {
'use strict';

var $cytJY = parcelRequire("cytJY");
module.exports = Function.prototype.bind || $cytJY;

});
parcelRegister("cytJY", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $923fbadf1e720976$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $923fbadf1e720976$var$toStr = Object.prototype.toString;
var $923fbadf1e720976$var$max = Math.max;
var $923fbadf1e720976$var$funcType = '[object Function]';
var $923fbadf1e720976$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $923fbadf1e720976$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $923fbadf1e720976$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $923fbadf1e720976$var$toStr.apply(target) !== $923fbadf1e720976$var$funcType) throw new TypeError($923fbadf1e720976$var$ERROR_MESSAGE + target);
    var args = $923fbadf1e720976$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $923fbadf1e720976$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $923fbadf1e720976$var$concatty(args, arguments));
    };
    var boundLength = $923fbadf1e720976$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $923fbadf1e720976$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9RlYm", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("2Y4BE", function(module, exports) {
'use strict';

var $a7ABz = parcelRequire("a7ABz");

var $hsI1I = parcelRequire("hsI1I");

var $9RlYm = parcelRequire("9RlYm");

var $cnaFh = parcelRequire("cnaFh");
/** @type {import('./actualApply')} */ module.exports = $cnaFh || $a7ABz.call($9RlYm, $hsI1I);

});
parcelRegister("hsI1I", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("cnaFh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("7Dte4", function(module, exports) {
'use strict';
var $58f2d89a35f5270b$var$call = Function.prototype.call;
var $58f2d89a35f5270b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $a7ABz = parcelRequire("a7ABz");
/** @type {import('.')} */ module.exports = $a7ABz.call($58f2d89a35f5270b$var$call, $58f2d89a35f5270b$var$$hasOwn);

});


parcelRegister("bhqNG", function(module, exports) {
'use strict';

var $avqmt = parcelRequire("avqmt");

var $csNIY = parcelRequire("csNIY");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $8366123d1c7410f8$var$$indexOf = $csNIY([
    $avqmt('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $avqmt(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $8366123d1c7410f8$var$$indexOf(name, '.prototype.') > -1) return $csNIY(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("4mZ6l", function(module, exports) {
'use strict';

var $avqmt = parcelRequire("avqmt");

var $bhqNG = parcelRequire("bhqNG");

var $5reXs = parcelRequire("5reXs");

var $Sth43 = parcelRequire("Sth43");

var $eDiIz = parcelRequire("eDiIz");
var $32e89cf5f0eb8664$var$$WeakMap = $avqmt('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $32e89cf5f0eb8664$var$$weakMapGet = $bhqNG('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $32e89cf5f0eb8664$var$$weakMapSet = $bhqNG('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $32e89cf5f0eb8664$var$$weakMapHas = $bhqNG('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $32e89cf5f0eb8664$var$$weakMapDelete = $bhqNG('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $32e89cf5f0eb8664$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eDiIz('Side channel does not contain ' + $5reXs(key));
        },
        'delete': function(key) {
            if ($32e89cf5f0eb8664$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $32e89cf5f0eb8664$var$$weakMapDelete($wm, key);
            } else if ($Sth43) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($32e89cf5f0eb8664$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $32e89cf5f0eb8664$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($32e89cf5f0eb8664$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $32e89cf5f0eb8664$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($32e89cf5f0eb8664$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $32e89cf5f0eb8664$var$$WeakMap();
                $32e89cf5f0eb8664$var$$weakMapSet($wm, key, value);
            } else if ($Sth43) {
                if (!$m) $m = $Sth43();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $Sth43;

});


parcelRegister("6fzSR", function(module, exports) {
'use strict';

var $aYeQo = parcelRequire("aYeQo");
var $48cffa948cd48b24$var$has = Object.prototype.hasOwnProperty;
var $48cffa948cd48b24$var$isArray = Array.isArray;
var $48cffa948cd48b24$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $48cffa948cd48b24$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($48cffa948cd48b24$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $48cffa948cd48b24$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $48cffa948cd48b24$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($48cffa948cd48b24$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$48cffa948cd48b24$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($48cffa948cd48b24$var$isArray(target) && !$48cffa948cd48b24$var$isArray(source)) mergeTarget = $48cffa948cd48b24$var$arrayToObject(target, options);
    if ($48cffa948cd48b24$var$isArray(target) && $48cffa948cd48b24$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($48cffa948cd48b24$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($48cffa948cd48b24$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $48cffa948cd48b24$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $48cffa948cd48b24$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $48cffa948cd48b24$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $48cffa948cd48b24$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $48cffa948cd48b24$var$limit){
        var segment = string.length >= $48cffa948cd48b24$var$limit ? string.slice(j, j + $48cffa948cd48b24$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $aYeQo.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $48cffa948cd48b24$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $48cffa948cd48b24$var$hexTable[0xC0 | c >> 6] + $48cffa948cd48b24$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $48cffa948cd48b24$var$hexTable[0xE0 | c >> 12] + $48cffa948cd48b24$var$hexTable[0x80 | c >> 6 & 0x3F] + $48cffa948cd48b24$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $48cffa948cd48b24$var$hexTable[0xF0 | c >> 18] + $48cffa948cd48b24$var$hexTable[0x80 | c >> 12 & 0x3F] + $48cffa948cd48b24$var$hexTable[0x80 | c >> 6 & 0x3F] + $48cffa948cd48b24$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $48cffa948cd48b24$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $48cffa948cd48b24$var$compactQueue(queue);
    return value;
};
var $48cffa948cd48b24$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $48cffa948cd48b24$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $48cffa948cd48b24$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $48cffa948cd48b24$var$maybeMap = function maybeMap(val, fn) {
    if ($48cffa948cd48b24$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $48cffa948cd48b24$var$arrayToObject,
    assign: $48cffa948cd48b24$var$assign,
    combine: $48cffa948cd48b24$var$combine,
    compact: $48cffa948cd48b24$var$compact,
    decode: $48cffa948cd48b24$var$decode,
    encode: $48cffa948cd48b24$var$encode,
    isBuffer: $48cffa948cd48b24$var$isBuffer,
    isRegExp: $48cffa948cd48b24$var$isRegExp,
    maybeMap: $48cffa948cd48b24$var$maybeMap,
    merge: $48cffa948cd48b24$var$merge
};

});
parcelRegister("aYeQo", function(module, exports) {
'use strict';
var $7fcb05b1ebb63679$var$replace = String.prototype.replace;
var $7fcb05b1ebb63679$var$percentTwenties = /%20/g;
var $7fcb05b1ebb63679$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $7fcb05b1ebb63679$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $7fcb05b1ebb63679$var$replace.call(value, $7fcb05b1ebb63679$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $7fcb05b1ebb63679$var$Format.RFC1738,
    RFC3986: $7fcb05b1ebb63679$var$Format.RFC3986
};

});



parcelRegister("1vzis", function(module, exports) {
'use strict';

var $6fzSR = parcelRequire("6fzSR");
var $119410e761f024ce$var$has = Object.prototype.hasOwnProperty;
var $119410e761f024ce$var$isArray = Array.isArray;
var $119410e761f024ce$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $6fzSR.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $119410e761f024ce$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $119410e761f024ce$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $119410e761f024ce$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $119410e761f024ce$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $119410e761f024ce$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $119410e761f024ce$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $119410e761f024ce$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $119410e761f024ce$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $119410e761f024ce$var$defaults.decoder, charset, 'key');
            val = $6fzSR.maybeMap($119410e761f024ce$var$parseArrayValue(part.slice(pos + 1), options, $119410e761f024ce$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $119410e761f024ce$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $119410e761f024ce$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $119410e761f024ce$var$isArray(val) ? [
            val
        ] : val;
        var existing = $119410e761f024ce$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $6fzSR.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $119410e761f024ce$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $119410e761f024ce$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $6fzSR.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $119410e761f024ce$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $119410e761f024ce$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $119410e761f024ce$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $119410e761f024ce$var$parseObject(keys, val, options, valuesParsed);
};
var $119410e761f024ce$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $119410e761f024ce$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $119410e761f024ce$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $119410e761f024ce$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $119410e761f024ce$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $119410e761f024ce$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $119410e761f024ce$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $119410e761f024ce$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $119410e761f024ce$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $119410e761f024ce$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $119410e761f024ce$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $119410e761f024ce$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $119410e761f024ce$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $6fzSR.isRegExp(opts.delimiter) ? opts.delimiter : $119410e761f024ce$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $119410e761f024ce$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $119410e761f024ce$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $119410e761f024ce$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $119410e761f024ce$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $119410e761f024ce$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $119410e761f024ce$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $119410e761f024ce$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $119410e761f024ce$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $119410e761f024ce$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $6fzSR.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $6fzSR.compact(obj);
};

});



parcelRegister("P8XPi", function(module, exports) {

$parcel$export(module.exports, "ENV", function () { return $099bb7962f016ab8$export$83401e34d5e11bf4; });
$parcel$export(module.exports, "RENDERER_TYPE", function () { return $099bb7962f016ab8$export$747c566515e2a1d9; });
$parcel$export(module.exports, "BUFFER_BITS", function () { return $099bb7962f016ab8$export$c07ea8ac66dac49; });
$parcel$export(module.exports, "BLEND_MODES", function () { return $099bb7962f016ab8$export$f821c68fe9beaecf; });
$parcel$export(module.exports, "DRAW_MODES", function () { return $099bb7962f016ab8$export$91100badd8469338; });
$parcel$export(module.exports, "FORMATS", function () { return $099bb7962f016ab8$export$e9c4b7b466aa8274; });
$parcel$export(module.exports, "TARGETS", function () { return $099bb7962f016ab8$export$d1ff3caf57547dc5; });
$parcel$export(module.exports, "TYPES", function () { return $099bb7962f016ab8$export$426db7a6155b7a80; });
$parcel$export(module.exports, "SAMPLER_TYPES", function () { return $099bb7962f016ab8$export$8ee8af3637d728f5; });
$parcel$export(module.exports, "SCALE_MODES", function () { return $099bb7962f016ab8$export$6b734c6a0bba8473; });
$parcel$export(module.exports, "WRAP_MODES", function () { return $099bb7962f016ab8$export$2ab395cfb0dd2f0f; });
$parcel$export(module.exports, "MIPMAP_MODES", function () { return $099bb7962f016ab8$export$16f6fb5da874bbfd; });
$parcel$export(module.exports, "ALPHA_MODES", function () { return $099bb7962f016ab8$export$d56550d454401b73; });
$parcel$export(module.exports, "CLEAR_MODES", function () { return $099bb7962f016ab8$export$784901839554cbc3; });
$parcel$export(module.exports, "GC_MODES", function () { return $099bb7962f016ab8$export$5c6ba89c1f52b344; });
$parcel$export(module.exports, "PRECISION", function () { return $099bb7962f016ab8$export$d6d3992f3becc879; });
$parcel$export(module.exports, "MASK_TYPES", function () { return $099bb7962f016ab8$export$dbbea138c5d144; });
$parcel$export(module.exports, "MSAA_QUALITY", function () { return $099bb7962f016ab8$export$1eadd657d5acc2f2; });
$parcel$export(module.exports, "BUFFER_TYPE", function () { return $099bb7962f016ab8$export$b595a7e482202b96; });
/*!
 * @pixi/constants - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/constants is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * Different types of environments for WebGL.
 *
 * @static
 * @memberof PIXI
 * @name ENV
 * @enum {number}
 * @property {number} WEBGL_LEGACY - Used for older v1 WebGL devices. PixiJS will aim to ensure compatibility
 *  with older / less advanced devices. If you experience unexplained flickering prefer this environment.
 * @property {number} WEBGL - Version 1 of WebGL
 * @property {number} WEBGL2 - Version 2 of WebGL
 */ var $099bb7962f016ab8$export$83401e34d5e11bf4;
(function(ENV) {
    ENV[ENV["WEBGL_LEGACY"] = 0] = "WEBGL_LEGACY";
    ENV[ENV["WEBGL"] = 1] = "WEBGL";
    ENV[ENV["WEBGL2"] = 2] = "WEBGL2";
})($099bb7962f016ab8$export$83401e34d5e11bf4 || ($099bb7962f016ab8$export$83401e34d5e11bf4 = {}));
/**
 * Constant to identify the Renderer Type.
 *
 * @static
 * @memberof PIXI
 * @name RENDERER_TYPE
 * @enum {number}
 * @property {number} UNKNOWN - Unknown render type.
 * @property {number} WEBGL - WebGL render type.
 * @property {number} CANVAS - Canvas render type.
 */ var $099bb7962f016ab8$export$747c566515e2a1d9;
(function(RENDERER_TYPE) {
    RENDERER_TYPE[RENDERER_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
    RENDERER_TYPE[RENDERER_TYPE["WEBGL"] = 1] = "WEBGL";
    RENDERER_TYPE[RENDERER_TYPE["CANVAS"] = 2] = "CANVAS";
})($099bb7962f016ab8$export$747c566515e2a1d9 || ($099bb7962f016ab8$export$747c566515e2a1d9 = {}));
/**
 * Bitwise OR of masks that indicate the buffers to be cleared.
 *
 * @static
 * @memberof PIXI
 * @name BUFFER_BITS
 * @enum {number}
 * @property {number} COLOR - Indicates the buffers currently enabled for color writing.
 * @property {number} DEPTH - Indicates the depth buffer.
 * @property {number} STENCIL - Indicates the stencil buffer.
 */ var $099bb7962f016ab8$export$c07ea8ac66dac49;
(function(BUFFER_BITS) {
    BUFFER_BITS[BUFFER_BITS["COLOR"] = 16384] = "COLOR";
    BUFFER_BITS[BUFFER_BITS["DEPTH"] = 256] = "DEPTH";
    BUFFER_BITS[BUFFER_BITS["STENCIL"] = 1024] = "STENCIL";
})($099bb7962f016ab8$export$c07ea8ac66dac49 || ($099bb7962f016ab8$export$c07ea8ac66dac49 = {}));
/**
 * Various blend modes supported by PIXI.
 *
 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
 * Anything else will silently act like NORMAL.
 *
 * @memberof PIXI
 * @name BLEND_MODES
 * @enum {number}
 * @property {number} NORMAL
 * @property {number} ADD
 * @property {number} MULTIPLY
 * @property {number} SCREEN
 * @property {number} OVERLAY
 * @property {number} DARKEN
 * @property {number} LIGHTEN
 * @property {number} COLOR_DODGE
 * @property {number} COLOR_BURN
 * @property {number} HARD_LIGHT
 * @property {number} SOFT_LIGHT
 * @property {number} DIFFERENCE
 * @property {number} EXCLUSION
 * @property {number} HUE
 * @property {number} SATURATION
 * @property {number} COLOR
 * @property {number} LUMINOSITY
 * @property {number} NORMAL_NPM
 * @property {number} ADD_NPM
 * @property {number} SCREEN_NPM
 * @property {number} NONE
 * @property {number} SRC_IN
 * @property {number} SRC_OUT
 * @property {number} SRC_ATOP
 * @property {number} DST_OVER
 * @property {number} DST_IN
 * @property {number} DST_OUT
 * @property {number} DST_ATOP
 * @property {number} SUBTRACT
 * @property {number} SRC_OVER
 * @property {number} ERASE
 * @property {number} XOR
 */ var $099bb7962f016ab8$export$f821c68fe9beaecf;
(function(BLEND_MODES) {
    BLEND_MODES[BLEND_MODES["NORMAL"] = 0] = "NORMAL";
    BLEND_MODES[BLEND_MODES["ADD"] = 1] = "ADD";
    BLEND_MODES[BLEND_MODES["MULTIPLY"] = 2] = "MULTIPLY";
    BLEND_MODES[BLEND_MODES["SCREEN"] = 3] = "SCREEN";
    BLEND_MODES[BLEND_MODES["OVERLAY"] = 4] = "OVERLAY";
    BLEND_MODES[BLEND_MODES["DARKEN"] = 5] = "DARKEN";
    BLEND_MODES[BLEND_MODES["LIGHTEN"] = 6] = "LIGHTEN";
    BLEND_MODES[BLEND_MODES["COLOR_DODGE"] = 7] = "COLOR_DODGE";
    BLEND_MODES[BLEND_MODES["COLOR_BURN"] = 8] = "COLOR_BURN";
    BLEND_MODES[BLEND_MODES["HARD_LIGHT"] = 9] = "HARD_LIGHT";
    BLEND_MODES[BLEND_MODES["SOFT_LIGHT"] = 10] = "SOFT_LIGHT";
    BLEND_MODES[BLEND_MODES["DIFFERENCE"] = 11] = "DIFFERENCE";
    BLEND_MODES[BLEND_MODES["EXCLUSION"] = 12] = "EXCLUSION";
    BLEND_MODES[BLEND_MODES["HUE"] = 13] = "HUE";
    BLEND_MODES[BLEND_MODES["SATURATION"] = 14] = "SATURATION";
    BLEND_MODES[BLEND_MODES["COLOR"] = 15] = "COLOR";
    BLEND_MODES[BLEND_MODES["LUMINOSITY"] = 16] = "LUMINOSITY";
    BLEND_MODES[BLEND_MODES["NORMAL_NPM"] = 17] = "NORMAL_NPM";
    BLEND_MODES[BLEND_MODES["ADD_NPM"] = 18] = "ADD_NPM";
    BLEND_MODES[BLEND_MODES["SCREEN_NPM"] = 19] = "SCREEN_NPM";
    BLEND_MODES[BLEND_MODES["NONE"] = 20] = "NONE";
    BLEND_MODES[BLEND_MODES["SRC_OVER"] = 0] = "SRC_OVER";
    BLEND_MODES[BLEND_MODES["SRC_IN"] = 21] = "SRC_IN";
    BLEND_MODES[BLEND_MODES["SRC_OUT"] = 22] = "SRC_OUT";
    BLEND_MODES[BLEND_MODES["SRC_ATOP"] = 23] = "SRC_ATOP";
    BLEND_MODES[BLEND_MODES["DST_OVER"] = 24] = "DST_OVER";
    BLEND_MODES[BLEND_MODES["DST_IN"] = 25] = "DST_IN";
    BLEND_MODES[BLEND_MODES["DST_OUT"] = 26] = "DST_OUT";
    BLEND_MODES[BLEND_MODES["DST_ATOP"] = 27] = "DST_ATOP";
    BLEND_MODES[BLEND_MODES["ERASE"] = 26] = "ERASE";
    BLEND_MODES[BLEND_MODES["SUBTRACT"] = 28] = "SUBTRACT";
    BLEND_MODES[BLEND_MODES["XOR"] = 29] = "XOR";
})($099bb7962f016ab8$export$f821c68fe9beaecf || ($099bb7962f016ab8$export$f821c68fe9beaecf = {}));
/**
 * Various webgl draw modes. These can be used to specify which GL drawMode to use
 * under certain situations and renderers.
 *
 * @memberof PIXI
 * @static
 * @name DRAW_MODES
 * @enum {number}
 * @property {number} POINTS
 * @property {number} LINES
 * @property {number} LINE_LOOP
 * @property {number} LINE_STRIP
 * @property {number} TRIANGLES
 * @property {number} TRIANGLE_STRIP
 * @property {number} TRIANGLE_FAN
 */ var $099bb7962f016ab8$export$91100badd8469338;
(function(DRAW_MODES) {
    DRAW_MODES[DRAW_MODES["POINTS"] = 0] = "POINTS";
    DRAW_MODES[DRAW_MODES["LINES"] = 1] = "LINES";
    DRAW_MODES[DRAW_MODES["LINE_LOOP"] = 2] = "LINE_LOOP";
    DRAW_MODES[DRAW_MODES["LINE_STRIP"] = 3] = "LINE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLES"] = 4] = "TRIANGLES";
    DRAW_MODES[DRAW_MODES["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
})($099bb7962f016ab8$export$91100badd8469338 || ($099bb7962f016ab8$export$91100badd8469338 = {}));
/**
 * Various GL texture/resources formats.
 *
 * @memberof PIXI
 * @static
 * @name FORMATS
 * @enum {number}
 * @property {number} RGBA=6408
 * @property {number} RGB=6407
 * @property {number} RG=33319
 * @property {number} RED=6403
 * @property {number} RGBA_INTEGER=36249
 * @property {number} RGB_INTEGER=36248
 * @property {number} RG_INTEGER=33320
 * @property {number} RED_INTEGER=36244
 * @property {number} ALPHA=6406
 * @property {number} LUMINANCE=6409
 * @property {number} LUMINANCE_ALPHA=6410
 * @property {number} DEPTH_COMPONENT=6402
 * @property {number} DEPTH_STENCIL=34041
 */ var $099bb7962f016ab8$export$e9c4b7b466aa8274;
(function(FORMATS) {
    FORMATS[FORMATS["RGBA"] = 6408] = "RGBA";
    FORMATS[FORMATS["RGB"] = 6407] = "RGB";
    FORMATS[FORMATS["RG"] = 33319] = "RG";
    FORMATS[FORMATS["RED"] = 6403] = "RED";
    FORMATS[FORMATS["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    FORMATS[FORMATS["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    FORMATS[FORMATS["RG_INTEGER"] = 33320] = "RG_INTEGER";
    FORMATS[FORMATS["RED_INTEGER"] = 36244] = "RED_INTEGER";
    FORMATS[FORMATS["ALPHA"] = 6406] = "ALPHA";
    FORMATS[FORMATS["LUMINANCE"] = 6409] = "LUMINANCE";
    FORMATS[FORMATS["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    FORMATS[FORMATS["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    FORMATS[FORMATS["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
})($099bb7962f016ab8$export$e9c4b7b466aa8274 || ($099bb7962f016ab8$export$e9c4b7b466aa8274 = {}));
/**
 * Various GL target types.
 *
 * @memberof PIXI
 * @static
 * @name TARGETS
 * @enum {number}
 * @property {number} TEXTURE_2D=3553
 * @property {number} TEXTURE_CUBE_MAP=34067
 * @property {number} TEXTURE_2D_ARRAY=35866
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_X=34069
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_X=34070
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Y=34071
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Y=34072
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Z=34073
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Z=34074
 */ var $099bb7962f016ab8$export$d1ff3caf57547dc5;
(function(TARGETS) {
    TARGETS[TARGETS["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    TARGETS[TARGETS["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
})($099bb7962f016ab8$export$d1ff3caf57547dc5 || ($099bb7962f016ab8$export$d1ff3caf57547dc5 = {}));
/**
 * Various GL data format types.
 *
 * @memberof PIXI
 * @static
 * @name TYPES
 * @enum {number}
 * @property {number} UNSIGNED_BYTE=5121
 * @property {number} UNSIGNED_SHORT=5123
 * @property {number} UNSIGNED_SHORT_5_6_5=33635
 * @property {number} UNSIGNED_SHORT_4_4_4_4=32819
 * @property {number} UNSIGNED_SHORT_5_5_5_1=32820
 * @property {number} UNSIGNED_INT=5125
 * @property {number} UNSIGNED_INT_10F_11F_11F_REV=35899
 * @property {number} UNSIGNED_INT_2_10_10_10_REV=33640
 * @property {number} UNSIGNED_INT_24_8=34042
 * @property {number} UNSIGNED_INT_5_9_9_9_REV=35902
 * @property {number} BYTE=5120
 * @property {number} SHORT=5122
 * @property {number} INT=5124
 * @property {number} FLOAT=5126
 * @property {number} FLOAT_32_UNSIGNED_INT_24_8_REV=36269
 * @property {number} HALF_FLOAT=36193
 */ var $099bb7962f016ab8$export$426db7a6155b7a80;
(function(TYPES) {
    TYPES[TYPES["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    TYPES[TYPES["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    TYPES[TYPES["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    TYPES[TYPES["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    TYPES[TYPES["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    TYPES[TYPES["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    TYPES[TYPES["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    TYPES[TYPES["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    TYPES[TYPES["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    TYPES[TYPES["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    TYPES[TYPES["BYTE"] = 5120] = "BYTE";
    TYPES[TYPES["SHORT"] = 5122] = "SHORT";
    TYPES[TYPES["INT"] = 5124] = "INT";
    TYPES[TYPES["FLOAT"] = 5126] = "FLOAT";
    TYPES[TYPES["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    TYPES[TYPES["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
})($099bb7962f016ab8$export$426db7a6155b7a80 || ($099bb7962f016ab8$export$426db7a6155b7a80 = {}));
/**
 * Various sampler types. Correspond to `sampler`, `isampler`, `usampler` GLSL types respectively.
 * WebGL1 works only with FLOAT.
 *
 * @memberof PIXI
 * @static
 * @name SAMPLER_TYPES
 * @enum {number}
 * @property {number} FLOAT=0
 * @property {number} INT=1
 * @property {number} UINT=2
 */ var $099bb7962f016ab8$export$8ee8af3637d728f5;
(function(SAMPLER_TYPES) {
    SAMPLER_TYPES[SAMPLER_TYPES["FLOAT"] = 0] = "FLOAT";
    SAMPLER_TYPES[SAMPLER_TYPES["INT"] = 1] = "INT";
    SAMPLER_TYPES[SAMPLER_TYPES["UINT"] = 2] = "UINT";
})($099bb7962f016ab8$export$8ee8af3637d728f5 || ($099bb7962f016ab8$export$8ee8af3637d728f5 = {}));
/**
 * The scale modes that are supported by pixi.
 *
 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
 *
 * @memberof PIXI
 * @static
 * @name SCALE_MODES
 * @enum {number}
 * @property {number} LINEAR Smooth scaling
 * @property {number} NEAREST Pixelating scaling
 */ var $099bb7962f016ab8$export$6b734c6a0bba8473;
(function(SCALE_MODES) {
    SCALE_MODES[SCALE_MODES["NEAREST"] = 0] = "NEAREST";
    SCALE_MODES[SCALE_MODES["LINEAR"] = 1] = "LINEAR";
})($099bb7962f016ab8$export$6b734c6a0bba8473 || ($099bb7962f016ab8$export$6b734c6a0bba8473 = {}));
/**
 * The wrap modes that are supported by pixi.
 *
 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
 * If the texture is non power of two then clamp will be used regardless as WebGL can
 * only use REPEAT if the texture is po2.
 *
 * This property only affects WebGL.
 *
 * @name WRAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} CLAMP - The textures uvs are clamped
 * @property {number} REPEAT - The texture uvs tile and repeat
 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
 */ var $099bb7962f016ab8$export$2ab395cfb0dd2f0f;
(function(WRAP_MODES) {
    WRAP_MODES[WRAP_MODES["CLAMP"] = 33071] = "CLAMP";
    WRAP_MODES[WRAP_MODES["REPEAT"] = 10497] = "REPEAT";
    WRAP_MODES[WRAP_MODES["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
})($099bb7962f016ab8$export$2ab395cfb0dd2f0f || ($099bb7962f016ab8$export$2ab395cfb0dd2f0f = {}));
/**
 * Mipmap filtering modes that are supported by pixi.
 *
 * The {@link PIXI.settings.MIPMAP_TEXTURES} affects default texture filtering.
 * Mipmaps are generated for a baseTexture if its `mipmap` field is `ON`,
 * or its `POW2` and texture dimensions are powers of 2.
 * Due to platform restriction, `ON` option will work like `POW2` for webgl-1.
 *
 * This property only affects WebGL.
 *
 * @name MIPMAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} OFF - No mipmaps
 * @property {number} POW2 - Generate mipmaps if texture dimensions are pow2
 * @property {number} ON - Always generate mipmaps
 * @property {number} ON_MANUAL - Use mipmaps, but do not auto-generate them; this is used with a resource
 *   that supports buffering each level-of-detail.
 */ var $099bb7962f016ab8$export$16f6fb5da874bbfd;
(function(MIPMAP_MODES) {
    MIPMAP_MODES[MIPMAP_MODES["OFF"] = 0] = "OFF";
    MIPMAP_MODES[MIPMAP_MODES["POW2"] = 1] = "POW2";
    MIPMAP_MODES[MIPMAP_MODES["ON"] = 2] = "ON";
    MIPMAP_MODES[MIPMAP_MODES["ON_MANUAL"] = 3] = "ON_MANUAL";
})($099bb7962f016ab8$export$16f6fb5da874bbfd || ($099bb7962f016ab8$export$16f6fb5da874bbfd = {}));
/**
 * How to treat textures with premultiplied alpha
 *
 * @name ALPHA_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NO_PREMULTIPLIED_ALPHA - Source is not premultiplied, leave it like that.
 *  Option for compressed and data textures that are created from typed arrays.
 * @property {number} PREMULTIPLY_ON_UPLOAD - Source is not premultiplied, premultiply on upload.
 *  Default option, used for all loaded images.
 * @property {number} PREMULTIPLIED_ALPHA - Source is already premultiplied
 *  Example: spine atlases with `_pma` suffix.
 * @property {number} NPM - Alias for NO_PREMULTIPLIED_ALPHA.
 * @property {number} UNPACK - Default option, alias for PREMULTIPLY_ON_UPLOAD.
 * @property {number} PMA - Alias for PREMULTIPLIED_ALPHA.
 */ var $099bb7962f016ab8$export$d56550d454401b73;
(function(ALPHA_MODES) {
    ALPHA_MODES[ALPHA_MODES["NPM"] = 0] = "NPM";
    ALPHA_MODES[ALPHA_MODES["UNPACK"] = 1] = "UNPACK";
    ALPHA_MODES[ALPHA_MODES["PMA"] = 2] = "PMA";
    ALPHA_MODES[ALPHA_MODES["NO_PREMULTIPLIED_ALPHA"] = 0] = "NO_PREMULTIPLIED_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ON_UPLOAD"] = 1] = "PREMULTIPLY_ON_UPLOAD";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ALPHA"] = 2] = "PREMULTIPLY_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLIED_ALPHA"] = 2] = "PREMULTIPLIED_ALPHA";
})($099bb7962f016ab8$export$d56550d454401b73 || ($099bb7962f016ab8$export$d56550d454401b73 = {}));
/**
 * Configure whether filter textures are cleared after binding.
 *
 * Filter textures need not be cleared if the filter does not use pixel blending. {@link CLEAR_MODES.BLIT} will detect
 * this and skip clearing as an optimization.
 *
 * @name CLEAR_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} BLEND - Do not clear the filter texture. The filter's output will blend on top of the output texture.
 * @property {number} CLEAR - Always clear the filter texture.
 * @property {number} BLIT - Clear only if {@link FilterSystem.forceClear} is set or if the filter uses pixel blending.
 * @property {number} NO - Alias for BLEND, same as `false` in earlier versions
 * @property {number} YES - Alias for CLEAR, same as `true` in earlier versions
 * @property {number} AUTO - Alias for BLIT
 */ var $099bb7962f016ab8$export$784901839554cbc3;
(function(CLEAR_MODES) {
    CLEAR_MODES[CLEAR_MODES["NO"] = 0] = "NO";
    CLEAR_MODES[CLEAR_MODES["YES"] = 1] = "YES";
    CLEAR_MODES[CLEAR_MODES["AUTO"] = 2] = "AUTO";
    CLEAR_MODES[CLEAR_MODES["BLEND"] = 0] = "BLEND";
    CLEAR_MODES[CLEAR_MODES["CLEAR"] = 1] = "CLEAR";
    CLEAR_MODES[CLEAR_MODES["BLIT"] = 2] = "BLIT";
})($099bb7962f016ab8$export$784901839554cbc3 || ($099bb7962f016ab8$export$784901839554cbc3 = {}));
/**
 * The gc modes that are supported by pixi.
 *
 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
 * used for a specified period of time they will be removed from the GPU. They will of course
 * be uploaded again when they are required. This is a silent behind the scenes process that
 * should ensure that the GPU does not  get filled up.
 *
 * Handy for mobile devices!
 * This property only affects WebGL.
 *
 * @name GC_MODES
 * @enum {number}
 * @static
 * @memberof PIXI
 * @property {number} AUTO - Garbage collection will happen periodically automatically
 * @property {number} MANUAL - Garbage collection will need to be called manually
 */ var $099bb7962f016ab8$export$5c6ba89c1f52b344;
(function(GC_MODES) {
    GC_MODES[GC_MODES["AUTO"] = 0] = "AUTO";
    GC_MODES[GC_MODES["MANUAL"] = 1] = "MANUAL";
})($099bb7962f016ab8$export$5c6ba89c1f52b344 || ($099bb7962f016ab8$export$5c6ba89c1f52b344 = {}));
/**
 * Constants that specify float precision in shaders.
 *
 * @name PRECISION
 * @memberof PIXI
 * @constant
 * @static
 * @enum {string}
 * @property {string} LOW='lowp'
 * @property {string} MEDIUM='mediump'
 * @property {string} HIGH='highp'
 */ var $099bb7962f016ab8$export$d6d3992f3becc879;
(function(PRECISION) {
    PRECISION["LOW"] = "lowp";
    PRECISION["MEDIUM"] = "mediump";
    PRECISION["HIGH"] = "highp";
})($099bb7962f016ab8$export$d6d3992f3becc879 || ($099bb7962f016ab8$export$d6d3992f3becc879 = {}));
/**
 * Constants for mask implementations.
 * We use `type` suffix because it leads to very different behaviours
 *
 * @name MASK_TYPES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - Mask is ignored
 * @property {number} SCISSOR - Scissor mask, rectangle on screen, cheap
 * @property {number} STENCIL - Stencil mask, 1-bit, medium, works only if renderer supports stencil
 * @property {number} SPRITE - Mask that uses SpriteMaskFilter, uses temporary RenderTexture
 */ var $099bb7962f016ab8$export$dbbea138c5d144;
(function(MASK_TYPES) {
    MASK_TYPES[MASK_TYPES["NONE"] = 0] = "NONE";
    MASK_TYPES[MASK_TYPES["SCISSOR"] = 1] = "SCISSOR";
    MASK_TYPES[MASK_TYPES["STENCIL"] = 2] = "STENCIL";
    MASK_TYPES[MASK_TYPES["SPRITE"] = 3] = "SPRITE";
})($099bb7962f016ab8$export$dbbea138c5d144 || ($099bb7962f016ab8$export$dbbea138c5d144 = {}));
/**
 * Constants for multi-sampling antialiasing.
 *
 * @see PIXI.Framebuffer#multisample
 *
 * @name MSAA_QUALITY
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - No multisampling for this renderTexture
 * @property {number} LOW - Try 2 samples
 * @property {number} MEDIUM - Try 4 samples
 * @property {number} HIGH - Try 8 samples
 */ var $099bb7962f016ab8$export$1eadd657d5acc2f2;
(function(MSAA_QUALITY) {
    MSAA_QUALITY[MSAA_QUALITY["NONE"] = 0] = "NONE";
    MSAA_QUALITY[MSAA_QUALITY["LOW"] = 2] = "LOW";
    MSAA_QUALITY[MSAA_QUALITY["MEDIUM"] = 4] = "MEDIUM";
    MSAA_QUALITY[MSAA_QUALITY["HIGH"] = 8] = "HIGH";
})($099bb7962f016ab8$export$1eadd657d5acc2f2 || ($099bb7962f016ab8$export$1eadd657d5acc2f2 = {}));
/**
 * Constants for various buffer types in Pixi
 *
 * @see PIXI.BUFFER_TYPE
 *
 * @name BUFFER_TYPE
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} ELEMENT_ARRAY_BUFFER - buffer type for using as an index buffer
 * @property {number} ARRAY_BUFFER - buffer type for using attribute data
 * @property {number} UNIFORM_BUFFER - the buffer type is for uniform buffer objects
 */ var $099bb7962f016ab8$export$b595a7e482202b96;
(function(BUFFER_TYPE) {
    BUFFER_TYPE[BUFFER_TYPE["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    BUFFER_TYPE[BUFFER_TYPE["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    // NOT YET SUPPORTED
    BUFFER_TYPE[BUFFER_TYPE["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
})($099bb7962f016ab8$export$b595a7e482202b96 || ($099bb7962f016ab8$export$b595a7e482202b96 = {}));

});


parcelRegister("aZdrZ", function(module, exports) {

$parcel$export(module.exports, "accessibleTarget", function () { return $7ffa08e1ea5f4c07$export$2c6c5fc5694bba8e; });
$parcel$export(module.exports, "AccessibilityManager", function () { return $7ffa08e1ea5f4c07$export$a2c2de1efa8671eb; });
/*!
 * @pixi/accessibility - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/accessibility is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $8t5Gy = parcelRequire("8t5Gy");
parcelRequire("csytw");
var $ezJmd = parcelRequire("ezJmd");
var $csytw = parcelRequire("csytw");
/**
 * Default property values of accessible objects
 * used by {@link PIXI.AccessibilityManager}.
 *
 * @private
 * @function accessibleTarget
 * @memberof PIXI
 * @type {Object}
 * @example
 *      function MyObject() {}
 *
 *      Object.assign(
 *          MyObject.prototype,
 *          PIXI.accessibleTarget
 *      );
 */ var $7ffa08e1ea5f4c07$export$2c6c5fc5694bba8e = {
    /**
     *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
     *   shadow div with attributes set
     *
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     */ accessible: false,
    /**
     * Sets the title attribute of the shadow div
     * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
     *
     * @member {?string}
     * @memberof PIXI.DisplayObject#
     */ accessibleTitle: null,
    /**
     * Sets the aria-label attribute of the shadow div
     *
     * @member {string}
     * @memberof PIXI.DisplayObject#
     */ accessibleHint: null,
    /**
     * @member {number}
     * @memberof PIXI.DisplayObject#
     * @private
     * @todo Needs docs.
     */ tabIndex: 0,
    /**
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     * @todo Needs docs.
     */ _accessibleActive: false,
    /**
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     * @todo Needs docs.
     */ _accessibleDiv: null,
    /**
     * Specify the type of div the accessible layer is. Screen readers treat the element differently
     * depending on this type. Defaults to button.
     *
     * @member {string}
     * @memberof PIXI.DisplayObject#
     * @default 'button'
     */ accessibleType: 'button',
    /**
     * Specify the pointer-events the accessible div will use
     * Defaults to auto.
     *
     * @member {string}
     * @memberof PIXI.DisplayObject#
     * @default 'auto'
     */ accessiblePointerEvents: 'auto',
    /**
     * Setting to false will prevent any children inside this container to
     * be accessible. Defaults to true.
     *
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     * @default true
     */ accessibleChildren: true,
    renderId: -1
};
// add some extra variables to the container..
(0, $8t5Gy.DisplayObject).mixin($7ffa08e1ea5f4c07$export$2c6c5fc5694bba8e);
var $7ffa08e1ea5f4c07$var$KEY_CODE_TAB = 9;
var $7ffa08e1ea5f4c07$var$DIV_TOUCH_SIZE = 100;
var $7ffa08e1ea5f4c07$var$DIV_TOUCH_POS_X = 0;
var $7ffa08e1ea5f4c07$var$DIV_TOUCH_POS_Y = 0;
var $7ffa08e1ea5f4c07$var$DIV_TOUCH_ZINDEX = 2;
var $7ffa08e1ea5f4c07$var$DIV_HOOK_SIZE = 1;
var $7ffa08e1ea5f4c07$var$DIV_HOOK_POS_X = -1000;
var $7ffa08e1ea5f4c07$var$DIV_HOOK_POS_Y = -1000;
var $7ffa08e1ea5f4c07$var$DIV_HOOK_ZINDEX = 2;
/**
 * The Accessibility manager recreates the ability to tab and have content read by screen readers.
 * This is very important as it can possibly help people with disabilities access PixiJS content.
 *
 * A DisplayObject can be made accessible just like it can be made interactive. This manager will map the
 * events as if the mouse was being used, minimizing the effort required to implement.
 *
 * An instance of this class is automatically created by default, and can be found at `renderer.plugins.accessibility`
 *
 * @class
 * @memberof PIXI
 */ var $7ffa08e1ea5f4c07$export$a2c2de1efa8671eb = /** @class */ function() {
    /**
     * @param {PIXI.CanvasRenderer|PIXI.Renderer} renderer - A reference to the current renderer
     */ function AccessibilityManager(renderer) {
        /** Setting this to true will visually show the divs. */ this.debug = false;
        /** Internal variable, see isActive getter. */ this._isActive = false;
        /** Internal variable, see isMobileAccessibility getter. */ this._isMobileAccessibility = false;
        /** A simple pool for storing divs. */ this.pool = [];
        /** This is a tick used to check if an object is no longer being rendered. */ this.renderId = 0;
        /** The array of currently active accessible items. */ this.children = [];
        /** Count to throttle div updates on android devices. */ this.androidUpdateCount = 0;
        /**  The frequency to update the div elements. */ this.androidUpdateFrequency = 500; // 2fps
        this._hookDiv = null;
        if ((0, $ezJmd.isMobile).tablet || (0, $ezJmd.isMobile).phone) this.createTouchHook();
        // first we create a div that will sit over the PixiJS element. This is where the div overlays will go.
        var div = document.createElement('div');
        div.style.width = $7ffa08e1ea5f4c07$var$DIV_TOUCH_SIZE + "px";
        div.style.height = $7ffa08e1ea5f4c07$var$DIV_TOUCH_SIZE + "px";
        div.style.position = 'absolute';
        div.style.top = $7ffa08e1ea5f4c07$var$DIV_TOUCH_POS_X + "px";
        div.style.left = $7ffa08e1ea5f4c07$var$DIV_TOUCH_POS_Y + "px";
        div.style.zIndex = $7ffa08e1ea5f4c07$var$DIV_TOUCH_ZINDEX.toString();
        this.div = div;
        this.renderer = renderer;
        /**
         * pre-bind the functions
         *
         * @type {Function}
         * @private
         */ this._onKeyDown = this._onKeyDown.bind(this);
        /**
         * pre-bind the functions
         *
         * @type {Function}
         * @private
         */ this._onMouseMove = this._onMouseMove.bind(this);
        // let listen for tab.. once pressed we can fire up and show the accessibility layer
        self.addEventListener('keydown', this._onKeyDown, false);
    }
    Object.defineProperty(AccessibilityManager.prototype, "isActive", {
        /**
         * Value of `true` if accessibility is currently active and accessibility layers are showing.
         * @member {boolean}
         * @readonly
         */ get: function() {
            return this._isActive;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccessibilityManager.prototype, "isMobileAccessibility", {
        /**
         * Value of `true` if accessibility is enabled for touch devices.
         * @member {boolean}
         * @readonly
         */ get: function() {
            return this._isMobileAccessibility;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Creates the touch hooks.
     *
     * @private
     */ AccessibilityManager.prototype.createTouchHook = function() {
        var _this = this;
        var hookDiv = document.createElement('button');
        hookDiv.style.width = $7ffa08e1ea5f4c07$var$DIV_HOOK_SIZE + "px";
        hookDiv.style.height = $7ffa08e1ea5f4c07$var$DIV_HOOK_SIZE + "px";
        hookDiv.style.position = 'absolute';
        hookDiv.style.top = $7ffa08e1ea5f4c07$var$DIV_HOOK_POS_X + "px";
        hookDiv.style.left = $7ffa08e1ea5f4c07$var$DIV_HOOK_POS_Y + "px";
        hookDiv.style.zIndex = $7ffa08e1ea5f4c07$var$DIV_HOOK_ZINDEX.toString();
        hookDiv.style.backgroundColor = '#FF0000';
        hookDiv.title = 'select to enable accessibility for this content';
        hookDiv.addEventListener('focus', function() {
            _this._isMobileAccessibility = true;
            _this.activate();
            _this.destroyTouchHook();
        });
        document.body.appendChild(hookDiv);
        this._hookDiv = hookDiv;
    };
    /**
     * Destroys the touch hooks.
     *
     * @private
     */ AccessibilityManager.prototype.destroyTouchHook = function() {
        if (!this._hookDiv) return;
        document.body.removeChild(this._hookDiv);
        this._hookDiv = null;
    };
    /**
     * Activating will cause the Accessibility layer to be shown.
     * This is called when a user presses the tab key.
     *
     * @private
     */ AccessibilityManager.prototype.activate = function() {
        var _a;
        if (this._isActive) return;
        this._isActive = true;
        self.document.addEventListener('mousemove', this._onMouseMove, true);
        self.removeEventListener('keydown', this._onKeyDown, false);
        this.renderer.on('postrender', this.update, this);
        (_a = this.renderer.view.parentNode) === null || _a === void 0 || _a.appendChild(this.div);
    };
    /**
     * Deactivating will cause the Accessibility layer to be hidden.
     * This is called when a user moves the mouse.
     *
     * @private
     */ AccessibilityManager.prototype.deactivate = function() {
        var _a;
        if (!this._isActive || this._isMobileAccessibility) return;
        this._isActive = false;
        self.document.removeEventListener('mousemove', this._onMouseMove, true);
        self.addEventListener('keydown', this._onKeyDown, false);
        this.renderer.off('postrender', this.update);
        (_a = this.div.parentNode) === null || _a === void 0 || _a.removeChild(this.div);
    };
    /**
     * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
     *
     * @private
     * @param {PIXI.Container} displayObject - The DisplayObject to check.
     */ AccessibilityManager.prototype.updateAccessibleObjects = function(displayObject) {
        if (!displayObject.visible || !displayObject.accessibleChildren) return;
        if (displayObject.accessible && displayObject.interactive) {
            if (!displayObject._accessibleActive) this.addChild(displayObject);
            displayObject.renderId = this.renderId;
        }
        var children = displayObject.children;
        if (children) for(var i = 0; i < children.length; i++)this.updateAccessibleObjects(children[i]);
    };
    /**
     * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
     *
     * @private
     */ AccessibilityManager.prototype.update = function() {
        /* On Android default web browser, tab order seems to be calculated by position rather than tabIndex,
        *  moving buttons can cause focus to flicker between two buttons making it hard/impossible to navigate,
        *  so I am just running update every half a second, seems to fix it.
        */ var now = performance.now();
        if ((0, $ezJmd.isMobile).android.device && now < this.androidUpdateCount) return;
        this.androidUpdateCount = now + this.androidUpdateFrequency;
        if (!this.renderer.renderingToScreen) return;
        // update children...
        if (this.renderer._lastObjectRendered) this.updateAccessibleObjects(this.renderer._lastObjectRendered);
        var _a = this.renderer.view.getBoundingClientRect(), left = _a.left, top = _a.top, width = _a.width, height = _a.height;
        var _b = this.renderer, viewWidth = _b.width, viewHeight = _b.height, resolution = _b.resolution;
        var sx = width / viewWidth * resolution;
        var sy = height / viewHeight * resolution;
        var div = this.div;
        div.style.left = left + "px";
        div.style.top = top + "px";
        div.style.width = viewWidth + "px";
        div.style.height = viewHeight + "px";
        for(var i = 0; i < this.children.length; i++){
            var child = this.children[i];
            if (child.renderId !== this.renderId) {
                child._accessibleActive = false;
                (0, $csytw.removeItems)(this.children, i, 1);
                this.div.removeChild(child._accessibleDiv);
                this.pool.push(child._accessibleDiv);
                child._accessibleDiv = null;
                i--;
            } else {
                // map div to display..
                div = child._accessibleDiv;
                var hitArea = child.hitArea;
                var wt = child.worldTransform;
                if (child.hitArea) {
                    div.style.left = (wt.tx + hitArea.x * wt.a) * sx + "px";
                    div.style.top = (wt.ty + hitArea.y * wt.d) * sy + "px";
                    div.style.width = hitArea.width * wt.a * sx + "px";
                    div.style.height = hitArea.height * wt.d * sy + "px";
                } else {
                    hitArea = child.getBounds();
                    this.capHitArea(hitArea);
                    div.style.left = hitArea.x * sx + "px";
                    div.style.top = hitArea.y * sy + "px";
                    div.style.width = hitArea.width * sx + "px";
                    div.style.height = hitArea.height * sy + "px";
                    // update button titles and hints if they exist and they've changed
                    if (div.title !== child.accessibleTitle && child.accessibleTitle !== null) div.title = child.accessibleTitle;
                    if (div.getAttribute('aria-label') !== child.accessibleHint && child.accessibleHint !== null) div.setAttribute('aria-label', child.accessibleHint);
                }
                // the title or index may have changed, if so lets update it!
                if (child.accessibleTitle !== div.title || child.tabIndex !== div.tabIndex) {
                    div.title = child.accessibleTitle;
                    div.tabIndex = child.tabIndex;
                    if (this.debug) this.updateDebugHTML(div);
                }
            }
        }
        // increment the render id..
        this.renderId++;
    };
    /**
     * private function that will visually add the information to the
     * accessability div
     *
     * @param {HTMLElement} div
     */ AccessibilityManager.prototype.updateDebugHTML = function(div) {
        div.innerHTML = "type: " + div.type + "</br> title : " + div.title + "</br> tabIndex: " + div.tabIndex;
    };
    /**
     * Adjust the hit area based on the bounds of a display object
     *
     * @param {PIXI.Rectangle} hitArea - Bounds of the child
     */ AccessibilityManager.prototype.capHitArea = function(hitArea) {
        if (hitArea.x < 0) {
            hitArea.width += hitArea.x;
            hitArea.x = 0;
        }
        if (hitArea.y < 0) {
            hitArea.height += hitArea.y;
            hitArea.y = 0;
        }
        var _a = this.renderer, viewWidth = _a.width, viewHeight = _a.height;
        if (hitArea.x + hitArea.width > viewWidth) hitArea.width = viewWidth - hitArea.x;
        if (hitArea.y + hitArea.height > viewHeight) hitArea.height = viewHeight - hitArea.y;
    };
    /**
     * Adds a DisplayObject to the accessibility manager
     *
     * @private
     * @param {PIXI.DisplayObject} displayObject - The child to make accessible.
     */ AccessibilityManager.prototype.addChild = function(displayObject) {
        //    this.activate();
        var div = this.pool.pop();
        if (!div) {
            div = document.createElement('button');
            div.style.width = $7ffa08e1ea5f4c07$var$DIV_TOUCH_SIZE + "px";
            div.style.height = $7ffa08e1ea5f4c07$var$DIV_TOUCH_SIZE + "px";
            div.style.backgroundColor = this.debug ? 'rgba(255,255,255,0.5)' : 'transparent';
            div.style.position = 'absolute';
            div.style.zIndex = $7ffa08e1ea5f4c07$var$DIV_TOUCH_ZINDEX.toString();
            div.style.borderStyle = 'none';
            // ARIA attributes ensure that button title and hint updates are announced properly
            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) // Chrome doesn't need aria-live to work as intended; in fact it just gets more confused.
            div.setAttribute('aria-live', 'off');
            else div.setAttribute('aria-live', 'polite');
            if (navigator.userAgent.match(/rv:.*Gecko\//)) // FireFox needs this to announce only the new button name
            div.setAttribute('aria-relevant', 'additions');
            else // required by IE, other browsers don't much care
            div.setAttribute('aria-relevant', 'text');
            div.addEventListener('click', this._onClick.bind(this));
            div.addEventListener('focus', this._onFocus.bind(this));
            div.addEventListener('focusout', this._onFocusOut.bind(this));
        }
        // set pointer events
        div.style.pointerEvents = displayObject.accessiblePointerEvents;
        // set the type, this defaults to button!
        div.type = displayObject.accessibleType;
        if (displayObject.accessibleTitle && displayObject.accessibleTitle !== null) div.title = displayObject.accessibleTitle;
        else if (!displayObject.accessibleHint || displayObject.accessibleHint === null) div.title = "displayObject " + displayObject.tabIndex;
        if (displayObject.accessibleHint && displayObject.accessibleHint !== null) div.setAttribute('aria-label', displayObject.accessibleHint);
        if (this.debug) this.updateDebugHTML(div);
        displayObject._accessibleActive = true;
        displayObject._accessibleDiv = div;
        div.displayObject = displayObject;
        this.children.push(displayObject);
        this.div.appendChild(displayObject._accessibleDiv);
        displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
    };
    /**
     * Maps the div button press to pixi's InteractionManager (click)
     *
     * @private
     * @param {MouseEvent} e - The click event.
     */ AccessibilityManager.prototype._onClick = function(e) {
        var interactionManager = this.renderer.plugins.interaction;
        var displayObject = e.target.displayObject;
        var eventData = interactionManager.eventData;
        interactionManager.dispatchEvent(displayObject, 'click', eventData);
        interactionManager.dispatchEvent(displayObject, 'pointertap', eventData);
        interactionManager.dispatchEvent(displayObject, 'tap', eventData);
    };
    /**
     * Maps the div focus events to pixi's InteractionManager (mouseover)
     *
     * @private
     * @param {FocusEvent} e - The focus event.
     */ AccessibilityManager.prototype._onFocus = function(e) {
        if (!e.target.getAttribute('aria-live')) e.target.setAttribute('aria-live', 'assertive');
        var interactionManager = this.renderer.plugins.interaction;
        var displayObject = e.target.displayObject;
        var eventData = interactionManager.eventData;
        interactionManager.dispatchEvent(displayObject, 'mouseover', eventData);
    };
    /**
     * Maps the div focus events to pixi's InteractionManager (mouseout)
     *
     * @private
     * @param {FocusEvent} e - The focusout event.
     */ AccessibilityManager.prototype._onFocusOut = function(e) {
        if (!e.target.getAttribute('aria-live')) e.target.setAttribute('aria-live', 'polite');
        var interactionManager = this.renderer.plugins.interaction;
        var displayObject = e.target.displayObject;
        var eventData = interactionManager.eventData;
        interactionManager.dispatchEvent(displayObject, 'mouseout', eventData);
    };
    /**
     * Is called when a key is pressed
     *
     * @private
     * @param {KeyboardEvent} e - The keydown event.
     */ AccessibilityManager.prototype._onKeyDown = function(e) {
        if (e.keyCode !== $7ffa08e1ea5f4c07$var$KEY_CODE_TAB) return;
        this.activate();
    };
    /**
     * Is called when the mouse moves across the renderer element
     *
     * @private
     * @param {MouseEvent} e - The mouse event.
     */ AccessibilityManager.prototype._onMouseMove = function(e) {
        if (e.movementX === 0 && e.movementY === 0) return;
        this.deactivate();
    };
    /**
     * Destroys the accessibility manager
     *
     */ AccessibilityManager.prototype.destroy = function() {
        this.destroyTouchHook();
        this.div = null;
        self.document.removeEventListener('mousemove', this._onMouseMove, true);
        self.removeEventListener('keydown', this._onKeyDown);
        this.pool = null;
        this.children = null;
        this.renderer = null;
    };
    return AccessibilityManager;
}();

});
parcelRegister("8t5Gy", function(module, exports) {

$parcel$export(module.exports, "Bounds", function () { return $62a57129ee044f79$export$c4e9d269599ab4b4; });
$parcel$export(module.exports, "DisplayObject", function () { return $62a57129ee044f79$export$1f679544f90d7d7c; });
$parcel$export(module.exports, "TemporaryDisplayObject", function () { return $62a57129ee044f79$export$a35515d77cade20d; });
$parcel$export(module.exports, "Container", function () { return $62a57129ee044f79$export$42a852a2b6b56249; });
/*!
 * @pixi/display - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/display is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $ezJmd = parcelRequire("ezJmd");

var $6qzqq = parcelRequire("6qzqq");
parcelRequire("csytw");
var $6p5EE = parcelRequire("6p5EE");
var $csytw = parcelRequire("csytw");
/**
 * Sets the default value for the container property 'sortableChildren'.
 * If set to true, the container will sort its children by zIndex value
 * when updateTransform() is called, or manually if sortChildren() is called.
 *
 * This actually changes the order of elements in the array, so should be treated
 * as a basic solution that is not performant compared to other solutions,
 * such as @link https://github.com/pixijs/pixi-display
 *
 * Also be aware of that this may not work nicely with the addChildAt() function,
 * as the zIndex sorting may cause the child to automatically sorted to another position.
 *
 * @static
 * @constant
 * @name SORTABLE_CHILDREN
 * @memberof PIXI.settings
 * @type {boolean}
 * @default false
 */ (0, $ezJmd.settings).SORTABLE_CHILDREN = false;
/**
 * 'Builder' pattern for bounds rectangles.
 *
 * This could be called an Axis-Aligned Bounding Box.
 * It is not an actual shape. It is a mutable thing; no 'EMPTY' or those kind of problems.
 *
 * @class
 * @memberof PIXI
 */ var $62a57129ee044f79$export$c4e9d269599ab4b4 = /** @class */ function() {
    function Bounds() {
        /**
         * @member {number}
         * @default 0
         */ this.minX = Infinity;
        /**
         * @member {number}
         * @default 0
         */ this.minY = Infinity;
        /**
         * @member {number}
         * @default 0
         */ this.maxX = -Infinity;
        /**
         * @member {number}
         * @default 0
         */ this.maxY = -Infinity;
        this.rect = null;
        /**
         * It is updated to _boundsID of corresponding object to keep bounds in sync with content.
         * Updated from outside, thus public modifier.
         *
         * @member {number}
         * @public
         */ this.updateID = -1;
    }
    /**
     * Checks if bounds are empty.
     *
     * @return {boolean} True if empty.
     */ Bounds.prototype.isEmpty = function() {
        return this.minX > this.maxX || this.minY > this.maxY;
    };
    /**
     * Clears the bounds and resets.
     *
     */ Bounds.prototype.clear = function() {
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
    };
    /**
     * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
     * It is not guaranteed that it will return tempRect
     *
     * @param {PIXI.Rectangle} rect - temporary object will be used if AABB is not empty
     * @returns {PIXI.Rectangle} A rectangle of the bounds
     */ Bounds.prototype.getRectangle = function(rect) {
        if (this.minX > this.maxX || this.minY > this.maxY) return (0, $6qzqq.Rectangle).EMPTY;
        rect = rect || new (0, $6qzqq.Rectangle)(0, 0, 1, 1);
        rect.x = this.minX;
        rect.y = this.minY;
        rect.width = this.maxX - this.minX;
        rect.height = this.maxY - this.minY;
        return rect;
    };
    /**
     * This function should be inlined when its possible.
     *
     * @param {PIXI.IPointData} point - The point to add.
     */ Bounds.prototype.addPoint = function(point) {
        this.minX = Math.min(this.minX, point.x);
        this.maxX = Math.max(this.maxX, point.x);
        this.minY = Math.min(this.minY, point.y);
        this.maxY = Math.max(this.maxY, point.y);
    };
    /**
     * Adds a point, after transformed. This should be inlined when its possible.
     *
     * @param matrix
     * @param point
     */ Bounds.prototype.addPointMatrix = function(matrix, point) {
        var a = matrix.a, b = matrix.b, c = matrix.c, d = matrix.d, tx = matrix.tx, ty = matrix.ty;
        var x = a * point.x + c * point.y + tx;
        var y = b * point.x + d * point.y + ty;
        this.minX = Math.min(this.minX, x);
        this.maxX = Math.max(this.maxX, x);
        this.minY = Math.min(this.minY, y);
        this.maxY = Math.max(this.maxY, y);
    };
    /**
     * Adds a quad, not transformed
     *
     * @param {Float32Array} vertices - The verts to add.
     */ Bounds.prototype.addQuad = function(vertices) {
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;
        var x = vertices[0];
        var y = vertices[1];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = vertices[2];
        y = vertices[3];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = vertices[4];
        y = vertices[5];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = vertices[6];
        y = vertices[7];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };
    /**
     * Adds sprite frame, transformed.
     *
     * @param {PIXI.Transform} transform - transform to apply
     * @param {number} x0 - left X of frame
     * @param {number} y0 - top Y of frame
     * @param {number} x1 - right X of frame
     * @param {number} y1 - bottom Y of frame
     */ Bounds.prototype.addFrame = function(transform, x0, y0, x1, y1) {
        this.addFrameMatrix(transform.worldTransform, x0, y0, x1, y1);
    };
    /**
     * Adds sprite frame, multiplied by matrix
     *
     * @param {PIXI.Matrix} matrix - matrix to apply
     * @param {number} x0 - left X of frame
     * @param {number} y0 - top Y of frame
     * @param {number} x1 - right X of frame
     * @param {number} y1 - bottom Y of frame
     */ Bounds.prototype.addFrameMatrix = function(matrix, x0, y0, x1, y1) {
        var a = matrix.a;
        var b = matrix.b;
        var c = matrix.c;
        var d = matrix.d;
        var tx = matrix.tx;
        var ty = matrix.ty;
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;
        var x = a * x0 + c * y0 + tx;
        var y = b * x0 + d * y0 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = a * x1 + c * y0 + tx;
        y = b * x1 + d * y0 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = a * x0 + c * y1 + tx;
        y = b * x0 + d * y1 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        x = a * x1 + c * y1 + tx;
        y = b * x1 + d * y1 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };
    /**
     * Adds screen vertices from array
     *
     * @param {Float32Array} vertexData - calculated vertices
     * @param {number} beginOffset - begin offset
     * @param {number} endOffset - end offset, excluded
     */ Bounds.prototype.addVertexData = function(vertexData, beginOffset, endOffset) {
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;
        for(var i = beginOffset; i < endOffset; i += 2){
            var x = vertexData[i];
            var y = vertexData[i + 1];
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };
    /**
     * Add an array of mesh vertices
     *
     * @param {PIXI.Transform} transform - mesh transform
     * @param {Float32Array} vertices - mesh coordinates in array
     * @param {number} beginOffset - begin offset
     * @param {number} endOffset - end offset, excluded
     */ Bounds.prototype.addVertices = function(transform, vertices, beginOffset, endOffset) {
        this.addVerticesMatrix(transform.worldTransform, vertices, beginOffset, endOffset);
    };
    /**
     * Add an array of mesh vertices.
     *
     * @param {PIXI.Matrix} matrix - mesh matrix
     * @param {Float32Array} vertices - mesh coordinates in array
     * @param {number} beginOffset - begin offset
     * @param {number} endOffset - end offset, excluded
     * @param {number} [padX=0] - x padding
     * @param {number} [padY=0] - y padding
     */ Bounds.prototype.addVerticesMatrix = function(matrix, vertices, beginOffset, endOffset, padX, padY) {
        if (padX === void 0) padX = 0;
        if (padY === void 0) padY = padX;
        var a = matrix.a;
        var b = matrix.b;
        var c = matrix.c;
        var d = matrix.d;
        var tx = matrix.tx;
        var ty = matrix.ty;
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;
        for(var i = beginOffset; i < endOffset; i += 2){
            var rawX = vertices[i];
            var rawY = vertices[i + 1];
            var x = a * rawX + c * rawY + tx;
            var y = d * rawY + b * rawX + ty;
            minX = Math.min(minX, x - padX);
            maxX = Math.max(maxX, x + padX);
            minY = Math.min(minY, y - padY);
            maxY = Math.max(maxY, y + padY);
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };
    /**
     * Adds other Bounds.
     *
     * @param {PIXI.Bounds} bounds - The Bounds to be added
     */ Bounds.prototype.addBounds = function(bounds) {
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;
        this.minX = bounds.minX < minX ? bounds.minX : minX;
        this.minY = bounds.minY < minY ? bounds.minY : minY;
        this.maxX = bounds.maxX > maxX ? bounds.maxX : maxX;
        this.maxY = bounds.maxY > maxY ? bounds.maxY : maxY;
    };
    /**
     * Adds other Bounds, masked with Bounds.
     *
     * @param {PIXI.Bounds} bounds - The Bounds to be added.
     * @param {PIXI.Bounds} mask - TODO
     */ Bounds.prototype.addBoundsMask = function(bounds, mask) {
        var _minX = bounds.minX > mask.minX ? bounds.minX : mask.minX;
        var _minY = bounds.minY > mask.minY ? bounds.minY : mask.minY;
        var _maxX = bounds.maxX < mask.maxX ? bounds.maxX : mask.maxX;
        var _maxY = bounds.maxY < mask.maxY ? bounds.maxY : mask.maxY;
        if (_minX <= _maxX && _minY <= _maxY) {
            var minX = this.minX;
            var minY = this.minY;
            var maxX = this.maxX;
            var maxY = this.maxY;
            this.minX = _minX < minX ? _minX : minX;
            this.minY = _minY < minY ? _minY : minY;
            this.maxX = _maxX > maxX ? _maxX : maxX;
            this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    };
    /**
     * Adds other Bounds, multiplied by matrix. Bounds shouldn't be empty.
     *
     * @param {PIXI.Bounds} bounds - other bounds
     * @param {PIXI.Matrix} matrix - multiplicator
     */ Bounds.prototype.addBoundsMatrix = function(bounds, matrix) {
        this.addFrameMatrix(matrix, bounds.minX, bounds.minY, bounds.maxX, bounds.maxY);
    };
    /**
     * Adds other Bounds, masked with Rectangle.
     *
     * @param {PIXI.Bounds} bounds - TODO
     * @param {PIXI.Rectangle} area - TODO
     */ Bounds.prototype.addBoundsArea = function(bounds, area) {
        var _minX = bounds.minX > area.x ? bounds.minX : area.x;
        var _minY = bounds.minY > area.y ? bounds.minY : area.y;
        var _maxX = bounds.maxX < area.x + area.width ? bounds.maxX : area.x + area.width;
        var _maxY = bounds.maxY < area.y + area.height ? bounds.maxY : area.y + area.height;
        if (_minX <= _maxX && _minY <= _maxY) {
            var minX = this.minX;
            var minY = this.minY;
            var maxX = this.maxX;
            var maxY = this.maxY;
            this.minX = _minX < minX ? _minX : minX;
            this.minY = _minY < minY ? _minY : minY;
            this.maxX = _maxX > maxX ? _maxX : maxX;
            this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    };
    /**
     * Pads bounds object, making it grow in all directions.
     * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
     *
     * @param {number} [paddingX=0] - The horizontal padding amount.
     * @param {number} [paddingY=0] - The vertical padding amount.
     */ Bounds.prototype.pad = function(paddingX, paddingY) {
        if (paddingX === void 0) paddingX = 0;
        if (paddingY === void 0) paddingY = paddingX;
        if (!this.isEmpty()) {
            this.minX -= paddingX;
            this.maxX += paddingX;
            this.minY -= paddingY;
            this.maxY += paddingY;
        }
    };
    /**
     * Adds padded frame. (x0, y0) should be strictly less than (x1, y1)
     *
     * @param {number} x0 - left X of frame
     * @param {number} y0 - top Y of frame
     * @param {number} x1 - right X of frame
     * @param {number} y1 - bottom Y of frame
     * @param {number} padX - padding X
     * @param {number} padY - padding Y
     */ Bounds.prototype.addFramePad = function(x0, y0, x1, y1, padX, padY) {
        x0 -= padX;
        y0 -= padY;
        x1 += padX;
        y1 += padY;
        this.minX = this.minX < x0 ? this.minX : x0;
        this.maxX = this.maxX > x1 ? this.maxX : x1;
        this.minY = this.minY < y0 ? this.minY : y0;
        this.maxY = this.maxY > y1 ? this.maxY : y1;
    };
    return Bounds;
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $62a57129ee044f79$var$extendStatics = function(d, b) {
    $62a57129ee044f79$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $62a57129ee044f79$var$extendStatics(d, b);
};
function $62a57129ee044f79$var$__extends(d, b) {
    $62a57129ee044f79$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * The base class for all objects that are rendered on the screen.
 *
 * This is an abstract class and can not be used on its own; rather it should be extended.
 *
 * ## Display objects implemented in PixiJS
 *
 * | Display Object                  | Description                                                           |
 * | ------------------------------- | --------------------------------------------------------------------- |
 * | {@link PIXI.Container}          | Adds support for `children` to DisplayObject                          |
 * | {@link PIXI.Graphics}           | Shape-drawing display object similar to the Canvas API                |
 * | {@link PIXI.Sprite}             | Draws textures (i.e. images)                                          |
 * | {@link PIXI.Text}               | Draws text using the Canvas API internally                            |
 * | {@link PIXI.BitmapText}         | More scaleable solution for text rendering, reusing glyph textures    |
 * | {@link PIXI.TilingSprite}       | Draws textures/images in a tiled fashion                              |
 * | {@link PIXI.AnimatedSprite}     | Draws an animation of multiple images                                 |
 * | {@link PIXI.Mesh}               | Provides a lower-level API for drawing meshes with custom data        |
 * | {@link PIXI.NineSlicePlane}     | Mesh-related                                                          |
 * | {@link PIXI.SimpleMesh}         | v4-compatible mesh                                                    |
 * | {@link PIXI.SimplePlane}        | Mesh-related                                                          |
 * | {@link PIXI.SimpleRope}         | Mesh-related                                                          |
 *
 * ## Transforms
 *
 * The [transform]{@link DisplayObject#transform} of a display object describes the projection from its
 * local coordinate space to its parent's local coordinate space. The following properties are derived
 * from the transform:
 *
 * <table>
 *   <thead>
 *     <tr>
 *       <th>Property</th>
 *       <th>Description</th>
 *     </tr>
 *   </thead>
 *   <tbody>
 *     <tr>
 *       <td>[pivot]{@link PIXI.DisplayObject#pivot}</td>
 *       <td>
 *         Invariant under rotation, scaling, and skewing. The projection of into the parent's space of the pivot
 *         is equal to position, regardless of the other three transformations. In other words, It is the center of
 *         rotation, scaling, and skewing.
 *       </td>
 *     </tr>
 *     <tr>
 *       <td>[position]{@link PIXI.DisplayObject#position}</td>
 *       <td>
 *         Translation. This is the position of the [pivot]{@link PIXI.DisplayObject#pivot} in the parent's local
 *         space. The default value of the pivot is the origin (0,0). If the top-left corner of your display object
 *         is (0,0) in its local space, then the position will be its top-left corner in the parent's local space.
 *       </td>
 *     </tr>
 *     <tr>
 *       <td>[scale]{@link PIXI.DisplayObject#scale}</td>
 *       <td>
 *         Scaling. This will stretch (or compress) the display object's projection. The scale factors are along the
 *         local coordinate axes. In other words, the display object is scaled before rotated or skewed. The center
 *         of scaling is the [pivot]{@link PIXI.DisplayObject#pivot}.
 *       </td>
 *     </tr>
 *     <tr>
 *       <td>[rotation]{@link PIXI.DisplayObject#rotation}</td>
 *       <td>
 *          Rotation. This will rotate the display object's projection by this angle (in radians).
 *       </td>
 *     </tr>
 *     <tr>
 *       <td>[skew]{@link PIXI.DisplayObject#skew}</td>
 *       <td>
 *         <p>Skewing. This can be used to deform a rectangular display object into a parallelogram.</p>
 *         <p>
 *         In PixiJS, skew has a slightly different behaviour than the conventional meaning. It can be
 *         thought of the net rotation applied to the coordinate axes (separately). For example, if "skew.x" is
 *         ⍺ and "skew.y" is β, then the line x = 0 will be rotated by ⍺ (y = -x*cot⍺) and the line y = 0 will be
 *         rotated by β (y = x*tanβ). A line y = x*tanϴ (i.e. a line at angle ϴ to the x-axis in local-space) will
 *         be rotated by an angle between ⍺ and β.
 *         </p>
 *         <p>
 *         It can be observed that if skew is applied equally to both axes, then it will be equivalent to applying
 *         a rotation. Indeed, if "skew.x" = -ϴ and "skew.y" = ϴ, it will produce an equivalent of "rotation" = ϴ.
 *         </p>
 *         <p>
 *         Another quite interesting observation is that "skew.x", "skew.y", rotation are communtative operations. Indeed,
 *         because rotation is essentially a careful combination of the two.
 *         </p>
 *       </td>
 *     </tr>
 *     <tr>
 *       <td>angle</td>
 *       <td>Rotation. This is an alias for [rotation]{@link PIXI.DisplayObject#rotation}, but in degrees.</td>
 *     </tr>
 *     <tr>
 *       <td>x</td>
 *       <td>Translation. This is an alias for position.x!</td>
 *     </tr>
 *     <tr>
 *       <td>y</td>
 *       <td>Translation. This is an alias for position.y!</td>
 *     </tr>
 *     <tr>
 *       <td>width</td>
 *       <td>
 *         Implemented in [Container]{@link PIXI.Container}. Scaling. The width property calculates scale.x by dividing
 *         the "requested" width by the local bounding box width. It is indirectly an abstraction over scale.x, and there
 *         is no concept of user-defined width.
 *       </td>
 *     </tr>
 *     <tr>
 *       <td>height</td>
 *       <td>
 *         Implemented in [Container]{@link PIXI.Container}. Scaling. The height property calculates scale.y by dividing
 *         the "requested" height by the local bounding box height. It is indirectly an abstraction over scale.y, and there
 *         is no concept of user-defined height.
 *       </td>
 *     </tr>
 *   </tbody>
 * </table>
 *
 * ## Bounds
 *
 * The bounds of a display object is defined by the minimum axis-aligned rectangle in world space that can fit
 * around it. The abstract `calculateBounds` method is responsible for providing it (and it should use the
 * `worldTransform` to calculate in world space).
 *
 * There are a few additional types of bounding boxes:
 *
 * | Bounds                | Description                                                                              |
 * | --------------------- | ---------------------------------------------------------------------------------------- |
 * | World Bounds          | This is synonymous is the regular bounds described above. See `getBounds()`.             |
 * | Local Bounds          | This the axis-aligned bounding box in the parent's local space. See `getLocalBounds()`.  |
 * | Render Bounds         | The bounds, but including extra rendering effects like filter padding.                   |
 * | Projected Bounds      | The bounds of the projected display object onto the screen. Usually equals world bounds. |
 * | Relative Bounds       | The bounds of a display object when projected onto a ancestor's (or parent's) space.     |
 * | Natural Bounds        | The bounds of an object in its own local space (not parent's space, like in local bounds)|
 * | Content Bounds        | The natural bounds when excluding all children of a `Container`.                         |
 *
 * ### calculateBounds
 *
 * [Container]{@link Container} already implements `calculateBounds` in a manner that includes children.
 *
 * But for a non-Container display object, the `calculateBounds` method must be overridden in order for `getBounds` and
 * `getLocalBounds` to work. This method must write the bounds into `this._bounds`.
 *
 * Generally, the following technique works for most simple cases: take the list of points
 * forming the "hull" of the object (i.e. outline of the object's shape), and then add them
 * using {@link PIXI.Bounds#addPointMatrix}.
 *
 * ```js
 * calculateBounds(): void
 * {
 *     const points = [...];
 *
 *     for (let i = 0, j = points.length; i < j; i++)
 *     {
 *         this._bounds.addPointMatrix(this.worldTransform, points[i]);
 *     }
 * }
 * ```
 *
 * You can optimize this for a large number of points by using {@link PIXI.Bounds#addVerticesMatrix} to pass them
 * in one array together.
 *
 * ## Alpha
 *
 * This alpha sets a display object's **relative opacity** w.r.t its parent. For example, if the alpha of a display
 * object is 0.5 and its parent's alpha is 0.5, then it will be rendered with 25% opacity (assuming alpha is not
 * applied on any ancestor further up the chain).
 *
 * The alpha with which the display object will be rendered is called the [worldAlpha]{@link PIXI.DisplayObject#worldAlpha}.
 *
 * ## Renderable vs Visible
 *
 * The `renderable` and `visible` properties can be used to prevent a display object from being rendered to the
 * screen. However, there is a subtle difference between the two. When using `renderable`, the transforms  of the display
 * object (and its children subtree) will continue to be calculated. When using `visible`, the transforms will not
 * be calculated.
 *
 * It is recommended that applications use the `renderable` property for culling. See
 * [@pixi-essentials/cull]{@link https://www.npmjs.com/package/@pixi-essentials/cull} or
 * [pixi-cull]{@link https://www.npmjs.com/package/pixi-cull} for more details.
 *
 * Otherwise, to prevent an object from rendering in the general-purpose sense - `visible` is the property to use. This
 * one is also better in terms of performance.
 *
 * @class
 * @extends PIXI.utils.EventEmitter
 * @memberof PIXI
 */ var $62a57129ee044f79$export$1f679544f90d7d7c = /** @class */ function(_super) {
    $62a57129ee044f79$var$__extends(DisplayObject, _super);
    function DisplayObject() {
        var _this = _super.call(this) || this;
        _this.tempDisplayObjectParent = null;
        // TODO: need to create Transform from factory
        /**
         * World transform and local transform of this object.
         * This will become read-only later, please do not assign anything there unless you know what are you doing.
         *
         * @member {PIXI.Transform}
         */ _this.transform = new (0, $6qzqq.Transform)();
        /**
         * The opacity of the object.
         *
         * @member {number}
         */ _this.alpha = 1;
        /**
         * The visibility of the object. If false the object will not be drawn, and
         * the updateTransform function will not be called.
         *
         * Only affects recursive calls from parent. You can ask for bounds or call updateTransform manually.
         *
         * @member {boolean}
         */ _this.visible = true;
        /**
         * Can this object be rendered, if false the object will not be drawn but the updateTransform
         * methods will still be called.
         *
         * Only affects recursive calls from parent. You can ask for bounds manually.
         *
         * @member {boolean}
         */ _this.renderable = true;
        /**
         * The display object container that contains this display object.
         *
         * @member {PIXI.Container}
         */ _this.parent = null;
        /**
         * The multiplied alpha of the displayObject.
         *
         * @member {number}
         * @readonly
         */ _this.worldAlpha = 1;
        /**
         * Which index in the children array the display component was before the previous zIndex sort.
         * Used by containers to help sort objects with the same zIndex, by using previous array index as the decider.
         *
         * @member {number}
         * @protected
         */ _this._lastSortedIndex = 0;
        /**
         * The zIndex of the displayObject.
         * A higher value will mean it will be rendered on top of other displayObjects within the same container.
         *
         * @member {number}
         * @protected
         */ _this._zIndex = 0;
        /**
         * The area the filter is applied to. This is used as more of an optimization
         * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle.
         *
         * Also works as an interaction mask.
         *
         * @member {?PIXI.Rectangle}
         */ _this.filterArea = null;
        /**
         * Sets the filters for the displayObject.
         * * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
         * To remove filters simply set this property to `'null'`.
         *
         * @member {?PIXI.Filter[]}
         */ _this.filters = null;
        /**
         * Currently enabled filters
         * @member {PIXI.Filter[]}
         * @protected
         */ _this._enabledFilters = null;
        /**
         * The bounds object, this is used to calculate and store the bounds of the displayObject.
         *
         * @member {PIXI.Bounds}
         */ _this._bounds = new $62a57129ee044f79$export$c4e9d269599ab4b4();
        /**
         * Local bounds object, swapped with `_bounds` when using `getLocalBounds()`.
         *
         * @member {PIXI.Bounds}
         */ _this._localBounds = null;
        /**
         * Flags the cached bounds as dirty.
         *
         * @member {number}
         * @protected
         */ _this._boundsID = 0;
        /**
         * Cache of this display-object's bounds-rectangle.
         *
         * @member {PIXI.Bounds}
         * @protected
         */ _this._boundsRect = null;
        /**
         * Cache of this display-object's local-bounds rectangle.
         *
         * @member {PIXI.Bounds}
         * @protected
         */ _this._localBoundsRect = null;
        /**
         * The original, cached mask of the object.
         *
         * @member {PIXI.Container|PIXI.MaskData|null}
         * @protected
         */ _this._mask = null;
        /**
         * The number of times this object is used as a mask by another object.
         *
         * @member {number}
         * @private
         */ _this._maskRefCount = 0;
        /**
         * If the object has been destroyed via destroy(). If true, it should not be used.
         *
         * @member {boolean}
         * @protected
         */ _this._destroyed = false;
        /**
         * used to fast check if a sprite is.. a sprite!
         * @member {boolean}
         */ _this.isSprite = false;
        /**
         * Does any other displayObject use this object as a mask?
         * @member {boolean}
         */ _this.isMask = false;
        return _this;
    }
    /**
     * Mixes all enumerable properties and methods from a source object to DisplayObject.
     *
     * @param {object} source - The source of properties and methods to mix in.
     */ DisplayObject.mixin = function(source) {
        // in ES8/ES2017, this would be really easy:
        // Object.defineProperties(DisplayObject.prototype, Object.getOwnPropertyDescriptors(source));
        // get all the enumerable property keys
        var keys = Object.keys(source);
        // loop through properties
        for(var i = 0; i < keys.length; ++i){
            var propertyName = keys[i];
            // Set the property using the property descriptor - this works for accessors and normal value properties
            Object.defineProperty(DisplayObject.prototype, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
        }
    };
    Object.defineProperty(DisplayObject.prototype, "destroyed", {
        /**
         * Fired when this DisplayObject is added to a Container.
         *
         * @instance
         * @event added
         * @param {PIXI.Container} container - The container added to.
         */ /**
         * Fired when this DisplayObject is removed from a Container.
         *
         * @instance
         * @event removed
         * @param {PIXI.Container} container - The container removed from.
         */ /**
         * Fired when this DisplayObject is destroyed.
         *
         * @instance
         * @event destroyed
         */ /**
         * Readonly flag for destroyed display objects.
         */ get: function() {
            return this._destroyed;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Recursively updates transform of all objects from the root to this one
     * internal function for toLocal()
     */ DisplayObject.prototype._recursivePostUpdateTransform = function() {
        if (this.parent) {
            this.parent._recursivePostUpdateTransform();
            this.transform.updateTransform(this.parent.transform);
        } else this.transform.updateTransform(this._tempDisplayObjectParent.transform);
    };
    /**
     * Updates the object transform for rendering.
     *
     * TODO - Optimization pass!
     */ DisplayObject.prototype.updateTransform = function() {
        this._boundsID++;
        this.transform.updateTransform(this.parent.transform);
        // multiply the alphas..
        this.worldAlpha = this.alpha * this.parent.worldAlpha;
    };
    /**
     * Calculates and returns the (world) bounds of the display object as a [Rectangle]{@link PIXI.Rectangle}.
     *
     * This method is expensive on containers with a large subtree (like the stage). This is because the bounds
     * of a container depend on its children's bounds, which recursively causes all bounds in the subtree to
     * be recalculated. The upside, however, is that calling `getBounds` once on a container will indeed update
     * the bounds of all children (the whole subtree, in fact). This side effect should be exploited by using
     * `displayObject._bounds.getRectangle()` when traversing through all the bounds in a scene graph. Otherwise,
     * calling `getBounds` on each object in a subtree will cause the total cost to increase quadratically as
     * its height increases.
     *
     * * The transforms of all objects in a container's **subtree** and of all **ancestors** are updated.
     * * The world bounds of all display objects in a container's **subtree** will also be recalculated.
     *
     * The `_bounds` object stores the last calculation of the bounds. You can use to entirely skip bounds
     * calculation if needed.
     *
     * ```js
     * const lastCalculatedBounds = displayObject._bounds.getRectangle(optionalRect);
     * ```
     *
     * Do know that usage of `getLocalBounds` can corrupt the `_bounds` of children (the whole subtree, actually). This
     * is a known issue that has not been solved. See [getLocalBounds]{@link PIXI.DisplayObject#getLocalBounds} for more
     * details.
     *
     * `getBounds` should be called with `skipUpdate` equal to `true` in a render() call. This is because the transforms
     * are guaranteed to be update-to-date. In fact, recalculating inside a render() call may cause corruption in certain
     * cases.
     *
     * @param {boolean} [skipUpdate] - Setting to `true` will stop the transforms of the scene graph from
     *  being updated. This means the calculation returned MAY be out of date BUT will give you a
     *  nice performance boost.
     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation.
     * @return {PIXI.Rectangle} The minimum axis-aligned rectangle in world space that fits around this object.
     */ DisplayObject.prototype.getBounds = function(skipUpdate, rect) {
        if (!skipUpdate) {
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.updateTransform();
                this.parent = null;
            } else {
                this._recursivePostUpdateTransform();
                this.updateTransform();
            }
        }
        if (this._bounds.updateID !== this._boundsID) {
            this.calculateBounds();
            this._bounds.updateID = this._boundsID;
        }
        if (!rect) {
            if (!this._boundsRect) this._boundsRect = new (0, $6qzqq.Rectangle)();
            rect = this._boundsRect;
        }
        return this._bounds.getRectangle(rect);
    };
    /**
     * Retrieves the local bounds of the displayObject as a rectangle object.
     *
     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation.
     * @return {PIXI.Rectangle} The rectangular bounding area.
     */ DisplayObject.prototype.getLocalBounds = function(rect) {
        if (!rect) {
            if (!this._localBoundsRect) this._localBoundsRect = new (0, $6qzqq.Rectangle)();
            rect = this._localBoundsRect;
        }
        if (!this._localBounds) this._localBounds = new $62a57129ee044f79$export$c4e9d269599ab4b4();
        var transformRef = this.transform;
        var parentRef = this.parent;
        this.parent = null;
        this.transform = this._tempDisplayObjectParent.transform;
        var worldBounds = this._bounds;
        var worldBoundsID = this._boundsID;
        this._bounds = this._localBounds;
        var bounds = this.getBounds(false, rect);
        this.parent = parentRef;
        this.transform = transformRef;
        this._bounds = worldBounds;
        this._bounds.updateID += this._boundsID - worldBoundsID; // reflect side-effects
        return bounds;
    };
    /**
     * Calculates the global position of the display object.
     *
     * @param {PIXI.IPointData} position - The world origin to calculate from.
     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
     *  (otherwise will create a new Point).
     * @param {boolean} [skipUpdate=false] - Should we skip the update transform.
     * @return {PIXI.Point} A point object representing the position of this object.
     */ DisplayObject.prototype.toGlobal = function(position, point, skipUpdate) {
        if (skipUpdate === void 0) skipUpdate = false;
        if (!skipUpdate) {
            this._recursivePostUpdateTransform();
            // this parent check is for just in case the item is a root object.
            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.displayObjectUpdateTransform();
                this.parent = null;
            } else this.displayObjectUpdateTransform();
        }
        // don't need to update the lot
        return this.worldTransform.apply(position, point);
    };
    /**
     * Calculates the local position of the display object relative to another point.
     *
     * @param {PIXI.IPointData} position - The world origin to calculate from.
     * @param {PIXI.DisplayObject} [from] - The DisplayObject to calculate the global position from.
     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
     *  (otherwise will create a new Point).
     * @param {boolean} [skipUpdate=false] - Should we skip the update transform
     * @return {PIXI.Point} A point object representing the position of this object
     */ DisplayObject.prototype.toLocal = function(position, from, point, skipUpdate) {
        if (from) position = from.toGlobal(position, point, skipUpdate);
        if (!skipUpdate) {
            this._recursivePostUpdateTransform();
            // this parent check is for just in case the item is a root object.
            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.displayObjectUpdateTransform();
                this.parent = null;
            } else this.displayObjectUpdateTransform();
        }
        // simply apply the matrix..
        return this.worldTransform.applyInverse(position, point);
    };
    /**
     * Set the parent Container of this DisplayObject.
     *
     * @param {PIXI.Container} container - The Container to add this DisplayObject to.
     * @return {PIXI.Container} The Container that this DisplayObject was added to.
     */ DisplayObject.prototype.setParent = function(container) {
        if (!container || !container.addChild) throw new Error('setParent: Argument must be a Container');
        container.addChild(this);
        return container;
    };
    /**
     * Convenience function to set the position, scale, skew and pivot at once.
     *
     * @param {number} [x=0] - The X position
     * @param {number} [y=0] - The Y position
     * @param {number} [scaleX=1] - The X scale value
     * @param {number} [scaleY=1] - The Y scale value
     * @param {number} [rotation=0] - The rotation
     * @param {number} [skewX=0] - The X skew value
     * @param {number} [skewY=0] - The Y skew value
     * @param {number} [pivotX=0] - The X pivot value
     * @param {number} [pivotY=0] - The Y pivot value
     * @return {PIXI.DisplayObject} The DisplayObject instance
     */ DisplayObject.prototype.setTransform = function(x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (scaleX === void 0) scaleX = 1;
        if (scaleY === void 0) scaleY = 1;
        if (rotation === void 0) rotation = 0;
        if (skewX === void 0) skewX = 0;
        if (skewY === void 0) skewY = 0;
        if (pivotX === void 0) pivotX = 0;
        if (pivotY === void 0) pivotY = 0;
        this.position.x = x;
        this.position.y = y;
        this.scale.x = !scaleX ? 1 : scaleX;
        this.scale.y = !scaleY ? 1 : scaleY;
        this.rotation = rotation;
        this.skew.x = skewX;
        this.skew.y = skewY;
        this.pivot.x = pivotX;
        this.pivot.y = pivotY;
        return this;
    };
    /**
     * Base destroy method for generic display objects. This will automatically
     * remove the display object from its parent Container as well as remove
     * all current event listeners and internal references. Do not use a DisplayObject
     * after calling `destroy()`.
     *
     */ DisplayObject.prototype.destroy = function(_options) {
        if (this.parent) this.parent.removeChild(this);
        this.emit('destroyed');
        this.removeAllListeners();
        this.transform = null;
        this.parent = null;
        this._bounds = null;
        this.mask = null;
        this.filters = null;
        this.filterArea = null;
        this.hitArea = null;
        this.interactive = false;
        this.interactiveChildren = false;
        this._destroyed = true;
    };
    Object.defineProperty(DisplayObject.prototype, "_tempDisplayObjectParent", {
        /**
         * @protected
         * @member {PIXI.Container}
         */ get: function() {
            if (this.tempDisplayObjectParent === null) // eslint-disable-next-line @typescript-eslint/no-use-before-define
            this.tempDisplayObjectParent = new $62a57129ee044f79$export$a35515d77cade20d();
            return this.tempDisplayObjectParent;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Used in Renderer, cacheAsBitmap and other places where you call an `updateTransform` on root
     *
     * ```
     * const cacheParent = elem.enableTempParent();
     * elem.updateTransform();
     * elem.disableTempParent(cacheParent);
     * ```
     *
     * @returns {PIXI.Container} current parent
     */ DisplayObject.prototype.enableTempParent = function() {
        var myParent = this.parent;
        this.parent = this._tempDisplayObjectParent;
        return myParent;
    };
    /**
     * Pair method for `enableTempParent`
     *
     * @param {PIXI.Container} cacheParent - Actual parent of element
     */ DisplayObject.prototype.disableTempParent = function(cacheParent) {
        this.parent = cacheParent;
    };
    Object.defineProperty(DisplayObject.prototype, "x", {
        /**
         * The position of the displayObject on the x axis relative to the local coordinates of the parent.
         * An alias to position.x
         *
         * @member {number}
         */ get: function() {
            return this.position.x;
        },
        set: function(value) {
            this.transform.position.x = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "y", {
        /**
         * The position of the displayObject on the y axis relative to the local coordinates of the parent.
         * An alias to position.y
         *
         * @member {number}
         */ get: function() {
            return this.position.y;
        },
        set: function(value) {
            this.transform.position.y = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "worldTransform", {
        /**
         * Current transform of the object based on world (parent) factors.
         *
         * @member {PIXI.Matrix}
         * @readonly
         */ get: function() {
            return this.transform.worldTransform;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "localTransform", {
        /**
         * Current transform of the object based on local factors: position, scale, other stuff.
         *
         * @member {PIXI.Matrix}
         * @readonly
         */ get: function() {
            return this.transform.localTransform;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "position", {
        /**
         * The coordinate of the object relative to the local coordinates of the parent.
         *
         * @since PixiJS 4
         * @member {PIXI.ObservablePoint}
         */ get: function() {
            return this.transform.position;
        },
        set: function(value) {
            this.transform.position.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "scale", {
        /**
         * The scale factors of this object along the local coordinate axes.
         *
         * The default scale is (1, 1).
         *
         * @since PixiJS 4
         * @member {PIXI.ObservablePoint}
         */ get: function() {
            return this.transform.scale;
        },
        set: function(value) {
            this.transform.scale.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "pivot", {
        /**
         * The center of rotation, scaling, and skewing for this display object in its local space. The `position`
         * is the projection of `pivot` in the parent's local space.
         *
         * By default, the pivot is the origin (0, 0).
         *
         * @since PixiJS 4
         * @member {PIXI.ObservablePoint}
         */ get: function() {
            return this.transform.pivot;
        },
        set: function(value) {
            this.transform.pivot.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "skew", {
        /**
         * The skew factor for the object in radians.
         *
         * @since PixiJS 4
         * @member {PIXI.ObservablePoint}
         */ get: function() {
            return this.transform.skew;
        },
        set: function(value) {
            this.transform.skew.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "rotation", {
        /**
         * The rotation of the object in radians.
         * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
         *
         * @member {number}
         */ get: function() {
            return this.transform.rotation;
        },
        set: function(value) {
            this.transform.rotation = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "angle", {
        /**
         * The angle of the object in degrees.
         * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
         *
         * @member {number}
         */ get: function() {
            return this.transform.rotation * (0, $6qzqq.RAD_TO_DEG);
        },
        set: function(value) {
            this.transform.rotation = value * (0, $6qzqq.DEG_TO_RAD);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "zIndex", {
        /**
         * The zIndex of the displayObject.
         *
         * If a container has the sortableChildren property set to true, children will be automatically
         * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
         * and thus rendered on top of other display objects within the same container.
         *
         * @member {number}
         * @see PIXI.Container#sortableChildren
         */ get: function() {
            return this._zIndex;
        },
        set: function(value) {
            this._zIndex = value;
            if (this.parent) this.parent.sortDirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "worldVisible", {
        /**
         * Indicates if the object is globally visible.
         *
         * @member {boolean}
         * @readonly
         */ get: function() {
            var item = this;
            do {
                if (!item.visible) return false;
                item = item.parent;
            }while (item);
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DisplayObject.prototype, "mask", {
        /**
         * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
         * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
         * {@link PIXI.Graphics} or a {@link PIXI.Sprite} object. This allows for much faster masking in canvas as it
         * utilities shape clipping. To remove a mask, set this property to `null`.
         *
         * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
         *
         * @example
         * const graphics = new PIXI.Graphics();
         * graphics.beginFill(0xFF3300);
         * graphics.drawRect(50, 250, 100, 100);
         * graphics.endFill();
         *
         * const sprite = new PIXI.Sprite(texture);
         * sprite.mask = graphics;
         *
         * @todo At the moment, PIXI.CanvasRenderer doesn't support PIXI.Sprite as mask.
         * @member {PIXI.Container|PIXI.MaskData|null}
         */ get: function() {
            return this._mask;
        },
        set: function(value) {
            if (this._mask === value) return;
            if (this._mask) {
                var maskObject = this._mask.maskObject || this._mask;
                maskObject._maskRefCount--;
                if (maskObject._maskRefCount === 0) {
                    maskObject.renderable = true;
                    maskObject.isMask = false;
                }
            }
            this._mask = value;
            if (this._mask) {
                var maskObject = this._mask.maskObject || this._mask;
                if (maskObject._maskRefCount === 0) {
                    maskObject.renderable = false;
                    maskObject.isMask = true;
                }
                maskObject._maskRefCount++;
            }
        },
        enumerable: false,
        configurable: true
    });
    return DisplayObject;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE))));
/**
 * @private
 */ var $62a57129ee044f79$export$a35515d77cade20d = /** @class */ function(_super) {
    $62a57129ee044f79$var$__extends(TemporaryDisplayObject, _super);
    function TemporaryDisplayObject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sortDirty = null;
        return _this;
    }
    return TemporaryDisplayObject;
}($62a57129ee044f79$export$1f679544f90d7d7c);
/**
 * DisplayObject default updateTransform, does not update children of container.
 * Will crash if there's no parent element.
 *
 * @memberof PIXI.DisplayObject#
 * @method displayObjectUpdateTransform
 */ $62a57129ee044f79$export$1f679544f90d7d7c.prototype.displayObjectUpdateTransform = $62a57129ee044f79$export$1f679544f90d7d7c.prototype.updateTransform;
/*!
 * @pixi/constants - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/constants is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * Different types of environments for WebGL.
 *
 * @static
 * @memberof PIXI
 * @name ENV
 * @enum {number}
 * @property {number} WEBGL_LEGACY - Used for older v1 WebGL devices. PixiJS will aim to ensure compatibility
 *  with older / less advanced devices. If you experience unexplained flickering prefer this environment.
 * @property {number} WEBGL - Version 1 of WebGL
 * @property {number} WEBGL2 - Version 2 of WebGL
 */ var $62a57129ee044f79$var$ENV;
(function(ENV) {
    ENV[ENV["WEBGL_LEGACY"] = 0] = "WEBGL_LEGACY";
    ENV[ENV["WEBGL"] = 1] = "WEBGL";
    ENV[ENV["WEBGL2"] = 2] = "WEBGL2";
})($62a57129ee044f79$var$ENV || ($62a57129ee044f79$var$ENV = {}));
/**
 * Constant to identify the Renderer Type.
 *
 * @static
 * @memberof PIXI
 * @name RENDERER_TYPE
 * @enum {number}
 * @property {number} UNKNOWN - Unknown render type.
 * @property {number} WEBGL - WebGL render type.
 * @property {number} CANVAS - Canvas render type.
 */ var $62a57129ee044f79$var$RENDERER_TYPE;
(function(RENDERER_TYPE) {
    RENDERER_TYPE[RENDERER_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
    RENDERER_TYPE[RENDERER_TYPE["WEBGL"] = 1] = "WEBGL";
    RENDERER_TYPE[RENDERER_TYPE["CANVAS"] = 2] = "CANVAS";
})($62a57129ee044f79$var$RENDERER_TYPE || ($62a57129ee044f79$var$RENDERER_TYPE = {}));
/**
 * Bitwise OR of masks that indicate the buffers to be cleared.
 *
 * @static
 * @memberof PIXI
 * @name BUFFER_BITS
 * @enum {number}
 * @property {number} COLOR - Indicates the buffers currently enabled for color writing.
 * @property {number} DEPTH - Indicates the depth buffer.
 * @property {number} STENCIL - Indicates the stencil buffer.
 */ var $62a57129ee044f79$var$BUFFER_BITS;
(function(BUFFER_BITS) {
    BUFFER_BITS[BUFFER_BITS["COLOR"] = 16384] = "COLOR";
    BUFFER_BITS[BUFFER_BITS["DEPTH"] = 256] = "DEPTH";
    BUFFER_BITS[BUFFER_BITS["STENCIL"] = 1024] = "STENCIL";
})($62a57129ee044f79$var$BUFFER_BITS || ($62a57129ee044f79$var$BUFFER_BITS = {}));
/**
 * Various blend modes supported by PIXI.
 *
 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
 * Anything else will silently act like NORMAL.
 *
 * @memberof PIXI
 * @name BLEND_MODES
 * @enum {number}
 * @property {number} NORMAL
 * @property {number} ADD
 * @property {number} MULTIPLY
 * @property {number} SCREEN
 * @property {number} OVERLAY
 * @property {number} DARKEN
 * @property {number} LIGHTEN
 * @property {number} COLOR_DODGE
 * @property {number} COLOR_BURN
 * @property {number} HARD_LIGHT
 * @property {number} SOFT_LIGHT
 * @property {number} DIFFERENCE
 * @property {number} EXCLUSION
 * @property {number} HUE
 * @property {number} SATURATION
 * @property {number} COLOR
 * @property {number} LUMINOSITY
 * @property {number} NORMAL_NPM
 * @property {number} ADD_NPM
 * @property {number} SCREEN_NPM
 * @property {number} NONE
 * @property {number} SRC_IN
 * @property {number} SRC_OUT
 * @property {number} SRC_ATOP
 * @property {number} DST_OVER
 * @property {number} DST_IN
 * @property {number} DST_OUT
 * @property {number} DST_ATOP
 * @property {number} SUBTRACT
 * @property {number} SRC_OVER
 * @property {number} ERASE
 * @property {number} XOR
 */ var $62a57129ee044f79$var$BLEND_MODES;
(function(BLEND_MODES) {
    BLEND_MODES[BLEND_MODES["NORMAL"] = 0] = "NORMAL";
    BLEND_MODES[BLEND_MODES["ADD"] = 1] = "ADD";
    BLEND_MODES[BLEND_MODES["MULTIPLY"] = 2] = "MULTIPLY";
    BLEND_MODES[BLEND_MODES["SCREEN"] = 3] = "SCREEN";
    BLEND_MODES[BLEND_MODES["OVERLAY"] = 4] = "OVERLAY";
    BLEND_MODES[BLEND_MODES["DARKEN"] = 5] = "DARKEN";
    BLEND_MODES[BLEND_MODES["LIGHTEN"] = 6] = "LIGHTEN";
    BLEND_MODES[BLEND_MODES["COLOR_DODGE"] = 7] = "COLOR_DODGE";
    BLEND_MODES[BLEND_MODES["COLOR_BURN"] = 8] = "COLOR_BURN";
    BLEND_MODES[BLEND_MODES["HARD_LIGHT"] = 9] = "HARD_LIGHT";
    BLEND_MODES[BLEND_MODES["SOFT_LIGHT"] = 10] = "SOFT_LIGHT";
    BLEND_MODES[BLEND_MODES["DIFFERENCE"] = 11] = "DIFFERENCE";
    BLEND_MODES[BLEND_MODES["EXCLUSION"] = 12] = "EXCLUSION";
    BLEND_MODES[BLEND_MODES["HUE"] = 13] = "HUE";
    BLEND_MODES[BLEND_MODES["SATURATION"] = 14] = "SATURATION";
    BLEND_MODES[BLEND_MODES["COLOR"] = 15] = "COLOR";
    BLEND_MODES[BLEND_MODES["LUMINOSITY"] = 16] = "LUMINOSITY";
    BLEND_MODES[BLEND_MODES["NORMAL_NPM"] = 17] = "NORMAL_NPM";
    BLEND_MODES[BLEND_MODES["ADD_NPM"] = 18] = "ADD_NPM";
    BLEND_MODES[BLEND_MODES["SCREEN_NPM"] = 19] = "SCREEN_NPM";
    BLEND_MODES[BLEND_MODES["NONE"] = 20] = "NONE";
    BLEND_MODES[BLEND_MODES["SRC_OVER"] = 0] = "SRC_OVER";
    BLEND_MODES[BLEND_MODES["SRC_IN"] = 21] = "SRC_IN";
    BLEND_MODES[BLEND_MODES["SRC_OUT"] = 22] = "SRC_OUT";
    BLEND_MODES[BLEND_MODES["SRC_ATOP"] = 23] = "SRC_ATOP";
    BLEND_MODES[BLEND_MODES["DST_OVER"] = 24] = "DST_OVER";
    BLEND_MODES[BLEND_MODES["DST_IN"] = 25] = "DST_IN";
    BLEND_MODES[BLEND_MODES["DST_OUT"] = 26] = "DST_OUT";
    BLEND_MODES[BLEND_MODES["DST_ATOP"] = 27] = "DST_ATOP";
    BLEND_MODES[BLEND_MODES["ERASE"] = 26] = "ERASE";
    BLEND_MODES[BLEND_MODES["SUBTRACT"] = 28] = "SUBTRACT";
    BLEND_MODES[BLEND_MODES["XOR"] = 29] = "XOR";
})($62a57129ee044f79$var$BLEND_MODES || ($62a57129ee044f79$var$BLEND_MODES = {}));
/**
 * Various webgl draw modes. These can be used to specify which GL drawMode to use
 * under certain situations and renderers.
 *
 * @memberof PIXI
 * @static
 * @name DRAW_MODES
 * @enum {number}
 * @property {number} POINTS
 * @property {number} LINES
 * @property {number} LINE_LOOP
 * @property {number} LINE_STRIP
 * @property {number} TRIANGLES
 * @property {number} TRIANGLE_STRIP
 * @property {number} TRIANGLE_FAN
 */ var $62a57129ee044f79$var$DRAW_MODES;
(function(DRAW_MODES) {
    DRAW_MODES[DRAW_MODES["POINTS"] = 0] = "POINTS";
    DRAW_MODES[DRAW_MODES["LINES"] = 1] = "LINES";
    DRAW_MODES[DRAW_MODES["LINE_LOOP"] = 2] = "LINE_LOOP";
    DRAW_MODES[DRAW_MODES["LINE_STRIP"] = 3] = "LINE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLES"] = 4] = "TRIANGLES";
    DRAW_MODES[DRAW_MODES["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
})($62a57129ee044f79$var$DRAW_MODES || ($62a57129ee044f79$var$DRAW_MODES = {}));
/**
 * Various GL texture/resources formats.
 *
 * @memberof PIXI
 * @static
 * @name FORMATS
 * @enum {number}
 * @property {number} RGBA=6408
 * @property {number} RGB=6407
 * @property {number} RG=33319
 * @property {number} RED=6403
 * @property {number} RGBA_INTEGER=36249
 * @property {number} RGB_INTEGER=36248
 * @property {number} RG_INTEGER=33320
 * @property {number} RED_INTEGER=36244
 * @property {number} ALPHA=6406
 * @property {number} LUMINANCE=6409
 * @property {number} LUMINANCE_ALPHA=6410
 * @property {number} DEPTH_COMPONENT=6402
 * @property {number} DEPTH_STENCIL=34041
 */ var $62a57129ee044f79$var$FORMATS;
(function(FORMATS) {
    FORMATS[FORMATS["RGBA"] = 6408] = "RGBA";
    FORMATS[FORMATS["RGB"] = 6407] = "RGB";
    FORMATS[FORMATS["RG"] = 33319] = "RG";
    FORMATS[FORMATS["RED"] = 6403] = "RED";
    FORMATS[FORMATS["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    FORMATS[FORMATS["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    FORMATS[FORMATS["RG_INTEGER"] = 33320] = "RG_INTEGER";
    FORMATS[FORMATS["RED_INTEGER"] = 36244] = "RED_INTEGER";
    FORMATS[FORMATS["ALPHA"] = 6406] = "ALPHA";
    FORMATS[FORMATS["LUMINANCE"] = 6409] = "LUMINANCE";
    FORMATS[FORMATS["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    FORMATS[FORMATS["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    FORMATS[FORMATS["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
})($62a57129ee044f79$var$FORMATS || ($62a57129ee044f79$var$FORMATS = {}));
/**
 * Various GL target types.
 *
 * @memberof PIXI
 * @static
 * @name TARGETS
 * @enum {number}
 * @property {number} TEXTURE_2D=3553
 * @property {number} TEXTURE_CUBE_MAP=34067
 * @property {number} TEXTURE_2D_ARRAY=35866
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_X=34069
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_X=34070
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Y=34071
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Y=34072
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Z=34073
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Z=34074
 */ var $62a57129ee044f79$var$TARGETS;
(function(TARGETS) {
    TARGETS[TARGETS["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    TARGETS[TARGETS["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
})($62a57129ee044f79$var$TARGETS || ($62a57129ee044f79$var$TARGETS = {}));
/**
 * Various GL data format types.
 *
 * @memberof PIXI
 * @static
 * @name TYPES
 * @enum {number}
 * @property {number} UNSIGNED_BYTE=5121
 * @property {number} UNSIGNED_SHORT=5123
 * @property {number} UNSIGNED_SHORT_5_6_5=33635
 * @property {number} UNSIGNED_SHORT_4_4_4_4=32819
 * @property {number} UNSIGNED_SHORT_5_5_5_1=32820
 * @property {number} UNSIGNED_INT=5125
 * @property {number} UNSIGNED_INT_10F_11F_11F_REV=35899
 * @property {number} UNSIGNED_INT_2_10_10_10_REV=33640
 * @property {number} UNSIGNED_INT_24_8=34042
 * @property {number} UNSIGNED_INT_5_9_9_9_REV=35902
 * @property {number} BYTE=5120
 * @property {number} SHORT=5122
 * @property {number} INT=5124
 * @property {number} FLOAT=5126
 * @property {number} FLOAT_32_UNSIGNED_INT_24_8_REV=36269
 * @property {number} HALF_FLOAT=36193
 */ var $62a57129ee044f79$var$TYPES;
(function(TYPES) {
    TYPES[TYPES["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    TYPES[TYPES["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    TYPES[TYPES["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    TYPES[TYPES["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    TYPES[TYPES["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    TYPES[TYPES["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    TYPES[TYPES["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    TYPES[TYPES["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    TYPES[TYPES["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    TYPES[TYPES["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    TYPES[TYPES["BYTE"] = 5120] = "BYTE";
    TYPES[TYPES["SHORT"] = 5122] = "SHORT";
    TYPES[TYPES["INT"] = 5124] = "INT";
    TYPES[TYPES["FLOAT"] = 5126] = "FLOAT";
    TYPES[TYPES["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    TYPES[TYPES["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
})($62a57129ee044f79$var$TYPES || ($62a57129ee044f79$var$TYPES = {}));
/**
 * Various sampler types. Correspond to `sampler`, `isampler`, `usampler` GLSL types respectively.
 * WebGL1 works only with FLOAT.
 *
 * @memberof PIXI
 * @static
 * @name SAMPLER_TYPES
 * @enum {number}
 * @property {number} FLOAT=0
 * @property {number} INT=1
 * @property {number} UINT=2
 */ var $62a57129ee044f79$var$SAMPLER_TYPES;
(function(SAMPLER_TYPES) {
    SAMPLER_TYPES[SAMPLER_TYPES["FLOAT"] = 0] = "FLOAT";
    SAMPLER_TYPES[SAMPLER_TYPES["INT"] = 1] = "INT";
    SAMPLER_TYPES[SAMPLER_TYPES["UINT"] = 2] = "UINT";
})($62a57129ee044f79$var$SAMPLER_TYPES || ($62a57129ee044f79$var$SAMPLER_TYPES = {}));
/**
 * The scale modes that are supported by pixi.
 *
 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
 *
 * @memberof PIXI
 * @static
 * @name SCALE_MODES
 * @enum {number}
 * @property {number} LINEAR Smooth scaling
 * @property {number} NEAREST Pixelating scaling
 */ var $62a57129ee044f79$var$SCALE_MODES;
(function(SCALE_MODES) {
    SCALE_MODES[SCALE_MODES["NEAREST"] = 0] = "NEAREST";
    SCALE_MODES[SCALE_MODES["LINEAR"] = 1] = "LINEAR";
})($62a57129ee044f79$var$SCALE_MODES || ($62a57129ee044f79$var$SCALE_MODES = {}));
/**
 * The wrap modes that are supported by pixi.
 *
 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
 * If the texture is non power of two then clamp will be used regardless as WebGL can
 * only use REPEAT if the texture is po2.
 *
 * This property only affects WebGL.
 *
 * @name WRAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} CLAMP - The textures uvs are clamped
 * @property {number} REPEAT - The texture uvs tile and repeat
 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
 */ var $62a57129ee044f79$var$WRAP_MODES;
(function(WRAP_MODES) {
    WRAP_MODES[WRAP_MODES["CLAMP"] = 33071] = "CLAMP";
    WRAP_MODES[WRAP_MODES["REPEAT"] = 10497] = "REPEAT";
    WRAP_MODES[WRAP_MODES["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
})($62a57129ee044f79$var$WRAP_MODES || ($62a57129ee044f79$var$WRAP_MODES = {}));
/**
 * Mipmap filtering modes that are supported by pixi.
 *
 * The {@link PIXI.settings.MIPMAP_TEXTURES} affects default texture filtering.
 * Mipmaps are generated for a baseTexture if its `mipmap` field is `ON`,
 * or its `POW2` and texture dimensions are powers of 2.
 * Due to platform restriction, `ON` option will work like `POW2` for webgl-1.
 *
 * This property only affects WebGL.
 *
 * @name MIPMAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} OFF - No mipmaps
 * @property {number} POW2 - Generate mipmaps if texture dimensions are pow2
 * @property {number} ON - Always generate mipmaps
 * @property {number} ON_MANUAL - Use mipmaps, but do not auto-generate them; this is used with a resource
 *   that supports buffering each level-of-detail.
 */ var $62a57129ee044f79$var$MIPMAP_MODES;
(function(MIPMAP_MODES) {
    MIPMAP_MODES[MIPMAP_MODES["OFF"] = 0] = "OFF";
    MIPMAP_MODES[MIPMAP_MODES["POW2"] = 1] = "POW2";
    MIPMAP_MODES[MIPMAP_MODES["ON"] = 2] = "ON";
    MIPMAP_MODES[MIPMAP_MODES["ON_MANUAL"] = 3] = "ON_MANUAL";
})($62a57129ee044f79$var$MIPMAP_MODES || ($62a57129ee044f79$var$MIPMAP_MODES = {}));
/**
 * How to treat textures with premultiplied alpha
 *
 * @name ALPHA_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NO_PREMULTIPLIED_ALPHA - Source is not premultiplied, leave it like that.
 *  Option for compressed and data textures that are created from typed arrays.
 * @property {number} PREMULTIPLY_ON_UPLOAD - Source is not premultiplied, premultiply on upload.
 *  Default option, used for all loaded images.
 * @property {number} PREMULTIPLIED_ALPHA - Source is already premultiplied
 *  Example: spine atlases with `_pma` suffix.
 * @property {number} NPM - Alias for NO_PREMULTIPLIED_ALPHA.
 * @property {number} UNPACK - Default option, alias for PREMULTIPLY_ON_UPLOAD.
 * @property {number} PMA - Alias for PREMULTIPLIED_ALPHA.
 */ var $62a57129ee044f79$var$ALPHA_MODES;
(function(ALPHA_MODES) {
    ALPHA_MODES[ALPHA_MODES["NPM"] = 0] = "NPM";
    ALPHA_MODES[ALPHA_MODES["UNPACK"] = 1] = "UNPACK";
    ALPHA_MODES[ALPHA_MODES["PMA"] = 2] = "PMA";
    ALPHA_MODES[ALPHA_MODES["NO_PREMULTIPLIED_ALPHA"] = 0] = "NO_PREMULTIPLIED_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ON_UPLOAD"] = 1] = "PREMULTIPLY_ON_UPLOAD";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ALPHA"] = 2] = "PREMULTIPLY_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLIED_ALPHA"] = 2] = "PREMULTIPLIED_ALPHA";
})($62a57129ee044f79$var$ALPHA_MODES || ($62a57129ee044f79$var$ALPHA_MODES = {}));
/**
 * Configure whether filter textures are cleared after binding.
 *
 * Filter textures need not be cleared if the filter does not use pixel blending. {@link CLEAR_MODES.BLIT} will detect
 * this and skip clearing as an optimization.
 *
 * @name CLEAR_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} BLEND - Do not clear the filter texture. The filter's output will blend on top of the output texture.
 * @property {number} CLEAR - Always clear the filter texture.
 * @property {number} BLIT - Clear only if {@link FilterSystem.forceClear} is set or if the filter uses pixel blending.
 * @property {number} NO - Alias for BLEND, same as `false` in earlier versions
 * @property {number} YES - Alias for CLEAR, same as `true` in earlier versions
 * @property {number} AUTO - Alias for BLIT
 */ var $62a57129ee044f79$var$CLEAR_MODES;
(function(CLEAR_MODES) {
    CLEAR_MODES[CLEAR_MODES["NO"] = 0] = "NO";
    CLEAR_MODES[CLEAR_MODES["YES"] = 1] = "YES";
    CLEAR_MODES[CLEAR_MODES["AUTO"] = 2] = "AUTO";
    CLEAR_MODES[CLEAR_MODES["BLEND"] = 0] = "BLEND";
    CLEAR_MODES[CLEAR_MODES["CLEAR"] = 1] = "CLEAR";
    CLEAR_MODES[CLEAR_MODES["BLIT"] = 2] = "BLIT";
})($62a57129ee044f79$var$CLEAR_MODES || ($62a57129ee044f79$var$CLEAR_MODES = {}));
/**
 * The gc modes that are supported by pixi.
 *
 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
 * used for a specified period of time they will be removed from the GPU. They will of course
 * be uploaded again when they are required. This is a silent behind the scenes process that
 * should ensure that the GPU does not  get filled up.
 *
 * Handy for mobile devices!
 * This property only affects WebGL.
 *
 * @name GC_MODES
 * @enum {number}
 * @static
 * @memberof PIXI
 * @property {number} AUTO - Garbage collection will happen periodically automatically
 * @property {number} MANUAL - Garbage collection will need to be called manually
 */ var $62a57129ee044f79$var$GC_MODES;
(function(GC_MODES) {
    GC_MODES[GC_MODES["AUTO"] = 0] = "AUTO";
    GC_MODES[GC_MODES["MANUAL"] = 1] = "MANUAL";
})($62a57129ee044f79$var$GC_MODES || ($62a57129ee044f79$var$GC_MODES = {}));
/**
 * Constants that specify float precision in shaders.
 *
 * @name PRECISION
 * @memberof PIXI
 * @constant
 * @static
 * @enum {string}
 * @property {string} LOW='lowp'
 * @property {string} MEDIUM='mediump'
 * @property {string} HIGH='highp'
 */ var $62a57129ee044f79$var$PRECISION;
(function(PRECISION) {
    PRECISION["LOW"] = "lowp";
    PRECISION["MEDIUM"] = "mediump";
    PRECISION["HIGH"] = "highp";
})($62a57129ee044f79$var$PRECISION || ($62a57129ee044f79$var$PRECISION = {}));
/**
 * Constants for mask implementations.
 * We use `type` suffix because it leads to very different behaviours
 *
 * @name MASK_TYPES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - Mask is ignored
 * @property {number} SCISSOR - Scissor mask, rectangle on screen, cheap
 * @property {number} STENCIL - Stencil mask, 1-bit, medium, works only if renderer supports stencil
 * @property {number} SPRITE - Mask that uses SpriteMaskFilter, uses temporary RenderTexture
 */ var $62a57129ee044f79$var$MASK_TYPES;
(function(MASK_TYPES) {
    MASK_TYPES[MASK_TYPES["NONE"] = 0] = "NONE";
    MASK_TYPES[MASK_TYPES["SCISSOR"] = 1] = "SCISSOR";
    MASK_TYPES[MASK_TYPES["STENCIL"] = 2] = "STENCIL";
    MASK_TYPES[MASK_TYPES["SPRITE"] = 3] = "SPRITE";
})($62a57129ee044f79$var$MASK_TYPES || ($62a57129ee044f79$var$MASK_TYPES = {}));
/**
 * Constants for multi-sampling antialiasing.
 *
 * @see PIXI.Framebuffer#multisample
 *
 * @name MSAA_QUALITY
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - No multisampling for this renderTexture
 * @property {number} LOW - Try 2 samples
 * @property {number} MEDIUM - Try 4 samples
 * @property {number} HIGH - Try 8 samples
 */ var $62a57129ee044f79$var$MSAA_QUALITY;
(function(MSAA_QUALITY) {
    MSAA_QUALITY[MSAA_QUALITY["NONE"] = 0] = "NONE";
    MSAA_QUALITY[MSAA_QUALITY["LOW"] = 2] = "LOW";
    MSAA_QUALITY[MSAA_QUALITY["MEDIUM"] = 4] = "MEDIUM";
    MSAA_QUALITY[MSAA_QUALITY["HIGH"] = 8] = "HIGH";
})($62a57129ee044f79$var$MSAA_QUALITY || ($62a57129ee044f79$var$MSAA_QUALITY = {}));
/**
 * Constants for various buffer types in Pixi
 *
 * @see PIXI.BUFFER_TYPE
 *
 * @name BUFFER_TYPE
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} ELEMENT_ARRAY_BUFFER - buffer type for using as an index buffer
 * @property {number} ARRAY_BUFFER - buffer type for using attribute data
 * @property {number} UNIFORM_BUFFER - the buffer type is for uniform buffer objects
 */ var $62a57129ee044f79$var$BUFFER_TYPE;
(function(BUFFER_TYPE) {
    BUFFER_TYPE[BUFFER_TYPE["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    BUFFER_TYPE[BUFFER_TYPE["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    // NOT YET SUPPORTED
    BUFFER_TYPE[BUFFER_TYPE["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
})($62a57129ee044f79$var$BUFFER_TYPE || ($62a57129ee044f79$var$BUFFER_TYPE = {}));
function $62a57129ee044f79$var$sortChildren(a, b) {
    if (a.zIndex === b.zIndex) return a._lastSortedIndex - b._lastSortedIndex;
    return a.zIndex - b.zIndex;
}
/**
 * Container is a general-purpose display object that holds children. It also adds built-in support for advanced
 * rendering features like masking and filtering.
 *
 * It is the base class of all display objects that act as a container for other objects, including Graphics
 * and Sprite.
 *
 * ```js
 * import { BlurFilter } from '@pixi/filter-blur';
 * import { Container } from '@pixi/display';
 * import { Graphics } from '@pixi/graphics';
 * import { Sprite } from '@pixi/sprite';
 *
 * let container = new Container();
 * let sprite = Sprite.from("https://s3-us-west-2.amazonaws.com/s.cdpn.io/693612/IaUrttj.png");
 *
 * sprite.width = 512;
 * sprite.height = 512;
 *
 * // Adds a sprite as a child to this container. As a result, the sprite will be rendered whenever the container
 * // is rendered.
 * container.addChild(sprite);
 *
 * // Blurs whatever is rendered by the container
 * container.filters = [new BlurFilter()];
 *
 * // Only the contents within a circle at the center should be rendered onto the screen.
 * container.mask = new Graphics()
 *  .beginFill(0xffffff)
 *  .drawCircle(sprite.width / 2, sprite.height / 2, Math.min(sprite.width, sprite.height) / 2)
 *  .endFill();
 * ```
 *
 * @class
 * @extends PIXI.DisplayObject
 * @memberof PIXI
 */ var $62a57129ee044f79$export$42a852a2b6b56249 = /** @class */ function(_super) {
    $62a57129ee044f79$var$__extends(Container, _super);
    function Container() {
        var _this = _super.call(this) || this;
        /**
         * The array of children of this container.
         *
         * @member {PIXI.DisplayObject[]}
         * @readonly
         */ _this.children = [];
        /**
         * If set to true, the container will sort its children by zIndex value
         * when updateTransform() is called, or manually if sortChildren() is called.
         *
         * This actually changes the order of elements in the array, so should be treated
         * as a basic solution that is not performant compared to other solutions,
         * such as @link https://github.com/pixijs/pixi-display
         *
         * Also be aware of that this may not work nicely with the addChildAt() function,
         * as the zIndex sorting may cause the child to automatically sorted to another position.
         *
         * @see PIXI.settings.SORTABLE_CHILDREN
         *
         * @member {boolean}
         */ _this.sortableChildren = (0, $ezJmd.settings).SORTABLE_CHILDREN;
        /**
         * Should children be sorted by zIndex at the next updateTransform call.
         *
         * Will get automatically set to true if a new child is added, or if a child's zIndex changes.
         *
         * @member {boolean}
         */ _this.sortDirty = false;
        return _this;
    /**
         * Fired when a DisplayObject is added to this Container.
         *
         * @event PIXI.Container#childAdded
         * @param {PIXI.DisplayObject} child - The child added to the Container.
         * @param {PIXI.Container} container - The container that added the child.
         * @param {number} index - The children's index of the added child.
         */ /**
         * Fired when a DisplayObject is removed from this Container.
         *
         * @event PIXI.DisplayObject#removedFrom
         * @param {PIXI.DisplayObject} child - The child removed from the Container.
         * @param {PIXI.Container} container - The container that removed removed the child.
         * @param {number} index - The former children's index of the removed child
         */ }
    /**
     * Overridable method that can be used by Container subclasses whenever the children array is modified
     *
     * @protected
     */ Container.prototype.onChildrenChange = function(_length) {
    /* empty */ };
    /**
     * Adds one or more children to the container.
     *
     * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
     *
     * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to add to the container
     * @return {PIXI.DisplayObject} The first child that was added.
     */ Container.prototype.addChild = function() {
        var arguments$1 = arguments;
        var children = [];
        for(var _i = 0; _i < arguments.length; _i++)children[_i] = arguments$1[_i];
        // if there is only one argument we can bypass looping through the them
        if (children.length > 1) // loop through the array and add all children
        for(var i = 0; i < children.length; i++)// eslint-disable-next-line prefer-rest-params
        this.addChild(children[i]);
        else {
            var child = children[0];
            // if the child has a parent then lets remove it as PixiJS objects can only exist in one place
            if (child.parent) child.parent.removeChild(child);
            child.parent = this;
            this.sortDirty = true;
            // ensure child transform will be recalculated
            child.transform._parentID = -1;
            this.children.push(child);
            // ensure bounds will be recalculated
            this._boundsID++;
            // TODO - lets either do all callbacks or all events.. not both!
            this.onChildrenChange(this.children.length - 1);
            this.emit('childAdded', child, this, this.children.length - 1);
            child.emit('added', this);
        }
        return children[0];
    };
    /**
     * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown
     *
     * @param {PIXI.DisplayObject} child - The child to add
     * @param {number} index - The index to place the child in
     * @return {PIXI.DisplayObject} The child that was added.
     */ Container.prototype.addChildAt = function(child, index) {
        if (index < 0 || index > this.children.length) throw new Error(child + "addChildAt: The index " + index + " supplied is out of bounds " + this.children.length);
        if (child.parent) child.parent.removeChild(child);
        child.parent = this;
        this.sortDirty = true;
        // ensure child transform will be recalculated
        child.transform._parentID = -1;
        this.children.splice(index, 0, child);
        // ensure bounds will be recalculated
        this._boundsID++;
        // TODO - lets either do all callbacks or all events.. not both!
        this.onChildrenChange(index);
        child.emit('added', this);
        this.emit('childAdded', child, this, index);
        return child;
    };
    /**
     * Swaps the position of 2 Display Objects within this container.
     *
     * @param {PIXI.DisplayObject} child - First display object to swap
     * @param {PIXI.DisplayObject} child2 - Second display object to swap
     */ Container.prototype.swapChildren = function(child, child2) {
        if (child === child2) return;
        var index1 = this.getChildIndex(child);
        var index2 = this.getChildIndex(child2);
        this.children[index1] = child2;
        this.children[index2] = child;
        this.onChildrenChange(index1 < index2 ? index1 : index2);
    };
    /**
     * Returns the index position of a child DisplayObject instance
     *
     * @param {PIXI.DisplayObject} child - The DisplayObject instance to identify
     * @return {number} The index position of the child display object to identify
     */ Container.prototype.getChildIndex = function(child) {
        var index = this.children.indexOf(child);
        if (index === -1) throw new Error('The supplied DisplayObject must be a child of the caller');
        return index;
    };
    /**
     * Changes the position of an existing child in the display object container
     *
     * @param {PIXI.DisplayObject} child - The child DisplayObject instance for which you want to change the index number
     * @param {number} index - The resulting index number for the child display object
     */ Container.prototype.setChildIndex = function(child, index) {
        if (index < 0 || index >= this.children.length) throw new Error("The index " + index + " supplied is out of bounds " + this.children.length);
        var currentIndex = this.getChildIndex(child);
        (0, $csytw.removeItems)(this.children, currentIndex, 1); // remove from old position
        this.children.splice(index, 0, child); // add at new position
        this.onChildrenChange(index);
    };
    /**
     * Returns the child at the specified index
     *
     * @param {number} index - The index to get the child at
     * @return {PIXI.DisplayObject} The child at the given index, if any.
     */ Container.prototype.getChildAt = function(index) {
        if (index < 0 || index >= this.children.length) throw new Error("getChildAt: Index (" + index + ") does not exist.");
        return this.children[index];
    };
    /**
     * Removes one or more children from the container.
     *
     * @param {...PIXI.DisplayObject} children - The DisplayObject(s) to remove
     * @return {PIXI.DisplayObject} The first child that was removed.
     */ Container.prototype.removeChild = function() {
        var arguments$1 = arguments;
        var children = [];
        for(var _i = 0; _i < arguments.length; _i++)children[_i] = arguments$1[_i];
        // if there is only one argument we can bypass looping through the them
        if (children.length > 1) // loop through the arguments property and remove all children
        for(var i = 0; i < children.length; i++)this.removeChild(children[i]);
        else {
            var child = children[0];
            var index = this.children.indexOf(child);
            if (index === -1) return null;
            child.parent = null;
            // ensure child transform will be recalculated
            child.transform._parentID = -1;
            (0, $csytw.removeItems)(this.children, index, 1);
            // ensure bounds will be recalculated
            this._boundsID++;
            // TODO - lets either do all callbacks or all events.. not both!
            this.onChildrenChange(index);
            child.emit('removed', this);
            this.emit('childRemoved', child, this, index);
        }
        return children[0];
    };
    /**
     * Removes a child from the specified index position.
     *
     * @param {number} index - The index to get the child from
     * @return {PIXI.DisplayObject} The child that was removed.
     */ Container.prototype.removeChildAt = function(index) {
        var child = this.getChildAt(index);
        // ensure child transform will be recalculated..
        child.parent = null;
        child.transform._parentID = -1;
        (0, $csytw.removeItems)(this.children, index, 1);
        // ensure bounds will be recalculated
        this._boundsID++;
        // TODO - lets either do all callbacks or all events.. not both!
        this.onChildrenChange(index);
        child.emit('removed', this);
        this.emit('childRemoved', child, this, index);
        return child;
    };
    /**
     * Removes all children from this container that are within the begin and end indexes.
     *
     * @param {number} [beginIndex=0] - The beginning position.
     * @param {number} [endIndex=this.children.length] - The ending position. Default value is size of the container.
     * @returns {PIXI.DisplayObject[]} List of removed children
     */ Container.prototype.removeChildren = function(beginIndex, endIndex) {
        if (beginIndex === void 0) beginIndex = 0;
        if (endIndex === void 0) endIndex = this.children.length;
        var begin = beginIndex;
        var end = endIndex;
        var range = end - begin;
        var removed;
        if (range > 0 && range <= end) {
            removed = this.children.splice(begin, range);
            for(var i = 0; i < removed.length; ++i){
                removed[i].parent = null;
                if (removed[i].transform) removed[i].transform._parentID = -1;
            }
            this._boundsID++;
            this.onChildrenChange(beginIndex);
            for(var i = 0; i < removed.length; ++i){
                removed[i].emit('removed', this);
                this.emit('childRemoved', removed[i], this, i);
            }
            return removed;
        } else if (range === 0 && this.children.length === 0) return [];
        throw new RangeError('removeChildren: numeric values are outside the acceptable range.');
    };
    /**
     * Sorts children by zIndex. Previous order is maintained for 2 children with the same zIndex.
     */ Container.prototype.sortChildren = function() {
        var sortRequired = false;
        for(var i = 0, j = this.children.length; i < j; ++i){
            var child = this.children[i];
            child._lastSortedIndex = i;
            if (!sortRequired && child.zIndex !== 0) sortRequired = true;
        }
        if (sortRequired && this.children.length > 1) this.children.sort($62a57129ee044f79$var$sortChildren);
        this.sortDirty = false;
    };
    /**
     * Updates the transform on all children of this container for rendering
     */ Container.prototype.updateTransform = function() {
        if (this.sortableChildren && this.sortDirty) this.sortChildren();
        this._boundsID++;
        this.transform.updateTransform(this.parent.transform);
        // TODO: check render flags, how to process stuff here
        this.worldAlpha = this.alpha * this.parent.worldAlpha;
        for(var i = 0, j = this.children.length; i < j; ++i){
            var child = this.children[i];
            if (child.visible) child.updateTransform();
        }
    };
    /**
     * Recalculates the bounds of the container.
     *
     * This implementation will automatically fit the children's bounds into the calculation. Each child's bounds
     * is limited to its mask's bounds or filterArea, if any is applied.
     */ Container.prototype.calculateBounds = function() {
        this._bounds.clear();
        this._calculateBounds();
        for(var i = 0; i < this.children.length; i++){
            var child = this.children[i];
            if (!child.visible || !child.renderable) continue;
            child.calculateBounds();
            // TODO: filter+mask, need to mask both somehow
            if (child._mask) {
                var maskObject = child._mask.maskObject || child._mask;
                maskObject.calculateBounds();
                this._bounds.addBoundsMask(child._bounds, maskObject._bounds);
            } else if (child.filterArea) this._bounds.addBoundsArea(child._bounds, child.filterArea);
            else this._bounds.addBounds(child._bounds);
        }
        this._bounds.updateID = this._boundsID;
    };
    /**
     * Retrieves the local bounds of the displayObject as a rectangle object.
     *
     * Calling `getLocalBounds` may invalidate the `_bounds` of the whole subtree below. If using it inside a render()
     * call, it is advised to call `getBounds()` immediately after to recalculate the world bounds of the subtree.
     *
     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation.
     * @param {boolean} [skipChildrenUpdate=false] - Setting to `true` will stop re-calculation of children transforms,
     *  it was default behaviour of pixi 4.0-5.2 and caused many problems to users.
     * @return {PIXI.Rectangle} The rectangular bounding area.
     */ Container.prototype.getLocalBounds = function(rect, skipChildrenUpdate) {
        if (skipChildrenUpdate === void 0) skipChildrenUpdate = false;
        var result = _super.prototype.getLocalBounds.call(this, rect);
        if (!skipChildrenUpdate) for(var i = 0, j = this.children.length; i < j; ++i){
            var child = this.children[i];
            if (child.visible) child.updateTransform();
        }
        return result;
    };
    /**
     * Recalculates the content bounds of this object. This should be overriden to
     * calculate the bounds of this specific object (not including children).
     *
     * @protected
     */ Container.prototype._calculateBounds = function() {
    // FILL IN//
    };
    /**
     * Renders the object using the WebGL renderer.
     *
     * The [_render]{@link PIXI.Container#_render} method is be overriden for rendering the contents of the
     * container itself. This `render` method will invoke it, and also invoke the `render` methods of all
     * children afterward.
     *
     * If `renderable` or `visible` is false or if `worldAlpha` is not positive, this implementation will entirely
     * skip rendering. See {@link PIXI.DisplayObject} for choosing between `renderable` or `visible`. Generally,
     * setting alpha to zero is not recommended for purely skipping rendering.
     *
     * When your scene becomes large (especially when it is larger than can be viewed in a single screen), it is
     * advised to employ **culling** to automatically skip rendering objects outside of the current screen. The
     * [@pixi-essentials/cull]{@link https://www.npmjs.com/package/@pixi-essentials/cull} and
     * [pixi-cull]{@link https://www.npmjs.com/package/pixi-cull} packages do this out of the box.
     *
     * The [renderAdvanced]{@link PIXI.Container#renderAdvanced} method is internally used when when masking or
     * filtering is applied on a container. This does, however, break batching and can affect performance when
     * masking and filtering is applied extensively throughout the scene graph.
     *
     * @param {PIXI.Renderer} renderer - The renderer
     */ Container.prototype.render = function(renderer) {
        // if the object is not visible or the alpha is 0 then no need to render this element
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
        // do a quick check to see if this element has a mask or a filter.
        if (this._mask || this.filters && this.filters.length) this.renderAdvanced(renderer);
        else {
            this._render(renderer);
            // simple render children!
            for(var i = 0, j = this.children.length; i < j; ++i)this.children[i].render(renderer);
        }
    };
    /**
     * Render the object using the WebGL renderer and advanced features.
     *
     * @protected
     * @param {PIXI.Renderer} renderer - The renderer
     */ Container.prototype.renderAdvanced = function(renderer) {
        var filters = this.filters;
        var mask = this._mask;
        // push filter first as we need to ensure the stencil buffer is correct for any masking
        if (filters) {
            if (!this._enabledFilters) this._enabledFilters = [];
            this._enabledFilters.length = 0;
            for(var i = 0; i < filters.length; i++)if (filters[i].enabled) this._enabledFilters.push(filters[i]);
        }
        var flush = filters && this._enabledFilters && this._enabledFilters.length || mask && (!mask.isMaskData || mask.enabled && (mask.autoDetect || mask.type !== $62a57129ee044f79$var$MASK_TYPES.NONE));
        if (flush) renderer.batch.flush();
        if (filters && this._enabledFilters && this._enabledFilters.length) renderer.filter.push(this, this._enabledFilters);
        if (mask) renderer.mask.push(this, this._mask);
        // add this object to the batch, only rendered if it has a texture.
        this._render(renderer);
        // now loop through the children and make sure they get rendered
        for(var i = 0, j = this.children.length; i < j; i++)this.children[i].render(renderer);
        if (flush) renderer.batch.flush();
        if (mask) renderer.mask.pop(this);
        if (filters && this._enabledFilters && this._enabledFilters.length) renderer.filter.pop();
    };
    /**
     * To be overridden by the subclasses.
     *
     * @protected
     * @param {PIXI.Renderer} renderer - The renderer
     */ Container.prototype._render = function(_renderer) {
    // this is where content itself gets rendered...
    };
    /**
     * Removes all internal references and listeners as well as removes children from the display list.
     * Do not use a Container after calling `destroy`.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
     *  method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */ Container.prototype.destroy = function(options) {
        _super.prototype.destroy.call(this);
        this.sortDirty = false;
        var destroyChildren = typeof options === 'boolean' ? options : options && options.children;
        var oldChildren = this.removeChildren(0, this.children.length);
        if (destroyChildren) for(var i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
    };
    Object.defineProperty(Container.prototype, "width", {
        /**
         * The width of the Container, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */ get: function() {
            return this.scale.x * this.getLocalBounds().width;
        },
        set: function(value) {
            var width = this.getLocalBounds().width;
            if (width !== 0) this.scale.x = value / width;
            else this.scale.x = 1;
            this._width = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Container.prototype, "height", {
        /**
         * The height of the Container, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */ get: function() {
            return this.scale.y * this.getLocalBounds().height;
        },
        set: function(value) {
            var height = this.getLocalBounds().height;
            if (height !== 0) this.scale.y = value / height;
            else this.scale.y = 1;
            this._height = value;
        },
        enumerable: false,
        configurable: true
    });
    return Container;
}($62a57129ee044f79$export$1f679544f90d7d7c);
/**
 * Container default updateTransform, does update children of container.
 * Will crash if there's no parent element.
 *
 * @memberof PIXI.Container#
 * @method containerUpdateTransform
 */ $62a57129ee044f79$export$42a852a2b6b56249.prototype.containerUpdateTransform = $62a57129ee044f79$export$42a852a2b6b56249.prototype.updateTransform;

});
parcelRegister("6qzqq", function(module, exports) {

$parcel$export(module.exports, "PI_2", function () { return $4ae0a6833d6839bf$export$59ed0a0a5de1084b; });
$parcel$export(module.exports, "RAD_TO_DEG", function () { return $4ae0a6833d6839bf$export$3f91627dc85c5d57; });
$parcel$export(module.exports, "DEG_TO_RAD", function () { return $4ae0a6833d6839bf$export$870617f62e3187f1; });
$parcel$export(module.exports, "SHAPES", function () { return $4ae0a6833d6839bf$export$511e1d54a4a8684e; });
$parcel$export(module.exports, "Rectangle", function () { return $4ae0a6833d6839bf$export$4617fb02663045ef; });
$parcel$export(module.exports, "Circle", function () { return $4ae0a6833d6839bf$export$c89a927ffc67e6fa; });
$parcel$export(module.exports, "Ellipse", function () { return $4ae0a6833d6839bf$export$80b0269ab108fa11; });
$parcel$export(module.exports, "Polygon", function () { return $4ae0a6833d6839bf$export$7d31b617c820d435; });
$parcel$export(module.exports, "RoundedRectangle", function () { return $4ae0a6833d6839bf$export$d55ab2e3dc5a4263; });
$parcel$export(module.exports, "Point", function () { return $4ae0a6833d6839bf$export$baf26146a414f24a; });
$parcel$export(module.exports, "ObservablePoint", function () { return $4ae0a6833d6839bf$export$3755aaad3fd42e52; });
$parcel$export(module.exports, "Matrix", function () { return $4ae0a6833d6839bf$export$5b12bf1653c0dd85; });
$parcel$export(module.exports, "groupD8", function () { return $4ae0a6833d6839bf$export$b7bb6a2a8d203102; });
$parcel$export(module.exports, "Transform", function () { return $4ae0a6833d6839bf$export$563a914cafbdc389; });
/*!
 * @pixi/math - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/math is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * Two Pi.
 *
 * @static
 * @member {number}
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$59ed0a0a5de1084b = Math.PI * 2;
/**
 * Conversion factor for converting radians to degrees.
 *
 * @static
 * @member {number} RAD_TO_DEG
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$3f91627dc85c5d57 = 180 / Math.PI;
/**
 * Conversion factor for converting degrees to radians.
 *
 * @static
 * @member {number}
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$870617f62e3187f1 = Math.PI / 180;
/**
 * Constants that identify shapes, mainly to prevent `instanceof` calls.
 *
 * @static
 * @memberof PIXI
 * @enum {number}
 * @property {number} POLY Polygon
 * @property {number} RECT Rectangle
 * @property {number} CIRC Circle
 * @property {number} ELIP Ellipse
 * @property {number} RREC Rounded Rectangle
 */ var $4ae0a6833d6839bf$export$511e1d54a4a8684e;
(function(SHAPES) {
    SHAPES[SHAPES["POLY"] = 0] = "POLY";
    SHAPES[SHAPES["RECT"] = 1] = "RECT";
    SHAPES[SHAPES["CIRC"] = 2] = "CIRC";
    SHAPES[SHAPES["ELIP"] = 3] = "ELIP";
    SHAPES[SHAPES["RREC"] = 4] = "RREC";
})($4ae0a6833d6839bf$export$511e1d54a4a8684e || ($4ae0a6833d6839bf$export$511e1d54a4a8684e = {}));
/**
 * Size object, contains width and height
 *
 * @memberof PIXI
 * @typedef {object} ISize
 */ /**
 * Rectangle object is an area defined by its position, as indicated by its top-left corner
 * point (x, y) and by its width and its height.
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$4617fb02663045ef = /** @class */ function() {
    /**
     * @param x - The X coordinate of the upper-left corner of the rectangle
     * @param y - The Y coordinate of the upper-left corner of the rectangle
     * @param width - The overall width of the rectangle
     * @param height - The overall height of the rectangle
     */ function Rectangle(x, y, width, height) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (width === void 0) width = 0;
        if (height === void 0) height = 0;
        this.x = Number(x);
        this.y = Number(y);
        this.width = Number(width);
        this.height = Number(height);
        this.type = $4ae0a6833d6839bf$export$511e1d54a4a8684e.RECT;
    }
    Object.defineProperty(Rectangle.prototype, "left", {
        /** Returns the left edge of the rectangle. */ get: function() {
            return this.x;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "right", {
        /** Returns the right edge of the rectangle. */ get: function() {
            return this.x + this.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "top", {
        /** Returns the top edge of the rectangle. */ get: function() {
            return this.y;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rectangle.prototype, "bottom", {
        /** Returns the bottom edge of the rectangle. */ get: function() {
            return this.y + this.height;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rectangle, "EMPTY", {
        /** A constant empty rectangle. */ get: function() {
            return new Rectangle(0, 0, 0, 0);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Creates a clone of this Rectangle
     *
     * @return a copy of the rectangle
     */ Rectangle.prototype.clone = function() {
        return new Rectangle(this.x, this.y, this.width, this.height);
    };
    /**
     * Copies another rectangle to this one.
     *
     * @param rectangle - The rectangle to copy from.
     * @return Returns itself.
     */ Rectangle.prototype.copyFrom = function(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    };
    /**
     * Copies this rectangle to another one.
     *
     * @param rectangle - The rectangle to copy to.
     * @return Returns given parameter.
     */ Rectangle.prototype.copyTo = function(rectangle) {
        rectangle.x = this.x;
        rectangle.y = this.y;
        rectangle.width = this.width;
        rectangle.height = this.height;
        return rectangle;
    };
    /**
     * Checks whether the x and y coordinates given are contained within this Rectangle
     *
     * @param x - The X coordinate of the point to test
     * @param y - The Y coordinate of the point to test
     * @return Whether the x/y coordinates are within this Rectangle
     */ Rectangle.prototype.contains = function(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x < this.x + this.width) {
            if (y >= this.y && y < this.y + this.height) return true;
        }
        return false;
    };
    /**
     * Pads the rectangle making it grow in all directions.
     * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
     *
     * @param paddingX - The horizontal padding amount.
     * @param paddingY - The vertical padding amount.
     * @return Returns itself.
     */ Rectangle.prototype.pad = function(paddingX, paddingY) {
        if (paddingX === void 0) paddingX = 0;
        if (paddingY === void 0) paddingY = paddingX;
        this.x -= paddingX;
        this.y -= paddingY;
        this.width += paddingX * 2;
        this.height += paddingY * 2;
        return this;
    };
    /**
     * Fits this rectangle around the passed one.
     *
     * @param rectangle - The rectangle to fit.
     * @return Returns itself.
     */ Rectangle.prototype.fit = function(rectangle) {
        var x1 = Math.max(this.x, rectangle.x);
        var x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
        var y1 = Math.max(this.y, rectangle.y);
        var y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = Math.max(x2 - x1, 0);
        this.y = y1;
        this.height = Math.max(y2 - y1, 0);
        return this;
    };
    /**
     * Enlarges rectangle that way its corners lie on grid
     *
     * @param resolution - resolution
     * @param eps - precision
     * @return Returns itself.
     */ Rectangle.prototype.ceil = function(resolution, eps) {
        if (resolution === void 0) resolution = 1;
        if (eps === void 0) eps = 0.001;
        var x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
        var y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        this.x = Math.floor((this.x + eps) * resolution) / resolution;
        this.y = Math.floor((this.y + eps) * resolution) / resolution;
        this.width = x2 - this.x;
        this.height = y2 - this.y;
        return this;
    };
    /**
     * Enlarges this rectangle to include the passed rectangle.
     *
     * @param rectangle - The rectangle to include.
     * @return Returns itself.
     */ Rectangle.prototype.enlarge = function(rectangle) {
        var x1 = Math.min(this.x, rectangle.x);
        var x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
        var y1 = Math.min(this.y, rectangle.y);
        var y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = x2 - x1;
        this.y = y1;
        this.height = y2 - y1;
        return this;
    };
    Rectangle.prototype.toString = function() {
        return "[@pixi/math:Rectangle x=" + this.x + " y=" + this.y + " width=" + this.width + " height=" + this.height + "]";
    };
    return Rectangle;
}();
/**
 * The Circle object is used to help draw graphics and can also be used to specify a hit area for displayObjects.
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$c89a927ffc67e6fa = /** @class */ function() {
    /**
     * @param x - The X coordinate of the center of this circle
     * @param y - The Y coordinate of the center of this circle
     * @param radius - The radius of the circle
     */ function Circle(x, y, radius) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (radius === void 0) radius = 0;
        this.x = x;
        this.y = y;
        this.radius = radius;
        this.type = $4ae0a6833d6839bf$export$511e1d54a4a8684e.CIRC;
    }
    /**
     * Creates a clone of this Circle instance
     *
     * @return A copy of the Circle
     */ Circle.prototype.clone = function() {
        return new Circle(this.x, this.y, this.radius);
    };
    /**
     * Checks whether the x and y coordinates given are contained within this circle
     *
     * @param x - The X coordinate of the point to test
     * @param y - The Y coordinate of the point to test
     * @return Whether the x/y coordinates are within this Circle
     */ Circle.prototype.contains = function(x, y) {
        if (this.radius <= 0) return false;
        var r2 = this.radius * this.radius;
        var dx = this.x - x;
        var dy = this.y - y;
        dx *= dx;
        dy *= dy;
        return dx + dy <= r2;
    };
    /**
    * Returns the framing rectangle of the circle as a Rectangle object
    *
    * @return The framing rectangle
    */ Circle.prototype.getBounds = function() {
        return new $4ae0a6833d6839bf$export$4617fb02663045ef(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
    };
    Circle.prototype.toString = function() {
        return "[@pixi/math:Circle x=" + this.x + " y=" + this.y + " radius=" + this.radius + "]";
    };
    return Circle;
}();
/**
 * The Ellipse object is used to help draw graphics and can also be used to specify a hit area for displayObjects.
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$80b0269ab108fa11 = /** @class */ function() {
    /**
     * @param x - The X coordinate of the center of this ellipse
     * @param y - The Y coordinate of the center of this ellipse
     * @param halfWidth - The half width of this ellipse
     * @param halfHeight - The half height of this ellipse
     */ function Ellipse(x, y, halfWidth, halfHeight) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (halfWidth === void 0) halfWidth = 0;
        if (halfHeight === void 0) halfHeight = 0;
        this.x = x;
        this.y = y;
        this.width = halfWidth;
        this.height = halfHeight;
        this.type = $4ae0a6833d6839bf$export$511e1d54a4a8684e.ELIP;
    }
    /**
     * Creates a clone of this Ellipse instance
     *
     * @return {PIXI.Ellipse} A copy of the ellipse
     */ Ellipse.prototype.clone = function() {
        return new Ellipse(this.x, this.y, this.width, this.height);
    };
    /**
     * Checks whether the x and y coordinates given are contained within this ellipse
     *
     * @param x - The X coordinate of the point to test
     * @param y - The Y coordinate of the point to test
     * @return Whether the x/y coords are within this ellipse
     */ Ellipse.prototype.contains = function(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        // normalize the coords to an ellipse with center 0,0
        var normx = (x - this.x) / this.width;
        var normy = (y - this.y) / this.height;
        normx *= normx;
        normy *= normy;
        return normx + normy <= 1;
    };
    /**
     * Returns the framing rectangle of the ellipse as a Rectangle object
     *
     * @return The framing rectangle
     */ Ellipse.prototype.getBounds = function() {
        return new $4ae0a6833d6839bf$export$4617fb02663045ef(this.x - this.width, this.y - this.height, this.width, this.height);
    };
    Ellipse.prototype.toString = function() {
        return "[@pixi/math:Ellipse x=" + this.x + " y=" + this.y + " width=" + this.width + " height=" + this.height + "]";
    };
    return Ellipse;
}();
/**
 * A class to define a shape via user defined coordinates.
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$7d31b617c820d435 = /** @class */ function() {
    /**
     * @param {PIXI.IPointData[]|number[]} points - This can be an array of Points
     *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
     *  the arguments passed can be all the points of the polygon e.g.
     *  `new PIXI.Polygon(new PIXI.Point(), new PIXI.Point(), ...)`, or the arguments passed can be flat
     *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
     */ function Polygon() {
        var arguments$1 = arguments;
        var points = [];
        for(var _i = 0; _i < arguments.length; _i++)points[_i] = arguments$1[_i];
        var flat = Array.isArray(points[0]) ? points[0] : points;
        // if this is an array of points, convert it to a flat array of numbers
        if (typeof flat[0] !== 'number') {
            var p = [];
            for(var i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat;
        this.type = $4ae0a6833d6839bf$export$511e1d54a4a8684e.POLY;
        this.closeStroke = true;
    }
    /**
     * Creates a clone of this polygon.
     *
     * @return - A copy of the polygon.
     */ Polygon.prototype.clone = function() {
        var points = this.points.slice();
        var polygon = new Polygon(points);
        polygon.closeStroke = this.closeStroke;
        return polygon;
    };
    /**
     * Checks whether the x and y coordinates passed to this function are contained within this polygon.
     *
     * @param x - The X coordinate of the point to test.
     * @param y - The Y coordinate of the point to test.
     * @return - Whether the x/y coordinates are within this polygon.
     */ Polygon.prototype.contains = function(x, y) {
        var inside = false;
        // use some raycasting to test hits
        // https://github.com/substack/point-in-polygon/blob/master/index.js
        var length = this.points.length / 2;
        for(var i = 0, j = length - 1; i < length; j = i++){
            var xi = this.points[i * 2];
            var yi = this.points[i * 2 + 1];
            var xj = this.points[j * 2];
            var yj = this.points[j * 2 + 1];
            var intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
            if (intersect) inside = !inside;
        }
        return inside;
    };
    Polygon.prototype.toString = function() {
        return "[@pixi/math:Polygon" + ("closeStroke=" + this.closeStroke) + ("points=" + this.points.reduce(function(pointsDesc, currentPoint) {
            return pointsDesc + ", " + currentPoint;
        }, '') + "]");
    };
    return Polygon;
}();
/**
 * The Rounded Rectangle object is an area that has nice rounded corners, as indicated by its
 * top-left corner point (x, y) and by its width and its height and its radius.
 *
 * @class
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$d55ab2e3dc5a4263 = /** @class */ function() {
    /**
     * @param {number} [x=0] - The X coordinate of the upper-left corner of the rounded rectangle
     * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rounded rectangle
     * @param {number} [width=0] - The overall width of this rounded rectangle
     * @param {number} [height=0] - The overall height of this rounded rectangle
     * @param {number} [radius=20] - Controls the radius of the rounded corners
     */ function RoundedRectangle(x, y, width, height, radius) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (width === void 0) width = 0;
        if (height === void 0) height = 0;
        if (radius === void 0) radius = 20;
        /**
         * @member {number}
         * @default 0
         */ this.x = x;
        /**
         * @member {number}
         * @default 0
         */ this.y = y;
        /**
         * @member {number}
         * @default 0
         */ this.width = width;
        /**
         * @member {number}
         * @default 0
         */ this.height = height;
        /**
         * @member {number}
         * @default 20
         */ this.radius = radius;
        /**
         * The type of the object, mainly used to avoid `instanceof` checks
         *
         * @member {number}
         * @readonly
         * @default PIXI.SHAPES.RREC
         * @see PIXI.SHAPES
         */ this.type = $4ae0a6833d6839bf$export$511e1d54a4a8684e.RREC;
    }
    /**
     * Creates a clone of this Rounded Rectangle
     *
     * @return {PIXI.RoundedRectangle} a copy of the rounded rectangle
     */ RoundedRectangle.prototype.clone = function() {
        return new RoundedRectangle(this.x, this.y, this.width, this.height, this.radius);
    };
    /**
     * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
     *
     * @param {number} x - The X coordinate of the point to test
     * @param {number} y - The Y coordinate of the point to test
     * @return {boolean} Whether the x/y coordinates are within this Rounded Rectangle
     */ RoundedRectangle.prototype.contains = function(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x <= this.x + this.width) {
            if (y >= this.y && y <= this.y + this.height) {
                var radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
                if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return true;
                var dx = x - (this.x + radius);
                var dy = y - (this.y + radius);
                var radius2 = radius * radius;
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + this.width - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dy = y - (this.y + this.height - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + radius);
                if (dx * dx + dy * dy <= radius2) return true;
            }
        }
        return false;
    };
    RoundedRectangle.prototype.toString = function() {
        return "[@pixi/math:RoundedRectangle x=" + this.x + " y=" + this.y + ("width=" + this.width + " height=" + this.height + " radius=" + this.radius + "]");
    };
    return RoundedRectangle;
}();
/**
 * The Point object represents a location in a two-dimensional coordinate system, where `x` represents
 * the position on the horizontal axis and `y` represents the position on the vertical axis
 *
 * @class
 * @memberof PIXI
 * @implements IPoint
 */ var $4ae0a6833d6839bf$export$baf26146a414f24a = /** @class */ function() {
    /** Creates a new `Point`
     * @param {number} [x=0] - position of the point on the x axis
     * @param {number} [y=0] - position of the point on the y axis
     */ function Point(x, y) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        /** Position of the point on the x axis */ this.x = 0;
        /** Position of the point on the y axis */ this.y = 0;
        this.x = x;
        this.y = y;
    }
    /** Creates a clone of this point
     * @returns A clone of this point
     */ Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    /**
     * Copies `x` and `y` from the given point into this point
     *
     * @param p - The point to copy from
     * @returns The point instance itself
     */ Point.prototype.copyFrom = function(p) {
        this.set(p.x, p.y);
        return this;
    };
    /**
     * Copies this point's x and y into the given point (`p`).
     *
     * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
     * @returns The point (`p`) with values updated
     */ Point.prototype.copyTo = function(p) {
        p.set(this.x, this.y);
        return p;
    };
    /**
     * Accepts another point (`p`) and returns `true` if the given point is equal to this point
     *
     * @param p - The point to check
     * @returns Returns `true` if both `x` and `y` are equal
     */ Point.prototype.equals = function(p) {
        return p.x === this.x && p.y === this.y;
    };
    /**
     * Sets the point to a new `x` and `y` position.
     * If `y` is omitted, both `x` and `y` will be set to `x`.
     *
     * @param {number} [x=0] - position of the point on the `x` axis
     * @param {number} [y=x] - position of the point on the `y` axis
     * @returns The point instance itself
     */ Point.prototype.set = function(x, y) {
        if (x === void 0) x = 0;
        if (y === void 0) y = x;
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.toString = function() {
        return "[@pixi/math:Point x=" + this.x + " y=" + this.y + "]";
    };
    return Point;
}();
/**
 * The ObservablePoint object represents a location in a two-dimensional coordinate system, where `x` represents
 * the position on the horizontal axis and `y` represents the position on the vertical axis.
 *
 * An `ObservablePoint` is a point that triggers a callback when the point's position is changed.
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$3755aaad3fd42e52 = /** @class */ function() {
    /**
     * Creates a new `ObservablePoint`
     *
     * @param cb - callback function triggered when `x` and/or `y` are changed
     * @param scope - owner of callback
     * @param {number} [x=0] - position of the point on the x axis
     * @param {number} [y=0] - position of the point on the y axis
    */ function ObservablePoint(cb, scope, x, y) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        this._x = x;
        this._y = y;
        this.cb = cb;
        this.scope = scope;
    }
    /**
     * Creates a clone of this point.
     * The callback and scope params can be overridden otherwise they will default
     * to the clone object's values.
     *
     * @override
     * @param cb - The callback function triggered when `x` and/or `y` are changed
     * @param scope - The owner of the callback
     * @return a copy of this observable point
     */ ObservablePoint.prototype.clone = function(cb, scope) {
        if (cb === void 0) cb = this.cb;
        if (scope === void 0) scope = this.scope;
        return new ObservablePoint(cb, scope, this._x, this._y);
    };
    /**
     * Sets the point to a new `x` and `y` position.
     * If `y` is omitted, both `x` and `y` will be set to `x`.
     *
     * @param {number} [x=0] - position of the point on the x axis
     * @param {number} [y=x] - position of the point on the y axis
     * @returns The observable point instance itself
     */ ObservablePoint.prototype.set = function(x, y) {
        if (x === void 0) x = 0;
        if (y === void 0) y = x;
        if (this._x !== x || this._y !== y) {
            this._x = x;
            this._y = y;
            this.cb.call(this.scope);
        }
        return this;
    };
    /**
     * Copies x and y from the given point (`p`)
     *
     * @param p - The point to copy from. Can be any of type that is or extends `IPointData`
     * @returns The observable point instance itself
     */ ObservablePoint.prototype.copyFrom = function(p) {
        if (this._x !== p.x || this._y !== p.y) {
            this._x = p.x;
            this._y = p.y;
            this.cb.call(this.scope);
        }
        return this;
    };
    /**
     * Copies this point's x and y into that of the given point (`p`)
     *
     * @param p - The point to copy to. Can be any of type that is or extends `IPointData`
     * @returns The point (`p`) with values updated
     */ ObservablePoint.prototype.copyTo = function(p) {
        p.set(this._x, this._y);
        return p;
    };
    /**
     * Accepts another point (`p`) and returns `true` if the given point is equal to this point
     *
     * @param p - The point to check
     * @returns Returns `true` if both `x` and `y` are equal
     */ ObservablePoint.prototype.equals = function(p) {
        return p.x === this._x && p.y === this._y;
    };
    ObservablePoint.prototype.toString = function() {
        return "[@pixi/math:ObservablePoint x=0 y=0 scope=" + this.scope + "]";
    };
    Object.defineProperty(ObservablePoint.prototype, "x", {
        /** Position of the observable point on the x axis. */ get: function() {
            return this._x;
        },
        set: function(value) {
            if (this._x !== value) {
                this._x = value;
                this.cb.call(this.scope);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservablePoint.prototype, "y", {
        /** Position of the observable point on the y axis. */ get: function() {
            return this._y;
        },
        set: function(value) {
            if (this._y !== value) {
                this._y = value;
                this.cb.call(this.scope);
            }
        },
        enumerable: false,
        configurable: true
    });
    return ObservablePoint;
}();
/**
 * The PixiJS Matrix as a class makes it a lot faster.
 *
 * Here is a representation of it:
 * ```js
 * | a | c | tx|
 * | b | d | ty|
 * | 0 | 0 | 1 |
 * ```
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$5b12bf1653c0dd85 = /** @class */ function() {
    /**
     * @param a - x scale
     * @param b - y skew
     * @param c - x skew
     * @param d - y scale
     * @param tx - x translation
     * @param ty - y translation
     */ function Matrix(a, b, c, d, tx, ty) {
        if (a === void 0) a = 1;
        if (b === void 0) b = 0;
        if (c === void 0) c = 0;
        if (d === void 0) d = 1;
        if (tx === void 0) tx = 0;
        if (ty === void 0) ty = 0;
        this.array = null;
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
    }
    /**
     * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
     *
     * a = array[0]
     * b = array[1]
     * c = array[3]
     * d = array[4]
     * tx = array[2]
     * ty = array[5]
     *
     * @param array - The array that the matrix will be populated from.
     */ Matrix.prototype.fromArray = function(array) {
        this.a = array[0];
        this.b = array[1];
        this.c = array[3];
        this.d = array[4];
        this.tx = array[2];
        this.ty = array[5];
    };
    /**
     * Sets the matrix properties.
     *
     * @param a - Matrix component
     * @param b - Matrix component
     * @param c - Matrix component
     * @param d - Matrix component
     * @param tx - Matrix component
     * @param ty - Matrix component
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.set = function(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
        return this;
    };
    /**
     * Creates an array from the current Matrix object.
     *
     * @param transpose - Whether we need to transpose the matrix or not
     * @param [out=new Float32Array(9)] - If provided the array will be assigned to out
     * @return The newly created array which contains the matrix
     */ Matrix.prototype.toArray = function(transpose, out) {
        if (!this.array) this.array = new Float32Array(9);
        var array = out || this.array;
        if (transpose) {
            array[0] = this.a;
            array[1] = this.b;
            array[2] = 0;
            array[3] = this.c;
            array[4] = this.d;
            array[5] = 0;
            array[6] = this.tx;
            array[7] = this.ty;
            array[8] = 1;
        } else {
            array[0] = this.a;
            array[1] = this.c;
            array[2] = this.tx;
            array[3] = this.b;
            array[4] = this.d;
            array[5] = this.ty;
            array[6] = 0;
            array[7] = 0;
            array[8] = 1;
        }
        return array;
    };
    /**
     * Get a new position with the current transformation applied.
     * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
     *
     * @param pos - The origin
     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
     * @return {PIXI.Point} The new point, transformed through this matrix
     */ Matrix.prototype.apply = function(pos, newPos) {
        newPos = newPos || new $4ae0a6833d6839bf$export$baf26146a414f24a();
        var x = pos.x;
        var y = pos.y;
        newPos.x = this.a * x + this.c * y + this.tx;
        newPos.y = this.b * x + this.d * y + this.ty;
        return newPos;
    };
    /**
     * Get a new position with the inverse of the current transformation applied.
     * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
     *
     * @param pos - The origin
     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
     * @return {PIXI.Point} The new point, inverse-transformed through this matrix
     */ Matrix.prototype.applyInverse = function(pos, newPos) {
        newPos = newPos || new $4ae0a6833d6839bf$export$baf26146a414f24a();
        var id = 1 / (this.a * this.d + this.c * -this.b);
        var x = pos.x;
        var y = pos.y;
        newPos.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id;
        newPos.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id;
        return newPos;
    };
    /**
     * Translates the matrix on the x and y.
     *
     * @param x - How much to translate x by
     * @param y - How much to translate y by
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.translate = function(x, y) {
        this.tx += x;
        this.ty += y;
        return this;
    };
    /**
     * Applies a scale transformation to the matrix.
     *
     * @param x - The amount to scale horizontally
     * @param y - The amount to scale vertically
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.scale = function(x, y) {
        this.a *= x;
        this.d *= y;
        this.c *= x;
        this.b *= y;
        this.tx *= x;
        this.ty *= y;
        return this;
    };
    /**
     * Applies a rotation transformation to the matrix.
     *
     * @param angle - The angle in radians.
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.rotate = function(angle) {
        var cos = Math.cos(angle);
        var sin = Math.sin(angle);
        var a1 = this.a;
        var c1 = this.c;
        var tx1 = this.tx;
        this.a = a1 * cos - this.b * sin;
        this.b = a1 * sin + this.b * cos;
        this.c = c1 * cos - this.d * sin;
        this.d = c1 * sin + this.d * cos;
        this.tx = tx1 * cos - this.ty * sin;
        this.ty = tx1 * sin + this.ty * cos;
        return this;
    };
    /**
     * Appends the given Matrix to this Matrix.
     *
     * @param matrix - The matrix to append.
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.append = function(matrix) {
        var a1 = this.a;
        var b1 = this.b;
        var c1 = this.c;
        var d1 = this.d;
        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;
        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
        return this;
    };
    /**
     * Sets the matrix based on all the available properties
     *
     * @param x - Position on the x axis
     * @param y - Position on the y axis
     * @param pivotX - Pivot on the x axis
     * @param pivotY - Pivot on the y axis
     * @param scaleX - Scale on the x axis
     * @param scaleY - Scale on the y axis
     * @param rotation - Rotation in radians
     * @param skewX - Skew on the x axis
     * @param skewY - Skew on the y axis
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.setTransform = function(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        this.a = Math.cos(rotation + skewY) * scaleX;
        this.b = Math.sin(rotation + skewY) * scaleX;
        this.c = -Math.sin(rotation - skewX) * scaleY;
        this.d = Math.cos(rotation - skewX) * scaleY;
        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);
        return this;
    };
    /**
     * Prepends the given Matrix to this Matrix.
     *
     * @param matrix - The matrix to prepend
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.prepend = function(matrix) {
        var tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            var a1 = this.a;
            var c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }
        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
        return this;
    };
    /**
     * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
     *
     * @param transform - The transform to apply the properties to.
     * @return The transform with the newly applied properties
     */ Matrix.prototype.decompose = function(transform) {
        // sort out rotation / skew..
        var a = this.a;
        var b = this.b;
        var c = this.c;
        var d = this.d;
        var pivot = transform.pivot;
        var skewX = -Math.atan2(-c, d);
        var skewY = Math.atan2(b, a);
        var delta = Math.abs(skewX + skewY);
        if (delta < 0.00001 || Math.abs($4ae0a6833d6839bf$export$59ed0a0a5de1084b - delta) < 0.00001) {
            transform.rotation = skewY;
            transform.skew.x = transform.skew.y = 0;
        } else {
            transform.rotation = 0;
            transform.skew.x = skewX;
            transform.skew.y = skewY;
        }
        // next set scale
        transform.scale.x = Math.sqrt(a * a + b * b);
        transform.scale.y = Math.sqrt(c * c + d * d);
        // next set position
        transform.position.x = this.tx + (pivot.x * a + pivot.y * c);
        transform.position.y = this.ty + (pivot.x * b + pivot.y * d);
        return transform;
    };
    /**
     * Inverts this matrix
     *
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.invert = function() {
        var a1 = this.a;
        var b1 = this.b;
        var c1 = this.c;
        var d1 = this.d;
        var tx1 = this.tx;
        var n = a1 * d1 - b1 * c1;
        this.a = d1 / n;
        this.b = -b1 / n;
        this.c = -c1 / n;
        this.d = a1 / n;
        this.tx = (c1 * this.ty - d1 * tx1) / n;
        this.ty = -(a1 * this.ty - b1 * tx1) / n;
        return this;
    };
    /**
     * Resets this Matrix to an identity (default) matrix.
     *
     * @return This matrix. Good for chaining method calls.
     */ Matrix.prototype.identity = function() {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.tx = 0;
        this.ty = 0;
        return this;
    };
    /**
     * Creates a new Matrix object with the same values as this one.
     *
     * @return A copy of this matrix. Good for chaining method calls.
     */ Matrix.prototype.clone = function() {
        var matrix = new Matrix();
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    };
    /**
     * Changes the values of the given matrix to be the same as the ones in this matrix
     *
     * @param matrix - The matrix to copy to.
     * @return The matrix given in parameter with its values updated.
     */ Matrix.prototype.copyTo = function(matrix) {
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    };
    /**
     * Changes the values of the matrix to be the same as the ones in given matrix
     *
     * @param {PIXI.Matrix} matrix - The matrix to copy from.
     * @return {PIXI.Matrix} this
     */ Matrix.prototype.copyFrom = function(matrix) {
        this.a = matrix.a;
        this.b = matrix.b;
        this.c = matrix.c;
        this.d = matrix.d;
        this.tx = matrix.tx;
        this.ty = matrix.ty;
        return this;
    };
    Matrix.prototype.toString = function() {
        return "[@pixi/math:Matrix a=" + this.a + " b=" + this.b + " c=" + this.c + " d=" + this.d + " tx=" + this.tx + " ty=" + this.ty + "]";
    };
    Object.defineProperty(Matrix, "IDENTITY", {
        /**
         * A default (identity) matrix
         *
         * @readonly
         */ get: function() {
            return new Matrix();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Matrix, "TEMP_MATRIX", {
        /**
         * A temp matrix
         *
         * @readonly
         */ get: function() {
            return new Matrix();
        },
        enumerable: false,
        configurable: true
    });
    return Matrix;
}();
// Your friendly neighbour https://en.wikipedia.org/wiki/Dihedral_group
/*
 * Transform matrix for operation n is:
 * | ux | vx |
 * | uy | vy |
 */ var $4ae0a6833d6839bf$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
];
var $4ae0a6833d6839bf$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
var $4ae0a6833d6839bf$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
var $4ae0a6833d6839bf$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
];
/**
 * [Cayley Table]{@link https://en.wikipedia.org/wiki/Cayley_table}
 * for the composition of each rotation in the dihederal group D8.
 *
 * @type number[][]
 * @private
 */ var $4ae0a6833d6839bf$var$rotationCayley = [];
/**
 * Matrices for each `GD8Symmetry` rotation.
 *
 * @type Matrix[]
 * @private
 */ var $4ae0a6833d6839bf$var$rotationMatrices = [];
/*
 * Alias for {@code Math.sign}.
 */ var $4ae0a6833d6839bf$var$signum = Math.sign;
/*
 * Initializes `rotationCayley` and `rotationMatrices`. It is called
 * only once below.
 */ function $4ae0a6833d6839bf$var$init() {
    for(var i = 0; i < 16; i++){
        var row = [];
        $4ae0a6833d6839bf$var$rotationCayley.push(row);
        for(var j = 0; j < 16; j++){
            /* Multiplies rotation matrices i and j. */ var _ux = $4ae0a6833d6839bf$var$signum($4ae0a6833d6839bf$var$ux[i] * $4ae0a6833d6839bf$var$ux[j] + $4ae0a6833d6839bf$var$vx[i] * $4ae0a6833d6839bf$var$uy[j]);
            var _uy = $4ae0a6833d6839bf$var$signum($4ae0a6833d6839bf$var$uy[i] * $4ae0a6833d6839bf$var$ux[j] + $4ae0a6833d6839bf$var$vy[i] * $4ae0a6833d6839bf$var$uy[j]);
            var _vx = $4ae0a6833d6839bf$var$signum($4ae0a6833d6839bf$var$ux[i] * $4ae0a6833d6839bf$var$vx[j] + $4ae0a6833d6839bf$var$vx[i] * $4ae0a6833d6839bf$var$vy[j]);
            var _vy = $4ae0a6833d6839bf$var$signum($4ae0a6833d6839bf$var$uy[i] * $4ae0a6833d6839bf$var$vx[j] + $4ae0a6833d6839bf$var$vy[i] * $4ae0a6833d6839bf$var$vy[j]);
            /* Finds rotation matrix matching the product and pushes it. */ for(var k = 0; k < 16; k++)if ($4ae0a6833d6839bf$var$ux[k] === _ux && $4ae0a6833d6839bf$var$uy[k] === _uy && $4ae0a6833d6839bf$var$vx[k] === _vx && $4ae0a6833d6839bf$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(var i = 0; i < 16; i++){
        var mat = new $4ae0a6833d6839bf$export$5b12bf1653c0dd85();
        mat.set($4ae0a6833d6839bf$var$ux[i], $4ae0a6833d6839bf$var$uy[i], $4ae0a6833d6839bf$var$vx[i], $4ae0a6833d6839bf$var$vy[i], 0, 0);
        $4ae0a6833d6839bf$var$rotationMatrices.push(mat);
    }
}
$4ae0a6833d6839bf$var$init();
/**
 * @memberof PIXI
 * @typedef {number} GD8Symmetry
 * @see PIXI.groupD8
 */ /**
 * Implements the dihedral group D8, which is similar to
 * [group D4]{@link http://mathworld.wolfram.com/DihedralGroupD4.html};
 * D8 is the same but with diagonals, and it is used for texture
 * rotations.
 *
 * The directions the U- and V- axes after rotation
 * of an angle of `a: GD8Constant` are the vectors `(uX(a), uY(a))`
 * and `(vX(a), vY(a))`. These aren't necessarily unit vectors.
 *
 * **Origin:**<br>
 *  This is the small part of gameofbombs.com portal system. It works.
 *
 * @see PIXI.groupD8.E
 * @see PIXI.groupD8.SE
 * @see PIXI.groupD8.S
 * @see PIXI.groupD8.SW
 * @see PIXI.groupD8.W
 * @see PIXI.groupD8.NW
 * @see PIXI.groupD8.N
 * @see PIXI.groupD8.NE
 * @author Ivan @ivanpopelyshev
 * @namespace PIXI.groupD8
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$b7bb6a2a8d203102 = {
    /**
     * | Rotation | Direction |
     * |----------|-----------|
     * | 0°       | East      |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ E: 0,
    /**
     * | Rotation | Direction |
     * |----------|-----------|
     * | 45°↻     | Southeast |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ SE: 1,
    /**
     * | Rotation | Direction |
     * |----------|-----------|
     * | 90°↻     | South     |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ S: 2,
    /**
     * | Rotation | Direction |
     * |----------|-----------|
     * | 135°↻    | Southwest |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ SW: 3,
    /**
     * | Rotation | Direction |
     * |----------|-----------|
     * | 180°     | West      |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ W: 4,
    /**
     * | Rotation    | Direction    |
     * |-------------|--------------|
     * | -135°/225°↻ | Northwest    |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ NW: 5,
    /**
     * | Rotation    | Direction    |
     * |-------------|--------------|
     * | -90°/270°↻  | North        |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ N: 6,
    /**
     * | Rotation    | Direction    |
     * |-------------|--------------|
     * | -45°/315°↻  | Northeast    |
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ NE: 7,
    /**
     * Reflection about Y-axis.
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ MIRROR_VERTICAL: 8,
    /**
     * Reflection about the main diagonal.
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ MAIN_DIAGONAL: 10,
    /**
     * Reflection about X-axis.
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ MIRROR_HORIZONTAL: 12,
    /**
     * Reflection about reverse diagonal.
     *
     * @memberof PIXI.groupD8
     * @constant {PIXI.GD8Symmetry}
     */ REVERSE_DIAGONAL: 14,
    /**
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
     * @return {PIXI.GD8Symmetry} The X-component of the U-axis
     *    after rotating the axes.
     */ uX: function(ind) {
        return $4ae0a6833d6839bf$var$ux[ind];
    },
    /**
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
     * @return {PIXI.GD8Symmetry} The Y-component of the U-axis
     *    after rotating the axes.
     */ uY: function(ind) {
        return $4ae0a6833d6839bf$var$uy[ind];
    },
    /**
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
     * @return {PIXI.GD8Symmetry} The X-component of the V-axis
     *    after rotating the axes.
     */ vX: function(ind) {
        return $4ae0a6833d6839bf$var$vx[ind];
    },
    /**
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} ind - sprite rotation angle.
     * @return {PIXI.GD8Symmetry} The Y-component of the V-axis
     *    after rotating the axes.
     */ vY: function(ind) {
        return $4ae0a6833d6839bf$var$vy[ind];
    },
    /**
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} rotation - symmetry whose opposite
     *   is needed. Only rotations have opposite symmetries while
     *   reflections don't.
     * @return {PIXI.GD8Symmetry} The opposite symmetry of `rotation`
     */ inv: function(rotation) {
        if (rotation & 8) return rotation & 15; // or rotation % 16
        return -rotation & 7; // or (8 - rotation) % 8
    },
    /**
     * Composes the two D8 operations.
     *
     * Taking `^` as reflection:
     *
     * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
     * |-------|-----|-----|-----|-----|------|-------|-------|-------|
     * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
     * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
     * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
     * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
     * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
     * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
     * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
     * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
     *
     * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} rotationSecond - Second operation, which
     *   is the row in the above cayley table.
     * @param {PIXI.GD8Symmetry} rotationFirst - First operation, which
     *   is the column in the above cayley table.
     * @return {PIXI.GD8Symmetry} Composed operation
     */ add: function(rotationSecond, rotationFirst) {
        return $4ae0a6833d6839bf$var$rotationCayley[rotationSecond][rotationFirst];
    },
    /**
     * Reverse of `add`.
     *
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} rotationSecond - Second operation
     * @param {PIXI.GD8Symmetry} rotationFirst - First operation
     * @return {PIXI.GD8Symmetry} Result
     */ sub: function(rotationSecond, rotationFirst) {
        return $4ae0a6833d6839bf$var$rotationCayley[rotationSecond][$4ae0a6833d6839bf$export$b7bb6a2a8d203102.inv(rotationFirst)];
    },
    /**
     * Adds 180 degrees to rotation, which is a commutative
     * operation.
     *
     * @memberof PIXI.groupD8
     * @param {number} rotation - The number to rotate.
     * @returns {number} Rotated number
     */ rotate180: function(rotation) {
        return rotation ^ 4;
    },
    /**
     * Checks if the rotation angle is vertical, i.e. south
     * or north. It doesn't work for reflections.
     *
     * @memberof PIXI.groupD8
     * @param {PIXI.GD8Symmetry} rotation - The number to check.
     * @returns {boolean} Whether or not the direction is vertical
     */ isVertical: function(rotation) {
        return (rotation & 3) === 2;
    },
    /**
     * Approximates the vector `V(dx,dy)` into one of the
     * eight directions provided by `groupD8`.
     *
     * @memberof PIXI.groupD8
     * @param {number} dx - X-component of the vector
     * @param {number} dy - Y-component of the vector
     * @return {PIXI.GD8Symmetry} Approximation of the vector into
     *  one of the eight symmetries.
     */ byDirection: function(dx, dy) {
        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
            if (dy >= 0) return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.S;
            return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.N;
        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
            if (dx > 0) return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.E;
            return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.W;
        } else if (dy > 0) {
            if (dx > 0) return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.SE;
            return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.SW;
        } else if (dx > 0) return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.NE;
        return $4ae0a6833d6839bf$export$b7bb6a2a8d203102.NW;
    },
    /**
     * Helps sprite to compensate texture packer rotation.
     *
     * @memberof PIXI.groupD8
     * @param {PIXI.Matrix} matrix - sprite world matrix
     * @param {PIXI.GD8Symmetry} rotation - The rotation factor to use.
     * @param {number} tx - sprite anchoring
     * @param {number} ty - sprite anchoring
     */ matrixAppendRotationInv: function(matrix, rotation, tx, ty) {
        if (tx === void 0) tx = 0;
        if (ty === void 0) ty = 0;
        // Packer used "rotation", we use "inv(rotation)"
        var mat = $4ae0a6833d6839bf$var$rotationMatrices[$4ae0a6833d6839bf$export$b7bb6a2a8d203102.inv(rotation)];
        mat.tx = tx;
        mat.ty = ty;
        matrix.append(mat);
    }
};
/**
 * Transform that takes care about its versions.
 *
 * @memberof PIXI
 */ var $4ae0a6833d6839bf$export$563a914cafbdc389 = /** @class */ function() {
    function Transform() {
        this.worldTransform = new $4ae0a6833d6839bf$export$5b12bf1653c0dd85();
        this.localTransform = new $4ae0a6833d6839bf$export$5b12bf1653c0dd85();
        this.position = new $4ae0a6833d6839bf$export$3755aaad3fd42e52(this.onChange, this, 0, 0);
        this.scale = new $4ae0a6833d6839bf$export$3755aaad3fd42e52(this.onChange, this, 1, 1);
        this.pivot = new $4ae0a6833d6839bf$export$3755aaad3fd42e52(this.onChange, this, 0, 0);
        this.skew = new $4ae0a6833d6839bf$export$3755aaad3fd42e52(this.updateSkew, this, 0, 0);
        this._rotation = 0;
        this._cx = 1;
        this._sx = 0;
        this._cy = 0;
        this._sy = 1;
        this._localID = 0;
        this._currentLocalID = 0;
        this._worldID = 0;
        this._parentID = 0;
    }
    /** Called when a value changes. */ Transform.prototype.onChange = function() {
        this._localID++;
    };
    /** Called when the skew or the rotation changes. */ Transform.prototype.updateSkew = function() {
        this._cx = Math.cos(this._rotation + this.skew.y);
        this._sx = Math.sin(this._rotation + this.skew.y);
        this._cy = -Math.sin(this._rotation - this.skew.x); // cos, added PI/2
        this._sy = Math.cos(this._rotation - this.skew.x); // sin, added PI/2
        this._localID++;
    };
    Transform.prototype.toString = function() {
        return "[@pixi/math:Transform " + ("position=(" + this.position.x + ", " + this.position.y + ") ") + ("rotation=" + this.rotation + " ") + ("scale=(" + this.scale.x + ", " + this.scale.y + ") ") + ("skew=(" + this.skew.x + ", " + this.skew.y + ") ") + "]";
    };
    /** Updates the local transformation matrix. */ Transform.prototype.updateLocalTransform = function() {
        var lt = this.localTransform;
        if (this._localID !== this._currentLocalID) {
            // get the matrix values of the displayobject based on its transform properties..
            lt.a = this._cx * this.scale.x;
            lt.b = this._sx * this.scale.x;
            lt.c = this._cy * this.scale.y;
            lt.d = this._sy * this.scale.y;
            lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
            lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
            this._currentLocalID = this._localID;
            // force an update..
            this._parentID = -1;
        }
    };
    /**
     * Updates the local and the world transformation matrices.
     *
     * @param parentTransform - The parent transform
     */ Transform.prototype.updateTransform = function(parentTransform) {
        var lt = this.localTransform;
        if (this._localID !== this._currentLocalID) {
            // get the matrix values of the displayobject based on its transform properties..
            lt.a = this._cx * this.scale.x;
            lt.b = this._sx * this.scale.x;
            lt.c = this._cy * this.scale.y;
            lt.d = this._sy * this.scale.y;
            lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
            lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
            this._currentLocalID = this._localID;
            // force an update..
            this._parentID = -1;
        }
        if (this._parentID !== parentTransform._worldID) {
            // concat the parent matrix with the objects transform.
            var pt = parentTransform.worldTransform;
            var wt = this.worldTransform;
            wt.a = lt.a * pt.a + lt.b * pt.c;
            wt.b = lt.a * pt.b + lt.b * pt.d;
            wt.c = lt.c * pt.a + lt.d * pt.c;
            wt.d = lt.c * pt.b + lt.d * pt.d;
            wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
            wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;
            this._parentID = parentTransform._worldID;
            // update the id of the transform..
            this._worldID++;
        }
    };
    /**
     * Decomposes a matrix and sets the transforms properties based on it.
     *
     * @param matrix - The matrix to decompose
     */ Transform.prototype.setFromMatrix = function(matrix) {
        matrix.decompose(this);
        this._localID++;
    };
    Object.defineProperty(Transform.prototype, "rotation", {
        /** The rotation of the object in radians. */ get: function() {
            return this._rotation;
        },
        set: function(value) {
            if (this._rotation !== value) {
                this._rotation = value;
                this.updateSkew();
            }
        },
        enumerable: false,
        configurable: true
    });
    /** A default (identity) transform. */ Transform.IDENTITY = new Transform();
    return Transform;
}();

});



parcelRegister("5q3yV", function(module, exports) {

$parcel$export(module.exports, "InteractionData", function () { return $3f2224d8df498ec4$export$73b9be86c227b464; });
$parcel$export(module.exports, "InteractionEvent", function () { return $3f2224d8df498ec4$export$5b6496a0e009b82d; });
$parcel$export(module.exports, "InteractionTrackingData", function () { return $3f2224d8df498ec4$export$656983b0c6f240c; });
$parcel$export(module.exports, "interactiveTarget", function () { return $3f2224d8df498ec4$export$90530c38f30e38c5; });
$parcel$export(module.exports, "InteractionManager", function () { return $3f2224d8df498ec4$export$aaa80641d584351c; });
/*!
 * @pixi/interaction - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/interaction is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $6qzqq = parcelRequire("6qzqq");

var $3YyWq = parcelRequire("3YyWq");

var $8t5Gy = parcelRequire("8t5Gy");
parcelRequire("csytw");
var $6p5EE = parcelRequire("6p5EE");
/**
 * Holds all information related to an Interaction event
 *
 * @class
 * @memberof PIXI
 */ var $3f2224d8df498ec4$export$73b9be86c227b464 = /** @class */ function() {
    function InteractionData() {
        this.pressure = 0;
        this.rotationAngle = 0;
        this.twist = 0;
        this.tangentialPressure = 0;
        /**
         * This point stores the global coords of where the touch/mouse event happened
         *
         * @member {PIXI.Point}
         */ this.global = new (0, $6qzqq.Point)();
        /**
         * The target Sprite that was interacted with
         *
         * @member {PIXI.Sprite}
         */ this.target = null;
        /**
         * When passed to an event handler, this will be the original DOM Event that was captured
         *
         * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent
         * @see https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent
         * @member {MouseEvent|TouchEvent|PointerEvent}
         */ this.originalEvent = null;
        /**
         * Unique identifier for this interaction
         *
         * @member {number}
         */ this.identifier = null;
        /**
         * Indicates whether or not the pointer device that created the event is the primary pointer.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/isPrimary
         * @type {Boolean}
         */ this.isPrimary = false;
        /**
         * Indicates which button was pressed on the mouse or pointer device to trigger the event.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
         * @type {number}
         */ this.button = 0;
        /**
         * Indicates which buttons are pressed on the mouse or pointer device when the event is triggered.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
         * @type {number}
         */ this.buttons = 0;
        /**
         * The width of the pointer's contact along the x-axis, measured in CSS pixels.
         * radiusX of TouchEvents will be represented by this value.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/width
         * @type {number}
         */ this.width = 0;
        /**
         * The height of the pointer's contact along the y-axis, measured in CSS pixels.
         * radiusY of TouchEvents will be represented by this value.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/height
         * @type {number}
         */ this.height = 0;
        /**
         * The angle, in degrees, between the pointer device and the screen.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltX
         * @type {number}
         */ this.tiltX = 0;
        /**
         * The angle, in degrees, between the pointer device and the screen.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltY
         * @type {number}
         */ this.tiltY = 0;
        /**
         * The type of pointer that triggered the event.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerType
         * @type {string}
         */ this.pointerType = null;
        /**
         * Pressure applied by the pointing device during the event. A Touch's force property
         * will be represented by this value.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pressure
         * @type {number}
         */ this.pressure = 0;
        /**
         * From TouchEvents (not PointerEvents triggered by touches), the rotationAngle of the Touch.
         * @see https://developer.mozilla.org/en-US/docs/Web/API/Touch/rotationAngle
         * @type {number}
         */ this.rotationAngle = 0;
        /**
         * Twist of a stylus pointer.
         * @see https://w3c.github.io/pointerevents/#pointerevent-interface
         * @type {number}
         */ this.twist = 0;
        /**
         * Barrel pressure on a stylus pointer.
         * @see https://w3c.github.io/pointerevents/#pointerevent-interface
         * @type {number}
         */ this.tangentialPressure = 0;
    }
    Object.defineProperty(InteractionData.prototype, "pointerId", {
        /**
         * The unique identifier of the pointer. It will be the same as `identifier`.
         * @readonly
         * @member {number}
         * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerId
         */ get: function() {
            return this.identifier;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * This will return the local coordinates of the specified displayObject for this InteractionData
     *
     * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
     *  coords off
     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional (otherwise
     *  will create a new point)
     * @param {PIXI.Point} [globalPos] - A Point object containing your custom global coords, optional
     *  (otherwise will use the current global coords)
     * @return {PIXI.Point} A point containing the coordinates of the InteractionData position relative
     *  to the DisplayObject
     */ InteractionData.prototype.getLocalPosition = function(displayObject, point, globalPos) {
        return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
    };
    /**
     * Copies properties from normalized event data.
     *
     * @param {Touch|MouseEvent|PointerEvent} event - The normalized event data
     */ InteractionData.prototype.copyEvent = function(event) {
        // isPrimary should only change on touchstart/pointerdown, so we don't want to overwrite
        // it with "false" on later events when our shim for it on touch events might not be
        // accurate
        if ('isPrimary' in event && event.isPrimary) this.isPrimary = true;
        this.button = 'button' in event && event.button;
        // event.buttons is not available in all browsers (ie. Safari), but it does have a non-standard
        // event.which property instead, which conveys the same information.
        var buttons = 'buttons' in event && event.buttons;
        this.buttons = Number.isInteger(buttons) ? buttons : 'which' in event && event.which;
        this.width = 'width' in event && event.width;
        this.height = 'height' in event && event.height;
        this.tiltX = 'tiltX' in event && event.tiltX;
        this.tiltY = 'tiltY' in event && event.tiltY;
        this.pointerType = 'pointerType' in event && event.pointerType;
        this.pressure = 'pressure' in event && event.pressure;
        this.rotationAngle = 'rotationAngle' in event && event.rotationAngle;
        this.twist = 'twist' in event && event.twist || 0;
        this.tangentialPressure = 'tangentialPressure' in event && event.tangentialPressure || 0;
    };
    /**
     * Resets the data for pooling.
     */ InteractionData.prototype.reset = function() {
        // isPrimary is the only property that we really need to reset - everything else is
        // guaranteed to be overwritten
        this.isPrimary = false;
    };
    return InteractionData;
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $3f2224d8df498ec4$var$extendStatics = function(d, b) {
    $3f2224d8df498ec4$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $3f2224d8df498ec4$var$extendStatics(d, b);
};
function $3f2224d8df498ec4$var$__extends(d, b) {
    $3f2224d8df498ec4$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * Event class that mimics native DOM events.
 *
 * @class
 * @memberof PIXI
 */ var $3f2224d8df498ec4$export$5b6496a0e009b82d = /** @class */ function() {
    function InteractionEvent() {
        /**
         * Whether this event will continue propagating in the tree.
         *
         * Remaining events for the {@link stopsPropagatingAt} object
         * will still be dispatched.
         *
         * @member {boolean}
         */ this.stopped = false;
        /**
         * At which object this event stops propagating.
         *
         * @private
         * @member {PIXI.DisplayObject}
         */ this.stopsPropagatingAt = null;
        /**
         * Whether we already reached the element we want to
         * stop propagating at. This is important for delayed events,
         * where we start over deeper in the tree again.
         *
         * @private
         * @member {boolean}
         */ this.stopPropagationHint = false;
        /**
         * The object which caused this event to be dispatched.
         * For listener callback see {@link PIXI.InteractionEvent.currentTarget}.
         *
         * @member {PIXI.DisplayObject}
         */ this.target = null;
        /**
         * The object whose event listener’s callback is currently being invoked.
         *
         * @member {PIXI.DisplayObject}
         */ this.currentTarget = null;
        /**
         * Type of the event
         *
         * @member {string}
         */ this.type = null;
        /**
         * InteractionData related to this event
         *
         * @member {PIXI.InteractionData}
         */ this.data = null;
    }
    /**
     * Prevents event from reaching any objects other than the current object.
     *
     */ InteractionEvent.prototype.stopPropagation = function() {
        this.stopped = true;
        this.stopPropagationHint = true;
        this.stopsPropagatingAt = this.currentTarget;
    };
    /**
     * Resets the event.
     */ InteractionEvent.prototype.reset = function() {
        this.stopped = false;
        this.stopsPropagatingAt = null;
        this.stopPropagationHint = false;
        this.currentTarget = null;
        this.target = null;
    };
    return InteractionEvent;
}();
/**
 * DisplayObjects with the {@link PIXI.interactiveTarget} mixin use this class to track interactions
 *
 * @class
 * @private
 * @memberof PIXI
 */ var $3f2224d8df498ec4$export$656983b0c6f240c = /** @class */ function() {
    /**
     * @param {number} pointerId - Unique pointer id of the event
     * @private
     */ function InteractionTrackingData(pointerId) {
        this._pointerId = pointerId;
        this._flags = InteractionTrackingData.FLAGS.NONE;
    }
    /**
     *
     * @private
     * @param {number} flag - The interaction flag to set
     * @param {boolean} yn - Should the flag be set or unset
     */ InteractionTrackingData.prototype._doSet = function(flag, yn) {
        if (yn) this._flags = this._flags | flag;
        else this._flags = this._flags & ~flag;
    };
    Object.defineProperty(InteractionTrackingData.prototype, "pointerId", {
        /**
         * Unique pointer id of the event
         *
         * @readonly
         * @private
         * @member {number}
         */ get: function() {
            return this._pointerId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractionTrackingData.prototype, "flags", {
        /**
         * State of the tracking data, expressed as bit flags
         *
         * @private
         * @member {number}
         */ get: function() {
            return this._flags;
        },
        set: function(flags) {
            this._flags = flags;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractionTrackingData.prototype, "none", {
        /**
         * Is the tracked event inactive (not over or down)?
         *
         * @private
         * @member {number}
         */ get: function() {
            return this._flags === InteractionTrackingData.FLAGS.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractionTrackingData.prototype, "over", {
        /**
         * Is the tracked event over the DisplayObject?
         *
         * @private
         * @member {boolean}
         */ get: function() {
            return (this._flags & InteractionTrackingData.FLAGS.OVER) !== 0;
        },
        set: function(yn) {
            this._doSet(InteractionTrackingData.FLAGS.OVER, yn);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractionTrackingData.prototype, "rightDown", {
        /**
         * Did the right mouse button come down in the DisplayObject?
         *
         * @private
         * @member {boolean}
         */ get: function() {
            return (this._flags & InteractionTrackingData.FLAGS.RIGHT_DOWN) !== 0;
        },
        set: function(yn) {
            this._doSet(InteractionTrackingData.FLAGS.RIGHT_DOWN, yn);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractionTrackingData.prototype, "leftDown", {
        /**
         * Did the left mouse button come down in the DisplayObject?
         *
         * @private
         * @member {boolean}
         */ get: function() {
            return (this._flags & InteractionTrackingData.FLAGS.LEFT_DOWN) !== 0;
        },
        set: function(yn) {
            this._doSet(InteractionTrackingData.FLAGS.LEFT_DOWN, yn);
        },
        enumerable: false,
        configurable: true
    });
    InteractionTrackingData.FLAGS = Object.freeze({
        NONE: 0,
        OVER: 1,
        LEFT_DOWN: 2,
        RIGHT_DOWN: 4
    });
    return InteractionTrackingData;
}();
/**
 * Strategy how to search through stage tree for interactive objects
 *
 * @private
 * @class
 * @memberof PIXI
 */ var $3f2224d8df498ec4$var$TreeSearch = /** @class */ function() {
    function TreeSearch() {
        this._tempPoint = new (0, $6qzqq.Point)();
    }
    /**
     * Recursive implementation for findHit
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - event containing the point that
     *  is tested for collision
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the displayObject
     *  that will be hit test (recursively crawls its children)
     * @param {Function} [func] - the function that will be called on each interactive object. The
     *  interactionEvent, displayObject and hit will be passed to the function
     * @param {boolean} [hitTest] - this indicates if the objects inside should be hit test against the point
     * @param {boolean} [interactive] - Whether the displayObject is interactive
     * @return {boolean} returns true if the displayObject hit the point
     */ TreeSearch.prototype.recursiveFindHit = function(interactionEvent, displayObject, func, hitTest, interactive) {
        if (!displayObject || !displayObject.visible) return false;
        var point = interactionEvent.data.global;
        // Took a little while to rework this function correctly! But now it is done and nice and optimized! ^_^
        //
        // This function will now loop through all objects and then only hit test the objects it HAS
        // to, not all of them. MUCH faster..
        // An object will be hit test if the following is true:
        //
        // 1: It is interactive.
        // 2: It belongs to a parent that is interactive AND one of the parents children have not already been hit.
        //
        // As another little optimization once an interactive object has been hit we can carry on
        // through the scenegraph, but we know that there will be no more hits! So we can avoid extra hit tests
        // A final optimization is that an object is not hit test directly if a child has already been hit.
        interactive = displayObject.interactive || interactive;
        var hit = false;
        var interactiveParent = interactive;
        // Flag here can set to false if the event is outside the parents hitArea or mask
        var hitTestChildren = true;
        // If there is a hitArea, no need to test against anything else if the pointer is not within the hitArea
        // There is also no longer a need to hitTest children.
        if (displayObject.hitArea) {
            if (hitTest) {
                displayObject.worldTransform.applyInverse(point, this._tempPoint);
                if (!displayObject.hitArea.contains(this._tempPoint.x, this._tempPoint.y)) {
                    hitTest = false;
                    hitTestChildren = false;
                } else hit = true;
            }
            interactiveParent = false;
        } else if (displayObject._mask) {
            if (hitTest) {
                if (!(displayObject._mask.containsPoint && displayObject._mask.containsPoint(point))) hitTest = false;
            }
        }
        // ** FREE TIP **! If an object is not interactive or has no buttons in it
        // (such as a game scene!) set interactiveChildren to false for that displayObject.
        // This will allow PixiJS to completely ignore and bypass checking the displayObjects children.
        if (hitTestChildren && displayObject.interactiveChildren && displayObject.children) {
            var children = displayObject.children;
            for(var i = children.length - 1; i >= 0; i--){
                var child = children[i];
                // time to get recursive.. if this function will return if something is hit..
                var childHit = this.recursiveFindHit(interactionEvent, child, func, hitTest, interactiveParent);
                if (childHit) {
                    // its a good idea to check if a child has lost its parent.
                    // this means it has been removed whilst looping so its best
                    if (!child.parent) continue;
                    // we no longer need to hit test any more objects in this container as we we
                    // now know the parent has been hit
                    interactiveParent = false;
                    // If the child is interactive , that means that the object hit was actually
                    // interactive and not just the child of an interactive object.
                    // This means we no longer need to hit test anything else. We still need to run
                    // through all objects, but we don't need to perform any hit tests.
                    if (childHit) {
                        if (interactionEvent.target) hitTest = false;
                        hit = true;
                    }
                }
            }
        }
        // no point running this if the item is not interactive or does not have an interactive parent.
        if (interactive) {
            // if we are hit testing (as in we have no hit any objects yet)
            // We also don't need to worry about hit testing if once of the displayObjects children
            // has already been hit - but only if it was interactive, otherwise we need to keep
            // looking for an interactive child, just in case we hit one
            if (hitTest && !interactionEvent.target) {
                // already tested against hitArea if it is defined
                if (!displayObject.hitArea && displayObject.containsPoint) {
                    if (displayObject.containsPoint(point)) hit = true;
                }
            }
            if (displayObject.interactive) {
                if (hit && !interactionEvent.target) interactionEvent.target = displayObject;
                if (func) func(interactionEvent, displayObject, !!hit);
            }
        }
        return hit;
    };
    /**
     * This function is provides a neat way of crawling through the scene graph and running a
     * specified function on all interactive objects it finds. It will also take care of hit
     * testing the interactive objects and passes the hit across in the function.
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - event containing the point that
     *  is tested for collision
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the displayObject
     *  that will be hit test (recursively crawls its children)
     * @param {Function} [func] - the function that will be called on each interactive object. The
     *  interactionEvent, displayObject and hit will be passed to the function
     * @param {boolean} [hitTest] - this indicates if the objects inside should be hit test against the point
     * @return {boolean} returns true if the displayObject hit the point
     */ TreeSearch.prototype.findHit = function(interactionEvent, displayObject, func, hitTest) {
        this.recursiveFindHit(interactionEvent, displayObject, func, hitTest, false);
    };
    return TreeSearch;
}();
/**
 * Interface for classes that represent a hit area.
 *
 * It is implemented by the following classes:
 * - {@link PIXI.Circle}
 * - {@link PIXI.Ellipse}
 * - {@link PIXI.Polygon}
 * - {@link PIXI.RoundedRectangle}
 *
 * @interface IHitArea
 * @memberof PIXI
 */ /**
 * Checks whether the x and y coordinates given are contained within this area
 *
 * @method
 * @name contains
 * @memberof PIXI.IHitArea#
 * @param {number} x - The X coordinate of the point to test
 * @param {number} y - The Y coordinate of the point to test
 * @return {boolean} Whether the x/y coordinates are within this area
 */ /**
 * Default property values of interactive objects
 * Used by {@link PIXI.InteractionManager} to automatically give all DisplayObjects these properties
 *
 * @private
 * @name interactiveTarget
 * @type {Object}
 * @memberof PIXI
 * @example
 *      function MyObject() {}
 *
 *      Object.assign(
 *          DisplayObject.prototype,
 *          PIXI.interactiveTarget
 *      );
 */ var $3f2224d8df498ec4$export$90530c38f30e38c5 = {
    interactive: false,
    interactiveChildren: true,
    hitArea: null,
    /**
     * If enabled, the mouse cursor use the pointer behavior when hovered over the displayObject if it is interactive
     * Setting this changes the 'cursor' property to `'pointer'`.
     *
     * @example
     * const sprite = new PIXI.Sprite(texture);
     * sprite.interactive = true;
     * sprite.buttonMode = true;
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     */ get buttonMode () {
        return this.cursor === 'pointer';
    },
    set buttonMode (value){
        if (value) this.cursor = 'pointer';
        else if (this.cursor === 'pointer') this.cursor = null;
    },
    /**
     * This defines what cursor mode is used when the mouse cursor
     * is hovered over the displayObject.
     *
     * @example
     * const sprite = new PIXI.Sprite(texture);
     * sprite.interactive = true;
     * sprite.cursor = 'wait';
     * @see https://developer.mozilla.org/en/docs/Web/CSS/cursor
     *
     * @member {string}
     * @memberof PIXI.DisplayObject#
     */ cursor: null,
    /**
     * Internal set of all active pointers, by identifier
     *
     * @member {Map<number, InteractionTrackingData>}
     * @memberof PIXI.DisplayObject#
     * @private
     */ get trackedPointers () {
        if (this._trackedPointers === undefined) this._trackedPointers = {};
        return this._trackedPointers;
    },
    /**
     * Map of all tracked pointers, by identifier. Use trackedPointers to access.
     *
     * @private
     * @type {Map<number, InteractionTrackingData>}
     */ _trackedPointers: undefined
};
// Mix interactiveTarget into DisplayObject.prototype
(0, $8t5Gy.DisplayObject).mixin($3f2224d8df498ec4$export$90530c38f30e38c5);
var $3f2224d8df498ec4$var$MOUSE_POINTER_ID = 1;
// helpers for hitTest() - only used inside hitTest()
var $3f2224d8df498ec4$var$hitTestEvent = {
    target: null,
    data: {
        global: null
    }
};
/**
 * The interaction manager deals with mouse, touch and pointer events.
 *
 * Any DisplayObject can be interactive if its `interactive` property is set to true.
 *
 * This manager also supports multitouch.
 *
 * An instance of this class is automatically created by default, and can be found at `renderer.plugins.interaction`
 *
 * @class
 * @extends PIXI.utils.EventEmitter
 * @memberof PIXI
 */ var $3f2224d8df498ec4$export$aaa80641d584351c = /** @class */ function(_super) {
    $3f2224d8df498ec4$var$__extends(InteractionManager, _super);
    /**
     * @param {PIXI.CanvasRenderer|PIXI.Renderer} renderer - A reference to the current renderer
     * @param {object} [options] - The options for the manager.
     * @param {boolean} [options.autoPreventDefault=true] - Should the manager automatically prevent default browser actions.
     * @param {number} [options.interactionFrequency=10] - Maximum frequency (ms) at pointer over/out states will be checked.
     * @param {number} [options.useSystemTicker=true] - Whether to add {@link tickerUpdate} to {@link PIXI.Ticker.system}.
     */ function InteractionManager(renderer, options) {
        var _this = _super.call(this) || this;
        options = options || {};
        /**
         * The renderer this interaction manager works for.
         *
         * @member {PIXI.AbstractRenderer}
         */ _this.renderer = renderer;
        /**
         * Should default browser actions automatically be prevented.
         * Does not apply to pointer events for backwards compatibility
         * preventDefault on pointer events stops mouse events from firing
         * Thus, for every pointer event, there will always be either a mouse of touch event alongside it.
         *
         * @member {boolean}
         * @default true
         */ _this.autoPreventDefault = options.autoPreventDefault !== undefined ? options.autoPreventDefault : true;
        /**
         * Maximum frequency in milliseconds at which pointer over/out states will be checked by {@link tickerUpdate}.
         *
         * @member {number}
         * @default 10
         */ _this.interactionFrequency = options.interactionFrequency || 10;
        /**
         * The mouse data
         *
         * @member {PIXI.InteractionData}
         */ _this.mouse = new $3f2224d8df498ec4$export$73b9be86c227b464();
        _this.mouse.identifier = $3f2224d8df498ec4$var$MOUSE_POINTER_ID;
        // setting the mouse to start off far off screen will mean that mouse over does
        //  not get called before we even move the mouse.
        _this.mouse.global.set(-999999);
        /**
         * Actively tracked InteractionData
         *
         * @private
         * @member {Object.<number,PIXI.InteractionData>}
         */ _this.activeInteractionData = {};
        _this.activeInteractionData[$3f2224d8df498ec4$var$MOUSE_POINTER_ID] = _this.mouse;
        /**
         * Pool of unused InteractionData
         *
         * @private
         * @member {PIXI.InteractionData[]}
         */ _this.interactionDataPool = [];
        /**
         * An event data object to handle all the event tracking/dispatching
         *
         * @member {object}
         */ _this.eventData = new $3f2224d8df498ec4$export$5b6496a0e009b82d();
        /**
         * The DOM element to bind to.
         *
         * @protected
         * @member {HTMLElement}
         */ _this.interactionDOMElement = null;
        /**
         * This property determines if mousemove and touchmove events are fired only when the cursor
         * is over the object.
         * Setting to true will make things work more in line with how the DOM version works.
         * Setting to false can make things easier for things like dragging
         * It is currently set to false as this is how PixiJS used to work. This will be set to true in
         * future versions of pixi.
         *
         * @member {boolean}
         * @default false
         */ _this.moveWhenInside = false;
        /**
         * Have events been attached to the dom element?
         *
         * @protected
         * @member {boolean}
         */ _this.eventsAdded = false;
        /**
         * Has the system ticker been added?
         *
         * @protected
         * @member {boolean}
         */ _this.tickerAdded = false;
        /**
         * Is the mouse hovering over the renderer? If working in worker mouse considered to be over renderer by default.
         *
         * @protected
         * @member {boolean}
         */ _this.mouseOverRenderer = !('PointerEvent' in self);
        /**
         * Does the device support touch events
         * https://www.w3.org/TR/touch-events/
         *
         * @readonly
         * @member {boolean}
         */ _this.supportsTouchEvents = 'ontouchstart' in self;
        /**
         * Does the device support pointer events
         * https://www.w3.org/Submission/pointer-events/
         *
         * @readonly
         * @member {boolean}
         */ _this.supportsPointerEvents = !!self.PointerEvent;
        // this will make it so that you don't have to call bind all the time
        /**
         * @private
         * @member {Function}
         */ _this.onPointerUp = _this.onPointerUp.bind(_this);
        _this.processPointerUp = _this.processPointerUp.bind(_this);
        /**
         * @private
         * @member {Function}
         */ _this.onPointerCancel = _this.onPointerCancel.bind(_this);
        _this.processPointerCancel = _this.processPointerCancel.bind(_this);
        /**
         * @private
         * @member {Function}
         */ _this.onPointerDown = _this.onPointerDown.bind(_this);
        _this.processPointerDown = _this.processPointerDown.bind(_this);
        /**
         * @private
         * @member {Function}
         */ _this.onPointerMove = _this.onPointerMove.bind(_this);
        _this.processPointerMove = _this.processPointerMove.bind(_this);
        /**
         * @private
         * @member {Function}
         */ _this.onPointerOut = _this.onPointerOut.bind(_this);
        _this.processPointerOverOut = _this.processPointerOverOut.bind(_this);
        /**
         * @private
         * @member {Function}
         */ _this.onPointerOver = _this.onPointerOver.bind(_this);
        /**
         * Dictionary of how different cursor modes are handled. Strings are handled as CSS cursor
         * values, objects are handled as dictionaries of CSS values for interactionDOMElement,
         * and functions are called instead of changing the CSS.
         * Default CSS cursor values are provided for 'default' and 'pointer' modes.
         * @member {Object.<string, Object>}
         */ _this.cursorStyles = {
            default: 'inherit',
            pointer: 'pointer'
        };
        /**
         * The mode of the cursor that is being used.
         * The value of this is a key from the cursorStyles dictionary.
         *
         * @member {string}
         */ _this.currentCursorMode = null;
        /**
         * Internal cached let.
         *
         * @private
         * @member {string}
         */ _this.cursor = null;
        /**
         * The current resolution / device pixel ratio.
         *
         * @member {number}
         * @default 1
         */ _this.resolution = 1;
        /**
         * Delayed pointer events. Used to guarantee correct ordering of over/out events.
         *
         * @private
         * @member {Array}
         */ _this.delayedEvents = [];
        /**
         * TreeSearch component that is used to hitTest stage tree
         *
         * @private
         * @member {PIXI.TreeSearch}
         */ _this.search = new $3f2224d8df498ec4$var$TreeSearch();
        /**
         * Used as a last rendered object in case renderer doesnt have _lastObjectRendered
         * @member {DisplayObject}
         * @private
         */ _this._tempDisplayObject = new (0, $8t5Gy.TemporaryDisplayObject)();
        /**
         * An options object specifies characteristics about the event listener.
         * @private
         * @readonly
         * @member {Object.<string, boolean>}
         */ _this._eventListenerOptions = {
            capture: true,
            passive: false
        };
        /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display
         * object.
         *
         * @event PIXI.InteractionManager#mousedown
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * on the display object.
         *
         * @event PIXI.InteractionManager#rightdown
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is released over the display
         * object.
         *
         * @event PIXI.InteractionManager#mouseup
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * over the display object.
         *
         * @event PIXI.InteractionManager#rightup
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
         * the display object.
         *
         * @event PIXI.InteractionManager#click
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * and released on the display object.
         *
         * @event PIXI.InteractionManager#rightclick
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is released outside the
         * display object that initially registered a
         * [mousedown]{@link PIXI.InteractionManager#event:mousedown}.
         *
         * @event PIXI.InteractionManager#mouseupoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * outside the display object that initially registered a
         * [rightdown]{@link PIXI.InteractionManager#event:rightdown}.
         *
         * @event PIXI.InteractionManager#rightupoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device (usually a mouse) is moved while over the display object
         *
         * @event PIXI.InteractionManager#mousemove
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device (usually a mouse) is moved onto the display object
         *
         * @event PIXI.InteractionManager#mouseover
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device (usually a mouse) is moved off the display object
         *
         * @event PIXI.InteractionManager#mouseout
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is pressed on the display object.
         *
         * @event PIXI.InteractionManager#pointerdown
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is released over the display object.
         * Not always fired when some buttons are held down while others are released. In those cases,
         * use [mousedown]{@link PIXI.InteractionManager#event:mousedown} and
         * [mouseup]{@link PIXI.InteractionManager#event:mouseup} instead.
         *
         * @event PIXI.InteractionManager#pointerup
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when the operating system cancels a pointer event
         *
         * @event PIXI.InteractionManager#pointercancel
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is pressed and released on the display object.
         *
         * @event PIXI.InteractionManager#pointertap
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is released outside the display object that initially
         * registered a [pointerdown]{@link PIXI.InteractionManager#event:pointerdown}.
         *
         * @event PIXI.InteractionManager#pointerupoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device is moved while over the display object
         *
         * @event PIXI.InteractionManager#pointermove
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device is moved onto the display object
         *
         * @event PIXI.InteractionManager#pointerover
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device is moved off the display object
         *
         * @event PIXI.InteractionManager#pointerout
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is placed on the display object.
         *
         * @event PIXI.InteractionManager#touchstart
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is removed from the display object.
         *
         * @event PIXI.InteractionManager#touchend
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when the operating system cancels a touch
         *
         * @event PIXI.InteractionManager#touchcancel
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is placed and removed from the display object.
         *
         * @event PIXI.InteractionManager#tap
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is removed outside of the display object that initially
         * registered a [touchstart]{@link PIXI.InteractionManager#event:touchstart}.
         *
         * @event PIXI.InteractionManager#touchendoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is moved along the display object.
         *
         * @event PIXI.InteractionManager#touchmove
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display.
         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#mousedown
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#rightdown
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is released over the display
         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#mouseup
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * over the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#rightup
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
         * the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#click
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * and released on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#rightclick
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button (usually a mouse left-button) is released outside the
         * display object that initially registered a
         * [mousedown]{@link PIXI.DisplayObject#event:mousedown}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#mouseupoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * outside the display object that initially registered a
         * [rightdown]{@link PIXI.DisplayObject#event:rightdown}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#rightupoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device (usually a mouse) is moved while over the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#mousemove
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device (usually a mouse) is moved onto the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#mouseover
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device (usually a mouse) is moved off the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#mouseout
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is pressed on the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointerdown
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is released over the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointerup
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when the operating system cancels a pointer event.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointercancel
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is pressed and released on the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointertap
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device button is released outside the display object that initially
         * registered a [pointerdown]{@link PIXI.DisplayObject#event:pointerdown}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointerupoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device is moved while over the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointermove
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device is moved onto the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointerover
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a pointer device is moved off the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#pointerout
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is placed on the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#touchstart
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is removed from the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#touchend
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when the operating system cancels a touch.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#touchcancel
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is placed and removed from the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#tap
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is removed outside of the display object that initially
         * registered a [touchstart]{@link PIXI.DisplayObject#event:touchstart}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#touchendoutside
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ /**
         * Fired when a touch point is moved along the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * This comes from the @pixi/interaction package.
         *
         * @event PIXI.DisplayObject#touchmove
         * @param {PIXI.InteractionEvent} event - Interaction event
         */ _this._useSystemTicker = options.useSystemTicker !== undefined ? options.useSystemTicker : true;
        _this.setTargetElement(_this.renderer.view, _this.renderer.resolution);
        return _this;
    }
    Object.defineProperty(InteractionManager.prototype, "useSystemTicker", {
        /**
         * Should the InteractionManager automatically add {@link tickerUpdate} to {@link PIXI.Ticker.system}.
         *
         * @member {boolean}
         * @default true
         */ get: function() {
            return this._useSystemTicker;
        },
        set: function(useSystemTicker) {
            this._useSystemTicker = useSystemTicker;
            if (useSystemTicker) this.addTickerListener();
            else this.removeTickerListener();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InteractionManager.prototype, "lastObjectRendered", {
        /**
         * Last rendered object or temp object
         * @readonly
         * @protected
         * @member {PIXI.DisplayObject}
         */ get: function() {
            return this.renderer._lastObjectRendered || this._tempDisplayObject;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Hit tests a point against the display tree, returning the first interactive object that is hit.
     *
     * @param {PIXI.Point} globalPoint - A point to hit test with, in global space.
     * @param {PIXI.Container} [root] - The root display object to start from. If omitted, defaults
     * to the last rendered root of the associated renderer.
     * @return {PIXI.DisplayObject} The hit display object, if any.
     */ InteractionManager.prototype.hitTest = function(globalPoint, root) {
        // clear the target for our hit test
        $3f2224d8df498ec4$var$hitTestEvent.target = null;
        // assign the global point
        $3f2224d8df498ec4$var$hitTestEvent.data.global = globalPoint;
        // ensure safety of the root
        if (!root) root = this.lastObjectRendered;
        // run the hit test
        this.processInteractive($3f2224d8df498ec4$var$hitTestEvent, root, null, true);
        // return our found object - it'll be null if we didn't hit anything
        return $3f2224d8df498ec4$var$hitTestEvent.target;
    };
    /**
     * Sets the DOM element which will receive mouse/touch events. This is useful for when you have
     * other DOM elements on top of the renderers Canvas element. With this you'll be bale to delegate
     * another DOM element to receive those events.
     *
     * @param {HTMLElement} element - the DOM element which will receive mouse and touch events.
     * @param {number} [resolution=1] - The resolution / device pixel ratio of the new element (relative to the canvas).
     */ InteractionManager.prototype.setTargetElement = function(element, resolution) {
        if (resolution === void 0) resolution = 1;
        this.removeTickerListener();
        this.removeEvents();
        this.interactionDOMElement = element;
        this.resolution = resolution;
        this.addEvents();
        this.addTickerListener();
    };
    /**
     * Add the ticker listener
     *
     * @private
     */ InteractionManager.prototype.addTickerListener = function() {
        if (this.tickerAdded || !this.interactionDOMElement || !this._useSystemTicker) return;
        (0, $3YyWq.Ticker).system.add(this.tickerUpdate, this, (0, $3YyWq.UPDATE_PRIORITY).INTERACTION);
        this.tickerAdded = true;
    };
    /**
     * Remove the ticker listener
     *
     * @private
     */ InteractionManager.prototype.removeTickerListener = function() {
        if (!this.tickerAdded) return;
        (0, $3YyWq.Ticker).system.remove(this.tickerUpdate, this);
        this.tickerAdded = false;
    };
    /**
     * Registers all the DOM events
     *
     * @private
     */ InteractionManager.prototype.addEvents = function() {
        if (this.eventsAdded || !this.interactionDOMElement) return;
        var style = this.interactionDOMElement.style;
        if (self.navigator.msPointerEnabled) {
            style.msContentZooming = 'none';
            style.msTouchAction = 'none';
        } else if (this.supportsPointerEvents) style.touchAction = 'none';
        /*
         * These events are added first, so that if pointer events are normalized, they are fired
         * in the same order as non-normalized events. ie. pointer event 1st, mouse / touch 2nd
         */ if (this.supportsPointerEvents) {
            self.document.addEventListener('pointermove', this.onPointerMove, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('pointerdown', this.onPointerDown, this._eventListenerOptions);
            // pointerout is fired in addition to pointerup (for touch events) and pointercancel
            // we already handle those, so for the purposes of what we do in onPointerOut, we only
            // care about the pointerleave event
            this.interactionDOMElement.addEventListener('pointerleave', this.onPointerOut, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('pointerover', this.onPointerOver, this._eventListenerOptions);
            self.addEventListener('pointercancel', this.onPointerCancel, this._eventListenerOptions);
            self.addEventListener('pointerup', this.onPointerUp, this._eventListenerOptions);
        } else {
            self.document.addEventListener('mousemove', this.onPointerMove, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('mousedown', this.onPointerDown, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('mouseout', this.onPointerOut, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('mouseover', this.onPointerOver, this._eventListenerOptions);
            self.addEventListener('mouseup', this.onPointerUp, this._eventListenerOptions);
        }
        // always look directly for touch events so that we can provide original data
        // In a future version we should change this to being just a fallback and rely solely on
        // PointerEvents whenever available
        if (this.supportsTouchEvents) {
            this.interactionDOMElement.addEventListener('touchstart', this.onPointerDown, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('touchcancel', this.onPointerCancel, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('touchend', this.onPointerUp, this._eventListenerOptions);
            this.interactionDOMElement.addEventListener('touchmove', this.onPointerMove, this._eventListenerOptions);
        }
        this.eventsAdded = true;
    };
    /**
     * Removes all the DOM events that were previously registered
     *
     * @private
     */ InteractionManager.prototype.removeEvents = function() {
        if (!this.eventsAdded || !this.interactionDOMElement) return;
        var style = this.interactionDOMElement.style;
        if (self.navigator.msPointerEnabled) {
            style.msContentZooming = '';
            style.msTouchAction = '';
        } else if (this.supportsPointerEvents) style.touchAction = '';
        if (this.supportsPointerEvents) {
            self.document.removeEventListener('pointermove', this.onPointerMove, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('pointerdown', this.onPointerDown, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('pointerleave', this.onPointerOut, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('pointerover', this.onPointerOver, this._eventListenerOptions);
            self.removeEventListener('pointercancel', this.onPointerCancel, this._eventListenerOptions);
            self.removeEventListener('pointerup', this.onPointerUp, this._eventListenerOptions);
        } else {
            self.document.removeEventListener('mousemove', this.onPointerMove, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('mousedown', this.onPointerDown, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('mouseout', this.onPointerOut, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('mouseover', this.onPointerOver, this._eventListenerOptions);
            self.removeEventListener('mouseup', this.onPointerUp, this._eventListenerOptions);
        }
        if (this.supportsTouchEvents) {
            this.interactionDOMElement.removeEventListener('touchstart', this.onPointerDown, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('touchcancel', this.onPointerCancel, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('touchend', this.onPointerUp, this._eventListenerOptions);
            this.interactionDOMElement.removeEventListener('touchmove', this.onPointerMove, this._eventListenerOptions);
        }
        this.interactionDOMElement = null;
        this.eventsAdded = false;
    };
    /**
     * Updates the state of interactive objects if at least {@link interactionFrequency}
     * milliseconds have passed since the last invocation.
     *
     * Invoked by a throttled ticker update from {@link PIXI.Ticker.system}.
     *
     * @param {number} deltaTime - time delta since the last call
     */ InteractionManager.prototype.tickerUpdate = function(deltaTime) {
        this._deltaTime += deltaTime;
        if (this._deltaTime < this.interactionFrequency) return;
        this._deltaTime = 0;
        this.update();
    };
    /**
     * Updates the state of interactive objects.
     */ InteractionManager.prototype.update = function() {
        if (!this.interactionDOMElement) return;
        // if the user move the mouse this check has already been done using the mouse move!
        if (this._didMove) {
            this._didMove = false;
            return;
        }
        this.cursor = null;
        // Resets the flag as set by a stopPropagation call. This flag is usually reset by a user interaction of any kind,
        // but there was a scenario of a display object moving under a static mouse cursor.
        // In this case, mouseover and mouseevents would not pass the flag test in dispatchEvent function
        for(var k in this.activeInteractionData)// eslint-disable-next-line no-prototype-builtins
        if (this.activeInteractionData.hasOwnProperty(k)) {
            var interactionData = this.activeInteractionData[k];
            if (interactionData.originalEvent && interactionData.pointerType !== 'touch') {
                var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, interactionData.originalEvent, interactionData);
                this.processInteractive(interactionEvent, this.lastObjectRendered, this.processPointerOverOut, true);
            }
        }
        this.setCursorMode(this.cursor);
    };
    /**
     * Sets the current cursor mode, handling any callbacks or CSS style changes.
     *
     * @param {string} mode - cursor mode, a key from the cursorStyles dictionary
     */ InteractionManager.prototype.setCursorMode = function(mode) {
        mode = mode || 'default';
        var applyStyles = true;
        // offscreen canvas does not support setting styles, but cursor modes can be functions,
        // in order to handle pixi rendered cursors, so we can't bail
        if (self.OffscreenCanvas && this.interactionDOMElement instanceof OffscreenCanvas) applyStyles = false;
        // if the mode didn't actually change, bail early
        if (this.currentCursorMode === mode) return;
        this.currentCursorMode = mode;
        var style = this.cursorStyles[mode];
        // only do things if there is a cursor style for it
        if (style) switch(typeof style){
            case 'string':
                // string styles are handled as cursor CSS
                if (applyStyles) this.interactionDOMElement.style.cursor = style;
                break;
            case 'function':
                // functions are just called, and passed the cursor mode
                style(mode);
                break;
            case 'object':
                // if it is an object, assume that it is a dictionary of CSS styles,
                // apply it to the interactionDOMElement
                if (applyStyles) Object.assign(this.interactionDOMElement.style, style);
                break;
        }
        else if (applyStyles && typeof mode === 'string' && !Object.prototype.hasOwnProperty.call(this.cursorStyles, mode)) // if it mode is a string (not a Symbol) and cursorStyles doesn't have any entry
        // for the mode, then assume that the dev wants it to be CSS for the cursor.
        this.interactionDOMElement.style.cursor = mode;
    };
    /**
     * Dispatches an event on the display object that was interacted with
     *
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the display object in question
     * @param {string} eventString - the name of the event (e.g, mousedown)
     * @param {PIXI.InteractionEvent} eventData - the event data object
     * @private
     */ InteractionManager.prototype.dispatchEvent = function(displayObject, eventString, eventData) {
        // Even if the event was stopped, at least dispatch any remaining events
        // for the same display object.
        if (!eventData.stopPropagationHint || displayObject === eventData.stopsPropagatingAt) {
            eventData.currentTarget = displayObject;
            eventData.type = eventString;
            displayObject.emit(eventString, eventData);
            if (displayObject[eventString]) displayObject[eventString](eventData);
        }
    };
    /**
     * Puts a event on a queue to be dispatched later. This is used to guarantee correct
     * ordering of over/out events.
     *
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the display object in question
     * @param {string} eventString - the name of the event (e.g, mousedown)
     * @param {object} eventData - the event data object
     * @private
     */ InteractionManager.prototype.delayDispatchEvent = function(displayObject, eventString, eventData) {
        this.delayedEvents.push({
            displayObject: displayObject,
            eventString: eventString,
            eventData: eventData
        });
    };
    /**
     * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
     * resulting value is stored in the point. This takes into account the fact that the DOM
     * element could be scaled and positioned anywhere on the screen.
     *
     * @param  {PIXI.IPointData} point - the point that the result will be stored in
     * @param  {number} x - the x coord of the position to map
     * @param  {number} y - the y coord of the position to map
     */ InteractionManager.prototype.mapPositionToPoint = function(point, x, y) {
        var rect;
        // IE 11 fix
        if (!this.interactionDOMElement.parentElement) rect = {
            x: 0,
            y: 0,
            width: this.interactionDOMElement.width,
            height: this.interactionDOMElement.height,
            left: 0,
            top: 0
        };
        else rect = this.interactionDOMElement.getBoundingClientRect();
        var resolutionMultiplier = 1.0 / this.resolution;
        point.x = (x - rect.left) * (this.interactionDOMElement.width / rect.width) * resolutionMultiplier;
        point.y = (y - rect.top) * (this.interactionDOMElement.height / rect.height) * resolutionMultiplier;
    };
    /**
     * This function is provides a neat way of crawling through the scene graph and running a
     * specified function on all interactive objects it finds. It will also take care of hit
     * testing the interactive objects and passes the hit across in the function.
     *
     * @protected
     * @param {PIXI.InteractionEvent} interactionEvent - event containing the point that
     *  is tested for collision
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - the displayObject
     *  that will be hit test (recursively crawls its children)
     * @param {Function} [func] - the function that will be called on each interactive object. The
     *  interactionEvent, displayObject and hit will be passed to the function
     * @param {boolean} [hitTest] - indicates whether we want to calculate hits
     *  or just iterate through all interactive objects
     */ InteractionManager.prototype.processInteractive = function(interactionEvent, displayObject, func, hitTest) {
        var hit = this.search.findHit(interactionEvent, displayObject, func, hitTest);
        var delayedEvents = this.delayedEvents;
        if (!delayedEvents.length) return hit;
        // Reset the propagation hint, because we start deeper in the tree again.
        interactionEvent.stopPropagationHint = false;
        var delayedLen = delayedEvents.length;
        this.delayedEvents = [];
        for(var i = 0; i < delayedLen; i++){
            var _a = delayedEvents[i], displayObject_1 = _a.displayObject, eventString = _a.eventString, eventData = _a.eventData;
            // When we reach the object we wanted to stop propagating at,
            // set the propagation hint.
            if (eventData.stopsPropagatingAt === displayObject_1) eventData.stopPropagationHint = true;
            this.dispatchEvent(displayObject_1, eventString, eventData);
        }
        return hit;
    };
    /**
     * Is called when the pointer button is pressed down on the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being pressed down
     */ InteractionManager.prototype.onPointerDown = function(originalEvent) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;
        var events = this.normalizeToPointerData(originalEvent);
        /*
         * No need to prevent default on natural pointer events, as there are no side effects
         * Normalized events, however, may have the double mousedown/touchstart issue on the native android browser,
         * so still need to be prevented.
         */ // Guaranteed that there will be at least one event in events, and all events must have the same pointer type
        if (this.autoPreventDefault && events[0].isNormalized) {
            var cancelable = originalEvent.cancelable || !('cancelable' in originalEvent);
            if (cancelable) originalEvent.preventDefault();
        }
        var eventLen = events.length;
        for(var i = 0; i < eventLen; i++){
            var event = events[i];
            var interactionData = this.getInteractionDataForPointerId(event);
            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
            interactionEvent.data.originalEvent = originalEvent;
            this.processInteractive(interactionEvent, this.lastObjectRendered, this.processPointerDown, true);
            this.emit('pointerdown', interactionEvent);
            if (event.pointerType === 'touch') this.emit('touchstart', interactionEvent);
            else if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
                var isRightButton = event.button === 2;
                this.emit(isRightButton ? 'rightdown' : 'mousedown', this.eventData);
            }
        }
    };
    /**
     * Processes the result of the pointer down check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */ InteractionManager.prototype.processPointerDown = function(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;
        var id = interactionEvent.data.identifier;
        if (hit) {
            if (!displayObject.trackedPointers[id]) displayObject.trackedPointers[id] = new $3f2224d8df498ec4$export$656983b0c6f240c(id);
            this.dispatchEvent(displayObject, 'pointerdown', interactionEvent);
            if (data.pointerType === 'touch') this.dispatchEvent(displayObject, 'touchstart', interactionEvent);
            else if (data.pointerType === 'mouse' || data.pointerType === 'pen') {
                var isRightButton = data.button === 2;
                if (isRightButton) displayObject.trackedPointers[id].rightDown = true;
                else displayObject.trackedPointers[id].leftDown = true;
                this.dispatchEvent(displayObject, isRightButton ? 'rightdown' : 'mousedown', interactionEvent);
            }
        }
    };
    /**
     * Is called when the pointer button is released on the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being released
     * @param {boolean} cancelled - true if the pointer is cancelled
     * @param {Function} func - Function passed to {@link processInteractive}
     */ InteractionManager.prototype.onPointerComplete = function(originalEvent, cancelled, func) {
        var events = this.normalizeToPointerData(originalEvent);
        var eventLen = events.length;
        // if the event wasn't targeting our canvas, then consider it to be pointerupoutside
        // in all cases (unless it was a pointercancel)
        var eventAppend = originalEvent.target !== this.interactionDOMElement ? 'outside' : '';
        for(var i = 0; i < eventLen; i++){
            var event = events[i];
            var interactionData = this.getInteractionDataForPointerId(event);
            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
            interactionEvent.data.originalEvent = originalEvent;
            // perform hit testing for events targeting our canvas or cancel events
            this.processInteractive(interactionEvent, this.lastObjectRendered, func, cancelled || !eventAppend);
            this.emit(cancelled ? 'pointercancel' : "pointerup" + eventAppend, interactionEvent);
            if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
                var isRightButton = event.button === 2;
                this.emit(isRightButton ? "rightup" + eventAppend : "mouseup" + eventAppend, interactionEvent);
            } else if (event.pointerType === 'touch') {
                this.emit(cancelled ? 'touchcancel' : "touchend" + eventAppend, interactionEvent);
                this.releaseInteractionDataForPointerId(event.pointerId);
            }
        }
    };
    /**
     * Is called when the pointer button is cancelled
     *
     * @private
     * @param {PointerEvent} event - The DOM event of a pointer button being released
     */ InteractionManager.prototype.onPointerCancel = function(event) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && event.pointerType === 'touch') return;
        this.onPointerComplete(event, true, this.processPointerCancel);
    };
    /**
     * Processes the result of the pointer cancel check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
     */ InteractionManager.prototype.processPointerCancel = function(interactionEvent, displayObject) {
        var data = interactionEvent.data;
        var id = interactionEvent.data.identifier;
        if (displayObject.trackedPointers[id] !== undefined) {
            delete displayObject.trackedPointers[id];
            this.dispatchEvent(displayObject, 'pointercancel', interactionEvent);
            if (data.pointerType === 'touch') this.dispatchEvent(displayObject, 'touchcancel', interactionEvent);
        }
    };
    /**
     * Is called when the pointer button is released on the renderer element
     *
     * @private
     * @param {PointerEvent} event - The DOM event of a pointer button being released
     */ InteractionManager.prototype.onPointerUp = function(event) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && event.pointerType === 'touch') return;
        this.onPointerComplete(event, false, this.processPointerUp);
    };
    /**
     * Processes the result of the pointer up check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */ InteractionManager.prototype.processPointerUp = function(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;
        var id = interactionEvent.data.identifier;
        var trackingData = displayObject.trackedPointers[id];
        var isTouch = data.pointerType === 'touch';
        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
        // need to track mouse down status in the mouse block so that we can emit
        // event in a later block
        var isMouseTap = false;
        // Mouse only
        if (isMouse) {
            var isRightButton = data.button === 2;
            var flags = $3f2224d8df498ec4$export$656983b0c6f240c.FLAGS;
            var test = isRightButton ? flags.RIGHT_DOWN : flags.LEFT_DOWN;
            var isDown = trackingData !== undefined && trackingData.flags & test;
            if (hit) {
                this.dispatchEvent(displayObject, isRightButton ? 'rightup' : 'mouseup', interactionEvent);
                if (isDown) {
                    this.dispatchEvent(displayObject, isRightButton ? 'rightclick' : 'click', interactionEvent);
                    // because we can confirm that the mousedown happened on this object, flag for later emit of pointertap
                    isMouseTap = true;
                }
            } else if (isDown) this.dispatchEvent(displayObject, isRightButton ? 'rightupoutside' : 'mouseupoutside', interactionEvent);
            // update the down state of the tracking data
            if (trackingData) {
                if (isRightButton) trackingData.rightDown = false;
                else trackingData.leftDown = false;
            }
        }
        // Pointers and Touches, and Mouse
        if (hit) {
            this.dispatchEvent(displayObject, 'pointerup', interactionEvent);
            if (isTouch) this.dispatchEvent(displayObject, 'touchend', interactionEvent);
            if (trackingData) {
                // emit pointertap if not a mouse, or if the mouse block decided it was a tap
                if (!isMouse || isMouseTap) this.dispatchEvent(displayObject, 'pointertap', interactionEvent);
                if (isTouch) {
                    this.dispatchEvent(displayObject, 'tap', interactionEvent);
                    // touches are no longer over (if they ever were) when we get the touchend
                    // so we should ensure that we don't keep pretending that they are
                    trackingData.over = false;
                }
            }
        } else if (trackingData) {
            this.dispatchEvent(displayObject, 'pointerupoutside', interactionEvent);
            if (isTouch) this.dispatchEvent(displayObject, 'touchendoutside', interactionEvent);
        }
        // Only remove the tracking data if there is no over/down state still associated with it
        if (trackingData && trackingData.none) delete displayObject.trackedPointers[id];
    };
    /**
     * Is called when the pointer moves across the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer moving
     */ InteractionManager.prototype.onPointerMove = function(originalEvent) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;
        var events = this.normalizeToPointerData(originalEvent);
        if (events[0].pointerType === 'mouse' || events[0].pointerType === 'pen') {
            this._didMove = true;
            this.cursor = null;
        }
        var eventLen = events.length;
        for(var i = 0; i < eventLen; i++){
            var event = events[i];
            var interactionData = this.getInteractionDataForPointerId(event);
            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
            interactionEvent.data.originalEvent = originalEvent;
            this.processInteractive(interactionEvent, this.lastObjectRendered, this.processPointerMove, true);
            this.emit('pointermove', interactionEvent);
            if (event.pointerType === 'touch') this.emit('touchmove', interactionEvent);
            if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.emit('mousemove', interactionEvent);
        }
        if (events[0].pointerType === 'mouse') this.setCursorMode(this.cursor);
    };
    /**
     * Processes the result of the pointer move check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */ InteractionManager.prototype.processPointerMove = function(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;
        var isTouch = data.pointerType === 'touch';
        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
        if (isMouse) this.processPointerOverOut(interactionEvent, displayObject, hit);
        if (!this.moveWhenInside || hit) {
            this.dispatchEvent(displayObject, 'pointermove', interactionEvent);
            if (isTouch) this.dispatchEvent(displayObject, 'touchmove', interactionEvent);
            if (isMouse) this.dispatchEvent(displayObject, 'mousemove', interactionEvent);
        }
    };
    /**
     * Is called when the pointer is moved out of the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer being moved out
     */ InteractionManager.prototype.onPointerOut = function(originalEvent) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;
        var events = this.normalizeToPointerData(originalEvent);
        // Only mouse and pointer can call onPointerOut, so events will always be length 1
        var event = events[0];
        if (event.pointerType === 'mouse') {
            this.mouseOverRenderer = false;
            this.setCursorMode(null);
        }
        var interactionData = this.getInteractionDataForPointerId(event);
        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
        interactionEvent.data.originalEvent = event;
        this.processInteractive(interactionEvent, this.lastObjectRendered, this.processPointerOverOut, false);
        this.emit('pointerout', interactionEvent);
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.emit('mouseout', interactionEvent);
        else // we can get touchleave events after touchend, so we want to make sure we don't
        // introduce memory leaks
        this.releaseInteractionDataForPointerId(interactionData.identifier);
    };
    /**
     * Processes the result of the pointer over/out check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */ InteractionManager.prototype.processPointerOverOut = function(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;
        var id = interactionEvent.data.identifier;
        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
        var trackingData = displayObject.trackedPointers[id];
        // if we just moused over the display object, then we need to track that state
        if (hit && !trackingData) trackingData = displayObject.trackedPointers[id] = new $3f2224d8df498ec4$export$656983b0c6f240c(id);
        if (trackingData === undefined) return;
        if (hit && this.mouseOverRenderer) {
            if (!trackingData.over) {
                trackingData.over = true;
                this.delayDispatchEvent(displayObject, 'pointerover', interactionEvent);
                if (isMouse) this.delayDispatchEvent(displayObject, 'mouseover', interactionEvent);
            }
            // only change the cursor if it has not already been changed (by something deeper in the
            // display tree)
            if (isMouse && this.cursor === null) this.cursor = displayObject.cursor;
        } else if (trackingData.over) {
            trackingData.over = false;
            this.dispatchEvent(displayObject, 'pointerout', this.eventData);
            if (isMouse) this.dispatchEvent(displayObject, 'mouseout', interactionEvent);
            // if there is no mouse down information for the pointer, then it is safe to delete
            if (trackingData.none) delete displayObject.trackedPointers[id];
        }
    };
    /**
     * Is called when the pointer is moved into the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being moved into the renderer view
     */ InteractionManager.prototype.onPointerOver = function(originalEvent) {
        var events = this.normalizeToPointerData(originalEvent);
        // Only mouse and pointer can call onPointerOver, so events will always be length 1
        var event = events[0];
        var interactionData = this.getInteractionDataForPointerId(event);
        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
        interactionEvent.data.originalEvent = event;
        if (event.pointerType === 'mouse') this.mouseOverRenderer = true;
        this.emit('pointerover', interactionEvent);
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.emit('mouseover', interactionEvent);
    };
    /**
     * Get InteractionData for a given pointerId. Store that data as well
     *
     * @private
     * @param {PointerEvent} event - Normalized pointer event, output from normalizeToPointerData
     * @return {PIXI.InteractionData} - Interaction data for the given pointer identifier
     */ InteractionManager.prototype.getInteractionDataForPointerId = function(event) {
        var pointerId = event.pointerId;
        var interactionData;
        if (pointerId === $3f2224d8df498ec4$var$MOUSE_POINTER_ID || event.pointerType === 'mouse') interactionData = this.mouse;
        else if (this.activeInteractionData[pointerId]) interactionData = this.activeInteractionData[pointerId];
        else {
            interactionData = this.interactionDataPool.pop() || new $3f2224d8df498ec4$export$73b9be86c227b464();
            interactionData.identifier = pointerId;
            this.activeInteractionData[pointerId] = interactionData;
        }
        // copy properties from the event, so that we can make sure that touch/pointer specific
        // data is available
        interactionData.copyEvent(event);
        return interactionData;
    };
    /**
     * Return unused InteractionData to the pool, for a given pointerId
     *
     * @private
     * @param {number} pointerId - Identifier from a pointer event
     */ InteractionManager.prototype.releaseInteractionDataForPointerId = function(pointerId) {
        var interactionData = this.activeInteractionData[pointerId];
        if (interactionData) {
            delete this.activeInteractionData[pointerId];
            interactionData.reset();
            this.interactionDataPool.push(interactionData);
        }
    };
    /**
     * Configure an InteractionEvent to wrap a DOM PointerEvent and InteractionData
     *
     * @private
     * @param {PIXI.InteractionEvent} interactionEvent - The event to be configured
     * @param {PointerEvent} pointerEvent - The DOM event that will be paired with the InteractionEvent
     * @param {PIXI.InteractionData} interactionData - The InteractionData that will be paired
     *        with the InteractionEvent
     * @return {PIXI.InteractionEvent} the interaction event that was passed in
     */ InteractionManager.prototype.configureInteractionEventForDOMEvent = function(interactionEvent, pointerEvent, interactionData) {
        interactionEvent.data = interactionData;
        this.mapPositionToPoint(interactionData.global, pointerEvent.clientX, pointerEvent.clientY);
        // Not really sure why this is happening, but it's how a previous version handled things
        if (pointerEvent.pointerType === 'touch') {
            pointerEvent.globalX = interactionData.global.x;
            pointerEvent.globalY = interactionData.global.y;
        }
        interactionData.originalEvent = pointerEvent;
        interactionEvent.reset();
        return interactionEvent;
    };
    /**
     * Ensures that the original event object contains all data that a regular pointer event would have
     *
     * @private
     * @param {TouchEvent|MouseEvent|PointerEvent} event - The original event data from a touch or mouse event
     * @return {PointerEvent[]} An array containing a single normalized pointer event, in the case of a pointer
     *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
     */ InteractionManager.prototype.normalizeToPointerData = function(event) {
        var normalizedEvents = [];
        if (this.supportsTouchEvents && event instanceof TouchEvent) for(var i = 0, li = event.changedTouches.length; i < li; i++){
            var touch = event.changedTouches[i];
            if (typeof touch.button === 'undefined') touch.button = event.touches.length ? 1 : 0;
            if (typeof touch.buttons === 'undefined') touch.buttons = event.touches.length ? 1 : 0;
            if (typeof touch.isPrimary === 'undefined') touch.isPrimary = event.touches.length === 1 && event.type === 'touchstart';
            if (typeof touch.width === 'undefined') touch.width = touch.radiusX || 1;
            if (typeof touch.height === 'undefined') touch.height = touch.radiusY || 1;
            if (typeof touch.tiltX === 'undefined') touch.tiltX = 0;
            if (typeof touch.tiltY === 'undefined') touch.tiltY = 0;
            if (typeof touch.pointerType === 'undefined') touch.pointerType = 'touch';
            if (typeof touch.pointerId === 'undefined') touch.pointerId = touch.identifier || 0;
            if (typeof touch.pressure === 'undefined') touch.pressure = touch.force || 0.5;
            if (typeof touch.twist === 'undefined') touch.twist = 0;
            if (typeof touch.tangentialPressure === 'undefined') touch.tangentialPressure = 0;
            // TODO: Remove these, as layerX/Y is not a standard, is deprecated, has uneven
            // support, and the fill ins are not quite the same
            // offsetX/Y might be okay, but is not the same as clientX/Y when the canvas's top
            // left is not 0,0 on the page
            if (typeof touch.layerX === 'undefined') touch.layerX = touch.offsetX = touch.clientX;
            if (typeof touch.layerY === 'undefined') touch.layerY = touch.offsetY = touch.clientY;
            // mark the touch as normalized, just so that we know we did it
            touch.isNormalized = true;
            normalizedEvents.push(touch);
        }
        else if (!self.MouseEvent || event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof self.PointerEvent))) {
            var tempEvent = event;
            if (typeof tempEvent.isPrimary === 'undefined') tempEvent.isPrimary = true;
            if (typeof tempEvent.width === 'undefined') tempEvent.width = 1;
            if (typeof tempEvent.height === 'undefined') tempEvent.height = 1;
            if (typeof tempEvent.tiltX === 'undefined') tempEvent.tiltX = 0;
            if (typeof tempEvent.tiltY === 'undefined') tempEvent.tiltY = 0;
            if (typeof tempEvent.pointerType === 'undefined') tempEvent.pointerType = 'mouse';
            if (typeof tempEvent.pointerId === 'undefined') tempEvent.pointerId = $3f2224d8df498ec4$var$MOUSE_POINTER_ID;
            if (typeof tempEvent.pressure === 'undefined') tempEvent.pressure = 0.5;
            if (typeof tempEvent.twist === 'undefined') tempEvent.twist = 0;
            if (typeof tempEvent.tangentialPressure === 'undefined') tempEvent.tangentialPressure = 0;
            // mark the mouse event as normalized, just so that we know we did it
            tempEvent.isNormalized = true;
            normalizedEvents.push(tempEvent);
        } else normalizedEvents.push(event);
        return normalizedEvents;
    };
    /**
     * Destroys the interaction manager
     *
     */ InteractionManager.prototype.destroy = function() {
        this.removeEvents();
        this.removeTickerListener();
        this.removeAllListeners();
        this.renderer = null;
        this.mouse = null;
        this.eventData = null;
        this.interactionDOMElement = null;
        this.onPointerDown = null;
        this.processPointerDown = null;
        this.onPointerUp = null;
        this.processPointerUp = null;
        this.onPointerCancel = null;
        this.processPointerCancel = null;
        this.onPointerMove = null;
        this.processPointerMove = null;
        this.onPointerOut = null;
        this.processPointerOverOut = null;
        this.onPointerOver = null;
        this.search = null;
    };
    return InteractionManager;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE))));

});
parcelRegister("3YyWq", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PRIORITY", function () { return $2e521452c1952d1b$export$688aaf132ba9b379; });
$parcel$export(module.exports, "Ticker", function () { return $2e521452c1952d1b$export$39c54bcc89dcee11; });
$parcel$export(module.exports, "TickerPlugin", function () { return $2e521452c1952d1b$export$50c361ceb4e2f4f0; });
/*!
 * @pixi/ticker - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/ticker is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $ezJmd = parcelRequire("ezJmd");
/**
 * Target frames per millisecond.
 *
 * @static
 * @name TARGET_FPMS
 * @memberof PIXI.settings
 * @type {number}
 * @default 0.06
 */ (0, $ezJmd.settings).TARGET_FPMS = 0.06;
/**
 * Represents the update priorities used by internal PIXI classes when registered with
 * the {@link PIXI.Ticker} object. Higher priority items are updated first and lower
 * priority items, such as render, should go later.
 *
 * @static
 * @constant
 * @name UPDATE_PRIORITY
 * @memberof PIXI
 * @enum {number}
 * @property {number} INTERACTION=50 Highest priority, used for {@link PIXI.InteractionManager}
 * @property {number} HIGH=25 High priority updating, {@link PIXI.VideoBaseTexture} and {@link PIXI.AnimatedSprite}
 * @property {number} NORMAL=0 Default priority for ticker events, see {@link PIXI.Ticker#add}.
 * @property {number} LOW=-25 Low priority used for {@link PIXI.Application} rendering.
 * @property {number} UTILITY=-50 Lowest priority used for {@link PIXI.BasePrepare} utility.
 */ var $2e521452c1952d1b$export$688aaf132ba9b379;
(function(UPDATE_PRIORITY) {
    UPDATE_PRIORITY[UPDATE_PRIORITY["INTERACTION"] = 50] = "INTERACTION";
    UPDATE_PRIORITY[UPDATE_PRIORITY["HIGH"] = 25] = "HIGH";
    UPDATE_PRIORITY[UPDATE_PRIORITY["NORMAL"] = 0] = "NORMAL";
    UPDATE_PRIORITY[UPDATE_PRIORITY["LOW"] = -25] = "LOW";
    UPDATE_PRIORITY[UPDATE_PRIORITY["UTILITY"] = -50] = "UTILITY";
})($2e521452c1952d1b$export$688aaf132ba9b379 || ($2e521452c1952d1b$export$688aaf132ba9b379 = {}));
/**
 * Internal class for handling the priority sorting of ticker handlers.
 *
 * @private
 * @class
 * @memberof PIXI
 */ var $2e521452c1952d1b$var$TickerListener = /** @class */ function() {
    /**
     * Constructor
     * @private
     * @param fn - The listener function to be added for one update
     * @param context - The listener context
     * @param priority - The priority for emitting
     * @param once - If the handler should fire once
     */ function TickerListener(fn, context, priority, once) {
        if (context === void 0) context = null;
        if (priority === void 0) priority = 0;
        if (once === void 0) once = false;
        /** The next item in chain. */ this.next = null;
        /** The previous item in chain. */ this.previous = null;
        /** `true` if this listener has been destroyed already. */ this._destroyed = false;
        this.fn = fn;
        this.context = context;
        this.priority = priority;
        this.once = once;
    }
    /**
     * Simple compare function to figure out if a function and context match.
     * @private
     * @param fn - The listener function to be added for one update
     * @param context - The listener context
     * @return `true` if the listener match the arguments
     */ TickerListener.prototype.match = function(fn, context) {
        if (context === void 0) context = null;
        return this.fn === fn && this.context === context;
    };
    /**
     * Emit by calling the current function.
     * @private
     * @param deltaTime - time since the last emit.
     * @return Next ticker
     */ TickerListener.prototype.emit = function(deltaTime) {
        if (this.fn) {
            if (this.context) this.fn.call(this.context, deltaTime);
            else this.fn(deltaTime);
        }
        var redirect = this.next;
        if (this.once) this.destroy(true);
        // Soft-destroying should remove
        // the next reference
        if (this._destroyed) this.next = null;
        return redirect;
    };
    /**
     * Connect to the list.
     * @private
     * @param previous - Input node, previous listener
     */ TickerListener.prototype.connect = function(previous) {
        this.previous = previous;
        if (previous.next) previous.next.previous = this;
        this.next = previous.next;
        previous.next = this;
    };
    /**
     * Destroy and don't use after this.
     * @private
     * @param hard - `true` to remove the `next` reference, this
     *        is considered a hard destroy. Soft destroy maintains the next reference.
     * @return The listener to redirect while emitting or removing.
     */ TickerListener.prototype.destroy = function(hard) {
        if (hard === void 0) hard = false;
        this._destroyed = true;
        this.fn = null;
        this.context = null;
        // Disconnect, hook up next and previous
        if (this.previous) this.previous.next = this.next;
        if (this.next) this.next.previous = this.previous;
        // Redirect to the next item
        var redirect = this.next;
        // Remove references
        this.next = hard ? null : redirect;
        this.previous = null;
        return redirect;
    };
    return TickerListener;
}();
/**
 * A Ticker class that runs an update loop that other objects listen to.
 *
 * This class is composed around listeners meant for execution on the next requested animation frame.
 * Animation frames are requested only when necessary, e.g. When the ticker is started and the emitter has listeners.
 *
 * @class
 * @memberof PIXI
 */ var $2e521452c1952d1b$export$39c54bcc89dcee11 = /** @class */ function() {
    function Ticker() {
        var _this = this;
        /**
         * Whether or not this ticker should invoke the method
         * {@link PIXI.Ticker#start} automatically
         * when a listener is added.
         */ this.autoStart = false;
        /**
         * Scalar time value from last frame to this frame.
         * This value is capped by setting {@link PIXI.Ticker#minFPS}
         * and is scaled with {@link PIXI.Ticker#speed}.
         * **Note:** The cap may be exceeded by scaling.
         */ this.deltaTime = 1;
        /**
         * The last time {@link PIXI.Ticker#update} was invoked.
         * This value is also reset internally outside of invoking
         * update, but only when a new animation frame is requested.
         * If the platform supports DOMHighResTimeStamp,
         * this value will have a precision of 1 µs.
         */ this.lastTime = -1;
        /**
         * Factor of current {@link PIXI.Ticker#deltaTime}.
         * @example
         * // Scales ticker.deltaTime to what would be
         * // the equivalent of approximately 120 FPS
         * ticker.speed = 2;
         */ this.speed = 1;
        /**
         * Whether or not this ticker has been started.
         * `true` if {@link PIXI.Ticker#start} has been called.
         * `false` if {@link PIXI.Ticker#stop} has been called.
         * While `false`, this value may change to `true` in the
         * event of {@link PIXI.Ticker#autoStart} being `true`
         * and a listener is added.
         */ this.started = false;
        /** Internal current frame request ID */ this._requestId = null;
        /**
         * Internal value managed by minFPS property setter and getter.
         * This is the maximum allowed milliseconds between updates.
         */ this._maxElapsedMS = 100;
        /**
         * Internal value managed by minFPS property setter and getter.
         * This is the minimum allowed milliseconds between updates.
         */ this._minElapsedMS = 0;
        /** If enabled, deleting is disabled.*/ this._protected = false;
        /**
         * The last time keyframe was executed.
         * Maintains a relatively fixed interval with the previous value.
         */ this._lastFrame = -1;
        this._head = new $2e521452c1952d1b$var$TickerListener(null, null, Infinity);
        this.deltaMS = 1 / (0, $ezJmd.settings).TARGET_FPMS;
        this.elapsedMS = 1 / (0, $ezJmd.settings).TARGET_FPMS;
        this._tick = function(time) {
            _this._requestId = null;
            if (_this.started) {
                // Invoke listeners now
                _this.update(time);
                // Listener side effects may have modified ticker state.
                if (_this.started && _this._requestId === null && _this._head.next) _this._requestId = requestAnimationFrame(_this._tick);
            }
        };
    }
    /**
     * Conditionally requests a new animation frame.
     * If a frame has not already been requested, and if the internal
     * emitter has listeners, a new frame is requested.
     *
     * @private
     */ Ticker.prototype._requestIfNeeded = function() {
        if (this._requestId === null && this._head.next) {
            // ensure callbacks get correct delta
            this.lastTime = performance.now();
            this._lastFrame = this.lastTime;
            this._requestId = requestAnimationFrame(this._tick);
        }
    };
    /**
     * Conditionally cancels a pending animation frame.
     * @private
     */ Ticker.prototype._cancelIfNeeded = function() {
        if (this._requestId !== null) {
            cancelAnimationFrame(this._requestId);
            this._requestId = null;
        }
    };
    /**
     * Conditionally requests a new animation frame.
     * If the ticker has been started it checks if a frame has not already
     * been requested, and if the internal emitter has listeners. If these
     * conditions are met, a new frame is requested. If the ticker has not
     * been started, but autoStart is `true`, then the ticker starts now,
     * and continues with the previous conditions to request a new frame.
     *
     * @private
     */ Ticker.prototype._startIfPossible = function() {
        if (this.started) this._requestIfNeeded();
        else if (this.autoStart) this.start();
    };
    /**
     * Register a handler for tick events. Calls continuously unless
     * it is removed or the ticker is stopped.
     *
     * @param fn - The listener function to be added for updates
     * @param context - The listener context
     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
     * @returns This instance of a ticker
     */ Ticker.prototype.add = function(fn, context, priority) {
        if (priority === void 0) priority = $2e521452c1952d1b$export$688aaf132ba9b379.NORMAL;
        return this._addListener(new $2e521452c1952d1b$var$TickerListener(fn, context, priority));
    };
    /**
     * Add a handler for the tick event which is only execute once.
     *
     * @param fn - The listener function to be added for one update
     * @param context - The listener context
     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
     * @returns This instance of a ticker
     */ Ticker.prototype.addOnce = function(fn, context, priority) {
        if (priority === void 0) priority = $2e521452c1952d1b$export$688aaf132ba9b379.NORMAL;
        return this._addListener(new $2e521452c1952d1b$var$TickerListener(fn, context, priority, true));
    };
    /**
     * Internally adds the event handler so that it can be sorted by priority.
     * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
     * before the rendering.
     *
     * @private
     * @param listener - Current listener being added.
     * @returns This instance of a ticker
     */ Ticker.prototype._addListener = function(listener) {
        // For attaching to head
        var current = this._head.next;
        var previous = this._head;
        // Add the first item
        if (!current) listener.connect(previous);
        else {
            // Go from highest to lowest priority
            while(current){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current;
                current = current.next;
            }
            // Not yet connected
            if (!listener.previous) listener.connect(previous);
        }
        this._startIfPossible();
        return this;
    };
    /**
     * Removes any handlers matching the function and context parameters.
     * If no handlers are left after removing, then it cancels the animation frame.
     *
     * @param fn - The listener function to be removed
     * @param context - The listener context to be removed
     * @returns This instance of a ticker
     */ Ticker.prototype.remove = function(fn, context) {
        var listener = this._head.next;
        while(listener)// We found a match, lets remove it
        // no break to delete all possible matches
        // incase a listener was added 2+ times
        if (listener.match(fn, context)) listener = listener.destroy();
        else listener = listener.next;
        if (!this._head.next) this._cancelIfNeeded();
        return this;
    };
    Object.defineProperty(Ticker.prototype, "count", {
        /**
         * The number of listeners on this ticker, calculated by walking through linked list
         *
         * @readonly
         * @member {number}
         */ get: function() {
            if (!this._head) return 0;
            var count = 0;
            var current = this._head;
            while(current = current.next)count++;
            return count;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Starts the ticker. If the ticker has listeners
     * a new animation frame is requested at this point.
     */ Ticker.prototype.start = function() {
        if (!this.started) {
            this.started = true;
            this._requestIfNeeded();
        }
    };
    /**
     * Stops the ticker. If the ticker has requested
     * an animation frame it is canceled at this point.
     */ Ticker.prototype.stop = function() {
        if (this.started) {
            this.started = false;
            this._cancelIfNeeded();
        }
    };
    /**
     * Destroy the ticker and don't use after this. Calling
     * this method removes all references to internal events.
     */ Ticker.prototype.destroy = function() {
        if (!this._protected) {
            this.stop();
            var listener = this._head.next;
            while(listener)listener = listener.destroy(true);
            this._head.destroy();
            this._head = null;
        }
    };
    /**
     * Triggers an update. An update entails setting the
     * current {@link PIXI.Ticker#elapsedMS},
     * the current {@link PIXI.Ticker#deltaTime},
     * invoking all listeners with current deltaTime,
     * and then finally setting {@link PIXI.Ticker#lastTime}
     * with the value of currentTime that was provided.
     * This method will be called automatically by animation
     * frame callbacks if the ticker instance has been started
     * and listeners are added.
     *
     * @param {number} [currentTime=performance.now()] - the current time of execution
     */ Ticker.prototype.update = function(currentTime) {
        if (currentTime === void 0) currentTime = performance.now();
        var elapsedMS;
        // If the difference in time is zero or negative, we ignore most of the work done here.
        // If there is no valid difference, then should be no reason to let anyone know about it.
        // A zero delta, is exactly that, nothing should update.
        //
        // The difference in time can be negative, and no this does not mean time traveling.
        // This can be the result of a race condition between when an animation frame is requested
        // on the current JavaScript engine event loop, and when the ticker's start method is invoked
        // (which invokes the internal _requestIfNeeded method). If a frame is requested before
        // _requestIfNeeded is invoked, then the callback for the animation frame the ticker requests,
        // can receive a time argument that can be less than the lastTime value that was set within
        // _requestIfNeeded. This difference is in microseconds, but this is enough to cause problems.
        //
        // This check covers this browser engine timing issue, as well as if consumers pass an invalid
        // currentTime value. This may happen if consumers opt-out of the autoStart, and update themselves.
        if (currentTime > this.lastTime) {
            // Save uncapped elapsedMS for measurement
            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
            // cap the milliseconds elapsed used for deltaTime
            if (elapsedMS > this._maxElapsedMS) elapsedMS = this._maxElapsedMS;
            elapsedMS *= this.speed;
            // If not enough time has passed, exit the function.
            // Get ready for next frame by setting _lastFrame, but based on _minElapsedMS
            // adjustment to ensure a relatively stable interval.
            if (this._minElapsedMS) {
                var delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS;
            this.deltaTime = this.deltaMS * (0, $ezJmd.settings).TARGET_FPMS;
            // Cache a local reference, in-case ticker is destroyed
            // during the emit, we can still check for head.next
            var head = this._head;
            // Invoke listeners added to internal emitter
            var listener = head.next;
            while(listener)listener = listener.emit(this.deltaTime);
            if (!head.next) this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    };
    Object.defineProperty(Ticker.prototype, "FPS", {
        /**
         * The frames per second at which this ticker is running.
         * The default is approximately 60 in most modern browsers.
         * **Note:** This does not factor in the value of
         * {@link PIXI.Ticker#speed}, which is specific
         * to scaling {@link PIXI.Ticker#deltaTime}.
         *
         * @member {number}
         * @readonly
         */ get: function() {
            return 1000 / this.elapsedMS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ticker.prototype, "minFPS", {
        /**
         * Manages the maximum amount of milliseconds allowed to
         * elapse between invoking {@link PIXI.Ticker#update}.
         * This value is used to cap {@link PIXI.Ticker#deltaTime},
         * but does not effect the measured value of {@link PIXI.Ticker#FPS}.
         * When setting this property it is clamped to a value between
         * `0` and `PIXI.settings.TARGET_FPMS * 1000`.
         *
         * @member {number}
         * @default 10
         */ get: function() {
            return 1000 / this._maxElapsedMS;
        },
        set: function(fps) {
            // Minimum must be below the maxFPS
            var minFPS = Math.min(this.maxFPS, fps);
            // Must be at least 0, but below 1 / settings.TARGET_FPMS
            var minFPMS = Math.min(Math.max(0, minFPS) / 1000, (0, $ezJmd.settings).TARGET_FPMS);
            this._maxElapsedMS = 1 / minFPMS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ticker.prototype, "maxFPS", {
        /**
         * Manages the minimum amount of milliseconds required to
         * elapse between invoking {@link PIXI.Ticker#update}.
         * This will effect the measured value of {@link PIXI.Ticker#FPS}.
         * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
         * Otherwise it will be at least `minFPS`
         *
         * @member {number}
         * @default 0
         */ get: function() {
            if (this._minElapsedMS) return Math.round(1000 / this._minElapsedMS);
            return 0;
        },
        set: function(fps) {
            if (fps === 0) this._minElapsedMS = 0;
            else {
                // Max must be at least the minFPS
                var maxFPS = Math.max(this.minFPS, fps);
                this._minElapsedMS = 1 / (maxFPS / 1000);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ticker, "shared", {
        /**
         * The shared ticker instance used by {@link PIXI.AnimatedSprite} and by
         * {@link PIXI.VideoResource} to update animation frames / video textures.
         *
         * It may also be used by {@link PIXI.Application} if created with the `sharedTicker` option property set to true.
         *
         * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
         * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
         *
         * @example
         * let ticker = PIXI.Ticker.shared;
         * // Set this to prevent starting this ticker when listeners are added.
         * // By default this is true only for the PIXI.Ticker.shared instance.
         * ticker.autoStart = false;
         * // FYI, call this to ensure the ticker is stopped. It should be stopped
         * // if you have not attempted to render anything yet.
         * ticker.stop();
         * // Call this when you are ready for a running shared ticker.
         * ticker.start();
         *
         * @example
         * // You may use the shared ticker to render...
         * let renderer = PIXI.autoDetectRenderer();
         * let stage = new PIXI.Container();
         * document.body.appendChild(renderer.view);
         * ticker.add(function (time) {
         *     renderer.render(stage);
         * });
         *
         * @example
         * // Or you can just update it manually.
         * ticker.autoStart = false;
         * ticker.stop();
         * function animate(time) {
         *     ticker.update(time);
         *     renderer.render(stage);
         *     requestAnimationFrame(animate);
         * }
         * animate(performance.now());
         *
         * @member {PIXI.Ticker}
         * @static
         */ get: function() {
            if (!Ticker._shared) {
                var shared = Ticker._shared = new Ticker();
                shared.autoStart = true;
                shared._protected = true;
            }
            return Ticker._shared;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ticker, "system", {
        /**
         * The system ticker instance used by {@link PIXI.InteractionManager} and by
         * {@link PIXI.BasePrepare} for core timing functionality that shouldn't usually need to be paused,
         * unlike the `shared` ticker which drives visual animations and rendering which may want to be paused.
         *
         * The property {@link PIXI.Ticker#autoStart} is set to `true` for this instance.
         *
         * @member {PIXI.Ticker}
         * @static
         */ get: function() {
            if (!Ticker._system) {
                var system = Ticker._system = new Ticker();
                system.autoStart = true;
                system._protected = true;
            }
            return Ticker._system;
        },
        enumerable: false,
        configurable: true
    });
    return Ticker;
}();
/**
 * Middleware for for Application Ticker.
 *
 * @example
 * import {TickerPlugin} from '@pixi/ticker';
 * import {Application} from '@pixi/app';
 * Application.registerPlugin(TickerPlugin);
 *
 * @class
 * @memberof PIXI
 */ var $2e521452c1952d1b$export$50c361ceb4e2f4f0 = /** @class */ function() {
    function TickerPlugin() {}
    /**
     * Initialize the plugin with scope of application instance
     *
     * @static
     * @private
     * @param {object} [options] - See application options
     */ TickerPlugin.init = function(options) {
        var _this = this;
        // Set default
        options = Object.assign({
            autoStart: true,
            sharedTicker: false
        }, options);
        // Create ticker setter
        Object.defineProperty(this, 'ticker', {
            set: function(ticker) {
                if (this._ticker) this._ticker.remove(this.render, this);
                this._ticker = ticker;
                if (ticker) ticker.add(this.render, this, $2e521452c1952d1b$export$688aaf132ba9b379.LOW);
            },
            get: function() {
                return this._ticker;
            }
        });
        /**
         * Convenience method for stopping the render.
         *
         * @method
         * @memberof PIXI.Application
         * @instance
         */ this.stop = function() {
            _this._ticker.stop();
        };
        /**
         * Convenience method for starting the render.
         *
         * @method
         * @memberof PIXI.Application
         * @instance
         */ this.start = function() {
            _this._ticker.start();
        };
        /**
         * Internal reference to the ticker.
         *
         * @type {PIXI.Ticker}
         * @name _ticker
         * @memberof PIXI.Application#
         * @private
         */ this._ticker = null;
        /**
         * Ticker for doing render updates.
         *
         * @type {PIXI.Ticker}
         * @name ticker
         * @memberof PIXI.Application#
         * @default PIXI.Ticker.shared
         */ this.ticker = options.sharedTicker ? $2e521452c1952d1b$export$39c54bcc89dcee11.shared : new $2e521452c1952d1b$export$39c54bcc89dcee11();
        // Start the rendering
        if (options.autoStart) this.start();
    };
    /**
     * Clean up the ticker, scoped to application.
     *
     * @static
     * @private
     */ TickerPlugin.destroy = function() {
        if (this._ticker) {
            var oldTicker = this._ticker;
            this.ticker = null;
            oldTicker.destroy();
        }
    };
    return TickerPlugin;
}();

});


parcelRegister("7DxQ2", function(module, exports) {

$parcel$export(module.exports, "Application", function () { return $58f66c8167568ee2$export$16975c34e60e1e61; });
/*!
 * @pixi/app - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/app is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $8t5Gy = parcelRequire("8t5Gy");

var $klOfb = parcelRequire("klOfb");
/**
 * Convenience class to create a new PIXI application.
 *
 * This class automatically creates the renderer, ticker and root container.
 *
 * @example
 * // Create the application
 * const app = new PIXI.Application();
 *
 * // Add the view to the DOM
 * document.body.appendChild(app.view);
 *
 * // ex, add display objects
 * app.stage.addChild(PIXI.Sprite.from('something.png'));
 *
 * @class
 * @memberof PIXI
 */ var $58f66c8167568ee2$export$16975c34e60e1e61 = /** @class */ function() {
    /**
     * @param {object} [options] - The optional renderer parameters.
     * @param {boolean} [options.autoStart=true] - Automatically starts the rendering after the construction.
     *     **Note**: Setting this parameter to false does NOT stop the shared ticker even if you set
     *     options.sharedTicker to true in case that it is already started. Stop it by your own.
     * @param {number} [options.width=800] - The width of the renderers view.
     * @param {number} [options.height=600] - The height of the renderers view.
     * @param {HTMLCanvasElement} [options.view] - The canvas to use as a view, optional.
     * @param {boolean} [options.useContextAlpha=true] - Pass-through value for canvas' context `alpha` property.
     *   If you want to set transparency, please use `backgroundAlpha`. This option is for cases where the
     *   canvas needs to be opaque, possibly for performance reasons on some older devices.
     * @param {boolean} [options.autoDensity=false] - Resizes renderer view in CSS pixels to allow for
     *   resolutions other than 1.
     * @param {boolean} [options.antialias=false] - Sets antialias
     * @param {boolean} [options.preserveDrawingBuffer=false] - Enables drawing buffer preservation, enable this if you
     *  need to call toDataUrl on the WebGL context.
     * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the renderer.
     * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present, this
     *   option only is available when using **pixi.js-legacy** or **@pixi/canvas-renderer** modules, otherwise
     *   it is ignored.
     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
     *  (shown if not transparent).
     * @param {number} [options.backgroundAlpha=1] - Value from 0 (fully transparent) to 1 (fully opaque).
     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
     *   not before the new render pass.
     * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
     *  for devices with dual graphics card. **(WebGL only)**.
     * @param {boolean} [options.sharedTicker=false] - `true` to use PIXI.Ticker.shared, `false` to create new ticker.
     *  If set to false, you cannot register a handler to occur before anything that runs on the shared ticker.
     *  The system ticker will always run before both the shared ticker and the app ticker.
     * @param {boolean} [options.sharedLoader=false] - `true` to use PIXI.Loader.shared, `false` to create new Loader.
     * @param {Window|HTMLElement} [options.resizeTo] - Element to automatically resize stage to.
     */ function Application(options) {
        var _this = this;
        /**
         * The root display container that's rendered.
         * @member {PIXI.Container}
         */ this.stage = new (0, $8t5Gy.Container)();
        // The default options
        options = Object.assign({
            forceCanvas: false
        }, options);
        this.renderer = (0, $klOfb.autoDetectRenderer)(options);
        // install plugins here
        Application._plugins.forEach(function(plugin) {
            plugin.init.call(_this, options);
        });
    }
    /**
     * Register a middleware plugin for the application
     * @static
     * @param {PIXI.IApplicationPlugin} plugin - Plugin being installed
     */ Application.registerPlugin = function(plugin) {
        Application._plugins.push(plugin);
    };
    /**
     * Render the current stage.
     */ Application.prototype.render = function() {
        this.renderer.render(this.stage);
    };
    Object.defineProperty(Application.prototype, "view", {
        /**
         * Reference to the renderer's canvas element.
         * @member {HTMLCanvasElement}
         * @readonly
         */ get: function() {
            return this.renderer.view;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Application.prototype, "screen", {
        /**
         * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
         * @member {PIXI.Rectangle}
         * @readonly
         */ get: function() {
            return this.renderer.screen;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Destroy and don't use after this.
     * @param {Boolean} [removeView=false] - Automatically remove canvas from DOM.
     * @param {object|boolean} [stageOptions] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [stageOptions.children=false] - if set to true, all the children will have their destroy
     *  method called as well. 'stageOptions' will be passed on to those calls.
     * @param {boolean} [stageOptions.texture=false] - Only used for child Sprites if stageOptions.children is set
     *  to true. Should it destroy the texture of the child sprite
     * @param {boolean} [stageOptions.baseTexture=false] - Only used for child Sprites if stageOptions.children is set
     *  to true. Should it destroy the base texture of the child sprite
     */ Application.prototype.destroy = function(removeView, stageOptions) {
        var _this = this;
        // Destroy plugins in the opposite order
        // which they were constructed
        var plugins = Application._plugins.slice(0);
        plugins.reverse();
        plugins.forEach(function(plugin) {
            plugin.destroy.call(_this);
        });
        this.stage.destroy(stageOptions);
        this.stage = null;
        this.renderer.destroy(removeView);
        this.renderer = null;
    };
    /** Collection of installed plugins. */ Application._plugins = [];
    return Application;
}();
/**
 * Middleware for for Application's resize functionality
 * @private
 * @class
 */ var $58f66c8167568ee2$var$ResizePlugin = /** @class */ function() {
    function ResizePlugin() {}
    /**
     * Initialize the plugin with scope of application instance
     * @static
     * @private
     * @param {object} [options] - See application options
     */ ResizePlugin.init = function(options) {
        var _this = this;
        Object.defineProperty(this, 'resizeTo', /**
         * The HTML element or window to automatically resize the
         * renderer's view element to match width and height.
         * @member {Window|HTMLElement}
         * @name resizeTo
         * @memberof PIXI.Application#
         */ {
            set: function(dom) {
                self.removeEventListener('resize', this.queueResize);
                this._resizeTo = dom;
                if (dom) {
                    self.addEventListener('resize', this.queueResize);
                    this.resize();
                }
            },
            get: function() {
                return this._resizeTo;
            }
        });
        /**
         * Resize is throttled, so it's safe to call this multiple times per frame and it'll
         * only be called once.
         *
         * @memberof PIXI.Application#
         * @method queueResize
         * @private
         */ this.queueResize = function() {
            if (!_this._resizeTo) return;
            _this.cancelResize();
            // // Throttle resize events per raf
            _this._resizeId = requestAnimationFrame(function() {
                return _this.resize();
            });
        };
        /**
         * Cancel the resize queue.
         *
         * @memberof PIXI.Application#
         * @method cancelResize
         * @private
         */ this.cancelResize = function() {
            if (_this._resizeId) {
                cancelAnimationFrame(_this._resizeId);
                _this._resizeId = null;
            }
        };
        /**
         * Execute an immediate resize on the renderer, this is not
         * throttled and can be expensive to call many times in a row.
         * Will resize only if `resizeTo` property is set.
         *
         * @memberof PIXI.Application#
         * @method resize
         */ this.resize = function() {
            if (!_this._resizeTo) return;
            // clear queue resize
            _this.cancelResize();
            var width;
            var height;
            // Resize to the window
            if (_this._resizeTo === self) {
                width = self.innerWidth;
                height = self.innerHeight;
            } else {
                var _a = _this._resizeTo, clientWidth = _a.clientWidth, clientHeight = _a.clientHeight;
                width = clientWidth;
                height = clientHeight;
            }
            _this.renderer.resize(width, height);
        };
        // On resize
        this._resizeId = null;
        this._resizeTo = null;
        this.resizeTo = options.resizeTo || null;
    };
    /**
     * Clean up the ticker, scoped to application
     *
     * @static
     * @private
     */ ResizePlugin.destroy = function() {
        self.removeEventListener('resize', this.queueResize);
        this.cancelResize();
        this.cancelResize = null;
        this.queueResize = null;
        this.resizeTo = null;
        this.resize = null;
    };
    return ResizePlugin;
}();
$58f66c8167568ee2$export$16975c34e60e1e61.registerPlugin($58f66c8167568ee2$var$ResizePlugin);

});
parcelRegister("klOfb", function(module, exports) {

$parcel$export(module.exports, "INSTALLED", function () { return INSTALLED; });
$parcel$export(module.exports, "autoDetectResource", function () { return autoDetectResource; });
$parcel$export(module.exports, "Resource", function () { return Resource; });
$parcel$export(module.exports, "BufferResource", function () { return BufferResource; });
$parcel$export(module.exports, "BaseTexture", function () { return BaseTexture; });
$parcel$export(module.exports, "AbstractMultiResource", function () { return AbstractMultiResource; });
$parcel$export(module.exports, "ArrayResource", function () { return ArrayResource; });
$parcel$export(module.exports, "BaseImageResource", function () { return BaseImageResource; });
$parcel$export(module.exports, "CanvasResource", function () { return CanvasResource; });
$parcel$export(module.exports, "CubeResource", function () { return CubeResource; });
$parcel$export(module.exports, "ImageResource", function () { return ImageResource; });
$parcel$export(module.exports, "SVGResource", function () { return SVGResource; });
$parcel$export(module.exports, "VideoResource", function () { return VideoResource; });
$parcel$export(module.exports, "ImageBitmapResource", function () { return ImageBitmapResource; });
$parcel$export(module.exports, "Framebuffer", function () { return Framebuffer; });
$parcel$export(module.exports, "BaseRenderTexture", function () { return BaseRenderTexture; });
$parcel$export(module.exports, "TextureUvs", function () { return TextureUvs; });
$parcel$export(module.exports, "Texture", function () { return Texture; });
$parcel$export(module.exports, "RenderTexture", function () { return RenderTexture; });
$parcel$export(module.exports, "RenderTexturePool", function () { return RenderTexturePool; });
$parcel$export(module.exports, "Attribute", function () { return Attribute; });
$parcel$export(module.exports, "Buffer", function () { return Buffer; });
$parcel$export(module.exports, "Geometry", function () { return Geometry; });
$parcel$export(module.exports, "Quad", function () { return Quad; });
$parcel$export(module.exports, "QuadUv", function () { return QuadUv; });
$parcel$export(module.exports, "UniformGroup", function () { return UniformGroup; });
$parcel$export(module.exports, "FilterState", function () { return FilterState; });
$parcel$export(module.exports, "FilterSystem", function () { return FilterSystem; });
$parcel$export(module.exports, "ObjectRenderer", function () { return ObjectRenderer; });
$parcel$export(module.exports, "BatchSystem", function () { return BatchSystem; });
$parcel$export(module.exports, "ContextSystem", function () { return ContextSystem; });
$parcel$export(module.exports, "GLFramebuffer", function () { return GLFramebuffer; });
$parcel$export(module.exports, "FramebufferSystem", function () { return FramebufferSystem; });
$parcel$export(module.exports, "GeometrySystem", function () { return GeometrySystem; });
$parcel$export(module.exports, "MaskData", function () { return MaskData; });
$parcel$export(module.exports, "getTestContext", function () { return getTestContext; });
$parcel$export(module.exports, "uniformParsers", function () { return uniformParsers; });
$parcel$export(module.exports, "checkMaxIfStatementsInShader", function () { return checkMaxIfStatementsInShader; });
$parcel$export(module.exports, "Program", function () { return Program; });
$parcel$export(module.exports, "Shader", function () { return Shader; });
$parcel$export(module.exports, "State", function () { return State; });
$parcel$export(module.exports, "Filter", function () { return Filter; });
$parcel$export(module.exports, "TextureMatrix", function () { return TextureMatrix; });
$parcel$export(module.exports, "SpriteMaskFilter", function () { return SpriteMaskFilter; });
$parcel$export(module.exports, "MaskSystem", function () { return MaskSystem; });
$parcel$export(module.exports, "ScissorSystem", function () { return ScissorSystem; });
$parcel$export(module.exports, "StencilSystem", function () { return StencilSystem; });
$parcel$export(module.exports, "ProjectionSystem", function () { return ProjectionSystem; });
$parcel$export(module.exports, "RenderTextureSystem", function () { return RenderTextureSystem; });
$parcel$export(module.exports, "createUBOElements", function () { return createUBOElements; });
$parcel$export(module.exports, "getUBOData", function () { return getUBOData; });
$parcel$export(module.exports, "generateUniformBufferSync", function () { return generateUniformBufferSync; });
$parcel$export(module.exports, "IGLUniformData", function () { return IGLUniformData; });
$parcel$export(module.exports, "GLProgram", function () { return GLProgram; });
$parcel$export(module.exports, "generateProgram", function () { return generateProgram; });
$parcel$export(module.exports, "ShaderSystem", function () { return ShaderSystem; });
$parcel$export(module.exports, "StateSystem", function () { return StateSystem; });
$parcel$export(module.exports, "TextureGCSystem", function () { return TextureGCSystem; });
$parcel$export(module.exports, "GLTexture", function () { return GLTexture; });
$parcel$export(module.exports, "TextureSystem", function () { return TextureSystem; });
$parcel$export(module.exports, "AbstractRenderer", function () { return AbstractRenderer; });
$parcel$export(module.exports, "Renderer", function () { return Renderer; });
$parcel$export(module.exports, "autoDetectRenderer", function () { return autoDetectRenderer; });
$parcel$export(module.exports, "defaultVertex", function () { return defaultVertex$2; });
$parcel$export(module.exports, "defaultFilterVertex", function () { return defaultFilterVertex; });
$parcel$export(module.exports, "System", function () { return System; });
$parcel$export(module.exports, "BatchDrawCall", function () { return BatchDrawCall; });
$parcel$export(module.exports, "BatchTextureArray", function () { return BatchTextureArray; });
$parcel$export(module.exports, "ViewableBuffer", function () { return ViewableBuffer; });
$parcel$export(module.exports, "AbstractBatchRenderer", function () { return AbstractBatchRenderer; });
$parcel$export(module.exports, "BatchShaderGenerator", function () { return BatchShaderGenerator; });
$parcel$export(module.exports, "BatchGeometry", function () { return BatchGeometry; });
$parcel$export(module.exports, "BatchPluginFactory", function () { return BatchPluginFactory; });
$parcel$export(module.exports, "BatchRenderer", function () { return BatchRenderer; });
$parcel$export(module.exports, "resources", function () { return resources; });
$parcel$export(module.exports, "systems", function () { return systems; });
/*!
 * @pixi/core - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/core is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $ezJmd = parcelRequire("ezJmd");

var $P8XPi = parcelRequire("P8XPi");
parcelRequire("csytw");
var $ezJmd = parcelRequire("ezJmd");
var $csytw = parcelRequire("csytw");
var $6p5EE = parcelRequire("6p5EE");

var $6fZag = parcelRequire("6fZag");

var $3YyWq = parcelRequire("3YyWq");

var $6qzqq = parcelRequire("6qzqq");
/**
 * The maximum support for using WebGL. If a device does not
 * support WebGL version, for instance WebGL 2, it will still
 * attempt to fallback support to WebGL 1. If you want to
 * explicitly remove feature support to target a more stable
 * baseline, prefer a lower environment.
 *
 * Due to {@link https://bugs.chromium.org/p/chromium/issues/detail?id=934823|bug in chromium}
 * we disable webgl2 by default for all non-apple mobile devices.
 *
 * @static
 * @name PREFER_ENV
 * @memberof PIXI.settings
 * @type {number}
 * @default PIXI.ENV.WEBGL2
 */ (0, $ezJmd.settings).PREFER_ENV = (0, $ezJmd.isMobile).any ? (0, $P8XPi.ENV).WEBGL : (0, $P8XPi.ENV).WEBGL2;
/**
 * If set to `true`, *only* Textures and BaseTexture objects stored
 * in the caches ({@link PIXI.utils.TextureCache TextureCache} and
 * {@link PIXI.utils.BaseTextureCache BaseTextureCache}) can be
 * used when calling {@link PIXI.Texture.from Texture.from} or
 * {@link PIXI.BaseTexture.from BaseTexture.from}.
 * Otherwise, these `from` calls throw an exception. Using this property
 * can be useful if you want to enforce preloading all assets with
 * {@link PIXI.Loader Loader}.
 *
 * @static
 * @name STRICT_TEXTURE_CACHE
 * @memberof PIXI.settings
 * @type {boolean}
 * @default false
 */ (0, $ezJmd.settings).STRICT_TEXTURE_CACHE = false;
/**
 * Collection of installed resource types, class must extend {@link PIXI.Resource}.
 * @example
 * class CustomResource extends PIXI.Resource {
 *   // MUST have source, options constructor signature
 *   // for auto-detected resources to be created.
 *   constructor(source, options) {
 *     super();
 *   }
 *   upload(renderer, baseTexture, glTexture) {
 *     // upload with GL
 *     return true;
 *   }
 *   // used to auto-detect resource
 *   static test(source, extension) {
 *     return extension === 'xyz'|| source instanceof SomeClass;
 *   }
 * }
 * // Install the new resource type
 * PIXI.INSTALLED.push(CustomResource);
 *
 * @memberof PIXI
 * @type {Array<PIXI.IResourcePlugin>}
 * @static
 * @readonly
 */ var INSTALLED = [];
/**
 * Create a resource element from a single source element. This
 * auto-detects which type of resource to create. All resources that
 * are auto-detectable must have a static `test` method and a constructor
 * with the arguments `(source, options?)`. Currently, the supported
 * resources for auto-detection include:
 *  - {@link PIXI.ImageResource}
 *  - {@link PIXI.CanvasResource}
 *  - {@link PIXI.VideoResource}
 *  - {@link PIXI.SVGResource}
 *  - {@link PIXI.BufferResource}
 * @static
 * @memberof PIXI
 * @function autoDetectResource
 * @param {string|*} source - Resource source, this can be the URL to the resource,
 *        a typed-array (for BufferResource), HTMLVideoElement, SVG data-uri
 *        or any other resource that can be auto-detected. If not resource is
 *        detected, it's assumed to be an ImageResource.
 * @param {object} [options] - Pass-through options to use for Resource
 * @param {number} [options.width] - Width of BufferResource or SVG rasterization
 * @param {number} [options.height] - Height of BufferResource or SVG rasterization
 * @param {boolean} [options.autoLoad=true] - Image, SVG and Video flag to start loading
 * @param {number} [options.scale=1] - SVG source scale. Overridden by width, height
 * @param {boolean} [options.createBitmap=PIXI.settings.CREATE_IMAGE_BITMAP] - Image option to create Bitmap object
 * @param {boolean} [options.crossorigin=true] - Image and Video option to set crossOrigin
 * @param {boolean} [options.autoPlay=true] - Video option to start playing video immediately
 * @param {number} [options.updateFPS=0] - Video option to update how many times a second the
 *        texture should be updated from the video. Leave at 0 to update at every render
 * @return {PIXI.Resource} The created resource.
 */ function autoDetectResource(source, options) {
    if (!source) return null;
    var extension = '';
    if (typeof source === 'string') {
        // search for file extension: period, 3-4 chars, then ?, # or EOL
        var result = /\.(\w{3,4})(?:$|\?|#)/i.exec(source);
        if (result) extension = result[1].toLowerCase();
    }
    for(var i = INSTALLED.length - 1; i >= 0; --i){
        var ResourcePlugin = INSTALLED[i];
        if (ResourcePlugin.test && ResourcePlugin.test(source, extension)) return new ResourcePlugin(source, options);
    }
    throw new Error('Unrecognized source type to auto-detect Resource');
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        var arguments$1 = arguments;
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments$1[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
}
/**
 * Base resource class for textures that manages validation and uploading, depending on its type.
 *
 * Uploading of a base texture to the GPU is required.
 *
 * @memberof PIXI
 */ var Resource = /** @class */ function() {
    /**
     * @param width - Width of the resource
     * @param height - Height of the resource
     */ function Resource(width, height) {
        if (width === void 0) width = 0;
        if (height === void 0) height = 0;
        this._width = width;
        this._height = height;
        this.destroyed = false;
        this.internal = false;
        this.onResize = new (0, $6fZag.Runner)('setRealSize');
        this.onUpdate = new (0, $6fZag.Runner)('update');
        this.onError = new (0, $6fZag.Runner)('onError');
    }
    /**
     * Bind to a parent BaseTexture
     *
     * @param baseTexture - Parent texture
     */ Resource.prototype.bind = function(baseTexture) {
        this.onResize.add(baseTexture);
        this.onUpdate.add(baseTexture);
        this.onError.add(baseTexture);
        // Call a resize immediate if we already
        // have the width and height of the resource
        if (this._width || this._height) this.onResize.emit(this._width, this._height);
    };
    /**
     * Unbind to a parent BaseTexture
     *
     * @param baseTexture - Parent texture
     */ Resource.prototype.unbind = function(baseTexture) {
        this.onResize.remove(baseTexture);
        this.onUpdate.remove(baseTexture);
        this.onError.remove(baseTexture);
    };
    /**
     * Trigger a resize event
     *
     * @param width - X dimension
     * @param height - Y dimension
     */ Resource.prototype.resize = function(width, height) {
        if (width !== this._width || height !== this._height) {
            this._width = width;
            this._height = height;
            this.onResize.emit(width, height);
        }
    };
    Object.defineProperty(Resource.prototype, "valid", {
        /**
         * Has been validated
         *
         * @readonly
         */ get: function() {
            return !!this._width && !!this._height;
        },
        enumerable: false,
        configurable: true
    });
    /** Has been updated trigger event. */ Resource.prototype.update = function() {
        if (!this.destroyed) this.onUpdate.emit();
    };
    /**
     * This can be overridden to start preloading a resource
     * or do any other prepare step.
     *
     * @protected
     * @return Handle the validate event
     */ Resource.prototype.load = function() {
        return Promise.resolve(this);
    };
    Object.defineProperty(Resource.prototype, "width", {
        /**
         * The width of the resource.
         *
         * @readonly
         */ get: function() {
            return this._width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "height", {
        /**
         * The height of the resource.
         *
         * @readonly
         */ get: function() {
            return this._height;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Set the style, optional to override
     *
     * @param renderer - yeah, renderer!
     * @param baseTexture - the texture
     * @param glTexture - texture instance for this webgl context
     * @returns - `true` is success
     */ Resource.prototype.style = function(_renderer, _baseTexture, _glTexture) {
        return false;
    };
    /** Clean up anything, this happens when destroying is ready. */ Resource.prototype.dispose = function() {
    // override
    };
    /**
     * Call when destroying resource, unbind any BaseTexture object
     * before calling this method, as reference counts are maintained
     * internally.
     */ Resource.prototype.destroy = function() {
        if (!this.destroyed) {
            this.destroyed = true;
            this.dispose();
            this.onError.removeAll();
            this.onError = null;
            this.onResize.removeAll();
            this.onResize = null;
            this.onUpdate.removeAll();
            this.onUpdate = null;
        }
    };
    /**
     * Abstract, used to auto-detect resource type.
     *
     * @param {*} source - The source object
     * @param {string} extension - The extension of source, if set
     */ Resource.test = function(_source, _extension) {
        return false;
    };
    return Resource;
}();
/**
 * @interface SharedArrayBuffer
 */ /**
 * Buffer resource with data of typed array.
 *
 * @memberof PIXI
 */ var BufferResource = /** @class */ function(_super) {
    __extends(BufferResource, _super);
    /**
     * @param source - Source buffer
     * @param options - Options
     * @param {number} options.width - Width of the texture
     * @param {number} options.height - Height of the texture
     */ function BufferResource(source, options) {
        var _this = this;
        var _a = options || {}, width = _a.width, height = _a.height;
        if (!width || !height) throw new Error('BufferResource width or height invalid');
        _this = _super.call(this, width, height) || this;
        _this.data = source;
        return _this;
    }
    /**
     * Upload the texture to the GPU.
     *
     * @param renderer - Upload to the renderer
     * @param baseTexture - Reference to parent texture
     * @param glTexture - glTexture
     * @returns - true is success
     */ BufferResource.prototype.upload = function(renderer, baseTexture, glTexture) {
        var gl = renderer.gl;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $P8XPi.ALPHA_MODES).UNPACK);
        var width = baseTexture.realWidth;
        var height = baseTexture.realHeight;
        if (glTexture.width === width && glTexture.height === height) gl.texSubImage2D(baseTexture.target, 0, 0, 0, width, height, baseTexture.format, glTexture.type, this.data);
        else {
            glTexture.width = width;
            glTexture.height = height;
            gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, width, height, 0, baseTexture.format, glTexture.type, this.data);
        }
        return true;
    };
    /** Destroy and don't use after this. */ BufferResource.prototype.dispose = function() {
        this.data = null;
    };
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @return {boolean} `true` if <canvas>
     */ BufferResource.test = function(source) {
        return source instanceof Float32Array || source instanceof Uint8Array || source instanceof Uint32Array;
    };
    return BufferResource;
}(Resource);
var defaultBufferOptions = {
    scaleMode: (0, $P8XPi.SCALE_MODES).NEAREST,
    format: (0, $P8XPi.FORMATS).RGBA,
    alphaMode: (0, $P8XPi.ALPHA_MODES).NPM
};
/**
 * A Texture stores the information that represents an image.
 * All textures have a base texture, which contains information about the source.
 * Therefore you can have many textures all using a single BaseTexture
 *
 * @class
 * @extends PIXI.utils.EventEmitter
 * @memberof PIXI
 * @typeParam R - The BaseTexture's Resource type.
 * @typeParam RO - The options for constructing resource.
 */ var BaseTexture = /** @class */ function(_super) {
    __extends(BaseTexture, _super);
    /**
     * @param {PIXI.Resource|string|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} [resource=null] -
     *        The current resource to use, for things that aren't Resource objects, will be converted
     *        into a Resource.
     * @param {Object} [options] - Collection of options
     * @param {PIXI.MIPMAP_MODES} [options.mipmap=PIXI.settings.MIPMAP_TEXTURES] - If mipmapping is enabled for texture
     * @param {number} [options.anisotropicLevel=PIXI.settings.ANISOTROPIC_LEVEL] - Anisotropic filtering level of texture
     * @param {PIXI.WRAP_MODES} [options.wrapMode=PIXI.settings.WRAP_MODE] - Wrap mode for textures
     * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.settings.SCALE_MODE] - Default scale mode, linear, nearest
     * @param {PIXI.FORMATS} [options.format=PIXI.FORMATS.RGBA] - GL format type
     * @param {PIXI.TYPES} [options.type=PIXI.TYPES.UNSIGNED_BYTE] - GL data type
     * @param {PIXI.TARGETS} [options.target=PIXI.TARGETS.TEXTURE_2D] - GL texture target
     * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.UNPACK] - Pre multiply the image alpha
     * @param {number} [options.width=0] - Width of the texture
     * @param {number} [options.height=0] - Height of the texture
     * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - Resolution of the base texture
     * @param {object} [options.resourceOptions] - Optional resource options,
     *        see {@link PIXI.autoDetectResource autoDetectResource}
     */ function BaseTexture(resource, options) {
        if (resource === void 0) resource = null;
        if (options === void 0) options = null;
        var _this = _super.call(this) || this;
        options = options || {};
        var alphaMode = options.alphaMode, mipmap = options.mipmap, anisotropicLevel = options.anisotropicLevel, scaleMode = options.scaleMode, width = options.width, height = options.height, wrapMode = options.wrapMode, format = options.format, type = options.type, target = options.target, resolution = options.resolution, resourceOptions = options.resourceOptions;
        // Convert the resource to a Resource object
        if (resource && !(resource instanceof Resource)) {
            resource = autoDetectResource(resource, resourceOptions);
            resource.internal = true;
        }
        _this.resolution = resolution || (0, $ezJmd.settings).RESOLUTION;
        _this.width = Math.round((width || 0) * _this.resolution) / _this.resolution;
        _this.height = Math.round((height || 0) * _this.resolution) / _this.resolution;
        _this._mipmap = mipmap !== undefined ? mipmap : (0, $ezJmd.settings).MIPMAP_TEXTURES;
        _this.anisotropicLevel = anisotropicLevel !== undefined ? anisotropicLevel : (0, $ezJmd.settings).ANISOTROPIC_LEVEL;
        _this._wrapMode = wrapMode || (0, $ezJmd.settings).WRAP_MODE;
        _this._scaleMode = scaleMode !== undefined ? scaleMode : (0, $ezJmd.settings).SCALE_MODE;
        _this.format = format || (0, $P8XPi.FORMATS).RGBA;
        _this.type = type || (0, $P8XPi.TYPES).UNSIGNED_BYTE;
        _this.target = target || (0, $P8XPi.TARGETS).TEXTURE_2D;
        _this.alphaMode = alphaMode !== undefined ? alphaMode : (0, $P8XPi.ALPHA_MODES).UNPACK;
        _this.uid = (0, $csytw.uid)();
        _this.touched = 0;
        _this.isPowerOfTwo = false;
        _this._refreshPOT();
        _this._glTextures = {};
        _this.dirtyId = 0;
        _this.dirtyStyleId = 0;
        _this.cacheId = null;
        _this.valid = width > 0 && height > 0;
        _this.textureCacheIds = [];
        _this.destroyed = false;
        _this.resource = null;
        _this._batchEnabled = 0;
        _this._batchLocation = 0;
        _this.parentTextureArray = null;
        /**
         * Fired when a not-immediately-available source finishes loading.
         *
         * @protected
         * @event PIXI.BaseTexture#loaded
         * @param {PIXI.BaseTexture} baseTexture - Resource loaded.
         */ /**
         * Fired when a not-immediately-available source fails to load.
         *
         * @protected
         * @event PIXI.BaseTexture#error
         * @param {PIXI.BaseTexture} baseTexture - Resource errored.
         * @param {ErrorEvent} event - Load error event.
         */ /**
         * Fired when BaseTexture is updated.
         *
         * @protected
         * @event PIXI.BaseTexture#loaded
         * @param {PIXI.BaseTexture} baseTexture - Resource loaded.
         */ /**
         * Fired when BaseTexture is updated.
         *
         * @protected
         * @event PIXI.BaseTexture#update
         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being updated.
         */ /**
         * Fired when BaseTexture is destroyed.
         *
         * @protected
         * @event PIXI.BaseTexture#dispose
         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being destroyed.
         */ // Set the resource
        _this.setResource(resource);
        return _this;
    }
    Object.defineProperty(BaseTexture.prototype, "realWidth", {
        /**
         * Pixel width of the source of this texture
         *
         * @readonly
         * @member {number}
         */ get: function() {
            return Math.round(this.width * this.resolution);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTexture.prototype, "realHeight", {
        /**
         * Pixel height of the source of this texture
         *
         * @readonly
         * @member {number}
         */ get: function() {
            return Math.round(this.height * this.resolution);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTexture.prototype, "mipmap", {
        /**
         * Mipmap mode of the texture, affects downscaled images
         *
         * @member {PIXI.MIPMAP_MODES}
         * @default PIXI.settings.MIPMAP_TEXTURES
         */ get: function() {
            return this._mipmap;
        },
        set: function(value) {
            if (this._mipmap !== value) {
                this._mipmap = value;
                this.dirtyStyleId++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTexture.prototype, "scaleMode", {
        /**
         * The scale mode to apply when scaling this texture
         *
         * @member {PIXI.SCALE_MODES}
         * @default PIXI.settings.SCALE_MODE
         */ get: function() {
            return this._scaleMode;
        },
        set: function(value) {
            if (this._scaleMode !== value) {
                this._scaleMode = value;
                this.dirtyStyleId++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTexture.prototype, "wrapMode", {
        /**
         * How the texture wraps
         * @member {PIXI.WRAP_MODES}
         * @default PIXI.settings.WRAP_MODE
         */ get: function() {
            return this._wrapMode;
        },
        set: function(value) {
            if (this._wrapMode !== value) {
                this._wrapMode = value;
                this.dirtyStyleId++;
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Changes style options of BaseTexture
     *
     * @param {PIXI.SCALE_MODES} [scaleMode] - Pixi scalemode
     * @param {PIXI.MIPMAP_MODES} [mipmap] - enable mipmaps
     * @returns {PIXI.BaseTexture} this
     */ BaseTexture.prototype.setStyle = function(scaleMode, mipmap) {
        var dirty;
        if (scaleMode !== undefined && scaleMode !== this.scaleMode) {
            this.scaleMode = scaleMode;
            dirty = true;
        }
        if (mipmap !== undefined && mipmap !== this.mipmap) {
            this.mipmap = mipmap;
            dirty = true;
        }
        if (dirty) this.dirtyStyleId++;
        return this;
    };
    /**
     * Changes w/h/resolution. Texture becomes valid if width and height are greater than zero.
     *
     * @param {number} desiredWidth - Desired visual width
     * @param {number} desiredHeight - Desired visual height
     * @param {number} [resolution] - Optionally set resolution
     * @returns {PIXI.BaseTexture} this
     */ BaseTexture.prototype.setSize = function(desiredWidth, desiredHeight, resolution) {
        resolution = resolution || this.resolution;
        return this.setRealSize(desiredWidth * resolution, desiredHeight * resolution, resolution);
    };
    /**
     * Sets real size of baseTexture, preserves current resolution.
     *
     * @param {number} realWidth - Full rendered width
     * @param {number} realHeight - Full rendered height
     * @param {number} [resolution] - Optionally set resolution
     * @returns {PIXI.BaseTexture} this
     */ BaseTexture.prototype.setRealSize = function(realWidth, realHeight, resolution) {
        this.resolution = resolution || this.resolution;
        this.width = Math.round(realWidth) / this.resolution;
        this.height = Math.round(realHeight) / this.resolution;
        this._refreshPOT();
        this.update();
        return this;
    };
    /**
     * Refresh check for isPowerOfTwo texture based on size
     *
     * @private
     */ BaseTexture.prototype._refreshPOT = function() {
        this.isPowerOfTwo = (0, $csytw.isPow2)(this.realWidth) && (0, $csytw.isPow2)(this.realHeight);
    };
    /**
     * Changes resolution
     *
     * @param {number} resolution - res
     * @returns {PIXI.BaseTexture} this
     */ BaseTexture.prototype.setResolution = function(resolution) {
        var oldResolution = this.resolution;
        if (oldResolution === resolution) return this;
        this.resolution = resolution;
        if (this.valid) {
            this.width = Math.round(this.width * oldResolution) / resolution;
            this.height = Math.round(this.height * oldResolution) / resolution;
            this.emit('update', this);
        }
        this._refreshPOT();
        return this;
    };
    /**
     * Sets the resource if it wasn't set. Throws error if resource already present
     *
     * @param {PIXI.Resource} resource - that is managing this BaseTexture
     * @returns {PIXI.BaseTexture} this
     */ BaseTexture.prototype.setResource = function(resource) {
        if (this.resource === resource) return this;
        if (this.resource) throw new Error('Resource can be set only once');
        resource.bind(this);
        this.resource = resource;
        return this;
    };
    /**
     * Invalidates the object. Texture becomes valid if width and height are greater than zero.
     */ BaseTexture.prototype.update = function() {
        if (!this.valid) {
            if (this.width > 0 && this.height > 0) {
                this.valid = true;
                this.emit('loaded', this);
                this.emit('update', this);
            }
        } else {
            this.dirtyId++;
            this.dirtyStyleId++;
            this.emit('update', this);
        }
    };
    /**
     * Handle errors with resources.
     * @private
     * @param {ErrorEvent} event - Error event emitted.
     */ BaseTexture.prototype.onError = function(event) {
        this.emit('error', this, event);
    };
    /**
     * Destroys this base texture.
     * The method stops if resource doesn't want this texture to be destroyed.
     * Removes texture from all caches.
     */ BaseTexture.prototype.destroy = function() {
        // remove and destroy the resource
        if (this.resource) {
            this.resource.unbind(this);
            // only destroy resourced created internally
            if (this.resource.internal) this.resource.destroy();
            this.resource = null;
        }
        if (this.cacheId) {
            delete (0, $csytw.BaseTextureCache)[this.cacheId];
            delete (0, $csytw.TextureCache)[this.cacheId];
            this.cacheId = null;
        }
        // finally let the WebGL renderer know..
        this.dispose();
        BaseTexture.removeFromCache(this);
        this.textureCacheIds = null;
        this.destroyed = true;
    };
    /**
     * Frees the texture from WebGL memory without destroying this texture object.
     * This means you can still use the texture later which will upload it to GPU
     * memory again.
     *
     * @fires PIXI.BaseTexture#dispose
     */ BaseTexture.prototype.dispose = function() {
        this.emit('dispose', this);
    };
    /**
     * Utility function for BaseTexture|Texture cast
     */ BaseTexture.prototype.castToBaseTexture = function() {
        return this;
    };
    /**
     * Helper function that creates a base texture based on the source you provide.
     * The source can be - image url, image element, canvas element. If the
     * source is an image url or an image element and not in the base texture
     * cache, it will be created and loaded.
     *
     * @static
     * @param {string|HTMLImageElement|HTMLCanvasElement|SVGElement|HTMLVideoElement} source - The
     *        source to create base texture from.
     * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
     * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
     * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
     * @returns {PIXI.BaseTexture} The new base texture.
     */ BaseTexture.from = function(source, options, strict) {
        if (strict === void 0) strict = (0, $ezJmd.settings).STRICT_TEXTURE_CACHE;
        var isFrame = typeof source === 'string';
        var cacheId = null;
        if (isFrame) cacheId = source;
        else {
            if (!source._pixiId) {
                var prefix = options && options.pixiIdPrefix || 'pixiid';
                source._pixiId = prefix + "_" + (0, $csytw.uid)();
            }
            cacheId = source._pixiId;
        }
        var baseTexture = (0, $csytw.BaseTextureCache)[cacheId];
        // Strict-mode rejects invalid cacheIds
        if (isFrame && strict && !baseTexture) throw new Error("The cacheId \"" + cacheId + "\" does not exist in BaseTextureCache.");
        if (!baseTexture) {
            baseTexture = new BaseTexture(source, options);
            baseTexture.cacheId = cacheId;
            BaseTexture.addToCache(baseTexture, cacheId);
        }
        return baseTexture;
    };
    /**
     * Create a new BaseTexture with a BufferResource from a Float32Array.
     * RGBA values are floats from 0 to 1.
     * @static
     * @param {Float32Array|Uint8Array} buffer - The optional array to use, if no data
     *        is provided, a new Float32Array is created.
     * @param {number} width - Width of the resource
     * @param {number} height - Height of the resource
     * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
     * @return {PIXI.BaseTexture} The resulting new BaseTexture
     */ BaseTexture.fromBuffer = function(buffer, width, height, options) {
        buffer = buffer || new Float32Array(width * height * 4);
        var resource = new BufferResource(buffer, {
            width: width,
            height: height
        });
        var type = buffer instanceof Float32Array ? (0, $P8XPi.TYPES).FLOAT : (0, $P8XPi.TYPES).UNSIGNED_BYTE;
        return new BaseTexture(resource, Object.assign(defaultBufferOptions, options || {
            width: width,
            height: height,
            type: type
        }));
    };
    /**
     * Adds a BaseTexture to the global BaseTextureCache. This cache is shared across the whole PIXI object.
     *
     * @static
     * @param {PIXI.BaseTexture} baseTexture - The BaseTexture to add to the cache.
     * @param {string} id - The id that the BaseTexture will be stored against.
     */ BaseTexture.addToCache = function(baseTexture, id) {
        if (id) {
            if (baseTexture.textureCacheIds.indexOf(id) === -1) baseTexture.textureCacheIds.push(id);
            if ((0, $csytw.BaseTextureCache)[id]) // eslint-disable-next-line no-console
            console.warn("BaseTexture added to the cache with an id [" + id + "] that already had an entry");
            (0, $csytw.BaseTextureCache)[id] = baseTexture;
        }
    };
    /**
     * Remove a BaseTexture from the global BaseTextureCache.
     *
     * @static
     * @param {string|PIXI.BaseTexture} baseTexture - id of a BaseTexture to be removed, or a BaseTexture instance itself.
     * @return {PIXI.BaseTexture|null} The BaseTexture that was removed.
     */ BaseTexture.removeFromCache = function(baseTexture) {
        if (typeof baseTexture === 'string') {
            var baseTextureFromCache = (0, $csytw.BaseTextureCache)[baseTexture];
            if (baseTextureFromCache) {
                var index = baseTextureFromCache.textureCacheIds.indexOf(baseTexture);
                if (index > -1) baseTextureFromCache.textureCacheIds.splice(index, 1);
                delete (0, $csytw.BaseTextureCache)[baseTexture];
                return baseTextureFromCache;
            }
        } else if (baseTexture && baseTexture.textureCacheIds) {
            for(var i = 0; i < baseTexture.textureCacheIds.length; ++i)delete (0, $csytw.BaseTextureCache)[baseTexture.textureCacheIds[i]];
            baseTexture.textureCacheIds.length = 0;
            return baseTexture;
        }
        return null;
    };
    /**
     * Global number of the texture batch, used by multi-texture renderers
     *
     * @static
     * @member {number}
     */ BaseTexture._globalBatch = 0;
    return BaseTexture;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE))));
/**
 * Resource that can manage several resource (items) inside.
 * All resources need to have the same pixel size.
 * Parent class for CubeResource and ArrayResource
 *
 * @memberof PIXI
 */ var AbstractMultiResource = /** @class */ function(_super) {
    __extends(AbstractMultiResource, _super);
    /**
     * @param length
     * @param options - Options to for Resource constructor
     * @param {number} [options.width] - Width of the resource
     * @param {number} [options.height] - Height of the resource
     */ function AbstractMultiResource(length, options) {
        var _this = this;
        var _a = options || {}, width = _a.width, height = _a.height;
        _this = _super.call(this, width, height) || this;
        _this.items = [];
        _this.itemDirtyIds = [];
        for(var i = 0; i < length; i++){
            var partTexture = new BaseTexture();
            _this.items.push(partTexture);
            // -2 - first run of texture array upload
            // -1 - texture item was allocated
            // >=0 - texture item uploaded , in sync with items[i].dirtyId
            _this.itemDirtyIds.push(-2);
        }
        _this.length = length;
        _this._load = null;
        _this.baseTexture = null;
        return _this;
    }
    /**
     * Used from ArrayResource and CubeResource constructors.
     *
     * @param resources - Can be resources, image elements, canvas, etc. ,
     *  length should be same as constructor length
     * @param options - Detect options for resources
     */ AbstractMultiResource.prototype.initFromArray = function(resources, options) {
        for(var i = 0; i < this.length; i++){
            if (!resources[i]) continue;
            if (resources[i].castToBaseTexture) this.addBaseTextureAt(resources[i].castToBaseTexture(), i);
            else if (resources[i] instanceof Resource) this.addResourceAt(resources[i], i);
            else this.addResourceAt(autoDetectResource(resources[i], options), i);
        }
    };
    /** Destroy this BaseImageResource. */ AbstractMultiResource.prototype.dispose = function() {
        for(var i = 0, len = this.length; i < len; i++)this.items[i].destroy();
        this.items = null;
        this.itemDirtyIds = null;
        this._load = null;
    };
    /**
     * Set a resource by ID
     *
     * @param resource
     * @param index - Zero-based index of resource to set
     * @return - Instance for chaining
     */ AbstractMultiResource.prototype.addResourceAt = function(resource, index) {
        if (!this.items[index]) throw new Error("Index " + index + " is out of bounds");
        // Inherit the first resource dimensions
        if (resource.valid && !this.valid) this.resize(resource.width, resource.height);
        this.items[index].setResource(resource);
        return this;
    };
    /** Set the parent base texture. */ AbstractMultiResource.prototype.bind = function(baseTexture) {
        if (this.baseTexture !== null) throw new Error('Only one base texture per TextureArray is allowed');
        _super.prototype.bind.call(this, baseTexture);
        for(var i = 0; i < this.length; i++){
            this.items[i].parentTextureArray = baseTexture;
            this.items[i].on('update', baseTexture.update, baseTexture);
        }
    };
    /** Unset the parent base texture. */ AbstractMultiResource.prototype.unbind = function(baseTexture) {
        _super.prototype.unbind.call(this, baseTexture);
        for(var i = 0; i < this.length; i++){
            this.items[i].parentTextureArray = null;
            this.items[i].off('update', baseTexture.update, baseTexture);
        }
    };
    /**
     * Load all the resources simultaneously
     *
     * @return - When load is resolved
     */ AbstractMultiResource.prototype.load = function() {
        var _this = this;
        if (this._load) return this._load;
        var resources = this.items.map(function(item) {
            return item.resource;
        }).filter(function(item) {
            return item;
        });
        // TODO: also implement load part-by-part strategy
        var promises = resources.map(function(item) {
            return item.load();
        });
        this._load = Promise.all(promises).then(function() {
            var _a = _this.items[0], realWidth = _a.realWidth, realHeight = _a.realHeight;
            _this.resize(realWidth, realHeight);
            return Promise.resolve(_this);
        });
        return this._load;
    };
    return AbstractMultiResource;
}(Resource);
/**
 * A resource that contains a number of sources.
 *
 * @memberof PIXI
 */ var ArrayResource = /** @class */ function(_super) {
    __extends(ArrayResource, _super);
    /**
     * @param source - Number of items in array or the collection
     *        of image URLs to use. Can also be resources, image elements, canvas, etc.
     * @param options - Options to apply to {@link PIXI.autoDetectResource}
     * @param {number} [options.width] - Width of the resource
     * @param {number} [options.height] - Height of the resource
     */ function ArrayResource(source, options) {
        var _this = this;
        var _a = options || {}, width = _a.width, height = _a.height;
        var urls;
        var length;
        if (Array.isArray(source)) {
            urls = source;
            length = source.length;
        } else length = source;
        _this = _super.call(this, length, {
            width: width,
            height: height
        }) || this;
        if (urls) _this.initFromArray(urls, options);
        return _this;
    }
    /**
     * Set a baseTexture by ID,
     * ArrayResource just takes resource from it, nothing more
     *
     * @param baseTexture
     * @param index - Zero-based index of resource to set
     * @return - Instance for chaining
     */ ArrayResource.prototype.addBaseTextureAt = function(baseTexture, index) {
        if (baseTexture.resource) this.addResourceAt(baseTexture.resource, index);
        else throw new Error('ArrayResource does not support RenderTexture');
        return this;
    };
    /** Add binding */ ArrayResource.prototype.bind = function(baseTexture) {
        _super.prototype.bind.call(this, baseTexture);
        baseTexture.target = (0, $P8XPi.TARGETS).TEXTURE_2D_ARRAY;
    };
    /**
     * Upload the resources to the GPU.
     *
     * @param renderer
     * @param texture
     * @param glTexture
     * @returns - whether texture was uploaded
     */ ArrayResource.prototype.upload = function(renderer, texture, glTexture) {
        var _a = this, length = _a.length, itemDirtyIds = _a.itemDirtyIds, items = _a.items;
        var gl = renderer.gl;
        if (glTexture.dirtyId < 0) gl.texImage3D(gl.TEXTURE_2D_ARRAY, 0, glTexture.internalFormat, this._width, this._height, length, 0, texture.format, glTexture.type, null);
        for(var i = 0; i < length; i++){
            var item = items[i];
            if (itemDirtyIds[i] < item.dirtyId) {
                itemDirtyIds[i] = item.dirtyId;
                if (item.valid) gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, 0, i, item.resource.width, item.resource.height, 1, texture.format, glTexture.type, item.resource.source);
            }
        }
        return true;
    };
    return ArrayResource;
}(AbstractMultiResource);
/**
 * Base for all the image/canvas resources.
 *
 * @memberof PIXI
 */ var BaseImageResource = /** @class */ function(_super) {
    __extends(BaseImageResource, _super);
    /**
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|SVGElement} source
     */ function BaseImageResource(source) {
        var _this = this;
        var sourceAny = source;
        var width = sourceAny.naturalWidth || sourceAny.videoWidth || sourceAny.width;
        var height = sourceAny.naturalHeight || sourceAny.videoHeight || sourceAny.height;
        _this = _super.call(this, width, height) || this;
        _this.source = source;
        _this.noSubImage = false;
        return _this;
    }
    /**
     * Set cross origin based detecting the url and the crossorigin
     *
     * @param element - Element to apply crossOrigin
     * @param url - URL to check
     * @param crossorigin - Cross origin value to use
     */ BaseImageResource.crossOrigin = function(element, url, crossorigin) {
        if (crossorigin === undefined && url.indexOf('data:') !== 0) element.crossOrigin = (0, $csytw.determineCrossOrigin)(url);
        else if (crossorigin !== false) element.crossOrigin = typeof crossorigin === 'string' ? crossorigin : 'anonymous';
    };
    /**
     * Upload the texture to the GPU.
     *
     * @param renderer - Upload to the renderer
     * @param baseTexture - Reference to parent texture
     * @param glTexture
     * @param {HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|SVGElement} [source] - (optional)
     * @returns - true is success
     */ BaseImageResource.prototype.upload = function(renderer, baseTexture, glTexture, source) {
        var gl = renderer.gl;
        var width = baseTexture.realWidth;
        var height = baseTexture.realHeight;
        source = source || this.source;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $P8XPi.ALPHA_MODES).UNPACK);
        if (!this.noSubImage && baseTexture.target === gl.TEXTURE_2D && glTexture.width === width && glTexture.height === height) gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, baseTexture.format, glTexture.type, source);
        else {
            glTexture.width = width;
            glTexture.height = height;
            gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, baseTexture.format, glTexture.type, source);
        }
        return true;
    };
    /**
     * Checks if source width/height was changed, resize can cause extra baseTexture update.
     * Triggers one update in any case.
     */ BaseImageResource.prototype.update = function() {
        if (this.destroyed) return;
        var source = this.source;
        var width = source.naturalWidth || source.videoWidth || source.width;
        var height = source.naturalHeight || source.videoHeight || source.height;
        this.resize(width, height);
        _super.prototype.update.call(this);
    };
    /** Destroy this {@link BaseImageResource} */ BaseImageResource.prototype.dispose = function() {
        this.source = null;
    };
    return BaseImageResource;
}(Resource);
/**
 * @interface OffscreenCanvas
 */ /**
 * Resource type for HTMLCanvasElement.
 *
 * @memberof PIXI
 */ var CanvasResource = /** @class */ function(_super) {
    __extends(CanvasResource, _super);
    /**
     * @param source - Canvas element to use
     */ // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    function CanvasResource(source) {
        return _super.call(this, source) || this;
    }
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @return {boolean} `true` if source is HTMLCanvasElement or OffscreenCanvas
     */ CanvasResource.test = function(source) {
        var OffscreenCanvas = self.OffscreenCanvas;
        // Check for browsers that don't yet support OffscreenCanvas
        if (OffscreenCanvas && source instanceof OffscreenCanvas) return true;
        return self.HTMLCanvasElement && source instanceof HTMLCanvasElement;
    };
    return CanvasResource;
}(BaseImageResource);
/**
 * Resource for a CubeTexture which contains six resources.
 *
 * @memberof PIXI
 */ var CubeResource = /** @class */ function(_super) {
    __extends(CubeResource, _super);
    /**
     * @param {Array<string|PIXI.Resource>} [source] - Collection of URLs or resources
     *        to use as the sides of the cube.
     * @param options - ImageResource options
     * @param {number} [options.width] - Width of resource
     * @param {number} [options.height] - Height of resource
     * @param {number} [options.autoLoad=true] - Whether to auto-load resources
     * @param {number} [options.linkBaseTexture=true] - In case BaseTextures are supplied,
     *   whether to copy them or use
     */ function CubeResource(source, options) {
        var _this = this;
        var _a = options || {}, width = _a.width, height = _a.height, autoLoad = _a.autoLoad, linkBaseTexture = _a.linkBaseTexture;
        if (source && source.length !== CubeResource.SIDES) throw new Error("Invalid length. Got " + source.length + ", expected 6");
        _this = _super.call(this, 6, {
            width: width,
            height: height
        }) || this;
        for(var i = 0; i < CubeResource.SIDES; i++)_this.items[i].target = (0, $P8XPi.TARGETS).TEXTURE_CUBE_MAP_POSITIVE_X + i;
        _this.linkBaseTexture = linkBaseTexture !== false;
        if (source) _this.initFromArray(source, options);
        if (autoLoad !== false) _this.load();
        return _this;
    }
    /**
     * Add binding.
     *
     * @param baseTexture - parent base texture
     */ CubeResource.prototype.bind = function(baseTexture) {
        _super.prototype.bind.call(this, baseTexture);
        baseTexture.target = (0, $P8XPi.TARGETS).TEXTURE_CUBE_MAP;
    };
    CubeResource.prototype.addBaseTextureAt = function(baseTexture, index, linkBaseTexture) {
        if (linkBaseTexture === undefined) linkBaseTexture = this.linkBaseTexture;
        if (!this.items[index]) throw new Error("Index " + index + " is out of bounds");
        if (!this.linkBaseTexture || baseTexture.parentTextureArray || Object.keys(baseTexture._glTextures).length > 0) {
            // copy mode
            if (baseTexture.resource) this.addResourceAt(baseTexture.resource, index);
            else throw new Error("CubeResource does not support copying of renderTexture.");
        } else {
            // link mode, the difficult one!
            baseTexture.target = (0, $P8XPi.TARGETS).TEXTURE_CUBE_MAP_POSITIVE_X + index;
            baseTexture.parentTextureArray = this.baseTexture;
            this.items[index] = baseTexture;
        }
        if (baseTexture.valid && !this.valid) this.resize(baseTexture.realWidth, baseTexture.realHeight);
        this.items[index] = baseTexture;
        return this;
    };
    /**
     * Upload the resource
     *
     * @returns {boolean} true is success
     */ CubeResource.prototype.upload = function(renderer, _baseTexture, glTexture) {
        var dirty = this.itemDirtyIds;
        for(var i = 0; i < CubeResource.SIDES; i++){
            var side = this.items[i];
            if (dirty[i] < side.dirtyId) {
                if (side.valid && side.resource) {
                    side.resource.upload(renderer, side, glTexture);
                    dirty[i] = side.dirtyId;
                } else if (dirty[i] < -1) {
                    // either item is not valid yet, either its a renderTexture
                    // allocate the memory
                    renderer.gl.texImage2D(side.target, 0, glTexture.internalFormat, _baseTexture.realWidth, _baseTexture.realHeight, 0, _baseTexture.format, glTexture.type, null);
                    dirty[i] = -1;
                }
            }
        }
        return true;
    };
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @return {boolean} `true` if source is an array of 6 elements
     */ CubeResource.test = function(source) {
        return Array.isArray(source) && source.length === CubeResource.SIDES;
    };
    /** Number of texture sides to store for CubeResources. */ CubeResource.SIDES = 6;
    return CubeResource;
}(AbstractMultiResource);
/**
 * Resource type for HTMLImageElement.
 *
 * @memberof PIXI
 */ var ImageResource = /** @class */ function(_super) {
    __extends(ImageResource, _super);
    /**
     * @param source - image source or URL
     * @param options
     * @param {boolean} [options.autoLoad=true] - start loading process
     * @param {boolean} [options.createBitmap=PIXI.settings.CREATE_IMAGE_BITMAP] - whether its required to create
     *        a bitmap before upload
     * @param {boolean} [options.crossorigin=true] - Load image using cross origin
     * @param {PIXI.ALPHA_MODES} [options.alphaMode=PIXI.ALPHA_MODES.UNPACK] - Premultiply image alpha in bitmap
     */ function ImageResource(source, options) {
        var _this = this;
        options = options || {};
        if (!(source instanceof HTMLImageElement)) {
            var imageElement = new Image();
            BaseImageResource.crossOrigin(imageElement, source, options.crossorigin);
            imageElement.src = source;
            source = imageElement;
        }
        _this = _super.call(this, source) || this;
        // FireFox 68, and possibly other versions, seems like setting the HTMLImageElement#width and #height
        // to non-zero values before its loading completes if images are in a cache.
        // Because of this, need to set the `_width` and the `_height` to zero to avoid uploading incomplete images.
        // Please refer to the issue #5968 (https://github.com/pixijs/pixi.js/issues/5968).
        if (!source.complete && !!_this._width && !!_this._height) {
            _this._width = 0;
            _this._height = 0;
        }
        _this.url = source.src;
        _this._process = null;
        _this.preserveBitmap = false;
        _this.createBitmap = (options.createBitmap !== undefined ? options.createBitmap : (0, $ezJmd.settings).CREATE_IMAGE_BITMAP) && !!self.createImageBitmap;
        _this.alphaMode = typeof options.alphaMode === 'number' ? options.alphaMode : null;
        _this.bitmap = null;
        _this._load = null;
        if (options.autoLoad !== false) _this.load();
        return _this;
    }
    /**
     * Returns a promise when image will be loaded and processed.
     *
     * @param createBitmap - whether process image into bitmap
     */ ImageResource.prototype.load = function(createBitmap) {
        var _this = this;
        if (this._load) return this._load;
        if (createBitmap !== undefined) this.createBitmap = createBitmap;
        this._load = new Promise(function(resolve, reject) {
            var source = _this.source;
            _this.url = source.src;
            var completed = function() {
                if (_this.destroyed) return;
                source.onload = null;
                source.onerror = null;
                _this.resize(source.width, source.height);
                _this._load = null;
                if (_this.createBitmap) resolve(_this.process());
                else resolve(_this);
            };
            if (source.complete && source.src) completed();
            else {
                source.onload = completed;
                source.onerror = function(event) {
                    // Avoids Promise freezing when resource broken
                    reject(event);
                    _this.onError.emit(event);
                };
            }
        });
        return this._load;
    };
    /**
     * Called when we need to convert image into BitmapImage.
     * Can be called multiple times, real promise is cached inside.
     *
     * @return - Cached promise to fill that bitmap
     */ ImageResource.prototype.process = function() {
        var _this = this;
        var source = this.source;
        if (this._process !== null) return this._process;
        if (this.bitmap !== null || !self.createImageBitmap) return Promise.resolve(this);
        var createImageBitmap = self.createImageBitmap;
        var cors = !source.crossOrigin || source.crossOrigin === 'anonymous';
        this._process = fetch(source.src, {
            mode: cors ? 'cors' : 'no-cors'
        }).then(function(r) {
            return r.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, 0, 0, source.width, source.height, {
                premultiplyAlpha: _this.alphaMode === (0, $P8XPi.ALPHA_MODES).UNPACK ? 'premultiply' : 'none'
            });
        }).then(function(bitmap) {
            if (_this.destroyed) return Promise.reject();
            _this.bitmap = bitmap;
            _this.update();
            _this._process = null;
            return Promise.resolve(_this);
        });
        return this._process;
    };
    /**
     * Upload the image resource to GPU.
     *
     * @param renderer - Renderer to upload to
     * @param baseTexture - BaseTexture for this resource
     * @param glTexture - GLTexture to use
     * @returns {boolean} true is success
     */ ImageResource.prototype.upload = function(renderer, baseTexture, glTexture) {
        if (typeof this.alphaMode === 'number') // bitmap stores unpack premultiply flag, we dont have to notify texImage2D about it
        baseTexture.alphaMode = this.alphaMode;
        if (!this.createBitmap) return _super.prototype.upload.call(this, renderer, baseTexture, glTexture);
        if (!this.bitmap) {
            // yeah, ignore the output
            this.process();
            if (!this.bitmap) return false;
        }
        _super.prototype.upload.call(this, renderer, baseTexture, glTexture, this.bitmap);
        if (!this.preserveBitmap) {
            // checks if there are other renderers that possibly need this bitmap
            var flag = true;
            var glTextures = baseTexture._glTextures;
            for(var key in glTextures){
                var otherTex = glTextures[key];
                if (otherTex !== glTexture && otherTex.dirtyId !== baseTexture.dirtyId) {
                    flag = false;
                    break;
                }
            }
            if (flag) {
                if (this.bitmap.close) this.bitmap.close();
                this.bitmap = null;
            }
        }
        return true;
    };
    /** Destroys this resource. */ ImageResource.prototype.dispose = function() {
        this.source.onload = null;
        this.source.onerror = null;
        _super.prototype.dispose.call(this);
        if (this.bitmap) {
            this.bitmap.close();
            this.bitmap = null;
        }
        this._process = null;
        this._load = null;
    };
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @return {boolean} `true` if source is string or HTMLImageElement
     */ ImageResource.test = function(source) {
        return typeof source === 'string' || source instanceof HTMLImageElement;
    };
    return ImageResource;
}(BaseImageResource);
/**
 * Resource type for SVG elements and graphics.
 *
 * @memberof PIXI
 */ var SVGResource = /** @class */ function(_super) {
    __extends(SVGResource, _super);
    /**
     * @param sourceBase64 - Base64 encoded SVG element or URL for SVG file.
     * @param {object} [options] - Options to use
     * @param {number} [options.scale=1] - Scale to apply to SVG. Overridden by...
     * @param {number} [options.width] - Rasterize SVG this wide. Aspect ratio preserved if height not specified.
     * @param {number} [options.height] - Rasterize SVG this high. Aspect ratio preserved if width not specified.
     * @param {boolean} [options.autoLoad=true] - Start loading right away.
     */ function SVGResource(sourceBase64, options) {
        var _this = this;
        options = options || {};
        _this = _super.call(this, document.createElement('canvas')) || this;
        _this._width = 0;
        _this._height = 0;
        _this.svg = sourceBase64;
        _this.scale = options.scale || 1;
        _this._overrideWidth = options.width;
        _this._overrideHeight = options.height;
        _this._resolve = null;
        _this._crossorigin = options.crossorigin;
        _this._load = null;
        if (options.autoLoad !== false) _this.load();
        return _this;
    }
    SVGResource.prototype.load = function() {
        var _this = this;
        if (this._load) return this._load;
        this._load = new Promise(function(resolve) {
            // Save this until after load is finished
            _this._resolve = function() {
                _this.resize(_this.source.width, _this.source.height);
                resolve(_this);
            };
            // Convert SVG inline string to data-uri
            if (SVGResource.SVG_XML.test(_this.svg.trim())) {
                if (!btoa) throw new Error('Your browser doesn\'t support base64 conversions.');
                _this.svg = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(_this.svg)));
            }
            _this._loadSvg();
        });
        return this._load;
    };
    /** Loads an SVG image from `imageUrl` or `data URL`. */ SVGResource.prototype._loadSvg = function() {
        var _this = this;
        var tempImage = new Image();
        BaseImageResource.crossOrigin(tempImage, this.svg, this._crossorigin);
        tempImage.src = this.svg;
        tempImage.onerror = function(event) {
            if (!_this._resolve) return;
            tempImage.onerror = null;
            _this.onError.emit(event);
        };
        tempImage.onload = function() {
            if (!_this._resolve) return;
            var svgWidth = tempImage.width;
            var svgHeight = tempImage.height;
            if (!svgWidth || !svgHeight) throw new Error('The SVG image must have width and height defined (in pixels), canvas API needs them.');
            // Set render size
            var width = svgWidth * _this.scale;
            var height = svgHeight * _this.scale;
            if (_this._overrideWidth || _this._overrideHeight) {
                width = _this._overrideWidth || _this._overrideHeight / svgHeight * svgWidth;
                height = _this._overrideHeight || _this._overrideWidth / svgWidth * svgHeight;
            }
            width = Math.round(width);
            height = Math.round(height);
            // Create a canvas element
            var canvas = _this.source;
            canvas.width = width;
            canvas.height = height;
            canvas._pixiId = "canvas_" + (0, $csytw.uid)();
            // Draw the Svg to the canvas
            canvas.getContext('2d').drawImage(tempImage, 0, 0, svgWidth, svgHeight, 0, 0, width, height);
            _this._resolve();
            _this._resolve = null;
        };
    };
    /**
     * Get size from an svg string using a regular expression.
     *
     * @param svgString - a serialized svg element
     * @return - image extension
     */ SVGResource.getSize = function(svgString) {
        var sizeMatch = SVGResource.SVG_SIZE.exec(svgString);
        var size = {};
        if (sizeMatch) {
            size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3]));
            size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]));
        }
        return size;
    };
    /** Destroys this texture. */ SVGResource.prototype.dispose = function() {
        _super.prototype.dispose.call(this);
        this._resolve = null;
        this._crossorigin = null;
    };
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @param {string} extension - The extension of source, if set
     * @return {boolean} - If the source is a SVG source or data file
     */ SVGResource.test = function(source, extension) {
        // url file extension is SVG
        return extension === 'svg' || typeof source === 'string' && /^data:image\/svg\+xml(;(charset=utf8|utf8))?;base64/.test(source) || typeof source === 'string' && SVGResource.SVG_XML.test(source);
    };
    /**
     * Regular expression for SVG XML document.
     *
     * @example &lt;?xml version="1.0" encoding="utf-8" ?&gt;&lt;!-- image/svg --&gt;&lt;svg
     * @readonly
     */ SVGResource.SVG_XML = /^(<\?xml[^?]+\?>)?\s*(<!--[^(-->)]*-->)?\s*\<svg/m;
    /**
     * Regular expression for SVG size.
     *
     * @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
     * @readonly
     */ SVGResource.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i; // eslint-disable-line max-len
    return SVGResource;
}(BaseImageResource);
/**
 * Resource type for {@code HTMLVideoElement}.
 *
 * @memberof PIXI
 */ var VideoResource = /** @class */ function(_super) {
    __extends(VideoResource, _super);
    /**
     * @param {HTMLVideoElement|object|string|Array<string|object>} source - Video element to use.
     * @param {object} [options] - Options to use
     * @param {boolean} [options.autoLoad=true] - Start loading the video immediately
     * @param {boolean} [options.autoPlay=true] - Start playing video immediately
     * @param {number} [options.updateFPS=0] - How many times a second to update the texture from the video.
     * Leave at 0 to update at every render.
     * @param {boolean} [options.crossorigin=true] - Load image using cross origin
     */ function VideoResource(source, options) {
        var _this = this;
        options = options || {};
        if (!(source instanceof HTMLVideoElement)) {
            var videoElement = document.createElement('video');
            // workaround for https://github.com/pixijs/pixi.js/issues/5996
            videoElement.setAttribute('preload', 'auto');
            videoElement.setAttribute('webkit-playsinline', '');
            videoElement.setAttribute('playsinline', '');
            if (typeof source === 'string') source = [
                source
            ];
            var firstSrc = source[0].src || source[0];
            BaseImageResource.crossOrigin(videoElement, firstSrc, options.crossorigin);
            // array of objects or strings
            for(var i = 0; i < source.length; ++i){
                var sourceElement = document.createElement('source');
                var _a = source[i], src = _a.src, mime = _a.mime;
                src = src || source[i];
                var baseSrc = src.split('?').shift().toLowerCase();
                var ext = baseSrc.substr(baseSrc.lastIndexOf('.') + 1);
                mime = mime || VideoResource.MIME_TYPES[ext] || "video/" + ext;
                sourceElement.src = src;
                sourceElement.type = mime;
                videoElement.appendChild(sourceElement);
            }
            // Override the source
            source = videoElement;
        }
        _this = _super.call(this, source) || this;
        _this.noSubImage = true;
        _this._autoUpdate = true;
        _this._isConnectedToTicker = false;
        _this._updateFPS = options.updateFPS || 0;
        _this._msToNextUpdate = 0;
        _this.autoPlay = options.autoPlay !== false;
        _this._load = null;
        _this._resolve = null;
        // Bind for listeners
        _this._onCanPlay = _this._onCanPlay.bind(_this);
        _this._onError = _this._onError.bind(_this);
        if (options.autoLoad !== false) _this.load();
        return _this;
    }
    /**
     * Trigger updating of the texture.
     *
     * @param deltaTime - time delta since last tick
     */ VideoResource.prototype.update = function(_deltaTime) {
        if (!this.destroyed) {
            // account for if video has had its playbackRate changed
            var elapsedMS = (0, $3YyWq.Ticker).shared.elapsedMS * this.source.playbackRate;
            this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
            if (!this._updateFPS || this._msToNextUpdate <= 0) {
                _super.prototype.update.call(this);
                this._msToNextUpdate = this._updateFPS ? Math.floor(1000 / this._updateFPS) : 0;
            }
        }
    };
    /**
     * Start preloading the video resource.
     *
     * @return {Promise<void>} Handle the validate event
     */ VideoResource.prototype.load = function() {
        var _this = this;
        if (this._load) return this._load;
        var source = this.source;
        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) source.complete = true;
        source.addEventListener('play', this._onPlayStart.bind(this));
        source.addEventListener('pause', this._onPlayStop.bind(this));
        if (!this._isSourceReady()) {
            source.addEventListener('canplay', this._onCanPlay);
            source.addEventListener('canplaythrough', this._onCanPlay);
            source.addEventListener('error', this._onError, true);
        } else this._onCanPlay();
        this._load = new Promise(function(resolve) {
            if (_this.valid) resolve(_this);
            else {
                _this._resolve = resolve;
                source.load();
            }
        });
        return this._load;
    };
    /** Handle video error events. */ VideoResource.prototype._onError = function(event) {
        this.source.removeEventListener('error', this._onError, true);
        this.onError.emit(event);
    };
    /**
     * Returns true if the underlying source is playing.
     *
     * @return - True if playing.
     */ VideoResource.prototype._isSourcePlaying = function() {
        var source = this.source;
        return source.currentTime > 0 && source.paused === false && source.ended === false && source.readyState > 2;
    };
    /**
     * Returns true if the underlying source is ready for playing.
     *
     * @return - True if ready.
     */ VideoResource.prototype._isSourceReady = function() {
        var source = this.source;
        return source.readyState === 3 || source.readyState === 4;
    };
    /** Runs the update loop when the video is ready to play. */ VideoResource.prototype._onPlayStart = function() {
        // Just in case the video has not received its can play even yet..
        if (!this.valid) this._onCanPlay();
        if (this.autoUpdate && !this._isConnectedToTicker) {
            (0, $3YyWq.Ticker).shared.add(this.update, this);
            this._isConnectedToTicker = true;
        }
    };
    /** Fired when a pause event is triggered, stops the update loop. */ VideoResource.prototype._onPlayStop = function() {
        if (this._isConnectedToTicker) {
            (0, $3YyWq.Ticker).shared.remove(this.update, this);
            this._isConnectedToTicker = false;
        }
    };
    /** Fired when the video is loaded and ready to play. */ VideoResource.prototype._onCanPlay = function() {
        var source = this.source;
        source.removeEventListener('canplay', this._onCanPlay);
        source.removeEventListener('canplaythrough', this._onCanPlay);
        var valid = this.valid;
        this.resize(source.videoWidth, source.videoHeight);
        // prevent multiple loaded dispatches..
        if (!valid && this._resolve) {
            this._resolve(this);
            this._resolve = null;
        }
        if (this._isSourcePlaying()) this._onPlayStart();
        else if (this.autoPlay) source.play();
    };
    /** Destroys this texture. */ VideoResource.prototype.dispose = function() {
        if (this._isConnectedToTicker) {
            (0, $3YyWq.Ticker).shared.remove(this.update, this);
            this._isConnectedToTicker = false;
        }
        var source = this.source;
        if (source) {
            source.removeEventListener('error', this._onError, true);
            source.pause();
            source.src = '';
            source.load();
        }
        _super.prototype.dispose.call(this);
    };
    Object.defineProperty(VideoResource.prototype, "autoUpdate", {
        /** Should the base texture automatically update itself, set to true by default. */ get: function() {
            return this._autoUpdate;
        },
        set: function(value) {
            if (value !== this._autoUpdate) {
                this._autoUpdate = value;
                if (!this._autoUpdate && this._isConnectedToTicker) {
                    (0, $3YyWq.Ticker).shared.remove(this.update, this);
                    this._isConnectedToTicker = false;
                } else if (this._autoUpdate && !this._isConnectedToTicker && this._isSourcePlaying()) {
                    (0, $3YyWq.Ticker).shared.add(this.update, this);
                    this._isConnectedToTicker = true;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VideoResource.prototype, "updateFPS", {
        /**
         * How many times a second to update the texture from the video. Leave at 0 to update at every render.
         * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
         */ get: function() {
            return this._updateFPS;
        },
        set: function(value) {
            if (value !== this._updateFPS) this._updateFPS = value;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @param {string} extension - The extension of source, if set
     * @return {boolean} `true` if video source
     */ VideoResource.test = function(source, extension) {
        return self.HTMLVideoElement && source instanceof HTMLVideoElement || VideoResource.TYPES.indexOf(extension) > -1;
    };
    /**
     * List of common video file extensions supported by VideoResource.
     *
     * @readonly
     */ VideoResource.TYPES = [
        'mp4',
        'm4v',
        'webm',
        'ogg',
        'ogv',
        'h264',
        'avi',
        'mov'
    ];
    /**
     * Map of video MIME types that can't be directly derived from file extensions.
     *
     * @readonly
     */ VideoResource.MIME_TYPES = {
        ogv: 'video/ogg',
        mov: 'video/quicktime',
        m4v: 'video/mp4'
    };
    return VideoResource;
}(BaseImageResource);
/**
 * Resource type for ImageBitmap.
 *
 * @memberof PIXI
 */ var ImageBitmapResource = /** @class */ function(_super) {
    __extends(ImageBitmapResource, _super);
    /**
     * @param source - Image element to use
     */ // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    function ImageBitmapResource(source) {
        return _super.call(this, source) || this;
    }
    /**
     * Used to auto-detect the type of resource.
     *
     * @param {*} source - The source object
     * @return {boolean} `true` if source is an ImageBitmap
     */ ImageBitmapResource.test = function(source) {
        return !!self.createImageBitmap && source instanceof ImageBitmap;
    };
    return ImageBitmapResource;
}(BaseImageResource);
INSTALLED.push(ImageResource, ImageBitmapResource, CanvasResource, VideoResource, SVGResource, BufferResource, CubeResource, ArrayResource);
var _resources = {
    __proto__: null,
    Resource: Resource,
    BaseImageResource: BaseImageResource,
    INSTALLED: INSTALLED,
    autoDetectResource: autoDetectResource,
    AbstractMultiResource: AbstractMultiResource,
    ArrayResource: ArrayResource,
    BufferResource: BufferResource,
    CanvasResource: CanvasResource,
    CubeResource: CubeResource,
    ImageResource: ImageResource,
    SVGResource: SVGResource,
    VideoResource: VideoResource,
    ImageBitmapResource: ImageBitmapResource
};
/**
 * Resource type for DepthTexture.
 *
 * @memberof PIXI
 */ var DepthResource = /** @class */ function(_super) {
    __extends(DepthResource, _super);
    function DepthResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Upload the texture to the GPU.
     *
     * @param renderer - Upload to the renderer
     * @param baseTexture - Reference to parent texture
     * @param glTexture - glTexture
     * @return - true is success
     */ DepthResource.prototype.upload = function(renderer, baseTexture, glTexture) {
        var gl = renderer.gl;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, baseTexture.alphaMode === (0, $P8XPi.ALPHA_MODES).UNPACK);
        var width = baseTexture.realWidth;
        var height = baseTexture.realHeight;
        if (glTexture.width === width && glTexture.height === height) gl.texSubImage2D(baseTexture.target, 0, 0, 0, width, height, baseTexture.format, glTexture.type, this.data);
        else {
            glTexture.width = width;
            glTexture.height = height;
            gl.texImage2D(baseTexture.target, 0, glTexture.internalFormat, width, height, 0, baseTexture.format, glTexture.type, this.data);
        }
        return true;
    };
    return DepthResource;
}(BufferResource);
/**
 * A framebuffer can be used to render contents off of the screen. {@link PIXI.BaseRenderTexture} uses
 * one internally to render into itself. You can attach a depth or stencil buffer to a framebuffer.
 *
 * On WebGL 2 machines, shaders can output to multiple textures simultaneously with GLSL 300 ES.
 *
 * @class
 * @memberof PIXI
 */ var Framebuffer = /** @class */ function() {
    /**
     * @param {number} width - Width of the frame buffer
     * @param {number} height - Height of the frame buffer
     */ function Framebuffer(width, height) {
        /**
         * Width of framebuffer in pixels
         * @member {number}
         */ this.width = Math.round(width || 100);
        /**
         * Height of framebuffer in pixels
         * @member {number}
         */ this.height = Math.round(height || 100);
        this.stencil = false;
        this.depth = false;
        this.dirtyId = 0;
        this.dirtyFormat = 0;
        this.dirtySize = 0;
        this.depthTexture = null;
        this.colorTextures = [];
        this.glFramebuffers = {};
        this.disposeRunner = new (0, $6fZag.Runner)('disposeFramebuffer');
        /**
         * Desired number of samples for antialiasing. 0 means AA should not be used.
         *
         * Experimental WebGL2 feature, allows to use antialiasing in individual renderTextures.
         * Antialiasing is the same as for main buffer with renderer `antialias:true` options.
         * Seriously affects GPU memory consumption and GPU performance.
         *
         *```js
         * renderTexture.framebuffer.multisample = PIXI.MSAA_QUALITY.HIGH;
         * //...
         * renderer.render(myContainer, {renderTexture});
         * renderer.framebuffer.blit(); // copies data from MSAA framebuffer to texture
         *  ```
         *
         * @member {PIXI.MSAA_QUALITY}
         * @default PIXI.MSAA_QUALITY.NONE
         */ this.multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
    }
    Object.defineProperty(Framebuffer.prototype, "colorTexture", {
        /**
         * Reference to the colorTexture.
         *
         * @member {PIXI.BaseTexture[]}
         * @readonly
         */ get: function() {
            return this.colorTextures[0];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Add texture to the colorTexture array
     *
     * @param {number} [index=0] - Index of the array to add the texture to
     * @param {PIXI.BaseTexture} [texture] - Texture to add to the array
     */ Framebuffer.prototype.addColorTexture = function(index, texture) {
        if (index === void 0) index = 0;
        // TODO add some validation to the texture - same width / height etc?
        this.colorTextures[index] = texture || new BaseTexture(null, {
            scaleMode: (0, $P8XPi.SCALE_MODES).NEAREST,
            resolution: 1,
            mipmap: (0, $P8XPi.MIPMAP_MODES).OFF,
            width: this.width,
            height: this.height
        });
        this.dirtyId++;
        this.dirtyFormat++;
        return this;
    };
    /**
     * Add a depth texture to the frame buffer
     *
     * @param {PIXI.BaseTexture} [texture] - Texture to add
     */ Framebuffer.prototype.addDepthTexture = function(texture) {
        /* eslint-disable max-len */ this.depthTexture = texture || new BaseTexture(new DepthResource(null, {
            width: this.width,
            height: this.height
        }), {
            scaleMode: (0, $P8XPi.SCALE_MODES).NEAREST,
            resolution: 1,
            width: this.width,
            height: this.height,
            mipmap: (0, $P8XPi.MIPMAP_MODES).OFF,
            format: (0, $P8XPi.FORMATS).DEPTH_COMPONENT,
            type: (0, $P8XPi.TYPES).UNSIGNED_SHORT
        });
        this.dirtyId++;
        this.dirtyFormat++;
        return this;
    };
    /**
     * Enable depth on the frame buffer
     */ Framebuffer.prototype.enableDepth = function() {
        this.depth = true;
        this.dirtyId++;
        this.dirtyFormat++;
        return this;
    };
    /**
     * Enable stencil on the frame buffer
     */ Framebuffer.prototype.enableStencil = function() {
        this.stencil = true;
        this.dirtyId++;
        this.dirtyFormat++;
        return this;
    };
    /**
     * Resize the frame buffer
     *
     * @param {number} width - Width of the frame buffer to resize to
     * @param {number} height - Height of the frame buffer to resize to
     */ Framebuffer.prototype.resize = function(width, height) {
        width = Math.round(width);
        height = Math.round(height);
        if (width === this.width && height === this.height) return;
        this.width = width;
        this.height = height;
        this.dirtyId++;
        this.dirtySize++;
        for(var i = 0; i < this.colorTextures.length; i++){
            var texture = this.colorTextures[i];
            var resolution = texture.resolution;
            // take into account the fact the texture may have a different resolution..
            texture.setSize(width / resolution, height / resolution);
        }
        if (this.depthTexture) {
            var resolution = this.depthTexture.resolution;
            this.depthTexture.setSize(width / resolution, height / resolution);
        }
    };
    /**
     * Disposes WebGL resources that are connected to this geometry
     */ Framebuffer.prototype.dispose = function() {
        this.disposeRunner.emit(this, false);
    };
    /**
     * Destroys and removes the depth texture added to this framebuffer.
     */ Framebuffer.prototype.destroyDepthTexture = function() {
        if (this.depthTexture) {
            this.depthTexture.destroy();
            this.depthTexture = null;
            ++this.dirtyId;
            ++this.dirtyFormat;
        }
    };
    return Framebuffer;
}();
/**
 * A BaseRenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
 *
 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a BaseRenderTexture should be preloaded
 * otherwise black rectangles will be drawn instead.
 *
 * A BaseRenderTexture takes a snapshot of any Display Object given to its render method. The position
 * and rotation of the given Display Objects is ignored. For example:
 *
 * ```js
 * let renderer = PIXI.autoDetectRenderer();
 * let baseRenderTexture = new PIXI.BaseRenderTexture({ width: 800, height: 600 });
 * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
 * let sprite = PIXI.Sprite.from("spinObj_01.png");
 *
 * sprite.position.x = 800/2;
 * sprite.position.y = 600/2;
 * sprite.anchor.x = 0.5;
 * sprite.anchor.y = 0.5;
 *
 * renderer.render(sprite, {renderTexture});
 * ```
 *
 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
 * you can clear the transform
 *
 * ```js
 *
 * sprite.setTransform()
 *
 * let baseRenderTexture = new PIXI.BaseRenderTexture({ width: 100, height: 100 });
 * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
 *
 * renderer.render(sprite, {renderTexture});  // Renders to center of RenderTexture
 * ```
 *
 * @class
 * @extends PIXI.BaseTexture
 * @memberof PIXI
 */ var BaseRenderTexture = /** @class */ function(_super) {
    __extends(BaseRenderTexture, _super);
    /**
     * @param {object} [options]
     * @param {number} [options.width=100] - The width of the base render texture.
     * @param {number} [options.height=100] - The height of the base render texture.
     * @param {PIXI.SCALE_MODES} [options.scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES}
     *   for possible values.
     * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio
     *   of the texture being generated.
     * @param {PIXI.MSAA_QUALITY} [options.multisample=PIXI.MSAA_QUALITY.NONE] - The number of samples of the frame buffer.
     */ function BaseRenderTexture(options) {
        var _this = this;
        if (typeof options === 'number') {
            /* eslint-disable prefer-rest-params */ // Backward compatibility of signature
            var width = arguments[0];
            var height = arguments[1];
            var scaleMode = arguments[2];
            var resolution = arguments[3];
            options = {
                width: width,
                height: height,
                scaleMode: scaleMode,
                resolution: resolution
            };
        /* eslint-enable prefer-rest-params */ }
        options.width = options.width || 100;
        options.height = options.height || 100;
        options.multisample = options.multisample !== undefined ? options.multisample : (0, $P8XPi.MSAA_QUALITY).NONE;
        _this = _super.call(this, null, options) || this;
        // Set defaults
        _this.mipmap = (0, $P8XPi.MIPMAP_MODES).OFF;
        _this.valid = true;
        _this.clearColor = [
            0,
            0,
            0,
            0
        ];
        _this.framebuffer = new Framebuffer(_this.realWidth, _this.realHeight).addColorTexture(0, _this);
        _this.framebuffer.multisample = options.multisample;
        // TODO - could this be added the systems?
        /**
         * The data structure for the stencil masks.
         *
         * @member {PIXI.MaskData[]}
         */ _this.maskStack = [];
        /**
         * The data structure for the filters.
         *
         * @member {Object[]}
         */ _this.filterStack = [
            {}
        ];
        return _this;
    }
    /**
     * Resizes the BaseRenderTexture.
     *
     * @param {number} desiredWidth - The desired width to resize to.
     * @param {number} desiredHeight - The desired height to resize to.
     */ BaseRenderTexture.prototype.resize = function(desiredWidth, desiredHeight) {
        this.framebuffer.resize(desiredWidth * this.resolution, desiredHeight * this.resolution);
        this.setRealSize(this.framebuffer.width, this.framebuffer.height);
    };
    /**
     * Frees the texture and framebuffer from WebGL memory without destroying this texture object.
     * This means you can still use the texture later which will upload it to GPU
     * memory again.
     *
     * @fires PIXI.BaseTexture#dispose
     */ BaseRenderTexture.prototype.dispose = function() {
        this.framebuffer.dispose();
        _super.prototype.dispose.call(this);
    };
    /**
     * Destroys this texture.
     */ BaseRenderTexture.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        this.framebuffer.destroyDepthTexture();
        this.framebuffer = null;
    };
    return BaseRenderTexture;
}(BaseTexture);
/**
 * Stores a texture's frame in UV coordinates, in
 * which everything lies in the rectangle `[(0,0), (1,0),
 * (1,1), (0,1)]`.
 *
 * | Corner       | Coordinates |
 * |--------------|-------------|
 * | Top-Left     | `(x0,y0)`   |
 * | Top-Right    | `(x1,y1)`   |
 * | Bottom-Right | `(x2,y2)`   |
 * | Bottom-Left  | `(x3,y3)`   |
 *
 * @class
 * @protected
 * @memberof PIXI
 */ var TextureUvs = /** @class */ function() {
    function TextureUvs() {
        /**
         * X-component of top-left corner `(x0,y0)`.
         *
         * @member {number}
         */ this.x0 = 0;
        /**
         * Y-component of top-left corner `(x0,y0)`.
         *
         * @member {number}
         */ this.y0 = 0;
        /**
         * X-component of top-right corner `(x1,y1)`.
         *
         * @member {number}
         */ this.x1 = 1;
        /**
         * Y-component of top-right corner `(x1,y1)`.
         *
         * @member {number}
         */ this.y1 = 0;
        /**
         * X-component of bottom-right corner `(x2,y2)`.
         *
         * @member {number}
         */ this.x2 = 1;
        /**
         * Y-component of bottom-right corner `(x2,y2)`.
         *
         * @member {number}
         */ this.y2 = 1;
        /**
         * X-component of bottom-left corner `(x3,y3)`.
         *
         * @member {number}
         */ this.x3 = 0;
        /**
         * Y-component of bottom-right corner `(x3,y3)`.
         *
         * @member {number}
         */ this.y3 = 1;
        this.uvsFloat32 = new Float32Array(8);
    }
    /**
     * Sets the texture Uvs based on the given frame information.
     *
     * @protected
     * @param {PIXI.Rectangle} frame - The frame of the texture
     * @param {PIXI.Rectangle} baseFrame - The base frame of the texture
     * @param {number} rotate - Rotation of frame, see {@link PIXI.groupD8}
     */ TextureUvs.prototype.set = function(frame, baseFrame, rotate) {
        var tw = baseFrame.width;
        var th = baseFrame.height;
        if (rotate) {
            // width and height div 2 div baseFrame size
            var w2 = frame.width / 2 / tw;
            var h2 = frame.height / 2 / th;
            // coordinates of center
            var cX = frame.x / tw + w2;
            var cY = frame.y / th + h2;
            rotate = (0, $6qzqq.groupD8).add(rotate, (0, $6qzqq.groupD8).NW); // NW is top-left corner
            this.x0 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
            this.y0 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
            rotate = (0, $6qzqq.groupD8).add(rotate, 2); // rotate 90 degrees clockwise
            this.x1 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
            this.y1 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
            rotate = (0, $6qzqq.groupD8).add(rotate, 2);
            this.x2 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
            this.y2 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
            rotate = (0, $6qzqq.groupD8).add(rotate, 2);
            this.x3 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
            this.y3 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
        } else {
            this.x0 = frame.x / tw;
            this.y0 = frame.y / th;
            this.x1 = (frame.x + frame.width) / tw;
            this.y1 = frame.y / th;
            this.x2 = (frame.x + frame.width) / tw;
            this.y2 = (frame.y + frame.height) / th;
            this.x3 = frame.x / tw;
            this.y3 = (frame.y + frame.height) / th;
        }
        this.uvsFloat32[0] = this.x0;
        this.uvsFloat32[1] = this.y0;
        this.uvsFloat32[2] = this.x1;
        this.uvsFloat32[3] = this.y1;
        this.uvsFloat32[4] = this.x2;
        this.uvsFloat32[5] = this.y2;
        this.uvsFloat32[6] = this.x3;
        this.uvsFloat32[7] = this.y3;
    };
    TextureUvs.prototype.toString = function() {
        return "[@pixi/core:TextureUvs " + ("x0=" + this.x0 + " y0=" + this.y0 + " ") + ("x1=" + this.x1 + " y1=" + this.y1 + " x2=" + this.x2 + " ") + ("y2=" + this.y2 + " x3=" + this.x3 + " y3=" + this.y3) + "]";
    };
    return TextureUvs;
}();
var DEFAULT_UVS = new TextureUvs();
/**
 * A texture stores the information that represents an image or part of an image.
 *
 * It cannot be added to the display list directly; instead use it as the texture for a Sprite.
 * If no frame is provided for a texture, then the whole image is used.
 *
 * You can directly create a texture from an image and then reuse it multiple times like this :
 *
 * ```js
 * let texture = PIXI.Texture.from('assets/image.png');
 * let sprite1 = new PIXI.Sprite(texture);
 * let sprite2 = new PIXI.Sprite(texture);
 * ```
 *
 * If you didnt pass the texture frame to constructor, it enables `noFrame` mode:
 * it subscribes on baseTexture events, it automatically resizes at the same time as baseTexture.
 *
 * Textures made from SVGs, loaded or not, cannot be used before the file finishes processing.
 * You can check for this by checking the sprite's _textureID property.
 * ```js
 * var texture = PIXI.Texture.from('assets/image.svg');
 * var sprite1 = new PIXI.Sprite(texture);
 * //sprite1._textureID should not be undefined if the texture has finished processing the SVG file
 * ```
 * You can use a ticker or rAF to ensure your sprites load the finished textures after processing. See issue #3068.
 *
 * @class
 * @extends PIXI.utils.EventEmitter
 * @memberof PIXI
 * @typeParam R - The BaseTexture's Resource type.
 */ var Texture = /** @class */ function(_super) {
    __extends(Texture, _super);
    /**
     * @param {PIXI.BaseTexture} baseTexture - The base texture source to create the texture from
     * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
     * @param {PIXI.Rectangle} [orig] - The area of original texture
     * @param {PIXI.Rectangle} [trim] - Trimmed rectangle of original texture
     * @param {number} [rotate] - indicates how the texture was rotated by texture packer. See {@link PIXI.groupD8}
     * @param {PIXI.IPointData} [anchor] - Default anchor point used for sprite placement / rotation
     */ function Texture(baseTexture, frame, orig, trim, rotate, anchor) {
        var _this = _super.call(this) || this;
        /**
         * Does this Texture have any frame data assigned to it?
         *
         * This mode is enabled automatically if no frame was passed inside constructor.
         *
         * In this mode texture is subscribed to baseTexture events, and fires `update` on any change.
         *
         * Beware, after loading or resize of baseTexture event can fired two times!
         * If you want more control, subscribe on baseTexture itself.
         *
         * ```js
         * texture.on('update', () => {});
         * ```
         *
         * Any assignment of `frame` switches off `noFrame` mode.
         *
         * @member {boolean}
         */ _this.noFrame = false;
        if (!frame) {
            _this.noFrame = true;
            frame = new (0, $6qzqq.Rectangle)(0, 0, 1, 1);
        }
        if (baseTexture instanceof Texture) baseTexture = baseTexture.baseTexture;
        /**
         * The base texture that this texture uses.
         *
         * @member {PIXI.BaseTexture}
         */ _this.baseTexture = baseTexture;
        /**
         * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
         * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
         *
         * @member {PIXI.Rectangle}
         */ _this._frame = frame;
        /**
         * This is the trimmed area of original texture, before it was put in atlas
         * Please call `updateUvs()` after you change coordinates of `trim` manually.
         *
         * @member {PIXI.Rectangle}
         */ _this.trim = trim;
        /**
         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
         *
         * @member {boolean}
         */ _this.valid = false;
        /**
         * The WebGL UV data cache. Can be used as quad UV
         *
         * @member {PIXI.TextureUvs}
         * @protected
         */ _this._uvs = DEFAULT_UVS;
        /**
         * Default TextureMatrix instance for this texture
         * By default that object is not created because its heavy
         *
         * @member {PIXI.TextureMatrix}
         */ _this.uvMatrix = null;
        /**
         * This is the area of original texture, before it was put in atlas
         *
         * @member {PIXI.Rectangle}
         */ _this.orig = orig || frame; // new Rectangle(0, 0, 1, 1);
        _this._rotate = Number(rotate || 0);
        if (rotate === true) // this is old texturepacker legacy, some games/libraries are passing "true" for rotated textures
        _this._rotate = 2;
        else if (_this._rotate % 2 !== 0) throw new Error('attempt to use diamond-shaped UVs. If you are sure, set rotation manually');
        /**
         * Anchor point that is used as default if sprite is created with this texture.
         * Changing the `defaultAnchor` at a later point of time will not update Sprite's anchor point.
         * @member {PIXI.Point}
         * @default {0,0}
         */ _this.defaultAnchor = anchor ? new (0, $6qzqq.Point)(anchor.x, anchor.y) : new (0, $6qzqq.Point)(0, 0);
        /**
         * Update ID is observed by sprites and TextureMatrix instances.
         * Call updateUvs() to increment it.
         *
         * @member {number}
         * @protected
         */ _this._updateID = 0;
        /**
         * The ids under which this Texture has been added to the texture cache. This is
         * automatically set as long as Texture.addToCache is used, but may not be set if a
         * Texture is added directly to the TextureCache array.
         *
         * @member {string[]}
         */ _this.textureCacheIds = [];
        if (!baseTexture.valid) baseTexture.once('loaded', _this.onBaseTextureUpdated, _this);
        else if (_this.noFrame) // if there is no frame we should monitor for any base texture changes..
        {
            if (baseTexture.valid) _this.onBaseTextureUpdated(baseTexture);
        } else _this.frame = frame;
        if (_this.noFrame) baseTexture.on('update', _this.onBaseTextureUpdated, _this);
        return _this;
    }
    /**
     * Updates this texture on the gpu.
     *
     * Calls the TextureResource update.
     *
     * If you adjusted `frame` manually, please call `updateUvs()` instead.
     *
     */ Texture.prototype.update = function() {
        if (this.baseTexture.resource) this.baseTexture.resource.update();
    };
    /**
     * Called when the base texture is updated
     *
     * @protected
     * @param {PIXI.BaseTexture} baseTexture - The base texture.
     */ Texture.prototype.onBaseTextureUpdated = function(baseTexture) {
        if (this.noFrame) {
            if (!this.baseTexture.valid) return;
            this._frame.width = baseTexture.width;
            this._frame.height = baseTexture.height;
            this.valid = true;
            this.updateUvs();
        } else // TODO this code looks confusing.. boo to abusing getters and setters!
        // if user gave us frame that has bigger size than resized texture it can be a problem
        this.frame = this._frame;
        this.emit('update', this);
    };
    /**
     * Destroys this texture
     *
     * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
     */ Texture.prototype.destroy = function(destroyBase) {
        if (this.baseTexture) {
            if (destroyBase) {
                var resource = this.baseTexture.resource;
                // delete the texture if it exists in the texture cache..
                // this only needs to be removed if the base texture is actually destroyed too..
                if (resource && resource.url && (0, $csytw.TextureCache)[resource.url]) Texture.removeFromCache(resource.url);
                this.baseTexture.destroy();
            }
            this.baseTexture.off('loaded', this.onBaseTextureUpdated, this);
            this.baseTexture.off('update', this.onBaseTextureUpdated, this);
            this.baseTexture = null;
        }
        this._frame = null;
        this._uvs = null;
        this.trim = null;
        this.orig = null;
        this.valid = false;
        Texture.removeFromCache(this);
        this.textureCacheIds = null;
    };
    /**
     * Creates a new texture object that acts the same as this one.
     *
     * @return {PIXI.Texture} The new texture
     */ Texture.prototype.clone = function() {
        var clonedFrame = this._frame.clone();
        var clonedOrig = this._frame === this.orig ? clonedFrame : this.orig.clone();
        var clonedTexture = new Texture(this.baseTexture, !this.noFrame && clonedFrame, clonedOrig, this.trim && this.trim.clone(), this.rotate, this.defaultAnchor);
        if (this.noFrame) clonedTexture._frame = clonedFrame;
        return clonedTexture;
    };
    /**
     * Updates the internal WebGL UV cache. Use it after you change `frame` or `trim` of the texture.
     * Call it after changing the frame
     */ Texture.prototype.updateUvs = function() {
        if (this._uvs === DEFAULT_UVS) this._uvs = new TextureUvs();
        this._uvs.set(this._frame, this.baseTexture, this.rotate);
        this._updateID++;
    };
    /**
     * Helper function that creates a new Texture based on the source you provide.
     * The source can be - frame id, image url, video url, canvas element, video element, base texture
     *
     * @static
     * @param {string|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|PIXI.BaseTexture} source -
     *        Source to create texture from
     * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
     * @param {string} [options.pixiIdPrefix=pixiid] - If a source has no id, this is the prefix of the generated id
     * @param {boolean} [strict] - Enforce strict-mode, see {@link PIXI.settings.STRICT_TEXTURE_CACHE}.
     * @return {PIXI.Texture} The newly created texture
     */ Texture.from = function(source, options, strict) {
        if (options === void 0) options = {};
        if (strict === void 0) strict = (0, $ezJmd.settings).STRICT_TEXTURE_CACHE;
        var isFrame = typeof source === 'string';
        var cacheId = null;
        if (isFrame) cacheId = source;
        else if (source instanceof BaseTexture) {
            if (!source.cacheId) {
                var prefix = options && options.pixiIdPrefix || 'pixiid';
                source.cacheId = prefix + "-" + (0, $csytw.uid)();
                BaseTexture.addToCache(source, source.cacheId);
            }
            cacheId = source.cacheId;
        } else {
            if (!source._pixiId) {
                var prefix = options && options.pixiIdPrefix || 'pixiid';
                source._pixiId = prefix + "_" + (0, $csytw.uid)();
            }
            cacheId = source._pixiId;
        }
        var texture = (0, $csytw.TextureCache)[cacheId];
        // Strict-mode rejects invalid cacheIds
        if (isFrame && strict && !texture) throw new Error("The cacheId \"" + cacheId + "\" does not exist in TextureCache.");
        if (!texture && !(source instanceof BaseTexture)) {
            if (!options.resolution) options.resolution = (0, $csytw.getResolutionOfUrl)(source);
            texture = new Texture(new BaseTexture(source, options));
            texture.baseTexture.cacheId = cacheId;
            BaseTexture.addToCache(texture.baseTexture, cacheId);
            Texture.addToCache(texture, cacheId);
        } else if (!texture && source instanceof BaseTexture) {
            texture = new Texture(source);
            Texture.addToCache(texture, cacheId);
        }
        // lets assume its a base texture!
        return texture;
    };
    /**
     * Useful for loading textures via URLs. Use instead of `Texture.from` because
     * it does a better job of handling failed URLs more effectively. This also ignores
     * `PIXI.settings.STRICT_TEXTURE_CACHE`. Works for Videos, SVGs, Images.
     * @param {string} url - The remote URL to load.
     * @param {object} [options] - Optional options to include
     * @return {Promise<PIXI.Texture>} A Promise that resolves to a Texture.
     */ Texture.fromURL = function(url, options) {
        var resourceOptions = Object.assign({
            autoLoad: false
        }, options === null || options === void 0 ? void 0 : options.resourceOptions);
        var texture = Texture.from(url, Object.assign({
            resourceOptions: resourceOptions
        }, options), false);
        var resource = texture.baseTexture.resource;
        // The texture was already loaded
        if (texture.baseTexture.valid) return Promise.resolve(texture);
        // Manually load the texture, this should allow users to handle load errors
        return resource.load().then(function() {
            return Promise.resolve(texture);
        });
    };
    /**
     * Create a new Texture with a BufferResource from a Float32Array.
     * RGBA values are floats from 0 to 1.
     * @static
     * @param {Float32Array|Uint8Array} buffer - The optional array to use, if no data
     *        is provided, a new Float32Array is created.
     * @param {number} width - Width of the resource
     * @param {number} height - Height of the resource
     * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
     * @return {PIXI.Texture} The resulting new BaseTexture
     */ Texture.fromBuffer = function(buffer, width, height, options) {
        return new Texture(BaseTexture.fromBuffer(buffer, width, height, options));
    };
    /**
     * Create a texture from a source and add to the cache.
     *
     * @static
     * @param {HTMLImageElement|HTMLCanvasElement|string} source - The input source.
     * @param {String} imageUrl - File name of texture, for cache and resolving resolution.
     * @param {String} [name] - Human readable name for the texture cache. If no name is
     *        specified, only `imageUrl` will be used as the cache ID.
     * @return {PIXI.Texture} Output texture
     */ Texture.fromLoader = function(source, imageUrl, name, options) {
        var baseTexture = new BaseTexture(source, Object.assign({
            scaleMode: (0, $ezJmd.settings).SCALE_MODE,
            resolution: (0, $csytw.getResolutionOfUrl)(imageUrl)
        }, options));
        var resource = baseTexture.resource;
        if (resource instanceof ImageResource) resource.url = imageUrl;
        var texture = new Texture(baseTexture);
        // No name, use imageUrl instead
        if (!name) name = imageUrl;
        // lets also add the frame to pixi's global cache for 'fromLoader' function
        BaseTexture.addToCache(texture.baseTexture, name);
        Texture.addToCache(texture, name);
        // also add references by url if they are different.
        if (name !== imageUrl) {
            BaseTexture.addToCache(texture.baseTexture, imageUrl);
            Texture.addToCache(texture, imageUrl);
        }
        // Generally images are valid right away
        if (texture.baseTexture.valid) return Promise.resolve(texture);
        // SVG assets need to be parsed async, let's wait
        return new Promise(function(resolve) {
            texture.baseTexture.once('loaded', function() {
                return resolve(texture);
            });
        });
    };
    /**
     * Adds a Texture to the global TextureCache. This cache is shared across the whole PIXI object.
     *
     * @static
     * @param {PIXI.Texture} texture - The Texture to add to the cache.
     * @param {string} id - The id that the Texture will be stored against.
     */ Texture.addToCache = function(texture, id) {
        if (id) {
            if (texture.textureCacheIds.indexOf(id) === -1) texture.textureCacheIds.push(id);
            if ((0, $csytw.TextureCache)[id]) // eslint-disable-next-line no-console
            console.warn("Texture added to the cache with an id [" + id + "] that already had an entry");
            (0, $csytw.TextureCache)[id] = texture;
        }
    };
    /**
     * Remove a Texture from the global TextureCache.
     *
     * @static
     * @param {string|PIXI.Texture} texture - id of a Texture to be removed, or a Texture instance itself
     * @return {PIXI.Texture|null} The Texture that was removed
     */ Texture.removeFromCache = function(texture) {
        if (typeof texture === 'string') {
            var textureFromCache = (0, $csytw.TextureCache)[texture];
            if (textureFromCache) {
                var index = textureFromCache.textureCacheIds.indexOf(texture);
                if (index > -1) textureFromCache.textureCacheIds.splice(index, 1);
                delete (0, $csytw.TextureCache)[texture];
                return textureFromCache;
            }
        } else if (texture && texture.textureCacheIds) {
            for(var i = 0; i < texture.textureCacheIds.length; ++i)// Check that texture matches the one being passed in before deleting it from the cache.
            if ((0, $csytw.TextureCache)[texture.textureCacheIds[i]] === texture) delete (0, $csytw.TextureCache)[texture.textureCacheIds[i]];
            texture.textureCacheIds.length = 0;
            return texture;
        }
        return null;
    };
    Object.defineProperty(Texture.prototype, "resolution", {
        /**
         * Returns resolution of baseTexture
         *
         * @member {number}
         * @readonly
         */ get: function() {
            return this.baseTexture.resolution;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Texture.prototype, "frame", {
        /**
         * The frame specifies the region of the base texture that this texture uses.
         * Please call `updateUvs()` after you change coordinates of `frame` manually.
         *
         * @member {PIXI.Rectangle}
         */ get: function() {
            return this._frame;
        },
        set: function(frame) {
            this._frame = frame;
            this.noFrame = false;
            var x = frame.x, y = frame.y, width = frame.width, height = frame.height;
            var xNotFit = x + width > this.baseTexture.width;
            var yNotFit = y + height > this.baseTexture.height;
            if (xNotFit || yNotFit) {
                var relationship = xNotFit && yNotFit ? 'and' : 'or';
                var errorX = "X: " + x + " + " + width + " = " + (x + width) + " > " + this.baseTexture.width;
                var errorY = "Y: " + y + " + " + height + " = " + (y + height) + " > " + this.baseTexture.height;
                throw new Error('Texture Error: frame does not fit inside the base Texture dimensions: ' + (errorX + " " + relationship + " " + errorY));
            }
            this.valid = width && height && this.baseTexture.valid;
            if (!this.trim && !this.rotate) this.orig = frame;
            if (this.valid) this.updateUvs();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Texture.prototype, "rotate", {
        /**
         * Indicates whether the texture is rotated inside the atlas
         * set to 2 to compensate for texture packer rotation
         * set to 6 to compensate for spine packer rotation
         * can be used to rotate or mirror sprites
         * See {@link PIXI.groupD8} for explanation
         *
         * @member {number}
         */ get: function() {
            return this._rotate;
        },
        set: function(rotate) {
            this._rotate = rotate;
            if (this.valid) this.updateUvs();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Texture.prototype, "width", {
        /**
         * The width of the Texture in pixels.
         *
         * @member {number}
         */ get: function() {
            return this.orig.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Texture.prototype, "height", {
        /**
         * The height of the Texture in pixels.
         *
         * @member {number}
         */ get: function() {
            return this.orig.height;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Utility function for BaseTexture|Texture cast
     */ Texture.prototype.castToBaseTexture = function() {
        return this.baseTexture;
    };
    return Texture;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE))));
function createWhiteTexture() {
    var canvas = document.createElement('canvas');
    canvas.width = 16;
    canvas.height = 16;
    var context = canvas.getContext('2d');
    context.fillStyle = 'white';
    context.fillRect(0, 0, 16, 16);
    return new Texture(new BaseTexture(new CanvasResource(canvas)));
}
function removeAllHandlers(tex) {
    tex.destroy = function _emptyDestroy() {};
    tex.on = function _emptyOn() {};
    tex.once = function _emptyOnce() {};
    tex.emit = function _emptyEmit() {};
}
/**
 * An empty texture, used often to not have to create multiple empty textures.
 * Can not be destroyed.
 *
 * @static
 * @constant
 * @member {PIXI.Texture}
 */ Texture.EMPTY = new Texture(new BaseTexture());
removeAllHandlers(Texture.EMPTY);
removeAllHandlers(Texture.EMPTY.baseTexture);
/**
 * A white texture of 16x16 size, used for graphics and other things
 * Can not be destroyed.
 *
 * @static
 * @constant
 * @member {PIXI.Texture}
 */ Texture.WHITE = createWhiteTexture();
removeAllHandlers(Texture.WHITE);
removeAllHandlers(Texture.WHITE.baseTexture);
/**
 * A RenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
 *
 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a RenderTexture should be preloaded
 * otherwise black rectangles will be drawn instead.
 *
 * __Hint-2__: The actual memory allocation will happen on first render.
 * You shouldn't create renderTextures each frame just to delete them after, try to reuse them.
 *
 * A RenderTexture takes a snapshot of any Display Object given to its render method. For example:
 *
 * ```js
 * let renderer = PIXI.autoDetectRenderer();
 * let renderTexture = PIXI.RenderTexture.create({ width: 800, height: 600 });
 * let sprite = PIXI.Sprite.from("spinObj_01.png");
 *
 * sprite.position.x = 800/2;
 * sprite.position.y = 600/2;
 * sprite.anchor.x = 0.5;
 * sprite.anchor.y = 0.5;
 *
 * renderer.render(sprite, {renderTexture});
 * ```
 * Note that you should not create a new renderer, but reuse the same one as the rest of the application.
 *
 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
 * you can clear the transform
 *
 * ```js
 *
 * sprite.setTransform()
 *
 * let renderTexture = new PIXI.RenderTexture.create({ width: 100, height: 100 });
 *
 * renderer.render(sprite, {renderTexture});  // Renders to center of RenderTexture
 * ```
 *
 * @memberof PIXI
 */ var RenderTexture = /** @class */ function(_super) {
    __extends(RenderTexture, _super);
    /**
     * @param baseRenderTexture - The base texture object that this texture uses.
     * @param frame - The rectangle frame of the texture to show.
     */ function RenderTexture(baseRenderTexture, frame) {
        var _this = _super.call(this, baseRenderTexture, frame) || this;
        _this.valid = true;
        _this.filterFrame = null;
        _this.filterPoolKey = null;
        _this.updateUvs();
        return _this;
    }
    Object.defineProperty(RenderTexture.prototype, "framebuffer", {
        /**
         * Shortcut to `this.baseTexture.framebuffer`, saves baseTexture cast.
         *
         * @readonly
         */ get: function() {
            return this.baseTexture.framebuffer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RenderTexture.prototype, "multisample", {
        /**
         * Shortcut to `this.framebuffer.multisample`.
         *
         * @default PIXI.MSAA_QUALITY.NONE
         */ get: function() {
            return this.framebuffer.multisample;
        },
        set: function(value) {
            this.framebuffer.multisample = value;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Resizes the RenderTexture.
     *
     * @param desiredWidth - The desired width to resize to.
     * @param desiredHeight - The desired height to resize to.
     * @param resizeBaseTexture - Should the baseTexture.width and height values be resized as well?
     */ RenderTexture.prototype.resize = function(desiredWidth, desiredHeight, resizeBaseTexture) {
        if (resizeBaseTexture === void 0) resizeBaseTexture = true;
        var resolution = this.baseTexture.resolution;
        var width = Math.round(desiredWidth * resolution) / resolution;
        var height = Math.round(desiredHeight * resolution) / resolution;
        // TODO - could be not required..
        this.valid = width > 0 && height > 0;
        this._frame.width = this.orig.width = width;
        this._frame.height = this.orig.height = height;
        if (resizeBaseTexture) this.baseTexture.resize(width, height);
        this.updateUvs();
    };
    /**
     * Changes the resolution of baseTexture, but does not change framebuffer size.
     *
     * @param resolution - The new resolution to apply to RenderTexture
     */ RenderTexture.prototype.setResolution = function(resolution) {
        var baseTexture = this.baseTexture;
        if (baseTexture.resolution === resolution) return;
        baseTexture.setResolution(resolution);
        this.resize(baseTexture.width, baseTexture.height, false);
    };
    RenderTexture.create = function(options) {
        var arguments$1 = arguments;
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments$1[_i];
        // @deprecated fallback, old-style: create(width, height, scaleMode, resolution)
        if (typeof options === 'number') {
            (0, $csytw.deprecation)('6.0.0', 'Arguments (width, height, scaleMode, resolution) have been deprecated.');
            /* eslint-disable prefer-rest-params */ options = {
                width: options,
                height: rest[0],
                scaleMode: rest[1],
                resolution: rest[2]
            };
        /* eslint-enable prefer-rest-params */ }
        return new RenderTexture(new BaseRenderTexture(options));
    };
    return RenderTexture;
}(Texture);
/**
 * Texture pool, used by FilterSystem and plugins.
 *
 * Stores collection of temporary pow2 or screen-sized renderTextures
 *
 * If you use custom RenderTexturePool for your filters, you can use methods
 * `getFilterTexture` and `returnFilterTexture` same as in
 *
 * @memberof PIXI
 */ var RenderTexturePool = /** @class */ function() {
    /**
     * @param textureOptions - options that will be passed to BaseRenderTexture constructor
     * @param {PIXI.SCALE_MODES} [textureOptions.scaleMode] - See {@link PIXI.SCALE_MODES} for possible values.
     */ function RenderTexturePool(textureOptions) {
        this.texturePool = {};
        this.textureOptions = textureOptions || {};
        this.enableFullScreen = false;
        this._pixelsWidth = 0;
        this._pixelsHeight = 0;
    }
    /**
     * Creates texture with params that were specified in pool constructor.
     *
     * @param realWidth - Width of texture in pixels.
     * @param realHeight - Height of texture in pixels.
     * @param multisample - Number of samples of the framebuffer.
     */ RenderTexturePool.prototype.createTexture = function(realWidth, realHeight, multisample) {
        if (multisample === void 0) multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
        var baseRenderTexture = new BaseRenderTexture(Object.assign({
            width: realWidth,
            height: realHeight,
            resolution: 1,
            multisample: multisample
        }, this.textureOptions));
        return new RenderTexture(baseRenderTexture);
    };
    /**
     * Gets a Power-of-Two render texture or fullScreen texture
     *
     * @param minWidth - The minimum width of the render texture.
     * @param minHeight - The minimum height of the render texture.
     * @param resolution - The resolution of the render texture.
     * @param multisample - Number of samples of the render texture.
     * @return The new render texture.
     */ RenderTexturePool.prototype.getOptimalTexture = function(minWidth, minHeight, resolution, multisample) {
        if (resolution === void 0) resolution = 1;
        if (multisample === void 0) multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
        var key;
        minWidth = Math.ceil(minWidth * resolution);
        minHeight = Math.ceil(minHeight * resolution);
        if (!this.enableFullScreen || minWidth !== this._pixelsWidth || minHeight !== this._pixelsHeight) {
            minWidth = (0, $csytw.nextPow2)(minWidth);
            minHeight = (0, $csytw.nextPow2)(minHeight);
            key = ((minWidth & 0xFFFF) << 16 | minHeight & 0xFFFF) >>> 0;
            if (multisample > 1) key += multisample * 0x100000000;
        } else key = multisample > 1 ? -multisample : -1;
        if (!this.texturePool[key]) this.texturePool[key] = [];
        var renderTexture = this.texturePool[key].pop();
        if (!renderTexture) renderTexture = this.createTexture(minWidth, minHeight, multisample);
        renderTexture.filterPoolKey = key;
        renderTexture.setResolution(resolution);
        return renderTexture;
    };
    /**
     * Gets extra texture of the same size as input renderTexture
     *
     * `getFilterTexture(input, 0.5)` or `getFilterTexture(0.5, input)`
     *
     * @param input - renderTexture from which size and resolution will be copied
     * @param resolution - override resolution of the renderTexture
     *  It overrides, it does not multiply
     * @param multisample - number of samples of the renderTexture
     * @returns
     */ RenderTexturePool.prototype.getFilterTexture = function(input, resolution, multisample) {
        var filterTexture = this.getOptimalTexture(input.width, input.height, resolution || input.resolution, multisample || (0, $P8XPi.MSAA_QUALITY).NONE);
        filterTexture.filterFrame = input.filterFrame;
        return filterTexture;
    };
    /**
     * Place a render texture back into the pool.
     *
     * @param renderTexture - The renderTexture to free
     */ RenderTexturePool.prototype.returnTexture = function(renderTexture) {
        var key = renderTexture.filterPoolKey;
        renderTexture.filterFrame = null;
        this.texturePool[key].push(renderTexture);
    };
    /**
     * Alias for returnTexture, to be compliant with FilterSystem interface.
     *
     * @param renderTexture - The renderTexture to free
     */ RenderTexturePool.prototype.returnFilterTexture = function(renderTexture) {
        this.returnTexture(renderTexture);
    };
    /**
     * Clears the pool.
     *
     * @param destroyTextures - Destroy all stored textures.
     */ RenderTexturePool.prototype.clear = function(destroyTextures) {
        destroyTextures = destroyTextures !== false;
        if (destroyTextures) for(var i in this.texturePool){
            var textures = this.texturePool[i];
            if (textures) for(var j = 0; j < textures.length; j++)textures[j].destroy(true);
        }
        this.texturePool = {};
    };
    /**
     * If screen size was changed, drops all screen-sized textures,
     * sets new screen size, sets `enableFullScreen` to true
     *
     * Size is measured in pixels, `renderer.view` can be passed here, not `renderer.screen`
     *
     * @param size - Initial size of screen.
     */ RenderTexturePool.prototype.setScreenSize = function(size) {
        if (size.width === this._pixelsWidth && size.height === this._pixelsHeight) return;
        this.enableFullScreen = size.width > 0 && size.height > 0;
        for(var i in this.texturePool){
            if (!(Number(i) < 0)) continue;
            var textures = this.texturePool[i];
            if (textures) for(var j = 0; j < textures.length; j++)textures[j].destroy(true);
            this.texturePool[i] = [];
        }
        this._pixelsWidth = size.width;
        this._pixelsHeight = size.height;
    };
    /**
     * Key that is used to store fullscreen renderTextures in a pool
     *
     * @constant
     */ RenderTexturePool.SCREEN_KEY = -1;
    return RenderTexturePool;
}();
/* eslint-disable max-len */ /**
 * Holds the information for a single attribute structure required to render geometry.
 *
 * This does not contain the actual data, but instead has a buffer id that maps to a {@link PIXI.Buffer}
 * This can include anything from positions, uvs, normals, colors etc.
 *
 * @memberof PIXI
 */ var Attribute = /** @class */ function() {
    /**
     * @param buffer - the id of the buffer that this attribute will look for
     * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2.
     * @param normalized - should the data be normalized.
     * @param {PIXI.TYPES} [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
     * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
     * @param [start=0] - How far into the array to start reading values (used for interleaving data)
     * @param [instance=false] - Whether the geometry is instanced.
     */ function Attribute(buffer, size, normalized, type, stride, start, instance) {
        if (size === void 0) size = 0;
        if (normalized === void 0) normalized = false;
        if (type === void 0) type = (0, $P8XPi.TYPES).FLOAT;
        this.buffer = buffer;
        this.size = size;
        this.normalized = normalized;
        this.type = type;
        this.stride = stride;
        this.start = start;
        this.instance = instance;
    }
    /** Destroys the Attribute. */ Attribute.prototype.destroy = function() {
        this.buffer = null;
    };
    /**
     * Helper function that creates an Attribute based on the information provided
     *
     * @param buffer - the id of the buffer that this attribute will look for
     * @param [size=0] - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
     * @param [normalized=false] - should the data be normalized.
     * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {@link PIXI.TYPES} to see the ones available
     * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
     * @returns - A new {@link PIXI.Attribute} based on the information provided
     */ Attribute.from = function(buffer, size, normalized, type, stride) {
        return new Attribute(buffer, size, normalized, type, stride);
    };
    return Attribute;
}();
var UID = 0;
/**
 * A wrapper for data so that it can be used and uploaded by WebGL
 *
 * @memberof PIXI
 */ var Buffer = /** @class */ function() {
    /**
     * @param {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} data - the data to store in the buffer.
     * @param _static - `true` for static buffer
     * @param index - `true` for index buffer
     */ function Buffer(data, _static, index) {
        if (_static === void 0) _static = true;
        if (index === void 0) index = false;
        this.data = data || new Float32Array(1);
        this._glBuffers = {};
        this._updateID = 0;
        this.index = index;
        this.static = _static;
        this.id = UID++;
        this.disposeRunner = new (0, $6fZag.Runner)('disposeBuffer');
    }
    // TODO could explore flagging only a partial upload?
    /**
     * Flags this buffer as requiring an upload to the GPU.
     * @param {ArrayBuffer|SharedArrayBuffer|ArrayBufferView|number[]} [data] - the data to update in the buffer.
     */ Buffer.prototype.update = function(data) {
        if (data instanceof Array) data = new Float32Array(data);
        this.data = data || this.data;
        this._updateID++;
    };
    /** Disposes WebGL resources that are connected to this geometry. */ Buffer.prototype.dispose = function() {
        this.disposeRunner.emit(this, false);
    };
    /** Destroys the buffer. */ Buffer.prototype.destroy = function() {
        this.dispose();
        this.data = null;
    };
    Object.defineProperty(Buffer.prototype, "index", {
        get: function() {
            return this.type === (0, $P8XPi.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER;
        },
        /**
         * Flags whether this is an index buffer.
         *
         * Index buffers are of type `ELEMENT_ARRAY_BUFFER`. Note that setting this property to false will make
         * the buffer of type `ARRAY_BUFFER`.
         *
         * For backwards compatibility.
         */ set: function(value) {
            this.type = value ? (0, $P8XPi.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER : (0, $P8XPi.BUFFER_TYPE).ARRAY_BUFFER;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Helper function that creates a buffer based on an array or TypedArray
     *
     * @param {ArrayBufferView | number[]} data - the TypedArray that the buffer will store. If this is a regular Array it will be converted to a Float32Array.
     * @return - A new Buffer based on the data provided.
     */ Buffer.from = function(data) {
        if (data instanceof Array) data = new Float32Array(data);
        return new Buffer(data);
    };
    return Buffer;
}();
/* eslint-disable object-shorthand */ var map = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array
};
function interleaveTypedArrays(arrays, sizes) {
    var outSize = 0;
    var stride = 0;
    var views = {};
    for(var i = 0; i < arrays.length; i++){
        stride += sizes[i];
        outSize += arrays[i].length;
    }
    var buffer = new ArrayBuffer(outSize * 4);
    var out = null;
    var littleOffset = 0;
    for(var i = 0; i < arrays.length; i++){
        var size = sizes[i];
        var array = arrays[i];
        var type = (0, $csytw.getBufferType)(array);
        if (!views[type]) views[type] = new map[type](buffer);
        out = views[type];
        for(var j = 0; j < array.length; j++){
            var indexStart = (j / size | 0) * stride + littleOffset;
            var index = j % size;
            out[indexStart + index] = array[j];
        }
        littleOffset += size;
    }
    return new Float32Array(buffer);
}
var byteSizeMap = {
    5126: 4,
    5123: 2,
    5121: 1
};
var UID$1 = 0;
/* eslint-disable object-shorthand */ var map$1 = {
    Float32Array: Float32Array,
    Uint32Array: Uint32Array,
    Int32Array: Int32Array,
    Uint8Array: Uint8Array,
    Uint16Array: Uint16Array
};
/* eslint-disable max-len */ /**
 * The Geometry represents a model. It consists of two components:
 * - GeometryStyle - The structure of the model such as the attributes layout
 * - GeometryData - the data of the model - this consists of buffers.
 * This can include anything from positions, uvs, normals, colors etc.
 *
 * Geometry can be defined without passing in a style or data if required (thats how I prefer!)
 *
 * ```js
 * let geometry = new PIXI.Geometry();
 *
 * geometry.addAttribute('positions', [0, 0, 100, 0, 100, 100, 0, 100], 2);
 * geometry.addAttribute('uvs', [0,0,1,0,1,1,0,1],2)
 * geometry.addIndex([0,1,2,1,3,2])
 * ```
 *
 * @memberof PIXI
 */ var Geometry = /** @class */ function() {
    /**
     * @param buffers - An array of buffers. optional.
     * @param attributes - Of the geometry, optional structure of the attributes layout
     */ function Geometry(buffers, attributes) {
        if (buffers === void 0) buffers = [];
        if (attributes === void 0) attributes = {};
        this.buffers = buffers;
        this.indexBuffer = null;
        this.attributes = attributes;
        this.glVertexArrayObjects = {};
        this.id = UID$1++;
        this.instanced = false;
        this.instanceCount = 1;
        this.disposeRunner = new (0, $6fZag.Runner)('disposeGeometry');
        this.refCount = 0;
    }
    /**
     *
     * Adds an attribute to the geometry
     * Note: `stride` and `start` should be `undefined` if you dont know them, not 0!
     *
     * @param id - the name of the attribute (matching up to a shader)
     * @param {PIXI.Buffer|number[]} buffer - the buffer that holds the data of the attribute . You can also provide an Array and a buffer will be created from it.
     * @param size - the size of the attribute. If you have 2 floats per vertex (eg position x and y) this would be 2
     * @param normalized - should the data be normalized.
     * @param [type=PIXI.TYPES.FLOAT] - what type of number is the attribute. Check {PIXI.TYPES} to see the ones available
     * @param [stride=0] - How far apart, in bytes, the start of each value is. (used for interleaving data)
     * @param [start=0] - How far into the array to start reading values (used for interleaving data)
     * @param instance - Instancing flag
     * @return - Returns self, useful for chaining.
     */ Geometry.prototype.addAttribute = function(id, buffer, size, normalized, type, stride, start, instance) {
        if (size === void 0) size = 0;
        if (normalized === void 0) normalized = false;
        if (instance === void 0) instance = false;
        if (!buffer) throw new Error('You must pass a buffer when creating an attribute');
        // check if this is a buffer!
        if (!(buffer instanceof Buffer)) {
            // its an array!
            if (buffer instanceof Array) buffer = new Float32Array(buffer);
            buffer = new Buffer(buffer);
        }
        var ids = id.split('|');
        if (ids.length > 1) {
            for(var i = 0; i < ids.length; i++)this.addAttribute(ids[i], buffer, size, normalized, type);
            return this;
        }
        var bufferIndex = this.buffers.indexOf(buffer);
        if (bufferIndex === -1) {
            this.buffers.push(buffer);
            bufferIndex = this.buffers.length - 1;
        }
        this.attributes[id] = new Attribute(bufferIndex, size, normalized, type, stride, start, instance);
        // assuming that if there is instanced data then this will be drawn with instancing!
        this.instanced = this.instanced || instance;
        return this;
    };
    /**
     * Returns the requested attribute.
     *
     * @param id - The name of the attribute required
     * @return - The attribute requested.
     */ Geometry.prototype.getAttribute = function(id) {
        return this.attributes[id];
    };
    /**
     * Returns the requested buffer.
     *
     * @param id - The name of the buffer required.
     * @return - The buffer requested.
     */ Geometry.prototype.getBuffer = function(id) {
        return this.buffers[this.getAttribute(id).buffer];
    };
    /**
    *
    * Adds an index buffer to the geometry
    * The index buffer contains integers, three for each triangle in the geometry, which reference the various attribute buffers (position, colour, UV coordinates, other UV coordinates, normal, …). There is only ONE index buffer.
    *
    * @param {PIXI.Buffer|number[]} [buffer] - The buffer that holds the data of the index buffer. You can also provide an Array and a buffer will be created from it.
    * @return - Returns self, useful for chaining.
    */ Geometry.prototype.addIndex = function(buffer) {
        if (!(buffer instanceof Buffer)) {
            // its an array!
            if (buffer instanceof Array) buffer = new Uint16Array(buffer);
            buffer = new Buffer(buffer);
        }
        buffer.type = (0, $P8XPi.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER;
        this.indexBuffer = buffer;
        if (this.buffers.indexOf(buffer) === -1) this.buffers.push(buffer);
        return this;
    };
    /**
     * Returns the index buffer
     *
     * @return - The index buffer.
     */ Geometry.prototype.getIndex = function() {
        return this.indexBuffer;
    };
    /**
     * This function modifies the structure so that all current attributes become interleaved into a single buffer
     * This can be useful if your model remains static as it offers a little performance boost
     *
     * @return - Returns self, useful for chaining.
     */ Geometry.prototype.interleave = function() {
        // a simple check to see if buffers are already interleaved..
        if (this.buffers.length === 1 || this.buffers.length === 2 && this.indexBuffer) return this;
        // assume already that no buffers are interleaved
        var arrays = [];
        var sizes = [];
        var interleavedBuffer = new Buffer();
        var i;
        for(i in this.attributes){
            var attribute = this.attributes[i];
            var buffer = this.buffers[attribute.buffer];
            arrays.push(buffer.data);
            sizes.push(attribute.size * byteSizeMap[attribute.type] / 4);
            attribute.buffer = 0;
        }
        interleavedBuffer.data = interleaveTypedArrays(arrays, sizes);
        for(i = 0; i < this.buffers.length; i++)if (this.buffers[i] !== this.indexBuffer) this.buffers[i].destroy();
        this.buffers = [
            interleavedBuffer
        ];
        if (this.indexBuffer) this.buffers.push(this.indexBuffer);
        return this;
    };
    /** Get the size of the geometries, in vertices. */ Geometry.prototype.getSize = function() {
        for(var i in this.attributes){
            var attribute = this.attributes[i];
            var buffer = this.buffers[attribute.buffer];
            return buffer.data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    };
    /** Disposes WebGL resources that are connected to this geometry. */ Geometry.prototype.dispose = function() {
        this.disposeRunner.emit(this, false);
    };
    /** Destroys the geometry. */ Geometry.prototype.destroy = function() {
        this.dispose();
        this.buffers = null;
        this.indexBuffer = null;
        this.attributes = null;
    };
    /**
     * Returns a clone of the geometry.
     *
     * @returns - A new clone of this geometry.
     */ Geometry.prototype.clone = function() {
        var geometry = new Geometry();
        for(var i = 0; i < this.buffers.length; i++)geometry.buffers[i] = new Buffer(this.buffers[i].data.slice(0));
        for(var i in this.attributes){
            var attrib = this.attributes[i];
            geometry.attributes[i] = new Attribute(attrib.buffer, attrib.size, attrib.normalized, attrib.type, attrib.stride, attrib.start, attrib.instance);
        }
        if (this.indexBuffer) {
            geometry.indexBuffer = geometry.buffers[this.buffers.indexOf(this.indexBuffer)];
            geometry.indexBuffer.type = (0, $P8XPi.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER;
        }
        return geometry;
    };
    /**
     * Merges an array of geometries into a new single one.
     *
     * Geometry attribute styles must match for this operation to work.
     *
     * @param geometries - array of geometries to merge
     * @return - Shiny new geometry!
     */ Geometry.merge = function(geometries) {
        // todo add a geometry check!
        // also a size check.. cant be too big!]
        var geometryOut = new Geometry();
        var arrays = [];
        var sizes = [];
        var offsets = [];
        var geometry;
        // pass one.. get sizes..
        for(var i = 0; i < geometries.length; i++){
            geometry = geometries[i];
            for(var j = 0; j < geometry.buffers.length; j++){
                sizes[j] = sizes[j] || 0;
                sizes[j] += geometry.buffers[j].data.length;
                offsets[j] = 0;
            }
        }
        // build the correct size arrays..
        for(var i = 0; i < geometry.buffers.length; i++){
            // TODO types!
            arrays[i] = new map$1[(0, $csytw.getBufferType)(geometry.buffers[i].data)](sizes[i]);
            geometryOut.buffers[i] = new Buffer(arrays[i]);
        }
        // pass to set data..
        for(var i = 0; i < geometries.length; i++){
            geometry = geometries[i];
            for(var j = 0; j < geometry.buffers.length; j++){
                arrays[j].set(geometry.buffers[j].data, offsets[j]);
                offsets[j] += geometry.buffers[j].data.length;
            }
        }
        geometryOut.attributes = geometry.attributes;
        if (geometry.indexBuffer) {
            geometryOut.indexBuffer = geometryOut.buffers[geometry.buffers.indexOf(geometry.indexBuffer)];
            geometryOut.indexBuffer.type = (0, $P8XPi.BUFFER_TYPE).ELEMENT_ARRAY_BUFFER;
            var offset = 0;
            var stride = 0;
            var offset2 = 0;
            var bufferIndexToCount = 0;
            // get a buffer
            for(var i = 0; i < geometry.buffers.length; i++)if (geometry.buffers[i] !== geometry.indexBuffer) {
                bufferIndexToCount = i;
                break;
            }
            // figure out the stride of one buffer..
            for(var i in geometry.attributes){
                var attribute = geometry.attributes[i];
                if ((attribute.buffer | 0) === bufferIndexToCount) stride += attribute.size * byteSizeMap[attribute.type] / 4;
            }
            // time to off set all indexes..
            for(var i = 0; i < geometries.length; i++){
                var indexBufferData = geometries[i].indexBuffer.data;
                for(var j = 0; j < indexBufferData.length; j++)geometryOut.indexBuffer.data[j + offset2] += offset;
                offset += geometries[i].buffers[bufferIndexToCount].data.length / stride;
                offset2 += indexBufferData.length;
            }
        }
        return geometryOut;
    };
    return Geometry;
}();
/**
 * Helper class to create a quad
 *
 * @class
 * @memberof PIXI
 */ var Quad = /** @class */ function(_super) {
    __extends(Quad, _super);
    function Quad() {
        var _this = _super.call(this) || this;
        _this.addAttribute('aVertexPosition', new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ])).addIndex([
            0,
            1,
            3,
            2
        ]);
        return _this;
    }
    return Quad;
}(Geometry);
/**
 * Helper class to create a quad with uvs like in v4
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.Geometry
 */ var QuadUv = /** @class */ function(_super) {
    __extends(QuadUv, _super);
    function QuadUv() {
        var _this = _super.call(this) || this;
        /**
         * An array of vertices
         *
         * @member {Float32Array}
         */ _this.vertices = new Float32Array([
            -1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            1
        ]);
        /**
         * The Uvs of the quad
         *
         * @member {Float32Array}
         */ _this.uvs = new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ]);
        _this.vertexBuffer = new Buffer(_this.vertices);
        _this.uvBuffer = new Buffer(_this.uvs);
        _this.addAttribute('aVertexPosition', _this.vertexBuffer).addAttribute('aTextureCoord', _this.uvBuffer).addIndex([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        return _this;
    }
    /**
     * Maps two Rectangle to the quad.
     *
     * @param {PIXI.Rectangle} targetTextureFrame - the first rectangle
     * @param {PIXI.Rectangle} destinationFrame - the second rectangle
     * @return {PIXI.Quad} Returns itself.
     */ QuadUv.prototype.map = function(targetTextureFrame, destinationFrame) {
        var x = 0; // destinationFrame.x / targetTextureFrame.width;
        var y = 0; // destinationFrame.y / targetTextureFrame.height;
        this.uvs[0] = x;
        this.uvs[1] = y;
        this.uvs[2] = x + destinationFrame.width / targetTextureFrame.width;
        this.uvs[3] = y;
        this.uvs[4] = x + destinationFrame.width / targetTextureFrame.width;
        this.uvs[5] = y + destinationFrame.height / targetTextureFrame.height;
        this.uvs[6] = x;
        this.uvs[7] = y + destinationFrame.height / targetTextureFrame.height;
        x = destinationFrame.x;
        y = destinationFrame.y;
        this.vertices[0] = x;
        this.vertices[1] = y;
        this.vertices[2] = x + destinationFrame.width;
        this.vertices[3] = y;
        this.vertices[4] = x + destinationFrame.width;
        this.vertices[5] = y + destinationFrame.height;
        this.vertices[6] = x;
        this.vertices[7] = y + destinationFrame.height;
        this.invalidate();
        return this;
    };
    /**
     * legacy upload method, just marks buffers dirty
     * @returns {PIXI.QuadUv} Returns itself.
     */ QuadUv.prototype.invalidate = function() {
        this.vertexBuffer._updateID++;
        this.uvBuffer._updateID++;
        return this;
    };
    return QuadUv;
}(Geometry);
var UID$2 = 0;
/**
 * Uniform group holds uniform map and some ID's for work
 *
 * `UniformGroup` has two modes:
 *
 * 1: Normal mode
 * Normal mode will upload the uniforms with individual function calls as required
 *
 * 2: Uniform buffer mode
 * This mode will treat the uniforms as a uniform buffer. You can pass in either a buffer that you manually handle, or
 * or a generic object that PixiJS will automatically map to a buffer for you.
 * For maximum benefits, make Ubo UniformGroups static, and only update them each frame.
 *
 * Rules of UBOs:
 * - UBOs only work with WebGL2, so make sure you have a fallback!
 * - Only floats are supported (including vec[2,3,4], mat[2,3,4])
 * - Samplers cannot be used in ubo's (a GPU limitation)
 * - You must ensure that the object you pass in exactly matches in the shader ubo structure.
 * Otherwise, weirdness will ensue!
 * - The name of the ubo object added to the group must match exactly the name of the ubo in the shader.
 *
 * ```
 * // ubo in shader:
 * uniform myCoolData { // declaring a ubo..
 * mat4 uCoolMatrix;
 * float uFloatyMcFloatFace
 *
 *
 * // a new uniform buffer object..
 * const myCoolData = new UniformBufferGroup({
 *   uCoolMatrix: new Matrix(),
 *   uFloatyMcFloatFace: 23,
 * }}
 *
 * // build a shader...
 * const shader = Shader.from(srcVert, srcFrag, {
 *   myCoolData // name matches the ubo name in the shader. will be processed accordingly.
 * })
 *
 *  ```
 *
 * @class
 * @memberof PIXI
 */ var UniformGroup = /** @class */ function() {
    /**
     * @param {object | Buffer} [uniforms] - Custom uniforms to use to augment the built-in ones. Or a pixi buffer
     * @param {boolean} [isStatic] - Uniforms wont be changed after creation
     * @param {boolean} [isUbo] - if true, will treat this uniform group as a uniform buffer object
     */ function UniformGroup(uniforms, isStatic, isUbo) {
        /**
         * Its a group and not a single uniforms
         * @member {boolean}
         * @readonly
         * @default true
         */ this.group = true;
        // lets generate this when the shader ?
        this.syncUniforms = {};
        /**
         * dirty version
         * @protected
         * @member {number}
         */ this.dirtyId = 0;
        /**
         * unique id
         * @protected
         * @member {number}
         */ this.id = UID$2++;
        /**
         * Uniforms wont be changed after creation
         * @member {boolean}
         */ this.static = !!isStatic;
        /**
         * Flags whether this group is treated like a uniform buffer object.
         * @member {boolean}
         */ this.ubo = !!isUbo;
        if (uniforms instanceof Buffer) {
            this.buffer = uniforms;
            this.buffer.type = (0, $P8XPi.BUFFER_TYPE).UNIFORM_BUFFER;
            this.autoManage = false;
            this.ubo = true;
        } else {
            /**
             * uniform values
             * @member {object}
             * @readonly
             */ this.uniforms = uniforms;
            if (this.ubo) {
                this.buffer = new Buffer(new Float32Array(1));
                this.buffer.type = (0, $P8XPi.BUFFER_TYPE).UNIFORM_BUFFER;
                this.autoManage = true;
            }
        }
    }
    UniformGroup.prototype.update = function() {
        this.dirtyId++;
        if (!this.autoManage && this.buffer) this.buffer.update();
    };
    UniformGroup.prototype.add = function(name, uniforms, _static) {
        if (!this.ubo) this.uniforms[name] = new UniformGroup(uniforms, _static);
        else // eslint-disable-next-line max-len
        throw new Error('[UniformGroup] uniform groups in ubo mode cannot be modified, or have uniform groups nested in them');
    };
    UniformGroup.from = function(uniforms, _static, _ubo) {
        return new UniformGroup(uniforms, _static, _ubo);
    };
    /**
     * A short hand function for creating a static UBO UniformGroup.
     *
     * @param uniforms - the ubo item
     * @param _static - should this be updated each time it is used? defaults to true here!
     */ UniformGroup.uboFrom = function(uniforms, _static) {
        return new UniformGroup(uniforms, _static !== null && _static !== void 0 ? _static : true, true);
    };
    return UniformGroup;
}();
/**
 * System plugin to the renderer to manage filter states.
 *
 * @ignore
 */ var FilterState = /** @class */ function() {
    function FilterState() {
        this.renderTexture = null;
        this.target = null;
        this.legacy = false;
        this.resolution = 1;
        this.multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
        // next three fields are created only for root
        // re-assigned for everything else
        this.sourceFrame = new (0, $6qzqq.Rectangle)();
        this.destinationFrame = new (0, $6qzqq.Rectangle)();
        this.bindingSourceFrame = new (0, $6qzqq.Rectangle)();
        this.bindingDestinationFrame = new (0, $6qzqq.Rectangle)();
        this.filters = [];
        this.transform = null;
    }
    /** Clears the state */ FilterState.prototype.clear = function() {
        this.target = null;
        this.filters = null;
        this.renderTexture = null;
    };
    return FilterState;
}();
var tempPoints = [
    new (0, $6qzqq.Point)(),
    new (0, $6qzqq.Point)(),
    new (0, $6qzqq.Point)(),
    new (0, $6qzqq.Point)()
];
var tempMatrix = new (0, $6qzqq.Matrix)();
/**
 * System plugin to the renderer to manage filters.
 *
 * ## Pipeline
 *
 * The FilterSystem executes the filtering pipeline by rendering the display-object into a texture, applying its
 * [filters]{@link PIXI.Filter} in series, and the last filter outputs into the final render-target.
 *
 * The filter-frame is the rectangle in world space being filtered, and those contents are mapped into
 * `(0, 0, filterFrame.width, filterFrame.height)` into the filter render-texture. The filter-frame is also called
 * the source-frame, as it is used to bind the filter render-textures. The last filter outputs to the `filterFrame`
 * in the final render-target.
 *
 * ## Usage
 *
 * {@link PIXI.Container#renderAdvanced} is an example of how to use the filter system. It is a 3 step process:
 *
 * * **push**: Use {@link PIXI.FilterSystem#push} to push the set of filters to be applied on a filter-target.
 * * **render**: Render the contents to be filtered using the renderer. The filter-system will only capture the contents
 *      inside the bounds of the filter-target. NOTE: Using {@link PIXI.Renderer#render} is
 *      illegal during an existing render cycle, and it may reset the filter system.
 * * **pop**: Use {@link PIXI.FilterSystem#pop} to pop & execute the filters you initially pushed. It will apply them
 *      serially and output to the bounds of the filter-target.
 *
 * @memberof PIXI
 */ var FilterSystem = /** @class */ function() {
    /**
     * @param renderer - The renderer this System works for.
     */ function FilterSystem(renderer) {
        this.renderer = renderer;
        this.defaultFilterStack = [
            {}
        ];
        this.texturePool = new RenderTexturePool();
        this.texturePool.setScreenSize(renderer.view);
        this.statePool = [];
        this.quad = new Quad();
        this.quadUv = new QuadUv();
        this.tempRect = new (0, $6qzqq.Rectangle)();
        this.activeState = {};
        this.globalUniforms = new UniformGroup({
            outputFrame: new (0, $6qzqq.Rectangle)(),
            inputSize: new Float32Array(4),
            inputPixel: new Float32Array(4),
            inputClamp: new Float32Array(4),
            resolution: 1,
            // legacy variables
            filterArea: new Float32Array(4),
            filterClamp: new Float32Array(4)
        }, true);
        this.forceClear = false;
        this.useMaxPadding = false;
    }
    /**
     * Pushes a set of filters to be applied later to the system. This will redirect further rendering into an
     * input render-texture for the rest of the filtering pipeline.
     *
     * @param {PIXI.DisplayObject} target - The target of the filter to render.
     * @param filters - The filters to apply.
     */ FilterSystem.prototype.push = function(target, filters) {
        var _a, _b;
        var renderer = this.renderer;
        var filterStack = this.defaultFilterStack;
        var state = this.statePool.pop() || new FilterState();
        var renderTextureSystem = this.renderer.renderTexture;
        var resolution = filters[0].resolution;
        var multisample = filters[0].multisample;
        var padding = filters[0].padding;
        var autoFit = filters[0].autoFit;
        // We don't know whether it's a legacy filter until it was bound for the first time,
        // therefore we have to assume that it is if legacy is undefined.
        var legacy = (_a = filters[0].legacy) !== null && _a !== void 0 ? _a : true;
        for(var i = 1; i < filters.length; i++){
            var filter = filters[i];
            // let's use the lowest resolution
            resolution = Math.min(resolution, filter.resolution);
            // let's use the lowest number of samples
            multisample = Math.min(multisample, filter.multisample);
            // figure out the padding required for filters
            padding = this.useMaxPadding ? Math.max(padding, filter.padding) : padding + filter.padding;
            // only auto fit if all filters are autofit
            autoFit = autoFit && filter.autoFit;
            legacy = legacy || ((_b = filter.legacy) !== null && _b !== void 0 ? _b : true);
        }
        if (filterStack.length === 1) this.defaultFilterStack[0].renderTexture = renderTextureSystem.current;
        filterStack.push(state);
        state.resolution = resolution;
        state.multisample = multisample;
        state.legacy = legacy;
        state.target = target;
        state.sourceFrame.copyFrom(target.filterArea || target.getBounds(true));
        state.sourceFrame.pad(padding);
        if (autoFit) {
            var sourceFrameProjected = this.tempRect.copyFrom(renderTextureSystem.sourceFrame);
            // Project source frame into world space (if projection is applied)
            if (renderer.projection.transform) this.transformAABB(tempMatrix.copyFrom(renderer.projection.transform).invert(), sourceFrameProjected);
            state.sourceFrame.fit(sourceFrameProjected);
        }
        // Round sourceFrame in screen space based on render-texture.
        this.roundFrame(state.sourceFrame, renderTextureSystem.current ? renderTextureSystem.current.resolution : renderer.resolution, renderTextureSystem.sourceFrame, renderTextureSystem.destinationFrame, renderer.projection.transform);
        state.renderTexture = this.getOptimalFilterTexture(state.sourceFrame.width, state.sourceFrame.height, resolution, multisample);
        state.filters = filters;
        state.destinationFrame.width = state.renderTexture.width;
        state.destinationFrame.height = state.renderTexture.height;
        var destinationFrame = this.tempRect;
        destinationFrame.x = 0;
        destinationFrame.y = 0;
        destinationFrame.width = state.sourceFrame.width;
        destinationFrame.height = state.sourceFrame.height;
        state.renderTexture.filterFrame = state.sourceFrame;
        state.bindingSourceFrame.copyFrom(renderTextureSystem.sourceFrame);
        state.bindingDestinationFrame.copyFrom(renderTextureSystem.destinationFrame);
        state.transform = renderer.projection.transform;
        renderer.projection.transform = null;
        renderTextureSystem.bind(state.renderTexture, state.sourceFrame, destinationFrame);
        renderer.framebuffer.clear(0, 0, 0, 0);
    };
    /** Pops off the filter and applies it. */ FilterSystem.prototype.pop = function() {
        var filterStack = this.defaultFilterStack;
        var state = filterStack.pop();
        var filters = state.filters;
        this.activeState = state;
        var globalUniforms = this.globalUniforms.uniforms;
        globalUniforms.outputFrame = state.sourceFrame;
        globalUniforms.resolution = state.resolution;
        var inputSize = globalUniforms.inputSize;
        var inputPixel = globalUniforms.inputPixel;
        var inputClamp = globalUniforms.inputClamp;
        inputSize[0] = state.destinationFrame.width;
        inputSize[1] = state.destinationFrame.height;
        inputSize[2] = 1.0 / inputSize[0];
        inputSize[3] = 1.0 / inputSize[1];
        inputPixel[0] = Math.round(inputSize[0] * state.resolution);
        inputPixel[1] = Math.round(inputSize[1] * state.resolution);
        inputPixel[2] = 1.0 / inputPixel[0];
        inputPixel[3] = 1.0 / inputPixel[1];
        inputClamp[0] = 0.5 * inputPixel[2];
        inputClamp[1] = 0.5 * inputPixel[3];
        inputClamp[2] = state.sourceFrame.width * inputSize[2] - 0.5 * inputPixel[2];
        inputClamp[3] = state.sourceFrame.height * inputSize[3] - 0.5 * inputPixel[3];
        // only update the rect if its legacy..
        if (state.legacy) {
            var filterArea = globalUniforms.filterArea;
            filterArea[0] = state.destinationFrame.width;
            filterArea[1] = state.destinationFrame.height;
            filterArea[2] = state.sourceFrame.x;
            filterArea[3] = state.sourceFrame.y;
            globalUniforms.filterClamp = globalUniforms.inputClamp;
        }
        this.globalUniforms.update();
        var lastState = filterStack[filterStack.length - 1];
        this.renderer.framebuffer.blit();
        if (filters.length === 1) {
            filters[0].apply(this, state.renderTexture, lastState.renderTexture, (0, $P8XPi.CLEAR_MODES).BLEND, state);
            this.returnFilterTexture(state.renderTexture);
        } else {
            var flip = state.renderTexture;
            var flop = this.getOptimalFilterTexture(flip.width, flip.height, state.resolution);
            flop.filterFrame = flip.filterFrame;
            var i = 0;
            for(i = 0; i < filters.length - 1; ++i){
                if (i === 1 && state.multisample > 1) {
                    flop = this.getOptimalFilterTexture(flip.width, flip.height, state.resolution);
                    flop.filterFrame = flip.filterFrame;
                }
                filters[i].apply(this, flip, flop, (0, $P8XPi.CLEAR_MODES).CLEAR, state);
                var t = flip;
                flip = flop;
                flop = t;
            }
            filters[i].apply(this, flip, lastState.renderTexture, (0, $P8XPi.CLEAR_MODES).BLEND, state);
            if (i > 1 && state.multisample > 1) this.returnFilterTexture(state.renderTexture);
            this.returnFilterTexture(flip);
            this.returnFilterTexture(flop);
        }
        // lastState.renderTexture is blitted when lastState is popped
        state.clear();
        this.statePool.push(state);
    };
    /**
     * Binds a renderTexture with corresponding `filterFrame`, clears it if mode corresponds.
     *
     * @param filterTexture - renderTexture to bind, should belong to filter pool or filter stack
     * @param clearMode - clearMode, by default its CLEAR/YES. See {@link PIXI.CLEAR_MODES}
     */ FilterSystem.prototype.bindAndClear = function(filterTexture, clearMode) {
        if (clearMode === void 0) clearMode = (0, $P8XPi.CLEAR_MODES).CLEAR;
        var _a = this.renderer, renderTextureSystem = _a.renderTexture, stateSystem = _a.state;
        if (filterTexture === this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture) // Restore projection transform if rendering into the output render-target.
        this.renderer.projection.transform = this.activeState.transform;
        else // Prevent projection within filtering pipeline.
        this.renderer.projection.transform = null;
        if (filterTexture && filterTexture.filterFrame) {
            var destinationFrame = this.tempRect;
            destinationFrame.x = 0;
            destinationFrame.y = 0;
            destinationFrame.width = filterTexture.filterFrame.width;
            destinationFrame.height = filterTexture.filterFrame.height;
            renderTextureSystem.bind(filterTexture, filterTexture.filterFrame, destinationFrame);
        } else if (filterTexture !== this.defaultFilterStack[this.defaultFilterStack.length - 1].renderTexture) renderTextureSystem.bind(filterTexture);
        else // Restore binding for output render-target.
        this.renderer.renderTexture.bind(filterTexture, this.activeState.bindingSourceFrame, this.activeState.bindingDestinationFrame);
        // Clear the texture in BLIT mode if blending is disabled or the forceClear flag is set. The blending
        // is stored in the 0th bit of the state.
        var autoClear = stateSystem.stateId & 1 || this.forceClear;
        if (clearMode === (0, $P8XPi.CLEAR_MODES).CLEAR || clearMode === (0, $P8XPi.CLEAR_MODES).BLIT && autoClear) // Use framebuffer.clear because we want to clear the whole filter texture, not just the filtering
        // area over which the shaders are run. This is because filters may sampling outside of it (e.g. blur)
        // instead of clamping their arithmetic.
        this.renderer.framebuffer.clear(0, 0, 0, 0);
    };
    /**
     * Draws a filter using the default rendering process.
     *
     * This should be called only by {@link Filter#apply}.
     *
     * @param filter - The filter to draw.
     * @param input - The input render target.
     * @param output - The target to output to.
     * @param clearMode - Should the output be cleared before rendering to it
     */ FilterSystem.prototype.applyFilter = function(filter, input, output, clearMode) {
        var renderer = this.renderer;
        // Set state before binding, so bindAndClear gets the blend mode.
        renderer.state.set(filter.state);
        this.bindAndClear(output, clearMode);
        // set the uniforms..
        filter.uniforms.uSampler = input;
        filter.uniforms.filterGlobals = this.globalUniforms;
        // TODO make it so that the order of this does not matter..
        // because it does at the moment cos of global uniforms.
        // they need to get resynced
        renderer.shader.bind(filter);
        // check to see if the filter is a legacy one..
        filter.legacy = !!filter.program.attributeData.aTextureCoord;
        if (filter.legacy) {
            this.quadUv.map(input._frame, input.filterFrame);
            renderer.geometry.bind(this.quadUv);
            renderer.geometry.draw((0, $P8XPi.DRAW_MODES).TRIANGLES);
        } else {
            renderer.geometry.bind(this.quad);
            renderer.geometry.draw((0, $P8XPi.DRAW_MODES).TRIANGLE_STRIP);
        }
    };
    /**
     * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
     *
     * Use `outputMatrix * vTextureCoord` in the shader.
     *
     * @param outputMatrix - The matrix to output to.
     * @param {PIXI.Sprite} sprite - The sprite to map to.
     * @return The mapped matrix.
     */ FilterSystem.prototype.calculateSpriteMatrix = function(outputMatrix, sprite) {
        var _a = this.activeState, sourceFrame = _a.sourceFrame, destinationFrame = _a.destinationFrame;
        var orig = sprite._texture.orig;
        var mappedMatrix = outputMatrix.set(destinationFrame.width, 0, 0, destinationFrame.height, sourceFrame.x, sourceFrame.y);
        var worldTransform = sprite.worldTransform.copyTo((0, $6qzqq.Matrix).TEMP_MATRIX);
        worldTransform.invert();
        mappedMatrix.prepend(worldTransform);
        mappedMatrix.scale(1.0 / orig.width, 1.0 / orig.height);
        mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y);
        return mappedMatrix;
    };
    /** Destroys this Filter System. */ FilterSystem.prototype.destroy = function() {
        this.renderer = null;
        // Those textures has to be destroyed by RenderTextureSystem or FramebufferSystem
        this.texturePool.clear(false);
    };
    /**
     * Gets a Power-of-Two render texture or fullScreen texture
     *
     * @param minWidth - The minimum width of the render texture in real pixels.
     * @param minHeight - The minimum height of the render texture in real pixels.
     * @param resolution - The resolution of the render texture.
     * @param multisample - Number of samples of the render texture.
     * @return - The new render texture.
     */ FilterSystem.prototype.getOptimalFilterTexture = function(minWidth, minHeight, resolution, multisample) {
        if (resolution === void 0) resolution = 1;
        if (multisample === void 0) multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
        return this.texturePool.getOptimalTexture(minWidth, minHeight, resolution, multisample);
    };
    /**
     * Gets extra render texture to use inside current filter
     * To be compliant with older filters, you can use params in any order
     *
     * @param input - renderTexture from which size and resolution will be copied
     * @param resolution - override resolution of the renderTexture
     * @param multisample - number of samples of the renderTexture
     */ FilterSystem.prototype.getFilterTexture = function(input, resolution, multisample) {
        if (typeof input === 'number') {
            var swap = input;
            input = resolution;
            resolution = swap;
        }
        input = input || this.activeState.renderTexture;
        var filterTexture = this.texturePool.getOptimalTexture(input.width, input.height, resolution || input.resolution, multisample || (0, $P8XPi.MSAA_QUALITY).NONE);
        filterTexture.filterFrame = input.filterFrame;
        return filterTexture;
    };
    /**
     * Frees a render texture back into the pool.
     *
     * @param renderTexture - The renderTarget to free
     */ FilterSystem.prototype.returnFilterTexture = function(renderTexture) {
        this.texturePool.returnTexture(renderTexture);
    };
    /** Empties the texture pool. */ FilterSystem.prototype.emptyPool = function() {
        this.texturePool.clear(true);
    };
    /** Calls `texturePool.resize()`, affects fullScreen renderTextures. */ FilterSystem.prototype.resize = function() {
        this.texturePool.setScreenSize(this.renderer.view);
    };
    /**
     * @param matrix - first param
     * @param rect - second param
     */ FilterSystem.prototype.transformAABB = function(matrix, rect) {
        var lt = tempPoints[0];
        var lb = tempPoints[1];
        var rt = tempPoints[2];
        var rb = tempPoints[3];
        lt.set(rect.left, rect.top);
        lb.set(rect.left, rect.bottom);
        rt.set(rect.right, rect.top);
        rb.set(rect.right, rect.bottom);
        matrix.apply(lt, lt);
        matrix.apply(lb, lb);
        matrix.apply(rt, rt);
        matrix.apply(rb, rb);
        var x0 = Math.min(lt.x, lb.x, rt.x, rb.x);
        var y0 = Math.min(lt.y, lb.y, rt.y, rb.y);
        var x1 = Math.max(lt.x, lb.x, rt.x, rb.x);
        var y1 = Math.max(lt.y, lb.y, rt.y, rb.y);
        rect.x = x0;
        rect.y = y0;
        rect.width = x1 - x0;
        rect.height = y1 - y0;
    };
    FilterSystem.prototype.roundFrame = function(frame, resolution, bindingSourceFrame, bindingDestinationFrame, transform) {
        if (frame.width <= 0 || frame.height <= 0 || bindingSourceFrame.width <= 0 || bindingSourceFrame.height <= 0) return;
        if (transform) {
            var a = transform.a, b = transform.b, c = transform.c, d = transform.d;
            // Skip if skew/rotation present in matrix, except for multiple of 90° rotation. If rotation
            // is a multiple of 90°, then either pair of (b,c) or (a,d) will be (0,0).
            if ((Math.abs(b) > 1e-4 || Math.abs(c) > 1e-4) && (Math.abs(a) > 1e-4 || Math.abs(d) > 1e-4)) return;
        }
        transform = transform ? tempMatrix.copyFrom(transform) : tempMatrix.identity();
        // Get forward transform from world space to screen space
        transform.translate(-bindingSourceFrame.x, -bindingSourceFrame.y).scale(bindingDestinationFrame.width / bindingSourceFrame.width, bindingDestinationFrame.height / bindingSourceFrame.height).translate(bindingDestinationFrame.x, bindingDestinationFrame.y);
        // Convert frame to screen space
        this.transformAABB(transform, frame);
        // Round frame in screen space
        frame.ceil(resolution);
        // Project back into world space.
        this.transformAABB(transform.invert(), frame);
    };
    return FilterSystem;
}();
/**
 * Base for a common object renderer that can be used as a
 * system renderer plugin.
 *
 * @memberof PIXI
 */ var ObjectRenderer = /** @class */ function() {
    /**
     * @param renderer - The renderer this manager works for.
     */ function ObjectRenderer(renderer) {
        this.renderer = renderer;
    }
    /**
     * Stub method that should be used to empty the current
     * batch by rendering objects now.
     */ ObjectRenderer.prototype.flush = function() {
    // flush!
    };
    /**
     * Generic destruction method that frees all resources. This
     * should be called by subclasses.
     */ ObjectRenderer.prototype.destroy = function() {
        this.renderer = null;
    };
    /**
     * Stub method that initializes any state required before
     * rendering starts. It is different from the `prerender`
     * signal, which occurs every frame, in that it is called
     * whenever an object requests _this_ renderer specifically.
     */ ObjectRenderer.prototype.start = function() {
    // set the shader..
    };
    /**
     * Stops the renderer. It should free up any state and
     * become dormant.
     */ ObjectRenderer.prototype.stop = function() {
        this.flush();
    };
    /**
     * Keeps the object to render. It doesn't have to be
     * rendered immediately.
     *
     * @param {PIXI.DisplayObject} object - The object to render.
     */ ObjectRenderer.prototype.render = function(_object) {
    // render the object
    };
    return ObjectRenderer;
}();
/**
 * System plugin to the renderer to manage batching.
 *
 * @memberof PIXI
 */ var BatchSystem = /** @class */ function() {
    /**
     * @param renderer - The renderer this System works for.
     */ function BatchSystem(renderer) {
        this.renderer = renderer;
        this.emptyRenderer = new ObjectRenderer(renderer);
        this.currentRenderer = this.emptyRenderer;
    }
    /**
     * Changes the current renderer to the one given in parameter
     *
     * @param objectRenderer - The object renderer to use.
     */ BatchSystem.prototype.setObjectRenderer = function(objectRenderer) {
        if (this.currentRenderer === objectRenderer) return;
        this.currentRenderer.stop();
        this.currentRenderer = objectRenderer;
        this.currentRenderer.start();
    };
    /**
     * This should be called if you wish to do some custom rendering
     * It will basically render anything that may be batched up such as sprites
     */ BatchSystem.prototype.flush = function() {
        this.setObjectRenderer(this.emptyRenderer);
    };
    /**
     * Reset the system to an empty renderer
     */ BatchSystem.prototype.reset = function() {
        this.setObjectRenderer(this.emptyRenderer);
    };
    /**
     * Handy function for batch renderers: copies bound textures in first maxTextures locations to array
     * sets actual _batchLocation for them
     *
     * @param arr - arr copy destination
     * @param maxTextures - number of copied elements
     */ BatchSystem.prototype.copyBoundTextures = function(arr, maxTextures) {
        var boundTextures = this.renderer.texture.boundTextures;
        for(var i = maxTextures - 1; i >= 0; --i){
            arr[i] = boundTextures[i] || null;
            if (arr[i]) arr[i]._batchLocation = i;
        }
    };
    /**
     * Assigns batch locations to textures in array based on boundTextures state.
     * All textures in texArray should have `_batchEnabled = _batchId`,
     * and their count should be less than `maxTextures`.
     *
     * @param texArray - textures to bound
     * @param boundTextures - current state of bound textures
     * @param batchId - marker for _batchEnabled param of textures in texArray
     * @param maxTextures - number of texture locations to manipulate
     */ BatchSystem.prototype.boundArray = function(texArray, boundTextures, batchId, maxTextures) {
        var elements = texArray.elements, ids = texArray.ids, count = texArray.count;
        var j = 0;
        for(var i = 0; i < count; i++){
            var tex = elements[i];
            var loc = tex._batchLocation;
            if (loc >= 0 && loc < maxTextures && boundTextures[loc] === tex) {
                ids[i] = loc;
                continue;
            }
            while(j < maxTextures){
                var bound = boundTextures[j];
                if (bound && bound._batchEnabled === batchId && bound._batchLocation === j) {
                    j++;
                    continue;
                }
                ids[i] = j;
                tex._batchLocation = j;
                boundTextures[j] = tex;
                break;
            }
        }
    };
    /**
     * @ignore
     */ BatchSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return BatchSystem;
}();
var CONTEXT_UID_COUNTER = 0;
/**
 * System plugin to the renderer to manage the context.
 *
 * @memberof PIXI
 */ var ContextSystem = /** @class */ function() {
    /** @param renderer - The renderer this System works for. */ function ContextSystem(renderer) {
        this.renderer = renderer;
        this.webGLVersion = 1;
        this.extensions = {};
        this.supports = {
            uint32Indices: false
        };
        // Bind functions
        this.handleContextLost = this.handleContextLost.bind(this);
        this.handleContextRestored = this.handleContextRestored.bind(this);
        renderer.view.addEventListener('webglcontextlost', this.handleContextLost, false);
        renderer.view.addEventListener('webglcontextrestored', this.handleContextRestored, false);
    }
    Object.defineProperty(ContextSystem.prototype, "isLost", {
        /**
         * `true` if the context is lost
         *
         * @readonly
         */ get: function() {
            return !this.gl || this.gl.isContextLost();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Handles the context change event.
     *
     * @param {WebGLRenderingContext} gl - New WebGL context.
     */ ContextSystem.prototype.contextChange = function(gl) {
        this.gl = gl;
        this.renderer.gl = gl;
        this.renderer.CONTEXT_UID = CONTEXT_UID_COUNTER++;
        // restore a context if it was previously lost
        if (gl.isContextLost() && gl.getExtension('WEBGL_lose_context')) gl.getExtension('WEBGL_lose_context').restoreContext();
    };
    /**
     * Initializes the context.
     *
     * @protected
     * @param {WebGLRenderingContext} gl - WebGL context
     */ ContextSystem.prototype.initFromContext = function(gl) {
        this.gl = gl;
        this.validateContext(gl);
        this.renderer.gl = gl;
        this.renderer.CONTEXT_UID = CONTEXT_UID_COUNTER++;
        this.renderer.runners.contextChange.emit(gl);
    };
    /**
     * Initialize from context options
     *
     * @protected
     * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
     * @param {object} options - context attributes
     */ ContextSystem.prototype.initFromOptions = function(options) {
        var gl = this.createContext(this.renderer.view, options);
        this.initFromContext(gl);
    };
    /**
     * Helper class to create a WebGL Context
     *
     * @param canvas - the canvas element that we will get the context from
     * @param options - An options object that gets passed in to the canvas element containing the
     *    context attributes
     * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
     * @return {WebGLRenderingContext} the WebGL context
     */ ContextSystem.prototype.createContext = function(canvas, options) {
        var gl;
        if ((0, $ezJmd.settings).PREFER_ENV >= (0, $P8XPi.ENV).WEBGL2) gl = canvas.getContext('webgl2', options);
        if (gl) this.webGLVersion = 2;
        else {
            this.webGLVersion = 1;
            gl = canvas.getContext('webgl', options) || canvas.getContext('experimental-webgl', options);
            if (!gl) // fail, not able to get a context
            throw new Error('This browser does not support WebGL. Try using the canvas renderer');
        }
        this.gl = gl;
        this.getExtensions();
        return this.gl;
    };
    /** Auto-populate the {@link PIXI.ContextSystem.extensions extensions}. */ ContextSystem.prototype.getExtensions = function() {
        // time to set up default extensions that Pixi uses.
        var gl = this.gl;
        var common = {
            anisotropicFiltering: gl.getExtension('EXT_texture_filter_anisotropic'),
            floatTextureLinear: gl.getExtension('OES_texture_float_linear'),
            s3tc: gl.getExtension('WEBGL_compressed_texture_s3tc'),
            s3tc_sRGB: gl.getExtension('WEBGL_compressed_texture_s3tc_srgb'),
            etc: gl.getExtension('WEBGL_compressed_texture_etc'),
            etc1: gl.getExtension('WEBGL_compressed_texture_etc1'),
            pvrtc: gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc'),
            atc: gl.getExtension('WEBGL_compressed_texture_atc'),
            astc: gl.getExtension('WEBGL_compressed_texture_astc')
        };
        if (this.webGLVersion === 1) Object.assign(this.extensions, common, {
            drawBuffers: gl.getExtension('WEBGL_draw_buffers'),
            depthTexture: gl.getExtension('WEBGL_depth_texture'),
            loseContext: gl.getExtension('WEBGL_lose_context'),
            vertexArrayObject: gl.getExtension('OES_vertex_array_object') || gl.getExtension('MOZ_OES_vertex_array_object') || gl.getExtension('WEBKIT_OES_vertex_array_object'),
            uint32ElementIndex: gl.getExtension('OES_element_index_uint'),
            // Floats and half-floats
            floatTexture: gl.getExtension('OES_texture_float'),
            floatTextureLinear: gl.getExtension('OES_texture_float_linear'),
            textureHalfFloat: gl.getExtension('OES_texture_half_float'),
            textureHalfFloatLinear: gl.getExtension('OES_texture_half_float_linear')
        });
        else if (this.webGLVersion === 2) Object.assign(this.extensions, common, {
            // Floats and half-floats
            colorBufferFloat: gl.getExtension('EXT_color_buffer_float')
        });
    };
    /**
     * Handles a lost webgl context
     *
     * @param {WebGLContextEvent} event - The context lost event.
     */ ContextSystem.prototype.handleContextLost = function(event) {
        event.preventDefault();
    };
    /** Handles a restored webgl context. */ ContextSystem.prototype.handleContextRestored = function() {
        this.renderer.runners.contextChange.emit(this.gl);
    };
    ContextSystem.prototype.destroy = function() {
        var view = this.renderer.view;
        this.renderer = null;
        // remove listeners
        view.removeEventListener('webglcontextlost', this.handleContextLost);
        view.removeEventListener('webglcontextrestored', this.handleContextRestored);
        this.gl.useProgram(null);
        if (this.extensions.loseContext) this.extensions.loseContext.loseContext();
    };
    /** Handle the post-render runner event. */ ContextSystem.prototype.postrender = function() {
        if (this.renderer.renderingToScreen) this.gl.flush();
    };
    /**
     * Validate context.
     *
     * @param {WebGLRenderingContext} gl - Render context.
     */ ContextSystem.prototype.validateContext = function(gl) {
        var attributes = gl.getContextAttributes();
        var isWebGl2 = 'WebGL2RenderingContext' in self && gl instanceof self.WebGL2RenderingContext;
        if (isWebGl2) this.webGLVersion = 2;
        // this is going to be fairly simple for now.. but at least we have room to grow!
        if (!attributes.stencil) /* eslint-disable max-len, no-console */ console.warn('Provided WebGL context does not have a stencil buffer, masks may not render correctly');
        var hasuint32 = isWebGl2 || !!gl.getExtension('OES_element_index_uint');
        this.supports.uint32Indices = hasuint32;
        if (!hasuint32) /* eslint-disable max-len, no-console */ console.warn('Provided WebGL context does not support 32 index buffer, complex graphics may not render correctly');
    };
    return ContextSystem;
}();
/**
 * Internal framebuffer for WebGL context
 * @class
 * @memberof PIXI
 */ var GLFramebuffer = /** @class */ function() {
    function GLFramebuffer(framebuffer) {
        /**
         * The WebGL framebuffer
         * @member {WebGLFramebuffer}
         */ this.framebuffer = framebuffer;
        /**
         * stencil+depth , usually costs 32bits per pixel
         * @member {WebGLRenderbuffer}
         */ this.stencil = null;
        /**
         * latest known version of framebuffer
         * @member {number}
         * @protected
         */ this.dirtyId = -1;
        /**
         * latest known version of framebuffer format
         * @member {number}
         * @protected
         */ this.dirtyFormat = -1;
        /**
         * latest known version of framebuffer size
         * @member {number}
         * @protected
         */ this.dirtySize = -1;
        /**
         * Detected AA samples number
         * @member {PIXI.MSAA_QUALITY}
         */ this.multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
        /**
         * In case MSAA, we use this Renderbuffer instead of colorTextures[0] when we write info
         * @member {WebGLRenderbuffer}
         */ this.msaaBuffer = null;
        /**
         * In case we use MSAA, this is actual framebuffer that has colorTextures[0]
         * The contents of that framebuffer are read when we use that renderTexture in sprites
         * @member {PIXI.Framebuffer}
         */ this.blitFramebuffer = null;
        /**
         * store the current mipmap of the textures the framebuffer will write too.
         */ this.mipLevel = 0;
    }
    return GLFramebuffer;
}();
var tempRectangle = new (0, $6qzqq.Rectangle)();
/**
 * System plugin to the renderer to manage framebuffers.
 *
 * @class
 * @extends PIXI.System
 * @memberof PIXI
 */ var FramebufferSystem = /** @class */ function() {
    /**
     * @param {PIXI.Renderer} renderer - The renderer this System works for.
     */ function FramebufferSystem(renderer) {
        this.renderer = renderer;
        /**
         * A list of managed framebuffers
         * @member {PIXI.Framebuffer[]}
         * @readonly
         */ this.managedFramebuffers = [];
        /**
         * Framebuffer value that shows that we don't know what is bound
         * @member {Framebuffer}
         * @readonly
         */ this.unknownFramebuffer = new Framebuffer(10, 10);
        this.msaaSamples = null;
    }
    /**
     * Sets up the renderer context and necessary buffers.
     */ FramebufferSystem.prototype.contextChange = function() {
        var gl = this.gl = this.renderer.gl;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
        this.current = this.unknownFramebuffer;
        this.viewport = new (0, $6qzqq.Rectangle)();
        this.hasMRT = true;
        this.writeDepthTexture = true;
        this.disposeAll(true);
        // webgl2
        if (this.renderer.context.webGLVersion === 1) {
            // webgl 1!
            var nativeDrawBuffersExtension_1 = this.renderer.context.extensions.drawBuffers;
            var nativeDepthTextureExtension = this.renderer.context.extensions.depthTexture;
            if ((0, $ezJmd.settings).PREFER_ENV === (0, $P8XPi.ENV).WEBGL_LEGACY) {
                nativeDrawBuffersExtension_1 = null;
                nativeDepthTextureExtension = null;
            }
            if (nativeDrawBuffersExtension_1) gl.drawBuffers = function(activeTextures) {
                return nativeDrawBuffersExtension_1.drawBuffersWEBGL(activeTextures);
            };
            else {
                this.hasMRT = false;
                gl.drawBuffers = function() {
                // empty
                };
            }
            if (!nativeDepthTextureExtension) this.writeDepthTexture = false;
        } else // WebGL2
        // cache possible MSAA samples
        this.msaaSamples = gl.getInternalformatParameter(gl.RENDERBUFFER, gl.RGBA8, gl.SAMPLES);
    };
    /**
     * Bind a framebuffer
     *
     * @param {PIXI.Framebuffer} [framebuffer]
     * @param {PIXI.Rectangle} [frame] - frame, default is framebuffer size
     * @param {number} [mipLevel] - optional mip level to set on the framebuffer - defaults to 0
     */ FramebufferSystem.prototype.bind = function(framebuffer, frame, mipLevel) {
        if (mipLevel === void 0) mipLevel = 0;
        var gl = this.gl;
        if (framebuffer) {
            // TODO caching layer!
            var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID] || this.initFramebuffer(framebuffer);
            if (this.current !== framebuffer) {
                this.current = framebuffer;
                gl.bindFramebuffer(gl.FRAMEBUFFER, fbo.framebuffer);
            }
            // make sure all textures are unbound..
            if (fbo.mipLevel !== mipLevel) {
                framebuffer.dirtyId++;
                framebuffer.dirtyFormat++;
                fbo.mipLevel = mipLevel;
            }
            // now check for updates...
            if (fbo.dirtyId !== framebuffer.dirtyId) {
                fbo.dirtyId = framebuffer.dirtyId;
                if (fbo.dirtyFormat !== framebuffer.dirtyFormat) {
                    fbo.dirtyFormat = framebuffer.dirtyFormat;
                    fbo.dirtySize = framebuffer.dirtySize;
                    this.updateFramebuffer(framebuffer, mipLevel);
                } else if (fbo.dirtySize !== framebuffer.dirtySize) {
                    fbo.dirtySize = framebuffer.dirtySize;
                    this.resizeFramebuffer(framebuffer);
                }
            }
            for(var i = 0; i < framebuffer.colorTextures.length; i++){
                var tex = framebuffer.colorTextures[i];
                this.renderer.texture.unbind(tex.parentTextureArray || tex);
            }
            if (framebuffer.depthTexture) this.renderer.texture.unbind(framebuffer.depthTexture);
            if (frame) {
                var mipWidth = frame.width >> mipLevel;
                var mipHeight = frame.height >> mipLevel;
                var scale = mipWidth / frame.width;
                this.setViewport(frame.x * scale, frame.y * scale, mipWidth, mipHeight);
            } else {
                var mipWidth = framebuffer.width >> mipLevel;
                var mipHeight = framebuffer.height >> mipLevel;
                this.setViewport(0, 0, mipWidth, mipHeight);
            }
        } else {
            if (this.current) {
                this.current = null;
                gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            }
            if (frame) this.setViewport(frame.x, frame.y, frame.width, frame.height);
            else this.setViewport(0, 0, this.renderer.width, this.renderer.height);
        }
    };
    /**
     * Set the WebGLRenderingContext's viewport.
     *
     * @param {Number} x - X position of viewport
     * @param {Number} y - Y position of viewport
     * @param {Number} width - Width of viewport
     * @param {Number} height - Height of viewport
     */ FramebufferSystem.prototype.setViewport = function(x, y, width, height) {
        var v = this.viewport;
        x = Math.round(x);
        y = Math.round(y);
        width = Math.round(width);
        height = Math.round(height);
        if (v.width !== width || v.height !== height || v.x !== x || v.y !== y) {
            v.x = x;
            v.y = y;
            v.width = width;
            v.height = height;
            this.gl.viewport(x, y, width, height);
        }
    };
    Object.defineProperty(FramebufferSystem.prototype, "size", {
        /**
         * Get the size of the current width and height. Returns object with `width` and `height` values.
         *
         * @member {object}
         * @readonly
         */ get: function() {
            if (this.current) // TODO store temp
            return {
                x: 0,
                y: 0,
                width: this.current.width,
                height: this.current.height
            };
            return {
                x: 0,
                y: 0,
                width: this.renderer.width,
                height: this.renderer.height
            };
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clear the color of the context
     *
     * @param {Number} r - Red value from 0 to 1
     * @param {Number} g - Green value from 0 to 1
     * @param {Number} b - Blue value from 0 to 1
     * @param {Number} a - Alpha value from 0 to 1
     * @param {PIXI.BUFFER_BITS} [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
     *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
     */ FramebufferSystem.prototype.clear = function(r, g, b, a, mask) {
        if (mask === void 0) mask = (0, $P8XPi.BUFFER_BITS).COLOR | (0, $P8XPi.BUFFER_BITS).DEPTH;
        var gl = this.gl;
        // TODO clear color can be set only one right?
        gl.clearColor(r, g, b, a);
        gl.clear(mask);
    };
    /**
     * Initialize framebuffer for this context
     *
     * @protected
     * @param {PIXI.Framebuffer} framebuffer
     * @returns {PIXI.GLFramebuffer} created GLFramebuffer
     */ FramebufferSystem.prototype.initFramebuffer = function(framebuffer) {
        var gl = this.gl;
        var fbo = new GLFramebuffer(gl.createFramebuffer());
        fbo.multisample = this.detectSamples(framebuffer.multisample);
        framebuffer.glFramebuffers[this.CONTEXT_UID] = fbo;
        this.managedFramebuffers.push(framebuffer);
        framebuffer.disposeRunner.add(this);
        return fbo;
    };
    /**
     * Resize the framebuffer
     *
     * @protected
     * @param {PIXI.Framebuffer} framebuffer
     */ FramebufferSystem.prototype.resizeFramebuffer = function(framebuffer) {
        var gl = this.gl;
        var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        if (fbo.msaaBuffer) {
            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.msaaBuffer);
            gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.RGBA8, framebuffer.width, framebuffer.height);
        }
        if (fbo.stencil) {
            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil);
            if (fbo.msaaBuffer) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.DEPTH24_STENCIL8, framebuffer.width, framebuffer.height);
            else gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, framebuffer.width, framebuffer.height);
        }
        var colorTextures = framebuffer.colorTextures;
        var count = colorTextures.length;
        if (!gl.drawBuffers) count = Math.min(count, 1);
        for(var i = 0; i < count; i++){
            var texture = colorTextures[i];
            var parentTexture = texture.parentTextureArray || texture;
            this.renderer.texture.bind(parentTexture, 0);
        }
        if (framebuffer.depthTexture && this.writeDepthTexture) this.renderer.texture.bind(framebuffer.depthTexture, 0);
    };
    /**
     * Update the framebuffer
     *
     * @protected
     * @param {PIXI.Framebuffer} framebuffer
     * @param {number} mipLevel
     */ FramebufferSystem.prototype.updateFramebuffer = function(framebuffer, mipLevel) {
        var gl = this.gl;
        var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        // bind the color texture
        var colorTextures = framebuffer.colorTextures;
        var count = colorTextures.length;
        if (!gl.drawBuffers) count = Math.min(count, 1);
        if (fbo.multisample > 1 && this.canMultisampleFramebuffer(framebuffer)) {
            fbo.msaaBuffer = fbo.msaaBuffer || gl.createRenderbuffer();
            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.msaaBuffer);
            gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.RGBA8, framebuffer.width, framebuffer.height);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, fbo.msaaBuffer);
        } else if (fbo.msaaBuffer) {
            gl.deleteRenderbuffer(fbo.msaaBuffer);
            fbo.msaaBuffer = null;
            if (fbo.blitFramebuffer) {
                fbo.blitFramebuffer.dispose();
                fbo.blitFramebuffer = null;
            }
        }
        var activeTextures = [];
        for(var i = 0; i < count; i++){
            var texture = colorTextures[i];
            var parentTexture = texture.parentTextureArray || texture;
            this.renderer.texture.bind(parentTexture, 0);
            if (i === 0 && fbo.msaaBuffer) continue;
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, texture.target, parentTexture._glTextures[this.CONTEXT_UID].texture, mipLevel);
            activeTextures.push(gl.COLOR_ATTACHMENT0 + i);
        }
        if (activeTextures.length > 1) gl.drawBuffers(activeTextures);
        if (framebuffer.depthTexture) {
            var writeDepthTexture = this.writeDepthTexture;
            if (writeDepthTexture) {
                var depthTexture = framebuffer.depthTexture;
                this.renderer.texture.bind(depthTexture, 0);
                gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.TEXTURE_2D, depthTexture._glTextures[this.CONTEXT_UID].texture, mipLevel);
            }
        }
        if ((framebuffer.stencil || framebuffer.depth) && !(framebuffer.depthTexture && this.writeDepthTexture)) {
            fbo.stencil = fbo.stencil || gl.createRenderbuffer();
            gl.bindRenderbuffer(gl.RENDERBUFFER, fbo.stencil);
            if (fbo.msaaBuffer) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.DEPTH24_STENCIL8, framebuffer.width, framebuffer.height);
            else gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, framebuffer.width, framebuffer.height);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, fbo.stencil);
        } else if (fbo.stencil) {
            gl.deleteRenderbuffer(fbo.stencil);
            fbo.stencil = null;
        }
    };
    /**
     * Returns true if the frame buffer can be multisampled
     *
     * @protected
     * @param {PIXI.Framebuffer} framebuffer
     */ FramebufferSystem.prototype.canMultisampleFramebuffer = function(framebuffer) {
        return this.renderer.context.webGLVersion !== 1 && framebuffer.colorTextures.length <= 1 && !framebuffer.depthTexture;
    };
    /**
     * Detects number of samples that is not more than a param but as close to it as possible
     *
     * @param {PIXI.MSAA_QUALITY} samples - number of samples
     * @returns {PIXI.MSAA_QUALITY} - recommended number of samples
     */ FramebufferSystem.prototype.detectSamples = function(samples) {
        var msaaSamples = this.msaaSamples;
        var res = (0, $P8XPi.MSAA_QUALITY).NONE;
        if (samples <= 1 || msaaSamples === null) return res;
        for(var i = 0; i < msaaSamples.length; i++)if (msaaSamples[i] <= samples) {
            res = msaaSamples[i];
            break;
        }
        if (res === 1) res = (0, $P8XPi.MSAA_QUALITY).NONE;
        return res;
    };
    /**
     * Only works with WebGL2
     *
     * blits framebuffer to another of the same or bigger size
     * after that target framebuffer is bound
     *
     * Fails with WebGL warning if blits multisample framebuffer to different size
     *
     * @param {PIXI.Framebuffer} [framebuffer] - by default it blits "into itself", from renderBuffer to texture.
     * @param {PIXI.Rectangle} [sourcePixels] - source rectangle in pixels
     * @param {PIXI.Rectangle} [destPixels] - dest rectangle in pixels, assumed to be the same as sourcePixels
     */ FramebufferSystem.prototype.blit = function(framebuffer, sourcePixels, destPixels) {
        var _a = this, current = _a.current, renderer = _a.renderer, gl = _a.gl, CONTEXT_UID = _a.CONTEXT_UID;
        if (renderer.context.webGLVersion !== 2) return;
        if (!current) return;
        var fbo = current.glFramebuffers[CONTEXT_UID];
        if (!fbo) return;
        if (!framebuffer) {
            if (!fbo.msaaBuffer) return;
            var colorTexture = current.colorTextures[0];
            if (!colorTexture) return;
            if (!fbo.blitFramebuffer) {
                fbo.blitFramebuffer = new Framebuffer(current.width, current.height);
                fbo.blitFramebuffer.addColorTexture(0, colorTexture);
            }
            framebuffer = fbo.blitFramebuffer;
            if (framebuffer.colorTextures[0] !== colorTexture) {
                framebuffer.colorTextures[0] = colorTexture;
                framebuffer.dirtyId++;
                framebuffer.dirtyFormat++;
            }
            if (framebuffer.width !== current.width || framebuffer.height !== current.height) {
                framebuffer.width = current.width;
                framebuffer.height = current.height;
                framebuffer.dirtyId++;
                framebuffer.dirtySize++;
            }
        }
        if (!sourcePixels) {
            sourcePixels = tempRectangle;
            sourcePixels.width = current.width;
            sourcePixels.height = current.height;
        }
        if (!destPixels) destPixels = sourcePixels;
        var sameSize = sourcePixels.width === destPixels.width && sourcePixels.height === destPixels.height;
        this.bind(framebuffer);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, fbo.framebuffer);
        gl.blitFramebuffer(sourcePixels.x, sourcePixels.y, sourcePixels.width, sourcePixels.height, destPixels.x, destPixels.y, destPixels.width, destPixels.height, gl.COLOR_BUFFER_BIT, sameSize ? gl.NEAREST : gl.LINEAR);
    };
    /**
     * Disposes framebuffer
     * @param {PIXI.Framebuffer} framebuffer - framebuffer that has to be disposed of
     * @param {boolean} [contextLost=false] - If context was lost, we suppress all delete function calls
     */ FramebufferSystem.prototype.disposeFramebuffer = function(framebuffer, contextLost) {
        var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        var gl = this.gl;
        if (!fbo) return;
        delete framebuffer.glFramebuffers[this.CONTEXT_UID];
        var index = this.managedFramebuffers.indexOf(framebuffer);
        if (index >= 0) this.managedFramebuffers.splice(index, 1);
        framebuffer.disposeRunner.remove(this);
        if (!contextLost) {
            gl.deleteFramebuffer(fbo.framebuffer);
            if (fbo.msaaBuffer) gl.deleteRenderbuffer(fbo.msaaBuffer);
            if (fbo.stencil) gl.deleteRenderbuffer(fbo.stencil);
        }
        if (fbo.blitFramebuffer) fbo.blitFramebuffer.dispose();
    };
    /**
     * Disposes all framebuffers, but not textures bound to them
     * @param {boolean} [contextLost=false] - If context was lost, we suppress all delete function calls
     */ FramebufferSystem.prototype.disposeAll = function(contextLost) {
        var list = this.managedFramebuffers;
        this.managedFramebuffers = [];
        for(var i = 0; i < list.length; i++)this.disposeFramebuffer(list[i], contextLost);
    };
    /**
     * Forcing creation of stencil buffer for current framebuffer, if it wasn't done before.
     * Used by MaskSystem, when its time to use stencil mask for Graphics element.
     *
     * Its an alternative for public lazy `framebuffer.enableStencil`, in case we need stencil without rebind.
     *
     * @private
     */ FramebufferSystem.prototype.forceStencil = function() {
        var framebuffer = this.current;
        if (!framebuffer) return;
        var fbo = framebuffer.glFramebuffers[this.CONTEXT_UID];
        if (!fbo || fbo.stencil) return;
        framebuffer.stencil = true;
        var w = framebuffer.width;
        var h = framebuffer.height;
        var gl = this.gl;
        var stencil = gl.createRenderbuffer();
        gl.bindRenderbuffer(gl.RENDERBUFFER, stencil);
        if (fbo.msaaBuffer) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, fbo.multisample, gl.DEPTH24_STENCIL8, w, h);
        else gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, w, h);
        fbo.stencil = stencil;
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, stencil);
    };
    /**
     * resets framebuffer stored state, binds screen framebuffer
     *
     * should be called before renderTexture reset()
     */ FramebufferSystem.prototype.reset = function() {
        this.current = this.unknownFramebuffer;
        this.viewport = new (0, $6qzqq.Rectangle)();
    };
    /**
     * @ignore
     */ FramebufferSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return FramebufferSystem;
}();
var byteSizeMap$1 = {
    5126: 4,
    5123: 2,
    5121: 1
};
/**
 * System plugin to the renderer to manage geometry.
 *
 * @memberof PIXI
 */ var GeometrySystem = /** @class */ function() {
    /** @param renderer - The renderer this System works for. */ function GeometrySystem(renderer) {
        this.renderer = renderer;
        this._activeGeometry = null;
        this._activeVao = null;
        this.hasVao = true;
        this.hasInstance = true;
        this.canUseUInt32ElementIndex = false;
        this.managedGeometries = {};
    }
    /** Sets up the renderer context and necessary buffers. */ GeometrySystem.prototype.contextChange = function() {
        this.disposeAll(true);
        var gl = this.gl = this.renderer.gl;
        var context = this.renderer.context;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
        // webgl2
        if (context.webGLVersion !== 2) {
            // webgl 1!
            var nativeVaoExtension_1 = this.renderer.context.extensions.vertexArrayObject;
            if ((0, $ezJmd.settings).PREFER_ENV === (0, $P8XPi.ENV).WEBGL_LEGACY) nativeVaoExtension_1 = null;
            if (nativeVaoExtension_1) {
                gl.createVertexArray = function() {
                    return nativeVaoExtension_1.createVertexArrayOES();
                };
                gl.bindVertexArray = function(vao) {
                    return nativeVaoExtension_1.bindVertexArrayOES(vao);
                };
                gl.deleteVertexArray = function(vao) {
                    return nativeVaoExtension_1.deleteVertexArrayOES(vao);
                };
            } else {
                this.hasVao = false;
                gl.createVertexArray = function() {
                    return null;
                };
                gl.bindVertexArray = function() {
                    return null;
                };
                gl.deleteVertexArray = function() {
                    return null;
                };
            }
        }
        if (context.webGLVersion !== 2) {
            var instanceExt_1 = gl.getExtension('ANGLE_instanced_arrays');
            if (instanceExt_1) {
                gl.vertexAttribDivisor = function(a, b) {
                    return instanceExt_1.vertexAttribDivisorANGLE(a, b);
                };
                gl.drawElementsInstanced = function(a, b, c, d, e) {
                    return instanceExt_1.drawElementsInstancedANGLE(a, b, c, d, e);
                };
                gl.drawArraysInstanced = function(a, b, c, d) {
                    return instanceExt_1.drawArraysInstancedANGLE(a, b, c, d);
                };
            } else this.hasInstance = false;
        }
        this.canUseUInt32ElementIndex = context.webGLVersion === 2 || !!context.extensions.uint32ElementIndex;
    };
    /**
     * Binds geometry so that is can be drawn. Creating a Vao if required
     *
     * @param geometry - Instance of geometry to bind.
     * @param shader - Instance of shader to use vao for.
     */ GeometrySystem.prototype.bind = function(geometry, shader) {
        shader = shader || this.renderer.shader.shader;
        var gl = this.gl;
        // not sure the best way to address this..
        // currently different shaders require different VAOs for the same geometry
        // Still mulling over the best way to solve this one..
        // will likely need to modify the shader attribute locations at run time!
        var vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID];
        var incRefCount = false;
        if (!vaos) {
            this.managedGeometries[geometry.id] = geometry;
            geometry.disposeRunner.add(this);
            geometry.glVertexArrayObjects[this.CONTEXT_UID] = vaos = {};
            incRefCount = true;
        }
        var vao = vaos[shader.program.id] || this.initGeometryVao(geometry, shader, incRefCount);
        this._activeGeometry = geometry;
        if (this._activeVao !== vao) {
            this._activeVao = vao;
            if (this.hasVao) gl.bindVertexArray(vao);
            else this.activateVao(geometry, shader.program);
        }
        // TODO - optimise later!
        // don't need to loop through if nothing changed!
        // maybe look to add an 'autoupdate' to geometry?
        this.updateBuffers();
    };
    /** Reset and unbind any active VAO and geometry. */ GeometrySystem.prototype.reset = function() {
        this.unbind();
    };
    /** Update buffers of the currently bound geometry. */ GeometrySystem.prototype.updateBuffers = function() {
        var geometry = this._activeGeometry;
        var bufferSystem = this.renderer.buffer;
        for(var i = 0; i < geometry.buffers.length; i++){
            var buffer = geometry.buffers[i];
            bufferSystem.update(buffer);
        }
    };
    /**
     * Check compatibility between a geometry and a program
     *
     * @param geometry - Geometry instance.
     * @param program - Program instance.
     */ GeometrySystem.prototype.checkCompatibility = function(geometry, program) {
        // geometry must have at least all the attributes that the shader requires.
        var geometryAttributes = geometry.attributes;
        var shaderAttributes = program.attributeData;
        for(var j in shaderAttributes){
            if (!geometryAttributes[j]) throw new Error("shader and geometry incompatible, geometry missing the \"" + j + "\" attribute");
        }
    };
    /**
     * Takes a geometry and program and generates a unique signature for them.
     *
     * @param geometry - To get signature from.
     * @param program - To test geometry against.
     * @return - Unique signature of the geometry and program
     */ GeometrySystem.prototype.getSignature = function(geometry, program) {
        var attribs = geometry.attributes;
        var shaderAttributes = program.attributeData;
        var strings = [
            'g',
            geometry.id
        ];
        for(var i in attribs)if (shaderAttributes[i]) strings.push(i, shaderAttributes[i].location);
        return strings.join('-');
    };
    /**
     * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
     * If vao is created, it is bound automatically. We use a shader to infer what and how to set up the
     * attribute locations.
     *
     * @param geometry - Instance of geometry to to generate Vao for.
     * @param shader - Instance of the shader.
     * @param incRefCount - Increment refCount of all geometry buffers.
     */ GeometrySystem.prototype.initGeometryVao = function(geometry, shader, incRefCount) {
        if (incRefCount === void 0) incRefCount = true;
        var gl = this.gl;
        var CONTEXT_UID = this.CONTEXT_UID;
        var bufferSystem = this.renderer.buffer;
        var program = shader.program;
        if (!program.glPrograms[CONTEXT_UID]) this.renderer.shader.generateProgram(shader);
        this.checkCompatibility(geometry, program);
        var signature = this.getSignature(geometry, program);
        var vaoObjectHash = geometry.glVertexArrayObjects[this.CONTEXT_UID];
        var vao = vaoObjectHash[signature];
        if (vao) {
            // this will give us easy access to the vao
            vaoObjectHash[program.id] = vao;
            return vao;
        }
        var buffers = geometry.buffers;
        var attributes = geometry.attributes;
        var tempStride = {};
        var tempStart = {};
        for(var j in buffers){
            tempStride[j] = 0;
            tempStart[j] = 0;
        }
        for(var j in attributes){
            if (!attributes[j].size && program.attributeData[j]) attributes[j].size = program.attributeData[j].size;
            else if (!attributes[j].size) console.warn("PIXI Geometry attribute '" + j + "' size cannot be determined (likely the bound shader does not have the attribute)"); // eslint-disable-line
            tempStride[attributes[j].buffer] += attributes[j].size * byteSizeMap$1[attributes[j].type];
        }
        for(var j in attributes){
            var attribute = attributes[j];
            var attribSize = attribute.size;
            if (attribute.stride === undefined) {
                if (tempStride[attribute.buffer] === attribSize * byteSizeMap$1[attribute.type]) attribute.stride = 0;
                else attribute.stride = tempStride[attribute.buffer];
            }
            if (attribute.start === undefined) {
                attribute.start = tempStart[attribute.buffer];
                tempStart[attribute.buffer] += attribSize * byteSizeMap$1[attribute.type];
            }
        }
        vao = gl.createVertexArray();
        gl.bindVertexArray(vao);
        // first update - and create the buffers!
        // only create a gl buffer if it actually gets
        for(var i = 0; i < buffers.length; i++){
            var buffer = buffers[i];
            bufferSystem.bind(buffer);
            if (incRefCount) buffer._glBuffers[CONTEXT_UID].refCount++;
        }
        // TODO - maybe make this a data object?
        // lets wait to see if we need to first!
        this.activateVao(geometry, program);
        this._activeVao = vao;
        // add it to the cache!
        vaoObjectHash[program.id] = vao;
        vaoObjectHash[signature] = vao;
        return vao;
    };
    /**
     * Disposes geometry.
     *
     * @param geometry - Geometry with buffers. Only VAO will be disposed
     * @param [contextLost=false] - If context was lost, we suppress deleteVertexArray
     */ GeometrySystem.prototype.disposeGeometry = function(geometry, contextLost) {
        var _a;
        if (!this.managedGeometries[geometry.id]) return;
        delete this.managedGeometries[geometry.id];
        var vaos = geometry.glVertexArrayObjects[this.CONTEXT_UID];
        var gl = this.gl;
        var buffers = geometry.buffers;
        var bufferSystem = (_a = this.renderer) === null || _a === void 0 ? void 0 : _a.buffer;
        geometry.disposeRunner.remove(this);
        if (!vaos) return;
        // bufferSystem may have already been destroyed..
        // if this is the case, there is no need to destroy the geometry buffers...
        // they already have been!
        if (bufferSystem) for(var i = 0; i < buffers.length; i++){
            var buf = buffers[i]._glBuffers[this.CONTEXT_UID];
            // my be null as context may have changed right before the dispose is called
            if (buf) {
                buf.refCount--;
                if (buf.refCount === 0 && !contextLost) bufferSystem.dispose(buffers[i], contextLost);
            }
        }
        if (!contextLost) {
            for(var vaoId in vaos)// delete only signatures, everything else are copies
            if (vaoId[0] === 'g') {
                var vao = vaos[vaoId];
                if (this._activeVao === vao) this.unbind();
                gl.deleteVertexArray(vao);
            }
        }
        delete geometry.glVertexArrayObjects[this.CONTEXT_UID];
    };
    /**
     * Dispose all WebGL resources of all managed geometries.
     *
     * @param [contextLost=false] - If context was lost, we suppress `gl.delete` calls
     */ GeometrySystem.prototype.disposeAll = function(contextLost) {
        var all = Object.keys(this.managedGeometries);
        for(var i = 0; i < all.length; i++)this.disposeGeometry(this.managedGeometries[all[i]], contextLost);
    };
    /**
     * Activate vertex array object.
     *
     * @param geometry - Geometry instance.
     * @param program - Shader program instance.
     */ GeometrySystem.prototype.activateVao = function(geometry, program) {
        var gl = this.gl;
        var CONTEXT_UID = this.CONTEXT_UID;
        var bufferSystem = this.renderer.buffer;
        var buffers = geometry.buffers;
        var attributes = geometry.attributes;
        if (geometry.indexBuffer) // first update the index buffer if we have one..
        bufferSystem.bind(geometry.indexBuffer);
        var lastBuffer = null;
        // add a new one!
        for(var j in attributes){
            var attribute = attributes[j];
            var buffer = buffers[attribute.buffer];
            var glBuffer = buffer._glBuffers[CONTEXT_UID];
            if (program.attributeData[j]) {
                if (lastBuffer !== glBuffer) {
                    bufferSystem.bind(buffer);
                    lastBuffer = glBuffer;
                }
                var location = program.attributeData[j].location;
                // TODO introduce state again
                // we can optimise this for older devices that have no VAOs
                gl.enableVertexAttribArray(location);
                gl.vertexAttribPointer(location, attribute.size, attribute.type || gl.FLOAT, attribute.normalized, attribute.stride, attribute.start);
                if (attribute.instance) {
                    // TODO calculate instance count based of this...
                    if (this.hasInstance) gl.vertexAttribDivisor(location, 1);
                    else throw new Error('geometry error, GPU Instancing is not supported on this device');
                }
            }
        }
    };
    /**
     * Draws the currently bound geometry.
     *
     * @param type - The type primitive to render.
     * @param size - The number of elements to be rendered. If not specified, all vertices after the
     *  starting vertex will be drawn.
     * @param start - The starting vertex in the geometry to start drawing from. If not specified,
     *  drawing will start from the first vertex.
     * @param instanceCount - The number of instances of the set of elements to execute. If not specified,
     *  all instances will be drawn.
     */ GeometrySystem.prototype.draw = function(type, size, start, instanceCount) {
        var gl = this.gl;
        var geometry = this._activeGeometry;
        // TODO.. this should not change so maybe cache the function?
        if (geometry.indexBuffer) {
            var byteSize = geometry.indexBuffer.data.BYTES_PER_ELEMENT;
            var glType = byteSize === 2 ? gl.UNSIGNED_SHORT : gl.UNSIGNED_INT;
            if (byteSize === 2 || byteSize === 4 && this.canUseUInt32ElementIndex) {
                if (geometry.instanced) /* eslint-disable max-len */ gl.drawElementsInstanced(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize, instanceCount || 1);
                else /* eslint-disable max-len */ gl.drawElements(type, size || geometry.indexBuffer.data.length, glType, (start || 0) * byteSize);
            } else console.warn('unsupported index buffer type: uint32');
        } else if (geometry.instanced) // TODO need a better way to calculate size..
        gl.drawArraysInstanced(type, start, size || geometry.getSize(), instanceCount || 1);
        else gl.drawArrays(type, start, size || geometry.getSize());
        return this;
    };
    /** Unbind/reset everything. */ GeometrySystem.prototype.unbind = function() {
        this.gl.bindVertexArray(null);
        this._activeVao = null;
        this._activeGeometry = null;
    };
    GeometrySystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return GeometrySystem;
}();
/**
 * Component for masked elements.
 *
 * Holds mask mode and temporary data about current mask.
 *
 * @memberof PIXI
 */ var MaskData = /** @class */ function() {
    /**
     * Create MaskData
     *
     * @param {PIXI.DisplayObject} [maskObject=null] - object that describes the mask
     */ function MaskData(maskObject) {
        if (maskObject === void 0) maskObject = null;
        this.type = (0, $P8XPi.MASK_TYPES).NONE;
        this.autoDetect = true;
        this.maskObject = maskObject || null;
        this.pooled = false;
        this.isMaskData = true;
        this.resolution = null;
        this.multisample = (0, $ezJmd.settings).FILTER_MULTISAMPLE;
        this.enabled = true;
        this._filters = null;
        this._stencilCounter = 0;
        this._scissorCounter = 0;
        this._scissorRect = null;
        this._scissorRectLocal = null;
        this._target = null;
    }
    Object.defineProperty(MaskData.prototype, "filter", {
        /**
         * The sprite mask filter.
         * If set to `null`, the default sprite mask filter is used.
         * @default null
         */ get: function() {
            return this._filters ? this._filters[0] : null;
        },
        set: function(value) {
            if (value) {
                if (this._filters) this._filters[0] = value;
                else this._filters = [
                    value
                ];
            } else this._filters = null;
        },
        enumerable: false,
        configurable: true
    });
    /** Resets the mask data after popMask(). */ MaskData.prototype.reset = function() {
        if (this.pooled) {
            this.maskObject = null;
            this.type = (0, $P8XPi.MASK_TYPES).NONE;
            this.autoDetect = true;
        }
        this._target = null;
        this._scissorRectLocal = null;
    };
    /** Copies counters from maskData above, called from pushMask(). */ MaskData.prototype.copyCountersOrReset = function(maskAbove) {
        if (maskAbove) {
            this._stencilCounter = maskAbove._stencilCounter;
            this._scissorCounter = maskAbove._scissorCounter;
            this._scissorRect = maskAbove._scissorRect;
        } else {
            this._stencilCounter = 0;
            this._scissorCounter = 0;
            this._scissorRect = null;
        }
    };
    return MaskData;
}();
/**
 * @private
 * @param {WebGLRenderingContext} gl - The current WebGL context {WebGLProgram}
 * @param {Number} type - the type, can be either VERTEX_SHADER or FRAGMENT_SHADER
 * @param {string} src - The vertex shader source as an array of strings.
 * @return {WebGLShader} the shader
 */ function compileShader(gl, type, src) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, src);
    gl.compileShader(shader);
    return shader;
}
/**
 * will log a shader error highlighting the lines with the error
 * also will add numbers along the side.
 *
 * @param gl - the WebGLContext
 * @param shader - the shader to log errors for
 */ function logPrettyShaderError(gl, shader) {
    var shaderSrc = gl.getShaderSource(shader).split('\n').map(function(line, index) {
        return index + ": " + line;
    });
    var shaderLog = gl.getShaderInfoLog(shader);
    var splitShader = shaderLog.split('\n');
    var dedupe = {};
    var lineNumbers = splitShader.map(function(line) {
        return parseFloat(line.replace(/^ERROR\: 0\:([\d]+)\:.*$/, '$1'));
    }).filter(function(n) {
        if (n && !dedupe[n]) {
            dedupe[n] = true;
            return true;
        }
        return false;
    });
    var logArgs = [
        ''
    ];
    lineNumbers.forEach(function(number) {
        shaderSrc[number - 1] = "%c" + shaderSrc[number - 1] + "%c";
        logArgs.push('background: #FF0000; color:#FFFFFF; font-size: 10px', 'font-size: 10px');
    });
    var fragmentSourceToLog = shaderSrc.join('\n');
    logArgs[0] = fragmentSourceToLog;
    console.error(shaderLog);
    // eslint-disable-next-line no-console
    console.groupCollapsed('click to view full shader code');
    console.warn.apply(console, logArgs);
    // eslint-disable-next-line no-console
    console.groupEnd();
}
/**
 *
 * logs out any program errors
 *
 * @param gl - The current WebGL context
 * @param program - the WebGL program to display errors for
 * @param vertexShader  - the fragment WebGL shader program
 * @param fragmentShader - the vertex WebGL shader program
 */ function logProgramError(gl, program, vertexShader, fragmentShader) {
    // if linking fails, then log and cleanup
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) logPrettyShaderError(gl, vertexShader);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) logPrettyShaderError(gl, fragmentShader);
        console.error('PixiJS Error: Could not initialize shader.');
        // if there is a program info log, log it
        if (gl.getProgramInfoLog(program) !== '') console.warn('PixiJS Warning: gl.getProgramInfoLog()', gl.getProgramInfoLog(program));
    }
}
function booleanArray(size) {
    var array = new Array(size);
    for(var i = 0; i < array.length; i++)array[i] = false;
    return array;
}
/**
 * @method defaultValue
 * @memberof PIXI.glCore.shader
 * @param {string} type - Type of value
 * @param {number} size
 * @private
 */ function defaultValue(type, size) {
    switch(type){
        case 'float':
            return 0;
        case 'vec2':
            return new Float32Array(2 * size);
        case 'vec3':
            return new Float32Array(3 * size);
        case 'vec4':
            return new Float32Array(4 * size);
        case 'int':
        case 'uint':
        case 'sampler2D':
        case 'sampler2DArray':
            return 0;
        case 'ivec2':
            return new Int32Array(2 * size);
        case 'ivec3':
            return new Int32Array(3 * size);
        case 'ivec4':
            return new Int32Array(4 * size);
        case 'uvec2':
            return new Uint32Array(2 * size);
        case 'uvec3':
            return new Uint32Array(3 * size);
        case 'uvec4':
            return new Uint32Array(4 * size);
        case 'bool':
            return false;
        case 'bvec2':
            return booleanArray(2 * size);
        case 'bvec3':
            return booleanArray(3 * size);
        case 'bvec4':
            return booleanArray(4 * size);
        case 'mat2':
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case 'mat3':
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case 'mat4':
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}
var unknownContext = {};
var context = unknownContext;
/**
 * returns a little WebGL context to use for program inspection.
 *
 * @static
 * @private
 * @returns {WebGLRenderingContext} a gl context to test with
 */ function getTestContext() {
    if (context === unknownContext || context && context.isContextLost()) {
        var canvas = document.createElement('canvas');
        var gl = void 0;
        if ((0, $ezJmd.settings).PREFER_ENV >= (0, $P8XPi.ENV).WEBGL2) gl = canvas.getContext('webgl2', {});
        if (!gl) {
            gl = canvas.getContext('webgl', {}) || canvas.getContext('experimental-webgl', {});
            if (!gl) // fail, not able to get a context
            gl = null;
            else // for shader testing..
            gl.getExtension('WEBGL_draw_buffers');
        }
        context = gl;
    }
    return context;
}
var maxFragmentPrecision;
function getMaxFragmentPrecision() {
    if (!maxFragmentPrecision) {
        maxFragmentPrecision = (0, $P8XPi.PRECISION).MEDIUM;
        var gl = getTestContext();
        if (gl) {
            if (gl.getShaderPrecisionFormat) {
                var shaderFragment = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
                maxFragmentPrecision = shaderFragment.precision ? (0, $P8XPi.PRECISION).HIGH : (0, $P8XPi.PRECISION).MEDIUM;
            }
        }
    }
    return maxFragmentPrecision;
}
/**
 * Sets the float precision on the shader, ensuring the device supports the request precision.
 * If the precision is already present, it just ensures that the device is able to handle it.
 *
 * @private
 * @param {string} src - The shader source
 * @param {PIXI.PRECISION} requestedPrecision - The request float precision of the shader.
 * @param {PIXI.PRECISION} maxSupportedPrecision - The maximum precision the shader supports.
 *
 * @return {string} modified shader source
 */ function setPrecision(src, requestedPrecision, maxSupportedPrecision) {
    if (src.substring(0, 9) !== 'precision') {
        // no precision supplied, so PixiJS will add the requested level.
        var precision = requestedPrecision;
        // If highp is requested but not supported, downgrade precision to a level all devices support.
        if (requestedPrecision === (0, $P8XPi.PRECISION).HIGH && maxSupportedPrecision !== (0, $P8XPi.PRECISION).HIGH) precision = (0, $P8XPi.PRECISION).MEDIUM;
        return "precision " + precision + " float;\n" + src;
    } else if (maxSupportedPrecision !== (0, $P8XPi.PRECISION).HIGH && src.substring(0, 15) === 'precision highp') // precision was supplied, but at a level this device does not support, so downgrading to mediump.
    return src.replace('precision highp', 'precision mediump');
    return src;
}
var GLSL_TO_SIZE = {
    float: 1,
    vec2: 2,
    vec3: 3,
    vec4: 4,
    int: 1,
    ivec2: 2,
    ivec3: 3,
    ivec4: 4,
    uint: 1,
    uvec2: 2,
    uvec3: 3,
    uvec4: 4,
    bool: 1,
    bvec2: 2,
    bvec3: 3,
    bvec4: 4,
    mat2: 4,
    mat3: 9,
    mat4: 16,
    sampler2D: 1
};
/**
 * @private
 * @method mapSize
 * @memberof PIXI.glCore.shader
 * @param {String} type
 * @return {Number}
 */ function mapSize(type) {
    return GLSL_TO_SIZE[type];
}
var GL_TABLE = null;
var GL_TO_GLSL_TYPES = {
    FLOAT: 'float',
    FLOAT_VEC2: 'vec2',
    FLOAT_VEC3: 'vec3',
    FLOAT_VEC4: 'vec4',
    INT: 'int',
    INT_VEC2: 'ivec2',
    INT_VEC3: 'ivec3',
    INT_VEC4: 'ivec4',
    UNSIGNED_INT: 'uint',
    UNSIGNED_INT_VEC2: 'uvec2',
    UNSIGNED_INT_VEC3: 'uvec3',
    UNSIGNED_INT_VEC4: 'uvec4',
    BOOL: 'bool',
    BOOL_VEC2: 'bvec2',
    BOOL_VEC3: 'bvec3',
    BOOL_VEC4: 'bvec4',
    FLOAT_MAT2: 'mat2',
    FLOAT_MAT3: 'mat3',
    FLOAT_MAT4: 'mat4',
    SAMPLER_2D: 'sampler2D',
    INT_SAMPLER_2D: 'sampler2D',
    UNSIGNED_INT_SAMPLER_2D: 'sampler2D',
    SAMPLER_CUBE: 'samplerCube',
    INT_SAMPLER_CUBE: 'samplerCube',
    UNSIGNED_INT_SAMPLER_CUBE: 'samplerCube',
    SAMPLER_2D_ARRAY: 'sampler2DArray',
    INT_SAMPLER_2D_ARRAY: 'sampler2DArray',
    UNSIGNED_INT_SAMPLER_2D_ARRAY: 'sampler2DArray'
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function mapType(gl, type) {
    if (!GL_TABLE) {
        var typeNames = Object.keys(GL_TO_GLSL_TYPES);
        GL_TABLE = {};
        for(var i = 0; i < typeNames.length; ++i){
            var tn = typeNames[i];
            GL_TABLE[gl[tn]] = GL_TO_GLSL_TYPES[tn];
        }
    }
    return GL_TABLE[type];
}
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // Parsers, each one of these will take a look at the type of shader property and uniform.
// if they pass the test function then the code function is called that returns a the shader upload code for that uniform.
// Shader upload code is automagically generated with these parsers.
// If no parser is valid then the default upload functions are used.
// exposing Parsers means that custom upload logic can be added to pixi's shaders.
// A good example would be a pixi rectangle can be directly set on a uniform.
// If the shader sees it it knows how to upload the rectangle structure as a vec4
// format is as follows:
//
// {
//     test: (data, uniform) => {} <--- test is this code should be used for this uniform
//     code: (name, uniform) => {} <--- returns the string of the piece of code that uploads the uniform
//     codeUbo: (name, uniform) => {} <--- returns the string of the piece of code that uploads the
//                                         uniform to a uniform buffer
// }
var uniformParsers = [
    // a float cache layer
    {
        test: function(data) {
            return data.type === 'float' && data.size === 1;
        },
        code: function(name) {
            return "\n            if(uv[\"" + name + "\"] !== ud[\"" + name + "\"].value)\n            {\n                ud[\"" + name + "\"].value = uv[\"" + name + "\"]\n                gl.uniform1f(ud[\"" + name + "\"].location, uv[\"" + name + "\"])\n            }\n            ";
        }
    },
    // handling samplers
    {
        test: function(data) {
            // eslint-disable-next-line max-len
            return (data.type === 'sampler2D' || data.type === 'samplerCube' || data.type === 'sampler2DArray') && data.size === 1 && !data.isArray;
        },
        code: function(name) {
            return "t = syncData.textureCount++;\n\n            renderer.texture.bind(uv[\"" + name + "\"], t);\n\n            if(ud[\"" + name + "\"].value !== t)\n            {\n                ud[\"" + name + "\"].value = t;\n                gl.uniform1i(ud[\"" + name + "\"].location, t);\n; // eslint-disable-line max-len\n            }";
        }
    },
    // uploading pixi matrix object to mat3
    {
        test: function(data, uniform) {
            return data.type === 'mat3' && data.size === 1 && uniform.a !== undefined;
        },
        code: function(name) {
            // TODO and some smart caching dirty ids here!
            return "\n            gl.uniformMatrix3fv(ud[\"" + name + "\"].location, false, uv[\"" + name + "\"].toArray(true));\n            ";
        },
        codeUbo: function(name) {
            return "\n                var " + name + "_matrix = uv." + name + ".toArray(true);\n\n                data[offset] = " + name + "_matrix[0];\n                data[offset+1] = " + name + "_matrix[1];\n                data[offset+2] = " + name + "_matrix[2];\n        \n                data[offset + 4] = " + name + "_matrix[3];\n                data[offset + 5] = " + name + "_matrix[4];\n                data[offset + 6] = " + name + "_matrix[5];\n        \n                data[offset + 8] = " + name + "_matrix[6];\n                data[offset + 9] = " + name + "_matrix[7];\n                data[offset + 10] = " + name + "_matrix[8];\n            ";
        }
    },
    // uploading a pixi point as a vec2 with caching layer
    {
        test: function(data, uniform) {
            return data.type === 'vec2' && data.size === 1 && uniform.x !== undefined;
        },
        code: function(name) {
            return "\n                cv = ud[\"" + name + "\"].value;\n                v = uv[\"" + name + "\"];\n\n                if(cv[0] !== v.x || cv[1] !== v.y)\n                {\n                    cv[0] = v.x;\n                    cv[1] = v.y;\n                    gl.uniform2f(ud[\"" + name + "\"].location, v.x, v.y);\n                }";
        },
        codeUbo: function(name) {
            return "\n                v = uv." + name + ";\n\n                data[offset] = v.x;\n                data[offset+1] = v.y;\n            ";
        }
    },
    // caching layer for a vec2
    {
        test: function(data) {
            return data.type === 'vec2' && data.size === 1;
        },
        code: function(name) {
            return "\n                cv = ud[\"" + name + "\"].value;\n                v = uv[\"" + name + "\"];\n\n                if(cv[0] !== v[0] || cv[1] !== v[1])\n                {\n                    cv[0] = v[0];\n                    cv[1] = v[1];\n                    gl.uniform2f(ud[\"" + name + "\"].location, v[0], v[1]);\n                }\n            ";
        }
    },
    // upload a pixi rectangle as a vec4 with caching layer
    {
        test: function(data, uniform) {
            return data.type === 'vec4' && data.size === 1 && uniform.width !== undefined;
        },
        code: function(name) {
            return "\n                cv = ud[\"" + name + "\"].value;\n                v = uv[\"" + name + "\"];\n\n                if(cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height)\n                {\n                    cv[0] = v.x;\n                    cv[1] = v.y;\n                    cv[2] = v.width;\n                    cv[3] = v.height;\n                    gl.uniform4f(ud[\"" + name + "\"].location, v.x, v.y, v.width, v.height)\n                }";
        },
        codeUbo: function(name) {
            return "\n                    v = uv." + name + ";\n\n                    data[offset] = v.x;\n                    data[offset+1] = v.y;\n                    data[offset+2] = v.width;\n                    data[offset+3] = v.height;\n                ";
        }
    },
    // a caching layer for vec4 uploading
    {
        test: function(data) {
            return data.type === 'vec4' && data.size === 1;
        },
        code: function(name) {
            return "\n                cv = ud[\"" + name + "\"].value;\n                v = uv[\"" + name + "\"];\n\n                if(cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])\n                {\n                    cv[0] = v[0];\n                    cv[1] = v[1];\n                    cv[2] = v[2];\n                    cv[3] = v[3];\n\n                    gl.uniform4f(ud[\"" + name + "\"].location, v[0], v[1], v[2], v[3])\n                }";
        }
    }
];
// cu = Cached value's uniform data field
// cv = Cached value
// v = value to upload
// ud = uniformData
// uv = uniformValue
// l = location
var GLSL_TO_SINGLE_SETTERS_CACHED = {
    float: "\n    if (cv !== v)\n    {\n        cu.value = v;\n        gl.uniform1f(location, v);\n    }",
    vec2: "\n    if (cv[0] !== v[0] || cv[1] !== v[1])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n\n        gl.uniform2f(location, v[0], v[1])\n    }",
    vec3: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n\n        gl.uniform3f(location, v[0], v[1], v[2])\n    }",
    vec4: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n        cv[3] = v[3];\n\n        gl.uniform4f(location, v[0], v[1], v[2], v[3]);\n    }",
    int: "\n    if (cv !== v)\n    {\n        cu.value = v;\n\n        gl.uniform1i(location, v);\n    }",
    ivec2: "\n    if (cv[0] !== v[0] || cv[1] !== v[1])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n\n        gl.uniform2i(location, v[0], v[1]);\n    }",
    ivec3: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n\n        gl.uniform3i(location, v[0], v[1], v[2]);\n    }",
    ivec4: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n        cv[3] = v[3];\n\n        gl.uniform4i(location, v[0], v[1], v[2], v[3]);\n    }",
    uint: "\n    if (cv !== v)\n    {\n        cu.value = v;\n\n        gl.uniform1ui(location, v);\n    }",
    uvec2: "\n    if (cv[0] !== v[0] || cv[1] !== v[1])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n\n        gl.uniform2ui(location, v[0], v[1]);\n    }",
    uvec3: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n\n        gl.uniform3ui(location, v[0], v[1], v[2]);\n    }",
    uvec4: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n        cv[3] = v[3];\n\n        gl.uniform4ui(location, v[0], v[1], v[2], v[3]);\n    }",
    bool: "\n    if (cv !== v)\n    {\n        cu.value = v;\n        gl.uniform1i(location, v);\n    }",
    bvec2: "\n    if (cv[0] != v[0] || cv[1] != v[1])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n\n        gl.uniform2i(location, v[0], v[1]);\n    }",
    bvec3: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n\n        gl.uniform3i(location, v[0], v[1], v[2]);\n    }",
    bvec4: "\n    if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3])\n    {\n        cv[0] = v[0];\n        cv[1] = v[1];\n        cv[2] = v[2];\n        cv[3] = v[3];\n\n        gl.uniform4i(location, v[0], v[1], v[2], v[3]);\n    }",
    mat2: 'gl.uniformMatrix2fv(location, false, v)',
    mat3: 'gl.uniformMatrix3fv(location, false, v)',
    mat4: 'gl.uniformMatrix4fv(location, false, v)',
    sampler2D: 'gl.uniform1i(location, v)',
    samplerCube: 'gl.uniform1i(location, v)',
    sampler2DArray: 'gl.uniform1i(location, v)'
};
var GLSL_TO_ARRAY_SETTERS = {
    float: "gl.uniform1fv(location, v)",
    vec2: "gl.uniform2fv(location, v)",
    vec3: "gl.uniform3fv(location, v)",
    vec4: 'gl.uniform4fv(location, v)',
    mat4: 'gl.uniformMatrix4fv(location, false, v)',
    mat3: 'gl.uniformMatrix3fv(location, false, v)',
    mat2: 'gl.uniformMatrix2fv(location, false, v)',
    int: 'gl.uniform1iv(location, v)',
    ivec2: 'gl.uniform2iv(location, v)',
    ivec3: 'gl.uniform3iv(location, v)',
    ivec4: 'gl.uniform4iv(location, v)',
    uint: 'gl.uniform1uiv(location, v)',
    uvec2: 'gl.uniform2uiv(location, v)',
    uvec3: 'gl.uniform3uiv(location, v)',
    uvec4: 'gl.uniform4uiv(location, v)',
    bool: 'gl.uniform1iv(location, v)',
    bvec2: 'gl.uniform2iv(location, v)',
    bvec3: 'gl.uniform3iv(location, v)',
    bvec4: 'gl.uniform4iv(location, v)',
    sampler2D: 'gl.uniform1iv(location, v)',
    samplerCube: 'gl.uniform1iv(location, v)',
    sampler2DArray: 'gl.uniform1iv(location, v)'
};
function generateUniformsSync(group, uniformData) {
    var _a;
    var funcFragments = [
        "\n        var v = null;\n        var cv = null;\n        var cu = null;\n        var t = 0;\n        var gl = renderer.gl;\n    "
    ];
    for(var i in group.uniforms){
        var data = uniformData[i];
        if (!data) {
            if ((_a = group.uniforms[i]) === null || _a === void 0 ? void 0 : _a.group) {
                if (group.uniforms[i].ubo) funcFragments.push("\n                        renderer.shader.syncUniformBufferGroup(uv." + i + ", '" + i + "');\n                    ");
                else funcFragments.push("\n                        renderer.shader.syncUniformGroup(uv." + i + ", syncData);\n                    ");
            }
            continue;
        }
        var uniform = group.uniforms[i];
        var parsed = false;
        for(var j = 0; j < uniformParsers.length; j++)if (uniformParsers[j].test(data, uniform)) {
            funcFragments.push(uniformParsers[j].code(i, uniform));
            parsed = true;
            break;
        }
        if (!parsed) {
            var templateType = data.size === 1 ? GLSL_TO_SINGLE_SETTERS_CACHED : GLSL_TO_ARRAY_SETTERS;
            var template = templateType[data.type].replace('location', "ud[\"" + i + "\"].location");
            funcFragments.push("\n            cu = ud[\"" + i + "\"];\n            cv = cu.value;\n            v = uv[\"" + i + "\"];\n            " + template + ";");
        }
    }
    /*
     * the introduction of syncData is to solve an issue where textures in uniform groups are not set correctly
     * the texture count was always starting from 0 in each group. This needs to increment each time a texture is used
     * no matter which group is being used
     *
     */ // eslint-disable-next-line no-new-func
    return new Function('ud', 'uv', 'renderer', 'syncData', funcFragments.join('\n'));
}
var fragTemplate = [
    'precision mediump float;',
    'void main(void){',
    'float test = 0.1;',
    '%forloop%',
    'gl_FragColor = vec4(0.0);',
    '}'
].join('\n');
function generateIfTestSrc(maxIfs) {
    var src = '';
    for(var i = 0; i < maxIfs; ++i){
        if (i > 0) src += '\nelse ';
        if (i < maxIfs - 1) src += "if(test == " + i + ".0){}";
    }
    return src;
}
function checkMaxIfStatementsInShader(maxIfs, gl) {
    if (maxIfs === 0) throw new Error('Invalid value of `0` passed to `checkMaxIfStatementsInShader`');
    var shader = gl.createShader(gl.FRAGMENT_SHADER);
    while(true){
        var fragmentSrc = fragTemplate.replace(/%forloop%/gi, generateIfTestSrc(maxIfs));
        gl.shaderSource(shader, fragmentSrc);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxIfs = maxIfs / 2 | 0;
        else break;
    }
    return maxIfs;
}
// Cache the result to prevent running this over and over
var unsafeEval;
/**
 * Not all platforms allow to generate function code (e.g., `new Function`).
 * this provides the platform-level detection.
 *
 * @private
 * @returns {boolean}
 */ function unsafeEvalSupported() {
    if (typeof unsafeEval === 'boolean') return unsafeEval;
    try {
        /* eslint-disable no-new-func */ var func = new Function('param1', 'param2', 'param3', 'return param1[param2] === param3;');
        /* eslint-enable no-new-func */ unsafeEval = func({
            a: 'b'
        }, 'a', 'b') === true;
    } catch (e) {
        unsafeEval = false;
    }
    return unsafeEval;
}
var defaultFragment = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\n\nvoid main(void){\n   gl_FragColor *= texture2D(uSampler, vTextureCoord);\n}";
var defaultVertex = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void){\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n   vTextureCoord = aTextureCoord;\n}\n";
var UID$3 = 0;
var nameCache = {};
/**
 * Helper class to create a shader program.
 *
 * @memberof PIXI
 */ var Program = /** @class */ function() {
    /**
     * @param vertexSrc - The source of the vertex shader.
     * @param fragmentSrc - The source of the fragment shader.
     * @param name - Name for shader
     */ function Program(vertexSrc, fragmentSrc, name) {
        if (name === void 0) name = 'pixi-shader';
        this.id = UID$3++;
        this.vertexSrc = vertexSrc || Program.defaultVertexSrc;
        this.fragmentSrc = fragmentSrc || Program.defaultFragmentSrc;
        this.vertexSrc = this.vertexSrc.trim();
        this.fragmentSrc = this.fragmentSrc.trim();
        if (this.vertexSrc.substring(0, 8) !== '#version') {
            name = name.replace(/\s+/g, '-');
            if (nameCache[name]) {
                nameCache[name]++;
                name += "-" + nameCache[name];
            } else nameCache[name] = 1;
            this.vertexSrc = "#define SHADER_NAME " + name + "\n" + this.vertexSrc;
            this.fragmentSrc = "#define SHADER_NAME " + name + "\n" + this.fragmentSrc;
            this.vertexSrc = setPrecision(this.vertexSrc, (0, $ezJmd.settings).PRECISION_VERTEX, (0, $P8XPi.PRECISION).HIGH);
            this.fragmentSrc = setPrecision(this.fragmentSrc, (0, $ezJmd.settings).PRECISION_FRAGMENT, getMaxFragmentPrecision());
        }
        // currently this does not extract structs only default types
        // this is where we store shader references..
        this.glPrograms = {};
        this.syncUniforms = null;
    }
    Object.defineProperty(Program, "defaultVertexSrc", {
        /**
         * The default vertex shader source.
         *
         * @constant
         */ get: function() {
            return defaultVertex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Program, "defaultFragmentSrc", {
        /**
         * The default fragment shader source.
         *
         * @constant
         */ get: function() {
            return defaultFragment;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * A short hand function to create a program based of a vertex and fragment shader.
     *
     * This method will also check to see if there is a cached program.
     *
     * @param vertexSrc - The source of the vertex shader.
     * @param fragmentSrc - The source of the fragment shader.
     * @param name - Name for shader
     * @returns A shiny new PixiJS shader program!
     */ Program.from = function(vertexSrc, fragmentSrc, name) {
        var key = vertexSrc + fragmentSrc;
        var program = (0, $csytw.ProgramCache)[key];
        if (!program) (0, $csytw.ProgramCache)[key] = program = new Program(vertexSrc, fragmentSrc, name);
        return program;
    };
    return Program;
}();
/**
 * A helper class for shaders.
 *
 * @memberof PIXI
 */ var Shader = /** @class */ function() {
    /**
     * @param program - The program the shader will use.
     * @param uniforms - Custom uniforms to use to augment the built-in ones.
     */ function Shader(program, uniforms) {
        /**
         * Used internally to bind uniform buffer objects.
         * @ignore
         */ this.uniformBindCount = 0;
        this.program = program;
        // lets see whats been passed in
        // uniforms should be converted to a uniform group
        if (uniforms) {
            if (uniforms instanceof UniformGroup) this.uniformGroup = uniforms;
            else this.uniformGroup = new UniformGroup(uniforms);
        } else this.uniformGroup = new UniformGroup({});
    }
    // TODO move to shader system..
    Shader.prototype.checkUniformExists = function(name, group) {
        if (group.uniforms[name]) return true;
        for(var i in group.uniforms){
            var uniform = group.uniforms[i];
            if (uniform.group) {
                if (this.checkUniformExists(name, uniform)) return true;
            }
        }
        return false;
    };
    Shader.prototype.destroy = function() {
        // usage count on programs?
        // remove if not used!
        this.uniformGroup = null;
    };
    Object.defineProperty(Shader.prototype, "uniforms", {
        /**
         * Shader uniform values, shortcut for `uniformGroup.uniforms`.
         *
         * @readonly
         */ get: function() {
            return this.uniformGroup.uniforms;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * A short hand function to create a shader based of a vertex and fragment shader.
     *
     * @param vertexSrc - The source of the vertex shader.
     * @param fragmentSrc - The source of the fragment shader.
     * @param uniforms - Custom uniforms to use to augment the built-in ones.
     * @returns A shiny new PixiJS shader!
     */ Shader.from = function(vertexSrc, fragmentSrc, uniforms) {
        var program = Program.from(vertexSrc, fragmentSrc);
        return new Shader(program, uniforms);
    };
    return Shader;
}();
/* eslint-disable max-len */ var BLEND = 0;
var OFFSET = 1;
var CULLING = 2;
var DEPTH_TEST = 3;
var WINDING = 4;
var DEPTH_MASK = 5;
/**
 * This is a WebGL state, and is is passed to {@link PIXI.StateSystem}.
 *
 * Each mesh rendered may require WebGL to be in a different state.
 * For example you may want different blend mode or to enable polygon offsets
 *
 * @memberof PIXI
 */ var State = /** @class */ function() {
    function State() {
        this.data = 0;
        this.blendMode = (0, $P8XPi.BLEND_MODES).NORMAL;
        this.polygonOffset = 0;
        this.blend = true;
        this.depthMask = true;
    //  this.depthTest = true;
    }
    Object.defineProperty(State.prototype, "blend", {
        /**
         * Activates blending of the computed fragment color values.
         *
         * @default true
         */ get: function() {
            return !!(this.data & 1 << BLEND);
        },
        set: function(value) {
            if (!!(this.data & 1 << BLEND) !== value) this.data ^= 1 << BLEND;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "offsets", {
        /**
         * Activates adding an offset to depth values of polygon's fragments
         *
         * @default false
         */ get: function() {
            return !!(this.data & 1 << OFFSET);
        },
        set: function(value) {
            if (!!(this.data & 1 << OFFSET) !== value) this.data ^= 1 << OFFSET;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "culling", {
        /**
         * Activates culling of polygons.
         *
         * @default false
         */ get: function() {
            return !!(this.data & 1 << CULLING);
        },
        set: function(value) {
            if (!!(this.data & 1 << CULLING) !== value) this.data ^= 1 << CULLING;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "depthTest", {
        /**
         * Activates depth comparisons and updates to the depth buffer.
         *
         * @default false
         */ get: function() {
            return !!(this.data & 1 << DEPTH_TEST);
        },
        set: function(value) {
            if (!!(this.data & 1 << DEPTH_TEST) !== value) this.data ^= 1 << DEPTH_TEST;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "depthMask", {
        /**
         * Enables or disables writing to the depth buffer.
         *
         * @default true
         */ get: function() {
            return !!(this.data & 1 << DEPTH_MASK);
        },
        set: function(value) {
            if (!!(this.data & 1 << DEPTH_MASK) !== value) this.data ^= 1 << DEPTH_MASK;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "clockwiseFrontFace", {
        /**
         * Specifies whether or not front or back-facing polygons can be culled.
         *
         * @default false
         */ get: function() {
            return !!(this.data & 1 << WINDING);
        },
        set: function(value) {
            if (!!(this.data & 1 << WINDING) !== value) this.data ^= 1 << WINDING;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "blendMode", {
        /**
         * The blend mode to be applied when this state is set. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
         * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
         *
         * @default PIXI.BLEND_MODES.NORMAL
         */ get: function() {
            return this._blendMode;
        },
        set: function(value) {
            this.blend = value !== (0, $P8XPi.BLEND_MODES).NONE;
            this._blendMode = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(State.prototype, "polygonOffset", {
        /**
         * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
         *
         * @default 0
         */ get: function() {
            return this._polygonOffset;
        },
        set: function(value) {
            this.offsets = !!value;
            this._polygonOffset = value;
        },
        enumerable: false,
        configurable: true
    });
    State.prototype.toString = function() {
        return "[@pixi/core:State " + ("blendMode=" + this.blendMode + " ") + ("clockwiseFrontFace=" + this.clockwiseFrontFace + " ") + ("culling=" + this.culling + " ") + ("depthMask=" + this.depthMask + " ") + ("polygonOffset=" + this.polygonOffset) + "]";
    };
    State.for2d = function() {
        var state = new State();
        state.depthTest = false;
        state.blend = true;
        return state;
    };
    return State;
}();
var defaultVertex$1 = "attribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aVertexPosition * (outputFrame.zw * inputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";
var defaultFragment$1 = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\n\nvoid main(void){\n   gl_FragColor = texture2D(uSampler, vTextureCoord);\n}\n";
/**
 * A filter is a special shader that applies post-processing effects to an input texture and writes into an output
 * render-target.
 *
 * {@link http://pixijs.io/examples/#/filters/blur-filter.js Example} of the
 * {@link PIXI.filters.BlurFilter BlurFilter}.
 *
 * ### Usage
 * Filters can be applied to any DisplayObject or Container.
 * PixiJS' `FilterSystem` renders the container into temporary Framebuffer,
 * then filter renders it to the screen.
 * Multiple filters can be added to the `filters` array property and stacked on each other.
 *
 * ```
 * const filter = new PIXI.Filter(myShaderVert, myShaderFrag, { myUniform: 0.5 });
 * const container = new PIXI.Container();
 * container.filters = [filter];
 * ```
 *
 * ### Previous Version Differences
 *
 * In PixiJS **v3**, a filter was always applied to _whole screen_.
 *
 * In PixiJS **v4**, a filter can be applied _only part of the screen_.
 * Developers had to create a set of uniforms to deal with coordinates.
 *
 * In PixiJS **v5** combines _both approaches_.
 * Developers can use normal coordinates of v3 and then allow filter to use partial Framebuffers,
 * bringing those extra uniforms into account.
 *
 * Also be aware that we have changed default vertex shader, please consult
 * {@link https://github.com/pixijs/pixi.js/wiki/v5-Creating-filters Wiki}.
 *
 * ### Frames
 *
 * The following table summarizes the coordinate spaces used in the filtering pipeline:
 *
 * <table>
 * <thead>
 *   <tr>
 *     <th>Coordinate Space</th>
 *     <th>Description</th>
 *   </tr>
 * </thead>
 * <tbody>
 *   <tr>
 *     <td>Texture Coordinates</td>
 *     <td>
 *         The texture (or UV) coordinates in the input base-texture's space. These are normalized into the (0,1) range along
 *         both axes.
 *     </td>
 *   </tr>
 *   <tr>
 *     <td>World Space</td>
 *     <td>
 *         A point in the same space as the world bounds of any display-object (i.e. in the scene graph's space).
 *     </td>
 *   </tr>
 *   <tr>
 *     <td>Physical Pixels</td>
 *     <td>
 *         This is base-texture's space with the origin on the top-left. You can calculate these by multiplying the texture
 *         coordinates by the dimensions of the texture.
 *     </td>
 *   </tr>
 * </tbody>
 * </table>
 *
 * ### Built-in Uniforms
 *
 * PixiJS viewport uses screen (CSS) coordinates, `(0, 0, renderer.screen.width, renderer.screen.height)`,
 * and `projectionMatrix` uniform maps it to the gl viewport.
 *
 * **uSampler**
 *
 * The most important uniform is the input texture that container was rendered into.
 * _Important note: as with all Framebuffers in PixiJS, both input and output are
 * premultiplied by alpha._
 *
 * By default, input normalized coordinates are passed to fragment shader with `vTextureCoord`.
 * Use it to sample the input.
 *
 * ```
 * const fragment = `
 * varying vec2 vTextureCoord;
 * uniform sampler2D uSampler;
 * void main(void)
 * {
 *    gl_FragColor = texture2D(uSampler, vTextureCoord);
 * }
 * `;
 *
 * const myFilter = new PIXI.Filter(null, fragment);
 * ```
 *
 * This filter is just one uniform less than {@link PIXI.filters.AlphaFilter AlphaFilter}.
 *
 * **outputFrame**
 *
 * The `outputFrame` holds the rectangle where filter is applied in screen (CSS) coordinates.
 * It's the same as `renderer.screen` for a fullscreen filter.
 * Only a part of  `outputFrame.zw` size of temporary Framebuffer is used,
 * `(0, 0, outputFrame.width, outputFrame.height)`,
 *
 * Filters uses this quad to normalized (0-1) space, its passed into `aVertexPosition` attribute.
 * To calculate vertex position in screen space using normalized (0-1) space:
 *
 * ```
 * vec4 filterVertexPosition( void )
 * {
 *     vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;
 *     return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
 * }
 * ```
 *
 * **inputSize**
 *
 * Temporary framebuffer is different, it can be either the size of screen, either power-of-two.
 * The `inputSize.xy` are size of temporary framebuffer that holds input.
 * The `inputSize.zw` is inverted, it's a shortcut to evade division inside the shader.
 *
 * Set `inputSize.xy = outputFrame.zw` for a fullscreen filter.
 *
 * To calculate input normalized coordinate, you have to map it to filter normalized space.
 * Multiply by `outputFrame.zw` to get input coordinate.
 * Divide by `inputSize.xy` to get input normalized coordinate.
 *
 * ```
 * vec2 filterTextureCoord( void )
 * {
 *     return aVertexPosition * (outputFrame.zw * inputSize.zw); // same as /inputSize.xy
 * }
 * ```
 * **resolution**
 *
 * The `resolution` is the ratio of screen (CSS) pixels to real pixels.
 *
 * **inputPixel**
 *
 * `inputPixel.xy` is the size of framebuffer in real pixels, same as `inputSize.xy * resolution`
 * `inputPixel.zw` is inverted `inputPixel.xy`.
 *
 * It's handy for filters that use neighbour pixels, like {@link PIXI.filters.FXAAFilter FXAAFilter}.
 *
 * **inputClamp**
 *
 * If you try to get info from outside of used part of Framebuffer - you'll get undefined behaviour.
 * For displacements, coordinates has to be clamped.
 *
 * The `inputClamp.xy` is left-top pixel center, you may ignore it, because we use left-top part of Framebuffer
 * `inputClamp.zw` is bottom-right pixel center.
 *
 * ```
 * vec4 color = texture2D(uSampler, clamp(modifiedTextureCoord, inputClamp.xy, inputClamp.zw))
 * ```
 * OR
 * ```
 * vec4 color = texture2D(uSampler, min(modifigedTextureCoord, inputClamp.zw))
 * ```
 *
 * ### Additional Information
 *
 * Complete documentation on Filter usage is located in the
 * {@link https://github.com/pixijs/pixi.js/wiki/v5-Creating-filters Wiki}.
 *
 * Since PixiJS only had a handful of built-in filters, additional filters can be downloaded
 * {@link https://github.com/pixijs/pixi-filters here} from the PixiJS Filters repository.
 *
 * @memberof PIXI
 */ var Filter = /** @class */ function(_super) {
    __extends(Filter, _super);
    /**
     * @param vertexSrc - The source of the vertex shader.
     * @param fragmentSrc - The source of the fragment shader.
     * @param uniforms - Custom uniforms to use to augment the built-in ones.
     */ function Filter(vertexSrc, fragmentSrc, uniforms) {
        var _this = this;
        var program = Program.from(vertexSrc || Filter.defaultVertexSrc, fragmentSrc || Filter.defaultFragmentSrc);
        _this = _super.call(this, program, uniforms) || this;
        _this.padding = 0;
        _this.resolution = (0, $ezJmd.settings).FILTER_RESOLUTION;
        _this.multisample = (0, $ezJmd.settings).FILTER_MULTISAMPLE;
        _this.enabled = true;
        _this.autoFit = true;
        _this.state = new State();
        return _this;
    }
    /**
     * Applies the filter
     *
     * @param {PIXI.FilterSystem} filterManager - The renderer to retrieve the filter from
     * @param {PIXI.RenderTexture} input - The input render target.
     * @param {PIXI.RenderTexture} output - The target to output to.
     * @param {PIXI.CLEAR_MODES} [clearMode] - Should the output be cleared before rendering to it.
     * @param {object} [currentState] - It's current state of filter.
     *        There are some useful properties in the currentState :
     *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
     */ Filter.prototype.apply = function(filterManager, input, output, clearMode, _currentState) {
        // do as you please!
        filterManager.applyFilter(this, input, output, clearMode);
    // or just do a regular render..
    };
    Object.defineProperty(Filter.prototype, "blendMode", {
        /**
         * Sets the blend mode of the filter.
         *
         * @default PIXI.BLEND_MODES.NORMAL
         */ get: function() {
            return this.state.blendMode;
        },
        set: function(value) {
            this.state.blendMode = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Filter.prototype, "resolution", {
        /**
         * The resolution of the filter. Setting this to be lower will lower the quality but
         * increase the performance of the filter.
         */ get: function() {
            return this._resolution;
        },
        set: function(value) {
            this._resolution = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Filter, "defaultVertexSrc", {
        /**
         * The default vertex shader source
         *
         * @constant
         */ get: function() {
            return defaultVertex$1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Filter, "defaultFragmentSrc", {
        /**
         * The default fragment shader source
         *
         * @constant
         */ get: function() {
            return defaultFragment$1;
        },
        enumerable: false,
        configurable: true
    });
    return Filter;
}(Shader);
var vertex = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 otherMatrix;\n\nvarying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n}\n";
var fragment = "varying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform sampler2D mask;\nuniform float alpha;\nuniform float npmAlpha;\nuniform vec4 maskClamp;\n\nvoid main(void)\n{\n    float clip = step(3.5,\n        step(maskClamp.x, vMaskCoord.x) +\n        step(maskClamp.y, vMaskCoord.y) +\n        step(vMaskCoord.x, maskClamp.z) +\n        step(vMaskCoord.y, maskClamp.w));\n\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    vec4 masky = texture2D(mask, vMaskCoord);\n    float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);\n\n    original *= (alphaMul * masky.r * alpha * clip);\n\n    gl_FragColor = original;\n}\n";
var tempMat = new (0, $6qzqq.Matrix)();
/**
 * Class controls uv mapping from Texture normal space to BaseTexture normal space.
 *
 * Takes `trim` and `rotate` into account. May contain clamp settings for Meshes and TilingSprite.
 *
 * Can be used in Texture `uvMatrix` field, or separately, you can use different clamp settings on the same texture.
 * If you want to add support for texture region of certain feature or filter, that's what you're looking for.
 *
 * Takes track of Texture changes through `_lastTextureID` private field.
 * Use `update()` method call to track it from outside.
 *
 * @see PIXI.Texture
 * @see PIXI.Mesh
 * @see PIXI.TilingSprite
 * @class
 * @memberof PIXI
 */ var TextureMatrix = /** @class */ function() {
    /**
     *
     * @param {PIXI.Texture} texture - observed texture
     * @param {number} [clampMargin] - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
     * @constructor
     */ function TextureMatrix(texture, clampMargin) {
        this._texture = texture;
        /**
         * Matrix operation that converts texture region coords to texture coords
         * @member {PIXI.Matrix}
         * @readonly
         */ this.mapCoord = new (0, $6qzqq.Matrix)();
        /**
         * Clamp region for normalized coords, left-top pixel center in xy , bottom-right in zw.
         * Calculated based on clampOffset.
         * @member {Float32Array}
         * @readonly
         */ this.uClampFrame = new Float32Array(4);
        /**
         * Normalized clamp offset.
         * Calculated based on clampOffset.
         * @member {Float32Array}
         * @readonly
         */ this.uClampOffset = new Float32Array(2);
        /**
         * Tracks Texture frame changes
         * @member {number}
         * @protected
         */ this._textureID = -1;
        /**
         * Tracks Texture frame changes
         * @member {number}
         * @protected
         */ this._updateID = 0;
        /**
         * Changes frame clamping
         * Works with TilingSprite and Mesh
         * Change to 1.5 if you texture has repeated right and bottom lines, that leads to smoother borders
         *
         * @default 0
         * @member {number}
         */ this.clampOffset = 0;
        /**
         * Changes frame clamping
         * Works with TilingSprite and Mesh
         * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
         *
         * @default 0.5
         * @member {number}
         */ this.clampMargin = typeof clampMargin === 'undefined' ? 0.5 : clampMargin;
        /**
         * If texture size is the same as baseTexture
         * @member {boolean}
         * @default false
         * @readonly
         */ this.isSimple = false;
    }
    Object.defineProperty(TextureMatrix.prototype, "texture", {
        /**
         * texture property
         * @member {PIXI.Texture}
         */ get: function() {
            return this._texture;
        },
        set: function(value) {
            this._texture = value;
            this._textureID = -1;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Multiplies uvs array to transform
     * @param {Float32Array} uvs - mesh uvs
     * @param {Float32Array} [out=uvs] - output
     * @returns {Float32Array} output
     */ TextureMatrix.prototype.multiplyUvs = function(uvs, out) {
        if (out === undefined) out = uvs;
        var mat = this.mapCoord;
        for(var i = 0; i < uvs.length; i += 2){
            var x = uvs[i];
            var y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx;
            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    };
    /**
     * updates matrices if texture was changed
     * @param {boolean} [forceUpdate=false] - if true, matrices will be updated any case
     * @returns {boolean} whether or not it was updated
     */ TextureMatrix.prototype.update = function(forceUpdate) {
        var tex = this._texture;
        if (!tex || !tex.valid) return false;
        if (!forceUpdate && this._textureID === tex._updateID) return false;
        this._textureID = tex._updateID;
        this._updateID++;
        var uvs = tex._uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        var orig = tex.orig;
        var trim = tex.trim;
        if (trim) {
            tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
            this.mapCoord.append(tempMat);
        }
        var texBase = tex.baseTexture;
        var frame = this.uClampFrame;
        var margin = this.clampMargin / texBase.resolution;
        var offset = this.clampOffset;
        frame[0] = (tex._frame.x + margin + offset) / texBase.width;
        frame[1] = (tex._frame.y + margin + offset) / texBase.height;
        frame[2] = (tex._frame.x + tex._frame.width - margin + offset) / texBase.width;
        frame[3] = (tex._frame.y + tex._frame.height - margin + offset) / texBase.height;
        this.uClampOffset[0] = offset / texBase.realWidth;
        this.uClampOffset[1] = offset / texBase.realHeight;
        this.isSimple = tex._frame.width === texBase.width && tex._frame.height === texBase.height && tex.rotate === 0;
        return true;
    };
    return TextureMatrix;
}();
/**
 * This handles a Sprite acting as a mask, as opposed to a Graphic.
 *
 * WebGL only.
 *
 * @memberof PIXI
 */ var SpriteMaskFilter = /** @class */ function(_super) {
    __extends(SpriteMaskFilter, _super);
    /** @ignore */ function SpriteMaskFilter(vertexSrc, fragmentSrc, uniforms) {
        var _this = this;
        var sprite = null;
        if (typeof vertexSrc !== 'string' && fragmentSrc === undefined && uniforms === undefined) {
            sprite = vertexSrc;
            vertexSrc = undefined;
            fragmentSrc = undefined;
            uniforms = undefined;
        }
        _this = _super.call(this, vertexSrc || vertex, fragmentSrc || fragment, uniforms) || this;
        _this.maskSprite = sprite;
        _this.maskMatrix = new (0, $6qzqq.Matrix)();
        return _this;
    }
    Object.defineProperty(SpriteMaskFilter.prototype, "maskSprite", {
        /**
         * Sprite mask
         *
         * @type {PIXI.DisplayObject}
         */ get: function() {
            return this._maskSprite;
        },
        set: function(value) {
            this._maskSprite = value;
            if (this._maskSprite) this._maskSprite.renderable = false;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Applies the filter
     *
     * @param filterManager - The renderer to retrieve the filter from
     * @param input - The input render target.
     * @param output - The target to output to.
     * @param clearMode - Should the output be cleared before rendering to it.
     */ SpriteMaskFilter.prototype.apply = function(filterManager, input, output, clearMode) {
        var maskSprite = this._maskSprite;
        var tex = maskSprite._texture;
        if (!tex.valid) return;
        if (!tex.uvMatrix) // margin = 0.0, let it bleed a bit, shader code becomes easier
        // assuming that atlas textures were made with 1-pixel padding
        tex.uvMatrix = new TextureMatrix(tex, 0.0);
        tex.uvMatrix.update();
        this.uniforms.npmAlpha = tex.baseTexture.alphaMode ? 0.0 : 1.0;
        this.uniforms.mask = tex;
        // get _normalized sprite texture coords_ and convert them to _normalized atlas texture coords_ with `prepend`
        this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite).prepend(tex.uvMatrix.mapCoord);
        this.uniforms.alpha = maskSprite.worldAlpha;
        this.uniforms.maskClamp = tex.uvMatrix.uClampFrame;
        filterManager.applyFilter(this, input, output, clearMode);
    };
    return SpriteMaskFilter;
}(Filter);
/**
 * System plugin to the renderer to manage masks.
 *
 * There are three built-in types of masking:
 * * **Scissor Masking**: Scissor masking discards pixels that are outside of a rectangle called the scissor box. It is
 *  the most performant as the scissor test is inexpensive. However, it can only be used when the mask is rectangular.
 * * **Stencil Masking**: Stencil masking discards pixels that don't overlap with the pixels rendered into the stencil
 *  buffer. It is the next fastest option as it does not require rendering into a separate framebuffer. However, it does
 *  cause the mask to be rendered **twice** for each masking operation; hence, minimize the rendering cost of your masks.
 * * **Sprite Mask Filtering**: Sprite mask filtering discards pixels based on the red channel of the sprite-mask's
 *  texture. (Generally, the masking texture is grayscale). Using advanced techniques, you might be able to embed this
 *  type of masking in a custom shader - and hence, bypassing the masking system fully for performance wins.
 *
 * The best type of masking is auto-detected when you `push` one. To use scissor masking, you must pass in a `Graphics`
 * object with just a rectangle drawn.
 *
 * ## Mask Stacks
 *
 * In the scene graph, masks can be applied recursively, i.e. a mask can be applied during a masking operation. The mask
 * stack stores the currently applied masks in order. Each {@link PIXI.BaseRenderTexture} holds its own mask stack, i.e.
 * when you switch render-textures, the old masks only applied when you switch back to rendering to the old render-target.
 *
 * @memberof PIXI
 */ var MaskSystem = /** @class */ function() {
    /**
     * @param renderer - The renderer this System works for.
     */ function MaskSystem(renderer) {
        this.renderer = renderer;
        this.enableScissor = true;
        this.alphaMaskPool = [];
        this.maskDataPool = [];
        this.maskStack = [];
        this.alphaMaskIndex = 0;
    }
    /**
     * Changes the mask stack that is used by this System.
     *
     * @param maskStack - The mask stack
     */ MaskSystem.prototype.setMaskStack = function(maskStack) {
        this.maskStack = maskStack;
        this.renderer.scissor.setMaskStack(maskStack);
        this.renderer.stencil.setMaskStack(maskStack);
    };
    /**
     * Enables the mask and appends it to the current mask stack.
     *
     * NOTE: The batch renderer should be flushed beforehand to prevent pending renders from being masked.
     *
     * @param {PIXI.DisplayObject} target - Display Object to push the mask to
     * @param {PIXI.MaskData|PIXI.Sprite|PIXI.Graphics|PIXI.DisplayObject} maskData - The masking data.
     */ MaskSystem.prototype.push = function(target, maskDataOrTarget) {
        var maskData = maskDataOrTarget;
        if (!maskData.isMaskData) {
            var d = this.maskDataPool.pop() || new MaskData();
            d.pooled = true;
            d.maskObject = maskDataOrTarget;
            maskData = d;
        }
        var maskAbove = this.maskStack.length !== 0 ? this.maskStack[this.maskStack.length - 1] : null;
        maskData.copyCountersOrReset(maskAbove);
        if (maskData.autoDetect) this.detect(maskData);
        maskData._target = target;
        if (maskData.type !== (0, $P8XPi.MASK_TYPES).SPRITE) this.maskStack.push(maskData);
        if (maskData.enabled) switch(maskData.type){
            case (0, $P8XPi.MASK_TYPES).SCISSOR:
                this.renderer.scissor.push(maskData);
                break;
            case (0, $P8XPi.MASK_TYPES).STENCIL:
                this.renderer.stencil.push(maskData);
                break;
            case (0, $P8XPi.MASK_TYPES).SPRITE:
                maskData.copyCountersOrReset(null);
                this.pushSpriteMask(maskData);
                break;
        }
        if (maskData.type === (0, $P8XPi.MASK_TYPES).SPRITE) this.maskStack.push(maskData);
    };
    /**
     * Removes the last mask from the mask stack and doesn't return it.
     *
     * NOTE: The batch renderer should be flushed beforehand to render the masked contents before the mask is removed.
     *
     * @param {PIXI.DisplayObject} target - Display Object to pop the mask from
     */ MaskSystem.prototype.pop = function(target) {
        var maskData = this.maskStack.pop();
        if (!maskData || maskData._target !== target) // TODO: add an assert when we have it
        return;
        if (maskData.enabled) switch(maskData.type){
            case (0, $P8XPi.MASK_TYPES).SCISSOR:
                this.renderer.scissor.pop();
                break;
            case (0, $P8XPi.MASK_TYPES).STENCIL:
                this.renderer.stencil.pop(maskData.maskObject);
                break;
            case (0, $P8XPi.MASK_TYPES).SPRITE:
                this.popSpriteMask(maskData);
                break;
        }
        maskData.reset();
        if (maskData.pooled) this.maskDataPool.push(maskData);
        if (this.maskStack.length !== 0) {
            var maskCurrent = this.maskStack[this.maskStack.length - 1];
            if (maskCurrent.type === (0, $P8XPi.MASK_TYPES).SPRITE && maskCurrent._filters) maskCurrent._filters[0].maskSprite = maskCurrent.maskObject;
        }
    };
    /** Sets type of MaskData based on its maskObject. */ MaskSystem.prototype.detect = function(maskData) {
        var maskObject = maskData.maskObject;
        if (maskObject.isSprite) maskData.type = (0, $P8XPi.MASK_TYPES).SPRITE;
        else if (this.enableScissor && this.renderer.scissor.testScissor(maskData)) maskData.type = (0, $P8XPi.MASK_TYPES).SCISSOR;
        else maskData.type = (0, $P8XPi.MASK_TYPES).STENCIL;
    };
    /**
     * Applies the Mask and adds it to the current filter stack.
     *
     * @param maskData - Sprite to be used as the mask.
     */ MaskSystem.prototype.pushSpriteMask = function(maskData) {
        var _a, _b;
        var maskObject = maskData.maskObject;
        var target = maskData._target;
        var alphaMaskFilter = maskData._filters;
        if (!alphaMaskFilter) {
            alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex];
            if (!alphaMaskFilter) alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex] = [
                new SpriteMaskFilter()
            ];
        }
        var renderer = this.renderer;
        var renderTextureSystem = renderer.renderTexture;
        var resolution;
        var multisample;
        if (renderTextureSystem.current) {
            var renderTexture = renderTextureSystem.current;
            resolution = maskData.resolution || renderTexture.resolution;
            multisample = (_a = maskData.multisample) !== null && _a !== void 0 ? _a : renderTexture.multisample;
        } else {
            resolution = maskData.resolution || renderer.resolution;
            multisample = (_b = maskData.multisample) !== null && _b !== void 0 ? _b : renderer.multisample;
        }
        alphaMaskFilter[0].resolution = resolution;
        alphaMaskFilter[0].multisample = multisample;
        alphaMaskFilter[0].maskSprite = maskObject;
        var stashFilterArea = target.filterArea;
        target.filterArea = maskObject.getBounds(true);
        renderer.filter.push(target, alphaMaskFilter);
        target.filterArea = stashFilterArea;
        if (!maskData._filters) this.alphaMaskIndex++;
    };
    /**
     * Removes the last filter from the filter stack and doesn't return it.
     *
     * @param maskData - Sprite to be used as the mask.
     */ MaskSystem.prototype.popSpriteMask = function(maskData) {
        this.renderer.filter.pop();
        if (maskData._filters) maskData._filters[0].maskSprite = null;
        else {
            this.alphaMaskIndex--;
            this.alphaMaskPool[this.alphaMaskIndex][0].maskSprite = null;
        }
    };
    MaskSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return MaskSystem;
}();
/**
 * System plugin to the renderer to manage specific types of masking operations.
 *
 * @memberof PIXI
 */ var AbstractMaskSystem = /** @class */ function() {
    /**
     * @param renderer - The renderer this System works for.
     */ function AbstractMaskSystem(renderer) {
        this.renderer = renderer;
        this.maskStack = [];
        this.glConst = 0;
    }
    /** Gets count of masks of certain type. */ AbstractMaskSystem.prototype.getStackLength = function() {
        return this.maskStack.length;
    };
    /**
     * Changes the mask stack that is used by this System.
     *
     * @param {PIXI.MaskData[]} maskStack - The mask stack
     */ AbstractMaskSystem.prototype.setMaskStack = function(maskStack) {
        var gl = this.renderer.gl;
        var curStackLen = this.getStackLength();
        this.maskStack = maskStack;
        var newStackLen = this.getStackLength();
        if (newStackLen !== curStackLen) {
            if (newStackLen === 0) gl.disable(this.glConst);
            else {
                gl.enable(this.glConst);
                this._useCurrent();
            }
        }
    };
    /**
     * Setup renderer to use the current mask data.
     * @private
     */ AbstractMaskSystem.prototype._useCurrent = function() {
    // OVERWRITE;
    };
    /** Destroys the mask stack. */ AbstractMaskSystem.prototype.destroy = function() {
        this.renderer = null;
        this.maskStack = null;
    };
    return AbstractMaskSystem;
}();
var tempMatrix$1 = new (0, $6qzqq.Matrix)();
/**
 * System plugin to the renderer to manage scissor masking.
 *
 * Scissor masking discards pixels outside of a rectangle called the scissor box. The scissor box is in the framebuffer
 * viewport's space; however, the mask's rectangle is projected from world-space to viewport space automatically
 * by this system.
 *
 * @memberof PIXI
 */ var ScissorSystem = /** @class */ function(_super) {
    __extends(ScissorSystem, _super);
    /**
     * @param {PIXI.Renderer} renderer - The renderer this System works for.
     */ function ScissorSystem(renderer) {
        var _this = _super.call(this, renderer) || this;
        _this.glConst = WebGLRenderingContext.SCISSOR_TEST;
        return _this;
    }
    ScissorSystem.prototype.getStackLength = function() {
        var maskData = this.maskStack[this.maskStack.length - 1];
        if (maskData) return maskData._scissorCounter;
        return 0;
    };
    /**
     * evaluates _boundsTransformed, _scissorRect for MaskData
     * @param maskData
     */ ScissorSystem.prototype.calcScissorRect = function(maskData) {
        if (maskData._scissorRectLocal) return;
        var prevData = maskData._scissorRect;
        var maskObject = maskData.maskObject;
        var renderer = this.renderer;
        var renderTextureSystem = renderer.renderTexture;
        maskObject.renderable = true;
        var rect = maskObject.getBounds();
        this.roundFrameToPixels(rect, renderTextureSystem.current ? renderTextureSystem.current.resolution : renderer.resolution, renderTextureSystem.sourceFrame, renderTextureSystem.destinationFrame, renderer.projection.transform);
        maskObject.renderable = false;
        if (prevData) rect.fit(prevData);
        maskData._scissorRectLocal = rect;
    };
    ScissorSystem.isMatrixRotated = function(matrix) {
        if (!matrix) return false;
        var a = matrix.a, b = matrix.b, c = matrix.c, d = matrix.d;
        // Skip if skew/rotation present in matrix, except for multiple of 90° rotation. If rotation
        // is a multiple of 90°, then either pair of (b,c) or (a,d) will be (0,0).
        return (Math.abs(b) > 1e-4 || Math.abs(c) > 1e-4) && (Math.abs(a) > 1e-4 || Math.abs(d) > 1e-4);
    };
    /**
     * Test, whether the object can be scissor mask with current renderer projection.
     * Calls "calcScissorRect()" if its true.
     * @param maskData mask data
     * @returns whether Whether the object can be scissor mask
     */ ScissorSystem.prototype.testScissor = function(maskData) {
        var maskObject = maskData.maskObject;
        if (!maskObject.isFastRect || !maskObject.isFastRect()) return false;
        if (ScissorSystem.isMatrixRotated(maskObject.worldTransform)) return false;
        if (ScissorSystem.isMatrixRotated(this.renderer.projection.transform)) return false;
        this.calcScissorRect(maskData);
        var rect = maskData._scissorRectLocal;
        return rect.width > 0 && rect.height > 0;
    };
    ScissorSystem.prototype.roundFrameToPixels = function(frame, resolution, bindingSourceFrame, bindingDestinationFrame, transform) {
        if (ScissorSystem.isMatrixRotated(transform)) return;
        transform = transform ? tempMatrix$1.copyFrom(transform) : tempMatrix$1.identity();
        // Get forward transform from world space to screen space
        transform.translate(-bindingSourceFrame.x, -bindingSourceFrame.y).scale(bindingDestinationFrame.width / bindingSourceFrame.width, bindingDestinationFrame.height / bindingSourceFrame.height).translate(bindingDestinationFrame.x, bindingDestinationFrame.y);
        // Convert frame to screen space
        this.renderer.filter.transformAABB(transform, frame);
        frame.fit(bindingDestinationFrame);
        frame.x = Math.round(frame.x * resolution);
        frame.y = Math.round(frame.y * resolution);
        frame.width = Math.round(frame.width * resolution);
        frame.height = Math.round(frame.height * resolution);
    };
    /**
     * Applies the Mask and adds it to the current stencil stack.
     *
     * @author alvin
     * @param maskData - The mask data.
     */ ScissorSystem.prototype.push = function(maskData) {
        if (!maskData._scissorRectLocal) this.calcScissorRect(maskData);
        var gl = this.renderer.gl;
        if (!maskData._scissorRect) gl.enable(gl.SCISSOR_TEST);
        maskData._scissorCounter++;
        maskData._scissorRect = maskData._scissorRectLocal;
        this._useCurrent();
    };
    /**
     * This should be called after a mask is popped off the mask stack. It will rebind the scissor box to be latest with the
     * last mask in the stack.
     *
     * This can also be called when you directly modify the scissor box and want to restore PixiJS state.
     */ ScissorSystem.prototype.pop = function() {
        var gl = this.renderer.gl;
        if (this.getStackLength() > 0) this._useCurrent();
        else gl.disable(gl.SCISSOR_TEST);
    };
    /**
     * Setup renderer to use the current scissor data.
     * @private
     */ ScissorSystem.prototype._useCurrent = function() {
        var rect = this.maskStack[this.maskStack.length - 1]._scissorRect;
        var y;
        if (this.renderer.renderTexture.current) y = rect.y;
        else // flipY. In future we'll have it over renderTextures as an option
        y = this.renderer.height - rect.height - rect.y;
        this.renderer.gl.scissor(rect.x, y, rect.width, rect.height);
    };
    return ScissorSystem;
}(AbstractMaskSystem);
/**
 * System plugin to the renderer to manage stencils (used for masks).
 *
 * @memberof PIXI
 */ var StencilSystem = /** @class */ function(_super) {
    __extends(StencilSystem, _super);
    /**
     * @param renderer - The renderer this System works for.
     */ function StencilSystem(renderer) {
        var _this = _super.call(this, renderer) || this;
        _this.glConst = WebGLRenderingContext.STENCIL_TEST;
        return _this;
    }
    StencilSystem.prototype.getStackLength = function() {
        var maskData = this.maskStack[this.maskStack.length - 1];
        if (maskData) return maskData._stencilCounter;
        return 0;
    };
    /**
     * Applies the Mask and adds it to the current stencil stack.
     *
     * @param maskData - The mask data
     */ StencilSystem.prototype.push = function(maskData) {
        var maskObject = maskData.maskObject;
        var gl = this.renderer.gl;
        var prevMaskCount = maskData._stencilCounter;
        if (prevMaskCount === 0) {
            // force use stencil texture in current framebuffer
            this.renderer.framebuffer.forceStencil();
            gl.clearStencil(0);
            gl.clear(gl.STENCIL_BUFFER_BIT);
            gl.enable(gl.STENCIL_TEST);
        }
        maskData._stencilCounter++;
        // Increment the reference stencil value where the new mask overlaps with the old ones.
        gl.colorMask(false, false, false, false);
        gl.stencilFunc(gl.EQUAL, prevMaskCount, 0xFFFFFFFF);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
        maskObject.renderable = true;
        maskObject.render(this.renderer);
        this.renderer.batch.flush();
        maskObject.renderable = false;
        this._useCurrent();
    };
    /**
     * Pops stencil mask. MaskData is already removed from stack
     *
     * @param {PIXI.DisplayObject} maskObject - object of popped mask data
     */ StencilSystem.prototype.pop = function(maskObject) {
        var gl = this.renderer.gl;
        if (this.getStackLength() === 0) // the stack is empty!
        gl.disable(gl.STENCIL_TEST);
        else {
            // Decrement the reference stencil value where the popped mask overlaps with the other ones
            gl.colorMask(false, false, false, false);
            gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
            maskObject.renderable = true;
            maskObject.render(this.renderer);
            this.renderer.batch.flush();
            maskObject.renderable = false;
            this._useCurrent();
        }
    };
    /**
     * Setup renderer to use the current stencil data.
     * @private
     */ StencilSystem.prototype._useCurrent = function() {
        var gl = this.renderer.gl;
        gl.colorMask(true, true, true, true);
        gl.stencilFunc(gl.EQUAL, this.getStackLength(), 0xFFFFFFFF);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
    };
    return StencilSystem;
}(AbstractMaskSystem);
/**
 * System plugin to the renderer to manage the projection matrix.
 *
 * The `projectionMatrix` is a global uniform provided to all shaders. It is used to transform points in world space to
 * normalized device coordinates.
 *
 * @memberof PIXI
 */ var ProjectionSystem = /** @class */ function() {
    /** @param renderer - The renderer this System works for. */ function ProjectionSystem(renderer) {
        this.renderer = renderer;
        this.destinationFrame = null;
        this.sourceFrame = null;
        this.defaultFrame = null;
        this.projectionMatrix = new (0, $6qzqq.Matrix)();
        this.transform = null;
    }
    /**
     * Updates the projection-matrix based on the sourceFrame → destinationFrame mapping provided.
     *
     * NOTE: It is expected you call `renderer.framebuffer.setViewport(destinationFrame)` after this. This is because
     * the framebuffer viewport converts shader vertex output in normalized device coordinates to window coordinates.
     *
     * NOTE-2: {@link RenderTextureSystem#bind} updates the projection-matrix when you bind a render-texture. It is expected
     * that you dirty the current bindings when calling this manually.
     *
     * @param destinationFrame - The rectangle in the render-target to render the contents into. If rendering to the canvas,
     *  the origin is on the top-left; if rendering to a render-texture, the origin is on the bottom-left.
     * @param sourceFrame - The rectangle in world space that contains the contents being rendered.
     * @param resolution - The resolution of the render-target, which is the ratio of
     *  world-space (or CSS) pixels to physical pixels.
     * @param root - Whether the render-target is the screen. This is required because rendering to textures
     *  is y-flipped (i.e. upside down relative to the screen).
     */ ProjectionSystem.prototype.update = function(destinationFrame, sourceFrame, resolution, root) {
        this.destinationFrame = destinationFrame || this.destinationFrame || this.defaultFrame;
        this.sourceFrame = sourceFrame || this.sourceFrame || destinationFrame;
        // Calculate object-space to clip-space projection
        this.calculateProjection(this.destinationFrame, this.sourceFrame, resolution, root);
        if (this.transform) this.projectionMatrix.append(this.transform);
        var renderer = this.renderer;
        renderer.globalUniforms.uniforms.projectionMatrix = this.projectionMatrix;
        renderer.globalUniforms.update();
        // this will work for now
        // but would be sweet to stick and even on the global uniforms..
        if (renderer.shader.shader) renderer.shader.syncUniformGroup(renderer.shader.shader.uniforms.globals);
    };
    /**
     * Calculates the `projectionMatrix` to map points inside `sourceFrame` to inside `destinationFrame`.
     *
     * @param destinationFrame - The destination frame in the render-target.
     * @param sourceFrame - The source frame in world space.
     * @param resolution - The render-target's resolution, i.e. ratio of CSS to physical pixels.
     * @param root - Whether rendering into the screen. Otherwise, if rendering to a framebuffer, the projection
     *  is y-flipped.
     */ ProjectionSystem.prototype.calculateProjection = function(_destinationFrame, sourceFrame, _resolution, root) {
        var pm = this.projectionMatrix;
        var sign = !root ? 1 : -1;
        pm.identity();
        pm.a = 1 / sourceFrame.width * 2;
        pm.d = sign * (1 / sourceFrame.height * 2);
        pm.tx = -1 - sourceFrame.x * pm.a;
        pm.ty = -sign - sourceFrame.y * pm.d;
    };
    /**
     * Sets the transform of the active render target to the given matrix.
     *
     * @param matrix - The transformation matrix
     */ ProjectionSystem.prototype.setTransform = function(_matrix) {
    // this._activeRenderTarget.transform = matrix;
    };
    ProjectionSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return ProjectionSystem;
}();
// Temporary rectangle for assigned sourceFrame or destinationFrame
var tempRect = new (0, $6qzqq.Rectangle)();
// Temporary rectangle for renderTexture destinationFrame
var tempRect2 = new (0, $6qzqq.Rectangle)();
/* eslint-disable max-len */ /**
 * System plugin to the renderer to manage render textures.
 *
 * Should be added after FramebufferSystem
 *
 * ### Frames
 *
 * The `RenderTextureSystem` holds a sourceFrame → destinationFrame projection. The following table explains the different
 * coordinate spaces used:
 *
 * | Frame                  | Description                                                      | Coordinate System                                       |
 * | ---------------------- | ---------------------------------------------------------------- | ------------------------------------------------------- |
 * | sourceFrame            | The rectangle inside of which display-objects are being rendered | **World Space**: The origin on the top-left             |
 * | destinationFrame       | The rectangle in the render-target (canvas or texture) into which contents should be rendered | If rendering to the canvas, this is in screen space and the origin is on the top-left. If rendering to a render-texture, this is in its base-texture's space with the origin on the bottom-left.  |
 * | viewportFrame          | The framebuffer viewport corresponding to the destination-frame  | **Window Coordinates**: The origin is always on the bottom-left. |
 *
 * @memberof PIXI
 */ var RenderTextureSystem = /** @class */ function() {
    /**
     * @param renderer - The renderer this System works for.
     */ function RenderTextureSystem(renderer) {
        this.renderer = renderer;
        this.clearColor = renderer._backgroundColorRgba;
        this.defaultMaskStack = [];
        this.current = null;
        this.sourceFrame = new (0, $6qzqq.Rectangle)();
        this.destinationFrame = new (0, $6qzqq.Rectangle)();
        this.viewportFrame = new (0, $6qzqq.Rectangle)();
    }
    /**
     * Bind the current render texture.
     *
     * @param renderTexture - RenderTexture to bind, by default its `null` - the screen.
     * @param sourceFrame - Part of world that is mapped to the renderTexture.
     * @param destinationFrame - Part of renderTexture, by default it has the same size as sourceFrame.
     */ RenderTextureSystem.prototype.bind = function(renderTexture, sourceFrame, destinationFrame) {
        if (renderTexture === void 0) renderTexture = null;
        var renderer = this.renderer;
        this.current = renderTexture;
        var baseTexture;
        var framebuffer;
        var resolution;
        if (renderTexture) {
            baseTexture = renderTexture.baseTexture;
            resolution = baseTexture.resolution;
            if (!sourceFrame) {
                tempRect.width = renderTexture.frame.width;
                tempRect.height = renderTexture.frame.height;
                sourceFrame = tempRect;
            }
            if (!destinationFrame) {
                tempRect2.x = renderTexture.frame.x;
                tempRect2.y = renderTexture.frame.y;
                tempRect2.width = sourceFrame.width;
                tempRect2.height = sourceFrame.height;
                destinationFrame = tempRect2;
            }
            framebuffer = baseTexture.framebuffer;
        } else {
            resolution = renderer.resolution;
            if (!sourceFrame) {
                tempRect.width = renderer.screen.width;
                tempRect.height = renderer.screen.height;
                sourceFrame = tempRect;
            }
            if (!destinationFrame) {
                destinationFrame = tempRect;
                destinationFrame.width = sourceFrame.width;
                destinationFrame.height = sourceFrame.height;
            }
        }
        var viewportFrame = this.viewportFrame;
        viewportFrame.x = destinationFrame.x * resolution;
        viewportFrame.y = destinationFrame.y * resolution;
        viewportFrame.width = destinationFrame.width * resolution;
        viewportFrame.height = destinationFrame.height * resolution;
        if (!renderTexture) viewportFrame.y = renderer.view.height - (viewportFrame.y + viewportFrame.height);
        viewportFrame.ceil();
        this.renderer.framebuffer.bind(framebuffer, viewportFrame);
        this.renderer.projection.update(destinationFrame, sourceFrame, resolution, !framebuffer);
        if (renderTexture) this.renderer.mask.setMaskStack(baseTexture.maskStack);
        else this.renderer.mask.setMaskStack(this.defaultMaskStack);
        this.sourceFrame.copyFrom(sourceFrame);
        this.destinationFrame.copyFrom(destinationFrame);
    };
    /**
     * Erases the render texture and fills the drawing area with a colour.
     *
     * @param clearColor - The color as rgba, default to use the renderer backgroundColor
     * @param [mask=BUFFER_BITS.COLOR | BUFFER_BITS.DEPTH] - Bitwise OR of masks
     *  that indicate the buffers to be cleared, by default COLOR and DEPTH buffers.
     */ RenderTextureSystem.prototype.clear = function(clearColor, mask) {
        if (this.current) clearColor = clearColor || this.current.baseTexture.clearColor;
        else clearColor = clearColor || this.clearColor;
        var destinationFrame = this.destinationFrame;
        var baseFrame = this.current ? this.current.baseTexture : this.renderer.screen;
        var clearMask = destinationFrame.width !== baseFrame.width || destinationFrame.height !== baseFrame.height;
        if (clearMask) {
            var _a = this.viewportFrame, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
            x = Math.round(x);
            y = Math.round(y);
            width = Math.round(width);
            height = Math.round(height);
            // TODO: ScissorSystem should cache whether the scissor test is enabled or not.
            this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST);
            this.renderer.gl.scissor(x, y, width, height);
        }
        this.renderer.framebuffer.clear(clearColor[0], clearColor[1], clearColor[2], clearColor[3], mask);
        if (clearMask) // Restore the scissor box
        this.renderer.scissor.pop();
    };
    RenderTextureSystem.prototype.resize = function() {
        // resize the root only!
        this.bind(null);
    };
    /** Resets render-texture state. */ RenderTextureSystem.prototype.reset = function() {
        this.bind(null);
    };
    RenderTextureSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return RenderTextureSystem;
}();
function uboUpdate(_ud, _uv, _renderer, _syncData, buffer) {
    _renderer.buffer.update(buffer);
}
// cv = CachedValue
// v = value
// ud = uniformData
// uv = uniformValue
// l = location
var UBO_TO_SINGLE_SETTERS = {
    float: "\n        data[offset] = v;\n    ",
    vec2: "\n        data[offset] = v[0];\n        data[offset+1] = v[1];\n    ",
    vec3: "\n        data[offset] = v[0];\n        data[offset+1] = v[1];\n        data[offset+2] = v[2];\n\n    ",
    vec4: "\n        data[offset] = v[0];\n        data[offset+1] = v[1];\n        data[offset+2] = v[2];\n        data[offset+3] = v[3];\n    ",
    mat2: "\n        data[offset] = v[0];\n        data[offset+1] = v[1];\n\n        data[offset+4] = v[2];\n        data[offset+5] = v[3];\n    ",
    mat3: "\n        data[offset] = v[0];\n        data[offset+1] = v[1];\n        data[offset+2] = v[2];\n\n        data[offset + 4] = v[3];\n        data[offset + 5] = v[4];\n        data[offset + 6] = v[5];\n\n        data[offset + 8] = v[6];\n        data[offset + 9] = v[7];\n        data[offset + 10] = v[8];\n    ",
    mat4: "\n        for(var i = 0; i < 16; i++)\n        {\n            data[offset + i] = v[i];\n        }\n    "
};
var GLSL_TO_STD40_SIZE = {
    float: 4,
    vec2: 8,
    vec3: 12,
    vec4: 16,
    int: 4,
    ivec2: 8,
    ivec3: 12,
    ivec4: 16,
    uint: 4,
    uvec2: 8,
    uvec3: 12,
    uvec4: 16,
    bool: 4,
    bvec2: 8,
    bvec3: 12,
    bvec4: 16,
    mat2: 32,
    mat3: 48,
    mat4: 64
};
/**
 * @ignore
 *
 * logic originally from here: https://github.com/sketchpunk/FunWithWebGL2/blob/master/lesson_022/Shaders.js
 * rewrote it, but this was a great starting point to get a solid understanding of whats going on :)
 *
 * @param uniformData
 */ function createUBOElements(uniformData) {
    var uboElements = uniformData.map(function(data) {
        return {
            data: data,
            offset: 0,
            dataLen: 0,
            dirty: 0
        };
    });
    var size = 0;
    var chunkSize = 0;
    var offset = 0;
    for(var i = 0; i < uboElements.length; i++){
        var uboElement = uboElements[i];
        size = GLSL_TO_STD40_SIZE[uboElement.data.type];
        if (uboElement.data.size > 1) size = Math.max(size, 16) * uboElement.data.size;
        uboElement.dataLen = size;
        // add some size offset..
        // must align to the nearest 16 bytes or internally nearest round size
        if (chunkSize % size !== 0 && chunkSize < 16) {
            // diff required to line up..
            var lineUpValue = chunkSize % size % 16;
            chunkSize += lineUpValue;
            offset += lineUpValue;
        }
        if (chunkSize + size > 16) {
            offset = Math.ceil(offset / 16) * 16;
            uboElement.offset = offset;
            offset += size;
            chunkSize = size;
        } else {
            uboElement.offset = offset;
            chunkSize += size;
            offset += size;
        }
    }
    offset = Math.ceil(offset / 16) * 16;
    return {
        uboElements: uboElements,
        size: offset
    };
}
function getUBOData(uniforms, uniformData) {
    var usedUniformDatas = [];
    // build..
    for(var i in uniforms)if (uniformData[i]) usedUniformDatas.push(uniformData[i]);
    // sort them out by index!
    usedUniformDatas.sort(function(a, b) {
        return a.index - b.index;
    });
    return usedUniformDatas;
}
function generateUniformBufferSync(group, uniformData) {
    if (!group.autoManage) // if the group is nott automatically managed, we don't need to generate a special function for it...
    return {
        size: 0,
        syncFunc: uboUpdate
    };
    var usedUniformDatas = getUBOData(group.uniforms, uniformData);
    var _a = createUBOElements(usedUniformDatas), uboElements = _a.uboElements, size = _a.size;
    var funcFragments = [
        "\n    var v = null;\n    var v2 = null;\n    var cv = null;\n    var t = 0;\n    var gl = renderer.gl\n    var index = 0;\n    var data = buffer.data;\n    "
    ];
    for(var i = 0; i < uboElements.length; i++){
        var uboElement = uboElements[i];
        var uniform = group.uniforms[uboElement.data.name];
        var name = uboElement.data.name;
        var parsed = false;
        for(var j = 0; j < uniformParsers.length; j++){
            var uniformParser = uniformParsers[j];
            if (uniformParser.codeUbo && uniformParser.test(uboElement.data, uniform)) {
                funcFragments.push("offset = " + uboElement.offset / 4 + ";", uniformParsers[j].codeUbo(uboElement.data.name, uniform));
                parsed = true;
                break;
            }
        }
        if (!parsed) {
            if (uboElement.data.size > 1) {
                var size_1 = mapSize(uboElement.data.type);
                var rowSize = Math.max(GLSL_TO_STD40_SIZE[uboElement.data.type] / 16, 1);
                var elementSize = size_1 / rowSize;
                var remainder = (4 - elementSize % 4) % 4;
                funcFragments.push("\n                cv = ud." + name + ".value;\n                v = uv." + name + ";\n                offset = " + uboElement.offset / 4 + ";\n\n                t = 0;\n\n                for(var i=0; i < " + uboElement.data.size * rowSize + "; i++)\n                {\n                    for(var j = 0; j < " + elementSize + "; j++)\n                    {\n                        data[offset++] = v[t++];\n                    }\n                    offset += " + remainder + ";\n                }\n\n                ");
            } else {
                var template = UBO_TO_SINGLE_SETTERS[uboElement.data.type];
                funcFragments.push("\n                cv = ud." + name + ".value;\n                v = uv." + name + ";\n                offset = " + uboElement.offset / 4 + ";\n                " + template + ";\n                ");
            }
        }
    }
    funcFragments.push("\n       renderer.buffer.update(buffer);\n    ");
    return {
        size: size,
        // eslint-disable-next-line no-new-func
        syncFunc: new Function('ud', 'uv', 'renderer', 'syncData', 'buffer', funcFragments.join('\n'))
    };
}
/**
 * @private
 */ var IGLUniformData = /** @class */ function() {
    function IGLUniformData() {}
    return IGLUniformData;
}();
/**
 * Helper class to create a WebGL Program
 *
 * @class
 * @memberof PIXI
 */ var GLProgram = /** @class */ function() {
    /**
     * Makes a new Pixi program
     *
     * @param {WebGLProgram} program - webgl program
     * @param {Object} uniformData - uniforms
     */ function GLProgram(program, uniformData) {
        /**
         * The shader program
         *
         * @member {WebGLProgram}
         */ this.program = program;
        /**
         * holds the uniform data which contains uniform locations
         * and current uniform values used for caching and preventing unneeded GPU commands
         * @member {Object}
         */ this.uniformData = uniformData;
        /**
         * uniformGroups holds the various upload functions for the shader. Each uniform group
         * and program have a unique upload function generated.
         * @member {Object}
         */ this.uniformGroups = {};
        this.uniformDirtyGroups = {};
        this.uniformBufferBindings = {};
    }
    /**
     * Destroys this program
     */ GLProgram.prototype.destroy = function() {
        this.uniformData = null;
        this.uniformGroups = null;
        this.uniformDirtyGroups = null;
        this.uniformBufferBindings = null;
        this.program = null;
    };
    return GLProgram;
}();
/**
 * returns the attribute data from the program
 * @private
 *
 * @param {WebGLProgram} [program] - the WebGL program
 * @param {WebGLRenderingContext} [gl] - the WebGL context
 *
 * @returns {object} the attribute data for this program
 */ function getAttributeData(program, gl) {
    var attributes = {};
    var totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(var i = 0; i < totalAttributes; i++){
        var attribData = gl.getActiveAttrib(program, i);
        if (attribData.name.indexOf('gl_') === 0) continue;
        var type = mapType(gl, attribData.type);
        var data = {
            type: type,
            name: attribData.name,
            size: mapSize(type),
            location: gl.getAttribLocation(program, attribData.name)
        };
        attributes[attribData.name] = data;
    }
    return attributes;
}
/**
 * returns the uniform data from the program
 * @private
 *
 * @param program - the webgl program
 * @param gl - the WebGL context
 *
 * @returns {object} the uniform data for this program
 */ function getUniformData(program, gl) {
    var uniforms = {};
    var totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
    for(var i = 0; i < totalUniforms; i++){
        var uniformData = gl.getActiveUniform(program, i);
        var name = uniformData.name.replace(/\[.*?\]$/, '');
        var isArray = !!uniformData.name.match(/\[.*?\]$/);
        var type = mapType(gl, uniformData.type);
        uniforms[name] = {
            name: name,
            index: i,
            type: type,
            size: uniformData.size,
            isArray: isArray,
            value: defaultValue(type, uniformData.size)
        };
    }
    return uniforms;
}
/**
 * generates a WebGL Program object from a high level Pixi Program.
 *
 * @param gl - a rendering context on which to generate the program
 * @param program - the high level Pixi Program.
 */ function generateProgram(gl, program) {
    var glVertShader = compileShader(gl, gl.VERTEX_SHADER, program.vertexSrc);
    var glFragShader = compileShader(gl, gl.FRAGMENT_SHADER, program.fragmentSrc);
    var webGLProgram = gl.createProgram();
    gl.attachShader(webGLProgram, glVertShader);
    gl.attachShader(webGLProgram, glFragShader);
    gl.linkProgram(webGLProgram);
    if (!gl.getProgramParameter(webGLProgram, gl.LINK_STATUS)) logProgramError(gl, webGLProgram, glVertShader, glFragShader);
    program.attributeData = getAttributeData(webGLProgram, gl);
    program.uniformData = getUniformData(webGLProgram, gl);
    // GLSL 1.00: bind attributes sorted by name in ascending order
    // GLSL 3.00: don't change the attribute locations that where chosen by the compiler
    //            or assigned by the layout specifier in the shader source code
    if (!/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(program.vertexSrc)) {
        var keys = Object.keys(program.attributeData);
        keys.sort(function(a, b) {
            return a > b ? 1 : -1;
        }); // eslint-disable-line no-confusing-arrow
        for(var i = 0; i < keys.length; i++){
            program.attributeData[keys[i]].location = i;
            gl.bindAttribLocation(webGLProgram, i, keys[i]);
        }
        gl.linkProgram(webGLProgram);
    }
    gl.deleteShader(glVertShader);
    gl.deleteShader(glFragShader);
    var uniformData = {};
    for(var i in program.uniformData){
        var data = program.uniformData[i];
        uniformData[i] = {
            location: gl.getUniformLocation(webGLProgram, i),
            value: defaultValue(data.type, data.size)
        };
    }
    var glProgram = new GLProgram(webGLProgram, uniformData);
    return glProgram;
}
var UID$4 = 0;
// default sync data so we don't create a new one each time!
var defaultSyncData = {
    textureCount: 0,
    uboCount: 0
};
/**
 * System plugin to the renderer to manage shaders.
 *
 * @memberof PIXI
 */ var ShaderSystem = /** @class */ function() {
    /** @param renderer - The renderer this System works for. */ function ShaderSystem(renderer) {
        this.destroyed = false;
        this.renderer = renderer;
        // Validation check that this environment support `new Function`
        this.systemCheck();
        this.gl = null;
        this.shader = null;
        this.program = null;
        this.cache = {};
        this._uboCache = {};
        this.id = UID$4++;
    }
    /**
     * Overrideable function by `@pixi/unsafe-eval` to silence
     * throwing an error if platform doesn't support unsafe-evals.
     *
     * @private
     */ ShaderSystem.prototype.systemCheck = function() {
        if (!unsafeEvalSupported()) throw new Error("Current environment does not allow unsafe-eval, please use @pixi/unsafe-eval module to enable support.");
    };
    ShaderSystem.prototype.contextChange = function(gl) {
        this.gl = gl;
        this.reset();
    };
    /**
     * Changes the current shader to the one given in parameter.
     *
     * @param shader - the new shader
     * @param dontSync - false if the shader should automatically sync its uniforms.
     * @returns the glProgram that belongs to the shader.
     */ ShaderSystem.prototype.bind = function(shader, dontSync) {
        shader.uniforms.globals = this.renderer.globalUniforms;
        var program = shader.program;
        var glProgram = program.glPrograms[this.renderer.CONTEXT_UID] || this.generateProgram(shader);
        this.shader = shader;
        // TODO - some current Pixi plugins bypass this.. so it not safe to use yet..
        if (this.program !== program) {
            this.program = program;
            this.gl.useProgram(glProgram.program);
        }
        if (!dontSync) {
            defaultSyncData.textureCount = 0;
            defaultSyncData.uboCount = 0;
            this.syncUniformGroup(shader.uniformGroup, defaultSyncData);
        }
        return glProgram;
    };
    /**
     * Uploads the uniforms values to the currently bound shader.
     *
     * @param uniforms - the uniforms values that be applied to the current shader
     */ ShaderSystem.prototype.setUniforms = function(uniforms) {
        var shader = this.shader.program;
        var glProgram = shader.glPrograms[this.renderer.CONTEXT_UID];
        shader.syncUniforms(glProgram.uniformData, uniforms, this.renderer);
    };
    /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
     * Syncs uniforms on the group
     *
     * @param group - the uniform group to sync
     * @param syncData - this is data that is passed to the sync function and any nested sync functions
     */ ShaderSystem.prototype.syncUniformGroup = function(group, syncData) {
        var glProgram = this.getGlProgram();
        if (!group.static || group.dirtyId !== glProgram.uniformDirtyGroups[group.id]) {
            glProgram.uniformDirtyGroups[group.id] = group.dirtyId;
            this.syncUniforms(group, glProgram, syncData);
        }
    };
    /**
     * Overrideable by the @pixi/unsafe-eval package to use static syncUniforms instead.
     */ ShaderSystem.prototype.syncUniforms = function(group, glProgram, syncData) {
        var syncFunc = group.syncUniforms[this.shader.program.id] || this.createSyncGroups(group);
        syncFunc(glProgram.uniformData, group.uniforms, this.renderer, syncData);
    };
    ShaderSystem.prototype.createSyncGroups = function(group) {
        var id = this.getSignature(group, this.shader.program.uniformData, 'u');
        if (!this.cache[id]) this.cache[id] = generateUniformsSync(group, this.shader.program.uniformData);
        group.syncUniforms[this.shader.program.id] = this.cache[id];
        return group.syncUniforms[this.shader.program.id];
    };
    /**
     * Syncs uniform buffers
     *
     * @param group - the uniform buffer group to sync
     * @param name - the name of the uniform buffer
     */ ShaderSystem.prototype.syncUniformBufferGroup = function(group, name) {
        var glProgram = this.getGlProgram();
        if (!group.static || group.dirtyId !== 0 || !glProgram.uniformGroups[group.id]) {
            group.dirtyId = 0;
            var syncFunc = glProgram.uniformGroups[group.id] || this.createSyncBufferGroup(group, glProgram, name);
            // TODO wrap update in a cache??
            group.buffer.update();
            syncFunc(glProgram.uniformData, group.uniforms, this.renderer, defaultSyncData, group.buffer);
        }
        this.renderer.buffer.bindBufferBase(group.buffer, glProgram.uniformBufferBindings[name]);
    };
    /**
     * Will create a function that uploads a uniform buffer using the STD140 standard.
     * The upload function will then be cached for future calls
     * If a group is manually managed, then a simple upload function is generated
     *
     * @param group - the uniform buffer group to sync
     * @param glProgram - the gl program to attach the uniform bindings to
     * @param name - the name of the uniform buffer (must exist on the shader)
     */ ShaderSystem.prototype.createSyncBufferGroup = function(group, glProgram, name) {
        var gl = this.renderer.gl;
        this.renderer.buffer.bind(group.buffer);
        // bind them...
        var uniformBlockIndex = this.gl.getUniformBlockIndex(glProgram.program, name);
        glProgram.uniformBufferBindings[name] = this.shader.uniformBindCount;
        gl.uniformBlockBinding(glProgram.program, uniformBlockIndex, this.shader.uniformBindCount);
        this.shader.uniformBindCount++;
        var id = this.getSignature(group, this.shader.program.uniformData, 'ubo');
        var uboData = this._uboCache[id];
        if (!uboData) uboData = this._uboCache[id] = generateUniformBufferSync(group, this.shader.program.uniformData);
        if (group.autoManage) {
            var data = new Float32Array(uboData.size / 4);
            group.buffer.update(data);
        }
        glProgram.uniformGroups[group.id] = uboData.syncFunc;
        return glProgram.uniformGroups[group.id];
    };
    /**
     * Takes a uniform group and data and generates a unique signature for them.
     *
     * @param group - The uniform group to get signature of
     * @param uniformData - Uniform information generated by the shader
     * @returns Unique signature of the uniform group
     */ ShaderSystem.prototype.getSignature = function(group, uniformData, preFix) {
        var uniforms = group.uniforms;
        var strings = [
            preFix + "-"
        ];
        for(var i in uniforms){
            strings.push(i);
            if (uniformData[i]) strings.push(uniformData[i].type);
        }
        return strings.join('-');
    };
    /**
     * Returns the underlying GLShade rof the currently bound shader.
     *
     * This can be handy for when you to have a little more control over the setting of your uniforms.
     *
     * @return The glProgram for the currently bound Shader for this context
     */ ShaderSystem.prototype.getGlProgram = function() {
        if (this.shader) return this.shader.program.glPrograms[this.renderer.CONTEXT_UID];
        return null;
    };
    /**
     * Generates a glProgram version of the Shader provided.
     *
     * @param shader - The shader that the glProgram will be based on.
     * @return A shiny new glProgram!
     */ ShaderSystem.prototype.generateProgram = function(shader) {
        var gl = this.gl;
        var program = shader.program;
        var glProgram = generateProgram(gl, program);
        program.glPrograms[this.renderer.CONTEXT_UID] = glProgram;
        return glProgram;
    };
    /** Resets ShaderSystem state, does not affect WebGL state. */ ShaderSystem.prototype.reset = function() {
        this.program = null;
        this.shader = null;
    };
    /** Destroys this System and removes all its textures. */ ShaderSystem.prototype.destroy = function() {
        this.renderer = null;
        // TODO implement destroy method for ShaderSystem
        this.destroyed = true;
    };
    return ShaderSystem;
}();
/**
 * Maps gl blend combinations to WebGL.
 *
 * @memberof PIXI
 * @function mapWebGLBlendModesToPixi
 * @private
 * @param {WebGLRenderingContext} gl - The rendering context.
 * @param {number[][]} [array=[]] - The array to output into.
 * @return {number[][]} Mapped modes.
 */ function mapWebGLBlendModesToPixi(gl, array) {
    if (array === void 0) array = [];
    // TODO - premultiply alpha would be different.
    // add a boolean for that!
    array[(0, $P8XPi.BLEND_MODES).NORMAL] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).ADD] = [
        gl.ONE,
        gl.ONE
    ];
    array[(0, $P8XPi.BLEND_MODES).MULTIPLY] = [
        gl.DST_COLOR,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).SCREEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).OVERLAY] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).DARKEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).LIGHTEN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).COLOR_DODGE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).COLOR_BURN] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).HARD_LIGHT] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).SOFT_LIGHT] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).DIFFERENCE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).EXCLUSION] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).HUE] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).SATURATION] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).COLOR] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).LUMINOSITY] = [
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).NONE] = [
        0,
        0
    ];
    // not-premultiplied blend modes
    array[(0, $P8XPi.BLEND_MODES).NORMAL_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).ADD_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE,
        gl.ONE,
        gl.ONE
    ];
    array[(0, $P8XPi.BLEND_MODES).SCREEN_NPM] = [
        gl.SRC_ALPHA,
        gl.ONE_MINUS_SRC_COLOR,
        gl.ONE,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    // composite operations
    array[(0, $P8XPi.BLEND_MODES).SRC_IN] = [
        gl.DST_ALPHA,
        gl.ZERO
    ];
    array[(0, $P8XPi.BLEND_MODES).SRC_OUT] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ZERO
    ];
    array[(0, $P8XPi.BLEND_MODES).SRC_ATOP] = [
        gl.DST_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).DST_OVER] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ONE
    ];
    array[(0, $P8XPi.BLEND_MODES).DST_IN] = [
        gl.ZERO,
        gl.SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).DST_OUT] = [
        gl.ZERO,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).DST_ATOP] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.SRC_ALPHA
    ];
    array[(0, $P8XPi.BLEND_MODES).XOR] = [
        gl.ONE_MINUS_DST_ALPHA,
        gl.ONE_MINUS_SRC_ALPHA
    ];
    // SUBTRACT from flash
    array[(0, $P8XPi.BLEND_MODES).SUBTRACT] = [
        gl.ONE,
        gl.ONE,
        gl.ONE,
        gl.ONE,
        gl.FUNC_REVERSE_SUBTRACT,
        gl.FUNC_ADD
    ];
    return array;
}
var BLEND$1 = 0;
var OFFSET$1 = 1;
var CULLING$1 = 2;
var DEPTH_TEST$1 = 3;
var WINDING$1 = 4;
var DEPTH_MASK$1 = 5;
/**
 * System plugin to the renderer to manage WebGL state machines.
 *
 * @memberof PIXI
 */ var StateSystem = /** @class */ function() {
    function StateSystem() {
        this.gl = null;
        this.stateId = 0;
        this.polygonOffset = 0;
        this.blendMode = (0, $P8XPi.BLEND_MODES).NONE;
        this._blendEq = false;
        // map functions for when we set state..
        this.map = [];
        this.map[BLEND$1] = this.setBlend;
        this.map[OFFSET$1] = this.setOffset;
        this.map[CULLING$1] = this.setCullFace;
        this.map[DEPTH_TEST$1] = this.setDepthTest;
        this.map[WINDING$1] = this.setFrontFace;
        this.map[DEPTH_MASK$1] = this.setDepthMask;
        this.checks = [];
        this.defaultState = new State();
        this.defaultState.blend = true;
    }
    StateSystem.prototype.contextChange = function(gl) {
        this.gl = gl;
        this.blendModes = mapWebGLBlendModesToPixi(gl);
        this.set(this.defaultState);
        this.reset();
    };
    /**
     * Sets the current state
     *
     * @param {*} state - The state to set.
     */ StateSystem.prototype.set = function(state) {
        state = state || this.defaultState;
        // TODO maybe to an object check? ( this.state === state )?
        if (this.stateId !== state.data) {
            var diff = this.stateId ^ state.data;
            var i = 0;
            // order from least to most common
            while(diff){
                if (diff & 1) // state change!
                this.map[i].call(this, !!(state.data & 1 << i));
                diff = diff >> 1;
                i++;
            }
            this.stateId = state.data;
        }
        // based on the above settings we check for specific modes..
        // for example if blend is active we check and set the blend modes
        // or of polygon offset is active we check the poly depth.
        for(var i = 0; i < this.checks.length; i++)this.checks[i](this, state);
    };
    /**
     * Sets the state, when previous state is unknown.
     *
     * @param {*} state - The state to set
     */ StateSystem.prototype.forceState = function(state) {
        state = state || this.defaultState;
        for(var i = 0; i < this.map.length; i++)this.map[i].call(this, !!(state.data & 1 << i));
        for(var i = 0; i < this.checks.length; i++)this.checks[i](this, state);
        this.stateId = state.data;
    };
    /**
     * Sets whether to enable or disable blending.
     *
     * @param value - Turn on or off WebGl blending.
     */ StateSystem.prototype.setBlend = function(value) {
        this.updateCheck(StateSystem.checkBlendMode, value);
        this.gl[value ? 'enable' : 'disable'](this.gl.BLEND);
    };
    /**
     * Sets whether to enable or disable polygon offset fill.
     *
     * @param value - Turn on or off webgl polygon offset testing.
     */ StateSystem.prototype.setOffset = function(value) {
        this.updateCheck(StateSystem.checkPolygonOffset, value);
        this.gl[value ? 'enable' : 'disable'](this.gl.POLYGON_OFFSET_FILL);
    };
    /**
     * Sets whether to enable or disable depth test.
     *
     * @param value - Turn on or off webgl depth testing.
     */ StateSystem.prototype.setDepthTest = function(value) {
        this.gl[value ? 'enable' : 'disable'](this.gl.DEPTH_TEST);
    };
    /**
     * Sets whether to enable or disable depth mask.
     *
     * @param value - Turn on or off webgl depth mask.
     */ StateSystem.prototype.setDepthMask = function(value) {
        this.gl.depthMask(value);
    };
    /**
     * Sets whether to enable or disable cull face.
     *
     * @param {boolean} value - Turn on or off webgl cull face.
     */ StateSystem.prototype.setCullFace = function(value) {
        this.gl[value ? 'enable' : 'disable'](this.gl.CULL_FACE);
    };
    /**
     * Sets the gl front face.
     *
     * @param {boolean} value - true is clockwise and false is counter-clockwise
     */ StateSystem.prototype.setFrontFace = function(value) {
        this.gl.frontFace(this.gl[value ? 'CW' : 'CCW']);
    };
    /**
     * Sets the blend mode.
     *
     * @param {number} value - The blend mode to set to.
     */ StateSystem.prototype.setBlendMode = function(value) {
        if (value === this.blendMode) return;
        this.blendMode = value;
        var mode = this.blendModes[value];
        var gl = this.gl;
        if (mode.length === 2) gl.blendFunc(mode[0], mode[1]);
        else gl.blendFuncSeparate(mode[0], mode[1], mode[2], mode[3]);
        if (mode.length === 6) {
            this._blendEq = true;
            gl.blendEquationSeparate(mode[4], mode[5]);
        } else if (this._blendEq) {
            this._blendEq = false;
            gl.blendEquationSeparate(gl.FUNC_ADD, gl.FUNC_ADD);
        }
    };
    /**
     * Sets the polygon offset.
     *
     * @param {number} value - the polygon offset
     * @param {number} scale - the polygon offset scale
     */ StateSystem.prototype.setPolygonOffset = function(value, scale) {
        this.gl.polygonOffset(value, scale);
    };
    // used
    /** Resets all the logic and disables the VAOs. */ StateSystem.prototype.reset = function() {
        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
        this.forceState(this.defaultState);
        this._blendEq = true;
        this.blendMode = -1;
        this.setBlendMode(0);
    };
    /**
     * Checks to see which updates should be checked based on which settings have been activated.
     *
     * For example, if blend is enabled then we should check the blend modes each time the state is changed
     * or if polygon fill is activated then we need to check if the polygon offset changes.
     * The idea is that we only check what we have too.
     *
     * @param func - the checking function to add or remove
     * @param value - should the check function be added or removed.
     */ StateSystem.prototype.updateCheck = function(func, value) {
        var index = this.checks.indexOf(func);
        if (value && index === -1) this.checks.push(func);
        else if (!value && index !== -1) this.checks.splice(index, 1);
    };
    /**
     * A private little wrapper function that we call to check the blend mode.
     *
     * @param System - the System to perform the state check on
     * @param state - the state that the blendMode will pulled from
     */ StateSystem.checkBlendMode = function(system, state) {
        system.setBlendMode(state.blendMode);
    };
    /**
     * A private little wrapper function that we call to check the polygon offset.
     *
     * @param System - the System to perform the state check on
     * @param state - the state that the blendMode will pulled from
     */ StateSystem.checkPolygonOffset = function(system, state) {
        system.setPolygonOffset(1, state.polygonOffset);
    };
    /**
     * @ignore
     */ StateSystem.prototype.destroy = function() {
        this.gl = null;
    };
    return StateSystem;
}();
/**
 * System plugin to the renderer to manage texture garbage collection on the GPU,
 * ensuring that it does not get clogged up with textures that are no longer being used.
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.System
 */ var TextureGCSystem = /** @class */ function() {
    /**
     * @param {PIXI.Renderer} renderer - The renderer this System works for.
     */ function TextureGCSystem(renderer) {
        this.renderer = renderer;
        /**
         * Count
         * @member {number}
         * @readonly
         */ this.count = 0;
        /**
         * Check count
         * @member {number}
         * @readonly
         */ this.checkCount = 0;
        /**
         * Maximum idle time, in seconds
         * @member {number}
         * @see PIXI.settings.GC_MAX_IDLE
         */ this.maxIdle = (0, $ezJmd.settings).GC_MAX_IDLE;
        /**
         * Maximum number of item to check
         * @member {number}
         * @see PIXI.settings.GC_MAX_CHECK_COUNT
         */ this.checkCountMax = (0, $ezJmd.settings).GC_MAX_CHECK_COUNT;
        /**
         * Current garbage collection mode
         * @member {PIXI.GC_MODES}
         * @see PIXI.settings.GC_MODE
         */ this.mode = (0, $ezJmd.settings).GC_MODE;
    }
    /**
     * Checks to see when the last time a texture was used
     * if the texture has not been used for a specified amount of time it will be removed from the GPU
     */ TextureGCSystem.prototype.postrender = function() {
        if (!this.renderer.renderingToScreen) return;
        this.count++;
        if (this.mode === (0, $P8XPi.GC_MODES).MANUAL) return;
        this.checkCount++;
        if (this.checkCount > this.checkCountMax) {
            this.checkCount = 0;
            this.run();
        }
    };
    /**
     * Checks to see when the last time a texture was used
     * if the texture has not been used for a specified amount of time it will be removed from the GPU
     */ TextureGCSystem.prototype.run = function() {
        var tm = this.renderer.texture;
        var managedTextures = tm.managedTextures;
        var wasRemoved = false;
        for(var i = 0; i < managedTextures.length; i++){
            var texture = managedTextures[i];
            // only supports non generated textures at the moment!
            if (!texture.framebuffer && this.count - texture.touched > this.maxIdle) {
                tm.destroyTexture(texture, true);
                managedTextures[i] = null;
                wasRemoved = true;
            }
        }
        if (wasRemoved) {
            var j = 0;
            for(var i = 0; i < managedTextures.length; i++)if (managedTextures[i] !== null) managedTextures[j++] = managedTextures[i];
            managedTextures.length = j;
        }
    };
    /**
     * Removes all the textures within the specified displayObject and its children from the GPU
     *
     * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
     */ TextureGCSystem.prototype.unload = function(displayObject) {
        var tm = this.renderer.texture;
        var texture = displayObject._texture;
        // only destroy non generated textures
        if (texture && !texture.framebuffer) tm.destroyTexture(texture);
        for(var i = displayObject.children.length - 1; i >= 0; i--)this.unload(displayObject.children[i]);
    };
    /**
     * @ignore
     */ TextureGCSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return TextureGCSystem;
}();
/**
 * Returns a lookup table that maps each type-format pair to a compatible internal format.
 *
 * @memberof PIXI
 * @function mapTypeAndFormatToInternalFormat
 * @private
 * @param {WebGLRenderingContext} gl - The rendering context.
 * @return {{ [type: number]: { [format: number]: number } }} Lookup table.
 */ function mapTypeAndFormatToInternalFormat(gl) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var table;
    if ('WebGL2RenderingContext' in self && gl instanceof self.WebGL2RenderingContext) table = (_a = {}, _a[(0, $P8XPi.TYPES).UNSIGNED_BYTE] = (_b = {}, _b[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA8, _b[(0, $P8XPi.FORMATS).RGB] = gl.RGB8, _b[(0, $P8XPi.FORMATS).RG] = gl.RG8, _b[(0, $P8XPi.FORMATS).RED] = gl.R8, _b[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGBA8UI, _b[(0, $P8XPi.FORMATS).RGB_INTEGER] = gl.RGB8UI, _b[(0, $P8XPi.FORMATS).RG_INTEGER] = gl.RG8UI, _b[(0, $P8XPi.FORMATS).RED_INTEGER] = gl.R8UI, _b[(0, $P8XPi.FORMATS).ALPHA] = gl.ALPHA, _b[(0, $P8XPi.FORMATS).LUMINANCE] = gl.LUMINANCE, _b[(0, $P8XPi.FORMATS).LUMINANCE_ALPHA] = gl.LUMINANCE_ALPHA, _b), _a[(0, $P8XPi.TYPES).BYTE] = (_c = {}, _c[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA8_SNORM, _c[(0, $P8XPi.FORMATS).RGB] = gl.RGB8_SNORM, _c[(0, $P8XPi.FORMATS).RG] = gl.RG8_SNORM, _c[(0, $P8XPi.FORMATS).RED] = gl.R8_SNORM, _c[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGBA8I, _c[(0, $P8XPi.FORMATS).RGB_INTEGER] = gl.RGB8I, _c[(0, $P8XPi.FORMATS).RG_INTEGER] = gl.RG8I, _c[(0, $P8XPi.FORMATS).RED_INTEGER] = gl.R8I, _c), _a[(0, $P8XPi.TYPES).UNSIGNED_SHORT] = (_d = {}, _d[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGBA16UI, _d[(0, $P8XPi.FORMATS).RGB_INTEGER] = gl.RGB16UI, _d[(0, $P8XPi.FORMATS).RG_INTEGER] = gl.RG16UI, _d[(0, $P8XPi.FORMATS).RED_INTEGER] = gl.R16UI, _d[(0, $P8XPi.FORMATS).DEPTH_COMPONENT] = gl.DEPTH_COMPONENT16, _d), _a[(0, $P8XPi.TYPES).SHORT] = (_e = {}, _e[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGBA16I, _e[(0, $P8XPi.FORMATS).RGB_INTEGER] = gl.RGB16I, _e[(0, $P8XPi.FORMATS).RG_INTEGER] = gl.RG16I, _e[(0, $P8XPi.FORMATS).RED_INTEGER] = gl.R16I, _e), _a[(0, $P8XPi.TYPES).UNSIGNED_INT] = (_f = {}, _f[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGBA32UI, _f[(0, $P8XPi.FORMATS).RGB_INTEGER] = gl.RGB32UI, _f[(0, $P8XPi.FORMATS).RG_INTEGER] = gl.RG32UI, _f[(0, $P8XPi.FORMATS).RED_INTEGER] = gl.R32UI, _f[(0, $P8XPi.FORMATS).DEPTH_COMPONENT] = gl.DEPTH_COMPONENT24, _f), _a[(0, $P8XPi.TYPES).INT] = (_g = {}, _g[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGBA32I, _g[(0, $P8XPi.FORMATS).RGB_INTEGER] = gl.RGB32I, _g[(0, $P8XPi.FORMATS).RG_INTEGER] = gl.RG32I, _g[(0, $P8XPi.FORMATS).RED_INTEGER] = gl.R32I, _g), _a[(0, $P8XPi.TYPES).FLOAT] = (_h = {}, _h[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA32F, _h[(0, $P8XPi.FORMATS).RGB] = gl.RGB32F, _h[(0, $P8XPi.FORMATS).RG] = gl.RG32F, _h[(0, $P8XPi.FORMATS).RED] = gl.R32F, _h[(0, $P8XPi.FORMATS).DEPTH_COMPONENT] = gl.DEPTH_COMPONENT32F, _h), _a[(0, $P8XPi.TYPES).HALF_FLOAT] = (_j = {}, _j[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA16F, _j[(0, $P8XPi.FORMATS).RGB] = gl.RGB16F, _j[(0, $P8XPi.FORMATS).RG] = gl.RG16F, _j[(0, $P8XPi.FORMATS).RED] = gl.R16F, _j), _a[(0, $P8XPi.TYPES).UNSIGNED_SHORT_5_6_5] = (_k = {}, _k[(0, $P8XPi.FORMATS).RGB] = gl.RGB565, _k), _a[(0, $P8XPi.TYPES).UNSIGNED_SHORT_4_4_4_4] = (_l = {}, _l[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA4, _l), _a[(0, $P8XPi.TYPES).UNSIGNED_SHORT_5_5_5_1] = (_m = {}, _m[(0, $P8XPi.FORMATS).RGBA] = gl.RGB5_A1, _m), _a[(0, $P8XPi.TYPES).UNSIGNED_INT_2_10_10_10_REV] = (_o = {}, _o[(0, $P8XPi.FORMATS).RGBA] = gl.RGB10_A2, _o[(0, $P8XPi.FORMATS).RGBA_INTEGER] = gl.RGB10_A2UI, _o), _a[(0, $P8XPi.TYPES).UNSIGNED_INT_10F_11F_11F_REV] = (_p = {}, _p[(0, $P8XPi.FORMATS).RGB] = gl.R11F_G11F_B10F, _p), _a[(0, $P8XPi.TYPES).UNSIGNED_INT_5_9_9_9_REV] = (_q = {}, _q[(0, $P8XPi.FORMATS).RGB] = gl.RGB9_E5, _q), _a[(0, $P8XPi.TYPES).UNSIGNED_INT_24_8] = (_r = {}, _r[(0, $P8XPi.FORMATS).DEPTH_STENCIL] = gl.DEPTH24_STENCIL8, _r), _a[(0, $P8XPi.TYPES).FLOAT_32_UNSIGNED_INT_24_8_REV] = (_s = {}, _s[(0, $P8XPi.FORMATS).DEPTH_STENCIL] = gl.DEPTH32F_STENCIL8, _s), _a);
    else table = (_t = {}, _t[(0, $P8XPi.TYPES).UNSIGNED_BYTE] = (_u = {}, _u[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA, _u[(0, $P8XPi.FORMATS).RGB] = gl.RGB, _u[(0, $P8XPi.FORMATS).ALPHA] = gl.ALPHA, _u[(0, $P8XPi.FORMATS).LUMINANCE] = gl.LUMINANCE, _u[(0, $P8XPi.FORMATS).LUMINANCE_ALPHA] = gl.LUMINANCE_ALPHA, _u), _t[(0, $P8XPi.TYPES).UNSIGNED_SHORT_5_6_5] = (_v = {}, _v[(0, $P8XPi.FORMATS).RGB] = gl.RGB, _v), _t[(0, $P8XPi.TYPES).UNSIGNED_SHORT_4_4_4_4] = (_w = {}, _w[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA, _w), _t[(0, $P8XPi.TYPES).UNSIGNED_SHORT_5_5_5_1] = (_x = {}, _x[(0, $P8XPi.FORMATS).RGBA] = gl.RGBA, _x), _t);
    return table;
}
/**
 * Internal texture for WebGL context
 * @class
 * @memberof PIXI
 */ var GLTexture = /** @class */ function() {
    function GLTexture(texture) {
        /**
         * The WebGL texture
         * @member {WebGLTexture}
         */ this.texture = texture;
        /**
         * Width of texture that was used in texImage2D
         * @member {number}
         */ this.width = -1;
        /**
         * Height of texture that was used in texImage2D
         * @member {number}
         */ this.height = -1;
        /**
         * Texture contents dirty flag
         * @member {number}
         */ this.dirtyId = -1;
        /**
         * Texture style dirty flag
         * @member {number}
         */ this.dirtyStyleId = -1;
        /**
         * Whether mip levels has to be generated
         * @member {boolean}
         */ this.mipmap = false;
        /**
         * WrapMode copied from baseTexture
         * @member {number}
         */ this.wrapMode = 33071;
        /**
         * Type copied from baseTexture
         * @member {number}
         */ this.type = (0, $P8XPi.TYPES).UNSIGNED_BYTE;
        /**
         * Type copied from baseTexture
         * @member {number}
         */ this.internalFormat = (0, $P8XPi.FORMATS).RGBA;
        this.samplerType = 0;
    }
    return GLTexture;
}();
/**
 * System plugin to the renderer to manage textures.
 *
 * @class
 * @extends PIXI.System
 * @memberof PIXI
 */ var TextureSystem = /** @class */ function() {
    /**
     * @param {PIXI.Renderer} renderer - The renderer this System works for.
     */ function TextureSystem(renderer) {
        this.renderer = renderer;
        // TODO set to max textures...
        /**
         * Bound textures
         * @member {PIXI.BaseTexture[]}
         * @readonly
         */ this.boundTextures = [];
        /**
         * Current location
         * @member {number}
         * @readonly
         */ this.currentLocation = -1;
        /**
         * List of managed textures
         * @member {PIXI.BaseTexture[]}
         * @readonly
         */ this.managedTextures = [];
        /**
         * Did someone temper with textures state? We'll overwrite them when we need to unbind something.
         * @member {boolean}
         * @private
         */ this._unknownBoundTextures = false;
        /**
         * BaseTexture value that shows that we don't know what is bound
         * @member {PIXI.BaseTexture}
         * @readonly
         */ this.unknownTexture = new BaseTexture();
        this.hasIntegerTextures = false;
    }
    /**
     * Sets up the renderer context and necessary buffers.
     */ TextureSystem.prototype.contextChange = function() {
        var gl = this.gl = this.renderer.gl;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
        this.webGLVersion = this.renderer.context.webGLVersion;
        this.internalFormats = mapTypeAndFormatToInternalFormat(gl);
        var maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
        this.boundTextures.length = maxTextures;
        for(var i = 0; i < maxTextures; i++)this.boundTextures[i] = null;
        // TODO move this.. to a nice make empty textures class..
        this.emptyTextures = {};
        var emptyTexture2D = new GLTexture(gl.createTexture());
        gl.bindTexture(gl.TEXTURE_2D, emptyTexture2D.texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array(4));
        this.emptyTextures[gl.TEXTURE_2D] = emptyTexture2D;
        this.emptyTextures[gl.TEXTURE_CUBE_MAP] = new GLTexture(gl.createTexture());
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.emptyTextures[gl.TEXTURE_CUBE_MAP].texture);
        for(var i = 0; i < 6; i++)gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        for(var i = 0; i < this.boundTextures.length; i++)this.bind(null, i);
    };
    /**
     * Bind a texture to a specific location
     *
     * If you want to unbind something, please use `unbind(texture)` instead of `bind(null, textureLocation)`
     *
     * @param {PIXI.Texture|PIXI.BaseTexture} texture_ - Texture to bind
     * @param {number} [location=0] - Location to bind at
     */ TextureSystem.prototype.bind = function(texture, location) {
        if (location === void 0) location = 0;
        var gl = this.gl;
        texture = texture === null || texture === void 0 ? void 0 : texture.castToBaseTexture();
        // cannot bind partial texture
        // TODO: report a warning
        if (texture && texture.valid && !texture.parentTextureArray) {
            texture.touched = this.renderer.textureGC.count;
            var glTexture = texture._glTextures[this.CONTEXT_UID] || this.initTexture(texture);
            if (this.boundTextures[location] !== texture) {
                if (this.currentLocation !== location) {
                    this.currentLocation = location;
                    gl.activeTexture(gl.TEXTURE0 + location);
                }
                gl.bindTexture(texture.target, glTexture.texture);
            }
            if (glTexture.dirtyId !== texture.dirtyId) {
                if (this.currentLocation !== location) {
                    this.currentLocation = location;
                    gl.activeTexture(gl.TEXTURE0 + location);
                }
                this.updateTexture(texture);
            }
            this.boundTextures[location] = texture;
        } else {
            if (this.currentLocation !== location) {
                this.currentLocation = location;
                gl.activeTexture(gl.TEXTURE0 + location);
            }
            gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[gl.TEXTURE_2D].texture);
            this.boundTextures[location] = null;
        }
    };
    /**
     * Resets texture location and bound textures
     *
     * Actual `bind(null, i)` calls will be performed at next `unbind()` call
     */ TextureSystem.prototype.reset = function() {
        this._unknownBoundTextures = true;
        this.hasIntegerTextures = false;
        this.currentLocation = -1;
        for(var i = 0; i < this.boundTextures.length; i++)this.boundTextures[i] = this.unknownTexture;
    };
    /**
     * Unbind a texture
     * @param {PIXI.BaseTexture} texture - Texture to bind
     */ TextureSystem.prototype.unbind = function(texture) {
        var _a = this, gl = _a.gl, boundTextures = _a.boundTextures;
        if (this._unknownBoundTextures) {
            this._unknownBoundTextures = false;
            // someone changed webGL state,
            // we have to be sure that our texture does not appear in multi-texture renderer samplers
            for(var i = 0; i < boundTextures.length; i++)if (boundTextures[i] === this.unknownTexture) this.bind(null, i);
        }
        for(var i = 0; i < boundTextures.length; i++)if (boundTextures[i] === texture) {
            if (this.currentLocation !== i) {
                gl.activeTexture(gl.TEXTURE0 + i);
                this.currentLocation = i;
            }
            gl.bindTexture(texture.target, this.emptyTextures[texture.target].texture);
            boundTextures[i] = null;
        }
    };
    /**
     * Ensures that current boundTextures all have FLOAT sampler type,
     * see {@link PIXI.SAMPLER_TYPES} for explanation.
     *
     * @param maxTextures - number of locations to check
     */ TextureSystem.prototype.ensureSamplerType = function(maxTextures) {
        var _a = this, boundTextures = _a.boundTextures, hasIntegerTextures = _a.hasIntegerTextures, CONTEXT_UID = _a.CONTEXT_UID;
        if (!hasIntegerTextures) return;
        for(var i = maxTextures - 1; i >= 0; --i){
            var tex = boundTextures[i];
            if (tex) {
                var glTexture = tex._glTextures[CONTEXT_UID];
                if (glTexture.samplerType !== (0, $P8XPi.SAMPLER_TYPES).FLOAT) this.renderer.texture.unbind(tex);
            }
        }
    };
    /**
     * Initialize a texture
     *
     * @private
     * @param {PIXI.BaseTexture} texture - Texture to initialize
     */ TextureSystem.prototype.initTexture = function(texture) {
        var glTexture = new GLTexture(this.gl.createTexture());
        // guarantee an update..
        glTexture.dirtyId = -1;
        texture._glTextures[this.CONTEXT_UID] = glTexture;
        this.managedTextures.push(texture);
        texture.on('dispose', this.destroyTexture, this);
        return glTexture;
    };
    TextureSystem.prototype.initTextureType = function(texture, glTexture) {
        var _a, _b;
        glTexture.internalFormat = (_b = (_a = this.internalFormats[texture.type]) === null || _a === void 0 ? void 0 : _a[texture.format]) !== null && _b !== void 0 ? _b : texture.format;
        if (this.webGLVersion === 2 && texture.type === (0, $P8XPi.TYPES).HALF_FLOAT) // TYPES.HALF_FLOAT is WebGL1 HALF_FLOAT_OES
        // we have to convert it to WebGL HALF_FLOAT
        glTexture.type = this.gl.HALF_FLOAT;
        else glTexture.type = texture.type;
    };
    /**
     * Update a texture
     *
     * @private
     * @param {PIXI.BaseTexture} texture - Texture to initialize
     */ TextureSystem.prototype.updateTexture = function(texture) {
        var glTexture = texture._glTextures[this.CONTEXT_UID];
        if (!glTexture) return;
        var renderer = this.renderer;
        this.initTextureType(texture, glTexture);
        if (texture.resource && texture.resource.upload(renderer, texture, glTexture)) // texture is uploaded, dont do anything!
        {
            if (glTexture.samplerType !== (0, $P8XPi.SAMPLER_TYPES).FLOAT) this.hasIntegerTextures = true;
        } else {
            // default, renderTexture-like logic
            var width = texture.realWidth;
            var height = texture.realHeight;
            var gl = renderer.gl;
            if (glTexture.width !== width || glTexture.height !== height || glTexture.dirtyId < 0) {
                glTexture.width = width;
                glTexture.height = height;
                gl.texImage2D(texture.target, 0, glTexture.internalFormat, width, height, 0, texture.format, glTexture.type, null);
            }
        }
        // lets only update what changes..
        if (texture.dirtyStyleId !== glTexture.dirtyStyleId) this.updateTextureStyle(texture);
        glTexture.dirtyId = texture.dirtyId;
    };
    /**
     * Deletes the texture from WebGL
     *
     * @private
     * @param {PIXI.BaseTexture|PIXI.Texture} texture_ - the texture to destroy
     * @param {boolean} [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
     */ TextureSystem.prototype.destroyTexture = function(texture, skipRemove) {
        var gl = this.gl;
        texture = texture.castToBaseTexture();
        if (texture._glTextures[this.CONTEXT_UID]) {
            this.unbind(texture);
            gl.deleteTexture(texture._glTextures[this.CONTEXT_UID].texture);
            texture.off('dispose', this.destroyTexture, this);
            delete texture._glTextures[this.CONTEXT_UID];
            if (!skipRemove) {
                var i = this.managedTextures.indexOf(texture);
                if (i !== -1) (0, $csytw.removeItems)(this.managedTextures, i, 1);
            }
        }
    };
    /**
     * Update texture style such as mipmap flag
     *
     * @private
     * @param {PIXI.BaseTexture} texture - Texture to update
     */ TextureSystem.prototype.updateTextureStyle = function(texture) {
        var glTexture = texture._glTextures[this.CONTEXT_UID];
        if (!glTexture) return;
        if ((texture.mipmap === (0, $P8XPi.MIPMAP_MODES).POW2 || this.webGLVersion !== 2) && !texture.isPowerOfTwo) glTexture.mipmap = false;
        else glTexture.mipmap = texture.mipmap >= 1;
        if (this.webGLVersion !== 2 && !texture.isPowerOfTwo) glTexture.wrapMode = (0, $P8XPi.WRAP_MODES).CLAMP;
        else glTexture.wrapMode = texture.wrapMode;
        if (texture.resource && texture.resource.style(this.renderer, texture, glTexture)) ;
        else this.setStyle(texture, glTexture);
        glTexture.dirtyStyleId = texture.dirtyStyleId;
    };
    /**
     * Set style for texture
     *
     * @private
     * @param {PIXI.BaseTexture} texture - Texture to update
     * @param {PIXI.GLTexture} glTexture
     */ TextureSystem.prototype.setStyle = function(texture, glTexture) {
        var gl = this.gl;
        if (glTexture.mipmap && texture.mipmap !== (0, $P8XPi.MIPMAP_MODES).ON_MANUAL) gl.generateMipmap(texture.target);
        gl.texParameteri(texture.target, gl.TEXTURE_WRAP_S, glTexture.wrapMode);
        gl.texParameteri(texture.target, gl.TEXTURE_WRAP_T, glTexture.wrapMode);
        if (glTexture.mipmap) {
            /* eslint-disable max-len */ gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === (0, $P8XPi.SCALE_MODES).LINEAR ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
            /* eslint-disable max-len */ var anisotropicExt = this.renderer.context.extensions.anisotropicFiltering;
            if (anisotropicExt && texture.anisotropicLevel > 0 && texture.scaleMode === (0, $P8XPi.SCALE_MODES).LINEAR) {
                var level = Math.min(texture.anisotropicLevel, gl.getParameter(anisotropicExt.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
                gl.texParameterf(texture.target, anisotropicExt.TEXTURE_MAX_ANISOTROPY_EXT, level);
            }
        } else gl.texParameteri(texture.target, gl.TEXTURE_MIN_FILTER, texture.scaleMode === (0, $P8XPi.SCALE_MODES).LINEAR ? gl.LINEAR : gl.NEAREST);
        gl.texParameteri(texture.target, gl.TEXTURE_MAG_FILTER, texture.scaleMode === (0, $P8XPi.SCALE_MODES).LINEAR ? gl.LINEAR : gl.NEAREST);
    };
    /**
     * @ignore
     */ TextureSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    return TextureSystem;
}();
var _systems = {
    __proto__: null,
    FilterSystem: FilterSystem,
    BatchSystem: BatchSystem,
    ContextSystem: ContextSystem,
    FramebufferSystem: FramebufferSystem,
    GeometrySystem: GeometrySystem,
    MaskSystem: MaskSystem,
    ScissorSystem: ScissorSystem,
    StencilSystem: StencilSystem,
    ProjectionSystem: ProjectionSystem,
    RenderTextureSystem: RenderTextureSystem,
    ShaderSystem: ShaderSystem,
    StateSystem: StateSystem,
    TextureGCSystem: TextureGCSystem,
    TextureSystem: TextureSystem
};
var tempMatrix$2 = new (0, $6qzqq.Matrix)();
/**
 * The AbstractRenderer is the base for a PixiJS Renderer. It is extended by the {@link PIXI.CanvasRenderer}
 * and {@link PIXI.Renderer} which can be used for rendering a PixiJS scene.
 *
 * @abstract
 * @class
 * @extends PIXI.utils.EventEmitter
 * @memberof PIXI
 */ var AbstractRenderer = /** @class */ function(_super) {
    __extends(AbstractRenderer, _super);
    /**
     * @param system - The name of the system this renderer is for.
     * @param [options] - The optional renderer parameters.
     * @param {number} [options.width=800] - The width of the screen.
     * @param {number} [options.height=600] - The height of the screen.
     * @param {HTMLCanvasElement} [options.view] - The canvas to use as a view, optional.
     * @param {boolean} [options.useContextAlpha=true] - Pass-through value for canvas' context `alpha` property.
     *   If you want to set transparency, please use `backgroundAlpha`. This option is for cases where the
     *   canvas needs to be opaque, possibly for performance reasons on some older devices.
     * @param {boolean} [options.autoDensity=false] - Resizes renderer view in CSS pixels to allow for
     *   resolutions other than 1.
     * @param {boolean} [options.antialias=false] - Sets antialias
     * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the renderer.
     * @param {boolean} [options.preserveDrawingBuffer=false] - Enables drawing buffer preservation,
     *  enable this if you need to call toDataUrl on the WebGL context.
     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
     *      not before the new render pass.
     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
     *  (shown if not transparent).
     * @param {number} [options.backgroundAlpha=1] - Value from 0 (fully transparent) to 1 (fully opaque).
     */ function AbstractRenderer(type, options) {
        if (type === void 0) type = (0, $P8XPi.RENDERER_TYPE).UNKNOWN;
        var _this = _super.call(this) || this;
        // Add the default render options
        options = Object.assign({}, (0, $ezJmd.settings).RENDER_OPTIONS, options);
        /**
         * The supplied constructor options.
         *
         * @member {Object}
         * @readOnly
         */ _this.options = options;
        /**
         * The type of the renderer.
         *
         * @member {number}
         * @default PIXI.RENDERER_TYPE.UNKNOWN
         * @see PIXI.RENDERER_TYPE
         */ _this.type = type;
        /**
         * Measurements of the screen. (0, 0, screenWidth, screenHeight).
         *
         * Its safe to use as filterArea or hitArea for the whole stage.
         *
         * @member {PIXI.Rectangle}
         */ _this.screen = new (0, $6qzqq.Rectangle)(0, 0, options.width, options.height);
        /**
         * The canvas element that everything is drawn to.
         *
         * @member {HTMLCanvasElement}
         */ _this.view = options.view || document.createElement('canvas');
        /**
         * The resolution / device pixel ratio of the renderer.
         *
         * @member {number}
         * @default PIXI.settings.RESOLUTION
         */ _this.resolution = options.resolution || (0, $ezJmd.settings).RESOLUTION;
        /**
         * Pass-thru setting for the the canvas' context `alpha` property. This is typically
         * not something you need to fiddle with. If you want transparency, use `backgroundAlpha`.
         *
         * @member {boolean}
         */ _this.useContextAlpha = options.useContextAlpha;
        /**
         * Whether CSS dimensions of canvas view should be resized to screen dimensions automatically.
         *
         * @member {boolean}
         */ _this.autoDensity = !!options.autoDensity;
        /**
         * The value of the preserveDrawingBuffer flag affects whether or not the contents of
         * the stencil buffer is retained after rendering.
         *
         * @member {boolean}
         */ _this.preserveDrawingBuffer = options.preserveDrawingBuffer;
        /**
         * This sets if the CanvasRenderer will clear the canvas or not before the new render pass.
         * If the scene is NOT transparent PixiJS will use a canvas sized fillRect operation every
         * frame to set the canvas background color. If the scene is transparent PixiJS will use clearRect
         * to clear the canvas every frame. Disable this by setting this to false. For example, if
         * your game has a canvas filling background image you often don't need this set.
         *
         * @member {boolean}
         * @default
         */ _this.clearBeforeRender = options.clearBeforeRender;
        /**
         * The background color as a number.
         *
         * @member {number}
         * @protected
         */ _this._backgroundColor = 0x000000;
        /**
         * The background color as an [R, G, B, A] array.
         *
         * @member {number[]}
         * @protected
         */ _this._backgroundColorRgba = [
            0,
            0,
            0,
            1
        ];
        /**
         * The background color as a string.
         *
         * @member {string}
         * @protected
         */ _this._backgroundColorString = '#000000';
        _this.backgroundColor = options.backgroundColor || _this._backgroundColor; // run bg color setter
        _this.backgroundAlpha = options.backgroundAlpha;
        // @deprecated
        if (options.transparent !== undefined) {
            (0, $csytw.deprecation)('6.0.0', 'Option transparent is deprecated, please use backgroundAlpha instead.');
            _this.useContextAlpha = options.transparent;
            _this.backgroundAlpha = options.transparent ? 0 : 1;
        }
        /**
         * The last root object that the renderer tried to render.
         *
         * @member {PIXI.DisplayObject}
         * @protected
         */ _this._lastObjectRendered = null;
        /**
         * Collection of plugins.
         * @readonly
         * @member {object}
         */ _this.plugins = {};
        return _this;
    }
    /**
     * Initialize the plugins.
     *
     * @protected
     * @param {object} staticMap - The dictionary of statically saved plugins.
     */ AbstractRenderer.prototype.initPlugins = function(staticMap) {
        for(var o in staticMap)this.plugins[o] = new staticMap[o](this);
    };
    Object.defineProperty(AbstractRenderer.prototype, "width", {
        /**
         * Same as view.width, actual number of pixels in the canvas by horizontal.
         *
         * @member {number}
         * @readonly
         * @default 800
         */ get: function() {
            return this.view.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractRenderer.prototype, "height", {
        /**
         * Same as view.height, actual number of pixels in the canvas by vertical.
         *
         * @member {number}
         * @readonly
         * @default 600
         */ get: function() {
            return this.view.height;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Resizes the screen and canvas as close as possible to the specified width and height.
     * Canvas dimensions are multiplied by resolution and rounded to the nearest integers.
     * The new canvas dimensions divided by the resolution become the new screen dimensions.
     *
     * @param desiredScreenWidth - The desired width of the screen.
     * @param desiredScreenHeight - The desired height of the screen.
     */ AbstractRenderer.prototype.resize = function(desiredScreenWidth, desiredScreenHeight) {
        this.view.width = Math.round(desiredScreenWidth * this.resolution);
        this.view.height = Math.round(desiredScreenHeight * this.resolution);
        var screenWidth = this.view.width / this.resolution;
        var screenHeight = this.view.height / this.resolution;
        this.screen.width = screenWidth;
        this.screen.height = screenHeight;
        if (this.autoDensity) {
            this.view.style.width = screenWidth + "px";
            this.view.style.height = screenHeight + "px";
        }
        /**
         * Fired after view has been resized.
         *
         * @event PIXI.Renderer#resize
         * @param {number} screenWidth - The new width of the screen.
         * @param {number} screenHeight - The new height of the screen.
         */ this.emit('resize', screenWidth, screenHeight);
    };
    /**
     * @ignore
     */ AbstractRenderer.prototype.generateTexture = function(displayObject, options, resolution, region) {
        if (options === void 0) options = {};
        // @deprecated parameters spread, use options instead
        if (typeof options === 'number') {
            (0, $csytw.deprecation)('6.1.0', 'generateTexture options (scaleMode, resolution, region) are now object options.');
            options = {
                scaleMode: options,
                resolution: resolution,
                region: region
            };
        }
        var manualRegion = options.region, textureOptions = __rest(options, [
            "region"
        ]);
        region = manualRegion || displayObject.getLocalBounds(null, true);
        // minimum texture size is 1x1, 0x0 will throw an error
        if (region.width === 0) region.width = 1;
        if (region.height === 0) region.height = 1;
        var renderTexture = RenderTexture.create(__assign({
            width: region.width,
            height: region.height
        }, textureOptions));
        tempMatrix$2.tx = -region.x;
        tempMatrix$2.ty = -region.y;
        this.render(displayObject, {
            renderTexture: renderTexture,
            clear: false,
            transform: tempMatrix$2,
            skipUpdateTransform: !!displayObject.parent
        });
        return renderTexture;
    };
    /**
     * Removes everything from the renderer and optionally removes the Canvas DOM element.
     *
     * @param [removeView=false] - Removes the Canvas element from the DOM.
     */ AbstractRenderer.prototype.destroy = function(removeView) {
        for(var o in this.plugins){
            this.plugins[o].destroy();
            this.plugins[o] = null;
        }
        if (removeView && this.view.parentNode) this.view.parentNode.removeChild(this.view);
        var thisAny = this;
        // null-ing all objects, that's a tradition!
        thisAny.plugins = null;
        thisAny.type = (0, $P8XPi.RENDERER_TYPE).UNKNOWN;
        thisAny.view = null;
        thisAny.screen = null;
        thisAny._tempDisplayObjectParent = null;
        thisAny.options = null;
        this._backgroundColorRgba = null;
        this._backgroundColorString = null;
        this._lastObjectRendered = null;
    };
    Object.defineProperty(AbstractRenderer.prototype, "backgroundColor", {
        /**
         * The background color to fill if not transparent
         *
         * @member {number}
         */ get: function() {
            return this._backgroundColor;
        },
        set: function(value) {
            this._backgroundColor = value;
            this._backgroundColorString = (0, $csytw.hex2string)(value);
            (0, $csytw.hex2rgb)(value, this._backgroundColorRgba);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AbstractRenderer.prototype, "backgroundAlpha", {
        /**
         * The background color alpha. Setting this to 0 will make the canvas transparent.
         *
         * @member {number}
         */ get: function() {
            return this._backgroundColorRgba[3];
        },
        set: function(value) {
            this._backgroundColorRgba[3] = value;
        },
        enumerable: false,
        configurable: true
    });
    return AbstractRenderer;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE))));
var GLBuffer = /** @class */ function() {
    function GLBuffer(buffer) {
        this.buffer = buffer || null;
        this.updateID = -1;
        this.byteLength = -1;
        this.refCount = 0;
    }
    return GLBuffer;
}();
/**
 * System plugin to the renderer to manage buffers.
 *
 * WebGL uses Buffers as a way to store objects to the GPU.
 * This system makes working with them a lot easier.
 *
 * Buffers are used in three main places in WebGL
 * - geometry information
 * - Uniform information (via uniform buffer objects - a WebGL 2 only feature)
 * - Transform feedback information. (WebGL 2 only feature)
 *
 * This system will handle the binding of buffers to the GPU as well as uploading
 * them. With this system, you never need to work directly with GPU buffers, but instead work with
 * the PIXI.Buffer class.
 *
 *
 * @class
 * @memberof PIXI
 */ var BufferSystem = /** @class */ function() {
    /**
     * @param {PIXI.Renderer} renderer - The renderer this System works for.
     */ function BufferSystem(renderer) {
        this.renderer = renderer;
        this.managedBuffers = {};
        this.boundBufferBases = {};
    }
    /**
     * @ignore
     */ BufferSystem.prototype.destroy = function() {
        this.renderer = null;
    };
    /**
     * Sets up the renderer context and necessary buffers.
     */ BufferSystem.prototype.contextChange = function() {
        this.disposeAll(true);
        this.gl = this.renderer.gl;
        // TODO fill out...
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
    };
    /**
     * This binds specified buffer. On first run, it will create the webGL buffers for the context too
     *
     * @param buffer - the buffer to bind to the renderer
     */ BufferSystem.prototype.bind = function(buffer) {
        var _a = this, gl = _a.gl, CONTEXT_UID = _a.CONTEXT_UID;
        var glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        gl.bindBuffer(buffer.type, glBuffer.buffer);
    };
    /**
     * Binds an uniform buffer to at the given index.
     *
     * A cache is used so a buffer will not be bound again if already bound.
     *
     * @param buffer - the buffer to bind
     * @param index - the base index to bind it to.
     */ BufferSystem.prototype.bindBufferBase = function(buffer, index) {
        var _a = this, gl = _a.gl, CONTEXT_UID = _a.CONTEXT_UID;
        if (this.boundBufferBases[index] !== buffer) {
            var glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
            this.boundBufferBases[index] = buffer;
            gl.bindBufferBase(gl.UNIFORM_BUFFER, index, glBuffer.buffer);
        }
    };
    /**
     * Binds a buffer whilst also binding its range.
     * This will make the buffer start from the offset supplied rather than 0 when it is read.
     *
     * @param buffer - the buffer to bind
     * @param index - the base index to bind at, defaults to 0
     * @param offset - the offset to bind at (this is blocks of 256). 0 = 0, 1 = 256, 2 = 512 etc
     */ BufferSystem.prototype.bindBufferRange = function(buffer, index, offset) {
        var _a = this, gl = _a.gl, CONTEXT_UID = _a.CONTEXT_UID;
        offset = offset || 0;
        var glBuffer = buffer._glBuffers[CONTEXT_UID] || this.createGLBuffer(buffer);
        gl.bindBufferRange(gl.UNIFORM_BUFFER, index || 0, glBuffer.buffer, offset * 256, 256);
    };
    /**
     * Will ensure sure the the data in the buffer is uploaded to the GPU.
     *
     * @param {PIXI.Buffer} buffer - the buffer to update
     */ BufferSystem.prototype.update = function(buffer) {
        var _a = this, gl = _a.gl, CONTEXT_UID = _a.CONTEXT_UID;
        var glBuffer = buffer._glBuffers[CONTEXT_UID];
        if (buffer._updateID === glBuffer.updateID) return;
        glBuffer.updateID = buffer._updateID;
        gl.bindBuffer(buffer.type, glBuffer.buffer);
        if (glBuffer.byteLength >= buffer.data.byteLength) // offset is always zero for now!
        gl.bufferSubData(buffer.type, 0, buffer.data);
        else {
            var drawType = buffer.static ? gl.STATIC_DRAW : gl.DYNAMIC_DRAW;
            glBuffer.byteLength = buffer.data.byteLength;
            gl.bufferData(buffer.type, buffer.data, drawType);
        }
    };
    /**
     * Disposes buffer
     * @param {PIXI.Buffer} buffer - buffer with data
     * @param {boolean} [contextLost=false] - If context was lost, we suppress deleteVertexArray
     */ BufferSystem.prototype.dispose = function(buffer, contextLost) {
        if (!this.managedBuffers[buffer.id]) return;
        delete this.managedBuffers[buffer.id];
        var glBuffer = buffer._glBuffers[this.CONTEXT_UID];
        var gl = this.gl;
        buffer.disposeRunner.remove(this);
        if (!glBuffer) return;
        if (!contextLost) gl.deleteBuffer(glBuffer.buffer);
        delete buffer._glBuffers[this.CONTEXT_UID];
    };
    /**
     * dispose all WebGL resources of all managed buffers
     * @param {boolean} [contextLost=false] - If context was lost, we suppress `gl.delete` calls
     */ BufferSystem.prototype.disposeAll = function(contextLost) {
        var all = Object.keys(this.managedBuffers);
        for(var i = 0; i < all.length; i++)this.dispose(this.managedBuffers[all[i]], contextLost);
    };
    /**
     * creates and attaches a GLBuffer object tied to the current context.
     * @protected
     */ BufferSystem.prototype.createGLBuffer = function(buffer) {
        var _a = this, CONTEXT_UID = _a.CONTEXT_UID, gl = _a.gl;
        buffer._glBuffers[CONTEXT_UID] = new GLBuffer(gl.createBuffer());
        this.managedBuffers[buffer.id] = buffer;
        buffer.disposeRunner.add(this);
        return buffer._glBuffers[CONTEXT_UID];
    };
    return BufferSystem;
}();
/**
 * The Renderer draws the scene and all its content onto a WebGL enabled canvas.
 *
 * This renderer should be used for browsers that support WebGL.
 *
 * This renderer works by automatically managing WebGLBatchesm, so no need for Sprite Batches or Sprite Clouds.
 * Don't forget to add the view to your DOM or you will not see anything!
 *
 * Renderer is composed of systems that manage specific tasks. The following systems are added by default
 * whenever you create a renderer:
 *
 * | System                               | Description                                                                   |
 * | ------------------------------------ | ----------------------------------------------------------------------------- |
 * | {@link PIXI.BatchSystem}             | This manages object renderers that defer rendering until a flush.             |
 * | {@link PIXI.ContextSystem}           | This manages the WebGL context and extensions.                                |
 * | {@link PIXI.EventSystem}             | This manages UI events.                                                       |
 * | {@link PIXI.FilterSystem}            | This manages the filtering pipeline for post-processing effects.              |
 * | {@link PIXI.FramebufferSystem}       | This manages framebuffers, which are used for offscreen rendering.            |
 * | {@link PIXI.GeometrySystem}          | This manages geometries & buffers, which are used to draw object meshes.      |
 * | {@link PIXI.MaskSystem}              | This manages masking operations.                                              |
 * | {@link PIXI.ProjectionSystem}        | This manages the `projectionMatrix`, used by shaders to get NDC coordinates.  |
 * | {@link PIXI.RenderTextureSystem}     | This manages render-textures, which are an abstraction over framebuffers.     |
 * | {@link PIXI.ScissorSystem}           | This handles scissor masking, and is used internally by {@link MaskSystem}    |
 * | {@link PIXI.ShaderSystem}            | This manages shaders, programs that run on the GPU to calculate 'em pixels.   |
 * | {@link PIXI.StateSystem}             | This manages the WebGL state variables like blend mode, depth testing, etc.   |
 * | {@link PIXI.StencilSystem}           | This handles stencil masking, and is used internally by {@link MaskSystem}    |
 * | {@link PIXI.TextureSystem}           | This manages textures and their resources on the GPU.                         |
 * | {@link PIXI.TextureGCSystem}         | This will automatically remove textures from the GPU if they are not used.    |
 *
 * The breadth of the API surface provided by the renderer is contained within these systems.
 *
 * @memberof PIXI
 */ var Renderer = /** @class */ function(_super) {
    __extends(Renderer, _super);
    /**
     * @param [options] - The optional renderer parameters.
     * @param {number} [options.width=800] - The width of the screen.
     * @param {number} [options.height=600] - The height of the screen.
     * @param {HTMLCanvasElement} [options.view] - The canvas to use as a view, optional.
     * @param {boolean} [options.useContextAlpha=true] - Pass-through value for canvas' context `alpha` property.
     *   If you want to set transparency, please use `backgroundAlpha`. This option is for cases where the
     *   canvas needs to be opaque, possibly for performance reasons on some older devices.
     * @param {boolean} [options.autoDensity=false] - Resizes renderer view in CSS pixels to allow for
     *   resolutions other than 1.
     * @param {boolean} [options.antialias=false] - Sets antialias. If not available natively then FXAA
     *  antialiasing is used.
     * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the renderer.
     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear
     *  the canvas or not before the new render pass. If you wish to set this to false, you *must* set
     *  preserveDrawingBuffer to `true`.
     * @param {boolean} [options.preserveDrawingBuffer=false] - Enables drawing buffer preservation,
     *  enable this if you need to call toDataUrl on the WebGL context.
     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
     *  (shown if not transparent).
     * @param {number} [options.backgroundAlpha=1] - Value from 0 (fully transparent) to 1 (fully opaque).
     * @param {string} [options.powerPreference] - Parameter passed to WebGL context, set to "high-performance"
     *  for devices with dual graphics card.
     * @param {object} [options.context] - If WebGL context already exists, all parameters must be taken from it.
     */ function Renderer(options) {
        var _this = _super.call(this, (0, $P8XPi.RENDERER_TYPE).WEBGL, options) || this;
        // the options will have been modified here in the super constructor with pixi's default settings..
        options = _this.options;
        _this.gl = null;
        _this.CONTEXT_UID = 0;
        _this.runners = {
            destroy: new (0, $6fZag.Runner)('destroy'),
            contextChange: new (0, $6fZag.Runner)('contextChange'),
            reset: new (0, $6fZag.Runner)('reset'),
            update: new (0, $6fZag.Runner)('update'),
            postrender: new (0, $6fZag.Runner)('postrender'),
            prerender: new (0, $6fZag.Runner)('prerender'),
            resize: new (0, $6fZag.Runner)('resize')
        };
        _this.runners.contextChange.add(_this);
        _this.globalUniforms = new UniformGroup({
            projectionMatrix: new (0, $6qzqq.Matrix)()
        }, true);
        _this.addSystem(MaskSystem, 'mask').addSystem(ContextSystem, 'context').addSystem(StateSystem, 'state').addSystem(ShaderSystem, 'shader').addSystem(TextureSystem, 'texture').addSystem(BufferSystem, 'buffer').addSystem(GeometrySystem, 'geometry').addSystem(FramebufferSystem, 'framebuffer').addSystem(ScissorSystem, 'scissor').addSystem(StencilSystem, 'stencil').addSystem(ProjectionSystem, 'projection').addSystem(TextureGCSystem, 'textureGC').addSystem(FilterSystem, 'filter').addSystem(RenderTextureSystem, 'renderTexture').addSystem(BatchSystem, 'batch');
        _this.initPlugins(Renderer.__plugins);
        _this.multisample = undefined;
        /*
         * The options passed in to create a new WebGL context.
         */ if (options.context) _this.context.initFromContext(options.context);
        else _this.context.initFromOptions({
            alpha: !!_this.useContextAlpha,
            antialias: options.antialias,
            premultipliedAlpha: _this.useContextAlpha && _this.useContextAlpha !== 'notMultiplied',
            stencil: true,
            preserveDrawingBuffer: options.preserveDrawingBuffer,
            powerPreference: _this.options.powerPreference
        });
        _this.renderingToScreen = true;
        (0, $csytw.sayHello)(_this.context.webGLVersion === 2 ? 'WebGL 2' : 'WebGL 1');
        _this.resize(_this.options.width, _this.options.height);
        return _this;
    }
    /**
     * Create renderer if WebGL is available. Overrideable
     * by the **@pixi/canvas-renderer** package to allow fallback.
     * throws error if WebGL is not available.
     *
     * @private
     */ Renderer.create = function(options) {
        if ((0, $csytw.isWebGLSupported)()) return new Renderer(options);
        throw new Error('WebGL unsupported in this browser, use "pixi.js-legacy" for fallback canvas2d support.');
    };
    Renderer.prototype.contextChange = function() {
        var gl = this.gl;
        var samples;
        if (this.context.webGLVersion === 1) {
            var framebuffer = gl.getParameter(gl.FRAMEBUFFER_BINDING);
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            samples = gl.getParameter(gl.SAMPLES);
            gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        } else {
            var framebuffer = gl.getParameter(gl.DRAW_FRAMEBUFFER_BINDING);
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
            samples = gl.getParameter(gl.SAMPLES);
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, framebuffer);
        }
        if (samples >= (0, $P8XPi.MSAA_QUALITY).HIGH) this.multisample = (0, $P8XPi.MSAA_QUALITY).HIGH;
        else if (samples >= (0, $P8XPi.MSAA_QUALITY).MEDIUM) this.multisample = (0, $P8XPi.MSAA_QUALITY).MEDIUM;
        else if (samples >= (0, $P8XPi.MSAA_QUALITY).LOW) this.multisample = (0, $P8XPi.MSAA_QUALITY).LOW;
        else this.multisample = (0, $P8XPi.MSAA_QUALITY).NONE;
    };
    /**
     * Add a new system to the renderer.
     * @param ClassRef - Class reference
     * @param [name] - Property name for system, if not specified
     *        will use a static `name` property on the class itself. This
     *        name will be assigned as s property on the Renderer so make
     *        sure it doesn't collide with properties on Renderer.
     * @return Return instance of renderer
     */ Renderer.prototype.addSystem = function(ClassRef, name) {
        var system = new ClassRef(this);
        if (this[name]) throw new Error("Whoops! The name \"" + name + "\" is already in use");
        this[name] = system;
        for(var i in this.runners)this.runners[i].add(system);
        /**
         * Fired after rendering finishes.
         *
         * @event PIXI.Renderer#postrender
         */ /**
         * Fired before rendering starts.
         *
         * @event PIXI.Renderer#prerender
         */ /**
         * Fired when the WebGL context is set.
         *
         * @event PIXI.Renderer#context
         * @param {WebGLRenderingContext} gl - WebGL context.
         */ return this;
    };
    /**
     * @ignore
     */ Renderer.prototype.render = function(displayObject, options) {
        var renderTexture;
        var clear;
        var transform;
        var skipUpdateTransform;
        if (options) {
            if (options instanceof RenderTexture) {
                (0, $csytw.deprecation)('6.0.0', 'Renderer#render arguments changed, use options instead.');
                /* eslint-disable prefer-rest-params */ renderTexture = options;
                clear = arguments[2];
                transform = arguments[3];
                skipUpdateTransform = arguments[4];
            /* eslint-enable prefer-rest-params */ } else {
                renderTexture = options.renderTexture;
                clear = options.clear;
                transform = options.transform;
                skipUpdateTransform = options.skipUpdateTransform;
            }
        }
        // can be handy to know!
        this.renderingToScreen = !renderTexture;
        this.runners.prerender.emit();
        this.emit('prerender');
        // apply a transform at a GPU level
        this.projection.transform = transform;
        // no point rendering if our context has been blown up!
        if (this.context.isLost) return;
        if (!renderTexture) this._lastObjectRendered = displayObject;
        if (!skipUpdateTransform) {
            // update the scene graph
            var cacheParent = displayObject.enableTempParent();
            displayObject.updateTransform();
            displayObject.disableTempParent(cacheParent);
        // displayObject.hitArea = //TODO add a temp hit area
        }
        this.renderTexture.bind(renderTexture);
        this.batch.currentRenderer.start();
        if (clear !== undefined ? clear : this.clearBeforeRender) this.renderTexture.clear();
        displayObject.render(this);
        // apply transform..
        this.batch.currentRenderer.flush();
        if (renderTexture) renderTexture.baseTexture.update();
        this.runners.postrender.emit();
        // reset transform after render
        this.projection.transform = null;
        this.emit('postrender');
    };
    /**
     * @override
     * @ignore
     */ Renderer.prototype.generateTexture = function(displayObject, options, resolution, region) {
        if (options === void 0) options = {};
        var renderTexture = _super.prototype.generateTexture.call(this, displayObject, options, resolution, region);
        this.framebuffer.blit();
        return renderTexture;
    };
    /**
     * Resizes the WebGL view to the specified width and height.
     *
     * @param desiredScreenWidth - The desired width of the screen.
     * @param desiredScreenHeight - The desired height of the screen.
     */ Renderer.prototype.resize = function(desiredScreenWidth, desiredScreenHeight) {
        _super.prototype.resize.call(this, desiredScreenWidth, desiredScreenHeight);
        this.runners.resize.emit(this.screen.height, this.screen.width);
    };
    /**
     * Resets the WebGL state so you can render things however you fancy!
     *
     * @return Returns itself.
     */ Renderer.prototype.reset = function() {
        this.runners.reset.emit();
        return this;
    };
    /** Clear the frame buffer. */ Renderer.prototype.clear = function() {
        this.renderTexture.bind();
        this.renderTexture.clear();
    };
    /**
     * Removes everything from the renderer (event listeners, spritebatch, etc...)
     *
     * @param [removeView=false] - Removes the Canvas element from the DOM.
     *  See: https://github.com/pixijs/pixi.js/issues/2233
     */ Renderer.prototype.destroy = function(removeView) {
        this.runners.destroy.emit();
        for(var r in this.runners)this.runners[r].destroy();
        // call base destroy
        _super.prototype.destroy.call(this, removeView);
        // TODO nullify all the managers..
        this.gl = null;
    };
    Object.defineProperty(Renderer.prototype, "extract", {
        /**
         * Please use `plugins.extract` instead.
         * @member {PIXI.Extract} extract
         * @deprecated since 6.0.0
         * @readonly
         */ get: function() {
            (0, $csytw.deprecation)('6.0.0', 'Renderer#extract has been deprecated, please use Renderer#plugins.extract instead.');
            return this.plugins.extract;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Adds a plugin to the renderer.
     *
     * @param pluginName - The name of the plugin.
     * @param ctor - The constructor function or class for the plugin.
     */ Renderer.registerPlugin = function(pluginName, ctor) {
        Renderer.__plugins = Renderer.__plugins || {};
        Renderer.__plugins[pluginName] = ctor;
    };
    return Renderer;
}(AbstractRenderer);
/**
 * This helper function will automatically detect which renderer you should be using.
 * WebGL is the preferred renderer as it is a lot faster. If WebGL is not supported by
 * the browser then this function will return a canvas renderer
 *
 * @memberof PIXI
 * @function autoDetectRenderer
 * @param {object} [options] - The optional renderer parameters
 * @param {number} [options.width=800] - the width of the renderers view
 * @param {number} [options.height=600] - the height of the renderers view
 * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
 * @param {boolean} [options.useContextAlpha=true] - Pass-through value for canvas' context `alpha` property.
 *   If you want to set transparency, please use `backgroundAlpha`. This option is for cases where the
 *   canvas needs to be opaque, possibly for performance reasons on some older devices.
 * @param {boolean} [options.autoDensity=false] - Resizes renderer view in CSS pixels to allow for
 *   resolutions other than 1
 * @param {boolean} [options.antialias=false] - sets antialias
 * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
 *  need to call toDataUrl on the webgl context
 * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
 *  (shown if not transparent).
 * @param {number} [options.backgroundAlpha=1] - Value from 0 (fully transparent) to 1 (fully opaque).
 * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
 *   not before the new render pass.
 * @param {number} [options.resolution=PIXI.settings.RESOLUTION] - The resolution / device pixel ratio of the renderer.
 * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present, this
 *   option only is available when using **pixi.js-legacy** or **@pixi/canvas-renderer** modules, otherwise
 *   it is ignored.
 * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
 *  for devices with dual graphics card **webgl only**
 * @return {PIXI.Renderer|PIXI.CanvasRenderer} Returns WebGL renderer if available, otherwise CanvasRenderer
 */ function autoDetectRenderer(options) {
    return Renderer.create(options);
}
var $defaultVertex = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}";
var $defaultFilterVertex = "attribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aVertexPosition * (outputFrame.zw * inputSize.zw);\n}\n\nvoid main(void)\n{\n    gl_Position = filterVertexPosition();\n    vTextureCoord = filterTextureCoord();\n}\n";
/**
 * Default vertex shader
 * @memberof PIXI
 * @member {string} defaultVertex
 */ /**
 * Default filter vertex shader
 * @memberof PIXI
 * @member {string} defaultFilterVertex
 */ // NOTE: This black magic is so that @microsoft/api-extractor does not complain! This explicitly specifies the types
// of defaultVertex, defaultFilterVertex.
var defaultVertex$2 = $defaultVertex;
var defaultFilterVertex = $defaultFilterVertex;
/**
 * Use the ISystem interface instead.
 * @deprecated since 6.1.0
 * @memberof PIXI
 */ var System = /** @class */ function() {
    /**
     * @param renderer - Reference to Renderer
     */ function System(renderer) {
        (0, $csytw.deprecation)('6.1.0', 'System class is deprecated, implemement ISystem interface instead.');
        this.renderer = renderer;
    }
    /** Destroy and don't use after this. */ System.prototype.destroy = function() {
        this.renderer = null;
    };
    return System;
}();
/**
 * Used by the batcher to draw batches.
 * Each one of these contains all information required to draw a bound geometry.
 *
 * @memberof PIXI
 */ var BatchDrawCall = /** @class */ function() {
    function BatchDrawCall() {
        this.texArray = null;
        this.blend = 0;
        this.type = (0, $P8XPi.DRAW_MODES).TRIANGLES;
        this.start = 0;
        this.size = 0;
        this.data = null;
    }
    return BatchDrawCall;
}();
/**
 * Used by the batcher to build texture batches.
 * Holds list of textures and their respective locations.
 *
 * @memberof PIXI
 */ var BatchTextureArray = /** @class */ function() {
    function BatchTextureArray() {
        this.elements = [];
        this.ids = [];
        this.count = 0;
    }
    BatchTextureArray.prototype.clear = function() {
        for(var i = 0; i < this.count; i++)this.elements[i] = null;
        this.count = 0;
    };
    return BatchTextureArray;
}();
/**
 * Flexible wrapper around `ArrayBuffer` that also provides typed array views on demand.
 *
 * @class
 * @memberof PIXI
 */ var ViewableBuffer = /** @class */ function() {
    function ViewableBuffer(sizeOrBuffer) {
        if (typeof sizeOrBuffer === 'number') /**
             * Underlying `ArrayBuffer` that holds all the data and is of capacity `this.size`.
             *
             * @member {ArrayBuffer}
             */ this.rawBinaryData = new ArrayBuffer(sizeOrBuffer);
        else if (sizeOrBuffer instanceof Uint8Array) this.rawBinaryData = sizeOrBuffer.buffer;
        else this.rawBinaryData = sizeOrBuffer;
        /**
         * View on the raw binary data as a `Uint32Array`.
         *
         * @member {Uint32Array}
         */ this.uint32View = new Uint32Array(this.rawBinaryData);
        /**
         * View on the raw binary data as a `Float32Array`.
         *
         * @member {Float32Array}
         */ this.float32View = new Float32Array(this.rawBinaryData);
    }
    Object.defineProperty(ViewableBuffer.prototype, "int8View", {
        /**
         * View on the raw binary data as a `Int8Array`.
         *
         * @member {Int8Array}
         */ get: function() {
            if (!this._int8View) this._int8View = new Int8Array(this.rawBinaryData);
            return this._int8View;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewableBuffer.prototype, "uint8View", {
        /**
         * View on the raw binary data as a `Uint8Array`.
         *
         * @member {Uint8Array}
         */ get: function() {
            if (!this._uint8View) this._uint8View = new Uint8Array(this.rawBinaryData);
            return this._uint8View;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewableBuffer.prototype, "int16View", {
        /**
         * View on the raw binary data as a `Int16Array`.
         *
         * @member {Int16Array}
         */ get: function() {
            if (!this._int16View) this._int16View = new Int16Array(this.rawBinaryData);
            return this._int16View;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewableBuffer.prototype, "uint16View", {
        /**
         * View on the raw binary data as a `Uint16Array`.
         *
         * @member {Uint16Array}
         */ get: function() {
            if (!this._uint16View) this._uint16View = new Uint16Array(this.rawBinaryData);
            return this._uint16View;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewableBuffer.prototype, "int32View", {
        /**
         * View on the raw binary data as a `Int32Array`.
         *
         * @member {Int32Array}
         */ get: function() {
            if (!this._int32View) this._int32View = new Int32Array(this.rawBinaryData);
            return this._int32View;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the view of the given type.
     *
     * @param {string} type - One of `int8`, `uint8`, `int16`,
     *    `uint16`, `int32`, `uint32`, and `float32`.
     * @return {object} typed array of given type
     */ ViewableBuffer.prototype.view = function(type) {
        return this[type + "View"];
    };
    /**
     * Destroys all buffer references. Do not use after calling
     * this.
     */ ViewableBuffer.prototype.destroy = function() {
        this.rawBinaryData = null;
        this._int8View = null;
        this._uint8View = null;
        this._int16View = null;
        this._uint16View = null;
        this._int32View = null;
        this.uint32View = null;
        this.float32View = null;
    };
    ViewableBuffer.sizeOf = function(type) {
        switch(type){
            case 'int8':
            case 'uint8':
                return 1;
            case 'int16':
            case 'uint16':
                return 2;
            case 'int32':
            case 'uint32':
            case 'float32':
                return 4;
            default:
                throw new Error(type + " isn't a valid view type");
        }
    };
    return ViewableBuffer;
}();
/**
 * Renderer dedicated to drawing and batching sprites.
 *
 * This is the default batch renderer. It buffers objects
 * with texture-based geometries and renders them in
 * batches. It uploads multiple textures to the GPU to
 * reduce to the number of draw calls.
 *
 * @memberof PIXI
 */ var AbstractBatchRenderer = /** @class */ function(_super) {
    __extends(AbstractBatchRenderer, _super);
    /**
     * This will hook onto the renderer's `contextChange`
     * and `prerender` signals.
     *
     * @param {PIXI.Renderer} renderer - The renderer this works for.
     */ function AbstractBatchRenderer(renderer) {
        var _this = _super.call(this, renderer) || this;
        _this.shaderGenerator = null;
        _this.geometryClass = null;
        _this.vertexSize = null;
        _this.state = State.for2d();
        _this.size = (0, $ezJmd.settings).SPRITE_BATCH_SIZE * 4;
        _this._vertexCount = 0;
        _this._indexCount = 0;
        _this._bufferedElements = [];
        _this._bufferedTextures = [];
        _this._bufferSize = 0;
        _this._shader = null;
        _this._packedGeometries = [];
        _this._packedGeometryPoolSize = 2;
        _this._flushId = 0;
        _this._aBuffers = {};
        _this._iBuffers = {};
        _this.MAX_TEXTURES = 1;
        _this.renderer.on('prerender', _this.onPrerender, _this);
        renderer.runners.contextChange.add(_this);
        _this._dcIndex = 0;
        _this._aIndex = 0;
        _this._iIndex = 0;
        _this._attributeBuffer = null;
        _this._indexBuffer = null;
        _this._tempBoundTextures = [];
        return _this;
    }
    /**
     * Handles the `contextChange` signal.
     *
     * It calculates `this.MAX_TEXTURES` and allocating the packed-geometry object pool.
     */ AbstractBatchRenderer.prototype.contextChange = function() {
        var gl = this.renderer.gl;
        if ((0, $ezJmd.settings).PREFER_ENV === (0, $P8XPi.ENV).WEBGL_LEGACY) this.MAX_TEXTURES = 1;
        else {
            // step 1: first check max textures the GPU can handle.
            this.MAX_TEXTURES = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), (0, $ezJmd.settings).SPRITE_MAX_TEXTURES);
            // step 2: check the maximum number of if statements the shader can have too..
            this.MAX_TEXTURES = checkMaxIfStatementsInShader(this.MAX_TEXTURES, gl);
        }
        this._shader = this.shaderGenerator.generateShader(this.MAX_TEXTURES);
        // we use the second shader as the first one depending on your browser
        // may omit aTextureId as it is not used by the shader so is optimized out.
        for(var i = 0; i < this._packedGeometryPoolSize; i++)/* eslint-disable max-len */ this._packedGeometries[i] = new this.geometryClass();
        this.initFlushBuffers();
    };
    /** Makes sure that static and dynamic flush pooled objects have correct dimensions. */ AbstractBatchRenderer.prototype.initFlushBuffers = function() {
        var _drawCallPool = AbstractBatchRenderer._drawCallPool, _textureArrayPool = AbstractBatchRenderer._textureArrayPool;
        // max draw calls
        var MAX_SPRITES = this.size / 4;
        // max texture arrays
        var MAX_TA = Math.floor(MAX_SPRITES / this.MAX_TEXTURES) + 1;
        while(_drawCallPool.length < MAX_SPRITES)_drawCallPool.push(new BatchDrawCall());
        while(_textureArrayPool.length < MAX_TA)_textureArrayPool.push(new BatchTextureArray());
        for(var i = 0; i < this.MAX_TEXTURES; i++)this._tempBoundTextures[i] = null;
    };
    /**
     * Handles the `prerender` signal.
     *
     * It ensures that flushes start from the first geometry object again.
     */ AbstractBatchRenderer.prototype.onPrerender = function() {
        this._flushId = 0;
    };
    /**
     * Buffers the "batchable" object. It need not be rendered immediately.
     *
     * @param {PIXI.DisplayObject} element - the element to render when
     *    using this renderer
     */ AbstractBatchRenderer.prototype.render = function(element) {
        if (!element._texture.valid) return;
        if (this._vertexCount + element.vertexData.length / 2 > this.size) this.flush();
        this._vertexCount += element.vertexData.length / 2;
        this._indexCount += element.indices.length;
        this._bufferedTextures[this._bufferSize] = element._texture.baseTexture;
        this._bufferedElements[this._bufferSize++] = element;
    };
    AbstractBatchRenderer.prototype.buildTexturesAndDrawCalls = function() {
        var _a = this, textures = _a._bufferedTextures, MAX_TEXTURES = _a.MAX_TEXTURES;
        var textureArrays = AbstractBatchRenderer._textureArrayPool;
        var batch = this.renderer.batch;
        var boundTextures = this._tempBoundTextures;
        var touch = this.renderer.textureGC.count;
        var TICK = ++BaseTexture._globalBatch;
        var countTexArrays = 0;
        var texArray = textureArrays[0];
        var start = 0;
        batch.copyBoundTextures(boundTextures, MAX_TEXTURES);
        for(var i = 0; i < this._bufferSize; ++i){
            var tex = textures[i];
            textures[i] = null;
            if (tex._batchEnabled === TICK) continue;
            if (texArray.count >= MAX_TEXTURES) {
                batch.boundArray(texArray, boundTextures, TICK, MAX_TEXTURES);
                this.buildDrawCalls(texArray, start, i);
                start = i;
                texArray = textureArrays[++countTexArrays];
                ++TICK;
            }
            tex._batchEnabled = TICK;
            tex.touched = touch;
            texArray.elements[texArray.count++] = tex;
        }
        if (texArray.count > 0) {
            batch.boundArray(texArray, boundTextures, TICK, MAX_TEXTURES);
            this.buildDrawCalls(texArray, start, this._bufferSize);
            ++countTexArrays;
            ++TICK;
        }
        // Clean-up
        for(var i = 0; i < boundTextures.length; i++)boundTextures[i] = null;
        BaseTexture._globalBatch = TICK;
    };
    /** Populating drawcalls for rendering */ AbstractBatchRenderer.prototype.buildDrawCalls = function(texArray, start, finish) {
        var _a = this, elements = _a._bufferedElements, _attributeBuffer = _a._attributeBuffer, _indexBuffer = _a._indexBuffer, vertexSize = _a.vertexSize;
        var drawCalls = AbstractBatchRenderer._drawCallPool;
        var dcIndex = this._dcIndex;
        var aIndex = this._aIndex;
        var iIndex = this._iIndex;
        var drawCall = drawCalls[dcIndex];
        drawCall.start = this._iIndex;
        drawCall.texArray = texArray;
        for(var i = start; i < finish; ++i){
            var sprite = elements[i];
            var tex = sprite._texture.baseTexture;
            var spriteBlendMode = (0, $csytw.premultiplyBlendMode)[tex.alphaMode ? 1 : 0][sprite.blendMode];
            elements[i] = null;
            if (start < i && drawCall.blend !== spriteBlendMode) {
                drawCall.size = iIndex - drawCall.start;
                start = i;
                drawCall = drawCalls[++dcIndex];
                drawCall.texArray = texArray;
                drawCall.start = iIndex;
            }
            this.packInterleavedGeometry(sprite, _attributeBuffer, _indexBuffer, aIndex, iIndex);
            aIndex += sprite.vertexData.length / 2 * vertexSize;
            iIndex += sprite.indices.length;
            drawCall.blend = spriteBlendMode;
        }
        if (start < finish) {
            drawCall.size = iIndex - drawCall.start;
            ++dcIndex;
        }
        this._dcIndex = dcIndex;
        this._aIndex = aIndex;
        this._iIndex = iIndex;
    };
    /** Bind textures for current rendering */ AbstractBatchRenderer.prototype.bindAndClearTexArray = function(texArray) {
        var textureSystem = this.renderer.texture;
        for(var j = 0; j < texArray.count; j++){
            textureSystem.bind(texArray.elements[j], texArray.ids[j]);
            texArray.elements[j] = null;
        }
        texArray.count = 0;
    };
    AbstractBatchRenderer.prototype.updateGeometry = function() {
        var _a = this, packedGeometries = _a._packedGeometries, attributeBuffer = _a._attributeBuffer, indexBuffer = _a._indexBuffer;
        if (!(0, $ezJmd.settings).CAN_UPLOAD_SAME_BUFFER) {
            if (this._packedGeometryPoolSize <= this._flushId) {
                this._packedGeometryPoolSize++;
                packedGeometries[this._flushId] = new this.geometryClass();
            }
            packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData);
            packedGeometries[this._flushId]._indexBuffer.update(indexBuffer);
            this.renderer.geometry.bind(packedGeometries[this._flushId]);
            this.renderer.geometry.updateBuffers();
            this._flushId++;
        } else {
            // lets use the faster option, always use buffer number 0
            packedGeometries[this._flushId]._buffer.update(attributeBuffer.rawBinaryData);
            packedGeometries[this._flushId]._indexBuffer.update(indexBuffer);
            this.renderer.geometry.updateBuffers();
        }
    };
    AbstractBatchRenderer.prototype.drawBatches = function() {
        var dcCount = this._dcIndex;
        var _a = this.renderer, gl = _a.gl, stateSystem = _a.state;
        var drawCalls = AbstractBatchRenderer._drawCallPool;
        var curTexArray = null;
        // Upload textures and do the draw calls
        for(var i = 0; i < dcCount; i++){
            var _b = drawCalls[i], texArray = _b.texArray, type = _b.type, size = _b.size, start = _b.start, blend = _b.blend;
            if (curTexArray !== texArray) {
                curTexArray = texArray;
                this.bindAndClearTexArray(texArray);
            }
            this.state.blendMode = blend;
            stateSystem.set(this.state);
            gl.drawElements(type, size, gl.UNSIGNED_SHORT, start * 2);
        }
    };
    /** Renders the content _now_ and empties the current batch. */ AbstractBatchRenderer.prototype.flush = function() {
        if (this._vertexCount === 0) return;
        this._attributeBuffer = this.getAttributeBuffer(this._vertexCount);
        this._indexBuffer = this.getIndexBuffer(this._indexCount);
        this._aIndex = 0;
        this._iIndex = 0;
        this._dcIndex = 0;
        this.buildTexturesAndDrawCalls();
        this.updateGeometry();
        this.drawBatches();
        // reset elements buffer for the next flush
        this._bufferSize = 0;
        this._vertexCount = 0;
        this._indexCount = 0;
    };
    /** Starts a new sprite batch. */ AbstractBatchRenderer.prototype.start = function() {
        this.renderer.state.set(this.state);
        this.renderer.texture.ensureSamplerType(this.MAX_TEXTURES);
        this.renderer.shader.bind(this._shader);
        if ((0, $ezJmd.settings).CAN_UPLOAD_SAME_BUFFER) // bind buffer #0, we don't need others
        this.renderer.geometry.bind(this._packedGeometries[this._flushId]);
    };
    /** Stops and flushes the current batch. */ AbstractBatchRenderer.prototype.stop = function() {
        this.flush();
    };
    /** Destroys this `AbstractBatchRenderer`. It cannot be used again. */ AbstractBatchRenderer.prototype.destroy = function() {
        for(var i = 0; i < this._packedGeometryPoolSize; i++)if (this._packedGeometries[i]) this._packedGeometries[i].destroy();
        this.renderer.off('prerender', this.onPrerender, this);
        this._aBuffers = null;
        this._iBuffers = null;
        this._packedGeometries = null;
        this._attributeBuffer = null;
        this._indexBuffer = null;
        if (this._shader) {
            this._shader.destroy();
            this._shader = null;
        }
        _super.prototype.destroy.call(this);
    };
    /**
     * Fetches an attribute buffer from `this._aBuffers` that can hold atleast `size` floats.
     *
     * @param size - minimum capacity required
     * @return - buffer than can hold atleast `size` floats
     */ AbstractBatchRenderer.prototype.getAttributeBuffer = function(size) {
        // 8 vertices is enough for 2 quads
        var roundedP2 = (0, $csytw.nextPow2)(Math.ceil(size / 8));
        var roundedSizeIndex = (0, $csytw.log2)(roundedP2);
        var roundedSize = roundedP2 * 8;
        if (this._aBuffers.length <= roundedSizeIndex) this._iBuffers.length = roundedSizeIndex + 1;
        var buffer = this._aBuffers[roundedSize];
        if (!buffer) this._aBuffers[roundedSize] = buffer = new ViewableBuffer(roundedSize * this.vertexSize * 4);
        return buffer;
    };
    /**
     * Fetches an index buffer from `this._iBuffers` that can
     * have at least `size` capacity.
     *
     * @param size - minimum required capacity
     * @return - buffer that can fit `size` indices.
     */ AbstractBatchRenderer.prototype.getIndexBuffer = function(size) {
        // 12 indices is enough for 2 quads
        var roundedP2 = (0, $csytw.nextPow2)(Math.ceil(size / 12));
        var roundedSizeIndex = (0, $csytw.log2)(roundedP2);
        var roundedSize = roundedP2 * 12;
        if (this._iBuffers.length <= roundedSizeIndex) this._iBuffers.length = roundedSizeIndex + 1;
        var buffer = this._iBuffers[roundedSizeIndex];
        if (!buffer) this._iBuffers[roundedSizeIndex] = buffer = new Uint16Array(roundedSize);
        return buffer;
    };
    /**
     * Takes the four batching parameters of `element`, interleaves
     * and pushes them into the batching attribute/index buffers given.
     *
     * It uses these properties: `vertexData` `uvs`, `textureId` and
     * `indicies`. It also uses the "tint" of the base-texture, if
     * present.
     *
     * @param {PIXI.DisplayObject} element - element being rendered
     * @param attributeBuffer - attribute buffer.
     * @param indexBuffer - index buffer
     * @param aIndex - number of floats already in the attribute buffer
     * @param iIndex - number of indices already in `indexBuffer`
     */ AbstractBatchRenderer.prototype.packInterleavedGeometry = function(element, attributeBuffer, indexBuffer, aIndex, iIndex) {
        var uint32View = attributeBuffer.uint32View, float32View = attributeBuffer.float32View;
        var packedVertices = aIndex / this.vertexSize;
        var uvs = element.uvs;
        var indicies = element.indices;
        var vertexData = element.vertexData;
        var textureId = element._texture.baseTexture._batchLocation;
        var alpha = Math.min(element.worldAlpha, 1.0);
        var argb = alpha < 1.0 && element._texture.baseTexture.alphaMode ? (0, $csytw.premultiplyTint)(element._tintRGB, alpha) : element._tintRGB + (alpha * 255 << 24);
        // lets not worry about tint! for now..
        for(var i = 0; i < vertexData.length; i += 2){
            float32View[aIndex++] = vertexData[i];
            float32View[aIndex++] = vertexData[i + 1];
            float32View[aIndex++] = uvs[i];
            float32View[aIndex++] = uvs[i + 1];
            uint32View[aIndex++] = argb;
            float32View[aIndex++] = textureId;
        }
        for(var i = 0; i < indicies.length; i++)indexBuffer[iIndex++] = packedVertices + indicies[i];
    };
    /**
     * Pool of `BatchDrawCall` objects that `flush` used
     * to create "batches" of the objects being rendered.
     *
     * These are never re-allocated again.
     * Shared between all batch renderers because it can be only one "flush" working at the moment.
     *
     * @member {PIXI.BatchDrawCall[]}
     */ AbstractBatchRenderer._drawCallPool = [];
    /**
     * Pool of `BatchDrawCall` objects that `flush` used
     * to create "batches" of the objects being rendered.
     *
     * These are never re-allocated again.
     * Shared between all batch renderers because it can be only one "flush" working at the moment.
     *
     * @member {PIXI.BatchTextureArray[]}
     */ AbstractBatchRenderer._textureArrayPool = [];
    return AbstractBatchRenderer;
}(ObjectRenderer);
/**
 * Helper that generates batching multi-texture shader. Use it with your new BatchRenderer
 *
 * @memberof PIXI
 */ var BatchShaderGenerator = /** @class */ function() {
    /**
     * @param vertexSrc - Vertex shader
     * @param fragTemplate - Fragment shader template
     */ function BatchShaderGenerator(vertexSrc, fragTemplate) {
        this.vertexSrc = vertexSrc;
        this.fragTemplate = fragTemplate;
        this.programCache = {};
        this.defaultGroupCache = {};
        if (fragTemplate.indexOf('%count%') < 0) throw new Error('Fragment template must contain "%count%".');
        if (fragTemplate.indexOf('%forloop%') < 0) throw new Error('Fragment template must contain "%forloop%".');
    }
    BatchShaderGenerator.prototype.generateShader = function(maxTextures) {
        if (!this.programCache[maxTextures]) {
            var sampleValues = new Int32Array(maxTextures);
            for(var i = 0; i < maxTextures; i++)sampleValues[i] = i;
            this.defaultGroupCache[maxTextures] = UniformGroup.from({
                uSamplers: sampleValues
            }, true);
            var fragmentSrc = this.fragTemplate;
            fragmentSrc = fragmentSrc.replace(/%count%/gi, "" + maxTextures);
            fragmentSrc = fragmentSrc.replace(/%forloop%/gi, this.generateSampleSrc(maxTextures));
            this.programCache[maxTextures] = new Program(this.vertexSrc, fragmentSrc);
        }
        var uniforms = {
            tint: new Float32Array([
                1,
                1,
                1,
                1
            ]),
            translationMatrix: new (0, $6qzqq.Matrix)(),
            default: this.defaultGroupCache[maxTextures]
        };
        return new Shader(this.programCache[maxTextures], uniforms);
    };
    BatchShaderGenerator.prototype.generateSampleSrc = function(maxTextures) {
        var src = '';
        src += '\n';
        src += '\n';
        for(var i = 0; i < maxTextures; i++){
            if (i > 0) src += '\nelse ';
            if (i < maxTextures - 1) src += "if(vTextureId < " + i + ".5)";
            src += '\n{';
            src += "\n\tcolor = texture2D(uSamplers[" + i + "], vTextureCoord);";
            src += '\n}';
        }
        src += '\n';
        src += '\n';
        return src;
    };
    return BatchShaderGenerator;
}();
/**
 * Geometry used to batch standard PIXI content (e.g. Mesh, Sprite, Graphics objects).
 *
 * @memberof PIXI
 */ var BatchGeometry = /** @class */ function(_super) {
    __extends(BatchGeometry, _super);
    /**
     * @param {boolean} [_static=false] - Optimization flag, where `false`
     *        is updated every frame, `true` doesn't change frame-to-frame.
     */ function BatchGeometry(_static) {
        if (_static === void 0) _static = false;
        var _this = _super.call(this) || this;
        _this._buffer = new Buffer(null, _static, false);
        _this._indexBuffer = new Buffer(null, _static, true);
        _this.addAttribute('aVertexPosition', _this._buffer, 2, false, (0, $P8XPi.TYPES).FLOAT).addAttribute('aTextureCoord', _this._buffer, 2, false, (0, $P8XPi.TYPES).FLOAT).addAttribute('aColor', _this._buffer, 4, true, (0, $P8XPi.TYPES).UNSIGNED_BYTE).addAttribute('aTextureId', _this._buffer, 1, true, (0, $P8XPi.TYPES).FLOAT).addIndex(_this._indexBuffer);
        return _this;
    }
    return BatchGeometry;
}(Geometry);
var defaultVertex$3 = "precision highp float;\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\nattribute float aTextureId;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform vec4 tint;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\n\nvoid main(void){\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vTextureId = aTextureId;\n    vColor = aColor * tint;\n}\n";
var defaultFragment$2 = "varying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\nuniform sampler2D uSamplers[%count%];\n\nvoid main(void){\n    vec4 color;\n    %forloop%\n    gl_FragColor = color * vColor;\n}\n";
/** @memberof PIXI */ var BatchPluginFactory = /** @class */ function() {
    function BatchPluginFactory() {}
    /**
     * Create a new BatchRenderer plugin for Renderer. this convenience can provide an easy way
     * to extend BatchRenderer with all the necessary pieces.
     * @example
     * const fragment = `
     * varying vec2 vTextureCoord;
     * varying vec4 vColor;
     * varying float vTextureId;
     * uniform sampler2D uSamplers[%count%];
     *
     * void main(void){
     *     vec4 color;
     *     %forloop%
     *     gl_FragColor = vColor * vec4(color.a - color.rgb, color.a);
     * }
     * `;
     * const InvertBatchRenderer = PIXI.BatchPluginFactory.create({ fragment });
     * PIXI.Renderer.registerPlugin('invert', InvertBatchRenderer);
     * const sprite = new PIXI.Sprite();
     * sprite.pluginName = 'invert';
     *
     * @param {object} [options]
     * @param {string} [options.vertex=PIXI.BatchPluginFactory.defaultVertexSrc] - Vertex shader source
     * @param {string} [options.fragment=PIXI.BatchPluginFactory.defaultFragmentTemplate] - Fragment shader template
     * @param {number} [options.vertexSize=6] - Vertex size
     * @param {object} [options.geometryClass=PIXI.BatchGeometry]
     * @return {*} New batch renderer plugin
     */ BatchPluginFactory.create = function(options) {
        var _a = Object.assign({
            vertex: defaultVertex$3,
            fragment: defaultFragment$2,
            geometryClass: BatchGeometry,
            vertexSize: 6
        }, options), vertex = _a.vertex, fragment = _a.fragment, vertexSize = _a.vertexSize, geometryClass = _a.geometryClass;
        return /** @class */ function(_super) {
            __extends(BatchPlugin, _super);
            function BatchPlugin(renderer) {
                var _this = _super.call(this, renderer) || this;
                _this.shaderGenerator = new BatchShaderGenerator(vertex, fragment);
                _this.geometryClass = geometryClass;
                _this.vertexSize = vertexSize;
                return _this;
            }
            return BatchPlugin;
        }(AbstractBatchRenderer);
    };
    Object.defineProperty(BatchPluginFactory, "defaultVertexSrc", {
        /**
         * The default vertex shader source
         *
         * @readonly
         */ get: function() {
            return defaultVertex$3;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BatchPluginFactory, "defaultFragmentTemplate", {
        /**
         * The default fragment shader source
         *
         * @readonly
         */ get: function() {
            return defaultFragment$2;
        },
        enumerable: false,
        configurable: true
    });
    return BatchPluginFactory;
}();
// Setup the default BatchRenderer plugin, this is what
// we'll actually export at the root level
var BatchRenderer = BatchPluginFactory.create();
/**
 * @memberof PIXI
 * @namespace resources
 * @see PIXI
 * @deprecated since 6.0.0
 */ var resources = {};
var _loop_1 = function(name) {
    Object.defineProperty(resources, name, {
        get: function() {
            (0, $csytw.deprecation)('6.0.0', "PIXI.systems." + name + " has moved to PIXI." + name);
            return _resources[name];
        }
    });
};
for(var name in _resources)_loop_1(name);
/**
 * @memberof PIXI
 * @namespace systems
 * @see PIXI
 * @deprecated since 6.0.0
 */ var systems = {};
var _loop_2 = function(name) {
    Object.defineProperty(systems, name, {
        get: function() {
            (0, $csytw.deprecation)('6.0.0', "PIXI.resources." + name + " has moved to PIXI." + name);
            return _systems[name];
        }
    });
};
for(var name in _systems)_loop_2(name);

});
parcelRegister("6fZag", function(module, exports) {

$parcel$export(module.exports, "Runner", function () { return $48e396c9ff697e5b$export$571ad3bcba5a0c45; });
/*!
 * @pixi/runner - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/runner is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * A Runner is a highly performant and simple alternative to signals. Best used in situations
 * where events are dispatched to many objects at high frequency (say every frame!)
 *
 *
 * like a signal..
 * ```
 * import { Runner } from '@pixi/runner';
 *
 * const myObject = {
 *     loaded: new Runner('loaded')
 * }
 *
 * const listener = {
 *     loaded: function(){
 *         // thin
 *     }
 * }
 *
 * myObject.loaded.add(listener);
 *
 * myObject.loaded.emit();
 * ```
 *
 * Or for handling calling the same function on many items
 * ```
 * import { Runner } from '@pixi/runner';
 *
 * const myGame = {
 *     update: new Runner('update')
 * }
 *
 * const gameObject = {
 *     update: function(time){
 *         // update my gamey state
 *     }
 * }
 *
 * myGame.update.add(gameObject);
 *
 * myGame.update.emit(time);
 * ```
 *
 * @memberof PIXI
 */ var $48e396c9ff697e5b$export$571ad3bcba5a0c45 = /** @class */ function() {
    /**
     * @param name - The function name that will be executed on the listeners added to this Runner.
     */ function Runner(name) {
        this.items = [];
        this._name = name;
        this._aliasCount = 0;
    }
    /**
     * Dispatch/Broadcast Runner to all listeners added to the queue.
     *
     * @param {...any} params - (optional) parameters to pass to each listener
     */ Runner.prototype.emit = function(a0, a1, a2, a3, a4, a5, a6, a7) {
        if (arguments.length > 8) throw new Error('max arguments reached');
        var _a = this, name = _a.name, items = _a.items;
        this._aliasCount++;
        for(var i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        if (items === this.items) this._aliasCount--;
        return this;
    };
    Runner.prototype.ensureNonAliasedItems = function() {
        if (this._aliasCount > 0 && this.items.length > 1) {
            this._aliasCount = 0;
            this.items = this.items.slice(0);
        }
    };
    /**
     * Add a listener to the Runner
     *
     * Runners do not need to have scope or functions passed to them.
     * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
     * as the name provided to the Runner when it was created.
     *
     * Eg A listener passed to this Runner will require a 'complete' function.
     *
     * ```
     * import { Runner } from '@pixi/runner';
     *
     * const complete = new Runner('complete');
     * ```
     *
     * The scope used will be the object itself.
     *
     * @param {any} item - The object that will be listening.
     */ Runner.prototype.add = function(item) {
        if (item[this._name]) {
            this.ensureNonAliasedItems();
            this.remove(item);
            this.items.push(item);
        }
        return this;
    };
    /**
     * Remove a single listener from the dispatch queue.
     *
     * @param {any} item - The listener that you would like to remove.
     */ Runner.prototype.remove = function(item) {
        var index = this.items.indexOf(item);
        if (index !== -1) {
            this.ensureNonAliasedItems();
            this.items.splice(index, 1);
        }
        return this;
    };
    /**
     * Check to see if the listener is already in the Runner
     *
     * @param {any} item - The listener that you would like to check.
     */ Runner.prototype.contains = function(item) {
        return this.items.indexOf(item) !== -1;
    };
    /** Remove all listeners from the Runner */ Runner.prototype.removeAll = function() {
        this.ensureNonAliasedItems();
        this.items.length = 0;
        return this;
    };
    /** Remove all references, don't use after this. */ Runner.prototype.destroy = function() {
        this.removeAll();
        this.items = null;
        this._name = null;
    };
    Object.defineProperty(Runner.prototype, "empty", {
        /**
         * `true` if there are no this Runner contains no listeners
         *
         * @readonly
         */ get: function() {
            return this.items.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Runner.prototype, "name", {
        /**
         * The name of the runner.
         *
         * @readonly
         */ get: function() {
            return this._name;
        },
        enumerable: false,
        configurable: true
    });
    return Runner;
}();
Object.defineProperties($48e396c9ff697e5b$export$571ad3bcba5a0c45.prototype, {
    /**
     * Alias for `emit`
     * @memberof PIXI.Runner#
     * @method dispatch
     * @see PIXI.Runner#emit
     */ dispatch: {
        value: $48e396c9ff697e5b$export$571ad3bcba5a0c45.prototype.emit
    },
    /**
     * Alias for `emit`
     * @memberof PIXI.Runner#
     * @method run
     * @see PIXI.Runner#emit
     */ run: {
        value: $48e396c9ff697e5b$export$571ad3bcba5a0c45.prototype.emit
    }
});

});



parcelRegister("3bQv9", function(module, exports) {

$parcel$export(module.exports, "Extract", function () { return $252b1fdb6b3c4af2$export$296daa4fd2384194; });
/*!
 * @pixi/extract - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/extract is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $csytw = parcelRequire("csytw");

var $6qzqq = parcelRequire("6qzqq");

var $klOfb = parcelRequire("klOfb");
var $252b1fdb6b3c4af2$var$TEMP_RECT = new (0, $6qzqq.Rectangle)();
var $252b1fdb6b3c4af2$var$BYTES_PER_PIXEL = 4;
/**
 * This class provides renderer-specific plugins for exporting content from a renderer.
 * For instance, these plugins can be used for saving an Image, Canvas element or for exporting the raw image data (pixels).
 *
 * Do not instantiate these plugins directly. It is available from the `renderer.plugins` property.
 * See {@link PIXI.CanvasRenderer#plugins} or {@link PIXI.Renderer#plugins}.
 * @example
 * // Create a new app (will auto-add extract plugin to renderer)
 * const app = new PIXI.Application();
 *
 * // Draw a red circle
 * const graphics = new PIXI.Graphics()
 *     .beginFill(0xFF0000)
 *     .drawCircle(0, 0, 50);
 *
 * // Render the graphics as an HTMLImageElement
 * const image = app.renderer.plugins.extract.image(graphics);
 * document.body.appendChild(image);
 * @class
 * @memberof PIXI
 */ var $252b1fdb6b3c4af2$export$296daa4fd2384194 = /** @class */ function() {
    /**
     * @param {PIXI.Renderer} renderer - A reference to the current renderer
     */ function Extract(renderer) {
        this.renderer = renderer;
    }
    /**
     * Will return a HTML Image of the target
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use the main renderer
     * @param {string} [format] - Image format, e.g. "image/jpeg" or "image/webp".
     * @param {number} [quality] - JPEG or Webp compression from 0 to 1. Default is 0.92.
     * @return {HTMLImageElement} HTML Image of the target
     */ Extract.prototype.image = function(target, format, quality) {
        var image = new Image();
        image.src = this.base64(target, format, quality);
        return image;
    };
    /**
     * Will return a a base64 encoded string of this target. It works by calling
     *  `Extract.getCanvas` and then running toDataURL on that.
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use the main renderer
     * @param {string} [format] - Image format, e.g. "image/jpeg" or "image/webp".
     * @param {number} [quality] - JPEG or Webp compression from 0 to 1. Default is 0.92.
     * @return {string} A base64 encoded string of the texture.
     */ Extract.prototype.base64 = function(target, format, quality) {
        return this.canvas(target).toDataURL(format, quality);
    };
    /**
     * Creates a Canvas element, renders this target to it and then returns it.
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use the main renderer
     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
     */ Extract.prototype.canvas = function(target) {
        var renderer = this.renderer;
        var resolution;
        var frame;
        var flipY = false;
        var renderTexture;
        var generated = false;
        if (target) {
            if (target instanceof (0, $klOfb.RenderTexture)) renderTexture = target;
            else {
                renderTexture = this.renderer.generateTexture(target);
                generated = true;
            }
        }
        if (renderTexture) {
            resolution = renderTexture.baseTexture.resolution;
            frame = renderTexture.frame;
            flipY = false;
            renderer.renderTexture.bind(renderTexture);
        } else {
            resolution = this.renderer.resolution;
            flipY = true;
            frame = $252b1fdb6b3c4af2$var$TEMP_RECT;
            frame.width = this.renderer.width;
            frame.height = this.renderer.height;
            renderer.renderTexture.bind(null);
        }
        var width = Math.floor(frame.width * resolution + 1e-4);
        var height = Math.floor(frame.height * resolution + 1e-4);
        var canvasBuffer = new (0, $csytw.CanvasRenderTarget)(width, height, 1);
        var webglPixels = new Uint8Array($252b1fdb6b3c4af2$var$BYTES_PER_PIXEL * width * height);
        // read pixels to the array
        var gl = renderer.gl;
        gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
        // add the pixels to the canvas
        var canvasData = canvasBuffer.context.getImageData(0, 0, width, height);
        Extract.arrayPostDivide(webglPixels, canvasData.data);
        canvasBuffer.context.putImageData(canvasData, 0, 0);
        // pulling pixels
        if (flipY) {
            var target_1 = new (0, $csytw.CanvasRenderTarget)(canvasBuffer.width, canvasBuffer.height, 1);
            target_1.context.scale(1, -1);
            // we can't render to itself because we should be empty before render.
            target_1.context.drawImage(canvasBuffer.canvas, 0, -height);
            canvasBuffer.destroy();
            canvasBuffer = target_1;
        }
        if (generated) renderTexture.destroy(true);
        // send the canvas back..
        return canvasBuffer.canvas;
    };
    /**
     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
     * order, with integer values between 0 and 255 (included).
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use the main renderer
     * @return {Uint8Array} One-dimensional array containing the pixel data of the entire texture
     */ Extract.prototype.pixels = function(target) {
        var renderer = this.renderer;
        var resolution;
        var frame;
        var renderTexture;
        var generated = false;
        if (target) {
            if (target instanceof (0, $klOfb.RenderTexture)) renderTexture = target;
            else {
                renderTexture = this.renderer.generateTexture(target);
                generated = true;
            }
        }
        if (renderTexture) {
            resolution = renderTexture.baseTexture.resolution;
            frame = renderTexture.frame;
            // bind the buffer
            renderer.renderTexture.bind(renderTexture);
        } else {
            resolution = renderer.resolution;
            frame = $252b1fdb6b3c4af2$var$TEMP_RECT;
            frame.width = renderer.width;
            frame.height = renderer.height;
            renderer.renderTexture.bind(null);
        }
        var width = frame.width * resolution;
        var height = frame.height * resolution;
        var webglPixels = new Uint8Array($252b1fdb6b3c4af2$var$BYTES_PER_PIXEL * width * height);
        // read pixels to the array
        var gl = renderer.gl;
        gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
        if (generated) renderTexture.destroy(true);
        Extract.arrayPostDivide(webglPixels, webglPixels);
        return webglPixels;
    };
    /**
     * Destroys the extract
     *
     */ Extract.prototype.destroy = function() {
        this.renderer = null;
    };
    /**
     * Takes premultiplied pixel data and produces regular pixel data
     *
     * @private
     * @param {number[] | Uint8Array | Uint8ClampedArray} pixels - array of pixel data
     * @param {number[] | Uint8Array | Uint8ClampedArray} out - output array
     */ Extract.arrayPostDivide = function(pixels, out) {
        for(var i = 0; i < pixels.length; i += 4){
            var alpha = out[i + 3] = pixels[i + 3];
            if (alpha !== 0) {
                out[i] = Math.round(Math.min(pixels[i] * 255.0 / alpha, 255.0));
                out[i + 1] = Math.round(Math.min(pixels[i + 1] * 255.0 / alpha, 255.0));
                out[i + 2] = Math.round(Math.min(pixels[i + 2] * 255.0 / alpha, 255.0));
            } else {
                out[i] = pixels[i];
                out[i + 1] = pixels[i + 1];
                out[i + 2] = pixels[i + 2];
            }
        }
    };
    return Extract;
}();

});

parcelRegister("kXE1p", function(module, exports) {

$parcel$export(module.exports, "LoaderResource", function () { return $f4285cd755ab388f$export$3a2d98834c8b0432; });
$parcel$export(module.exports, "Loader", function () { return $f4285cd755ab388f$export$3b0d6d7590275603; });
$parcel$export(module.exports, "AppLoaderPlugin", function () { return $f4285cd755ab388f$export$4d6e8fa105d8152b; });
$parcel$export(module.exports, "TextureLoader", function () { return $f4285cd755ab388f$export$fd1bfc71f64c538c; });
/*!
 * @pixi/loaders - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/loaders is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");
/* jshint -W097 */ /**
 * @memberof PIXI
 */ var $f4285cd755ab388f$var$SignalBinding = /** @class */ function() {
    /**
     * SignalBinding constructor.
     * @constructs SignalBinding
     * @param {Function} fn - Event handler to be called.
     * @param {Boolean} [once=false] - Should this listener be removed after dispatch
     * @param {object} [thisArg] - The context of the callback function.
     * @api private
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    function SignalBinding(fn, once, thisArg) {
        if (once === void 0) once = false;
        this._fn = fn;
        this._once = once;
        this._thisArg = thisArg;
        this._next = this._prev = this._owner = null;
    }
    SignalBinding.prototype.detach = function() {
        if (this._owner === null) return false;
        this._owner.detach(this);
        return true;
    };
    return SignalBinding;
}();
/**
 * @private
 */ function $f4285cd755ab388f$var$_addSignalBinding(self1, node) {
    if (!self1._head) {
        self1._head = node;
        self1._tail = node;
    } else {
        self1._tail._next = node;
        node._prev = self1._tail;
        self1._tail = node;
    }
    node._owner = self1;
    return node;
}
/**
 * @memberof PIXI
 */ var $f4285cd755ab388f$var$Signal = /** @class */ function() {
    /**
     * MiniSignal constructor.
     * @example
     * let mySignal = new Signal();
     * let binding = mySignal.add(onSignal);
     * mySignal.dispatch('foo', 'bar');
     * mySignal.detach(binding);
     */ function Signal() {
        this._head = this._tail = undefined;
    }
    /**
     * Return an array of attached SignalBinding.
     *
     * @param {Boolean} [exists=false] - We only need to know if there are handlers.
     * @returns {PIXI.SignalBinding[]|Boolean} Array of attached SignalBinding or Boolean if called with exists = true
     * @api public
     */ Signal.prototype.handlers = function(exists) {
        if (exists === void 0) exists = false;
        var node = this._head;
        if (exists) return !!node;
        var ee = [];
        while(node){
            ee.push(node);
            node = node._next;
        }
        return ee;
    };
    /**
     * Return true if node is a SignalBinding attached to this MiniSignal
     *
     * @param {PIXI.SignalBinding} node - Node to check.
     * @returns {Boolean} True if node is attache to mini-signal
     */ Signal.prototype.has = function(node) {
        if (!(node instanceof $f4285cd755ab388f$var$SignalBinding)) throw new Error('MiniSignal#has(): First arg must be a SignalBinding object.');
        return node._owner === this;
    };
    /**
     * Dispaches a signal to all registered listeners.
     *
     * @returns {Boolean} Indication if we've emitted an event.
     */ Signal.prototype.dispatch = function() {
        var arguments$1 = arguments;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments$1[_i];
        var node = this._head;
        if (!node) return false;
        while(node){
            if (node._once) this.detach(node);
            node._fn.apply(node._thisArg, args);
            node = node._next;
        }
        return true;
    };
    /**
     * Register a new listener.
     *
     * @param {Function} fn - Callback function.
     * @param {object} [thisArg] - The context of the callback function.
     * @returns {PIXI.SignalBinding} The SignalBinding node that was added.
     */ Signal.prototype.add = function(fn, thisArg) {
        if (thisArg === void 0) thisArg = null;
        if (typeof fn !== 'function') throw new Error('MiniSignal#add(): First arg must be a Function.');
        return $f4285cd755ab388f$var$_addSignalBinding(this, new $f4285cd755ab388f$var$SignalBinding(fn, false, thisArg));
    };
    /**
     * Register a new listener that will be executed only once.
     *
     * @param {Function} fn - Callback function.
     * @param {object} [thisArg] - The context of the callback function.
     * @returns {PIXI.SignalBinding} The SignalBinding node that was added.
     */ Signal.prototype.once = function(fn, thisArg) {
        if (thisArg === void 0) thisArg = null;
        if (typeof fn !== 'function') throw new Error('MiniSignal#once(): First arg must be a Function.');
        return $f4285cd755ab388f$var$_addSignalBinding(this, new $f4285cd755ab388f$var$SignalBinding(fn, true, thisArg));
    };
    /**
     * Remove binding object.
     *
     * @param {PIXI.SignalBinding} node - The binding node that will be removed.
     * @returns {Signal} The instance on which this method was called.
     * @api public */ Signal.prototype.detach = function(node) {
        if (!(node instanceof $f4285cd755ab388f$var$SignalBinding)) throw new Error('MiniSignal#detach(): First arg must be a SignalBinding object.');
        if (node._owner !== this) return this;
         // todo: or error?
        if (node._prev) node._prev._next = node._next;
        if (node._next) node._next._prev = node._prev;
        if (node === this._head) {
            this._head = node._next;
            if (node._next === null) this._tail = null;
        } else if (node === this._tail) {
            this._tail = node._prev;
            this._tail._next = null;
        }
        node._owner = null;
        return this;
    };
    /**
     * Detach all listeners.
     *
     * @returns {Signal} The instance on which this method was called.
     */ Signal.prototype.detachAll = function() {
        var node = this._head;
        if (!node) return this;
        this._head = this._tail = null;
        while(node){
            node._owner = null;
            node = node._next;
        }
        return this;
    };
    return Signal;
}();
/**
 * function from npm package `parseUri`, converted to TS to avoid leftpad incident
 * @param {string} str
 * @param [opts] - options
 * @param {boolean} [opts.strictMode] - type of parser
 */ function $f4285cd755ab388f$var$parseUri(str, opts) {
    opts = opts || {};
    var o = {
        // eslint-disable-next-line max-len
        key: [
            'source',
            'protocol',
            'authority',
            'userInfo',
            'user',
            'password',
            'host',
            'port',
            'relative',
            'path',
            'directory',
            'file',
            'query',
            'anchor'
        ],
        q: {
            name: 'queryKey',
            parser: /(?:^|&)([^&=]*)=?([^&]*)/g
        },
        parser: {
            // eslint-disable-next-line max-len
            strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
            // eslint-disable-next-line max-len
            loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
        }
    };
    var m = o.parser[opts.strictMode ? 'strict' : 'loose'].exec(str);
    var uri = {};
    var i = 14;
    while(i--)uri[o.key[i]] = m[i] || '';
    uri[o.q.name] = {};
    uri[o.key[12]].replace(o.q.parser, function(_t0, t1, t2) {
        if (t1) uri[o.q.name][t1] = t2;
    });
    return uri;
}
// tests if CORS is supported in XHR, if not we need to use XDR
var $f4285cd755ab388f$var$useXdr = !!(self.XDomainRequest && !('withCredentials' in new XMLHttpRequest()));
var $f4285cd755ab388f$var$tempAnchor = null;
// some status constants
var $f4285cd755ab388f$var$STATUS_NONE = 0;
var $f4285cd755ab388f$var$STATUS_OK = 200;
var $f4285cd755ab388f$var$STATUS_EMPTY = 204;
var $f4285cd755ab388f$var$STATUS_IE_BUG_EMPTY = 1223;
var $f4285cd755ab388f$var$STATUS_TYPE_OK = 2;
// noop
function $f4285cd755ab388f$var$_noop() {}
/**
 * Quick helper to set a value on one of the extension maps. Ensures there is no
 * dot at the start of the extension.
 *
 * @ignore
 * @param map - The map to set on.
 * @param extname - The extension (or key) to set.
 * @param val - The value to set.
 */ function $f4285cd755ab388f$var$setExtMap(map, extname, val) {
    if (extname && extname.indexOf('.') === 0) extname = extname.substring(1);
    if (!extname) return;
    map[extname] = val;
}
/**
 * Quick helper to get string xhr type.
 *
 * @ignore
 * @param xhr - The request to check.
 * @return The type.
 */ function $f4285cd755ab388f$var$reqType(xhr) {
    return xhr.toString().replace('object ', '');
}
/**
 * Manages the state and loading of a resource and all child resources.
 *
 * Can be extended in `GlobalMixins.LoaderResource`.
 *
 * @memberof PIXI
 */ var $f4285cd755ab388f$export$3a2d98834c8b0432 = /** @class */ function() {
    /**
     * @param {string} name - The name of the resource to load.
     * @param {string|string[]} url - The url for this resource, for audio/video loads you can pass
     *      an array of sources.
     * @param {object} [options] - The options for the load.
     * @param {string|boolean} [options.crossOrigin] - Is this request cross-origin? Default is to
     *      determine automatically.
     * @param {number} [options.timeout=0] - A timeout in milliseconds for the load. If the load takes
     *      longer than this time it is cancelled and the load is considered a failure. If this value is
     *      set to `0` then there is no explicit timeout.
     * @param {PIXI.LoaderResource.LOAD_TYPE} [options.loadType=LOAD_TYPE.XHR] - How should this resource
     *      be loaded?
     * @param {PIXI.LoaderResource.XHR_RESPONSE_TYPE} [options.xhrType=XHR_RESPONSE_TYPE.DEFAULT] - How
     *      should the data being loaded be interpreted when using XHR?
     * @param {PIXI.LoaderResource.IMetadata} [options.metadata] - Extra configuration for middleware
     *      and the Resource object.
     */ function LoaderResource(name, url, options) {
        /**
         * The `dequeue` method that will be used a storage place for the async queue dequeue method
         * used privately by the loader.
         *
         * @private
         * @member {function}
         */ this._dequeue = $f4285cd755ab388f$var$_noop;
        /**
         * Used a storage place for the on load binding used privately by the loader.
         *
         * @private
         * @member {function}
         */ this._onLoadBinding = null;
        /**
         * The timer for element loads to check if they timeout.
         *
         * @private
         */ this._elementTimer = 0;
        /**
         * The `complete` function bound to this resource's context.
         *
         * @private
         * @type {function}
         */ this._boundComplete = null;
        /**
         * The `_onError` function bound to this resource's context.
         *
         * @private
         * @type {function}
         */ this._boundOnError = null;
        /**
         * The `_onProgress` function bound to this resource's context.
         *
         * @private
         * @type {function}
         */ this._boundOnProgress = null;
        /**
         * The `_onTimeout` function bound to this resource's context.
         *
         * @private
         * @type {function}
         */ this._boundOnTimeout = null;
        this._boundXhrOnError = null;
        this._boundXhrOnTimeout = null;
        this._boundXhrOnAbort = null;
        this._boundXhrOnLoad = null;
        if (typeof name !== 'string' || typeof url !== 'string') throw new Error('Both name and url are required for constructing a resource.');
        options = options || {};
        this._flags = 0;
        // set data url flag, needs to be set early for some _determineX checks to work.
        this._setFlag(LoaderResource.STATUS_FLAGS.DATA_URL, url.indexOf('data:') === 0);
        this.name = name;
        this.url = url;
        this.extension = this._getExtension();
        this.data = null;
        this.crossOrigin = options.crossOrigin === true ? 'anonymous' : options.crossOrigin;
        this.timeout = options.timeout || 0;
        this.loadType = options.loadType || this._determineLoadType();
        // The type used to load the resource via XHR. If unset, determined automatically.
        this.xhrType = options.xhrType;
        // Extra info for middleware, and controlling specifics about how the resource loads.
        // Note that if you pass in a `loadElement`, the Resource class takes ownership of it.
        // Meaning it will modify it as it sees fit.
        this.metadata = options.metadata || {};
        // The error that occurred while loading (if any).
        this.error = null;
        // The XHR object that was used to load this resource. This is only set
        // when `loadType` is `LoaderResource.LOAD_TYPE.XHR`.
        this.xhr = null;
        // The child resources this resource owns.
        this.children = [];
        // The resource type.
        this.type = LoaderResource.TYPE.UNKNOWN;
        // The progress chunk owned by this resource.
        this.progressChunk = 0;
        // The `dequeue` method that will be used a storage place for the async queue dequeue method
        // used privately by the loader.
        this._dequeue = $f4285cd755ab388f$var$_noop;
        // Used a storage place for the on load binding used privately by the loader.
        this._onLoadBinding = null;
        // The timer for element loads to check if they timeout.
        this._elementTimer = 0;
        this._boundComplete = this.complete.bind(this);
        this._boundOnError = this._onError.bind(this);
        this._boundOnProgress = this._onProgress.bind(this);
        this._boundOnTimeout = this._onTimeout.bind(this);
        // xhr callbacks
        this._boundXhrOnError = this._xhrOnError.bind(this);
        this._boundXhrOnTimeout = this._xhrOnTimeout.bind(this);
        this._boundXhrOnAbort = this._xhrOnAbort.bind(this);
        this._boundXhrOnLoad = this._xhrOnLoad.bind(this);
        // Dispatched when the resource beings to load.
        this.onStart = new $f4285cd755ab388f$var$Signal();
        // Dispatched each time progress of this resource load updates.
        // Not all resources types and loader systems can support this event
        // so sometimes it may not be available. If the resource
        // is being loaded on a modern browser, using XHR, and the remote server
        // properly sets Content-Length headers, then this will be available.
        this.onProgress = new $f4285cd755ab388f$var$Signal();
        // Dispatched once this resource has loaded, if there was an error it will
        // be in the `error` property.
        this.onComplete = new $f4285cd755ab388f$var$Signal();
        // Dispatched after this resource has had all the *after* middleware run on it.
        this.onAfterMiddleware = new $f4285cd755ab388f$var$Signal();
    }
    /**
     * Sets the load type to be used for a specific extension.
     *
     * @static
     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
     * @param {PIXI.LoaderResource.LOAD_TYPE} loadType - The load type to set it to.
     */ LoaderResource.setExtensionLoadType = function(extname, loadType) {
        $f4285cd755ab388f$var$setExtMap(LoaderResource._loadTypeMap, extname, loadType);
    };
    /**
     * Sets the load type to be used for a specific extension.
     *
     * @static
     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
     * @param {PIXI.LoaderResource.XHR_RESPONSE_TYPE} xhrType - The xhr type to set it to.
     */ LoaderResource.setExtensionXhrType = function(extname, xhrType) {
        $f4285cd755ab388f$var$setExtMap(LoaderResource._xhrTypeMap, extname, xhrType);
    };
    Object.defineProperty(LoaderResource.prototype, "isDataUrl", {
        /**
         * When the resource starts to load.
         *
         * @memberof PIXI.LoaderResource
         * @callback OnStartSignal
         * @param {Resource} resource - The resource that the event happened on.
         */ /**
         * When the resource reports loading progress.
         *
         * @memberof PIXI.LoaderResource
         * @callback OnProgressSignal
         * @param {Resource} resource - The resource that the event happened on.
         * @param {number} percentage - The progress of the load in the range [0, 1].
         */ /**
         * When the resource finishes loading.
         *
         * @memberof PIXI.LoaderResource
         * @callback OnCompleteSignal
         * @param {Resource} resource - The resource that the event happened on.
         */ /**
         * @memberof PIXI.LoaderResource
         * @typedef {object} IMetadata
         * @property {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [loadElement=null] - The
         *      element to use for loading, instead of creating one.
         * @property {boolean} [skipSource=false] - Skips adding source(s) to the load element. This
         *      is useful if you want to pass in a `loadElement` that you already added load sources to.
         * @property {string|string[]} [mimeType] - The mime type to use for the source element
         *      of a video/audio elment. If the urls are an array, you can pass this as an array as well
         *      where each index is the mime type to use for the corresponding url index.
         */ /**
         * Stores whether or not this url is a data url.
         *
         * @readonly
         * @member {boolean}
         */ get: function() {
            return this._hasFlag(LoaderResource.STATUS_FLAGS.DATA_URL);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoaderResource.prototype, "isComplete", {
        /**
         * Describes if this resource has finished loading. Is true when the resource has completely
         * loaded.
         *
         * @readonly
         * @member {boolean}
         */ get: function() {
            return this._hasFlag(LoaderResource.STATUS_FLAGS.COMPLETE);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LoaderResource.prototype, "isLoading", {
        /**
         * Describes if this resource is currently loading. Is true when the resource starts loading,
         * and is false again when complete.
         *
         * @readonly
         * @member {boolean}
         */ get: function() {
            return this._hasFlag(LoaderResource.STATUS_FLAGS.LOADING);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Marks the resource as complete.
     *
     */ LoaderResource.prototype.complete = function() {
        this._clearEvents();
        this._finish();
    };
    /**
     * Aborts the loading of this resource, with an optional message.
     *
     * @param {string} message - The message to use for the error
     */ LoaderResource.prototype.abort = function(message) {
        // abort can be called multiple times, ignore subsequent calls.
        if (this.error) return;
        // store error
        this.error = new Error(message);
        // clear events before calling aborts
        this._clearEvents();
        // abort the actual loading
        if (this.xhr) this.xhr.abort();
        else if (this.xdr) this.xdr.abort();
        else if (this.data) {
            // single source
            if (this.data.src) this.data.src = LoaderResource.EMPTY_GIF;
            else while(this.data.firstChild)this.data.removeChild(this.data.firstChild);
        }
        // done now.
        this._finish();
    };
    /**
     * Kicks off loading of this resource. This method is asynchronous.
     *
     * @param {PIXI.LoaderResource.OnCompleteSignal} [cb] - Optional callback to call once the resource is loaded.
     */ LoaderResource.prototype.load = function(cb) {
        var _this = this;
        if (this.isLoading) return;
        if (this.isComplete) {
            if (cb) setTimeout(function() {
                return cb(_this);
            }, 1);
            return;
        } else if (cb) this.onComplete.once(cb);
        this._setFlag(LoaderResource.STATUS_FLAGS.LOADING, true);
        this.onStart.dispatch(this);
        // if unset, determine the value
        if (this.crossOrigin === false || typeof this.crossOrigin !== 'string') this.crossOrigin = this._determineCrossOrigin(this.url);
        switch(this.loadType){
            case LoaderResource.LOAD_TYPE.IMAGE:
                this.type = LoaderResource.TYPE.IMAGE;
                this._loadElement('image');
                break;
            case LoaderResource.LOAD_TYPE.AUDIO:
                this.type = LoaderResource.TYPE.AUDIO;
                this._loadSourceElement('audio');
                break;
            case LoaderResource.LOAD_TYPE.VIDEO:
                this.type = LoaderResource.TYPE.VIDEO;
                this._loadSourceElement('video');
                break;
            case LoaderResource.LOAD_TYPE.XHR:
            /* falls through */ default:
                if ($f4285cd755ab388f$var$useXdr && this.crossOrigin) this._loadXdr();
                else this._loadXhr();
                break;
        }
    };
    /**
     * Checks if the flag is set.
     *
     * @param flag - The flag to check.
     * @return True if the flag is set.
     */ LoaderResource.prototype._hasFlag = function(flag) {
        return (this._flags & flag) !== 0;
    };
    /**
     * (Un)Sets the flag.
     *
     * @param flag - The flag to (un)set.
     * @param value - Whether to set or (un)set the flag.
     */ LoaderResource.prototype._setFlag = function(flag, value) {
        this._flags = value ? this._flags | flag : this._flags & ~flag;
    };
    /**
     * Clears all the events from the underlying loading source.
     */ LoaderResource.prototype._clearEvents = function() {
        clearTimeout(this._elementTimer);
        if (this.data && this.data.removeEventListener) {
            this.data.removeEventListener('error', this._boundOnError, false);
            this.data.removeEventListener('load', this._boundComplete, false);
            this.data.removeEventListener('progress', this._boundOnProgress, false);
            this.data.removeEventListener('canplaythrough', this._boundComplete, false);
        }
        if (this.xhr) {
            if (this.xhr.removeEventListener) {
                this.xhr.removeEventListener('error', this._boundXhrOnError, false);
                this.xhr.removeEventListener('timeout', this._boundXhrOnTimeout, false);
                this.xhr.removeEventListener('abort', this._boundXhrOnAbort, false);
                this.xhr.removeEventListener('progress', this._boundOnProgress, false);
                this.xhr.removeEventListener('load', this._boundXhrOnLoad, false);
            } else {
                this.xhr.onerror = null;
                this.xhr.ontimeout = null;
                this.xhr.onprogress = null;
                this.xhr.onload = null;
            }
        }
    };
    /**
     * Finalizes the load.
     */ LoaderResource.prototype._finish = function() {
        if (this.isComplete) throw new Error('Complete called again for an already completed resource.');
        this._setFlag(LoaderResource.STATUS_FLAGS.COMPLETE, true);
        this._setFlag(LoaderResource.STATUS_FLAGS.LOADING, false);
        this.onComplete.dispatch(this);
    };
    /**
     * Loads this resources using an element that has a single source,
     * like an HTMLImageElement.
     * @private
     * @param type - The type of element to use.
     */ LoaderResource.prototype._loadElement = function(type) {
        if (this.metadata.loadElement) this.data = this.metadata.loadElement;
        else if (type === 'image' && typeof self.Image !== 'undefined') this.data = new Image();
        else this.data = document.createElement(type);
        if (this.crossOrigin) this.data.crossOrigin = this.crossOrigin;
        if (!this.metadata.skipSource) this.data.src = this.url;
        this.data.addEventListener('error', this._boundOnError, false);
        this.data.addEventListener('load', this._boundComplete, false);
        this.data.addEventListener('progress', this._boundOnProgress, false);
        if (this.timeout) this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout);
    };
    /**
     * Loads this resources using an element that has multiple sources,
     * like an HTMLAudioElement or HTMLVideoElement.
     * @param type - The type of element to use.
     */ LoaderResource.prototype._loadSourceElement = function(type) {
        if (this.metadata.loadElement) this.data = this.metadata.loadElement;
        else if (type === 'audio' && typeof self.Audio !== 'undefined') this.data = new Audio();
        else this.data = document.createElement(type);
        if (this.data === null) {
            this.abort("Unsupported element: " + type);
            return;
        }
        if (this.crossOrigin) this.data.crossOrigin = this.crossOrigin;
        if (!this.metadata.skipSource) {
            // support for CocoonJS Canvas+ runtime, lacks document.createElement('source')
            if (navigator.isCocoonJS) this.data.src = Array.isArray(this.url) ? this.url[0] : this.url;
            else if (Array.isArray(this.url)) {
                var mimeTypes = this.metadata.mimeType;
                for(var i = 0; i < this.url.length; ++i)this.data.appendChild(this._createSource(type, this.url[i], Array.isArray(mimeTypes) ? mimeTypes[i] : mimeTypes));
            } else {
                var mimeTypes = this.metadata.mimeType;
                this.data.appendChild(this._createSource(type, this.url, Array.isArray(mimeTypes) ? mimeTypes[0] : mimeTypes));
            }
        }
        this.data.addEventListener('error', this._boundOnError, false);
        this.data.addEventListener('load', this._boundComplete, false);
        this.data.addEventListener('progress', this._boundOnProgress, false);
        this.data.addEventListener('canplaythrough', this._boundComplete, false);
        this.data.load();
        if (this.timeout) this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout);
    };
    /**
     * Loads this resources using an XMLHttpRequest.
     */ LoaderResource.prototype._loadXhr = function() {
        // if unset, determine the value
        if (typeof this.xhrType !== 'string') this.xhrType = this._determineXhrType();
        var xhr = this.xhr = new XMLHttpRequest();
        // set the request type and url
        xhr.open('GET', this.url, true);
        xhr.timeout = this.timeout;
        // load json as text and parse it ourselves. We do this because some browsers
        // *cough* safari *cough* can't deal with it.
        if (this.xhrType === LoaderResource.XHR_RESPONSE_TYPE.JSON || this.xhrType === LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT) xhr.responseType = LoaderResource.XHR_RESPONSE_TYPE.TEXT;
        else xhr.responseType = this.xhrType;
        xhr.addEventListener('error', this._boundXhrOnError, false);
        xhr.addEventListener('timeout', this._boundXhrOnTimeout, false);
        xhr.addEventListener('abort', this._boundXhrOnAbort, false);
        xhr.addEventListener('progress', this._boundOnProgress, false);
        xhr.addEventListener('load', this._boundXhrOnLoad, false);
        xhr.send();
    };
    /**
     * Loads this resources using an XDomainRequest. This is here because we need to support IE9 (gross).
     */ LoaderResource.prototype._loadXdr = function() {
        // if unset, determine the value
        if (typeof this.xhrType !== 'string') this.xhrType = this._determineXhrType();
        var xdr = this.xhr = new self.XDomainRequest(); // eslint-disable-line no-undef
        // XDomainRequest has a few quirks. Occasionally it will abort requests
        // A way to avoid this is to make sure ALL callbacks are set even if not used
        // More info here: http://stackoverflow.com/questions/15786966/xdomainrequest-aborts-post-on-ie-9
        xdr.timeout = this.timeout || 5000; // XDR needs a timeout value or it breaks in IE9
        xdr.onerror = this._boundXhrOnError;
        xdr.ontimeout = this._boundXhrOnTimeout;
        xdr.onprogress = this._boundOnProgress;
        xdr.onload = this._boundXhrOnLoad;
        xdr.open('GET', this.url, true);
        // Note: The xdr.send() call is wrapped in a timeout to prevent an
        // issue with the interface where some requests are lost if multiple
        // XDomainRequests are being sent at the same time.
        // Some info here: https://github.com/photonstorm/phaser/issues/1248
        setTimeout(function() {
            return xdr.send();
        }, 1);
    };
    /**
     * Creates a source used in loading via an element.
     * @param type - The element type (video or audio).
     * @param url - The source URL to load from.
     * @param [mime] - The mime type of the video
     * @return The source element.
     */ LoaderResource.prototype._createSource = function(type, url, mime) {
        if (!mime) mime = type + "/" + this._getExtension(url);
        var source = document.createElement('source');
        source.src = url;
        source.type = mime;
        return source;
    };
    /**
     * Called if a load errors out.
     *
     * @param event - The error event from the element that emits it.
     */ LoaderResource.prototype._onError = function(event) {
        this.abort("Failed to load element using: " + event.target.nodeName);
    };
    /**
     * Called if a load progress event fires for an element or xhr/xdr.
     * @param event - Progress event.
     */ LoaderResource.prototype._onProgress = function(event) {
        if (event && event.lengthComputable) this.onProgress.dispatch(this, event.loaded / event.total);
    };
    /**
     * Called if a timeout event fires for an element.
     */ LoaderResource.prototype._onTimeout = function() {
        this.abort("Load timed out.");
    };
    /**
     * Called if an error event fires for xhr/xdr.
     */ LoaderResource.prototype._xhrOnError = function() {
        var xhr = this.xhr;
        this.abort($f4285cd755ab388f$var$reqType(xhr) + " Request failed. Status: " + xhr.status + ", text: \"" + xhr.statusText + "\"");
    };
    /**
     * Called if an error event fires for xhr/xdr.
     */ LoaderResource.prototype._xhrOnTimeout = function() {
        var xhr = this.xhr;
        this.abort($f4285cd755ab388f$var$reqType(xhr) + " Request timed out.");
    };
    /**
     * Called if an abort event fires for xhr/xdr.
     */ LoaderResource.prototype._xhrOnAbort = function() {
        var xhr = this.xhr;
        this.abort($f4285cd755ab388f$var$reqType(xhr) + " Request was aborted by the user.");
    };
    /**
     * Called when data successfully loads from an xhr/xdr request.
     */ LoaderResource.prototype._xhrOnLoad = function() {
        var xhr = this.xhr;
        var text = '';
        var status = typeof xhr.status === 'undefined' ? $f4285cd755ab388f$var$STATUS_OK : xhr.status; // XDR has no `.status`, assume 200.
        // responseText is accessible only if responseType is '' or 'text' and on older browsers
        if (xhr.responseType === '' || xhr.responseType === 'text' || typeof xhr.responseType === 'undefined') text = xhr.responseText;
        // status can be 0 when using the `file://` protocol so we also check if a response is set.
        // If it has a response, we assume 200; otherwise a 0 status code with no contents is an aborted request.
        if (status === $f4285cd755ab388f$var$STATUS_NONE && (text.length > 0 || xhr.responseType === LoaderResource.XHR_RESPONSE_TYPE.BUFFER)) status = $f4285cd755ab388f$var$STATUS_OK;
        else if (status === $f4285cd755ab388f$var$STATUS_IE_BUG_EMPTY) status = $f4285cd755ab388f$var$STATUS_EMPTY;
        var statusType = status / 100 | 0;
        if (statusType === $f4285cd755ab388f$var$STATUS_TYPE_OK) {
            // if text, just return it
            if (this.xhrType === LoaderResource.XHR_RESPONSE_TYPE.TEXT) {
                this.data = text;
                this.type = LoaderResource.TYPE.TEXT;
            } else if (this.xhrType === LoaderResource.XHR_RESPONSE_TYPE.JSON) try {
                this.data = JSON.parse(text);
                this.type = LoaderResource.TYPE.JSON;
            } catch (e) {
                this.abort("Error trying to parse loaded json: " + e);
                return;
            }
            else if (this.xhrType === LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT) try {
                if (self.DOMParser) {
                    var domparser = new DOMParser();
                    this.data = domparser.parseFromString(text, 'text/xml');
                } else {
                    var div = document.createElement('div');
                    div.innerHTML = text;
                    this.data = div;
                }
                this.type = LoaderResource.TYPE.XML;
            } catch (e$1) {
                this.abort("Error trying to parse loaded xml: " + e$1);
                return;
            }
            else this.data = xhr.response || text;
        } else {
            this.abort("[" + xhr.status + "] " + xhr.statusText + ": " + xhr.responseURL);
            return;
        }
        this.complete();
    };
    /**
     * Sets the `crossOrigin` property for this resource based on if the url
     * for this resource is cross-origin. If crossOrigin was manually set, this
     * function does nothing.
     * @private
     * @param url - The url to test.
     * @param [loc=self.location] - The location object to test against.
     * @return The crossOrigin value to use (or empty string for none).
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    LoaderResource.prototype._determineCrossOrigin = function(url, loc) {
        // data: and javascript: urls are considered same-origin
        if (url.indexOf('data:') === 0) return '';
        // A sandboxed iframe without the 'allow-same-origin' attribute will have a special
        // origin designed not to match self.location.origin, and will always require
        // crossOrigin requests regardless of whether the location matches.
        if (self.origin !== self.location.origin) return 'anonymous';
        // default is self.location
        loc = loc || self.location;
        if (!$f4285cd755ab388f$var$tempAnchor) $f4285cd755ab388f$var$tempAnchor = document.createElement('a');
        // let the browser determine the full href for the url of this resource and then
        // parse with the node url lib, we can't use the properties of the anchor element
        // because they don't work in IE9 :(
        $f4285cd755ab388f$var$tempAnchor.href = url;
        var parsedUrl = $f4285cd755ab388f$var$parseUri($f4285cd755ab388f$var$tempAnchor.href, {
            strictMode: true
        });
        var samePort = !parsedUrl.port && loc.port === '' || parsedUrl.port === loc.port;
        var protocol = parsedUrl.protocol ? parsedUrl.protocol + ":" : '';
        // if cross origin
        if (parsedUrl.host !== loc.hostname || !samePort || protocol !== loc.protocol) return 'anonymous';
        return '';
    };
    /**
     * Determines the responseType of an XHR request based on the extension of the
     * resource being loaded.
     *
     * @private
     * @return {PIXI.LoaderResource.XHR_RESPONSE_TYPE} The responseType to use.
     */ LoaderResource.prototype._determineXhrType = function() {
        return LoaderResource._xhrTypeMap[this.extension] || LoaderResource.XHR_RESPONSE_TYPE.TEXT;
    };
    /**
     * Determines the loadType of a resource based on the extension of the
     * resource being loaded.
     *
     * @private
     * @return {PIXI.LoaderResource.LOAD_TYPE} The loadType to use.
     */ LoaderResource.prototype._determineLoadType = function() {
        return LoaderResource._loadTypeMap[this.extension] || LoaderResource.LOAD_TYPE.XHR;
    };
    /**
     * Extracts the extension (sans '.') of the file being loaded by the resource.
     *
     * @param [url] - url to parse, `this.url` by default.
     * @return The extension.
     */ LoaderResource.prototype._getExtension = function(url) {
        if (url === void 0) url = this.url;
        var ext = '';
        if (this.isDataUrl) {
            var slashIndex = url.indexOf('/');
            ext = url.substring(slashIndex + 1, url.indexOf(';', slashIndex));
        } else {
            var queryStart = url.indexOf('?');
            var hashStart = url.indexOf('#');
            var index = Math.min(queryStart > -1 ? queryStart : url.length, hashStart > -1 ? hashStart : url.length);
            url = url.substring(0, index);
            ext = url.substring(url.lastIndexOf('.') + 1);
        }
        return ext.toLowerCase();
    };
    /**
     * Determines the mime type of an XHR request based on the responseType of
     * resource being loaded.
     *
     * @param type - The type to get a mime type for.
     * @private
     * @return The mime type to use.
     */ LoaderResource.prototype._getMimeFromXhrType = function(type) {
        switch(type){
            case LoaderResource.XHR_RESPONSE_TYPE.BUFFER:
                return 'application/octet-binary';
            case LoaderResource.XHR_RESPONSE_TYPE.BLOB:
                return 'application/blob';
            case LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT:
                return 'application/xml';
            case LoaderResource.XHR_RESPONSE_TYPE.JSON:
                return 'application/json';
            case LoaderResource.XHR_RESPONSE_TYPE.DEFAULT:
            case LoaderResource.XHR_RESPONSE_TYPE.TEXT:
            /* falls through */ default:
                return 'text/plain';
        }
    };
    return LoaderResource;
}();
// eslint-disable-next-line @typescript-eslint/no-namespace
(function(LoaderResource) {
    /**
     * The types of resources a resource could represent.
     *
     * @static
     * @readonly
     * @enum {number}
     * @memberof PIXI.LoaderResource
     */ var STATUS_FLAGS;
    (function(STATUS_FLAGS) {
        /** None */ STATUS_FLAGS[STATUS_FLAGS["NONE"] = 0] = "NONE";
        /** Data URL */ STATUS_FLAGS[STATUS_FLAGS["DATA_URL"] = 1] = "DATA_URL";
        /** Complete */ STATUS_FLAGS[STATUS_FLAGS["COMPLETE"] = 2] = "COMPLETE";
        /** Loading */ STATUS_FLAGS[STATUS_FLAGS["LOADING"] = 4] = "LOADING";
    })(STATUS_FLAGS = LoaderResource.STATUS_FLAGS || (LoaderResource.STATUS_FLAGS = {}));
    /**
     * The types of resources a resource could represent.
     *
     * @static
     * @readonly
     * @enum {number}
     * @memberof PIXI.LoaderResource
     */ var TYPE;
    (function(TYPE) {
        /** Unknown */ TYPE[TYPE["UNKNOWN"] = 0] = "UNKNOWN";
        /** JSON */ TYPE[TYPE["JSON"] = 1] = "JSON";
        /** XML */ TYPE[TYPE["XML"] = 2] = "XML";
        /** Image */ TYPE[TYPE["IMAGE"] = 3] = "IMAGE";
        /** Audio */ TYPE[TYPE["AUDIO"] = 4] = "AUDIO";
        /** Video */ TYPE[TYPE["VIDEO"] = 5] = "VIDEO";
        /** Plain text */ TYPE[TYPE["TEXT"] = 6] = "TEXT";
    })(TYPE = LoaderResource.TYPE || (LoaderResource.TYPE = {}));
    /**
     * The types of loading a resource can use.
     *
     * @static
     * @readonly
     * @enum {number}
     * @memberof PIXI.LoaderResource
     */ var LOAD_TYPE;
    (function(LOAD_TYPE) {
        /** Uses XMLHttpRequest to load the resource. */ LOAD_TYPE[LOAD_TYPE["XHR"] = 1] = "XHR";
        /** Uses an `Image` object to load the resource. */ LOAD_TYPE[LOAD_TYPE["IMAGE"] = 2] = "IMAGE";
        /** Uses an `Audio` object to load the resource. */ LOAD_TYPE[LOAD_TYPE["AUDIO"] = 3] = "AUDIO";
        /** Uses a `Video` object to load the resource. */ LOAD_TYPE[LOAD_TYPE["VIDEO"] = 4] = "VIDEO";
    })(LOAD_TYPE = LoaderResource.LOAD_TYPE || (LoaderResource.LOAD_TYPE = {}));
    /**
     * The XHR ready states, used internally.
     *
     * @static
     * @readonly
     * @enum {string}
     * @memberof PIXI.LoaderResource
     */ var XHR_RESPONSE_TYPE;
    (function(XHR_RESPONSE_TYPE) {
        /** string */ XHR_RESPONSE_TYPE["DEFAULT"] = "text";
        /** ArrayBuffer */ XHR_RESPONSE_TYPE["BUFFER"] = "arraybuffer";
        /** Blob */ XHR_RESPONSE_TYPE["BLOB"] = "blob";
        /** Document */ XHR_RESPONSE_TYPE["DOCUMENT"] = "document";
        /** Object */ XHR_RESPONSE_TYPE["JSON"] = "json";
        /** String */ XHR_RESPONSE_TYPE["TEXT"] = "text";
    })(XHR_RESPONSE_TYPE = LoaderResource.XHR_RESPONSE_TYPE || (LoaderResource.XHR_RESPONSE_TYPE = {}));
    LoaderResource._loadTypeMap = {
        // images
        gif: LoaderResource.LOAD_TYPE.IMAGE,
        png: LoaderResource.LOAD_TYPE.IMAGE,
        bmp: LoaderResource.LOAD_TYPE.IMAGE,
        jpg: LoaderResource.LOAD_TYPE.IMAGE,
        jpeg: LoaderResource.LOAD_TYPE.IMAGE,
        tif: LoaderResource.LOAD_TYPE.IMAGE,
        tiff: LoaderResource.LOAD_TYPE.IMAGE,
        webp: LoaderResource.LOAD_TYPE.IMAGE,
        tga: LoaderResource.LOAD_TYPE.IMAGE,
        svg: LoaderResource.LOAD_TYPE.IMAGE,
        'svg+xml': LoaderResource.LOAD_TYPE.IMAGE,
        // audio
        mp3: LoaderResource.LOAD_TYPE.AUDIO,
        ogg: LoaderResource.LOAD_TYPE.AUDIO,
        wav: LoaderResource.LOAD_TYPE.AUDIO,
        // videos
        mp4: LoaderResource.LOAD_TYPE.VIDEO,
        webm: LoaderResource.LOAD_TYPE.VIDEO
    };
    LoaderResource._xhrTypeMap = {
        // xml
        xhtml: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        html: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        htm: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        xml: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        tmx: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        svg: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        // This was added to handle Tiled Tileset XML, but .tsx is also a TypeScript React Component.
        // Since it is way less likely for people to be loading TypeScript files instead of Tiled files,
        // this should probably be fine.
        tsx: LoaderResource.XHR_RESPONSE_TYPE.DOCUMENT,
        // images
        gif: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        png: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        bmp: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        jpg: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        jpeg: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        tif: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        tiff: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        webp: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        tga: LoaderResource.XHR_RESPONSE_TYPE.BLOB,
        // json
        json: LoaderResource.XHR_RESPONSE_TYPE.JSON,
        // text
        text: LoaderResource.XHR_RESPONSE_TYPE.TEXT,
        txt: LoaderResource.XHR_RESPONSE_TYPE.TEXT,
        // fonts
        ttf: LoaderResource.XHR_RESPONSE_TYPE.BUFFER,
        otf: LoaderResource.XHR_RESPONSE_TYPE.BUFFER
    };
    // We can't set the `src` attribute to empty string, so on abort we set it to this 1px transparent gif
    LoaderResource.EMPTY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
})($f4285cd755ab388f$export$3a2d98834c8b0432 || ($f4285cd755ab388f$export$3a2d98834c8b0432 = {}));
/**
 * Smaller version of the async library constructs.
 * @ignore
 */ function $f4285cd755ab388f$var$_noop$1() {}
/**
 * Ensures a function is only called once.
 * @ignore
 * @param {function} fn - The function to wrap.
 * @return {function} The wrapping function.
 */ function $f4285cd755ab388f$var$onlyOnce(fn) {
    return function onceWrapper() {
        var arguments$1 = arguments;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments$1[_i];
        if (fn === null) throw new Error('Callback was already called.');
        var callFn = fn;
        fn = null;
        callFn.apply(this, args);
    };
}
/**
 * @private
 * @memberof PIXI
 */ var $f4285cd755ab388f$var$AsyncQueueItem = /** @class */ function() {
    /**
     * @private
     */ function AsyncQueueItem(data, callback) {
        this.data = data;
        this.callback = callback;
    }
    return AsyncQueueItem;
}();
/**
 * @private
 * @memberof PIXI
 */ var $f4285cd755ab388f$var$AsyncQueue = /** @class */ function() {
    /**
     * @private
     */ function AsyncQueue(worker, concurrency) {
        var _this = this;
        if (concurrency === void 0) concurrency = 1;
        this.workers = 0;
        this.saturated = $f4285cd755ab388f$var$_noop$1;
        this.unsaturated = $f4285cd755ab388f$var$_noop$1;
        this.empty = $f4285cd755ab388f$var$_noop$1;
        this.drain = $f4285cd755ab388f$var$_noop$1;
        this.error = $f4285cd755ab388f$var$_noop$1;
        this.started = false;
        this.paused = false;
        this._tasks = [];
        this._insert = function(data, insertAtFront, callback) {
            if (callback && typeof callback !== 'function') throw new Error('task callback must be a function');
            _this.started = true;
            // eslint-disable-next-line no-eq-null,eqeqeq
            if (data == null && _this.idle()) {
                // call drain immediately if there are no tasks
                setTimeout(function() {
                    return _this.drain();
                }, 1);
                return;
            }
            var item = new $f4285cd755ab388f$var$AsyncQueueItem(data, typeof callback === 'function' ? callback : $f4285cd755ab388f$var$_noop$1);
            if (insertAtFront) _this._tasks.unshift(item);
            else _this._tasks.push(item);
            setTimeout(_this.process, 1);
        };
        this.process = function() {
            while(!_this.paused && _this.workers < _this.concurrency && _this._tasks.length){
                var task = _this._tasks.shift();
                if (_this._tasks.length === 0) _this.empty();
                _this.workers += 1;
                if (_this.workers === _this.concurrency) _this.saturated();
                _this._worker(task.data, $f4285cd755ab388f$var$onlyOnce(_this._next(task)));
            }
        };
        this._worker = worker;
        if (concurrency === 0) throw new Error('Concurrency must not be zero');
        this.concurrency = concurrency;
        this.buffer = concurrency / 4.0;
    }
    /**
     * @private
     */ AsyncQueue.prototype._next = function(task) {
        var _this = this;
        return function() {
            var arguments$1 = arguments;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments$1[_i];
            _this.workers -= 1;
            task.callback.apply(task, args);
            // eslint-disable-next-line no-eq-null,eqeqeq
            if (args[0] != null) _this.error(args[0], task.data);
            if (_this.workers <= _this.concurrency - _this.buffer) _this.unsaturated();
            if (_this.idle()) _this.drain();
            _this.process();
        };
    };
    // That was in object
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    AsyncQueue.prototype.push = function(data, callback) {
        this._insert(data, false, callback);
    };
    AsyncQueue.prototype.kill = function() {
        this.workers = 0;
        this.drain = $f4285cd755ab388f$var$_noop$1;
        this.started = false;
        this._tasks = [];
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    AsyncQueue.prototype.unshift = function(data, callback) {
        this._insert(data, true, callback);
    };
    AsyncQueue.prototype.length = function() {
        return this._tasks.length;
    };
    AsyncQueue.prototype.running = function() {
        return this.workers;
    };
    AsyncQueue.prototype.idle = function() {
        return this._tasks.length + this.workers === 0;
    };
    AsyncQueue.prototype.pause = function() {
        if (this.paused === true) return;
        this.paused = true;
    };
    AsyncQueue.prototype.resume = function() {
        if (this.paused === false) return;
        this.paused = false;
        // Need to call this.process once per concurrent
        // worker to preserve full concurrency after pause
        for(var w = 1; w <= this.concurrency; w++)this.process();
    };
    /**
     * Iterates an array in series.
     *
     * @param {Array.<*>} array - Array to iterate.
     * @param {function} iterator - Function to call for each element.
     * @param {function} callback - Function to call when done, or on error.
     * @param {boolean} [deferNext=false] - Break synchronous each loop by calling next with a setTimeout of 1.
     */ AsyncQueue.eachSeries = function(array, iterator, callback, deferNext) {
        var i = 0;
        var len = array.length;
        function next(err) {
            if (err || i === len) {
                if (callback) callback(err);
                return;
            }
            if (deferNext) setTimeout(function() {
                iterator(array[i++], next);
            }, 1);
            else iterator(array[i++], next);
        }
        next();
    };
    /**
     * Async queue implementation,
     *
     * @param {function} worker - The worker function to call for each task.
     * @param {number} concurrency - How many workers to run in parrallel.
     * @return {*} The async queue object.
     */ AsyncQueue.queue = function(worker, concurrency) {
        return new AsyncQueue(worker, concurrency);
    };
    return AsyncQueue;
}();
// some constants
var $f4285cd755ab388f$var$MAX_PROGRESS = 100;
var $f4285cd755ab388f$var$rgxExtractUrlHash = /(#[\w-]+)?$/;
/**
 * The new loader, forked from Resource Loader by Chad Engler: https://github.com/englercj/resource-loader
 *
 * ```js
 * const loader = PIXI.Loader.shared; // PixiJS exposes a premade instance for you to use.
 * // or
 * const loader = new PIXI.Loader(); // You can also create your own if you want
 *
 * const sprites = {};
 *
 * // Chainable `add` to enqueue a resource
 * loader.add('bunny', 'data/bunny.png')
 *       .add('spaceship', 'assets/spritesheet.json');
 * loader.add('scoreFont', 'assets/score.fnt');
 *
 * // Chainable `pre` to add a middleware that runs for each resource, *before* loading that resource.
 * // This is useful to implement custom caching modules (using filesystem, indexeddb, memory, etc).
 * loader.pre(cachingMiddleware);
 *
 * // Chainable `use` to add a middleware that runs for each resource, *after* loading that resource.
 * // This is useful to implement custom parsing modules (like spritesheet parsers, spine parser, etc).
 * loader.use(parsingMiddleware);
 *
 * // The `load` method loads the queue of resources, and calls the passed in callback called once all
 * // resources have loaded.
 * loader.load((loader, resources) => {
 *     // resources is an object where the key is the name of the resource loaded and the value is the resource object.
 *     // They have a couple default properties:
 *     // - `url`: The URL that the resource was loaded from
 *     // - `error`: The error that happened when trying to load (if any)
 *     // - `data`: The raw data that was loaded
 *     // also may contain other properties based on the middleware that runs.
 *     sprites.bunny = new PIXI.TilingSprite(resources.bunny.texture);
 *     sprites.spaceship = new PIXI.TilingSprite(resources.spaceship.texture);
 *     sprites.scoreFont = new PIXI.TilingSprite(resources.scoreFont.texture);
 * });
 *
 * // throughout the process multiple signals can be dispatched.
 * loader.onProgress.add(() => {}); // called once per loaded/errored file
 * loader.onError.add(() => {}); // called once per errored file
 * loader.onLoad.add(() => {}); // called once per loaded file
 * loader.onComplete.add(() => {}); // called once when the queued resources all load.
 * ```
 *
 * @memberof PIXI
 */ var $f4285cd755ab388f$export$3b0d6d7590275603 = /** @class */ function() {
    /**
     * @param baseUrl - The base url for all resources loaded by this loader.
     * @param concurrency - The number of resources to load concurrently.
     */ function Loader(baseUrl, concurrency) {
        var _this = this;
        if (baseUrl === void 0) baseUrl = '';
        if (concurrency === void 0) concurrency = 10;
        /**
         * The progress percent of the loader going through the queue.
         */ this.progress = 0;
        /**
         * Loading state of the loader, true if it is currently loading resources.
         */ this.loading = false;
        /**
         * A querystring to append to every URL added to the loader.
         *
         * This should be a valid query string *without* the question-mark (`?`). The loader will
         * also *not* escape values for you. Make sure to escape your parameters with
         * [`encodeURIComponent`](https://mdn.io/encodeURIComponent) before assigning this property.
         *
         * @example
         * const loader = new Loader();
         *
         * loader.defaultQueryString = 'user=me&password=secret';
         *
         * // This will request 'image.png?user=me&password=secret'
         * loader.add('image.png').load();
         *
         * loader.reset();
         *
         * // This will request 'image.png?v=1&user=me&password=secret'
         * loader.add('iamge.png?v=1').load();
         */ this.defaultQueryString = '';
        /**
         * The middleware to run before loading each resource.
         */ this._beforeMiddleware = [];
        /**
         * The middleware to run after loading each resource.
         */ this._afterMiddleware = [];
        /**
         * The tracks the resources we are currently completing parsing for.
         */ this._resourcesParsing = [];
        /**
         * The `_loadResource` function bound with this object context.
         *
         * @param r - The resource to load
         * @param d - The dequeue function
         */ this._boundLoadResource = function(r, d) {
            return _this._loadResource(r, d);
        };
        /**
         * All the resources for this loader keyed by name.
         */ this.resources = {};
        this.baseUrl = baseUrl;
        this._beforeMiddleware = [];
        this._afterMiddleware = [];
        this._resourcesParsing = [];
        this._boundLoadResource = function(r, d) {
            return _this._loadResource(r, d);
        };
        this._queue = $f4285cd755ab388f$var$AsyncQueue.queue(this._boundLoadResource, concurrency);
        this._queue.pause();
        this.resources = {};
        this.onProgress = new $f4285cd755ab388f$var$Signal();
        this.onError = new $f4285cd755ab388f$var$Signal();
        this.onLoad = new $f4285cd755ab388f$var$Signal();
        this.onStart = new $f4285cd755ab388f$var$Signal();
        this.onComplete = new $f4285cd755ab388f$var$Signal();
        for(var i = 0; i < Loader._plugins.length; ++i){
            var plugin = Loader._plugins[i];
            var pre = plugin.pre, use = plugin.use;
            if (pre) this.pre(pre);
            if (use) this.use(use);
        }
        this._protected = false;
    }
    /**
     * Same as add, params have strict order
     *
     * @private
     * @param name - The name of the resource to load.
     * @param url - The url for this resource, relative to the baseUrl of this loader.
     * @param options - The options for the load.
     * @param callback - Function to call when this specific resource completes loading.
     * @return The loader itself.
     */ Loader.prototype._add = function(name, url, options, callback) {
        // if loading already you can only add resources that have a parent.
        if (this.loading && (!options || !options.parentResource)) throw new Error('Cannot add resources while the loader is running.');
        // check if resource already exists.
        if (this.resources[name]) throw new Error("Resource named \"" + name + "\" already exists.");
        // add base url if this isn't an absolute url
        url = this._prepareUrl(url);
        // create the store the resource
        this.resources[name] = new $f4285cd755ab388f$export$3a2d98834c8b0432(name, url, options);
        if (typeof callback === 'function') this.resources[name].onAfterMiddleware.once(callback);
        // if actively loading, make sure to adjust progress chunks for that parent and its children
        if (this.loading) {
            var parent = options.parentResource;
            var incompleteChildren = [];
            for(var i = 0; i < parent.children.length; ++i)if (!parent.children[i].isComplete) incompleteChildren.push(parent.children[i]);
            var fullChunk = parent.progressChunk * (incompleteChildren.length + 1); // +1 for parent
            var eachChunk = fullChunk / (incompleteChildren.length + 2); // +2 for parent & new child
            parent.children.push(this.resources[name]);
            parent.progressChunk = eachChunk;
            for(var i = 0; i < incompleteChildren.length; ++i)incompleteChildren[i].progressChunk = eachChunk;
            this.resources[name].progressChunk = eachChunk;
        }
        // add the resource to the queue
        this._queue.push(this.resources[name]);
        return this;
    };
    /* eslint-enable require-jsdoc,valid-jsdoc */ /**
     * Sets up a middleware function that will run *before* the
     * resource is loaded.
     *
     * @param fn - The middleware function to register.
     * @return The loader itself.
     */ Loader.prototype.pre = function(fn) {
        this._beforeMiddleware.push(fn);
        return this;
    };
    /**
     * Sets up a middleware function that will run *after* the
     * resource is loaded.
     *
     * @param fn - The middleware function to register.
     * @return The loader itself.
     */ Loader.prototype.use = function(fn) {
        this._afterMiddleware.push(fn);
        return this;
    };
    /**
     * Resets the queue of the loader to prepare for a new load.
     *
     * @return The loader itself.
     */ Loader.prototype.reset = function() {
        this.progress = 0;
        this.loading = false;
        this._queue.kill();
        this._queue.pause();
        // abort all resource loads
        for(var k in this.resources){
            var res = this.resources[k];
            if (res._onLoadBinding) res._onLoadBinding.detach();
            if (res.isLoading) res.abort('loader reset');
        }
        this.resources = {};
        return this;
    };
    /**
     * Starts loading the queued resources.
     * @param cb - Optional callback that will be bound to the `complete` event.
     * @return The loader itself.
     */ Loader.prototype.load = function(cb) {
        // register complete callback if they pass one
        if (typeof cb === 'function') this.onComplete.once(cb);
        // if the queue has already started we are done here
        if (this.loading) return this;
        if (this._queue.idle()) {
            this._onStart();
            this._onComplete();
        } else {
            // distribute progress chunks
            var numTasks = this._queue._tasks.length;
            var chunk = $f4285cd755ab388f$var$MAX_PROGRESS / numTasks;
            for(var i = 0; i < this._queue._tasks.length; ++i)this._queue._tasks[i].data.progressChunk = chunk;
            // notify we are starting
            this._onStart();
            // start loading
            this._queue.resume();
        }
        return this;
    };
    Object.defineProperty(Loader.prototype, "concurrency", {
        /**
         * The number of resources to load concurrently.
         *
         * @default 10
         */ get: function() {
            return this._queue.concurrency;
        },
        set: function(concurrency) {
            this._queue.concurrency = concurrency;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Prepares a url for usage based on the configuration of this object
     * @param url - The url to prepare.
     * @return The prepared url.
     */ Loader.prototype._prepareUrl = function(url) {
        var parsedUrl = $f4285cd755ab388f$var$parseUri(url, {
            strictMode: true
        });
        var result;
        // absolute url, just use it as is.
        if (parsedUrl.protocol || !parsedUrl.path || url.indexOf('//') === 0) result = url;
        else if (this.baseUrl.length && this.baseUrl.lastIndexOf('/') !== this.baseUrl.length - 1 && url.charAt(0) !== '/') result = this.baseUrl + "/" + url;
        else result = this.baseUrl + url;
        // if we need to add a default querystring, there is a bit more work
        if (this.defaultQueryString) {
            var hash = $f4285cd755ab388f$var$rgxExtractUrlHash.exec(result)[0];
            result = result.substr(0, result.length - hash.length);
            if (result.indexOf('?') !== -1) result += "&" + this.defaultQueryString;
            else result += "?" + this.defaultQueryString;
            result += hash;
        }
        return result;
    };
    /**
     * Loads a single resource.
     *
     * @param resource - The resource to load.
     * @param dequeue - The function to call when we need to dequeue this item.
     */ Loader.prototype._loadResource = function(resource, dequeue) {
        var _this = this;
        resource._dequeue = dequeue;
        // run before middleware
        $f4285cd755ab388f$var$AsyncQueue.eachSeries(this._beforeMiddleware, function(fn, next) {
            fn.call(_this, resource, function() {
                // if the before middleware marks the resource as complete,
                // break and don't process any more before middleware
                next(resource.isComplete ? {} : null);
            });
        }, function() {
            if (resource.isComplete) _this._onLoad(resource);
            else {
                resource._onLoadBinding = resource.onComplete.once(_this._onLoad, _this);
                resource.load();
            }
        }, true);
    };
    /**
     * Called once loading has started.
     */ Loader.prototype._onStart = function() {
        this.progress = 0;
        this.loading = true;
        this.onStart.dispatch(this);
    };
    /**
     * Called once each resource has loaded.
     */ Loader.prototype._onComplete = function() {
        this.progress = $f4285cd755ab388f$var$MAX_PROGRESS;
        this.loading = false;
        this.onComplete.dispatch(this, this.resources);
    };
    /**
     * Called each time a resources is loaded.
     * @param resource - The resource that was loaded
     */ Loader.prototype._onLoad = function(resource) {
        var _this = this;
        resource._onLoadBinding = null;
        // remove this resource from the async queue, and add it to our list of resources that are being parsed
        this._resourcesParsing.push(resource);
        resource._dequeue();
        // run all the after middleware for this resource
        $f4285cd755ab388f$var$AsyncQueue.eachSeries(this._afterMiddleware, function(fn, next) {
            fn.call(_this, resource, next);
        }, function() {
            resource.onAfterMiddleware.dispatch(resource);
            _this.progress = Math.min($f4285cd755ab388f$var$MAX_PROGRESS, _this.progress + resource.progressChunk);
            _this.onProgress.dispatch(_this, resource);
            if (resource.error) _this.onError.dispatch(resource.error, _this, resource);
            else _this.onLoad.dispatch(_this, resource);
            _this._resourcesParsing.splice(_this._resourcesParsing.indexOf(resource), 1);
            // do completion check
            if (_this._queue.idle() && _this._resourcesParsing.length === 0) _this._onComplete();
        }, true);
    };
    /**
     * Destroy the loader, removes references.
     */ Loader.prototype.destroy = function() {
        if (!this._protected) this.reset();
    };
    Object.defineProperty(Loader, "shared", {
        /**
         * A premade instance of the loader that can be used to load resources.
         */ get: function() {
            var shared = Loader._shared;
            if (!shared) {
                shared = new Loader();
                shared._protected = true;
                Loader._shared = shared;
            }
            return shared;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Adds a Loader plugin for the global shared loader and all
     * new Loader instances created.
     *
     * @param plugin - The plugin to add
     * @return Reference to PIXI.Loader for chaining
     */ Loader.registerPlugin = function(plugin) {
        Loader._plugins.push(plugin);
        if (plugin.add) plugin.add();
        return Loader;
    };
    Loader._plugins = [];
    return Loader;
}();
$f4285cd755ab388f$export$3b0d6d7590275603.prototype.add = function add(name, url, options, callback) {
    // special case of an array of objects or urls
    if (Array.isArray(name)) {
        for(var i = 0; i < name.length; ++i)this.add(name[i]);
        return this;
    }
    // if an object is passed instead of params
    if (typeof name === 'object') {
        options = name;
        callback = url || options.callback || options.onComplete;
        url = options.url;
        name = options.name || options.key || options.url;
    }
    // case where no name is passed shift all args over by one.
    if (typeof url !== 'string') {
        callback = options;
        options = url;
        url = name;
    }
    // now that we shifted make sure we have a proper url.
    if (typeof url !== 'string') throw new Error('No url passed to add resource to loader.');
    // options are optional so people might pass a function and no options
    if (typeof options === 'function') {
        callback = options;
        options = null;
    }
    return this._add(name, url, options, callback);
};
/**
 * Application plugin for supporting loader option. Installing the LoaderPlugin
 * is not necessary if using **pixi.js** or **pixi.js-legacy**.
 * @example
 * import {AppLoaderPlugin} from '@pixi/loaders';
 * import {Application} from '@pixi/app';
 * Application.registerPlugin(AppLoaderPlugin);
 * @memberof PIXI
 */ var $f4285cd755ab388f$export$4d6e8fa105d8152b = /** @class */ function() {
    function AppLoaderPlugin() {}
    /**
     * Called on application constructor
     *
     * @private
     */ AppLoaderPlugin.init = function(options) {
        options = Object.assign({
            sharedLoader: false
        }, options);
        this.loader = options.sharedLoader ? $f4285cd755ab388f$export$3b0d6d7590275603.shared : new $f4285cd755ab388f$export$3b0d6d7590275603();
    };
    /**
     * Called when application destroyed
     *
     * @private
     */ AppLoaderPlugin.destroy = function() {
        if (this.loader) {
            this.loader.destroy();
            this.loader = null;
        }
    };
    return AppLoaderPlugin;
}();
/**
 * Loader plugin for handling Texture resources.
 *
 * @memberof PIXI
 */ var $f4285cd755ab388f$export$fd1bfc71f64c538c = /** @class */ function() {
    function TextureLoader() {}
    /**
     * Handle SVG elements a text, render with SVGResource.
     */ TextureLoader.add = function() {
        $f4285cd755ab388f$export$3a2d98834c8b0432.setExtensionLoadType('svg', $f4285cd755ab388f$export$3a2d98834c8b0432.LOAD_TYPE.XHR);
        $f4285cd755ab388f$export$3a2d98834c8b0432.setExtensionXhrType('svg', $f4285cd755ab388f$export$3a2d98834c8b0432.XHR_RESPONSE_TYPE.TEXT);
    };
    /**
     * Called after a resource is loaded.
     * @see PIXI.Loader.loaderMiddleware
     * @param resource
     * @param {function} next
     */ TextureLoader.use = function(resource, next) {
        // create a new texture if the data is an Image object
        if (resource.data && (resource.type === $f4285cd755ab388f$export$3a2d98834c8b0432.TYPE.IMAGE || resource.extension === 'svg')) {
            var data = resource.data, url = resource.url, name = resource.name, metadata = resource.metadata;
            (0, $klOfb.Texture).fromLoader(data, url, name, metadata).then(function(texture) {
                resource.texture = texture;
                next();
            })// TODO: handle errors in Texture.fromLoader
            // so we can pass them to the Loader
            .catch(next);
        } else next();
    };
    return TextureLoader;
}();
var $f4285cd755ab388f$var$_keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
/**
 * Encodes binary into base64.
 *
 * @function encodeBinary
 * @param {string} input - The input data to encode.
 * @returns {string} The encoded base64 string
 */ function $f4285cd755ab388f$var$encodeBinary(input) {
    var output = '';
    var inx = 0;
    while(inx < input.length){
        // Fill byte buffer array
        var bytebuffer = [
            0,
            0,
            0
        ];
        var encodedCharIndexes = [
            0,
            0,
            0,
            0
        ];
        for(var jnx = 0; jnx < bytebuffer.length; ++jnx)if (inx < input.length) // throw away high-order byte, as documented at:
        // https://developer.mozilla.org/En/Using_XMLHttpRequest#Handling_binary_data
        bytebuffer[jnx] = input.charCodeAt(inx++) & 0xff;
        else bytebuffer[jnx] = 0;
        // Get each encoded character, 6 bits at a time
        // index 1: first 6 bits
        encodedCharIndexes[0] = bytebuffer[0] >> 2;
        // index 2: second 6 bits (2 least significant bits from input byte 1 + 4 most significant bits from byte 2)
        encodedCharIndexes[1] = (bytebuffer[0] & 0x3) << 4 | bytebuffer[1] >> 4;
        // index 3: third 6 bits (4 least significant bits from input byte 2 + 2 most significant bits from byte 3)
        encodedCharIndexes[2] = (bytebuffer[1] & 0x0f) << 2 | bytebuffer[2] >> 6;
        // index 3: forth 6 bits (6 least significant bits from input byte 3)
        encodedCharIndexes[3] = bytebuffer[2] & 0x3f;
        // Determine whether padding happened, and adjust accordingly
        var paddingBytes = inx - (input.length - 1);
        switch(paddingBytes){
            case 2:
                // Set last 2 characters to padding char
                encodedCharIndexes[3] = 64;
                encodedCharIndexes[2] = 64;
                break;
            case 1:
                // Set last character to padding char
                encodedCharIndexes[3] = 64;
                break;
        }
        // Now we will grab each appropriate character out of our keystring
        // based on our index array and append it to the output string
        for(var jnx = 0; jnx < encodedCharIndexes.length; ++jnx)output += $f4285cd755ab388f$var$_keyStr.charAt(encodedCharIndexes[jnx]);
    }
    return output;
}
var $f4285cd755ab388f$var$Url = self.URL || self.webkitURL;
/**
 * A middleware for transforming XHR loaded Blobs into more useful objects
 *
 * @ignore
 * @function parsing
 * @example
 * import { Loader, middleware } from 'resource-loader';
 * const loader = new Loader();
 * loader.use(middleware.parsing);
 * @param resource - Current Resource
 * @param next - Callback when complete
 */ function $f4285cd755ab388f$var$parsing(resource, next) {
    if (!resource.data) {
        next();
        return;
    }
    // if this was an XHR load of a blob
    if (resource.xhr && resource.xhrType === $f4285cd755ab388f$export$3a2d98834c8b0432.XHR_RESPONSE_TYPE.BLOB) {
        // if there is no blob support we probably got a binary string back
        if (!self.Blob || typeof resource.data === 'string') {
            var type = resource.xhr.getResponseHeader('content-type');
            // this is an image, convert the binary string into a data url
            if (type && type.indexOf('image') === 0) {
                resource.data = new Image();
                resource.data.src = "data:" + type + ";base64," + $f4285cd755ab388f$var$encodeBinary(resource.xhr.responseText);
                resource.type = $f4285cd755ab388f$export$3a2d98834c8b0432.TYPE.IMAGE;
                // wait until the image loads and then callback
                resource.data.onload = function() {
                    resource.data.onload = null;
                    next();
                };
                // next will be called on load
                return;
            }
        } else if (resource.data.type.indexOf('image') === 0) {
            var src_1 = $f4285cd755ab388f$var$Url.createObjectURL(resource.data);
            resource.blob = resource.data;
            resource.data = new Image();
            resource.data.src = src_1;
            resource.type = $f4285cd755ab388f$export$3a2d98834c8b0432.TYPE.IMAGE;
            // cleanup the no longer used blob after the image loads
            // TODO: Is this correct? Will the image be invalid after revoking?
            resource.data.onload = function() {
                $f4285cd755ab388f$var$Url.revokeObjectURL(src_1);
                resource.data.onload = null;
                next();
            };
            // next will be called on load.
            return;
        }
    }
    next();
}
// parse any blob into more usable objects (e.g. Image)
$f4285cd755ab388f$export$3b0d6d7590275603.registerPlugin({
    use: $f4285cd755ab388f$var$parsing
});
// parse any Image objects into textures
$f4285cd755ab388f$export$3b0d6d7590275603.registerPlugin($f4285cd755ab388f$export$fd1bfc71f64c538c);

});

parcelRegister("ejo0r", function(module, exports) {

$parcel$export(module.exports, "INTERNAL_FORMATS", function () { return $a6b5762b13998910$export$9a3c57b95f3e5f5d; });
$parcel$export(module.exports, "INTERNAL_FORMAT_TO_BYTES_PER_PIXEL", function () { return $a6b5762b13998910$export$fb888e587c979eee; });
$parcel$export(module.exports, "BlobResource", function () { return $a6b5762b13998910$export$f257f839012584a2; });
$parcel$export(module.exports, "CompressedTextureResource", function () { return $a6b5762b13998910$export$1982af6892f05657; });
$parcel$export(module.exports, "CompressedTextureLoader", function () { return $a6b5762b13998910$export$bd73ce947a280350; });
$parcel$export(module.exports, "DDSLoader", function () { return $a6b5762b13998910$export$7c2d2826fcfc7c67; });
$parcel$export(module.exports, "TYPES_TO_BYTES_PER_COMPONENT", function () { return $a6b5762b13998910$export$96c88eb9c7372a0b; });
$parcel$export(module.exports, "FORMATS_TO_COMPONENTS", function () { return $a6b5762b13998910$export$ace48b1390b9b0c2; });
$parcel$export(module.exports, "TYPES_TO_BYTES_PER_PIXEL", function () { return $a6b5762b13998910$export$2ca26443044e8798; });
$parcel$export(module.exports, "KTXLoader", function () { return $a6b5762b13998910$export$f154586e513f353e; });
/*!
 * @pixi/compressed-textures - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/compressed-textures is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $kXE1p = parcelRequire("kXE1p");

var $csytw = parcelRequire("csytw");

var $P8XPi = parcelRequire("P8XPi");
var $a6b5762b13998910$var$_a;
/**
 * WebGL internal formats, including compressed texture formats provided by extensions
 *
 * @memberof PIXI
 * @static
 * @name INTERNAL_FORMATS
 * @enum {number}
 * @property {number} COMPRESSED_RGB_S3TC_DXT1_EXT=0x83F0
 * @property {number} COMPRESSED_RGBA_S3TC_DXT1_EXT=0x83F1
 * @property {number} COMPRESSED_RGBA_S3TC_DXT3_EXT=0x83F2
 * @property {number} COMPRESSED_RGBA_S3TC_DXT5_EXT=0x83F3
 * @property {number} COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT=35917
 * @property {number} COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT=35918
 * @property {number} COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT=35919
 * @property {number} COMPRESSED_SRGB_S3TC_DXT1_EXT=35916
 * @property {number} COMPRESSED_R11_EAC=0x9270
 * @property {number} COMPRESSED_SIGNED_R11_EAC=0x9271
 * @property {number} COMPRESSED_RG11_EAC=0x9272
 * @property {number} COMPRESSED_SIGNED_RG11_EAC=0x9273
 * @property {number} COMPRESSED_RGB8_ETC2=0x9274
 * @property {number} COMPRESSED_RGBA8_ETC2_EAC=0x9278
 * @property {number} COMPRESSED_SRGB8_ETC2=0x9275
 * @property {number} COMPRESSED_SRGB8_ALPHA8_ETC2_EAC=0x9279
 * @property {number} COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2=0x9276
 * @property {number} COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2=0x9277
 * @property {number} COMPRESSED_RGB_PVRTC_4BPPV1_IMG=0x8C00
 * @property {number} COMPRESSED_RGBA_PVRTC_4BPPV1_IMG=0x8C02
 * @property {number} COMPRESSED_RGB_PVRTC_2BPPV1_IMG=0x8C01
 * @property {number} COMPRESSED_RGBA_PVRTC_2BPPV1_IMG=0x8C03
 * @property {number} COMPRESSED_RGB_ETC1_WEBGL=0x8D64
 * @property {number} COMPRESSED_RGB_ATC_WEBGL=0x8C92
 * @property {number} COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL=0x8C92
 * @property {number} COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL=0x87EE
 */ var $a6b5762b13998910$export$9a3c57b95f3e5f5d;
(function(INTERNAL_FORMATS) {
    // WEBGL_compressed_texture_s3tc
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB_S3TC_DXT1_EXT"] = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_S3TC_DXT1_EXT"] = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_S3TC_DXT3_EXT"] = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_S3TC_DXT5_EXT"] = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT";
    // WEBGL_compressed_texture_s3tc_srgb
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT"] = 35917] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT"] = 35918] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT"] = 35919] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB_S3TC_DXT1_EXT"] = 35916] = "COMPRESSED_SRGB_S3TC_DXT1_EXT";
    // WEBGL_compressed_texture_etc
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_R11_EAC"] = 37488] = "COMPRESSED_R11_EAC";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SIGNED_R11_EAC"] = 37489] = "COMPRESSED_SIGNED_R11_EAC";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RG11_EAC"] = 37490] = "COMPRESSED_RG11_EAC";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SIGNED_RG11_EAC"] = 37491] = "COMPRESSED_SIGNED_RG11_EAC";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB8_ETC2"] = 37492] = "COMPRESSED_RGB8_ETC2";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA8_ETC2_EAC"] = 37496] = "COMPRESSED_RGBA8_ETC2_EAC";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB8_ETC2"] = 37493] = "COMPRESSED_SRGB8_ETC2";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB8_ALPHA8_ETC2_EAC"] = 37497] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37494] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37495] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2";
    // WEBGL_compressed_texture_pvrtc
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB_PVRTC_4BPPV1_IMG"] = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_PVRTC_4BPPV1_IMG"] = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB_PVRTC_2BPPV1_IMG"] = 35841] = "COMPRESSED_RGB_PVRTC_2BPPV1_IMG";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_PVRTC_2BPPV1_IMG"] = 35843] = "COMPRESSED_RGBA_PVRTC_2BPPV1_IMG";
    // WEBGL_compressed_texture_etc1
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB_ETC1_WEBGL"] = 36196] = "COMPRESSED_RGB_ETC1_WEBGL";
    // WEBGL_compressed_texture_atc
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGB_ATC_WEBGL"] = 35986] = "COMPRESSED_RGB_ATC_WEBGL";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL"] = 35986] = "COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL";
    INTERNAL_FORMATS[INTERNAL_FORMATS["COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL"] = 34798] = "COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL";
})($a6b5762b13998910$export$9a3c57b95f3e5f5d || ($a6b5762b13998910$export$9a3c57b95f3e5f5d = {}));
/**
 * Maps the compressed texture formats in {@link PIXI.INTERNAL_FORMATS} to the number of bytes taken by
 * each texel.
 *
 * @memberof PIXI
 * @static
 * @ignore
 */ var $a6b5762b13998910$export$fb888e587c979eee = ($a6b5762b13998910$var$_a = {}, // WEBGL_compressed_texture_s3tc
$a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB_S3TC_DXT1_EXT] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT1_EXT] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT3_EXT] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT5_EXT] = 1, // WEBGL_compressed_texture_s3tc
$a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_S3TC_DXT1_EXT] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT] = 1, // WEBGL_compressed_texture_etc
$a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_R11_EAC] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SIGNED_R11_EAC] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RG11_EAC] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SIGNED_RG11_EAC] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB8_ETC2] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA8_ETC2_EAC] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB8_ETC2] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2] = 0.5, // WEBGL_compressed_texture_pvrtc
$a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB_PVRTC_4BPPV1_IMG] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB_PVRTC_2BPPV1_IMG] = 0.25, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG] = 0.25, // WEBGL_compressed_texture_etc1
$a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB_ETC1_WEBGL] = 0.5, // @see https://www.khronos.org/registry/OpenGL/extensions/AMD/AMD_compressed_ATC_texture.txt
// WEBGL_compressed_texture_atc
$a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGB_ATC_WEBGL] = 0.5, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL] = 1, $a6b5762b13998910$var$_a[$a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL] = 1, $a6b5762b13998910$var$_a);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $a6b5762b13998910$var$extendStatics = function(d, b) {
    $a6b5762b13998910$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $a6b5762b13998910$var$extendStatics(d, b);
};
function $a6b5762b13998910$var$__extends(d, b) {
    $a6b5762b13998910$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function $a6b5762b13998910$var$__awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function(resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a6b5762b13998910$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
/**
 * Resource that fetches texture data over the network and stores it in a buffer.
 *
 * @class
 * @extends PIXI.Resource
 * @memberof PIXI
 */ var $a6b5762b13998910$export$f257f839012584a2 = /** @class */ function(_super) {
    $a6b5762b13998910$var$__extends(BlobResource, _super);
    /**
     * @param {string} url - the URL of the texture file
     * @param {boolean}[autoLoad] - whether to fetch the data immediately;
     *  you can fetch it later via {@link BlobResource#load}
     */ function BlobResource(source, options) {
        if (options === void 0) options = {
            width: 1,
            height: 1,
            autoLoad: true
        };
        var _this = this;
        var origin;
        var data;
        if (typeof source === 'string') {
            origin = source;
            data = new Uint8Array();
        } else {
            origin = null;
            data = source;
        }
        _this = _super.call(this, data, options) || this;
        /**
         * The URL of the texture file
         * @member {string}
         */ _this.origin = origin;
        /**
         * The viewable buffer on the data
         * @member {ViewableBuffer}
         */ // HINT: BlobResource allows "null" sources, assuming the child class provides an alternative
        _this.buffer = data ? new (0, $klOfb.ViewableBuffer)(data) : null;
        // Allow autoLoad = "undefined" still load the resource by default
        if (_this.origin && options.autoLoad !== false) _this.load();
        if (data && data.length) {
            _this.loaded = true;
            _this.onBlobLoaded(_this.buffer.rawBinaryData);
        }
        return _this;
    }
    BlobResource.prototype.onBlobLoaded = function(_data) {
    // TODO: Override this method
    };
    /**
     * Loads the blob
     */ BlobResource.prototype.load = function() {
        return $a6b5762b13998910$var$__awaiter(this, void 0, Promise, function() {
            var response, blob, arrayBuffer;
            return $a6b5762b13998910$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fetch(this.origin)
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.blob()
                        ];
                    case 2:
                        blob = _a.sent();
                        return [
                            4 /*yield*/ ,
                            blob.arrayBuffer()
                        ];
                    case 3:
                        arrayBuffer = _a.sent();
                        this.data = new Uint32Array(arrayBuffer);
                        this.buffer = new (0, $klOfb.ViewableBuffer)(arrayBuffer);
                        this.loaded = true;
                        this.onBlobLoaded(arrayBuffer);
                        this.update();
                        return [
                            2 /*return*/ ,
                            this
                        ];
                }
            });
        });
    };
    return BlobResource;
}((0, $klOfb.BufferResource));
/**
 * Resource for compressed texture formats, as follows: S3TC/DXTn (& their sRGB formats), ATC, ASTC, ETC 1/2, PVRTC.
 *
 * Compressed textures improve performance when rendering is texture-bound. The texture data stays compressed in
 * graphics memory, increasing memory locality and speeding up texture fetches. These formats can also be used to store
 * more detail in the same amount of memory.
 *
 * For most developers, container file formats are a better abstraction instead of directly handling raw texture
 * data. PixiJS provides native support for the following texture file formats (via {@link PIXI.Loader}):
 *
 * * **.dds** - the DirectDraw Surface file format stores DXTn (DXT-1,3,5) data. See {@link PIXI.DDSLoader}
 * * **.ktx** - the Khronos Texture Container file format supports storing all the supported WebGL compression formats.
 *  See {@link PIXI.KTXLoader}.
 * * **.basis** - the BASIS supercompressed file format stores texture data in an internal format that is transcoded
 *  to the compression format supported on the device at _runtime_. It also supports transcoding into a uncompressed
 *  format as a fallback; you must install the `@pixi/basis-loader`, `@pixi/basis-transcoder` packages separately to
 *  use these files. See {@link PIXI.BasisLoader}.
 *
 * The loaders for the aforementioned formats use `CompressedTextureResource` internally. It is strongly suggested that
 * they be used instead.
 *
 * ## Working directly with CompressedTextureResource
 *
 * Since `CompressedTextureResource` inherits `BlobResource`, you can provide it a URL pointing to a file containing
 * the raw texture data (with no file headers!):
 *
 * ```js
 * // The resource backing the texture data for your textures.
 * // NOTE: You can also provide a ArrayBufferView instead of a URL. This is used when loading data from a container file
 * //   format such as KTX, DDS, or BASIS.
 * const compressedResource = new PIXI.CompressedTextureResource("bunny.dxt5", {
 *   format: PIXI.INTERNAL_FORMATS.COMPRESSED_RGBA_S3TC_DXT5_EXT,
 *   width: 256,
 *   height: 256
 * });
 *
 * // You can create a base-texture to the cache, so that future `Texture`s can be created using the `Texture.from` API.
 * const baseTexture = new PIXI.BaseTexture(compressedResource, { pmaMode: PIXI.ALPHA_MODES.NPM });
 *
 * // Create a Texture to add to the TextureCache
 * const texture = new PIXI.Texture(baseTexture);
 *
 * // Add baseTexture & texture to the global texture cache
 * PIXI.BaseTexture.addToCache(baseTexture, "bunny.dxt5");
 * PIXI.Texture.addToCache(texture, "bunny.dxt5");
 * ```
 *
 * @memberof PIXI
 */ var $a6b5762b13998910$export$1982af6892f05657 = /** @class */ function(_super) {
    $a6b5762b13998910$var$__extends(CompressedTextureResource, _super);
    /**
     * @param source - the buffer/URL holding the compressed texture data
     * @param options
     * @param {PIXI.INTERNAL_FORMATS} options.format - the compression format
     * @param {number} options.width - the image width in pixels.
     * @param {number} options.height - the image height in pixels.
     * @param {number} [options.level=1] - the mipmap levels stored in the compressed texture, including level 0.
     * @param {number} [options.levelBuffers] - the buffers for each mipmap level. `CompressedTextureResource` can allows you
     *      to pass `null` for `source`, for cases where each level is stored in non-contiguous memory.
     */ function CompressedTextureResource(source, options) {
        var _this = _super.call(this, source, options) || this;
        _this.format = options.format;
        _this.levels = options.levels || 1;
        _this._width = options.width;
        _this._height = options.height;
        _this._extension = CompressedTextureResource._formatToExtension(_this.format);
        if (options.levelBuffers || _this.buffer) // ViewableBuffer doesn't support byteOffset :-( so allow source to be Uint8Array
        _this._levelBuffers = options.levelBuffers || CompressedTextureResource._createLevelBuffers(source instanceof Uint8Array ? source : _this.buffer.uint8View, _this.format, _this.levels, 4, 4, _this.width, _this.height);
        return _this;
    }
    /**
     * @override
     * @param renderer - A reference to the current renderer
     * @param _texture - the texture
     * @param _glTexture - texture instance for this webgl context
     */ CompressedTextureResource.prototype.upload = function(renderer, _texture, _glTexture) {
        var gl = renderer.gl;
        var extension = renderer.context.extensions[this._extension];
        if (!extension) throw new Error(this._extension + " textures are not supported on the current machine");
        if (!this._levelBuffers) // Do not try to upload data before BlobResource loads, unless the levelBuffers were provided directly!
        return false;
        for(var i = 0, j = this.levels; i < j; i++){
            var _a = this._levelBuffers[i], levelID = _a.levelID, levelWidth = _a.levelWidth, levelHeight = _a.levelHeight, levelBuffer = _a.levelBuffer;
            gl.compressedTexImage2D(gl.TEXTURE_2D, levelID, this.format, levelWidth, levelHeight, 0, levelBuffer);
        }
        return true;
    };
    /** @protected */ CompressedTextureResource.prototype.onBlobLoaded = function() {
        this._levelBuffers = CompressedTextureResource._createLevelBuffers(this.buffer.uint8View, this.format, this.levels, 4, 4, this.width, this.height);
    };
    /**
     * Returns the key (to ContextSystem#extensions) for the WebGL extension supporting the compression format
     *
     * @private
     * @param format - the compression format to get the extension for.
     */ CompressedTextureResource._formatToExtension = function(format) {
        if (format >= 0x83F0 && format <= 0x83F3) return 's3tc';
        else if (format >= 0x9270 && format <= 0x9279) return 'etc';
        else if (format >= 0x8C00 && format <= 0x8C03) return 'pvrtc';
        else if (format >= 0x8D64) return 'etc1';
        else if (format >= 0x8C92 && format <= 0x87EE) return 'atc';
        throw new Error('Invalid (compressed) texture format given!');
    };
    /**
     * Pre-creates buffer views for each mipmap level
     *
     * @private
     * @param buffer -
     * @param format - compression formats
     * @param levels - mipmap levels
     * @param blockWidth -
     * @param blockHeight -
     * @param imageWidth - width of the image in pixels
     * @param imageHeight - height of the image in pixels
     */ CompressedTextureResource._createLevelBuffers = function(buffer, format, levels, blockWidth, blockHeight, imageWidth, imageHeight) {
        // The byte-size of the first level buffer
        var buffers = new Array(levels);
        var offset = buffer.byteOffset;
        var levelWidth = imageWidth;
        var levelHeight = imageHeight;
        var alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1);
        var alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1);
        var levelSize = alignedLevelWidth * alignedLevelHeight * $a6b5762b13998910$export$fb888e587c979eee[format];
        for(var i = 0; i < levels; i++){
            buffers[i] = {
                levelID: i,
                levelWidth: levels > 1 ? levelWidth : alignedLevelWidth,
                levelHeight: levels > 1 ? levelHeight : alignedLevelHeight,
                levelBuffer: new Uint8Array(buffer.buffer, offset, levelSize)
            };
            offset += levelSize;
            // Calculate levelBuffer dimensions for next iteration
            levelWidth = levelWidth >> 1 || 1;
            levelHeight = levelHeight >> 1 || 1;
            alignedLevelWidth = levelWidth + blockWidth - 1 & ~(blockWidth - 1);
            alignedLevelHeight = levelHeight + blockHeight - 1 & ~(blockHeight - 1);
            levelSize = alignedLevelWidth * alignedLevelHeight * $a6b5762b13998910$export$fb888e587c979eee[format];
        }
        return buffers;
    };
    return CompressedTextureResource;
}($a6b5762b13998910$export$f257f839012584a2);
/* eslint-enable camelcase */ /**
 * Loader plugin for handling compressed textures for all platforms.
 *
 * @class
 * @memberof PIXI
 * @implements PIXI.ILoaderPlugin
 */ var $a6b5762b13998910$export$bd73ce947a280350 = /** @class */ function() {
    function CompressedTextureLoader() {}
    /**
     * Called after a compressed-textures manifest is loaded.
     *
     * This will then load the correct compression format for the device. Your manifest should adhere
     * to the following schema:
     *
     * ```js
     * import { INTERNAL_FORMATS } from '@pixi/constants';
     *
     * type CompressedTextureManifest = {
     *  textures: Array<{ src: string, format?: keyof INTERNAL_FORMATS}>,
     *  cacheID: string;
     * };
     * ```
     *
     * This is an example of a .json manifest file
     *
     * ```json
     * {
     *   "cacheID":"asset",
     *   "textures":[
     *     { "src":"asset.fallback.png" },
     *     { "format":"COMPRESSED_RGBA_S3TC_DXT5_EXT", "src":"asset.s3tc.ktx" },
     *     { "format":"COMPRESSED_RGBA8_ETC2_EAC", "src":"asset.etc.ktx" },
     *     { "format":"RGBA_PVRTC_4BPPV1_IMG", "src":"asset.pvrtc.ktx" }
     *   ]
     * }
     * ```
     */ CompressedTextureLoader.use = function(resource, next) {
        var data = resource.data;
        var loader = this;
        if (resource.type === (0, $kXE1p.LoaderResource).TYPE.JSON && data && data.cacheID && data.textures) {
            var textures = data.textures;
            var textureURL = void 0;
            var fallbackURL = void 0;
            // Search for an extension that holds one the formats
            for(var i = 0, j = textures.length; i < j; i++){
                var texture = textures[i];
                var url_1 = texture.src;
                var format = texture.format;
                if (!format) fallbackURL = url_1;
                if (CompressedTextureLoader.textureFormats[format]) {
                    textureURL = url_1;
                    break;
                }
            }
            textureURL = textureURL || fallbackURL;
            // Make sure we have a URL
            if (!textureURL) {
                next(new Error("Cannot load compressed-textures in " + resource.url + ", make sure you provide a fallback"));
                return;
            }
            if (textureURL === resource.url) {
                // Prevent infinite loops
                next(new Error('URL of compressed texture cannot be the same as the manifest\'s URL'));
                return;
            }
            var loadOptions = {
                crossOrigin: resource.crossOrigin,
                metadata: resource.metadata.imageMetadata,
                parentResource: resource
            };
            var resourcePath = (0, $csytw.url).resolve(resource.url.replace(loader.baseUrl, ''), textureURL);
            var resourceName = data.cacheID;
            // The appropriate loader should register the texture
            loader.add(resourceName, resourcePath, loadOptions, function(res) {
                if (res.error) {
                    next(res.error);
                    return;
                }
                var _a = res.texture, texture = _a === void 0 ? null : _a, _b = res.textures, textures = _b === void 0 ? {} : _b;
                // Make sure texture/textures is assigned to parent resource
                Object.assign(resource, {
                    texture: texture,
                    textures: textures
                });
                // Pass along any error
                next();
            });
        } else next();
    };
    /**
     * Detects the available compressed texture extensions on the device.
     * @ignore
     */ CompressedTextureLoader.add = function() {
        // Auto-detect WebGL compressed-texture extensions
        var canvas = document.createElement('canvas');
        var gl = canvas.getContext('webgl');
        if (!gl) {
            console.warn('WebGL not available for compressed textures. Silently failing.');
            return;
        }
        var extensions = {
            s3tc: gl.getExtension('WEBGL_compressed_texture_s3tc'),
            s3tc_sRGB: gl.getExtension('WEBGL_compressed_texture_s3tc_srgb'),
            etc: gl.getExtension('WEBGL_compressed_texture_etc'),
            etc1: gl.getExtension('WEBGL_compressed_texture_etc1'),
            pvrtc: gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc'),
            atc: gl.getExtension('WEBGL_compressed_texture_atc'),
            astc: gl.getExtension('WEBGL_compressed_texture_astc')
        };
        CompressedTextureLoader.textureExtensions = extensions;
        CompressedTextureLoader.textureFormats = {};
        // Assign all available compressed-texture formats
        for(var extensionName in extensions){
            var extension = extensions[extensionName];
            if (!extension) continue;
            Object.assign(CompressedTextureLoader.textureFormats, Object.getPrototypeOf(extension));
        }
    };
    return CompressedTextureLoader;
}();
/**
 * Creates base-textures and textures for each compressed-texture resource and adds them into the global
 * texture cache. The first texture has two IDs - `${url}`, `${url}-1`; while the rest have an ID of the
 * form `${url}-i`.
 *
 * @param url - the original address of the resources
 * @param resources - the resources backing texture data
 * @ignore
 */ function $a6b5762b13998910$var$registerCompressedTextures(url, resources, metadata) {
    var result = {
        textures: {},
        texture: null
    };
    if (!resources) return result;
    var textures = resources.map(function(resource) {
        return new (0, $klOfb.Texture)(new (0, $klOfb.BaseTexture)(resource, Object.assign({
            mipmap: (0, $P8XPi.MIPMAP_MODES).OFF,
            alphaMode: (0, $P8XPi.ALPHA_MODES).NO_PREMULTIPLIED_ALPHA
        }, metadata)));
    });
    textures.forEach(function(texture, i) {
        var baseTexture = texture.baseTexture;
        var cacheID = url + "-" + (i + 1);
        (0, $klOfb.BaseTexture).addToCache(baseTexture, cacheID);
        (0, $klOfb.Texture).addToCache(texture, cacheID);
        if (i === 0) {
            (0, $klOfb.BaseTexture).addToCache(baseTexture, url);
            (0, $klOfb.Texture).addToCache(texture, url);
            result.texture = texture;
        }
        result.textures[cacheID] = texture;
    });
    return result;
}
var $a6b5762b13998910$var$_a$1, $a6b5762b13998910$var$_b;
// Set DDS files to be loaded as an ArrayBuffer
(0, $kXE1p.LoaderResource).setExtensionXhrType('dds', (0, $kXE1p.LoaderResource).XHR_RESPONSE_TYPE.BUFFER);
var $a6b5762b13998910$var$DDS_MAGIC_SIZE = 4;
var $a6b5762b13998910$var$DDS_HEADER_SIZE = 124;
var $a6b5762b13998910$var$DDS_HEADER_PF_SIZE = 32;
var $a6b5762b13998910$var$DDS_HEADER_DX10_SIZE = 20;
// DDS file format magic word
var $a6b5762b13998910$var$DDS_MAGIC = 0x20534444;
/**
 * DWORD offsets of the DDS file header fields (relative to file start).
 *
 * @ignore
 */ var $a6b5762b13998910$var$DDS_FIELDS = {
    SIZE: 1,
    FLAGS: 2,
    HEIGHT: 3,
    WIDTH: 4,
    MIPMAP_COUNT: 7,
    PIXEL_FORMAT: 19
};
/**
 * DWORD offsets of the DDS PIXEL_FORMAT fields.
 *
 * @ignore
 */ var $a6b5762b13998910$var$DDS_PF_FIELDS = {
    SIZE: 0,
    FLAGS: 1,
    FOURCC: 2,
    RGB_BITCOUNT: 3,
    R_BIT_MASK: 4,
    G_BIT_MASK: 5,
    B_BIT_MASK: 6,
    A_BIT_MASK: 7
};
/**
 * DWORD offsets of the DDS_HEADER_DX10 fields.
 *
 * @ignore
 */ var $a6b5762b13998910$var$DDS_DX10_FIELDS = {
    DXGI_FORMAT: 0,
    RESOURCE_DIMENSION: 1,
    MISC_FLAG: 2,
    ARRAY_SIZE: 3,
    MISC_FLAGS2: 4
};
/**
 * @see https://docs.microsoft.com/en-us/windows/win32/api/dxgiformat/ne-dxgiformat-dxgi_format
 * @ignore
 */ // This is way over-blown for us! Lend us a hand, and remove the ones that aren't used (but set the remaining
// ones to their correct value)
var $a6b5762b13998910$var$DXGI_FORMAT;
(function(DXGI_FORMAT) {
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_UNKNOWN"] = 0] = "DXGI_FORMAT_UNKNOWN";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32A32_TYPELESS"] = 1] = "DXGI_FORMAT_R32G32B32A32_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32A32_FLOAT"] = 2] = "DXGI_FORMAT_R32G32B32A32_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32A32_UINT"] = 3] = "DXGI_FORMAT_R32G32B32A32_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32A32_SINT"] = 4] = "DXGI_FORMAT_R32G32B32A32_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32_TYPELESS"] = 5] = "DXGI_FORMAT_R32G32B32_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32_FLOAT"] = 6] = "DXGI_FORMAT_R32G32B32_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32_UINT"] = 7] = "DXGI_FORMAT_R32G32B32_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32B32_SINT"] = 8] = "DXGI_FORMAT_R32G32B32_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16B16A16_TYPELESS"] = 9] = "DXGI_FORMAT_R16G16B16A16_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16B16A16_FLOAT"] = 10] = "DXGI_FORMAT_R16G16B16A16_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16B16A16_UNORM"] = 11] = "DXGI_FORMAT_R16G16B16A16_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16B16A16_UINT"] = 12] = "DXGI_FORMAT_R16G16B16A16_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16B16A16_SNORM"] = 13] = "DXGI_FORMAT_R16G16B16A16_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16B16A16_SINT"] = 14] = "DXGI_FORMAT_R16G16B16A16_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32_TYPELESS"] = 15] = "DXGI_FORMAT_R32G32_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32_FLOAT"] = 16] = "DXGI_FORMAT_R32G32_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32_UINT"] = 17] = "DXGI_FORMAT_R32G32_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G32_SINT"] = 18] = "DXGI_FORMAT_R32G32_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32G8X24_TYPELESS"] = 19] = "DXGI_FORMAT_R32G8X24_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_D32_FLOAT_S8X24_UINT"] = 20] = "DXGI_FORMAT_D32_FLOAT_S8X24_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32_FLOAT_X8X24_TYPELESS"] = 21] = "DXGI_FORMAT_R32_FLOAT_X8X24_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_X32_TYPELESS_G8X24_UINT"] = 22] = "DXGI_FORMAT_X32_TYPELESS_G8X24_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R10G10B10A2_TYPELESS"] = 23] = "DXGI_FORMAT_R10G10B10A2_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R10G10B10A2_UNORM"] = 24] = "DXGI_FORMAT_R10G10B10A2_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R10G10B10A2_UINT"] = 25] = "DXGI_FORMAT_R10G10B10A2_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R11G11B10_FLOAT"] = 26] = "DXGI_FORMAT_R11G11B10_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8B8A8_TYPELESS"] = 27] = "DXGI_FORMAT_R8G8B8A8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8B8A8_UNORM"] = 28] = "DXGI_FORMAT_R8G8B8A8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8B8A8_UNORM_SRGB"] = 29] = "DXGI_FORMAT_R8G8B8A8_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8B8A8_UINT"] = 30] = "DXGI_FORMAT_R8G8B8A8_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8B8A8_SNORM"] = 31] = "DXGI_FORMAT_R8G8B8A8_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8B8A8_SINT"] = 32] = "DXGI_FORMAT_R8G8B8A8_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16_TYPELESS"] = 33] = "DXGI_FORMAT_R16G16_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16_FLOAT"] = 34] = "DXGI_FORMAT_R16G16_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16_UNORM"] = 35] = "DXGI_FORMAT_R16G16_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16_UINT"] = 36] = "DXGI_FORMAT_R16G16_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16_SNORM"] = 37] = "DXGI_FORMAT_R16G16_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16G16_SINT"] = 38] = "DXGI_FORMAT_R16G16_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32_TYPELESS"] = 39] = "DXGI_FORMAT_R32_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_D32_FLOAT"] = 40] = "DXGI_FORMAT_D32_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32_FLOAT"] = 41] = "DXGI_FORMAT_R32_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32_UINT"] = 42] = "DXGI_FORMAT_R32_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R32_SINT"] = 43] = "DXGI_FORMAT_R32_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R24G8_TYPELESS"] = 44] = "DXGI_FORMAT_R24G8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_D24_UNORM_S8_UINT"] = 45] = "DXGI_FORMAT_D24_UNORM_S8_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R24_UNORM_X8_TYPELESS"] = 46] = "DXGI_FORMAT_R24_UNORM_X8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_X24_TYPELESS_G8_UINT"] = 47] = "DXGI_FORMAT_X24_TYPELESS_G8_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8_TYPELESS"] = 48] = "DXGI_FORMAT_R8G8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8_UNORM"] = 49] = "DXGI_FORMAT_R8G8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8_UINT"] = 50] = "DXGI_FORMAT_R8G8_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8_SNORM"] = 51] = "DXGI_FORMAT_R8G8_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8_SINT"] = 52] = "DXGI_FORMAT_R8G8_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16_TYPELESS"] = 53] = "DXGI_FORMAT_R16_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16_FLOAT"] = 54] = "DXGI_FORMAT_R16_FLOAT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_D16_UNORM"] = 55] = "DXGI_FORMAT_D16_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16_UNORM"] = 56] = "DXGI_FORMAT_R16_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16_UINT"] = 57] = "DXGI_FORMAT_R16_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16_SNORM"] = 58] = "DXGI_FORMAT_R16_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R16_SINT"] = 59] = "DXGI_FORMAT_R16_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8_TYPELESS"] = 60] = "DXGI_FORMAT_R8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8_UNORM"] = 61] = "DXGI_FORMAT_R8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8_UINT"] = 62] = "DXGI_FORMAT_R8_UINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8_SNORM"] = 63] = "DXGI_FORMAT_R8_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8_SINT"] = 64] = "DXGI_FORMAT_R8_SINT";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_A8_UNORM"] = 65] = "DXGI_FORMAT_A8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R1_UNORM"] = 66] = "DXGI_FORMAT_R1_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R9G9B9E5_SHAREDEXP"] = 67] = "DXGI_FORMAT_R9G9B9E5_SHAREDEXP";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R8G8_B8G8_UNORM"] = 68] = "DXGI_FORMAT_R8G8_B8G8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_G8R8_G8B8_UNORM"] = 69] = "DXGI_FORMAT_G8R8_G8B8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC1_TYPELESS"] = 70] = "DXGI_FORMAT_BC1_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC1_UNORM"] = 71] = "DXGI_FORMAT_BC1_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC1_UNORM_SRGB"] = 72] = "DXGI_FORMAT_BC1_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC2_TYPELESS"] = 73] = "DXGI_FORMAT_BC2_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC2_UNORM"] = 74] = "DXGI_FORMAT_BC2_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC2_UNORM_SRGB"] = 75] = "DXGI_FORMAT_BC2_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC3_TYPELESS"] = 76] = "DXGI_FORMAT_BC3_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC3_UNORM"] = 77] = "DXGI_FORMAT_BC3_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC3_UNORM_SRGB"] = 78] = "DXGI_FORMAT_BC3_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC4_TYPELESS"] = 79] = "DXGI_FORMAT_BC4_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC4_UNORM"] = 80] = "DXGI_FORMAT_BC4_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC4_SNORM"] = 81] = "DXGI_FORMAT_BC4_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC5_TYPELESS"] = 82] = "DXGI_FORMAT_BC5_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC5_UNORM"] = 83] = "DXGI_FORMAT_BC5_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC5_SNORM"] = 84] = "DXGI_FORMAT_BC5_SNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B5G6R5_UNORM"] = 85] = "DXGI_FORMAT_B5G6R5_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B5G5R5A1_UNORM"] = 86] = "DXGI_FORMAT_B5G5R5A1_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B8G8R8A8_UNORM"] = 87] = "DXGI_FORMAT_B8G8R8A8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B8G8R8X8_UNORM"] = 88] = "DXGI_FORMAT_B8G8R8X8_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_R10G10B10_XR_BIAS_A2_UNORM"] = 89] = "DXGI_FORMAT_R10G10B10_XR_BIAS_A2_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B8G8R8A8_TYPELESS"] = 90] = "DXGI_FORMAT_B8G8R8A8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B8G8R8A8_UNORM_SRGB"] = 91] = "DXGI_FORMAT_B8G8R8A8_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B8G8R8X8_TYPELESS"] = 92] = "DXGI_FORMAT_B8G8R8X8_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B8G8R8X8_UNORM_SRGB"] = 93] = "DXGI_FORMAT_B8G8R8X8_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC6H_TYPELESS"] = 94] = "DXGI_FORMAT_BC6H_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC6H_UF16"] = 95] = "DXGI_FORMAT_BC6H_UF16";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC6H_SF16"] = 96] = "DXGI_FORMAT_BC6H_SF16";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC7_TYPELESS"] = 97] = "DXGI_FORMAT_BC7_TYPELESS";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC7_UNORM"] = 98] = "DXGI_FORMAT_BC7_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_BC7_UNORM_SRGB"] = 99] = "DXGI_FORMAT_BC7_UNORM_SRGB";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_AYUV"] = 100] = "DXGI_FORMAT_AYUV";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_Y410"] = 101] = "DXGI_FORMAT_Y410";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_Y416"] = 102] = "DXGI_FORMAT_Y416";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_NV12"] = 103] = "DXGI_FORMAT_NV12";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_P010"] = 104] = "DXGI_FORMAT_P010";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_P016"] = 105] = "DXGI_FORMAT_P016";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_420_OPAQUE"] = 106] = "DXGI_FORMAT_420_OPAQUE";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_YUY2"] = 107] = "DXGI_FORMAT_YUY2";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_Y210"] = 108] = "DXGI_FORMAT_Y210";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_Y216"] = 109] = "DXGI_FORMAT_Y216";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_NV11"] = 110] = "DXGI_FORMAT_NV11";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_AI44"] = 111] = "DXGI_FORMAT_AI44";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_IA44"] = 112] = "DXGI_FORMAT_IA44";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_P8"] = 113] = "DXGI_FORMAT_P8";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_A8P8"] = 114] = "DXGI_FORMAT_A8P8";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_B4G4R4A4_UNORM"] = 115] = "DXGI_FORMAT_B4G4R4A4_UNORM";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_P208"] = 116] = "DXGI_FORMAT_P208";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_V208"] = 117] = "DXGI_FORMAT_V208";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_V408"] = 118] = "DXGI_FORMAT_V408";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_SAMPLER_FEEDBACK_MIN_MIP_OPAQUE"] = 119] = "DXGI_FORMAT_SAMPLER_FEEDBACK_MIN_MIP_OPAQUE";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_SAMPLER_FEEDBACK_MIP_REGION_USED_OPAQUE"] = 120] = "DXGI_FORMAT_SAMPLER_FEEDBACK_MIP_REGION_USED_OPAQUE";
    DXGI_FORMAT[DXGI_FORMAT["DXGI_FORMAT_FORCE_UINT"] = 121] = "DXGI_FORMAT_FORCE_UINT";
})($a6b5762b13998910$var$DXGI_FORMAT || ($a6b5762b13998910$var$DXGI_FORMAT = {}));
/**
 * Possible values of the field {@link DDS_DX10_FIELDS.RESOURCE_DIMENSION}
 *
 * @ignore
 */ var $a6b5762b13998910$var$D3D10_RESOURCE_DIMENSION;
(function(D3D10_RESOURCE_DIMENSION) {
    D3D10_RESOURCE_DIMENSION[D3D10_RESOURCE_DIMENSION["DDS_DIMENSION_TEXTURE1D"] = 2] = "DDS_DIMENSION_TEXTURE1D";
    D3D10_RESOURCE_DIMENSION[D3D10_RESOURCE_DIMENSION["DDS_DIMENSION_TEXTURE2D"] = 3] = "DDS_DIMENSION_TEXTURE2D";
    D3D10_RESOURCE_DIMENSION[D3D10_RESOURCE_DIMENSION["DDS_DIMENSION_TEXTURE3D"] = 6] = "DDS_DIMENSION_TEXTURE3D";
})($a6b5762b13998910$var$D3D10_RESOURCE_DIMENSION || ($a6b5762b13998910$var$D3D10_RESOURCE_DIMENSION = {}));
var $a6b5762b13998910$var$PF_FLAGS = 1;
// PIXEL_FORMAT flags
var $a6b5762b13998910$var$DDPF_ALPHA = 0x2;
var $a6b5762b13998910$var$DDPF_FOURCC = 0x4;
var $a6b5762b13998910$var$DDPF_RGB = 0x40;
var $a6b5762b13998910$var$DDPF_YUV = 0x200;
var $a6b5762b13998910$var$DDPF_LUMINANCE = 0x20000;
// Four character codes for DXTn formats
var $a6b5762b13998910$var$FOURCC_DXT1 = 0x31545844;
var $a6b5762b13998910$var$FOURCC_DXT3 = 0x33545844;
var $a6b5762b13998910$var$FOURCC_DXT5 = 0x35545844;
var $a6b5762b13998910$var$FOURCC_DX10 = 0x30315844;
// Cubemap texture flag (for DDS_DX10_FIELDS.MISC_FLAG)
var $a6b5762b13998910$var$DDS_RESOURCE_MISC_TEXTURECUBE = 0x4;
/**
 * Maps `FOURCC_*` formats to internal formats (see {@link PIXI.INTERNAL_FORMATS}).
 *
 * @ignore
 */ var $a6b5762b13998910$var$FOURCC_TO_FORMAT = ($a6b5762b13998910$var$_a$1 = {}, $a6b5762b13998910$var$_a$1[$a6b5762b13998910$var$FOURCC_DXT1] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT1_EXT, $a6b5762b13998910$var$_a$1[$a6b5762b13998910$var$FOURCC_DXT3] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT3_EXT, $a6b5762b13998910$var$_a$1[$a6b5762b13998910$var$FOURCC_DXT5] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT5_EXT, $a6b5762b13998910$var$_a$1);
/**
 * Maps {@link DXGI_FORMAT} to types/internal-formats (see {@link PIXI.TYPES}, {@link PIXI.INTERNAL_FORMATS})
 *
 * @ignore
 */ var $a6b5762b13998910$var$DXGI_TO_FORMAT = ($a6b5762b13998910$var$_b = {}, // WEBGL_compressed_texture_s3tc
$a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC1_TYPELESS] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT1_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC1_UNORM] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT1_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC2_TYPELESS] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT3_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC2_UNORM] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT3_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC3_TYPELESS] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT5_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC3_UNORM] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_RGBA_S3TC_DXT5_EXT, // WEBGL_compressed_texture_s3tc_srgb
$a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC1_UNORM_SRGB] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC2_UNORM_SRGB] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT, $a6b5762b13998910$var$_b[$a6b5762b13998910$var$DXGI_FORMAT.DXGI_FORMAT_BC3_UNORM_SRGB] = $a6b5762b13998910$export$9a3c57b95f3e5f5d.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT, $a6b5762b13998910$var$_b);
/**
 * @class
 * @memberof PIXI
 * @implements PIXI.ILoaderPlugin
 * @see https://docs.microsoft.com/en-us/windows/win32/direct3ddds/dx-graphics-dds-pguide
 */ var $a6b5762b13998910$export$7c2d2826fcfc7c67 = /** @class */ function() {
    function DDSLoader() {}
    /**
     * Registers a DDS compressed texture
     * @see PIXI.Loader.loaderMiddleware
     * @param resource - loader resource that is checked to see if it is a DDS file
     * @param next - callback Function to call when done
     */ DDSLoader.use = function(resource, next) {
        if (resource.extension === 'dds' && resource.data) try {
            Object.assign(resource, $a6b5762b13998910$var$registerCompressedTextures(resource.name || resource.url, DDSLoader.parse(resource.data), resource.metadata));
        } catch (err) {
            next(err);
            return;
        }
        next();
    };
    /** Parses the DDS file header, generates base-textures, and puts them into the texture cache. */ DDSLoader.parse = function(arrayBuffer) {
        var data = new Uint32Array(arrayBuffer);
        var magicWord = data[0];
        if (magicWord !== $a6b5762b13998910$var$DDS_MAGIC) throw new Error('Invalid DDS file magic word');
        var header = new Uint32Array(arrayBuffer, 0, $a6b5762b13998910$var$DDS_HEADER_SIZE / Uint32Array.BYTES_PER_ELEMENT);
        // DDS header fields
        var height = header[$a6b5762b13998910$var$DDS_FIELDS.HEIGHT];
        var width = header[$a6b5762b13998910$var$DDS_FIELDS.WIDTH];
        var mipmapCount = header[$a6b5762b13998910$var$DDS_FIELDS.MIPMAP_COUNT];
        // PIXEL_FORMAT fields
        var pixelFormat = new Uint32Array(arrayBuffer, $a6b5762b13998910$var$DDS_FIELDS.PIXEL_FORMAT * Uint32Array.BYTES_PER_ELEMENT, $a6b5762b13998910$var$DDS_HEADER_PF_SIZE / Uint32Array.BYTES_PER_ELEMENT);
        var formatFlags = pixelFormat[$a6b5762b13998910$var$PF_FLAGS];
        // File contains compressed texture(s)
        if (formatFlags & $a6b5762b13998910$var$DDPF_FOURCC) {
            var fourCC = pixelFormat[$a6b5762b13998910$var$DDS_PF_FIELDS.FOURCC];
            // File contains one DXTn compressed texture
            if (fourCC !== $a6b5762b13998910$var$FOURCC_DX10) {
                var internalFormat_1 = $a6b5762b13998910$var$FOURCC_TO_FORMAT[fourCC];
                var dataOffset_1 = $a6b5762b13998910$var$DDS_MAGIC_SIZE + $a6b5762b13998910$var$DDS_HEADER_SIZE;
                var texData = new Uint8Array(arrayBuffer, dataOffset_1);
                var resource = new $a6b5762b13998910$export$1982af6892f05657(texData, {
                    format: internalFormat_1,
                    width: width,
                    height: height,
                    levels: mipmapCount // CompressedTextureResource will separate the levelBuffers for us!
                });
                return [
                    resource
                ];
            }
            // FOURCC_DX10 indicates there is a 20-byte DDS_HEADER_DX10 after DDS_HEADER
            var dx10Offset = $a6b5762b13998910$var$DDS_MAGIC_SIZE + $a6b5762b13998910$var$DDS_HEADER_SIZE;
            var dx10Header = new Uint32Array(data.buffer, dx10Offset, $a6b5762b13998910$var$DDS_HEADER_DX10_SIZE / Uint32Array.BYTES_PER_ELEMENT);
            var dxgiFormat = dx10Header[$a6b5762b13998910$var$DDS_DX10_FIELDS.DXGI_FORMAT];
            var resourceDimension = dx10Header[$a6b5762b13998910$var$DDS_DX10_FIELDS.RESOURCE_DIMENSION];
            var miscFlag = dx10Header[$a6b5762b13998910$var$DDS_DX10_FIELDS.MISC_FLAG];
            var arraySize = dx10Header[$a6b5762b13998910$var$DDS_DX10_FIELDS.ARRAY_SIZE];
            // Map dxgiFormat to PIXI.INTERNAL_FORMATS
            var internalFormat_2 = $a6b5762b13998910$var$DXGI_TO_FORMAT[dxgiFormat];
            if (internalFormat_2 === undefined) throw new Error("DDSLoader cannot parse texture data with DXGI format " + dxgiFormat);
            if (miscFlag === $a6b5762b13998910$var$DDS_RESOURCE_MISC_TEXTURECUBE) // FIXME: Anybody excited about cubemap compressed textures?
            throw new Error('DDSLoader does not support cubemap textures');
            if (resourceDimension === $a6b5762b13998910$var$D3D10_RESOURCE_DIMENSION.DDS_DIMENSION_TEXTURE3D) // FIXME: Anybody excited about 3D compressed textures?
            throw new Error('DDSLoader does not supported 3D texture data');
            // Uint8Array buffers of image data, including all mipmap levels in each image
            var imageBuffers = new Array();
            var dataOffset = $a6b5762b13998910$var$DDS_MAGIC_SIZE + $a6b5762b13998910$var$DDS_HEADER_SIZE + $a6b5762b13998910$var$DDS_HEADER_DX10_SIZE;
            if (arraySize === 1) // No need bothering with the imageSize calculation!
            imageBuffers.push(new Uint8Array(arrayBuffer, dataOffset));
            else {
                // Calculate imageSize for each texture, and then locate each image's texture data
                var pixelSize = $a6b5762b13998910$export$fb888e587c979eee[internalFormat_2];
                var imageSize = 0;
                var levelWidth = width;
                var levelHeight = height;
                for(var i = 0; i < mipmapCount; i++){
                    var alignedLevelWidth = Math.max(1, levelWidth + 3 & -4);
                    var alignedLevelHeight = Math.max(1, levelHeight + 3 & -4);
                    var levelSize = alignedLevelWidth * alignedLevelHeight * pixelSize;
                    imageSize += levelSize;
                    levelWidth = levelWidth >>> 1;
                    levelHeight = levelHeight >>> 1;
                }
                var imageOffset = dataOffset;
                // NOTE: Cubemaps have 6-images per texture (but they aren't supported so ^_^)
                for(var i = 0; i < arraySize; i++){
                    imageBuffers.push(new Uint8Array(arrayBuffer, imageOffset, imageSize));
                    imageOffset += imageSize;
                }
            }
            // Uint8Array -> CompressedTextureResource, and we're done!
            return imageBuffers.map(function(buffer) {
                return new $a6b5762b13998910$export$1982af6892f05657(buffer, {
                    format: internalFormat_2,
                    width: width,
                    height: height,
                    levels: mipmapCount
                });
            });
        }
        if (formatFlags & $a6b5762b13998910$var$DDPF_RGB) // FIXME: We might want to allow uncompressed *.dds files?
        throw new Error('DDSLoader does not support uncompressed texture data.');
        if (formatFlags & $a6b5762b13998910$var$DDPF_YUV) // FIXME: Does anybody need this feature?
        throw new Error('DDSLoader does not supported YUV uncompressed texture data.');
        if (formatFlags & $a6b5762b13998910$var$DDPF_LUMINANCE) // FIXME: Microsoft says older DDS filers use this feature! Probably not worth the effort!
        throw new Error('DDSLoader does not support single-channel (lumninance) texture data!');
        if (formatFlags & $a6b5762b13998910$var$DDPF_ALPHA) // FIXME: I'm tired! See above =)
        throw new Error('DDSLoader does not support single-channel (alpha) texture data!');
        throw new Error('DDSLoader failed to load a texture file due to an unknown reason!');
    };
    return DDSLoader;
}();
var $a6b5762b13998910$var$_a$2, $a6b5762b13998910$var$_b$1, $a6b5762b13998910$var$_c;
// Set KTX files to be loaded as an ArrayBuffer
(0, $kXE1p.LoaderResource).setExtensionXhrType('ktx', (0, $kXE1p.LoaderResource).XHR_RESPONSE_TYPE.BUFFER);
/**
 * The 12-byte KTX file identifier
 *
 * @see https://www.khronos.org/opengles/sdk/tools/KTX/file_format_spec/#2.1
 * @ignore
 */ var $a6b5762b13998910$var$FILE_IDENTIFIER = [
    0xAB,
    0x4B,
    0x54,
    0x58,
    0x20,
    0x31,
    0x31,
    0xBB,
    0x0D,
    0x0A,
    0x1A,
    0x0A
];
/**
 * The value stored in the "endianness" field.
 *
 * @see https://www.khronos.org/opengles/sdk/tools/KTX/file_format_spec/#2.2
 * @ignore
 */ var $a6b5762b13998910$var$ENDIANNESS = 0x04030201;
/**
 * Byte offsets of the KTX file header fields
 *
 * @ignore
 */ var $a6b5762b13998910$var$KTX_FIELDS = {
    FILE_IDENTIFIER: 0,
    ENDIANNESS: 12,
    GL_TYPE: 16,
    GL_TYPE_SIZE: 20,
    GL_FORMAT: 24,
    GL_INTERNAL_FORMAT: 28,
    GL_BASE_INTERNAL_FORMAT: 32,
    PIXEL_WIDTH: 36,
    PIXEL_HEIGHT: 40,
    PIXEL_DEPTH: 44,
    NUMBER_OF_ARRAY_ELEMENTS: 48,
    NUMBER_OF_FACES: 52,
    NUMBER_OF_MIPMAP_LEVELS: 56,
    BYTES_OF_KEY_VALUE_DATA: 60
};
/**
 * Byte size of the file header fields in {@code KTX_FIELDS}
 *
 * @ignore
 */ var $a6b5762b13998910$var$FILE_HEADER_SIZE = 64;
/**
 * Maps {@link PIXI.TYPES} to the bytes taken per component, excluding those ones that are bit-fields.
 *
 * @ignore
 */ var $a6b5762b13998910$export$96c88eb9c7372a0b = ($a6b5762b13998910$var$_a$2 = {}, $a6b5762b13998910$var$_a$2[(0, $P8XPi.TYPES).UNSIGNED_BYTE] = 1, $a6b5762b13998910$var$_a$2[(0, $P8XPi.TYPES).UNSIGNED_SHORT] = 2, $a6b5762b13998910$var$_a$2[(0, $P8XPi.TYPES).FLOAT] = 4, $a6b5762b13998910$var$_a$2[(0, $P8XPi.TYPES).HALF_FLOAT] = 8, $a6b5762b13998910$var$_a$2);
/**
 * Number of components in each {@link PIXI.FORMATS}
 *
 * @ignore
 */ var $a6b5762b13998910$export$ace48b1390b9b0c2 = ($a6b5762b13998910$var$_b$1 = {}, $a6b5762b13998910$var$_b$1[(0, $P8XPi.FORMATS).RGBA] = 4, $a6b5762b13998910$var$_b$1[(0, $P8XPi.FORMATS).RGB] = 3, $a6b5762b13998910$var$_b$1[(0, $P8XPi.FORMATS).LUMINANCE] = 1, $a6b5762b13998910$var$_b$1[(0, $P8XPi.FORMATS).LUMINANCE_ALPHA] = 2, $a6b5762b13998910$var$_b$1[(0, $P8XPi.FORMATS).ALPHA] = 1, $a6b5762b13998910$var$_b$1);
/**
 * Number of bytes per pixel in bit-field types in {@link PIXI.TYPES}
 *
 * @ignore
 */ var $a6b5762b13998910$export$2ca26443044e8798 = ($a6b5762b13998910$var$_c = {}, $a6b5762b13998910$var$_c[(0, $P8XPi.TYPES).UNSIGNED_SHORT_4_4_4_4] = 2, $a6b5762b13998910$var$_c[(0, $P8XPi.TYPES).UNSIGNED_SHORT_5_5_5_1] = 2, $a6b5762b13998910$var$_c[(0, $P8XPi.TYPES).UNSIGNED_SHORT_5_6_5] = 2, $a6b5762b13998910$var$_c);
/**
 * Loader plugin for handling KTX texture container files.
 *
 * This KTX loader does not currently support the following features:
 * * cube textures
 * * 3D textures
 * * vendor-specific key/value data parsing
 * * endianness conversion for big-endian machines
 * * embedded *.basis files
 *
 * It does supports the following features:
 * * multiple textures per file
 * * mipmapping
 *
 * @class
 * @memberof PIXI
 * @implements PIXI.ILoaderPlugin
 */ var $a6b5762b13998910$export$f154586e513f353e = /** @class */ function() {
    function KTXLoader() {}
    /**
     * Called after a KTX file is loaded.
     *
     * This will parse the KTX file header and add a {@code BaseTexture} to the texture
     * cache.
     *
     * @see PIXI.Loader.loaderMiddleware
     * @param resource - loader resource that is checked to see if it is a KTX file
     * @param next - callback Function to call when done
     */ KTXLoader.use = function(resource, next) {
        if (resource.extension === 'ktx' && resource.data) try {
            var url = resource.name || resource.url;
            Object.assign(resource, $a6b5762b13998910$var$registerCompressedTextures(url, KTXLoader.parse(url, resource.data), resource.metadata));
        } catch (err) {
            next(err);
            return;
        }
        next();
    };
    /** Parses the KTX file header, generates base-textures, and puts them into the texture cache. */ KTXLoader.parse = function(url, arrayBuffer) {
        var dataView = new DataView(arrayBuffer);
        if (!KTXLoader.validate(url, dataView)) return null;
        var littleEndian = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.ENDIANNESS, true) === $a6b5762b13998910$var$ENDIANNESS;
        var glType = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.GL_TYPE, littleEndian);
        // const glTypeSize = dataView.getUint32(KTX_FIELDS.GL_TYPE_SIZE, littleEndian);
        var glFormat = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.GL_FORMAT, littleEndian);
        var glInternalFormat = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.GL_INTERNAL_FORMAT, littleEndian);
        var pixelWidth = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.PIXEL_WIDTH, littleEndian);
        var pixelHeight = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.PIXEL_HEIGHT, littleEndian) || 1; // "pixelHeight = 0" -> "1"
        var pixelDepth = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.PIXEL_DEPTH, littleEndian) || 1; // ^^
        var numberOfArrayElements = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.NUMBER_OF_ARRAY_ELEMENTS, littleEndian) || 1; // ^^
        var numberOfFaces = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.NUMBER_OF_FACES, littleEndian);
        var numberOfMipmapLevels = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.NUMBER_OF_MIPMAP_LEVELS, littleEndian);
        var bytesOfKeyValueData = dataView.getUint32($a6b5762b13998910$var$KTX_FIELDS.BYTES_OF_KEY_VALUE_DATA, littleEndian);
        // Whether the platform architecture is little endian. If littleEndian !== platformLittleEndian, then the
        // file contents must be endian-converted!
        // TODO: Endianness conversion
        // const platformLittleEndian = new Uint8Array((new Uint32Array([ENDIANNESS])).buffer)[0] === 0x01;
        if (pixelHeight === 0 || pixelDepth !== 1) throw new Error('Only 2D textures are supported');
        if (numberOfFaces !== 1) throw new Error('CubeTextures are not supported by KTXLoader yet!');
        if (numberOfArrayElements !== 1) // TODO: Support splitting array-textures into multiple BaseTextures
        throw new Error('WebGL does not support array textures');
        // TODO: 8x4 blocks for 2bpp pvrtc
        var blockWidth = 4;
        var blockHeight = 4;
        var alignedWidth = pixelWidth + 3 & -4;
        var alignedHeight = pixelHeight + 3 & -4;
        var imageBuffers = new Array(numberOfArrayElements);
        var imagePixels = pixelWidth * pixelHeight;
        if (glType === 0) // Align to 16 pixels (4x4 blocks)
        imagePixels = alignedWidth * alignedHeight;
        var imagePixelByteSize;
        if (glType !== 0) {
            // Uncompressed texture format
            if ($a6b5762b13998910$export$96c88eb9c7372a0b[glType]) imagePixelByteSize = $a6b5762b13998910$export$96c88eb9c7372a0b[glType] * $a6b5762b13998910$export$ace48b1390b9b0c2[glFormat];
            else imagePixelByteSize = $a6b5762b13998910$export$2ca26443044e8798[glType];
        } else imagePixelByteSize = $a6b5762b13998910$export$fb888e587c979eee[glInternalFormat];
        if (imagePixelByteSize === undefined) throw new Error('Unable to resolve the pixel format stored in the *.ktx file!');
        var imageByteSize = imagePixels * imagePixelByteSize;
        var mipByteSize = imageByteSize;
        var mipWidth = pixelWidth;
        var mipHeight = pixelHeight;
        var alignedMipWidth = alignedWidth;
        var alignedMipHeight = alignedHeight;
        var imageOffset = $a6b5762b13998910$var$FILE_HEADER_SIZE + bytesOfKeyValueData;
        for(var mipmapLevel = 0; mipmapLevel < numberOfMipmapLevels; mipmapLevel++){
            var imageSize = dataView.getUint32(imageOffset, littleEndian);
            var elementOffset = imageOffset + 4;
            for(var arrayElement = 0; arrayElement < numberOfArrayElements; arrayElement++){
                // TODO: Maybe support 3D textures? :-)
                // for (let zSlice = 0; zSlice < pixelDepth; zSlice)
                var mips = imageBuffers[arrayElement];
                if (!mips) mips = imageBuffers[arrayElement] = new Array(numberOfMipmapLevels);
                mips[mipmapLevel] = {
                    levelID: mipmapLevel,
                    levelWidth: numberOfMipmapLevels > 1 ? mipWidth : alignedMipWidth,
                    levelHeight: numberOfMipmapLevels > 1 ? mipHeight : alignedMipHeight,
                    levelBuffer: new Uint8Array(arrayBuffer, elementOffset, mipByteSize)
                };
                elementOffset += mipByteSize;
            }
            // HINT: Aligns to 4-byte boundary after jumping imageSize (in lieu of mipPadding)
            imageOffset += imageSize + 4; // (+4 to jump the imageSize field itself)
            imageOffset = imageOffset % 4 !== 0 ? imageOffset + 4 - imageOffset % 4 : imageOffset;
            // Calculate mipWidth, mipHeight for _next_ iteration
            mipWidth = mipWidth >> 1 || 1;
            mipHeight = mipHeight >> 1 || 1;
            alignedMipWidth = mipWidth + blockWidth - 1 & ~(blockWidth - 1);
            alignedMipHeight = mipHeight + blockHeight - 1 & ~(blockHeight - 1);
            // Each mipmap level is 4-times smaller?
            mipByteSize = alignedMipWidth * alignedMipHeight * imagePixelByteSize;
        }
        // We use the levelBuffers feature of CompressedTextureResource b/c texture data is image-major, not level-major.
        if (glType !== 0) throw new Error('TODO: Uncompressed');
        return imageBuffers.map(function(levelBuffers) {
            return new $a6b5762b13998910$export$1982af6892f05657(null, {
                format: glInternalFormat,
                width: pixelWidth,
                height: pixelHeight,
                levels: numberOfMipmapLevels,
                levelBuffers: levelBuffers
            });
        });
    };
    /** Checks whether the arrayBuffer contains a valid *.ktx file. */ KTXLoader.validate = function(url, dataView) {
        // NOTE: Do not optimize this into 3 32-bit integer comparison because the endianness
        // of the data is not specified.
        for(var i = 0; i < $a6b5762b13998910$var$FILE_IDENTIFIER.length; i++)if (dataView.getUint8(i) !== $a6b5762b13998910$var$FILE_IDENTIFIER[i]) {
            console.error(url + " is not a valid *.ktx file!");
            return false;
        }
        return true;
    };
    return KTXLoader;
}();

});

parcelRegister("9eyo7", function(module, exports) {

$parcel$export(module.exports, "ParticleContainer", function () { return $6b9018a1467258a6$export$e63bf72b2cfda112; });
$parcel$export(module.exports, "ParticleRenderer", function () { return $6b9018a1467258a6$export$42cbb08a275c7ff9; });
/*!
 * @pixi/particle-container - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/particle-container is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $P8XPi = parcelRequire("P8XPi");

var $8t5Gy = parcelRequire("8t5Gy");

var $csytw = parcelRequire("csytw");

var $klOfb = parcelRequire("klOfb");

var $6qzqq = parcelRequire("6qzqq");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $6b9018a1467258a6$var$extendStatics = function(d, b) {
    $6b9018a1467258a6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $6b9018a1467258a6$var$extendStatics(d, b);
};
function $6b9018a1467258a6$var$__extends(d, b) {
    $6b9018a1467258a6$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * The ParticleContainer class is a really fast version of the Container built solely for speed,
 * so use when you need a lot of sprites or particles.
 *
 * The tradeoff of the ParticleContainer is that most advanced functionality will not work.
 * ParticleContainer implements the basic object transform (position, scale, rotation)
 * and some advanced functionality like tint (as of v4.5.6).
 *
 * Other more advanced functionality like masking, children, filters, etc will not work on sprites in this batch.
 *
 * It's extremely easy to use:
 * ```js
 * let container = new ParticleContainer();
 *
 * for (let i = 0; i < 100; ++i)
 * {
 *     let sprite = PIXI.Sprite.from("myImage.png");
 *     container.addChild(sprite);
 * }
 * ```
 *
 * And here you have a hundred sprites that will be rendered at the speed of light.
 *
 * @memberof PIXI
 */ var $6b9018a1467258a6$export$e63bf72b2cfda112 = /** @class */ function(_super) {
    $6b9018a1467258a6$var$__extends(ParticleContainer, _super);
    /**
     * @param maxSize - The maximum number of particles that can be rendered by the container.
     *  Affects size of allocated buffers.
     * @param properties - The properties of children that should be uploaded to the gpu and applied.
     * @param {boolean} [properties.vertices=false] - When true, vertices be uploaded and applied.
     *                  if sprite's ` scale/anchor/trim/frame/orig` is dynamic, please set `true`.
     * @param {boolean} [properties.position=true] - When true, position be uploaded and applied.
     * @param {boolean} [properties.rotation=false] - When true, rotation be uploaded and applied.
     * @param {boolean} [properties.uvs=false] - When true, uvs be uploaded and applied.
     * @param {boolean} [properties.tint=false] - When true, alpha and tint be uploaded and applied.
     * @param {number} [batchSize=16384] - Number of particles per batch. If less than maxSize, it uses maxSize instead.
     * @param {boolean} [autoResize=false] - If true, container allocates more batches in case
     *  there are more than `maxSize` particles.
     */ function ParticleContainer(maxSize, properties, batchSize, autoResize) {
        if (maxSize === void 0) maxSize = 1500;
        if (batchSize === void 0) batchSize = 16384;
        if (autoResize === void 0) autoResize = false;
        var _this = _super.call(this) || this;
        // Making sure the batch size is valid
        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
        // so max number of particles is 65536 / 4 = 16384
        var maxBatchSize = 16384;
        if (batchSize > maxBatchSize) batchSize = maxBatchSize;
        _this._properties = [
            false,
            true,
            false,
            false,
            false
        ];
        _this._maxSize = maxSize;
        _this._batchSize = batchSize;
        _this._buffers = null;
        _this._bufferUpdateIDs = [];
        _this._updateID = 0;
        _this.interactiveChildren = false;
        _this.blendMode = (0, $P8XPi.BLEND_MODES).NORMAL;
        _this.autoResize = autoResize;
        _this.roundPixels = true;
        _this.baseTexture = null;
        _this.setProperties(properties);
        _this._tint = 0;
        _this.tintRgb = new Float32Array(4);
        _this.tint = 0xFFFFFF;
        return _this;
    }
    /**
     * Sets the private properties array to dynamic / static based on the passed properties object
     *
     * @param properties - The properties to be uploaded
     */ ParticleContainer.prototype.setProperties = function(properties) {
        if (properties) {
            this._properties[0] = 'vertices' in properties || 'scale' in properties ? !!properties.vertices || !!properties.scale : this._properties[0];
            this._properties[1] = 'position' in properties ? !!properties.position : this._properties[1];
            this._properties[2] = 'rotation' in properties ? !!properties.rotation : this._properties[2];
            this._properties[3] = 'uvs' in properties ? !!properties.uvs : this._properties[3];
            this._properties[4] = 'tint' in properties || 'alpha' in properties ? !!properties.tint || !!properties.alpha : this._properties[4];
        }
    };
    ParticleContainer.prototype.updateTransform = function() {
        // TODO don't need to!
        this.displayObjectUpdateTransform();
    };
    Object.defineProperty(ParticleContainer.prototype, "tint", {
        /**
         * The tint applied to the container. This is a hex value.
         * A value of 0xFFFFFF will remove any tint effect.
         * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
         *
         * @default 0xFFFFFF
         */ get: function() {
            return this._tint;
        },
        set: function(value) {
            this._tint = value;
            (0, $csytw.hex2rgb)(value, this.tintRgb);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Renders the container using the WebGL renderer.
     *
     * @param renderer - The WebGL renderer.
     */ ParticleContainer.prototype.render = function(renderer) {
        var _this = this;
        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) return;
        if (!this.baseTexture) {
            this.baseTexture = this.children[0]._texture.baseTexture;
            if (!this.baseTexture.valid) this.baseTexture.once('update', function() {
                return _this.onChildrenChange(0);
            });
        }
        renderer.batch.setObjectRenderer(renderer.plugins.particle);
        renderer.plugins.particle.render(this);
    };
    /**
     * Set the flag that static data should be updated to true
     *
     * @param smallestChildIndex - The smallest child index.
     */ ParticleContainer.prototype.onChildrenChange = function(smallestChildIndex) {
        var bufferIndex = Math.floor(smallestChildIndex / this._batchSize);
        while(this._bufferUpdateIDs.length < bufferIndex)this._bufferUpdateIDs.push(0);
        this._bufferUpdateIDs[bufferIndex] = ++this._updateID;
    };
    ParticleContainer.prototype.dispose = function() {
        if (this._buffers) {
            for(var i = 0; i < this._buffers.length; ++i)this._buffers[i].destroy();
            this._buffers = null;
        }
    };
    /**
     * Destroys the container
     *
     * @param options - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their
     *  destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */ ParticleContainer.prototype.destroy = function(options) {
        _super.prototype.destroy.call(this, options);
        this.dispose();
        this._properties = null;
        this._buffers = null;
        this._bufferUpdateIDs = null;
    };
    return ParticleContainer;
}((0, $8t5Gy.Container));
/*
 * @author Mat Groves
 *
 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
 * for creating the original PixiJS version!
 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that
 * they now share 4 bytes on the vertex buffer
 *
 * Heavily inspired by LibGDX's ParticleBuffer:
 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleBuffer.java
 */ /**
 * The particle buffer manages the static and dynamic buffers for a particle container.
 *
 * @private
 * @memberof PIXI
 */ var $6b9018a1467258a6$var$ParticleBuffer = /** @class */ function() {
    /**
     * @param {object} properties - The properties to upload.
     * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
     * @param {number} size - The size of the batch.
     */ function ParticleBuffer(properties, dynamicPropertyFlags, size) {
        this.geometry = new (0, $klOfb.Geometry)();
        this.indexBuffer = null;
        this.size = size;
        this.dynamicProperties = [];
        this.staticProperties = [];
        for(var i = 0; i < properties.length; ++i){
            var property = properties[i];
            // Make copy of properties object so that when we edit the offset it doesn't
            // change all other instances of the object literal
            property = {
                attributeName: property.attributeName,
                size: property.size,
                uploadFunction: property.uploadFunction,
                type: property.type || (0, $P8XPi.TYPES).FLOAT,
                offset: property.offset
            };
            if (dynamicPropertyFlags[i]) this.dynamicProperties.push(property);
            else this.staticProperties.push(property);
        }
        this.staticStride = 0;
        this.staticBuffer = null;
        this.staticData = null;
        this.staticDataUint32 = null;
        this.dynamicStride = 0;
        this.dynamicBuffer = null;
        this.dynamicData = null;
        this.dynamicDataUint32 = null;
        this._updateID = 0;
        this.initBuffers();
    }
    /** Sets up the renderer context and necessary buffers. */ ParticleBuffer.prototype.initBuffers = function() {
        var geometry = this.geometry;
        var dynamicOffset = 0;
        this.indexBuffer = new (0, $klOfb.Buffer)((0, $csytw.createIndicesForQuads)(this.size), true, true);
        geometry.addIndex(this.indexBuffer);
        this.dynamicStride = 0;
        for(var i = 0; i < this.dynamicProperties.length; ++i){
            var property = this.dynamicProperties[i];
            property.offset = dynamicOffset;
            dynamicOffset += property.size;
            this.dynamicStride += property.size;
        }
        var dynBuffer = new ArrayBuffer(this.size * this.dynamicStride * 16);
        this.dynamicData = new Float32Array(dynBuffer);
        this.dynamicDataUint32 = new Uint32Array(dynBuffer);
        this.dynamicBuffer = new (0, $klOfb.Buffer)(this.dynamicData, false, false);
        // static //
        var staticOffset = 0;
        this.staticStride = 0;
        for(var i = 0; i < this.staticProperties.length; ++i){
            var property = this.staticProperties[i];
            property.offset = staticOffset;
            staticOffset += property.size;
            this.staticStride += property.size;
        }
        var statBuffer = new ArrayBuffer(this.size * this.staticStride * 16);
        this.staticData = new Float32Array(statBuffer);
        this.staticDataUint32 = new Uint32Array(statBuffer);
        this.staticBuffer = new (0, $klOfb.Buffer)(this.staticData, true, false);
        for(var i = 0; i < this.dynamicProperties.length; ++i){
            var property = this.dynamicProperties[i];
            geometry.addAttribute(property.attributeName, this.dynamicBuffer, 0, property.type === (0, $P8XPi.TYPES).UNSIGNED_BYTE, property.type, this.dynamicStride * 4, property.offset * 4);
        }
        for(var i = 0; i < this.staticProperties.length; ++i){
            var property = this.staticProperties[i];
            geometry.addAttribute(property.attributeName, this.staticBuffer, 0, property.type === (0, $P8XPi.TYPES).UNSIGNED_BYTE, property.type, this.staticStride * 4, property.offset * 4);
        }
    };
    /**
     * Uploads the dynamic properties.
     *
     * @param children - The children to upload.
     * @param startIndex - The index to start at.
     * @param amount - The number to upload.
     */ ParticleBuffer.prototype.uploadDynamic = function(children, startIndex, amount) {
        for(var i = 0; i < this.dynamicProperties.length; i++){
            var property = this.dynamicProperties[i];
            property.uploadFunction(children, startIndex, amount, property.type === (0, $P8XPi.TYPES).UNSIGNED_BYTE ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, property.offset);
        }
        this.dynamicBuffer._updateID++;
    };
    /**
     * Uploads the static properties.
     *
     * @param children - The children to upload.
     * @param startIndex - The index to start at.
     * @param amount - The number to upload.
     */ ParticleBuffer.prototype.uploadStatic = function(children, startIndex, amount) {
        for(var i = 0; i < this.staticProperties.length; i++){
            var property = this.staticProperties[i];
            property.uploadFunction(children, startIndex, amount, property.type === (0, $P8XPi.TYPES).UNSIGNED_BYTE ? this.staticDataUint32 : this.staticData, this.staticStride, property.offset);
        }
        this.staticBuffer._updateID++;
    };
    /** Destroys the ParticleBuffer. */ ParticleBuffer.prototype.destroy = function() {
        this.indexBuffer = null;
        this.dynamicProperties = null;
        this.dynamicBuffer = null;
        this.dynamicData = null;
        this.dynamicDataUint32 = null;
        this.staticProperties = null;
        this.staticBuffer = null;
        this.staticData = null;
        this.staticDataUint32 = null;
        // all buffers are destroyed inside geometry
        this.geometry.destroy();
    };
    return ParticleBuffer;
}();
var $6b9018a1467258a6$var$fragment = "varying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void){\n    vec4 color = texture2D(uSampler, vTextureCoord) * vColor;\n    gl_FragColor = color;\n}";
var $6b9018a1467258a6$var$vertex = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\n\nattribute vec2 aPositionCoord;\nattribute float aRotation;\n\nuniform mat3 translationMatrix;\nuniform vec4 uColor;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nvoid main(void){\n    float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);\n    float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);\n\n    vec2 v = vec2(x, y);\n    v = v + aPositionCoord;\n\n    gl_Position = vec4((translationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vColor = aColor * uColor;\n}\n";
/*
 * @author Mat Groves
 *
 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
 * for creating the original PixiJS version!
 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
 * share 4 bytes on the vertex buffer
 *
 * Heavily inspired by LibGDX's ParticleRenderer:
 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleRenderer.java
 */ /**
 * Renderer for Particles that is designer for speed over feature set.
 *
 * @memberof PIXI
 */ var $6b9018a1467258a6$export$42cbb08a275c7ff9 = /** @class */ function(_super) {
    $6b9018a1467258a6$var$__extends(ParticleRenderer, _super);
    /**
     * @param renderer - The renderer this sprite batch works for.
     */ function ParticleRenderer(renderer) {
        var _this = _super.call(this, renderer) || this;
        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
        // so max number of particles is 65536 / 4 = 16384
        // and max number of element in the index buffer is 16384 * 6 = 98304
        // Creating a full index buffer, overhead is 98304 * 2 = 196Ko
        // let numIndices = 98304;
        _this.shader = null;
        _this.properties = null;
        _this.tempMatrix = new (0, $6qzqq.Matrix)();
        _this.properties = [
            // verticesData
            {
                attributeName: 'aVertexPosition',
                size: 2,
                uploadFunction: _this.uploadVertices,
                offset: 0
            },
            // positionData
            {
                attributeName: 'aPositionCoord',
                size: 2,
                uploadFunction: _this.uploadPosition,
                offset: 0
            },
            // rotationData
            {
                attributeName: 'aRotation',
                size: 1,
                uploadFunction: _this.uploadRotation,
                offset: 0
            },
            // uvsData
            {
                attributeName: 'aTextureCoord',
                size: 2,
                uploadFunction: _this.uploadUvs,
                offset: 0
            },
            // tintData
            {
                attributeName: 'aColor',
                size: 1,
                type: (0, $P8XPi.TYPES).UNSIGNED_BYTE,
                uploadFunction: _this.uploadTint,
                offset: 0
            }
        ];
        _this.shader = (0, $klOfb.Shader).from($6b9018a1467258a6$var$vertex, $6b9018a1467258a6$var$fragment, {});
        _this.state = (0, $klOfb.State).for2d();
        return _this;
    }
    /**
     * Renders the particle container object.
     *
     * @param container - The container to render using this ParticleRenderer.
     */ ParticleRenderer.prototype.render = function(container) {
        var children = container.children;
        var maxSize = container._maxSize;
        var batchSize = container._batchSize;
        var renderer = this.renderer;
        var totalChildren = children.length;
        if (totalChildren === 0) return;
        else if (totalChildren > maxSize && !container.autoResize) totalChildren = maxSize;
        var buffers = container._buffers;
        if (!buffers) buffers = container._buffers = this.generateBuffers(container);
        var baseTexture = children[0]._texture.baseTexture;
        // if the uvs have not updated then no point rendering just yet!
        this.state.blendMode = (0, $csytw.correctBlendMode)(container.blendMode, baseTexture.alphaMode);
        renderer.state.set(this.state);
        var gl = renderer.gl;
        var m = container.worldTransform.copyTo(this.tempMatrix);
        m.prepend(renderer.globalUniforms.uniforms.projectionMatrix);
        this.shader.uniforms.translationMatrix = m.toArray(true);
        this.shader.uniforms.uColor = (0, $csytw.premultiplyRgba)(container.tintRgb, container.worldAlpha, this.shader.uniforms.uColor, baseTexture.alphaMode);
        this.shader.uniforms.uSampler = baseTexture;
        this.renderer.shader.bind(this.shader);
        var updateStatic = false;
        // now lets upload and render the buffers..
        for(var i = 0, j = 0; i < totalChildren; i += batchSize, j += 1){
            var amount = totalChildren - i;
            if (amount > batchSize) amount = batchSize;
            if (j >= buffers.length) buffers.push(this._generateOneMoreBuffer(container));
            var buffer = buffers[j];
            // we always upload the dynamic
            buffer.uploadDynamic(children, i, amount);
            var bid = container._bufferUpdateIDs[j] || 0;
            updateStatic = updateStatic || buffer._updateID < bid;
            // we only upload the static content when we have to!
            if (updateStatic) {
                buffer._updateID = container._updateID;
                buffer.uploadStatic(children, i, amount);
            }
            // bind the buffer
            renderer.geometry.bind(buffer.geometry);
            gl.drawElements(gl.TRIANGLES, amount * 6, gl.UNSIGNED_SHORT, 0);
        }
    };
    /**
     * Creates one particle buffer for each child in the container we want to render and updates internal properties.
     *
     * @param container - The container to render using this ParticleRenderer
     * @return - The buffers
     */ ParticleRenderer.prototype.generateBuffers = function(container) {
        var buffers = [];
        var size = container._maxSize;
        var batchSize = container._batchSize;
        var dynamicPropertyFlags = container._properties;
        for(var i = 0; i < size; i += batchSize)buffers.push(new $6b9018a1467258a6$var$ParticleBuffer(this.properties, dynamicPropertyFlags, batchSize));
        return buffers;
    };
    /**
     * Creates one more particle buffer, because container has autoResize feature.
     *
     * @param container - The container to render using this ParticleRenderer
     * @return - The generated buffer
     */ ParticleRenderer.prototype._generateOneMoreBuffer = function(container) {
        var batchSize = container._batchSize;
        var dynamicPropertyFlags = container._properties;
        return new $6b9018a1467258a6$var$ParticleBuffer(this.properties, dynamicPropertyFlags, batchSize);
    };
    /**
     * Uploads the vertices.
     *
     * @param children - the array of display objects to render
     * @param startIndex - the index to start from in the children array
     * @param amount - the amount of children that will have their vertices uploaded
     * @param array - The vertices to upload.
     * @param stride - Stride to use for iteration.
     * @param offset - Offset to start at.
     */ ParticleRenderer.prototype.uploadVertices = function(children, startIndex, amount, array, stride, offset) {
        var w0 = 0;
        var w1 = 0;
        var h0 = 0;
        var h1 = 0;
        for(var i = 0; i < amount; ++i){
            var sprite = children[startIndex + i];
            var texture = sprite._texture;
            var sx = sprite.scale.x;
            var sy = sprite.scale.y;
            var trim = texture.trim;
            var orig = texture.orig;
            if (trim) {
                // if the sprite is trimmed and is not a tilingsprite then we need to add the
                // extra space before transforming the sprite coords..
                w1 = trim.x - sprite.anchor.x * orig.width;
                w0 = w1 + trim.width;
                h1 = trim.y - sprite.anchor.y * orig.height;
                h0 = h1 + trim.height;
            } else {
                w0 = orig.width * (1 - sprite.anchor.x);
                w1 = orig.width * -sprite.anchor.x;
                h0 = orig.height * (1 - sprite.anchor.y);
                h1 = orig.height * -sprite.anchor.y;
            }
            array[offset] = w1 * sx;
            array[offset + 1] = h1 * sy;
            array[offset + stride] = w0 * sx;
            array[offset + stride + 1] = h1 * sy;
            array[offset + stride * 2] = w0 * sx;
            array[offset + stride * 2 + 1] = h0 * sy;
            array[offset + stride * 3] = w1 * sx;
            array[offset + stride * 3 + 1] = h0 * sy;
            offset += stride * 4;
        }
    };
    /**
     * Uploads the position.
     *
     * @param children - the array of display objects to render
     * @param startIndex - the index to start from in the children array
     * @param amount - the amount of children that will have their positions uploaded
     * @param array - The vertices to upload.
     * @param stride - Stride to use for iteration.
     * @param offset - Offset to start at.
     */ ParticleRenderer.prototype.uploadPosition = function(children, startIndex, amount, array, stride, offset) {
        for(var i = 0; i < amount; i++){
            var spritePosition = children[startIndex + i].position;
            array[offset] = spritePosition.x;
            array[offset + 1] = spritePosition.y;
            array[offset + stride] = spritePosition.x;
            array[offset + stride + 1] = spritePosition.y;
            array[offset + stride * 2] = spritePosition.x;
            array[offset + stride * 2 + 1] = spritePosition.y;
            array[offset + stride * 3] = spritePosition.x;
            array[offset + stride * 3 + 1] = spritePosition.y;
            offset += stride * 4;
        }
    };
    /**
     * Uploads the rotation.
     *
     * @param children - the array of display objects to render
     * @param startIndex - the index to start from in the children array
     * @param amount - the amount of children that will have their rotation uploaded
     * @param array - The vertices to upload.
     * @param stride - Stride to use for iteration.
     * @param offset - Offset to start at.
     */ ParticleRenderer.prototype.uploadRotation = function(children, startIndex, amount, array, stride, offset) {
        for(var i = 0; i < amount; i++){
            var spriteRotation = children[startIndex + i].rotation;
            array[offset] = spriteRotation;
            array[offset + stride] = spriteRotation;
            array[offset + stride * 2] = spriteRotation;
            array[offset + stride * 3] = spriteRotation;
            offset += stride * 4;
        }
    };
    /**
     * Uploads the UVs.
     *
     * @param children - the array of display objects to render
     * @param startIndex - the index to start from in the children array
     * @param amount - the amount of children that will have their rotation uploaded
     * @param array - The vertices to upload.
     * @param stride - Stride to use for iteration.
     * @param offset - Offset to start at.
     */ ParticleRenderer.prototype.uploadUvs = function(children, startIndex, amount, array, stride, offset) {
        for(var i = 0; i < amount; ++i){
            var textureUvs = children[startIndex + i]._texture._uvs;
            if (textureUvs) {
                array[offset] = textureUvs.x0;
                array[offset + 1] = textureUvs.y0;
                array[offset + stride] = textureUvs.x1;
                array[offset + stride + 1] = textureUvs.y1;
                array[offset + stride * 2] = textureUvs.x2;
                array[offset + stride * 2 + 1] = textureUvs.y2;
                array[offset + stride * 3] = textureUvs.x3;
                array[offset + stride * 3 + 1] = textureUvs.y3;
                offset += stride * 4;
            } else {
                // TODO you know this can be easier!
                array[offset] = 0;
                array[offset + 1] = 0;
                array[offset + stride] = 0;
                array[offset + stride + 1] = 0;
                array[offset + stride * 2] = 0;
                array[offset + stride * 2 + 1] = 0;
                array[offset + stride * 3] = 0;
                array[offset + stride * 3 + 1] = 0;
                offset += stride * 4;
            }
        }
    };
    /**
     * Uploads the tint.
     *
     * @param children - the array of display objects to render
     * @param startIndex - the index to start from in the children array
     * @param amount - the amount of children that will have their rotation uploaded
     * @param array - The vertices to upload.
     * @param stride - Stride to use for iteration.
     * @param offset - Offset to start at.
     */ ParticleRenderer.prototype.uploadTint = function(children, startIndex, amount, array, stride, offset) {
        for(var i = 0; i < amount; ++i){
            var sprite = children[startIndex + i];
            var premultiplied = sprite._texture.baseTexture.alphaMode > 0;
            var alpha = sprite.alpha;
            // we dont call extra function if alpha is 1.0, that's faster
            var argb = alpha < 1.0 && premultiplied ? (0, $csytw.premultiplyTint)(sprite._tintRGB, alpha) : sprite._tintRGB + (alpha * 255 << 24);
            array[offset] = argb;
            array[offset + stride] = argb;
            array[offset + stride * 2] = argb;
            array[offset + stride * 3] = argb;
            offset += stride * 4;
        }
    };
    /** Destroys the ParticleRenderer. */ ParticleRenderer.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        if (this.shader) {
            this.shader.destroy();
            this.shader = null;
        }
        this.tempMatrix = null;
    };
    return ParticleRenderer;
}((0, $klOfb.ObjectRenderer));

});

parcelRegister("1WkLv", function(module, exports) {

$parcel$export(module.exports, "CountLimiter", function () { return $169b50be80908716$export$29966907153718d8; });
$parcel$export(module.exports, "BasePrepare", function () { return $169b50be80908716$export$189fb89547161769; });
$parcel$export(module.exports, "Prepare", function () { return $169b50be80908716$export$6475b8f46e7e39d6; });
$parcel$export(module.exports, "TimeLimiter", function () { return $169b50be80908716$export$82e43921ff85c600; });
/*!
 * @pixi/prepare - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/prepare is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $ezJmd = parcelRequire("ezJmd");

var $klOfb = parcelRequire("klOfb");

var $gwPoJ = parcelRequire("gwPoJ");

var $3YyWq = parcelRequire("3YyWq");

var $8t5Gy = parcelRequire("8t5Gy");

var $9Pi8W = parcelRequire("9Pi8W");
/**
 * Default number of uploads per frame using prepare plugin.
 *
 * @static
 * @memberof PIXI.settings
 * @name UPLOADS_PER_FRAME
 * @type {number}
 * @default 4
 */ (0, $ezJmd.settings).UPLOADS_PER_FRAME = 4;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $169b50be80908716$var$extendStatics = function(d, b) {
    $169b50be80908716$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $169b50be80908716$var$extendStatics(d, b);
};
function $169b50be80908716$var$__extends(d, b) {
    $169b50be80908716$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * CountLimiter limits the number of items handled by a {@link PIXI.BasePrepare} to a specified
 * number of items per frame.
 *
 * @memberof PIXI
 */ var $169b50be80908716$export$29966907153718d8 = /** @class */ function() {
    /**
     * @param maxItemsPerFrame - The maximum number of items that can be prepared each frame.
     */ function CountLimiter(maxItemsPerFrame) {
        this.maxItemsPerFrame = maxItemsPerFrame;
        this.itemsLeft = 0;
    }
    /** Resets any counting properties to start fresh on a new frame. */ CountLimiter.prototype.beginFrame = function() {
        this.itemsLeft = this.maxItemsPerFrame;
    };
    /**
     * Checks to see if another item can be uploaded. This should only be called once per item.
     *
     * @return If the item is allowed to be uploaded.
     */ CountLimiter.prototype.allowedToUpload = function() {
        return this.itemsLeft-- > 0;
    };
    return CountLimiter;
}();
/**
 * Built-in hook to find multiple textures from objects like AnimatedSprites.
 *
 * @private
 * @param item - Display object to check
 * @param queue - Collection of items to upload
 * @return If a PIXI.Texture object was found.
 */ function $169b50be80908716$var$findMultipleBaseTextures(item, queue) {
    var result = false;
    // Objects with multiple textures
    if (item && item._textures && item._textures.length) {
        for(var i = 0; i < item._textures.length; i++)if (item._textures[i] instanceof (0, $klOfb.Texture)) {
            var baseTexture = item._textures[i].baseTexture;
            if (queue.indexOf(baseTexture) === -1) {
                queue.push(baseTexture);
                result = true;
            }
        }
    }
    return result;
}
/**
 * Built-in hook to find BaseTextures from Texture.
 *
 * @private
 * @param item - Display object to check
 * @param queue - Collection of items to upload
 * @return If a PIXI.Texture object was found.
 */ function $169b50be80908716$var$findBaseTexture(item, queue) {
    if (item.baseTexture instanceof (0, $klOfb.BaseTexture)) {
        var texture = item.baseTexture;
        if (queue.indexOf(texture) === -1) queue.push(texture);
        return true;
    }
    return false;
}
/**
 * Built-in hook to find textures from objects.
 *
 * @private
 * @param item - Display object to check
 * @param queue - Collection of items to upload
 * @return If a PIXI.Texture object was found.
 */ function $169b50be80908716$var$findTexture(item, queue) {
    if (item._texture && item._texture instanceof (0, $klOfb.Texture)) {
        var texture = item._texture.baseTexture;
        if (queue.indexOf(texture) === -1) queue.push(texture);
        return true;
    }
    return false;
}
/**
 * Built-in hook to draw PIXI.Text to its texture.
 *
 * @private
 * @param helper - Not used by this upload handler
 * @param item - Item to check
 * @return If item was uploaded.
 */ function $169b50be80908716$var$drawText(_helper, item) {
    if (item instanceof (0, $9Pi8W.Text)) {
        // updating text will return early if it is not dirty
        item.updateText(true);
        return true;
    }
    return false;
}
/**
 * Built-in hook to calculate a text style for a PIXI.Text object.
 *
 * @private
 * @param helper - Not used by this upload handler
 * @param item - Item to check
 * @return If item was uploaded.
 */ function $169b50be80908716$var$calculateTextStyle(_helper, item) {
    if (item instanceof (0, $9Pi8W.TextStyle)) {
        var font = item.toFontString();
        (0, $9Pi8W.TextMetrics).measureFont(font);
        return true;
    }
    return false;
}
/**
 * Built-in hook to find Text objects.
 *
 * @private
 * @param item - Display object to check
 * @param queue - Collection of items to upload
 * @return if a PIXI.Text object was found.
 */ function $169b50be80908716$var$findText(item, queue) {
    if (item instanceof (0, $9Pi8W.Text)) {
        // push the text style to prepare it - this can be really expensive
        if (queue.indexOf(item.style) === -1) queue.push(item.style);
        // also push the text object so that we can render it (to canvas/texture) if needed
        if (queue.indexOf(item) === -1) queue.push(item);
        // also push the Text's texture for upload to GPU
        var texture = item._texture.baseTexture;
        if (queue.indexOf(texture) === -1) queue.push(texture);
        return true;
    }
    return false;
}
/**
 * Built-in hook to find TextStyle objects.
 *
 * @private
 * @param item - Display object to check
 * @param queue - Collection of items to upload
 * @return If a PIXI.TextStyle object was found.
 */ function $169b50be80908716$var$findTextStyle(item, queue) {
    if (item instanceof (0, $9Pi8W.TextStyle)) {
        if (queue.indexOf(item) === -1) queue.push(item);
        return true;
    }
    return false;
}
/**
 * The prepare manager provides functionality to upload content to the GPU.
 *
 * BasePrepare handles basic queuing functionality and is extended by
 * {@link PIXI.Prepare} and {@link PIXI.CanvasPrepare}
 * to provide preparation capabilities specific to their respective renderers.
 *
 * @example
 * // Create a sprite
 * const sprite = PIXI.Sprite.from('something.png');
 *
 * // Load object into GPU
 * app.renderer.plugins.prepare.upload(sprite, () => {
 *
 *     //Texture(s) has been uploaded to GPU
 *     app.stage.addChild(sprite);
 *
 * })
 *
 * @abstract
 * @memberof PIXI
 */ var $169b50be80908716$export$189fb89547161769 = /** @class */ function() {
    /**
     * @param {PIXI.AbstractRenderer} renderer - A reference to the current renderer
     */ function BasePrepare(renderer) {
        var _this = this;
        this.limiter = new $169b50be80908716$export$29966907153718d8((0, $ezJmd.settings).UPLOADS_PER_FRAME);
        this.renderer = renderer;
        this.uploadHookHelper = null;
        this.queue = [];
        this.addHooks = [];
        this.uploadHooks = [];
        this.completes = [];
        this.ticking = false;
        this.delayedTick = function() {
            // unlikely, but in case we were destroyed between tick() and delayedTick()
            if (!_this.queue) return;
            _this.prepareItems();
        };
        // hooks to find the correct texture
        this.registerFindHook($169b50be80908716$var$findText);
        this.registerFindHook($169b50be80908716$var$findTextStyle);
        this.registerFindHook($169b50be80908716$var$findMultipleBaseTextures);
        this.registerFindHook($169b50be80908716$var$findBaseTexture);
        this.registerFindHook($169b50be80908716$var$findTexture);
        // upload hooks
        this.registerUploadHook($169b50be80908716$var$drawText);
        this.registerUploadHook($169b50be80908716$var$calculateTextStyle);
    }
    /**
     * Upload all the textures and graphics to the GPU.
     *
     * @param {Function|PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} item -
     *        Either the container or display object to search for items to upload, the items to upload themselves,
     *        or the callback function, if items have been added using `prepare.add`.
     * @param {Function} [done] - Optional callback when all queued uploads have completed
     */ BasePrepare.prototype.upload = function(item, done) {
        if (typeof item === 'function') {
            done = item;
            item = null;
        }
        // If a display object, search for items
        // that we could upload
        if (item) this.add(item);
        // Get the items for upload from the display
        if (this.queue.length) {
            if (done) this.completes.push(done);
            if (!this.ticking) {
                this.ticking = true;
                (0, $3YyWq.Ticker).system.addOnce(this.tick, this, (0, $3YyWq.UPDATE_PRIORITY).UTILITY);
            }
        } else if (done) done();
    };
    /**
     * Handle tick update
     *
     * @private
     */ BasePrepare.prototype.tick = function() {
        setTimeout(this.delayedTick, 0);
    };
    /**
     * Actually prepare items. This is handled outside of the tick because it will take a while
     * and we do NOT want to block the current animation frame from rendering.
     *
     * @private
     */ BasePrepare.prototype.prepareItems = function() {
        this.limiter.beginFrame();
        // Upload the graphics
        while(this.queue.length && this.limiter.allowedToUpload()){
            var item = this.queue[0];
            var uploaded = false;
            if (item && !item._destroyed) {
                for(var i = 0, len = this.uploadHooks.length; i < len; i++)if (this.uploadHooks[i](this.uploadHookHelper, item)) {
                    this.queue.shift();
                    uploaded = true;
                    break;
                }
            }
            if (!uploaded) this.queue.shift();
        }
        // We're finished
        if (!this.queue.length) {
            this.ticking = false;
            var completes = this.completes.slice(0);
            this.completes.length = 0;
            for(var i = 0, len = completes.length; i < len; i++)completes[i]();
        } else // if we are not finished, on the next rAF do this again
        (0, $3YyWq.Ticker).system.addOnce(this.tick, this, (0, $3YyWq.UPDATE_PRIORITY).UTILITY);
    };
    /**
     * Adds hooks for finding items.
     *
     * @param {Function} addHook - Function call that takes two parameters: `item:*, queue:Array`
     *          function must return `true` if it was able to add item to the queue.
     * @return Instance of plugin for chaining.
     */ BasePrepare.prototype.registerFindHook = function(addHook) {
        if (addHook) this.addHooks.push(addHook);
        return this;
    };
    /**
     * Adds hooks for uploading items.
     *
     * @param {Function} uploadHook - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
     *          function must return `true` if it was able to handle upload of item.
     * @return Instance of plugin for chaining.
     */ BasePrepare.prototype.registerUploadHook = function(uploadHook) {
        if (uploadHook) this.uploadHooks.push(uploadHook);
        return this;
    };
    /**
     * Manually add an item to the uploading queue.
     *
     * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
     *        add to the queue
     * @return Instance of plugin for chaining.
     */ BasePrepare.prototype.add = function(item) {
        // Add additional hooks for finding elements on special
        // types of objects that
        for(var i = 0, len = this.addHooks.length; i < len; i++){
            if (this.addHooks[i](item, this.queue)) break;
        }
        // Get children recursively
        if (item instanceof (0, $8t5Gy.Container)) for(var i = item.children.length - 1; i >= 0; i--)this.add(item.children[i]);
        return this;
    };
    /** Destroys the plugin, don't use after this. */ BasePrepare.prototype.destroy = function() {
        if (this.ticking) (0, $3YyWq.Ticker).system.remove(this.tick, this);
        this.ticking = false;
        this.addHooks = null;
        this.uploadHooks = null;
        this.renderer = null;
        this.completes = null;
        this.queue = null;
        this.limiter = null;
        this.uploadHookHelper = null;
    };
    return BasePrepare;
}();
/**
 * Built-in hook to upload PIXI.Texture objects to the GPU.
 *
 * @private
 * @param renderer - instance of the webgl renderer
 * @param item - Item to check
 * @return If item was uploaded.
 */ function $169b50be80908716$var$uploadBaseTextures(renderer, item) {
    if (item instanceof (0, $klOfb.BaseTexture)) {
        // if the texture already has a GL texture, then the texture has been prepared or rendered
        // before now. If the texture changed, then the changer should be calling texture.update() which
        // reuploads the texture without need for preparing it again
        if (!item._glTextures[renderer.CONTEXT_UID]) renderer.texture.bind(item);
        return true;
    }
    return false;
}
/**
 * Built-in hook to upload PIXI.Graphics to the GPU.
 *
 * @private
 * @param renderer - instance of the webgl renderer
 * @param item - Item to check
 * @return If item was uploaded.
 */ function $169b50be80908716$var$uploadGraphics(renderer, item) {
    if (!(item instanceof (0, $gwPoJ.Graphics))) return false;
    var geometry = item.geometry;
    // update dirty graphics to get batches
    item.finishPoly();
    geometry.updateBatches();
    var batches = geometry.batches;
    // upload all textures found in styles
    for(var i = 0; i < batches.length; i++){
        var texture = batches[i].style.texture;
        if (texture) $169b50be80908716$var$uploadBaseTextures(renderer, texture.baseTexture);
    }
    // if its not batchable - update vao for particular shader
    if (!geometry.batchable) renderer.geometry.bind(geometry, item._resolveDirectShader(renderer));
    return true;
}
/**
 * Built-in hook to find graphics.
 *
 * @private
 * @param item - Display object to check
 * @param queue - Collection of items to upload
 * @return if a PIXI.Graphics object was found.
 */ function $169b50be80908716$var$findGraphics(item, queue) {
    if (item instanceof (0, $gwPoJ.Graphics)) {
        queue.push(item);
        return true;
    }
    return false;
}
/**
 * The prepare plugin provides renderer-specific plugins for pre-rendering DisplayObjects. These plugins are useful for
 * asynchronously preparing and uploading to the GPU assets, textures, graphics waiting to be displayed.
 *
 * Do not instantiate this plugin directly. It is available from the `renderer.plugins` property.
 * See {@link PIXI.CanvasRenderer#plugins} or {@link PIXI.Renderer#plugins}.
 * @example
 * // Create a new application
 * const app = new PIXI.Application();
 * document.body.appendChild(app.view);
 *
 * // Don't start rendering right away
 * app.stop();
 *
 * // create a display object
 * const rect = new PIXI.Graphics()
 *     .beginFill(0x00ff00)
 *     .drawRect(40, 40, 200, 200);
 *
 * // Add to the stage
 * app.stage.addChild(rect);
 *
 * // Don't start rendering until the graphic is uploaded to the GPU
 * app.renderer.plugins.prepare.upload(app.stage, () => {
 *     app.start();
 * });
 *
 *
 * @memberof PIXI
 */ var $169b50be80908716$export$6475b8f46e7e39d6 = /** @class */ function(_super) {
    $169b50be80908716$var$__extends(Prepare, _super);
    /**
     * @param {PIXI.Renderer} renderer - A reference to the current renderer
     */ function Prepare(renderer) {
        var _this = _super.call(this, renderer) || this;
        _this.uploadHookHelper = _this.renderer;
        // Add textures and graphics to upload
        _this.registerFindHook($169b50be80908716$var$findGraphics);
        _this.registerUploadHook($169b50be80908716$var$uploadBaseTextures);
        _this.registerUploadHook($169b50be80908716$var$uploadGraphics);
        return _this;
    }
    return Prepare;
}($169b50be80908716$export$189fb89547161769);
/**
 * TimeLimiter limits the number of items handled by a {@link PIXI.BasePrepare} to a specified
 * number of milliseconds per frame.
 *
 * @memberof PIXI
 */ var $169b50be80908716$export$82e43921ff85c600 = /** @class */ function() {
    /** @param maxMilliseconds - The maximum milliseconds that can be spent preparing items each frame. */ function TimeLimiter(maxMilliseconds) {
        this.maxMilliseconds = maxMilliseconds;
        this.frameStart = 0;
    }
    /** Resets any counting properties to start fresh on a new frame. */ TimeLimiter.prototype.beginFrame = function() {
        this.frameStart = Date.now();
    };
    /**
     * Checks to see if another item can be uploaded. This should only be called once per item.
     *
     * @return - If the item is allowed to be uploaded.
     */ TimeLimiter.prototype.allowedToUpload = function() {
        return Date.now() - this.frameStart < this.maxMilliseconds;
    };
    return TimeLimiter;
}();

});
parcelRegister("gwPoJ", function(module, exports) {

$parcel$export(module.exports, "LINE_JOIN", function () { return $c0878112c399eabe$export$c6a6e344be1302e7; });
$parcel$export(module.exports, "LINE_CAP", function () { return $c0878112c399eabe$export$b113e22c48c75d2e; });
$parcel$export(module.exports, "GRAPHICS_CURVES", function () { return $c0878112c399eabe$export$8331f8d2be429f2c; });
$parcel$export(module.exports, "FillStyle", function () { return $c0878112c399eabe$export$c42b166860ccdbd8; });
$parcel$export(module.exports, "GraphicsData", function () { return $c0878112c399eabe$export$94accce0eb494446; });
$parcel$export(module.exports, "GraphicsGeometry", function () { return $c0878112c399eabe$export$c707987b44ce3a12; });
$parcel$export(module.exports, "LineStyle", function () { return $c0878112c399eabe$export$5d24e00cfde59887; });
$parcel$export(module.exports, "Graphics", function () { return $c0878112c399eabe$export$29d3e417456abdad; });
$parcel$export(module.exports, "graphicsUtils", function () { return $c0878112c399eabe$export$efc72ad5bf88689; });
/*!
 * @pixi/graphics - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/graphics is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $6qzqq = parcelRequire("6qzqq");
parcelRequire("csytw");
var $fPquT = parcelRequire("fPquT");
var $csytw = parcelRequire("csytw");

var $P8XPi = parcelRequire("P8XPi");

var $8t5Gy = parcelRequire("8t5Gy");
/**
 * Supported line joints in `PIXI.LineStyle` for graphics.
 *
 * @see PIXI.Graphics#lineStyle
 * @see https://graphicdesign.stackexchange.com/questions/59018/what-is-a-bevel-join-of-two-lines-exactly-illustrator
 *
 * @name LINE_JOIN
 * @memberof PIXI
 * @static
 * @enum {string}
 * @property {string} MITER - 'miter': make a sharp corner where outer part of lines meet
 * @property {string} BEVEL - 'bevel': add a square butt at each end of line segment and fill the triangle at turn
 * @property {string} ROUND - 'round': add an arc at the joint
 */ var $c0878112c399eabe$export$c6a6e344be1302e7;
(function(LINE_JOIN) {
    LINE_JOIN["MITER"] = "miter";
    LINE_JOIN["BEVEL"] = "bevel";
    LINE_JOIN["ROUND"] = "round";
})($c0878112c399eabe$export$c6a6e344be1302e7 || ($c0878112c399eabe$export$c6a6e344be1302e7 = {}));
/**
 * Support line caps in `PIXI.LineStyle` for graphics.
 *
 * @see PIXI.Graphics#lineStyle
 *
 * @name LINE_CAP
 * @memberof PIXI
 * @static
 * @enum {string}
 * @property {string} BUTT - 'butt': don't add any cap at line ends (leaves orthogonal edges)
 * @property {string} ROUND - 'round': add semicircle at ends
 * @property {string} SQUARE - 'square': add square at end (like `BUTT` except more length at end)
 */ var $c0878112c399eabe$export$b113e22c48c75d2e;
(function(LINE_CAP) {
    LINE_CAP["BUTT"] = "butt";
    LINE_CAP["ROUND"] = "round";
    LINE_CAP["SQUARE"] = "square";
})($c0878112c399eabe$export$b113e22c48c75d2e || ($c0878112c399eabe$export$b113e22c48c75d2e = {}));
/**
 * Graphics curves resolution settings. If `adaptive` flag is set to `true`,
 * the resolution is calculated based on the curve's length to ensure better visual quality.
 * Adaptive draw works with `bezierCurveTo` and `quadraticCurveTo`.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name GRAPHICS_CURVES
 * @type {object}
 * @property {boolean} adaptive=true - flag indicating if the resolution should be adaptive
 * @property {number} maxLength=10 - maximal length of a single segment of the curve (if adaptive = false, ignored)
 * @property {number} minSegments=8 - minimal number of segments in the curve (if adaptive = false, ignored)
 * @property {number} maxSegments=2048 - maximal number of segments in the curve (if adaptive = false, ignored)
 */ var $c0878112c399eabe$export$8331f8d2be429f2c = {
    adaptive: true,
    maxLength: 10,
    minSegments: 8,
    maxSegments: 2048,
    epsilon: 0.0001,
    _segmentsCount: function(length, defaultSegments) {
        if (defaultSegments === void 0) defaultSegments = 20;
        if (!this.adaptive || !length || isNaN(length)) return defaultSegments;
        var result = Math.ceil(length / this.maxLength);
        if (result < this.minSegments) result = this.minSegments;
        else if (result > this.maxSegments) result = this.maxSegments;
        return result;
    }
};
/**
 * Fill style object for Graphics.
 *
 * @class
 * @memberof PIXI
 */ var $c0878112c399eabe$export$c42b166860ccdbd8 = /** @class */ function() {
    function FillStyle() {
        /**
         * The hex color value used when coloring the Graphics object.
         *
         * @default 0xFFFFFF
         */ this.color = 0xFFFFFF;
        /** The alpha value used when filling the Graphics object. */ this.alpha = 1.0;
        /**
         * The texture to be used for the fill.
         *
         * @member {PIXI.Texture}
         * @default 0
         */ this.texture = (0, $klOfb.Texture).WHITE;
        /**
         * The transform applied to the texture.
         *
         * @member {PIXI.Matrix}
         * @default null
         */ this.matrix = null;
        /** If the current fill is visible. */ this.visible = false;
        this.reset();
    }
    /**
     * Clones the object
     *
     * @return {PIXI.FillStyle}
     */ FillStyle.prototype.clone = function() {
        var obj = new FillStyle();
        obj.color = this.color;
        obj.alpha = this.alpha;
        obj.texture = this.texture;
        obj.matrix = this.matrix;
        obj.visible = this.visible;
        return obj;
    };
    /**
     * Reset
     */ FillStyle.prototype.reset = function() {
        this.color = 0xFFFFFF;
        this.alpha = 1;
        this.texture = (0, $klOfb.Texture).WHITE;
        this.matrix = null;
        this.visible = false;
    };
    /**
     * Destroy and don't use after this
     */ FillStyle.prototype.destroy = function() {
        this.texture = null;
        this.matrix = null;
    };
    return FillStyle;
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $c0878112c399eabe$var$extendStatics = function(d, b) {
    $c0878112c399eabe$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $c0878112c399eabe$var$extendStatics(d, b);
};
function $c0878112c399eabe$var$__extends(d, b) {
    $c0878112c399eabe$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * Builds a polygon to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the WebGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the WebGL-specific information to create nativeLines
 */ var $c0878112c399eabe$var$buildPoly = {
    build: function(graphicsData) {
        graphicsData.points = graphicsData.shape.points.slice();
    },
    triangulate: function(graphicsData, graphicsGeometry) {
        var points = graphicsData.points;
        var holes = graphicsData.holes;
        var verts = graphicsGeometry.points;
        var indices = graphicsGeometry.indices;
        if (points.length >= 6) {
            var holeArray = [];
            // Process holes..
            for(var i = 0; i < holes.length; i++){
                var hole = holes[i];
                holeArray.push(points.length / 2);
                points = points.concat(hole.points);
            }
            // sort color
            var triangles = (0, (/*@__PURE__*/$parcel$interopDefault($fPquT)))(points, holeArray, 2);
            if (!triangles) return;
            var vertPos = verts.length / 2;
            for(var i = 0; i < triangles.length; i += 3){
                indices.push(triangles[i] + vertPos);
                indices.push(triangles[i + 1] + vertPos);
                indices.push(triangles[i + 2] + vertPos);
            }
            for(var i = 0; i < points.length; i++)verts.push(points[i]);
        }
    }
};
// for type only
/**
 * Builds a circle to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object to draw
 * @param {object} webGLData - an object containing all the WebGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the WebGL-specific information to create nativeLines
 */ var $c0878112c399eabe$var$buildCircle = {
    build: function(graphicsData) {
        // need to convert points to a nice regular data
        var circleData = graphicsData.shape;
        var points = graphicsData.points;
        var x = circleData.x;
        var y = circleData.y;
        var width;
        var height;
        points.length = 0;
        // TODO - bit hacky??
        if (graphicsData.type === (0, $6qzqq.SHAPES).CIRC) {
            width = circleData.radius;
            height = circleData.radius;
        } else {
            var ellipseData = graphicsData.shape;
            width = ellipseData.width;
            height = ellipseData.height;
        }
        if (width === 0 || height === 0) return;
        var totalSegs = Math.floor(30 * Math.sqrt(circleData.radius)) || Math.floor(15 * Math.sqrt(width + height));
        totalSegs /= 2.3;
        var seg = Math.PI * 2 / totalSegs;
        for(var i = 0; i < totalSegs - 0.5; i++)points.push(x + Math.sin(-seg * i) * width, y + Math.cos(-seg * i) * height);
        points.push(points[0], points[1]);
    },
    triangulate: function(graphicsData, graphicsGeometry) {
        var points = graphicsData.points;
        var verts = graphicsGeometry.points;
        var indices = graphicsGeometry.indices;
        var vertPos = verts.length / 2;
        var center = vertPos;
        var circle = graphicsData.shape;
        var matrix = graphicsData.matrix;
        var x = circle.x;
        var y = circle.y;
        // Push center (special point)
        verts.push(graphicsData.matrix ? matrix.a * x + matrix.c * y + matrix.tx : x, graphicsData.matrix ? matrix.b * x + matrix.d * y + matrix.ty : y);
        for(var i = 0; i < points.length; i += 2){
            verts.push(points[i], points[i + 1]);
            // add some uvs
            indices.push(vertPos++, center, vertPos);
        }
    }
};
/**
 * Builds a rectangle to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the WebGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the WebGL-specific information to create nativeLines
 */ var $c0878112c399eabe$var$buildRectangle = {
    build: function(graphicsData) {
        // --- //
        // need to convert points to a nice regular data
        //
        var rectData = graphicsData.shape;
        var x = rectData.x;
        var y = rectData.y;
        var width = rectData.width;
        var height = rectData.height;
        var points = graphicsData.points;
        points.length = 0;
        points.push(x, y, x + width, y, x + width, y + height, x, y + height);
    },
    triangulate: function(graphicsData, graphicsGeometry) {
        var points = graphicsData.points;
        var verts = graphicsGeometry.points;
        var vertPos = verts.length / 2;
        verts.push(points[0], points[1], points[2], points[3], points[6], points[7], points[4], points[5]);
        graphicsGeometry.indices.push(vertPos, vertPos + 1, vertPos + 2, vertPos + 1, vertPos + 2, vertPos + 3);
    }
};
/**
 * Calculate a single point for a quadratic bezier curve.
 * Utility function used by quadraticBezierCurve.
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {number} n1 - first number
 * @param {number} n2 - second number
 * @param {number} perc - percentage
 * @return {number} the result
 *
 */ function $c0878112c399eabe$var$getPt(n1, n2, perc) {
    var diff = n2 - n1;
    return n1 + diff * perc;
}
/**
 * Calculate the points for a quadratic bezier curve. (helper function..)
 * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {number} fromX - Origin point x
 * @param {number} fromY - Origin point x
 * @param {number} cpX - Control point x
 * @param {number} cpY - Control point y
 * @param {number} toX - Destination point x
 * @param {number} toY - Destination point y
 * @param {number[]} [out=[]] - The output array to add points into. If not passed, a new array is created.
 * @return {number[]} an array of points
 */ function $c0878112c399eabe$var$quadraticBezierCurve(fromX, fromY, cpX, cpY, toX, toY, out) {
    if (out === void 0) out = [];
    var n = 20;
    var points = out;
    var xa = 0;
    var ya = 0;
    var xb = 0;
    var yb = 0;
    var x = 0;
    var y = 0;
    for(var i = 0, j = 0; i <= n; ++i){
        j = i / n;
        // The Green Line
        xa = $c0878112c399eabe$var$getPt(fromX, cpX, j);
        ya = $c0878112c399eabe$var$getPt(fromY, cpY, j);
        xb = $c0878112c399eabe$var$getPt(cpX, toX, j);
        yb = $c0878112c399eabe$var$getPt(cpY, toY, j);
        // The Black Dot
        x = $c0878112c399eabe$var$getPt(xa, xb, j);
        y = $c0878112c399eabe$var$getPt(ya, yb, j);
        // Handle case when first curve points overlaps and earcut fails to triangulate
        if (i === 0 && points[points.length - 2] === x && points[points.length - 1] === y) continue;
        points.push(x, y);
    }
    return points;
}
/**
 * Builds a rounded rectangle to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the WebGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the WebGL-specific information to create nativeLines
 */ var $c0878112c399eabe$var$buildRoundedRectangle = {
    build: function(graphicsData) {
        var rrectData = graphicsData.shape;
        var points = graphicsData.points;
        var x = rrectData.x;
        var y = rrectData.y;
        var width = rrectData.width;
        var height = rrectData.height;
        // Don't allow negative radius or greater than half the smallest width
        var radius = Math.max(0, Math.min(rrectData.radius, Math.min(width, height) / 2));
        points.length = 0;
        // No radius, do a simple rectangle
        if (!radius) points.push(x, y, x + width, y, x + width, y + height, x, y + height);
        else {
            $c0878112c399eabe$var$quadraticBezierCurve(x, y + radius, x, y, x + radius, y, points);
            $c0878112c399eabe$var$quadraticBezierCurve(x + width - radius, y, x + width, y, x + width, y + radius, points);
            $c0878112c399eabe$var$quadraticBezierCurve(x + width, y + height - radius, x + width, y + height, x + width - radius, y + height, points);
            $c0878112c399eabe$var$quadraticBezierCurve(x + radius, y + height, x, y + height, x, y + height - radius, points);
        }
    },
    triangulate: function(graphicsData, graphicsGeometry) {
        var points = graphicsData.points;
        var verts = graphicsGeometry.points;
        var indices = graphicsGeometry.indices;
        var vecPos = verts.length / 2;
        var triangles = (0, (/*@__PURE__*/$parcel$interopDefault($fPquT)))(points, null, 2);
        for(var i = 0, j = triangles.length; i < j; i += 3){
            indices.push(triangles[i] + vecPos);
            //     indices.push(triangles[i] + vecPos);
            indices.push(triangles[i + 1] + vecPos);
            //   indices.push(triangles[i + 2] + vecPos);
            indices.push(triangles[i + 2] + vecPos);
        }
        for(var i = 0, j = points.length; i < j; i++)verts.push(points[i], points[++i]);
    }
};
/**
 * Buffers vertices to draw a square cap.
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {number} x - X-coord of end point
 * @param {number} y - Y-coord of end point
 * @param {number} nx - X-coord of line normal pointing inside
 * @param {number} ny - Y-coord of line normal pointing inside
 * @param {Array<number>} verts - vertex buffer
 * @returns {}
 */ function $c0878112c399eabe$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, /* rotation for square (true at left end, false at right end) */ verts) {
    var ix = x - nx * innerWeight;
    var iy = y - ny * innerWeight;
    var ox = x + nx * outerWeight;
    var oy = y + ny * outerWeight;
    /* Rotate nx,ny for extension vector */ var exx;
    var eyy;
    if (clockwise) {
        exx = ny;
        eyy = -nx;
    } else {
        exx = -ny;
        eyy = nx;
    }
    /* [i|0]x,y extended at cap */ var eix = ix + exx;
    var eiy = iy + eyy;
    var eox = ox + exx;
    var eoy = oy + eyy;
    /* Square itself must be inserted clockwise*/ verts.push(eix, eiy);
    verts.push(eox, eoy);
    return 2;
}
/**
 * Buffers vertices to draw an arc at the line joint or cap.
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {number} cx - X-coord of center
 * @param {number} cy - Y-coord of center
 * @param {number} sx - X-coord of arc start
 * @param {number} sy - Y-coord of arc start
 * @param {number} ex - X-coord of arc end
 * @param {number} ey - Y-coord of arc end
 * @param {Array<number>} verts - buffer of vertices
 * @param {boolean} clockwise - orientation of vertices
 * @returns {number} - no. of vertices pushed
 */ function $c0878112c399eabe$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    var cx2p0x = sx - cx;
    var cy2p0y = sy - cy;
    var angle0 = Math.atan2(cx2p0x, cy2p0y);
    var angle1 = Math.atan2(ex - cx, ey - cy);
    if (clockwise && angle0 < angle1) angle0 += Math.PI * 2;
    else if (!clockwise && angle0 > angle1) angle1 += Math.PI * 2;
    var startAngle = angle0;
    var angleDiff = angle1 - angle0;
    var absAngleDiff = Math.abs(angleDiff);
    /* if (absAngleDiff >= PI_LBOUND && absAngleDiff <= PI_UBOUND)
    {
        const r1x = cx - nxtPx;
        const r1y = cy - nxtPy;

        if (r1x === 0)
        {
            if (r1y > 0)
            {
                angleDiff = -angleDiff;
            }
        }
        else if (r1x >= -GRAPHICS_CURVES.epsilon)
        {
            angleDiff = -angleDiff;
        }
    }*/ var radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y);
    var segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1;
    var angleInc = angleDiff / segCount;
    startAngle += angleInc;
    if (clockwise) {
        verts.push(cx, cy);
        verts.push(sx, sy);
        for(var i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx, cy);
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        }
        verts.push(cx, cy);
        verts.push(ex, ey);
    } else {
        verts.push(sx, sy);
        verts.push(cx, cy);
        for(var i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
            verts.push(cx, cy);
        }
        verts.push(ex, ey);
        verts.push(cx, cy);
    }
    return segCount * 2;
}
/**
 * Builds a line to draw using the polygon method.
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.GraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {PIXI.GraphicsGeometry} graphicsGeometry - Geometry where to append output
 */ function $c0878112c399eabe$var$buildNonNativeLine(graphicsData, graphicsGeometry) {
    var shape = graphicsData.shape;
    var points = graphicsData.points || shape.points.slice();
    var eps = graphicsGeometry.closePointEps;
    if (points.length === 0) return;
    // if the line width is an odd number add 0.5 to align to a whole pixel
    // commenting this out fixes #711 and #1620
    // if (graphicsData.lineWidth%2)
    // {
    //     for (i = 0; i < points.length; i++)
    //     {
    //         points[i] += 0.5;
    //     }
    // }
    var style = graphicsData.lineStyle;
    // get first and last point.. figure out the middle!
    var firstPoint = new (0, $6qzqq.Point)(points[0], points[1]);
    var lastPoint = new (0, $6qzqq.Point)(points[points.length - 2], points[points.length - 1]);
    var closedShape = shape.type !== (0, $6qzqq.SHAPES).POLY || shape.closeStroke;
    var closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    // if the first point is the last point - gonna have issues :)
    if (closedShape) {
        // need to clone as we are going to slightly modify the shape..
        points = points.slice();
        if (closedPath) {
            points.pop();
            points.pop();
            lastPoint.set(points[points.length - 2], points[points.length - 1]);
        }
        var midPointX = (firstPoint.x + lastPoint.x) * 0.5;
        var midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY);
        points.push(midPointX, midPointY);
    }
    var verts = graphicsGeometry.points;
    var length = points.length / 2;
    var indexCount = points.length;
    var indexStart = verts.length / 2;
    // Max. inner and outer width
    var width = style.width / 2;
    var widthSquared = width * width;
    var miterLimitSquared = style.miterLimit * style.miterLimit;
    /* Line segments of interest where (x1,y1) forms the corner. */ var x0 = points[0];
    var y0 = points[1];
    var x1 = points[2];
    var y1 = points[3];
    var x2 = 0;
    var y2 = 0;
    /* perp[?](x|y) = the line normal with magnitude lineWidth. */ var perpx = -(y0 - y1);
    var perpy = x0 - x1;
    var perp1x = 0;
    var perp1y = 0;
    var dist = Math.sqrt(perpx * perpx + perpy * perpy);
    perpx /= dist;
    perpy /= dist;
    perpx *= width;
    perpy *= width;
    var ratio = style.alignment; // 0.5;
    var innerWeight = (1 - ratio) * 2;
    var outerWeight = ratio * 2;
    if (!closedShape) {
        if (style.cap === $c0878112c399eabe$export$b113e22c48c75d2e.ROUND) indexCount += $c0878112c399eabe$var$round(x0 - perpx * (innerWeight - outerWeight) * 0.5, y0 - perpy * (innerWeight - outerWeight) * 0.5, x0 - perpx * innerWeight, y0 - perpy * innerWeight, x0 + perpx * outerWeight, y0 + perpy * outerWeight, verts, true) + 2;
        else if (style.cap === $c0878112c399eabe$export$b113e22c48c75d2e.SQUARE) indexCount += $c0878112c399eabe$var$square(x0, y0, perpx, perpy, innerWeight, outerWeight, true, verts);
    }
    // Push first point (below & above vertices)
    verts.push(x0 - perpx * innerWeight, y0 - perpy * innerWeight);
    verts.push(x0 + perpx * outerWeight, y0 + perpy * outerWeight);
    for(var i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2];
        y0 = points[(i - 1) * 2 + 1];
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        x2 = points[(i + 1) * 2];
        y2 = points[(i + 1) * 2 + 1];
        perpx = -(y0 - y1);
        perpy = x0 - x1;
        dist = Math.sqrt(perpx * perpx + perpy * perpy);
        perpx /= dist;
        perpy /= dist;
        perpx *= width;
        perpy *= width;
        perp1x = -(y1 - y2);
        perp1y = x1 - x2;
        dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y);
        perp1x /= dist;
        perp1y /= dist;
        perp1x *= width;
        perp1y *= width;
        /* d[x|y](0|1) = the component displacement between points p(0,1|1,2) */ var dx0 = x1 - x0;
        var dy0 = y0 - y1;
        var dx1 = x1 - x2;
        var dy1 = y2 - y1;
        /* +ve if internal angle counterclockwise, -ve if internal angle clockwise. */ var cross = dy0 * dx1 - dy1 * dx0;
        var clockwise = cross < 0;
        /* Going nearly straight? */ if (Math.abs(cross) < 0.1) {
            verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight);
            verts.push(x1 + perpx * outerWeight, y1 + perpy * outerWeight);
            continue;
        }
        /* p[x|y] is the miter point. pdist is the distance between miter point and p1. */ var c1 = (-perpx + x0) * (-perpy + y1) - (-perpx + x1) * (-perpy + y0);
        var c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2);
        var px = (dx0 * c2 - dx1 * c1) / cross;
        var py = (dy1 * c1 - dy0 * c2) / cross;
        var pdist = (px - x1) * (px - x1) + (py - y1) * (py - y1);
        /* Inner miter point */ var imx = x1 + (px - x1) * innerWeight;
        var imy = y1 + (py - y1) * innerWeight;
        /* Outer miter point */ var omx = x1 - (px - x1) * outerWeight;
        var omy = y1 - (py - y1) * outerWeight;
        /* Is the inside miter point too far away, creating a spike? */ var smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1);
        var insideWeight = clockwise ? innerWeight : outerWeight;
        var smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared;
        var insideMiterOk = pdist <= smallerInsideDiagonalSq;
        if (insideMiterOk) {
            if (style.join === $c0878112c399eabe$export$c6a6e344be1302e7.BEVEL || pdist / widthSquared > miterLimitSquared) {
                if (clockwise) /* rotating at inner angle */ {
                    verts.push(imx, imy); // inner miter point
                    verts.push(x1 + perpx * outerWeight, y1 + perpy * outerWeight); // first segment's outer vertex
                    verts.push(imx, imy); // inner miter point
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight); // second segment's outer vertex
                } else /* rotating at outer angle */ {
                    verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight); // first segment's inner vertex
                    verts.push(omx, omy); // outer miter point
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight); // second segment's outer vertex
                    verts.push(omx, omy); // outer miter point
                }
                indexCount += 2;
            } else if (style.join === $c0878112c399eabe$export$c6a6e344be1302e7.ROUND) {
                if (clockwise) /* arc is outside */ {
                    verts.push(imx, imy);
                    verts.push(x1 + perpx * outerWeight, y1 + perpy * outerWeight);
                    indexCount += $c0878112c399eabe$var$round(x1, y1, x1 + perpx * outerWeight, y1 + perpy * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 4;
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else /* arc is inside */ {
                    verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight);
                    verts.push(omx, omy);
                    indexCount += $c0878112c399eabe$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
            } else {
                verts.push(imx, imy);
                verts.push(omx, omy);
            }
        } else {
            verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight); // first segment's inner vertex
            verts.push(x1 + perpx * outerWeight, y1 + perpy * outerWeight); // first segment's outer vertex
            if (style.join === $c0878112c399eabe$export$c6a6e344be1302e7.BEVEL || pdist / widthSquared > miterLimitSquared) ;
            else if (style.join === $c0878112c399eabe$export$c6a6e344be1302e7.ROUND) {
                if (clockwise) indexCount += $c0878112c399eabe$var$round(x1, y1, x1 + perpx * outerWeight, y1 + perpy * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 2;
                else indexCount += $c0878112c399eabe$var$round(x1, y1, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 2;
            } else {
                if (clockwise) {
                    verts.push(omx, omy); // inner miter point
                    verts.push(omx, omy); // inner miter point
                } else {
                    verts.push(imx, imy); // outer miter point
                    verts.push(imx, imy); // outer miter point
                }
                indexCount += 2;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight); // second segment's inner vertex
            verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight); // second segment's outer vertex
            indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2];
    y0 = points[(length - 2) * 2 + 1];
    x1 = points[(length - 1) * 2];
    y1 = points[(length - 1) * 2 + 1];
    perpx = -(y0 - y1);
    perpy = x0 - x1;
    dist = Math.sqrt(perpx * perpx + perpy * perpy);
    perpx /= dist;
    perpy /= dist;
    perpx *= width;
    perpy *= width;
    verts.push(x1 - perpx * innerWeight, y1 - perpy * innerWeight);
    verts.push(x1 + perpx * outerWeight, y1 + perpy * outerWeight);
    if (!closedShape) {
        if (style.cap === $c0878112c399eabe$export$b113e22c48c75d2e.ROUND) indexCount += $c0878112c399eabe$var$round(x1 - perpx * (innerWeight - outerWeight) * 0.5, y1 - perpy * (innerWeight - outerWeight) * 0.5, x1 - perpx * innerWeight, y1 - perpy * innerWeight, x1 + perpx * outerWeight, y1 + perpy * outerWeight, verts, false) + 2;
        else if (style.cap === $c0878112c399eabe$export$b113e22c48c75d2e.SQUARE) indexCount += $c0878112c399eabe$var$square(x1, y1, perpx, perpy, innerWeight, outerWeight, false, verts);
    }
    var indices = graphicsGeometry.indices;
    var eps2 = $c0878112c399eabe$export$8331f8d2be429f2c.epsilon * $c0878112c399eabe$export$8331f8d2be429f2c.epsilon;
    // indices.push(indexStart);
    for(var i = indexStart; i < indexCount + indexStart - 2; ++i){
        x0 = verts[i * 2];
        y0 = verts[i * 2 + 1];
        x1 = verts[(i + 1) * 2];
        y1 = verts[(i + 1) * 2 + 1];
        x2 = verts[(i + 2) * 2];
        y2 = verts[(i + 2) * 2 + 1];
        /* Skip zero area triangles */ if (Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) continue;
        indices.push(i, i + 1, i + 2);
    }
}
/**
 * Builds a line to draw using the gl.drawArrays(gl.LINES) method
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.GraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {PIXI.GraphicsGeometry} graphicsGeometry - Geometry where to append output
 */ function $c0878112c399eabe$var$buildNativeLine(graphicsData, graphicsGeometry) {
    var i = 0;
    var shape = graphicsData.shape;
    var points = graphicsData.points || shape.points;
    var closedShape = shape.type !== (0, $6qzqq.SHAPES).POLY || shape.closeStroke;
    if (points.length === 0) return;
    var verts = graphicsGeometry.points;
    var indices = graphicsGeometry.indices;
    var length = points.length / 2;
    var startIndex = verts.length / 2;
    var currentIndex = startIndex;
    verts.push(points[0], points[1]);
    for(i = 1; i < length; i++){
        verts.push(points[i * 2], points[i * 2 + 1]);
        indices.push(currentIndex, currentIndex + 1);
        currentIndex++;
    }
    if (closedShape) indices.push(currentIndex, startIndex);
}
/**
 * Builds a line to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.GraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {PIXI.GraphicsGeometry} graphicsGeometry - Geometry where to append output
 */ function $c0878112c399eabe$var$buildLine(graphicsData, graphicsGeometry) {
    if (graphicsData.lineStyle.native) $c0878112c399eabe$var$buildNativeLine(graphicsData, graphicsGeometry);
    else $c0878112c399eabe$var$buildNonNativeLine(graphicsData, graphicsGeometry);
}
/**
 * Utilities for arc curves
 * @class
 * @private
 */ var $c0878112c399eabe$var$ArcUtils = /** @class */ function() {
    function ArcUtils() {}
    /**
     * The arcTo() method creates an arc/curve between two tangents on the canvas.
     *
     * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
     *
     * @private
     * @param {number} x1 - The x-coordinate of the beginning of the arc
     * @param {number} y1 - The y-coordinate of the beginning of the arc
     * @param {number} x2 - The x-coordinate of the end of the arc
     * @param {number} y2 - The y-coordinate of the end of the arc
     * @param {number} radius - The radius of the arc
     * @return {object} If the arc length is valid, return center of circle, radius and other info otherwise `null`.
     */ ArcUtils.curveTo = function(x1, y1, x2, y2, radius, points) {
        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];
        var a1 = fromY - y1;
        var b1 = fromX - x1;
        var a2 = y2 - y1;
        var b2 = x2 - x1;
        var mm = Math.abs(a1 * b2 - b1 * a2);
        if (mm < 1.0e-8 || radius === 0) {
            if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) points.push(x1, y1);
            return null;
        }
        var dd = a1 * a1 + b1 * b1;
        var cc = a2 * a2 + b2 * b2;
        var tt = a1 * a2 + b1 * b2;
        var k1 = radius * Math.sqrt(dd) / mm;
        var k2 = radius * Math.sqrt(cc) / mm;
        var j1 = k1 * tt / dd;
        var j2 = k2 * tt / cc;
        var cx = k1 * b2 + k2 * b1;
        var cy = k1 * a2 + k2 * a1;
        var px = b1 * (k2 + j1);
        var py = a1 * (k2 + j1);
        var qx = b2 * (k1 + j2);
        var qy = a2 * (k1 + j2);
        var startAngle = Math.atan2(py - cy, px - cx);
        var endAngle = Math.atan2(qy - cy, qx - cx);
        return {
            cx: cx + x1,
            cy: cy + y1,
            radius: radius,
            startAngle: startAngle,
            endAngle: endAngle,
            anticlockwise: b1 * a2 > b2 * a1
        };
    };
    /* eslint-disable max-len */ /**
     * The arc method creates an arc/curve (used to create circles, or parts of circles).
     *
     * @private
     * @param {number} startX - Start x location of arc
     * @param {number} startY - Start y location of arc
     * @param {number} cx - The x-coordinate of the center of the circle
     * @param {number} cy - The y-coordinate of the center of the circle
     * @param {number} radius - The radius of the circle
     * @param {number} startAngle - The starting angle, in radians (0 is at the 3 o'clock position
     *  of the arc's circle)
     * @param {number} endAngle - The ending angle, in radians
     * @param {boolean} anticlockwise - Specifies whether the drawing should be
     *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
     *  indicates counter-clockwise.
     * @param {number[]} points - Collection of points to add to
     */ ArcUtils.arc = function(_startX, _startY, cx, cy, radius, startAngle, endAngle, _anticlockwise, points) {
        var sweep = endAngle - startAngle;
        var n = $c0878112c399eabe$export$8331f8d2be429f2c._segmentsCount(Math.abs(sweep) * radius, Math.ceil(Math.abs(sweep) / (0, $6qzqq.PI_2)) * 40);
        var theta = sweep / (n * 2);
        var theta2 = theta * 2;
        var cTheta = Math.cos(theta);
        var sTheta = Math.sin(theta);
        var segMinus = n - 1;
        var remainder = segMinus % 1 / segMinus;
        for(var i = 0; i <= segMinus; ++i){
            var real = i + remainder * i;
            var angle = theta + startAngle + theta2 * real;
            var c = Math.cos(angle);
            var s = -Math.sin(angle);
            points.push((cTheta * c + sTheta * s) * radius + cx, (cTheta * -s + sTheta * c) * radius + cy);
        }
    };
    return ArcUtils;
}();
/**
 * Utilities for bezier curves
 * @class
 * @private
 */ var $c0878112c399eabe$var$BezierUtils = /** @class */ function() {
    function BezierUtils() {}
    /**
     * Calculate length of bezier curve.
     * Analytical solution is impossible, since it involves an integral that does not integrate in general.
     * Therefore numerical solution is used.
     *
     * @private
     * @param {number} fromX - Starting point x
     * @param {number} fromY - Starting point y
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} cpX2 - Second Control point x
     * @param {number} cpY2 - Second Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @return {number} Length of bezier curve
     */ BezierUtils.curveLength = function(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY) {
        var n = 10;
        var result = 0.0;
        var t = 0.0;
        var t2 = 0.0;
        var t3 = 0.0;
        var nt = 0.0;
        var nt2 = 0.0;
        var nt3 = 0.0;
        var x = 0.0;
        var y = 0.0;
        var dx = 0.0;
        var dy = 0.0;
        var prevX = fromX;
        var prevY = fromY;
        for(var i = 1; i <= n; ++i){
            t = i / n;
            t2 = t * t;
            t3 = t2 * t;
            nt = 1.0 - t;
            nt2 = nt * nt;
            nt3 = nt2 * nt;
            x = nt3 * fromX + 3.0 * nt2 * t * cpX + 3.0 * nt * t2 * cpX2 + t3 * toX;
            y = nt3 * fromY + 3.0 * nt2 * t * cpY + 3 * nt * t2 * cpY2 + t3 * toY;
            dx = prevX - x;
            dy = prevY - y;
            prevX = x;
            prevY = y;
            result += Math.sqrt(dx * dx + dy * dy);
        }
        return result;
    };
    /**
     * Calculate the points for a bezier curve and then draws it.
     *
     * Ignored from docs since it is not directly exposed.
     *
     * @ignore
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} cpX2 - Second Control point x
     * @param {number} cpY2 - Second Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @param {number[]} points - Path array to push points into
     */ BezierUtils.curveTo = function(cpX, cpY, cpX2, cpY2, toX, toY, points) {
        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];
        points.length -= 2;
        var n = $c0878112c399eabe$export$8331f8d2be429f2c._segmentsCount(BezierUtils.curveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY));
        var dt = 0;
        var dt2 = 0;
        var dt3 = 0;
        var t2 = 0;
        var t3 = 0;
        points.push(fromX, fromY);
        for(var i = 1, j = 0; i <= n; ++i){
            j = i / n;
            dt = 1 - j;
            dt2 = dt * dt;
            dt3 = dt2 * dt;
            t2 = j * j;
            t3 = t2 * j;
            points.push(dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX, dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
        }
    };
    return BezierUtils;
}();
/**
 * Utilities for quadratic curves
 * @class
 * @private
 */ var $c0878112c399eabe$var$QuadraticUtils = /** @class */ function() {
    function QuadraticUtils() {}
    /**
     * Calculate length of quadratic curve
     * @see {@link http://www.malczak.linuxpl.com/blog/quadratic-bezier-curve-length/}
     * for the detailed explanation of math behind this.
     *
     * @private
     * @param {number} fromX - x-coordinate of curve start point
     * @param {number} fromY - y-coordinate of curve start point
     * @param {number} cpX - x-coordinate of curve control point
     * @param {number} cpY - y-coordinate of curve control point
     * @param {number} toX - x-coordinate of curve end point
     * @param {number} toY - y-coordinate of curve end point
     * @return {number} Length of quadratic curve
     */ QuadraticUtils.curveLength = function(fromX, fromY, cpX, cpY, toX, toY) {
        var ax = fromX - 2.0 * cpX + toX;
        var ay = fromY - 2.0 * cpY + toY;
        var bx = 2.0 * cpX - 2.0 * fromX;
        var by = 2.0 * cpY - 2.0 * fromY;
        var a = 4.0 * (ax * ax + ay * ay);
        var b = 4.0 * (ax * bx + ay * by);
        var c = bx * bx + by * by;
        var s = 2.0 * Math.sqrt(a + b + c);
        var a2 = Math.sqrt(a);
        var a32 = 2.0 * a * a2;
        var c2 = 2.0 * Math.sqrt(c);
        var ba = b / a2;
        return (a32 * s + a2 * b * (s - c2) + (4.0 * c * a - b * b) * Math.log((2.0 * a2 + ba + s) / (ba + c2))) / (4.0 * a32);
    };
    /**
     * Calculate the points for a quadratic bezier curve and then draws it.
     * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
     *
     * @private
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @param {number[]} points - Points to add segments to.
     */ QuadraticUtils.curveTo = function(cpX, cpY, toX, toY, points) {
        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];
        var n = $c0878112c399eabe$export$8331f8d2be429f2c._segmentsCount(QuadraticUtils.curveLength(fromX, fromY, cpX, cpY, toX, toY));
        var xa = 0;
        var ya = 0;
        for(var i = 1; i <= n; ++i){
            var j = i / n;
            xa = fromX + (cpX - fromX) * j;
            ya = fromY + (cpY - fromY) * j;
            points.push(xa + (cpX + (toX - cpX) * j - xa) * j, ya + (cpY + (toY - cpY) * j - ya) * j);
        }
    };
    return QuadraticUtils;
}();
/**
 * A structure to hold interim batch objects for Graphics.
 * @class
 * @memberof PIXI.graphicsUtils
 */ var $c0878112c399eabe$var$BatchPart = /** @class */ function() {
    function BatchPart() {
        this.reset();
    }
    /**
     * Begin batch part
     *
     * @param {PIXI.FillStyle | PIXI.LineStyle} style
     * @param {number} startIndex
     * @param {number} attribStart
     */ BatchPart.prototype.begin = function(style, startIndex, attribStart) {
        this.reset();
        this.style = style;
        this.start = startIndex;
        this.attribStart = attribStart;
    };
    /**
     * End batch part
     *
     * @param {number} endIndex
     * @param {number} endAttrib
     */ BatchPart.prototype.end = function(endIndex, endAttrib) {
        this.attribSize = endAttrib - this.attribStart;
        this.size = endIndex - this.start;
    };
    BatchPart.prototype.reset = function() {
        this.style = null;
        this.size = 0;
        this.start = 0;
        this.attribStart = 0;
        this.attribSize = 0;
    };
    return BatchPart;
}();
/**
 * Generalized convenience utilities for Graphics.
 *
 * @namespace graphicsUtils
 * @memberof PIXI
 */ var $c0878112c399eabe$var$_a;
/**
 * Map of fill commands for each shape type.
 *
 * @memberof PIXI.graphicsUtils
 * @member {Object} FILL_COMMANDS
 */ var $c0878112c399eabe$var$FILL_COMMANDS = ($c0878112c399eabe$var$_a = {}, $c0878112c399eabe$var$_a[(0, $6qzqq.SHAPES).POLY] = $c0878112c399eabe$var$buildPoly, $c0878112c399eabe$var$_a[(0, $6qzqq.SHAPES).CIRC] = $c0878112c399eabe$var$buildCircle, $c0878112c399eabe$var$_a[(0, $6qzqq.SHAPES).ELIP] = $c0878112c399eabe$var$buildCircle, $c0878112c399eabe$var$_a[(0, $6qzqq.SHAPES).RECT] = $c0878112c399eabe$var$buildRectangle, $c0878112c399eabe$var$_a[(0, $6qzqq.SHAPES).RREC] = $c0878112c399eabe$var$buildRoundedRectangle, $c0878112c399eabe$var$_a);
/**
 * Batch pool, stores unused batches for preventing allocations.
 *
 * @memberof PIXI.graphicsUtils
 * @member {Array<PIXI.graphicsUtils.BatchPart>} BATCH_POOL
 */ var $c0878112c399eabe$var$BATCH_POOL = [];
/**
 * Draw call pool, stores unused draw calls for preventing allocations.
 *
 * @memberof PIXI.graphicsUtils
 * @member {Array<PIXI.BatchDrawCall>} DRAW_CALL_POOL
 */ var $c0878112c399eabe$var$DRAW_CALL_POOL = [];
/**
 * Determine if polygon is clockwise or counterclockwise.
 * @see {@link https://stackoverflow.com/questions/1165647}
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {Polygon} polygon
 * @return {boolean}
 */ function $c0878112c399eabe$var$isPolygonClockwise(polygon) {
    var points = polygon.points;
    var sum = 0;
    for(var i = 0; i < points.length - 2; i += 2)sum += (points[i + 2] - points[i]) * (points[i + 3] + points[i + 1]);
    return sum > 0;
}
/**
 * A class to contain data useful for Graphics objects
 *
 * @class
 * @memberof PIXI
 */ var $c0878112c399eabe$export$94accce0eb494446 = /** @class */ function() {
    /**
     *
     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
     * @param {PIXI.FillStyle} [fillStyle] - the width of the line to draw
     * @param {PIXI.LineStyle} [lineStyle] - the color of the line to draw
     * @param {PIXI.Matrix} [matrix] - Transform matrix
     */ function GraphicsData(shape, fillStyle, lineStyle, matrix) {
        if (fillStyle === void 0) fillStyle = null;
        if (lineStyle === void 0) lineStyle = null;
        if (matrix === void 0) matrix = null;
        /** The collection of points. */ this.points = [];
        /**
         * The collection of holes.
         *
         * @member {PIXI.GraphicsData[]}
         */ this.holes = [];
        /**
         * The shape object to draw.
         * @member {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle}
         */ this.shape = shape;
        /**
         * The style of the line.
         * @member {PIXI.LineStyle}
         */ this.lineStyle = lineStyle;
        /**
         * The style of the fill.
         * @member {PIXI.FillStyle}
         */ this.fillStyle = fillStyle;
        /**
         * The transform matrix.
         * @member {PIXI.Matrix}
         */ this.matrix = matrix;
        /**
         * The type of the shape, see the Const.Shapes file for all the existing types,
         * @member {number}
         */ this.type = shape.type;
    }
    /**
     * Creates a new GraphicsData object with the same values as this one.
     *
     * @return {PIXI.GraphicsData} Cloned GraphicsData object
     */ GraphicsData.prototype.clone = function() {
        return new GraphicsData(this.shape, this.fillStyle, this.lineStyle, this.matrix);
    };
    /**
     * Destroys the Graphics data.
     *
     */ GraphicsData.prototype.destroy = function() {
        this.shape = null;
        this.holes.length = 0;
        this.holes = null;
        this.points.length = 0;
        this.points = null;
        this.lineStyle = null;
        this.fillStyle = null;
    };
    return GraphicsData;
}();
var $c0878112c399eabe$var$tmpPoint = new (0, $6qzqq.Point)();
var $c0878112c399eabe$var$tmpBounds = new (0, $8t5Gy.Bounds)();
/**
 * The Graphics class contains methods used to draw primitive shapes such as lines, circles and
 * rectangles to the display, and to color and fill them.
 *
 * GraphicsGeometry is designed to not be continually updating the geometry since it's expensive
 * to re-tesselate using **earcut**. Consider using {@link PIXI.Mesh} for this use-case, it's much faster.
 *
 * @class
 * @extends PIXI.BatchGeometry
 * @memberof PIXI
 */ var $c0878112c399eabe$export$c707987b44ce3a12 = /** @class */ function(_super) {
    $c0878112c399eabe$var$__extends(GraphicsGeometry, _super);
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    function GraphicsGeometry() {
        var _this = _super.call(this) || this;
        /**
         * Minimal distance between points that are considered different.
         * Affects line tesselation.
         */ _this.closePointEps = 1e-4;
        /** Padding to add to the bounds. */ _this.boundsPadding = 0;
        _this.uvsFloat32 = null;
        _this.indicesUint16 = null;
        _this.batchable = false;
        /** An array of points to draw, 2 numbers per point */ _this.points = [];
        /** The collection of colors */ _this.colors = [];
        /** The UVs collection */ _this.uvs = [];
        /** The indices of the vertices */ _this.indices = [];
        /** Reference to the texture IDs. */ _this.textureIds = [];
        /**
         * The collection of drawn shapes.
         *
         * @member {PIXI.GraphicsData[]}
         */ _this.graphicsData = [];
        /**
         * List of current draw calls drived from the batches.
         *
         * @member {PIXI.BatchDrawCall[]}
         */ _this.drawCalls = [];
        /** Batches need to regenerated if the geometry is updated. */ _this.batchDirty = -1;
        /**
         * Intermediate abstract format sent to batch system.
         * Can be converted to drawCalls or to batchable objects.
         *
         * @member {PIXI.graphicsUtils.BatchPart[]}
         */ _this.batches = [];
        /** Used to detect if the graphics object has changed. */ _this.dirty = 0;
        /** Used to check if the cache is dirty. */ _this.cacheDirty = -1;
        /** Used to detect if we cleared the graphicsData. */ _this.clearDirty = 0;
        /** Index of the last batched shape in the stack of calls. */ _this.shapeIndex = 0;
        /**
         * Cached bounds.
         *
         * @member {PIXI.Bounds}
         */ _this._bounds = new (0, $8t5Gy.Bounds)();
        /** The bounds dirty flag. */ _this.boundsDirty = -1;
        return _this;
    }
    Object.defineProperty(GraphicsGeometry.prototype, "bounds", {
        /**
         * Get the current bounds of the graphic geometry.
         *
         * @member {PIXI.Bounds}
         * @readonly
         */ get: function() {
            if (this.boundsDirty !== this.dirty) {
                this.boundsDirty = this.dirty;
                this.calculateBounds();
            }
            return this._bounds;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call if you changed graphicsData manually.
     * Empties all batch buffers.
     */ GraphicsGeometry.prototype.invalidate = function() {
        this.boundsDirty = -1;
        this.dirty++;
        this.batchDirty++;
        this.shapeIndex = 0;
        this.points.length = 0;
        this.colors.length = 0;
        this.uvs.length = 0;
        this.indices.length = 0;
        this.textureIds.length = 0;
        for(var i = 0; i < this.drawCalls.length; i++){
            this.drawCalls[i].texArray.clear();
            $c0878112c399eabe$var$DRAW_CALL_POOL.push(this.drawCalls[i]);
        }
        this.drawCalls.length = 0;
        for(var i = 0; i < this.batches.length; i++){
            var batchPart = this.batches[i];
            batchPart.reset();
            $c0878112c399eabe$var$BATCH_POOL.push(batchPart);
        }
        this.batches.length = 0;
    };
    /**
     * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
     *
     * @return {PIXI.GraphicsGeometry} This GraphicsGeometry object. Good for chaining method calls
     */ GraphicsGeometry.prototype.clear = function() {
        if (this.graphicsData.length > 0) {
            this.invalidate();
            this.clearDirty++;
            this.graphicsData.length = 0;
        }
        return this;
    };
    /**
     * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
     *
     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
     * @param {PIXI.FillStyle} fillStyle - Defines style of the fill.
     * @param {PIXI.LineStyle} lineStyle - Defines style of the lines.
     * @param {PIXI.Matrix} matrix - Transform applied to the points of the shape.
     * @return {PIXI.GraphicsGeometry} Returns geometry for chaining.
     */ GraphicsGeometry.prototype.drawShape = function(shape, fillStyle, lineStyle, matrix) {
        if (fillStyle === void 0) fillStyle = null;
        if (lineStyle === void 0) lineStyle = null;
        if (matrix === void 0) matrix = null;
        var data = new $c0878112c399eabe$export$94accce0eb494446(shape, fillStyle, lineStyle, matrix);
        this.graphicsData.push(data);
        this.dirty++;
        return this;
    };
    /**
     * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
     *
     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
     * @param {PIXI.Matrix} matrix - Transform applied to the points of the shape.
     * @return {PIXI.GraphicsGeometry} Returns geometry for chaining.
     */ GraphicsGeometry.prototype.drawHole = function(shape, matrix) {
        if (matrix === void 0) matrix = null;
        if (!this.graphicsData.length) return null;
        var data = new $c0878112c399eabe$export$94accce0eb494446(shape, null, null, matrix);
        var lastShape = this.graphicsData[this.graphicsData.length - 1];
        data.lineStyle = lastShape.lineStyle;
        lastShape.holes.push(data);
        this.dirty++;
        return this;
    };
    /**
     * Destroys the GraphicsGeometry object.
     *
     */ GraphicsGeometry.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        // destroy each of the GraphicsData objects
        for(var i = 0; i < this.graphicsData.length; ++i)this.graphicsData[i].destroy();
        this.points.length = 0;
        this.points = null;
        this.colors.length = 0;
        this.colors = null;
        this.uvs.length = 0;
        this.uvs = null;
        this.indices.length = 0;
        this.indices = null;
        this.indexBuffer.destroy();
        this.indexBuffer = null;
        this.graphicsData.length = 0;
        this.graphicsData = null;
        this.drawCalls.length = 0;
        this.drawCalls = null;
        this.batches.length = 0;
        this.batches = null;
        this._bounds = null;
    };
    /**
     * Check to see if a point is contained within this geometry.
     *
     * @param {PIXI.IPointData} point - Point to check if it's contained.
     * @return {Boolean} `true` if the point is contained within geometry.
     */ GraphicsGeometry.prototype.containsPoint = function(point) {
        var graphicsData = this.graphicsData;
        for(var i = 0; i < graphicsData.length; ++i){
            var data = graphicsData[i];
            if (!data.fillStyle.visible) continue;
            // only deal with fills..
            if (data.shape) {
                if (data.matrix) data.matrix.applyInverse(point, $c0878112c399eabe$var$tmpPoint);
                else $c0878112c399eabe$var$tmpPoint.copyFrom(point);
                if (data.shape.contains($c0878112c399eabe$var$tmpPoint.x, $c0878112c399eabe$var$tmpPoint.y)) {
                    var hitHole = false;
                    if (data.holes) for(var i_1 = 0; i_1 < data.holes.length; i_1++){
                        var hole = data.holes[i_1];
                        if (hole.shape.contains($c0878112c399eabe$var$tmpPoint.x, $c0878112c399eabe$var$tmpPoint.y)) {
                            hitHole = true;
                            break;
                        }
                    }
                    if (!hitHole) return true;
                }
            }
        }
        return false;
    };
    /**
     * Generates intermediate batch data. Either gets converted to drawCalls
     * or used to convert to batch objects directly by the Graphics object.
     *
     * @param {boolean} [allow32Indices] - Allow using 32-bit indices for preventing artifacts when more that 65535 vertices
     */ GraphicsGeometry.prototype.updateBatches = function(allow32Indices) {
        if (!this.graphicsData.length) {
            this.batchable = true;
            return;
        }
        if (!this.validateBatching()) return;
        this.cacheDirty = this.dirty;
        var uvs = this.uvs;
        var graphicsData = this.graphicsData;
        var batchPart = null;
        var currentStyle = null;
        if (this.batches.length > 0) {
            batchPart = this.batches[this.batches.length - 1];
            currentStyle = batchPart.style;
        }
        for(var i = this.shapeIndex; i < graphicsData.length; i++){
            this.shapeIndex++;
            var data = graphicsData[i];
            var fillStyle = data.fillStyle;
            var lineStyle = data.lineStyle;
            var command = $c0878112c399eabe$var$FILL_COMMANDS[data.type];
            // build out the shapes points..
            command.build(data);
            if (data.matrix) this.transformPoints(data.points, data.matrix);
            for(var j = 0; j < 2; j++){
                var style = j === 0 ? fillStyle : lineStyle;
                if (!style.visible) continue;
                var nextTexture = style.texture.baseTexture;
                var index_1 = this.indices.length;
                var attribIndex = this.points.length / 2;
                nextTexture.wrapMode = (0, $P8XPi.WRAP_MODES).REPEAT;
                if (j === 0) this.processFill(data);
                else this.processLine(data);
                var size = this.points.length / 2 - attribIndex;
                if (size === 0) continue;
                // close batch if style is different
                if (batchPart && !this._compareStyles(currentStyle, style)) {
                    batchPart.end(index_1, attribIndex);
                    batchPart = null;
                }
                // spawn new batch if its first batch or previous was closed
                if (!batchPart) {
                    batchPart = $c0878112c399eabe$var$BATCH_POOL.pop() || new $c0878112c399eabe$var$BatchPart();
                    batchPart.begin(style, index_1, attribIndex);
                    this.batches.push(batchPart);
                    currentStyle = style;
                }
                this.addUvs(this.points, uvs, style.texture, attribIndex, size, style.matrix);
            }
        }
        var index = this.indices.length;
        var attrib = this.points.length / 2;
        if (batchPart) batchPart.end(index, attrib);
        if (this.batches.length === 0) {
            // there are no visible styles in GraphicsData
            // its possible that someone wants Graphics just for the bounds
            this.batchable = true;
            return;
        }
        // prevent allocation when length is same as buffer
        if (this.indicesUint16 && this.indices.length === this.indicesUint16.length) this.indicesUint16.set(this.indices);
        else {
            var need32 = attrib > 0xffff && allow32Indices;
            this.indicesUint16 = need32 ? new Uint32Array(this.indices) : new Uint16Array(this.indices);
        }
        // TODO make this a const..
        this.batchable = this.isBatchable();
        if (this.batchable) this.packBatches();
        else this.buildDrawCalls();
    };
    /**
     * Affinity check
     *
     * @param {PIXI.FillStyle | PIXI.LineStyle} styleA
     * @param {PIXI.FillStyle | PIXI.LineStyle} styleB
     */ GraphicsGeometry.prototype._compareStyles = function(styleA, styleB) {
        if (!styleA || !styleB) return false;
        if (styleA.texture.baseTexture !== styleB.texture.baseTexture) return false;
        if (styleA.color + styleA.alpha !== styleB.color + styleB.alpha) return false;
        if (!!styleA.native !== !!styleB.native) return false;
        return true;
    };
    /**
     * Test geometry for batching process.
     *
     * @protected
     */ GraphicsGeometry.prototype.validateBatching = function() {
        if (this.dirty === this.cacheDirty || !this.graphicsData.length) return false;
        for(var i = 0, l = this.graphicsData.length; i < l; i++){
            var data = this.graphicsData[i];
            var fill = data.fillStyle;
            var line = data.lineStyle;
            if (fill && !fill.texture.baseTexture.valid) return false;
            if (line && !line.texture.baseTexture.valid) return false;
        }
        return true;
    };
    /**
     * Offset the indices so that it works with the batcher.
     *
     * @protected
     */ GraphicsGeometry.prototype.packBatches = function() {
        this.batchDirty++;
        this.uvsFloat32 = new Float32Array(this.uvs);
        var batches = this.batches;
        for(var i = 0, l = batches.length; i < l; i++){
            var batch = batches[i];
            for(var j = 0; j < batch.size; j++){
                var index = batch.start + j;
                this.indicesUint16[index] = this.indicesUint16[index] - batch.attribStart;
            }
        }
    };
    /**
     * Checks to see if this graphics geometry can be batched.
     * Currently it needs to be small enough and not contain any native lines.
     *
     * @protected
     */ GraphicsGeometry.prototype.isBatchable = function() {
        // prevent heavy mesh batching
        if (this.points.length > 131070) return false;
        var batches = this.batches;
        for(var i = 0; i < batches.length; i++){
            if (batches[i].style.native) return false;
        }
        return this.points.length < GraphicsGeometry.BATCHABLE_SIZE * 2;
    };
    /**
     * Converts intermediate batches data to drawCalls.
     *
     * @protected
     */ GraphicsGeometry.prototype.buildDrawCalls = function() {
        var TICK = ++(0, $klOfb.BaseTexture)._globalBatch;
        for(var i = 0; i < this.drawCalls.length; i++){
            this.drawCalls[i].texArray.clear();
            $c0878112c399eabe$var$DRAW_CALL_POOL.push(this.drawCalls[i]);
        }
        this.drawCalls.length = 0;
        var colors = this.colors;
        var textureIds = this.textureIds;
        var currentGroup = $c0878112c399eabe$var$DRAW_CALL_POOL.pop();
        if (!currentGroup) {
            currentGroup = new (0, $klOfb.BatchDrawCall)();
            currentGroup.texArray = new (0, $klOfb.BatchTextureArray)();
        }
        currentGroup.texArray.count = 0;
        currentGroup.start = 0;
        currentGroup.size = 0;
        currentGroup.type = (0, $P8XPi.DRAW_MODES).TRIANGLES;
        var textureCount = 0;
        var currentTexture = null;
        var textureId = 0;
        var native = false;
        var drawMode = (0, $P8XPi.DRAW_MODES).TRIANGLES;
        var index = 0;
        this.drawCalls.push(currentGroup);
        // TODO - this can be simplified
        for(var i = 0; i < this.batches.length; i++){
            var data = this.batches[i];
            // TODO add some full on MAX_TEXTURE CODE..
            var MAX_TEXTURES = 8;
            // Forced cast for checking `native` without errors
            var style = data.style;
            var nextTexture = style.texture.baseTexture;
            if (native !== !!style.native) {
                native = !!style.native;
                drawMode = native ? (0, $P8XPi.DRAW_MODES).LINES : (0, $P8XPi.DRAW_MODES).TRIANGLES;
                // force the batch to break!
                currentTexture = null;
                textureCount = MAX_TEXTURES;
                TICK++;
            }
            if (currentTexture !== nextTexture) {
                currentTexture = nextTexture;
                if (nextTexture._batchEnabled !== TICK) {
                    if (textureCount === MAX_TEXTURES) {
                        TICK++;
                        textureCount = 0;
                        if (currentGroup.size > 0) {
                            currentGroup = $c0878112c399eabe$var$DRAW_CALL_POOL.pop();
                            if (!currentGroup) {
                                currentGroup = new (0, $klOfb.BatchDrawCall)();
                                currentGroup.texArray = new (0, $klOfb.BatchTextureArray)();
                            }
                            this.drawCalls.push(currentGroup);
                        }
                        currentGroup.start = index;
                        currentGroup.size = 0;
                        currentGroup.texArray.count = 0;
                        currentGroup.type = drawMode;
                    }
                    // TODO add this to the render part..
                    // Hack! Because texture has protected `touched`
                    nextTexture.touched = 1; // touch;
                    nextTexture._batchEnabled = TICK;
                    nextTexture._batchLocation = textureCount;
                    nextTexture.wrapMode = (0, $P8XPi.WRAP_MODES).REPEAT;
                    currentGroup.texArray.elements[currentGroup.texArray.count++] = nextTexture;
                    textureCount++;
                }
            }
            currentGroup.size += data.size;
            index += data.size;
            textureId = nextTexture._batchLocation;
            this.addColors(colors, style.color, style.alpha, data.attribSize, data.attribStart);
            this.addTextureIds(textureIds, textureId, data.attribSize, data.attribStart);
        }
        (0, $klOfb.BaseTexture)._globalBatch = TICK;
        // upload..
        // merge for now!
        this.packAttributes();
    };
    /**
     * Packs attributes to single buffer.
     *
     * @protected
     */ GraphicsGeometry.prototype.packAttributes = function() {
        var verts = this.points;
        var uvs = this.uvs;
        var colors = this.colors;
        var textureIds = this.textureIds;
        // verts are 2 positions.. so we * by 3 as there are 6 properties.. then 4 cos its bytes
        var glPoints = new ArrayBuffer(verts.length * 12);
        var f32 = new Float32Array(glPoints);
        var u32 = new Uint32Array(glPoints);
        var p = 0;
        for(var i = 0; i < verts.length / 2; i++){
            f32[p++] = verts[i * 2];
            f32[p++] = verts[i * 2 + 1];
            f32[p++] = uvs[i * 2];
            f32[p++] = uvs[i * 2 + 1];
            u32[p++] = colors[i];
            f32[p++] = textureIds[i];
        }
        this._buffer.update(glPoints);
        this._indexBuffer.update(this.indicesUint16);
    };
    /**
     * Process fill part of Graphics.
     *
     * @param {PIXI.GraphicsData} data
     * @protected
     */ GraphicsGeometry.prototype.processFill = function(data) {
        if (data.holes.length) {
            this.processHoles(data.holes);
            $c0878112c399eabe$var$buildPoly.triangulate(data, this);
        } else {
            var command = $c0878112c399eabe$var$FILL_COMMANDS[data.type];
            command.triangulate(data, this);
        }
    };
    /**
     * Process line part of Graphics.
     *
     * @param {PIXI.GraphicsData} data
     * @protected
     */ GraphicsGeometry.prototype.processLine = function(data) {
        $c0878112c399eabe$var$buildLine(data, this);
        for(var i = 0; i < data.holes.length; i++)$c0878112c399eabe$var$buildLine(data.holes[i], this);
    };
    /**
     * Process the holes data.
     *
     * @param {PIXI.GraphicsData[]} holes - Holes to render
     * @protected
     */ GraphicsGeometry.prototype.processHoles = function(holes) {
        for(var i = 0; i < holes.length; i++){
            var hole = holes[i];
            var command = $c0878112c399eabe$var$FILL_COMMANDS[hole.type];
            command.build(hole);
            if (hole.matrix) this.transformPoints(hole.points, hole.matrix);
        }
    };
    /**
     * Update the local bounds of the object. Expensive to use performance-wise.
     *
     * @protected
     */ GraphicsGeometry.prototype.calculateBounds = function() {
        var bounds = this._bounds;
        var sequenceBounds = $c0878112c399eabe$var$tmpBounds;
        var curMatrix = (0, $6qzqq.Matrix).IDENTITY;
        this._bounds.clear();
        sequenceBounds.clear();
        for(var i = 0; i < this.graphicsData.length; i++){
            var data = this.graphicsData[i];
            var shape = data.shape;
            var type = data.type;
            var lineStyle = data.lineStyle;
            var nextMatrix = data.matrix || (0, $6qzqq.Matrix).IDENTITY;
            var lineWidth = 0.0;
            if (lineStyle && lineStyle.visible) {
                var alignment = lineStyle.alignment;
                lineWidth = lineStyle.width;
                if (type === (0, $6qzqq.SHAPES).POLY) {
                    if ($c0878112c399eabe$var$isPolygonClockwise(shape)) lineWidth = lineWidth * (1 - alignment);
                    else lineWidth = lineWidth * alignment;
                } else lineWidth = lineWidth * Math.max(0, alignment);
            }
            if (curMatrix !== nextMatrix) {
                if (!sequenceBounds.isEmpty()) {
                    bounds.addBoundsMatrix(sequenceBounds, curMatrix);
                    sequenceBounds.clear();
                }
                curMatrix = nextMatrix;
            }
            if (type === (0, $6qzqq.SHAPES).RECT || type === (0, $6qzqq.SHAPES).RREC) {
                var rect = shape;
                sequenceBounds.addFramePad(rect.x, rect.y, rect.x + rect.width, rect.y + rect.height, lineWidth, lineWidth);
            } else if (type === (0, $6qzqq.SHAPES).CIRC) {
                var circle = shape;
                sequenceBounds.addFramePad(circle.x, circle.y, circle.x, circle.y, circle.radius + lineWidth, circle.radius + lineWidth);
            } else if (type === (0, $6qzqq.SHAPES).ELIP) {
                var ellipse = shape;
                sequenceBounds.addFramePad(ellipse.x, ellipse.y, ellipse.x, ellipse.y, ellipse.width + lineWidth, ellipse.height + lineWidth);
            } else {
                var poly = shape;
                // adding directly to the bounds
                bounds.addVerticesMatrix(curMatrix, poly.points, 0, poly.points.length, lineWidth, lineWidth);
            }
        }
        if (!sequenceBounds.isEmpty()) bounds.addBoundsMatrix(sequenceBounds, curMatrix);
        bounds.pad(this.boundsPadding, this.boundsPadding);
    };
    /**
     * Transform points using matrix.
     *
     * @protected
     * @param {number[]} points - Points to transform
     * @param {PIXI.Matrix} matrix - Transform matrix
     */ GraphicsGeometry.prototype.transformPoints = function(points, matrix) {
        for(var i = 0; i < points.length / 2; i++){
            var x = points[i * 2];
            var y = points[i * 2 + 1];
            points[i * 2] = matrix.a * x + matrix.c * y + matrix.tx;
            points[i * 2 + 1] = matrix.b * x + matrix.d * y + matrix.ty;
        }
    };
    /**
     * Add colors.
     *
     * @protected
     * @param {number[]} colors - List of colors to add to
     * @param {number} color - Color to add
     * @param {number} alpha - Alpha to use
     * @param {number} size - Number of colors to add
     * @param {number} offset
     */ GraphicsGeometry.prototype.addColors = function(colors, color, alpha, size, offset) {
        if (offset === void 0) offset = 0;
        // TODO use the premultiply bits Ivan added
        var rgb = (color >> 16) + (color & 0xff00) + ((color & 0xff) << 16);
        var rgba = (0, $csytw.premultiplyTint)(rgb, alpha);
        colors.length = Math.max(colors.length, offset + size);
        for(var i = 0; i < size; i++)colors[offset + i] = rgba;
    };
    /**
     * Add texture id that the shader/fragment wants to use.
     *
     * @protected
     * @param {number[]} textureIds
     * @param {number} id
     * @param {number} size
     * @param {number} offset
     */ GraphicsGeometry.prototype.addTextureIds = function(textureIds, id, size, offset) {
        if (offset === void 0) offset = 0;
        textureIds.length = Math.max(textureIds.length, offset + size);
        for(var i = 0; i < size; i++)textureIds[offset + i] = id;
    };
    /**
     * Generates the UVs for a shape.
     *
     * @protected
     * @param {number[]} verts - Vertices
     * @param {number[]} uvs - UVs
     * @param {PIXI.Texture} texture - Reference to Texture
     * @param {number} start - Index buffer start index.
     * @param {number} size - The size/length for index buffer.
     * @param {PIXI.Matrix} [matrix] - Optional transform for all points.
     */ GraphicsGeometry.prototype.addUvs = function(verts, uvs, texture, start, size, matrix) {
        if (matrix === void 0) matrix = null;
        var index = 0;
        var uvsStart = uvs.length;
        var frame = texture.frame;
        while(index < size){
            var x = verts[(start + index) * 2];
            var y = verts[(start + index) * 2 + 1];
            if (matrix) {
                var nx = matrix.a * x + matrix.c * y + matrix.tx;
                y = matrix.b * x + matrix.d * y + matrix.ty;
                x = nx;
            }
            index++;
            uvs.push(x / frame.width, y / frame.height);
        }
        var baseTexture = texture.baseTexture;
        if (frame.width < baseTexture.width || frame.height < baseTexture.height) this.adjustUvs(uvs, texture, uvsStart, size);
    };
    /**
     * Modify uvs array according to position of texture region
     * Does not work with rotated or trimmed textures
     *
     * @param {number[]} uvs - array
     * @param {PIXI.Texture} texture - region
     * @param {number} start - starting index for uvs
     * @param {number} size - how many points to adjust
     */ GraphicsGeometry.prototype.adjustUvs = function(uvs, texture, start, size) {
        var baseTexture = texture.baseTexture;
        var eps = 1e-6;
        var finish = start + size * 2;
        var frame = texture.frame;
        var scaleX = frame.width / baseTexture.width;
        var scaleY = frame.height / baseTexture.height;
        var offsetX = frame.x / frame.width;
        var offsetY = frame.y / frame.height;
        var minX = Math.floor(uvs[start] + eps);
        var minY = Math.floor(uvs[start + 1] + eps);
        for(var i = start + 2; i < finish; i += 2){
            minX = Math.min(minX, Math.floor(uvs[i] + eps));
            minY = Math.min(minY, Math.floor(uvs[i + 1] + eps));
        }
        offsetX -= minX;
        offsetY -= minY;
        for(var i = start; i < finish; i += 2){
            uvs[i] = (uvs[i] + offsetX) * scaleX;
            uvs[i + 1] = (uvs[i + 1] + offsetY) * scaleY;
        }
    };
    /**
     * The maximum number of points to consider an object "batchable",
     * able to be batched by the renderer's batch system.
\    */ GraphicsGeometry.BATCHABLE_SIZE = 100;
    return GraphicsGeometry;
}((0, $klOfb.BatchGeometry));
/**
 * Represents the line style for Graphics.
 * @memberof PIXI
 * @class
 * @extends PIXI.FillStyle
 */ var $c0878112c399eabe$export$5d24e00cfde59887 = /** @class */ function(_super) {
    $c0878112c399eabe$var$__extends(LineStyle, _super);
    function LineStyle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** The width (thickness) of any lines drawn. */ _this.width = 0;
        /** The alignment of any lines drawn (0.5 = middle, 1 = outer, 0 = inner). WebGL only. */ _this.alignment = 0.5;
        /** If true the lines will be draw using LINES instead of TRIANGLE_STRIP */ _this.native = false;
        /**
         * Line cap style.
         *
         * @member {PIXI.LINE_CAP}
         * @default PIXI.LINE_CAP.BUTT
         */ _this.cap = $c0878112c399eabe$export$b113e22c48c75d2e.BUTT;
        /**
         * Line join style.
         *
         * @member {PIXI.LINE_JOIN}
         * @default PIXI.LINE_JOIN.MITER
         */ _this.join = $c0878112c399eabe$export$c6a6e344be1302e7.MITER;
        /** Miter limit. */ _this.miterLimit = 10;
        return _this;
    }
    /**
     * Clones the object
     *
     * @return {PIXI.LineStyle}
     */ LineStyle.prototype.clone = function() {
        var obj = new LineStyle();
        obj.color = this.color;
        obj.alpha = this.alpha;
        obj.texture = this.texture;
        obj.matrix = this.matrix;
        obj.visible = this.visible;
        obj.width = this.width;
        obj.alignment = this.alignment;
        obj.native = this.native;
        obj.cap = this.cap;
        obj.join = this.join;
        obj.miterLimit = this.miterLimit;
        return obj;
    };
    /**
     * Reset the line style to default.
     */ LineStyle.prototype.reset = function() {
        _super.prototype.reset.call(this);
        // Override default line style color
        this.color = 0x0;
        this.alignment = 0.5;
        this.width = 0;
        this.native = false;
    };
    return LineStyle;
}($c0878112c399eabe$export$c42b166860ccdbd8);
var $c0878112c399eabe$var$temp = new Float32Array(3);
// a default shaders map used by graphics..
var $c0878112c399eabe$var$DEFAULT_SHADERS = {};
/**
 * The Graphics class is primarily used to render primitive shapes such as lines, circles and
 * rectangles to the display, and to color and fill them.  However, you can also use a Graphics
 * object to build a list of primitives to use as a mask, or as a complex hitArea.
 *
 * Please note that due to legacy naming conventions, the behavior of some functions in this class
 * can be confusing.  Each call to `drawRect()`, `drawPolygon()`, etc. actually stores that primitive
 * in the Geometry class's GraphicsGeometry object for later use in rendering or hit testing - the
 * functions do not directly draw anything to the screen.  Similarly, the `clear()` function doesn't
 * change the screen, it simply resets the list of primitives, which can be useful if you want to
 * rebuild the contents of an existing Graphics object.
 *
 * Once a GraphicsGeometry list is built, you can re-use it in other Geometry objects as
 * an optimization, by passing it into a new Geometry object's constructor.  Because of this
 * ability, it's important to call `destroy()` on Geometry objects once you are done with them, to
 * properly dereference each GraphicsGeometry and prevent memory leaks.
 *
 * @class
 * @extends PIXI.Container
 * @memberof PIXI
 */ var $c0878112c399eabe$export$29d3e417456abdad = /** @class */ function(_super) {
    $c0878112c399eabe$var$__extends(Graphics, _super);
    /**
     * @param {PIXI.GraphicsGeometry} [geometry=null] - Geometry to use, if omitted
     *        will create a new GraphicsGeometry instance.
     */ function Graphics(geometry) {
        if (geometry === void 0) geometry = null;
        var _this = _super.call(this) || this;
        /**
         * Represents the vertex and fragment shaders that processes the geometry and runs on the GPU.
         * Can be shared between multiple Graphics objects.
         */ _this.shader = null;
        /** Renderer plugin for batching */ _this.pluginName = 'batch';
        /**
         * Current path
         *
         * @member {PIXI.Polygon}
         * @readonly
         */ _this.currentPath = null;
        /**
         * A collections of batches! These can be drawn by the renderer batch system.
         *
         * @member {PIXI.IGraphicsBatchElement[]}
         */ _this.batches = [];
        /** Update dirty for limiting calculating tints for batches. */ _this.batchTint = -1;
        /** Update dirty for limiting calculating batches.*/ _this.batchDirty = -1;
        /** Copy of the object vertex data. */ _this.vertexData = null;
        /**
         * Current fill style
         *
         * @member {PIXI.FillStyle}
         */ _this._fillStyle = new $c0878112c399eabe$export$c42b166860ccdbd8();
        /**
         * Current line style
         *
         * @member {PIXI.LineStyle}
         */ _this._lineStyle = new $c0878112c399eabe$export$5d24e00cfde59887();
        /**
         * Current shape transform matrix.
         *
         * @member {PIXI.Matrix}
         */ _this._matrix = null;
        /** Current hole mode is enabled. */ _this._holeMode = false;
        /**
         * Represents the WebGL state the Graphics required to render, excludes shader and geometry. E.g.,
         * blend mode, culling, depth testing, direction of rendering triangles, backface, etc.
         *
         * @member {PIXI.State}
         */ _this.state = (0, $klOfb.State).for2d();
        _this._geometry = geometry || new $c0878112c399eabe$export$c707987b44ce3a12();
        _this._geometry.refCount++;
        /**
         * When cacheAsBitmap is set to true the graphics object will be rendered as if it was a sprite.
         * This is useful if your graphics element does not change often, as it will speed up the rendering
         * of the object in exchange for taking up texture memory. It is also useful if you need the graphics
         * object to be anti-aliased, because it will be rendered using canvas. This is not recommended if
         * you are constantly redrawing the graphics element.
         *
         * @name cacheAsBitmap
         * @member {boolean}
         * @memberof PIXI.Graphics#
         * @default false
         */ _this._transformID = -1;
        // Set default
        _this.tint = 0xFFFFFF;
        _this.blendMode = (0, $P8XPi.BLEND_MODES).NORMAL;
        return _this;
    }
    Object.defineProperty(Graphics.prototype, "geometry", {
        /**
         * Includes vertex positions, face indices, normals, colors, UVs, and
         * custom attributes within buffers, reducing the cost of passing all
         * this data to the GPU. Can be shared between multiple Mesh or Graphics objects.
         *
         * @member {PIXI.GraphicsGeometry}
         * @readonly
         */ get: function() {
            return this._geometry;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Creates a new Graphics object with the same values as this one.
     * Note that only the geometry of the object is cloned, not its transform (position,scale,etc)
     *
     * @return {PIXI.Graphics} A clone of the graphics object
     */ Graphics.prototype.clone = function() {
        this.finishPoly();
        return new Graphics(this._geometry);
    };
    Object.defineProperty(Graphics.prototype, "blendMode", {
        get: function() {
            return this.state.blendMode;
        },
        /**
         * The blend mode to be applied to the graphic shape. Apply a value of
         * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.  Note that, since each
         * primitive in the GraphicsGeometry list is rendered sequentially, modes
         * such as `PIXI.BLEND_MODES.ADD` and `PIXI.BLEND_MODES.MULTIPLY` will
         * be applied per-primitive.
         *
         * @member {number}
         * @default PIXI.BLEND_MODES.NORMAL;
         * @see PIXI.BLEND_MODES
         */ set: function(value) {
            this.state.blendMode = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Graphics.prototype, "tint", {
        /**
         * The tint applied to each graphic shape. This is a hex value. A value of
         * 0xFFFFFF will remove any tint effect.
         *
         * @member {number}
         * @default 0xFFFFFF
         */ get: function() {
            return this._tint;
        },
        set: function(value) {
            this._tint = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Graphics.prototype, "fill", {
        /**
         * The current fill style.
         *
         * @member {PIXI.FillStyle}
         * @readonly
         */ get: function() {
            return this._fillStyle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Graphics.prototype, "line", {
        /**
         * The current line style.
         *
         * @member {PIXI.LineStyle}
         * @readonly
         */ get: function() {
            return this._lineStyle;
        },
        enumerable: false,
        configurable: true
    });
    Graphics.prototype.lineStyle = function(options, color, alpha, alignment, native) {
        if (options === void 0) options = null;
        if (color === void 0) color = 0x0;
        if (alpha === void 0) alpha = 1;
        if (alignment === void 0) alignment = 0.5;
        if (native === void 0) native = false;
        // Support non-object params: (width, color, alpha, alignment, native)
        if (typeof options === 'number') options = {
            width: options,
            color: color,
            alpha: alpha,
            alignment: alignment,
            native: native
        };
        return this.lineTextureStyle(options);
    };
    /**
     * Like line style but support texture for line fill.
     *
     * @param {object} [options] - Collection of options for setting line style.
     * @param {number} [options.width=0] - width of the line to draw, will update the objects stored style
     * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to use
     * @param {number} [options.color=0x0] - color of the line to draw, will update the objects stored style.
     *  Default 0xFFFFFF if texture present.
     * @param {number} [options.alpha=1] - alpha of the line to draw, will update the objects stored style
     * @param {PIXI.Matrix} [options.matrix=null] - Texture matrix to transform texture
     * @param {number} [options.alignment=0.5] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outer).
     *        WebGL only.
     * @param {boolean} [options.native=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
     * @param {PIXI.LINE_CAP}[options.cap=PIXI.LINE_CAP.BUTT] - line cap style
     * @param {PIXI.LINE_JOIN}[options.join=PIXI.LINE_JOIN.MITER] - line join style
     * @param {number}[options.miterLimit=10] - miter limit ratio
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.lineTextureStyle = function(options) {
        // Apply defaults
        options = Object.assign({
            width: 0,
            texture: (0, $klOfb.Texture).WHITE,
            color: options && options.texture ? 0xFFFFFF : 0x0,
            alpha: 1,
            matrix: null,
            alignment: 0.5,
            native: false,
            cap: $c0878112c399eabe$export$b113e22c48c75d2e.BUTT,
            join: $c0878112c399eabe$export$c6a6e344be1302e7.MITER,
            miterLimit: 10
        }, options);
        if (this.currentPath) this.startPoly();
        var visible = options.width > 0 && options.alpha > 0;
        if (!visible) this._lineStyle.reset();
        else {
            if (options.matrix) {
                options.matrix = options.matrix.clone();
                options.matrix.invert();
            }
            Object.assign(this._lineStyle, {
                visible: visible
            }, options);
        }
        return this;
    };
    /**
     * Start a polygon object internally
     * @protected
     */ Graphics.prototype.startPoly = function() {
        if (this.currentPath) {
            var points = this.currentPath.points;
            var len = this.currentPath.points.length;
            if (len > 2) {
                this.drawShape(this.currentPath);
                this.currentPath = new (0, $6qzqq.Polygon)();
                this.currentPath.closeStroke = false;
                this.currentPath.points.push(points[len - 2], points[len - 1]);
            }
        } else {
            this.currentPath = new (0, $6qzqq.Polygon)();
            this.currentPath.closeStroke = false;
        }
    };
    /**
     * Finish the polygon object.
     * @protected
     */ Graphics.prototype.finishPoly = function() {
        if (this.currentPath) {
            if (this.currentPath.points.length > 2) {
                this.drawShape(this.currentPath);
                this.currentPath = null;
            } else this.currentPath.points.length = 0;
        }
    };
    /**
     * Moves the current drawing position to x, y.
     *
     * @param {number} x - the X coordinate to move to
     * @param {number} y - the Y coordinate to move to
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.moveTo = function(x, y) {
        this.startPoly();
        this.currentPath.points[0] = x;
        this.currentPath.points[1] = y;
        return this;
    };
    /**
     * Draws a line using the current line style from the current drawing position to (x, y);
     * The current drawing position is then set to (x, y).
     *
     * @param {number} x - the X coordinate to draw to
     * @param {number} y - the Y coordinate to draw to
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.lineTo = function(x, y) {
        if (!this.currentPath) this.moveTo(0, 0);
        // remove duplicates..
        var points = this.currentPath.points;
        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];
        if (fromX !== x || fromY !== y) points.push(x, y);
        return this;
    };
    /**
     * Initialize the curve
     *
     * @param {number} [x=0]
     * @param {number} [y=0]
     */ Graphics.prototype._initCurve = function(x, y) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (this.currentPath) {
            if (this.currentPath.points.length === 0) this.currentPath.points = [
                x,
                y
            ];
        } else this.moveTo(x, y);
    };
    /**
     * Calculate the points for a quadratic bezier curve and then draws it.
     * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
     *
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.quadraticCurveTo = function(cpX, cpY, toX, toY) {
        this._initCurve();
        var points = this.currentPath.points;
        if (points.length === 0) this.moveTo(0, 0);
        $c0878112c399eabe$var$QuadraticUtils.curveTo(cpX, cpY, toX, toY, points);
        return this;
    };
    /**
     * Calculate the points for a bezier curve and then draws it.
     *
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} cpX2 - Second Control point x
     * @param {number} cpY2 - Second Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.bezierCurveTo = function(cpX, cpY, cpX2, cpY2, toX, toY) {
        this._initCurve();
        $c0878112c399eabe$var$BezierUtils.curveTo(cpX, cpY, cpX2, cpY2, toX, toY, this.currentPath.points);
        return this;
    };
    /**
     * The arcTo() method creates an arc/curve between two tangents on the canvas.
     *
     * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
     *
     * @param {number} x1 - The x-coordinate of the first tangent point of the arc
     * @param {number} y1 - The y-coordinate of the first tangent point of the arc
     * @param {number} x2 - The x-coordinate of the end of the arc
     * @param {number} y2 - The y-coordinate of the end of the arc
     * @param {number} radius - The radius of the arc
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._initCurve(x1, y1);
        var points = this.currentPath.points;
        var result = $c0878112c399eabe$var$ArcUtils.curveTo(x1, y1, x2, y2, radius, points);
        if (result) {
            var cx = result.cx, cy = result.cy, radius_1 = result.radius, startAngle = result.startAngle, endAngle = result.endAngle, anticlockwise = result.anticlockwise;
            this.arc(cx, cy, radius_1, startAngle, endAngle, anticlockwise);
        }
        return this;
    };
    /**
     * The arc method creates an arc/curve (used to create circles, or parts of circles).
     *
     * @param {number} cx - The x-coordinate of the center of the circle
     * @param {number} cy - The y-coordinate of the center of the circle
     * @param {number} radius - The radius of the circle
     * @param {number} startAngle - The starting angle, in radians (0 is at the 3 o'clock position
     *  of the arc's circle)
     * @param {number} endAngle - The ending angle, in radians
     * @param {boolean} [anticlockwise=false] - Specifies whether the drawing should be
     *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
     *  indicates counter-clockwise.
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.arc = function(cx, cy, radius, startAngle, endAngle, anticlockwise) {
        if (anticlockwise === void 0) anticlockwise = false;
        if (startAngle === endAngle) return this;
        if (!anticlockwise && endAngle <= startAngle) endAngle += (0, $6qzqq.PI_2);
        else if (anticlockwise && startAngle <= endAngle) startAngle += (0, $6qzqq.PI_2);
        var sweep = endAngle - startAngle;
        if (sweep === 0) return this;
        var startX = cx + Math.cos(startAngle) * radius;
        var startY = cy + Math.sin(startAngle) * radius;
        var eps = this._geometry.closePointEps;
        // If the currentPath exists, take its points. Otherwise call `moveTo` to start a path.
        var points = this.currentPath ? this.currentPath.points : null;
        if (points) {
            // TODO: make a better fix.
            // We check how far our start is from the last existing point
            var xDiff = Math.abs(points[points.length - 2] - startX);
            var yDiff = Math.abs(points[points.length - 1] - startY);
            if (xDiff < eps && yDiff < eps) ;
            else points.push(startX, startY);
        } else {
            this.moveTo(startX, startY);
            points = this.currentPath.points;
        }
        $c0878112c399eabe$var$ArcUtils.arc(startX, startY, cx, cy, radius, startAngle, endAngle, anticlockwise, points);
        return this;
    };
    /**
     * Specifies a simple one-color fill that subsequent calls to other Graphics methods
     * (such as lineTo() or drawCircle()) use when drawing.
     *
     * @param {number} [color=0] - the color of the fill
     * @param {number} [alpha=1] - the alpha of the fill
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.beginFill = function(color, alpha) {
        if (color === void 0) color = 0;
        if (alpha === void 0) alpha = 1;
        return this.beginTextureFill({
            texture: (0, $klOfb.Texture).WHITE,
            color: color,
            alpha: alpha
        });
    };
    /**
     * Begin the texture fill
     *
     * @param {object} [options] - Object object.
     * @param {PIXI.Texture} [options.texture=PIXI.Texture.WHITE] - Texture to fill
     * @param {number} [options.color=0xffffff] - Background to fill behind texture
     * @param {number} [options.alpha=1] - Alpha of fill
     * @param {PIXI.Matrix} [options.matrix=null] - Transform matrix
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.beginTextureFill = function(options) {
        // Apply defaults
        options = Object.assign({
            texture: (0, $klOfb.Texture).WHITE,
            color: 0xFFFFFF,
            alpha: 1,
            matrix: null
        }, options);
        if (this.currentPath) this.startPoly();
        var visible = options.alpha > 0;
        if (!visible) this._fillStyle.reset();
        else {
            if (options.matrix) {
                options.matrix = options.matrix.clone();
                options.matrix.invert();
            }
            Object.assign(this._fillStyle, {
                visible: visible
            }, options);
        }
        return this;
    };
    /**
     * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
     *
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.endFill = function() {
        this.finishPoly();
        this._fillStyle.reset();
        return this;
    };
    /**
     * Draws a rectangle shape.
     *
     * @param {number} x - The X coord of the top-left of the rectangle
     * @param {number} y - The Y coord of the top-left of the rectangle
     * @param {number} width - The width of the rectangle
     * @param {number} height - The height of the rectangle
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.drawRect = function(x, y, width, height) {
        return this.drawShape(new (0, $6qzqq.Rectangle)(x, y, width, height));
    };
    /**
     * Draw a rectangle shape with rounded/beveled corners.
     *
     * @param {number} x - The X coord of the top-left of the rectangle
     * @param {number} y - The Y coord of the top-left of the rectangle
     * @param {number} width - The width of the rectangle
     * @param {number} height - The height of the rectangle
     * @param {number} radius - Radius of the rectangle corners
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.drawRoundedRect = function(x, y, width, height, radius) {
        return this.drawShape(new (0, $6qzqq.RoundedRectangle)(x, y, width, height, radius));
    };
    /**
     * Draws a circle.
     *
     * @param {number} x - The X coordinate of the center of the circle
     * @param {number} y - The Y coordinate of the center of the circle
     * @param {number} radius - The radius of the circle
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.drawCircle = function(x, y, radius) {
        return this.drawShape(new (0, $6qzqq.Circle)(x, y, radius));
    };
    /**
     * Draws an ellipse.
     *
     * @param {number} x - The X coordinate of the center of the ellipse
     * @param {number} y - The Y coordinate of the center of the ellipse
     * @param {number} width - The half width of the ellipse
     * @param {number} height - The half height of the ellipse
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.drawEllipse = function(x, y, width, height) {
        return this.drawShape(new (0, $6qzqq.Ellipse)(x, y, width, height));
    };
    /**
     * Draws a polygon using the given path.
     *
     * @param {number[]|PIXI.Point[]|PIXI.Polygon} path - The path data used to construct the polygon.
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.drawPolygon = function() {
        var arguments$1 = arguments;
        var path = [];
        for(var _i = 0; _i < arguments.length; _i++)path[_i] = arguments$1[_i];
        var points;
        var closeStroke = true; // !!this._fillStyle;
        var poly = path[0];
        // check if data has points..
        if (poly.points) {
            closeStroke = poly.closeStroke;
            points = poly.points;
        } else if (Array.isArray(path[0])) points = path[0];
        else points = path;
        var shape = new (0, $6qzqq.Polygon)(points);
        shape.closeStroke = closeStroke;
        this.drawShape(shape);
        return this;
    };
    /**
     * Draw any shape.
     *
     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - Shape to draw
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.drawShape = function(shape) {
        if (!this._holeMode) this._geometry.drawShape(shape, this._fillStyle.clone(), this._lineStyle.clone(), this._matrix);
        else this._geometry.drawHole(shape, this._matrix);
        return this;
    };
    /**
     * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
     *
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */ Graphics.prototype.clear = function() {
        this._geometry.clear();
        this._lineStyle.reset();
        this._fillStyle.reset();
        this._boundsID++;
        this._matrix = null;
        this._holeMode = false;
        this.currentPath = null;
        return this;
    };
    /**
     * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
     * masked with gl.scissor.
     *
     * @returns {boolean} True if only 1 rect.
     */ Graphics.prototype.isFastRect = function() {
        var data = this._geometry.graphicsData;
        return data.length === 1 && data[0].shape.type === (0, $6qzqq.SHAPES).RECT && !data[0].matrix && !data[0].holes.length && !(data[0].lineStyle.visible && data[0].lineStyle.width);
    };
    /**
     * Renders the object using the WebGL renderer
     *
     * @param {PIXI.Renderer} renderer - The renderer
     */ Graphics.prototype._render = function(renderer) {
        this.finishPoly();
        var geometry = this._geometry;
        var hasuint32 = renderer.context.supports.uint32Indices;
        // batch part..
        // batch it!
        geometry.updateBatches(hasuint32);
        if (geometry.batchable) {
            if (this.batchDirty !== geometry.batchDirty) this._populateBatches();
            this._renderBatched(renderer);
        } else {
            // no batching...
            renderer.batch.flush();
            this._renderDirect(renderer);
        }
    };
    /** Populating batches for rendering. */ Graphics.prototype._populateBatches = function() {
        var geometry = this._geometry;
        var blendMode = this.blendMode;
        var len = geometry.batches.length;
        this.batchTint = -1;
        this._transformID = -1;
        this.batchDirty = geometry.batchDirty;
        this.batches.length = len;
        this.vertexData = new Float32Array(geometry.points);
        for(var i = 0; i < len; i++){
            var gI = geometry.batches[i];
            var color = gI.style.color;
            var vertexData = new Float32Array(this.vertexData.buffer, gI.attribStart * 8, gI.attribSize * 2);
            var uvs = new Float32Array(geometry.uvsFloat32.buffer, gI.attribStart * 8, gI.attribSize * 2);
            var indices = new Uint16Array(geometry.indicesUint16.buffer, gI.start * 2, gI.size);
            var batch = {
                vertexData: vertexData,
                blendMode: blendMode,
                indices: indices,
                uvs: uvs,
                _batchRGB: (0, $csytw.hex2rgb)(color),
                _tintRGB: color,
                _texture: gI.style.texture,
                alpha: gI.style.alpha,
                worldAlpha: 1
            };
            this.batches[i] = batch;
        }
    };
    /**
     * Renders the batches using the BathedRenderer plugin
     *
     * @param {PIXI.Renderer} renderer - The renderer
     */ Graphics.prototype._renderBatched = function(renderer) {
        if (!this.batches.length) return;
        renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]);
        this.calculateVertices();
        this.calculateTints();
        for(var i = 0, l = this.batches.length; i < l; i++){
            var batch = this.batches[i];
            batch.worldAlpha = this.worldAlpha * batch.alpha;
            renderer.plugins[this.pluginName].render(batch);
        }
    };
    /**
     * Renders the graphics direct
     *
     * @param {PIXI.Renderer} renderer - The renderer
     */ Graphics.prototype._renderDirect = function(renderer) {
        var shader = this._resolveDirectShader(renderer);
        var geometry = this._geometry;
        var tint = this.tint;
        var worldAlpha = this.worldAlpha;
        var uniforms = shader.uniforms;
        var drawCalls = geometry.drawCalls;
        // lets set the transfomr
        uniforms.translationMatrix = this.transform.worldTransform;
        // and then lets set the tint..
        uniforms.tint[0] = (tint >> 16 & 0xFF) / 255 * worldAlpha;
        uniforms.tint[1] = (tint >> 8 & 0xFF) / 255 * worldAlpha;
        uniforms.tint[2] = (tint & 0xFF) / 255 * worldAlpha;
        uniforms.tint[3] = worldAlpha;
        // the first draw call, we can set the uniforms of the shader directly here.
        // this means that we can tack advantage of the sync function of pixi!
        // bind and sync uniforms..
        // there is a way to optimise this..
        renderer.shader.bind(shader);
        renderer.geometry.bind(geometry, shader);
        // set state..
        renderer.state.set(this.state);
        // then render the rest of them...
        for(var i = 0, l = drawCalls.length; i < l; i++)this._renderDrawCallDirect(renderer, geometry.drawCalls[i]);
    };
    /**
     * Renders specific DrawCall
     *
     * @param {PIXI.Renderer} renderer
     * @param {PIXI.BatchDrawCall} drawCall
     */ Graphics.prototype._renderDrawCallDirect = function(renderer, drawCall) {
        var texArray = drawCall.texArray, type = drawCall.type, size = drawCall.size, start = drawCall.start;
        var groupTextureCount = texArray.count;
        for(var j = 0; j < groupTextureCount; j++)renderer.texture.bind(texArray.elements[j], j);
        renderer.geometry.draw(type, size, start);
    };
    /**
     * Resolves shader for direct rendering
     *
     * @param {PIXI.Renderer} renderer - The renderer
     */ Graphics.prototype._resolveDirectShader = function(renderer) {
        var shader = this.shader;
        var pluginName = this.pluginName;
        if (!shader) {
            // if there is no shader here, we can use the default shader.
            // and that only gets created if we actually need it..
            // but may be more than one plugins for graphics
            if (!$c0878112c399eabe$var$DEFAULT_SHADERS[pluginName]) {
                var MAX_TEXTURES = renderer.plugins.batch.MAX_TEXTURES;
                var sampleValues = new Int32Array(MAX_TEXTURES);
                for(var i = 0; i < MAX_TEXTURES; i++)sampleValues[i] = i;
                var uniforms = {
                    tint: new Float32Array([
                        1,
                        1,
                        1,
                        1
                    ]),
                    translationMatrix: new (0, $6qzqq.Matrix)(),
                    default: (0, $klOfb.UniformGroup).from({
                        uSamplers: sampleValues
                    }, true)
                };
                var program = renderer.plugins[pluginName]._shader.program;
                $c0878112c399eabe$var$DEFAULT_SHADERS[pluginName] = new (0, $klOfb.Shader)(program, uniforms);
            }
            shader = $c0878112c399eabe$var$DEFAULT_SHADERS[pluginName];
        }
        return shader;
    };
    /** Retrieves the bounds of the graphic shape as a rectangle object. */ Graphics.prototype._calculateBounds = function() {
        this.finishPoly();
        var geometry = this._geometry;
        // skipping when graphics is empty, like a container
        if (!geometry.graphicsData.length) return;
        var _a = geometry.bounds, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    };
    /**
     * Tests if a point is inside this graphics object
     *
     * @param {PIXI.IPointData} point - the point to test
     * @return {boolean} the result of the test
     */ Graphics.prototype.containsPoint = function(point) {
        this.worldTransform.applyInverse(point, Graphics._TEMP_POINT);
        return this._geometry.containsPoint(Graphics._TEMP_POINT);
    };
    /** Recalculate the tint by applying tint to batches using Graphics tint. */ Graphics.prototype.calculateTints = function() {
        if (this.batchTint !== this.tint) {
            this.batchTint = this.tint;
            var tintRGB = (0, $csytw.hex2rgb)(this.tint, $c0878112c399eabe$var$temp);
            for(var i = 0; i < this.batches.length; i++){
                var batch = this.batches[i];
                var batchTint = batch._batchRGB;
                var r = tintRGB[0] * batchTint[0] * 255;
                var g = tintRGB[1] * batchTint[1] * 255;
                var b = tintRGB[2] * batchTint[2] * 255;
                // TODO Ivan, can this be done in one go?
                var color = (r << 16) + (g << 8) + (b | 0);
                batch._tintRGB = (color >> 16) + (color & 0xff00) + ((color & 0xff) << 16);
            }
        }
    };
    /**
     * If there's a transform update or a change to the shape of the
     * geometry, recalculate the vertices.
     */ Graphics.prototype.calculateVertices = function() {
        var wtID = this.transform._worldID;
        if (this._transformID === wtID) return;
        this._transformID = wtID;
        var wt = this.transform.worldTransform;
        var a = wt.a;
        var b = wt.b;
        var c = wt.c;
        var d = wt.d;
        var tx = wt.tx;
        var ty = wt.ty;
        var data = this._geometry.points; // batch.vertexDataOriginal;
        var vertexData = this.vertexData;
        var count = 0;
        for(var i = 0; i < data.length; i += 2){
            var x = data[i];
            var y = data[i + 1];
            vertexData[count++] = a * x + c * y + tx;
            vertexData[count++] = d * y + b * x + ty;
        }
    };
    /**
     * Closes the current path.
     *
     * @return {PIXI.Graphics} Returns itself.
     */ Graphics.prototype.closePath = function() {
        var currentPath = this.currentPath;
        if (currentPath) {
            // we don't need to add extra point in the end because buildLine will take care of that
            currentPath.closeStroke = true;
            // ensure that the polygon is completed, and is available for hit detection
            // (even if the graphics is not rendered yet)
            this.finishPoly();
        }
        return this;
    };
    /**
     * Apply a matrix to the positional data.
     *
     * @param {PIXI.Matrix} matrix - Matrix to use for transform current shape.
     * @return {PIXI.Graphics} Returns itself.
     */ Graphics.prototype.setMatrix = function(matrix) {
        this._matrix = matrix;
        return this;
    };
    /**
     * Begin adding holes to the last draw shape
     * IMPORTANT: holes must be fully inside a shape to work
     * Also weirdness ensues if holes overlap!
     * Ellipses, Circles, Rectangles and Rounded Rectangles cannot be holes or host for holes in CanvasRenderer,
     * please use `moveTo` `lineTo`, `quadraticCurveTo` if you rely on pixi-legacy bundle.
     * @return {PIXI.Graphics} Returns itself.
     */ Graphics.prototype.beginHole = function() {
        this.finishPoly();
        this._holeMode = true;
        return this;
    };
    /**
     * End adding holes to the last draw shape
     * @return {PIXI.Graphics} Returns itself.
     */ Graphics.prototype.endHole = function() {
        this.finishPoly();
        this._holeMode = false;
        return this;
    };
    /**
     * Destroys the Graphics object.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
     *  options have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have
     *  their destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */ Graphics.prototype.destroy = function(options) {
        this._geometry.refCount--;
        if (this._geometry.refCount === 0) this._geometry.dispose();
        this._matrix = null;
        this.currentPath = null;
        this._lineStyle.destroy();
        this._lineStyle = null;
        this._fillStyle.destroy();
        this._fillStyle = null;
        this._geometry = null;
        this.shader = null;
        this.vertexData = null;
        this.batches.length = 0;
        this.batches = null;
        _super.prototype.destroy.call(this, options);
    };
    /**
     * Temporary point to use for containsPoint
     *
     * @static
     * @private
     */ Graphics._TEMP_POINT = new (0, $6qzqq.Point)();
    return Graphics;
}((0, $8t5Gy.Container));
var $c0878112c399eabe$export$efc72ad5bf88689 = {
    buildPoly: $c0878112c399eabe$var$buildPoly,
    buildCircle: $c0878112c399eabe$var$buildCircle,
    buildRectangle: $c0878112c399eabe$var$buildRectangle,
    buildRoundedRectangle: $c0878112c399eabe$var$buildRoundedRectangle,
    buildLine: $c0878112c399eabe$var$buildLine,
    ArcUtils: $c0878112c399eabe$var$ArcUtils,
    BezierUtils: $c0878112c399eabe$var$BezierUtils,
    QuadraticUtils: $c0878112c399eabe$var$QuadraticUtils,
    BatchPart: $c0878112c399eabe$var$BatchPart,
    FILL_COMMANDS: $c0878112c399eabe$var$FILL_COMMANDS,
    BATCH_POOL: $c0878112c399eabe$var$BATCH_POOL,
    DRAW_CALL_POOL: $c0878112c399eabe$var$DRAW_CALL_POOL
};

});

parcelRegister("9Pi8W", function(module, exports) {

$parcel$export(module.exports, "TEXT_GRADIENT", function () { return $7276f35895ff141a$export$131daa784848984; });
$parcel$export(module.exports, "TextStyle", function () { return $7276f35895ff141a$export$1df879243bf2e42d; });
$parcel$export(module.exports, "TextMetrics", function () { return $7276f35895ff141a$export$4c5a129a59e1ef34; });
$parcel$export(module.exports, "Text", function () { return $7276f35895ff141a$export$5f1af8db9871e1d6; });
/*!
 * @pixi/text - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/text is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $7Bs2Z = parcelRequire("7Bs2Z");

var $klOfb = parcelRequire("klOfb");

var $ezJmd = parcelRequire("ezJmd");

var $6qzqq = parcelRequire("6qzqq");

var $csytw = parcelRequire("csytw");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $7276f35895ff141a$var$extendStatics = function(d, b) {
    $7276f35895ff141a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $7276f35895ff141a$var$extendStatics(d, b);
};
function $7276f35895ff141a$var$__extends(d, b) {
    $7276f35895ff141a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * Constants that define the type of gradient on text.
 *
 * @static
 * @constant
 * @name TEXT_GRADIENT
 * @memberof PIXI
 * @type {object}
 * @property {number} LINEAR_VERTICAL Vertical gradient
 * @property {number} LINEAR_HORIZONTAL Linear gradient
 */ var $7276f35895ff141a$export$131daa784848984;
(function(TEXT_GRADIENT) {
    TEXT_GRADIENT[TEXT_GRADIENT["LINEAR_VERTICAL"] = 0] = "LINEAR_VERTICAL";
    TEXT_GRADIENT[TEXT_GRADIENT["LINEAR_HORIZONTAL"] = 1] = "LINEAR_HORIZONTAL";
})($7276f35895ff141a$export$131daa784848984 || ($7276f35895ff141a$export$131daa784848984 = {}));
// disabling eslint for now, going to rewrite this in v5
var $7276f35895ff141a$var$defaultStyle = {
    align: 'left',
    breakWords: false,
    dropShadow: false,
    dropShadowAlpha: 1,
    dropShadowAngle: Math.PI / 6,
    dropShadowBlur: 0,
    dropShadowColor: 'black',
    dropShadowDistance: 5,
    fill: 'black',
    fillGradientType: $7276f35895ff141a$export$131daa784848984.LINEAR_VERTICAL,
    fillGradientStops: [],
    fontFamily: 'Arial',
    fontSize: 26,
    fontStyle: 'normal',
    fontVariant: 'normal',
    fontWeight: 'normal',
    letterSpacing: 0,
    lineHeight: 0,
    lineJoin: 'miter',
    miterLimit: 10,
    padding: 0,
    stroke: 'black',
    strokeThickness: 0,
    textBaseline: 'alphabetic',
    trim: false,
    whiteSpace: 'pre',
    wordWrap: false,
    wordWrapWidth: 100,
    leading: 0
};
var $7276f35895ff141a$var$genericFontFamilies = [
    'serif',
    'sans-serif',
    'monospace',
    'cursive',
    'fantasy',
    'system-ui'
];
/**
 * A TextStyle Object contains information to decorate a Text objects.
 *
 * An instance can be shared between multiple Text objects; then changing the style will update all text objects using it.
 *
 * A tool can be used to generate a text style [here](https://pixijs.io/pixi-text-style).
 *
 * @memberof PIXI
 */ var $7276f35895ff141a$export$1df879243bf2e42d = /** @class */ function() {
    /**
     * @param {object} [style] - The style parameters
     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'),
     *  does not affect single line text
     * @param {boolean} [style.breakWords=false] - Indicates if lines can be wrapped within words, it
     *  needs wordWrap to be set to true
     * @param {boolean} [style.dropShadow=false] - Set a drop shadow for the text
     * @param {number} [style.dropShadowAlpha=1] - Set alpha for the drop shadow
     * @param {number} [style.dropShadowAngle=Math.PI/6] - Set a angle of the drop shadow
     * @param {number} [style.dropShadowBlur=0] - Set a shadow blur radius
     * @param {string|number} [style.dropShadowColor='black'] - A fill style to be used on the dropshadow e.g 'red', '#00FF00'
     * @param {number} [style.dropShadowDistance=5] - Set a distance of the drop shadow
     * @param {string|string[]|number|number[]|CanvasGradient|CanvasPattern} [style.fill='black'] - A canvas
     *  fillstyle that will be used on the text e.g 'red', '#00FF00'. Can be an array to create a gradient
     *  eg ['#000000','#FFFFFF']
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
     * @param {number} [style.fillGradientType=PIXI.TEXT_GRADIENT.LINEAR_VERTICAL] - If fill is an array of colours
     *  to create a gradient, this can change the type/direction of the gradient. See {@link PIXI.TEXT_GRADIENT}
     * @param {number[]} [style.fillGradientStops] - If fill is an array of colours to create a gradient, this array can set
     * the stop points (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
     * @param {string|string[]} [style.fontFamily='Arial'] - The font family
     * @param {number|string} [style.fontSize=26] - The font size (as a number it converts to px, but as a string,
     *  equivalents are '26px','20pt','160%' or '1.6em')
     * @param {string} [style.fontStyle='normal'] - The font style ('normal', 'italic' or 'oblique')
     * @param {string} [style.fontVariant='normal'] - The font variant ('normal' or 'small-caps')
     * @param {string} [style.fontWeight='normal'] - The font weight ('normal', 'bold', 'bolder', 'lighter' and '100',
     *  '200', '300', '400', '500', '600', '700', '800' or '900')
     * @param {number} [style.leading=0] - The space between lines
     * @param {number} [style.letterSpacing=0] - The amount of spacing between letters, default is 0
     * @param {number} [style.lineHeight] - The line height, a number that represents the vertical space that a letter uses
     * @param {string} [style.lineJoin='miter'] - The lineJoin property sets the type of corner created, it can resolve
     *      spiked text issues. Possible values "miter" (creates a sharp corner), "round" (creates a round corner) or "bevel"
     *      (creates a squared corner).
     * @param {number} [style.miterLimit=10] - The miter limit to use when using the 'miter' lineJoin mode. This can reduce
     *      or increase the spikiness of rendered text.
     * @param {number} [style.padding=0] - Occasionally some fonts are cropped. Adding some padding will prevent this from
     *     happening by adding padding to all sides of the text.
     * @param {string|number} [style.stroke='black'] - A canvas fillstyle that will be used on the text stroke
     *  e.g 'blue', '#FCFF00'
     * @param {number} [style.strokeThickness=0] - A number that represents the thickness of the stroke.
     *  Default is 0 (no stroke)
     * @param {boolean} [style.trim=false] - Trim transparent borders
     * @param {string} [style.textBaseline='alphabetic'] - The baseline of the text that is rendered.
     * @param {string} [style.whiteSpace='pre'] - Determines whether newlines & spaces are collapsed or preserved "normal"
     *      (collapse, collapse), "pre" (preserve, preserve) | "pre-line" (preserve, collapse). It needs wordWrap to be set to true
     * @param {boolean} [style.wordWrap=false] - Indicates if word wrap should be used
     * @param {number} [style.wordWrapWidth=100] - The width at which text will wrap, it needs wordWrap to be set to true
     */ function TextStyle(style) {
        this.styleID = 0;
        this.reset();
        $7276f35895ff141a$var$deepCopyProperties(this, style, style);
    }
    /**
     * Creates a new TextStyle object with the same values as this one.
     * Note that the only the properties of the object are cloned.
     *
     * @return New cloned TextStyle object
     */ TextStyle.prototype.clone = function() {
        var clonedProperties = {};
        $7276f35895ff141a$var$deepCopyProperties(clonedProperties, this, $7276f35895ff141a$var$defaultStyle);
        return new TextStyle(clonedProperties);
    };
    /** Resets all properties to the defaults specified in TextStyle.prototype._default */ TextStyle.prototype.reset = function() {
        $7276f35895ff141a$var$deepCopyProperties(this, $7276f35895ff141a$var$defaultStyle, $7276f35895ff141a$var$defaultStyle);
    };
    Object.defineProperty(TextStyle.prototype, "align", {
        /**
         * Alignment for multiline text ('left', 'center' or 'right'), does not affect single line text
         *
         * @member {string}
         */ get: function() {
            return this._align;
        },
        set: function(align) {
            if (this._align !== align) {
                this._align = align;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "breakWords", {
        /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */ get: function() {
            return this._breakWords;
        },
        set: function(breakWords) {
            if (this._breakWords !== breakWords) {
                this._breakWords = breakWords;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "dropShadow", {
        /** Set a drop shadow for the text. */ get: function() {
            return this._dropShadow;
        },
        set: function(dropShadow) {
            if (this._dropShadow !== dropShadow) {
                this._dropShadow = dropShadow;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "dropShadowAlpha", {
        /** Set alpha for the drop shadow. */ get: function() {
            return this._dropShadowAlpha;
        },
        set: function(dropShadowAlpha) {
            if (this._dropShadowAlpha !== dropShadowAlpha) {
                this._dropShadowAlpha = dropShadowAlpha;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "dropShadowAngle", {
        /** Set a angle of the drop shadow. */ get: function() {
            return this._dropShadowAngle;
        },
        set: function(dropShadowAngle) {
            if (this._dropShadowAngle !== dropShadowAngle) {
                this._dropShadowAngle = dropShadowAngle;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "dropShadowBlur", {
        /** Set a shadow blur radius. */ get: function() {
            return this._dropShadowBlur;
        },
        set: function(dropShadowBlur) {
            if (this._dropShadowBlur !== dropShadowBlur) {
                this._dropShadowBlur = dropShadowBlur;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "dropShadowColor", {
        /** A fill style to be used on the dropshadow e.g 'red', '#00FF00'. */ get: function() {
            return this._dropShadowColor;
        },
        set: function(dropShadowColor) {
            var outputColor = $7276f35895ff141a$var$getColor(dropShadowColor);
            if (this._dropShadowColor !== outputColor) {
                this._dropShadowColor = outputColor;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "dropShadowDistance", {
        /** Set a distance of the drop shadow. */ get: function() {
            return this._dropShadowDistance;
        },
        set: function(dropShadowDistance) {
            if (this._dropShadowDistance !== dropShadowDistance) {
                this._dropShadowDistance = dropShadowDistance;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fill", {
        /**
         * A canvas fillstyle that will be used on the text e.g 'red', '#00FF00'.
         *
         * Can be an array to create a gradient eg ['#000000','#FFFFFF']
         * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
         *
         * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
         */ get: function() {
            return this._fill;
        },
        set: function(fill) {
            // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
            //       the setter converts to string. See this thread for more details:
            //       https://github.com/microsoft/TypeScript/issues/2521
            // TODO: Not sure if getColor works properly with CanvasGradient and/or CanvasPattern, can't pass in
            //       without casting here.
            var outputColor = $7276f35895ff141a$var$getColor(fill);
            if (this._fill !== outputColor) {
                this._fill = outputColor;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fillGradientType", {
        /**
         * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
         *
         * @see PIXI.TEXT_GRADIENT
         */ get: function() {
            return this._fillGradientType;
        },
        set: function(fillGradientType) {
            if (this._fillGradientType !== fillGradientType) {
                this._fillGradientType = fillGradientType;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fillGradientStops", {
        /**
         * If fill is an array of colours to create a gradient, this array can set the stop points
         * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
         */ get: function() {
            return this._fillGradientStops;
        },
        set: function(fillGradientStops) {
            if (!$7276f35895ff141a$var$areArraysEqual(this._fillGradientStops, fillGradientStops)) {
                this._fillGradientStops = fillGradientStops;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fontFamily", {
        /** The font family. */ get: function() {
            return this._fontFamily;
        },
        set: function(fontFamily) {
            if (this.fontFamily !== fontFamily) {
                this._fontFamily = fontFamily;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fontSize", {
        /**
         * The font size
         * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
         */ get: function() {
            return this._fontSize;
        },
        set: function(fontSize) {
            if (this._fontSize !== fontSize) {
                this._fontSize = fontSize;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fontStyle", {
        /**
         * The font style
         * ('normal', 'italic' or 'oblique')
         *
         * @member {string}
         */ get: function() {
            return this._fontStyle;
        },
        set: function(fontStyle) {
            if (this._fontStyle !== fontStyle) {
                this._fontStyle = fontStyle;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fontVariant", {
        /**
         * The font variant
         * ('normal' or 'small-caps')
         *
         * @member {string}
         */ get: function() {
            return this._fontVariant;
        },
        set: function(fontVariant) {
            if (this._fontVariant !== fontVariant) {
                this._fontVariant = fontVariant;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "fontWeight", {
        /**
         * The font weight
         * ('normal', 'bold', 'bolder', 'lighter' and '100', '200', '300', '400', '500', '600', '700', 800' or '900')
         *
         * @member {string}
         */ get: function() {
            return this._fontWeight;
        },
        set: function(fontWeight) {
            if (this._fontWeight !== fontWeight) {
                this._fontWeight = fontWeight;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "letterSpacing", {
        /** The amount of spacing between letters, default is 0. */ get: function() {
            return this._letterSpacing;
        },
        set: function(letterSpacing) {
            if (this._letterSpacing !== letterSpacing) {
                this._letterSpacing = letterSpacing;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "lineHeight", {
        /** The line height, a number that represents the vertical space that a letter uses. */ get: function() {
            return this._lineHeight;
        },
        set: function(lineHeight) {
            if (this._lineHeight !== lineHeight) {
                this._lineHeight = lineHeight;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "leading", {
        /** The space between lines. */ get: function() {
            return this._leading;
        },
        set: function(leading) {
            if (this._leading !== leading) {
                this._leading = leading;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "lineJoin", {
        /**
         * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
         * Default is 'miter' (creates a sharp corner).
         *
         * @member {string}
         */ get: function() {
            return this._lineJoin;
        },
        set: function(lineJoin) {
            if (this._lineJoin !== lineJoin) {
                this._lineJoin = lineJoin;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "miterLimit", {
        /**
         * The miter limit to use when using the 'miter' lineJoin mode.
         *
         * This can reduce or increase the spikiness of rendered text.
         */ get: function() {
            return this._miterLimit;
        },
        set: function(miterLimit) {
            if (this._miterLimit !== miterLimit) {
                this._miterLimit = miterLimit;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "padding", {
        /**
         * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
         * by adding padding to all sides of the text.
         */ get: function() {
            return this._padding;
        },
        set: function(padding) {
            if (this._padding !== padding) {
                this._padding = padding;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "stroke", {
        /**
         * A canvas fillstyle that will be used on the text stroke
         * e.g 'blue', '#FCFF00'
         */ get: function() {
            return this._stroke;
        },
        set: function(stroke) {
            // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
            //       the setter converts to string. See this thread for more details:
            //       https://github.com/microsoft/TypeScript/issues/2521
            var outputColor = $7276f35895ff141a$var$getColor(stroke);
            if (this._stroke !== outputColor) {
                this._stroke = outputColor;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "strokeThickness", {
        /**
         * A number that represents the thickness of the stroke.
         *
         * @default 0
         */ get: function() {
            return this._strokeThickness;
        },
        set: function(strokeThickness) {
            if (this._strokeThickness !== strokeThickness) {
                this._strokeThickness = strokeThickness;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "textBaseline", {
        /**
         * The baseline of the text that is rendered.
         *
         * @member {string}
         */ get: function() {
            return this._textBaseline;
        },
        set: function(textBaseline) {
            if (this._textBaseline !== textBaseline) {
                this._textBaseline = textBaseline;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "trim", {
        /** Trim transparent borders. */ get: function() {
            return this._trim;
        },
        set: function(trim) {
            if (this._trim !== trim) {
                this._trim = trim;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "whiteSpace", {
        /**
         * How newlines and spaces should be handled.
         * Default is 'pre' (preserve, preserve).
         *
         *  value       | New lines     |   Spaces
         *  ---         | ---           |   ---
         * 'normal'     | Collapse      |   Collapse
         * 'pre'        | Preserve      |   Preserve
         * 'pre-line'   | Preserve      |   Collapse
         *
         * @member {string}
         */ get: function() {
            return this._whiteSpace;
        },
        set: function(whiteSpace) {
            if (this._whiteSpace !== whiteSpace) {
                this._whiteSpace = whiteSpace;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "wordWrap", {
        /** Indicates if word wrap should be used. */ get: function() {
            return this._wordWrap;
        },
        set: function(wordWrap) {
            if (this._wordWrap !== wordWrap) {
                this._wordWrap = wordWrap;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextStyle.prototype, "wordWrapWidth", {
        /** The width at which text will wrap, it needs wordWrap to be set to true. */ get: function() {
            return this._wordWrapWidth;
        },
        set: function(wordWrapWidth) {
            if (this._wordWrapWidth !== wordWrapWidth) {
                this._wordWrapWidth = wordWrapWidth;
                this.styleID++;
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Generates a font style string to use for `TextMetrics.measureFont()`.
     *
     * @return Font style string, for passing to `TextMetrics.measureFont()`
     */ TextStyle.prototype.toFontString = function() {
        // build canvas api font setting from individual components. Convert a numeric this.fontSize to px
        var fontSizeString = typeof this.fontSize === 'number' ? this.fontSize + "px" : this.fontSize;
        // Clean-up fontFamily property by quoting each font name
        // this will support font names with spaces
        var fontFamilies = this.fontFamily;
        if (!Array.isArray(this.fontFamily)) fontFamilies = this.fontFamily.split(',');
        for(var i = fontFamilies.length - 1; i >= 0; i--){
            // Trim any extra white-space
            var fontFamily = fontFamilies[i].trim();
            // Check if font already contains strings
            if (!/([\"\'])[^\'\"]+\1/.test(fontFamily) && $7276f35895ff141a$var$genericFontFamilies.indexOf(fontFamily) < 0) fontFamily = "\"" + fontFamily + "\"";
            fontFamilies[i] = fontFamily;
        }
        return this.fontStyle + " " + this.fontVariant + " " + this.fontWeight + " " + fontSizeString + " " + fontFamilies.join(',');
    };
    return TextStyle;
}();
/**
 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
 * @private
 * @param color
 * @return The color as a string.
 */ function $7276f35895ff141a$var$getSingleColor(color) {
    if (typeof color === 'number') return (0, $csytw.hex2string)(color);
    else if (typeof color === 'string') {
        if (color.indexOf('0x') === 0) color = color.replace('0x', '#');
    }
    return color;
}
function $7276f35895ff141a$var$getColor(color) {
    if (!Array.isArray(color)) return $7276f35895ff141a$var$getSingleColor(color);
    else {
        for(var i = 0; i < color.length; ++i)color[i] = $7276f35895ff141a$var$getSingleColor(color[i]);
        return color;
    }
}
/**
 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
 * This version can also convert array of colors
 * @private
 * @param array1 - First array to compare
 * @param array2 - Second array to compare
 * @return Do the arrays contain the same values in the same order
 */ function $7276f35895ff141a$var$areArraysEqual(array1, array2) {
    if (!Array.isArray(array1) || !Array.isArray(array2)) return false;
    if (array1.length !== array2.length) return false;
    for(var i = 0; i < array1.length; ++i){
        if (array1[i] !== array2[i]) return false;
    }
    return true;
}
/**
 * Utility function to ensure that object properties are copied by value, and not by reference
 * @private
 * @param target - Target object to copy properties into
 * @param source - Source object for the properties to copy
 * @param propertyObj - Object containing properties names we want to loop over
 */ function $7276f35895ff141a$var$deepCopyProperties(target, source, propertyObj) {
    for(var prop in propertyObj)if (Array.isArray(source[prop])) target[prop] = source[prop].slice();
    else target[prop] = source[prop];
}
/**
 * The TextMetrics object represents the measurement of a block of text with a specified style.
 *
 * ```js
 * let style = new PIXI.TextStyle({fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'})
 * let textMetrics = PIXI.TextMetrics.measureText('Your text', style)
 * ```
 *
 * @memberof PIXI
 */ var $7276f35895ff141a$export$4c5a129a59e1ef34 = /** @class */ function() {
    /**
     * @param text - the text that was measured
     * @param style - the style that was measured
     * @param width - the measured width of the text
     * @param height - the measured height of the text
     * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
     * @param lineWidths - an array of the line widths for each line matched to `lines`
     * @param lineHeight - the measured line height for this style
     * @param maxLineWidth - the maximum line width for all measured lines
     * @param {PIXI.IFontMetrics} fontProperties - the font properties object from TextMetrics.measureFont
     */ function TextMetrics(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties) {
        this.text = text;
        this.style = style;
        this.width = width;
        this.height = height;
        this.lines = lines;
        this.lineWidths = lineWidths;
        this.lineHeight = lineHeight;
        this.maxLineWidth = maxLineWidth;
        this.fontProperties = fontProperties;
    }
    /**
     * Measures the supplied string of text and returns a Rectangle.
     *
     * @param text - The text to measure.
     * @param style - The text style to use for measuring
     * @param wordWrap - Override for if word-wrap should be applied to the text.
     * @param canvas - optional specification of the canvas to use for measuring.
     * @return Measured width and height of the text.
     */ TextMetrics.measureText = function(text, style, wordWrap, canvas) {
        if (canvas === void 0) canvas = TextMetrics._canvas;
        wordWrap = wordWrap === undefined || wordWrap === null ? style.wordWrap : wordWrap;
        var font = style.toFontString();
        var fontProperties = TextMetrics.measureFont(font);
        // fallback in case UA disallow canvas data extraction
        // (toDataURI, getImageData functions)
        if (fontProperties.fontSize === 0) {
            fontProperties.fontSize = style.fontSize;
            fontProperties.ascent = style.fontSize;
        }
        var context = canvas.getContext('2d');
        context.font = font;
        var outputText = wordWrap ? TextMetrics.wordWrap(text, style, canvas) : text;
        var lines = outputText.split(/(?:\r\n|\r|\n)/);
        var lineWidths = new Array(lines.length);
        var maxLineWidth = 0;
        for(var i = 0; i < lines.length; i++){
            var lineWidth = context.measureText(lines[i]).width + (lines[i].length - 1) * style.letterSpacing;
            lineWidths[i] = lineWidth;
            maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        var width = maxLineWidth + style.strokeThickness;
        if (style.dropShadow) width += style.dropShadowDistance;
        var lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;
        var height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness) + (lines.length - 1) * (lineHeight + style.leading);
        if (style.dropShadow) height += style.dropShadowDistance;
        return new TextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
    };
    /**
     * Applies newlines to a string to have it optimally fit into the horizontal
     * bounds set by the Text object's wordWrapWidth property.
     *
     * @param text - String to apply word wrapping to
     * @param style - the style to use when wrapping
     * @param canvas - optional specification of the canvas to use for measuring.
     * @return New string with new lines applied where required
     */ TextMetrics.wordWrap = function(text, style, canvas) {
        if (canvas === void 0) canvas = TextMetrics._canvas;
        var context = canvas.getContext('2d');
        var width = 0;
        var line = '';
        var lines = '';
        var cache = Object.create(null);
        var letterSpacing = style.letterSpacing, whiteSpace = style.whiteSpace;
        // How to handle whitespaces
        var collapseSpaces = TextMetrics.collapseSpaces(whiteSpace);
        var collapseNewlines = TextMetrics.collapseNewlines(whiteSpace);
        // whether or not spaces may be added to the beginning of lines
        var canPrependSpaces = !collapseSpaces;
        // There is letterSpacing after every char except the last one
        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!
        // so for convenience the above needs to be compared to width + 1 extra letterSpace
        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!_
        // ________________________________________________
        // And then the final space is simply no appended to each line
        var wordWrapWidth = style.wordWrapWidth + letterSpacing;
        // break text into words, spaces and newline chars
        var tokens = TextMetrics.tokenize(text);
        for(var i = 0; i < tokens.length; i++){
            // get the word, space or newlineChar
            var token = tokens[i];
            // if word is a new line
            if (TextMetrics.isNewline(token)) {
                // keep the new line
                if (!collapseNewlines) {
                    lines += TextMetrics.addLine(line);
                    canPrependSpaces = !collapseSpaces;
                    line = '';
                    width = 0;
                    continue;
                }
                // if we should collapse new lines
                // we simply convert it into a space
                token = ' ';
            }
            // if we should collapse repeated whitespaces
            if (collapseSpaces) {
                // check both this and the last tokens for spaces
                var currIsBreakingSpace = TextMetrics.isBreakingSpace(token);
                var lastIsBreakingSpace = TextMetrics.isBreakingSpace(line[line.length - 1]);
                if (currIsBreakingSpace && lastIsBreakingSpace) continue;
            }
            // get word width from cache if possible
            var tokenWidth = TextMetrics.getFromCache(token, letterSpacing, cache, context);
            // word is longer than desired bounds
            if (tokenWidth > wordWrapWidth) {
                // if we are not already at the beginning of a line
                if (line !== '') {
                    // start newlines for overflow words
                    lines += TextMetrics.addLine(line);
                    line = '';
                    width = 0;
                }
                // break large word over multiple lines
                if (TextMetrics.canBreakWords(token, style.breakWords)) {
                    // break word into characters
                    var characters = TextMetrics.wordWrapSplit(token);
                    // loop the characters
                    for(var j = 0; j < characters.length; j++){
                        var char = characters[j];
                        var k = 1;
                        // we are not at the end of the token
                        while(characters[j + k]){
                            var nextChar = characters[j + k];
                            var lastChar = char[char.length - 1];
                            // should not split chars
                            if (!TextMetrics.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) // combine chars & move forward one
                            char += nextChar;
                            else break;
                            k++;
                        }
                        j += char.length - 1;
                        var characterWidth = TextMetrics.getFromCache(char, letterSpacing, cache, context);
                        if (characterWidth + width > wordWrapWidth) {
                            lines += TextMetrics.addLine(line);
                            canPrependSpaces = false;
                            line = '';
                            width = 0;
                        }
                        line += char;
                        width += characterWidth;
                    }
                } else {
                    // if there are words in this line already
                    // finish that line and start a new one
                    if (line.length > 0) {
                        lines += TextMetrics.addLine(line);
                        line = '';
                        width = 0;
                    }
                    var isLastToken = i === tokens.length - 1;
                    // give it its own line if it's not the end
                    lines += TextMetrics.addLine(token, !isLastToken);
                    canPrependSpaces = false;
                    line = '';
                    width = 0;
                }
            } else {
                // word won't fit because of existing words
                // start a new line
                if (tokenWidth + width > wordWrapWidth) {
                    // if its a space we don't want it
                    canPrependSpaces = false;
                    // add a new line
                    lines += TextMetrics.addLine(line);
                    // start a new line
                    line = '';
                    width = 0;
                }
                // don't add spaces to the beginning of lines
                if (line.length > 0 || !TextMetrics.isBreakingSpace(token) || canPrependSpaces) {
                    // add the word to the current line
                    line += token;
                    // update width counter
                    width += tokenWidth;
                }
            }
        }
        lines += TextMetrics.addLine(line, false);
        return lines;
    };
    /**
     * Convienience function for logging each line added during the wordWrap method.
     *
     * @param line    - The line of text to add
     * @param newLine - Add new line character to end
     * @return A formatted line
     */ TextMetrics.addLine = function(line, newLine) {
        if (newLine === void 0) newLine = true;
        line = TextMetrics.trimRight(line);
        line = newLine ? line + "\n" : line;
        return line;
    };
    /**
     * Gets & sets the widths of calculated characters in a cache object
     *
     * @param key            - The key
     * @param letterSpacing  - The letter spacing
     * @param cache          - The cache
     * @param context        - The canvas context
     * @return The from cache.
     */ TextMetrics.getFromCache = function(key, letterSpacing, cache, context) {
        var width = cache[key];
        if (typeof width !== 'number') {
            var spacing = key.length * letterSpacing;
            width = context.measureText(key).width + spacing;
            cache[key] = width;
        }
        return width;
    };
    /**
     * Determines whether we should collapse breaking spaces.
     *
     * @param whiteSpace - The TextStyle property whiteSpace
     * @return Should collapse
     */ TextMetrics.collapseSpaces = function(whiteSpace) {
        return whiteSpace === 'normal' || whiteSpace === 'pre-line';
    };
    /**
     * Determines whether we should collapse newLine chars.
     *
     * @param whiteSpace - The white space
     * @return  should collapse
     */ TextMetrics.collapseNewlines = function(whiteSpace) {
        return whiteSpace === 'normal';
    };
    /**
     * Trims breaking whitespaces from string.
     *
     * @param  text - The text
     * @return Trimmed string
     */ TextMetrics.trimRight = function(text) {
        if (typeof text !== 'string') return '';
        for(var i = text.length - 1; i >= 0; i--){
            var char = text[i];
            if (!TextMetrics.isBreakingSpace(char)) break;
            text = text.slice(0, -1);
        }
        return text;
    };
    /**
     * Determines if char is a newline.
     *
     * @param  char - The character
     * @return True if newline, False otherwise.
     */ TextMetrics.isNewline = function(char) {
        if (typeof char !== 'string') return false;
        return TextMetrics._newlines.indexOf(char.charCodeAt(0)) >= 0;
    };
    /**
     * Determines if char is a breaking whitespace.
     *
     * It allows one to determine whether char should be a breaking whitespace
     * For example certain characters in CJK langs or numbers.
     * It must return a boolean.
     *
     * @param char     - The character
     * @param [nextChar] - The next character
     * @return True if whitespace, False otherwise.
     */ TextMetrics.isBreakingSpace = function(char, _nextChar) {
        if (typeof char !== 'string') return false;
        return TextMetrics._breakingSpaces.indexOf(char.charCodeAt(0)) >= 0;
    };
    /**
     * Splits a string into words, breaking-spaces and newLine characters
     *
     * @param  text - The text
     * @return  A tokenized array
     */ TextMetrics.tokenize = function(text) {
        var tokens = [];
        var token = '';
        if (typeof text !== 'string') return tokens;
        for(var i = 0; i < text.length; i++){
            var char = text[i];
            var nextChar = text[i + 1];
            if (TextMetrics.isBreakingSpace(char, nextChar) || TextMetrics.isNewline(char)) {
                if (token !== '') {
                    tokens.push(token);
                    token = '';
                }
                tokens.push(char);
                continue;
            }
            token += char;
        }
        if (token !== '') tokens.push(token);
        return tokens;
    };
    /**
     * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
     *
     * It allows one to customise which words should break
     * Examples are if the token is CJK or numbers.
     * It must return a boolean.
     *
     * @param  token       - The token
     * @param  breakWords - The style attr break words
     * @return Whether to break word or not
     */ TextMetrics.canBreakWords = function(_token, breakWords) {
        return breakWords;
    };
    /**
     * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
     *
     * It allows one to determine whether a pair of characters
     * should be broken by newlines
     * For example certain characters in CJK langs or numbers.
     * It must return a boolean.
     *
     * @param  char        - The character
     * @param  nextChar    - The next character
     * @param  token       - The token/word the characters are from
     * @param  index       - The index in the token of the char
     * @param  breakWords - The style attr break words
     * @return whether to break word or not
     */ TextMetrics.canBreakChars = function(_char, _nextChar, _token, _index, _breakWords) {
        return true;
    };
    /**
     * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
     *
     * It is called when a token (usually a word) has to be split into separate pieces
     * in order to determine the point to break a word.
     * It must return an array of characters.
     *
     * @example
     * // Correctly splits emojis, eg "🤪🤪" will result in two element array, each with one emoji.
     * TextMetrics.wordWrapSplit = (token) => [...token];
     *
     * @param  token - The token to split
     * @return The characters of the token
     */ TextMetrics.wordWrapSplit = function(token) {
        return token.split('');
    };
    /**
     * Calculates the ascent, descent and fontSize of a given font-style
     *
     * @param font - String representing the style of the font
     * @return Font properties object
     */ TextMetrics.measureFont = function(font) {
        // as this method is used for preparing assets, don't recalculate things if we don't need to
        if (TextMetrics._fonts[font]) return TextMetrics._fonts[font];
        var properties = {
            ascent: 0,
            descent: 0,
            fontSize: 0
        };
        var canvas = TextMetrics._canvas;
        var context = TextMetrics._context;
        context.font = font;
        var metricsString = TextMetrics.METRICS_STRING + TextMetrics.BASELINE_SYMBOL;
        var width = Math.ceil(context.measureText(metricsString).width);
        var baseline = Math.ceil(context.measureText(TextMetrics.BASELINE_SYMBOL).width);
        var height = Math.ceil(TextMetrics.HEIGHT_MULTIPLIER * baseline);
        baseline = baseline * TextMetrics.BASELINE_MULTIPLIER | 0;
        canvas.width = width;
        canvas.height = height;
        context.fillStyle = '#f00';
        context.fillRect(0, 0, width, height);
        context.font = font;
        context.textBaseline = 'alphabetic';
        context.fillStyle = '#000';
        context.fillText(metricsString, 0, baseline);
        var imagedata = context.getImageData(0, 0, width, height).data;
        var pixels = imagedata.length;
        var line = width * 4;
        var i = 0;
        var idx = 0;
        var stop = false;
        // ascent. scan from top to bottom until we find a non red pixel
        for(i = 0; i < baseline; ++i){
            for(var j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                stop = true;
                break;
            }
            if (!stop) idx += line;
            else break;
        }
        properties.ascent = baseline - i;
        idx = pixels - line;
        stop = false;
        // descent. scan from bottom to top until we find a non red pixel
        for(i = height; i > baseline; --i){
            for(var j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                stop = true;
                break;
            }
            if (!stop) idx -= line;
            else break;
        }
        properties.descent = i - baseline;
        properties.fontSize = properties.ascent + properties.descent;
        TextMetrics._fonts[font] = properties;
        return properties;
    };
    /**
     * Clear font metrics in metrics cache.
     *
     * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
     */ TextMetrics.clearMetrics = function(font) {
        if (font === void 0) font = '';
        if (font) delete TextMetrics._fonts[font];
        else TextMetrics._fonts = {};
    };
    return TextMetrics;
}();
/**
 * Internal return object for {@link PIXI.TextMetrics.measureFont `TextMetrics.measureFont`}.
 *
 * @typedef {object} FontMetrics
 * @property {number} ascent - The ascent distance
 * @property {number} descent - The descent distance
 * @property {number} fontSize - Font size from ascent to descent
 * @memberof PIXI.TextMetrics
 * @private
 */ var $7276f35895ff141a$var$canvas = function() {
    try {
        // OffscreenCanvas2D measureText can be up to 40% faster.
        var c = new OffscreenCanvas(0, 0);
        var context = c.getContext('2d');
        if (context && context.measureText) return c;
        return document.createElement('canvas');
    } catch (ex) {
        return document.createElement('canvas');
    }
}();
$7276f35895ff141a$var$canvas.width = $7276f35895ff141a$var$canvas.height = 10;
/**
 * Cached canvas element for measuring text
 *
 * @memberof PIXI.TextMetrics
 * @type {HTMLCanvasElement}
 * @private
 */ $7276f35895ff141a$export$4c5a129a59e1ef34._canvas = $7276f35895ff141a$var$canvas;
/**
 * Cache for context to use.
 *
 * @memberof PIXI.TextMetrics
 * @type {CanvasRenderingContext2D}
 * @private
 */ $7276f35895ff141a$export$4c5a129a59e1ef34._context = $7276f35895ff141a$var$canvas.getContext('2d');
/**
 * Cache of {@see PIXI.TextMetrics.FontMetrics} objects.
 *
 * @memberof PIXI.TextMetrics
 * @type {Object}
 * @private
 */ $7276f35895ff141a$export$4c5a129a59e1ef34._fonts = {};
/**
 * String used for calculate font metrics.
 * These characters are all tall to help calculate the height required for text.
 *
 * @static
 * @memberof PIXI.TextMetrics
 * @name METRICS_STRING
 * @type {string}
 * @default |ÉqÅ
 */ $7276f35895ff141a$export$4c5a129a59e1ef34.METRICS_STRING = "|\xc9q\xc5";
/**
 * Baseline symbol for calculate font metrics.
 *
 * @static
 * @memberof PIXI.TextMetrics
 * @name BASELINE_SYMBOL
 * @type {string}
 * @default M
 */ $7276f35895ff141a$export$4c5a129a59e1ef34.BASELINE_SYMBOL = 'M';
/**
 * Baseline multiplier for calculate font metrics.
 *
 * @static
 * @memberof PIXI.TextMetrics
 * @name BASELINE_MULTIPLIER
 * @type {number}
 * @default 1.4
 */ $7276f35895ff141a$export$4c5a129a59e1ef34.BASELINE_MULTIPLIER = 1.4;
/**
 * Height multiplier for setting height of canvas to calculate font metrics.
 *
 * @static
 * @memberof PIXI.TextMetrics
 * @name HEIGHT_MULTIPLIER
 * @type {number}
 * @default 2.00
 */ $7276f35895ff141a$export$4c5a129a59e1ef34.HEIGHT_MULTIPLIER = 2.0;
/**
 * Cache of new line chars.
 *
 * @memberof PIXI.TextMetrics
 * @type {number[]}
 * @private
 */ $7276f35895ff141a$export$4c5a129a59e1ef34._newlines = [
    0x000A,
    0x000D
];
/**
 * Cache of breaking spaces.
 *
 * @memberof PIXI.TextMetrics
 * @type {number[]}
 * @private
 */ $7276f35895ff141a$export$4c5a129a59e1ef34._breakingSpaces = [
    0x0009,
    0x0020,
    0x2000,
    0x2001,
    0x2002,
    0x2003,
    0x2004,
    0x2005,
    0x2006,
    0x2008,
    0x2009,
    0x200A,
    0x205F,
    0x3000
];
/**
 * A number, or a string containing a number.
 *
 * @memberof PIXI
 * @typedef {object} IFontMetrics
 * @property {number} ascent - Font ascent
 * @property {number} descent - Font descent
 * @property {number} fontSize - Font size
 */ var $7276f35895ff141a$var$defaultDestroyOptions = {
    texture: true,
    children: false,
    baseTexture: true
};
/**
 * A Text Object will create a line or multiple lines of text.
 *
 * The text is created using the [Canvas API](https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API).
 *
 * The primary advantage of this class over BitmapText is that you have great control over the style of the text,
 * which you can change at runtime.
 *
 * The primary disadvantages is that each piece of text has it's own texture, which can use more memory.
 * When text changes, this texture has to be re-generated and re-uploaded to the GPU, taking up time.
 *
 * To split a line you can use '\n' in your text string, or, on the `style` object,
 * change its `wordWrap` property to true and and give the `wordWrapWidth` property a value.
 *
 * A Text can be created directly from a string and a style object,
 * which can be generated [here](https://pixijs.io/pixi-text-style).
 *
 * ```js
 * let text = new PIXI.Text('This is a PixiJS text',{fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'});
 * ```
 *
 * @memberof PIXI
 */ var $7276f35895ff141a$export$5f1af8db9871e1d6 = /** @class */ function(_super) {
    $7276f35895ff141a$var$__extends(Text, _super);
    /**
     * @param text - The string that you would like the text to display
     * @param {object|PIXI.TextStyle} [style] - The style parameters
     * @param canvas - The canvas element for drawing text
     */ function Text(text, style, canvas) {
        var _this = this;
        var ownCanvas = false;
        if (!canvas) {
            canvas = document.createElement('canvas');
            ownCanvas = true;
        }
        canvas.width = 3;
        canvas.height = 3;
        var texture = (0, $klOfb.Texture).from(canvas);
        texture.orig = new (0, $6qzqq.Rectangle)();
        texture.trim = new (0, $6qzqq.Rectangle)();
        _this = _super.call(this, texture) || this;
        _this._ownCanvas = ownCanvas;
        _this.canvas = canvas;
        _this.context = _this.canvas.getContext('2d');
        _this._resolution = (0, $ezJmd.settings).RESOLUTION;
        _this._autoResolution = true;
        _this._text = null;
        _this._style = null;
        _this._styleListener = null;
        _this._font = '';
        _this.text = text;
        _this.style = style;
        _this.localStyleID = -1;
        return _this;
    }
    /**
     * Renders text to its canvas, and updates its texture.
     *
     * By default this is used internally to ensure the texture is correct before rendering,
     * but it can be used called externally, for example from this class to 'pre-generate' the texture from a piece of text,
     * and then shared across multiple Sprites.
     *
     * @param respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
     */ Text.prototype.updateText = function(respectDirty) {
        var style = this._style;
        // check if style has changed..
        if (this.localStyleID !== style.styleID) {
            this.dirty = true;
            this.localStyleID = style.styleID;
        }
        if (!this.dirty && respectDirty) return;
        this._font = this._style.toFontString();
        var context = this.context;
        var measured = $7276f35895ff141a$export$4c5a129a59e1ef34.measureText(this._text || ' ', this._style, this._style.wordWrap, this.canvas);
        var width = measured.width;
        var height = measured.height;
        var lines = measured.lines;
        var lineHeight = measured.lineHeight;
        var lineWidths = measured.lineWidths;
        var maxLineWidth = measured.maxLineWidth;
        var fontProperties = measured.fontProperties;
        this.canvas.width = Math.ceil(Math.ceil(Math.max(1, width) + style.padding * 2) * this._resolution);
        this.canvas.height = Math.ceil(Math.ceil(Math.max(1, height) + style.padding * 2) * this._resolution);
        context.scale(this._resolution, this._resolution);
        context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        context.font = this._font;
        context.lineWidth = style.strokeThickness;
        context.textBaseline = style.textBaseline;
        context.lineJoin = style.lineJoin;
        context.miterLimit = style.miterLimit;
        var linePositionX;
        var linePositionY;
        // require 2 passes if a shadow; the first to draw the drop shadow, the second to draw the text
        var passesCount = style.dropShadow ? 2 : 1;
        // For v4, we drew text at the colours of the drop shadow underneath the normal text. This gave the correct zIndex,
        // but features such as alpha and shadowblur did not look right at all, since we were using actual text as a shadow.
        //
        // For v5.0.0, we moved over to just use the canvas API for drop shadows, which made them look much nicer and more
        // visually please, but now because the stroke is drawn and then the fill, drop shadows would appear on both the fill
        // and the stroke; and fill drop shadows would appear over the top of the stroke.
        //
        // For v5.1.1, the new route is to revert to v4 style of drawing text first to get the drop shadows underneath normal
        // text, but instead drawing text in the correct location, we'll draw it off screen (-paddingY), and then adjust the
        // drop shadow so only that appears on screen (+paddingY). Now we'll have the correct draw order of the shadow
        // beneath the text, whilst also having the proper text shadow styling.
        for(var i = 0; i < passesCount; ++i){
            var isShadowPass = style.dropShadow && i === 0;
            // we only want the drop shadow, so put text way off-screen
            var dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + style.padding * 2) : 0;
            var dsOffsetShadow = dsOffsetText * this._resolution;
            if (isShadowPass) {
                // On Safari, text with gradient and drop shadows together do not position correctly
                // if the scale of the canvas is not 1: https://bugs.webkit.org/show_bug.cgi?id=197689
                // Therefore we'll set the styles to be a plain black whilst generating this drop shadow
                context.fillStyle = 'black';
                context.strokeStyle = 'black';
                var dropShadowColor = style.dropShadowColor;
                var rgb = (0, $csytw.hex2rgb)(typeof dropShadowColor === 'number' ? dropShadowColor : (0, $csytw.string2hex)(dropShadowColor));
                var dropShadowBlur = style.dropShadowBlur * this._resolution;
                var dropShadowDistance = style.dropShadowDistance * this._resolution;
                context.shadowColor = "rgba(" + rgb[0] * 255 + "," + rgb[1] * 255 + "," + rgb[2] * 255 + "," + style.dropShadowAlpha + ")";
                context.shadowBlur = dropShadowBlur;
                context.shadowOffsetX = Math.cos(style.dropShadowAngle) * dropShadowDistance;
                context.shadowOffsetY = Math.sin(style.dropShadowAngle) * dropShadowDistance + dsOffsetShadow;
            } else {
                // set canvas text styles
                context.fillStyle = this._generateFillStyle(style, lines, measured);
                // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
                //       the setter converts to string. See this thread for more details:
                //       https://github.com/microsoft/TypeScript/issues/2521
                context.strokeStyle = style.stroke;
                context.shadowColor = 'black';
                context.shadowBlur = 0;
                context.shadowOffsetX = 0;
                context.shadowOffsetY = 0;
            }
            var linePositionYShift = (lineHeight - fontProperties.fontSize) / 2;
            if (!Text.nextLineHeightBehavior || lineHeight - fontProperties.fontSize < 0) linePositionYShift = 0;
            // draw lines line by line
            for(var i_1 = 0; i_1 < lines.length; i_1++){
                linePositionX = style.strokeThickness / 2;
                linePositionY = style.strokeThickness / 2 + i_1 * lineHeight + fontProperties.ascent + linePositionYShift;
                if (style.align === 'right') linePositionX += maxLineWidth - lineWidths[i_1];
                else if (style.align === 'center') linePositionX += (maxLineWidth - lineWidths[i_1]) / 2;
                if (style.stroke && style.strokeThickness) this.drawLetterSpacing(lines[i_1], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText, true);
                if (style.fill) this.drawLetterSpacing(lines[i_1], linePositionX + style.padding, linePositionY + style.padding - dsOffsetText);
            }
        }
        this.updateTexture();
    };
    /**
     * Render the text with letter-spacing.
     *
     * @param text - The text to draw
     * @param x - Horizontal position to draw the text
     * @param y - Vertical position to draw the text
     * @param isStroke - Is this drawing for the outside stroke of the
     *  text? If not, it's for the inside fill
     */ Text.prototype.drawLetterSpacing = function(text, x, y, isStroke) {
        if (isStroke === void 0) isStroke = false;
        var style = this._style;
        // letterSpacing of 0 means normal
        var letterSpacing = style.letterSpacing;
        // Checking that we can use moddern canvas2D api
        // https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
        // note: this is unstable API, Chrome less 94 use a `textLetterSpacing`, newest use a letterSpacing
        // eslint-disable-next-line max-len
        var supportLetterSpacing = 'letterSpacing' in CanvasRenderingContext2D.prototype || 'textLetterSpacing' in CanvasRenderingContext2D.prototype;
        if (letterSpacing === 0 || supportLetterSpacing) {
            if (supportLetterSpacing) {
                this.context.letterSpacing = letterSpacing;
                this.context.textLetterSpacing = letterSpacing;
            }
            if (isStroke) this.context.strokeText(text, x, y);
            else this.context.fillText(text, x, y);
            return;
        }
        var currentPosition = x;
        // Using Array.from correctly splits characters whilst keeping emoji together.
        // This is not supported on IE as it requires ES6, so regular text splitting occurs.
        // This also doesn't account for emoji that are multiple emoji put together to make something else.
        // Handling all of this would require a big library itself.
        // https://medium.com/@giltayar/iterating-over-emoji-characters-the-es6-way-f06e4589516
        // https://github.com/orling/grapheme-splitter
        var stringArray = Array.from ? Array.from(text) : text.split('');
        var previousWidth = this.context.measureText(text).width;
        var currentWidth = 0;
        for(var i = 0; i < stringArray.length; ++i){
            var currentChar = stringArray[i];
            if (isStroke) this.context.strokeText(currentChar, currentPosition, y);
            else this.context.fillText(currentChar, currentPosition, y);
            var textStr = '';
            for(var j = i + 1; j < stringArray.length; ++j)textStr += stringArray[j];
            currentWidth = this.context.measureText(textStr).width;
            currentPosition += previousWidth - currentWidth + letterSpacing;
            previousWidth = currentWidth;
        }
    };
    /** Updates texture size based on canvas size. */ Text.prototype.updateTexture = function() {
        var canvas = this.canvas;
        if (this._style.trim) {
            var trimmed = (0, $csytw.trimCanvas)(canvas);
            if (trimmed.data) {
                canvas.width = trimmed.width;
                canvas.height = trimmed.height;
                this.context.putImageData(trimmed.data, 0, 0);
            }
        }
        var texture = this._texture;
        var style = this._style;
        var padding = style.trim ? 0 : style.padding;
        var baseTexture = texture.baseTexture;
        texture.trim.width = texture._frame.width = canvas.width / this._resolution;
        texture.trim.height = texture._frame.height = canvas.height / this._resolution;
        texture.trim.x = -padding;
        texture.trim.y = -padding;
        texture.orig.width = texture._frame.width - padding * 2;
        texture.orig.height = texture._frame.height - padding * 2;
        // call sprite onTextureUpdate to update scale if _width or _height were set
        this._onTextureUpdate();
        baseTexture.setRealSize(canvas.width, canvas.height, this._resolution);
        texture.updateUvs();
        // Recursively updates transform of all objects from the root to this one
        this._recursivePostUpdateTransform();
        this.dirty = false;
    };
    /**
     * Renders the object using the WebGL renderer
     *
     * @param renderer - The renderer
     */ Text.prototype._render = function(renderer) {
        if (this._autoResolution && this._resolution !== renderer.resolution) {
            this._resolution = renderer.resolution;
            this.dirty = true;
        }
        this.updateText(true);
        _super.prototype._render.call(this, renderer);
    };
    /**
     * Gets the local bounds of the text object.
     *
     * @param rect - The output rectangle.
     * @return The bounds.
     */ Text.prototype.getLocalBounds = function(rect) {
        this.updateText(true);
        return _super.prototype.getLocalBounds.call(this, rect);
    };
    /** Calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account. */ Text.prototype._calculateBounds = function() {
        this.updateText(true);
        this.calculateVertices();
        // if we have already done this on THIS frame.
        this._bounds.addQuad(this.vertexData);
    };
    /**
     * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
     *
     * @param style - The style.
     * @param lines - The lines of text.
     * @return The fill style
     */ Text.prototype._generateFillStyle = function(style, lines, metrics) {
        // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
        //       the setter converts to string. See this thread for more details:
        //       https://github.com/microsoft/TypeScript/issues/2521
        var fillStyle = style.fill;
        if (!Array.isArray(fillStyle)) return fillStyle;
        else if (fillStyle.length === 1) return fillStyle[0];
        // the gradient will be evenly spaced out according to how large the array is.
        // ['#FF0000', '#00FF00', '#0000FF'] would created stops at 0.25, 0.5 and 0.75
        var gradient;
        // a dropshadow will enlarge the canvas and result in the gradient being
        // generated with the incorrect dimensions
        var dropShadowCorrection = style.dropShadow ? style.dropShadowDistance : 0;
        // should also take padding into account, padding can offset the gradient
        var padding = style.padding || 0;
        var width = this.canvas.width / this._resolution - dropShadowCorrection - padding * 2;
        var height = this.canvas.height / this._resolution - dropShadowCorrection - padding * 2;
        // make a copy of the style settings, so we can manipulate them later
        var fill = fillStyle.slice();
        var fillGradientStops = style.fillGradientStops.slice();
        // wanting to evenly distribute the fills. So an array of 4 colours should give fills of 0.25, 0.5 and 0.75
        if (!fillGradientStops.length) {
            var lengthPlus1 = fill.length + 1;
            for(var i = 1; i < lengthPlus1; ++i)fillGradientStops.push(i / lengthPlus1);
        }
        // stop the bleeding of the last gradient on the line above to the top gradient of the this line
        // by hard defining the first gradient colour at point 0, and last gradient colour at point 1
        fill.unshift(fillStyle[0]);
        fillGradientStops.unshift(0);
        fill.push(fillStyle[fillStyle.length - 1]);
        fillGradientStops.push(1);
        if (style.fillGradientType === $7276f35895ff141a$export$131daa784848984.LINEAR_VERTICAL) {
            // start the gradient at the top center of the canvas, and end at the bottom middle of the canvas
            gradient = this.context.createLinearGradient(width / 2, padding, width / 2, height + padding);
            // we need to repeat the gradient so that each individual line of text has the same vertical gradient effect
            // ['#FF0000', '#00FF00', '#0000FF'] over 2 lines would create stops at 0.125, 0.25, 0.375, 0.625, 0.75, 0.875
            // Actual height of the text itself, not counting spacing for lineHeight/leading/dropShadow etc
            var textHeight = metrics.fontProperties.fontSize + style.strokeThickness;
            for(var i = 0; i < lines.length; i++){
                var lastLineBottom = metrics.lineHeight * (i - 1) + textHeight;
                var thisLineTop = metrics.lineHeight * i;
                var thisLineGradientStart = thisLineTop;
                // Handle case where last & this line overlap
                if (i > 0 && lastLineBottom > thisLineTop) thisLineGradientStart = (thisLineTop + lastLineBottom) / 2;
                var thisLineBottom = thisLineTop + textHeight;
                var nextLineTop = metrics.lineHeight * (i + 1);
                var thisLineGradientEnd = thisLineBottom;
                // Handle case where this & next line overlap
                if (i + 1 < lines.length && nextLineTop < thisLineBottom) thisLineGradientEnd = (thisLineBottom + nextLineTop) / 2;
                // textHeight, but as a 0-1 size in global gradient stop space
                var gradStopLineHeight = (thisLineGradientEnd - thisLineGradientStart) / height;
                for(var j = 0; j < fill.length; j++){
                    // 0-1 stop point for the current line, multiplied to global space afterwards
                    var lineStop = 0;
                    if (typeof fillGradientStops[j] === 'number') lineStop = fillGradientStops[j];
                    else lineStop = j / fill.length;
                    var globalStop = Math.min(1, Math.max(0, thisLineGradientStart / height + lineStop * gradStopLineHeight));
                    // There's potential for floating point precision issues at the seams between gradient repeats.
                    globalStop = Number(globalStop.toFixed(5));
                    gradient.addColorStop(globalStop, fill[j]);
                }
            }
        } else {
            // start the gradient at the center left of the canvas, and end at the center right of the canvas
            gradient = this.context.createLinearGradient(padding, height / 2, width + padding, height / 2);
            // can just evenly space out the gradients in this case, as multiple lines makes no difference
            // to an even left to right gradient
            var totalIterations = fill.length + 1;
            var currentIteration = 1;
            for(var i = 0; i < fill.length; i++){
                var stop = void 0;
                if (typeof fillGradientStops[i] === 'number') stop = fillGradientStops[i];
                else stop = currentIteration / totalIterations;
                gradient.addColorStop(stop, fill[i]);
                currentIteration++;
            }
        }
        return gradient;
    };
    /**
     * Destroys this text object.
     *
     * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
     * the majority of the time the texture will not be shared with any other Sprites.
     *
     * @param options - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their
     *  destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
     * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
     */ Text.prototype.destroy = function(options) {
        if (typeof options === 'boolean') options = {
            children: options
        };
        options = Object.assign({}, $7276f35895ff141a$var$defaultDestroyOptions, options);
        _super.prototype.destroy.call(this, options);
        // set canvas width and height to 0 to workaround memory leak in Safari < 13
        // https://stackoverflow.com/questions/52532614/total-canvas-memory-use-exceeds-the-maximum-limit-safari-12
        if (this._ownCanvas) this.canvas.height = this.canvas.width = 0;
        // make sure to reset the the context and canvas.. dont want this hanging around in memory!
        this.context = null;
        this.canvas = null;
        this._style = null;
    };
    Object.defineProperty(Text.prototype, "width", {
        /** The width of the Text, setting this will actually modify the scale to achieve the value set. */ get: function() {
            this.updateText(true);
            return Math.abs(this.scale.x) * this._texture.orig.width;
        },
        set: function(value) {
            this.updateText(true);
            var s = (0, $csytw.sign)(this.scale.x) || 1;
            this.scale.x = s * value / this._texture.orig.width;
            this._width = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Text.prototype, "height", {
        /** The height of the Text, setting this will actually modify the scale to achieve the value set. */ get: function() {
            this.updateText(true);
            return Math.abs(this.scale.y) * this._texture.orig.height;
        },
        set: function(value) {
            this.updateText(true);
            var s = (0, $csytw.sign)(this.scale.y) || 1;
            this.scale.y = s * value / this._texture.orig.height;
            this._height = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Text.prototype, "style", {
        /**
         * Set the style of the text.
         *
         * Set up an event listener to listen for changes on the style object and mark the text as dirty.
         */ get: function() {
            // TODO: Can't have different types for getter and setter. The getter shouldn't have the ITextStyle
            //       since the setter creates the TextStyle. See this thread for more details:
            //       https://github.com/microsoft/TypeScript/issues/2521
            return this._style;
        },
        set: function(style) {
            style = style || {};
            if (style instanceof $7276f35895ff141a$export$1df879243bf2e42d) this._style = style;
            else this._style = new $7276f35895ff141a$export$1df879243bf2e42d(style);
            this.localStyleID = -1;
            this.dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Text.prototype, "text", {
        /** Set the copy for the text object. To split a line you can use '\n'. */ get: function() {
            return this._text;
        },
        set: function(text) {
            text = String(text === null || text === undefined ? '' : text);
            if (this._text === text) return;
            this._text = text;
            this.dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Text.prototype, "resolution", {
        /**
         * The resolution / device pixel ratio of the canvas.
         *
         * This is set to automatically match the renderer resolution by default, but can be overridden by setting manually.
         *
         * @default 1
         */ get: function() {
            return this._resolution;
        },
        set: function(value) {
            this._autoResolution = false;
            if (this._resolution === value) return;
            this._resolution = value;
            this.dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * New behavior for `lineHeight` that's meant to mimic HTML text. A value of `true` will
     * make sure the first baseline is offset by the `lineHeight` value if it is greater than `fontSize`.
     * A value of `false` will use the legacy behavior and not change the baseline of the first line.
     * In the next major release, we'll enable this by default.
     */ Text.nextLineHeightBehavior = false;
    return Text;
}((0, $7Bs2Z.Sprite));

});
parcelRegister("7Bs2Z", function(module, exports) {

$parcel$export(module.exports, "Sprite", function () { return $5891beb64fa1f02f$export$3075603db8e6204c; });
/*!
 * @pixi/sprite - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/sprite is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $P8XPi = parcelRequire("P8XPi");

var $klOfb = parcelRequire("klOfb");

var $8t5Gy = parcelRequire("8t5Gy");

var $6qzqq = parcelRequire("6qzqq");

var $ezJmd = parcelRequire("ezJmd");

var $csytw = parcelRequire("csytw");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $5891beb64fa1f02f$var$extendStatics = function(d, b) {
    $5891beb64fa1f02f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $5891beb64fa1f02f$var$extendStatics(d, b);
};
function $5891beb64fa1f02f$var$__extends(d, b) {
    $5891beb64fa1f02f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5891beb64fa1f02f$var$tempPoint = new (0, $6qzqq.Point)();
var $5891beb64fa1f02f$var$indices = new Uint16Array([
    0,
    1,
    2,
    0,
    2,
    3
]);
/**
 * The Sprite object is the base for all textured objects that are rendered to the screen
*
 * A sprite can be created directly from an image like this:
 *
 * ```js
 * let sprite = PIXI.Sprite.from('assets/image.png');
 * ```
 *
 * The more efficient way to create sprites is using a {@link PIXI.Spritesheet},
 * as swapping base textures when rendering to the screen is inefficient.
 *
 * ```js
 * PIXI.Loader.shared.add("assets/spritesheet.json").load(setup);
 *
 * function setup() {
 *   let sheet = PIXI.Loader.shared.resources["assets/spritesheet.json"].spritesheet;
 *   let sprite = new PIXI.Sprite(sheet.textures["image.png"]);
 *   ...
 * }
 * ```
 *
 * @memberof PIXI
 */ var $5891beb64fa1f02f$export$3075603db8e6204c = /** @class */ function(_super) {
    $5891beb64fa1f02f$var$__extends(Sprite, _super);
    /** @param texture - The texture for this sprite. */ function Sprite(texture) {
        var _this = _super.call(this) || this;
        _this._anchor = new (0, $6qzqq.ObservablePoint)(_this._onAnchorUpdate, _this, texture ? texture.defaultAnchor.x : 0, texture ? texture.defaultAnchor.y : 0);
        _this._texture = null;
        _this._width = 0;
        _this._height = 0;
        _this._tint = null;
        _this._tintRGB = null;
        _this.tint = 0xFFFFFF;
        _this.blendMode = (0, $P8XPi.BLEND_MODES).NORMAL;
        _this._cachedTint = 0xFFFFFF;
        _this.uvs = null;
        // call texture setter
        _this.texture = texture || (0, $klOfb.Texture).EMPTY;
        _this.vertexData = new Float32Array(8);
        _this.vertexTrimmedData = null;
        _this._transformID = -1;
        _this._textureID = -1;
        _this._transformTrimmedID = -1;
        _this._textureTrimmedID = -1;
        // Batchable stuff..
        // TODO could make this a mixin?
        _this.indices = $5891beb64fa1f02f$var$indices;
        _this.pluginName = 'batch';
        /**
         * Used to fast check if a sprite is.. a sprite!
         * @member {boolean}
         */ _this.isSprite = true;
        _this._roundPixels = (0, $ezJmd.settings).ROUND_PIXELS;
        return _this;
    }
    /** When the texture is updated, this event will fire to update the scale and frame. */ Sprite.prototype._onTextureUpdate = function() {
        this._textureID = -1;
        this._textureTrimmedID = -1;
        this._cachedTint = 0xFFFFFF;
        // so if _width is 0 then width was not set..
        if (this._width) this.scale.x = (0, $csytw.sign)(this.scale.x) * this._width / this._texture.orig.width;
        if (this._height) this.scale.y = (0, $csytw.sign)(this.scale.y) * this._height / this._texture.orig.height;
    };
    /** Called when the anchor position updates. */ Sprite.prototype._onAnchorUpdate = function() {
        this._transformID = -1;
        this._transformTrimmedID = -1;
    };
    /** Calculates worldTransform * vertices, store it in vertexData. */ Sprite.prototype.calculateVertices = function() {
        var texture = this._texture;
        if (this._transformID === this.transform._worldID && this._textureID === texture._updateID) return;
        // update texture UV here, because base texture can be changed without calling `_onTextureUpdate`
        if (this._textureID !== texture._updateID) this.uvs = this._texture._uvs.uvsFloat32;
        this._transformID = this.transform._worldID;
        this._textureID = texture._updateID;
        // set the vertex data
        var wt = this.transform.worldTransform;
        var a = wt.a;
        var b = wt.b;
        var c = wt.c;
        var d = wt.d;
        var tx = wt.tx;
        var ty = wt.ty;
        var vertexData = this.vertexData;
        var trim = texture.trim;
        var orig = texture.orig;
        var anchor = this._anchor;
        var w0 = 0;
        var w1 = 0;
        var h0 = 0;
        var h1 = 0;
        if (trim) {
            // if the sprite is trimmed and is not a tilingsprite then we need to add the extra
            // space before transforming the sprite coords.
            w1 = trim.x - anchor._x * orig.width;
            w0 = w1 + trim.width;
            h1 = trim.y - anchor._y * orig.height;
            h0 = h1 + trim.height;
        } else {
            w1 = -anchor._x * orig.width;
            w0 = w1 + orig.width;
            h1 = -anchor._y * orig.height;
            h0 = h1 + orig.height;
        }
        // xy
        vertexData[0] = a * w1 + c * h1 + tx;
        vertexData[1] = d * h1 + b * w1 + ty;
        // xy
        vertexData[2] = a * w0 + c * h1 + tx;
        vertexData[3] = d * h1 + b * w0 + ty;
        // xy
        vertexData[4] = a * w0 + c * h0 + tx;
        vertexData[5] = d * h0 + b * w0 + ty;
        // xy
        vertexData[6] = a * w1 + c * h0 + tx;
        vertexData[7] = d * h0 + b * w1 + ty;
        if (this._roundPixels) {
            var resolution = (0, $ezJmd.settings).RESOLUTION;
            for(var i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round((vertexData[i] * resolution | 0) / resolution);
        }
    };
    /**
     * Calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData.
     *
     * This is used to ensure that the true width and height of a trimmed texture is respected.
     */ Sprite.prototype.calculateTrimmedVertices = function() {
        if (!this.vertexTrimmedData) this.vertexTrimmedData = new Float32Array(8);
        else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID) return;
        this._transformTrimmedID = this.transform._worldID;
        this._textureTrimmedID = this._texture._updateID;
        // lets do some special trim code!
        var texture = this._texture;
        var vertexData = this.vertexTrimmedData;
        var orig = texture.orig;
        var anchor = this._anchor;
        // lets calculate the new untrimmed bounds..
        var wt = this.transform.worldTransform;
        var a = wt.a;
        var b = wt.b;
        var c = wt.c;
        var d = wt.d;
        var tx = wt.tx;
        var ty = wt.ty;
        var w1 = -anchor._x * orig.width;
        var w0 = w1 + orig.width;
        var h1 = -anchor._y * orig.height;
        var h0 = h1 + orig.height;
        // xy
        vertexData[0] = a * w1 + c * h1 + tx;
        vertexData[1] = d * h1 + b * w1 + ty;
        // xy
        vertexData[2] = a * w0 + c * h1 + tx;
        vertexData[3] = d * h1 + b * w0 + ty;
        // xy
        vertexData[4] = a * w0 + c * h0 + tx;
        vertexData[5] = d * h0 + b * w0 + ty;
        // xy
        vertexData[6] = a * w1 + c * h0 + tx;
        vertexData[7] = d * h0 + b * w1 + ty;
    };
    /**
     *
     * Renders the object using the WebGL renderer
     *
     * @param renderer - The webgl renderer to use.
     */ Sprite.prototype._render = function(renderer) {
        this.calculateVertices();
        renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]);
        renderer.plugins[this.pluginName].render(this);
    };
    /** Updates the bounds of the sprite. */ Sprite.prototype._calculateBounds = function() {
        var trim = this._texture.trim;
        var orig = this._texture.orig;
        // First lets check to see if the current texture has a trim..
        if (!trim || trim.width === orig.width && trim.height === orig.height) {
            // no trim! lets use the usual calculations..
            this.calculateVertices();
            this._bounds.addQuad(this.vertexData);
        } else {
            // lets calculate a special trimmed bounds...
            this.calculateTrimmedVertices();
            this._bounds.addQuad(this.vertexTrimmedData);
        }
    };
    /**
     * Gets the local bounds of the sprite object.
     *
     * @param rect - Optional output rectangle.
     * @return The bounds.
     */ Sprite.prototype.getLocalBounds = function(rect) {
        // we can do a fast local bounds if the sprite has no children!
        if (this.children.length === 0) {
            if (!this._localBounds) this._localBounds = new (0, $8t5Gy.Bounds)();
            this._localBounds.minX = this._texture.orig.width * -this._anchor._x;
            this._localBounds.minY = this._texture.orig.height * -this._anchor._y;
            this._localBounds.maxX = this._texture.orig.width * (1 - this._anchor._x);
            this._localBounds.maxY = this._texture.orig.height * (1 - this._anchor._y);
            if (!rect) {
                if (!this._localBoundsRect) this._localBoundsRect = new (0, $6qzqq.Rectangle)();
                rect = this._localBoundsRect;
            }
            return this._localBounds.getRectangle(rect);
        }
        return _super.prototype.getLocalBounds.call(this, rect);
    };
    /**
     * Tests if a point is inside this sprite
     *
     * @param point - the point to test
     * @return The result of the test
     */ Sprite.prototype.containsPoint = function(point) {
        this.worldTransform.applyInverse(point, $5891beb64fa1f02f$var$tempPoint);
        var width = this._texture.orig.width;
        var height = this._texture.orig.height;
        var x1 = -width * this.anchor.x;
        var y1 = 0;
        if ($5891beb64fa1f02f$var$tempPoint.x >= x1 && $5891beb64fa1f02f$var$tempPoint.x < x1 + width) {
            y1 = -height * this.anchor.y;
            if ($5891beb64fa1f02f$var$tempPoint.y >= y1 && $5891beb64fa1f02f$var$tempPoint.y < y1 + height) return true;
        }
        return false;
    };
    /**
     * Destroys this sprite and optionally its texture and children.
     *
     * @param options - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param [options.children=false] - if set to true, all the children will have their destroy
     *      method called as well. 'options' will be passed on to those calls.
     * @param [options.texture=false] - Should it destroy the current texture of the sprite as well
     * @param [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
     */ Sprite.prototype.destroy = function(options) {
        _super.prototype.destroy.call(this, options);
        this._texture.off('update', this._onTextureUpdate, this);
        this._anchor = null;
        var destroyTexture = typeof options === 'boolean' ? options : options && options.texture;
        if (destroyTexture) {
            var destroyBaseTexture = typeof options === 'boolean' ? options : options && options.baseTexture;
            this._texture.destroy(!!destroyBaseTexture);
        }
        this._texture = null;
    };
    // some helper functions..
    /**
     * Helper function that creates a new sprite based on the source you provide.
     * The source can be - frame id, image url, video url, canvas element, video element, base texture
     *
     * @param {string|PIXI.Texture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
     * @param {object} [options] - See {@link PIXI.BaseTexture}'s constructor for options.
     * @return The newly created sprite
     */ Sprite.from = function(source, options) {
        var texture = source instanceof (0, $klOfb.Texture) ? source : (0, $klOfb.Texture).from(source, options);
        return new Sprite(texture);
    };
    Object.defineProperty(Sprite.prototype, "roundPixels", {
        get: function() {
            return this._roundPixels;
        },
        /**
         * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
         *
         * Advantages can include sharper image quality (like text) and faster rendering on canvas.
         * The main disadvantage is movement of objects may appear less smooth.
         *
         * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}.
         *
         * @default false
         */ set: function(value) {
            if (this._roundPixels !== value) this._transformID = -1;
            this._roundPixels = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sprite.prototype, "width", {
        /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get: function() {
            return Math.abs(this.scale.x) * this._texture.orig.width;
        },
        set: function(value) {
            var s = (0, $csytw.sign)(this.scale.x) || 1;
            this.scale.x = s * value / this._texture.orig.width;
            this._width = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sprite.prototype, "height", {
        /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */ get: function() {
            return Math.abs(this.scale.y) * this._texture.orig.height;
        },
        set: function(value) {
            var s = (0, $csytw.sign)(this.scale.y) || 1;
            this.scale.y = s * value / this._texture.orig.height;
            this._height = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sprite.prototype, "anchor", {
        /**
         * The anchor sets the origin point of the sprite. The default value is taken from the {@link PIXI.Texture|Texture}
         * and passed to the constructor.
         *
         * The default is `(0,0)`, this means the sprite's origin is the top left.
         *
         * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
         *
         * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
         *
         * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
         *
         * @example
         * const sprite = new PIXI.Sprite(texture);
         * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
         */ get: function() {
            return this._anchor;
        },
        set: function(value) {
            this._anchor.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sprite.prototype, "tint", {
        /**
         * The tint applied to the sprite. This is a hex value.
         *
         * A value of 0xFFFFFF will remove any tint effect.
         *
         * @default 0xFFFFFF
         */ get: function() {
            return this._tint;
        },
        set: function(value) {
            this._tint = value;
            this._tintRGB = (value >> 16) + (value & 0xff00) + ((value & 0xff) << 16);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sprite.prototype, "texture", {
        /** The texture that the sprite is using. */ get: function() {
            return this._texture;
        },
        set: function(value) {
            if (this._texture === value) return;
            if (this._texture) this._texture.off('update', this._onTextureUpdate, this);
            this._texture = value || (0, $klOfb.Texture).EMPTY;
            this._cachedTint = 0xFFFFFF;
            this._textureID = -1;
            this._textureTrimmedID = -1;
            if (value) {
                // wait for the texture to load
                if (value.baseTexture.valid) this._onTextureUpdate();
                else value.once('update', this._onTextureUpdate, this);
            }
        },
        enumerable: false,
        configurable: true
    });
    return Sprite;
}((0, $8t5Gy.Container));

});



parcelRegister("kfhEp", function(module, exports) {

$parcel$export(module.exports, "Spritesheet", function () { return $ebd2e674a11bdcf0$export$674d2eb4debbef0c; });
$parcel$export(module.exports, "SpritesheetLoader", function () { return $ebd2e674a11bdcf0$export$cef90d24aa5a3136; });
/*!
 * @pixi/spritesheet - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/spritesheet is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $6qzqq = parcelRequire("6qzqq");

var $klOfb = parcelRequire("klOfb");

var $csytw = parcelRequire("csytw");

var $kXE1p = parcelRequire("kXE1p");
/**
 * Utility class for maintaining reference to a collection
 * of Textures on a single Spritesheet.
 *
 * To access a sprite sheet from your code pass its JSON data file to Pixi's loader:
 *
 * ```js
 * PIXI.Loader.shared.add("images/spritesheet.json").load(setup);
 *
 * function setup() {
 *   let sheet = PIXI.Loader.shared.resources["images/spritesheet.json"].spritesheet;
 *   ...
 * }
 * ```
 * With the `sheet.textures` you can create Sprite objects,`sheet.animations` can be used to create an AnimatedSprite.
 *
 * Sprite sheets can be packed using tools like {@link https://codeandweb.com/texturepacker|TexturePacker},
 * {@link https://renderhjs.net/shoebox/|Shoebox} or {@link https://github.com/krzysztof-o/spritesheet.js|Spritesheet.js}.
 * Default anchor points (see {@link PIXI.Texture#defaultAnchor}) and grouping of animation sprites are currently only
 * supported by TexturePacker.
 *
 * @memberof PIXI
 */ var $ebd2e674a11bdcf0$export$674d2eb4debbef0c = /** @class */ function() {
    /**
     * @param baseTexture - Reference to the source BaseTexture object.
     * @param {Object} data - Spritesheet image data.
     * @param resolutionFilename - The filename to consider when determining
     *        the resolution of the spritesheet. If not provided, the imageUrl will
     *        be used on the BaseTexture.
     */ function Spritesheet(texture, data, resolutionFilename) {
        if (resolutionFilename === void 0) resolutionFilename = null;
        this._texture = texture instanceof (0, $klOfb.Texture) ? texture : null;
        this.baseTexture = texture instanceof (0, $klOfb.BaseTexture) ? texture : this._texture.baseTexture;
        this.textures = {};
        this.animations = {};
        this.data = data;
        var resource = this.baseTexture.resource;
        this.resolution = this._updateResolution(resolutionFilename || (resource ? resource.url : null));
        this._frames = this.data.frames;
        this._frameKeys = Object.keys(this._frames);
        this._batchIndex = 0;
        this._callback = null;
    }
    /**
     * Generate the resolution from the filename or fallback
     * to the meta.scale field of the JSON data.
     *
     * @param resolutionFilename - The filename to use for resolving
     *        the default resolution.
     * @return Resolution to use for spritesheet.
     */ Spritesheet.prototype._updateResolution = function(resolutionFilename) {
        if (resolutionFilename === void 0) resolutionFilename = null;
        var scale = this.data.meta.scale;
        // Use a defaultValue of `null` to check if a url-based resolution is set
        var resolution = (0, $csytw.getResolutionOfUrl)(resolutionFilename, null);
        // No resolution found via URL
        if (resolution === null) // Use the scale value or default to 1
        resolution = scale !== undefined ? parseFloat(scale) : 1;
        // For non-1 resolutions, update baseTexture
        if (resolution !== 1) this.baseTexture.setResolution(resolution);
        return resolution;
    };
    /**
     * Parser spritesheet from loaded data. This is done asynchronously
     * to prevent creating too many Texture within a single process.
     *
     * @param {Function} callback - Callback when complete returns
     *        a map of the Textures for this spritesheet.
     */ Spritesheet.prototype.parse = function(callback) {
        this._batchIndex = 0;
        this._callback = callback;
        if (this._frameKeys.length <= Spritesheet.BATCH_SIZE) {
            this._processFrames(0);
            this._processAnimations();
            this._parseComplete();
        } else this._nextBatch();
    };
    /**
     * Process a batch of frames
     *
     * @param initialFrameIndex - The index of frame to start.
     */ Spritesheet.prototype._processFrames = function(initialFrameIndex) {
        var frameIndex = initialFrameIndex;
        var maxFrames = Spritesheet.BATCH_SIZE;
        while(frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length){
            var i = this._frameKeys[frameIndex];
            var data = this._frames[i];
            var rect = data.frame;
            if (rect) {
                var frame = null;
                var trim = null;
                var sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
                var orig = new (0, $6qzqq.Rectangle)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                if (data.rotated) frame = new (0, $6qzqq.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution);
                else frame = new (0, $6qzqq.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                //  Check to see if the sprite is trimmed
                if (data.trimmed !== false && data.spriteSourceSize) trim = new (0, $6qzqq.Rectangle)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                this.textures[i] = new (0, $klOfb.Texture)(this.baseTexture, frame, orig, trim, data.rotated ? 2 : 0, data.anchor);
                // lets also add the frame to pixi's global cache for 'from' and 'fromLoader' functions
                (0, $klOfb.Texture).addToCache(this.textures[i], i);
            }
            frameIndex++;
        }
    };
    /** Parse animations config. */ Spritesheet.prototype._processAnimations = function() {
        var animations = this.data.animations || {};
        for(var animName in animations){
            this.animations[animName] = [];
            for(var i = 0; i < animations[animName].length; i++){
                var frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    };
    /** The parse has completed. */ Spritesheet.prototype._parseComplete = function() {
        var callback = this._callback;
        this._callback = null;
        this._batchIndex = 0;
        callback.call(this, this.textures);
    };
    /** Begin the next batch of textures. */ Spritesheet.prototype._nextBatch = function() {
        var _this = this;
        this._processFrames(this._batchIndex * Spritesheet.BATCH_SIZE);
        this._batchIndex++;
        setTimeout(function() {
            if (_this._batchIndex * Spritesheet.BATCH_SIZE < _this._frameKeys.length) _this._nextBatch();
            else {
                _this._processAnimations();
                _this._parseComplete();
            }
        }, 0);
    };
    /**
     * Destroy Spritesheet and don't use after this.
     *
     * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
     */ Spritesheet.prototype.destroy = function(destroyBase) {
        var _a;
        if (destroyBase === void 0) destroyBase = false;
        for(var i in this.textures)this.textures[i].destroy();
        this._frames = null;
        this._frameKeys = null;
        this.data = null;
        this.textures = null;
        if (destroyBase) {
            (_a = this._texture) === null || _a === void 0 || _a.destroy();
            this.baseTexture.destroy();
        }
        this._texture = null;
        this.baseTexture = null;
    };
    /** The maximum number of Textures to build per process. */ Spritesheet.BATCH_SIZE = 1000;
    return Spritesheet;
}();
/**
 * Reference to Spritesheet object created.
 * @member {PIXI.Spritesheet} spritesheet
 * @memberof PIXI.LoaderResource
 * @instance
 */ /**
 * Dictionary of textures from Spritesheet.
 * @member {object<string, PIXI.Texture>} textures
 * @memberof PIXI.LoaderResource
 * @instance
 */ /**
 * {@link PIXI.Loader} middleware for loading texture atlases that have been created with
 * TexturePacker or similar JSON-based spritesheet.
 *
 * This middleware automatically generates Texture resources.
 *
 * If you're using Webpack or other bundlers and plan on bundling the atlas' JSON,
 * use the {@link PIXI.Spritesheet} class to directly parse the JSON.
 *
 * The Loader's image Resource name is automatically appended with `"_image"`.
 * If a Resource with this name is already loaded, the Loader will skip parsing the
 * Spritesheet. The code below will generate an internal Loader Resource called `"myatlas_image"`.
 *
 * @example
 * loader.add('myatlas', 'path/to/myatlas.json');
 * loader.load(() => {
 *   loader.resources.myatlas; // atlas JSON resource
 *   loader.resources.myatlas_image; // atlas Image resource
 * });
 *
 * @memberof PIXI
 */ var $ebd2e674a11bdcf0$export$cef90d24aa5a3136 = /** @class */ function() {
    function SpritesheetLoader() {}
    /**
     * Called after a resource is loaded.
     *
     * @see PIXI.Loader.loaderMiddleware
     * @param resource
     * @param next
     */ SpritesheetLoader.use = function(resource, next) {
        var _a, _b;
        // because this is middleware, it execute in loader context. `this` = loader
        var loader = this;
        var imageResourceName = resource.name + "_image";
        // skip if no data, its not json, it isn't spritesheet data, or the image resource already exists
        if (!resource.data || resource.type !== (0, $kXE1p.LoaderResource).TYPE.JSON || !resource.data.frames || loader.resources[imageResourceName]) {
            next();
            return;
        }
        // Check and add the multi atlas
        // Heavily influenced and based on https://github.com/rocket-ua/pixi-tps-loader/blob/master/src/ResourceLoader.js
        // eslint-disable-next-line camelcase
        var multiPacks = (_b = (_a = resource.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.related_multi_packs;
        if (Array.isArray(multiPacks)) {
            var _loop_1 = function(item) {
                if (typeof item !== 'string') return "continue";
                var itemName = item.replace('.json', '');
                var itemUrl = (0, $csytw.url).resolve(resource.url.replace(loader.baseUrl, ''), item);
                // Check if the file wasn't already added as multipacks are redundant
                if (loader.resources[itemName] || Object.values(loader.resources).some(function(r) {
                    return (0, $csytw.url).format((0, $csytw.url).parse(r.url)) === itemUrl;
                })) return "continue";
                var options = {
                    crossOrigin: resource.crossOrigin,
                    loadType: (0, $kXE1p.LoaderResource).LOAD_TYPE.XHR,
                    xhrType: (0, $kXE1p.LoaderResource).XHR_RESPONSE_TYPE.JSON,
                    parentResource: resource,
                    metadata: resource.metadata
                };
                loader.add(itemName, itemUrl, options);
            };
            for(var _i = 0, multiPacks_1 = multiPacks; _i < multiPacks_1.length; _i++){
                var item = multiPacks_1[_i];
                _loop_1(item);
            }
        }
        var loadOptions = {
            crossOrigin: resource.crossOrigin,
            metadata: resource.metadata.imageMetadata,
            parentResource: resource
        };
        var resourcePath = SpritesheetLoader.getResourcePath(resource, loader.baseUrl);
        // load the image for this sheet
        loader.add(imageResourceName, resourcePath, loadOptions, function onImageLoad(res) {
            if (res.error) {
                next(res.error);
                return;
            }
            var spritesheet = new $ebd2e674a11bdcf0$export$674d2eb4debbef0c(res.texture, resource.data, resource.url);
            spritesheet.parse(function() {
                resource.spritesheet = spritesheet;
                resource.textures = spritesheet.textures;
                next();
            });
        });
    };
    /**
     * Get the spritesheets root path
     *
     * @param resource - Resource to check path
     * @param baseUrl - Base root url
     */ SpritesheetLoader.getResourcePath = function(resource, baseUrl) {
        // Prepend url path unless the resource image is a data url
        if (resource.isDataUrl) return resource.data.meta.image;
        return (0, $csytw.url).resolve(resource.url.replace(baseUrl, ''), resource.data.meta.image);
    };
    return SpritesheetLoader;
}();

});

parcelRegister("eQ8XE", function(module, exports) {

$parcel$export(module.exports, "TilingSprite", function () { return $acdcdf7c54003bfb$export$db8370cd1ebcc819; });
$parcel$export(module.exports, "TilingSpriteRenderer", function () { return $acdcdf7c54003bfb$export$8b7f6ad84090f14c; });
/*!
 * @pixi/sprite-tiling - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/sprite-tiling is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $6qzqq = parcelRequire("6qzqq");

var $7Bs2Z = parcelRequire("7Bs2Z");

var $P8XPi = parcelRequire("P8XPi");

var $csytw = parcelRequire("csytw");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $acdcdf7c54003bfb$var$extendStatics = function(d, b) {
    $acdcdf7c54003bfb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $acdcdf7c54003bfb$var$extendStatics(d, b);
};
function $acdcdf7c54003bfb$var$__extends(d, b) {
    $acdcdf7c54003bfb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $acdcdf7c54003bfb$var$tempPoint = new (0, $6qzqq.Point)();
/**
 * A tiling sprite is a fast way of rendering a tiling image.
 *
 * @memberof PIXI
 */ var $acdcdf7c54003bfb$export$db8370cd1ebcc819 = /** @class */ function(_super) {
    $acdcdf7c54003bfb$var$__extends(TilingSprite, _super);
    /**
     * @param texture - The texture of the tiling sprite.
     * @param width - The width of the tiling sprite.
     * @param height - The height of the tiling sprite.
     */ function TilingSprite(texture, width, height) {
        if (width === void 0) width = 100;
        if (height === void 0) height = 100;
        var _this = _super.call(this, texture) || this;
        _this.tileTransform = new (0, $6qzqq.Transform)();
        // The width of the tiling sprite
        _this._width = width;
        // The height of the tiling sprite
        _this._height = height;
        _this.uvMatrix = _this.texture.uvMatrix || new (0, $klOfb.TextureMatrix)(texture);
        /**
         * Plugin that is responsible for rendering this element.
         * Allows to customize the rendering process without overriding '_render' method.
         *
         * @default 'tilingSprite'
         */ _this.pluginName = 'tilingSprite';
        _this.uvRespectAnchor = false;
        return _this;
    }
    Object.defineProperty(TilingSprite.prototype, "clampMargin", {
        /**
         * Changes frame clamping in corresponding textureTransform, shortcut
         * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
         *
         * @default 0.5
         * @member {number}
         */ get: function() {
            return this.uvMatrix.clampMargin;
        },
        set: function(value) {
            this.uvMatrix.clampMargin = value;
            this.uvMatrix.update(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TilingSprite.prototype, "tileScale", {
        /** The scaling of the image that is being tiled. */ get: function() {
            return this.tileTransform.scale;
        },
        set: function(value) {
            this.tileTransform.scale.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TilingSprite.prototype, "tilePosition", {
        /** The offset of the image that is being tiled. */ get: function() {
            return this.tileTransform.position;
        },
        set: function(value) {
            this.tileTransform.position.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @protected
     */ TilingSprite.prototype._onTextureUpdate = function() {
        if (this.uvMatrix) this.uvMatrix.texture = this._texture;
        this._cachedTint = 0xFFFFFF;
    };
    /**
     * Renders the object using the WebGL renderer
     *
     * @param renderer - The renderer
     */ TilingSprite.prototype._render = function(renderer) {
        // tweak our texture temporarily..
        var texture = this._texture;
        if (!texture || !texture.valid) return;
        this.tileTransform.updateLocalTransform();
        this.uvMatrix.update();
        renderer.batch.setObjectRenderer(renderer.plugins[this.pluginName]);
        renderer.plugins[this.pluginName].render(this);
    };
    /** Updates the bounds of the tiling sprite. */ TilingSprite.prototype._calculateBounds = function() {
        var minX = this._width * -this._anchor._x;
        var minY = this._height * -this._anchor._y;
        var maxX = this._width * (1 - this._anchor._x);
        var maxY = this._height * (1 - this._anchor._y);
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    };
    /**
     * Gets the local bounds of the sprite object.
     *
     * @param rect - Optional output rectangle.
     * @return The bounds.
     */ TilingSprite.prototype.getLocalBounds = function(rect) {
        // we can do a fast local bounds if the sprite has no children!
        if (this.children.length === 0) {
            this._bounds.minX = this._width * -this._anchor._x;
            this._bounds.minY = this._height * -this._anchor._y;
            this._bounds.maxX = this._width * (1 - this._anchor._x);
            this._bounds.maxY = this._height * (1 - this._anchor._y);
            if (!rect) {
                if (!this._localBoundsRect) this._localBoundsRect = new (0, $6qzqq.Rectangle)();
                rect = this._localBoundsRect;
            }
            return this._bounds.getRectangle(rect);
        }
        return _super.prototype.getLocalBounds.call(this, rect);
    };
    /**
     * Checks if a point is inside this tiling sprite.
     *
     * @param point - The point to check.
     * @return Whether or not the sprite contains the point.
     */ TilingSprite.prototype.containsPoint = function(point) {
        this.worldTransform.applyInverse(point, $acdcdf7c54003bfb$var$tempPoint);
        var width = this._width;
        var height = this._height;
        var x1 = -width * this.anchor._x;
        if ($acdcdf7c54003bfb$var$tempPoint.x >= x1 && $acdcdf7c54003bfb$var$tempPoint.x < x1 + width) {
            var y1 = -height * this.anchor._y;
            if ($acdcdf7c54003bfb$var$tempPoint.y >= y1 && $acdcdf7c54003bfb$var$tempPoint.y < y1 + height) return true;
        }
        return false;
    };
    /**
     * Destroys this sprite and optionally its texture and children
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
     *      method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
     */ TilingSprite.prototype.destroy = function(options) {
        _super.prototype.destroy.call(this, options);
        this.tileTransform = null;
        this.uvMatrix = null;
    };
    /**
     * Helper function that creates a new tiling sprite based on the source you provide.
     * The source can be - frame id, image url, video url, canvas element, video element, base texture
     *
     * @static
     * @param {string|PIXI.Texture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
     * @param {Object} options - See {@link PIXI.BaseTexture}'s constructor for options.
     * @param {number} options.width - required width of the tiling sprite
     * @param {number} options.height - required height of the tiling sprite
     * @return {PIXI.TilingSprite} The newly created texture
     */ TilingSprite.from = function(source, options) {
        var texture = source instanceof (0, $klOfb.Texture) ? source : (0, $klOfb.Texture).from(source, options);
        return new TilingSprite(texture, options.width, options.height);
    };
    Object.defineProperty(TilingSprite.prototype, "width", {
        /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get: function() {
            return this._width;
        },
        set: function(value) {
            this._width = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TilingSprite.prototype, "height", {
        /** The height of the TilingSprite, setting this will actually modify the scale to achieve the value set. */ get: function() {
            return this._height;
        },
        set: function(value) {
            this._height = value;
        },
        enumerable: false,
        configurable: true
    });
    return TilingSprite;
}((0, $7Bs2Z.Sprite));
var $acdcdf7c54003bfb$var$fragmentSimpleSrc = "#version 100\n#define SHADER_NAME Tiling-Sprite-Simple-100\n\nprecision lowp float;\n\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\n\nvoid main(void)\n{\n    vec4 texSample = texture2D(uSampler, vTextureCoord);\n    gl_FragColor = texSample * uColor;\n}\n";
var $acdcdf7c54003bfb$var$gl1VertexSrc = "#version 100\n#define SHADER_NAME Tiling-Sprite-100\n\nprecision lowp float;\n\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n";
var $acdcdf7c54003bfb$var$gl1FragmentSrc = "#version 100\n#ifdef GL_EXT_shader_texture_lod\n    #extension GL_EXT_shader_texture_lod : enable\n#endif\n#define SHADER_NAME Tiling-Sprite-100\n\nprecision lowp float;\n\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    vec2 unclamped = coord;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    #ifdef GL_EXT_shader_texture_lod\n        vec4 texSample = unclamped == coord\n            ? texture2D(uSampler, coord) \n            : texture2DLodEXT(uSampler, coord, 0);\n    #else\n        vec4 texSample = texture2D(uSampler, coord);\n    #endif\n\n    gl_FragColor = texSample * uColor;\n}\n";
var $acdcdf7c54003bfb$var$gl2VertexSrc = "#version 300 es\n#define SHADER_NAME Tiling-Sprite-300\n\nprecision lowp float;\n\nin vec2 aVertexPosition;\nin vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nout vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n";
var $acdcdf7c54003bfb$var$gl2FragmentSrc = "#version 300 es\n#define SHADER_NAME Tiling-Sprite-100\n\nprecision lowp float;\n\nin vec2 vTextureCoord;\n\nout vec4 fragmentColor;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = vTextureCoord + ceil(uClampOffset - vTextureCoord);\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    vec2 unclamped = coord;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    vec4 texSample = texture(uSampler, coord, unclamped == coord ? 0.0f : -32.0f);// lod-bias very negative to force lod 0\n\n    fragmentColor = texSample * uColor;\n}\n";
var $acdcdf7c54003bfb$var$tempMat = new (0, $6qzqq.Matrix)();
/**
 * WebGL renderer plugin for tiling sprites
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.ObjectRenderer
 */ var $acdcdf7c54003bfb$export$8b7f6ad84090f14c = /** @class */ function(_super) {
    $acdcdf7c54003bfb$var$__extends(TilingSpriteRenderer, _super);
    /**
     * constructor for renderer
     *
     * @param {PIXI.Renderer} renderer - The renderer this tiling awesomeness works for.
     */ function TilingSpriteRenderer(renderer) {
        var _this = _super.call(this, renderer) || this;
        // WebGL version is not available during initialization!
        renderer.runners.contextChange.add(_this);
        _this.quad = new (0, $klOfb.QuadUv)();
        /**
         * The WebGL state in which this renderer will work.
         *
         * @member {PIXI.State}
         * @readonly
         */ _this.state = (0, $klOfb.State).for2d();
        return _this;
    }
    /**
     * Creates shaders when context is initialized.
     */ TilingSpriteRenderer.prototype.contextChange = function() {
        var renderer = this.renderer;
        var uniforms = {
            globals: renderer.globalUniforms
        };
        this.simpleShader = (0, $klOfb.Shader).from($acdcdf7c54003bfb$var$gl1VertexSrc, $acdcdf7c54003bfb$var$fragmentSimpleSrc, uniforms);
        this.shader = renderer.context.webGLVersion > 1 ? (0, $klOfb.Shader).from($acdcdf7c54003bfb$var$gl2VertexSrc, $acdcdf7c54003bfb$var$gl2FragmentSrc, uniforms) : (0, $klOfb.Shader).from($acdcdf7c54003bfb$var$gl1VertexSrc, $acdcdf7c54003bfb$var$gl1FragmentSrc, uniforms);
    };
    /**
     * @param {PIXI.TilingSprite} ts - tilingSprite to be rendered
     */ TilingSpriteRenderer.prototype.render = function(ts) {
        var renderer = this.renderer;
        var quad = this.quad;
        var vertices = quad.vertices;
        vertices[0] = vertices[6] = ts._width * -ts.anchor.x;
        vertices[1] = vertices[3] = ts._height * -ts.anchor.y;
        vertices[2] = vertices[4] = ts._width * (1.0 - ts.anchor.x);
        vertices[5] = vertices[7] = ts._height * (1.0 - ts.anchor.y);
        var anchorX = ts.uvRespectAnchor ? ts.anchor.x : 0;
        var anchorY = ts.uvRespectAnchor ? ts.anchor.y : 0;
        vertices = quad.uvs;
        vertices[0] = vertices[6] = -anchorX;
        vertices[1] = vertices[3] = -anchorY;
        vertices[2] = vertices[4] = 1.0 - anchorX;
        vertices[5] = vertices[7] = 1.0 - anchorY;
        quad.invalidate();
        var tex = ts._texture;
        var baseTex = tex.baseTexture;
        var lt = ts.tileTransform.localTransform;
        var uv = ts.uvMatrix;
        var isSimple = baseTex.isPowerOfTwo && tex.frame.width === baseTex.width && tex.frame.height === baseTex.height;
        // auto, force repeat wrapMode for big tiling textures
        if (isSimple) {
            if (!baseTex._glTextures[renderer.CONTEXT_UID]) {
                if (baseTex.wrapMode === (0, $P8XPi.WRAP_MODES).CLAMP) baseTex.wrapMode = (0, $P8XPi.WRAP_MODES).REPEAT;
            } else isSimple = baseTex.wrapMode !== (0, $P8XPi.WRAP_MODES).CLAMP;
        }
        var shader = isSimple ? this.simpleShader : this.shader;
        var w = tex.width;
        var h = tex.height;
        var W = ts._width;
        var H = ts._height;
        $acdcdf7c54003bfb$var$tempMat.set(lt.a * w / W, lt.b * w / H, lt.c * h / W, lt.d * h / H, lt.tx / W, lt.ty / H);
        // that part is the same as above:
        // tempMat.identity();
        // tempMat.scale(tex.width, tex.height);
        // tempMat.prepend(lt);
        // tempMat.scale(1.0 / ts._width, 1.0 / ts._height);
        $acdcdf7c54003bfb$var$tempMat.invert();
        if (isSimple) $acdcdf7c54003bfb$var$tempMat.prepend(uv.mapCoord);
        else {
            shader.uniforms.uMapCoord = uv.mapCoord.toArray(true);
            shader.uniforms.uClampFrame = uv.uClampFrame;
            shader.uniforms.uClampOffset = uv.uClampOffset;
        }
        shader.uniforms.uTransform = $acdcdf7c54003bfb$var$tempMat.toArray(true);
        shader.uniforms.uColor = (0, $csytw.premultiplyTintToRgba)(ts.tint, ts.worldAlpha, shader.uniforms.uColor, baseTex.alphaMode);
        shader.uniforms.translationMatrix = ts.transform.worldTransform.toArray(true);
        shader.uniforms.uSampler = tex;
        renderer.shader.bind(shader);
        renderer.geometry.bind(quad);
        this.state.blendMode = (0, $csytw.correctBlendMode)(ts.blendMode, baseTex.alphaMode);
        renderer.state.set(this.state);
        renderer.geometry.draw(this.renderer.gl.TRIANGLES, 6, 0);
    };
    return TilingSpriteRenderer;
}((0, $klOfb.ObjectRenderer));

});

parcelRegister("hnGDn", function(module, exports) {

$parcel$export(module.exports, "BitmapFontData", function () { return $ca75a7df8c7436d8$export$2fb2a0e272ba703b; });
$parcel$export(module.exports, "BitmapFont", function () { return $ca75a7df8c7436d8$export$17957a09927cadc7; });
$parcel$export(module.exports, "BitmapText", function () { return $ca75a7df8c7436d8$export$ae0da96467efdba0; });
$parcel$export(module.exports, "BitmapFontLoader", function () { return $ca75a7df8c7436d8$export$d4a75f306c6c494f; });
/*!
 * @pixi/text-bitmap - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/text-bitmap is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $6qzqq = parcelRequire("6qzqq");

var $ezJmd = parcelRequire("ezJmd");

var $9Tsx3 = parcelRequire("9Tsx3");

var $csytw = parcelRequire("csytw");

var $klOfb = parcelRequire("klOfb");

var $9Pi8W = parcelRequire("9Pi8W");

var $P8XPi = parcelRequire("P8XPi");

var $8t5Gy = parcelRequire("8t5Gy");

var $kXE1p = parcelRequire("kXE1p");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $ca75a7df8c7436d8$var$extendStatics = function(d, b) {
    $ca75a7df8c7436d8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ca75a7df8c7436d8$var$extendStatics(d, b);
};
function $ca75a7df8c7436d8$var$__extends(d, b) {
    $ca75a7df8c7436d8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/* eslint-disable max-len */ /**
 * Normalized parsed data from .fnt files.
 *
 * @memberof PIXI
 */ var $ca75a7df8c7436d8$export$2fb2a0e272ba703b = /** @class */ function() {
    function BitmapFontData() {
        this.info = [];
        this.common = [];
        this.page = [];
        this.char = [];
        this.kerning = [];
        this.distanceField = [];
    }
    return BitmapFontData;
}();
/**
 * BitmapFont format that's Text-based.
 *
 * @private
 */ var $ca75a7df8c7436d8$var$TextFormat = /** @class */ function() {
    function TextFormat() {}
    /**
     * Check if resource refers to txt font data.
     *
     * @param data
     * @return - True if resource could be treated as font data, false otherwise.
     */ TextFormat.test = function(data) {
        return typeof data === 'string' && data.indexOf('info face=') === 0;
    };
    /**
     * Convert text font data to a javascript object.
     *
     * @param txt - Raw string data to be converted
     * @return - Parsed font data
     */ TextFormat.parse = function(txt) {
        // Retrieve data item
        var items = txt.match(/^[a-z]+\s+.+$/gm);
        var rawData = {
            info: [],
            common: [],
            page: [],
            char: [],
            chars: [],
            kerning: [],
            kernings: [],
            distanceField: []
        };
        for(var i in items){
            // Extract item name
            var name = items[i].match(/^[a-z]+/gm)[0];
            // Extract item attribute list as string ex.: "width=10"
            var attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm);
            // Convert attribute list into an object
            var itemData = {};
            for(var i_1 in attributeList){
                // Split key-value pairs
                var split = attributeList[i_1].split('=');
                var key = split[0];
                // Remove eventual quotes from value
                var strValue = split[1].replace(/"/gm, '');
                // Try to convert value into float
                var floatValue = parseFloat(strValue);
                // Use string value case float value is NaN
                var value = isNaN(floatValue) ? strValue : floatValue;
                itemData[key] = value;
            }
            // Push current item to the resulting data
            rawData[name].push(itemData);
        }
        var font = new $ca75a7df8c7436d8$export$2fb2a0e272ba703b();
        rawData.info.forEach(function(info) {
            return font.info.push({
                face: info.face,
                size: parseInt(info.size, 10)
            });
        });
        rawData.common.forEach(function(common) {
            return font.common.push({
                lineHeight: parseInt(common.lineHeight, 10)
            });
        });
        rawData.page.forEach(function(page) {
            return font.page.push({
                id: parseInt(page.id, 10),
                file: page.file
            });
        });
        rawData.char.forEach(function(char) {
            return font.char.push({
                id: parseInt(char.id, 10),
                page: parseInt(char.page, 10),
                x: parseInt(char.x, 10),
                y: parseInt(char.y, 10),
                width: parseInt(char.width, 10),
                height: parseInt(char.height, 10),
                xoffset: parseInt(char.xoffset, 10),
                yoffset: parseInt(char.yoffset, 10),
                xadvance: parseInt(char.xadvance, 10)
            });
        });
        rawData.kerning.forEach(function(kerning) {
            return font.kerning.push({
                first: parseInt(kerning.first, 10),
                second: parseInt(kerning.second, 10),
                amount: parseInt(kerning.amount, 10)
            });
        });
        rawData.distanceField.forEach(function(df) {
            return font.distanceField.push({
                distanceRange: parseInt(df.distanceRange, 10),
                fieldType: df.fieldType
            });
        });
        return font;
    };
    return TextFormat;
}();
/**
 * BitmapFont format that's XML-based.
 *
 * @private
 */ var $ca75a7df8c7436d8$var$XMLFormat = /** @class */ function() {
    function XMLFormat() {}
    /**
     * Check if resource refers to xml font data.
     *
     * @param data
     * @return - True if resource could be treated as font data, false otherwise.
     */ XMLFormat.test = function(data) {
        return data instanceof XMLDocument && data.getElementsByTagName('page').length && data.getElementsByTagName('info')[0].getAttribute('face') !== null;
    };
    /**
     * Convert the XML into BitmapFontData that we can use.
     *
     * @param xml
     * @return - Data to use for BitmapFont
     */ XMLFormat.parse = function(xml) {
        var data = new $ca75a7df8c7436d8$export$2fb2a0e272ba703b();
        var info = xml.getElementsByTagName('info');
        var common = xml.getElementsByTagName('common');
        var page = xml.getElementsByTagName('page');
        var char = xml.getElementsByTagName('char');
        var kerning = xml.getElementsByTagName('kerning');
        var distanceField = xml.getElementsByTagName('distanceField');
        for(var i = 0; i < info.length; i++)data.info.push({
            face: info[i].getAttribute('face'),
            size: parseInt(info[i].getAttribute('size'), 10)
        });
        for(var i = 0; i < common.length; i++)data.common.push({
            lineHeight: parseInt(common[i].getAttribute('lineHeight'), 10)
        });
        for(var i = 0; i < page.length; i++)data.page.push({
            id: parseInt(page[i].getAttribute('id'), 10) || 0,
            file: page[i].getAttribute('file')
        });
        for(var i = 0; i < char.length; i++){
            var letter = char[i];
            data.char.push({
                id: parseInt(letter.getAttribute('id'), 10),
                page: parseInt(letter.getAttribute('page'), 10) || 0,
                x: parseInt(letter.getAttribute('x'), 10),
                y: parseInt(letter.getAttribute('y'), 10),
                width: parseInt(letter.getAttribute('width'), 10),
                height: parseInt(letter.getAttribute('height'), 10),
                xoffset: parseInt(letter.getAttribute('xoffset'), 10),
                yoffset: parseInt(letter.getAttribute('yoffset'), 10),
                xadvance: parseInt(letter.getAttribute('xadvance'), 10)
            });
        }
        for(var i = 0; i < kerning.length; i++)data.kerning.push({
            first: parseInt(kerning[i].getAttribute('first'), 10),
            second: parseInt(kerning[i].getAttribute('second'), 10),
            amount: parseInt(kerning[i].getAttribute('amount'), 10)
        });
        for(var i = 0; i < distanceField.length; i++)data.distanceField.push({
            fieldType: distanceField[i].getAttribute('fieldType'),
            distanceRange: parseInt(distanceField[i].getAttribute('distanceRange'), 10)
        });
        return data;
    };
    return XMLFormat;
}();
/**
 * BitmapFont format that's XML-based.
 *
 * @private
 */ var $ca75a7df8c7436d8$var$XMLStringFormat = /** @class */ function() {
    function XMLStringFormat() {}
    /**
     * Check if resource refers to text xml font data.
     *
     * @param data
     * @return - True if resource could be treated as font data, false otherwise.
     */ XMLStringFormat.test = function(data) {
        if (typeof data === 'string' && data.indexOf('<font>') > -1) {
            var xml = new self.DOMParser().parseFromString(data, 'text/xml');
            return $ca75a7df8c7436d8$var$XMLFormat.test(xml);
        }
        return false;
    };
    /**
     * Convert the text XML into BitmapFontData that we can use.
     *
     * @param xmlTxt
     * @return - Data to use for BitmapFont
     */ XMLStringFormat.parse = function(xmlTxt) {
        var xml = new self.DOMParser().parseFromString(xmlTxt, 'text/xml');
        return $ca75a7df8c7436d8$var$XMLFormat.parse(xml);
    };
    return XMLStringFormat;
}();
// Registered formats, maybe make this extensible in the future?
var $ca75a7df8c7436d8$var$formats = [
    $ca75a7df8c7436d8$var$TextFormat,
    $ca75a7df8c7436d8$var$XMLFormat,
    $ca75a7df8c7436d8$var$XMLStringFormat
];
/**
 * Auto-detect BitmapFont parsing format based on data.
 * @private
 * @param {any} data - Data to detect format
 * @return {any} Format or null
 */ function $ca75a7df8c7436d8$var$autoDetectFormat(data) {
    for(var i = 0; i < $ca75a7df8c7436d8$var$formats.length; i++){
        if ($ca75a7df8c7436d8$var$formats[i].test(data)) return $ca75a7df8c7436d8$var$formats[i];
    }
    return null;
}
// TODO: Prevent code duplication b/w generateFillStyle & Text#generateFillStyle
/**
 * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
 *
 * @private
 * @param {object} style - The style.
 * @param {string[]} lines - The lines of text.
 * @return {string|number|CanvasGradient} The fill style
 */ function $ca75a7df8c7436d8$var$generateFillStyle(canvas, context, style, resolution, lines, metrics) {
    // TODO: Can't have different types for getter and setter. The getter shouldn't have the number type as
    //       the setter converts to string. See this thread for more details:
    //       https://github.com/microsoft/TypeScript/issues/2521
    var fillStyle = style.fill;
    if (!Array.isArray(fillStyle)) return fillStyle;
    else if (fillStyle.length === 1) return fillStyle[0];
    // the gradient will be evenly spaced out according to how large the array is.
    // ['#FF0000', '#00FF00', '#0000FF'] would created stops at 0.25, 0.5 and 0.75
    var gradient;
    // a dropshadow will enlarge the canvas and result in the gradient being
    // generated with the incorrect dimensions
    var dropShadowCorrection = style.dropShadow ? style.dropShadowDistance : 0;
    // should also take padding into account, padding can offset the gradient
    var padding = style.padding || 0;
    var width = canvas.width / resolution - dropShadowCorrection - padding * 2;
    var height = canvas.height / resolution - dropShadowCorrection - padding * 2;
    // make a copy of the style settings, so we can manipulate them later
    var fill = fillStyle.slice();
    var fillGradientStops = style.fillGradientStops.slice();
    // wanting to evenly distribute the fills. So an array of 4 colours should give fills of 0.25, 0.5 and 0.75
    if (!fillGradientStops.length) {
        var lengthPlus1 = fill.length + 1;
        for(var i = 1; i < lengthPlus1; ++i)fillGradientStops.push(i / lengthPlus1);
    }
    // stop the bleeding of the last gradient on the line above to the top gradient of the this line
    // by hard defining the first gradient colour at point 0, and last gradient colour at point 1
    fill.unshift(fillStyle[0]);
    fillGradientStops.unshift(0);
    fill.push(fillStyle[fillStyle.length - 1]);
    fillGradientStops.push(1);
    if (style.fillGradientType === (0, $9Pi8W.TEXT_GRADIENT).LINEAR_VERTICAL) {
        // start the gradient at the top center of the canvas, and end at the bottom middle of the canvas
        gradient = context.createLinearGradient(width / 2, padding, width / 2, height + padding);
        // we need to repeat the gradient so that each individual line of text has the same vertical gradient effect
        // ['#FF0000', '#00FF00', '#0000FF'] over 2 lines would create stops at 0.125, 0.25, 0.375, 0.625, 0.75, 0.875
        // There's potential for floating point precision issues at the seams between gradient repeats.
        // The loop below generates the stops in order, so track the last generated one to prevent
        // floating point precision from making us go the teeniest bit backwards, resulting in
        // the first and last colors getting swapped.
        var lastIterationStop = 0;
        // Actual height of the text itself, not counting spacing for lineHeight/leading/dropShadow etc
        var textHeight = metrics.fontProperties.fontSize + style.strokeThickness;
        // textHeight, but as a 0-1 size in global gradient stop space
        var gradStopLineHeight = textHeight / height;
        for(var i = 0; i < lines.length; i++){
            var thisLineTop = metrics.lineHeight * i;
            for(var j = 0; j < fill.length; j++){
                // 0-1 stop point for the current line, multiplied to global space afterwards
                var lineStop = 0;
                if (typeof fillGradientStops[j] === 'number') lineStop = fillGradientStops[j];
                else lineStop = j / fill.length;
                var globalStop = thisLineTop / height + lineStop * gradStopLineHeight;
                // Prevent color stop generation going backwards from floating point imprecision
                var clampedStop = Math.max(lastIterationStop, globalStop);
                clampedStop = Math.min(clampedStop, 1); // Cap at 1 as well for safety's sake to avoid a possible throw.
                gradient.addColorStop(clampedStop, fill[j]);
                lastIterationStop = clampedStop;
            }
        }
    } else {
        // start the gradient at the center left of the canvas, and end at the center right of the canvas
        gradient = context.createLinearGradient(padding, height / 2, width + padding, height / 2);
        // can just evenly space out the gradients in this case, as multiple lines makes no difference
        // to an even left to right gradient
        var totalIterations = fill.length + 1;
        var currentIteration = 1;
        for(var i = 0; i < fill.length; i++){
            var stop = void 0;
            if (typeof fillGradientStops[i] === 'number') stop = fillGradientStops[i];
            else stop = currentIteration / totalIterations;
            gradient.addColorStop(stop, fill[i]);
            currentIteration++;
        }
    }
    return gradient;
}
// TODO: Prevent code duplication b/w drawGlyph & Text#updateText
/**
 * Draws the glyph `metrics.text` on the given canvas.
 *
 * Ignored because not directly exposed.
 *
 * @ignore
 * @param {HTMLCanvasElement} canvas
 * @param {CanvasRenderingContext2D} context
 * @param {TextMetrics} metrics
 * @param {number} x
 * @param {number} y
 * @param {number} resolution
 * @param {TextStyle} style
 */ function $ca75a7df8c7436d8$var$drawGlyph(canvas, context, metrics, x, y, resolution, style) {
    var char = metrics.text;
    var fontProperties = metrics.fontProperties;
    context.translate(x, y);
    context.scale(resolution, resolution);
    var tx = style.strokeThickness / 2;
    var ty = -(style.strokeThickness / 2);
    context.font = style.toFontString();
    context.lineWidth = style.strokeThickness;
    context.textBaseline = style.textBaseline;
    context.lineJoin = style.lineJoin;
    context.miterLimit = style.miterLimit;
    // set canvas text styles
    context.fillStyle = $ca75a7df8c7436d8$var$generateFillStyle(canvas, context, style, resolution, [
        char
    ], metrics);
    context.strokeStyle = style.stroke;
    if (style.dropShadow) {
        var dropShadowColor = style.dropShadowColor;
        var rgb = (0, $csytw.hex2rgb)(typeof dropShadowColor === 'number' ? dropShadowColor : (0, $csytw.string2hex)(dropShadowColor));
        var dropShadowBlur = style.dropShadowBlur * resolution;
        var dropShadowDistance = style.dropShadowDistance * resolution;
        context.shadowColor = "rgba(" + rgb[0] * 255 + "," + rgb[1] * 255 + "," + rgb[2] * 255 + "," + style.dropShadowAlpha + ")";
        context.shadowBlur = dropShadowBlur;
        context.shadowOffsetX = Math.cos(style.dropShadowAngle) * dropShadowDistance;
        context.shadowOffsetY = Math.sin(style.dropShadowAngle) * dropShadowDistance;
    } else {
        context.shadowColor = 'black';
        context.shadowBlur = 0;
        context.shadowOffsetX = 0;
        context.shadowOffsetY = 0;
    }
    if (style.stroke && style.strokeThickness) context.strokeText(char, tx, ty + metrics.lineHeight - fontProperties.descent);
    if (style.fill) context.fillText(char, tx, ty + metrics.lineHeight - fontProperties.descent);
    context.setTransform(1, 0, 0, 1, 0, 0); // defaults needed for older browsers (e.g. Opera 29)
    context.fillStyle = 'rgba(0, 0, 0, 0)';
}
/**
 * Ponyfill for IE because it doesn't support `Array.from`
 * @private
 */ function $ca75a7df8c7436d8$var$splitTextToCharacters(text) {
    return Array.from ? Array.from(text) : text.split('');
}
/**
 * Processes the passed character set data and returns a flattened array of all the characters.
 *
 * Ignored because not directly exposed.
 *
 * @ignore
 * @param {string | string[] | string[][] } chars
 * @returns {string[]}
 */ function $ca75a7df8c7436d8$var$resolveCharacters(chars) {
    // Split the chars string into individual characters
    if (typeof chars === 'string') chars = [
        chars
    ];
    // Handle an array of characters+ranges
    var result = [];
    for(var i = 0, j = chars.length; i < j; i++){
        var item = chars[i];
        // Handle range delimited by start/end chars
        if (Array.isArray(item)) {
            if (item.length !== 2) throw new Error("[BitmapFont]: Invalid character range length, expecting 2 got " + item.length + ".");
            var startCode = item[0].charCodeAt(0);
            var endCode = item[1].charCodeAt(0);
            if (endCode < startCode) throw new Error('[BitmapFont]: Invalid character range.');
            for(var i_1 = startCode, j_1 = endCode; i_1 <= j_1; i_1++)result.push(String.fromCharCode(i_1));
        } else result.push.apply(result, $ca75a7df8c7436d8$var$splitTextToCharacters(item));
    }
    if (result.length === 0) throw new Error('[BitmapFont]: Empty set when resolving characters.');
    return result;
}
/**
 * Ponyfill for IE because it doesn't support `codePointAt`
 * @private
 */ function $ca75a7df8c7436d8$var$extractCharCode(str) {
    return str.codePointAt ? str.codePointAt(0) : str.charCodeAt(0);
}
/**
 * BitmapFont represents a typeface available for use with the BitmapText class. Use the `install`
 * method for adding a font to be used.
 *
 * @memberof PIXI
 */ var $ca75a7df8c7436d8$export$17957a09927cadc7 = /** @class */ function() {
    /**
     * @param data
     * @param textures
     * @param ownsTextures - Setting to `true` will destroy page textures
     *        when the font is uninstalled.
     */ function BitmapFont(data, textures, ownsTextures) {
        var _a, _b;
        var info = data.info[0];
        var common = data.common[0];
        var page = data.page[0];
        var distanceField = data.distanceField[0];
        var res = (0, $csytw.getResolutionOfUrl)(page.file);
        var pageTextures = {};
        this._ownsTextures = ownsTextures;
        this.font = info.face;
        this.size = info.size;
        this.lineHeight = common.lineHeight / res;
        this.chars = {};
        this.pageTextures = pageTextures;
        // Convert the input Texture, Textures or object
        // into a page Texture lookup by "id"
        for(var i = 0; i < data.page.length; i++){
            var _c = data.page[i], id = _c.id, file = _c.file;
            pageTextures[id] = textures instanceof Array ? textures[i] : textures[file];
            // only MSDF and SDF fonts need no-premultiplied-alpha
            if ((distanceField === null || distanceField === void 0 ? void 0 : distanceField.fieldType) && distanceField.fieldType !== 'none') pageTextures[id].baseTexture.alphaMode = (0, $P8XPi.ALPHA_MODES).NO_PREMULTIPLIED_ALPHA;
        }
        // parse letters
        for(var i = 0; i < data.char.length; i++){
            var _d = data.char[i], id = _d.id, page_1 = _d.page;
            var _e = data.char[i], x = _e.x, y = _e.y, width = _e.width, height = _e.height, xoffset = _e.xoffset, yoffset = _e.yoffset, xadvance = _e.xadvance;
            x /= res;
            y /= res;
            width /= res;
            height /= res;
            xoffset /= res;
            yoffset /= res;
            xadvance /= res;
            var rect = new (0, $6qzqq.Rectangle)(x + pageTextures[page_1].frame.x / res, y + pageTextures[page_1].frame.y / res, width, height);
            this.chars[id] = {
                xOffset: xoffset,
                yOffset: yoffset,
                xAdvance: xadvance,
                kerning: {},
                texture: new (0, $klOfb.Texture)(pageTextures[page_1].baseTexture, rect),
                page: page_1
            };
        }
        // parse kernings
        for(var i = 0; i < data.kerning.length; i++){
            var _f = data.kerning[i], first = _f.first, second = _f.second, amount = _f.amount;
            first /= res;
            second /= res;
            amount /= res;
            if (this.chars[second]) this.chars[second].kerning[first] = amount;
        }
        // Store distance field information
        this.distanceFieldRange = distanceField === null || distanceField === void 0 ? void 0 : distanceField.distanceRange;
        this.distanceFieldType = (_b = (_a = distanceField === null || distanceField === void 0 ? void 0 : distanceField.fieldType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : 'none';
    }
    /** Remove references to created glyph textures. */ BitmapFont.prototype.destroy = function() {
        for(var id in this.chars){
            this.chars[id].texture.destroy();
            this.chars[id].texture = null;
        }
        for(var id in this.pageTextures){
            if (this._ownsTextures) this.pageTextures[id].destroy(true);
            this.pageTextures[id] = null;
        }
        // Set readonly null.
        this.chars = null;
        this.pageTextures = null;
    };
    /**
     * Register a new bitmap font.
     *
     * @param data - The
     *        characters map that could be provided as xml or raw string.
     * @param textures - List of textures for each page.
     * @param ownsTextures - Set to `true` to destroy page textures
     *        when the font is uninstalled. By default fonts created with
     *        `BitmapFont.from` or from the `BitmapFontLoader` are `true`.
     * @return {PIXI.BitmapFont} Result font object with font, size, lineHeight
     *         and char fields.
     */ BitmapFont.install = function(data, textures, ownsTextures) {
        var fontData;
        if (data instanceof $ca75a7df8c7436d8$export$2fb2a0e272ba703b) fontData = data;
        else {
            var format = $ca75a7df8c7436d8$var$autoDetectFormat(data);
            if (!format) throw new Error('Unrecognized data format for font.');
            fontData = format.parse(data);
        }
        // Single texture, convert to list
        if (textures instanceof (0, $klOfb.Texture)) textures = [
            textures
        ];
        var font = new BitmapFont(fontData, textures, ownsTextures);
        BitmapFont.available[font.font] = font;
        return font;
    };
    /**
     * Remove bitmap font by name.
     *
     * @param name - Name of the font to uninstall.
     */ BitmapFont.uninstall = function(name) {
        var font = BitmapFont.available[name];
        if (!font) throw new Error("No font found named '" + name + "'");
        font.destroy();
        delete BitmapFont.available[name];
    };
    /**
     * Generates a bitmap-font for the given style and character set. This does not support
     * kernings yet. With `style` properties, only the following non-layout properties are used:
     *
     * - {@link PIXI.TextStyle#dropShadow|dropShadow}
     * - {@link PIXI.TextStyle#dropShadowDistance|dropShadowDistance}
     * - {@link PIXI.TextStyle#dropShadowColor|dropShadowColor}
     * - {@link PIXI.TextStyle#dropShadowBlur|dropShadowBlur}
     * - {@link PIXI.TextStyle#dropShadowAngle|dropShadowAngle}
     * - {@link PIXI.TextStyle#fill|fill}
     * - {@link PIXI.TextStyle#fillGradientStops|fillGradientStops}
     * - {@link PIXI.TextStyle#fillGradientType|fillGradientType}
     * - {@link PIXI.TextStyle#fontFamily|fontFamily}
     * - {@link PIXI.TextStyle#fontSize|fontSize}
     * - {@link PIXI.TextStyle#fontVariant|fontVariant}
     * - {@link PIXI.TextStyle#fontWeight|fontWeight}
     * - {@link PIXI.TextStyle#lineJoin|lineJoin}
     * - {@link PIXI.TextStyle#miterLimit|miterLimit}
     * - {@link PIXI.TextStyle#stroke|stroke}
     * - {@link PIXI.TextStyle#strokeThickness|strokeThickness}
     * - {@link PIXI.TextStyle#textBaseline|textBaseline}
     *
     * @param name - The name of the custom font to use with BitmapText.
     * @param style - Style options to render with BitmapFont.
     * @param options - Setup options for font or name of the font.
     * @param {string|string[]|string[][]} [options.chars=PIXI.BitmapFont.ALPHANUMERIC] - characters included
     *      in the font set. You can also use ranges. For example, `[['a', 'z'], ['A', 'Z'], "!@#$%^&*()~{}[] "]`.
     *      Don't forget to include spaces ' ' in your character set!
     * @param {number} [options.resolution=1] - Render resolution for glyphs.
     * @param {number} [options.textureWidth=512] - Optional width of atlas, smaller values to reduce memory.
     * @param {number} [options.textureHeight=512] - Optional height of atlas, smaller values to reduce memory.
     * @param {number} [options.padding=4] - Padding between glyphs on texture atlas.
     * @return Font generated by style options.
     * @example
     * PIXI.BitmapFont.from("TitleFont", {
     *     fontFamily: "Arial",
     *     fontSize: 12,
     *     strokeThickness: 2,
     *     fill: "purple"
     * });
     *
     * const title = new PIXI.BitmapText("This is the title", { fontName: "TitleFont" });
     */ BitmapFont.from = function(name, textStyle, options) {
        if (!name) throw new Error('[BitmapFont] Property `name` is required.');
        var _a = Object.assign({}, BitmapFont.defaultOptions, options), chars = _a.chars, padding = _a.padding, resolution = _a.resolution, textureWidth = _a.textureWidth, textureHeight = _a.textureHeight;
        var charsList = $ca75a7df8c7436d8$var$resolveCharacters(chars);
        var style = textStyle instanceof (0, $9Pi8W.TextStyle) ? textStyle : new (0, $9Pi8W.TextStyle)(textStyle);
        var lineWidth = textureWidth;
        var fontData = new $ca75a7df8c7436d8$export$2fb2a0e272ba703b();
        fontData.info[0] = {
            face: style.fontFamily,
            size: style.fontSize
        };
        fontData.common[0] = {
            lineHeight: style.fontSize
        };
        var positionX = 0;
        var positionY = 0;
        var canvas;
        var context;
        var baseTexture;
        var maxCharHeight = 0;
        var textures = [];
        for(var i = 0; i < charsList.length; i++){
            if (!canvas) {
                canvas = document.createElement('canvas');
                canvas.width = textureWidth;
                canvas.height = textureHeight;
                context = canvas.getContext('2d');
                baseTexture = new (0, $klOfb.BaseTexture)(canvas, {
                    resolution: resolution
                });
                textures.push(new (0, $klOfb.Texture)(baseTexture));
                fontData.page.push({
                    id: textures.length - 1,
                    file: ''
                });
            }
            // Measure glyph dimensions
            var metrics = (0, $9Pi8W.TextMetrics).measureText(charsList[i], style, false, canvas);
            var width = metrics.width;
            var height = Math.ceil(metrics.height);
            // This is ugly - but italics are given more space so they don't overlap
            var textureGlyphWidth = Math.ceil((style.fontStyle === 'italic' ? 2 : 1) * width);
            // Can't fit char anymore: next canvas please!
            if (positionY >= textureHeight - height * resolution) {
                if (positionY === 0) // We don't want user debugging an infinite loop (or do we? :)
                throw new Error("[BitmapFont] textureHeight " + textureHeight + "px is " + ("too small for " + style.fontSize + "px fonts"));
                --i;
                // Create new atlas once current has filled up
                canvas = null;
                context = null;
                baseTexture = null;
                positionY = 0;
                positionX = 0;
                maxCharHeight = 0;
                continue;
            }
            maxCharHeight = Math.max(height + metrics.fontProperties.descent, maxCharHeight);
            // Wrap line once full row has been rendered
            if (textureGlyphWidth * resolution + positionX >= lineWidth) {
                --i;
                positionY += maxCharHeight * resolution;
                positionY = Math.ceil(positionY);
                positionX = 0;
                maxCharHeight = 0;
                continue;
            }
            $ca75a7df8c7436d8$var$drawGlyph(canvas, context, metrics, positionX, positionY, resolution, style);
            // Unique (numeric) ID mapping to this glyph
            var id = $ca75a7df8c7436d8$var$extractCharCode(metrics.text);
            // Create a texture holding just the glyph
            fontData.char.push({
                id: id,
                page: textures.length - 1,
                x: positionX / resolution,
                y: positionY / resolution,
                width: textureGlyphWidth,
                height: height,
                xoffset: 0,
                yoffset: 0,
                xadvance: Math.ceil(width - (style.dropShadow ? style.dropShadowDistance : 0) - (style.stroke ? style.strokeThickness : 0))
            });
            positionX += (textureGlyphWidth + 2 * padding) * resolution;
            positionX = Math.ceil(positionX);
        }
        // Brute-force kerning info, this can be expensive b/c it's an O(n²),
        // but we're using measureText which is native and fast.
        for(var i = 0, len = charsList.length; i < len; i++){
            var first = charsList[i];
            for(var j = 0; j < len; j++){
                var second = charsList[j];
                var c1 = context.measureText(first).width;
                var c2 = context.measureText(second).width;
                var total = context.measureText(first + second).width;
                var amount = total - (c1 + c2);
                if (amount) fontData.kerning.push({
                    first: $ca75a7df8c7436d8$var$extractCharCode(first),
                    second: $ca75a7df8c7436d8$var$extractCharCode(second),
                    amount: amount
                });
            }
        }
        var font = new BitmapFont(fontData, textures, true);
        // Make it easier to replace a font
        if (BitmapFont.available[name] !== undefined) BitmapFont.uninstall(name);
        BitmapFont.available[name] = font;
        return font;
    };
    /**
     * This character set includes all the letters in the alphabet (both lower- and upper- case).
     *
     * @type {string[][]}
     * @example
     * BitmapFont.from("ExampleFont", style, { chars: BitmapFont.ALPHA })
     */ BitmapFont.ALPHA = [
        [
            'a',
            'z'
        ],
        [
            'A',
            'Z'
        ],
        ' '
    ];
    /**
     * This character set includes all decimal digits (from 0 to 9).
     *
     * @type {string[][]}
     * @example
     * BitmapFont.from("ExampleFont", style, { chars: BitmapFont.NUMERIC })
     */ BitmapFont.NUMERIC = [
        [
            '0',
            '9'
        ]
    ];
    /**
     * This character set is the union of `BitmapFont.ALPHA` and `BitmapFont.NUMERIC`.
     *
     * @type {string[][]}
     */ BitmapFont.ALPHANUMERIC = [
        [
            'a',
            'z'
        ],
        [
            'A',
            'Z'
        ],
        [
            '0',
            '9'
        ],
        ' '
    ];
    /**
     * This character set consists of all the ASCII table.
     *
     * @member {string[][]}
     * @see http://www.asciitable.com/
     */ BitmapFont.ASCII = [
        [
            ' ',
            '~'
        ]
    ];
    /**
     * Collection of default options when using `BitmapFont.from`.
     *
     * @property {number} resolution=1
     * @property {number} textureWidth=512
     * @property {number} textureHeight=512
     * @property {number} padding=4
     * @property {string|string[]|string[][]} chars = PIXI.BitmapFont.ALPHANUMERIC
     */ BitmapFont.defaultOptions = {
        resolution: 1,
        textureWidth: 512,
        textureHeight: 512,
        padding: 4,
        chars: BitmapFont.ALPHANUMERIC
    };
    /** Collection of available/installed fonts. */ BitmapFont.available = {};
    return BitmapFont;
}();
var $ca75a7df8c7436d8$var$msdfFrag = "// Pixi texture info\r\nvarying vec2 vTextureCoord;\r\nuniform sampler2D uSampler;\r\n\r\n// Tint\r\nuniform vec4 uColor;\r\n\r\n// on 2D applications fwidth is screenScale / glyphAtlasScale * distanceFieldRange\r\nuniform float uFWidth;\r\n\r\nvoid main(void) {\r\n\r\n  // To stack MSDF and SDF we need a non-pre-multiplied-alpha texture.\r\n  vec4 texColor = texture2D(uSampler, vTextureCoord);\r\n\r\n  // MSDF\r\n  float median = texColor.r + texColor.g + texColor.b -\r\n                  min(texColor.r, min(texColor.g, texColor.b)) -\r\n                  max(texColor.r, max(texColor.g, texColor.b));\r\n  // SDF\r\n  median = min(median, texColor.a);\r\n\r\n  float screenPxDistance = uFWidth * (median - 0.5);\r\n  float alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);\r\n\r\n  // NPM Textures, NPM outputs\r\n  gl_FragColor = vec4(uColor.rgb, uColor.a * alpha);\r\n\r\n}\r\n";
var $ca75a7df8c7436d8$var$msdfVert = "// Mesh material default fragment\r\nattribute vec2 aVertexPosition;\r\nattribute vec2 aTextureCoord;\r\n\r\nuniform mat3 projectionMatrix;\r\nuniform mat3 translationMatrix;\r\nuniform mat3 uTextureMatrix;\r\n\r\nvarying vec2 vTextureCoord;\r\n\r\nvoid main(void)\r\n{\r\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\r\n\r\n    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;\r\n}\r\n";
// If we ever need more than two pools, please make a Dict or something better.
var $ca75a7df8c7436d8$var$pageMeshDataDefaultPageMeshData = [];
var $ca75a7df8c7436d8$var$pageMeshDataMSDFPageMeshData = [];
var $ca75a7df8c7436d8$var$charRenderDataPool = [];
/**
 * A BitmapText object will create a line or multiple lines of text using bitmap font.
 *
 * The primary advantage of this class over Text is that all of your textures are pre-generated and loading,
 * meaning that rendering is fast, and changing text has no performance implications.
 *
 * Supporting character sets other than latin, such as CJK languages, may be impractical due to the number of characters.
 *
 * To split a line you can use '\n', '\r' or '\r\n' in your string.
 *
 * PixiJS can auto-generate fonts on-the-fly using BitmapFont or use fnt files provided by:
 * http://www.angelcode.com/products/bmfont/ for Windows or
 * http://www.bmglyph.com/ for Mac.
 *
 * You can also use SDF, MSDF and MTSDF BitmapFonts for vector-like scaling appearance provided by:
 * https://github.com/soimy/msdf-bmfont-xml for SDF and MSDF fnt files or
 * https://github.com/Chlumsky/msdf-atlas-gen for SDF, MSDF and MTSDF json files
 *
 * A BitmapText can only be created when the font is loaded.
 *
 * ```js
 * // in this case the font is in a file called 'desyrel.fnt'
 * let bitmapText = new PIXI.BitmapText("text using a fancy font!", {
 *   fontName: "Desyrel",
 *   fontSize: 35,
 *   align: "right"
 * });
 * ```
 *
 * @memberof PIXI
 */ var $ca75a7df8c7436d8$export$ae0da96467efdba0 = /** @class */ function(_super) {
    $ca75a7df8c7436d8$var$__extends(BitmapText, _super);
    /**
     * @param text - A string that you would like the text to display.
     * @param style - The style parameters.
     * @param {string} style.fontName - The installed BitmapFont name.
     * @param {number} [style.fontSize] - The size of the font in pixels, e.g. 24. If undefined,
     *.     this will default to the BitmapFont size.
     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center', 'right' or 'justify'),
     *      does not affect single line text.
     * @param {number} [style.tint=0xFFFFFF] - The tint color.
     * @param {number} [style.letterSpacing=0] - The amount of spacing between letters.
     * @param {number} [style.maxWidth=0] - The max width of the text before line wrapping.
     */ function BitmapText(text, style) {
        if (style === void 0) style = {};
        var _this = _super.call(this) || this;
        /**
         * Private tracker for the current tint.
         *
         * @private
         */ _this._tint = 0xFFFFFF;
        // Apply the defaults
        var _a = Object.assign({}, BitmapText.styleDefaults, style), align = _a.align, tint = _a.tint, maxWidth = _a.maxWidth, letterSpacing = _a.letterSpacing, fontName = _a.fontName, fontSize = _a.fontSize;
        if (!$ca75a7df8c7436d8$export$17957a09927cadc7.available[fontName]) throw new Error("Missing BitmapFont \"" + fontName + "\"");
        _this._activePagesMeshData = [];
        _this._textWidth = 0;
        _this._textHeight = 0;
        _this._align = align;
        _this._tint = tint;
        _this._fontName = fontName;
        _this._fontSize = fontSize || $ca75a7df8c7436d8$export$17957a09927cadc7.available[fontName].size;
        _this._text = text;
        _this._maxWidth = maxWidth;
        _this._maxLineHeight = 0;
        _this._letterSpacing = letterSpacing;
        _this._anchor = new (0, $6qzqq.ObservablePoint)(function() {
            _this.dirty = true;
        }, _this, 0, 0);
        _this._roundPixels = (0, $ezJmd.settings).ROUND_PIXELS;
        _this.dirty = true;
        _this._textureCache = {};
        return _this;
    }
    /**
     * Renders text and updates it when needed. This should only be called
     * if the BitmapFont is regenerated.
     */ BitmapText.prototype.updateText = function() {
        var _a;
        var data = $ca75a7df8c7436d8$export$17957a09927cadc7.available[this._fontName];
        var scale = this._fontSize / data.size;
        var pos = new (0, $6qzqq.Point)();
        var chars = [];
        var lineWidths = [];
        var lineSpaces = [];
        var text = this._text.replace(/(?:\r\n|\r)/g, '\n') || ' ';
        var charsInput = $ca75a7df8c7436d8$var$splitTextToCharacters(text);
        var maxWidth = this._maxWidth * data.size / this._fontSize;
        var pageMeshDataPool = data.distanceFieldType === 'none' ? $ca75a7df8c7436d8$var$pageMeshDataDefaultPageMeshData : $ca75a7df8c7436d8$var$pageMeshDataMSDFPageMeshData;
        var prevCharCode = null;
        var lastLineWidth = 0;
        var maxLineWidth = 0;
        var line = 0;
        var lastBreakPos = -1;
        var lastBreakWidth = 0;
        var spacesRemoved = 0;
        var maxLineHeight = 0;
        var spaceCount = 0;
        for(var i = 0; i < charsInput.length; i++){
            var char = charsInput[i];
            var charCode = $ca75a7df8c7436d8$var$extractCharCode(char);
            if (/(?:\s)/.test(char)) {
                lastBreakPos = i;
                lastBreakWidth = lastLineWidth;
                spaceCount++;
            }
            if (char === '\r' || char === '\n') {
                lineWidths.push(lastLineWidth);
                lineSpaces.push(-1);
                maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
                ++line;
                ++spacesRemoved;
                pos.x = 0;
                pos.y += data.lineHeight;
                prevCharCode = null;
                spaceCount = 0;
                continue;
            }
            var charData = data.chars[charCode];
            if (!charData) continue;
            if (prevCharCode && charData.kerning[prevCharCode]) pos.x += charData.kerning[prevCharCode];
            var charRenderData = $ca75a7df8c7436d8$var$charRenderDataPool.pop() || {
                texture: (0, $klOfb.Texture).EMPTY,
                line: 0,
                charCode: 0,
                prevSpaces: 0,
                position: new (0, $6qzqq.Point)()
            };
            charRenderData.texture = charData.texture;
            charRenderData.line = line;
            charRenderData.charCode = charCode;
            charRenderData.position.x = pos.x + charData.xOffset + this._letterSpacing / 2;
            charRenderData.position.y = pos.y + charData.yOffset;
            charRenderData.prevSpaces = spaceCount;
            chars.push(charRenderData);
            lastLineWidth = charRenderData.position.x + charData.texture.orig.width; // Use charRenderData position!
            pos.x += charData.xAdvance + this._letterSpacing;
            maxLineHeight = Math.max(maxLineHeight, charData.yOffset + charData.texture.height);
            prevCharCode = charCode;
            if (lastBreakPos !== -1 && maxWidth > 0 && pos.x > maxWidth) {
                ++spacesRemoved;
                (0, $csytw.removeItems)(chars, 1 + lastBreakPos - spacesRemoved, 1 + i - lastBreakPos);
                i = lastBreakPos;
                lastBreakPos = -1;
                lineWidths.push(lastBreakWidth);
                lineSpaces.push(chars.length > 0 ? chars[chars.length - 1].prevSpaces : 0);
                maxLineWidth = Math.max(maxLineWidth, lastBreakWidth);
                line++;
                pos.x = 0;
                pos.y += data.lineHeight;
                prevCharCode = null;
                spaceCount = 0;
            }
        }
        var lastChar = charsInput[charsInput.length - 1];
        if (lastChar !== '\r' && lastChar !== '\n') {
            if (/(?:\s)/.test(lastChar)) lastLineWidth = lastBreakWidth;
            lineWidths.push(lastLineWidth);
            maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
            lineSpaces.push(-1);
        }
        var lineAlignOffsets = [];
        for(var i = 0; i <= line; i++){
            var alignOffset = 0;
            if (this._align === 'right') alignOffset = maxLineWidth - lineWidths[i];
            else if (this._align === 'center') alignOffset = (maxLineWidth - lineWidths[i]) / 2;
            else if (this._align === 'justify') alignOffset = lineSpaces[i] < 0 ? 0 : (maxLineWidth - lineWidths[i]) / lineSpaces[i];
            lineAlignOffsets.push(alignOffset);
        }
        var lenChars = chars.length;
        var pagesMeshData = {};
        var newPagesMeshData = [];
        var activePagesMeshData = this._activePagesMeshData;
        for(var i = 0; i < activePagesMeshData.length; i++)pageMeshDataPool.push(activePagesMeshData[i]);
        for(var i = 0; i < lenChars; i++){
            var texture = chars[i].texture;
            var baseTextureUid = texture.baseTexture.uid;
            if (!pagesMeshData[baseTextureUid]) {
                var pageMeshData = pageMeshDataPool.pop();
                if (!pageMeshData) {
                    var geometry = new (0, $9Tsx3.MeshGeometry)();
                    var material = void 0;
                    var meshBlendMode = void 0;
                    if (data.distanceFieldType === 'none') {
                        material = new (0, $9Tsx3.MeshMaterial)((0, $klOfb.Texture).EMPTY);
                        meshBlendMode = (0, $P8XPi.BLEND_MODES).NORMAL;
                    } else {
                        material = new (0, $9Tsx3.MeshMaterial)((0, $klOfb.Texture).EMPTY, {
                            program: (0, $klOfb.Program).from($ca75a7df8c7436d8$var$msdfVert, $ca75a7df8c7436d8$var$msdfFrag),
                            uniforms: {
                                uFWidth: 0
                            }
                        });
                        meshBlendMode = (0, $P8XPi.BLEND_MODES).NORMAL_NPM;
                    }
                    var mesh = new (0, $9Tsx3.Mesh)(geometry, material);
                    mesh.blendMode = meshBlendMode;
                    pageMeshData = {
                        index: 0,
                        indexCount: 0,
                        vertexCount: 0,
                        uvsCount: 0,
                        total: 0,
                        mesh: mesh,
                        vertices: null,
                        uvs: null,
                        indices: null
                    };
                }
                // reset data..
                pageMeshData.index = 0;
                pageMeshData.indexCount = 0;
                pageMeshData.vertexCount = 0;
                pageMeshData.uvsCount = 0;
                pageMeshData.total = 0;
                // TODO need to get page texture here somehow..
                var _textureCache = this._textureCache;
                _textureCache[baseTextureUid] = _textureCache[baseTextureUid] || new (0, $klOfb.Texture)(texture.baseTexture);
                pageMeshData.mesh.texture = _textureCache[baseTextureUid];
                pageMeshData.mesh.tint = this._tint;
                newPagesMeshData.push(pageMeshData);
                pagesMeshData[baseTextureUid] = pageMeshData;
            }
            pagesMeshData[baseTextureUid].total++;
        }
        // lets find any previously active pageMeshDatas that are no longer required for
        // the updated text (if any), removed and return them to the pool.
        for(var i = 0; i < activePagesMeshData.length; i++)if (newPagesMeshData.indexOf(activePagesMeshData[i]) === -1) this.removeChild(activePagesMeshData[i].mesh);
        // next lets add any new meshes, that have not yet been added to this BitmapText
        // we only add if its not already a child of this BitmapObject
        for(var i = 0; i < newPagesMeshData.length; i++)if (newPagesMeshData[i].mesh.parent !== this) this.addChild(newPagesMeshData[i].mesh);
        // active page mesh datas are set to be the new pages added.
        this._activePagesMeshData = newPagesMeshData;
        for(var i in pagesMeshData){
            var pageMeshData = pagesMeshData[i];
            var total = pageMeshData.total;
            // lets only allocate new buffers if we can fit the new text in the current ones..
            // unless that is, we will be batching. Currently batching dose not respect the size property of mesh
            if (!(((_a = pageMeshData.indices) === null || _a === void 0 ? void 0 : _a.length) > 6 * total) || pageMeshData.vertices.length < (0, $9Tsx3.Mesh).BATCHABLE_SIZE * 2) {
                pageMeshData.vertices = new Float32Array(8 * total);
                pageMeshData.uvs = new Float32Array(8 * total);
                pageMeshData.indices = new Uint16Array(6 * total);
            } else {
                var total_1 = pageMeshData.total;
                var vertices = pageMeshData.vertices;
                // Clear the garbage at the end of the vertices buffer. This will prevent the bounds miscalculation.
                for(var i_1 = total_1 * 8; i_1 < vertices.length; i_1++)vertices[i_1] = 0;
            }
            // as a buffer maybe bigger than the current word, we set the size of the meshMaterial
            // to match the number of letters needed
            pageMeshData.mesh.size = 6 * total;
        }
        for(var i = 0; i < lenChars; i++){
            var char = chars[i];
            var offset = char.position.x + lineAlignOffsets[char.line] * (this._align === 'justify' ? char.prevSpaces : 1);
            if (this._roundPixels) offset = Math.round(offset);
            var xPos = offset * scale;
            var yPos = char.position.y * scale;
            var texture = char.texture;
            var pageMesh = pagesMeshData[texture.baseTexture.uid];
            var textureFrame = texture.frame;
            var textureUvs = texture._uvs;
            var index = pageMesh.index++;
            pageMesh.indices[index * 6 + 0] = 0 + index * 4;
            pageMesh.indices[index * 6 + 1] = 1 + index * 4;
            pageMesh.indices[index * 6 + 2] = 2 + index * 4;
            pageMesh.indices[index * 6 + 3] = 0 + index * 4;
            pageMesh.indices[index * 6 + 4] = 2 + index * 4;
            pageMesh.indices[index * 6 + 5] = 3 + index * 4;
            pageMesh.vertices[index * 8 + 0] = xPos;
            pageMesh.vertices[index * 8 + 1] = yPos;
            pageMesh.vertices[index * 8 + 2] = xPos + textureFrame.width * scale;
            pageMesh.vertices[index * 8 + 3] = yPos;
            pageMesh.vertices[index * 8 + 4] = xPos + textureFrame.width * scale;
            pageMesh.vertices[index * 8 + 5] = yPos + textureFrame.height * scale;
            pageMesh.vertices[index * 8 + 6] = xPos;
            pageMesh.vertices[index * 8 + 7] = yPos + textureFrame.height * scale;
            pageMesh.uvs[index * 8 + 0] = textureUvs.x0;
            pageMesh.uvs[index * 8 + 1] = textureUvs.y0;
            pageMesh.uvs[index * 8 + 2] = textureUvs.x1;
            pageMesh.uvs[index * 8 + 3] = textureUvs.y1;
            pageMesh.uvs[index * 8 + 4] = textureUvs.x2;
            pageMesh.uvs[index * 8 + 5] = textureUvs.y2;
            pageMesh.uvs[index * 8 + 6] = textureUvs.x3;
            pageMesh.uvs[index * 8 + 7] = textureUvs.y3;
        }
        this._textWidth = maxLineWidth * scale;
        this._textHeight = (pos.y + data.lineHeight) * scale;
        for(var i in pagesMeshData){
            var pageMeshData = pagesMeshData[i];
            // apply anchor
            if (this.anchor.x !== 0 || this.anchor.y !== 0) {
                var vertexCount = 0;
                var anchorOffsetX = this._textWidth * this.anchor.x;
                var anchorOffsetY = this._textHeight * this.anchor.y;
                for(var i_2 = 0; i_2 < pageMeshData.total; i_2++){
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetX;
                    pageMeshData.vertices[vertexCount++] -= anchorOffsetY;
                }
            }
            this._maxLineHeight = maxLineHeight * scale;
            var vertexBuffer = pageMeshData.mesh.geometry.getBuffer('aVertexPosition');
            var textureBuffer = pageMeshData.mesh.geometry.getBuffer('aTextureCoord');
            var indexBuffer = pageMeshData.mesh.geometry.getIndex();
            vertexBuffer.data = pageMeshData.vertices;
            textureBuffer.data = pageMeshData.uvs;
            indexBuffer.data = pageMeshData.indices;
            vertexBuffer.update();
            textureBuffer.update();
            indexBuffer.update();
        }
        for(var i = 0; i < chars.length; i++)$ca75a7df8c7436d8$var$charRenderDataPool.push(chars[i]);
    };
    BitmapText.prototype.updateTransform = function() {
        this.validate();
        this.containerUpdateTransform();
    };
    BitmapText.prototype._render = function(renderer) {
        // Update the uniform
        var _a = $ca75a7df8c7436d8$export$17957a09927cadc7.available[this._fontName], distanceFieldRange = _a.distanceFieldRange, distanceFieldType = _a.distanceFieldType, size = _a.size;
        if (distanceFieldType !== 'none') {
            // Inject the shader code with the correct value
            var _b = this.worldTransform, a = _b.a, b = _b.b, c = _b.c, d = _b.d;
            var dx = Math.sqrt(a * a + b * b);
            var dy = Math.sqrt(c * c + d * d);
            var worldScale = (Math.abs(dx) + Math.abs(dy)) / 2;
            var fontScale = this._fontSize / size;
            for(var _i = 0, _c = this._activePagesMeshData; _i < _c.length; _i++){
                var mesh = _c[_i];
                mesh.mesh.shader.uniforms.uFWidth = worldScale * distanceFieldRange * fontScale * renderer.resolution;
            }
        }
        _super.prototype._render.call(this, renderer);
    };
    /**
     * Validates text before calling parent's getLocalBounds
     *
     * @return - The rectangular bounding area
     */ BitmapText.prototype.getLocalBounds = function() {
        this.validate();
        return _super.prototype.getLocalBounds.call(this);
    };
    /**
     * Updates text when needed
     *
     * @private
     */ BitmapText.prototype.validate = function() {
        if (this.dirty) {
            this.updateText();
            this.dirty = false;
        }
    };
    Object.defineProperty(BitmapText.prototype, "tint", {
        /**
         * The tint of the BitmapText object.
         *
         * @default 0xffffff
         */ get: function() {
            return this._tint;
        },
        set: function(value) {
            if (this._tint === value) return;
            this._tint = value;
            for(var i = 0; i < this._activePagesMeshData.length; i++)this._activePagesMeshData[i].mesh.tint = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "align", {
        /**
         * The alignment of the BitmapText object.
         *
         * @member {string}
         * @default 'left'
         */ get: function() {
            return this._align;
        },
        set: function(value) {
            if (this._align !== value) {
                this._align = value;
                this.dirty = true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "fontName", {
        /** The name of the BitmapFont. */ get: function() {
            return this._fontName;
        },
        set: function(value) {
            if (!$ca75a7df8c7436d8$export$17957a09927cadc7.available[value]) throw new Error("Missing BitmapFont \"" + value + "\"");
            if (this._fontName !== value) {
                this._fontName = value;
                this.dirty = true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "fontSize", {
        /** The size of the font to display. */ get: function() {
            return this._fontSize;
        },
        set: function(value) {
            if (this._fontSize !== value) {
                this._fontSize = value;
                this.dirty = true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "anchor", {
        /**
         * The anchor sets the origin point of the text.
         *
         * The default is `(0,0)`, this means the text's origin is the top left.
         *
         * Setting the anchor to `(0.5,0.5)` means the text's origin is centered.
         *
         * Setting the anchor to `(1,1)` would mean the text's origin point will be the bottom right corner.
         */ get: function() {
            return this._anchor;
        },
        set: function(value) {
            if (typeof value === 'number') this._anchor.set(value);
            else this._anchor.copyFrom(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "text", {
        /** The text of the BitmapText object. */ get: function() {
            return this._text;
        },
        set: function(text) {
            text = String(text === null || text === undefined ? '' : text);
            if (this._text === text) return;
            this._text = text;
            this.dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "maxWidth", {
        /**
         * The max width of this bitmap text in pixels. If the text provided is longer than the
         * value provided, line breaks will be automatically inserted in the last whitespace.
         * Disable by setting the value to 0.
         */ get: function() {
            return this._maxWidth;
        },
        set: function(value) {
            if (this._maxWidth === value) return;
            this._maxWidth = value;
            this.dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "maxLineHeight", {
        /**
         * The max line height. This is useful when trying to use the total height of the Text,
         * i.e. when trying to vertically align.
         *
         * @readonly
         */ get: function() {
            this.validate();
            return this._maxLineHeight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "textWidth", {
        /**
         * The width of the overall text, different from fontSize,
         * which is defined in the style object.
         *
         * @readonly
         */ get: function() {
            this.validate();
            return this._textWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "letterSpacing", {
        /** Additional space between characters. */ get: function() {
            return this._letterSpacing;
        },
        set: function(value) {
            if (this._letterSpacing !== value) {
                this._letterSpacing = value;
                this.dirty = true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "roundPixels", {
        /**
         * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
         * Advantages can include sharper image quality (like text) and faster rendering on canvas.
         * The main disadvantage is movement of objects may appear less smooth.
         * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
         *
         * @default PIXI.settings.ROUND_PIXELS
         */ get: function() {
            return this._roundPixels;
        },
        set: function(value) {
            if (value !== this._roundPixels) {
                this._roundPixels = value;
                this.dirty = true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapText.prototype, "textHeight", {
        /**
         * The height of the overall text, different from fontSize,
         * which is defined in the style object.
         *
         * @readonly
         */ get: function() {
            this.validate();
            return this._textHeight;
        },
        enumerable: false,
        configurable: true
    });
    BitmapText.prototype.destroy = function(options) {
        var _textureCache = this._textureCache;
        for(var id in _textureCache){
            var texture = _textureCache[id];
            texture.destroy();
            delete _textureCache[id];
        }
        this._textureCache = null;
        _super.prototype.destroy.call(this, options);
    };
    BitmapText.styleDefaults = {
        align: 'left',
        tint: 0xFFFFFF,
        maxWidth: 0,
        letterSpacing: 0
    };
    return BitmapText;
}((0, $8t5Gy.Container));
/**
 * {@link PIXI.Loader Loader} middleware for loading
 * bitmap-based fonts suitable for using with {@link PIXI.BitmapText}.
 *
 * @memberof PIXI
 */ var $ca75a7df8c7436d8$export$d4a75f306c6c494f = /** @class */ function() {
    function BitmapFontLoader() {}
    /**
     * Called when the plugin is installed.
     *
     * @see PIXI.Loader.registerPlugin
     */ BitmapFontLoader.add = function() {
        (0, $kXE1p.LoaderResource).setExtensionXhrType('fnt', (0, $kXE1p.LoaderResource).XHR_RESPONSE_TYPE.TEXT);
    };
    /**
     * Called after a resource is loaded.
     *
     * @see PIXI.Loader.loaderMiddleware
     * @param {PIXI.LoaderResource} resource
     * @param {function} next
     */ BitmapFontLoader.use = function(resource, next) {
        var format = $ca75a7df8c7436d8$var$autoDetectFormat(resource.data);
        // Resource was not recognised as any of the expected font data format
        if (!format) {
            next();
            return;
        }
        var baseUrl = BitmapFontLoader.getBaseUrl(this, resource);
        var data = format.parse(resource.data);
        var textures = {};
        // Handle completed, when the number of textures
        // load is the same number as references in the fnt file
        var completed = function(page) {
            textures[page.metadata.pageFile] = page.texture;
            if (Object.keys(textures).length === data.page.length) {
                resource.bitmapFont = $ca75a7df8c7436d8$export$17957a09927cadc7.install(data, textures, true);
                next();
            }
        };
        for(var i = 0; i < data.page.length; ++i){
            var pageFile = data.page[i].file;
            var url = baseUrl + pageFile;
            var exists = false;
            // incase the image is loaded outside
            // using the same loader, resource will be available
            for(var name in this.resources){
                var bitmapResource = this.resources[name];
                if (bitmapResource.url === url) {
                    bitmapResource.metadata.pageFile = pageFile;
                    if (bitmapResource.texture) completed(bitmapResource);
                    else bitmapResource.onAfterMiddleware.add(completed);
                    exists = true;
                    break;
                }
            }
            // texture is not loaded, we'll attempt to add
            // it to the load and add the texture to the list
            if (!exists) {
                // Standard loading options for images
                var options = {
                    crossOrigin: resource.crossOrigin,
                    loadType: (0, $kXE1p.LoaderResource).LOAD_TYPE.IMAGE,
                    metadata: Object.assign({
                        pageFile: pageFile
                    }, resource.metadata.imageMetadata),
                    parentResource: resource
                };
                this.add(url, options, completed);
            }
        }
    };
    /** Get folder path from a resource. */ BitmapFontLoader.getBaseUrl = function(loader, resource) {
        var resUrl = !resource.isDataUrl ? BitmapFontLoader.dirname(resource.url) : '';
        if (resource.isDataUrl) {
            if (resUrl === '.') resUrl = '';
            if (loader.baseUrl && resUrl) // if baseurl has a trailing slash then add one to resUrl so the replace works below
            {
                if (loader.baseUrl.charAt(loader.baseUrl.length - 1) === '/') resUrl += '/';
            }
        }
        // remove baseUrl from resUrl
        resUrl = resUrl.replace(loader.baseUrl, '');
        // if there is an resUrl now, it needs a trailing slash. Ensure that it does if the string isn't empty.
        if (resUrl && resUrl.charAt(resUrl.length - 1) !== '/') resUrl += '/';
        return resUrl;
    };
    /**
     * Replacement for NodeJS's path.dirname
     *
     * @param {string} url - Path to get directory for
     */ BitmapFontLoader.dirname = function(url) {
        var dir = url.replace(/\\/g, '/') // convert windows notation to UNIX notation, URL-safe because it's a forbidden character
        .replace(/\/$/, '') // replace trailing slash
        .replace(/\/[^\/]*$/, ''); // remove everything after the last
        // File request is relative, use current directory
        if (dir === url) return '.';
        else if (dir === '') return '/';
        return dir;
    };
    return BitmapFontLoader;
}();

});
parcelRegister("9Tsx3", function(module, exports) {

$parcel$export(module.exports, "MeshBatchUvs", function () { return $733f620544d369b5$export$49cc356fa6ba0e7b; });
$parcel$export(module.exports, "Mesh", function () { return $733f620544d369b5$export$e176487c05830cc5; });
$parcel$export(module.exports, "MeshMaterial", function () { return $733f620544d369b5$export$d552dadfd66cc650; });
$parcel$export(module.exports, "MeshGeometry", function () { return $733f620544d369b5$export$8d075a36a73d54bc; });
/*!
 * @pixi/mesh - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/mesh is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $6qzqq = parcelRequire("6qzqq");

var $P8XPi = parcelRequire("P8XPi");

var $8t5Gy = parcelRequire("8t5Gy");

var $ezJmd = parcelRequire("ezJmd");

var $csytw = parcelRequire("csytw");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $733f620544d369b5$var$extendStatics = function(d, b) {
    $733f620544d369b5$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $733f620544d369b5$var$extendStatics(d, b);
};
function $733f620544d369b5$var$__extends(d, b) {
    $733f620544d369b5$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * Class controls cache for UV mapping from Texture normal space to BaseTexture normal space.
 *
 * @class
 * @memberof PIXI
 */ var $733f620544d369b5$export$49cc356fa6ba0e7b = /** @class */ function() {
    /**
     * @param {PIXI.Buffer} uvBuffer - Buffer with normalized uv's
     * @param {PIXI.TextureMatrix} uvMatrix - Material UV matrix
     */ function MeshBatchUvs(uvBuffer, uvMatrix) {
        /**
         * Buffer with normalized UV's
         * @member {PIXI.Buffer}
         */ this.uvBuffer = uvBuffer;
        /**
         * Material UV matrix
         * @member {PIXI.TextureMatrix}
         */ this.uvMatrix = uvMatrix;
        /**
         * UV Buffer data
         * @member {Float32Array}
         * @readonly
         */ this.data = null;
        this._bufferUpdateId = -1;
        this._textureUpdateId = -1;
        this._updateID = 0;
    }
    /**
     * updates
     *
     * @param {boolean} [forceUpdate] - force the update
     */ MeshBatchUvs.prototype.update = function(forceUpdate) {
        if (!forceUpdate && this._bufferUpdateId === this.uvBuffer._updateID && this._textureUpdateId === this.uvMatrix._updateID) return;
        this._bufferUpdateId = this.uvBuffer._updateID;
        this._textureUpdateId = this.uvMatrix._updateID;
        var data = this.uvBuffer.data;
        if (!this.data || this.data.length !== data.length) this.data = new Float32Array(data.length);
        this.uvMatrix.multiplyUvs(data, this.data);
        this._updateID++;
    };
    return MeshBatchUvs;
}();
var $733f620544d369b5$var$tempPoint = new (0, $6qzqq.Point)();
var $733f620544d369b5$var$tempPolygon = new (0, $6qzqq.Polygon)();
/**
 * Base mesh class.
 *
 * This class empowers you to have maximum flexibility to render any kind of WebGL visuals you can think of.
 * This class assumes a certain level of WebGL knowledge.
 * If you know a bit this should abstract enough away to make your life easier!
 *
 * Pretty much ALL WebGL can be broken down into the following:
 * - Geometry - The structure and data for the mesh. This can include anything from positions, uvs, normals, colors etc..
 * - Shader - This is the shader that PixiJS will render the geometry with (attributes in the shader must match the geometry)
 * - State - This is the state of WebGL required to render the mesh.
 *
 * Through a combination of the above elements you can render anything you want, 2D or 3D!
 *
 * @memberof PIXI
 */ var $733f620544d369b5$export$e176487c05830cc5 = /** @class */ function(_super) {
    $733f620544d369b5$var$__extends(Mesh, _super);
    /**
     * @param geometry - The geometry the mesh will use.
     * @param {PIXI.MeshMaterial} shader - The shader the mesh will use.
     * @param state - The state that the WebGL context is required to be in to render the mesh
     *        if no state is provided, uses {@link PIXI.State.for2d} to create a 2D state for PixiJS.
     * @param drawMode - The drawMode, can be any of the {@link PIXI.DRAW_MODES} constants.
     */ function Mesh(geometry, shader, state, drawMode) {
        if (drawMode === void 0) drawMode = (0, $P8XPi.DRAW_MODES).TRIANGLES;
        var _this = _super.call(this) || this;
        _this.geometry = geometry;
        _this.shader = shader;
        _this.state = state || (0, $klOfb.State).for2d();
        _this.drawMode = drawMode;
        _this.start = 0;
        _this.size = 0;
        _this.uvs = null;
        _this.indices = null;
        _this.vertexData = new Float32Array(1);
        _this.vertexDirty = -1;
        _this._transformID = -1;
        _this._roundPixels = (0, $ezJmd.settings).ROUND_PIXELS;
        _this.batchUvs = null;
        return _this;
    }
    Object.defineProperty(Mesh.prototype, "geometry", {
        /**
         * Includes vertex positions, face indices, normals, colors, UVs, and
         * custom attributes within buffers, reducing the cost of passing all
         * this data to the GPU. Can be shared between multiple Mesh objects.
         */ get: function() {
            return this._geometry;
        },
        set: function(value) {
            if (this._geometry === value) return;
            if (this._geometry) {
                this._geometry.refCount--;
                if (this._geometry.refCount === 0) this._geometry.dispose();
            }
            this._geometry = value;
            if (this._geometry) this._geometry.refCount++;
            this.vertexDirty = -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "uvBuffer", {
        /**
         * To change mesh uv's, change its uvBuffer data and increment its _updateID.
         *
         * @readonly
         */ get: function() {
            return this.geometry.buffers[1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "verticesBuffer", {
        /**
         * To change mesh vertices, change its uvBuffer data and increment its _updateID.
         * Incrementing _updateID is optional because most of Mesh objects do it anyway.
         *
         * @readonly
         */ get: function() {
            return this.geometry.buffers[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "material", {
        get: function() {
            return this.shader;
        },
        /** Alias for {@link PIXI.Mesh#shader}. */ set: function(value) {
            this.shader = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "blendMode", {
        get: function() {
            return this.state.blendMode;
        },
        /**
         * The blend mode to be applied to the Mesh. Apply a value of
         * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
         *
         * @default PIXI.BLEND_MODES.NORMAL;
         */ set: function(value) {
            this.state.blendMode = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "roundPixels", {
        get: function() {
            return this._roundPixels;
        },
        /**
         * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
         * Advantages can include sharper image quality (like text) and faster rendering on canvas.
         * The main disadvantage is movement of objects may appear less smooth.
         * To set the global default, change {@link PIXI.settings.ROUND_PIXELS}
         *
         * @default false
         */ set: function(value) {
            if (this._roundPixels !== value) this._transformID = -1;
            this._roundPixels = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "tint", {
        /**
         * The multiply tint applied to the Mesh. This is a hex value. A value of
         * `0xFFFFFF` will remove any tint effect.
         *
         * Null for non-MeshMaterial shaders
         *
         * @default 0xFFFFFF
         */ get: function() {
            return 'tint' in this.shader ? this.shader.tint : null;
        },
        set: function(value) {
            this.shader.tint = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mesh.prototype, "texture", {
        /**
         * The texture that the Mesh uses.
         *
         * Null for non-MeshMaterial shaders
         */ get: function() {
            return 'texture' in this.shader ? this.shader.texture : null;
        },
        set: function(value) {
            this.shader.texture = value;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Standard renderer draw.
     *
     * @param renderer - Instance to renderer.
     */ Mesh.prototype._render = function(renderer) {
        // set properties for batching..
        // TODO could use a different way to grab verts?
        var vertices = this.geometry.buffers[0].data;
        var shader = this.shader;
        // TODO benchmark check for attribute size..
        if (shader.batchable && this.drawMode === (0, $P8XPi.DRAW_MODES).TRIANGLES && vertices.length < Mesh.BATCHABLE_SIZE * 2) this._renderToBatch(renderer);
        else this._renderDefault(renderer);
    };
    /**
     * Standard non-batching way of rendering.
     *
     * @param renderer - Instance to renderer.
     */ Mesh.prototype._renderDefault = function(renderer) {
        var shader = this.shader;
        shader.alpha = this.worldAlpha;
        if (shader.update) shader.update();
        renderer.batch.flush();
        // bind and sync uniforms..
        shader.uniforms.translationMatrix = this.transform.worldTransform.toArray(true);
        renderer.shader.bind(shader);
        // set state..
        renderer.state.set(this.state);
        // bind the geometry...
        renderer.geometry.bind(this.geometry, shader);
        // then render it
        renderer.geometry.draw(this.drawMode, this.size, this.start, this.geometry.instanceCount);
    };
    /**
     * Rendering by using the Batch system.
     *
     * @param renderer - Instance to renderer.
     */ Mesh.prototype._renderToBatch = function(renderer) {
        var geometry = this.geometry;
        var shader = this.shader;
        if (shader.uvMatrix) {
            shader.uvMatrix.update();
            this.calculateUvs();
        }
        // set properties for batching..
        this.calculateVertices();
        this.indices = geometry.indexBuffer.data;
        this._tintRGB = shader._tintRGB;
        this._texture = shader.texture;
        var pluginName = this.material.pluginName;
        renderer.batch.setObjectRenderer(renderer.plugins[pluginName]);
        renderer.plugins[pluginName].render(this);
    };
    /** Updates vertexData field based on transform and vertices. */ Mesh.prototype.calculateVertices = function() {
        var geometry = this.geometry;
        var verticesBuffer = geometry.buffers[0];
        var vertices = verticesBuffer.data;
        var vertexDirtyId = verticesBuffer._updateID;
        if (vertexDirtyId === this.vertexDirty && this._transformID === this.transform._worldID) return;
        this._transformID = this.transform._worldID;
        if (this.vertexData.length !== vertices.length) this.vertexData = new Float32Array(vertices.length);
        var wt = this.transform.worldTransform;
        var a = wt.a;
        var b = wt.b;
        var c = wt.c;
        var d = wt.d;
        var tx = wt.tx;
        var ty = wt.ty;
        var vertexData = this.vertexData;
        for(var i = 0; i < vertexData.length / 2; i++){
            var x = vertices[i * 2];
            var y = vertices[i * 2 + 1];
            vertexData[i * 2] = a * x + c * y + tx;
            vertexData[i * 2 + 1] = b * x + d * y + ty;
        }
        if (this._roundPixels) {
            var resolution = (0, $ezJmd.settings).RESOLUTION;
            for(var i = 0; i < vertexData.length; ++i)vertexData[i] = Math.round((vertexData[i] * resolution | 0) / resolution);
        }
        this.vertexDirty = vertexDirtyId;
    };
    /** Updates uv field based on from geometry uv's or batchUvs. */ Mesh.prototype.calculateUvs = function() {
        var geomUvs = this.geometry.buffers[1];
        var shader = this.shader;
        if (!shader.uvMatrix.isSimple) {
            if (!this.batchUvs) this.batchUvs = new $733f620544d369b5$export$49cc356fa6ba0e7b(geomUvs, shader.uvMatrix);
            this.batchUvs.update();
            this.uvs = this.batchUvs.data;
        } else this.uvs = geomUvs.data;
    };
    /**
     * Updates the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
     * there must be a aVertexPosition attribute present in the geometry for bounds to be calculated correctly.
     */ Mesh.prototype._calculateBounds = function() {
        this.calculateVertices();
        this._bounds.addVertexData(this.vertexData, 0, this.vertexData.length);
    };
    /**
     * Tests if a point is inside this mesh. Works only for PIXI.DRAW_MODES.TRIANGLES.
     *
     * @param point - The point to test.
     * @return - The result of the test.
     */ Mesh.prototype.containsPoint = function(point) {
        if (!this.getBounds().contains(point.x, point.y)) return false;
        this.worldTransform.applyInverse(point, $733f620544d369b5$var$tempPoint);
        var vertices = this.geometry.getBuffer('aVertexPosition').data;
        var points = $733f620544d369b5$var$tempPolygon.points;
        var indices = this.geometry.getIndex().data;
        var len = indices.length;
        var step = this.drawMode === 4 ? 3 : 1;
        for(var i = 0; i + 2 < len; i += step){
            var ind0 = indices[i] * 2;
            var ind1 = indices[i + 1] * 2;
            var ind2 = indices[i + 2] * 2;
            points[0] = vertices[ind0];
            points[1] = vertices[ind0 + 1];
            points[2] = vertices[ind1];
            points[3] = vertices[ind1 + 1];
            points[4] = vertices[ind2];
            points[5] = vertices[ind2 + 1];
            if ($733f620544d369b5$var$tempPolygon.contains($733f620544d369b5$var$tempPoint.x, $733f620544d369b5$var$tempPoint.y)) return true;
        }
        return false;
    };
    Mesh.prototype.destroy = function(options) {
        _super.prototype.destroy.call(this, options);
        if (this._cachedTexture) {
            this._cachedTexture.destroy();
            this._cachedTexture = null;
        }
        this.geometry = null;
        this.shader = null;
        this.state = null;
        this.uvs = null;
        this.indices = null;
        this.vertexData = null;
    };
    /**
     * The maximum number of vertices to consider batchable. Generally, the complexity
     * of the geometry.
     */ Mesh.BATCHABLE_SIZE = 100;
    return Mesh;
}((0, $8t5Gy.Container));
var $733f620544d369b5$var$fragment = "varying vec2 vTextureCoord;\nuniform vec4 uColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void)\n{\n    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;\n}\n";
var $733f620544d369b5$var$vertex = "attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTextureMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTextureMatrix * vec3(aTextureCoord, 1.0)).xy;\n}\n";
/**
 * Slightly opinionated default shader for PixiJS 2D objects.
 * @class
 * @memberof PIXI
 * @extends PIXI.Shader
 */ var $733f620544d369b5$export$d552dadfd66cc650 = /** @class */ function(_super) {
    $733f620544d369b5$var$__extends(MeshMaterial, _super);
    /**
     * @param {PIXI.Texture} uSampler - Texture that material uses to render.
     * @param {object} [options] - Additional options
     * @param {number} [options.alpha=1] - Default alpha.
     * @param {number} [options.tint=0xFFFFFF] - Default tint.
     * @param {string} [options.pluginName='batch'] - Renderer plugin for batching.
     * @param {PIXI.Program} [options.program=0xFFFFFF] - Custom program.
     * @param {object} [options.uniforms] - Custom uniforms.
     */ function MeshMaterial(uSampler, options) {
        var _this = this;
        var uniforms = {
            uSampler: uSampler,
            alpha: 1,
            uTextureMatrix: (0, $6qzqq.Matrix).IDENTITY,
            uColor: new Float32Array([
                1,
                1,
                1,
                1
            ])
        };
        // Set defaults
        options = Object.assign({
            tint: 0xFFFFFF,
            alpha: 1,
            pluginName: 'batch'
        }, options);
        if (options.uniforms) Object.assign(uniforms, options.uniforms);
        _this = _super.call(this, options.program || (0, $klOfb.Program).from($733f620544d369b5$var$vertex, $733f620544d369b5$var$fragment), uniforms) || this;
        /**
         * Only do update if tint or alpha changes.
         * @member {boolean}
         * @private
         * @default false
         */ _this._colorDirty = false;
        /**
         * TextureMatrix instance for this Mesh, used to track Texture changes
         *
         * @member {PIXI.TextureMatrix}
         * @readonly
         */ _this.uvMatrix = new (0, $klOfb.TextureMatrix)(uSampler);
        /**
         * `true` if shader can be batch with the renderer's batch system.
         * @member {boolean}
         * @default true
         */ _this.batchable = options.program === undefined;
        /**
         * Renderer plugin for batching
         *
         * @member {string}
         * @default 'batch'
         */ _this.pluginName = options.pluginName;
        _this.tint = options.tint;
        _this.alpha = options.alpha;
        return _this;
    }
    Object.defineProperty(MeshMaterial.prototype, "texture", {
        /**
         * Reference to the texture being rendered.
         * @member {PIXI.Texture}
         */ get: function() {
            return this.uniforms.uSampler;
        },
        set: function(value) {
            if (this.uniforms.uSampler !== value) {
                this.uniforms.uSampler = value;
                this.uvMatrix.texture = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeshMaterial.prototype, "alpha", {
        get: function() {
            return this._alpha;
        },
        /**
         * This gets automatically set by the object using this.
         *
         * @default 1
         * @member {number}
         */ set: function(value) {
            if (value === this._alpha) return;
            this._alpha = value;
            this._colorDirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeshMaterial.prototype, "tint", {
        get: function() {
            return this._tint;
        },
        /**
         * Multiply tint for the material.
         * @member {number}
         * @default 0xFFFFFF
         */ set: function(value) {
            if (value === this._tint) return;
            this._tint = value;
            this._tintRGB = (value >> 16) + (value & 0xff00) + ((value & 0xff) << 16);
            this._colorDirty = true;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Gets called automatically by the Mesh. Intended to be overridden for custom
     * MeshMaterial objects.
     */ MeshMaterial.prototype.update = function() {
        if (this._colorDirty) {
            this._colorDirty = false;
            var baseTexture = this.texture.baseTexture;
            (0, $csytw.premultiplyTintToRgba)(this._tint, this._alpha, this.uniforms.uColor, baseTexture.alphaMode);
        }
        if (this.uvMatrix.update()) this.uniforms.uTextureMatrix = this.uvMatrix.mapCoord;
    };
    return MeshMaterial;
}((0, $klOfb.Shader));
/**
 * Standard 2D geometry used in PixiJS.
 *
 * Geometry can be defined without passing in a style or data if required.
 *
 * ```js
 * const geometry = new PIXI.Geometry();
 *
 * geometry.addAttribute('positions', [0, 0, 100, 0, 100, 100, 0, 100], 2);
 * geometry.addAttribute('uvs', [0,0,1,0,1,1,0,1], 2);
 * geometry.addIndex([0,1,2,1,3,2]);
 *
 * ```
 * @class
 * @memberof PIXI
 * @extends PIXI.Geometry
 */ var $733f620544d369b5$export$8d075a36a73d54bc = /** @class */ function(_super) {
    $733f620544d369b5$var$__extends(MeshGeometry, _super);
    /**
     * @param {Float32Array|number[]} [vertices] - Positional data on geometry.
     * @param {Float32Array|number[]} [uvs] - Texture UVs.
     * @param {Uint16Array|number[]} [index] - IndexBuffer
     */ function MeshGeometry(vertices, uvs, index) {
        var _this = _super.call(this) || this;
        var verticesBuffer = new (0, $klOfb.Buffer)(vertices);
        var uvsBuffer = new (0, $klOfb.Buffer)(uvs, true);
        var indexBuffer = new (0, $klOfb.Buffer)(index, true, true);
        _this.addAttribute('aVertexPosition', verticesBuffer, 2, false, (0, $P8XPi.TYPES).FLOAT).addAttribute('aTextureCoord', uvsBuffer, 2, false, (0, $P8XPi.TYPES).FLOAT).addIndex(indexBuffer);
        /**
         * Dirty flag to limit update calls on Mesh. For example,
         * limiting updates on a single Mesh instance with a shared Geometry
         * within the render loop.
         * @private
         * @member {number}
         * @default -1
         */ _this._updateId = -1;
        return _this;
    }
    Object.defineProperty(MeshGeometry.prototype, "vertexDirtyId", {
        /**
         * If the vertex position is updated.
         * @member {number}
         * @readonly
         * @private
         */ get: function() {
            return this.buffers[0]._updateID;
        },
        enumerable: false,
        configurable: true
    });
    return MeshGeometry;
}((0, $klOfb.Geometry));

});


parcelRegister("9RO7y", function(module, exports) {

$parcel$export(module.exports, "AlphaFilter", function () { return $72eff13dea783257$export$adbaa0de008b0d7a; });
/*!
 * @pixi/filter-alpha - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/filter-alpha is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $72eff13dea783257$var$extendStatics = function(d, b) {
    $72eff13dea783257$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $72eff13dea783257$var$extendStatics(d, b);
};
function $72eff13dea783257$var$__extends(d, b) {
    $72eff13dea783257$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $72eff13dea783257$var$fragment = "varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float uAlpha;\n\nvoid main(void)\n{\n   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;\n}\n";
/**
 * Simplest filter - applies alpha.
 *
 * Use this instead of Container's alpha property to avoid visual layering of individual elements.
 * AlphaFilter applies alpha evenly across the entire display object and any opaque elements it contains.
 * If elements are not opaque, they will blend with each other anyway.
 *
 * Very handy if you want to use common features of all filters:
 *
 * 1. Assign a blendMode to this filter, blend all elements inside display object with background.
 *
 * 2. To use clipping in display coordinates, assign a filterArea to the same container that has this filter.
 *
 * @memberof PIXI.filters
 */ var $72eff13dea783257$export$adbaa0de008b0d7a = /** @class */ function(_super) {
    $72eff13dea783257$var$__extends(AlphaFilter, _super);
    /**
     * @param alpha - Amount of alpha from 0 to 1, where 0 is transparent
     */ function AlphaFilter(alpha) {
        if (alpha === void 0) alpha = 1.0;
        var _this = _super.call(this, (0, $klOfb.defaultVertex), $72eff13dea783257$var$fragment, {
            uAlpha: 1
        }) || this;
        _this.alpha = alpha;
        return _this;
    }
    Object.defineProperty(AlphaFilter.prototype, "alpha", {
        /**
         * Coefficient for alpha multiplication
         *
         * @default 1
         */ get: function() {
            return this.uniforms.uAlpha;
        },
        set: function(value) {
            this.uniforms.uAlpha = value;
        },
        enumerable: false,
        configurable: true
    });
    return AlphaFilter;
}((0, $klOfb.Filter));

});

parcelRegister("1vBjL", function(module, exports) {

$parcel$export(module.exports, "BlurFilterPass", function () { return $1195a23c10b8e0b1$export$b100a8e8116621cf; });
$parcel$export(module.exports, "BlurFilter", function () { return $1195a23c10b8e0b1$export$424348d09d827f49; });
/*!
 * @pixi/filter-blur - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/filter-blur is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $ezJmd = parcelRequire("ezJmd");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $1195a23c10b8e0b1$var$extendStatics = function(d, b) {
    $1195a23c10b8e0b1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $1195a23c10b8e0b1$var$extendStatics(d, b);
};
function $1195a23c10b8e0b1$var$__extends(d, b) {
    $1195a23c10b8e0b1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1195a23c10b8e0b1$var$vertTemplate = "\n    attribute vec2 aVertexPosition;\n\n    uniform mat3 projectionMatrix;\n\n    uniform float strength;\n\n    varying vec2 vBlurTexCoords[%size%];\n\n    uniform vec4 inputSize;\n    uniform vec4 outputFrame;\n\n    vec4 filterVertexPosition( void )\n    {\n        vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n        return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n    }\n\n    vec2 filterTextureCoord( void )\n    {\n        return aVertexPosition * (outputFrame.zw * inputSize.zw);\n    }\n\n    void main(void)\n    {\n        gl_Position = filterVertexPosition();\n\n        vec2 textureCoord = filterTextureCoord();\n        %blur%\n    }";
function $1195a23c10b8e0b1$var$generateBlurVertSource(kernelSize, x) {
    var halfLength = Math.ceil(kernelSize / 2);
    var vertSource = $1195a23c10b8e0b1$var$vertTemplate;
    var blurLoop = '';
    var template;
    if (x) template = 'vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * strength, 0.0);';
    else template = 'vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * strength);';
    for(var i = 0; i < kernelSize; i++){
        var blur = template.replace('%index%', i.toString());
        blur = blur.replace('%sampleIndex%', i - (halfLength - 1) + ".0");
        blurLoop += blur;
        blurLoop += '\n';
    }
    vertSource = vertSource.replace('%blur%', blurLoop);
    vertSource = vertSource.replace('%size%', kernelSize.toString());
    return vertSource;
}
var $1195a23c10b8e0b1$var$GAUSSIAN_VALUES = {
    5: [
        0.153388,
        0.221461,
        0.250301
    ],
    7: [
        0.071303,
        0.131514,
        0.189879,
        0.214607
    ],
    9: [
        0.028532,
        0.067234,
        0.124009,
        0.179044,
        0.20236
    ],
    11: [
        0.0093,
        0.028002,
        0.065984,
        0.121703,
        0.175713,
        0.198596
    ],
    13: [
        0.002406,
        0.009255,
        0.027867,
        0.065666,
        0.121117,
        0.174868,
        0.197641
    ],
    15: [
        0.000489,
        0.002403,
        0.009246,
        0.02784,
        0.065602,
        0.120999,
        0.174697,
        0.197448
    ]
};
var $1195a23c10b8e0b1$var$fragTemplate = [
    'varying vec2 vBlurTexCoords[%size%];',
    'uniform sampler2D uSampler;',
    'void main(void)',
    '{',
    '    gl_FragColor = vec4(0.0);',
    '    %blur%',
    '}'
].join('\n');
function $1195a23c10b8e0b1$var$generateBlurFragSource(kernelSize) {
    var kernel = $1195a23c10b8e0b1$var$GAUSSIAN_VALUES[kernelSize];
    var halfLength = kernel.length;
    var fragSource = $1195a23c10b8e0b1$var$fragTemplate;
    var blurLoop = '';
    var template = 'gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;';
    var value;
    for(var i = 0; i < kernelSize; i++){
        var blur = template.replace('%index%', i.toString());
        value = i;
        if (i >= halfLength) value = kernelSize - i - 1;
        blur = blur.replace('%value%', kernel[value].toString());
        blurLoop += blur;
        blurLoop += '\n';
    }
    fragSource = fragSource.replace('%blur%', blurLoop);
    fragSource = fragSource.replace('%size%', kernelSize.toString());
    return fragSource;
}
/*!
 * @pixi/constants - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/constants is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * Different types of environments for WebGL.
 *
 * @static
 * @memberof PIXI
 * @name ENV
 * @enum {number}
 * @property {number} WEBGL_LEGACY - Used for older v1 WebGL devices. PixiJS will aim to ensure compatibility
 *  with older / less advanced devices. If you experience unexplained flickering prefer this environment.
 * @property {number} WEBGL - Version 1 of WebGL
 * @property {number} WEBGL2 - Version 2 of WebGL
 */ var $1195a23c10b8e0b1$var$ENV;
(function(ENV) {
    ENV[ENV["WEBGL_LEGACY"] = 0] = "WEBGL_LEGACY";
    ENV[ENV["WEBGL"] = 1] = "WEBGL";
    ENV[ENV["WEBGL2"] = 2] = "WEBGL2";
})($1195a23c10b8e0b1$var$ENV || ($1195a23c10b8e0b1$var$ENV = {}));
/**
 * Constant to identify the Renderer Type.
 *
 * @static
 * @memberof PIXI
 * @name RENDERER_TYPE
 * @enum {number}
 * @property {number} UNKNOWN - Unknown render type.
 * @property {number} WEBGL - WebGL render type.
 * @property {number} CANVAS - Canvas render type.
 */ var $1195a23c10b8e0b1$var$RENDERER_TYPE;
(function(RENDERER_TYPE) {
    RENDERER_TYPE[RENDERER_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
    RENDERER_TYPE[RENDERER_TYPE["WEBGL"] = 1] = "WEBGL";
    RENDERER_TYPE[RENDERER_TYPE["CANVAS"] = 2] = "CANVAS";
})($1195a23c10b8e0b1$var$RENDERER_TYPE || ($1195a23c10b8e0b1$var$RENDERER_TYPE = {}));
/**
 * Bitwise OR of masks that indicate the buffers to be cleared.
 *
 * @static
 * @memberof PIXI
 * @name BUFFER_BITS
 * @enum {number}
 * @property {number} COLOR - Indicates the buffers currently enabled for color writing.
 * @property {number} DEPTH - Indicates the depth buffer.
 * @property {number} STENCIL - Indicates the stencil buffer.
 */ var $1195a23c10b8e0b1$var$BUFFER_BITS;
(function(BUFFER_BITS) {
    BUFFER_BITS[BUFFER_BITS["COLOR"] = 16384] = "COLOR";
    BUFFER_BITS[BUFFER_BITS["DEPTH"] = 256] = "DEPTH";
    BUFFER_BITS[BUFFER_BITS["STENCIL"] = 1024] = "STENCIL";
})($1195a23c10b8e0b1$var$BUFFER_BITS || ($1195a23c10b8e0b1$var$BUFFER_BITS = {}));
/**
 * Various blend modes supported by PIXI.
 *
 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
 * Anything else will silently act like NORMAL.
 *
 * @memberof PIXI
 * @name BLEND_MODES
 * @enum {number}
 * @property {number} NORMAL
 * @property {number} ADD
 * @property {number} MULTIPLY
 * @property {number} SCREEN
 * @property {number} OVERLAY
 * @property {number} DARKEN
 * @property {number} LIGHTEN
 * @property {number} COLOR_DODGE
 * @property {number} COLOR_BURN
 * @property {number} HARD_LIGHT
 * @property {number} SOFT_LIGHT
 * @property {number} DIFFERENCE
 * @property {number} EXCLUSION
 * @property {number} HUE
 * @property {number} SATURATION
 * @property {number} COLOR
 * @property {number} LUMINOSITY
 * @property {number} NORMAL_NPM
 * @property {number} ADD_NPM
 * @property {number} SCREEN_NPM
 * @property {number} NONE
 * @property {number} SRC_IN
 * @property {number} SRC_OUT
 * @property {number} SRC_ATOP
 * @property {number} DST_OVER
 * @property {number} DST_IN
 * @property {number} DST_OUT
 * @property {number} DST_ATOP
 * @property {number} SUBTRACT
 * @property {number} SRC_OVER
 * @property {number} ERASE
 * @property {number} XOR
 */ var $1195a23c10b8e0b1$var$BLEND_MODES;
(function(BLEND_MODES) {
    BLEND_MODES[BLEND_MODES["NORMAL"] = 0] = "NORMAL";
    BLEND_MODES[BLEND_MODES["ADD"] = 1] = "ADD";
    BLEND_MODES[BLEND_MODES["MULTIPLY"] = 2] = "MULTIPLY";
    BLEND_MODES[BLEND_MODES["SCREEN"] = 3] = "SCREEN";
    BLEND_MODES[BLEND_MODES["OVERLAY"] = 4] = "OVERLAY";
    BLEND_MODES[BLEND_MODES["DARKEN"] = 5] = "DARKEN";
    BLEND_MODES[BLEND_MODES["LIGHTEN"] = 6] = "LIGHTEN";
    BLEND_MODES[BLEND_MODES["COLOR_DODGE"] = 7] = "COLOR_DODGE";
    BLEND_MODES[BLEND_MODES["COLOR_BURN"] = 8] = "COLOR_BURN";
    BLEND_MODES[BLEND_MODES["HARD_LIGHT"] = 9] = "HARD_LIGHT";
    BLEND_MODES[BLEND_MODES["SOFT_LIGHT"] = 10] = "SOFT_LIGHT";
    BLEND_MODES[BLEND_MODES["DIFFERENCE"] = 11] = "DIFFERENCE";
    BLEND_MODES[BLEND_MODES["EXCLUSION"] = 12] = "EXCLUSION";
    BLEND_MODES[BLEND_MODES["HUE"] = 13] = "HUE";
    BLEND_MODES[BLEND_MODES["SATURATION"] = 14] = "SATURATION";
    BLEND_MODES[BLEND_MODES["COLOR"] = 15] = "COLOR";
    BLEND_MODES[BLEND_MODES["LUMINOSITY"] = 16] = "LUMINOSITY";
    BLEND_MODES[BLEND_MODES["NORMAL_NPM"] = 17] = "NORMAL_NPM";
    BLEND_MODES[BLEND_MODES["ADD_NPM"] = 18] = "ADD_NPM";
    BLEND_MODES[BLEND_MODES["SCREEN_NPM"] = 19] = "SCREEN_NPM";
    BLEND_MODES[BLEND_MODES["NONE"] = 20] = "NONE";
    BLEND_MODES[BLEND_MODES["SRC_OVER"] = 0] = "SRC_OVER";
    BLEND_MODES[BLEND_MODES["SRC_IN"] = 21] = "SRC_IN";
    BLEND_MODES[BLEND_MODES["SRC_OUT"] = 22] = "SRC_OUT";
    BLEND_MODES[BLEND_MODES["SRC_ATOP"] = 23] = "SRC_ATOP";
    BLEND_MODES[BLEND_MODES["DST_OVER"] = 24] = "DST_OVER";
    BLEND_MODES[BLEND_MODES["DST_IN"] = 25] = "DST_IN";
    BLEND_MODES[BLEND_MODES["DST_OUT"] = 26] = "DST_OUT";
    BLEND_MODES[BLEND_MODES["DST_ATOP"] = 27] = "DST_ATOP";
    BLEND_MODES[BLEND_MODES["ERASE"] = 26] = "ERASE";
    BLEND_MODES[BLEND_MODES["SUBTRACT"] = 28] = "SUBTRACT";
    BLEND_MODES[BLEND_MODES["XOR"] = 29] = "XOR";
})($1195a23c10b8e0b1$var$BLEND_MODES || ($1195a23c10b8e0b1$var$BLEND_MODES = {}));
/**
 * Various webgl draw modes. These can be used to specify which GL drawMode to use
 * under certain situations and renderers.
 *
 * @memberof PIXI
 * @static
 * @name DRAW_MODES
 * @enum {number}
 * @property {number} POINTS
 * @property {number} LINES
 * @property {number} LINE_LOOP
 * @property {number} LINE_STRIP
 * @property {number} TRIANGLES
 * @property {number} TRIANGLE_STRIP
 * @property {number} TRIANGLE_FAN
 */ var $1195a23c10b8e0b1$var$DRAW_MODES;
(function(DRAW_MODES) {
    DRAW_MODES[DRAW_MODES["POINTS"] = 0] = "POINTS";
    DRAW_MODES[DRAW_MODES["LINES"] = 1] = "LINES";
    DRAW_MODES[DRAW_MODES["LINE_LOOP"] = 2] = "LINE_LOOP";
    DRAW_MODES[DRAW_MODES["LINE_STRIP"] = 3] = "LINE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLES"] = 4] = "TRIANGLES";
    DRAW_MODES[DRAW_MODES["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
})($1195a23c10b8e0b1$var$DRAW_MODES || ($1195a23c10b8e0b1$var$DRAW_MODES = {}));
/**
 * Various GL texture/resources formats.
 *
 * @memberof PIXI
 * @static
 * @name FORMATS
 * @enum {number}
 * @property {number} RGBA=6408
 * @property {number} RGB=6407
 * @property {number} RG=33319
 * @property {number} RED=6403
 * @property {number} RGBA_INTEGER=36249
 * @property {number} RGB_INTEGER=36248
 * @property {number} RG_INTEGER=33320
 * @property {number} RED_INTEGER=36244
 * @property {number} ALPHA=6406
 * @property {number} LUMINANCE=6409
 * @property {number} LUMINANCE_ALPHA=6410
 * @property {number} DEPTH_COMPONENT=6402
 * @property {number} DEPTH_STENCIL=34041
 */ var $1195a23c10b8e0b1$var$FORMATS;
(function(FORMATS) {
    FORMATS[FORMATS["RGBA"] = 6408] = "RGBA";
    FORMATS[FORMATS["RGB"] = 6407] = "RGB";
    FORMATS[FORMATS["RG"] = 33319] = "RG";
    FORMATS[FORMATS["RED"] = 6403] = "RED";
    FORMATS[FORMATS["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    FORMATS[FORMATS["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    FORMATS[FORMATS["RG_INTEGER"] = 33320] = "RG_INTEGER";
    FORMATS[FORMATS["RED_INTEGER"] = 36244] = "RED_INTEGER";
    FORMATS[FORMATS["ALPHA"] = 6406] = "ALPHA";
    FORMATS[FORMATS["LUMINANCE"] = 6409] = "LUMINANCE";
    FORMATS[FORMATS["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    FORMATS[FORMATS["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    FORMATS[FORMATS["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
})($1195a23c10b8e0b1$var$FORMATS || ($1195a23c10b8e0b1$var$FORMATS = {}));
/**
 * Various GL target types.
 *
 * @memberof PIXI
 * @static
 * @name TARGETS
 * @enum {number}
 * @property {number} TEXTURE_2D=3553
 * @property {number} TEXTURE_CUBE_MAP=34067
 * @property {number} TEXTURE_2D_ARRAY=35866
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_X=34069
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_X=34070
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Y=34071
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Y=34072
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Z=34073
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Z=34074
 */ var $1195a23c10b8e0b1$var$TARGETS;
(function(TARGETS) {
    TARGETS[TARGETS["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    TARGETS[TARGETS["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
})($1195a23c10b8e0b1$var$TARGETS || ($1195a23c10b8e0b1$var$TARGETS = {}));
/**
 * Various GL data format types.
 *
 * @memberof PIXI
 * @static
 * @name TYPES
 * @enum {number}
 * @property {number} UNSIGNED_BYTE=5121
 * @property {number} UNSIGNED_SHORT=5123
 * @property {number} UNSIGNED_SHORT_5_6_5=33635
 * @property {number} UNSIGNED_SHORT_4_4_4_4=32819
 * @property {number} UNSIGNED_SHORT_5_5_5_1=32820
 * @property {number} UNSIGNED_INT=5125
 * @property {number} UNSIGNED_INT_10F_11F_11F_REV=35899
 * @property {number} UNSIGNED_INT_2_10_10_10_REV=33640
 * @property {number} UNSIGNED_INT_24_8=34042
 * @property {number} UNSIGNED_INT_5_9_9_9_REV=35902
 * @property {number} BYTE=5120
 * @property {number} SHORT=5122
 * @property {number} INT=5124
 * @property {number} FLOAT=5126
 * @property {number} FLOAT_32_UNSIGNED_INT_24_8_REV=36269
 * @property {number} HALF_FLOAT=36193
 */ var $1195a23c10b8e0b1$var$TYPES;
(function(TYPES) {
    TYPES[TYPES["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    TYPES[TYPES["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    TYPES[TYPES["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    TYPES[TYPES["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    TYPES[TYPES["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    TYPES[TYPES["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    TYPES[TYPES["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    TYPES[TYPES["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    TYPES[TYPES["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    TYPES[TYPES["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    TYPES[TYPES["BYTE"] = 5120] = "BYTE";
    TYPES[TYPES["SHORT"] = 5122] = "SHORT";
    TYPES[TYPES["INT"] = 5124] = "INT";
    TYPES[TYPES["FLOAT"] = 5126] = "FLOAT";
    TYPES[TYPES["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    TYPES[TYPES["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
})($1195a23c10b8e0b1$var$TYPES || ($1195a23c10b8e0b1$var$TYPES = {}));
/**
 * Various sampler types. Correspond to `sampler`, `isampler`, `usampler` GLSL types respectively.
 * WebGL1 works only with FLOAT.
 *
 * @memberof PIXI
 * @static
 * @name SAMPLER_TYPES
 * @enum {number}
 * @property {number} FLOAT=0
 * @property {number} INT=1
 * @property {number} UINT=2
 */ var $1195a23c10b8e0b1$var$SAMPLER_TYPES;
(function(SAMPLER_TYPES) {
    SAMPLER_TYPES[SAMPLER_TYPES["FLOAT"] = 0] = "FLOAT";
    SAMPLER_TYPES[SAMPLER_TYPES["INT"] = 1] = "INT";
    SAMPLER_TYPES[SAMPLER_TYPES["UINT"] = 2] = "UINT";
})($1195a23c10b8e0b1$var$SAMPLER_TYPES || ($1195a23c10b8e0b1$var$SAMPLER_TYPES = {}));
/**
 * The scale modes that are supported by pixi.
 *
 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
 *
 * @memberof PIXI
 * @static
 * @name SCALE_MODES
 * @enum {number}
 * @property {number} LINEAR Smooth scaling
 * @property {number} NEAREST Pixelating scaling
 */ var $1195a23c10b8e0b1$var$SCALE_MODES;
(function(SCALE_MODES) {
    SCALE_MODES[SCALE_MODES["NEAREST"] = 0] = "NEAREST";
    SCALE_MODES[SCALE_MODES["LINEAR"] = 1] = "LINEAR";
})($1195a23c10b8e0b1$var$SCALE_MODES || ($1195a23c10b8e0b1$var$SCALE_MODES = {}));
/**
 * The wrap modes that are supported by pixi.
 *
 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
 * If the texture is non power of two then clamp will be used regardless as WebGL can
 * only use REPEAT if the texture is po2.
 *
 * This property only affects WebGL.
 *
 * @name WRAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} CLAMP - The textures uvs are clamped
 * @property {number} REPEAT - The texture uvs tile and repeat
 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
 */ var $1195a23c10b8e0b1$var$WRAP_MODES;
(function(WRAP_MODES) {
    WRAP_MODES[WRAP_MODES["CLAMP"] = 33071] = "CLAMP";
    WRAP_MODES[WRAP_MODES["REPEAT"] = 10497] = "REPEAT";
    WRAP_MODES[WRAP_MODES["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
})($1195a23c10b8e0b1$var$WRAP_MODES || ($1195a23c10b8e0b1$var$WRAP_MODES = {}));
/**
 * Mipmap filtering modes that are supported by pixi.
 *
 * The {@link PIXI.settings.MIPMAP_TEXTURES} affects default texture filtering.
 * Mipmaps are generated for a baseTexture if its `mipmap` field is `ON`,
 * or its `POW2` and texture dimensions are powers of 2.
 * Due to platform restriction, `ON` option will work like `POW2` for webgl-1.
 *
 * This property only affects WebGL.
 *
 * @name MIPMAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} OFF - No mipmaps
 * @property {number} POW2 - Generate mipmaps if texture dimensions are pow2
 * @property {number} ON - Always generate mipmaps
 * @property {number} ON_MANUAL - Use mipmaps, but do not auto-generate them; this is used with a resource
 *   that supports buffering each level-of-detail.
 */ var $1195a23c10b8e0b1$var$MIPMAP_MODES;
(function(MIPMAP_MODES) {
    MIPMAP_MODES[MIPMAP_MODES["OFF"] = 0] = "OFF";
    MIPMAP_MODES[MIPMAP_MODES["POW2"] = 1] = "POW2";
    MIPMAP_MODES[MIPMAP_MODES["ON"] = 2] = "ON";
    MIPMAP_MODES[MIPMAP_MODES["ON_MANUAL"] = 3] = "ON_MANUAL";
})($1195a23c10b8e0b1$var$MIPMAP_MODES || ($1195a23c10b8e0b1$var$MIPMAP_MODES = {}));
/**
 * How to treat textures with premultiplied alpha
 *
 * @name ALPHA_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NO_PREMULTIPLIED_ALPHA - Source is not premultiplied, leave it like that.
 *  Option for compressed and data textures that are created from typed arrays.
 * @property {number} PREMULTIPLY_ON_UPLOAD - Source is not premultiplied, premultiply on upload.
 *  Default option, used for all loaded images.
 * @property {number} PREMULTIPLIED_ALPHA - Source is already premultiplied
 *  Example: spine atlases with `_pma` suffix.
 * @property {number} NPM - Alias for NO_PREMULTIPLIED_ALPHA.
 * @property {number} UNPACK - Default option, alias for PREMULTIPLY_ON_UPLOAD.
 * @property {number} PMA - Alias for PREMULTIPLIED_ALPHA.
 */ var $1195a23c10b8e0b1$var$ALPHA_MODES;
(function(ALPHA_MODES) {
    ALPHA_MODES[ALPHA_MODES["NPM"] = 0] = "NPM";
    ALPHA_MODES[ALPHA_MODES["UNPACK"] = 1] = "UNPACK";
    ALPHA_MODES[ALPHA_MODES["PMA"] = 2] = "PMA";
    ALPHA_MODES[ALPHA_MODES["NO_PREMULTIPLIED_ALPHA"] = 0] = "NO_PREMULTIPLIED_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ON_UPLOAD"] = 1] = "PREMULTIPLY_ON_UPLOAD";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ALPHA"] = 2] = "PREMULTIPLY_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLIED_ALPHA"] = 2] = "PREMULTIPLIED_ALPHA";
})($1195a23c10b8e0b1$var$ALPHA_MODES || ($1195a23c10b8e0b1$var$ALPHA_MODES = {}));
/**
 * Configure whether filter textures are cleared after binding.
 *
 * Filter textures need not be cleared if the filter does not use pixel blending. {@link CLEAR_MODES.BLIT} will detect
 * this and skip clearing as an optimization.
 *
 * @name CLEAR_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} BLEND - Do not clear the filter texture. The filter's output will blend on top of the output texture.
 * @property {number} CLEAR - Always clear the filter texture.
 * @property {number} BLIT - Clear only if {@link FilterSystem.forceClear} is set or if the filter uses pixel blending.
 * @property {number} NO - Alias for BLEND, same as `false` in earlier versions
 * @property {number} YES - Alias for CLEAR, same as `true` in earlier versions
 * @property {number} AUTO - Alias for BLIT
 */ var $1195a23c10b8e0b1$var$CLEAR_MODES;
(function(CLEAR_MODES) {
    CLEAR_MODES[CLEAR_MODES["NO"] = 0] = "NO";
    CLEAR_MODES[CLEAR_MODES["YES"] = 1] = "YES";
    CLEAR_MODES[CLEAR_MODES["AUTO"] = 2] = "AUTO";
    CLEAR_MODES[CLEAR_MODES["BLEND"] = 0] = "BLEND";
    CLEAR_MODES[CLEAR_MODES["CLEAR"] = 1] = "CLEAR";
    CLEAR_MODES[CLEAR_MODES["BLIT"] = 2] = "BLIT";
})($1195a23c10b8e0b1$var$CLEAR_MODES || ($1195a23c10b8e0b1$var$CLEAR_MODES = {}));
/**
 * The gc modes that are supported by pixi.
 *
 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
 * used for a specified period of time they will be removed from the GPU. They will of course
 * be uploaded again when they are required. This is a silent behind the scenes process that
 * should ensure that the GPU does not  get filled up.
 *
 * Handy for mobile devices!
 * This property only affects WebGL.
 *
 * @name GC_MODES
 * @enum {number}
 * @static
 * @memberof PIXI
 * @property {number} AUTO - Garbage collection will happen periodically automatically
 * @property {number} MANUAL - Garbage collection will need to be called manually
 */ var $1195a23c10b8e0b1$var$GC_MODES;
(function(GC_MODES) {
    GC_MODES[GC_MODES["AUTO"] = 0] = "AUTO";
    GC_MODES[GC_MODES["MANUAL"] = 1] = "MANUAL";
})($1195a23c10b8e0b1$var$GC_MODES || ($1195a23c10b8e0b1$var$GC_MODES = {}));
/**
 * Constants that specify float precision in shaders.
 *
 * @name PRECISION
 * @memberof PIXI
 * @constant
 * @static
 * @enum {string}
 * @property {string} LOW='lowp'
 * @property {string} MEDIUM='mediump'
 * @property {string} HIGH='highp'
 */ var $1195a23c10b8e0b1$var$PRECISION;
(function(PRECISION) {
    PRECISION["LOW"] = "lowp";
    PRECISION["MEDIUM"] = "mediump";
    PRECISION["HIGH"] = "highp";
})($1195a23c10b8e0b1$var$PRECISION || ($1195a23c10b8e0b1$var$PRECISION = {}));
/**
 * Constants for mask implementations.
 * We use `type` suffix because it leads to very different behaviours
 *
 * @name MASK_TYPES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - Mask is ignored
 * @property {number} SCISSOR - Scissor mask, rectangle on screen, cheap
 * @property {number} STENCIL - Stencil mask, 1-bit, medium, works only if renderer supports stencil
 * @property {number} SPRITE - Mask that uses SpriteMaskFilter, uses temporary RenderTexture
 */ var $1195a23c10b8e0b1$var$MASK_TYPES;
(function(MASK_TYPES) {
    MASK_TYPES[MASK_TYPES["NONE"] = 0] = "NONE";
    MASK_TYPES[MASK_TYPES["SCISSOR"] = 1] = "SCISSOR";
    MASK_TYPES[MASK_TYPES["STENCIL"] = 2] = "STENCIL";
    MASK_TYPES[MASK_TYPES["SPRITE"] = 3] = "SPRITE";
})($1195a23c10b8e0b1$var$MASK_TYPES || ($1195a23c10b8e0b1$var$MASK_TYPES = {}));
/**
 * Constants for multi-sampling antialiasing.
 *
 * @see PIXI.Framebuffer#multisample
 *
 * @name MSAA_QUALITY
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - No multisampling for this renderTexture
 * @property {number} LOW - Try 2 samples
 * @property {number} MEDIUM - Try 4 samples
 * @property {number} HIGH - Try 8 samples
 */ var $1195a23c10b8e0b1$var$MSAA_QUALITY;
(function(MSAA_QUALITY) {
    MSAA_QUALITY[MSAA_QUALITY["NONE"] = 0] = "NONE";
    MSAA_QUALITY[MSAA_QUALITY["LOW"] = 2] = "LOW";
    MSAA_QUALITY[MSAA_QUALITY["MEDIUM"] = 4] = "MEDIUM";
    MSAA_QUALITY[MSAA_QUALITY["HIGH"] = 8] = "HIGH";
})($1195a23c10b8e0b1$var$MSAA_QUALITY || ($1195a23c10b8e0b1$var$MSAA_QUALITY = {}));
/**
 * Constants for various buffer types in Pixi
 *
 * @see PIXI.BUFFER_TYPE
 *
 * @name BUFFER_TYPE
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} ELEMENT_ARRAY_BUFFER - buffer type for using as an index buffer
 * @property {number} ARRAY_BUFFER - buffer type for using attribute data
 * @property {number} UNIFORM_BUFFER - the buffer type is for uniform buffer objects
 */ var $1195a23c10b8e0b1$var$BUFFER_TYPE;
(function(BUFFER_TYPE) {
    BUFFER_TYPE[BUFFER_TYPE["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    BUFFER_TYPE[BUFFER_TYPE["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    // NOT YET SUPPORTED
    BUFFER_TYPE[BUFFER_TYPE["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
})($1195a23c10b8e0b1$var$BUFFER_TYPE || ($1195a23c10b8e0b1$var$BUFFER_TYPE = {}));
/**
 * The BlurFilterPass applies a horizontal or vertical Gaussian blur to an object.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */ var $1195a23c10b8e0b1$export$b100a8e8116621cf = /** @class */ function(_super) {
    $1195a23c10b8e0b1$var$__extends(BlurFilterPass, _super);
    /**
     * @param {boolean} horizontal - Do pass along the x-axis (`true`) or y-axis (`false`).
     * @param {number} [strength=8] - The strength of the blur filter.
     * @param {number} [quality=4] - The quality of the blur filter.
     * @param {number} [resolution=PIXI.settings.FILTER_RESOLUTION] - The resolution of the blur filter.
     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
     */ function BlurFilterPass(horizontal, strength, quality, resolution, kernelSize) {
        if (strength === void 0) strength = 8;
        if (quality === void 0) quality = 4;
        if (resolution === void 0) resolution = (0, $ezJmd.settings).FILTER_RESOLUTION;
        if (kernelSize === void 0) kernelSize = 5;
        var _this = this;
        var vertSrc = $1195a23c10b8e0b1$var$generateBlurVertSource(kernelSize, horizontal);
        var fragSrc = $1195a23c10b8e0b1$var$generateBlurFragSource(kernelSize);
        _this = _super.call(this, // vertex shader
        vertSrc, // fragment shader
        fragSrc) || this;
        _this.horizontal = horizontal;
        _this.resolution = resolution;
        _this._quality = 0;
        _this.quality = quality;
        _this.blur = strength;
        return _this;
    }
    /**
     * Applies the filter.
     *
     * @param {PIXI.FilterSystem} filterManager - The manager.
     * @param {PIXI.RenderTexture} input - The input target.
     * @param {PIXI.RenderTexture} output - The output target.
     * @param {PIXI.CLEAR_MODES} clearMode - How to clear
     */ BlurFilterPass.prototype.apply = function(filterManager, input, output, clearMode) {
        if (output) {
            if (this.horizontal) this.uniforms.strength = 1 / output.width * (output.width / input.width);
            else this.uniforms.strength = 1 / output.height * (output.height / input.height);
        } else if (this.horizontal) this.uniforms.strength = 1 / filterManager.renderer.width * (filterManager.renderer.width / input.width);
        else this.uniforms.strength = 1 / filterManager.renderer.height * (filterManager.renderer.height / input.height); // eslint-disable-line
        // screen space!
        this.uniforms.strength *= this.strength;
        this.uniforms.strength /= this.passes;
        if (this.passes === 1) filterManager.applyFilter(this, input, output, clearMode);
        else {
            var renderTarget = filterManager.getFilterTexture();
            var renderer = filterManager.renderer;
            var flip = input;
            var flop = renderTarget;
            this.state.blend = false;
            filterManager.applyFilter(this, flip, flop, $1195a23c10b8e0b1$var$CLEAR_MODES.CLEAR);
            for(var i = 1; i < this.passes - 1; i++){
                filterManager.bindAndClear(flip, $1195a23c10b8e0b1$var$CLEAR_MODES.BLIT);
                this.uniforms.uSampler = flop;
                var temp = flop;
                flop = flip;
                flip = temp;
                renderer.shader.bind(this);
                renderer.geometry.draw(5);
            }
            this.state.blend = true;
            filterManager.applyFilter(this, flop, output, clearMode);
            filterManager.returnFilterTexture(renderTarget);
        }
    };
    Object.defineProperty(BlurFilterPass.prototype, "blur", {
        /**
         * Sets the strength of both the blur.
         *
         * @member {number}
         * @default 16
         */ get: function() {
            return this.strength;
        },
        set: function(value) {
            this.padding = 1 + Math.abs(value) * 2;
            this.strength = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurFilterPass.prototype, "quality", {
        /**
         * Sets the quality of the blur by modifying the number of passes. More passes means higher
         * quality bluring but the lower the performance.
         *
         * @member {number}
         * @default 4
         */ get: function() {
            return this._quality;
        },
        set: function(value) {
            this._quality = value;
            this.passes = value;
        },
        enumerable: false,
        configurable: true
    });
    return BlurFilterPass;
}((0, $klOfb.Filter));
/**
 * The BlurFilter applies a Gaussian blur to an object.
 *
 * The strength of the blur can be set for the x-axis and y-axis separately.
 *
 * @memberof PIXI.filters
 */ var $1195a23c10b8e0b1$export$424348d09d827f49 = /** @class */ function(_super) {
    $1195a23c10b8e0b1$var$__extends(BlurFilter, _super);
    /**
     * @param strength - The strength of the blur filter.
     * @param quality - The quality of the blur filter.
     * @param [resolution=PIXI.settings.FILTER_RESOLUTION] - The resolution of the blur filter.
     * @param kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
     */ function BlurFilter(strength, quality, resolution, kernelSize) {
        if (strength === void 0) strength = 8;
        if (quality === void 0) quality = 4;
        if (resolution === void 0) resolution = (0, $ezJmd.settings).FILTER_RESOLUTION;
        if (kernelSize === void 0) kernelSize = 5;
        var _this = _super.call(this) || this;
        _this.blurXFilter = new $1195a23c10b8e0b1$export$b100a8e8116621cf(true, strength, quality, resolution, kernelSize);
        _this.blurYFilter = new $1195a23c10b8e0b1$export$b100a8e8116621cf(false, strength, quality, resolution, kernelSize);
        _this.resolution = resolution;
        _this.quality = quality;
        _this.blur = strength;
        _this.repeatEdgePixels = false;
        return _this;
    }
    /**
     * Applies the filter.
     *
     * @param filterManager - The manager.
     * @param input - The input target.
     * @param output - The output target.
     * @param clearMode - How to clear
     */ BlurFilter.prototype.apply = function(filterManager, input, output, clearMode) {
        var xStrength = Math.abs(this.blurXFilter.strength);
        var yStrength = Math.abs(this.blurYFilter.strength);
        if (xStrength && yStrength) {
            var renderTarget = filterManager.getFilterTexture();
            this.blurXFilter.apply(filterManager, input, renderTarget, $1195a23c10b8e0b1$var$CLEAR_MODES.CLEAR);
            this.blurYFilter.apply(filterManager, renderTarget, output, clearMode);
            filterManager.returnFilterTexture(renderTarget);
        } else if (yStrength) this.blurYFilter.apply(filterManager, input, output, clearMode);
        else this.blurXFilter.apply(filterManager, input, output, clearMode);
    };
    BlurFilter.prototype.updatePadding = function() {
        if (this._repeatEdgePixels) this.padding = 0;
        else this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
    };
    Object.defineProperty(BlurFilter.prototype, "blur", {
        /**
         * Sets the strength of both the blurX and blurY properties simultaneously
         *
         * @default 2
         */ get: function() {
            return this.blurXFilter.blur;
        },
        set: function(value) {
            this.blurXFilter.blur = this.blurYFilter.blur = value;
            this.updatePadding();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "quality", {
        /**
         * Sets the number of passes for blur. More passes means higher quality bluring.
         *
         * @default 1
         */ get: function() {
            return this.blurXFilter.quality;
        },
        set: function(value) {
            this.blurXFilter.quality = this.blurYFilter.quality = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "blurX", {
        /**
         * Sets the strength of the blurX property
         *
         * @default 2
         */ get: function() {
            return this.blurXFilter.blur;
        },
        set: function(value) {
            this.blurXFilter.blur = value;
            this.updatePadding();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "blurY", {
        /**
         * Sets the strength of the blurY property
         *
         * @default 2
         */ get: function() {
            return this.blurYFilter.blur;
        },
        set: function(value) {
            this.blurYFilter.blur = value;
            this.updatePadding();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "blendMode", {
        /**
         * Sets the blendmode of the filter
         *
         * @default PIXI.BLEND_MODES.NORMAL
         */ get: function() {
            return this.blurYFilter.blendMode;
        },
        set: function(value) {
            this.blurYFilter.blendMode = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BlurFilter.prototype, "repeatEdgePixels", {
        /**
         * If set to true the edge of the target will be clamped
         *
         * @default false
         */ get: function() {
            return this._repeatEdgePixels;
        },
        set: function(value) {
            this._repeatEdgePixels = value;
            this.updatePadding();
        },
        enumerable: false,
        configurable: true
    });
    return BlurFilter;
}((0, $klOfb.Filter));

});

parcelRegister("aPxof", function(module, exports) {

$parcel$export(module.exports, "ColorMatrixFilter", function () { return $7e28916011673245$export$6547db23997fcec5; });
/*!
 * @pixi/filter-color-matrix - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/filter-color-matrix is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $7e28916011673245$var$extendStatics = function(d, b) {
    $7e28916011673245$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $7e28916011673245$var$extendStatics(d, b);
};
function $7e28916011673245$var$__extends(d, b) {
    $7e28916011673245$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7e28916011673245$var$fragment = "varying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform float m[20];\nuniform float uAlpha;\n\nvoid main(void)\n{\n    vec4 c = texture2D(uSampler, vTextureCoord);\n\n    if (uAlpha == 0.0) {\n        gl_FragColor = c;\n        return;\n    }\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (c.a > 0.0) {\n      c.rgb /= c.a;\n    }\n\n    vec4 result;\n\n    result.r = (m[0] * c.r);\n        result.r += (m[1] * c.g);\n        result.r += (m[2] * c.b);\n        result.r += (m[3] * c.a);\n        result.r += m[4];\n\n    result.g = (m[5] * c.r);\n        result.g += (m[6] * c.g);\n        result.g += (m[7] * c.b);\n        result.g += (m[8] * c.a);\n        result.g += m[9];\n\n    result.b = (m[10] * c.r);\n       result.b += (m[11] * c.g);\n       result.b += (m[12] * c.b);\n       result.b += (m[13] * c.a);\n       result.b += m[14];\n\n    result.a = (m[15] * c.r);\n       result.a += (m[16] * c.g);\n       result.a += (m[17] * c.b);\n       result.a += (m[18] * c.a);\n       result.a += m[19];\n\n    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);\n\n    // Premultiply alpha again.\n    rgb *= result.a;\n\n    gl_FragColor = vec4(rgb, result.a);\n}\n";
/**
 * The ColorMatrixFilter class lets you apply a 5x4 matrix transformation on the RGBA
 * color and alpha values of every pixel on your displayObject to produce a result
 * with a new set of RGBA color and alpha values. It's pretty powerful!
 *
 * ```js
 *  let colorMatrix = new PIXI.filters.ColorMatrixFilter();
 *  container.filters = [colorMatrix];
 *  colorMatrix.contrast(2);
 * ```
 * @author Clément Chenebault <clement@goodboydigital.com>
 * @memberof PIXI.filters
 */ var $7e28916011673245$export$6547db23997fcec5 = /** @class */ function(_super) {
    $7e28916011673245$var$__extends(ColorMatrixFilter, _super);
    function ColorMatrixFilter() {
        var _this = this;
        var uniforms = {
            m: new Float32Array([
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ]),
            uAlpha: 1
        };
        _this = _super.call(this, (0, $klOfb.defaultFilterVertex), $7e28916011673245$var$fragment, uniforms) || this;
        _this.alpha = 1;
        return _this;
    }
    /**
     * Transforms current matrix and set the new one
     *
     * @param {number[]} matrix - 5x4 matrix
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype._loadMatrix = function(matrix, multiply) {
        if (multiply === void 0) multiply = false;
        var newMatrix = matrix;
        if (multiply) {
            this._multiply(newMatrix, this.uniforms.m, matrix);
            newMatrix = this._colorMatrix(newMatrix);
        }
        // set the new matrix
        this.uniforms.m = newMatrix;
    };
    /**
     * Multiplies two mat5's
     *
     * @private
     * @param out - 5x4 matrix the receiving matrix
     * @param a - 5x4 matrix the first operand
     * @param b - 5x4 matrix the second operand
     * @returns {number[]} 5x4 matrix
     */ ColorMatrixFilter.prototype._multiply = function(out, a, b) {
        // Red Channel
        out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15];
        out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16];
        out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17];
        out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18];
        out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4];
        // Green Channel
        out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15];
        out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16];
        out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17];
        out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18];
        out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9];
        // Blue Channel
        out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15];
        out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16];
        out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17];
        out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18];
        out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14];
        // Alpha Channel
        out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15];
        out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16];
        out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17];
        out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18];
        out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19];
        return out;
    };
    /**
     * Create a Float32 Array and normalize the offset component to 0-1
     *
     * @param {number[]} matrix - 5x4 matrix
     * @return {number[]} 5x4 matrix with all values between 0-1
     */ ColorMatrixFilter.prototype._colorMatrix = function(matrix) {
        // Create a Float32 Array and normalize the offset component to 0-1
        var m = new Float32Array(matrix);
        m[4] /= 255;
        m[9] /= 255;
        m[14] /= 255;
        m[19] /= 255;
        return m;
    };
    /**
     * Adjusts brightness
     *
     * @param b - value of the brigthness (0-1, where 0 is black)
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.brightness = function(b, multiply) {
        var matrix = [
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Sets each channel on the diagonal of the color matrix.
     * This can be used to achieve a tinting effect on Containers similar to the tint field of some
     * display objects like Sprite, Text, Graphics, and Mesh.
     *
     * @param color - Color of the tint. This is a hex value.
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.tint = function(color, multiply) {
        var r = color >> 16 & 0xff;
        var g = color >> 8 & 0xff;
        var b = color & 0xff;
        var matrix = [
            r / 255,
            0,
            0,
            0,
            0,
            0,
            g / 255,
            0,
            0,
            0,
            0,
            0,
            b / 255,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Set the matrices in grey scales
     *
     * @param scale - value of the grey (0-1, where 0 is black)
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.greyscale = function(scale, multiply) {
        var matrix = [
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            scale,
            scale,
            scale,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Set the black and white matrice.
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.blackAndWhite = function(multiply) {
        var matrix = [
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0.3,
            0.6,
            0.1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Set the hue property of the color
     *
     * @param rotation - in degrees
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.hue = function(rotation, multiply) {
        rotation = (rotation || 0) / 180 * Math.PI;
        var cosR = Math.cos(rotation);
        var sinR = Math.sin(rotation);
        var sqrt = Math.sqrt;
        /* a good approximation for hue rotation
         This matrix is far better than the versions with magic luminance constants
         formerly used here, but also used in the starling framework (flash) and known from this
         old part of the internet: quasimondo.com/archives/000565.php

         This new matrix is based on rgb cube rotation in space. Look here for a more descriptive
         implementation as a shader not a general matrix:
         https://github.com/evanw/glfx.js/blob/58841c23919bd59787effc0333a4897b43835412/src/filters/adjust/huesaturation.js

         This is the source for the code:
         see http://stackoverflow.com/questions/8507885/shift-hue-of-an-rgb-color/8510751#8510751
         */ var w = 1 / 3;
        var sqrW = sqrt(w); // weight is
        var a00 = cosR + (1.0 - cosR) * w;
        var a01 = w * (1.0 - cosR) - sqrW * sinR;
        var a02 = w * (1.0 - cosR) + sqrW * sinR;
        var a10 = w * (1.0 - cosR) + sqrW * sinR;
        var a11 = cosR + w * (1.0 - cosR);
        var a12 = w * (1.0 - cosR) - sqrW * sinR;
        var a20 = w * (1.0 - cosR) - sqrW * sinR;
        var a21 = w * (1.0 - cosR) + sqrW * sinR;
        var a22 = cosR + w * (1.0 - cosR);
        var matrix = [
            a00,
            a01,
            a02,
            0,
            0,
            a10,
            a11,
            a12,
            0,
            0,
            a20,
            a21,
            a22,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Set the contrast matrix, increase the separation between dark and bright
     * Increase contrast : shadows darker and highlights brighter
     * Decrease contrast : bring the shadows up and the highlights down
     *
     * @param amount - value of the contrast (0-1)
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.contrast = function(amount, multiply) {
        var v = (amount || 0) + 1;
        var o = -0.5 * (v - 1);
        var matrix = [
            v,
            0,
            0,
            0,
            o,
            0,
            v,
            0,
            0,
            o,
            0,
            0,
            v,
            0,
            o,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Set the saturation matrix, increase the separation between colors
     * Increase saturation : increase contrast, brightness, and sharpness
     *
     * @param amount - The saturation amount (0-1)
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.saturate = function(amount, multiply) {
        if (amount === void 0) amount = 0;
        var x = amount * 2 / 3 + 1;
        var y = (x - 1) * -0.5;
        var matrix = [
            x,
            y,
            y,
            0,
            0,
            y,
            x,
            y,
            0,
            0,
            y,
            y,
            x,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Desaturate image (remove color)
     *
     * Call the saturate function
     */ ColorMatrixFilter.prototype.desaturate = function() {
        this.saturate(-1);
    };
    /**
     * Negative image (inverse of classic rgb matrix)
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.negative = function(multiply) {
        var matrix = [
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            -1,
            1,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Sepia image
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.sepia = function(multiply) {
        var matrix = [
            0.393,
            0.7689999,
            0.18899999,
            0,
            0,
            0.349,
            0.6859999,
            0.16799999,
            0,
            0,
            0.272,
            0.5339999,
            0.13099999,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.technicolor = function(multiply) {
        var matrix = [
            1.9125277891456083,
            -0.8545344976951645,
            -0.09155508482755585,
            0,
            11.793603434377337,
            -0.3087833385928097,
            1.7658908555458428,
            -0.10601743074722245,
            0,
            -70.35205161461398,
            -0.231103377548616,
            -0.7501899197440212,
            1.847597816108189,
            0,
            30.950940869491138,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Polaroid filter
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.polaroid = function(multiply) {
        var matrix = [
            1.438,
            -0.062,
            -0.062,
            0,
            0,
            -0.122,
            1.378,
            -0.122,
            0,
            0,
            -0.016,
            -0.016,
            1.483,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Filter who transforms : Red -> Blue and Blue -> Red
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.toBGR = function(multiply) {
        var matrix = [
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.kodachrome = function(multiply) {
        var matrix = [
            1.1285582396593525,
            -0.3967382283601348,
            -0.03992559172921793,
            0,
            63.72958762196502,
            -0.16404339962244616,
            1.0835251566291304,
            -0.05498805115633132,
            0,
            24.732407896706203,
            -0.16786010706155763,
            -0.5603416277695248,
            1.6014850761964943,
            0,
            35.62982807460946,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Brown delicious browni filter (thanks Dominic Szablewski)
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.browni = function(multiply) {
        var matrix = [
            0.5997023498159715,
            0.34553243048391263,
            -0.2708298674538042,
            0,
            47.43192855600873,
            -0.037703249837783157,
            0.8609577587992641,
            0.15059552388459913,
            0,
            -36.96841498319127,
            0.24113635128153335,
            -0.07441037908422492,
            0.44972182064877153,
            0,
            -7.562075277591283,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Vintage filter (thanks Dominic Szablewski)
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.vintage = function(multiply) {
        var matrix = [
            0.6279345635605994,
            0.3202183420819367,
            -0.03965408211312453,
            0,
            9.651285835294123,
            0.02578397704808868,
            0.6441188644374771,
            0.03259127616149294,
            0,
            7.462829176470591,
            0.0466055556782719,
            -0.0851232987247891,
            0.5241648018700465,
            0,
            5.159190588235296,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * We don't know exactly what it does, kind of gradient map, but funny to play with!
     *
     * @param desaturation - Tone values.
     * @param toned - Tone values.
     * @param lightColor - Tone values, example: `0xFFE580`
     * @param darkColor - Tone values, example: `0xFFE580`
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.colorTone = function(desaturation, toned, lightColor, darkColor, multiply) {
        desaturation = desaturation || 0.2;
        toned = toned || 0.15;
        lightColor = lightColor || 0xFFE580;
        darkColor = darkColor || 0x338000;
        var lR = (lightColor >> 16 & 0xFF) / 255;
        var lG = (lightColor >> 8 & 0xFF) / 255;
        var lB = (lightColor & 0xFF) / 255;
        var dR = (darkColor >> 16 & 0xFF) / 255;
        var dG = (darkColor >> 8 & 0xFF) / 255;
        var dB = (darkColor & 0xFF) / 255;
        var matrix = [
            0.3,
            0.59,
            0.11,
            0,
            0,
            lR,
            lG,
            lB,
            desaturation,
            0,
            dR,
            dG,
            dB,
            toned,
            0,
            lR - dR,
            lG - dG,
            lB - dB,
            0,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Night effect
     *
     * @param intensity - The intensity of the night effect.
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.night = function(intensity, multiply) {
        intensity = intensity || 0.1;
        var matrix = [
            intensity * -2,
            -intensity,
            0,
            0,
            0,
            -intensity,
            0,
            intensity,
            0,
            0,
            0,
            intensity,
            intensity * 2.0,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * Predator effect
     *
     * Erase the current matrix by setting a new indepent one
     *
     * @param amount - how much the predator feels his future victim
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.predator = function(amount, multiply) {
        var matrix = [
            // row 1
            11.224130630493164 * amount,
            -4.794486999511719 * amount,
            -2.8746118545532227 * amount,
            0 * amount,
            0.40342438220977783 * amount,
            // row 2
            -3.6330697536468506 * amount,
            9.193157196044922 * amount,
            -2.951810836791992 * amount,
            0 * amount,
            -1.316135048866272 * amount,
            // row 3
            -3.2184197902679443 * amount,
            -4.2375030517578125 * amount,
            7.476448059082031 * amount,
            0 * amount,
            0.8044459223747253 * amount,
            // row 4
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /**
     * LSD effect
     *
     * Multiply the current matrix
     *
     * @param multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */ ColorMatrixFilter.prototype.lsd = function(multiply) {
        var matrix = [
            2,
            -0.4,
            0.5,
            0,
            0,
            -0.5,
            2,
            -0.4,
            0,
            0,
            -0.4,
            -0.5,
            3,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, multiply);
    };
    /** Erase the current matrix by setting the default one. */ ColorMatrixFilter.prototype.reset = function() {
        var matrix = [
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
        this._loadMatrix(matrix, false);
    };
    Object.defineProperty(ColorMatrixFilter.prototype, "matrix", {
        /**
         * The matrix of the color matrix filter
         *
         * @member {number[]}
         * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
         */ get: function() {
            return this.uniforms.m;
        },
        set: function(value) {
            this.uniforms.m = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorMatrixFilter.prototype, "alpha", {
        /**
         * The opacity value to use when mixing the original and resultant colors.
         *
         * When the value is 0, the original color is used without modification.
         * When the value is 1, the result color is used.
         * When in the range (0, 1) the color is interpolated between the original and result by this amount.
         *
         * @default 1
         */ get: function() {
            return this.uniforms.uAlpha;
        },
        set: function(value) {
            this.uniforms.uAlpha = value;
        },
        enumerable: false,
        configurable: true
    });
    return ColorMatrixFilter;
}((0, $klOfb.Filter));
// Americanized alias
$7e28916011673245$export$6547db23997fcec5.prototype.grayscale = $7e28916011673245$export$6547db23997fcec5.prototype.greyscale;

});

parcelRegister("68QeL", function(module, exports) {

$parcel$export(module.exports, "DisplacementFilter", function () { return $478c02a70e37469a$export$8ebf3229158e2895; });
/*!
 * @pixi/filter-displacement - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/filter-displacement is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $6qzqq = parcelRequire("6qzqq");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $478c02a70e37469a$var$extendStatics = function(d, b) {
    $478c02a70e37469a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $478c02a70e37469a$var$extendStatics(d, b);
};
function $478c02a70e37469a$var$__extends(d, b) {
    $478c02a70e37469a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $478c02a70e37469a$var$fragment = "varying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform vec2 scale;\nuniform mat2 rotation;\nuniform sampler2D uSampler;\nuniform sampler2D mapSampler;\n\nuniform highp vec4 inputSize;\nuniform vec4 inputClamp;\n\nvoid main(void)\n{\n  vec4 map =  texture2D(mapSampler, vFilterCoord);\n\n  map -= 0.5;\n  map.xy = scale * inputSize.zw * (rotation * map.xy);\n\n  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), inputClamp.xy, inputClamp.zw));\n}\n";
var $478c02a70e37469a$var$vertex = "attribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\nuniform mat3 filterMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvec2 filterTextureCoord( void )\n{\n    return aVertexPosition * (outputFrame.zw * inputSize.zw);\n}\n\nvoid main(void)\n{\n\tgl_Position = filterVertexPosition();\n\tvTextureCoord = filterTextureCoord();\n\tvFilterCoord = ( filterMatrix * vec3( vTextureCoord, 1.0)  ).xy;\n}\n";
/**
 * The DisplacementFilter class uses the pixel values from the specified texture
 * (called the displacement map) to perform a displacement of an object.
 *
 * You can use this filter to apply all manor of crazy warping effects.
 * Currently the `r` property of the texture is used to offset the `x`
 * and the `g` property of the texture is used to offset the `y`.
 *
 * The way it works is it uses the values of the displacement map to look up the
 * correct pixels to output. This means it's not technically moving the original.
 * Instead, it's starting at the output and asking "which pixel from the original goes here".
 * For example, if a displacement map pixel has `red = 1` and the filter scale is `20`,
 * this filter will output the pixel approximately 20 pixels to the right of the original.
 *
 * @memberof PIXI.filters
 */ var $478c02a70e37469a$export$8ebf3229158e2895 = /** @class */ function(_super) {
    $478c02a70e37469a$var$__extends(DisplacementFilter, _super);
    /**
     * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
     * @param scale - The scale of the displacement
     */ function DisplacementFilter(sprite, scale) {
        var _this = this;
        var maskMatrix = new (0, $6qzqq.Matrix)();
        sprite.renderable = false;
        _this = _super.call(this, $478c02a70e37469a$var$vertex, $478c02a70e37469a$var$fragment, {
            mapSampler: sprite._texture,
            filterMatrix: maskMatrix,
            scale: {
                x: 1,
                y: 1
            },
            rotation: new Float32Array([
                1,
                0,
                0,
                1
            ])
        }) || this;
        _this.maskSprite = sprite;
        _this.maskMatrix = maskMatrix;
        if (scale === null || scale === undefined) scale = 20;
        /**
         * scaleX, scaleY for displacements
         * @member {PIXI.Point}
         */ _this.scale = new (0, $6qzqq.Point)(scale, scale);
        return _this;
    }
    /**
     * Applies the filter.
     *
     * @param filterManager - The manager.
     * @param input - The input target.
     * @param output - The output target.
     * @param clearMode - clearMode.
     */ DisplacementFilter.prototype.apply = function(filterManager, input, output, clearMode) {
        // fill maskMatrix with _normalized sprite texture coords_
        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
        this.uniforms.scale.x = this.scale.x;
        this.uniforms.scale.y = this.scale.y;
        // Extract rotation from world transform
        var wt = this.maskSprite.worldTransform;
        var lenX = Math.sqrt(wt.a * wt.a + wt.b * wt.b);
        var lenY = Math.sqrt(wt.c * wt.c + wt.d * wt.d);
        if (lenX !== 0 && lenY !== 0) {
            this.uniforms.rotation[0] = wt.a / lenX;
            this.uniforms.rotation[1] = wt.b / lenX;
            this.uniforms.rotation[2] = wt.c / lenY;
            this.uniforms.rotation[3] = wt.d / lenY;
        }
        // draw the filter...
        filterManager.applyFilter(this, input, output, clearMode);
    };
    Object.defineProperty(DisplacementFilter.prototype, "map", {
        /** The texture used for the displacement map. Must be power of 2 sized texture. */ get: function() {
            return this.uniforms.mapSampler;
        },
        set: function(value) {
            this.uniforms.mapSampler = value;
        },
        enumerable: false,
        configurable: true
    });
    return DisplacementFilter;
}((0, $klOfb.Filter));

});

parcelRegister("a3TLq", function(module, exports) {

$parcel$export(module.exports, "FXAAFilter", function () { return $753570bf0b1e1037$export$86086ddb5389b795; });
/*!
 * @pixi/filter-fxaa - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/filter-fxaa is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $753570bf0b1e1037$var$extendStatics = function(d, b) {
    $753570bf0b1e1037$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $753570bf0b1e1037$var$extendStatics(d, b);
};
function $753570bf0b1e1037$var$__extends(d, b) {
    $753570bf0b1e1037$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $753570bf0b1e1037$var$vertex = "\nattribute vec2 aVertexPosition;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vFragCoord;\n\nuniform vec4 inputSize;\nuniform vec4 outputFrame;\n\nvec4 filterVertexPosition( void )\n{\n    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy;\n\n    return vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);\n}\n\nvoid texcoords(vec2 fragCoord, vec2 inverseVP,\n               out vec2 v_rgbNW, out vec2 v_rgbNE,\n               out vec2 v_rgbSW, out vec2 v_rgbSE,\n               out vec2 v_rgbM) {\n    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;\n    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;\n    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;\n    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;\n    v_rgbM = vec2(fragCoord * inverseVP);\n}\n\nvoid main(void) {\n\n   gl_Position = filterVertexPosition();\n\n   vFragCoord = aVertexPosition * outputFrame.zw;\n\n   texcoords(vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n}\n";
var $753570bf0b1e1037$var$fragment = "varying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vFragCoord;\nuniform sampler2D uSampler;\nuniform highp vec4 inputSize;\n\n\n/**\n Basic FXAA implementation based on the code on geeks3d.com with the\n modification that the texture2DLod stuff was removed since it's\n unsupported by WebGL.\n\n --\n\n From:\n https://github.com/mitsuhiko/webgl-meincraft\n\n Copyright (c) 2011 by Armin Ronacher.\n\n Some rights reserved.\n\n Redistribution and use in source and binary forms, with or without\n modification, are permitted provided that the following conditions are\n met:\n\n * Redistributions of source code must retain the above copyright\n notice, this list of conditions and the following disclaimer.\n\n * Redistributions in binary form must reproduce the above\n copyright notice, this list of conditions and the following\n disclaimer in the documentation and/or other materials provided\n with the distribution.\n\n * The names of the contributors may not be used to endorse or\n promote products derived from this software without specific\n prior written permission.\n\n THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS\n \"AS IS\" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT\n LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR\n A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT\n OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,\n SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT\n LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,\n DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY\n THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n */\n\n#ifndef FXAA_REDUCE_MIN\n#define FXAA_REDUCE_MIN   (1.0/ 128.0)\n#endif\n#ifndef FXAA_REDUCE_MUL\n#define FXAA_REDUCE_MUL   (1.0 / 8.0)\n#endif\n#ifndef FXAA_SPAN_MAX\n#define FXAA_SPAN_MAX     8.0\n#endif\n\n//optimized version for mobile, where dependent\n//texture reads can be a bottleneck\nvec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 inverseVP,\n          vec2 v_rgbNW, vec2 v_rgbNE,\n          vec2 v_rgbSW, vec2 v_rgbSE,\n          vec2 v_rgbM) {\n    vec4 color;\n    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;\n    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;\n    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;\n    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;\n    vec4 texColor = texture2D(tex, v_rgbM);\n    vec3 rgbM  = texColor.xyz;\n    vec3 luma = vec3(0.299, 0.587, 0.114);\n    float lumaNW = dot(rgbNW, luma);\n    float lumaNE = dot(rgbNE, luma);\n    float lumaSW = dot(rgbSW, luma);\n    float lumaSE = dot(rgbSE, luma);\n    float lumaM  = dot(rgbM,  luma);\n    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));\n    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));\n\n    mediump vec2 dir;\n    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));\n    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));\n\n    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *\n                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);\n\n    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);\n    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),\n              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),\n                  dir * rcpDirMin)) * inverseVP;\n\n    vec3 rgbA = 0.5 * (\n                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +\n                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);\n    vec3 rgbB = rgbA * 0.5 + 0.25 * (\n                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +\n                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);\n\n    float lumaB = dot(rgbB, luma);\n    if ((lumaB < lumaMin) || (lumaB > lumaMax))\n        color = vec4(rgbA, texColor.a);\n    else\n        color = vec4(rgbB, texColor.a);\n    return color;\n}\n\nvoid main() {\n\n      vec4 color;\n\n      color = fxaa(uSampler, vFragCoord, inputSize.zw, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n\n      gl_FragColor = color;\n}\n";
/**
 * Basic FXAA (Fast Approximate Anti-Aliasing) implementation based on the code on geeks3d.com
 * with the modification that the texture2DLod stuff was removed since it is unsupported by WebGL.
 *
 * @see https://github.com/mitsuhiko/webgl-meincraft
 *
 * @memberof PIXI.filters
 */ var $753570bf0b1e1037$export$86086ddb5389b795 = /** @class */ function(_super) {
    $753570bf0b1e1037$var$__extends(FXAAFilter, _super);
    function FXAAFilter() {
        // TODO - needs work
        return _super.call(this, $753570bf0b1e1037$var$vertex, $753570bf0b1e1037$var$fragment) || this;
    }
    return FXAAFilter;
}((0, $klOfb.Filter));

});

parcelRegister("arZq0", function(module, exports) {

$parcel$export(module.exports, "NoiseFilter", function () { return $79bc116dce27c2f3$export$2d7a5b72233a5183; });
/*!
 * @pixi/filter-noise - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/filter-noise is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $79bc116dce27c2f3$var$extendStatics = function(d, b) {
    $79bc116dce27c2f3$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $79bc116dce27c2f3$var$extendStatics(d, b);
};
function $79bc116dce27c2f3$var$__extends(d, b) {
    $79bc116dce27c2f3$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $79bc116dce27c2f3$var$fragment = "precision highp float;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform float uNoise;\nuniform float uSeed;\nuniform sampler2D uSampler;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture2D(uSampler, vTextureCoord);\n    float randomValue = rand(gl_FragCoord.xy * uSeed);\n    float diff = (randomValue - 0.5) * uNoise;\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n    }\n\n    color.r += diff;\n    color.g += diff;\n    color.b += diff;\n\n    // Premultiply alpha again.\n    color.rgb *= color.a;\n\n    gl_FragColor = color;\n}\n";
/**
 * A Noise effect filter.
 *
 * original filter: https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/noise.js
 *
 * @memberof PIXI.filters
 * @author Vico @vicocotea
 */ var $79bc116dce27c2f3$export$2d7a5b72233a5183 = /** @class */ function(_super) {
    $79bc116dce27c2f3$var$__extends(NoiseFilter, _super);
    /**
     * @param {number} [noise=0.5] - The noise intensity, should be a normalized value in the range [0, 1].
     * @param {number} [seed] - A random seed for the noise generation. Default is `Math.random()`.
     */ function NoiseFilter(noise, seed) {
        if (noise === void 0) noise = 0.5;
        if (seed === void 0) seed = Math.random();
        var _this = _super.call(this, (0, $klOfb.defaultFilterVertex), $79bc116dce27c2f3$var$fragment, {
            uNoise: 0,
            uSeed: 0
        }) || this;
        _this.noise = noise;
        _this.seed = seed;
        return _this;
    }
    Object.defineProperty(NoiseFilter.prototype, "noise", {
        /**
         * The amount of noise to apply, this value should be in the range (0, 1].
         *
         * @default 0.5
         */ get: function() {
            return this.uniforms.uNoise;
        },
        set: function(value) {
            this.uniforms.uNoise = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NoiseFilter.prototype, "seed", {
        /** A seed value to apply to the random noise generation. `Math.random()` is a good value to use. */ get: function() {
            return this.uniforms.uSeed;
        },
        set: function(value) {
            this.uniforms.uSeed = value;
        },
        enumerable: false,
        configurable: true
    });
    return NoiseFilter;
}((0, $klOfb.Filter));

});

parcelRegister("aqTFY", function(module, exports) {
/*!
 * @pixi/mixin-cache-as-bitmap - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/mixin-cache-as-bitmap is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $7Bs2Z = parcelRequire("7Bs2Z");

var $8t5Gy = parcelRequire("8t5Gy");

var $6qzqq = parcelRequire("6qzqq");

var $csytw = parcelRequire("csytw");

var $ezJmd = parcelRequire("ezJmd");
/*!
 * @pixi/constants - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/constants is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ /**
 * Different types of environments for WebGL.
 *
 * @static
 * @memberof PIXI
 * @name ENV
 * @enum {number}
 * @property {number} WEBGL_LEGACY - Used for older v1 WebGL devices. PixiJS will aim to ensure compatibility
 *  with older / less advanced devices. If you experience unexplained flickering prefer this environment.
 * @property {number} WEBGL - Version 1 of WebGL
 * @property {number} WEBGL2 - Version 2 of WebGL
 */ var $79878534657a31ab$var$ENV;
(function(ENV) {
    ENV[ENV["WEBGL_LEGACY"] = 0] = "WEBGL_LEGACY";
    ENV[ENV["WEBGL"] = 1] = "WEBGL";
    ENV[ENV["WEBGL2"] = 2] = "WEBGL2";
})($79878534657a31ab$var$ENV || ($79878534657a31ab$var$ENV = {}));
/**
 * Constant to identify the Renderer Type.
 *
 * @static
 * @memberof PIXI
 * @name RENDERER_TYPE
 * @enum {number}
 * @property {number} UNKNOWN - Unknown render type.
 * @property {number} WEBGL - WebGL render type.
 * @property {number} CANVAS - Canvas render type.
 */ var $79878534657a31ab$var$RENDERER_TYPE;
(function(RENDERER_TYPE) {
    RENDERER_TYPE[RENDERER_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
    RENDERER_TYPE[RENDERER_TYPE["WEBGL"] = 1] = "WEBGL";
    RENDERER_TYPE[RENDERER_TYPE["CANVAS"] = 2] = "CANVAS";
})($79878534657a31ab$var$RENDERER_TYPE || ($79878534657a31ab$var$RENDERER_TYPE = {}));
/**
 * Bitwise OR of masks that indicate the buffers to be cleared.
 *
 * @static
 * @memberof PIXI
 * @name BUFFER_BITS
 * @enum {number}
 * @property {number} COLOR - Indicates the buffers currently enabled for color writing.
 * @property {number} DEPTH - Indicates the depth buffer.
 * @property {number} STENCIL - Indicates the stencil buffer.
 */ var $79878534657a31ab$var$BUFFER_BITS;
(function(BUFFER_BITS) {
    BUFFER_BITS[BUFFER_BITS["COLOR"] = 16384] = "COLOR";
    BUFFER_BITS[BUFFER_BITS["DEPTH"] = 256] = "DEPTH";
    BUFFER_BITS[BUFFER_BITS["STENCIL"] = 1024] = "STENCIL";
})($79878534657a31ab$var$BUFFER_BITS || ($79878534657a31ab$var$BUFFER_BITS = {}));
/**
 * Various blend modes supported by PIXI.
 *
 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
 * Anything else will silently act like NORMAL.
 *
 * @memberof PIXI
 * @name BLEND_MODES
 * @enum {number}
 * @property {number} NORMAL
 * @property {number} ADD
 * @property {number} MULTIPLY
 * @property {number} SCREEN
 * @property {number} OVERLAY
 * @property {number} DARKEN
 * @property {number} LIGHTEN
 * @property {number} COLOR_DODGE
 * @property {number} COLOR_BURN
 * @property {number} HARD_LIGHT
 * @property {number} SOFT_LIGHT
 * @property {number} DIFFERENCE
 * @property {number} EXCLUSION
 * @property {number} HUE
 * @property {number} SATURATION
 * @property {number} COLOR
 * @property {number} LUMINOSITY
 * @property {number} NORMAL_NPM
 * @property {number} ADD_NPM
 * @property {number} SCREEN_NPM
 * @property {number} NONE
 * @property {number} SRC_IN
 * @property {number} SRC_OUT
 * @property {number} SRC_ATOP
 * @property {number} DST_OVER
 * @property {number} DST_IN
 * @property {number} DST_OUT
 * @property {number} DST_ATOP
 * @property {number} SUBTRACT
 * @property {number} SRC_OVER
 * @property {number} ERASE
 * @property {number} XOR
 */ var $79878534657a31ab$var$BLEND_MODES;
(function(BLEND_MODES) {
    BLEND_MODES[BLEND_MODES["NORMAL"] = 0] = "NORMAL";
    BLEND_MODES[BLEND_MODES["ADD"] = 1] = "ADD";
    BLEND_MODES[BLEND_MODES["MULTIPLY"] = 2] = "MULTIPLY";
    BLEND_MODES[BLEND_MODES["SCREEN"] = 3] = "SCREEN";
    BLEND_MODES[BLEND_MODES["OVERLAY"] = 4] = "OVERLAY";
    BLEND_MODES[BLEND_MODES["DARKEN"] = 5] = "DARKEN";
    BLEND_MODES[BLEND_MODES["LIGHTEN"] = 6] = "LIGHTEN";
    BLEND_MODES[BLEND_MODES["COLOR_DODGE"] = 7] = "COLOR_DODGE";
    BLEND_MODES[BLEND_MODES["COLOR_BURN"] = 8] = "COLOR_BURN";
    BLEND_MODES[BLEND_MODES["HARD_LIGHT"] = 9] = "HARD_LIGHT";
    BLEND_MODES[BLEND_MODES["SOFT_LIGHT"] = 10] = "SOFT_LIGHT";
    BLEND_MODES[BLEND_MODES["DIFFERENCE"] = 11] = "DIFFERENCE";
    BLEND_MODES[BLEND_MODES["EXCLUSION"] = 12] = "EXCLUSION";
    BLEND_MODES[BLEND_MODES["HUE"] = 13] = "HUE";
    BLEND_MODES[BLEND_MODES["SATURATION"] = 14] = "SATURATION";
    BLEND_MODES[BLEND_MODES["COLOR"] = 15] = "COLOR";
    BLEND_MODES[BLEND_MODES["LUMINOSITY"] = 16] = "LUMINOSITY";
    BLEND_MODES[BLEND_MODES["NORMAL_NPM"] = 17] = "NORMAL_NPM";
    BLEND_MODES[BLEND_MODES["ADD_NPM"] = 18] = "ADD_NPM";
    BLEND_MODES[BLEND_MODES["SCREEN_NPM"] = 19] = "SCREEN_NPM";
    BLEND_MODES[BLEND_MODES["NONE"] = 20] = "NONE";
    BLEND_MODES[BLEND_MODES["SRC_OVER"] = 0] = "SRC_OVER";
    BLEND_MODES[BLEND_MODES["SRC_IN"] = 21] = "SRC_IN";
    BLEND_MODES[BLEND_MODES["SRC_OUT"] = 22] = "SRC_OUT";
    BLEND_MODES[BLEND_MODES["SRC_ATOP"] = 23] = "SRC_ATOP";
    BLEND_MODES[BLEND_MODES["DST_OVER"] = 24] = "DST_OVER";
    BLEND_MODES[BLEND_MODES["DST_IN"] = 25] = "DST_IN";
    BLEND_MODES[BLEND_MODES["DST_OUT"] = 26] = "DST_OUT";
    BLEND_MODES[BLEND_MODES["DST_ATOP"] = 27] = "DST_ATOP";
    BLEND_MODES[BLEND_MODES["ERASE"] = 26] = "ERASE";
    BLEND_MODES[BLEND_MODES["SUBTRACT"] = 28] = "SUBTRACT";
    BLEND_MODES[BLEND_MODES["XOR"] = 29] = "XOR";
})($79878534657a31ab$var$BLEND_MODES || ($79878534657a31ab$var$BLEND_MODES = {}));
/**
 * Various webgl draw modes. These can be used to specify which GL drawMode to use
 * under certain situations and renderers.
 *
 * @memberof PIXI
 * @static
 * @name DRAW_MODES
 * @enum {number}
 * @property {number} POINTS
 * @property {number} LINES
 * @property {number} LINE_LOOP
 * @property {number} LINE_STRIP
 * @property {number} TRIANGLES
 * @property {number} TRIANGLE_STRIP
 * @property {number} TRIANGLE_FAN
 */ var $79878534657a31ab$var$DRAW_MODES;
(function(DRAW_MODES) {
    DRAW_MODES[DRAW_MODES["POINTS"] = 0] = "POINTS";
    DRAW_MODES[DRAW_MODES["LINES"] = 1] = "LINES";
    DRAW_MODES[DRAW_MODES["LINE_LOOP"] = 2] = "LINE_LOOP";
    DRAW_MODES[DRAW_MODES["LINE_STRIP"] = 3] = "LINE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLES"] = 4] = "TRIANGLES";
    DRAW_MODES[DRAW_MODES["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
    DRAW_MODES[DRAW_MODES["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
})($79878534657a31ab$var$DRAW_MODES || ($79878534657a31ab$var$DRAW_MODES = {}));
/**
 * Various GL texture/resources formats.
 *
 * @memberof PIXI
 * @static
 * @name FORMATS
 * @enum {number}
 * @property {number} RGBA=6408
 * @property {number} RGB=6407
 * @property {number} RG=33319
 * @property {number} RED=6403
 * @property {number} RGBA_INTEGER=36249
 * @property {number} RGB_INTEGER=36248
 * @property {number} RG_INTEGER=33320
 * @property {number} RED_INTEGER=36244
 * @property {number} ALPHA=6406
 * @property {number} LUMINANCE=6409
 * @property {number} LUMINANCE_ALPHA=6410
 * @property {number} DEPTH_COMPONENT=6402
 * @property {number} DEPTH_STENCIL=34041
 */ var $79878534657a31ab$var$FORMATS;
(function(FORMATS) {
    FORMATS[FORMATS["RGBA"] = 6408] = "RGBA";
    FORMATS[FORMATS["RGB"] = 6407] = "RGB";
    FORMATS[FORMATS["RG"] = 33319] = "RG";
    FORMATS[FORMATS["RED"] = 6403] = "RED";
    FORMATS[FORMATS["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
    FORMATS[FORMATS["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
    FORMATS[FORMATS["RG_INTEGER"] = 33320] = "RG_INTEGER";
    FORMATS[FORMATS["RED_INTEGER"] = 36244] = "RED_INTEGER";
    FORMATS[FORMATS["ALPHA"] = 6406] = "ALPHA";
    FORMATS[FORMATS["LUMINANCE"] = 6409] = "LUMINANCE";
    FORMATS[FORMATS["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
    FORMATS[FORMATS["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
    FORMATS[FORMATS["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
})($79878534657a31ab$var$FORMATS || ($79878534657a31ab$var$FORMATS = {}));
/**
 * Various GL target types.
 *
 * @memberof PIXI
 * @static
 * @name TARGETS
 * @enum {number}
 * @property {number} TEXTURE_2D=3553
 * @property {number} TEXTURE_CUBE_MAP=34067
 * @property {number} TEXTURE_2D_ARRAY=35866
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_X=34069
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_X=34070
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Y=34071
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Y=34072
 * @property {number} TEXTURE_CUBE_MAP_POSITIVE_Z=34073
 * @property {number} TEXTURE_CUBE_MAP_NEGATIVE_Z=34074
 */ var $79878534657a31ab$var$TARGETS;
(function(TARGETS) {
    TARGETS[TARGETS["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
    TARGETS[TARGETS["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
    TARGETS[TARGETS["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
})($79878534657a31ab$var$TARGETS || ($79878534657a31ab$var$TARGETS = {}));
/**
 * Various GL data format types.
 *
 * @memberof PIXI
 * @static
 * @name TYPES
 * @enum {number}
 * @property {number} UNSIGNED_BYTE=5121
 * @property {number} UNSIGNED_SHORT=5123
 * @property {number} UNSIGNED_SHORT_5_6_5=33635
 * @property {number} UNSIGNED_SHORT_4_4_4_4=32819
 * @property {number} UNSIGNED_SHORT_5_5_5_1=32820
 * @property {number} UNSIGNED_INT=5125
 * @property {number} UNSIGNED_INT_10F_11F_11F_REV=35899
 * @property {number} UNSIGNED_INT_2_10_10_10_REV=33640
 * @property {number} UNSIGNED_INT_24_8=34042
 * @property {number} UNSIGNED_INT_5_9_9_9_REV=35902
 * @property {number} BYTE=5120
 * @property {number} SHORT=5122
 * @property {number} INT=5124
 * @property {number} FLOAT=5126
 * @property {number} FLOAT_32_UNSIGNED_INT_24_8_REV=36269
 * @property {number} HALF_FLOAT=36193
 */ var $79878534657a31ab$var$TYPES;
(function(TYPES) {
    TYPES[TYPES["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
    TYPES[TYPES["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
    TYPES[TYPES["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
    TYPES[TYPES["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
    TYPES[TYPES["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
    TYPES[TYPES["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
    TYPES[TYPES["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
    TYPES[TYPES["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
    TYPES[TYPES["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
    TYPES[TYPES["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
    TYPES[TYPES["BYTE"] = 5120] = "BYTE";
    TYPES[TYPES["SHORT"] = 5122] = "SHORT";
    TYPES[TYPES["INT"] = 5124] = "INT";
    TYPES[TYPES["FLOAT"] = 5126] = "FLOAT";
    TYPES[TYPES["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
    TYPES[TYPES["HALF_FLOAT"] = 36193] = "HALF_FLOAT";
})($79878534657a31ab$var$TYPES || ($79878534657a31ab$var$TYPES = {}));
/**
 * Various sampler types. Correspond to `sampler`, `isampler`, `usampler` GLSL types respectively.
 * WebGL1 works only with FLOAT.
 *
 * @memberof PIXI
 * @static
 * @name SAMPLER_TYPES
 * @enum {number}
 * @property {number} FLOAT=0
 * @property {number} INT=1
 * @property {number} UINT=2
 */ var $79878534657a31ab$var$SAMPLER_TYPES;
(function(SAMPLER_TYPES) {
    SAMPLER_TYPES[SAMPLER_TYPES["FLOAT"] = 0] = "FLOAT";
    SAMPLER_TYPES[SAMPLER_TYPES["INT"] = 1] = "INT";
    SAMPLER_TYPES[SAMPLER_TYPES["UINT"] = 2] = "UINT";
})($79878534657a31ab$var$SAMPLER_TYPES || ($79878534657a31ab$var$SAMPLER_TYPES = {}));
/**
 * The scale modes that are supported by pixi.
 *
 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
 *
 * @memberof PIXI
 * @static
 * @name SCALE_MODES
 * @enum {number}
 * @property {number} LINEAR Smooth scaling
 * @property {number} NEAREST Pixelating scaling
 */ var $79878534657a31ab$var$SCALE_MODES;
(function(SCALE_MODES) {
    SCALE_MODES[SCALE_MODES["NEAREST"] = 0] = "NEAREST";
    SCALE_MODES[SCALE_MODES["LINEAR"] = 1] = "LINEAR";
})($79878534657a31ab$var$SCALE_MODES || ($79878534657a31ab$var$SCALE_MODES = {}));
/**
 * The wrap modes that are supported by pixi.
 *
 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
 * If the texture is non power of two then clamp will be used regardless as WebGL can
 * only use REPEAT if the texture is po2.
 *
 * This property only affects WebGL.
 *
 * @name WRAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} CLAMP - The textures uvs are clamped
 * @property {number} REPEAT - The texture uvs tile and repeat
 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
 */ var $79878534657a31ab$var$WRAP_MODES;
(function(WRAP_MODES) {
    WRAP_MODES[WRAP_MODES["CLAMP"] = 33071] = "CLAMP";
    WRAP_MODES[WRAP_MODES["REPEAT"] = 10497] = "REPEAT";
    WRAP_MODES[WRAP_MODES["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
})($79878534657a31ab$var$WRAP_MODES || ($79878534657a31ab$var$WRAP_MODES = {}));
/**
 * Mipmap filtering modes that are supported by pixi.
 *
 * The {@link PIXI.settings.MIPMAP_TEXTURES} affects default texture filtering.
 * Mipmaps are generated for a baseTexture if its `mipmap` field is `ON`,
 * or its `POW2` and texture dimensions are powers of 2.
 * Due to platform restriction, `ON` option will work like `POW2` for webgl-1.
 *
 * This property only affects WebGL.
 *
 * @name MIPMAP_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} OFF - No mipmaps
 * @property {number} POW2 - Generate mipmaps if texture dimensions are pow2
 * @property {number} ON - Always generate mipmaps
 * @property {number} ON_MANUAL - Use mipmaps, but do not auto-generate them; this is used with a resource
 *   that supports buffering each level-of-detail.
 */ var $79878534657a31ab$var$MIPMAP_MODES;
(function(MIPMAP_MODES) {
    MIPMAP_MODES[MIPMAP_MODES["OFF"] = 0] = "OFF";
    MIPMAP_MODES[MIPMAP_MODES["POW2"] = 1] = "POW2";
    MIPMAP_MODES[MIPMAP_MODES["ON"] = 2] = "ON";
    MIPMAP_MODES[MIPMAP_MODES["ON_MANUAL"] = 3] = "ON_MANUAL";
})($79878534657a31ab$var$MIPMAP_MODES || ($79878534657a31ab$var$MIPMAP_MODES = {}));
/**
 * How to treat textures with premultiplied alpha
 *
 * @name ALPHA_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NO_PREMULTIPLIED_ALPHA - Source is not premultiplied, leave it like that.
 *  Option for compressed and data textures that are created from typed arrays.
 * @property {number} PREMULTIPLY_ON_UPLOAD - Source is not premultiplied, premultiply on upload.
 *  Default option, used for all loaded images.
 * @property {number} PREMULTIPLIED_ALPHA - Source is already premultiplied
 *  Example: spine atlases with `_pma` suffix.
 * @property {number} NPM - Alias for NO_PREMULTIPLIED_ALPHA.
 * @property {number} UNPACK - Default option, alias for PREMULTIPLY_ON_UPLOAD.
 * @property {number} PMA - Alias for PREMULTIPLIED_ALPHA.
 */ var $79878534657a31ab$var$ALPHA_MODES;
(function(ALPHA_MODES) {
    ALPHA_MODES[ALPHA_MODES["NPM"] = 0] = "NPM";
    ALPHA_MODES[ALPHA_MODES["UNPACK"] = 1] = "UNPACK";
    ALPHA_MODES[ALPHA_MODES["PMA"] = 2] = "PMA";
    ALPHA_MODES[ALPHA_MODES["NO_PREMULTIPLIED_ALPHA"] = 0] = "NO_PREMULTIPLIED_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ON_UPLOAD"] = 1] = "PREMULTIPLY_ON_UPLOAD";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLY_ALPHA"] = 2] = "PREMULTIPLY_ALPHA";
    ALPHA_MODES[ALPHA_MODES["PREMULTIPLIED_ALPHA"] = 2] = "PREMULTIPLIED_ALPHA";
})($79878534657a31ab$var$ALPHA_MODES || ($79878534657a31ab$var$ALPHA_MODES = {}));
/**
 * Configure whether filter textures are cleared after binding.
 *
 * Filter textures need not be cleared if the filter does not use pixel blending. {@link CLEAR_MODES.BLIT} will detect
 * this and skip clearing as an optimization.
 *
 * @name CLEAR_MODES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} BLEND - Do not clear the filter texture. The filter's output will blend on top of the output texture.
 * @property {number} CLEAR - Always clear the filter texture.
 * @property {number} BLIT - Clear only if {@link FilterSystem.forceClear} is set or if the filter uses pixel blending.
 * @property {number} NO - Alias for BLEND, same as `false` in earlier versions
 * @property {number} YES - Alias for CLEAR, same as `true` in earlier versions
 * @property {number} AUTO - Alias for BLIT
 */ var $79878534657a31ab$var$CLEAR_MODES;
(function(CLEAR_MODES) {
    CLEAR_MODES[CLEAR_MODES["NO"] = 0] = "NO";
    CLEAR_MODES[CLEAR_MODES["YES"] = 1] = "YES";
    CLEAR_MODES[CLEAR_MODES["AUTO"] = 2] = "AUTO";
    CLEAR_MODES[CLEAR_MODES["BLEND"] = 0] = "BLEND";
    CLEAR_MODES[CLEAR_MODES["CLEAR"] = 1] = "CLEAR";
    CLEAR_MODES[CLEAR_MODES["BLIT"] = 2] = "BLIT";
})($79878534657a31ab$var$CLEAR_MODES || ($79878534657a31ab$var$CLEAR_MODES = {}));
/**
 * The gc modes that are supported by pixi.
 *
 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
 * used for a specified period of time they will be removed from the GPU. They will of course
 * be uploaded again when they are required. This is a silent behind the scenes process that
 * should ensure that the GPU does not  get filled up.
 *
 * Handy for mobile devices!
 * This property only affects WebGL.
 *
 * @name GC_MODES
 * @enum {number}
 * @static
 * @memberof PIXI
 * @property {number} AUTO - Garbage collection will happen periodically automatically
 * @property {number} MANUAL - Garbage collection will need to be called manually
 */ var $79878534657a31ab$var$GC_MODES;
(function(GC_MODES) {
    GC_MODES[GC_MODES["AUTO"] = 0] = "AUTO";
    GC_MODES[GC_MODES["MANUAL"] = 1] = "MANUAL";
})($79878534657a31ab$var$GC_MODES || ($79878534657a31ab$var$GC_MODES = {}));
/**
 * Constants that specify float precision in shaders.
 *
 * @name PRECISION
 * @memberof PIXI
 * @constant
 * @static
 * @enum {string}
 * @property {string} LOW='lowp'
 * @property {string} MEDIUM='mediump'
 * @property {string} HIGH='highp'
 */ var $79878534657a31ab$var$PRECISION;
(function(PRECISION) {
    PRECISION["LOW"] = "lowp";
    PRECISION["MEDIUM"] = "mediump";
    PRECISION["HIGH"] = "highp";
})($79878534657a31ab$var$PRECISION || ($79878534657a31ab$var$PRECISION = {}));
/**
 * Constants for mask implementations.
 * We use `type` suffix because it leads to very different behaviours
 *
 * @name MASK_TYPES
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - Mask is ignored
 * @property {number} SCISSOR - Scissor mask, rectangle on screen, cheap
 * @property {number} STENCIL - Stencil mask, 1-bit, medium, works only if renderer supports stencil
 * @property {number} SPRITE - Mask that uses SpriteMaskFilter, uses temporary RenderTexture
 */ var $79878534657a31ab$var$MASK_TYPES;
(function(MASK_TYPES) {
    MASK_TYPES[MASK_TYPES["NONE"] = 0] = "NONE";
    MASK_TYPES[MASK_TYPES["SCISSOR"] = 1] = "SCISSOR";
    MASK_TYPES[MASK_TYPES["STENCIL"] = 2] = "STENCIL";
    MASK_TYPES[MASK_TYPES["SPRITE"] = 3] = "SPRITE";
})($79878534657a31ab$var$MASK_TYPES || ($79878534657a31ab$var$MASK_TYPES = {}));
/**
 * Constants for multi-sampling antialiasing.
 *
 * @see PIXI.Framebuffer#multisample
 *
 * @name MSAA_QUALITY
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} NONE - No multisampling for this renderTexture
 * @property {number} LOW - Try 2 samples
 * @property {number} MEDIUM - Try 4 samples
 * @property {number} HIGH - Try 8 samples
 */ var $79878534657a31ab$var$MSAA_QUALITY;
(function(MSAA_QUALITY) {
    MSAA_QUALITY[MSAA_QUALITY["NONE"] = 0] = "NONE";
    MSAA_QUALITY[MSAA_QUALITY["LOW"] = 2] = "LOW";
    MSAA_QUALITY[MSAA_QUALITY["MEDIUM"] = 4] = "MEDIUM";
    MSAA_QUALITY[MSAA_QUALITY["HIGH"] = 8] = "HIGH";
})($79878534657a31ab$var$MSAA_QUALITY || ($79878534657a31ab$var$MSAA_QUALITY = {}));
/**
 * Constants for various buffer types in Pixi
 *
 * @see PIXI.BUFFER_TYPE
 *
 * @name BUFFER_TYPE
 * @memberof PIXI
 * @static
 * @enum {number}
 * @property {number} ELEMENT_ARRAY_BUFFER - buffer type for using as an index buffer
 * @property {number} ARRAY_BUFFER - buffer type for using attribute data
 * @property {number} UNIFORM_BUFFER - the buffer type is for uniform buffer objects
 */ var $79878534657a31ab$var$BUFFER_TYPE;
(function(BUFFER_TYPE) {
    BUFFER_TYPE[BUFFER_TYPE["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
    BUFFER_TYPE[BUFFER_TYPE["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
    // NOT YET SUPPORTED
    BUFFER_TYPE[BUFFER_TYPE["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
})($79878534657a31ab$var$BUFFER_TYPE || ($79878534657a31ab$var$BUFFER_TYPE = {}));
var $79878534657a31ab$var$_tempMatrix = new (0, $6qzqq.Matrix)();
(0, $8t5Gy.DisplayObject).prototype._cacheAsBitmap = false;
(0, $8t5Gy.DisplayObject).prototype._cacheData = null;
(0, $8t5Gy.DisplayObject).prototype._cacheAsBitmapResolution = null;
(0, $8t5Gy.DisplayObject).prototype._cacheAsBitmapMultisample = $79878534657a31ab$var$MSAA_QUALITY.NONE;
// figured there's no point adding ALL the extra variables to prototype.
// this model can hold the information needed. This can also be generated on demand as
// most objects are not cached as bitmaps.
/**
 * @class
 * @ignore
 * @private
 */ var $79878534657a31ab$export$3e19bdfd927f283c = /** @class */ function() {
    function CacheData() {
        this.textureCacheId = null;
        this.originalRender = null;
        this.originalRenderCanvas = null;
        this.originalCalculateBounds = null;
        this.originalGetLocalBounds = null;
        this.originalUpdateTransform = null;
        this.originalDestroy = null;
        this.originalMask = null;
        this.originalFilterArea = null;
        this.originalContainsPoint = null;
        this.sprite = null;
    }
    return CacheData;
}();
Object.defineProperties((0, $8t5Gy.DisplayObject).prototype, {
    /**
     * The resolution to use for cacheAsBitmap. By default this will use the renderer's resolution
     * but can be overriden for performance. Lower values will reduce memory usage at the expense
     * of render quality. A falsey value of `null` or `0` will default to the renderer's resolution.
     * If `cacheAsBitmap` is set to `true`, this will re-render with the new resolution.
     *
     * @member {number} cacheAsBitmapResolution
     * @memberof PIXI.DisplayObject#
     * @default null
     */ cacheAsBitmapResolution: {
        get: function() {
            return this._cacheAsBitmapResolution;
        },
        set: function(resolution) {
            if (resolution === this._cacheAsBitmapResolution) return;
            this._cacheAsBitmapResolution = resolution;
            if (this.cacheAsBitmap) {
                // Toggle to re-render at the new resolution
                this.cacheAsBitmap = false;
                this.cacheAsBitmap = true;
            }
        }
    },
    /**
     * The number of samples to use for cacheAsBitmap. If set to `null`, the renderer's
     * sample count is used.
     * If `cacheAsBitmap` is set to `true`, this will re-render with the new number of samples.
     *
     * @member {number} cacheAsBitmapMultisample
     * @memberof PIXI.DisplayObject#
     * @default PIXI.MSAA_QUALITY.NONE
     */ cacheAsBitmapMultisample: {
        get: function() {
            return this._cacheAsBitmapMultisample;
        },
        set: function(multisample) {
            if (multisample === this._cacheAsBitmapMultisample) return;
            this._cacheAsBitmapMultisample = multisample;
            if (this.cacheAsBitmap) {
                // Toggle to re-render with new multisample
                this.cacheAsBitmap = false;
                this.cacheAsBitmap = true;
            }
        }
    },
    /**
     * Set this to true if you want this display object to be cached as a bitmap.
     * This basically takes a snap shot of the display object as it is at that moment. It can
     * provide a performance benefit for complex static displayObjects.
     * To remove simply set this property to `false`
     *
     * IMPORTANT GOTCHA - Make sure that all your textures are preloaded BEFORE setting this property to true
     * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
     *
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     */ cacheAsBitmap: {
        get: function() {
            return this._cacheAsBitmap;
        },
        set: function(value) {
            if (this._cacheAsBitmap === value) return;
            this._cacheAsBitmap = value;
            var data;
            if (value) {
                if (!this._cacheData) this._cacheData = new $79878534657a31ab$export$3e19bdfd927f283c();
                data = this._cacheData;
                data.originalRender = this.render;
                data.originalRenderCanvas = this.renderCanvas;
                data.originalUpdateTransform = this.updateTransform;
                data.originalCalculateBounds = this.calculateBounds;
                data.originalGetLocalBounds = this.getLocalBounds;
                data.originalDestroy = this.destroy;
                data.originalContainsPoint = this.containsPoint;
                data.originalMask = this._mask;
                data.originalFilterArea = this.filterArea;
                this.render = this._renderCached;
                this.renderCanvas = this._renderCachedCanvas;
                this.destroy = this._cacheAsBitmapDestroy;
            } else {
                data = this._cacheData;
                if (data.sprite) this._destroyCachedDisplayObject();
                this.render = data.originalRender;
                this.renderCanvas = data.originalRenderCanvas;
                this.calculateBounds = data.originalCalculateBounds;
                this.getLocalBounds = data.originalGetLocalBounds;
                this.destroy = data.originalDestroy;
                this.updateTransform = data.originalUpdateTransform;
                this.containsPoint = data.originalContainsPoint;
                this._mask = data.originalMask;
                this.filterArea = data.originalFilterArea;
            }
        }
    }
});
/**
 * Renders a cached version of the sprite with WebGL
 *
 * @private
 * @method _renderCached
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.Renderer} renderer - the WebGL renderer
 */ (0, $8t5Gy.DisplayObject).prototype._renderCached = function _renderCached(renderer) {
    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
    this._initCachedDisplayObject(renderer);
    this._cacheData.sprite.transform._worldID = this.transform._worldID;
    this._cacheData.sprite.worldAlpha = this.worldAlpha;
    this._cacheData.sprite._render(renderer);
};
/**
 * Prepares the WebGL renderer to cache the sprite
 *
 * @private
 * @method _initCachedDisplayObject
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.Renderer} renderer - the WebGL renderer
 */ (0, $8t5Gy.DisplayObject).prototype._initCachedDisplayObject = function _initCachedDisplayObject(renderer) {
    var _a;
    if (this._cacheData && this._cacheData.sprite) return;
    // make sure alpha is set to 1 otherwise it will get rendered as invisible!
    var cacheAlpha = this.alpha;
    this.alpha = 1;
    // first we flush anything left in the renderer (otherwise it would get rendered to the cached texture)
    renderer.batch.flush();
    // this.filters= [];
    // next we find the dimensions of the untransformed object
    // this function also calls updatetransform on all its children as part of the measuring.
    // This means we don't need to update the transform again in this function
    // TODO pass an object to clone too? saves having to create a new one each time!
    var bounds = this.getLocalBounds(null, true).clone();
    // add some padding!
    if (this.filters && this.filters.length) {
        var padding = this.filters[0].padding;
        bounds.pad(padding);
    }
    bounds.ceil((0, $ezJmd.settings).RESOLUTION);
    // for now we cache the current renderTarget that the WebGL renderer is currently using.
    // this could be more elegant..
    var cachedRenderTexture = renderer.renderTexture.current;
    var cachedSourceFrame = renderer.renderTexture.sourceFrame.clone();
    var cachedDestinationFrame = renderer.renderTexture.destinationFrame.clone();
    var cachedProjectionTransform = renderer.projection.transform;
    // We also store the filter stack - I will definitely look to change how this works a little later down the line.
    // const stack = renderer.filterManager.filterStack;
    // this renderTexture will be used to store the cached DisplayObject
    var renderTexture = (0, $klOfb.RenderTexture).create({
        width: bounds.width,
        height: bounds.height,
        resolution: this.cacheAsBitmapResolution || renderer.resolution,
        multisample: (_a = this.cacheAsBitmapMultisample) !== null && _a !== void 0 ? _a : renderer.multisample
    });
    var textureCacheId = "cacheAsBitmap_" + (0, $csytw.uid)();
    this._cacheData.textureCacheId = textureCacheId;
    (0, $klOfb.BaseTexture).addToCache(renderTexture.baseTexture, textureCacheId);
    (0, $klOfb.Texture).addToCache(renderTexture, textureCacheId);
    // need to set //
    var m = this.transform.localTransform.copyTo($79878534657a31ab$var$_tempMatrix).invert().translate(-bounds.x, -bounds.y);
    // set all properties to there original so we can render to a texture
    this.render = this._cacheData.originalRender;
    renderer.render(this, {
        renderTexture: renderTexture,
        clear: true,
        transform: m,
        skipUpdateTransform: false
    });
    renderer.framebuffer.blit();
    // now restore the state be setting the new properties
    renderer.projection.transform = cachedProjectionTransform;
    renderer.renderTexture.bind(cachedRenderTexture, cachedSourceFrame, cachedDestinationFrame);
    // renderer.filterManager.filterStack = stack;
    this.render = this._renderCached;
    // the rest is the same as for Canvas
    this.updateTransform = this.displayObjectUpdateTransform;
    this.calculateBounds = this._calculateCachedBounds;
    this.getLocalBounds = this._getCachedLocalBounds;
    this._mask = null;
    this.filterArea = null;
    this.alpha = cacheAlpha;
    // create our cached sprite
    var cachedSprite = new (0, $7Bs2Z.Sprite)(renderTexture);
    cachedSprite.transform.worldTransform = this.transform.worldTransform;
    cachedSprite.anchor.x = -(bounds.x / bounds.width);
    cachedSprite.anchor.y = -(bounds.y / bounds.height);
    cachedSprite.alpha = cacheAlpha;
    cachedSprite._bounds = this._bounds;
    this._cacheData.sprite = cachedSprite;
    this.transform._parentID = -1;
    // restore the transform of the cached sprite to avoid the nasty flicker..
    if (!this.parent) {
        this.enableTempParent();
        this.updateTransform();
        this.disableTempParent(null);
    } else this.updateTransform();
    // map the hit test..
    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};
/**
 * Renders a cached version of the sprite with canvas
 *
 * @private
 * @method _renderCachedCanvas
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.CanvasRenderer} renderer - The canvas renderer
 */ (0, $8t5Gy.DisplayObject).prototype._renderCachedCanvas = function _renderCachedCanvas(renderer) {
    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
    this._initCachedDisplayObjectCanvas(renderer);
    this._cacheData.sprite.worldAlpha = this.worldAlpha;
    this._cacheData.sprite._renderCanvas(renderer);
};
// TODO this can be the same as the WebGL version.. will need to do a little tweaking first though..
/**
 * Prepares the Canvas renderer to cache the sprite
 *
 * @private
 * @method _initCachedDisplayObjectCanvas
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.CanvasRenderer} renderer - The canvas renderer
 */ (0, $8t5Gy.DisplayObject).prototype._initCachedDisplayObjectCanvas = function _initCachedDisplayObjectCanvas(renderer) {
    if (this._cacheData && this._cacheData.sprite) return;
    // get bounds actually transforms the object for us already!
    var bounds = this.getLocalBounds(null, true);
    var cacheAlpha = this.alpha;
    this.alpha = 1;
    var cachedRenderTarget = renderer.context;
    var cachedProjectionTransform = renderer._projTransform;
    bounds.ceil((0, $ezJmd.settings).RESOLUTION);
    var renderTexture = (0, $klOfb.RenderTexture).create({
        width: bounds.width,
        height: bounds.height
    });
    var textureCacheId = "cacheAsBitmap_" + (0, $csytw.uid)();
    this._cacheData.textureCacheId = textureCacheId;
    (0, $klOfb.BaseTexture).addToCache(renderTexture.baseTexture, textureCacheId);
    (0, $klOfb.Texture).addToCache(renderTexture, textureCacheId);
    // need to set //
    var m = $79878534657a31ab$var$_tempMatrix;
    this.transform.localTransform.copyTo(m);
    m.invert();
    m.tx -= bounds.x;
    m.ty -= bounds.y;
    // m.append(this.transform.worldTransform.)
    // set all properties to there original so we can render to a texture
    this.renderCanvas = this._cacheData.originalRenderCanvas;
    renderer.render(this, {
        renderTexture: renderTexture,
        clear: true,
        transform: m,
        skipUpdateTransform: false
    });
    // now restore the state be setting the new properties
    renderer.context = cachedRenderTarget;
    renderer._projTransform = cachedProjectionTransform;
    this.renderCanvas = this._renderCachedCanvas;
    // the rest is the same as for WebGL
    this.updateTransform = this.displayObjectUpdateTransform;
    this.calculateBounds = this._calculateCachedBounds;
    this.getLocalBounds = this._getCachedLocalBounds;
    this._mask = null;
    this.filterArea = null;
    this.alpha = cacheAlpha;
    // create our cached sprite
    var cachedSprite = new (0, $7Bs2Z.Sprite)(renderTexture);
    cachedSprite.transform.worldTransform = this.transform.worldTransform;
    cachedSprite.anchor.x = -(bounds.x / bounds.width);
    cachedSprite.anchor.y = -(bounds.y / bounds.height);
    cachedSprite.alpha = cacheAlpha;
    cachedSprite._bounds = this._bounds;
    this._cacheData.sprite = cachedSprite;
    this.transform._parentID = -1;
    // restore the transform of the cached sprite to avoid the nasty flicker..
    if (!this.parent) {
        this.parent = renderer._tempDisplayObjectParent;
        this.updateTransform();
        this.parent = null;
    } else this.updateTransform();
    // map the hit test..
    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};
/**
 * Calculates the bounds of the cached sprite
 *
 * @private
 * @method
 */ (0, $8t5Gy.DisplayObject).prototype._calculateCachedBounds = function _calculateCachedBounds() {
    this._bounds.clear();
    this._cacheData.sprite.transform._worldID = this.transform._worldID;
    this._cacheData.sprite._calculateBounds();
    this._bounds.updateID = this._boundsID;
};
/**
 * Gets the bounds of the cached sprite.
 *
 * @private
 * @method
 * @return {Rectangle} The local bounds.
 */ (0, $8t5Gy.DisplayObject).prototype._getCachedLocalBounds = function _getCachedLocalBounds() {
    return this._cacheData.sprite.getLocalBounds(null);
};
/**
 * Destroys the cached sprite.
 *
 * @private
 * @method
 */ (0, $8t5Gy.DisplayObject).prototype._destroyCachedDisplayObject = function _destroyCachedDisplayObject() {
    this._cacheData.sprite._texture.destroy(true);
    this._cacheData.sprite = null;
    (0, $klOfb.BaseTexture).removeFromCache(this._cacheData.textureCacheId);
    (0, $klOfb.Texture).removeFromCache(this._cacheData.textureCacheId);
    this._cacheData.textureCacheId = null;
};
/**
 * Destroys the cached object.
 *
 * @private
 * @method
 * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
 *  have been set to that value.
 *  Used when destroying containers, see the Container.destroy method.
 */ (0, $8t5Gy.DisplayObject).prototype._cacheAsBitmapDestroy = function _cacheAsBitmapDestroy(options) {
    this.cacheAsBitmap = false;
    this.destroy(options);
};

});

parcelRegister("1xfIs", function(module, exports) {
/*!
 * @pixi/mixin-get-child-by-name - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/mixin-get-child-by-name is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $8t5Gy = parcelRequire("8t5Gy");
/**
 * The instance name of the object.
 *
 * @memberof PIXI.DisplayObject#
 * @member {string} name
 */ (0, $8t5Gy.DisplayObject).prototype.name = null;
/**
 * Returns the display object in the container.
 *
 * Recursive searches are done in a preorder traversal.
 *
 * @method getChildByName
 * @memberof PIXI.Container#
 * @param {string} name - Instance name.
 * @param {boolean}[deep=false] - Whether to search recursively
 * @return {PIXI.DisplayObject} The child with the specified name.
 */ (0, $8t5Gy.Container).prototype.getChildByName = function getChildByName(name, deep) {
    for(var i = 0, j = this.children.length; i < j; i++){
        if (this.children[i].name === name) return this.children[i];
    }
    if (deep) for(var i = 0, j = this.children.length; i < j; i++){
        var child = this.children[i];
        if (!child.getChildByName) continue;
        var target = this.children[i].getChildByName(name, true);
        if (target) return target;
    }
    return null;
};

});

parcelRegister("60K84", function(module, exports) {
/*!
 * @pixi/mixin-get-global-position - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/mixin-get-global-position is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $8t5Gy = parcelRequire("8t5Gy");

var $6qzqq = parcelRequire("6qzqq");
/**
 * Returns the global position of the displayObject. Does not depend on object scale, rotation and pivot.
 *
 * @method getGlobalPosition
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.Point} [point=new PIXI.Point()] - The point to write the global value to.
 * @param {boolean} [skipUpdate=false] - Setting to true will stop the transforms of the scene graph from
 *  being updated. This means the calculation returned MAY be out of date BUT will give you a
 *  nice performance boost.
 * @return {PIXI.Point} The updated point.
 */ (0, $8t5Gy.DisplayObject).prototype.getGlobalPosition = function getGlobalPosition(point, skipUpdate) {
    if (point === void 0) point = new (0, $6qzqq.Point)();
    if (skipUpdate === void 0) skipUpdate = false;
    if (this.parent) this.parent.toGlobal(this.position, point, skipUpdate);
    else {
        point.x = this.position.x;
        point.y = this.position.y;
    }
    return point;
};

});

parcelRegister("eUwg9", function(module, exports) {

$parcel$export(module.exports, "PlaneGeometry", function () { return $adaf51b2c64e8e1b$export$967d831af31f69ce; });
$parcel$export(module.exports, "RopeGeometry", function () { return $adaf51b2c64e8e1b$export$6a9827483976bf64; });
$parcel$export(module.exports, "SimpleRope", function () { return $adaf51b2c64e8e1b$export$f009a14c3f00879e; });
$parcel$export(module.exports, "SimplePlane", function () { return $adaf51b2c64e8e1b$export$d47c1aa7111669b9; });
$parcel$export(module.exports, "SimpleMesh", function () { return $adaf51b2c64e8e1b$export$81b9e78682e7feca; });
$parcel$export(module.exports, "NineSlicePlane", function () { return $adaf51b2c64e8e1b$export$acdf4cb3f489544e; });
/*!
 * @pixi/mesh-extras - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/mesh-extras is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $9Tsx3 = parcelRequire("9Tsx3");

var $P8XPi = parcelRequire("P8XPi");

var $klOfb = parcelRequire("klOfb");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $adaf51b2c64e8e1b$var$extendStatics = function(d, b) {
    $adaf51b2c64e8e1b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $adaf51b2c64e8e1b$var$extendStatics(d, b);
};
function $adaf51b2c64e8e1b$var$__extends(d, b) {
    $adaf51b2c64e8e1b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * @memberof PIXI
 */ var $adaf51b2c64e8e1b$export$967d831af31f69ce = /** @class */ function(_super) {
    $adaf51b2c64e8e1b$var$__extends(PlaneGeometry, _super);
    /**
     * @param width - The width of the plane.
     * @param height - The height of the plane.
     * @param segWidth - Number of horizontal segments.
     * @param segHeight - Number of vertical segments.
     */ function PlaneGeometry(width, height, segWidth, segHeight) {
        if (width === void 0) width = 100;
        if (height === void 0) height = 100;
        if (segWidth === void 0) segWidth = 10;
        if (segHeight === void 0) segHeight = 10;
        var _this = _super.call(this) || this;
        _this.segWidth = segWidth;
        _this.segHeight = segHeight;
        _this.width = width;
        _this.height = height;
        _this.build();
        return _this;
    }
    /**
     * Refreshes plane coordinates
     * @private
     */ PlaneGeometry.prototype.build = function() {
        var total = this.segWidth * this.segHeight;
        var verts = [];
        var uvs = [];
        var indices = [];
        var segmentsX = this.segWidth - 1;
        var segmentsY = this.segHeight - 1;
        var sizeX = this.width / segmentsX;
        var sizeY = this.height / segmentsY;
        for(var i = 0; i < total; i++){
            var x = i % this.segWidth;
            var y = i / this.segWidth | 0;
            verts.push(x * sizeX, y * sizeY);
            uvs.push(x / segmentsX, y / segmentsY);
        }
        var totalSub = segmentsX * segmentsY;
        for(var i = 0; i < totalSub; i++){
            var xpos = i % segmentsX;
            var ypos = i / segmentsX | 0;
            var value = ypos * this.segWidth + xpos;
            var value2 = ypos * this.segWidth + xpos + 1;
            var value3 = (ypos + 1) * this.segWidth + xpos;
            var value4 = (ypos + 1) * this.segWidth + xpos + 1;
            indices.push(value, value2, value3, value2, value4, value3);
        }
        this.buffers[0].data = new Float32Array(verts);
        this.buffers[1].data = new Float32Array(uvs);
        this.indexBuffer.data = new Uint16Array(indices);
        // ensure that the changes are uploaded
        this.buffers[0].update();
        this.buffers[1].update();
        this.indexBuffer.update();
    };
    return PlaneGeometry;
}((0, $9Tsx3.MeshGeometry));
/**
 * RopeGeometry allows you to draw a geometry across several points and then manipulate these points.
 *
 * ```js
 * for (let i = 0; i < 20; i++) {
 *     points.push(new PIXI.Point(i * 50, 0));
 * };
 * const rope = new PIXI.RopeGeometry(100, points);
 * ```
 *
 * @class
 * @extends PIXI.MeshGeometry
 * @memberof PIXI
 *
 */ var $adaf51b2c64e8e1b$export$6a9827483976bf64 = /** @class */ function(_super) {
    $adaf51b2c64e8e1b$var$__extends(RopeGeometry, _super);
    /**
     * @param {number} [width=200] - The width (i.e., thickness) of the rope.
     * @param {PIXI.Point[]} [points] - An array of {@link PIXI.Point} objects to construct this rope.
     * @param {number} [textureScale=0] - By default the rope texture will be stretched to match
     *     rope length. If textureScale is positive this value will be treated as a scaling
     *     factor and the texture will preserve its aspect ratio instead. To create a tiling rope
     *     set baseTexture.wrapMode to {@link PIXI.WRAP_MODES.REPEAT} and use a power of two texture,
     *     then set textureScale=1 to keep the original texture pixel size.
     *     In order to reduce alpha channel artifacts provide a larger texture and downsample -
     *     i.e. set textureScale=0.5 to scale it down twice.
     */ function RopeGeometry(width, points, textureScale) {
        if (width === void 0) width = 200;
        if (textureScale === void 0) textureScale = 0;
        var _this = _super.call(this, new Float32Array(points.length * 4), new Float32Array(points.length * 4), new Uint16Array((points.length - 1) * 6)) || this;
        /**
         * An array of points that determine the rope
         * @member {PIXI.Point[]}
         */ _this.points = points;
        /**
         * The width (i.e., thickness) of the rope.
         * @member {number}
         * @readOnly
         */ _this._width = width;
        /**
         * Rope texture scale, if zero then the rope texture is stretched.
         * @member {number}
         * @readOnly
         */ _this.textureScale = textureScale;
        _this.build();
        return _this;
    }
    Object.defineProperty(RopeGeometry.prototype, "width", {
        /**
         * The width (i.e., thickness) of the rope.
         * @member {number}
         * @readOnly
         */ get: function() {
            return this._width;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Refreshes Rope indices and uvs
     * @private
     */ RopeGeometry.prototype.build = function() {
        var points = this.points;
        if (!points) return;
        var vertexBuffer = this.getBuffer('aVertexPosition');
        var uvBuffer = this.getBuffer('aTextureCoord');
        var indexBuffer = this.getIndex();
        // if too little points, or texture hasn't got UVs set yet just move on.
        if (points.length < 1) return;
        // if the number of points has changed we will need to recreate the arraybuffers
        if (vertexBuffer.data.length / 4 !== points.length) {
            vertexBuffer.data = new Float32Array(points.length * 4);
            uvBuffer.data = new Float32Array(points.length * 4);
            indexBuffer.data = new Uint16Array((points.length - 1) * 6);
        }
        var uvs = uvBuffer.data;
        var indices = indexBuffer.data;
        uvs[0] = 0;
        uvs[1] = 0;
        uvs[2] = 0;
        uvs[3] = 1;
        var amount = 0;
        var prev = points[0];
        var textureWidth = this._width * this.textureScale;
        var total = points.length; // - 1;
        for(var i = 0; i < total; i++){
            // time to do some smart drawing!
            var index = i * 4;
            if (this.textureScale > 0) {
                // calculate pixel distance from previous point
                var dx = prev.x - points[i].x;
                var dy = prev.y - points[i].y;
                var distance = Math.sqrt(dx * dx + dy * dy);
                prev = points[i];
                amount += distance / textureWidth;
            } else // stretch texture
            amount = i / (total - 1);
            uvs[index] = amount;
            uvs[index + 1] = 0;
            uvs[index + 2] = amount;
            uvs[index + 3] = 1;
        }
        var indexCount = 0;
        for(var i = 0; i < total - 1; i++){
            var index = i * 2;
            indices[indexCount++] = index;
            indices[indexCount++] = index + 1;
            indices[indexCount++] = index + 2;
            indices[indexCount++] = index + 2;
            indices[indexCount++] = index + 1;
            indices[indexCount++] = index + 3;
        }
        // ensure that the changes are uploaded
        uvBuffer.update();
        indexBuffer.update();
        this.updateVertices();
    };
    /**
     * refreshes vertices of Rope mesh
     */ RopeGeometry.prototype.updateVertices = function() {
        var points = this.points;
        if (points.length < 1) return;
        var lastPoint = points[0];
        var nextPoint;
        var perpX = 0;
        var perpY = 0;
        var vertices = this.buffers[0].data;
        var total = points.length;
        for(var i = 0; i < total; i++){
            var point = points[i];
            var index = i * 4;
            if (i < points.length - 1) nextPoint = points[i + 1];
            else nextPoint = point;
            perpY = -(nextPoint.x - lastPoint.x);
            perpX = nextPoint.y - lastPoint.y;
            var perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
            var num = this.textureScale > 0 ? this.textureScale * this._width / 2 : this._width / 2;
            perpX /= perpLength;
            perpY /= perpLength;
            perpX *= num;
            perpY *= num;
            vertices[index] = point.x + perpX;
            vertices[index + 1] = point.y + perpY;
            vertices[index + 2] = point.x - perpX;
            vertices[index + 3] = point.y - perpY;
            lastPoint = point;
        }
        this.buffers[0].update();
    };
    RopeGeometry.prototype.update = function() {
        if (this.textureScale > 0) this.build(); // we need to update UVs
        else this.updateVertices();
    };
    return RopeGeometry;
}((0, $9Tsx3.MeshGeometry));
/**
 * The rope allows you to draw a texture across several points and then manipulate these points
 *
 *```js
 * for (let i = 0; i < 20; i++) {
 *     points.push(new PIXI.Point(i * 50, 0));
 * };
 * let rope = new PIXI.SimpleRope(PIXI.Texture.from("snake.png"), points);
 *  ```
 *
 * @memberof PIXI
 */ var $adaf51b2c64e8e1b$export$f009a14c3f00879e = /** @class */ function(_super) {
    $adaf51b2c64e8e1b$var$__extends(SimpleRope, _super);
    /**
     * @param texture - The texture to use on the rope.
     * @param points - An array of {@link PIXI.Point} objects to construct this rope.
     * @param {number} textureScale - Optional. Positive values scale rope texture
     * keeping its aspect ratio. You can reduce alpha channel artifacts by providing a larger texture
     * and downsampling here. If set to zero, texture will be stretched instead.
     */ function SimpleRope(texture, points, textureScale) {
        if (textureScale === void 0) textureScale = 0;
        var _this = this;
        var ropeGeometry = new $adaf51b2c64e8e1b$export$6a9827483976bf64(texture.height, points, textureScale);
        var meshMaterial = new (0, $9Tsx3.MeshMaterial)(texture);
        if (textureScale > 0) // attempt to set UV wrapping, will fail on non-power of two textures
        texture.baseTexture.wrapMode = (0, $P8XPi.WRAP_MODES).REPEAT;
        _this = _super.call(this, ropeGeometry, meshMaterial) || this;
        /**
         * re-calculate vertices by rope points each frame
         *
         * @member {boolean}
         */ _this.autoUpdate = true;
        return _this;
    }
    SimpleRope.prototype._render = function(renderer) {
        var geometry = this.geometry;
        if (this.autoUpdate || geometry._width !== this.shader.texture.height) {
            geometry._width = this.shader.texture.height;
            geometry.update();
        }
        _super.prototype._render.call(this, renderer);
    };
    return SimpleRope;
}((0, $9Tsx3.Mesh));
/**
 * The SimplePlane allows you to draw a texture across several points and then manipulate these points
 *
 *```js
 * for (let i = 0; i < 20; i++) {
 *     points.push(new PIXI.Point(i * 50, 0));
 * };
 * let SimplePlane = new PIXI.SimplePlane(PIXI.Texture.from("snake.png"), points);
 *  ```
 *
 * @memberof PIXI
 */ var $adaf51b2c64e8e1b$export$d47c1aa7111669b9 = /** @class */ function(_super) {
    $adaf51b2c64e8e1b$var$__extends(SimplePlane, _super);
    /**
     * @param texture - The texture to use on the SimplePlane.
     * @param verticesX - The number of vertices in the x-axis
     * @param verticesY - The number of vertices in the y-axis
     */ function SimplePlane(texture, verticesX, verticesY) {
        var _this = this;
        var planeGeometry = new $adaf51b2c64e8e1b$export$967d831af31f69ce(texture.width, texture.height, verticesX, verticesY);
        var meshMaterial = new (0, $9Tsx3.MeshMaterial)((0, $klOfb.Texture).WHITE);
        _this = _super.call(this, planeGeometry, meshMaterial) || this;
        // lets call the setter to ensure all necessary updates are performed
        _this.texture = texture;
        _this.autoResize = true;
        return _this;
    }
    /**
     * Method used for overrides, to do something in case texture frame was changed.
     * Meshes based on plane can override it and change more details based on texture.
     */ SimplePlane.prototype.textureUpdated = function() {
        this._textureID = this.shader.texture._updateID;
        var geometry = this.geometry;
        var _a = this.shader.texture, width = _a.width, height = _a.height;
        if (this.autoResize && (geometry.width !== width || geometry.height !== height)) {
            geometry.width = this.shader.texture.width;
            geometry.height = this.shader.texture.height;
            geometry.build();
        }
    };
    Object.defineProperty(SimplePlane.prototype, "texture", {
        get: function() {
            return this.shader.texture;
        },
        set: function(value) {
            // Track texture same way sprite does.
            // For generated meshes like NineSlicePlane it can change the geometry.
            // Unfortunately, this method might not work if you directly change texture in material.
            if (this.shader.texture === value) return;
            this.shader.texture = value;
            this._textureID = -1;
            if (value.baseTexture.valid) this.textureUpdated();
            else value.once('update', this.textureUpdated, this);
        },
        enumerable: false,
        configurable: true
    });
    SimplePlane.prototype._render = function(renderer) {
        if (this._textureID !== this.shader.texture._updateID) this.textureUpdated();
        _super.prototype._render.call(this, renderer);
    };
    SimplePlane.prototype.destroy = function(options) {
        this.shader.texture.off('update', this.textureUpdated, this);
        _super.prototype.destroy.call(this, options);
    };
    return SimplePlane;
}((0, $9Tsx3.Mesh));
/**
 * The Simple Mesh class mimics Mesh in PixiJS v4, providing easy-to-use constructor arguments.
 * For more robust customization, use {@link PIXI.Mesh}.
 *
 * @memberof PIXI
 */ var $adaf51b2c64e8e1b$export$81b9e78682e7feca = /** @class */ function(_super) {
    $adaf51b2c64e8e1b$var$__extends(SimpleMesh, _super);
    /**
     * @param texture - The texture to use
     * @param {Float32Array} [vertices] - if you want to specify the vertices
     * @param {Float32Array} [uvs] - if you want to specify the uvs
     * @param {Uint16Array} [indices] - if you want to specify the indices
     * @param drawMode - the drawMode, can be any of the Mesh.DRAW_MODES consts
     */ function SimpleMesh(texture, vertices, uvs, indices, drawMode) {
        if (texture === void 0) texture = (0, $klOfb.Texture).EMPTY;
        var _this = this;
        var geometry = new (0, $9Tsx3.MeshGeometry)(vertices, uvs, indices);
        geometry.getBuffer('aVertexPosition').static = false;
        var meshMaterial = new (0, $9Tsx3.MeshMaterial)(texture);
        _this = _super.call(this, geometry, meshMaterial, null, drawMode) || this;
        _this.autoUpdate = true;
        return _this;
    }
    Object.defineProperty(SimpleMesh.prototype, "vertices", {
        /**
         * Collection of vertices data.
         * @type {Float32Array}
         */ get: function() {
            return this.geometry.getBuffer('aVertexPosition').data;
        },
        set: function(value) {
            this.geometry.getBuffer('aVertexPosition').data = value;
        },
        enumerable: false,
        configurable: true
    });
    SimpleMesh.prototype._render = function(renderer) {
        if (this.autoUpdate) this.geometry.getBuffer('aVertexPosition').update();
        _super.prototype._render.call(this, renderer);
    };
    return SimpleMesh;
}((0, $9Tsx3.Mesh));
var $adaf51b2c64e8e1b$var$DEFAULT_BORDER_SIZE = 10;
/**
 * The NineSlicePlane allows you to stretch a texture using 9-slice scaling. The corners will remain unscaled (useful
 * for buttons with rounded corners for example) and the other areas will be scaled horizontally and or vertically
 *
 *```js
 * let Plane9 = new PIXI.NineSlicePlane(PIXI.Texture.from('BoxWithRoundedCorners.png'), 15, 15, 15, 15);
 *  ```
 * <pre>
 *      A                          B
 *    +---+----------------------+---+
 *  C | 1 |          2           | 3 |
 *    +---+----------------------+---+
 *    |   |                      |   |
 *    | 4 |          5           | 6 |
 *    |   |                      |   |
 *    +---+----------------------+---+
 *  D | 7 |          8           | 9 |
 *    +---+----------------------+---+

 *  When changing this objects width and/or height:
 *     areas 1 3 7 and 9 will remain unscaled.
 *     areas 2 and 8 will be stretched horizontally
 *     areas 4 and 6 will be stretched vertically
 *     area 5 will be stretched both horizontally and vertically
 * </pre>
 *
 * @memberof PIXI
 */ var $adaf51b2c64e8e1b$export$acdf4cb3f489544e = /** @class */ function(_super) {
    $adaf51b2c64e8e1b$var$__extends(NineSlicePlane, _super);
    /**
     * @param texture - The texture to use on the NineSlicePlane.
     * @param {number} [leftWidth=10] - size of the left vertical bar (A)
     * @param {number} [topHeight=10] - size of the top horizontal bar (C)
     * @param {number} [rightWidth=10] - size of the right vertical bar (B)
     * @param {number} [bottomHeight=10] - size of the bottom horizontal bar (D)
     */ function NineSlicePlane(texture, leftWidth, topHeight, rightWidth, bottomHeight) {
        if (leftWidth === void 0) leftWidth = $adaf51b2c64e8e1b$var$DEFAULT_BORDER_SIZE;
        if (topHeight === void 0) topHeight = $adaf51b2c64e8e1b$var$DEFAULT_BORDER_SIZE;
        if (rightWidth === void 0) rightWidth = $adaf51b2c64e8e1b$var$DEFAULT_BORDER_SIZE;
        if (bottomHeight === void 0) bottomHeight = $adaf51b2c64e8e1b$var$DEFAULT_BORDER_SIZE;
        var _this = _super.call(this, (0, $klOfb.Texture).WHITE, 4, 4) || this;
        _this._origWidth = texture.orig.width;
        _this._origHeight = texture.orig.height;
        /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ _this._width = _this._origWidth;
        /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ _this._height = _this._origHeight;
        _this._leftWidth = leftWidth;
        _this._rightWidth = rightWidth;
        _this._topHeight = topHeight;
        _this._bottomHeight = bottomHeight;
        // lets call the setter to ensure all necessary updates are performed
        _this.texture = texture;
        return _this;
    }
    NineSlicePlane.prototype.textureUpdated = function() {
        this._textureID = this.shader.texture._updateID;
        this._refresh();
    };
    Object.defineProperty(NineSlicePlane.prototype, "vertices", {
        get: function() {
            return this.geometry.getBuffer('aVertexPosition').data;
        },
        set: function(value) {
            this.geometry.getBuffer('aVertexPosition').data = value;
        },
        enumerable: false,
        configurable: true
    });
    /** Updates the horizontal vertices. */ NineSlicePlane.prototype.updateHorizontalVertices = function() {
        var vertices = this.vertices;
        var scale = this._getMinScale();
        vertices[9] = vertices[11] = vertices[13] = vertices[15] = this._topHeight * scale;
        vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - this._bottomHeight * scale;
        vertices[25] = vertices[27] = vertices[29] = vertices[31] = this._height;
    };
    /** Updates the vertical vertices. */ NineSlicePlane.prototype.updateVerticalVertices = function() {
        var vertices = this.vertices;
        var scale = this._getMinScale();
        vertices[2] = vertices[10] = vertices[18] = vertices[26] = this._leftWidth * scale;
        vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - this._rightWidth * scale;
        vertices[6] = vertices[14] = vertices[22] = vertices[30] = this._width;
    };
    /**
     * Returns the smaller of a set of vertical and horizontal scale of nine slice corners.
     *
     * @return Smaller number of vertical and horizontal scale.
     */ NineSlicePlane.prototype._getMinScale = function() {
        var w = this._leftWidth + this._rightWidth;
        var scaleW = this._width > w ? 1.0 : this._width / w;
        var h = this._topHeight + this._bottomHeight;
        var scaleH = this._height > h ? 1.0 : this._height / h;
        var scale = Math.min(scaleW, scaleH);
        return scale;
    };
    Object.defineProperty(NineSlicePlane.prototype, "width", {
        /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ get: function() {
            return this._width;
        },
        set: function(value) {
            this._width = value;
            this._refresh();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NineSlicePlane.prototype, "height", {
        /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */ get: function() {
            return this._height;
        },
        set: function(value) {
            this._height = value;
            this._refresh();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NineSlicePlane.prototype, "leftWidth", {
        /** The width of the left column. */ get: function() {
            return this._leftWidth;
        },
        set: function(value) {
            this._leftWidth = value;
            this._refresh();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NineSlicePlane.prototype, "rightWidth", {
        /** The width of the right column. */ get: function() {
            return this._rightWidth;
        },
        set: function(value) {
            this._rightWidth = value;
            this._refresh();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NineSlicePlane.prototype, "topHeight", {
        /** The height of the top row. */ get: function() {
            return this._topHeight;
        },
        set: function(value) {
            this._topHeight = value;
            this._refresh();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NineSlicePlane.prototype, "bottomHeight", {
        /** The height of the bottom row. */ get: function() {
            return this._bottomHeight;
        },
        set: function(value) {
            this._bottomHeight = value;
            this._refresh();
        },
        enumerable: false,
        configurable: true
    });
    /** Refreshes NineSlicePlane coords. All of them. */ NineSlicePlane.prototype._refresh = function() {
        var texture = this.texture;
        var uvs = this.geometry.buffers[1].data;
        this._origWidth = texture.orig.width;
        this._origHeight = texture.orig.height;
        var _uvw = 1.0 / this._origWidth;
        var _uvh = 1.0 / this._origHeight;
        uvs[0] = uvs[8] = uvs[16] = uvs[24] = 0;
        uvs[1] = uvs[3] = uvs[5] = uvs[7] = 0;
        uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1;
        uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1;
        uvs[2] = uvs[10] = uvs[18] = uvs[26] = _uvw * this._leftWidth;
        uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - _uvw * this._rightWidth;
        uvs[9] = uvs[11] = uvs[13] = uvs[15] = _uvh * this._topHeight;
        uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - _uvh * this._bottomHeight;
        this.updateHorizontalVertices();
        this.updateVerticalVertices();
        this.geometry.buffers[0].update();
        this.geometry.buffers[1].update();
    };
    return NineSlicePlane;
}($adaf51b2c64e8e1b$export$d47c1aa7111669b9);

});

parcelRegister("d3fD1", function(module, exports) {

$parcel$export(module.exports, "AnimatedSprite", function () { return $9807ad9f96ef10f2$export$dae599798687ad3c; });
/*!
 * @pixi/sprite-animated - v6.2.2
 * Compiled Wed, 26 Jan 2022 16:23:27 UTC
 *
 * @pixi/sprite-animated is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $klOfb = parcelRequire("klOfb");

var $7Bs2Z = parcelRequire("7Bs2Z");

var $3YyWq = parcelRequire("3YyWq");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ /* global Reflect, Promise */ var $9807ad9f96ef10f2$var$extendStatics = function(d, b) {
    $9807ad9f96ef10f2$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $9807ad9f96ef10f2$var$extendStatics(d, b);
};
function $9807ad9f96ef10f2$var$__extends(d, b) {
    $9807ad9f96ef10f2$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * An AnimatedSprite is a simple way to display an animation depicted by a list of textures.
 *
 * ```js
 * let alienImages = ["image_sequence_01.png","image_sequence_02.png","image_sequence_03.png","image_sequence_04.png"];
 * let textureArray = [];
 *
 * for (let i=0; i < 4; i++)
 * {
 *      let texture = PIXI.Texture.from(alienImages[i]);
 *      textureArray.push(texture);
 * };
 *
 * let animatedSprite = new PIXI.AnimatedSprite(textureArray);
 * ```
 *
 * The more efficient and simpler way to create an animated sprite is using a {@link PIXI.Spritesheet}
 * containing the animation definitions:
 *
 * ```js
 * PIXI.Loader.shared.add("assets/spritesheet.json").load(setup);
 *
 * function setup() {
 *   let sheet = PIXI.Loader.shared.resources["assets/spritesheet.json"].spritesheet;
 *   animatedSprite = new PIXI.AnimatedSprite(sheet.animations["image_sequence"]);
 *   ...
 * }
 * ```
 *
 * @memberof PIXI
 */ var $9807ad9f96ef10f2$export$dae599798687ad3c = /** @class */ function(_super) {
    $9807ad9f96ef10f2$var$__extends(AnimatedSprite, _super);
    /**
     * @param textures - An array of {@link PIXI.Texture} or frame
     *  objects that make up the animation.
     * @param {boolean} [autoUpdate=true] - Whether to use PIXI.Ticker.shared to auto update animation time.
     */ function AnimatedSprite(textures, autoUpdate) {
        if (autoUpdate === void 0) autoUpdate = true;
        var _this = _super.call(this, textures[0] instanceof (0, $klOfb.Texture) ? textures[0] : textures[0].texture) || this;
        _this._textures = null;
        _this._durations = null;
        _this._autoUpdate = autoUpdate;
        _this._isConnectedToTicker = false;
        _this.animationSpeed = 1;
        _this.loop = true;
        _this.updateAnchor = false;
        _this.onComplete = null;
        _this.onFrameChange = null;
        _this.onLoop = null;
        _this._currentTime = 0;
        _this._playing = false;
        _this._previousFrame = null;
        _this.textures = textures;
        return _this;
    }
    /** Stops the AnimatedSprite. */ AnimatedSprite.prototype.stop = function() {
        if (!this._playing) return;
        this._playing = false;
        if (this._autoUpdate && this._isConnectedToTicker) {
            (0, $3YyWq.Ticker).shared.remove(this.update, this);
            this._isConnectedToTicker = false;
        }
    };
    /** Plays the AnimatedSprite. */ AnimatedSprite.prototype.play = function() {
        if (this._playing) return;
        this._playing = true;
        if (this._autoUpdate && !this._isConnectedToTicker) {
            (0, $3YyWq.Ticker).shared.add(this.update, this, (0, $3YyWq.UPDATE_PRIORITY).HIGH);
            this._isConnectedToTicker = true;
        }
    };
    /**
     * Stops the AnimatedSprite and goes to a specific frame.
     *
     * @param frameNumber - Frame index to stop at.
     */ AnimatedSprite.prototype.gotoAndStop = function(frameNumber) {
        this.stop();
        var previousFrame = this.currentFrame;
        this._currentTime = frameNumber;
        if (previousFrame !== this.currentFrame) this.updateTexture();
    };
    /**
     * Goes to a specific frame and begins playing the AnimatedSprite.
     *
     * @param frameNumber - Frame index to start at.
     */ AnimatedSprite.prototype.gotoAndPlay = function(frameNumber) {
        var previousFrame = this.currentFrame;
        this._currentTime = frameNumber;
        if (previousFrame !== this.currentFrame) this.updateTexture();
        this.play();
    };
    /**
     * Updates the object transform for rendering.
     *
     * @param deltaTime - Time since last tick.
     */ AnimatedSprite.prototype.update = function(deltaTime) {
        if (!this._playing) return;
        var elapsed = this.animationSpeed * deltaTime;
        var previousFrame = this.currentFrame;
        if (this._durations !== null) {
            var lag = this._currentTime % 1 * this._durations[this.currentFrame];
            lag += elapsed / 60 * 1000;
            while(lag < 0){
                this._currentTime--;
                lag += this._durations[this.currentFrame];
            }
            var sign = Math.sign(this.animationSpeed * deltaTime);
            this._currentTime = Math.floor(this._currentTime);
            while(lag >= this._durations[this.currentFrame]){
                lag -= this._durations[this.currentFrame] * sign;
                this._currentTime += sign;
            }
            this._currentTime += lag / this._durations[this.currentFrame];
        } else this._currentTime += elapsed;
        if (this._currentTime < 0 && !this.loop) {
            this.gotoAndStop(0);
            if (this.onComplete) this.onComplete();
        } else if (this._currentTime >= this._textures.length && !this.loop) {
            this.gotoAndStop(this._textures.length - 1);
            if (this.onComplete) this.onComplete();
        } else if (previousFrame !== this.currentFrame) {
            if (this.loop && this.onLoop) {
                if (this.animationSpeed > 0 && this.currentFrame < previousFrame) this.onLoop();
                else if (this.animationSpeed < 0 && this.currentFrame > previousFrame) this.onLoop();
            }
            this.updateTexture();
        }
    };
    /** Updates the displayed texture to match the current frame index. */ AnimatedSprite.prototype.updateTexture = function() {
        var currentFrame = this.currentFrame;
        if (this._previousFrame === currentFrame) return;
        this._previousFrame = currentFrame;
        this._texture = this._textures[currentFrame];
        this._textureID = -1;
        this._textureTrimmedID = -1;
        this._cachedTint = 0xFFFFFF;
        this.uvs = this._texture._uvs.uvsFloat32;
        if (this.updateAnchor) this._anchor.copyFrom(this._texture.defaultAnchor);
        if (this.onFrameChange) this.onFrameChange(this.currentFrame);
    };
    /**
     * Stops the AnimatedSprite and destroys it.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value.
     * @param {boolean} [options.children=false] - If set to true, all the children will have their destroy
     *      method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well.
     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well.
     */ AnimatedSprite.prototype.destroy = function(options) {
        this.stop();
        _super.prototype.destroy.call(this, options);
        this.onComplete = null;
        this.onFrameChange = null;
        this.onLoop = null;
    };
    /**
     * A short hand way of creating an AnimatedSprite from an array of frame ids.
     *
     * @param frames - The array of frames ids the AnimatedSprite will use as its texture frames.
     * @return - The new animated sprite with the specified frames.
     */ AnimatedSprite.fromFrames = function(frames) {
        var textures = [];
        for(var i = 0; i < frames.length; ++i)textures.push((0, $klOfb.Texture).from(frames[i]));
        return new AnimatedSprite(textures);
    };
    /**
     * A short hand way of creating an AnimatedSprite from an array of image ids.
     *
     * @param images - The array of image urls the AnimatedSprite will use as its texture frames.
     * @return The new animate sprite with the specified images as frames.
     */ AnimatedSprite.fromImages = function(images) {
        var textures = [];
        for(var i = 0; i < images.length; ++i)textures.push((0, $klOfb.Texture).from(images[i]));
        return new AnimatedSprite(textures);
    };
    Object.defineProperty(AnimatedSprite.prototype, "totalFrames", {
        /**
         * The total number of frames in the AnimatedSprite. This is the same as number of textures
         * assigned to the AnimatedSprite.
         *
         * @readonly
         * @default 0
         */ get: function() {
            return this._textures.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnimatedSprite.prototype, "textures", {
        /** The array of textures used for this AnimatedSprite. */ get: function() {
            return this._textures;
        },
        set: function(value) {
            if (value[0] instanceof (0, $klOfb.Texture)) {
                this._textures = value;
                this._durations = null;
            } else {
                this._textures = [];
                this._durations = [];
                for(var i = 0; i < value.length; i++){
                    this._textures.push(value[i].texture);
                    this._durations.push(value[i].time);
                }
            }
            this._previousFrame = null;
            this.gotoAndStop(0);
            this.updateTexture();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnimatedSprite.prototype, "currentFrame", {
        /**
         * The AnimatedSprites current frame index.
         *
         * @readonly
         */ get: function() {
            var currentFrame = Math.floor(this._currentTime) % this._textures.length;
            if (currentFrame < 0) currentFrame += this._textures.length;
            return currentFrame;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnimatedSprite.prototype, "playing", {
        /**
         * Indicates if the AnimatedSprite is currently playing.
         *
         * @readonly
         */ get: function() {
            return this._playing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnimatedSprite.prototype, "autoUpdate", {
        /** Whether to use PIXI.Ticker.shared to auto update animation time. */ get: function() {
            return this._autoUpdate;
        },
        set: function(value) {
            if (value !== this._autoUpdate) {
                this._autoUpdate = value;
                if (!this._autoUpdate && this._isConnectedToTicker) {
                    (0, $3YyWq.Ticker).shared.remove(this.update, this);
                    this._isConnectedToTicker = false;
                } else if (this._autoUpdate && !this._isConnectedToTicker && this._playing) {
                    (0, $3YyWq.Ticker).shared.add(this.update, this);
                    this._isConnectedToTicker = true;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    return AnimatedSprite;
}((0, $7Bs2Z.Sprite));

});


parcelRegister("8Odl4", function(module, exports) {

$parcel$export(module.exports, "sound", function () { return I; });
/*!
 * @pixi/sound - v4.2.0
 * https://github.com/pixijs/pixi-sound
 * Compiled Wed, 05 Jan 2022 14:56:00 UTC
 *
 * @pixi/sound is licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license
 */ 
var $kXE1p = parcelRequire("kXE1p");
parcelRequire("csytw");
var $6p5EE = parcelRequire("6p5EE");

var $3YyWq = parcelRequire("3YyWq");

var $klOfb = parcelRequire("klOfb");
var r;
function s() {
    return r;
}
var u = function(t, e) {
    return (u = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    })(t, e);
};
function a(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function n() {
        this.constructor = t;
    }
    u(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
}
var c = function() {
    return (c = Object.assign || function(t) {
        for(var e, n = 1, o = arguments.length; n < o; n++)for(var i in e = arguments[n])Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        return t;
    }).apply(this, arguments);
}, l = [
    "mp3",
    "ogg",
    "oga",
    "opus",
    "mpeg",
    "wav",
    "m4a",
    "aiff",
    "wma",
    "mid",
    "caf"
], p = {};
function h(t) {
    var e = c({
        m4a: "audio/mp4",
        oga: "audio/ogg",
        opus: 'audio/ogg; codecs="opus"',
        caf: 'audio/x-caf; codecs="opus"'
    }, t || {}), n = document.createElement("audio"), o = {}, i = /^no$/;
    l.forEach(function(t) {
        var r = n.canPlayType("audio/".concat(t)).replace(i, ""), s = e[t] ? n.canPlayType(e[t]).replace(i, "") : "";
        o[t] = !!r || !!s;
    }), Object.assign(p, o);
}
h();
var f = /\.(\{([^\}]+)\})(\?.*)?$/;
function d(t) {
    var e = f, n = "string" == typeof t ? t : t.url;
    if (!e.test(n)) return n;
    for(var o = e.exec(n), i = o[2].split(","), r = i[i.length - 1], s = 0, u = i.length; s < u; s++){
        var a = i[s];
        if (p[a]) {
            r = a;
            break;
        }
    }
    var c = n.replace(o[1], r);
    if ("string" != typeof t) {
        var l = t;
        l.extension = r, l.url = c;
    }
    return c;
}
var _ = function() {
    function e() {}
    return e.add = function() {
        e.setLegacy(s().useLegacy);
    }, e.setLegacy = function(e) {
        var n = l;
        e ? n.forEach(function(e) {
            (0, $kXE1p.LoaderResource).setExtensionXhrType(e, (0, $kXE1p.LoaderResource).XHR_RESPONSE_TYPE.DEFAULT), (0, $kXE1p.LoaderResource).setExtensionLoadType(e, (0, $kXE1p.LoaderResource).LOAD_TYPE.AUDIO);
        }) : n.forEach(function(e) {
            (0, $kXE1p.LoaderResource).setExtensionXhrType(e, (0, $kXE1p.LoaderResource).XHR_RESPONSE_TYPE.BUFFER), (0, $kXE1p.LoaderResource).setExtensionLoadType(e, (0, $kXE1p.LoaderResource).LOAD_TYPE.XHR);
        });
    }, e.pre = function(t, e) {
        d(t), e();
    }, e.use = function(t, e) {
        t.data && l.indexOf(t.extension) > -1 ? t.sound = s().add(t.name, {
            loaded: e,
            preload: !0,
            url: t.url,
            source: t.data
        }) : e();
    }, e;
}(), y = 0, m = function(t) {
    function e(e) {
        var n = t.call(this) || this;
        return n.id = y++, n.init(e), n;
    }
    return a(e, t), e.prototype.set = function(t, e) {
        if (void 0 === this[t]) throw new Error("Property with name ".concat(t, " does not exist."));
        switch(t){
            case "speed":
                this.speed = e;
                break;
            case "volume":
                this.volume = e;
                break;
            case "paused":
                this.paused = e;
                break;
            case "loop":
                this.loop = e;
                break;
            case "muted":
                this.muted = e;
        }
        return this;
    }, Object.defineProperty(e.prototype, "progress", {
        get: function() {
            return this._source.currentTime / this._duration;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "paused", {
        get: function() {
            return this._paused;
        },
        set: function(t) {
            this._paused = t, this.refreshPaused();
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype._onPlay = function() {
        this._playing = !0;
    }, e.prototype._onPause = function() {
        this._playing = !1;
    }, e.prototype.init = function(t) {
        this._playing = !1, this._duration = t.source.duration;
        var e = this._source = t.source.cloneNode(!1);
        e.src = t.parent.url, e.onplay = this._onPlay.bind(this), e.onpause = this._onPause.bind(this), t.context.on("refresh", this.refresh, this), t.context.on("refreshPaused", this.refreshPaused, this), this._media = t;
    }, e.prototype._internalStop = function() {
        this._source && this._playing && (this._source.onended = null, this._source.pause());
    }, e.prototype.stop = function() {
        this._internalStop(), this._source && this.emit("stop");
    }, Object.defineProperty(e.prototype, "speed", {
        get: function() {
            return this._speed;
        },
        set: function(t) {
            this._speed = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "volume", {
        get: function() {
            return this._volume;
        },
        set: function(t) {
            this._volume = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "loop", {
        get: function() {
            return this._loop;
        },
        set: function(t) {
            this._loop = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "muted", {
        get: function() {
            return this._muted;
        },
        set: function(t) {
            this._muted = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "filters", {
        get: function() {
            return null;
        },
        set: function(t) {},
        enumerable: !1,
        configurable: !0
    }), e.prototype.refresh = function() {
        var t = this._media.context, e = this._media.parent;
        this._source.loop = this._loop || e.loop;
        var n = t.volume * (t.muted ? 0 : 1), o = e.volume * (e.muted ? 0 : 1), i = this._volume * (this._muted ? 0 : 1);
        this._source.volume = i * n * o, this._source.playbackRate = this._speed * t.speed * e.speed;
    }, e.prototype.refreshPaused = function() {
        var t = this._media.context, e = this._media.parent, n = this._paused || e.paused || t.paused;
        n !== this._pausedReal && (this._pausedReal = n, n ? (this._internalStop(), this.emit("paused")) : (this.emit("resumed"), this.play({
            start: this._source.currentTime,
            end: this._end,
            volume: this._volume,
            speed: this._speed,
            loop: this._loop
        })), this.emit("pause", n));
    }, e.prototype.play = function(t) {
        var n = this, i = t.start, r = t.end, s = t.speed, u = t.loop, a = t.volume, c = t.muted;
        this._speed = s, this._volume = a, this._loop = !!u, this._muted = c, this.refresh(), this.loop && null !== r && (this.loop = !1), this._start = i, this._end = r || this._duration, this._start = Math.max(0, this._start - e.PADDING), this._end = Math.min(this._end + e.PADDING, this._duration), this._source.onloadedmetadata = function() {
            n._source && (n._source.currentTime = i, n._source.onloadedmetadata = null, n.emit("progress", i, n._duration), (0, $3YyWq.Ticker).shared.add(n._onUpdate, n));
        }, this._source.onended = this._onComplete.bind(this), this._source.play(), this.emit("start");
    }, e.prototype._onUpdate = function() {
        this.emit("progress", this.progress, this._duration), this._source.currentTime >= this._end && !this._source.loop && this._onComplete();
    }, e.prototype._onComplete = function() {
        (0, $3YyWq.Ticker).shared.remove(this._onUpdate, this), this._internalStop(), this.emit("progress", 1, this._duration), this.emit("end", this);
    }, e.prototype.destroy = function() {
        (0, $3YyWq.Ticker).shared.remove(this._onUpdate, this), this.removeAllListeners();
        var t = this._source;
        t && (t.onended = null, t.onplay = null, t.onpause = null, this._internalStop()), this._source = null, this._speed = 1, this._volume = 1, this._loop = !1, this._end = null, this._start = 0, this._duration = 0, this._playing = !1, this._pausedReal = !1, this._paused = !1, this._muted = !1, this._media && (this._media.context.off("refresh", this.refresh, this), this._media.context.off("refreshPaused", this.refreshPaused, this), this._media = null);
    }, e.prototype.toString = function() {
        return "[HTMLAudioInstance id=".concat(this.id, "]");
    }, e.PADDING = .1, e;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE)))), g = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return a(e, t), e.prototype.init = function(t) {
        this.parent = t, this._source = t.options.source || new Audio, t.url && (this._source.src = t.url);
    }, e.prototype.create = function() {
        return new m(this);
    }, Object.defineProperty(e.prototype, "isPlayable", {
        get: function() {
            return !!this._source && 4 === this._source.readyState;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "duration", {
        get: function() {
            return this._source.duration;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "context", {
        get: function() {
            return this.parent.context;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "filters", {
        get: function() {
            return null;
        },
        set: function(t) {},
        enumerable: !1,
        configurable: !0
    }), e.prototype.destroy = function() {
        this.removeAllListeners(), this.parent = null, this._source && (this._source.src = "", this._source.load(), this._source = null);
    }, Object.defineProperty(e.prototype, "source", {
        get: function() {
            return this._source;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.load = function(t) {
        var e = this._source, n = this.parent;
        if (4 !== e.readyState) {
            if (n.url) {
                e.src = n.url;
                var o = function() {
                    s(), n.isLoaded = !0;
                    var e = n.autoPlayStart();
                    t && t(null, n, e);
                }, i = function() {
                    s(), t && t(new Error("Sound loading has been aborted"));
                }, r = function() {
                    s();
                    var n = "Failed to load audio element (code: ".concat(e.error.code, ")");
                    t && t(new Error(n));
                }, s = function() {
                    e.removeEventListener("canplaythrough", o), e.removeEventListener("load", o), e.removeEventListener("abort", i), e.removeEventListener("error", r);
                };
                e.addEventListener("canplaythrough", o, !1), e.addEventListener("load", o, !1), e.addEventListener("abort", i, !1), e.addEventListener("error", r, !1), e.load();
            } else t(new Error("sound.url or sound.source must be set"));
        } else {
            n.isLoaded = !0;
            var u = n.autoPlayStart();
            t && setTimeout(function() {
                t(null, n, u);
            }, 0);
        }
    }, e;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE)))), b = function() {
    function t(t, e) {
        this.parent = t, Object.assign(this, e), this.duration = this.end - this.start;
    }
    return t.prototype.play = function(t) {
        return this.parent.play({
            complete: t,
            speed: this.speed || this.parent.speed,
            end: this.end,
            start: this.start,
            loop: this.loop
        });
    }, t.prototype.destroy = function() {
        this.parent = null;
    }, t;
}(), v = function() {
    function t() {}
    return t.setParamValue = function(t, e) {
        if (t.setValueAtTime) {
            var n = s().context;
            t.setValueAtTime(e, n.audioContext.currentTime);
        } else t.value = e;
        return e;
    }, t;
}(), P = 0, x = function(t) {
    function e(e) {
        var n = t.call(this) || this;
        return n.id = P++, n._media = null, n._paused = !1, n._muted = !1, n._elapsed = 0, n.init(e), n;
    }
    return a(e, t), e.prototype.set = function(t, e) {
        if (void 0 === this[t]) throw new Error("Property with name ".concat(t, " does not exist."));
        switch(t){
            case "speed":
                this.speed = e;
                break;
            case "volume":
                this.volume = e;
                break;
            case "muted":
                this.muted = e;
                break;
            case "loop":
                this.loop = e;
                break;
            case "paused":
                this.paused = e;
        }
        return this;
    }, e.prototype.stop = function() {
        this._source && (this._internalStop(), this.emit("stop"));
    }, Object.defineProperty(e.prototype, "speed", {
        get: function() {
            return this._speed;
        },
        set: function(t) {
            this._speed = t, this.refresh(), this._update(!0);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "volume", {
        get: function() {
            return this._volume;
        },
        set: function(t) {
            this._volume = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "muted", {
        get: function() {
            return this._muted;
        },
        set: function(t) {
            this._muted = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "loop", {
        get: function() {
            return this._loop;
        },
        set: function(t) {
            this._loop = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "filters", {
        get: function() {
            return this._filters;
        },
        set: function(t) {
            var e;
            this._filters && (null === (e = this._filters) || void 0 === e || e.filter(function(t) {
                return t;
            }).forEach(function(t) {
                return t.disconnect();
            }), this._filters = null, this._source.connect(this._gain)), this._filters = (null == t ? void 0 : t.length) ? t.slice(0) : null, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.refresh = function() {
        if (this._source) {
            var t = this._media.context, e = this._media.parent;
            this._source.loop = this._loop || e.loop;
            var n = t.volume * (t.muted ? 0 : 1), o = e.volume * (e.muted ? 0 : 1), i = this._volume * (this._muted ? 0 : 1);
            v.setParamValue(this._gain.gain, i * o * n), v.setParamValue(this._source.playbackRate, this._speed * e.speed * t.speed), this.applyFilters();
        }
    }, e.prototype.applyFilters = function() {
        var t;
        if (null === (t = this._filters) || void 0 === t ? void 0 : t.length) {
            this._source.disconnect();
            var e = this._source;
            this._filters.forEach(function(t) {
                e.connect(t.destination), e = t;
            }), e.connect(this._gain);
        }
    }, e.prototype.refreshPaused = function() {
        var t = this._media.context, e = this._media.parent, n = this._paused || e.paused || t.paused;
        n !== this._pausedReal && (this._pausedReal = n, n ? (this._internalStop(), this.emit("paused")) : (this.emit("resumed"), this.play({
            start: this._elapsed % this._duration,
            end: this._end,
            speed: this._speed,
            loop: this._loop,
            volume: this._volume
        })), this.emit("pause", n));
    }, e.prototype.play = function(t) {
        var e = t.start, n = t.end, o = t.speed, i = t.loop, r = t.volume, s = t.muted, u = t.filters;
        this._paused = !1;
        var a = this._media.nodes.cloneBufferSource(), c = a.source, l = a.gain;
        this._source = c, this._gain = l, this._speed = o, this._volume = r, this._loop = !!i, this._muted = s, this._filters = u, this.refresh();
        var p = this._source.buffer.duration;
        this._duration = p, this._end = n, this._lastUpdate = this._now(), this._elapsed = e, this._source.onended = this._onComplete.bind(this), this._loop ? (this._source.loopEnd = n, this._source.loopStart = e, this._source.start(0, e)) : n ? this._source.start(0, e, n - e) : this._source.start(0, e), this.emit("start"), this._update(!0), this.enableTicker(!0);
    }, e.prototype.enableTicker = function(t) {
        (0, $3YyWq.Ticker).shared.remove(this._updateListener, this), t && (0, $3YyWq.Ticker).shared.add(this._updateListener, this);
    }, Object.defineProperty(e.prototype, "progress", {
        get: function() {
            return this._progress;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "paused", {
        get: function() {
            return this._paused;
        },
        set: function(t) {
            this._paused = t, this.refreshPaused();
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.destroy = function() {
        var t;
        this.removeAllListeners(), this._internalStop(), this._gain && (this._gain.disconnect(), this._gain = null), this._media && (this._media.context.events.off("refresh", this.refresh, this), this._media.context.events.off("refreshPaused", this.refreshPaused, this), this._media = null), null === (t = this._filters) || void 0 === t || t.forEach(function(t) {
            return t.disconnect();
        }), this._filters = null, this._end = null, this._speed = 1, this._volume = 1, this._loop = !1, this._elapsed = 0, this._duration = 0, this._paused = !1, this._muted = !1, this._pausedReal = !1;
    }, e.prototype.toString = function() {
        return "[WebAudioInstance id=".concat(this.id, "]");
    }, e.prototype._now = function() {
        return this._media.context.audioContext.currentTime;
    }, e.prototype._updateListener = function() {
        this._update();
    }, e.prototype._update = function(t) {
        if (void 0 === t && (t = !1), this._source) {
            var e = this._now(), n = e - this._lastUpdate;
            if (n > 0 || t) {
                var o = this._source.playbackRate.value;
                this._elapsed += n * o, this._lastUpdate = e;
                var i = this._duration, r = void 0;
                if (this._source.loopStart) {
                    var s = this._source.loopEnd - this._source.loopStart;
                    r = (this._source.loopStart + this._elapsed % s) / i;
                } else r = this._elapsed % i / i;
                this._progress = r, this.emit("progress", this._progress, i);
            }
        }
    }, e.prototype.init = function(t) {
        this._media = t, t.context.events.on("refresh", this.refresh, this), t.context.events.on("refreshPaused", this.refreshPaused, this);
    }, e.prototype._internalStop = function() {
        if (this._source) {
            this.enableTicker(!1), this._source.onended = null, this._source.stop(0), this._source.disconnect();
            try {
                this._source.buffer = null;
            } catch (t) {}
            this._source = null;
        }
    }, e.prototype._onComplete = function() {
        if (this._source) {
            this.enableTicker(!1), this._source.onended = null, this._source.disconnect();
            try {
                this._source.buffer = null;
            } catch (t) {}
        }
        this._source = null, this._progress = 1, this.emit("progress", 1, this._duration), this.emit("end", this);
    }, e;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE)))), O = function() {
    function t(t, e) {
        this._output = e, this._input = t;
    }
    return Object.defineProperty(t.prototype, "destination", {
        get: function() {
            return this._input;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "filters", {
        get: function() {
            return this._filters;
        },
        set: function(t) {
            var e = this;
            if (this._filters && (this._filters.forEach(function(t) {
                t && t.disconnect();
            }), this._filters = null, this._input.connect(this._output)), t && t.length) {
                this._filters = t.slice(0), this._input.disconnect();
                var n = null;
                t.forEach(function(t) {
                    null === n ? e._input.connect(t.destination) : n.connect(t.destination), n = t;
                }), n.connect(this._output);
            }
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.destroy = function() {
        this.filters = null, this._input = null, this._output = null;
    }, t;
}(), j = function(t) {
    function e(e) {
        var n = this, o = e.audioContext, i = o.createBufferSource(), r = o.createGain(), s = o.createAnalyser();
        return i.connect(s), s.connect(r), r.connect(e.destination), (n = t.call(this, s, r) || this).context = e, n.bufferSource = i, n.gain = r, n.analyser = s, n;
    }
    return a(e, t), Object.defineProperty(e.prototype, "script", {
        get: function() {
            return this._script || (this._script = this.context.audioContext.createScriptProcessor(e.BUFFER_SIZE), this._script.connect(this.context.destination)), this._script;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.destroy = function() {
        t.prototype.destroy.call(this), this.bufferSource.disconnect(), this._script && this._script.disconnect(), this.gain.disconnect(), this.analyser.disconnect(), this.bufferSource = null, this._script = null, this.gain = null, this.analyser = null, this.context = null;
    }, e.prototype.cloneBufferSource = function() {
        var t = this.bufferSource, e = this.context.audioContext.createBufferSource();
        e.buffer = t.buffer, v.setParamValue(e.playbackRate, t.playbackRate.value), e.loop = t.loop;
        var n = this.context.audioContext.createGain();
        return e.connect(n), n.connect(this.destination), {
            source: e,
            gain: n
        };
    }, Object.defineProperty(e.prototype, "bufferSize", {
        get: function() {
            return this.script.bufferSize;
        },
        enumerable: !1,
        configurable: !0
    }), e.BUFFER_SIZE = 0, e;
}(O), w = function() {
    function t() {}
    return t.prototype.init = function(t) {
        this.parent = t, this._nodes = new j(this.context), this._source = this._nodes.bufferSource, this.source = t.options.source;
    }, t.prototype.destroy = function() {
        this.parent = null, this._nodes.destroy(), this._nodes = null;
        try {
            this._source.buffer = null;
        } catch (t) {}
        this._source = null, this.source = null;
    }, t.prototype.create = function() {
        return new x(this);
    }, Object.defineProperty(t.prototype, "context", {
        get: function() {
            return this.parent.context;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isPlayable", {
        get: function() {
            return !!this._source && !!this._source.buffer;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "filters", {
        get: function() {
            return this._nodes.filters;
        },
        set: function(t) {
            this._nodes.filters = t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "duration", {
        get: function() {
            return this._source.buffer.duration;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "buffer", {
        get: function() {
            return this._source.buffer;
        },
        set: function(t) {
            this._source.buffer = t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "nodes", {
        get: function() {
            return this._nodes;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.load = function(t) {
        this.source ? this._decode(this.source, t) : this.parent.url ? this._loadUrl(t) : t && t(new Error("sound.url or sound.source must be set"));
    }, t.prototype._loadUrl = function(t) {
        var e = this, n = new XMLHttpRequest, o = this.parent.url;
        n.open("GET", o, !0), n.responseType = "arraybuffer", n.onload = function() {
            e.source = n.response, e._decode(n.response, t);
        }, n.send();
    }, t.prototype._decode = function(t, e) {
        var n = this, o = function(t, o) {
            if (t) e && e(t);
            else {
                n.parent.isLoaded = !0, n.buffer = o;
                var i = n.parent.autoPlayStart();
                e && e(null, n.parent, i);
            }
        };
        t instanceof AudioBuffer ? o(null, t) : this.parent.context.decode(t, o);
    }, t;
}(), A = function() {
    function t(t, e) {
        this.media = t, this.options = e, this._instances = [], this._sprites = {}, this.media.init(this);
        var n = e.complete;
        this._autoPlayOptions = n ? {
            complete: n
        } : null, this.isLoaded = !1, this.isPlaying = !1, this.autoPlay = e.autoPlay, this.singleInstance = e.singleInstance, this.preload = e.preload || this.autoPlay, this.url = e.url, this.speed = e.speed, this.volume = e.volume, this.loop = e.loop, e.sprites && this.addSprites(e.sprites), this.preload && this._preload(e.loaded);
    }
    return t.from = function(e) {
        var n = {};
        return "string" == typeof e ? n.url = e : e instanceof ArrayBuffer || e instanceof AudioBuffer || e instanceof HTMLAudioElement ? n.source = e : n = e, (n = c({
            autoPlay: !1,
            singleInstance: !1,
            url: null,
            source: null,
            preload: !1,
            volume: 1,
            speed: 1,
            complete: null,
            loaded: null,
            loop: !1
        }, n)).url && (n.url = d(n.url)), Object.freeze(n), new t(s().useLegacy ? new g : new w, n);
    }, Object.defineProperty(t.prototype, "context", {
        get: function() {
            return s().context;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.pause = function() {
        return this.isPlaying = !1, this.paused = !0, this;
    }, t.prototype.resume = function() {
        return this.isPlaying = this._instances.length > 0, this.paused = !1, this;
    }, Object.defineProperty(t.prototype, "paused", {
        get: function() {
            return this._paused;
        },
        set: function(t) {
            this._paused = t, this.refreshPaused();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "speed", {
        get: function() {
            return this._speed;
        },
        set: function(t) {
            this._speed = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "filters", {
        get: function() {
            return this.media.filters;
        },
        set: function(t) {
            this.media.filters = t;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.addSprites = function(t, e) {
        if ("object" == typeof t) {
            var n = {};
            for(var o in t)n[o] = this.addSprites(o, t[o]);
            return n;
        }
        var i = new b(this, e);
        return this._sprites[t] = i, i;
    }, t.prototype.destroy = function() {
        this._removeInstances(), this.removeSprites(), this.media.destroy(), this.media = null, this._sprites = null, this._instances = null;
    }, t.prototype.removeSprites = function(t) {
        if (t) {
            var e = this._sprites[t];
            void 0 !== e && (e.destroy(), delete this._sprites[t]);
        } else for(var n in this._sprites)this.removeSprites(n);
        return this;
    }, Object.defineProperty(t.prototype, "isPlayable", {
        get: function() {
            return this.isLoaded && this.media && this.media.isPlayable;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.stop = function() {
        if (!this.isPlayable) return this.autoPlay = !1, this._autoPlayOptions = null, this;
        this.isPlaying = !1;
        for(var t = this._instances.length - 1; t >= 0; t--)this._instances[t].stop();
        return this;
    }, t.prototype.play = function(t, e) {
        var n, o = this;
        "string" == typeof t ? n = {
            sprite: r = t,
            loop: this.loop,
            complete: e
        } : "function" == typeof t ? (n = {}).complete = t : n = t;
        if ((n = c({
            complete: null,
            loaded: null,
            sprite: null,
            end: null,
            start: 0,
            volume: 1,
            speed: 1,
            muted: !1,
            loop: !1
        }, n || {})).sprite) {
            var i = n.sprite, r = this._sprites[i];
            n.start = r.start + (n.start || 0), n.end = r.end, n.speed = r.speed || 1, n.loop = r.loop || n.loop, delete n.sprite;
        }
        if (n.offset && (n.start = n.offset), !this.isLoaded) return new Promise(function(t, e) {
            o.autoPlay = !0, o._autoPlayOptions = n, o._preload(function(o, i, r) {
                o ? e(o) : (n.loaded && n.loaded(o, i, r), t(r));
            });
        });
        (this.singleInstance || n.singleInstance) && this._removeInstances();
        var s = this._createInstance();
        return this._instances.push(s), this.isPlaying = !0, s.once("end", function() {
            n.complete && n.complete(o), o._onComplete(s);
        }), s.once("stop", function() {
            o._onComplete(s);
        }), s.play(n), s;
    }, t.prototype.refresh = function() {
        for(var t = this._instances.length, e = 0; e < t; e++)this._instances[e].refresh();
    }, t.prototype.refreshPaused = function() {
        for(var t = this._instances.length, e = 0; e < t; e++)this._instances[e].refreshPaused();
    }, Object.defineProperty(t.prototype, "volume", {
        get: function() {
            return this._volume;
        },
        set: function(t) {
            this._volume = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "muted", {
        get: function() {
            return this._muted;
        },
        set: function(t) {
            this._muted = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "loop", {
        get: function() {
            return this._loop;
        },
        set: function(t) {
            this._loop = t, this.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype._preload = function(t) {
        this.media.load(t);
    }, Object.defineProperty(t.prototype, "instances", {
        get: function() {
            return this._instances;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "sprites", {
        get: function() {
            return this._sprites;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "duration", {
        get: function() {
            return this.media.duration;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.autoPlayStart = function() {
        var t;
        return this.autoPlay && (t = this.play(this._autoPlayOptions)), t;
    }, t.prototype._removeInstances = function() {
        for(var t = this._instances.length - 1; t >= 0; t--)this._poolInstance(this._instances[t]);
        this._instances.length = 0;
    }, t.prototype._onComplete = function(t) {
        if (this._instances) {
            var e = this._instances.indexOf(t);
            e > -1 && this._instances.splice(e, 1), this.isPlaying = this._instances.length > 0;
        }
        this._poolInstance(t);
    }, t.prototype._createInstance = function() {
        if (t._pool.length > 0) {
            var e = t._pool.pop();
            return e.init(this.media), e;
        }
        return this.media.create();
    }, t.prototype._poolInstance = function(e) {
        e.destroy(), t._pool.indexOf(e) < 0 && t._pool.push(e);
    }, t._pool = [], t;
}(), F = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.speed = 1, e.muted = !1, e.volume = 1, e.paused = !1, e;
    }
    return a(e, t), e.prototype.refresh = function() {
        this.emit("refresh");
    }, e.prototype.refreshPaused = function() {
        this.emit("refreshPaused");
    }, Object.defineProperty(e.prototype, "filters", {
        get: function() {
            return null;
        },
        set: function(t) {},
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "audioContext", {
        get: function() {
            return null;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.toggleMute = function() {
        return this.muted = !this.muted, this.refresh(), this.muted;
    }, e.prototype.togglePause = function() {
        return this.paused = !this.paused, this.refreshPaused(), this.paused;
    }, e.prototype.destroy = function() {
        this.removeAllListeners();
    }, e;
}((0, (/*@__PURE__*/$parcel$interopDefault($6p5EE)))), C = function(t) {
    function e() {
        var o = this, i = window, r = new e.AudioContext, s = r.createDynamicsCompressor(), u = r.createAnalyser();
        return u.connect(s), s.connect(r.destination), (o = t.call(this, u, s) || this)._ctx = r, o._offlineCtx = new e.OfflineAudioContext(1, 2, i.OfflineAudioContext ? r.sampleRate : 44100), o._unlocked = !1, o.compressor = s, o.analyser = u, o.events = new (0, (/*@__PURE__*/$parcel$interopDefault($6p5EE))), o.volume = 1, o.speed = 1, o.muted = !1, o.paused = !1, "running" !== r.state && (o._unlock(), o._unlock = o._unlock.bind(o), document.addEventListener("mousedown", o._unlock, !0), document.addEventListener("touchstart", o._unlock, !0), document.addEventListener("touchend", o._unlock, !0)), o;
    }
    return a(e, t), e.prototype._unlock = function() {
        this._unlocked || (this.playEmptySound(), "running" === this._ctx.state && (document.removeEventListener("mousedown", this._unlock, !0), document.removeEventListener("touchend", this._unlock, !0), document.removeEventListener("touchstart", this._unlock, !0), this._unlocked = !0));
    }, e.prototype.playEmptySound = function() {
        var t = this._ctx.createBufferSource();
        t.buffer = this._ctx.createBuffer(1, 1, 22050), t.connect(this._ctx.destination), t.start(0, 0, 0), "suspended" === t.context.state && t.context.resume();
    }, Object.defineProperty(e, "AudioContext", {
        get: function() {
            var t = window;
            return t.AudioContext || t.webkitAudioContext || null;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e, "OfflineAudioContext", {
        get: function() {
            var t = window;
            return t.OfflineAudioContext || t.webkitOfflineAudioContext || null;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.destroy = function() {
        t.prototype.destroy.call(this);
        var e = this._ctx;
        void 0 !== e.close && e.close(), this.events.removeAllListeners(), this.analyser.disconnect(), this.compressor.disconnect(), this.analyser = null, this.compressor = null, this.events = null, this._offlineCtx = null, this._ctx = null;
    }, Object.defineProperty(e.prototype, "audioContext", {
        get: function() {
            return this._ctx;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "offlineContext", {
        get: function() {
            return this._offlineCtx;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(e.prototype, "paused", {
        get: function() {
            return this._paused;
        },
        set: function(t) {
            t && "running" === this._ctx.state ? this._ctx.suspend() : t || "suspended" !== this._ctx.state || this._ctx.resume(), this._paused = t;
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.refresh = function() {
        this.events.emit("refresh");
    }, e.prototype.refreshPaused = function() {
        this.events.emit("refreshPaused");
    }, e.prototype.toggleMute = function() {
        return this.muted = !this.muted, this.refresh(), this.muted;
    }, e.prototype.togglePause = function() {
        return this.paused = !this.paused, this.refreshPaused(), this._paused;
    }, e.prototype.decode = function(t, e) {
        var n = function(t) {
            e(new Error(t.message || "Unable to decode file"));
        }, o = this._offlineCtx.decodeAudioData(t, function(t) {
            e(null, t);
        }, n);
        o && o.catch(n);
    }, e;
}(O), E = function() {
    function t() {
        this.init();
    }
    return t.prototype.init = function() {
        return this.supported && (this._webAudioContext = new C), this._htmlAudioContext = new F, this._sounds = {}, this.useLegacy = !this.supported, this;
    }, Object.defineProperty(t.prototype, "context", {
        get: function() {
            return this._context;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "filtersAll", {
        get: function() {
            return this.useLegacy ? [] : this._context.filters;
        },
        set: function(t) {
            this.useLegacy || (this._context.filters = t);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "supported", {
        get: function() {
            return null !== C.AudioContext;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.add = function(t, e) {
        if ("object" == typeof t) {
            var n = {};
            for(var o in t){
                var i = this._getOptions(t[o], e);
                n[o] = this.add(o, i);
            }
            return n;
        }
        if (e instanceof A) return this._sounds[t] = e, e;
        var r = this._getOptions(e), s = A.from(r);
        return this._sounds[t] = s, s;
    }, t.prototype._getOptions = function(t, e) {
        var n;
        return n = "string" == typeof t ? {
            url: t
        } : t instanceof ArrayBuffer || t instanceof AudioBuffer || t instanceof HTMLAudioElement ? {
            source: t
        } : t, n = c(c({}, n), e || {});
    }, Object.defineProperty(t.prototype, "useLegacy", {
        get: function() {
            return this._useLegacy;
        },
        set: function(t) {
            _.setLegacy(t), this._useLegacy = t, this._context = !t && this.supported ? this._webAudioContext : this._htmlAudioContext;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.remove = function(t) {
        return this.exists(t, !0), this._sounds[t].destroy(), delete this._sounds[t], this;
    }, Object.defineProperty(t.prototype, "volumeAll", {
        get: function() {
            return this._context.volume;
        },
        set: function(t) {
            this._context.volume = t, this._context.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "speedAll", {
        get: function() {
            return this._context.speed;
        },
        set: function(t) {
            this._context.speed = t, this._context.refresh();
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.togglePauseAll = function() {
        return this._context.togglePause();
    }, t.prototype.pauseAll = function() {
        return this._context.paused = !0, this._context.refreshPaused(), this;
    }, t.prototype.resumeAll = function() {
        return this._context.paused = !1, this._context.refreshPaused(), this;
    }, t.prototype.toggleMuteAll = function() {
        return this._context.toggleMute();
    }, t.prototype.muteAll = function() {
        return this._context.muted = !0, this._context.refresh(), this;
    }, t.prototype.unmuteAll = function() {
        return this._context.muted = !1, this._context.refresh(), this;
    }, t.prototype.removeAll = function() {
        for(var t in this._sounds)this._sounds[t].destroy(), delete this._sounds[t];
        return this;
    }, t.prototype.stopAll = function() {
        for(var t in this._sounds)this._sounds[t].stop();
        return this;
    }, t.prototype.exists = function(t, e) {
        return void 0 === e && (e = !1), !!this._sounds[t];
    }, t.prototype.find = function(t) {
        return this.exists(t, !0), this._sounds[t];
    }, t.prototype.play = function(t, e) {
        return this.find(t).play(e);
    }, t.prototype.stop = function(t) {
        return this.find(t).stop();
    }, t.prototype.pause = function(t) {
        return this.find(t).pause();
    }, t.prototype.resume = function(t) {
        return this.find(t).resume();
    }, t.prototype.volume = function(t, e) {
        var n = this.find(t);
        return void 0 !== e && (n.volume = e), n.volume;
    }, t.prototype.speed = function(t, e) {
        var n = this.find(t);
        return void 0 !== e && (n.speed = e), n.speed;
    }, t.prototype.duration = function(t) {
        return this.find(t).duration;
    }, t.prototype.close = function() {
        return this.removeAll(), this._sounds = null, this._webAudioContext && (this._webAudioContext.destroy(), this._webAudioContext = null), this._htmlAudioContext && (this._htmlAudioContext.destroy(), this._htmlAudioContext = null), this._context = null, this;
    }, t;
}(), L = {
    __proto__: null,
    HTMLAudioMedia: g,
    HTMLAudioInstance: m,
    HTMLAudioContext: F
}, S = function() {
    function t(t, e) {
        this.init(t, e);
    }
    return t.prototype.init = function(t, e) {
        this.destination = t, this.source = e || t;
    }, t.prototype.connect = function(t) {
        this.source.connect(t);
    }, t.prototype.disconnect = function() {
        this.source.disconnect();
    }, t.prototype.destroy = function() {
        this.disconnect(), this.destination = null, this.source = null;
    }, t;
}(), k = {
    __proto__: null,
    Filter: S,
    EqualizerFilter: function(t) {
        function e(n, o, i, r, u, a, c, l, p, h) {
            void 0 === n && (n = 0), void 0 === o && (o = 0), void 0 === i && (i = 0), void 0 === r && (r = 0), void 0 === u && (u = 0), void 0 === a && (a = 0), void 0 === c && (c = 0), void 0 === l && (l = 0), void 0 === p && (p = 0), void 0 === h && (h = 0);
            var f = this;
            if (!s().useLegacy) {
                var d = [
                    {
                        f: e.F32,
                        type: "lowshelf",
                        gain: n
                    },
                    {
                        f: e.F64,
                        type: "peaking",
                        gain: o
                    },
                    {
                        f: e.F125,
                        type: "peaking",
                        gain: i
                    },
                    {
                        f: e.F250,
                        type: "peaking",
                        gain: r
                    },
                    {
                        f: e.F500,
                        type: "peaking",
                        gain: u
                    },
                    {
                        f: e.F1K,
                        type: "peaking",
                        gain: a
                    },
                    {
                        f: e.F2K,
                        type: "peaking",
                        gain: c
                    },
                    {
                        f: e.F4K,
                        type: "peaking",
                        gain: l
                    },
                    {
                        f: e.F8K,
                        type: "peaking",
                        gain: p
                    },
                    {
                        f: e.F16K,
                        type: "highshelf",
                        gain: h
                    }
                ].map(function(t) {
                    var e = s().context.audioContext.createBiquadFilter();
                    return e.type = t.type, v.setParamValue(e.Q, 1), e.frequency.value = t.f, v.setParamValue(e.gain, t.gain), e;
                });
                (f = t.call(this, d[0], d[d.length - 1]) || this).bands = d, f.bandsMap = {};
                for(var _ = 0; _ < f.bands.length; _++){
                    var y = f.bands[_];
                    _ > 0 && f.bands[_ - 1].connect(y), f.bandsMap[y.frequency.value] = y;
                }
                return f;
            }
            f = t.call(this, null) || this;
        }
        return a(e, t), e.prototype.setGain = function(t, e) {
            if (void 0 === e && (e = 0), !this.bandsMap[t]) throw new Error("No band found for frequency ".concat(t));
            v.setParamValue(this.bandsMap[t].gain, e);
        }, e.prototype.getGain = function(t) {
            if (!this.bandsMap[t]) throw new Error("No band found for frequency ".concat(t));
            return this.bandsMap[t].gain.value;
        }, Object.defineProperty(e.prototype, "f32", {
            get: function() {
                return this.getGain(e.F32);
            },
            set: function(t) {
                this.setGain(e.F32, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f64", {
            get: function() {
                return this.getGain(e.F64);
            },
            set: function(t) {
                this.setGain(e.F64, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f125", {
            get: function() {
                return this.getGain(e.F125);
            },
            set: function(t) {
                this.setGain(e.F125, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f250", {
            get: function() {
                return this.getGain(e.F250);
            },
            set: function(t) {
                this.setGain(e.F250, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f500", {
            get: function() {
                return this.getGain(e.F500);
            },
            set: function(t) {
                this.setGain(e.F500, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f1k", {
            get: function() {
                return this.getGain(e.F1K);
            },
            set: function(t) {
                this.setGain(e.F1K, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f2k", {
            get: function() {
                return this.getGain(e.F2K);
            },
            set: function(t) {
                this.setGain(e.F2K, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f4k", {
            get: function() {
                return this.getGain(e.F4K);
            },
            set: function(t) {
                this.setGain(e.F4K, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f8k", {
            get: function() {
                return this.getGain(e.F8K);
            },
            set: function(t) {
                this.setGain(e.F8K, t);
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "f16k", {
            get: function() {
                return this.getGain(e.F16K);
            },
            set: function(t) {
                this.setGain(e.F16K, t);
            },
            enumerable: !1,
            configurable: !0
        }), e.prototype.reset = function() {
            this.bands.forEach(function(t) {
                v.setParamValue(t.gain, 0);
            });
        }, e.prototype.destroy = function() {
            this.bands.forEach(function(t) {
                t.disconnect();
            }), this.bands = null, this.bandsMap = null;
        }, e.F32 = 32, e.F64 = 64, e.F125 = 125, e.F250 = 250, e.F500 = 500, e.F1K = 1e3, e.F2K = 2e3, e.F4K = 4e3, e.F8K = 8e3, e.F16K = 16e3, e;
    }(S),
    DistortionFilter: function(t) {
        function e(e) {
            void 0 === e && (e = 0);
            var n = this;
            if (!s().useLegacy) {
                var o = s().context.audioContext.createWaveShaper();
                return (n = t.call(this, o) || this)._distortion = o, n.amount = e, n;
            }
            n = t.call(this, null) || this;
        }
        return a(e, t), Object.defineProperty(e.prototype, "amount", {
            get: function() {
                return this._amount;
            },
            set: function(t) {
                this._amount = t;
                for(var e, n = 1e3 * t, o = 44100, i = new Float32Array(o), r = Math.PI / 180, s = 0; s < o; ++s)e = 2 * s / o - 1, i[s] = (3 + n) * e * 20 * r / (Math.PI + n * Math.abs(e));
                this._distortion.curve = i, this._distortion.oversample = "4x";
            },
            enumerable: !1,
            configurable: !0
        }), e.prototype.destroy = function() {
            this._distortion = null, t.prototype.destroy.call(this);
        }, e;
    }(S),
    StereoFilter: function(t) {
        function e(e) {
            void 0 === e && (e = 0);
            var n = this;
            if (!s().useLegacy) {
                var o, i, r, u = s().context.audioContext;
                return u.createStereoPanner ? r = o = u.createStereoPanner() : ((i = u.createPanner()).panningModel = "equalpower", r = i), (n = t.call(this, r) || this)._stereo = o, n._panner = i, n.pan = e, n;
            }
            n = t.call(this, null) || this;
        }
        return a(e, t), Object.defineProperty(e.prototype, "pan", {
            get: function() {
                return this._pan;
            },
            set: function(t) {
                this._pan = t, this._stereo ? v.setParamValue(this._stereo.pan, t) : this._panner.setPosition(t, 0, 1 - Math.abs(t));
            },
            enumerable: !1,
            configurable: !0
        }), e.prototype.destroy = function() {
            t.prototype.destroy.call(this), this._stereo = null, this._panner = null;
        }, e;
    }(S),
    ReverbFilter: function(t) {
        function e(e, n, o) {
            void 0 === e && (e = 3), void 0 === n && (n = 2), void 0 === o && (o = !1);
            var i = this;
            if (!s().useLegacy) return (i = t.call(this, null) || this)._seconds = i._clamp(e, 1, 50), i._decay = i._clamp(n, 0, 100), i._reverse = o, i._rebuild(), i;
            i = t.call(this, null) || this;
        }
        return a(e, t), e.prototype._clamp = function(t, e, n) {
            return Math.min(n, Math.max(e, t));
        }, Object.defineProperty(e.prototype, "seconds", {
            get: function() {
                return this._seconds;
            },
            set: function(t) {
                this._seconds = this._clamp(t, 1, 50), this._rebuild();
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "decay", {
            get: function() {
                return this._decay;
            },
            set: function(t) {
                this._decay = this._clamp(t, 0, 100), this._rebuild();
            },
            enumerable: !1,
            configurable: !0
        }), Object.defineProperty(e.prototype, "reverse", {
            get: function() {
                return this._reverse;
            },
            set: function(t) {
                this._reverse = t, this._rebuild();
            },
            enumerable: !1,
            configurable: !0
        }), e.prototype._rebuild = function() {
            for(var t, e = s().context.audioContext, n = e.sampleRate, o = n * this._seconds, i = e.createBuffer(2, o, n), r = i.getChannelData(0), u = i.getChannelData(1), a = 0; a < o; a++)t = this._reverse ? o - a : a, r[a] = (2 * Math.random() - 1) * Math.pow(1 - t / o, this._decay), u[a] = (2 * Math.random() - 1) * Math.pow(1 - t / o, this._decay);
            var c = s().context.audioContext.createConvolver();
            c.buffer = i, this.init(c);
        }, e;
    }(S),
    MonoFilter: function(t) {
        function e() {
            var e = this;
            if (!s().useLegacy) {
                var n = s().context.audioContext, o = n.createChannelSplitter(), i = n.createChannelMerger();
                return i.connect(o), (e = t.call(this, i, o) || this)._merger = i, e;
            }
            e = t.call(this, null) || this;
        }
        return a(e, t), e.prototype.destroy = function() {
            this._merger.disconnect(), this._merger = null, t.prototype.destroy.call(this);
        }, e;
    }(S),
    StreamFilter: function(t) {
        function e() {
            var e = this;
            if (!s().useLegacy) {
                var n = s().context.audioContext, o = n.createMediaStreamDestination(), i = n.createMediaStreamSource(o.stream);
                return (e = t.call(this, o, i) || this)._stream = o.stream, e;
            }
            e = t.call(this, null) || this;
        }
        return a(e, t), Object.defineProperty(e.prototype, "stream", {
            get: function() {
                return this._stream;
            },
            enumerable: !1,
            configurable: !0
        }), e.prototype.destroy = function() {
            this._stream = null, t.prototype.destroy.call(this);
        }, e;
    }(S),
    TelephoneFilter: function(t) {
        function e() {
            if (!s().useLegacy) {
                var e = s().context.audioContext, n = e.createBiquadFilter(), o = e.createBiquadFilter(), i = e.createBiquadFilter(), r = e.createBiquadFilter();
                return n.type = "lowpass", v.setParamValue(n.frequency, 2e3), o.type = "lowpass", v.setParamValue(o.frequency, 2e3), i.type = "highpass", v.setParamValue(i.frequency, 500), r.type = "highpass", v.setParamValue(r.frequency, 500), n.connect(o), o.connect(i), i.connect(r), t.call(this, n, r) || this;
            }
            t.call(this, null);
        }
        return a(e, t), e;
    }(S)
}, M = {
    __proto__: null,
    WebAudioMedia: w,
    WebAudioInstance: x,
    WebAudioNodes: j,
    WebAudioContext: C,
    WebAudioUtils: v
}, T = 0;
var G = {
    __proto__: null,
    playOnce: function(t, e) {
        var n = "alias".concat(T++);
        return s().add(n, {
            url: t,
            preload: !0,
            autoPlay: !0,
            loaded: function(t) {
                t && (s().remove(n), e && e(t));
            },
            complete: function() {
                s().remove(n), e && e(null);
            }
        }), n;
    },
    get PLAY_ID () {
        return T;
    },
    render: function(t, e) {
        var n = document.createElement("canvas");
        e = c({
            width: 512,
            height: 128,
            fill: "black"
        }, e || {}), n.width = e.width, n.height = e.height;
        var o = (0, $klOfb.BaseTexture).from(n);
        if (!(t.media instanceof w)) return o;
        var r = t.media, s = n.getContext("2d");
        s.fillStyle = e.fill;
        for(var u = r.buffer.getChannelData(0), a = Math.ceil(u.length / e.width), l = e.height / 2, p = 0; p < e.width; p++){
            for(var h = 1, f = -1, d = 0; d < a; d++){
                var _ = u[p * a + d];
                _ < h && (h = _), _ > f && (f = _);
            }
            s.fillRect(p, (1 + h) * l, 1, Math.max(1, (f - h) * l));
        }
        return o;
    },
    resolveUrl: d,
    sineTone: function(t, e) {
        void 0 === t && (t = 200), void 0 === e && (e = 1);
        var n = A.from({
            singleInstance: !0
        });
        if (!(n.media instanceof w)) return n;
        for(var o = n.media, i = n.context.audioContext.createBuffer(1, 48e3 * e, 48e3), r = i.getChannelData(0), s = 0; s < r.length; s++){
            var u = t * (s / i.sampleRate) * Math.PI;
            r[s] = 2 * Math.sin(u);
        }
        return o.buffer = i, n.isLoaded = !0, n;
    },
    validateFormats: h,
    supported: p,
    extensions: l
}, I = function(t) {
    return r = t, t;
}(new E);
(0, $kXE1p.Loader).registerPlugin(_);

});

parcelRegister("2ZTWb", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(' ');
        me.s1 = mash(' ');
        me.s2 = mash(' ');
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("xnasA", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("huIqu", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("jSeQD", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = '' + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("cEbON", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + '\0';
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("iBJuF", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("5UG8I", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $4f3c196954fdbf9a$export$af88d00dbe7f521; });

var $3C0Nn = parcelRequire("3C0Nn");
class $4f3c196954fdbf9a$export$3081f6083935bfeb {
    constructor(config = {}){
        this.config = {
            level: config.level || "info",
            allowedTags: config.allowedTags || [],
            minLevel: config.minLevel || 30,
            serverEndpoint: config.serverEndpoint || "http://localhost:8080/log",
            enableServerLogging: config.enableServerLogging || false
        };
        // Check if we're in a browser environment
        const isBrowser = typeof window !== "undefined";
        if (isBrowser) // Browser environment - use basic pino without transport
        this.logger = (0, (/*@__PURE__*/$parcel$interopDefault($3C0Nn)))({
            level: this.config.level,
            browser: {
                asObject: false,
                write: (o)=>{
                    // Custom pretty printing for browser
                    const level = o.level;
                    const date = new Date(o.time);
                    const time = date.toTimeString().split(" ")[0] + "." + date.getMilliseconds().toString().padStart(3, "0");
                    const msg = o.msg || "";
                    const tags = o.tags ? ` [${o.tags.join(", ")}]` : "";
                    const extra = Object.keys(o).filter((k)=>![
                            "level",
                            "time",
                            "msg",
                            "tags"
                        ].includes(k)).map((k)=>`${k}: ${JSON.stringify(o[k])}`).join(" ");
                    const levelColors = {
                        10: "\x1b[90m",
                        20: "\x1b[36m",
                        30: "\x1b[32m",
                        40: "\x1b[33m",
                        50: "\x1b[31m",
                        60: "\x1b[35m"
                    };
                    const levelNames = {
                        10: "TRACE",
                        20: "DEBUG",
                        30: "INFO",
                        40: "WARN",
                        50: "ERROR",
                        60: "FATAL"
                    };
                    const color = levelColors[level] || "";
                    const reset = "\x1b[0m";
                    const levelName = levelNames[level] || "LOG";
                    console.log(`${color}[${time}]${reset} ${msg}${extra ? " " + extra : ""}`);
                }
            }
        });
        else // Node.js environment - use pino-pretty
        this.logger = (0, (/*@__PURE__*/$parcel$interopDefault($3C0Nn)))({
            level: this.config.level,
            transport: {
                target: "pino-pretty",
                options: {
                    colorize: true,
                    translateTime: "HH:MM:ss.SSS",
                    ignore: "pid,hostname",
                    singleLine: false,
                    hideObject: false
                }
            }
        });
        // Output configuration on initialization
        this.logConfiguration();
    }
    // Log current configuration
    logConfiguration() {
        const tagFilter = this.config.allowedTags.length > 0 ? `Tags: [${this.config.allowedTags.join(", ")}] (OR logic)` : "Tags: All (no filtering)";
        const levelFilter = `Level: ${this.config.level} (min: ${this.config.minLevel})`;
        console.log(`\u{1F527} Logger initialized - ${levelFilter}, ${tagFilter}`);
    }
    // Update configuration at runtime
    updateConfig(newConfig) {
        this.config = {
            ...this.config,
            ...newConfig
        };
        // Update logger level if changed
        if (newConfig.level) this.logger.level = newConfig.level;
        // Log updated configuration
        this.logConfiguration();
    }
    // Convenience method to update only the allowed tags
    setAllowedTags(tags) {
        this.updateConfig({
            allowedTags: tags
        });
    }
    // Convenience method to add tags to the current allowed tags
    addAllowedTags(tags) {
        const currentTags = this.config.allowedTags || [];
        const newTags = [
            ...new Set([
                ...currentTags,
                ...tags
            ])
        ] // Remove duplicates
        ;
        this.updateConfig({
            allowedTags: newTags
        });
    }
    // Convenience method to remove tags from the current allowed tags
    removeAllowedTags(tags) {
        const currentTags = this.config.allowedTags || [];
        const newTags = currentTags.filter((tag)=>!tags.includes(tag));
        this.updateConfig({
            allowedTags: newTags
        });
    }
    // Convenience method to clear all tag filtering (allow all logs)
    clearTagFilter() {
        this.updateConfig({
            allowedTags: []
        });
    }
    // Convenience method to enable/disable server logging
    setServerLogging(enabled, endpoint) {
        this.updateConfig({
            enableServerLogging: enabled,
            serverEndpoint: endpoint || this.config.serverEndpoint
        });
    }
    // Get current configuration
    getConfig() {
        return {
            ...this.config
        };
    }
    shouldLog(level, logData) {
        // Check if log level meets minimum requirement
        if (level < this.config.minLevel) return false;
        // If no tags are specified, allow all logs
        if (this.config.allowedTags.length === 0) return true;
        // Check if the log has tags and if ANY of them are in allowedTags
        if (typeof logData === "object" && logData && logData.tags && Array.isArray(logData.tags)) // Check if any log tag is in the allowed tags
        return logData.tags.some((tag)=>this.config.allowedTags.includes(tag));
        else // If no tags in the log but tags are required, don't log
        return false;
    }
    // Log methods that match pino's API
    trace(obj, msg, ...args) {
        if (this.shouldLog(10, obj)) {
            this.logger.trace(obj, msg, ...args);
            // Send to server if enabled
            if (this.config.enableServerLogging) {
                const tags = obj?.tags;
                const extra = {
                    ...obj
                };
                delete extra.tags;
                this.sendToServer("trace", msg || "", tags, extra);
            }
        }
    }
    debug(obj, msg, ...args) {
        if (this.shouldLog(20, obj)) {
            this.logger.debug(obj, msg, ...args);
            // Send to server if enabled
            if (this.config.enableServerLogging) {
                const tags = obj?.tags;
                const extra = {
                    ...obj
                };
                delete extra.tags;
                this.sendToServer("debug", msg || "", tags, extra);
            }
        }
    }
    info(obj, msg, ...args) {
        if (this.shouldLog(30, obj)) {
            this.logger.info(obj, msg, ...args);
            // Send to server if enabled
            if (this.config.enableServerLogging) {
                const tags = obj?.tags;
                const extra = {
                    ...obj
                };
                delete extra.tags;
                this.sendToServer("info", msg || "", tags, extra);
            }
        }
    }
    warn(obj, msg, ...args) {
        if (this.shouldLog(40, obj)) {
            this.logger.warn(obj, msg, ...args);
            // Send to server if enabled
            if (this.config.enableServerLogging) {
                const tags = obj?.tags;
                const extra = {
                    ...obj
                };
                delete extra.tags;
                this.sendToServer("warn", msg || "", tags, extra);
            }
        }
    }
    error(obj, msg, ...args) {
        if (this.shouldLog(50, obj)) {
            this.logger.error(obj, msg, ...args);
            // Send to server if enabled
            if (this.config.enableServerLogging) {
                const tags = obj?.tags;
                const extra = {
                    ...obj
                };
                delete extra.tags;
                this.sendToServer("error", msg || "", tags, extra);
            }
        }
    }
    fatal(obj, msg, ...args) {
        if (this.shouldLog(60, obj)) {
            this.logger.fatal(obj, msg, ...args);
            // Send to server if enabled
            if (this.config.enableServerLogging) {
                const tags = obj?.tags;
                const extra = {
                    ...obj
                };
                delete extra.tags;
                this.sendToServer("fatal", msg || "", tags, extra);
            }
        }
    }
    // Send log to server endpoint
    async sendToServer(level, msg, tags, extra) {
        if (!this.config.enableServerLogging || !this.config.serverEndpoint) return;
        try {
            const logData = {
                level: level,
                msg: msg,
                tags: tags || [],
                timestamp: new Date().toISOString(),
                extra: extra
            };
            await fetch(this.config.serverEndpoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(logData)
            });
        } catch (error) {
            // Silently fail to avoid infinite logging loops
            console.warn("Failed to send log to server:", error);
        }
    }
    // Convenience method for simple string logging
    log(msg, tags) {
        if (tags) this.info({
            tags: tags
        }, msg);
        else this.info(msg);
    }
}
const $4f3c196954fdbf9a$export$af88d00dbe7f521 = new $4f3c196954fdbf9a$export$3081f6083935bfeb({
    allowedTags: [
        "viewport",
        "callback",
        "animation",
        "map",
        "damage"
    ],
    level: "debug",
    minLevel: 10,
    enableServerLogging: false,
    serverEndpoint: "http://localhost:8080/log"
});

});
parcelRegister("3C0Nn", function(module, exports) {
'use strict';

var $bb5r4 = parcelRequire("bb5r4");
module.exports = $2a1589ac5e33c3f7$var$pino;
const $2a1589ac5e33c3f7$var$_console = $2a1589ac5e33c3f7$var$pfGlobalThisOrFallback().console || {};
const $2a1589ac5e33c3f7$var$stdSerializers = {
    mapHttpRequest: $2a1589ac5e33c3f7$var$mock,
    mapHttpResponse: $2a1589ac5e33c3f7$var$mock,
    wrapRequestSerializer: $2a1589ac5e33c3f7$var$passthrough,
    wrapResponseSerializer: $2a1589ac5e33c3f7$var$passthrough,
    wrapErrorSerializer: $2a1589ac5e33c3f7$var$passthrough,
    req: $2a1589ac5e33c3f7$var$mock,
    res: $2a1589ac5e33c3f7$var$mock,
    err: $2a1589ac5e33c3f7$var$asErrValue,
    errWithCause: $2a1589ac5e33c3f7$var$asErrValue
};
function $2a1589ac5e33c3f7$var$levelToValue(level, logger) {
    return level === 'silent' ? Infinity : logger.levels.values[level];
}
const $2a1589ac5e33c3f7$var$baseLogFunctionSymbol = Symbol('pino.logFuncs');
const $2a1589ac5e33c3f7$var$hierarchySymbol = Symbol('pino.hierarchy');
const $2a1589ac5e33c3f7$var$logFallbackMap = {
    error: 'log',
    fatal: 'error',
    warn: 'error',
    info: 'log',
    debug: 'log',
    trace: 'log'
};
function $2a1589ac5e33c3f7$var$appendChildLogger(parentLogger, childLogger) {
    const newEntry = {
        logger: childLogger,
        parent: parentLogger[$2a1589ac5e33c3f7$var$hierarchySymbol]
    };
    childLogger[$2a1589ac5e33c3f7$var$hierarchySymbol] = newEntry;
}
function $2a1589ac5e33c3f7$var$setupBaseLogFunctions(logger, levels, proto) {
    const logFunctions = {};
    levels.forEach((level)=>{
        logFunctions[level] = proto[level] ? proto[level] : $2a1589ac5e33c3f7$var$_console[level] || $2a1589ac5e33c3f7$var$_console[$2a1589ac5e33c3f7$var$logFallbackMap[level] || 'log'] || $2a1589ac5e33c3f7$var$noop;
    });
    logger[$2a1589ac5e33c3f7$var$baseLogFunctionSymbol] = logFunctions;
}
function $2a1589ac5e33c3f7$var$shouldSerialize(serialize, serializers) {
    if (Array.isArray(serialize)) {
        const hasToFilter = serialize.filter(function(k) {
            return k !== '!stdSerializers.err';
        });
        return hasToFilter;
    } else if (serialize === true) return Object.keys(serializers);
    return false;
}
function $2a1589ac5e33c3f7$var$pino(opts) {
    opts = opts || {};
    opts.browser = opts.browser || {};
    const transmit = opts.browser.transmit;
    if (transmit && typeof transmit.send !== 'function') throw Error('pino: transmit option must have a send function');
    const proto = opts.browser.write || $2a1589ac5e33c3f7$var$_console;
    if (opts.browser.write) opts.browser.asObject = true;
    const serializers = opts.serializers || {};
    const serialize = $2a1589ac5e33c3f7$var$shouldSerialize(opts.browser.serialize, serializers);
    let stdErrSerialize = opts.browser.serialize;
    if (Array.isArray(opts.browser.serialize) && opts.browser.serialize.indexOf('!stdSerializers.err') > -1) stdErrSerialize = false;
    const customLevels = Object.keys(opts.customLevels || {});
    const levels = [
        'error',
        'fatal',
        'warn',
        'info',
        'debug',
        'trace'
    ].concat(customLevels);
    if (typeof proto === 'function') levels.forEach(function(level) {
        proto[level] = proto;
    });
    if (opts.enabled === false || opts.browser.disabled) opts.level = 'silent';
    const level = opts.level || 'info';
    const logger = Object.create(proto);
    if (!logger.log) logger.log = $2a1589ac5e33c3f7$var$noop;
    $2a1589ac5e33c3f7$var$setupBaseLogFunctions(logger, levels, proto);
    // setup root hierarchy entry
    $2a1589ac5e33c3f7$var$appendChildLogger({}, logger);
    Object.defineProperty(logger, 'levelVal', {
        get: getLevelVal
    });
    Object.defineProperty(logger, 'level', {
        get: getLevel,
        set: setLevel
    });
    const setOpts = {
        transmit: transmit,
        serialize: serialize,
        asObject: opts.browser.asObject,
        formatters: opts.browser.formatters,
        levels: levels,
        timestamp: $2a1589ac5e33c3f7$var$getTimeFunction(opts)
    };
    logger.levels = $2a1589ac5e33c3f7$var$getLevels(opts);
    logger.level = level;
    logger.setMaxListeners = logger.getMaxListeners = logger.emit = logger.addListener = logger.on = logger.prependListener = logger.once = logger.prependOnceListener = logger.removeListener = logger.removeAllListeners = logger.listeners = logger.listenerCount = logger.eventNames = logger.write = logger.flush = $2a1589ac5e33c3f7$var$noop;
    logger.serializers = serializers;
    logger._serialize = serialize;
    logger._stdErrSerialize = stdErrSerialize;
    logger.child = child;
    if (transmit) logger._logEvent = $2a1589ac5e33c3f7$var$createLogEventShape();
    function getLevelVal() {
        return $2a1589ac5e33c3f7$var$levelToValue(this.level, this);
    }
    function getLevel() {
        return this._level;
    }
    function setLevel(level) {
        if (level !== 'silent' && !this.levels.values[level]) throw Error('unknown level ' + level);
        this._level = level;
        $2a1589ac5e33c3f7$var$set(this, setOpts, logger, 'error') // <-- must stay first
        ;
        $2a1589ac5e33c3f7$var$set(this, setOpts, logger, 'fatal');
        $2a1589ac5e33c3f7$var$set(this, setOpts, logger, 'warn');
        $2a1589ac5e33c3f7$var$set(this, setOpts, logger, 'info');
        $2a1589ac5e33c3f7$var$set(this, setOpts, logger, 'debug');
        $2a1589ac5e33c3f7$var$set(this, setOpts, logger, 'trace');
        customLevels.forEach((level)=>{
            $2a1589ac5e33c3f7$var$set(this, setOpts, logger, level);
        });
    }
    function child(bindings, childOptions) {
        if (!bindings) throw new Error('missing bindings for child Pino');
        childOptions = childOptions || {};
        if (serialize && bindings.serializers) childOptions.serializers = bindings.serializers;
        const childOptionsSerializers = childOptions.serializers;
        if (serialize && childOptionsSerializers) {
            var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
            var childSerialize = opts.browser.serialize === true ? Object.keys(childSerializers) : serialize;
            delete bindings.serializers;
            $2a1589ac5e33c3f7$var$applySerializers([
                bindings
            ], childSerialize, childSerializers, this._stdErrSerialize);
        }
        function Child(parent) {
            this._childLevel = (parent._childLevel | 0) + 1;
            // make sure bindings are available in the `set` function
            this.bindings = bindings;
            if (childSerializers) {
                this.serializers = childSerializers;
                this._serialize = childSerialize;
            }
            if (transmit) this._logEvent = $2a1589ac5e33c3f7$var$createLogEventShape([].concat(parent._logEvent.bindings, bindings));
        }
        Child.prototype = this;
        const newLogger = new Child(this);
        // must happen before the level is assigned
        $2a1589ac5e33c3f7$var$appendChildLogger(this, newLogger);
        // required to actually initialize the logger functions for any given child
        newLogger.level = this.level;
        return newLogger;
    }
    return logger;
}
function $2a1589ac5e33c3f7$var$getLevels(opts) {
    const customLevels = opts.customLevels || {};
    const values = Object.assign({}, $2a1589ac5e33c3f7$var$pino.levels.values, customLevels);
    const labels = Object.assign({}, $2a1589ac5e33c3f7$var$pino.levels.labels, $2a1589ac5e33c3f7$var$invertObject(customLevels));
    return {
        values: values,
        labels: labels
    };
}
function $2a1589ac5e33c3f7$var$invertObject(obj) {
    const inverted = {};
    Object.keys(obj).forEach(function(key) {
        inverted[obj[key]] = key;
    });
    return inverted;
}
$2a1589ac5e33c3f7$var$pino.levels = {
    values: {
        fatal: 60,
        error: 50,
        warn: 40,
        info: 30,
        debug: 20,
        trace: 10
    },
    labels: {
        10: 'trace',
        20: 'debug',
        30: 'info',
        40: 'warn',
        50: 'error',
        60: 'fatal'
    }
};
$2a1589ac5e33c3f7$var$pino.stdSerializers = $2a1589ac5e33c3f7$var$stdSerializers;
$2a1589ac5e33c3f7$var$pino.stdTimeFunctions = Object.assign({}, {
    nullTime: $2a1589ac5e33c3f7$var$nullTime,
    epochTime: $2a1589ac5e33c3f7$var$epochTime,
    unixTime: $2a1589ac5e33c3f7$var$unixTime,
    isoTime: $2a1589ac5e33c3f7$var$isoTime
});
function $2a1589ac5e33c3f7$var$getBindingChain(logger) {
    const bindings = [];
    if (logger.bindings) bindings.push(logger.bindings);
    // traverse up the tree to get all bindings
    let hierarchy = logger[$2a1589ac5e33c3f7$var$hierarchySymbol];
    while(hierarchy.parent){
        hierarchy = hierarchy.parent;
        if (hierarchy.logger.bindings) bindings.push(hierarchy.logger.bindings);
    }
    return bindings.reverse();
}
function $2a1589ac5e33c3f7$var$set(self1, opts, rootLogger, level) {
    // override the current log functions with either `noop` or the base log function
    Object.defineProperty(self1, level, {
        value: $2a1589ac5e33c3f7$var$levelToValue(self1.level, rootLogger) > $2a1589ac5e33c3f7$var$levelToValue(level, rootLogger) ? $2a1589ac5e33c3f7$var$noop : rootLogger[$2a1589ac5e33c3f7$var$baseLogFunctionSymbol][level],
        writable: true,
        enumerable: true,
        configurable: true
    });
    if (!opts.transmit && self1[level] === $2a1589ac5e33c3f7$var$noop) return;
    // make sure the log format is correct
    self1[level] = $2a1589ac5e33c3f7$var$createWrap(self1, opts, rootLogger, level);
    // prepend bindings if it is not the root logger
    const bindings = $2a1589ac5e33c3f7$var$getBindingChain(self1);
    if (bindings.length === 0) // early exit in case for rootLogger
    return;
    self1[level] = $2a1589ac5e33c3f7$var$prependBindingsInArguments(bindings, self1[level]);
}
function $2a1589ac5e33c3f7$var$prependBindingsInArguments(bindings, logFunc) {
    return function() {
        return logFunc.apply(this, [
            ...bindings,
            ...arguments
        ]);
    };
}
function $2a1589ac5e33c3f7$var$createWrap(self1, opts, rootLogger, level) {
    return function(write) {
        return function LOG() {
            const ts = opts.timestamp();
            const args = new Array(arguments.length);
            const proto = Object.getPrototypeOf && Object.getPrototypeOf(this) === $2a1589ac5e33c3f7$var$_console ? $2a1589ac5e33c3f7$var$_console : this;
            for(var i = 0; i < args.length; i++)args[i] = arguments[i];
            if (opts.serialize && !opts.asObject) $2a1589ac5e33c3f7$var$applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
            if (opts.asObject || opts.formatters) write.call(proto, $2a1589ac5e33c3f7$var$asObject(this, level, args, ts, opts.formatters));
            else write.apply(proto, args);
            if (opts.transmit) {
                const transmitLevel = opts.transmit.level || self1._level;
                const transmitValue = rootLogger.levels.values[transmitLevel];
                const methodValue = rootLogger.levels.values[level];
                if (methodValue < transmitValue) return;
                $2a1589ac5e33c3f7$var$transmit(this, {
                    ts: ts,
                    methodLevel: level,
                    methodValue: methodValue,
                    transmitLevel: transmitLevel,
                    transmitValue: rootLogger.levels.values[opts.transmit.level || self1._level],
                    send: opts.transmit.send,
                    val: $2a1589ac5e33c3f7$var$levelToValue(self1._level, rootLogger)
                }, args);
            }
        };
    }(self1[$2a1589ac5e33c3f7$var$baseLogFunctionSymbol][level]);
}
function $2a1589ac5e33c3f7$var$asObject(logger, level, args, ts, formatters = {}) {
    const { level: levelFormatter = ()=>logger.levels.values[level], log: logObjectFormatter = (obj)=>obj } = formatters;
    if (logger._serialize) $2a1589ac5e33c3f7$var$applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
    const argsCloned = args.slice();
    let msg = argsCloned[0];
    const logObject = {};
    if (ts) logObject.time = ts;
    logObject.level = levelFormatter(level, logger.levels.values[level]);
    let lvl = (logger._childLevel | 0) + 1;
    if (lvl < 1) lvl = 1;
    // deliberate, catching objects, arrays
    if (msg !== null && typeof msg === 'object') {
        while(lvl-- && typeof argsCloned[0] === 'object')Object.assign(logObject, argsCloned.shift());
        msg = argsCloned.length ? $bb5r4(argsCloned.shift(), argsCloned) : undefined;
    } else if (typeof msg === 'string') msg = $bb5r4(argsCloned.shift(), argsCloned);
    if (msg !== undefined) logObject.msg = msg;
    const formattedLogObject = logObjectFormatter(logObject);
    return formattedLogObject;
}
function $2a1589ac5e33c3f7$var$applySerializers(args, serialize, serializers, stdErrSerialize) {
    for(const i in args){
        if (stdErrSerialize && args[i] instanceof Error) args[i] = $2a1589ac5e33c3f7$var$pino.stdSerializers.err(args[i]);
        else if (typeof args[i] === 'object' && !Array.isArray(args[i])) {
            for(const k in args[i])if (serialize && serialize.indexOf(k) > -1 && k in serializers) args[i][k] = serializers[k](args[i][k]);
        }
    }
}
function $2a1589ac5e33c3f7$var$transmit(logger, opts, args) {
    const send = opts.send;
    const ts = opts.ts;
    const methodLevel = opts.methodLevel;
    const methodValue = opts.methodValue;
    const val = opts.val;
    const bindings = logger._logEvent.bindings;
    $2a1589ac5e33c3f7$var$applySerializers(args, logger._serialize || Object.keys(logger.serializers), logger.serializers, logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize);
    logger._logEvent.ts = ts;
    logger._logEvent.messages = args.filter(function(arg) {
        // bindings can only be objects, so reference equality check via indexOf is fine
        return bindings.indexOf(arg) === -1;
    });
    logger._logEvent.level.label = methodLevel;
    logger._logEvent.level.value = methodValue;
    send(methodLevel, logger._logEvent, val);
    logger._logEvent = $2a1589ac5e33c3f7$var$createLogEventShape(bindings);
}
function $2a1589ac5e33c3f7$var$createLogEventShape(bindings) {
    return {
        ts: 0,
        messages: [],
        bindings: bindings || [],
        level: {
            label: '',
            value: 0
        }
    };
}
function $2a1589ac5e33c3f7$var$asErrValue(err) {
    const obj = {
        type: err.constructor.name,
        msg: err.message,
        stack: err.stack
    };
    for(const key in err)if (obj[key] === undefined) obj[key] = err[key];
    return obj;
}
function $2a1589ac5e33c3f7$var$getTimeFunction(opts) {
    if (typeof opts.timestamp === 'function') return opts.timestamp;
    if (opts.timestamp === false) return $2a1589ac5e33c3f7$var$nullTime;
    return $2a1589ac5e33c3f7$var$epochTime;
}
function $2a1589ac5e33c3f7$var$mock() {
    return {};
}
function $2a1589ac5e33c3f7$var$passthrough(a) {
    return a;
}
function $2a1589ac5e33c3f7$var$noop() {}
function $2a1589ac5e33c3f7$var$nullTime() {
    return false;
}
function $2a1589ac5e33c3f7$var$epochTime() {
    return Date.now();
}
function $2a1589ac5e33c3f7$var$unixTime() {
    return Math.round(Date.now() / 1000.0);
}
function $2a1589ac5e33c3f7$var$isoTime() {
    return new Date(Date.now()).toISOString();
} // using Date.now() for testability
/* eslint-disable */ /* istanbul ignore next */ function $2a1589ac5e33c3f7$var$pfGlobalThisOrFallback() {
    function defd(o) {
        return typeof o !== 'undefined' && o;
    }
    try {
        if (typeof globalThis !== 'undefined') return globalThis;
        Object.defineProperty(Object.prototype, 'globalThis', {
            get: function() {
                delete Object.prototype.globalThis;
                return this.globalThis = this;
            },
            configurable: true
        });
        return globalThis;
    } catch (e) {
        return defd(self) || defd(window) || defd(this) || {};
    }
}
/* eslint-enable */ module.exports.default = $2a1589ac5e33c3f7$var$pino;
module.exports.pino = $2a1589ac5e33c3f7$var$pino;

});
parcelRegister("bb5r4", function(module, exports) {
'use strict';
function $8234f0346c62e618$var$tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
module.exports = $8234f0346c62e618$var$format;
function $8234f0346c62e618$var$format(f, args, opts) {
    var ss = opts && opts.stringify || $8234f0346c62e618$var$tryStringify;
    var offset = 1;
    if (typeof f === 'object' && f !== null) {
        var len = args.length + offset;
        if (len === 1) return f;
        var objects = new Array(len);
        objects[0] = ss(f);
        for(var index = 1; index < len; index++)objects[index] = ss(args[index]);
        return objects.join(' ');
    }
    if (typeof f !== 'string') return f;
    var argLen = args.length;
    if (argLen === 0) return f;
    var str = '';
    var a = 1 - offset;
    var lastPos = -1;
    var flen = f && f.length || 0;
    for(var i = 0; i < flen;){
        if (f.charCodeAt(i) === 37 && i + 1 < flen) {
            lastPos = lastPos > -1 ? lastPos : 0;
            switch(f.charCodeAt(i + 1)){
                case 100:
                case 102:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Number(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 105:
                    if (a >= argLen) break;
                    if (args[a] == null) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += Math.floor(Number(args[a]));
                    lastPos = i + 2;
                    i++;
                    break;
                case 79:
                case 111:
                case 106:
                    if (a >= argLen) break;
                    if (args[a] === undefined) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    var type = typeof args[a];
                    if (type === 'string') {
                        str += '\'' + args[a] + '\'';
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    if (type === 'function') {
                        str += args[a].name || '<anonymous>';
                        lastPos = i + 2;
                        i++;
                        break;
                    }
                    str += ss(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 115:
                    if (a >= argLen) break;
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += String(args[a]);
                    lastPos = i + 2;
                    i++;
                    break;
                case 37:
                    if (lastPos < i) str += f.slice(lastPos, i);
                    str += '%';
                    lastPos = i + 2;
                    i++;
                    a--;
                    break;
            }
            ++a;
        }
        ++i;
    }
    if (lastPos === -1) return f;
    else if (lastPos < flen) str += f.slice(lastPos);
    return str;
}

});



parcelRegister("8JEKL", function(module, exports) {

(function(pkg) {
    const PIXI1 = pkg.PIXI;
    class TextInput extends PIXI1.Container {
        constructor(styles){
            super();
            this._input_style = Object.assign({
                position: 'absolute',
                background: 'none',
                border: 'none',
                outline: 'none',
                transformOrigin: '0 0',
                lineHeight: '1'
            }, styles.input);
            if (styles.box) this._box_generator = typeof styles.box === 'function' ? styles.box : new DefaultBoxGenerator(styles.box);
            else this._box_generator = null;
            if (this._input_style.hasOwnProperty('multiline')) {
                this._multiline = !!this._input_style.multiline;
                delete this._input_style.multiline;
            } else this._multiline = false;
            this._box_cache = {};
            this._previous = {};
            this._dom_added = false;
            this._dom_visible = true;
            this._placeholder = '';
            this._placeholderColor = 0xa9a9a9;
            this._selection = [
                0,
                0
            ];
            this._restrict_value = '';
            this._createDOMInput();
            this.substituteText = true;
            this._setState('DEFAULT');
            this._addListeners();
        }
        // GETTERS & SETTERS
        get substituteText() {
            return this._substituted;
        }
        set substituteText(substitute) {
            if (this._substituted == substitute) return;
            this._substituted = substitute;
            if (substitute) {
                this._createSurrogate();
                this._dom_visible = false;
            } else {
                this._destroySurrogate();
                this._dom_visible = true;
            }
            this.placeholder = this._placeholder;
            this._update();
        }
        get placeholder() {
            return this._placeholder;
        }
        set placeholder(text) {
            this._placeholder = text;
            if (this._substituted) {
                this._updateSurrogate();
                this._dom_input.placeholder = '';
            } else this._dom_input.placeholder = text;
        }
        get disabled() {
            return this._disabled;
        }
        set disabled(disabled) {
            this._disabled = disabled;
            this._dom_input.disabled = disabled;
            this._setState(disabled ? 'DISABLED' : 'DEFAULT');
        }
        get maxLength() {
            return this._max_length;
        }
        set maxLength(length) {
            this._max_length = length;
            this._dom_input.setAttribute('maxlength', length);
        }
        get restrict() {
            return this._restrict_regex;
        }
        set restrict(regex) {
            if (regex instanceof RegExp) {
                regex = regex.toString().slice(1, -1);
                if (regex.charAt(0) !== '^') regex = '^' + regex;
                if (regex.charAt(regex.length - 1) !== '$') regex = regex + '$';
                regex = new RegExp(regex);
            } else regex = new RegExp('^[' + regex + ']*$');
            this._restrict_regex = regex;
        }
        get text() {
            return this._dom_input.value;
        }
        set text(text) {
            this._dom_input.value = text;
            if (this._substituted) this._updateSurrogate();
        }
        get htmlInput() {
            return this._dom_input;
        }
        focus() {
            if (this._substituted && !this.dom_visible) this._setDOMInputVisible(true);
            this._dom_input.focus();
        }
        blur() {
            this._dom_input.blur();
        }
        select() {
            this.focus();
            this._dom_input.select();
        }
        setInputStyle(key, value) {
            this._input_style[key] = value;
            this._dom_input.style[key] = value;
            if (this._substituted && (key === 'fontFamily' || key === 'fontSize')) this._updateFontMetrics();
            if (this._last_renderer) this._update();
        }
        destroy(options) {
            this._destroyBoxCache();
            super.destroy(options);
        }
        // SETUP
        _createDOMInput() {
            if (this._multiline) {
                this._dom_input = document.createElement('textarea');
                this._dom_input.style.resize = 'none';
            } else {
                this._dom_input = document.createElement('input');
                this._dom_input.type = 'text';
            }
            for(let key in this._input_style)this._dom_input.style[key] = this._input_style[key];
        }
        _addListeners() {
            this.on('added', this._onAdded.bind(this));
            this.on('removed', this._onRemoved.bind(this));
            this._dom_input.addEventListener('keydown', this._onInputKeyDown.bind(this));
            this._dom_input.addEventListener('input', this._onInputInput.bind(this));
            this._dom_input.addEventListener('keyup', this._onInputKeyUp.bind(this));
            this._dom_input.addEventListener('focus', this._onFocused.bind(this));
            this._dom_input.addEventListener('blur', this._onBlurred.bind(this));
        }
        _onInputKeyDown(e) {
            this._selection = [
                this._dom_input.selectionStart,
                this._dom_input.selectionEnd
            ];
            this.emit('keydown', e.keyCode);
        }
        _onInputInput(e) {
            if (this._restrict_regex) this._applyRestriction();
            if (this._substituted) this._updateSubstitution();
            this.emit('input', this.text);
        }
        _onInputKeyUp(e) {
            this.emit('keyup', e.keyCode);
        }
        _onFocused() {
            this._setState('FOCUSED');
            this.emit('focus');
        }
        _onBlurred() {
            this._setState('DEFAULT');
            this.emit('blur');
        }
        _onAdded() {
            document.body.appendChild(this._dom_input);
            this._dom_input.style.display = 'none';
            this._dom_added = true;
        }
        _onRemoved() {
            document.body.removeChild(this._dom_input);
            this._dom_added = false;
        }
        _setState(state) {
            this.state = state;
            this._updateBox();
            if (this._substituted) this._updateSubstitution();
        }
        // RENDER & UPDATE
        // for pixi v4
        renderWebGL(renderer) {
            super.renderWebGL(renderer);
            this._renderInternal(renderer);
        }
        // for pixi v4
        renderCanvas(renderer) {
            super.renderCanvas(renderer);
            this._renderInternal(renderer);
        }
        // for pixi v5
        render(renderer) {
            super.render(renderer);
            this._renderInternal(renderer);
        }
        _renderInternal(renderer) {
            this._resolution = renderer.resolution;
            this._last_renderer = renderer;
            this._canvas_bounds = this._getCanvasBounds();
            if (this._needsUpdate()) this._update();
        }
        _update() {
            this._updateDOMInput();
            if (this._substituted) this._updateSurrogate();
            this._updateBox();
        }
        _updateBox() {
            if (!this._box_generator) return;
            if (this._needsNewBoxCache()) this._buildBoxCache();
            if (this.state == this._previous.state && this._box == this._box_cache[this.state]) return;
            if (this._box) this.removeChild(this._box);
            this._box = this._box_cache[this.state];
            this.addChildAt(this._box, 0);
            this._previous.state = this.state;
        }
        _updateSubstitution() {
            if (this.state === 'FOCUSED') {
                this._dom_visible = true;
                this._surrogate.visible = this.text.length === 0;
            } else {
                this._dom_visible = false;
                this._surrogate.visible = true;
            }
            this._updateDOMInput();
            this._updateSurrogate();
        }
        _updateDOMInput() {
            if (!this._canvas_bounds) return;
            this._dom_input.style.top = (this._canvas_bounds.top || 0) + 'px';
            this._dom_input.style.left = (this._canvas_bounds.left || 0) + 'px';
            this._dom_input.style.transform = this._pixiMatrixToCSS(this._getDOMRelativeWorldTransform());
            this._dom_input.style.opacity = this.worldAlpha;
            this._setDOMInputVisible(this.worldVisible && this._dom_visible);
            this._previous.canvas_bounds = this._canvas_bounds;
            this._previous.world_transform = this.worldTransform.clone();
            this._previous.world_alpha = this.worldAlpha;
            this._previous.world_visible = this.worldVisible;
        }
        _applyRestriction() {
            if (this._restrict_regex.test(this.text)) this._restrict_value = this.text;
            else {
                this.text = this._restrict_value;
                this._dom_input.setSelectionRange(this._selection[0], this._selection[1]);
            }
        }
        // STATE COMPAIRSON (FOR PERFORMANCE BENEFITS)
        _needsUpdate() {
            return !this._comparePixiMatrices(this.worldTransform, this._previous.world_transform) || !this._compareClientRects(this._canvas_bounds, this._previous.canvas_bounds) || this.worldAlpha != this._previous.world_alpha || this.worldVisible != this._previous.world_visible;
        }
        _needsNewBoxCache() {
            let input_bounds = this._getDOMInputBounds();
            return !this._previous.input_bounds || input_bounds.width != this._previous.input_bounds.width || input_bounds.height != this._previous.input_bounds.height;
        }
        // INPUT SUBSTITUTION
        _createSurrogate() {
            this._surrogate_hitbox = new PIXI1.Graphics();
            this._surrogate_hitbox.alpha = 0;
            this._surrogate_hitbox.interactive = true;
            this._surrogate_hitbox.cursor = 'text';
            this._surrogate_hitbox.on('pointerdown', this._onSurrogateFocus.bind(this));
            this.addChild(this._surrogate_hitbox);
            this._surrogate_mask = new PIXI1.Graphics();
            this.addChild(this._surrogate_mask);
            this._surrogate = new PIXI1.Text('', {});
            this.addChild(this._surrogate);
            this._surrogate.mask = this._surrogate_mask;
            this._updateFontMetrics();
            this._updateSurrogate();
        }
        _updateSurrogate() {
            let padding = this._deriveSurrogatePadding();
            let input_bounds = this._getDOMInputBounds();
            this._surrogate.style = this._deriveSurrogateStyle();
            this._surrogate.style.padding = Math.max.apply(Math, padding);
            this._surrogate.y = this._multiline ? padding[0] : (input_bounds.height - this._surrogate.height) / 2;
            this._surrogate.x = padding[3];
            this._surrogate.text = this._deriveSurrogateText();
            switch(this._surrogate.style.align){
                case 'left':
                    this._surrogate.x = padding[3];
                    break;
                case 'center':
                    this._surrogate.x = input_bounds.width * 0.5 - this._surrogate.width * 0.5;
                    break;
                case 'right':
                    this._surrogate.x = input_bounds.width - padding[1] - this._surrogate.width;
                    break;
            }
            this._updateSurrogateHitbox(input_bounds);
            this._updateSurrogateMask(input_bounds, padding);
        }
        _updateSurrogateHitbox(bounds) {
            this._surrogate_hitbox.clear();
            this._surrogate_hitbox.beginFill(0);
            this._surrogate_hitbox.drawRect(0, 0, bounds.width, bounds.height);
            this._surrogate_hitbox.endFill();
            this._surrogate_hitbox.interactive = !this._disabled;
        }
        _updateSurrogateMask(bounds, padding) {
            this._surrogate_mask.clear();
            this._surrogate_mask.beginFill(0);
            this._surrogate_mask.drawRect(padding[3], 0, bounds.width - padding[3] - padding[1], bounds.height);
            this._surrogate_mask.endFill();
        }
        _destroySurrogate() {
            if (!this._surrogate) return;
            this.removeChild(this._surrogate);
            this.removeChild(this._surrogate_hitbox);
            this._surrogate.destroy();
            this._surrogate_hitbox.destroy();
            this._surrogate = null;
            this._surrogate_hitbox = null;
        }
        _onSurrogateFocus() {
            this._setDOMInputVisible(true);
            //sometimes the input is not being focused by the mouseclick
            setTimeout(this._ensureFocus.bind(this), 10);
        }
        _ensureFocus() {
            if (!this._hasFocus()) this.focus();
        }
        _deriveSurrogateStyle() {
            let style = new PIXI1.TextStyle();
            for(var key in this._input_style)switch(key){
                case 'color':
                    style.fill = this._input_style.color;
                    break;
                case 'fontFamily':
                case 'fontSize':
                case 'fontWeight':
                case 'fontVariant':
                case 'fontStyle':
                    style[key] = this._input_style[key];
                    break;
                case 'letterSpacing':
                    style.letterSpacing = parseFloat(this._input_style.letterSpacing);
                    break;
                case 'textAlign':
                    style.align = this._input_style.textAlign;
                    break;
            }
            if (this._multiline) {
                style.lineHeight = parseFloat(style.fontSize);
                style.wordWrap = true;
                style.wordWrapWidth = this._getDOMInputBounds().width;
            }
            if (this._dom_input.value.length === 0) style.fill = this._placeholderColor;
            return style;
        }
        _deriveSurrogatePadding() {
            let indent = this._input_style.textIndent ? parseFloat(this._input_style.textIndent) : 0;
            if (this._input_style.padding && this._input_style.padding.length > 0) {
                let components = this._input_style.padding.trim().split(' ');
                if (components.length == 1) {
                    let padding = parseFloat(components[0]);
                    return [
                        padding,
                        padding,
                        padding,
                        padding + indent
                    ];
                } else if (components.length == 2) {
                    let paddingV = parseFloat(components[0]);
                    let paddingH = parseFloat(components[1]);
                    return [
                        paddingV,
                        paddingH,
                        paddingV,
                        paddingH + indent
                    ];
                } else if (components.length == 4) {
                    let padding = components.map((component)=>{
                        return parseFloat(component);
                    });
                    padding[3] += indent;
                    return padding;
                }
            }
            return [
                0,
                0,
                0,
                indent
            ];
        }
        _deriveSurrogateText() {
            if (this._dom_input.value.length === 0) return this._placeholder;
            if (this._dom_input.type == 'password') return "\u2022".repeat(this._dom_input.value.length);
            return this._dom_input.value;
        }
        _updateFontMetrics() {
            const style = this._deriveSurrogateStyle();
            const font = style.toFontString();
            this._font_metrics = PIXI1.TextMetrics.measureFont(font);
        }
        // CACHING OF INPUT BOX GRAPHICS
        _buildBoxCache() {
            this._destroyBoxCache();
            let states = [
                'DEFAULT',
                'FOCUSED',
                'DISABLED'
            ];
            let input_bounds = this._getDOMInputBounds();
            for(let i in states)this._box_cache[states[i]] = this._box_generator(input_bounds.width, input_bounds.height, states[i]);
            this._previous.input_bounds = input_bounds;
        }
        _destroyBoxCache() {
            if (this._box) {
                this.removeChild(this._box);
                this._box = null;
            }
            for(let i in this._box_cache){
                this._box_cache[i].destroy();
                this._box_cache[i] = null;
                delete this._box_cache[i];
            }
        }
        // HELPER FUNCTIONS
        _hasFocus() {
            return document.activeElement === this._dom_input;
        }
        _setDOMInputVisible(visible) {
            this._dom_input.style.display = visible ? 'block' : 'none';
        }
        _getCanvasBounds() {
            let rect = this._last_renderer.view.getBoundingClientRect();
            let bounds = {
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height
            };
            bounds.left += window.scrollX;
            bounds.top += window.scrollY;
            return bounds;
        }
        _getDOMInputBounds() {
            let remove_after = false;
            if (!this._dom_added) {
                document.body.appendChild(this._dom_input);
                remove_after = true;
            }
            let org_transform = this._dom_input.style.transform;
            let org_display = this._dom_input.style.display;
            this._dom_input.style.transform = '';
            this._dom_input.style.display = 'block';
            let bounds = this._dom_input.getBoundingClientRect();
            this._dom_input.style.transform = org_transform;
            this._dom_input.style.display = org_display;
            if (remove_after) document.body.removeChild(this._dom_input);
            return bounds;
        }
        _getDOMRelativeWorldTransform() {
            let canvas_bounds = this._last_renderer.view.getBoundingClientRect();
            let matrix = this.worldTransform.clone();
            matrix.scale(this._resolution, this._resolution);
            matrix.scale(canvas_bounds.width / this._last_renderer.width, canvas_bounds.height / this._last_renderer.height);
            return matrix;
        }
        _pixiMatrixToCSS(m) {
            return 'matrix(' + [
                m.a,
                m.b,
                m.c,
                m.d,
                m.tx,
                m.ty
            ].join(',') + ')';
        }
        _comparePixiMatrices(m1, m2) {
            if (!m1 || !m2) return false;
            return m1.a == m2.a && m1.b == m2.b && m1.c == m2.c && m1.d == m2.d && m1.tx == m2.tx && m1.ty == m2.ty;
        }
        _compareClientRects(r1, r2) {
            if (!r1 || !r2) return false;
            return r1.left == r2.left && r1.top == r2.top && r1.width == r2.width && r1.height == r2.height;
        }
    }
    function DefaultBoxGenerator(styles) {
        styles = styles || {
            fill: 0xcccccc
        };
        if (styles.default) {
            styles.focused = styles.focused || styles.default;
            styles.disabled = styles.disabled || styles.default;
        } else {
            let temp_styles = styles;
            styles = {};
            styles.default = styles.focused = styles.disabled = temp_styles;
        }
        return function(w, h, state) {
            let style = styles[state.toLowerCase()];
            let box = new PIXI1.Graphics();
            if (style.fill) box.beginFill(style.fill);
            if (style.stroke) box.lineStyle(style.stroke.width || 1, style.stroke.color || 0, style.stroke.alpha || 1);
            if (style.rounded) box.drawRoundedRect(0, 0, w, h, style.rounded);
            else box.drawRect(0, 0, w, h);
            box.endFill();
            box.closePath();
            return box;
        };
    }
    pkg.exportTo[0][pkg.exportTo[1]] = TextInput;
})(typeof PIXI === 'object' ? {
    PIXI: PIXI,
    exportTo: [
        PIXI,
        'TextInput'
    ]
} : {
    PIXI: (parcelRequire("1avo5")),
    exportTo: [
        module,
        'exports'
    ]
});

});

parcelRegister("bW0pk", function(module, exports) {
module.exports = $parcel$import("eInMy").then(()=>parcelRequire('h5Yew'));

});

parcelRegister("f9obu", function(module, exports) {

$parcel$export(module.exports, "ShadowDebugTest", function () { return $2ad4f177bd78ba9a$export$dc8416ded43a30dc; });

var $5UG8I = parcelRequire("5UG8I");

var $aFPGo = parcelRequire("aFPGo");
class $2ad4f177bd78ba9a$export$dc8416ded43a30dc {
    constructor(shadowRendering){
        this.testFrameCount = 0;
        this.maxTestFrames = 100;
        /**
     * Run a test to verify cache behavior
     */ this.runTest = ()=>{
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, "[Shadow Debug Test] Starting cache test...");
            this.testFrameCount = 0;
            this.performanceMonitor.reset();
            // Run test for a few frames
            const testInterval = setInterval(()=>{
                this.performanceMonitor.update();
                this.testFrameCount++;
                if (this.testFrameCount >= this.maxTestFrames) {
                    clearInterval(testInterval);
                    this.logTestResults();
                }
            }, 16) // ~60 FPS
            ;
        };
        this.logTestResults = ()=>{
            const metrics = this.performanceMonitor.getMetrics();
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, "[Shadow Debug Test] Test Results:");
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `  Total Frames: ${metrics.totalFrames}`);
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `  Cache Hit Rate: ${metrics.cacheHitRate.toFixed(1)}%`);
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `  Texture Regen Rate: ${metrics.textureRegenRate.toFixed(1)}%`);
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `  Cache Size: ${metrics.cacheSize}/${metrics.maxCacheSize}`);
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `  Needs Update: ${metrics.needsUpdate}`);
            // Check if cache is working
            if (metrics.cacheHitRate > 0) (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, "\u2705 Cache is working!");
            else (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, "\u274C Cache is not working - 0% hit rate");
        };
        /**
     * Force a cache clear to test cache miss behavior
     */ this.forceCacheClear = ()=>{
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, "[Shadow Debug Test] Forcing cache clear...");
            this.shadowRendering.forceTextureUpdate();
        };
        /**
     * Get current cache statistics
     */ this.getCacheStats = ()=>{
            return this.shadowRendering.getCacheStats();
        };
        /**
     * Enable/disable debug logging
     */ this.setDebugLogging = (enabled)=>{
            this.shadowRendering.debugHashCalculation = enabled;
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `[Shadow Debug Test] Debug logging ${enabled ? "enabled" : "disabled"}`);
        };
        this.shadowRendering = shadowRendering;
        this.performanceMonitor = new (0, $aFPGo.ShadowPerformanceMonitor)(shadowRendering);
        // Enable debug logging
        this.shadowRendering.debugHashCalculation = true;
    }
} /**
 * Usage example:
 *
 * // In your main client code:
 * const shadowDebugTest = new ShadowDebugTest(shadowRendering)
 *
 * // Run the test
 * shadowDebugTest.runTest()
 *
 * // Or manually check cache stats
 * logger.info({ tags: ["shadow", "debug"] }, shadowDebugTest.getCacheStats())
 */ 

});
parcelRegister("aFPGo", function(module, exports) {

$parcel$export(module.exports, "ShadowPerformanceMonitor", function () { return $7df034c62ab51562$export$35757d4a95da683c; });

var $5UG8I = parcelRequire("5UG8I");
class $7df034c62ab51562$export$35757d4a95da683c {
    constructor(shadowRendering){
        this.frameCount = 0;
        this.textureRegenerationCount = 0;
        this.cacheHitCount = 0;
        this.lastStatsTime = Date.now();
        this.lastCacheSize = 0;
        this.lastHash = "";
        /**
     * Call this every frame to track performance
     */ this.update = ()=>{
            this.frameCount++;
            const stats = this.shadowRendering.getCacheStats();
            // Track cache hits vs misses based on hash changes
            // If hash changed, it means we need to regenerate texture (cache miss)
            // If hash is the same, it means we can reuse cached texture (cache hit)
            if (stats.lastVisibilityHash !== this.lastHash) {
                this.textureRegenerationCount++;
                this.lastHash = stats.lastVisibilityHash;
            } else if (stats.lastVisibilityHash) this.cacheHitCount++;
            // Log stats every 5 seconds
            const now = Date.now();
            if (now - this.lastStatsTime > 5000) {
                this.logStats();
                this.lastStatsTime = now;
            }
        };
        this.logStats = ()=>{
            const stats = this.shadowRendering.getCacheStats();
            const totalFrames = this.frameCount;
            const cacheHitRate = totalFrames > 0 ? (this.cacheHitCount / totalFrames * 100).toFixed(1) : "0";
            const textureRegenRate = totalFrames > 0 ? (this.textureRegenerationCount / totalFrames * 100).toFixed(1) : "0";
            (0, $5UG8I.logger).info({
                tags: [
                    "shadow",
                    "debug"
                ]
            }, `[Shadow Performance] Frames: ${totalFrames}, Cache Hit Rate: ${cacheHitRate}%, Texture Regen: ${textureRegenRate}%, Cache Size: ${stats.cacheSize}/${stats.maxCacheSize}`);
            // Reset counters
            this.frameCount = 0;
            this.textureRegenerationCount = 0;
            this.cacheHitCount = 0;
        };
        /**
     * Get current performance metrics
     */ this.getMetrics = ()=>{
            const stats = this.shadowRendering.getCacheStats();
            return {
                totalFrames: this.frameCount,
                cacheHitRate: this.frameCount > 0 ? this.cacheHitCount / this.frameCount * 100 : 0,
                textureRegenRate: this.frameCount > 0 ? this.textureRegenerationCount / this.frameCount * 100 : 0,
                cacheSize: stats.cacheSize,
                maxCacheSize: stats.maxCacheSize,
                needsUpdate: stats.needsUpdate
            };
        };
        /**
     * Reset all counters
     */ this.reset = ()=>{
            this.frameCount = 0;
            this.textureRegenerationCount = 0;
            this.cacheHitCount = 0;
            this.lastStatsTime = Date.now();
            this.lastHash = "";
        };
        this.shadowRendering = shadowRendering;
    }
} /**
 * Usage example:
 *
 * // In your main render loop or client update:
 * const shadowMonitor = new ShadowPerformanceMonitor(shadowRendering)
 *
 * // In your render function:
 * shadowMonitor.update()
 *
 * // To get current metrics:
 * const metrics = shadowMonitor.getMetrics()
 * logger.info({ tags: ["shadow", "debug"] }, `Cache hit rate: ${metrics.cacheHitRate.toFixed(1)}%`)
 */ 

});


var $ca5eab90a111e4cd$exports = {};
$parcel$extendImportMap({
    "eInMy": "debug_viewport_culling.f56aa5d8.js"
});

var $4cd2695ccd862b0a$exports = {};
$4cd2695ccd862b0a$exports = JSON.parse('{"assets":{"LPC_Ancient_Rome_Architecture.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/LPC_Ancient_Rome_Architecture.png","LPC_Ancient_Rome_Architecture_aquaduct.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/LPC_Ancient_Rome_Architecture_aquaduct.png","LPC_Ancient_Rome_Architecture_therme.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/LPC_Ancient_Rome_Architecture_therme.png","atlas.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/atlas.json","atlas.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/atlas.png","authored-terrain-v2.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/authored-terrain-v2.png","authored-terrain.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/authored-terrain.json","authored-terrain.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/authored-terrain.png","beach-desert.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/beach-desert.json","beach-desert.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/beach-desert.png","bonecaller_chant.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/bonecaller_chant.ogg","bonecaller_complete.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/bonecaller_complete.ogg","bonecaller_spike_impact.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/bonecaller_spike_impact.ogg","bonecaller_spike_windup.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/bonecaller_spike_windup.ogg","bonecaller_sweep_impact.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/bonecaller_sweep_impact.ogg","bonecaller_sweep_windup.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/bonecaller_sweep_windup.ogg","boots/0.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/boots/0.ogg","boots/1.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/boots/1.ogg","boots/2.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/boots/2.ogg","boots/3.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/boots/3.ogg","boots/4.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/boots/4.ogg","boots/5.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/boots/5.ogg","boots/6.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/boots/6.ogg","boots/7.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/boots/7.ogg","boots/8.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/boots/8.ogg","boots/license.txt":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/boots/license.txt","build_atlas.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/build_atlas.json","build_atlas.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/build_atlas.png","build_printed.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/build_printed.ogg","campfire_fed.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/campfire_fed.ogg","campfire_lit.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/campfire_lit.ogg","chapter_announce.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/chapter_announce.ogg","chapter_begin.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/chapter_begin.ogg","chapter_complete.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/chapter_complete.ogg","chapter_task_complete.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/chapter_task_complete.ogg","chapter_task_stamp.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/chapter_task_stamp.ogg","click.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/click.mp3","clocktick.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/clocktick.mp3","cloth.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/cloth.ogg","coin3.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/coin3.ogg","colony.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/colony.json","colony.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/colony.png","container.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/container.json","container.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/container.png","cottage.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/cottage.json","cottage.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/cottage.png","decorations-medieval.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/decorations-medieval.json","decorations-medieval.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/decorations-medieval.png","discord.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/discord.png","dome1.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/dome1.ogg","door-open.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/door-open.ogg","door_close.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/door_close.ogg","door_open.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/door_open.ogg","dooropen.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/dooropen.mp3","dungeon-ambience.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/dungeon-ambience.ogg","dungeon_tiles.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/dungeon_tiles.png","ember_core_blast.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/ember_core_blast.ogg","ember_core_charge.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/ember_core_charge.ogg","ember_core_fire.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/ember_core_fire.ogg","ember_core_fuse.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/ember_core_fuse.ogg","ember_core_ready.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/ember_core_ready.ogg","emp.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/emp.mp3","explosion.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/explosion.mp3","fence_medieval.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/fence_medieval.json","fence_medieval.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/fence_medieval.png","floors.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/floors.json","floors.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/floors.png","footstep.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/footstep.mp3","forest-dirt.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/forest-dirt.json","forest-dirt.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/forest-dirt.png","forest-grass.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/forest-grass.json","forest-grass.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/forest-grass.png","furniture-blonde-wood.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/furniture-blonde-wood.json","furniture-blonde-wood.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/furniture-blonde-wood.png","grass/0.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/grass/0.ogg","grass/1.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/grass/1.ogg","ground_rupture.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/ground_rupture.ogg","gunshot.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/gunshot.mp3","hatch-wood.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/hatch-wood.json","hatch-wood.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/hatch-wood.png","health.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/health.mp3","human/death/1.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/human/death/1.ogg","human/death/2.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/human/death/2.ogg","human/death/3.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/human/death/3.ogg","human/death/4.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/human/death/4.ogg","human/death/5.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/human/death/5.ogg","human/death/6.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/human/death/6.ogg","human/death/7.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/human/death/7.ogg","human/death/8.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/human/death/8.ogg","human/death/aargh.txt":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/human/death/aargh.txt","humanoid.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/humanoid.json","humanoid.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/humanoid.png","intro/scene.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/intro/scene.png","item-art-32902d50537ebad17e79.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-32902d50537ebad17e79.json","item-art-32902d50537ebad17e79.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-32902d50537ebad17e79.png","item-art-35c925e4db81912bfe38.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-35c925e4db81912bfe38.json","item-art-35c925e4db81912bfe38.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-35c925e4db81912bfe38.png","item-art-4d6c318ef966e097227a.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-4d6c318ef966e097227a.json","item-art-4d6c318ef966e097227a.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-4d6c318ef966e097227a.png","item-art-5902c8b486e89c8f8e57.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-5902c8b486e89c8f8e57.json","item-art-5902c8b486e89c8f8e57.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-5902c8b486e89c8f8e57.png","item-art-721c3f8a8d4621a46f90.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-721c3f8a8d4621a46f90.json","item-art-721c3f8a8d4621a46f90.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-721c3f8a8d4621a46f90.png","item-art-7fc02d2406eaa57e3be0.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-7fc02d2406eaa57e3be0.json","item-art-7fc02d2406eaa57e3be0.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-7fc02d2406eaa57e3be0.png","item-art-887e0636d4bbe2a4f448.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-887e0636d4bbe2a4f448.json","item-art-887e0636d4bbe2a4f448.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-887e0636d4bbe2a4f448.png","item-art-99ea85dcdc93fac8db18.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-99ea85dcdc93fac8db18.json","item-art-99ea85dcdc93fac8db18.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-99ea85dcdc93fac8db18.png","item-art-a7225776548a58ab4e04.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-a7225776548a58ab4e04.json","item-art-a7225776548a58ab4e04.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-a7225776548a58ab4e04.png","item-art-af19df691fc7aa944194.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-af19df691fc7aa944194.json","item-art-af19df691fc7aa944194.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-af19df691fc7aa944194.png","item-art-b1d5a86cbcd21ed656d3.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-b1d5a86cbcd21ed656d3.json","item-art-b1d5a86cbcd21ed656d3.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-b1d5a86cbcd21ed656d3.png","item-art-b9ef00e25a4177065abd.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-b9ef00e25a4177065abd.json","item-art-b9ef00e25a4177065abd.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-b9ef00e25a4177065abd.png","item-art-bb4afa7ce4e3c1ba55ba.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-bb4afa7ce4e3c1ba55ba.json","item-art-bb4afa7ce4e3c1ba55ba.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-bb4afa7ce4e3c1ba55ba.png","item-art-d9ecaed5ff4485611809.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-d9ecaed5ff4485611809.json","item-art-d9ecaed5ff4485611809.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-d9ecaed5ff4485611809.png","item-art-e46e4dec4aea45bf9d8e.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-e46e4dec4aea45bf9d8e.json","item-art-e46e4dec4aea45bf9d8e.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-e46e4dec4aea45bf9d8e.png","item-art-ebdd046fea0f3ab21669.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-ebdd046fea0f3ab21669.json","item-art-ebdd046fea0f3ab21669.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-ebdd046fea0f3ab21669.png","item-art-f728e0bbaefbd1982b2d.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-f728e0bbaefbd1982b2d.json","item-art-f728e0bbaefbd1982b2d.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item-art-f728e0bbaefbd1982b2d.png","item_crafted.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/item_crafted.ogg","joystick-handle.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/joystick-handle.png","joystick.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/joystick.png","jungle-ruins.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/jungle-ruins.json","jungle-ruins.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/jungle-ruins.png","lpc-flowers-plants-fungi-wood.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc-flowers-plants-fungi-wood.json","lpc-flowers-plants-fungi-wood.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc-flowers-plants-fungi-wood.png","lpc-terrain.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc-terrain.json","lpc-terrain.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc-terrain.png","lpc/CREDITS.csv":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/CREDITS.csv","lpc/spritesheets/authored/iron-pickaxe/female.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/iron-pickaxe/female.png","lpc/spritesheets/authored/iron-pickaxe/female.png.frames.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/iron-pickaxe/female.png.frames.json","lpc/spritesheets/authored/iron-pickaxe/female.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/iron-pickaxe/female.png.json","lpc/spritesheets/authored/iron-pickaxe/male.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/iron-pickaxe/male.png","lpc/spritesheets/authored/iron-pickaxe/male.png.frames.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/iron-pickaxe/male.png.frames.json","lpc/spritesheets/authored/iron-pickaxe/male.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/iron-pickaxe/male.png.json","lpc/spritesheets/authored/lpc-chicken.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/lpc-chicken.png","lpc/spritesheets/authored/lpc-chicken.png.frames.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/lpc-chicken.png.frames.json","lpc/spritesheets/authored/lpc-chicken.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/lpc-chicken.png.json","lpc/spritesheets/authored/lpc-viper.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/lpc-viper.png","lpc/spritesheets/authored/lpc-viper.png.frames.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/lpc-viper.png.frames.json","lpc/spritesheets/authored/lpc-viper.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/lpc-viper.png.json","lpc/spritesheets/authored/rage-slime.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/rage-slime.png","lpc/spritesheets/authored/rage-slime.png.frames.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/rage-slime.png.frames.json","lpc/spritesheets/authored/rage-slime.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/rage-slime.png.json","lpc/spritesheets/authored/wild-hare.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/wild-hare.png","lpc/spritesheets/authored/wild-hare.png.frames.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/wild-hare.png.frames.json","lpc/spritesheets/authored/wild-hare.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/authored/wild-hare.png.json","lpc/spritesheets/bauldron/female/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/bauldron/female/brown.png","lpc/spritesheets/bauldron/female/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/bauldron/female/brown.png.json","lpc/spritesheets/bauldron/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/bauldron/male/brown.png","lpc/spritesheets/bauldron/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/bauldron/male/brown.png.json","lpc/spritesheets/body/female/deer/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/deer/brown.png","lpc/spritesheets/body/female/deer/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/deer/brown.png.json","lpc/spritesheets/body/female/human/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/black.png","lpc/spritesheets/body/female/human/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/black.png.json","lpc/spritesheets/body/female/human/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/brown.png","lpc/spritesheets/body/female/human/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/brown.png.json","lpc/spritesheets/body/female/human/dark.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/dark.png","lpc/spritesheets/body/female/human/dark.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/dark.png.json","lpc/spritesheets/body/female/human/light.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/light.png","lpc/spritesheets/body/female/human/light.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/light.png.json","lpc/spritesheets/body/female/human/olive.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/olive.png","lpc/spritesheets/body/female/human/olive.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/olive.png.json","lpc/spritesheets/body/female/human/tanned.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/tanned.png","lpc/spritesheets/body/female/human/tanned.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/tanned.png.json","lpc/spritesheets/body/female/human/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/white.png","lpc/spritesheets/body/female/human/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/human/white.png.json","lpc/spritesheets/body/female/orcs/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/orcs/gray.png","lpc/spritesheets/body/female/orcs/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/orcs/gray.png.json","lpc/spritesheets/body/female/orcs/green_1.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/orcs/green_1.png","lpc/spritesheets/body/female/orcs/green_1.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/orcs/green_1.png.json","lpc/spritesheets/body/female/orcs/green_3.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/orcs/green_3.png","lpc/spritesheets/body/female/orcs/green_3.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/orcs/green_3.png.json","lpc/spritesheets/body/female/reptiles/blue_unwinged.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/reptiles/blue_unwinged.png","lpc/spritesheets/body/female/reptiles/blue_unwinged.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/reptiles/blue_unwinged.png.json","lpc/spritesheets/body/female/reptiles/blue_winged.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/reptiles/blue_winged.png","lpc/spritesheets/body/female/reptiles/blue_winged.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/reptiles/blue_winged.png.json","lpc/spritesheets/body/female/reptiles/green_unwinged.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/reptiles/green_unwinged.png","lpc/spritesheets/body/female/reptiles/green_unwinged.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/reptiles/green_unwinged.png.json","lpc/spritesheets/body/female/reptiles/green_winged.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/reptiles/green_winged.png","lpc/spritesheets/body/female/reptiles/green_winged.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/reptiles/green_winged.png.json","lpc/spritesheets/body/female/reptiles/lightgreen_unwinged.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/reptiles/lightgreen_unwinged.png","lpc/spritesheets/body/female/reptiles/lightgreen_unwinged.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/reptiles/lightgreen_unwinged.png.json","lpc/spritesheets/body/female/reptiles/lightgreen_winged.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/reptiles/lightgreen_winged.png","lpc/spritesheets/body/female/reptiles/lightgreen_winged.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/reptiles/lightgreen_winged.png.json","lpc/spritesheets/body/female/wolf/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/black.png","lpc/spritesheets/body/female/wolf/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/black.png.json","lpc/spritesheets/body/female/wolf/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/brown.png","lpc/spritesheets/body/female/wolf/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/brown.png.json","lpc/spritesheets/body/female/wolf/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/gray.png","lpc/spritesheets/body/female/wolf/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/gray.png.json","lpc/spritesheets/body/female/wolf/head/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/head/black.png","lpc/spritesheets/body/female/wolf/head/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/head/black.png.json","lpc/spritesheets/body/female/wolf/head/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/head/brown.png","lpc/spritesheets/body/female/wolf/head/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/head/brown.png.json","lpc/spritesheets/body/female/wolf/head/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/head/gray.png","lpc/spritesheets/body/female/wolf/head/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/head/gray.png.json","lpc/spritesheets/body/female/wolf/head/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/head/white.png","lpc/spritesheets/body/female/wolf/head/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/head/white.png.json","lpc/spritesheets/body/female/wolf/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/white.png","lpc/spritesheets/body/female/wolf/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/female/wolf/white.png.json","lpc/spritesheets/body/male/chicken/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/chicken/white.png","lpc/spritesheets/body/male/chicken/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/chicken/white.png.json","lpc/spritesheets/body/male/deer/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/deer/brown.png","lpc/spritesheets/body/male/deer/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/deer/brown.png.json","lpc/spritesheets/body/male/horse/burdened/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/horse/burdened/brown.png","lpc/spritesheets/body/male/horse/burdened/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/horse/burdened/brown.png.json","lpc/spritesheets/body/male/human/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/black.png","lpc/spritesheets/body/male/human/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/black.png.json","lpc/spritesheets/body/male/human/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/brown.png","lpc/spritesheets/body/male/human/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/brown.png.json","lpc/spritesheets/body/male/human/dark.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/dark.png","lpc/spritesheets/body/male/human/dark.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/dark.png.json","lpc/spritesheets/body/male/human/light.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/light.png","lpc/spritesheets/body/male/human/light.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/light.png.json","lpc/spritesheets/body/male/human/olive.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/olive.png","lpc/spritesheets/body/male/human/olive.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/olive.png.json","lpc/spritesheets/body/male/human/tanned.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/tanned.png","lpc/spritesheets/body/male/human/tanned.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/tanned.png.json","lpc/spritesheets/body/male/human/transparent.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/transparent.png","lpc/spritesheets/body/male/human/transparent.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/transparent.png.json","lpc/spritesheets/body/male/human/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/white.png","lpc/spritesheets/body/male/human/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/human/white.png.json","lpc/spritesheets/body/male/orcs/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/orcs/gray.png","lpc/spritesheets/body/male/orcs/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/orcs/gray.png.json","lpc/spritesheets/body/male/orcs/green_1.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/orcs/green_1.png","lpc/spritesheets/body/male/orcs/green_1.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/orcs/green_1.png.json","lpc/spritesheets/body/male/orcs/green_3.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/orcs/green_3.png","lpc/spritesheets/body/male/orcs/green_3.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/orcs/green_3.png.json","lpc/spritesheets/body/male/rabbit/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/rabbit/white.png","lpc/spritesheets/body/male/rabbit/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/rabbit/white.png.json","lpc/spritesheets/body/male/redspider/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/redspider/red.png","lpc/spritesheets/body/male/redspider/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/redspider/red.png.json","lpc/spritesheets/body/male/reptiles/blue_unwinged.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/blue_unwinged.png","lpc/spritesheets/body/male/reptiles/blue_unwinged.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/blue_unwinged.png.json","lpc/spritesheets/body/male/reptiles/blue_winged.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/blue_winged.png","lpc/spritesheets/body/male/reptiles/blue_winged.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/blue_winged.png.json","lpc/spritesheets/body/male/reptiles/green_unwinged.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/green_unwinged.png","lpc/spritesheets/body/male/reptiles/green_unwinged.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/green_unwinged.png.json","lpc/spritesheets/body/male/reptiles/green_winged.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/green_winged.png","lpc/spritesheets/body/male/reptiles/green_winged.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/green_winged.png.json","lpc/spritesheets/body/male/reptiles/lightgreen_unwinged.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/lightgreen_unwinged.png","lpc/spritesheets/body/male/reptiles/lightgreen_unwinged.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/lightgreen_unwinged.png.json","lpc/spritesheets/body/male/reptiles/lightgreen_winged.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/lightgreen_winged.png","lpc/spritesheets/body/male/reptiles/lightgreen_winged.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/lightgreen_winged.png.json","lpc/spritesheets/body/male/reptiles/red_winged.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/red_winged.png","lpc/spritesheets/body/male/reptiles/red_winged.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/reptiles/red_winged.png.json","lpc/spritesheets/body/male/slime/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/slime/green.png","lpc/spritesheets/body/male/slime/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/slime/green.png.json","lpc/spritesheets/body/male/snake/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/snake/green.png","lpc/spritesheets/body/male/snake/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/snake/green.png.json","lpc/spritesheets/body/male/special/zombie.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/special/zombie.png","lpc/spritesheets/body/male/special/zombie.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/special/zombie.png.json","lpc/spritesheets/body/male/wasp/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wasp/yellow.png","lpc/spritesheets/body/male/wasp/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wasp/yellow.png.json","lpc/spritesheets/body/male/wolf/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/black.png","lpc/spritesheets/body/male/wolf/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/black.png.json","lpc/spritesheets/body/male/wolf/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/brown.png","lpc/spritesheets/body/male/wolf/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/brown.png.json","lpc/spritesheets/body/male/wolf/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/gray.png","lpc/spritesheets/body/male/wolf/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/gray.png.json","lpc/spritesheets/body/male/wolf/head/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/head/black.png","lpc/spritesheets/body/male/wolf/head/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/head/black.png.json","lpc/spritesheets/body/male/wolf/head/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/head/brown.png","lpc/spritesheets/body/male/wolf/head/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/head/brown.png.json","lpc/spritesheets/body/male/wolf/head/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/head/gray.png","lpc/spritesheets/body/male/wolf/head/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/head/gray.png.json","lpc/spritesheets/body/male/wolf/head/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/head/white.png","lpc/spritesheets/body/male/wolf/head/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/head/white.png.json","lpc/spritesheets/body/male/wolf/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/white.png","lpc/spritesheets/body/male/wolf/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/male/wolf/white.png.json","lpc/spritesheets/body/skeleton/beige.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/skeleton/beige.png","lpc/spritesheets/body/skeleton/beige.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/skeleton/beige.png.json","lpc/spritesheets/body/skeleton/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/skeleton/gray.png","lpc/spritesheets/body/skeleton/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/skeleton/gray.png.json","lpc/spritesheets/body/skeleton/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/skeleton/green.png","lpc/spritesheets/body/skeleton/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/body/skeleton/green.png.json","lpc/spritesheets/cape/solid/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/black.png","lpc/spritesheets/cape/solid/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/black.png.json","lpc/spritesheets/cape/solid/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/blue.png","lpc/spritesheets/cape/solid/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/blue.png.json","lpc/spritesheets/cape/solid/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/brown.png","lpc/spritesheets/cape/solid/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/brown.png.json","lpc/spritesheets/cape/solid/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/gray.png","lpc/spritesheets/cape/solid/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/gray.png.json","lpc/spritesheets/cape/solid/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/green.png","lpc/spritesheets/cape/solid/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/green.png.json","lpc/spritesheets/cape/solid/male/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/maroon.png","lpc/spritesheets/cape/solid/male/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/maroon.png.json","lpc/spritesheets/cape/solid/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/red.png","lpc/spritesheets/cape/solid/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/red.png.json","lpc/spritesheets/cape/solid/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/white.png","lpc/spritesheets/cape/solid/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/white.png.json","lpc/spritesheets/cape/solid/male/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/yellow.png","lpc/spritesheets/cape/solid/male/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid/male/yellow.png.json","lpc/spritesheets/cape/solid_behind/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/black.png","lpc/spritesheets/cape/solid_behind/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/black.png.json","lpc/spritesheets/cape/solid_behind/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/blue.png","lpc/spritesheets/cape/solid_behind/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/blue.png.json","lpc/spritesheets/cape/solid_behind/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/brown.png","lpc/spritesheets/cape/solid_behind/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/brown.png.json","lpc/spritesheets/cape/solid_behind/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/gray.png","lpc/spritesheets/cape/solid_behind/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/gray.png.json","lpc/spritesheets/cape/solid_behind/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/green.png","lpc/spritesheets/cape/solid_behind/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/green.png.json","lpc/spritesheets/cape/solid_behind/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/maroon.png","lpc/spritesheets/cape/solid_behind/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/maroon.png.json","lpc/spritesheets/cape/solid_behind/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/red.png","lpc/spritesheets/cape/solid_behind/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/red.png.json","lpc/spritesheets/cape/solid_behind/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/white.png","lpc/spritesheets/cape/solid_behind/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/white.png.json","lpc/spritesheets/cape/solid_behind/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/yellow.png","lpc/spritesheets/cape/solid_behind/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/solid_behind/yellow.png.json","lpc/spritesheets/cape/tattered/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/black.png","lpc/spritesheets/cape/tattered/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/black.png.json","lpc/spritesheets/cape/tattered/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/blue.png","lpc/spritesheets/cape/tattered/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/blue.png.json","lpc/spritesheets/cape/tattered/female/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/brown.png","lpc/spritesheets/cape/tattered/female/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/brown.png.json","lpc/spritesheets/cape/tattered/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/gray.png","lpc/spritesheets/cape/tattered/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/gray.png.json","lpc/spritesheets/cape/tattered/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/green.png","lpc/spritesheets/cape/tattered/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/green.png.json","lpc/spritesheets/cape/tattered/female/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/maroon.png","lpc/spritesheets/cape/tattered/female/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/maroon.png.json","lpc/spritesheets/cape/tattered/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/red.png","lpc/spritesheets/cape/tattered/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/red.png.json","lpc/spritesheets/cape/tattered/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/white.png","lpc/spritesheets/cape/tattered/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/white.png.json","lpc/spritesheets/cape/tattered/female/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/yellow.png","lpc/spritesheets/cape/tattered/female/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered/female/yellow.png.json","lpc/spritesheets/cape/tattered_behind/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/black.png","lpc/spritesheets/cape/tattered_behind/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/black.png.json","lpc/spritesheets/cape/tattered_behind/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/blue.png","lpc/spritesheets/cape/tattered_behind/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/blue.png.json","lpc/spritesheets/cape/tattered_behind/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/brown.png","lpc/spritesheets/cape/tattered_behind/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/brown.png.json","lpc/spritesheets/cape/tattered_behind/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/gray.png","lpc/spritesheets/cape/tattered_behind/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/gray.png.json","lpc/spritesheets/cape/tattered_behind/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/green.png","lpc/spritesheets/cape/tattered_behind/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/green.png.json","lpc/spritesheets/cape/tattered_behind/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/maroon.png","lpc/spritesheets/cape/tattered_behind/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/maroon.png.json","lpc/spritesheets/cape/tattered_behind/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/red.png","lpc/spritesheets/cape/tattered_behind/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/red.png.json","lpc/spritesheets/cape/tattered_behind/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/white.png","lpc/spritesheets/cape/tattered_behind/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/white.png.json","lpc/spritesheets/cape/tattered_behind/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/yellow.png","lpc/spritesheets/cape/tattered_behind/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/tattered_behind/yellow.png.json","lpc/spritesheets/cape/trimmed/female/white_blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/trimmed/female/white_blue.png","lpc/spritesheets/cape/trimmed/female/white_blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/trimmed/female/white_blue.png.json","lpc/spritesheets/cape/trimmed_behind/white_blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/trimmed_behind/white_blue.png","lpc/spritesheets/cape/trimmed_behind/white_blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/cape/trimmed_behind/white_blue.png.json","lpc/spritesheets/eyes/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/blue.png","lpc/spritesheets/eyes/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/blue.png.json","lpc/spritesheets/eyes/female/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/brown.png","lpc/spritesheets/eyes/female/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/brown.png.json","lpc/spritesheets/eyes/female/cyclope.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/cyclope.png","lpc/spritesheets/eyes/female/cyclope.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/cyclope.png.json","lpc/spritesheets/eyes/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/gray.png","lpc/spritesheets/eyes/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/gray.png.json","lpc/spritesheets/eyes/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/green.png","lpc/spritesheets/eyes/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/green.png.json","lpc/spritesheets/eyes/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/orange.png","lpc/spritesheets/eyes/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/orange.png.json","lpc/spritesheets/eyes/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/purple.png","lpc/spritesheets/eyes/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/purple.png.json","lpc/spritesheets/eyes/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/red.png","lpc/spritesheets/eyes/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/red.png.json","lpc/spritesheets/eyes/female/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/yellow.png","lpc/spritesheets/eyes/female/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/female/yellow.png.json","lpc/spritesheets/eyes/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/blue.png","lpc/spritesheets/eyes/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/blue.png.json","lpc/spritesheets/eyes/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/brown.png","lpc/spritesheets/eyes/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/brown.png.json","lpc/spritesheets/eyes/male/cyclope.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/cyclope.png","lpc/spritesheets/eyes/male/cyclope.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/cyclope.png.json","lpc/spritesheets/eyes/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/gray.png","lpc/spritesheets/eyes/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/gray.png.json","lpc/spritesheets/eyes/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/green.png","lpc/spritesheets/eyes/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/green.png.json","lpc/spritesheets/eyes/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/orange.png","lpc/spritesheets/eyes/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/orange.png.json","lpc/spritesheets/eyes/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/purple.png","lpc/spritesheets/eyes/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/purple.png.json","lpc/spritesheets/eyes/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/red.png","lpc/spritesheets/eyes/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/red.png.json","lpc/spritesheets/eyes/male/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/yellow.png","lpc/spritesheets/eyes/male/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/eyes/male/yellow.png.json","lpc/spritesheets/feet/armor/female/4.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/female/4.png","lpc/spritesheets/feet/armor/female/4.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/female/4.png.json","lpc/spritesheets/feet/armor/female/5.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/female/5.png","lpc/spritesheets/feet/armor/female/5.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/female/5.png.json","lpc/spritesheets/feet/armor/female/6.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/female/6.png","lpc/spritesheets/feet/armor/female/6.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/female/6.png.json","lpc/spritesheets/feet/armor/female/7.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/female/7.png","lpc/spritesheets/feet/armor/female/7.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/female/7.png.json","lpc/spritesheets/feet/armor/female/8.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/female/8.png","lpc/spritesheets/feet/armor/female/8.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/female/8.png.json","lpc/spritesheets/feet/armor/female/9.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/female/9.png","lpc/spritesheets/feet/armor/female/9.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/female/9.png.json","lpc/spritesheets/feet/armor/male/4.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/male/4.png","lpc/spritesheets/feet/armor/male/4.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/male/4.png.json","lpc/spritesheets/feet/armor/male/5.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/male/5.png","lpc/spritesheets/feet/armor/male/5.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/male/5.png.json","lpc/spritesheets/feet/armor/male/6.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/male/6.png","lpc/spritesheets/feet/armor/male/6.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/male/6.png.json","lpc/spritesheets/feet/armor/male/7.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/male/7.png","lpc/spritesheets/feet/armor/male/7.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/male/7.png.json","lpc/spritesheets/feet/armor/male/8.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/male/8.png","lpc/spritesheets/feet/armor/male/8.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/male/8.png.json","lpc/spritesheets/feet/armor/male/9.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/male/9.png","lpc/spritesheets/feet/armor/male/9.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/armor/male/9.png.json","lpc/spritesheets/feet/boots/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/black.png","lpc/spritesheets/feet/boots/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/black.png.json","lpc/spritesheets/feet/boots/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/blue.png","lpc/spritesheets/feet/boots/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/blue.png.json","lpc/spritesheets/feet/boots/female/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/brown.png","lpc/spritesheets/feet/boots/female/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/brown.png.json","lpc/spritesheets/feet/boots/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/gray.png","lpc/spritesheets/feet/boots/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/gray.png.json","lpc/spritesheets/feet/boots/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/green.png","lpc/spritesheets/feet/boots/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/green.png.json","lpc/spritesheets/feet/boots/female/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/maroon.png","lpc/spritesheets/feet/boots/female/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/maroon.png.json","lpc/spritesheets/feet/boots/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/orange.png","lpc/spritesheets/feet/boots/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/orange.png.json","lpc/spritesheets/feet/boots/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/purple.png","lpc/spritesheets/feet/boots/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/purple.png.json","lpc/spritesheets/feet/boots/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/red.png","lpc/spritesheets/feet/boots/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/red.png.json","lpc/spritesheets/feet/boots/female/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/tan.png","lpc/spritesheets/feet/boots/female/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/tan.png.json","lpc/spritesheets/feet/boots/female/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/teal.png","lpc/spritesheets/feet/boots/female/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/teal.png.json","lpc/spritesheets/feet/boots/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/white.png","lpc/spritesheets/feet/boots/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/white.png.json","lpc/spritesheets/feet/boots/female/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/yellow.png","lpc/spritesheets/feet/boots/female/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/female/yellow.png.json","lpc/spritesheets/feet/boots/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/black.png","lpc/spritesheets/feet/boots/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/black.png.json","lpc/spritesheets/feet/boots/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/blue.png","lpc/spritesheets/feet/boots/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/blue.png.json","lpc/spritesheets/feet/boots/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/brown.png","lpc/spritesheets/feet/boots/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/brown.png.json","lpc/spritesheets/feet/boots/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/gray.png","lpc/spritesheets/feet/boots/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/gray.png.json","lpc/spritesheets/feet/boots/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/green.png","lpc/spritesheets/feet/boots/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/green.png.json","lpc/spritesheets/feet/boots/male/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/maroon.png","lpc/spritesheets/feet/boots/male/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/maroon.png.json","lpc/spritesheets/feet/boots/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/orange.png","lpc/spritesheets/feet/boots/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/orange.png.json","lpc/spritesheets/feet/boots/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/purple.png","lpc/spritesheets/feet/boots/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/purple.png.json","lpc/spritesheets/feet/boots/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/red.png","lpc/spritesheets/feet/boots/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/red.png.json","lpc/spritesheets/feet/boots/male/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/tan.png","lpc/spritesheets/feet/boots/male/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/tan.png.json","lpc/spritesheets/feet/boots/male/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/teal.png","lpc/spritesheets/feet/boots/male/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/teal.png.json","lpc/spritesheets/feet/boots/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/white.png","lpc/spritesheets/feet/boots/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/white.png.json","lpc/spritesheets/feet/boots/male/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/yellow.png","lpc/spritesheets/feet/boots/male/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/boots/male/yellow.png.json","lpc/spritesheets/feet/sandals/female/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/sandals/female/brown.png","lpc/spritesheets/feet/sandals/female/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/sandals/female/brown.png.json","lpc/spritesheets/feet/sandals/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/sandals/male/brown.png","lpc/spritesheets/feet/sandals/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/sandals/male/brown.png.json","lpc/spritesheets/feet/shoes/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/shoes/female/black.png","lpc/spritesheets/feet/shoes/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/shoes/female/black.png.json","lpc/spritesheets/feet/shoes/female/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/shoes/female/brown.png","lpc/spritesheets/feet/shoes/female/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/shoes/female/brown.png.json","lpc/spritesheets/feet/shoes/female/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/shoes/female/maroon.png","lpc/spritesheets/feet/shoes/female/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/shoes/female/maroon.png.json","lpc/spritesheets/feet/shoes/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/shoes/male/black.png","lpc/spritesheets/feet/shoes/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/shoes/male/black.png.json","lpc/spritesheets/feet/shoes/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/shoes/male/brown.png","lpc/spritesheets/feet/shoes/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/shoes/male/brown.png.json","lpc/spritesheets/feet/shoes/male/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/shoes/male/maroon.png","lpc/spritesheets/feet/shoes/male/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/shoes/male/maroon.png.json","lpc/spritesheets/feet/slippers/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/slippers/female/black.png","lpc/spritesheets/feet/slippers/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/slippers/female/black.png.json","lpc/spritesheets/feet/slippers/female/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/slippers/female/brown.png","lpc/spritesheets/feet/slippers/female/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/slippers/female/brown.png.json","lpc/spritesheets/feet/slippers/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/slippers/female/gray.png","lpc/spritesheets/feet/slippers/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/feet/slippers/female/gray.png.json","lpc/spritesheets/hair/afro/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/black.png","lpc/spritesheets/hair/afro/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/black.png.json","lpc/spritesheets/hair/afro/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/blonde.png","lpc/spritesheets/hair/afro/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/blonde.png.json","lpc/spritesheets/hair/afro/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/blue.png","lpc/spritesheets/hair/afro/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/blue.png.json","lpc/spritesheets/hair/afro/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/dark_brown.png","lpc/spritesheets/hair/afro/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/dark_brown.png.json","lpc/spritesheets/hair/afro/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/gold.png","lpc/spritesheets/hair/afro/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/gold.png.json","lpc/spritesheets/hair/afro/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/gray.png","lpc/spritesheets/hair/afro/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/gray.png.json","lpc/spritesheets/hair/afro/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/green.png","lpc/spritesheets/hair/afro/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/green.png.json","lpc/spritesheets/hair/afro/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/light_brown.png","lpc/spritesheets/hair/afro/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/light_brown.png.json","lpc/spritesheets/hair/afro/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/orange.png","lpc/spritesheets/hair/afro/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/orange.png.json","lpc/spritesheets/hair/afro/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/purple.png","lpc/spritesheets/hair/afro/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/purple.png.json","lpc/spritesheets/hair/afro/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/red.png","lpc/spritesheets/hair/afro/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/red.png.json","lpc/spritesheets/hair/afro/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/white.png","lpc/spritesheets/hair/afro/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/female/white.png.json","lpc/spritesheets/hair/afro/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/black.png","lpc/spritesheets/hair/afro/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/black.png.json","lpc/spritesheets/hair/afro/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/blonde.png","lpc/spritesheets/hair/afro/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/blonde.png.json","lpc/spritesheets/hair/afro/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/blue.png","lpc/spritesheets/hair/afro/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/blue.png.json","lpc/spritesheets/hair/afro/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/dark_brown.png","lpc/spritesheets/hair/afro/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/dark_brown.png.json","lpc/spritesheets/hair/afro/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/gold.png","lpc/spritesheets/hair/afro/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/gold.png.json","lpc/spritesheets/hair/afro/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/gray.png","lpc/spritesheets/hair/afro/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/gray.png.json","lpc/spritesheets/hair/afro/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/green.png","lpc/spritesheets/hair/afro/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/green.png.json","lpc/spritesheets/hair/afro/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/light_brown.png","lpc/spritesheets/hair/afro/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/light_brown.png.json","lpc/spritesheets/hair/afro/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/orange.png","lpc/spritesheets/hair/afro/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/orange.png.json","lpc/spritesheets/hair/afro/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/purple.png","lpc/spritesheets/hair/afro/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/purple.png.json","lpc/spritesheets/hair/afro/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/red.png","lpc/spritesheets/hair/afro/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/red.png.json","lpc/spritesheets/hair/afro/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/white.png","lpc/spritesheets/hair/afro/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/afro/male/white.png.json","lpc/spritesheets/hair/balding/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/black.png","lpc/spritesheets/hair/balding/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/black.png.json","lpc/spritesheets/hair/balding/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/blonde.png","lpc/spritesheets/hair/balding/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/blonde.png.json","lpc/spritesheets/hair/balding/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/blue.png","lpc/spritesheets/hair/balding/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/blue.png.json","lpc/spritesheets/hair/balding/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/dark_brown.png","lpc/spritesheets/hair/balding/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/dark_brown.png.json","lpc/spritesheets/hair/balding/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/gold.png","lpc/spritesheets/hair/balding/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/gold.png.json","lpc/spritesheets/hair/balding/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/gray.png","lpc/spritesheets/hair/balding/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/gray.png.json","lpc/spritesheets/hair/balding/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/green.png","lpc/spritesheets/hair/balding/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/green.png.json","lpc/spritesheets/hair/balding/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/light_brown.png","lpc/spritesheets/hair/balding/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/light_brown.png.json","lpc/spritesheets/hair/balding/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/orange.png","lpc/spritesheets/hair/balding/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/orange.png.json","lpc/spritesheets/hair/balding/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/purple.png","lpc/spritesheets/hair/balding/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/purple.png.json","lpc/spritesheets/hair/balding/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/red.png","lpc/spritesheets/hair/balding/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/red.png.json","lpc/spritesheets/hair/balding/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/white.png","lpc/spritesheets/hair/balding/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/female/white.png.json","lpc/spritesheets/hair/balding/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/black.png","lpc/spritesheets/hair/balding/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/black.png.json","lpc/spritesheets/hair/balding/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/blonde.png","lpc/spritesheets/hair/balding/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/blonde.png.json","lpc/spritesheets/hair/balding/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/blue.png","lpc/spritesheets/hair/balding/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/blue.png.json","lpc/spritesheets/hair/balding/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/dark_brown.png","lpc/spritesheets/hair/balding/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/dark_brown.png.json","lpc/spritesheets/hair/balding/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/gold.png","lpc/spritesheets/hair/balding/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/gold.png.json","lpc/spritesheets/hair/balding/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/gray.png","lpc/spritesheets/hair/balding/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/gray.png.json","lpc/spritesheets/hair/balding/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/green.png","lpc/spritesheets/hair/balding/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/green.png.json","lpc/spritesheets/hair/balding/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/light_brown.png","lpc/spritesheets/hair/balding/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/light_brown.png.json","lpc/spritesheets/hair/balding/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/orange.png","lpc/spritesheets/hair/balding/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/orange.png.json","lpc/spritesheets/hair/balding/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/purple.png","lpc/spritesheets/hair/balding/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/purple.png.json","lpc/spritesheets/hair/balding/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/red.png","lpc/spritesheets/hair/balding/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/red.png.json","lpc/spritesheets/hair/balding/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/white.png","lpc/spritesheets/hair/balding/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/balding/male/white.png.json","lpc/spritesheets/hair/bangs/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/black.png","lpc/spritesheets/hair/bangs/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/black.png.json","lpc/spritesheets/hair/bangs/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/blonde.png","lpc/spritesheets/hair/bangs/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/blonde.png.json","lpc/spritesheets/hair/bangs/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/blue.png","lpc/spritesheets/hair/bangs/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/blue.png.json","lpc/spritesheets/hair/bangs/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/dark_brown.png","lpc/spritesheets/hair/bangs/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/dark_brown.png.json","lpc/spritesheets/hair/bangs/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/gold.png","lpc/spritesheets/hair/bangs/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/gold.png.json","lpc/spritesheets/hair/bangs/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/gray.png","lpc/spritesheets/hair/bangs/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/gray.png.json","lpc/spritesheets/hair/bangs/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/green.png","lpc/spritesheets/hair/bangs/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/green.png.json","lpc/spritesheets/hair/bangs/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/light_brown.png","lpc/spritesheets/hair/bangs/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/light_brown.png.json","lpc/spritesheets/hair/bangs/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/orange.png","lpc/spritesheets/hair/bangs/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/orange.png.json","lpc/spritesheets/hair/bangs/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/purple.png","lpc/spritesheets/hair/bangs/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/purple.png.json","lpc/spritesheets/hair/bangs/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/red.png","lpc/spritesheets/hair/bangs/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/red.png.json","lpc/spritesheets/hair/bangs/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/white.png","lpc/spritesheets/hair/bangs/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/female/white.png.json","lpc/spritesheets/hair/bangs/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/black.png","lpc/spritesheets/hair/bangs/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/black.png.json","lpc/spritesheets/hair/bangs/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/blonde.png","lpc/spritesheets/hair/bangs/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/blonde.png.json","lpc/spritesheets/hair/bangs/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/blue.png","lpc/spritesheets/hair/bangs/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/blue.png.json","lpc/spritesheets/hair/bangs/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/dark_brown.png","lpc/spritesheets/hair/bangs/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/dark_brown.png.json","lpc/spritesheets/hair/bangs/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/gold.png","lpc/spritesheets/hair/bangs/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/gold.png.json","lpc/spritesheets/hair/bangs/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/gray.png","lpc/spritesheets/hair/bangs/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/gray.png.json","lpc/spritesheets/hair/bangs/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/green.png","lpc/spritesheets/hair/bangs/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/green.png.json","lpc/spritesheets/hair/bangs/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/light_brown.png","lpc/spritesheets/hair/bangs/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/light_brown.png.json","lpc/spritesheets/hair/bangs/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/orange.png","lpc/spritesheets/hair/bangs/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/orange.png.json","lpc/spritesheets/hair/bangs/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/purple.png","lpc/spritesheets/hair/bangs/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/purple.png.json","lpc/spritesheets/hair/bangs/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/red.png","lpc/spritesheets/hair/bangs/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/red.png.json","lpc/spritesheets/hair/bangs/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/white.png","lpc/spritesheets/hair/bangs/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs/male/white.png.json","lpc/spritesheets/hair/bangs_bun/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/black.png","lpc/spritesheets/hair/bangs_bun/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/black.png.json","lpc/spritesheets/hair/bangs_bun/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/blonde.png","lpc/spritesheets/hair/bangs_bun/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/blonde.png.json","lpc/spritesheets/hair/bangs_bun/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/blue.png","lpc/spritesheets/hair/bangs_bun/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/blue.png.json","lpc/spritesheets/hair/bangs_bun/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/dark_brown.png","lpc/spritesheets/hair/bangs_bun/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/dark_brown.png.json","lpc/spritesheets/hair/bangs_bun/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/gold.png","lpc/spritesheets/hair/bangs_bun/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/gold.png.json","lpc/spritesheets/hair/bangs_bun/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/gray.png","lpc/spritesheets/hair/bangs_bun/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/gray.png.json","lpc/spritesheets/hair/bangs_bun/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/green.png","lpc/spritesheets/hair/bangs_bun/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/green.png.json","lpc/spritesheets/hair/bangs_bun/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/light_brown.png","lpc/spritesheets/hair/bangs_bun/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/light_brown.png.json","lpc/spritesheets/hair/bangs_bun/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/orange.png","lpc/spritesheets/hair/bangs_bun/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/orange.png.json","lpc/spritesheets/hair/bangs_bun/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/purple.png","lpc/spritesheets/hair/bangs_bun/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/purple.png.json","lpc/spritesheets/hair/bangs_bun/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/red.png","lpc/spritesheets/hair/bangs_bun/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/red.png.json","lpc/spritesheets/hair/bangs_bun/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/white.png","lpc/spritesheets/hair/bangs_bun/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/female/white.png.json","lpc/spritesheets/hair/bangs_bun/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/black.png","lpc/spritesheets/hair/bangs_bun/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/black.png.json","lpc/spritesheets/hair/bangs_bun/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/blonde.png","lpc/spritesheets/hair/bangs_bun/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/blonde.png.json","lpc/spritesheets/hair/bangs_bun/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/blue.png","lpc/spritesheets/hair/bangs_bun/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/blue.png.json","lpc/spritesheets/hair/bangs_bun/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/dark_brown.png","lpc/spritesheets/hair/bangs_bun/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/dark_brown.png.json","lpc/spritesheets/hair/bangs_bun/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/gold.png","lpc/spritesheets/hair/bangs_bun/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/gold.png.json","lpc/spritesheets/hair/bangs_bun/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/gray.png","lpc/spritesheets/hair/bangs_bun/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/gray.png.json","lpc/spritesheets/hair/bangs_bun/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/green.png","lpc/spritesheets/hair/bangs_bun/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/green.png.json","lpc/spritesheets/hair/bangs_bun/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/light_brown.png","lpc/spritesheets/hair/bangs_bun/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/light_brown.png.json","lpc/spritesheets/hair/bangs_bun/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/orange.png","lpc/spritesheets/hair/bangs_bun/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/orange.png.json","lpc/spritesheets/hair/bangs_bun/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/purple.png","lpc/spritesheets/hair/bangs_bun/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/purple.png.json","lpc/spritesheets/hair/bangs_bun/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/red.png","lpc/spritesheets/hair/bangs_bun/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/red.png.json","lpc/spritesheets/hair/bangs_bun/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/white.png","lpc/spritesheets/hair/bangs_bun/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangs_bun/male/white.png.json","lpc/spritesheets/hair/bangslong/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/black.png","lpc/spritesheets/hair/bangslong/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/black.png.json","lpc/spritesheets/hair/bangslong/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/blonde.png","lpc/spritesheets/hair/bangslong/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/blonde.png.json","lpc/spritesheets/hair/bangslong/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/blue.png","lpc/spritesheets/hair/bangslong/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/blue.png.json","lpc/spritesheets/hair/bangslong/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/dark_brown.png","lpc/spritesheets/hair/bangslong/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/dark_brown.png.json","lpc/spritesheets/hair/bangslong/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/gold.png","lpc/spritesheets/hair/bangslong/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/gold.png.json","lpc/spritesheets/hair/bangslong/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/gray.png","lpc/spritesheets/hair/bangslong/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/gray.png.json","lpc/spritesheets/hair/bangslong/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/green.png","lpc/spritesheets/hair/bangslong/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/green.png.json","lpc/spritesheets/hair/bangslong/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/light_brown.png","lpc/spritesheets/hair/bangslong/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/light_brown.png.json","lpc/spritesheets/hair/bangslong/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/orange.png","lpc/spritesheets/hair/bangslong/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/orange.png.json","lpc/spritesheets/hair/bangslong/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/purple.png","lpc/spritesheets/hair/bangslong/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/purple.png.json","lpc/spritesheets/hair/bangslong/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/red.png","lpc/spritesheets/hair/bangslong/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/red.png.json","lpc/spritesheets/hair/bangslong/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/white.png","lpc/spritesheets/hair/bangslong/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/female/white.png.json","lpc/spritesheets/hair/bangslong/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/black.png","lpc/spritesheets/hair/bangslong/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/black.png.json","lpc/spritesheets/hair/bangslong/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/blonde.png","lpc/spritesheets/hair/bangslong/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/blonde.png.json","lpc/spritesheets/hair/bangslong/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/blue.png","lpc/spritesheets/hair/bangslong/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/blue.png.json","lpc/spritesheets/hair/bangslong/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/dark_brown.png","lpc/spritesheets/hair/bangslong/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/dark_brown.png.json","lpc/spritesheets/hair/bangslong/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/gold.png","lpc/spritesheets/hair/bangslong/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/gold.png.json","lpc/spritesheets/hair/bangslong/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/gray.png","lpc/spritesheets/hair/bangslong/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/gray.png.json","lpc/spritesheets/hair/bangslong/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/green.png","lpc/spritesheets/hair/bangslong/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/green.png.json","lpc/spritesheets/hair/bangslong/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/light_brown.png","lpc/spritesheets/hair/bangslong/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/light_brown.png.json","lpc/spritesheets/hair/bangslong/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/orange.png","lpc/spritesheets/hair/bangslong/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/orange.png.json","lpc/spritesheets/hair/bangslong/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/purple.png","lpc/spritesheets/hair/bangslong/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/purple.png.json","lpc/spritesheets/hair/bangslong/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/red.png","lpc/spritesheets/hair/bangslong/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/red.png.json","lpc/spritesheets/hair/bangslong/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/white.png","lpc/spritesheets/hair/bangslong/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong/male/white.png.json","lpc/spritesheets/hair/bangslong2/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/black.png","lpc/spritesheets/hair/bangslong2/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/black.png.json","lpc/spritesheets/hair/bangslong2/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/blonde.png","lpc/spritesheets/hair/bangslong2/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/blonde.png.json","lpc/spritesheets/hair/bangslong2/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/blue.png","lpc/spritesheets/hair/bangslong2/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/blue.png.json","lpc/spritesheets/hair/bangslong2/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/dark_brown.png","lpc/spritesheets/hair/bangslong2/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/dark_brown.png.json","lpc/spritesheets/hair/bangslong2/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/gold.png","lpc/spritesheets/hair/bangslong2/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/gold.png.json","lpc/spritesheets/hair/bangslong2/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/gray.png","lpc/spritesheets/hair/bangslong2/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/gray.png.json","lpc/spritesheets/hair/bangslong2/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/green.png","lpc/spritesheets/hair/bangslong2/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/green.png.json","lpc/spritesheets/hair/bangslong2/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/light_brown.png","lpc/spritesheets/hair/bangslong2/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/light_brown.png.json","lpc/spritesheets/hair/bangslong2/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/orange.png","lpc/spritesheets/hair/bangslong2/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/orange.png.json","lpc/spritesheets/hair/bangslong2/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/purple.png","lpc/spritesheets/hair/bangslong2/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/purple.png.json","lpc/spritesheets/hair/bangslong2/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/red.png","lpc/spritesheets/hair/bangslong2/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/red.png.json","lpc/spritesheets/hair/bangslong2/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/white.png","lpc/spritesheets/hair/bangslong2/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/female/white.png.json","lpc/spritesheets/hair/bangslong2/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/black.png","lpc/spritesheets/hair/bangslong2/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/black.png.json","lpc/spritesheets/hair/bangslong2/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/blonde.png","lpc/spritesheets/hair/bangslong2/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/blonde.png.json","lpc/spritesheets/hair/bangslong2/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/blue.png","lpc/spritesheets/hair/bangslong2/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/blue.png.json","lpc/spritesheets/hair/bangslong2/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/dark_brown.png","lpc/spritesheets/hair/bangslong2/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/dark_brown.png.json","lpc/spritesheets/hair/bangslong2/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/gold.png","lpc/spritesheets/hair/bangslong2/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/gold.png.json","lpc/spritesheets/hair/bangslong2/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/gray.png","lpc/spritesheets/hair/bangslong2/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/gray.png.json","lpc/spritesheets/hair/bangslong2/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/green.png","lpc/spritesheets/hair/bangslong2/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/green.png.json","lpc/spritesheets/hair/bangslong2/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/light_brown.png","lpc/spritesheets/hair/bangslong2/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/light_brown.png.json","lpc/spritesheets/hair/bangslong2/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/orange.png","lpc/spritesheets/hair/bangslong2/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/orange.png.json","lpc/spritesheets/hair/bangslong2/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/purple.png","lpc/spritesheets/hair/bangslong2/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/purple.png.json","lpc/spritesheets/hair/bangslong2/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/red.png","lpc/spritesheets/hair/bangslong2/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/red.png.json","lpc/spritesheets/hair/bangslong2/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/white.png","lpc/spritesheets/hair/bangslong2/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangslong2/male/white.png.json","lpc/spritesheets/hair/bangsshort/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/black.png","lpc/spritesheets/hair/bangsshort/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/black.png.json","lpc/spritesheets/hair/bangsshort/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/blonde.png","lpc/spritesheets/hair/bangsshort/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/blonde.png.json","lpc/spritesheets/hair/bangsshort/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/blue.png","lpc/spritesheets/hair/bangsshort/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/blue.png.json","lpc/spritesheets/hair/bangsshort/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/dark_brown.png","lpc/spritesheets/hair/bangsshort/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/dark_brown.png.json","lpc/spritesheets/hair/bangsshort/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/gold.png","lpc/spritesheets/hair/bangsshort/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/gold.png.json","lpc/spritesheets/hair/bangsshort/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/gray.png","lpc/spritesheets/hair/bangsshort/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/gray.png.json","lpc/spritesheets/hair/bangsshort/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/green.png","lpc/spritesheets/hair/bangsshort/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/green.png.json","lpc/spritesheets/hair/bangsshort/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/light_brown.png","lpc/spritesheets/hair/bangsshort/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/light_brown.png.json","lpc/spritesheets/hair/bangsshort/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/orange.png","lpc/spritesheets/hair/bangsshort/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/orange.png.json","lpc/spritesheets/hair/bangsshort/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/purple.png","lpc/spritesheets/hair/bangsshort/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/purple.png.json","lpc/spritesheets/hair/bangsshort/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/red.png","lpc/spritesheets/hair/bangsshort/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/red.png.json","lpc/spritesheets/hair/bangsshort/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/white.png","lpc/spritesheets/hair/bangsshort/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/female/white.png.json","lpc/spritesheets/hair/bangsshort/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/black.png","lpc/spritesheets/hair/bangsshort/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/black.png.json","lpc/spritesheets/hair/bangsshort/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/blonde.png","lpc/spritesheets/hair/bangsshort/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/blonde.png.json","lpc/spritesheets/hair/bangsshort/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/blue.png","lpc/spritesheets/hair/bangsshort/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/blue.png.json","lpc/spritesheets/hair/bangsshort/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/dark_brown.png","lpc/spritesheets/hair/bangsshort/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/dark_brown.png.json","lpc/spritesheets/hair/bangsshort/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/gold.png","lpc/spritesheets/hair/bangsshort/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/gold.png.json","lpc/spritesheets/hair/bangsshort/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/gray.png","lpc/spritesheets/hair/bangsshort/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/gray.png.json","lpc/spritesheets/hair/bangsshort/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/green.png","lpc/spritesheets/hair/bangsshort/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/green.png.json","lpc/spritesheets/hair/bangsshort/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/light_brown.png","lpc/spritesheets/hair/bangsshort/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/light_brown.png.json","lpc/spritesheets/hair/bangsshort/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/orange.png","lpc/spritesheets/hair/bangsshort/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/orange.png.json","lpc/spritesheets/hair/bangsshort/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/purple.png","lpc/spritesheets/hair/bangsshort/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/purple.png.json","lpc/spritesheets/hair/bangsshort/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/red.png","lpc/spritesheets/hair/bangsshort/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/red.png.json","lpc/spritesheets/hair/bangsshort/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/white.png","lpc/spritesheets/hair/bangsshort/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bangsshort/male/white.png.json","lpc/spritesheets/hair/bedhead/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/black.png","lpc/spritesheets/hair/bedhead/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/black.png.json","lpc/spritesheets/hair/bedhead/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/blonde.png","lpc/spritesheets/hair/bedhead/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/blonde.png.json","lpc/spritesheets/hair/bedhead/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/blue.png","lpc/spritesheets/hair/bedhead/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/blue.png.json","lpc/spritesheets/hair/bedhead/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/dark_brown.png","lpc/spritesheets/hair/bedhead/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/dark_brown.png.json","lpc/spritesheets/hair/bedhead/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/gold.png","lpc/spritesheets/hair/bedhead/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/gold.png.json","lpc/spritesheets/hair/bedhead/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/gray.png","lpc/spritesheets/hair/bedhead/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/gray.png.json","lpc/spritesheets/hair/bedhead/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/green.png","lpc/spritesheets/hair/bedhead/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/green.png.json","lpc/spritesheets/hair/bedhead/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/light_brown.png","lpc/spritesheets/hair/bedhead/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/light_brown.png.json","lpc/spritesheets/hair/bedhead/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/orange.png","lpc/spritesheets/hair/bedhead/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/orange.png.json","lpc/spritesheets/hair/bedhead/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/purple.png","lpc/spritesheets/hair/bedhead/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/purple.png.json","lpc/spritesheets/hair/bedhead/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/red.png","lpc/spritesheets/hair/bedhead/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/red.png.json","lpc/spritesheets/hair/bedhead/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/white.png","lpc/spritesheets/hair/bedhead/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/female/white.png.json","lpc/spritesheets/hair/bedhead/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/black.png","lpc/spritesheets/hair/bedhead/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/black.png.json","lpc/spritesheets/hair/bedhead/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/blonde.png","lpc/spritesheets/hair/bedhead/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/blonde.png.json","lpc/spritesheets/hair/bedhead/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/blue.png","lpc/spritesheets/hair/bedhead/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/blue.png.json","lpc/spritesheets/hair/bedhead/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/dark_brown.png","lpc/spritesheets/hair/bedhead/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/dark_brown.png.json","lpc/spritesheets/hair/bedhead/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/gold.png","lpc/spritesheets/hair/bedhead/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/gold.png.json","lpc/spritesheets/hair/bedhead/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/gray.png","lpc/spritesheets/hair/bedhead/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/gray.png.json","lpc/spritesheets/hair/bedhead/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/green.png","lpc/spritesheets/hair/bedhead/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/green.png.json","lpc/spritesheets/hair/bedhead/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/light_brown.png","lpc/spritesheets/hair/bedhead/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/light_brown.png.json","lpc/spritesheets/hair/bedhead/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/orange.png","lpc/spritesheets/hair/bedhead/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/orange.png.json","lpc/spritesheets/hair/bedhead/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/purple.png","lpc/spritesheets/hair/bedhead/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/purple.png.json","lpc/spritesheets/hair/bedhead/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/red.png","lpc/spritesheets/hair/bedhead/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/red.png.json","lpc/spritesheets/hair/bedhead/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/white.png","lpc/spritesheets/hair/bedhead/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bedhead/male/white.png.json","lpc/spritesheets/hair/bob/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/black.png","lpc/spritesheets/hair/bob/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/black.png.json","lpc/spritesheets/hair/bob/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/blonde.png","lpc/spritesheets/hair/bob/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/blonde.png.json","lpc/spritesheets/hair/bob/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/blue.png","lpc/spritesheets/hair/bob/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/blue.png.json","lpc/spritesheets/hair/bob/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/dark_brown.png","lpc/spritesheets/hair/bob/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/dark_brown.png.json","lpc/spritesheets/hair/bob/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/gold.png","lpc/spritesheets/hair/bob/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/gold.png.json","lpc/spritesheets/hair/bob/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/gray.png","lpc/spritesheets/hair/bob/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/gray.png.json","lpc/spritesheets/hair/bob/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/green.png","lpc/spritesheets/hair/bob/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/green.png.json","lpc/spritesheets/hair/bob/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/light_brown.png","lpc/spritesheets/hair/bob/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/light_brown.png.json","lpc/spritesheets/hair/bob/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/orange.png","lpc/spritesheets/hair/bob/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/orange.png.json","lpc/spritesheets/hair/bob/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/purple.png","lpc/spritesheets/hair/bob/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/purple.png.json","lpc/spritesheets/hair/bob/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/red.png","lpc/spritesheets/hair/bob/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/red.png.json","lpc/spritesheets/hair/bob/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/white.png","lpc/spritesheets/hair/bob/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/female/white.png.json","lpc/spritesheets/hair/bob/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/black.png","lpc/spritesheets/hair/bob/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/black.png.json","lpc/spritesheets/hair/bob/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/blonde.png","lpc/spritesheets/hair/bob/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/blonde.png.json","lpc/spritesheets/hair/bob/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/blue.png","lpc/spritesheets/hair/bob/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/blue.png.json","lpc/spritesheets/hair/bob/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/dark_brown.png","lpc/spritesheets/hair/bob/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/dark_brown.png.json","lpc/spritesheets/hair/bob/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/gold.png","lpc/spritesheets/hair/bob/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/gold.png.json","lpc/spritesheets/hair/bob/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/gray.png","lpc/spritesheets/hair/bob/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/gray.png.json","lpc/spritesheets/hair/bob/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/green.png","lpc/spritesheets/hair/bob/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/green.png.json","lpc/spritesheets/hair/bob/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/light_brown.png","lpc/spritesheets/hair/bob/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/light_brown.png.json","lpc/spritesheets/hair/bob/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/orange.png","lpc/spritesheets/hair/bob/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/orange.png.json","lpc/spritesheets/hair/bob/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/purple.png","lpc/spritesheets/hair/bob/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/purple.png.json","lpc/spritesheets/hair/bob/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/red.png","lpc/spritesheets/hair/bob/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/red.png.json","lpc/spritesheets/hair/bob/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/white.png","lpc/spritesheets/hair/bob/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob/male/white.png.json","lpc/spritesheets/hair/bob_side_part/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/black.png","lpc/spritesheets/hair/bob_side_part/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/black.png.json","lpc/spritesheets/hair/bob_side_part/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/blonde.png","lpc/spritesheets/hair/bob_side_part/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/blonde.png.json","lpc/spritesheets/hair/bob_side_part/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/blue.png","lpc/spritesheets/hair/bob_side_part/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/blue.png.json","lpc/spritesheets/hair/bob_side_part/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/dark_brown.png","lpc/spritesheets/hair/bob_side_part/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/dark_brown.png.json","lpc/spritesheets/hair/bob_side_part/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/gold.png","lpc/spritesheets/hair/bob_side_part/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/gold.png.json","lpc/spritesheets/hair/bob_side_part/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/gray.png","lpc/spritesheets/hair/bob_side_part/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/gray.png.json","lpc/spritesheets/hair/bob_side_part/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/green.png","lpc/spritesheets/hair/bob_side_part/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/green.png.json","lpc/spritesheets/hair/bob_side_part/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/light_brown.png","lpc/spritesheets/hair/bob_side_part/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/light_brown.png.json","lpc/spritesheets/hair/bob_side_part/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/orange.png","lpc/spritesheets/hair/bob_side_part/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/orange.png.json","lpc/spritesheets/hair/bob_side_part/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/purple.png","lpc/spritesheets/hair/bob_side_part/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/purple.png.json","lpc/spritesheets/hair/bob_side_part/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/red.png","lpc/spritesheets/hair/bob_side_part/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/red.png.json","lpc/spritesheets/hair/bob_side_part/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/white.png","lpc/spritesheets/hair/bob_side_part/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/female/white.png.json","lpc/spritesheets/hair/bob_side_part/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/black.png","lpc/spritesheets/hair/bob_side_part/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/black.png.json","lpc/spritesheets/hair/bob_side_part/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/blonde.png","lpc/spritesheets/hair/bob_side_part/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/blonde.png.json","lpc/spritesheets/hair/bob_side_part/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/blue.png","lpc/spritesheets/hair/bob_side_part/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/blue.png.json","lpc/spritesheets/hair/bob_side_part/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/dark_brown.png","lpc/spritesheets/hair/bob_side_part/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/dark_brown.png.json","lpc/spritesheets/hair/bob_side_part/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/gold.png","lpc/spritesheets/hair/bob_side_part/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/gold.png.json","lpc/spritesheets/hair/bob_side_part/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/gray.png","lpc/spritesheets/hair/bob_side_part/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/gray.png.json","lpc/spritesheets/hair/bob_side_part/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/green.png","lpc/spritesheets/hair/bob_side_part/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/green.png.json","lpc/spritesheets/hair/bob_side_part/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/light_brown.png","lpc/spritesheets/hair/bob_side_part/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/light_brown.png.json","lpc/spritesheets/hair/bob_side_part/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/orange.png","lpc/spritesheets/hair/bob_side_part/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/orange.png.json","lpc/spritesheets/hair/bob_side_part/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/purple.png","lpc/spritesheets/hair/bob_side_part/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/purple.png.json","lpc/spritesheets/hair/bob_side_part/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/red.png","lpc/spritesheets/hair/bob_side_part/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/red.png.json","lpc/spritesheets/hair/bob_side_part/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/white.png","lpc/spritesheets/hair/bob_side_part/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bob_side_part/male/white.png.json","lpc/spritesheets/hair/braid/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/black.png","lpc/spritesheets/hair/braid/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/black.png.json","lpc/spritesheets/hair/braid/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/blonde.png","lpc/spritesheets/hair/braid/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/blonde.png.json","lpc/spritesheets/hair/braid/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/blue.png","lpc/spritesheets/hair/braid/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/blue.png.json","lpc/spritesheets/hair/braid/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/dark_brown.png","lpc/spritesheets/hair/braid/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/dark_brown.png.json","lpc/spritesheets/hair/braid/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/gold.png","lpc/spritesheets/hair/braid/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/gold.png.json","lpc/spritesheets/hair/braid/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/gray.png","lpc/spritesheets/hair/braid/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/gray.png.json","lpc/spritesheets/hair/braid/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/green.png","lpc/spritesheets/hair/braid/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/green.png.json","lpc/spritesheets/hair/braid/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/light_brown.png","lpc/spritesheets/hair/braid/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/light_brown.png.json","lpc/spritesheets/hair/braid/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/orange.png","lpc/spritesheets/hair/braid/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/orange.png.json","lpc/spritesheets/hair/braid/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/purple.png","lpc/spritesheets/hair/braid/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/purple.png.json","lpc/spritesheets/hair/braid/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/red.png","lpc/spritesheets/hair/braid/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/red.png.json","lpc/spritesheets/hair/braid/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/white.png","lpc/spritesheets/hair/braid/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/female/white.png.json","lpc/spritesheets/hair/braid/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/black.png","lpc/spritesheets/hair/braid/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/black.png.json","lpc/spritesheets/hair/braid/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/blonde.png","lpc/spritesheets/hair/braid/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/blonde.png.json","lpc/spritesheets/hair/braid/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/blue.png","lpc/spritesheets/hair/braid/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/blue.png.json","lpc/spritesheets/hair/braid/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/dark_brown.png","lpc/spritesheets/hair/braid/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/dark_brown.png.json","lpc/spritesheets/hair/braid/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/gold.png","lpc/spritesheets/hair/braid/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/gold.png.json","lpc/spritesheets/hair/braid/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/gray.png","lpc/spritesheets/hair/braid/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/gray.png.json","lpc/spritesheets/hair/braid/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/green.png","lpc/spritesheets/hair/braid/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/green.png.json","lpc/spritesheets/hair/braid/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/light_brown.png","lpc/spritesheets/hair/braid/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/light_brown.png.json","lpc/spritesheets/hair/braid/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/orange.png","lpc/spritesheets/hair/braid/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/orange.png.json","lpc/spritesheets/hair/braid/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/purple.png","lpc/spritesheets/hair/braid/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/purple.png.json","lpc/spritesheets/hair/braid/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/red.png","lpc/spritesheets/hair/braid/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/red.png.json","lpc/spritesheets/hair/braid/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/white.png","lpc/spritesheets/hair/braid/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid/male/white.png.json","lpc/spritesheets/hair/braid2/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/black.png","lpc/spritesheets/hair/braid2/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/black.png.json","lpc/spritesheets/hair/braid2/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/blonde.png","lpc/spritesheets/hair/braid2/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/blonde.png.json","lpc/spritesheets/hair/braid2/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/blue.png","lpc/spritesheets/hair/braid2/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/blue.png.json","lpc/spritesheets/hair/braid2/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/dark_brown.png","lpc/spritesheets/hair/braid2/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/dark_brown.png.json","lpc/spritesheets/hair/braid2/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/gold.png","lpc/spritesheets/hair/braid2/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/gold.png.json","lpc/spritesheets/hair/braid2/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/gray.png","lpc/spritesheets/hair/braid2/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/gray.png.json","lpc/spritesheets/hair/braid2/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/green.png","lpc/spritesheets/hair/braid2/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/green.png.json","lpc/spritesheets/hair/braid2/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/light_brown.png","lpc/spritesheets/hair/braid2/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/light_brown.png.json","lpc/spritesheets/hair/braid2/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/orange.png","lpc/spritesheets/hair/braid2/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/orange.png.json","lpc/spritesheets/hair/braid2/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/purple.png","lpc/spritesheets/hair/braid2/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/purple.png.json","lpc/spritesheets/hair/braid2/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/red.png","lpc/spritesheets/hair/braid2/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/red.png.json","lpc/spritesheets/hair/braid2/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/white.png","lpc/spritesheets/hair/braid2/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/female/white.png.json","lpc/spritesheets/hair/braid2/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/black.png","lpc/spritesheets/hair/braid2/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/black.png.json","lpc/spritesheets/hair/braid2/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/blonde.png","lpc/spritesheets/hair/braid2/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/blonde.png.json","lpc/spritesheets/hair/braid2/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/blue.png","lpc/spritesheets/hair/braid2/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/blue.png.json","lpc/spritesheets/hair/braid2/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/dark_brown.png","lpc/spritesheets/hair/braid2/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/dark_brown.png.json","lpc/spritesheets/hair/braid2/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/gold.png","lpc/spritesheets/hair/braid2/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/gold.png.json","lpc/spritesheets/hair/braid2/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/gray.png","lpc/spritesheets/hair/braid2/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/gray.png.json","lpc/spritesheets/hair/braid2/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/green.png","lpc/spritesheets/hair/braid2/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/green.png.json","lpc/spritesheets/hair/braid2/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/light_brown.png","lpc/spritesheets/hair/braid2/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/light_brown.png.json","lpc/spritesheets/hair/braid2/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/orange.png","lpc/spritesheets/hair/braid2/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/orange.png.json","lpc/spritesheets/hair/braid2/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/purple.png","lpc/spritesheets/hair/braid2/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/purple.png.json","lpc/spritesheets/hair/braid2/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/red.png","lpc/spritesheets/hair/braid2/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/red.png.json","lpc/spritesheets/hair/braid2/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/white.png","lpc/spritesheets/hair/braid2/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/braid2/male/white.png.json","lpc/spritesheets/hair/bunches/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/black.png","lpc/spritesheets/hair/bunches/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/black.png.json","lpc/spritesheets/hair/bunches/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/blonde.png","lpc/spritesheets/hair/bunches/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/blonde.png.json","lpc/spritesheets/hair/bunches/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/blue.png","lpc/spritesheets/hair/bunches/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/blue.png.json","lpc/spritesheets/hair/bunches/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/dark_brown.png","lpc/spritesheets/hair/bunches/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/dark_brown.png.json","lpc/spritesheets/hair/bunches/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/gold.png","lpc/spritesheets/hair/bunches/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/gold.png.json","lpc/spritesheets/hair/bunches/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/gray.png","lpc/spritesheets/hair/bunches/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/gray.png.json","lpc/spritesheets/hair/bunches/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/green.png","lpc/spritesheets/hair/bunches/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/green.png.json","lpc/spritesheets/hair/bunches/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/light_brown.png","lpc/spritesheets/hair/bunches/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/light_brown.png.json","lpc/spritesheets/hair/bunches/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/orange.png","lpc/spritesheets/hair/bunches/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/orange.png.json","lpc/spritesheets/hair/bunches/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/purple.png","lpc/spritesheets/hair/bunches/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/purple.png.json","lpc/spritesheets/hair/bunches/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/red.png","lpc/spritesheets/hair/bunches/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/red.png.json","lpc/spritesheets/hair/bunches/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/white.png","lpc/spritesheets/hair/bunches/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/female/white.png.json","lpc/spritesheets/hair/bunches/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/black.png","lpc/spritesheets/hair/bunches/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/black.png.json","lpc/spritesheets/hair/bunches/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/blonde.png","lpc/spritesheets/hair/bunches/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/blonde.png.json","lpc/spritesheets/hair/bunches/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/blue.png","lpc/spritesheets/hair/bunches/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/blue.png.json","lpc/spritesheets/hair/bunches/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/dark_brown.png","lpc/spritesheets/hair/bunches/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/dark_brown.png.json","lpc/spritesheets/hair/bunches/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/gold.png","lpc/spritesheets/hair/bunches/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/gold.png.json","lpc/spritesheets/hair/bunches/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/gray.png","lpc/spritesheets/hair/bunches/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/gray.png.json","lpc/spritesheets/hair/bunches/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/green.png","lpc/spritesheets/hair/bunches/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/green.png.json","lpc/spritesheets/hair/bunches/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/light_brown.png","lpc/spritesheets/hair/bunches/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/light_brown.png.json","lpc/spritesheets/hair/bunches/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/orange.png","lpc/spritesheets/hair/bunches/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/orange.png.json","lpc/spritesheets/hair/bunches/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/purple.png","lpc/spritesheets/hair/bunches/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/purple.png.json","lpc/spritesheets/hair/bunches/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/red.png","lpc/spritesheets/hair/bunches/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/red.png.json","lpc/spritesheets/hair/bunches/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/white.png","lpc/spritesheets/hair/bunches/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/bunches/male/white.png.json","lpc/spritesheets/hair/buzzcut/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/black.png","lpc/spritesheets/hair/buzzcut/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/black.png.json","lpc/spritesheets/hair/buzzcut/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/blonde.png","lpc/spritesheets/hair/buzzcut/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/blonde.png.json","lpc/spritesheets/hair/buzzcut/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/blue.png","lpc/spritesheets/hair/buzzcut/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/blue.png.json","lpc/spritesheets/hair/buzzcut/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/dark_brown.png","lpc/spritesheets/hair/buzzcut/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/dark_brown.png.json","lpc/spritesheets/hair/buzzcut/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/gold.png","lpc/spritesheets/hair/buzzcut/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/gold.png.json","lpc/spritesheets/hair/buzzcut/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/gray.png","lpc/spritesheets/hair/buzzcut/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/gray.png.json","lpc/spritesheets/hair/buzzcut/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/green.png","lpc/spritesheets/hair/buzzcut/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/green.png.json","lpc/spritesheets/hair/buzzcut/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/light_brown.png","lpc/spritesheets/hair/buzzcut/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/light_brown.png.json","lpc/spritesheets/hair/buzzcut/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/orange.png","lpc/spritesheets/hair/buzzcut/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/orange.png.json","lpc/spritesheets/hair/buzzcut/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/purple.png","lpc/spritesheets/hair/buzzcut/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/purple.png.json","lpc/spritesheets/hair/buzzcut/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/red.png","lpc/spritesheets/hair/buzzcut/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/red.png.json","lpc/spritesheets/hair/buzzcut/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/white.png","lpc/spritesheets/hair/buzzcut/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/female/white.png.json","lpc/spritesheets/hair/buzzcut/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/black.png","lpc/spritesheets/hair/buzzcut/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/black.png.json","lpc/spritesheets/hair/buzzcut/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/blonde.png","lpc/spritesheets/hair/buzzcut/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/blonde.png.json","lpc/spritesheets/hair/buzzcut/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/blue.png","lpc/spritesheets/hair/buzzcut/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/blue.png.json","lpc/spritesheets/hair/buzzcut/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/dark_brown.png","lpc/spritesheets/hair/buzzcut/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/dark_brown.png.json","lpc/spritesheets/hair/buzzcut/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/gold.png","lpc/spritesheets/hair/buzzcut/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/gold.png.json","lpc/spritesheets/hair/buzzcut/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/gray.png","lpc/spritesheets/hair/buzzcut/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/gray.png.json","lpc/spritesheets/hair/buzzcut/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/green.png","lpc/spritesheets/hair/buzzcut/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/green.png.json","lpc/spritesheets/hair/buzzcut/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/light_brown.png","lpc/spritesheets/hair/buzzcut/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/light_brown.png.json","lpc/spritesheets/hair/buzzcut/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/orange.png","lpc/spritesheets/hair/buzzcut/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/orange.png.json","lpc/spritesheets/hair/buzzcut/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/purple.png","lpc/spritesheets/hair/buzzcut/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/purple.png.json","lpc/spritesheets/hair/buzzcut/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/red.png","lpc/spritesheets/hair/buzzcut/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/red.png.json","lpc/spritesheets/hair/buzzcut/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/white.png","lpc/spritesheets/hair/buzzcut/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/buzzcut/male/white.png.json","lpc/spritesheets/hair/cornrows/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/black.png","lpc/spritesheets/hair/cornrows/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/black.png.json","lpc/spritesheets/hair/cornrows/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/blonde.png","lpc/spritesheets/hair/cornrows/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/blonde.png.json","lpc/spritesheets/hair/cornrows/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/blue.png","lpc/spritesheets/hair/cornrows/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/blue.png.json","lpc/spritesheets/hair/cornrows/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/dark_brown.png","lpc/spritesheets/hair/cornrows/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/dark_brown.png.json","lpc/spritesheets/hair/cornrows/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/gold.png","lpc/spritesheets/hair/cornrows/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/gold.png.json","lpc/spritesheets/hair/cornrows/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/gray.png","lpc/spritesheets/hair/cornrows/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/gray.png.json","lpc/spritesheets/hair/cornrows/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/green.png","lpc/spritesheets/hair/cornrows/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/green.png.json","lpc/spritesheets/hair/cornrows/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/light_brown.png","lpc/spritesheets/hair/cornrows/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/light_brown.png.json","lpc/spritesheets/hair/cornrows/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/orange.png","lpc/spritesheets/hair/cornrows/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/orange.png.json","lpc/spritesheets/hair/cornrows/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/purple.png","lpc/spritesheets/hair/cornrows/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/purple.png.json","lpc/spritesheets/hair/cornrows/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/red.png","lpc/spritesheets/hair/cornrows/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/red.png.json","lpc/spritesheets/hair/cornrows/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/white.png","lpc/spritesheets/hair/cornrows/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/female/white.png.json","lpc/spritesheets/hair/cornrows/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/black.png","lpc/spritesheets/hair/cornrows/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/black.png.json","lpc/spritesheets/hair/cornrows/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/blonde.png","lpc/spritesheets/hair/cornrows/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/blonde.png.json","lpc/spritesheets/hair/cornrows/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/blue.png","lpc/spritesheets/hair/cornrows/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/blue.png.json","lpc/spritesheets/hair/cornrows/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/dark_brown.png","lpc/spritesheets/hair/cornrows/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/dark_brown.png.json","lpc/spritesheets/hair/cornrows/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/gold.png","lpc/spritesheets/hair/cornrows/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/gold.png.json","lpc/spritesheets/hair/cornrows/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/gray.png","lpc/spritesheets/hair/cornrows/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/gray.png.json","lpc/spritesheets/hair/cornrows/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/green.png","lpc/spritesheets/hair/cornrows/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/green.png.json","lpc/spritesheets/hair/cornrows/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/light_brown.png","lpc/spritesheets/hair/cornrows/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/light_brown.png.json","lpc/spritesheets/hair/cornrows/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/orange.png","lpc/spritesheets/hair/cornrows/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/orange.png.json","lpc/spritesheets/hair/cornrows/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/purple.png","lpc/spritesheets/hair/cornrows/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/purple.png.json","lpc/spritesheets/hair/cornrows/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/red.png","lpc/spritesheets/hair/cornrows/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/red.png.json","lpc/spritesheets/hair/cornrows/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/white.png","lpc/spritesheets/hair/cornrows/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cornrows/male/white.png.json","lpc/spritesheets/hair/cowlick/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/black.png","lpc/spritesheets/hair/cowlick/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/black.png.json","lpc/spritesheets/hair/cowlick/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/blonde.png","lpc/spritesheets/hair/cowlick/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/blonde.png.json","lpc/spritesheets/hair/cowlick/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/blue.png","lpc/spritesheets/hair/cowlick/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/blue.png.json","lpc/spritesheets/hair/cowlick/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/dark_brown.png","lpc/spritesheets/hair/cowlick/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/dark_brown.png.json","lpc/spritesheets/hair/cowlick/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/gold.png","lpc/spritesheets/hair/cowlick/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/gold.png.json","lpc/spritesheets/hair/cowlick/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/gray.png","lpc/spritesheets/hair/cowlick/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/gray.png.json","lpc/spritesheets/hair/cowlick/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/green.png","lpc/spritesheets/hair/cowlick/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/green.png.json","lpc/spritesheets/hair/cowlick/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/light_brown.png","lpc/spritesheets/hair/cowlick/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/light_brown.png.json","lpc/spritesheets/hair/cowlick/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/orange.png","lpc/spritesheets/hair/cowlick/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/orange.png.json","lpc/spritesheets/hair/cowlick/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/purple.png","lpc/spritesheets/hair/cowlick/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/purple.png.json","lpc/spritesheets/hair/cowlick/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/red.png","lpc/spritesheets/hair/cowlick/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/red.png.json","lpc/spritesheets/hair/cowlick/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/white.png","lpc/spritesheets/hair/cowlick/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/female/white.png.json","lpc/spritesheets/hair/cowlick/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/black.png","lpc/spritesheets/hair/cowlick/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/black.png.json","lpc/spritesheets/hair/cowlick/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/blonde.png","lpc/spritesheets/hair/cowlick/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/blonde.png.json","lpc/spritesheets/hair/cowlick/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/blue.png","lpc/spritesheets/hair/cowlick/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/blue.png.json","lpc/spritesheets/hair/cowlick/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/dark_brown.png","lpc/spritesheets/hair/cowlick/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/dark_brown.png.json","lpc/spritesheets/hair/cowlick/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/gold.png","lpc/spritesheets/hair/cowlick/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/gold.png.json","lpc/spritesheets/hair/cowlick/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/gray.png","lpc/spritesheets/hair/cowlick/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/gray.png.json","lpc/spritesheets/hair/cowlick/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/green.png","lpc/spritesheets/hair/cowlick/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/green.png.json","lpc/spritesheets/hair/cowlick/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/light_brown.png","lpc/spritesheets/hair/cowlick/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/light_brown.png.json","lpc/spritesheets/hair/cowlick/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/orange.png","lpc/spritesheets/hair/cowlick/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/orange.png.json","lpc/spritesheets/hair/cowlick/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/purple.png","lpc/spritesheets/hair/cowlick/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/purple.png.json","lpc/spritesheets/hair/cowlick/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/red.png","lpc/spritesheets/hair/cowlick/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/red.png.json","lpc/spritesheets/hair/cowlick/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/white.png","lpc/spritesheets/hair/cowlick/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick/male/white.png.json","lpc/spritesheets/hair/cowlick_tall/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/black.png","lpc/spritesheets/hair/cowlick_tall/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/black.png.json","lpc/spritesheets/hair/cowlick_tall/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/blonde.png","lpc/spritesheets/hair/cowlick_tall/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/blonde.png.json","lpc/spritesheets/hair/cowlick_tall/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/blue.png","lpc/spritesheets/hair/cowlick_tall/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/blue.png.json","lpc/spritesheets/hair/cowlick_tall/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/dark_brown.png","lpc/spritesheets/hair/cowlick_tall/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/dark_brown.png.json","lpc/spritesheets/hair/cowlick_tall/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/gold.png","lpc/spritesheets/hair/cowlick_tall/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/gold.png.json","lpc/spritesheets/hair/cowlick_tall/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/gray.png","lpc/spritesheets/hair/cowlick_tall/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/gray.png.json","lpc/spritesheets/hair/cowlick_tall/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/green.png","lpc/spritesheets/hair/cowlick_tall/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/green.png.json","lpc/spritesheets/hair/cowlick_tall/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/light_brown.png","lpc/spritesheets/hair/cowlick_tall/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/light_brown.png.json","lpc/spritesheets/hair/cowlick_tall/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/orange.png","lpc/spritesheets/hair/cowlick_tall/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/orange.png.json","lpc/spritesheets/hair/cowlick_tall/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/purple.png","lpc/spritesheets/hair/cowlick_tall/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/purple.png.json","lpc/spritesheets/hair/cowlick_tall/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/red.png","lpc/spritesheets/hair/cowlick_tall/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/red.png.json","lpc/spritesheets/hair/cowlick_tall/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/white.png","lpc/spritesheets/hair/cowlick_tall/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/female/white.png.json","lpc/spritesheets/hair/cowlick_tall/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/black.png","lpc/spritesheets/hair/cowlick_tall/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/black.png.json","lpc/spritesheets/hair/cowlick_tall/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/blonde.png","lpc/spritesheets/hair/cowlick_tall/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/blonde.png.json","lpc/spritesheets/hair/cowlick_tall/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/blue.png","lpc/spritesheets/hair/cowlick_tall/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/blue.png.json","lpc/spritesheets/hair/cowlick_tall/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/dark_brown.png","lpc/spritesheets/hair/cowlick_tall/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/dark_brown.png.json","lpc/spritesheets/hair/cowlick_tall/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/gold.png","lpc/spritesheets/hair/cowlick_tall/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/gold.png.json","lpc/spritesheets/hair/cowlick_tall/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/gray.png","lpc/spritesheets/hair/cowlick_tall/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/gray.png.json","lpc/spritesheets/hair/cowlick_tall/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/green.png","lpc/spritesheets/hair/cowlick_tall/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/green.png.json","lpc/spritesheets/hair/cowlick_tall/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/light_brown.png","lpc/spritesheets/hair/cowlick_tall/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/light_brown.png.json","lpc/spritesheets/hair/cowlick_tall/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/orange.png","lpc/spritesheets/hair/cowlick_tall/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/orange.png.json","lpc/spritesheets/hair/cowlick_tall/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/purple.png","lpc/spritesheets/hair/cowlick_tall/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/purple.png.json","lpc/spritesheets/hair/cowlick_tall/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/red.png","lpc/spritesheets/hair/cowlick_tall/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/red.png.json","lpc/spritesheets/hair/cowlick_tall/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/white.png","lpc/spritesheets/hair/cowlick_tall/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/cowlick_tall/male/white.png.json","lpc/spritesheets/hair/curly_long/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/black.png","lpc/spritesheets/hair/curly_long/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/black.png.json","lpc/spritesheets/hair/curly_long/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/blonde.png","lpc/spritesheets/hair/curly_long/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/blonde.png.json","lpc/spritesheets/hair/curly_long/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/blue.png","lpc/spritesheets/hair/curly_long/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/blue.png.json","lpc/spritesheets/hair/curly_long/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/dark_brown.png","lpc/spritesheets/hair/curly_long/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/dark_brown.png.json","lpc/spritesheets/hair/curly_long/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/gold.png","lpc/spritesheets/hair/curly_long/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/gold.png.json","lpc/spritesheets/hair/curly_long/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/gray.png","lpc/spritesheets/hair/curly_long/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/gray.png.json","lpc/spritesheets/hair/curly_long/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/green.png","lpc/spritesheets/hair/curly_long/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/green.png.json","lpc/spritesheets/hair/curly_long/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/light_brown.png","lpc/spritesheets/hair/curly_long/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/light_brown.png.json","lpc/spritesheets/hair/curly_long/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/orange.png","lpc/spritesheets/hair/curly_long/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/orange.png.json","lpc/spritesheets/hair/curly_long/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/purple.png","lpc/spritesheets/hair/curly_long/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/purple.png.json","lpc/spritesheets/hair/curly_long/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/red.png","lpc/spritesheets/hair/curly_long/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/red.png.json","lpc/spritesheets/hair/curly_long/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/white.png","lpc/spritesheets/hair/curly_long/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/female/white.png.json","lpc/spritesheets/hair/curly_long/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/black.png","lpc/spritesheets/hair/curly_long/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/black.png.json","lpc/spritesheets/hair/curly_long/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/blonde.png","lpc/spritesheets/hair/curly_long/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/blonde.png.json","lpc/spritesheets/hair/curly_long/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/blue.png","lpc/spritesheets/hair/curly_long/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/blue.png.json","lpc/spritesheets/hair/curly_long/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/dark_brown.png","lpc/spritesheets/hair/curly_long/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/dark_brown.png.json","lpc/spritesheets/hair/curly_long/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/gold.png","lpc/spritesheets/hair/curly_long/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/gold.png.json","lpc/spritesheets/hair/curly_long/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/gray.png","lpc/spritesheets/hair/curly_long/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/gray.png.json","lpc/spritesheets/hair/curly_long/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/green.png","lpc/spritesheets/hair/curly_long/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/green.png.json","lpc/spritesheets/hair/curly_long/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/light_brown.png","lpc/spritesheets/hair/curly_long/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/light_brown.png.json","lpc/spritesheets/hair/curly_long/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/orange.png","lpc/spritesheets/hair/curly_long/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/orange.png.json","lpc/spritesheets/hair/curly_long/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/purple.png","lpc/spritesheets/hair/curly_long/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/purple.png.json","lpc/spritesheets/hair/curly_long/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/red.png","lpc/spritesheets/hair/curly_long/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/red.png.json","lpc/spritesheets/hair/curly_long/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/white.png","lpc/spritesheets/hair/curly_long/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_long/male/white.png.json","lpc/spritesheets/hair/curly_short/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/black.png","lpc/spritesheets/hair/curly_short/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/black.png.json","lpc/spritesheets/hair/curly_short/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/blonde.png","lpc/spritesheets/hair/curly_short/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/blonde.png.json","lpc/spritesheets/hair/curly_short/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/blue.png","lpc/spritesheets/hair/curly_short/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/blue.png.json","lpc/spritesheets/hair/curly_short/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/dark_brown.png","lpc/spritesheets/hair/curly_short/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/dark_brown.png.json","lpc/spritesheets/hair/curly_short/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/gold.png","lpc/spritesheets/hair/curly_short/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/gold.png.json","lpc/spritesheets/hair/curly_short/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/gray.png","lpc/spritesheets/hair/curly_short/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/gray.png.json","lpc/spritesheets/hair/curly_short/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/green.png","lpc/spritesheets/hair/curly_short/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/green.png.json","lpc/spritesheets/hair/curly_short/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/light_brown.png","lpc/spritesheets/hair/curly_short/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/light_brown.png.json","lpc/spritesheets/hair/curly_short/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/orange.png","lpc/spritesheets/hair/curly_short/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/orange.png.json","lpc/spritesheets/hair/curly_short/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/purple.png","lpc/spritesheets/hair/curly_short/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/purple.png.json","lpc/spritesheets/hair/curly_short/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/red.png","lpc/spritesheets/hair/curly_short/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/red.png.json","lpc/spritesheets/hair/curly_short/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/white.png","lpc/spritesheets/hair/curly_short/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/female/white.png.json","lpc/spritesheets/hair/curly_short/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/black.png","lpc/spritesheets/hair/curly_short/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/black.png.json","lpc/spritesheets/hair/curly_short/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/blonde.png","lpc/spritesheets/hair/curly_short/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/blonde.png.json","lpc/spritesheets/hair/curly_short/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/blue.png","lpc/spritesheets/hair/curly_short/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/blue.png.json","lpc/spritesheets/hair/curly_short/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/dark_brown.png","lpc/spritesheets/hair/curly_short/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/dark_brown.png.json","lpc/spritesheets/hair/curly_short/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/gold.png","lpc/spritesheets/hair/curly_short/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/gold.png.json","lpc/spritesheets/hair/curly_short/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/gray.png","lpc/spritesheets/hair/curly_short/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/gray.png.json","lpc/spritesheets/hair/curly_short/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/green.png","lpc/spritesheets/hair/curly_short/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/green.png.json","lpc/spritesheets/hair/curly_short/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/light_brown.png","lpc/spritesheets/hair/curly_short/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/light_brown.png.json","lpc/spritesheets/hair/curly_short/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/orange.png","lpc/spritesheets/hair/curly_short/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/orange.png.json","lpc/spritesheets/hair/curly_short/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/purple.png","lpc/spritesheets/hair/curly_short/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/purple.png.json","lpc/spritesheets/hair/curly_short/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/red.png","lpc/spritesheets/hair/curly_short/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/red.png.json","lpc/spritesheets/hair/curly_short/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/white.png","lpc/spritesheets/hair/curly_short/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curly_short/male/white.png.json","lpc/spritesheets/hair/curtains/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/black.png","lpc/spritesheets/hair/curtains/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/black.png.json","lpc/spritesheets/hair/curtains/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/blonde.png","lpc/spritesheets/hair/curtains/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/blonde.png.json","lpc/spritesheets/hair/curtains/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/blue.png","lpc/spritesheets/hair/curtains/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/blue.png.json","lpc/spritesheets/hair/curtains/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/dark_brown.png","lpc/spritesheets/hair/curtains/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/dark_brown.png.json","lpc/spritesheets/hair/curtains/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/gold.png","lpc/spritesheets/hair/curtains/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/gold.png.json","lpc/spritesheets/hair/curtains/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/gray.png","lpc/spritesheets/hair/curtains/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/gray.png.json","lpc/spritesheets/hair/curtains/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/green.png","lpc/spritesheets/hair/curtains/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/green.png.json","lpc/spritesheets/hair/curtains/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/light_brown.png","lpc/spritesheets/hair/curtains/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/light_brown.png.json","lpc/spritesheets/hair/curtains/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/orange.png","lpc/spritesheets/hair/curtains/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/orange.png.json","lpc/spritesheets/hair/curtains/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/purple.png","lpc/spritesheets/hair/curtains/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/purple.png.json","lpc/spritesheets/hair/curtains/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/red.png","lpc/spritesheets/hair/curtains/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/red.png.json","lpc/spritesheets/hair/curtains/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/white.png","lpc/spritesheets/hair/curtains/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/female/white.png.json","lpc/spritesheets/hair/curtains/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/black.png","lpc/spritesheets/hair/curtains/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/black.png.json","lpc/spritesheets/hair/curtains/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/blonde.png","lpc/spritesheets/hair/curtains/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/blonde.png.json","lpc/spritesheets/hair/curtains/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/blue.png","lpc/spritesheets/hair/curtains/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/blue.png.json","lpc/spritesheets/hair/curtains/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/dark_brown.png","lpc/spritesheets/hair/curtains/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/dark_brown.png.json","lpc/spritesheets/hair/curtains/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/gold.png","lpc/spritesheets/hair/curtains/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/gold.png.json","lpc/spritesheets/hair/curtains/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/gray.png","lpc/spritesheets/hair/curtains/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/gray.png.json","lpc/spritesheets/hair/curtains/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/green.png","lpc/spritesheets/hair/curtains/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/green.png.json","lpc/spritesheets/hair/curtains/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/light_brown.png","lpc/spritesheets/hair/curtains/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/light_brown.png.json","lpc/spritesheets/hair/curtains/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/orange.png","lpc/spritesheets/hair/curtains/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/orange.png.json","lpc/spritesheets/hair/curtains/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/purple.png","lpc/spritesheets/hair/curtains/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/purple.png.json","lpc/spritesheets/hair/curtains/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/red.png","lpc/spritesheets/hair/curtains/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/red.png.json","lpc/spritesheets/hair/curtains/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/white.png","lpc/spritesheets/hair/curtains/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains/male/white.png.json","lpc/spritesheets/hair/curtains_long/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/black.png","lpc/spritesheets/hair/curtains_long/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/black.png.json","lpc/spritesheets/hair/curtains_long/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/blonde.png","lpc/spritesheets/hair/curtains_long/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/blonde.png.json","lpc/spritesheets/hair/curtains_long/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/blue.png","lpc/spritesheets/hair/curtains_long/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/blue.png.json","lpc/spritesheets/hair/curtains_long/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/dark_brown.png","lpc/spritesheets/hair/curtains_long/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/dark_brown.png.json","lpc/spritesheets/hair/curtains_long/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/gold.png","lpc/spritesheets/hair/curtains_long/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/gold.png.json","lpc/spritesheets/hair/curtains_long/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/gray.png","lpc/spritesheets/hair/curtains_long/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/gray.png.json","lpc/spritesheets/hair/curtains_long/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/green.png","lpc/spritesheets/hair/curtains_long/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/green.png.json","lpc/spritesheets/hair/curtains_long/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/light_brown.png","lpc/spritesheets/hair/curtains_long/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/light_brown.png.json","lpc/spritesheets/hair/curtains_long/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/orange.png","lpc/spritesheets/hair/curtains_long/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/orange.png.json","lpc/spritesheets/hair/curtains_long/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/purple.png","lpc/spritesheets/hair/curtains_long/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/purple.png.json","lpc/spritesheets/hair/curtains_long/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/red.png","lpc/spritesheets/hair/curtains_long/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/red.png.json","lpc/spritesheets/hair/curtains_long/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/white.png","lpc/spritesheets/hair/curtains_long/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/female/white.png.json","lpc/spritesheets/hair/curtains_long/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/black.png","lpc/spritesheets/hair/curtains_long/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/black.png.json","lpc/spritesheets/hair/curtains_long/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/blonde.png","lpc/spritesheets/hair/curtains_long/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/blonde.png.json","lpc/spritesheets/hair/curtains_long/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/blue.png","lpc/spritesheets/hair/curtains_long/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/blue.png.json","lpc/spritesheets/hair/curtains_long/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/dark_brown.png","lpc/spritesheets/hair/curtains_long/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/dark_brown.png.json","lpc/spritesheets/hair/curtains_long/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/gold.png","lpc/spritesheets/hair/curtains_long/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/gold.png.json","lpc/spritesheets/hair/curtains_long/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/gray.png","lpc/spritesheets/hair/curtains_long/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/gray.png.json","lpc/spritesheets/hair/curtains_long/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/green.png","lpc/spritesheets/hair/curtains_long/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/green.png.json","lpc/spritesheets/hair/curtains_long/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/light_brown.png","lpc/spritesheets/hair/curtains_long/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/light_brown.png.json","lpc/spritesheets/hair/curtains_long/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/orange.png","lpc/spritesheets/hair/curtains_long/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/orange.png.json","lpc/spritesheets/hair/curtains_long/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/purple.png","lpc/spritesheets/hair/curtains_long/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/purple.png.json","lpc/spritesheets/hair/curtains_long/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/red.png","lpc/spritesheets/hair/curtains_long/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/red.png.json","lpc/spritesheets/hair/curtains_long/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/white.png","lpc/spritesheets/hair/curtains_long/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/curtains_long/male/white.png.json","lpc/spritesheets/hair/dreadlocks_long/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/black.png","lpc/spritesheets/hair/dreadlocks_long/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/black.png.json","lpc/spritesheets/hair/dreadlocks_long/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/blonde.png","lpc/spritesheets/hair/dreadlocks_long/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/blonde.png.json","lpc/spritesheets/hair/dreadlocks_long/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/blue.png","lpc/spritesheets/hair/dreadlocks_long/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/blue.png.json","lpc/spritesheets/hair/dreadlocks_long/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/dark_brown.png","lpc/spritesheets/hair/dreadlocks_long/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/dark_brown.png.json","lpc/spritesheets/hair/dreadlocks_long/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/gold.png","lpc/spritesheets/hair/dreadlocks_long/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/gold.png.json","lpc/spritesheets/hair/dreadlocks_long/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/gray.png","lpc/spritesheets/hair/dreadlocks_long/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/gray.png.json","lpc/spritesheets/hair/dreadlocks_long/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/green.png","lpc/spritesheets/hair/dreadlocks_long/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/green.png.json","lpc/spritesheets/hair/dreadlocks_long/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/light_brown.png","lpc/spritesheets/hair/dreadlocks_long/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/light_brown.png.json","lpc/spritesheets/hair/dreadlocks_long/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/orange.png","lpc/spritesheets/hair/dreadlocks_long/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/orange.png.json","lpc/spritesheets/hair/dreadlocks_long/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/purple.png","lpc/spritesheets/hair/dreadlocks_long/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/purple.png.json","lpc/spritesheets/hair/dreadlocks_long/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/red.png","lpc/spritesheets/hair/dreadlocks_long/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/red.png.json","lpc/spritesheets/hair/dreadlocks_long/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/white.png","lpc/spritesheets/hair/dreadlocks_long/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/female/white.png.json","lpc/spritesheets/hair/dreadlocks_long/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/black.png","lpc/spritesheets/hair/dreadlocks_long/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/black.png.json","lpc/spritesheets/hair/dreadlocks_long/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/blonde.png","lpc/spritesheets/hair/dreadlocks_long/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/blonde.png.json","lpc/spritesheets/hair/dreadlocks_long/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/blue.png","lpc/spritesheets/hair/dreadlocks_long/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/blue.png.json","lpc/spritesheets/hair/dreadlocks_long/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/dark_brown.png","lpc/spritesheets/hair/dreadlocks_long/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/dark_brown.png.json","lpc/spritesheets/hair/dreadlocks_long/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/gold.png","lpc/spritesheets/hair/dreadlocks_long/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/gold.png.json","lpc/spritesheets/hair/dreadlocks_long/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/gray.png","lpc/spritesheets/hair/dreadlocks_long/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/gray.png.json","lpc/spritesheets/hair/dreadlocks_long/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/green.png","lpc/spritesheets/hair/dreadlocks_long/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/green.png.json","lpc/spritesheets/hair/dreadlocks_long/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/light_brown.png","lpc/spritesheets/hair/dreadlocks_long/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/light_brown.png.json","lpc/spritesheets/hair/dreadlocks_long/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/orange.png","lpc/spritesheets/hair/dreadlocks_long/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/orange.png.json","lpc/spritesheets/hair/dreadlocks_long/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/purple.png","lpc/spritesheets/hair/dreadlocks_long/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/purple.png.json","lpc/spritesheets/hair/dreadlocks_long/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/red.png","lpc/spritesheets/hair/dreadlocks_long/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/red.png.json","lpc/spritesheets/hair/dreadlocks_long/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/white.png","lpc/spritesheets/hair/dreadlocks_long/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_long/male/white.png.json","lpc/spritesheets/hair/dreadlocks_short/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/black.png","lpc/spritesheets/hair/dreadlocks_short/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/black.png.json","lpc/spritesheets/hair/dreadlocks_short/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/blonde.png","lpc/spritesheets/hair/dreadlocks_short/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/blonde.png.json","lpc/spritesheets/hair/dreadlocks_short/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/blue.png","lpc/spritesheets/hair/dreadlocks_short/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/blue.png.json","lpc/spritesheets/hair/dreadlocks_short/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/dark_brown.png","lpc/spritesheets/hair/dreadlocks_short/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/dark_brown.png.json","lpc/spritesheets/hair/dreadlocks_short/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/gold.png","lpc/spritesheets/hair/dreadlocks_short/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/gold.png.json","lpc/spritesheets/hair/dreadlocks_short/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/gray.png","lpc/spritesheets/hair/dreadlocks_short/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/gray.png.json","lpc/spritesheets/hair/dreadlocks_short/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/green.png","lpc/spritesheets/hair/dreadlocks_short/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/green.png.json","lpc/spritesheets/hair/dreadlocks_short/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/light_brown.png","lpc/spritesheets/hair/dreadlocks_short/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/light_brown.png.json","lpc/spritesheets/hair/dreadlocks_short/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/orange.png","lpc/spritesheets/hair/dreadlocks_short/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/orange.png.json","lpc/spritesheets/hair/dreadlocks_short/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/purple.png","lpc/spritesheets/hair/dreadlocks_short/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/purple.png.json","lpc/spritesheets/hair/dreadlocks_short/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/red.png","lpc/spritesheets/hair/dreadlocks_short/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/red.png.json","lpc/spritesheets/hair/dreadlocks_short/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/white.png","lpc/spritesheets/hair/dreadlocks_short/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/female/white.png.json","lpc/spritesheets/hair/dreadlocks_short/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/black.png","lpc/spritesheets/hair/dreadlocks_short/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/black.png.json","lpc/spritesheets/hair/dreadlocks_short/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/blonde.png","lpc/spritesheets/hair/dreadlocks_short/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/blonde.png.json","lpc/spritesheets/hair/dreadlocks_short/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/blue.png","lpc/spritesheets/hair/dreadlocks_short/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/blue.png.json","lpc/spritesheets/hair/dreadlocks_short/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/dark_brown.png","lpc/spritesheets/hair/dreadlocks_short/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/dark_brown.png.json","lpc/spritesheets/hair/dreadlocks_short/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/gold.png","lpc/spritesheets/hair/dreadlocks_short/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/gold.png.json","lpc/spritesheets/hair/dreadlocks_short/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/gray.png","lpc/spritesheets/hair/dreadlocks_short/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/gray.png.json","lpc/spritesheets/hair/dreadlocks_short/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/green.png","lpc/spritesheets/hair/dreadlocks_short/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/green.png.json","lpc/spritesheets/hair/dreadlocks_short/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/light_brown.png","lpc/spritesheets/hair/dreadlocks_short/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/light_brown.png.json","lpc/spritesheets/hair/dreadlocks_short/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/orange.png","lpc/spritesheets/hair/dreadlocks_short/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/orange.png.json","lpc/spritesheets/hair/dreadlocks_short/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/purple.png","lpc/spritesheets/hair/dreadlocks_short/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/purple.png.json","lpc/spritesheets/hair/dreadlocks_short/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/red.png","lpc/spritesheets/hair/dreadlocks_short/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/red.png.json","lpc/spritesheets/hair/dreadlocks_short/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/white.png","lpc/spritesheets/hair/dreadlocks_short/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/dreadlocks_short/male/white.png.json","lpc/spritesheets/hair/flat_top_fade/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/black.png","lpc/spritesheets/hair/flat_top_fade/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/black.png.json","lpc/spritesheets/hair/flat_top_fade/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/blonde.png","lpc/spritesheets/hair/flat_top_fade/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/blonde.png.json","lpc/spritesheets/hair/flat_top_fade/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/blue.png","lpc/spritesheets/hair/flat_top_fade/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/blue.png.json","lpc/spritesheets/hair/flat_top_fade/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/dark_brown.png","lpc/spritesheets/hair/flat_top_fade/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/dark_brown.png.json","lpc/spritesheets/hair/flat_top_fade/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/gold.png","lpc/spritesheets/hair/flat_top_fade/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/gold.png.json","lpc/spritesheets/hair/flat_top_fade/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/gray.png","lpc/spritesheets/hair/flat_top_fade/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/gray.png.json","lpc/spritesheets/hair/flat_top_fade/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/green.png","lpc/spritesheets/hair/flat_top_fade/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/green.png.json","lpc/spritesheets/hair/flat_top_fade/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/light_brown.png","lpc/spritesheets/hair/flat_top_fade/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/light_brown.png.json","lpc/spritesheets/hair/flat_top_fade/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/orange.png","lpc/spritesheets/hair/flat_top_fade/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/orange.png.json","lpc/spritesheets/hair/flat_top_fade/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/purple.png","lpc/spritesheets/hair/flat_top_fade/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/purple.png.json","lpc/spritesheets/hair/flat_top_fade/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/red.png","lpc/spritesheets/hair/flat_top_fade/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/red.png.json","lpc/spritesheets/hair/flat_top_fade/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/white.png","lpc/spritesheets/hair/flat_top_fade/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/female/white.png.json","lpc/spritesheets/hair/flat_top_fade/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/black.png","lpc/spritesheets/hair/flat_top_fade/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/black.png.json","lpc/spritesheets/hair/flat_top_fade/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/blonde.png","lpc/spritesheets/hair/flat_top_fade/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/blonde.png.json","lpc/spritesheets/hair/flat_top_fade/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/blue.png","lpc/spritesheets/hair/flat_top_fade/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/blue.png.json","lpc/spritesheets/hair/flat_top_fade/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/dark_brown.png","lpc/spritesheets/hair/flat_top_fade/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/dark_brown.png.json","lpc/spritesheets/hair/flat_top_fade/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/gold.png","lpc/spritesheets/hair/flat_top_fade/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/gold.png.json","lpc/spritesheets/hair/flat_top_fade/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/gray.png","lpc/spritesheets/hair/flat_top_fade/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/gray.png.json","lpc/spritesheets/hair/flat_top_fade/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/green.png","lpc/spritesheets/hair/flat_top_fade/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/green.png.json","lpc/spritesheets/hair/flat_top_fade/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/light_brown.png","lpc/spritesheets/hair/flat_top_fade/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/light_brown.png.json","lpc/spritesheets/hair/flat_top_fade/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/orange.png","lpc/spritesheets/hair/flat_top_fade/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/orange.png.json","lpc/spritesheets/hair/flat_top_fade/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/purple.png","lpc/spritesheets/hair/flat_top_fade/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/purple.png.json","lpc/spritesheets/hair/flat_top_fade/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/red.png","lpc/spritesheets/hair/flat_top_fade/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/red.png.json","lpc/spritesheets/hair/flat_top_fade/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/white.png","lpc/spritesheets/hair/flat_top_fade/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_fade/male/white.png.json","lpc/spritesheets/hair/flat_top_straight/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/black.png","lpc/spritesheets/hair/flat_top_straight/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/black.png.json","lpc/spritesheets/hair/flat_top_straight/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/blonde.png","lpc/spritesheets/hair/flat_top_straight/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/blonde.png.json","lpc/spritesheets/hair/flat_top_straight/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/blue.png","lpc/spritesheets/hair/flat_top_straight/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/blue.png.json","lpc/spritesheets/hair/flat_top_straight/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/dark_brown.png","lpc/spritesheets/hair/flat_top_straight/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/dark_brown.png.json","lpc/spritesheets/hair/flat_top_straight/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/gold.png","lpc/spritesheets/hair/flat_top_straight/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/gold.png.json","lpc/spritesheets/hair/flat_top_straight/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/gray.png","lpc/spritesheets/hair/flat_top_straight/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/gray.png.json","lpc/spritesheets/hair/flat_top_straight/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/green.png","lpc/spritesheets/hair/flat_top_straight/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/green.png.json","lpc/spritesheets/hair/flat_top_straight/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/light_brown.png","lpc/spritesheets/hair/flat_top_straight/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/light_brown.png.json","lpc/spritesheets/hair/flat_top_straight/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/orange.png","lpc/spritesheets/hair/flat_top_straight/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/orange.png.json","lpc/spritesheets/hair/flat_top_straight/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/purple.png","lpc/spritesheets/hair/flat_top_straight/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/purple.png.json","lpc/spritesheets/hair/flat_top_straight/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/red.png","lpc/spritesheets/hair/flat_top_straight/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/red.png.json","lpc/spritesheets/hair/flat_top_straight/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/white.png","lpc/spritesheets/hair/flat_top_straight/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/female/white.png.json","lpc/spritesheets/hair/flat_top_straight/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/black.png","lpc/spritesheets/hair/flat_top_straight/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/black.png.json","lpc/spritesheets/hair/flat_top_straight/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/blonde.png","lpc/spritesheets/hair/flat_top_straight/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/blonde.png.json","lpc/spritesheets/hair/flat_top_straight/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/blue.png","lpc/spritesheets/hair/flat_top_straight/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/blue.png.json","lpc/spritesheets/hair/flat_top_straight/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/dark_brown.png","lpc/spritesheets/hair/flat_top_straight/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/dark_brown.png.json","lpc/spritesheets/hair/flat_top_straight/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/gold.png","lpc/spritesheets/hair/flat_top_straight/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/gold.png.json","lpc/spritesheets/hair/flat_top_straight/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/gray.png","lpc/spritesheets/hair/flat_top_straight/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/gray.png.json","lpc/spritesheets/hair/flat_top_straight/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/green.png","lpc/spritesheets/hair/flat_top_straight/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/green.png.json","lpc/spritesheets/hair/flat_top_straight/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/light_brown.png","lpc/spritesheets/hair/flat_top_straight/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/light_brown.png.json","lpc/spritesheets/hair/flat_top_straight/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/orange.png","lpc/spritesheets/hair/flat_top_straight/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/orange.png.json","lpc/spritesheets/hair/flat_top_straight/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/purple.png","lpc/spritesheets/hair/flat_top_straight/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/purple.png.json","lpc/spritesheets/hair/flat_top_straight/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/red.png","lpc/spritesheets/hair/flat_top_straight/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/red.png.json","lpc/spritesheets/hair/flat_top_straight/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/white.png","lpc/spritesheets/hair/flat_top_straight/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/flat_top_straight/male/white.png.json","lpc/spritesheets/hair/half_up/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/black.png","lpc/spritesheets/hair/half_up/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/black.png.json","lpc/spritesheets/hair/half_up/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/blonde.png","lpc/spritesheets/hair/half_up/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/blonde.png.json","lpc/spritesheets/hair/half_up/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/blue.png","lpc/spritesheets/hair/half_up/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/blue.png.json","lpc/spritesheets/hair/half_up/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/dark_brown.png","lpc/spritesheets/hair/half_up/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/dark_brown.png.json","lpc/spritesheets/hair/half_up/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/gold.png","lpc/spritesheets/hair/half_up/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/gold.png.json","lpc/spritesheets/hair/half_up/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/gray.png","lpc/spritesheets/hair/half_up/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/gray.png.json","lpc/spritesheets/hair/half_up/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/green.png","lpc/spritesheets/hair/half_up/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/green.png.json","lpc/spritesheets/hair/half_up/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/light_brown.png","lpc/spritesheets/hair/half_up/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/light_brown.png.json","lpc/spritesheets/hair/half_up/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/orange.png","lpc/spritesheets/hair/half_up/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/orange.png.json","lpc/spritesheets/hair/half_up/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/purple.png","lpc/spritesheets/hair/half_up/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/purple.png.json","lpc/spritesheets/hair/half_up/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/red.png","lpc/spritesheets/hair/half_up/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/red.png.json","lpc/spritesheets/hair/half_up/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/white.png","lpc/spritesheets/hair/half_up/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/female/white.png.json","lpc/spritesheets/hair/half_up/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/black.png","lpc/spritesheets/hair/half_up/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/black.png.json","lpc/spritesheets/hair/half_up/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/blonde.png","lpc/spritesheets/hair/half_up/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/blonde.png.json","lpc/spritesheets/hair/half_up/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/blue.png","lpc/spritesheets/hair/half_up/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/blue.png.json","lpc/spritesheets/hair/half_up/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/dark_brown.png","lpc/spritesheets/hair/half_up/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/dark_brown.png.json","lpc/spritesheets/hair/half_up/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/gold.png","lpc/spritesheets/hair/half_up/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/gold.png.json","lpc/spritesheets/hair/half_up/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/gray.png","lpc/spritesheets/hair/half_up/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/gray.png.json","lpc/spritesheets/hair/half_up/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/green.png","lpc/spritesheets/hair/half_up/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/green.png.json","lpc/spritesheets/hair/half_up/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/light_brown.png","lpc/spritesheets/hair/half_up/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/light_brown.png.json","lpc/spritesheets/hair/half_up/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/orange.png","lpc/spritesheets/hair/half_up/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/orange.png.json","lpc/spritesheets/hair/half_up/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/purple.png","lpc/spritesheets/hair/half_up/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/purple.png.json","lpc/spritesheets/hair/half_up/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/red.png","lpc/spritesheets/hair/half_up/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/red.png.json","lpc/spritesheets/hair/half_up/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/white.png","lpc/spritesheets/hair/half_up/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/half_up/male/white.png.json","lpc/spritesheets/hair/halfmessy/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/black.png","lpc/spritesheets/hair/halfmessy/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/black.png.json","lpc/spritesheets/hair/halfmessy/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/blonde.png","lpc/spritesheets/hair/halfmessy/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/blonde.png.json","lpc/spritesheets/hair/halfmessy/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/blue.png","lpc/spritesheets/hair/halfmessy/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/blue.png.json","lpc/spritesheets/hair/halfmessy/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/dark_brown.png","lpc/spritesheets/hair/halfmessy/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/dark_brown.png.json","lpc/spritesheets/hair/halfmessy/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/gold.png","lpc/spritesheets/hair/halfmessy/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/gold.png.json","lpc/spritesheets/hair/halfmessy/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/gray.png","lpc/spritesheets/hair/halfmessy/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/gray.png.json","lpc/spritesheets/hair/halfmessy/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/green.png","lpc/spritesheets/hair/halfmessy/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/green.png.json","lpc/spritesheets/hair/halfmessy/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/light_brown.png","lpc/spritesheets/hair/halfmessy/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/light_brown.png.json","lpc/spritesheets/hair/halfmessy/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/orange.png","lpc/spritesheets/hair/halfmessy/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/orange.png.json","lpc/spritesheets/hair/halfmessy/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/purple.png","lpc/spritesheets/hair/halfmessy/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/purple.png.json","lpc/spritesheets/hair/halfmessy/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/red.png","lpc/spritesheets/hair/halfmessy/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/red.png.json","lpc/spritesheets/hair/halfmessy/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/white.png","lpc/spritesheets/hair/halfmessy/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/female/white.png.json","lpc/spritesheets/hair/halfmessy/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/black.png","lpc/spritesheets/hair/halfmessy/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/black.png.json","lpc/spritesheets/hair/halfmessy/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/blonde.png","lpc/spritesheets/hair/halfmessy/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/blonde.png.json","lpc/spritesheets/hair/halfmessy/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/blue.png","lpc/spritesheets/hair/halfmessy/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/blue.png.json","lpc/spritesheets/hair/halfmessy/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/dark_brown.png","lpc/spritesheets/hair/halfmessy/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/dark_brown.png.json","lpc/spritesheets/hair/halfmessy/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/gold.png","lpc/spritesheets/hair/halfmessy/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/gold.png.json","lpc/spritesheets/hair/halfmessy/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/gray.png","lpc/spritesheets/hair/halfmessy/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/gray.png.json","lpc/spritesheets/hair/halfmessy/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/green.png","lpc/spritesheets/hair/halfmessy/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/green.png.json","lpc/spritesheets/hair/halfmessy/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/light_brown.png","lpc/spritesheets/hair/halfmessy/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/light_brown.png.json","lpc/spritesheets/hair/halfmessy/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/orange.png","lpc/spritesheets/hair/halfmessy/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/orange.png.json","lpc/spritesheets/hair/halfmessy/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/purple.png","lpc/spritesheets/hair/halfmessy/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/purple.png.json","lpc/spritesheets/hair/halfmessy/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/red.png","lpc/spritesheets/hair/halfmessy/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/red.png.json","lpc/spritesheets/hair/halfmessy/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/white.png","lpc/spritesheets/hair/halfmessy/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/halfmessy/male/white.png.json","lpc/spritesheets/hair/high_and_tight/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/black.png","lpc/spritesheets/hair/high_and_tight/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/black.png.json","lpc/spritesheets/hair/high_and_tight/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/blonde.png","lpc/spritesheets/hair/high_and_tight/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/blonde.png.json","lpc/spritesheets/hair/high_and_tight/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/blue.png","lpc/spritesheets/hair/high_and_tight/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/blue.png.json","lpc/spritesheets/hair/high_and_tight/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/dark_brown.png","lpc/spritesheets/hair/high_and_tight/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/dark_brown.png.json","lpc/spritesheets/hair/high_and_tight/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/gold.png","lpc/spritesheets/hair/high_and_tight/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/gold.png.json","lpc/spritesheets/hair/high_and_tight/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/gray.png","lpc/spritesheets/hair/high_and_tight/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/gray.png.json","lpc/spritesheets/hair/high_and_tight/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/green.png","lpc/spritesheets/hair/high_and_tight/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/green.png.json","lpc/spritesheets/hair/high_and_tight/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/light_brown.png","lpc/spritesheets/hair/high_and_tight/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/light_brown.png.json","lpc/spritesheets/hair/high_and_tight/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/orange.png","lpc/spritesheets/hair/high_and_tight/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/orange.png.json","lpc/spritesheets/hair/high_and_tight/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/purple.png","lpc/spritesheets/hair/high_and_tight/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/purple.png.json","lpc/spritesheets/hair/high_and_tight/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/red.png","lpc/spritesheets/hair/high_and_tight/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/red.png.json","lpc/spritesheets/hair/high_and_tight/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/white.png","lpc/spritesheets/hair/high_and_tight/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/female/white.png.json","lpc/spritesheets/hair/high_and_tight/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/black.png","lpc/spritesheets/hair/high_and_tight/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/black.png.json","lpc/spritesheets/hair/high_and_tight/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/blonde.png","lpc/spritesheets/hair/high_and_tight/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/blonde.png.json","lpc/spritesheets/hair/high_and_tight/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/blue.png","lpc/spritesheets/hair/high_and_tight/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/blue.png.json","lpc/spritesheets/hair/high_and_tight/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/dark_brown.png","lpc/spritesheets/hair/high_and_tight/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/dark_brown.png.json","lpc/spritesheets/hair/high_and_tight/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/gold.png","lpc/spritesheets/hair/high_and_tight/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/gold.png.json","lpc/spritesheets/hair/high_and_tight/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/gray.png","lpc/spritesheets/hair/high_and_tight/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/gray.png.json","lpc/spritesheets/hair/high_and_tight/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/green.png","lpc/spritesheets/hair/high_and_tight/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/green.png.json","lpc/spritesheets/hair/high_and_tight/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/light_brown.png","lpc/spritesheets/hair/high_and_tight/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/light_brown.png.json","lpc/spritesheets/hair/high_and_tight/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/orange.png","lpc/spritesheets/hair/high_and_tight/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/orange.png.json","lpc/spritesheets/hair/high_and_tight/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/purple.png","lpc/spritesheets/hair/high_and_tight/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/purple.png.json","lpc/spritesheets/hair/high_and_tight/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/red.png","lpc/spritesheets/hair/high_and_tight/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/red.png.json","lpc/spritesheets/hair/high_and_tight/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/white.png","lpc/spritesheets/hair/high_and_tight/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_and_tight/male/white.png.json","lpc/spritesheets/hair/high_ponytail/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/black.png","lpc/spritesheets/hair/high_ponytail/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/black.png.json","lpc/spritesheets/hair/high_ponytail/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/blonde.png","lpc/spritesheets/hair/high_ponytail/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/blonde.png.json","lpc/spritesheets/hair/high_ponytail/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/blue.png","lpc/spritesheets/hair/high_ponytail/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/blue.png.json","lpc/spritesheets/hair/high_ponytail/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/dark_brown.png","lpc/spritesheets/hair/high_ponytail/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/dark_brown.png.json","lpc/spritesheets/hair/high_ponytail/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/gold.png","lpc/spritesheets/hair/high_ponytail/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/gold.png.json","lpc/spritesheets/hair/high_ponytail/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/gray.png","lpc/spritesheets/hair/high_ponytail/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/gray.png.json","lpc/spritesheets/hair/high_ponytail/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/green.png","lpc/spritesheets/hair/high_ponytail/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/green.png.json","lpc/spritesheets/hair/high_ponytail/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/light_brown.png","lpc/spritesheets/hair/high_ponytail/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/light_brown.png.json","lpc/spritesheets/hair/high_ponytail/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/orange.png","lpc/spritesheets/hair/high_ponytail/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/orange.png.json","lpc/spritesheets/hair/high_ponytail/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/purple.png","lpc/spritesheets/hair/high_ponytail/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/purple.png.json","lpc/spritesheets/hair/high_ponytail/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/red.png","lpc/spritesheets/hair/high_ponytail/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/red.png.json","lpc/spritesheets/hair/high_ponytail/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/white.png","lpc/spritesheets/hair/high_ponytail/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/female/white.png.json","lpc/spritesheets/hair/high_ponytail/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/black.png","lpc/spritesheets/hair/high_ponytail/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/black.png.json","lpc/spritesheets/hair/high_ponytail/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/blonde.png","lpc/spritesheets/hair/high_ponytail/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/blonde.png.json","lpc/spritesheets/hair/high_ponytail/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/blue.png","lpc/spritesheets/hair/high_ponytail/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/blue.png.json","lpc/spritesheets/hair/high_ponytail/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/dark_brown.png","lpc/spritesheets/hair/high_ponytail/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/dark_brown.png.json","lpc/spritesheets/hair/high_ponytail/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/gold.png","lpc/spritesheets/hair/high_ponytail/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/gold.png.json","lpc/spritesheets/hair/high_ponytail/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/gray.png","lpc/spritesheets/hair/high_ponytail/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/gray.png.json","lpc/spritesheets/hair/high_ponytail/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/green.png","lpc/spritesheets/hair/high_ponytail/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/green.png.json","lpc/spritesheets/hair/high_ponytail/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/light_brown.png","lpc/spritesheets/hair/high_ponytail/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/light_brown.png.json","lpc/spritesheets/hair/high_ponytail/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/orange.png","lpc/spritesheets/hair/high_ponytail/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/orange.png.json","lpc/spritesheets/hair/high_ponytail/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/purple.png","lpc/spritesheets/hair/high_ponytail/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/purple.png.json","lpc/spritesheets/hair/high_ponytail/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/red.png","lpc/spritesheets/hair/high_ponytail/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/red.png.json","lpc/spritesheets/hair/high_ponytail/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/white.png","lpc/spritesheets/hair/high_ponytail/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/high_ponytail/male/white.png.json","lpc/spritesheets/hair/idol/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/black.png","lpc/spritesheets/hair/idol/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/black.png.json","lpc/spritesheets/hair/idol/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/blonde.png","lpc/spritesheets/hair/idol/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/blonde.png.json","lpc/spritesheets/hair/idol/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/blue.png","lpc/spritesheets/hair/idol/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/blue.png.json","lpc/spritesheets/hair/idol/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/dark_brown.png","lpc/spritesheets/hair/idol/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/dark_brown.png.json","lpc/spritesheets/hair/idol/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/gold.png","lpc/spritesheets/hair/idol/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/gold.png.json","lpc/spritesheets/hair/idol/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/gray.png","lpc/spritesheets/hair/idol/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/gray.png.json","lpc/spritesheets/hair/idol/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/green.png","lpc/spritesheets/hair/idol/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/green.png.json","lpc/spritesheets/hair/idol/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/light_brown.png","lpc/spritesheets/hair/idol/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/light_brown.png.json","lpc/spritesheets/hair/idol/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/orange.png","lpc/spritesheets/hair/idol/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/orange.png.json","lpc/spritesheets/hair/idol/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/purple.png","lpc/spritesheets/hair/idol/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/purple.png.json","lpc/spritesheets/hair/idol/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/red.png","lpc/spritesheets/hair/idol/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/red.png.json","lpc/spritesheets/hair/idol/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/white.png","lpc/spritesheets/hair/idol/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/female/white.png.json","lpc/spritesheets/hair/idol/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/black.png","lpc/spritesheets/hair/idol/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/black.png.json","lpc/spritesheets/hair/idol/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/blonde.png","lpc/spritesheets/hair/idol/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/blonde.png.json","lpc/spritesheets/hair/idol/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/blue.png","lpc/spritesheets/hair/idol/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/blue.png.json","lpc/spritesheets/hair/idol/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/dark_brown.png","lpc/spritesheets/hair/idol/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/dark_brown.png.json","lpc/spritesheets/hair/idol/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/gold.png","lpc/spritesheets/hair/idol/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/gold.png.json","lpc/spritesheets/hair/idol/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/gray.png","lpc/spritesheets/hair/idol/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/gray.png.json","lpc/spritesheets/hair/idol/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/green.png","lpc/spritesheets/hair/idol/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/green.png.json","lpc/spritesheets/hair/idol/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/light_brown.png","lpc/spritesheets/hair/idol/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/light_brown.png.json","lpc/spritesheets/hair/idol/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/orange.png","lpc/spritesheets/hair/idol/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/orange.png.json","lpc/spritesheets/hair/idol/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/purple.png","lpc/spritesheets/hair/idol/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/purple.png.json","lpc/spritesheets/hair/idol/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/red.png","lpc/spritesheets/hair/idol/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/red.png.json","lpc/spritesheets/hair/idol/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/white.png","lpc/spritesheets/hair/idol/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/idol/male/white.png.json","lpc/spritesheets/hair/jewfro/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/black.png","lpc/spritesheets/hair/jewfro/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/black.png.json","lpc/spritesheets/hair/jewfro/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/blonde.png","lpc/spritesheets/hair/jewfro/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/blonde.png.json","lpc/spritesheets/hair/jewfro/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/blue.png","lpc/spritesheets/hair/jewfro/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/blue.png.json","lpc/spritesheets/hair/jewfro/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/dark_brown.png","lpc/spritesheets/hair/jewfro/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/dark_brown.png.json","lpc/spritesheets/hair/jewfro/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/gold.png","lpc/spritesheets/hair/jewfro/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/gold.png.json","lpc/spritesheets/hair/jewfro/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/gray.png","lpc/spritesheets/hair/jewfro/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/gray.png.json","lpc/spritesheets/hair/jewfro/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/green.png","lpc/spritesheets/hair/jewfro/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/green.png.json","lpc/spritesheets/hair/jewfro/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/light_brown.png","lpc/spritesheets/hair/jewfro/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/light_brown.png.json","lpc/spritesheets/hair/jewfro/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/orange.png","lpc/spritesheets/hair/jewfro/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/orange.png.json","lpc/spritesheets/hair/jewfro/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/purple.png","lpc/spritesheets/hair/jewfro/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/purple.png.json","lpc/spritesheets/hair/jewfro/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/red.png","lpc/spritesheets/hair/jewfro/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/red.png.json","lpc/spritesheets/hair/jewfro/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/white.png","lpc/spritesheets/hair/jewfro/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/female/white.png.json","lpc/spritesheets/hair/jewfro/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/black.png","lpc/spritesheets/hair/jewfro/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/black.png.json","lpc/spritesheets/hair/jewfro/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/blonde.png","lpc/spritesheets/hair/jewfro/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/blonde.png.json","lpc/spritesheets/hair/jewfro/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/blue.png","lpc/spritesheets/hair/jewfro/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/blue.png.json","lpc/spritesheets/hair/jewfro/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/dark_brown.png","lpc/spritesheets/hair/jewfro/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/dark_brown.png.json","lpc/spritesheets/hair/jewfro/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/gold.png","lpc/spritesheets/hair/jewfro/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/gold.png.json","lpc/spritesheets/hair/jewfro/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/gray.png","lpc/spritesheets/hair/jewfro/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/gray.png.json","lpc/spritesheets/hair/jewfro/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/green.png","lpc/spritesheets/hair/jewfro/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/green.png.json","lpc/spritesheets/hair/jewfro/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/light_brown.png","lpc/spritesheets/hair/jewfro/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/light_brown.png.json","lpc/spritesheets/hair/jewfro/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/orange.png","lpc/spritesheets/hair/jewfro/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/orange.png.json","lpc/spritesheets/hair/jewfro/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/purple.png","lpc/spritesheets/hair/jewfro/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/purple.png.json","lpc/spritesheets/hair/jewfro/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/red.png","lpc/spritesheets/hair/jewfro/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/red.png.json","lpc/spritesheets/hair/jewfro/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/white.png","lpc/spritesheets/hair/jewfro/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/jewfro/male/white.png.json","lpc/spritesheets/hair/lob/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/black.png","lpc/spritesheets/hair/lob/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/black.png.json","lpc/spritesheets/hair/lob/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/blonde.png","lpc/spritesheets/hair/lob/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/blonde.png.json","lpc/spritesheets/hair/lob/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/blue.png","lpc/spritesheets/hair/lob/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/blue.png.json","lpc/spritesheets/hair/lob/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/dark_brown.png","lpc/spritesheets/hair/lob/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/dark_brown.png.json","lpc/spritesheets/hair/lob/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/gold.png","lpc/spritesheets/hair/lob/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/gold.png.json","lpc/spritesheets/hair/lob/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/gray.png","lpc/spritesheets/hair/lob/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/gray.png.json","lpc/spritesheets/hair/lob/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/green.png","lpc/spritesheets/hair/lob/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/green.png.json","lpc/spritesheets/hair/lob/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/light_brown.png","lpc/spritesheets/hair/lob/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/light_brown.png.json","lpc/spritesheets/hair/lob/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/orange.png","lpc/spritesheets/hair/lob/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/orange.png.json","lpc/spritesheets/hair/lob/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/purple.png","lpc/spritesheets/hair/lob/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/purple.png.json","lpc/spritesheets/hair/lob/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/red.png","lpc/spritesheets/hair/lob/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/red.png.json","lpc/spritesheets/hair/lob/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/white.png","lpc/spritesheets/hair/lob/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/female/white.png.json","lpc/spritesheets/hair/lob/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/black.png","lpc/spritesheets/hair/lob/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/black.png.json","lpc/spritesheets/hair/lob/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/blonde.png","lpc/spritesheets/hair/lob/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/blonde.png.json","lpc/spritesheets/hair/lob/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/blue.png","lpc/spritesheets/hair/lob/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/blue.png.json","lpc/spritesheets/hair/lob/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/dark_brown.png","lpc/spritesheets/hair/lob/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/dark_brown.png.json","lpc/spritesheets/hair/lob/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/gold.png","lpc/spritesheets/hair/lob/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/gold.png.json","lpc/spritesheets/hair/lob/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/gray.png","lpc/spritesheets/hair/lob/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/gray.png.json","lpc/spritesheets/hair/lob/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/green.png","lpc/spritesheets/hair/lob/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/green.png.json","lpc/spritesheets/hair/lob/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/light_brown.png","lpc/spritesheets/hair/lob/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/light_brown.png.json","lpc/spritesheets/hair/lob/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/orange.png","lpc/spritesheets/hair/lob/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/orange.png.json","lpc/spritesheets/hair/lob/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/purple.png","lpc/spritesheets/hair/lob/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/purple.png.json","lpc/spritesheets/hair/lob/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/red.png","lpc/spritesheets/hair/lob/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/red.png.json","lpc/spritesheets/hair/lob/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/white.png","lpc/spritesheets/hair/lob/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/lob/male/white.png.json","lpc/spritesheets/hair/long/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/black.png","lpc/spritesheets/hair/long/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/black.png.json","lpc/spritesheets/hair/long/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/blonde.png","lpc/spritesheets/hair/long/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/blonde.png.json","lpc/spritesheets/hair/long/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/blue.png","lpc/spritesheets/hair/long/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/blue.png.json","lpc/spritesheets/hair/long/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/dark_brown.png","lpc/spritesheets/hair/long/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/dark_brown.png.json","lpc/spritesheets/hair/long/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/gold.png","lpc/spritesheets/hair/long/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/gold.png.json","lpc/spritesheets/hair/long/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/gray.png","lpc/spritesheets/hair/long/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/gray.png.json","lpc/spritesheets/hair/long/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/green.png","lpc/spritesheets/hair/long/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/green.png.json","lpc/spritesheets/hair/long/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/light_brown.png","lpc/spritesheets/hair/long/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/light_brown.png.json","lpc/spritesheets/hair/long/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/orange.png","lpc/spritesheets/hair/long/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/orange.png.json","lpc/spritesheets/hair/long/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/purple.png","lpc/spritesheets/hair/long/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/purple.png.json","lpc/spritesheets/hair/long/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/red.png","lpc/spritesheets/hair/long/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/red.png.json","lpc/spritesheets/hair/long/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/white.png","lpc/spritesheets/hair/long/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/female/white.png.json","lpc/spritesheets/hair/long/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/black.png","lpc/spritesheets/hair/long/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/black.png.json","lpc/spritesheets/hair/long/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/blonde.png","lpc/spritesheets/hair/long/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/blonde.png.json","lpc/spritesheets/hair/long/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/blue.png","lpc/spritesheets/hair/long/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/blue.png.json","lpc/spritesheets/hair/long/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/dark_brown.png","lpc/spritesheets/hair/long/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/dark_brown.png.json","lpc/spritesheets/hair/long/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/gold.png","lpc/spritesheets/hair/long/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/gold.png.json","lpc/spritesheets/hair/long/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/gray.png","lpc/spritesheets/hair/long/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/gray.png.json","lpc/spritesheets/hair/long/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/green.png","lpc/spritesheets/hair/long/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/green.png.json","lpc/spritesheets/hair/long/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/light_brown.png","lpc/spritesheets/hair/long/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/light_brown.png.json","lpc/spritesheets/hair/long/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/orange.png","lpc/spritesheets/hair/long/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/orange.png.json","lpc/spritesheets/hair/long/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/purple.png","lpc/spritesheets/hair/long/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/purple.png.json","lpc/spritesheets/hair/long/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/red.png","lpc/spritesheets/hair/long/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/red.png.json","lpc/spritesheets/hair/long/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/white.png","lpc/spritesheets/hair/long/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long/male/white.png.json","lpc/spritesheets/hair/long_band/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/black.png","lpc/spritesheets/hair/long_band/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/black.png.json","lpc/spritesheets/hair/long_band/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/blonde.png","lpc/spritesheets/hair/long_band/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/blonde.png.json","lpc/spritesheets/hair/long_band/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/blue.png","lpc/spritesheets/hair/long_band/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/blue.png.json","lpc/spritesheets/hair/long_band/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/dark_brown.png","lpc/spritesheets/hair/long_band/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/dark_brown.png.json","lpc/spritesheets/hair/long_band/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/gold.png","lpc/spritesheets/hair/long_band/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/gold.png.json","lpc/spritesheets/hair/long_band/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/gray.png","lpc/spritesheets/hair/long_band/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/gray.png.json","lpc/spritesheets/hair/long_band/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/green.png","lpc/spritesheets/hair/long_band/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/green.png.json","lpc/spritesheets/hair/long_band/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/light_brown.png","lpc/spritesheets/hair/long_band/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/light_brown.png.json","lpc/spritesheets/hair/long_band/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/orange.png","lpc/spritesheets/hair/long_band/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/orange.png.json","lpc/spritesheets/hair/long_band/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/purple.png","lpc/spritesheets/hair/long_band/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/purple.png.json","lpc/spritesheets/hair/long_band/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/red.png","lpc/spritesheets/hair/long_band/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/red.png.json","lpc/spritesheets/hair/long_band/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/white.png","lpc/spritesheets/hair/long_band/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/female/white.png.json","lpc/spritesheets/hair/long_band/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/black.png","lpc/spritesheets/hair/long_band/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/black.png.json","lpc/spritesheets/hair/long_band/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/blonde.png","lpc/spritesheets/hair/long_band/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/blonde.png.json","lpc/spritesheets/hair/long_band/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/blue.png","lpc/spritesheets/hair/long_band/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/blue.png.json","lpc/spritesheets/hair/long_band/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/dark_brown.png","lpc/spritesheets/hair/long_band/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/dark_brown.png.json","lpc/spritesheets/hair/long_band/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/gold.png","lpc/spritesheets/hair/long_band/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/gold.png.json","lpc/spritesheets/hair/long_band/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/gray.png","lpc/spritesheets/hair/long_band/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/gray.png.json","lpc/spritesheets/hair/long_band/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/green.png","lpc/spritesheets/hair/long_band/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/green.png.json","lpc/spritesheets/hair/long_band/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/light_brown.png","lpc/spritesheets/hair/long_band/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/light_brown.png.json","lpc/spritesheets/hair/long_band/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/orange.png","lpc/spritesheets/hair/long_band/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/orange.png.json","lpc/spritesheets/hair/long_band/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/purple.png","lpc/spritesheets/hair/long_band/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/purple.png.json","lpc/spritesheets/hair/long_band/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/red.png","lpc/spritesheets/hair/long_band/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/red.png.json","lpc/spritesheets/hair/long_band/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/white.png","lpc/spritesheets/hair/long_band/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_band/male/white.png.json","lpc/spritesheets/hair/long_center_part/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/black.png","lpc/spritesheets/hair/long_center_part/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/black.png.json","lpc/spritesheets/hair/long_center_part/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/blonde.png","lpc/spritesheets/hair/long_center_part/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/blonde.png.json","lpc/spritesheets/hair/long_center_part/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/blue.png","lpc/spritesheets/hair/long_center_part/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/blue.png.json","lpc/spritesheets/hair/long_center_part/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/dark_brown.png","lpc/spritesheets/hair/long_center_part/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/dark_brown.png.json","lpc/spritesheets/hair/long_center_part/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/gold.png","lpc/spritesheets/hair/long_center_part/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/gold.png.json","lpc/spritesheets/hair/long_center_part/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/gray.png","lpc/spritesheets/hair/long_center_part/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/gray.png.json","lpc/spritesheets/hair/long_center_part/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/green.png","lpc/spritesheets/hair/long_center_part/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/green.png.json","lpc/spritesheets/hair/long_center_part/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/light_brown.png","lpc/spritesheets/hair/long_center_part/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/light_brown.png.json","lpc/spritesheets/hair/long_center_part/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/orange.png","lpc/spritesheets/hair/long_center_part/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/orange.png.json","lpc/spritesheets/hair/long_center_part/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/purple.png","lpc/spritesheets/hair/long_center_part/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/purple.png.json","lpc/spritesheets/hair/long_center_part/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/red.png","lpc/spritesheets/hair/long_center_part/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/red.png.json","lpc/spritesheets/hair/long_center_part/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/white.png","lpc/spritesheets/hair/long_center_part/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/female/white.png.json","lpc/spritesheets/hair/long_center_part/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/black.png","lpc/spritesheets/hair/long_center_part/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/black.png.json","lpc/spritesheets/hair/long_center_part/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/blonde.png","lpc/spritesheets/hair/long_center_part/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/blonde.png.json","lpc/spritesheets/hair/long_center_part/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/blue.png","lpc/spritesheets/hair/long_center_part/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/blue.png.json","lpc/spritesheets/hair/long_center_part/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/dark_brown.png","lpc/spritesheets/hair/long_center_part/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/dark_brown.png.json","lpc/spritesheets/hair/long_center_part/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/gold.png","lpc/spritesheets/hair/long_center_part/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/gold.png.json","lpc/spritesheets/hair/long_center_part/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/gray.png","lpc/spritesheets/hair/long_center_part/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/gray.png.json","lpc/spritesheets/hair/long_center_part/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/green.png","lpc/spritesheets/hair/long_center_part/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/green.png.json","lpc/spritesheets/hair/long_center_part/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/light_brown.png","lpc/spritesheets/hair/long_center_part/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/light_brown.png.json","lpc/spritesheets/hair/long_center_part/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/orange.png","lpc/spritesheets/hair/long_center_part/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/orange.png.json","lpc/spritesheets/hair/long_center_part/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/purple.png","lpc/spritesheets/hair/long_center_part/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/purple.png.json","lpc/spritesheets/hair/long_center_part/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/red.png","lpc/spritesheets/hair/long_center_part/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/red.png.json","lpc/spritesheets/hair/long_center_part/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/white.png","lpc/spritesheets/hair/long_center_part/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_center_part/male/white.png.json","lpc/spritesheets/hair/long_messy/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/black.png","lpc/spritesheets/hair/long_messy/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/black.png.json","lpc/spritesheets/hair/long_messy/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/blonde.png","lpc/spritesheets/hair/long_messy/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/blonde.png.json","lpc/spritesheets/hair/long_messy/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/blue.png","lpc/spritesheets/hair/long_messy/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/blue.png.json","lpc/spritesheets/hair/long_messy/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/dark_brown.png","lpc/spritesheets/hair/long_messy/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/dark_brown.png.json","lpc/spritesheets/hair/long_messy/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/gold.png","lpc/spritesheets/hair/long_messy/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/gold.png.json","lpc/spritesheets/hair/long_messy/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/gray.png","lpc/spritesheets/hair/long_messy/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/gray.png.json","lpc/spritesheets/hair/long_messy/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/green.png","lpc/spritesheets/hair/long_messy/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/green.png.json","lpc/spritesheets/hair/long_messy/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/light_brown.png","lpc/spritesheets/hair/long_messy/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/light_brown.png.json","lpc/spritesheets/hair/long_messy/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/orange.png","lpc/spritesheets/hair/long_messy/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/orange.png.json","lpc/spritesheets/hair/long_messy/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/purple.png","lpc/spritesheets/hair/long_messy/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/purple.png.json","lpc/spritesheets/hair/long_messy/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/red.png","lpc/spritesheets/hair/long_messy/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/red.png.json","lpc/spritesheets/hair/long_messy/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/white.png","lpc/spritesheets/hair/long_messy/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/female/white.png.json","lpc/spritesheets/hair/long_messy/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/black.png","lpc/spritesheets/hair/long_messy/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/black.png.json","lpc/spritesheets/hair/long_messy/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/blonde.png","lpc/spritesheets/hair/long_messy/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/blonde.png.json","lpc/spritesheets/hair/long_messy/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/blue.png","lpc/spritesheets/hair/long_messy/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/blue.png.json","lpc/spritesheets/hair/long_messy/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/dark_brown.png","lpc/spritesheets/hair/long_messy/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/dark_brown.png.json","lpc/spritesheets/hair/long_messy/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/gold.png","lpc/spritesheets/hair/long_messy/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/gold.png.json","lpc/spritesheets/hair/long_messy/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/gray.png","lpc/spritesheets/hair/long_messy/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/gray.png.json","lpc/spritesheets/hair/long_messy/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/green.png","lpc/spritesheets/hair/long_messy/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/green.png.json","lpc/spritesheets/hair/long_messy/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/light_brown.png","lpc/spritesheets/hair/long_messy/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/light_brown.png.json","lpc/spritesheets/hair/long_messy/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/orange.png","lpc/spritesheets/hair/long_messy/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/orange.png.json","lpc/spritesheets/hair/long_messy/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/purple.png","lpc/spritesheets/hair/long_messy/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/purple.png.json","lpc/spritesheets/hair/long_messy/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/red.png","lpc/spritesheets/hair/long_messy/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/red.png.json","lpc/spritesheets/hair/long_messy/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/white.png","lpc/spritesheets/hair/long_messy/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy/male/white.png.json","lpc/spritesheets/hair/long_messy2/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/black.png","lpc/spritesheets/hair/long_messy2/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/black.png.json","lpc/spritesheets/hair/long_messy2/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/blonde.png","lpc/spritesheets/hair/long_messy2/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/blonde.png.json","lpc/spritesheets/hair/long_messy2/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/blue.png","lpc/spritesheets/hair/long_messy2/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/blue.png.json","lpc/spritesheets/hair/long_messy2/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/dark_brown.png","lpc/spritesheets/hair/long_messy2/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/dark_brown.png.json","lpc/spritesheets/hair/long_messy2/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/gold.png","lpc/spritesheets/hair/long_messy2/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/gold.png.json","lpc/spritesheets/hair/long_messy2/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/gray.png","lpc/spritesheets/hair/long_messy2/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/gray.png.json","lpc/spritesheets/hair/long_messy2/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/green.png","lpc/spritesheets/hair/long_messy2/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/green.png.json","lpc/spritesheets/hair/long_messy2/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/light_brown.png","lpc/spritesheets/hair/long_messy2/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/light_brown.png.json","lpc/spritesheets/hair/long_messy2/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/orange.png","lpc/spritesheets/hair/long_messy2/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/orange.png.json","lpc/spritesheets/hair/long_messy2/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/purple.png","lpc/spritesheets/hair/long_messy2/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/purple.png.json","lpc/spritesheets/hair/long_messy2/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/red.png","lpc/spritesheets/hair/long_messy2/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/red.png.json","lpc/spritesheets/hair/long_messy2/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/white.png","lpc/spritesheets/hair/long_messy2/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/female/white.png.json","lpc/spritesheets/hair/long_messy2/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/black.png","lpc/spritesheets/hair/long_messy2/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/black.png.json","lpc/spritesheets/hair/long_messy2/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/blonde.png","lpc/spritesheets/hair/long_messy2/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/blonde.png.json","lpc/spritesheets/hair/long_messy2/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/blue.png","lpc/spritesheets/hair/long_messy2/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/blue.png.json","lpc/spritesheets/hair/long_messy2/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/dark_brown.png","lpc/spritesheets/hair/long_messy2/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/dark_brown.png.json","lpc/spritesheets/hair/long_messy2/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/gold.png","lpc/spritesheets/hair/long_messy2/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/gold.png.json","lpc/spritesheets/hair/long_messy2/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/gray.png","lpc/spritesheets/hair/long_messy2/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/gray.png.json","lpc/spritesheets/hair/long_messy2/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/green.png","lpc/spritesheets/hair/long_messy2/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/green.png.json","lpc/spritesheets/hair/long_messy2/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/light_brown.png","lpc/spritesheets/hair/long_messy2/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/light_brown.png.json","lpc/spritesheets/hair/long_messy2/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/orange.png","lpc/spritesheets/hair/long_messy2/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/orange.png.json","lpc/spritesheets/hair/long_messy2/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/purple.png","lpc/spritesheets/hair/long_messy2/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/purple.png.json","lpc/spritesheets/hair/long_messy2/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/red.png","lpc/spritesheets/hair/long_messy2/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/red.png.json","lpc/spritesheets/hair/long_messy2/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/white.png","lpc/spritesheets/hair/long_messy2/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_messy2/male/white.png.json","lpc/spritesheets/hair/long_tied/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/black.png","lpc/spritesheets/hair/long_tied/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/black.png.json","lpc/spritesheets/hair/long_tied/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/blonde.png","lpc/spritesheets/hair/long_tied/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/blonde.png.json","lpc/spritesheets/hair/long_tied/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/blue.png","lpc/spritesheets/hair/long_tied/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/blue.png.json","lpc/spritesheets/hair/long_tied/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/dark_brown.png","lpc/spritesheets/hair/long_tied/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/dark_brown.png.json","lpc/spritesheets/hair/long_tied/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/gold.png","lpc/spritesheets/hair/long_tied/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/gold.png.json","lpc/spritesheets/hair/long_tied/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/gray.png","lpc/spritesheets/hair/long_tied/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/gray.png.json","lpc/spritesheets/hair/long_tied/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/green.png","lpc/spritesheets/hair/long_tied/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/green.png.json","lpc/spritesheets/hair/long_tied/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/light_brown.png","lpc/spritesheets/hair/long_tied/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/light_brown.png.json","lpc/spritesheets/hair/long_tied/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/orange.png","lpc/spritesheets/hair/long_tied/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/orange.png.json","lpc/spritesheets/hair/long_tied/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/purple.png","lpc/spritesheets/hair/long_tied/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/purple.png.json","lpc/spritesheets/hair/long_tied/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/red.png","lpc/spritesheets/hair/long_tied/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/red.png.json","lpc/spritesheets/hair/long_tied/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/white.png","lpc/spritesheets/hair/long_tied/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/female/white.png.json","lpc/spritesheets/hair/long_tied/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/black.png","lpc/spritesheets/hair/long_tied/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/black.png.json","lpc/spritesheets/hair/long_tied/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/blonde.png","lpc/spritesheets/hair/long_tied/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/blonde.png.json","lpc/spritesheets/hair/long_tied/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/blue.png","lpc/spritesheets/hair/long_tied/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/blue.png.json","lpc/spritesheets/hair/long_tied/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/dark_brown.png","lpc/spritesheets/hair/long_tied/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/dark_brown.png.json","lpc/spritesheets/hair/long_tied/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/gold.png","lpc/spritesheets/hair/long_tied/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/gold.png.json","lpc/spritesheets/hair/long_tied/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/gray.png","lpc/spritesheets/hair/long_tied/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/gray.png.json","lpc/spritesheets/hair/long_tied/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/green.png","lpc/spritesheets/hair/long_tied/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/green.png.json","lpc/spritesheets/hair/long_tied/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/light_brown.png","lpc/spritesheets/hair/long_tied/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/light_brown.png.json","lpc/spritesheets/hair/long_tied/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/orange.png","lpc/spritesheets/hair/long_tied/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/orange.png.json","lpc/spritesheets/hair/long_tied/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/purple.png","lpc/spritesheets/hair/long_tied/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/purple.png.json","lpc/spritesheets/hair/long_tied/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/red.png","lpc/spritesheets/hair/long_tied/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/red.png.json","lpc/spritesheets/hair/long_tied/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/white.png","lpc/spritesheets/hair/long_tied/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/long_tied/male/white.png.json","lpc/spritesheets/hair/longhawk/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/black.png","lpc/spritesheets/hair/longhawk/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/black.png.json","lpc/spritesheets/hair/longhawk/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/blonde.png","lpc/spritesheets/hair/longhawk/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/blonde.png.json","lpc/spritesheets/hair/longhawk/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/blue.png","lpc/spritesheets/hair/longhawk/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/blue.png.json","lpc/spritesheets/hair/longhawk/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/dark_brown.png","lpc/spritesheets/hair/longhawk/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/dark_brown.png.json","lpc/spritesheets/hair/longhawk/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/gold.png","lpc/spritesheets/hair/longhawk/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/gold.png.json","lpc/spritesheets/hair/longhawk/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/gray.png","lpc/spritesheets/hair/longhawk/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/gray.png.json","lpc/spritesheets/hair/longhawk/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/green.png","lpc/spritesheets/hair/longhawk/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/green.png.json","lpc/spritesheets/hair/longhawk/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/light_brown.png","lpc/spritesheets/hair/longhawk/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/light_brown.png.json","lpc/spritesheets/hair/longhawk/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/orange.png","lpc/spritesheets/hair/longhawk/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/orange.png.json","lpc/spritesheets/hair/longhawk/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/purple.png","lpc/spritesheets/hair/longhawk/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/purple.png.json","lpc/spritesheets/hair/longhawk/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/red.png","lpc/spritesheets/hair/longhawk/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/red.png.json","lpc/spritesheets/hair/longhawk/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/white.png","lpc/spritesheets/hair/longhawk/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/female/white.png.json","lpc/spritesheets/hair/longhawk/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/black.png","lpc/spritesheets/hair/longhawk/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/black.png.json","lpc/spritesheets/hair/longhawk/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/blonde.png","lpc/spritesheets/hair/longhawk/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/blonde.png.json","lpc/spritesheets/hair/longhawk/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/blue.png","lpc/spritesheets/hair/longhawk/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/blue.png.json","lpc/spritesheets/hair/longhawk/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/dark_brown.png","lpc/spritesheets/hair/longhawk/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/dark_brown.png.json","lpc/spritesheets/hair/longhawk/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/gold.png","lpc/spritesheets/hair/longhawk/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/gold.png.json","lpc/spritesheets/hair/longhawk/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/gray.png","lpc/spritesheets/hair/longhawk/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/gray.png.json","lpc/spritesheets/hair/longhawk/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/green.png","lpc/spritesheets/hair/longhawk/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/green.png.json","lpc/spritesheets/hair/longhawk/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/light_brown.png","lpc/spritesheets/hair/longhawk/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/light_brown.png.json","lpc/spritesheets/hair/longhawk/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/orange.png","lpc/spritesheets/hair/longhawk/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/orange.png.json","lpc/spritesheets/hair/longhawk/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/purple.png","lpc/spritesheets/hair/longhawk/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/purple.png.json","lpc/spritesheets/hair/longhawk/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/red.png","lpc/spritesheets/hair/longhawk/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/red.png.json","lpc/spritesheets/hair/longhawk/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/white.png","lpc/spritesheets/hair/longhawk/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longhawk/male/white.png.json","lpc/spritesheets/hair/longknot/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/black.png","lpc/spritesheets/hair/longknot/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/black.png.json","lpc/spritesheets/hair/longknot/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/blonde.png","lpc/spritesheets/hair/longknot/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/blonde.png.json","lpc/spritesheets/hair/longknot/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/blue.png","lpc/spritesheets/hair/longknot/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/blue.png.json","lpc/spritesheets/hair/longknot/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/dark_brown.png","lpc/spritesheets/hair/longknot/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/dark_brown.png.json","lpc/spritesheets/hair/longknot/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/gold.png","lpc/spritesheets/hair/longknot/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/gold.png.json","lpc/spritesheets/hair/longknot/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/gray.png","lpc/spritesheets/hair/longknot/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/gray.png.json","lpc/spritesheets/hair/longknot/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/green.png","lpc/spritesheets/hair/longknot/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/green.png.json","lpc/spritesheets/hair/longknot/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/light_brown.png","lpc/spritesheets/hair/longknot/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/light_brown.png.json","lpc/spritesheets/hair/longknot/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/orange.png","lpc/spritesheets/hair/longknot/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/orange.png.json","lpc/spritesheets/hair/longknot/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/purple.png","lpc/spritesheets/hair/longknot/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/purple.png.json","lpc/spritesheets/hair/longknot/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/red.png","lpc/spritesheets/hair/longknot/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/red.png.json","lpc/spritesheets/hair/longknot/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/white.png","lpc/spritesheets/hair/longknot/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/female/white.png.json","lpc/spritesheets/hair/longknot/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/black.png","lpc/spritesheets/hair/longknot/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/black.png.json","lpc/spritesheets/hair/longknot/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/blonde.png","lpc/spritesheets/hair/longknot/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/blonde.png.json","lpc/spritesheets/hair/longknot/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/blue.png","lpc/spritesheets/hair/longknot/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/blue.png.json","lpc/spritesheets/hair/longknot/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/dark_brown.png","lpc/spritesheets/hair/longknot/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/dark_brown.png.json","lpc/spritesheets/hair/longknot/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/gold.png","lpc/spritesheets/hair/longknot/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/gold.png.json","lpc/spritesheets/hair/longknot/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/gray.png","lpc/spritesheets/hair/longknot/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/gray.png.json","lpc/spritesheets/hair/longknot/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/green.png","lpc/spritesheets/hair/longknot/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/green.png.json","lpc/spritesheets/hair/longknot/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/light_brown.png","lpc/spritesheets/hair/longknot/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/light_brown.png.json","lpc/spritesheets/hair/longknot/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/orange.png","lpc/spritesheets/hair/longknot/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/orange.png.json","lpc/spritesheets/hair/longknot/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/purple.png","lpc/spritesheets/hair/longknot/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/purple.png.json","lpc/spritesheets/hair/longknot/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/red.png","lpc/spritesheets/hair/longknot/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/red.png.json","lpc/spritesheets/hair/longknot/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/white.png","lpc/spritesheets/hair/longknot/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/longknot/male/white.png.json","lpc/spritesheets/hair/loose/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/black.png","lpc/spritesheets/hair/loose/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/black.png.json","lpc/spritesheets/hair/loose/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/blonde.png","lpc/spritesheets/hair/loose/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/blonde.png.json","lpc/spritesheets/hair/loose/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/blue.png","lpc/spritesheets/hair/loose/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/blue.png.json","lpc/spritesheets/hair/loose/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/dark_brown.png","lpc/spritesheets/hair/loose/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/dark_brown.png.json","lpc/spritesheets/hair/loose/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/gold.png","lpc/spritesheets/hair/loose/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/gold.png.json","lpc/spritesheets/hair/loose/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/gray.png","lpc/spritesheets/hair/loose/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/gray.png.json","lpc/spritesheets/hair/loose/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/green.png","lpc/spritesheets/hair/loose/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/green.png.json","lpc/spritesheets/hair/loose/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/light_brown.png","lpc/spritesheets/hair/loose/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/light_brown.png.json","lpc/spritesheets/hair/loose/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/orange.png","lpc/spritesheets/hair/loose/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/orange.png.json","lpc/spritesheets/hair/loose/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/purple.png","lpc/spritesheets/hair/loose/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/purple.png.json","lpc/spritesheets/hair/loose/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/red.png","lpc/spritesheets/hair/loose/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/red.png.json","lpc/spritesheets/hair/loose/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/white.png","lpc/spritesheets/hair/loose/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/female/white.png.json","lpc/spritesheets/hair/loose/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/black.png","lpc/spritesheets/hair/loose/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/black.png.json","lpc/spritesheets/hair/loose/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/blonde.png","lpc/spritesheets/hair/loose/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/blonde.png.json","lpc/spritesheets/hair/loose/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/blue.png","lpc/spritesheets/hair/loose/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/blue.png.json","lpc/spritesheets/hair/loose/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/dark_brown.png","lpc/spritesheets/hair/loose/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/dark_brown.png.json","lpc/spritesheets/hair/loose/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/gold.png","lpc/spritesheets/hair/loose/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/gold.png.json","lpc/spritesheets/hair/loose/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/gray.png","lpc/spritesheets/hair/loose/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/gray.png.json","lpc/spritesheets/hair/loose/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/green.png","lpc/spritesheets/hair/loose/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/green.png.json","lpc/spritesheets/hair/loose/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/light_brown.png","lpc/spritesheets/hair/loose/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/light_brown.png.json","lpc/spritesheets/hair/loose/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/orange.png","lpc/spritesheets/hair/loose/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/orange.png.json","lpc/spritesheets/hair/loose/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/purple.png","lpc/spritesheets/hair/loose/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/purple.png.json","lpc/spritesheets/hair/loose/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/red.png","lpc/spritesheets/hair/loose/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/red.png.json","lpc/spritesheets/hair/loose/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/white.png","lpc/spritesheets/hair/loose/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/loose/male/white.png.json","lpc/spritesheets/hair/messy1/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/black.png","lpc/spritesheets/hair/messy1/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/black.png.json","lpc/spritesheets/hair/messy1/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/blonde.png","lpc/spritesheets/hair/messy1/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/blonde.png.json","lpc/spritesheets/hair/messy1/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/blue.png","lpc/spritesheets/hair/messy1/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/blue.png.json","lpc/spritesheets/hair/messy1/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/dark_brown.png","lpc/spritesheets/hair/messy1/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/dark_brown.png.json","lpc/spritesheets/hair/messy1/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/gold.png","lpc/spritesheets/hair/messy1/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/gold.png.json","lpc/spritesheets/hair/messy1/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/gray.png","lpc/spritesheets/hair/messy1/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/gray.png.json","lpc/spritesheets/hair/messy1/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/green.png","lpc/spritesheets/hair/messy1/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/green.png.json","lpc/spritesheets/hair/messy1/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/light_brown.png","lpc/spritesheets/hair/messy1/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/light_brown.png.json","lpc/spritesheets/hair/messy1/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/orange.png","lpc/spritesheets/hair/messy1/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/orange.png.json","lpc/spritesheets/hair/messy1/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/purple.png","lpc/spritesheets/hair/messy1/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/purple.png.json","lpc/spritesheets/hair/messy1/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/red.png","lpc/spritesheets/hair/messy1/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/red.png.json","lpc/spritesheets/hair/messy1/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/white.png","lpc/spritesheets/hair/messy1/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/female/white.png.json","lpc/spritesheets/hair/messy1/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/black.png","lpc/spritesheets/hair/messy1/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/black.png.json","lpc/spritesheets/hair/messy1/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/blonde.png","lpc/spritesheets/hair/messy1/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/blonde.png.json","lpc/spritesheets/hair/messy1/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/blue.png","lpc/spritesheets/hair/messy1/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/blue.png.json","lpc/spritesheets/hair/messy1/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/dark_brown.png","lpc/spritesheets/hair/messy1/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/dark_brown.png.json","lpc/spritesheets/hair/messy1/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/gold.png","lpc/spritesheets/hair/messy1/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/gold.png.json","lpc/spritesheets/hair/messy1/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/gray.png","lpc/spritesheets/hair/messy1/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/gray.png.json","lpc/spritesheets/hair/messy1/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/green.png","lpc/spritesheets/hair/messy1/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/green.png.json","lpc/spritesheets/hair/messy1/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/light_brown.png","lpc/spritesheets/hair/messy1/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/light_brown.png.json","lpc/spritesheets/hair/messy1/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/orange.png","lpc/spritesheets/hair/messy1/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/orange.png.json","lpc/spritesheets/hair/messy1/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/purple.png","lpc/spritesheets/hair/messy1/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/purple.png.json","lpc/spritesheets/hair/messy1/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/red.png","lpc/spritesheets/hair/messy1/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/red.png.json","lpc/spritesheets/hair/messy1/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/white.png","lpc/spritesheets/hair/messy1/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy1/male/white.png.json","lpc/spritesheets/hair/messy2/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/black.png","lpc/spritesheets/hair/messy2/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/black.png.json","lpc/spritesheets/hair/messy2/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/blonde.png","lpc/spritesheets/hair/messy2/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/blonde.png.json","lpc/spritesheets/hair/messy2/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/blue.png","lpc/spritesheets/hair/messy2/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/blue.png.json","lpc/spritesheets/hair/messy2/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/dark_brown.png","lpc/spritesheets/hair/messy2/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/dark_brown.png.json","lpc/spritesheets/hair/messy2/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/gold.png","lpc/spritesheets/hair/messy2/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/gold.png.json","lpc/spritesheets/hair/messy2/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/gray.png","lpc/spritesheets/hair/messy2/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/gray.png.json","lpc/spritesheets/hair/messy2/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/green.png","lpc/spritesheets/hair/messy2/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/green.png.json","lpc/spritesheets/hair/messy2/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/light_brown.png","lpc/spritesheets/hair/messy2/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/light_brown.png.json","lpc/spritesheets/hair/messy2/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/orange.png","lpc/spritesheets/hair/messy2/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/orange.png.json","lpc/spritesheets/hair/messy2/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/purple.png","lpc/spritesheets/hair/messy2/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/purple.png.json","lpc/spritesheets/hair/messy2/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/red.png","lpc/spritesheets/hair/messy2/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/red.png.json","lpc/spritesheets/hair/messy2/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/white.png","lpc/spritesheets/hair/messy2/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/female/white.png.json","lpc/spritesheets/hair/messy2/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/black.png","lpc/spritesheets/hair/messy2/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/black.png.json","lpc/spritesheets/hair/messy2/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/blonde.png","lpc/spritesheets/hair/messy2/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/blonde.png.json","lpc/spritesheets/hair/messy2/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/blue.png","lpc/spritesheets/hair/messy2/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/blue.png.json","lpc/spritesheets/hair/messy2/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/dark_brown.png","lpc/spritesheets/hair/messy2/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/dark_brown.png.json","lpc/spritesheets/hair/messy2/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/gold.png","lpc/spritesheets/hair/messy2/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/gold.png.json","lpc/spritesheets/hair/messy2/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/gray.png","lpc/spritesheets/hair/messy2/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/gray.png.json","lpc/spritesheets/hair/messy2/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/green.png","lpc/spritesheets/hair/messy2/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/green.png.json","lpc/spritesheets/hair/messy2/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/light_brown.png","lpc/spritesheets/hair/messy2/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/light_brown.png.json","lpc/spritesheets/hair/messy2/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/orange.png","lpc/spritesheets/hair/messy2/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/orange.png.json","lpc/spritesheets/hair/messy2/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/purple.png","lpc/spritesheets/hair/messy2/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/purple.png.json","lpc/spritesheets/hair/messy2/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/red.png","lpc/spritesheets/hair/messy2/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/red.png.json","lpc/spritesheets/hair/messy2/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/white.png","lpc/spritesheets/hair/messy2/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy2/male/white.png.json","lpc/spritesheets/hair/messy3/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/black.png","lpc/spritesheets/hair/messy3/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/black.png.json","lpc/spritesheets/hair/messy3/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/blonde.png","lpc/spritesheets/hair/messy3/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/blonde.png.json","lpc/spritesheets/hair/messy3/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/blue.png","lpc/spritesheets/hair/messy3/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/blue.png.json","lpc/spritesheets/hair/messy3/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/dark_brown.png","lpc/spritesheets/hair/messy3/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/dark_brown.png.json","lpc/spritesheets/hair/messy3/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/gold.png","lpc/spritesheets/hair/messy3/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/gold.png.json","lpc/spritesheets/hair/messy3/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/gray.png","lpc/spritesheets/hair/messy3/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/gray.png.json","lpc/spritesheets/hair/messy3/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/green.png","lpc/spritesheets/hair/messy3/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/green.png.json","lpc/spritesheets/hair/messy3/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/light_brown.png","lpc/spritesheets/hair/messy3/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/light_brown.png.json","lpc/spritesheets/hair/messy3/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/orange.png","lpc/spritesheets/hair/messy3/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/orange.png.json","lpc/spritesheets/hair/messy3/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/purple.png","lpc/spritesheets/hair/messy3/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/purple.png.json","lpc/spritesheets/hair/messy3/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/red.png","lpc/spritesheets/hair/messy3/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/red.png.json","lpc/spritesheets/hair/messy3/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/white.png","lpc/spritesheets/hair/messy3/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/female/white.png.json","lpc/spritesheets/hair/messy3/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/black.png","lpc/spritesheets/hair/messy3/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/black.png.json","lpc/spritesheets/hair/messy3/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/blonde.png","lpc/spritesheets/hair/messy3/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/blonde.png.json","lpc/spritesheets/hair/messy3/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/blue.png","lpc/spritesheets/hair/messy3/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/blue.png.json","lpc/spritesheets/hair/messy3/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/dark_brown.png","lpc/spritesheets/hair/messy3/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/dark_brown.png.json","lpc/spritesheets/hair/messy3/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/gold.png","lpc/spritesheets/hair/messy3/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/gold.png.json","lpc/spritesheets/hair/messy3/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/gray.png","lpc/spritesheets/hair/messy3/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/gray.png.json","lpc/spritesheets/hair/messy3/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/green.png","lpc/spritesheets/hair/messy3/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/green.png.json","lpc/spritesheets/hair/messy3/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/light_brown.png","lpc/spritesheets/hair/messy3/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/light_brown.png.json","lpc/spritesheets/hair/messy3/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/orange.png","lpc/spritesheets/hair/messy3/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/orange.png.json","lpc/spritesheets/hair/messy3/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/purple.png","lpc/spritesheets/hair/messy3/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/purple.png.json","lpc/spritesheets/hair/messy3/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/red.png","lpc/spritesheets/hair/messy3/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/red.png.json","lpc/spritesheets/hair/messy3/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/white.png","lpc/spritesheets/hair/messy3/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/messy3/male/white.png.json","lpc/spritesheets/hair/mop/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/black.png","lpc/spritesheets/hair/mop/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/black.png.json","lpc/spritesheets/hair/mop/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/blonde.png","lpc/spritesheets/hair/mop/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/blonde.png.json","lpc/spritesheets/hair/mop/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/blue.png","lpc/spritesheets/hair/mop/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/blue.png.json","lpc/spritesheets/hair/mop/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/dark_brown.png","lpc/spritesheets/hair/mop/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/dark_brown.png.json","lpc/spritesheets/hair/mop/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/gold.png","lpc/spritesheets/hair/mop/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/gold.png.json","lpc/spritesheets/hair/mop/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/gray.png","lpc/spritesheets/hair/mop/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/gray.png.json","lpc/spritesheets/hair/mop/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/green.png","lpc/spritesheets/hair/mop/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/green.png.json","lpc/spritesheets/hair/mop/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/light_brown.png","lpc/spritesheets/hair/mop/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/light_brown.png.json","lpc/spritesheets/hair/mop/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/orange.png","lpc/spritesheets/hair/mop/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/orange.png.json","lpc/spritesheets/hair/mop/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/purple.png","lpc/spritesheets/hair/mop/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/purple.png.json","lpc/spritesheets/hair/mop/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/red.png","lpc/spritesheets/hair/mop/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/red.png.json","lpc/spritesheets/hair/mop/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/white.png","lpc/spritesheets/hair/mop/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/female/white.png.json","lpc/spritesheets/hair/mop/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/black.png","lpc/spritesheets/hair/mop/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/black.png.json","lpc/spritesheets/hair/mop/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/blonde.png","lpc/spritesheets/hair/mop/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/blonde.png.json","lpc/spritesheets/hair/mop/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/blue.png","lpc/spritesheets/hair/mop/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/blue.png.json","lpc/spritesheets/hair/mop/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/dark_brown.png","lpc/spritesheets/hair/mop/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/dark_brown.png.json","lpc/spritesheets/hair/mop/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/gold.png","lpc/spritesheets/hair/mop/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/gold.png.json","lpc/spritesheets/hair/mop/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/gray.png","lpc/spritesheets/hair/mop/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/gray.png.json","lpc/spritesheets/hair/mop/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/green.png","lpc/spritesheets/hair/mop/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/green.png.json","lpc/spritesheets/hair/mop/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/light_brown.png","lpc/spritesheets/hair/mop/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/light_brown.png.json","lpc/spritesheets/hair/mop/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/orange.png","lpc/spritesheets/hair/mop/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/orange.png.json","lpc/spritesheets/hair/mop/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/purple.png","lpc/spritesheets/hair/mop/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/purple.png.json","lpc/spritesheets/hair/mop/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/red.png","lpc/spritesheets/hair/mop/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/red.png.json","lpc/spritesheets/hair/mop/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/white.png","lpc/spritesheets/hair/mop/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/mop/male/white.png.json","lpc/spritesheets/hair/natural/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/black.png","lpc/spritesheets/hair/natural/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/black.png.json","lpc/spritesheets/hair/natural/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/blonde.png","lpc/spritesheets/hair/natural/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/blonde.png.json","lpc/spritesheets/hair/natural/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/blue.png","lpc/spritesheets/hair/natural/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/blue.png.json","lpc/spritesheets/hair/natural/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/dark_brown.png","lpc/spritesheets/hair/natural/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/dark_brown.png.json","lpc/spritesheets/hair/natural/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/gold.png","lpc/spritesheets/hair/natural/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/gold.png.json","lpc/spritesheets/hair/natural/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/gray.png","lpc/spritesheets/hair/natural/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/gray.png.json","lpc/spritesheets/hair/natural/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/green.png","lpc/spritesheets/hair/natural/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/green.png.json","lpc/spritesheets/hair/natural/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/light_brown.png","lpc/spritesheets/hair/natural/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/light_brown.png.json","lpc/spritesheets/hair/natural/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/orange.png","lpc/spritesheets/hair/natural/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/orange.png.json","lpc/spritesheets/hair/natural/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/purple.png","lpc/spritesheets/hair/natural/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/purple.png.json","lpc/spritesheets/hair/natural/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/red.png","lpc/spritesheets/hair/natural/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/red.png.json","lpc/spritesheets/hair/natural/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/white.png","lpc/spritesheets/hair/natural/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/female/white.png.json","lpc/spritesheets/hair/natural/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/black.png","lpc/spritesheets/hair/natural/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/black.png.json","lpc/spritesheets/hair/natural/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/blonde.png","lpc/spritesheets/hair/natural/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/blonde.png.json","lpc/spritesheets/hair/natural/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/blue.png","lpc/spritesheets/hair/natural/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/blue.png.json","lpc/spritesheets/hair/natural/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/dark_brown.png","lpc/spritesheets/hair/natural/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/dark_brown.png.json","lpc/spritesheets/hair/natural/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/gold.png","lpc/spritesheets/hair/natural/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/gold.png.json","lpc/spritesheets/hair/natural/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/gray.png","lpc/spritesheets/hair/natural/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/gray.png.json","lpc/spritesheets/hair/natural/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/green.png","lpc/spritesheets/hair/natural/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/green.png.json","lpc/spritesheets/hair/natural/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/light_brown.png","lpc/spritesheets/hair/natural/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/light_brown.png.json","lpc/spritesheets/hair/natural/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/orange.png","lpc/spritesheets/hair/natural/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/orange.png.json","lpc/spritesheets/hair/natural/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/purple.png","lpc/spritesheets/hair/natural/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/purple.png.json","lpc/spritesheets/hair/natural/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/red.png","lpc/spritesheets/hair/natural/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/red.png.json","lpc/spritesheets/hair/natural/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/white.png","lpc/spritesheets/hair/natural/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/natural/male/white.png.json","lpc/spritesheets/hair/page/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/black.png","lpc/spritesheets/hair/page/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/black.png.json","lpc/spritesheets/hair/page/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/blonde.png","lpc/spritesheets/hair/page/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/blonde.png.json","lpc/spritesheets/hair/page/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/blue.png","lpc/spritesheets/hair/page/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/blue.png.json","lpc/spritesheets/hair/page/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/dark_brown.png","lpc/spritesheets/hair/page/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/dark_brown.png.json","lpc/spritesheets/hair/page/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/gold.png","lpc/spritesheets/hair/page/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/gold.png.json","lpc/spritesheets/hair/page/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/gray.png","lpc/spritesheets/hair/page/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/gray.png.json","lpc/spritesheets/hair/page/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/green.png","lpc/spritesheets/hair/page/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/green.png.json","lpc/spritesheets/hair/page/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/light_brown.png","lpc/spritesheets/hair/page/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/light_brown.png.json","lpc/spritesheets/hair/page/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/orange.png","lpc/spritesheets/hair/page/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/orange.png.json","lpc/spritesheets/hair/page/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/purple.png","lpc/spritesheets/hair/page/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/purple.png.json","lpc/spritesheets/hair/page/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/red.png","lpc/spritesheets/hair/page/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/red.png.json","lpc/spritesheets/hair/page/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/white.png","lpc/spritesheets/hair/page/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/female/white.png.json","lpc/spritesheets/hair/page/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/black.png","lpc/spritesheets/hair/page/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/black.png.json","lpc/spritesheets/hair/page/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/blonde.png","lpc/spritesheets/hair/page/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/blonde.png.json","lpc/spritesheets/hair/page/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/blue.png","lpc/spritesheets/hair/page/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/blue.png.json","lpc/spritesheets/hair/page/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/dark_brown.png","lpc/spritesheets/hair/page/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/dark_brown.png.json","lpc/spritesheets/hair/page/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/gold.png","lpc/spritesheets/hair/page/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/gold.png.json","lpc/spritesheets/hair/page/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/gray.png","lpc/spritesheets/hair/page/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/gray.png.json","lpc/spritesheets/hair/page/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/green.png","lpc/spritesheets/hair/page/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/green.png.json","lpc/spritesheets/hair/page/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/light_brown.png","lpc/spritesheets/hair/page/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/light_brown.png.json","lpc/spritesheets/hair/page/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/orange.png","lpc/spritesheets/hair/page/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/orange.png.json","lpc/spritesheets/hair/page/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/purple.png","lpc/spritesheets/hair/page/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/purple.png.json","lpc/spritesheets/hair/page/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/red.png","lpc/spritesheets/hair/page/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/red.png.json","lpc/spritesheets/hair/page/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/white.png","lpc/spritesheets/hair/page/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page/male/white.png.json","lpc/spritesheets/hair/page2/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/black.png","lpc/spritesheets/hair/page2/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/black.png.json","lpc/spritesheets/hair/page2/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/blonde.png","lpc/spritesheets/hair/page2/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/blonde.png.json","lpc/spritesheets/hair/page2/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/blue.png","lpc/spritesheets/hair/page2/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/blue.png.json","lpc/spritesheets/hair/page2/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/dark_brown.png","lpc/spritesheets/hair/page2/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/dark_brown.png.json","lpc/spritesheets/hair/page2/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/gold.png","lpc/spritesheets/hair/page2/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/gold.png.json","lpc/spritesheets/hair/page2/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/gray.png","lpc/spritesheets/hair/page2/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/gray.png.json","lpc/spritesheets/hair/page2/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/green.png","lpc/spritesheets/hair/page2/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/green.png.json","lpc/spritesheets/hair/page2/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/light_brown.png","lpc/spritesheets/hair/page2/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/light_brown.png.json","lpc/spritesheets/hair/page2/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/orange.png","lpc/spritesheets/hair/page2/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/orange.png.json","lpc/spritesheets/hair/page2/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/purple.png","lpc/spritesheets/hair/page2/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/purple.png.json","lpc/spritesheets/hair/page2/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/red.png","lpc/spritesheets/hair/page2/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/red.png.json","lpc/spritesheets/hair/page2/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/white.png","lpc/spritesheets/hair/page2/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/female/white.png.json","lpc/spritesheets/hair/page2/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/black.png","lpc/spritesheets/hair/page2/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/black.png.json","lpc/spritesheets/hair/page2/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/blonde.png","lpc/spritesheets/hair/page2/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/blonde.png.json","lpc/spritesheets/hair/page2/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/blue.png","lpc/spritesheets/hair/page2/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/blue.png.json","lpc/spritesheets/hair/page2/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/dark_brown.png","lpc/spritesheets/hair/page2/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/dark_brown.png.json","lpc/spritesheets/hair/page2/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/gold.png","lpc/spritesheets/hair/page2/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/gold.png.json","lpc/spritesheets/hair/page2/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/gray.png","lpc/spritesheets/hair/page2/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/gray.png.json","lpc/spritesheets/hair/page2/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/green.png","lpc/spritesheets/hair/page2/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/green.png.json","lpc/spritesheets/hair/page2/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/light_brown.png","lpc/spritesheets/hair/page2/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/light_brown.png.json","lpc/spritesheets/hair/page2/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/orange.png","lpc/spritesheets/hair/page2/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/orange.png.json","lpc/spritesheets/hair/page2/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/purple.png","lpc/spritesheets/hair/page2/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/purple.png.json","lpc/spritesheets/hair/page2/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/red.png","lpc/spritesheets/hair/page2/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/red.png.json","lpc/spritesheets/hair/page2/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/white.png","lpc/spritesheets/hair/page2/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/page2/male/white.png.json","lpc/spritesheets/hair/part2/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/black.png","lpc/spritesheets/hair/part2/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/black.png.json","lpc/spritesheets/hair/part2/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/blonde.png","lpc/spritesheets/hair/part2/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/blonde.png.json","lpc/spritesheets/hair/part2/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/blue.png","lpc/spritesheets/hair/part2/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/blue.png.json","lpc/spritesheets/hair/part2/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/dark_brown.png","lpc/spritesheets/hair/part2/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/dark_brown.png.json","lpc/spritesheets/hair/part2/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/gold.png","lpc/spritesheets/hair/part2/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/gold.png.json","lpc/spritesheets/hair/part2/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/gray.png","lpc/spritesheets/hair/part2/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/gray.png.json","lpc/spritesheets/hair/part2/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/green.png","lpc/spritesheets/hair/part2/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/green.png.json","lpc/spritesheets/hair/part2/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/light_brown.png","lpc/spritesheets/hair/part2/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/light_brown.png.json","lpc/spritesheets/hair/part2/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/orange.png","lpc/spritesheets/hair/part2/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/orange.png.json","lpc/spritesheets/hair/part2/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/purple.png","lpc/spritesheets/hair/part2/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/purple.png.json","lpc/spritesheets/hair/part2/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/red.png","lpc/spritesheets/hair/part2/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/red.png.json","lpc/spritesheets/hair/part2/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/white.png","lpc/spritesheets/hair/part2/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/female/white.png.json","lpc/spritesheets/hair/part2/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/black.png","lpc/spritesheets/hair/part2/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/black.png.json","lpc/spritesheets/hair/part2/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/blonde.png","lpc/spritesheets/hair/part2/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/blonde.png.json","lpc/spritesheets/hair/part2/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/blue.png","lpc/spritesheets/hair/part2/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/blue.png.json","lpc/spritesheets/hair/part2/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/dark_brown.png","lpc/spritesheets/hair/part2/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/dark_brown.png.json","lpc/spritesheets/hair/part2/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/gold.png","lpc/spritesheets/hair/part2/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/gold.png.json","lpc/spritesheets/hair/part2/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/gray.png","lpc/spritesheets/hair/part2/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/gray.png.json","lpc/spritesheets/hair/part2/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/green.png","lpc/spritesheets/hair/part2/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/green.png.json","lpc/spritesheets/hair/part2/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/light_brown.png","lpc/spritesheets/hair/part2/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/light_brown.png.json","lpc/spritesheets/hair/part2/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/orange.png","lpc/spritesheets/hair/part2/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/orange.png.json","lpc/spritesheets/hair/part2/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/purple.png","lpc/spritesheets/hair/part2/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/purple.png.json","lpc/spritesheets/hair/part2/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/red.png","lpc/spritesheets/hair/part2/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/red.png.json","lpc/spritesheets/hair/part2/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/white.png","lpc/spritesheets/hair/part2/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/part2/male/white.png.json","lpc/spritesheets/hair/parted/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/black.png","lpc/spritesheets/hair/parted/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/black.png.json","lpc/spritesheets/hair/parted/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/blonde.png","lpc/spritesheets/hair/parted/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/blonde.png.json","lpc/spritesheets/hair/parted/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/blue.png","lpc/spritesheets/hair/parted/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/blue.png.json","lpc/spritesheets/hair/parted/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/dark_brown.png","lpc/spritesheets/hair/parted/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/dark_brown.png.json","lpc/spritesheets/hair/parted/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/gold.png","lpc/spritesheets/hair/parted/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/gold.png.json","lpc/spritesheets/hair/parted/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/gray.png","lpc/spritesheets/hair/parted/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/gray.png.json","lpc/spritesheets/hair/parted/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/green.png","lpc/spritesheets/hair/parted/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/green.png.json","lpc/spritesheets/hair/parted/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/light_brown.png","lpc/spritesheets/hair/parted/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/light_brown.png.json","lpc/spritesheets/hair/parted/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/orange.png","lpc/spritesheets/hair/parted/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/orange.png.json","lpc/spritesheets/hair/parted/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/purple.png","lpc/spritesheets/hair/parted/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/purple.png.json","lpc/spritesheets/hair/parted/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/red.png","lpc/spritesheets/hair/parted/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/red.png.json","lpc/spritesheets/hair/parted/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/white.png","lpc/spritesheets/hair/parted/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/female/white.png.json","lpc/spritesheets/hair/parted/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/black.png","lpc/spritesheets/hair/parted/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/black.png.json","lpc/spritesheets/hair/parted/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/blonde.png","lpc/spritesheets/hair/parted/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/blonde.png.json","lpc/spritesheets/hair/parted/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/blue.png","lpc/spritesheets/hair/parted/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/blue.png.json","lpc/spritesheets/hair/parted/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/dark_brown.png","lpc/spritesheets/hair/parted/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/dark_brown.png.json","lpc/spritesheets/hair/parted/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/gold.png","lpc/spritesheets/hair/parted/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/gold.png.json","lpc/spritesheets/hair/parted/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/gray.png","lpc/spritesheets/hair/parted/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/gray.png.json","lpc/spritesheets/hair/parted/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/green.png","lpc/spritesheets/hair/parted/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/green.png.json","lpc/spritesheets/hair/parted/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/light_brown.png","lpc/spritesheets/hair/parted/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/light_brown.png.json","lpc/spritesheets/hair/parted/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/orange.png","lpc/spritesheets/hair/parted/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/orange.png.json","lpc/spritesheets/hair/parted/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/purple.png","lpc/spritesheets/hair/parted/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/purple.png.json","lpc/spritesheets/hair/parted/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/red.png","lpc/spritesheets/hair/parted/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/red.png.json","lpc/spritesheets/hair/parted/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/white.png","lpc/spritesheets/hair/parted/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/parted/male/white.png.json","lpc/spritesheets/hair/pigtails/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/black.png","lpc/spritesheets/hair/pigtails/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/black.png.json","lpc/spritesheets/hair/pigtails/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/blonde.png","lpc/spritesheets/hair/pigtails/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/blonde.png.json","lpc/spritesheets/hair/pigtails/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/blue.png","lpc/spritesheets/hair/pigtails/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/blue.png.json","lpc/spritesheets/hair/pigtails/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/dark_brown.png","lpc/spritesheets/hair/pigtails/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/dark_brown.png.json","lpc/spritesheets/hair/pigtails/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/gold.png","lpc/spritesheets/hair/pigtails/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/gold.png.json","lpc/spritesheets/hair/pigtails/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/gray.png","lpc/spritesheets/hair/pigtails/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/gray.png.json","lpc/spritesheets/hair/pigtails/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/green.png","lpc/spritesheets/hair/pigtails/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/green.png.json","lpc/spritesheets/hair/pigtails/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/light_brown.png","lpc/spritesheets/hair/pigtails/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/light_brown.png.json","lpc/spritesheets/hair/pigtails/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/orange.png","lpc/spritesheets/hair/pigtails/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/orange.png.json","lpc/spritesheets/hair/pigtails/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/purple.png","lpc/spritesheets/hair/pigtails/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/purple.png.json","lpc/spritesheets/hair/pigtails/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/red.png","lpc/spritesheets/hair/pigtails/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/red.png.json","lpc/spritesheets/hair/pigtails/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/white.png","lpc/spritesheets/hair/pigtails/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/female/white.png.json","lpc/spritesheets/hair/pigtails/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/black.png","lpc/spritesheets/hair/pigtails/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/black.png.json","lpc/spritesheets/hair/pigtails/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/blonde.png","lpc/spritesheets/hair/pigtails/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/blonde.png.json","lpc/spritesheets/hair/pigtails/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/blue.png","lpc/spritesheets/hair/pigtails/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/blue.png.json","lpc/spritesheets/hair/pigtails/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/dark_brown.png","lpc/spritesheets/hair/pigtails/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/dark_brown.png.json","lpc/spritesheets/hair/pigtails/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/gold.png","lpc/spritesheets/hair/pigtails/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/gold.png.json","lpc/spritesheets/hair/pigtails/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/gray.png","lpc/spritesheets/hair/pigtails/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/gray.png.json","lpc/spritesheets/hair/pigtails/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/green.png","lpc/spritesheets/hair/pigtails/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/green.png.json","lpc/spritesheets/hair/pigtails/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/light_brown.png","lpc/spritesheets/hair/pigtails/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/light_brown.png.json","lpc/spritesheets/hair/pigtails/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/orange.png","lpc/spritesheets/hair/pigtails/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/orange.png.json","lpc/spritesheets/hair/pigtails/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/purple.png","lpc/spritesheets/hair/pigtails/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/purple.png.json","lpc/spritesheets/hair/pigtails/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/red.png","lpc/spritesheets/hair/pigtails/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/red.png.json","lpc/spritesheets/hair/pigtails/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/white.png","lpc/spritesheets/hair/pigtails/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails/male/white.png.json","lpc/spritesheets/hair/pigtails_bangs/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/black.png","lpc/spritesheets/hair/pigtails_bangs/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/black.png.json","lpc/spritesheets/hair/pigtails_bangs/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/blonde.png","lpc/spritesheets/hair/pigtails_bangs/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/blonde.png.json","lpc/spritesheets/hair/pigtails_bangs/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/blue.png","lpc/spritesheets/hair/pigtails_bangs/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/blue.png.json","lpc/spritesheets/hair/pigtails_bangs/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/dark_brown.png","lpc/spritesheets/hair/pigtails_bangs/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/dark_brown.png.json","lpc/spritesheets/hair/pigtails_bangs/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/gold.png","lpc/spritesheets/hair/pigtails_bangs/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/gold.png.json","lpc/spritesheets/hair/pigtails_bangs/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/gray.png","lpc/spritesheets/hair/pigtails_bangs/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/gray.png.json","lpc/spritesheets/hair/pigtails_bangs/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/green.png","lpc/spritesheets/hair/pigtails_bangs/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/green.png.json","lpc/spritesheets/hair/pigtails_bangs/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/light_brown.png","lpc/spritesheets/hair/pigtails_bangs/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/light_brown.png.json","lpc/spritesheets/hair/pigtails_bangs/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/orange.png","lpc/spritesheets/hair/pigtails_bangs/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/orange.png.json","lpc/spritesheets/hair/pigtails_bangs/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/purple.png","lpc/spritesheets/hair/pigtails_bangs/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/purple.png.json","lpc/spritesheets/hair/pigtails_bangs/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/red.png","lpc/spritesheets/hair/pigtails_bangs/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/red.png.json","lpc/spritesheets/hair/pigtails_bangs/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/white.png","lpc/spritesheets/hair/pigtails_bangs/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/female/white.png.json","lpc/spritesheets/hair/pigtails_bangs/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/black.png","lpc/spritesheets/hair/pigtails_bangs/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/black.png.json","lpc/spritesheets/hair/pigtails_bangs/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/blonde.png","lpc/spritesheets/hair/pigtails_bangs/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/blonde.png.json","lpc/spritesheets/hair/pigtails_bangs/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/blue.png","lpc/spritesheets/hair/pigtails_bangs/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/blue.png.json","lpc/spritesheets/hair/pigtails_bangs/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/dark_brown.png","lpc/spritesheets/hair/pigtails_bangs/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/dark_brown.png.json","lpc/spritesheets/hair/pigtails_bangs/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/gold.png","lpc/spritesheets/hair/pigtails_bangs/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/gold.png.json","lpc/spritesheets/hair/pigtails_bangs/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/gray.png","lpc/spritesheets/hair/pigtails_bangs/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/gray.png.json","lpc/spritesheets/hair/pigtails_bangs/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/green.png","lpc/spritesheets/hair/pigtails_bangs/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/green.png.json","lpc/spritesheets/hair/pigtails_bangs/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/light_brown.png","lpc/spritesheets/hair/pigtails_bangs/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/light_brown.png.json","lpc/spritesheets/hair/pigtails_bangs/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/orange.png","lpc/spritesheets/hair/pigtails_bangs/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/orange.png.json","lpc/spritesheets/hair/pigtails_bangs/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/purple.png","lpc/spritesheets/hair/pigtails_bangs/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/purple.png.json","lpc/spritesheets/hair/pigtails_bangs/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/red.png","lpc/spritesheets/hair/pigtails_bangs/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/red.png.json","lpc/spritesheets/hair/pigtails_bangs/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/white.png","lpc/spritesheets/hair/pigtails_bangs/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pigtails_bangs/male/white.png.json","lpc/spritesheets/hair/pixie/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/black.png","lpc/spritesheets/hair/pixie/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/black.png.json","lpc/spritesheets/hair/pixie/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/blonde.png","lpc/spritesheets/hair/pixie/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/blonde.png.json","lpc/spritesheets/hair/pixie/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/blue.png","lpc/spritesheets/hair/pixie/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/blue.png.json","lpc/spritesheets/hair/pixie/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/dark_brown.png","lpc/spritesheets/hair/pixie/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/dark_brown.png.json","lpc/spritesheets/hair/pixie/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/gold.png","lpc/spritesheets/hair/pixie/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/gold.png.json","lpc/spritesheets/hair/pixie/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/gray.png","lpc/spritesheets/hair/pixie/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/gray.png.json","lpc/spritesheets/hair/pixie/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/green.png","lpc/spritesheets/hair/pixie/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/green.png.json","lpc/spritesheets/hair/pixie/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/light_brown.png","lpc/spritesheets/hair/pixie/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/light_brown.png.json","lpc/spritesheets/hair/pixie/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/orange.png","lpc/spritesheets/hair/pixie/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/orange.png.json","lpc/spritesheets/hair/pixie/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/purple.png","lpc/spritesheets/hair/pixie/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/purple.png.json","lpc/spritesheets/hair/pixie/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/red.png","lpc/spritesheets/hair/pixie/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/red.png.json","lpc/spritesheets/hair/pixie/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/white.png","lpc/spritesheets/hair/pixie/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/female/white.png.json","lpc/spritesheets/hair/pixie/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/black.png","lpc/spritesheets/hair/pixie/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/black.png.json","lpc/spritesheets/hair/pixie/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/blonde.png","lpc/spritesheets/hair/pixie/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/blonde.png.json","lpc/spritesheets/hair/pixie/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/blue.png","lpc/spritesheets/hair/pixie/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/blue.png.json","lpc/spritesheets/hair/pixie/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/dark_brown.png","lpc/spritesheets/hair/pixie/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/dark_brown.png.json","lpc/spritesheets/hair/pixie/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/gold.png","lpc/spritesheets/hair/pixie/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/gold.png.json","lpc/spritesheets/hair/pixie/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/gray.png","lpc/spritesheets/hair/pixie/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/gray.png.json","lpc/spritesheets/hair/pixie/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/green.png","lpc/spritesheets/hair/pixie/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/green.png.json","lpc/spritesheets/hair/pixie/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/light_brown.png","lpc/spritesheets/hair/pixie/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/light_brown.png.json","lpc/spritesheets/hair/pixie/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/orange.png","lpc/spritesheets/hair/pixie/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/orange.png.json","lpc/spritesheets/hair/pixie/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/purple.png","lpc/spritesheets/hair/pixie/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/purple.png.json","lpc/spritesheets/hair/pixie/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/red.png","lpc/spritesheets/hair/pixie/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/red.png.json","lpc/spritesheets/hair/pixie/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/white.png","lpc/spritesheets/hair/pixie/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/pixie/male/white.png.json","lpc/spritesheets/hair/plain/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/black.png","lpc/spritesheets/hair/plain/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/black.png.json","lpc/spritesheets/hair/plain/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/blonde.png","lpc/spritesheets/hair/plain/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/blonde.png.json","lpc/spritesheets/hair/plain/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/blue.png","lpc/spritesheets/hair/plain/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/blue.png.json","lpc/spritesheets/hair/plain/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/dark_brown.png","lpc/spritesheets/hair/plain/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/dark_brown.png.json","lpc/spritesheets/hair/plain/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/gold.png","lpc/spritesheets/hair/plain/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/gold.png.json","lpc/spritesheets/hair/plain/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/gray.png","lpc/spritesheets/hair/plain/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/gray.png.json","lpc/spritesheets/hair/plain/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/green.png","lpc/spritesheets/hair/plain/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/green.png.json","lpc/spritesheets/hair/plain/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/light_brown.png","lpc/spritesheets/hair/plain/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/light_brown.png.json","lpc/spritesheets/hair/plain/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/orange.png","lpc/spritesheets/hair/plain/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/orange.png.json","lpc/spritesheets/hair/plain/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/purple.png","lpc/spritesheets/hair/plain/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/purple.png.json","lpc/spritesheets/hair/plain/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/red.png","lpc/spritesheets/hair/plain/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/red.png.json","lpc/spritesheets/hair/plain/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/white.png","lpc/spritesheets/hair/plain/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/female/white.png.json","lpc/spritesheets/hair/plain/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/black.png","lpc/spritesheets/hair/plain/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/black.png.json","lpc/spritesheets/hair/plain/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/blonde.png","lpc/spritesheets/hair/plain/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/blonde.png.json","lpc/spritesheets/hair/plain/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/blue.png","lpc/spritesheets/hair/plain/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/blue.png.json","lpc/spritesheets/hair/plain/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/dark_brown.png","lpc/spritesheets/hair/plain/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/dark_brown.png.json","lpc/spritesheets/hair/plain/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/gold.png","lpc/spritesheets/hair/plain/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/gold.png.json","lpc/spritesheets/hair/plain/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/gray.png","lpc/spritesheets/hair/plain/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/gray.png.json","lpc/spritesheets/hair/plain/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/green.png","lpc/spritesheets/hair/plain/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/green.png.json","lpc/spritesheets/hair/plain/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/light_brown.png","lpc/spritesheets/hair/plain/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/light_brown.png.json","lpc/spritesheets/hair/plain/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/orange.png","lpc/spritesheets/hair/plain/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/orange.png.json","lpc/spritesheets/hair/plain/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/purple.png","lpc/spritesheets/hair/plain/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/purple.png.json","lpc/spritesheets/hair/plain/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/red.png","lpc/spritesheets/hair/plain/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/red.png.json","lpc/spritesheets/hair/plain/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/white.png","lpc/spritesheets/hair/plain/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/plain/male/white.png.json","lpc/spritesheets/hair/ponytail/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/black.png","lpc/spritesheets/hair/ponytail/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/black.png.json","lpc/spritesheets/hair/ponytail/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/blonde.png","lpc/spritesheets/hair/ponytail/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/blonde.png.json","lpc/spritesheets/hair/ponytail/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/blue.png","lpc/spritesheets/hair/ponytail/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/blue.png.json","lpc/spritesheets/hair/ponytail/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/dark_brown.png","lpc/spritesheets/hair/ponytail/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/dark_brown.png.json","lpc/spritesheets/hair/ponytail/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/gold.png","lpc/spritesheets/hair/ponytail/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/gold.png.json","lpc/spritesheets/hair/ponytail/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/gray.png","lpc/spritesheets/hair/ponytail/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/gray.png.json","lpc/spritesheets/hair/ponytail/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/green.png","lpc/spritesheets/hair/ponytail/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/green.png.json","lpc/spritesheets/hair/ponytail/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/light_brown.png","lpc/spritesheets/hair/ponytail/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/light_brown.png.json","lpc/spritesheets/hair/ponytail/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/orange.png","lpc/spritesheets/hair/ponytail/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/orange.png.json","lpc/spritesheets/hair/ponytail/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/purple.png","lpc/spritesheets/hair/ponytail/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/purple.png.json","lpc/spritesheets/hair/ponytail/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/red.png","lpc/spritesheets/hair/ponytail/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/red.png.json","lpc/spritesheets/hair/ponytail/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/white.png","lpc/spritesheets/hair/ponytail/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/female/white.png.json","lpc/spritesheets/hair/ponytail/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/black.png","lpc/spritesheets/hair/ponytail/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/black.png.json","lpc/spritesheets/hair/ponytail/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/blonde.png","lpc/spritesheets/hair/ponytail/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/blonde.png.json","lpc/spritesheets/hair/ponytail/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/blue.png","lpc/spritesheets/hair/ponytail/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/blue.png.json","lpc/spritesheets/hair/ponytail/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/dark_brown.png","lpc/spritesheets/hair/ponytail/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/dark_brown.png.json","lpc/spritesheets/hair/ponytail/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/gold.png","lpc/spritesheets/hair/ponytail/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/gold.png.json","lpc/spritesheets/hair/ponytail/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/gray.png","lpc/spritesheets/hair/ponytail/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/gray.png.json","lpc/spritesheets/hair/ponytail/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/green.png","lpc/spritesheets/hair/ponytail/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/green.png.json","lpc/spritesheets/hair/ponytail/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/light_brown.png","lpc/spritesheets/hair/ponytail/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/light_brown.png.json","lpc/spritesheets/hair/ponytail/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/orange.png","lpc/spritesheets/hair/ponytail/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/orange.png.json","lpc/spritesheets/hair/ponytail/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/purple.png","lpc/spritesheets/hair/ponytail/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/purple.png.json","lpc/spritesheets/hair/ponytail/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/red.png","lpc/spritesheets/hair/ponytail/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/red.png.json","lpc/spritesheets/hair/ponytail/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/white.png","lpc/spritesheets/hair/ponytail/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail/male/white.png.json","lpc/spritesheets/hair/ponytail2/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/black.png","lpc/spritesheets/hair/ponytail2/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/black.png.json","lpc/spritesheets/hair/ponytail2/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/blonde.png","lpc/spritesheets/hair/ponytail2/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/blonde.png.json","lpc/spritesheets/hair/ponytail2/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/blue.png","lpc/spritesheets/hair/ponytail2/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/blue.png.json","lpc/spritesheets/hair/ponytail2/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/dark_brown.png","lpc/spritesheets/hair/ponytail2/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/dark_brown.png.json","lpc/spritesheets/hair/ponytail2/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/gold.png","lpc/spritesheets/hair/ponytail2/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/gold.png.json","lpc/spritesheets/hair/ponytail2/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/gray.png","lpc/spritesheets/hair/ponytail2/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/gray.png.json","lpc/spritesheets/hair/ponytail2/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/green.png","lpc/spritesheets/hair/ponytail2/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/green.png.json","lpc/spritesheets/hair/ponytail2/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/light_brown.png","lpc/spritesheets/hair/ponytail2/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/light_brown.png.json","lpc/spritesheets/hair/ponytail2/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/orange.png","lpc/spritesheets/hair/ponytail2/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/orange.png.json","lpc/spritesheets/hair/ponytail2/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/purple.png","lpc/spritesheets/hair/ponytail2/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/purple.png.json","lpc/spritesheets/hair/ponytail2/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/red.png","lpc/spritesheets/hair/ponytail2/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/red.png.json","lpc/spritesheets/hair/ponytail2/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/white.png","lpc/spritesheets/hair/ponytail2/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/female/white.png.json","lpc/spritesheets/hair/ponytail2/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/black.png","lpc/spritesheets/hair/ponytail2/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/black.png.json","lpc/spritesheets/hair/ponytail2/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/blonde.png","lpc/spritesheets/hair/ponytail2/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/blonde.png.json","lpc/spritesheets/hair/ponytail2/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/blue.png","lpc/spritesheets/hair/ponytail2/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/blue.png.json","lpc/spritesheets/hair/ponytail2/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/dark_brown.png","lpc/spritesheets/hair/ponytail2/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/dark_brown.png.json","lpc/spritesheets/hair/ponytail2/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/gold.png","lpc/spritesheets/hair/ponytail2/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/gold.png.json","lpc/spritesheets/hair/ponytail2/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/gray.png","lpc/spritesheets/hair/ponytail2/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/gray.png.json","lpc/spritesheets/hair/ponytail2/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/green.png","lpc/spritesheets/hair/ponytail2/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/green.png.json","lpc/spritesheets/hair/ponytail2/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/light_brown.png","lpc/spritesheets/hair/ponytail2/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/light_brown.png.json","lpc/spritesheets/hair/ponytail2/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/orange.png","lpc/spritesheets/hair/ponytail2/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/orange.png.json","lpc/spritesheets/hair/ponytail2/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/purple.png","lpc/spritesheets/hair/ponytail2/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/purple.png.json","lpc/spritesheets/hair/ponytail2/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/red.png","lpc/spritesheets/hair/ponytail2/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/red.png.json","lpc/spritesheets/hair/ponytail2/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/white.png","lpc/spritesheets/hair/ponytail2/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/ponytail2/male/white.png.json","lpc/spritesheets/hair/princess/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/black.png","lpc/spritesheets/hair/princess/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/black.png.json","lpc/spritesheets/hair/princess/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/blonde.png","lpc/spritesheets/hair/princess/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/blonde.png.json","lpc/spritesheets/hair/princess/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/blue.png","lpc/spritesheets/hair/princess/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/blue.png.json","lpc/spritesheets/hair/princess/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/dark_brown.png","lpc/spritesheets/hair/princess/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/dark_brown.png.json","lpc/spritesheets/hair/princess/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/gold.png","lpc/spritesheets/hair/princess/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/gold.png.json","lpc/spritesheets/hair/princess/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/gray.png","lpc/spritesheets/hair/princess/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/gray.png.json","lpc/spritesheets/hair/princess/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/green.png","lpc/spritesheets/hair/princess/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/green.png.json","lpc/spritesheets/hair/princess/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/light_brown.png","lpc/spritesheets/hair/princess/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/light_brown.png.json","lpc/spritesheets/hair/princess/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/orange.png","lpc/spritesheets/hair/princess/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/orange.png.json","lpc/spritesheets/hair/princess/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/purple.png","lpc/spritesheets/hair/princess/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/purple.png.json","lpc/spritesheets/hair/princess/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/red.png","lpc/spritesheets/hair/princess/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/red.png.json","lpc/spritesheets/hair/princess/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/white.png","lpc/spritesheets/hair/princess/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/female/white.png.json","lpc/spritesheets/hair/princess/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/black.png","lpc/spritesheets/hair/princess/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/black.png.json","lpc/spritesheets/hair/princess/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/blonde.png","lpc/spritesheets/hair/princess/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/blonde.png.json","lpc/spritesheets/hair/princess/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/blue.png","lpc/spritesheets/hair/princess/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/blue.png.json","lpc/spritesheets/hair/princess/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/dark_brown.png","lpc/spritesheets/hair/princess/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/dark_brown.png.json","lpc/spritesheets/hair/princess/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/gold.png","lpc/spritesheets/hair/princess/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/gold.png.json","lpc/spritesheets/hair/princess/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/gray.png","lpc/spritesheets/hair/princess/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/gray.png.json","lpc/spritesheets/hair/princess/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/green.png","lpc/spritesheets/hair/princess/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/green.png.json","lpc/spritesheets/hair/princess/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/light_brown.png","lpc/spritesheets/hair/princess/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/light_brown.png.json","lpc/spritesheets/hair/princess/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/orange.png","lpc/spritesheets/hair/princess/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/orange.png.json","lpc/spritesheets/hair/princess/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/purple.png","lpc/spritesheets/hair/princess/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/purple.png.json","lpc/spritesheets/hair/princess/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/red.png","lpc/spritesheets/hair/princess/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/red.png.json","lpc/spritesheets/hair/princess/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/white.png","lpc/spritesheets/hair/princess/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/princess/male/white.png.json","lpc/spritesheets/hair/sara/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/black.png","lpc/spritesheets/hair/sara/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/black.png.json","lpc/spritesheets/hair/sara/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/blonde.png","lpc/spritesheets/hair/sara/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/blonde.png.json","lpc/spritesheets/hair/sara/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/blue.png","lpc/spritesheets/hair/sara/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/blue.png.json","lpc/spritesheets/hair/sara/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/dark_brown.png","lpc/spritesheets/hair/sara/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/dark_brown.png.json","lpc/spritesheets/hair/sara/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/gold.png","lpc/spritesheets/hair/sara/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/gold.png.json","lpc/spritesheets/hair/sara/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/gray.png","lpc/spritesheets/hair/sara/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/gray.png.json","lpc/spritesheets/hair/sara/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/green.png","lpc/spritesheets/hair/sara/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/green.png.json","lpc/spritesheets/hair/sara/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/light_brown.png","lpc/spritesheets/hair/sara/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/light_brown.png.json","lpc/spritesheets/hair/sara/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/orange.png","lpc/spritesheets/hair/sara/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/orange.png.json","lpc/spritesheets/hair/sara/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/purple.png","lpc/spritesheets/hair/sara/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/purple.png.json","lpc/spritesheets/hair/sara/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/red.png","lpc/spritesheets/hair/sara/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/red.png.json","lpc/spritesheets/hair/sara/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/white.png","lpc/spritesheets/hair/sara/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/female/white.png.json","lpc/spritesheets/hair/sara/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/black.png","lpc/spritesheets/hair/sara/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/black.png.json","lpc/spritesheets/hair/sara/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/blonde.png","lpc/spritesheets/hair/sara/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/blonde.png.json","lpc/spritesheets/hair/sara/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/blue.png","lpc/spritesheets/hair/sara/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/blue.png.json","lpc/spritesheets/hair/sara/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/dark_brown.png","lpc/spritesheets/hair/sara/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/dark_brown.png.json","lpc/spritesheets/hair/sara/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/gold.png","lpc/spritesheets/hair/sara/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/gold.png.json","lpc/spritesheets/hair/sara/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/gray.png","lpc/spritesheets/hair/sara/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/gray.png.json","lpc/spritesheets/hair/sara/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/green.png","lpc/spritesheets/hair/sara/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/green.png.json","lpc/spritesheets/hair/sara/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/light_brown.png","lpc/spritesheets/hair/sara/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/light_brown.png.json","lpc/spritesheets/hair/sara/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/orange.png","lpc/spritesheets/hair/sara/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/orange.png.json","lpc/spritesheets/hair/sara/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/purple.png","lpc/spritesheets/hair/sara/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/purple.png.json","lpc/spritesheets/hair/sara/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/red.png","lpc/spritesheets/hair/sara/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/red.png.json","lpc/spritesheets/hair/sara/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/white.png","lpc/spritesheets/hair/sara/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/sara/male/white.png.json","lpc/spritesheets/hair/shorthawk/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/black.png","lpc/spritesheets/hair/shorthawk/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/black.png.json","lpc/spritesheets/hair/shorthawk/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/blonde.png","lpc/spritesheets/hair/shorthawk/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/blonde.png.json","lpc/spritesheets/hair/shorthawk/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/blue.png","lpc/spritesheets/hair/shorthawk/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/blue.png.json","lpc/spritesheets/hair/shorthawk/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/dark_brown.png","lpc/spritesheets/hair/shorthawk/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/dark_brown.png.json","lpc/spritesheets/hair/shorthawk/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/gold.png","lpc/spritesheets/hair/shorthawk/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/gold.png.json","lpc/spritesheets/hair/shorthawk/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/gray.png","lpc/spritesheets/hair/shorthawk/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/gray.png.json","lpc/spritesheets/hair/shorthawk/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/green.png","lpc/spritesheets/hair/shorthawk/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/green.png.json","lpc/spritesheets/hair/shorthawk/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/light_brown.png","lpc/spritesheets/hair/shorthawk/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/light_brown.png.json","lpc/spritesheets/hair/shorthawk/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/orange.png","lpc/spritesheets/hair/shorthawk/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/orange.png.json","lpc/spritesheets/hair/shorthawk/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/purple.png","lpc/spritesheets/hair/shorthawk/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/purple.png.json","lpc/spritesheets/hair/shorthawk/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/red.png","lpc/spritesheets/hair/shorthawk/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/red.png.json","lpc/spritesheets/hair/shorthawk/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/white.png","lpc/spritesheets/hair/shorthawk/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/female/white.png.json","lpc/spritesheets/hair/shorthawk/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/black.png","lpc/spritesheets/hair/shorthawk/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/black.png.json","lpc/spritesheets/hair/shorthawk/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/blonde.png","lpc/spritesheets/hair/shorthawk/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/blonde.png.json","lpc/spritesheets/hair/shorthawk/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/blue.png","lpc/spritesheets/hair/shorthawk/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/blue.png.json","lpc/spritesheets/hair/shorthawk/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/dark_brown.png","lpc/spritesheets/hair/shorthawk/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/dark_brown.png.json","lpc/spritesheets/hair/shorthawk/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/gold.png","lpc/spritesheets/hair/shorthawk/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/gold.png.json","lpc/spritesheets/hair/shorthawk/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/gray.png","lpc/spritesheets/hair/shorthawk/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/gray.png.json","lpc/spritesheets/hair/shorthawk/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/green.png","lpc/spritesheets/hair/shorthawk/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/green.png.json","lpc/spritesheets/hair/shorthawk/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/light_brown.png","lpc/spritesheets/hair/shorthawk/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/light_brown.png.json","lpc/spritesheets/hair/shorthawk/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/orange.png","lpc/spritesheets/hair/shorthawk/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/orange.png.json","lpc/spritesheets/hair/shorthawk/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/purple.png","lpc/spritesheets/hair/shorthawk/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/purple.png.json","lpc/spritesheets/hair/shorthawk/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/red.png","lpc/spritesheets/hair/shorthawk/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/red.png.json","lpc/spritesheets/hair/shorthawk/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/white.png","lpc/spritesheets/hair/shorthawk/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shorthawk/male/white.png.json","lpc/spritesheets/hair/shortknot/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/black.png","lpc/spritesheets/hair/shortknot/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/black.png.json","lpc/spritesheets/hair/shortknot/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/blonde.png","lpc/spritesheets/hair/shortknot/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/blonde.png.json","lpc/spritesheets/hair/shortknot/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/blue.png","lpc/spritesheets/hair/shortknot/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/blue.png.json","lpc/spritesheets/hair/shortknot/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/dark_brown.png","lpc/spritesheets/hair/shortknot/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/dark_brown.png.json","lpc/spritesheets/hair/shortknot/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/gold.png","lpc/spritesheets/hair/shortknot/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/gold.png.json","lpc/spritesheets/hair/shortknot/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/gray.png","lpc/spritesheets/hair/shortknot/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/gray.png.json","lpc/spritesheets/hair/shortknot/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/green.png","lpc/spritesheets/hair/shortknot/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/green.png.json","lpc/spritesheets/hair/shortknot/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/light_brown.png","lpc/spritesheets/hair/shortknot/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/light_brown.png.json","lpc/spritesheets/hair/shortknot/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/orange.png","lpc/spritesheets/hair/shortknot/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/orange.png.json","lpc/spritesheets/hair/shortknot/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/purple.png","lpc/spritesheets/hair/shortknot/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/purple.png.json","lpc/spritesheets/hair/shortknot/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/red.png","lpc/spritesheets/hair/shortknot/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/red.png.json","lpc/spritesheets/hair/shortknot/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/white.png","lpc/spritesheets/hair/shortknot/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/female/white.png.json","lpc/spritesheets/hair/shortknot/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/black.png","lpc/spritesheets/hair/shortknot/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/black.png.json","lpc/spritesheets/hair/shortknot/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/blonde.png","lpc/spritesheets/hair/shortknot/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/blonde.png.json","lpc/spritesheets/hair/shortknot/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/blue.png","lpc/spritesheets/hair/shortknot/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/blue.png.json","lpc/spritesheets/hair/shortknot/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/dark_brown.png","lpc/spritesheets/hair/shortknot/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/dark_brown.png.json","lpc/spritesheets/hair/shortknot/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/gold.png","lpc/spritesheets/hair/shortknot/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/gold.png.json","lpc/spritesheets/hair/shortknot/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/gray.png","lpc/spritesheets/hair/shortknot/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/gray.png.json","lpc/spritesheets/hair/shortknot/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/green.png","lpc/spritesheets/hair/shortknot/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/green.png.json","lpc/spritesheets/hair/shortknot/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/light_brown.png","lpc/spritesheets/hair/shortknot/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/light_brown.png.json","lpc/spritesheets/hair/shortknot/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/orange.png","lpc/spritesheets/hair/shortknot/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/orange.png.json","lpc/spritesheets/hair/shortknot/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/purple.png","lpc/spritesheets/hair/shortknot/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/purple.png.json","lpc/spritesheets/hair/shortknot/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/red.png","lpc/spritesheets/hair/shortknot/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/red.png.json","lpc/spritesheets/hair/shortknot/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/white.png","lpc/spritesheets/hair/shortknot/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shortknot/male/white.png.json","lpc/spritesheets/hair/shoulderl/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/black.png","lpc/spritesheets/hair/shoulderl/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/black.png.json","lpc/spritesheets/hair/shoulderl/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/blonde.png","lpc/spritesheets/hair/shoulderl/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/blonde.png.json","lpc/spritesheets/hair/shoulderl/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/blue.png","lpc/spritesheets/hair/shoulderl/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/blue.png.json","lpc/spritesheets/hair/shoulderl/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/dark_brown.png","lpc/spritesheets/hair/shoulderl/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/dark_brown.png.json","lpc/spritesheets/hair/shoulderl/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/gold.png","lpc/spritesheets/hair/shoulderl/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/gold.png.json","lpc/spritesheets/hair/shoulderl/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/gray.png","lpc/spritesheets/hair/shoulderl/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/gray.png.json","lpc/spritesheets/hair/shoulderl/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/green.png","lpc/spritesheets/hair/shoulderl/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/green.png.json","lpc/spritesheets/hair/shoulderl/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/light_brown.png","lpc/spritesheets/hair/shoulderl/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/light_brown.png.json","lpc/spritesheets/hair/shoulderl/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/orange.png","lpc/spritesheets/hair/shoulderl/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/orange.png.json","lpc/spritesheets/hair/shoulderl/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/purple.png","lpc/spritesheets/hair/shoulderl/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/purple.png.json","lpc/spritesheets/hair/shoulderl/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/red.png","lpc/spritesheets/hair/shoulderl/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/red.png.json","lpc/spritesheets/hair/shoulderl/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/white.png","lpc/spritesheets/hair/shoulderl/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/female/white.png.json","lpc/spritesheets/hair/shoulderl/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/black.png","lpc/spritesheets/hair/shoulderl/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/black.png.json","lpc/spritesheets/hair/shoulderl/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/blonde.png","lpc/spritesheets/hair/shoulderl/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/blonde.png.json","lpc/spritesheets/hair/shoulderl/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/blue.png","lpc/spritesheets/hair/shoulderl/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/blue.png.json","lpc/spritesheets/hair/shoulderl/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/dark_brown.png","lpc/spritesheets/hair/shoulderl/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/dark_brown.png.json","lpc/spritesheets/hair/shoulderl/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/gold.png","lpc/spritesheets/hair/shoulderl/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/gold.png.json","lpc/spritesheets/hair/shoulderl/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/gray.png","lpc/spritesheets/hair/shoulderl/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/gray.png.json","lpc/spritesheets/hair/shoulderl/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/green.png","lpc/spritesheets/hair/shoulderl/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/green.png.json","lpc/spritesheets/hair/shoulderl/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/light_brown.png","lpc/spritesheets/hair/shoulderl/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/light_brown.png.json","lpc/spritesheets/hair/shoulderl/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/orange.png","lpc/spritesheets/hair/shoulderl/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/orange.png.json","lpc/spritesheets/hair/shoulderl/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/purple.png","lpc/spritesheets/hair/shoulderl/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/purple.png.json","lpc/spritesheets/hair/shoulderl/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/red.png","lpc/spritesheets/hair/shoulderl/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/red.png.json","lpc/spritesheets/hair/shoulderl/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/white.png","lpc/spritesheets/hair/shoulderl/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderl/male/white.png.json","lpc/spritesheets/hair/shoulderr/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/black.png","lpc/spritesheets/hair/shoulderr/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/black.png.json","lpc/spritesheets/hair/shoulderr/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/blonde.png","lpc/spritesheets/hair/shoulderr/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/blonde.png.json","lpc/spritesheets/hair/shoulderr/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/blue.png","lpc/spritesheets/hair/shoulderr/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/blue.png.json","lpc/spritesheets/hair/shoulderr/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/dark_brown.png","lpc/spritesheets/hair/shoulderr/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/dark_brown.png.json","lpc/spritesheets/hair/shoulderr/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/gold.png","lpc/spritesheets/hair/shoulderr/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/gold.png.json","lpc/spritesheets/hair/shoulderr/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/gray.png","lpc/spritesheets/hair/shoulderr/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/gray.png.json","lpc/spritesheets/hair/shoulderr/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/green.png","lpc/spritesheets/hair/shoulderr/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/green.png.json","lpc/spritesheets/hair/shoulderr/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/light_brown.png","lpc/spritesheets/hair/shoulderr/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/light_brown.png.json","lpc/spritesheets/hair/shoulderr/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/orange.png","lpc/spritesheets/hair/shoulderr/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/orange.png.json","lpc/spritesheets/hair/shoulderr/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/purple.png","lpc/spritesheets/hair/shoulderr/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/purple.png.json","lpc/spritesheets/hair/shoulderr/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/red.png","lpc/spritesheets/hair/shoulderr/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/red.png.json","lpc/spritesheets/hair/shoulderr/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/white.png","lpc/spritesheets/hair/shoulderr/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/female/white.png.json","lpc/spritesheets/hair/shoulderr/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/black.png","lpc/spritesheets/hair/shoulderr/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/black.png.json","lpc/spritesheets/hair/shoulderr/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/blonde.png","lpc/spritesheets/hair/shoulderr/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/blonde.png.json","lpc/spritesheets/hair/shoulderr/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/blue.png","lpc/spritesheets/hair/shoulderr/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/blue.png.json","lpc/spritesheets/hair/shoulderr/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/dark_brown.png","lpc/spritesheets/hair/shoulderr/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/dark_brown.png.json","lpc/spritesheets/hair/shoulderr/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/gold.png","lpc/spritesheets/hair/shoulderr/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/gold.png.json","lpc/spritesheets/hair/shoulderr/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/gray.png","lpc/spritesheets/hair/shoulderr/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/gray.png.json","lpc/spritesheets/hair/shoulderr/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/green.png","lpc/spritesheets/hair/shoulderr/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/green.png.json","lpc/spritesheets/hair/shoulderr/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/light_brown.png","lpc/spritesheets/hair/shoulderr/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/light_brown.png.json","lpc/spritesheets/hair/shoulderr/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/orange.png","lpc/spritesheets/hair/shoulderr/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/orange.png.json","lpc/spritesheets/hair/shoulderr/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/purple.png","lpc/spritesheets/hair/shoulderr/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/purple.png.json","lpc/spritesheets/hair/shoulderr/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/red.png","lpc/spritesheets/hair/shoulderr/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/red.png.json","lpc/spritesheets/hair/shoulderr/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/white.png","lpc/spritesheets/hair/shoulderr/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/shoulderr/male/white.png.json","lpc/spritesheets/hair/single/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/black.png","lpc/spritesheets/hair/single/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/black.png.json","lpc/spritesheets/hair/single/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/blonde.png","lpc/spritesheets/hair/single/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/blonde.png.json","lpc/spritesheets/hair/single/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/blue.png","lpc/spritesheets/hair/single/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/blue.png.json","lpc/spritesheets/hair/single/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/dark_brown.png","lpc/spritesheets/hair/single/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/dark_brown.png.json","lpc/spritesheets/hair/single/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/gold.png","lpc/spritesheets/hair/single/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/gold.png.json","lpc/spritesheets/hair/single/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/gray.png","lpc/spritesheets/hair/single/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/gray.png.json","lpc/spritesheets/hair/single/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/green.png","lpc/spritesheets/hair/single/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/green.png.json","lpc/spritesheets/hair/single/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/light_brown.png","lpc/spritesheets/hair/single/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/light_brown.png.json","lpc/spritesheets/hair/single/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/orange.png","lpc/spritesheets/hair/single/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/orange.png.json","lpc/spritesheets/hair/single/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/purple.png","lpc/spritesheets/hair/single/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/purple.png.json","lpc/spritesheets/hair/single/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/red.png","lpc/spritesheets/hair/single/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/red.png.json","lpc/spritesheets/hair/single/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/white.png","lpc/spritesheets/hair/single/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/female/white.png.json","lpc/spritesheets/hair/single/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/black.png","lpc/spritesheets/hair/single/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/black.png.json","lpc/spritesheets/hair/single/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/blonde.png","lpc/spritesheets/hair/single/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/blonde.png.json","lpc/spritesheets/hair/single/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/blue.png","lpc/spritesheets/hair/single/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/blue.png.json","lpc/spritesheets/hair/single/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/dark_brown.png","lpc/spritesheets/hair/single/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/dark_brown.png.json","lpc/spritesheets/hair/single/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/gold.png","lpc/spritesheets/hair/single/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/gold.png.json","lpc/spritesheets/hair/single/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/gray.png","lpc/spritesheets/hair/single/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/gray.png.json","lpc/spritesheets/hair/single/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/green.png","lpc/spritesheets/hair/single/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/green.png.json","lpc/spritesheets/hair/single/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/light_brown.png","lpc/spritesheets/hair/single/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/light_brown.png.json","lpc/spritesheets/hair/single/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/orange.png","lpc/spritesheets/hair/single/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/orange.png.json","lpc/spritesheets/hair/single/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/purple.png","lpc/spritesheets/hair/single/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/purple.png.json","lpc/spritesheets/hair/single/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/red.png","lpc/spritesheets/hair/single/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/red.png.json","lpc/spritesheets/hair/single/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/white.png","lpc/spritesheets/hair/single/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/single/male/white.png.json","lpc/spritesheets/hair/spiked/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/black.png","lpc/spritesheets/hair/spiked/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/black.png.json","lpc/spritesheets/hair/spiked/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/blonde.png","lpc/spritesheets/hair/spiked/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/blonde.png.json","lpc/spritesheets/hair/spiked/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/blue.png","lpc/spritesheets/hair/spiked/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/blue.png.json","lpc/spritesheets/hair/spiked/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/dark_brown.png","lpc/spritesheets/hair/spiked/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/dark_brown.png.json","lpc/spritesheets/hair/spiked/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/gold.png","lpc/spritesheets/hair/spiked/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/gold.png.json","lpc/spritesheets/hair/spiked/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/gray.png","lpc/spritesheets/hair/spiked/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/gray.png.json","lpc/spritesheets/hair/spiked/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/green.png","lpc/spritesheets/hair/spiked/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/green.png.json","lpc/spritesheets/hair/spiked/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/light_brown.png","lpc/spritesheets/hair/spiked/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/light_brown.png.json","lpc/spritesheets/hair/spiked/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/orange.png","lpc/spritesheets/hair/spiked/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/orange.png.json","lpc/spritesheets/hair/spiked/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/purple.png","lpc/spritesheets/hair/spiked/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/purple.png.json","lpc/spritesheets/hair/spiked/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/red.png","lpc/spritesheets/hair/spiked/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/red.png.json","lpc/spritesheets/hair/spiked/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/white.png","lpc/spritesheets/hair/spiked/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/female/white.png.json","lpc/spritesheets/hair/spiked/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/black.png","lpc/spritesheets/hair/spiked/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/black.png.json","lpc/spritesheets/hair/spiked/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/blonde.png","lpc/spritesheets/hair/spiked/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/blonde.png.json","lpc/spritesheets/hair/spiked/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/blue.png","lpc/spritesheets/hair/spiked/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/blue.png.json","lpc/spritesheets/hair/spiked/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/dark_brown.png","lpc/spritesheets/hair/spiked/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/dark_brown.png.json","lpc/spritesheets/hair/spiked/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/gold.png","lpc/spritesheets/hair/spiked/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/gold.png.json","lpc/spritesheets/hair/spiked/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/gray.png","lpc/spritesheets/hair/spiked/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/gray.png.json","lpc/spritesheets/hair/spiked/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/green.png","lpc/spritesheets/hair/spiked/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/green.png.json","lpc/spritesheets/hair/spiked/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/light_brown.png","lpc/spritesheets/hair/spiked/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/light_brown.png.json","lpc/spritesheets/hair/spiked/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/orange.png","lpc/spritesheets/hair/spiked/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/orange.png.json","lpc/spritesheets/hair/spiked/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/purple.png","lpc/spritesheets/hair/spiked/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/purple.png.json","lpc/spritesheets/hair/spiked/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/red.png","lpc/spritesheets/hair/spiked/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/red.png.json","lpc/spritesheets/hair/spiked/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/white.png","lpc/spritesheets/hair/spiked/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked/male/white.png.json","lpc/spritesheets/hair/spiked2/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/black.png","lpc/spritesheets/hair/spiked2/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/black.png.json","lpc/spritesheets/hair/spiked2/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/blonde.png","lpc/spritesheets/hair/spiked2/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/blonde.png.json","lpc/spritesheets/hair/spiked2/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/blue.png","lpc/spritesheets/hair/spiked2/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/blue.png.json","lpc/spritesheets/hair/spiked2/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/dark_brown.png","lpc/spritesheets/hair/spiked2/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/dark_brown.png.json","lpc/spritesheets/hair/spiked2/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/gold.png","lpc/spritesheets/hair/spiked2/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/gold.png.json","lpc/spritesheets/hair/spiked2/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/gray.png","lpc/spritesheets/hair/spiked2/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/gray.png.json","lpc/spritesheets/hair/spiked2/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/green.png","lpc/spritesheets/hair/spiked2/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/green.png.json","lpc/spritesheets/hair/spiked2/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/light_brown.png","lpc/spritesheets/hair/spiked2/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/light_brown.png.json","lpc/spritesheets/hair/spiked2/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/orange.png","lpc/spritesheets/hair/spiked2/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/orange.png.json","lpc/spritesheets/hair/spiked2/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/purple.png","lpc/spritesheets/hair/spiked2/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/purple.png.json","lpc/spritesheets/hair/spiked2/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/red.png","lpc/spritesheets/hair/spiked2/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/red.png.json","lpc/spritesheets/hair/spiked2/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/white.png","lpc/spritesheets/hair/spiked2/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/female/white.png.json","lpc/spritesheets/hair/spiked2/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/black.png","lpc/spritesheets/hair/spiked2/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/black.png.json","lpc/spritesheets/hair/spiked2/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/blonde.png","lpc/spritesheets/hair/spiked2/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/blonde.png.json","lpc/spritesheets/hair/spiked2/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/blue.png","lpc/spritesheets/hair/spiked2/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/blue.png.json","lpc/spritesheets/hair/spiked2/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/dark_brown.png","lpc/spritesheets/hair/spiked2/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/dark_brown.png.json","lpc/spritesheets/hair/spiked2/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/gold.png","lpc/spritesheets/hair/spiked2/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/gold.png.json","lpc/spritesheets/hair/spiked2/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/gray.png","lpc/spritesheets/hair/spiked2/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/gray.png.json","lpc/spritesheets/hair/spiked2/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/green.png","lpc/spritesheets/hair/spiked2/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/green.png.json","lpc/spritesheets/hair/spiked2/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/light_brown.png","lpc/spritesheets/hair/spiked2/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/light_brown.png.json","lpc/spritesheets/hair/spiked2/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/orange.png","lpc/spritesheets/hair/spiked2/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/orange.png.json","lpc/spritesheets/hair/spiked2/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/purple.png","lpc/spritesheets/hair/spiked2/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/purple.png.json","lpc/spritesheets/hair/spiked2/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/red.png","lpc/spritesheets/hair/spiked2/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/red.png.json","lpc/spritesheets/hair/spiked2/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/white.png","lpc/spritesheets/hair/spiked2/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked2/male/white.png.json","lpc/spritesheets/hair/spiked_beehive/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/black.png","lpc/spritesheets/hair/spiked_beehive/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/black.png.json","lpc/spritesheets/hair/spiked_beehive/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/blonde.png","lpc/spritesheets/hair/spiked_beehive/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/blonde.png.json","lpc/spritesheets/hair/spiked_beehive/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/blue.png","lpc/spritesheets/hair/spiked_beehive/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/blue.png.json","lpc/spritesheets/hair/spiked_beehive/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/dark_brown.png","lpc/spritesheets/hair/spiked_beehive/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/dark_brown.png.json","lpc/spritesheets/hair/spiked_beehive/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/gold.png","lpc/spritesheets/hair/spiked_beehive/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/gold.png.json","lpc/spritesheets/hair/spiked_beehive/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/gray.png","lpc/spritesheets/hair/spiked_beehive/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/gray.png.json","lpc/spritesheets/hair/spiked_beehive/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/green.png","lpc/spritesheets/hair/spiked_beehive/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/green.png.json","lpc/spritesheets/hair/spiked_beehive/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/light_brown.png","lpc/spritesheets/hair/spiked_beehive/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/light_brown.png.json","lpc/spritesheets/hair/spiked_beehive/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/orange.png","lpc/spritesheets/hair/spiked_beehive/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/orange.png.json","lpc/spritesheets/hair/spiked_beehive/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/purple.png","lpc/spritesheets/hair/spiked_beehive/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/purple.png.json","lpc/spritesheets/hair/spiked_beehive/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/red.png","lpc/spritesheets/hair/spiked_beehive/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/red.png.json","lpc/spritesheets/hair/spiked_beehive/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/white.png","lpc/spritesheets/hair/spiked_beehive/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/female/white.png.json","lpc/spritesheets/hair/spiked_beehive/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/black.png","lpc/spritesheets/hair/spiked_beehive/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/black.png.json","lpc/spritesheets/hair/spiked_beehive/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/blonde.png","lpc/spritesheets/hair/spiked_beehive/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/blonde.png.json","lpc/spritesheets/hair/spiked_beehive/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/blue.png","lpc/spritesheets/hair/spiked_beehive/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/blue.png.json","lpc/spritesheets/hair/spiked_beehive/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/dark_brown.png","lpc/spritesheets/hair/spiked_beehive/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/dark_brown.png.json","lpc/spritesheets/hair/spiked_beehive/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/gold.png","lpc/spritesheets/hair/spiked_beehive/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/gold.png.json","lpc/spritesheets/hair/spiked_beehive/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/gray.png","lpc/spritesheets/hair/spiked_beehive/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/gray.png.json","lpc/spritesheets/hair/spiked_beehive/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/green.png","lpc/spritesheets/hair/spiked_beehive/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/green.png.json","lpc/spritesheets/hair/spiked_beehive/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/light_brown.png","lpc/spritesheets/hair/spiked_beehive/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/light_brown.png.json","lpc/spritesheets/hair/spiked_beehive/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/orange.png","lpc/spritesheets/hair/spiked_beehive/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/orange.png.json","lpc/spritesheets/hair/spiked_beehive/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/purple.png","lpc/spritesheets/hair/spiked_beehive/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/purple.png.json","lpc/spritesheets/hair/spiked_beehive/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/red.png","lpc/spritesheets/hair/spiked_beehive/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/red.png.json","lpc/spritesheets/hair/spiked_beehive/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/white.png","lpc/spritesheets/hair/spiked_beehive/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_beehive/male/white.png.json","lpc/spritesheets/hair/spiked_liberty/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/black.png","lpc/spritesheets/hair/spiked_liberty/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/black.png.json","lpc/spritesheets/hair/spiked_liberty/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/blonde.png","lpc/spritesheets/hair/spiked_liberty/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/blonde.png.json","lpc/spritesheets/hair/spiked_liberty/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/blue.png","lpc/spritesheets/hair/spiked_liberty/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/blue.png.json","lpc/spritesheets/hair/spiked_liberty/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/dark_brown.png","lpc/spritesheets/hair/spiked_liberty/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/dark_brown.png.json","lpc/spritesheets/hair/spiked_liberty/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/gold.png","lpc/spritesheets/hair/spiked_liberty/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/gold.png.json","lpc/spritesheets/hair/spiked_liberty/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/gray.png","lpc/spritesheets/hair/spiked_liberty/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/gray.png.json","lpc/spritesheets/hair/spiked_liberty/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/green.png","lpc/spritesheets/hair/spiked_liberty/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/green.png.json","lpc/spritesheets/hair/spiked_liberty/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/light_brown.png","lpc/spritesheets/hair/spiked_liberty/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/light_brown.png.json","lpc/spritesheets/hair/spiked_liberty/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/orange.png","lpc/spritesheets/hair/spiked_liberty/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/orange.png.json","lpc/spritesheets/hair/spiked_liberty/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/purple.png","lpc/spritesheets/hair/spiked_liberty/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/purple.png.json","lpc/spritesheets/hair/spiked_liberty/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/red.png","lpc/spritesheets/hair/spiked_liberty/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/red.png.json","lpc/spritesheets/hair/spiked_liberty/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/white.png","lpc/spritesheets/hair/spiked_liberty/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/female/white.png.json","lpc/spritesheets/hair/spiked_liberty/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/black.png","lpc/spritesheets/hair/spiked_liberty/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/black.png.json","lpc/spritesheets/hair/spiked_liberty/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/blonde.png","lpc/spritesheets/hair/spiked_liberty/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/blonde.png.json","lpc/spritesheets/hair/spiked_liberty/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/blue.png","lpc/spritesheets/hair/spiked_liberty/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/blue.png.json","lpc/spritesheets/hair/spiked_liberty/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/dark_brown.png","lpc/spritesheets/hair/spiked_liberty/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/dark_brown.png.json","lpc/spritesheets/hair/spiked_liberty/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/gold.png","lpc/spritesheets/hair/spiked_liberty/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/gold.png.json","lpc/spritesheets/hair/spiked_liberty/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/gray.png","lpc/spritesheets/hair/spiked_liberty/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/gray.png.json","lpc/spritesheets/hair/spiked_liberty/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/green.png","lpc/spritesheets/hair/spiked_liberty/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/green.png.json","lpc/spritesheets/hair/spiked_liberty/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/light_brown.png","lpc/spritesheets/hair/spiked_liberty/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/light_brown.png.json","lpc/spritesheets/hair/spiked_liberty/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/orange.png","lpc/spritesheets/hair/spiked_liberty/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/orange.png.json","lpc/spritesheets/hair/spiked_liberty/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/purple.png","lpc/spritesheets/hair/spiked_liberty/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/purple.png.json","lpc/spritesheets/hair/spiked_liberty/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/red.png","lpc/spritesheets/hair/spiked_liberty/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/red.png.json","lpc/spritesheets/hair/spiked_liberty/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/white.png","lpc/spritesheets/hair/spiked_liberty/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty/male/white.png.json","lpc/spritesheets/hair/spiked_liberty2/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/black.png","lpc/spritesheets/hair/spiked_liberty2/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/black.png.json","lpc/spritesheets/hair/spiked_liberty2/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/blonde.png","lpc/spritesheets/hair/spiked_liberty2/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/blonde.png.json","lpc/spritesheets/hair/spiked_liberty2/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/blue.png","lpc/spritesheets/hair/spiked_liberty2/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/blue.png.json","lpc/spritesheets/hair/spiked_liberty2/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/dark_brown.png","lpc/spritesheets/hair/spiked_liberty2/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/dark_brown.png.json","lpc/spritesheets/hair/spiked_liberty2/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/gold.png","lpc/spritesheets/hair/spiked_liberty2/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/gold.png.json","lpc/spritesheets/hair/spiked_liberty2/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/gray.png","lpc/spritesheets/hair/spiked_liberty2/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/gray.png.json","lpc/spritesheets/hair/spiked_liberty2/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/green.png","lpc/spritesheets/hair/spiked_liberty2/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/green.png.json","lpc/spritesheets/hair/spiked_liberty2/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/light_brown.png","lpc/spritesheets/hair/spiked_liberty2/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/light_brown.png.json","lpc/spritesheets/hair/spiked_liberty2/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/orange.png","lpc/spritesheets/hair/spiked_liberty2/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/orange.png.json","lpc/spritesheets/hair/spiked_liberty2/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/purple.png","lpc/spritesheets/hair/spiked_liberty2/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/purple.png.json","lpc/spritesheets/hair/spiked_liberty2/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/red.png","lpc/spritesheets/hair/spiked_liberty2/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/red.png.json","lpc/spritesheets/hair/spiked_liberty2/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/white.png","lpc/spritesheets/hair/spiked_liberty2/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/female/white.png.json","lpc/spritesheets/hair/spiked_liberty2/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/black.png","lpc/spritesheets/hair/spiked_liberty2/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/black.png.json","lpc/spritesheets/hair/spiked_liberty2/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/blonde.png","lpc/spritesheets/hair/spiked_liberty2/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/blonde.png.json","lpc/spritesheets/hair/spiked_liberty2/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/blue.png","lpc/spritesheets/hair/spiked_liberty2/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/blue.png.json","lpc/spritesheets/hair/spiked_liberty2/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/dark_brown.png","lpc/spritesheets/hair/spiked_liberty2/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/dark_brown.png.json","lpc/spritesheets/hair/spiked_liberty2/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/gold.png","lpc/spritesheets/hair/spiked_liberty2/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/gold.png.json","lpc/spritesheets/hair/spiked_liberty2/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/gray.png","lpc/spritesheets/hair/spiked_liberty2/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/gray.png.json","lpc/spritesheets/hair/spiked_liberty2/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/green.png","lpc/spritesheets/hair/spiked_liberty2/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/green.png.json","lpc/spritesheets/hair/spiked_liberty2/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/light_brown.png","lpc/spritesheets/hair/spiked_liberty2/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/light_brown.png.json","lpc/spritesheets/hair/spiked_liberty2/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/orange.png","lpc/spritesheets/hair/spiked_liberty2/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/orange.png.json","lpc/spritesheets/hair/spiked_liberty2/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/purple.png","lpc/spritesheets/hair/spiked_liberty2/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/purple.png.json","lpc/spritesheets/hair/spiked_liberty2/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/red.png","lpc/spritesheets/hair/spiked_liberty2/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/red.png.json","lpc/spritesheets/hair/spiked_liberty2/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/white.png","lpc/spritesheets/hair/spiked_liberty2/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_liberty2/male/white.png.json","lpc/spritesheets/hair/spiked_porcupine/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/black.png","lpc/spritesheets/hair/spiked_porcupine/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/black.png.json","lpc/spritesheets/hair/spiked_porcupine/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/blonde.png","lpc/spritesheets/hair/spiked_porcupine/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/blonde.png.json","lpc/spritesheets/hair/spiked_porcupine/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/blue.png","lpc/spritesheets/hair/spiked_porcupine/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/blue.png.json","lpc/spritesheets/hair/spiked_porcupine/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/dark_brown.png","lpc/spritesheets/hair/spiked_porcupine/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/dark_brown.png.json","lpc/spritesheets/hair/spiked_porcupine/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/gold.png","lpc/spritesheets/hair/spiked_porcupine/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/gold.png.json","lpc/spritesheets/hair/spiked_porcupine/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/gray.png","lpc/spritesheets/hair/spiked_porcupine/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/gray.png.json","lpc/spritesheets/hair/spiked_porcupine/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/green.png","lpc/spritesheets/hair/spiked_porcupine/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/green.png.json","lpc/spritesheets/hair/spiked_porcupine/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/light_brown.png","lpc/spritesheets/hair/spiked_porcupine/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/light_brown.png.json","lpc/spritesheets/hair/spiked_porcupine/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/orange.png","lpc/spritesheets/hair/spiked_porcupine/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/orange.png.json","lpc/spritesheets/hair/spiked_porcupine/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/purple.png","lpc/spritesheets/hair/spiked_porcupine/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/purple.png.json","lpc/spritesheets/hair/spiked_porcupine/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/red.png","lpc/spritesheets/hair/spiked_porcupine/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/red.png.json","lpc/spritesheets/hair/spiked_porcupine/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/white.png","lpc/spritesheets/hair/spiked_porcupine/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/female/white.png.json","lpc/spritesheets/hair/spiked_porcupine/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/black.png","lpc/spritesheets/hair/spiked_porcupine/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/black.png.json","lpc/spritesheets/hair/spiked_porcupine/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/blonde.png","lpc/spritesheets/hair/spiked_porcupine/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/blonde.png.json","lpc/spritesheets/hair/spiked_porcupine/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/blue.png","lpc/spritesheets/hair/spiked_porcupine/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/blue.png.json","lpc/spritesheets/hair/spiked_porcupine/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/dark_brown.png","lpc/spritesheets/hair/spiked_porcupine/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/dark_brown.png.json","lpc/spritesheets/hair/spiked_porcupine/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/gold.png","lpc/spritesheets/hair/spiked_porcupine/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/gold.png.json","lpc/spritesheets/hair/spiked_porcupine/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/gray.png","lpc/spritesheets/hair/spiked_porcupine/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/gray.png.json","lpc/spritesheets/hair/spiked_porcupine/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/green.png","lpc/spritesheets/hair/spiked_porcupine/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/green.png.json","lpc/spritesheets/hair/spiked_porcupine/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/light_brown.png","lpc/spritesheets/hair/spiked_porcupine/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/light_brown.png.json","lpc/spritesheets/hair/spiked_porcupine/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/orange.png","lpc/spritesheets/hair/spiked_porcupine/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/orange.png.json","lpc/spritesheets/hair/spiked_porcupine/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/purple.png","lpc/spritesheets/hair/spiked_porcupine/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/purple.png.json","lpc/spritesheets/hair/spiked_porcupine/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/red.png","lpc/spritesheets/hair/spiked_porcupine/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/red.png.json","lpc/spritesheets/hair/spiked_porcupine/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/white.png","lpc/spritesheets/hair/spiked_porcupine/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/spiked_porcupine/male/white.png.json","lpc/spritesheets/hair/swoop/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/black.png","lpc/spritesheets/hair/swoop/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/black.png.json","lpc/spritesheets/hair/swoop/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/blonde.png","lpc/spritesheets/hair/swoop/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/blonde.png.json","lpc/spritesheets/hair/swoop/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/blue.png","lpc/spritesheets/hair/swoop/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/blue.png.json","lpc/spritesheets/hair/swoop/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/dark_brown.png","lpc/spritesheets/hair/swoop/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/dark_brown.png.json","lpc/spritesheets/hair/swoop/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/gold.png","lpc/spritesheets/hair/swoop/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/gold.png.json","lpc/spritesheets/hair/swoop/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/gray.png","lpc/spritesheets/hair/swoop/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/gray.png.json","lpc/spritesheets/hair/swoop/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/green.png","lpc/spritesheets/hair/swoop/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/green.png.json","lpc/spritesheets/hair/swoop/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/light_brown.png","lpc/spritesheets/hair/swoop/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/light_brown.png.json","lpc/spritesheets/hair/swoop/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/orange.png","lpc/spritesheets/hair/swoop/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/orange.png.json","lpc/spritesheets/hair/swoop/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/purple.png","lpc/spritesheets/hair/swoop/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/purple.png.json","lpc/spritesheets/hair/swoop/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/red.png","lpc/spritesheets/hair/swoop/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/red.png.json","lpc/spritesheets/hair/swoop/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/white.png","lpc/spritesheets/hair/swoop/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/female/white.png.json","lpc/spritesheets/hair/swoop/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/black.png","lpc/spritesheets/hair/swoop/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/black.png.json","lpc/spritesheets/hair/swoop/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/blonde.png","lpc/spritesheets/hair/swoop/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/blonde.png.json","lpc/spritesheets/hair/swoop/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/blue.png","lpc/spritesheets/hair/swoop/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/blue.png.json","lpc/spritesheets/hair/swoop/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/dark_brown.png","lpc/spritesheets/hair/swoop/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/dark_brown.png.json","lpc/spritesheets/hair/swoop/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/gold.png","lpc/spritesheets/hair/swoop/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/gold.png.json","lpc/spritesheets/hair/swoop/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/gray.png","lpc/spritesheets/hair/swoop/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/gray.png.json","lpc/spritesheets/hair/swoop/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/green.png","lpc/spritesheets/hair/swoop/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/green.png.json","lpc/spritesheets/hair/swoop/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/light_brown.png","lpc/spritesheets/hair/swoop/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/light_brown.png.json","lpc/spritesheets/hair/swoop/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/orange.png","lpc/spritesheets/hair/swoop/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/orange.png.json","lpc/spritesheets/hair/swoop/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/purple.png","lpc/spritesheets/hair/swoop/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/purple.png.json","lpc/spritesheets/hair/swoop/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/red.png","lpc/spritesheets/hair/swoop/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/red.png.json","lpc/spritesheets/hair/swoop/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/white.png","lpc/spritesheets/hair/swoop/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/swoop/male/white.png.json","lpc/spritesheets/hair/twists_fade/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/black.png","lpc/spritesheets/hair/twists_fade/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/black.png.json","lpc/spritesheets/hair/twists_fade/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/blonde.png","lpc/spritesheets/hair/twists_fade/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/blonde.png.json","lpc/spritesheets/hair/twists_fade/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/blue.png","lpc/spritesheets/hair/twists_fade/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/blue.png.json","lpc/spritesheets/hair/twists_fade/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/dark_brown.png","lpc/spritesheets/hair/twists_fade/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/dark_brown.png.json","lpc/spritesheets/hair/twists_fade/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/gold.png","lpc/spritesheets/hair/twists_fade/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/gold.png.json","lpc/spritesheets/hair/twists_fade/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/gray.png","lpc/spritesheets/hair/twists_fade/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/gray.png.json","lpc/spritesheets/hair/twists_fade/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/green.png","lpc/spritesheets/hair/twists_fade/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/green.png.json","lpc/spritesheets/hair/twists_fade/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/light_brown.png","lpc/spritesheets/hair/twists_fade/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/light_brown.png.json","lpc/spritesheets/hair/twists_fade/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/orange.png","lpc/spritesheets/hair/twists_fade/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/orange.png.json","lpc/spritesheets/hair/twists_fade/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/purple.png","lpc/spritesheets/hair/twists_fade/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/purple.png.json","lpc/spritesheets/hair/twists_fade/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/red.png","lpc/spritesheets/hair/twists_fade/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/red.png.json","lpc/spritesheets/hair/twists_fade/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/white.png","lpc/spritesheets/hair/twists_fade/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/female/white.png.json","lpc/spritesheets/hair/twists_fade/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/black.png","lpc/spritesheets/hair/twists_fade/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/black.png.json","lpc/spritesheets/hair/twists_fade/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/blonde.png","lpc/spritesheets/hair/twists_fade/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/blonde.png.json","lpc/spritesheets/hair/twists_fade/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/blue.png","lpc/spritesheets/hair/twists_fade/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/blue.png.json","lpc/spritesheets/hair/twists_fade/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/dark_brown.png","lpc/spritesheets/hair/twists_fade/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/dark_brown.png.json","lpc/spritesheets/hair/twists_fade/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/gold.png","lpc/spritesheets/hair/twists_fade/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/gold.png.json","lpc/spritesheets/hair/twists_fade/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/gray.png","lpc/spritesheets/hair/twists_fade/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/gray.png.json","lpc/spritesheets/hair/twists_fade/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/green.png","lpc/spritesheets/hair/twists_fade/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/green.png.json","lpc/spritesheets/hair/twists_fade/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/light_brown.png","lpc/spritesheets/hair/twists_fade/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/light_brown.png.json","lpc/spritesheets/hair/twists_fade/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/orange.png","lpc/spritesheets/hair/twists_fade/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/orange.png.json","lpc/spritesheets/hair/twists_fade/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/purple.png","lpc/spritesheets/hair/twists_fade/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/purple.png.json","lpc/spritesheets/hair/twists_fade/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/red.png","lpc/spritesheets/hair/twists_fade/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/red.png.json","lpc/spritesheets/hair/twists_fade/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/white.png","lpc/spritesheets/hair/twists_fade/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_fade/male/white.png.json","lpc/spritesheets/hair/twists_straight/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/black.png","lpc/spritesheets/hair/twists_straight/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/black.png.json","lpc/spritesheets/hair/twists_straight/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/blonde.png","lpc/spritesheets/hair/twists_straight/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/blonde.png.json","lpc/spritesheets/hair/twists_straight/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/blue.png","lpc/spritesheets/hair/twists_straight/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/blue.png.json","lpc/spritesheets/hair/twists_straight/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/dark_brown.png","lpc/spritesheets/hair/twists_straight/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/dark_brown.png.json","lpc/spritesheets/hair/twists_straight/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/gold.png","lpc/spritesheets/hair/twists_straight/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/gold.png.json","lpc/spritesheets/hair/twists_straight/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/gray.png","lpc/spritesheets/hair/twists_straight/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/gray.png.json","lpc/spritesheets/hair/twists_straight/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/green.png","lpc/spritesheets/hair/twists_straight/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/green.png.json","lpc/spritesheets/hair/twists_straight/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/light_brown.png","lpc/spritesheets/hair/twists_straight/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/light_brown.png.json","lpc/spritesheets/hair/twists_straight/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/orange.png","lpc/spritesheets/hair/twists_straight/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/orange.png.json","lpc/spritesheets/hair/twists_straight/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/purple.png","lpc/spritesheets/hair/twists_straight/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/purple.png.json","lpc/spritesheets/hair/twists_straight/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/red.png","lpc/spritesheets/hair/twists_straight/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/red.png.json","lpc/spritesheets/hair/twists_straight/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/white.png","lpc/spritesheets/hair/twists_straight/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/female/white.png.json","lpc/spritesheets/hair/twists_straight/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/black.png","lpc/spritesheets/hair/twists_straight/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/black.png.json","lpc/spritesheets/hair/twists_straight/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/blonde.png","lpc/spritesheets/hair/twists_straight/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/blonde.png.json","lpc/spritesheets/hair/twists_straight/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/blue.png","lpc/spritesheets/hair/twists_straight/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/blue.png.json","lpc/spritesheets/hair/twists_straight/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/dark_brown.png","lpc/spritesheets/hair/twists_straight/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/dark_brown.png.json","lpc/spritesheets/hair/twists_straight/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/gold.png","lpc/spritesheets/hair/twists_straight/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/gold.png.json","lpc/spritesheets/hair/twists_straight/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/gray.png","lpc/spritesheets/hair/twists_straight/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/gray.png.json","lpc/spritesheets/hair/twists_straight/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/green.png","lpc/spritesheets/hair/twists_straight/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/green.png.json","lpc/spritesheets/hair/twists_straight/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/light_brown.png","lpc/spritesheets/hair/twists_straight/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/light_brown.png.json","lpc/spritesheets/hair/twists_straight/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/orange.png","lpc/spritesheets/hair/twists_straight/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/orange.png.json","lpc/spritesheets/hair/twists_straight/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/purple.png","lpc/spritesheets/hair/twists_straight/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/purple.png.json","lpc/spritesheets/hair/twists_straight/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/red.png","lpc/spritesheets/hair/twists_straight/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/red.png.json","lpc/spritesheets/hair/twists_straight/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/white.png","lpc/spritesheets/hair/twists_straight/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/twists_straight/male/white.png.json","lpc/spritesheets/hair/unkempt/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/black.png","lpc/spritesheets/hair/unkempt/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/black.png.json","lpc/spritesheets/hair/unkempt/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/blonde.png","lpc/spritesheets/hair/unkempt/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/blonde.png.json","lpc/spritesheets/hair/unkempt/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/blue.png","lpc/spritesheets/hair/unkempt/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/blue.png.json","lpc/spritesheets/hair/unkempt/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/dark_brown.png","lpc/spritesheets/hair/unkempt/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/dark_brown.png.json","lpc/spritesheets/hair/unkempt/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/gold.png","lpc/spritesheets/hair/unkempt/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/gold.png.json","lpc/spritesheets/hair/unkempt/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/gray.png","lpc/spritesheets/hair/unkempt/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/gray.png.json","lpc/spritesheets/hair/unkempt/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/green.png","lpc/spritesheets/hair/unkempt/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/green.png.json","lpc/spritesheets/hair/unkempt/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/light_brown.png","lpc/spritesheets/hair/unkempt/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/light_brown.png.json","lpc/spritesheets/hair/unkempt/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/orange.png","lpc/spritesheets/hair/unkempt/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/orange.png.json","lpc/spritesheets/hair/unkempt/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/purple.png","lpc/spritesheets/hair/unkempt/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/purple.png.json","lpc/spritesheets/hair/unkempt/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/red.png","lpc/spritesheets/hair/unkempt/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/red.png.json","lpc/spritesheets/hair/unkempt/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/white.png","lpc/spritesheets/hair/unkempt/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/female/white.png.json","lpc/spritesheets/hair/unkempt/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/black.png","lpc/spritesheets/hair/unkempt/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/black.png.json","lpc/spritesheets/hair/unkempt/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/blonde.png","lpc/spritesheets/hair/unkempt/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/blonde.png.json","lpc/spritesheets/hair/unkempt/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/blue.png","lpc/spritesheets/hair/unkempt/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/blue.png.json","lpc/spritesheets/hair/unkempt/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/dark_brown.png","lpc/spritesheets/hair/unkempt/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/dark_brown.png.json","lpc/spritesheets/hair/unkempt/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/gold.png","lpc/spritesheets/hair/unkempt/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/gold.png.json","lpc/spritesheets/hair/unkempt/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/gray.png","lpc/spritesheets/hair/unkempt/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/gray.png.json","lpc/spritesheets/hair/unkempt/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/green.png","lpc/spritesheets/hair/unkempt/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/green.png.json","lpc/spritesheets/hair/unkempt/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/light_brown.png","lpc/spritesheets/hair/unkempt/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/light_brown.png.json","lpc/spritesheets/hair/unkempt/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/orange.png","lpc/spritesheets/hair/unkempt/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/orange.png.json","lpc/spritesheets/hair/unkempt/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/purple.png","lpc/spritesheets/hair/unkempt/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/purple.png.json","lpc/spritesheets/hair/unkempt/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/red.png","lpc/spritesheets/hair/unkempt/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/red.png.json","lpc/spritesheets/hair/unkempt/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/white.png","lpc/spritesheets/hair/unkempt/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/unkempt/male/white.png.json","lpc/spritesheets/hair/wavy/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/black.png","lpc/spritesheets/hair/wavy/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/black.png.json","lpc/spritesheets/hair/wavy/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/blonde.png","lpc/spritesheets/hair/wavy/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/blonde.png.json","lpc/spritesheets/hair/wavy/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/blue.png","lpc/spritesheets/hair/wavy/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/blue.png.json","lpc/spritesheets/hair/wavy/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/dark_brown.png","lpc/spritesheets/hair/wavy/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/dark_brown.png.json","lpc/spritesheets/hair/wavy/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/gold.png","lpc/spritesheets/hair/wavy/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/gold.png.json","lpc/spritesheets/hair/wavy/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/gray.png","lpc/spritesheets/hair/wavy/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/gray.png.json","lpc/spritesheets/hair/wavy/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/green.png","lpc/spritesheets/hair/wavy/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/green.png.json","lpc/spritesheets/hair/wavy/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/light_brown.png","lpc/spritesheets/hair/wavy/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/light_brown.png.json","lpc/spritesheets/hair/wavy/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/orange.png","lpc/spritesheets/hair/wavy/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/orange.png.json","lpc/spritesheets/hair/wavy/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/purple.png","lpc/spritesheets/hair/wavy/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/purple.png.json","lpc/spritesheets/hair/wavy/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/red.png","lpc/spritesheets/hair/wavy/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/red.png.json","lpc/spritesheets/hair/wavy/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/white.png","lpc/spritesheets/hair/wavy/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/female/white.png.json","lpc/spritesheets/hair/wavy/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/black.png","lpc/spritesheets/hair/wavy/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/black.png.json","lpc/spritesheets/hair/wavy/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/blonde.png","lpc/spritesheets/hair/wavy/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/blonde.png.json","lpc/spritesheets/hair/wavy/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/blue.png","lpc/spritesheets/hair/wavy/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/blue.png.json","lpc/spritesheets/hair/wavy/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/dark_brown.png","lpc/spritesheets/hair/wavy/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/dark_brown.png.json","lpc/spritesheets/hair/wavy/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/gold.png","lpc/spritesheets/hair/wavy/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/gold.png.json","lpc/spritesheets/hair/wavy/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/gray.png","lpc/spritesheets/hair/wavy/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/gray.png.json","lpc/spritesheets/hair/wavy/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/green.png","lpc/spritesheets/hair/wavy/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/green.png.json","lpc/spritesheets/hair/wavy/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/light_brown.png","lpc/spritesheets/hair/wavy/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/light_brown.png.json","lpc/spritesheets/hair/wavy/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/orange.png","lpc/spritesheets/hair/wavy/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/orange.png.json","lpc/spritesheets/hair/wavy/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/purple.png","lpc/spritesheets/hair/wavy/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/purple.png.json","lpc/spritesheets/hair/wavy/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/red.png","lpc/spritesheets/hair/wavy/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/red.png.json","lpc/spritesheets/hair/wavy/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/white.png","lpc/spritesheets/hair/wavy/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/wavy/male/white.png.json","lpc/spritesheets/hair/xlong/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/black.png","lpc/spritesheets/hair/xlong/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/black.png.json","lpc/spritesheets/hair/xlong/female/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/blonde.png","lpc/spritesheets/hair/xlong/female/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/blonde.png.json","lpc/spritesheets/hair/xlong/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/blue.png","lpc/spritesheets/hair/xlong/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/blue.png.json","lpc/spritesheets/hair/xlong/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/dark_brown.png","lpc/spritesheets/hair/xlong/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/dark_brown.png.json","lpc/spritesheets/hair/xlong/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/gold.png","lpc/spritesheets/hair/xlong/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/gold.png.json","lpc/spritesheets/hair/xlong/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/gray.png","lpc/spritesheets/hair/xlong/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/gray.png.json","lpc/spritesheets/hair/xlong/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/green.png","lpc/spritesheets/hair/xlong/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/green.png.json","lpc/spritesheets/hair/xlong/female/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/light_brown.png","lpc/spritesheets/hair/xlong/female/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/light_brown.png.json","lpc/spritesheets/hair/xlong/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/orange.png","lpc/spritesheets/hair/xlong/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/orange.png.json","lpc/spritesheets/hair/xlong/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/purple.png","lpc/spritesheets/hair/xlong/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/purple.png.json","lpc/spritesheets/hair/xlong/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/red.png","lpc/spritesheets/hair/xlong/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/red.png.json","lpc/spritesheets/hair/xlong/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/white.png","lpc/spritesheets/hair/xlong/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/female/white.png.json","lpc/spritesheets/hair/xlong/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/black.png","lpc/spritesheets/hair/xlong/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/black.png.json","lpc/spritesheets/hair/xlong/male/blonde.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/blonde.png","lpc/spritesheets/hair/xlong/male/blonde.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/blonde.png.json","lpc/spritesheets/hair/xlong/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/blue.png","lpc/spritesheets/hair/xlong/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/blue.png.json","lpc/spritesheets/hair/xlong/male/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/dark_brown.png","lpc/spritesheets/hair/xlong/male/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/dark_brown.png.json","lpc/spritesheets/hair/xlong/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/gold.png","lpc/spritesheets/hair/xlong/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/gold.png.json","lpc/spritesheets/hair/xlong/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/gray.png","lpc/spritesheets/hair/xlong/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/gray.png.json","lpc/spritesheets/hair/xlong/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/green.png","lpc/spritesheets/hair/xlong/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/green.png.json","lpc/spritesheets/hair/xlong/male/light_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/light_brown.png","lpc/spritesheets/hair/xlong/male/light_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/light_brown.png.json","lpc/spritesheets/hair/xlong/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/orange.png","lpc/spritesheets/hair/xlong/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/orange.png.json","lpc/spritesheets/hair/xlong/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/purple.png","lpc/spritesheets/hair/xlong/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/purple.png.json","lpc/spritesheets/hair/xlong/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/red.png","lpc/spritesheets/hair/xlong/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/red.png.json","lpc/spritesheets/hair/xlong/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/white.png","lpc/spritesheets/hair/xlong/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/hair/xlong/male/white.png.json","lpc/spritesheets/head/nose/big/female/darkelf.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/big/female/darkelf.png","lpc/spritesheets/head/nose/big/female/darkelf.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/big/female/darkelf.png.json","lpc/spritesheets/head/nose/big/female/light.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/big/female/light.png","lpc/spritesheets/head/nose/big/female/light.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/big/female/light.png.json","lpc/spritesheets/head/nose/big/female/tanned.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/big/female/tanned.png","lpc/spritesheets/head/nose/big/female/tanned.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/big/female/tanned.png.json","lpc/spritesheets/head/nose/big/male/darkelf.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/big/male/darkelf.png","lpc/spritesheets/head/nose/big/male/darkelf.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/big/male/darkelf.png.json","lpc/spritesheets/head/nose/big/male/light.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/big/male/light.png","lpc/spritesheets/head/nose/big/male/light.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/big/male/light.png.json","lpc/spritesheets/head/nose/big/male/tanned.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/big/male/tanned.png","lpc/spritesheets/head/nose/big/male/tanned.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/big/male/tanned.png.json","lpc/spritesheets/head/nose/button/female/darkelf.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/button/female/darkelf.png","lpc/spritesheets/head/nose/button/female/darkelf.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/button/female/darkelf.png.json","lpc/spritesheets/head/nose/button/female/light.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/button/female/light.png","lpc/spritesheets/head/nose/button/female/light.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/button/female/light.png.json","lpc/spritesheets/head/nose/button/female/tanned.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/button/female/tanned.png","lpc/spritesheets/head/nose/button/female/tanned.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/button/female/tanned.png.json","lpc/spritesheets/head/nose/button/male/darkelf.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/button/male/darkelf.png","lpc/spritesheets/head/nose/button/male/darkelf.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/button/male/darkelf.png.json","lpc/spritesheets/head/nose/button/male/light.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/button/male/light.png","lpc/spritesheets/head/nose/button/male/light.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/button/male/light.png.json","lpc/spritesheets/head/nose/button/male/tanned.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/button/male/tanned.png","lpc/spritesheets/head/nose/button/male/tanned.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/button/male/tanned.png.json","lpc/spritesheets/head/nose/straight/female/darkelf.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/straight/female/darkelf.png","lpc/spritesheets/head/nose/straight/female/darkelf.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/straight/female/darkelf.png.json","lpc/spritesheets/head/nose/straight/female/light.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/straight/female/light.png","lpc/spritesheets/head/nose/straight/female/light.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/straight/female/light.png.json","lpc/spritesheets/head/nose/straight/female/tanned.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/straight/female/tanned.png","lpc/spritesheets/head/nose/straight/female/tanned.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/straight/female/tanned.png.json","lpc/spritesheets/head/nose/straight/male/darkelf.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/straight/male/darkelf.png","lpc/spritesheets/head/nose/straight/male/darkelf.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/straight/male/darkelf.png.json","lpc/spritesheets/head/nose/straight/male/light.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/straight/male/light.png","lpc/spritesheets/head/nose/straight/male/light.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/straight/male/light.png.json","lpc/spritesheets/head/nose/straight/male/tanned.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/straight/male/tanned.png","lpc/spritesheets/head/nose/straight/male/tanned.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/head/nose/straight/male/tanned.png.json","lpc/spritesheets/legs/armour/female/10.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/female/10.png","lpc/spritesheets/legs/armour/female/10.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/female/10.png.json","lpc/spritesheets/legs/armour/female/11.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/female/11.png","lpc/spritesheets/legs/armour/female/11.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/female/11.png.json","lpc/spritesheets/legs/armour/female/7.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/female/7.png","lpc/spritesheets/legs/armour/female/7.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/female/7.png.json","lpc/spritesheets/legs/armour/female/8.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/female/8.png","lpc/spritesheets/legs/armour/female/8.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/female/8.png.json","lpc/spritesheets/legs/armour/female/9.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/female/9.png","lpc/spritesheets/legs/armour/female/9.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/female/9.png.json","lpc/spritesheets/legs/armour/male/10.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/male/10.png","lpc/spritesheets/legs/armour/male/10.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/male/10.png.json","lpc/spritesheets/legs/armour/male/11.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/male/11.png","lpc/spritesheets/legs/armour/male/11.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/male/11.png.json","lpc/spritesheets/legs/armour/male/7.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/male/7.png","lpc/spritesheets/legs/armour/male/7.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/male/7.png.json","lpc/spritesheets/legs/armour/male/8.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/male/8.png","lpc/spritesheets/legs/armour/male/8.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/male/8.png.json","lpc/spritesheets/legs/armour/male/9.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/male/9.png","lpc/spritesheets/legs/armour/male/9.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/armour/male/9.png.json","lpc/spritesheets/legs/pantaloons/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/black.png","lpc/spritesheets/legs/pantaloons/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/black.png.json","lpc/spritesheets/legs/pantaloons/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/blue.png","lpc/spritesheets/legs/pantaloons/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/blue.png.json","lpc/spritesheets/legs/pantaloons/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/brown.png","lpc/spritesheets/legs/pantaloons/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/brown.png.json","lpc/spritesheets/legs/pantaloons/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/gray.png","lpc/spritesheets/legs/pantaloons/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/gray.png.json","lpc/spritesheets/legs/pantaloons/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/green.png","lpc/spritesheets/legs/pantaloons/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/green.png.json","lpc/spritesheets/legs/pantaloons/male/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/maroon.png","lpc/spritesheets/legs/pantaloons/male/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/maroon.png.json","lpc/spritesheets/legs/pantaloons/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/orange.png","lpc/spritesheets/legs/pantaloons/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/orange.png.json","lpc/spritesheets/legs/pantaloons/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/purple.png","lpc/spritesheets/legs/pantaloons/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/purple.png.json","lpc/spritesheets/legs/pantaloons/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/red.png","lpc/spritesheets/legs/pantaloons/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/red.png.json","lpc/spritesheets/legs/pantaloons/male/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/tan.png","lpc/spritesheets/legs/pantaloons/male/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/tan.png.json","lpc/spritesheets/legs/pantaloons/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/white.png","lpc/spritesheets/legs/pantaloons/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/white.png.json","lpc/spritesheets/legs/pantaloons/male/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/yellow.png","lpc/spritesheets/legs/pantaloons/male/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pantaloons/male/yellow.png.json","lpc/spritesheets/legs/pants/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/black.png","lpc/spritesheets/legs/pants/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/black.png.json","lpc/spritesheets/legs/pants/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/blue.png","lpc/spritesheets/legs/pants/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/blue.png.json","lpc/spritesheets/legs/pants/female/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/brown.png","lpc/spritesheets/legs/pants/female/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/brown.png.json","lpc/spritesheets/legs/pants/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/gray.png","lpc/spritesheets/legs/pants/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/gray.png.json","lpc/spritesheets/legs/pants/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/green.png","lpc/spritesheets/legs/pants/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/green.png.json","lpc/spritesheets/legs/pants/female/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/maroon.png","lpc/spritesheets/legs/pants/female/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/maroon.png.json","lpc/spritesheets/legs/pants/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/orange.png","lpc/spritesheets/legs/pants/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/orange.png.json","lpc/spritesheets/legs/pants/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/purple.png","lpc/spritesheets/legs/pants/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/purple.png.json","lpc/spritesheets/legs/pants/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/red.png","lpc/spritesheets/legs/pants/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/red.png.json","lpc/spritesheets/legs/pants/female/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/tan.png","lpc/spritesheets/legs/pants/female/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/tan.png.json","lpc/spritesheets/legs/pants/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/white.png","lpc/spritesheets/legs/pants/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/white.png.json","lpc/spritesheets/legs/pants/female/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/yellow.png","lpc/spritesheets/legs/pants/female/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/female/yellow.png.json","lpc/spritesheets/legs/pants/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/black.png","lpc/spritesheets/legs/pants/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/black.png.json","lpc/spritesheets/legs/pants/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/blue.png","lpc/spritesheets/legs/pants/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/blue.png.json","lpc/spritesheets/legs/pants/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/brown.png","lpc/spritesheets/legs/pants/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/brown.png.json","lpc/spritesheets/legs/pants/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/gray.png","lpc/spritesheets/legs/pants/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/gray.png.json","lpc/spritesheets/legs/pants/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/green.png","lpc/spritesheets/legs/pants/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/green.png.json","lpc/spritesheets/legs/pants/male/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/maroon.png","lpc/spritesheets/legs/pants/male/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/maroon.png.json","lpc/spritesheets/legs/pants/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/orange.png","lpc/spritesheets/legs/pants/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/orange.png.json","lpc/spritesheets/legs/pants/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/purple.png","lpc/spritesheets/legs/pants/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/purple.png.json","lpc/spritesheets/legs/pants/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/red.png","lpc/spritesheets/legs/pants/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/red.png.json","lpc/spritesheets/legs/pants/male/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/tan.png","lpc/spritesheets/legs/pants/male/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/tan.png.json","lpc/spritesheets/legs/pants/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/white.png","lpc/spritesheets/legs/pants/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/white.png.json","lpc/spritesheets/legs/pants/male/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/yellow.png","lpc/spritesheets/legs/pants/male/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/pants/male/yellow.png.json","lpc/spritesheets/legs/skirts/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/female/black.png","lpc/spritesheets/legs/skirts/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/female/black.png.json","lpc/spritesheets/legs/skirts/female/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/female/brown.png","lpc/spritesheets/legs/skirts/female/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/female/brown.png.json","lpc/spritesheets/legs/skirts/female/legion.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/female/legion.png","lpc/spritesheets/legs/skirts/female/legion.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/female/legion.png.json","lpc/spritesheets/legs/skirts/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/female/white.png","lpc/spritesheets/legs/skirts/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/female/white.png.json","lpc/spritesheets/legs/skirts/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/male/black.png","lpc/spritesheets/legs/skirts/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/male/black.png.json","lpc/spritesheets/legs/skirts/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/male/brown.png","lpc/spritesheets/legs/skirts/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/male/brown.png.json","lpc/spritesheets/legs/skirts/male/legion.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/male/legion.png","lpc/spritesheets/legs/skirts/male/legion.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/male/legion.png.json","lpc/spritesheets/legs/skirts/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/male/white.png","lpc/spritesheets/legs/skirts/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/legs/skirts/male/white.png.json","lpc/spritesheets/shield/female/crusader.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/crusader.png","lpc/spritesheets/shield/female/crusader.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/crusader.png.json","lpc/spritesheets/shield/female/kite_blue_blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_blue_blue.png","lpc/spritesheets/shield/female/kite_blue_blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_blue_blue.png.json","lpc/spritesheets/shield/female/kite_blue_gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_blue_gray.png","lpc/spritesheets/shield/female/kite_blue_gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_blue_gray.png.json","lpc/spritesheets/shield/female/kite_gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_gray.png","lpc/spritesheets/shield/female/kite_gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_gray.png.json","lpc/spritesheets/shield/female/kite_gray_blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_gray_blue.png","lpc/spritesheets/shield/female/kite_gray_blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_gray_blue.png.json","lpc/spritesheets/shield/female/kite_gray_gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_gray_gray.png","lpc/spritesheets/shield/female/kite_gray_gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_gray_gray.png.json","lpc/spritesheets/shield/female/kite_gray_green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_gray_green.png","lpc/spritesheets/shield/female/kite_gray_green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_gray_green.png.json","lpc/spritesheets/shield/female/kite_gray_orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_gray_orange.png","lpc/spritesheets/shield/female/kite_gray_orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_gray_orange.png.json","lpc/spritesheets/shield/female/kite_green_gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_green_gray.png","lpc/spritesheets/shield/female/kite_green_gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_green_gray.png.json","lpc/spritesheets/shield/female/kite_orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_orange.png","lpc/spritesheets/shield/female/kite_orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_orange.png.json","lpc/spritesheets/shield/female/kite_red_gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_red_gray.png","lpc/spritesheets/shield/female/kite_red_gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/kite_red_gray.png.json","lpc/spritesheets/shield/female/round_black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/round_black.png","lpc/spritesheets/shield/female/round_black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/round_black.png.json","lpc/spritesheets/shield/female/round_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/round_brown.png","lpc/spritesheets/shield/female/round_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/round_brown.png.json","lpc/spritesheets/shield/female/round_gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/round_gold.png","lpc/spritesheets/shield/female/round_gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/round_gold.png.json","lpc/spritesheets/shield/female/round_green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/round_green.png","lpc/spritesheets/shield/female/round_green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/round_green.png.json","lpc/spritesheets/shield/female/round_silver.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/round_silver.png","lpc/spritesheets/shield/female/round_silver.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/round_silver.png.json","lpc/spritesheets/shield/female/round_yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/round_yellow.png","lpc/spritesheets/shield/female/round_yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/round_yellow.png.json","lpc/spritesheets/shield/female/spartan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/spartan.png","lpc/spritesheets/shield/female/spartan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/female/spartan.png.json","lpc/spritesheets/shield/male/crusader.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/crusader.png","lpc/spritesheets/shield/male/crusader.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/crusader.png.json","lpc/spritesheets/shield/male/kite_blue_blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_blue_blue.png","lpc/spritesheets/shield/male/kite_blue_blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_blue_blue.png.json","lpc/spritesheets/shield/male/kite_blue_gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_blue_gray.png","lpc/spritesheets/shield/male/kite_blue_gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_blue_gray.png.json","lpc/spritesheets/shield/male/kite_gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_gray.png","lpc/spritesheets/shield/male/kite_gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_gray.png.json","lpc/spritesheets/shield/male/kite_gray_blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_gray_blue.png","lpc/spritesheets/shield/male/kite_gray_blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_gray_blue.png.json","lpc/spritesheets/shield/male/kite_gray_gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_gray_gray.png","lpc/spritesheets/shield/male/kite_gray_gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_gray_gray.png.json","lpc/spritesheets/shield/male/kite_gray_green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_gray_green.png","lpc/spritesheets/shield/male/kite_gray_green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_gray_green.png.json","lpc/spritesheets/shield/male/kite_gray_orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_gray_orange.png","lpc/spritesheets/shield/male/kite_gray_orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_gray_orange.png.json","lpc/spritesheets/shield/male/kite_green_gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_green_gray.png","lpc/spritesheets/shield/male/kite_green_gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_green_gray.png.json","lpc/spritesheets/shield/male/kite_orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_orange.png","lpc/spritesheets/shield/male/kite_orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_orange.png.json","lpc/spritesheets/shield/male/kite_red_gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_red_gray.png","lpc/spritesheets/shield/male/kite_red_gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/kite_red_gray.png.json","lpc/spritesheets/shield/male/round_black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/round_black.png","lpc/spritesheets/shield/male/round_black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/round_black.png.json","lpc/spritesheets/shield/male/round_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/round_brown.png","lpc/spritesheets/shield/male/round_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/round_brown.png.json","lpc/spritesheets/shield/male/round_gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/round_gold.png","lpc/spritesheets/shield/male/round_gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/round_gold.png.json","lpc/spritesheets/shield/male/round_green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/round_green.png","lpc/spritesheets/shield/male/round_green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/round_green.png.json","lpc/spritesheets/shield/male/round_silver.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/round_silver.png","lpc/spritesheets/shield/male/round_silver.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/round_silver.png.json","lpc/spritesheets/shield/male/round_yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/round_yellow.png","lpc/spritesheets/shield/male/round_yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/round_yellow.png.json","lpc/spritesheets/shield/male/spartan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/spartan.png","lpc/spritesheets/shield/male/spartan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/shield/male/spartan.png.json","lpc/spritesheets/spike/spikes1.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/spike/spikes1.png","lpc/spritesheets/spike/spikes1.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/spike/spikes1.png.json","lpc/spritesheets/torso/armour/leather/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/leather/female/blue.png","lpc/spritesheets/torso/armour/leather/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/leather/female/blue.png.json","lpc/spritesheets/torso/armour/leather/female/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/leather/female/brown.png","lpc/spritesheets/torso/armour/leather/female/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/leather/female/brown.png.json","lpc/spritesheets/torso/armour/leather/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/leather/female/green.png","lpc/spritesheets/torso/armour/leather/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/leather/female/green.png.json","lpc/spritesheets/torso/armour/leather/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/leather/male/blue.png","lpc/spritesheets/torso/armour/leather/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/leather/male/blue.png.json","lpc/spritesheets/torso/armour/leather/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/leather/male/brown.png","lpc/spritesheets/torso/armour/leather/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/leather/male/brown.png.json","lpc/spritesheets/torso/armour/leather/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/leather/male/green.png","lpc/spritesheets/torso/armour/leather/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/leather/male/green.png.json","lpc/spritesheets/torso/armour/legion/female/bronze.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/legion/female/bronze.png","lpc/spritesheets/torso/armour/legion/female/bronze.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/legion/female/bronze.png.json","lpc/spritesheets/torso/armour/legion/female/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/legion/female/gold.png","lpc/spritesheets/torso/armour/legion/female/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/legion/female/gold.png.json","lpc/spritesheets/torso/armour/legion/female/steel.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/legion/female/steel.png","lpc/spritesheets/torso/armour/legion/female/steel.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/legion/female/steel.png.json","lpc/spritesheets/torso/armour/legion/male/bronze.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/legion/male/bronze.png","lpc/spritesheets/torso/armour/legion/male/bronze.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/legion/male/bronze.png.json","lpc/spritesheets/torso/armour/legion/male/gold.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/legion/male/gold.png","lpc/spritesheets/torso/armour/legion/male/gold.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/legion/male/gold.png.json","lpc/spritesheets/torso/armour/legion/male/steel.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/legion/male/steel.png","lpc/spritesheets/torso/armour/legion/male/steel.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/legion/male/steel.png.json","lpc/spritesheets/torso/armour/plate/female/11.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/female/11.png","lpc/spritesheets/torso/armour/plate/female/11.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/female/11.png.json","lpc/spritesheets/torso/armour/plate/female/12.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/female/12.png","lpc/spritesheets/torso/armour/plate/female/12.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/female/12.png.json","lpc/spritesheets/torso/armour/plate/female/14.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/female/14.png","lpc/spritesheets/torso/armour/plate/female/14.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/female/14.png.json","lpc/spritesheets/torso/armour/plate/female/16.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/female/16.png","lpc/spritesheets/torso/armour/plate/female/16.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/female/16.png.json","lpc/spritesheets/torso/armour/plate/female/special.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/female/special.png","lpc/spritesheets/torso/armour/plate/female/special.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/female/special.png.json","lpc/spritesheets/torso/armour/plate/male/11.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/male/11.png","lpc/spritesheets/torso/armour/plate/male/11.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/male/11.png.json","lpc/spritesheets/torso/armour/plate/male/12.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/male/12.png","lpc/spritesheets/torso/armour/plate/male/12.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/male/12.png.json","lpc/spritesheets/torso/armour/plate/male/14.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/male/14.png","lpc/spritesheets/torso/armour/plate/male/14.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/male/14.png.json","lpc/spritesheets/torso/armour/plate/male/16.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/male/16.png","lpc/spritesheets/torso/armour/plate/male/16.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/male/16.png.json","lpc/spritesheets/torso/armour/plate/male/special.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/male/special.png","lpc/spritesheets/torso/armour/plate/male/special.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/armour/plate/male/special.png.json","lpc/spritesheets/torso/clothes/blouse/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/black.png","lpc/spritesheets/torso/clothes/blouse/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/black.png.json","lpc/spritesheets/torso/clothes/blouse/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/blue.png","lpc/spritesheets/torso/clothes/blouse/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/blue.png.json","lpc/spritesheets/torso/clothes/blouse/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/gray.png","lpc/spritesheets/torso/clothes/blouse/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/gray.png.json","lpc/spritesheets/torso/clothes/blouse/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/green.png","lpc/spritesheets/torso/clothes/blouse/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/green.png.json","lpc/spritesheets/torso/clothes/blouse/female/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/maroon.png","lpc/spritesheets/torso/clothes/blouse/female/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/maroon.png.json","lpc/spritesheets/torso/clothes/blouse/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/orange.png","lpc/spritesheets/torso/clothes/blouse/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/orange.png.json","lpc/spritesheets/torso/clothes/blouse/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/purple.png","lpc/spritesheets/torso/clothes/blouse/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/purple.png.json","lpc/spritesheets/torso/clothes/blouse/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/red.png","lpc/spritesheets/torso/clothes/blouse/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/red.png.json","lpc/spritesheets/torso/clothes/blouse/female/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/tan.png","lpc/spritesheets/torso/clothes/blouse/female/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/tan.png.json","lpc/spritesheets/torso/clothes/blouse/female/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/teal.png","lpc/spritesheets/torso/clothes/blouse/female/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/teal.png.json","lpc/spritesheets/torso/clothes/blouse/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/white.png","lpc/spritesheets/torso/clothes/blouse/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/white.png.json","lpc/spritesheets/torso/clothes/blouse/female/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/yellow.png","lpc/spritesheets/torso/clothes/blouse/female/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse/female/yellow.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/black.png","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/black.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/blue.png","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/blue.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/gray.png","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/gray.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/green.png","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/green.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/maroon.png","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/maroon.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/orange.png","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/orange.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/purple.png","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/purple.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/red.png","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/red.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/tan.png","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/tan.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/teal.png","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/teal.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/white.png","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/white.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/yellow.png","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/blouse_longsleeve/female/yellow.png.json","lpc/spritesheets/torso/clothes/corset/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/black.png","lpc/spritesheets/torso/clothes/corset/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/black.png.json","lpc/spritesheets/torso/clothes/corset/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/blue.png","lpc/spritesheets/torso/clothes/corset/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/blue.png.json","lpc/spritesheets/torso/clothes/corset/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/gray.png","lpc/spritesheets/torso/clothes/corset/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/gray.png.json","lpc/spritesheets/torso/clothes/corset/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/green.png","lpc/spritesheets/torso/clothes/corset/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/green.png.json","lpc/spritesheets/torso/clothes/corset/female/leather.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/leather.png","lpc/spritesheets/torso/clothes/corset/female/leather.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/leather.png.json","lpc/spritesheets/torso/clothes/corset/female/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/maroon.png","lpc/spritesheets/torso/clothes/corset/female/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/maroon.png.json","lpc/spritesheets/torso/clothes/corset/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/orange.png","lpc/spritesheets/torso/clothes/corset/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/orange.png.json","lpc/spritesheets/torso/clothes/corset/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/purple.png","lpc/spritesheets/torso/clothes/corset/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/purple.png.json","lpc/spritesheets/torso/clothes/corset/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/red.png","lpc/spritesheets/torso/clothes/corset/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/red.png.json","lpc/spritesheets/torso/clothes/corset/female/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/tan.png","lpc/spritesheets/torso/clothes/corset/female/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/tan.png.json","lpc/spritesheets/torso/clothes/corset/female/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/teal.png","lpc/spritesheets/torso/clothes/corset/female/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/teal.png.json","lpc/spritesheets/torso/clothes/corset/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/white.png","lpc/spritesheets/torso/clothes/corset/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/white.png.json","lpc/spritesheets/torso/clothes/corset/female/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/yellow.png","lpc/spritesheets/torso/clothes/corset/female/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/corset/female/yellow.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/black.png","lpc/spritesheets/torso/clothes/longsleeve/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/black.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/blue.png","lpc/spritesheets/torso/clothes/longsleeve/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/blue.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/gray.png","lpc/spritesheets/torso/clothes/longsleeve/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/gray.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/green.png","lpc/spritesheets/torso/clothes/longsleeve/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/green.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/maroon.png","lpc/spritesheets/torso/clothes/longsleeve/female/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/maroon.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/orange.png","lpc/spritesheets/torso/clothes/longsleeve/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/orange.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/purple.png","lpc/spritesheets/torso/clothes/longsleeve/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/purple.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/red.png","lpc/spritesheets/torso/clothes/longsleeve/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/red.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/tan.png","lpc/spritesheets/torso/clothes/longsleeve/female/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/tan.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/teal.png","lpc/spritesheets/torso/clothes/longsleeve/female/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/teal.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/white.png","lpc/spritesheets/torso/clothes/longsleeve/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/white.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/yellow.png","lpc/spritesheets/torso/clothes/longsleeve/female/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/female/yellow.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/black.png","lpc/spritesheets/torso/clothes/longsleeve/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/black.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/blue.png","lpc/spritesheets/torso/clothes/longsleeve/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/blue.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/brown.png","lpc/spritesheets/torso/clothes/longsleeve/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/brown.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/green.png","lpc/spritesheets/torso/clothes/longsleeve/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/green.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/maroon.png","lpc/spritesheets/torso/clothes/longsleeve/male/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/maroon.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/purple.png","lpc/spritesheets/torso/clothes/longsleeve/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/purple.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/red.png","lpc/spritesheets/torso/clothes/longsleeve/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/red.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/teal.png","lpc/spritesheets/torso/clothes/longsleeve/male/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/teal.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/white.png","lpc/spritesheets/torso/clothes/longsleeve/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/white.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/yellow.png","lpc/spritesheets/torso/clothes/longsleeve/male/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve/male/yellow.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/black.png","lpc/spritesheets/torso/clothes/longsleeve_laced/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/black.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/blue.png","lpc/spritesheets/torso/clothes/longsleeve_laced/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/blue.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/brown.png","lpc/spritesheets/torso/clothes/longsleeve_laced/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/brown.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/gray.png","lpc/spritesheets/torso/clothes/longsleeve_laced/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/gray.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/green.png","lpc/spritesheets/torso/clothes/longsleeve_laced/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/green.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/maroon.png","lpc/spritesheets/torso/clothes/longsleeve_laced/male/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/maroon.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/orange.png","lpc/spritesheets/torso/clothes/longsleeve_laced/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/orange.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/purple.png","lpc/spritesheets/torso/clothes/longsleeve_laced/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/purple.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/red.png","lpc/spritesheets/torso/clothes/longsleeve_laced/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/red.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/tan.png","lpc/spritesheets/torso/clothes/longsleeve_laced/male/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/tan.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/teal.png","lpc/spritesheets/torso/clothes/longsleeve_laced/male/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/teal.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/white.png","lpc/spritesheets/torso/clothes/longsleeve_laced/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/white.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/yellow.png","lpc/spritesheets/torso/clothes/longsleeve_laced/male/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/longsleeve_laced/male/yellow.png.json","lpc/spritesheets/torso/clothes/robe/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/black.png","lpc/spritesheets/torso/clothes/robe/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/black.png.json","lpc/spritesheets/torso/clothes/robe/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/blue.png","lpc/spritesheets/torso/clothes/robe/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/blue.png.json","lpc/spritesheets/torso/clothes/robe/female/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/brown.png","lpc/spritesheets/torso/clothes/robe/female/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/brown.png.json","lpc/spritesheets/torso/clothes/robe/female/dark_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/dark_brown.png","lpc/spritesheets/torso/clothes/robe/female/dark_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/dark_brown.png.json","lpc/spritesheets/torso/clothes/robe/female/dark_gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/dark_gray.png","lpc/spritesheets/torso/clothes/robe/female/dark_gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/dark_gray.png.json","lpc/spritesheets/torso/clothes/robe/female/forest_green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/forest_green.png","lpc/spritesheets/torso/clothes/robe/female/forest_green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/forest_green.png.json","lpc/spritesheets/torso/clothes/robe/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/purple.png","lpc/spritesheets/torso/clothes/robe/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/purple.png.json","lpc/spritesheets/torso/clothes/robe/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/red.png","lpc/spritesheets/torso/clothes/robe/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/red.png.json","lpc/spritesheets/torso/clothes/robe/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/white.png","lpc/spritesheets/torso/clothes/robe/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/robe/female/white.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/black.png","lpc/spritesheets/torso/clothes/scoop_shirt/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/black.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/blue.png","lpc/spritesheets/torso/clothes/scoop_shirt/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/blue.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/gray.png","lpc/spritesheets/torso/clothes/scoop_shirt/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/gray.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/green.png","lpc/spritesheets/torso/clothes/scoop_shirt/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/green.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/maroon.png","lpc/spritesheets/torso/clothes/scoop_shirt/female/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/maroon.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/orange.png","lpc/spritesheets/torso/clothes/scoop_shirt/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/orange.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/purple.png","lpc/spritesheets/torso/clothes/scoop_shirt/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/purple.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/red.png","lpc/spritesheets/torso/clothes/scoop_shirt/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/red.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/tan.png","lpc/spritesheets/torso/clothes/scoop_shirt/female/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/tan.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/teal.png","lpc/spritesheets/torso/clothes/scoop_shirt/female/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/teal.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/white.png","lpc/spritesheets/torso/clothes/scoop_shirt/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/white.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/yellow.png","lpc/spritesheets/torso/clothes/scoop_shirt/female/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/scoop_shirt/female/yellow.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/black.png","lpc/spritesheets/torso/clothes/sleeveless/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/black.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/blue.png","lpc/spritesheets/torso/clothes/sleeveless/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/blue.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/brown.png","lpc/spritesheets/torso/clothes/sleeveless/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/brown.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/gray.png","lpc/spritesheets/torso/clothes/sleeveless/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/gray.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/green.png","lpc/spritesheets/torso/clothes/sleeveless/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/green.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/maroon.png","lpc/spritesheets/torso/clothes/sleeveless/male/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/maroon.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/orange.png","lpc/spritesheets/torso/clothes/sleeveless/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/orange.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/purple.png","lpc/spritesheets/torso/clothes/sleeveless/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/purple.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/red.png","lpc/spritesheets/torso/clothes/sleeveless/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/red.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/tan.png","lpc/spritesheets/torso/clothes/sleeveless/male/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/tan.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/teal.png","lpc/spritesheets/torso/clothes/sleeveless/male/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/teal.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/white.png","lpc/spritesheets/torso/clothes/sleeveless/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/white.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/yellow.png","lpc/spritesheets/torso/clothes/sleeveless/male/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless/male/yellow.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/black.png","lpc/spritesheets/torso/clothes/sleeveless_laced/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/black.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/blue.png","lpc/spritesheets/torso/clothes/sleeveless_laced/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/blue.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/brown.png","lpc/spritesheets/torso/clothes/sleeveless_laced/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/brown.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/gray.png","lpc/spritesheets/torso/clothes/sleeveless_laced/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/gray.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/green.png","lpc/spritesheets/torso/clothes/sleeveless_laced/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/green.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/maroon.png","lpc/spritesheets/torso/clothes/sleeveless_laced/male/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/maroon.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/orange.png","lpc/spritesheets/torso/clothes/sleeveless_laced/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/orange.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/purple.png","lpc/spritesheets/torso/clothes/sleeveless_laced/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/purple.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/red.png","lpc/spritesheets/torso/clothes/sleeveless_laced/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/red.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/tan.png","lpc/spritesheets/torso/clothes/sleeveless_laced/male/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/tan.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/teal.png","lpc/spritesheets/torso/clothes/sleeveless_laced/male/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/teal.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/white.png","lpc/spritesheets/torso/clothes/sleeveless_laced/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/white.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/yellow.png","lpc/spritesheets/torso/clothes/sleeveless_laced/male/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_laced/male/yellow.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/black.png","lpc/spritesheets/torso/clothes/sleeveless_striped/male/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/black.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/blue.png","lpc/spritesheets/torso/clothes/sleeveless_striped/male/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/blue.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/brown.png","lpc/spritesheets/torso/clothes/sleeveless_striped/male/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/brown.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/gray.png","lpc/spritesheets/torso/clothes/sleeveless_striped/male/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/gray.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/green.png","lpc/spritesheets/torso/clothes/sleeveless_striped/male/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/green.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/maroon.png","lpc/spritesheets/torso/clothes/sleeveless_striped/male/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/maroon.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/orange.png","lpc/spritesheets/torso/clothes/sleeveless_striped/male/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/orange.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/purple.png","lpc/spritesheets/torso/clothes/sleeveless_striped/male/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/purple.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/red.png","lpc/spritesheets/torso/clothes/sleeveless_striped/male/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/red.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/tan.png","lpc/spritesheets/torso/clothes/sleeveless_striped/male/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/tan.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/teal.png","lpc/spritesheets/torso/clothes/sleeveless_striped/male/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/teal.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/white.png","lpc/spritesheets/torso/clothes/sleeveless_striped/male/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/white.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/yellow.png","lpc/spritesheets/torso/clothes/sleeveless_striped/male/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/sleeveless_striped/male/yellow.png.json","lpc/spritesheets/torso/clothes/tanktop/female/black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/black.png","lpc/spritesheets/torso/clothes/tanktop/female/black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/black.png.json","lpc/spritesheets/torso/clothes/tanktop/female/blue.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/blue.png","lpc/spritesheets/torso/clothes/tanktop/female/blue.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/blue.png.json","lpc/spritesheets/torso/clothes/tanktop/female/gray.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/gray.png","lpc/spritesheets/torso/clothes/tanktop/female/gray.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/gray.png.json","lpc/spritesheets/torso/clothes/tanktop/female/green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/green.png","lpc/spritesheets/torso/clothes/tanktop/female/green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/green.png.json","lpc/spritesheets/torso/clothes/tanktop/female/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/maroon.png","lpc/spritesheets/torso/clothes/tanktop/female/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/maroon.png.json","lpc/spritesheets/torso/clothes/tanktop/female/orange.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/orange.png","lpc/spritesheets/torso/clothes/tanktop/female/orange.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/orange.png.json","lpc/spritesheets/torso/clothes/tanktop/female/purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/purple.png","lpc/spritesheets/torso/clothes/tanktop/female/purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/purple.png.json","lpc/spritesheets/torso/clothes/tanktop/female/red.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/red.png","lpc/spritesheets/torso/clothes/tanktop/female/red.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/red.png.json","lpc/spritesheets/torso/clothes/tanktop/female/tan.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/tan.png","lpc/spritesheets/torso/clothes/tanktop/female/tan.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/tan.png.json","lpc/spritesheets/torso/clothes/tanktop/female/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/teal.png","lpc/spritesheets/torso/clothes/tanktop/female/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/teal.png.json","lpc/spritesheets/torso/clothes/tanktop/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/white.png","lpc/spritesheets/torso/clothes/tanktop/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/white.png.json","lpc/spritesheets/torso/clothes/tanktop/female/yellow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/yellow.png","lpc/spritesheets/torso/clothes/tanktop/female/yellow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tanktop/female/yellow.png.json","lpc/spritesheets/torso/clothes/tunic/female/brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tunic/female/brown.png","lpc/spritesheets/torso/clothes/tunic/female/brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tunic/female/brown.png.json","lpc/spritesheets/torso/clothes/tunic/female/maroon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tunic/female/maroon.png","lpc/spritesheets/torso/clothes/tunic/female/maroon.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tunic/female/maroon.png.json","lpc/spritesheets/torso/clothes/tunic/female/teal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tunic/female/teal.png","lpc/spritesheets/torso/clothes/tunic/female/teal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tunic/female/teal.png.json","lpc/spritesheets/torso/clothes/tunic/female/white.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tunic/female/white.png","lpc/spritesheets/torso/clothes/tunic/female/white.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/torso/clothes/tunic/female/white.png.json","lpc/spritesheets/weapon/bow/10.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/bow/10.png","lpc/spritesheets/weapon/bow/10.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/bow/10.png.json","lpc/spritesheets/weapon/bow/normal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/bow/normal.png","lpc/spritesheets/weapon/bow/normal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/bow/normal.png.json","lpc/spritesheets/weapon/slash/female/axe.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/female/axe.png","lpc/spritesheets/weapon/slash/female/axe.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/female/axe.png.json","lpc/spritesheets/weapon/slash/female/axe_2.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/female/axe_2.png","lpc/spritesheets/weapon/slash/female/axe_2.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/female/axe_2.png.json","lpc/spritesheets/weapon/slash/female/dagger.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/female/dagger.png","lpc/spritesheets/weapon/slash/female/dagger.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/female/dagger.png.json","lpc/spritesheets/weapon/slash/female/dagger_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/female/dagger_brown.png","lpc/spritesheets/weapon/slash/female/dagger_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/female/dagger_brown.png.json","lpc/spritesheets/weapon/slash/female/warhammer.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/female/warhammer.png","lpc/spritesheets/weapon/slash/female/warhammer.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/female/warhammer.png.json","lpc/spritesheets/weapon/slash/male/axe.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/male/axe.png","lpc/spritesheets/weapon/slash/male/axe.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/male/axe.png.json","lpc/spritesheets/weapon/slash/male/axe_2.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/male/axe_2.png","lpc/spritesheets/weapon/slash/male/axe_2.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/male/axe_2.png.json","lpc/spritesheets/weapon/slash/male/dagger.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/male/dagger.png","lpc/spritesheets/weapon/slash/male/dagger.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/male/dagger.png.json","lpc/spritesheets/weapon/slash/male/dagger_brown.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/male/dagger_brown.png","lpc/spritesheets/weapon/slash/male/dagger_brown.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/male/dagger_brown.png.json","lpc/spritesheets/weapon/slash/male/warhammer.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/male/warhammer.png","lpc/spritesheets/weapon/slash/male/warhammer.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash/male/warhammer.png.json","lpc/spritesheets/weapon/slash_oversize/female/flail.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/female/flail.png","lpc/spritesheets/weapon/slash_oversize/female/flail.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/female/flail.png.json","lpc/spritesheets/weapon/slash_oversize/female/halberd.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/female/halberd.png","lpc/spritesheets/weapon/slash_oversize/female/halberd.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/female/halberd.png.json","lpc/spritesheets/weapon/slash_oversize/female/universal/flail.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/female/universal/flail.png","lpc/spritesheets/weapon/slash_oversize/female/universal/flail.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/female/universal/flail.png.json","lpc/spritesheets/weapon/slash_oversize/female/universal/halberd.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/female/universal/halberd.png","lpc/spritesheets/weapon/slash_oversize/female/universal/halberd.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/female/universal/halberd.png.json","lpc/spritesheets/weapon/slash_oversize/female/universal/waraxe.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/female/universal/waraxe.png","lpc/spritesheets/weapon/slash_oversize/female/universal/waraxe.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/female/universal/waraxe.png.json","lpc/spritesheets/weapon/slash_oversize/female/waraxe.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/female/waraxe.png","lpc/spritesheets/weapon/slash_oversize/female/waraxe.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/female/waraxe.png.json","lpc/spritesheets/weapon/slash_oversize/male/flail.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/male/flail.png","lpc/spritesheets/weapon/slash_oversize/male/flail.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/male/flail.png.json","lpc/spritesheets/weapon/slash_oversize/male/halberd.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/male/halberd.png","lpc/spritesheets/weapon/slash_oversize/male/halberd.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/male/halberd.png.json","lpc/spritesheets/weapon/slash_oversize/male/universal/flail.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/male/universal/flail.png","lpc/spritesheets/weapon/slash_oversize/male/universal/flail.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/male/universal/flail.png.json","lpc/spritesheets/weapon/slash_oversize/male/universal/halberd.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/male/universal/halberd.png","lpc/spritesheets/weapon/slash_oversize/male/universal/halberd.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/male/universal/halberd.png.json","lpc/spritesheets/weapon/slash_oversize/male/universal/waraxe.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/male/universal/waraxe.png","lpc/spritesheets/weapon/slash_oversize/male/universal/waraxe.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/male/universal/waraxe.png.json","lpc/spritesheets/weapon/slash_oversize/male/waraxe.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/male/waraxe.png","lpc/spritesheets/weapon/slash_oversize/male/waraxe.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize/male/waraxe.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/longsword.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/longsword.png","lpc/spritesheets/weapon/slash_oversize_layered/all/longsword.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/longsword.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/mace.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/mace.png","lpc/spritesheets/weapon/slash_oversize_layered/all/mace.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/mace.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/rapier.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/rapier.png","lpc/spritesheets/weapon/slash_oversize_layered/all/rapier.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/rapier.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/saber.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/saber.png","lpc/spritesheets/weapon/slash_oversize_layered/all/saber.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/saber.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/scythe.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/scythe.png","lpc/spritesheets/weapon/slash_oversize_layered/all/scythe.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/scythe.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/longsword.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/longsword.png","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/longsword.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/longsword.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/mace.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/mace.png","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/mace.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/mace.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/rapier.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/rapier.png","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/rapier.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/rapier.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/saber.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/saber.png","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/saber.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/saber.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/scythe.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/scythe.png","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/scythe.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/scythe.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/longsword.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/longsword.png","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/longsword.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/longsword.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/mace.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/mace.png","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/mace.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/mace.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/rapier.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/rapier.png","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/rapier.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/rapier.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/saber.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/saber.png","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/saber.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/saber.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/scythe.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/scythe.png","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/scythe.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/slash_oversize_layered/all/universal/scythe.png.json","lpc/spritesheets/weapon/thrust/female/crossbow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/crossbow.png","lpc/spritesheets/weapon/thrust/female/crossbow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/crossbow.png.json","lpc/spritesheets/weapon/thrust/female/simple_staff.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/simple_staff.png","lpc/spritesheets/weapon/thrust/female/simple_staff.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/simple_staff.png.json","lpc/spritesheets/weapon/thrust/female/spear_2.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/spear_2.png","lpc/spritesheets/weapon/thrust/female/spear_2.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/spear_2.png.json","lpc/spritesheets/weapon/thrust/female/spear_black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/spear_black.png","lpc/spritesheets/weapon/thrust/female/spear_black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/spear_black.png.json","lpc/spritesheets/weapon/thrust/female/spear_green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/spear_green.png","lpc/spritesheets/weapon/thrust/female/spear_green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/spear_green.png.json","lpc/spritesheets/weapon/thrust/female/spear_metal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/spear_metal.png","lpc/spritesheets/weapon/thrust/female/spear_metal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/spear_metal.png.json","lpc/spritesheets/weapon/thrust/female/spear_purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/spear_purple.png","lpc/spritesheets/weapon/thrust/female/spear_purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/female/spear_purple.png.json","lpc/spritesheets/weapon/thrust/male/crossbow.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/crossbow.png","lpc/spritesheets/weapon/thrust/male/crossbow.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/crossbow.png.json","lpc/spritesheets/weapon/thrust/male/simple_staff.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/simple_staff.png","lpc/spritesheets/weapon/thrust/male/simple_staff.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/simple_staff.png.json","lpc/spritesheets/weapon/thrust/male/spear_2.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/spear_2.png","lpc/spritesheets/weapon/thrust/male/spear_2.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/spear_2.png.json","lpc/spritesheets/weapon/thrust/male/spear_black.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/spear_black.png","lpc/spritesheets/weapon/thrust/male/spear_black.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/spear_black.png.json","lpc/spritesheets/weapon/thrust/male/spear_green.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/spear_green.png","lpc/spritesheets/weapon/thrust/male/spear_green.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/spear_green.png.json","lpc/spritesheets/weapon/thrust/male/spear_metal.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/spear_metal.png","lpc/spritesheets/weapon/thrust/male/spear_metal.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/spear_metal.png.json","lpc/spritesheets/weapon/thrust/male/spear_purple.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/spear_purple.png","lpc/spritesheets/weapon/thrust/male/spear_purple.png.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/lpc/spritesheets/weapon/thrust/male/spear_purple.png.json","mana.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/mana.mp3","map-atlas.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/map-atlas.json","map-atlas.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/map-atlas.png","map_location.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/map_location.ogg","maps/templates/caves.tmj":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/templates/caves.tmj","maps/templates/geo.tmj":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/templates/geo.tmj","maps/templates/item.tmj":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/templates/item.tmj","maps/templates/ruins.tmj":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/templates/ruins.tmj","maps/templates/settlement.tmj":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/templates/settlement.tmj","maps/tilesets/authored-terrain.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/authored-terrain.tsx","maps/tilesets/beach-desert.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/beach-desert.tsx","maps/tilesets/bonecaller-stones.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/bonecaller-stones.json","maps/tilesets/build_atlas.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/build_atlas.tsx","maps/tilesets/container.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/container.tsx","maps/tilesets/cottage.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/cottage.tsx","maps/tilesets/decorations-medieval.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/decorations-medieval.tsx","maps/tilesets/fence_medieval.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/fence_medieval.tsx","maps/tilesets/floors.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/floors.tsx","maps/tilesets/forest-dirt.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/forest-dirt.tsx","maps/tilesets/forest-grass.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/forest-grass.tsx","maps/tilesets/furniture-blonde-wood.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/furniture-blonde-wood.tsx","maps/tilesets/jungle-ruins.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/jungle-ruins.tsx","maps/tilesets/lpc-flowers-plants-fungi-wood.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/lpc-flowers-plants-fungi-wood.tsx","maps/tilesets/lpc-terrain.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/lpc-terrain.tsx","maps/tilesets/map-atlas.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/map-atlas.tsx","maps/tilesets/mountains-v6.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/mountains-v6.tsx","maps/tilesets/ore.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/ore.tsx","maps/tilesets/plants.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/plants.tsx","maps/tilesets/roofs.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/roofs.tsx","maps/tilesets/walls.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/walls.tsx","maps/tilesets/walls2.tsx":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/maps/tilesets/walls2.tsx","mountains-v6.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/mountains-v6.json","mountains-v6.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/mountains-v6.png","ore.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/ore.json","ore.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/ore.png","overworld-day-noises.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/overworld-day-noises.ogg","overworld-night-noises.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/overworld-night-noises.ogg","overworld1.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/overworld1.ogg","plants.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/plants.json","plants.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/plants.png","powerup.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/powerup.mp3","reddit.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/reddit.png","roofs.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/roofs.json","roofs.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/roofs.png","samsara_cropped.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/samsara_cropped.png","shoot.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/shoot.ogg","shotgun.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/shotgun.mp3","stairs-icon.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/stairs-icon.json","stairs-icon.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/stairs-icon.png","strike1.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/strike1.ogg","strike2.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/strike2.ogg","swamp/0.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/swamp/0.ogg","swamp/1.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/swamp/1.ogg","swordswing.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/swordswing.ogg","thatched-roof.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/thatched-roof.png","to_battle.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/to_battle.ogg","tree_creak.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/tree_creak.ogg","tree_fall.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/tree_fall.ogg","visitor_arrives.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/visitor_arrives.ogg","walls.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/walls.json","walls.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/walls.png","walls2.json":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/walls2.json","walls2.png":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/walls2.png","wave_starting.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/wave_starting.ogg","wheel_select.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/wheel_select.ogg","woodhit.ogg":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/woodhit.ogg","zombie/attack/1.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/attack/1.mp3","zombie/attack/2.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/attack/2.mp3","zombie/attack/3.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/attack/3.mp3","zombie/attack/4.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/attack/4.mp3","zombie/attack/5.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/attack/5.mp3","zombie/attack/6.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/attack/6.mp3","zombie/attack/7.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/attack/7.mp3","zombie/death/1.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/death/1.mp3","zombie/death/2.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/death/2.mp3","zombie/death/3.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/death/3.mp3","zombie/death/4.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/death/4.mp3","zombie/death/5.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/death/5.mp3","zombie/death/6.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/death/6.mp3","zombie/detect/1.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/detect/1.mp3","zombie/detect/2.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/detect/2.mp3","zombie/detect/3.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/detect/3.mp3","zombie/detect/4.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/detect/4.mp3","zombie/detect/5.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/detect/5.mp3","zombie/hit/1.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/hit/1.mp3","zombie/hit/2.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/hit/2.mp3","zombie/hit/3.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/hit/3.mp3","zombie/hit/4.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/hit/4.mp3","zombie/hit/5.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/hit/5.mp3","zombie/hit/6.mp3":"content/072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c/zombie/hit/6.mp3"},"creatures":{"lpc-chicken":{"template":"chicken"},"lpc-viper":{"template":"snake"},"rage-slime":{"template":"snake"},"wild-hare":{"template":"rabbit"}},"itemDrops":{"armor-leather":[{"itemType":{"class":"resource","color":"gray","type":"shard-metal"},"quantity":3}],"armor-legion":[{"itemType":{"class":"resource","color":"gray","type":"shard-metal"},"quantity":2}],"armor-plate":[{"itemType":{"class":"resource","color":"gray","type":"shard-metal"},"quantity":3}],"axe":[{"itemType":{"class":"resource","color":"gray","type":"shard-metal"},"quantity":2}],"dagger":[{"itemType":{"class":"resource","color":"gray","type":"shard-metal"},"quantity":1}],"spear":[{"itemType":{"class":"resource","color":"gray","type":"shard-metal"},"quantity":1}]},"items":{"all":["armor-leather","armor-legion","armor-plate","arrow","axe","bauldron","blouse","blouse_longsleeve","boots","bow","campfire","cape-solid","cape-tattered","cape-trimmed","castlekey","chest-wood","coal","copper","corset","crossbow","dagger","door-wood","drumstick","feather","flail","floor-cobble","floor-stone","floor-wood","flower-single-blue","flower-single-purple","flower-single-red","flower-single-yellow","gold","halberd","hide","iron","legion","longsleeve","longsleeve_laced","longsword","mace","metal-bar-copper","metal-bar-gold","metal-bar-iron","metal-bar-silver","mushroom-purple","mushroom-red","mushroom-yellow","none","pantaloons","pants","pants-armor","planks","railing-wood","rapier","roof-wood","rope","saber","sandals","scoop_shirt","scythe","seed","shard-metal","shield-crusader","shield-kite","shield-kite_blue","shield-kite_gray","shield-kite_green","shield-kite_red","shield-round","shield-spartan","shoes","shoes-armor","silver","skirts","sleeveless","sleeveless_laced","sleeveless_striped","slippers","snare-rabbit","spear","staff","stick","stool-small","straw","table-large-rough","table-mid-round","tanktop","torch","tunic","wall-wood","wall2-wood","wall-stone","waraxe","warhammer","web","webAmmo","wood","ember-charge","spider-silk","barrel1","stackedBags","stool1","table-mid-rough","strawBed","strawBedSmall","iron-pickaxe","stairs","floor-opening","timber-frame-wall","thatch-roof","window-frame","chimney-stack","dormer-window","grove-oak-a","grove-oak-b","grove-spruce-a","grove-spruce-b","grove-round-a","grove-round-b","grove-low-a","grove-low-b","meadow-grass-a","meadow-grass-b","meadow-grass-c","meadow-grass-d","meadow-grass-e","meadow-grass-f","meadow-sprout","hatch-wood","castle-footing","castle-wall","castle-merlons","arrow-slit","tower-render"],"characteristics":{"arrow":{"isAmmo":true,"stackable":true,"unsellable":true},"arrow-slit":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"ornament":"arrow-slit","stackable":true,"useHasWorldEffect":true},"barrel1":{"buildable":true,"readyable":true,"unbuyable":true},"campfire":{"placementAction":"use","placementRange":1,"useHasWorldEffect":true,"useable":true},"castle-footing":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"castle-merlons":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"castle-wall":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"castlekey":{"stackable":true},"chest-wood":{"buildType":"entity","buildable":true,"exclusiveReadiness":true,"placementAction":"build","placementRange":1,"stackable":false,"useHasWorldEffect":true},"chimney-stack":{"buildType":"roof","buildable":true,"exclusiveReadiness":true,"ornament":"chimney","stackable":true,"useHasWorldEffect":true},"crossbow":{"unbuyable":true},"door-wood":{"buildType":"entity","buildable":true,"exclusiveReadiness":true,"stackable":false,"useHasWorldEffect":true},"dormer-window":{"buildType":"roof","buildable":true,"exclusiveReadiness":true,"ornament":"dormer","stackable":true,"useHasWorldEffect":true},"drumstick":{"primaryUseable":true,"unbuyable":true,"useHasWorldEffect":true,"useable":true},"ember-charge":{"isAmmo":true,"stackable":true,"unbuyable":true,"unsellable":true},"feather":{"unbuyable":true,"unsellable":true},"flail":{"unbuyable":true},"floor-cobble":{"buildType":"floor","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"floor-opening":{"buildType":"entity","buildable":false,"stackable":false},"floor-stone":{"buildType":"floor","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"floor-wood":{"buildType":"floor","buildable":true,"campfireFuel":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"flower-single-blue":{"unbuyable":true,"unsellable":true},"flower-single-purple":{"unbuyable":true,"unsellable":true},"flower-single-red":{"unbuyable":true,"unsellable":true},"flower-single-yellow":{"unbuyable":true,"unsellable":true},"grove-low-a":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"grove-low-b":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"grove-oak-a":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"grove-oak-b":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"grove-round-a":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"grove-round-b":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"grove-spruce-a":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"grove-spruce-b":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"halberd":{"unbuyable":true},"hatch-wood":{"buildType":"entity","buildable":false,"stackable":true},"hide":{"unbuyable":true},"longsword":{"unbuyable":true},"mace":{"unbuyable":true},"meadow-grass-a":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"meadow-grass-b":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"meadow-grass-c":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"meadow-grass-d":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"meadow-grass-e":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"meadow-grass-f":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"meadow-sprout":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"mushroom-purple":{"unbuyable":true,"useHasWorldEffect":true,"useable":true},"mushroom-red":{"unbuyable":true,"useHasWorldEffect":true,"useable":true},"mushroom-yellow":{"unbuyable":true,"useHasWorldEffect":true,"useable":true},"none":{"hasDurability":false},"railing-wood":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"rapier":{"unbuyable":true},"roof-wood":{"buildType":"roof","buildable":true,"campfireFuel":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"rope":{"unbuyable":true},"saber":{"unbuyable":true},"scythe":{"unbuyable":true},"seed":{"placementAction":"use","placementRange":1,"unbuyable":true,"unsellable":true,"useHasWorldEffect":true,"useable":true},"snare-rabbit":{"useHasWorldEffect":true,"useable":true},"spider-silk":{"stackable":true,"unbuyable":true,"unsellable":true},"stackedBags":{"buildable":true,"readyable":true,"unbuyable":true},"staff":{"unbuyable":true},"stairs":{"buildType":"entity","buildable":true,"deactivateAfterPlacement":true,"exclusiveReadiness":true,"placementAction":"build","stackable":false,"useHasWorldEffect":true},"stool-small":{"buildable":true,"exclusiveReadiness":true,"stackable":false,"useHasWorldEffect":true},"stool1":{"buildable":true,"readyable":true,"unbuyable":true,"useable":false},"straw":{"unbuyable":true,"unsellable":true},"strawBed":{"buildable":true,"readyable":true,"unbuyable":true,"useable":false},"strawBedSmall":{"buildable":true,"readyable":true,"unbuyable":true,"useable":false},"table-large-rough":{"buildable":true,"exclusiveReadiness":true,"stackable":false,"useHasWorldEffect":true,"useable":false},"table-mid-rough":{"buildable":true,"readyable":true,"unbuyable":true,"useable":false},"table-mid-round":{"buildable":true,"exclusiveReadiness":true,"stackable":false,"useHasWorldEffect":true,"useable":false},"thatch-roof":{"buildType":"roof","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"timber-frame-wall":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"torch":{"useable":true},"tower-render":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"wall-stone":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"wall-wood":{"buildType":"wall","buildable":true,"campfireFuel":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"wall2-wood":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"waraxe":{"unbuyable":true},"warhammer":{"unbuyable":true},"window-frame":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"ornament":"window","stackable":true,"useHasWorldEffect":true},"wood":{"campfireFuel":true,"exclusiveReadiness":true,"primaryUseable":true,"unbuyable":true}},"classCharacteristics":{"armor":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"bauldron":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"cape":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"key":{"exclusiveReadiness":true,"readyable":true},"pants":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"resource":{"disallowedClassesOnActive":["weapon","structure"],"exclusiveReadiness":true,"readyable":true,"stackable":true},"shield":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"shirt":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"shoes":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"structure":{"disallowedClassesOnActive":["weapon","resource"],"exclusiveReadiness":true,"readyable":true,"stableAngleOnDrop":true,"unbuyable":true},"weapon":{"disallowedClassesOnActive":["resource","structure"],"equippable":true,"exclusiveReadiness":true,"hasDurability":true,"readyable":true}},"classToTypes":{"armor":["armor-leather","armor-legion","armor-plate"],"bauldron":["bauldron"],"cape":["cape-solid","cape-tattered","cape-trimmed"],"key":["castlekey"],"pants":["legion","pantaloons","pants","pants-armor","skirts"],"resource":["arrow","webAmmo","ember-charge","coal","copper","gold","iron","silver","drumstick","feather","planks","rope","stick","spider-silk","flower-single-blue","flower-single-purple","flower-single-red","flower-single-yellow","hide","metal-bar-copper","metal-bar-gold","metal-bar-iron","metal-bar-silver","mushroom-purple","mushroom-red","mushroom-yellow","seed","shard-metal","straw","torch","wood","shard-metal"],"shield":["shield-crusader","shield-kite","shield-kite_blue","shield-kite_gray","shield-kite_green","shield-kite_red","shield-round","shield-spartan"],"shirt":["blouse","blouse_longsleeve","corset","longsleeve","longsleeve_laced","scoop_shirt","sleeveless","sleeveless_laced","sleeveless_striped","tanktop","tunic"],"shoes":["boots","sandals","shoes","shoes-armor","slippers"],"structure":["campfire","snare-rabbit","stool-small","table-large-rough","table-mid-round","barrel1","stackedBags","stool1","table-mid-rough","strawBed","strawBedSmall","chest-wood","door-wood","floor-wood","floor-stone","floor-cobble","roof-wood","wall-wood","wall2-wood","wall-stone","railing-wood","stairs","floor-opening","hatch-wood","timber-frame-wall","thatch-roof","window-frame","chimney-stack","dormer-window","grove-oak-a","grove-oak-b","grove-spruce-a","grove-spruce-b","grove-round-a","grove-round-b","grove-low-a","grove-low-b","meadow-grass-a","meadow-grass-b","meadow-grass-c","meadow-grass-d","meadow-grass-e","meadow-grass-f","meadow-sprout","castle-footing","castle-wall","castle-merlons","arrow-slit","tower-render"],"weapon":["axe","bow","crossbow","dagger","flail","halberd","longsword","mace","none","rapier","saber","scythe","spear","staff","waraxe","warhammer","web","iron-pickaxe"]},"classes":["armor","bauldron","cape","key","pants","resource","shield","shirt","shoes","structure","weapon"],"metadata":{"armor-leather":[{"class":"armor","color":"brown","spriteId":null,"type":"armor-leather"}],"armor-legion":[{"class":"armor","color":"brown","spriteId":null,"type":"armor-legion"}],"arrow":[{"class":"resource","color":"brown","spriteId":null,"type":"arrow"}],"arrow-slit":[{"class":"structure","color":"na","spriteId":"authored-terrain:899","type":"arrow-slit"}],"barrel1":[{"class":"structure","color":"na","spriteId":"container:60","type":"barrel1"}],"bauldron":[{"class":"bauldron","color":"brown","spriteId":null,"type":"bauldron"}],"campfire":[{"class":"structure","color":"na","spriteId":null,"type":"campfire"}],"castle-footing":[{"class":"structure","color":"na","spriteId":"authored-terrain:824","type":"castle-footing"}],"castle-merlons":[{"class":"structure","color":"na","spriteId":"authored-terrain:924","type":"castle-merlons"}],"castle-wall":[{"class":"structure","color":"na","spriteId":"authored-terrain:872","type":"castle-wall"}],"castlekey":[{"class":"key","color":"gold","spriteId":null,"type":"castlekey"}],"chest-wood":[{"class":"structure","color":"na","spriteId":"container:140","type":"chest-wood"}],"chimney-stack":[{"class":"structure","color":"na","spriteId":"authored-terrain:421","type":"chimney-stack"}],"coal":[{"class":"resource","color":"na","spriteId":"ore:161","type":"coal"}],"copper":[{"class":"resource","color":"na","spriteId":"ore:180","type":"copper"}],"dagger":[{"class":"weapon","color":"brown","spriteId":null,"type":"dagger"},{"class":"weapon","color":"metal","spriteId":null,"type":"dagger"}],"door-wood":[{"class":"structure","color":"na","spriteId":"fence_medieval:478","type":"door-wood"}],"dormer-window":[{"class":"structure","color":"na","spriteId":"authored-terrain:424","type":"dormer-window"}],"drumstick":[{"class":"resource","color":"brown","spriteId":null,"type":"drumstick"}],"ember-charge":[{"class":"resource","color":"na","spriteId":"ore:180","type":"ember-charge"}],"feather":[{"class":"resource","color":"na","spriteId":"ore:72","type":"feather"}],"floor-cobble":[{"class":"structure","color":"na","spriteId":"floors:225","type":"floor-cobble"}],"floor-opening":[{"class":"structure","color":"na","spriteId":"authored-terrain:3","type":"floor-opening"}],"floor-stone":[{"class":"structure","color":"na","spriteId":"floors:129","type":"floor-stone"}],"floor-wood":[{"class":"structure","color":"na","spriteId":"floors:33","type":"floor-wood"}],"flower-single-blue":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:104","type":"flower-single-blue"}],"flower-single-purple":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:103","type":"flower-single-purple"}],"flower-single-red":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:105","type":"flower-single-red"}],"flower-single-yellow":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:106","type":"flower-single-yellow"}],"gold":[{"class":"resource","color":"na","spriteId":"ore:182","type":"gold"}],"grove-low-a":[{"class":"structure","color":"na","spriteId":"item-art-32902d50537ebad17e79:1","type":"grove-low-a"}],"grove-low-b":[{"class":"structure","color":"na","spriteId":"item-art-5902c8b486e89c8f8e57:1","type":"grove-low-b"}],"grove-oak-a":[{"class":"structure","color":"na","spriteId":"item-art-887e0636d4bbe2a4f448:1","type":"grove-oak-a"}],"grove-oak-b":[{"class":"structure","color":"na","spriteId":"item-art-f728e0bbaefbd1982b2d:1","type":"grove-oak-b"}],"grove-round-a":[{"class":"structure","color":"na","spriteId":"item-art-bb4afa7ce4e3c1ba55ba:1","type":"grove-round-a"}],"grove-round-b":[{"class":"structure","color":"na","spriteId":"item-art-e46e4dec4aea45bf9d8e:1","type":"grove-round-b"}],"grove-spruce-a":[{"class":"structure","color":"na","spriteId":"item-art-35c925e4db81912bfe38:1","type":"grove-spruce-a"}],"grove-spruce-b":[{"class":"structure","color":"na","spriteId":"item-art-99ea85dcdc93fac8db18:1","type":"grove-spruce-b"}],"hatch-wood":[{"class":"structure","color":"na","spriteId":"hatch-wood:1","type":"hatch-wood"}],"hide":[{"class":"resource","color":"brown","spriteId":null,"type":"hide"}],"iron":[{"class":"resource","color":"na","spriteId":"ore:179","type":"iron"}],"iron-pickaxe":[{"class":"weapon","color":"na","spriteId":"item-art-b1d5a86cbcd21ed656d3:1","type":"iron-pickaxe"}],"legion":[{"class":"pants","color":"brown","spriteId":null,"type":"legion"}],"meadow-grass-a":[{"class":"structure","color":"na","spriteId":"item-art-ebdd046fea0f3ab21669:1","type":"meadow-grass-a"}],"meadow-grass-b":[{"class":"structure","color":"na","spriteId":"item-art-4d6c318ef966e097227a:1","type":"meadow-grass-b"}],"meadow-grass-c":[{"class":"structure","color":"na","spriteId":"item-art-721c3f8a8d4621a46f90:1","type":"meadow-grass-c"}],"meadow-grass-d":[{"class":"structure","color":"na","spriteId":"item-art-7fc02d2406eaa57e3be0:1","type":"meadow-grass-d"}],"meadow-grass-e":[{"class":"structure","color":"na","spriteId":"item-art-a7225776548a58ab4e04:1","type":"meadow-grass-e"}],"meadow-grass-f":[{"class":"structure","color":"na","spriteId":"item-art-d9ecaed5ff4485611809:1","type":"meadow-grass-f"}],"meadow-sprout":[{"class":"structure","color":"na","spriteId":"item-art-af19df691fc7aa944194:1","type":"meadow-sprout"}],"metal-bar-copper":[{"class":"resource","color":"na","spriteId":"ore:180","type":"metal-bar-copper"}],"metal-bar-gold":[{"class":"resource","color":"na","spriteId":"ore:182","type":"metal-bar-gold"}],"metal-bar-iron":[{"class":"resource","color":"na","spriteId":"ore:179","type":"metal-bar-iron"}],"metal-bar-silver":[{"class":"resource","color":"na","spriteId":"ore:181","type":"metal-bar-silver"}],"mushroom-purple":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:353","type":"mushroom-purple"}],"mushroom-red":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:355","type":"mushroom-red"}],"mushroom-yellow":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:354","type":"mushroom-yellow"}],"planks":[{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"}],"railing-wood":[{"class":"structure","color":"na","spriteId":"fence_medieval:1","type":"railing-wood"}],"roof-wood":[{"class":"structure","color":"na","spriteId":"authored-terrain:807","type":"roof-wood"}],"rope":[{"class":"resource","color":"na","spriteId":"ore:88","type":"rope"}],"seed":[{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"}],"shard-metal":[{"class":"resource","color":"gray","type":"shard-metal"}],"shield-crusader":[{"class":"shield","color":"white","spriteId":null,"type":"shield-crusader"}],"shield-kite":[{"class":"shield","color":"white","spriteId":null,"type":"shield-kite"}],"shield-round":[{"class":"shield","color":"brown","spriteId":null,"type":"shield-round"}],"silver":[{"class":"resource","color":"na","spriteId":"ore:181","type":"silver"}],"snare-rabbit":[{"class":"structure","color":"na","spriteId":"snare-rabbit.png","type":"snare-rabbit"}],"spider-silk":[{"class":"resource","color":"na","spriteId":"ore:88","type":"spider-silk"}],"stackedBags":[{"class":"structure","color":"na","spriteId":"container:449","type":"stackedBags"}],"stairs":[{"class":"structure","color":"na","spriteId":"stairs-icon:1","type":"stairs"}],"stick":[{"class":"resource","color":"na","spriteId":"ore:26","type":"stick"}],"stool-small":[{"class":"structure","color":"na","spriteId":"furniture-blonde-wood:126","type":"stool-small"}],"stool1":[{"class":"structure","color":"na","spriteId":"furniture-blond-wood:128","type":"stool1"}],"straw":[{"class":"resource","color":"na","noGlint":true,"spriteId":"item-art-b9ef00e25a4177065abd:1","type":"straw"}],"strawBed":[{"class":"structure","color":"na","spriteId":"build_atlas:684","type":"strawBed"}],"strawBedSmall":[{"class":"structure","color":"na","spriteId":"build_atlas:684","type":"strawBedSmall"}],"table-large-rough":[{"class":"structure","color":"na","spriteId":"furniture-blonde-wood:458","type":"table-large-rough"}],"table-mid-rough":[{"class":"structure","color":"na","spriteId":"furniture-blonde-wood:141","type":"table-mid-rough"}],"table-mid-round":[{"class":"structure","color":"na","spriteId":"furniture-blonde-wood:124","type":"table-mid-round"}],"thatch-roof":[{"class":"structure","color":"na","spriteId":"authored-terrain:378","type":"thatch-roof"}],"timber-frame-wall":[{"class":"structure","color":"na","spriteId":"authored-terrain:50","type":"timber-frame-wall"}],"torch":[{"class":"resource","color":"na","spriteId":null,"type":"torch"}],"tower-render":[{"class":"structure","color":"na","spriteId":"authored-terrain:927","type":"tower-render"}],"wall-stone":[{"class":"structure","color":"na","spriteId":"walls2:53","type":"wall-stone"}],"wall-wood":[{"class":"structure","color":"na","spriteId":"authored-terrain:643","type":"wall-wood"}],"wall2-wood":[{"class":"structure","color":"na","spriteId":"walls2:43","type":"wall2-wood"}],"web":[{"class":"weapon","color":"white","type":"web"}],"webAmmo":[{"class":"resource","color":"white","type":"webAmmo"}],"window-frame":[{"class":"structure","color":"na","spriteId":"authored-terrain:419","type":"window-frame"}],"wood":[{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"}]},"protection":{"armor":{"armor-leather":0.1,"armor-legion":0.2,"armor-plate":0.3},"bauldron":{"bauldron":0.05},"cape":{},"key":{},"pants":{"legion":0.1,"pantaloons":0.01,"pants-armor":0.1,"skirts":0.01},"resource":{},"shield":{"shield-crusader":0.2,"shield-kite":0.2,"shield-kite_blue":0.2,"shield-kite_gray":0.2,"shield-kite_green":0.2,"shield-kite_red":0.2,"shield-round":0.1,"shield-spartan":0.15},"shirt":{"blouse":0.01,"blouse_longsleeve":0.01,"corset":0.01,"longsleeve":0.01,"longsleeve_laced":0.01,"scoop_shirt":0.01,"sleeveless":0.01,"sleeveless_laced":0.01,"sleeveless_striped":0.01,"tanktop":0.01,"tunic":0.01},"shoes":{"boots":0.01,"sandals":0.01,"shoes":0.01,"shoes-armor":0.1,"slippers":0.01},"structure":{},"weapon":{}},"recipes":[{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:179","type":"iron"},"quantity":5}],"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:179","type":"metal-bar-iron"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:181","type":"silver"},"quantity":5}],"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:181","type":"metal-bar-silver"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:180","type":"copper"},"quantity":5}],"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:180","type":"metal-bar-copper"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:182","type":"gold"},"quantity":5}],"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:182","type":"metal-bar-gold"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:179","type":"iron"},"quantity":1}],"itemTypeMeta":{"class":"resource","color":"gray","type":"shard-metal"},"quantity":5},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"quantity":1}],"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:26","type":"stick"},"quantity":5},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","noGlint":true,"spriteId":"item-art-b9ef00e25a4177065abd:1","type":"straw"},"quantity":3}],"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:88","type":"rope"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"quantity":1}],"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":4},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":3}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"authored-terrain:643","type":"wall-wood"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":3}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"walls2:53","type":"wall-stone"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":3}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"floors:33","type":"floor-wood"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":3}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"fence_medieval:478","type":"door-wood"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":5}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"container:140","type":"chest-wood"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":4}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"authored-terrain:807","type":"roof-wood"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"quantity":2}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":null,"type":"campfire"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:26","type":"stick"},"quantity":5},{"itemTypeMeta":{"class":"resource","color":"gray","type":"shard-metal"},"quantity":5}],"itemTypeMeta":{"class":"weapon","color":"metal","spriteId":null,"type":"dagger"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:26","type":"stick"},"quantity":5}],"itemTypeMeta":{"class":"weapon","color":"brown","spriteId":null,"type":"dagger"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:26","type":"stick"},"quantity":2},{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:72","type":"feather"},"quantity":3},{"itemTypeMeta":{"class":"resource","color":"gray","type":"shard-metal"},"quantity":2}],"itemTypeMeta":{"class":"resource","color":"brown","spriteId":null,"type":"arrow"},"quantity":10},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:179","type":"metal-bar-iron"},"quantity":3},{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:26","type":"stick"},"quantity":2}],"itemTypeMeta":{"class":"weapon","color":"metal","type":"axe"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:26","type":"stick"},"quantity":5},{"itemTypeMeta":{"class":"resource","color":"gray","type":"shard-metal"},"quantity":3}],"itemTypeMeta":{"class":"weapon","color":"na","spriteId":"item-art-b1d5a86cbcd21ed656d3:1","type":"iron-pickaxe"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"quantity":10},{"itemTypeMeta":{"class":"resource","color":"gray","type":"shard-metal"},"quantity":3}],"itemTypeMeta":{"class":"weapon","color":"brown","type":"spear"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:179","type":"metal-bar-iron"},"quantity":3},{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":1}],"itemTypeMeta":{"class":"weapon","color":"metal","type":"longsword"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:179","type":"metal-bar-iron"},"quantity":4},{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":2}],"itemTypeMeta":{"class":"weapon","color":"metal","type":"waraxe"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:26","type":"stick"},"quantity":15},{"itemTypeMeta":{"class":"resource","color":"gray","type":"shard-metal"},"quantity":5},{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:88","type":"rope"},"quantity":2}],"itemTypeMeta":{"class":"weapon","color":"brown","type":"bow"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:26","type":"stick"},"quantity":3},{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:88","type":"rope"},"quantity":1}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"snare-rabbit.png","type":"snare-rabbit"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:180","type":"copper"},"quantity":1},{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:161","type":"coal"},"quantity":2},{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:88","type":"spider-silk"},"quantity":1}],"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:180","type":"ember-charge"},"quantity":9},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":4}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"stairs-icon:1","type":"stairs"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":4}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"authored-terrain:378","type":"thatch-roof"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":3}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"authored-terrain:50","type":"timber-frame-wall"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":2}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"authored-terrain:419","type":"window-frame"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":3}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"authored-terrain:421","type":"chimney-stack"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":2}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"authored-terrain:424","type":"dormer-window"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":2}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"hatch-wood:1","type":"hatch-wood"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":5}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"authored-terrain:824","type":"castle-footing"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":5}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"authored-terrain:872","type":"castle-wall"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":3}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"authored-terrain:924","type":"castle-merlons"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":2}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"authored-terrain:899","type":"arrow-slit"},"quantity":1},{"ingredients":[{"itemTypeMeta":{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"},"quantity":4}],"itemTypeMeta":{"class":"structure","color":"na","spriteId":"authored-terrain:927","type":"tower-render"},"quantity":1}],"resolvedMetadata":{"armor-leather":[{"class":"armor","color":"brown","spriteId":null,"type":"armor-leather"}],"armor-legion":[{"class":"armor","color":"brown","spriteId":null,"type":"armor-legion"}],"armor-plate":[{"class":"armor","color":"gray","type":"armor-plate"},{"class":"armor","color":"metal","type":"armor-plate"},{"class":"armor","color":"yellow","type":"armor-plate"},{"class":"armor","color":"gold","type":"armor-plate"},{"class":"armor","color":"orange","type":"armor-plate"},{"class":"armor","color":"tan","type":"armor-plate"}],"arrow":[{"class":"resource","color":"brown","spriteId":null,"type":"arrow"}],"arrow-slit":[{"class":"structure","color":"na","spriteId":"authored-terrain:899","type":"arrow-slit"}],"axe":[{"class":"weapon","color":"metal","type":"axe"}],"barrel1":[{"class":"structure","color":"na","spriteId":"container:60","type":"barrel1"}],"bauldron":[{"class":"bauldron","color":"brown","spriteId":null,"type":"bauldron"}],"blouse":[{"class":"shirt","color":"black","type":"blouse"},{"class":"shirt","color":"blue","type":"blouse"},{"class":"shirt","color":"green","type":"blouse"},{"class":"shirt","color":"maroon","type":"blouse"},{"class":"shirt","color":"purple","type":"blouse"},{"class":"shirt","color":"red","type":"blouse"},{"class":"shirt","color":"teal","type":"blouse"},{"class":"shirt","color":"white","type":"blouse"},{"class":"shirt","color":"yellow","type":"blouse"},{"class":"shirt","color":"tan","type":"blouse"},{"class":"shirt","color":"gray","type":"blouse"},{"class":"shirt","color":"orange","type":"blouse"}],"blouse_longsleeve":[{"class":"shirt","color":"black","type":"blouse_longsleeve"},{"class":"shirt","color":"blue","type":"blouse_longsleeve"},{"class":"shirt","color":"green","type":"blouse_longsleeve"},{"class":"shirt","color":"maroon","type":"blouse_longsleeve"},{"class":"shirt","color":"purple","type":"blouse_longsleeve"},{"class":"shirt","color":"red","type":"blouse_longsleeve"},{"class":"shirt","color":"teal","type":"blouse_longsleeve"},{"class":"shirt","color":"white","type":"blouse_longsleeve"},{"class":"shirt","color":"yellow","type":"blouse_longsleeve"},{"class":"shirt","color":"tan","type":"blouse_longsleeve"},{"class":"shirt","color":"gray","type":"blouse_longsleeve"},{"class":"shirt","color":"orange","type":"blouse_longsleeve"}],"boots":[{"class":"shoes","color":"black","type":"boots"},{"class":"shoes","color":"blue","type":"boots"},{"class":"shoes","color":"brown","type":"boots"},{"class":"shoes","color":"gray","type":"boots"},{"class":"shoes","color":"green","type":"boots"},{"class":"shoes","color":"maroon","type":"boots"},{"class":"shoes","color":"orange","type":"boots"},{"class":"shoes","color":"purple","type":"boots"},{"class":"shoes","color":"red","type":"boots"},{"class":"shoes","color":"tan","type":"boots"},{"class":"shoes","color":"teal","type":"boots"},{"class":"shoes","color":"white","type":"boots"},{"class":"shoes","color":"yellow","type":"boots"}],"bow":[{"class":"weapon","color":"brown","type":"bow"}],"campfire":[{"class":"structure","color":"na","spriteId":null,"type":"campfire"}],"cape-solid":[{"class":"cape","color":"black","type":"cape-solid"},{"class":"cape","color":"blue","type":"cape-solid"},{"class":"cape","color":"brown","type":"cape-solid"},{"class":"cape","color":"gray","type":"cape-solid"},{"class":"cape","color":"green","type":"cape-solid"},{"class":"cape","color":"maroon","type":"cape-solid"},{"class":"cape","color":"red","type":"cape-solid"},{"class":"cape","color":"white","type":"cape-solid"},{"class":"cape","color":"yellow","type":"cape-solid"}],"cape-tattered":[{"class":"cape","color":"black","type":"cape-tattered"},{"class":"cape","color":"blue","type":"cape-tattered"},{"class":"cape","color":"brown","type":"cape-tattered"},{"class":"cape","color":"gray","type":"cape-tattered"},{"class":"cape","color":"green","type":"cape-tattered"},{"class":"cape","color":"maroon","type":"cape-tattered"},{"class":"cape","color":"red","type":"cape-tattered"},{"class":"cape","color":"white","type":"cape-tattered"},{"class":"cape","color":"yellow","type":"cape-tattered"}],"cape-trimmed":[{"class":"cape","color":"white","type":"cape-trimmed"}],"castle-footing":[{"class":"structure","color":"na","spriteId":"authored-terrain:824","type":"castle-footing"}],"castle-merlons":[{"class":"structure","color":"na","spriteId":"authored-terrain:924","type":"castle-merlons"}],"castle-wall":[{"class":"structure","color":"na","spriteId":"authored-terrain:872","type":"castle-wall"}],"castlekey":[{"class":"key","color":"gold","spriteId":null,"type":"castlekey"}],"chest-wood":[{"class":"structure","color":"na","spriteId":"container:140","type":"chest-wood"}],"chimney-stack":[{"class":"structure","color":"na","spriteId":"authored-terrain:421","type":"chimney-stack"}],"coal":[{"class":"resource","color":"na","spriteId":"ore:161","type":"coal"}],"copper":[{"class":"resource","color":"na","spriteId":"ore:180","type":"copper"}],"corset":[{"class":"shirt","color":"black","type":"corset"},{"class":"shirt","color":"blue","type":"corset"},{"class":"shirt","color":"green","type":"corset"},{"class":"shirt","color":"maroon","type":"corset"},{"class":"shirt","color":"purple","type":"corset"},{"class":"shirt","color":"red","type":"corset"},{"class":"shirt","color":"teal","type":"corset"},{"class":"shirt","color":"white","type":"corset"},{"class":"shirt","color":"yellow","type":"corset"},{"class":"shirt","color":"brown","type":"corset"},{"class":"shirt","color":"tan","type":"corset"},{"class":"shirt","color":"gray","type":"corset"},{"class":"shirt","color":"orange","type":"corset"}],"crossbow":[{"class":"weapon","color":"brown","type":"crossbow"}],"dagger":[{"class":"weapon","color":"brown","spriteId":null,"type":"dagger"},{"class":"weapon","color":"metal","spriteId":null,"type":"dagger"}],"door-wood":[{"class":"structure","color":"na","spriteId":"fence_medieval:478","type":"door-wood"}],"dormer-window":[{"class":"structure","color":"na","spriteId":"authored-terrain:424","type":"dormer-window"}],"drumstick":[{"class":"resource","color":"brown","spriteId":null,"type":"drumstick"}],"ember-charge":[{"class":"resource","color":"na","spriteId":"ore:180","type":"ember-charge"}],"feather":[{"class":"resource","color":"na","spriteId":"ore:72","type":"feather"}],"flail":[{"class":"weapon","color":"metal","type":"flail"}],"floor-cobble":[{"class":"structure","color":"na","spriteId":"floors:225","type":"floor-cobble"}],"floor-opening":[{"class":"structure","color":"na","spriteId":"authored-terrain:3","type":"floor-opening"}],"floor-stone":[{"class":"structure","color":"na","spriteId":"floors:129","type":"floor-stone"}],"floor-wood":[{"class":"structure","color":"na","spriteId":"floors:33","type":"floor-wood"}],"flower-single-blue":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:104","type":"flower-single-blue"}],"flower-single-purple":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:103","type":"flower-single-purple"}],"flower-single-red":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:105","type":"flower-single-red"}],"flower-single-yellow":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:106","type":"flower-single-yellow"}],"gold":[{"class":"resource","color":"na","spriteId":"ore:182","type":"gold"}],"grove-low-a":[{"class":"structure","color":"na","spriteId":"item-art-32902d50537ebad17e79:1","type":"grove-low-a"}],"grove-low-b":[{"class":"structure","color":"na","spriteId":"item-art-5902c8b486e89c8f8e57:1","type":"grove-low-b"}],"grove-oak-a":[{"class":"structure","color":"na","spriteId":"item-art-887e0636d4bbe2a4f448:1","type":"grove-oak-a"}],"grove-oak-b":[{"class":"structure","color":"na","spriteId":"item-art-f728e0bbaefbd1982b2d:1","type":"grove-oak-b"}],"grove-round-a":[{"class":"structure","color":"na","spriteId":"item-art-bb4afa7ce4e3c1ba55ba:1","type":"grove-round-a"}],"grove-round-b":[{"class":"structure","color":"na","spriteId":"item-art-e46e4dec4aea45bf9d8e:1","type":"grove-round-b"}],"grove-spruce-a":[{"class":"structure","color":"na","spriteId":"item-art-35c925e4db81912bfe38:1","type":"grove-spruce-a"}],"grove-spruce-b":[{"class":"structure","color":"na","spriteId":"item-art-99ea85dcdc93fac8db18:1","type":"grove-spruce-b"}],"halberd":[{"class":"weapon","color":"metal","type":"halberd"}],"hatch-wood":[{"class":"structure","color":"na","spriteId":"hatch-wood:1","type":"hatch-wood"}],"hide":[{"class":"resource","color":"brown","spriteId":null,"type":"hide"}],"iron":[{"class":"resource","color":"na","spriteId":"ore:179","type":"iron"}],"iron-pickaxe":[{"class":"weapon","color":"na","spriteId":"item-art-b1d5a86cbcd21ed656d3:1","type":"iron-pickaxe"}],"legion":[{"class":"pants","color":"brown","spriteId":null,"type":"legion"}],"longsleeve":[{"class":"shirt","color":"black","type":"longsleeve"},{"class":"shirt","color":"blue","type":"longsleeve"},{"class":"shirt","color":"green","type":"longsleeve"},{"class":"shirt","color":"maroon","type":"longsleeve"},{"class":"shirt","color":"purple","type":"longsleeve"},{"class":"shirt","color":"red","type":"longsleeve"},{"class":"shirt","color":"teal","type":"longsleeve"},{"class":"shirt","color":"white","type":"longsleeve"},{"class":"shirt","color":"yellow","type":"longsleeve"}],"longsleeve_laced":[{"class":"shirt","color":"black","type":"longsleeve_laced"},{"class":"shirt","color":"blue","type":"longsleeve_laced"},{"class":"shirt","color":"green","type":"longsleeve_laced"},{"class":"shirt","color":"maroon","type":"longsleeve_laced"},{"class":"shirt","color":"purple","type":"longsleeve_laced"},{"class":"shirt","color":"red","type":"longsleeve_laced"},{"class":"shirt","color":"teal","type":"longsleeve_laced"},{"class":"shirt","color":"white","type":"longsleeve_laced"},{"class":"shirt","color":"yellow","type":"longsleeve_laced"},{"class":"shirt","color":"tan","type":"longsleeve_laced"},{"class":"shirt","color":"gray","type":"longsleeve_laced"},{"class":"shirt","color":"orange","type":"longsleeve_laced"}],"longsword":[{"class":"weapon","color":"metal","type":"longsword"}],"mace":[{"class":"weapon","color":"metal","type":"mace"}],"meadow-grass-a":[{"class":"structure","color":"na","spriteId":"item-art-ebdd046fea0f3ab21669:1","type":"meadow-grass-a"}],"meadow-grass-b":[{"class":"structure","color":"na","spriteId":"item-art-4d6c318ef966e097227a:1","type":"meadow-grass-b"}],"meadow-grass-c":[{"class":"structure","color":"na","spriteId":"item-art-721c3f8a8d4621a46f90:1","type":"meadow-grass-c"}],"meadow-grass-d":[{"class":"structure","color":"na","spriteId":"item-art-7fc02d2406eaa57e3be0:1","type":"meadow-grass-d"}],"meadow-grass-e":[{"class":"structure","color":"na","spriteId":"item-art-a7225776548a58ab4e04:1","type":"meadow-grass-e"}],"meadow-grass-f":[{"class":"structure","color":"na","spriteId":"item-art-d9ecaed5ff4485611809:1","type":"meadow-grass-f"}],"meadow-sprout":[{"class":"structure","color":"na","spriteId":"item-art-af19df691fc7aa944194:1","type":"meadow-sprout"}],"metal-bar-copper":[{"class":"resource","color":"na","spriteId":"ore:180","type":"metal-bar-copper"}],"metal-bar-gold":[{"class":"resource","color":"na","spriteId":"ore:182","type":"metal-bar-gold"}],"metal-bar-iron":[{"class":"resource","color":"na","spriteId":"ore:179","type":"metal-bar-iron"}],"metal-bar-silver":[{"class":"resource","color":"na","spriteId":"ore:181","type":"metal-bar-silver"}],"mushroom-purple":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:353","type":"mushroom-purple"}],"mushroom-red":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:355","type":"mushroom-red"}],"mushroom-yellow":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:354","type":"mushroom-yellow"}],"pantaloons":[{"class":"pants","color":"black","type":"pantaloons"},{"class":"pants","color":"blue","type":"pantaloons"},{"class":"pants","color":"brown","type":"pantaloons"},{"class":"pants","color":"gray","type":"pantaloons"},{"class":"pants","color":"green","type":"pantaloons"},{"class":"pants","color":"maroon","type":"pantaloons"},{"class":"pants","color":"orange","type":"pantaloons"},{"class":"pants","color":"purple","type":"pantaloons"},{"class":"pants","color":"red","type":"pantaloons"},{"class":"pants","color":"tan","type":"pantaloons"},{"class":"pants","color":"white","type":"pantaloons"},{"class":"pants","color":"yellow","type":"pantaloons"}],"pants":[{"class":"pants","color":"black","type":"pants"},{"class":"pants","color":"blue","type":"pants"},{"class":"pants","color":"brown","type":"pants"},{"class":"pants","color":"gray","type":"pants"},{"class":"pants","color":"green","type":"pants"},{"class":"pants","color":"maroon","type":"pants"},{"class":"pants","color":"orange","type":"pants"},{"class":"pants","color":"purple","type":"pants"},{"class":"pants","color":"red","type":"pants"},{"class":"pants","color":"tan","type":"pants"},{"class":"pants","color":"white","type":"pants"},{"class":"pants","color":"yellow","type":"pants"}],"pants-armor":[{"class":"pants","color":"gray","type":"pants-armor"},{"class":"pants","color":"metal","type":"pants-armor"},{"class":"pants","color":"yellow","type":"pants-armor"},{"class":"pants","color":"gold","type":"pants-armor"},{"class":"pants","color":"tan","type":"pants-armor"},{"class":"pants","color":"orange","type":"pants-armor"}],"planks":[{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"}],"railing-wood":[{"class":"structure","color":"na","spriteId":"fence_medieval:1","type":"railing-wood"}],"rapier":[{"class":"weapon","color":"metal","type":"rapier"}],"roof-wood":[{"class":"structure","color":"na","spriteId":"authored-terrain:807","type":"roof-wood"}],"rope":[{"class":"resource","color":"na","spriteId":"ore:88","type":"rope"}],"saber":[{"class":"weapon","color":"metal","type":"saber"}],"sandals":[{"class":"shoes","color":"brown","type":"sandals"}],"scoop_shirt":[{"class":"shirt","color":"black","type":"scoop_shirt"},{"class":"shirt","color":"blue","type":"scoop_shirt"},{"class":"shirt","color":"green","type":"scoop_shirt"},{"class":"shirt","color":"maroon","type":"scoop_shirt"},{"class":"shirt","color":"purple","type":"scoop_shirt"},{"class":"shirt","color":"red","type":"scoop_shirt"},{"class":"shirt","color":"teal","type":"scoop_shirt"},{"class":"shirt","color":"white","type":"scoop_shirt"},{"class":"shirt","color":"yellow","type":"scoop_shirt"},{"class":"shirt","color":"gray","type":"scoop_shirt"},{"class":"shirt","color":"orange","type":"scoop_shirt"}],"scythe":[{"class":"weapon","color":"metal","type":"scythe"}],"seed":[{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"}],"shard-metal":[{"class":"resource","color":"gray","type":"shard-metal"}],"shield-crusader":[{"class":"shield","color":"white","spriteId":null,"type":"shield-crusader"}],"shield-kite":[{"class":"shield","color":"white","spriteId":null,"type":"shield-kite"}],"shield-kite_blue":[{"class":"shield","color":"blue","type":"shield-kite_blue"},{"class":"shield","color":"gray","type":"shield-kite_blue"}],"shield-kite_gray":[{"class":"shield","color":"blue","type":"shield-kite_gray"},{"class":"shield","color":"gray","type":"shield-kite_gray"},{"class":"shield","color":"green","type":"shield-kite_gray"},{"class":"shield","color":"orange","type":"shield-kite_gray"}],"shield-kite_green":[{"class":"shield","color":"gray","type":"shield-kite_green"}],"shield-kite_red":[{"class":"shield","color":"gray","type":"shield-kite_red"}],"shield-round":[{"class":"shield","color":"brown","spriteId":null,"type":"shield-round"}],"shield-spartan":[{"class":"shield","color":"brown","type":"shield-spartan"}],"shoes":[{"class":"shoes","color":"black","type":"shoes"},{"class":"shoes","color":"brown","type":"shoes"},{"class":"shoes","color":"maroon","type":"shoes"}],"shoes-armor":[{"class":"shoes","color":"gray","type":"shoes-armor"},{"class":"shoes","color":"metal","type":"shoes-armor"},{"class":"shoes","color":"yellow","type":"shoes-armor"},{"class":"shoes","color":"gold","type":"shoes-armor"},{"class":"shoes","color":"tan","type":"shoes-armor"},{"class":"shoes","color":"orange","type":"shoes-armor"}],"silver":[{"class":"resource","color":"na","spriteId":"ore:181","type":"silver"}],"skirts":[{"class":"pants","color":"brown","type":"skirts"},{"class":"pants","color":"black","type":"skirts"},{"class":"pants","color":"white","type":"skirts"}],"sleeveless":[{"class":"shirt","color":"black","type":"sleeveless"},{"class":"shirt","color":"blue","type":"sleeveless"},{"class":"shirt","color":"green","type":"sleeveless"},{"class":"shirt","color":"maroon","type":"sleeveless"},{"class":"shirt","color":"purple","type":"sleeveless"},{"class":"shirt","color":"red","type":"sleeveless"},{"class":"shirt","color":"teal","type":"sleeveless"},{"class":"shirt","color":"white","type":"sleeveless"},{"class":"shirt","color":"yellow","type":"sleeveless"},{"class":"shirt","color":"brown","type":"sleeveless"},{"class":"shirt","color":"tan","type":"sleeveless"},{"class":"shirt","color":"gray","type":"sleeveless"},{"class":"shirt","color":"orange","type":"sleeveless"}],"sleeveless_laced":[{"class":"shirt","color":"black","type":"sleeveless_laced"},{"class":"shirt","color":"blue","type":"sleeveless_laced"},{"class":"shirt","color":"green","type":"sleeveless_laced"},{"class":"shirt","color":"maroon","type":"sleeveless_laced"},{"class":"shirt","color":"purple","type":"sleeveless_laced"},{"class":"shirt","color":"red","type":"sleeveless_laced"},{"class":"shirt","color":"teal","type":"sleeveless_laced"},{"class":"shirt","color":"white","type":"sleeveless_laced"},{"class":"shirt","color":"yellow","type":"sleeveless_laced"},{"class":"shirt","color":"brown","type":"sleeveless_laced"},{"class":"shirt","color":"tan","type":"sleeveless_laced"},{"class":"shirt","color":"gray","type":"sleeveless_laced"},{"class":"shirt","color":"orange","type":"sleeveless_laced"}],"sleeveless_striped":[{"class":"shirt","color":"black","type":"sleeveless_striped"},{"class":"shirt","color":"blue","type":"sleeveless_striped"},{"class":"shirt","color":"green","type":"sleeveless_striped"},{"class":"shirt","color":"maroon","type":"sleeveless_striped"},{"class":"shirt","color":"purple","type":"sleeveless_striped"},{"class":"shirt","color":"red","type":"sleeveless_striped"},{"class":"shirt","color":"teal","type":"sleeveless_striped"},{"class":"shirt","color":"white","type":"sleeveless_striped"},{"class":"shirt","color":"yellow","type":"sleeveless_striped"},{"class":"shirt","color":"brown","type":"sleeveless_striped"},{"class":"shirt","color":"tan","type":"sleeveless_striped"},{"class":"shirt","color":"gray","type":"sleeveless_striped"},{"class":"shirt","color":"orange","type":"sleeveless_striped"}],"slippers":[{"class":"shoes","color":"black","type":"slippers"},{"class":"shoes","color":"brown","type":"slippers"},{"class":"shoes","color":"gray","type":"slippers"}],"snare-rabbit":[{"class":"structure","color":"na","spriteId":"snare-rabbit.png","type":"snare-rabbit"}],"spear":[{"class":"weapon","color":"brown","type":"spear"},{"class":"weapon","color":"black","type":"spear"},{"class":"weapon","color":"green","type":"spear"},{"class":"weapon","color":"metal","type":"spear"},{"class":"weapon","color":"purple","type":"spear"}],"spider-silk":[{"class":"resource","color":"na","spriteId":"ore:88","type":"spider-silk"}],"stackedBags":[{"class":"structure","color":"na","spriteId":"container:449","type":"stackedBags"}],"staff":[{"class":"weapon","color":"brown","type":"staff"}],"stairs":[{"class":"structure","color":"na","spriteId":"stairs-icon:1","type":"stairs"}],"stick":[{"class":"resource","color":"na","spriteId":"ore:26","type":"stick"}],"stool-small":[{"class":"structure","color":"na","spriteId":"furniture-blonde-wood:126","type":"stool-small"}],"stool1":[{"class":"structure","color":"na","spriteId":"furniture-blond-wood:128","type":"stool1"}],"straw":[{"class":"resource","color":"na","noGlint":true,"spriteId":"item-art-b9ef00e25a4177065abd:1","type":"straw"}],"strawBed":[{"class":"structure","color":"na","spriteId":"build_atlas:684","type":"strawBed"}],"strawBedSmall":[{"class":"structure","color":"na","spriteId":"build_atlas:684","type":"strawBedSmall"}],"table-large-rough":[{"class":"structure","color":"na","spriteId":"furniture-blonde-wood:458","type":"table-large-rough"}],"table-mid-rough":[{"class":"structure","color":"na","spriteId":"furniture-blonde-wood:141","type":"table-mid-rough"}],"table-mid-round":[{"class":"structure","color":"na","spriteId":"furniture-blonde-wood:124","type":"table-mid-round"}],"tanktop":[{"class":"shirt","color":"black","type":"tanktop"},{"class":"shirt","color":"blue","type":"tanktop"},{"class":"shirt","color":"green","type":"tanktop"},{"class":"shirt","color":"maroon","type":"tanktop"},{"class":"shirt","color":"purple","type":"tanktop"},{"class":"shirt","color":"red","type":"tanktop"},{"class":"shirt","color":"teal","type":"tanktop"},{"class":"shirt","color":"white","type":"tanktop"},{"class":"shirt","color":"yellow","type":"tanktop"},{"class":"shirt","color":"tan","type":"tanktop"},{"class":"shirt","color":"gray","type":"tanktop"},{"class":"shirt","color":"orange","type":"tanktop"}],"thatch-roof":[{"class":"structure","color":"na","spriteId":"authored-terrain:378","type":"thatch-roof"}],"timber-frame-wall":[{"class":"structure","color":"na","spriteId":"authored-terrain:50","type":"timber-frame-wall"}],"torch":[{"class":"resource","color":"na","spriteId":null,"type":"torch"}],"tower-render":[{"class":"structure","color":"na","spriteId":"authored-terrain:927","type":"tower-render"}],"tunic":[{"class":"shirt","color":"brown","type":"tunic"},{"class":"shirt","color":"maroon","type":"tunic"},{"class":"shirt","color":"teal","type":"tunic"},{"class":"shirt","color":"white","type":"tunic"}],"wall-stone":[{"class":"structure","color":"na","spriteId":"walls2:53","type":"wall-stone"}],"wall-wood":[{"class":"structure","color":"na","spriteId":"authored-terrain:643","type":"wall-wood"}],"wall2-wood":[{"class":"structure","color":"na","spriteId":"walls2:43","type":"wall2-wood"}],"waraxe":[{"class":"weapon","color":"metal","type":"waraxe"}],"warhammer":[{"class":"weapon","color":"metal","type":"warhammer"}],"web":[{"class":"weapon","color":"white","type":"web"}],"webAmmo":[{"class":"resource","color":"white","type":"webAmmo"}],"window-frame":[{"class":"structure","color":"na","spriteId":"authored-terrain:419","type":"window-frame"}],"wood":[{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"}]},"sprites":{"arrow-slit":"authored-terrain:899","barrel1":"container:60","castle-footing":"authored-terrain:824","castle-merlons":"authored-terrain:924","castle-wall":"authored-terrain:872","chest-wood":"container:140","chimney-stack":"authored-terrain:421","coal":"ore:161","copper":"ore:180","door-wood":"fence_medieval:478","dormer-window":"authored-terrain:424","ember-charge":"ore:180","feather":"ore:72","floor-cobble":"floors:225","floor-opening":"authored-terrain:3","floor-stone":"floors:129","floor-wood":"floors:33","flower-single-blue":"lpc-flowers-plants-fungi-wood:104","flower-single-purple":"lpc-flowers-plants-fungi-wood:103","flower-single-red":"lpc-flowers-plants-fungi-wood:105","flower-single-yellow":"lpc-flowers-plants-fungi-wood:106","gold":"ore:182","grove-low-a":"item-art-32902d50537ebad17e79:1","grove-low-b":"item-art-5902c8b486e89c8f8e57:1","grove-oak-a":"item-art-887e0636d4bbe2a4f448:1","grove-oak-b":"item-art-f728e0bbaefbd1982b2d:1","grove-round-a":"item-art-bb4afa7ce4e3c1ba55ba:1","grove-round-b":"item-art-e46e4dec4aea45bf9d8e:1","grove-spruce-a":"item-art-35c925e4db81912bfe38:1","grove-spruce-b":"item-art-99ea85dcdc93fac8db18:1","hatch-wood":"hatch-wood:1","iron":"ore:179","iron-pickaxe":"item-art-b1d5a86cbcd21ed656d3:1","meadow-grass-a":"item-art-ebdd046fea0f3ab21669:1","meadow-grass-b":"item-art-4d6c318ef966e097227a:1","meadow-grass-c":"item-art-721c3f8a8d4621a46f90:1","meadow-grass-d":"item-art-7fc02d2406eaa57e3be0:1","meadow-grass-e":"item-art-a7225776548a58ab4e04:1","meadow-grass-f":"item-art-d9ecaed5ff4485611809:1","meadow-sprout":"item-art-af19df691fc7aa944194:1","metal-bar-copper":"ore:180","metal-bar-gold":"ore:182","metal-bar-iron":"ore:179","metal-bar-silver":"ore:181","mushroom-purple":"lpc-flowers-plants-fungi-wood:353","mushroom-red":"lpc-flowers-plants-fungi-wood:355","mushroom-yellow":"lpc-flowers-plants-fungi-wood:354","planks":"ore:25","railing-wood":"fence_medieval:1","roof-wood":"authored-terrain:807","rope":"ore:88","seed":"seed-green.png","silver":"ore:181","snare-rabbit":"snare-rabbit.png","spider-silk":"ore:88","stackedBags":"container:449","stairs":"stairs-icon:1","stick":"ore:26","stool-small":"furniture-blonde-wood:126","stool1":"furniture-blond-wood:128","straw":"item-art-b9ef00e25a4177065abd:1","strawBed":"build_atlas:684","strawBedSmall":"build_atlas:684","table-large-rough":"furniture-blonde-wood:458","table-mid-rough":"furniture-blonde-wood:141","table-mid-round":"furniture-blonde-wood:124","thatch-roof":"authored-terrain:378","timber-frame-wall":"authored-terrain:50","tower-render":"authored-terrain:927","wall-stone":"walls2:53","wall-wood":"authored-terrain:643","wall2-wood":"walls2:43","window-frame":"authored-terrain:419"},"subClasses":{"ammo":["arrow","webAmmo","ember-charge"],"armor":["armor-leather","armor-legion","armor-plate"],"bauldron":["bauldron"],"cape":["cape-solid","cape-tattered","cape-trimmed"],"chest":["chest-wood"],"chimney":["chimney-stack"],"craftResource":["feather","planks","rope","stick","spider-silk"],"door":["door-wood"],"dormer":["dormer-window"],"drumstick":["drumstick"],"floor":["floor-wood","floor-stone","floor-cobble"],"flower":["flower-single-blue","flower-single-purple","flower-single-red","flower-single-yellow"],"hide":["hide"],"key":["castlekey"],"metalBar":["metal-bar-copper","metal-bar-gold","metal-bar-iron","metal-bar-silver"],"mushroom":["mushroom-purple","mushroom-red","mushroom-yellow"],"ore":["coal","copper","gold","iron","silver"],"pants":["legion","pantaloons","pants","pants-armor","skirts"],"resource":["shard-metal"],"roof":["roof-wood","thatch-roof"],"seed":["seed"],"shard":["shard-metal"],"shield":["shield-crusader","shield-kite","shield-kite_blue","shield-kite_gray","shield-kite_green","shield-kite_red","shield-round","shield-spartan"],"shirt":["blouse","blouse_longsleeve","corset","longsleeve","longsleeve_laced","scoop_shirt","sleeveless","sleeveless_laced","sleeveless_striped","tanktop","tunic"],"shoes":["boots","sandals","shoes","shoes-armor","slippers"],"straw":["straw"],"structure":["campfire","snare-rabbit","stool-small","table-large-rough","table-mid-round","barrel1","stackedBags","stool1","table-mid-rough","strawBed","strawBedSmall","stairs","floor-opening","hatch-wood","grove-oak-a","grove-oak-b","grove-spruce-a","grove-spruce-b","grove-round-a","grove-round-b","grove-low-a","grove-low-b","meadow-grass-a","meadow-grass-b","meadow-grass-c","meadow-grass-d","meadow-grass-e","meadow-grass-f","meadow-sprout"],"torch":["torch"],"wall":["wall-wood","wall2-wood","wall-stone","railing-wood","timber-frame-wall","castle-footing","castle-wall","castle-merlons","tower-render"],"weapon":["axe","bow","crossbow","dagger","flail","halberd","longsword","mace","none","rapier","saber","scythe","spear","staff","waraxe","warhammer","web","iron-pickaxe"],"window":["window-frame","arrow-slit"],"wood":["wood"]},"trade":{"armor-leather":{"itemType":"shard-metal","quantity":60},"armor-legion":{"itemType":"shard-metal","quantity":240},"armor-plate":{"itemType":"shard-metal","quantity":360},"arrow":{"itemType":"shard-metal","quantity":0.1},"coal":{"itemType":"shard-metal","quantity":3},"copper":{"itemType":"shard-metal","quantity":9},"dagger":{"itemType":"shard-metal","quantity":10},"drumstick":{"itemType":"shard-metal","quantity":10},"feather":{"itemType":"shard-metal","quantity":10},"gold":{"itemType":"shard-metal","quantity":15},"hide":{"itemType":"shard-metal","quantity":2},"iron":{"itemType":"shard-metal","quantity":6},"metal-bar-copper":{"itemType":"shard-metal","quantity":45},"metal-bar-gold":{"itemType":"shard-metal","quantity":80},"metal-bar-iron":{"itemType":"shard-metal","quantity":30},"metal-bar-silver":{"itemType":"shard-metal","quantity":60},"shield-crusader":{"itemType":"shard-metal","quantity":120},"shield-kite":{"itemType":"shard-metal","quantity":120},"shield-kite_blue":{"itemType":"shard-metal","quantity":120},"shield-kite_gray":{"itemType":"shard-metal","quantity":120},"shield-kite_green":{"itemType":"shard-metal","quantity":120},"shield-kite_red":{"itemType":"shard-metal","quantity":120},"shield-round":{"itemType":"shard-metal","quantity":120},"silver":{"itemType":"shard-metal","quantity":12},"spear":{"itemType":"shard-metal","quantity":20}},"weight":{"armor":{"armor-leather":0.1,"armor-legion":0.2,"armor-plate":0.3},"bauldron":{"bauldron":0.05},"cape":{},"key":{},"pants":{"legion":0.1,"pants-armor":0.1},"resource":{},"shield":{"shield-crusader":0.2,"shield-kite":0.2,"shield-kite_blue":0.2,"shield-kite_gray":0.2,"shield-kite_green":0.2,"shield-kite_red":0.2,"shield-round":0.1,"shield-spartan":0.15},"shirt":{},"shoes":{"shoes-armor":0.1,"slippers":0.01},"structure":{},"weapon":{"axe":0.08,"bow":0.05,"iron-pickaxe":0.08,"spear":0.05,"staff":0.05,"warhammer":0.1}}},"mapTemplates":{"caves":{"compressionlevel":-1,"height":50,"infinite":false,"layers":[{"data":[2091,2091,2091,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,0,0,2091,2091,2091,2091,2091,0,0,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,0,0,2091,2091,2091,2091,2091,0,0,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,0,0,2091,2091,2091,2091,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,0,0,2091,2091,2091,2091,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,0,0,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,0,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,0,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,0,2091,2091,2091,0,2091,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,0,2091,2091,2091,0,0,2091,0,0,0,0,2091,2091,2091,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,0,2091,2091,2091,0,0,0,0,0,0,0,2091,2091,2091,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,2091,0,2091,2091,2091,2091,2091,2091,2091,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,2091,0,2091,2091,2091,2091,2091,2091,2091,0,0,0,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,2091,2091,2091,2091,2091,2091,2091,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,2091,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,2091,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,354,354,354,354,354,354,354,354,354,354,354,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,2091,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,0,0,2091,0,2091,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,0,0,2091,0,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,0,0,2091,0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,0,0,0,0,0,2091,0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,0,0,0,0,0,2091,0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,2091,2091,2091,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,2091,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,2091,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,2091,2091,2091,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,2091,2091,2091,0,0,0,0,2091,2091,2091,2091,2091,2091,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2091,0,0,2091,2091,2091,0,0,0,0,0,0,0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,354,354,354,2091,2091,354,354,354,354,354,354,354,354,354,354,308,308,308,308,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":1,"name":"map1","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,258,258,258,258,227,0,0,0,0,0,0,0,0,0,1570,1570,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1223,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4050,1223,1223,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1223,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1223,1223,1223,1223,1223,1223,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1223,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":2,"name":"map2","opacity":1,"properties":[{"name":"entityTileSurface","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,723,723,0,0,1133,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":3,"name":"map3","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2569,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2635,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2759,2759,2759,0,4175,4112,4177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4115,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4053,4112,4052,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4115,4114,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4179,0,4179,0,0,0,4053,4052,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2758,0,0,0,0,0,4115,0,4114,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4112,0,4053,0,4052,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2632,0,0,0,0,0,0,0,0,0,4112,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2760,0,0,0,0,0,2631,0,4112,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4111,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4112,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4179,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4112,2759,2759,2759,2759,2759,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2632,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4175,4112,2760,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2759,2759,2759,2759,2759,0,0,0,0,0,0,0,0,0,2758,4112,4112,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2758,4112,4112,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4112,4177,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4112,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4112,2759,2759,4179,2759,4112,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2759,0,0,4115,0,0,0,0,0,0,2632,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4112,4112,4112,4112,4112,4112,2760,0,0,0,0,0,2759,2759,2759,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2759,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4112,0,0,0,4053,2759,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":4,"name":"map4","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[2569,2631,2631,583,2631,2565,0,2569,583,2631,2631,2631,2565,0,2569,2631,2631,2631,2631,2565,0,0,0,0,0,0,0,0,0,2569,2631,2631,2565,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2571,2759,2759,711,2759,2563,0,2571,711,2759,2759,2759,2563,0,2571,2759,2759,2759,2759,2563,0,0,2569,2631,2631,583,2565,0,0,2571,2759,2759,2630,2631,2631,2631,2631,2565,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,0,0,0,3149,0,3147,0,0,0,184,3149,0,3147,0,0,0,0,2630,2631,2631,2635,2759,2759,711,2563,0,0,3147,0,0,0,2759,2759,2759,2759,2563,0,0,0,0,0,0,0,0,0,0,0,0,3147,184,0,0,0,3149,0,3147,0,0,0,0,3149,0,3147,0,0,0,0,2758,2759,2759,2760,0,184,0,3149,0,0,3147,0,0,3140,3212,3212,3141,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,0,0,184,3149,0,3147,0,0,0,0,3149,0,3147,184,0,0,0,3140,3212,3212,3141,0,0,0,3149,0,0,3211,3212,3212,3213,0,0,3147,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,3211,3212,3212,3212,3212,3213,0,3211,3212,3141,0,3140,3213,0,3211,3212,3212,3212,3212,3213,0,0,3211,3212,3212,3212,3213,0,0,0,0,0,0,0,0,3147,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2569,2632,0,2630,2565,0,2569,583,2565,2567,2569,2631,2631,2631,2631,2631,2631,2631,2565,0,0,0,0,0,0,0,0,3147,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2571,2760,0,2758,2563,0,2571,711,2563,2567,3147,2759,2759,2759,2759,2759,2759,2759,2563,0,0,0,0,0,0,0,2569,2632,0,2630,2631,2631,2565,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,0,0,3149,0,3147,0,2566,2567,3211,3212,3212,3212,3212,3212,3141,184,3149,0,0,0,0,0,0,0,2571,2760,0,2758,2759,2759,2630,2631,2631,2631,2631,2565,0,0,0,0,0,0,0,0,0,0,0,0,3147,184,0,0,3149,0,3147,0,2566,2567,2567,2567,2567,2567,2567,2567,2568,0,3149,0,0,0,0,2569,2631,2631,2632,0,0,0,0,0,2758,2759,2759,2759,2759,2563,0,0,0,0,0,0,0,0,0,0,0,0,3211,3212,3212,3212,3213,0,3147,0,2630,2631,2631,2631,2631,2631,2631,2631,2632,0,3149,0,0,0,0,2571,2759,2759,2760,0,0,0,0,0,3140,3212,3212,3141,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,184,2758,2759,2759,2759,2759,2759,2759,2759,2760,0,3149,0,0,0,0,3147,0,3140,3141,0,0,0,0,0,3149,0,0,3147,0,2630,2631,2631,2565,0,0,2569,2631,2565,0,2631,2631,2631,0,0,0,0,0,0,3211,3212,3212,3212,3212,3212,3212,3212,3212,3212,3212,3212,3213,0,0,0,0,3147,0,3149,3147,0,0,0,0,0,3149,0,0,3147,0,2758,2759,2759,2563,0,0,0,2759,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,3149,3211,3212,3141,0,3140,3212,3213,0,0,3147,0,3140,3212,3212,3213,0,0,0,0,0,0,0,2631,0,0,0,0,0,0,0,0,8173,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,3149,0,0,3147,0,3149,0,0,0,0,3147,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8205,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,3149,0,0,3147,0,2630,2631,2631,2631,2631,2632,0,3149,0,0,0,0,0,0,0,0,0,4178,0,4178,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,3149,0,0,3147,0,2758,2759,2759,2759,2759,2760,0,3149,0,0,0,0,0,2630,0,0,0,0,0,0,0,4178,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,3149,0,0,3211,3212,3212,3212,3212,3212,3212,3141,0,3149,0,0,0,0,0,0,0,0,0,2631,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,3149,0,0,0,0,0,0,0,0,0,3147,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2631,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2569,2631,2631,2632,0,2630,2631,2565,0,0,0,0,0,0,0,3147,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2571,2759,2759,2760,0,2758,2759,2563,0,0,0,0,0,0,0,3147,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,0,0,0,0,0,2630,2631,2631,2631,2631,2631,2631,2631,2632,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2631,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,0,0,0,0,0,2758,2759,2759,2759,2759,2759,2759,2759,2760,0,3149,0,0,0,0,0,4178,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,0,0,0,0,0,3140,3212,3212,3212,3212,3212,3212,3212,3212,3212,3213,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3211,3212,3141,0,3140,3212,3212,3213,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4180,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2632,0,2630,0,0,2569,2631,2631,2631,2631,2631,2565,0,0,0,0,0,0,0,0,0,723,723,723,723,723,2567,2567,2567,2567,2567,2569,2631,2631,2631,2631,2565,2567,2567,2567,0,0,0,0,0,2569,2631,2565,0,2632,2760,0,2758,2630,0,2571,2759,2759,2759,2759,2759,2563,0,0,0,0,0,0,0,0,0,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,2632,0,0,0,0,0,2567,2567,2567,0,0,0,0,0,2571,2759,2563,0,2760,0,0,0,2758,0,3147,0,3140,3212,3141,0,3149,0,0,0,0,0,0,0,0,0,2567,2567,2567,2567,2567,2567,2567,2567,2631,2631,0,0,0,0,0,0,2567,2567,2567,0,0,0,0,0,3211,3212,3213,0,3141,0,0,0,3140,0,3147,0,3149,0,3147,0,3149,0,0,0,0,0,0,0,0,0,2567,2569,2631,2631,2631,2565,2567,2567,0,0,0,0,0,0,0,2630,2631,2631,2631,0,0,0,0,0,0,0,0,0,0,3141,0,3140,0,0,3147,0,2630,2631,2632,0,3149,0,0,0,0,0,0,0,0,0,2567,0,2759,2759,2759,0,2567,2567,4047,2567,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,2758,2759,2760,0,3149,0,0,0,0,0,0,0,0,0,2567,0,0,0,0,2630,2631,2631,4051,2567,0,4180,0,0,0,0,2567,2567,2567,0,0,0,0,0,2632,0,3149,0,3147,0,2630,0,0,0,3211,3212,3212,3212,3212,3212,3213,0,0,0,0,0,0,0,0,0,2567,0,0,0,0,0,0,0,0,2567,2567,4047,2567,2567,2567,2567,2567,2567,2567,0,0,0,0,0,2760,0,3149,0,3147,0,2758,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2567,0,0,0,0,0,2567,2567,2567,2567,2567,4047,2567,2567,2567,2567,2567,2567,2567,0,0,0,0,0,3141,0,3149,0,3147,0,3140,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2567,0,0,4180,0,0,2567,2567,2567,2567,2567,0,2631,2631,2567,2567,2567,2567,2567,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2567,2567,2567,0,2567,2567,2567,2567,2567,2567,2567,0,0,0,2567,2567,2567,2567,2567,0,0,0,0,0,2632,0,2630,0,2632,0,2630,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2631,2567,2567,0,2567,2567,2567,2567,2567,2567,2567,2567,2567,4047,2567,2567,2567,2567,2567,0,0,0,0,0,2760,0,2758,0,2760,0,2758,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2567,2567,0,2567,2567,2567,2567,2567,2567,2569,2631,2631,4178,2631,2565,2567,2567,2567,0,0,0,0,0,3141,0,3140,0,3212,3212,3212,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2631,2567,2567,0,2567,2567,2567,2567,2567,2567,0,0,0,0,0,0,2567,2567,2567,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2567,2567,0,2631,2631,2631,2631,2631,2631,0,0,0,0,0,0,2631,2631,2631,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2567,2567,2567,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2631,2567,2567,2567,2567,2567,2567,2567,2567,2567,0,0,0,0,0,0,2567,2567,2567,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2567,2567,0,0,0,2567,2567,2567,2567,0,0,0,0,0,0,2567,2567,2567,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2631,2567,2567,0,0,2631,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2567,2567,0,0,0,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2567,2567,2567,0,0,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,2567,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":6,"name":"sprite","opacity":1,"properties":[{"name":"sprite","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":7,"name":"skyTrigger","opacity":1,"properties":[{"name":"skyTrigger","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4048,0,4049,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4306,0,4307,0,4309,4113,4308,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,3149,0,4050,0,4051,0,4047,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3211,3212,3213,0,4303,4113,4305,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4048,4049,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4304,0,4244,0,0,0,4303,4305,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4243,0,0,0,0,0,4048,0,4049,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4244,0,4048,0,4049,0,4049,0,4116,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4305,0,4181,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4242,0,0,0,0,0,4116,0,4113,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4048,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4303,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4306,0,0,0,0,4307,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4048,0,0,0,0,0,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4113,4242,0,0,0,0,0,0,0,4049,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4306,0,0,0,4307,0,0,0,0,3147,0,0,0,0,4243,4113,4113,4113,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,0,0,0,0,0,0,0,3211,0,3212,3212,3212,3213,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,0,0,4243,4113,4113,4305,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,0,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3211,3212,0,3212,3213,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4047,0,0,0,0,0,0,0,4303,4113,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4047,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4113,0,0,4047,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4047,0,0,0,0,0,0,4306,0,0,0,0,4307,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4304,0,0,4048,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4303,4113,4113,4113,4113,4113,4113,4242,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,0,0,0,0,3212,3212,3212,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3147,0,0,0,0,3149,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4304,0,0,0,0,0,0,0,0,0,3211,3212,3212,3212,3212,3213,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4113,0,0,0,4048,4304,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,4241,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":5,"name":"sky","opacity":1,"properties":[{"name":"sky","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[122,122,122,0,122,122,0,122,0,122,122,122,122,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,122,0,122,0,0,0,0,122,0,122,0,0,0,0,122,0,0,122,122,122,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,122,0,122,0,0,0,0,122,0,122,0,0,0,0,122,122,122,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,122,0,122,0,0,0,0,122,0,122,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,122,0,122,0,0,0,0,122,0,122,0,0,0,0,0,122,122,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,122,122,122,0,122,122,0,122,122,122,122,122,122,122,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,0,122,122,0,122,0,122,122,122,122,122,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,122,0,122,0,122,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,122,0,122,122,122,122,122,122,122,122,122,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,122,0,122,0,0,0,0,0,0,0,122,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,0,122,0,122,122,122,122,122,122,122,122,122,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,122,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,0,0,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,122,122,0,0,0,0,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,122,122,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,122,122,0,122,0,0,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,122,122,0,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,122,122,122,0,122,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,122,0,0,0,122,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,0,122,122,122,0,0,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,122,0,122,0,0,0,0,0,122,122,122,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,122,0,0,0,0,122,122,122,122,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,122,0,0,0,0,122,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,122,122,122,122,122,122,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,122,122,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":6,"name":"blocking","opacity":1,"properties":[{"name":"blocking","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"draworder":"topdown","id":1,"name":"objects","objects":[{"class":"FRAGMENT","height":192,"id":994,"name":"cave1","properties":[{"name":"category","type":"string","value":"cave"},{"name":"subcategory","type":"string","value":"medium"}],"rotation":0,"visible":true,"width":192,"x":0,"y":0},{"class":"FRAGMENT","height":384,"id":995,"name":"cave2","properties":[{"name":"category","type":"string","value":"cave"},{"name":"subcategory","type":"string","value":"large"}],"rotation":0,"visible":true,"width":192,"x":224,"y":0},{"class":"FRAGMENT","height":192,"id":996,"name":"cave3","properties":[{"name":"category","type":"string","value":"cave"},{"name":"subcategory","type":"string","value":"large"}],"rotation":0,"visible":true,"width":416,"x":448,"y":0},{"class":"FRAGMENT","height":224,"id":997,"name":"cave4","properties":[{"name":"category","type":"string","value":"cave"},{"name":"subcategory","type":"string","value":"large"}],"rotation":0,"visible":true,"width":416,"x":448,"y":224},{"class":"FRAGMENT","height":32,"id":1006,"name":"","properties":[{"name":"category","type":"string","value":"cave"},{"name":"tag","type":"string","value":"mid_right"}],"rotation":0,"visible":true,"width":32,"x":96,"y":480},{"class":"FRAGMENT","height":32,"id":1007,"name":"","properties":[{"name":"category","type":"string","value":"cave"},{"name":"tag","type":"string","value":"bottom_right"}],"rotation":0,"visible":true,"width":32,"x":96,"y":512},{"class":"FRAGMENT","height":32,"id":1008,"name":"","properties":[{"name":"category","type":"string","value":"cave"},{"name":"tag","type":"string","value":"bottom_mid"}],"rotation":0,"visible":true,"width":32,"x":64,"y":512},{"class":"FRAGMENT","height":32,"id":1009,"name":"","properties":[{"name":"category","type":"string","value":"cave"},{"name":"tag","type":"string","value":"bottom_left"}],"rotation":0,"visible":true,"width":32,"x":32,"y":512},{"class":"FRAGMENT","height":32,"id":1010,"name":"","properties":[{"name":"category","type":"string","value":"cave"},{"name":"tag","type":"string","value":"mid_left"}],"rotation":0,"visible":true,"width":32,"x":32,"y":480},{"class":"FRAGMENT","height":64,"id":1014,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"tunnel_entrance_left"}],"rotation":0,"visible":true,"width":32,"x":32,"y":576},{"class":"FRAGMENT","height":64,"id":1017,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"tunnel_entrance_right"}],"rotation":0,"visible":true,"width":32,"x":32,"y":672},{"class":"FRAGMENT","height":64,"id":1018,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"tunnel_entrance_top"}],"rotation":0,"visible":true,"width":32,"x":32,"y":768},{"class":"FRAGMENT","height":32,"id":1019,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"tunnel_entrance_bottom"}],"rotation":0,"visible":true,"width":32,"x":32,"y":864},{"class":"FRAGMENT","height":64,"id":1031,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"top_left"}],"rotation":0,"visible":true,"width":32,"x":160,"y":416},{"class":"FRAGMENT","height":64,"id":1032,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"top_mid"}],"rotation":0,"visible":true,"width":32,"x":192,"y":416},{"class":"FRAGMENT","height":64,"id":1033,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"top_right"}],"rotation":0,"visible":true,"width":32,"x":224,"y":416},{"class":"FRAGMENT","height":32,"id":1034,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"mid_left"}],"rotation":0,"visible":true,"width":32,"x":160,"y":480},{"class":"FRAGMENT","height":32,"id":1035,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"mid_right"}],"rotation":0,"visible":true,"width":32,"x":224,"y":480},{"class":"FRAGMENT","height":64,"id":1040,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"bottom_mid"}],"rotation":0,"visible":true,"width":32,"x":192,"y":480},{"class":"FRAGMENT","height":64,"id":1044,"name":"","properties":[{"name":"category","type":"string","value":"cave"},{"name":"tag","type":"string","value":"top_left"}],"rotation":0,"visible":true,"width":32,"x":32,"y":416},{"class":"FRAGMENT","height":64,"id":1045,"name":"","properties":[{"name":"category","type":"string","value":"cave"},{"name":"tag","type":"string","value":"top_mid"}],"rotation":0,"visible":true,"width":32,"x":64,"y":416},{"class":"FRAGMENT","height":64,"id":1046,"name":"","properties":[{"name":"category","type":"string","value":"cave"},{"name":"tag","type":"string","value":"top_right"}],"rotation":0,"visible":true,"width":32,"x":96,"y":416},{"class":"FRAGMENT","height":32,"id":1049,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"north_south"}],"rotation":0,"visible":true,"width":32,"x":288,"y":480},{"class":"FRAGMENT","height":64,"id":1051,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"bottom_left"}],"rotation":0,"visible":true,"width":32,"x":352,"y":544},{"class":"FRAGMENT","height":64,"id":1053,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"junction_9"}],"rotation":0,"visible":true,"width":32,"x":160,"y":544},{"class":"FRAGMENT","height":64,"id":1057,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"junction_21"}],"rotation":0,"visible":true,"width":32,"x":160,"y":608},{"class":"FRAGMENT","height":64,"id":1058,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"junction_all"}],"rotation":0,"visible":true,"width":32,"x":224,"y":544},{"class":"FRAGMENT","height":64,"id":1059,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"bottom_right"}],"rotation":0,"visible":true,"width":32,"x":384,"y":544},{"class":"FRAGMENT","height":64,"id":1060,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"junction_19"}],"rotation":0,"visible":true,"width":32,"x":224,"y":608},{"class":"FRAGMENT","height":64,"id":1061,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"junction_16"}],"rotation":0,"visible":true,"width":32,"x":288,"y":608},{"class":"FRAGMENT","height":64,"id":1063,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"end_right"}],"rotation":0,"visible":true,"width":32,"x":352,"y":640},{"class":"FRAGMENT","height":64,"id":1064,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"end_left"}],"rotation":0,"visible":true,"width":32,"x":352,"y":736},{"class":"FRAGMENT","height":32,"id":1067,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"end_top"}],"rotation":0,"visible":true,"width":32,"x":416,"y":640},{"class":"FRAGMENT","height":32,"id":1069,"name":"","properties":[{"name":"category","type":"string","value":"tunnel"},{"name":"tag","type":"string","value":"end_bottom"}],"rotation":0,"visible":true,"width":32,"x":416,"y":672},{"class":"FRAGMENT","height":64,"id":1071,"name":"","properties":[{"name":"category","type":"string","value":"object"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"tag","type":"string","value":"door-up-down"}],"rotation":0,"visible":true,"width":32,"x":480,"y":480}],"opacity":1,"type":"objectgroup","visible":true,"x":0,"y":0}],"nextlayerid":8,"nextobjectid":1072,"orientation":"orthogonal","renderorder":"right-down","tiledversion":"1.9.0","tileheight":32,"tilesets":[{"firstgid":1,"source":"../tilesets/lpc-terrain.tsx"},{"firstgid":1025,"source":"../tilesets/plants.tsx"},{"firstgid":1194,"source":"../tilesets/lpc-flowers-plants-fungi-wood.tsx"},{"firstgid":1706,"source":"../tilesets/mountains-v6.tsx"},{"firstgid":6826,"source":"../tilesets/ore.tsx"},{"firstgid":7082,"source":"../tilesets/jungle-ruins.tsx"},{"firstgid":8106,"source":"../tilesets/build_atlas.tsx"},{"firstgid":9130,"source":"../tilesets/decorations-medieval.tsx"},{"firstgid":10154,"source":"../tilesets/roofs.tsx"},{"firstgid":14250,"source":"../tilesets/cottage.tsx"},{"firstgid":14506,"source":"../tilesets/walls.tsx"}],"tilewidth":32,"type":"map","version":"1.9","width":50},"geo":{"compressionlevel":-1,"height":50,"infinite":false,"layers":[{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,0,0,0,0,0,0,0,101,101,101,101,0,0,0,0,0,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,0,0,0,0,0,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,0,0,0,0,0,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,0,0,0,0,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,0,0,0,0,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,0,0,0,0,0,0,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,0,0,0,0,0,0,0,0,0,0,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,0,0,0,0,0,0,0,101,101,101,101,101,0,0,0,0,0,0,0,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,0,0,0,101,101,101,101,101,0,0,0,0,0,0,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,101,0,0,0,101,101,101,0,0,0,0,0,0,0,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,0,0,0,0],"height":50,"id":1,"name":"map1","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8828,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8828,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,378,378,378,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,378,378,378,378,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,378,378,378,378,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,378,378,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,378,378,378,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,378,378,378,378,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,813,0,0,0,0,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,378,378,378,378,0,0,0,0,378,378,378,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,813,606,0,0,0,0,0,0,0,0,813,0,0,0,0,0,0,0,0,0,0,0,378,378,378,0,0,0,0,0,378,378,378,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,606,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,813,0,0,0,0,0,0,0,0,0,0,813,0,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,378,378,378,378,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,606,0,0,0,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,378,378,378,378,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,378,378,378,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,606,723,723,723,723,723,783,723,723,0,0,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,638,813,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,606,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,813,0,0,0,0,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,813,606,0,0,0,0,0,0,0,0,813,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,606,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,813,0,0,0,0,0,0,0,0,0,0,813,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,606,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,606,723,723,723,723,723,783,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,638,813,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,606,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,257,258,259,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,257,227,290,226,258,259,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,257,227,290,290,290,290,291,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,290,290,290,194,323,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,321,195,290,290,194,323,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,321,322,322,323,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,257,259,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,257,258,258,259,321,323,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,290,226,258,259,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,289,290,290,290,290,291,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,257,227,290,290,290,194,323,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,321,322,322,322,322,323,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":2,"name":"map2","opacity":1,"properties":[{"name":"entityTileSurface","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8828,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8828,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,442,723,442,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,474,8828,474,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,8828,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":3,"name":"map3","opacity":0,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2981,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,3045,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,723,723,723,723,723,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,0,0,0,0,723,723,442,443,0,0,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,441,442,723,0,0,0,0,723,442,474,475,0,0,0,0,0,723,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,473,474,442,723,723,723,723,442,474,723,723,0,0,0,0,441,409,0,411,443,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,474,723,723,723,723,474,723,723,723,0,0,0,0,473,441,0,443,475,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,723,723,723,723,723,723,723,723,0,0,0,0,0,473,0,475,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,723,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,723,723,723,723,723,723,723,723,0,0,723,0,0,0,0,0,0,0,0,0,0,0,723,0,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,442,442,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,345,346,346,347,0,0,0,0,0,0,723,474,474,475,0,0,723,723,442,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,345,191,378,378,192,347,0,0,0,0,0,0,0,0,0,0,0,723,723,474,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,377,378,378,378,378,379,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,0,0,0,0,723,723,442,443,0,0,0,409,410,410,410,410,411,0,0,0,0,0,723,723,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,441,442,723,0,0,0,0,723,442,474,475,0,0,0,441,442,442,442,442,443,0,0,0,0,0,723,723,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,473,474,442,723,723,723,723,442,474,723,723,0,0,0,473,474,474,474,474,0,0,0,0,0,0,723,723,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,474,723,723,723,723,474,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,442,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,723,723,723,723,723,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,473,474,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":4,"name":"map4","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,723,723,723,723,723,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,345,346,346,346,347,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,345,191,2104,2104,2104,192,346,347,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,345,191,2104,2104,2104,2104,2104,2104,192,347,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,345,191,2104,2104,2104,2104,2104,2104,2104,2104,379,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,377,2104,2104,2104,2104,2104,2104,2104,2104,224,411,0,0,0,0,723,345,346,346,347,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,409,223,2104,2104,2104,2104,2104,2104,224,411,0,0,0,0,0,345,191,104,104,379,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,409,223,2104,2104,2104,2104,224,411,443,0,0,0,0,0,409,223,104,224,411,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,441,409,410,410,410,410,411,443,475,723,0,0,0,0,0,0,410,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,473,441,442,442,442,442,443,475,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,473,474,474,474,474,475,723,723,723,0,0,0,0,723,0,0,0,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,345,346,347,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,723,723,723,723,723,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,377,2104,192,347,0,0,723,345,346,347,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,723,345,346,346,346,347,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,409,223,224,411,0,0,345,191,2104,379,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,345,191,2104,2104,2104,192,346,347,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,441,409,411,443,0,0,409,410,223,379,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,345,191,2104,2104,2104,2104,2104,2104,192,347,0,0,0,0,0,0,0,0,0,0,0,0,0,0,473,441,443,0,0,0,441,442,409,411,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,345,191,2104,2104,2104,2104,2104,2104,2104,2104,379,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,473,475,0,0,0,473,474,441,443,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,377,2104,2104,2104,2104,2104,2104,2104,2104,224,411,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,409,223,2104,2104,2104,2104,2104,2104,224,411,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,345,347,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,409,223,2104,2104,2104,2104,224,411,443,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,377,192,347,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,441,409,410,410,410,410,411,443,475,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,409,223,379,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,473,441,442,442,442,442,443,475,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,441,377,379,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,723,473,474,474,474,474,475,723,723,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,0,409,411,723,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,441,443,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,723,473,475,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1421,1421,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1602,1421,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1602,0,0,1421,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1421,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1133,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1602,0,0,1133,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1133,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1602,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1133,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":6,"name":"sprite","opacity":1,"properties":[{"name":"sprite","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":5,"name":"sky","opacity":1,"properties":[{"name":"sky","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,122,122,0,0,0,0,0,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,0,0,0,0,122,122,122,0,0,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,122,122,0,0,0,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,0,0,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":6,"name":"blocking","opacity":1,"properties":[{"name":"blocking","type":"bool","value":true}],"type":"tilelayer","visible":false,"width":50,"x":0,"y":0},{"draworder":"topdown","id":1,"name":"objects","objects":[{"class":"FRAGMENT","height":192,"id":959,"name":"","properties":[{"name":"category","type":"string","value":"mountain"},{"name":"context","type":"string","value":"{\\n  \\"locationIcon\\": \\"cave.png\\",\\n  \\"isDungeonEntrance\\": true,\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"minehill"}],"rotation":0,"visible":true,"width":160,"x":768,"y":416},{"class":"FRAGMENT","height":192,"id":962,"name":"","properties":[{"name":"category","type":"string","value":"mountain"},{"name":"context","type":"string","value":"{\\n  \\"locationIcon\\": \\"cave.png\\",\\n  \\"isDungeonEntrance\\": true,\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":128,"x":1024,"y":224},{"class":"FRAGMENT","height":128,"id":963,"name":"","properties":[{"name":"category","type":"string","value":"mountain"},{"name":"context","type":"string","value":"{\\n  \\"locationIcon\\": \\"cave.png\\",\\n  \\"isDungeonEntrance\\": true,\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":96,"x":1280,"y":288},{"class":"FRAGMENT","height":160,"id":964,"name":"","properties":[{"name":"category","type":"string","value":"mountain"},{"name":"context","type":"string","value":"{\\n  \\"locationIcon\\": \\"cave.png\\",\\n  \\"isDungeonEntrance\\": true,\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":128,"x":1280,"y":448},{"class":"FRAGMENT","height":160,"id":966,"name":"","properties":[{"name":"category","type":"string","value":"mountain"},{"name":"context","type":"string","value":"{\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":128,"x":1280,"y":672},{"class":"FRAGMENT","height":224,"id":967,"name":"","properties":[{"name":"category","type":"string","value":"mountain"},{"name":"context","type":"string","value":"{\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":96,"x":1120,"y":864},{"class":"FRAGMENT","height":384,"id":972,"name":"","properties":[{"name":"category","type":"string","value":"mountain"},{"name":"context","type":"string","value":"{\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":416,"x":256,"y":672},{"class":"FRAGMENT","height":64,"id":976,"name":"cavedoor","properties":[{"name":"category","type":"string","value":"cavedoor"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"cavedoor"}],"rotation":0,"visible":true,"width":32,"x":32,"y":64},{"class":"FRAGMENT_POINT","height":0,"id":979,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"geo\\",\\n    \\"tag\\": \\"cavedoor\\",\\n    \\"category\\": \\"cavedoor\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":832,"y":544},{"class":"FRAGMENT_POINT","height":0,"id":980,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"geo\\",\\n    \\"tag\\": \\"cavedoor\\",\\n    \\"category\\": \\"cavedoor\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1056,"y":352},{"class":"FRAGMENT_POINT","height":0,"id":981,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"geo\\",\\n    \\"tag\\": \\"cavedoor\\",\\n    \\"category\\": \\"cavedoor\\"\\n  },\\n  \\"noResourceSpawn\\": true\\n}"}],"rotation":0,"visible":true,"width":0,"x":1344,"y":544},{"class":"FRAGMENT_POINT","height":0,"id":984,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"geo\\",\\n    \\"tag\\": \\"cavedoor\\",\\n    \\"category\\": \\"cavedoor\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1312,"y":352},{"class":"FRAGMENT","height":192,"id":988,"name":"","properties":[{"name":"category","type":"string","value":"mountain"},{"name":"context","type":"string","value":"{\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":128,"x":1088,"y":640},{"class":"mapSpriteCap","height":0,"id":989,"name":"","point":true,"rotation":0,"visible":true,"width":0,"x":1200.81165133596,"y":762.907139728428},{"class":"FRAGMENT_POINT","height":0,"id":1003,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"geo\\",\\n    \\"tag\\": \\"grasses|trees\\",\\n    \\"category\\": \\"geo\\",\\n    \\"subcategory\\": \\"topping\\",\\n    \\"renderStrategy\\": \\"sprite\\",\\n    \\"context\\": {\\n       \\"renderZIdxOffset\\": 300\\n    }\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":368.69281961956,"y":759.246170138566},{"class":"FRAGMENT","height":192,"id":1004,"name":"","properties":[{"name":"category","type":"string","value":"geo"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"topping"},{"name":"tag","type":"string","value":"grasses"}],"rotation":0,"visible":true,"width":224,"x":352,"y":1120},{"class":"FRAGMENT","height":192,"id":1008,"name":"","properties":[{"name":"category","type":"string","value":"geo"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"topping"},{"name":"tag","type":"string","value":"trees"}],"rotation":0,"visible":true,"width":224,"x":352,"y":1344},{"class":"FRAGMENT","height":192,"id":1009,"name":"","properties":[{"name":"category","type":"string","value":"geo"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"cover"},{"name":"tag","type":"string","value":"grass1"}],"rotation":0,"visible":true,"width":224,"x":96,"y":1120},{"class":"FRAGMENT","height":192,"id":1011,"name":"","properties":[{"name":"category","type":"string","value":"geo"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"cover"},{"name":"tag","type":"string","value":"grass2"}],"rotation":0,"visible":true,"width":224,"x":96,"y":1344},{"class":"FRAGMENT_POINT","height":0,"id":1012,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"geo\\",\\n    \\"tag\\": \\"grass1|grass2\\",\\n    \\"category\\": \\"geo\\",\\n    \\"subcategory\\": \\"cover\\",\\n    \\"renderStrategy\\": \\"sprite\\",\\n    \\"context\\": {\\n       \\"renderZIdxOffset\\": 200\\n    }\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":368.049121659673,"y":749.904626955147},{"class":"FRAGMENT","height":192,"id":1015,"name":"","properties":[{"name":"category","type":"string","value":"geo"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"cover"},{"name":"tag","type":"string","value":"rock1"}],"rotation":0,"visible":true,"width":224,"x":704,"y":768},{"class":"FRAGMENT","height":384,"id":1017,"name":"","properties":[{"name":"category","type":"string","value":"mountain"},{"name":"context","type":"string","value":"{\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":416,"x":256,"y":256},{"class":"FRAGMENT_POINT","height":0,"id":1018,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"geo\\",\\n    \\"tag\\": \\"rock1\\",\\n    \\"category\\": \\"geo\\",\\n    \\"subcategory\\": \\"cover\\",\\n    \\"renderStrategy\\": \\"sprite\\",\\n    \\"context\\": {\\n       \\"renderZIdxOffset\\": 200\\n    }\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":364.503952332967,"y":342.057545526337},{"class":"FRAGMENT","height":96,"id":1025,"name":"","properties":[{"name":"catalog","type":"string","value":"geo"},{"name":"category","type":"string","value":"dirt"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":128,"x":864,"y":1024},{"class":"FRAGMENT","height":224,"id":1027,"name":"","properties":[{"name":"catalog","type":"string","value":"geo"},{"name":"category","type":"string","value":"dirt"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":224,"x":768,"y":1184},{"class":"FRAGMENT","height":192,"id":1029,"name":"","properties":[{"name":"catalog","type":"string","value":"geo"},{"name":"category","type":"string","value":"dirt"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":192,"x":1120,"y":1184},{"class":"FRAGMENT","height":192,"id":1030,"name":"","properties":[{"name":"catalog","type":"string","value":"geo"},{"name":"category","type":"string","value":"dirt"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":128,"x":1472,"y":768},{"class":"FRAGMENT","height":192,"id":1031,"name":"","properties":[{"name":"catalog","type":"string","value":"geo"},{"name":"category","type":"string","value":"dirt"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":192,"x":1376,"y":1024},{"class":"FRAGMENT","height":192,"id":1032,"name":"","properties":[{"name":"catalog","type":"string","value":"geo"},{"name":"category","type":"string","value":"dirt"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":224,"x":1344,"y":1408},{"class":"FRAGMENT","height":128,"id":1033,"name":"","properties":[{"name":"catalog","type":"string","value":"geo"},{"name":"category","type":"string","value":"dirt"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":160,"x":992,"y":1408},{"class":"FRAGMENT","height":160,"id":1034,"name":"","properties":[{"name":"catalog","type":"string","value":"geo"},{"name":"category","type":"string","value":"dirt"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":288,"x":640,"y":1440}],"opacity":1,"type":"objectgroup","visible":true,"x":0,"y":0}],"nextlayerid":7,"nextobjectid":1036,"orientation":"orthogonal","renderorder":"right-down","tiledversion":"1.9.0","tileheight":32,"tilesets":[{"firstgid":1,"source":"../tilesets/lpc-terrain.tsx"},{"firstgid":1025,"source":"../tilesets/plants.tsx"},{"firstgid":1194,"source":"../tilesets/lpc-flowers-plants-fungi-wood.tsx"},{"firstgid":1706,"source":"../tilesets/mountains-v6.tsx"},{"firstgid":6826,"source":"../tilesets/ore.tsx"},{"firstgid":7082,"source":"../tilesets/jungle-ruins.tsx"},{"firstgid":8106,"source":"../tilesets/build_atlas.tsx"},{"firstgid":9130,"source":"../tilesets/decorations-medieval.tsx"},{"firstgid":10154,"source":"../tilesets/roofs.tsx"}],"tilewidth":32,"type":"map","version":"1.9","width":50},"item":{"compressionlevel":-1,"height":50,"infinite":false,"layers":[{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":1,"name":"map1","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":2,"name":"map2","opacity":1,"properties":[{"name":"entityTileSurface","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8757,8758,8757,8758,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8789,8790,8821,8822,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8821,8822,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":3,"name":"map3","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":4,"name":"map4","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":17,"name":"map5","opacity":1,"type":"tilelayer","visible":false,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":18,"name":"map6","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":6,"name":"sprite","opacity":1,"properties":[{"name":"sprite","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[20651,21053,21054,22313,22298,22299,22300,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20667,21069,21070,0,22314,22315,22316,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":9,"name":"sprite2","opacity":1,"properties":[{"name":"sprite","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":10,"name":"sprite3","opacity":1,"properties":[{"name":"sprite","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":7,"name":"skyTrigger","opacity":1,"properties":[{"name":"skyTrigger","type":"bool","value":true}],"type":"tilelayer","visible":false,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":5,"name":"sky","opacity":1,"properties":[{"name":"sky","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":12,"name":"sky2","opacity":1,"properties":[{"name":"sky","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,122,122,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":6,"name":"blocking","opacity":0.25,"properties":[{"name":"blocking","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"draworder":"topdown","id":1,"name":"objects","objects":[{"class":"FRAGMENT","height":64,"id":1195,"name":"","properties":[{"name":"category","type":"string","value":"barrel1"},{"name":"context","type":"string","value":"{\\n  \\"clearPointsForLayers\\": [\\"sprite\\"]\\n}"},{"name":"craftableMeta","type":"string","value":"{\\n    \\"buildType\\": \\"entity\\",\\n    \\"fragmentPointer\\": {\\n        \\"catalog\\": \\"item\\",\\n        \\"tag\\": \\"barrel1\\"\\n    },\\n    \\"itemType\\": \\"barrel1\\"\\n}\\n"},{"name":"itemId","type":"string","value":"barrel1"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"barrel1"}],"rotation":0,"visible":true,"width":32,"x":0,"y":0},{"class":"FRAGMENT","height":64,"id":1196,"name":"","properties":[{"name":"category","type":"string","value":"stackedBags"},{"name":"context","type":"string","value":"{\\n  \\"mustBeFreeAtLayers\\": [\\"sprite\\", \\"sprite2\\"]\\n}"},{"name":"craftableMeta","type":"string","value":"{\\n    \\"buildType\\": \\"entity\\",\\n    \\"fragmentPointer\\": {\\n        \\"catalog\\": \\"item\\",\\n        \\"tag\\": \\"stackedBags\\"\\n    },\\n    \\"itemType\\": \\"stackedBags\\"\\n}\\n"},{"name":"itemId","type":"string","value":"stackedBags"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"stackedBags"}],"rotation":0,"visible":true,"width":64,"x":32,"y":0},{"class":"FRAGMENT","height":32,"id":1197,"name":"","properties":[{"name":"category","type":"string","value":"stool1"},{"name":"context","type":"string","value":"{\\n}"},{"name":"craftableMeta","type":"string","value":"{\\n    \\"buildType\\": \\"entity\\",\\n    \\"fragmentPointer\\": {\\n        \\"catalog\\": \\"item\\",\\n        \\"tag\\": \\"stool1\\"\\n    },\\n    \\"itemType\\": \\"stool1\\"\\n}\\n"},{"name":"itemId","type":"string","value":"stool1"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"stool1"}],"rotation":0,"visible":true,"width":32,"x":96,"y":0},{"class":"FRAGMENT","height":64,"id":1200,"name":"","properties":[{"name":"category","type":"string","value":"midRoughTable"},{"name":"context","type":"string","value":"{\\n  \\"mustBeFreeAtLayers\\": [\\"sprite\\", \\"sprite2\\"]\\n}"},{"name":"craftableMeta","type":"string","value":"{\\n    \\"buildType\\": \\"entity\\",\\n    \\"fragmentPointer\\": {\\n        \\"catalog\\": \\"item\\",\\n        \\"tag\\": \\"midRoughTable\\"\\n    },\\n    \\"itemType\\": \\"table-mid-rough\\"\\n}\\n"},{"name":"itemId","type":"string","value":"table-mid-rough"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"midRoughTable"}],"rotation":0,"visible":true,"width":96,"x":128,"y":0},{"class":"FRAGMENT","height":96,"id":1202,"name":"","properties":[{"name":"category","type":"string","value":"strawBed"},{"name":"context","type":"string","value":"{\\n  \\"mustBeFreeAtLayers\\": [\\"map3\\"]\\n}"},{"name":"craftableMeta","type":"string","value":"{\\n    \\"buildType\\": \\"floor2\\",\\n    \\"fragmentPointer\\": {\\n        \\"catalog\\": \\"item\\",\\n        \\"tag\\": \\"strawBed\\"\\n    },\\n    \\"itemType\\": \\"strawBed\\"\\n}\\n"},{"name":"itemId","type":"string","value":"strawBed"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"strawBed"}],"rotation":0,"visible":true,"width":64,"x":0,"y":64},{"class":"mapSpriteCap","height":0,"id":1203,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"exclusive\\": \\"furniture-blonde-wood-128\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":113.380281690141,"y":23.943661971831},{"class":"FRAGMENT","height":64,"id":1205,"name":"","properties":[{"name":"category","type":"string","value":"strawBedSmall"},{"name":"context","type":"string","value":"{\\n  \\"mustBeFreeAtLayers\\": [\\"map3\\"]\\n}"},{"name":"craftableMeta","type":"string","value":"{\\n    \\"buildType\\": \\"floor2\\",\\n    \\"fragmentPointer\\": {\\n        \\"catalog\\": \\"item\\",\\n        \\"tag\\": \\"strawBedSmall\\"\\n    },\\n    \\"itemType\\": \\"strawBedSmall\\"\\n}\\n"},{"name":"itemId","type":"string","value":"strawBedSmall"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"strawBedSmall"}],"rotation":0,"visible":true,"width":64,"x":64,"y":64}],"opacity":1,"type":"objectgroup","visible":true,"x":0,"y":0}],"nextlayerid":19,"nextobjectid":1206,"orientation":"orthogonal","renderorder":"right-down","tiledversion":"1.9.0","tileheight":32,"tilesets":[{"firstgid":1,"source":"../tilesets/lpc-terrain.tsx"},{"firstgid":1025,"source":"../tilesets/plants.tsx"},{"firstgid":1194,"source":"../tilesets/lpc-flowers-plants-fungi-wood.tsx"},{"firstgid":1706,"source":"../tilesets/mountains-v6.tsx"},{"firstgid":6826,"source":"../tilesets/ore.tsx"},{"firstgid":7082,"source":"../tilesets/jungle-ruins.tsx"},{"firstgid":8106,"source":"../tilesets/build_atlas.tsx"},{"firstgid":9130,"source":"../tilesets/decorations-medieval.tsx"},{"firstgid":10154,"source":"../tilesets/roofs.tsx"},{"firstgid":14250,"source":"../tilesets/cottage.tsx"},{"firstgid":14506,"source":"../tilesets/walls.tsx"},{"firstgid":20650,"source":"../tilesets/container.tsx"},{"firstgid":21674,"source":"../tilesets/fence_medieval.tsx"},{"firstgid":22186,"source":"../tilesets/furniture-blonde-wood.tsx"}],"tilewidth":32,"type":"map","version":"1.9","width":50},"ruins":{"compressionlevel":-1,"height":50,"infinite":false,"layers":[{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":1,"name":"map1","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":2,"name":"map2","opacity":1,"properties":[{"name":"entityTileSurface","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8084,8086,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8083,8085,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":3,"name":"map3","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":4,"name":"map4","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,7402,7628,7403,7404,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7434,7435,7435,7436,0,0,7694,7559,7560,7539,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7498,0,0,0,0,7629,7692,7591,7592,7571,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7530,7531,7690,7694,0,7757,7691,7623,7624,7603,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7562,7563,7563,7564,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7594,7595,7756,7596,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7520,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7552,0,7553,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7584,0,7584,0,7553,0,8019,8021,8022,0,0,8010,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7616,0,7616,0,7616,0,8051,8053,8054,0,0,8076,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8252,8253,8254,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":6,"name":"sprite","opacity":1,"properties":[{"name":"sprite","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,7484,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7516,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,7516,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":5,"name":"sky","opacity":1,"properties":[{"name":"sky","type":"bool","value":true}],"type":"tilelayer","visible":false,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,122,122,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,122,0,122,0,122,122,122,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":6,"name":"blocking","opacity":1,"properties":[{"name":"blocking","type":"bool","value":true}],"type":"tilelayer","visible":false,"width":50,"x":0,"y":0},{"draworder":"topdown","id":1,"name":"objects","objects":[{"class":"FRAGMENT","height":192,"id":927,"name":"smallBuilding","properties":[{"name":"category","type":"string","value":"building"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":128,"x":32,"y":0},{"class":"FRAGMENT","height":96,"id":928,"name":"mediumWall","properties":[{"name":"category","type":"string","value":"fragment"},{"name":"subcategory","type":"string","value":"medium"}],"rotation":0,"visible":true,"width":160,"x":192,"y":32},{"class":"FRAGMENT","height":128,"id":929,"name":"tallPillar","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"tall"}],"rotation":0,"visible":true,"width":32,"x":192,"y":192},{"class":"FRAGMENT","height":96,"id":930,"name":"mediumPillar","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"tall"}],"rotation":0,"visible":true,"width":32,"x":256,"y":224},{"class":"FRAGMENT","height":64,"id":932,"name":"shortPillar","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"tall"}],"rotation":0,"visible":true,"width":32,"x":320,"y":256},{"class":"FRAGMENT","height":64,"id":940,"name":"rubble1","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"tall"}],"rotation":0,"visible":true,"width":32,"x":384,"y":256},{"class":"FRAGMENT","height":64,"id":941,"name":"rubble2","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"tall"}],"rotation":0,"visible":true,"width":32,"x":416,"y":256},{"class":"FRAGMENT","height":64,"id":942,"name":"rubble3","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"tall"}],"rotation":0,"visible":true,"width":32,"x":448,"y":256},{"class":"FRAGMENT","height":32,"id":943,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"subcategory","type":"string","value":"tile"}],"rotation":0,"visible":true,"width":32,"x":480,"y":256},{"class":"FRAGMENT","height":32,"id":944,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"subcategory","type":"string","value":"tile"}],"rotation":0,"visible":true,"width":32,"x":512,"y":256},{"class":"FRAGMENT","height":32,"id":945,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"subcategory","type":"string","value":"tile"}],"rotation":0,"visible":true,"width":32,"x":480,"y":288},{"class":"FRAGMENT","height":32,"id":946,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"subcategory","type":"string","value":"tile"}],"rotation":0,"visible":true,"width":32,"x":512,"y":288},{"class":"FRAGMENT","height":64,"id":948,"name":"seatedFigure1","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"tall"}],"rotation":0,"visible":true,"width":32,"x":544,"y":256},{"class":"FRAGMENTX","height":32,"id":950,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"tall"}],"rotation":0,"visible":true,"width":96,"x":192,"y":352}],"opacity":1,"type":"objectgroup","visible":true,"x":0,"y":0}],"nextlayerid":7,"nextobjectid":952,"orientation":"orthogonal","renderorder":"right-down","tiledversion":"1.9.0","tileheight":32,"tilesets":[{"firstgid":1,"source":"../tilesets/lpc-terrain.tsx"},{"firstgid":1025,"source":"../tilesets/plants.tsx"},{"firstgid":1194,"source":"../tilesets/lpc-flowers-plants-fungi-wood.tsx"},{"firstgid":1706,"source":"../tilesets/mountains-v6.tsx"},{"firstgid":6826,"source":"../tilesets/ore.tsx"},{"firstgid":7082,"source":"../tilesets/jungle-ruins.tsx"},{"firstgid":8106,"source":"../tilesets/build_atlas.tsx"}],"tilewidth":32,"type":"map","version":"1.9","width":50},"settlement":{"compressionlevel":-1,"height":50,"infinite":false,"layers":[{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,0,0,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,0,0,101,101,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,101,101,101,101,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":1,"name":"map1","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,71,72,72,73,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,135,136,136,137,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,71,72,72,72,72,72,72,72,72,72,72,72,72,72,72,72,73,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,104,104,104,104,104,104,104,104,104,104,104,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,104,104,104,104,104,169,104,104,104,168,104,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,169,104,104,104,104,104,104,104,169,169,104,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,104,104,169,104,104,104,167,104,169,169,169,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8397,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,167,104,104,104,104,104,104,104,104,169,169,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8429,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,104,104,104,104,104,104,104,104,104,104,104,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,104,104,104,104,104,104,168,104,169,104,104,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11920,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,104,104,104,104,104,104,104,104,104,104,104,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11920,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,104,104,169,104,104,104,104,104,104,104,167,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11920,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,104,104,104,104,104,104,104,104,104,104,168,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,168,104,167,104,104,104,169,104,104,104,104,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,104,104,104,104,104,104,104,169,104,169,104,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,104,104,104,104,104,169,104,104,104,104,104,104,104,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,773,0,0,0,0,0,0,0,103,104,104,104,104,104,169,169,104,104,104,104,104,104,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,773,0,0,0,0,0,0,0,103,104,104,104,104,104,104,104,168,104,104,104,104,104,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,773,0,0,0,0,0,0,0,103,104,104,104,104,104,104,104,104,104,104,104,104,104,104,104,105,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,135,136,136,136,136,136,136,136,136,136,136,136,136,136,136,136,137,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,773,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,773,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,773,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,773,773,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,773,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,8397,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,8429,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":2,"name":"map2","opacity":1,"properties":[{"name":"entityTileSurface","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,10090,10090,10090,10090,0,0,10090,10090,10090,10090,10090,10090,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10090,10090,10090,10090,0,10090,10090,10090,10090,10090,10090,10090,10090,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10090,10090,10090,10090,0,10090,10090,10090,10090,10090,10090,10090,10090,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10090,0,0,10090,0,10090,10090,10090,10090,10090,10090,10090,10090,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10090,10090,10090,10009,0,10090,10090,10090,10090,10090,10090,10090,10090,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11468,11468,11468,11468,11468,11468,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11468,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11468,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11468,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11468,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11468,0,0,0,14259,14260,14260,14260,14252,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,107,107,107,107,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11468,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,107,107,107,107,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11468,0,0,0,0,0,0,8174,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,107,107,107,107,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11468,0,0,597,597,597,597,597,597,597,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,107,107,107,107,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,677,677,677,677,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,107,107,107,107,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,677,677,677,677,0,0,0,0,0,0,0,0,0,0,0,0,9674,9675,9675,9676,0,0,0,0,0,0,0,0,0,0,0,0,0,0,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,677,677,677,677,0,0,0,0,0,0,0,0,0,0,0,0,9690,9691,9691,9692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,677,677,677,677,0,677,677,677,677,677,677,677,0,0,0,0,9690,9691,9691,9692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,677,677,677,677,0,677,677,677,677,677,677,677,0,0,0,0,9706,9707,9707,9708,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,677,677,677,677,0,677,677,677,677,677,677,677,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,677,677,677,677,0,677,677,677,677,677,677,677,0,0,0,0,9674,9675,9676,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,9690,9691,9692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,9706,9707,9708,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,107,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17179,17179,17179,17179,0,104,104,104,104,104,104,0,0,0,0,0,0,0,0,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,104,104,104,104,104,104,0,0,0,0,0,0,0,0,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8174,0,0,104,104,104,104,104,104,0,0,0,0,0,0,0,0,107,107,107,107,107,107,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,104,104,104,104,104,104,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,104,104,104,104,104,104,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,104,104,104,104,104,104,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":3,"name":"map3","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,14427,14427,14427,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,14427,14427,14427,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15802,15802,15802,15802,15802,15802,15802,15802,15802,15802,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15930,15930,15930,15930,15930,15930,15930,15930,15930,15930,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8757,8758,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8789,8790,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8821,8822,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,816,816,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,816,816,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,816,816,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,816,816,0,0,0,816,816,816,816,816,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,816,816,0,0,0,816,816,816,816,816,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,773,773,773,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15818,15820,15818,15820,15818,15820,0,0,0,0,0,0,0,0,0,0,0,0,0,0,9924,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15882,15884,15882,15884,15882,15884,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,743,743,743,743,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,743,743,743,743,0,15802,15802,15802,15802,15802,15802,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,14451,14451,14452,14453,0,15930,15930,15930,15930,15930,15930,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17179,17179,743,17179,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,17179,17179,743,17179,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":4,"name":"map4","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":17,"name":"map5","opacity":1,"type":"tilelayer","visible":false,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":18,"name":"map6","opacity":1,"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,10007,10008,0,0,0,9931,9939,9939,9939,9940,9935,0,0,0,9459,9460,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10022,10023,10024,10025,0,9946,9947,0,0,0,0,9951,9952,0,0,9475,9476,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10038,10089,10089,10041,0,9962,9963,0,0,0,0,9967,9968,0,0,9491,9492,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10054,0,0,10057,0,9978,9979,0,0,0,0,9983,9984,0,0,9507,9508,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10070,10071,10072,10073,0,9994,9995,9996,0,0,9998,9999,10000,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15818,15820,15818,15820,15818,15820,15818,15820,15818,15820,15818,15820,15821,15818,15820,15818,15820,15818,15820,15818,15820,15818,15820,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15882,15884,15882,15884,15597,15407,15407,15407,15407,15407,15407,15407,15407,15407,15407,15407,15407,15407,15601,15882,15884,15882,15884,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10181,0,0,0,0,0,0,20986,20987,20696,20697,0,0,15690,0,0,0,15473,15791,15791,15791,15791,15792,20214,20215,20216,15792,15791,15791,15791,15792,15473,0,0,0,15692,0,0,0,21930,21966,21966,21966,21934,0,0,0,0,0,10244,10245,10246,0,0,0,0,0,21002,21003,20712,20713,0,0,15690,0,0,0,15473,15855,15855,15855,15855,15856,20278,20279,20280,15856,15855,15855,15855,15856,15473,0,0,0,15692,0,0,0,21946,21982,21982,21982,21951,0,0,0,0,10307,10308,10309,10310,10311,0,0,8799,8800,8801,8391,0,0,0,0,15690,0,0,0,15473,15919,15919,15919,15919,15920,20278,0,20280,15920,15919,15919,15919,15920,15473,0,0,0,15692,0,0,0,21946,21982,21982,21982,21951,0,0,0,13526,10371,10372,10373,10374,10375,13533,0,8831,8832,8833,8423,0,0,0,0,15690,0,0,0,15473,0,0,0,0,0,0,0,0,0,0,0,0,0,15473,0,0,0,15692,0,0,0,21949,0,0,0,21919,0,0,0,13590,10435,10436,0,10438,10439,13597,0,8736,8737,0,8393,8457,0,0,0,15690,0,0,0,15537,0,0,15610,15611,15611,15611,15611,15611,15611,15611,15611,15612,0,15537,0,0,0,15692,0,0,0,21950,21966,21966,21966,21887,0,0,0,13590,10499,0,0,0,10503,13597,0,8768,8769,0,8425,8489,0,0,0,15690,0,0,0,15791,0,0,15674,0,0,0,0,0,0,0,0,15676,0,15791,0,0,0,15692,0,0,0,21982,21982,21982,21982,21982,0,0,0,0,14266,14276,14276,0,14268,0,0,0,0,8585,9456,0,0,0,0,15690,0,0,0,15855,0,0,15674,0,0,15675,0,0,0,0,0,15676,0,15855,0,0,0,15692,0,0,0,21982,22016,21982,21982,21982,0,0,0,0,14282,14292,14292,0,14284,0,0,0,0,0,9472,0,0,0,0,15690,0,0,0,15919,0,0,15738,15739,15739,15739,15547,0,0,0,0,15676,0,15919,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8585,0,0,0,0,0,15690,0,0,0,0,0,0,15802,15802,15802,15803,15674,0,0,0,0,15676,0,0,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15690,0,0,0,15409,0,0,15930,15930,15930,15931,15674,0,0,0,0,15676,0,15409,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15690,0,0,0,15473,0,0,0,0,0,0,15738,15739,15739,15739,15739,15740,0,15473,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15690,0,0,0,15473,0,0,0,0,9896,0,15802,15802,8628,8629,15803,15804,0,15473,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15690,0,0,0,15473,0,0,0,0,9912,0,15930,15930,8660,8661,15932,15933,0,15473,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15690,0,0,0,15473,0,0,0,0,0,0,0,0,0,0,0,0,0,15473,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15690,0,0,0,15725,15407,15407,15407,15407,15407,15407,15407,15407,15407,15407,15407,15407,15407,15729,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15690,0,0,0,15791,15791,15791,15790,15791,15792,20214,20215,20216,15792,15792,15792,15792,15792,15791,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15690,0,0,0,15855,15855,15855,15854,15855,15856,20278,20279,20280,15856,15856,15856,15856,15856,15855,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15690,0,0,0,15919,15919,15919,15918,15919,15920,20278,0,20280,15920,15920,15920,15920,15920,15919,15821,0,15818,15820,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,22336,22337,22258,0,0,0,0,0,0,0,0,15690,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15885,0,15882,15884,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,22352,22353,22274,0,22313,0,0,0,0,0,0,15754,15755,15755,15755,15755,15755,15755,15755,15755,15755,15755,15755,15755,15755,15755,15755,15755,15755,15755,15755,15755,15755,15756,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,22290,0,22311,0,0,0,0,0,0,15818,15820,15818,15820,15820,15818,15820,15818,15820,15818,15820,15818,15820,15818,15820,15818,15820,15818,15820,15818,15820,0,15820,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15882,15884,15882,15884,15884,15882,15884,15882,15884,15882,15884,15882,15884,15882,15884,15882,15884,15882,15884,15882,15884,0,15884,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,22189,22190,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,22205,22206,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,9641,0,9673,0,0,0,0,0,0,0,0,0,0,0,0,0,0,18122,18122,18122,18123,18124,18125,0,0,0,0,0,0,0,0,15626,15627,15627,15627,15627,15628,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,18186,18186,18186,18187,18188,18189,0,0,0,0,0,0,0,0,15690,0,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,9641,0,9673,0,0,0,0,0,0,0,0,0,11502,11503,11503,11505,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15690,0,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11566,11567,11567,11569,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15690,0,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11630,11567,11567,11633,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15690,0,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11694,11695,11695,11697,0,15610,15611,15611,15611,15611,15612,0,0,0,0,0,0,0,0,15690,0,0,0,0,15692,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11758,11759,11759,11759,0,15674,0,0,0,0,15676,21754,21678,21678,21711,0,0,0,0,15754,15755,15755,15755,15755,15756,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,14467,14467,0,14469,0,15674,0,0,0,0,15676,0,0,0,21694,0,0,0,0,15818,15820,15626,15628,15818,15820,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,14483,14483,0,14485,0,15674,0,0,0,0,15676,0,0,0,21694,0,0,0,0,15882,15884,15690,15692,15882,15884,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15738,15739,0,15739,15739,15740,0,0,0,21694,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,15755,15739,0,15802,15802,0,15803,15803,15804,0,0,0,21694,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,16167,16167,16167,0,15930,15930,0,15932,15932,15933,21711,0,0,21694,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,9743,0,0,0,0,0,0,0,21694,0,0,21694,0,0,0,0,14478,14478,14478,14478,14478,14478,0,9741,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,9759,0,0,0,0,0,0,0,21741,21755,21678,21743,0,0,0,0,0,0,0,22308,22309,22310,0,9757,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,9773,0,0,0],"height":50,"id":6,"name":"sprite","opacity":1,"properties":[{"name":"sprite","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,22135,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,22151,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,22135,22136,8109,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,22151,22152,8141,0,0,0,0,0,0,0,0,0,22615,22616,22617,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,22631,22632,22633,0,22305,22306,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20790,20806,0,0,0,0,0,0,0,0,0,0,22647,22648,22649,0,22321,22322,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":9,"name":"sprite2","opacity":1,"properties":[{"name":"sprite","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":10,"name":"sprite3","opacity":1,"properties":[{"name":"sprite","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,9997,9997,9997,9997,0,0,0,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,9997,9997,9997,9997,0,0,0,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,9997,9997,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10064,10064,10064,10064,10064,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10064,10064,10064,10064,10064,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,10064,10064,10064,10064,10064,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,10064,10064,10064,10064,10064,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":7,"name":"skyTrigger","opacity":1,"properties":[{"name":"skyTrigger","type":"bool","value":true}],"type":"tilelayer","visible":false,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,9932,9933,9933,9934,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,9948,9949,9949,9950,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10039,10040,0,0,0,0,9964,9965,9965,9966,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,10055,10056,0,0,0,0,9980,9981,9981,9982,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,22076,22076,22076,22076,22076,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,22091,22092,22124,22124,22124,22092,22093,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,22091,22092,22092,22092,22092,22092,22093,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12341,12344,0,0,0,0,0,0,0,0,0,0,22091,22092,22124,22124,22124,22092,22093,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12340,12342,12343,12344,12341,12342,12405,12408,12343,12344,0,0,0,0,0,0,0,0,22091,22124,22124,22092,22092,22092,22093,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13526,12404,12405,12407,12407,12469,12405,12405,12472,12407,12408,13533,0,0,0,0,0,0,0,22091,22092,22092,22092,22092,22124,22093,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13590,12404,12405,12407,12407,12469,12405,12405,12472,12471,12472,13597,0,0,0,0,0,0,0,0,22108,22108,22108,22108,22108,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13590,12404,12405,12407,12407,12469,12405,12405,12472,12407,12408,13597,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13590,12532,12534,12535,12536,12469,12405,12405,12408,12407,12408,13597,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13654,0,0,0,13526,12469,12405,12405,12408,12407,12408,13597,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13590,12469,12469,12533,12536,12407,12408,13597,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13590,12533,12534,0,0,12535,12536,13597,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13654,0,0,0,0,0,0,13661,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12331,12332,12332,12333,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12395,12396,12396,12397,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12459,12460,12460,12461,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,11947,12203,12204,12204,12205,11949,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12138,12011,12203,12204,12205,12205,12013,12142,0,0,0,0,0,0,0,0,0,0,0,0,9541,9542,9542,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12202,12011,12203,12204,12204,12205,12013,12206,0,0,0,0,0,0,0,0,0,0,0,0,9557,9558,9558,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12202,12011,12203,12204,12205,12205,12013,12206,0,0,0,0,0,0,0,0,0,0,0,0,9573,0,9574,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12202,12011,12203,12204,12205,12205,12013,12206,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12341,12344,0,0,0,0,0,0,0,0,0,12202,12011,12203,12204,12204,12205,12013,12206,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,12341,12342,12405,12408,12343,12344,0,0,0,0,0,0,0,12202,12011,12204,12204,12204,12204,12013,12206,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13526,12469,12405,12405,12472,12407,12408,13533,0,0,0,0,0,0,12202,12011,12204,12204,12205,12205,12013,12206,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13590,12469,12405,12405,12472,12471,12472,13597,0,0,0,0,0,0,12202,12522,0,0,0,0,12526,12206,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13590,12469,12405,12405,12472,12407,12408,13597,0,0,0,0,0,0,12266,0,0,0,0,0,0,12270,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13590,12469,12469,12533,12536,12407,12408,13597,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13590,12533,12534,0,0,12535,12536,13597,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,13654,0,0,0,0,0,0,13661,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":5,"name":"sky","opacity":1,"properties":[{"name":"sky","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":12,"name":"sky2","opacity":1,"properties":[{"name":"sky","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"data":[0,0,0,0,0,0,0,0,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,958,959,959,960,0,122,122,0,0,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,990,959,959,992,0,122,122,0,0,0,0,122,122,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,990,0,0,992,0,122,122,0,0,0,0,122,122,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1022,0,0,1024,0,122,122,0,0,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,122,122,122,122,122,0,0,0,122,122,122,122,122,122,0,0,0,122,0,0,0,122,122,122,122,122,0,0,0,0,122,122,122,122,122,0,0,122,122,0,122,0,0,0,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,0,122,0,0,0,122,0,0,0,0,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,122,122,122,122,122,122,122,122,122,122,0,122,0,0,0,122,0,0,0,122,0,0,0,122,0,0,0,0,122,122,122,122,122,0,0,122,122,0,122,122,0,0,0,122,0,0,0,122,0,0,122,122,122,122,122,122,122,122,122,122,0,122,0,0,0,122,0,0,0,122,0,0,0,122,0,0,0,0,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,122,0,0,0,0,0,0,0,0,122,0,122,0,0,0,122,0,0,0,122,0,122,122,122,0,0,0,0,122,122,122,0,122,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,122,0,0,0,0,0,0,0,0,122,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,122,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,122,122,122,122,122,0,0,0,0,122,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,0,0,0,0,122,0,0,0,0,122,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,0,0,0,0,122,0,0,0,0,122,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,0,0,122,0,122,122,0,0,122,122,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,122,122,122,122,122,122,0,0,0,122,122,122,122,122,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,0,0,122,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,122,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,0,122,122,122,122,122,122,0,0,0,0,0,0,0,0,122,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,0,122,122,122,122,122,122,122,122,122,122,0,0,0,0,122,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,0,122,0,0,0,0,122,0,0,0,122,0,0,0,0,122,0,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,0,122,0,122,0,0,0,122,122,0,0,0,122,0,0,0,0,122,122,0,0,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,0,0,122,0,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,0,122,122,122,122,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,0,0,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,122,122,122,122,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"height":50,"id":6,"name":"blocking","opacity":0.25,"properties":[{"name":"blocking","type":"bool","value":true}],"type":"tilelayer","visible":true,"width":50,"x":0,"y":0},{"draworder":"topdown","id":1,"name":"objects","objects":[{"class":"FRAGMENT","height":192,"id":951,"name":"smallTent","properties":[{"name":"category","type":"string","value":"tent"},{"name":"context","type":"string","value":"{\\n  \\"transportTarget\\": true,\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":192,"x":0,"y":0},{"class":"FRAGMENT","height":160,"id":952,"name":"largeTent","properties":[{"name":"category","type":"string","value":"tent"},{"name":"context","type":"string","value":"{\\n  \\"transportTarget\\": true,\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"large"}],"rotation":0,"visible":true,"width":256,"x":192,"y":0},{"class":"FRAGMENT","height":96,"id":958,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"hay"}],"rotation":0,"visible":true,"width":64,"x":544,"y":416},{"class":"FRAGMENT","height":32,"id":959,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"woodPile"}],"rotation":0,"visible":true,"width":32,"x":608,"y":448},{"class":"FRAGMENT","height":64,"id":962,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"barrel"}],"rotation":0,"visible":true,"width":64,"x":640,"y":352},{"class":"FRAGMENT","height":64,"id":963,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"hayCart"}],"rotation":0,"visible":true,"width":96,"x":544,"y":288},{"class":"FRAGMENT","height":64,"id":964,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"fork"}],"rotation":0,"visible":true,"width":32,"x":640,"y":416},{"class":"FRAGMENT","height":64,"id":965,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"emptyCart"}],"rotation":0,"visible":true,"width":64,"x":544,"y":352},{"class":"FRAGMENT","height":64,"id":966,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"barrel"}],"rotation":0,"visible":true,"width":32,"x":640,"y":288},{"class":"FRAGMENT","height":128,"id":968,"name":"","properties":[{"name":"category","type":"string","value":"platform"},{"name":"subcategory","type":"string","value":"large"},{"name":"tag","type":"string","value":"woodPlatform"}],"rotation":0,"visible":true,"width":128,"x":576,"y":544},{"class":"FRAGMENT","height":32,"id":970,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"bucket"}],"rotation":0,"visible":true,"width":32,"x":608,"y":416},{"class":"FRAGMENT","height":96,"id":971,"name":"","properties":[{"name":"category","type":"string","value":"platform"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"woodPlatform"}],"rotation":0,"visible":true,"width":96,"x":576,"y":704},{"class":"FRAGMENT","height":256,"id":974,"name":"","properties":[{"name":"category","type":"string","value":"house"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":""}],"rotation":0,"visible":true,"width":224,"x":288,"y":224},{"class":"FRAGMENT","height":224,"id":975,"name":"","properties":[{"name":"category","type":"string","value":"house"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":""}],"rotation":0,"visible":true,"width":128,"x":640,"y":1184},{"class":"FRAGMENT","height":128,"id":976,"name":"","properties":[{"name":"category","type":"string","value":"field"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":224,"x":224,"y":608},{"class":"FRAGMENT","height":224,"id":977,"name":"","properties":[{"name":"category","type":"string","value":"field"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":128,"x":64,"y":512},{"class":"FRAGMENT","height":768,"id":980,"name":"warlordCompound","properties":[{"name":"category","type":"string","value":"compound"},{"name":"context","type":"string","value":"{\\n  \\"locationIcon\\": \\"castle.png\\",\\n  \\"noResourceSpawn\\": true,\\n  \\"noProximitySpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"warlord1"}],"rotation":0,"visible":true,"width":736,"x":800,"y":160},{"class":"FRAGMENT_POINT","height":0,"id":983,"name":"warlord","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"warlord\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":1245.77564558162,"y":471.023058571008},{"class":"FRAGMENT_POINT","height":0,"id":984,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"vassalCount\\": 4\\n}"}],"rotation":0,"visible":true,"width":0,"x":1168.5951196399,"y":345.896532817096},{"class":"FRAGMENT_POINT","height":0,"id":985,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"vassalCount\\": 4\\n}"}],"rotation":0,"visible":true,"width":0,"x":1392.06666779218,"y":507.640213111478},{"class":"FRAGMENT_POINT","height":0,"id":986,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"vassalCount\\": 4\\n}"}],"rotation":0,"visible":true,"width":0,"x":993.372026906084,"y":503.889918076573},{"class":"FRAGMENT_POINT","height":0,"id":987,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"vassalCount\\": 4\\n}"}],"rotation":0,"visible":true,"width":0,"x":1166.87119992558,"y":755.22688551167},{"class":"FRAGMENT_POINT","height":0,"id":988,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"vassalCount\\": 4\\n}"}],"rotation":0,"visible":true,"width":0,"x":1198.9196872779,"y":503.164179104478},{"class":"FRAGMENT_POINT","height":0,"id":989,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"vassalCount\\": 4\\n}"}],"rotation":0,"visible":true,"width":0,"x":1297.4745321014,"y":502.21653636579},{"class":"FRAGMENT_POINT","height":0,"id":990,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"vassalCount\\": 4\\n}"}],"rotation":0,"visible":true,"width":0,"x":1056.29945510543,"y":607.878701729448},{"class":"FRAGMENT_POINT","height":0,"id":991,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"vassalCount\\": 4\\n}"}],"rotation":0,"visible":true,"width":0,"x":1245.22309163037,"y":675.574357458389},{"class":"FRAGMENT_POINT","height":0,"id":992,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"vassalCount\\": 4\\n}"}],"rotation":0,"visible":true,"width":0,"x":1246.30182421227,"y":549.467583456947},{"class":"FRAGMENT_POINT","height":0,"id":993,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"vassalCount\\": 4\\n}"}],"rotation":0,"visible":true,"width":0,"x":1009.86496090974,"y":704.064439706231},{"class":"FRAGMENT_POINT","height":0,"id":994,"name":"entrance","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"tentCampaign\\": true,\\n  \\"type\\": \\"entrance\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":96.6429298067141,"y":156.832824686334},{"class":"FRAGMENT_POINT","height":0,"id":995,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"stackedBoxes\\",\\n    \\"category\\": \\"stackedBoxes\\",\\n    \\"subcategory\\": \\"medium\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":335.729420461832,"y":26.8907795529035},{"class":"FRAGMENT_POINT","height":0,"id":996,"name":"trader","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"trader\\": {}\\n}"}],"rotation":0,"visible":true,"width":0,"x":273.478906084376,"y":72.7863755211646},{"class":"FRAGMENT_POINT","height":0,"id":997,"name":"entrance","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"tentCampaign\\": true,\\n  \\"type\\": \\"entrance\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":315.515649911891,"y":129.646723168583},{"class":"FRAGMENT_POINT","height":0,"id":998,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"boundToWarlord\\": true,\\n  \\"weapon\\": \\"dagger\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":1293.04197136229,"y":1305.69361106082},{"class":"FRAGMENT_POINT","height":0,"id":999,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"boundToWarlord\\": true,\\n  \\"weapon\\": \\"axe\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":1335.70161297231,"y":1306.38675409772},{"class":"FRAGMENT_POINT","height":0,"id":1001,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"boundToWarlord\\": true,\\n  \\"weapon\\": \\"spear\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":1314.99774735056,"y":1268.03479709253},{"class":"FRAGMENT_POINT","height":0,"id":1002,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"weapon\\": \\"axe\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":1389.32773558251,"y":1438.67752049268},{"class":"FRAGMENT_POINT","height":0,"id":1003,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"weapon\\": \\"spear\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":1294.47305571578,"y":1438.11331376733},{"class":"FRAGMENT_POINT","height":0,"id":1005,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"vassalCount\\": 2\\n}"}],"rotation":0,"visible":true,"width":0,"x":1345.73229821573,"y":1438.06368463239},{"class":"FRAGMENT_POINT","height":0,"id":1008,"name":"warlord","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"warlord\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":1313.16480433151,"y":1241.18411348239},{"class":"FRAGMENT","height":416,"id":1009,"name":"warlordSubCompound","properties":[{"name":"category","type":"string","value":"compound"},{"name":"context","type":"string","value":"{\\n  \\"locationIcon\\": \\"building.png\\",\\n  \\"noResourceSpawn\\": true,\\n  \\"noProximitySpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"warlordSmall"}],"rotation":0,"visible":true,"width":320,"x":1184,"y":1056},{"class":"FRAGMENT","height":352,"id":1013,"name":"warlordSubCompound","properties":[{"name":"category","type":"string","value":"compound"},{"name":"context","type":"string","value":"{\\n  \\"locationIcon\\": \\"building.png\\",\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"warlordSmall"}],"rotation":0,"visible":true,"width":352,"x":768,"y":1216},{"class":"FRAGMENT_POINT","height":0,"id":1014,"name":"warlord","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"warlord\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":887.106846912483,"y":1400.02211214174},{"class":"FRAGMENT_POINT","height":0,"id":1015,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"boundToWarlord\\": true,\\n  \\"weapon\\": \\"axe\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":865.559103927082,"y":1422.49385849316},{"class":"FRAGMENT_POINT","height":0,"id":1016,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"boundToWarlord\\": true,\\n  \\"weapon\\": \\"spear\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":902.678005950269,"y":1423.67160646618},{"class":"mapSpriteCap","height":0,"id":1025,"name":"","point":true,"rotation":0,"visible":true,"width":0,"x":645.131976473575,"y":295.075614606694},{"class":"mapSpriteCap","height":0,"id":1026,"name":"","point":true,"rotation":0,"visible":true,"width":0,"x":646.976685143655,"y":359.666567934668},{"class":"mapSpriteCap","height":0,"id":1027,"name":"","point":true,"rotation":0,"visible":true,"width":0,"x":678.905591769766,"y":361.403041993703},{"class":"FRAGMENT","height":64,"id":1039,"name":"","properties":[{"name":"category","type":"string","value":"stackedBoxes"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"stackedBoxes"}],"rotation":0,"visible":true,"width":64,"x":608,"y":224},{"class":"FRAGMENT_POINT","height":0,"id":1040,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"stackedBoxes\\",\\n    \\"category\\": \\"stackedBoxes\\",\\n    \\"subcategory\\": \\"medium\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1042.29814084459,"y":1396.68480878788},{"class":"FRAGMENT_POINT","height":0,"id":1042,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"bucket2\\",\\n    \\"category\\": \\"decoration\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\",\\n    \\"context\\": {\\n       \\"absolutePosition\\": true\\n    }\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":858.02437276563,"y":1384.05630234478},{"class":"FRAGMENT_POINT","height":0,"id":1045,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"fork\\",\\n    \\"category\\": \\"decoration\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1006.83133945364,"y":1401.65923032355},{"class":"FRAGMENT_POINT","height":0,"id":1046,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"wallDeco1\\",\\n    \\"category\\": \\"decoration\\",\\n    \\"subcategory\\": \\"building\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":846.931140966989,"y":1465.41213777149},{"class":"FRAGMENT","height":32,"id":1048,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"bucket2"}],"rotation":0,"visible":true,"width":32,"x":608,"y":480},{"class":"FRAGMENT_POINT","height":0,"id":1051,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"veryLargeBarrel\\",\\n    \\"category\\": \\"veryLargeBarrel\\",\\n    \\"subcategory\\": \\"medium\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1030.23366043325,"y":1305.3486391409},{"class":"FRAGMENT_POINT","height":0,"id":1054,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"largeCabinet\\",\\n    \\"category\\": \\"largeCabinet\\",\\n    \\"subcategory\\": \\"medium\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":817.974787903599,"y":1329.90997678676},{"class":"FRAGMENT","height":64,"id":1055,"name":"","properties":[{"name":"category","type":"string","value":"roofShadow"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"roofShadow"}],"rotation":0,"visible":true,"width":192,"x":800,"y":1120},{"class":"FRAGMENT_POINT","height":0,"id":1056,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"stackedBoxes\\",\\n    \\"category\\": \\"stackedBoxes\\",\\n    \\"subcategory\\": \\"medium\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1008.89060688056,"y":1361.42249710089},{"class":"FRAGMENT","height":64,"id":1058,"name":"","properties":[{"name":"category","type":"string","value":"largeCabinet"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"largeCabinet"}],"rotation":0,"visible":true,"width":64,"x":448,"y":800},{"class":"FRAGMENT_POINT","height":0,"id":1059,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"largeCabinetSide\\",\\n    \\"category\\": \\"largeCabinetSide\\",\\n    \\"subcategory\\": \\"medium\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":968.846507434443,"y":1332.95170775697},{"class":"FRAGMENT","height":96,"id":1080,"name":"","properties":[{"name":"category","type":"string","value":"largeCabinetSide"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"largeCabinetSide"}],"rotation":0,"visible":true,"width":32,"x":512,"y":800},{"class":"FRAGMENT","height":32,"id":1083,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"craftableMeta","type":"string","value":"{\\n    \\"buildType\\": \\"entity\\",\\n    \\"fragmentPointer\\": {\\n        \\"catalog\\": \\"settlement\\",\\n        \\"tag\\": \\"stool\\"\\n    },\\n    \\"itemType\\": \\"stool-small\\"\\n}\\n"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"stool"}],"rotation":0,"visible":true,"width":32,"x":576,"y":832},{"class":"FRAGMENT","height":32,"id":1084,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"table"}],"rotation":0,"visible":true,"width":32,"x":576,"y":864},{"class":"FRAGMENT_POINT","height":0,"id":1085,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"table\\",\\n    \\"category\\": \\"decoration\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":943.645366658807,"y":1398.25512850743},{"class":"FRAGMENT_POINT","height":0,"id":1086,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"stool\\",\\n    \\"category\\": \\"decoration\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":943.413558699247,"y":1368.73047951497},{"class":"FRAGMENT_POINT","height":0,"id":1087,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"stool\\",\\n    \\"category\\": \\"decoration\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":912.86275083674,"y":1398.9352374176},{"class":"FRAGMENT_POINT","height":0,"id":1088,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"stool\\",\\n    \\"category\\": \\"decoration\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":944.204933959279,"y":1428.93131290004},{"class":"FRAGMENT_POINT","height":0,"id":1089,"name":"door","point":true,"properties":[{"name":"context","type":"string","value":"{\\"type\\":\\"door\\", \\"direction\\":\\"Down\\"}"}],"rotation":0,"visible":true,"width":0,"x":880.972927418075,"y":1493.94833319717},{"class":"FRAGMENT","height":64,"id":1090,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"context","type":"string","value":"{\\n   \\"renderZIdxOffset\\": 32\\n}"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"building"},{"name":"tag","type":"string","value":"arch"}],"rotation":0,"visible":true,"width":32,"x":736,"y":1440},{"class":"FRAGMENT_POINT","height":0,"id":1092,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"arch\\",\\n    \\"category\\": \\"decoration\\",\\n    \\"subcategory\\": \\"building\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":879.663231238206,"y":1425.64232834954},{"class":"FRAGMENT_POINT","height":0,"id":1100,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"roofShadow\\",\\n    \\"category\\": \\"roofShadow\\",\\n    \\"subcategory\\": \\"medium\\",\\n    \\"renderStrategy\\": \\"sprite\\",\\n    \\"context\\": {\\n       \\"roofLayer\\": \\"below\\"\\n    }\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":817.645480240261,"y":1397.11880252454},{"class":"FRAGMENT","height":64,"id":1109,"name":"","properties":[{"name":"category","type":"string","value":"veryLargeBarrel"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"veryLargeBarrel"}],"rotation":0,"visible":true,"width":64,"x":672,"y":224},{"class":"FRAGMENT","height":64,"id":1111,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"context","type":"string","value":"{\\n   \\"renderZIdxOffset\\": 32\\n}"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"building"},{"name":"tag","type":"string","value":"wallDeco1"}],"rotation":0,"visible":true,"width":32,"x":736,"y":1504},{"class":"FRAGMENT","height":32,"id":1117,"name":"","properties":[{"name":"category","type":"string","value":"roofShadow2"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"roofShadow2"}],"rotation":0,"visible":true,"width":192,"x":1248,"y":1504},{"class":"FRAGMENT_POINT","height":0,"id":1121,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"roofShadow2\\",\\n    \\"category\\": \\"roofShadow2\\",\\n    \\"subcategory\\": \\"medium\\",\\n    \\"renderStrategy\\": \\"sprite\\",\\n    \\"context\\": {\\n       \\"roofLayer\\": \\"below\\"\\n    }\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1263.31160810231,"y":1332.15656275044},{"class":"FRAGMENT","height":32,"id":1122,"name":"","properties":[{"name":"category","type":"string","value":"benchHorizontal"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"benchHorizontal"}],"rotation":0,"visible":true,"width":96,"x":1344,"y":1536},{"class":"FRAGMENT_POINT","height":0,"id":1124,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"benchHorizontal\\",\\n    \\"category\\": \\"benchHorizontal\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1357.94282346006,"y":1204.00058944887},{"class":"FRAGMENT_POINT","height":0,"id":1127,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"benchHorizontal\\",\\n    \\"category\\": \\"benchHorizontal\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1357.83760683761,"y":1235.21131741821},{"class":"FRAGMENT_POINT","height":0,"id":1128,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"benchHorizontal\\",\\n    \\"category\\": \\"benchHorizontal\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1357.83760683761,"y":1266.68552903036},{"class":"FRAGMENT_POINT","height":0,"id":1131,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"benchHorizontal\\",\\n    \\"category\\": \\"benchHorizontal\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1358.10079575597,"y":1298.21013852048},{"class":"FRAGMENT","height":96,"id":1132,"name":"","properties":[{"name":"category","type":"string","value":"wallFlagRed"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"wallFlagRed"}],"rotation":0,"visible":true,"width":32,"x":1472,"y":1504},{"class":"FRAGMENT_POINT","height":0,"id":1133,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"wallFlagRed\\",\\n    \\"category\\": \\"wallFlagRed\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1329.65517241379,"y":1141.6091954023},{"class":"FRAGMENT_POINT","height":0,"id":1135,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"wallFlagRed\\",\\n    \\"category\\": \\"wallFlagRed\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1361.57471264368,"y":1141.33333333333},{"class":"FRAGMENT_POINT","height":0,"id":1136,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"wallFlagRed\\",\\n    \\"category\\": \\"wallFlagRed\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1394.57471264368,"y":1141.33333333333},{"class":"FRAGMENT","height":64,"id":1137,"name":"","properties":[{"name":"category","type":"string","value":"diasHorizontal"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"diasHorizontal"}],"rotation":0,"visible":true,"width":64,"x":1184,"y":960},{"class":"FRAGMENT_POINT","height":0,"id":1138,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"diasHorizontal\\",\\n    \\"category\\": \\"diasHorizontal\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1291,"y":1173.5},{"class":"FRAGMENT","height":224,"id":1148,"name":"warlordSubCompound","properties":[{"name":"category","type":"string","value":"compound"},{"name":"context","type":"string","value":"{\\n  \\"locationIcon\\": \\"building.png\\",\\n  \\"initialMapFeature\\": true,\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"warlordSmall"}],"rotation":0,"visible":true,"width":224,"x":192,"y":1056},{"class":"FRAGMENT_POINT","height":0,"id":1149,"name":"warlord","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"warlord\\",\\n  \\"weapon\\": \\"axe\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":274.666666666667,"y":1178},{"class":"FRAGMENT_POINT","height":0,"id":1151,"name":"guard","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"warlordsCampaign\\": true,\\n  \\"type\\": \\"guard\\",\\n  \\"boundToWarlord\\": true,\\n  \\"weapon\\": \\"spear\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":304.5,"y":1205},{"class":"FRAGMENT_POINT","height":0,"id":1153,"name":"chestSpawner","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"chestSpawner\\": true\\n}"}],"rotation":0,"visible":true,"width":0,"x":305.253194510175,"y":1146.86859126045},{"class":"FRAGMENT_POINT","height":0,"id":1154,"name":"chestSpawner","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"chestSpawner\\": true\\n}"}],"rotation":0,"visible":true,"width":0,"x":913.206897916319,"y":1369.07351165162},{"class":"FRAGMENT_POINT","height":0,"id":1155,"name":"chestSpawner","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"chestSpawner\\": true\\n}"}],"rotation":0,"visible":true,"width":0,"x":1269.21932347981,"y":1238.46840591211},{"class":"FRAGMENT_POINT","height":0,"id":1156,"name":"door","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"type\\":\\"door\\", \\n  \\"direction\\":\\"Down\\",\\n  \\"accessRequires\\": \\"castlekey:3\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":1488,"y":916},{"class":"FRAGMENT_POINT","height":0,"id":1157,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"arch2\\",\\n    \\"category\\": \\"decoration\\",\\n    \\"subcategory\\": \\"building\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1487.5,"y":856.5},{"class":"FRAGMENT","height":64,"id":1158,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"context","type":"string","value":"{\\n   \\"renderZIdxOffset\\": 32\\n}"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"building"},{"name":"tag","type":"string","value":"arch2"}],"rotation":0,"visible":true,"width":32,"x":704,"y":1440},{"class":"FRAGMENT_POINT","height":0,"id":1160,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"arch3\\",\\n    \\"category\\": \\"decoration\\",\\n    \\"subcategory\\": \\"building\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":1454.93436293436,"y":762.208494208494},{"class":"FRAGMENT","height":64,"id":1162,"name":"","properties":[{"name":"category","type":"string","value":"decoration"},{"name":"context","type":"string","value":"{\\n   \\"renderZIdxOffset\\": 32\\n}"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"building"},{"name":"tag","type":"string","value":"arch3"}],"rotation":0,"visible":true,"width":32,"x":672,"y":1440},{"class":"mapSpriteCap","height":0,"id":1163,"name":"","point":true,"rotation":0,"visible":true,"width":0,"x":1413.98093508852,"y":851.112119836587},{"class":"FRAGMENT_POINT","height":0,"id":1164,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"table\\",\\n    \\"category\\": \\"decoration\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":367.221552129605,"y":84.9558165665011},{"class":"FRAGMENT_POINT","height":0,"id":1165,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"fragmentPointer\\": {\\n    \\"catalog\\": \\"settlement\\",\\n    \\"tag\\": \\"stool\\",\\n    \\"category\\": \\"decoration\\",\\n    \\"subcategory\\": \\"small\\",\\n    \\"renderStrategy\\": \\"sprite\\"\\n  }\\n}"}],"rotation":0,"visible":true,"width":0,"x":367.781552129605,"y":115.625816566501},{"class":"mapSpriteCap","height":0,"id":1169,"name":"","point":true,"rotation":0,"visible":true,"width":0,"x":75.9416767922236,"y":103.888213851762},{"class":"FRAGMENT","height":288,"id":1170,"name":"smallWoodenHouse","properties":[{"name":"category","type":"string","value":"house"},{"name":"context","type":"string","value":"{\\n  \\"noResourceSpawn\\": true\\n}"},{"name":"subcategory","type":"string","value":"small"}],"rotation":0,"visible":true,"width":224,"x":0,"y":224},{"class":"FRAGMENT","height":64,"id":1175,"name":"","properties":[{"name":"category","type":"string","value":"woodDoor"},{"name":"context","type":"string","value":"{\\n  \\"entityType\\": \\"door\\",\\n  \\"openFragment\\": \\"settlement:woodDoorSide\\",\\n  \\"closedFragment\\": \\"settlement:woodDoor\\",\\n  \\"clearPointsForLayers\\": [\\"sprite\\"]\\n}"},{"name":"craftableMeta","type":"string","value":"{\\n    \\"buildType\\": \\"entity\\",\\n    \\"entityType\\": \\"door\\",\\n    \\"fragmentPointer\\": {\\n        \\"catalog\\": \\"settlement\\",\\n        \\"tag\\": \\"woodDoor\\"\\n    },\\n    \\"itemType\\": \\"door-wood\\"\\n}\\n"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"woodDoor"}],"rotation":0,"visible":true,"width":32,"x":64,"y":864},{"class":"FRAGMENT_POINT","height":0,"id":1176,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"anchor\\": true\\n}"}],"rotation":0,"visible":true,"width":0,"x":79.656862745098,"y":908.90522875817},{"class":"FRAGMENT","height":64,"id":1179,"name":"","properties":[{"name":"category","type":"string","value":"window"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"window"}],"rotation":0,"visible":true,"width":32,"x":128,"y":864},{"class":"FRAGMENT_POINT","height":0,"id":1180,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"anchor\\": true,\\n  \\"occlusion\\": \\"remove\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":143.5,"y":915.5},{"class":"FRAGMENT_POINT","height":0,"id":1182,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"anchor\\": true,\\n  \\"blocking\\": \\"remove\\",\\n  \\"occlusion\\": \\"remove\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":115.292384601279,"y":908.862152016455},{"class":"FRAGMENT","height":64,"id":1184,"name":"","properties":[{"name":"category","type":"string","value":"woodDoorSide"},{"name":"context","type":"string","value":"{\\n  \\"entityType\\": \\"door\\",\\n  \\"clearPointsForLayers\\": [\\"sprite\\", \\"occlusion\\"]\\n}"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"woodDoorSide"}],"rotation":0,"visible":true,"width":32,"x":96,"y":864},{"class":"FRAGMENT","height":32,"id":1186,"name":"","properties":[{"name":"category","type":"string","value":"woodChest"},{"name":"context","type":"string","value":"{\\n  \\"entityType\\": \\"chest\\",\\n  \\"openFragment\\": \\"settlement:woodChestOpen\\",\\n  \\"closedFragment\\": \\"settlement:woodChest\\"\\n}"},{"name":"craftableMeta","type":"string","value":"{\\n    \\"buildType\\": \\"entity\\",\\n    \\"entityType\\": \\"chest\\",\\n    \\"fragmentPointer\\": {\\n        \\"catalog\\": \\"settlement\\",\\n        \\"tag\\": \\"woodChest\\"\\n    },\\n    \\"itemType\\": \\"chest-wood\\"\\n}\\n"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"woodChest"}],"rotation":0,"visible":true,"width":32,"x":64,"y":960},{"class":"FRAGMENT","height":32,"id":1187,"name":"","properties":[{"name":"category","type":"string","value":"woodChestOpen"},{"name":"context","type":"string","value":"{\\n  \\"entityType\\": \\"chest\\"\\n}"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"small"},{"name":"tag","type":"string","value":"woodChestOpen"}],"rotation":0,"visible":true,"width":32,"x":96,"y":960},{"class":"FRAGMENT_POINT","height":0,"id":1190,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"anchor\\": true,\\n  \\"occlusion\\": \\"remove\\",\\n  \\"blocking\\": \\"remove\\"\\n}"}],"rotation":0,"visible":true,"width":0,"x":80.2151019493614,"y":979.161998655613},{"class":"FRAGMENT_POINT","height":0,"id":1191,"name":"","point":true,"properties":[{"name":"context","type":"string","value":"{\\n  \\"anchor\\": true\\n}"}],"rotation":0,"visible":true,"width":0,"x":112.256329822989,"y":979.610127716782},{"class":"FRAGMENT","height":96,"id":1193,"name":"","properties":[{"name":"category","type":"string","value":"largeRoughTable"},{"name":"context","type":"string","value":"{\\n  \\"mustBeFreeAtLayers\\": [\\"sprite\\", \\"sprite2\\"]\\n}"},{"name":"craftableMeta","type":"string","value":"{\\n    \\"buildType\\": \\"entity\\",\\n    \\"fragmentPointer\\": {\\n        \\"catalog\\": \\"settlement\\",\\n        \\"tag\\": \\"largeRoughTable\\"\\n    },\\n    \\"itemType\\": \\"table-large-rough\\"\\n}\\n"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"largeRoughTable"}],"rotation":0,"visible":true,"width":96,"x":448,"y":896},{"class":"FRAGMENT","height":64,"id":1194,"name":"","properties":[{"name":"category","type":"string","value":"medRoundTable"},{"name":"context","type":"string","value":"{\\n  \\"mustBeFreeAtLayers\\": [\\"sprite\\", \\"sprite2\\"]\\n}"},{"name":"craftableMeta","type":"string","value":"{\\n    \\"buildType\\": \\"entity\\",\\n    \\"fragmentPointer\\": {\\n        \\"catalog\\": \\"settlement\\",\\n        \\"tag\\": \\"medRoundTable\\"\\n    },\\n    \\"itemType\\": \\"table-mid-round\\"\\n}\\n"},{"name":"renderStrategy","type":"string","value":"sprite"},{"name":"subcategory","type":"string","value":"medium"},{"name":"tag","type":"string","value":"medRoundTable"}],"rotation":0,"visible":true,"width":64,"x":576,"y":928}],"opacity":1,"type":"objectgroup","visible":true,"x":0,"y":0}],"nextlayerid":19,"nextobjectid":1197,"orientation":"orthogonal","renderorder":"right-down","tiledversion":"1.9.0","tileheight":32,"tilesets":[{"firstgid":1,"source":"../tilesets/lpc-terrain.tsx"},{"firstgid":1025,"source":"../tilesets/plants.tsx"},{"firstgid":1194,"source":"../tilesets/lpc-flowers-plants-fungi-wood.tsx"},{"firstgid":1706,"source":"../tilesets/mountains-v6.tsx"},{"firstgid":6826,"source":"../tilesets/ore.tsx"},{"firstgid":7082,"source":"../tilesets/jungle-ruins.tsx"},{"firstgid":8106,"source":"../tilesets/build_atlas.tsx"},{"firstgid":9130,"source":"../tilesets/decorations-medieval.tsx"},{"firstgid":10154,"source":"../tilesets/roofs.tsx"},{"firstgid":14250,"source":"../tilesets/cottage.tsx"},{"firstgid":14506,"source":"../tilesets/walls.tsx"},{"firstgid":20650,"source":"../tilesets/container.tsx"},{"firstgid":21674,"source":"../tilesets/fence_medieval.tsx"},{"firstgid":22186,"source":"../tilesets/furniture-blonde-wood.tsx"}],"tilewidth":32,"type":"map","version":"1.9","width":50}},"mapTilesets":{"authored-terrain":{"columns":32,"image":"../../media/authored-terrain-v2.png","imageheight":1024,"imagewidth":1024,"margin":0,"name":"authored-terrain","spacing":0,"tilecount":1024,"tiledversion":"1.9.0","tileheight":32,"tiles":[{"id":0,"properties":[{"name":"entityTileId","type":"string","value":"stairs-down"},{"name":"labItemType","type":"string","value":"stairs-down"}]},{"id":1,"properties":[{"name":"entityTileId","type":"string","value":"stairs-up"},{"name":"labItemType","type":"string","value":"stairs-up"}]},{"id":2,"properties":[{"name":"entityTileId","type":"string","value":"floor-opening"},{"name":"labItemType","type":"string","value":"floor-opening"}]},{"id":469,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":470,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":471,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":472,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":473,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":474,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":475,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":476,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":477,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":478,"properties":[{"name":"compositeTileId","type":"string","value":"grove-bush-a"}]},{"id":479,"properties":[{"name":"compositeTileId","type":"string","value":"grove-bush-a"}]},{"id":480,"properties":[{"name":"compositeTileIdParent","type":"string","value":"grove-shrub-a"},{"name":"castsShadow","type":"bool","value":true}]},{"id":481,"properties":[{"name":"compositeTileIdParent","type":"string","value":"grove-shrub-b"},{"name":"castsShadow","type":"bool","value":true}]},{"id":482,"properties":[{"name":"compositeTileIdParent","type":"string","value":"grove-shrub-c"},{"name":"castsShadow","type":"bool","value":true}]},{"id":483,"properties":[{"name":"compositeTileIdParent","type":"string","value":"meadow-tuft-a"},{"name":"renderZIdxOffset","type":"float","value":-4}]},{"id":484,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":485,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":486,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":487,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-a"}]},{"id":488,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-a"}]},{"id":489,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-a"}]},{"id":490,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-b"}]},{"id":491,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-b"}]},{"id":492,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-b"}]},{"id":493,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":494,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":495,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":496,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":497,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":498,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":499,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":500,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":501,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":502,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":503,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":504,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":505,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":506,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":507,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":508,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":509,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":510,"properties":[{"name":"compositeTileIdParent","type":"string","value":"grove-bush-a"},{"name":"castsShadow","type":"bool","value":true},{"name":"renderYOffset","type":"float","value":16}]},{"id":511,"properties":[{"name":"compositeTileId","type":"string","value":"grove-bush-a"}]},{"id":516,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":517,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":518,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":519,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-a"}]},{"id":520,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-a"}]},{"id":521,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-a"}]},{"id":522,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-b"}]},{"id":523,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-b"}]},{"id":524,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-b"}]},{"id":525,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":526,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":527,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":528,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":529,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":530,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":531,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":532,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":533,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":534,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":535,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":536,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":537,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":538,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":539,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":540,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":541,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":542,"properties":[{"name":"compositeTileId","type":"string","value":"grove-bush-b"}]},{"id":543,"properties":[{"name":"compositeTileId","type":"string","value":"grove-bush-b"}]},{"id":548,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":549,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":550,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":551,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-a"}]},{"id":552,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-a"}]},{"id":553,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-a"}]},{"id":554,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-b"}]},{"id":555,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-b"}]},{"id":556,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-b"}]},{"id":557,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":558,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":559,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":560,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":561,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":562,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":563,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":564,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":565,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":566,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":567,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":568,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":569,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":570,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":571,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":572,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":573,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":574,"properties":[{"name":"compositeTileIdParent","type":"string","value":"grove-bush-b"},{"name":"castsShadow","type":"bool","value":true},{"name":"renderYOffset","type":"float","value":16}]},{"id":575,"properties":[{"name":"compositeTileId","type":"string","value":"grove-bush-b"}]},{"id":578,"properties":[{"name":"compositeTileId","type":"string","value":"grove-bush-c"}]},{"id":579,"properties":[{"name":"compositeTileId","type":"string","value":"grove-bush-c"}]},{"id":580,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":581,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":582,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":583,"properties":[{"name":"entityTileId","type":"string","value":"grove-round-a"},{"name":"labItemType","type":"string","value":"grove-round-a"},{"name":"compositeTileIdParent","type":"string","value":"grove-round-a"},{"name":"castsShadow","type":"bool","value":true},{"name":"blocking","type":"bool","value":true},{"name":"malleable","type":"bool","value":true},{"name":"renderXOffset","type":"float","value":-8},{"name":"renderYOffset","type":"float","value":16},{"name":"blockingRects","type":"string","value":"[{\\"x\\":6,\\"y\\":10,\\"width\\":20,\\"height\\":9,\\"bodyInsetBottom\\":8}]"}]},{"id":584,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-a"}]},{"id":585,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-a"}]},{"id":586,"properties":[{"name":"entityTileId","type":"string","value":"grove-round-b"},{"name":"labItemType","type":"string","value":"grove-round-b"},{"name":"compositeTileIdParent","type":"string","value":"grove-round-b"},{"name":"castsShadow","type":"bool","value":true},{"name":"blocking","type":"bool","value":true},{"name":"malleable","type":"bool","value":true},{"name":"renderXOffset","type":"float","value":-8},{"name":"renderYOffset","type":"float","value":16},{"name":"blockingRects","type":"string","value":"[{\\"x\\":6,\\"y\\":10,\\"width\\":20,\\"height\\":9,\\"bodyInsetBottom\\":8}]"}]},{"id":587,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-b"}]},{"id":588,"properties":[{"name":"compositeTileId","type":"string","value":"grove-round-b"}]},{"id":589,"properties":[{"name":"entityTileId","type":"string","value":"grove-low-a"},{"name":"labItemType","type":"string","value":"grove-low-a"},{"name":"compositeTileIdParent","type":"string","value":"grove-low-a"},{"name":"castsShadow","type":"bool","value":true},{"name":"blocking","type":"bool","value":true},{"name":"malleable","type":"bool","value":true},{"name":"renderXOffset","type":"float","value":-16},{"name":"renderYOffset","type":"float","value":16},{"name":"blockingRects","type":"string","value":"[{\\"x\\":6,\\"y\\":10,\\"width\\":20,\\"height\\":9,\\"bodyInsetBottom\\":8}]"}]},{"id":590,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":591,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":592,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-a"}]},{"id":593,"properties":[{"name":"entityTileId","type":"string","value":"grove-low-b"},{"name":"labItemType","type":"string","value":"grove-low-b"},{"name":"compositeTileIdParent","type":"string","value":"grove-low-b"},{"name":"castsShadow","type":"bool","value":true},{"name":"blocking","type":"bool","value":true},{"name":"malleable","type":"bool","value":true},{"name":"renderXOffset","type":"float","value":-16},{"name":"renderYOffset","type":"float","value":16},{"name":"blockingRects","type":"string","value":"[{\\"x\\":6,\\"y\\":10,\\"width\\":20,\\"height\\":9,\\"bodyInsetBottom\\":8}]"}]},{"id":594,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":595,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":596,"properties":[{"name":"compositeTileId","type":"string","value":"grove-low-b"}]},{"id":597,"properties":[{"name":"entityTileId","type":"string","value":"grove-oak-a"},{"name":"labItemType","type":"string","value":"grove-oak-a"},{"name":"compositeTileIdParent","type":"string","value":"grove-oak-a"},{"name":"castsShadow","type":"bool","value":true},{"name":"blocking","type":"bool","value":true},{"name":"malleable","type":"bool","value":true},{"name":"renderXOffset","type":"float","value":-8},{"name":"renderYOffset","type":"float","value":16},{"name":"blockingRects","type":"string","value":"[{\\"x\\":6,\\"y\\":10,\\"width\\":20,\\"height\\":9,\\"bodyInsetBottom\\":8}]"}]},{"id":598,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":599,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-a"}]},{"id":600,"properties":[{"name":"entityTileId","type":"string","value":"grove-oak-b"},{"name":"labItemType","type":"string","value":"grove-oak-b"},{"name":"compositeTileIdParent","type":"string","value":"grove-oak-b"},{"name":"castsShadow","type":"bool","value":true},{"name":"blocking","type":"bool","value":true},{"name":"malleable","type":"bool","value":true},{"name":"renderXOffset","type":"float","value":-8},{"name":"renderYOffset","type":"float","value":16},{"name":"blockingRects","type":"string","value":"[{\\"x\\":6,\\"y\\":10,\\"width\\":20,\\"height\\":9,\\"bodyInsetBottom\\":8}]"}]},{"id":601,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":602,"properties":[{"name":"compositeTileId","type":"string","value":"grove-oak-b"}]},{"id":603,"properties":[{"name":"entityTileId","type":"string","value":"grove-spruce-a"},{"name":"labItemType","type":"string","value":"grove-spruce-a"},{"name":"compositeTileIdParent","type":"string","value":"grove-spruce-a"},{"name":"castsShadow","type":"bool","value":true},{"name":"blocking","type":"bool","value":true},{"name":"malleable","type":"bool","value":true},{"name":"renderXOffset","type":"float","value":-8},{"name":"renderYOffset","type":"float","value":16},{"name":"blockingRects","type":"string","value":"[{\\"x\\":6,\\"y\\":10,\\"width\\":20,\\"height\\":9,\\"bodyInsetBottom\\":8}]"}]},{"id":604,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":605,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-a"}]},{"id":606,"properties":[{"name":"compositeTileId","type":"string","value":"grove-bush-d"}]},{"id":607,"properties":[{"name":"compositeTileId","type":"string","value":"grove-bush-d"}]},{"id":608,"properties":[{"name":"compositeTileId","type":"string","value":"meadow-grass-a"}]},{"id":609,"properties":[{"name":"compositeTileId","type":"string","value":"meadow-grass-b"}]},{"id":610,"properties":[{"name":"compositeTileIdParent","type":"string","value":"grove-bush-c"},{"name":"castsShadow","type":"bool","value":true},{"name":"renderYOffset","type":"float","value":16}]},{"id":611,"properties":[{"name":"compositeTileId","type":"string","value":"grove-bush-c"}]},{"id":612,"properties":[{"name":"entityTileId","type":"string","value":"grove-spruce-b"},{"name":"labItemType","type":"string","value":"grove-spruce-b"},{"name":"compositeTileIdParent","type":"string","value":"grove-spruce-b"},{"name":"castsShadow","type":"bool","value":true},{"name":"blocking","type":"bool","value":true},{"name":"malleable","type":"bool","value":true},{"name":"renderXOffset","type":"float","value":-8},{"name":"renderYOffset","type":"float","value":16},{"name":"blockingRects","type":"string","value":"[{\\"x\\":6,\\"y\\":10,\\"width\\":20,\\"height\\":9,\\"bodyInsetBottom\\":8}]"}]},{"id":613,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":614,"properties":[{"name":"compositeTileId","type":"string","value":"grove-spruce-b"}]},{"id":615,"properties":[{"name":"compositeTileId","type":"string","value":"meadow-grass-c"}]},{"id":616,"properties":[{"name":"compositeTileId","type":"string","value":"meadow-grass-d"}]},{"id":617,"properties":[{"name":"compositeTileId","type":"string","value":"meadow-grass-e"}]},{"id":618,"properties":[{"name":"compositeTileId","type":"string","value":"meadow-grass-f"}]},{"id":619,"properties":[{"name":"compositeTileIdParent","type":"string","value":"meadow-tuft-b"},{"name":"renderZIdxOffset","type":"float","value":-4}]},{"id":620,"properties":[{"name":"compositeTileIdParent","type":"string","value":"meadow-tuft-c"},{"name":"renderZIdxOffset","type":"float","value":-4}]},{"id":621,"properties":[{"name":"compositeTileIdParent","type":"string","value":"meadow-tuft-d"},{"name":"renderZIdxOffset","type":"float","value":-4}]},{"id":622,"properties":[{"name":"compositeTileIdParent","type":"string","value":"meadow-tuft-e"},{"name":"renderZIdxOffset","type":"float","value":-4}]},{"id":623,"properties":[{"name":"entityTileId","type":"string","value":"meadow-sprout"},{"name":"labItemType","type":"string","value":"meadow-sprout"},{"name":"compositeTileIdParent","type":"string","value":"meadow-sprout"},{"name":"malleable","type":"bool","value":true},{"name":"renderZIdxOffset","type":"float","value":-4}]},{"id":624,"properties":[{"name":"compositeTileIdParent","type":"string","value":"dirt-sedge-a"},{"name":"renderZIdxOffset","type":"float","value":-4}]},{"id":625,"properties":[{"name":"compositeTileIdParent","type":"string","value":"dirt-sedge-b"},{"name":"renderZIdxOffset","type":"float","value":-4}]},{"id":626,"properties":[{"name":"compositeTileIdParent","type":"string","value":"dirt-sedge-c"},{"name":"renderZIdxOffset","type":"float","value":-4}]},{"id":627,"properties":[{"name":"compositeTileIdParent","type":"string","value":"dirt-herb-a"},{"name":"renderZIdxOffset","type":"float","value":-4}]},{"id":628,"properties":[{"name":"compositeTileIdParent","type":"string","value":"dirt-herb-b"},{"name":"renderZIdxOffset","type":"float","value":-4}]},{"id":629,"properties":[{"name":"compositeTileIdParent","type":"string","value":"dirt-herb-c"},{"name":"renderZIdxOffset","type":"float","value":-4}]},{"id":630,"properties":[{"name":"woodenWall","type":"int","value":9}]},{"id":631,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":632,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":633,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":634,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":635,"properties":[{"name":"woodenWall","type":"int","value":7}]},{"id":636,"properties":[{"name":"woodenWall","type":"int","value":10}]},{"id":637,"properties":[{"name":"woodenWall","type":"int","value":2}]},{"id":638,"properties":[{"name":"compositeTileIdParent","type":"string","value":"grove-bush-d"},{"name":"castsShadow","type":"bool","value":true},{"name":"renderYOffset","type":"float","value":16}]},{"id":639,"properties":[{"name":"compositeTileId","type":"string","value":"grove-bush-d"}]},{"id":640,"properties":[{"name":"entityTileId","type":"string","value":"meadow-grass-a"},{"name":"labItemType","type":"string","value":"meadow-grass-a"},{"name":"compositeTileIdParent","type":"string","value":"meadow-grass-a"},{"name":"densityStrategy","type":"string","value":"denseVertical"},{"name":"malleable","type":"bool","value":true},{"name":"renderZIdxOffset","type":"float","value":-4},{"name":"denseCopies","type":"float","value":1}]},{"id":641,"properties":[{"name":"entityTileId","type":"string","value":"meadow-grass-b"},{"name":"labItemType","type":"string","value":"meadow-grass-b"},{"name":"compositeTileIdParent","type":"string","value":"meadow-grass-b"},{"name":"densityStrategy","type":"string","value":"denseVertical"},{"name":"malleable","type":"bool","value":true},{"name":"renderZIdxOffset","type":"float","value":-4},{"name":"denseCopies","type":"float","value":1}]},{"id":642,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":643,"properties":[{"name":"woodenWall","type":"int","value":3}]},{"id":644,"properties":[{"name":"woodenWall","type":"int","value":8}]},{"id":645,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":646,"properties":[{"name":"woodenWall","type":"int","value":0}]},{"id":647,"properties":[{"name":"entityTileId","type":"string","value":"meadow-grass-c"},{"name":"labItemType","type":"string","value":"meadow-grass-c"},{"name":"compositeTileIdParent","type":"string","value":"meadow-grass-c"},{"name":"densityStrategy","type":"string","value":"denseVertical"},{"name":"malleable","type":"bool","value":true},{"name":"renderZIdxOffset","type":"float","value":-4},{"name":"denseCopies","type":"float","value":1}]},{"id":648,"properties":[{"name":"entityTileId","type":"string","value":"meadow-grass-d"},{"name":"labItemType","type":"string","value":"meadow-grass-d"},{"name":"compositeTileIdParent","type":"string","value":"meadow-grass-d"},{"name":"densityStrategy","type":"string","value":"denseVertical"},{"name":"malleable","type":"bool","value":true},{"name":"renderZIdxOffset","type":"float","value":-4},{"name":"denseCopies","type":"float","value":1}]},{"id":649,"properties":[{"name":"entityTileId","type":"string","value":"meadow-grass-e"},{"name":"labItemType","type":"string","value":"meadow-grass-e"},{"name":"compositeTileIdParent","type":"string","value":"meadow-grass-e"},{"name":"densityStrategy","type":"string","value":"denseVertical"},{"name":"malleable","type":"bool","value":true},{"name":"renderZIdxOffset","type":"float","value":-4},{"name":"denseCopies","type":"float","value":1}]},{"id":650,"properties":[{"name":"entityTileId","type":"string","value":"meadow-grass-f"},{"name":"labItemType","type":"string","value":"meadow-grass-f"},{"name":"compositeTileIdParent","type":"string","value":"meadow-grass-f"},{"name":"densityStrategy","type":"string","value":"denseVertical"},{"name":"malleable","type":"bool","value":true},{"name":"renderZIdxOffset","type":"float","value":-4},{"name":"denseCopies","type":"float","value":1}]},{"id":651,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":652,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":653,"properties":[{"name":"woodenWall","type":"int","value":11}]},{"id":654,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":655,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":656,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":657,"properties":[{"name":"woodenWall","type":"int","value":5}]},{"id":658,"properties":[{"name":"woodenWall","type":"int","value":12}]},{"id":659,"properties":[{"name":"woodenWall","type":"int","value":6}]},{"id":660,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":661,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":662,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":663,"properties":[{"name":"woodenWall","type":"int","value":4}]},{"id":664,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":665,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":666,"properties":[{"name":"woodenWall","type":"int","value":9}]},{"id":667,"properties":[{"name":"woodenWall","type":"int","value":10}]},{"id":668,"properties":[{"name":"woodenWall","type":"int","value":2}]},{"id":669,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":670,"properties":[{"name":"woodenWall","type":"int","value":3}]},{"id":671,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":672,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":673,"properties":[{"name":"woodenWall","type":"int","value":11}]},{"id":674,"properties":[{"name":"woodenWall","type":"int","value":5}]},{"id":675,"properties":[{"name":"woodenWall","type":"int","value":12}]},{"id":676,"properties":[{"name":"woodenWall","type":"int","value":6}]},{"id":677,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":678,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":679,"properties":[{"name":"woodenWall","type":"int","value":4}]},{"id":680,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":681,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":682,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":683,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":684,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":685,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":686,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":687,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":688,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":689,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":690,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":691,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":692,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":693,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":694,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":695,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":696,"properties":[{"name":"woodenWall","type":"int","value":8}]},{"id":697,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":698,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":699,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":700,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":701,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":702,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":703,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":704,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":705,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":706,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":707,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":708,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":709,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":710,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":711,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":712,"properties":[{"name":"woodenWall","type":"int","value":7}]},{"id":713,"properties":[{"name":"woodenWall","type":"int","value":0}]},{"id":714,"properties":[{"name":"woodenWall","type":"int","value":9}]},{"id":715,"properties":[{"name":"woodenWall","type":"int","value":10}]},{"id":716,"properties":[{"name":"woodenWall","type":"int","value":2}]},{"id":717,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":718,"properties":[{"name":"woodenWall","type":"int","value":3}]},{"id":719,"properties":[{"name":"woodenWall","type":"int","value":11}]},{"id":720,"properties":[{"name":"woodenWall","type":"int","value":5}]},{"id":721,"properties":[{"name":"woodenWall","type":"int","value":12}]},{"id":722,"properties":[{"name":"woodenWall","type":"int","value":6}]},{"id":723,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":724,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":725,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":726,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":727,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":728,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":729,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":730,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":731,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":732,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":733,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":734,"properties":[{"name":"woodenWall","type":"int","value":1}]}],"tilewidth":32,"type":"tileset","version":1.9},"beach-desert":{"columns":32,"image":"../../media/beach-desert.png","imageheight":1024,"imagewidth":1024,"margin":0,"name":"beach-desert","spacing":0,"tilecount":1024,"tiledversion":"1.9.0","tileheight":32,"tiles":[{"id":256,"properties":[{"name":"compositeTileId","type":"string","value":"palm1"}]},{"id":257,"properties":[{"name":"compositeTileId","type":"string","value":"palm1"}]},{"id":258,"properties":[{"name":"compositeTileId","type":"string","value":"palm1"}]},{"id":259,"properties":[{"name":"compositeTileId","type":"string","value":"palm2"}]},{"id":260,"properties":[{"name":"compositeTileId","type":"string","value":"palm2"}]},{"id":261,"properties":[{"name":"compositeTileId","type":"string","value":"palm2"}]},{"id":262,"properties":[{"name":"compositeTileId","type":"string","value":"palm3"}]},{"id":263,"properties":[{"name":"compositeTileId","type":"string","value":"palm3"}]},{"id":264,"properties":[{"name":"compositeTileId","type":"string","value":"palm3"}]},{"id":265,"properties":[{"name":"compositeTileId","type":"string","value":"palm4"}]},{"id":266,"properties":[{"name":"compositeTileId","type":"string","value":"palm4"}]},{"id":267,"properties":[{"name":"compositeTileId","type":"string","value":"palm4"}]},{"id":268,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":269,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":270,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":271,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":272,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":273,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":288,"properties":[{"name":"compositeTileId","type":"string","value":"palm1"}]},{"id":289,"properties":[{"name":"compositeTileId","type":"string","value":"palm1"}]},{"id":290,"properties":[{"name":"compositeTileId","type":"string","value":"palm1"}]},{"id":291,"properties":[{"name":"compositeTileId","type":"string","value":"palm2"}]},{"id":292,"properties":[{"name":"compositeTileId","type":"string","value":"palm2"}]},{"id":293,"properties":[{"name":"compositeTileId","type":"string","value":"palm2"}]},{"id":294,"properties":[{"name":"compositeTileId","type":"string","value":"palm3"}]},{"id":295,"properties":[{"name":"compositeTileId","type":"string","value":"palm3"}]},{"id":296,"properties":[{"name":"compositeTileId","type":"string","value":"palm3"}]},{"id":297,"properties":[{"name":"compositeTileId","type":"string","value":"palm4"}]},{"id":298,"properties":[{"name":"compositeTileId","type":"string","value":"palm4"}]},{"id":299,"properties":[{"name":"compositeTileId","type":"string","value":"palm4"}]},{"id":300,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":301,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":302,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":303,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":304,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":305,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":321,"properties":[{"name":"compositeTileId","type":"string","value":"palm1"}]},{"id":324,"properties":[{"name":"compositeTileId","type":"string","value":"palm2"}]},{"id":326,"properties":[{"name":"compositeTileId","type":"string","value":"palm3"}]},{"id":327,"properties":[{"name":"compositeTileId","type":"string","value":"palm3"}]},{"id":328,"properties":[{"name":"compositeTileId","type":"string","value":"palm3"}]},{"id":329,"properties":[{"name":"compositeTileId","type":"string","value":"palm4"}]},{"id":330,"properties":[{"name":"compositeTileId","type":"string","value":"palm4"}]},{"id":331,"properties":[{"name":"compositeTileId","type":"string","value":"palm4"}]},{"id":332,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":333,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":334,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":335,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":336,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":337,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":352,"properties":[{"name":"compositeTileId","type":"string","value":"palm1"}]},{"id":353,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"palm1"},{"name":"entityTileId","type":"string","value":"palmTree1"},{"name":"malleable","type":"bool","value":true},{"name":"renderYOffset","type":"int","value":25}]},{"id":354,"properties":[{"name":"compositeTileId","type":"string","value":"palm1"}]},{"id":356,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"palm2"},{"name":"entityTileId","type":"string","value":"palmTree2"},{"name":"renderYOffset","type":"int","value":25}]},{"id":358,"properties":[{"name":"compositeTileId","type":"string","value":"palm3"}]},{"id":359,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"palm3"},{"name":"entityTileId","type":"string","value":"palmTree3"},{"name":"malleable","type":"bool","value":true},{"name":"renderYOffset","type":"int","value":25}]},{"id":360,"properties":[{"name":"compositeTileId","type":"string","value":"palm3"}]},{"id":361,"properties":[{"name":"compositeTileId","type":"string","value":"palm4"}]},{"id":362,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"palm4"},{"name":"entityTileId","type":"string","value":"palmTree4"},{"name":"malleable","type":"bool","value":true},{"name":"renderYOffset","type":"int","value":25}]},{"id":363,"properties":[{"name":"compositeTileId","type":"string","value":"palm4"}]},{"id":364,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":365,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":366,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":367,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":368,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":369,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":396,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":397,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"},{"name":"entityTileId","type":"string","value":"palmTree5"},{"name":"malleable","type":"bool","value":true}]},{"id":398,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":399,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":400,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"},{"name":"entityTileId","type":"string","value":"palmTree6"},{"name":"malleable","type":"bool","value":true}]},{"id":401,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":428,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":429,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"palm5"},{"name":"renderYOffset","type":"int","value":25}]},{"id":430,"properties":[{"name":"compositeTileId","type":"string","value":"palm5"}]},{"id":431,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]},{"id":432,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"palm6"},{"name":"renderYOffset","type":"int","value":25}]},{"id":433,"properties":[{"name":"compositeTileId","type":"string","value":"palm6"}]}],"tilewidth":32,"type":"tileset","version":1.9},"bonecaller-stones":{"columns":32,"image":"../../media/lpc-terrain.png","imageheight":1024,"imagewidth":1024,"margin":0,"name":"bonecaller-stones","spacing":0,"tilecount":1024,"tileheight":32,"tiles":[{"id":0,"properties":[{"name":"compositeTileIdParent","type":"string","value":"bonecaller-stone"},{"name":"entityTileId","type":"string","value":"bonecaller-stone"}]}],"tilewidth":32,"type":"tileset","version":"1.8"},"build_atlas":{"columns":32,"image":"../../media/build_atlas.png","imageheight":1024,"imagewidth":1024,"margin":0,"name":"build_atlas","spacing":0,"tilecount":1024,"tiledversion":"1.9.0","tileheight":32,"tiles":[{"id":153,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":154,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":155,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":156,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":157,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":186,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":188,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":216,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":217,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":218,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":219,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":220,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":221,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":222,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":248,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":249,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":250,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":251,"properties":[{"name":"compositeTileIdParent","type":"string","value":"fancyGate"}]},{"id":252,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":253,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":254,"properties":[{"name":"compositeTileId","type":"string","value":"fancyGate"}]},{"id":283,"properties":[{"name":"compositeTileId","type":"string","value":"lionStatue"}]},{"id":284,"properties":[{"name":"compositeTileId","type":"string","value":"lionStatue"}]},{"id":285,"properties":[{"name":"compositeTileId","type":"string","value":"barrel1"}]},{"id":315,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"lionStatue"}]},{"id":316,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"lionStatue"}]},{"id":317,"properties":[{"name":"compositeTileIdParent","type":"string","value":"barrel1"}]},{"id":347,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"lionStatue"}]},{"id":348,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"lionStatue"}]},{"id":526,"properties":[{"name":"compositeTileId","type":"string","value":"tent"}]},{"id":527,"properties":[{"name":"compositeTileId","type":"string","value":"tent"}]},{"id":557,"properties":[{"name":"compositeTileId","type":"string","value":"tent"}]},{"id":558,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"tent"}]},{"id":559,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"tent"}]},{"id":560,"properties":[{"name":"compositeTileId","type":"string","value":"tent"}]},{"id":589,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":590,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":591,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":592,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":621,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":622,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":623,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":624,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":653,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":656,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":687,"properties":[{"name":"renderZIdxOffset","type":"int","value":-12}]},{"id":688,"properties":[{"name":"compositeTileIdParent","type":"string","value":"chestOpen"}]},{"id":783,"properties":[{"name":"renderZIdxOffset","type":"int","value":-12}]}],"tilewidth":32,"type":"tileset","version":1.9},"container":{"columns":16,"image":"../../media/container.png","imageheight":2048,"imagewidth":512,"margin":0,"name":"container","spacing":0,"tilecount":1024,"tiledversion":"1.9.0","tileheight":32,"tilewidth":32,"type":"tileset","version":1.9},"cottage":{"columns":16,"image":"../../media/cottage.png","imageheight":512,"imagewidth":512,"margin":0,"name":"cottage","spacing":0,"tilecount":256,"tiledversion":"1.9.0","tileheight":32,"tilewidth":32,"type":"tileset","version":1.9},"decorations-medieval":{"columns":16,"image":"../../media/decorations-medieval.png","imageheight":2048,"imagewidth":512,"margin":0,"name":"decorations-medieval","spacing":0,"tilecount":1024,"tiledversion":"1.9.0","tileheight":32,"tilewidth":32,"type":"tileset","version":1.9},"fence_medieval":{"columns":16,"image":"../../media/fence_medieval.png","imageheight":1024,"imagewidth":512,"margin":0,"name":"fence_medieval","spacing":0,"tilecount":512,"tiledversion":"1.9.0","tileheight":32,"tiles":[{"id":396,"properties":[{"name":"woodenWall","type":"int","value":9}]},{"id":408,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":409,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":410,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":411,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":412,"properties":[{"name":"woodenWall","type":"int","value":7}]},{"id":424,"properties":[{"name":"woodenWall","type":"int","value":10}]},{"id":425,"properties":[{"name":"woodenWall","type":"int","value":2}]},{"id":426,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":427,"properties":[{"name":"woodenWall","type":"int","value":3}]},{"id":431,"properties":[{"name":"woodenWall","type":"int","value":8}]},{"id":440,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":441,"properties":[{"name":"woodenWall","type":"int","value":0}]},{"id":444,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":445,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":456,"properties":[{"name":"woodenWall","type":"int","value":11}]},{"id":457,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":458,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":459,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":473,"properties":[{"name":"woodenWall","type":"int","value":5}]},{"id":474,"properties":[{"name":"woodenWall","type":"int","value":12}]},{"id":475,"properties":[{"name":"woodenWall","type":"int","value":6}]},{"id":490,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":492,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":493,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":495,"properties":[{"name":"woodenWall","type":"int","value":4}]},{"id":506,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":508,"properties":[{"name":"woodenWall","type":"int","value":13}]}],"tilewidth":32,"type":"tileset","version":1.9},"floors":{"columns":32,"image":"../../media/floors.png","imageheight":1024,"imagewidth":1024,"margin":0,"name":"floors","spacing":0,"tilecount":1024,"tiledversion":"1.9.0","tileheight":32,"tiles":[{"id":0,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":1,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":2,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":3,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":4,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":5,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":6,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":7,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":8,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":9,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":10,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":12,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":13,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":14,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":15,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":16,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":17,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":32,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":33,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":34,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":35,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":36,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":37,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":38,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":39,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":40,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":41,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":42,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":64,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":65,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":66,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":67,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":68,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":69,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":70,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":71,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":72,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":73,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":74,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":96,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":97,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":98,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":99,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":100,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":101,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":102,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":103,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":104,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":105,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":106,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":108,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":109,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":110,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":111,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":112,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":113,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":128,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":129,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":130,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":131,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":132,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":133,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":134,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":135,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":136,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":137,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":138,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":160,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":161,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":162,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":163,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":164,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":165,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":166,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":167,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":168,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":169,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":170,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":192,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":193,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":194,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":195,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":196,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":197,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":198,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":199,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":200,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":201,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":202,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":204,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":205,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":206,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":207,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":208,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":209,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":224,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":225,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":226,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":227,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":228,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":229,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":230,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":231,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":232,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":233,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":234,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":256,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":257,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":258,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":259,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":260,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":261,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":262,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":263,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":264,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":265,"properties":[{"name":"floor","type":"bool","value":true}]},{"id":266,"properties":[{"name":"floor","type":"bool","value":true}]}],"tilewidth":32,"type":"tileset","version":1.9},"forest-dirt":{"columns":32,"image":"../../media/forest-dirt.png","imageheight":3808,"imagewidth":1024,"margin":0,"name":"forest-dirt","spacing":0,"tilecount":3796,"tiledversion":"1.9.0","tileheight":32,"tilewidth":32,"type":"tileset","version":1.9},"forest-grass":{"columns":32,"image":"../../media/forest-grass.png","imageheight":4096,"imagewidth":1024,"margin":0,"name":"forest-grass","spacing":0,"tilecount":4096,"tiledversion":"1.9.0","tileheight":32,"tilewidth":32,"type":"tileset","version":1.9},"furniture-blonde-wood":{"columns":16,"image":"../../media/furniture-blonde-wood.png","imageheight":1024,"imagewidth":512,"margin":0,"name":"furniture-blonde-wood","spacing":0,"tilecount":512,"tiledversion":"1.9.0","tileheight":32,"tilewidth":32,"type":"tileset","version":1.9},"jungle-ruins":{"columns":32,"image":"../../media/jungle-ruins.png","imageheight":1024,"imagewidth":1024,"margin":0,"name":"jungle-ruins","spacing":0,"tilecount":1024,"tiledversion":"1.9.0","tileheight":32,"tilewidth":32,"type":"tileset","version":1.9},"lpc-flowers-plants-fungi-wood":{"columns":16,"image":"../../media/lpc-flowers-plants-fungi-wood.png","imageheight":1024,"imagewidth":512,"margin":0,"name":"lpc-flowers-plants-fungi-wood","spacing":0,"tilecount":512,"tiledversion":"1.9.0","tileheight":32,"tiles":[{"id":69,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":85,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":100,"properties":[{"name":"compositeTileIdParent","type":"string","value":""},{"name":"densityStrategy","type":"string","value":""},{"name":"entityTileId","type":"string","value":""},{"name":"malleable","type":"bool","value":false}]},{"id":101,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":102,"properties":[{"name":"renderZIdxOffset","type":"int","value":-16}]},{"id":103,"properties":[{"name":"renderZIdxOffset","type":"int","value":-16}]},{"id":104,"properties":[{"name":"renderZIdxOffset","type":"int","value":-16}]},{"id":105,"properties":[{"name":"renderZIdxOffset","type":"int","value":-16}]},{"id":116,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":117,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":130,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":131,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":144,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":145,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":146,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":147,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":149,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":154,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":155,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":157,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":160,"properties":[{"name":"compositeTileIdParent","type":"string","value":"altGrass1"},{"name":"renderZIdxOffset","type":"int","value":-4}]},{"id":161,"properties":[{"name":"compositeTileIdParent","type":"string","value":"shortGrassTuft2"},{"name":"renderZIdxOffset","type":"int","value":-4}]},{"id":162,"properties":[{"name":"compositeTileIdParent","type":"string","value":"altGrass3"},{"name":"renderZIdxOffset","type":"int","value":-4}]},{"id":170,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":177,"properties":[{"name":"compositeTileIdParent","type":"string","value":"altGrass5"},{"name":"renderZIdxOffset","type":"int","value":-4}]},{"id":178,"properties":[{"name":"compositeTileIdParent","type":"string","value":"altGrass4"},{"name":"renderZIdxOffset","type":"int","value":-4}]},{"id":179,"properties":[{"name":"compositeTileIdParent","type":"string","value":"grassSprout"},{"name":"entityTileId","type":"string","value":"grassSprout"},{"name":"malleable","type":"bool","value":true},{"name":"renderZIdxOffset","type":"int","value":-4}]},{"id":186,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":188,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":202,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":203,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":204,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":205,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":206,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":209,"properties":[{"name":"compositeTileId","type":"string","value":"cattails1"}]},{"id":211,"properties":[{"name":"compositeTileId","type":"string","value":"tallGrass"}]},{"id":218,"properties":[{"name":"compositeTileIdParent","type":"string","value":"testgrass2"}]},{"id":219,"properties":[{"name":"compositeTileDense","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"testgrass"},{"name":"renderZIdxOffset","type":"int","value":-12},{"name":"variant","type":"string","value":"noisy"}]},{"id":220,"properties":[{"name":"compositeTileIdParent","type":"string","value":"altGrass2"}]},{"id":225,"properties":[{"name":"compositeTileIdParent","type":"string","value":"cattails1"}]},{"id":227,"properties":[{"name":"compositeTileIdParent","type":"string","value":"tallGrass"},{"name":"densityStrategy","type":"string","value":"denseVertical"},{"name":"entityTileId","type":"string","value":"tallGrass"},{"name":"malleable","type":"bool","value":true},{"name":"renderZIdxOffset","type":"int","value":-4}]},{"id":228,"properties":[{"name":"compositeTileIdParent","type":"string","value":"reedsShort"}]},{"id":229,"properties":[{"name":"compositeTileId","type":"string","value":"tallReeds"}]},{"id":245,"properties":[{"name":"compositeTileIdParent","type":"string","value":"tallReeds"},{"name":"densityStrategy","type":"string","value":"denseVertical"},{"name":"entityTileId","type":"string","value":"tallReeds"},{"name":"malleable","type":"bool","value":true},{"name":"renderZIdxOffset","type":"int","value":-4}]},{"id":278,"properties":[{"name":"compositeTileId","type":"string","value":"tallVine"}]},{"id":279,"properties":[{"name":"compositeTileId","type":"string","value":"tallVine"}]},{"id":280,"properties":[{"name":"compositeTileId","type":"string","value":"tallVine"}]},{"id":294,"properties":[{"name":"compositeTileId","type":"string","value":"tallVine"}]},{"id":295,"properties":[{"name":"compositeTileId","type":"string","value":"tallVine"}]},{"id":296,"properties":[{"name":"compositeTileId","type":"string","value":"tallVine"}]},{"id":310,"properties":[{"name":"compositeTileIdParent","type":"string","value":"tallVine"}]},{"id":323,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":324,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":325,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":339,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":340,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":341,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":352,"properties":[{"name":"renderZIdxOffset","type":"int","value":-12}]},{"id":353,"properties":[{"name":"renderZIdxOffset","type":"int","value":-12}]},{"id":354,"properties":[{"name":"renderZIdxOffset","type":"int","value":-12}]},{"id":355,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":356,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":357,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":360,"properties":[{"name":"compositeTileId","type":"string","value":"bush2"}]},{"id":361,"properties":[{"name":"compositeTileId","type":"string","value":"bush2"}]},{"id":364,"properties":[{"name":"compositeTileId","type":"string","value":"deadBush"}]},{"id":365,"properties":[{"name":"compositeTileId","type":"string","value":"deadBush"}]},{"id":366,"properties":[{"name":"compositeTileId","type":"string","value":"deadTree1"}]},{"id":367,"properties":[{"name":"compositeTileId","type":"string","value":"deadTree2"}]},{"id":368,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":369,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":370,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":371,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":372,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":373,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":376,"properties":[{"name":"compositeTileIdParent","type":"string","value":"bush2"},{"name":"renderYOffset","type":"int","value":16}]},{"id":377,"properties":[{"name":"compositeTileId","type":"string","value":"bush2"}]},{"id":380,"properties":[{"name":"compositeTileIdParent","type":"string","value":"deadBush"},{"name":"renderYOffset","type":"int","value":16}]},{"id":381,"properties":[{"name":"compositeTileId","type":"string","value":"deadBush"}]},{"id":382,"properties":[{"name":"compositeTileIdParent","type":"string","value":"deadTree1"}]},{"id":383,"properties":[{"name":"compositeTileIdParent","type":"string","value":"deadTree2"}]},{"id":384,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":385,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":388,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":389,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":392,"properties":[{"name":"compositeTileId","type":"string","value":"bush1"}]},{"id":393,"properties":[{"name":"compositeTileId","type":"string","value":"bush1"}]},{"id":396,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":397,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":400,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":408,"properties":[{"name":"compositeTileIdParent","type":"string","value":"bush1"},{"name":"renderYOffset","type":"int","value":16}]},{"id":409,"properties":[{"name":"compositeTileId","type":"string","value":"bush1"}]},{"id":412,"properties":[{"name":"compositeTileIdParent","type":"string","value":"smallBush"}]},{"id":416,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":420,"properties":[{"name":"compositeTileIdParent","type":"string","value":"sapling"},{"name":"entityTileId","type":"string","value":"sapling"},{"name":"malleable","type":"bool","value":true}]},{"id":421,"properties":[{"name":"compositeTileIdParent","type":"string","value":"groundLog"},{"name":"renderZIdxOffset","type":"int","value":-6}]},{"id":422,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":427,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":429,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":430,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":431,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":432,"properties":[{"name":"compositeTileId","type":"string","value":"bigLog"}]},{"id":433,"properties":[{"name":"compositeTileId","type":"string","value":"bigLog"}]},{"id":434,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"bigLog"}]},{"id":435,"properties":[{"name":"compositeTileId","type":"string","value":"bigLog"}]},{"id":436,"properties":[{"name":"compositeTileIdParent","type":"string","value":"twig3"}]},{"id":437,"properties":[{"name":"compositeTileId","type":"string","value":"twig3"}]},{"id":438,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":443,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":444,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":445,"properties":[{"name":"compositeTileIdParent","type":"string","value":"smallBush3"}]},{"id":446,"properties":[{"name":"compositeTileIdParent","type":"string","value":"smallBush4"}]},{"id":447,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":448,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"bigLog"},{"name":"entityTileId","type":"string","value":""},{"name":"malleable","type":"bool","value":false}]},{"id":449,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"bigLog"}]},{"id":450,"properties":[{"name":"compositeTileId","type":"string","value":"bigLog"}]},{"id":451,"properties":[{"name":"compositeTileIdParent","type":"string","value":"twig1"}]},{"id":452,"properties":[{"name":"compositeTileIdParent","type":"string","value":"twig2"}]},{"id":453,"properties":[{"name":"compositeTileId","type":"string","value":"twig2"}]},{"id":464,"properties":[{"name":"compositeTileId","type":"string","value":"bigLog"}]},{"id":465,"properties":[{"name":"compositeTileId","type":"string","value":"bigLog"}]},{"id":466,"properties":[{"name":"compositeTileId","type":"string","value":"bigLog2"}]},{"id":467,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"bigLog2"}]},{"id":468,"properties":[{"name":"compositeTileId","type":"string","value":"bigLog2"}]},{"id":472,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":473,"properties":[{"name":"compositeTileIdParent","type":"string","value":"smallBush3"}]},{"id":475,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":476,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":478,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":479,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":487,"properties":[{"name":"compositeTileId","type":"string","value":"smallTree1"}]},{"id":488,"properties":[{"name":"compositeTileId","type":"string","value":"smallTree2"}]},{"id":489,"properties":[{"name":"compositeTileId","type":"string","value":"tree2Small"}]},{"id":494,"properties":[{"name":"compositeTileId","type":"string","value":"tree1Small"}]},{"id":503,"properties":[{"name":"compositeTileIdParent","type":"string","value":"smallTree1"}]},{"id":504,"properties":[{"name":"compositeTileIdParent","type":"string","value":"smallTree2"}]},{"id":505,"properties":[{"name":"compositeTileIdParent","type":"string","value":"tree2Small"},{"name":"entityTileId","type":"string","value":"tree2Small"},{"name":"malleable","type":"bool","value":true}]},{"id":510,"properties":[{"name":"compositeTileIdParent","type":"string","value":"tree1Small"},{"name":"entityTileId","type":"string","value":"tree1Small"},{"name":"malleable","type":"bool","value":true}]}],"tilewidth":32,"type":"tileset","version":1.9},"lpc-terrain":{"columns":32,"image":"../../media/lpc-terrain.png","imageheight":1024,"imagewidth":1024,"margin":0,"name":"lpc-terrain","spacing":0,"tilecount":1024,"tiledversion":"1.9.0","tileheight":32,"tiles":[{"id":121,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":124,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":227,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":440,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":441,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":442,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":472,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":473,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":474,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":478,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":481,"properties":[{"name":"deep","type":"bool","value":true}]},{"id":509,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"renderYOffset","type":"int","value":-16}]},{"id":544,"properties":[{"name":"deep","type":"bool","value":true}]},{"id":545,"properties":[{"name":"deep","type":"bool","value":true}]},{"id":546,"properties":[{"name":"deep","type":"bool","value":true}]},{"id":574,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":575,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":590,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":591,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":592,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":594,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":595,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":596,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"entityTileId","type":"string","value":"generic_marker"},{"name":"malleable","type":"bool","value":true}]},{"id":606,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":622,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":623,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":624,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":626,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":627,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":632,"properties":[{"name":"compositeTileId","type":"string","value":"boulder1"}]},{"id":633,"properties":[{"name":"compositeTileId","type":"string","value":"boulder1"}]},{"id":634,"properties":[{"name":"compositeTileId","type":"string","value":"boulder2"}]},{"id":635,"properties":[{"name":"compositeTileId","type":"string","value":"boulder2"}]},{"id":636,"properties":[{"name":"compositeTileId","type":"string","value":"boulder3"}]},{"id":639,"properties":[{"name":"compositeTileIdParent","type":"string","value":""}]},{"id":651,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":654,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":655,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":656,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":658,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":659,"properties":[{"name":"lava","type":"bool","value":true}]},{"id":664,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"boulder1"}]},{"id":665,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"boulder1"}]},{"id":666,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"boulder2"}]},{"id":667,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"boulder2"}]},{"id":668,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"boulder3"}]},{"id":696,"properties":[{"name":"compositeTileId","type":"string","value":"boulder4"}]},{"id":697,"properties":[{"name":"compositeTileId","type":"string","value":"boulder4"}]},{"id":698,"properties":[{"name":"compositeTileId","type":"string","value":"boulder5"}]},{"id":699,"properties":[{"name":"compositeTileId","type":"string","value":"boulder5"}]},{"id":728,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"boulder4"}]},{"id":729,"properties":[{"name":"compositeTileId","type":"string","value":"boulder4"}]},{"id":730,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"boulder5"}]},{"id":731,"properties":[{"name":"compositeTileId","type":"string","value":"boulder5"}]},{"id":732,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":758,"properties":[{"name":"compositeTileId","type":"string","value":"campfire"}]},{"id":759,"properties":[{"name":"compositeTileIdParent","type":"string","value":"campfire"},{"name":"entityTileId","type":"string","value":"campfire"},{"name":"renderZIdxOffset","type":"int","value":-16}]},{"id":760,"properties":[{"name":"compositeTileId","type":"string","value":"campfire"}]},{"id":793,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":813,"properties":[{"name":"compositeTileDense","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"shrub"}]},{"id":815,"properties":[{"name":"compositeTileDense","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"corn"},{"name":"spriteId","type":"string","value":"corn.png"}]}],"tilewidth":32,"type":"tileset","version":1.9},"map-atlas":{"columns":7,"image":"../../media/map-atlas.png","imageheight":672,"imagewidth":239,"margin":0,"name":"map-atlas","spacing":0,"tilecount":147,"tiledversion":"1.9.0","tileheight":32,"tiles":[{"id":0,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":1,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":2,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":3,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":4,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":5,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":6,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":7,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":9,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":10,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":11,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":12,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":13,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":14,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":17,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":18,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":19,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":21,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":22,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":23,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":24,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":25,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":26,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":27,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":28,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":29,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":30,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":31,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":32,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":33,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":34,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":35,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":36,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":37,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":38,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":39,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":40,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":41,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":42,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":43,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":44,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":45,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":46,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":47,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":48,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":49,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":50,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":51,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":52,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":53,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":54,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":55,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":56,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":57,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":58,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":59,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":60,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":61,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":62,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":63,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":64,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":65,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":66,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":67,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":68,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":69,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":70,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":71,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":72,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":73,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":74,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":75,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":76,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":77,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":78,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":79,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":80,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":81,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":82,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":83,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":84,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":85,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":86,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":87,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":88,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":89,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":90,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":91,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":92,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":93,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":94,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":95,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":96,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":97,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":98,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":99,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":100,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":101,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":102,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":103,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":104,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":105,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":106,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":107,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":108,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":109,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":110,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":111,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":112,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":113,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":114,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":115,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":116,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":117,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":118,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":119,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":120,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":121,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":122,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":123,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":124,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":125,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":126,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":127,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":128,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":129,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":130,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":131,"properties":[{"name":"blocking","type":"bool","value":false}]},{"id":132,"properties":[{"name":"blocking","type":"bool","value":false}]}],"tilewidth":32,"type":"tileset","version":1.9},"mountains-v6":{"columns":64,"image":"../../media/mountains-v6.png","imageheight":2560,"imagewidth":2048,"margin":0,"name":"mountains-v6","spacing":0,"tilecount":5120,"tiledversion":"1.9.0","tileheight":32,"tiles":[{"id":2328,"properties":[{"name":"compositeTileId","type":"string","value":"testore"}]},{"id":2329,"properties":[{"name":"compositeTileId","type":"string","value":"stoneBreaklevel1"}]},{"id":2330,"properties":[{"name":"compositeTileId","type":"string","value":"stoneBreaklevel2"}]},{"id":2331,"properties":[{"name":"compositeTileId","type":"string","value":"stoneBreaklevel3"}]},{"id":2392,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"breakageMeta","type":"string","value":"{\\n    \\"descriptors\\": [\\n        {\\n            \\"tilesetId\\": \\"mountains-v6\\",\\n            \\"compositeTileId\\": \\"stoneBreaklevel1\\",\\n            \\"thresholdLow\\": 0.3,\\n            \\"thresholdHigh\\": 0.5\\n        },\\n        {\\n            \\"tilesetId\\": \\"mountains-v6\\",\\n            \\"compositeTileId\\": \\"stoneBreaklevel2\\",\\n            \\"thresholdLow\\": 0.5,\\n            \\"thresholdHigh\\": 0.7\\n        },\\n        {\\n            \\"tilesetId\\": \\"mountains-v6\\",\\n            \\"compositeTileId\\": \\"stoneBreaklevel3\\",\\n            \\"thresholdLow\\": 0.7\\n        }\\n    ]\\n}"},{"name":"compositeTileIdParent","type":"string","value":"testore"},{"name":"entityTileId","type":"string","value":"testore"},{"name":"malleable","type":"bool","value":true}]},{"id":2393,"properties":[{"name":"compositeTileIdParent","type":"string","value":"stoneBreaklevel1"},{"name":"entityTileId","type":"string","value":"stoneBreaklevel1"}]},{"id":2394,"properties":[{"name":"compositeTileIdParent","type":"string","value":"stoneBreaklevel2"},{"name":"entityTileId","type":"string","value":"stoneBreaklevel2"}]},{"id":2395,"properties":[{"name":"compositeTileIdParent","type":"string","value":"stoneBreaklevel3"},{"name":"entityTileId","type":"string","value":"stoneBreaklevel3"}]}],"tilewidth":32,"type":"tileset","version":1.9},"ore":{"columns":16,"image":"../../media/ore.png","imageheight":512,"imagewidth":512,"margin":0,"name":"ore","spacing":0,"tilecount":256,"tiledversion":"1.9.0","tileheight":32,"tiles":[{"id":0,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"ore-coal1"},{"name":"entityTileId","type":"string","value":"ore-coal"},{"name":"malleable","type":"bool","value":true}]},{"id":1,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":2,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":3,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":4,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":5,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":18,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":19,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":20,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":21,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":22,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":33,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":34,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":35,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":36,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":37,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":38,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":48,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":49,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":50,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":51,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":52,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":53,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":54,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":64,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"ore-coal2"},{"name":"entityTileId","type":"string","value":"ore-coal"},{"name":"malleable","type":"bool","value":true}]},{"id":65,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":66,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":67,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":68,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":69,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":70,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":82,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":83,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":84,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":85,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":86,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":96,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"ore-coal3"},{"name":"entityTileId","type":"string","value":"ore-coal"},{"name":"malleable","type":"bool","value":true}]},{"id":97,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":98,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":99,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":100,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":101,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":102,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"rock1"},{"name":"renderZIdxOffset","type":"int","value":-12}]},{"id":112,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"ore-coal4"},{"name":"entityTileId","type":"string","value":"ore-coal"},{"name":"malleable","type":"bool","value":true}]},{"id":113,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":114,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":115,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":116,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":117,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":118,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"rock2"},{"name":"renderZIdxOffset","type":"int","value":-12}]},{"id":178,"properties":[{"name":"renderZIdxOffset","type":"int","value":-24}]},{"id":179,"properties":[{"name":"renderZIdxOffset","type":"int","value":-24}]},{"id":180,"properties":[{"name":"renderZIdxOffset","type":"int","value":-24}]},{"id":181,"properties":[{"name":"renderZIdxOffset","type":"int","value":-24}]},{"id":182,"properties":[{"name":"renderZIdxOffset","type":"int","value":-24}]}],"tilewidth":32,"type":"tileset","version":1.9},"plants":{"columns":13,"image":"../../media/plants.png","imageheight":416,"imagewidth":416,"margin":0,"name":"plants","spacing":0,"tilecount":169,"tiledversion":"1.9.0","tileheight":32,"tiles":[{"id":2,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":3,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":4,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":5,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":6,"properties":[{"name":"compositeTileId","type":"string","value":"tree4"}]},{"id":7,"properties":[{"name":"compositeTileId","type":"string","value":"tree4"}]},{"id":8,"properties":[{"name":"compositeTileId","type":"string","value":"tree4"}]},{"id":15,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":16,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":17,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":18,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":19,"properties":[{"name":"compositeTileId","type":"string","value":"tree4"}]},{"id":20,"properties":[{"name":"compositeTileId","type":"string","value":"tree4"}]},{"id":21,"properties":[{"name":"compositeTileId","type":"string","value":"tree4"}]},{"id":28,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":29,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":30,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":31,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":32,"properties":[{"name":"compositeTileId","type":"string","value":"tree4"}]},{"id":33,"properties":[{"name":"compositeTileId","type":"string","value":"tree4"}]},{"id":34,"properties":[{"name":"compositeTileId","type":"string","value":"tree4"}]},{"id":41,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":42,"properties":[{"name":"compositeTileIdParent","type":"string","value":"tree3"}]},{"id":43,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":44,"properties":[{"name":"compositeTileId","type":"string","value":"tree3"}]},{"id":45,"properties":[{"name":"compositeTileId","type":"string","value":"tree4"}]},{"id":46,"properties":[{"name":"blockingRects","type":"string","value":"[{\\"x\\":6,\\"y\\":1,\\"width\\":20,\\"height\\":12,\\"bodyInsetBottom\\":8}]"},{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"tree4"},{"name":"entityTileId","type":"string","value":"tree4"},{"name":"malleable","type":"bool","value":true},{"name":"renderXOffset","type":"int","value":-8},{"name":"renderYOffset","type":"int","value":25}]},{"id":47,"properties":[{"name":"compositeTileId","type":"string","value":"tree4"}]},{"id":52,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":53,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":55,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":56,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":57,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":58,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":59,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":60,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":68,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":69,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":70,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":71,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":72,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":73,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":78,"properties":[{"name":"compositeTileId","type":"string","value":"deadTree"}]},{"id":79,"properties":[{"name":"compositeTileId","type":"string","value":"deadTree"}]},{"id":80,"properties":[{"name":"compositeTileId","type":"string","value":"deadTree"}]},{"id":81,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":82,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":83,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":84,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":85,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":86,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":87,"properties":[{"name":"compositeTileId","type":"string","value":"smallTree1"}]},{"id":88,"properties":[{"name":"compositeTileId","type":"string","value":"smallTree1"}]},{"id":91,"properties":[{"name":"compositeTileId","type":"string","value":"deadTree"}]},{"id":92,"properties":[{"name":"compositeTileId","type":"string","value":"deadTree"}]},{"id":93,"properties":[{"name":"compositeTileId","type":"string","value":"deadTree"}]},{"id":94,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":95,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":96,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":97,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":98,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":99,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":100,"properties":[{"name":"compositeTileId","type":"string","value":"smallTree1"}]},{"id":101,"properties":[{"name":"compositeTileId","type":"string","value":"smallTree1"}]},{"id":104,"properties":[{"name":"compositeTileId","type":"string","value":"deadTree"}]},{"id":105,"properties":[{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"deadTree"}]},{"id":106,"properties":[{"name":"compositeTileId","type":"string","value":"deadTree"}]},{"id":107,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":108,"properties":[{"name":"blockingRects","type":"string","value":"[{\\"x\\":6,\\"y\\":10,\\"width\\":24,\\"height\\":9,\\"bodyInsetBottom\\":8}]"},{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"tree1"},{"name":"entityTileId","type":"string","value":"tree1"},{"name":"malleable","type":"bool","value":true},{"name":"renderXOffset","type":"int","value":-8},{"name":"renderYOffset","type":"int","value":25}]},{"id":109,"properties":[{"name":"compositeTileId","type":"string","value":"tree1"}]},{"id":110,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":111,"properties":[{"name":"blockingRects","type":"string","value":"[{\\"x\\":0,\\"y\\":1,\\"width\\":32,\\"height\\":12,\\"bodyInsetBottom\\":8}]"},{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"tree2"},{"name":"entityTileId","type":"string","value":"tree2"},{"name":"malleable","type":"bool","value":true},{"name":"renderXOffset","type":"int","value":-8},{"name":"renderYOffset","type":"int","value":25}]},{"id":112,"properties":[{"name":"compositeTileId","type":"string","value":"tree2"}]},{"id":113,"properties":[{"name":"blockingRects","type":"string","value":"[{\\"x\\":8,\\"y\\":-20,\\"width\\":16,\\"height\\":10,\\"bodyInsetBottom\\":8}]"},{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"smallTree1"},{"name":"entityTileId","type":"string","value":"smallTree1"},{"name":"malleable","type":"bool","value":true}]},{"id":114,"properties":[{"name":"compositeTileId","type":"string","value":"smallTree1"}]},{"id":117,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":118,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":119,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":120,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":121,"properties":[{"name":"compositeTileId","type":"string","value":"tree5"}]},{"id":122,"properties":[{"name":"compositeTileId","type":"string","value":"tree5"}]},{"id":123,"properties":[{"name":"compositeTileId","type":"string","value":"tree5"}]},{"id":130,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":131,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":132,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":133,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":134,"properties":[{"name":"compositeTileId","type":"string","value":"tree5"}]},{"id":135,"properties":[{"name":"compositeTileId","type":"string","value":"tree5"}]},{"id":136,"properties":[{"name":"compositeTileId","type":"string","value":"tree5"}]},{"id":143,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":144,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":145,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":146,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":147,"properties":[{"name":"compositeTileId","type":"string","value":"tree5"}]},{"id":148,"properties":[{"name":"compositeTileId","type":"string","value":"tree5"}]},{"id":149,"properties":[{"name":"compositeTileId","type":"string","value":"tree5"}]},{"id":156,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":157,"properties":[{"name":"blockingRects","type":"string","value":"[{\\"x\\":8,\\"y\\":-20,\\"width\\":24,\\"height\\":9,\\"bodyInsetBottom\\":8}]"},{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"tree6"},{"name":"entityTileId","type":"string","value":"tree6"},{"name":"malleable","type":"bool","value":true}]},{"id":158,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":159,"properties":[{"name":"compositeTileId","type":"string","value":"tree6"}]},{"id":160,"properties":[{"name":"compositeTileId","type":"string","value":"tree5"}]},{"id":161,"properties":[{"name":"blockingRects","type":"string","value":"[{\\"x\\":8,\\"y\\":-20,\\"width\\":32,\\"height\\":9,\\"bodyInsetBottom\\":8}]"},{"name":"blocking","type":"bool","value":true},{"name":"compositeTileIdParent","type":"string","value":"tree5"},{"name":"entityTileId","type":"string","value":"tree5"},{"name":"malleable","type":"bool","value":true}]},{"id":162,"properties":[{"name":"compositeTileId","type":"string","value":"tree5"}]},{"id":164,"properties":[{"name":"blocking","type":"bool","value":true}]},{"id":167,"properties":[{"name":"blocking","type":"bool","value":false}]}],"tilewidth":32,"type":"tileset","version":1.9},"roofs":{"columns":64,"image":"../../media/roofs.png","imageheight":2048,"imagewidth":2048,"margin":0,"name":"roofs","spacing":0,"tilecount":4096,"tiledversion":"1.9.0","tileheight":32,"tilewidth":32,"type":"tileset","version":1.9},"walls":{"columns":64,"image":"../../media/walls.png","imageheight":3072,"imagewidth":2048,"margin":0,"name":"walls","spacing":0,"tilecount":6144,"tiledversion":"1.9.0","tileheight":32,"tilewidth":32,"type":"tileset","version":1.9},"walls2":{"columns":32,"image":"../../media/walls2.png","imageheight":1024,"imagewidth":1024,"margin":0,"name":"walls2","spacing":0,"tilecount":1024,"tiledversion":"1.9.0","tileheight":32,"tiles":[{"id":14,"properties":[{"name":"woodenWall","type":"int","value":9}]},{"id":42,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":43,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":44,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":45,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":46,"properties":[{"name":"woodenWall","type":"int","value":7}]},{"id":74,"properties":[{"name":"woodenWall","type":"int","value":10}]},{"id":75,"properties":[{"name":"woodenWall","type":"int","value":2}]},{"id":76,"properties":[{"name":"woodenWall","type":"int","value":1}]},{"id":77,"properties":[{"name":"woodenWall","type":"int","value":3}]},{"id":81,"properties":[{"name":"woodenWall","type":"int","value":8}]},{"id":106,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":107,"properties":[{"name":"woodenWall","type":"int","value":0}]},{"id":110,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":111,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":138,"properties":[{"name":"woodenWall","type":"int","value":11}]},{"id":139,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":140,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":141,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":171,"properties":[{"name":"woodenWall","type":"int","value":5}]},{"id":172,"properties":[{"name":"woodenWall","type":"int","value":12}]},{"id":173,"properties":[{"name":"woodenWall","type":"int","value":6}]},{"id":204,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":206,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":207,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":209,"properties":[{"name":"woodenWall","type":"int","value":4}]},{"id":236,"properties":[{"name":"woodenWall","type":"int","value":13}]},{"id":238,"properties":[{"name":"woodenWall","type":"int","value":13}]}],"tilewidth":32,"type":"tileset","version":1.9}},"npcDrops":{"chicken":[{"itemType":{"class":"resource","color":"brown","type":"drumstick"},"quantity":1},{"itemType":{"class":"resource","color":"na","spriteId":"ore:72","type":"feather"},"quantity":10}],"deer":[{"itemType":{"class":"resource","color":"brown","type":"hide"},"quantity":3},{"itemType":{"class":"resource","color":"brown","type":"drumstick"},"quantity":3}],"human":[{"itemType":{"class":"resource","color":"gray","type":"shard-metal"},"probability":0.2,"quantity":10}],"rabbit":[{"itemType":{"class":"resource","color":"brown","type":"hide"},"quantity":1},{"itemType":{"class":"resource","color":"brown","type":"drumstick"},"quantity":2}],"redspider":[{"itemType":{"class":"resource","color":"na","spriteId":"ore:88","type":"spider-silk"},"probability":1,"quantity":1}],"skeleton":[{"itemType":{"class":"resource","color":"gray","type":"shard-metal"},"probability":0.6,"quantity":2}],"slime":[{"itemType":{"class":"resource","color":"gray","type":"shard-metal"},"probability":0.35,"quantity":1}],"snake":[{"itemType":{"class":"resource","color":"gray","type":"shard-metal"},"probability":0.25,"quantity":1}],"wolfman":[{"itemType":{"class":"resource","color":"gray","type":"shard-metal"},"probability":1,"quantity":8},{"itemType":{"class":"resource","color":"gray","type":"shard-metal"},"probability":0.5,"quantity":1},{"itemType":{"class":"resource","color":"brown","type":"hide"},"probability":0.5,"quantity":2}]},"revision":"072646d2a7dd9306f9d008e795975ca1b65b1f3413352d163277d24d88c3af5c","schemaVersion":1,"source":{"autotiles":{"about":"Autotile definitions: parameters only. The mechanics stay in code (packages/common/room/autotile_library.ts, and autotile_wall.ts for kind `wall`), selected by each definition\'s `kind`. Indices are autotiler.ts bitmask indices 1-47; tile positions are 0-based cells of the named tileset. A `wall` entry is a building wall material: per index, the tiles to emit at offsets from the wall\'s cell, in order (later steps see earlier ones); which item builds it is mapped in house.ts. Validated on load and by autotile_library.test.ts.","definitions":[{"id":"lpc-terrain:353","kind":"bitmask","name":"Grass (Tiled templates)","tilePos":353,"tiledTemplate":true,"tiles":{"4":322,"7":320,"12":321,"26":258,"28":290,"33":193,"34":256,"36":288,"41":194,"42":257,"44":225,"45":226},"tilesetId":"lpc-terrain"},{"id":"lpc-terrain:676","kind":"bitmask","name":"Dirt patch with grass fringe (Tiled templates)","tilePos":676,"tiledTemplate":true,"tiles":{"4":709,"7":707,"12":708,"26":645,"28":677,"33":580,"34":643,"36":675,"41":581,"42":644,"44":612,"45":613},"tilesetId":"lpc-terrain"},{"fallback":-1,"id":"grass","kind":"bitmask","layerId":"map1","name":"Grass","tilePos":353,"tiles":{"1":1011,"2":981,"3":950,"4":322,"5":980,"6":949,"7":320,"8":886,"10":934,"11":889,"12":321,"13":979,"14":917,"15":918,"17":890,"18":885,"20":986,"25":1015,"26":258,"27":933,"28":290,"29":955,"31":984,"32":887,"33":193,"34":256,"35":967,"36":288,"37":954,"39":888,"40":982,"41":194,"42":257,"43":951,"44":225,"45":226,"47":192},"tilesetId":"lpc-terrain"},{"fallback":481,"id":"swamp","kind":"bitmask","layerId":"map1","name":"Swamp water","tilePos":546,"tiles":{"4":514,"7":512,"10":514,"11":512,"12":513,"14":785,"17":514,"20":512,"26":450,"27":450,"28":482,"29":450,"33":385,"34":448,"35":448,"36":480,"37":448,"41":386,"42":449,"44":417,"45":418},"tilesetId":"lpc-terrain"},{"fallback":623,"id":"lava","kind":"bitmask","layerId":"map4","name":"Lava","notes":{"1":"rim E,S,W -> S edge (bottom cap / south tip)","2":"rim N,E,S -> E edge (east cap / east tip)","3":"rim E,S, notch NW -> SE corner","4":"rim S,E SE corner (swamp\'s 514)","5":"rim N,S,W -> W edge (west cap / west tip)","6":"rim S,W, notch NE -> SW corner","7":"rim S,W SW corner (swamp\'s 512)","8":"rim N,S -> S edge","9":"rim S, notches NW+NE","10":"rim S, notch NE -> S edge (was 656, the SE corner, as swamp maps it)","11":"rim S, notch NW -> S edge (was 654, the SW corner, as swamp maps it)","12":"rim S S edge (swamp\'s 513)","13":"rim N,E,W -> N edge (top cap of a vertical run / north tip of a diamond)","14":"rim W,E the 1-wide N/S channel (swamp\'s 785)","15":"rim N,E, notch SW -> NE corner","16":"rim E, notches NW+SW","17":"rim E, notch SW -> E edge (was 656, the SE corner, as swamp maps it)","18":"rim N,W, notch SE -> NW corner","19":"rim W, notches NE+SE","20":"rim W, notch SE -> W edge (was 654, the SW corner, as swamp maps it)","21":"rim N, notches SW+SE","22":"all four notches <- the centre of a plus, i.e. of a radius-1 flood","23":"notches NE+SW+SE","24":"notches NW+SW+SE","25":"notches SW+SE <- the south mid-edge cell","26":"rim N,E NE corner (swamp\'s 450)","27":"rim E, notch NW -> E edge (was 592, the NE corner, as swamp maps it)","28":"rim E E edge (swamp\'s 482)","29":"rim N, notch SE -> N edge (was 592, the NE corner, as swamp maps it)","30":"notches NW+NE+SE","31":"notches NE+SE <- the east mid-edge cell","32":"notches NW+SE (saddle)","33":"no rim, notch SE inner corner (swamp\'s 385)","34":"rim N,W NW corner (swamp\'s 448)","35":"rim W, notch NE -> W edge (was 590, the NW corner, as swamp maps it)","36":"rim W W edge (swamp\'s 480)","37":"rim N, notch SW -> N edge (was 590, the NW corner, as swamp maps it)","38":"notches NW+NE+SW","39":"notches NE+SW (saddle)","40":"notches NW+SW <- the west mid-edge cell","41":"no rim, notch SW inner corner (swamp\'s 386)","42":"rim N N edge (swamp\'s 449)","43":"notches NW+NE <- the north mid-edge cell of every flood diamond","44":"no rim, notch NE inner corner (swamp\'s 417)","45":"no rim, notch NW inner corner (swamp\'s 418)","47":"rim N,E,S,W -> the N/S channel, read as a one-cell segment"},"tilePos":658,"tiles":{"1":655,"2":624,"3":656,"4":656,"5":622,"6":654,"7":654,"8":655,"9":655,"10":655,"11":655,"12":655,"13":591,"14":659,"15":592,"16":624,"17":624,"18":590,"19":622,"20":622,"21":591,"22":658,"23":658,"24":658,"25":658,"26":592,"27":624,"28":624,"29":591,"30":658,"31":658,"32":658,"33":594,"34":590,"35":622,"36":622,"37":591,"38":658,"39":658,"40":658,"41":595,"42":591,"43":658,"44":626,"45":627,"47":659},"tilesetId":"lpc-terrain"},{"id":"forest-dirt","indices":[4,7,12,26,28,33,34,36,41,42,44,45],"kind":"uniform","layerId":"map3","name":"Forest dirt","previewTilePos":436,"tilesetId":"lpc-flowers-plants-fungi-wood"},{"id":"lpc-terrain:377","kind":"platform","name":"Cave wall / rock cliff","preview":{"autoBlocking":true,"autoOcclusion":true,"layerId":"map3"},"tilePos":377,"tilesetId":"lpc-terrain","variants":[344,345,346,376,378,408,409,410,440,441,442,472,473,474,223,222,191,190,5,344,346,408,410]},{"id":"mountains-v6:837","kind":"platform","name":"Mountain cliff, pale stone","preview":{"autoBlocking":true,"autoOcclusion":false,"layerId":"map4"},"tilePos":837,"tilesetId":"mountains-v6","variants":[772,773,774,836,838,900,901,902,964,965,966,1028,1029,1030,839,835,1481,1483,-1,772,774,900,902]},{"id":"mountains-v6:861","kind":"platform","name":"Mountain cliff, dark stone","preview":{"autoBlocking":true,"autoOcclusion":false,"layerId":"map4"},"tilePos":861,"tilesetId":"mountains-v6","variants":[796,797,798,860,862,924,925,926,988,989,990,1052,1053,1054,863,859,1505,1507,23,796,798,924,926]},{"cell":{"blocking":{"tilePos":121,"tilesetId":"lpc-terrain"},"occlusion":{"tilePos":121,"tilesetId":"lpc-terrain"}},"id":"wall-wood","itemType":"wall-wood","kind":"wall","layerId":"sprite","name":"Log cabin wall","notes":{"1":"south end of a north-south run: one tile on the cell, the column\'s foot","2":"east end of an east-west run: cap above, base","3":"bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise","5":"west end of an east-west run: cap above, base","6":"bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise","8":"middle of an east-west run (and the only index a door may stand on): cap above, base","9":"T with its stem north (walls west, east and north): the cap re-points the stem\'s foot","13":"north end of a north-south run: one tile on the cell, the column\'s top; a different top when the wall south-east of it is an east end (index 2)","14":"middle of a north-south run: one tile on the cell","15":"top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)","16":"west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)","18":"top-left corner (walls east and south): cap above, base","19":"east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall\'s base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap","21":"T with its stem south (walls west, east and south): cap above, base","22":"cross (walls on all four sides): the cap re-points the wall above","47":"a lone wall: cap above, base"},"ornaments":{"burl":{"scatter":0.06,"tiles":{"642":680,"669":681}},"fungus":{"scatter":0.04,"tiles":{"642":682,"669":683}},"knots":{"scatter":0.09,"tiles":{"642":684,"669":685}},"lichen":{"scatter":0.06,"tiles":{"642":686,"669":687}},"moss":{"scatter":0.1,"tiles":{"642":688,"669":689}},"split":{"scatter":0.07,"tiles":{"642":690,"669":691}}},"rules":{"1":[{"tile":630}],"2":[{"dy":-1,"tile":645},{"tile":653}],"3":[{"choose":[{"emit":[{"dy":-1,"tile":651}],"when":{"index":[18,19],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":656}]}]},{"tile":659}],"5":[{"dy":-1,"tile":631},{"tile":636}],"6":[{"choose":[{"emit":[{"dy":-1,"tile":652}],"when":{"index":[15,16],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":654}]}]},{"tile":657}],"8":[{"dy":-1,"tile":633},{"tile":642}],"9":[{"dy":-1,"tile":664},{"tile":642}],"13":[{"choose":[{"emit":[{"tile":644}],"when":{"index":[2],"neighbour":[1,1]}},{"emit":[{"tile":635}]}]}],"14":[{"tile":646}],"15":[{"dy":-1,"tile":634},{"choose":[{"emit":[{"tile":663}],"when":{"exists":[1,0]}},{"emit":[{"tile":643}]}]}],"16":[{"choose":[{"emit":[{"dy":-1,"tile":661}],"when":{"index":[18],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":665}]}]},{"tile":643}],"18":[{"dy":-1,"tile":632},{"tile":637}],"19":[{"choose":[{"emit":[{"tile":651}],"when":{"all":[{"exists":[-1,0]},{"neighbour":[1,0]}]}},{"emit":[{"dy":-1,"tile":644}],"when":{"not":{"exists":[-1,-1]}}},{"emit":[{"dy":-1,"tile":662}]}]},{"tile":637}],"21":[{"dy":-1,"tile":655},{"tile":658}],"22":[{"dy":-1,"tile":660},{"tile":658}],"47":[{"dy":-1,"tile":633},{"tile":642}]},"seams":{"continued":{"635":{"tilePos":712,"tilesetId":"authored-terrain"},"646":{"tilePos":713,"tilesetId":"authored-terrain"},"666":{"tilePos":714,"tilesetId":"authored-terrain"},"667":{"tilePos":715,"tilesetId":"authored-terrain"},"668":{"tilePos":716,"tilesetId":"authored-terrain"},"669":{"tilePos":717,"tilesetId":"authored-terrain"},"670":{"tilePos":718,"tilesetId":"authored-terrain"},"673":{"tilePos":719,"tilesetId":"authored-terrain"},"674":{"tilePos":720,"tilesetId":"authored-terrain"},"675":{"tilePos":721,"tilesetId":"authored-terrain"},"676":{"tilePos":722,"tilesetId":"authored-terrain"},"680":{"tilePos":723,"tilesetId":"authored-terrain"},"681":{"tilePos":724,"tilesetId":"authored-terrain"},"682":{"tilePos":725,"tilesetId":"authored-terrain"},"683":{"tilePos":726,"tilesetId":"authored-terrain"},"684":{"tilePos":727,"tilesetId":"authored-terrain"},"685":{"tilePos":728,"tilesetId":"authored-terrain"},"686":{"tilePos":729,"tilesetId":"authored-terrain"},"687":{"tilePos":730,"tilesetId":"authored-terrain"},"688":{"tilePos":731,"tilesetId":"authored-terrain"},"689":{"tilePos":732,"tilesetId":"authored-terrain"},"690":{"tilePos":733,"tilesetId":"authored-terrain"},"691":{"tilePos":734,"tilesetId":"authored-terrain"}},"covered":{"631":{"tilePos":692,"tilesetId":"authored-terrain"},"632":{"tilePos":693,"tilesetId":"authored-terrain"},"633":{"tilePos":694,"tilesetId":"authored-terrain"},"634":{"tilePos":695,"tilesetId":"authored-terrain"},"644":{"tilePos":696,"tilesetId":"authored-terrain"},"645":{"tilePos":697,"tilesetId":"authored-terrain"},"651":{"tilePos":698,"tilesetId":"authored-terrain"},"652":{"tilePos":699,"tilesetId":"authored-terrain"},"654":{"tilePos":700,"tilesetId":"authored-terrain"},"655":{"tilePos":701,"tilesetId":"authored-terrain"},"656":{"tilePos":702,"tilesetId":"authored-terrain"},"660":{"tilePos":703,"tilesetId":"authored-terrain"},"661":{"tilePos":704,"tilesetId":"authored-terrain"},"662":{"tilePos":705,"tilesetId":"authored-terrain"},"664":{"tilePos":706,"tilesetId":"authored-terrain"},"665":{"tilePos":707,"tilesetId":"authored-terrain"},"671":{"tilePos":708,"tilesetId":"authored-terrain"},"672":{"tilePos":709,"tilesetId":"authored-terrain"},"677":{"tilePos":710,"tilesetId":"authored-terrain"},"678":{"tilePos":711,"tilesetId":"authored-terrain"}},"joints":{"635":{"tilePos":818,"tilesetId":"authored-terrain"},"646":{"tilePos":820,"tilesetId":"authored-terrain"},"666":{"tilePos":821,"tilesetId":"authored-terrain"}},"lintel":{"tilePos":735,"tilesetId":"authored-terrain"},"style":"seamless"},"tilesetId":"authored-terrain","upperTiles":{"630":666,"636":667,"637":668,"642":669,"643":670,"651":671,"652":672,"653":673,"657":674,"658":675,"659":676,"661":677,"662":678,"663":679}},{"cell":{"blocking":{"tilePos":121,"tilesetId":"lpc-terrain"},"occlusion":{"tilePos":121,"tilesetId":"lpc-terrain"}},"id":"wall2-wood","itemType":"wall2-wood","kind":"wall","layerId":"sprite","name":"Wooden wall 2","notes":{"1":"south end of a north-south run: one tile on the cell, the column\'s foot","2":"east end of an east-west run: cap above, base","3":"bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise","5":"west end of an east-west run: cap above, base","6":"bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise","8":"middle of an east-west run (and the only index a door may stand on): cap above, base","9":"T with its stem north (walls west, east and north): the cap re-points the stem\'s foot","13":"north end of a north-south run: one tile on the cell, the column\'s top; a different top when the wall south-east of it is an east end (index 2)","14":"middle of a north-south run: one tile on the cell","15":"top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)","16":"west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)","18":"top-left corner (walls east and south): cap above, base","19":"east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall\'s base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap","21":"T with its stem south (walls west, east and south): cap above, base","22":"cross (walls on all four sides): the cap re-points the wall above","47":"a lone wall: cap above, base"},"rules":{"1":[{"tile":14}],"2":[{"dy":-1,"tile":106},{"tile":138}],"3":[{"choose":[{"emit":[{"dy":-1,"tile":110}],"when":{"index":[18,19],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":141}]}]},{"tile":173}],"5":[{"dy":-1,"tile":42},{"tile":74}],"6":[{"choose":[{"emit":[{"dy":-1,"tile":111}],"when":{"index":[15,16],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":139}]}]},{"tile":171}],"8":[{"dy":-1,"tile":44},{"tile":76}],"9":[{"dy":-1,"tile":236},{"tile":76}],"13":[{"choose":[{"emit":[{"tile":81}],"when":{"index":[2],"neighbour":[1,1]}},{"emit":[{"tile":46}]}]}],"14":[{"tile":107}],"15":[{"dy":-1,"tile":45},{"choose":[{"emit":[{"tile":209}],"when":{"exists":[1,0]}},{"emit":[{"tile":77}]}]}],"16":[{"choose":[{"emit":[{"dy":-1,"tile":206}],"when":{"index":[18],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":238}]}]},{"tile":77}],"18":[{"dy":-1,"tile":43},{"tile":75}],"19":[{"choose":[{"emit":[{"tile":110}],"when":{"all":[{"exists":[-1,0]},{"neighbour":[1,0]}]}},{"emit":[{"dy":-1,"tile":81}],"when":{"not":{"exists":[-1,-1]}}},{"emit":[{"dy":-1,"tile":207}]}]},{"tile":75}],"21":[{"dy":-1,"tile":140},{"tile":172}],"22":[{"dy":-1,"tile":204},{"tile":172}],"47":[{"dy":-1,"tile":44},{"tile":76}]},"tilesetId":"walls2"},{"cell":{"blocking":{"tilePos":121,"tilesetId":"lpc-terrain"},"occlusion":{"tilePos":121,"tilesetId":"lpc-terrain"}},"id":"wall-stone","itemType":"wall-stone","kind":"wall","layerId":"sprite","name":"Stone wall","notes":{"1":"south end of a north-south run: one tile on the cell, the column\'s foot","2":"east end of an east-west run: cap above, base","3":"bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise","5":"west end of an east-west run: cap above, base","6":"bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise","8":"middle of an east-west run (and the only index a door may stand on): cap above, base","9":"T with its stem north (walls west, east and north): the cap re-points the stem\'s foot","13":"north end of a north-south run: one tile on the cell, the column\'s top; a different top when the wall south-east of it is an east end (index 2)","14":"middle of a north-south run: one tile on the cell","15":"top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)","16":"west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)","18":"top-left corner (walls east and south): cap above, base","19":"east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall\'s base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap","21":"T with its stem south (walls west, east and south): cap above, base","22":"cross (walls on all four sides): the cap re-points the wall above","47":"a lone wall: cap above, base"},"rules":{"1":[{"tile":24}],"2":[{"dy":-1,"tile":116},{"tile":148}],"3":[{"choose":[{"emit":[{"dy":-1,"tile":120}],"when":{"index":[18,19],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":151}]}]},{"tile":183}],"5":[{"dy":-1,"tile":52},{"tile":84}],"6":[{"choose":[{"emit":[{"dy":-1,"tile":121}],"when":{"index":[15,16],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":149}]}]},{"tile":181}],"8":[{"dy":-1,"tile":54},{"tile":86}],"9":[{"dy":-1,"tile":246},{"tile":86}],"13":[{"choose":[{"emit":[{"tile":91}],"when":{"index":[2],"neighbour":[1,1]}},{"emit":[{"tile":56}]}]}],"14":[{"tile":117}],"15":[{"dy":-1,"tile":55},{"choose":[{"emit":[{"tile":219}],"when":{"exists":[1,0]}},{"emit":[{"tile":87}]}]}],"16":[{"choose":[{"emit":[{"dy":-1,"tile":216}],"when":{"index":[18],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":248}]}]},{"tile":87}],"18":[{"dy":-1,"tile":53},{"tile":85}],"19":[{"choose":[{"emit":[{"tile":120}],"when":{"all":[{"exists":[-1,0]},{"neighbour":[1,0]}]}},{"emit":[{"dy":-1,"tile":91}],"when":{"not":{"exists":[-1,-1]}}},{"emit":[{"dy":-1,"tile":217}]}]},{"tile":85}],"21":[{"dy":-1,"tile":150},{"tile":182}],"22":[{"dy":-1,"tile":214},{"tile":182}],"47":[{"dy":-1,"tile":54},{"tile":86}]},"seams":{"covered":{"52":{"tilePos":451,"tilesetId":"authored-terrain"},"53":{"tilePos":452,"tilesetId":"authored-terrain"},"54":{"tilePos":453,"tilesetId":"authored-terrain"},"55":{"tilePos":454,"tilesetId":"authored-terrain"},"91":{"tilePos":455,"tilesetId":"authored-terrain"},"116":{"tilePos":456,"tilesetId":"authored-terrain"},"120":{"tilePos":457,"tilesetId":"authored-terrain"},"121":{"tilePos":458,"tilesetId":"authored-terrain"},"149":{"tilePos":459,"tilesetId":"authored-terrain"},"150":{"tilePos":460,"tilesetId":"authored-terrain"},"151":{"tilePos":461,"tilesetId":"authored-terrain"},"214":{"tilePos":462,"tilesetId":"authored-terrain"},"216":{"tilePos":463,"tilesetId":"authored-terrain"},"217":{"tilePos":464,"tilesetId":"authored-terrain"},"246":{"tilePos":465,"tilesetId":"authored-terrain"},"248":{"tilePos":466,"tilesetId":"authored-terrain"}},"lintel":{"tilePos":467,"tilesetId":"authored-terrain"},"style":"seamless"},"tilesetId":"walls2"},{"id":"mossy-carpet","kind":"bitmask","layerId":"map3","name":"Mossy carpet","notes":{"1":"composed: NW corner-sw \xb7 NE corner-se \xb7 SW corner-sw \xb7 SE corner-se","2":"composed: NW corner-ne \xb7 NE corner-ne \xb7 SW corner-se \xb7 SE corner-se","3":"composed: NW notch-nw \xb7 NE corner-se \xb7 SW corner-se \xb7 SE corner-se","4":"composed: corner-se, whole","5":"composed: NW corner-nw \xb7 NE corner-nw \xb7 SW corner-sw \xb7 SE corner-sw","6":"composed: NW corner-sw \xb7 NE notch-ne \xb7 SW corner-sw \xb7 SE corner-sw","7":"composed: corner-sw, whole","8":"composed: NW edge-n \xb7 NE edge-n \xb7 SW edge-s \xb7 SE edge-s","9":"composed: NW notch-nw \xb7 NE notch-ne \xb7 SW edge-s \xb7 SE edge-s","10":"composed: NW edge-s \xb7 NE notch-ne \xb7 SW edge-s \xb7 SE edge-s","11":"composed: NW notch-nw \xb7 NE edge-s \xb7 SW edge-s \xb7 SE edge-s","12":"composed: edge-s, whole","13":"composed: NW corner-nw \xb7 NE corner-ne \xb7 SW corner-nw \xb7 SE corner-ne","14":"composed: NW edge-w \xb7 NE edge-e \xb7 SW edge-w \xb7 SE edge-e","15":"composed: NW corner-ne \xb7 NE corner-ne \xb7 SW notch-sw \xb7 SE corner-ne","16":"composed: NW notch-nw \xb7 NE edge-e \xb7 SW notch-sw \xb7 SE edge-e","17":"composed: NW edge-e \xb7 NE edge-e \xb7 SW notch-sw \xb7 SE edge-e","18":"composed: NW corner-nw \xb7 NE corner-nw \xb7 SW corner-nw \xb7 SE notch-se","19":"composed: NW edge-w \xb7 NE notch-ne \xb7 SW edge-w \xb7 SE notch-se","20":"composed: NW edge-w \xb7 NE edge-w \xb7 SW edge-w \xb7 SE notch-se","21":"composed: NW edge-n \xb7 NE edge-n \xb7 SW notch-sw \xb7 SE notch-se","22":"composed: NW notch-nw \xb7 NE notch-ne \xb7 SW notch-sw \xb7 SE notch-se","23":"composed: NW centre \xb7 NE notch-ne \xb7 SW notch-sw \xb7 SE notch-se","24":"composed: NW notch-nw \xb7 NE centre \xb7 SW notch-sw \xb7 SE notch-se","25":"composed: NW centre \xb7 NE centre \xb7 SW notch-sw \xb7 SE notch-se","26":"composed: corner-ne, whole","27":"composed: NW notch-nw \xb7 NE edge-e \xb7 SW edge-e \xb7 SE edge-e","28":"composed: edge-e, whole","29":"composed: NW edge-n \xb7 NE edge-n \xb7 SW edge-n \xb7 SE notch-se","30":"composed: NW notch-nw \xb7 NE notch-ne \xb7 SW centre \xb7 SE notch-se","31":"composed: NW centre \xb7 NE notch-ne \xb7 SW centre \xb7 SE notch-se","32":"composed: NW notch-nw \xb7 NE centre \xb7 SW centre \xb7 SE notch-se","33":"composed: notch-se, whole","34":"composed: corner-nw, whole","35":"composed: NW edge-w \xb7 NE notch-ne \xb7 SW edge-w \xb7 SE edge-w","36":"composed: edge-w, whole","37":"composed: NW edge-n \xb7 NE edge-n \xb7 SW notch-sw \xb7 SE edge-n","38":"composed: NW notch-nw \xb7 NE notch-ne \xb7 SW notch-sw \xb7 SE centre","39":"composed: NW centre \xb7 NE notch-ne \xb7 SW notch-sw \xb7 SE centre","40":"composed: NW notch-nw \xb7 NE centre \xb7 SW notch-sw \xb7 SE centre","41":"composed: notch-sw, whole","42":"composed: edge-n, whole","43":"composed: NW notch-nw \xb7 NE notch-ne \xb7 SW centre \xb7 SE centre","44":"composed: notch-ne, whole","45":"composed: notch-nw, whole","46":"keeps the base: the composed centre","47":"composed: the blob cell, whole"},"tilePos":1,"tiledTemplate":true,"tiles":{"1":2,"2":3,"3":4,"4":5,"5":6,"6":7,"7":8,"8":9,"9":10,"10":11,"11":12,"12":13,"13":14,"14":15,"15":16,"16":17,"17":18,"18":19,"19":20,"20":21,"21":22,"22":23,"23":24,"24":25,"25":26,"26":27,"27":28,"28":29,"29":30,"30":31,"31":32,"32":33,"33":34,"34":35,"35":36,"36":37,"37":38,"38":39,"39":40,"40":41,"41":42,"42":43,"43":44,"44":45,"45":46,"47":47},"tilesetId":"authored-terrain"},{"cell":{"blocking":{"tilePos":121,"tilesetId":"lpc-terrain"},"occlusion":{"tilePos":121,"tilesetId":"lpc-terrain"}},"id":"timber-frame-wall","itemType":"timber-frame-wall","kind":"wall","layerId":"sprite","name":"Timber-frame wall","notes":{"1":"south end of a north-south run: one tile on the cell, the column\'s foot","2":"east end of an east-west run: cap above, base","3":"bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise","5":"west end of an east-west run: cap above, base","6":"bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise","8":"middle of an east-west run (and the only index a door may stand on): cap above, base","9":"T with its stem north (walls west, east and north): the cap re-points the stem\'s foot","13":"north end of a north-south run: one tile on the cell, the column\'s top; a different top when the wall south-east of it is an east end (index 2)","14":"middle of a north-south run: one tile on the cell","15":"top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)","16":"west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)","18":"top-left corner (walls east and south): cap above, base","19":"east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall\'s base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap","21":"T with its stem south (walls west, east and south): cap above, base","22":"cross (walls on all four sides): the cap re-points the wall above","47":"a lone wall: cap above, base"},"ornaments":{"crack":{"scatter":0.07,"tiles":{"56":980,"381":981}},"damp":{"scatter":0.05,"tiles":{"56":982,"381":983}},"nest":{"scatter":0.03,"tiles":{"56":984,"381":985}},"patched":{"scatter":0.05,"tiles":{"56":416,"381":417}},"wattle":{"scatter":0.05,"tiles":{"56":986,"381":987}},"window":{"tiles":{"56":418,"381":419}}},"rules":{"1":[{"tile":48}],"2":[{"dy":-1,"tile":59},{"tile":63}],"3":[{"choose":[{"emit":[{"dy":-1,"tile":61}],"when":{"index":[18,19],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":322}]}]},{"tile":325}],"5":[{"dy":-1,"tile":49},{"tile":54}],"6":[{"choose":[{"emit":[{"dy":-1,"tile":62}],"when":{"index":[15,16],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":320}]}]},{"tile":323}],"8":[{"dy":-1,"tile":51},{"tile":56}],"9":[{"dy":-1,"tile":330},{"tile":56}],"13":[{"choose":[{"emit":[{"tile":58}],"when":{"index":[2],"neighbour":[1,1]}},{"emit":[{"tile":53}]}]}],"14":[{"tile":60}],"15":[{"dy":-1,"tile":52},{"choose":[{"emit":[{"tile":329}],"when":{"exists":[1,0]}},{"emit":[{"tile":57}]}]}],"16":[{"choose":[{"emit":[{"dy":-1,"tile":327}],"when":{"index":[18],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":331}]}]},{"tile":57}],"18":[{"dy":-1,"tile":50},{"tile":55}],"19":[{"choose":[{"emit":[{"tile":61}],"when":{"all":[{"exists":[-1,0]},{"neighbour":[1,0]}]}},{"emit":[{"dy":-1,"tile":58}],"when":{"not":{"exists":[-1,-1]}}},{"emit":[{"dy":-1,"tile":328}]}]},{"tile":55}],"21":[{"dy":-1,"tile":321},{"tile":324}],"22":[{"dy":-1,"tile":326},{"tile":324}],"47":[{"dy":-1,"tile":51},{"tile":56}]},"seams":{"covered":{"49":{"tilePos":430,"tilesetId":"authored-terrain"},"50":{"tilePos":431,"tilesetId":"authored-terrain"},"51":{"tilePos":432,"tilesetId":"authored-terrain"},"52":{"tilePos":433,"tilesetId":"authored-terrain"},"58":{"tilePos":434,"tilesetId":"authored-terrain"},"59":{"tilePos":435,"tilesetId":"authored-terrain"},"61":{"tilePos":436,"tilesetId":"authored-terrain"},"62":{"tilePos":437,"tilesetId":"authored-terrain"},"320":{"tilePos":438,"tilesetId":"authored-terrain"},"321":{"tilePos":439,"tilesetId":"authored-terrain"},"322":{"tilePos":440,"tilesetId":"authored-terrain"},"326":{"tilePos":441,"tilesetId":"authored-terrain"},"327":{"tilePos":442,"tilesetId":"authored-terrain"},"328":{"tilePos":443,"tilesetId":"authored-terrain"},"330":{"tilePos":444,"tilesetId":"authored-terrain"},"331":{"tilePos":445,"tilesetId":"authored-terrain"},"383":{"tilePos":446,"tilesetId":"authored-terrain"},"384":{"tilePos":447,"tilesetId":"authored-terrain"},"389":{"tilePos":448,"tilesetId":"authored-terrain"},"390":{"tilePos":449,"tilesetId":"authored-terrain"}},"joints":{"53":{"tilePos":822,"tilesetId":"authored-terrain"},"60":{"tilePos":824,"tilesetId":"authored-terrain"},"468":{"tilePos":825,"tilesetId":"authored-terrain"}},"lintel":{"tilePos":450,"tilesetId":"authored-terrain"},"ownBeam":true,"style":"beam"},"tilesetId":"authored-terrain","trims":{"creepers":{"bloom":0.35,"reach":[0.8,1.7],"share":0.15,"spread":18},"foot":{"moss":0,"rubble":0.25,"tufts":0.6},"framing":{"bays":[26,28,30,32,34],"over":["#4a3524","#6a4c31","#8a6943","#a88757"],"panels":[{"fills":{"arched":1.5,"brace":3,"chevron":2,"plain":1.5,"stud":1},"rows":[0,11]},{"fills":{"brace":1.5,"cross":1,"plain":3,"stud":3},"rows":[15,22]}],"posts":[0,22],"tones":0.03,"width":4},"masonry":{"ground":{"rows":[26,30],"splits":[[5]],"widths":[6,7,8,9,10,11,12,14]}},"palette":{"dressed":["#3a261b","#553826","#6f4c34","#8a6243"],"flowers":["#7a1f2e","#b8384a","#e8788a"],"grass":["#2e5628","#447632","#609243","#84ac50"],"joint":"#4d4741","leaves":["#1e3c22","#2e562a","#467a36","#68983e","#8ab250"],"moss":["#424d2c","#5d6b3c","#7d8a4c"],"outline":"#241914","stem":"#4e3c28","stone":["#5c564f","#756e64","#8d8579","#a59c8f","#bdb4a6"],"timber":["#3a261b","#553826","#6f4c34","#8a6243","#a37b55"],"top":["#5e4a39","#7c634d","#937a62","#a99079","#bea78f"]},"parts":{"face":["#4d4741","#5c564f","#756e64","#8c7250","#8d8579","#9a8058","#a59c8f","#b59a6e","#bdb4a6","#ccb183","#dcc394","#e6cfa3","#ecd8b2","#f0dfbd","#f4e4c4","#f7ead0"],"top":["#5e4a39","#7c634d","#937a62","#a99079","#bea78f"]}},"upperTiles":{"48":468,"54":379,"55":380,"56":381,"57":382,"61":383,"62":384,"63":385,"323":386,"324":387,"325":388,"327":389,"328":390,"329":391}},{"id":"thatch-roof","itemType":"thatch-roof","kind":"roof","name":"Thatch roof","ornaments":{"chimney":{"pieces":{"ridge.mid":420,"ridgeTop.mid":421,"solo.mid":422}},"dormer":{"pieces":{"front.mid":423}},"moss":{"pieces":{"front.mid":424},"scatter":0.12}},"pitched":{"back.east":394,"back.mid":392,"back.single":395,"back.west":393,"eave.east":410,"eave.mid":408,"eave.single":411,"eave.west":409,"front.bothJoin":429,"front.east":406,"front.eastJoin":426,"front.eastJoinWest":428,"front.mid":404,"front.single":407,"front.west":405,"front.westJoin":425,"front.westJoinEast":427,"ridge.east":402,"ridge.mid":400,"ridge.single":403,"ridge.west":401,"ridgeTop.east":398,"ridgeTop.mid":396,"ridgeTop.single":399,"ridgeTop.west":397,"solo.east":414,"solo.mid":412,"solo.single":415,"solo.west":413},"tiles":{"1":332,"2":333,"3":334,"4":335,"5":336,"6":337,"7":338,"8":339,"9":340,"10":341,"11":342,"12":343,"13":344,"14":345,"15":346,"16":347,"17":348,"18":349,"19":350,"20":351,"21":352,"22":353,"23":354,"24":355,"25":356,"26":357,"27":358,"28":359,"29":360,"30":361,"31":362,"32":363,"33":364,"34":365,"35":366,"36":367,"37":368,"38":369,"39":370,"40":371,"41":372,"42":373,"43":374,"44":375,"45":376,"46":377,"47":378},"tilesetId":"authored-terrain"},{"id":"roof-wood","itemType":"roof-wood","kind":"roof","name":"Plank roof","ornaments":{"knothole":{"pieces":{"front.mid":812},"scatter":0.05},"lichen":{"pieces":{"front.mid":813},"scatter":0.07},"moss":{"pieces":{"front.mid":814},"scatter":0.1},"moss-back":{"pieces":{"back.mid":815},"scatter":0.22},"split":{"pieces":{"front.mid":816},"scatter":0.05},"warped":{"pieces":{"front.mid":817},"scatter":0.05}},"pitched":{"back.east":785,"back.mid":783,"back.single":786,"back.west":784,"eave.east":801,"eave.mid":799,"eave.single":802,"eave.west":800,"front.bothJoin":811,"front.east":797,"front.eastJoin":808,"front.eastJoinWest":810,"front.mid":795,"front.single":798,"front.west":796,"front.westJoin":807,"front.westJoinEast":809,"ridge.east":793,"ridge.mid":791,"ridge.single":794,"ridge.west":792,"ridgeTop.east":789,"ridgeTop.mid":787,"ridgeTop.single":790,"ridgeTop.west":788,"solo.east":805,"solo.mid":803,"solo.single":806,"solo.west":804},"tiles":{"1":736,"2":737,"3":738,"4":739,"5":740,"6":741,"7":742,"8":743,"9":744,"10":745,"11":746,"12":747,"13":748,"14":749,"15":750,"16":751,"17":752,"18":753,"19":754,"20":755,"21":756,"22":757,"23":758,"24":759,"25":760,"26":761,"27":762,"28":763,"29":764,"30":765,"31":766,"32":767,"33":768,"34":769,"35":770,"36":771,"37":772,"38":773,"39":774,"40":775,"41":776,"42":777,"43":778,"44":779,"45":780,"46":781,"47":782},"tilesetId":"authored-terrain"},{"id":"floor-wood","itemType":"floor-wood","kind":"bitmask","layerId":"map2","name":"Rough-hewn plank floor","ornaments":{"burl":{"scatter":0.09,"tiles":{"46":12}},"long-grain":{"scatter":0.23,"tiles":{"46":16}},"small-burl":{"scatter":0.07,"tiles":{"46":15}},"split":{"scatter":0.08,"tiles":{"46":14}},"stain":{"scatter":0.08,"tiles":{"46":13}},"worn":{"scatter":0.23,"tiles":{"46":17}}},"tilePos":33,"tiles":{"1":39,"2":68,"3":70,"4":66,"5":67,"6":69,"7":64,"8":6,"9":65,"10":65,"11":65,"12":65,"13":71,"14":37,"15":7,"16":34,"17":34,"18":5,"19":32,"20":32,"21":1,"22":33,"23":33,"24":33,"25":73,"26":2,"27":34,"28":34,"29":1,"30":33,"31":42,"32":33,"33":3,"34":0,"35":32,"36":32,"37":1,"38":33,"39":33,"40":40,"41":4,"42":1,"43":9,"44":35,"45":36,"46":33,"47":38},"tilesetId":"floors"},{"id":"floor-stone","itemType":"floor-stone","kind":"bitmask","layerId":"map2","name":"Flagstone floor","ornaments":{"chip":{"scatter":0.06,"tiles":{"46":109}},"crack":{"scatter":0.06,"tiles":{"46":108}},"moss":{"scatter":0.05,"tiles":{"46":110}},"stain":{"scatter":0.05,"tiles":{"46":111}},"worn":{"scatter":0.06,"tiles":{"46":112}}},"tilePos":129,"tiles":{"1":135,"2":164,"3":166,"4":162,"5":163,"6":165,"7":160,"8":102,"9":161,"10":161,"11":161,"12":161,"13":167,"14":133,"15":103,"16":130,"17":130,"18":101,"19":128,"20":128,"21":97,"22":129,"23":129,"24":129,"25":169,"26":98,"27":130,"28":130,"29":97,"30":129,"31":138,"32":129,"33":99,"34":96,"35":128,"36":128,"37":97,"38":129,"39":129,"40":136,"41":100,"42":97,"43":105,"44":131,"45":132,"46":129,"47":134},"tilesetId":"floors"},{"id":"floor-cobble","itemType":"floor-cobble","kind":"bitmask","layerId":"map2","name":"Cobbled floor","ornaments":{"earth":{"scatter":0.06,"tiles":{"46":204}},"earth-b":{"scatter":0.03,"tiles":{"46":208}},"grass":{"scatter":0.05,"tiles":{"46":206}},"grass-b":{"scatter":0.03,"tiles":{"46":209}},"tint":{"scatter":0.05,"tiles":{"46":205}},"tint-b":{"scatter":0.05,"tiles":{"46":207}}},"tilePos":225,"tiles":{"1":231,"2":260,"3":262,"4":258,"5":259,"6":261,"7":256,"8":198,"9":257,"10":257,"11":257,"12":257,"13":263,"14":229,"15":199,"16":226,"17":226,"18":197,"19":224,"20":224,"21":193,"22":225,"23":225,"24":225,"25":265,"26":194,"27":226,"28":226,"29":193,"30":225,"31":234,"32":225,"33":195,"34":192,"35":224,"36":224,"37":193,"38":225,"39":225,"40":232,"41":196,"42":193,"43":201,"44":227,"45":228,"46":225,"47":230},"tilesetId":"floors"},{"cell":{"blocking":{"tilePos":121,"tilesetId":"lpc-terrain"}},"id":"railing-wood","itemType":"railing-wood","joins":"own","kind":"wall","layerId":"sprite","name":"Wooden railing","notes":{"47":"A lone post: the south end of a north-south run, no rail drawn."},"rules":{"1":[{"tile":16}],"2":[{"tile":2}],"3":[{"tile":66}],"5":[{"tile":0}],"6":[{"tile":64}],"8":[{"tile":1}],"9":[{"tile":65}],"13":[{"tile":18}],"14":[{"tile":17}],"15":[{"tile":34}],"16":[{"tile":50}],"18":[{"tile":32}],"19":[{"tile":48}],"21":[{"tile":33}],"22":[{"tile":49}],"47":[{"tile":16}]},"tilesetId":"fence_medieval"},{"cell":{"blocking":{"tilePos":121,"tilesetId":"lpc-terrain"},"occlusion":{"tilePos":121,"tilesetId":"lpc-terrain"}},"id":"castle-footing","itemType":"castle-footing","kind":"wall","layerId":"sprite","name":"Castle footing","notes":{"1":"south end of a north-south run: one tile on the cell, the column\'s foot","2":"east end of an east-west run: cap above, base","3":"bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise","5":"west end of an east-west run: cap above, base","6":"bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise","8":"middle of an east-west run (and the only index a door may stand on): cap above, base","9":"T with its stem north (walls west, east and north): the cap re-points the stem\'s foot","13":"north end of a north-south run: one tile on the cell, the column\'s top; a different top when the wall south-east of it is an east end (index 2)","14":"middle of a north-south run: one tile on the cell","15":"top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)","16":"west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)","18":"top-left corner (walls east and south): cap above, base","19":"east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall\'s base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap","21":"T with its stem south (walls west, east and south): cap above, base","22":"cross (walls on all four sides): the cap re-points the wall above","47":"a lone wall: cap above, base"},"ornaments":{"arrow-slit":{"tiles":{"832":852}}},"rules":{"1":[{"tile":819}],"2":[{"dy":-1,"tile":835},{"tile":839}],"3":[{"choose":[{"emit":[{"dy":-1,"tile":837}],"when":{"index":[18,19],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":842}]}]},{"tile":845}],"5":[{"dy":-1,"tile":823},{"tile":830}],"6":[{"choose":[{"emit":[{"dy":-1,"tile":838}],"when":{"index":[15,16],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":840}]}]},{"tile":843}],"8":[{"dy":-1,"tile":827},{"tile":832}],"9":[{"dy":-1,"tile":850},{"tile":832}],"13":[{"choose":[{"emit":[{"tile":834}],"when":{"index":[2],"neighbour":[1,1]}},{"emit":[{"tile":829}]}]}],"14":[{"tile":836}],"15":[{"dy":-1,"tile":828},{"choose":[{"emit":[{"tile":849}],"when":{"exists":[1,0]}},{"emit":[{"tile":833}]}]}],"16":[{"choose":[{"emit":[{"dy":-1,"tile":847}],"when":{"index":[18],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":851}]}]},{"tile":833}],"18":[{"dy":-1,"tile":826},{"tile":831}],"19":[{"choose":[{"emit":[{"tile":837}],"when":{"all":[{"exists":[-1,0]},{"neighbour":[1,0]}]}},{"emit":[{"dy":-1,"tile":834}],"when":{"not":{"exists":[-1,-1]}}},{"emit":[{"dy":-1,"tile":848}]}]},{"tile":831}],"21":[{"dy":-1,"tile":841},{"tile":844}],"22":[{"dy":-1,"tile":846},{"tile":844}],"47":[{"dy":-1,"tile":827},{"tile":832}]},"seams":{"covered":{"823":{"tilePos":853,"tilesetId":"authored-terrain"},"826":{"tilePos":854,"tilesetId":"authored-terrain"},"827":{"tilePos":855,"tilesetId":"authored-terrain"},"828":{"tilePos":856,"tilesetId":"authored-terrain"},"834":{"tilePos":857,"tilesetId":"authored-terrain"},"835":{"tilePos":858,"tilesetId":"authored-terrain"},"837":{"tilePos":859,"tilesetId":"authored-terrain"},"838":{"tilePos":860,"tilesetId":"authored-terrain"},"840":{"tilePos":861,"tilesetId":"authored-terrain"},"841":{"tilePos":862,"tilesetId":"authored-terrain"},"842":{"tilePos":863,"tilesetId":"authored-terrain"},"846":{"tilePos":864,"tilesetId":"authored-terrain"},"847":{"tilePos":865,"tilesetId":"authored-terrain"},"848":{"tilePos":866,"tilesetId":"authored-terrain"},"850":{"tilePos":867,"tilesetId":"authored-terrain"},"851":{"tilePos":868,"tilesetId":"authored-terrain"}},"lintel":{"tilePos":869,"tilesetId":"authored-terrain"},"style":"seamless"},"shadow":{"body":{"depth":18,"left":3,"right":29}},"tilesetId":"authored-terrain","trims":{"arch":{"maxSpan":3,"ring":6,"rise":26},"coping":{"lengths":[8,18]},"creepers":{"reach":[1.2,3.5],"share":0.3,"spread":16},"foot":{"moss":0.5,"rubble":0.5,"tufts":0.5},"masonry":{"ground":{"rows":[4,23],"splits":[[20],[10,10],[12,8],[8,12]],"widths":[16,20,26,32,40,48]}},"palette":{"dressed":["#6c635f","#887e73","#ada393","#cbc1b0"],"grass":["#2e5628","#447632","#609243","#84ac50"],"joint":"#463d40","leaves":["#1e3c22","#2e562a","#467a36","#68983e","#8ab250"],"moss":["#424d2c","#5d6b3c","#7d8a4c"],"outline":"#2b2427","stem":"#4e3c28","stone":["#635a57","#72686a","#827872","#9c9289","#bdb3a4"],"top":["#776e62","#9c9382","#afa694","#c0b7a5","#d6cebd"],"vault":"#231d20"},"parts":{"coping":["#4b4346","#6e665f","#8c8377","#a29a8b","#b8af9f","#d3cab9"],"face":["#463d40","#635a57","#72686a","#827872","#90867e","#9c9289","#aaa094","#bdb3a4"],"top":["#776e62","#979c74","#9c9382","#afa694","#b2b48a","#c0b7a5","#d6cebd"]},"spurs":{"height":28,"reach":12},"streaks":{"share":0.04},"weeds":{"share":0.1}}},{"cell":{"blocking":{"tilePos":121,"tilesetId":"lpc-terrain"},"occlusion":{"tilePos":121,"tilesetId":"lpc-terrain"}},"id":"castle-wall","itemType":"castle-wall","kind":"wall","layerId":"sprite","name":"Castle wall","notes":{"1":"south end of a north-south run: one tile on the cell, the column\'s foot","2":"east end of an east-west run: cap above, base","3":"bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise","5":"west end of an east-west run: cap above, base","6":"bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise","8":"middle of an east-west run (and the only index a door may stand on): cap above, base","9":"T with its stem north (walls west, east and north): the cap re-points the stem\'s foot","13":"north end of a north-south run: one tile on the cell, the column\'s top; a different top when the wall south-east of it is an east end (index 2)","14":"middle of a north-south run: one tile on the cell","15":"top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)","16":"west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)","18":"top-left corner (walls east and south): cap above, base","19":"east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall\'s base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap","21":"T with its stem south (walls west, east and south): cap above, base","22":"cross (walls on all four sides): the cap re-points the wall above","47":"a lone wall: cap above, base"},"ornaments":{"arrow-slit":{"tiles":{"878":898}},"cracked-coping":{"scatter":0.08,"tiles":{"873":899}},"putlogs":{"scatter":0.07,"tiles":{"878":900}},"sunken-coping":{"scatter":0.06,"tiles":{"873":901}},"weeds":{"scatter":0.07,"tiles":{"873":902}}},"rules":{"1":[{"tile":870}],"2":[{"dy":-1,"tile":881},{"tile":885}],"3":[{"choose":[{"emit":[{"dy":-1,"tile":883}],"when":{"index":[18,19],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":888}]}]},{"tile":891}],"5":[{"dy":-1,"tile":871},{"tile":876}],"6":[{"choose":[{"emit":[{"dy":-1,"tile":884}],"when":{"index":[15,16],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":886}]}]},{"tile":889}],"8":[{"dy":-1,"tile":873},{"tile":878}],"9":[{"dy":-1,"tile":896},{"tile":878}],"13":[{"choose":[{"emit":[{"tile":880}],"when":{"index":[2],"neighbour":[1,1]}},{"emit":[{"tile":875}]}]}],"14":[{"tile":882}],"15":[{"dy":-1,"tile":874},{"choose":[{"emit":[{"tile":895}],"when":{"exists":[1,0]}},{"emit":[{"tile":879}]}]}],"16":[{"choose":[{"emit":[{"dy":-1,"tile":893}],"when":{"index":[18],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":897}]}]},{"tile":879}],"18":[{"dy":-1,"tile":872},{"tile":877}],"19":[{"choose":[{"emit":[{"tile":883}],"when":{"all":[{"exists":[-1,0]},{"neighbour":[1,0]}]}},{"emit":[{"dy":-1,"tile":880}],"when":{"not":{"exists":[-1,-1]}}},{"emit":[{"dy":-1,"tile":894}]}]},{"tile":877}],"21":[{"dy":-1,"tile":887},{"tile":890}],"22":[{"dy":-1,"tile":892},{"tile":890}],"47":[{"dy":-1,"tile":873},{"tile":878}]},"seams":{"covered":{"871":{"tilePos":903,"tilesetId":"authored-terrain"},"872":{"tilePos":904,"tilesetId":"authored-terrain"},"873":{"tilePos":905,"tilesetId":"authored-terrain"},"874":{"tilePos":906,"tilesetId":"authored-terrain"},"880":{"tilePos":907,"tilesetId":"authored-terrain"},"881":{"tilePos":908,"tilesetId":"authored-terrain"},"883":{"tilePos":909,"tilesetId":"authored-terrain"},"884":{"tilePos":910,"tilesetId":"authored-terrain"},"886":{"tilePos":911,"tilesetId":"authored-terrain"},"887":{"tilePos":912,"tilesetId":"authored-terrain"},"888":{"tilePos":913,"tilesetId":"authored-terrain"},"892":{"tilePos":914,"tilesetId":"authored-terrain"},"893":{"tilePos":915,"tilesetId":"authored-terrain"},"894":{"tilePos":916,"tilesetId":"authored-terrain"},"896":{"tilePos":917,"tilesetId":"authored-terrain"},"897":{"tilePos":918,"tilesetId":"authored-terrain"},"899":{"tilePos":919,"tilesetId":"authored-terrain"},"901":{"tilePos":920,"tilesetId":"authored-terrain"},"902":{"tilePos":921,"tilesetId":"authored-terrain"}},"lintel":{"tilePos":922,"tilesetId":"authored-terrain"},"style":"seamless"},"shadow":{"body":{"depth":18,"left":3,"right":29}},"tilesetId":"authored-terrain","trims":{"arch":{"maxSpan":3,"ring":6,"rise":26},"coping":{"lengths":[7,16]},"creepers":{"reach":[1,3.5],"share":0.2,"spread":14},"foot":{"moss":0.45,"rubble":0.45,"tufts":0.5},"masonry":{"ground":{"rows":[0,30],"splits":[[31],[20,11],[11,20],[15,16],[14,17]],"widths":[14,18,22,26,30,36,44]},"upper":{"rows":[0,30],"splits":[[16,15],[10,10,11],[9,22],[20,11],[12,19],[31],[11,20]],"widths":[10,12,14,16,20,24,28]}},"palette":{"dressed":["#6c635f","#887e73","#ada393","#cbc1b0"],"grass":["#2e5628","#447632","#609243","#84ac50"],"joint":"#463d40","leaves":["#1e3c22","#2e562a","#467a36","#68983e","#8ab250"],"moss":["#424d2c","#5d6b3c","#7d8a4c"],"outline":"#2b2427","stem":"#4e3c28","stone":["#635a57","#72686a","#827872","#9c9289","#bdb3a4"],"top":["#776e62","#9c9382","#afa694","#c0b7a5","#d6cebd"],"vault":"#231d20"},"parts":{"coping":["#4b4346","#6e665f","#8c8377","#a29a8b","#b8af9f","#d3cab9"],"face":["#463d40","#635a57","#72686a","#827872","#90867e","#9c9289","#aaa094","#bdb3a4"],"top":["#776e62","#979c74","#9c9382","#afa694","#b2b48a","#c0b7a5","#d6cebd"]},"spurs":{"height":26,"reach":10},"streaks":{"share":0.05},"weeds":{"share":0.12}}},{"cell":{"blocking":{"tilePos":121,"tilesetId":"lpc-terrain"}},"id":"castle-merlons","itemType":"castle-merlons","kind":"wall","layerId":"sprite","name":"Merlons","ornaments":{"weathered":{"scatter":0.3,"tiles":{"923":924}}},"parapet":true,"rules":{"1":[{"tile":923}],"2":[{"tile":923}],"3":[{"tile":923}],"5":[{"tile":923}],"6":[{"tile":923}],"8":[{"tile":923}],"9":[{"tile":923}],"13":[{"tile":923}],"14":[{"tile":923}],"15":[{"tile":923}],"16":[{"tile":923}],"18":[{"tile":923}],"19":[{"tile":923}],"21":[{"tile":923}],"22":[{"tile":923}],"47":[{"tile":923}]},"shadow":{"block":{"bottom":29,"height":12,"left":7,"right":25,"top":17}},"tilesetId":"authored-terrain"},{"cell":{"blocking":{"tilePos":121,"tilesetId":"lpc-terrain"},"occlusion":{"tilePos":121,"tilesetId":"lpc-terrain"}},"id":"tower-render","itemType":"tower-render","kind":"wall","layerId":"sprite","name":"Tower render","notes":{"1":"south end of a north-south run: one tile on the cell, the column\'s foot","2":"east end of an east-west run: cap above, base","3":"bottom-right corner (walls north and west). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-left corner or an east T (index 18/19), the plain one otherwise","5":"west end of an east-west run: cap above, base","6":"bottom-left corner (walls north and east). Its cap lands on the wall above and re-points that wall\'s tile: the joint under a top-right corner or a west T (index 15/16), the plain one otherwise","8":"middle of an east-west run (and the only index a door may stand on): cap above, base","9":"T with its stem north (walls west, east and north): the cap re-points the stem\'s foot","13":"north end of a north-south run: one tile on the cell, the column\'s top; a different top when the wall south-east of it is an east end (index 2)","14":"middle of a north-south run: one tile on the cell","15":"top-right corner (walls west and south): cap above, base. The other base needs a tile already east of the cell, which no wall puts there (only another feature on the layer)","16":"west T (walls north, west and south): its cap re-points the wall above, with the joint under a top-left corner (index 18)","18":"top-left corner (walls east and south): cap above, base","19":"east T (walls north, east and south). The cap re-points the wall above: the joint when no tile is north-west of the cell, the other when a wall\'s base already is. If a tile already sits west of the cell (no wall puts one there), it draws on the cell instead, the base re-points that tile, and there is no cap","21":"T with its stem south (walls west, east and south): cap above, base","22":"cross (walls on all four sides): the cap re-points the wall above","47":"a lone wall: cap above, base"},"ornaments":{"arrow-slit":{"tiles":{"933":953}},"crack":{"scatter":0.09,"tiles":{"933":954}},"damp":{"scatter":0.07,"tiles":{"933":955}},"patch":{"scatter":0.06,"tiles":{"933":956}},"putlogs":{"scatter":0.07,"tiles":{"933":957}},"spall":{"scatter":0.06,"tiles":{"933":958}},"spall-high":{"scatter":0.05,"tiles":{"933":959}},"tie-plate":{"scatter":0.05,"tiles":{"933":960}}},"rules":{"1":[{"tile":925}],"2":[{"dy":-1,"tile":936},{"tile":940}],"3":[{"choose":[{"emit":[{"dy":-1,"tile":938}],"when":{"index":[18,19],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":943}]}]},{"tile":946}],"5":[{"dy":-1,"tile":926},{"tile":931}],"6":[{"choose":[{"emit":[{"dy":-1,"tile":939}],"when":{"index":[15,16],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":941}]}]},{"tile":944}],"8":[{"dy":-1,"tile":928},{"tile":933}],"9":[{"dy":-1,"tile":951},{"tile":933}],"13":[{"choose":[{"emit":[{"tile":935}],"when":{"index":[2],"neighbour":[1,1]}},{"emit":[{"tile":930}]}]}],"14":[{"tile":937}],"15":[{"dy":-1,"tile":929},{"choose":[{"emit":[{"tile":950}],"when":{"exists":[1,0]}},{"emit":[{"tile":934}]}]}],"16":[{"choose":[{"emit":[{"dy":-1,"tile":948}],"when":{"index":[18],"neighbour":[0,-1]}},{"emit":[{"dy":-1,"tile":952}]}]},{"tile":934}],"18":[{"dy":-1,"tile":927},{"tile":932}],"19":[{"choose":[{"emit":[{"tile":938}],"when":{"all":[{"exists":[-1,0]},{"neighbour":[1,0]}]}},{"emit":[{"dy":-1,"tile":935}],"when":{"not":{"exists":[-1,-1]}}},{"emit":[{"dy":-1,"tile":949}]}]},{"tile":932}],"21":[{"dy":-1,"tile":942},{"tile":945}],"22":[{"dy":-1,"tile":947},{"tile":945}],"47":[{"dy":-1,"tile":928},{"tile":933}]},"seams":{"covered":{"926":{"tilePos":961,"tilesetId":"authored-terrain"},"927":{"tilePos":962,"tilesetId":"authored-terrain"},"928":{"tilePos":963,"tilesetId":"authored-terrain"},"929":{"tilePos":964,"tilesetId":"authored-terrain"},"935":{"tilePos":965,"tilesetId":"authored-terrain"},"936":{"tilePos":966,"tilesetId":"authored-terrain"},"938":{"tilePos":967,"tilesetId":"authored-terrain"},"939":{"tilePos":968,"tilesetId":"authored-terrain"},"941":{"tilePos":969,"tilesetId":"authored-terrain"},"942":{"tilePos":970,"tilesetId":"authored-terrain"},"943":{"tilePos":971,"tilesetId":"authored-terrain"},"947":{"tilePos":972,"tilesetId":"authored-terrain"},"948":{"tilePos":973,"tilesetId":"authored-terrain"},"949":{"tilePos":974,"tilesetId":"authored-terrain"},"951":{"tilePos":975,"tilesetId":"authored-terrain"},"952":{"tilePos":976,"tilesetId":"authored-terrain"}},"lintel":{"tilePos":977,"tilesetId":"authored-terrain"},"style":"seamless"},"tilesetId":"authored-terrain","trims":{"arch":{"maxSpan":2,"ring":5,"rise":22},"continuous":true,"creepers":{"reach":[1.5,4.5],"share":0.12,"spread":12},"damp":{"height":[4,10]},"foot":{"moss":0.35,"rubble":0.3,"tufts":0.55},"palette":{"dressed":["#6c635f","#887e73","#ada393","#cbc1b0"],"grass":["#2e5628","#447632","#609243","#84ac50"],"joint":"#755733","leaves":["#1e3c22","#2e562a","#467a36","#68983e","#8ab250"],"moss":["#424d2c","#5d6b3c","#7d8a4c"],"outline":"#2e2421","stem":"#4e3c28","stone":["#8c693c","#9c7746","#ab854f","#c49d64","#d9b982"],"top":["#a99f8b","#c6bca8","#d7cfbd","#e4ddcd","#f1ebdf"],"vault":"#231d20"},"parts":{"coping":["#8a6a43","#b08e5c","#cbb48b","#dfd5c1","#f4efe4"],"face":["#755733","#8c693c","#9c7746","#ab854f","#b28b54","#b99159","#be975e","#c2a274","#c49d64","#ccb085","#cfab73","#d9b982","#e2d3b0"],"top":["#a99f8b","#c6bca8","#d7cfbd","#ddd6c5","#e4ddcd","#e9e3d5","#f1ebdf"]},"quoins":{"course":8,"long":11,"short":6},"streaks":{"share":0.06},"weeds":{"share":0.06}}}],"version":1},"classes":[{"characteristics":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"id":"armor"},{"characteristics":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"id":"bauldron"},{"characteristics":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"id":"cape"},{"characteristics":{"exclusiveReadiness":true,"readyable":true},"id":"key"},{"characteristics":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"id":"pants"},{"characteristics":{"disallowedClassesOnActive":["weapon","structure"],"exclusiveReadiness":true,"readyable":true,"stackable":true},"id":"resource"},{"characteristics":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"id":"shield"},{"characteristics":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"id":"shirt"},{"characteristics":{"equippable":true,"exclusiveReadiness":true,"readyable":true},"id":"shoes"},{"characteristics":{"disallowedClassesOnActive":["weapon","resource"],"exclusiveReadiness":true,"readyable":true,"stableAngleOnDrop":true,"unbuyable":true},"id":"structure"},{"characteristics":{"disallowedClassesOnActive":["resource","structure"],"equippable":true,"exclusiveReadiness":true,"hasDurability":true,"readyable":true},"id":"weapon"}],"ember":{"about":"Ember humanoid equipment as data. MODELS say what a garment, shield or weapon is made of -- volumes hung on the solved skeleton, cut and painted -- in the expression language of game-common/ember_sprite/expr.ts; DESIGNS bind an item type to a model and its parameters. See game-common/ember_sprite/model.ts.","designs":[{"handling":{},"id":"axe","model":"axe","slot":"held"},{"handling":{"rest":{"out":75,"wrist":60}},"id":"dagger","model":"dagger","slot":"held"},{"handling":{"frame":112,"rest":{"out":15,"wrist":18}},"id":"longsword","model":"longsword","slot":"held"},{"handling":{"frame":112,"rest":{"out":15,"wrist":18}},"id":"saber","model":"saber","slot":"held"},{"handling":{"twoHanded":true},"id":"bow","model":"bow","slot":"held"},{"handling":{},"id":"mace","model":"mace","slot":"held"},{"handling":{},"id":"warhammer","model":"warhammer","slot":"held"},{"handling":{},"id":"flail","model":"flail","slot":"held"},{"handling":{"frame":112,"twoHanded":true},"id":"waraxe","model":"waraxe","slot":"held"},{"handling":{"frame":128,"polearm":true,"twoHanded":true},"id":"halberd","model":"halberd","slot":"held"},{"handling":{"frame":128,"polearm":true,"twoHanded":true},"id":"scythe","model":"scythe","slot":"held"},{"handling":{"frame":112,"rest":{"out":15,"wrist":18}},"id":"rapier","model":"rapier","slot":"held"},{"handling":{},"id":"iron-pickaxe","model":"iron-pickaxe","slot":"held"},{"handling":{"frame":128,"polearm":true,"twoHanded":true},"id":"spear","model":"spear","slot":"held"},{"handling":{"frame":128,"polearm":true,"twoHanded":true},"id":"staff","model":"staff","slot":"held"},{"handling":{"twoHanded":true},"icon":{"tilt":50,"turn":40},"id":"crossbow","model":"crossbow","slot":"held"},{"bind":{"chargeMaterial":"rampFrom(\'#9b2a24\')","field":"tincture(\'white\')","rim":"SHIELD_STEEL"},"id":"shield-crusader","model":"shield","params":{"charge":"cross","shape":"heater"},"slot":"shield"},{"bind":{"field":"tincture(color)","rim":"SHIELD_STEEL"},"id":"shield-kite","model":"shield","params":{"shape":"heater"},"slot":"shield"},{"bind":{"chargeMaterial":"tincture(color)","field":"tincture(\'blue\')","rim":"SHIELD_BRASS"},"id":"shield-kite_blue","model":"shield","params":{"charge":"chevron","shape":"heater"},"slot":"shield"},{"bind":{"chargeMaterial":"tincture(color)","field":"tincture(\'gray\')","rim":"SHIELD_BRASS"},"id":"shield-kite_gray","model":"shield","params":{"charge":"chevron","shape":"heater"},"slot":"shield"},{"bind":{"chargeMaterial":"tincture(color)","field":"tincture(\'green\')","rim":"SHIELD_BRASS"},"id":"shield-kite_green","model":"shield","params":{"charge":"chevron","shape":"heater"},"slot":"shield"},{"bind":{"chargeMaterial":"tincture(color)","field":"tincture(\'red\')","rim":"SHIELD_BRASS"},"id":"shield-kite_red","model":"shield","params":{"charge":"chevron","shape":"heater"},"slot":"shield"},{"bind":{"field":"SHIELD_WOOD","rim":"SHIELD_IRON"},"id":"shield-round","model":"shield","params":{"shape":"round"},"slot":"shield"},{"bind":{"chargeMaterial":"metalFrom(\'#6e4a1f\')","field":"SHIELD_BRONZE","rim":"SHIELD_BRONZE"},"id":"shield-spartan","model":"shield","params":{"charge":"lambda","metal":true,"shape":"aspis"},"slot":"shield"},{"id":"shoes","model":"shoes","slot":"shoes"},{"id":"boots","model":"boots","slot":"shoes"},{"id":"slippers","model":"slippers","slot":"shoes"},{"id":"sandals","model":"sandals","slot":"shoes"},{"id":"shoes-armor","model":"sabatons","slot":"shoes"},{"id":"pants","model":"trousers","slot":"pants"},{"id":"pantaloons","model":"pantaloons","slot":"pants"},{"id":"skirts","model":"skirt","slot":"pants"},{"id":"legion","model":"legion","slot":"pants"},{"id":"pants-armor","model":"greaves","slot":"pants"},{"id":"longsleeve","model":"shirt","params":{"sleeves":"long"},"slot":"shirt"},{"id":"longsleeve_laced","model":"shirt","params":{"neck":"laced","sleeves":"long"},"slot":"shirt"},{"id":"sleeveless","model":"shirt","params":{"neck":"scoop","sleeves":"none"},"slot":"shirt"},{"id":"sleeveless_laced","model":"shirt","params":{"neck":"laced","sleeves":"none"},"slot":"shirt"},{"id":"sleeveless_striped","model":"shirt","params":{"neck":"scoop","pattern":"stripes","sleeves":"none"},"slot":"shirt"},{"id":"blouse","model":"shirt","params":{"neck":"scoop","puffed":true,"sleeves":"short"},"slot":"shirt"},{"id":"blouse_longsleeve","model":"shirt","params":{"neck":"scoop","puffed":true,"sleeves":"long"},"slot":"shirt"},{"id":"corset","model":"shirt","params":{"neck":"low","pattern":"lacing","sleeves":"none"},"slot":"shirt"},{"id":"scoop_shirt","model":"shirt","params":{"neck":"scoop","sleeves":"short"},"slot":"shirt"},{"id":"tanktop","model":"shirt","params":{"neck":"low","sleeves":"none"},"slot":"shirt"},{"id":"tunic","model":"shirt","params":{"hem":"thigh","sleeves":"none","tunic":true},"slot":"shirt"},{"id":"armor-leather","model":"leather","slot":"armor"},{"id":"armor-legion","model":"legion","slot":"armor"},{"id":"armor-plate","model":"plate","slot":"armor"},{"id":"bauldron","model":"bauldron","slot":"bauldron"}],"library":[["AXE_HAFT","rampFrom(\'#8a5b34\')"],["AXE_HEAD","rampFrom(\'#a3acb5\')"],["SWORD_STEEL","rampFrom(\'#c3cbd3\', \'#4b525e\')","Materials (rampFrom / metalFrom ramps) the game\'s weapons are made of: AXE_HAFT AXE_HEAD SWORD_STEEL SWORD_BRASS SWORD_GRIP DAGGER_GRIP DAGGER_GUARD BOW_WOOD BOW_GRIP BOW_STRING ARROW_SHAFT ARROW_HEAD ARROW_FLETCH IRON DARK_WOOD STAFF_WOOD STAFF_GEM RAPIER_GOLD CROSSBOW_STOCK."],["SWORD_BRASS","rampFrom(\'#b8924a\')"],["SWORD_GRIP","rampFrom(\'#4a2e22\')"],["DAGGER_GRIP","rampFrom(\'#5b3a26\')"],["DAGGER_GUARD","rampFrom(\'#8d7a55\')"],["BOW_WOOD","rampFrom(\'#a8692f\')"],["BOW_GRIP","rampFrom(\'#4a3022\')"],["BOW_STRING","rampFrom(\'#ddd5c2\')"],["ARROW_SHAFT","rampFrom(\'#c29a68\')"],["ARROW_HEAD","rampFrom(\'#a9b2ba\')"],["ARROW_FLETCH","rampFrom(\'#b0443a\')"],["IRON","rampFrom(\'#7d848c\', \'#2f3338\')"],["DARK_WOOD","rampFrom(\'#5e3b22\')"],["STAFF_WOOD","rampFrom(\'#9b6a3c\')"],["STAFF_GEM","rampFrom(\'#5fc4e8\', \'#1f4c66\')"],["RAPIER_GOLD","rampFrom(\'#d6b04a\', \'#5a4520\')"],["CROSSBOW_STOCK","rampFrom(\'#8a3e2c\', \'#3a1a12\')"],["bladeFrame",{"fn":["j","d"],"let":[["across","sub(j.edge, scale(d, dot(j.edge, d)))"],["edge","dot(across, across) > 1e-6 ? normalize(across) : normalize(cross(d, [1, 0, 0]))"],["thin","normalize(cross(edge, d))"]],"return":"{ edge, thin, basis: [thin[0], d[0], edge[0], thin[1], d[1], edge[1], thin[2], d[2], edge[2]] }"},"bladeFrame(j, d) -> { edge, thin, basis }: a blade\'s frame from the hand\'s joints j and its axis d -- edge across its width, in the plane the wrist bends in (j.edge), thin through its flat; basis is [thin, d, edge] as a Mat3."],["blade",{"fn":["base","d","edge","thin","length","width","point","thick","curve","steel"],"let":[["bow","curve ?? 0"],["m","steel ?? SWORD_STEEL"],["at","u => add(add(base, scale(d, u * length)), scale(edge, -bow * length * u * u))"],["slice",{"fn":["i"],"let":[["u0","i / 8"],["u1","(i + 1) / 8"],["a","at(u0)"],["b","at(u1)"],["along","normalize(sub(b, a))"],["across","normalize(cross(thin, along))"],["basis","[thin[0], along[0], across[0], thin[1], along[1], across[1], thin[2], along[2], across[2]]"],["half","sqrt(dot(sub(b, a), sub(b, a))) / 2"],["u","(u0 + u1) / 2"],["w","u < 0.65 ? width + (point - width) * 0.25 * (u / 0.65) : width * 0.75 + (point - width * 0.75) * ((u - 0.65) / 0.35)"]],"return":"ellipsoid(scale(add(a, b), 0.5), basis, [thick, half * 1.35, w], m, \'held\')"}]],"return":"range(8).map(i => slice(i))"},"blade(base, d, edge, thin, length, width, point, thick, curve?, steel?) -> 8 ellipsoids: a flat blade from base along d, width across (along edge) narrowing to point at the tip, thick through the flat; curve sweeps it back off the edge (a share of its length); steel defaults to SWORD_STEEL. Group \'held\'."],["around",{"fn":["d"],"let":[["a","normalize(abs(d[1]) < 0.9 ? cross(d, [0, 1, 0]) : cross(d, [1, 0, 0]))"]],"return":"[a, normalize(cross(d, a))]"},"around(d) -> [a, b]: two unit vectors square to d and to each other: a frame round a shaft."],["spikes",{"fn":["at","d","r","length","m"],"let":[["ab","around(d)"],["spike",{"fn":["i"],"let":[["t","(i / 6) * 2 * PI"],["out","add(scale(ab[0], cos(t)), scale(ab[1], sin(t)))"]],"return":"segment(add(at, scale(out, r * 0.6)), add(at, scale(out, r + length)), max(0.7, r * 0.3), m, \'held\')"}]],"return":"[...range(6).map(i => spike(i)), segment(at, add(at, scale(d, r + length)), max(0.7, r * 0.3), m, \'held\')]"},"spikes(at, d, r, length, m) -> segments: six spikes standing out of a ball of radius r round at, square to d, and one off its end along d."],["haft",{"fn":["fist","d","length","behind","r","m"],"let":[["butt","add(fist, scale(d, -length * behind))"],["tip","add(fist, scale(d, length * (1 - behind)))"]],"return":"{ butt, tip, prim: capsule(butt, tip, r, m, \'held\') }"},"haft(fist, d, length, behind, r, m) -> { butt, tip, prim }: a capsule haft through the fist along d, `behind` (a share of its length) below the fist, the rest ahead; prim is the capsule (group \'held\')."],["TINCTURES",{"blue":"#3e63a0","gray":"#8b9096","green":"#4f7a3a","orange":"#c06a2c","red":"#a33a33","white":"#dcd6c8"}],["tincture","name => rampFrom(TINCTURES[name] ?? TINCTURES.gray)","tincture(name) -> a heraldic paint ramp (TINCTURES: white gray blue green red orange; others gray)."],["SHIELD_STEEL","metalFrom(\'#9aa2aa\')"],["SHIELD_IRON","metalFrom(\'#5d6268\')"],["SHIELD_BRASS","metalFrom(\'#b8924a\')"],["SHIELD_WOOD","rampFrom(\'#7a5134\')"],["SHIELD_BACK","rampFrom(\'#5e4029\')"],["SHIELD_BRONZE","metalFrom(\'#a5712f\')"],["SHIELD_TURN","{ front: deg(15), back: deg(25), left: deg(55), right: deg(-55), frontleft: deg(35), frontright: deg(-20), backleft: deg(40), backright: deg(-15) }","Per facing, how far (radians) a shield\'s face is turned from the body\'s forward toward the camera."],["ARMOR_COLORS",{"leather":{"blue":"#3d5170","brown":"#6b4a30","green":"#4c5f36"},"legion":{"brown":"#a5712f","gold":"#c39a34","gray":"#87919b"},"plate":{"gold":"#c39a34","gray":"#6b727a","metal":"#88929c","orange":"#b0662f","tan":"#9e8866","yellow":"#c2a240"}},"Body armour\'s base colours by kind (leather, legion, plate), by the item colour\'s name; plate\'s metals are also sabatons\' and greaves\'."],["shoeOf",{"fn":["sk","p","side","by","m","footWidth","keep"],"let":[["j","sk[side]"]],"return":"{ ...foot(j.heel, j.toe, p.footRadius + by, footWidth + by, m, legOf(side)), ...(keep ? { keep } : {}) }"},"shoeOf(sk, p, side, by, m, footWidth, keep?) -> the side\'s foot volume `by` off the skin in m, cut by keep (a (q) => boolean on the foot\'s own frame: q[2] forward, q[1] up)."],["LEGION_LEATHER","rampFrom(\'#5e3017\')","The legionary skirt\'s leather (LEGION_TUNIC its red tunic)."],["LEGION_TUNIC","rampFrom(\'#8e2a22\')"],["skirtLike",{"fn":["sk","p","m","t","hem","lining","slice"],"let":[["off","lining.off ?? 0.5 + 0.3 * t"],["endOf","j => hem <= 1 ? lerp(j.hip, j.knee, hem) : lerp(j.knee, j.ankle, hem - 1)"],["liningOf",{"cases":[["hem <= 1","[capsule(lerp(j.hip, end, lining.from ?? 0), end, p.thighRadius + off, lining.m, \'skirt\')]"]],"fn":["side"],"let":[["j","sk[side]"],["end","endOf(j)"]],"return":"[segment(j.hip, j.knee, p.thighRadius + off, lining.m, \'skirt\'), joint(j.knee, p.shinRadius * 0.9 + off, lining.m, \'skirt\'), segment(j.knee, end, p.shinRadius + off, lining.m, \'skirt\')]"}],["path",{"fn":["side"],"let":[["j","sk[side]"],["end","endOf(j)"],["knee","hem <= 1 ? end : j.knee"],["upper","sqrt(dot(sub(knee, j.hip), sub(knee, j.hip)))"],["lower","hem <= 1 ? 0 : sqrt(dot(sub(end, j.knee), sub(end, j.knee)))"],["at",{"cases":[["d <= upper","{ at: lerp(j.hip, knee, d / upper), along: normalize(sub(knee, j.hip)) }"]],"fn":["f"],"let":[["d","f * (upper + lower)"]],"return":"{ at: lerp(j.knee, end, (d - upper) / lower), along: normalize(sub(end, j.knee)) }"}]],"return":"{ length: upper + lower, at }"}],["legL","path(\'L\')"],["legR","path(\'R\')"],["N","max(4, round(hem * 6))"],["spacing","(legL.length + legR.length) / 2 / N"],["sliceAt",{"fn":["i"],"let":[["f","i / N"],["a","legL.at(f)"],["b","legR.at(f)"],["center","scale(add(a.at, b.at), 0.5)"],["y","normalize(scale(add(a.along, b.along), -1))"],["span","sub(a.at, b.at)"],["flat","sub(span, scale(y, dot(span, y)))"],["x","dot(flat, flat) > 1e-6 ? normalize(flat) : normalize(apply(sk.pelvisBasis, [1, 0, 0]))"],["z","normalize(cross(x, y))"],["basis","[x[0], y[0], z[0], x[1], y[1], z[1], x[2], y[2], z[2]]"],["slant","max(0.6, min(-dot(a.along, y), -dot(b.along, y)))"],["legRadius","hem <= 1 || f < 0.5 ? p.thighRadius : p.shinRadius"],["reach","(legRadius + 0.5 + 0.6 * t + (hem / 1.7) * f) / slant"],["half","sqrt(dot(flat, flat)) / 2"],["radii","[half + reach, spacing * 1.2, reach]"],["toWorld","q => add(center, apply(basis, q))"]],"return":"ellipsoid(center, basis, radii, m, \'skirt\', { exponent: [3.5, 4, 3.5], ...(slice ? slice(i, N, radii, toWorld) : {}) })"}]],"return":"[...lowerBody(sk, p, m, 0.9 * t, undefined, true).map(prim => ({ ...prim, group: \'skirt\' })), ...liningOf(\'L\'), ...liningOf(\'R\'), ...range(N).map(k => sliceAt(k + 1))]"},"skirtLike(sk, p, m, t, hem, lining, slice?) -> one volume round both legs from the hips to `hem` (in leg segments: 0.55 mid-thigh, 1 the knee, 1.7 the lower calf): the hips, a lining per leg (lining: { m, from?, off? }) and a stack of drum slices spanning the legs; slice(i, n, radii, toWorld) may add a decal or keep to each slice. Group \'skirt\'."],["LACE","rampFrom(\'#e6dcc4\')"],["ARMOR_BUCKLE","metalFrom(\'#c3c8cc\')"],["BAULDRON_COLORS",{"brown":"#5a2410"}],["BAULDRON_TIP","metalFrom(\'#9a9a9a\')"]],"models":{"armor":{"leather":{"about":"A leather jerkin to the hips, belted at the waist, a metal buckle at the front; the cloth ramp\'s softer light.","let":[["base","(tones && tones[color]) ?? ARMOR_COLORS.leather[color] ?? ARMOR_COLORS.leather.brown"],["m","rampFrom(base)"],["by","0.9 * t + 0.1"],["chest","upperBody(sk, p, m, by, facing).filter(prim => prim.group === \'torso\' || prim.group === \'bust\')"],["hips","lowerBody(sk, p, m, by + 0.15, q => q[1] > -p.pelvis[1] * 0.5)"],["up","apply(sk.torsoBasis, [0, 1, 0])"],["across","apply(sk.torsoBasis, [1, 0, 0])"],["ahead","apply(sk.torsoBasis, [0, 0, 1])"],["waist","add(sk.pelvis, apply(sk.pelvisBasis, [0, p.pelvis[1] * 0.45, 0]))"],["belt","[p.pelvis[0] + by + 0.9, 1.0, p.pelvis[2] + by + 0.9]"]],"params":{"color":"brown","tones":null},"parts":["chest","hips","ellipsoid(waist, sk.pelvisBasis, belt, rampFrom(\'#3a2a20\'), \'torso\', { exponent: [3, 4, 3], decal: q => (abs(q[0]) < 1.0 && q[2] > 0 ? ARMOR_BUCKLE.light : undefined) })"]},"legion":{"about":"A legionary\'s banded cuirass: overlapping bands round the torso to the waist, following its lean, a dark seam a pixel wide where each overlaps the next; metal\'s own light (sheen).","let":[["base","(tones && tones[color]) ?? ARMOR_COLORS.legion[color] ?? ARMOR_COLORS.legion.brown"],["m","metalFrom(base)"],["by","1.0 * t + 0.35"],["chest","upperBody(sk, p, m, by, facing).filter(prim => prim.group === \'torso\' || prim.group === \'bust\')"],["hips","lowerBody(sk, p, m, by + 0.15, q => q[1] > -p.pelvis[1] * 0.05)"],["up","apply(sk.torsoBasis, [0, 1, 0])"],["across","apply(sk.torsoBasis, [1, 0, 0])"],["ahead","apply(sk.torsoBasis, [0, 0, 1])"],["band","2.6"],["shine","sheen(m, facing)"]],"params":{"color":"brown","tones":null},"parts":[{"paint":{"fn":["w","n"],"let":[["y","dot(sub(w, sk.chest), up) / band"]],"return":"y - floor(y) < 0.38 ? m.deep : shine(n)"},"parts":["chest","hips"]}]},"plate":{"about":"A plate breastplate: a rigid shell, not the body\'s own shape -- swelling out ahead of the chest, a barrel in profile, ending in a flared fauld over the hips (a hard edge cloth never has) -- with a raised ridge down its middle, lit on the side toward the light, shadowed beside it; metal\'s own light.","let":[["base","(tones && tones[color]) ?? ARMOR_COLORS.plate[color] ?? ARMOR_COLORS.plate.gray"],["m","metalFrom(base)"],["by","1.0 * t + 0.35"],["chest","upperBody(sk, p, m, by, facing).filter(prim => prim.group === \'torso\' || prim.group === \'bust\')"],["hips","lowerBody(sk, p, m, by + 0.15, q => q[1] > -p.pelvis[1] * 0.25)"],["up","apply(sk.torsoBasis, [0, 1, 0])"],["across","apply(sk.torsoBasis, [1, 0, 0])"],["ahead","apply(sk.torsoBasis, [0, 0, 1])"],["breast","add(sk.chest, apply(sk.torsoBasis, [0, -0.4, p.posture + 0.7]))"],["shell","ellipsoid(breast, sk.torsoBasis, [p.torso[0] + by * 0.6, p.torso[1] * 0.9 + by, p.torso[2] + by + 0.5], m, \'torso\', { exponent: [3, 2.4, 2] })"],["fauldAt","add(sk.pelvis, apply(sk.pelvisBasis, [0, p.pelvis[1] * 0.15, 0.2]))"],["fauld","ellipsoid(fauldAt, sk.pelvisBasis, [p.pelvis[0] + by + 0.8, 1.4, p.pelvis[2] + by + 0.9], m, \'torso\', { exponent: [2.6, 4, 2.6] })"],["shine","sheen(m, facing)"]],"params":{"color":"gray","tones":null},"parts":[{"paint":{"cases":[["ridge && x > -0.6 && x <= 0.3","m.light"],["ridge && x > 0.3 && x < 1.1","m.deep"]],"fn":["w","n"],"let":[["v","sub(w, sk.chest)"],["x","dot(v, across)"],["ridge","dot(v, ahead) > 0 && dot(v, up) > -p.spine"]],"return":"shine(n)"},"parts":["chest","shell","hips","fauld"]}]}},"bauldron":{"bauldron":{"about":"The game\'s bauldron, as LPC draws it: a leather pauldron capping the RIGHT shoulder, two lames deep, hard-edged and standing off whatever the shoulder wears (a sleeve or not), hidden side-on with that shoulder away; and its strap (a baldric), PAINTED over every torso surface -- skin, shirt or armour, whichever the camera sees -- from the top of the right shoulder down across the chest to the left side and the same way round the back, its steel tip hanging at the left side in front.","let":[["m","rampFrom((tones && tones[color]) ?? BAULDRON_COLORS[color] ?? BAULDRON_COLORS.brown)"],["under","look.shirt && look.shirt.sleeves !== \'none\' ? 0.6 * t : 0"],["hidden","(facing === \'left\' || facing === \'right\') && farSide(facing) === \'R\'"],["j","sk.R"],["out","apply(sk.torsoBasis, [sideSign(\'R\'), 0, 0])"],["lit","lighting(facing)"],["r","p.deltoidRadius + under + 0.9"],["cap","add(j.shoulder, apply(sk.torsoBasis, [sideSign(\'R\') * 0.6, 0.7, 0]))"],["dome","ellipsoid(cap, sk.torsoBasis, [r + 0.2, r * 0.8, r + 0.2], m, \'armR\', { part: \'pauldron\', keep: q => q[1] > -r * 0.35 })"],["arm","distance(j.shoulder, j.elbow)"],["lame","as(segment(j.shoulder, lerp(j.shoulder, j.elbow, 0.45), p.upperArmRadius + under + 0.7, m, \'armR\'), \'pauldron\')"],["lower","{ ...lame, keep: q => dot(apply(lame.basis, q), out) > -0.3 && q[1] < arm * 0.12 }"],["sAcross","apply(sk.torsoBasis, [1, 0, 0])"],["sUp","apply(sk.torsoBasis, [0, 1, 0])"],["sAhead","apply(sk.torsoBasis, [0, 0, 1])"],["shoulder","sub(sk.R.shoulder, sk.chest)"],["from","[dot(shoulder, sAcross) * 0.7, dot(shoulder, sUp) + p.deltoidRadius * 0.6]"],["to","[p.torso[0] * 0.95, -p.torso[1] * 0.55]"],["run","[to[0] - from[0], to[1] - from[1]]"],["runLength","hypot(run[0], run[1])"],["dir","[run[0] / runLength, run[1] / runLength]"],["half","max(1.05, p.torso[0] * 0.13)"],["strap",{"cases":[["s < -half * 2 || s > runLength","undefined"],["abs(d) > half","undefined"],["s > runLength - half * 1.6 && dot(v, sAhead) > 0","tone(BAULDRON_TIP, lit(n))"]],"fn":["w","n"],"let":[["v","sub(w, sk.chest)"],["x","dot(v, sAcross) - from[0]"],["y","dot(v, sUp) - from[1]"],["s","x * dir[0] + y * dir[1]"],["d","x * -dir[1] + y * dir[0]"]],"return":"d < -half * 0.35 ? m.deep : tone(m, min(2, lit(n)))"}]],"overBody":{"groups":["torso","bust","shoulder"],"paint":"strap"},"params":{"color":"brown","tones":null},"parts":[{"parts":[{"paint":{"fn":["w","n"],"let":[["below","dot(sub(w, cap), apply(sk.torsoBasis, [0, 1, 0]))"]],"return":"abs(below + r * 0.3) < 0.45 ? m.deep : tone(m, lit(n))"},"parts":["dome","lower"]}],"when":"!hidden"}]}},"belt":{"belt":{"about":"A belt: a flat band round the pelvis at the top of the hips, over whatever is worn there.","let":[["m","cloth(dye)"],["waist","add(sk.pelvis, apply(sk.pelvisBasis, [0, p.pelvis[1] * 0.55, 0]))"]],"params":{"dye":"black"},"parts":["ellipsoid(waist, sk.pelvisBasis, [p.pelvis[0] + 1.3 * t, 0.9, p.pelvis[2] + 1.3 * t], m, \'torso\', { exponent: p.pelvisRoundness })"]}},"held":{"axe":{"about":"A woodsman\'s axe in the fist: a haft through the hand along its grip, the iron head at the far end with its edge on the forearm\'s side of the haft -- the side that leads when the arm chops. Sized to the body that holds it.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","normalize(j.grip)"],["forearm","normalize(sub(j.hand, j.elbow))"],["across","sub(forearm, scale(d, dot(forearm, d)))"],["edge","dot(across, across) > 1e-6 ? normalize(across) : normalize(cross(d, [1, 0, 0]))"],["len","leg * 0.93"],["r","max(0.8, leg * 0.042)"],["butt","add(fist, scale(d, -len * 0.12))"],["tip","add(fist, scale(d, len * 0.88))"],["thin","normalize(cross(edge, d))"],["basis","[thin[0], d[0], edge[0], thin[1], d[1], edge[1], thin[2], d[2], edge[2]]"],["bladeAt","add(add(tip, scale(d, -len * 0.1)), scale(edge, len * 0.09))"],["pollAt","add(add(tip, scale(d, -len * 0.09)), scale(edge, -len * 0.05))"]],"parts":["capsule(butt, tip, r, AXE_HAFT, \'held\')","ellipsoid(bladeAt, basis, [r * 0.9, len * 0.15, len * 0.16], AXE_HEAD, \'held\', { exponent: [2, 2.6, 2.2] })","ellipsoid(pollAt, basis, [r * 1.1, len * 0.06, len * 0.06], AXE_HEAD, \'held\', { exponent: 2.6 })"]},"bow":{"about":"A longbow in the LEFT hand, about as tall as the man: its limbs run along the hand\'s grip (biased to upright) and curve back toward the archer at the tips, further the harder it is drawn (the skeleton\'s draw). Undrawn the string runs tip to tip; drawn, to the right hand at the jaw, an arrow nocked there and laid across the bow hand.","let":[["leg","legLength(p)"],["draw","sk.draw ?? 0"],["grip","fistCenter(sk, p, \'L\')"],["nock","fistCenter(sk, p, \'R\')"],["axis","normalize(add(normalize(sk.L.grip), [0, 1.5, 0]))"],["aim","draw > 0 ? sub(grip, nock) : apply(sk.pelvisBasis, [0, 0, 1])"],["ahead0","sub(aim, scale(axis, dot(aim, axis)))"],["ahead","dot(ahead0, ahead0) > 1e-6 ? normalize(ahead0) : normalize(cross(axis, [1, 0, 0]))"],["half","leg * 0.85"],["bend","0.1 + 0.22 * draw"],["r0","max(1.9, leg * 0.07)"],["at","u => add(add(grip, scale(axis, u * half * (1 - 0.15 * bend * u * u))), scale(ahead, -bend * half * u * u))"],["limb",{"fn":["i"],"let":[["u0","-1 + (2 * i) / 12"],["u1","-1 + (2 * (i + 1)) / 12"],["mid","(u0 + u1) / 2"],["material","abs(mid) < 0.12 ? BOW_GRIP : BOW_WOOD"]],"return":"capsule(at(u0), at(u1), r0 * (1 - 0.4 * mid * mid), material, \'held\')"}],["top","at(1)"],["bottom","at(-1)"],["flight","normalize(sub(grip, nock))"],["arrowTip","add(nock, scale(flight, leg * 0.82))"]],"parts":["range(12).map(i => limb(i))",{"else":["capsule(top, bottom, 0.5, BOW_STRING, \'held\')"],"parts":["capsule(top, nock, 0.5, BOW_STRING, \'held\')","capsule(nock, bottom, 0.5, BOW_STRING, \'held\')","capsule(nock, arrowTip, 0.42, ARROW_SHAFT, \'held\')","ellipsoid(arrowTip, sk.torsoBasis, [0.7, 0.7, 0.7], ARROW_HEAD, \'held\')","capsule(nock, add(nock, scale(flight, leg * 0.1)), 0.7, ARROW_FLETCH, \'held\')"],"when":"draw > 0"}]},"crossbow":{"about":"A crossbow: a stock along the grip from behind the fist, a prod across its front swept back at the tips (lying flat whatever the stock does), the string drawn back to the nut and a bolt along the top.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","normalize(j.grip)"],["r","max(1.0, leg * 0.045)"],["back","add(fist, scale(d, -leg * 0.14))"],["front","add(fist, scale(d, leg * 0.45))"],["level","cross(d, [0, 1, 0])"],["across","dot(level, level) > 1e-6 ? normalize(level) : around(d)[0]"],["up","normalize(cross(across, d))"],["nut","add(fist, scale(d, leg * 0.16))"],["prod",{"fn":["s"],"let":[["tipAt","add(add(front, scale(across, s * leg * 0.3)), scale(d, -leg * 0.08))"]],"return":"[capsule(front, tipAt, max(0.8, leg * 0.03), BOW_GRIP, \'held\'), capsule(tipAt, nut, 0.45, BOW_STRING, \'held\')]"}]],"parts":["capsule(back, front, r, CROSSBOW_STOCK, \'held\')","prod(1)","prod(-1)","capsule(add(nut, scale(up, r * 0.8)), add(front, add(scale(d, leg * 0.06), scale(up, r * 0.8))), 0.5, ARROW_SHAFT, \'held\')"]},"dagger":{"about":"A dagger in the fist: a short handle, a small crossguard and a blade two-fifths of the leg long, laid along the blade\'s line (between the grip and the forearm). Its blade by the item\'s colour: metal is steel, brown bronze.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","bladeAxis(j)"],["r","max(0.9, leg * 0.032)"],["pommel","add(fist, scale(d, -leg * 0.09))"],["guardAt","add(fist, scale(d, leg * 0.07))"],["frame","bladeFrame(j, d)"],["blades","{ metal: rampFrom(\'#b9c2cb\', \'#4b525e\'), brown: rampFrom(\'#b5824a\', \'#5a3a22\') }"],["steel","blades[color ?? \'metal\'] ?? blades.metal"]],"params":{"color":"metal"},"parts":["capsule(pommel, guardAt, r, DAGGER_GRIP, \'held\')","ellipsoid(guardAt, frame.basis, [r * 1.2, r, leg * 0.09], DAGGER_GUARD, \'held\')","blade(guardAt, d, frame.edge, frame.thin, leg * 0.42, max(1.8, leg * 0.07), 0.6, max(1.1, leg * 0.04), 0, steel)"]},"flail":{"about":"A flail: a short haft, a chain from its end drooping under the ball, a spiked iron ball.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","normalize(j.grip)"],["h","haft(fist, d, leg * 0.45, 0.2, max(0.8, leg * 0.038), DARK_WOOD)"],["hr","max(2.6, leg * 0.09)"],["chain","normalize(add(d, [0, -1.4, 0]))"],["ball","add(h.tip, scale(chain, leg * 0.3))"]],"parts":["h.prim","[1, 2, 3].map(i => ellipsoid(lerp(h.tip, ball, i / 4), [1, 0, 0, 0, 1, 0, 0, 0, 1], [1, 1, 1], IRON, \'held\'))","ellipsoid(ball, [1, 0, 0, 0, 1, 0, 0, 0, 1], [hr, hr, hr], IRON, \'held\')","spikes(ball, chain, hr, max(1.2, leg * 0.04), IRON)"]},"halberd":{"about":"A halberd: a pole taller than its bearer, an axe blade and a spike at the top, a hook behind.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","normalize(j.grip)"],["len","leg * 1.85"],["r","max(0.9, leg * 0.038)"],["h","haft(fist, d, len, 0.35, r, DARK_WOOD)"],["frame","bladeFrame(j, d)"],["bladeAt","add(add(h.tip, scale(d, -leg * 0.13)), scale(frame.edge, leg * 0.13))"]],"parts":["h.prim","segment(h.tip, add(h.tip, scale(d, leg * 0.26)), max(1.0, leg * 0.035), SWORD_STEEL, \'held\')","ellipsoid(bladeAt, frame.basis, [r * 0.9, leg * 0.2, leg * 0.14], SWORD_STEEL, \'held\', { exponent: [2, 2.6, 2] })","segment(add(h.tip, scale(d, -leg * 0.1)), add(add(h.tip, scale(d, -leg * 0.06)), scale(frame.edge, -leg * 0.14)), max(0.7, leg * 0.026), SWORD_STEEL, \'held\')"]},"iron-pickaxe":{"about":"An iron pickaxe: a haft and, square across its end, a pick bar drawn to a point both ways, each arm curving down toward the hand.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","normalize(j.grip)"],["h","haft(fist, d, leg * 0.85, 0.12, max(0.8, leg * 0.04), AXE_HAFT)"],["edge","bladeFrame(j, d).edge"],["arm",{"fn":["s"],"let":[["mid","add(add(h.tip, scale(edge, s * leg * 0.12)), scale(d, -leg * 0.015))"],["end","add(add(h.tip, scale(edge, s * leg * 0.24)), scale(d, -leg * 0.07))"]],"return":"[capsule(h.tip, mid, max(1.1, leg * 0.04), IRON, \'held\'), capsule(mid, end, max(0.7, leg * 0.026), IRON, \'held\')]"}]],"parts":["h.prim","arm(1)","arm(-1)"]},"longsword":{"about":"A longsword: a straight double-edged blade about a leg long (never under 24px), a cross of brass quillons, a grip long enough for both hands, a wheel pommel.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","swordAxis(j)"],["frame","bladeFrame(j, d)"],["edge","frame.edge"],["guardAt","add(fist, scale(d, p.handRadius + 0.3))"],["pommelAt","add(fist, scale(d, -(twoHandSpan(p) + p.handRadius + 0.4)))"],["quillon","max(3.6, leg * 0.15)"]],"parts":["blade(guardAt, d, edge, frame.thin, max(24, leg * 0.95), max(2.2, leg * 0.085), 0.7, max(1.4, leg * 0.05))","capsule(add(guardAt, scale(edge, -quillon)), add(guardAt, scale(edge, quillon)), max(1.0, leg * 0.04), SWORD_BRASS, \'held\')","capsule(guardAt, pommelAt, max(1.0, leg * 0.036), SWORD_GRIP, \'held\')","ellipsoid(pommelAt, frame.basis, [1.3, 1.4, 1.8], SWORD_BRASS, \'held\')"]},"mace":{"about":"A mace: a short haft and a flanged iron head, heavy enough to read as one.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","normalize(j.grip)"],["h","haft(fist, d, leg * 0.6, 0.15, max(0.9, leg * 0.04), DARK_WOOD)"],["hr","max(3, leg * 0.1)"],["head","add(h.tip, scale(d, -hr * 0.3))"]],"parts":["h.prim","ellipsoid(head, [1, 0, 0, 0, 1, 0, 0, 0, 1], [hr, hr, hr], IRON, \'held\')","spikes(head, d, hr, max(1.4, leg * 0.045), IRON)"]},"rapier":{"about":"A rapier: a long, narrow, straight blade for the point, and a gold swept hilt -- a cup at the guard, quillons across it and a knuckle-bow round the fingers to the pommel.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","swordAxis(j)"],["frame","bladeFrame(j, d)"],["edge","frame.edge"],["guardAt","add(fist, scale(d, p.handRadius + 0.3))"],["capAt","add(fist, scale(d, -(p.handRadius + 0.4)))"],["r","max(0.8, leg * 0.03)"],["bow","u => add(add(guardAt, scale(d, -u * (p.handRadius * 2 + 0.7))), scale(edge, (p.handRadius + 0.7) * sin(PI * min(1, u * 1.15)) + 0.6))"]],"parts":["blade(guardAt, d, edge, frame.thin, max(22, leg * 0.95), max(1.4, leg * 0.05), 0.4, max(1.0, leg * 0.035))","range(4).map(i => capsule(bow(i / 4), bow((i + 1) / 4), r, RAPIER_GOLD, \'held\'))","ellipsoid(guardAt, [1, 0, 0, 0, 1, 0, 0, 0, 1], [1.5, 1.5, 1.5], RAPIER_GOLD, \'held\')","capsule(add(guardAt, scale(edge, -2.2)), add(guardAt, scale(edge, 2.2)), max(0.8, leg * 0.03), RAPIER_GOLD, \'held\')","ellipsoid(capAt, [1, 0, 0, 0, 1, 0, 0, 0, 1], [1.2, 1.2, 1.2], RAPIER_GOLD, \'held\')"]},"saber":{"about":"A cavalry saber: a single-edged blade sweeping back off its edge (never under 20px), a short grip, a brass knuckle-bow from the guard round the fist to the pommel cap.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","swordAxis(j)"],["frame","bladeFrame(j, d)"],["edge","frame.edge"],["guardAt","add(fist, scale(d, p.handRadius + 0.2))"],["capAt","add(fist, scale(d, -(p.handRadius + 0.3)))"],["bow","u => add(add(guardAt, scale(d, -u * (p.handRadius * 2 + 0.5))), scale(edge, (p.handRadius + 0.6) * sin(PI * min(1, u * 1.15)) + 0.6))"],["r","max(0.8, leg * 0.03)"]],"parts":["blade(guardAt, d, edge, frame.thin, max(20, leg * 0.85), max(2.0, leg * 0.075), 0.6, max(1.2, leg * 0.045), 0.12)","range(4).map(i => capsule(bow(i / 4), bow((i + 1) / 4), r, SWORD_BRASS, \'held\'))","capsule(add(guardAt, scale(edge, -1.2)), add(guardAt, scale(edge, 1.2)), max(0.9, leg * 0.034), SWORD_BRASS, \'held\')","ellipsoid(capAt, [1, 0, 0, 0, 1, 0, 0, 0, 1], [1.2, 1.2, 1.2], SWORD_BRASS, \'held\')"]},"scythe":{"about":"A scythe: a long snath and, square to it at the top, a long blade curving down toward the hands.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","normalize(j.grip)"],["len","leg * 1.7"],["h","haft(fist, d, len, 0.28, max(0.9, leg * 0.036), DARK_WOOD)"],["edge","bladeFrame(j, d).edge"],["thin","normalize(cross(d, edge))"]],"parts":["h.prim","blade(h.tip, edge, d, thin, leg * 0.75, max(2.0, leg * 0.07), 0.5, max(1.1, leg * 0.035), 0.3)"]},"spear":{"about":"A spear: a long shaft and a leaf-shaped iron point on a socket.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","normalize(j.grip)"],["h","haft(fist, d, leg * 1.95, 0.35, max(0.8, leg * 0.034), DARK_WOOD)"],["basis","bladeFrame(j, d).basis"]],"parts":["h.prim","ellipsoid(add(h.tip, scale(d, leg * 0.12)), basis, [max(0.9, leg * 0.03), leg * 0.15, max(1.8, leg * 0.065)], SWORD_STEEL, \'held\')","ellipsoid(h.tip, basis, [1.1, 1.0, 1.1], IRON, \'held\')"]},"staff":{"about":"A staff: a tall plain stave and, held in a knot of its wood at the top, a blue gem (LPC\'s).","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","normalize(j.grip)"],["h","haft(fist, d, leg * 1.8, 0.3, max(1.0, leg * 0.042), STAFF_WOOD)"],["gr","max(1.6, leg * 0.06)"],["gem","add(h.tip, scale(d, gr * 0.9))"],["a","around(d)[0]"]],"parts":["h.prim","ellipsoid(h.tip, [1, 0, 0, 0, 1, 0, 0, 0, 1], [gr * 0.9, gr * 0.9, gr * 0.9], STAFF_WOOD, \'held\')","segment(add(h.tip, scale(a, gr * 0.8)), add(gem, scale(a, gr * 0.9)), 0.6, STAFF_WOOD, \'held\')","segment(add(h.tip, scale(a, -gr * 0.8)), add(gem, scale(a, -gr * 0.9)), 0.6, STAFF_WOOD, \'held\')","ellipsoid(gem, [1, 0, 0, 0, 1, 0, 0, 0, 1], [gr, gr, gr], STAFF_GEM, \'held\')"]},"waraxe":{"about":"A war axe: a great axe for two hands, a long haft and a crescent blade either side of its head.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","normalize(j.grip)"],["len","leg * 1.15"],["r","max(0.9, leg * 0.042)"],["h","haft(fist, d, len, 0.25, r, DARK_WOOD)"],["frame","bladeFrame(j, d)"],["at","add(h.tip, scale(d, -len * 0.12))"]],"parts":["h.prim","ellipsoid(add(at, scale(frame.edge, len * 0.12)), frame.basis, [r * 0.9, len * 0.19, len * 0.12], AXE_HEAD, \'held\', { exponent: [2, 2.4, 2] })","ellipsoid(add(at, scale(frame.edge, -len * 0.1)), frame.basis, [r * 0.9, len * 0.15, len * 0.1], AXE_HEAD, \'held\', { exponent: [2, 2.4, 2] })"]},"warhammer":{"about":"A warhammer: a haft with a squared iron block across its end, a spike behind.","let":[["j","sk.R"],["fist","fistCenter(sk, p, \'R\')"],["leg","legLength(p)"],["d","normalize(j.grip)"],["h","haft(fist, d, leg * 0.78, 0.15, max(0.8, leg * 0.04), DARK_WOOD)"],["frame","bladeFrame(j, d)"],["hr","max(2.6, leg * 0.09)"],["head","add(h.tip, scale(d, -hr * 0.5))"]],"parts":["h.prim","ellipsoid(add(head, scale(frame.edge, hr * 0.5)), frame.basis, [hr * 0.95, hr * 1.1, hr * 1.8], IRON, \'held\', { exponent: 4 })","segment(head, add(head, scale(frame.edge, -hr * 2.4)), max(0.7, hr * 0.35), IRON, \'held\')"]}},"pants":{"greaves":{"about":"Armoured leg wear, LPC\'s steel leggings: plate over the seat, cuisses down each thigh in three overlapping lames, a cop standing proud over the knee, a greave down the shin to the ankle, in the plate armour\'s metals. Shaded as legs are (LPC\'s greaves are dark steel); only the knee cop takes the glint. Each plate is a limb segment of its own, so the raster lines it where it overlaps the next.","let":[["m","metalFrom(ARMOR_COLORS.plate[dye] ?? ARMOR_COLORS.plate.metal)"],["lit","lighting(facing)"],["by","0.6 * t + 0.25"]],"params":{"dye":"metal"},"parts":["lowerBody(sk, p, m, by + 0.1, undefined, true)",{"as":"side","each":"SIDES","let":[["j","sk[side]"],["g","legOf(side)"],["along","normalize(sub(j.knee, j.hip))"],["lame","distance(j.hip, j.knee) / 3"]],"parts":[{"paint":{"fn":["w"],"let":[["d","dot(sub(w, j.hip), along) / lame"]],"return":"d > 0.8 && d < 2.8 && d - floor(d) < 0.3 ? m.deep : undefined"},"parts":["thighOf(sk, side, p, by, m, g).map(prim => as(prim, \'thigh\'))"]},{"paint":"(_w, n) => (lit(n) === 0 ? m.light : undefined)","parts":["as(joint(j.knee, p.shinRadius * 0.9 + by + 0.6, m, g), \'knee\')"]},"shinOf(sk, side, p, by, m, g, 0.94).map(prim => as(prim, \'shin\'))"]}]},"legion":{"about":"A legionary\'s pteruges: a short skirt of leather straps hanging from a studded belt to mid-thigh, each strap tipped with a brass stud and hanging free at the bottom, where the red tunic worn under it shows between them. Straps run round the body\'s own upright axis, the same for every slice, so a seam falls straight down the skirt. The item comes in one colour.","let":[["ax","apply(sk.pelvisBasis, [1, 0, 0])"],["az","apply(sk.pelvisBasis, [0, 0, 1])"],["strap",{"fn":["world","count"],"let":[["v","sub(world, sk.pelvis)"]],"return":"((atan2(dot(v, az), dot(v, ax)) / (2 * PI) + 0.5) * (count ?? 12)) % 1"}],["slice",{"fn":["i","n","radii","toWorld"],"let":[["free","i > n * 0.55"]],"return":"{ decal: q => strapDecal(q, i, n, radii, toWorld), keep: free ? (q => strap(toWorld(q)) >= 0.34) : undefined }"}],["strapDecal",{"cases":[["u < 0.3","LEGION_LEATHER.line"],["i === n && u > 0.5 && u < 0.85 && abs(q[1]) < radii[1] * 0.45","SWORD_BRASS.base"]],"fn":["q","i","n","radii","toWorld"],"let":[["u","strap(toWorld(q))"]],"return":"undefined"}],["waist","add(sk.pelvis, apply(sk.pelvisBasis, [0, p.pelvis[1] * 0.55, 0]))"],["beltRadii","[p.pelvis[0] + 1.6 * t, 1.1, p.pelvis[2] + 1.6 * t]"]],"params":{"dye":"brown"},"parts":["skirtLike(sk, p, LEGION_LEATHER, t, 0.55, { m: LEGION_TUNIC, from: 0.5, off: 0.3 }, slice)",{"as":"side","each":"SIDES","let":[["j","sk[side]"]],"parts":["capsule(j.hip, lerp(j.hip, j.knee, 0.15), p.thighRadius + 0.2, LEGION_LEATHER, \'skirt\')"]},"ellipsoid(waist, sk.pelvisBasis, beltRadii, LEGION_LEATHER, \'skirt\', { exponent: [3, 4, 3], decal: q => (strap(add(waist, apply(sk.pelvisBasis, q)), 12) < 0.72 ? SWORD_BRASS.base : LEGION_LEATHER.deep) })"]},"pantaloons":{"about":"Pantaloons: loose, full trousers. Roomy through the seat and thigh, blousing over the knee and calf, then gathered into a band three-quarters of the way down the shin, the ankle left bare. The fullness hangs off the OUTSIDE of each leg, as the cut drapes, so the legs stay apart below the seat.","let":[["m","cloth(dye)"],["loose","0.8 + 0.7 * t"]],"params":{"dye":"brown"},"parts":["lowerBody(sk, p, m, 0.8 * t, undefined, true)",{"as":"side","each":"SIDES","let":[["j","sk[side]"],["band","lerp(j.knee, j.ankle, 0.74)"],["out","scale(apply(sk.pelvisBasis, [sideSign(side), 0, 0]), loose * 0.45)"]],"parts":["segment(add(j.hip, scale(out, 0.5)), add(j.knee, out), p.thighRadius + loose, m, legOf(side))","joint(add(j.knee, out), p.shinRadius * 0.9 + loose * 1.1, m, legOf(side))","segment(add(j.knee, out), add(band, scale(out, 0.6)), p.shinRadius + loose * 1.2, m, legOf(side))","as(capsule(lerp(j.knee, j.ankle, 0.7), lerp(j.knee, j.ankle, 0.8), p.shinRadius * 0.8 + 0.35 * t, m, legOf(side)), \'band\')"]}]},"shorts":{"about":"Shorts: trousers cut at the knee.","params":{"cut":"shorts","dye":"brown"},"parts":[{"use":"trousers","with":{"cut":"shorts"}}]},"skirt":{"about":"A skirt to the lower calf, round both legs, the feet stepping out beneath it.","let":[["m","cloth(dye)"]],"params":{"dye":"brown"},"parts":["skirtLike(sk, p, m, t, 1.7, { m })"]},"trousers":{"about":"Trousers (and `shorts`, cut at the knee): the hips, a thigh and a knee per leg, and the shin to the ankle, each the body\'s own volume a little off it.","let":[["m","cloth(dye)"]],"params":{"cut":"trousers","dye":"brown"},"parts":["lowerBody(sk, p, m, 0.5 * t, undefined, true)",{"as":"side","each":"SIDES","let":[["j","sk[side]"]],"parts":["thighOf(sk, side, p, 0.45 * t, m, legOf(side))","joint(j.knee, p.shinRadius * 0.9 + 0.4 * t, m, legOf(side))",{"parts":["shinOf(sk, side, p, 0.4 * t, m, legOf(side), 0.92)"],"when":"cut !== \'shorts\'"}]}]}},"shield":{"shield":{"about":"A shield gripped in the LEFT fist (a centre grip, as LPC holds every shield), its face turned toward the camera for the facing, or slung on the back (`slung`) while that hand has a bow. A heater is a flat slab cut to a point below; a round shield a disc with an iron rim and boss over planks; the aspis a bronze dome with a raised rim. Paint is lit here (decals skip the raster\'s shading); the back shows bare wood. Parameters: shape (heater | round | aspis), field and rim (materials, usually bound: tincture(color), SHIELD_WOOD), charge (cross | chevron | lambda, in chargeMaterial), metal (a polished face), size (1 the game\'s own; 0.7 a buckler).","let":[["leg","legLength(p)"],["up","apply(sk.torsoBasis, [0, 1, 0])"],["w","(shape === \'heater\' ? max(6.5, leg * 0.3) : max(8, leg * (shape === \'aspis\' ? 0.42 : 0.38))) * size"],["h","shape === \'heater\' ? max(9, leg * 0.42) * size : w"],["thick","shape === \'aspis\' ? 2.8 : 0.9"],["turn","SHIELD_TURN[facing]"],["face","slung ? apply(sk.torsoBasis, [0.25, 0, -1]) : apply(sk.torsoBasis, [sin(turn), 0, cos(turn)])"],["center","slung ? add(sk.chest, apply(sk.torsoBasis, [0.5, -1.5, -(p.torso[2] + thick + 1.2)])) : add(fistCenter(sk, p, \'L\'), scale(face, p.handRadius * 0.7 + thick))"],["n","normalize(face)"],["x","normalize(cross(up, n))"],["y","normalize(cross(n, x))"],["basis","[x[0], y[0], n[0], x[1], y[1], n[1], x[2], y[2], n[2]]"],["toLocal","world => apply(transpose(basis), sub(world, center))"],["halfWidth","yn => (shape !== \'heater\' ? sqrt(max(0, 1 - yn * yn)) : yn > -0.2 ? 1 : sqrt(max(0, 1 - ((-0.2 - yn) / 0.8) ** 2)))"],["stroke",{"fn":["xn","yn","sx"],"let":[["ax","0"],["ay","0.5"],["bx","sx * 0.42"],["by","-0.5"],["t","max(0, min(1, ((xn - ax) * (bx - ax) + (yn - ay) * (by - ay)) / ((bx - ax) ** 2 + (by - ay) ** 2)))"]],"return":"hypot(xn - (ax + t * (bx - ax)), yn - (ay + t * (by - ay))) < 0.09"}],["charged",{"cases":[["!charge","false"],["charge === \'cross\'","(abs(xn) < 0.14 && yn > -0.7 && yn < 0.8) || (abs(yn - 0.3) < 0.11 && abs(xn) < 0.62)"],["charge === \'chevron\'","abs(yn - (0.35 - 0.85 * abs(xn))) < 0.14"]],"fn":["xn","yn"],"return":"stroke(xn, yn, 1) || stroke(xn, yn, -1)"}],["lit","lighting(facing)"],["shine","sheen(field, facing)"],["rimWidth","shape === \'aspis\' ? 1.5 : 1.1"],["paint",{"cases":[["lz < 0","tone(SHIELD_BACK, step)"],["edge < rimWidth || (shape !== \'heater\' && hypot(lx, ly) > w - rimWidth)","tone(rim, step)"],["charged(xn, yn)","tone(chargeMaterial, step)"],["metal","shine(normal)"],["shape === \'round\' && ((lx / 2.6) % 1 + 1) % 1 < 0.2","tone(field, min(3, step + 1))"]],"fn":["world","normal"],"let":[["l","toLocal(world)"],["lx","l[0]"],["ly","l[1]"],["lz","l[2]"],["step","lit(normal)"],["xn","lx / w"],["yn","ly / h"],["edge","min(w * halfWidth(yn) - abs(lx), shape === \'heater\' ? h - ly : w * 9)"]],"return":"tone(field, step)"}],["slab","ellipsoid(center, basis, [w, h, thick], field, \'held\', { exponent: shape === \'heater\' ? [6, 6, 2] : shape === \'round\' ? [2, 2, 4] : [2, 2, 2], keep: shape === \'heater\' ? q => abs(q[0]) <= w * halfWidth(q[1] / h) : undefined })"],["shineBoss","sheen(SHIELD_IRON, facing)"]],"params":{"charge":null,"chargeMaterial":null,"color":"white","field":null,"metal":false,"rim":null,"shape":"heater","size":1,"slung":false},"parts":["painted([slab], paint)",{"parts":["painted([ellipsoid(add(center, scale(n, thick * 0.8)), basis, [w * 0.24, w * 0.24, 1.5], SHIELD_IRON, \'held\')], (_w, normal) => shineBoss(normal))"],"when":"shape === \'round\' && !slung"}]}},"shirt":{"shirt":{"about":"A shirt: the body\'s chest, shoulders and hips inflated in the dye (sleeveless leaves the deltoids bare), down to the belt -- or, on a body with a waist, to the waist\'s narrowest, where leg wear begins -- or over the hips as a `tunic` (with `hem: \'thigh\'` a skirt to mid-thigh); sleeves `short` or `long`, `puffed` at the shoulder. A neckline (`scoop`, `low`, `laced`) and a pattern (`stripes`, `lacing`) are PAINTED in the body\'s own skin and lace, lit as the cloth is: they never change the silhouette.","let":[["m","cloth(dye)"],["shoulders","upperBody(sk, p, m, 0.6 * t, facing)"],["top","p.waist ? (p.pelvisLow ?? 0) + (p.waistHeight ?? 0) : -p.pelvis[1] * 0.1"],["lit","lighting(facing)"],["up","apply(sk.torsoBasis, [0, 1, 0])"],["across","apply(sk.torsoBasis, [1, 0, 0])"],["ahead","apply(sk.torsoBasis, [0, 0, 1])"],["collar","p.torso[1] * 0.92"],["white","cloth(\'white\')"],["laced","(x, y) => (((y + abs(x) * 1.6) / 2.0) % 1 + 1) % 1 < 0.34"],["paint",{"cases":[["(neck === \'scoop\' || neck === \'low\') && front && abs(x) < width && y > collar - depth * (1 - (x / width) ** 2)","tone(skin, step)"],["(neck === \'scoop\' || neck === \'low\') && low && abs(x) > width + 1.4 && y > collar - p.torso[1] * 0.3","tone(skin, step)"],["neck === \'laced\' && front && abs(x) < (y - (collar - vDepth)) * 0.5","laced(x, y) ? tone(LACE, step) : tone(skin, step)"],["pattern === \'stripes\' && (((y / 1.8) % 1) + 1) % 1 < 0.45","tone(white, step)"],["pattern === \'lacing\' && front && abs(x) < 1.7 && y < collar - p.torso[1] * 0.4 && laced(x, y)","tone(LACE, step)"]],"fn":["w","n"],"let":[["v","sub(w, sk.chest)"],["x","dot(v, across)"],["y","dot(v, up)"],["front","dot(v, ahead) > 0"],["step","lit(n)"],["low","neck === \'low\'"],["width","p.shoulderWidth * (low ? 0.55 : 0.42)"],["depth","p.torso[1] * (low ? 0.45 : 0.28)"],["vDepth","p.torso[1] * 0.75"]],"return":"undefined"}],["body","[...(sleeves === \'none\' ? shoulders.filter(s => s.group === \'torso\' || s.group === \'bust\') : shoulders), ...lowerBody(sk, p, m, (tunic ? 1.1 : 0.85) * t, tunic ? undefined : q => q[1] > top)]"],["puff","puffed ? 0.5 + 0.6 * t : 0"]],"params":{"dye":"white","hem":null,"neck":null,"pattern":null,"puffed":false,"sleeves":"none","tunic":false},"parts":["neck || pattern ? painted(body, paint) : body",{"as":"side","each":"SIDES","let":[["j","sk[side]"]],"parts":[{"parts":["segment(j.shoulder, lerp(j.shoulder, j.elbow, 0.6), p.upperArmRadius + 0.5 * t + puff, m, armOf(side))"],"when":"sleeves === \'short\'"},{"parts":["segment(j.shoulder, j.elbow, p.upperArmRadius + 0.5 * t, m, armOf(side))","joint(j.elbow, p.forearmRadius * 0.85 + 0.45 * t, m, armOf(side))","segment(j.elbow, lerp(j.elbow, j.hand, 0.8), p.forearmRadius + 0.45 * t, m, armOf(side))",{"parts":["segment(j.shoulder, lerp(j.shoulder, j.elbow, 0.4), p.upperArmRadius + 0.5 * t + puff, m, armOf(side))"],"when":"puff"}],"when":"sleeves === \'long\'"}]},{"parts":["skirtLike(sk, p, m, t, 0.45, { m })"],"when":"hem === \'thigh\'"}]}},"shoes":{"boots":{"about":"Boots: shoes, and a shaft climbing the shin almost halfway to the knee.","let":[["m","cloth(dye)"]],"params":{"dye":"brown"},"parts":[{"as":"side","each":"SIDES","let":[["j","sk[side]"]],"parts":["shoeOf(sk, p, side, 0.5 * t, m, footWidth)","capsule(j.ankle, lerp(j.ankle, j.knee, 0.45), p.shinRadius + 0.8 * t, m, legOf(side))"]}]},"sabatons":{"about":"Sabatons: steel plates across the foot, overlapping toward the toe, and a cuff over the ankle, in plate armour\'s metals with metal\'s own light.","let":[["m","metalFrom(ARMOR_COLORS.plate[dye] ?? ARMOR_COLORS.plate.metal)"]],"params":{"dye":"metal"},"parts":[{"as":"side","each":"SIDES","let":[["j","sk[side]"],["along","normalize(sub(j.toe, j.heel))"],["shine","sheen(m, facing)"]],"parts":[{"paint":{"fn":["w","n"],"let":[["d","dot(sub(w, j.heel), along) / 1.7"]],"return":"d > 1 && d - floor(d) < 0.3 ? m.deep : shine(n)"},"parts":["shoeOf(sk, p, side, 0.6 * t, m, footWidth)","capsule(j.ankle, lerp(j.ankle, j.knee, 0.22), p.shinRadius + 0.7 * t, m, legOf(side))"]}]}]},"sandals":{"about":"Sandals: the sole under the foot, straps criss-crossing over it with the skin between them, tied round the ankle. Stood well off the foot and over a pixel wide, or a small foot\'s straps never win a pixel.","let":[["m","cloth(dye)"],["by","0.5 + 0.3 * t"],["r","p.footRadius + by"],["strap","q => (((q[2] + abs(q[0]) * 1.2) / 2.4) % 1 + 1) % 1 < 0.5"]],"params":{"dye":"brown"},"parts":[{"as":"side","each":"SIDES","let":[["j","sk[side]"]],"parts":["shoeOf(sk, p, side, by, m, footWidth, q => q[1] < -r * 0.35 || strap(q))","ellipsoid(j.ankle, sk.pelvisBasis, [p.shinRadius * 0.8 + 0.8, 1.6, p.shinRadius * 0.8 + 0.8], m, legOf(side), { keep: q => abs(q[1]) < 0.7 })"]}]},"shoes":{"about":"Shoes: the foot\'s volume, half a pixel of leather off it, to the ankle.","let":[["m","cloth(dye)"]],"params":{"dye":"brown"},"parts":[{"as":"side","each":"SIDES","parts":["shoeOf(sk, p, side, 0.5 * t, m, footWidth)"]}]},"slippers":{"about":"Slippers: low all round, and a toe box over the front: the top of the foot behind it shows.","let":[["m","cloth(dye)"],["r","p.footRadius + 0.35 * t"]],"params":{"dye":"brown"},"parts":[{"as":"side","each":"SIDES","parts":["shoeOf(sk, p, side, 0.35 * t, m, footWidth, q => q[1] < r * 0.1 || q[2] > 0)"]}]}}},"version":1},"emberAnimations":{"about":"Animations made as data: PERFORMANCES any Ember body can play when something asks it to (the `/perform <name>` dev command, or whatever sets an entity\'s performance). Each is a keyframed clip like the game\'s own strikes and falls: KEYS -- poses of the whole body at times t from 0 to 1 -- eased between and drawn in `frames` frames of `frameMs` each, in every facing, on every body; `loop` plays it until it is stopped. A key says how the body rises (rise, px), shifts (shiftX), rolls, pitches forward from the pelvis (pitch: a bow), is let down onto whatever of it is lowest (ground, 0..1), bends forward (lean) and sideways (sideBend), turns its chest (twist; with hips and head given, those turn too), nods (headPitch); each arm as [pitch (raised forward: 90 level, 180 straight up), abduct (out to the side), flex (the elbow), wrist?] and each leg as planted feet [x out from the hip, z ahead] in px or angles [pitch, abduct, flex]. Angles in degrees. A name is lowercase letters, digits and _, never one of the game\'s actions.","animations":{"bow":{"about":"A courtly bow: the right hand brought across the chest, the left swept out behind, the body bent forward from the hips with the head down, held a moment, and back up.","frameMs":80,"frames":14,"keys":[{"armL":[8,12,20],"armR":[10,12,25],"feetL":[0.5,1.5],"feetR":[0.5,-1.5],"t":0},{"armL":[-35,30,10],"armR":[55,-40,95],"feetL":[0.5,1.5],"feetR":[0.5,-1.5],"headPitch":18,"pitch":34,"t":0.35},{"armL":[-35,30,10],"armR":[55,-40,95],"feetL":[0.5,1.5],"feetR":[0.5,-1.5],"headPitch":18,"pitch":34,"t":0.65},{"armL":[8,12,20],"armR":[10,12,25],"feetL":[0.5,1.5],"feetR":[0.5,-1.5],"t":1}]},"wave":{"about":"A friendly wave: the right arm raised high and swung side to side over the head twice, the body leaning a little away from it, and lowered.","frameMs":70,"frames":16,"keys":[{"armL":[8,12,20],"armR":[10,12,25],"feetL":[0.5,1],"feetR":[0.5,-1],"t":0},{"armL":[8,12,20],"armR":[155,55,25,150],"feetL":[0.5,1],"feetR":[0.5,-1],"headPitch":-6,"sideBend":-5,"t":0.2},{"armL":[8,12,20],"armR":[155,22,35,150],"feetL":[0.5,1],"feetR":[0.5,-1],"headPitch":-6,"sideBend":-5,"t":0.36},{"armL":[8,12,20],"armR":[155,55,25,150],"feetL":[0.5,1],"feetR":[0.5,-1],"headPitch":-6,"sideBend":-5,"t":0.52},{"armL":[8,12,20],"armR":[155,22,35,150],"feetL":[0.5,1],"feetR":[0.5,-1],"headPitch":-6,"sideBend":-5,"t":0.68},{"armL":[8,12,20],"armR":[155,55,25,150],"feetL":[0.5,1],"feetR":[0.5,-1],"headPitch":-6,"sideBend":-5,"t":0.84},{"armL":[8,12,20],"armR":[10,12,25],"feetL":[0.5,1],"feetR":[0.5,-1],"t":1}]}},"version":1},"emberBodies":{"about":"The Ember humanoid\'s body as data: what is hung on the solved skeleton (rig.ts, clips.ts) for its flesh, its bones, a beast\'s head and fur, a dead body\'s wounds -- in the model language of game-common/ember_sprite/model.ts and expr.ts, like equipment.json. The engine draws a body with the `human` model (a look may name another: look.body), then the FEATURES a look adds to it (look.features: models of slot `feature` -- horns, markings; Sprite Lab\'s creatures bring their own); its LIBRARY is the body\'s own volumes, which every garment in equipment.json is an inflated copy of (upperBody, lowerBody, thighOf, shinOf, legFrame), and the paint and materials the bodies use. A model sees the posed skeleton (sk), the body\'s proportions (p), the look, the facing, the skin\'s material (skin) and the foot\'s half-width this facing (footWidth).","features":{"horns":{"about":"A pair of horns from the top of the brow: rising out and up, then sweeping back the further they `curl` (0 straight, 1 swept right back over the skull). `length` is in heads (1 about the head\'s own height), `spread` how far they splay out, `thickness` their girth at the root; `color` the horn\'s, as #rrggbb.","let":[["a","p.head[0]"],["b","p.head[1]"],["c","p.head[2]"],["at","v => add(sk.head, apply(sk.headBasis, v))"],["m","rampFrom(color)"],["N","4"],["L","b * 1.7 * length"],["r0","max(1.5, a * 0.36) * thickness"],["horn",{"fn":["s"],"let":[["base","[s * a * 0.62, b * 0.78, c * 0.2]"],["d0","normalize([s * spread, 1, 0.2])"],["d1","normalize([s * spread * 1.4, -0.35, -1])"],["points","range(N).reduce((list, i) => [...list, add(list[list.length - 1], scale(normalize(lerp(d0, d1, curl * (i + 0.5) / N)), L / N))], [base])"]],"return":"taper(points.map(at), r0, max(0.7, r0 * 0.35), m, \'head\')"}]],"params":{"color":"#d8c9a0","curl":0.5,"length":1.4,"spread":0.5,"thickness":1},"parts":["horn(1)","horn(-1)"]},"markings":{"about":"Markings painted on the bare skin -- what is worn over them covers them: `stripes` (bands round the body and limbs, as a tiger\'s), `spots`, or `scars` (pale welts across chest, arms and thighs). `color` their colour (unset: a shade darker than the skin; scars: a shade lighter), `spacing` in pixels.","let":[["lit","lighting(facing)"],["m","color ? rampFrom(color) : skin"],["shade","n => color ? tone(m, lit(n)) : pattern === \'scars\' ? tone(skin, max(0, lit(n) - 1)) : lit(n) >= 2 ? skin.line : tone(skin, lit(n) + 2)"],["across","apply(sk.torsoBasis, [1, 0, 0])"],["up","apply(sk.torsoBasis, [0, 1, 0])"],["ahead","apply(sk.torsoBasis, [0, 0, 1])"],["mark",{"cases":[["pattern === \'stripes\'","((y + 1.4 * sin(x * 0.55 + z * 0.4)) / spacing % 1 + 1) % 1 < 0.34 ? shade(n) : undefined"],["pattern === \'spots\'","hash3(floor(x / spacing), floor(y / spacing), floor(z / spacing)) % 7 === 0 ? shade(n) : undefined"]],"fn":["w","n"],"let":[["v","sub(w, sk.chest)"],["x","dot(v, across)"],["y","dot(v, up)"],["z","dot(v, ahead)"]],"return":"abs(((x * 0.8 - y) / spacing / 2.5 % 1 + 1) % 1 - 0.5) < 0.06 && hash3(floor((x + y) / 6), 3, floor(z / 4)) % 3 === 0 ? shade(n) : undefined"}]],"overBody":{"groups":["head","torso","bust","shoulder","armL","armR","legL","legR","tail"],"paint":"mark","skin":true},"params":{"color":null,"pattern":"stripes","spacing":4},"parts":[]}},"library":[["TUNE_LEG",{"calfBack":0.45,"calfDepth":0.85,"calfLength":0.28,"calfWidth":1,"heads":[[0.3,0.3,0.9],[0.36,-0.35,1]],"quadAhead":0.3,"quadDepth":0.9,"quadDown":0.38,"quadLength":0.4,"quadOut":0.15,"quadWidth":1},"An athlete\'s leg muscles, as shares of the leg: where the quadriceps swells the thigh (down, ahead, out, and its size) and where the calf\'s two heads sit behind the shin\'s upper third ([down, outward, size] each)."],["legFrame",{"fn":["sk","side","a","b"],"let":[["along","normalize(sub(b, a))"],["square","v => sub(v, scale(along, dot(v, along)))"],["toe","square(sub(sk[side].toe, sk[side].heel))"],["ahead","normalize(dot(toe, toe) > 1e-4 ? toe : square(apply(sk.pelvisBasis, [0, 0, 1])))"],["x","cross(along, ahead)"],["basis","[x[0], along[0], ahead[0], x[1], along[1], ahead[1], x[2], along[2], ahead[2]]"],["out","scale(x, dot(x, apply(sk.pelvisBasis, [sideSign(side), 0, 0])) < 0 ? -1 : 1)"]],"return":"{ along, ahead, out, basis, length: distance(a, b) }"},"legFrame(sk, side, a, b): a frame square to a leg bone from a to b -- along it, ahead the way its foot points, out away from the other leg -- and basis (x, along, ahead) for ellipsoids laid along it, and the bone\'s length."],["thighOf",{"fn":["sk","side","p","by","m","g"],"let":[["j","sk[side]"],["thigh","segment(j.hip, j.knee, p.thighRadius + by, m, g)"],["quad",{"fn":[],"let":[["f","legFrame(sk, side, j.hip, j.knee)"],["L","TUNE_LEG"],["at","add(lerp(j.hip, j.knee, L.quadDown), add(scale(f.ahead, p.thighRadius * L.quadAhead), scale(f.out, p.thighRadius * L.quadOut)))"]],"return":"ellipsoid(at, f.basis, [p.quad * L.quadWidth + by, f.length * L.quadLength + by, p.quad * L.quadDepth + by], m, g)"}]],"return":"p.quad ? [thigh, quad()] : [thigh]"},"thighOf(sk, side, p, by, m, group): a thigh `by` off the skin -- one muscle-shaped segment, and on an athlete\'s legs (p.quad) the quadriceps swelling it in front and to the outside, fullest a third of the way down and drawn in to the knee."],["shinOf",{"fn":["sk","side","p","by","m","g","to"],"let":[["j","sk[side]"],["shin","segment(j.knee, (to ?? 1) === 1 ? j.ankle : lerp(j.knee, j.ankle, to), p.shinRadius + by, m, g)"],["calf",{"fn":[],"let":[["f","legFrame(sk, side, j.knee, j.ankle)"],["L","TUNE_LEG"],["back","scale(f.ahead, -p.shinRadius * L.calfBack)"]],"return":"L.heads.map(h => ellipsoid(add(lerp(j.knee, j.ankle, h[0]), add(back, scale(f.out, h[1] * p.shinRadius))), f.basis, [p.calf * h[2] * L.calfWidth + by, f.length * L.calfLength + by, p.calf * h[2] * L.calfDepth + by], m, g))"}]],"return":"p.calf ? [shin, ...calf()] : [shin]"},"shinOf(sk, side, p, by, m, group, to?): a shin from the knee to `to` of the way to the ankle (all of it unless given), `by` off the skin -- one segment, and on an athlete\'s legs (p.calf) the two heads of the calf behind its upper third, the inner one fuller and lower."],["headOf",{"fn":["sk","p","skin"],"let":[["a","p.head[0]"],["b","p.head[1]"],["c","p.head[2]"],["skull","ellipsoid(add(sk.head, apply(sk.headBasis, [0, p.craniumLift, 0])), sk.headBasis, p.head, skin, \'head\', { exponent: p.headRoundness })"],["jaw","ellipsoid(add(sk.head, apply(sk.headBasis, [0, -b * 0.5, c * 0.38])), sk.headBasis, [a * 0.9, b * 0.62, c * 0.6], skin, \'head\', { exponent: [2.6, 3, 2.0] })"],["kx","a / 10.05"],["ky","b / 8.7"],["kz","c / 9.15"],["ears","[1, -1].map(s => ellipsoid(add(sk.head, apply(sk.headBasis, [s * (a - 0.5 * kx), p.earHeight, -0.8 * kz])), sk.headBasis, [1.6 * kx, 2.3 * ky, 1.5 * kz], skin, \'head\'))"]],"return":"[skull, jaw, ...ears]"},"headOf(sk, p, skin): the skull -- a rounded box, flat at the sides and across the face, widest at the cheeks, as the LPC head is drawn -- the jaw forward and below it (tall and flat-fronted: in profile the face runs straight down from brow to chin), and ears standing a pixel proud at eye level. The eyes are not geometry: they are stamped on (marks.json eyeStyles)."],["upperBody",{"fn":["sk","p","m","inflateBy","facingGiven"],"let":[["by","inflateBy ?? 0"],["facing","facingGiven ?? \'front\'"],["chest","add(sk.chest, apply(sk.torsoBasis, [0, 0, p.posture]))"],["ribs","ellipsoid(chest, sk.torsoBasis, inflate(p.torso, by), m, \'torso\', { exponent: p.torsoRoundness })"],["cut","p.girdle.cut"],["girdle","ellipsoid(add(sk.chest, apply(sk.torsoBasis, [0, p.girdle.drop - by, -0.3])), sk.torsoBasis, inflate(p.girdle.radii, by), m, \'torso\', { keep: q => q[1] > cut, exponent: p.girdle.exponent })"],["sideOn","facing === \'left\' || facing === \'right\'"],["deltoids","SIDES.filter(side => !(sideOn && side === farSide(facing))).map(side => ellipsoid(add(sk[side].shoulder, apply(sk.torsoBasis, [sideSign(side) * 0.3, 0.5, 0])), sk.torsoBasis, [p.deltoidRadius + by, p.deltoidRadius + by, p.deltoidRadius + by], m, \'shoulder\'))"],["pecs","p.pecs ? [1, -1].map(s => ellipsoid(add(chest, apply(sk.torsoBasis, [s * p.torso[0] * 0.36, p.torso[1] * 0.22, p.torso[2] * 0.72])), sk.torsoBasis, [p.pecs * 1.25 + by, p.pecs * 0.8 + by, p.pecs * 0.62 + by], m, \'torso\', { exponent: [2.4, 2.2, 2] })) : []"],["bust","p.bust ? [1, -1].map(s => ellipsoid(add(chest, apply(sk.torsoBasis, [s * p.torso[0] * 0.47, -p.torso[1] * 0.2, p.torso[2] * 1.0])), sk.torsoBasis, [p.bust + by, p.bust * 0.9 + by, p.bust * 0.85 + by], m, \'bust\')) : []"]],"return":"[ribs, girdle, ...deltoids, ...pecs, ...bust]"},"upperBody(sk, p, m, by?, facing?): chest, shoulder girdle and deltoids, every volume `by` off the skin (garments). The girdle is the top of a wide dome, so the line from the neck to each deltoid slopes and each deltoid caps its arm round; a garment\'s girdle grows out and around but not up, so a collar sits under the chin. Side-on the far deltoid is left out (it would show past the throat, where LPC leaves a notch). Pectorals (p.pecs) are wide flat slabs either side of the breastbone; a woman\'s bust (p.bust) sits on the chest\'s front below the collarbones, group `bust`, so a shirt or breastplate covers it and the raster draws the seam under it."],["lowerBody",{"fn":["sk","p","m","inflateBy","keep","legWear"],"let":[["by","inflateBy ?? 0"],["hips","ellipsoid(p.pelvisLow ? add(sk.pelvis, apply(sk.pelvisBasis, [0, -p.pelvisLow, 0])) : sk.pelvis, sk.pelvisBasis, inflate(p.pelvis, by), m, \'torso\', { exponent: p.pelvisRoundness, keep })"],["waist",{"fn":[],"let":[["lift","p.waistHeight ?? 0"],["low","p.pelvisLow ?? 0"],["garment","keep && (q => keep([q[0], q[1] + lift + low, q[2]]))"],["waistKeep","legWear ? (q => q[1] < 0 && (!garment || garment(q))) : garment"]],"return":"ellipsoid(add(sk.pelvis, apply(sk.pelvisBasis, [0, lift, 0])), sk.pelvisBasis, inflate(p.waist, by), m, \'torso\', { keep: waistKeep })"}]],"return":"p.waist ? [hips, waist()] : [hips]"},"lowerBody(sk, p, m, by?, keep?, legWear?): the hips, and a woman\'s waist above them (p.waist), `by` off the skin; `keep` cuts them in the pelvis\'s frame (a garment\'s top edge), and `legWear` stops the waist at the natural waist, as trousers and skirts do, instead of riding up the ribs."],["absOf",{"fn":["sk","p","skin","facing"],"let":[["lit","lighting(facing)"],["up","apply(sk.torsoBasis, [0, 1, 0])"],["across","apply(sk.torsoBasis, [1, 0, 0])"],["ahead","apply(sk.torsoBasis, [0, 0, 1])"],["top","p.torso[1] * 0.0"],["bottom","-p.torso[1] * 0.8"],["half","p.torso[0] * 0.3"]],"return":{"cases":[["dot(v, ahead) <= 0 || y > top || y < bottom || abs(x) > half","undefined"]],"fn":["w","n"],"let":[["v","sub(w, sk.chest)"],["x","dot(v, across)"],["y","dot(v, up)"],["row","(top - y) / ((top - bottom) / 3)"]],"return":"abs(x) < 0.45 || (row % 1 < 0.22 && row > 0.5) ? tone(skin, min(3, lit(n) + 1)) : undefined"}},"absOf(sk, p, skin, facing): paint for a muscled belly\'s six-pack down the front of the bare chest below the pectorals -- the line down the middle and two across, a shade darker than the skin round them."],["furred",{"fn":["prims","fur","facing"],"let":[["lit","lighting(facing)"],["furOn",{"fn":["prim"],"let":[["before","prim.decal"],["decal",{"cases":[["own !== undefined","own"],["hash3(floor(q[0] / 1.3), floor(q[1] / 2.4), floor(q[2] / 1.3)) % 5 !== 0","undefined"]],"fn":["q"],"let":[["own","before ? before(q) : undefined"]],"return":"tone(fur, min(3, lit(normalOf(prim, q)) + 1))"}]],"return":"{ ...prim, decal }"}]],"return":"prims.map(prim => prim.kind !== \'ellipsoid\' ? prim : furOn(prim))"},"furred(prims, fur, facing): fur on a beast\'s body -- short strands a shade darker than the light gives each spot, about one in five cells, scattered over every volume; hashed in each volume\'s own frame, so the grain moves with the body instead of crawling over it, and paint already there (a muscled chest\'s abs) shows first."],["WOUND","rampFrom(\'#8a3a34\')","A wound\'s raw rim."],["GORE","rampFrom(\'#5a1f22\')","A wound\'s dark core."],["woundsOf",{"fn":["sk","p","facing"],"let":[["lit","lighting(facing)"],["T","v => add(sk.chest, apply(sk.torsoBasis, v))"],["P","v => add(sk.pelvis, apply(sk.pelvisBasis, v))"],["r","max(1.2, p.torso[0] * 0.2)"],["wounds","[[T([p.torso[0] * 0.45, p.torso[1] * 0.3, p.torso[2]]), r], [T([-p.torso[0] * 0.3, -p.torso[1] * 0.4, p.torso[2]]), r * 0.8], [T([p.torso[0] * 0.2, p.torso[1] * 0.1, -p.torso[2]]), r], [lerp(sk.R.elbow, sk.R.hand, 0.5), r * 0.75], [P([p.hipWidth, -p.thigh * 0.35, p.thighRadius * 0.8]), r * 0.8], [lerp(sk.L.knee, sk.L.ankle, 0.4), r * 0.7]]"]],"return":{"cases":[["!hit","undefined"],["distance(w, hit[0]) < hit[1] * 0.55","tone(GORE, lit(n))"]],"fn":["w","n"],"let":[["hit","wounds.find(x => distance(w, x[0]) < x[1])"]],"return":"tone(WOUND, lit(n))"}},"woundsOf(sk, p, facing): paint for a dead body torn open -- wounds at fixed places on the skeleton (the chest, the belly, the back, a forearm, a thigh, a shin), each a dark core in a raw rim, lit like the flesh round them."],["WOLF_NOSE","rampFrom(\'#2a1f22\', \'#0c0809\')","A wolf\'s nose."],["WOLF_EAR","rampFrom(\'#c98a86\')","The pink inside a wolf\'s ear."],["wolfHeadOf",{"fn":["sk","p","fur","facing"],"let":[["a","p.head[0]"],["b","p.head[1]"],["c","p.head[2]"],["at","v => add(sk.head, apply(sk.headBasis, v))"],["muzzle","{ ...fur, light: fur.base, base: fur.shade, shade: fur.deep, deep: fur.line }"],["lit","lighting(facing)"],["toHead","transpose(sk.headBasis)"],["bridge",{"fn":["w","n"],"let":[["q","apply(toHead, sub(w, sk.head))"],["width","a * (0.22 - 0.1 * max(0, q[1] / b))"]],"return":"q[2] > c * 0.3 && abs(q[0]) < width && q[1] > -b * 0.3 && q[1] < b * 0.45 ? tone(muzzle, lit(n)) : undefined"}],["skull","painted([ellipsoid(at([0, p.craniumLift * 0.5, -c * 0.05]), sk.headBasis, [a * 0.95, b * 0.88, c * 0.95], fur, \'head\', { exponent: p.headRoundness })], bridge)"],["snout","[ellipsoid(at([0, -b * 0.32, c * 1.0]), sk.headBasis, [a * 0.42, b * 0.38, c * 0.8], muzzle, \'head\', { exponent: [2.2, 2.6, 2] }), ellipsoid(at([0, -b * 0.62, c * 0.72]), sk.headBasis, [a * 0.36, b * 0.22, c * 0.6], muzzle, \'head\'), ellipsoid(at([0, -b * 0.16, c * 1.8]), sk.headBasis, [max(0.9, a * 0.22), max(0.8, b * 0.18), 0.8], WOLF_NOSE, \'head\')]"],["jowls","[1, -1].map(s => ellipsoid(at([s * a * 0.7, -b * 0.4, -c * 0.1]), sk.headBasis, [a * 0.36, b * 0.48, c * 0.6], fur, \'head\'))"],["ahead","apply(sk.headBasis, [0, 0, 1])"],["ears","painted([1, -1].map(s => segment(at([s * a * 0.5, b * 0.5, -c * 0.1]), at([s * a * 0.95, b * 1.6, -c * 0.3]), max(1.3, a * 0.34), fur, \'head\')), (w, n) => (dot(n, ahead) > 0.4 ? tone(WOLF_EAR, lit(n)) : undefined))"]],"return":"[...skull, ...snout, ...jowls, ...ears]"},"wolfHeadOf(sk, p, fur, facing): a wolf\'s head on the man\'s neck, as LPC\'s wolfman wears one -- the skull, its muzzle a shade darker than the coat and that dark running up the bridge between the eyes, a long muzzle with a dark nose on its tip and a lower jaw under it, the jowls filling out the cheeks, and tall pointed ears standing up off the crown, pink inside. Sized off the man\'s own head (p.head), so the eyes still sit where his would."],["wolfFurOf",{"fn":["sk","p","fur"],"let":[["leg","legLength(p)"],["ruff","ellipsoid(add(sk.neck, apply(sk.torsoBasis, [0, -p.neckRadius * 0.3, -p.neckRadius * 0.2])), sk.torsoBasis, [p.neckRadius * 2.0, p.neckRadius * 1.35, p.neckRadius * 1.75], fur, \'torso\')"],["root","add(sk.pelvis, apply(sk.pelvisBasis, [0, -p.pelvis[1] * 0.15, -p.pelvis[2] * 0.85]))"],["mid","add(root, apply(sk.pelvisBasis, [0, -leg * 0.2, -leg * 0.14]))"],["tip","add(root, apply(sk.pelvisBasis, [0, -leg * 0.46, -leg * 0.16]))"],["r","max(1.3, p.thighRadius * 0.45)"]],"return":"[ruff, segment(root, mid, r, fur, \'tail\'), segment(mid, tip, r * 1.35, fur, \'tail\')]"},"wolfFurOf(sk, p, fur): the rest of a wolfman\'s wolf -- a thick ruff of fur round the neck, setting the head down into the shoulders as LPC draws it, and a bushy tail from the base of the spine, outlined as a part of its own."],["HOLLOW","rampFrom(\'#3b3330\')","The dark of a skull\'s sockets and the hollow behind the ribs."],["taper",{"fn":["points","r0","r1","m","g"],"return":"range(points.length - 1).map(i => segment(points[i], points[i + 1], r0 + (r1 - r0) * i / max(1, points.length - 2), m, g))"},"taper(points, r0, r1, m, group): a limb-like chain of segments through the points, radius r0 at the first easing to r1 at the last: horns, tails, spines."]],"models":{"flesh":{"about":"The living body: head (a wolf\'s, with its ruff and tail, on a wolf: look.beast), neck, chest (a muscled one\'s abs painted on it, under any shirt), hips, and limbs as muscle-shaped volumes in the skin. Each joint ball belongs to the segment below it, so a joint gets one line, not two. A hand is a fist, or -- empty, at rest (ArmPose.open) -- hangs open: longer, the fingers down, and narrow seen from the front, the palm turned to the thigh.","parts":[{"else":["headOf(sk, p, skin)"],"parts":["wolfHeadOf(sk, p, skin, facing)","wolfFurOf(sk, p, skin)"],"when":"look.beast === \'wolf\'"},"capsule(sk.chest, sk.neck, p.neckRadius, skin, \'torso\')",{"let":[["chest","upperBody(sk, p, skin, 0, facing)"]],"parts":["p.pecs ? [...painted(chest.slice(0, 1), absOf(sk, p, skin, facing)), ...chest.slice(1)] : chest"]},"lowerBody(sk, p, skin)",{"as":"side","each":"SIDES","let":[["j","sk[side]"],["arm","armOf(side)"],["leg","legOf(side)"]],"parts":["as(segment(j.shoulder, j.elbow, p.upperArmRadius, skin, arm), \'upperArm\')","as(joint(j.elbow, p.forearmRadius * 0.85, skin, arm), \'forearm\')","as(segment(j.elbow, j.hand, p.forearmRadius, skin, arm), \'forearm\')",{"else":["as(ellipsoid(add(j.hand, apply(sk.torsoBasis, [-sideSign(side) * p.handInset, 0, 0])), sk.torsoBasis, [p.handRadius, p.handRadius, p.handRadius], skin, arm), \'hand\')"],"parts":[{"else":["as(segment(j.hand, add(j.hand, scale(normalize(sub(j.hand, j.elbow)), p.handLength)), p.handRadius, skin, arm, 2.8), \'hand\')"],"parts":[{"let":[["d","normalize(sub(j.hand, j.elbow))"],["fist","p.handLength / 2 + p.handRadius * 0.45"],["reach","fist * 1.4"]],"parts":["as({ ...segment(j.hand, add(j.hand, scale(d, p.handLength)), p.handRadius, skin, arm, 2.8), center: add(j.hand, scale(d, p.handLength / 2 + reach - fist)), radii: [p.handRadius * 0.58, reach, p.handRadius * 0.95] }, \'hand\')"]}],"when":"j.open"}],"when":"p.handLength"},"thighOf(sk, side, p, 0, skin, leg).map(prim => as(prim, \'thigh\'))","as(joint(j.knee, p.shinRadius * 0.9, skin, leg), \'shin\')","shinOf(sk, side, p, 0, skin, leg).map(prim => as(prim, \'shin\'))","as(joint(j.ankle, p.shinRadius * 0.7, skin, leg), \'foot\')","as(foot(j.heel, j.toe, p.footRadius, footWidth, skin, leg), \'foot\')"]}]},"human":{"about":"A humanoid\'s body by its look: bones where the flesh would be (look.bones: the skeleton), or the living flesh -- furred on a beast (look.beast), torn open on the dead (look.wounds).","parts":[{"else":[{"paint":"look.wounds ? woundsOf(sk, p, facing) : undefined","parts":[{"apply":"look.beast ? (prims => furred(prims, skin, facing)) : undefined","parts":[{"use":"flesh"}]}]}],"parts":[{"use":"skeleton"}],"when":"look.bones"}]},"skeleton":{"about":"A skeleton on the same rig as a living body, so every clip, weapon and garment works on it: a skull with dark sockets, nose and teeth; a ribcage of bands with the hollow dark behind them, a sternum and collarbones; a spine down to a pelvic bowl; limb bones with knobbed joints; bony hands and feet. Bone is a few pixels of ivory at this size: every bone stays two or three pixels thick (forearm and shin are one bone each -- a pair is too fine to read), and the skull is drawn large, as pixel-art skeletons are, so its sockets and teeth show. In the look\'s bone colour (look.boneColor, palettes.json bones).","let":[["bone","BONES[look.boneColor ?? \'white\'] ?? BONES.white"],["a","p.head[0]"],["b","p.head[1]"],["c","p.head[2]"],["skull","add(sk.head, apply(sk.headBasis, [0, p.craniumLift + 0.9, -0.2]))"],["across","apply(sk.headBasis, [1, 0, 0])"],["up","apply(sk.headBasis, [0, 1, 0])"],["ahead","apply(sk.headBasis, [0, 0, 1])"],["toward","(x, y) => normalize(apply(sk.headBasis, [x, y - p.craniumLift - 0.9, c]))"],["profile","facing === \'left\' || facing === \'right\'"],["eyeY","p.eyeHeight + b * 0.1"],["eyeX","max(a * (profile ? 0.9 : 0.5), 1.7)"],["sockets","[toward(-eyeX, eyeY), toward(eyeX, eyeY)]"],["socketWide","cos(atan2(max(a * (profile ? 0.42 : 0.3), profile ? 1.6 : 1.2), c))"],["nose","toward(0, eyeY - max(a * 0.4, 1.5))"],["noseWide","cos(atan2(max(a * 0.13, 0.6), c))"],["teeth","-b * 0.52"],["holes",{"cases":[["sockets.some(d => dot(from, d) > socketWide) || dot(from, nose) > noseWide","HOLLOW.deep"],["dot(v, ahead) > c * 0.3 && abs(y - teeth) < max(0.55, b * 0.09) && abs(x) < a * 0.6 && ((x / 1.1) % 1 + 1) % 1 < 0.4","HOLLOW.base"]],"fn":["w","n"],"let":[["from","normalize(sub(w, skull))"],["v","sub(w, sk.head)"],["x","dot(v, across)"],["y","dot(v, up)"]]}]],"parts":[{"paint":"holes","parts":["ellipsoid(skull, sk.headBasis, [a * 1.25, b * 1.18, c * 1.12], bone, \'head\', { exponent: p.headRoundness })","ellipsoid(add(sk.head, apply(sk.headBasis, [0, -b * 0.62, c * 0.38])), sk.headBasis, [a * 0.9, b * 0.48, c * 0.6], bone, \'head\', { exponent: [2.4, 2.6, 2] })"]},{"let":[["neckTop","add(sk.head, apply(sk.headBasis, [0, -b * 0.55, -c * 0.25]))"],["neckBase","add(sk.chest, apply(sk.torsoBasis, [0, p.torso[1] * 0.85, -p.torso[2] * 0.3]))"]],"parts":["range(3).map(i => joint(lerp(neckBase, neckTop, (i + 0.5) / 3), 1.1, bone, \'torso\'))"]},{"let":[["lumbarTop","add(sk.chest, apply(sk.torsoBasis, [0, -p.torso[1] * 0.55, -p.torso[2] * 0.35]))"],["sacrum","add(sk.pelvis, apply(sk.pelvisBasis, [0, p.pelvis[1] * 0.3, -p.pelvis[2] * 0.4]))"]],"parts":["range(4).map(i => ellipsoid(lerp(lumbarTop, sacrum, (i + 0.5) / 4), sk.torsoBasis, [1.4, 0.9, 1.2], bone, \'torso\'))"]},{"let":[["ribsAt","add(sk.chest, apply(sk.torsoBasis, [0, p.torso[1] * 0.15, p.posture]))"],["ribRadii","[p.torso[0] * 0.82, p.torso[1] * 0.78, p.torso[2] * 0.88]"],["period","max(1.9, p.torso[1] * 0.3)"],["sternumTop","add(ribsAt, apply(sk.torsoBasis, [0, ribRadii[1] * 0.75, ribRadii[2] * 0.75]))"]],"parts":["ellipsoid(ribsAt, sk.torsoBasis, ribRadii, bone, \'torso\', { exponent: p.torsoRoundness, keep: q => q[1] > -ribRadii[1] * 0.7 && (((q[1] + ribRadii[1]) / period) % 1) < 0.55 })","ellipsoid(ribsAt, sk.torsoBasis, [ribRadii[0] * 0.8, ribRadii[1] * 0.8, ribRadii[2] * 0.75], HOLLOW, \'torso\', { exponent: p.torsoRoundness, keep: q => q[1] > -ribRadii[1] * 0.55 })","capsule(sternumTop, add(ribsAt, apply(sk.torsoBasis, [0, -ribRadii[1] * 0.2, ribRadii[2] * 0.95])), 0.8, bone, \'torso\')","SIDES.map(side => capsule(sternumTop, sk[side].shoulder, 0.75, bone, \'torso\'))"]},"ellipsoid(add(sk.pelvis, apply(sk.pelvisBasis, [0, p.pelvis[1] * 0.15, 0])), sk.pelvisBasis, [p.pelvis[0] * 0.95, p.pelvis[1] * 0.55, p.pelvis[2] * 0.62], bone, \'torso\', { exponent: [2.4, 2.2, 2.2], keep: q => q[1] < p.pelvis[1] * 0.25 })",{"as":"side","each":"SIDES","let":[["j","sk[side]"],["arm","armOf(side)"],["leg","legOf(side)"]],"parts":["as(joint(j.shoulder, max(1.5, p.upperArmRadius * 0.62), bone, arm), \'upperArm\')","as(capsule(j.shoulder, j.elbow, max(1.25, p.upperArmRadius * 0.5), bone, arm), \'upperArm\')","as(joint(j.elbow, max(1.4, p.forearmRadius * 0.68), bone, arm), \'forearm\')","as(capsule(j.elbow, j.hand, max(1.1, p.forearmRadius * 0.52), bone, arm), \'forearm\')","as(ellipsoid(fistCenter(sk, p, side), sk.torsoBasis, [p.handRadius * 0.6, p.handRadius * 0.7, p.handRadius * 0.6], bone, arm, { exponent: 2.6 }), \'hand\')","as(joint(j.hip, max(1.6, p.thighRadius * 0.55), bone, leg), \'thigh\')","as(capsule(j.hip, j.knee, max(1.35, p.thighRadius * 0.47), bone, leg), \'thigh\')","as(joint(j.knee, max(1.5, p.shinRadius * 0.68), bone, leg), \'shin\')","as(capsule(j.knee, j.ankle, max(1.15, p.shinRadius * 0.5), bone, leg), \'shin\')","as(joint(j.ankle, max(0.9, p.shinRadius * 0.4), bone, leg), \'foot\')","as(foot(j.heel, j.toe, p.footRadius * 0.75, footWidth * 0.75, bone, leg), \'foot\')"]}]}},"version":1},"emberHair":{"about":"Hair as data. A STYLE is a few numbers -- how far it stands off the skull (`volume`: 0.3 a buzz cut, 0.9 a short cut, 3 an afro), how low the fringe comes (`fringe`: 0 high off the brow, 0.35 a short cut\'s, 1 bangs to the eyebrows), how long it falls (`length`: to the nape, framing the face to the jaw, or falling to the shoulder, back or waist) -- and what it has besides: `sides` shaved (a crest left on top) or faded close, a bald `crown`, something on `top` (spikes, tufts, tuft, tall-tuft, crest, tall-crest, flat, quiff, beehive), a `tie` (ponytail, high-ponytail, bun, topknot, bunches, braid), a `texture` (curls, locks, rows). A style is drawn by its model\'s parameters (`model`, the `shell` unless it names another) in the look\'s hair colour (palettes.json hair). Ember\'s own styles (crop, short, long, ponytail) and each of the game\'s LPC styles as the nearest design; a look\'s style the game does not know is drawn as `default`, and the `none` styles are no hair at all. Skeletons and beasts have none.","default":"short","models":{"shell":{"about":"Hair from a style\'s numbers: a shell over the skull cut to its hairline, and what falls or stands off it. Sizes are set for the LPC head (10.05 x 8.7 x 9.15) and scaled to this one\'s (k); features of their own keep a few pixels on a small head (s), or a realist\'s spikes would be specks. The cap is at least most of a pixel thick, so a small head\'s hair still shows past the skull; volume past a short cut\'s grows faster (an afro must double a small head, not pad it), and long hair has body a short cut doesn\'t. Volume past a pixel or so grows up and back, off the face: inflated all round, a big head of hair would stand out in front of the face and the hairline cut leave a brim over the eyes. The hairline is above the brow at the front, lower round the back and sides (a small head\'s long hair comes lower, or front-on it is a band over a bare crown); a full head of hair (volume 1.4 and up: an afro, a mop) comes round the head, not just over it -- a dome cut off above the ears reads as a mushroom -- and stands round the face at the sides too, the face showing through a window in it; hair to the jaw or longer comes down over the ears, framing the face.","let":[["m","hairDye(color)"],["a","p.head[0]"],["b","p.head[1]"],["c","p.head[2]"],["k","b / 8.7"],["s","max(k, 0.6)"],["at","v => add(sk.head, apply(sk.headBasis, v))"],["long","length === \'shoulder\' || length === \'back\' || length === \'waist\'"],["full","k < 1 ? max(k * 1.3, 2) : k * 1.3"],["lift","min(volume, 1) * max(k, 0.7) + max(0, volume - 1) * full + (long ? max(k, 0.7) : 0)"],["extra","max(0, lift - 1.2)"],["center","at([0, 0.5 * k + 0.35 * extra, -0.4 * k - 0.45 * extra])"],["radii","[a + lift, b + lift - 0.25 * extra, c + lift - 0.45 * extra]"],["brow","p.eyeHeight + b * (0.62 - 0.4 * fringe) - (k < 1 && long ? 0.8 : 0) - 0.35 * extra"],["bushy","volume >= 1.4"],["nape","length === \'nape\' && !bushy ? -b * 0.5 : -b * 0.9"],["sideLine","length === \'jaw\' || long || bushy ? -b * 0.85 : brow - 3 * k"],["atSides","q => abs(q[0]) > a * 0.8 && q[1] > sideLine && (bushy || q[2] < c * 0.2)"],["hairline","q => q[1] > brow || (q[2] < -c * 0.15 && q[1] > nape) || atSides(q)"],["shaved","sides === \'shaved\' ? (q => hairline(q) && abs(q[0]) < a * 0.38) : hairline"],["faded","sides === \'faded\' ? (q => shaved(q) && q[1] > b * 0.25) : shaved"],["keep","crown === \'bald\' ? (q => faded(q) && q[1] < b * 0.3 && q[2] < c * 0.1) : faded"],["spike",{"fn":["dir","len","r"],"let":[["out","normalize(apply(sk.headBasis, dir))"],["base","add(center, scale(out, b * 0.75))"]],"return":"segment(base, add(base, scale(out, len)), r, m, \'hair\')"}],["up","apply(sk.headBasis, [0, 1, 0])"],["across","apply(sk.headBasis, [1, 0, 0])"],["ahead","apply(sk.headBasis, [0, 0, 1])"],["textured",{"cases":[["texture === \'curls\'","hash3(floor(dot(v, across) / 1.3), floor(dot(v, up) / 1.3), floor(dot(v, ahead) / 1.3)) % 4 === 0 ? m.deep : undefined"],["texture === \'rows\'","((dot(v, across) / 1.6) % 1 + 1) % 1 < 0.35 && dot(v, up) > 0 ? m.deep : undefined"]],"fn":["w"],"let":[["v","sub(w, sk.head)"]],"return":"((atan2(dot(v, ahead), dot(v, across)) * (a + lift) / 1.8) % 1 + 1) % 1 < 0.3 ? m.deep : undefined"}]],"params":{"color":"brown","crown":null,"fringe":0.35,"length":"nape","sides":null,"texture":null,"tie":null,"top":null,"volume":0.9},"parts":[{"paint":"texture ? textured : undefined","parts":[{"parts":["ellipsoid(center, sk.headBasis, inflate(p.head, 0.3 * max(k, 0.7)), m, \'hair\', { exponent: p.headRoundness, keep: q => q[1] <= b * 0.3 && ((q[2] < -c * 0.15 && q[1] > -b * 0.5) || atSides(q)) })"],"when":"sides === \'faded\'"},"ellipsoid(center, sk.headBasis, radii, m, \'hair\', { exponent: p.headRoundness, keep })",{"parts":[{"let":[["reach","dot(sub(sk.head, sk.chest), apply(sk.torsoBasis, [0, 1, 0]))"],["end","length === \'shoulder\' ? p.shoulderHeight - 0.5 : length === \'back\' ? -p.torso[1] * 0.35 : -p.spine * 0.8"],["behind","p.torso[2] + 1.2"]],"parts":["ellipsoid(add(sk.chest, apply(sk.torsoBasis, [0, (reach + end) / 2, -behind])), sk.torsoBasis, [a + lift, (reach - end) / 2, 1.4], m, \'hair\', { exponent: [2, 3.2, 2] })","[-1, 1].map(x => capsule(at([x * a * 0.9, -b * 0.1, -c * 0.05]), add(sk.chest, apply(sk.torsoBasis, [x * (p.neckRadius + 1.6), p.shoulderHeight + 0.6, p.torso[2] * 0.15])), max(1.3, 1.4 * k) + lift * 0.3, m, \'hair\'))"]}],"when":"long"},{"parts":["[-1, 1].map(x => ellipsoid(at([x * a * 0.82, -b * 0.45, -c * 0.15]), sk.headBasis, [max(1.6 * s, 1.3) + lift * 0.5, b * 0.55, c * 0.6], m, \'hair\'))"],"when":"length === \'jaw\'"},{"parts":["[[0, 0.5], [-0.6, 0.15], [0.6, 0.15], [-0.4, -0.45], [0.4, -0.45], [0, -0.1]].map(xz => spike([xz[0], 1, xz[1]], 6.5 * s, 1.6 * s))"],"when":"top === \'spikes\'"},{"parts":["[[-0.45, 0.3], [0.35, 0.4], [0.1, -0.35], [-0.25, -0.1]].map(xz => spike([xz[0], 1, xz[1]], 3 * s, 1.4 * s))"],"when":"top === \'tufts\'"},{"parts":["spike([0.1, 1, 0.6], (top === \'tuft\' ? 2.5 : 4.5) * s, 1.3 * s)"],"when":"top === \'tuft\' || top === \'tall-tuft\'"},{"parts":[{"let":[["tall","top === \'crest\' ? 2.4 : 4.5"]],"parts":["ellipsoid(at([0, b + lift + tall * s * 0.4, -c * 0.1]), sk.headBasis, [1.3 * s, tall * s, c * 0.85], m, \'hair\')"]}],"when":"top === \'crest\' || top === \'tall-crest\'"},{"parts":["ellipsoid(at([0, b * 0.85 + lift, -c * 0.05]), sk.headBasis, [a * 0.88, 2.2 * s, c * 0.82], m, \'hair\', { exponent: [2.6, 6, 2.6] })"],"when":"top === \'flat\'"},{"parts":["ellipsoid(at([0, b * 0.85 + lift + 0.8 * s, c * 0.55]), sk.headBasis, [a * 0.75, 3.2 * s, 3.8 * s], m, \'hair\')"],"when":"top === \'quiff\'"},{"parts":["ellipsoid(at([0, b * 1.25 + lift, -c * 0.15]), sk.headBasis, [a * 0.8, b * 0.8, c * 0.8], m, \'hair\')"],"when":"top === \'beehive\'"},{"parts":[{"let":[["root","at([0, 2.5 * k, -c - 0.6 * k])"]],"parts":["capsule(root, add(root, apply(sk.torsoBasis, [0, -10 * k, -2.2 * k])), 1.9 * k, m, \'hair\')"]}],"when":"tie === \'ponytail\'"},{"parts":[{"let":[["root","at([0, b * 0.75, -c * 0.85])"]],"parts":["capsule(root, add(root, apply(sk.torsoBasis, [0, -12 * s, -2.6 * s])), 1.8 * s, m, \'hair\')"]}],"when":"tie === \'high-ponytail\'"},{"parts":["ellipsoid(at([0, b * 0.25, -c - 1.4 * s]), sk.headBasis, [2.6 * s, 2.6 * s, 2.4 * s], m, \'hair\')"],"when":"tie === \'bun\'"},{"parts":["ellipsoid(at([0, b + lift + 1.6 * s, -c * 0.25]), sk.headBasis, [2.3 * s, 2.2 * s, 2.3 * s], m, \'hair\')"],"when":"tie === \'topknot\'"},{"parts":["[-1, 1].map(x => capsule(at([x * (a + 0.4 * s), b * 0.15, -c * 0.35]), add(at([x * (a + 0.4 * s), b * 0.15, -c * 0.35]), apply(sk.headBasis, [x * 2.2 * s, -8 * s, -0.8 * s])), 1.6 * s, m, \'hair\'))"],"when":"tie === \'bunches\'"},{"parts":["range(6).map(i => ellipsoid(add(at([0, -b * 0.4, -c - 0.4 * s]), apply(sk.torsoBasis, [0, -i * 2.2 * s, -0.3 * i * s])), sk.headBasis, [1.4 * s, 1.3 * s, 1.3 * s], m, \'hair\'))"],"when":"tie === \'braid\'"}]}]}},"none":["bald","none"],"styles":{"afro":{"fringe":0.3,"length":"nape","texture":"curls","volume":3},"balding":{"crown":"bald","fringe":0,"length":"nape","volume":0.6},"bangs":{"fringe":1,"length":"nape","volume":1},"bangs_bun":{"fringe":1,"length":"nape","tie":"bun","volume":1},"bangslong":{"fringe":1,"length":"back","volume":1},"bangslong2":{"fringe":1,"length":"waist","volume":1},"bangsshort":{"fringe":0.9,"length":"nape","volume":0.8},"bedhead":{"fringe":0.5,"length":"nape","top":"tufts","volume":1.2},"bob":{"fringe":0.7,"length":"jaw","volume":1},"bob_side_part":{"fringe":0.5,"length":"jaw","volume":1},"braid":{"fringe":0.35,"length":"nape","tie":"braid","volume":0.9},"braid2":{"fringe":0.35,"length":"nape","tie":"braid","volume":0.9},"bunches":{"fringe":0.6,"length":"nape","tie":"bunches","volume":0.9},"buzzcut":{"fringe":0.1,"length":"nape","volume":0.3},"cornrows":{"fringe":0.2,"length":"nape","texture":"rows","volume":0.4},"cowlick":{"fringe":0.35,"length":"nape","top":"tuft","volume":0.9},"cowlick_tall":{"fringe":0.35,"length":"nape","top":"tall-tuft","volume":0.9},"crop":{"fringe":0,"length":"nape","volume":0.5},"curly_long":{"fringe":0.4,"length":"back","texture":"curls","volume":1.4},"curly_short":{"fringe":0.4,"length":"nape","texture":"curls","volume":1.4},"curtains":{"fringe":0.6,"length":"jaw","volume":1},"curtains_long":{"fringe":0.6,"length":"shoulder","volume":1},"dreadlocks_long":{"fringe":0.5,"length":"back","texture":"locks","volume":1.2},"dreadlocks_short":{"fringe":0.5,"length":"jaw","texture":"locks","volume":1.2},"flat_top_fade":{"fringe":0.2,"length":"nape","sides":"faded","top":"flat","volume":0.9},"flat_top_straight":{"fringe":0.2,"length":"nape","top":"flat","volume":0.9},"half_up":{"fringe":0.4,"length":"shoulder","tie":"bun","volume":1},"halfmessy":{"fringe":0.5,"length":"jaw","top":"tufts","volume":1.1},"high_and_tight":{"fringe":0.15,"length":"nape","sides":"faded","volume":0.7},"high_ponytail":{"fringe":0.3,"length":"nape","tie":"high-ponytail","volume":0.9},"idol":{"fringe":0.2,"length":"nape","top":"quiff","volume":0.9},"jewfro":{"fringe":0.4,"length":"nape","texture":"curls","volume":1.9},"lob":{"fringe":0.5,"length":"shoulder","volume":1},"long":{"fringe":0.35,"length":"shoulder","volume":0.9},"long_band":{"fringe":0.3,"length":"back","volume":1},"long_center_part":{"fringe":0.4,"length":"back","volume":1},"long_messy":{"fringe":0.5,"length":"back","top":"tufts","volume":1.2},"long_messy2":{"fringe":0.6,"length":"back","top":"tufts","volume":1.2},"long_tied":{"fringe":0.35,"length":"nape","tie":"ponytail","volume":0.9},"longhawk":{"fringe":0.1,"length":"nape","sides":"shaved","top":"tall-crest","volume":0.4},"longknot":{"fringe":0.35,"length":"shoulder","tie":"topknot","volume":1},"loose":{"fringe":0.4,"length":"back","volume":1.1},"messy1":{"fringe":0.5,"length":"nape","top":"tufts","volume":1.1},"messy2":{"fringe":0.6,"length":"nape","top":"tufts","volume":1.1},"messy3":{"fringe":0.5,"length":"jaw","top":"tufts","volume":1.2},"mop":{"fringe":1,"length":"jaw","volume":1.4},"natural":{"fringe":0.3,"length":"nape","texture":"curls","volume":2.2},"page":{"fringe":1,"length":"jaw","volume":1},"page2":{"fringe":0.9,"length":"jaw","volume":1},"part2":{"fringe":0.4,"length":"nape","volume":0.9},"parted":{"fringe":0.4,"length":"nape","volume":0.9},"pixie":{"fringe":0.7,"length":"nape","volume":0.8},"plain":{"fringe":0.35,"length":"nape","volume":0.9},"ponytail":{"fringe":0.35,"length":"nape","tie":"ponytail","volume":0.9},"ponytail2":{"fringe":0.35,"length":"nape","tie":"ponytail","volume":0.9},"princess":{"fringe":0.4,"length":"back","tie":"topknot","volume":1},"sara":{"fringe":0.5,"length":"back","volume":1.1},"short":{"fringe":0.35,"length":"nape","volume":0.9},"shorthawk":{"fringe":0.1,"length":"nape","sides":"shaved","top":"crest","volume":0.4},"shortknot":{"fringe":0.35,"length":"nape","tie":"topknot","volume":0.9},"shoulderl":{"fringe":0.6,"length":"shoulder","volume":1},"shoulderr":{"fringe":0.6,"length":"shoulder","volume":1},"single":{"fringe":0.35,"length":"nape","tie":"braid","volume":0.9},"spiked":{"fringe":0.3,"length":"nape","top":"spikes","volume":0.8},"spiked2":{"fringe":0.4,"length":"nape","top":"spikes","volume":0.8},"spiked_beehive":{"fringe":0.3,"length":"nape","top":"beehive","volume":0.9},"spiked_liberty":{"fringe":0.2,"length":"nape","sides":"faded","top":"spikes","volume":0.6},"spiked_liberty2":{"fringe":0.2,"length":"nape","sides":"faded","top":"spikes","volume":0.6},"spiked_porcupine":{"fringe":0.3,"length":"nape","top":"spikes","volume":0.8},"swoop":{"fringe":0.7,"length":"nape","volume":1},"twists_fade":{"fringe":0.3,"length":"nape","sides":"faded","texture":"locks","volume":1.1},"twists_straight":{"fringe":0.3,"length":"nape","texture":"locks","volume":1.1},"unkempt":{"fringe":0.6,"length":"jaw","top":"tufts","volume":1.2},"wavy":{"fringe":0.5,"length":"back","texture":"curls","volume":1.2},"xlong":{"fringe":0.4,"length":"waist","volume":1}},"version":1},"emberHumanoids":{"about":"The named Ember humanoids -- what `/ember appearance <name>` puts a player into -- and which one draws each race. Each is a record: a look (what it is and wears: skin, hair, eyes, clothes, bones/beast/wounds), a build (its proportions over the rig\'s default, LPC\'s; a BUILD may extend another and scale it whole), a style (styles.json), a posture over every clip (`shamble`, a zombie\'s), and the smallest frame it is drawn on (a body taller than the 64px frame allows needs more room). A build\'s `stance` is how it stands still, per view (front/back/side): its arms as angles (pitch, abduct, flex, radians) -- hanging close past the body, elbows soft, the hands by the thighs, ready but at ease, never held out like a mannequin\'s -- feet out from under the hips, `crouch` (px the knees let the hips down) and `lean` (the chest forward, radians; the head stays level). Every frame of every animation is generated from it. RACES: the first rule whose race (and sex, where it names one) an entity has picks its body; a race none names keeps its LPC body.","bodyColors":{"about":"How an entity\'s body colour (its appearance.bodyColor: the game\'s LPC body colours) recolours its Ember body. A skeleton\'s bone takes it as is (palettes.json bones). A living human\'s skin -- a look whose skin is one of `skins` -- becomes the skin `skins` names for it (a zombie\'s dead flesh is its own). A beast\'s fur becomes the skin its beast\'s `furs` table names (a wolf: `wolf-<colour>`). A colour none names leaves the look\'s own.","furs":{"wolf":{"black":"wolf-black","brown":"wolf-brown","gray":"wolf-gray","white":"wolf-white"}},"skins":{"black":"black","brown":"brown","dark":"black","light":"light","olive":"olive","tan":"olive","white":"light"}},"builds":{"human-man":{"about":"The human man every human man is drawn as: a barbarian\'s build, some 8% taller than the slim man (about 59px) and far heavier -- broad shoulders under big deltoids and a heavy trapezius, a deep wide chest with slab pectorals tapering to a narrower waist, thick neck, arms, thighs and calves -- the head a touch smaller for the size; feet set wide under the weight.","extends":"slim-man","proportions":{"ankleHeight":2.35,"deltoidRadius":3.4,"eyeSpacing":1.6,"footLength":5.1,"footProfileWidth":1.75,"footRadius":1.5,"footWidth":2.6,"forearm":8.8,"forearmRadius":2.85,"girdle":{"cut":0,"drop":1.4,"radii":[9.8,7.2,3.9]},"handLength":1.1,"handRadius":3,"head":[3.75,3.7,3.65],"headCenter":5.1,"hipDrop":1.9,"hipWidth":3.1,"neck":8.7,"neckRadius":3.1,"pecs":2.6,"pelvis":[5.2,4.7,4],"shin":14.85,"shinRadius":3,"shoulderHeight":2.6,"shoulderWidth":7.8,"spine":8.1,"stance":{"back":{"abduct":0.089,"crouch":0.6,"feetOut":2.55,"flex":0.967,"lean":0.05,"pitch":-0.2},"front":{"abduct":0.089,"crouch":0.6,"feetOut":2.55,"flex":0.967,"lean":0.05,"pitch":-0.2},"side":{"abduct":-0.053,"crouch":0.6,"feetOut":0.4,"feetSplit":1.2,"flex":0.946,"lean":0.05,"pitch":-0.164}},"thigh":14.85,"thighRadius":3.9,"torso":[7.6,6.9,5.2],"upperArm":11.4,"upperArmRadius":3.4}},"realist-woman":{"about":"The woman as drawn: 8% larger than her build (about 55px), the slim man\'s height, so she stands about his height beside the heavier human man. Scaled whole: every length and girth, not roundness, cloth or stance angles.","extends":"woman","scale":1.08},"slim-man":{"about":"A slim adult man, drawn about 55px tall: the Ember Lord\'s.","proportions":{"ankleHeight":2.2,"clothThickness":0.5,"craniumLift":0.45,"deltoidRadius":2.5,"earHeight":-0.7,"eyeHeight":0.8,"eyeSpacing":1.55,"footLength":4.73,"footProfileWidth":1.54,"footRadius":1.32,"footWidth":2.2,"forearm":8.14,"forearmRadius":2.1,"girdle":{"cut":0,"drop":1.6,"radii":[7.8,6.2,3.2]},"handInset":0,"handLength":1,"handRadius":2.6,"head":[3.65,3.6,3.55],"headCenter":4.9,"headRoundness":[2.2,2.3,2.1],"hipDrop":1.76,"hipWidth":2.5,"neck":8.14,"neckRadius":2.4,"pelvis":[4.7,4.4,3.6],"pelvisRoundness":[2.4,2,2],"posture":0.33,"profileEyeInset":0.9,"shin":13.75,"shinRadius":2.4,"shoulderHeight":2.7,"shoulderWidth":6.2,"spine":7.5,"stance":{"back":{"abduct":0.083,"crouch":0.6,"feetOut":2.21,"flex":0.964,"lean":0.05,"pitch":-0.19},"front":{"abduct":0.083,"crouch":0.6,"feetOut":2.21,"flex":0.964,"lean":0.05,"pitch":-0.19},"side":{"abduct":-0.049,"crouch":0.6,"feetOut":0.33,"feetSplit":1.1,"flex":0.941,"lean":0.05,"pitch":-0.155}},"thigh":13.75,"thighRadius":3,"torso":[6.2,6,4.4],"torsoRoundness":[2.2,2,2],"upperArm":10.56,"upperArmRadius":2.5}},"wolfman":{"about":"The human man\'s rig and build -- every bone the same length -- under a wolf\'s head half again a man\'s (the wolf head is sized off `head`; the eyes follow it).","extends":"human-man","proportions":{"eyeHeight":1.1,"eyeSpacing":2.3,"head":[5.64,5.52,5.52],"profileEyeInset":1.3}},"woman":{"about":"A real adult woman\'s build beside the slim man\'s: about 92% of his height, narrower in the shoulders and ribcage; an hourglass -- a slim ribcage, a pelvis wider than it set low so it is widest at the hip joints and tapers up into the waist (tall and set low: its top at the waist turns down steeply, so the light doesn\'t catch a shelf there that reads as a belly), thighs set wide so the hips flare below the waist; slimmer arms, neck, hands and feet, and a bust. The same rig and clips: she walks, fights and dresses as he does.","extends":"slim-man","proportions":{"ankleHeight":2,"bust":2.55,"calf":2,"deltoidRadius":1.9,"eyeSpacing":1.45,"footLength":4.2,"footProfileWidth":1.35,"footRadius":1.15,"footWidth":1.9,"forearm":7.5,"forearmRadius":1.6,"girdle":{"cut":0,"drop":1.5,"radii":[6.2,5.2,2.7]},"handLength":0.9,"handRadius":2.1,"head":[3.45,3.45,3.4],"headCenter":4.6,"hipDrop":1.7,"hipWidth":3.2,"neck":7.5,"neckRadius":1.9,"pelvis":[5.6,5.1,3.8],"pelvisLow":2.1,"pelvisRoundness":[2.1,2,2],"quad":2.6,"shin":12.65,"shinRadius":1.75,"shoulderHeight":2.4,"shoulderWidth":5.1,"spine":6.9,"stance":{"back":{"abduct":0.175,"crouch":0.56,"feetOut":1.7,"flex":0.925,"lean":0.05,"pitch":-0.174},"front":{"abduct":0.175,"crouch":0.56,"feetOut":1.7,"flex":0.925,"lean":0.05,"pitch":-0.174},"side":{"abduct":0.063,"crouch":0.56,"feetOut":0.3,"feetSplit":1,"flex":0.947,"lean":0.05,"pitch":-0.156}},"thigh":12.65,"thighRadius":2.85,"torso":[4.7,5.3,3.8],"upperArm":9.7,"upperArmRadius":1.9,"waist":[3.3,2.7,2.9],"waistHeight":2.4}}},"humanoids":[{"about":"Ember\'s own man: a real adult\'s proportions -- about seven heads tall, elbows at the waist, wrists at the crotch, fingertips at mid-thigh -- with a barbarian\'s build, in Ember\'s own style, at LPC\'s camera. Bare, for judging the body; `realist-dressed` is him in clothes. Every human man is drawn as him (clothes, hair and skin come from the entity).","build":"human-man","frame":80,"look":{"skin":"light"},"name":"realist","style":"realist"},{"about":"The slim man, bare: the realist man as first drawn. The Ember Lord is one.","build":"slim-man","look":{"skin":"light"},"name":"male-slim","style":"realist"},{"about":"The slim man dressed.","build":"slim-man","look":{"belt":{"dye":"black"},"hair":{"color":"brown","style":"short"},"pants":{"dye":"brown"},"shirt":{"dye":"teal","sleeves":"long"},"shoes":{"cut":"boots","dye":"leather"},"skin":"light"},"name":"male-slim-dressed","style":"realist"},{"about":"The realist woman, bare: every human woman is drawn as her (clothes, hair and skin come from the entity).","build":"realist-woman","look":{"eyes":"lash","skin":"light"},"name":"realist-female","style":"realist"},{"about":"The realist woman dressed.","build":"realist-woman","look":{"belt":{"dye":"black"},"eyes":"lash","hair":{"color":"chestnut","style":"long"},"pants":{"cut":"skirt","dye":"brown"},"shirt":{"dye":"maroon","neck":"scoop","puffed":true,"sleeves":"short"},"shoes":{"dye":"leather"},"skin":"light"},"name":"realist-female-dressed","style":"realist"},{"about":"The human man\'s skeleton: the same rig and proportions, bone where the flesh was, so it walks, fights and wears equipment as he does.","build":"human-man","frame":80,"look":{"bones":true,"skin":"light"},"name":"skeleton","style":"realist"},{"about":"The human man dead and risen: grey-green flesh torn open, sunken eyes, ragged shorts, the shamble -- hunched, arms reaching -- over his own walk, run and strike.","build":"human-man","frame":80,"look":{"eyes":"zombie","pants":{"cut":"shorts","dye":"brown"},"skin":"zombie","wounds":true},"name":"zombie","posture":"shamble","style":"realist"},{"about":"LPC\'s wolfman on the human man\'s rig and build: a wolf\'s head and fur (the game\'s wolf colours), a ruff and a tail; he walks, fights and dresses as the man does.","build":"wolfman","frame":80,"look":{"beast":"wolf","eyes":"wolf","skin":"wolf-brown"},"name":"wolfman","style":"realist"},{"about":"The human man dressed.","build":"human-man","frame":80,"look":{"belt":{"dye":"black"},"hair":{"color":"brown","style":"short"},"pants":{"dye":"brown"},"shirt":{"dye":"teal","sleeves":"long"},"shoes":{"cut":"boots","dye":"leather"},"skin":"light"},"name":"realist-dressed","style":"realist"},{"about":"An LPC-style man, dressed for the road.","look":{"belt":{"dye":"leather"},"hair":{"color":"brown","style":"short"},"pants":{"dye":"brown"},"shirt":{"dye":"green","sleeves":"short"},"shoes":{"cut":"boots","dye":"leather"},"skin":"light"},"name":"wanderer"},{"about":"An LPC-style warden: broad in the shoulders and chest.","look":{"belt":{"dye":"ochre"},"hair":{"color":"black","style":"crop"},"pants":{"dye":"charcoal"},"shirt":{"dye":"maroon","sleeves":"long","tunic":true},"shoes":{"cut":"boots","dye":"black"},"skin":"brown"},"name":"warden","proportions":{"shoulderWidth":10.2,"torso":[8.6,6.8,8.6]}},{"about":"An LPC-style forager.","look":{"hair":{"color":"blonde","style":"long"},"pants":{"dye":"tan"},"shirt":{"dye":"blue","sleeves":"long"},"shoes":{"dye":"brown"},"skin":"olive"},"name":"forager","proportions":{"hipWidth":4.4,"shoulderWidth":9,"torso":[7.6,6.4,7.7]}},{"about":"An LPC-style runner.","look":{"hair":{"color":"red","style":"ponytail"},"pants":{"cut":"shorts","dye":"navy"},"shirt":{"dye":"white","sleeves":"none"},"shoes":{"dye":"gray"},"skin":"black"},"name":"runner"}],"races":[{"body":"skeleton","race":"skeleton"},{"body":"zombie","race":"zombie"},{"body":"wolfman","race":"wolfman"},{"body":"realist-female","race":"human","sex":"female"},{"body":"realist","race":"human"}],"version":1},"emberMarks":{"about":"Anatomy and faces as LPC paints them: pixel patterns stamped onto the render, pinned to the skeleton so they move with the pose. An eye is a few pixels and a muscle a few more: rendered from geometry they come out a different few pixels every frame, so they are painted on. Rows are characters: a letter names a colour (markLetters / eyeLetters, or a style\'s own colours), \\".\\" leaves the render alone.","defaultEyes":"ember","eyeLetters":{"#":"skin.outline","a":"eye.ember","about":"Colours eyes paint unless the eye style names its own: `skin.<step>` the face\'s skin ramp, `eye.<name>` palettes.json eye colours.","c":"eye.glint","g":"eye.wolf","n":"skin.line","w":"eye.white"},"eyePlacement":{"about":"Where the skeleton puts the eyes and when they show: both from the front once the head\'s forward is turned more than frontTurn toward the camera; the near eye alone in profile once it is turned more than profileTurn sideways; none from behind. They sit at the head\'s eyeSpacing and eyeHeight, faceDepth of its depth forward of its centre (in profile, set back by profileEyeInset and out toward the near cheek, cheek of its width). The head\'s actual turn, not the facing name, picks the pattern.","cheek":0.8,"faceDepth":0.97,"frontTurn":0.5,"profileTurn":0.6},"eyeStyles":{"dot":{"about":"A head drawn at real proportions is a few pixels across: each eye is one dark pixel.","center":{"x":0.5,"y":0.5},"colors":{"e":"eye.warmPupil","i":"eye.warmPupil","p":"eye.warmPupil"},"front":[["e"],["e"]],"profile":["e"]},"ember":{"about":"Ember\'s own: a tall near-black eye with the fire\'s amber catch-light and a short brow slanted outward. No white and no cool glint, which is what makes an LPC eye read as LPC.","center":{"x":2,"y":2},"colors":{"e":"eye.warmPupil","i":"eye.warmPupil","p":"eye.warmPupil"},"front":[["nn..",".ae.",".ee.",".ee."],["..nn",".ae.",".ee.",".ee."]],"profile":["nn..","ae..","ee..","ee.."]},"lash":{"about":"The realist\'s dot eye with a lash at its outer corner: a woman\'s face at this size.","center":{"x":1.5,"y":1.5},"colors":{"e":"eye.warmPupil","i":"eye.warmPupil","p":"eye.warmPupil"},"front":[["#..",".e."],["..#",".e."]],"profile":["#..",".e."]},"lpc":{"about":"LPC\'s own eye, read off body/male/human/light.png: a brow, lashes, a cool glint at the corners, white, iris and pupil.","center":{"x":2,"y":2.5},"colors":{"e":"eye.pupil","i":"eye.iris","p":"eye.pupil"},"front":[[".nn.","c##c","w#iw",".ppw"],[".nn.","c##c","wi#w","wpp."]],"profile":[".nn.","##cc","i#ww","ppw."]},"wolf":{"about":"A wolfman\'s: LPC\'s pale cyan glow, a pixel each, set in the dark of the fur.","center":{"x":0.5,"y":0.5},"colors":{"e":"eye.wolf","i":"eye.wolf","p":"eye.wolf"},"front":[["g"],["g"]],"profile":["g"]},"zombie":{"about":"A dead eye: sunk dark in its socket, a milky glint where a living one has its pupil.","center":{"x":1,"y":0.5},"colors":{"e":"eye.warmPupil","i":"eye.warmPupil","p":"eye.warmPupil"},"front":[["ew"],["we"]],"profile":["we"]}},"markLetters":{"B":"base","D":"deep","L":"light","S":"shade","about":"Muscle marks paint the skin\'s own ramp.","n":"line"},"markSets":{"lpc-male":{"about":"LPC\'s muscle marks, read off the LPC male body (tools ember-markgen): collarbones, a lit deltoid cap, abdominals, a fist\'s knuckles, a knee -- modelled as bumps these melt into lumps at this size, and shading alone puts a highlight wherever the light falls rather than one per muscle. A mark\'s `at` is where LPC paints it (its top-left pixel) in the standing frame of its facing; its offset from the joint it is `on` is measured in Ember\'s standing pose at the default (LPC) proportions, so standing still it lands on LPC\'s pixel and any other pose carries it along with the joint -- which is why a style draws these only on the LPC-fitted body. It paints only bare skin of the parts round that joint (a shirt or an arm in front hides it), and is left off when the limb has swung more than `swungLimit` degrees from where it hung, or the torso turned more than `turnedLimit` from its standing turn (a pattern does not rotate). Front and back marks are written for the limb on the screen\'s left (`side: screenLeft`) and mirrored onto the other (mirrorSides); a facing in mirrorFacings is another\'s marks mirrored. Side-on, `near` and `far` are the limbs nearer and farther from the camera. Diagonal facings have none: they are shaded from the volumes alone.","facings":{"back":[{"about":"The crown, lit, its outline softened at the corners.","at":[25,16],"on":"head","rows":["..nSSBBBSSSn..","nSBBBBBBBBSSSn","SBBBBBBBBBBSSS"]},{"about":"The ear.","at":[22,24],"on":"head","rows":["nSBB","nDBB","SDSB","BSSB","SBSS"],"side":"screenLeft"},{"about":"The nape in the head\'s shadow, down over the trapezius.","at":[24,29],"on":"neck","rows":["DSSSBBBBBBSSSSSD","nSSSSSSSSSSSSSSn",".DSSSSSSSSSSSSD.",".nDSSSSSSSSSSDn.","DDnnSSSSSSSSnnSD","BBSSSSSSSSSSSSBB","BBBSSSSSSSSSSBBB","BBBBBSSSSSSBBBBB","BBBBBBBBBBBBBBBB"]},{"about":"The deltoid, lit on its cap.","at":[20,33],"on":"shoulder","rows":[".nSSD","nLLLB","BLLBB","BBBBB","SBBBB"],"side":"screenLeft"},{"about":"The shoulder blades.","at":[23,38],"on":"chest","rows":["..................","DS..............SD",".DS...S....S...SD.",".nDS..S....S..SDn."]},{"about":"The back of the arm, where it leaves the shoulder blade.","at":[18,38],"on":"shoulder","rows":[".SSDD","nSSSn","D.SD.","S.Sn."],"side":"screenLeft"},{"about":"The lower back: the spine\'s valley between muscles in shade.","at":[24,42],"on":"pelvis","rows":[".DDDSS....SSDDD.",".DSSSS....SSSSDn","nSSSSS....SSSSSn","nSSSS......SSSSn","DSDSS......SSDSD"]},{"about":"The seat.","at":[23,47],"on":"pelvis","rows":[".SSDSS......SSDSS.","...SnSS....SSnS...","D...DnDDSSDDnD...D","D...Sn......nS...D"]},{"about":"The forearm, lit along its outer edge.","at":[18,40],"on":"elbow","rows":["DBSD","SBSn","LLS.","BLD."],"side":"screenLeft"},{"about":"The back of the hand.","at":[18,44],"on":"hand","rows":["SBBS.","SLBBn","DBBBS","nBBBB",".DBSS"],"side":"screenLeft"},{"about":"The calf, dark, its outline lined.","at":[21,51],"on":"knee","rows":["..D..SD","..nSSSn","..nDDS.",".nnDDD.","nnDSSS.","nnS..S."],"side":"screenLeft"},{"about":"The heel, lit.","at":[21,57],"on":"ankle","rows":["DDLLBD.","DSLLBD.",".nSBDn."],"side":"screenLeft"}],"front":[{"about":"The crown, lit, its outline softened at the corners.","at":[25,16],"on":"head","rows":["..nDSBBBSSDn..","nSBBBBBBBBSSDn","SBBBBBBBBBBBSS"]},{"about":"The ear.","at":[22,26],"on":"head","rows":["nDSB","BDSS","BDSS","BBDS",".BDS"],"side":"screenLeft"},{"about":"Collarbones meeting at the sternum, the upper chest shaded under them.","at":[25,33],"on":"chest","rows":["nSBBBBBBBBBBSn","SnnSBBBBBBSnnS","BSSnnnnnnnnSSB","BBSSSSSSSSSSBB","BBBSSSSSSSSBBB"]},{"about":"The deltoid, lit on its cap.","at":[20,33],"on":"shoulder","rows":[".nSSD","nLLLB","SLLLB","BLLBB","BBBBB"],"side":"screenLeft"},{"about":"The armpit crease where the arm leaves the chest.","at":[19,38],"on":"shoulder","rows":["DSSDSS.","SSDnDS.","SSSnnSS"],"side":"screenLeft"},{"about":"The lower ribs: pecs lit along their bottom edge, flanks in shade.","at":[24,41],"on":"chest","rows":["DSBLBBBBBBBBLBSD","nDSBLLBBBBLLBSDn",".DDDSBBBBBBSDDD."]},{"about":"The abdomen: two pairs of lit blocks.","at":[25,44],"on":"pelvis","rows":["SSSBBLLLLBBSSS","SSSBLLBBLLBSSS","SSSSBBBBBBSSSS"]},{"about":"The lower belly in shade, the lines of the hips running in to the groin.","at":[24,47],"on":"pelvis","rows":["SSDSSS....SSSDSS","SSDDSSSSSSSSDDSS","..SDnDSSSSDnDS..","...SSn....nSS..."]},{"about":"The forearm, lit along its outer edge.","at":[18,41],"on":"elbow","rows":["LBSD","LBS.","LLS.","BBD."],"side":"screenLeft"},{"about":"The fist: knuckles lit, fingers lined.","at":[18,45],"on":"hand","rows":["SBBS.","SLBBB","DBBnB","nBBnn",".DBSS"],"side":"screenLeft"},{"about":"The knee: a stroke inside above it, the calf\'s outline below.","at":[23,50],"on":"knee","rows":["D.....","D....n","D...D.","D...n.","nD....","n..D..","....n."],"side":"screenLeft"},{"about":"The toes.","at":[21,57],"on":"ankle","rows":[".SBBBSD","DBBBBBS","BBBBBBS","SBLDLL."],"side":"screenLeft"}],"left":[{"about":"The crown, lit, its outline softened at the corners.","at":[26,16],"on":"head","rows":["..nDSBBBSDn...","nDBBBBBBBBSDn.","SBBBBBBBBBBSSn"]},{"about":"The ear, and the angle of the jaw below it.","at":[34,26],"on":"head","rows":["BBDDDBS","BSDBDSD","SSBBDSD","SBBBDD.","SSBDn..","SSnn..."]},{"about":"The face, lit to its edge: a profile is not rimmed in shade like the back of the head.","at":[24,19],"on":"head","rows":[".SBB.","nBBB.","DBBB.","SBBBB","BBBBB","BBBBB","BBBBB","BBBBB","BBBBB","SBBBS",".BBB.",".BBB.",".BBB.",".SBBB"]},{"about":"Under the jaw: the chin\'s underside, the jaw\'s angle, a line and a band of shade on the chest below.","at":[25,32],"on":"neck","rows":["SBBBBBBBBBSD",".DBBBBBBBSDn","..nSBBBBSDnn","nnnnnnnnnnSB","DDDSSSSSSBBB","SSSSSSSSBBBB"]},{"about":"The near deltoid, lit on its cap.","at":[35,33],"on":"shoulder","rows":["Dnn....","nnSSn..","SBLLLn.","BBLLLS.","BBBLLBn"],"side":"near"},{"about":"The near arm, lit down its front.","at":[36,39],"on":"elbow","rows":["SS....","DDS...","S.D...","S..L..","D..L.S","D.D..D",".DD..."],"side":"near"},{"about":"The near hand.","at":[36,46],"on":"hand","rows":["S....","n..LD","n...D","...D."],"side":"near"},{"about":"Chest and belly: the pec lit along its bottom, the stomach below.","at":[25,40],"on":"chest","rows":["SBBBBBBBBBB","SBBBBBLLBBB","nBBBLLLBBSS",".SBBSSDDSSD",".DLLBBBSSSD",".nBBLLBSSSD"]},{"about":"The lower belly and the groin.","at":[26,46],"on":"pelvis","rows":["n.....SSD.","nS...SSSD.","DSSSSSSSS.","SSDnnDSSS.","SSDD.nS..n"]},{"about":"The near knee.","at":[31,50],"on":"knee","rows":["nS..n..",".S..SSn",".n...Sn","..D...D","..nS.SD","...nSSS"],"side":"near"},{"about":"The far knee.","at":[26,51],"on":"knee","rows":["DSSDn","nSSSn",".DSSD",".nSSD",".nSSS","DS.SS"],"side":"far"}]},"frame":64,"mirrorFacings":{"right":"left"},"mirrorSides":{"screenLeft":"screenRight"},"swungLimit":35,"turnedLimit":0.35}},"version":1},"emberPalettes":{"about":"Ember\'s colours. A RAMP is a material: six colours, [light, base, shade, deep, line, outline] -- the shader picks one of the first four from the light (it never invents a colour, which keeps the result pixel art), `line` marks creases and limbs crossing the body, `outline` is drawn where the material meets the background. Ramps come in named groups; a SKIN SET (what a style draws skin with) is a list of groups. Garment and hair colours are single base colours that rampFrom turns into a ramp (shadows toward violet, highlights toward warm yellow, as LPC\'s cloth).","dyes":{"about":"Cloth and leather dyes an Ember humanoid\'s outfit may name; an unknown name is gray.","colors":{"black":"#2d2a30","blue":"#3e63a0","brown":"#7a5134","charcoal":"#45454c","forest":"#35583a","gray":"#7b7c80","green":"#55813f","leather":"#6b4a30","maroon":"#6e2a31","navy":"#2b3a63","ochre":"#b8873a","orange":"#c06a2c","purple":"#674a8f","red":"#a8383b","tan":"#a98557","teal":"#2f7a7a","white":"#d9d4c7","yellow":"#d6b546"}},"eye":{"about":"Eye colours, sampled from the LPC sheets: `glint` the cyan catch-light at the corners of an LPC eye, `white`, `iris`, `pupil`; `ember` Ember\'s warm catch-light from the fire on `warmPupil`, a warm near-black; `wolf` a wolfman\'s eye, LPC\'s pale cyan glow.","colors":{"ember":"#ffbf5a","glint":"#50d4ec","iris":"#5187b3","pupil":"#293d4b","warmPupil":"#24140f","white":"#f2f8f9","wolf":"#9cf3d9"}},"hair":{"about":"Hair colours: Ember\'s own and the rest of the game\'s (LPC\'s); an unknown name is brown.","colors":{"black":"#2b2629","blonde":"#d1a654","blue":"#3a5a9a","brown":"#5d3b25","chestnut":"#7d4426","gold":"#c9952f","gray":"#8d8a8a","green":"#3f7a3a","lightbrown":"#8a5f3a","orange":"#c0642a","purple":"#6a4a8f","red":"#a5452a","white":"#d8d4cf"}},"ramps":{"bones":{"about":"A skeleton\'s bone by the game\'s skeleton body colours (LPC\'s beige, gray and green sheets); `white` unless named. Ivory with warm grey shadows -- the shared ramp\'s purple-ward shift turns pale bone pink. LPC\'s green skeleton is a vivid, toxic green, not a mossy bone.","tones":{"beige":["#f1ebd8","#d9d0b4","#aca186","#7d735f","#544c3f","#281820"],"gray":["#f0f0f8","#c9c9e0","#a3abb9","#727080","#4d4b5c","#1d131e"],"green":["#a8ff7a","#38e83c","#2f9a1d","#2a6a22","#1f4a1b","#1d131e"],"white":["#f1ebd8","#d9d0b4","#aca186","#7d735f","#544c3f","#281820"]}},"lpc-skin":{"about":"Skin sampled from content/game/media/lpc/spritesheets/body/male/human/<tone>.png, so an LPC-style body sits beside the LPC art. `zombie` is dead flesh: a sickly grey-green, the game\'s zombie \\"green\\".","tones":{"black":["#714535","#61382d","#3b2924","#2b2122","#1c1418","#070609"],"brown":["#c58050","#a86431","#7e4f32","#644334","#442826","#120d0f"],"light":["#fbece6","#fdd5b7","#eaa377","#d28560","#9e3e37","#281820"],"olive":["#d99f90","#d98e60","#a96b4c","#905e51","#5a3737","#281821"],"zombie":["#d3d8ae","#aab184","#848c66","#636a4b","#454a33","#281820"]}},"painted-skin":{"about":"Skin for Ember\'s own (realist) style: picked, not sampled, and set apart from LPC by its shadows, which cool toward violet, and its outline, a deep plum rather than LPC\'s brown-black.","tones":{"black":["#8f5f4c","#6b4337","#4e2f2d","#38222a","#271822","#110a14"],"brown":["#c98f63","#a26a45","#7b4d3c","#5c3637","#40242f","#1a1022"],"light":["#f8dcc4","#e9b892","#c98a6c","#9c6158","#6e3d4a","#25182b"],"olive":["#e6bf98","#c99468","#9f6c55","#7a4d4c","#553243","#22162a"],"zombie":["#cdd3a6","#a6ad80","#808862","#5f6648","#424730","#25182b"]}},"wolf-fur":{"about":"A wolfman\'s fur in the game\'s four wolf colours, `wolf-<colour>`, ramps taken off LPC\'s wolfman sheets (its black is a blue-black, its white a cool grey-white). The same in both skin sets.","tones":{"wolf-black":["#2f4552","#1b2c36","#14212c","#0d1621","#0a0e1b","#040510"],"wolf-brown":["#8a5b47","#624135","#4a3830","#33251f","#1e120e","#100806"],"wolf-gray":["#8c9296","#6a6e74","#55585f","#41424a","#26262d","#0f0f11"],"wolf-white":["#e6e9e9","#c4c7c8","#9ea5a9","#7a8389","#484e57","#17171a"]}}},"skins":{"lpc":["lpc-skin","wolf-fur"],"painted":["painted-skin","wolf-fur"]},"version":1},"emberSpecies":{"about":"Species on rigs of their own (ember_sprite/species.ts): each brings its joints and legs, gaits generated from a few numbers, keyed clips, which of them plays each of the game\'s actions, and its bodies -- models of slot `species` hung on the posed joints. Angles in degrees, lengths in world pixels; y up, +z the way the body faces, +x its left.","library":[],"models":{"centaur":{"about":"A centaur: a horse\'s barrel on four legs, a person\'s torso, arms and head rising from its chest, a long tail. Bare-chested with a leather band across the chest.","let":[["coatM","rampFrom(coat)"],["skinM","rampFrom(skin)"],["hairM","rampFrom(hair)"],["hoofM","rampFrom(hoof)"],["bandM","rampFrom(band)"],["J","sk.at"],["B","sk.basis"],["chestC","add(J.chest, apply(B.chest, [0, -4.4, -1]))"],["bellyC","add(J.loin, apply(B.loin, [0, -4.4, 0]))"],["rumpC","add(J.pelvis, apply(B.pelvis, [0, -3.4, -0.6]))"],["withers","add(J.chest, apply(B.chest, [0, -0.5, 2.6]))"],["belly","lerp(J.waist, J.torso, 0.35)"],["eyes","(w, n) => [1, -1].some(s => distance(w, add(J.head, apply(B.head, [s * 1.2, 0.2, 2.6]))) < 0.55) ? hairM.deep : undefined"],["strap","(w, n) => abs(dot(sub(w, J.torso), normalize(apply(B.torso, [-0.75, 1, 0])))) < 0.7 ? bandM.base : undefined"],["legs","[[\'fl\', \'legFL\', 1], [\'fr\', \'legFR\', 1], [\'hl\', \'legHL\', 0], [\'hr\', \'legHR\', 0]]"],["arms","[[\'r\', \'armR\'], [\'l\', \'armL\']]"]],"params":{"band":"#5a3a22","coat":"#8a5a34","hair":"#3a2416","hoof":"#2f2420","skin":"#d8a07a"},"parts":["ellipsoid(chestC, B.chest, [5.6, 7.0, 7.4], coatM, \'torso\')","ellipsoid(bellyC, B.loin, [5.5, 6.3, 10.5], coatM, \'torso\')","ellipsoid(rumpC, B.pelvis, [5.8, 6.8, 7.0], coatM, \'torso\')","segment(withers, J.waist, 3.9, coatM, \'torso\')",{"paint":"strap","parts":["ellipsoid(belly, B.waist, [3.9, 3.9, 3.1], skinM, \'torso\')","ellipsoid(J.torso, B.torso, [4.7, 4.7, 3.4], skinM, \'torso\', { exponent: [2.6, 2.2, 2.2] })"]},"joint(J.rShoulder, 2.2, skinM, \'torso\')","joint(J.lShoulder, 2.2, skinM, \'torso\')","segment(J.torso, J.neck, 1.8, skinM, \'torso\')",{"paint":"eyes","parts":["ellipsoid(J.head, B.head, [2.8, 3.2, 2.9], skinM, \'head\')"]},"ellipsoid(add(J.head, apply(B.head, [0, 1.0, -0.5])), B.head, [3.1, 2.7, 3.2], hairM, \'hair\', { keep: q => q[1] > -0.6 && q[2] < 1.8 })","ellipsoid(add(J.head, apply(B.head, [0, -1.8, -2.1])), B.head, [2.7, 3.0, 1.4], hairM, \'hair\')",{"as":"arm","each":"arms","let":[["s","arm[0]"],["group","arm[1]"]],"parts":["segment(J[s + \'Shoulder\'], J[s + \'Elbow\'], 1.75, skinM, group)","as(segment(J[s + \'Elbow\'], J[s + \'Hand\'], 1.5, skinM, group), \'forearm\')","as(joint(J[s + \'Hand\'], 1.45, skinM, group), \'hand\')"]},"segment(J.tail, J.tail2, 1.8, hairM, \'tail\')","segment(J.tail2, J.tailTip, 2.0, hairM, \'tail\')",{"as":"leg","each":"legs","let":[["k","leg[0]"],["group","leg[1]"],["fore","leg[2] === 1"],["top","J[k + (fore ? \'Shoulder\' : \'Hip\')]"],["knee","J[k + (fore ? \'Elbow\' : \'Stifle\')]"],["ankle","J[k + (fore ? \'Knee\' : \'Hock\')]"],["hoofAt","J[k + \'Hoof\']"]],"parts":["segment(top, knee, fore ? 3.0 : 3.9, coatM, group)","as(segment(knee, ankle, fore ? 1.8 : 2.0, coatM, group), \'shin\')","as(segment(ankle, hoofAt, 1.3, coatM, group), \'cannon\')","as(ellipsoid(hoofAt, B[k + \'Hoof\'], [1.4, 1.2, 1.6], hoofM, group), \'foot\')"]}]},"deer":{"about":"A deer: a barrel of chest, belly and haunch on four slender legs, a long neck, a narrow head with a dark muzzle and big ears, a pale belly, throat and rump, a short tail with a white underside. Antlers on a stag.","let":[["coatM","rampFrom(coat)"],["paleM","rampFrom(pale)"],["darkM","rampFrom(dark)"],["hornM","rampFrom(\'#cbb48a\')"],["J","sk.at"],["B","sk.basis"],["chestC","add(J.chest, apply(B.chest, [0, -4.3, -0.5]))"],["bellyC","add(J.loin, apply(B.loin, [0, -4.0, 0]))"],["rumpC","add(J.pelvis, apply(B.pelvis, [0, -3.3, -0.6]))"],["throat","add(J.head, apply(B.head, [0, -2.0, -1.4]))"],["neckBase","add(J.neck, apply(B.neck, [0, -3.0, -1.2]))"],["neckMid","lerp(neckBase, throat, 0.45)"],["muzzleRoot","add(J.head, apply(B.head, [0, -0.6, 1.2]))"],["eye","s => add(J.head, apply(B.head, [s * 2.1, 0.6, 1.4]))"],["earTip","(ear, s) => add(J[ear], apply(B[ear], [s * 2.8, 3.2, -0.9]))"],["underside","(w, n) => n[1] < -0.55 ? paleM.base : undefined"],["rumpPatch","(w, n) => dot(sub(w, rumpC), apply(B.pelvis, [0, 0, -1])) > 3.6 && dot(sub(w, rumpC), apply(B.pelvis, [0, 1, 0])) < 2.6 ? paleM.base : undefined"],["eyes","(w, n) => distance(w, eye(1)) < 0.75 || distance(w, eye(-1)) < 0.75 ? darkM.deep : undefined"],["legs","[[\'fl\', \'legFL\', 1], [\'fr\', \'legFR\', 1], [\'hl\', \'legHL\', 0], [\'hr\', \'legHR\', 0]]"]],"params":{"antlers":false,"coat":"#9a6438","dark":"#3b2a22","pale":"#e6d7bf"},"parts":[{"paint":"(w, n) => underside(w, n) ?? rumpPatch(w, n)","parts":["ellipsoid(chestC, B.chest, [4.8, 6.7, 6.8], coatM, \'torso\')","ellipsoid(bellyC, B.loin, [5.0, 5.9, 10], coatM, \'torso\')","ellipsoid(rumpC, B.pelvis, [5, 6.2, 6.3], coatM, \'torso\')"]},{"paint":"(w, n) => n[1] < -0.3 ? paleM.base : undefined","parts":["segment(neckBase, neckMid, 3.6, coatM, \'torso\')","segment(neckMid, throat, 2.7, coatM, \'torso\')"]},{"paint":"eyes","parts":["ellipsoid(J.head, B.head, [2.6, 2.9, 3.4], coatM, \'head\')"]},"segment(muzzleRoot, J.nose, 1.8, coatM, \'head\')","joint(J.nose, 1.05, darkM, \'head\')","segment(J.earL, earTip(\'earL\', 1), 1.3, coatM, \'head\')","segment(J.earR, earTip(\'earR\', -1), 1.3, coatM, \'head\')",{"parts":[{"as":"s","each":"[1, -1]","let":[["base","add(J.head, apply(B.head, [s * 1.2, 2.2, -0.4]))"],["beam","add(base, apply(B.head, [s * 3.0, 6.2, -1.6]))"],["top","add(beam, apply(B.head, [s * 0.8, 4.0, 2.0]))"],["tine","add(beam, apply(B.head, [s * -0.6, 2.8, 2.8]))"],["brow","add(base, apply(B.head, [s * 0.8, 2.8, 2.6]))"]],"parts":["segment(base, beam, 0.85, hornM, \'head\')","segment(beam, top, 0.75, hornM, \'head\')","segment(beam, tine, 0.7, hornM, \'head\')","segment(base, brow, 0.65, hornM, \'head\')"]}],"when":"antlers"},{"paint":"(w, n) => dot(n, apply(B.tail, [0, 0, -1])) > 0.2 || n[1] < -0.2 ? paleM.base : undefined","parts":["segment(J.tail, J.tailTip, 1.35, coatM, \'tail\')"]},{"as":"leg","each":"legs","let":[["k","leg[0]"],["group","leg[1]"],["fore","leg[2] === 1"],["top","J[k + (fore ? \'Shoulder\' : \'Hip\')]"],["knee","J[k + (fore ? \'Elbow\' : \'Stifle\')]"],["ankle","J[k + (fore ? \'Knee\' : \'Hock\')]"],["hoof","J[k + \'Hoof\']"]],"parts":["segment(top, knee, fore ? 2.6 : 3.4, coatM, group)","as(segment(knee, ankle, fore ? 1.5 : 1.75, coatM, group), \'shin\')","as(segment(ankle, hoof, 1.05, coatM, group), \'cannon\')","as(ellipsoid(hoof, B[k + \'Hoof\'], [1.05, 1.0, 1.3], darkM, group), \'foot\')"]}]}},"races":[],"species":{"centaur":{"about":"A centaur: a horse\'s body with a person\'s torso, arms and head rising from its chest; it holds the game\'s weapons in its hands -- a sword in its right, a shield or a bow\'s grip in its left.","actions":{"cast":"cast","climb":"idle","hurt":"hurt","idle":"idle","run":"run","shoot":"shoot","slash":"slash","thrust":"thrust","walk":"walk"},"bodies":{"centaur":{"about":"A chestnut centaur.","model":"centaur","scale":1.15},"centaur-grey":{"about":"A dapple-grey centaur, fair-haired.","model":"centaur","params":{"coat":"#9a958c","hair":"#d8c890","skin":"#e8c0a0"},"scale":1.15}},"clips":{"cast":{"about":"Both arms raised to the sky.","frameMs":90,"frames":8,"keys":[{"t":0,"turns":{"lElbow":[-15,0,0],"rElbow":[-15,0,0]}},{"pitch":-5,"t":0.45,"turns":{"lElbow":[-20,0,0],"lShoulder":[-150,0,-20],"neck":[-15,0,0],"rElbow":[-20,0,0],"rShoulder":[-150,0,20],"waist":[-10,0,0]}},{"pitch":-5,"t":0.75,"turns":{"lElbow":[-20,0,0],"lShoulder":[-150,0,-20],"neck":[-15,0,0],"rElbow":[-20,0,0],"rShoulder":[-150,0,20],"waist":[-10,0,0]}},{"t":1,"turns":{"lElbow":[-15,0,0],"rElbow":[-15,0,0]}}]},"hurt":{"about":"Falls: the forelegs buckle, it goes over onto its side, the arms flung out.","frameMs":70,"frames":8,"keys":[{"t":0,"turns":{"lElbow":[-15,0,0],"rElbow":[-15,0,0]}},{"feet":{"fl":[0,0,-1,40],"fr":[0,0,-1,40]},"pitch":12,"rise":-6,"t":0.35,"turns":{"lShoulder":[-40,0,-20],"rShoulder":[-40,0,20],"waist":[20,0,0]}},{"feet":{"fl":"free","fr":"free","hl":"free","hr":"free"},"rise":-16,"roll":65,"side":2,"t":0.75,"turns":{"lShoulder":[-20,0,-30],"rShoulder":[-60,0,30],"waist":[10,0,-15]}},{"feet":{"fl":"free","fr":"free","hl":"free","hr":"free"},"rise":-21,"roll":86,"side":3,"t":1,"turns":{"lShoulder":[-10,0,-30],"neck":[0,0,-15],"rShoulder":[-80,0,30],"waist":[0,0,-20]}}]},"idle":{"about":"Standing at ease, breathing; it looks about, the tail swishes.","frameMs":110,"frames":24,"keys":[{"t":0,"turns":{"lElbow":[-15,0,0],"rElbow":[-15,0,0]}},{"rise":0.3,"t":0.3,"turns":{"lElbow":[-15,0,0],"rElbow":[-15,0,0],"tail":[0,12,0],"torso":[-2,0,0]}},{"t":0.55,"turns":{"lElbow":[-15,0,0],"neck":[0,18,0],"rElbow":[-15,0,0],"tail":[0,-10,0],"waist":[0,8,0]}},{"rise":0.3,"t":0.8,"turns":{"lElbow":[-15,0,0],"neck":[0,18,0],"rElbow":[-15,0,0],"waist":[0,8,0]}},{"t":1,"turns":{"lElbow":[-15,0,0],"rElbow":[-15,0,0]}}],"loop":true},"shoot":{"about":"A bow drawn and loosed: the bow arm out ahead, the string hand drawn back to the cheek.","frameMs":60,"frames":10,"keys":[{"t":0,"turns":{"lElbow":[-15,0,0],"rElbow":[-15,0,0]}},{"t":0.4,"turns":{"lElbow":[-5,0,0],"lShoulder":[-88,0,-8],"rElbow":[-120,0,0],"rShoulder":[-80,0,20],"waist":[0,25,0]}},{"t":0.75,"turns":{"lElbow":[-5,0,0],"lShoulder":[-88,0,-8],"rElbow":[-60,0,0],"rShoulder":[-60,0,25],"waist":[0,25,0]}},{"t":1,"turns":{"lElbow":[-15,0,0],"rElbow":[-15,0,0]}}]},"slash":{"about":"An overhead cut: the weapon raised behind the head, the body rocking back on its haunches, then brought down and through.","frameMs":50,"frames":10,"keys":[{"t":0,"turns":{"lElbow":[-15,0,0],"rElbow":[-15,0,0]}},{"pitch":-7,"t":0.4,"turns":{"lElbow":[-30,0,0],"lShoulder":[-30,0,0],"rElbow":[-35,0,0],"rHand":[10,0,0],"rShoulder":[-170,0,12],"waist":[-12,12,0]}},{"feet":{"fl":[0,0,2.5]},"pitch":4,"t":0.62,"turns":{"lElbow":[-20,0,0],"lShoulder":[10,0,0],"rElbow":[-5,0,0],"rHand":[95,0,0],"rShoulder":[-55,0,0],"waist":[16,-10,0]}},{"feet":{"fl":[0,0,2.5]},"pitch":2,"t":0.8,"turns":{"lElbow":[-20,0,0],"rElbow":[-10,0,0],"rHand":[80,0,0],"rShoulder":[-25,0,-10],"waist":[12,-14,0]}},{"t":1,"turns":{"lElbow":[-15,0,0],"rElbow":[-15,0,0]}}]},"thrust":{"about":"A lunge: the body surges forward and the weapon drives out straight from the shoulder.","frameMs":50,"frames":10,"keys":[{"t":0,"turns":{"lElbow":[-15,0,0],"rElbow":[-15,0,0]}},{"shift":-1.5,"t":0.35,"turns":{"lElbow":[-30,0,0],"lShoulder":[-40,0,0],"rElbow":[-95,0,0],"rHand":[95,0,0],"rShoulder":[-75,0,10],"waist":[-4,18,0]}},{"feet":{"fl":[0,0,3]},"pitch":3,"shift":3,"t":0.6,"turns":{"lElbow":[-20,0,0],"lShoulder":[-10,0,0],"rElbow":[-5,0,0],"rHand":[95,0,0],"rShoulder":[-85,0,0],"waist":[10,-12,0]}},{"feet":{"fl":[0,0,2]},"shift":1.5,"t":0.8,"turns":{"rElbow":[-25,0,0],"rHand":[95,0,0],"rShoulder":[-70,0,0],"waist":[6,-8,0]}},{"t":1,"turns":{"lElbow":[-15,0,0],"rElbow":[-15,0,0]}}]}},"frame":128,"gaits":{"run":{"about":"A gallop; the person leans into it, arms tucked.","duty":0.3,"fold":{"fl":105,"fr":105,"hl":45,"hr":45},"frameMs":60,"frames":10,"lift":{"fl":7,"fr":7,"hl":5,"hr":5},"motion":[{"amplitude":1.6,"axis":"rise","joint":"root","perCycle":1,"phase":0.37},{"amplitude":5,"axis":"pitch","joint":"root","perCycle":1,"phase":0.68},{"amplitude":6,"axis":"pitch","joint":"loin","perCycle":1,"phase":0.65},{"amplitude":4,"axis":"pitch","joint":"waist","offset":14,"perCycle":1,"phase":0.2},{"amplitude":6,"axis":"pitch","joint":"rShoulder","offset":-25,"perCycle":1},{"amplitude":6,"axis":"pitch","joint":"lShoulder","offset":-25,"perCycle":1,"phase":0.5},{"amplitude":0,"axis":"pitch","joint":"rElbow","offset":-60},{"amplitude":0,"axis":"pitch","joint":"lElbow","offset":-60},{"amplitude":8,"axis":"pitch","joint":"tail","offset":-40,"perCycle":1}],"phases":{"fl":0.38,"fr":0.46,"hl":0,"hr":0.06},"reach":2,"stride":46},"walk":{"about":"A horse\'s four-beat walk; the person\'s arms swing a little, the torso riding steady.","duty":0.66,"fold":{"fl":55,"fr":55,"hl":30,"hr":30},"frameMs":90,"frames":12,"lift":{"fl":3,"fr":3,"hl":2.5,"hr":2.5},"motion":[{"amplitude":0.45,"axis":"rise","joint":"root","perCycle":2,"phase":0.25},{"amplitude":1.5,"axis":"pitch","joint":"waist","perCycle":2,"phase":0.6},{"amplitude":10,"axis":"pitch","joint":"rShoulder","perCycle":1,"phase":0},{"amplitude":10,"axis":"pitch","joint":"lShoulder","perCycle":1,"phase":0.5},{"amplitude":0,"axis":"pitch","joint":"rElbow","offset":-15},{"amplitude":0,"axis":"pitch","joint":"lElbow","offset":-15},{"amplitude":6,"axis":"yaw","joint":"tail","perCycle":1}],"phases":{"fl":0.25,"fr":0.75,"hl":0,"hr":0.5},"reach":1.5,"stride":20}},"grips":{"L":{"grip":[0,0.55,0.83],"hand":"lHand"},"R":{"grip":[0,0.55,0.83],"hand":"rHand"},"torso":"torso"},"joints":[["pelvis",null,[0,27,-12]],["loin","pelvis",[0,27.5,-2]],["chest","loin",[0,28,8]],["waist","chest",[0,32,11.5]],["torso","waist",[0,39.5,12]],["neck","torso",[0,45,12.2]],["head","neck",[0,49,12.6]],["rShoulder","torso",[-4.3,43.4,12]],["rElbow","rShoulder",[-4.9,37.4,11.4]],["rHand","rElbow",[-4.7,32.4,13.8]],["lShoulder","torso",[4.3,43.4,12]],["lElbow","lShoulder",[4.9,37.4,11.4]],["lHand","lElbow",[4.7,32.4,13.8]],["tail","pelvis",[0,28.5,-19]],["tail2","tail",[0,24,-22]],["tailTip","tail2",[0,18.5,-23]],["flShoulder","chest",[3.5,22,8.5]],["flElbow","flShoulder",[3.5,15,4.6]],["flKnee","flElbow",[3.3,7.6,6.8]],["flHoof","flKnee",[3.3,1.2,6.9]],["frShoulder","chest",[-3.5,22,8.5]],["frElbow","frShoulder",[-3.5,15,4.6]],["frKnee","frElbow",[-3.3,7.6,6.8]],["frHoof","frKnee",[-3.3,1.2,6.9]],["hlHip","pelvis",[3.7,23,-12]],["hlStifle","hlHip",[3.9,15.5,-8]],["hlHock","hlStifle",[3.5,9,-14.2]],["hlHoof","hlHock",[3.4,1.2,-13]],["hrHip","pelvis",[-3.7,23,-12]],["hrStifle","hrHip",[-3.9,15.5,-8]],["hrHock","hrStifle",[-3.5,9,-14.2]],["hrHoof","hrHock",[-3.4,1.2,-13]]],"legs":{"fl":{"joints":["flShoulder","flElbow","flKnee","flHoof"]},"fr":{"joints":["frShoulder","frElbow","frKnee","frHoof"]},"hl":{"joints":["hlHip","hlStifle","hlHock","hlHoof"]},"hr":{"joints":["hrHip","hrStifle","hrHock","hrHoof"]}},"points":{"head":"head"},"raster":{"pitch":20},"sideTurn":10,"style":"realist"},"deer":{"about":"A deer, at the scale of LPC\'s: about 30px at the withers and 60px nose to tail. Walks a four-beat walk (left hind, left fore, right hind, right fore) and runs a bounding gallop.","actions":{"cast":"attack","climb":"idle","hurt":"hurt","idle":"idle","run":"run","shoot":"attack","slash":"attack","thrust":"attack","walk":"walk"},"bodies":{"deer":{"about":"A doe, at LPC\'s deer\'s size.","model":"deer","scale":1.22},"stag":{"about":"A stag: bigger and darker, with antlers.","model":"deer","params":{"antlers":true,"coat":"#80522e"},"scale":1.32}},"clips":{"attack":{"about":"Rears on its hind legs, forelegs tucked, and strikes down with its forehooves.","frameMs":50,"frames":10,"keys":[{"t":0},{"feet":{"fl":"free","fr":"free","hl":[0,0,1.5],"hr":[0,0,1.5]},"pitch":-38,"rise":1,"t":0.35,"turns":{"flKnee":[110,0,0],"flShoulder":[-55,0,0],"frKnee":[100,0,0],"frShoulder":[-45,0,0],"neck":[-20,0,0],"tail":[-30,0,0]}},{"feet":{"fl":"free","fr":"free","hl":[0,0,1.5],"hr":[0,0,1.5]},"pitch":-14,"t":0.6,"turns":{"flKnee":[20,0,0],"flShoulder":[-70,0,0],"frKnee":[25,0,0],"frShoulder":[-62,0,0],"neck":[10,0,0]}},{"feet":{"fl":[0,0,6],"fr":[0,0,5]},"t":0.78,"turns":{"neck":[14,0,0]}},{"t":1}]},"graze":{"about":"Head down to the grass and up again.","frameMs":110,"frames":16,"keys":[{"t":0},{"feet":{"fl":[0,0,1],"fr":[0,0,-1]},"t":0.3,"turns":{"head":[20,0,0],"neck":[75,0,0]}},{"feet":{"fl":[0,0,1],"fr":[0,0,-1]},"t":0.7,"turns":{"head":[22,0,0],"neck":[78,4,0]}},{"t":1}]},"hurt":{"about":"Falls: the forelegs buckle, then it goes over onto its side and lies still.","frameMs":70,"frames":8,"keys":[{"t":0},{"feet":{"fl":[0,0,-1,40],"fr":[0,0,-1,40]},"pitch":14,"rise":-6,"t":0.35,"turns":{"neck":[20,0,0]}},{"feet":{"fl":"free","fr":"free","hl":"free","hr":"free"},"pitch":4,"rise":-16,"roll":65,"side":2,"t":0.75,"turns":{"neck":[10,0,-20]}},{"feet":{"fl":"free","fr":"free","hl":"free","hr":"free"},"rise":-21,"roll":86,"side":3,"t":1,"turns":{"head":[0,0,-10],"neck":[0,0,-30]}}]},"idle":{"about":"Standing, breathing; an ear flicks, the head turns to look, the tail twitches.","frameMs":110,"frames":24,"keys":[{"t":0},{"rise":0.3,"t":0.2},{"rise":0.3,"t":0.28,"turns":{"earL":[0,0,25]}},{"rise":0.2,"t":0.34},{"t":0.5,"turns":{"head":[0,14,0],"neck":[-4,10,0]}},{"rise":0.3,"t":0.72,"turns":{"head":[0,14,0],"neck":[-4,10,0],"tail":[-30,0,0]}},{"rise":0.2,"t":0.8,"turns":{"head":[0,7,0],"neck":[-2,5,0]}},{"t":1}],"loop":true}},"frame":128,"gaits":{"run":{"about":"A bounding gallop: the hind feet land together, then the fore; a moment of flight between; the back flexing and stretching, the body rocking and rising through it.","duty":0.3,"fold":{"fl":105,"fr":105,"hl":45,"hr":45},"frameMs":60,"frames":10,"lift":{"fl":7,"fr":7,"hl":5,"hr":5},"motion":[{"amplitude":1.6,"axis":"rise","joint":"root","perCycle":1,"phase":0.37},{"amplitude":5,"axis":"pitch","joint":"root","perCycle":1,"phase":0.68},{"amplitude":6,"axis":"pitch","joint":"loin","perCycle":1,"phase":0.65},{"amplitude":10,"axis":"pitch","joint":"neck","offset":12,"perCycle":1,"phase":0.9},{"amplitude":8,"axis":"pitch","joint":"tail","offset":-25,"perCycle":1}],"phases":{"fl":0.38,"fr":0.46,"hl":0,"hr":0.06},"reach":2,"stride":48},"walk":{"about":"A four-beat walk: each foot down two thirds of the time, landing in turn left hind, left fore, right hind, right fore; the body bobbing once a step and the head nodding with it.","duty":0.66,"fold":{"fl":55,"fr":55,"hl":30,"hr":30},"frameMs":90,"frames":12,"lift":{"fl":3,"fr":3,"hl":2.5,"hr":2.5},"motion":[{"amplitude":0.45,"axis":"rise","joint":"root","perCycle":2,"phase":0.25},{"amplitude":3,"axis":"pitch","joint":"neck","perCycle":2,"phase":0.1},{"amplitude":6,"axis":"yaw","joint":"tail","perCycle":1}],"phases":{"fl":0.25,"fr":0.75,"hl":0,"hr":0.5},"reach":1.5,"stride":22}},"joints":[["pelvis",null,[0,28.5,-12]],["loin","pelvis",[0,29,-2]],["chest","loin",[0,29.5,9]],["neck","chest",[0,30,14]],["head","neck",[0,41.5,22]],["nose","head",[0,38,28.8]],["earL","head",[1.8,43.9,20.4]],["earR","head",[-1.8,43.9,20.4]],["tail","pelvis",[0,30.2,-19]],["tailTip","tail",[0,27.6,-21.2]],["flShoulder","chest",[3.2,24.5,11.5]],["flElbow","flShoulder",[3.2,16.5,7]],["flKnee","flElbow",[3,8.6,9.5]],["flHoof","flKnee",[3,1,9.5]],["frShoulder","chest",[-3.2,24.5,11.5]],["frElbow","frShoulder",[-3.2,16.5,7]],["frKnee","frElbow",[-3,8.6,9.5]],["frHoof","frKnee",[-3,1,9.5]],["hlHip","pelvis",[3.4,25,-12]],["hlStifle","hlHip",[3.6,17,-8]],["hlHock","hlStifle",[3.2,10,-14.5]],["hlHoof","hlHock",[3,1,-13.5]],["hrHip","pelvis",[-3.4,25,-12]],["hrStifle","hrHip",[-3.6,17,-8]],["hrHock","hrStifle",[-3.2,10,-14.5]],["hrHoof","hrHock",[-3,1,-13.5]]],"legs":{"fl":{"joints":["flShoulder","flElbow","flKnee","flHoof"]},"fr":{"joints":["frShoulder","frElbow","frKnee","frHoof"]},"hl":{"joints":["hlHip","hlStifle","hlHock","hlHoof"]},"hr":{"joints":["hrHip","hrStifle","hrHock","hrHoof"]}},"points":{"hands":["flHoof","frHoof"],"head":"head"},"raster":{"pitch":20},"sideTurn":10,"style":"realist"}},"version":1},"emberStyles":{"about":"How a humanoid is drawn, apart from what it is (its build) and what it wears: the raster\'s settings over the engine\'s own (raster.ts DEFAULT_RASTER, merged object by object), the skin set its skins are drawn in (palettes.json skins), the muscle marks it paints (marks.json markSets; none unless named), the eye style for a look that names none, and the clips it plays its own way (`natural`: clips.ts NATURAL_CLIPS) over the shared ones.","default":"lpc","styles":{"lpc":{"about":"Fitted to sit beside LPC art: its raster, its sampled skins, and the muscle marks painted on the LPC-fitted body.","marks":"lpc-male","raster":{},"skins":"lpc"},"realist":{"about":"Ember\'s own, for bodies at real human proportions: picked skins with cool shadows and a plum outline; chest, waist and hips one body (no seam where one swells past the next, creaseDepth); seams only where a limb segment clearly overlaps the next, not at every knee (jointLine); one key light from above-left cut into steps at fixed darkness -- a clean terminator down the whole body rather than LPC\'s share of every step per region and its rim of shade inside every outline; no LPC marks (they are calibrated to the LPC body and would land in the wrong places on any other). A real body walks and runs like one: LPC\'s gait, scaled to its long legs, shuffles.","clips":"natural","eyes":"dot","raster":{"creaseDepth":3,"jointLine":2.5,"outline":"dark","shading":{"facing":0.1,"light":1,"rim":0,"thresholds":[0.04,0.24,0.55]}},"skins":"painted"}},"version":1},"ids":{"aliases":{"colors":{},"items":{"stairs-down":"stairs","stairs-up":"stairs"},"races":{}},"retired":{"colors":{},"items":{"mossy-ruin":"Deleted in Sprite Lab with its wall material \\"Mossy Ruin Wall\\"; saved ones are set aside.","sickle":"Removed from the item tables before the content migration; saved sickles are set aside, not converted.","wall-ossuary":"Deleted in Sprite Lab with its wall material \\"Ossuary Wall\\"; saved ones are set aside."},"races":{}}},"items":[{"class":"armor","id":"armor-leather","metadata":[{"class":"armor","color":"brown","spriteId":null,"type":"armor-leather"}],"protection":0.1,"subClass":"armor","trade":{"itemType":"shard-metal","quantity":60},"weight":0.1},{"class":"armor","id":"armor-legion","metadata":[{"class":"armor","color":"brown","spriteId":null,"type":"armor-legion"}],"protection":0.2,"subClass":"armor","trade":{"itemType":"shard-metal","quantity":240},"weight":0.2},{"class":"armor","id":"armor-plate","protection":0.3,"subClass":"armor","trade":{"itemType":"shard-metal","quantity":360},"weight":0.3},{"characteristics":{"isAmmo":true,"stackable":true,"unsellable":true},"class":"resource","id":"arrow","metadata":[{"class":"resource","color":"brown","spriteId":null,"type":"arrow"}],"subClass":"ammo","trade":{"itemType":"shard-metal","quantity":0.1}},{"class":"weapon","id":"axe","subClass":"weapon","weight":0.08},{"class":"bauldron","id":"bauldron","metadata":[{"class":"bauldron","color":"brown","spriteId":null,"type":"bauldron"}],"protection":0.05,"subClass":"bauldron","weight":0.05},{"class":"shirt","id":"blouse","protection":0.01,"subClass":"shirt"},{"class":"shirt","id":"blouse_longsleeve","protection":0.01,"subClass":"shirt"},{"class":"shoes","id":"boots","protection":0.01,"subClass":"shoes"},{"class":"weapon","id":"bow","subClass":"weapon","weight":0.05},{"characteristics":{"placementAction":"use","placementRange":1,"useHasWorldEffect":true,"useable":true},"class":"structure","id":"campfire","metadata":[{"class":"structure","color":"na","spriteId":null,"type":"campfire"}],"subClass":"structure"},{"class":"cape","id":"cape-solid","subClass":"cape"},{"class":"cape","id":"cape-tattered","subClass":"cape"},{"class":"cape","id":"cape-trimmed","subClass":"cape"},{"characteristics":{"stackable":true},"class":"key","id":"castlekey","metadata":[{"class":"key","color":"gold","spriteId":null,"type":"castlekey"}],"subClass":"key"},{"characteristics":{"buildType":"entity","buildable":true,"exclusiveReadiness":true,"placementAction":"build","placementRange":1,"stackable":false,"useHasWorldEffect":true},"class":"structure","id":"chest-wood","metadata":[{"class":"structure","color":"na","spriteId":"container:140","type":"chest-wood"}],"sprite":"container:140","subClass":"chest"},{"class":"resource","id":"coal","metadata":[{"class":"resource","color":"na","spriteId":"ore:161","type":"coal"}],"sprite":"ore:161","subClass":"ore","trade":{"itemType":"shard-metal","quantity":3}},{"class":"resource","id":"copper","metadata":[{"class":"resource","color":"na","spriteId":"ore:180","type":"copper"}],"sprite":"ore:180","subClass":"ore","trade":{"itemType":"shard-metal","quantity":9}},{"class":"shirt","id":"corset","protection":0.01,"subClass":"shirt"},{"characteristics":{"unbuyable":true},"class":"weapon","id":"crossbow","subClass":"weapon"},{"class":"weapon","id":"dagger","metadata":[{"class":"weapon","color":"brown","spriteId":null,"type":"dagger"},{"class":"weapon","color":"metal","spriteId":null,"type":"dagger"}],"subClass":"weapon","trade":{"itemType":"shard-metal","quantity":10}},{"characteristics":{"buildType":"entity","buildable":true,"exclusiveReadiness":true,"stackable":false,"useHasWorldEffect":true},"class":"structure","id":"door-wood","metadata":[{"class":"structure","color":"na","spriteId":"fence_medieval:478","type":"door-wood"}],"sprite":"fence_medieval:478","subClass":"door"},{"characteristics":{"primaryUseable":true,"unbuyable":true,"useHasWorldEffect":true,"useable":true},"class":"resource","id":"drumstick","metadata":[{"class":"resource","color":"brown","spriteId":null,"type":"drumstick"}],"subClass":"drumstick","trade":{"itemType":"shard-metal","quantity":10}},{"characteristics":{"unbuyable":true,"unsellable":true},"class":"resource","id":"feather","metadata":[{"class":"resource","color":"na","spriteId":"ore:72","type":"feather"}],"sprite":"ore:72","subClass":"craftResource","trade":{"itemType":"shard-metal","quantity":10}},{"characteristics":{"unbuyable":true},"class":"weapon","id":"flail","subClass":"weapon"},{"characteristics":{"buildType":"floor","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"floor-cobble","metadata":[{"class":"structure","color":"na","spriteId":"floors:225","type":"floor-cobble"}],"sprite":"floors:225","subClass":"floor"},{"characteristics":{"buildType":"floor","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"floor-stone","metadata":[{"class":"structure","color":"na","spriteId":"floors:129","type":"floor-stone"}],"sprite":"floors:129","subClass":"floor"},{"characteristics":{"buildType":"floor","buildable":true,"campfireFuel":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"floor-wood","metadata":[{"class":"structure","color":"na","spriteId":"floors:33","type":"floor-wood"}],"sprite":"floors:33","subClass":"floor"},{"characteristics":{"unbuyable":true,"unsellable":true},"class":"resource","id":"flower-single-blue","metadata":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:104","type":"flower-single-blue"}],"sprite":"lpc-flowers-plants-fungi-wood:104","subClass":"flower"},{"characteristics":{"unbuyable":true,"unsellable":true},"class":"resource","id":"flower-single-purple","metadata":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:103","type":"flower-single-purple"}],"sprite":"lpc-flowers-plants-fungi-wood:103","subClass":"flower"},{"characteristics":{"unbuyable":true,"unsellable":true},"class":"resource","id":"flower-single-red","metadata":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:105","type":"flower-single-red"}],"sprite":"lpc-flowers-plants-fungi-wood:105","subClass":"flower"},{"characteristics":{"unbuyable":true,"unsellable":true},"class":"resource","id":"flower-single-yellow","metadata":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:106","type":"flower-single-yellow"}],"sprite":"lpc-flowers-plants-fungi-wood:106","subClass":"flower"},{"class":"resource","id":"gold","metadata":[{"class":"resource","color":"na","spriteId":"ore:182","type":"gold"}],"sprite":"ore:182","subClass":"ore","trade":{"itemType":"shard-metal","quantity":15}},{"characteristics":{"unbuyable":true},"class":"weapon","id":"halberd","subClass":"weapon"},{"characteristics":{"unbuyable":true},"class":"resource","id":"hide","metadata":[{"class":"resource","color":"brown","spriteId":null,"type":"hide"}],"subClass":"hide","trade":{"itemType":"shard-metal","quantity":2}},{"class":"resource","id":"iron","metadata":[{"class":"resource","color":"na","spriteId":"ore:179","type":"iron"}],"sprite":"ore:179","subClass":"ore","trade":{"itemType":"shard-metal","quantity":6}},{"class":"pants","id":"legion","metadata":[{"class":"pants","color":"brown","spriteId":null,"type":"legion"}],"protection":0.1,"subClass":"pants","weight":0.1},{"class":"shirt","id":"longsleeve","protection":0.01,"subClass":"shirt"},{"class":"shirt","id":"longsleeve_laced","protection":0.01,"subClass":"shirt"},{"characteristics":{"unbuyable":true},"class":"weapon","id":"longsword","subClass":"weapon"},{"characteristics":{"unbuyable":true},"class":"weapon","id":"mace","subClass":"weapon"},{"class":"resource","id":"metal-bar-copper","metadata":[{"class":"resource","color":"na","spriteId":"ore:180","type":"metal-bar-copper"}],"sprite":"ore:180","subClass":"metalBar","trade":{"itemType":"shard-metal","quantity":45}},{"class":"resource","id":"metal-bar-gold","metadata":[{"class":"resource","color":"na","spriteId":"ore:182","type":"metal-bar-gold"}],"sprite":"ore:182","subClass":"metalBar","trade":{"itemType":"shard-metal","quantity":80}},{"class":"resource","id":"metal-bar-iron","metadata":[{"class":"resource","color":"na","spriteId":"ore:179","type":"metal-bar-iron"}],"sprite":"ore:179","subClass":"metalBar","trade":{"itemType":"shard-metal","quantity":30}},{"class":"resource","id":"metal-bar-silver","metadata":[{"class":"resource","color":"na","spriteId":"ore:181","type":"metal-bar-silver"}],"sprite":"ore:181","subClass":"metalBar","trade":{"itemType":"shard-metal","quantity":60}},{"characteristics":{"unbuyable":true,"useHasWorldEffect":true,"useable":true},"class":"resource","id":"mushroom-purple","metadata":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:353","type":"mushroom-purple"}],"sprite":"lpc-flowers-plants-fungi-wood:353","subClass":"mushroom"},{"characteristics":{"unbuyable":true,"useHasWorldEffect":true,"useable":true},"class":"resource","id":"mushroom-red","metadata":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:355","type":"mushroom-red"}],"sprite":"lpc-flowers-plants-fungi-wood:355","subClass":"mushroom"},{"characteristics":{"unbuyable":true,"useHasWorldEffect":true,"useable":true},"class":"resource","id":"mushroom-yellow","metadata":[{"class":"resource","color":"na","spriteId":"lpc-flowers-plants-fungi-wood:354","type":"mushroom-yellow"}],"sprite":"lpc-flowers-plants-fungi-wood:354","subClass":"mushroom"},{"characteristics":{"hasDurability":false},"class":"weapon","id":"none","subClass":"weapon"},{"class":"pants","id":"pantaloons","protection":0.01,"subClass":"pants"},{"class":"pants","id":"pants","subClass":"pants"},{"class":"pants","id":"pants-armor","protection":0.1,"subClass":"pants","weight":0.1},{"class":"resource","id":"planks","metadata":[{"class":"resource","color":"na","spriteId":"ore:25","type":"planks"}],"sprite":"ore:25","subClass":"craftResource"},{"characteristics":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"railing-wood","metadata":[{"class":"structure","color":"na","spriteId":"fence_medieval:1","type":"railing-wood"}],"sprite":"fence_medieval:1","subClass":"wall"},{"characteristics":{"unbuyable":true},"class":"weapon","id":"rapier","subClass":"weapon"},{"characteristics":{"buildType":"roof","buildable":true,"campfireFuel":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"roof-wood","metadata":[{"class":"structure","color":"na","spriteId":"authored-terrain:807","type":"roof-wood"}],"sprite":"authored-terrain:807","subClass":"roof"},{"characteristics":{"unbuyable":true},"class":"resource","id":"rope","metadata":[{"class":"resource","color":"na","spriteId":"ore:88","type":"rope"}],"sprite":"ore:88","subClass":"craftResource"},{"characteristics":{"unbuyable":true},"class":"weapon","id":"saber","subClass":"weapon"},{"class":"shoes","id":"sandals","protection":0.01,"subClass":"shoes"},{"class":"shirt","id":"scoop_shirt","protection":0.01,"subClass":"shirt"},{"characteristics":{"unbuyable":true},"class":"weapon","id":"scythe","subClass":"weapon"},{"characteristics":{"placementAction":"use","placementRange":1,"unbuyable":true,"unsellable":true,"useHasWorldEffect":true,"useable":true},"class":"resource","id":"seed","metadata":[{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"}],"sprite":"seed-green.png","subClass":"seed"},{"class":"resource","id":"shard-metal","metadata":[{"class":"resource","color":"gray","type":"shard-metal"}],"subClass":"shard"},{"class":"shield","id":"shield-crusader","metadata":[{"class":"shield","color":"white","spriteId":null,"type":"shield-crusader"}],"protection":0.2,"subClass":"shield","trade":{"itemType":"shard-metal","quantity":120},"weight":0.2},{"class":"shield","id":"shield-kite","metadata":[{"class":"shield","color":"white","spriteId":null,"type":"shield-kite"}],"protection":0.2,"subClass":"shield","trade":{"itemType":"shard-metal","quantity":120},"weight":0.2},{"class":"shield","id":"shield-kite_blue","protection":0.2,"subClass":"shield","trade":{"itemType":"shard-metal","quantity":120},"weight":0.2},{"class":"shield","id":"shield-kite_gray","protection":0.2,"subClass":"shield","trade":{"itemType":"shard-metal","quantity":120},"weight":0.2},{"class":"shield","id":"shield-kite_green","protection":0.2,"subClass":"shield","trade":{"itemType":"shard-metal","quantity":120},"weight":0.2},{"class":"shield","id":"shield-kite_red","protection":0.2,"subClass":"shield","trade":{"itemType":"shard-metal","quantity":120},"weight":0.2},{"class":"shield","id":"shield-round","metadata":[{"class":"shield","color":"brown","spriteId":null,"type":"shield-round"}],"protection":0.1,"subClass":"shield","trade":{"itemType":"shard-metal","quantity":120},"weight":0.1},{"class":"shield","id":"shield-spartan","protection":0.15,"subClass":"shield","weight":0.15},{"class":"shoes","id":"shoes","protection":0.01,"subClass":"shoes"},{"class":"shoes","id":"shoes-armor","protection":0.1,"subClass":"shoes","weight":0.1},{"class":"resource","id":"silver","metadata":[{"class":"resource","color":"na","spriteId":"ore:181","type":"silver"}],"sprite":"ore:181","subClass":"ore","trade":{"itemType":"shard-metal","quantity":12}},{"class":"pants","id":"skirts","protection":0.01,"subClass":"pants"},{"class":"shirt","id":"sleeveless","protection":0.01,"subClass":"shirt"},{"class":"shirt","id":"sleeveless_laced","protection":0.01,"subClass":"shirt"},{"class":"shirt","id":"sleeveless_striped","protection":0.01,"subClass":"shirt"},{"class":"shoes","id":"slippers","protection":0.01,"subClass":"shoes","weight":0.01},{"characteristics":{"useHasWorldEffect":true,"useable":true},"class":"structure","id":"snare-rabbit","metadata":[{"class":"structure","color":"na","spriteId":"snare-rabbit.png","type":"snare-rabbit"}],"sprite":"snare-rabbit.png","subClass":"structure"},{"class":"weapon","id":"spear","subClass":"weapon","trade":{"itemType":"shard-metal","quantity":20},"weight":0.05},{"characteristics":{"unbuyable":true},"class":"weapon","id":"staff","subClass":"weapon","weight":0.05},{"class":"resource","id":"stick","metadata":[{"class":"resource","color":"na","spriteId":"ore:26","type":"stick"}],"sprite":"ore:26","subClass":"craftResource"},{"characteristics":{"buildable":true,"exclusiveReadiness":true,"stackable":false,"useHasWorldEffect":true},"class":"structure","id":"stool-small","metadata":[{"class":"structure","color":"na","spriteId":"furniture-blonde-wood:126","type":"stool-small"}],"sprite":"furniture-blonde-wood:126","subClass":"structure"},{"characteristics":{"unbuyable":true,"unsellable":true},"class":"resource","id":"straw","metadata":[{"class":"resource","color":"na","noGlint":true,"spriteId":"item-art-b9ef00e25a4177065abd:1","type":"straw"}],"sprite":"item-art-b9ef00e25a4177065abd:1","subClass":"straw"},{"characteristics":{"buildable":true,"exclusiveReadiness":true,"stackable":false,"useHasWorldEffect":true,"useable":false},"class":"structure","id":"table-large-rough","metadata":[{"class":"structure","color":"na","spriteId":"furniture-blonde-wood:458","type":"table-large-rough"}],"sprite":"furniture-blonde-wood:458","subClass":"structure"},{"characteristics":{"buildable":true,"exclusiveReadiness":true,"stackable":false,"useHasWorldEffect":true,"useable":false},"class":"structure","id":"table-mid-round","metadata":[{"class":"structure","color":"na","spriteId":"furniture-blonde-wood:124","type":"table-mid-round"}],"sprite":"furniture-blonde-wood:124","subClass":"structure"},{"class":"shirt","id":"tanktop","protection":0.01,"subClass":"shirt"},{"characteristics":{"useable":true},"class":"resource","id":"torch","metadata":[{"class":"resource","color":"na","spriteId":null,"type":"torch"}],"subClass":"torch"},{"class":"shirt","id":"tunic","protection":0.01,"subClass":"shirt"},{"characteristics":{"buildType":"wall","buildable":true,"campfireFuel":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"wall-wood","metadata":[{"class":"structure","color":"na","spriteId":"authored-terrain:643","type":"wall-wood"}],"sprite":"authored-terrain:643","subClass":"wall"},{"characteristics":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"wall2-wood","metadata":[{"class":"structure","color":"na","spriteId":"walls2:43","type":"wall2-wood"}],"sprite":"walls2:43","subClass":"wall"},{"characteristics":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"wall-stone","metadata":[{"class":"structure","color":"na","spriteId":"walls2:53","type":"wall-stone"}],"sprite":"walls2:53","subClass":"wall"},{"characteristics":{"unbuyable":true},"class":"weapon","id":"waraxe","subClass":"weapon"},{"characteristics":{"unbuyable":true},"class":"weapon","id":"warhammer","subClass":"weapon","weight":0.1},{"class":"weapon","id":"web","metadata":[{"class":"weapon","color":"white","type":"web"}],"subClass":"weapon"},{"class":"resource","id":"webAmmo","metadata":[{"class":"resource","color":"white","type":"webAmmo"}],"subClass":"ammo"},{"characteristics":{"campfireFuel":true,"exclusiveReadiness":true,"primaryUseable":true,"unbuyable":true},"class":"resource","id":"wood","metadata":[{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"}],"subClass":"wood"},{"characteristics":{"isAmmo":true,"stackable":true,"unbuyable":true,"unsellable":true},"class":"resource","id":"ember-charge","metadata":[{"class":"resource","color":"na","spriteId":"ore:180","type":"ember-charge"}],"sprite":"ore:180","subClass":"ammo"},{"characteristics":{"stackable":true,"unbuyable":true,"unsellable":true},"class":"resource","id":"spider-silk","metadata":[{"class":"resource","color":"na","spriteId":"ore:88","type":"spider-silk"}],"sprite":"ore:88","subClass":"craftResource"},{"characteristics":{"buildable":true,"readyable":true,"unbuyable":true},"class":"structure","id":"barrel1","metadata":[{"class":"structure","color":"na","spriteId":"container:60","type":"barrel1"}],"sprite":"container:60","subClass":"structure"},{"characteristics":{"buildable":true,"readyable":true,"unbuyable":true},"class":"structure","id":"stackedBags","metadata":[{"class":"structure","color":"na","spriteId":"container:449","type":"stackedBags"}],"sprite":"container:449","subClass":"structure"},{"characteristics":{"buildable":true,"readyable":true,"unbuyable":true,"useable":false},"class":"structure","id":"stool1","metadata":[{"class":"structure","color":"na","spriteId":"furniture-blond-wood:128","type":"stool1"}],"sprite":"furniture-blond-wood:128","subClass":"structure"},{"characteristics":{"buildable":true,"readyable":true,"unbuyable":true,"useable":false},"class":"structure","id":"table-mid-rough","metadata":[{"class":"structure","color":"na","spriteId":"furniture-blonde-wood:141","type":"table-mid-rough"}],"sprite":"furniture-blonde-wood:141","subClass":"structure"},{"characteristics":{"buildable":true,"readyable":true,"unbuyable":true,"useable":false},"class":"structure","id":"strawBed","metadata":[{"class":"structure","color":"na","spriteId":"build_atlas:684","type":"strawBed"}],"sprite":"build_atlas:684","subClass":"structure"},{"characteristics":{"buildable":true,"readyable":true,"unbuyable":true,"useable":false},"class":"structure","id":"strawBedSmall","metadata":[{"class":"structure","color":"na","spriteId":"build_atlas:684","type":"strawBedSmall"}],"sprite":"build_atlas:684","subClass":"structure"},{"class":"weapon","id":"iron-pickaxe","metadata":[{"class":"weapon","color":"na","spriteId":"item-art-b1d5a86cbcd21ed656d3:1","type":"iron-pickaxe"}],"sprite":"item-art-b1d5a86cbcd21ed656d3:1","subClass":"weapon","weight":0.08},{"characteristics":{"buildType":"entity","buildable":true,"deactivateAfterPlacement":true,"exclusiveReadiness":true,"placementAction":"build","stackable":false,"useHasWorldEffect":true},"class":"structure","id":"stairs","metadata":[{"class":"structure","color":"na","spriteId":"stairs-icon:1","type":"stairs"}],"sprite":"stairs-icon:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":false,"stackable":false},"class":"structure","id":"floor-opening","metadata":[{"class":"structure","color":"na","spriteId":"authored-terrain:3","type":"floor-opening"}],"sprite":"authored-terrain:3","subClass":"structure"},{"characteristics":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"timber-frame-wall","metadata":[{"class":"structure","color":"na","spriteId":"authored-terrain:50","type":"timber-frame-wall"}],"sprite":"authored-terrain:50","subClass":"wall"},{"characteristics":{"buildType":"roof","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"thatch-roof","metadata":[{"class":"structure","color":"na","spriteId":"authored-terrain:378","type":"thatch-roof"}],"sprite":"authored-terrain:378","subClass":"roof"},{"characteristics":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"ornament":"window","stackable":true,"useHasWorldEffect":true},"class":"structure","id":"window-frame","metadata":[{"class":"structure","color":"na","spriteId":"authored-terrain:419","type":"window-frame"}],"sprite":"authored-terrain:419","subClass":"window"},{"characteristics":{"buildType":"roof","buildable":true,"exclusiveReadiness":true,"ornament":"chimney","stackable":true,"useHasWorldEffect":true},"class":"structure","id":"chimney-stack","metadata":[{"class":"structure","color":"na","spriteId":"authored-terrain:421","type":"chimney-stack"}],"sprite":"authored-terrain:421","subClass":"chimney"},{"characteristics":{"buildType":"roof","buildable":true,"exclusiveReadiness":true,"ornament":"dormer","stackable":true,"useHasWorldEffect":true},"class":"structure","id":"dormer-window","metadata":[{"class":"structure","color":"na","spriteId":"authored-terrain:424","type":"dormer-window"}],"sprite":"authored-terrain:424","subClass":"dormer"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"grove-oak-a","metadata":[{"class":"structure","color":"na","spriteId":"item-art-887e0636d4bbe2a4f448:1","type":"grove-oak-a"}],"sprite":"item-art-887e0636d4bbe2a4f448:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"grove-oak-b","metadata":[{"class":"structure","color":"na","spriteId":"item-art-f728e0bbaefbd1982b2d:1","type":"grove-oak-b"}],"sprite":"item-art-f728e0bbaefbd1982b2d:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"grove-spruce-a","metadata":[{"class":"structure","color":"na","spriteId":"item-art-35c925e4db81912bfe38:1","type":"grove-spruce-a"}],"sprite":"item-art-35c925e4db81912bfe38:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"grove-spruce-b","metadata":[{"class":"structure","color":"na","spriteId":"item-art-99ea85dcdc93fac8db18:1","type":"grove-spruce-b"}],"sprite":"item-art-99ea85dcdc93fac8db18:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"grove-round-a","metadata":[{"class":"structure","color":"na","spriteId":"item-art-bb4afa7ce4e3c1ba55ba:1","type":"grove-round-a"}],"sprite":"item-art-bb4afa7ce4e3c1ba55ba:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"grove-round-b","metadata":[{"class":"structure","color":"na","spriteId":"item-art-e46e4dec4aea45bf9d8e:1","type":"grove-round-b"}],"sprite":"item-art-e46e4dec4aea45bf9d8e:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"grove-low-a","metadata":[{"class":"structure","color":"na","spriteId":"item-art-32902d50537ebad17e79:1","type":"grove-low-a"}],"sprite":"item-art-32902d50537ebad17e79:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"grove-low-b","metadata":[{"class":"structure","color":"na","spriteId":"item-art-5902c8b486e89c8f8e57:1","type":"grove-low-b"}],"sprite":"item-art-5902c8b486e89c8f8e57:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"meadow-grass-a","metadata":[{"class":"structure","color":"na","spriteId":"item-art-ebdd046fea0f3ab21669:1","type":"meadow-grass-a"}],"sprite":"item-art-ebdd046fea0f3ab21669:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"meadow-grass-b","metadata":[{"class":"structure","color":"na","spriteId":"item-art-4d6c318ef966e097227a:1","type":"meadow-grass-b"}],"sprite":"item-art-4d6c318ef966e097227a:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"meadow-grass-c","metadata":[{"class":"structure","color":"na","spriteId":"item-art-721c3f8a8d4621a46f90:1","type":"meadow-grass-c"}],"sprite":"item-art-721c3f8a8d4621a46f90:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"meadow-grass-d","metadata":[{"class":"structure","color":"na","spriteId":"item-art-7fc02d2406eaa57e3be0:1","type":"meadow-grass-d"}],"sprite":"item-art-7fc02d2406eaa57e3be0:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"meadow-grass-e","metadata":[{"class":"structure","color":"na","spriteId":"item-art-a7225776548a58ab4e04:1","type":"meadow-grass-e"}],"sprite":"item-art-a7225776548a58ab4e04:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"meadow-grass-f","metadata":[{"class":"structure","color":"na","spriteId":"item-art-d9ecaed5ff4485611809:1","type":"meadow-grass-f"}],"sprite":"item-art-d9ecaed5ff4485611809:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":true,"placementAction":"build","placementRange":1,"stackable":true},"class":"structure","id":"meadow-sprout","metadata":[{"class":"structure","color":"na","spriteId":"item-art-af19df691fc7aa944194:1","type":"meadow-sprout"}],"sprite":"item-art-af19df691fc7aa944194:1","subClass":"structure"},{"characteristics":{"buildType":"entity","buildable":false,"stackable":true},"class":"structure","id":"hatch-wood","metadata":[{"class":"structure","color":"na","spriteId":"hatch-wood:1","type":"hatch-wood"}],"sprite":"hatch-wood:1","subClass":"structure"},{"characteristics":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"castle-footing","metadata":[{"class":"structure","color":"na","spriteId":"authored-terrain:824","type":"castle-footing"}],"sprite":"authored-terrain:824","subClass":"wall"},{"characteristics":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"castle-wall","metadata":[{"class":"structure","color":"na","spriteId":"authored-terrain:872","type":"castle-wall"}],"sprite":"authored-terrain:872","subClass":"wall"},{"characteristics":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"castle-merlons","metadata":[{"class":"structure","color":"na","spriteId":"authored-terrain:924","type":"castle-merlons"}],"sprite":"authored-terrain:924","subClass":"wall"},{"characteristics":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"ornament":"arrow-slit","stackable":true,"useHasWorldEffect":true},"class":"structure","id":"arrow-slit","metadata":[{"class":"structure","color":"na","spriteId":"authored-terrain:899","type":"arrow-slit"}],"sprite":"authored-terrain:899","subClass":"window"},{"characteristics":{"buildType":"wall","buildable":true,"exclusiveReadiness":true,"stackable":true,"useHasWorldEffect":true},"class":"structure","id":"tower-render","metadata":[{"class":"structure","color":"na","spriteId":"authored-terrain:927","type":"tower-render"}],"sprite":"authored-terrain:927","subClass":"wall"}],"maps":{"collisionOverrides":{},"generatorInputs":[{"file":"maps/sources/housetemplate.tmj","id":"house-template"}],"historical":[{"file":"maps/archive/exports/r1.json","note":"Earlier JSON export superseded by the room in maps/rooms; never loaded."},{"file":"maps/archive/exports/r2.json","note":"Earlier JSON export superseded by the room in maps/rooms; never loaded."},{"file":"maps/archive/exports/r4.json","note":"Earlier JSON export superseded by the room in maps/rooms; never loaded."},{"file":"maps/archive/exports/room1.json","note":"Earlier JSON export superseded by the room in maps/rooms; never loaded."},{"file":"maps/archive/exports/room2.json","note":"Earlier JSON export superseded by the room in maps/rooms; never loaded."},{"file":"maps/archive/exports/room3.json","note":"Earlier JSON export superseded by the room in maps/rooms; never loaded."},{"file":"maps/archive/exports/room4.json","note":"Earlier JSON export superseded by the room in maps/rooms; never loaded."},{"file":"maps/archive/exports/wave1.json","note":"Earlier JSON export superseded by the room in maps/rooms; never loaded."},{"file":"maps/archive/exports/wave2.json","note":"Earlier JSON export superseded by the room in maps/rooms; never loaded."},{"file":"maps/archive/map.png","note":"Retired world bitmap; no reader."},{"file":"maps/archive/map2.png","note":"Retired world bitmap; no reader."},{"file":"maps/archive/rooms/room-1-3.tmj","note":"Older copy of a generated grid room; never loaded."},{"file":"maps/archive/rooms/room-7-5.tmj","note":"Older copy of a generated grid room; never loaded."},{"file":"maps/archive/sources/atlas.tsx","note":"Archived Tiled source; its tileset and exports are historical."},{"file":"maps/archive/sources/housetemplate2.tmj","note":"Archived Tiled source; its tileset and exports are historical."},{"file":"maps/archive/sources/room1.tmx","note":"Archived Tiled source; its tileset and exports are historical."},{"file":"maps/archive/sources/room2.tmx","note":"Archived Tiled source; its tileset and exports are historical."},{"file":"maps/archive/sources/room3.tmx","note":"Archived Tiled source; its tileset and exports are historical."},{"file":"maps/archive/sources/room4.tmx","note":"Archived Tiled source; its tileset and exports are historical."},{"file":"maps/archive/wall-test.json","note":"Retired room-definition experiment; not a Tiled map and never loaded."},{"file":"maps/sources/blank.tmx","note":"Tiled source with no shipped room (roomId lab2)."},{"file":"maps/sources/openworld.tmx","note":"Tiled source with no shipped room (roomId wilderness)."}],"rooms":[{"file":"maps/rooms/cave-0-0.tmj","id":"cave-0-0"},{"file":"maps/rooms/dome1.tmj","id":"dome1","provenance":"maps/sources/dome1.tmx"},{"file":"maps/rooms/dome2-lobby.tmj","id":"dome2-lobby","provenance":"maps/sources/dome2-lobby.tmx"},{"file":"maps/rooms/dome2.tmj","id":"dome2","provenance":"maps/sources/dome2.tmx"},{"file":"maps/rooms/dungeon-0-0.tmj","id":"dungeon-0-0"},{"file":"maps/rooms/experiment.tmj","id":"experiment","provenance":"maps/sources/experiment.tmx"},{"file":"maps/rooms/house-0-0.tmj","id":"house-0-0"},{"file":"maps/rooms/house-0-1.tmj","id":"house-0-1"},{"file":"maps/rooms/lab.tmj","id":"lab","provenance":"maps/sources/lab.tmx"},{"file":"maps/rooms/lab1.tmj","id":"lab1","provenance":"maps/sources/lab1.tmx"},{"file":"maps/rooms/lab2.tmj","id":"lab2","provenance":"maps/sources/lab2.tmx"},{"file":"maps/rooms/lab3.tmj","id":"lab3","provenance":"maps/sources/lab3.tmx"},{"file":"maps/rooms/lpc.tmj","id":"lpc","provenance":"maps/sources/lpc.tmx"},{"file":"maps/rooms/playground.tmj","id":"playground"},{"file":"maps/rooms/playground2.tmj","id":"playground2"},{"file":"maps/rooms/r1.tmj","id":"battleRoyale","provenance":"maps/sources/r1.tmx"},{"file":"maps/rooms/r2.tmj","id":"zombies","provenance":"maps/sources/r2.tmx"},{"file":"maps/rooms/r3.tmj","id":"lobby","provenance":"maps/sources/r3.tmx"},{"file":"maps/rooms/r4.tmj","id":"captureTheFlag","provenance":"maps/sources/r4.tmx"},{"file":"maps/rooms/room-0-0.tmj","id":"room-0-0"},{"file":"maps/rooms/room-0-1.tmj","id":"room-0-1"},{"file":"maps/rooms/room-0-10.tmj","id":"room-0-10"},{"file":"maps/rooms/room-0-11.tmj","id":"room-0-11"},{"file":"maps/rooms/room-0-12.tmj","id":"room-0-12"},{"file":"maps/rooms/room-0-13.tmj","id":"room-0-13"},{"file":"maps/rooms/room-0-14.tmj","id":"room-0-14"},{"file":"maps/rooms/room-0-15.tmj","id":"room-0-15"},{"file":"maps/rooms/room-0-2.tmj","id":"room-0-2"},{"file":"maps/rooms/room-0-3.tmj","id":"room-0-3"},{"file":"maps/rooms/room-0-4.tmj","id":"room-0-4"},{"file":"maps/rooms/room-0-5.tmj","id":"room-0-5"},{"file":"maps/rooms/room-0-6.tmj","id":"room-0-6"},{"file":"maps/rooms/room-0-7.tmj","id":"room-0-7"},{"file":"maps/rooms/room-0-8.tmj","id":"room-0-8"},{"file":"maps/rooms/room-0-9.tmj","id":"room-0-9"},{"file":"maps/rooms/room-1-0.tmj","id":"room-1-0"},{"file":"maps/rooms/room-1-1.tmj","id":"room-1-1"},{"file":"maps/rooms/room-1-10.tmj","id":"room-1-10"},{"file":"maps/rooms/room-1-11.tmj","id":"room-1-11"},{"file":"maps/rooms/room-1-12.tmj","id":"room-1-12"},{"file":"maps/rooms/room-1-13.tmj","id":"room-1-13"},{"file":"maps/rooms/room-1-14.tmj","id":"room-1-14"},{"file":"maps/rooms/room-1-15.tmj","id":"room-1-15"},{"file":"maps/rooms/room-1-2.tmj","id":"room-1-2"},{"file":"maps/rooms/room-1-3.tmj","id":"room-1-3"},{"file":"maps/rooms/room-1-4.tmj","id":"room-1-4"},{"file":"maps/rooms/room-1-5.tmj","id":"room-1-5"},{"file":"maps/rooms/room-1-6.tmj","id":"room-1-6"},{"file":"maps/rooms/room-1-7.tmj","id":"room-1-7"},{"file":"maps/rooms/room-1-8.tmj","id":"room-1-8"},{"file":"maps/rooms/room-1-9.tmj","id":"room-1-9"},{"file":"maps/rooms/room-10-0.tmj","id":"room-10-0"},{"file":"maps/rooms/room-10-1.tmj","id":"room-10-1"},{"file":"maps/rooms/room-10-10.tmj","id":"room-10-10"},{"file":"maps/rooms/room-10-11.tmj","id":"room-10-11"},{"file":"maps/rooms/room-10-12.tmj","id":"room-10-12"},{"file":"maps/rooms/room-10-13.tmj","id":"room-10-13"},{"file":"maps/rooms/room-10-14.tmj","id":"room-10-14"},{"file":"maps/rooms/room-10-15.tmj","id":"room-10-15"},{"file":"maps/rooms/room-10-2.tmj","id":"room-10-2"},{"file":"maps/rooms/room-10-3.tmj","id":"room-10-3"},{"file":"maps/rooms/room-10-4.tmj","id":"room-10-4"},{"file":"maps/rooms/room-10-5.tmj","id":"room-10-5"},{"file":"maps/rooms/room-10-6.tmj","id":"room-10-6"},{"file":"maps/rooms/room-10-7.tmj","id":"room-10-7"},{"file":"maps/rooms/room-10-8.tmj","id":"room-10-8"},{"file":"maps/rooms/room-10-9.tmj","id":"room-10-9"},{"file":"maps/rooms/room-11-0.tmj","id":"room-11-0"},{"file":"maps/rooms/room-11-1.tmj","id":"room-11-1"},{"file":"maps/rooms/room-11-10.tmj","id":"room-11-10"},{"file":"maps/rooms/room-11-11.tmj","id":"room-11-11"},{"file":"maps/rooms/room-11-12.tmj","id":"room-11-12"},{"file":"maps/rooms/room-11-13.tmj","id":"room-11-13"},{"file":"maps/rooms/room-11-14.tmj","id":"room-11-14"},{"file":"maps/rooms/room-11-15.tmj","id":"room-11-15"},{"file":"maps/rooms/room-11-2.tmj","id":"room-11-2"},{"file":"maps/rooms/room-11-3.tmj","id":"room-11-3"},{"file":"maps/rooms/room-11-4.tmj","id":"room-11-4"},{"file":"maps/rooms/room-11-5.tmj","id":"room-11-5"},{"file":"maps/rooms/room-11-6.tmj","id":"room-11-6"},{"file":"maps/rooms/room-11-7.tmj","id":"room-11-7"},{"file":"maps/rooms/room-11-8.tmj","id":"room-11-8"},{"file":"maps/rooms/room-11-9.tmj","id":"room-11-9"},{"file":"maps/rooms/room-12-0.tmj","id":"room-12-0"},{"file":"maps/rooms/room-12-1.tmj","id":"room-12-1"},{"file":"maps/rooms/room-12-10.tmj","id":"room-12-10"},{"file":"maps/rooms/room-12-11.tmj","id":"room-12-11"},{"file":"maps/rooms/room-12-12.tmj","id":"room-12-12"},{"file":"maps/rooms/room-12-13.tmj","id":"room-12-13"},{"file":"maps/rooms/room-12-14.tmj","id":"room-12-14"},{"file":"maps/rooms/room-12-15.tmj","id":"room-12-15"},{"file":"maps/rooms/room-12-2.tmj","id":"room-12-2"},{"file":"maps/rooms/room-12-3.tmj","id":"room-12-3"},{"file":"maps/rooms/room-12-4.tmj","id":"room-12-4"},{"file":"maps/rooms/room-12-5.tmj","id":"room-12-5"},{"file":"maps/rooms/room-12-6.tmj","id":"room-12-6"},{"file":"maps/rooms/room-12-7.tmj","id":"room-12-7"},{"file":"maps/rooms/room-12-8.tmj","id":"room-12-8"},{"file":"maps/rooms/room-12-9.tmj","id":"room-12-9"},{"file":"maps/rooms/room-13-0.tmj","id":"room-13-0"},{"file":"maps/rooms/room-13-1.tmj","id":"room-13-1"},{"file":"maps/rooms/room-13-10.tmj","id":"room-13-10"},{"file":"maps/rooms/room-13-11.tmj","id":"room-13-11"},{"file":"maps/rooms/room-13-12.tmj","id":"room-13-12"},{"file":"maps/rooms/room-13-13.tmj","id":"room-13-13"},{"file":"maps/rooms/room-13-14.tmj","id":"room-13-14"},{"file":"maps/rooms/room-13-15.tmj","id":"room-13-15"},{"file":"maps/rooms/room-13-2.tmj","id":"room-13-2"},{"file":"maps/rooms/room-13-3.tmj","id":"room-13-3"},{"file":"maps/rooms/room-13-4.tmj","id":"room-13-4"},{"file":"maps/rooms/room-13-5.tmj","id":"room-13-5"},{"file":"maps/rooms/room-13-6.tmj","id":"room-13-6"},{"file":"maps/rooms/room-13-7.tmj","id":"room-13-7"},{"file":"maps/rooms/room-13-8.tmj","id":"room-13-8"},{"file":"maps/rooms/room-13-9.tmj","id":"room-13-9"},{"file":"maps/rooms/room-14-0.tmj","id":"room-14-0"},{"file":"maps/rooms/room-14-1.tmj","id":"room-14-1"},{"file":"maps/rooms/room-14-10.tmj","id":"room-14-10"},{"file":"maps/rooms/room-14-11.tmj","id":"room-14-11"},{"file":"maps/rooms/room-14-12.tmj","id":"room-14-12"},{"file":"maps/rooms/room-14-13.tmj","id":"room-14-13"},{"file":"maps/rooms/room-14-14.tmj","id":"room-14-14"},{"file":"maps/rooms/room-14-15.tmj","id":"room-14-15"},{"file":"maps/rooms/room-14-2.tmj","id":"room-14-2"},{"file":"maps/rooms/room-14-3.tmj","id":"room-14-3"},{"file":"maps/rooms/room-14-4.tmj","id":"room-14-4"},{"file":"maps/rooms/room-14-5.tmj","id":"room-14-5"},{"file":"maps/rooms/room-14-6.tmj","id":"room-14-6"},{"file":"maps/rooms/room-14-7.tmj","id":"room-14-7"},{"file":"maps/rooms/room-14-8.tmj","id":"room-14-8"},{"file":"maps/rooms/room-14-9.tmj","id":"room-14-9"},{"file":"maps/rooms/room-15-0.tmj","id":"room-15-0"},{"file":"maps/rooms/room-15-1.tmj","id":"room-15-1"},{"file":"maps/rooms/room-15-10.tmj","id":"room-15-10"},{"file":"maps/rooms/room-15-11.tmj","id":"room-15-11"},{"file":"maps/rooms/room-15-12.tmj","id":"room-15-12"},{"file":"maps/rooms/room-15-13.tmj","id":"room-15-13"},{"file":"maps/rooms/room-15-14.tmj","id":"room-15-14"},{"file":"maps/rooms/room-15-15.tmj","id":"room-15-15"},{"file":"maps/rooms/room-15-2.tmj","id":"room-15-2"},{"file":"maps/rooms/room-15-3.tmj","id":"room-15-3"},{"file":"maps/rooms/room-15-4.tmj","id":"room-15-4"},{"file":"maps/rooms/room-15-5.tmj","id":"room-15-5"},{"file":"maps/rooms/room-15-6.tmj","id":"room-15-6"},{"file":"maps/rooms/room-15-7.tmj","id":"room-15-7"},{"file":"maps/rooms/room-15-8.tmj","id":"room-15-8"},{"file":"maps/rooms/room-15-9.tmj","id":"room-15-9"},{"file":"maps/rooms/room-2-0.tmj","id":"room-2-0"},{"file":"maps/rooms/room-2-1.tmj","id":"room-2-1"},{"file":"maps/rooms/room-2-10.tmj","id":"room-2-10"},{"file":"maps/rooms/room-2-11.tmj","id":"room-2-11"},{"file":"maps/rooms/room-2-12.tmj","id":"room-2-12"},{"file":"maps/rooms/room-2-13.tmj","id":"room-2-13"},{"file":"maps/rooms/room-2-14.tmj","id":"room-2-14"},{"file":"maps/rooms/room-2-15.tmj","id":"room-2-15"},{"file":"maps/rooms/room-2-2.tmj","id":"room-2-2"},{"file":"maps/rooms/room-2-3.tmj","id":"room-2-3"},{"file":"maps/rooms/room-2-4.tmj","id":"room-2-4"},{"file":"maps/rooms/room-2-5.tmj","id":"room-2-5"},{"file":"maps/rooms/room-2-6.tmj","id":"room-2-6"},{"file":"maps/rooms/room-2-7.tmj","id":"room-2-7"},{"file":"maps/rooms/room-2-8.tmj","id":"room-2-8"},{"file":"maps/rooms/room-2-9.tmj","id":"room-2-9"},{"file":"maps/rooms/room-3-0.tmj","id":"room-3-0"},{"file":"maps/rooms/room-3-1.tmj","id":"room-3-1"},{"file":"maps/rooms/room-3-10.tmj","id":"room-3-10"},{"file":"maps/rooms/room-3-11.tmj","id":"room-3-11"},{"file":"maps/rooms/room-3-12.tmj","id":"room-3-12"},{"file":"maps/rooms/room-3-13.tmj","id":"room-3-13"},{"file":"maps/rooms/room-3-14.tmj","id":"room-3-14"},{"file":"maps/rooms/room-3-15.tmj","id":"room-3-15"},{"file":"maps/rooms/room-3-2.tmj","id":"room-3-2"},{"file":"maps/rooms/room-3-3.tmj","id":"room-3-3"},{"file":"maps/rooms/room-3-4.tmj","id":"room-3-4"},{"file":"maps/rooms/room-3-5.tmj","id":"room-3-5"},{"file":"maps/rooms/room-3-6.tmj","id":"room-3-6"},{"file":"maps/rooms/room-3-7.tmj","id":"room-3-7"},{"file":"maps/rooms/room-3-8.tmj","id":"room-3-8"},{"file":"maps/rooms/room-3-9.tmj","id":"room-3-9"},{"file":"maps/rooms/room-4-0.tmj","id":"room-4-0"},{"file":"maps/rooms/room-4-1.tmj","id":"room-4-1"},{"file":"maps/rooms/room-4-10.tmj","id":"room-4-10"},{"file":"maps/rooms/room-4-11.tmj","id":"room-4-11"},{"file":"maps/rooms/room-4-12.tmj","id":"room-4-12"},{"file":"maps/rooms/room-4-13.tmj","id":"room-4-13"},{"file":"maps/rooms/room-4-14.tmj","id":"room-4-14"},{"file":"maps/rooms/room-4-15.tmj","id":"room-4-15"},{"file":"maps/rooms/room-4-2.tmj","id":"room-4-2"},{"file":"maps/rooms/room-4-3.tmj","id":"room-4-3"},{"file":"maps/rooms/room-4-4.tmj","id":"room-4-4"},{"file":"maps/rooms/room-4-5.tmj","id":"room-4-5"},{"file":"maps/rooms/room-4-6.tmj","id":"room-4-6"},{"file":"maps/rooms/room-4-7.tmj","id":"room-4-7"},{"file":"maps/rooms/room-4-8.tmj","id":"room-4-8"},{"file":"maps/rooms/room-4-9.tmj","id":"room-4-9"},{"file":"maps/rooms/room-5-0.tmj","id":"room-5-0"},{"file":"maps/rooms/room-5-1.tmj","id":"room-5-1"},{"file":"maps/rooms/room-5-10.tmj","id":"room-5-10"},{"file":"maps/rooms/room-5-11.tmj","id":"room-5-11"},{"file":"maps/rooms/room-5-12.tmj","id":"room-5-12"},{"file":"maps/rooms/room-5-13.tmj","id":"room-5-13"},{"file":"maps/rooms/room-5-14.tmj","id":"room-5-14"},{"file":"maps/rooms/room-5-15.tmj","id":"room-5-15"},{"file":"maps/rooms/room-5-2.tmj","id":"room-5-2"},{"file":"maps/rooms/room-5-3.tmj","id":"room-5-3"},{"file":"maps/rooms/room-5-4.tmj","id":"room-5-4"},{"file":"maps/rooms/room-5-5.tmj","id":"room-5-5"},{"file":"maps/rooms/room-5-6.tmj","id":"room-5-6"},{"file":"maps/rooms/room-5-7.tmj","id":"room-5-7"},{"file":"maps/rooms/room-5-8.tmj","id":"room-5-8"},{"file":"maps/rooms/room-5-9.tmj","id":"room-5-9"},{"file":"maps/rooms/room-6-0.tmj","id":"room-6-0"},{"file":"maps/rooms/room-6-1.tmj","id":"room-6-1"},{"file":"maps/rooms/room-6-10.tmj","id":"room-6-10"},{"file":"maps/rooms/room-6-11.tmj","id":"room-6-11"},{"file":"maps/rooms/room-6-12.tmj","id":"room-6-12"},{"file":"maps/rooms/room-6-13.tmj","id":"room-6-13"},{"file":"maps/rooms/room-6-14.tmj","id":"room-6-14"},{"file":"maps/rooms/room-6-15.tmj","id":"room-6-15"},{"file":"maps/rooms/room-6-2.tmj","id":"room-6-2"},{"file":"maps/rooms/room-6-3.tmj","id":"room-6-3"},{"file":"maps/rooms/room-6-4.tmj","id":"room-6-4"},{"file":"maps/rooms/room-6-5.tmj","id":"room-6-5"},{"file":"maps/rooms/room-6-6.tmj","id":"room-6-6"},{"file":"maps/rooms/room-6-7.tmj","id":"room-6-7"},{"file":"maps/rooms/room-6-8.tmj","id":"room-6-8"},{"file":"maps/rooms/room-6-9.tmj","id":"room-6-9"},{"file":"maps/rooms/room-7-0.tmj","id":"room-7-0"},{"file":"maps/rooms/room-7-1.tmj","id":"room-7-1"},{"file":"maps/rooms/room-7-10.tmj","id":"room-7-10"},{"file":"maps/rooms/room-7-11.tmj","id":"room-7-11"},{"file":"maps/rooms/room-7-12.tmj","id":"room-7-12"},{"file":"maps/rooms/room-7-13.tmj","id":"room-7-13"},{"file":"maps/rooms/room-7-14.tmj","id":"room-7-14"},{"file":"maps/rooms/room-7-15.tmj","id":"room-7-15"},{"file":"maps/rooms/room-7-2.tmj","id":"room-7-2"},{"file":"maps/rooms/room-7-3.tmj","id":"room-7-3"},{"file":"maps/rooms/room-7-4.tmj","id":"room-7-4"},{"file":"maps/rooms/room-7-5.tmj","id":"room-7-5"},{"file":"maps/rooms/room-7-6.tmj","id":"room-7-6"},{"file":"maps/rooms/room-7-7.tmj","id":"room-7-7"},{"file":"maps/rooms/room-7-8.tmj","id":"room-7-8"},{"file":"maps/rooms/room-7-9.tmj","id":"room-7-9"},{"file":"maps/rooms/room-8-0.tmj","id":"room-8-0"},{"file":"maps/rooms/room-8-1.tmj","id":"room-8-1"},{"file":"maps/rooms/room-8-10.tmj","id":"room-8-10"},{"file":"maps/rooms/room-8-11.tmj","id":"room-8-11"},{"file":"maps/rooms/room-8-12.tmj","id":"room-8-12"},{"file":"maps/rooms/room-8-13.tmj","id":"room-8-13"},{"file":"maps/rooms/room-8-14.tmj","id":"room-8-14"},{"file":"maps/rooms/room-8-15.tmj","id":"room-8-15"},{"file":"maps/rooms/room-8-2.tmj","id":"room-8-2"},{"file":"maps/rooms/room-8-3.tmj","id":"room-8-3"},{"file":"maps/rooms/room-8-4.tmj","id":"room-8-4"},{"file":"maps/rooms/room-8-5.tmj","id":"room-8-5"},{"file":"maps/rooms/room-8-6.tmj","id":"room-8-6"},{"file":"maps/rooms/room-8-7.tmj","id":"room-8-7"},{"file":"maps/rooms/room-8-8.tmj","id":"room-8-8"},{"file":"maps/rooms/room-8-9.tmj","id":"room-8-9"},{"file":"maps/rooms/room-9-0.tmj","id":"room-9-0"},{"file":"maps/rooms/room-9-1.tmj","id":"room-9-1"},{"file":"maps/rooms/room-9-10.tmj","id":"room-9-10"},{"file":"maps/rooms/room-9-11.tmj","id":"room-9-11"},{"file":"maps/rooms/room-9-12.tmj","id":"room-9-12"},{"file":"maps/rooms/room-9-13.tmj","id":"room-9-13"},{"file":"maps/rooms/room-9-14.tmj","id":"room-9-14"},{"file":"maps/rooms/room-9-15.tmj","id":"room-9-15"},{"file":"maps/rooms/room-9-2.tmj","id":"room-9-2"},{"file":"maps/rooms/room-9-3.tmj","id":"room-9-3"},{"file":"maps/rooms/room-9-4.tmj","id":"room-9-4"},{"file":"maps/rooms/room-9-5.tmj","id":"room-9-5"},{"file":"maps/rooms/room-9-6.tmj","id":"room-9-6"},{"file":"maps/rooms/room-9-7.tmj","id":"room-9-7"},{"file":"maps/rooms/room-9-8.tmj","id":"room-9-8"},{"file":"maps/rooms/room-9-9.tmj","id":"room-9-9"},{"file":"maps/rooms/shadow-trials.tmj","id":"shadowTrials","provenance":"maps/sources/shadow-trials.tmx"},{"file":"maps/rooms/test.tmj","id":"test","provenance":"maps/sources/test.tmx"},{"file":"maps/rooms/test2.tmj","id":"test2","provenance":"maps/sources/test2.tmx"},{"file":"maps/rooms/test3.tmj","id":"test3"},{"file":"maps/rooms/test4.tmj","id":"test4"},{"file":"maps/rooms/tutorial1.tmj","id":"tutorial1","provenance":"maps/sources/tutorial1.tmx"},{"file":"maps/rooms/tutorial2.tmj","id":"tutorial2","provenance":"maps/sources/tutorial2.tmx"},{"file":"maps/rooms/tutorial3.tmj","id":"tutorial3","provenance":"maps/sources/tutorial3.tmx"},{"file":"maps/rooms/tutorial4.tmj","id":"tutorial4","provenance":"maps/sources/tutorial4.tmx"},{"file":"maps/rooms/wave1.tmj","id":"wave1","provenance":"maps/sources/wave1.tmx"},{"file":"maps/rooms/wave2.tmj","id":"wave2","provenance":"maps/sources/wave2.tmx"}],"templates":[{"file":"maps/templates/ruins.tmj","id":"ruins"},{"file":"maps/templates/settlement.tmj","id":"settlement"},{"file":"maps/templates/geo.tmj","id":"geo"},{"file":"maps/templates/caves.tmj","id":"caves"},{"file":"maps/templates/item.tmj","id":"item"}],"tilesets":[{"file":"maps/tilesets/authored-terrain.tsx","format":"tsx","id":"authored-terrain"},{"file":"maps/tilesets/beach-desert.tsx","format":"tsx","id":"beach-desert"},{"file":"maps/tilesets/bonecaller-stones.json","format":"json","id":"bonecaller-stones"},{"file":"maps/tilesets/build_atlas.tsx","format":"tsx","id":"build_atlas"},{"file":"maps/tilesets/container.tsx","format":"tsx","id":"container","legacyOmittedTiles":[46,47,62,63]},{"file":"maps/tilesets/cottage.tsx","format":"tsx","id":"cottage"},{"file":"maps/tilesets/decorations-medieval.tsx","format":"tsx","id":"decorations-medieval"},{"file":"maps/tilesets/fence_medieval.tsx","format":"tsx","id":"fence_medieval"},{"file":"maps/tilesets/floors.tsx","format":"tsx","id":"floors"},{"file":"maps/tilesets/furniture-blonde-wood.tsx","format":"tsx","id":"furniture-blonde-wood"},{"file":"maps/tilesets/jungle-ruins.tsx","format":"tsx","id":"jungle-ruins"},{"file":"maps/tilesets/lpc-flowers-plants-fungi-wood.tsx","format":"tsx","id":"lpc-flowers-plants-fungi-wood"},{"file":"maps/tilesets/lpc-terrain.tsx","format":"tsx","id":"lpc-terrain"},{"file":"maps/tilesets/map-atlas.tsx","format":"tsx","id":"map-atlas"},{"file":"maps/tilesets/mountains-v6.tsx","format":"tsx","id":"mountains-v6"},{"file":"maps/tilesets/ore.tsx","format":"tsx","id":"ore"},{"file":"maps/tilesets/plants.tsx","format":"tsx","id":"plants"},{"file":"maps/tilesets/roofs.tsx","format":"tsx","id":"roofs"},{"file":"maps/tilesets/walls.tsx","format":"tsx","id":"walls"},{"file":"maps/tilesets/walls2.tsx","format":"tsx","id":"walls2"},{"file":"maps/tilesets/forest-grass.tsx","format":"tsx","id":"forest-grass"},{"file":"maps/tilesets/forest-dirt.tsx","format":"tsx","id":"forest-dirt"}],"world":"maps/world/world_meta.json"},"preload":["lpc/spritesheets/bauldron/female/brown.png.json","lpc/spritesheets/bauldron/male/brown.png.json","lpc/spritesheets/body/female/deer/brown.png.json","lpc/spritesheets/body/female/human/black.png.json","lpc/spritesheets/body/female/human/brown.png.json","lpc/spritesheets/body/female/human/dark.png.json","lpc/spritesheets/body/female/human/light.png.json","lpc/spritesheets/body/female/human/olive.png.json","lpc/spritesheets/body/female/human/tanned.png.json","lpc/spritesheets/body/female/human/white.png.json","lpc/spritesheets/body/female/orcs/gray.png.json","lpc/spritesheets/body/female/orcs/green_1.png.json","lpc/spritesheets/body/female/orcs/green_3.png.json","lpc/spritesheets/body/female/reptiles/blue_unwinged.png.json","lpc/spritesheets/body/female/reptiles/blue_winged.png.json","lpc/spritesheets/body/female/reptiles/green_unwinged.png.json","lpc/spritesheets/body/female/reptiles/green_winged.png.json","lpc/spritesheets/body/female/reptiles/lightgreen_unwinged.png.json","lpc/spritesheets/body/female/reptiles/lightgreen_winged.png.json","lpc/spritesheets/body/female/wolf/black.png.json","lpc/spritesheets/body/female/wolf/brown.png.json","lpc/spritesheets/body/female/wolf/gray.png.json","lpc/spritesheets/body/female/wolf/head/black.png.json","lpc/spritesheets/body/female/wolf/head/brown.png.json","lpc/spritesheets/body/female/wolf/head/gray.png.json","lpc/spritesheets/body/female/wolf/head/white.png.json","lpc/spritesheets/body/female/wolf/white.png.json","lpc/spritesheets/body/male/chicken/white.png.json","lpc/spritesheets/body/male/horse/burdened/brown.png.json","lpc/spritesheets/body/male/human/black.png.json","lpc/spritesheets/body/male/human/brown.png.json","lpc/spritesheets/body/male/human/dark.png.json","lpc/spritesheets/body/male/human/light.png.json","lpc/spritesheets/body/male/human/olive.png.json","lpc/spritesheets/body/male/human/tanned.png.json","lpc/spritesheets/body/male/human/white.png.json","lpc/spritesheets/body/male/orcs/gray.png.json","lpc/spritesheets/body/male/orcs/green_1.png.json","lpc/spritesheets/body/male/orcs/green_3.png.json","lpc/spritesheets/body/male/rabbit/white.png.json","lpc/spritesheets/body/male/redspider/red.png.json","lpc/spritesheets/body/male/reptiles/blue_unwinged.png.json","lpc/spritesheets/body/male/reptiles/blue_winged.png.json","lpc/spritesheets/body/male/reptiles/green_unwinged.png.json","lpc/spritesheets/body/male/reptiles/green_winged.png.json","lpc/spritesheets/body/male/reptiles/lightgreen_unwinged.png.json","lpc/spritesheets/body/male/reptiles/lightgreen_winged.png.json","lpc/spritesheets/body/male/slime/green.png.json","lpc/spritesheets/body/male/snake/green.png.json","lpc/spritesheets/body/male/special/zombie.png.json","lpc/spritesheets/body/male/wasp/yellow.png.json","lpc/spritesheets/body/male/wolf/black.png.json","lpc/spritesheets/body/male/wolf/brown.png.json","lpc/spritesheets/body/male/wolf/gray.png.json","lpc/spritesheets/body/male/wolf/head/black.png.json","lpc/spritesheets/body/male/wolf/head/brown.png.json","lpc/spritesheets/body/male/wolf/head/gray.png.json","lpc/spritesheets/body/male/wolf/head/white.png.json","lpc/spritesheets/body/male/wolf/white.png.json","lpc/spritesheets/body/skeleton/beige.png.json","lpc/spritesheets/body/skeleton/gray.png.json","lpc/spritesheets/body/skeleton/green.png.json","lpc/spritesheets/cape/solid/male/black.png.json","lpc/spritesheets/cape/solid/male/blue.png.json","lpc/spritesheets/cape/solid/male/brown.png.json","lpc/spritesheets/cape/solid/male/gray.png.json","lpc/spritesheets/cape/solid/male/green.png.json","lpc/spritesheets/cape/solid/male/maroon.png.json","lpc/spritesheets/cape/solid/male/red.png.json","lpc/spritesheets/cape/solid/male/white.png.json","lpc/spritesheets/cape/solid/male/yellow.png.json","lpc/spritesheets/cape/solid_behind/black.png.json","lpc/spritesheets/cape/solid_behind/blue.png.json","lpc/spritesheets/cape/solid_behind/brown.png.json","lpc/spritesheets/cape/solid_behind/gray.png.json","lpc/spritesheets/cape/solid_behind/green.png.json","lpc/spritesheets/cape/solid_behind/maroon.png.json","lpc/spritesheets/cape/solid_behind/red.png.json","lpc/spritesheets/cape/solid_behind/white.png.json","lpc/spritesheets/cape/solid_behind/yellow.png.json","lpc/spritesheets/cape/tattered/female/black.png.json","lpc/spritesheets/cape/tattered/female/blue.png.json","lpc/spritesheets/cape/tattered/female/brown.png.json","lpc/spritesheets/cape/tattered/female/gray.png.json","lpc/spritesheets/cape/tattered/female/green.png.json","lpc/spritesheets/cape/tattered/female/maroon.png.json","lpc/spritesheets/cape/tattered/female/red.png.json","lpc/spritesheets/cape/tattered/female/white.png.json","lpc/spritesheets/cape/tattered/female/yellow.png.json","lpc/spritesheets/cape/tattered_behind/black.png.json","lpc/spritesheets/cape/tattered_behind/blue.png.json","lpc/spritesheets/cape/tattered_behind/brown.png.json","lpc/spritesheets/cape/tattered_behind/gray.png.json","lpc/spritesheets/cape/tattered_behind/green.png.json","lpc/spritesheets/cape/tattered_behind/maroon.png.json","lpc/spritesheets/cape/tattered_behind/red.png.json","lpc/spritesheets/cape/tattered_behind/white.png.json","lpc/spritesheets/cape/tattered_behind/yellow.png.json","lpc/spritesheets/cape/trimmed/female/white_blue.png.json","lpc/spritesheets/cape/trimmed_behind/white_blue.png.json","lpc/spritesheets/eyes/female/blue.png.json","lpc/spritesheets/eyes/female/brown.png.json","lpc/spritesheets/eyes/female/cyclope.png.json","lpc/spritesheets/eyes/female/gray.png.json","lpc/spritesheets/eyes/female/green.png.json","lpc/spritesheets/eyes/female/orange.png.json","lpc/spritesheets/eyes/female/purple.png.json","lpc/spritesheets/eyes/female/red.png.json","lpc/spritesheets/eyes/female/yellow.png.json","lpc/spritesheets/eyes/male/blue.png.json","lpc/spritesheets/eyes/male/brown.png.json","lpc/spritesheets/eyes/male/cyclope.png.json","lpc/spritesheets/eyes/male/gray.png.json","lpc/spritesheets/eyes/male/green.png.json","lpc/spritesheets/eyes/male/orange.png.json","lpc/spritesheets/eyes/male/purple.png.json","lpc/spritesheets/eyes/male/red.png.json","lpc/spritesheets/eyes/male/yellow.png.json","lpc/spritesheets/feet/armor/female/4.png.json","lpc/spritesheets/feet/armor/female/5.png.json","lpc/spritesheets/feet/armor/female/6.png.json","lpc/spritesheets/feet/armor/female/7.png.json","lpc/spritesheets/feet/armor/female/8.png.json","lpc/spritesheets/feet/armor/female/9.png.json","lpc/spritesheets/feet/armor/male/4.png.json","lpc/spritesheets/feet/armor/male/5.png.json","lpc/spritesheets/feet/armor/male/6.png.json","lpc/spritesheets/feet/armor/male/7.png.json","lpc/spritesheets/feet/armor/male/8.png.json","lpc/spritesheets/feet/armor/male/9.png.json","lpc/spritesheets/feet/boots/female/black.png.json","lpc/spritesheets/feet/boots/female/blue.png.json","lpc/spritesheets/feet/boots/female/brown.png.json","lpc/spritesheets/feet/boots/female/gray.png.json","lpc/spritesheets/feet/boots/female/green.png.json","lpc/spritesheets/feet/boots/female/maroon.png.json","lpc/spritesheets/feet/boots/female/orange.png.json","lpc/spritesheets/feet/boots/female/purple.png.json","lpc/spritesheets/feet/boots/female/red.png.json","lpc/spritesheets/feet/boots/female/tan.png.json","lpc/spritesheets/feet/boots/female/teal.png.json","lpc/spritesheets/feet/boots/female/white.png.json","lpc/spritesheets/feet/boots/female/yellow.png.json","lpc/spritesheets/feet/boots/male/black.png.json","lpc/spritesheets/feet/boots/male/blue.png.json","lpc/spritesheets/feet/boots/male/brown.png.json","lpc/spritesheets/feet/boots/male/gray.png.json","lpc/spritesheets/feet/boots/male/green.png.json","lpc/spritesheets/feet/boots/male/maroon.png.json","lpc/spritesheets/feet/boots/male/orange.png.json","lpc/spritesheets/feet/boots/male/purple.png.json","lpc/spritesheets/feet/boots/male/red.png.json","lpc/spritesheets/feet/boots/male/tan.png.json","lpc/spritesheets/feet/boots/male/teal.png.json","lpc/spritesheets/feet/boots/male/white.png.json","lpc/spritesheets/feet/boots/male/yellow.png.json","lpc/spritesheets/feet/sandals/female/brown.png.json","lpc/spritesheets/feet/sandals/male/brown.png.json","lpc/spritesheets/feet/shoes/female/black.png.json","lpc/spritesheets/feet/shoes/female/brown.png.json","lpc/spritesheets/feet/shoes/female/maroon.png.json","lpc/spritesheets/feet/shoes/male/black.png.json","lpc/spritesheets/feet/shoes/male/brown.png.json","lpc/spritesheets/feet/shoes/male/maroon.png.json","lpc/spritesheets/feet/slippers/female/black.png.json","lpc/spritesheets/feet/slippers/female/brown.png.json","lpc/spritesheets/feet/slippers/female/gray.png.json","lpc/spritesheets/hair/afro/female/black.png.json","lpc/spritesheets/hair/afro/female/blonde.png.json","lpc/spritesheets/hair/afro/female/blue.png.json","lpc/spritesheets/hair/afro/female/dark_brown.png.json","lpc/spritesheets/hair/afro/female/gold.png.json","lpc/spritesheets/hair/afro/female/gray.png.json","lpc/spritesheets/hair/afro/female/green.png.json","lpc/spritesheets/hair/afro/female/light_brown.png.json","lpc/spritesheets/hair/afro/female/orange.png.json","lpc/spritesheets/hair/afro/female/purple.png.json","lpc/spritesheets/hair/afro/female/red.png.json","lpc/spritesheets/hair/afro/female/white.png.json","lpc/spritesheets/hair/afro/male/black.png.json","lpc/spritesheets/hair/afro/male/blonde.png.json","lpc/spritesheets/hair/afro/male/blue.png.json","lpc/spritesheets/hair/afro/male/dark_brown.png.json","lpc/spritesheets/hair/afro/male/gold.png.json","lpc/spritesheets/hair/afro/male/gray.png.json","lpc/spritesheets/hair/afro/male/green.png.json","lpc/spritesheets/hair/afro/male/light_brown.png.json","lpc/spritesheets/hair/afro/male/orange.png.json","lpc/spritesheets/hair/afro/male/purple.png.json","lpc/spritesheets/hair/afro/male/red.png.json","lpc/spritesheets/hair/afro/male/white.png.json","lpc/spritesheets/hair/balding/male/black.png.json","lpc/spritesheets/hair/balding/male/blonde.png.json","lpc/spritesheets/hair/balding/male/blue.png.json","lpc/spritesheets/hair/balding/male/dark_brown.png.json","lpc/spritesheets/hair/balding/male/gold.png.json","lpc/spritesheets/hair/balding/male/gray.png.json","lpc/spritesheets/hair/balding/male/green.png.json","lpc/spritesheets/hair/balding/male/light_brown.png.json","lpc/spritesheets/hair/balding/male/orange.png.json","lpc/spritesheets/hair/balding/male/purple.png.json","lpc/spritesheets/hair/balding/male/red.png.json","lpc/spritesheets/hair/balding/male/white.png.json","lpc/spritesheets/hair/bangs/female/black.png.json","lpc/spritesheets/hair/bangs/female/blonde.png.json","lpc/spritesheets/hair/bangs/female/blue.png.json","lpc/spritesheets/hair/bangs/female/dark_brown.png.json","lpc/spritesheets/hair/bangs/female/gold.png.json","lpc/spritesheets/hair/bangs/female/gray.png.json","lpc/spritesheets/hair/bangs/female/green.png.json","lpc/spritesheets/hair/bangs/female/light_brown.png.json","lpc/spritesheets/hair/bangs/female/orange.png.json","lpc/spritesheets/hair/bangs/female/purple.png.json","lpc/spritesheets/hair/bangs/female/red.png.json","lpc/spritesheets/hair/bangs/female/white.png.json","lpc/spritesheets/hair/bangs/male/black.png.json","lpc/spritesheets/hair/bangs/male/blonde.png.json","lpc/spritesheets/hair/bangs/male/blue.png.json","lpc/spritesheets/hair/bangs/male/dark_brown.png.json","lpc/spritesheets/hair/bangs/male/gold.png.json","lpc/spritesheets/hair/bangs/male/gray.png.json","lpc/spritesheets/hair/bangs/male/green.png.json","lpc/spritesheets/hair/bangs/male/light_brown.png.json","lpc/spritesheets/hair/bangs/male/orange.png.json","lpc/spritesheets/hair/bangs/male/purple.png.json","lpc/spritesheets/hair/bangs/male/red.png.json","lpc/spritesheets/hair/bangs/male/white.png.json","lpc/spritesheets/hair/bangs_bun/female/black.png.json","lpc/spritesheets/hair/bangs_bun/female/blonde.png.json","lpc/spritesheets/hair/bangs_bun/female/blue.png.json","lpc/spritesheets/hair/bangs_bun/female/dark_brown.png.json","lpc/spritesheets/hair/bangs_bun/female/gold.png.json","lpc/spritesheets/hair/bangs_bun/female/gray.png.json","lpc/spritesheets/hair/bangs_bun/female/green.png.json","lpc/spritesheets/hair/bangs_bun/female/light_brown.png.json","lpc/spritesheets/hair/bangs_bun/female/orange.png.json","lpc/spritesheets/hair/bangs_bun/female/purple.png.json","lpc/spritesheets/hair/bangs_bun/female/red.png.json","lpc/spritesheets/hair/bangs_bun/female/white.png.json","lpc/spritesheets/hair/bangs_bun/male/black.png.json","lpc/spritesheets/hair/bangs_bun/male/blonde.png.json","lpc/spritesheets/hair/bangs_bun/male/blue.png.json","lpc/spritesheets/hair/bangs_bun/male/dark_brown.png.json","lpc/spritesheets/hair/bangs_bun/male/gold.png.json","lpc/spritesheets/hair/bangs_bun/male/gray.png.json","lpc/spritesheets/hair/bangs_bun/male/green.png.json","lpc/spritesheets/hair/bangs_bun/male/light_brown.png.json","lpc/spritesheets/hair/bangs_bun/male/orange.png.json","lpc/spritesheets/hair/bangs_bun/male/purple.png.json","lpc/spritesheets/hair/bangs_bun/male/red.png.json","lpc/spritesheets/hair/bangs_bun/male/white.png.json","lpc/spritesheets/hair/bangslong/female/black.png.json","lpc/spritesheets/hair/bangslong/female/blonde.png.json","lpc/spritesheets/hair/bangslong/female/blue.png.json","lpc/spritesheets/hair/bangslong/female/dark_brown.png.json","lpc/spritesheets/hair/bangslong/female/gold.png.json","lpc/spritesheets/hair/bangslong/female/gray.png.json","lpc/spritesheets/hair/bangslong/female/green.png.json","lpc/spritesheets/hair/bangslong/female/light_brown.png.json","lpc/spritesheets/hair/bangslong/female/orange.png.json","lpc/spritesheets/hair/bangslong/female/purple.png.json","lpc/spritesheets/hair/bangslong/female/red.png.json","lpc/spritesheets/hair/bangslong/female/white.png.json","lpc/spritesheets/hair/bangslong/male/black.png.json","lpc/spritesheets/hair/bangslong/male/blonde.png.json","lpc/spritesheets/hair/bangslong/male/blue.png.json","lpc/spritesheets/hair/bangslong/male/dark_brown.png.json","lpc/spritesheets/hair/bangslong/male/gold.png.json","lpc/spritesheets/hair/bangslong/male/gray.png.json","lpc/spritesheets/hair/bangslong/male/green.png.json","lpc/spritesheets/hair/bangslong/male/light_brown.png.json","lpc/spritesheets/hair/bangslong/male/orange.png.json","lpc/spritesheets/hair/bangslong/male/purple.png.json","lpc/spritesheets/hair/bangslong/male/red.png.json","lpc/spritesheets/hair/bangslong/male/white.png.json","lpc/spritesheets/hair/bangslong2/female/black.png.json","lpc/spritesheets/hair/bangslong2/female/blonde.png.json","lpc/spritesheets/hair/bangslong2/female/blue.png.json","lpc/spritesheets/hair/bangslong2/female/dark_brown.png.json","lpc/spritesheets/hair/bangslong2/female/gold.png.json","lpc/spritesheets/hair/bangslong2/female/gray.png.json","lpc/spritesheets/hair/bangslong2/female/green.png.json","lpc/spritesheets/hair/bangslong2/female/light_brown.png.json","lpc/spritesheets/hair/bangslong2/female/orange.png.json","lpc/spritesheets/hair/bangslong2/female/purple.png.json","lpc/spritesheets/hair/bangslong2/female/red.png.json","lpc/spritesheets/hair/bangslong2/female/white.png.json","lpc/spritesheets/hair/bangslong2/male/black.png.json","lpc/spritesheets/hair/bangslong2/male/blonde.png.json","lpc/spritesheets/hair/bangslong2/male/blue.png.json","lpc/spritesheets/hair/bangslong2/male/dark_brown.png.json","lpc/spritesheets/hair/bangslong2/male/gold.png.json","lpc/spritesheets/hair/bangslong2/male/gray.png.json","lpc/spritesheets/hair/bangslong2/male/green.png.json","lpc/spritesheets/hair/bangslong2/male/light_brown.png.json","lpc/spritesheets/hair/bangslong2/male/orange.png.json","lpc/spritesheets/hair/bangslong2/male/purple.png.json","lpc/spritesheets/hair/bangslong2/male/red.png.json","lpc/spritesheets/hair/bangslong2/male/white.png.json","lpc/spritesheets/hair/bangsshort/female/black.png.json","lpc/spritesheets/hair/bangsshort/female/blonde.png.json","lpc/spritesheets/hair/bangsshort/female/blue.png.json","lpc/spritesheets/hair/bangsshort/female/dark_brown.png.json","lpc/spritesheets/hair/bangsshort/female/gold.png.json","lpc/spritesheets/hair/bangsshort/female/gray.png.json","lpc/spritesheets/hair/bangsshort/female/green.png.json","lpc/spritesheets/hair/bangsshort/female/light_brown.png.json","lpc/spritesheets/hair/bangsshort/female/orange.png.json","lpc/spritesheets/hair/bangsshort/female/purple.png.json","lpc/spritesheets/hair/bangsshort/female/red.png.json","lpc/spritesheets/hair/bangsshort/female/white.png.json","lpc/spritesheets/hair/bangsshort/male/black.png.json","lpc/spritesheets/hair/bangsshort/male/blonde.png.json","lpc/spritesheets/hair/bangsshort/male/blue.png.json","lpc/spritesheets/hair/bangsshort/male/dark_brown.png.json","lpc/spritesheets/hair/bangsshort/male/gold.png.json","lpc/spritesheets/hair/bangsshort/male/gray.png.json","lpc/spritesheets/hair/bangsshort/male/green.png.json","lpc/spritesheets/hair/bangsshort/male/light_brown.png.json","lpc/spritesheets/hair/bangsshort/male/orange.png.json","lpc/spritesheets/hair/bangsshort/male/purple.png.json","lpc/spritesheets/hair/bangsshort/male/red.png.json","lpc/spritesheets/hair/bangsshort/male/white.png.json","lpc/spritesheets/hair/bedhead/female/black.png.json","lpc/spritesheets/hair/bedhead/female/blonde.png.json","lpc/spritesheets/hair/bedhead/female/blue.png.json","lpc/spritesheets/hair/bedhead/female/dark_brown.png.json","lpc/spritesheets/hair/bedhead/female/gold.png.json","lpc/spritesheets/hair/bedhead/female/gray.png.json","lpc/spritesheets/hair/bedhead/female/green.png.json","lpc/spritesheets/hair/bedhead/female/light_brown.png.json","lpc/spritesheets/hair/bedhead/female/orange.png.json","lpc/spritesheets/hair/bedhead/female/purple.png.json","lpc/spritesheets/hair/bedhead/female/red.png.json","lpc/spritesheets/hair/bedhead/female/white.png.json","lpc/spritesheets/hair/bedhead/male/black.png.json","lpc/spritesheets/hair/bedhead/male/blonde.png.json","lpc/spritesheets/hair/bedhead/male/blue.png.json","lpc/spritesheets/hair/bedhead/male/dark_brown.png.json","lpc/spritesheets/hair/bedhead/male/gold.png.json","lpc/spritesheets/hair/bedhead/male/gray.png.json","lpc/spritesheets/hair/bedhead/male/green.png.json","lpc/spritesheets/hair/bedhead/male/light_brown.png.json","lpc/spritesheets/hair/bedhead/male/orange.png.json","lpc/spritesheets/hair/bedhead/male/purple.png.json","lpc/spritesheets/hair/bedhead/male/red.png.json","lpc/spritesheets/hair/bedhead/male/white.png.json","lpc/spritesheets/hair/bob/female/black.png.json","lpc/spritesheets/hair/bob/female/blonde.png.json","lpc/spritesheets/hair/bob/female/blue.png.json","lpc/spritesheets/hair/bob/female/dark_brown.png.json","lpc/spritesheets/hair/bob/female/gold.png.json","lpc/spritesheets/hair/bob/female/gray.png.json","lpc/spritesheets/hair/bob/female/green.png.json","lpc/spritesheets/hair/bob/female/light_brown.png.json","lpc/spritesheets/hair/bob/female/orange.png.json","lpc/spritesheets/hair/bob/female/purple.png.json","lpc/spritesheets/hair/bob/female/red.png.json","lpc/spritesheets/hair/bob/female/white.png.json","lpc/spritesheets/hair/bob_side_part/female/black.png.json","lpc/spritesheets/hair/bob_side_part/female/blonde.png.json","lpc/spritesheets/hair/bob_side_part/female/blue.png.json","lpc/spritesheets/hair/bob_side_part/female/dark_brown.png.json","lpc/spritesheets/hair/bob_side_part/female/gold.png.json","lpc/spritesheets/hair/bob_side_part/female/gray.png.json","lpc/spritesheets/hair/bob_side_part/female/green.png.json","lpc/spritesheets/hair/bob_side_part/female/light_brown.png.json","lpc/spritesheets/hair/bob_side_part/female/orange.png.json","lpc/spritesheets/hair/bob_side_part/female/purple.png.json","lpc/spritesheets/hair/bob_side_part/female/red.png.json","lpc/spritesheets/hair/bob_side_part/female/white.png.json","lpc/spritesheets/hair/braid/female/black.png.json","lpc/spritesheets/hair/braid/female/blonde.png.json","lpc/spritesheets/hair/braid/female/blue.png.json","lpc/spritesheets/hair/braid/female/dark_brown.png.json","lpc/spritesheets/hair/braid/female/gold.png.json","lpc/spritesheets/hair/braid/female/gray.png.json","lpc/spritesheets/hair/braid/female/green.png.json","lpc/spritesheets/hair/braid/female/light_brown.png.json","lpc/spritesheets/hair/braid/female/orange.png.json","lpc/spritesheets/hair/braid/female/purple.png.json","lpc/spritesheets/hair/braid/female/red.png.json","lpc/spritesheets/hair/braid/female/white.png.json","lpc/spritesheets/hair/braid2/female/black.png.json","lpc/spritesheets/hair/braid2/female/blonde.png.json","lpc/spritesheets/hair/braid2/female/blue.png.json","lpc/spritesheets/hair/braid2/female/dark_brown.png.json","lpc/spritesheets/hair/braid2/female/gold.png.json","lpc/spritesheets/hair/braid2/female/gray.png.json","lpc/spritesheets/hair/braid2/female/green.png.json","lpc/spritesheets/hair/braid2/female/light_brown.png.json","lpc/spritesheets/hair/braid2/female/orange.png.json","lpc/spritesheets/hair/braid2/female/purple.png.json","lpc/spritesheets/hair/braid2/female/red.png.json","lpc/spritesheets/hair/braid2/female/white.png.json","lpc/spritesheets/hair/bunches/female/black.png.json","lpc/spritesheets/hair/bunches/female/blonde.png.json","lpc/spritesheets/hair/bunches/female/blue.png.json","lpc/spritesheets/hair/bunches/female/dark_brown.png.json","lpc/spritesheets/hair/bunches/female/gold.png.json","lpc/spritesheets/hair/bunches/female/gray.png.json","lpc/spritesheets/hair/bunches/female/green.png.json","lpc/spritesheets/hair/bunches/female/light_brown.png.json","lpc/spritesheets/hair/bunches/female/orange.png.json","lpc/spritesheets/hair/bunches/female/purple.png.json","lpc/spritesheets/hair/bunches/female/red.png.json","lpc/spritesheets/hair/bunches/female/white.png.json","lpc/spritesheets/hair/buzzcut/female/black.png.json","lpc/spritesheets/hair/buzzcut/female/blonde.png.json","lpc/spritesheets/hair/buzzcut/female/blue.png.json","lpc/spritesheets/hair/buzzcut/female/dark_brown.png.json","lpc/spritesheets/hair/buzzcut/female/gold.png.json","lpc/spritesheets/hair/buzzcut/female/gray.png.json","lpc/spritesheets/hair/buzzcut/female/green.png.json","lpc/spritesheets/hair/buzzcut/female/light_brown.png.json","lpc/spritesheets/hair/buzzcut/female/orange.png.json","lpc/spritesheets/hair/buzzcut/female/purple.png.json","lpc/spritesheets/hair/buzzcut/female/red.png.json","lpc/spritesheets/hair/buzzcut/female/white.png.json","lpc/spritesheets/hair/buzzcut/male/black.png.json","lpc/spritesheets/hair/buzzcut/male/blonde.png.json","lpc/spritesheets/hair/buzzcut/male/blue.png.json","lpc/spritesheets/hair/buzzcut/male/dark_brown.png.json","lpc/spritesheets/hair/buzzcut/male/gold.png.json","lpc/spritesheets/hair/buzzcut/male/gray.png.json","lpc/spritesheets/hair/buzzcut/male/green.png.json","lpc/spritesheets/hair/buzzcut/male/light_brown.png.json","lpc/spritesheets/hair/buzzcut/male/orange.png.json","lpc/spritesheets/hair/buzzcut/male/purple.png.json","lpc/spritesheets/hair/buzzcut/male/red.png.json","lpc/spritesheets/hair/buzzcut/male/white.png.json","lpc/spritesheets/hair/cornrows/female/black.png.json","lpc/spritesheets/hair/cornrows/female/blonde.png.json","lpc/spritesheets/hair/cornrows/female/blue.png.json","lpc/spritesheets/hair/cornrows/female/dark_brown.png.json","lpc/spritesheets/hair/cornrows/female/gold.png.json","lpc/spritesheets/hair/cornrows/female/gray.png.json","lpc/spritesheets/hair/cornrows/female/green.png.json","lpc/spritesheets/hair/cornrows/female/light_brown.png.json","lpc/spritesheets/hair/cornrows/female/orange.png.json","lpc/spritesheets/hair/cornrows/female/purple.png.json","lpc/spritesheets/hair/cornrows/female/red.png.json","lpc/spritesheets/hair/cornrows/female/white.png.json","lpc/spritesheets/hair/cornrows/male/black.png.json","lpc/spritesheets/hair/cornrows/male/blonde.png.json","lpc/spritesheets/hair/cornrows/male/blue.png.json","lpc/spritesheets/hair/cornrows/male/dark_brown.png.json","lpc/spritesheets/hair/cornrows/male/gold.png.json","lpc/spritesheets/hair/cornrows/male/gray.png.json","lpc/spritesheets/hair/cornrows/male/green.png.json","lpc/spritesheets/hair/cornrows/male/light_brown.png.json","lpc/spritesheets/hair/cornrows/male/orange.png.json","lpc/spritesheets/hair/cornrows/male/purple.png.json","lpc/spritesheets/hair/cornrows/male/red.png.json","lpc/spritesheets/hair/cornrows/male/white.png.json","lpc/spritesheets/hair/cowlick/female/black.png.json","lpc/spritesheets/hair/cowlick/female/blonde.png.json","lpc/spritesheets/hair/cowlick/female/blue.png.json","lpc/spritesheets/hair/cowlick/female/dark_brown.png.json","lpc/spritesheets/hair/cowlick/female/gold.png.json","lpc/spritesheets/hair/cowlick/female/gray.png.json","lpc/spritesheets/hair/cowlick/female/green.png.json","lpc/spritesheets/hair/cowlick/female/light_brown.png.json","lpc/spritesheets/hair/cowlick/female/orange.png.json","lpc/spritesheets/hair/cowlick/female/purple.png.json","lpc/spritesheets/hair/cowlick/female/red.png.json","lpc/spritesheets/hair/cowlick/female/white.png.json","lpc/spritesheets/hair/cowlick/male/black.png.json","lpc/spritesheets/hair/cowlick/male/blonde.png.json","lpc/spritesheets/hair/cowlick/male/blue.png.json","lpc/spritesheets/hair/cowlick/male/dark_brown.png.json","lpc/spritesheets/hair/cowlick/male/gold.png.json","lpc/spritesheets/hair/cowlick/male/gray.png.json","lpc/spritesheets/hair/cowlick/male/green.png.json","lpc/spritesheets/hair/cowlick/male/light_brown.png.json","lpc/spritesheets/hair/cowlick/male/orange.png.json","lpc/spritesheets/hair/cowlick/male/purple.png.json","lpc/spritesheets/hair/cowlick/male/red.png.json","lpc/spritesheets/hair/cowlick/male/white.png.json","lpc/spritesheets/hair/cowlick_tall/female/black.png.json","lpc/spritesheets/hair/cowlick_tall/female/blonde.png.json","lpc/spritesheets/hair/cowlick_tall/female/blue.png.json","lpc/spritesheets/hair/cowlick_tall/female/dark_brown.png.json","lpc/spritesheets/hair/cowlick_tall/female/gold.png.json","lpc/spritesheets/hair/cowlick_tall/female/gray.png.json","lpc/spritesheets/hair/cowlick_tall/female/green.png.json","lpc/spritesheets/hair/cowlick_tall/female/light_brown.png.json","lpc/spritesheets/hair/cowlick_tall/female/orange.png.json","lpc/spritesheets/hair/cowlick_tall/female/purple.png.json","lpc/spritesheets/hair/cowlick_tall/female/red.png.json","lpc/spritesheets/hair/cowlick_tall/female/white.png.json","lpc/spritesheets/hair/cowlick_tall/male/black.png.json","lpc/spritesheets/hair/cowlick_tall/male/blonde.png.json","lpc/spritesheets/hair/cowlick_tall/male/blue.png.json","lpc/spritesheets/hair/cowlick_tall/male/dark_brown.png.json","lpc/spritesheets/hair/cowlick_tall/male/gold.png.json","lpc/spritesheets/hair/cowlick_tall/male/gray.png.json","lpc/spritesheets/hair/cowlick_tall/male/green.png.json","lpc/spritesheets/hair/cowlick_tall/male/light_brown.png.json","lpc/spritesheets/hair/cowlick_tall/male/orange.png.json","lpc/spritesheets/hair/cowlick_tall/male/purple.png.json","lpc/spritesheets/hair/cowlick_tall/male/red.png.json","lpc/spritesheets/hair/cowlick_tall/male/white.png.json","lpc/spritesheets/hair/curly_long/female/black.png.json","lpc/spritesheets/hair/curly_long/female/blonde.png.json","lpc/spritesheets/hair/curly_long/female/blue.png.json","lpc/spritesheets/hair/curly_long/female/dark_brown.png.json","lpc/spritesheets/hair/curly_long/female/gold.png.json","lpc/spritesheets/hair/curly_long/female/gray.png.json","lpc/spritesheets/hair/curly_long/female/green.png.json","lpc/spritesheets/hair/curly_long/female/light_brown.png.json","lpc/spritesheets/hair/curly_long/female/orange.png.json","lpc/spritesheets/hair/curly_long/female/purple.png.json","lpc/spritesheets/hair/curly_long/female/red.png.json","lpc/spritesheets/hair/curly_long/female/white.png.json","lpc/spritesheets/hair/curly_short/female/black.png.json","lpc/spritesheets/hair/curly_short/female/blonde.png.json","lpc/spritesheets/hair/curly_short/female/blue.png.json","lpc/spritesheets/hair/curly_short/female/dark_brown.png.json","lpc/spritesheets/hair/curly_short/female/gold.png.json","lpc/spritesheets/hair/curly_short/female/gray.png.json","lpc/spritesheets/hair/curly_short/female/green.png.json","lpc/spritesheets/hair/curly_short/female/light_brown.png.json","lpc/spritesheets/hair/curly_short/female/orange.png.json","lpc/spritesheets/hair/curly_short/female/purple.png.json","lpc/spritesheets/hair/curly_short/female/red.png.json","lpc/spritesheets/hair/curly_short/female/white.png.json","lpc/spritesheets/hair/curly_short/male/black.png.json","lpc/spritesheets/hair/curly_short/male/blonde.png.json","lpc/spritesheets/hair/curly_short/male/blue.png.json","lpc/spritesheets/hair/curly_short/male/dark_brown.png.json","lpc/spritesheets/hair/curly_short/male/gold.png.json","lpc/spritesheets/hair/curly_short/male/gray.png.json","lpc/spritesheets/hair/curly_short/male/green.png.json","lpc/spritesheets/hair/curly_short/male/light_brown.png.json","lpc/spritesheets/hair/curly_short/male/orange.png.json","lpc/spritesheets/hair/curly_short/male/purple.png.json","lpc/spritesheets/hair/curly_short/male/red.png.json","lpc/spritesheets/hair/curly_short/male/white.png.json","lpc/spritesheets/hair/curtains/female/black.png.json","lpc/spritesheets/hair/curtains/female/blonde.png.json","lpc/spritesheets/hair/curtains/female/blue.png.json","lpc/spritesheets/hair/curtains/female/dark_brown.png.json","lpc/spritesheets/hair/curtains/female/gold.png.json","lpc/spritesheets/hair/curtains/female/gray.png.json","lpc/spritesheets/hair/curtains/female/green.png.json","lpc/spritesheets/hair/curtains/female/light_brown.png.json","lpc/spritesheets/hair/curtains/female/orange.png.json","lpc/spritesheets/hair/curtains/female/purple.png.json","lpc/spritesheets/hair/curtains/female/red.png.json","lpc/spritesheets/hair/curtains/female/white.png.json","lpc/spritesheets/hair/curtains/male/black.png.json","lpc/spritesheets/hair/curtains/male/blonde.png.json","lpc/spritesheets/hair/curtains/male/blue.png.json","lpc/spritesheets/hair/curtains/male/dark_brown.png.json","lpc/spritesheets/hair/curtains/male/gold.png.json","lpc/spritesheets/hair/curtains/male/gray.png.json","lpc/spritesheets/hair/curtains/male/green.png.json","lpc/spritesheets/hair/curtains/male/light_brown.png.json","lpc/spritesheets/hair/curtains/male/orange.png.json","lpc/spritesheets/hair/curtains/male/purple.png.json","lpc/spritesheets/hair/curtains/male/red.png.json","lpc/spritesheets/hair/curtains/male/white.png.json","lpc/spritesheets/hair/curtains_long/female/black.png.json","lpc/spritesheets/hair/curtains_long/female/blonde.png.json","lpc/spritesheets/hair/curtains_long/female/blue.png.json","lpc/spritesheets/hair/curtains_long/female/dark_brown.png.json","lpc/spritesheets/hair/curtains_long/female/gold.png.json","lpc/spritesheets/hair/curtains_long/female/gray.png.json","lpc/spritesheets/hair/curtains_long/female/green.png.json","lpc/spritesheets/hair/curtains_long/female/light_brown.png.json","lpc/spritesheets/hair/curtains_long/female/orange.png.json","lpc/spritesheets/hair/curtains_long/female/purple.png.json","lpc/spritesheets/hair/curtains_long/female/red.png.json","lpc/spritesheets/hair/curtains_long/female/white.png.json","lpc/spritesheets/hair/curtains_long/male/black.png.json","lpc/spritesheets/hair/curtains_long/male/blonde.png.json","lpc/spritesheets/hair/curtains_long/male/blue.png.json","lpc/spritesheets/hair/curtains_long/male/dark_brown.png.json","lpc/spritesheets/hair/curtains_long/male/gold.png.json","lpc/spritesheets/hair/curtains_long/male/gray.png.json","lpc/spritesheets/hair/curtains_long/male/green.png.json","lpc/spritesheets/hair/curtains_long/male/light_brown.png.json","lpc/spritesheets/hair/curtains_long/male/orange.png.json","lpc/spritesheets/hair/curtains_long/male/purple.png.json","lpc/spritesheets/hair/curtains_long/male/red.png.json","lpc/spritesheets/hair/curtains_long/male/white.png.json","lpc/spritesheets/hair/dreadlocks_long/female/black.png.json","lpc/spritesheets/hair/dreadlocks_long/female/blonde.png.json","lpc/spritesheets/hair/dreadlocks_long/female/blue.png.json","lpc/spritesheets/hair/dreadlocks_long/female/dark_brown.png.json","lpc/spritesheets/hair/dreadlocks_long/female/gold.png.json","lpc/spritesheets/hair/dreadlocks_long/female/gray.png.json","lpc/spritesheets/hair/dreadlocks_long/female/green.png.json","lpc/spritesheets/hair/dreadlocks_long/female/light_brown.png.json","lpc/spritesheets/hair/dreadlocks_long/female/orange.png.json","lpc/spritesheets/hair/dreadlocks_long/female/purple.png.json","lpc/spritesheets/hair/dreadlocks_long/female/red.png.json","lpc/spritesheets/hair/dreadlocks_long/female/white.png.json","lpc/spritesheets/hair/dreadlocks_long/male/black.png.json","lpc/spritesheets/hair/dreadlocks_long/male/blonde.png.json","lpc/spritesheets/hair/dreadlocks_long/male/blue.png.json","lpc/spritesheets/hair/dreadlocks_long/male/dark_brown.png.json","lpc/spritesheets/hair/dreadlocks_long/male/gold.png.json","lpc/spritesheets/hair/dreadlocks_long/male/gray.png.json","lpc/spritesheets/hair/dreadlocks_long/male/green.png.json","lpc/spritesheets/hair/dreadlocks_long/male/light_brown.png.json","lpc/spritesheets/hair/dreadlocks_long/male/orange.png.json","lpc/spritesheets/hair/dreadlocks_long/male/purple.png.json","lpc/spritesheets/hair/dreadlocks_long/male/red.png.json","lpc/spritesheets/hair/dreadlocks_long/male/white.png.json","lpc/spritesheets/hair/dreadlocks_short/female/black.png.json","lpc/spritesheets/hair/dreadlocks_short/female/blonde.png.json","lpc/spritesheets/hair/dreadlocks_short/female/blue.png.json","lpc/spritesheets/hair/dreadlocks_short/female/dark_brown.png.json","lpc/spritesheets/hair/dreadlocks_short/female/gold.png.json","lpc/spritesheets/hair/dreadlocks_short/female/gray.png.json","lpc/spritesheets/hair/dreadlocks_short/female/green.png.json","lpc/spritesheets/hair/dreadlocks_short/female/light_brown.png.json","lpc/spritesheets/hair/dreadlocks_short/female/orange.png.json","lpc/spritesheets/hair/dreadlocks_short/female/purple.png.json","lpc/spritesheets/hair/dreadlocks_short/female/red.png.json","lpc/spritesheets/hair/dreadlocks_short/female/white.png.json","lpc/spritesheets/hair/dreadlocks_short/male/black.png.json","lpc/spritesheets/hair/dreadlocks_short/male/blonde.png.json","lpc/spritesheets/hair/dreadlocks_short/male/blue.png.json","lpc/spritesheets/hair/dreadlocks_short/male/dark_brown.png.json","lpc/spritesheets/hair/dreadlocks_short/male/gold.png.json","lpc/spritesheets/hair/dreadlocks_short/male/gray.png.json","lpc/spritesheets/hair/dreadlocks_short/male/green.png.json","lpc/spritesheets/hair/dreadlocks_short/male/light_brown.png.json","lpc/spritesheets/hair/dreadlocks_short/male/orange.png.json","lpc/spritesheets/hair/dreadlocks_short/male/purple.png.json","lpc/spritesheets/hair/dreadlocks_short/male/red.png.json","lpc/spritesheets/hair/dreadlocks_short/male/white.png.json","lpc/spritesheets/hair/flat_top_fade/female/black.png.json","lpc/spritesheets/hair/flat_top_fade/female/blonde.png.json","lpc/spritesheets/hair/flat_top_fade/female/blue.png.json","lpc/spritesheets/hair/flat_top_fade/female/dark_brown.png.json","lpc/spritesheets/hair/flat_top_fade/female/gold.png.json","lpc/spritesheets/hair/flat_top_fade/female/gray.png.json","lpc/spritesheets/hair/flat_top_fade/female/green.png.json","lpc/spritesheets/hair/flat_top_fade/female/light_brown.png.json","lpc/spritesheets/hair/flat_top_fade/female/orange.png.json","lpc/spritesheets/hair/flat_top_fade/female/purple.png.json","lpc/spritesheets/hair/flat_top_fade/female/red.png.json","lpc/spritesheets/hair/flat_top_fade/female/white.png.json","lpc/spritesheets/hair/flat_top_fade/male/black.png.json","lpc/spritesheets/hair/flat_top_fade/male/blonde.png.json","lpc/spritesheets/hair/flat_top_fade/male/blue.png.json","lpc/spritesheets/hair/flat_top_fade/male/dark_brown.png.json","lpc/spritesheets/hair/flat_top_fade/male/gold.png.json","lpc/spritesheets/hair/flat_top_fade/male/gray.png.json","lpc/spritesheets/hair/flat_top_fade/male/green.png.json","lpc/spritesheets/hair/flat_top_fade/male/light_brown.png.json","lpc/spritesheets/hair/flat_top_fade/male/orange.png.json","lpc/spritesheets/hair/flat_top_fade/male/purple.png.json","lpc/spritesheets/hair/flat_top_fade/male/red.png.json","lpc/spritesheets/hair/flat_top_fade/male/white.png.json","lpc/spritesheets/hair/flat_top_straight/female/black.png.json","lpc/spritesheets/hair/flat_top_straight/female/blonde.png.json","lpc/spritesheets/hair/flat_top_straight/female/blue.png.json","lpc/spritesheets/hair/flat_top_straight/female/dark_brown.png.json","lpc/spritesheets/hair/flat_top_straight/female/gold.png.json","lpc/spritesheets/hair/flat_top_straight/female/gray.png.json","lpc/spritesheets/hair/flat_top_straight/female/green.png.json","lpc/spritesheets/hair/flat_top_straight/female/light_brown.png.json","lpc/spritesheets/hair/flat_top_straight/female/orange.png.json","lpc/spritesheets/hair/flat_top_straight/female/purple.png.json","lpc/spritesheets/hair/flat_top_straight/female/red.png.json","lpc/spritesheets/hair/flat_top_straight/female/white.png.json","lpc/spritesheets/hair/flat_top_straight/male/black.png.json","lpc/spritesheets/hair/flat_top_straight/male/blonde.png.json","lpc/spritesheets/hair/flat_top_straight/male/blue.png.json","lpc/spritesheets/hair/flat_top_straight/male/dark_brown.png.json","lpc/spritesheets/hair/flat_top_straight/male/gold.png.json","lpc/spritesheets/hair/flat_top_straight/male/gray.png.json","lpc/spritesheets/hair/flat_top_straight/male/green.png.json","lpc/spritesheets/hair/flat_top_straight/male/light_brown.png.json","lpc/spritesheets/hair/flat_top_straight/male/orange.png.json","lpc/spritesheets/hair/flat_top_straight/male/purple.png.json","lpc/spritesheets/hair/flat_top_straight/male/red.png.json","lpc/spritesheets/hair/flat_top_straight/male/white.png.json","lpc/spritesheets/hair/half_up/female/black.png.json","lpc/spritesheets/hair/half_up/female/blonde.png.json","lpc/spritesheets/hair/half_up/female/blue.png.json","lpc/spritesheets/hair/half_up/female/dark_brown.png.json","lpc/spritesheets/hair/half_up/female/gold.png.json","lpc/spritesheets/hair/half_up/female/gray.png.json","lpc/spritesheets/hair/half_up/female/green.png.json","lpc/spritesheets/hair/half_up/female/light_brown.png.json","lpc/spritesheets/hair/half_up/female/orange.png.json","lpc/spritesheets/hair/half_up/female/purple.png.json","lpc/spritesheets/hair/half_up/female/red.png.json","lpc/spritesheets/hair/half_up/female/white.png.json","lpc/spritesheets/hair/half_up/male/black.png.json","lpc/spritesheets/hair/half_up/male/blonde.png.json","lpc/spritesheets/hair/half_up/male/blue.png.json","lpc/spritesheets/hair/half_up/male/dark_brown.png.json","lpc/spritesheets/hair/half_up/male/gold.png.json","lpc/spritesheets/hair/half_up/male/gray.png.json","lpc/spritesheets/hair/half_up/male/green.png.json","lpc/spritesheets/hair/half_up/male/light_brown.png.json","lpc/spritesheets/hair/half_up/male/orange.png.json","lpc/spritesheets/hair/half_up/male/purple.png.json","lpc/spritesheets/hair/half_up/male/red.png.json","lpc/spritesheets/hair/half_up/male/white.png.json","lpc/spritesheets/hair/halfmessy/female/black.png.json","lpc/spritesheets/hair/halfmessy/female/blonde.png.json","lpc/spritesheets/hair/halfmessy/female/blue.png.json","lpc/spritesheets/hair/halfmessy/female/dark_brown.png.json","lpc/spritesheets/hair/halfmessy/female/gold.png.json","lpc/spritesheets/hair/halfmessy/female/gray.png.json","lpc/spritesheets/hair/halfmessy/female/green.png.json","lpc/spritesheets/hair/halfmessy/female/light_brown.png.json","lpc/spritesheets/hair/halfmessy/female/orange.png.json","lpc/spritesheets/hair/halfmessy/female/purple.png.json","lpc/spritesheets/hair/halfmessy/female/red.png.json","lpc/spritesheets/hair/halfmessy/female/white.png.json","lpc/spritesheets/hair/halfmessy/male/black.png.json","lpc/spritesheets/hair/halfmessy/male/blonde.png.json","lpc/spritesheets/hair/halfmessy/male/blue.png.json","lpc/spritesheets/hair/halfmessy/male/dark_brown.png.json","lpc/spritesheets/hair/halfmessy/male/gold.png.json","lpc/spritesheets/hair/halfmessy/male/gray.png.json","lpc/spritesheets/hair/halfmessy/male/green.png.json","lpc/spritesheets/hair/halfmessy/male/light_brown.png.json","lpc/spritesheets/hair/halfmessy/male/orange.png.json","lpc/spritesheets/hair/halfmessy/male/purple.png.json","lpc/spritesheets/hair/halfmessy/male/red.png.json","lpc/spritesheets/hair/halfmessy/male/white.png.json","lpc/spritesheets/hair/high_and_tight/female/black.png.json","lpc/spritesheets/hair/high_and_tight/female/blonde.png.json","lpc/spritesheets/hair/high_and_tight/female/blue.png.json","lpc/spritesheets/hair/high_and_tight/female/dark_brown.png.json","lpc/spritesheets/hair/high_and_tight/female/gold.png.json","lpc/spritesheets/hair/high_and_tight/female/gray.png.json","lpc/spritesheets/hair/high_and_tight/female/green.png.json","lpc/spritesheets/hair/high_and_tight/female/light_brown.png.json","lpc/spritesheets/hair/high_and_tight/female/orange.png.json","lpc/spritesheets/hair/high_and_tight/female/purple.png.json","lpc/spritesheets/hair/high_and_tight/female/red.png.json","lpc/spritesheets/hair/high_and_tight/female/white.png.json","lpc/spritesheets/hair/high_and_tight/male/black.png.json","lpc/spritesheets/hair/high_and_tight/male/blonde.png.json","lpc/spritesheets/hair/high_and_tight/male/blue.png.json","lpc/spritesheets/hair/high_and_tight/male/dark_brown.png.json","lpc/spritesheets/hair/high_and_tight/male/gold.png.json","lpc/spritesheets/hair/high_and_tight/male/gray.png.json","lpc/spritesheets/hair/high_and_tight/male/green.png.json","lpc/spritesheets/hair/high_and_tight/male/light_brown.png.json","lpc/spritesheets/hair/high_and_tight/male/orange.png.json","lpc/spritesheets/hair/high_and_tight/male/purple.png.json","lpc/spritesheets/hair/high_and_tight/male/red.png.json","lpc/spritesheets/hair/high_and_tight/male/white.png.json","lpc/spritesheets/hair/high_ponytail/female/black.png.json","lpc/spritesheets/hair/high_ponytail/female/blonde.png.json","lpc/spritesheets/hair/high_ponytail/female/blue.png.json","lpc/spritesheets/hair/high_ponytail/female/dark_brown.png.json","lpc/spritesheets/hair/high_ponytail/female/gold.png.json","lpc/spritesheets/hair/high_ponytail/female/gray.png.json","lpc/spritesheets/hair/high_ponytail/female/green.png.json","lpc/spritesheets/hair/high_ponytail/female/light_brown.png.json","lpc/spritesheets/hair/high_ponytail/female/orange.png.json","lpc/spritesheets/hair/high_ponytail/female/purple.png.json","lpc/spritesheets/hair/high_ponytail/female/red.png.json","lpc/spritesheets/hair/high_ponytail/female/white.png.json","lpc/spritesheets/hair/high_ponytail/male/black.png.json","lpc/spritesheets/hair/high_ponytail/male/blonde.png.json","lpc/spritesheets/hair/high_ponytail/male/blue.png.json","lpc/spritesheets/hair/high_ponytail/male/dark_brown.png.json","lpc/spritesheets/hair/high_ponytail/male/gold.png.json","lpc/spritesheets/hair/high_ponytail/male/gray.png.json","lpc/spritesheets/hair/high_ponytail/male/green.png.json","lpc/spritesheets/hair/high_ponytail/male/light_brown.png.json","lpc/spritesheets/hair/high_ponytail/male/orange.png.json","lpc/spritesheets/hair/high_ponytail/male/purple.png.json","lpc/spritesheets/hair/high_ponytail/male/red.png.json","lpc/spritesheets/hair/high_ponytail/male/white.png.json","lpc/spritesheets/hair/idol/female/black.png.json","lpc/spritesheets/hair/idol/female/blonde.png.json","lpc/spritesheets/hair/idol/female/blue.png.json","lpc/spritesheets/hair/idol/female/dark_brown.png.json","lpc/spritesheets/hair/idol/female/gold.png.json","lpc/spritesheets/hair/idol/female/gray.png.json","lpc/spritesheets/hair/idol/female/green.png.json","lpc/spritesheets/hair/idol/female/light_brown.png.json","lpc/spritesheets/hair/idol/female/orange.png.json","lpc/spritesheets/hair/idol/female/purple.png.json","lpc/spritesheets/hair/idol/female/red.png.json","lpc/spritesheets/hair/idol/female/white.png.json","lpc/spritesheets/hair/idol/male/black.png.json","lpc/spritesheets/hair/idol/male/blonde.png.json","lpc/spritesheets/hair/idol/male/blue.png.json","lpc/spritesheets/hair/idol/male/dark_brown.png.json","lpc/spritesheets/hair/idol/male/gold.png.json","lpc/spritesheets/hair/idol/male/gray.png.json","lpc/spritesheets/hair/idol/male/green.png.json","lpc/spritesheets/hair/idol/male/light_brown.png.json","lpc/spritesheets/hair/idol/male/orange.png.json","lpc/spritesheets/hair/idol/male/purple.png.json","lpc/spritesheets/hair/idol/male/red.png.json","lpc/spritesheets/hair/idol/male/white.png.json","lpc/spritesheets/hair/jewfro/female/black.png.json","lpc/spritesheets/hair/jewfro/female/blonde.png.json","lpc/spritesheets/hair/jewfro/female/blue.png.json","lpc/spritesheets/hair/jewfro/female/dark_brown.png.json","lpc/spritesheets/hair/jewfro/female/gold.png.json","lpc/spritesheets/hair/jewfro/female/gray.png.json","lpc/spritesheets/hair/jewfro/female/green.png.json","lpc/spritesheets/hair/jewfro/female/light_brown.png.json","lpc/spritesheets/hair/jewfro/female/orange.png.json","lpc/spritesheets/hair/jewfro/female/purple.png.json","lpc/spritesheets/hair/jewfro/female/red.png.json","lpc/spritesheets/hair/jewfro/female/white.png.json","lpc/spritesheets/hair/jewfro/male/black.png.json","lpc/spritesheets/hair/jewfro/male/blonde.png.json","lpc/spritesheets/hair/jewfro/male/blue.png.json","lpc/spritesheets/hair/jewfro/male/dark_brown.png.json","lpc/spritesheets/hair/jewfro/male/gold.png.json","lpc/spritesheets/hair/jewfro/male/gray.png.json","lpc/spritesheets/hair/jewfro/male/green.png.json","lpc/spritesheets/hair/jewfro/male/light_brown.png.json","lpc/spritesheets/hair/jewfro/male/orange.png.json","lpc/spritesheets/hair/jewfro/male/purple.png.json","lpc/spritesheets/hair/jewfro/male/red.png.json","lpc/spritesheets/hair/jewfro/male/white.png.json","lpc/spritesheets/hair/lob/female/black.png.json","lpc/spritesheets/hair/lob/female/blonde.png.json","lpc/spritesheets/hair/lob/female/blue.png.json","lpc/spritesheets/hair/lob/female/dark_brown.png.json","lpc/spritesheets/hair/lob/female/gold.png.json","lpc/spritesheets/hair/lob/female/gray.png.json","lpc/spritesheets/hair/lob/female/green.png.json","lpc/spritesheets/hair/lob/female/light_brown.png.json","lpc/spritesheets/hair/lob/female/orange.png.json","lpc/spritesheets/hair/lob/female/purple.png.json","lpc/spritesheets/hair/lob/female/red.png.json","lpc/spritesheets/hair/lob/female/white.png.json","lpc/spritesheets/hair/lob/male/black.png.json","lpc/spritesheets/hair/lob/male/blonde.png.json","lpc/spritesheets/hair/lob/male/blue.png.json","lpc/spritesheets/hair/lob/male/dark_brown.png.json","lpc/spritesheets/hair/lob/male/gold.png.json","lpc/spritesheets/hair/lob/male/gray.png.json","lpc/spritesheets/hair/lob/male/green.png.json","lpc/spritesheets/hair/lob/male/light_brown.png.json","lpc/spritesheets/hair/lob/male/orange.png.json","lpc/spritesheets/hair/lob/male/purple.png.json","lpc/spritesheets/hair/lob/male/red.png.json","lpc/spritesheets/hair/lob/male/white.png.json","lpc/spritesheets/hair/long/female/black.png.json","lpc/spritesheets/hair/long/female/blonde.png.json","lpc/spritesheets/hair/long/female/blue.png.json","lpc/spritesheets/hair/long/female/dark_brown.png.json","lpc/spritesheets/hair/long/female/gold.png.json","lpc/spritesheets/hair/long/female/gray.png.json","lpc/spritesheets/hair/long/female/green.png.json","lpc/spritesheets/hair/long/female/light_brown.png.json","lpc/spritesheets/hair/long/female/orange.png.json","lpc/spritesheets/hair/long/female/purple.png.json","lpc/spritesheets/hair/long/female/red.png.json","lpc/spritesheets/hair/long/female/white.png.json","lpc/spritesheets/hair/long/male/black.png.json","lpc/spritesheets/hair/long/male/blonde.png.json","lpc/spritesheets/hair/long/male/blue.png.json","lpc/spritesheets/hair/long/male/dark_brown.png.json","lpc/spritesheets/hair/long/male/gold.png.json","lpc/spritesheets/hair/long/male/gray.png.json","lpc/spritesheets/hair/long/male/green.png.json","lpc/spritesheets/hair/long/male/light_brown.png.json","lpc/spritesheets/hair/long/male/orange.png.json","lpc/spritesheets/hair/long/male/purple.png.json","lpc/spritesheets/hair/long/male/red.png.json","lpc/spritesheets/hair/long/male/white.png.json","lpc/spritesheets/hair/long_band/female/black.png.json","lpc/spritesheets/hair/long_band/female/blonde.png.json","lpc/spritesheets/hair/long_band/female/blue.png.json","lpc/spritesheets/hair/long_band/female/dark_brown.png.json","lpc/spritesheets/hair/long_band/female/gold.png.json","lpc/spritesheets/hair/long_band/female/gray.png.json","lpc/spritesheets/hair/long_band/female/green.png.json","lpc/spritesheets/hair/long_band/female/light_brown.png.json","lpc/spritesheets/hair/long_band/female/orange.png.json","lpc/spritesheets/hair/long_band/female/purple.png.json","lpc/spritesheets/hair/long_band/female/red.png.json","lpc/spritesheets/hair/long_band/female/white.png.json","lpc/spritesheets/hair/long_center_part/female/black.png.json","lpc/spritesheets/hair/long_center_part/female/blonde.png.json","lpc/spritesheets/hair/long_center_part/female/blue.png.json","lpc/spritesheets/hair/long_center_part/female/dark_brown.png.json","lpc/spritesheets/hair/long_center_part/female/gold.png.json","lpc/spritesheets/hair/long_center_part/female/gray.png.json","lpc/spritesheets/hair/long_center_part/female/green.png.json","lpc/spritesheets/hair/long_center_part/female/light_brown.png.json","lpc/spritesheets/hair/long_center_part/female/orange.png.json","lpc/spritesheets/hair/long_center_part/female/purple.png.json","lpc/spritesheets/hair/long_center_part/female/red.png.json","lpc/spritesheets/hair/long_center_part/female/white.png.json","lpc/spritesheets/hair/long_center_part/male/black.png.json","lpc/spritesheets/hair/long_center_part/male/blonde.png.json","lpc/spritesheets/hair/long_center_part/male/blue.png.json","lpc/spritesheets/hair/long_center_part/male/dark_brown.png.json","lpc/spritesheets/hair/long_center_part/male/gold.png.json","lpc/spritesheets/hair/long_center_part/male/gray.png.json","lpc/spritesheets/hair/long_center_part/male/green.png.json","lpc/spritesheets/hair/long_center_part/male/light_brown.png.json","lpc/spritesheets/hair/long_center_part/male/orange.png.json","lpc/spritesheets/hair/long_center_part/male/purple.png.json","lpc/spritesheets/hair/long_center_part/male/red.png.json","lpc/spritesheets/hair/long_center_part/male/white.png.json","lpc/spritesheets/hair/long_messy/female/black.png.json","lpc/spritesheets/hair/long_messy/female/blonde.png.json","lpc/spritesheets/hair/long_messy/female/blue.png.json","lpc/spritesheets/hair/long_messy/female/dark_brown.png.json","lpc/spritesheets/hair/long_messy/female/gold.png.json","lpc/spritesheets/hair/long_messy/female/gray.png.json","lpc/spritesheets/hair/long_messy/female/green.png.json","lpc/spritesheets/hair/long_messy/female/light_brown.png.json","lpc/spritesheets/hair/long_messy/female/orange.png.json","lpc/spritesheets/hair/long_messy/female/purple.png.json","lpc/spritesheets/hair/long_messy/female/red.png.json","lpc/spritesheets/hair/long_messy/female/white.png.json","lpc/spritesheets/hair/long_messy/male/black.png.json","lpc/spritesheets/hair/long_messy/male/blonde.png.json","lpc/spritesheets/hair/long_messy/male/blue.png.json","lpc/spritesheets/hair/long_messy/male/dark_brown.png.json","lpc/spritesheets/hair/long_messy/male/gold.png.json","lpc/spritesheets/hair/long_messy/male/gray.png.json","lpc/spritesheets/hair/long_messy/male/green.png.json","lpc/spritesheets/hair/long_messy/male/light_brown.png.json","lpc/spritesheets/hair/long_messy/male/orange.png.json","lpc/spritesheets/hair/long_messy/male/purple.png.json","lpc/spritesheets/hair/long_messy/male/red.png.json","lpc/spritesheets/hair/long_messy/male/white.png.json","lpc/spritesheets/hair/long_messy2/female/black.png.json","lpc/spritesheets/hair/long_messy2/female/blonde.png.json","lpc/spritesheets/hair/long_messy2/female/blue.png.json","lpc/spritesheets/hair/long_messy2/female/dark_brown.png.json","lpc/spritesheets/hair/long_messy2/female/gold.png.json","lpc/spritesheets/hair/long_messy2/female/gray.png.json","lpc/spritesheets/hair/long_messy2/female/green.png.json","lpc/spritesheets/hair/long_messy2/female/light_brown.png.json","lpc/spritesheets/hair/long_messy2/female/orange.png.json","lpc/spritesheets/hair/long_messy2/female/purple.png.json","lpc/spritesheets/hair/long_messy2/female/red.png.json","lpc/spritesheets/hair/long_messy2/female/white.png.json","lpc/spritesheets/hair/long_messy2/male/black.png.json","lpc/spritesheets/hair/long_messy2/male/blonde.png.json","lpc/spritesheets/hair/long_messy2/male/blue.png.json","lpc/spritesheets/hair/long_messy2/male/dark_brown.png.json","lpc/spritesheets/hair/long_messy2/male/gold.png.json","lpc/spritesheets/hair/long_messy2/male/gray.png.json","lpc/spritesheets/hair/long_messy2/male/green.png.json","lpc/spritesheets/hair/long_messy2/male/light_brown.png.json","lpc/spritesheets/hair/long_messy2/male/orange.png.json","lpc/spritesheets/hair/long_messy2/male/purple.png.json","lpc/spritesheets/hair/long_messy2/male/red.png.json","lpc/spritesheets/hair/long_messy2/male/white.png.json","lpc/spritesheets/hair/long_tied/female/black.png.json","lpc/spritesheets/hair/long_tied/female/blonde.png.json","lpc/spritesheets/hair/long_tied/female/blue.png.json","lpc/spritesheets/hair/long_tied/female/dark_brown.png.json","lpc/spritesheets/hair/long_tied/female/gold.png.json","lpc/spritesheets/hair/long_tied/female/gray.png.json","lpc/spritesheets/hair/long_tied/female/green.png.json","lpc/spritesheets/hair/long_tied/female/light_brown.png.json","lpc/spritesheets/hair/long_tied/female/orange.png.json","lpc/spritesheets/hair/long_tied/female/purple.png.json","lpc/spritesheets/hair/long_tied/female/red.png.json","lpc/spritesheets/hair/long_tied/female/white.png.json","lpc/spritesheets/hair/long_tied/male/black.png.json","lpc/spritesheets/hair/long_tied/male/blonde.png.json","lpc/spritesheets/hair/long_tied/male/blue.png.json","lpc/spritesheets/hair/long_tied/male/dark_brown.png.json","lpc/spritesheets/hair/long_tied/male/gold.png.json","lpc/spritesheets/hair/long_tied/male/gray.png.json","lpc/spritesheets/hair/long_tied/male/green.png.json","lpc/spritesheets/hair/long_tied/male/light_brown.png.json","lpc/spritesheets/hair/long_tied/male/orange.png.json","lpc/spritesheets/hair/long_tied/male/purple.png.json","lpc/spritesheets/hair/long_tied/male/red.png.json","lpc/spritesheets/hair/long_tied/male/white.png.json","lpc/spritesheets/hair/longhawk/female/black.png.json","lpc/spritesheets/hair/longhawk/female/blonde.png.json","lpc/spritesheets/hair/longhawk/female/blue.png.json","lpc/spritesheets/hair/longhawk/female/dark_brown.png.json","lpc/spritesheets/hair/longhawk/female/gold.png.json","lpc/spritesheets/hair/longhawk/female/gray.png.json","lpc/spritesheets/hair/longhawk/female/green.png.json","lpc/spritesheets/hair/longhawk/female/light_brown.png.json","lpc/spritesheets/hair/longhawk/female/orange.png.json","lpc/spritesheets/hair/longhawk/female/purple.png.json","lpc/spritesheets/hair/longhawk/female/red.png.json","lpc/spritesheets/hair/longhawk/female/white.png.json","lpc/spritesheets/hair/longhawk/male/black.png.json","lpc/spritesheets/hair/longhawk/male/blonde.png.json","lpc/spritesheets/hair/longhawk/male/blue.png.json","lpc/spritesheets/hair/longhawk/male/dark_brown.png.json","lpc/spritesheets/hair/longhawk/male/gold.png.json","lpc/spritesheets/hair/longhawk/male/gray.png.json","lpc/spritesheets/hair/longhawk/male/green.png.json","lpc/spritesheets/hair/longhawk/male/light_brown.png.json","lpc/spritesheets/hair/longhawk/male/orange.png.json","lpc/spritesheets/hair/longhawk/male/purple.png.json","lpc/spritesheets/hair/longhawk/male/red.png.json","lpc/spritesheets/hair/longhawk/male/white.png.json","lpc/spritesheets/hair/longknot/female/black.png.json","lpc/spritesheets/hair/longknot/female/blonde.png.json","lpc/spritesheets/hair/longknot/female/blue.png.json","lpc/spritesheets/hair/longknot/female/dark_brown.png.json","lpc/spritesheets/hair/longknot/female/gold.png.json","lpc/spritesheets/hair/longknot/female/gray.png.json","lpc/spritesheets/hair/longknot/female/green.png.json","lpc/spritesheets/hair/longknot/female/light_brown.png.json","lpc/spritesheets/hair/longknot/female/orange.png.json","lpc/spritesheets/hair/longknot/female/purple.png.json","lpc/spritesheets/hair/longknot/female/red.png.json","lpc/spritesheets/hair/longknot/female/white.png.json","lpc/spritesheets/hair/longknot/male/black.png.json","lpc/spritesheets/hair/longknot/male/blonde.png.json","lpc/spritesheets/hair/longknot/male/blue.png.json","lpc/spritesheets/hair/longknot/male/dark_brown.png.json","lpc/spritesheets/hair/longknot/male/gold.png.json","lpc/spritesheets/hair/longknot/male/gray.png.json","lpc/spritesheets/hair/longknot/male/green.png.json","lpc/spritesheets/hair/longknot/male/light_brown.png.json","lpc/spritesheets/hair/longknot/male/orange.png.json","lpc/spritesheets/hair/longknot/male/purple.png.json","lpc/spritesheets/hair/longknot/male/red.png.json","lpc/spritesheets/hair/longknot/male/white.png.json","lpc/spritesheets/hair/loose/female/black.png.json","lpc/spritesheets/hair/loose/female/blonde.png.json","lpc/spritesheets/hair/loose/female/blue.png.json","lpc/spritesheets/hair/loose/female/dark_brown.png.json","lpc/spritesheets/hair/loose/female/gold.png.json","lpc/spritesheets/hair/loose/female/gray.png.json","lpc/spritesheets/hair/loose/female/green.png.json","lpc/spritesheets/hair/loose/female/light_brown.png.json","lpc/spritesheets/hair/loose/female/orange.png.json","lpc/spritesheets/hair/loose/female/purple.png.json","lpc/spritesheets/hair/loose/female/red.png.json","lpc/spritesheets/hair/loose/female/white.png.json","lpc/spritesheets/hair/loose/male/black.png.json","lpc/spritesheets/hair/loose/male/blonde.png.json","lpc/spritesheets/hair/loose/male/blue.png.json","lpc/spritesheets/hair/loose/male/dark_brown.png.json","lpc/spritesheets/hair/loose/male/gold.png.json","lpc/spritesheets/hair/loose/male/gray.png.json","lpc/spritesheets/hair/loose/male/green.png.json","lpc/spritesheets/hair/loose/male/light_brown.png.json","lpc/spritesheets/hair/loose/male/orange.png.json","lpc/spritesheets/hair/loose/male/purple.png.json","lpc/spritesheets/hair/loose/male/red.png.json","lpc/spritesheets/hair/loose/male/white.png.json","lpc/spritesheets/hair/messy1/female/black.png.json","lpc/spritesheets/hair/messy1/female/blonde.png.json","lpc/spritesheets/hair/messy1/female/blue.png.json","lpc/spritesheets/hair/messy1/female/dark_brown.png.json","lpc/spritesheets/hair/messy1/female/gold.png.json","lpc/spritesheets/hair/messy1/female/gray.png.json","lpc/spritesheets/hair/messy1/female/green.png.json","lpc/spritesheets/hair/messy1/female/light_brown.png.json","lpc/spritesheets/hair/messy1/female/orange.png.json","lpc/spritesheets/hair/messy1/female/purple.png.json","lpc/spritesheets/hair/messy1/female/red.png.json","lpc/spritesheets/hair/messy1/female/white.png.json","lpc/spritesheets/hair/messy1/male/black.png.json","lpc/spritesheets/hair/messy1/male/blonde.png.json","lpc/spritesheets/hair/messy1/male/blue.png.json","lpc/spritesheets/hair/messy1/male/dark_brown.png.json","lpc/spritesheets/hair/messy1/male/gold.png.json","lpc/spritesheets/hair/messy1/male/gray.png.json","lpc/spritesheets/hair/messy1/male/green.png.json","lpc/spritesheets/hair/messy1/male/light_brown.png.json","lpc/spritesheets/hair/messy1/male/orange.png.json","lpc/spritesheets/hair/messy1/male/purple.png.json","lpc/spritesheets/hair/messy1/male/red.png.json","lpc/spritesheets/hair/messy1/male/white.png.json","lpc/spritesheets/hair/messy2/female/black.png.json","lpc/spritesheets/hair/messy2/female/blonde.png.json","lpc/spritesheets/hair/messy2/female/blue.png.json","lpc/spritesheets/hair/messy2/female/dark_brown.png.json","lpc/spritesheets/hair/messy2/female/gold.png.json","lpc/spritesheets/hair/messy2/female/gray.png.json","lpc/spritesheets/hair/messy2/female/green.png.json","lpc/spritesheets/hair/messy2/female/light_brown.png.json","lpc/spritesheets/hair/messy2/female/orange.png.json","lpc/spritesheets/hair/messy2/female/purple.png.json","lpc/spritesheets/hair/messy2/female/red.png.json","lpc/spritesheets/hair/messy2/female/white.png.json","lpc/spritesheets/hair/messy2/male/black.png.json","lpc/spritesheets/hair/messy2/male/blonde.png.json","lpc/spritesheets/hair/messy2/male/blue.png.json","lpc/spritesheets/hair/messy2/male/dark_brown.png.json","lpc/spritesheets/hair/messy2/male/gold.png.json","lpc/spritesheets/hair/messy2/male/gray.png.json","lpc/spritesheets/hair/messy2/male/green.png.json","lpc/spritesheets/hair/messy2/male/light_brown.png.json","lpc/spritesheets/hair/messy2/male/orange.png.json","lpc/spritesheets/hair/messy2/male/purple.png.json","lpc/spritesheets/hair/messy2/male/red.png.json","lpc/spritesheets/hair/messy2/male/white.png.json","lpc/spritesheets/hair/messy3/female/black.png.json","lpc/spritesheets/hair/messy3/female/blonde.png.json","lpc/spritesheets/hair/messy3/female/blue.png.json","lpc/spritesheets/hair/messy3/female/dark_brown.png.json","lpc/spritesheets/hair/messy3/female/gold.png.json","lpc/spritesheets/hair/messy3/female/gray.png.json","lpc/spritesheets/hair/messy3/female/green.png.json","lpc/spritesheets/hair/messy3/female/light_brown.png.json","lpc/spritesheets/hair/messy3/female/orange.png.json","lpc/spritesheets/hair/messy3/female/purple.png.json","lpc/spritesheets/hair/messy3/female/red.png.json","lpc/spritesheets/hair/messy3/female/white.png.json","lpc/spritesheets/hair/messy3/male/black.png.json","lpc/spritesheets/hair/messy3/male/blonde.png.json","lpc/spritesheets/hair/messy3/male/blue.png.json","lpc/spritesheets/hair/messy3/male/dark_brown.png.json","lpc/spritesheets/hair/messy3/male/gold.png.json","lpc/spritesheets/hair/messy3/male/gray.png.json","lpc/spritesheets/hair/messy3/male/green.png.json","lpc/spritesheets/hair/messy3/male/light_brown.png.json","lpc/spritesheets/hair/messy3/male/orange.png.json","lpc/spritesheets/hair/messy3/male/purple.png.json","lpc/spritesheets/hair/messy3/male/red.png.json","lpc/spritesheets/hair/messy3/male/white.png.json","lpc/spritesheets/hair/mop/female/black.png.json","lpc/spritesheets/hair/mop/female/blonde.png.json","lpc/spritesheets/hair/mop/female/blue.png.json","lpc/spritesheets/hair/mop/female/dark_brown.png.json","lpc/spritesheets/hair/mop/female/gold.png.json","lpc/spritesheets/hair/mop/female/gray.png.json","lpc/spritesheets/hair/mop/female/green.png.json","lpc/spritesheets/hair/mop/female/light_brown.png.json","lpc/spritesheets/hair/mop/female/orange.png.json","lpc/spritesheets/hair/mop/female/purple.png.json","lpc/spritesheets/hair/mop/female/red.png.json","lpc/spritesheets/hair/mop/female/white.png.json","lpc/spritesheets/hair/mop/male/black.png.json","lpc/spritesheets/hair/mop/male/blonde.png.json","lpc/spritesheets/hair/mop/male/blue.png.json","lpc/spritesheets/hair/mop/male/dark_brown.png.json","lpc/spritesheets/hair/mop/male/gold.png.json","lpc/spritesheets/hair/mop/male/gray.png.json","lpc/spritesheets/hair/mop/male/green.png.json","lpc/spritesheets/hair/mop/male/light_brown.png.json","lpc/spritesheets/hair/mop/male/orange.png.json","lpc/spritesheets/hair/mop/male/purple.png.json","lpc/spritesheets/hair/mop/male/red.png.json","lpc/spritesheets/hair/mop/male/white.png.json","lpc/spritesheets/hair/natural/female/black.png.json","lpc/spritesheets/hair/natural/female/blonde.png.json","lpc/spritesheets/hair/natural/female/blue.png.json","lpc/spritesheets/hair/natural/female/dark_brown.png.json","lpc/spritesheets/hair/natural/female/gold.png.json","lpc/spritesheets/hair/natural/female/gray.png.json","lpc/spritesheets/hair/natural/female/green.png.json","lpc/spritesheets/hair/natural/female/light_brown.png.json","lpc/spritesheets/hair/natural/female/orange.png.json","lpc/spritesheets/hair/natural/female/purple.png.json","lpc/spritesheets/hair/natural/female/red.png.json","lpc/spritesheets/hair/natural/female/white.png.json","lpc/spritesheets/hair/natural/male/black.png.json","lpc/spritesheets/hair/natural/male/blonde.png.json","lpc/spritesheets/hair/natural/male/blue.png.json","lpc/spritesheets/hair/natural/male/dark_brown.png.json","lpc/spritesheets/hair/natural/male/gold.png.json","lpc/spritesheets/hair/natural/male/gray.png.json","lpc/spritesheets/hair/natural/male/green.png.json","lpc/spritesheets/hair/natural/male/light_brown.png.json","lpc/spritesheets/hair/natural/male/orange.png.json","lpc/spritesheets/hair/natural/male/purple.png.json","lpc/spritesheets/hair/natural/male/red.png.json","lpc/spritesheets/hair/natural/male/white.png.json","lpc/spritesheets/hair/page/female/black.png.json","lpc/spritesheets/hair/page/female/blonde.png.json","lpc/spritesheets/hair/page/female/blue.png.json","lpc/spritesheets/hair/page/female/dark_brown.png.json","lpc/spritesheets/hair/page/female/gold.png.json","lpc/spritesheets/hair/page/female/gray.png.json","lpc/spritesheets/hair/page/female/green.png.json","lpc/spritesheets/hair/page/female/light_brown.png.json","lpc/spritesheets/hair/page/female/orange.png.json","lpc/spritesheets/hair/page/female/purple.png.json","lpc/spritesheets/hair/page/female/red.png.json","lpc/spritesheets/hair/page/female/white.png.json","lpc/spritesheets/hair/page/male/black.png.json","lpc/spritesheets/hair/page/male/blonde.png.json","lpc/spritesheets/hair/page/male/blue.png.json","lpc/spritesheets/hair/page/male/dark_brown.png.json","lpc/spritesheets/hair/page/male/gold.png.json","lpc/spritesheets/hair/page/male/gray.png.json","lpc/spritesheets/hair/page/male/green.png.json","lpc/spritesheets/hair/page/male/light_brown.png.json","lpc/spritesheets/hair/page/male/orange.png.json","lpc/spritesheets/hair/page/male/purple.png.json","lpc/spritesheets/hair/page/male/red.png.json","lpc/spritesheets/hair/page/male/white.png.json","lpc/spritesheets/hair/page2/female/black.png.json","lpc/spritesheets/hair/page2/female/blonde.png.json","lpc/spritesheets/hair/page2/female/blue.png.json","lpc/spritesheets/hair/page2/female/dark_brown.png.json","lpc/spritesheets/hair/page2/female/gold.png.json","lpc/spritesheets/hair/page2/female/gray.png.json","lpc/spritesheets/hair/page2/female/green.png.json","lpc/spritesheets/hair/page2/female/light_brown.png.json","lpc/spritesheets/hair/page2/female/orange.png.json","lpc/spritesheets/hair/page2/female/purple.png.json","lpc/spritesheets/hair/page2/female/red.png.json","lpc/spritesheets/hair/page2/female/white.png.json","lpc/spritesheets/hair/page2/male/black.png.json","lpc/spritesheets/hair/page2/male/blonde.png.json","lpc/spritesheets/hair/page2/male/blue.png.json","lpc/spritesheets/hair/page2/male/dark_brown.png.json","lpc/spritesheets/hair/page2/male/gold.png.json","lpc/spritesheets/hair/page2/male/gray.png.json","lpc/spritesheets/hair/page2/male/green.png.json","lpc/spritesheets/hair/page2/male/light_brown.png.json","lpc/spritesheets/hair/page2/male/orange.png.json","lpc/spritesheets/hair/page2/male/purple.png.json","lpc/spritesheets/hair/page2/male/red.png.json","lpc/spritesheets/hair/page2/male/white.png.json","lpc/spritesheets/hair/part2/female/black.png.json","lpc/spritesheets/hair/part2/female/blonde.png.json","lpc/spritesheets/hair/part2/female/blue.png.json","lpc/spritesheets/hair/part2/female/dark_brown.png.json","lpc/spritesheets/hair/part2/female/gold.png.json","lpc/spritesheets/hair/part2/female/gray.png.json","lpc/spritesheets/hair/part2/female/green.png.json","lpc/spritesheets/hair/part2/female/light_brown.png.json","lpc/spritesheets/hair/part2/female/orange.png.json","lpc/spritesheets/hair/part2/female/purple.png.json","lpc/spritesheets/hair/part2/female/red.png.json","lpc/spritesheets/hair/part2/female/white.png.json","lpc/spritesheets/hair/part2/male/black.png.json","lpc/spritesheets/hair/part2/male/blonde.png.json","lpc/spritesheets/hair/part2/male/blue.png.json","lpc/spritesheets/hair/part2/male/dark_brown.png.json","lpc/spritesheets/hair/part2/male/gold.png.json","lpc/spritesheets/hair/part2/male/gray.png.json","lpc/spritesheets/hair/part2/male/green.png.json","lpc/spritesheets/hair/part2/male/light_brown.png.json","lpc/spritesheets/hair/part2/male/orange.png.json","lpc/spritesheets/hair/part2/male/purple.png.json","lpc/spritesheets/hair/part2/male/red.png.json","lpc/spritesheets/hair/part2/male/white.png.json","lpc/spritesheets/hair/parted/female/black.png.json","lpc/spritesheets/hair/parted/female/blonde.png.json","lpc/spritesheets/hair/parted/female/blue.png.json","lpc/spritesheets/hair/parted/female/dark_brown.png.json","lpc/spritesheets/hair/parted/female/gold.png.json","lpc/spritesheets/hair/parted/female/gray.png.json","lpc/spritesheets/hair/parted/female/green.png.json","lpc/spritesheets/hair/parted/female/light_brown.png.json","lpc/spritesheets/hair/parted/female/orange.png.json","lpc/spritesheets/hair/parted/female/purple.png.json","lpc/spritesheets/hair/parted/female/red.png.json","lpc/spritesheets/hair/parted/female/white.png.json","lpc/spritesheets/hair/parted/male/black.png.json","lpc/spritesheets/hair/parted/male/blonde.png.json","lpc/spritesheets/hair/parted/male/blue.png.json","lpc/spritesheets/hair/parted/male/dark_brown.png.json","lpc/spritesheets/hair/parted/male/gold.png.json","lpc/spritesheets/hair/parted/male/gray.png.json","lpc/spritesheets/hair/parted/male/green.png.json","lpc/spritesheets/hair/parted/male/light_brown.png.json","lpc/spritesheets/hair/parted/male/orange.png.json","lpc/spritesheets/hair/parted/male/purple.png.json","lpc/spritesheets/hair/parted/male/red.png.json","lpc/spritesheets/hair/parted/male/white.png.json","lpc/spritesheets/hair/pixie/female/black.png.json","lpc/spritesheets/hair/pixie/female/blonde.png.json","lpc/spritesheets/hair/pixie/female/blue.png.json","lpc/spritesheets/hair/pixie/female/dark_brown.png.json","lpc/spritesheets/hair/pixie/female/gold.png.json","lpc/spritesheets/hair/pixie/female/gray.png.json","lpc/spritesheets/hair/pixie/female/green.png.json","lpc/spritesheets/hair/pixie/female/light_brown.png.json","lpc/spritesheets/hair/pixie/female/orange.png.json","lpc/spritesheets/hair/pixie/female/purple.png.json","lpc/spritesheets/hair/pixie/female/red.png.json","lpc/spritesheets/hair/pixie/female/white.png.json","lpc/spritesheets/hair/pixie/male/black.png.json","lpc/spritesheets/hair/pixie/male/blonde.png.json","lpc/spritesheets/hair/pixie/male/blue.png.json","lpc/spritesheets/hair/pixie/male/dark_brown.png.json","lpc/spritesheets/hair/pixie/male/gold.png.json","lpc/spritesheets/hair/pixie/male/gray.png.json","lpc/spritesheets/hair/pixie/male/green.png.json","lpc/spritesheets/hair/pixie/male/light_brown.png.json","lpc/spritesheets/hair/pixie/male/orange.png.json","lpc/spritesheets/hair/pixie/male/purple.png.json","lpc/spritesheets/hair/pixie/male/red.png.json","lpc/spritesheets/hair/pixie/male/white.png.json","lpc/spritesheets/hair/plain/female/black.png.json","lpc/spritesheets/hair/plain/female/blonde.png.json","lpc/spritesheets/hair/plain/female/blue.png.json","lpc/spritesheets/hair/plain/female/dark_brown.png.json","lpc/spritesheets/hair/plain/female/gold.png.json","lpc/spritesheets/hair/plain/female/gray.png.json","lpc/spritesheets/hair/plain/female/green.png.json","lpc/spritesheets/hair/plain/female/light_brown.png.json","lpc/spritesheets/hair/plain/female/orange.png.json","lpc/spritesheets/hair/plain/female/purple.png.json","lpc/spritesheets/hair/plain/female/red.png.json","lpc/spritesheets/hair/plain/female/white.png.json","lpc/spritesheets/hair/plain/male/black.png.json","lpc/spritesheets/hair/plain/male/blonde.png.json","lpc/spritesheets/hair/plain/male/blue.png.json","lpc/spritesheets/hair/plain/male/dark_brown.png.json","lpc/spritesheets/hair/plain/male/gold.png.json","lpc/spritesheets/hair/plain/male/gray.png.json","lpc/spritesheets/hair/plain/male/green.png.json","lpc/spritesheets/hair/plain/male/light_brown.png.json","lpc/spritesheets/hair/plain/male/orange.png.json","lpc/spritesheets/hair/plain/male/purple.png.json","lpc/spritesheets/hair/plain/male/red.png.json","lpc/spritesheets/hair/plain/male/white.png.json","lpc/spritesheets/hair/ponytail/female/black.png.json","lpc/spritesheets/hair/ponytail/female/blonde.png.json","lpc/spritesheets/hair/ponytail/female/blue.png.json","lpc/spritesheets/hair/ponytail/female/dark_brown.png.json","lpc/spritesheets/hair/ponytail/female/gold.png.json","lpc/spritesheets/hair/ponytail/female/gray.png.json","lpc/spritesheets/hair/ponytail/female/green.png.json","lpc/spritesheets/hair/ponytail/female/light_brown.png.json","lpc/spritesheets/hair/ponytail/female/orange.png.json","lpc/spritesheets/hair/ponytail/female/purple.png.json","lpc/spritesheets/hair/ponytail/female/red.png.json","lpc/spritesheets/hair/ponytail/female/white.png.json","lpc/spritesheets/hair/ponytail/male/black.png.json","lpc/spritesheets/hair/ponytail/male/blonde.png.json","lpc/spritesheets/hair/ponytail/male/blue.png.json","lpc/spritesheets/hair/ponytail/male/dark_brown.png.json","lpc/spritesheets/hair/ponytail/male/gold.png.json","lpc/spritesheets/hair/ponytail/male/gray.png.json","lpc/spritesheets/hair/ponytail/male/green.png.json","lpc/spritesheets/hair/ponytail/male/light_brown.png.json","lpc/spritesheets/hair/ponytail/male/orange.png.json","lpc/spritesheets/hair/ponytail/male/purple.png.json","lpc/spritesheets/hair/ponytail/male/red.png.json","lpc/spritesheets/hair/ponytail/male/white.png.json","lpc/spritesheets/hair/ponytail2/female/black.png.json","lpc/spritesheets/hair/ponytail2/female/blonde.png.json","lpc/spritesheets/hair/ponytail2/female/blue.png.json","lpc/spritesheets/hair/ponytail2/female/dark_brown.png.json","lpc/spritesheets/hair/ponytail2/female/gold.png.json","lpc/spritesheets/hair/ponytail2/female/gray.png.json","lpc/spritesheets/hair/ponytail2/female/green.png.json","lpc/spritesheets/hair/ponytail2/female/light_brown.png.json","lpc/spritesheets/hair/ponytail2/female/orange.png.json","lpc/spritesheets/hair/ponytail2/female/purple.png.json","lpc/spritesheets/hair/ponytail2/female/red.png.json","lpc/spritesheets/hair/ponytail2/female/white.png.json","lpc/spritesheets/hair/ponytail2/male/black.png.json","lpc/spritesheets/hair/ponytail2/male/blonde.png.json","lpc/spritesheets/hair/ponytail2/male/blue.png.json","lpc/spritesheets/hair/ponytail2/male/dark_brown.png.json","lpc/spritesheets/hair/ponytail2/male/gold.png.json","lpc/spritesheets/hair/ponytail2/male/gray.png.json","lpc/spritesheets/hair/ponytail2/male/green.png.json","lpc/spritesheets/hair/ponytail2/male/light_brown.png.json","lpc/spritesheets/hair/ponytail2/male/orange.png.json","lpc/spritesheets/hair/ponytail2/male/purple.png.json","lpc/spritesheets/hair/ponytail2/male/red.png.json","lpc/spritesheets/hair/ponytail2/male/white.png.json","lpc/spritesheets/hair/princess/female/black.png.json","lpc/spritesheets/hair/princess/female/blonde.png.json","lpc/spritesheets/hair/princess/female/blue.png.json","lpc/spritesheets/hair/princess/female/dark_brown.png.json","lpc/spritesheets/hair/princess/female/gold.png.json","lpc/spritesheets/hair/princess/female/gray.png.json","lpc/spritesheets/hair/princess/female/green.png.json","lpc/spritesheets/hair/princess/female/light_brown.png.json","lpc/spritesheets/hair/princess/female/orange.png.json","lpc/spritesheets/hair/princess/female/purple.png.json","lpc/spritesheets/hair/princess/female/red.png.json","lpc/spritesheets/hair/princess/female/white.png.json","lpc/spritesheets/hair/sara/female/black.png.json","lpc/spritesheets/hair/sara/female/blonde.png.json","lpc/spritesheets/hair/sara/female/blue.png.json","lpc/spritesheets/hair/sara/female/dark_brown.png.json","lpc/spritesheets/hair/sara/female/gold.png.json","lpc/spritesheets/hair/sara/female/gray.png.json","lpc/spritesheets/hair/sara/female/green.png.json","lpc/spritesheets/hair/sara/female/light_brown.png.json","lpc/spritesheets/hair/sara/female/orange.png.json","lpc/spritesheets/hair/sara/female/purple.png.json","lpc/spritesheets/hair/sara/female/red.png.json","lpc/spritesheets/hair/sara/female/white.png.json","lpc/spritesheets/hair/shorthawk/female/black.png.json","lpc/spritesheets/hair/shorthawk/female/blonde.png.json","lpc/spritesheets/hair/shorthawk/female/blue.png.json","lpc/spritesheets/hair/shorthawk/female/dark_brown.png.json","lpc/spritesheets/hair/shorthawk/female/gold.png.json","lpc/spritesheets/hair/shorthawk/female/gray.png.json","lpc/spritesheets/hair/shorthawk/female/green.png.json","lpc/spritesheets/hair/shorthawk/female/light_brown.png.json","lpc/spritesheets/hair/shorthawk/female/orange.png.json","lpc/spritesheets/hair/shorthawk/female/purple.png.json","lpc/spritesheets/hair/shorthawk/female/red.png.json","lpc/spritesheets/hair/shorthawk/female/white.png.json","lpc/spritesheets/hair/shorthawk/male/black.png.json","lpc/spritesheets/hair/shorthawk/male/blonde.png.json","lpc/spritesheets/hair/shorthawk/male/blue.png.json","lpc/spritesheets/hair/shorthawk/male/dark_brown.png.json","lpc/spritesheets/hair/shorthawk/male/gold.png.json","lpc/spritesheets/hair/shorthawk/male/gray.png.json","lpc/spritesheets/hair/shorthawk/male/green.png.json","lpc/spritesheets/hair/shorthawk/male/light_brown.png.json","lpc/spritesheets/hair/shorthawk/male/orange.png.json","lpc/spritesheets/hair/shorthawk/male/purple.png.json","lpc/spritesheets/hair/shorthawk/male/red.png.json","lpc/spritesheets/hair/shorthawk/male/white.png.json","lpc/spritesheets/hair/shortknot/female/black.png.json","lpc/spritesheets/hair/shortknot/female/blonde.png.json","lpc/spritesheets/hair/shortknot/female/blue.png.json","lpc/spritesheets/hair/shortknot/female/dark_brown.png.json","lpc/spritesheets/hair/shortknot/female/gold.png.json","lpc/spritesheets/hair/shortknot/female/gray.png.json","lpc/spritesheets/hair/shortknot/female/green.png.json","lpc/spritesheets/hair/shortknot/female/light_brown.png.json","lpc/spritesheets/hair/shortknot/female/orange.png.json","lpc/spritesheets/hair/shortknot/female/purple.png.json","lpc/spritesheets/hair/shortknot/female/red.png.json","lpc/spritesheets/hair/shortknot/female/white.png.json","lpc/spritesheets/hair/shortknot/male/black.png.json","lpc/spritesheets/hair/shortknot/male/blonde.png.json","lpc/spritesheets/hair/shortknot/male/blue.png.json","lpc/spritesheets/hair/shortknot/male/dark_brown.png.json","lpc/spritesheets/hair/shortknot/male/gold.png.json","lpc/spritesheets/hair/shortknot/male/gray.png.json","lpc/spritesheets/hair/shortknot/male/green.png.json","lpc/spritesheets/hair/shortknot/male/light_brown.png.json","lpc/spritesheets/hair/shortknot/male/orange.png.json","lpc/spritesheets/hair/shortknot/male/purple.png.json","lpc/spritesheets/hair/shortknot/male/red.png.json","lpc/spritesheets/hair/shortknot/male/white.png.json","lpc/spritesheets/hair/shoulderl/female/black.png.json","lpc/spritesheets/hair/shoulderl/female/blonde.png.json","lpc/spritesheets/hair/shoulderl/female/blue.png.json","lpc/spritesheets/hair/shoulderl/female/dark_brown.png.json","lpc/spritesheets/hair/shoulderl/female/gold.png.json","lpc/spritesheets/hair/shoulderl/female/gray.png.json","lpc/spritesheets/hair/shoulderl/female/green.png.json","lpc/spritesheets/hair/shoulderl/female/light_brown.png.json","lpc/spritesheets/hair/shoulderl/female/orange.png.json","lpc/spritesheets/hair/shoulderl/female/purple.png.json","lpc/spritesheets/hair/shoulderl/female/red.png.json","lpc/spritesheets/hair/shoulderl/female/white.png.json","lpc/spritesheets/hair/shoulderr/female/black.png.json","lpc/spritesheets/hair/shoulderr/female/blonde.png.json","lpc/spritesheets/hair/shoulderr/female/blue.png.json","lpc/spritesheets/hair/shoulderr/female/dark_brown.png.json","lpc/spritesheets/hair/shoulderr/female/gold.png.json","lpc/spritesheets/hair/shoulderr/female/gray.png.json","lpc/spritesheets/hair/shoulderr/female/green.png.json","lpc/spritesheets/hair/shoulderr/female/light_brown.png.json","lpc/spritesheets/hair/shoulderr/female/orange.png.json","lpc/spritesheets/hair/shoulderr/female/purple.png.json","lpc/spritesheets/hair/shoulderr/female/red.png.json","lpc/spritesheets/hair/shoulderr/female/white.png.json","lpc/spritesheets/hair/single/female/black.png.json","lpc/spritesheets/hair/single/female/blonde.png.json","lpc/spritesheets/hair/single/female/blue.png.json","lpc/spritesheets/hair/single/female/dark_brown.png.json","lpc/spritesheets/hair/single/female/gold.png.json","lpc/spritesheets/hair/single/female/gray.png.json","lpc/spritesheets/hair/single/female/green.png.json","lpc/spritesheets/hair/single/female/light_brown.png.json","lpc/spritesheets/hair/single/female/orange.png.json","lpc/spritesheets/hair/single/female/purple.png.json","lpc/spritesheets/hair/single/female/red.png.json","lpc/spritesheets/hair/single/female/white.png.json","lpc/spritesheets/hair/single/male/black.png.json","lpc/spritesheets/hair/single/male/blonde.png.json","lpc/spritesheets/hair/single/male/blue.png.json","lpc/spritesheets/hair/single/male/dark_brown.png.json","lpc/spritesheets/hair/single/male/gold.png.json","lpc/spritesheets/hair/single/male/gray.png.json","lpc/spritesheets/hair/single/male/green.png.json","lpc/spritesheets/hair/single/male/light_brown.png.json","lpc/spritesheets/hair/single/male/orange.png.json","lpc/spritesheets/hair/single/male/purple.png.json","lpc/spritesheets/hair/single/male/red.png.json","lpc/spritesheets/hair/single/male/white.png.json","lpc/spritesheets/hair/spiked/female/black.png.json","lpc/spritesheets/hair/spiked/female/blonde.png.json","lpc/spritesheets/hair/spiked/female/blue.png.json","lpc/spritesheets/hair/spiked/female/dark_brown.png.json","lpc/spritesheets/hair/spiked/female/gold.png.json","lpc/spritesheets/hair/spiked/female/gray.png.json","lpc/spritesheets/hair/spiked/female/green.png.json","lpc/spritesheets/hair/spiked/female/light_brown.png.json","lpc/spritesheets/hair/spiked/female/orange.png.json","lpc/spritesheets/hair/spiked/female/purple.png.json","lpc/spritesheets/hair/spiked/female/red.png.json","lpc/spritesheets/hair/spiked/female/white.png.json","lpc/spritesheets/hair/spiked/male/black.png.json","lpc/spritesheets/hair/spiked/male/blonde.png.json","lpc/spritesheets/hair/spiked/male/blue.png.json","lpc/spritesheets/hair/spiked/male/dark_brown.png.json","lpc/spritesheets/hair/spiked/male/gold.png.json","lpc/spritesheets/hair/spiked/male/gray.png.json","lpc/spritesheets/hair/spiked/male/green.png.json","lpc/spritesheets/hair/spiked/male/light_brown.png.json","lpc/spritesheets/hair/spiked/male/orange.png.json","lpc/spritesheets/hair/spiked/male/purple.png.json","lpc/spritesheets/hair/spiked/male/red.png.json","lpc/spritesheets/hair/spiked/male/white.png.json","lpc/spritesheets/hair/spiked2/female/black.png.json","lpc/spritesheets/hair/spiked2/female/blonde.png.json","lpc/spritesheets/hair/spiked2/female/blue.png.json","lpc/spritesheets/hair/spiked2/female/dark_brown.png.json","lpc/spritesheets/hair/spiked2/female/gold.png.json","lpc/spritesheets/hair/spiked2/female/gray.png.json","lpc/spritesheets/hair/spiked2/female/green.png.json","lpc/spritesheets/hair/spiked2/female/light_brown.png.json","lpc/spritesheets/hair/spiked2/female/orange.png.json","lpc/spritesheets/hair/spiked2/female/purple.png.json","lpc/spritesheets/hair/spiked2/female/red.png.json","lpc/spritesheets/hair/spiked2/female/white.png.json","lpc/spritesheets/hair/spiked2/male/black.png.json","lpc/spritesheets/hair/spiked2/male/blonde.png.json","lpc/spritesheets/hair/spiked2/male/blue.png.json","lpc/spritesheets/hair/spiked2/male/dark_brown.png.json","lpc/spritesheets/hair/spiked2/male/gold.png.json","lpc/spritesheets/hair/spiked2/male/gray.png.json","lpc/spritesheets/hair/spiked2/male/green.png.json","lpc/spritesheets/hair/spiked2/male/light_brown.png.json","lpc/spritesheets/hair/spiked2/male/orange.png.json","lpc/spritesheets/hair/spiked2/male/purple.png.json","lpc/spritesheets/hair/spiked2/male/red.png.json","lpc/spritesheets/hair/spiked2/male/white.png.json","lpc/spritesheets/hair/spiked_beehive/female/black.png.json","lpc/spritesheets/hair/spiked_beehive/female/blonde.png.json","lpc/spritesheets/hair/spiked_beehive/female/blue.png.json","lpc/spritesheets/hair/spiked_beehive/female/dark_brown.png.json","lpc/spritesheets/hair/spiked_beehive/female/gold.png.json","lpc/spritesheets/hair/spiked_beehive/female/gray.png.json","lpc/spritesheets/hair/spiked_beehive/female/green.png.json","lpc/spritesheets/hair/spiked_beehive/female/light_brown.png.json","lpc/spritesheets/hair/spiked_beehive/female/orange.png.json","lpc/spritesheets/hair/spiked_beehive/female/purple.png.json","lpc/spritesheets/hair/spiked_beehive/female/red.png.json","lpc/spritesheets/hair/spiked_beehive/female/white.png.json","lpc/spritesheets/hair/spiked_beehive/male/black.png.json","lpc/spritesheets/hair/spiked_beehive/male/blonde.png.json","lpc/spritesheets/hair/spiked_beehive/male/blue.png.json","lpc/spritesheets/hair/spiked_beehive/male/dark_brown.png.json","lpc/spritesheets/hair/spiked_beehive/male/gold.png.json","lpc/spritesheets/hair/spiked_beehive/male/gray.png.json","lpc/spritesheets/hair/spiked_beehive/male/green.png.json","lpc/spritesheets/hair/spiked_beehive/male/light_brown.png.json","lpc/spritesheets/hair/spiked_beehive/male/orange.png.json","lpc/spritesheets/hair/spiked_beehive/male/purple.png.json","lpc/spritesheets/hair/spiked_beehive/male/red.png.json","lpc/spritesheets/hair/spiked_beehive/male/white.png.json","lpc/spritesheets/hair/spiked_liberty/female/black.png.json","lpc/spritesheets/hair/spiked_liberty/female/blonde.png.json","lpc/spritesheets/hair/spiked_liberty/female/blue.png.json","lpc/spritesheets/hair/spiked_liberty/female/dark_brown.png.json","lpc/spritesheets/hair/spiked_liberty/female/gold.png.json","lpc/spritesheets/hair/spiked_liberty/female/gray.png.json","lpc/spritesheets/hair/spiked_liberty/female/green.png.json","lpc/spritesheets/hair/spiked_liberty/female/light_brown.png.json","lpc/spritesheets/hair/spiked_liberty/female/orange.png.json","lpc/spritesheets/hair/spiked_liberty/female/purple.png.json","lpc/spritesheets/hair/spiked_liberty/female/red.png.json","lpc/spritesheets/hair/spiked_liberty/female/white.png.json","lpc/spritesheets/hair/spiked_liberty/male/black.png.json","lpc/spritesheets/hair/spiked_liberty/male/blonde.png.json","lpc/spritesheets/hair/spiked_liberty/male/blue.png.json","lpc/spritesheets/hair/spiked_liberty/male/dark_brown.png.json","lpc/spritesheets/hair/spiked_liberty/male/gold.png.json","lpc/spritesheets/hair/spiked_liberty/male/gray.png.json","lpc/spritesheets/hair/spiked_liberty/male/green.png.json","lpc/spritesheets/hair/spiked_liberty/male/light_brown.png.json","lpc/spritesheets/hair/spiked_liberty/male/orange.png.json","lpc/spritesheets/hair/spiked_liberty/male/purple.png.json","lpc/spritesheets/hair/spiked_liberty/male/red.png.json","lpc/spritesheets/hair/spiked_liberty/male/white.png.json","lpc/spritesheets/hair/spiked_liberty2/female/black.png.json","lpc/spritesheets/hair/spiked_liberty2/female/blonde.png.json","lpc/spritesheets/hair/spiked_liberty2/female/blue.png.json","lpc/spritesheets/hair/spiked_liberty2/female/dark_brown.png.json","lpc/spritesheets/hair/spiked_liberty2/female/gold.png.json","lpc/spritesheets/hair/spiked_liberty2/female/gray.png.json","lpc/spritesheets/hair/spiked_liberty2/female/green.png.json","lpc/spritesheets/hair/spiked_liberty2/female/light_brown.png.json","lpc/spritesheets/hair/spiked_liberty2/female/orange.png.json","lpc/spritesheets/hair/spiked_liberty2/female/purple.png.json","lpc/spritesheets/hair/spiked_liberty2/female/red.png.json","lpc/spritesheets/hair/spiked_liberty2/female/white.png.json","lpc/spritesheets/hair/spiked_liberty2/male/black.png.json","lpc/spritesheets/hair/spiked_liberty2/male/blonde.png.json","lpc/spritesheets/hair/spiked_liberty2/male/blue.png.json","lpc/spritesheets/hair/spiked_liberty2/male/dark_brown.png.json","lpc/spritesheets/hair/spiked_liberty2/male/gold.png.json","lpc/spritesheets/hair/spiked_liberty2/male/gray.png.json","lpc/spritesheets/hair/spiked_liberty2/male/green.png.json","lpc/spritesheets/hair/spiked_liberty2/male/light_brown.png.json","lpc/spritesheets/hair/spiked_liberty2/male/orange.png.json","lpc/spritesheets/hair/spiked_liberty2/male/purple.png.json","lpc/spritesheets/hair/spiked_liberty2/male/red.png.json","lpc/spritesheets/hair/spiked_liberty2/male/white.png.json","lpc/spritesheets/hair/spiked_porcupine/female/black.png.json","lpc/spritesheets/hair/spiked_porcupine/female/blonde.png.json","lpc/spritesheets/hair/spiked_porcupine/female/blue.png.json","lpc/spritesheets/hair/spiked_porcupine/female/dark_brown.png.json","lpc/spritesheets/hair/spiked_porcupine/female/gold.png.json","lpc/spritesheets/hair/spiked_porcupine/female/gray.png.json","lpc/spritesheets/hair/spiked_porcupine/female/green.png.json","lpc/spritesheets/hair/spiked_porcupine/female/light_brown.png.json","lpc/spritesheets/hair/spiked_porcupine/female/orange.png.json","lpc/spritesheets/hair/spiked_porcupine/female/purple.png.json","lpc/spritesheets/hair/spiked_porcupine/female/red.png.json","lpc/spritesheets/hair/spiked_porcupine/female/white.png.json","lpc/spritesheets/hair/spiked_porcupine/male/black.png.json","lpc/spritesheets/hair/spiked_porcupine/male/blonde.png.json","lpc/spritesheets/hair/spiked_porcupine/male/blue.png.json","lpc/spritesheets/hair/spiked_porcupine/male/dark_brown.png.json","lpc/spritesheets/hair/spiked_porcupine/male/gold.png.json","lpc/spritesheets/hair/spiked_porcupine/male/gray.png.json","lpc/spritesheets/hair/spiked_porcupine/male/green.png.json","lpc/spritesheets/hair/spiked_porcupine/male/light_brown.png.json","lpc/spritesheets/hair/spiked_porcupine/male/orange.png.json","lpc/spritesheets/hair/spiked_porcupine/male/purple.png.json","lpc/spritesheets/hair/spiked_porcupine/male/red.png.json","lpc/spritesheets/hair/spiked_porcupine/male/white.png.json","lpc/spritesheets/hair/swoop/female/black.png.json","lpc/spritesheets/hair/swoop/female/blonde.png.json","lpc/spritesheets/hair/swoop/female/blue.png.json","lpc/spritesheets/hair/swoop/female/dark_brown.png.json","lpc/spritesheets/hair/swoop/female/gold.png.json","lpc/spritesheets/hair/swoop/female/gray.png.json","lpc/spritesheets/hair/swoop/female/green.png.json","lpc/spritesheets/hair/swoop/female/light_brown.png.json","lpc/spritesheets/hair/swoop/female/orange.png.json","lpc/spritesheets/hair/swoop/female/purple.png.json","lpc/spritesheets/hair/swoop/female/red.png.json","lpc/spritesheets/hair/swoop/female/white.png.json","lpc/spritesheets/hair/swoop/male/black.png.json","lpc/spritesheets/hair/swoop/male/blonde.png.json","lpc/spritesheets/hair/swoop/male/blue.png.json","lpc/spritesheets/hair/swoop/male/dark_brown.png.json","lpc/spritesheets/hair/swoop/male/gold.png.json","lpc/spritesheets/hair/swoop/male/gray.png.json","lpc/spritesheets/hair/swoop/male/green.png.json","lpc/spritesheets/hair/swoop/male/light_brown.png.json","lpc/spritesheets/hair/swoop/male/orange.png.json","lpc/spritesheets/hair/swoop/male/purple.png.json","lpc/spritesheets/hair/swoop/male/red.png.json","lpc/spritesheets/hair/swoop/male/white.png.json","lpc/spritesheets/hair/twists_fade/female/black.png.json","lpc/spritesheets/hair/twists_fade/female/blonde.png.json","lpc/spritesheets/hair/twists_fade/female/blue.png.json","lpc/spritesheets/hair/twists_fade/female/dark_brown.png.json","lpc/spritesheets/hair/twists_fade/female/gold.png.json","lpc/spritesheets/hair/twists_fade/female/gray.png.json","lpc/spritesheets/hair/twists_fade/female/green.png.json","lpc/spritesheets/hair/twists_fade/female/light_brown.png.json","lpc/spritesheets/hair/twists_fade/female/orange.png.json","lpc/spritesheets/hair/twists_fade/female/purple.png.json","lpc/spritesheets/hair/twists_fade/female/red.png.json","lpc/spritesheets/hair/twists_fade/female/white.png.json","lpc/spritesheets/hair/twists_fade/male/black.png.json","lpc/spritesheets/hair/twists_fade/male/blonde.png.json","lpc/spritesheets/hair/twists_fade/male/blue.png.json","lpc/spritesheets/hair/twists_fade/male/dark_brown.png.json","lpc/spritesheets/hair/twists_fade/male/gold.png.json","lpc/spritesheets/hair/twists_fade/male/gray.png.json","lpc/spritesheets/hair/twists_fade/male/green.png.json","lpc/spritesheets/hair/twists_fade/male/light_brown.png.json","lpc/spritesheets/hair/twists_fade/male/orange.png.json","lpc/spritesheets/hair/twists_fade/male/purple.png.json","lpc/spritesheets/hair/twists_fade/male/red.png.json","lpc/spritesheets/hair/twists_fade/male/white.png.json","lpc/spritesheets/hair/twists_straight/female/black.png.json","lpc/spritesheets/hair/twists_straight/female/blonde.png.json","lpc/spritesheets/hair/twists_straight/female/blue.png.json","lpc/spritesheets/hair/twists_straight/female/dark_brown.png.json","lpc/spritesheets/hair/twists_straight/female/gold.png.json","lpc/spritesheets/hair/twists_straight/female/gray.png.json","lpc/spritesheets/hair/twists_straight/female/green.png.json","lpc/spritesheets/hair/twists_straight/female/light_brown.png.json","lpc/spritesheets/hair/twists_straight/female/orange.png.json","lpc/spritesheets/hair/twists_straight/female/purple.png.json","lpc/spritesheets/hair/twists_straight/female/red.png.json","lpc/spritesheets/hair/twists_straight/female/white.png.json","lpc/spritesheets/hair/twists_straight/male/black.png.json","lpc/spritesheets/hair/twists_straight/male/blonde.png.json","lpc/spritesheets/hair/twists_straight/male/blue.png.json","lpc/spritesheets/hair/twists_straight/male/dark_brown.png.json","lpc/spritesheets/hair/twists_straight/male/gold.png.json","lpc/spritesheets/hair/twists_straight/male/gray.png.json","lpc/spritesheets/hair/twists_straight/male/green.png.json","lpc/spritesheets/hair/twists_straight/male/light_brown.png.json","lpc/spritesheets/hair/twists_straight/male/orange.png.json","lpc/spritesheets/hair/twists_straight/male/purple.png.json","lpc/spritesheets/hair/twists_straight/male/red.png.json","lpc/spritesheets/hair/twists_straight/male/white.png.json","lpc/spritesheets/hair/unkempt/female/black.png.json","lpc/spritesheets/hair/unkempt/female/blonde.png.json","lpc/spritesheets/hair/unkempt/female/blue.png.json","lpc/spritesheets/hair/unkempt/female/dark_brown.png.json","lpc/spritesheets/hair/unkempt/female/gold.png.json","lpc/spritesheets/hair/unkempt/female/gray.png.json","lpc/spritesheets/hair/unkempt/female/green.png.json","lpc/spritesheets/hair/unkempt/female/light_brown.png.json","lpc/spritesheets/hair/unkempt/female/orange.png.json","lpc/spritesheets/hair/unkempt/female/purple.png.json","lpc/spritesheets/hair/unkempt/female/red.png.json","lpc/spritesheets/hair/unkempt/female/white.png.json","lpc/spritesheets/hair/unkempt/male/black.png.json","lpc/spritesheets/hair/unkempt/male/blonde.png.json","lpc/spritesheets/hair/unkempt/male/blue.png.json","lpc/spritesheets/hair/unkempt/male/dark_brown.png.json","lpc/spritesheets/hair/unkempt/male/gold.png.json","lpc/spritesheets/hair/unkempt/male/gray.png.json","lpc/spritesheets/hair/unkempt/male/green.png.json","lpc/spritesheets/hair/unkempt/male/light_brown.png.json","lpc/spritesheets/hair/unkempt/male/orange.png.json","lpc/spritesheets/hair/unkempt/male/purple.png.json","lpc/spritesheets/hair/unkempt/male/red.png.json","lpc/spritesheets/hair/unkempt/male/white.png.json","lpc/spritesheets/hair/wavy/female/black.png.json","lpc/spritesheets/hair/wavy/female/blonde.png.json","lpc/spritesheets/hair/wavy/female/blue.png.json","lpc/spritesheets/hair/wavy/female/dark_brown.png.json","lpc/spritesheets/hair/wavy/female/gold.png.json","lpc/spritesheets/hair/wavy/female/gray.png.json","lpc/spritesheets/hair/wavy/female/green.png.json","lpc/spritesheets/hair/wavy/female/light_brown.png.json","lpc/spritesheets/hair/wavy/female/orange.png.json","lpc/spritesheets/hair/wavy/female/purple.png.json","lpc/spritesheets/hair/wavy/female/red.png.json","lpc/spritesheets/hair/wavy/female/white.png.json","lpc/spritesheets/hair/wavy/male/black.png.json","lpc/spritesheets/hair/wavy/male/blonde.png.json","lpc/spritesheets/hair/wavy/male/blue.png.json","lpc/spritesheets/hair/wavy/male/dark_brown.png.json","lpc/spritesheets/hair/wavy/male/gold.png.json","lpc/spritesheets/hair/wavy/male/gray.png.json","lpc/spritesheets/hair/wavy/male/green.png.json","lpc/spritesheets/hair/wavy/male/light_brown.png.json","lpc/spritesheets/hair/wavy/male/orange.png.json","lpc/spritesheets/hair/wavy/male/purple.png.json","lpc/spritesheets/hair/wavy/male/red.png.json","lpc/spritesheets/hair/wavy/male/white.png.json","lpc/spritesheets/hair/xlong/female/black.png.json","lpc/spritesheets/hair/xlong/female/blonde.png.json","lpc/spritesheets/hair/xlong/female/blue.png.json","lpc/spritesheets/hair/xlong/female/dark_brown.png.json","lpc/spritesheets/hair/xlong/female/gold.png.json","lpc/spritesheets/hair/xlong/female/gray.png.json","lpc/spritesheets/hair/xlong/female/green.png.json","lpc/spritesheets/hair/xlong/female/light_brown.png.json","lpc/spritesheets/hair/xlong/female/orange.png.json","lpc/spritesheets/hair/xlong/female/purple.png.json","lpc/spritesheets/hair/xlong/female/red.png.json","lpc/spritesheets/hair/xlong/female/white.png.json","lpc/spritesheets/head/nose/big/female/darkelf.png.json","lpc/spritesheets/head/nose/big/female/light.png.json","lpc/spritesheets/head/nose/big/female/tanned.png.json","lpc/spritesheets/head/nose/big/male/darkelf.png.json","lpc/spritesheets/head/nose/big/male/light.png.json","lpc/spritesheets/head/nose/big/male/tanned.png.json","lpc/spritesheets/head/nose/button/female/darkelf.png.json","lpc/spritesheets/head/nose/button/female/light.png.json","lpc/spritesheets/head/nose/button/female/tanned.png.json","lpc/spritesheets/head/nose/button/male/darkelf.png.json","lpc/spritesheets/head/nose/button/male/light.png.json","lpc/spritesheets/head/nose/button/male/tanned.png.json","lpc/spritesheets/head/nose/straight/female/darkelf.png.json","lpc/spritesheets/head/nose/straight/female/light.png.json","lpc/spritesheets/head/nose/straight/female/tanned.png.json","lpc/spritesheets/head/nose/straight/male/darkelf.png.json","lpc/spritesheets/head/nose/straight/male/light.png.json","lpc/spritesheets/head/nose/straight/male/tanned.png.json","lpc/spritesheets/legs/armour/female/10.png.json","lpc/spritesheets/legs/armour/female/11.png.json","lpc/spritesheets/legs/armour/female/7.png.json","lpc/spritesheets/legs/armour/female/8.png.json","lpc/spritesheets/legs/armour/female/9.png.json","lpc/spritesheets/legs/armour/male/10.png.json","lpc/spritesheets/legs/armour/male/11.png.json","lpc/spritesheets/legs/armour/male/7.png.json","lpc/spritesheets/legs/armour/male/8.png.json","lpc/spritesheets/legs/armour/male/9.png.json","lpc/spritesheets/legs/pantaloons/male/black.png.json","lpc/spritesheets/legs/pantaloons/male/blue.png.json","lpc/spritesheets/legs/pantaloons/male/brown.png.json","lpc/spritesheets/legs/pantaloons/male/gray.png.json","lpc/spritesheets/legs/pantaloons/male/green.png.json","lpc/spritesheets/legs/pantaloons/male/maroon.png.json","lpc/spritesheets/legs/pantaloons/male/orange.png.json","lpc/spritesheets/legs/pantaloons/male/purple.png.json","lpc/spritesheets/legs/pantaloons/male/red.png.json","lpc/spritesheets/legs/pantaloons/male/tan.png.json","lpc/spritesheets/legs/pantaloons/male/white.png.json","lpc/spritesheets/legs/pantaloons/male/yellow.png.json","lpc/spritesheets/legs/pants/female/black.png.json","lpc/spritesheets/legs/pants/female/blue.png.json","lpc/spritesheets/legs/pants/female/brown.png.json","lpc/spritesheets/legs/pants/female/gray.png.json","lpc/spritesheets/legs/pants/female/green.png.json","lpc/spritesheets/legs/pants/female/maroon.png.json","lpc/spritesheets/legs/pants/female/orange.png.json","lpc/spritesheets/legs/pants/female/purple.png.json","lpc/spritesheets/legs/pants/female/red.png.json","lpc/spritesheets/legs/pants/female/tan.png.json","lpc/spritesheets/legs/pants/female/white.png.json","lpc/spritesheets/legs/pants/female/yellow.png.json","lpc/spritesheets/legs/pants/male/black.png.json","lpc/spritesheets/legs/pants/male/blue.png.json","lpc/spritesheets/legs/pants/male/brown.png.json","lpc/spritesheets/legs/pants/male/gray.png.json","lpc/spritesheets/legs/pants/male/green.png.json","lpc/spritesheets/legs/pants/male/maroon.png.json","lpc/spritesheets/legs/pants/male/orange.png.json","lpc/spritesheets/legs/pants/male/purple.png.json","lpc/spritesheets/legs/pants/male/red.png.json","lpc/spritesheets/legs/pants/male/tan.png.json","lpc/spritesheets/legs/pants/male/white.png.json","lpc/spritesheets/legs/pants/male/yellow.png.json","lpc/spritesheets/legs/skirts/female/black.png.json","lpc/spritesheets/legs/skirts/female/brown.png.json","lpc/spritesheets/legs/skirts/female/legion.png.json","lpc/spritesheets/legs/skirts/female/white.png.json","lpc/spritesheets/legs/skirts/male/black.png.json","lpc/spritesheets/legs/skirts/male/brown.png.json","lpc/spritesheets/legs/skirts/male/legion.png.json","lpc/spritesheets/legs/skirts/male/white.png.json","lpc/spritesheets/shield/female/crusader.png.json","lpc/spritesheets/shield/female/kite_blue_blue.png.json","lpc/spritesheets/shield/female/kite_blue_gray.png.json","lpc/spritesheets/shield/female/kite_gray.png.json","lpc/spritesheets/shield/female/kite_gray_blue.png.json","lpc/spritesheets/shield/female/kite_gray_gray.png.json","lpc/spritesheets/shield/female/kite_gray_green.png.json","lpc/spritesheets/shield/female/kite_gray_orange.png.json","lpc/spritesheets/shield/female/kite_green_gray.png.json","lpc/spritesheets/shield/female/kite_orange.png.json","lpc/spritesheets/shield/female/kite_red_gray.png.json","lpc/spritesheets/shield/female/round_black.png.json","lpc/spritesheets/shield/female/round_brown.png.json","lpc/spritesheets/shield/female/round_gold.png.json","lpc/spritesheets/shield/female/round_green.png.json","lpc/spritesheets/shield/female/round_silver.png.json","lpc/spritesheets/shield/female/round_yellow.png.json","lpc/spritesheets/shield/female/spartan.png.json","lpc/spritesheets/shield/male/crusader.png.json","lpc/spritesheets/shield/male/kite_blue_blue.png.json","lpc/spritesheets/shield/male/kite_blue_gray.png.json","lpc/spritesheets/shield/male/kite_gray.png.json","lpc/spritesheets/shield/male/kite_gray_blue.png.json","lpc/spritesheets/shield/male/kite_gray_gray.png.json","lpc/spritesheets/shield/male/kite_gray_green.png.json","lpc/spritesheets/shield/male/kite_gray_orange.png.json","lpc/spritesheets/shield/male/kite_green_gray.png.json","lpc/spritesheets/shield/male/kite_orange.png.json","lpc/spritesheets/shield/male/kite_red_gray.png.json","lpc/spritesheets/shield/male/round_black.png.json","lpc/spritesheets/shield/male/round_brown.png.json","lpc/spritesheets/shield/male/round_gold.png.json","lpc/spritesheets/shield/male/round_green.png.json","lpc/spritesheets/shield/male/round_silver.png.json","lpc/spritesheets/shield/male/round_yellow.png.json","lpc/spritesheets/shield/male/spartan.png.json","lpc/spritesheets/spike/spikes1.png.json","lpc/spritesheets/torso/armour/leather/female/blue.png.json","lpc/spritesheets/torso/armour/leather/female/brown.png.json","lpc/spritesheets/torso/armour/leather/female/green.png.json","lpc/spritesheets/torso/armour/leather/male/blue.png.json","lpc/spritesheets/torso/armour/leather/male/brown.png.json","lpc/spritesheets/torso/armour/leather/male/green.png.json","lpc/spritesheets/torso/armour/legion/female/bronze.png.json","lpc/spritesheets/torso/armour/legion/female/gold.png.json","lpc/spritesheets/torso/armour/legion/female/steel.png.json","lpc/spritesheets/torso/armour/legion/male/bronze.png.json","lpc/spritesheets/torso/armour/legion/male/gold.png.json","lpc/spritesheets/torso/armour/legion/male/steel.png.json","lpc/spritesheets/torso/armour/plate/female/11.png.json","lpc/spritesheets/torso/armour/plate/female/12.png.json","lpc/spritesheets/torso/armour/plate/female/14.png.json","lpc/spritesheets/torso/armour/plate/female/16.png.json","lpc/spritesheets/torso/armour/plate/female/special.png.json","lpc/spritesheets/torso/armour/plate/male/11.png.json","lpc/spritesheets/torso/armour/plate/male/12.png.json","lpc/spritesheets/torso/armour/plate/male/14.png.json","lpc/spritesheets/torso/armour/plate/male/16.png.json","lpc/spritesheets/torso/armour/plate/male/special.png.json","lpc/spritesheets/torso/clothes/blouse/female/black.png.json","lpc/spritesheets/torso/clothes/blouse/female/blue.png.json","lpc/spritesheets/torso/clothes/blouse/female/gray.png.json","lpc/spritesheets/torso/clothes/blouse/female/green.png.json","lpc/spritesheets/torso/clothes/blouse/female/maroon.png.json","lpc/spritesheets/torso/clothes/blouse/female/orange.png.json","lpc/spritesheets/torso/clothes/blouse/female/purple.png.json","lpc/spritesheets/torso/clothes/blouse/female/red.png.json","lpc/spritesheets/torso/clothes/blouse/female/tan.png.json","lpc/spritesheets/torso/clothes/blouse/female/teal.png.json","lpc/spritesheets/torso/clothes/blouse/female/white.png.json","lpc/spritesheets/torso/clothes/blouse/female/yellow.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/black.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/blue.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/gray.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/green.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/maroon.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/orange.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/purple.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/red.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/tan.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/teal.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/white.png.json","lpc/spritesheets/torso/clothes/blouse_longsleeve/female/yellow.png.json","lpc/spritesheets/torso/clothes/corset/female/black.png.json","lpc/spritesheets/torso/clothes/corset/female/blue.png.json","lpc/spritesheets/torso/clothes/corset/female/gray.png.json","lpc/spritesheets/torso/clothes/corset/female/green.png.json","lpc/spritesheets/torso/clothes/corset/female/leather.png.json","lpc/spritesheets/torso/clothes/corset/female/maroon.png.json","lpc/spritesheets/torso/clothes/corset/female/orange.png.json","lpc/spritesheets/torso/clothes/corset/female/purple.png.json","lpc/spritesheets/torso/clothes/corset/female/red.png.json","lpc/spritesheets/torso/clothes/corset/female/tan.png.json","lpc/spritesheets/torso/clothes/corset/female/teal.png.json","lpc/spritesheets/torso/clothes/corset/female/white.png.json","lpc/spritesheets/torso/clothes/corset/female/yellow.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/black.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/blue.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/green.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/maroon.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/purple.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/red.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/teal.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/white.png.json","lpc/spritesheets/torso/clothes/longsleeve/female/yellow.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/black.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/blue.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/green.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/maroon.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/purple.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/red.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/teal.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/white.png.json","lpc/spritesheets/torso/clothes/longsleeve/male/yellow.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/black.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/blue.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/gray.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/green.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/maroon.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/orange.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/purple.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/red.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/tan.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/teal.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/white.png.json","lpc/spritesheets/torso/clothes/longsleeve_laced/male/yellow.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/black.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/blue.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/gray.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/green.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/maroon.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/orange.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/purple.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/red.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/teal.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/white.png.json","lpc/spritesheets/torso/clothes/scoop_shirt/female/yellow.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/black.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/blue.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/brown.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/gray.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/green.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/maroon.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/orange.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/purple.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/red.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/tan.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/teal.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/white.png.json","lpc/spritesheets/torso/clothes/sleeveless/male/yellow.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/black.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/blue.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/brown.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/gray.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/green.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/maroon.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/orange.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/purple.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/red.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/tan.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/teal.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/white.png.json","lpc/spritesheets/torso/clothes/sleeveless_laced/male/yellow.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/black.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/blue.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/brown.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/gray.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/green.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/maroon.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/orange.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/purple.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/red.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/tan.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/teal.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/white.png.json","lpc/spritesheets/torso/clothes/sleeveless_striped/male/yellow.png.json","lpc/spritesheets/torso/clothes/tanktop/female/black.png.json","lpc/spritesheets/torso/clothes/tanktop/female/blue.png.json","lpc/spritesheets/torso/clothes/tanktop/female/gray.png.json","lpc/spritesheets/torso/clothes/tanktop/female/green.png.json","lpc/spritesheets/torso/clothes/tanktop/female/maroon.png.json","lpc/spritesheets/torso/clothes/tanktop/female/orange.png.json","lpc/spritesheets/torso/clothes/tanktop/female/purple.png.json","lpc/spritesheets/torso/clothes/tanktop/female/red.png.json","lpc/spritesheets/torso/clothes/tanktop/female/tan.png.json","lpc/spritesheets/torso/clothes/tanktop/female/teal.png.json","lpc/spritesheets/torso/clothes/tanktop/female/white.png.json","lpc/spritesheets/torso/clothes/tanktop/female/yellow.png.json","lpc/spritesheets/torso/clothes/tunic/female/brown.png.json","lpc/spritesheets/torso/clothes/tunic/female/maroon.png.json","lpc/spritesheets/torso/clothes/tunic/female/teal.png.json","lpc/spritesheets/torso/clothes/tunic/female/white.png.json","lpc/spritesheets/weapon/bow/normal.png.json","lpc/spritesheets/weapon/slash/female/axe_2.png.json","lpc/spritesheets/weapon/slash/female/dagger.png.json","lpc/spritesheets/weapon/slash/female/dagger_brown.png.json","lpc/spritesheets/weapon/slash/female/warhammer.png.json","lpc/spritesheets/weapon/slash/male/axe_2.png.json","lpc/spritesheets/weapon/slash/male/dagger.png.json","lpc/spritesheets/weapon/slash/male/dagger_brown.png.json","lpc/spritesheets/weapon/slash/male/warhammer.png.json","lpc/spritesheets/weapon/slash_oversize/female/flail.png.json","lpc/spritesheets/weapon/slash_oversize/female/halberd.png.json","lpc/spritesheets/weapon/slash_oversize/female/universal/flail.png.json","lpc/spritesheets/weapon/slash_oversize/female/universal/halberd.png.json","lpc/spritesheets/weapon/slash_oversize/female/universal/waraxe.png.json","lpc/spritesheets/weapon/slash_oversize/female/waraxe.png.json","lpc/spritesheets/weapon/slash_oversize/male/flail.png.json","lpc/spritesheets/weapon/slash_oversize/male/halberd.png.json","lpc/spritesheets/weapon/slash_oversize/male/universal/flail.png.json","lpc/spritesheets/weapon/slash_oversize/male/universal/halberd.png.json","lpc/spritesheets/weapon/slash_oversize/male/universal/waraxe.png.json","lpc/spritesheets/weapon/slash_oversize/male/waraxe.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/longsword.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/mace.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/rapier.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/saber.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/scythe.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/longsword.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/mace.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/rapier.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/saber.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/behind/scythe.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/longsword.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/mace.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/rapier.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/saber.png.json","lpc/spritesheets/weapon/slash_oversize_layered/all/universal/scythe.png.json","lpc/spritesheets/weapon/thrust/female/crossbow.png.json","lpc/spritesheets/weapon/thrust/female/simple_staff.png.json","lpc/spritesheets/weapon/thrust/female/spear_2.png.json","lpc/spritesheets/weapon/thrust/female/spear_black.png.json","lpc/spritesheets/weapon/thrust/female/spear_green.png.json","lpc/spritesheets/weapon/thrust/female/spear_metal.png.json","lpc/spritesheets/weapon/thrust/female/spear_purple.png.json","lpc/spritesheets/weapon/thrust/male/crossbow.png.json","lpc/spritesheets/weapon/thrust/male/simple_staff.png.json","lpc/spritesheets/weapon/thrust/male/spear_2.png.json","lpc/spritesheets/weapon/thrust/male/spear_black.png.json","lpc/spritesheets/weapon/thrust/male/spear_green.png.json","lpc/spritesheets/weapon/thrust/male/spear_metal.png.json","lpc/spritesheets/weapon/thrust/male/spear_purple.png.json","lpc/spritesheets/authored/wild-hare.png.json","lpc/spritesheets/authored/rage-slime.png.json","lpc/spritesheets/authored/lpc-viper.png.json","lpc/spritesheets/authored/lpc-chicken.png.json","lpc/spritesheets/authored/iron-pickaxe/male.png.json","lpc/spritesheets/authored/iron-pickaxe/female.png.json"],"presentation":{"classToTypes":{"armor":["armor-leather","armor-legion","armor-plate"],"bauldron":["bauldron"],"cape":["cape-solid","cape-tattered","cape-trimmed"],"key":["castlekey"],"pants":["legion","pantaloons","pants","pants-armor","skirts"],"resource":["arrow","webAmmo","ember-charge","coal","copper","gold","iron","silver","drumstick","feather","planks","rope","stick","spider-silk","flower-single-blue","flower-single-purple","flower-single-red","flower-single-yellow","hide","metal-bar-copper","metal-bar-gold","metal-bar-iron","metal-bar-silver","mushroom-purple","mushroom-red","mushroom-yellow","seed","shard-metal","straw","torch","wood","shard-metal"],"shield":["shield-crusader","shield-kite","shield-kite_blue","shield-kite_gray","shield-kite_green","shield-kite_red","shield-round","shield-spartan"],"shirt":["blouse","blouse_longsleeve","corset","longsleeve","longsleeve_laced","scoop_shirt","sleeveless","sleeveless_laced","sleeveless_striped","tanktop","tunic"],"shoes":["boots","sandals","shoes","shoes-armor","slippers"],"structure":["campfire","snare-rabbit","stool-small","table-large-rough","table-mid-round","barrel1","stackedBags","stool1","table-mid-rough","strawBed","strawBedSmall","chest-wood","door-wood","floor-wood","floor-stone","floor-cobble","roof-wood","wall-wood","wall2-wood","wall-stone","railing-wood","stairs","floor-opening","hatch-wood"],"weapon":["axe","bow","crossbow","dagger","flail","halberd","longsword","mace","none","rapier","saber","scythe","spear","staff","waraxe","warhammer","web"]},"crafting":{"byClass":{"resource":"materials","structure":"camp","weapon":"weapons"},"defaultGroup":"materials","groups":["camp","hunting","weapons","materials"],"labels":{"camp":"Camp","hunting":"Hunting","materials":"Materials","weapons":"Weapons"},"overrides":{"arrow":"hunting","bow":"hunting","ember-charge":"weapons","snare-rabbit":"hunting"},"sourceHints":{"coal":"Mine ore veins","copper":"Mine ore veins","feather":"Hunt chickens","gold":"Mine ore veins","iron":"Mine ore veins","shard-metal":"Dropped by snakes and slimes","silver":"Mine ore veins","spider-silk":"Hunt spiders outside camp","straw":"Cut long grass","wood":"Chop trees"},"undisclosedSources":["shard-metal"]},"sheets":[{"file":"furniture-blonde-wood.json","id":"furniture-blonde-wood"},{"file":"fence_medieval.json","id":"fence_medieval"},{"file":"container.json","id":"container"},{"file":"walls.json","id":"walls"},{"file":"walls2.json","id":"walls2"},{"file":"floors.json","id":"floors"},{"file":"cottage.json","id":"cottage"},{"file":"roofs.json","id":"roofs"},{"file":"ore.json","id":"ore"},{"file":"decorations-medieval.json","id":"decorations-medieval"},{"file":"jungle-ruins.json","id":"jungle-ruins"},{"file":"mountains-v6.json","id":"mountains-v6"},{"file":"lpc-flowers-plants-fungi-wood.json","id":"lpc-flowers-plants-fungi-wood"},{"file":"lpc-terrain.json","id":"lpc-terrain"},{"file":"beach-desert.json","id":"beach-desert"},{"file":"map-atlas.json","id":"map-atlas"},{"file":"plants.json","id":"plants"},{"file":"build_atlas.json","id":"build_atlas"},{"file":"humanoid.json","id":"humanoid"},{"file":"authored-terrain.json","id":"authored-terrain"},{"file":"item-art-b1d5a86cbcd21ed656d3.json","id":"item-art-b1d5a86cbcd21ed656d3"},{"file":"forest-grass.json","id":"forest-grass"},{"file":"forest-dirt.json","id":"forest-dirt"},{"file":"stairs-icon.json","id":"stairs-icon"},{"file":"item-art-887e0636d4bbe2a4f448.json","id":"item-art-887e0636d4bbe2a4f448"},{"file":"item-art-f728e0bbaefbd1982b2d.json","id":"item-art-f728e0bbaefbd1982b2d"},{"file":"item-art-35c925e4db81912bfe38.json","id":"item-art-35c925e4db81912bfe38"},{"file":"item-art-99ea85dcdc93fac8db18.json","id":"item-art-99ea85dcdc93fac8db18"},{"file":"item-art-bb4afa7ce4e3c1ba55ba.json","id":"item-art-bb4afa7ce4e3c1ba55ba"},{"file":"item-art-e46e4dec4aea45bf9d8e.json","id":"item-art-e46e4dec4aea45bf9d8e"},{"file":"item-art-32902d50537ebad17e79.json","id":"item-art-32902d50537ebad17e79"},{"file":"item-art-5902c8b486e89c8f8e57.json","id":"item-art-5902c8b486e89c8f8e57"},{"file":"item-art-ebdd046fea0f3ab21669.json","id":"item-art-ebdd046fea0f3ab21669"},{"file":"item-art-4d6c318ef966e097227a.json","id":"item-art-4d6c318ef966e097227a"},{"file":"item-art-721c3f8a8d4621a46f90.json","id":"item-art-721c3f8a8d4621a46f90"},{"file":"item-art-7fc02d2406eaa57e3be0.json","id":"item-art-7fc02d2406eaa57e3be0"},{"file":"item-art-a7225776548a58ab4e04.json","id":"item-art-a7225776548a58ab4e04"},{"file":"item-art-d9ecaed5ff4485611809.json","id":"item-art-d9ecaed5ff4485611809"},{"file":"item-art-af19df691fc7aa944194.json","id":"item-art-af19df691fc7aa944194"},{"file":"item-art-b9ef00e25a4177065abd.json","id":"item-art-b9ef00e25a4177065abd"},{"file":"hatch-wood.json","id":"hatch-wood"}],"subClasses":{"ammo":["arrow","webAmmo","ember-charge"],"armor":["armor-leather","armor-legion","armor-plate"],"bauldron":["bauldron"],"cape":["cape-solid","cape-tattered","cape-trimmed"],"chest":["chest-wood"],"craftResource":["feather","planks","rope","stick","spider-silk"],"door":["door-wood"],"drumstick":["drumstick"],"floor":["floor-wood","floor-stone","floor-cobble"],"flower":["flower-single-blue","flower-single-purple","flower-single-red","flower-single-yellow"],"hide":["hide"],"key":["castlekey"],"metalBar":["metal-bar-copper","metal-bar-gold","metal-bar-iron","metal-bar-silver"],"mushroom":["mushroom-purple","mushroom-red","mushroom-yellow"],"ore":["coal","copper","gold","iron","silver"],"pants":["legion","pantaloons","pants","pants-armor","skirts"],"resource":["shard-metal"],"roof":["roof-wood"],"seed":["seed"],"shard":["shard-metal"],"shield":["shield-crusader","shield-kite","shield-kite_blue","shield-kite_gray","shield-kite_green","shield-kite_red","shield-round","shield-spartan"],"shirt":["blouse","blouse_longsleeve","corset","longsleeve","longsleeve_laced","scoop_shirt","sleeveless","sleeveless_laced","sleeveless_striped","tanktop","tunic"],"shoes":["boots","sandals","shoes","shoes-armor","slippers"],"straw":["straw"],"structure":["campfire","snare-rabbit","stool-small","table-large-rough","table-mid-round","barrel1","stackedBags","stool1","table-mid-rough","strawBed","strawBedSmall","stairs","floor-opening","hatch-wood"],"torch":["torch"],"wall":["wall-wood","wall2-wood","wall-stone","railing-wood"],"weapon":["axe","bow","crossbow","dagger","flail","halberd","longsword","mace","none","rapier","saber","scythe","spear","staff","waraxe","warhammer","web"],"wood":["wood"]}},"profiles":{"drops":{"chicken":[{"metadata":{"class":"resource","color":"brown","type":"drumstick"},"quantity":1},{"quantity":10,"reference":{"item":"feather"}}],"deer":[{"metadata":{"class":"resource","color":"brown","type":"hide"},"quantity":3},{"metadata":{"class":"resource","color":"brown","type":"drumstick"},"quantity":3}],"human":[{"probability":0.2,"quantity":10,"reference":{"item":"shard-metal"}}],"rabbit":[{"metadata":{"class":"resource","color":"brown","type":"hide"},"quantity":1},{"metadata":{"class":"resource","color":"brown","type":"drumstick"},"quantity":2}],"redspider":[{"probability":1,"quantity":1,"reference":{"item":"spider-silk"}}],"skeleton":[{"probability":0.6,"quantity":2,"reference":{"item":"shard-metal"}}],"slime":[{"probability":0.35,"quantity":1,"reference":{"item":"shard-metal"}}],"snake":[{"probability":0.25,"quantity":1,"reference":{"item":"shard-metal"}}],"wolfman":[{"probability":1,"quantity":8,"reference":{"item":"shard-metal"}},{"probability":0.5,"quantity":1,"reference":{"item":"shard-metal"}},{"metadata":{"class":"resource","color":"brown","type":"hide"},"probability":0.5,"quantity":2}]},"effects":{"torch":{"clockDuration":50,"effect":"light"}},"encounters":{"emberWildlife":{"defaultEnemy":"snake","enemyWeights":[{"race":"slime","weight":0.55},{"race":"snake","weight":0.35},{"race":"redspider","weight":0.1}],"specs":{"chicken":{"brainProps":{"peckWander":true},"flags":{"devKillable":true,"dropsLootOnDeath":true,"isChicken":true,"noContactPush":true,"nonAggro":true},"hp":2,"immoveable":false,"probability":1,"race":"chicken","sex":"male"},"rabbit":{"flags":{"devKillable":true,"dropsLootOnDeath":true,"isRabbit":true,"nonAggro":true},"hp":2,"immoveable":false,"probability":1,"race":"rabbit"},"redspider":{"bodyColor":"red","brainProps":{"avoidEntities":true,"leashRange":{"baseline":"tileSize","multiplier":5},"psychProfile":{"hostility":80},"randomWander":false,"scanPlayersOnly":false,"scanner":true,"seeker":"astar","targetLocationMaxDistance":{"baseline":"tileSize","multiplier":9},"targetLocationThresholdDistance":16,"v2":true},"faction":"wild","flags":{"devKillable":true,"dropsLootOnDeath":true,"isWildEnemy":true,"nonAggro":false,"patrolWander":true},"hp":4,"immoveable":false,"probability":1,"race":"redspider","sex":"male","speed":70},"slime":{"bodyColor":"green","brainProps":{"avoidEntities":true,"leashRange":{"baseline":"tileSize","multiplier":5},"psychProfile":{"hostility":80},"randomWander":false,"scanPlayersOnly":false,"scanner":true,"seeker":"astar","targetLocationMaxDistance":{"baseline":"tileSize","multiplier":9},"targetLocationThresholdDistance":16,"v2":true},"faction":"wild","flags":{"devKillable":true,"dropsLootOnDeath":true,"isWildEnemy":true,"nonAggro":false,"patrolWander":true},"hp":4,"immoveable":false,"probability":1,"race":"slime","sex":"male","speed":70},"snake":{"bodyColor":"green","brainProps":{"avoidEntities":true,"leashRange":{"baseline":"tileSize","multiplier":5},"psychProfile":{"hostility":80},"randomWander":false,"scanPlayersOnly":false,"scanner":true,"seeker":"astar","targetLocationMaxDistance":{"baseline":"tileSize","multiplier":9},"targetLocationThresholdDistance":16,"v2":true},"faction":"wild","flags":{"devKillable":true,"dropsLootOnDeath":true,"isWildEnemy":true,"nonAggro":false,"patrolWander":true},"hp":4,"immoveable":false,"probability":1,"race":"snake","sex":"male","speed":70}}}},"factions":{"chicken":"none","deer":"wild","rabbit":"wild","redspider":"wild","skeleton":"undead","wasp":"wild"},"itemDrops":{"armor-leather":[{"quantity":3,"reference":{"item":"shard-metal"}}],"armor-legion":[{"quantity":2,"reference":{"item":"shard-metal"}}],"armor-plate":[{"quantity":3,"reference":{"item":"shard-metal"}}],"axe":[{"quantity":2,"reference":{"item":"shard-metal"}}],"dagger":[{"quantity":1,"reference":{"item":"shard-metal"}}],"spear":[{"quantity":1,"reference":{"item":"shard-metal"}}]},"npcSpecs":{"bee":{"brainProps":{"randomWander":true,"scanPlayersOnly":false,"scanner":true,"seeker":"brute"},"npc":{"angle":0,"clickable":true,"faction":"none","hp":1,"name":"bee","persistable":false,"portable":false,"speed":{"baseline":"speed","multiplier":0.1},"spriteId":"bee","strikeable":false,"type":"marker"}}},"population":{"chicken":{"hp":{"baseline":"hp"},"maxSpeed":{"baseline":"speed","pctOfMax":0.05},"psych":{"chronotype":"diurnal","hostility":{"baseline":"hostility"}}},"deer":{"hp":{"baseline":"hp","pctOfMax":0.1},"maxSpeed":{"baseline":"speed","pctOfMax":1},"psych":{"hostility":{"baseline":"hostility"}}},"rabbit":{"hp":{"baseline":"hp"},"maxSpeed":{"baseline":"speed","pctOfMax":0.7},"psych":{"chronotype":"diurnal","hostility":{"baseline":"hostility"}}},"redspider":{"hp":{"baseline":"hp"},"maxSpeed":{"baseline":"speed","pctOfMax":0.05},"psych":{"attackPattern":"v2","chronotype":"diurnal","closeOnStun":true,"hostility":{"baseline":"hostility","pctOfMax":0.2}}},"skeleton":{"hp":{"baseline":"hp","pctOfMax":0.3},"maxSpeed":{"baseline":"speed"},"preSpawnEffect":{"durationMs":900,"type":"ground-rupture"},"psych":{"attackPattern":"v2","chronotype":"nocturnal","hostility":{"baseline":"hostility","pctOfMax":0.5}},"scanDistanceTiles":6},"slime":{"hp":{"baseline":"hp"},"maxSpeed":{"baseline":"speed","multiplier":0.15,"pctOfMax":0},"psych":{"chronotype":"diurnal","hostility":{"baseline":"hostility","pctOfMax":0.1}}},"snake":{"hp":1,"maxSpeed":{"baseline":"speed","multiplier":0.4,"pctOfMax":0},"psych":{"chronotype":"diurnal","hostility":{"baseline":"hostility","pctOfMax":0.6}}},"spikes1":{"hp":{"baseline":"hp"},"maxSpeed":0,"psych":{"chronotype":"diurnal","hostility":{"baseline":"hostility","pctOfMax":1}}},"wasp":{"hp":{"baseline":"hp"},"maxSpeed":{"baseline":"speed","pctOfMax":0.05},"psych":{"attackPattern":"swoop","chronotype":"diurnal","hostility":{"baseline":"hostility","pctOfMax":0.2}}},"zombie":{"hp":{"baseline":"hp","pctOfMax":0.3},"maxSpeed":5,"preSpawnEffect":{"durationMs":900,"type":"ground-rupture"},"psych":{"attackPattern":"v2","chronotype":"nocturnal","hostility":{"baseline":"hostility","pctOfMax":0.5}},"scanDistanceTiles":6}},"populationDefault":{"hp":{"baseline":"hp"},"maxSpeed":{"baseline":"speed","pctOfMax":0},"psych":{"aggroResponse":"default","attackPattern":"default","chronotype":"diurnal","closeOnStun":false,"hostility":{"baseline":"hostility","pctOfMax":0.25}}},"weapons":{"axe":{"baseDamage":3,"bulletSpeed":500,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":500,"manaCost":1,"maxDistance":32,"maxEntitiesHit":2,"maxParticles":2,"slotVisible":true},"bomb":{"equipOrder":3,"slotVisible":true},"bow":{"attackRange":128,"baseDamage":1,"bulletSpeed":500,"bulletSpriteId":"arrow-brown.png","bulletType":"arrow","equipOrder":0,"firingLatchMs":400,"manaCost":1,"maxDistance":160,"maxParticles":1,"slotVisible":true},"crossbow":{"attackRange":128,"baseDamage":1,"bulletSpeed":500,"bulletSpriteId":"arrow-brown.png","equipOrder":0,"firingLatchMs":400,"manaCost":1,"maxDistance":160,"maxParticles":1,"slotVisible":true},"dagger":{"baseDamage":1,"bulletSpeed":500,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":450,"manaCost":1,"maxDistance":32,"maxParticles":1,"pushStrength":0,"slotVisible":true},"emp":{"duration":3000,"equipOrder":2,"manaCost":6,"maxDistance":{"baseline":"tileSize","multiplier":8},"slotVisible":true},"flail":{"attackRange":64,"baseDamage":0.75,"bulletSpeed":500,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":250,"manaCost":3,"maxDistance":45,"maxEntitiesHit":3,"maxParticles":2,"pushStrength":1,"slotVisible":true},"halberd":{"baseDamage":1,"bulletSpeed":150,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":500,"manaCost":1,"maxDistance":20,"maxParticles":1,"slotVisible":true},"iron-pickaxe":{"baseDamage":1,"bulletSpeed":150,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":500,"manaCost":1,"maxDistance":20,"maxEntitiesHit":1,"maxParticles":1,"slotVisible":true},"longsword":{"attackRange":64,"baseDamage":2,"bulletSpeed":500,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":550,"manaCost":3,"maxDistance":50,"maxParticles":2,"pushStrength":1,"slotVisible":true},"mace":{"baseDamage":1,"bulletSpeed":150,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":500,"manaCost":1,"maxDistance":20,"maxParticles":1,"slotVisible":true},"none":{"baseDamage":1,"bulletSpeed":200,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":400,"manaCost":1,"maxDistance":25,"maxParticles":1,"slotVisible":true},"rapier":{"baseDamage":1,"bulletSpeed":150,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":500,"manaCost":1,"maxDistance":20,"maxParticles":1,"slotVisible":true},"saber":{"baseDamage":1.5,"bulletSpeed":500,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":500,"manaCost":3,"maxDistance":40,"maxParticles":2,"slotVisible":true},"scythe":{"baseDamage":1,"bulletSpeed":150,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":500,"manaCost":1,"maxDistance":20,"maxParticles":1,"slotVisible":true},"spear":{"baseDamage":1,"bulletSpeed":150,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":525,"manaCost":1,"maxDistance":50,"maxParticles":3,"slotVisible":true},"staff":{"slotVisible":true},"waraxe":{"attackRange":64,"baseDamage":1,"bulletSpeed":500,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":550,"manaCost":1,"maxDistance":40,"maxParticles":2,"pushStrength":2,"slotVisible":true},"warhammer":{"baseDamage":5,"bulletSpeed":150,"bulletSpriteId":"none","equipOrder":0,"firingLatchMs":600,"manaCost":1,"maxDistance":20,"maxParticles":1,"pushStrength":2,"slotVisible":true},"web":{"attackRange":128,"baseDamage":0,"bulletSpeed":500,"bulletSpriteId":"web-white.png","bulletType":"webAmmo","equipOrder":0,"firingLatchMs":400,"manaCost":1,"maxDistance":160,"maxParticles":1,"pushStrength":0,"slotVisible":true}}},"recipes":[{"ingredients":[{"quantity":5,"reference":{"item":"iron"}}],"output":{"item":"metal-bar-iron"},"quantity":1},{"ingredients":[{"quantity":5,"reference":{"item":"silver"}}],"output":{"item":"metal-bar-silver"},"quantity":1},{"ingredients":[{"quantity":5,"reference":{"item":"copper"}}],"output":{"item":"metal-bar-copper"},"quantity":1},{"ingredients":[{"quantity":5,"reference":{"item":"gold"}}],"output":{"item":"metal-bar-gold"},"quantity":1},{"ingredients":[{"quantity":1,"reference":{"item":"iron"}}],"output":{"item":"shard-metal"},"quantity":5},{"ingredients":[{"quantity":1,"reference":{"item":"wood"}}],"output":{"item":"stick"},"quantity":5},{"ingredients":[{"quantity":3,"reference":{"item":"straw"}}],"output":{"item":"rope"},"quantity":1},{"ingredients":[{"quantity":1,"reference":{"item":"wood"}}],"output":{"item":"planks"},"quantity":4},{"ingredients":[{"quantity":3,"reference":{"item":"planks"}}],"output":{"item":"wall-wood"},"quantity":1},{"ingredients":[{"quantity":3,"reference":{"item":"planks"}}],"output":{"item":"wall-stone"},"quantity":1},{"ingredients":[{"quantity":3,"reference":{"item":"planks"}}],"output":{"item":"floor-wood"},"quantity":1},{"ingredients":[{"quantity":3,"reference":{"item":"planks"}}],"output":{"item":"door-wood"},"quantity":1},{"ingredients":[{"quantity":5,"reference":{"item":"planks"}}],"output":{"item":"chest-wood"},"quantity":1},{"ingredients":[{"quantity":4,"reference":{"item":"planks"}}],"output":{"item":"roof-wood"},"quantity":1},{"ingredients":[{"quantity":2,"reference":{"item":"wood"}}],"output":{"item":"campfire"},"quantity":1},{"ingredients":[{"quantity":5,"reference":{"item":"stick"}},{"quantity":5,"reference":{"item":"shard-metal"}}],"output":{"color":"metal","item":"dagger"},"quantity":1},{"ingredients":[{"quantity":5,"reference":{"item":"stick"}}],"output":{"color":"brown","item":"dagger"},"quantity":1},{"ingredients":[{"quantity":2,"reference":{"item":"stick"}},{"quantity":3,"reference":{"item":"feather"}},{"quantity":2,"reference":{"item":"shard-metal"}}],"output":{"item":"arrow"},"quantity":10},{"ingredients":[{"quantity":3,"reference":{"item":"metal-bar-iron"}},{"quantity":2,"reference":{"item":"stick"}}],"output":{"item":"axe"},"quantity":1},{"ingredients":[{"quantity":5,"reference":{"item":"stick"}},{"quantity":3,"reference":{"item":"shard-metal"}}],"output":{"item":"iron-pickaxe"},"quantity":1},{"ingredients":[{"quantity":10,"reference":{"item":"wood"}},{"quantity":3,"reference":{"item":"shard-metal"}}],"output":{"item":"spear"},"quantity":1},{"ingredients":[{"quantity":3,"reference":{"item":"metal-bar-iron"}},{"quantity":1,"reference":{"item":"planks"}}],"output":{"item":"longsword"},"quantity":1},{"ingredients":[{"quantity":4,"reference":{"item":"metal-bar-iron"}},{"quantity":2,"reference":{"item":"planks"}}],"output":{"item":"waraxe"},"quantity":1},{"ingredients":[{"quantity":15,"reference":{"item":"stick"}},{"quantity":5,"reference":{"item":"shard-metal"}},{"quantity":2,"reference":{"item":"rope"}}],"output":{"item":"bow"},"quantity":1},{"ingredients":[{"quantity":3,"reference":{"item":"stick"}},{"quantity":1,"reference":{"item":"rope"}}],"output":{"item":"snare-rabbit"},"quantity":1},{"ingredients":[{"quantity":1,"reference":{"item":"copper"}},{"quantity":2,"reference":{"item":"coal"}},{"quantity":1,"reference":{"item":"spider-silk"}}],"output":{"item":"ember-charge"},"quantity":9},{"ingredients":[{"quantity":4,"reference":{"item":"planks"}}],"output":{"item":"stairs"},"quantity":1},{"ingredients":[{"quantity":4,"reference":{"item":"planks"}}],"output":{"item":"thatch-roof"},"quantity":1},{"ingredients":[{"quantity":3,"reference":{"item":"planks"}}],"output":{"item":"timber-frame-wall"},"quantity":1},{"ingredients":[{"quantity":2,"reference":{"item":"planks"}}],"output":{"item":"window-frame"},"quantity":1},{"ingredients":[{"quantity":3,"reference":{"item":"planks"}}],"output":{"item":"chimney-stack"},"quantity":1},{"ingredients":[{"quantity":2,"reference":{"item":"planks"}}],"output":{"item":"dormer-window"},"quantity":1},{"ingredients":[{"quantity":2,"reference":{"item":"planks"}}],"output":{"item":"hatch-wood"},"quantity":1},{"ingredients":[{"quantity":5,"reference":{"item":"planks"}}],"output":{"item":"castle-footing"},"quantity":1},{"ingredients":[{"quantity":5,"reference":{"item":"planks"}}],"output":{"item":"castle-wall"},"quantity":1},{"ingredients":[{"quantity":3,"reference":{"item":"planks"}}],"output":{"item":"castle-merlons"},"quantity":1},{"ingredients":[{"quantity":2,"reference":{"item":"planks"}}],"output":{"item":"arrow-slit"},"quantity":1},{"ingredients":[{"quantity":4,"reference":{"item":"planks"}}],"output":{"item":"tower-render"},"quantity":1}],"registry":{"armor":{"armor-leather":{"colors":["blue","brown","green"],"layers":[{"path":"torso/armour/leather/{sex}/{variant}.png","z":60}],"variants":{"blue":"blue","brown":"brown","green":"green"}},"armor-legion":{"colors":["brown","gray","gold"],"layers":[{"path":"torso/armour/legion/{sex}/{variant}.png","z":60}],"variants":{"brown":"bronze","gold":"gold","gray":"steel"}},"armor-plate":{"colors":["gray","metal","yellow","gold","orange","tan"],"layers":[{"path":"torso/armour/plate/{sex}/{variant}.png","z":60}],"variants":{"gold":"14","gray":"11","metal":"12","orange":"16","tan":"special","yellow":"12"}}},"bauldron":{"bauldron":{"colors":["brown"],"layers":[{"path":"bauldron/{sex}/brown.png","z":65}]}},"body":{"bee":{"colors":["yellow"],"groundAnchor":{"x":32,"y":60},"layers":[{"path":"body/{sex}/bee/yellow.png","z":10}]},"chicken":{"colors":["white"],"groundAnchor":{"x":16,"y":29},"layers":[{"path":"authored/lpc-chicken.png","z":10}],"shadow":{"feetY":45}},"deer":{"colors":["brown"],"groundAnchor":{"x":64,"y":87},"layers":[{"path":"body/{sex}/deer/brown.png","z":10}],"shadow":{"feetY":55}},"horse":{"colors":["brown"],"groundAnchor":{"x":64,"y":92},"layers":[{"path":"body/{sex}/horse/burdened/brown.png","z":10}]},"human":{"colors":["white","black","olive","brown","light","dark","tan"],"groundAnchor":{"x":32,"y":60},"layers":[{"path":"body/{sex}/human/{variant}.png","z":10}],"variants":{"black":"black","brown":"brown","dark":"dark","light":"light","olive":"olive","tan":"tanned","white":"white"}},"lpc-chicken":{"colors":["white"],"groundAnchor":{"x":16,"y":29},"layers":[{"path":"authored/lpc-chicken.png","z":10}],"shadow":{"feetY":45}},"lpc-viper":{"colors":["green"],"groundAnchor":{"x":32,"y":44},"layers":[{"path":"authored/lpc-viper.png","z":10}],"shadow":{"feetY":44}},"orc":{"colors":["gray","green","lightgreen"],"groundAnchor":{"x":32,"y":60},"layers":[{"path":"body/{sex}/orcs/{variant}.png","z":10}],"variants":{"gray":"gray","green":"green_1","lightgreen":"green_3"}},"rabbit":{"colors":["white"],"groundAnchor":{"x":36,"y":50},"layers":[{"path":"authored/wild-hare.png","z":10}],"shadow":{"feetY":46}},"rage-slime":{"colors":["green"],"groundAnchor":{"x":32,"y":44},"layers":[{"path":"authored/rage-slime.png","z":10}],"shadow":{"feetY":44}},"redspider":{"colors":["red"],"groundAnchor":{"x":32,"y":49},"layers":[{"path":"body/{sex}/redspider/red.png","z":10}],"shadow":{"feetY":49}},"reptile":{"colors":["green","lightgreen","blue"],"groundAnchor":{"x":32,"y":60},"layers":[{"path":"body/{sex}/reptiles/{variant}_unwinged.png","z":10}],"variants":{"blue":"blue","green":"green","lightgreen":"lightgreen"}},"reptile-winged":{"colors":["green","lightgreen","blue"],"groundAnchor":{"x":32,"y":60},"layers":[{"path":"body/{sex}/reptiles/{variant}_winged.png","z":10}],"variants":{"blue":"blue","green":"green","lightgreen":"lightgreen"}},"skeleton":{"colors":["white","gray","green"],"groundAnchor":{"x":32,"y":60},"layers":[{"path":"body/skeleton/{variant}.png","z":10}],"variants":{"gray":"gray","green":"green","white":"beige"}},"slime":{"colors":["green"],"groundAnchor":{"x":32,"y":49.4},"layers":[{"path":"authored/rage-slime.png","z":10}],"shadow":{"feetY":49.4}},"snake":{"colors":["green"],"groundAnchor":{"x":32,"y":44},"layers":[{"path":"authored/lpc-viper.png","z":10}],"shadow":{"feetY":44}},"spikes1":{"colors":["white"],"groundAnchor":{"x":16,"y":44},"layers":[{"path":"spike/spikes1.png","z":10}]},"wasp":{"colors":["yellow"],"groundAnchor":{"x":16,"y":44},"layers":[{"path":"body/{sex}/wasp/yellow.png","z":10}]},"wild-hare":{"colors":["white"],"groundAnchor":{"x":36,"y":50},"layers":[{"path":"authored/wild-hare.png","z":10}],"shadow":{"feetY":46}},"wolfman":{"colors":["brown","black","gray","white"],"groundAnchor":{"x":32,"y":60},"layers":[{"path":"body/{sex}/wolf/{variant}.png","z":10},{"path":"body/{sex}/wolf/head/{variant}.png","z":100}],"variants":{"black":"black","brown":"brown","gray":"gray","white":"white"}},"zombie":{"colors":["green"],"groundAnchor":{"x":32,"y":60},"layers":[{"path":"body/{sex}/special/zombie.png","z":10}]}},"cape":{"cape-solid":{"colors":["black","blue","brown","gray","green","maroon","red","white","yellow"],"layers":[{"path":"cape/solid/{sex}/{variant}.png","z":85},{"path":"cape/solid_behind/{variant}.png","z":5}],"variants":{"black":"black","blue":"blue","brown":"brown","gray":"gray","green":"green","maroon":"maroon","red":"red","white":"white","yellow":"yellow"}},"cape-tattered":{"colors":["black","blue","brown","gray","green","maroon","red","white","yellow"],"layers":[{"path":"cape/tattered/{sex}/{variant}.png","z":85},{"path":"cape/tattered_behind/{variant}.png","z":5}],"variants":{"black":"black","blue":"blue","brown":"brown","gray":"gray","green":"green","maroon":"maroon","red":"red","white":"white","yellow":"yellow"}},"cape-trimmed":{"colors":["white"],"layers":[{"path":"cape/trimmed/{sex}/white_blue.png","z":85},{"path":"cape/trimmed_behind/white_blue.png","z":5}]}},"eyes":{"cyclops":{"colors":["red"],"layers":[{"path":"eyes/{sex}/cyclope.png","z":20}]},"normal":{"colors":["blue","brown","gray","green","orange","purple","red","yellow"],"layers":[{"path":"eyes/{sex}/{variant}.png","z":20}],"variants":{"blue":"blue","brown":"brown","gray":"gray","green":"green","orange":"orange","purple":"purple","red":"red","yellow":"yellow"}}},"hair":{"afro":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/afro/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"balding":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/balding/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"bangs":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/bangs/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"bangs_bun":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/bangs_bun/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"bangslong":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/bangslong/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"bangslong2":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/bangslong2/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"bangsshort":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/bangsshort/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"bedhead":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/bedhead/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"bob":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/bob/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"bob_side_part":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/bob_side_part/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"braid":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/braid/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"braid2":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/braid2/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"bunches":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/bunches/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"buzzcut":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/buzzcut/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"cornrows":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/cornrows/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"cowlick":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/cowlick/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"cowlick_tall":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/cowlick_tall/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"curly_long":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/curly_long/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"curly_short":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/curly_short/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"curtains":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/curtains/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"curtains_long":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/curtains_long/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"dreadlocks_long":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/dreadlocks_long/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"dreadlocks_short":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/dreadlocks_short/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"flat_top_fade":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/flat_top_fade/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"flat_top_straight":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/flat_top_straight/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"half_up":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/half_up/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"halfmessy":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/halfmessy/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"high_and_tight":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/high_and_tight/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"high_ponytail":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/high_ponytail/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"idol":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/idol/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"jewfro":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/jewfro/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"lob":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/lob/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"long":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/long/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"long_band":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/long_band/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"long_center_part":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/long_center_part/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"long_messy":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/long_messy/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"long_messy2":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/long_messy2/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"long_tied":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/long_tied/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"longhawk":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/longhawk/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"longknot":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/longknot/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"loose":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/loose/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"messy1":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/messy1/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"messy2":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/messy2/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"messy3":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/messy3/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"mop":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/mop/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"natural":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/natural/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"page":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/page/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"page2":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/page2/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"part2":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/part2/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"parted":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/parted/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"pixie":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/pixie/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"plain":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/plain/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"ponytail":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/ponytail/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"ponytail2":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/ponytail2/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"princess":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/princess/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"sara":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/sara/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"shorthawk":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/shorthawk/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"shortknot":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/shortknot/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"shoulderl":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/shoulderl/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"shoulderr":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/shoulderr/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"single":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/single/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"spiked":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/spiked/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"spiked2":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/spiked2/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"spiked_beehive":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/spiked_beehive/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"spiked_liberty":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/spiked_liberty/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"spiked_liberty2":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/spiked_liberty2/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"spiked_porcupine":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/spiked_porcupine/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"swoop":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/swoop/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"twists_fade":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/twists_fade/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"twists_straight":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/twists_straight/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"unkempt":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/unkempt/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"wavy":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/wavy/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}},"xlong":{"colors":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"layers":[{"path":"hair/xlong/{sex}/{variant}.png","z":120}],"variants":{"black":"black","blonde":"blonde","blue":"blue","brown":"dark_brown","gold":"gold","gray":"gray","green":"green","lightbrown":"light_brown","orange":"orange","purple":"purple","red":"red","white":"white"}}},"nose":{"big":{"colors":["white","tan","gray"],"layers":[{"path":"head/nose/big/{sex}/{variant}.png","z":20}],"variants":{"gray":"darkelf","tan":"tanned","white":"light"}},"button":{"colors":["white","tan","gray"],"layers":[{"path":"head/nose/button/{sex}/{variant}.png","z":20}],"variants":{"gray":"darkelf","tan":"tanned","white":"light"}},"straight":{"colors":["white","tan","gray"],"layers":[{"path":"head/nose/straight/{sex}/{variant}.png","z":20}],"variants":{"gray":"darkelf","tan":"tanned","white":"light"}}},"pants":{"legion":{"colors":["brown"],"layers":[{"path":"legs/skirts/{sex}/legion.png","z":20}]},"pantaloons":{"colors":["black","blue","brown","gray","green","maroon","orange","purple","red","tan","white","yellow"],"layers":[{"path":"legs/pantaloons/{sex}/{variant}.png","z":20}],"variants":{"black":"black","blue":"blue","brown":"brown","gray":"gray","green":"green","maroon":"maroon","orange":"orange","purple":"purple","red":"red","tan":"tan","white":"white","yellow":"yellow"}},"pants":{"colors":["black","blue","brown","gray","green","maroon","orange","purple","red","tan","white","yellow"],"layers":[{"path":"legs/pants/{sex}/{variant}.png","z":20}],"variants":{"black":"black","blue":"blue","brown":"brown","gray":"gray","green":"green","maroon":"maroon","orange":"orange","purple":"purple","red":"red","tan":"tan","white":"white","yellow":"yellow"}},"pants-armor":{"colors":["gray","metal","yellow","gold","tan","orange"],"layers":[{"path":"legs/armour/{sex}/{variant}.png","z":20}],"variants":{"gold":"8","gray":"7","metal":"8","orange":"11","tan":"10","yellow":"9"}},"skirts":{"colors":["brown","black","white"],"layers":[{"path":"legs/skirts/{sex}/{variant}.png","z":20}],"variants":{"black":"black","brown":"brown","white":"white"}}},"shield":{"shield-crusader":{"colors":["white"],"layers":[{"path":"shield/{sex}/crusader.png","z":141}]},"shield-kite":{"colors":["gray","orange"],"layers":[{"path":"shield/{sex}/kite_{variant}.png","z":141}],"variants":{"gray":"gray","orange":"orange"}},"shield-kite_blue":{"colors":["blue","gray"],"layers":[{"path":"shield/{sex}/kite_blue_{variant}.png","z":141}],"variants":{"blue":"blue","gray":"gray"}},"shield-kite_gray":{"colors":["blue","gray","green","orange"],"layers":[{"path":"shield/{sex}/kite_gray_{variant}.png","z":141}],"variants":{"blue":"blue","gray":"gray","green":"green","orange":"orange"}},"shield-kite_green":{"colors":["gray"],"layers":[{"path":"shield/{sex}/kite_green_gray.png","z":141}]},"shield-kite_red":{"colors":["gray"],"layers":[{"path":"shield/{sex}/kite_red_gray.png","z":141}]},"shield-round":{"colors":["black","brown","gold","green","silver","yellow"],"layers":[{"path":"shield/{sex}/round_{variant}.png","z":141}],"variants":{"black":"black","brown":"brown","gold":"gold","green":"green","silver":"silver","yellow":"yellow"}},"shield-spartan":{"colors":["brown"],"layers":[{"path":"shield/{sex}/spartan.png","z":141}]}},"shirt":{"blouse":{"colors":["black","blue","green","maroon","purple","red","teal","white","yellow","tan","gray","orange"],"layers":[{"path":"torso/clothes/blouse/{sex}/{variant}.png","z":35}],"variants":{"black":"black","blue":"blue","gray":"gray","green":"green","maroon":"maroon","orange":"orange","purple":"purple","red":"red","tan":"tan","teal":"teal","white":"white","yellow":"yellow"}},"blouse_longsleeve":{"colors":["black","blue","green","maroon","purple","red","teal","white","yellow","tan","gray","orange"],"layers":[{"path":"torso/clothes/blouse_longsleeve/{sex}/{variant}.png","z":35}],"variants":{"black":"black","blue":"blue","gray":"gray","green":"green","maroon":"maroon","orange":"orange","purple":"purple","red":"red","tan":"tan","teal":"teal","white":"white","yellow":"yellow"}},"corset":{"colors":["black","blue","green","maroon","purple","red","teal","white","yellow","brown","tan","gray","orange"],"layers":[{"path":"torso/clothes/corset/{sex}/{variant}.png","z":35}],"variants":{"black":"black","blue":"blue","brown":"leather","gray":"gray","green":"green","maroon":"maroon","orange":"orange","purple":"purple","red":"red","tan":"tan","teal":"teal","white":"white","yellow":"yellow"}},"longsleeve":{"colors":["black","blue","green","maroon","purple","red","teal","white","yellow"],"layers":[{"path":"torso/clothes/longsleeve/{sex}/{variant}.png","z":35}],"variants":{"black":"black","blue":"blue","green":"green","maroon":"maroon","purple":"purple","red":"red","teal":"teal","white":"white","yellow":"yellow"}},"longsleeve_laced":{"colors":["black","blue","green","maroon","purple","red","teal","white","yellow","tan","gray","orange"],"layers":[{"path":"torso/clothes/longsleeve_laced/{sex}/{variant}.png","z":35}],"variants":{"black":"black","blue":"blue","gray":"gray","green":"green","maroon":"maroon","orange":"orange","purple":"purple","red":"red","tan":"tan","teal":"teal","white":"white","yellow":"yellow"}},"scoop_shirt":{"colors":["black","blue","green","maroon","purple","red","teal","white","yellow","gray","orange"],"layers":[{"path":"torso/clothes/scoop_shirt/{sex}/{variant}.png","z":35}],"variants":{"black":"black","blue":"blue","gray":"gray","green":"green","maroon":"maroon","orange":"orange","purple":"purple","red":"red","teal":"teal","white":"white","yellow":"yellow"}},"sleeveless":{"colors":["black","blue","green","maroon","purple","red","teal","white","yellow","brown","tan","gray","orange"],"layers":[{"path":"torso/clothes/sleeveless/{sex}/{variant}.png","z":35}],"variants":{"black":"black","blue":"blue","brown":"brown","gray":"gray","green":"green","maroon":"maroon","orange":"orange","purple":"purple","red":"red","tan":"tan","teal":"teal","white":"white","yellow":"yellow"}},"sleeveless_laced":{"colors":["black","blue","green","maroon","purple","red","teal","white","yellow","brown","tan","gray","orange"],"layers":[{"path":"torso/clothes/sleeveless_laced/{sex}/{variant}.png","z":35}],"variants":{"black":"black","blue":"blue","brown":"brown","gray":"gray","green":"green","maroon":"maroon","orange":"orange","purple":"purple","red":"red","tan":"tan","teal":"teal","white":"white","yellow":"yellow"}},"sleeveless_striped":{"colors":["black","blue","green","maroon","purple","red","teal","white","yellow","brown","tan","gray","orange"],"layers":[{"path":"torso/clothes/sleeveless_striped/{sex}/{variant}.png","z":35}],"variants":{"black":"black","blue":"blue","brown":"brown","gray":"gray","green":"green","maroon":"maroon","orange":"orange","purple":"purple","red":"red","tan":"tan","teal":"teal","white":"white","yellow":"yellow"}},"tanktop":{"colors":["black","blue","green","maroon","purple","red","teal","white","yellow","tan","gray","orange"],"layers":[{"path":"torso/clothes/tanktop/{sex}/{variant}.png","z":35}],"variants":{"black":"black","blue":"blue","gray":"gray","green":"green","maroon":"maroon","orange":"orange","purple":"purple","red":"red","tan":"tan","teal":"teal","white":"white","yellow":"yellow"}},"tunic":{"colors":["brown","maroon","teal","white"],"layers":[{"path":"torso/clothes/tunic/{sex}/{variant}.png","z":35}],"variants":{"brown":"brown","maroon":"maroon","teal":"teal","white":"white"}}},"shoes":{"boots":{"colors":["black","blue","brown","gray","green","maroon","orange","purple","red","tan","teal","white","yellow"],"layers":[{"path":"feet/boots/{sex}/{variant}.png","z":25}],"variants":{"black":"black","blue":"blue","brown":"brown","gray":"gray","green":"green","maroon":"maroon","orange":"orange","purple":"purple","red":"red","tan":"tan","teal":"teal","white":"white","yellow":"yellow"}},"sandals":{"colors":["brown"],"layers":[{"path":"feet/sandals/{sex}/brown.png","z":15}]},"shoes":{"colors":["black","brown","maroon"],"layers":[{"path":"feet/shoes/{sex}/{variant}.png","z":15}],"variants":{"black":"black","brown":"brown","maroon":"maroon"}},"shoes-armor":{"colors":["gray","metal","yellow","gold","tan","orange"],"layers":[{"path":"feet/armor/{sex}/{variant}.png","z":15}],"variants":{"gold":"7","gray":"4","metal":"5","orange":"9","tan":"8","yellow":"6"}},"slippers":{"colors":["black","brown","gray"],"layers":[{"path":"feet/slippers/{sex}/{variant}.png","z":15}],"variants":{"black":"black","brown":"brown","gray":"gray"}}},"weapon":{"axe":{"colors":["metal"],"layers":[{"path":"weapon/slash/{sex}/axe_2.png","z":140}]},"bow":{"colors":["brown"],"layers":[{"path":"weapon/bow/normal.png","z":140}]},"crossbow":{"colors":["brown"],"layers":[{"path":"weapon/thrust/{sex}/crossbow.png","z":140}]},"dagger":{"colors":["metal","brown"],"layers":[{"path":"weapon/slash/{sex}/{variant}.png","z":140}],"variants":{"brown":"dagger_brown","metal":"dagger"}},"flail":{"colors":["metal"],"layers":[{"path":"weapon/slash_oversize/{sex}/universal/flail.png","z":140},{"path":"weapon/slash_oversize/{sex}/flail.png","type":"oversize","z":150}]},"halberd":{"colors":["metal"],"layers":[{"path":"weapon/slash_oversize/{sex}/universal/halberd.png","z":140},{"path":"weapon/slash_oversize/{sex}/halberd.png","type":"oversize","z":150}]},"iron-pickaxe":{"colors":["na"],"layers":[{"path":"authored/iron-pickaxe/{sex}.png","z":140}]},"longsword":{"colors":["metal"],"layers":[{"path":"weapon/slash_oversize_layered/all/universal/behind/longsword.png","z":9},{"path":"weapon/slash_oversize_layered/all/universal/longsword.png","z":140},{"path":"weapon/slash_oversize_layered/all/longsword.png","type":"oversize","z":150}]},"mace":{"colors":["metal"],"layers":[{"path":"weapon/slash_oversize_layered/all/universal/behind/mace.png","z":9},{"path":"weapon/slash_oversize_layered/all/universal/mace.png","z":140},{"path":"weapon/slash_oversize_layered/all/mace.png","type":"oversize","z":150}]},"none":{"colors":[],"layers":[]},"rapier":{"colors":["metal"],"layers":[{"path":"weapon/slash_oversize_layered/all/universal/behind/rapier.png","z":9},{"path":"weapon/slash_oversize_layered/all/universal/rapier.png","z":140},{"path":"weapon/slash_oversize_layered/all/rapier.png","type":"oversize","z":150}]},"saber":{"colors":["metal"],"layers":[{"path":"weapon/slash_oversize_layered/all/universal/behind/saber.png","z":9},{"path":"weapon/slash_oversize_layered/all/universal/saber.png","z":140},{"path":"weapon/slash_oversize_layered/all/saber.png","type":"oversize","z":150}]},"scythe":{"colors":["metal"],"layers":[{"path":"weapon/slash_oversize_layered/all/universal/behind/scythe.png","z":9},{"path":"weapon/slash_oversize_layered/all/universal/scythe.png","z":140},{"path":"weapon/slash_oversize_layered/all/scythe.png","type":"oversize","z":150}]},"spear":{"colors":["brown","black","green","metal","purple"],"layers":[{"path":"weapon/thrust/{sex}/spear_{variant}.png","z":140}],"variants":{"black":"black","brown":"2","green":"green","metal":"metal","purple":"purple"}},"staff":{"colors":["brown"],"layers":[{"path":"weapon/thrust/{sex}/simple_staff.png","z":140}]},"waraxe":{"colors":["metal"],"layers":[{"path":"weapon/slash_oversize/{sex}/universal/waraxe.png","z":140},{"path":"weapon/slash_oversize/{sex}/waraxe.png","type":"oversize","z":150}]},"warhammer":{"colors":["metal"],"layers":[{"path":"weapon/slash/{sex}/warhammer.png","z":140}]},"web":{"colors":["white"],"layers":[]}}},"sprites":{"creatures":{"lpc-chicken":{"template":"chicken"},"lpc-viper":{"template":"snake"},"rage-slime":{"template":"snake"},"wild-hare":{"template":"rabbit"}},"dimensions":{"chicken":{"h":32,"w":32},"deer":{"h":128,"w":128},"horse":{"h":128,"w":128},"lpc-chicken":{"h":32,"w":32},"lpc-viper":{"h":64,"w":64},"rabbit":{"h":72,"w":72},"rage-slime":{"h":64,"w":64},"redspider":{"h":64,"w":64},"slime":{"h":64,"w":64},"snake":{"h":64,"w":64},"spikes1":{"h":32,"w":32},"wasp":{"h":32,"w":32},"wild-hare":{"h":72,"w":72}},"registration":{"ArmorTypes":["armor-plate","armor-leather","armor-legion"],"CapeTypes":["cape-solid","cape-tattered","cape-trimmed"],"DefaultAttackActionType":{"lpc-viper":"thrust","rage-slime":"thrust","redspider":"thrust","skeleton":"thrust","slime":"thrust","snake":"thrust","spikes1":"thrust","wasp":"thrust","zombie":"slash"},"EyeTypes":["normal","cyclops"],"HairTypes":["afro","balding","bangs","bangs_bun","bangslong","bangslong2","bangsshort","bedhead","bob","bob_side_part","braid","braid2","bunches","buzzcut","cornrows","cowlick","cowlick_tall","curly_long","curly_short","curtains","curtains_long","dreadlocks_long","dreadlocks_short","flat_top_fade","flat_top_straight","half_up","halfmessy","high_and_tight","high_ponytail","idol","jewfro","lob","long","long_band","long_center_part","long_messy","long_messy2","long_tied","longhawk","longknot","loose","messy1","messy2","messy3","mop","natural","page","page2","part2","parted","pixie","plain","ponytail","ponytail2","princess","sara","shorthawk","shortknot","shoulderl","shoulderr","single","spiked","spiked2","spiked_beehive","spiked_liberty","spiked_liberty2","spiked_porcupine","swoop","twists_fade","twists_straight","unkempt","wavy","xlong"],"HumanoidRaceTypes":["human","reptile","reptile-winged","orc","skeleton","wolfman","zombie"],"NoseTypes":["button","big","straight"],"PantsTypes":["pants-armor","pants","pantaloons","legion","skirts"],"RaceEyes":{"human":["normal"],"orc":["normal"],"skeleton":["normal"],"zombie":["normal"]},"RaceNoses":{"human":["big","button","straight"],"orc":["big","button","straight"],"reptile":[],"reptile-winged":[],"skeleton":["big","button","straight"],"wolfman":[],"zombie":["big","button","straight"]},"RaceSexes":{"bee":["male"],"chicken":["male"],"deer":["female"],"horse":["male"],"human":["male","female"],"lpc-chicken":["male"],"lpc-viper":["male"],"orc":["male","female"],"rabbit":["male"],"rage-slime":["male"],"redspider":["male"],"reptile":["male","female"],"reptile-winged":["male","female"],"skeleton":["male"],"slime":["male"],"snake":["male"],"spikes1":["male"],"wasp":["male"],"wild-hare":["male"],"wolfman":["male","female"],"zombie":["male"]},"RaceTypes":["human","reptile","reptile-winged","orc","skeleton","wolfman","zombie","horse","snake","deer","slime","rabbit","chicken","bee","wasp","redspider","spikes1","wild-hare","rage-slime","lpc-viper","lpc-chicken"],"RaceWeapons":{"human":["spear","bow","staff","axe","warhammer","none","iron-pickaxe"],"orc":["spear","bow","staff","axe","warhammer","none","iron-pickaxe"],"reptile":["spear","bow","staff","axe","warhammer","none","iron-pickaxe"],"reptile-winged":["spear","bow","staff","axe","warhammer","none","iron-pickaxe"],"skeleton":["spear","bow","staff","axe","warhammer","none","iron-pickaxe"],"wolfman":["spear","bow","staff","axe","warhammer","none","iron-pickaxe"],"zombie":["spear","bow","staff","axe","warhammer","none","iron-pickaxe"]},"SexCapes":{"female":["cape-tattered","cape-trimmed"],"male":["cape-solid"]},"SexHair":{"female":["afro","bangs","bangs_bun","bangslong","bangslong2","bangsshort","bedhead","bob","bob_side_part","braid","braid2","bunches","buzzcut","cornrows","cowlick","cowlick_tall","curly_long","curly_short","curtains","curtains_long","dreadlocks_long","dreadlocks_short","flat_top_fade","flat_top_straight","half_up","halfmessy","high_and_tight","high_ponytail","idol","jewfro","lob","long","long_band","long_center_part","long_messy","long_messy2","long_tied","longhawk","longknot","loose","messy1","messy2","messy3","mop","natural","page","page2","part2","parted","pixie","plain","ponytail","ponytail2","princess","sara","shorthawk","shortknot","shoulderl","shoulderr","single","spiked","spiked2","spiked_beehive","spiked_liberty","spiked_liberty2","spiked_porcupine","swoop","twists_fade","twists_straight","unkempt","wavy","xlong"],"male":["afro","balding","bangs","bangs_bun","bangslong","bangslong2","bangsshort","bedhead","buzzcut","cornrows","cowlick","cowlick_tall","curly_short","curtains","curtains_long","dreadlocks_long","dreadlocks_short","flat_top_fade","flat_top_straight","half_up","halfmessy","high_and_tight","high_ponytail","idol","jewfro","lob","long","long_center_part","long_messy","long_messy2","long_tied","longhawk","longknot","loose","messy1","messy2","messy3","mop","natural","page","page2","part2","parted","pixie","plain","ponytail","ponytail2","shorthawk","shortknot","single","spiked","spiked2","spiked_beehive","spiked_liberty","spiked_liberty2","spiked_porcupine","swoop","twists_fade","twists_straight","unkempt","wavy"]},"SexPants":{"female":["pants-armor","pants","legion","skirts"],"male":["pants-armor","pants","pantaloons","legion","skirts"]},"SexShirts":{"female":["blouse","blouse_longsleeve","corset","longsleeve","scoop_shirt","tanktop","tunic"],"male":["longsleeve","longsleeve_laced","sleeveless","sleeveless_laced","sleeveless_striped"]},"SexShoes":{"female":["shoes-armor","boots","sandals","shoes","slippers"],"male":["shoes-armor","boots","sandals","shoes"]},"ShieldTypes":["shield-crusader","shield-spartan","shield-round","shield-kite","shield-kite_blue","shield-kite_gray","shield-kite_green","shield-kite_red"],"ShirtTypes":["blouse","blouse_longsleeve","corset","longsleeve","longsleeve_laced","scoop_shirt","sleeveless","sleeveless_laced","sleeveless_striped","tanktop","tunic"],"ShoeTypes":["boots","shoes","shoes-armor","slippers","sandals"],"WeaponAction":{"axe":"slash","bow":"shoot","crossbow":"thrust","dagger":"slash","flail":"slash","halberd":"slash","iron-pickaxe":"slash","longsword":"slash","mace":"slash","none":"slash","rapier":"slash","saber":"slash","scythe":"slash","spear":"thrust","staff":"thrust","waraxe":"slash","warhammer":"slash","web":"shoot"},"WeaponAmmo":{"bow":"arrow","crossbow":"arrow","web":"webAmmo"},"WeaponTypes":["dagger","spear","bow","crossbow","staff","axe","warhammer","longsword","mace","rapier","saber","scythe","flail","halberd","waraxe","web","none","iron-pickaxe"]},"version":1,"weapons":{"iron-pickaxe":"axe"}},"tiles":{"damageDefaults":{"bonecaller-stone":0,"castle-footing":1,"castle-merlons":1,"castle-wall":1,"chest-wood":1,"door-wood":1,"floor-cobble":1,"floor-opening":0,"floor-stone":1,"floor-wood":1,"grassSprout":1,"grove-low-a":1,"grove-low-b":1,"grove-oak-a":1,"grove-oak-b":1,"grove-round-a":1,"grove-round-b":1,"grove-spruce-a":1,"grove-spruce-b":1,"meadow-grass-a":1,"meadow-grass-b":1,"meadow-grass-c":1,"meadow-grass-d":1,"meadow-grass-e":1,"meadow-grass-f":1,"meadow-sprout":1,"ore-coal":6,"railing-wood":1,"roof-wood":1,"sapling":1,"stairs-down":1,"stairs-up":1,"table-mid-round":1,"tallGrass":1,"tallReeds":1,"testore":6,"thatch-roof":1,"timber-frame-wall":1,"tower-render":1,"tree1Small":1,"tree2Small":1,"wall-stone":1,"wall-wood":1,"wall2-wood":1},"damageSpecifics":{"castle-footing":[{"damage":1,"weaponType":"dagger"},{"damage":1,"weaponType":"saber"},{"damage":1,"weaponType":"spear"},{"damage":1,"weaponType":"longsword"},{"damage":2,"weaponType":"mace"},{"damage":2,"weaponType":"axe"},{"damage":2,"weaponType":"waraxe"},{"damage":6,"weaponType":"warhammer"},{"damage":4,"weaponType":"iron-pickaxe"}],"castle-merlons":[{"damage":1,"weaponType":"dagger"},{"damage":1,"weaponType":"saber"},{"damage":1,"weaponType":"spear"},{"damage":1,"weaponType":"longsword"},{"damage":2,"weaponType":"mace"},{"damage":2,"weaponType":"axe"},{"damage":2,"weaponType":"waraxe"},{"damage":6,"weaponType":"warhammer"},{"damage":4,"weaponType":"iron-pickaxe"}],"castle-wall":[{"damage":1,"weaponType":"dagger"},{"damage":1,"weaponType":"saber"},{"damage":1,"weaponType":"spear"},{"damage":1,"weaponType":"longsword"},{"damage":2,"weaponType":"mace"},{"damage":2,"weaponType":"axe"},{"damage":2,"weaponType":"waraxe"},{"damage":6,"weaponType":"warhammer"},{"damage":4,"weaponType":"iron-pickaxe"}],"grassSprout":[{"damage":0,"weaponType":"bow"},{"damage":0,"weaponType":"crossbow"},{"damage":0,"weaponType":"web"}],"grove-low-a":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"grove-low-b":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"grove-oak-a":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"grove-oak-b":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"grove-round-a":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"grove-round-b":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"grove-spruce-a":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"grove-spruce-b":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"meadow-grass-a":[{"damage":0,"weaponType":"bow"},{"damage":0,"weaponType":"web"},{"damage":1,"weaponType":"longsword"},{"damage":0,"weaponType":"crossbow"},{"damage":30,"weaponType":"warhammer"}],"meadow-grass-b":[{"damage":0,"weaponType":"bow"},{"damage":0,"weaponType":"web"},{"damage":1,"weaponType":"longsword"},{"damage":0,"weaponType":"crossbow"},{"damage":30,"weaponType":"warhammer"}],"meadow-grass-c":[{"damage":0,"weaponType":"bow"},{"damage":0,"weaponType":"web"},{"damage":1,"weaponType":"longsword"},{"damage":0,"weaponType":"crossbow"},{"damage":30,"weaponType":"warhammer"}],"meadow-grass-d":[{"damage":0,"weaponType":"bow"},{"damage":0,"weaponType":"web"},{"damage":1,"weaponType":"longsword"},{"damage":0,"weaponType":"crossbow"},{"damage":30,"weaponType":"warhammer"}],"meadow-grass-e":[{"damage":0,"weaponType":"bow"},{"damage":0,"weaponType":"web"},{"damage":1,"weaponType":"longsword"},{"damage":0,"weaponType":"crossbow"},{"damage":30,"weaponType":"warhammer"}],"meadow-grass-f":[{"damage":0,"weaponType":"bow"},{"damage":0,"weaponType":"web"},{"damage":1,"weaponType":"longsword"},{"damage":0,"weaponType":"crossbow"},{"damage":30,"weaponType":"warhammer"}],"meadow-sprout":[{"damage":0,"weaponType":"bow"},{"damage":0,"weaponType":"crossbow"},{"damage":0,"weaponType":"web"}],"ore-coal":[{"damage":30,"weaponType":"warhammer"},{"damage":15,"weaponType":"iron-pickaxe"}],"palmTree1":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"palmTree2":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"palmTree3":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"palmTree4":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"palmTree5":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"palmTree6":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"railing-wood":[{"damage":3,"weaponType":"dagger"},{"damage":3,"weaponType":"saber"},{"damage":3,"weaponType":"spear"},{"damage":3,"weaponType":"longsword"},{"damage":3,"weaponType":"mace"},{"damage":4,"weaponType":"axe"},{"damage":4,"weaponType":"waraxe"},{"damage":8,"weaponType":"warhammer"}],"sapling":[{"damage":0,"weaponType":"bow"},{"damage":0,"weaponType":"web"},{"damage":1,"weaponType":"longsword"},{"damage":0,"weaponType":"crossbow"},{"damage":30,"weaponType":"warhammer"}],"smallTree1":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"tallGrass":[{"damage":0,"weaponType":"bow"},{"damage":0,"weaponType":"web"},{"damage":1,"weaponType":"longsword"},{"damage":0,"weaponType":"crossbow"},{"damage":30,"weaponType":"warhammer"}],"tallReeds":[{"damage":0,"weaponType":"bow"},{"damage":0,"weaponType":"web"},{"damage":1,"weaponType":"longsword"},{"damage":0,"weaponType":"crossbow"},{"damage":30,"weaponType":"warhammer"}],"testore":[{"damage":30,"weaponType":"warhammer"},{"damage":15,"weaponType":"iron-pickaxe"}],"timber-frame-wall":[{"damage":3,"weaponType":"dagger"},{"damage":3,"weaponType":"saber"},{"damage":3,"weaponType":"spear"},{"damage":3,"weaponType":"longsword"},{"damage":3,"weaponType":"mace"},{"damage":4,"weaponType":"axe"},{"damage":4,"weaponType":"waraxe"},{"damage":8,"weaponType":"warhammer"}],"tower-render":[{"damage":1,"weaponType":"dagger"},{"damage":1,"weaponType":"saber"},{"damage":1,"weaponType":"spear"},{"damage":1,"weaponType":"longsword"},{"damage":2,"weaponType":"mace"},{"damage":2,"weaponType":"axe"},{"damage":2,"weaponType":"waraxe"},{"damage":6,"weaponType":"warhammer"},{"damage":4,"weaponType":"iron-pickaxe"}],"tree1":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"tree1Small":[{"damage":0,"weaponType":"bow"},{"damage":0,"weaponType":"web"},{"damage":1,"weaponType":"longsword"},{"damage":0,"weaponType":"crossbow"},{"damage":30,"weaponType":"warhammer"}],"tree2":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"tree2Small":[{"damage":0,"weaponType":"bow"},{"damage":0,"weaponType":"web"},{"damage":1,"weaponType":"longsword"},{"damage":0,"weaponType":"crossbow"},{"damage":30,"weaponType":"warhammer"}],"tree3":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"tree4":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"tree5":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"tree6":[{"damage":6,"weaponType":"dagger"},{"damage":6,"weaponType":"spear"},{"damage":6,"weaponType":"longsword"},{"damage":10,"weaponType":"waraxe"},{"damage":10,"weaponType":"axe"},{"damage":30,"weaponType":"warhammer"},{"damage":1,"weaponType":"bow"},{"damage":1,"weaponType":"web"},{"damage":1,"weaponType":"crossbow"},{"damage":1,"weaponType":"none"},{"damage":6,"weaponType":"iron-pickaxe"}],"wall-stone":[{"damage":3,"weaponType":"warhammer"}],"wall-wood":[{"damage":3,"weaponType":"dagger"},{"damage":3,"weaponType":"saber"},{"damage":3,"weaponType":"spear"},{"damage":3,"weaponType":"longsword"},{"damage":3,"weaponType":"mace"},{"damage":4,"weaponType":"axe"},{"damage":4,"weaponType":"waraxe"},{"damage":8,"weaponType":"warhammer"}],"wall2-wood":[{"damage":3,"weaponType":"dagger"},{"damage":3,"weaponType":"saber"},{"damage":3,"weaponType":"spear"},{"damage":3,"weaponType":"longsword"},{"damage":3,"weaponType":"mace"},{"damage":4,"weaponType":"axe"},{"damage":4,"weaponType":"waraxe"},{"damage":8,"weaponType":"warhammer"}]},"definitions":{"bonecaller-stone":{"growthSequence":[],"hp":100,"onDestructionCreateItems":[]},"castle-footing":{"growthSequence":[],"hp":160,"onDestructionCreateItems":[{"itemType":{"item":"castle-footing"},"probability":1,"quantity":1,"replicate":false}]},"castle-merlons":{"growthSequence":[],"hp":100,"onDestructionCreateItems":[{"itemType":{"item":"castle-merlons"},"probability":1,"quantity":1,"replicate":false}]},"castle-wall":{"growthSequence":[],"hp":140,"onDestructionCreateItems":[{"itemType":{"item":"castle-wall"},"probability":1,"quantity":1,"replicate":false}]},"chest-wood":{"growthSequence":[],"hp":3,"onDestructionCreateItems":[{"itemType":{"item":"chest-wood"},"probability":1,"quantity":1,"replicate":false}]},"door-wood":{"growthSequence":[],"hp":5,"onDestructionCreateItems":[{"itemType":{"item":"door-wood"},"probability":1,"quantity":1,"replicate":false}]},"floor-cobble":{"growthSequence":[],"hp":10,"onDestructionCreateItems":[{"itemType":{"item":"floor-cobble"},"probability":1,"quantity":1,"replicate":false}]},"floor-opening":{"growthSequence":[],"hp":1000000,"onDestructionCreateItems":[]},"floor-stone":{"growthSequence":[],"hp":10,"onDestructionCreateItems":[{"itemType":{"item":"floor-stone"},"probability":1,"quantity":1,"replicate":false}]},"floor-wood":{"growthSequence":[],"hp":5,"onDestructionCreateItems":[{"itemType":{"item":"floor-wood"},"probability":1,"quantity":1,"replicate":false}]},"grassSprout":{"grass":"sprout","growthSequence":[],"hp":1,"onDestructionCreateItems":[]},"grove-low-a":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-low-b":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-oak-a":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree1Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-oak-b":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree1Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-round-a":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-round-b":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-spruce-a":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree1Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-spruce-b":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree1Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"meadow-grass-a":{"grass":"long","growthSequence":[{"entityTileId":"meadow-sprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"item":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}]},"meadow-grass-b":{"grass":"long","growthSequence":[{"entityTileId":"meadow-sprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"item":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}]},"meadow-grass-c":{"grass":"long","growthSequence":[{"entityTileId":"meadow-sprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"item":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}]},"meadow-grass-d":{"grass":"long","growthSequence":[{"entityTileId":"meadow-sprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"item":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}]},"meadow-grass-e":{"grass":"long","growthSequence":[{"entityTileId":"meadow-sprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"item":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}]},"meadow-grass-f":{"grass":"long","growthSequence":[{"entityTileId":"meadow-sprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"item":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}]},"meadow-sprout":{"grass":"sprout","growthSequence":[],"hp":1,"onDestructionCreateItems":[]},"ore-coal":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"coal"},"probability":1,"quantity":3,"replicate":false}]},"palmTree1":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"palmTree2":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"palmTree3":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"palmTree4":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"palmTree5":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"palmTree6":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"railing-wood":{"growthSequence":[],"hp":4,"onDestructionCreateItems":[{"itemType":{"item":"railing-wood"},"probability":1,"quantity":1,"replicate":false}]},"roof-wood":{"growthSequence":[],"hp":5,"onDestructionCreateItems":[{"itemType":{"item":"roof-wood"},"probability":1,"quantity":1,"replicate":false}]},"sapling":{"growthSequence":[],"hp":1,"onDestructionCreateItems":[]},"smallTree1":{"growthSequence":[{"entityTileId":"tree2Small","requiredTime":30}],"hp":15,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false}],"tree":"grown"},"stairs-down":{"growthSequence":[],"hp":10,"onDestructionCreateItems":[{"itemType":{"item":"stairs"},"probability":1,"quantity":1,"replicate":false}]},"stairs-up":{"growthSequence":[],"hp":10,"onDestructionCreateItems":[{"itemType":{"item":"stairs"},"probability":1,"quantity":1,"replicate":false}]},"table-mid-round":{"growthSequence":[],"hp":5,"onDestructionCreateItems":[{"itemType":{"item":"table-mid-round"},"probability":1,"quantity":1,"replicate":false}]},"tallGrass":{"grass":"long","growthSequence":[{"entityTileId":"grassSprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"item":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}]},"tallReeds":{"growthSequence":[],"hp":3,"onDestructionCreateItems":[]},"testore":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"coal"},"probability":0.25,"quantity":3,"replicate":false},{"itemType":{"item":"iron"},"probability":0.15,"quantity":3,"replicate":false},{"itemType":{"item":"copper"},"probability":0.1,"quantity":3,"replicate":false},{"itemType":{"item":"silver"},"probability":0.05,"quantity":3,"replicate":false},{"itemType":{"item":"gold"},"probability":0.025,"quantity":3,"replicate":false}]},"thatch-roof":{"growthSequence":[],"hp":5,"onDestructionCreateItems":[{"itemType":{"item":"thatch-roof"},"probability":1,"quantity":1,"replicate":false}]},"timber-frame-wall":{"growthSequence":[],"hp":50,"onDestructionCreateItems":[{"itemType":{"item":"timber-frame-wall"},"probability":1,"quantity":1,"replicate":false}]},"tower-render":{"growthSequence":[],"hp":120,"onDestructionCreateItems":[{"itemType":{"item":"tower-render"},"probability":1,"quantity":1,"replicate":false}]},"tree1":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree1Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"tree1Small":{"growthSequence":[],"hp":3,"onDestructionCreateItems":[],"tree":"young"},"tree2":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"tree2Small":{"growthSequence":[],"hp":3,"onDestructionCreateItems":[],"tree":"young"},"tree3":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"tree4":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"tree5":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"tree6":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"item":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"item":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"wall-stone":{"growthSequence":[],"hp":5,"onDestructionCreateItems":[{"itemType":{"item":"wall-stone"},"probability":1,"quantity":1,"replicate":false}]},"wall-wood":{"growthSequence":[],"hp":50,"onDestructionCreateItems":[{"itemType":{"item":"wall-wood"},"probability":1,"quantity":1,"replicate":false}]},"wall2-wood":{"growthSequence":[],"hp":50,"onDestructionCreateItems":[{"itemType":{"item":"wall2-wood"},"probability":1,"quantity":1,"replicate":false}]}},"types":["bonecaller-stone","chest-wood","door-wood","floor-cobble","floor-stone","floor-wood","grassSprout","ore-coal","palmTree1","palmTree2","palmTree3","palmTree4","palmTree5","palmTree6","roof-wood","sapling","smallTree1","table-mid-round","tallGrass","tallReeds","testore","tree1","tree1Small","tree2","tree2Small","tree3","tree4","tree5","tree6","wall-stone","wall-wood","railing-wood","wall2-wood","stairs-up","stairs-down","floor-opening","timber-frame-wall","thatch-roof","grove-oak-a","grove-oak-b","grove-spruce-a","grove-spruce-b","grove-round-a","grove-round-b","grove-low-a","grove-low-b","meadow-grass-a","meadow-grass-b","meadow-grass-c","meadow-grass-d","meadow-grass-e","meadow-grass-f","meadow-sprout","castle-footing","castle-wall","castle-merlons","tower-render"]},"vocabularies":{"colors":["white","blonde","yellow","light","lightgreen","gold","green","teal","blue","orange","maroon","red","purple","olive","tan","lightbrown","brown","dark","gray","silver","metal","pink","black","na"]}},"spriteColors":{"armor":{"armor-leather":["blue","brown","green"],"armor-legion":["brown","gray","gold"],"armor-plate":["gray","metal","yellow","gold","orange","tan"]},"bauldron":{"bauldron":["brown"]},"body":{"bee":["yellow"],"chicken":["white"],"deer":["brown"],"horse":["brown"],"human":["white","black","olive","brown","light","dark","tan"],"lpc-chicken":["white"],"lpc-viper":["green"],"orc":["gray","green","lightgreen"],"rabbit":["white"],"rage-slime":["green"],"redspider":["red"],"reptile":["green","lightgreen","blue"],"reptile-winged":["green","lightgreen","blue"],"skeleton":["white","gray","green"],"slime":["green"],"snake":["green"],"spikes1":["white"],"wasp":["yellow"],"wild-hare":["white"],"wolfman":["brown","black","gray","white"],"zombie":["green"]},"cape":{"cape-solid":["black","blue","brown","gray","green","maroon","red","white","yellow"],"cape-tattered":["black","blue","brown","gray","green","maroon","red","white","yellow"],"cape-trimmed":["white"]},"eyes":{"cyclops":["red"],"normal":["blue","brown","gray","green","orange","purple","red","yellow"]},"hair":{"afro":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"balding":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"bangs":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"bangs_bun":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"bangslong":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"bangslong2":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"bangsshort":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"bedhead":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"bob":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"bob_side_part":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"braid":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"braid2":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"bunches":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"buzzcut":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"cornrows":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"cowlick":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"cowlick_tall":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"curly_long":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"curly_short":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"curtains":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"curtains_long":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"dreadlocks_long":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"dreadlocks_short":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"flat_top_fade":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"flat_top_straight":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"half_up":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"halfmessy":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"high_and_tight":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"high_ponytail":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"idol":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"jewfro":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"lob":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"long":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"long_band":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"long_center_part":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"long_messy":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"long_messy2":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"long_tied":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"longhawk":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"longknot":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"loose":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"messy1":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"messy2":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"messy3":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"mop":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"natural":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"page":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"page2":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"part2":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"parted":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"pixie":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"plain":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"ponytail":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"ponytail2":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"princess":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"sara":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"shorthawk":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"shortknot":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"shoulderl":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"shoulderr":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"single":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"spiked":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"spiked2":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"spiked_beehive":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"spiked_liberty":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"spiked_liberty2":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"spiked_porcupine":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"swoop":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"twists_fade":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"twists_straight":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"unkempt":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"wavy":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"],"xlong":["white","blonde","gold","green","blue","red","orange","purple","brown","lightbrown","gray","black"]},"nose":{"big":["white","tan","gray"],"button":["white","tan","gray"],"straight":["white","tan","gray"]},"pants":{"legion":["brown"],"pantaloons":["black","blue","brown","gray","green","maroon","orange","purple","red","tan","white","yellow"],"pants":["black","blue","brown","gray","green","maroon","orange","purple","red","tan","white","yellow"],"pants-armor":["gray","metal","yellow","gold","tan","orange"],"skirts":["brown","black","white"]},"shield":{"shield-crusader":["white"],"shield-kite":["gray","orange"],"shield-kite_blue":["blue","gray"],"shield-kite_gray":["blue","gray","green","orange"],"shield-kite_green":["gray"],"shield-kite_red":["gray"],"shield-round":["black","brown","gold","green","silver","yellow"],"shield-spartan":["brown"]},"shirt":{"blouse":["black","blue","green","maroon","purple","red","teal","white","yellow","tan","gray","orange"],"blouse_longsleeve":["black","blue","green","maroon","purple","red","teal","white","yellow","tan","gray","orange"],"corset":["black","blue","green","maroon","purple","red","teal","white","yellow","brown","tan","gray","orange"],"longsleeve":["black","blue","green","maroon","purple","red","teal","white","yellow"],"longsleeve_laced":["black","blue","green","maroon","purple","red","teal","white","yellow","tan","gray","orange"],"scoop_shirt":["black","blue","green","maroon","purple","red","teal","white","yellow","gray","orange"],"sleeveless":["black","blue","green","maroon","purple","red","teal","white","yellow","brown","tan","gray","orange"],"sleeveless_laced":["black","blue","green","maroon","purple","red","teal","white","yellow","brown","tan","gray","orange"],"sleeveless_striped":["black","blue","green","maroon","purple","red","teal","white","yellow","brown","tan","gray","orange"],"tanktop":["black","blue","green","maroon","purple","red","teal","white","yellow","tan","gray","orange"],"tunic":["brown","maroon","teal","white"]},"shoes":{"boots":["black","blue","brown","gray","green","maroon","orange","purple","red","tan","teal","white","yellow"],"sandals":["brown"],"shoes":["black","brown","maroon"],"shoes-armor":["gray","metal","yellow","gold","tan","orange"],"slippers":["black","brown","gray"]},"weapon":{"axe":["metal"],"bow":["brown"],"crossbow":["brown"],"dagger":["metal","brown"],"flail":["metal"],"halberd":["metal"],"iron-pickaxe":["na"],"longsword":["metal"],"mace":["metal"],"none":[],"rapier":["metal"],"saber":["metal"],"scythe":["metal"],"spear":["brown","black","green","metal","purple"],"staff":["brown"],"waraxe":["metal"],"warhammer":["metal"],"web":["white"]}},"tiles":{"bonecaller-stone":{"growthSequence":[],"hp":100,"onDestructionCreateItems":[]},"castle-footing":{"growthSequence":[],"hp":160,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"authored-terrain:824","type":"castle-footing"},"probability":1,"quantity":1,"replicate":false}]},"castle-merlons":{"growthSequence":[],"hp":100,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"authored-terrain:924","type":"castle-merlons"},"probability":1,"quantity":1,"replicate":false}]},"castle-wall":{"growthSequence":[],"hp":140,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"authored-terrain:872","type":"castle-wall"},"probability":1,"quantity":1,"replicate":false}]},"chest-wood":{"growthSequence":[],"hp":3,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"container:140","type":"chest-wood"},"probability":1,"quantity":1,"replicate":false}]},"door-wood":{"growthSequence":[],"hp":5,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"fence_medieval:478","type":"door-wood"},"probability":1,"quantity":1,"replicate":false}]},"floor-cobble":{"growthSequence":[],"hp":10,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"floors:225","type":"floor-cobble"},"probability":1,"quantity":1,"replicate":false}]},"floor-opening":{"growthSequence":[],"hp":1000000,"onDestructionCreateItems":[]},"floor-stone":{"growthSequence":[],"hp":10,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"floors:129","type":"floor-stone"},"probability":1,"quantity":1,"replicate":false}]},"floor-wood":{"growthSequence":[],"hp":5,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"floors:33","type":"floor-wood"},"probability":1,"quantity":1,"replicate":false}]},"grassSprout":{"grass":"sprout","growthSequence":[],"hp":1,"onDestructionCreateItems":[]},"grove-low-a":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-low-b":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-oak-a":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree1Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-oak-b":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree1Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-round-a":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-round-b":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-spruce-a":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree1Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"grove-spruce-b":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree1Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"meadow-grass-a":{"grass":"long","growthSequence":[{"entityTileId":"meadow-sprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"item-art-b9ef00e25a4177065abd:1","type":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}]},"meadow-grass-b":{"grass":"long","growthSequence":[{"entityTileId":"meadow-sprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"item-art-b9ef00e25a4177065abd:1","type":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}]},"meadow-grass-c":{"grass":"long","growthSequence":[{"entityTileId":"meadow-sprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"item-art-b9ef00e25a4177065abd:1","type":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}]},"meadow-grass-d":{"grass":"long","growthSequence":[{"entityTileId":"meadow-sprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"item-art-b9ef00e25a4177065abd:1","type":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}]},"meadow-grass-e":{"grass":"long","growthSequence":[{"entityTileId":"meadow-sprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"item-art-b9ef00e25a4177065abd:1","type":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}]},"meadow-grass-f":{"grass":"long","growthSequence":[{"entityTileId":"meadow-sprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"item-art-b9ef00e25a4177065abd:1","type":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}]},"meadow-sprout":{"grass":"sprout","growthSequence":[],"hp":1,"onDestructionCreateItems":[]},"ore-coal":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"na","spriteId":"ore:161","type":"coal"},"probability":1,"quantity":3,"replicate":false}]},"palmTree1":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"palmTree2":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"palmTree3":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"palmTree4":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"palmTree5":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"palmTree6":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"railing-wood":{"growthSequence":[],"hp":4,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"fence_medieval:1","type":"railing-wood"},"probability":1,"quantity":1,"replicate":false}]},"roof-wood":{"growthSequence":[],"hp":5,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"authored-terrain:807","type":"roof-wood"},"probability":1,"quantity":1,"replicate":false}]},"sapling":{"growthSequence":[],"hp":1,"onDestructionCreateItems":[]},"smallTree1":{"growthSequence":[{"entityTileId":"tree2Small","requiredTime":30}],"hp":15,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false}],"tree":"grown"},"stairs-down":{"growthSequence":[],"hp":10,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"stairs-icon:1","type":"stairs"},"probability":1,"quantity":1,"replicate":false}]},"stairs-up":{"growthSequence":[],"hp":10,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"stairs-icon:1","type":"stairs"},"probability":1,"quantity":1,"replicate":false}]},"table-mid-round":{"growthSequence":[],"hp":5,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"furniture-blonde-wood:124","type":"table-mid-round"},"probability":1,"quantity":1,"replicate":false}]},"tallGrass":{"grass":"long","growthSequence":[{"entityTileId":"grassSprout","requiredTime":15}],"hp":2,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"item-art-b9ef00e25a4177065abd:1","type":"straw"},"probability":0.5,"quantity":3,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}]},"tallReeds":{"growthSequence":[],"hp":3,"onDestructionCreateItems":[]},"testore":{"growthSequence":[],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"na","spriteId":"ore:161","type":"coal"},"probability":0.25,"quantity":3,"replicate":false},{"itemType":{"class":"resource","color":"na","spriteId":"ore:179","type":"iron"},"probability":0.15,"quantity":3,"replicate":false},{"itemType":{"class":"resource","color":"na","spriteId":"ore:180","type":"copper"},"probability":0.1,"quantity":3,"replicate":false},{"itemType":{"class":"resource","color":"na","spriteId":"ore:181","type":"silver"},"probability":0.05,"quantity":3,"replicate":false},{"itemType":{"class":"resource","color":"na","spriteId":"ore:182","type":"gold"},"probability":0.025,"quantity":3,"replicate":false}]},"thatch-roof":{"growthSequence":[],"hp":5,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"authored-terrain:378","type":"thatch-roof"},"probability":1,"quantity":1,"replicate":false}]},"timber-frame-wall":{"growthSequence":[],"hp":50,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"authored-terrain:50","type":"timber-frame-wall"},"probability":1,"quantity":1,"replicate":false}]},"tower-render":{"growthSequence":[],"hp":120,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"authored-terrain:927","type":"tower-render"},"probability":1,"quantity":1,"replicate":false}]},"tree1":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree1Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"tree1Small":{"growthSequence":[],"hp":3,"onDestructionCreateItems":[],"tree":"young"},"tree2":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"tree2Small":{"growthSequence":[],"hp":3,"onDestructionCreateItems":[],"tree":"young"},"tree3":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"tree4":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"tree5":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"tree6":{"growthSequence":[{"entityTileId":"sapling","requiredTime":10},{"entityTileId":"tree2Small","requiredTime":20}],"hp":30,"onDestructionCreateItems":[{"itemType":{"class":"resource","color":"brown","noGlint":true,"spriteId":null,"type":"wood"},"probability":1,"quantity":2,"replicate":false},{"itemType":{"class":"resource","color":"na","noGlint":true,"spriteId":"seed-green.png","type":"seed"},"probability":1,"quantity":2,"replicate":true}],"tree":"grown"},"wall-stone":{"growthSequence":[],"hp":5,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"walls2:53","type":"wall-stone"},"probability":1,"quantity":1,"replicate":false}]},"wall-wood":{"growthSequence":[],"hp":50,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"authored-terrain:643","type":"wall-wood"},"probability":1,"quantity":1,"replicate":false}]},"wall2-wood":{"growthSequence":[],"hp":50,"onDestructionCreateItems":[{"itemType":{"class":"structure","color":"na","spriteId":"walls2:43","type":"wall2-wood"},"probability":1,"quantity":1,"replicate":false}]}},"weapons":{"iron-pickaxe":"axe"}}');


const $59a4975031bf42fe$export$5f7ad4bf4d14138b = (value)=>{
    const normalize = (v)=>{
        if (Array.isArray(v)) return v.map(normalize);
        if (v && typeof v === "object") return Object.keys(v).sort().reduce((out, key)=>{
            if (v[key] !== undefined) out[key] = normalize(v[key]);
            return out;
        }, {});
        return v;
    };
    return JSON.stringify(normalize(value), null, 2) + "\n";
};
const $59a4975031bf42fe$export$d682c65f11e12f14 = (profiles, bases)=>{
    const result = Object.create(null);
    const visiting = new Set();
    const visit = (id)=>{
        if (result[id]) return result[id];
        if (visiting.has(id)) throw new Error(`Template cycle at ${id}`);
        const profile = profiles[id];
        if (!profile) throw new Error(`Unknown template ${id}`);
        visiting.add(id);
        const inherited = profiles[profile.template] ? visit(profile.template) : undefined;
        if (!inherited && !bases.includes(profile.template)) throw new Error(`Unknown template ${profile.template}`);
        result[id] = {
            ...inherited,
            ...profile,
            template: inherited?.template || profile.template
        };
        visiting.delete(id);
        return result[id];
    };
    Object.keys(profiles).forEach(visit);
    return result;
};
const $59a4975031bf42fe$export$9db02abe11bb4ea8 = (source, revision)=>{
    const spriteColors = Object.create(null);
    Object.entries(source.registry).forEach(([slot, components])=>{
        spriteColors[slot] = Object.fromEntries(Object.entries(components).map(([id, entry])=>[
                id,
                [
                    ...entry.colors || []
                ]
            ]));
    });
    const items = {
        all: source.items.map((item)=>item.id),
        classes: source.classes.map((c)=>c.id),
        classToTypes: {},
        subClasses: {},
        metadata: {},
        resolvedMetadata: {},
        sprites: {},
        weight: {},
        protection: {},
        characteristics: {},
        classCharacteristics: {},
        trade: {},
        recipes: []
    };
    source.classes.forEach((c)=>{
        const members = source.items.filter((i)=>i.class === c.id).map((i)=>i.id);
        const ordered = (source.presentation.classToTypes[c.id] || []).filter((id)=>members.includes(id));
        items.classToTypes[c.id] = [
            ...ordered,
            ...members.filter((id)=>!ordered.includes(id))
        ];
        items.weight[c.id] = {};
        items.protection[c.id] = {};
        if (c.characteristics) items.classCharacteristics[c.id] = c.characteristics;
    });
    for (const subclass of new Set([
        ...Object.keys(source.presentation.subClasses),
        ...source.items.map((i)=>i.subClass)
    ])){
        const members = source.items.filter((i)=>i.subClass === subclass).map((i)=>i.id);
        const ordered = (source.presentation.subClasses[subclass] || []).filter((id)=>items.all.includes(id));
        items.subClasses[subclass] = [
            ...ordered,
            ...members.filter((id)=>!ordered.includes(id))
        ];
    }
    const slots = {
        weapon: "weapon",
        pants: "pants",
        shirt: "shirt",
        armor: "armor",
        shoes: "shoes",
        shield: "shield",
        cape: "cape",
        bauldron: "bauldron"
    };
    source.items.forEach((item)=>{
        if (item.metadata) items.metadata[item.id] = item.metadata;
        if (item.sprite) items.sprites[item.id] = item.sprite;
        if (item.weight != null) items.weight[item.class][item.id] = item.weight;
        if (item.protection != null) items.protection[item.class][item.id] = item.protection;
        if (item.characteristics) items.characteristics[item.id] = item.characteristics;
        if (item.trade) items.trade[item.id] = item.trade;
        const colors = slots[item.class] ? spriteColors[slots[item.class]]?.[item.id] || [] : [
            "na"
        ];
        if (item.metadata || colors.length) items.resolvedMetadata[item.id] = item.metadata || colors.map((color)=>({
                type: item.id,
                class: item.class,
                color: color,
                ...item.sprite ? {
                    spriteId: item.sprite
                } : {}
            }));
    });
    const resolveReference = (ref)=>{
        const first = items.resolvedMetadata[ref.item]?.[0];
        if (!first) throw new Error(`Item ${ref.item} has no metadata`);
        // Legacy recipes override the first colour, even when it is not an offered colour.
        return {
            ...first,
            ...ref.color !== undefined ? {
                color: ref.color
            } : {}
        };
    };
    items.recipes = source.recipes.map((r)=>({
            itemTypeMeta: resolveReference(r.output),
            quantity: r.quantity,
            ingredients: r.ingredients.map((i)=>({
                    itemTypeMeta: resolveReference(i.reference),
                    quantity: i.quantity
                }))
        }));
    const tiles = {};
    Object.entries(source.tiles.definitions).forEach(([id, tile])=>{
        tiles[id] = {
            ...tile,
            onDestructionCreateItems: tile.onDestructionCreateItems.map((drop)=>({
                    ...drop,
                    itemType: resolveReference(drop.itemType)
                }))
        };
    });
    const weaponProfiles = Object.fromEntries(Object.entries(source.sprites.weapons || {}).map(([id, template])=>[
            id,
            {
                template: template
            }
        ]));
    const drops = (tables)=>Object.fromEntries(Object.entries(tables).map(([id, entries])=>[
                id,
                entries.map(({ reference: reference, metadata: metadata, ...drop })=>({
                        ...drop,
                        itemType: reference ? resolveReference(reference) : metadata
                    }))
            ]));
    return {
        schemaVersion: 1,
        revision: revision,
        source: source,
        items: items,
        spriteColors: spriteColors,
        tiles: tiles,
        assets: {},
        mapTemplates: {},
        mapTilesets: {},
        npcDrops: drops(source.profiles.drops),
        itemDrops: drops(source.profiles.itemDrops),
        creatures: $59a4975031bf42fe$export$d682c65f11e12f14(source.sprites.creatures, source.sprites.registration.RaceTypes),
        weapons: Object.fromEntries(Object.entries($59a4975031bf42fe$export$d682c65f11e12f14(weaponProfiles, source.sprites.registration.WeaponTypes)).map(([id, p])=>[
                id,
                p.template
            ]))
    };
};


/** Retained world calibration: existing obstacle footprints were authored against this sole offset. */ const $9667a1379a787b5e$export$5985b04c8e71b763 = 21.6;
const $9667a1379a787b5e$export$3ceafdb2446078a8 = -6.4;
const $9667a1379a787b5e$export$334e00c898f4892e = (width, height, feetY = 60)=>({
        x: width / 2,
        y: height / 2 + feetY - 32
    });
const $9667a1379a787b5e$export$6863cf1031889941 = (width, height, anchor = 60)=>{
    const feet = typeof anchor === "number" ? $9667a1379a787b5e$export$334e00c898f4892e(width, height, anchor) : anchor;
    return {
        x: 32 - feet.x,
        y: 60 - feet.y
    };
};
const $9667a1379a787b5e$export$6dc1bea310ef816a = (pixels, width, height, feet, bakeOffset)=>{
    let left = width, right = -1, bottom = -1;
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++)if (pixels[(y * width + x) * 4 + 3] > 0) {
        left = Math.min(left, x);
        right = Math.max(right, x);
        bottom = y;
    }
    return bottom < 0 ? undefined : {
        x: Math.round((feet.x - (left + right + 1) / 2 - bakeOffset.x) * 10) / 10,
        y: Math.round((feet.y - (bottom + 1) - bakeOffset.y) * 10) / 10
    };
};
const $9667a1379a787b5e$export$20726201b68e0cab = (width, height, entry)=>entry?.groundAnchor ?? $9667a1379a787b5e$export$334e00c898f4892e(width, height, entry?.shadow?.feetY);
const $9667a1379a787b5e$export$4fd5d77b3f05d134 = (entry, slot)=>{
    const errors = [];
    for (const field of [
        "placement",
        "groundAnchor"
    ]){
        const point = entry[field];
        if (point === undefined) continue;
        if (slot !== "body" || !point || Array.isArray(point) || Object.keys(point).some((k)=>k !== "x" && k !== "y") || !Number.isFinite(point.x) || !Number.isFinite(point.y)) errors.push(`${field} x and y must be finite numbers on a body`);
    }
    if (entry.depthBias !== undefined && (slot !== "body" || !Number.isFinite(entry.depthBias))) errors.push("depthBias must be a finite number on a body");
    return errors;
};
const $9667a1379a787b5e$export$37167d5ed9a6c8ce = (names)=>{
    const sorted = [
        ...names
    ].sort((a, b)=>a.localeCompare(b, "en", {
            numeric: true
        }));
    for (const action of [
        "walk-front",
        "walk-down",
        "idle-front",
        "idle-down"
    ])if (sorted.some((name)=>name === action || name.startsWith(`${action}-`))) return sorted.find((name)=>name === action || name.startsWith(`${action}-`));
    return sorted.find((name)=>/^(walk|idle)-/.test(name)) ?? sorted[0];
};


const $9be3ff017f3cb29b$export$eac6cd1dc8845500 = [
    "grown",
    "young"
];
const $9be3ff017f3cb29b$export$3dc6003d27a80399 = [
    "long",
    "sprout"
];



/**
 * Validating an autotile definitions file (content/game/maps/autotiles.json): structure always, tile
 * references when the caller passes the tilesets' tile counts.
 *
 * Its own leaf, apart from autotile_library.ts, because of WHO calls it: the content compiler
 * (game-common/content/validate.ts) checks a candidate's definitions before any runtime catalog
 * exists, while autotile_library.ts loads the published definitions from that catalog at import. So
 * this module imports only the wall kind's validator and types -- no catalog, no models, no IO.
 */ /**
 * The `wall` autotile kind: building walls (wood, stone, ...) as data.
 *
 * A wall definition says, for each autotile index a material can draw, which tiles to emit at which
 * offsets from the wall's cell (the ANCHOR) -- a lone wall is a cap one row up and a base on the
 * cell -- and, where the art depends on more than the index, which alternative to take. HouseBuilder
 * (house/feature/house.ts) asks `resolveWallCell` for every wall cell, in row-major order, and writes
 * what it returns through its own entry()/addFor(); Sprite Lab asks the same function.
 *
 * Every emitted tile is grouped under the anchor as its PARENT (HouseBuilder's `addFor(x, y)`): one
 * wall = one object, one HP counter, one coordinateCache key, one sort row. `parent: "self"` makes a
 * tile its own object instead (HouseBuilder's `add`).
 *
 * Two of HouseBuilder's behaviours shape what a rule means, and are kept by construction:
 *  - its entry() keeps ONE tile per cell+layer, so a second emit onto a cell re-points the tile that
 *    is already there (only its tile position changes; its tileset stays) rather than adding one;
 *  - `exists` sees only tiles emitted EARLIER -- by cells before this one in row-major order, by
 *    earlier steps of this cell's own rule, or by anything else HouseBuilder put on the layer first.
 *    So the order of a rule's steps is part of the data.
 *
 * Conditions read the index grid of EVERY wall cell, whatever its material: one house grid holds
 * all of them, so a wooden wall joins a stone one.
 *
 * The indices a definition has a rule for are the ones it can draw; any other index is a shape the
 * material cannot render, and placement refuses it (autotiler.ts, COMPUTABLE_WALL_AUTOTILE_INDICES).
 *
 * `itemType` links a material to the item that builds it (HouseBuilder.wallMaterials is derived from
 * it); content validation requires that item to exist with buildType "wall", and no two materials to
 * name the same item.
 *
 * A leaf like autotile_library.ts (which validates and loads these): no models, no mechanics, no
 * map builder, no file system. Only types are imported.
 */ const $d06e01c1880d4b6a$export$a476270257d86655 = (definition)=>definition?.joins === "own" ? definition.id : undefined;
const $d06e01c1880d4b6a$export$a2f415c060ce2b32 = (definition)=>!!definition && !definition.parapet;
const $d06e01c1880d4b6a$export$3ad3a12c780212fb = (definition, tilePos, role, above, belowSame, southWall = false)=>{
    const seams = definition?.seams;
    if (!seams) return undefined;
    if (role === "top" && above) return seams.covered[String(tilePos)];
    if (role === "face" && belowSame) return (!southWall ? seams.joints?.[String(tilePos)] : undefined) ?? (seams.style === "seamless" ? seams.continued?.[String(tilePos)] : undefined);
    return undefined;
};
const $d06e01c1880d4b6a$export$414e0c962a37354b = (x, y, storey, name)=>{
    let h = 2166136261 ^ x * 374761393 ^ y * 668265263 ^ storey * 2246822519;
    for(let i = 0; i < name.length; i++)h = Math.imul(h ^ name.charCodeAt(i), 16777619);
    h = Math.imul(h ^ h >>> 15, 2246822507);
    h = Math.imul(h ^ h >>> 13, 3266489909);
    return ((h ^ h >>> 16) >>> 0) / 4294967296;
};
const $d06e01c1880d4b6a$export$9eba03b0b3dd1baf = (definition, placed, x, y, storey = 0)=>{
    const ornaments = definition?.ornaments;
    if (!ornaments) return undefined;
    if (placed && ornaments[placed]) return placed;
    return Object.keys(ornaments).sort().find((name)=>(ornaments[name].scatter ?? 0) > 0 && $d06e01c1880d4b6a$export$414e0c962a37354b(x, y, storey, name) < ornaments[name].scatter);
};
const $d06e01c1880d4b6a$export$7fb7b5877f16f088 = (step)=>step.choose !== undefined;
const $d06e01c1880d4b6a$var$isInt = (value)=>typeof value === "number" && Number.isInteger(value);
const $d06e01c1880d4b6a$var$isIndex = (value)=>$d06e01c1880d4b6a$var$isInt(value) && value >= 1 && value <= 47;
const $d06e01c1880d4b6a$var$isObject = (value)=>!!value && typeof value === "object" && !Array.isArray(value);
const $d06e01c1880d4b6a$var$EMIT_KEYS = [
    "dx",
    "dy",
    "tile",
    "parent"
];
const $d06e01c1880d4b6a$var$ALTERNATIVE_KEYS = [
    "when",
    "emit"
];
const $d06e01c1880d4b6a$var$CONDITION_FORMS = [
    "neighbour",
    "exists",
    "all",
    "any",
    "not"
];
const $d06e01c1880d4b6a$export$54efb664f5a7f6dc = (definition, { fail: fail, tile: tile, tileRef: tileRef, layer: layer })=>{
    layer("layerId", definition.layerId, true);
    if (definition.itemType !== undefined && (typeof definition.itemType !== "string" || !/^[A-Za-z0-9][A-Za-z0-9_.-]*$/.test(definition.itemType))) fail(`itemType must be an item id, got ${JSON.stringify(definition.itemType)}`);
    if (!$d06e01c1880d4b6a$var$isObject(definition.cell)) fail("cell must say what goes under every wall cell ({} for nothing)");
    else Object.keys(definition.cell).forEach((key)=>{
        if (key !== "blocking" && key !== "occlusion") fail(`cell: unknown decoration "${key}" (expected blocking, occlusion)`);
        else tileRef(`cell.${key}`, definition.cell[key]);
    });
    const offset = (label, value, { allowSelf: allowSelf })=>{
        if (!Array.isArray(value) || value.length !== 2 || !value.every($d06e01c1880d4b6a$var$isInt)) fail(`${label} must be an offset [dx, dy] of integers, got ${JSON.stringify(value)}`);
        else if (value.some((d)=>d < -1 || d > 1)) fail(`${label} ${JSON.stringify(value)} is outside the wall's neighbourhood (each of dx, dy is -1, 0 or 1)`);
        else if (!allowSelf && value[0] === 0 && value[1] === 0) fail(`${label} [0, 0] is the wall's own cell`);
    };
    const emit = (label, value)=>{
        if (!$d06e01c1880d4b6a$var$isObject(value)) {
            fail(`${label} must be a tile to emit ({ "dx", "dy", "tile", "parent" })`);
            return;
        }
        Object.keys(value).forEach((key)=>{
            if (!$d06e01c1880d4b6a$var$EMIT_KEYS.includes(key)) fail(`${label}: unknown field "${key}" (expected ${$d06e01c1880d4b6a$var$EMIT_KEYS.join(", ")})`);
        });
        [
            "dx",
            "dy"
        ].forEach((axis)=>{
            const d = value[axis];
            if (d === undefined) return;
            if (!$d06e01c1880d4b6a$var$isInt(d)) fail(`${label}.${axis} must be an integer, got ${JSON.stringify(d)}`);
            else if (d < -1 || d > 1) fail(`${label}.${axis} ${d} is outside the wall's neighbourhood (-1, 0 or 1)`);
        });
        tile(`${label}.tile`, value.tile);
        if (value.parent !== undefined && value.parent !== "self") fail(`${label}.parent must be "self" or left out, got ${JSON.stringify(value.parent)}`);
    };
    const condition = (label, value, depth = 0)=>{
        if (depth > 8) {
            fail(`${label}: conditions nest too deep`);
            return;
        }
        if (!$d06e01c1880d4b6a$var$isObject(value)) {
            fail(`${label} must be a condition (one of ${$d06e01c1880d4b6a$var$CONDITION_FORMS.join(", ")})`);
            return;
        }
        const forms = Object.keys(value).filter((key)=>$d06e01c1880d4b6a$var$CONDITION_FORMS.includes(key));
        const unknown = Object.keys(value).filter((key)=>!$d06e01c1880d4b6a$var$CONDITION_FORMS.includes(key) && !(key === "index" && forms[0] === "neighbour"));
        if (forms.length !== 1) {
            fail(`${label}: unknown condition form ${JSON.stringify(Object.keys(value))} (expected exactly one of ${$d06e01c1880d4b6a$var$CONDITION_FORMS.join(", ")})`);
            return;
        }
        unknown.forEach((key)=>fail(`${label}: unknown field "${key}" in a ${forms[0]} condition`));
        switch(forms[0]){
            case "neighbour":
                offset(`${label}.neighbour`, value.neighbour, {
                    allowSelf: false
                });
                if (value.index !== undefined) {
                    if (!Array.isArray(value.index) || value.index.length === 0) fail(`${label}.index must be a non-empty list of autotile indices`);
                    else value.index.forEach((i, n)=>!$d06e01c1880d4b6a$var$isIndex(i) && fail(`${label}.index[${n}] ${JSON.stringify(i)} is not an autotile index (1-47)`));
                }
                break;
            case "exists":
                offset(`${label}.exists`, value.exists, {
                    allowSelf: true
                });
                break;
            case "all":
            case "any":
                {
                    const parts = value[forms[0]];
                    if (!Array.isArray(parts) || parts.length === 0) fail(`${label}.${forms[0]} must be a non-empty list of conditions`);
                    else parts.forEach((part, n)=>condition(`${label}.${forms[0]}[${n}]`, part, depth + 1));
                    break;
                }
            case "not":
                condition(`${label}.not`, value.not, depth + 1);
                break;
        }
    };
    if (!$d06e01c1880d4b6a$var$isObject(definition.rules)) fail("rules must map autotile indices to lists of steps");
    else {
        if (Object.keys(definition.rules).length === 0) fail("rules is empty: the material could draw nothing");
        Object.entries(definition.rules).forEach(([index, steps])=>{
            const where = `rules[${index}]`;
            if (!/^\d+$/.test(index) || !$d06e01c1880d4b6a$var$isIndex(Number(index))) fail(`rules: "${index}" is not an autotile index (1-47)`);
            if (!Array.isArray(steps) || steps.length === 0) {
                fail(`${where} must be a non-empty list of steps (leave the index out if the material cannot draw it)`);
                return;
            }
            steps.forEach((step, s)=>{
                const at = `${where}[${s}]`;
                if ($d06e01c1880d4b6a$var$isObject(step) && "choose" in step) {
                    Object.keys(step).forEach((key)=>key !== "choose" && fail(`${at}: unknown field "${key}" beside "choose"`));
                    const alternatives = step.choose;
                    if (!Array.isArray(alternatives) || alternatives.length === 0) {
                        fail(`${at}.choose must be a non-empty list of alternatives`);
                        return;
                    }
                    alternatives.forEach((alternative, a)=>{
                        const alt = `${at}.choose[${a}]`;
                        if (!$d06e01c1880d4b6a$var$isObject(alternative)) {
                            fail(`${alt} must be an alternative ({ "when", "emit" })`);
                            return;
                        }
                        Object.keys(alternative).forEach((key)=>{
                            if (!$d06e01c1880d4b6a$var$ALTERNATIVE_KEYS.includes(key)) fail(`${alt}: unknown field "${key}" (expected when, emit)`);
                        });
                        if (alternative.when === undefined) {
                            if (a !== alternatives.length - 1) fail(`${alt} has no "when", so the alternatives after it can never be taken`);
                        } else condition(`${alt}.when`, alternative.when);
                        if (!Array.isArray(alternative.emit)) fail(`${alt}.emit must be a list of tiles ([] for none)`);
                        else alternative.emit.forEach((e, n)=>emit(`${alt}.emit[${n}]`, e));
                    });
                } else emit(at, step);
            });
        });
    }
    if (definition.notes !== undefined) {
        if (!$d06e01c1880d4b6a$var$isObject(definition.notes)) fail("notes must map autotile indices to strings");
        else Object.entries(definition.notes).forEach(([index, note])=>{
            if (!$d06e01c1880d4b6a$var$isIndex(Number(index)) || typeof note !== "string") fail(`notes: "${index}" must be an index with a string note`);
        });
    }
    if (definition.ornaments !== undefined) {
        if (!$d06e01c1880d4b6a$var$isObject(definition.ornaments)) fail("ornaments must map ornament names to { tiles, scatter? }");
        else {
            const drawn = new Set(Object.values($d06e01c1880d4b6a$var$isObject(definition.upperTiles) ? definition.upperTiles : {}).map(String));
            Object.values($d06e01c1880d4b6a$var$isObject(definition.rules) ? definition.rules : {}).forEach((steps)=>Array.isArray(steps) && steps.forEach((step)=>($d06e01c1880d4b6a$export$7fb7b5877f16f088(step) ? (step.choose || []).flatMap((a)=>a.emit || []) : [
                        step
                    ]).forEach((e)=>$d06e01c1880d4b6a$var$isObject(e) && drawn.add(String(e.tile)))));
            Object.entries(definition.ornaments).forEach(([name, ornament])=>{
                const at = `ornaments.${name}`;
                if (!/^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/.test(name)) fail(`${at}: an ornament's name is lower-case words joined by '-'`);
                if (!$d06e01c1880d4b6a$var$isObject(ornament) || !$d06e01c1880d4b6a$var$isObject(ornament.tiles) || !Object.keys(ornament.tiles).length) {
                    fail(`${at} must give the tiles it replaces ({ tiles: { emitted: replacement } })`);
                    return;
                }
                Object.entries(ornament.tiles).forEach(([from, to])=>{
                    if (!drawn.has(from)) fail(`${at}.tiles: "${from}" is not a tile the rules or upperTiles draw`);
                    tile(`${at}.tiles[${from}]`, to);
                });
                if (ornament.scatter !== undefined && !(typeof ornament.scatter === "number" && ornament.scatter > 0 && ornament.scatter <= 1)) fail(`${at}.scatter must be a share between 0 and 1`);
                Object.keys(ornament).forEach((key)=>key !== "tiles" && key !== "scatter" && fail(`${at}: unknown field "${key}" (expected tiles, scatter)`));
            });
        }
    }
    if (definition.seams !== undefined) {
        const seams = definition.seams;
        if (!$d06e01c1880d4b6a$var$isObject(seams)) fail("seams must be { style, covered, continued?, joints?, lintel?, ownBeam? }");
        else {
            if (seams.style !== "beam" && seams.style !== "seamless") fail(`seams.style must be "beam" or "seamless", got ${JSON.stringify(seams.style)}`);
            const pieces = (label, map, required)=>{
                if (map === undefined && !required) return;
                if (!$d06e01c1880d4b6a$var$isObject(map)) {
                    fail(`${label} must map tiles this wall draws to tile references`);
                    return;
                }
                Object.entries(map).forEach(([from, to])=>{
                    if (!/^\d+$/.test(from)) fail(`${label}: "${from}" is not a tile position`);
                    else tile(`${label} key ${from}`, Number(from));
                    tileRef(`${label}[${from}]`, to);
                });
            };
            pieces("seams.covered", seams.covered, true);
            pieces("seams.continued", seams.continued, false);
            pieces("seams.joints", seams.joints, false);
            if (seams.lintel !== undefined) tileRef("seams.lintel", seams.lintel);
            if (seams.ownBeam !== undefined && (seams.ownBeam !== true || seams.style !== "beam" || seams.lintel === undefined)) fail("seams.ownBeam must be true, on a beam with a lintel (which holds the beam)");
            Object.keys(seams).forEach((key)=>![
                    "style",
                    "covered",
                    "continued",
                    "joints",
                    "lintel",
                    "ownBeam"
                ].includes(key) && fail(`seams: unknown field "${key}" (expected style, covered, continued, joints, lintel, ownBeam)`));
        }
    }
    if (definition.trims !== undefined) $d06e01c1880d4b6a$export$c9208e13acb20a1a(definition.trims, fail);
    if (definition.shadow !== undefined) $d06e01c1880d4b6a$export$2bfe6a0ea687dbd8(definition.shadow, fail);
    if (definition.parapet !== undefined && typeof definition.parapet !== "boolean") fail("parapet must be true or false");
    if (definition.joins !== undefined && definition.joins !== "own") fail('joins must be "own" (or left out: it joins every wall)');
    if (definition.upperTiles !== undefined) {
        if (!$d06e01c1880d4b6a$var$isObject(definition.upperTiles)) fail("upperTiles must map tiles the rules emit to the tiles drawn above the ground");
        else {
            const emitted = new Set();
            Object.values($d06e01c1880d4b6a$var$isObject(definition.rules) ? definition.rules : {}).forEach((steps)=>Array.isArray(steps) && steps.forEach((step)=>($d06e01c1880d4b6a$export$7fb7b5877f16f088(step) ? (step.choose || []).flatMap((a)=>a.emit || []) : [
                        step
                    ]).forEach((e)=>$d06e01c1880d4b6a$var$isObject(e) && emitted.add(String(e.tile)))));
            Object.entries(definition.upperTiles).forEach(([from, to])=>{
                if (!emitted.has(from)) fail(`upperTiles: "${from}" is not a tile the rules emit`);
                tile(`upperTiles[${from}]`, to);
            });
        }
    }
};
const $d06e01c1880d4b6a$export$2bfe6a0ea687dbd8 = (shadow, fail)=>{
    const isObject = (v)=>!!v && typeof v === "object" && !Array.isArray(v);
    const local = (n)=>Number.isInteger(n) && n >= 0 && n <= 32;
    const footprint = (v)=>isObject(v) && local(v.left) && local(v.right) && local(v.depth) && v.left < v.right && v.depth > 0;
    if (!isObject(shadow)) return fail("shadow must be { body? } or { block }");
    Object.keys(shadow).forEach((key)=>![
            "body",
            "block"
        ].includes(key) && fail(`shadow: unknown field "${key}" (expected body, block)`));
    if (shadow.body !== undefined && !footprint(shadow.body)) fail("shadow.body must be { left, right, depth } in cell-local px, left < right");
    const block = shadow.block;
    if (block !== undefined && !(isObject(block) && [
        block.left,
        block.right,
        block.top,
        block.bottom
    ].every(local) && block.left < block.right && block.top < block.bottom && Number.isInteger(block.height) && block.height > 0 && block.height <= 64)) fail("shadow.block must be { left, right, top, bottom, height } in cell-local px, left < right, top < bottom, height 1-64");
    if (shadow.body !== undefined && shadow.block !== undefined) fail("shadow: a block casts instead of a body; give one");
};
const $d06e01c1880d4b6a$export$20c965c5f296dad5 = [
    "plain",
    "stud",
    "studs",
    "brace",
    "chevron",
    "cross",
    "arched"
];
const $d06e01c1880d4b6a$var$HEX = /^#[0-9a-fA-F]{6}$/;
const $d06e01c1880d4b6a$export$c9208e13acb20a1a = (trims, fail)=>{
    const isObject = (v)=>!!v && typeof v === "object" && !Array.isArray(v);
    if (!isObject(trims)) return fail("trims must be an object");
    const colours = (label, value, length)=>{
        if (!Array.isArray(value) || !value.length || value.some((c)=>typeof c !== "string" || !$d06e01c1880d4b6a$var$HEX.test(c))) return fail(`${label} must be a list of #rrggbb colours`);
        if (length !== undefined && value.length !== length) fail(`${label} must have ${length} colours`);
    };
    const share = (label, value)=>{
        if (typeof value !== "number" || !(value >= 0 && value <= 1)) fail(`${label} must be a share between 0 and 1`);
    };
    const px = (label, value, min = 0, max = 256)=>{
        if (!Number.isInteger(value) || value < min || value > max) fail(`${label} must be a whole number of pixels ${min}-${max}`);
    };
    const known = [
        "parts",
        "palette",
        "masonry",
        "coping",
        "foot",
        "spurs",
        "streaks",
        "weeds",
        "arch",
        "creepers",
        "continuous",
        "damp",
        "quoins",
        "stringCourse",
        "framing"
    ];
    Object.keys(trims).forEach((key)=>!known.includes(key) && fail(`trims: unknown field "${key}" (expected ${known.join(", ")})`));
    if (!isObject(trims.parts)) fail("trims.parts must be { face, top, coping? }");
    else {
        colours("trims.parts.face", trims.parts.face);
        colours("trims.parts.top", trims.parts.top);
        if (trims.parts.coping !== undefined) colours("trims.parts.coping", trims.parts.coping);
    }
    const p = trims.palette;
    if (!isObject(p)) fail("trims.palette must be an object");
    else {
        [
            "outline",
            "joint",
            "stem"
        ].forEach((key)=>(typeof p[key] !== "string" || !$d06e01c1880d4b6a$var$HEX.test(p[key])) && fail(`trims.palette.${key} must be a #rrggbb colour`));
        if (p.vault !== undefined && (typeof p.vault !== "string" || !$d06e01c1880d4b6a$var$HEX.test(p.vault))) fail("trims.palette.vault must be a #rrggbb colour");
        colours("trims.palette.stone", p.stone, 5);
        colours("trims.palette.top", p.top, 5);
        colours("trims.palette.dressed", p.dressed, 4);
        colours("trims.palette.moss", p.moss);
        colours("trims.palette.grass", p.grass);
        colours("trims.palette.leaves", p.leaves);
        if (p.timber !== undefined) colours("trims.palette.timber", p.timber, 5);
        if (p.flowers !== undefined) colours("trims.palette.flowers", p.flowers, 3);
    }
    const masonry = (label, m)=>{
        if (!isObject(m)) return fail(`${label} must be { rows, widths, splits }`);
        if (!Array.isArray(m.rows) || m.rows.length !== 2 || !m.rows.every((r)=>Number.isInteger(r) && r >= 0 && r < 32) || m.rows[0] > m.rows[1]) fail(`${label}.rows must be [first, last] face rows 0-31`);
        if (!Array.isArray(m.widths) || !m.widths.length || m.widths.some((w)=>!Number.isInteger(w) || w < 4 || w > 96)) fail(`${label}.widths must be widths of 4-96 px`);
        if (!Array.isArray(m.splits) || !m.splits.length || m.splits.some((s)=>!Array.isArray(s) || !s.length || s.some((h)=>!Number.isInteger(h) || h < 3 || h > 32))) fail(`${label}.splits must be lists of stone heights of 3-32 px`);
    };
    if (trims.masonry !== undefined) {
        if (!isObject(trims.masonry)) fail("trims.masonry must be { ground, upper? }");
        else {
            masonry("trims.masonry.ground", trims.masonry.ground);
            if (trims.masonry.upper !== undefined) masonry("trims.masonry.upper", trims.masonry.upper);
        }
    }
    if (trims.coping !== undefined) {
        const l = trims.coping?.lengths;
        if (!Array.isArray(l) || l.length !== 2 || !l.every((n)=>Number.isInteger(n) && n >= 3 && n <= 64) || l[0] > l[1]) fail("trims.coping.lengths must be [shortest, longest] px, 3-64");
    }
    if (trims.foot !== undefined) [
        "rubble",
        "tufts",
        "moss"
    ].forEach((key)=>share(`trims.foot.${key}`, trims.foot?.[key]));
    if (trims.spurs !== undefined) {
        px("trims.spurs.reach", trims.spurs?.reach, 2, 16);
        px("trims.spurs.height", trims.spurs?.height, 4, 31);
    }
    if (trims.streaks !== undefined) share("trims.streaks.share", trims.streaks?.share);
    if (trims.weeds !== undefined) share("trims.weeds.share", trims.weeds?.share);
    if (trims.arch !== undefined) {
        px("trims.arch.rise", trims.arch?.rise, 4, 30);
        px("trims.arch.ring", trims.arch?.ring, 2, 12);
        px("trims.arch.maxSpan", trims.arch?.maxSpan, 1, 4);
    }
    if (trims.creepers !== undefined) {
        share("trims.creepers.share", trims.creepers?.share);
        const r = trims.creepers?.reach;
        if (!Array.isArray(r) || r.length !== 2 || !r.every((n)=>typeof n === "number" && n > 0 && n <= 12) || r[0] > r[1]) fail("trims.creepers.reach must be [least, most] storeys");
        px("trims.creepers.spread", trims.creepers?.spread, 2, 64);
        if (trims.creepers?.bloom !== undefined) {
            share("trims.creepers.bloom", trims.creepers.bloom);
            if (!isObject(p) || p.flowers === undefined) fail("trims.creepers.bloom needs trims.palette.flowers");
        }
    }
    if (trims.framing !== undefined) {
        const f = trims.framing;
        const rows = (label, r)=>{
            if (!Array.isArray(r) || r.length !== 2 || !r.every((n)=>Number.isInteger(n) && n >= 0 && n < 32) || r[0] > r[1]) fail(`${label} must be [first, last] face rows 0-31`);
        };
        if (!isObject(f)) fail("trims.framing must be { posts, bays, width, panels, over?, tones? }");
        else {
            const stray = Object.keys(f).filter((key)=>![
                    "posts",
                    "bays",
                    "width",
                    "panels",
                    "over",
                    "tones"
                ].includes(key));
            if (stray.length) fail(`trims.framing: unknown field ${stray.join(", ")}`);
            rows("trims.framing.posts", f.posts);
            if (!Array.isArray(f.bays) || !f.bays.length || f.bays.some((w)=>!Number.isInteger(w) || w < 12 || w > 64)) fail("trims.framing.bays must be post spacings of 12-64 px");
            px("trims.framing.width", f.width, 3, 6);
            if (!Array.isArray(f.panels) || !f.panels.length) fail("trims.framing.panels must be a list of { rows, fills }");
            else f.panels.forEach((panel, i)=>{
                if (!isObject(panel)) return fail(`trims.framing.panels[${i}] must be { rows, fills }`);
                rows(`trims.framing.panels[${i}].rows`, panel.rows);
                const fills = panel.fills;
                if (!isObject(fills) || !Object.keys(fills).length) return fail(`trims.framing.panels[${i}].fills must name some fills`);
                Object.entries(fills).forEach(([name, weight])=>{
                    if (!$d06e01c1880d4b6a$export$20c965c5f296dad5.includes(name)) fail(`trims.framing.panels[${i}].fills: unknown fill "${name}" (expected ${$d06e01c1880d4b6a$export$20c965c5f296dad5.join(", ")})`);
                    if (typeof weight !== "number" || !(weight >= 0)) fail(`trims.framing.panels[${i}].fills.${name} must be a weight of 0 or more`);
                });
            });
            if (f.over !== undefined) colours("trims.framing.over", f.over);
            if (f.tones !== undefined && (typeof f.tones !== "number" || !(f.tones >= 0 && f.tones <= 0.12))) fail("trims.framing.tones must be a share between 0 and 0.12");
            if (!isObject(p) || p.timber === undefined) fail("trims.framing needs trims.palette.timber");
        }
    }
    if (trims.continuous !== undefined && typeof trims.continuous !== "boolean") fail("trims.continuous must be true or false");
    if (trims.damp !== undefined) {
        const h = trims.damp?.height;
        if (!Array.isArray(h) || h.length !== 2 || !h.every((n)=>Number.isInteger(n) && n >= 1 && n <= 24) || h[0] > h[1]) fail("trims.damp.height must be [least, most] px, 1-24");
    }
    if (trims.quoins !== undefined) {
        px("trims.quoins.long", trims.quoins?.long, 3, 24);
        px("trims.quoins.short", trims.quoins?.short, 2, 24);
        px("trims.quoins.course", trims.quoins?.course, 3, 32);
        if (trims.quoins?.short > trims.quoins?.long) fail("trims.quoins.short must be at most trims.quoins.long");
    }
    if (trims.stringCourse !== undefined) {
        const every = trims.stringCourse?.every;
        if (!Number.isInteger(every) || every < 1 || every > 12) fail("trims.stringCourse.every must be a whole number of storeys, 1-12");
    }
};
const $d06e01c1880d4b6a$var$signed = (d)=>d > 0 ? `+${d}` : `${d}`;
const $d06e01c1880d4b6a$var$offsetText = ([dx, dy])=>`(${$d06e01c1880d4b6a$var$signed(dx)}, ${$d06e01c1880d4b6a$var$signed(dy)})`;
const $d06e01c1880d4b6a$export$e77585708b3c51b6 = (definition, index)=>definition.rules[String(index)];
const $d06e01c1880d4b6a$export$f0c21dc345122cf3 = (definition)=>Object.keys(definition.rules).map(Number).sort((a, b)=>a - b);
const $d06e01c1880d4b6a$export$1edf2891fa0ebefc = (definition, x, y, context, options = {})=>{
    const index = context.indices[y]?.[x] ?? 0;
    const rule = $d06e01c1880d4b6a$export$e77585708b3c51b6(definition, index);
    const writes = [];
    const choices = [];
    if (!rule) return {
        x: x,
        y: y,
        index: index,
        drawable: false,
        writes: writes,
        choices: choices
    };
    const { layerId: layerId, tilesetId: tilesetId } = definition;
    // Tiles this cell has already written count as existing, exactly as they would in HouseBuilder's
    // cache had each write been applied as it was made.
    const written = new Set();
    const exists = (cx, cy)=>written.has(`${cx},${cy}`) || context.exists(cx, cy, layerId);
    const indexAt = (cx, cy)=>context.indices[cy]?.[cx] ?? 0;
    const evaluate = (condition)=>{
        const describe = options.trace;
        if ("neighbour" in condition) {
            const [dx, dy] = condition.neighbour;
            const there = indexAt(x + dx, y + dy);
            const holds = condition.index ? condition.index.includes(there) : !!there;
            const text = describe ? condition.index ? `neighbour ${$d06e01c1880d4b6a$var$offsetText(condition.neighbour)} has index ${there || "none"}; wanted ${condition.index.join(" or ")}` : `a wall at ${$d06e01c1880d4b6a$var$offsetText(condition.neighbour)}: ${there ? `yes (index ${there})` : "no"}` : "";
            return {
                text: text,
                holds: holds
            };
        }
        if ("exists" in condition) {
            const [dx, dy] = condition.exists;
            const holds = exists(x + dx, y + dy);
            return {
                text: describe ? `a ${layerId} tile already at ${$d06e01c1880d4b6a$var$offsetText(condition.exists)}: ${holds ? "yes" : "no"}` : "",
                holds: holds
            };
        }
        if ("not" in condition) {
            const inner = evaluate(condition.not);
            return {
                text: describe ? "not" : "",
                holds: !inner.holds,
                parts: [
                    inner
                ]
            };
        }
        const all = "all" in condition;
        const parts = (all ? condition.all : condition.any).map(evaluate);
        return {
            text: describe ? all ? "all of" : "any of" : "",
            holds: all ? parts.every((p)=>p.holds) : parts.some((p)=>p.holds),
            parts: parts
        };
    };
    const upper = (options.storey ?? 0) > 0 ? definition.upperTiles : undefined;
    const ornament = options.ornament ? definition.ornaments?.[options.ornament]?.tiles : undefined;
    const drawnTile = (tile)=>{
        const storeyed = upper && upper[String(tile)] !== undefined ? upper[String(tile)] : tile;
        return ornament && ornament[String(storeyed)] !== undefined ? ornament[String(storeyed)] : storeyed;
    };
    const emit = (e, step, alternative)=>{
        const dx = e.dx || 0;
        const dy = e.dy || 0;
        const self = e.parent === "self";
        writes.push({
            x: x + dx,
            y: y + dy,
            dx: dx,
            dy: dy,
            layerId: layerId,
            tilesetId: tilesetId,
            tilePos: drawnTile(e.tile),
            parent: self ? {
                x: x + dx,
                y: y + dy
            } : {
                x: x,
                y: y
            },
            parentMode: self ? "self" : "anchor",
            step: step,
            ...alternative === undefined ? {} : {
                alternative: alternative
            }
        });
        written.add(`${x + dx},${y + dy}`);
    };
    rule.forEach((step, s)=>{
        if (!$d06e01c1880d4b6a$export$7fb7b5877f16f088(step)) {
            emit(step, s);
            return;
        }
        const trace = {
            step: s,
            alternatives: []
        };
        step.choose.forEach((alternative, a)=>{
            // Conditions only read, so describing the ones after the chosen alternative changes nothing.
            if (trace.chosen !== undefined && !options.trace) return;
            const verdict = alternative.when ? evaluate(alternative.when) : undefined;
            const holds = verdict ? verdict.holds : true;
            trace.alternatives.push({
                ...verdict && options.trace ? {
                    when: verdict
                } : {},
                holds: holds,
                emits: alternative.emit.length
            });
            if (holds && trace.chosen === undefined) trace.chosen = a;
        });
        choices.push(trace);
        if (trace.chosen !== undefined) step.choose[trace.chosen].emit.forEach((e)=>emit(e, s, trace.chosen));
    });
    return {
        x: x,
        y: y,
        index: index,
        drawable: true,
        writes: writes,
        choices: choices
    };
};
const $d06e01c1880d4b6a$export$9c6b1f61882a2146 = (definition, indices, x, y, utils, options)=>{
    const resolution = $d06e01c1880d4b6a$export$1edf2891fa0ebefc(definition, x, y, {
        indices: indices,
        exists: utils.exists
    }, options);
    resolution.writes.forEach((w)=>utils.addFor(w.parent.x, w.parent.y, utils.entry(w.x, w.y, w.tilePos, w.layerId, w.tilesetId)));
    return resolution;
};


/** Roof pieces share the building grid's neighbour indices, and draw on the sky layer. */ const $48a990ae9133d7d6$export$de1d6aafc8dccb91 = [
    "back",
    "ridgeTop",
    "ridge",
    "front",
    "eave",
    "solo"
];
const $48a990ae9133d7d6$export$ac74eebe1797c33c = [
    "mid",
    "west",
    "east",
    "single"
];
const $48a990ae9133d7d6$export$c3a1ba957eeb4c96 = $48a990ae9133d7d6$export$de1d6aafc8dccb91.flatMap((row)=>$48a990ae9133d7d6$export$ac74eebe1797c33c.map((edge)=>`${row}.${edge}`));
const $48a990ae9133d7d6$export$68e77b0d13138b72 = [
    "front.westJoin",
    "front.eastJoin",
    "front.westJoinEast",
    "front.eastJoinWest",
    "front.bothJoin"
];
const $48a990ae9133d7d6$export$209eca667366d849 = 19;
const $48a990ae9133d7d6$export$eb1f96a8e22fbe1a = (piece)=>({
        "front.westJoin": "front.mid",
        "front.eastJoin": "front.mid",
        "front.westJoinEast": "front.east",
        "front.eastJoinWest": "front.west",
        "front.bothJoin": "front.mid"
    })[piece] ?? piece;
/** The rows of the north-south run of roof through (x, y). */ const $48a990ae9133d7d6$var$columnRun = (isRoof, x, y)=>{
    let top = y;
    while(isRoof(x, top - 1))top--;
    let bottom = y;
    while(isRoof(x, bottom + 1))bottom++;
    return {
        top: top,
        bottom: bottom
    };
};
/**
 * Whether the ridge along a roof's top edge can sit a row down, under a strip of back slope: only
 * when every column that starts on that edge (the east-west run of cells along row `top` with no
 * roof north of them) is five or more deep. Otherwise one shallow column would keep its ridge on
 * the top row while its deep neighbours dropped theirs, breaking the ridge -- a T, or an L with
 * its wing to the south, would show a patch of back slope in the middle of a broken ridge.
 */ const $48a990ae9133d7d6$var$ridgeDrops = (isRoof, x, top)=>{
    const startsHere = (cx)=>isRoof(cx, top) && !isRoof(cx, top - 1);
    const deep = (cx)=>$48a990ae9133d7d6$var$columnRun(isRoof, cx, top).bottom - top + 1 >= 5;
    for(let cx = x; startsHere(cx); cx--)if (!deep(cx)) return false;
    for(let cx = x + 1; startsHere(cx); cx++)if (!deep(cx)) return false;
    return true;
};
const $48a990ae9133d7d6$export$bb60dad4b331947b = (isRoof, x, y)=>{
    const { row: row, top: top } = $48a990ae9133d7d6$var$pitchedRowRole(isRoof, x, y);
    const side = (nx)=>{
        if (!isRoof(nx, y)) return "open";
        if (row !== "front") return "continues";
        // A taller part's front slope beside a lower roof starting here: its edge carries on down,
        // all the way beside the lower roof's back slope, to the bottom of the roll beside its ridge.
        const beside = $48a990ae9133d7d6$var$pitchedRowRole(isRoof, nx, y);
        if (beside.top <= top) return "continues";
        if (beside.row === "back" && beside.top === y) return "open";
        return beside.top === y && (beside.row === "ridgeTop" || beside.row === "solo") || beside.row === "ridge" && beside.top === y - 1 ? "join" : "continues";
    };
    const west = side(x - 1), east = side(x + 1);
    if (west === "join" || east === "join") {
        const edge = west === "join" && east === "join" ? "bothJoin" : west === "join" ? east === "open" ? "westJoinEast" : "westJoin" : west === "open" ? "eastJoinWest" : "eastJoin";
        return `front.${edge}`;
    }
    return `${row}.${west === "open" && east === "open" ? "single" : west === "open" ? "west" : east === "open" ? "east" : "mid"}`;
};
/** A cell's row role in its north-south run, and where the run starts. */ const $48a990ae9133d7d6$var$pitchedRowRole = (isRoof, x, y)=>{
    const { top: top, bottom: bottom } = $48a990ae9133d7d6$var$columnRun(isRoof, x, y);
    const depth = bottom - top + 1;
    const i = y - top;
    const row = depth === 1 ? "solo" : depth <= 4 || !$48a990ae9133d7d6$var$ridgeDrops(isRoof, x, top) ? i === 0 ? "ridgeTop" : i === depth - 1 ? "eave" : "front" : i === 0 ? "back" : i === 1 ? "ridge" : i === depth - 1 ? "eave" : "front";
    return {
        row: row,
        top: top
    };
};
const $48a990ae9133d7d6$export$7954d1f2a988f873 = (x, y, storey, name)=>{
    const salted = `roof:${name}`;
    let h = 2166136261 ^ x * 374761393 ^ y * 668265263 ^ storey * 2246822519;
    for(let i = 0; i < salted.length; i++)h = Math.imul(h ^ salted.charCodeAt(i), 16777619);
    h = Math.imul(h ^ h >>> 15, 2246822507);
    h = Math.imul(h ^ h >>> 13, 3266489909);
    return ((h ^ h >>> 16) >>> 0) / 4294967296;
};
const $48a990ae9133d7d6$export$fbdac3382545883e = (definition, name, piece)=>!!definition?.pitched && definition.ornaments?.[name]?.pieces?.[piece] !== undefined;
const $48a990ae9133d7d6$export$a773f16770998fca = (definition, placed, piece, x, y, storey = 0)=>{
    const ornaments = definition?.pitched && definition.ornaments;
    if (!ornaments) return undefined;
    if (placed && $48a990ae9133d7d6$export$fbdac3382545883e(definition, placed, piece)) return placed;
    return Object.keys(ornaments).sort().find((name)=>ornaments[name].pieces?.[piece] !== undefined && (ornaments[name].scatter ?? 0) > 0 && $48a990ae9133d7d6$export$7954d1f2a988f873(x, y, storey, name) < ornaments[name].scatter);
};
const $48a990ae9133d7d6$export$421588be49dcc38d = (definition, isRoof, x, y)=>{
    const piece = $48a990ae9133d7d6$export$bb60dad4b331947b(isRoof, x, y);
    return definition.pitched?.[piece] !== undefined ? piece : $48a990ae9133d7d6$export$eb1f96a8e22fbe1a(piece);
};
const $48a990ae9133d7d6$export$ae9b38edca1c9221 = (definition, index, isRoof, x, y, options = {})=>{
    if (!definition?.pitched) return $48a990ae9133d7d6$export$cafdb8dfbcb4da10(definition, index);
    const piece = $48a990ae9133d7d6$export$421588be49dcc38d(definition, isRoof, x, y);
    const ornament = $48a990ae9133d7d6$export$a773f16770998fca(definition, options.ornament, piece, x + (options.worldOrigin?.x ?? 0), y + (options.worldOrigin?.y ?? 0), options.storey ?? 0);
    return {
        tilesetId: definition.tilesetId,
        tilePos: ornament ? definition.ornaments[ornament].pieces[piece] : definition.pitched[piece]
    };
};
/** The original wooden roof mapping, preserved for existing roof-wood buildings. */ const $48a990ae9133d7d6$var$woodenTiles = {
    47: 468,
    42: 449,
    36: 464,
    46: 465,
    12: 481,
    28: 466,
    34: 448,
    26: 450,
    7: 480,
    4: 482,
    18: 451,
    8: 452,
    15: 453,
    14: 467,
    6: 483,
    3: 484,
    5: 455,
    2: 454,
    13: 485,
    1: 469,
    21: 404,
    9: 420,
    19: 435,
    16: 436,
    29: 416,
    37: 417,
    17: 466,
    22: 419,
    20: 464,
    10: 481,
    27: 466,
    35: 464,
    11: 481
};
const $48a990ae9133d7d6$export$1a9f2fca497fed07 = (index)=>!!index && ![
        18,
        8,
        15,
        14,
        6,
        3,
        34,
        26,
        42,
        28,
        13,
        1,
        5,
        2
    ].includes(index);
const $48a990ae9133d7d6$export$cafdb8dfbcb4da10 = (definition, index)=>({
        tilesetId: definition?.tilesetId || "fence_medieval",
        tilePos: definition ? definition.tiles[index] : $48a990ae9133d7d6$export$b2b9db084d9662fb(index)
    });
const $48a990ae9133d7d6$export$b2b9db084d9662fb = (index)=>$48a990ae9133d7d6$var$woodenTiles[index] ?? 465;


const $c5e6b310c34d168e$export$7af7634d8ee361cb = [
    "bitmask",
    "uniform",
    "platform",
    "wall",
    "roof"
];
const $c5e6b310c34d168e$export$25e373d20010e3ff = 23;
const $c5e6b310c34d168e$var$ID_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*(?::\d+)?$/;
const $c5e6b310c34d168e$var$NAME_PATTERN = /^[A-Za-z0-9_-]+$/;
const $c5e6b310c34d168e$var$LAYER_PATTERN = /^[a-z][a-z0-9]*$/;
const $c5e6b310c34d168e$var$isInt = (value)=>typeof value === "number" && Number.isInteger(value);
const $c5e6b310c34d168e$var$isIndex = (value)=>$c5e6b310c34d168e$var$isInt(value) && value >= 1 && value <= 47;
const $c5e6b310c34d168e$export$2bdd69dcfe9ad25a = (file, options = {})=>{
    const errors = [];
    const root = file;
    if (!root || typeof root !== "object") return [
        "autotile definitions: expected an object"
    ];
    if (root.version !== 1) errors.push(`autotile definitions: unsupported version ${JSON.stringify(root.version)}`);
    if (!Array.isArray(root.definitions)) return [
        ...errors,
        "autotile definitions: `definitions` must be an array"
    ];
    const ids = new Set();
    const templates = new Set();
    root.definitions.forEach((definition, position)=>{
        const where = `definition ${typeof definition?.id === "string" ? `"${definition.id}"` : `#${position}`}`;
        const fail = (message)=>errors.push(`${where}: ${message}`);
        if (!definition || typeof definition !== "object") {
            fail("expected an object");
            return;
        }
        if (typeof definition.id !== "string" || !$c5e6b310c34d168e$var$ID_PATTERN.test(definition.id)) fail("id must be lower-case words joined by '-', optionally ':<number>' (e.g. grass, lpc-terrain:353)");
        else if (ids.has(definition.id)) fail("duplicate id");
        else ids.add(definition.id);
        if (typeof definition.name !== "string" || !definition.name.trim()) fail("name must be a non-empty string");
        if (!$c5e6b310c34d168e$export$7af7634d8ee361cb.includes(definition.kind)) {
            fail(`unsupported kind ${JSON.stringify(definition.kind)} (expected one of ${$c5e6b310c34d168e$export$7af7634d8ee361cb.join(", ")})`);
            return;
        }
        const tilesetId = definition.tilesetId;
        const tileCount = options.tilesets?.[tilesetId];
        if (typeof tilesetId !== "string" || !$c5e6b310c34d168e$var$NAME_PATTERN.test(tilesetId)) fail("tilesetId must name a tileset");
        else if (options.tilesets && tileCount === undefined) fail(`unknown tileset "${tilesetId}"`);
        const tile = (label, value, { allowNone: allowNone = false } = {})=>{
            if (!$c5e6b310c34d168e$var$isInt(value) || value < (allowNone ? -1 : 0)) fail(`${label} must be a tile position (an integer${allowNone ? " >= -1" : " >= 0"}), got ${JSON.stringify(value)}`);
            else if (tileCount !== undefined && value >= tileCount) fail(`${label} ${value} is outside ${tilesetId}, which has ${tileCount} tiles`);
        };
        const layer = (label, value, required)=>{
            if (value === undefined && !required) return;
            if (typeof value !== "string" || !$c5e6b310c34d168e$var$LAYER_PATTERN.test(value)) fail(`${label} must be a layer id such as map1`);
        };
        // A tile in a tileset the reference names itself: { tilesetId, tilePos }.
        const tileRef = (label, value)=>{
            const ref = value;
            if (!ref || typeof ref !== "object" || Array.isArray(ref)) {
                fail(`${label} must be a tile reference { "tilesetId", "tilePos" }`);
                return;
            }
            const count = options.tilesets?.[ref.tilesetId];
            if (typeof ref.tilesetId !== "string" || !$c5e6b310c34d168e$var$NAME_PATTERN.test(ref.tilesetId)) fail(`${label}.tilesetId must name a tileset`);
            else if (options.tilesets && count === undefined) fail(`${label}: unknown tileset "${ref.tilesetId}"`);
            if (!$c5e6b310c34d168e$var$isInt(ref.tilePos) || ref.tilePos < 0) fail(`${label}.tilePos must be a tile position (an integer >= 0), got ${JSON.stringify(ref.tilePos)}`);
            else if (count !== undefined && ref.tilePos >= count) fail(`${label}.tilePos ${ref.tilePos} is outside ${ref.tilesetId}, which has ${count} tiles`);
            Object.keys(ref).forEach((key)=>key !== "tilesetId" && key !== "tilePos" && fail(`${label}: unknown field "${key}"`));
        };
        switch(definition.kind){
            case "roof":
                if (typeof definition.itemType !== "string" || !$c5e6b310c34d168e$var$ID_PATTERN.test(definition.itemType)) fail("itemType must name the buildable roof item");
                if (!definition.tiles || typeof definition.tiles !== "object" || Array.isArray(definition.tiles)) fail("tiles must map all roof indices (1-47) to tile positions");
                else {
                    for(let i = 1; i <= 47; i++)tile(`tiles[${i}]`, definition.tiles[i]);
                    Object.keys(definition.tiles).forEach((i)=>{
                        if (!/^\d+$/.test(i) || !$c5e6b310c34d168e$var$isIndex(Number(i))) fail(`tiles: invalid roof index ${i}`);
                    });
                }
                if (definition.pitched !== undefined) {
                    if (!definition.pitched || typeof definition.pitched !== "object" || Array.isArray(definition.pitched)) fail(`pitched must map every pitched piece (${(0, $48a990ae9133d7d6$export$c3a1ba957eeb4c96).length}) to a tile position`);
                    else {
                        (0, $48a990ae9133d7d6$export$c3a1ba957eeb4c96).forEach((piece)=>tile(`pitched[${piece}]`, definition.pitched[piece]));
                        (0, $48a990ae9133d7d6$export$68e77b0d13138b72).forEach((piece)=>definition.pitched[piece] !== undefined && tile(`pitched[${piece}]`, definition.pitched[piece]));
                        Object.keys(definition.pitched).forEach((piece)=>{
                            if (!(0, $48a990ae9133d7d6$export$c3a1ba957eeb4c96).includes(piece) && !(0, $48a990ae9133d7d6$export$68e77b0d13138b72).includes(piece)) fail(`pitched: unknown piece "${piece}" (expected <row>.<edge>, e.g. ridge.west)`);
                        });
                    }
                }
                if (definition.ornaments !== undefined) {
                    const ornaments = definition.ornaments;
                    if (!definition.pitched) fail("ornaments need a pitched roof: each one replaces some of its pitched pieces");
                    if (!ornaments || typeof ornaments !== "object" || Array.isArray(ornaments)) fail("ornaments must map ornament names to { pieces, scatter? }");
                    else Object.entries(ornaments).forEach(([name, ornament])=>{
                        const at = `ornaments.${name}`;
                        if (!/^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/.test(name)) fail(`${at}: an ornament's name is lower-case words joined by '-'`);
                        const pieces = ornament?.pieces;
                        if (!ornament || typeof ornament !== "object" || !pieces || typeof pieces !== "object" || Array.isArray(pieces) || !Object.keys(pieces).length) {
                            fail(`${at} must be { pieces: { <pitched piece>: tile }, scatter? } with at least one piece`);
                            return;
                        }
                        Object.entries(pieces).forEach(([piece, value])=>{
                            if (!(0, $48a990ae9133d7d6$export$c3a1ba957eeb4c96).includes(piece) && !(0, $48a990ae9133d7d6$export$68e77b0d13138b72).includes(piece)) fail(`${at}.pieces: unknown piece "${piece}" (expected <row>.<edge>, e.g. ridge.mid)`);
                            tile(`${at}.pieces[${piece}]`, value);
                        });
                        if (ornament.scatter !== undefined && !(typeof ornament.scatter === "number" && ornament.scatter > 0 && ornament.scatter <= 1)) fail(`${at}.scatter must be a share between 0 and 1`);
                        Object.keys(ornament).forEach((key)=>key !== "pieces" && key !== "scatter" && fail(`${at}: unknown field "${key}" (expected pieces, scatter)`));
                    });
                }
                break;
            case "bitmask":
                tile("tilePos", definition.tilePos);
                layer("layerId", definition.layerId, false);
                if (!definition.tiles || typeof definition.tiles !== "object" || Array.isArray(definition.tiles)) fail("tiles must map autotile indices to tile positions");
                else Object.entries(definition.tiles).forEach(([index, value])=>{
                    if (!/^\d+$/.test(index) || !$c5e6b310c34d168e$var$isIndex(Number(index))) fail(`tiles: "${index}" is not an autotile index (1-47)`);
                    tile(`tiles[${index}]`, value);
                });
                if (definition.fallback !== undefined) tile("fallback", definition.fallback, {
                    allowNone: true
                });
                if (definition.ornaments !== undefined) {
                    const ornaments = definition.ornaments;
                    if (!ornaments || typeof ornaments !== "object" || Array.isArray(ornaments)) fail("ornaments must map names to { tiles, scatter? }");
                    else Object.entries(ornaments).forEach(([name, ornament])=>{
                        const at = `ornaments.${name}`;
                        if (!/^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/.test(name)) fail(`${at}: invalid ornament name`);
                        if (!ornament?.tiles || typeof ornament.tiles !== "object" || Array.isArray(ornament.tiles) || !Object.keys(ornament.tiles).length) {
                            fail(`${at}.tiles must map at least one autotile index to a tile position`);
                            return;
                        }
                        Object.entries(ornament.tiles).forEach(([index, value])=>{
                            if (!/^\d+$/.test(index) || !$c5e6b310c34d168e$var$isIndex(Number(index))) fail(`${at}.tiles: invalid index ${index}`);
                            tile(`${at}.tiles[${index}]`, value);
                        });
                        if (ornament.scatter !== undefined && !(typeof ornament.scatter === "number" && ornament.scatter > 0 && ornament.scatter <= 1)) fail(`${at}.scatter must be a share between 0 and 1`);
                        Object.keys(ornament).forEach((key)=>key !== "tiles" && key !== "scatter" && fail(`${at}: unknown field "${key}"`));
                    });
                }
                if (definition.mapLayerYDelta !== undefined && !$c5e6b310c34d168e$var$isInt(definition.mapLayerYDelta)) fail("mapLayerYDelta must be an integer");
                if (definition.tiledTemplate !== undefined && typeof definition.tiledTemplate !== "boolean") fail("tiledTemplate must be true or false");
                if (definition.tiledTemplate) {
                    const key = `${tilesetId}:${definition.tilePos}`;
                    if (templates.has(key)) fail(`a second Tiled-template set for ${key}`);
                    templates.add(key);
                }
                if (definition.notes !== undefined) Object.entries(definition.notes || {}).forEach(([index, note])=>{
                    if (!$c5e6b310c34d168e$var$isIndex(Number(index)) || typeof note !== "string") fail(`notes: "${index}" must be an index with a string note`);
                });
                break;
            case "uniform":
                layer("layerId", definition.layerId, true);
                tile("previewTilePos", definition.previewTilePos);
                if (!Array.isArray(definition.indices) || !definition.indices.every($c5e6b310c34d168e$var$isIndex)) fail("indices must be a list of autotile indices (1-47)");
                else if (new Set(definition.indices).size !== definition.indices.length) fail("indices repeat");
                break;
            case "platform":
                tile("tilePos", definition.tilePos);
                if (!Array.isArray(definition.variants) || definition.variants.length !== $c5e6b310c34d168e$export$25e373d20010e3ff) fail(`variants must list exactly ${$c5e6b310c34d168e$export$25e373d20010e3ff} tile positions`);
                else definition.variants.forEach((value, i)=>tile(`variants[${i}]`, value, {
                        allowNone: true
                    }));
                if (definition.preview !== undefined) {
                    const preview = definition.preview;
                    layer("preview.layerId", preview?.layerId, true);
                    if (typeof preview?.autoBlocking !== "boolean" || typeof preview?.autoOcclusion !== "boolean") fail("preview needs autoBlocking and autoOcclusion flags");
                }
                break;
            case "wall":
                (0, $d06e01c1880d4b6a$export$54efb664f5a7f6dc)(definition, {
                    fail: fail,
                    tile: tile,
                    tileRef: tileRef,
                    layer: layer
                });
                break;
        }
    });
    return errors;
};
const $c5e6b310c34d168e$export$93c6fbb13078b3a5 = (file, options)=>{
    const errors = $c5e6b310c34d168e$export$2bdd69dcfe9ad25a(file, options);
    if (errors.length) throw new Error(`Invalid autotile definitions:\n  ${errors.join("\n  ")}`);
    return file.definitions;
};


/**
 * The behaviour content may select. Each name is implemented by engine code; content chooses among
 * them and supplies parameters, and validation refuses anything else before publication. Adding a
 * name here means implementing it first. `content/engine_handlers.test.ts` holds these lists equal
 * to the engine's own types.
 */ const $8d9457f98f5de202$export$8d83692a55402888 = {
    /** USE_ITEM activations (server campaigns/atoms/effect.ts handleActivateEffectMeta). */ itemActivationEffects: [
        "light"
    ],
    /** Projectile behaviours (mechanics/item_mechanics.ts Projectile.resolveAmmoMetaFromAmmo). */ ammoTypes: [
        "arrow",
        "webAmmo"
    ],
    /** Attack animations a weapon or race plays (client lpc_composite.ts). */ attackActions: [
        "thrust",
        "slash",
        "shoot"
    ],
    /** NPC kinds a content NPC spec creates: a sprite marker or an LPC creature (npc/forge/npc_forge.ts). */ npcTypes: [
        "marker",
        "zombie"
    ],
    /** Entity flags the engine reads on encounter creatures. */ encounterFlags: [
        "devKillable",
        "dropsLootOnDeath",
        "isChicken",
        "isRabbit",
        "isWildEnemy",
        "noContactPush",
        "nonAggro",
        "patrolWander"
    ],
    /** Item and item-class characteristics (item/item.ts ItemCharacteristics), by value type. */ characteristics: {
        boolean: [
            "equippable",
            "readyable",
            "buildable",
            "deactivateAfterPlacement",
            "exclusiveReadiness",
            "stackable",
            "useable",
            "primaryUseable",
            "campfireFuel",
            "useOnBuild",
            "useHasWorldEffect",
            "stableAngleOnDrop",
            "isCurrency",
            "isAmmo",
            "unsellable",
            "unbuyable",
            "hasDurability"
        ],
        buildType: [
            "wall",
            "decor",
            "entity",
            "roof",
            "floor",
            "floor2"
        ],
        placementAction: [
            "use",
            "build"
        ]
    },
    /**
     * Content the engine names in code: hunger and healing foods, currency, chests, building
     * pieces, outfits, wildlife. Removing or renaming one needs an engine change first, so
     * validation refuses content without them. `engine_handlers.test.ts` keeps this list complete.
     */ required: {
        items: [
            "armor-leather",
            "armor-plate",
            "arrow",
            "axe",
            "barrel1",
            "bauldron",
            "bow",
            "campfire",
            "cape-solid",
            "castlekey",
            "chest-wood",
            "coal",
            "copper",
            "crossbow",
            "dagger",
            "door-wood",
            "drumstick",
            "ember-charge",
            "feather",
            "flail",
            "floor-cobble",
            "floor-opening",
            "floor-stone",
            "floor-wood",
            "flower-single-blue",
            "flower-single-purple",
            "flower-single-red",
            "flower-single-yellow",
            "gold",
            "halberd",
            "hatch-wood",
            "hide",
            "iron",
            "iron-pickaxe",
            "legion",
            "longsleeve",
            "longsword",
            "mace",
            "metal-bar-copper",
            "metal-bar-gold",
            "metal-bar-iron",
            "metal-bar-silver",
            "mushroom-purple",
            "mushroom-red",
            "mushroom-yellow",
            "none",
            "pants",
            "pants-armor",
            "planks",
            "railing-wood",
            "rapier",
            "roof-wood",
            "rope",
            "saber",
            "sandals",
            "scythe",
            "seed",
            "shard-metal",
            "shield-crusader",
            "shield-round",
            "shield-spartan",
            "shoes",
            "shoes-armor",
            "silver",
            "skirts",
            "slippers",
            "snare-rabbit",
            "spear",
            "staff",
            "stairs",
            "stick",
            "stool1",
            "stool-small",
            "straw",
            "table-large-rough",
            "table-mid-rough",
            "table-mid-round",
            "thatch-roof",
            "timber-frame-wall",
            "torch",
            "window-frame",
            "chimney-stack",
            "dormer-window",
            "wall-stone",
            "wall-wood",
            "wall2-wood",
            "waraxe",
            "warhammer",
            "web",
            "wood",
            "tunic",
            "pantaloons",
            "boots",
            // the castle showcase: its curtain (footing, wall, battlements, arrow slits) and its towers
            "castle-footing",
            "castle-wall",
            "castle-merlons",
            "arrow-slit",
            "tower-render",
            // the ember forest's grove trees and meadow grass, planted by id (Lab tiles are also items)
            "grove-oak-a",
            "grove-oak-b",
            "grove-spruce-a",
            "grove-spruce-b",
            "grove-round-a",
            "grove-round-b",
            "grove-low-a",
            "grove-low-b",
            "meadow-grass-a",
            "meadow-grass-b",
            "meadow-grass-c",
            "meadow-grass-d",
            "meadow-grass-e",
            "meadow-grass-f"
        ],
        races: [
            "bee",
            "chicken",
            "deer",
            "horse",
            "human",
            "orc",
            "rabbit",
            "redspider",
            "skeleton",
            "slime",
            "snake",
            "spikes1",
            "wasp",
            "wolfman",
            "zombie"
        ],
        /** Encounter tables engine code reads by name, with the races it reads from each. */ encounters: {
            emberWildlife: [
                "rabbit",
                "chicken"
            ]
        }
    }
};


/**
 * Ember equipment as data. Everything a body wears or holds -- shirts, leg wear, footwear, armour,
 * a bauldron, a belt, shields and weapons -- is a MODEL: a record that says, in the expression
 * language (expr.ts), which volumes to hang on the solved skeleton, how to cut them and how to
 * paint them. A DESIGN binds an item type to a model and the values of its parameters (a
 * `longsleeve_laced` is the `shirt` model with long sleeves and a laced neck). The engine (body.ts)
 * supplies the body's own volumes, the primitive shapes, the light and the materials; models compose
 * them. The rig and its clips are the engine's; a model follows them in every pose and facing.
 *
 * The game's models and designs live in content (`content/game/sprites/ember/equipment.json`);
 * Sprite Lab makes more. Records only: what a model may call is what the engine hands it
 * (`setModelBuiltins`). Under them is the BODY LAYER (`bodies.json`, `hair.json`): the body itself
 * -- flesh, bones, a beast's head, wounds -- and hair are models too, of the `body` and `hair`
 * slots, and their library (the body's own volumes, which garments are inflated copies of) is in
 * scope for every equipment model.
 *
 * Order matters and the content compiler sorts object keys, so everything ordered is a list:
 * `let` is a list of [name, value] pairs, `parts` a list of part specs.
 */ /**
 * The expression language Ember models are written in (see model.ts): a small, side-effect-free
 * subset of JavaScript's expressions, so a model can say exactly what a drawing used to compute
 * and the frames come out the same to the bit.
 *
 *   numbers 0.5 1e-6, strings 'front', true false undefined null
 *   names and members  p.torso[1]  sk[side].knee  look.shirt.sleeves
 *   arithmetic  + - * / % **  (+ and - also add and subtract vectors; * and / scale one by a number)
 *   comparison  < <= > >= == != === !==   logic  && || ?? !   choice  a ? b : c
 *   arrays [a, b, ...rest]   objects { exponent: 2, ...extra }   calls f(a, ...rest)
 *   functions  q => q[1] > 0   (w, n) => tone(m, lit(n))
 *   array methods  .map .filter .some .every .find .includes .slice .concat .flat .indexOf .join .length
 *
 * There are no statements, assignments or loops: a model iterates with `map` over `range(n)` and
 * names its intermediate values in `let` lists. Only the functions and values a model is handed
 * exist; nothing reaches the host's globals, and constructors and prototypes are not reachable.
 *
 * Source is parsed once into a tree, which runs one of two ways with the same results: compiled to
 * JavaScript (generated only from the tree -- validated names, quoted strings, numbers, and this
 * file's own templates -- never from source text), which is what bakes frames at full speed; or,
 * where a page forbids generated code, walked by a closure interpreter.
 */ const $d3e6310995e5de40$var$OPS = [
    "===",
    "!==",
    "...",
    "=>",
    "**",
    "??",
    "&&",
    "||",
    "==",
    "!=",
    "<=",
    ">=",
    "+",
    "-",
    "*",
    "/",
    "%",
    "<",
    ">",
    "!",
    "?",
    ":",
    "(",
    ")",
    "[",
    "]",
    "{",
    "}",
    ",",
    "."
];
const $d3e6310995e5de40$var$NAME = /^[A-Za-z_$][A-Za-z0-9_$]*$/;
class $d3e6310995e5de40$export$ce85bfe1d50071fc extends Error {
}
const $d3e6310995e5de40$var$tokenize = (src)=>{
    const out = [];
    let i = 0;
    while(i < src.length){
        const c = src[i];
        if (/\s/.test(c)) {
            i++;
            continue;
        }
        if (/[0-9]/.test(c) || c === "." && /[0-9]/.test(src[i + 1] ?? "")) {
            const m = /^(?:[0-9]+\.?[0-9]*|\.[0-9]+)(?:[eE][+-]?[0-9]+)?/.exec(src.slice(i));
            out.push({
                t: "num",
                v: Number(m[0]),
                at: i
            });
            i += m[0].length;
            continue;
        }
        if (/[A-Za-z_$]/.test(c)) {
            const m = /^[A-Za-z_$][A-Za-z0-9_$]*/.exec(src.slice(i));
            out.push({
                t: "id",
                v: m[0],
                at: i
            });
            i += m[0].length;
            continue;
        }
        if (c === "'" || c === "\"") {
            let j = i + 1, text = "";
            while(j < src.length && src[j] !== c)if (src[j] === "\\") {
                text += src[j + 1] ?? "";
                j += 2;
            } else text += src[j++];
            if (j >= src.length) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Unterminated string at ${i}`);
            out.push({
                t: "str",
                v: text,
                at: i
            });
            i = j + 1;
            continue;
        }
        const op = $d3e6310995e5de40$var$OPS.find((o)=>src.startsWith(o, i));
        if (!op) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Unexpected '${c}' at ${i}`);
        out.push({
            t: "op",
            v: op,
            at: i
        });
        i += op.length;
    }
    out.push({
        t: "eof",
        at: src.length
    });
    return out;
};
/** Names never reachable as members or names: the way out to Function and the host. (A function's own
 * members -- call, apply, bind -- are unreachable because functions have none here.) */ const $d3e6310995e5de40$var$FORBIDDEN = new Set([
    "constructor",
    "__proto__",
    "prototype",
    "__defineGetter__",
    "__defineSetter__",
    "__lookupGetter__",
    "__lookupSetter__"
]);
const $d3e6310995e5de40$var$ARRAY_METHODS = new Set([
    "map",
    "filter",
    "some",
    "every",
    "find",
    "findIndex",
    "includes",
    "slice",
    "concat",
    "flat",
    "indexOf",
    "join",
    "reduce"
]);
const $d3e6310995e5de40$var$KEYWORDS = new Set([
    "true",
    "false",
    "undefined",
    "null"
]);
const $d3e6310995e5de40$var$PRECEDENCE = [
    [
        "??"
    ],
    [
        "||"
    ],
    [
        "&&"
    ],
    [
        "==",
        "!=",
        "===",
        "!=="
    ],
    [
        "<",
        "<=",
        ">",
        ">="
    ],
    [
        "+",
        "-"
    ],
    [
        "*",
        "/",
        "%"
    ]
];
const $d3e6310995e5de40$export$4543f39bf454f242 = (src)=>{
    const tokens = $d3e6310995e5de40$var$tokenize(src);
    let pos = 0;
    const peek = ()=>tokens[pos];
    const isOp = (v, tok = peek())=>tok.t === "op" && tok.v === v;
    const expect = (v)=>{
        if (!isOp(v)) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Expected '${v}' at ${peek().at} in ${src}`);
        pos++;
    };
    const checkName = (name, at)=>{
        if ($d3e6310995e5de40$var$FORBIDDEN.has(name)) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`'${name}' is not available (at ${at} in ${src})`);
        return name;
    };
    // `x => ...` or `(a, b) => ...`: the parameter names, if a function starts here.
    const lambdaAhead = ()=>{
        const tok = peek();
        if (tok.t === "id" && isOp("=>", tokens[pos + 1])) return {
            params: [
                checkName(tok.v, tok.at)
            ],
            end: pos + 2
        };
        if (!isOp("(")) return undefined;
        let depth = 0, j = pos;
        for(; j < tokens.length; j++){
            if (isOp("(", tokens[j])) depth++;
            else if (isOp(")", tokens[j]) && --depth === 0) break;
        }
        if (!isOp("=>", tokens[j + 1])) return undefined;
        const params = [];
        for(let k = pos + 1; k < j; k++){
            const t = tokens[k];
            if (t.t === "id" && !$d3e6310995e5de40$var$KEYWORDS.has(t.v)) params.push(checkName(t.v, t.at));
            else if (!isOp(",", t)) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Bad parameter list at ${t.at} in ${src}`);
        }
        return {
            params: params,
            end: j + 2
        };
    };
    const expression = ()=>{
        const lambda = lambdaAhead();
        if (lambda) {
            pos = lambda.end;
            return {
                k: "lambda",
                params: lambda.params,
                body: expression()
            };
        }
        const test = binary(0);
        if (!isOp("?")) return test;
        pos++;
        const a = expression();
        expect(":");
        return {
            k: "cond",
            c: test,
            a: a,
            b: expression()
        };
    };
    const binary = (level)=>{
        if (level >= $d3e6310995e5de40$var$PRECEDENCE.length) return unary();
        let left = binary(level + 1);
        while(peek().t === "op" && $d3e6310995e5de40$var$PRECEDENCE[level].includes(peek().v)){
            const op = tokens[pos++].v;
            left = {
                k: "bin",
                op: op,
                a: left,
                b: binary(level + 1)
            };
        }
        return left;
    };
    const unary = ()=>{
        if (isOp("-")) {
            pos++;
            return {
                k: "neg",
                a: unary()
            };
        }
        if (isOp("+")) {
            pos++;
            return unary();
        }
        if (isOp("!")) {
            pos++;
            return {
                k: "not",
                a: unary()
            };
        }
        const base = postfix();
        if (!isOp("**")) return base;
        pos++;
        return {
            k: "bin",
            op: "**",
            a: base,
            b: unary()
        };
    };
    const list = (close)=>{
        const items = [];
        while(!isOp(close)){
            const spread = isOp("...");
            if (spread) pos++;
            items.push({
                node: expression(),
                spread: spread
            });
            if (!isOp(close)) expect(",");
        }
        pos++;
        return items;
    };
    const postfix = ()=>{
        let node = primary();
        for(;;){
            if (isOp(".")) {
                pos++;
                const tok = tokens[pos++];
                if (tok.t !== "id") throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Expected a name after '.' at ${tok.at} in ${src}`);
                node = {
                    k: "dot",
                    obj: node,
                    name: checkName(tok.v, tok.at)
                };
            } else if (isOp("[")) {
                pos++;
                const index = expression();
                expect("]");
                node = {
                    k: "index",
                    obj: node,
                    index: index
                };
            } else if (isOp("(")) {
                pos++;
                node = {
                    k: "call",
                    fn: node,
                    args: list(")")
                };
            } else return node;
        }
    };
    const primary = ()=>{
        const tok = tokens[pos++];
        if (tok.t === "num" || tok.t === "str") return {
            k: "lit",
            v: tok.v
        };
        if (tok.t === "id") {
            if (tok.v === "true") return {
                k: "lit",
                v: true
            };
            if (tok.v === "false") return {
                k: "lit",
                v: false
            };
            if (tok.v === "undefined") return {
                k: "lit",
                v: undefined
            };
            if (tok.v === "null") return {
                k: "lit",
                v: null
            };
            return {
                k: "name",
                name: checkName(tok.v, tok.at)
            };
        }
        if (tok.t === "op" && tok.v === "(") {
            const inner = expression();
            expect(")");
            return inner;
        }
        if (tok.t === "op" && tok.v === "[") return {
            k: "array",
            items: list("]")
        };
        if (tok.t === "op" && tok.v === "{") {
            const entries = [];
            while(!isOp("}")){
                if (isOp("...")) {
                    pos++;
                    entries.push({
                        spread: expression()
                    });
                } else {
                    const k = tokens[pos++];
                    if (k.t !== "id" && k.t !== "str") throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Expected a key at ${k.at} in ${src}`);
                    const key = checkName(k.v, k.at);
                    if (isOp(":")) {
                        pos++;
                        entries.push({
                            key: key,
                            value: expression()
                        });
                    } else if (k.t === "id") entries.push({
                        key: key,
                        value: {
                            k: "name",
                            name: key
                        }
                    });
                    else throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Expected ':' after '${key}' in ${src}`);
                }
                if (!isOp("}")) expect(",");
            }
            pos++;
            return {
                k: "object",
                entries: entries
            };
        }
        throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Unexpected ${tok.t === "eof" ? "end" : `'${tok.v}'`} at ${tok.at} in ${src}`);
    };
    const result = expression();
    if (peek().t !== "eof") throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Unexpected '${peek().v}' at ${peek().at} in ${src}`);
    return result;
};
// ---- semantics shared by both back ends -----------------------------------------------------
const $d3e6310995e5de40$var$isVec = (v)=>Array.isArray(v) || ArrayBuffer.isView(v);
const $d3e6310995e5de40$var$member = (obj, name)=>{
    if (obj === null || obj === undefined) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Cannot read '${String(name)}' of ${obj}`);
    if (typeof name !== "string" && typeof name !== "number") throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Bad member ${String(name)}`);
    if (typeof name === "string" && $d3e6310995e5de40$var$FORBIDDEN.has(name)) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`'${name}' is not available`);
    if (typeof obj === "function") throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Functions have no members (${String(name)})`);
    if ($d3e6310995e5de40$var$isVec(obj)) {
        const list = obj;
        if (name === "length") return list.length;
        if (typeof name === "number" || /^[0-9]+$/.test(name)) return list[name];
        if ($d3e6310995e5de40$var$ARRAY_METHODS.has(name)) return list[name].bind(list);
        throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Arrays have no '${name}'`);
    }
    if (typeof obj === "string") {
        if (name === "length") return obj.length;
        if (name === "startsWith" || name === "endsWith" || name === "includes") return obj[name].bind(obj);
        throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Strings have no '${name}'`);
    }
    if (typeof obj !== "object") throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`${typeof obj} has no '${name}'`);
    return Object.prototype.hasOwnProperty.call(obj, name) ? obj[name] : undefined;
};
const $d3e6310995e5de40$var$hasOwn = Object.prototype.hasOwnProperty;
/** `obj.name` for a name the parser has already checked: plain objects straight off, the rest as member. */ const $d3e6310995e5de40$var$dot = (obj, name)=>obj !== null && typeof obj === "object" && !Array.isArray(obj) && !ArrayBuffer.isView(obj) ? $d3e6310995e5de40$var$hasOwn.call(obj, name) ? obj[name] : undefined : $d3e6310995e5de40$var$member(obj, name);
const $d3e6310995e5de40$var$add = (a, b)=>{
    if (typeof a === "number" && typeof b === "number") return a + b;
    if ($d3e6310995e5de40$var$isVec(a) && $d3e6310995e5de40$var$isVec(b)) return [
        a[0] + b[0],
        a[1] + b[1],
        a[2] + b[2]
    ];
    if (typeof a === "string" && typeof b === "string") return a + b;
    throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Cannot add ${typeof a} and ${typeof b}`);
};
const $d3e6310995e5de40$var$sub = (a, b)=>{
    if (typeof a === "number" && typeof b === "number") return a - b;
    if ($d3e6310995e5de40$var$isVec(a) && $d3e6310995e5de40$var$isVec(b)) return [
        a[0] - b[0],
        a[1] - b[1],
        a[2] - b[2]
    ];
    throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Cannot subtract ${typeof b} from ${typeof a}`);
};
const $d3e6310995e5de40$var$mul = (a, b)=>{
    if (typeof a === "number" && typeof b === "number") return a * b;
    if ($d3e6310995e5de40$var$isVec(a) && typeof b === "number") return [
        a[0] * b,
        a[1] * b,
        a[2] * b
    ];
    if (typeof a === "number" && $d3e6310995e5de40$var$isVec(b)) return [
        a * b[0],
        a * b[1],
        a * b[2]
    ];
    throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Cannot multiply ${typeof a} by ${typeof b}`);
};
const $d3e6310995e5de40$var$div = (a, b)=>{
    if (typeof a === "number" && typeof b === "number") return a / b;
    if ($d3e6310995e5de40$var$isVec(a) && typeof b === "number") return [
        a[0] / b,
        a[1] / b,
        a[2] / b
    ];
    throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Cannot divide ${typeof a} by ${typeof b}`);
};
const $d3e6310995e5de40$var$neg = (v)=>{
    if (typeof v === "number") return -v;
    if ($d3e6310995e5de40$var$isVec(v)) return [
        -v[0],
        -v[1],
        -v[2]
    ];
    throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Cannot negate ${typeof v}`);
};
const $d3e6310995e5de40$var$lookup = (scope, name)=>{
    const v = scope[name];
    if (v === undefined && !(name in scope)) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Unknown name '${name}'`);
    return v;
};
const $d3e6310995e5de40$var$num = (op, f)=>(a, b)=>{
        if (typeof a !== "number" || typeof b !== "number") throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`'${op}' needs numbers`);
        return f(a, b);
    };
const $d3e6310995e5de40$var$BINARY = {
    "+": $d3e6310995e5de40$var$add,
    "-": $d3e6310995e5de40$var$sub,
    "*": $d3e6310995e5de40$var$mul,
    "/": $d3e6310995e5de40$var$div,
    "%": $d3e6310995e5de40$var$num("%", (a, b)=>a % b),
    "**": $d3e6310995e5de40$var$num("**", (a, b)=>a ** b),
    "<": $d3e6310995e5de40$var$num("<", (a, b)=>a < b),
    "<=": $d3e6310995e5de40$var$num("<=", (a, b)=>a <= b),
    ">": $d3e6310995e5de40$var$num(">", (a, b)=>a > b),
    ">=": $d3e6310995e5de40$var$num(">=", (a, b)=>a >= b),
    "==": (a, b)=>a === b,
    "===": (a, b)=>a === b,
    "!=": (a, b)=>a !== b,
    "!==": (a, b)=>a !== b
};
// ---- back end 1: closures ------------------------------------------------------------------
const $d3e6310995e5de40$var$spreadInto = (items, s)=>{
    const out = [];
    for (const it of items){
        const v = it.node(s);
        if (it.spread) {
            if (!$d3e6310995e5de40$var$isVec(v)) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc("Only an array can be spread");
            const list = v;
            for(let i = 0; i < list.length; i++)out.push(list[i]);
        } else out.push(v);
    }
    return out;
};
const $d3e6310995e5de40$export$67beed298888a38b = (node)=>{
    switch(node.k){
        case "lit":
            {
                const v = node.v;
                return ()=>v;
            }
        case "name":
            {
                const name = node.name;
                return (s)=>$d3e6310995e5de40$var$lookup(s, name);
            }
        case "dot":
            {
                const obj = $d3e6310995e5de40$export$67beed298888a38b(node.obj), name = node.name;
                return (s)=>$d3e6310995e5de40$var$dot(obj(s), name);
            }
        case "index":
            {
                const obj = $d3e6310995e5de40$export$67beed298888a38b(node.obj), index = $d3e6310995e5de40$export$67beed298888a38b(node.index);
                return (s)=>$d3e6310995e5de40$var$member(obj(s), index(s));
            }
        case "call":
            {
                const fn = $d3e6310995e5de40$export$67beed298888a38b(node.fn), args = node.args.map((a)=>({
                        node: $d3e6310995e5de40$export$67beed298888a38b(a.node),
                        spread: a.spread
                    }));
                return (s)=>{
                    const f = fn(s);
                    if (typeof f !== "function") throw new $d3e6310995e5de40$export$ce85bfe1d50071fc("Not a function");
                    return f(...$d3e6310995e5de40$var$spreadInto(args, s));
                };
            }
        case "neg":
            {
                const a = $d3e6310995e5de40$export$67beed298888a38b(node.a);
                return (s)=>$d3e6310995e5de40$var$neg(a(s));
            }
        case "not":
            {
                const a = $d3e6310995e5de40$export$67beed298888a38b(node.a);
                return (s)=>!a(s);
            }
        case "cond":
            {
                const c = $d3e6310995e5de40$export$67beed298888a38b(node.c), a = $d3e6310995e5de40$export$67beed298888a38b(node.a), b = $d3e6310995e5de40$export$67beed298888a38b(node.b);
                return (s)=>c(s) ? a(s) : b(s);
            }
        case "bin":
            {
                const a = $d3e6310995e5de40$export$67beed298888a38b(node.a), b = $d3e6310995e5de40$export$67beed298888a38b(node.b);
                if (node.op === "&&") return (s)=>a(s) && b(s);
                if (node.op === "||") return (s)=>a(s) || b(s);
                if (node.op === "??") return (s)=>a(s) ?? b(s);
                const f = $d3e6310995e5de40$var$BINARY[node.op];
                return (s)=>f(a(s), b(s));
            }
        case "array":
            {
                const items = node.items.map((a)=>({
                        node: $d3e6310995e5de40$export$67beed298888a38b(a.node),
                        spread: a.spread
                    }));
                return (s)=>$d3e6310995e5de40$var$spreadInto(items, s);
            }
        case "object":
            {
                const entries = node.entries.map((e)=>"spread" in e ? {
                        spread: $d3e6310995e5de40$export$67beed298888a38b(e.spread)
                    } : {
                        key: e.key,
                        value: $d3e6310995e5de40$export$67beed298888a38b(e.value)
                    });
                return (s)=>{
                    const out = {};
                    for (const e of entries)if ("spread" in e) {
                        const v = e.spread(s);
                        if (v && typeof v === "object") {
                            for (const k of Object.keys(v))if (!$d3e6310995e5de40$var$FORBIDDEN.has(k)) out[k] = v[k];
                        }
                    } else out[e.key] = e.value(s);
                    return out;
                };
            }
        case "lambda":
            {
                const params = node.params, body = $d3e6310995e5de40$export$67beed298888a38b(node.body);
                return (scope)=>(...args)=>{
                        const inner = Object.create(scope);
                        for(let i = 0; i < params.length; i++)inner[params[i]] = args[i];
                        return body(inner);
                    };
            }
    }
};
const $d3e6310995e5de40$var$isFn = (v)=>!!v && typeof v === "object" && !Array.isArray(v) && Array.isArray(v.fn);
const $d3e6310995e5de40$var$local = (name)=>`v_${name}`;
/** `obj[index]`: a list's item straight off, the rest as member. */ const $d3e6310995e5de40$var$index = (obj, k)=>typeof k === "number" && Array.isArray(obj) ? obj[k] : $d3e6310995e5de40$var$member(obj, k);
/** `obj.name(...args)`: a list's or string's own method called on it (as member's bound one would be), the rest a function member. */ const $d3e6310995e5de40$var$call = (obj, name, args)=>{
    if ($d3e6310995e5de40$var$isVec(obj) && $d3e6310995e5de40$var$ARRAY_METHODS.has(name)) return obj[name](...args);
    if (typeof obj === "string" && (name === "startsWith" || name === "endsWith" || name === "includes")) return obj[name](...args);
    return $d3e6310995e5de40$var$dot(obj, name)(...args);
};
const $d3e6310995e5de40$var$helpers = {
    $g: $d3e6310995e5de40$var$lookup,
    $m: $d3e6310995e5de40$var$member,
    $d: $d3e6310995e5de40$var$dot,
    $i: $d3e6310995e5de40$var$index,
    $call: $d3e6310995e5de40$var$call,
    $add: $d3e6310995e5de40$var$add,
    $sub: $d3e6310995e5de40$var$sub,
    $mul: $d3e6310995e5de40$var$mul,
    $div: $d3e6310995e5de40$var$div,
    $neg: $d3e6310995e5de40$var$neg
};
const $d3e6310995e5de40$var$PRELUDE = `"use strict"; const { $g, $m, $d, $i, $call, $add, $sub, $mul, $div, $neg } = $h;`;
const $d3e6310995e5de40$var$literal = (unit, v)=>`$L[${unit.literals.push(v) - 1}]`;
const $d3e6310995e5de40$var$gen = (node, locals, unit)=>{
    const g = (n)=>$d3e6310995e5de40$var$gen(n, locals, unit);
    const items = (list)=>list.map((i)=>i.spread ? `...(${g(i.node)})` : `(${g(i.node)})`).join(", ");
    switch(node.k){
        case "lit":
            {
                const v = node.v;
                if (typeof v === "number") return Number.isFinite(v) ? String(v) : v !== v ? "NaN" : v > 0 ? "(1/0)" : "(-1/0)";
                if (typeof v === "string") return JSON.stringify(v);
                return v === undefined ? "undefined" : v === null ? "null" : v ? "true" : "false";
            }
        case "name":
            if (!$d3e6310995e5de40$var$NAME.test(node.name) || $d3e6310995e5de40$var$FORBIDDEN.has(node.name)) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Bad name ${node.name}`);
            if (locals.has(node.name)) return $d3e6310995e5de40$var$local(node.name);
            let cached = unit.names.get(node.name);
            if (!cached) unit.names.set(node.name, cached = `$c${unit.names.size}`);
            return `(${cached} !== undefined ? ${cached} : (${cached} = $g($s, ${JSON.stringify(node.name)})))`;
        case "dot":
            if (!$d3e6310995e5de40$var$NAME.test(node.name) || $d3e6310995e5de40$var$FORBIDDEN.has(node.name)) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Bad member ${node.name}`);
            return `$d(${g(node.obj)}, ${JSON.stringify(node.name)})`;
        case "index":
            return `$i(${g(node.obj)}, ${g(node.index)})`;
        case "call":
            if (node.fn.k === "dot") {
                if (!$d3e6310995e5de40$var$NAME.test(node.fn.name) || $d3e6310995e5de40$var$FORBIDDEN.has(node.fn.name)) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Bad member ${node.fn.name}`);
                return `$call(${g(node.fn.obj)}, ${JSON.stringify(node.fn.name)}, [${items(node.args)}])`;
            }
            return `(${g(node.fn)})(${items(node.args)})`;
        case "neg":
            return `$neg(${g(node.a)})`;
        case "not":
            return `(!(${g(node.a)}))`;
        case "cond":
            return `((${g(node.c)}) ? (${g(node.a)}) : (${g(node.b)}))`;
        case "bin":
            {
                const a = g(node.a), b = g(node.b);
                switch(node.op){
                    case "+":
                        return `$add(${a}, ${b})`;
                    case "-":
                        return `$sub(${a}, ${b})`;
                    case "*":
                        return `$mul(${a}, ${b})`;
                    case "/":
                        return `$div(${a}, ${b})`;
                    case "==":
                        return `((${a}) === (${b}))`;
                    case "!=":
                        return `((${a}) !== (${b}))`;
                    case "%":
                    case "**":
                    case "<":
                    case "<=":
                    case ">":
                    case ">=":
                    case "===":
                    case "!==":
                    case "&&":
                    case "||":
                    case "??":
                        return `((${a}) ${node.op} (${b}))`;
                }
                throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Unknown operator ${node.op}`);
            }
        case "array":
            return `[${items(node.items)}]`;
        case "object":
            return `({ ${node.entries.map((e)=>"spread" in e ? `...(${g(e.spread)})` : `${JSON.stringify(e.key)}: (${g(e.value)})`).join(", ")} })`;
        case "lambda":
            {
                for (const p of node.params)if (!$d3e6310995e5de40$var$NAME.test(p) || $d3e6310995e5de40$var$FORBIDDEN.has(p)) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Bad parameter ${p}`);
                const inner = new Set([
                    ...locals,
                    ...node.params
                ]);
                return `((${node.params.map($d3e6310995e5de40$var$local).join(", ")}) => (${$d3e6310995e5de40$var$gen(node.body, inner, unit)}))`;
            }
    }
};
const $d3e6310995e5de40$var$genValue = (value, locals, unit)=>typeof value === "string" ? $d3e6310995e5de40$var$gen($d3e6310995e5de40$export$4543f39bf454f242(value), locals, unit) : $d3e6310995e5de40$var$isFn(value) ? $d3e6310995e5de40$var$genFn(value, locals, unit) : $d3e6310995e5de40$var$literal(unit, $d3e6310995e5de40$var$deepFreeze($d3e6310995e5de40$var$clone(value)));
const $d3e6310995e5de40$var$genFn = (spec, locals, unit)=>{
    const names = [
        ...spec.fn,
        ...(spec.let ?? []).map(([n])=>n)
    ];
    for (const n of names)if (typeof n !== "string" || !$d3e6310995e5de40$var$NAME.test(n) || $d3e6310995e5de40$var$FORBIDDEN.has(n)) throw new $d3e6310995e5de40$export$ce85bfe1d50071fc(`Bad name ${String(n)}`);
    const inner = new Set([
        ...locals,
        ...names
    ]);
    const lets = (spec.let ?? []).map(([n, v])=>`${$d3e6310995e5de40$var$local(n)} = ${$d3e6310995e5de40$var$genValue(v, inner, unit)};`).join(" ");
    const declared = (spec.let ?? []).length ? `let ${(spec.let ?? []).map(([n])=>$d3e6310995e5de40$var$local(n)).join(", ")};` : "";
    const cases = (spec.cases ?? []).map(([c, v])=>`if (${$d3e6310995e5de40$var$gen($d3e6310995e5de40$export$4543f39bf454f242(c), inner, unit)}) return ${$d3e6310995e5de40$var$genValue(v, inner, unit)};`).join(" ");
    const result = spec.return === undefined ? "undefined" : $d3e6310995e5de40$var$genValue(spec.return, inner, unit);
    return `(function (${spec.fn.map($d3e6310995e5de40$var$local).join(", ")}) { ${declared} ${lets} ${cases} return ${result}; })`;
};
const $d3e6310995e5de40$var$clone = (v)=>v === undefined ? undefined : JSON.parse(JSON.stringify(v));
const $d3e6310995e5de40$var$deepFreeze = (v)=>{
    if (v && typeof v === "object") {
        Object.values(v).forEach($d3e6310995e5de40$var$deepFreeze);
        Object.freeze(v);
    }
    return v;
};
/** Whether this page lets us generate code (a strict content-security policy may not). */ let $d3e6310995e5de40$var$generated;
const $d3e6310995e5de40$var$canGenerate = ()=>{
    if ($d3e6310995e5de40$var$generated === undefined) try {
        $d3e6310995e5de40$var$generated = new Function("return 1")() === 1;
    } catch  {
        $d3e6310995e5de40$var$generated = false;
    }
    return $d3e6310995e5de40$var$generated;
};
const $d3e6310995e5de40$export$6b9f86a7f6b32c41 = (backend)=>{
    $d3e6310995e5de40$var$generated = backend === "auto" ? undefined : backend === "js";
    $d3e6310995e5de40$var$cache.clear();
    $d3e6310995e5de40$var$fnCache.clear();
};
const $d3e6310995e5de40$var$build = (body, unit)=>{
    const cache = unit.names.size ? `let ${[
        ...unit.names.values()
    ].join(", ")}; ` : "";
    return new Function("$h", "$L", `${$d3e6310995e5de40$var$PRELUDE} return ($s) => { ${cache}return (${body}); };`)($d3e6310995e5de40$var$helpers, unit.literals);
};
const $d3e6310995e5de40$export$12c06bded9e47a5d = (src)=>{
    const tree = $d3e6310995e5de40$export$4543f39bf454f242(src);
    if (!$d3e6310995e5de40$var$canGenerate()) return $d3e6310995e5de40$export$67beed298888a38b(tree);
    const unit = {
        literals: [],
        names: new Map()
    };
    return $d3e6310995e5de40$var$build($d3e6310995e5de40$var$gen(tree, new Set(), unit), unit);
};
const $d3e6310995e5de40$var$cache = new Map();
const $d3e6310995e5de40$export$dce8637ca0d755f = (src)=>{
    let c = $d3e6310995e5de40$var$cache.get(src);
    if (!c) {
        c = $d3e6310995e5de40$export$12c06bded9e47a5d(src);
        $d3e6310995e5de40$var$cache.set(src, c);
    }
    return c;
};
const $d3e6310995e5de40$var$interpretValue = (value, path)=>{
    if (typeof value === "string") return $d3e6310995e5de40$export$67beed298888a38b($d3e6310995e5de40$export$4543f39bf454f242(value));
    if ($d3e6310995e5de40$var$isFn(value)) return $d3e6310995e5de40$var$interpretFn(value, path);
    const v = $d3e6310995e5de40$var$deepFreeze($d3e6310995e5de40$var$clone(value));
    return ()=>v;
};
const $d3e6310995e5de40$var$interpretFn = (spec, path)=>{
    const params = spec.fn;
    const lets = (spec.let ?? []).map(([n, v])=>[
            n,
            $d3e6310995e5de40$var$interpretValue(v, path)
        ]);
    const cases = (spec.cases ?? []).map(([c, v])=>[
            $d3e6310995e5de40$export$67beed298888a38b($d3e6310995e5de40$export$4543f39bf454f242(c)),
            $d3e6310995e5de40$var$interpretValue(v, path)
        ]);
    const result = spec.return === undefined ? undefined : $d3e6310995e5de40$var$interpretValue(spec.return, path);
    return (scope)=>(...args)=>{
            const s = Object.create(scope);
            for(let i = 0; i < params.length; i++)s[params[i]] = args[i];
            for(let i = 0; i < lets.length; i++)s[lets[i][0]] = lets[i][1](s);
            for(let i = 0; i < cases.length; i++)if (cases[i][0](s)) return cases[i][1](s);
            return result ? result(s) : undefined;
        };
};
const $d3e6310995e5de40$var$fnCache = new Map();
const $d3e6310995e5de40$export$3709c8c7dabff5d2 = (spec, path = "fn")=>{
    const key = JSON.stringify(spec);
    let c = $d3e6310995e5de40$var$fnCache.get(key);
    if (c) return c;
    if ($d3e6310995e5de40$var$canGenerate()) {
        const unit = {
            literals: [],
            names: new Map()
        };
        c = $d3e6310995e5de40$var$build($d3e6310995e5de40$var$genFn(spec, new Set(), unit), unit);
    } else c = $d3e6310995e5de40$var$interpretFn(spec, path);
    $d3e6310995e5de40$var$fnCache.set(key, c);
    return c;
};


const $121d74fbc26f823b$export$d942c7a6b15bf97d = [
    "pants",
    "shoes",
    "shirt",
    "belt",
    "armor",
    "bauldron",
    "shield",
    "held"
];
const $121d74fbc26f823b$export$7a1cd63e2b2b9229 = [
    "body",
    "feature",
    "hair"
];
const $121d74fbc26f823b$export$a839e9ddc1b1a60f = {
    shirt: "shirt",
    pants: "pants",
    shoes: "shoes",
    belt: undefined,
    armor: "armor",
    bauldron: "bauldron",
    shield: "shield",
    held: "weapon"
};
const $121d74fbc26f823b$export$5586d797f390878c = "shell";
const $121d74fbc26f823b$var$isObject = (v)=>!!v && typeof v === "object" && !Array.isArray(v);
const $121d74fbc26f823b$var$deepFreeze = (v)=>{
    if (v && typeof v === "object") {
        Object.values(v).forEach($121d74fbc26f823b$var$deepFreeze);
        Object.freeze(v);
    }
    return v;
};
const $121d74fbc26f823b$var$withPath = (path, f)=>{
    try {
        return f();
    } catch (e) {
        throw new (0, $d3e6310995e5de40$export$ce85bfe1d50071fc)(`${path}: ${e.message}`);
    }
};
const $121d74fbc26f823b$export$c630c49e4db917cd = (value, path)=>{
    if (typeof value === "string") return $121d74fbc26f823b$var$withPath(path, ()=>(0, $d3e6310995e5de40$export$dce8637ca0d755f)(value));
    if ($121d74fbc26f823b$var$isObject(value) && Array.isArray(value.fn)) return $121d74fbc26f823b$var$withPath(path, ()=>(0, $d3e6310995e5de40$export$3709c8c7dabff5d2)(value, path));
    const literal = $121d74fbc26f823b$var$deepFreeze(JSON.parse(JSON.stringify(value)));
    return ()=>literal;
};
const $121d74fbc26f823b$var$compileLets = (lets, path)=>(lets ?? []).map(([name, value], i)=>{
        if (typeof name !== "string" || !/^[A-Za-z_$][A-Za-z0-9_$]*$/.test(name)) throw new (0, $d3e6310995e5de40$export$ce85bfe1d50071fc)(`${path}.let[${i}]: bad name ${String(name)}`);
        return [
            name,
            $121d74fbc26f823b$export$c630c49e4db917cd(value, `${path}.let[${i}] ${name}`)
        ];
    });
/** Names bound lazily, once per scope: a value nothing reads is never computed (or able to fail). */ const $121d74fbc26f823b$var$bindLazy = (scope, lets)=>{
    for (const [name, compiled] of lets){
        let done = false, value;
        Object.defineProperty(scope, name, {
            enumerable: true,
            configurable: true,
            get: ()=>{
                if (!done) {
                    value = compiled(scope);
                    done = true;
                }
                return value;
            }
        });
    }
};
const $121d74fbc26f823b$var$collect = (value, out)=>{
    if (value === undefined || value === null || value === false) return;
    if (Array.isArray(value)) {
        for (const v of value)$121d74fbc26f823b$var$collect(v, out);
        return;
    }
    out.push(value);
};
const $121d74fbc26f823b$var$compileParts = (parts, path, models, slot)=>(parts ?? []).map((part, i)=>$121d74fbc26f823b$var$compilePart(part, `${path}[${i}]`, models, slot));
const $121d74fbc26f823b$var$compilePart = (part, path, models, slot)=>{
    if (typeof part === "string") {
        const c = $121d74fbc26f823b$var$withPath(path, ()=>(0, $d3e6310995e5de40$export$dce8637ca0d755f)(part));
        return (s, out)=>$121d74fbc26f823b$var$collect(c(s), out);
    }
    if (!$121d74fbc26f823b$var$isObject(part)) throw new (0, $d3e6310995e5de40$export$ce85bfe1d50071fc)(`${path}: a part is an expression or a part spec`);
    if ("when" in part) {
        const test = $121d74fbc26f823b$var$withPath(`${path}.when`, ()=>(0, $d3e6310995e5de40$export$dce8637ca0d755f)(part.when));
        const yes = $121d74fbc26f823b$var$compileParts(part.parts, `${path}.parts`, models, slot);
        const no = $121d74fbc26f823b$var$compileParts(part.else ?? [], `${path}.else`, models, slot);
        return (s, out)=>{
            for (const r of test(s) ? yes : no)r(s, out);
        };
    }
    if ("each" in part) {
        const list = $121d74fbc26f823b$var$withPath(`${path}.each`, ()=>(0, $d3e6310995e5de40$export$dce8637ca0d755f)(part.each));
        const lets = $121d74fbc26f823b$var$compileLets(part.let, path);
        const inner = $121d74fbc26f823b$var$compileParts(part.parts, `${path}.parts`, models, slot);
        const as = part.as;
        return (s, out)=>{
            const items = list(s);
            if (!Array.isArray(items)) throw new (0, $d3e6310995e5de40$export$ce85bfe1d50071fc)(`${path}.each: not a list`);
            for (const item of items){
                const scope = Object.create(s);
                scope[as] = item;
                for (const [name, c] of lets)scope[name] = c(scope);
                for (const r of inner)r(scope, out);
            }
        };
    }
    if ("paint" in part) {
        const paint = $121d74fbc26f823b$export$c630c49e4db917cd(part.paint, `${path}.paint`);
        const inner = $121d74fbc26f823b$var$compileParts(part.parts, `${path}.parts`, models, slot);
        const over = !!part.over;
        return (s, out)=>{
            const made = [];
            for (const r of inner)r(s, made);
            const f = paint(s);
            if (!f) {
                out.push(...made);
                return;
            }
            const builtins = s.$builtins;
            out.push(...(over ? builtins.overPainted : builtins.painted)(made, f));
        };
    }
    if ("apply" in part) {
        const fn = $121d74fbc26f823b$var$withPath(`${path}.apply`, ()=>(0, $d3e6310995e5de40$export$dce8637ca0d755f)(part.apply));
        const inner = $121d74fbc26f823b$var$compileParts(part.parts, `${path}.parts`, models, slot);
        return (s, out)=>{
            const made = [];
            for (const r of inner)r(s, made);
            const f = fn(s);
            if (!f) {
                out.push(...made);
                return;
            }
            if (typeof f !== "function") throw new (0, $d3e6310995e5de40$export$ce85bfe1d50071fc)(`${path}.apply: not a function`);
            $121d74fbc26f823b$var$collect(f(made), out);
        };
    }
    if ("use" in part) {
        const [useSlot, name] = part.use.includes("/") ? part.use.split("/") : [
            slot,
            part.use
        ];
        const bound = Object.entries(part.bind ?? {}).map(([k, v])=>[
                k,
                $121d74fbc26f823b$var$withPath(`${path}.bind.${k}`, ()=>(0, $d3e6310995e5de40$export$dce8637ca0d755f)(v))
            ]);
        const literal = part.with ?? {};
        return (s, out)=>{
            const params = {
                ...s.params,
                ...literal
            };
            for (const [k, c] of bound)params[k] = c(s);
            $121d74fbc26f823b$var$collect(models.run(useSlot, name, params, s.$context), out);
        };
    }
    if ("let" in part) {
        const lets = $121d74fbc26f823b$var$compileLets(part.let, path);
        const inner = $121d74fbc26f823b$var$compileParts(part.parts, `${path}.parts`, models, slot);
        return (s, out)=>{
            const scope = Object.create(s);
            $121d74fbc26f823b$var$bindLazy(scope, lets);
            for (const r of inner)r(scope, out);
        };
    }
    throw new (0, $d3e6310995e5de40$export$ce85bfe1d50071fc)(`${path}: unknown part spec (${Object.keys(part).join(", ")})`);
};
let $121d74fbc26f823b$var$builtins = Object.create(null);
const $121d74fbc26f823b$export$9adde861b5055710 = (names)=>{
    $121d74fbc26f823b$var$builtins = Object.assign(Object.create(null), names);
    $121d74fbc26f823b$var$builtins.$builtins = $121d74fbc26f823b$var$builtins;
    for (const set of [
        $121d74fbc26f823b$var$body,
        $121d74fbc26f823b$var$content,
        $121d74fbc26f823b$var$preview,
        $121d74fbc26f823b$var$species,
        $121d74fbc26f823b$var$speciesPreview
    ])set.reset();
};
const $121d74fbc26f823b$export$2b279e4c49e9707c = ()=>Object.fromEntries(Object.entries($121d74fbc26f823b$var$builtins).filter(([name])=>!name.startsWith("$")));
class $121d74fbc26f823b$var$ModelSet {
    constructor(file, fallback){
        this.file = file;
        this.fallback = fallback;
        this.compiled = new Map();
    }
    reset() {
        this.compiled.clear();
        this.library = undefined;
    }
    libraryScope() {
        if (!this.library) {
            const scope = Object.create(this.fallback ? this.fallback.libraryScope() : $121d74fbc26f823b$var$builtins);
            $121d74fbc26f823b$var$bindLazy(scope, $121d74fbc26f823b$var$compileLets(this.file?.library, "library"));
            this.library = scope;
        }
        return this.library;
    }
    model(slot, name) {
        const own = this.file?.models?.[slot]?.[name];
        return own ?? this.fallback?.model(slot, name);
    }
    compile(slot, name) {
        const k = `${slot}/${name}`;
        let c = this.compiled.get(k);
        if (c) return c;
        const m = this.model(slot, name);
        if (!m) return undefined;
        const path = `models.${slot}.${name}`;
        c = {
            params: m.params ?? {},
            lets: $121d74fbc26f823b$var$compileLets(m.let, path),
            parts: $121d74fbc26f823b$var$compileParts(m.parts, `${path}.parts`, this, slot),
            overBody: m.overBody ? {
                groups: m.overBody.groups,
                paint: $121d74fbc26f823b$export$c630c49e4db917cd(m.overBody.paint, `${path}.overBody.paint`),
                skin: !!m.overBody.skin
            } : undefined
        };
        this.compiled.set(k, c);
        return c;
    }
    /** Run a model: the primitives it makes, and paint it lays over the body (pushed onto `overBody`). */ run(slot, name, params, context, overBody, bind) {
        const c = this.compile(slot, name);
        if (!c) return [];
        const scope = Object.create(this.libraryScope());
        Object.assign(scope, context);
        scope.$context = context;
        const all = {
            ...c.params,
            ...params
        };
        scope.params = all;
        for (const k of Object.keys(all))scope[k] = all[k];
        if (bind) $121d74fbc26f823b$var$bindLazy(scope, Object.entries(bind).map(([k, v])=>[
                k,
                $121d74fbc26f823b$var$withPath(`${slot}/${name} bind.${k}`, ()=>(0, $d3e6310995e5de40$export$dce8637ca0d755f)(v))
            ]));
        $121d74fbc26f823b$var$bindLazy(scope, c.lets);
        const out = [];
        for (const r of c.parts)r(scope, out);
        if (c.overBody && overBody) overBody.push({
            groups: c.overBody.groups,
            paint: c.overBody.paint(scope),
            ...c.overBody.skin ? {
                skin: true
            } : {}
        });
        return out;
    }
    designs() {
        const own = this.file?.designs ?? [];
        const ids = new Set(own.map((d)=>`${d.slot}:${d.id}`));
        return [
            ...this.fallback?.designs().filter((d)=>!ids.has(`${d.slot}:${d.id}`)) ?? [],
            ...own
        ];
    }
}
/** The body layer (bodies.json, hair.json): under the game's equipment, which sees its library. */ const $121d74fbc26f823b$var$body = new $121d74fbc26f823b$var$ModelSet(undefined);
const $121d74fbc26f823b$var$content = new $121d74fbc26f823b$var$ModelSet(undefined, $121d74fbc26f823b$var$body);
let $121d74fbc26f823b$var$preview = new $121d74fbc26f823b$var$ModelSet(undefined, $121d74fbc26f823b$var$content);
/** Species bodies (species.json): their own models over the body layer, whose library they see; a tool's preview over them. */ const $121d74fbc26f823b$var$species = new $121d74fbc26f823b$var$ModelSet(undefined, $121d74fbc26f823b$var$body);
const $121d74fbc26f823b$var$speciesPreview = new $121d74fbc26f823b$var$ModelSet(undefined, $121d74fbc26f823b$var$species);
let $121d74fbc26f823b$var$hair;
let $121d74fbc26f823b$var$designIndex = new Map();
let $121d74fbc26f823b$var$designKeys = new Map();
const $121d74fbc26f823b$var$fingerprintOf = (value)=>{
    const text = JSON.stringify(value);
    let h = 2166136261;
    for(let i = 0; i < text.length; i++)h = Math.imul(h ^ text.charCodeAt(i), 16777619);
    return (h >>> 0).toString(36);
};
const $121d74fbc26f823b$var$listeners = [];
const $121d74fbc26f823b$export$dde91a05cabd1edf = (listener)=>{
    $121d74fbc26f823b$var$listeners.push(listener);
    listener();
};
let $121d74fbc26f823b$var$revision = "";
const $121d74fbc26f823b$export$7087b1beab1089cd = ()=>$121d74fbc26f823b$var$revision;
const $121d74fbc26f823b$var$parts = new Map();
const $121d74fbc26f823b$var$reindex = ()=>{
    $121d74fbc26f823b$var$designIndex = new Map($121d74fbc26f823b$var$preview.designs().map((d)=>[
            `${d.slot}:${d.id}`,
            d
        ]));
    $121d74fbc26f823b$var$designKeys = new Map();
    $121d74fbc26f823b$var$parts.set("preview", $121d74fbc26f823b$var$fingerprintOf($121d74fbc26f823b$var$preview.file ?? null));
    $121d74fbc26f823b$var$revision = $121d74fbc26f823b$var$fingerprintOf([
        ...$121d74fbc26f823b$var$parts.entries()
    ].sort());
    for (const listener of $121d74fbc26f823b$var$listeners)listener();
};
const $121d74fbc26f823b$export$35d5ab3d09c2908f = (part, value)=>{
    $121d74fbc26f823b$var$parts.set(part, $121d74fbc26f823b$var$fingerprintOf(value ?? null));
    $121d74fbc26f823b$var$reindex();
};
const $121d74fbc26f823b$export$8d98c437dc3f7e0a = (bodies, hairFile)=>{
    $121d74fbc26f823b$var$body.file = bodies || hairFile ? {
        version: 1,
        library: [
            ...bodies?.library ?? [],
            ...hairFile?.library ?? []
        ],
        models: {
            body: bodies?.models ?? {},
            feature: bodies?.features ?? {},
            hair: hairFile?.models ?? {}
        },
        designs: []
    } : undefined;
    $121d74fbc26f823b$var$hair = hairFile;
    for (const set of [
        $121d74fbc26f823b$var$body,
        $121d74fbc26f823b$var$content,
        $121d74fbc26f823b$var$preview,
        $121d74fbc26f823b$var$species,
        $121d74fbc26f823b$var$speciesPreview
    ])set.reset();
    $121d74fbc26f823b$var$parts.set("bodies", $121d74fbc26f823b$var$fingerprintOf([
        bodies ?? null,
        hairFile ?? null
    ]));
    $121d74fbc26f823b$var$reindex();
};
const $121d74fbc26f823b$export$22dcbb71e9260857 = (style)=>{
    if (!$121d74fbc26f823b$var$hair || $121d74fbc26f823b$var$hair.none.includes(style)) return undefined;
    const own = $121d74fbc26f823b$var$hair.styles[style] ?? $121d74fbc26f823b$var$hair.styles[$121d74fbc26f823b$var$hair.default];
    if (!own) return undefined;
    const { model: model, about: about, ...params } = own;
    return {
        model: typeof model === "string" ? model : $121d74fbc26f823b$export$5586d797f390878c,
        params: params
    };
};
const $121d74fbc26f823b$export$f8f17b875f484d58 = ()=>$121d74fbc26f823b$var$hair?.styles ?? {};
const $121d74fbc26f823b$export$65e2f1c969933753 = (file)=>{
    $121d74fbc26f823b$var$content.file = file;
    $121d74fbc26f823b$var$content.reset();
    $121d74fbc26f823b$var$preview.reset();
    $121d74fbc26f823b$var$parts.set("equipment", $121d74fbc26f823b$var$fingerprintOf(file ?? null));
    $121d74fbc26f823b$var$reindex();
};
const $121d74fbc26f823b$export$ab25aae853be001e = (file)=>{
    $121d74fbc26f823b$var$preview = new $121d74fbc26f823b$var$ModelSet(file ? {
        version: 1,
        models: {},
        designs: [],
        ...file
    } : undefined, $121d74fbc26f823b$var$content);
    $121d74fbc26f823b$var$reindex();
};
const $121d74fbc26f823b$export$d2c6fd47dbbb12e9 = (slot, id)=>id === undefined ? undefined : $121d74fbc26f823b$var$designIndex.get(`${slot}:${id}`);
const $121d74fbc26f823b$export$dbd794431332c1b0 = (slot)=>[
        ...$121d74fbc26f823b$var$designIndex.values()
    ].filter((d)=>!slot || d.slot === slot);
const $121d74fbc26f823b$export$7e1865720e6f5698 = (slot, name)=>$121d74fbc26f823b$var$preview.model(slot, name);
const $121d74fbc26f823b$export$dd69c95da7963367 = (slot)=>[
        ...new Set([
            $121d74fbc26f823b$var$body,
            $121d74fbc26f823b$var$content,
            $121d74fbc26f823b$var$preview
        ].flatMap((set)=>Object.keys(set.file?.models?.[slot] ?? {})))
    ];
const $121d74fbc26f823b$export$2bce6f4245497bfd = (slot, id)=>{
    if (id === undefined) return "";
    const k = `${slot}:${id}`;
    let key = $121d74fbc26f823b$var$designKeys.get(k);
    if (key === undefined) {
        const d = $121d74fbc26f823b$var$designIndex.get(k);
        key = d ? $121d74fbc26f823b$var$fingerprintOf([
            d,
            $121d74fbc26f823b$var$preview.model(d.slot, d.model),
            $121d74fbc26f823b$var$preview.file?.library ?? null
        ]) : "";
        $121d74fbc26f823b$var$designKeys.set(k, key);
    }
    return key;
};
const $121d74fbc26f823b$export$b77192350bd9e470 = (file)=>{
    $121d74fbc26f823b$var$species.file = file ? {
        version: 1,
        library: file.library ?? [],
        models: {
            species: file.models ?? {}
        },
        designs: []
    } : undefined;
    $121d74fbc26f823b$var$species.reset();
    $121d74fbc26f823b$var$speciesPreview.reset();
};
const $121d74fbc26f823b$export$18fb756b6accb28b = (file)=>{
    $121d74fbc26f823b$var$speciesPreview.file = file ? {
        version: 1,
        library: file.library ?? [],
        models: {
            species: file.models ?? {}
        },
        designs: []
    } : undefined;
    $121d74fbc26f823b$var$speciesPreview.reset();
};
const $121d74fbc26f823b$export$550cfc25b8c4a4f7 = (name, params, context)=>$121d74fbc26f823b$var$speciesPreview.run("species", name, params, context);
const $121d74fbc26f823b$export$4942545267cbc1ad = (slot, name, params, context, overBody, bind)=>$121d74fbc26f823b$var$preview.run(slot, name, params, context, overBody, bind);
const $121d74fbc26f823b$export$ebc80c910378e7da = (file, slots = $121d74fbc26f823b$export$d942c7a6b15bf97d)=>{
    const problems = [];
    if (!$121d74fbc26f823b$var$isObject(file)) return [
        "expected an object"
    ];
    if (file.version !== 1) problems.push("version: expected 1");
    const set = new $121d74fbc26f823b$var$ModelSet(file);
    try {
        $121d74fbc26f823b$var$compileLets(file.library, "library");
    } catch (e) {
        problems.push(e.message);
    }
    if (!$121d74fbc26f823b$var$isObject(file.models)) problems.push("models: expected slot -> name -> model");
    else for (const [slot, models] of Object.entries(file.models)){
        if (!slots.includes(slot)) {
            problems.push(`models.${slot}: not a slot (${slots.join(", ")})`);
            continue;
        }
        if (!$121d74fbc26f823b$var$isObject(models)) {
            problems.push(`models.${slot}: expected name -> model`);
            continue;
        }
        for (const [name, model] of Object.entries(models)){
            if (!$121d74fbc26f823b$var$isObject(model) || !Array.isArray(model.parts)) {
                problems.push(`models.${slot}.${name}: a model has parts`);
                continue;
            }
            try {
                $121d74fbc26f823b$var$compileLets(model.let, `models.${slot}.${name}`);
                $121d74fbc26f823b$var$compileParts(model.parts, `models.${slot}.${name}.parts`, set, slot);
                if (model.overBody) $121d74fbc26f823b$export$c630c49e4db917cd(model.overBody.paint, `models.${slot}.${name}.overBody.paint`);
            } catch (e) {
                problems.push(e.message);
            }
        }
    }
    if (!Array.isArray(file.designs)) problems.push("designs: expected a list");
    else {
        const seen = new Set();
        file.designs.forEach((d, i)=>{
            const at = `designs[${i}]`;
            if (!$121d74fbc26f823b$var$isObject(d)) {
                problems.push(`${at}: expected an object`);
                return;
            }
            if (typeof d.id !== "string" || !/^[a-z][a-z0-9_-]{1,47}$/.test(d.id)) problems.push(`${at}.id: 2\u{2013}48 lowercase letters, digits, - or _`);
            if (!$121d74fbc26f823b$export$d942c7a6b15bf97d.includes(d.slot)) problems.push(`${at}.slot: one of ${$121d74fbc26f823b$export$d942c7a6b15bf97d.join(", ")}`);
            else if (!set.model(d.slot, d.model)) problems.push(`${at}.model: ${d.slot} has no model ${d.model}`);
            if (seen.has(`${d.slot}:${d.id}`)) problems.push(`${at}: ${d.slot} ${d.id} is designed twice`);
            seen.add(`${d.slot}:${d.id}`);
            if (d.params !== undefined && !$121d74fbc26f823b$var$isObject(d.params)) problems.push(`${at}.params: expected an object`);
            // A design sets only what its model declares: a misspelt or dropped parameter would otherwise do nothing, silently.
            const model = $121d74fbc26f823b$export$d942c7a6b15bf97d.includes(d.slot) ? set.model(d.slot, d.model) : undefined;
            if (model) {
                const declared = Object.keys(model.params ?? {});
                for (const k of [
                    ...Object.keys($121d74fbc26f823b$var$isObject(d.params) ? d.params : {}),
                    ...Object.keys($121d74fbc26f823b$var$isObject(d.bind) ? d.bind : {})
                ])if (!declared.includes(k)) problems.push(`${at}: ${d.slot}/${d.model} has no parameter ${k} (it has ${declared.join(", ") || "none"})`);
            }
            if (d.bind !== undefined) {
                if (!$121d74fbc26f823b$var$isObject(d.bind)) problems.push(`${at}.bind: name -> expression`);
                else for (const [k, v] of Object.entries(d.bind)){
                    if (typeof v !== "string") {
                        problems.push(`${at}.bind.${k}: an expression`);
                        continue;
                    }
                    try {
                        (0, $d3e6310995e5de40$export$dce8637ca0d755f)(v);
                    } catch (e) {
                        problems.push(`${at}.bind.${k}: ${e.message}`);
                    }
                }
            }
            if (d.colors !== undefined && (!Array.isArray(d.colors) || d.colors.some((c)=>typeof c !== "string"))) problems.push(`${at}.colors: a list of colour names`);
            if (d.icon !== undefined) {
                const vec = (v)=>Array.isArray(v) && v.length === 3 && v.every((n)=>typeof n === "number" && Number.isFinite(n));
                if (!$121d74fbc26f823b$var$isObject(d.icon)) problems.push(`${at}.icon: expected an object`);
                else for (const [k, v] of Object.entries(d.icon)){
                    if ([
                        "grip",
                        "forearm",
                        "edge"
                    ].includes(k)) {
                        if (!vec(v)) problems.push(`${at}.icon.${k}: [x, y, z]`);
                    } else if ([
                        "turn",
                        "tilt"
                    ].includes(k)) {
                        if (typeof v !== "number" || !Number.isFinite(v)) problems.push(`${at}.icon.${k}: degrees`);
                    } else problems.push(`${at}.icon.${k}: unknown (grip, forearm, edge, turn, tilt)`);
                }
            }
            if (d.handling !== undefined) {
                if (d.slot !== "held") problems.push(`${at}.handling: only a held design has handling`);
                else if (!$121d74fbc26f823b$var$isObject(d.handling)) problems.push(`${at}.handling: expected an object`);
                else {
                    const h = d.handling;
                    if (h.frame !== undefined && (!Number.isInteger(h.frame) || h.frame < 64 || h.frame > 192)) problems.push(`${at}.handling.frame: 64\u{2013}192 pixels`);
                    for (const k of [
                        "twoHanded",
                        "polearm"
                    ])if (h[k] !== undefined && typeof h[k] !== "boolean") problems.push(`${at}.handling.${k}: true or false`);
                    if (h.clips !== undefined && typeof h.clips !== "string") problems.push(`${at}.handling.clips: a weapon name`);
                    if (h.rest !== undefined) {
                        if (!$121d74fbc26f823b$var$isObject(h.rest)) problems.push(`${at}.handling.rest: expected an object`);
                        else for (const [k, v] of Object.entries(h.rest)){
                            if (k !== "wrist" && k !== "out") problems.push(`${at}.handling.rest.${k}: not wrist or out`);
                            else if (typeof v !== "number" || !Number.isFinite(v) || v < -180 || v > 180) problems.push(`${at}.handling.rest.${k}: degrees, -180\u{2013}180`);
                        }
                    }
                }
            }
        });
    }
    return problems;
};
const $121d74fbc26f823b$export$c38d4c0d63da762e = "human";
const $121d74fbc26f823b$export$6dc13596c1f9366b = (bodies, hairFile)=>{
    const problems = [];
    const of = (file, messages)=>problems.push(...messages.map((message)=>({
                file: file,
                message: message
            })));
    const shape = (file, value)=>{
        if (!$121d74fbc26f823b$var$isObject(value)) {
            of(file, [
                "expected an object"
            ]);
            return false;
        }
        if (value.version !== 1) of(file, [
            "version: expected 1"
        ]);
        if (!$121d74fbc26f823b$var$isObject(value.models)) {
            of(file, [
                "models: expected name -> model"
            ]);
            return false;
        }
        return true;
    };
    for (const [file, value, slot] of [
        [
            "bodies",
            bodies,
            "body"
        ],
        [
            "hair",
            hairFile,
            "hair"
        ]
    ]){
        if (!shape(file, value)) continue;
        of(file, $121d74fbc26f823b$export$ebc80c910378e7da({
            version: 1,
            library: value.library,
            models: {
                [slot]: value.models
            },
            designs: []
        }, $121d74fbc26f823b$export$7a1cd63e2b2b9229).map((m)=>m.replace(`models.${slot}.`, "models.")));
    }
    if ($121d74fbc26f823b$var$isObject(bodies) && bodies.features !== undefined) {
        if (!$121d74fbc26f823b$var$isObject(bodies.features)) of("bodies", [
            "features: expected name -> model"
        ]);
        else of("bodies", $121d74fbc26f823b$export$ebc80c910378e7da({
            version: 1,
            models: {
                feature: bodies.features
            },
            designs: []
        }, $121d74fbc26f823b$export$7a1cd63e2b2b9229).map((m)=>m.replace("models.feature.", "features.")));
    }
    if ($121d74fbc26f823b$var$isObject(bodies) && $121d74fbc26f823b$var$isObject(bodies.models) && !$121d74fbc26f823b$var$isObject(bodies.models[$121d74fbc26f823b$export$c38d4c0d63da762e])) of("bodies", [
        `models.${$121d74fbc26f823b$export$c38d4c0d63da762e}: the body a look that names none is drawn with`
    ]);
    if (!$121d74fbc26f823b$var$isObject(hairFile) || !$121d74fbc26f823b$var$isObject(hairFile.models)) return problems;
    if (!$121d74fbc26f823b$var$isObject(hairFile.styles)) {
        of("hair", [
            "styles: expected name -> parameters"
        ]);
        return problems;
    }
    if (typeof hairFile.default !== "string" || !$121d74fbc26f823b$var$isObject(hairFile.styles[hairFile.default])) of("hair", [
        "default: one of the styles"
    ]);
    if (!Array.isArray(hairFile.none) || hairFile.none.some((n)=>typeof n !== "string")) of("hair", [
        "none: a list of style names"
    ]);
    for (const [name, style] of Object.entries(hairFile.styles)){
        if (!$121d74fbc26f823b$var$isObject(style)) {
            of("hair", [
                `styles.${name}: expected parameters`
            ]);
            continue;
        }
        const modelName = style.model ?? $121d74fbc26f823b$export$5586d797f390878c;
        const model = typeof modelName === "string" ? hairFile.models[modelName] : undefined;
        if (!$121d74fbc26f823b$var$isObject(model)) {
            of("hair", [
                `styles.${name}.model: hair has no model ${String(modelName)}`
            ]);
            continue;
        }
        const declared = Object.keys($121d74fbc26f823b$var$isObject(model.params) ? model.params : {});
        for (const k of Object.keys(style))if (k !== "model" && k !== "about" && !declared.includes(k)) of("hair", [
            `styles.${name}: ${modelName} has no parameter ${k} (it has ${declared.join(", ") || "none"})`
        ]);
    }
    return problems;
};


/**
 * Whether Ember's content tables load: palettes.json, marks.json, styles.json, humanoids.json, each
 * on its own and against the others (a style's skin set, a humanoid's style and build, a look's
 * skin, hair and eyes, a race's body). Whether the result draws well is the renderer's question;
 * this is whether it can be drawn at all.
 *
 * Pure: imports no catalog (the content compiler validates before there is one), so the vocabulary
 * the engine knows -- mark anchors, clip sets -- is spelled out here and checked against the
 * engine's own by the tests.
 */ /** Where a mark can be pinned: a point of the trunk, or a limb's joint. */ const $88d3b9e55635678e$export$8c76e5e70bb4030b = [
    "head",
    "neck",
    "chest",
    "pelvis"
];
const $88d3b9e55635678e$export$950e8dafe4cecf7e = [
    "shoulder",
    "elbow",
    "hand",
    "knee",
    "ankle"
];
const $88d3b9e55635678e$export$fd6dcad2d1e1ee87 = [
    "screenLeft",
    "screenRight",
    "near",
    "far"
];
const $88d3b9e55635678e$export$efe8cd6ccacffcbb = [
    "light",
    "base",
    "shade",
    "deep",
    "line",
    "outline"
];
const $88d3b9e55635678e$export$a65e72be67cefa3b = [
    "natural"
];
const $88d3b9e55635678e$export$144bcf914944d3fe = [
    "shamble"
];
const $88d3b9e55635678e$export$fd1ad3dac1dc232a = [
    "idle",
    "walk",
    "run",
    "slash",
    "thrust",
    "shoot",
    "cast",
    "hurt",
    "climb",
    "falling"
];
const $88d3b9e55635678e$var$PERFORMANCE_NAME = /^[a-z][a-z0-9_]{1,31}$/;
const $88d3b9e55635678e$export$ca4815871a87548b = (file)=>{
    const problems = [];
    const f = file;
    if (!$88d3b9e55635678e$var$isObject(f)) return [
        "expected an object"
    ];
    if (f.version !== 1) problems.push("version: expected 1");
    if (!$88d3b9e55635678e$var$isObject(f.animations)) return [
        ...problems,
        "animations: expected name -> animation"
    ];
    const nums = (v, n)=>Array.isArray(v) && n.includes(v.length) && v.every($88d3b9e55635678e$var$isNumber);
    for (const [name, a] of Object.entries(f.animations)){
        const at = `animations.${name}`;
        if (!$88d3b9e55635678e$var$PERFORMANCE_NAME.test(name)) problems.push(`${at}: a name of 2-32 lowercase letters, digits or _, starting with a letter`);
        if ($88d3b9e55635678e$export$fd1ad3dac1dc232a.includes(name)) problems.push(`${at}: ${name} is one of the game's actions`);
        // Settles (settle.ts) are named for what they settle from: `settle.walk.5-left`.
        if (name === "settle") problems.push(`${at}: settle is the name the game's settles take`);
        if (!$88d3b9e55635678e$var$isObject(a)) {
            problems.push(`${at}: expected an object`);
            continue;
        }
        if (!Number.isInteger(a.frames) || a.frames < 2 || a.frames > 64) problems.push(`${at}.frames: 2-64`);
        if (!Number.isInteger(a.frameMs) || a.frameMs < 20 || a.frameMs > 1000) problems.push(`${at}.frameMs: 20-1000`);
        if (a.loop !== undefined && typeof a.loop !== "boolean") problems.push(`${at}.loop: true or false`);
        if (!Array.isArray(a.keys) || a.keys.length < 2 || a.keys.length > 64) {
            problems.push(`${at}.keys: 2-64 key poses`);
            continue;
        }
        a.keys.forEach((k, i)=>{
            const where = `${at}.keys[${i}]`;
            if (!$88d3b9e55635678e$var$isObject(k)) {
                problems.push(`${where}: expected a key pose`);
                return;
            }
            const known = [
                "t",
                "rise",
                "shiftX",
                "roll",
                "pitch",
                "ground",
                "lean",
                "twist",
                "hips",
                "head",
                "sideBend",
                "headPitch",
                "armL",
                "armR",
                "feetL",
                "feetR",
                "legL",
                "legR"
            ];
            for (const field of Object.keys(k))if (!known.includes(field)) problems.push(`${where}.${field}: not a key field (${known.join(", ")})`);
            if (!$88d3b9e55635678e$var$isNumber(k.t) || k.t < 0 || k.t > 1) problems.push(`${where}.t: 0-1`);
            if (i === 0 && k.t !== 0) problems.push(`${where}.t: the first key is at 0`);
            if (i === a.keys.length - 1 && k.t !== 1) problems.push(`${where}.t: the last key is at 1`);
            if (i > 0 && $88d3b9e55635678e$var$isNumber(k.t) && $88d3b9e55635678e$var$isNumber(a.keys[i - 1]?.t) && k.t < a.keys[i - 1].t) problems.push(`${where}.t: keys in order of t`);
            for (const field of [
                "rise",
                "shiftX",
                "roll",
                "pitch",
                "ground",
                "lean",
                "twist",
                "hips",
                "head",
                "sideBend",
                "headPitch"
            ])if (k[field] !== undefined && !$88d3b9e55635678e$var$isNumber(k[field])) problems.push(`${where}.${field}: a number`);
            for (const arm of [
                "armL",
                "armR"
            ])if (!nums(k[arm], [
                3,
                4
            ])) problems.push(`${where}.${arm}: [pitch, abduct, flex, wrist?] in degrees`);
            for (const foot of [
                "feetL",
                "feetR"
            ])if (k[foot] !== undefined && !nums(k[foot], [
                2
            ])) problems.push(`${where}.${foot}: [x, z] in pixels`);
            for (const leg of [
                "legL",
                "legR"
            ])if (k[leg] !== undefined && !nums(k[leg], [
                3
            ])) problems.push(`${where}.${leg}: [pitch, abduct, flex] in degrees`);
        });
    }
    return problems;
};
const $88d3b9e55635678e$var$isObject = (v)=>!!v && typeof v === "object" && !Array.isArray(v);
const $88d3b9e55635678e$var$isHex = (c)=>typeof c === "string" && /^#[0-9a-fA-F]{6}$/.test(c);
const $88d3b9e55635678e$var$isNumber = (v)=>typeof v === "number" && Number.isFinite(v);
const $88d3b9e55635678e$var$own = (o, k)=>$88d3b9e55635678e$var$isObject(o) && typeof k === "string" && Object.prototype.hasOwnProperty.call(o, k);
const $88d3b9e55635678e$var$entries = (o)=>$88d3b9e55635678e$var$isObject(o) ? Object.entries(o) : [];
/** A letter table's letters (a table may carry an `about`). */ const $88d3b9e55635678e$var$letters = (o)=>$88d3b9e55635678e$var$entries(o).filter(([k])=>k !== "about");
const $88d3b9e55635678e$export$2aa96452a8ae5e08 = (t)=>{
    const problems = [];
    const fail = (file, message)=>problems.push({
            file: file,
            message: message
        });
    // ---- palettes ---------------------------------------------------------------------------------
    const pal = t.palettes;
    const eyeColors = $88d3b9e55635678e$var$isObject(pal?.eye?.colors) ? pal.eye.colors : {};
    if (!$88d3b9e55635678e$var$isObject(pal)) fail("palettes", "expected an object");
    else {
        if (pal.version !== 1) fail("palettes", "version: expected 1");
        if (!$88d3b9e55635678e$var$isObject(pal.ramps)) fail("palettes", "ramps: expected name -> { tones }");
        for (const [name, group] of $88d3b9e55635678e$var$entries(pal.ramps)){
            if (!$88d3b9e55635678e$var$isObject(group?.tones)) {
                fail("palettes", `ramps.${name}: expected { tones }`);
                continue;
            }
            for (const [tone, r] of $88d3b9e55635678e$var$entries(group.tones))if (!Array.isArray(r) || r.length !== 6 || !r.every($88d3b9e55635678e$var$isHex)) fail("palettes", `ramps.${name}.tones.${tone}: six #rrggbb colours, light to outline`);
        }
        if (!$88d3b9e55635678e$var$own(pal.ramps?.bones?.tones, "white")) fail("palettes", "ramps.bones.tones.white: the bone a skeleton has unless it is named");
        if (!$88d3b9e55635678e$var$isObject(pal.skins)) fail("palettes", "skins: expected name -> ramp group names");
        for (const [name, list] of $88d3b9e55635678e$var$entries(pal.skins)){
            if (!Array.isArray(list) || !list.every((g)=>typeof g === "string")) {
                fail("palettes", `skins.${name}: a list of ramp group names`);
                continue;
            }
            for (const group of list)if (!$88d3b9e55635678e$var$own(pal.ramps, group)) fail("palettes", `skins.${name}: no ramp group ${group}`);
            if (!list.some((group)=>$88d3b9e55635678e$var$own(pal.ramps?.[group]?.tones, "light"))) fail("palettes", `skins.${name}: needs a \`light\` skin (what an unknown skin is drawn as)`);
        }
        for (const key of [
            "eye",
            "dyes",
            "hair"
        ]){
            if (!$88d3b9e55635678e$var$isObject(pal[key]?.colors)) {
                fail("palettes", `${key}.colors: expected name -> #rrggbb`);
                continue;
            }
            for (const [name, c] of $88d3b9e55635678e$var$entries(pal[key].colors))if (!$88d3b9e55635678e$var$isHex(c)) fail("palettes", `${key}.colors.${name}: #rrggbb`);
        }
        if (!$88d3b9e55635678e$var$own(pal.dyes?.colors, "gray")) fail("palettes", "dyes.colors.gray: what an unknown dye is drawn as");
        if (!$88d3b9e55635678e$var$own(pal.hair?.colors, "brown")) fail("palettes", "hair.colors.brown: what an unknown hair colour is drawn as");
    }
    const skinSet = (name)=>{
        if (!$88d3b9e55635678e$var$own(pal?.skins, name) || !Array.isArray(pal.skins[name])) return undefined;
        return new Set(pal.skins[name].flatMap((group)=>Object.keys($88d3b9e55635678e$var$isObject(pal.ramps?.[group]?.tones) ? pal.ramps[group].tones : {})));
    };
    // ---- marks and eyes ---------------------------------------------------------------------------
    const marks = t.marks;
    const colorRef = (ref)=>$88d3b9e55635678e$var$isHex(ref) || typeof ref === "string" && (ref.startsWith("skin.") && $88d3b9e55635678e$export$efe8cd6ccacffcbb.includes(ref.slice(5)) || ref.startsWith("eye.") && $88d3b9e55635678e$var$own(eyeColors, ref.slice(4)));
    const rowsOk = (rows, known, at)=>{
        if (!Array.isArray(rows) || !rows.length || !rows.every((r)=>typeof r === "string" && r.length)) {
            fail("marks", `${at}: a list of pattern rows`);
            return;
        }
        if (rows.some((r)=>r.length !== rows[0].length)) fail("marks", `${at}: every row the same width`);
        for (const ch of new Set(rows.join("")))if (ch !== "." && !known.has(ch)) fail("marks", `${at}: no colour for '${ch}'`);
    };
    if (!$88d3b9e55635678e$var$isObject(marks)) fail("marks", "expected an object");
    else {
        if (marks.version !== 1) fail("marks", "version: expected 1");
        for (const [letter, step] of $88d3b9e55635678e$var$letters(marks.markLetters))if (!$88d3b9e55635678e$export$efe8cd6ccacffcbb.includes(step)) fail("marks", `markLetters.${letter}: a ramp step (${$88d3b9e55635678e$export$efe8cd6ccacffcbb.join(", ")})`);
        const markLetters = new Set($88d3b9e55635678e$var$letters(marks.markLetters).map(([k])=>k));
        if (!$88d3b9e55635678e$var$isObject(marks.markSets)) fail("marks", "markSets: expected name -> mark set");
        for (const [name, set] of $88d3b9e55635678e$var$entries(marks.markSets)){
            const at = `markSets.${name}`;
            if (!$88d3b9e55635678e$var$isObject(set)) {
                fail("marks", `${at}: expected an object`);
                continue;
            }
            if (!Number.isInteger(set.frame) || set.frame < 16) fail("marks", `${at}.frame: the frame the marks were read off, in pixels`);
            if (!$88d3b9e55635678e$var$isNumber(set.swungLimit)) fail("marks", `${at}.swungLimit: degrees`);
            if (!$88d3b9e55635678e$var$isNumber(set.turnedLimit)) fail("marks", `${at}.turnedLimit: a number`);
            for (const [to, from] of $88d3b9e55635678e$var$entries(set.mirrorFacings))if (!$88d3b9e55635678e$var$own(set.facings, from)) fail("marks", `${at}.mirrorFacings.${to}: no facing ${from} to mirror`);
            for (const [from, to] of $88d3b9e55635678e$var$entries(set.mirrorSides))if (!$88d3b9e55635678e$export$fd6dcad2d1e1ee87.includes(from) || !$88d3b9e55635678e$export$fd6dcad2d1e1ee87.includes(to)) fail("marks", `${at}.mirrorSides.${from}: sides (${$88d3b9e55635678e$export$fd6dcad2d1e1ee87.join(", ")})`);
            if (!$88d3b9e55635678e$var$isObject(set.facings)) {
                fail("marks", `${at}.facings: expected facing -> marks`);
                continue;
            }
            for (const [facing, list] of $88d3b9e55635678e$var$entries(set.facings)){
                if (!Array.isArray(list)) {
                    fail("marks", `${at}.facings.${facing}: a list of marks`);
                    continue;
                }
                list.forEach((m, i)=>{
                    const where = `${at}.facings.${facing}[${i}]`;
                    if (!$88d3b9e55635678e$var$isObject(m)) {
                        fail("marks", `${where}: expected a mark`);
                        return;
                    }
                    if (![
                        ...$88d3b9e55635678e$export$8c76e5e70bb4030b,
                        ...$88d3b9e55635678e$export$950e8dafe4cecf7e
                    ].includes(m.on)) fail("marks", `${where}.on: one of ${[
                        ...$88d3b9e55635678e$export$8c76e5e70bb4030b,
                        ...$88d3b9e55635678e$export$950e8dafe4cecf7e
                    ].join(", ")}`);
                    if (m.side !== undefined && !$88d3b9e55635678e$export$fd6dcad2d1e1ee87.includes(m.side)) fail("marks", `${where}.side: one of ${$88d3b9e55635678e$export$fd6dcad2d1e1ee87.join(", ")}`);
                    if ($88d3b9e55635678e$export$950e8dafe4cecf7e.includes(m.on) && m.side === undefined) fail("marks", `${where}.side: a mark on a limb's joint says which limb`);
                    if (!Array.isArray(m.at) || m.at.length !== 2 || !m.at.every(Number.isInteger)) fail("marks", `${where}.at: [x, y] pixels`);
                    rowsOk(m.rows, markLetters, `${where}.rows`);
                });
            }
        }
        for (const [letter, ref] of $88d3b9e55635678e$var$letters(marks.eyeLetters))if (!colorRef(ref)) fail("marks", `eyeLetters.${letter}: skin.<step>, eye.<name> or #rrggbb`);
        for (const k of [
            "frontTurn",
            "profileTurn",
            "faceDepth",
            "cheek"
        ])if (!$88d3b9e55635678e$var$isNumber(marks.eyePlacement?.[k])) fail("marks", `eyePlacement.${k}: a number`);
        if (!$88d3b9e55635678e$var$isObject(marks.eyeStyles)) fail("marks", "eyeStyles: expected name -> eye style");
        if (!$88d3b9e55635678e$var$own(marks.eyeStyles, marks.defaultEyes)) fail("marks", "defaultEyes: one of the eye styles");
        for (const [name, style] of $88d3b9e55635678e$var$entries(marks.eyeStyles)){
            const at = `eyeStyles.${name}`;
            if (!$88d3b9e55635678e$var$isObject(style)) {
                fail("marks", `${at}: expected an object`);
                continue;
            }
            for (const [letter, ref] of $88d3b9e55635678e$var$letters(style.colors))if (!colorRef(ref)) fail("marks", `${at}.colors.${letter}: skin.<step>, eye.<name> or #rrggbb`);
            const known = new Set([
                ...$88d3b9e55635678e$var$letters(marks.eyeLetters),
                ...$88d3b9e55635678e$var$letters(style.colors)
            ].map(([k])=>k));
            if (!Array.isArray(style.front) || style.front.length !== 2) fail("marks", `${at}.front: [screen-left eye, screen-right eye]`);
            else style.front.forEach((rows, i)=>rowsOk(rows, known, `${at}.front[${i}]`));
            rowsOk(style.profile, known, `${at}.profile`);
            if (!$88d3b9e55635678e$var$isNumber(style.center?.x) || !$88d3b9e55635678e$var$isNumber(style.center?.y)) fail("marks", `${at}.center: { x, y } pixels`);
        }
    }
    // ---- styles -----------------------------------------------------------------------------------
    const styles = t.styles;
    if (!$88d3b9e55635678e$var$isObject(styles)) fail("styles", "expected an object");
    else {
        if (styles.version !== 1) fail("styles", "version: expected 1");
        if (!$88d3b9e55635678e$var$own(styles.styles, styles.default)) fail("styles", "default: one of the styles");
        for (const [name, s] of $88d3b9e55635678e$var$entries(styles.styles)){
            const at = `styles.${name}`;
            if (!$88d3b9e55635678e$var$isObject(s)) {
                fail("styles", `${at}: expected an object`);
                continue;
            }
            if (s.raster !== undefined && !$88d3b9e55635678e$var$isObject(s.raster)) fail("styles", `${at}.raster: settings over the engine's`);
            if (!skinSet(s.skins)) fail("styles", `${at}.skins: one of the skin sets (palettes.json skins)`);
            if (s.marks !== undefined && !$88d3b9e55635678e$var$own(marks?.markSets, s.marks)) fail("styles", `${at}.marks: one of the mark sets (marks.json markSets)`);
            if (s.eyes !== undefined && !$88d3b9e55635678e$var$own(marks?.eyeStyles, s.eyes)) fail("styles", `${at}.eyes: one of the eye styles (marks.json eyeStyles)`);
            if (s.clips !== undefined && !$88d3b9e55635678e$export$a65e72be67cefa3b.includes(s.clips)) fail("styles", `${at}.clips: one of ${$88d3b9e55635678e$export$a65e72be67cefa3b.join(", ")}`);
        }
    }
    // ---- humanoids --------------------------------------------------------------------------------
    const hum = t.humanoids;
    if (!$88d3b9e55635678e$var$isObject(hum)) {
        fail("humanoids", "expected an object");
        return problems;
    }
    if (hum.version !== 1) fail("humanoids", "version: expected 1");
    const builds = $88d3b9e55635678e$var$isObject(hum.builds) ? hum.builds : {};
    for (const [name, b] of $88d3b9e55635678e$var$entries(builds)){
        const at = `builds.${name}`;
        if (!$88d3b9e55635678e$var$isObject(b)) {
            fail("humanoids", `${at}: expected an object`);
            continue;
        }
        if (b.extends !== undefined && !$88d3b9e55635678e$var$own(builds, b.extends)) fail("humanoids", `${at}.extends: no build ${b.extends}`);
        if (b.proportions !== undefined && !$88d3b9e55635678e$var$isObject(b.proportions)) fail("humanoids", `${at}.proportions: name -> value`);
        if (b.scale !== undefined && (!$88d3b9e55635678e$var$isNumber(b.scale) || b.scale <= 0)) fail("humanoids", `${at}.scale: a positive number`);
        const seen = [
            name
        ];
        for(let next = b.extends; typeof next === "string" && $88d3b9e55635678e$var$own(builds, next); next = builds[next].extends){
            if (seen.includes(next)) {
                fail("humanoids", `${at}: extends itself (${[
                    ...seen,
                    next
                ].join(" -> ")})`);
                break;
            }
            seen.push(next);
        }
    }
    const names = new Set();
    const hairStyles = $88d3b9e55635678e$var$isObject(t.hair?.styles) ? t.hair.styles : undefined;
    const noHair = Array.isArray(t.hair?.none) ? t.hair.none : [];
    const equipment = $88d3b9e55635678e$var$isObject(t.equipment?.models) ? t.equipment.models : undefined;
    const dyes = $88d3b9e55635678e$var$isObject(pal?.dyes?.colors) ? pal.dyes.colors : {};
    if (!Array.isArray(hum.humanoids)) fail("humanoids", "humanoids: a list");
    else hum.humanoids.forEach((h, i)=>{
        const at = `humanoids[${i}]${typeof h?.name === "string" ? ` (${h.name})` : ""}`;
        if (!$88d3b9e55635678e$var$isObject(h)) {
            fail("humanoids", `${at}: expected an object`);
            return;
        }
        if (typeof h.name !== "string" || !/^[a-z][a-z0-9-]{1,47}$/.test(h.name)) fail("humanoids", `${at}.name: 2-48 lowercase letters, digits or -`);
        else if (names.has(h.name)) fail("humanoids", `${at}.name: named twice`);
        else names.add(h.name);
        const style = h.style ?? styles?.default;
        if (!$88d3b9e55635678e$var$own(styles?.styles, style)) fail("humanoids", `${at}.style: one of the styles (styles.json)`);
        if (h.build !== undefined && !$88d3b9e55635678e$var$own(builds, h.build)) fail("humanoids", `${at}.build: no build ${h.build}`);
        if (h.proportions !== undefined && !$88d3b9e55635678e$var$isObject(h.proportions)) fail("humanoids", `${at}.proportions: name -> value`);
        if (h.posture !== undefined && !$88d3b9e55635678e$export$144bcf914944d3fe.includes(h.posture)) fail("humanoids", `${at}.posture: one of ${$88d3b9e55635678e$export$144bcf914944d3fe.join(", ")}`);
        if (h.frame !== undefined && (!Number.isInteger(h.frame) || h.frame < 64 || h.frame > 192)) fail("humanoids", `${at}.frame: 64-192 pixels`);
        if (h.keepsOwn !== undefined && (!Array.isArray(h.keepsOwn) || h.keepsOwn.some((k)=>k !== "hair" && k !== "skin"))) fail("humanoids", `${at}.keepsOwn: a list of hair, skin`);
        const look = h.look;
        if (!$88d3b9e55635678e$var$isObject(look)) {
            fail("humanoids", `${at}.look: expected an object`);
            return;
        }
        const skins = $88d3b9e55635678e$var$own(styles?.styles, style) ? skinSet(styles.styles[style].skins) : undefined;
        if (skins && !skins.has(look.skin)) fail("humanoids", `${at}.look.skin: no skin ${look.skin} in its style's skin set`);
        if (look.eyes !== undefined && !$88d3b9e55635678e$var$own(marks?.eyeStyles, look.eyes)) fail("humanoids", `${at}.look.eyes: one of the eye styles`);
        if (look.body !== undefined && $88d3b9e55635678e$var$isObject(t.bodies?.models) && !$88d3b9e55635678e$var$own(t.bodies.models, look.body)) fail("humanoids", `${at}.look.body: no body model ${look.body}`);
        if (look.boneColor !== undefined && !$88d3b9e55635678e$var$own(pal?.ramps?.bones?.tones, look.boneColor)) fail("humanoids", `${at}.look.boneColor: one of the bone colours`);
        if (look.features !== undefined) {
            const features = $88d3b9e55635678e$var$isObject(t.bodies?.features) ? t.bodies.features : {};
            if (!Array.isArray(look.features)) fail("humanoids", `${at}.look.features: a list of { model, params? }`);
            else look.features.forEach((f, k)=>{
                const where = `${at}.look.features[${k}]`;
                if (!$88d3b9e55635678e$var$isObject(f) || typeof f.model !== "string") {
                    fail("humanoids", `${where}: { model, params? }`);
                    return;
                }
                if (!$88d3b9e55635678e$var$own(features, f.model)) {
                    fail("humanoids", `${where}.model: no feature ${f.model} (bodies.json features)`);
                    return;
                }
                if (f.params !== undefined && !$88d3b9e55635678e$var$isObject(f.params)) {
                    fail("humanoids", `${where}.params: name -> value`);
                    return;
                }
                const declared = Object.keys($88d3b9e55635678e$var$isObject(features[f.model].params) ? features[f.model].params : {});
                for (const k2 of Object.keys(f.params ?? {}))if (!declared.includes(k2)) fail("humanoids", `${where}: ${f.model} has no parameter ${k2} (it has ${declared.join(", ") || "none"})`);
            });
        }
        if (look.hair !== undefined) {
            if (hairStyles && !$88d3b9e55635678e$var$own(hairStyles, look.hair.style) && !noHair.includes(look.hair.style)) fail("humanoids", `${at}.look.hair.style: no hair style ${look.hair.style}`);
            if (!$88d3b9e55635678e$var$own(pal?.hair?.colors, look.hair.color)) fail("humanoids", `${at}.look.hair.color: one of the hair colours`);
        }
        // Garments: a model of the slot (its own, a cut, or the slot's own), in a dye the game has (metal names a metal).
        const garments = [
            [
                "shirt",
                "shirt",
                "dye"
            ],
            [
                "pants",
                "trousers",
                "dye"
            ],
            [
                "shoes",
                "shoes",
                "dye"
            ],
            [
                "belt",
                "belt",
                "dye"
            ]
        ];
        for (const [slot, fallback, color] of garments){
            const g = look[slot];
            if (g === undefined) continue;
            if (!$88d3b9e55635678e$var$isObject(g)) {
                fail("humanoids", `${at}.look.${slot}: expected an object`);
                continue;
            }
            const model = g.model ?? g.cut ?? fallback;
            if (equipment && !$88d3b9e55635678e$var$own(equipment[slot], model)) fail("humanoids", `${at}.look.${slot}: no ${slot} model ${model} (equipment.json)`);
            if (typeof g[color] !== "string") fail("humanoids", `${at}.look.${slot}.${color}: a colour name`);
            else if (model !== "greaves" && model !== "sabatons" && !$88d3b9e55635678e$var$own(dyes, g[color])) fail("humanoids", `${at}.look.${slot}.${color}: no dye ${g[color]}`);
        }
    });
    if (!Array.isArray(hum.races)) fail("humanoids", "races: a list of { race, sex?, body }");
    else hum.races.forEach((r, i)=>{
        if (!$88d3b9e55635678e$var$isObject(r) || typeof r.race !== "string" || r.sex !== undefined && typeof r.sex !== "string") fail("humanoids", `races[${i}]: { race, sex?, body }`);
        else if (!names.has(r.body)) fail("humanoids", `races[${i}].body: no humanoid ${r.body}`);
    });
    const anySkin = new Set($88d3b9e55635678e$var$entries(pal?.skins).flatMap(([name])=>[
            ...skinSet(name) ?? []
        ]));
    for (const [color, skin] of $88d3b9e55635678e$var$entries(hum.bodyColors?.skins))if (!anySkin.has(skin)) fail("humanoids", `bodyColors.skins.${color}: no skin ${skin}`);
    for (const [beast, table] of $88d3b9e55635678e$var$entries(hum.bodyColors?.furs))for (const [color, skin] of $88d3b9e55635678e$var$entries(table))if (!anySkin.has(skin)) fail("humanoids", `bodyColors.furs.${beast}.${color}: no skin ${skin}`);
    if (!$88d3b9e55635678e$var$isObject(hum.bodyColors?.skins) || !$88d3b9e55635678e$var$isObject(hum.bodyColors?.furs)) fail("humanoids", "bodyColors: { skins, furs }");
    return problems;
};
// ---- species (species.json) -----------------------------------------------------------------------
const $88d3b9e55635678e$var$SPECIES_NAME = /^[a-z][a-z0-9-]{1,47}$/;
const $88d3b9e55635678e$var$JOINT_NAME = /^[a-z][A-Za-z0-9]{0,31}$/;
const $88d3b9e55635678e$var$CLIP_NAME = /^[a-z][a-z0-9_]{1,31}$/;
const $88d3b9e55635678e$var$MOTION_AXES = [
    "pitch",
    "yaw",
    "roll",
    "rise",
    "shift",
    "side"
];
const $88d3b9e55635678e$var$ROOT_AXES = [
    "rise",
    "shift",
    "side"
];
const $88d3b9e55635678e$export$714e142d4f44ebae = (file, context = {})=>{
    const problems = [];
    const f = file;
    if (!$88d3b9e55635678e$var$isObject(f)) return [
        "expected an object"
    ];
    if (f.version !== 1) problems.push("version: expected 1");
    if (f.library !== undefined && !Array.isArray(f.library)) problems.push("library: a list of [name, value]");
    if (!$88d3b9e55635678e$var$isObject(f.models)) problems.push("models: expected name -> model");
    if (!$88d3b9e55635678e$var$isObject(f.species)) return [
        ...problems,
        "species: expected name -> species"
    ];
    const models = $88d3b9e55635678e$var$isObject(f.models) ? f.models : {};
    const bodies = new Set();
    const range = (v, lo, hi)=>$88d3b9e55635678e$var$isNumber(v) && v >= lo && v <= hi;
    const int = (v, lo, hi)=>Number.isInteger(v) && v >= lo && v <= hi;
    const nums = (v, n)=>Array.isArray(v) && n.includes(v.length) && v.every($88d3b9e55635678e$var$isNumber);
    for (const [name, s] of $88d3b9e55635678e$var$entries(f.species)){
        const at = `species.${name}`;
        if (!$88d3b9e55635678e$var$SPECIES_NAME.test(name)) problems.push(`${at}: a name of 2-48 lowercase letters, digits or -`);
        if (!$88d3b9e55635678e$var$isObject(s)) {
            problems.push(`${at}: expected an object`);
            continue;
        }
        if (s.style !== undefined && (typeof s.style !== "string" || context.styles && !context.styles.includes(s.style))) problems.push(`${at}.style: one of the styles${context.styles ? ` (${context.styles.join(", ")})` : ""}`);
        if (s.raster !== undefined && !$88d3b9e55635678e$var$isObject(s.raster)) problems.push(`${at}.raster: settings over its style's`);
        if ($88d3b9e55635678e$var$isObject(s.raster) && s.raster.pitch !== undefined && !range(s.raster.pitch, 0, 60)) problems.push(`${at}.raster.pitch: 0-60 degrees`);
        if (!int(s.frame, 64, 192)) problems.push(`${at}.frame: 64-192 pixels`);
        if (s.sideTurn !== undefined && !range(s.sideTurn, 0, 45)) problems.push(`${at}.sideTurn: 0-45 degrees`);
        if (s.proportions !== undefined && !$88d3b9e55635678e$var$isObject(s.proportions)) problems.push(`${at}.proportions: name -> value`);
        // The rig: one root first, every joint after its parent.
        const parentOf = new Map();
        if (!Array.isArray(s.joints) || s.joints.length < 1 || s.joints.length > 96) problems.push(`${at}.joints: 1-96 of [name, parent, [x, y, z]]`);
        else s.joints.forEach((j, i)=>{
            const where = `${at}.joints[${i}]`;
            if (!Array.isArray(j) || j.length !== 3) {
                problems.push(`${where}: [name, parent, [x, y, z]]`);
                return;
            }
            const [joint, parent, rest] = j;
            if (typeof joint !== "string" || !$88d3b9e55635678e$var$JOINT_NAME.test(joint)) {
                problems.push(`${where}: a joint name: a letter, then letters and digits (1-32)`);
                return;
            }
            if (parentOf.has(joint)) problems.push(`${where}: ${joint} is named twice`);
            if (i === 0 && parent !== null) problems.push(`${where}: the first joint is the root (parent null)`);
            if (i > 0 && parent === null) problems.push(`${where}: only the first joint is the root`);
            if (i > 0 && parent !== null && !parentOf.has(parent)) problems.push(`${where}: its parent ${String(parent)} is not a joint before it`);
            if (!nums(rest, [
                3
            ])) problems.push(`${where}: its rest position [x, y, z] in pixels`);
            parentOf.set(joint, parent);
        });
        const joints = new Set(parentOf.keys());
        // Legs: chains of joints, none shared.
        const legs = new Set();
        const used = new Set();
        if (!$88d3b9e55635678e$var$isObject(s.legs)) problems.push(`${at}.legs: expected name -> { joints }`);
        else for (const [leg, l] of $88d3b9e55635678e$var$entries(s.legs)){
            const where = `${at}.legs.${leg}`;
            if (!$88d3b9e55635678e$var$JOINT_NAME.test(leg)) problems.push(`${where}: a leg name: a letter, then letters and digits`);
            legs.add(leg);
            if (!$88d3b9e55635678e$var$isObject(l) || !Array.isArray(l.joints) || l.joints.length < 3 || l.joints.length > 4) {
                problems.push(`${where}.joints: root, knee, ankle and optionally the foot's tip`);
                continue;
            }
            l.joints.forEach((j, k)=>{
                if (typeof j !== "string" || !joints.has(j)) {
                    problems.push(`${where}.joints[${k}]: no joint ${String(j)}`);
                    return;
                }
                if (used.has(j)) problems.push(`${where}.joints[${k}]: ${j} is in another leg`);
                used.add(j);
                if (k > 0 && parentOf.get(j) !== l.joints[k - 1]) problems.push(`${where}.joints[${k}]: ${j} does not hang from ${String(l.joints[k - 1])}`);
            });
            if (l.fold !== undefined && l.fold !== 1 && l.fold !== -1) problems.push(`${where}.fold: 1 or -1`);
        }
        // Gaits and clips.
        const clips = new Set();
        const timing = (c, where)=>{
            if (!int(c.frames, 2, 64)) problems.push(`${where}.frames: 2-64`);
            if (!int(c.frameMs, 20, 1000)) problems.push(`${where}.frameMs: 20-1000`);
        };
        if (!$88d3b9e55635678e$var$isObject(s.gaits)) problems.push(`${at}.gaits: expected name -> gait`);
        else for (const [gait, g] of $88d3b9e55635678e$var$entries(s.gaits)){
            const where = `${at}.gaits.${gait}`;
            if (!$88d3b9e55635678e$var$CLIP_NAME.test(gait)) problems.push(`${where}: a name of 2-32 lowercase letters, digits or _`);
            clips.add(gait);
            if (!$88d3b9e55635678e$var$isObject(g)) {
                problems.push(`${where}: expected an object`);
                continue;
            }
            timing(g, where);
            if (!range(g.stride, 0.1, 400)) problems.push(`${where}.stride: the ground a cycle covers, 0.1-400 pixels`);
            if (!$88d3b9e55635678e$var$isNumber(g.duty) || g.duty <= 0 || g.duty >= 1) problems.push(`${where}.duty: the share of the cycle a foot is down, over 0 and under 1`);
            if (!$88d3b9e55635678e$var$isObject(g.phases)) problems.push(`${where}.phases: leg -> when its foot lands, 0..1`);
            else for (const [leg, ph] of $88d3b9e55635678e$var$entries(g.phases)){
                if (!legs.has(leg)) problems.push(`${where}.phases.${leg}: no leg ${leg}`);
                if (!$88d3b9e55635678e$var$isNumber(ph) || ph < 0 || ph >= 1) problems.push(`${where}.phases.${leg}: 0 up to 1`);
            }
            // One for every leg, or by leg.
            const perLeg = (v, lo, hi, what, key)=>{
                if ($88d3b9e55635678e$var$isObject(v)) for (const [leg, n] of $88d3b9e55635678e$var$entries(v)){
                    if (!legs.has(leg)) problems.push(`${where}.${key}.${leg}: no leg ${leg}`);
                    if (!range(n, lo, hi)) problems.push(`${where}.${key}.${leg}: ${what}`);
                }
                else if (!range(v, lo, hi)) problems.push(`${where}.${key}: ${what}, or by leg`);
            };
            perLeg(g.lift, 0, 100, "0-100 pixels", "lift");
            if (g.fold !== undefined) perLeg(g.fold, -180, 180, "-180 to 180 degrees", "fold");
            for (const k of [
                "reach",
                "rise"
            ])if (g[k] !== undefined && !$88d3b9e55635678e$var$isNumber(g[k])) problems.push(`${where}.${k}: a number`);
            if (g.motion !== undefined && !Array.isArray(g.motion)) problems.push(`${where}.motion: a list of swings`);
            else (g.motion ?? []).forEach((m, i)=>{
                const w = `${where}.motion[${i}]`;
                if (!$88d3b9e55635678e$var$isObject(m)) {
                    problems.push(`${w}: { joint, axis, amplitude, perCycle?, phase?, offset? }`);
                    return;
                }
                if (m.joint !== "root" && !joints.has(m.joint)) problems.push(`${w}.joint: root or one of its joints`);
                if (!$88d3b9e55635678e$var$MOTION_AXES.includes(m.axis)) problems.push(`${w}.axis: one of ${$88d3b9e55635678e$var$MOTION_AXES.join(", ")}`);
                else if ($88d3b9e55635678e$var$ROOT_AXES.includes(m.axis) && m.joint !== "root") problems.push(`${w}.axis: ${m.axis} moves the root only`);
                if (!$88d3b9e55635678e$var$isNumber(m.amplitude)) problems.push(`${w}.amplitude: a number`);
                if (m.perCycle !== undefined && !int(m.perCycle, 1, 16)) problems.push(`${w}.perCycle: 1-16 whole swings a cycle`);
                for (const k of [
                    "phase",
                    "offset"
                ])if (m[k] !== undefined && !$88d3b9e55635678e$var$isNumber(m[k])) problems.push(`${w}.${k}: a number`);
            });
        }
        if (!$88d3b9e55635678e$var$isObject(s.clips)) problems.push(`${at}.clips: expected name -> clip`);
        else for (const [clip, c] of $88d3b9e55635678e$var$entries(s.clips)){
            const where = `${at}.clips.${clip}`;
            if (!$88d3b9e55635678e$var$CLIP_NAME.test(clip)) problems.push(`${where}: a name of 2-32 lowercase letters, digits or _`);
            if (clips.has(clip)) problems.push(`${where}: a gait has this name`);
            clips.add(clip);
            if (!$88d3b9e55635678e$var$isObject(c)) {
                problems.push(`${where}: expected an object`);
                continue;
            }
            timing(c, where);
            if (c.loop !== undefined && typeof c.loop !== "boolean") problems.push(`${where}.loop: true or false`);
            if (!Array.isArray(c.keys) || c.keys.length < 2 || c.keys.length > 64) {
                problems.push(`${where}.keys: 2-64 key poses`);
                continue;
            }
            c.keys.forEach((k, i)=>{
                const w = `${where}.keys[${i}]`;
                if (!$88d3b9e55635678e$var$isObject(k)) {
                    problems.push(`${w}: expected a key pose`);
                    return;
                }
                const known = [
                    "t",
                    "rise",
                    "shift",
                    "side",
                    "pitch",
                    "yaw",
                    "roll",
                    "turns",
                    "feet"
                ];
                for (const field of Object.keys(k))if (!known.includes(field)) problems.push(`${w}.${field}: not a key field (${known.join(", ")})`);
                if (!$88d3b9e55635678e$var$isNumber(k.t) || k.t < 0 || k.t > 1) problems.push(`${w}.t: 0-1`);
                if (i === 0 && k.t !== 0) problems.push(`${w}.t: the first key is at 0`);
                if (i === c.keys.length - 1 && k.t !== 1) problems.push(`${w}.t: the last key is at 1`);
                if (i > 0 && $88d3b9e55635678e$var$isNumber(k.t) && $88d3b9e55635678e$var$isNumber(c.keys[i - 1]?.t) && k.t < c.keys[i - 1].t) problems.push(`${w}.t: keys in order of t`);
                for (const field of [
                    "rise",
                    "shift",
                    "side",
                    "pitch",
                    "yaw",
                    "roll"
                ])if (k[field] !== undefined && !$88d3b9e55635678e$var$isNumber(k[field])) problems.push(`${w}.${field}: a number`);
                if (k.turns !== undefined && !$88d3b9e55635678e$var$isObject(k.turns)) problems.push(`${w}.turns: joint -> [pitch, yaw, roll]`);
                for (const [joint, turn] of $88d3b9e55635678e$var$entries(k.turns)){
                    if (!joints.has(joint)) problems.push(`${w}.turns.${joint}: no joint ${joint}`);
                    if (!nums(turn, [
                        3
                    ])) problems.push(`${w}.turns.${joint}: [pitch, yaw, roll] in degrees`);
                }
                if (k.feet !== undefined && !$88d3b9e55635678e$var$isObject(k.feet)) problems.push(`${w}.feet: leg -> [x, y, z, fold?] or "free"`);
                for (const [leg, foot] of $88d3b9e55635678e$var$entries(k.feet)){
                    if (!legs.has(leg)) problems.push(`${w}.feet.${leg}: no leg ${leg}`);
                    if (foot !== "free" && !nums(foot, [
                        3,
                        4
                    ])) problems.push(`${w}.feet.${leg}: [x, y, z] from where it stands (and its fold in degrees), or "free"`);
                }
            });
        }
        // Actions, points, bodies.
        if (!$88d3b9e55635678e$var$isObject(s.actions)) problems.push(`${at}.actions: action -> gait or clip`);
        else {
            for (const [action, clip] of $88d3b9e55635678e$var$entries(s.actions)){
                if (!$88d3b9e55635678e$export$fd1ad3dac1dc232a.includes(action)) problems.push(`${at}.actions.${action}: not one of the game's actions (${$88d3b9e55635678e$export$fd1ad3dac1dc232a.join(", ")})`);
                if (typeof clip !== "string" || !clips.has(clip)) problems.push(`${at}.actions.${action}: no gait or clip ${String(clip)}`);
            }
            if (!$88d3b9e55635678e$var$own(s.actions, "idle")) problems.push(`${at}.actions.idle: what it does standing`);
        }
        if (s.points !== undefined) {
            if (!$88d3b9e55635678e$var$isObject(s.points)) problems.push(`${at}.points: { head?, hands? }`);
            else {
                if (s.points.head !== undefined && !joints.has(s.points.head)) problems.push(`${at}.points.head: no joint ${String(s.points.head)}`);
                if (s.points.hands !== undefined && (!Array.isArray(s.points.hands) || s.points.hands.length !== 2 || s.points.hands.some((h)=>typeof h !== "string" || !joints.has(h)))) problems.push(`${at}.points.hands: two of its joints`);
            }
        }
        if (s.grips !== undefined) {
            if (!$88d3b9e55635678e$var$isObject(s.grips)) problems.push(`${at}.grips: { R?, L?, torso?, size? }`);
            else {
                for (const k of Object.keys(s.grips))if (![
                    "R",
                    "L",
                    "torso",
                    "size"
                ].includes(k)) problems.push(`${at}.grips.${k}: not a grips field (R, L, torso, size)`);
                if (s.grips.R === undefined && s.grips.L === undefined) problems.push(`${at}.grips: an R grip (the weapon hand), an L grip, or both`);
                for (const side of [
                    "R",
                    "L"
                ]){
                    const g = s.grips[side];
                    if (g === undefined) continue;
                    const where = `${at}.grips.${side}`;
                    if (!$88d3b9e55635678e$var$isObject(g)) {
                        problems.push(`${where}: { hand, elbow?, shoulder?, grip, edge? }`);
                        continue;
                    }
                    for (const joint of [
                        "hand",
                        "elbow",
                        "shoulder"
                    ])if ((joint === "hand" || g[joint] !== undefined) && !joints.has(g[joint])) problems.push(`${where}.${joint}: no joint ${String(g[joint])}`);
                    if (!nums(g.grip, [
                        3
                    ]) || g.grip.every((v)=>v === 0)) problems.push(`${where}.grip: [x, y, z], which way a held tool points from the hand at rest`);
                    if (g.edge !== undefined && (!nums(g.edge, [
                        3
                    ]) || g.edge.every((v)=>v === 0))) problems.push(`${where}.edge: [x, y, z], which way a blade's edge faces at rest`);
                }
                if (s.grips.torso !== undefined && !joints.has(s.grips.torso)) problems.push(`${at}.grips.torso: no joint ${String(s.grips.torso)}`);
                if (s.grips.size !== undefined && !range(s.grips.size, 0.2, 4)) problems.push(`${at}.grips.size: 0.2-4 (a person's weapon is 1)`);
            }
        }
        if (!$88d3b9e55635678e$var$isObject(s.bodies) || !Object.keys(s.bodies).length) problems.push(`${at}.bodies: at least one, name -> { model, params?, scale? }`);
        else for (const [body, b] of $88d3b9e55635678e$var$entries(s.bodies)){
            const where = `${at}.bodies.${body}`;
            if (!$88d3b9e55635678e$var$SPECIES_NAME.test(body)) problems.push(`${where}: a name of 2-48 lowercase letters, digits or -`);
            if (bodies.has(body)) problems.push(`${where}: another species has a body called ${body}`);
            if (context.humanoids?.includes(body)) problems.push(`${where}: a humanoid is called ${body}`);
            bodies.add(body);
            if (!$88d3b9e55635678e$var$isObject(b)) {
                problems.push(`${where}: { model, params?, scale? }`);
                continue;
            }
            if (!$88d3b9e55635678e$var$own(models, b.model)) {
                problems.push(`${where}.model: no model ${String(b.model)}`);
                continue;
            }
            if (b.params !== undefined && !$88d3b9e55635678e$var$isObject(b.params)) problems.push(`${where}.params: name -> value`);
            const declared = Object.keys($88d3b9e55635678e$var$isObject(models[b.model].params) ? models[b.model].params : {});
            for (const k of Object.keys($88d3b9e55635678e$var$isObject(b.params) ? b.params : {}))if (!declared.includes(k)) problems.push(`${where}: ${b.model} has no parameter ${k} (it has ${declared.join(", ") || "none"})`);
            if (b.scale !== undefined && !range(b.scale, 0.25, 4)) problems.push(`${where}.scale: 0.25-4`);
        }
    }
    if (f.races !== undefined) {
        if (!Array.isArray(f.races)) problems.push("races: a list of { race, sex?, body }");
        else f.races.forEach((r, i)=>{
            if (!$88d3b9e55635678e$var$isObject(r) || typeof r.race !== "string" || r.sex !== undefined && r.sex !== "male" && r.sex !== "female") problems.push(`races[${i}]: { race, sex?, body }`);
            else if (!bodies.has(r.body)) problems.push(`races[${i}].body: no species body ${String(r.body)}`);
            else if (context.races && !context.races.includes(r.race)) problems.push(`races[${i}].race: no race ${r.race}`);
            else if (context.humanoidRaces?.includes(r.race)) problems.push(`races[${i}].race: a humanoid draws ${r.race} (humanoids.json races)`);
        });
    }
    return problems;
};


const $c3a2a0c750683e7a$export$fe84807a46f1035b = (value)=>typeof value === "string" && value.length > 0 && !value.startsWith("/") && !value.includes("\\") && !value.includes("\0") && !/^[A-Za-z]:/.test(value) && value.split("/").every((part)=>part !== "" && part !== "." && part !== "..");
const $c3a2a0c750683e7a$var$safeId = (v)=>typeof v === "string" && /^[A-Za-z0-9][A-Za-z0-9_.-]*$/.test(v) && ![
        "__proto__",
        "prototype",
        "constructor"
    ].includes(v);
const $c3a2a0c750683e7a$var$object = (v)=>!!v && typeof v === "object" && !Array.isArray(v);
const $c3a2a0c750683e7a$var$finite = (v)=>typeof v === "number" && Number.isFinite(v);
const $c3a2a0c750683e7a$export$1fbd44e8a75e17b6 = (input)=>{
    const findings = [];
    const fail = (path, message)=>findings.push({
            path: path,
            message: message
        });
    const preSpawnEffect = (value, p)=>{
        if (value === undefined || value === null) return;
        if (!$c3a2a0c750683e7a$var$object(value) || value.type !== "ground-rupture" || Object.keys(value).some((k)=>![
                "type",
                "durationMs"
            ].includes(k)) || value.durationMs !== undefined && (!$c3a2a0c750683e7a$var$finite(value.durationMs) || value.durationMs <= 0)) fail(p, "Invalid pre-spawn effect: expected ground-rupture and a positive durationMs");
    };
    if (!$c3a2a0c750683e7a$var$object(input)) return [
        {
            path: "catalog",
            message: "Expected an object"
        }
    ];
    const inspect = (value, at, depth)=>{
        if (depth > 80) {
            fail(at, "Content nesting is too deep");
            return;
        }
        if (!value || typeof value !== "object") return;
        for (const key of Object.keys(value))if ([
            "__proto__",
            "prototype",
            "constructor"
        ].includes(key)) fail(`${at}.${key}`, "Reserved object key");
        else inspect(value[key], `${at}.${key}`, depth + 1);
    };
    inspect(input, "catalog", 0);
    if (findings.length) return findings;
    const source = input;
    for (const key of [
        "classes",
        "items",
        "recipes",
        "preload"
    ])if (!Array.isArray(source[key])) fail(key, "Expected an array");
    for (const key of [
        "vocabularies",
        "ids",
        "presentation",
        "tiles",
        "registry",
        "sprites",
        "profiles",
        "maps",
        "autotiles",
        "ember",
        "emberAnimations",
        "emberBodies",
        "emberHair",
        "emberHumanoids",
        "emberMarks",
        "emberPalettes",
        "emberSpecies",
        "emberStyles"
    ])if (!$c3a2a0c750683e7a$var$object(source[key])) fail(key, "Expected an object");
    if (findings.length) return findings;
    if (!Array.isArray(source.vocabularies.colors) || !source.vocabularies.colors.every($c3a2a0c750683e7a$var$safeId) || new Set(source.vocabularies.colors).size !== source.vocabularies.colors.length) fail("vocabularies.colors", "Expected unique colour IDs");
    const colors = new Set(Array.isArray(source.vocabularies.colors) ? source.vocabularies.colors : []);
    const ids = (rows, path)=>{
        const seen = new Set();
        rows.forEach((row, i)=>{
            if (!$c3a2a0c750683e7a$var$object(row) || !$c3a2a0c750683e7a$var$safeId(row.id)) fail(`${path}[${i}]`, "Invalid ID");
            else if (seen.has(row.id)) fail(`${path}[${i}]`, `Duplicate ID ${row.id}`);
            else seen.add(row.id);
        });
        return seen;
    };
    const classes = ids(source.classes, "classes"), items = ids(source.items, "items");
    const handlers = (0, $8d9457f98f5de202$export$8d83692a55402888).characteristics;
    const characteristics = (value, p)=>{
        if (value === undefined) return;
        if (!$c3a2a0c750683e7a$var$object(value)) {
            fail(p, "Expected characteristics");
            return;
        }
        for (const [key, v] of Object.entries(value)){
            if (handlers.boolean.includes(key)) {
                if (typeof v !== "boolean") fail(`${p}.${key}`, "Expected a flag");
            } else if (key === "buildType") {
                if (!handlers.buildType.includes(v)) fail(`${p}.${key}`, "Unknown build handler");
            } else if (key === "placementAction") {
                if (!handlers.placementAction.includes(v)) fail(`${p}.${key}`, "Unknown placement handler");
            } else if (key === "placementRange") {
                if (!$c3a2a0c750683e7a$var$finite(v) || v <= 0) fail(`${p}.${key}`, "Expected a positive range");
            } else if (key === "ornament") {
                if (typeof v !== "string" || !/^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/.test(v)) fail(`${p}.${key}`, "Expected a wall ornament name");
            } else if (key === "disallowedClassesOnActive") {
                if (!Array.isArray(v) || v.some((c)=>!classes.has(c))) fail(`${p}.${key}`, "Expected item classes");
            } else fail(`${p}.${key}`, "Unknown item characteristic");
        }
    };
    const reference = (ref, p)=>{
        if (!$c3a2a0c750683e7a$var$object(ref) || !items.has(ref.item)) fail(p, `Unknown item ${ref?.item}`);
        if (ref?.color !== undefined && !colors.has(ref.color)) fail(p, `Unknown colour ${ref.color}`);
    };
    const positive = (n, p)=>{
        if (!$c3a2a0c750683e7a$var$finite(n) || n <= 0) fail(p, "Expected a positive finite number");
    };
    source.items.forEach((item, i)=>{
        const p = `items[${i}]`;
        if (!$c3a2a0c750683e7a$var$object(item)) return;
        if (!classes.has(item.class)) fail(p, `Unknown class ${item.class}`);
        if (!$c3a2a0c750683e7a$var$safeId(item.subClass)) fail(p, "Invalid subclass");
        for (const k of [
            "weight",
            "protection"
        ])if (item[k] != null && (!$c3a2a0c750683e7a$var$finite(item[k]) || item[k] < 0)) fail(`${p}.${k}`, "Expected a non-negative number");
        if (item.metadata !== undefined) {
            if (!Array.isArray(item.metadata) || !item.metadata.length) fail(`${p}.metadata`, "Expected metadata entries");
            else item.metadata.forEach((meta, j)=>{
                if (!$c3a2a0c750683e7a$var$object(meta) || meta.type !== item.id || meta.class !== item.class || !colors.has(meta.color)) fail(`${p}.metadata[${j}]`, "Metadata must match the item, class and colour vocabulary");
            });
        }
        if (item.trade) {
            reference({
                item: item.trade.itemType
            }, `${p}.trade`);
            positive(item.trade.quantity, `${p}.trade.quantity`);
        }
        characteristics(item.characteristics, `${p}.characteristics`);
    });
    source.classes.forEach((c, i)=>{
        if ($c3a2a0c750683e7a$var$object(c)) characteristics(c.characteristics, `classes[${i}].characteristics`);
    });
    source.recipes.forEach((recipe, i)=>{
        const p = `recipes[${i}]`;
        if (!$c3a2a0c750683e7a$var$object(recipe)) {
            fail(p, "Expected a recipe");
            return;
        }
        reference(recipe.output, `${p}.output`);
        positive(recipe.quantity, `${p}.quantity`);
        if (!Array.isArray(recipe.ingredients) || !recipe.ingredients.length) fail(p, "Expected ingredients");
        else recipe.ingredients.forEach((ingredient, j)=>{
            reference(ingredient?.reference, `${p}.ingredients[${j}]`);
            positive(ingredient?.quantity, `${p}.ingredients[${j}].quantity`);
        });
    });
    const slots = {
        body: "RaceTypes",
        eyes: "EyeTypes",
        nose: "NoseTypes",
        weapon: "WeaponTypes",
        hair: "HairTypes",
        pants: "PantsTypes",
        shirt: "ShirtTypes",
        armor: "ArmorTypes",
        shoes: "ShoeTypes",
        shield: "ShieldTypes",
        cape: "CapeTypes",
        bauldron: undefined
    };
    if (source.sprites.version !== 1 || !$c3a2a0c750683e7a$var$object(source.sprites.registration) || !$c3a2a0c750683e7a$var$object(source.sprites.dimensions) || !$c3a2a0c750683e7a$var$object(source.sprites.creatures) || !$c3a2a0c750683e7a$var$object(source.sprites.weapons)) fail("sprites", "Invalid sprite definitions");
    else {
        const registration = source.sprites.registration;
        const fields = [
            "HumanoidRaceTypes",
            "RaceTypes",
            "RaceSexes",
            "EyeTypes",
            "NoseTypes",
            "RaceNoses",
            "RaceEyes",
            "WeaponTypes",
            "WeaponAction",
            "WeaponAmmo",
            "RaceWeapons",
            "DefaultAttackActionType",
            "HairTypes",
            "SexHair",
            "PantsTypes",
            "SexPants",
            "ShirtTypes",
            "SexShirts",
            "ArmorTypes",
            "ShoeTypes",
            "SexShoes",
            "ShieldTypes",
            "CapeTypes",
            "SexCapes"
        ];
        for (const key of Object.keys(registration))if (!fields.includes(key)) fail(`sprites.registration.${key}`, "Unknown registration field");
        for (const key of fields)if (!(key in registration)) fail(`sprites.registration.${key}`, "Missing registration field");
        for (const [key, values] of Object.entries(registration))if (key.endsWith("Types") && (!Array.isArray(values) || !values.every($c3a2a0c750683e7a$var$safeId) || new Set(values).size !== values.length)) fail(`sprites.registration.${key}`, "Expected unique IDs");
        if (findings.some((f)=>f.path.startsWith("sprites.registration"))) return findings;
        const emberHeld = new Set((source.ember?.designs || []).filter((d)=>d?.slot === "held").map((d)=>d.id));
        for (const [slot, table] of Object.entries(slots))if (table) {
            if (!Array.isArray(registration[table])) fail(`sprites.registration.${table}`, "Missing registration");
            else for (const id of registration[table])if (id !== "none" && !source.registry[slot]?.[id] && !(slot === "weapon" && emberHeld.has(id))) fail(`sprites.registration.${table}`, `Missing component ${slot}/${id}`);
        }
        if (findings.some((f)=>f.path.startsWith("sprites.registration"))) return findings;
        const races = registration.RaceTypes || [], weapons = registration.WeaponTypes || [];
        // Every humanoid race is a race. New ones are appended wherever they come, so a race added live
        // (Sprite Lab's humanoid creatures) never moves the races a running game already has.
        if (!(registration.HumanoidRaceTypes || []).every((race)=>races.includes(race))) fail("sprites.registration.HumanoidRaceTypes", "Every humanoid race must be in RaceTypes");
        for (const race of races)if (!Array.isArray(registration.RaceSexes?.[race]) || !registration.RaceSexes[race].length || registration.RaceSexes[race].some((s)=>![
                "male",
                "female"
            ].includes(s))) fail(`sprites.registration.RaceSexes.${race}`, "Invalid sexes");
        for (const [key, values] of Object.entries(registration)){
            const targets = {
                RaceWeapons: weapons,
                RaceEyes: registration.EyeTypes,
                RaceNoses: registration.NoseTypes,
                SexHair: registration.HairTypes,
                SexPants: registration.PantsTypes,
                SexShirts: registration.ShirtTypes,
                SexShoes: registration.ShoeTypes,
                SexCapes: registration.CapeTypes
            }[key];
            if (targets && $c3a2a0c750683e7a$var$object(values)) {
                for (const [id, list] of Object.entries(values))if (!Array.isArray(list) || list.some((v)=>v !== "none" && !targets.includes(v))) fail(`sprites.registration.${key}.${id}`, "Unknown eligible component");
            }
        }
        const attacks = (0, $8d9457f98f5de202$export$8d83692a55402888).attackActions;
        for (const [id, action] of Object.entries(registration.DefaultAttackActionType || {}))if (!races.includes(id) || !attacks.includes(action)) fail(`sprites.registration.DefaultAttackActionType.${id}`, "Unknown race or attack action");
        for (const [id, action] of Object.entries(registration.WeaponAction || {}))if (!weapons.includes(id) || !attacks.includes(action)) fail(`sprites.registration.WeaponAction.${id}`, "Unknown weapon or attack action");
        for (const [id, ammo] of Object.entries(registration.WeaponAmmo || {}))if (!weapons.includes(id) || !items.has(ammo)) fail(`sprites.registration.WeaponAmmo.${id}`, "Unknown weapon or ammo item");
        for (const [id, size] of Object.entries(source.sprites.dimensions))if (!$c3a2a0c750683e7a$var$object(size) || ![
            size.w,
            size.h
        ].every((n)=>Number.isInteger(n) && n > 0 && n <= 1024)) fail(`sprites.dimensions.${id}`, "Invalid frame dimensions");
        for (const [id, profile] of Object.entries(source.sprites.creatures)){
            const p = `sprites.creatures.${id}`;
            if (!races.includes(id) || !$c3a2a0c750683e7a$var$object(profile) || !races.includes(profile.template)) {
                fail(p, "Unknown creature or template");
                continue;
            }
            for (const key of Object.keys(profile))if (![
                "template",
                "hp",
                "speed",
                "hostility",
                "faction",
                "scanDistanceTiles",
                "drops",
                "preSpawnEffect"
            ].includes(key)) fail(`${p}.${key}`, "Unknown creature profile field");
            preSpawnEffect(profile.preSpawnEffect, `${p}.preSpawnEffect`);
            for (const k of [
                "hp",
                "speed",
                "hostility",
                "scanDistanceTiles"
            ])if (profile[k] !== undefined && (!$c3a2a0c750683e7a$var$finite(profile[k]) || profile[k] < 0)) fail(`${p}.${k}`, "Expected a non-negative finite number");
            if (profile.drops !== undefined) {
                if (!Array.isArray(profile.drops)) fail(`${p}.drops`, "Expected drops");
                else profile.drops.forEach((drop, i)=>{
                    reference(drop, `${p}.drops[${i}]`);
                    positive(drop?.quantity, `${p}.drops[${i}].quantity`);
                    if (!$c3a2a0c750683e7a$var$finite(drop?.probability) || drop.probability < 0 || drop.probability > 1) fail(`${p}.drops[${i}]`, "Invalid drop probability");
                });
            }
        }
        try {
            (0, $59a4975031bf42fe$export$d682c65f11e12f14)(source.sprites.creatures, races);
        } catch (e) {
            fail("sprites.creatures", e.message);
        }
        const profiles = {};
        for (const [id, template] of Object.entries(source.sprites.weapons)){
            if (!weapons.includes(id) || !weapons.includes(template)) fail(`sprites.weapons.${id}`, "Unknown weapon or template");
            profiles[id] = {
                template: template
            };
        }
        try {
            (0, $59a4975031bf42fe$export$d682c65f11e12f14)(profiles, weapons);
        } catch (e) {
            fail("sprites.weapons", e.message);
        }
    }
    for (const [slot, entries] of Object.entries(source.registry)){
        if (!Object.prototype.hasOwnProperty.call(slots, slot) || !$c3a2a0c750683e7a$var$object(entries)) {
            fail(`registry.${slot}`, "Unknown slot or invalid components");
            continue;
        }
        for (const [id, entry] of Object.entries(entries)){
            const p = `registry.${slot}.${id}`;
            if (!$c3a2a0c750683e7a$var$safeId(id) || !$c3a2a0c750683e7a$var$object(entry)) {
                fail(p, "Invalid component");
                continue;
            }
            if (Boolean(entry.layers) === Boolean(entry.explicit)) fail(p, "Choose layers or explicit sheets");
            if (!Array.isArray(entry.colors) || entry.colors.some((c)=>!colors.has(c)) || new Set(entry.colors).size !== entry.colors.length) fail(`${p}.colors`, "Expected unique known colours");
            for (const message of (0, $9667a1379a787b5e$export$4fd5d77b3f05d134)(entry, slot))fail(p, message);
            if (entry.shadow && !$c3a2a0c750683e7a$var$finite(entry.shadow.feetY)) fail(`${p}.shadow`, "Expected finite feetY");
            if (entry.variants && (!$c3a2a0c750683e7a$var$object(entry.variants) || Object.values(entry.variants).some((v)=>typeof v !== "string" || !v || /[\\/{}]/.test(v) || v === "." || v === ".."))) fail(`${p}.variants`, "Invalid variant names");
            if (entry.layers && !Array.isArray(entry.layers)) {
                fail(`${p}.layers`, "Expected layers");
                continue;
            }
            if (entry.explicit && !$c3a2a0c750683e7a$var$object(entry.explicit)) {
                fail(`${p}.explicit`, "Expected an explicit table");
                continue;
            }
            const lists = entry.explicit ? Object.values(entry.explicit) : [
                entry.layers || []
            ];
            for (const layers of lists){
                if (!Array.isArray(layers)) {
                    fail(p, "Expected sheet arrays");
                    continue;
                }
                for (const layer of layers){
                    if (!$c3a2a0c750683e7a$var$object(layer) || !$c3a2a0c750683e7a$var$finite(layer.z) || !$c3a2a0c750683e7a$export$fe84807a46f1035b(layer.path) || !layer.path.endsWith(".png") || /\{(?!sex\}|variant\})/.test(layer.path) || layer.type && ![
                        "primary",
                        "oversize"
                    ].includes(layer.type)) fail(p, "Invalid layer path, order or renderer type");
                    else if (layer.path.includes("{variant}") && !entry.variants) fail(p, "Missing variant mappings");
                }
            }
        }
    }
    if (!Array.isArray(source.presentation.sheets) || !$c3a2a0c750683e7a$var$object(source.presentation.subClasses) || !$c3a2a0c750683e7a$var$object(source.presentation.classToTypes)) fail("presentation", "Invalid presentation catalog");
    else {
        ids(source.presentation.sheets, "presentation.sheets");
        source.presentation.sheets.forEach((s, i)=>{
            if (!$c3a2a0c750683e7a$export$fe84807a46f1035b(s?.file)) fail(`presentation.sheets[${i}].file`, "Invalid atlas path");
        });
        for (const [table, rows] of Object.entries({
            subClasses: source.presentation.subClasses,
            classToTypes: source.presentation.classToTypes
        }))for (const [id, members] of Object.entries(rows))if (!Array.isArray(members) || members.some((v)=>!items.has(v))) fail(`presentation.${table}.${id}`, "Unknown ordered item");
    }
    const crafting = source.presentation.crafting;
    if (!$c3a2a0c750683e7a$var$object(crafting) || !Array.isArray(crafting.groups) || !crafting.groups.every($c3a2a0c750683e7a$var$safeId) || new Set(crafting.groups).size !== crafting.groups.length || !$c3a2a0c750683e7a$var$object(crafting.labels) || !$c3a2a0c750683e7a$var$object(crafting.overrides) || !$c3a2a0c750683e7a$var$object(crafting.byClass) || !$c3a2a0c750683e7a$var$object(crafting.sourceHints)) fail("presentation.crafting", "Invalid crafting presentation");
    else {
        for (const group of crafting.groups)if (typeof crafting.labels[group] !== "string" || !crafting.labels[group]) fail(`presentation.crafting.labels.${group}`, "Missing group label");
        if (!crafting.groups.includes(crafting.defaultGroup)) fail("presentation.crafting.defaultGroup", "Unknown default group");
        for (const [id, group] of Object.entries(crafting.overrides))if (!items.has(id) || !crafting.groups.includes(group)) fail(`presentation.crafting.overrides.${id}`, "Unknown item/group");
        for (const [id, group] of Object.entries(crafting.byClass))if (!classes.has(id) || !crafting.groups.includes(group)) fail(`presentation.crafting.byClass.${id}`, "Unknown class/group");
        for (const [id, hint] of Object.entries(crafting.sourceHints))if (!items.has(id) || typeof hint !== "string") fail(`presentation.crafting.sourceHints.${id}`, "Unknown item or invalid source hint");
        if (crafting.undisclosedSources !== undefined && (!Array.isArray(crafting.undisclosedSources) || crafting.undisclosedSources.some((id)=>!items.has(id)))) fail("presentation.crafting.undisclosedSources", "Unknown undisclosed-source item");
    }
    for (const p of source.preload)if (!$c3a2a0c750683e7a$export$fe84807a46f1035b(p)) fail("preload", "Invalid atlas path");
    const tiles = source.tiles;
    if (!Array.isArray(tiles.types) || !$c3a2a0c750683e7a$var$object(tiles.definitions) || !$c3a2a0c750683e7a$var$object(tiles.damageDefaults) || !$c3a2a0c750683e7a$var$object(tiles.damageSpecifics)) fail("tiles", "Invalid tile catalog");
    else {
        if (new Set(tiles.types).size !== tiles.types.length) fail("tiles.types", "Duplicate tile ID");
        for (const [id, tile] of Object.entries(tiles.definitions)){
            const p = `tiles.definitions.${id}`;
            if (!tiles.types.includes(id) || !$c3a2a0c750683e7a$var$object(tile)) {
                fail(p, "Unregistered tile");
                continue;
            }
            positive(tile.hp, `${p}.hp`);
            if (!Array.isArray(tile.onDestructionCreateItems) || !Array.isArray(tile.growthSequence)) {
                fail(p, "Invalid drops or growth sequence");
                continue;
            }
            tile.onDestructionCreateItems.forEach((d, i)=>{
                reference(d?.itemType, `${p}.drops[${i}]`);
                positive(d?.quantity, `${p}.drops[${i}].quantity`);
                if (!$c3a2a0c750683e7a$var$finite(d?.probability) || d.probability < 0 || d.probability > 1) fail(p, "Invalid drop probability");
            });
            tile.growthSequence.forEach((g, i)=>{
                if (!$c3a2a0c750683e7a$var$object(g)) {
                    fail(p, "Invalid growth entry");
                    return;
                }
                if (!tiles.types.includes(g.entityTileId)) fail(p, `Unknown growth tile ${g.entityTileId}`);
                positive(g.requiredTime, `${p}.growthSequence[${i}]`);
            });
            if (tile.tree !== undefined && !(0, $9be3ff017f3cb29b$export$eac6cd1dc8845500).includes(tile.tree)) fail(`${p}.tree`, `Expected ${(0, $9be3ff017f3cb29b$export$eac6cd1dc8845500).join(" or ")}`);
            if (tile.grass !== undefined && !(0, $9be3ff017f3cb29b$export$3dc6003d27a80399).includes(tile.grass)) fail(`${p}.grass`, `Expected ${(0, $9be3ff017f3cb29b$export$3dc6003d27a80399).join(" or ")}`);
        }
        for (const [id, damage] of Object.entries(tiles.damageDefaults))if (!tiles.types.includes(id) || !$c3a2a0c750683e7a$var$finite(damage) || damage < 0) fail(`tiles.damageDefaults.${id}`, "Invalid tile damage");
        for (const [id, rules] of Object.entries(tiles.damageSpecifics))if (!tiles.types.includes(id) || !Array.isArray(rules) || rules.some((r)=>!$c3a2a0c750683e7a$var$object(r) || !$c3a2a0c750683e7a$var$finite(r.damage) || r.damage < 0 || !source.sprites.registration?.WeaponTypes?.includes(r.weaponType))) fail(`tiles.damageSpecifics.${id}`, "Unknown tile, weapon or invalid damage");
    }
    const mapFiles = new Set();
    const ownMapFile = (file, extension, at)=>{
        if (!$c3a2a0c750683e7a$export$fe84807a46f1035b(file) || !file.startsWith("maps/") || !extension.test(file)) {
            fail(at, "Invalid map file path");
            return false;
        }
        if (mapFiles.has(file)) {
            fail(at, `Map file ${file} has more than one owner`);
            return false;
        }
        mapFiles.add(file);
        return true;
    };
    if (!Array.isArray(source.maps.templates)) fail("maps.templates", "Expected a template list");
    else {
        const ids = new Set();
        for (const template of source.maps.templates){
            if (!$c3a2a0c750683e7a$var$object(template) || !$c3a2a0c750683e7a$var$safeId(template.id) || ids.has(template.id) || !ownMapFile(template.file, /\.tmj$/, "maps.templates")) {
                fail("maps.templates", "Invalid or duplicate template ownership");
                continue;
            }
            ids.add(template.id);
        }
    }
    if (!$c3a2a0c750683e7a$var$object(source.maps.collisionOverrides)) fail("maps.collisionOverrides", "Expected collision overrides");
    if (!Array.isArray(source.maps.tilesets)) fail("maps.tilesets", "Expected a tileset list");
    else {
        const ids = new Set();
        for (const tileset of source.maps.tilesets){
            if (!$c3a2a0c750683e7a$var$object(tileset) || !$c3a2a0c750683e7a$var$safeId(tileset.id) || ids.has(tileset.id) || ![
                "tsx",
                "json"
            ].includes(tileset.format) || !ownMapFile(tileset.file, tileset.format === "json" ? /\.json$/ : /\.tsx$/, "maps.tilesets")) {
                fail("maps.tilesets", "Invalid or duplicate tileset ownership");
                continue;
            }
            ids.add(tileset.id);
            if (tileset.legacyOmittedTiles !== undefined && (tileset.id !== "container" || JSON.stringify(tileset.legacyOmittedTiles) !== "[46,47,62,63]")) fail("maps.tilesets", "Unknown legacy tile omission");
        }
    }
    if (!Array.isArray(source.maps.rooms) || !source.maps.rooms.length) fail("maps.rooms", "Expected a room list");
    else {
        const ids = new Set();
        source.maps.rooms.forEach((room, i)=>{
            const at = `maps.rooms[${i}]`;
            if (!$c3a2a0c750683e7a$var$object(room) || !$c3a2a0c750683e7a$var$safeId(room.id)) {
                fail(at, "Invalid room ID");
                return;
            }
            if (ids.has(room.id)) fail(at, `Duplicate room ID ${room.id}`);
            ids.add(room.id);
            ownMapFile(room.file, /\.tmj$/, `${at}.file`);
            if (room.provenance !== undefined) ownMapFile(room.provenance, /\.tmx$/, `${at}.provenance`);
            for (const key of Object.keys(room))if (![
                "id",
                "file",
                "provenance"
            ].includes(key)) fail(`${at}.${key}`, "Unknown room field");
        });
    }
    ownMapFile(source.maps.world, /\.json$/, "maps.world");
    if (!Array.isArray(source.maps.generatorInputs)) fail("maps.generatorInputs", "Expected generator inputs");
    else {
        const ids = new Set();
        source.maps.generatorInputs.forEach((input, i)=>{
            if (!$c3a2a0c750683e7a$var$object(input) || !$c3a2a0c750683e7a$var$safeId(input.id) || ids.has(input.id)) fail(`maps.generatorInputs[${i}]`, "Invalid or duplicate generator input");
            else {
                ids.add(input.id);
                ownMapFile(input.file, /\.(tmj|json)$/, `maps.generatorInputs[${i}].file`);
            }
        });
    }
    if (!Array.isArray(source.maps.historical)) fail("maps.historical", "Expected historical files");
    else source.maps.historical.forEach((entry, i)=>{
        if (!$c3a2a0c750683e7a$var$object(entry) || typeof entry.note !== "string" || !entry.note.trim()) fail(`maps.historical[${i}]`, "Historical files need a note");
        else ownMapFile(entry.file, /\.(tmx|tmj|tsx|json|png)$/, `maps.historical[${i}].file`);
    });
    const lifecycle = source.ids;
    if (!$c3a2a0c750683e7a$var$object(lifecycle.aliases) || !$c3a2a0c750683e7a$var$object(lifecycle.retired) || Object.keys(lifecycle).some((k)=>![
            "aliases",
            "retired"
        ].includes(k))) fail("ids", "Expected aliases and retired tables");
    else {
        const current = {
            items: items,
            races: new Set(source.sprites?.registration?.RaceTypes || []),
            colors: colors
        };
        for (const table of [
            "aliases",
            "retired"
        ])for (const [kind, entries] of Object.entries(lifecycle[table])){
            const p = `ids.${table}.${kind}`;
            if (!current[kind] || !$c3a2a0c750683e7a$var$object(entries)) {
                fail(p, "Expected items, races or colors");
                continue;
            }
            for (const [id, value] of Object.entries(entries)){
                if (!$c3a2a0c750683e7a$var$safeId(id) || current[kind].has(id)) fail(`${p}.${id}`, "A renamed or retired ID must not be a current ID");
                else if (table === "aliases" && (typeof value !== "string" || !current[kind].has(value))) fail(`${p}.${id}`, "An alias must name a current ID");
                else if (table === "retired" && (typeof value !== "string" || !value.trim())) fail(`${p}.${id}`, "Say why the ID was retired");
                else if (table === "retired" && lifecycle.aliases[kind]?.[id] !== undefined) fail(`${p}.${id}`, "An ID is either renamed or retired");
            }
        }
        for (const kind of [
            "items",
            "races",
            "colors"
        ])if (!$c3a2a0c750683e7a$var$object(lifecycle.aliases[kind]) || !$c3a2a0c750683e7a$var$object(lifecycle.retired[kind])) fail(`ids.${kind}`, "Expected alias and retired tables for every kind");
    }
    for (const id of (0, $8d9457f98f5de202$export$8d83692a55402888).required.items)if (!items.has(id)) fail("items", `Engine code requires item ${id}`);
    for (const id of (0, $8d9457f98f5de202$export$8d83692a55402888).required.races)if (!source.sprites?.registration?.RaceTypes?.includes(id)) fail("sprites.registration.RaceTypes", `Engine code requires race ${id}`);
    findings.push(...$c3a2a0c750683e7a$export$10161d9aaed3f2b9(source.autotiles));
    findings.push(...$c3a2a0c750683e7a$export$26480ca9332dfe33(source.ember, source));
    findings.push(...$c3a2a0c750683e7a$export$b2ce862c20b342c1(source));
    // Building materials must name items of the matching build type; an item belongs to one material.
    const builders = new Map();
    (source.autotiles?.definitions || []).forEach((definition, i)=>{
        if (![
            "wall",
            "roof",
            "bitmask"
        ].includes(definition?.kind) || definition.itemType === undefined) return;
        const p = `autotiles.definitions[${i}].itemType`;
        const builds = definition.kind === "bitmask" ? "floor" : definition.kind;
        const item = source.items.find((entry)=>entry.id === definition.itemType);
        if (!item) fail(p, `Unknown item ${definition.itemType}`);
        else if (item.characteristics?.buildType !== builds) fail(p, `Item ${definition.itemType} does not build ${builds}s (characteristics.buildType is ${JSON.stringify(item.characteristics?.buildType)})`);
        if (builders.has(definition.itemType)) fail(p, `Item ${definition.itemType} already builds ${definition.kind} material ${builders.get(definition.itemType)}`);
        builders.set(definition.itemType, definition.id);
    });
    const profiles = source.profiles;
    const ranges = [
        "speed",
        "hp",
        "hostility",
        "tileSize"
    ];
    const scalar = (value, p)=>{
        if ($c3a2a0c750683e7a$var$finite(value)) {
            if (value < 0) fail(p, "Expected a nonnegative value");
            return;
        }
        if (!$c3a2a0c750683e7a$var$object(value) || !ranges.includes(value.baseline) || Object.keys(value).some((k)=>![
                "baseline",
                "pctOfMax",
                "multiplier"
            ].includes(k)) || value.pctOfMax !== undefined && (!$c3a2a0c750683e7a$var$finite(value.pctOfMax) || value.pctOfMax < 0 || value.pctOfMax > 1 || value.baseline === "tileSize") || value.multiplier !== undefined && (!$c3a2a0c750683e7a$var$finite(value.multiplier) || value.multiplier < 0)) fail(p, "Invalid engine scaling form");
    };
    const baseline = (value, p)=>{
        if (!$c3a2a0c750683e7a$var$object(value) || Object.keys(value).some((k)=>![
                "maxSpeed",
                "hp",
                "psych",
                "scanDistanceTiles",
                "preSpawnEffect"
            ].includes(k)) || !$c3a2a0c750683e7a$var$object(value.psych)) {
            fail(p, "Invalid population profile");
            return;
        }
        preSpawnEffect(value.preSpawnEffect, `${p}.preSpawnEffect`);
        scalar(value.maxSpeed, `${p}.maxSpeed`);
        scalar(value.hp, `${p}.hp`);
        for (const [key, v] of Object.entries(value.psych)){
            if (key === "hostility") scalar(v, `${p}.psych.hostility`);
            else if (key === "chronotype" && [
                "diurnal",
                "nocturnal",
                "both"
            ].includes(v)) continue;
            else if (key === "attackPattern" && [
                "default",
                "swoop",
                "v2"
            ].includes(v)) continue;
            else if (key === "aggroResponse" && [
                "default",
                "pause"
            ].includes(v)) continue;
            else if (key === "closeOnStun" && typeof v === "boolean") continue;
            else fail(`${p}.psych.${key}`, "Unknown behavior key or invalid value");
        }
        if (value.scanDistanceTiles !== undefined) positive(value.scanDistanceTiles, `${p}.scanDistanceTiles`);
    };
    for (const key of [
        "weapons",
        "populationDefault",
        "population",
        "npcSpecs",
        "factions",
        "drops",
        "itemDrops",
        "effects",
        "encounters"
    ])if (!$c3a2a0c750683e7a$var$object(profiles[key])) fail(`profiles.${key}`, "Expected a profile table");
    if (findings.some((f)=>f.path.startsWith("profiles"))) return findings;
    baseline(profiles.populationDefault, "profiles.populationDefault");
    const races = new Set(source.sprites.registration.RaceTypes);
    for (const [id, value] of Object.entries(profiles.population)){
        if (!races.has(id)) fail(`profiles.population.${id}`, "Unknown race");
        baseline(value, `profiles.population.${id}`);
    }
    for (const [id, faction] of Object.entries(profiles.factions))if (!races.has(id) || !$c3a2a0c750683e7a$var$safeId(faction)) fail(`profiles.factions.${id}`, "Unknown race or invalid faction");
    for (const [name, table] of Object.entries({
        drops: profiles.drops,
        itemDrops: profiles.itemDrops
    }))for (const [id, list] of Object.entries(table)){
        const p = `profiles.${name}.${id}`;
        if (!(name === "drops" ? races : items).has(id) || !Array.isArray(list)) {
            fail(p, "Unknown owner or invalid drop list");
            continue;
        }
        for (const drop of list){
            if (!$c3a2a0c750683e7a$var$object(drop) || Boolean(drop.reference) === Boolean(drop.metadata)) {
                fail(p, "Choose an item reference or explicit legacy metadata");
                continue;
            }
            if (drop.reference) reference(drop.reference, p);
            else if (!items.has(drop.metadata.type) || !classes.has(drop.metadata.class) || !colors.has(drop.metadata.color)) fail(p, "Invalid drop metadata");
            positive(drop.quantity, `${p}.quantity`);
            if (drop.probability !== undefined && (!$c3a2a0c750683e7a$var$finite(drop.probability) || drop.probability < 0 || drop.probability > 1)) fail(p, "Invalid drop probability");
        }
    }
    const weaponFields = [
        "bulletSpeed",
        "firingLatchMs",
        "manaCost",
        "maxDistance",
        "attackRange",
        "maxParticles",
        "maxEntitiesHit",
        "duration",
        "equipOrder",
        "muzzleFireOffset",
        "slotVisible",
        "baseDamage",
        "bulletSpriteId",
        "pushStrength",
        "bulletType",
        "collisionDimensions"
    ];
    for (const [id, values] of Object.entries(profiles.weapons)){
        const p = `profiles.weapons.${id}`;
        if (!$c3a2a0c750683e7a$var$safeId(id) || !$c3a2a0c750683e7a$var$object(values)) {
            fail(p, "Invalid weapon profile");
            continue;
        }
        for (const [key, value] of Object.entries(values)){
            if (!weaponFields.includes(key)) fail(`${p}.${key}`, "Unknown weapon parameter");
            else if (key === "slotVisible") {
                if (typeof value !== "boolean") fail(p, "Invalid visibility");
            } else if (key === "bulletType") {
                if (!(0, $8d9457f98f5de202$export$8d83692a55402888).ammoTypes.includes(value)) fail(`${p}.${key}`, "Unknown projectile handler");
            } else if (key === "bulletSpriteId") {
                if (typeof value !== "string" || !/^[A-Za-z0-9][A-Za-z0-9_.-]*$/.test(value)) fail(p, "Invalid projectile sprite");
            } else if (key === "collisionDimensions") {
                if (!$c3a2a0c750683e7a$var$object(value) || !$c3a2a0c750683e7a$var$finite(value.w) || !$c3a2a0c750683e7a$var$finite(value.h) || value.w <= 0 || value.h <= 0) fail(p, "Invalid projectile geometry");
            } else scalar(value, `${p}.${key}`);
        }
    }
    const brain = (value, p)=>{
        if (!$c3a2a0c750683e7a$var$object(value)) {
            fail(p, "Invalid brain parameters");
            return;
        }
        const booleans = [
            "scanner",
            "scanPlayersOnly",
            "randomWander",
            "peckWander",
            "v2",
            "avoidEntities",
            "noop",
            "shooter",
            "seeksPlayers",
            "randomizedPauses",
            "seekUntilMinimumDistance",
            "strictEntityAvoidance"
        ];
        const numbers = [
            "leashRange",
            "targetLocationMaxDistance",
            "targetLocationThresholdDistance",
            "leaderLocationThresholdDistance",
            "actionCoolDownTs",
            "actionRange",
            "patrolPause",
            "patrolPauseLikelihood",
            "switchLatchTs"
        ];
        for (const [key, item] of Object.entries(value)){
            if (booleans.includes(key)) {
                if (typeof item !== "boolean") fail(`${p}.${key}`, "Expected a behavior flag");
            } else if (numbers.includes(key)) scalar(item, `${p}.${key}`);
            else if (key === "seeker") {
                if (![
                    "brute",
                    "astar"
                ].includes(item)) fail(`${p}.${key}`, "Unknown seeker behavior");
            } else if (key === "psychProfile") baseline({
                maxSpeed: 0,
                hp: 1,
                psych: item
            }, p);
            else fail(`${p}.${key}`, "Unknown brain behavior parameter");
        }
    };
    for (const [id, value] of Object.entries(profiles.npcSpecs)){
        const p = `profiles.npcSpecs.${id}`;
        if (!races.has(id) || !$c3a2a0c750683e7a$var$object(value) || !$c3a2a0c750683e7a$var$object(value.npc) || !$c3a2a0c750683e7a$var$object(value.brainProps)) {
            fail(p, "Invalid NPC specification");
            continue;
        }
        for (const [key, item] of Object.entries(value.npc)){
            if ([
                "portable",
                "persistable",
                "clickable",
                "strikeable"
            ].includes(key)) {
                if (typeof item !== "boolean") fail(`${p}.${key}`, "Expected a flag");
            } else if ([
                "speed",
                "hp",
                "angle"
            ].includes(key)) scalar(item, `${p}.${key}`);
            else if (key === "type") {
                if (!(0, $8d9457f98f5de202$export$8d83692a55402888).npcTypes.includes(item)) fail(p, "Unknown NPC kind");
            } else if ([
                "name",
                "spriteId",
                "faction"
            ].includes(key)) {
                if (!$c3a2a0c750683e7a$var$safeId(item)) fail(p, "Invalid NPC identifier");
            } else if (key === "preSpawnEffect") preSpawnEffect(item, `${p}.npc.${key}`);
            else fail(`${p}.${key}`, "Unknown NPC parameter");
        }
        brain(value.brainProps, `${p}.brainProps`);
    }
    for (const [id, effect] of Object.entries(profiles.effects)){
        const p = `profiles.effects.${id}`;
        if (!items.has(id) || !$c3a2a0c750683e7a$var$object(effect) || !(0, $8d9457f98f5de202$export$8d83692a55402888).itemActivationEffects.includes(effect.effect) || effect.clockDuration !== undefined && (!$c3a2a0c750683e7a$var$finite(effect.clockDuration) || effect.clockDuration < 0)) fail(p, "Unknown item or item activation handler, or invalid duration");
        else for (const key of Object.keys(effect))if (![
            "effect",
            "clockDuration"
        ].includes(key)) fail(`${p}.${key}`, "Unknown effect parameter");
    }
    for (const [table, races] of Object.entries((0, $8d9457f98f5de202$export$8d83692a55402888).required.encounters))for (const race of races)if (!$c3a2a0c750683e7a$var$object(profiles.encounters[table]?.specs?.[race])) fail(`profiles.encounters.${table}`, `Engine code requires a ${race} encounter`);
    for (const [id, encounter] of Object.entries(profiles.encounters)){
        const p = `profiles.encounters.${id}`;
        if (!$c3a2a0c750683e7a$var$safeId(id) || !$c3a2a0c750683e7a$var$object(encounter) || !$c3a2a0c750683e7a$var$object(encounter.specs) || !Array.isArray(encounter.enemyWeights)) {
            fail(p, "Invalid encounter table");
            continue;
        }
        const weighted = new Set();
        let total = 0;
        for (const entry of encounter.enemyWeights){
            if (!$c3a2a0c750683e7a$var$object(entry) || !races.has(entry.race) || !Object.prototype.hasOwnProperty.call(encounter.specs, entry.race) || weighted.has(entry.race) || !$c3a2a0c750683e7a$var$finite(entry.weight) || entry.weight < 0) {
                fail(p, "Invalid or duplicate weighted race");
                continue;
            }
            weighted.add(entry.race);
            total += entry.weight;
        }
        if (total <= 0 || !weighted.has(encounter.defaultEnemy)) fail(p, "An encounter needs positive weights and a weighted default race");
        for (const [race, spec] of Object.entries(encounter.specs)){
            const at = `${p}.specs.${race}`;
            if (!races.has(race) || !$c3a2a0c750683e7a$var$object(spec) || spec.race !== race || !$c3a2a0c750683e7a$var$finite(spec.probability) || spec.probability < 0 || spec.probability > 1) {
                fail(at, "Invalid encounter race or probability");
                continue;
            }
            for (const [key, value] of Object.entries(spec)){
                if (key === "race" || key === "probability") continue;
                if (key === "hp" || key === "speed") scalar(value, `${at}.${key}`);
                else if (key === "brainProps") brain(value, `${at}.brainProps`);
                else if (key === "faction") {
                    if (!$c3a2a0c750683e7a$var$safeId(value)) fail(at, "Invalid faction");
                } else if (key === "immoveable") {
                    if (typeof value !== "boolean") fail(at, "Invalid movement flag");
                } else if (key === "sex") {
                    if (!source.sprites.registration.RaceSexes[race]?.includes(value)) fail(at, "Unsupported sex");
                } else if (key === "bodyColor") {
                    if (!colors.has(value) || !source.registry.body[race]?.colors?.includes(value)) fail(at, "Unsupported body color");
                } else if (key === "flags") {
                    if (!$c3a2a0c750683e7a$var$object(value) || Object.entries(value).some(([name, v])=>!(0, $8d9457f98f5de202$export$8d83692a55402888).encounterFlags.includes(name) || !(typeof v === "boolean" || typeof v === "string" || $c3a2a0c750683e7a$var$finite(v)))) fail(at, "Encounter flags must be engine-read flags with scalar values");
                } else fail(`${at}.${key}`, "Unknown encounter parameter");
            }
        }
    }
    return findings;
};
const $c3a2a0c750683e7a$export$10161d9aaed3f2b9 = (file, tilesets)=>(0, $c5e6b310c34d168e$export$2bdd69dcfe9ad25a)(file, tilesets ? {
        tilesets: Object.fromEntries(Object.entries(tilesets).map(([id, data])=>[
                id,
                data.tilecount
            ]))
    } : {}).map((message)=>({
            path: "autotiles",
            message: message
        }));
const $c3a2a0c750683e7a$export$26480ca9332dfe33 = (file, source)=>{
    const findings = (0, $121d74fbc26f823b$export$ebc80c910378e7da)(file).map((message)=>({
            path: "ember",
            message: message
        }));
    if (findings.length) return findings;
    // Judged against what the rest of the source says, however malformed that is (it is reported on its own).
    const colors = new Set(Array.isArray(source.vocabularies?.colors) ? source.vocabularies.colors : []);
    const items = Array.isArray(source.items) ? source.items : [];
    file.designs.forEach((design, i)=>{
        const p = `ember.designs[${i}]`;
        const itemClass = (0, $121d74fbc26f823b$export$a839e9ddc1b1a60f)[design.slot];
        const item = items.find((entry)=>entry?.id === design.id);
        if (!itemClass) findings.push({
            path: p,
            message: `A ${design.slot} is part of a look, never an item: it has models, not designs`
        });
        else if (!item) findings.push({
            path: `${p}.id`,
            message: `Unknown item ${design.id}`
        });
        else if (item.class !== itemClass) findings.push({
            path: `${p}.id`,
            message: `Item ${design.id} is class ${item.class}; a ${design.slot} design draws a ${itemClass}`
        });
        for (const color of design.colors ?? [])if (!colors.has(color)) findings.push({
            path: `${p}.colors`,
            message: `Unknown colour ${color}`
        });
    });
    return findings;
};
const $c3a2a0c750683e7a$export$b2ce862c20b342c1 = (source)=>{
    const findings = (0, $121d74fbc26f823b$export$6dc13596c1f9366b)(source.emberBodies, source.emberHair).map((p)=>({
            path: p.file === "bodies" ? "emberBodies" : "emberHair",
            message: p.message
        }));
    const files = {
        palettes: "emberPalettes",
        marks: "emberMarks",
        styles: "emberStyles",
        humanoids: "emberHumanoids"
    };
    findings.push(...(0, $88d3b9e55635678e$export$2aa96452a8ae5e08)({
        palettes: source.emberPalettes,
        marks: source.emberMarks,
        styles: source.emberStyles,
        humanoids: source.emberHumanoids,
        hair: source.emberHair,
        bodies: source.emberBodies,
        equipment: source.ember
    }).map((p)=>({
            path: files[p.file] ?? p.file,
            message: p.message
        })));
    findings.push(...(0, $88d3b9e55635678e$export$ca4815871a87548b)(source.emberAnimations).map((message)=>({
            path: "emberAnimations",
            message: message
        })));
    // Species: rigs, gaits, clips and bodies hold together, and their models compile.
    const species = source.emberSpecies;
    const humanoids = Array.isArray(source.emberHumanoids?.humanoids) ? source.emberHumanoids.humanoids.map((h)=>h?.name) : [];
    const styles = Object.keys(source.emberStyles?.styles ?? {});
    const races = source.sprites?.registration?.RaceTypes ?? [];
    const humanoidRaces = Array.isArray(source.emberHumanoids?.races) ? source.emberHumanoids.races.map((r)=>r?.race) : [];
    findings.push(...(0, $88d3b9e55635678e$export$714e142d4f44ebae)(species, {
        humanoids: humanoids,
        styles: styles,
        races: races,
        humanoidRaces: humanoidRaces
    }).map((message)=>({
            path: "emberSpecies",
            message: message
        })));
    if (species && typeof species === "object" && species.models && typeof species.models === "object") findings.push(...(0, $121d74fbc26f823b$export$ebc80c910378e7da)({
        version: 1,
        library: species.library,
        models: {
            species: species.models
        },
        designs: []
    }, [
        "species"
    ]).map((message)=>({
            path: "emberSpecies",
            message: message.replace("models.species.", "models.")
        })));
    return findings;
};
function $c3a2a0c750683e7a$export$3e6f1edc065228a0(source) {
    const findings = $c3a2a0c750683e7a$export$1fbd44e8a75e17b6(source);
    if (findings.length) throw new Error(findings.map((f)=>`${f.path}: ${f.message}`).join("\n"));
}


const $32bf6ee6be8f6c23$export$560fbceae326a62a = 1;
const $32bf6ee6be8f6c23$var$record = (value)=>!!value && typeof value === "object" && !Array.isArray(value);
const $32bf6ee6be8f6c23$var$revisionPattern = /^[0-9a-f]{64}$/;
const $32bf6ee6be8f6c23$export$f91df3745e1c6929 = (published, file)=>{
    if (typeof published !== "string" || !published.startsWith("content/")) return false;
    const rest = published.slice(8), slash = rest.indexOf("/");
    return slash === 64 && $32bf6ee6be8f6c23$var$revisionPattern.test(rest.slice(0, 64)) && rest.slice(65) === file;
};
const $32bf6ee6be8f6c23$export$de1e2c66da6b2894 = (published)=>published.slice(8, 72);
const $32bf6ee6be8f6c23$export$ec1ee6117ca85b54 = [
    "manifest.json",
    "catalog.json"
];
const $32bf6ee6be8f6c23$export$37801d296f1f2529 = (revision, media, integrity, atlasImages)=>{
    const manifest = {
        schemaVersion: 1,
        engineContentVersion: $32bf6ee6be8f6c23$export$560fbceae326a62a,
        revision: revision,
        catalog: "catalog.json",
        media: [
            ...media
        ],
        ...integrity ? {
            integrity: integrity
        } : {},
        ...atlasImages ? {
            atlasImages: atlasImages
        } : {}
    };
    $32bf6ee6be8f6c23$export$2347314d566cdccc(manifest);
    return manifest;
};
function $32bf6ee6be8f6c23$export$2347314d566cdccc(value) {
    if (!$32bf6ee6be8f6c23$var$record(value) || value.schemaVersion !== 1 || value.engineContentVersion !== $32bf6ee6be8f6c23$export$560fbceae326a62a) throw new Error("Incompatible content release: unsupported schema or engine content version");
    if (!$32bf6ee6be8f6c23$var$revisionPattern.test(value.revision) || value.catalog !== "catalog.json") throw new Error("Invalid content release identity");
    if (!Array.isArray(value.media) || value.media.some((file)=>!(0, $c3a2a0c750683e7a$export$fe84807a46f1035b)(file) || $32bf6ee6be8f6c23$export$ec1ee6117ca85b54.includes(file)) || new Set(value.media).size !== value.media.length) throw new Error("Invalid content release media paths (duplicate, unsafe or reserved)");
    if (value.integrity !== undefined) {
        const digest = (entry)=>$32bf6ee6be8f6c23$var$record(entry) && typeof entry.sha256 === "string" && $32bf6ee6be8f6c23$var$revisionPattern.test(entry.sha256) && Number.isSafeInteger(entry.size) && entry.size >= 0;
        const inventory = (entries)=>$32bf6ee6be8f6c23$var$record(entries) && Object.entries(entries).every(([file, entry])=>(0, $c3a2a0c750683e7a$export$fe84807a46f1035b)(file) && digest(entry));
        const integrity = value.integrity;
        if (!$32bf6ee6be8f6c23$var$record(integrity) || !digest(integrity.catalog) || !inventory(integrity.media) || !inventory(integrity.server) || (0, $59a4975031bf42fe$export$5f7ad4bf4d14138b)(Object.keys(integrity.media).sort()) !== (0, $59a4975031bf42fe$export$5f7ad4bf4d14138b)([
            ...value.media
        ].sort()) || !integrity.server["index.json"]) throw new Error("Invalid content release integrity inventory");
    }
    if (value.atlasImages !== undefined) {
        const media = new Set(value.media);
        if (!$32bf6ee6be8f6c23$var$record(value.atlasImages) || Object.entries(value.atlasImages).some(([atlas, image])=>!media.has(atlas) || typeof image !== "string" || !media.has(image))) throw new Error("Invalid content release atlas images");
    }
}
function $32bf6ee6be8f6c23$export$921a76185990260e(manifest, value) {
    $32bf6ee6be8f6c23$export$2347314d566cdccc(manifest);
    if (!$32bf6ee6be8f6c23$var$record(value) || value.schemaVersion !== 1 || value.revision !== manifest.revision) throw new Error("Content catalog does not match its release");
    (0, $c3a2a0c750683e7a$export$3e6f1edc065228a0)(value.source);
    const derived = (0, $59a4975031bf42fe$export$9db02abe11bb4ea8)(value.source, value.revision);
    for (const key of [
        "items",
        "spriteColors",
        "tiles",
        "npcDrops",
        "itemDrops",
        "creatures",
        "weapons"
    ]){
        if ((0, $59a4975031bf42fe$export$5f7ad4bf4d14138b)(value[key]) !== (0, $59a4975031bf42fe$export$5f7ad4bf4d14138b)(derived[key])) throw new Error(`Invalid derived content table: ${key}`);
    }
    if (!$32bf6ee6be8f6c23$var$record(value.assets) || Object.keys(value.assets).length !== manifest.media.length) throw new Error("Content asset index does not match release media");
    for (const file of manifest.media){
        if (!$32bf6ee6be8f6c23$export$f91df3745e1c6929(value.assets[file], file)) throw new Error(`Invalid release asset path: ${file}`);
    }
    // Full geometry/atlas validation belongs to the compiler. The release must at least contain
    // the registered map tables; these are not derivable from source catalogs alone.
    for (const [key, entries] of [
        [
            "mapTemplates",
            value.source.maps.templates
        ],
        [
            "mapTilesets",
            value.source.maps.tilesets
        ]
    ]){
        if (!$32bf6ee6be8f6c23$var$record(value[key]) || (0, $59a4975031bf42fe$export$5f7ad4bf4d14138b)(Object.keys(value[key]).sort()) !== (0, $59a4975031bf42fe$export$5f7ad4bf4d14138b)(entries.map((entry)=>entry.id).sort())) throw new Error(`Invalid release map index: ${key}`);
        if (Object.values(value[key]).some((entry)=>!$32bf6ee6be8f6c23$var$record(entry))) throw new Error(`Invalid release map document: ${key}`);
    }
}



const $37c55e30895d384f$var$freeze = (value)=>{
    if (value && typeof value === "object") {
        Object.values(value).forEach($37c55e30895d384f$var$freeze);
        Object.freeze(value);
    }
    return value;
};
const $37c55e30895d384f$var$snapshot = (manifest, catalog, generation)=>{
    // A detached JSON snapshot prevents a caller mutating active or pending content afterward.
    const copy = JSON.parse(JSON.stringify({
        manifest: manifest,
        catalog: catalog
    }));
    (0, $32bf6ee6be8f6c23$export$921a76185990260e)(copy.manifest, copy.catalog);
    return $37c55e30895d384f$var$freeze({
        generation: generation,
        manifest: copy.manifest,
        catalog: copy.catalog
    });
};
class $37c55e30895d384f$export$66497b07577dd981 {
    constructor(manifest, catalog){
        this.preparing = false;
        this.current = $37c55e30895d384f$var$snapshot(manifest, catalog, 0);
    }
    get active() {
        return this.current;
    }
    assertIdle() {
        if (this.preparing) throw new Error("Content preparation is already in progress");
    }
    prepare(manifest, catalog, prepareDependents) {
        this.assertIdle();
        const next = $37c55e30895d384f$var$snapshot(manifest, catalog, this.current.generation + 1);
        // A dependent preparation failure must not replace an earlier valid pending release.
        this.preparing = true;
        try {
            prepareDependents?.(next);
        } finally{
            this.preparing = false;
        }
        const handle = Object.freeze({
            revision: next.catalog.revision,
            baseGeneration: this.current.generation
        });
        // Only successful preparation supersedes an earlier candidate.
        this.pending = {
            handle: handle,
            snapshot: next
        };
        return handle;
    }
    activate(handle) {
        this.assertIdle();
        if (!this.pending || this.pending.handle !== handle || handle.baseGeneration !== this.current.generation) throw new Error("Content preparation is stale or belongs to another store");
        this.current = this.pending.snapshot;
        this.pending = undefined;
        return this.current;
    }
    discard(handle) {
        this.assertIdle();
        if (this.pending?.handle === handle) this.pending = undefined;
    }
}


const $15d2a9f75b1dc98a$var$copy = (value)=>JSON.parse(JSON.stringify(value));
class $15d2a9f75b1dc98a$export$8da397fb250a4ca {
    constructor(manifest, catalog){
        this.bindings = new Set();
        this.busy = false;
        this.store = new (0, $37c55e30895d384f$export$66497b07577dd981)(manifest, catalog);
        this.view = $15d2a9f75b1dc98a$var$copy(this.store.active.catalog);
    }
    get active() {
        return this.store.active;
    }
    assertIdle() {
        if (this.busy) throw new Error("Content transaction is already in progress");
    }
    /** Pure selectors share one detached catalog view, preserving existing table aliases. */ bind(select, apply) {
        this.assertIdle();
        const binding = {
            prepare: select,
            apply: apply,
            current: undefined
        };
        this.busy = true;
        try {
            binding.current = select(this.view);
            apply(binding.current);
            this.bindings.add(binding);
            // A newly imported consumer was not included in an earlier preparation.
            this.cancelPending();
        } finally{
            this.busy = false;
        }
        return ()=>{
            this.assertIdle();
            if (this.bindings.delete(binding)) this.cancelPending();
        };
    }
    prepare(manifest, catalog) {
        this.assertIdle();
        this.busy = true;
        try {
            const values = new Map();
            let view;
            const handle = this.store.prepare(manifest, catalog, (candidate)=>{
                view = $15d2a9f75b1dc98a$var$copy(candidate.catalog);
                for (const binding of this.bindings)values.set(binding, binding.prepare(view));
            });
            this.pending = {
                handle: handle,
                values: values,
                view: view
            };
            return handle;
        } finally{
            this.busy = false;
        }
    }
    activate(handle) {
        this.assertIdle();
        if (!this.pending || this.pending.handle !== handle) throw new Error("Content preparation is stale or belongs to another runtime");
        const pending = this.pending;
        const applied = [];
        this.busy = true;
        try {
            for (const [binding, value] of pending.values){
                // Include the failing binding: a callback might assign state before throwing.
                applied.push(binding);
                binding.apply(value);
            }
            const active = this.store.activate(handle);
            this.view = pending.view;
            for (const [binding, value] of pending.values)binding.current = value;
            this.pending = undefined;
            return active;
        } catch (error) {
            const failures = [];
            for (const binding of applied.reverse())try {
                binding.apply(binding.current);
            } catch (rollbackError) {
                failures.push(rollbackError);
            }
            this.cancelPending();
            if (failures.length) throw new Error(`Content rollback failed after ${String(error)}: ${failures.map(String).join("; ")}`);
            throw error;
        } finally{
            this.busy = false;
        }
    }
    discard(handle) {
        this.assertIdle();
        if (this.pending?.handle === handle) this.cancelPending();
    }
    cancelPending() {
        if (this.pending) this.store.discard(this.pending.handle);
        this.pending = undefined;
    }
}


/** Stable browser-safe import. The tools compiler validates before publication. */ // Common and server use different interop settings; normalize both JSON module shapes.
const $e5c675b7b9585b42$var$bundled = $4cd2695ccd862b0a$exports.default || $4cd2695ccd862b0a$exports;
const $e5c675b7b9585b42$export$6a6f8fa24d5c0853 = new (0, $15d2a9f75b1dc98a$export$8da397fb250a4ca)((0, $32bf6ee6be8f6c23$export$37801d296f1f2529)($e5c675b7b9585b42$var$bundled.revision, Object.keys($e5c675b7b9585b42$var$bundled.assets)), $e5c675b7b9585b42$var$bundled);
let $e5c675b7b9585b42$export$8952b416ba38edb4;
let $e5c675b7b9585b42$export$43829b1119ccb642;
const $e5c675b7b9585b42$export$eca3444cf0ef4f9a = ()=>$e5c675b7b9585b42$export$6a6f8fa24d5c0853.active.generation;
const $e5c675b7b9585b42$export$f9af3f5df3a57431 = (select, apply)=>$e5c675b7b9585b42$export$6a6f8fa24d5c0853.bind(select, apply);
$e5c675b7b9585b42$export$f9af3f5df3a57431((catalog)=>({
        catalog: catalog,
        revision: catalog.revision
    }), (state)=>{
    $e5c675b7b9585b42$export$8952b416ba38edb4 = state.catalog;
    $e5c675b7b9585b42$export$43829b1119ccb642 = state.revision;
});
const $e5c675b7b9585b42$export$b203ec133a674bd0 = (value)=>typeof value === "string" && $e5c675b7b9585b42$export$8952b416ba38edb4.items.all.includes(value);
const $e5c675b7b9585b42$export$93dc97e717710a7c = (value)=>typeof value === "string" && $e5c675b7b9585b42$export$8952b416ba38edb4.source.sprites.registration.RaceTypes.includes(value);
const $e5c675b7b9585b42$export$404df70c1873382 = (value)=>{
    if (!$e5c675b7b9585b42$export$b203ec133a674bd0(value)) throw new Error(`Unknown saved or network item ID: ${String(value)}`);
    return value;
};
const $e5c675b7b9585b42$export$778b0dfe23702ce7 = (revision)=>{
    if (revision !== $e5c675b7b9585b42$export$43829b1119ccb642) throw new Error(`Content revision mismatch: expected ${$e5c675b7b9585b42$export$43829b1119ccb642}, received ${revision}`);
};
const $e5c675b7b9585b42$export$68aaae2ac04b8328 = (subclass)=>$e5c675b7b9585b42$export$8952b416ba38edb4.items.subClasses[subclass] || [];
const $e5c675b7b9585b42$export$bab18279d67f8654 = (url)=>{
    const prefix = "assets/";
    if (!url.startsWith(prefix) || url.startsWith(`${prefix}content/`)) return url;
    const published = $e5c675b7b9585b42$export$8952b416ba38edb4.assets[url.slice(prefix.length)];
    if (!published) throw new Error(`Unregistered content asset ${url}`);
    return prefix + published;
};


/** Stable content adapter; authoring never rewrites this module. */ 
let $49ede8eb593e752a$export$c51a3547a8532e0a = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.presentation.sheets;
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        itemSpriteSheets: catalog.source.presentation.sheets
    }), (next)=>{
    $49ede8eb593e752a$export$c51a3547a8532e0a = next.itemSpriteSheets;
});


parcelRequire("1avo5");
var $ezJmd = parcelRequire("ezJmd");
var $P8XPi = parcelRequire("P8XPi");
var $gwPoJ = parcelRequire("gwPoJ");
var $kXE1p = parcelRequire("kXE1p");
var $7DxQ2 = parcelRequire("7DxQ2");
var $hnGDn = parcelRequire("hnGDn");


var $8Odl4 = parcelRequire("8Odl4");

const $afc439431837457b$export$736d42feedf23b37 = (at)=>({
        left: at.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
        right: (at.x + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
        north: at.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 48 + 12,
        south: at.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 48 + 39
    });


// Global time function that can be overridden for testing
let $4171652afd996934$var$globalTimeFunction = null;
function $4171652afd996934$export$55c0f46e09192d7(timeFn) {
    $4171652afd996934$var$globalTimeFunction = timeFn;
}
function $4171652afd996934$export$a86190deb5c4a8d0() {
    return $4171652afd996934$var$globalTimeFunction ? $4171652afd996934$var$globalTimeFunction() : Date.now();
}


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $ecc82b4b4d5334a5$var$getRandomValues;
var $ecc82b4b4d5334a5$var$rnds8 = new Uint8Array(16);
function $ecc82b4b4d5334a5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ecc82b4b4d5334a5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $ecc82b4b4d5334a5$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$ecc82b4b4d5334a5$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $ecc82b4b4d5334a5$var$getRandomValues($ecc82b4b4d5334a5$var$rnds8);
}


var $83c241de251331e8$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $e70e86397c656fa2$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $83c241de251331e8$export$2e2bcd8739ae039).test(uuid);
}
var $e70e86397c656fa2$export$2e2bcd8739ae039 = $e70e86397c656fa2$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $5ce84198744ccadf$var$byteToHex = [];
for(var $5ce84198744ccadf$var$i = 0; $5ce84198744ccadf$var$i < 256; ++$5ce84198744ccadf$var$i)$5ce84198744ccadf$var$byteToHex.push(($5ce84198744ccadf$var$i + 0x100).toString(16).substr(1));
function $5ce84198744ccadf$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($5ce84198744ccadf$var$byteToHex[arr[offset + 0]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 1]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 2]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 3]] + '-' + $5ce84198744ccadf$var$byteToHex[arr[offset + 4]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 5]] + '-' + $5ce84198744ccadf$var$byteToHex[arr[offset + 6]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 7]] + '-' + $5ce84198744ccadf$var$byteToHex[arr[offset + 8]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 9]] + '-' + $5ce84198744ccadf$var$byteToHex[arr[offset + 10]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 11]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 12]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 13]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 14]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $e70e86397c656fa2$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $5ce84198744ccadf$export$2e2bcd8739ae039 = $5ce84198744ccadf$var$stringify;


function $87befc68df50040c$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $ecc82b4b4d5334a5$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $5ce84198744ccadf$export$2e2bcd8739ae039)(rnds);
}
var $87befc68df50040c$export$2e2bcd8739ae039 = $87befc68df50040c$var$v4;






const $df375085b7c59381$export$e4b2ac9215619f8d = {
    vileAndCrude: {
        small: [
            'ach',
            'adz',
            'ak',
            'ark',
            'az',
            'balg',
            'bilg',
            'blid',
            'blig',
            'blok',
            'blot',
            'bolg',
            'bot',
            'bug',
            'burk',
            'dokh',
            'drik',
            'driz',
            'duf',
            'flug',
            'ga',
            'gad',
            'gag',
            'gah',
            'gak',
            'gar',
            'gat',
            'gaz',
            'ghag',
            'ghak',
            'git',
            'glag',
            'glak',
            'glat',
            'glig',
            'gliz',
            'glok',
            'gnat',
            'gog',
            'grak',
            'grat',
            'guk',
            'hig',
            'irk',
            'kak',
            'khad',
            'krig',
            'lag',
            'lak',
            'lig',
            'likk',
            'loz',
            'luk',
            'mak',
            'maz',
            'miz',
            'mub',
            'nad',
            'nag',
            'naz',
            'nig',
            'nikk',
            'nogg',
            'nok',
            'nukk',
            'rag',
            'rak',
            'rat',
            'rok',
            'shrig',
            'shuk',
            'skrag',
            'skug',
            'slai',
            'slig',
            'slog',
            'sna',
            'snag',
            'snark',
            'snat',
            'snig',
            'snik',
            'snit',
            'sog',
            'spik',
            'stogg',
            'tog',
            'urf',
            'vark',
            'yad',
            'yagg',
            'yak',
            'yark',
            'yarp',
            'yig',
            'yip',
            'zat',
            'zib',
            'zit',
            'ziz'
        ],
        medium: [
            'ag',
            'aug',
            'bad',
            'bag',
            'bakh',
            'bash',
            'baz',
            'blag',
            'brag',
            'brog',
            'bruz',
            'dag',
            'dakk',
            'darg',
            'dob',
            'dog',
            'drab',
            'dug',
            'dur',
            'gash',
            'ghaz',
            'glakh',
            'glaz',
            'glob',
            'glol',
            'gluf',
            'glur',
            'gnarl',
            'gnash',
            'gnub',
            'gob',
            'gokh',
            'gol',
            'golk',
            'gor',
            'grakh',
            'grash',
            'grath',
            'graz',
            'grot',
            'grub',
            'grud',
            'gud',
            'gut',
            'hag',
            'hakk',
            'hrat',
            'hrog',
            'hrug',
            'khag',
            'khar',
            'krag',
            'krud',
            'lakh',
            'lash',
            'lob',
            'lub',
            'lud',
            'luf',
            'luk',
            'molk',
            'muk',
            'muz',
            'nar',
            'ogg',
            'olg',
            'rag',
            'rash',
            'rogg',
            'rorg',
            'rot',
            'rud',
            'ruft',
            'rug',
            'rut',
            'shad',
            'shag',
            'shak',
            'shaz',
            'shog',
            'skar',
            'skulg',
            'slur',
            'snar',
            'snorl',
            'snub',
            'snurr',
            'sod',
            'stulg',
            'thak',
            'trog',
            'ug',
            'umsh',
            'ung',
            'uth',
            'yakh',
            'yash',
            'yob',
            'zahk',
            'zog'
        ],
        large: [
            'argh',
            'barsh',
            'bog',
            'burz',
            'dof',
            'drok',
            'drub',
            'drug',
            'dub',
            'dug',
            'dul',
            'dursh',
            'dush',
            'duz',
            'faug',
            'fug',
            'ghakh',
            'ghar',
            'ghash',
            'ghol',
            'ghor',
            'ghukk',
            'ghul',
            'glub',
            'glud',
            'glug',
            'gluz',
            'gom',
            'grad',
            'grash',
            'grob',
            'grogg',
            'grok',
            'grol',
            'gru',
            'gruf',
            'gruk',
            'grul',
            'grum',
            'grumf',
            'grut',
            'gruz',
            'guhl',
            'gulv',
            'hai',
            'hrung',
            'hur',
            'hurg',
            'kai',
            'klob',
            'krod',
            'kug',
            'kulk',
            'kur',
            'lorg',
            'lug',
            'lukh',
            'lum',
            'lurz',
            'lush',
            'luz',
            'makh',
            'maug',
            'molg',
            'mud',
            'mug',
            'mul',
            'murk',
            'muzd',
            'nakh',
            'narg',
            'obb',
            'rolb',
            'rukh',
            'ruz',
            'sharg',
            'shruf',
            'shud',
            'shug',
            'shur',
            'shuz',
            'slub',
            'slud',
            'slug',
            'snad',
            'snog',
            'thrag',
            'thulk',
            'thurk',
            'trug',
            'ulg',
            'ur',
            'urd',
            'urgh',
            'urkh',
            'uz',
            'yug',
            'yur',
            'zud',
            'zug'
        ]
    },
    primitive: {
        names: [
            'ahg',
            'baod',
            'beegh',
            'bohr',
            'bul',
            'buli',
            'burh',
            'buri',
            'chah',
            'dhak',
            'digri',
            'dum',
            'eghi',
            'ehm',
            'faogh',
            'feehm',
            'ghad',
            'ghah',
            'gham',
            'ghan',
            'ghat',
            'ghaw',
            'ghee',
            'ghish',
            'ghug',
            'giree',
            'gonkh',
            'goun',
            'goush',
            'guh',
            'gunri',
            'hah',
            'hani',
            'haogh',
            'hatoo',
            'heghi',
            'heh',
            'hoo',
            'houm',
            'hree',
            'ig',
            'kham',
            'khan',
            'khaz',
            'khee',
            'khem',
            'khuri',
            'logh',
            'lugh',
            'maoh',
            'meh',
            'mogh',
            'mouh',
            'mugh',
            'naoh',
            'naroo',
            'nham',
            'nuh',
            'ob',
            'oli',
            'orf',
            'ough',
            'ouh',
            'peh',
            'pogh',
            'pugh',
            'puh',
            'quagi',
            'rahoo',
            'rhoo',
            'rifoo',
            'ronkh',
            'rouk',
            'saom',
            'saori',
            'shehi',
            'shlo',
            'shom',
            'shour',
            'shul',
            'snaoh',
            'suhi',
            'suth',
            'teb',
            'thom',
            'toudh',
            'tregh',
            'tuhli',
            'ub',
            'urush',
            'ush',
            'vuh',
            'wah',
            'wuh',
            'yaum',
            'yauth',
            'yeeh',
            'yih',
            'yuh',
            'zham'
        ],
        suffixes: [
            'doh',
            'rei',
            'mih',
            'fah',
            'soh',
            'lah',
            'tih',
            'daoh'
        ]
    },
    doughty: {
        syllables: [
            'bal',
            'durn',
            'na',
            'bord',
            'from',
            'nor',
            'born',
            'fror',
            'nord',
            'brim',
            'fuld',
            'orm',
            'brod',
            'fund',
            'skand',
            'brokk',
            'gim',
            'skond',
            'brom',
            'glo',
            'storn',
            'bru',
            'gond',
            'strom',
            'bur',
            'gord',
            'stur',
            'burl',
            'gorm',
            'sturl',
            'da',
            'grad',
            'sund',
            'dal',
            'grim',
            'thor',
            'dolg',
            'grod',
            'thorn',
            'dor',
            'grom',
            'thra',
            'dorm',
            'guld',
            'thro',
            'dral',
            'gund',
            'throl',
            'drim',
            'gur',
            'thror',
            'drom',
            'hord',
            'thru',
            'dur',
            'horn',
            'thrur',
            'durm',
            'hra',
            'thund'
        ],
        maleSuffixes: [
            'bor',
            'din',
            'in',
            'in',
            'in',
            'ir',
            'li',
            'li',
            'lin',
            'nir',
            'or',
            'ri',
            'ri',
            'rin',
            'rok',
            'ror',
            'rur',
            'vi',
            'vir',
            'vor'
        ],
        femaleSuffixes: [
            'bis',
            'da',
            'dis',
            'dis',
            'dis',
            'dis',
            'ga',
            'hild',
            'is',
            'is',
            'lif',
            'lind',
            'lis',
            'na',
            'nis',
            'ris',
            'rith',
            'run',
            'run',
            'vis'
        ]
    },
    homely: {
        syllables: [
            'ad',
            'blanc',
            'falc',
            'mil',
            'adel',
            'boff',
            'ferd',
            'mung',
            'adr',
            'bomb',
            'frob',
            'od',
            'ail',
            'bram',
            'fulb',
            'oth',
            'alb',
            'bung',
            'gam',
            'sab',
            'alm',
            'droc',
            'hald',
            'sam',
            'amb',
            'drog',
            'ham',
            'seg',
            'band',
            'durl',
            'hasc',
            'serl',
            'bard',
            'emm',
            'hod',
            'tob',
            'ben',
            'erd',
            'hug',
            'wan',
            'biff',
            'ern',
            'iv',
            'wig',
            'bild',
            'ever',
            'mark',
            'wyd'
        ],
        maleSuffixes: [
            'ald',
            'ard',
            'ert',
            'fast',
            'o',
            'o',
            'o',
            'o',
            'o',
            'old',
            'win',
            'wise'
        ],
        femaleSuffixes: [
            'a',
            'a',
            'a',
            'a',
            'a',
            'ia',
            'ia',
            'ice',
            'ily',
            'ina',
            'wina',
            'wisa'
        ]
    },
    familyName: {
        english: [
            'Adshead',
            'Akers',
            'Antell',
            'Applegarth',
            'Babb',
            'Babbs',
            'Baffin',
            'Bagg',
            'Baggett',
            'Bagnall',
            'Baldey',
            'Bamber',
            'Bark',
            'Barling',
            'Barnstable',
            'Barraclough',
            'Bastable',
            'Bastin',
            'Bather',
            'Batkin',
            'Batt',
            'Bazley',
            'Bebb',
            'Beddall',
            'Beeby',
            'Beecroft',
            'Beedell',
            'Bellis',
            'Belsey',
            'Berridge',
            'Besley',
            'Bibby',
            'Bickle',
            'Biddle',
            'Biddulph',
            'Bigg',
            'Binks',
            'Binns',
            'Bisp',
            'Biss',
            'Blenk',
            'Blenkin',
            'Boam',
            'Bobo',
            'Boddington',
            'Boffey',
            'Bonger',
            'Bonney',
            'Bonser',
            'Borrett',
            'Bossey',
            'Botterill',
            'Botting',
            'Bottom',
            'Bottomley',
            'Botwright',
            'Bowser',
            'Bracher',
            'Brasnett',
            'Brayley',
            'Breary',
            'Brickwood',
            'Brindley',
            'Broadfoot',
            'Broadribb',
            'Brocksopp',
            'Broster',
            'Buckmaster',
            'Budge',
            'Buffard',
            'Bugg',
            'Buggy',
            'Bulger',
            'Bulman',
            'Bunce',
            'Bunt',
            'Burrow',
            'Bushby',
            'Buss',
            'Cade',
            'Cadwaller',
            'Cantrill',
            'Cardno',
            'Catlow',
            'Cattermole',
            'Chaffe',
            'Chaffer',
            'Chard',
            'Chettle',
            'Chilcott',
            'Chitty',
            'Chivers',
            'Chubb',
            'Chugg',
            'Clewes',
            'Coaker',
            'Cobden',
            'Cobley',
            'Coggan',
            'Coggins',
            'Collop',
            'Coney',
            'Coote',
            'Copp',
            'Coppard',
            'Cornock',
            'Cossey',
            'Cottle',
            'Coultip',
            'Crang',
            'Crimp',
            'Croom',
            'Crowles',
            'Cubitt',
            'Cullimore',
            'Cuss',
            'Custance',
            'Cuthbert',
            'Dabbin',
            'Dabbing',
            'Dabbs',
            'Dagg',
            'Dainty',
            'Deeley',
            'Derrick',
            'Dibb',
            'Dibble',
            'Diccox',
            'Diggins',
            'Diggle',
            'Diggles',
            'Digweed',
            'Dimmock',
            'Dinsdale',
            'Dipple',
            'Dobbie',
            'Dobby',
            'Doggett',
            'Dorey',
            'Drabble',
            'Draycott',
            'Dring',
            'Drudge',
            'Duffield',
            'Dufty',
            'Duggan',
            'Duggleby',
            'Dumbrell',
            'Dunkley',
            'Eatwell',
            'Eggins',
            'Entwistle',
            'Erlam',
            'Etchells',
            'Fairclough',
            'Felgate',
            'Fensome',
            'Fenton',
            'Fidge',
            'Fidoe',
            'Figg',
            'Filer',
            'Fincham',
            'Firkins',
            'Flann',
            'Flanner',
            'Flippance',
            'Flook',
            'Flunder',
            'Followes',
            'Fooks',
            'Fremlin',
            'Frisby',
            'Frogley',
            'Frohock',
            'Froome',
            'Frow',
            'Fuggle',
            'Furse',
            'Furze',
            'Gabb',
            'Gaffey',
            'Gagg',
            'Gander',
            'Garbutt',
            'Garlick',
            'Garn',
            'Gazard',
            'Gedge',
            'Giblett',
            'Giddy',
            'Gigg',
            'Gilliat',
            'Gimble',
            'Gimson',
            'Ginger',
            'Gipps',
            'Girdler',
            'Gissing',
            'Gleave',
            'Goggin',
            'Gollogly',
            'Gomm',
            'Goodier',
            'Gook',
            'Gorringe',
            'Gorwyn',
            'Gosden',
            'Gribble',
            'Grigg',
            'Griggs',
            'Grill',
            'Grimble',
            'Grimes',
            'Grimshaw',
            'Grist',
            'Grubb',
            'Guckeen',
            'Guckian',
            'Guild',
            'Gull',
            'Gully',
            'Gumbold',
            'Gummer',
            'Gummidge',
            'Gurden',
            'Haffenden',
            'Hales',
            'Halse',
            'Harpham',
            'Hartle',
            'Hatch',
            'Hayhurst',
            'Hearle',
            'Henley',
            'Henwood',
            'Heppell',
            'Herrick',
            'Herring',
            'Hesketh',
            'Hext',
            'Hicken',
            'Hickmott',
            'Higman',
            'Hinchcliffe',
            'Hindmarsh',
            'Hobley',
            'Hoddy',
            'Hogben',
            'Holdom',
            'Hollick',
            'Holtom',
            'Honeysett',
            'Hook',
            'Hopley',
            'Hopps',
            'Horrocks',
            'Horsfall',
            'Horwood',
            'Hotten',
            'Housely',
            'Howie',
            'Huff',
            'Huffam',
            'Hutton',
            'Huxtable',
            'Icke',
            'Idden',
            'Inskip',
            'Iveson',
            'Izzard',
            'Jaggs',
            'Jellis',
            'Jepson',
            'Jesty',
            'Keel',
            'Keetley',
            'Kerkin',
            'Kerslake',
            'Kettley',
            'Killick',
            'Kinch',
            'Knaggs',
            'Kneebone',
            'Knopp',
            'Knott',
            'Lagden',
            'Laslett',
            'Laverick',
            'Leaper',
            'Leggett',
            'Liddane',
            'Liddy',
            'Liggan',
            'Lithgoe',
            'Lobb',
            'Lodder',
            'Looby',
            'Loody',
            'Lubbock',
            'Luff',
            'Lugard',
            'Lugg',
            'Lumsden',
            'Lyle',
            'Mabb',
            'Mabbitt',
            'Mabbot',
            'Mabbs',
            'Mabbutt',
            'Maffey',
            'Mallam',
            'Mangold',
            'Mapp',
            'Mappin',
            'Marfell',
            'Matthams',
            'Maunder',
            'Maxted',
            'Mayo',
            'Meech',
            'Meeson',
            'Meggison',
            'Meggitt',
            'Meggs',
            'Mellings',
            'Merrikin',
            'Metherell',
            'Mew',
            'Miggles',
            'Miggs',
            'Milsom',
            'Milson',
            'Minchin',
            'Minns',
            'Mobbs',
            'Moberly',
            'Mockler',
            'Mogford',
            'Mogg',
            'Moggs',
            'Morkam',
            'Morphett',
            'Mossman',
            'Mossop',
            'Mottershead',
            'Moulds',
            'Muddle',
            'Muddock',
            'Mudge',
            'Mullock',
            'Murch',
            'Murfin',
            'Murfitt',
            'Musson',
            'Mustill',
            'Mutter',
            'Mutton',
            'Nance',
            'Napper',
            'Neep',
            'Negus',
            'Netherway',
            'Newitt',
            'Niblett',
            'Nickless',
            'Noad',
            'Nobbs',
            'Noblet',
            'Nosworthy',
            'Nottage',
            'Nutt',
            'Offen',
            'Oram',
            'Orcutt',
            'Ord',
            'Orpe',
            'Paddock',
            'Paddon',
            'Pannell',
            'Parham',
            'Pavey',
            'Peay',
            'Peever',
            'Pegg',
            'Pegge',
            'Pegler',
            'Pegrum',
            'Pelly',
            'Pelter',
            'Pendle',
            'Petch',
            'Petcher',
            'Petchey',
            'Pettipher',
            'Philp',
            'Phippen',
            'Phippin',
            'Pickersgill',
            'Pickley',
            'Pickwell',
            'Pidduck',
            'Pigg',
            'Pilkington',
            'Pimblett',
            'Pingree',
            'Pinch',
            'Pinn',
            'Pither',
            'Pochin',
            'Poggs',
            'Polkinghorne',
            'Pomeroy',
            'Pomfret',
            'Postlethwaite',
            'Potticary',
            'Poxon',
            'Pring',
            'Pringle',
            'Prisk',
            'Proudfoot',
            'Puddicombe',
            'Pudding',
            'Puddy',
            'Pugsley',
            'Purslove',
            'Pym',
            'Quaife',
            'Quain',
            'Quenby',
            'Quibell',
            'Quigg',
            'Raddle',
            'Ranby',
            'Rapkins',
            'Ratter',
            'Reakes',
            'Reeson',
            'Riddle',
            'Rix',
            'Roddis',
            'Rosser',
            'Ruddle',
            'Ruffle',
            'Rugg',
            'Rumming',
            'Rump',
            'Sadd',
            'Samways',
            'Sankey',
            'Scantlebury',
            'Scoones',
            'Scouse',
            'Scragg',
            'Scrimgeour',
            'Scroggs',
            'Scruby',
            'Scutt',
            'Sefton',
            'Selth',
            'Semmens',
            'Seward',
            'Shalloo',
            'Sharples',
            'Siggers',
            'Sirett',
            'Skeels',
            'Skerrett',
            'Slee',
            'Sluggett',
            'Smedley',
            'Snoddy',
            'Snuggs',
            'Sparrow',
            'Sparrowhawke',
            'Spink',
            'Spinks',
            'Spriggs',
            'Springett',
            'Sproat',
            'Sprunt',
            'Spurle',
            'Spurrett',
            'Spurrier',
            'Squance',
            'Squarey',
            'Squibb',
            'Squirrel',
            'Staines',
            'Steggal',
            'Stelfox',
            'Stirk',
            'Stith',
            'Strag',
            'Straw',
            'Strutt',
            'Stubbins',
            'Stuppies',
            'Suggett',
            'Swaffer',
            'Swaffield',
            'Swarbrick',
            'Symes',
            'Tabor',
            'Tagg',
            'Tapping',
            'Tarr',
            'Tassell',
            'Teale',
            'Thew',
            'Thick',
            'Thornber',
            'Thwaites',
            'Tibbins',
            'Tibbits',
            'Tibbles',
            'Tibbotts',
            'Tink',
            'Tippell',
            'Tipping',
            'Tippins',
            'Tippling',
            'Tipton',
            'Tisser',
            'Tittmuss',
            'Tobitt',
            'Tonks',
            'Topping',
            'Towse',
            'Toye',
            'Tozer',
            'Trafford',
            'Treasure',
            'Tremlett',
            'Trett',
            'Trible',
            'Tricker',
            'Tripe',
            'Trippe',
            'Tripper',
            'Trist',
            'Troake',
            'Trotter',
            'Trouncer',
            'Trumble',
            'Tudge',
            'Tuffin',
            'Tufley',
            'Tulk',
            'Tully',
            'Tumman',
            'Tunks',
            'Tunnah',
            'Tunnicliffe',
            'Turnock',
            'Tween',
            'Tyrer',
            'Unsworth',
            'Uttley',
            'Varney',
            'Vooght',
            'Wackrill',
            'Waddilove',
            'Waddilow',
            'Walthew',
            'Waltho',
            'Walwin',
            'Wanless',
            'Wann',
            'Waple',
            'Waring',
            'Warrilow',
            'Welburn',
            'Wenden',
            'Werrett',
            'Wescott',
            'Whinnett',
            'Whiskard',
            'Whisker',
            'Whitefoot',
            'Whitlow',
            'Wibberley',
            'Widdicombe',
            'Widdows',
            'Widdup',
            'Wigg',
            'Wigley',
            'Wilberforce',
            'Wilmer',
            'Wintle',
            'Witherden',
            'Witney',
            'Witter',
            'Wolnoth',
            'Woodhead',
            'Wookey',
            'Woolland',
            'Woombill',
            'Worrel',
            'Worsley',
            'Wortley',
            'Wragg',
            'Wrixon',
            'Yeandle',
            'Yeend',
            'Yemm',
            'Yould'
        ],
        scottish: [
            'Aiken',
            'Aitken',
            'Baikie',
            'Baillie',
            'Bainbridge',
            'Baird',
            'Bairnsfeather',
            'Balios',
            'Balnaves',
            'Barbour',
            'Barclay',
            'Barrie',
            'Beattie',
            'Beilby',
            'Bell',
            'Bellenden',
            'Berwick',
            'Blackie',
            'Blackwood',
            'Blaikie',
            'Blair',
            'Bogue',
            'Boyce',
            'Braid',
            'Brechin',
            'Brisbane',
            'Brough',
            'Brougham',
            'Brown',
            'Brownlee',
            'Brymner',
            'Cairns',
            'Calderwood',
            'Candlish',
            'Cardus',
            'Cargill',
            'Caven',
            'Christison',
            'Clyde',
            'Cochran',
            'Cochrane',
            'Cockburn',
            'Colomb',
            'Crockett',
            'Cronin',
            'Cruden',
            'Cunningham',
            'Cushny',
            'Dalziel',
            'Deems',
            'Dempster',
            'Dinwiddie',
            'Doohan',
            'Doone',
            'Dunbar',
            'Dundas',
            'Dundee',
            'Dunn',
            'Dunning',
            'Eccles',
            'Eckford',
            'Edmonstone',
            'Elder',
            'Fairbairn',
            'Falconer',
            'Fenwick',
            'Ferrier',
            'Gairdner',
            'Galloway',
            'Galt',
            'Geddes',
            'Geikie',
            'Glass',
            'Glendon',
            'Graham',
            'Gregory',
            'Guthrie',
            'Haig',
            'Halkett',
            'Herdman',
            'Hogg',
            'Imey',
            'Inchbald',
            'Inglis',
            'Irvine',
            'Ivory',
            'Jebb',
            'Kerr',
            'Kircaldy',
            'Kirk',
            'Kirkbride',
            'Laird',
            'Laughlin',
            'Lawson',
            'Legge',
            'Lillie',
            'Lipton',
            'Lockhart',
            'Lorimer',
            'Lyall',
            'Lyte',
            'Masson',
            'Melrose',
            'Mill',
            'Miller',
            'Milligan',
            'Milner',
            'Moffat',
            'Mollison',
            'Moncrief',
            'Montrose',
            'Motherwell',
            'Muir',
            'Muirhead',
            'Murray',
            'Nairn',
            'Naysmith',
            'Nesbit',
            'Nisbet',
            "No\xebl",
            'Orchardson',
            'Pasley',
            'Paterson',
            'Pender',
            'Preston',
            'Primrose',
            'Pringle',
            'Quiller',
            'Raeburn',
            'Ransay',
            'Redpath',
            'Renfrew',
            'Rennie',
            'Renwick',
            'Sanderson',
            'Semphill',
            'Smiles',
            'Smollett',
            'Smybert',
            'Spenlove',
            'Sterling',
            'Stirling',
            'Strang',
            'Strange',
            'Strangeways',
            'Tait',
            'Tannahill',
            'Tassie',
            'Thom',
            'Tolmie',
            'Urquhart',
            'Wardlaw',
            'Wedderburn',
            'Whearty',
            'Wilkie',
            'Wiseheart',
            'Wishart',
            'Yarrow'
        ]
    },
    fairAndNoble: {
        elfPrefixes: [
            'an',
            'im',
            'ar',
            'in',
            'cal',
            'ir',
            'car',
            'ist',
            'cel',
            'lar',
            'cir',
            'lir',
            'clar',
            'lor',
            'el',
            'mar',
            'elb',
            'mel',
            'er',
            'mer',
            'erl',
            'mir',
            'est',
            'nim',
            'far',
            'nin',
            'fin',
            'nir',
            'gal',
            'ral',
            'gan',
            'ran',
            'gar',
            'rel',
            'gel',
            'ril',
            'gil',
            'rin',
            'ilm',
            'rim'
        ],
        alternativeElfPrefixes: [
            'aeg',
            'lith',
            'ael',
            'maeg',
            'aer',
            'mind',
            'aes',
            'mith',
            'aeth',
            'nith',
            'bel',
            'rael',
            'ber',
            'rind',
            'cael',
            'saer',
            'caer',
            'sar',
            'cris',
            'seld',
            'ear',
            'ser',
            'elth',
            'sil',
            'eol',
            'silm',
            'faer',
            'sind',
            'fean',
            'thael',
            'find',
            'thaer',
            'ith',
            'thal',
            'laeg',
            'thel',
            'lend',
            'ther',
            'lind',
            'thir'
        ],
        middle: [
            'ad',
            'al',
            'am',
            'an',
            'ar',
            'as',
            'eb',
            'ed',
            'el',
            'em',
            'en',
            'er',
            'es',
            'ev',
            'il',
            'in',
            'ir',
            'ol',
            'thal',
            'thon'
        ],
        maleSuffixes: [
            'ad',
            'dan',
            'del',
            'dil',
            'dir',
            'fal',
            'ion',
            'ion',
            'lad',
            'las',
            'lin',
            'nar',
            'or',
            'orn',
            'ras',
            'rior',
            'rod',
            'rond',
            'ros',
            'thir'
        ],
        femaleSuffixes: [
            'edel',
            'el',
            'eth',
            'ian',
            'iel',
            'iel',
            'ien',
            'loth',
            'mir',
            'rial',
            'rian',
            'riel',
            'riel',
            'rien',
            'ril',
            "ro\xebl",
            'sil',
            "w\xeb",
            'wen',
            'wen'
        ]
    },
    fairy: {
        prefixes: [
            'dex',
            'gliss',
            'tink',
            'flax',
            'goss',
            'tiss',
            'flim',
            'hex',
            'trill',
            'fliss',
            'liss',
            'trist',
            'flix',
            'min',
            'twill',
            'foss',
            'misk',
            'twiss',
            'frisk',
            'raff',
            'twisp',
            'friss',
            'ress',
            'twix',
            'gess',
            'riff',
            'weft',
            'glan',
            'rill',
            'wesk',
            'glax',
            'saff',
            'winn',
            'glim',
            'shim',
            'wisp'
        ],
        maleSuffixes: [
            'aldo',
            'allo',
            'amo',
            'ando',
            'aroll',
            'aron',
            'asto',
            'endo',
            'eroll',
            'eron',
            'esto',
            'ondo'
        ],
        femaleSuffixes: [
            'afer',
            'amer',
            'anel',
            'arel',
            'asti',
            'efer',
            'enti',
            'erel',
            'ifer',
            'imer',
            'inel',
            'irel'
        ]
    },
    alternateFairy: {
        prefixes: [
            'bris',
            'iphil',
            'opal',
            'cryl',
            'ispel',
            'oris',
            'elsi',
            'istle',
            'orif',
            'ember',
            'jat',
            'peri',
            'esk',
            'jost',
            'sarm',
            'feris',
            'jus',
            'sprin',
            'frimi',
            'lirra',
            'stith',
            'gan',
            'mali',
            'tansi',
            'glink',
            'mink',
            'tirra',
            'hal',
            'mirra',
            'trump',
            'hel',
            'mistle',
            'whis',
            'hist',
            'ninka',
            'zando'
        ],
        maleSuffixes: [
            'bik',
            'brix',
            'frell',
            'fret',
            'kin',
            'mist',
            'mit',
            'rix',
            'tross',
            'twik',
            'win',
            'zisk'
        ],
        femaleSuffixes: [
            'dee',
            'kiss',
            'la',
            'liss',
            'mee',
            'niss',
            'nyx',
            'ree',
            'riss',
            'sa',
            'tiss',
            'ynx'
        ]
    },
    elegantEvil: {
        prefixesDarkElves: [
            'bal',
            'myr',
            'ber',
            'ne',
            'char',
            'nel',
            'de',
            'nil',
            'div',
            'no',
            'dri',
            'nyl',
            'dul',
            'rel',
            'eil',
            'rha',
            'ek',
            'ru',
            'im',
            'sab',
            'ins',
            'sin',
            'ist',
            'sul',
            'jeg',
            'sus',
            'jer',
            'tel',
            'jys',
            'tul',
            'lil',
            'ver',
            'mar',
            'vil',
            'mer',
            'vir',
            'mez',
            'vril',
            'mor',
            'yas'
        ],
        prefixesAlternateDarkElves: [
            'bur',
            'olg',
            'chor',
            'on',
            'col',
            'or',
            'dol',
            'org',
            'dor',
            'oth',
            'drom',
            'pan',
            'dur',
            'pel',
            'en',
            'por',
            'er',
            'sek',
            'gon',
            'sol',
            'gul',
            'sun',
            'jend',
            'ten',
            'kil',
            'thal',
            'lul',
            'tor',
            'mab',
            'torm',
            'maz',
            'vek',
            'mol',
            'vol',
            'nor',
            'vor',
            'noth',
            'yel',
            'ol',
            'yol'
        ],
        middle: [
            'dyl',
            'el',
            'en',
            'er',
            'id',
            'il',
            'is',
            'lav',
            'len',
            'lev',
            'lin',
            'liv',
            'pel',
            'pir',
            'ra',
            'ral',
            'ril',
            'rin',
            'sin',
            'syl'
        ],
        maleSuffixes: [
            'ald',
            'eld',
            'id',
            'ild',
            'ird',
            'lim',
            'naz',
            'nid',
            'nil',
            'nim',
            'red',
            'rid',
            'rim',
            'riv',
            'ul',
            'uld',
            'vid',
            'vim',
            'vir',
            'viz'
        ],
        femaleSuffixes: [
            'bra',
            'dra',
            'dril',
            'ene',
            'hel',
            'ia',
            'il',
            'iln',
            'ira',
            'istra',
            'ith',
            'iza',
            'lin',
            'na',
            'ra',
            'rin',
            'sil',
            'tra',
            'vra',
            'vril'
        ]
    },
    malevolent: {
        prefixes: [
            'aag',
            'karg',
            'ulthu',
            'alur',
            'khark',
            'urz',
            'arak',
            'krau',
            'uti',
            'az',
            'kriv',
            'uznid',
            'azik',
            'kuaz',
            'virn',
            'bral',
            'kudu',
            'vlaaj',
            'braz',
            'luri',
            'vlag',
            'bruh',
            'mulk',
            'vlash',
            'draan',
            'nau',
            'vluk',
            'drulg',
            'nid',
            'vluzak',
            'guz',
            'ninj',
            'vraz',
            'haug',
            'nul',
            'vulk',
            'idru',
            'nym',
            'xau',
            'jhaal',
            'ranag',
            'xid',
            'jid',
            'rilthu',
            'xul',
            'jiu',
            'ruk',
            'xuraj',
            'jur',
            'rulk',
            'zauv',
            'jurg',
            'ruz',
            'zug',
            'jurz',
            'saag',
            'zuldu',
            'kaaz',
            'skaur',
            'zuv'
        ],
        maleSuffixes: [
            'arag',
            'bru',
            'drul',
            'inu',
            'lank',
            'lun',
            'lurr',
            'lurug',
            'nal',
            'rul',
            'ruzuk',
            'salk',
            'sul',
            'suruk',
            'ull',
            'undak',
            'uvik',
            'xulg',
            'zu',
            'zuk'
        ],
        femaleSuffixes: [
            'anil',
            'bau',
            'diu',
            'dusla',
            'giu',
            'ija',
            'izil',
            'jiul',
            'lihyl',
            'lin',
            'lyrr',
            'nalu',
            'rhyl',
            'rula',
            'skiu',
            'sula',
            'ulla',
            'xhiu',
            'zihyl',
            'ziu'
        ]
    },
    draconic: {
        prefixes: [
            'abra',
            'har',
            'phrixu',
            'adastra',
            'helio',
            'porphyro',
            'adra',
            'huro',
            'pyra',
            'anca',
            'iul',
            'rhada',
            'andra',
            'jalan',
            'rhe',
            'arag',
            'jarzem',
            'rhodo',
            'archo',
            'jazra',
            'rau',
            'atra',
            'jurga',
            'sar',
            'bar',
            'keruxa',
            'sarcu',
            'bara',
            'kralka',
            'sarda',
            'beru',
            'lazulo',
            'scarva',
            'bhakri',
            'majuri',
            'sidereo',
            'bia',
            'malacho',
            'skhia',
            'bra',
            'mar',
            'sulchru',
            'brado',
            'marmora',
            'tchalcedo',
            'brima',
            'melkar',
            'tchazar',
            'cadra',
            'orgra',
            'trocho',
            'chro',
            'ouro',
            'vra',
            'chryso',
            'perido',
            'zalar',
            'glau',
            'phoro',
            'zerul'
        ],
        suffixes: [
            'bazius',
            'boros',
            'bradax',
            'calchax',
            'cordax',
            'lagon',
            'malax',
            'mandros',
            'manthys',
            'mordax',
            'nadral',
            'nalux',
            'neriax',
            'phylax',
            'vorax',
            'vorung',
            'xenor',
            'zuthrax',
            'zzebrax',
            'zzemal'
        ]
    },
    infernal: {
        softs: [
            'alu',
            'alz',
            'avu',
            'azaz',
            'baph',
            'baz',
            'cha',
            'fraz',
            'garl',
            'garu',
            'gla',
            'hra',
            'mal',
            'nahu',
            'nal',
            'nasu',
            'paz',
            'raz',
            'tha',
            'thalu',
            'bre',
            'dre',
            'gel',
            'gle',
            'gre',
            'hez',
            'rez',
            'rezu',
            'tze',
            'gzi',
            'hriz',
            'hzi',
            'idrau',
            'itha',
            'ixu',
            'lilu',
            'riz',
            'yil',
            'dromu',
            'gro',
            'lol',
            'moz',
            'olth',
            'oxu',
            'sco',
            'tho',
            'bu',
            'bul',
            'buz',
            'chru',
            'dru',
            'ghu',
            'gura',
            'guz',
            'hruz',
            'huz',
            'kul',
            'lurhz',
            'muz',
            'ru',
            'shu',
            'ssu',
            'szul',
            'thu',
            'ulchru',
            'utu',
            'vul',
            'zu',
            'zul',
            'baal',
            'ghaa',
            'kraa',
            'phaal',
            'raal',
            'saa',
            'bial',
            'oazo',
            'soaz',
            'ruaz',
            'gya',
            'yaa',
            'bael',
            'nee',
            'ziel',
            'yee',
            'aiaz',
            'shai',
            'reoz',
            'duoi',
            'drau',
            'ghau',
            'glau',
            'mau',
            'sau',
            'tzau',
            'iuz',
            'juu',
            'rhuu',
            'vuul',
            'zuu'
        ],
        dulls: [
            'agh',
            'alg',
            'barg',
            'chag',
            'ghad',
            'glab',
            'grag',
            'hrag',
            'kag',
            'kwarg',
            'mag',
            'nalb',
            'sag',
            'tharg',
            'brelg',
            'dergh',
            'dregh',
            'drelb',
            'felg',
            'heg',
            'kleg',
            'igg',
            'rigg',
            'blog',
            'drog',
            'grolb',
            'kolg',
            'krolg',
            'lolg',
            'mog',
            'morg',
            'nog',
            'obb',
            'ogg',
            'olb',
            'rogg',
            'strog',
            'thog',
            'trob',
            'tzolg',
            'vogt',
            'bub',
            'bulg',
            'druj',
            'durg',
            'frub',
            'fulg',
            'gub',
            'hrud',
            'hurg',
            'jub',
            'julb',
            'nud',
            'nug',
            'nulb',
            'rung',
            'shub',
            'stug',
            'sug',
            'szug',
            'trulg',
            'ulb',
            'urb',
            'vub',
            'vulb',
            'xub',
            'zub',
            'zug',
            'zugt',
            'aab',
            'aag',
            'glaag',
            'haag',
            'naag',
            'raag',
            'boaj',
            'moab',
            'uag',
            'leegh',
            'yeb',
            'yeeg',
            'aig',
            'yibb',
            'iog',
            'droog',
            'nyog',
            'aug',
            'baug',
            'daurg',
            'draug',
            'gaub',
            'laug',
            'maug',
            'naug',
            'raug',
            'saug',
            'thaug',
            'iub',
            'iug',
            'ruug'
        ],
        sharps: [
            'ach',
            'akk',
            'ash',
            'azt',
            'bahor',
            'bar',
            'bas',
            'brax',
            'charn',
            'dak',
            'hrax',
            'lach',
            'lazt',
            'mat',
            'nam',
            'nazt',
            'ralk',
            'rhast',
            'sark',
            'slarv',
            'tash',
            'thak',
            'thalur',
            'thalk',
            'vach',
            'vap',
            'dek',
            'ech',
            'fesh',
            'gek',
            'hrek',
            'lech',
            'met',
            'ner',
            'ter',
            'blik',
            'gith',
            'igm',
            'inax',
            'irsch',
            'kir',
            'lis',
            'lisk',
            'lith',
            'nilv',
            'nirr',
            'tlizit',
            'bor',
            'chon',
            'goch',
            'gor',
            'goth',
            'hoth',
            'khor',
            'kos',
            'loch',
            'lok',
            'loth',
            'moch',
            'moth',
            'noc',
            'och',
            'oth',
            'rolk',
            'roth',
            'sot',
            'soth',
            'vrok',
            'dun',
            'gur',
            'hun',
            'luth',
            'muth',
            'nur',
            'rutt',
            'sut',
            'sutt',
            'szut',
            'tur',
            'urt',
            'utuk',
            'uzt',
            'krych',
            'nyth',
            'slyth',
            'gaan',
            'xaas',
            'boak',
            'ruaak',
            'yalm',
            'haerx',
            'iex',
            'draum',
            'gaur',
            'glaur',
            'rauk',
            'saur',
            'duum',
            'nuur',
            'ruun'
        ]
    },
    empyreal: {
        prefixes: [
            'adan',
            'asan',
            'jasan',
            'palant',
            'sarnat',
            'valmar',
            'adrast',
            'asarn',
            'jasarm',
            'palor',
            'solar',
            'valnar',
            'alant',
            'astar',
            'javral',
            'raman',
            'talan',
            'valnor',
            'amad',
            'atar',
            'kalad',
            'ranal',
            'talar',
            'valon',
            'aman',
            'atlan',
            'kalar',
            'ranar',
            'talas',
            'valor',
            'amar',
            'avar',
            'kalas',
            'rasan',
            'talon',
            'vanar',
            'amars',
            'avlant',
            'kalast',
            'ravan',
            'taran',
            'varal',
            'amart',
            'avral',
            'kasal',
            'samar',
            'taval',
            'varam',
            'ansam',
            'jalan',
            'katarn',
            'saran',
            'valant',
            'varan',
            'arad',
            'jalkar',
            'kaval',
            'sarat',
            'valar',
            'varat',
            'aram',
            'jaran',
            'klaron',
            'sardan',
            'valdor',
            'vardar',
            'aran',
            'jasal',
            'palad',
            'sardar',
            'valkar',
            'voltar'
        ],
        maleSuffixes: [
            'al',
            'an',
            'ar',
            'as',
            'at',
            'ath',
            'ath',
            'ath',
            'anth',
            'athal',
            'athar',
            'athas'
        ],
        femaleSuffixes: [
            'el',
            'en',
            'er',
            'es',
            'et',
            'eth',
            'eth',
            'eth',
            'enth',
            'eleth',
            'ereth',
            'eseth'
        ],
        titles: [
            'ar-',
            'sar-',
            'tar-',
            'var-',
            'jal-',
            'kal-',
            'pal-',
            'ral-',
            'tal-'
        ]
    },
    human: {
        one: [
            'Aind',
            'Ainn',
            'Airk',
            'Aitze',
            'Ald',
            'Ance',
            'Anxe',
            'Ard',
            'Ashf',
            'Aulg',
            'Aun',
            'Aure',
            'Authe',
            'Baelt',
            'Bakh',
            'Bal',
            'Balt',
            'Balthe',
            'Barg',
            'Barll',
            'Bauce',
            'Baysc',
            'Beek',
            'Beele',
            'Berl',
            'Bersch',
            'Beyn',
            'Bhozt',
            'Birme',
            'Birr',
            'Bjanc',
            'Blaen',
            'Blize',
            'Blouch',
            'Blurk',
            'Blynze',
            'Bokk',
            'Borl',
            'Borse',
            'Brahl',
            'Brakk',
            'Bralk',
            'Brang',
            'Brann',
            'Branth',
            'Brem',
            'Bress',
            'Breun',
            'Briint',
            'Brill',
            'Brize',
            'Brod',
            'Broik',
            'Brolt',
            'Bront',
            'Broozh',
            'Brosck',
            'Broud',
            'Brud',
            'Brule',
            'Brun',
            'Bulse',
            'Bunth',
            'Byar',
            'Byst',
            'Caer',
            'Cail',
            'Canth',
            'Carn',
            'Cayrl',
            'Ceyt',
            'Chaeng',
            'Chail',
            'Chaith',
            'Chal',
            'Chalm',
            'Charg',
            'Charn',
            'Chave',
            'Chayle',
            'Chaze',
            'Cheal',
            'Cheev',
            'Chel',
            'Chern',
            'Cherze',
            'Chezl',
            'Chilk',
            'Chlenk',
            'Choalg',
            'Choje',
            'Chor',
            'Chorl',
            'Chorsk',
            'Chounce',
            'Chraq',
            'Chrarr',
            'Chrem',
            'Chrent',
            'Chriyb',
            'Chroad',
            'Chud',
            'Chuz',
            'Claed',
            'Clart',
            'Clesh',
            'Cloup',
            'Clour',
            'Clowr',
            'Coll',
            'Corb',
            'Corje',
            'Corm',
            'Corme',
            'Crade',
            'Creeg',
            'Croold',
            'Croyn',
            'Cthon',
            'Cush',
            'Daalx',
            'Dahr',
            'Daig',
            'Dal',
            'Darm',
            'Darsh',
            'Darze',
            'Dashf',
            'Dask',
            'Datz',
            'Daug',
            'Dawl',
            'Deelth',
            'Deerch',
            'Derd',
            'Derle',
            'Dest',
            'Deuth',
            'Dex',
            'Dhaant',
            'Dherl',
            'Dhoul',
            'Dhuul',
            'Dhuur',
            'Dinz',
            'Dlak',
            'Dlask',
            'Dlir',
            'Doag',
            'Dolc',
            'Dorse',
            'Dralg',
            'Dram',
            'Dran',
            'Drance',
            'Drath',
            'Drax',
            'Draygg',
            'Dreact',
            'Dreed',
            'Dreeg',
            'Dreen',
            'Dreev',
            'Drelm',
            'Drelth',
            'Drerle',
            'Drewm',
            'Drilm',
            'Drinn',
            'Drism',
            'Drissth',
            'Drix',
            'Droale',
            'Drojj',
            'Drom',
            'Droxe',
            'Droy',
            'Drun',
            'Drust',
            'Druuth',
            'Dryle',
            'Drynn',
            'Drythe',
            'Dvarch',
            'Dwesk',
            'Dzairn',
            'Dzij',
            'Dzym',
            'Eeb',
            'Eenthe',
            'Elb',
            'Emp',
            'Ence',
            'Ench',
            'Eng',
            'Enz',
            'Ept',
            'Erd',
            'Esk',
            'Faig',
            'Falthe',
            'Fanch',
            'Faoth',
            'Fard',
            'Faum',
            'Faz',
            'Feant',
            'Feej',
            'Felg',
            'Fernsh',
            'Fesk',
            'Fess',
            'Feth',
            'Fimth',
            'Fize',
            'Flast',
            'Flatch',
            'Flayre',
            'Flerd',
            'Flersh',
            'Flisp',
            'Florn',
            'Fompt',
            'Fousk',
            'Fraine',
            'Frakk',
            'Fralg',
            'Frast',
            'Fregg',
            'Frem',
            'Fresk',
            'Fretch',
            'Frex',
            'Frike',
            'Frile',
            'Frism',
            'Frold',
            'Frone',
            'Fronx',
            'Frook',
            'Frool',
            'Froy',
            'Frush',
            'Fryx',
            'Fulm',
            'Fyahn',
            'Fyast',
            'Fyorb',
            'Fzek',
            'Fzron',
            'Gair',
            'Galthz',
            'Gand',
            'Gane',
            'Gann',
            'Gart',
            'Gath',
            'Gault',
            'Gawle',
            'Gax',
            'Genze',
            'Gerd',
            'Gez',
            'Gharl',
            'Ghea',
            'Ghenz',
            'Ghorl',
            'Ghorx',
            'Gilft',
            'Gilm',
            'Gire',
            'Glaar',
            'Glain',
            'Glarch',
            'Glaux',
            'Gleeth',
            'Gleev',
            'Gleft',
            'Glekke',
            'Glem',
            'Glice',
            'Glip',
            'Glish',
            'Glith',
            'Gloard',
            'Gloob',
            'Gloorsh',
            'Glosk',
            'Glund',
            'Glyre',
            'Glyth',
            'Gnarre',
            'Golm',
            'Gond',
            'Gorm',
            'Gosp',
            'Goste',
            'Graal',
            'Grall',
            'Greel',
            'Greeld',
            'Greelp',
            'Grend',
            'Grilf',
            'Grimp',
            'Groad',
            'Grond',
            'Groolsh',
            'Gruon',
            'Grux',
            'Gthuu',
            'Gurze',
            'Gwisp',
            'Gwith',
            'Gwosk',
            'Gyorr',
            'Gyz',
            'Haag',
            'Haar',
            'Haask',
            'Hade',
            'Hadj',
            'Halk',
            'Halm',
            'Hane',
            'Harb',
            'Harch',
            'Harg',
            'Harx',
            'Hauke',
            'Haux',
            'Hawlx',
            'Hax',
            'Heerf',
            'Hersh',
            'Hetz',
            'Hezz',
            'Hisk',
            'Hize',
            'Hjorr',
            'Hlare',
            'Hlor',
            'Hoag',
            'Hob',
            'Horl',
            'Horm',
            'Hosh',
            'Hraak',
            'Hrailk',
            'Hreen',
            'Hrine',
            'Hroon',
            'Hrume',
            'Hruse',
            'Huxx',
            'Hythe',
            'Ingg',
            'Jaarge',
            'Jad',
            'Jaerth',
            'Jaig',
            'Jairn',
            'Jal',
            'Jalth',
            'Jance',
            'Jand',
            'Jant',
            'Janx',
            'Jard',
            'Jark',
            'Jarn',
            'Jask',
            'Jath',
            'Jauce',
            'Jaus',
            'Jauth',
            'Jaze',
            'Jeel',
            'Jekk',
            'Jend',
            'Jenx',
            'Jerd',
            'Jern',
            'Jexx',
            'Jhang',
            'Jhaulk',
            'Jhor',
            'Jhure',
            'Jinch',
            'Jind',
            'Jinz',
            'Jirle',
            'Joorm',
            'Jorm',
            'Jorn',
            'Jrond',
            'Jurze',
            'Jusk',
            'Juzz',
            'Jyfe',
            'Jyin',
            'Kaerr',
            'Kaid',
            'Kal',
            'Kamn',
            'Kand',
            'Kang',
            'Kank',
            'Karn',
            'Karth',
            'Karze',
            'Kaune',
            'Kedj',
            'Keek',
            'Keig',
            'Kell',
            'Kelph',
            'Kerce',
            'Kerm',
            'Kerst',
            'Kesp',
            'Keth',
            'Kez',
            'Khaiz',
            'Khal',
            'Khand',
            'Kharb',
            'Kharsp',
            'Khern',
            'Khif',
            'Khond',
            "Kh\xf4r",
            'Khorst',
            'Khrev',
            'Kinch',
            'Kish',
            'Kiv',
            'Kjeld',
            'Klaff',
            'Klaz',
            'Kleed',
            'Kloob',
            'Kloohn',
            'Klyne',
            'Kmool',
            'Knaar',
            'Knut',
            'Kolff',
            'Kolg',
            'Konv',
            'Koss',
            'Koul',
            'Krake',
            'Krall',
            'Kranj',
            'Krax',
            'Kreel',
            'Krej',
            'Kremp',
            'Krey',
            'Krile',
            'Krinch',
            'Kroff',
            'Kroll',
            'Krompf',
            'Kuest',
            'Kull',
            'Kulm',
            'Kuon',
            'Kuum',
            'Kvon',
            'Kwask',
            'Kwaz',
            'Kyre',
            'Lach',
            'Laev',
            'Lan',
            'Lantz',
            'Larnste',
            'Lartz',
            'Laur',
            'Lawrg',
            'Layje',
            'Leet',
            'Lenx',
            'Leth',
            'Liln',
            'Liss',
            'Lod',
            'Loec',
            'Lonn',
            'Loord',
            'Loosk',
            'Lound',
            'Luhr',
            'Lumbb',
            'Lurs',
            'Lyrr',
            'Lysk',
            'Maarth',
            'Maec',
            'Maelv',
            'Magh',
            'Mald',
            'Mant',
            'Manth',
            'Mantz',
            'Marb',
            'Mard',
            'Mayxe',
            'Meand',
            'Meeth',
            'Melg',
            'Meln',
            'Merrt',
            'Merzh',
            'Mesp',
            'Mirsp',
            'Mirx',
            'Miskt',
            "Ml\xf6",
            'Mointh',
            'Mool',
            'Moork',
            'Moorthe',
            'Mord',
            'Morl',
            'Moskt',
            'Mox',
            'Mulse',
            'Murlk',
            'Murste',
            'Myrrhne',
            'Naall',
            'Naar',
            'Naaz',
            'Naer',
            'Naik',
            'Naine',
            'Nairx',
            'Nalm',
            'Nanx',
            'Naois',
            'Naphk',
            'Nar',
            'Narct',
            'Narrm',
            'Naulk',
            'Naxx',
            'Naze',
            'Nelq',
            'Nem',
            'Nemn',
            'Nerrz',
            'Ngal',
            'Nime',
            'Nirft',
            'Nisp',
            'Nithe',
            'Noerth',
            'Nolgh',
            'Nool',
            'Noom',
            'Norb',
            'Norle',
            'Noth',
            'Nraeve',
            'Nulth',
            'Nurb',
            'Nuss',
            'Nyalg',
            'Nyalk',
            'Nym',
            'Nynx',
            'Olth',
            'Omm',
            'Omn',
            'Ooon',
            'Ord',
            'Orld',
            'Ornce',
            'Oth',
            'Ounde',
            'Ourne',
            'Paaz',
            'Palch',
            'Parn',
            'Parth',
            'Parzt',
            'Path',
            'Pelk',
            'Pell',
            'Pesm',
            'Phad',
            'Phairn',
            'Phant',
            'Phlarn',
            'Phong',
            'Photz',
            'Phral',
            'Phul',
            'Pirz',
            'Pjanth',
            'Plange',
            'Plaz',
            'Plegg',
            'Plind',
            'Plomb',
            'Plorze',
            'Plumf',
            'Pluun',
            'Pnidd',
            'Poile',
            'Pome',
            'Pould',
            'Praige',
            'Presk',
            'Prike',
            'Prokk',
            'Prook',
            'Prya',
            'Pryle',
            'Prynne',
            'Psarn',
            'Ptenx',
            'Pulge',
            'Pume',
            'Quaan',
            'Quaar',
            'Quagh',
            'Quaild',
            'Quaisth',
            'Qual',
            'Qualt',
            'Quanst',
            'Quanz',
            'Quaoph',
            'Quarl',
            'Quast',
            'Quech',
            'Qued',
            'Quelg',
            'Quelm',
            'Querk',
            'Quigg',
            'Quilg',
            'Quol',
            'Quonj',
            'Quool',
            'Quorze',
            'Quune',
            'Quynd',
            'Raask',
            'Rahm',
            'Raine',
            'Raisth',
            'Ralce',
            'Rald',
            'Rast',
            'Raunt',
            'Raupt',
            'Rax',
            'Raxt',
            'Rayche',
            'Raz',
            'Reelce',
            'Reendt',
            'Relth',
            'Relz',
            'Rez',
            'Rhath',
            'Rhaze',
            'Rhiss',
            'Rhom',
            'Rhorn',
            'Rhyll',
            'Rifk',
            'Rilm',
            'Rilx',
            'Rimsk',
            'Rimth',
            'Riss',
            'Rith',
            'Rix',
            'Rodr',
            'Rodst',
            'Roen',
            'Rogg',
            'Rolm',
            'Rolx',
            'Roult',
            'Rull',
            'Rulm',
            'Rult',
            'Rumche',
            'Runce',
            'Ruor',
            'Ruusque',
            'Ruz',
            'Ryke',
            'Rynx',
            'Ryond',
            'Rythe',
            'Saar',
            'Saech',
            'Saedd',
            'Sairgh',
            'San',
            'Sange',
            'Sarg',
            'Sark',
            'Sarl',
            'Sarn',
            'Sarpt',
            'Skroine',
            'Scroot',
            'Scrylte',
            'Scryme',
            'Sculp',
            'Scuss',
            'Scyrth',
            'Sdor',
            'Seelt',
            'Seif',
            'Sen',
            'Senthe',
            'Sfite',
            'Shad',
            'Shar',
            'Sharg',
            'Sharm',
            'Sharn',
            'Sheb',
            'Sheel',
            'Shenn',
            'Shenx',
            'Sherth',
            'Shilm',
            'Shind',
            'Shont',
            'Shren',
            'Shune',
            'Shurm',
            'Shuuth',
            'Shyang',
            'Skarn',
            'Skart',
            'Skeen',
            'Skerr',
            'Skorle',
            'Skraf',
            'Skrafe',
            'Skrib',
            'Skrift',
            'Skroi',
            'Skyre',
            'Slaar',
            'Slanc',
            'Slark',
            'Slarm',
            'Slask',
            'Slaunce',
            'Slaur',
            'Sleer',
            'Slemt',
            'Slike',
            'Slith',
            'Sloif',
            'Slorg',
            'Slorn',
            'Sluff',
            'Slynd',
            'Smeke',
            'Smete',
            'Smink',
            'Smold',
            'Snabe',
            'Snard',
            'Snarr',
            'Sneath',
            'Snurch',
            'Soick',
            'Solm',
            'Sool',
            'Soorve',
            'Sorl',
            'Sorm',
            'Sorn',
            'Sosz',
            'Sounx',
            'Sparll',
            'Splynd',
            'Sprake',
            'Squalj',
            'Sran',
            'Srend',
            'Sroon',
            'Stalb',
            'Starl',
            'Stelk',
            'Strangg',
            'Strix',
            'Strom',
            'Strowl',
            'Stuhr',
            'Styche',
            'Styre',
            'Suntz',
            'Suule',
            'Suusht',
            'Svinse',
            'Swaerk',
            'Swyst',
            'Syle',
            'Syoll',
            'Taede',
            'Tael',
            'Tak',
            'Tal',
            'Tanj',
            'Targ',
            'Targh',
            'Tark',
            'Tarl',
            'Tath',
            'Taus',
            'Tavv',
            'Taze',
            'Tchel',
            'Tcherm',
            'Tchoum',
            'Tebs',
            'Teelk',
            'Teern',
            'Teirn',
            'Telg',
            'Telk',
            'Terb',
            'Terre',
            'Tez',
            'Thaad',
            'Thaarn',
            'Thad',
            'Thaed',
            'Tham',
            'Thand',
            'Thang',
            'Thapp',
            'Thard',
            'Thark',
            'Thask',
            'Thaugh',
            'Thaum',
            'Thaurn',
            'Thawn',
            'Thax',
            'Theed',
            'Thesk',
            'Thevv',
            'Theyz',
            'Thirrf',
            'Tholk',
            'Thorm',
            'Thosk',
            'Thoure',
            'Thrak',
            'Thralf',
            'Thrand',
            'Thrasp',
            'Thrawl',
            'Thrawn',
            'Thrax',
            'Thrilce',
            'Thrizz',
            'Throck',
            'Thromb',
            'Throsp',
            'Thull',
            'Thuu',
            "Tl\xf6n",
            'Toal',
            'Tog',
            'Tol',
            'Tolg',
            'Tolm',
            'Tooz',
            'Torb',
            'Torje',
            'Torm',
            'Torr',
            'Torsk',
            'Torth',
            'Trahl',
            'Treel',
            'Treesk',
            'Trell',
            'Trem',
            'Treys',
            'Trild',
            'Trilse',
            'Trinx',
            'Trojj',
            'Tronf',
            'Trost',
            'Troyne',
            'Trulm',
            'Tsai',
            'Tsang',
            'Tselm',
            'Tsleg',
            'Tspoy',
            'Tsrome',
            'Tthann',
            'Tull',
            'Tvash',
            'Twez',
            'Twillx',
            'Tyae',
            'Tyfe',
            'Tyog',
            'Tzank',
            'Tzoy',
            'Ulm',
            'Urst',
            'Vaar',
            'Vaersl',
            'Vaist',
            'Valg',
            'Valtch',
            'Vand',
            'Vansh',
            'Var',
            'Vard',
            'Varl',
            'Vask',
            'Vass',
            'Vath',
            'Vaulx',
            'Vaus',
            'Vaxx',
            'Vayze',
            'Veb',
            'Veed',
            'Veeth',
            'Vegg',
            'Vek',
            'Velb',
            'Venk',
            'Venth',
            'Verle',
            'Vesp',
            'Veth',
            'Vilt',
            'Vipt',
            'Virl',
            'Virx',
            'Visk',
            'Viss',
            'Vist',
            'Vith',
            'Vlack',
            'Vlax',
            'Vleft',
            'Vloongh',
            'Vohm',
            'Volg',
            'Vool',
            'Voon',
            'Voor',
            'Vor',
            'Vorg',
            'Vorl',
            'Vorque',
            'Vorse',
            'Vort',
            'Vrahk',
            'Vrain',
            'Vramp',
            'Vreng',
            'Vrilx',
            'Vrosk',
            'Vroyce',
            'Vuul',
            'Wertz',
            'Wheld',
            'Whimk',
            'Whirx',
            'Whoord',
            'Wix',
            'Woise',
            'Wome',
            'Woorn',
            'Worrb',
            'Wrahz',
            'Wraime',
            'Wrax',
            'Wrhye',
            'Wrold',
            'Wrost',
            'Wurlp',
            'Wyast',
            'Wye',
            'Wynv',
            'Wyrn',
            'Xaayr',
            'Xaen',
            'Xaif',
            'Xain',
            'Xalm',
            'Xan',
            'Xarle',
            'Xas',
            'Xau',
            'Xean',
            'Xelb',
            'Xenve',
            'Xerth',
            'Xill',
            'Xin',
            'Xinsce',
            'Xis',
            'Xive',
            'Xix',
            'Xord',
            'Xoth',
            'Xush',
            'Xyle',
            'Xysc',
            'Yad',
            'Yagre',
            'Yaim',
            'Yand',
            'Yarl',
            'Yauce',
            'Yeb',
            'Yeerk',
            'Yend',
            'Yenj',
            'Yest',
            'Yhalm',
            'Yhe',
            'Yhem',
            'Yifth',
            'Yilb',
            'Yivv',
            'Yoort',
            'Yoth',
            'Yrr',
            'Yund',
            'Yush',
            'Yuun',
            'Zaar',
            'Zahn',
            'Zaidh',
            'Zaift',
            'Zaile',
            'Zaive',
            'Zand',
            'Zanq',
            'Zao',
            'Zaon',
            'Zaoth',
            'Zar',
            'Zash',
            'Zeft',
            'Zeige',
            'Zek',
            'Zell',
            'Zelm',
            'Zelth',
            'Zend',
            'Zha',
            'Zhash',
            'Zhayce',
            'Zherl',
            'Zhirth',
            'Zhool',
            'Zhorm',
            'Zhuul',
            'Zil',
            'Zilge',
            'Zinn',
            'Zixt',
            'Zlante',
            'Zlaque',
            'Zlar',
            'Zold',
            'Zook',
            'Zool',
            'Zoor',
            'Zor',
            'Zorl',
            'Zorn',
            'Zoth',
            'Zoul',
            'Zreethe',
            'Zull',
            'Zusque',
            'Zwerl',
            'Zynx',
            'Zyx'
        ],
        two: [
            'Aahdret',
            'Aarlen',
            'Aasren',
            'Aastrasl',
            'Aban',
            'Abbith',
            'Ablif',
            'Aboas',
            'Abrance',
            'Abrax',
            'Abryn',
            'Abyok',
            'Acear',
            'Acfyst',
            'Achekk',
            'Achelse',
            'Achlarg',
            'Achren',
            'Achriss',
            'Ackvold',
            'Acram',
            'Acu',
            'Adaon',
            'Addanc',
            'Adeil',
            'Adire',
            'Adlay',
            'Adlen',
            'Adlon',
            'Admel',
            'Adoin',
            'Adon',
            'Adrek',
            'Adreln',
            'Adrich',
            'Adrilc',
            'Adurthe',
            'Aduush',
            'Aealim',
            'Aeddan',
            'Aedha',
            'Aedir',
            'Aedlynx',
            'Aeiran',
            'Aelis',
            'Aelma',
            'Aemon',
            'Aenet',
            'Aenthu',
            'Aeprox',
            'Aeren',
            'Aerind',
            'Aerkoon',
            'Aerkour',
            'Aerlithe',
            'Aeron',
            'Aeryle',
            'Aethlyr',
            'Aethon',
            'Afenk',
            'Affraig',
            'Afraaj',
            'Agburz',
            'Ageen',
            'Aghil',
            'Aghill',
            'Aglin',
            'Agroth',
            'Agwyn',
            'Agyorl',
            "Ahmr\xe9",
            'Aia',
            'Aiaia',
            'Aibmab',
            'Aidajn',
            'Aiden',
            'Aidon',
            'Aigol',
            'Ailcaer',
            "Aink\xe9",
            'Ainzu',
            'Airmid',
            'Aislinn',
            'Aislithe',
            'Aiza',
            'Aizan',
            'Ajaak',
            'Ajnaic',
            'Akaal',
            'Akar',
            'Akem',
            'Akhtar',
            'Akif',
            'Akii',
            'Akir',
            'Aklo',
            'Akon',
            'Akoorb',
            'Akrain',
            'Akshooth',
            'Akthrain',
            'Akvar',
            'Alao',
            'Alarre',
            'Albaize',
            'Albin',
            'Albrif',
            'Aldende',
            'Aldlor',
            'Aldlum',
            'Aldon',
            'Aldor',
            'Aldreb',
            'Aldred',
            'Aldren',
            'Aldryn',
            'Aldtas',
            'Alenthe',
            'Alfan',
            'Algus',
            'Alif',
            'Aling',
            'Aljic',
            'Aljric',
            'Allaire',
            'Allar',
            'Almaer',
            'Almeir',
            'Almen',
            'Alodd',
            'Alsob',
            'Altin',
            'Altur',
            'Alver',
            'Alya',
            'Amact',
            'Amair',
            'Ambard',
            'Ambeln',
            'Ambril',
            'Ameste',
            'Amfik',
            'Amkir',
            'Ammdar',
            'Ammek',
            'Amoyl',
            'Amphoth',
            'Amrath',
            'Amren',
            'Amyrg',
            'Amzar',
            'Anach',
            'Anar',
            'Anaz',
            'Ancharl',
            'Anclaar',
            'Anctash',
            'Andell',
            'Andjez',
            'Andon',
            'Andore',
            'Andorh',
            'Andrad',
            'Andreth',
            'Androlg',
            'Andrys',
            'Andval',
            'Anghra',
            'Anglame',
            'Angleem',
            'Anglock',
            'Anglor',
            'Angmor',
            'Angtai',
            'Anhlaw',
            'Anigg',
            'Anin',
            'Anjak',
            'Anjos',
            'Anken',
            'Ansher',
            'Ansoj',
            'Anson',
            'Antar',
            'Antarn',
            'Anthor',
            'Antrim',
            'Antriq',
            'Antrisp',
            'Anvar',
            'Anvyen',
            'Anxrin',
            'Anzire',
            'Aopharz',
            'Aophim',
            'Aquill',
            'Ara',
            'Araar',
            'Aradh',
            'Arak',
            'Aran',
            'Araste',
            'Araz',
            'Arbal',
            'Archam',
            'Archech',
            'Archite',
            'Arcus',
            'Ardann',
            'Ardesh',
            'Ardlen',
            'Ardoth',
            'Ardune',
            'Ardwar',
            'Ardwil',
            'Ardwile',
            'Areest',
            'Arell',
            'Argin',
            'Argorm',
            'Argrath',
            'Arhnaal',
            'Aribe',
            'Arick',
            'Arjhag',
            'Arkal',
            'Arkharn',
            'Arklow',
            'Arkrog',
            'Arlan',
            'Arlbeth',
            'Arldon',
            'Arlya',
            'Armast',
            'Armorn',
            'Armyze',
            'Arna',
            'Arnhor',
            'Arnid',
            'Arnlor',
            'Arnrost',
            'Aroinz',
            'Arrah',
            'Arrhod',
            'Arshel',
            'Artheen',
            'Arthex',
            'Artor',
            'Artus',
            'Arun',
            'Arvel',
            'Arvilk',
            'Arvol',
            'Arvox',
            'Arweld',
            'Aryem',
            'Aryft',
            'Aryon',
            'Aryph',
            'Aryus',
            'Arzang',
            'Arzi',
            'Asberl',
            'Ascelle',
            'Aschar',
            'Aschka',
            'Asco',
            "\xc4s\xeb",
            'Asgar',
            'Asgorn',
            'Ashan',
            'Ashane',
            'Ashbarl',
            'Ashed',
            'Ashild',
            'Ashlann',
            'Ashnyn',
            'Ashord',
            'Ashtah',
            'Ashur',
            'Askar',
            'Aspand',
            'Asrai',
            'Astei',
            'Astem',
            'Astha',
            'Astran',
            'Astrin',
            'Atang',
            'Atar',
            'Atdeel',
            'Ateng',
            'Athald',
            'Athar',
            'Athcroj',
            'Athlas',
            'Athlos',
            'Athmar',
            'Athquom',
            'Atlampt',
            'Atlank',
            'Atmaas',
            'Atmeh',
            'Atmog',
            'Atox',
            'Atraaf',
            'Atrend',
            'Atsal',
            'Attor',
            'Atyar',
            'Atyre',
            'Auchstyr',
            'Auchur',
            'Aucir',
            'Audric',
            'Aundan',
            'Aunxar',
            'Aurawn',
            'Aureth',
            'Auxid',
            'Avane',
            'Avarr',
            'Averq',
            'Avoon',
            'Avorn',
            'Awndale',
            'Axaane',
            'Axos',
            'Aya',
            'Aydras',
            'Ayen',
            'Ayin',
            'Ayir',
            'Ayla',
            'Aylmer',
            'Ayrish',
            'Ayshun',
            'Ayshung',
            'Azal',
            'Azash',
            'Azeal',
            'Azen',
            'Azgoth',
            'Azhrarn',
            'Azlon',
            'Azlyn',
            'Azmael',
            'Azorn',
            'Azoth',
            'Azra',
            'Azraq',
            'Azrean',
            'Azreck',
            'Azter',
            'Azzay',
            'Babdar',
            'Baccruz',
            'Baelil',
            'Bahar',
            'Baiar',
            'Baiern',
            'Baikaen',
            'Baiposk',
            'Bakan',
            'Bakra',
            'Balain',
            'Balaz',
            'Baldhur',
            'Baldrim',
            'Balgurr',
            'Balkar',
            'Balok',
            'Balour',
            'Banek',
            'Banffoge',
            'Bannheld',
            'Bannor',
            'Baraell',
            'Bardel',
            'Barduy',
            'Baren',
            'Barim',
            'Barind',
            'Barldsy',
            'Barlom',
            'Barlon',
            'Barltan',
            'Barnar',
            'Barood',
            'Baros',
            'Barrenc',
            'Barrin',
            'Bartain',
            'Basfric',
            'Basim',
            'Basmol',
            'Bassinth',
            'Bassto',
            'Bastarre',
            'Batrosque',
            'Bayven',
            'Bayzell',
            'Bazan',
            'Bazit',
            'Beclaan',
            'Bedane',
            'Bedese',
            'Beejlam',
            'Begnus',
            'Belan',
            'Belaz',
            'Belcoir',
            'Beleth',
            'Belgaun',
            'Belic',
            'Beljan',
            'Bellin',
            'Bellom',
            'Belmul',
            'Belnarth',
            'Belor',
            'Belorn',
            'Belot',
            'Belrain',
            'Belstos',
            'Belthan',
            'Belthis',
            'Belwilg',
            'Bengol',
            "B\xebol",
            'Beolj',
            'Beras',
            'Berclad',
            'Bercol',
            'Berik',
            'Berild',
            'Berim',
            'Berith',
            'Berlyne',
            'Berrec',
            'Bersem',
            'Bershar',
            'Bertrenk',
            'Berzik',
            'Bethmel',
            'Beyash',
            'Beyus',
            'Bezgrael',
            'Bezpar',
            'Bhoorva',
            'Biferb',
            'Biilar',
            'Bildesh',
            'Billosh',
            'Bilmar',
            'Bindle',
            'Biraad',
            'Birain',
            'Bireln',
            'Birta',
            'Bisel',
            'Bjanni',
            'Blauthike',
            'Bleran',
            'Bleskran',
            'Blonjerg',
            'Blorvind',
            'Blunyc',
            'Bodvar',
            "Bo\xebd",
            'Boggrah',
            'Bolaoz',
            'Bolthorn',
            'Borale',
            'Boren',
            'Borgald',
            'Borin',
            'Borlaith',
            'Borlas',
            'Borlid',
            'Borlo',
            'Borngah',
            'Borzer',
            'Boshan',
            'Bothar',
            'Botro',
            'Bouphar',
            'Bowjen',
            'Boyarl',
            'Braagen',
            'Bracca',
            'Braeklarn',
            'Bragen',
            'Brahan',
            'Brakkon',
            'Brala',
            'Brali',
            'Brallu',
            'Bralma',
            'Brandar',
            'Brandec',
            'Brangwej',
            'Branthu',
            'Brantys',
            'Branvaol',
            'Branzan',
            'Brascand',
            'Brasslin',
            'Braxen',
            'Braxtor',
            'Brealij',
            'Bredhal',
            'Breedast',
            'Bregem',
            'Brehen',
            'Breitsoj',
            'Brelkrov',
            'Brenen',
            'Brenlan',
            'Brestej',
            'Brethil',
            'Bretta',
            'Brevlyn',
            'Brevta',
            'Brielle',
            'Brindax',
            'Brindence',
            'Brintu',
            'Brinys',
            'Brislyn',
            'Brithael',
            'Brithric',
            'Brobal',
            'Brohnin',
            'Brona',
            'Broosin',
            'Broxus',
            'Brufod',
            'Brundelx',
            'Bryapka',
            'Brynit',
            'Buckrald',
            'Bulvet',
            'Burcan',
            'Burrgaut',
            'Bwermolc',
            'Byeloor',
            'Bylys',
            'Byrkast',
            'Byzar',
            'Cadairn',
            'Caddax',
            'Cadel',
            'Cadfrel',
            'Cadrach',
            'Cadreth',
            'Caecyn',
            'Caedfer',
            'Caelis',
            'Caerron',
            'Caillean',
            'Caiphul',
            'Cairon',
            'Caldel',
            'Calensch',
            'Calkdaev',
            'Calmic',
            'Calnor',
            'Calunn',
            'Calyz',
            'Calzan',
            'Camain',
            'Cambree',
            'Camdlon',
            'Camsar',
            'Candla',
            'Candrak',
            'Canelb',
            'Cangmor',
            'Canthar',
            'Cantrasc',
            'Caopha',
            'Caostri',
            'Caranth',
            'Carbrod',
            'Cardelv',
            'Carfheen',
            'Carlasc',
            'Carlinx',
            'Carnax',
            'Carnly',
            'Carnool',
            'Caroin',
            'Carquel',
            'Carthis',
            'Caskeil',
            'Castlon',
            'Cathlaid',
            'Caveesm',
            'Cavorn',
            'Cavosse',
            'Cavris',
            'Caynarv',
            'Cayrin',
            'Cazberr',
            'Cazyach',
            'Cedrim',
            'Cedrisk',
            'Ceilerse',
            'Celbarb',
            'Cemtruo',
            'Cenyth',
            'Ceraik',
            'Cercyon',
            'Cerdun',
            'Cerlint',
            'Cermor',
            'Cernon',
            'Cerra',
            'Cessair',
            'Cevir',
            'Ceylinn',
            'Chadan',
            'Chadlor',
            'Chadzik',
            'Chaemor',
            'Chagor',
            'Chalar',
            'Challem',
            'Challeth',
            'Chalvir',
            'Chambarr',
            'Changtsai',
            'Chanoth',
            'Chanti',
            "Cha\xf6l",
            'Charatze',
            'Charnyx',
            'Charresh',
            'Charyd',
            'Chaska',
            'Chaulet',
            'Chavir',
            'Chayim',
            'Chazane',
            'Chazgel',
            'Cheldor',
            'Chelim',
            'Chelprey',
            'Chelshrike',
            'Chendil',
            'Chenean',
            'Chenoa',
            'Cherla',
            'Chessene',
            'Chevonde',
            'Chezil',
            'Chial',
            'Chian',
            'Chigran',
            'Chimu',
            'Chimzil',
            'Chirril',
            'Chirthiz',
            'Chitrind',
            'Chlangi',
            'Chlodig',
            'Chlorild',
            'Chordash',
            'Chorrin',
            'Chrezel',
            'Chungaez',
            'Chunjan',
            'Chyvil',
            'Cidran',
            'Cilmar',
            'Cinctraic',
            'Ciraf',
            'Cirkin',
            'Cirnak',
            'Cista',
            'Civar',
            'Ciwan',
            'Clafaug',
            'Clarinn',
            'Cleedis',
            'Clendlim',
            'Clenvred',
            'Cligra',
            'Cloosag',
            'Cloralt',
            "Co\xe4x",
            'Cobord',
            'Cobrynth',
            'Coddry',
            'Cogarn',
            'Coimarn',
            'Colgrim',
            'Colyss',
            'Comnlan',
            'Conjerb',
            'Conjin',
            'Coram',
            'Corbrod',
            'Cordin',
            'Corem',
            'Coreme',
            'Corill',
            'Corince',
            'Cormast',
            'Corrysm',
            'Corsolle',
            'Couran',
            'Coyzan',
            'Cramog',
            'Craxan',
            'Craydarth',
            'Craye',
            'Creidah',
            'Crennex',
            'Crestarl',
            'Crestry',
            'Creydai',
            'Crezel',
            'Crilayth',
            'Crixbine',
            'Crochell',
            'Crolas',
            'Cromough',
            'Croquarne',
            'Cuddry',
            'Cuhaid',
            'Cullyn',
            'Curik',
            'Curin',
            'Curlask',
            'Cusheal',
            'Cusheth',
            'Cuttray',
            'Cyanril',
            'Cydace',
            'Cylenn',
            'Cynquil',
            'Cyrand',
            'Cyrib',
            'Cyrvemth',
            'Czarai',
            'Dabthan',
            'Dacil',
            'Daeglev',
            'Daelden',
            'Dafor',
            'Daghand',
            'Dagharz',
            'Dagir',
            'Dahiil',
            'Daikoon',
            'Dailenn',
            'Dakul',
            'Dakvon',
            'Dalain',
            'Dalanc',
            'Dalcraw',
            'Dalga',
            'Dalgirth',
            'Dalith',
            'Dalman',
            'Dalraev',
            'Dalsar',
            'Dalvai',
            'Dalvoc',
            'Dalwyn',
            'Damaal',
            'Damar',
            'Damesk',
            'Damrir',
            'Danchel',
            'Dandar',
            'Dandroan',
            'Danfis',
            'Dangrim',
            'Dankin',
            'Dantlee',
            'Daotar',
            'Daphrin',
            'Daplurn',
            'Dara',
            'Darach',
            'Darake',
            'Daran',
            'Darax',
            'Darbeel',
            'Darcer',
            'Darga',
            'Darglin',
            'Darinth',
            'Darjek',
            'Darjii',
            'Darlist',
            'Darlith',
            'Darmont',
            'Darmore',
            'Darnath',
            'Darnein',
            'Darnime',
            'Daron',
            'Darool',
            'Darsid',
            'Darsiiv',
            'Darsin',
            'Darvane',
            'Darven',
            'Darzed',
            'Darzha',
            'Dashgu',
            'Dasig',
            'Dastor',
            'Dastryn',
            'Daugas',
            'Daulaz',
            'Davar',
            'Daveld',
            'Davix',
            'Davlit',
            'Davras',
            'Davrou',
            'Davrune',
            'Dawfoke',
            'Daxon',
            'Dayko',
            'Daysase',
            'Daytar',
            'Deaclynd',
            'Debfin',
            'Dechru',
            'Deenos',
            'Delaur',
            'Delcold',
            'Deldrak',
            'Deleea',
            'Delente',
            'Delgath',
            'Delgaun',
            'Delmar',
            'Delna',
            'Delrean',
            'Delser',
            'Demgris',
            'Deneth',
            'Dengar',
            'Denlorn',
            'Derdain',
            'Derfel',
            'Dergast',
            'Derild',
            'Derlin',
            'Derlor',
            'Deroh',
            'Deron',
            'Derroll',
            'Dersarre',
            'Derthark',
            'Devolt',
            'Devreed',
            'Dhakos',
            'Dhornen',
            'Dhoumene',
            'Dhranak',
            'Dhyana',
            'Dialn',
            'Dibdrek',
            'Dilfar',
            'Dilgid',
            'Dilquay',
            'Dilvak',
            'Dinoor',
            'Diorne',
            'Diran',
            'Dirim',
            'Dirkalt',
            'Dirmalk',
            'Dirrach',
            'Dirrahk',
            'Dirvus',
            'Distar',
            'Disten',
            'Distran',
            'Ditrenth',
            'Divos',
            'Djarmon',
            'Djehla',
            'Djelha',
            'Djira',
            'Djola',
            'Dolljan',
            'Dolthar',
            'Dolvith',
            'Domede',
            'Domen',
            'Domin',
            'Domnux',
            'Domon',
            'Domvit',
            'Domwren',
            'Donet',
            'Donlaze',
            'Doran',
            'Dorath',
            'Dorgand',
            'Dorgath',
            'Dorhar',
            'Dorin',
            'Dornath',
            'Dornbain',
            'Dorok',
            'Dorsan',
            'Dorspaich',
            'Dortoom',
            'Dorvai',
            'Dostaan',
            'Doussa',
            'Dowflox',
            'Dozrig',
            'Dozthuk',
            'Drabsnar',
            'Dradoi',
            'Dradus',
            'Draegra',
            'Drakhor',
            'Drakhri',
            'Drakirn',
            'Drakkan',
            'Dralar',
            'Dramah',
            'Dramfer',
            'Draogat',
            'Drassonne',
            'Drauphor',
            'Draven',
            'Draxok',
            'Drayley',
            'Drayven',
            'Drazvec',
            'Drebyss',
            'Dreezhan',
            'Drefest',
            'Dreggol',
            'Dreintor',
            'Drellefe',
            'Drenfust',
            'Drengar',
            'Drethlec',
            'Drevark',
            'Dreynel',
            'Drezael',
            'Drezaem',
            'Drilant',
            'Drimmis',
            'Drinda',
            'Dringle',
            'Drion',
            'Drissa',
            'Dristirk',
            'Drocolg',
            'Drogan',
            'Drohulse',
            'Droilfin',
            'Drokoag',
            'Dronasp',
            'Druchor',
            'Drunal',
            'Drusilf',
            'Dryduos',
            'Duarn',
            'Duergan',
            'Dulith',
            'Dulkarn',
            'Dulkast',
            'Dunry',
            'Durnik',
            'Durzin',
            'Duskim',
            'Duubown',
            'Dvorast',
            'Dwendlim',
            'Dwyvach',
            'Dygard',
            'Dylenx',
            'Dymnash',
            'Dynqua',
            'Dynroth',
            'Dyoni',
            'Dyshim',
            'Dyskrahn',
            'Dytheus',
            'Dyvim',
            'Dyzant',
            'Dzoraug',
            'Easval',
            'Ebane',
            'Ebur',
            'Echael',
            'Echross',
            'Eclane',
            'Edcyl',
            'Eddar',
            'Eddax',
            'Eddor',
            'Edeth',
            'Edhil',
            'Edrun',
            'Eduu',
            'Eehatt',
            'Eelek',
            'Eelgren',
            'Eerban',
            'Eglarth',
            'Egron',
            'Ehilm',
            'Ehlmat',
            'Ehlreth',
            'Eidon',
            'Eidrinn',
            'Eilif',
            'Einar',
            'Eirecht',
            "Eithn\xe9",
            'Ejence',
            'Ekvarl',
            'Elaen',
            'Eland',
            'Elath',
            'Eldin',
            'Eldix',
            'Eldrab',
            'Eldron',
            'Eldru',
            'Elek',
            'Elem',
            'Elfreth',
            'Elgroth',
            'Elkin',
            'Elkleth',
            'Ellern',
            'Ellrass',
            'Elmral',
            'Elnume',
            'Elod',
            'Elran',
            'Elriph',
            'Elu',
            'Elvrit',
            'Elyx',
            'Elzast',
            'Emal',
            'Emberle',
            'Emdel',
            'Emerl',
            'Emgar',
            'Emton',
            'Enban',
            'Encarth',
            'Endrade',
            'Endril',
            'Enferth',
            'Englin',
            'Enkim',
            'Ennek',
            'Enris',
            'Enrost',
            'Enskel',
            'Ensorn',
            'Envess',
            'Enzhai',
            'Ephelt',
            'Ephraj',
            'Ephti',
            'Ephyre',
            'Eppent',
            'Eppin',
            'Erbmaj',
            'Erdlan',
            'Ergar',
            'Ergoth',
            'Ergron',
            'Erhil',
            'Erijn',
            'Ermon',
            'Ermor',
            'Eron',
            'Errain',
            'Errone',
            'Erson',
            'Erwat',
            'Erxab',
            'Escande',
            'Esceft',
            'Esdrix',
            'Esghar',
            'Eshrik',
            'Eshuur',
            'Eskarn',
            'Eslyn',
            'Esris',
            'Essa',
            'Estrag',
            'Estorl',
            'Estrif',
            'Esyfe',
            'Ethrene',
            'Euross',
            'Evelj',
            'Evinth',
            'Evith',
            'Evorn',
            'Evska',
            'Ewlon',
            'Eyphra',
            'Eythor',
            'Ezail',
            'Ezmi',
            'Ezri',
            'Fabolde',
            'Fadar',
            'Faendyre',
            'Faesten',
            'Faffle',
            'Fafnalg',
            'Faiorg',
            'Falbin',
            'Falcarn',
            'Falgar',
            'Falhehn',
            'Fali',
            'Falldrijn',
            'Falsfeen',
            'Falslen',
            'Falume',
            'Fanchel',
            'Faran',
            'Fardoth',
            'Fardron',
            'Farglid',
            'Farhaude',
            'Farleit',
            'Farli',
            'Farmolj',
            'Farnek',
            'Farngold',
            'Farngor',
            'Faroon',
            'Farosh',
            'Farrain',
            'Farscall',
            'Farsun',
            'Farunst',
            'Farzdoy',
            'Fasthes',
            'Fautell',
            'Favuld',
            'Favvaz',
            'Fayel',
            'Faygrenn',
            'Faylaol',
            'Faylynn',
            'Fayol',
            'Fazhal',
            'Fazzur',
            'Feeming',
            'Feikry',
            'Feirrex',
            'Felinx',
            'Felnar',
            'Felor',
            'Felstar',
            'Felthund',
            'Felvrand',
            'Femigg',
            'Fendahl',
            'Fendrabe',
            'Fenew',
            'Fenic',
            'Fenist',
            'Fenleith',
            'Fennus',
            'Fenrald',
            'Fenzil',
            'Feorth',
            'Ferman',
            'Fermern',
            'Fernath',
            'Ferndel',
            'Fernhol',
            'Fernool',
            'Fernosk',
            'Ferram',
            'Ferthel',
            'Fervigg',
            'Ferwend',
            'Fesru',
            'Fethlan',
            'Feyan',
            'Feyern',
            'Fhorat',
            'Fiantz',
            'Fictyr',
            'Figgin',
            'Fiiya',
            'Filtarg',
            'Fingril',
            'Finstar',
            'Firca',
            'Firga',
            'Firin',
            'Firon',
            'Fiskroll',
            'Fissworx',
            'Flauleck',
            'Flayna',
            'Flestrin',
            'Fletchen',
            'Flikir',
            'Flingrel',
            'Flitan',
            'Flixis',
            'Foarad',
            'Fodusk',
            'Fogrin',
            'Fohdon',
            'Folstin',
            'Fomkrin',
            'Fontand',
            'Foozan',
            'Foragh',
            'Forang',
            'Foraujh',
            'Forbulse',
            'Foren',
            'Forjisk',
            'Formki',
            'Fornoar',
            'Foros',
            'Forroosk',
            'Forstine',
            'Fortrelce',
            'Forvael',
            'Fozgiel',
            'Frama',
            'Franaard',
            'Frannon',
            'Frashtol',
            'Frayja',
            'Freasand',
            'Fremmoun',
            'Frillox',
            'Friston',
            'Frixeen',
            'Frolin',
            'Frondir',
            'Fronost',
            'Fronubb',
            'Froscele',
            'Frowal',
            'Fruwasp',
            'Ftoomi',
            'Fulshin',
            'Fulume',
            'Fumpsil',
            'Furtloft',
            'Fusraul',
            'Fylin',
            'Fylssa',
            'Fyojhkor',
            "Fy\xf6nn",
            'Fyza',
            'Gaatel',
            'Gadan',
            'Gadoc',
            'Gadra',
            'Gadri',
            'Gaenlea',
            'Gaerlind',
            'Gaerris',
            'Gafael',
            'Gaisherl',
            'Gajiste',
            'Gakaal',
            'Galaart',
            'Galach',
            'Galaij',
            'Galan',
            'Galbaaz',
            'Galchan',
            'Galdoir',
            'Galenx',
            'Galind',
            'Gallarg',
            'Gallasp',
            'Galmad',
            'Galron',
            'Galsdor',
            'Galvrix',
            'Gambrax',
            'Gamitz',
            'Gamkya',
            'Ganaek',
            'Gandril',
            'Ganerth',
            'Ganerve',
            'Ganix',
            'Gankor',
            'Ganock',
            'Gareck',
            'Gareld',
            'Garhaft',
            'Garlan',
            'Garol',
            'Garon',
            'Garos',
            'Garpast',
            'Garras',
            'Garron',
            'Garstrang',
            'Garstrith',
            'Garthag',
            'Garthaun',
            'Garven',
            'Gathen',
            'Gaunmar',
            'Gaurbal',
            'Gavrok',
            'Gawend',
            'Gaxtor',
            'Gazwylg',
            'Gearna',
            'Geaxa',
            'Gebrence',
            'Gebrow',
            'Gechart',
            'Gechrak',
            'Gedreth',
            'Geerharg',
            'Gehed',
            'Gelan',
            'Gelann',
            'Geldol',
            'Gelwik',
            'Gemal',
            'Gemelf',
            'Genglar',
            'Gerant',
            'Gerin',
            'Gerlant',
            'Geroind',
            'Gerreint',
            'Gerren',
            'Gesin',
            'Gethen',
            'Gezdrey',
            'Ghaachev',
            'Gharlane',
            'Ghatar',
            'Ghatha',
            'Ghellence',
            'Gherent',
            'Gherlan',
            'Ghirra',
            'Ghomnir',
            'Ghralence',
            'Giaj',
            'Gilboch',
            'Gildor',
            'Gildren',
            'Gildrift',
            'Gilflin',
            'Gilir',
            'Gilith',
            'Gillyn',
            'Gilmir',
            'Gilmirst',
            'Gilnar',
            'Gilorn',
            'Gilos',
            'Gilva',
            'Gilvar',
            'Gimeld',
            'Gimlej',
            'Gimnel',
            'Ginnen',
            'Ginorsh',
            'Girbeaux',
            'Girin',
            'Girzan',
            'Gisgin',
            'Githeld',
            'Githew',
            'Gitlan',
            'Gitril',
            'Gittos',
            'Gizralle',
            'Glaeloth',
            'Glaernex',
            'Glaraum',
            'Glasdray',
            'Glasquel',
            'Glaury',
            'Glayant',
            'Gleada',
            'Glebur',
            'Glethlot',
            'Gleyden',
            'Glianth',
            'Glidnimm',
            'Glimanthe',
            'Glirice',
            'Glirrish',
            'Gloisur',
            'Glowan',
            'Glufjyn',
            'Glyngal',
            'Glynzel',
            'Glystraine',
            'Gnasthor',
            'Gnasthra',
            'Gnivlah',
            'Gnohesk',
            'Gnorri',
            'Gnospret',
            'Gobar',
            'Goklod',
            'Golluer',
            'Gomar',
            'Gondrift',
            'Gonjal',
            'Gorad',
            'Gorgost',
            'Gorin',
            'Gorinssk',
            'Gorklu',
            'Gorlis',
            'Gormane',
            'Gornik',
            'Gorshay',
            'Goryon',
            'Gossparl',
            'Gothel',
            'Grachar',
            'Graequil',
            'Graghan',
            'Grahault',
            'Grainim',
            'Granik',
            'Granlon',
            'Gravec',
            'Greavdal',
            'Greelar',
            'Greethrin',
            'Greforn',
            'Grehuse',
            'Grekith',
            'Gremdahl',
            'Grendax',
            'Grennath',
            'Grenslae',
            'Grenvin',
            'Greorle',
            'Grevam',
            'Greyfell',
            'Griam',
            'Grian',
            'Griea',
            'Griffix',
            'Grifnid',
            'Grindan',
            'Grishulf',
            'Gristis',
            'Griswald',
            'Grittu',
            'Grivalx',
            "Gro\xe4xx",
            'Grombul',
            'Grondar',
            'Grortam',
            'Grulbest',
            'Grussex',
            'Grydon',
            'Gryemox',
            'Grykar',
            'Grypha',
            'Guhan',
            'Guhlnor',
            'Gulla',
            'Gulzund',
            'Gunshird',
            'Gunthal',
            'Gunthar',
            'Gunzhur',
            'Gurdam',
            'Gurjan',
            'Gustay',
            'Guthril',
            'Gwacyn',
            'Gwaihir',
            'Gweddyn',
            'Gweien',
            'Gwenca',
            'Gwendald',
            'Gwepfrath',
            'Gwesder',
            'Gwildor',
            'Gwithra',
            'Gwomyr',
            'Gwyran',
            'Gwythinst',
            "Gy\xe1n",
            'Gylrath',
            "Gy\xf3rb",
            'Gyriss',
            'Gyrlaen',
            'Gyrlath',
            'Gysankh',
            'Gyseyt',
            'Gystral',
            'Haakrim',
            'Haarstrin',
            'Habmarl',
            'Hadan',
            'Hadar',
            'Hadarg',
            'Hado',
            'Hadrim',
            'Hadron',
            'Haestan',
            'Haefgan',
            'Hafthir',
            'Hagith',
            'Hagra',
            'Haidelth',
            'Haijiss',
            'Hainen',
            'Hakhoim',
            'Haklar',
            'Haklor',
            'Hakpard',
            'Hala',
            'Halbex',
            'Halborn',
            'Haldor',
            'Haloth',
            'Halperle',
            'Halsan',
            "Hal\xfbt",
            'Halvner',
            'Hamba',
            'Hamisk',
            'Hanastre',
            'Handra',
            'Hanil',
            'Hanierth',
            'Hanith',
            'Hantar',
            'Hanthryn',
            'Hapvar',
            'Haral',
            'Harave',
            'Harchyl',
            'Harfare',
            'Hargan',
            'Harnir',
            'Harntil',
            'Harnyrse',
            'Harpann',
            'Harran',
            'Harrelm',
            'Harstar',
            'Hartaz',
            'Harthan',
            'Harthex',
            'Harthran',
            'Hartrond',
            'Harvas',
            'Harvel',
            'Harzelle',
            'Haspid',
            'Hasrick',
            'Hatchiss',
            'Hatrasd',
            'Havin',
            'Havrel',
            'Hawklin',
            'Hawkram',
            'Hawkran',
            'Hawkreld',
            'Hawleet',
            'Hawljin',
            'Hawtran',
            'Haxas',
            'Hazgarl',
            'Hazkar',
            'Hazrond',
            'Hazvelc',
            'Hazyrg',
            'Hazzal',
            'Hearroj',
            'Hedin',
            'Heenarg',
            'Heengul',
            'Hefpyre',
            'Heinvroh',
            'Helaz',
            'Heldix',
            'Helflitz',
            'Helir',
            'Helsdal',
            'Helsur',
            'Helvem',
            'Hembra',
            'Heram',
            'Herisk',
            'Herndre',
            'Herrul',
            'Herthose',
            'Herym',
            'Herzick',
            'Hespek',
            'Hesrel',
            'Hessun',
            'Hetcroft',
            'Hethar',
            'Hethra',
            'Heurhyl',
            'Hexil',
            'Hezron',
            'Heztor',
            'Hibriss',
            'Hienn',
            'Hiffelk',
            'Hifforn',
            'Hifryn',
            'Hildred',
            'Hilix',
            'Hiljin',
            'Hilxin',
            'Himlon',
            'Himon',
            'Himvli',
            'Hinthan',
            'Hinzay',
            'Hireal',
            'Hirrean',
            'Hisrilf',
            'Hisvran',
            'Hizar',
            'Hizron',
            'Hjalmar',
            'Hjeldin',
            'Hjordrik',
            'Hlyrmis',
            'Hobtalg',
            'Hoesgald',
            'Holay',
            'Holgar',
            'Hollox',
            'Holthan',
            'Homli',
            'Honturg',
            'Hophand',
            'Hoprig',
            'Horan',
            'Horglin',
            'Horjak',
            'Horlask',
            'Hormatz',
            'Horond',
            'Horros',
            'Horthoon',
            'Horzak',
            'Hotath',
            'Hothcog',
            'Hothcol',
            'Hrasha',
            'Hrasquer',
            'Hrelar',
            'Hresheuth',
            'Hrinspire',
            'Hroleur',
            "Hr\xf6nir",
            'Hrossa',
            'Hrostar',
            'Hsaptren',
            'Humbuss',
            'Humquor',
            'Hunard',
            'Hundar',
            'Hurcad',
            'Hurgal',
            'Hurnod',
            'Hurrisk',
            'Hursin',
            'Hurvin',
            'Hurym',
            'Hussuln',
            'Huusim',
            'Hyarante',
            'Hyfryn',
            'Hylar',
            'Hyssome',
            'Hyxley',
            'Hyzail',
            'Hyzen',
            'Ibchol',
            'Ibizt',
            'Ibrolg',
            'Ica',
            'Ictar',
            'Iduun',
            'Ighai',
            'Ignale',
            'Ignire',
            'Igraa',
            'Igresk',
            'Iijind',
            'Iithkin',
            'Ijeng',
            'Ikalss',
            'Ikeen',
            'Ikkrish',
            "Ikl\xe9y",
            'Ildel',
            'Ildelft',
            'Ildin',
            'Ildis',
            'Ildnarr',
            'Illa',
            'Illyis',
            'Ilnim',
            'Ilruhn',
            'Ilsuor',
            'Ilthoss',
            'Iltrilt',
            'Iltrogh',
            'Ilva',
            'Ilvar',
            'Ilxar',
            'Ilyag',
            'Imcanx',
            'Imcolg',
            'Imdiv',
            'Imhas',
            'Immak',
            'Immoyr',
            'Imnarl',
            'Impag',
            'Imrib',
            'Imrift',
            'Imtsith',
            'Indlech',
            'Indloth',
            'Indlut',
            'Indred',
            'Ingarh',
            'Ingelk',
            'Ingen',
            'Inghar',
            'Ingolm',
            'Ingrald',
            'Inilv',
            'Inis',
            'Innluu',
            'Inoke',
            'Inslar',
            'Iom',
            'Ipshoom',
            'Iraiz',
            'Iras',
            'Irauld',
            'Iraunt',
            'Irbry',
            'Irchel',
            'Irex',
            'Irglas',
            'Irlen',
            'Irough',
            'Irrash',
            'Irrax',
            'Irsai',
            'Iruste',
            'Irwick',
            'Irxeath',
            'Isbard',
            'Ishan',
            'Ishenx',
            'Ishgan',
            'Ishkar',
            'Ishlak',
            'Ishshan',
            'Ishya',
            'Islarch',
            'Ismlok',
            'Isorn',
            'Isphek',
            'Issa',
            'Isstan',
            'Itaaq',
            'Ithend',
            'Ithkaar',
            'Ithome',
            'Ivaade',
            'Ivaire',
            'Ivind',
            'Ivool',
            'Ivorn',
            'Ivral',
            'Ivran',
            'Ivrax',
            'Ivyd',
            'Ivyod',
            'Ixan',
            'Ixaq',
            'Ixor',
            'Iygin',
            'Izinth',
            'Izleng',
            'Izmisk',
            'Iztra',
            'Izvire',
            'Jaadis',
            'Jaagix',
            'Jaalmez',
            'Jaalon',
            'Jaaluth',
            'Jablant',
            'Jacor',
            'Jadir',
            'Jado',
            'Jadoorm',
            'Jaedan',
            'Jaelyss',
            'Jagan',
            'Jaggol',
            'Jagrid',
            'Jahir',
            'Jahrgrim',
            'Jaidu',
            'Jaldeer',
            'Jalmid',
            'Jalom',
            'Jama',
            'Janam',
            'Janan',
            'Jandix',
            'Janlay',
            'Jano',
            'Janrass',
            'Jantust',
            'Janu',
            'Japloon',
            'Jarad',
            'Jarilz',
            'Jariz',
            'Jarlew',
            'Jarlith',
            'Jarngor',
            'Jarra',
            'Jartak',
            'Jartusk',
            'Jarveen',
            'Jarvil',
            'Jarvix',
            'Jarzad',
            'Jasir',
            'Jasphar',
            'Jaswen',
            'Jaussig',
            'Jautan',
            'Javen',
            'Javert',
            'Javrik',
            'Javtir',
            'Jaxal',
            'Jaxel',
            'Jaylence',
            'Jazanne',
            'Jazraal',
            'Jazrel',
            'Jazrode',
            'Jebhart',
            'Jedra',
            'Jeeldor',
            'Jeelteg',
            'Jehzehr',
            'Jelthar',
            'Jekkar',
            'Jelantru',
            'Jelday',
            'Jeldor',
            'Jelym',
            'Jenbow',
            'Jendarr',
            'Jenkisk',
            'Jerdys',
            'Jerec',
            'Jerel',
            'Jerim',
            'Jessel',
            'Jetashe',
            'Jethrik',
            'Jeven',
            'Jevist',
            'Jezreel',
            'Jezzar',
            'Jezzra',
            'Jhebdaeg',
            'Jheexadh',
            'Jheluth',
            'Jherrox',
            'Jhinarr',
            'Jhinith',
            'Jhorin',
            'Jhourlann',
            'Jhumpoust',
            'Jhuvar',
            'Jiaf',
            'Jianc',
            'Jiglak',
            'Jihalg',
            'Jilsa',
            'Jiltarn',
            'Jinnow',
            'Jintlorn',
            'Jinvik',
            'Jiral',
            'Jirnon',
            'Jirnost',
            'Jisa',
            'Jithrast',
            'Jixile',
            'Joamorsk',
            'Jobel',
            'Jolrant',
            'Jolsir',
            'Jomec',
            'Jomsut',
            'Jondar',
            'Jooskan',
            'Jorad',
            'Jorael',
            'Joram',
            'Joran',
            'Jorel',
            'Jornic',
            'Joron',
            'Jorvim',
            'Joskyl',
            'Jossak',
            'Jostib',
            'Jothal',
            'Jovaine',
            'Joysair',
            'Jugeen',
            'Juldrake',
            'Julix',
            'Julphra',
            'Jultus',
            'Jungro',
            'Junnar',
            'Jurin',
            'Jurinn',
            'Jurret',
            'Jushdak',
            'Justix',
            'Juthcot',
            'Juxpire',
            'Jynyx',
            'Jyvlex',
            'Kaanpell',
            'Kadjix',
            'Kaerjeld',
            'Kaggoth',
            'Kagolm',
            'Kahlan',
            'Kahmahr',
            'Kaiya',
            'Kaklo',
            'Kaldrak',
            'Kalduk',
            'Kalen',
            'Kaliss',
            'Kallak',
            'Kalshai',
            'Kalthen',
            'Kalvek',
            'Kalvran',
            'Kalxin',
            'Kaman',
            'Kamlant',
            'Kamon',
            'Kander',
            'Kangmir',
            'Kangmor',
            'Kanliin',
            'Kanpo',
            'Kantar',
            'Kanthrix',
            'Kantran',
            'Kanven',
            'Kaplull',
            'Karchad',
            'Karchen',
            'Karchoy',
            'Karcist',
            'Karect',
            'Kareeb',
            'Kargon',
            'Karjin',
            'Karjus',
            'Karkrust',
            'Karnek',
            'Karrax',
            'Karrim',
            'Karsa',
            'Karstall',
            'Kartol',
            'Kasel',
            'Kashir',
            'Kashtuul',
            'Kaspim',
            'Kaspin',
            'Kassar',
            'Katan',
            'Kathak',
            'Kathar',
            'Kathasp',
            'Kathor',
            'Kattelg',
            'Kattra',
            'Kaukris',
            'Kavar',
            'Kavarl',
            'Kavath',
            'Kavis',
            'Kavor',
            'Kayesp',
            'Kayris',
            'Kazarn',
            'Keanca',
            'Kedern',
            'Keerlin',
            'Keermeth',
            'Kegryn',
            'Keigtril',
            'Kekkan',
            'Kelar',
            'Keldar',
            'Kelgus',
            'Kelkor',
            'Kelmar',
            'Kelner',
            'Kelrac',
            'Kelshiir',
            'Kelver',
            'Kelvon',
            'Kelvyath',
            'Kember',
            'Kembriss',
            'Kemoy',
            'Kenshlin',
            'Keraan',
            'Kerdal',
            'Kered',
            'Kerrol',
            'Kersenct',
            'Keru',
            'Kerzard',
            'Kesdric',
            'Kesnahr',
            'Kespeth',
            'Kesrack',
            'Kesrick',
            'Kethdjal',
            'Kethrak',
            'Kevlad',
            'Kexy',
            'Kezven',
            'Khadar',
            'Khadys',
            'Khalart',
            'Khaldan',
            'Khalir',
            'Kheverl',
            'Khondru',
            'Khordov',
            'Khrissa',
            'Khrithra',
            'Khrosa',
            'Khudrax',
            'Khugweb',
            'Kian',
            'Kibbath',
            'Kibha',
            'Kidash',
            'Kiirmu',
            'Kijmin',
            'Kikrasht',
            'Kilas',
            'Kilat',
            'Kilgand',
            'Kilisp',
            'Kilmin',
            'Kimda',
            'Kinduhr',
            'Kinorm',
            'Kinzroft',
            'Kipplob',
            'Kirdon',
            'Kirklen',
            'Kiroum',
            'Kirrax',
            'Kirun',
            'Kirskar',
            'Kirzav',
            'Kisarld',
            'Kishin',
            'Kismer',
            'Kismerle',
            'Kisprimn',
            'Kiston',
            'Kisvord',
            'Kithert',
            'Kithorsk',
            'Kithund',
            'Kithvor',
            'Kivan',
            'Kivooz',
            'Kivoum',
            'Kixime',
            'Kizmay',
            'Kjeldor',
            'Kjindar',
            'Koabon',
            'Kofoum',
            'Koino',
            'Kolbect',
            'Kolchash',
            'Kolduk',
            'Kolthya',
            'Kolvram',
            'Konvain',
            'Korak',
            'Korban',
            'Kordale',
            'Koren',
            'Koreth',
            'Korghil',
            'Korix',
            'Korlisk',
            'Kornor',
            'Kornud',
            'Korok',
            'Korrik',
            'Korsal',
            'Korseng',
            'Kortael',
            'Kortenj',
            'Korthoon',
            'Koruk',
            'Korusk',
            'Korvar',
            'Kosjourn',
            'Kothar',
            'Koxir',
            'Kozzir',
            'Kraatin',
            'Krallorn',
            'Krana',
            'Krangar',
            'Kranorn',
            'Krantheer',
            'Krantor',
            'Kredhal',
            'Kregnux',
            'Krelgar',
            'Krentomzh',
            'Kressen',
            'Krexnahr',
            'Krillon',
            'Krissenq',
            "Kro\xebld",
            'Krotald',
            'Krotar',
            'Krotem',
            'Kruchaen',
            'Krynerl',
            'Kugar',
            'Kuldrah',
            'Kulik',
            'Kulleest',
            'Kulxel',
            'Kunatht',
            'Kurdghar',
            'Kurgnar',
            'Kuruz',
            'Kurvos',
            'Kushish',
            'Kydra',
            'Kyladz',
            'Kylcrum',
            'Kylix',
            'Kyllam',
            'Kymen',
            'Kyrake',
            'Kyrmo',
            'Kyrsha',
            'Kyshi',
            'Kysho',
            'Laabrun',
            'Laarskim',
            'Laconde',
            "La\xebl",
            'Lagu',
            'Lailaske',
            'Laithare',
            'Lakis',
            'Lalan',
            'Lalit',
            'Lalun',
            'Lampor',
            'Lanaar',
            'Landish',
            'Landreth',
            'Langbar',
            'Lanreex',
            'Lanscitt',
            'Lanteld',
            'Lantis',
            'Lantos',
            'Lanvilt',
            'Lanycth',
            'Lanzee',
            'Lanzept',
            'Larbrun',
            'Laresm',
            'Larid',
            'Larind',
            'Larkrosp',
            'Lasquor',
            'Lathir',
            'Lathmarc',
            'Latra',
            'Laudrin',
            'Laxar',
            'Laydor',
            'Layek',
            'Lazelle',
            'Ledmai',
            'Leela',
            'Leena',
            'Leerank',
            'Leesclar',
            'Leggwyt',
            'Leghast',
            'Lehun',
            'Leistorn',
            'Lembarl',
            'Lemgaar',
            'Lemtarn',
            'Lendra',
            'Lensith',
            'Lenzeel',
            'Lephais',
            'Lephern',
            'Leqquan',
            'Lerdeln',
            'Lerlya',
            'Lermest',
            'Lerquint',
            'Lestin',
            'Letek',
            'Lexan',
            'Lextraa',
            'Leystorne',
            'Lherache',
            'Lhusark',
            'Liance',
            'Libourne',
            'Lidrill',
            'Lilir',
            'Lilnid',
            'Liltar',
            'Limdal',
            'Limhoth',
            'Limka',
            'Limson',
            'Lindarl',
            'Lindlorn',
            'Linlaith',
            'Linmer',
            'Linor',
            'Linspar',
            'Lintan',
            'Lintra',
            'Liosse',
            'Liphrodd',
            'Lirram',
            'Lishran',
            'Liskeel',
            'Lissar',
            'Lisstar',
            'Lisstra',
            'Liston',
            'Lisvorn',
            'Litheem',
            'Lithrad',
            'Littwyst',
            'Lixelle',
            'Lixeth',
            'Lixter',
            'Lizki',
            'Lobror',
            'Logas',
            'Lohmi',
            'Loiarl',
            'Loomar',
            'Loorin',
            'Loorzig',
            'Loraem',
            'Loral',
            'Lorbis',
            'Lorrhin',
            'Lorrin',
            'Lorvra',
            'Lothilv',
            'Louwend',
            'Lovoz',
            'Loxzor',
            'Luast',
            'Lubist',
            'Lucenne',
            'Lufraut',
            'Lumas',
            'Lumfa',
            'Lunzar',
            'Lurand',
            'Lurash',
            'Lurin',
            'Luscan',
            'Lutril',
            'Luzfel',
            'Lyanec',
            "Lye\xfcm",
            'Lylix',
            'Lyra',
            'Lyrin',
            'Lyron',
            'Maaga',
            'Macra',
            'Macrad',
            'Maefon',
            'Maegwin',
            'Maerraent',
            'Magalph',
            'Maghan',
            'Maglone',
            'Magmarl',
            'Magnyck',
            'Mahhri',
            'Mahrik',
            'Maidah',
            'Maidak',
            'Mairish',
            'Maisa',
            'Maisan',
            'Majan',
            'Makamb',
            'Makisp',
            'Malak',
            'Malasc',
            'Malber',
            'Malboe',
            'Malda',
            'Maldock',
            'Malfar',
            'Malgrah',
            'Malheme',
            'Malinsp',
            'Malkorf',
            'Malnurb',
            'Malthen',
            'Maltheus',
            'Malthgri',
            'Malthor',
            'Malvisp',
            'Malwer',
            "Malzh\xe9",
            'Mandrask',
            'Manggrim',
            'Mankril',
            'Manthi',
            'Manton',
            "Ma\xf6l",
            'Mapyn',
            'Marack',
            'Maraide',
            'Marasp',
            'Marath',
            'Marax',
            'Marclaw',
            'Marcoorg',
            'Mardhrene',
            'Mardix',
            'Mardur',
            'Mareft',
            'Marhalk',
            'Marhart',
            'Marjaan',
            'Markryn',
            'Marlath',
            'Marlock',
            'Marnec',
            'Maroosh',
            'Marost',
            'Marrek',
            'Marrhal',
            'Marrhan',
            'Marril',
            'Marslin',
            'Marslai',
            'Martheel',
            'Marul',
            'Marvold',
            'Marwhool',
            'Mascrox',
            'Maskrulp',
            'Masplern',
            'Masply',
            'Masquoor',
            'Masryn',
            'Massac',
            'Mastram',
            'Mastrith',
            'Mastruse',
            'Mathgi',
            'Mathlin',
            'Mattraw',
            'Matzin',
            'Maularn',
            'Maundrib',
            'Maurdax',
            'Maustere',
            'Mavasce',
            'Mavic',
            'Mavkert',
            'Mavour',
            'Maxil',
            'Mayern',
            'Maylern',
            'Maylin',
            'Mayrime',
            'Mazzyott',
            'Medarm',
            'Meder',
            'Medist',
            'Meeratz',
            'Meffroa',
            'Mefron',
            'Meglos',
            'Megwen',
            'Mejea',
            'Mekosp',
            'Melaunce',
            'Meldresc',
            'Meleas',
            'Melib',
            'Melisk',
            'Meljarn',
            'Melkur',
            'Melleg',
            'Mellore',
            'Melnayl',
            'Melnyth',
            'Melshiv',
            'Melslem',
            'Melviig',
            'Mendra',
            'Mengisp',
            'Menksoor',
            'Menna',
            'Mephyr',
            'Merdim',
            'Merewn',
            'Merkal',
            'Merkan',
            'Merley',
            'Mermold',
            'Mermoth',
            'Merngar',
            'Merophe',
            'Merresh',
            'Merrest',
            'Merrost',
            'Merryn',
            'Mershun',
            'Mersic',
            'Mersna',
            'Merssan',
            'Merthyr',
            'Merweld',
            'Mesrah',
            'Mesrawn',
            'Mestorl',
            'Mestrin',
            'Methnos',
            'Metrosq',
            'Mevid',
            'Mezard',
            'Mhoran',
            'Mhordaal',
            'Mhovair',
            'Mhurdaal',
            'Mhyrrail',
            'Mianth',
            'Mibris',
            'Micrum',
            'Mida',
            'Midor',
            'Mifrax',
            'Migglin',
            'Mijar',
            'Mijhyk',
            'Mikird',
            'Mileern',
            'Milzrik',
            'Mimur',
            'Minom',
            'Minvra',
            'Minyal',
            'Miraad',
            'Mirach',
            'Mircheld',
            'Mirdain',
            'Mirdij',
            'Mirdole',
            'Mireth',
            'Mirglish',
            'Mirhaz',
            'Mirikke',
            'Mirja',
            'Mirjanth',
            'Mirjenx',
            'Mirkaise',
            'Mirkin',
            'Mirla',
            'Mirrash',
            'Mirrin',
            'Mirrym',
            'Mirtrax',
            'Miryash',
            'Mishaar',
            'Mishim',
            'Miskin',
            'Miskul',
            'Misrach',
            'Miszlar',
            'Mithbrin',
            'Mithlerb',
            'Mitrel',
            'Mivarch',
            'Mivrid',
            'Miwarl',
            'Mixtry',
            'Mizarl',
            'Mizma',
            'Mizrab',
            'Mlenjas',
            'Mlocber',
            'Mlodach',
            'Moda',
            'Mogorn',
            'Moirulse',
            'Molez',
            'Mollith',
            'Molnyx',
            'Molrin',
            'Molvigg',
            'Molvind',
            'Mommur',
            'Monmar',
            'Moondar',
            'Mooneld',
            'Moorith',
            'Moorlow',
            'Moormish',
            'Moran',
            'Morax',
            'Morcal',
            'Morchiss',
            'Mordak',
            'Mordlaw',
            'Mordoc',
            'Mordyle',
            'Moreth',
            'Morgath',
            'Morgleeg',
            'Morglin',
            'Morgmar',
            'Morgrim',
            'Morhain',
            'Morix',
            'Morktar',
            'Morla',
            'Morlig',
            'Morlosc',
            'Mornith',
            'Morrhan',
            'Morsklon',
            'Morssen',
            'Mortan',
            'Morthyld',
            'Morvaen',
            'Moryak',
            'Moshaol',
            'Mosyerl',
            'Moyank',
            'Mozoorb',
            'Mrossard',
            'Mubfusc',
            'Mubur',
            'Mudanc',
            'Mudaz',
            'Muhlenk',
            'Muilt',
            'Mungin',
            'Munin',
            'Murgaist',
            'Murhsan',
            'Mustile',
            'Muuthas',
            'Mygon',
            'Myndax',
            'Myrii',
            'Myrnar',
            'Myronce',
            'Myrrim',
            'Myrvarth',
            'Myrya',
            'Mysind',
            'Mysmak',
            'Naadem',
            'Naadra',
            'Naafa',
            'Naalvad',
            'Naasjerth',
            'Nabdoor',
            'Nabol',
            'Nadar',
            'Nadhil',
            'Nadin',
            'Nagai',
            'Naghir',
            'Nagist',
            'Nagvar',
            'Nahar',
            'Nahoul',
            'Naia',
            'Naidel',
            'Naidis',
            'Naidule',
            'Naidusk',
            'Naion',
            'Naisnim',
            'Naithool',
            'Nakrea',
            'Nalbis',
            'Naldecc',
            'Nalkleth',
            'Nalray',
            'Namail',
            'Namat',
            'Namoin',
            'Namvert',
            'Nandrulg',
            'Namphruk',
            'Nantarth',
            "Na\xf6k",
            'Napolx',
            'Naras',
            'Nardalg',
            'Naren',
            'Narev',
            'Nargath',
            'Narjath',
            'Narkrisst',
            'Naron',
            'Narqui',
            'Narsok',
            'Narthold',
            'Nartolth',
            'Narvi',
            'Narvik',
            'Nasank',
            'Nasir',
            'Natchai',
            'Natchren',
            'Natein',
            'Nathlim',
            'Nathor',
            'Nathraq',
            'Nautcheb',
            'Navai',
            'Navairnz',
            'Navar',
            'Navesm',
            'Nazaarl',
            'Ndola',
            'Nebcherl',
            'Nebron',
            'Nectesce',
            'Neelrix',
            'Neepmire',
            'Nefhorn',
            'Negert',
            'Negort',
            'Nelat',
            'Nelbron',
            'Nelesck',
            'Nelynn',
            'Nemstere',
            'Nemweal',
            'Nenaire',
            'Nengret',
            'Nephard',
            'Nephog',
            'Neri',
            'Nerish',
            'Neruus',
            'Nerveer',
            'Nesbin',
            'Neshkem',
            'Nesser',
            'Nestra',
            'Nesvan',
            'Nethelb',
            'Netskra',
            'Nevlyn',
            'Newhar',
            'Nexoz',
            'Nextar',
            'Nexxar',
            'Neywode',
            'Nezuel',
            'Nezzdak',
            'Niand',
            'Nibine',
            'Nibor',
            'Niconde',
            'Nictroi',
            'Nida',
            'Nifeld',
            'Nigil',
            "Nigr\xe4l",
            'Nijim',
            'Nijis',
            'Nikusp',
            'Nilgorm',
            'Nilnoi',
            'Nimbol',
            'Nimir',
            'Nimon',
            'Nimrede',
            'Nindiss',
            'Nireal',
            'Nirel',
            'Nirhain',
            'Nirhath',
            'Nirloge',
            'Nirnir',
            'Nisherj',
            'Nishla',
            'Nishmir',
            'Nishran',
            'Nissac',
            'Nissal',
            'Nithilt',
            'Nithlom',
            'Nitra',
            'Nivenk',
            'Nivgrom',
            'Nixin',
            'Nizoon',
            'Nizten',
            'Nogaarn',
            'Nokelm',
            'Nolfig',
            'Noloq',
            'Nolthar',
            'Noorlim',
            'Norahl',
            'Nordell',
            'Nordran',
            'Norfroib',
            'Norin',
            'Noroj',
            'Norstoj',
            'Novvulse',
            'Noxit',
            'Nrial',
            'Nuad',
            'Nubweft',
            'Nuendo',
            'Nuhar',
            'Nulka',
            'Nulvilch',
            'Nummag',
            'Nurgan',
            'Nurrzek',
            'Nuscolg',
            'Nushla',
            'Nuuzsal',
            'Nuxile',
            'Nuzain',
            'Nyankra',
            'Nyassaed',
            'Nybron',
            'Nyconth',
            'Nydaur',
            'Nyeon',
            'Nylray',
            'Nynaeve',
            'Nyra',
            'Nyren',
            'Nysra',
            'Oaffleg',
            'Oakine',
            'Oalilse',
            'Oalyn',
            'Oarine',
            'Obron',
            'Obtin',
            'Ocarg',
            'Oedjert',
            'Oeglath',
            'Oejos',
            'Oenu',
            'Oerusk',
            'Oggran',
            'Ogmarx',
            'Ogstlang',
            'Ohmir',
            'Ohmoul',
            'Ohrool',
            'Ohwhon',
            'Ohya',
            'Olanc',
            'Olbrod',
            'Olcind',
            'Oldaar',
            'Oldac',
            'Oleird',
            'Olesk',
            'Olgeerd',
            'Olisch',
            'Olix',
            'Olney',
            'Olthang',
            'Oluode',
            'Olvoor',
            'Omag',
            'Omazd',
            'Ombaast',
            'Omdret',
            'Omfelx',
            'Omkraum',
            'Omoq',
            'Omron',
            'Onchorl',
            'Ondar',
            'Onilsh',
            'Oninsp',
            'Onolk',
            'Onvrix',
            'Oonglax',
            'Ooxaith',
            'Opaor',
            'Opchel',
            'Opild',
            'Opmar',
            'Opult',
            'Oqueln',
            'Orasch',
            'Orayl',
            'Orbern',
            'Orbohst',
            'Orbweft',
            'Ordol',
            'Orgoch',
            'Orgrool',
            'Orhomb',
            'Orinde',
            'Orisse',
            'Orix',
            'Orjasp',
            'Orkuuz',
            'Orli',
            'Orlim',
            'Ormdrad',
            'Ormerd',
            'Ormuuz',
            'Ornault',
            'Ornith',
            'Oroon',
            'Orpax',
            'Orrisk',
            'Orsind',
            'Orskog',
            'Ortain',
            'Orthmar',
            'Ortholt',
            'Orthroy',
            'Ortkuz',
            'Orvulse',
            'Orwelt',
            'Orxlorn',
            'Osgleft',
            'Oshraal',
            'Osphel',
            'Ospin',
            'Osresp',
            'Ossiz',
            'Ossvule',
            'Osthandl',
            'Othast',
            'Ottlan',
            'Ovaile',
            'Ovar',
            'Owal',
            'Owelft',
            'Owlin',
            'Ouxroul',
            'Oxdren',
            'Oxiv',
            'Oxoor',
            'Ozur',
            'Padath',
            'Palaor',
            'Palew',
            'Palifte',
            'Palvem',
            'Palzac',
            'Pamar',
            'Paminsk',
            'Panarre',
            'Pancraf',
            'Pandak',
            'Pandire',
            'Paneesh',
            'Pangaz',
            'Paono',
            'Paraerg',
            'Parbha',
            'Pargask',
            'Pargus',
            'Parmist',
            'Parnon',
            'Paroul',
            'Parrsath',
            'Paslaive',
            'Paxilp',
            'Pazot',
            'Peaflod',
            'Pelas',
            'Pelase',
            'Pelcourj',
            'Pellin',
            'Pelnos',
            'Pelvest',
            'Pemnarsc',
            'Pendoir',
            'Pendra',
            'Pengarth',
            'Pengron',
            'Peraule',
            'Percaal',
            'Perdin',
            'Perdis',
            'Perisk',
            'Perlask',
            'Perral',
            'Perreld',
            'Perrinx',
            'Perthald',
            'Perzec',
            'Pevel',
            'Pexul',
            'Pezloch',
            'Phaithor',
            'Phaleg',
            'Phanstern',
            'Phaovonce',
            'Pharan',
            'Phargon',
            'Pharvis',
            'Phatuum',
            'Phayra',
            'Phenquor',
            'Phesjan',
            'Phinerc',
            'Phinna',
            'Phinra',
            'Phislid',
            'Phlomel',
            'Pholgon',
            'Phondath',
            'Phynynx',
            'Phyzent',
            'Pidnubb',
            'Pilark',
            'Pilkarn',
            'Pirkrod',
            'Pittheus',
            'Planget',
            'Plitkin',
            'Pluroign',
            'Pnakord',
            'Poddle',
            'Pohlon',
            'Pohnoor',
            'Poroon',
            'Porsthil',
            'Portlusce',
            'Praamon',
            'Praarin',
            'Prabaar',
            'Pravdile',
            'Pressar',
            'Presta',
            'Pretil',
            'Prilsorn',
            'Pritantte',
            'Pritjan',
            'Prollel',
            'Proter',
            'Prothoon',
            'Psattor',
            'Psirrim',
            'Pteron',
            'Pulaaz',
            'Pulisk',
            'Pumish',
            'Purrdiste',
            'Puuhilsk',
            'Puvas',
            'Pyalvar',
            'Pyra',
            'Pyrafe',
            'Pyreyn',
            'Pyrjus',
            'Pyular',
            'Pyzzim',
            'Qraatin',
            'Quaestrin',
            'Quagel',
            'Quagrith',
            "Qua\xefve",
            'Quaman',
            'Quamrith',
            'Quanar',
            'Quanthon',
            'Quantra',
            'Quanvire',
            'Quardan',
            'Quargom',
            'Quarnos',
            'Quarouth',
            'Quasha',
            'Queageth',
            'Quedrech',
            'Queeden',
            'Queeyat',
            'Quekal',
            'Quelade',
            'Queldrim',
            'Quelges',
            'Quelneth',
            'Quelthar',
            'Quembras',
            'Quenna',
            'Querkez',
            'Querlo',
            'Queryl',
            'Quesan',
            'Quesparl',
            'Quesrol',
            'Quevros',
            'Queygo',
            'Quiddel',
            'Quidre',
            'Quigmoss',
            'Quilmose',
            'Quinaut',
            'Quindle',
            'Quinga',
            'Quinid',
            'Quintarl',
            'Quirrak',
            'Quirvell',
            'Quisrym',
            'Quizlo',
            'Quolbin',
            'Quondoon',
            'Quuddreus',
            'Quyssa',
            'Raaxis',
            'Raband',
            'Raberm',
            'Rablaen',
            'Rabuur',
            'Raccyx',
            'Racere',
            'Radalt',
            'Raddel',
            'Radeld',
            "Ra\xebn",
            "Ra\xebss",
            'Raethel',
            'Raevact',
            'Rafain',
            'Rafam',
            'Rafarn',
            'Rafmarth',
            'Raftwen',
            'Rafur',
            'Ragdra',
            'Ragen',
            'Rago',
            'Rahaz',
            'Raina',
            "Ra\xefre",
            'Raishauer',
            'Raistlig',
            'Raistoc',
            'Rajan',
            'Rajin',
            'Raju',
            'Rakeeg',
            'Rakhan',
            'Rakhaz',
            'Rakheer',
            'Rakkim',
            'Rakspire',
            'Rakthvi',
            'Ralik',
            'Ralir',
            'Ralise',
            'Ralith',
            'Ralkeev',
            'Ralvord',
            'Ramat',
            'Ramath',
            'Ranax',
            'Randar',
            'Randor',
            'Ranghen',
            'Rangvair',
            'Rani',
            'Ranid',
            'Ranousse',
            'Ranthur',
            "Ran\xfbk",
            'Ranyem',
            'Rascha',
            'Rascrag',
            'Raslak',
            'Rasmoth',
            'Rastagg',
            'Rastak',
            'Ratai',
            'Rater',
            'Rathdome',
            'Rathgor',
            'Rathlede',
            'Rathor',
            'Raudal',
            'Raudell',
            'Ravann',
            'Ravoe',
            'Ravthek',
            'Raxar',
            'Raxen',
            'Razdan',
            'Razdel',
            'Razul',
            'Rebesc',
            'Reddom',
            'Redlac',
            'Redleth',
            'Reeval',
            'Reevast',
            'Regwelf',
            'Relem',
            'Rellskar',
            'Rellzer',
            'Relmnar',
            'Relmund',
            'Relthar',
            'Remerst',
            'Remist',
            'Renair',
            'Rendkett',
            'Rendlorn',
            'Renjik',
            'Renlaw',
            'Renna',
            'Renquil',
            'Resfrith',
            'Reskem',
            'Resna',
            'Ressif',
            'Restid',
            'Retheer',
            'Retor',
            'Retraaj',
            'Reuzor',
            'Revas',
            'Reyga',
            'Reyna',
            'Rezbain',
            'Rezhar',
            'Rhamaine',
            'Rhandain',
            'Rhavee',
            'Rhaxdan',
            'Rhenea',
            'Rheya',
            'Rhila',
            'Rhiorn',
            'Rhobban',
            'Rhodelx',
            'Rhojann',
            'Rhylash',
            'Riaal',
            'Riak',
            'Ribos',
            'Ridun',
            'Ridya',
            'Rience',
            'Rifdos',
            'Rifgild',
            'Rigar',
            'Riklak',
            'Riksul',
            'Rila',
            'Rillif',
            'Rillu',
            'Rilmorn',
            'Rimchoze',
            'Rimnaaj',
            'Rimsall',
            'Ringool',
            'Rinquel',
            'Rinthmaw',
            'Ripurth',
            'Risnys',
            'Ristang',
            'Riswod',
            'Rivalke',
            'Rivarsh',
            'Rivcol',
            'Riveld',
            'Riverle',
            'Rivlin',
            'Rivoold',
            'Rivrook',
            'Rivvid',
            'Rixel',
            'Rixju',
            'Rizhad',
            'Rizzek',
            "Ro\xe4k",
            'Roakey',
            'Roandat',
            'Robforz',
            'Rocaltz',
            'Rodan',
            'Rodhar',
            "Ro\xeble",
            "Ro\xebll",
            'Roethord',
            'Rofloef',
            'Rokeel',
            'Rolthar',
            "R\xf6lyat",
            'Rontayn',
            'Roolenth',
            'Roqual',
            'Rorkar',
            'Rothar',
            'Roujat',
            'Roweal',
            'Roxhaast',
            'Royanse',
            'Royskyar',
            'Rubarj',
            'Rubiss',
            'Rudrisk',
            'Ruidh',
            'Rukhjan',
            'Rukuz',
            'Rulbowe',
            'Rulmool',
            'Rumael',
            'Rupaic',
            'Rupsey',
            'Rurik',
            'Rusgar',
            'Rusis',
            'Ruther',
            'Ruusul',
            'Ruvad',
            'Ruwen',
            'Ryalas',
            'Rygarn',
            'Rynell',
            'Rynrys',
            'Rysta',
            'Sabak',
            'Sabal',
            'Sabfane',
            'Sabhel',
            'Sabon',
            'Sabrok',
            'Sador',
            'Sadrouth',
            'Saerdon',
            'Saerulse',
            'Safrence',
            'Safrine',
            'Sagard',
            'Saglamne',
            'Saia',
            'Saihail',
            'Saijax',
            'Salir',
            'Sallese',
            'Samand',
            'Samar',
            'Sambrea',
            'Samler',
            'Sanald',
            'Sanan',
            'Sanar',
            'Sandice',
            'Sangol',
            'Sankor',
            'Sanpalk',
            'Sanrind',
            'Sanrow',
            'Sansal',
            'Santlor',
            'Santrul',
            'Saphyx',
            'Sarbrid',
            'Sarcyn',
            'Sardrum',
            'Sarel',
            'Sarex',
            'Sarfinn',
            'Sargash',
            'Sarik',
            'Sarla',
            'Sarlyn',
            'Sarmuld',
            'Sarnax',
            'Sarode',
            'Saroon',
            'Sarthath',
            'Sarthay',
            'Saruul',
            'Sarvan',
            'Sateer',
            'Sathla',
            'Saudraal',
            'Saugrib',
            'Savak',
            'Savar',
            'Savaunce',
            'Savay',
            'Savot',
            'Savryn',
            'Saxar',
            'Scamire',
            'Scarloth',
            'Scaroth',
            'Scarvlin',
            'Schabith',
            'Scharay',
            'Sclava',
            'Scolath',
            'Scradast',
            'Scrilisp',
            'Searan',
            'Seckba',
            'Sedrim',
            'Seethenn',
            'Segrold',
            'Seheitt',
            'Sejar',
            'Selar',
            'Seldar',
            'Selgren',
            'Selith',
            'Selkind',
            'Selnor',
            'Selris',
            'Selthen',
            'Sember',
            'Sembrith',
            'Semer',
            'Semisk',
            'Sena',
            'Sendrej',
            'Sendure',
            'Sengeld',
            'Senrin',
            'Senther',
            'Sentix',
            'Seonce',
            'Sephrone',
            'Seplacc',
            'Seprism',
            'Seraan',
            'Seranth',
            'Seray',
            'Serdu',
            'Sereste',
            'Serlarc',
            'Sermer',
            'Seroz',
            'Serrof',
            'Serryx',
            'Sersoom',
            'Sertase',
            'Seskel',
            'Sethar',
            'Sethchell',
            'Sethjen',
            'Sethran',
            "Sfa\xebl",
            'Sfennec',
            'Sferaj',
            'Sforakh',
            'Shabrum',
            'Shadar',
            'Shagold',
            'Shahile',
            'Shaifarl',
            'Shalun',
            'Shalvir',
            'Shamad',
            'Shanfa',
            'Sharaq',
            'Sharaz',
            'Sharrak',
            'Sharrel',
            'Sharva',
            'Sharzik',
            'Shastor',
            'Shathak',
            'Shaxa',
            'Shaydayl',
            'Sheerah',
            'Shembis',
            'Shenesk',
            'Shetrax',
            'Shezael',
            'Shiaf',
            'Shialk',
            'Shila',
            'Shilex',
            'Shimar',
            'Shimglor',
            'Shimren',
            'Shintar',
            'Shirak',
            'Shivan',
            'Shiza',
            'Sholmeg',
            'Shruuminth',
            'Shryffin',
            'Shudleet',
            'Shurik',
            'Shurrug',
            'Shyden',
            'Shylath',
            'Siade',
            'Sibvir',
            'Sidron',
            'Sierl',
            'Sila',
            'Silcharn',
            'Sildeed',
            'Silgast',
            'Silgool',
            'Siljenk',
            'Silmat',
            'Silon',
            'Silphane',
            'Silruum',
            'Silure',
            'Silvasp',
            'Silvryn',
            'Simbrul',
            'Sindhi',
            'Siol',
            'Siralk',
            'Sithirg',
            'Sium',
            'Skaaro',
            'Skagra',
            'Skarazk',
            'Skarloch',
            'Skayla',
            'Skedrea',
            'Skeltrin',
            'Skilon',
            'Skorafe',
            'Skurin',
            'Slanslar',
            'Slanthar',
            'Slarood',
            'Slaskren',
            'Slavgar',
            'Slazor',
            'Sleekla',
            'Sleshkeg',
            'Sleynux',
            'Slijash',
            'Slorac',
            'Slurvaum',
            'Smarag',
            'Smerdis',
            'Smialv',
            'Snargai',
            'Snayrod',
            'Sneitad',
            'Snurlix',
            'Sobeck',
            'Sodarg',
            'Solael',
            'Solbar',
            'Soldine',
            'Solis',
            'Solohe',
            'Solok',
            'Solos',
            'Soltar',
            'Sombrid',
            'Sophald',
            'Sorak',
            'Sorgas',
            'Sormtor',
            'Sorquoon',
            'Sorren',
            'Sorven',
            'Sorza',
            'Sotar',
            'Soveh',
            'Soydil',
            'Spalant',
            'Spandrell',
            'Sparveld',
            'Sperax',
            'Spereld',
            'Spirach',
            'Splinvek',
            'Sprimaine',
            'Squamgreve',
            'Srajsken',
            'Sraknis',
            'Sramine',
            'Srebold',
            'Sreeva',
            'Srendix',
            'Srennant',
            'Sriddoth',
            'Sroika',
            'Sroweb',
            'Sryxla',
            'Stajesce',
            'Stalfess',
            'Starklyn',
            'Staygus',
            'Steeglorn',
            'Stengos',
            'Stereth',
            'Steylin',
            'Sthygron',
            'Stielle',
            'Stirgan',
            'Stornrafe',
            'Strakhan',
            'Strakkar',
            'Streggen',
            'Struquil',
            'Stryast',
            'Strylax',
            'Subreen',
            'Suggner',
            'Sujaim',
            'Sulgra',
            'Sulji',
            'Sulmsy',
            'Sulnseir',
            'Sundoth',
            'Sunjeade',
            'Surast',
            'Surigg',
            'Surjan',
            'Surpy',
            'Susstark',
            'Susteelk',
            'Susur',
            'Sutekh',
            'Suukeeg',
            'Suulkas',
            'Suunall',
            'Suvael',
            'Suvrin',
            'Svringal',
            'Swarflig',
            'Swarro',
            'Swendril',
            'Swiez',
            'Syanor',
            'Sybra',
            'Sylfrix',
            'Sylvine',
            'Sylvyn',
            'Symnar',
            'Syphtar',
            'Syrag',
            'Syran',
            'Syssahz',
            'Syzaash',
            'Taarna',
            'Tabrind',
            'Tachel',
            'Tacrine',
            'Tadra',
            'Taedel',
            'Taennyn',
            'Taeral',
            'Taeya',
            'Tagor',
            'Taher',
            'Tahrjun',
            'Taiwine',
            'Talanth',
            'Talar',
            'Taldar',
            'Taleeg',
            'Taled',
            'Talesm',
            'Talgan',
            'Talgraine',
            'Talgyr',
            'Talisk',
            'Talith',
            'Talor',
            'Talthran',
            'Talune',
            'Talven',
            'Talver',
            'Tamar',
            'Tamnuz',
            'Tamone',
            'Tamoorn',
            'Tamriss',
            'Tanchilt',
            'Tandro',
            'Tanha',
            'Tanisk',
            'Tanlin',
            'Tanndo',
            'Tanoor',
            'Tanry',
            "Tan\xfbr",
            'Tanzel',
            'Tanzlor',
            'Taosar',
            'Taoyot',
            'Taran',
            'Tarath',
            'Tarax',
            'Tarcen',
            'Tareth',
            'Tarik',
            'Tarin',
            'Tarisk',
            'Tarith',
            'Tarkand',
            'Tarkrog',
            'Tarlmar',
            'Tarnor',
            'Taron',
            'Taroyn',
            'Tarqu',
            'Tarxas',
            'Tasharg',
            'Tashforn',
            'Tashlex',
            'Tashu',
            'Tashuul',
            'Tasrak',
            'Tasselt',
            'Tasvoor',
            'Taulin',
            'Taval',
            'Tavan',
            'Tavon',
            'Taxlon',
            'Tayerl',
            'Taylin',
            'Tayrsil',
            'Tazen',
            'Tazine',
            'Tchasko',
            'Tealryn',
            'Teawar',
            'Tebish',
            'Tedra',
            'Teekah',
            'Teekug',
            'Teerlin',
            'Tefaz',
            'Tefleer',
            'Tegan',
            'Tegglyn',
            'Tegoth',
            'Teiresh',
            'Teirna',
            'Telaer',
            'Telast',
            'Telcarn',
            'Telett',
            'Telglas',
            'Telgrest',
            'Telkarr',
            'Tellan',
            'Telnar',
            'Telnoom',
            'Telsar',
            'Telva',
            'Telzley',
            'Temorg',
            'Tempros',
            'Tened',
            'Tenelle',
            'Tenjal',
            'Tenlor',
            'Tenna',
            'Tensfar',
            'Tentil',
            'Teode',
            'Terare',
            'Terglaw',
            'Tergon',
            'Terlkin',
            'Terlyn',
            'Ternasse',
            'Terragg',
            'Terris',
            'Tershar',
            'Terslond',
            'Tesin',
            'Teslan',
            'Tevrin',
            'Teyvrilt',
            'Thabou',
            'Thadrum',
            'Thaiduk',
            'Thaki',
            'Thalarn',
            'Thalax',
            'Thaldok',
            'Thamin',
            'Thandart',
            'Thandrov',
            'Thandusc',
            'Thangor',
            'Tharbad',
            'Tharbolt',
            'Tharij',
            'Tharis',
            'Tharjun',
            'Tharkesh',
            'Tharquist',
            'Tharsna',
            'Tharxac',
            'Thaskam',
            'Thaval',
            'Thavarl',
            'Thawlton',
            'Thaxid',
            'Thaxis',
            'Thaxmool',
            'Thaxnar',
            'Thayvudd',
            'Theandra',
            'Thebek',
            'Thelbor',
            'Theleb',
            'Thelin',
            'Thelred',
            'Themnon',
            'Theras',
            'Therbur',
            'Therrak',
            'Therras',
            'Therrat',
            'Thervoh',
            'Thesi',
            'Thesstor',
            'Thibkern',
            'Thimmoz',
            'Thinhla',
            'Thiob',
            'Thios',
            'Thirlain',
            'Thirrild',
            'Thomilt',
            'Thondrac',
            'Thorgeir',
            'Thornix',
            'Thorskal',
            'Thorztar',
            'Thorzyl',
            'Thoskold',
            'Thoye',
            'Thranor',
            'Thraxil',
            'Thremek',
            'Thremix',
            'Thrindish',
            'Thrinyr',
            'Thrykar',
            'Thryxeer',
            'Thugar',
            'Thuldudge',
            'Thulsa',
            'Thurdis',
            'Thuvgalt',
            'Thyra',
            'Thyzlont',
            'Tiaft',
            'Tiak',
            'Tian',
            'Ticham',
            'Tiffrod',
            'Tihan',
            'Tika',
            'Tilal',
            'Tilir',
            'Timaas',
            'Timak',
            'Timdos',
            'Tira',
            'Tiralle',
            'Tirhthri',
            'Tirkan',
            'Tirnor',
            'Tirouv',
            'Tirvil',
            'Tislim',
            'Tisreth',
            'Tisseth',
            'Tithesb',
            'Tivaln',
            'Tlembic',
            'Tlichgo',
            'Tlishat',
            'Tobar',
            'Todyc',
            'Toglank',
            'Tokath',
            'Tokkreft',
            'Tokraz',
            'Tolgarm',
            'Toma',
            'Tonom',
            'Torak',
            'Torang',
            'Torbelt',
            'Torbold',
            'Torden',
            'Toreth',
            'Torghai',
            'Tormir',
            'Torsund',
            'Torthar',
            'Torvin',
            'Torxar',
            'Toscrah',
            'Tourrhok',
            'Tovak',
            'Tovis',
            'Toxathe',
            'Tozjroch',
            'Traalyr',
            'Traken',
            'Tramorn',
            'Trantain',
            'Trantle',
            'Trasven',
            'Travech',
            'Trazom',
            'Tredek',
            'Treeplin',
            'Treffaun',
            'Trefoin',
            'Treizeng',
            'Tremas',
            'Treof',
            'Treslont',
            'Tressak',
            'Trevarq',
            'Trevul',
            'Tricoj',
            'Tridusk',
            'Trilinn',
            'Trisgil',
            'Tristak',
            'Trithax',
            'Triveark',
            'Trizdoth',
            'Troiom',
            'Tromest',
            'Tronvel',
            'Troulden',
            'Trujko',
            'Tsarlit',
            'Tsavan',
            'Tsodjan',
            'Tsojwar',
            'Tsorak',
            'Tuane',
            'Tuchror',
            'Tudlech',
            'Tuezinth',
            'Tugan',
            'Tulkas',
            'Tulsoorm',
            'Tuntix',
            'Turan',
            'Turmasc',
            'Turmis',
            'Turvoost',
            'Turweld',
            'Turzeal',
            'Tuuraj',
            'Tvejasp',
            'Twenja',
            'Twinaile',
            'Twixtib',
            'Tyasaj',
            'Tydwyk',
            'Tylark',
            'Tylith',
            'Tylnen',
            'Tymarl',
            'Tymdrak',
            'Tyrbast',
            'Tyrdon',
            'Tyreen',
            'Tyrgyre',
            'Tyrinx',
            'Tyrlon',
            'Tyrum',
            'Tzichrism',
            'Tzilen',
            'Tziphrin',
            'Udraam',
            'Ufang',
            'Ufoin',
            'Ulak',
            'Ulfade',
            'Ullfrax',
            'Ulli',
            'Ulmyst',
            'Ulos',
            'Ulphar',
            'Ulsplasm',
            'Umbrask',
            'Umbresk',
            'Umchor',
            'Umleer',
            'Ummice',
            'Undreet',
            'Unfegg',
            'Ungax',
            'Unstric',
            'Unstrix',
            'Untveld',
            'Unza',
            'Uqbar',
            'Urdaa',
            'Urdain',
            'Urdal',
            'Urdryce',
            'Urlyn',
            'Urrind',
            'Urthryn',
            'Urtond',
            'Urwoon',
            'Urzvir',
            'Ushnee',
            'Usquik',
            'Ussart',
            'Ussfaal',
            'Ussit',
            'Usstrilt',
            'Ustar',
            'Ustiln',
            'Ustlin',
            'Ustor',
            'Ustorne',
            'Ustrelm',
            'Usxald',
            'Uthmal',
            'Uthnor',
            'Uvorne',
            'Uzfron',
            'Uztum',
            'Vacla',
            'Vadein',
            'Vadrelj',
            'Vadri',
            'Vadru',
            'Vaeddyn',
            'Vaelythe',
            "Va\xebrn",
            'Vagar',
            'Vaigthlu',
            'Vaitarr',
            'Valan',
            'Valaz',
            'Valbard',
            'Valek',
            'Valen',
            'Valeth',
            'Valgaard',
            'Valgar',
            'Valgarv',
            'Valka',
            'Valkarth',
            'Valken',
            'Valkesh',
            'Valkis',
            'Valkyr',
            'Valmisce',
            'Valreque',
            'Valtarb',
            'Valthoth',
            'Valyn',
            'Vamert',
            'Vamfade',
            'Vanache',
            'Vanek',
            'Vanger',
            'Vannak',
            'Vannyn',
            'Vanra',
            'Vantsled',
            'Vanyar',
            'Vaona',
            'Varat',
            'Varda',
            'Vareth',
            'Varga',
            'Varka',
            'Varlik',
            'Varmon',
            'Varmyr',
            'Varna',
            'Varnac',
            'Varnar',
            'Varnax',
            'Varnaz',
            'Varos',
            'Varrow',
            'Varsta',
            'Vartoor',
            'Vasaav',
            'Vascais',
            'Vasrind',
            'Vathan',
            'Vathar',
            'Vathek',
            'Vaudric',
            'Vayas',
            'Vaydir',
            'Vayi',
            'Vazar',
            'Vazdo',
            "Ve\xe4xe",
            'Veena',
            'Vegreth',
            'Vekil',
            'Velaunce',
            'Veldan',
            'Veldin',
            'Velex',
            'Velkind',
            'Velnard',
            'Velsant',
            'Velsard',
            'Velsin',
            'Vembrex',
            'Venast',
            'Vendik',
            'Vengkuld',
            'Venklar',
            'Vennec',
            'Vennsor',
            'Venscoth',
            'Ventorl',
            'Venzra',
            'Veor',
            'Verek',
            'Verisse',
            'Verla',
            'Verlis',
            'Vernar',
            'Vernat',
            'Vernil',
            'Veror',
            'Verren',
            'Vertence',
            'Vervitz',
            'Verwantz',
            'Verxain',
            'Verzod',
            'Veskin',
            'Veswinch',
            'Veyen',
            'Vherla',
            'Viaxx',
            'Vibsoom',
            'Vibur',
            'Vilgrax',
            'Vilraj',
            'Vilsa',
            'Vilthod',
            'Viltor',
            'Viltorc',
            'Vingverd',
            'Virainth',
            'Viran',
            'Virdla',
            'Viscanth',
            'Visharn',
            'Viskrek',
            'Vissir',
            'Vistar',
            'Vistarl',
            'Vithmard',
            'Viux',
            'Vixa',
            'Vixai',
            'Vixlim',
            'Vlastov',
            'Vlitchek',
            'Vluisc',
            'Vlustra',
            'Volcilde',
            'Voldor',
            'Volnir',
            'Vomquind',
            'Vonir',
            'Voozale',
            'Vordnaz',
            'Vorgan',
            'Vorplen',
            'Vorrmor',
            'Vorshak',
            'Vortice',
            'Vosklune',
            'Votorn',
            'Votrax',
            'Voxarl',
            'Vozkoog',
            'Vratund',
            'Vreeleth',
            'Vregom',
            'Vrithon',
            'Vrumtuun',
            'Vryxnir',
            'Vuespra',
            'Vuestri',
            'Vulpix',
            'Vuranc',
            'Vurick',
            'Vurog',
            'Vuron',
            'Vuubul',
            'Vynda',
            'Vyrnael',
            'Vywyn',
            'Vzoris',
            'Wadziq',
            'Waeytef',
            'Wairbren',
            'Walgwim',
            'Wallibt',
            'Walscrin',
            'Wanelj',
            'Wanjok',
            'Wannach',
            'Wanruum',
            'Wanthim',
            'Warbosk',
            'Warell',
            'Warisk',
            'Warthan',
            'Waryn',
            'Wastur',
            'Waylra',
            'Waznak',
            'Weardlon',
            'Wedjeeg',
            'Wedra',
            'Weftig',
            'Weftorb',
            'Weitvan',
            'Welfrede',
            'Welmek',
            'Welndar',
            'Wemsin',
            'Wendath',
            'Weppel',
            'Werclam',
            'Werin',
            'Weshap',
            'Weskin',
            'Westra',
            'Wevkinz',
            'Wextri',
            'Whilfig',
            'Whilmor',
            'Wicrore',
            'Wileert',
            'Wilnim',
            'Wilven',
            'Wilzech',
            'Wirreth',
            'Wirzanth',
            'Wistril',
            'Witrix',
            'Witrost',
            'Wizlow',
            'Wolcharn',
            'Wolkoon',
            'Wolnihr',
            'Worlit',
            'Wraxil',
            'Wrybeck',
            'Wryplax',
            'Wryxerg',
            'Wubneft',
            'Wulfrit',
            'Wurflense',
            'Wusheig',
            'Wuunal',
            'Wuxorn',
            'Wychnor',
            'Wylvin',
            'Wyndbrel',
            'Wyndra',
            'Wyrgon',
            'Wyrsis',
            'Wysholt',
            'Wyvrax',
            'Wyxef',
            'Xadair',
            'Xaedra',
            'Xaelinth',
            'Xaharl',
            'Xaidis',
            'Xaitchek',
            'Xaldreth',
            'Xalkhas',
            'Xalla',
            'Xallath',
            'Xameld',
            'Xanax',
            'Xanbarg',
            'Xandar',
            'Xandrix',
            'Xanille',
            'Xanna',
            'Xanos',
            'Xanrei',
            'Xanthon',
            'Xarafe',
            'Xarakh',
            'Xarek',
            'Xasim',
            'Xaudrin',
            'Xavest',
            'Xavin',
            'Xawnis',
            'Xaxul',
            'Xayide',
            'Xeebract',
            'Xeerha',
            'Xejem',
            'Xela',
            'Xeldon',
            'Xellosp',
            'Xenerge',
            'Xenir',
            'Xephar',
            'Xerra',
            'Xerxisp',
            'Xerys',
            'Xexal',
            'Xhagrim',
            'Xhaibar',
            'Xhomdroll',
            'Xhorald',
            'Xigil',
            'Xion',
            'Xiplin',
            'Xiri',
            'Xirrip',
            'Xloris',
            'Xoncarg',
            'Xopon',
            'Xoris',
            'Xormeer',
            'Xothun',
            'Xovro',
            'Xudeet',
            'Xulan',
            'Xundrahl',
            'Xustral',
            "Xy\xe1s",
            "Xy\xe1st",
            'Xybeuth',
            'Xycort',
            'Xydorn',
            'Xydra',
            'Xygbenth',
            'Xyhaek',
            'Xykrog',
            'Xylance',
            'Xylarz',
            'Xylvorm',
            'Xymoyl',
            'Xytrin',
            'Yaalder',
            'Yaathab',
            'Yadarl',
            'Yaddith',
            'Yadel',
            'Yadreth',
            'Yadurk',
            'Yaglaid',
            'Yagmoon',
            'Yaklar',
            'Yaklin',
            'Yako',
            'Yakthoob',
            'Yammoth',
            'Yamphut',
            'Yandorn',
            "Ya\xf6th",
            'Yarat',
            'Yarel',
            'Yari',
            'Yarin',
            'Yarnis',
            'Yarram',
            'Yastoz',
            'Yaten',
            'Yatheg',
            'Yavarre',
            'Yavood',
            'Yavroun',
            'Yazlar',
            'Ycore',
            'Yeafosk',
            'Yeifolk',
            'Yeldoj',
            'Yeldrai',
            'Yeoft',
            'Yeoun',
            'Yerdeen',
            'Yergal',
            'Yerkel',
            'Yernoold',
            'Yethler',
            'Yewrapt',
            'Yexil',
            'Yezrik',
            'Yhemnis',
            'Yhemog',
            'Yhoudeh',
            'Yiash',
            'Yildiz',
            'Yilkeyr',
            'Yimzuuem',
            'Yinaun',
            'Yiod',
            'Yirod',
            'Yivthi',
            'Ymar',
            'Ymarl',
            'Yodkin',
            'Yojra',
            'Yombris',
            'Yoorzamph',
            'Yoppulse',
            'Yorim',
            'Yorlask',
            'Yorrak',
            'Yoskan',
            'Yosneth',
            'Yothir',
            'Yottoa',
            'Yrdirr',
            'Yrgash',
            'Yrgil',
            'Yrinth',
            'Yrlmar',
            'Yrvoor',
            'Yuklat',
            'Yuleng',
            'Yurisp',
            'Yuvib',
            'Yuzan',
            'Yween',
            'Zaalit',
            'Zabal',
            'Zabil',
            'Zadko',
            'Zadom',
            'Zadool',
            'Zaelken',
            'Zaery',
            'Zaffar',
            'Zagrosk',
            'Zahur',
            'Zaihra',
            'Zalethe',
            'Zalmic',
            'Zalthen',
            'Zamar',
            'Zamewl',
            'Zamind',
            'Zamog',
            'Zamray',
            'Zanak',
            'Zaneer',
            'Zangor',
            'Zanqua',
            'Zantain',
            'Zanthu',
            'Zantir',
            'Zantyen',
            'Zanurb',
            'Zarak',
            'Zaranthe',
            'Zardal',
            'Zardence',
            'Zardirm',
            'Zardox',
            'Zargoi',
            'Zaric',
            'Zarlon',
            'Zarmarl',
            'Zarouk',
            'Zarphaut',
            'Zarquar',
            'Zarquemf',
            'Zarros',
            'Zarthule',
            'Zastor',
            'Zatarl',
            'Zatheen',
            'Zathras',
            'Zathu',
            'Zatoum',
            'Zausric',
            'Zavach',
            'Zavak',
            'Zavel',
            'Zaviv',
            'Zaxweer',
            'Zayarn',
            'Zaydrim',
            'Zebor',
            'Zebulse',
            'Zedresk',
            'Zefteel',
            'Zehain',
            'Zehirn',
            'Zekal',
            'Zeldaph',
            'Zelgad',
            'Zelgen',
            'Zelisp',
            'Zelked',
            'Zelmarth',
            'Zelminx',
            'Zelvant',
            'Zembis',
            'Zendarg',
            'Zentos',
            'Zeraa',
            'Zerai',
            'Zerakl',
            'Zermish',
            'Zerric',
            'Zervid',
            'Zesdick',
            'Zessain',
            'Zethrel',
            'Zhaizald',
            'Zhakoor',
            'Zhalore',
            'Zhantaine',
            'Zhapris',
            'Zharmele',
            'Zharvek',
            'Zhassa',
            'Zhawend',
            'Zhaya',
            'Zheral',
            'Zhirek',
            'Zhirem',
            'Zhiroq',
            'Zhirquis',
            'Zhogri',
            'Zhomrach',
            'Zhoreb',
            'Zhrana',
            'Zigmoth',
            'Zikuyth',
            'Zilar',
            'Zilmork',
            'Zincir',
            'Zindor',
            'Ziorn',
            'Zirin',
            'Zishuun',
            'Zislun',
            'Zisurgh',
            "Zlant\xe9",
            'Zlatos',
            'Zofram',
            'Zoides',
            'Zojan',
            'Zohldrom',
            'Zolfran',
            'Zoltaft',
            'Zomra',
            'Zondar',
            'Zoorkon',
            'Zopine',
            'Zorac',
            'Zorith',
            'Zorlan',
            'Zorthal',
            'Zosarde',
            'Zrufend',
            'Zugdin',
            'Zugoth',
            'Zuril',
            'Zusdhrun',
            'Zuukan',
            'Zvegnaz',
            'Zyjin',
            'Zyla',
            'Zylaax',
            'Zylyn',
            'Zyrel',
            'Zyrelx',
            'Zytan',
            'Zyxim'
        ],
        three: [
            'Aathoklaa',
            'Abalore',
            'Abeli',
            'Abreyxorn',
            'Abrisen',
            'Acaena',
            'Acamar',
            'Acarnod',
            'Ackia',
            'Acozer',
            'Acravel',
            'Actinor',
            'Adalon',
            'Adalrik',
            'Adanac',
            'Adasho',
            'Adelin',
            'Adelir',
            'Adembal',
            'Aderak',
            'Aderel',
            'Aderyn',
            'Adhara',
            'Adhirman',
            'Adia',
            'Adian',
            'Adiol',
            'Aditu',
            'Adlaron',
            'Admarlen',
            'Adnirrin',
            'Adnoren',
            'Adracea',
            'Adraeran',
            'Adraewyth',
            'Adrasta',
            'Adrena',
            'Adriphaas',
            'Aelarim',
            'Aerissa',
            'Aeruin',
            'Aetharyn',
            'Aexien',
            'Afaellan',
            'Agador',
            'Agaki',
            'Agari',
            'Agella',
            'Agerquon',
            'Agetan',
            'Agexa',
            'Aginor',
            'Agior',
            'Agnaska',
            'Agraia',
            'Agrasline',
            'Agrasol',
            'Agrias',
            'Agristair',
            'Ahina',
            'Ahorra',
            'Aidaron',
            'Aililry',
            'Ainnatic',
            'Aioula',
            'Aircristir',
            'Aistomar',
            'Ajasonde',
            'Akajur',
            'Akashic',
            'Akasta',
            'Akenchi',
            'Akhrida',
            'Akiina',
            'Akirga',
            'Akirku',
            'Akritas',
            'Akura',
            'Akvaron',
            'Alamak',
            'Alanik',
            'Alanyx',
            'Alardan',
            'Alaris',
            'Alarynd',
            'Alathen',
            'Alatvair',
            'Alaxa',
            'Alaztyr',
            'Albara',
            'Albaral',
            'Alberist',
            'Alberon',
            'Alceon',
            'Alceor',
            'Alchica',
            'Aldachur',
            'Aldaka',
            'Aldamir',
            'Aldirim',
            'Aldrella',
            'Aleasna',
            'Aleaxa',
            'Aleena',
            'Aleidar',
            'Alembis',
            'Alera',
            'Aleva',
            'Alfanar',
            'Alhana',
            'Alidar',
            'Aliet',
            'Alifyan',
            'Alinaeus',
            'Alindra',
            'Alixa',
            'Aljarik',
            'Alkaios',
            'Allindren',
            'Allomir',
            'Alloran',
            'Almarisc',
            'Almeron',
            'Almiel',
            'Alnavor',
            'Alshagrel',
            'Altavan',
            'Altorlan',
            'Altria',
            'Alucard',
            'Alzamar',
            'Alzarin',
            'Amadis',
            'Amadix',
            'Amafer',
            'Amaja',
            'Amakelb',
            'Amanster',
            'Amaremne',
            'Amarette',
            'Amatin',
            'Amazya',
            'Ambrezul',
            'Amelis',
            'Amerill',
            'Amether',
            'Amethi',
            'Amharad',
            'Amilin',
            'Aminak',
            'Amintor',
            'Amlieth',
            'Amolithe',
            'Amorin',
            'Ampenden',
            'Amramyr',
            'Anandra',
            'Anara',
            'Anartig',
            'Anashea',
            'Anatsath',
            'Ancelyn',
            'Ancifer',
            'Andaraan',
            'Andistair',
            'Andolan',
            'Andrasha',
            'Andula',
            'Aneelen',
            'Anfara',
            'Anferas',
            'Anfesef',
            'Angalli',
            'Angemon',
            'Anghyrud',
            'Anhalus',
            'Anici',
            'Anina',
            'Ankrista',
            'Annoxin',
            'Anraculd',
            'Anroana',
            'Ansivlan',
            'Ansuki',
            'Antalyaar',
            'Antarlest',
            'Anterra',
            'Antesri',
            'Anthlamar',
            'Antraneyk',
            'Anzera',
            'Apelnin',
            'Aphithea',
            'Apporrosh',
            'Aquiel',
            'Aquorren',
            'Aradek',
            'Aragaj',
            'Araglas',
            'Arajist',
            'Arakbaal',
            'Arakhreen',
            'Arakin',
            'Araldar',
            'Aralik',
            'Aramil',
            'Aranat',
            'Aranis',
            'Arathorb',
            'Araxis',
            'Arbadrul',
            'Arbalac',
            'Arbalon',
            'Arbitan',
            'Arboran',
            'Arcastor',
            'Archolach',
            'Ardalanx',
            'Ardanos',
            'Ardatha',
            'Ardaxil',
            'Ardelin',
            'Ardilex',
            'Ardiseng',
            'Ardissa',
            'Aregel',
            'Arenith',
            'Arestel',
            'Arfandas',
            'Argethlam',
            'Arghesos',
            'Argion',
            "Argo\xebl",
            'Argolin',
            'Arhanen',
            'Ariann',
            'Arianth',
            'Aribeth',
            'Arien',
            'Arion',
            'Arioth',
            'Ariseph',
            'Arismacht',
            'Aristea',
            'Arivid',
            'Arkadit',
            'Arkaris',
            'Arkavyn',
            'Arkissar',
            'Arkurel',
            'Arlana',
            'Arleano',
            'Arleost',
            'Arlomma',
            'Arokair',
            'Arolant',
            'Arozan',
            'Arpiax',
            'Arrashad',
            'Arrelask',
            'Arrenol',
            'Arriam',
            'Arridor',
            'Arrivid',
            'Arrosas',
            'Arrossai',
            'Arshashi',
            'Arshavir',
            'Artithea',
            'Artlexu',
            'Arura',
            'Arvanor',
            'Arvirask',
            'Aryion',
            'Arzeela',
            'Ascarleth',
            'Ascaveen',
            'Ascomeld',
            'Asgarath',
            'Asherild',
            'Ashikri',
            'Ashilja',
            'Ashnisci',
            'Ashrodu',
            'Asilun',
            'Asius',
            'Aslior',
            'Asmacul',
            'Asmictir',
            'Aspaleed',
            'Asparind',
            'Asphodal',
            'Aspolyme',
            'Asquilla',
            'Astaedi',
            'Astalon',
            "Aste\xe4",
            'Astinus',
            "Astra\xeba",
            'Asurzel',
            'Atalis',
            'Atazra',
            'Athana',
            'Atheran',
            'Athermoj',
            'Athina',
            'Athnolan',
            'Athrasomb',
            'Athrilas',
            'Atlavan',
            'Atorin',
            'Atralan',
            'Atraxon',
            'Atrujal',
            'Attanir',
            'Atticog',
            'Aturin',
            'Atyoto',
            'Aurever',
            'Aurian',
            'Auridra',
            'Aurina',
            'Aurion',
            'Auxebaz',
            'Avalzaunt',
            'Avandir',
            'Avarath',
            'Avasceen',
            'Avenaar',
            'Aveole',
            'Averdal',
            'Avereem',
            'Avernide',
            "Av\xe8ss\xe8d",
            'Avesur',
            'Avori',
            'Avriax',
            'Avronil',
            'Awennes',
            'Axanar',
            'Axarun',
            'Aximil',
            'Ayaren',
            'Ayesra',
            'Azaka',
            'Azakour',
            'Azanakh',
            'Azanor',
            'Azarmax',
            'Azatta',
            'Azella',
            'Azergal',
            'Azfotha',
            'Azilos',
            'Azmarbi',
            'Azmeren',
            'Azolem',
            'Azraxel',
            'Azriaz',
            'Azrienne',
            'Aztira',
            'Azuva',
            'Azuzu',
            'Baeglyndven',
            'Bahnshiath',
            'Bakailis',
            'Bakiar',
            'Balandix',
            'Balanjik',
            'Balathol',
            'Balazar',
            'Balderon',
            'Baledor',
            'Baloward',
            'Baltarreg',
            'Bandibras',
            'Banira',
            'Banjasah',
            'Banjicoy',
            'Banrodi',
            'Bantirgen',
            'Baraca',
            'Barahir',
            'Baramei',
            'Barbardon',
            'Barixid',
            'Barjazan',
            'Barolio',
            'Barsimmern',
            'Bartosca',
            'Barzolo',
            'Basfui',
            'Basidrix',
            'Baslayan',
            'Basliard',
            'Batiax',
            'Baudefloy',
            'Bayazin',
            'Bayidon',
            'Bazakel',
            'Baziran',
            "Be\xe4brae",
            'Becheton',
            'Bedivere',
            'Behamkai',
            'Belaraz',
            'Belarba',
            'Belathgert',
            'Beldara',
            'Beldaran',
            'Belegern',
            'Belensarl',
            'Belgarath',
            'Belida',
            'Belimu',
            'Belinzith',
            'Belistra',
            'Belithin',
            'Bellarix',
            'Bellinus',
            'Belloram',
            'Belmalar',
            'Belmatar',
            'Benalath',
            'Beorilf',
            'Beoshar',
            'Berazan',
            'Berefex',
            'Berethan',
            'Beriam',
            'Berlemdo',
            'Bermulan',
            'Berterin',
            'Besagren',
            'Bestagar',
            'Bethalus',
            'Beztevil',
            'Bilamarj',
            'Birictzin',
            'Birimi',
            'Birrtezir',
            'Bisuneh',
            'Bithritrilb',
            'Blascarro',
            "Bo\xe4lod",
            "Bo\xe4zye",
            'Bolangi',
            'Bolgodar',
            'Boradrend',
            'Borvazan',
            'Bordvedo',
            'Boridorn',
            'Borivig',
            'Boroqual',
            'Borosov',
            'Boruja',
            'Breldiar',
            'Breyugar',
            'Brindelvix',
            'Brinzindis',
            'Brirelin',
            'Brofothin',
            'Bruyefol',
            'Bundetlan',
            'Burangald',
            'Byjagan',
            'Caadausid',
            'Cadrillan',
            'Cadxiel',
            'Caglaree',
            'Caladon',
            'Caladra',
            'Calandol',
            'Calandra',
            'Calara',
            'Caldiza',
            'Calial',
            'Calian',
            'Calibarz',
            'Caliburr',
            'Calimen',
            'Calinor',
            'Calinthor',
            'Caliroon',
            'Calrohir',
            'Calvari',
            'Calyreg',
            'Camorba',
            'Camrenard',
            'Candelisce',
            'Candralta',
            'Canteril',
            'Capsia',
            'Caradin',
            'Caraman',
            'Carano',
            'Carastac',
            'Cardannor',
            'Cardriman',
            'Carejjar',
            'Carenac',
            'Caribros',
            'Carvirras',
            'Casliet',
            'Cassira',
            'Castivin',
            'Cathloda',
            'Cauluden',
            'Cavrello',
            'Cazago',
            'Cazrogatz',
            'Cedethea',
            'Cedruin',
            'Celasli',
            'Celedrax',
            'Celeldrir',
            'Celenorb',
            'Celephais',
            'Celimbsel',
            'Celissar',
            'Celmiac',
            'Celria',
            'Cemendur',
            'Ceomyr',
            'Cerastes',
            'Cerdotur',
            'Cereden',
            'Ceremeb',
            'Cerindar',
            'Cernaia',
            'Cerrivald',
            'Cerrlemere',
            'Cervetar',
            'Chakjalom',
            'Chalberyn',
            'Chandalla',
            'Charizar',
            'Charovis',
            'Chasergha',
            'Chatony',
            'Chavrenard',
            'Chayuleth',
            'Chedynas',
            'Chemedis',
            'Cherinra',
            'Cheshinif',
            'Chesifith',
            'Chexotah',
            'Chiranin',
            'Chirophanx',
            'Chirystrad',
            'Chissaera',
            'Choriaal',
            'Chrystara',
            'Cialrak',
            'Ciarna',
            'Ciliath',
            'Cillegra',
            'Cimpelis',
            'Cirial',
            'Cirilar',
            'Cisidor',
            'Claraven',
            'Clarian',
            'Clymerice',
            'Colperat',
            'Colverslyne',
            'Conridas',
            'Coramur',
            'Corcoran',
            'Cordago',
            'Corisur',
            'Cormannon',
            'Coromis',
            'Corraemer',
            'Corstanis',
            'Coyasal',
            'Cramorul',
            'Crayeera',
            'Credori',
            'Cresbaral',
            'Crodelan',
            'Cromora',
            'Crondowys',
            'Cruirmox',
            'Crysindlyn',
            'Cthasia',
            'Cubrucol',
            'Curtifer',
            'Cveralisk',
            'Cyarium',
            'Cynalis',
            'Cynara',
            'Cyrilla',
            'Cyrissil',
            'Daakrasef',
            'Dabnavar',
            'Dacarin',
            'Dagaldsain',
            'Dagorla',
            'Daiavend',
            'Dakkiah',
            'Dakokan',
            'Dalarthra',
            'Dalimir',
            'Dallandra',
            'Dallibren',
            'Dalmaxen',
            'Damarel',
            'Damia',
            'Damisen',
            'Dammarlet',
            'Damria',
            'Danatren',
            'Danbrelaj',
            'Daqualor',
            'Daragard',
            'Darandril',
            'Darani',
            'Darimpelg',
            'Darioj',
            'Darisimp',
            'Darnien',
            'Daruda',
            'Darusor',
            'Darvenel',
            'Darvien',
            'Dasanay',
            'Dasyani',
            'Dathanja',
            "Dauro\xe4t",
            'Daximyr',
            'Dazaroth',
            'Deglavar',
            'Dekreon',
            'Delalea',
            'Delandim',
            'Delaquoth',
            'Delcardes',
            'Delgadjas',
            'Delgari',
            'Deliard',
            'Delitra',
            'Delmonda',
            'Delonos',
            'Delsinar',
            "Demels\xe0vre",
            'Deminar',
            'Demithea',
            'Dendera',
            'Denivra',
            'Deowrix',
            'Deralten',
            'Derian',
            'Derisurm',
            'Derokain',
            'Descelet',
            'Desnema',
            'Desthia',
            'Destrino',
            'Devabril',
            'Devaia',
            'Devaren',
            'Deviscind',
            'Devyna',
            'Dezelglim',
            'Dharijor',
            'Diagur',
            'Diamel',
            'Diastul',
            'Diazrax',
            'Diniwirn',
            'Dional',
            'Diony',
            'Dismarntir',
            'Distana',
            'Distiva',
            'Diurmad',
            'Divior',
            "Do\xe4lva",
            'Dokessin',
            'Dolitan',
            'Dolskior',
            'Domagren',
            'Domovoy',
            'Doniale',
            'Donivesh',
            'Dorana',
            'Doravin',
            'Doraxa',
            'Dorether',
            'Dorgrian',
            'Dorianth',
            'Dorosard',
            'Drafarna',
            'Draglios',
            'Dralgamor',
            'Drelbaran',
            'Dreleon',
            'Dreower',
            'Drusmirak',
            'Druycalid',
            'Durathor',
            'Duruis',
            'Dusoto',
            'Duvalin',
            'Dvereya',
            'Dygardo',
            'Eberyn',
            'Ecarnis',
            'Echengar',
            'Echredrisk',
            'Edalcor',
            'Edamar',
            'Edaris',
            'Edeera',
            'Edeiric',
            'Edelan',
            'Edromon',
            'Eemonil',
            'Eermiaw',
            'Efelin',
            'Efiath',
            'Egarun',
            'Egeanin',
            'Eglashor',
            'Eglathorm',
            'Ehlmargis',
            'Eilinud',
            'Einnara',
            'Ekisha',
            'Elaara',
            'Eladain',
            'Elanja',
            'Elanlir',
            'Elantir',
            'Elardoand',
            'Elayess',
            'Elbasant',
            'Elbrian',
            'Elcaros',
            'Eldikohl',
            'Eldimyr',
            'Eldivren',
            'Eleaseth',
            'Eleniin',
            'Elerasc',
            'Eleril',
            'Elesfar',
            'Elexna',
            'Elhanter',
            'Elharta',
            'Elhiri',
            'Eliaazh',
            'Elindel',
            'Elion',
            'Elispesh',
            'Elissim',
            'Elistan',
            'Eljendril',
            'Ellamoin',
            'Ellanath',
            'Ellendar',
            'Ellidyr',
            'Elmeric',
            'Elmradra',
            'Elnavor',
            "Elno\xeb",
            'Elorix',
            'Elriseth',
            'Elrodin',
            'Elrowan',
            'Elsandar',
            'Elverus',
            'Elzirtha',
            'Emeresc',
            'Emistar',
            'Emparyn',
            "Emra\xebl",
            'Enchasol',
            'Endelaer',
            'Endeltrad',
            'Endoyarl',
            'Endremen',
            'Engkalat',
            'Enifrax',
            'Enliack',
            'Ennorath',
            "Eno\xebre",
            'Ensocand',
            'Enzoray',
            'Eolair',
            'Eolglyu',
            'Eomer',
            'Eosin',
            'Eowine',
            'Eralith',
            'Erbarax',
            'Erdegron',
            "Ere\xe4d",
            'Ereboen',
            'Eregin',
            'Ereia',
            'Ereidan',
            'Ereinid',
            'Eresbor',
            'Ergamarl',
            'Erian',
            'Erihim',
            'Erijin',
            'Erilind',
            'Erilyth',
            'Erimewn',
            'Eriptil',
            'Erizael',
            'Erjesko',
            'Erkollo',
            'Erlata',
            'Erliskan',
            'Ermentej',
            'Ermiod',
            'Ermizard',
            'Erobor',
            'Erraxam',
            'Errixi',
            'Ersazern',
            'Erudin',
            'Eruna',
            'Escaloth',
            'Eshorden',
            'Eskedar',
            'Eslenix',
            'Esmeril',
            'Essamor',
            'Esselin',
            'Estelorn',
            'Estulman',
            'Esyorna',
            'Ethayan',
            'Ethilrist',
            'Ettellarn',
            'Euralen',
            'Eurayo',
            'Evarul',
            'Evedben',
            'Eveltur',
            'Evenor',
            'Everan',
            'Everard',
            'Evidor',
            'Evrilet',
            'Ewugan',
            'Exior',
            'Exorric',
            'Ezirith',
            'Ezpirasp',
            'Ezrabar',
            'Fabliain',
            'Faerlasdar',
            'Fafmalan',
            'Fahorjom',
            'Falamund',
            'Falazarm',
            'Faldian',
            'Faledra',
            'Falias',
            'Faliorn',
            'Fallonar',
            'Falmalin',
            'Famaril',
            'Famiryah',
            'Farammil',
            'Faranar',
            'Farathar',
            'Farazwen',
            'Farendal',
            'Farezar',
            'Farias',
            'Farinda',
            'Farovlem',
            'Farreflan',
            'Farrian',
            'Fassander',
            'Fassiral',
            'Fathanor',
            'Fathimlas',
            'Favular',
            'Fayenned',
            'Felacroy',
            'Felectos',
            'Felendos',
            'Felentir',
            'Felinstrod',
            'Felladin',
            'Fellathor',
            'Fellazoor',
            'Felmarus',
            'Felvia',
            'Fenhalut',
            'Fenkkara',
            'Feollan',
            'Feraanty',
            'Ferazhin',
            'Ferdithir',
            'Ferena',
            'Ferescha',
            'Feridmir',
            'Feridoth',
            'Ferilken',
            'Ferkiel',
            'Fermandra',
            'Fermazeth',
            'Ferozak',
            'Ferrandry',
            'Ferrinox',
            'Fertimqui',
            'Fesanor',
            'Fesmaran',
            'Fethijorn',
            'Fethorval',
            'Fezmirath',
            'Fiaminch',
            'Fiantzin',
            'Fiathna',
            'Fiensar',
            'Fierex',
            'Filigal',
            'Filrena',
            'Finaefin',
            'Findegil',
            'Finmanal',
            'Finrhabar',
            'Fiollix',
            'Fionlex',
            'Fiorag',
            'Fiori',
            'Fiosthan',
            'Firandaal',
            'Firimar',
            'Firmrius',
            'Fivrenesse',
            "Flaco\xeb",
            'Fluimorl',
            "Fo\xe4shroud",
            'Fomorisk',
            'Fonesco',
            'Fontaera',
            'Forambad',
            'Forizuld',
            "Foront\xe9",
            'Forrandir',
            'Foxilkin',
            'Fozdollo',
            'Fraajior',
            'Fragadin',
            "Fre\xe4laf",
            'Frinilex',
            'Frosserthil',
            'Frugansey',
            'Fuareece',
            'Fulinas',
            'Fulmerack',
            'Fumorak',
            'Furalor',
            'Fusial',
            'Gadino',
            'Gaffindur',
            'Gaherist',
            'Gaianac',
            'Galassad',
            'Galedrej',
            'Galeeya',
            'Galeia',
            'Galendil',
            'Galhambraj',
            'Galhandvis',
            'Galiel',
            'Galjiu',
            'Gallaia',
            'Galorin',
            'Galrion',
            'Galthien',
            'Galtyran',
            'Galvaris',
            'Gambrefax',
            'Gamorrand',
            'Ganatus',
            'Ganelon',
            'Ganoraz',
            'Ganscion',
            'Ganzadahl',
            'Garagrim',
            'Garalden',
            'Garathgen',
            'Garduil',
            'Gardulkar',
            'Garemo',
            'Garflion',
            'Garlenon',
            'Garriech',
            'Garziot',
            'Gastenmil',
            'Gatlatas',
            'Gatzeiros',
            'Gavendra',
            'Gavilen',
            'Gefandrall',
            'Gelsgiath',
            'Genteras',
            'Gerergol',
            'Gerexi',
            'Geskrivus',
            'Gevanarth',
            'Ghiella',
            'Gidyrrha',
            'Gildanar',
            'Gilennan',
            'Gilfangron',
            'Giljrian',
            'Giltsanos',
            'Gimika',
            'Gipideur',
            'Girazi',
            'Giridal',
            'Giridyne',
            'Giriel',
            'Girkirath',
            'Gisorath',
            'Gisriral',
            'Gisselek',
            'Givirtrik',
            'Gizarak',
            'Gizbion',
            'Gizherae',
            'Gledrion',
            'Gleocyn',
            'Gleyander',
            'Gliranna',
            'Glirfingril',
            'Goibhniu',
            'Golexar',
            "Golo\xeb",
            'Gonscevin',
            'Gontomir',
            'Goranna',
            'Gorazky',
            'Gordalis',
            'Gorias',
            'Gorion',
            'Goronwy',
            'Goronyr',
            'Gorova',
            'Gorthokon',
            'Graginar',
            'Graliath',
            'Gredanost',
            'Griarnix',
            'Griotam',
            'Grissejan',
            'Grolliax',
            'Gualat',
            'Guilmarn',
            'Gulifrith',
            'Gurnarok',
            'Gwyrion',
            'Gydrian',
            'Gymnivus',
            'Gyrelyest',
            'Hacoulede',
            'Hadowrak',
            'Hafranel',
            'Haielva',
            'Haijannod',
            'Hajandin',
            'Hakatri',
            'Halibarn',
            'Halios',
            'Haliwyn',
            'Halveron',
            'Halvia',
            'Hamadar',
            'Hamancen',
            'Hamavand',
            'Hanamere',
            'Haneran',
            'Hanorayn',
            'Hanrassu',
            'Hantaira',
            'Haplana',
            'Haprissa',
            'Harana',
            'Harandash',
            'Harezek',
            'Hargranar',
            'Harigran',
            'Harnahad',
            'Harobel',
            'Harondar',
            'Harromarl',
            'Harsinna',
            'Hartien',
            'Hartazan',
            'Hasalgar',
            'Hasprion',
            'Hathlizu',
            'Hathvoril',
            'Hautilim',
            'Hautulin',
            'Hauxpomel',
            'Haxmaraun',
            'Haxmaspar',
            'Haxmered',
            'Hazalet',
            'Hazazel',
            'Hazharat',
            'Haziran',
            'Hedrapake',
            'Heereos',
            'Hekeren',
            'Helbathil',
            'Helobaine',
            'Helphegad',
            'Helziatz',
            'Hemgarel',
            'Henalur',
            'Herecharn',
            'Heriganj',
            'Heriol',
            'Hessevet',
            'Hethica',
            'Heuleanar',
            'Hexavren',
            'Hexelin',
            'Hiabaid',
            'Hiassveil',
            'Hifridil',
            'Higlaia',
            'Hilio',
            'Himurlem',
            'Hintyrit',
            'Hirodrix',
            'Hizirin',
            "Hokry\xe4hn",
            'Holmarun',
            'Horbajir',
            'Horlabo',
            'Hralfecca',
            'Hrioncet',
            'Hulterna',
            "Hurja\xebl",
            'Huvatal',
            'Hyaliptar',
            'Hyarantar',
            'Hydrestin',
            'Hylamet',
            'Hylarel',
            'Hylissa',
            'Hyphorond',
            'Hyraskel',
            'Hyrkhalla',
            'Hyzaspes',
            'Iahaun',
            'Iarlen',
            'Iasho',
            'Ibekon',
            'Ibgali',
            'Ibrana',
            'Ibriax',
            'Ibriole',
            'Icanaar',
            'Icavra',
            'Icera',
            'Ichandrik',
            'Ichindar',
            'Idarlan',
            'Iffalon',
            'Igjaru',
            'Ijevthla',
            'Ikarin',
            'Ikirkar',
            'Ilabrem',
            'Ilairam',
            'Ilarnin',
            'Ildezir',
            'Ilenfal',
            'Ilfangir',
            'Ilfinir',
            'Ilgaeldar',
            'Ilikir',
            'Ilimvair',
            "Ilkern\xe9",
            'Ilkyarzim',
            'Illana',
            'Illara',
            'Illiarn',
            'Illsuin',
            'Illuanc',
            'Illurdan',
            'Ilkaroque',
            'Ilnitelg',
            'Ilrehjan',
            'Ilumaar',
            'Ilvelisk',
            'Imaia',
            'Imajin',
            'Imashla',
            'Imaydra',
            'Imedet',
            'Imikeer',
            'Imilxime',
            'Imisard',
            'Immelanx',
            'Immoreth',
            'Immornam',
            'Imnatris',
            'Imrahran',
            'Imravog',
            'Imrazixt',
            'Imzia',
            'Inayiss',
            'Indreju',
            'Ingrenux',
            'Inhectin',
            'Inidar',
            'Inifael',
            'Inifox',
            'Ininay',
            'Inisdex',
            'Inisfail',
            'Inkiljist',
            'Inkotai',
            "Inno\xe4k",
            'Inora',
            'Insallasc',
            'Intaphka',
            'Inzellene',
            'Ioga',
            'Iolan',
            'Iombar',
            'Iosaz',
            'Iosdil',
            'Iperi',
            'Iphara',
            'Ipholar',
            'Ipolok',
            'Iptasor',
            'Irankar',
            'Irathar',
            'Ireneemp',
            'Irial',
            'Irian',
            'Iriboth',
            'Iriga',
            'Irmaskor',
            'Irmistib',
            'Irphilin',
            'Irriosce',
            'Irshirkur',
            'Isaelsu',
            'Isamar',
            'Isarma',
            'Isbexa',
            'Isencal',
            'Isgremnir',
            'Ishmira',
            'Ishnitra',
            'Isiki',
            'Iskarrine',
            'Iskimi',
            'Iskiret',
            'Isodrost',
            'Isotu',
            'Isromant',
            'Isrotha',
            'Issakra',
            'Issanthal',
            'Issevex',
            'Issimrak',
            'Istengrem',
            'Istensanth',
            'Isthentild',
            'Istheol',
            'Isthgiol',
            'Istidom',
            'Istijed',
            'Istroval',
            'Isuxnen',
            'Itharna',
            'Ithelus',
            'Ithimryr',
            'Ithineg',
            'Ithober',
            'Iventhax',
            'Ivrishel',
            'Iwranda',
            'Ixambel',
            'Ixanthis',
            'Ixarine',
            'Ixcavar',
            'Ixium',
            'Iyenna',
            'Iyiskek',
            'Izpiizzi',
            'Jabarla',
            'Jablomeed',
            'Jaelmura',
            'Jafila',
            'Jagadis',
            'Jagaroch',
            'Jahaurin',
            'Jakalar',
            'Jakarhul',
            'Jakendar',
            'Jakharral',
            'Jakronib',
            'Jalaran',
            'Jalatha',
            'Jaleana',
            'Jaligar',
            'Jalisharn',
            'Jalnio',
            'Jalvochin',
            "Jance\xe4",
            'Jandagar',
            'Jandenor',
            'Janien',
            'Janniel',
            'Jaralor',
            'Jarantin',
            'Jaratryne',
            'Jardilan',
            'Jarien',
            'Jarioth',
            'Jaronris',
            'Jascelat',
            'Jascenant',
            'Jaslani',
            'Jassolind',
            'Jatherfar',
            'Jathlabra',
            'Jathzoril',
            'Jaukulmar',
            'Jaurelin',
            'Javennae',
            'Javrezac',
            'Jazaeron',
            'Jejaneel',
            'Jeleeya',
            'Jelerish',
            'Jelgrion',
            'Jemadar',
            'Jemkoleng',
            'Jeoric',
            'Jeoster',
            'Jeprana',
            'Jertezan',
            'Jervida',
            'Jessabra',
            'Jevalor',
            'Jevedic',
            'Jevorin',
            'Jevrian',
            'Jhessala',
            'Jhinilak',
            'Jianthi',
            'Jidesa',
            'Jifrusni',
            'Jijinjic',
            'Jilarna',
            'Jilitha',
            'Jillaro',
            'Jingaran',
            'Jiriselk',
            'Jiruik',
            'Jivessla',
            'Jivizet',
            'Jixannil',
            'Jizuret',
            "Jo\xe4sra",
            'Joplezno',
            'Jorian',
            'Joriel',
            'Jorodrin',
            'Josafyre',
            'Jothaugan',
            'Jothera',
            'Jozranal',
            'Jranahaz',
            'Juarin',
            'Jumeon',
            'Juramanx',
            'Jussondrel',
            'Juxeccan',
            'Juzawik',
            'Kacinzen',
            'Kadishir',
            'Kahora',
            'Kairaku',
            'Kajabor',
            'Kajua',
            'Kalandrin',
            'Kaledath',
            'Kalvaro',
            'Kamisu',
            'Kamundam',
            'Kandonak',
            'Kandorin',
            'Kapasin',
            "Kara\xebl",
            'Karamis',
            'Karanchir',
            'Kardarkar',
            'Kardotha',
            'Karela',
            'Karezthame',
            'Karimeg',
            'Karogan',
            'Kasiran',
            'Kasluna',
            'Kastana',
            "Kastau\xebt",
            'Kasthukras',
            'Kathanal',
            'Katryzaj',
            'Katumar',
            'Kazellor',
            "Kazu\xf6n",
            'Kedrinal',
            'Kelemon',
            'Kelmerveld',
            'Kelraiog',
            'Kelvixa',
            'Kemmergen',
            'Kerannix',
            'Kerason',
            'Kerasun',
            'Kerendul',
            'Kerfina',
            'Kernamald',
            'Keroona',
            'Kerrekril',
            'Kerrihaude',
            'Kestramel',
            'Kexranea',
            'Khadera',
            "Khalid\xfbr",
            'Kharisden',
            'Khelaret',
            'Khorenym',
            'Khosilin',
            'Khuraram',
            'Khurkula',
            'Kiarak',
            'Kiaskek',
            'Kifadli',
            'Kinbulser',
            'Kinjeon',
            'Kintarna',
            'Kioxug',
            'Kireoj',
            'Kirias',
            'Kiriok',
            'Kirithul',
            'Kirrevi',
            'Kiuspou',
            'Kizarlon',
            'Klandisar',
            'Klirundon',
            'Kodoki',
            'Korachon',
            'Korasal',
            'Kortien',
            'Korvaron',
            'Kotajad',
            'Kothenai',
            'Kovaia',
            'Kozanga',
            'Krasgalad',
            'Krienna',
            'Krisilal',
            'Krytelgaz',
            'Kuiju',
            'Kydomor',
            'Kylara',
            'Kylinsra',
            'Kymelin',
            'Kymorel',
            'Kyrembra',
            'Kyvaran',
            'Kyveler',
            'Laaraban',
            'Lacoumox',
            'Lacrion',
            'Ladamur',
            'Ladestro',
            'Laesina',
            'Lafera',
            'Lagaram',
            'Lagova',
            'Lahanolt',
            'Laklanot',
            'Lalaia',
            'Lalthilan',
            'Lamidris',
            'Lamifer',
            'Lamizjax',
            'Lampralur',
            'Lamrella',
            'Lanisor',
            'Lanival',
            "Lanstre\xe4",
            'Lantakrel',
            'Lantamar',
            'Lanumel',
            'Lappeleme',
            'Laprimal',
            'Larana',
            'Laranel',
            'Larilect',
            'Larion',
            'Larquinip',
            'Lascynthis',
            'Lasirusk',
            'Lataffin',
            'Lattremond',
            'Lazadon',
            'Ledmial',
            'Legaaruksh',
            'Lelatha',
            'Leledish',
            'Lendela',
            'Lendoweer',
            'Leodaan',
            'Leojith',
            'Leoptrin',
            'Leptenar',
            'Leptredin',
            'Leranorb',
            'Lessefren',
            'Lethrian',
            'Levasim',
            'Lhyrrhana',
            'Liamar',
            'Liambra',
            'Liammeck',
            'Lianairn',
            'Liansra',
            'Lianvrin',
            'Liarxa',
            'Liavec',
            'Liembra',
            'Lilasta',
            'Lilkauki',
            'Lilthia',
            'Limbria',
            'Linargan',
            'Linnaker',
            'Lionus',
            'Liossoor',
            'Liquemar',
            'Liroitzin',
            'Lisimbra',
            'Lissara',
            'Lissflorel',
            'Lithuir',
            'Lithyulin',
            'Litoefer',
            'Liydala',
            'Lizenna',
            'Lizinra',
            'Llanaanu',
            "Lo\xebra",
            'Logano',
            'Lorana',
            'Lorenvra',
            'Loriant',
            'Lozeneth',
            'Luciet',
            'Lucimer',
            'Lunzia',
            'Lurepusc',
            'Luspilkir',
            'Luthirring',
            'Luuranoth',
            'Lydalay',
            'Lymandal',
            'Lynaya',
            "Lyndr\xe9",
            'Lynxias',
            'Lypilla',
            'Lyraloss',
            'Lyrian',
            'Lyrossa',
            'Lyrozi',
            'Lythian',
            'Lythratole',
            'Lyzeary',
            'Maalkeyan',
            'Maceon',
            'Madaluur',
            'Madiglim',
            'Madora',
            'Maerleetlas',
            'Maeronyx',
            'Mafranic',
            'Magezatt',
            'Magithel',
            'Maglethom',
            'Magylin',
            'Mahelas',
            'Majaelith',
            'Makana',
            "Mala\xebsse",
            'Malaioc',
            'Malambard',
            'Malandor',
            'Malasire',
            'Malasquor',
            'Malavok',
            'Malbrosac',
            'Maldagon',
            'Malechan',
            'Malestrin',
            'Malgadarn',
            'Malhantis',
            'Malhemar',
            'Malidryth',
            'Malifrin',
            'Malisken',
            'Mallaran',
            'Maloroc',
            'Malsanon',
            'Mamvier',
            'Mandrezool',
            'Manjalem',
            'Mannanon',
            'Mantragan',
            "Ma\xf6ndat",
            'Mapiran',
            'Mardieth',
            'Maridan',
            'Maridisp',
            'Marindro',
            'Marinus',
            'Marivik',
            'Marliok',
            'Marmaranx',
            'Marmeron',
            'Marniel',
            'Marreldix',
            'Marsarok',
            'Marsineh',
            'Martanzix',
            'Maruis',
            'Mashalla',
            'Masira',
            'Massoran',
            'Mathannil',
            'Matzirik',
            'Maunestin',
            'Mavira',
            'Maxander',
            'Maxtibel',
            'Mazegus',
            'Mazesra',
            'Mazian',
            'Mazivel',
            'Medarinn',
            'Medrahar',
            'Medvergaal',
            'Mehalet',
            'Mejarlan',
            'Mekeesha',
            'Melamnir',
            'Melapis',
            'Melasdar',
            'Melikkhaz',
            'Meliune',
            'Melliorn',
            'Melorond',
            'Memisaire',
            'Menalor',
            'Mendobarl',
            'Menelvaour',
            'Meodas',
            'Meraleph',
            'Merama',
            'Meramel',
            'Meranshu',
            'Meraudax',
            'Meriag',
            'Meridyn',
            'Meriel',
            'Merilec',
            'Merinar',
            'Merinard',
            'Merivran',
            'Merkalo',
            'Merlience',
            'Merresil',
            'Merscianthe',
            'Mertamet',
            'Mesegrim',
            'Metrofa',
            'Mevedet',
            'Mewreddan',
            'Mezedan',
            'Mezerel',
            'Mezlehet',
            'Mezlethil',
            'Mezrian',
            'Mezrenain',
            'Mezvorax',
            'Mialdere',
            'Mialorn',
            'Midela',
            'Mierah',
            'Mikramil',
            'Milicseth',
            'Minaxa',
            'Minrioth',
            'Miranei',
            'Mirantilb',
            'Mirelith',
            'Mirenta',
            'Miriel',
            'Mirieth',
            'Mirintha',
            'Mirion',
            'Mirreschade',
            'Mirrsomi',
            'Misella',
            'Misiplum',
            'Misirim',
            'Mithelos',
            "Mo\xe4lroc",
            'Mobrias',
            'Moieddin',
            'Moisiane',
            'Molhanni',
            'Mondestin',
            'Moramin',
            'Morannel',
            'Morilimth',
            'Morleved',
            'Mormindar',
            'Morofar',
            'Morozam',
            'Morrixan',
            'Mosbelo',
            'Movellan',
            'Moxfiel',
            'Mrankali',
            'Mredisu',
            'Mujeket',
            'Mulciner',
            'Mumivor',
            'Murbahir',
            'Murias',
            'Murinja',
            'Mustesra',
            'Mylbdenir',
            'Mylenost',
            'Myllara',
            'Myloryx',
            'Myractus',
            'Myrmelesc',
            'Myrrhismir',
            'Myrstica',
            'Myruken',
            'Myvior',
            'Naadien',
            'Nabronyb',
            "Na\xebska",
            'Nagarax',
            'Naiagard',
            'Najikim',
            'Nambolar',
            'Namezlith',
            'Namien',
            'Nappolanc',
            'Naramant',
            'Naranlob',
            'Naraven',
            'Narecan',
            'Naretha',
            'Narfalax',
            'Narimas',
            'Narisdaat',
            'Narissa',
            'Narotham',
            'Narothun',
            'Narrabhar',
            'Narseldax',
            'Nasmerul',
            'Nateera',
            'Nathogan',
            'Natrifer',
            'Nauthzegam',
            'Naveiruz',
            'Navislorn',
            'Navithesk',
            'Nefaroyn',
            'Negula',
            'Nelibar',
            'Nelphina',
            'Nelthenti',
            'Nelveren',
            'Nemarhaz',
            'Nemisen',
            'Nereitra',
            'Nerevaunt',
            'Nerian',
            'Nerida',
            'Neryonid',
            'Netharna',
            "Netho\xebl",
            'Neveena',
            'Nexian',
            'Nexlio',
            'Niascynth',
            'Nidoran',
            'Nienra',
            'Niggollo',
            'Nilchauntif',
            'Nilmio',
            'Nimandest',
            'Nimfiralth',
            'Nimiax',
            'Ninozain',
            'Niomakh',
            'Nisamon',
            'Nisaqua',
            'Nissafen',
            'Nitharna',
            'Nithikin',
            'Nitoda',
            'Nivilan',
            'Nizamar',
            'Nizared',
            'Noldiruth',
            'Nolteera',
            'Nooranda',
            'Norian',
            'Norvandrel',
            'Noumander',
            'Novrima',
            'Noxalwan',
            'Nuanvi',
            'Nuarban',
            'Nujriha',
            'Nulagdi',
            'Nuskuron',
            'Nyrana',
            'Nysorat',
            'Obatzi',
            'Obelnid',
            'Ocmias',
            'Odimos',
            'Offenalke',
            'Ogola',
            'Ohranjat',
            'Ojavi',
            'Ojilinx',
            'Okalder',
            'Okpala',
            'Oktavisp',
            'Olamar',
            'Olbenos',
            'Oldarane',
            'Oldrinben',
            'Olican',
            'Ollascet',
            'Olnefkin',
            'Olondin',
            'Olonthos',
            'Oloru',
            'Oloxem',
            'Olybris',
            'Omaldras',
            'Omaphel',
            'Omarna',
            'Omarthis',
            'Omberdal',
            'Ombriand',
            'Ommarisk',
            'Omosdur',
            'Omziec',
            'Onaldrus',
            'Oneira',
            'Onfivlen',
            'Oniack',
            'Onjedrit',
            'Onoxim',
            'Oolevran',
            'Oomia',
            'Oorandehle',
            'Oquilda',
            'Oradrad',
            'Orbasdron',
            'Orbeleez',
            'Orbitan',
            'Orchellor',
            'Orebus',
            'Oremex',
            'Orenai',
            'Orennem',
            'Oridyr',
            'Oriob',
            'Oristkel',
            'Orithreyn',
            'Orivaen',
            'Orlantsu',
            'Orliend',
            'Orlopem',
            'Orluan',
            'Ormadzel',
            'Ormarit',
            'Ormion',
            'Ornulaa',
            'Orodel',
            'Oromrath',
            'Orovar',
            'Orovune',
            'Orpirrhis',
            'Orreminsk',
            'Ortazan',
            'Osgoran',
            'Oskana',
            'Osmoril',
            'Osoyrir',
            'Ossfenness',
            'Otargol',
            'Othaldon',
            'Otralinx',
            'Oujanglor',
            'Ouraia',
            'Ovarasc',
            'Ovelleau',
            'Oveselm',
            'Ovranoj',
            'Ovrenor',
            'Oxavar',
            'Oxavart',
            "Oxru\xebl",
            'Ozatris',
            'Ozgethern',
            'Ozmirall',
            'Ozringol',
            'Palabell',
            'Palarna',
            'Palegain',
            'Palidral',
            'Palimbrust',
            'Palinor',
            'Panafig',
            'Pandaxes',
            'Pandelee',
            'Pandeleur',
            'Paomelna',
            'Pardyereyk',
            'Pargascir',
            'Parlion',
            'Paskorran',
            'Pastengral',
            'Pavadahl',
            'Pavandor',
            'Paxijanc',
            'Paxilla',
            'Pazaleeb',
            'Peladon',
            'Peledor',
            'Pelendur',
            'Peleod',
            'Pelezef',
            'Peliast',
            'Pelizon',
            'Pellingale',
            'Pelmercest',
            'Pelmergol',
            'Pelsiffra',
            'Penengvik',
            'Peradal',
            'Peraga',
            'Perendan',
            'Perendor',
            'Peridor',
            'Peripril',
            'Perisgrim',
            'Peristaad',
            'Perligon',
            'Pernian',
            'Perridex',
            'Persimmid',
            'Perushka',
            'Peslivar',
            'Petreban',
            'Phaidonaz',
            'Phaneon',
            'Pharethyn',
            'Phariol',
            'Pharnioth',
            'Phascalon',
            'Phesian',
            'Phiarusk',
            'Philizim',
            'Phiniak',
            'Phiressa',
            'Phoosrotex',
            'Phoseter',
            'Phramberzond',
            'Phranzulet',
            'Piapiar',
            'Pievalp',
            'Pillia',
            'Pioma',
            'Pirigal',
            'Pirilaud',
            'Pirinweal',
            'Piritosk',
            "Pis\xe7ion",
            'Pishior',
            'Pithibryl',
            'Piynameer',
            'Plamias',
            'Plenchiel',
            'Poinellay',
            'Poinembet',
            'Polassar',
            'Polorrum',
            'Porodo',
            'Porsenna',
            'Potadu',
            'Priligrel',
            'Progneti',
            'Ptamriad',
            'Ptelian',
            'Pteraphon',
            'Pulsavra',
            'Pyrenda',
            'Pyrtolosc',
            'Pytholtus',
            'Pytrigon',
            'Quaeleon',
            'Quagrana',
            'Qualbian',
            'Qualhassan',
            "Quana\xf6ck",
            'Quandiel',
            'Queegani',
            'Quenteri',
            'Quentezard',
            'Queoddry',
            'Queridra',
            "Quero\xeb",
            'Quersemel',
            'Quilium',
            'Quilverex',
            'Quinibus',
            'Quisifrix',
            'Quolatha',
            'Quolessip',
            "Quoran\xfbl",
            'Quyzacorm',
            'Raascia',
            'Racassar',
            'Rackafel',
            'Radasman',
            'Radelon',
            'Radula',
            'Raiveral',
            'Rajiten',
            'Rajurno',
            'Rakmyrral',
            'Rakshilan',
            'Ralanzur',
            'Ralisimp',
            'Ralmanor',
            'Ralystra',
            'Ramura',
            'Ranessin',
            'Ranicroy',
            'Ranifice',
            'Ranomar',
            'Rasaleth',
            'Rashemba',
            'Rassdolim',
            'Rasseglin',
            'Rassfydel',
            'Rastilon',
            'Ravathene',
            'Ravenor',
            'Raverail',
            'Ravimo',
            'Raxia',
            'Razamor',
            'Raziel',
            "Re\xe4nkal",
            'Reepifer',
            'Regalorj',
            'Regimir',
            'Reldorin',
            'Releza',
            'Relikin',
            'Relion',
            'Rellevirk',
            'Relliapt',
            'Relundar',
            'Rendeptir',
            'Renzelath',
            'Reonin',
            'Requiek',
            'Rescorance',
            'Resmenalse',
            'Retalkin',
            'Rethia',
            'Revenal',
            'Rezmyra',
            'Rhakotis',
            'Rhendalin',
            'Rhiacind',
            'Rhimaya',
            'Rhimeren',
            'Rhisala',
            'Rhomiscele',
            'Rhydolin',
            "Rhy\xf6lar",
            'Riasine',
            'Riatar',
            'Riatha',
            'Rickata',
            'Rigisil',
            'Rigonav',
            'Riimara',
            'Rilatha',
            'Rilidtai',
            'Rilmara',
            'Rilmorban',
            'Rinxfantir',
            'Riodan',
            'Riolarn',
            'Riolba',
            'Riscintell',
            'Risgana',
            'Risia',
            'Risrinam',
            'Rithotarl',
            'Rixian',
            'Rizifire',
            'Rocapeste',
            'Rodifel',
            'Rodion',
            "Ro\xebnen",
            'Rokefyre',
            'Romela',
            'Romenom',
            'Rondolla',
            'Rophelon',
            'Rophendir',
            'Rosmarlind',
            "Rou\xe4dth",
            'Rovlerac',
            'Rozeeldin',
            'Rugiel',
            'Ruhria',
            'Rumilan',
            'Runian',
            'Rusaadi',
            'Rusalmna',
            'Rusitholk',
            'Ruvasarn',
            'Ruvatro',
            "Ry\xf6zile",
            'Rynian',
            'Rynristas',
            'Rynyris',
            'Ryxarro',
            'Sabrazsa',
            'Sabriel',
            'Sabtimon',
            'Sadabel',
            'Sadeera',
            'Sadonel',
            'Safarrinx',
            'Saffinka',
            'Sagamir',
            'Saguil',
            "Sa\xefnda",
            'Sajaerix',
            'Salaarus',
            'Salathir',
            'Salclias',
            'Salina',
            'Salinen',
            'Salioct',
            'Salitlan',
            'Salmorin',
            'Salrissa',
            'Samalend',
            'Samerlan',
            'Sancial',
            'Sannsara',
            'Sanorye',
            'Sanpellin',
            'Sanseran',
            'Sanzhara',
            'Saqavar',
            'Sarandere',
            'Saraxa',
            'Sardanak',
            'Sarendril',
            'Sargadal',
            'Sariya',
            'Sarkinos',
            'Sarkozan',
            'Sarlian',
            'Sarmasar',
            "Saro\xeb",
            'Sarozak',
            'Sarrier',
            'Sarrofo',
            'Sarsicaul',
            'Sartenna',
            'Sarupha',
            'Saschalon',
            'Sathlatta',
            'Satrothan',
            "Sav\xeama",
            'Savretos',
            'Savria',
            'Scathanar',
            'Scesefna',
            'Sebandune',
            'Selamvra',
            'Selestor',
            'Selial',
            'Selidro',
            'Selior',
            'Selmiar',
            'Selnara',
            'Selnia',
            'Selsabar',
            'Selverel',
            'Semarsen',
            'Semdalice',
            'Semmagel',
            'Semurquan',
            'Sendara',
            'Senoster',
            'Seorra',
            'Sepiroth',
            'Seprenal',
            'Sepria',
            'Serakel',
            'Serambast',
            'Seramir',
            'Serefic',
            'Serrios',
            'Sertumen',
            'Servelen',
            'Serydran',
            'Seskandal',
            'Sevandir',
            'Sevandor',
            'Severique',
            'Severlesk',
            "Sevlasn\xe9",
            'Seytarin',
            'Sfaeriqua',
            'Sferalan',
            'Sferio',
            'Shaikala',
            'Shalimed',
            'Shameera',
            'Shanatherl',
            'Shanderzoth',
            'Sharajsha',
            'Sharbremil',
            'Shardovan',
            'Sharretal',
            "Shaxe\xe4n",
            'Shehallem',
            'Shekkazad',
            'Sherethis',
            'Sherina',
            'Sherotha',
            'Shevrian',
            'Shibema',
            'Shiennith',
            'Shildakor',
            'Shimjian',
            'Sholgonda',
            'Shragonach',
            'Shrymaroyne',
            'Shurakai',
            'Shushila',
            'Sialtaan',
            'Sianar',
            'Siandar',
            'Siandor',
            'Siannem',
            'Sidanzar',
            'Siendred',
            'Sientij',
            'Sientrib',
            'Siflana',
            'Sigilla',
            'Sildengold',
            'Silifer',
            'Silistel',
            'Silivis',
            'Silmriel',
            'Silvarak',
            'Silvronom',
            'Simara',
            'Simblio',
            'Simirling',
            'Simisthir',
            'Simrana',
            'Simusha',
            'Sindaract',
            'Sindiris',
            'Sindiroq',
            'Sinhadak',
            'Sinira',
            'Sinoprin',
            'Siortlen',
            'Sioshorl',
            'Sirelu',
            'Sirenel',
            'Sirgamesc',
            'Sirifrix',
            'Sirinar',
            'Sisimar',
            'Sisimbra',
            'Siugorn',
            'Sjalara',
            'Skalidra',
            'Skelalack',
            'Skelogha',
            'Skelother',
            'Skesira',
            'Slanarra',
            'Slanria',
            'Slenlior',
            'Slevindralsk',
            'Slyrmegnel',
            'Sofrego',
            'Sofurin',
            'Soleddin',
            'Solfellan',
            'Soliroq',
            'Solliot',
            'Solmerip',
            'Soltharan',
            'Somagar',
            'Sondaardrel',
            'Sondrelen',
            'Soomerak',
            'Soquallin',
            'Sorasta',
            'Sormian',
            'Sozmerold',
            'Srandelix',
            'Sravoorin',
            'Steraval',
            'Sthinalel',
            'Stiaver',
            'Stivernach',
            'Sudevim',
            'Sufranar',
            'Suilim',
            'Sujorgni',
            'Sukratak',
            'Sulathaag',
            'Sulethri',
            'Suliane',
            'Sulien',
            'Sulimo',
            'Sulkanar',
            'Sulkari',
            "Sulron\xe9",
            'Surmaris',
            'Suruay',
            'Suzamil',
            'Svialdan',
            'Swangoren',
            'Sweiborla',
            'Sylvetane',
            'Symaril',
            'Syriolg',
            'Syzirept',
            'Szivistri',
            'Taalivex',
            'Tabusaad',
            'Tadasli',
            'Tafashic',
            'Tainbara',
            'Taladere',
            'Talareme',
            'Talarin',
            'Talertus',
            'Talien',
            'Taliess',
            'Talieux',
            'Talion',
            'Talislance',
            'Talmora',
            'Taloxar',
            'Taloxi',
            'Talunon',
            'Tamavold',
            'Tamias',
            'Tamioj',
            'Tamlivran',
            'Tamnithir',
            'Tanafin',
            'Tanakord',
            'Tanier',
            'Tanjalas',
            'Tanjara',
            'Tanseral',
            'Tanviu',
            'Tarakus',
            'Taramag',
            'Taramos',
            'Tardelin',
            'Tariaj',
            'Tarkenthos',
            'Tarmesorn',
            'Tarmioc',
            'Taroya',
            'Tasardy',
            'Taslhiot',
            'Tassafert',
            'Tassiran',
            'Taumonar',
            'Taveli',
            'Tavista',
            'Tayaren',
            "Te\xe4nyn",
            'Tegana',
            'Tegleron',
            'Teirajan',
            'Teirishir',
            'Telarna',
            'Telcyra',
            'Teldrua',
            'Telegris',
            'Telendys',
            'Teleura',
            'Telnarzim',
            'Temeris',
            'Temeslin',
            'Temmosus',
            'Temontel',
            'Tenadas',
            'Tenidrist',
            'Teotsir',
            'Terasiln',
            'Terejoen',
            'Terena',
            'Terquaelen',
            'Terrenus',
            'Terthelej',
            'Terthyrkrim',
            "Terva\xebn",
            'Tesmarrak',
            'Tevala',
            'Tezarim',
            'Thadarin',
            'Thalafer',
            'Thalaras',
            'Thalira',
            'Thalladyle',
            'Thameera',
            'Thamiel',
            'Thanalar',
            'Tharamoon',
            'Tharnia',
            'Tharomyl',
            'Tharoval',
            'Thellikkin',
            'Thelodin',
            'Thereski',
            'Thieras',
            'Thieryn',
            'Thirindon',
            'Thithrama',
            'Thitrivar',
            'Thixagen',
            'Thlenedern',
            'Thlunarna',
            'Thoorana',
            'Thrabanquo',
            'Thumithar',
            'Thurmatoth',
            'Thuuvanar',
            'Tiabrell',
            'Tiachul',
            'Tianan',
            'Tiaosut',
            'Tiaxa',
            'Tiazan',
            'Tiefkol',
            'Tifulgar',
            'Tigrana',
            'Tirages',
            'Tiregam',
            'Tirelev',
            'Tirion',
            'Tirlimist',
            'Tirrasthu',
            'Tissawane',
            'Titia',
            'Tivadul',
            'Tiveran',
            'Tivriex',
            'Tiyagar',
            'Tizvian',
            'Tolarim',
            'Tolarmej',
            'Tolenka',
            'Tolibell',
            'Toramus',
            'Torbera',
            'Torgassin',
            'Torlion',
            'Tormitran',
            "Toro\xe4sh",
            'Toroman',
            'Torquenyx',
            'Torresind',
            'Torsamant',
            'Torzundus',
            'Tothirnal',
            'Tralien',
            'Tralquien',
            'Traviod',
            'Tredestin',
            'Trellium',
            'Trenaevis',
            'Trilajo',
            'Trinezhan',
            'Triolus',
            'Trisdestrin',
            'Troviawn',
            'Trydaron',
            'Trysadon',
            'Tsacramal',
            'Tsalkoril',
            'Tuilleth',
            'Tulio',
            'Tuniger',
            'Turmalin',
            'Turobel',
            'Turvesin',
            'Twanalor',
            'Twillessin',
            'Tylastreen',
            'Tyldora',
            'Tylenea',
            'Tyradin',
            'Tyrathis',
            'Tyrtyra',
            'Tzaroli',
            'Ualosk',
            'Ubdakon',
            'Udanax',
            'Udanib',
            'Udefoin',
            'Udrahart',
            'Udria',
            'Ufanort',
            'Ufial',
            'Ugivor',
            'Uilda',
            'Uilric',
            'Uixet',
            'Ukinorn',
            'Ulanthas',
            'Ulember',
            'Ulendal',
            'Ullifan',
            'Ulnavell',
            'Ulnaxdra',
            'Ulrepin',
            "Ulro\xebnce",
            'Umaspin',
            'Umbraheed',
            'Umbrina',
            'Umerac',
            'Umeri',
            'Umikrel',
            'Umistal',
            'Undalryn',
            'Unedrinj',
            'Unkalisk',
            'Unstoffel',
            "Ura\xf6r",
            'Urghazkoy',
            'Urhankren',
            'Urimnor',
            'Urjalum',
            'Urjaya',
            'Urmalgis',
            'Urrelor',
            'Urzunift',
            'Uscrumine',
            'Usegar',
            'Ushamtar',
            'Usigul',
            'Uskanast',
            'Ussala',
            'Ussolec',
            'Ustaleaugh',
            'Uthudain',
            'Utorel',
            'Uveena',
            'Uxavis',
            'Uxinor',
            'Uxuvi',
            'Uzileth',
            'Uziprost',
            'Uzirin',
            'Uzisloj',
            "Vacru\xebx",
            'Vakrissa',
            'Valabar',
            'Valadan',
            'Valagarth',
            'Valandrib',
            'Valarend',
            'Valarom',
            'Valaxis',
            'Valdera',
            'Valfoxel',
            'Valina',
            'Valion',
            'Valistes',
            'Vallia',
            'Valmerac',
            'Valphanar',
            'Valserna',
            'Valterla',
            "Valthom\xe9",
            'Vanamon',
            'Vanara',
            'Vanathil',
            'Vandelex',
            'Vanegrin',
            'Vangrahzmid',
            'Vantarad',
            'Varamanx',
            'Varamid',
            'Varamis',
            'Varcantis',
            'Varchimas',
            'Varkellit',
            'Varlandel',
            "Varra\xebl",
            'Varrakel',
            'Vashlion',
            'Vasmarro',
            'Vaudirek',
            'Vayemis',
            'Vedaraf',
            "Veezpro\xe4",
            'Velaila',
            'Velanac',
            'Velija',
            'Velina',
            'Velior',
            'Velissa',
            'Velozma',
            'Velvermeld',
            'Vendramyr',
            'Veneska',
            'Venithros',
            'Venmarenc',
            'Vercazlyde',
            'Vereedra',
            'Verenice',
            'Vereska',
            'Verethest',
            'Verissrad',
            'Verolant',
            'Verowa',
            'Vervadesce',
            'Ververine',
            'Veslomere',
            'Vetrengarr',
            'Vettemis',
            'Vhiallon',
            'Viastin',
            'Viastra',
            'Videla',
            'Videssos',
            'Viero',
            'Vilirast',
            'Vilrokin',
            'Vilscelyn',
            'Viomer',
            'Virandisp',
            'Virenar',
            'Virensa',
            'Virjauruk',
            'Virosanne',
            'Virthuren',
            'Vismarun',
            'Visperime',
            'Vixuad',
            "Vixu\xebl",
            'Vizina',
            'Vladilesk',
            'Vlarobaal',
            "Voiop\xeb",
            'Vojeera',
            'Voldisterre',
            'Volkazen',
            'Volmaran',
            'Voluru',
            'Vonidar',
            'Voozcoreme',
            'Voranor',
            'Vorchazel',
            'Vorelgin',
            'Vorien',
            'Vornica',
            'Vornovas',
            'Vorquemand',
            'Vorunir',
            'Vorvadoss',
            'Vosmerrel',
            'Vossari',
            'Vozmarald',
            'Vrepimus',
            'Vrilestamn',
            'Vristamor',
            "Vu\xebthar",
            'Walspinore',
            'Wandalar',
            'Wanestka',
            'Wantorak',
            'Wardlanof',
            'Warlwier',
            'Warrigel',
            'Wascramin',
            "Wasmo\xebt",
            'Watreyan',
            'Wazerac',
            'Wedonal',
            'Welmerel',
            'Wendower',
            'Werrelet',
            'Werscunok',
            'Weverin',
            'Wexavin',
            'Whallifrond',
            'Whearius',
            'Whibmistle',
            'Wianna',
            'Wicardod',
            'Widzoonaev',
            'Wignaja',
            'Wiinecot',
            'Winian',
            'Wodhrian',
            'Woringel',
            'Woxethoon',
            'Wrodlian',
            'Wurzemand',
            'Wyliath',
            'Xadamos',
            'Xadogar',
            'Xaisuruk',
            'Xalorof',
            'Xanafel',
            'Xanalver',
            'Xanbiah',
            'Xania',
            'Xantenmec',
            'Xanxia',
            'Xaraata',
            'Xargusull',
            'Xarthia',
            'Xeelafarl',
            'Xeelona',
            'Xegessem',
            'Xelica',
            'Xemeret',
            'Xemindar',
            'Xenia',
            'Xeralisk',
            'Xerdelisse',
            'Xerechron',
            'Xhalsadan',
            'Xhanazlet',
            'Xhodrovan',
            'Xibalba',
            'Xiifrani',
            'Ximahlto',
            'Ximakran',
            'Ximodi',
            'Xirian',
            'Xirijasp',
            "Xo\xe4non",
            'Xomdiral',
            'Xorandor',
            'Xoryalan',
            'Xyaria',
            'Yaimondar',
            'Yakovar',
            'Yakthodah',
            'Yalduvar',
            'Yaliath',
            'Yallarna',
            'Yallorind',
            'Yalveron',
            'Yamala',
            'Yamindra',
            'Yandelar',
            'Yandrahla',
            'Yaralet',
            'Yarial',
            'Yarillo',
            'Yarzolept',
            'Yashengzeb',
            'Yathagault',
            'Yathoric',
            'Yathorlak',
            'Ybalil',
            'Ybranar',
            'Yeltranal',
            "Yelu\xf6z",
            'Yemanthal',
            'Yemboloth',
            'Yerdien',
            'Yesgolod',
            'Yevjarel',
            'Yfremoon',
            'Ygristan',
            "Yhantu\xf6r",
            'Yldejaste',
            'Ymarisce',
            'Ymbria',
            'Yncaarim',
            'Yohonough',
            'Yonraloth',
            'Yoplossa',
            'Yoredan',
            'Yormexoon',
            'Yranthis',
            'Yratos',
            'Yrcanos',
            'Yronthol',
            'Yrwelos',
            'Yryloth',
            'Ythlyra',
            'Ythribond',
            'Yurnada',
            'Yusperal',
            'Yuzigral',
            'Zaamontel',
            'Zadamun',
            'Zadipan',
            'Zadrowane',
            'Zagrenxa',
            'Zaharbif',
            'Zajrenja',
            'Zakiwya',
            'Zalagi',
            'Zalanath',
            'Zalazar',
            'Zalberek',
            'Zalremy',
            'Zamberel',
            'Zamblezur',
            'Zamora',
            'Zamordax',
            'Zamorla',
            'Zanatir',
            'Zanestra',
            'Zangabal',
            'Zanindil',
            'Zanreynad',
            'Zantifer',
            'Zanzinel',
            'Zaraana',
            'Zaranave',
            'Zaranax',
            'Zarfhaano',
            'Zarimarth',
            'Zathmandar',
            'Zayzazi',
            'Zazamanc',
            'Zazumel',
            'Zazwinoon',
            'Zebalan',
            'Zefaeran',
            'Zefrondus',
            'Zelemorn',
            'Zelgadis',
            'Zellinet',
            'Zelmarine',
            'Zelprothon',
            'Zemanthel',
            'Zemirtol',
            'Zenaxa',
            'Zenilyeth',
            'Zenithral',
            'Zenorsha',
            'Zentrigar',
            'Zeosard',
            'Zephiron',
            'Zequiel',
            'Zeranoj',
            'Zhelavon',
            'Zhemaeta',
            'Ziacalt',
            'Zifidin',
            'Zilkorlaz',
            'Ziraldra',
            'Zirdarbis',
            'Zirzihin',
            "Zo\xe4lmar",
            "Zo\xe4ndrik",
            "Zo\xe4var",
            'Zochiad',
            'Zodolin',
            'Zoltaren',
            'Zominor',
            'Zoramus',
            'Zoranji',
            'Zorashad',
            'Zorayas',
            'Zorestrel',
            'Zorewyr',
            'Zoroma',
            'Zoromesh',
            'Zosmindo',
            'Zotaquaan',
            'Zotheera',
            'Zozminod',
            'Zubvuysa',
            'Zulaeram',
            'Zulpirek',
            'Zurenkin',
            'Zurliban',
            'Zydaraf',
            'Zylarthen',
            'Zyramythe',
            'Zytavirk'
        ],
        more: [
            'Abadapnyr',
            'Abrethendar',
            'Acrasian',
            'Adario',
            'Adieseth',
            'Adilikor',
            'Adinalar',
            'Adriaxa',
            'Afelanidd',
            'Aforvalon',
            'Agiora',
            'Agreliwin',
            'Aguidran',
            'Aguilla',
            'Aikikia',
            'Akitarka',
            'Alanahetra',
            'Alarion',
            'Alartia',
            'Alarurigu',
            'Alcidio',
            'Aldarian',
            'Alelakon',
            'Aleshmara',
            'Aletorim',
            'Aleuworust',
            'Alianala',
            'Alicindra',
            'Allessanya',
            'Alorassanz',
            'Amafeyan',
            'Amathenar',
            'Amdaramast',
            'Amiria',
            'Amriffien',
            'Anaumiantis',
            'Anelofar',
            'Angetenar',
            'Angurvidel',
            'Animeldio',
            'Anixido',
            'Ankitarla',
            'Ansamanthion',
            'Ansimantar',
            'Anspiladri',
            'Antillia',
            'Aphiana',
            'Aptolcater',
            'Aptrinuptium',
            'Aquilia',
            "Aradlum\xe9",
            'Araledek',
            'Aramanzom',
            'Aramestor',
            'Arania',
            'Arazederu',
            'Arazynxa',
            'Ardzefurith',
            'Arezia',
            'Arhilian',
            'Arianroth',
            'Ariaria',
            'Ariaxoc',
            'Arismaspia',
            'Ariyava',
            'Armalisrah',
            'Aroxian',
            'Arrolian',
            'Arsevalin',
            'Artalien',
            'Aruzustin',
            'Arzangiran',
            'Asalirin',
            'Asarlia',
            'Asicia',
            'Aslambarash',
            'Aslerion',
            'Asthania',
            'Asuricorm',
            'Atarana',
            'Athiana',
            'Athlebasia',
            'Athoriel',
            'Atiaran',
            'Aulurien',
            'Avalenar',
            'Avanimmerl',
            'Avelembai',
            'Aviathar',
            'Axajaxas',
            'Azeledim',
            'Azgelazgus',
            'Aziria',
            'Barosathlom',
            'Barylophar',
            'Bazkalia',
            'Beledira',
            'Belintraia',
            'Belrablion',
            'Borosiyan',
            'Bradullio',
            'Brodalcaflar',
            'Cajarrida',
            "Calane\xfcs",
            'Calasapia',
            'Caldiloran',
            'Caleria',
            'Calgalcandar',
            'Calidundarios',
            'Calliwelleran',
            'Calmamelis',
            'Caratrothis',
            'Carthazian',
            'Casrinian',
            'Cassrimello',
            "Cauditrice\xe4",
            'Cerelama',
            'Chaestebalon',
            'Chalirio',
            "Cha\xf6lthanesh",
            'Chisirion',
            'Cinariyan',
            'Cinnarath',
            'Cirthavion',
            "Co\xe4berul",
            "Co\xebxitaq",
            "Coranco\xe4n",
            'Coreliad',
            'Corrilisan',
            'Cossario',
            'Crotimian',
            'Cuidurjau',
            'Cymoria',
            'Dajuvius',
            'Dakrolidur',
            'Dameraxia',
            'Daraviel',
            'Daraztheon',
            'Darsimala',
            'Darsurion',
            'Dassalpian',
            'Daxxihidil',
            'Delrinian',
            'Demasaran',
            'Demeriolet',
            'Devaloka',
            'Diamerune',
            'Dicadoran',
            'Didoria',
            'Dinrudromon',
            'Dirinnia',
            'Dolohies',
            'Dophinrian',
            'Dornatentorl',
            'Drevixibrind',
            'Drexorvion',
            'Duralica',
            'Dyskilian',
            "E\xe4lisen",
            "E\xe4tinor",
            'Ebriany',
            'Eclaramon',
            'Efarion',
            'Efiranlas',
            'Egajia',
            'Eglaharant',
            'Eglantarask',
            'Elantargin',
            'Elarial',
            'Eleglorross',
            'Elianna',
            'Elisdriel',
            "Elivint\xe9",
            'Ellyria',
            "Elorta\xf6l",
            'Eltaria',
            'Elverion',
            'Elysia',
            'Emelesis',
            'Emelsyna',
            'Enstarlamyn',
            'Entalaroth',
            'Epimissia',
            'Erejitha',
            'Eremiess',
            'Erengazor',
            'Erigia',
            'Erivalda',
            'Escalinian',
            'Escamorid',
            'Eschurioz',
            'Esmerashard',
            'Esnaramik',
            'Etheriasa',
            'Etianor',
            'Etybrinel',
            'Ezaltarem',
            'Ezellohar',
            'Faedulias',
            'Falastien',
            'Falerio',
            'Falyrias',
            'Farsemnithal',
            'Favaijeness',
            'Felarica',
            'Felmarien',
            'Feresilmar',
            'Fiarazio',
            'Fiespegar',
            'Fimalemuen',
            'Finactias',
            'Fiormezath',
            'Firvintilis',
            'Flamorriwisp',
            'Flaxifyglar',
            "Fo\xe4zekov",
            'Folsalino',
            'Frixalissa',
            'Fusafandra',
            'Fuvusarooz',
            'Gaflorinos',
            'Galathanax',
            'Galdviara',
            'Galirrhyalen',
            'Gambrimanthus',
            'Ganthelios',
            'Ganvarathimyr',
            'Garlinian',
            'Gauribanon',
            'Gazaforen',
            "Geluru\xebm",
            'Gemaleon',
            'Ghondaliom',
            'Giavicel',
            'Gikishika',
            'Gorvonia',
            'Halremsolath',
            'Hanciara',
            'Harfelengol',
            'Hatuina',
            'Hazrathsimoon',
            'Hazrinivra',
            'Herazibrax',
            'Hiabezur',
            'Hidolebni',
            'Hipalonin',
            'Hizzlechaltezeme',
            "Hlantremi\xebr",
            'Hovancomi',
            'Hurania',
            "Hyfe\xe4ntio",
            'Ibaletri',
            'Idriella',
            'Ierendi',
            'Igadiax',
            'Iglithebem',
            'Ilanayom',
            'Ilerida',
            'Ilirsiya',
            'Ilizio',
            'Illemestri',
            'Ilminaris',
            'Impelia',
            'Inikia',
            "Inthe\xe4nereon",
            'Ionellza',
            'Iongua',
            'Iophroster',
            'Iptameela',
            'Irgasia',
            'Iskarnia',
            'Iuzator',
            'Ixiosyne',
            'Izmirodon',
            'Jachoriax',
            'Jakanuin',
            'Jalanochlan',
            'Jaleduin',
            'Jandrebliash',
            'Jaralectan',
            'Jarchesmadis',
            'Javethiel',
            'Jelanjaztor',
            'Jemalkhiri',
            'Jemarixtesen',
            'Jirchesmiod',
            'Juaxmanar',
            'Jurelisma',
            'Kadarion',
            'Kagilia',
            'Kalenizin',
            'Kalienlod',
            'Kalpalanin',
            'Kandathama',
            'Kanthamio',
            'Karania',
            'Kardamordax',
            'Karethezam',
            'Karisempatur',
            'Karriasal',
            'Karthassily',
            'Kastrevelda',
            'Katanmaral',
            'Kemeroxel',
            'Keolotrest',
            'Keremelar',
            'Kerisiar',
            'Khalatulajax',
            'Khrysarlion',
            'Kikianik',
            'Kiralizur',
            'Kishidega',
            'Koquilgion',
            'Kryslaria',
            'Lalarian',
            'Lamamelis',
            'Lamdiraka',
            'Lamirila',
            'Lamotridac',
            'Lantessorax',
            'Larasajan',
            'Laschiantria',
            'Lauaxeta',
            'Laziarlan',
            'Lemesprie',
            'Leoniax',
            'Lepeduin',
            'Lialasia',
            'Liquilioss',
            'Lirrissia',
            "Locrama\xebl",
            'Ludurafet',
            'Luithiole',
            'Lyzalian',
            'Lyzeoldir',
            'Maheriel',
            "Majezre\xe4l",
            'Malabderas',
            'Malantiggar',
            'Malasteon',
            'Malevila',
            'Malyremeth',
            'Manariasc',
            'Maranduax',
            'Marassumar',
            'Maresedin',
            'Marillia',
            'Marzaranax',
            'Mathranislom',
            'Maudrosnia',
            'Mayulisas',
            'Medricaeldo',
            'Meliabrak',
            'Meliadoul',
            'Melidium',
            'Meliofard',
            "Melismond\xe9",
            'Melkandoro',
            'Melozathel',
            'Melusinnia',
            'Mereniax',
            'Meresinapt',
            'Mermiculex',
            'Metebelvis',
            'Mianjira',
            'Milinderra',
            'Mirelassar',
            'Mirianis',
            'Mirtagarkarit',
            "Mo\xe4thyalond",
            'Momelsia',
            'Morasina',
            'Morciana',
            'Moriliem',
            'Morilioth',
            'Muathazaglimid',
            'Mylakhrion',
            'Myrraxion',
            'Myrristica',
            'Naburios',
            'Nanieroj',
            'Narasia',
            'Narjiona',
            'Narragazkara',
            'Narzelduin',
            'Nemmaridus',
            'Nempifermal',
            'Nerovius',
            'Nevalrimyr',
            'Nevinlemnus',
            'Nichoriam',
            'Nimrathelet',
            'Nissebaral',
            'Niziliom',
            'Nohbirrian',
            'Octramadus',
            'Ohirial',
            'Okarbia',
            'Okpralio',
            'Olemerrin',
            'Oloscendivarn',
            'Onnurian',
            'Opacalia',
            'Orathiris',
            'Orbicritis',
            'Orialex',
            'Oriastus',
            'Orissanat',
            'Ormallivir',
            'Ormeria',
            'Orrizia',
            'Orroptio',
            'Orthaxifer',
            'Orviliach',
            'Otolvian',
            'Pactinasa',
            'Palzyriax',
            'Panaxcrador',
            'Panthioleed',
            'Paolalian',
            'Pelemurto',
            'Pelluxia',
            'Pemelojurg',
            'Pemulinaan',
            'Perjauruan',
            'Phayzelobion',
            'Phomechelian',
            'Phorissital',
            'Piartamisk',
            "Pirou\xebtta",
            'Pluzemelar',
            "Pomivarno\xebn",
            'Pyrvinrian',
            'Quanamelis',
            'Quarlusian',
            'Quelidia',
            'Quelizantor',
            'Querrulian',
            'Quetradendith',
            'Rajanthesina',
            'Rakanamet',
            'Ramantasset',
            'Ranasceleb',
            'Rasanathan',
            'Rathelemen',
            'Ravannifer',
            'Reondoresin',
            'Rhazazarak',
            'Rhiadirask',
            'Roxifalcor',
            "Rozalro\xe4th",
            "Ru\xe4lia",
            'Rudliptalin',
            'Rufomella',
            'Rulinian',
            'Runevara',
            'Ruzultrejest',
            'Rylissilin',
            'Saboorakel',
            'Sadonakai',
            'Saegdondakhar',
            'Salletifian',
            'Sandurion',
            'Sanoreya',
            'Sapelintir',
            'Sarantimar',
            'Sarathia',
            "Sarpemethe\xe4n",
            'Sarrabhluil',
            'Sartenia',
            'Saterbia',
            'Scarliherin',
            "Scoramant\xe9",
            'Semnegarius',
            'Serejarand',
            'Seremnaria',
            'Seriastis',
            'Serilia',
            'Seriona',
            'Shadarabar',
            'Sharadjelamir',
            'Sharajamar',
            'Shelarinisse',
            'Shelmorian',
            'Sireelia',
            'Sirezvia',
            'Siriena',
            'Sirulia',
            'Sorolonex',
            'Soromyrium',
            'Sorosilmar',
            'Sphallurian',
            'Sreltaneema',
            'Sulparia',
            'Suularaba',
            'Sylixia',
            'Tallosia',
            'Tamarien',
            'Tapromethyna',
            'Tarachien',
            'Taralian',
            'Tarsmiria',
            'Tasambekeer',
            'Tayenias',
            'Telaswiral',
            'Telaznemor',
            'Temilion',
            'Teniliak',
            'Tercyrian',
            'Thetalia',
            'Thorosiaz',
            'Tiaskelu',
            'Tifalius',
            'Tinzlactiash',
            'Tiriala',
            'Tirunriyek',
            'Tivamtemar',
            'Toraxoran',
            'Torellian',
            'Tormosian',
            'Trystaria',
            'Tsaliveren',
            'Tsardatsira',
            'Tuivoreth',
            'Ugalius',
            'Uguesilar',
            'Uirugan',
            'Ulakrugir',
            'Ulkarien',
            'Ullibunda',
            'Ultharnarath',
            'Umasdalen',
            'Umicia',
            'Unaramand',
            'Unlasnulkai',
            'Unorrehod',
            'Unuvia',
            'Upalumo',
            "Ura\xf6sin",
            'Uttosembuluz',
            'Uxulinak',
            'Valarindio',
            'Valarion',
            'Valaronai',
            'Valeauviej',
            'Varcassian',
            'Veladamar',
            'Velorian',
            'Venzafurome',
            'Vercerenos',
            'Veridia',
            'Vialora',
            'Vilcarien',
            'Vimbrodelthion',
            'Vincarian',
            'Virunia',
            'Vistramisorn',
            'Vreniriab',
            'Vruthalidrom',
            'Vyjeremanx',
            'Vyrania',
            'Werzamerand',
            'Wiernamal',
            'Wrosceltiar',
            'Wyjezinelb',
            'Xacuahatl',
            'Xaeximinar',
            'Xalaibisad',
            'Xalisuri',
            'Xaralien',
            'Xaralyna',
            'Xarilia',
            'Xasseldasene',
            'Xavanimar',
            'Xemelenos',
            'Xilvemzarad',
            'Xiomriest',
            'Xorlanterond',
            'Xorosia',
            'Yamidala',
            'Yamovelhas',
            'Yannavalka',
            'Yarbithresin',
            'Yarmidrian',
            'Yavilana',
            'Yazarrahaj',
            'Yetlioro',
            'Yormanien',
            'Yssarion',
            'Yzaniva',
            'Zabarianx',
            'Zaharsian',
            'Zalrevliaf',
            'Zanzarathool',
            'Zatakruan',
            'Zaulizanir',
            'Zavalliar',
            'Zavalniax',
            'Zekundaloth',
            'Zekundemar',
            'Zelissinfra',
            'Zelobindio',
            'Ziandela',
            'Zicarecem',
            'Zimenaechu',
            'Zofelliara',
            'Zoramatoth',
            'Zulaaria',
            'Zuralion',
            'Zuruxeno',
            'Zuzusilmar',
            'Zwimolio',
            "Zwy\xe4clemon",
            'Zyrissalantisar'
        ]
    }
};


var $a005f386d8246fce$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $a005f386d8246fce$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $a005f386d8246fce$var$symbolTag = '[object Symbol]';
/** Used to compose unicode character classes. */ var $a005f386d8246fce$var$rsAstralRange = '\\ud800-\\udfff', $a005f386d8246fce$var$rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23', $a005f386d8246fce$var$rsComboSymbolsRange = '\\u20d0-\\u20f0', $a005f386d8246fce$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $a005f386d8246fce$var$rsAstral = '[' + $a005f386d8246fce$var$rsAstralRange + ']', $a005f386d8246fce$var$rsCombo = '[' + $a005f386d8246fce$var$rsComboMarksRange + $a005f386d8246fce$var$rsComboSymbolsRange + ']', $a005f386d8246fce$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $a005f386d8246fce$var$rsModifier = '(?:' + $a005f386d8246fce$var$rsCombo + '|' + $a005f386d8246fce$var$rsFitz + ')', $a005f386d8246fce$var$rsNonAstral = '[^' + $a005f386d8246fce$var$rsAstralRange + ']', $a005f386d8246fce$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $a005f386d8246fce$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $a005f386d8246fce$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $a005f386d8246fce$var$reOptMod = $a005f386d8246fce$var$rsModifier + '?', $a005f386d8246fce$var$rsOptVar = '[' + $a005f386d8246fce$var$rsVarRange + ']?', $a005f386d8246fce$var$rsOptJoin = '(?:' + $a005f386d8246fce$var$rsZWJ + '(?:' + [
    $a005f386d8246fce$var$rsNonAstral,
    $a005f386d8246fce$var$rsRegional,
    $a005f386d8246fce$var$rsSurrPair
].join('|') + ')' + $a005f386d8246fce$var$rsOptVar + $a005f386d8246fce$var$reOptMod + ')*', $a005f386d8246fce$var$rsSeq = $a005f386d8246fce$var$rsOptVar + $a005f386d8246fce$var$reOptMod + $a005f386d8246fce$var$rsOptJoin, $a005f386d8246fce$var$rsSymbol = '(?:' + [
    $a005f386d8246fce$var$rsNonAstral + $a005f386d8246fce$var$rsCombo + '?',
    $a005f386d8246fce$var$rsCombo,
    $a005f386d8246fce$var$rsRegional,
    $a005f386d8246fce$var$rsSurrPair,
    $a005f386d8246fce$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $a005f386d8246fce$var$reUnicode = RegExp($a005f386d8246fce$var$rsFitz + '(?=' + $a005f386d8246fce$var$rsFitz + ')|' + $a005f386d8246fce$var$rsSymbol + $a005f386d8246fce$var$rsSeq, 'g');
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $a005f386d8246fce$var$reHasUnicode = RegExp('[' + $a005f386d8246fce$var$rsZWJ + $a005f386d8246fce$var$rsAstralRange + $a005f386d8246fce$var$rsComboMarksRange + $a005f386d8246fce$var$rsComboSymbolsRange + $a005f386d8246fce$var$rsVarRange + ']');
/** Detect free variable `global` from Node.js. */ var $a005f386d8246fce$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $a005f386d8246fce$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $a005f386d8246fce$var$root = $a005f386d8246fce$var$freeGlobal || $a005f386d8246fce$var$freeSelf || Function('return this')();
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a005f386d8246fce$var$asciiToArray(string) {
    return string.split('');
}
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $a005f386d8246fce$var$hasUnicode(string) {
    return $a005f386d8246fce$var$reHasUnicode.test(string);
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a005f386d8246fce$var$stringToArray(string) {
    return $a005f386d8246fce$var$hasUnicode(string) ? $a005f386d8246fce$var$unicodeToArray(string) : $a005f386d8246fce$var$asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $a005f386d8246fce$var$unicodeToArray(string) {
    return string.match($a005f386d8246fce$var$reUnicode) || [];
}
/** Used for built-in method references. */ var $a005f386d8246fce$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a005f386d8246fce$var$objectToString = $a005f386d8246fce$var$objectProto.toString;
/** Built-in value references. */ var $a005f386d8246fce$var$Symbol = $a005f386d8246fce$var$root.Symbol;
/** Used to convert symbols to primitives and strings. */ var $a005f386d8246fce$var$symbolProto = $a005f386d8246fce$var$Symbol ? $a005f386d8246fce$var$Symbol.prototype : undefined, $a005f386d8246fce$var$symbolToString = $a005f386d8246fce$var$symbolProto ? $a005f386d8246fce$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $a005f386d8246fce$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $a005f386d8246fce$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($a005f386d8246fce$var$isSymbol(value)) return $a005f386d8246fce$var$symbolToString ? $a005f386d8246fce$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$a005f386d8246fce$var$INFINITY ? '-0' : result;
}
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $a005f386d8246fce$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $a005f386d8246fce$var$baseSlice(array, start, end);
}
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $a005f386d8246fce$var$createCaseFirst(methodName) {
    return function(string) {
        string = $a005f386d8246fce$var$toString(string);
        var strSymbols = $a005f386d8246fce$var$hasUnicode(string) ? $a005f386d8246fce$var$stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $a005f386d8246fce$var$castSlice(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $a005f386d8246fce$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $a005f386d8246fce$var$isSymbol(value) {
    return typeof value == 'symbol' || $a005f386d8246fce$var$isObjectLike(value) && $a005f386d8246fce$var$objectToString.call(value) == $a005f386d8246fce$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $a005f386d8246fce$var$toString(value) {
    return value == null ? '' : $a005f386d8246fce$var$baseToString(value);
}
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $a005f386d8246fce$var$capitalize(string) {
    return $a005f386d8246fce$var$upperFirst($a005f386d8246fce$var$toString(string).toLowerCase());
}
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $a005f386d8246fce$var$upperFirst = $a005f386d8246fce$var$createCaseFirst('toUpperCase');
$a005f386d8246fce$exports = $a005f386d8246fce$var$capitalize;


var $9a926653c32dbfd1$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $9a926653c32dbfd1$var$INFINITY = 1 / 0, $9a926653c32dbfd1$var$MAX_INTEGER = 1.7976931348623157e+308, $9a926653c32dbfd1$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $9a926653c32dbfd1$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $9a926653c32dbfd1$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $9a926653c32dbfd1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $9a926653c32dbfd1$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $9a926653c32dbfd1$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $9a926653c32dbfd1$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $9a926653c32dbfd1$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $9a926653c32dbfd1$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $9a926653c32dbfd1$var$root = $9a926653c32dbfd1$var$freeGlobal || $9a926653c32dbfd1$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $9a926653c32dbfd1$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9a926653c32dbfd1$var$objectToString = $9a926653c32dbfd1$var$objectProto.toString;
/** Built-in value references. */ var $9a926653c32dbfd1$var$Symbol = $9a926653c32dbfd1$var$root.Symbol;
/** Used to convert symbols to primitives and strings. */ var $9a926653c32dbfd1$var$symbolProto = $9a926653c32dbfd1$var$Symbol ? $9a926653c32dbfd1$var$Symbol.prototype : undefined, $9a926653c32dbfd1$var$symbolToString = $9a926653c32dbfd1$var$symbolProto ? $9a926653c32dbfd1$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $9a926653c32dbfd1$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $9a926653c32dbfd1$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($9a926653c32dbfd1$var$isSymbol(value)) return $9a926653c32dbfd1$var$symbolToString ? $9a926653c32dbfd1$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$9a926653c32dbfd1$var$INFINITY ? '-0' : result;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $9a926653c32dbfd1$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $9a926653c32dbfd1$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $9a926653c32dbfd1$var$isSymbol(value) {
    return typeof value == 'symbol' || $9a926653c32dbfd1$var$isObjectLike(value) && $9a926653c32dbfd1$var$objectToString.call(value) == $9a926653c32dbfd1$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $9a926653c32dbfd1$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $9a926653c32dbfd1$var$toNumber(value);
    if (value === $9a926653c32dbfd1$var$INFINITY || value === -$9a926653c32dbfd1$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $9a926653c32dbfd1$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $9a926653c32dbfd1$var$toInteger(value) {
    var result = $9a926653c32dbfd1$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $9a926653c32dbfd1$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($9a926653c32dbfd1$var$isSymbol(value)) return $9a926653c32dbfd1$var$NAN;
    if ($9a926653c32dbfd1$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $9a926653c32dbfd1$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($9a926653c32dbfd1$var$reTrim, '');
    var isBinary = $9a926653c32dbfd1$var$reIsBinary.test(value);
    return isBinary || $9a926653c32dbfd1$var$reIsOctal.test(value) ? $9a926653c32dbfd1$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $9a926653c32dbfd1$var$reIsBadHex.test(value) ? $9a926653c32dbfd1$var$NAN : +value;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $9a926653c32dbfd1$var$toString(value) {
    return value == null ? '' : $9a926653c32dbfd1$var$baseToString(value);
}
/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */ function $9a926653c32dbfd1$var$endsWith(string, target, position) {
    string = $9a926653c32dbfd1$var$toString(string);
    target = $9a926653c32dbfd1$var$baseToString(target);
    var length = string.length;
    position = position === undefined ? length : $9a926653c32dbfd1$var$baseClamp($9a926653c32dbfd1$var$toInteger(position), 0, length);
    var end = position;
    position -= target.length;
    return position >= 0 && string.slice(position, end) == target;
}
$9a926653c32dbfd1$exports = $9a926653c32dbfd1$var$endsWith;


const $be7d6440f987b85e$var$dieRoll = (dieSize = 10)=>(0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, dieSize, {
        rngFn: $be7d6440f987b85e$var$rngFnContainer.rngFn
    });
const $be7d6440f987b85e$var$isVowel = (letter)=>[
        "a",
        "e",
        "i",
        "o",
        "u"
    ].includes(letter);
const $be7d6440f987b85e$var$vileAndCrude = (size)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).vileAndCrude[size];
    return $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr)) + $be7d6440f987b85e$var$sample(nameArr);
};
const $be7d6440f987b85e$var$genderSuffixesKey = (gender)=>`${gender}Suffixes`;
const $be7d6440f987b85e$export$f330661115510edf = ()=>$be7d6440f987b85e$var$vileAndCrude("small");
const $be7d6440f987b85e$export$164e3face987268c = ()=>$be7d6440f987b85e$var$vileAndCrude("medium");
const $be7d6440f987b85e$export$cbca8355c5841452 = ()=>$be7d6440f987b85e$var$vileAndCrude("large");
const $be7d6440f987b85e$export$fc734a8352e8f082 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).primitive;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.names));
    const roll = $be7d6440f987b85e$var$dieRoll(10);
    if (gender === "male") {
        if (roll > 3) name = `${name}-${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.names))}`;
        if (roll > 8) name = `${name}-${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.names))}`;
    } else if (gender === "female") {
        if (roll > 5) name = `${name}-${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.names))}`;
        name = `${name}-${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.suffixes))}`;
    }
    return name;
};
const $be7d6440f987b85e$export$b7a6217d119153b2 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).doughty;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.syllables));
    const roll = $be7d6440f987b85e$var$dieRoll(10);
    if (gender === "male") {
        if (roll > 7) name = `${name}${$be7d6440f987b85e$var$isVowel(name.slice(-1)) ? "r" : "i"}`;
        else name = `${name}${$be7d6440f987b85e$var$sample(nameArr.maleSuffixes)}`;
    } else if (gender === "female") {
        if (roll > 7) name = `${name}${$be7d6440f987b85e$var$isVowel(name.slice(-1)) ? "ra" : "a"}`;
        else name = `${name}${$be7d6440f987b85e$var$sample(nameArr.femaleSuffixes)}`;
    }
    return name;
};
const $be7d6440f987b85e$export$b6dba0b78ba793e2 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).homely;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.syllables));
    const roll = $be7d6440f987b85e$var$dieRoll(10);
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    if (roll > 6) name = `${name} ${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).familyName.english)}`;
    return name;
};
const $be7d6440f987b85e$export$6fb065e3009500e1 = (gender)=>{
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).doughty.syllables));
    const roll = $be7d6440f987b85e$var$dieRoll(10);
    if ((0, $df375085b7c59381$export$e4b2ac9215619f8d).homely[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).homely[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    if (roll > 6) name = `${name} ${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).familyName.scottish)}`;
    return name;
};
const $be7d6440f987b85e$var$sample = (arr)=>{
    return (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(arr, {
        rngFn: $be7d6440f987b85e$var$rngFnContainer.rngFn
    });
};
const $be7d6440f987b85e$export$1ad0edd53e6ef91 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).fairAndNoble;
    let name = `${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.elfPrefixes))}${$be7d6440f987b85e$var$sample(nameArr.middle)}`;
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$e251ffd6d5b8e509 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).fairAndNoble;
    let name = `${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.alternativeElfPrefixes))}${$be7d6440f987b85e$var$sample(nameArr.middle)}`;
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$var$rngFnContainer = {
    rngFn: Math.random
};
const $be7d6440f987b85e$export$d7b219776568c005 = (seed)=>{
    $be7d6440f987b85e$var$rngFnContainer.rngFn = (0, $a80d0b17b615d6f7$export$5cc7dd0a77110dbe)(seed);
};
const $be7d6440f987b85e$export$166a844384d7abeb = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).fairy;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixes));
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$8e76d4779b05a9b7 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).alternateFairy;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixes));
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$aa1fcb80c0fc6987 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).elegantEvil;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixesDarkElves));
    const roll = $be7d6440f987b85e$var$dieRoll(10);
    if (roll > 2) name = `${name}${$be7d6440f987b85e$var$sample(nameArr.middle)}`;
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$ee2ecd3ff60576bc = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).elegantEvil;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixesAlternateDarkElves));
    const roll = $be7d6440f987b85e$var$dieRoll(10);
    if (roll > 2) name = `${name}${$be7d6440f987b85e$var$sample(nameArr.middle)}`;
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$9e2da7d9137ba6f2 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).malevolent;
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixes));
    if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$f1fd645118ed8be8 = ()=>{
    const keys = Object.keys((0, $df375085b7c59381$export$e4b2ac9215619f8d).infernal);
    const roll = $be7d6440f987b85e$var$dieRoll(3) - 1;
    const roll2 = $be7d6440f987b85e$var$dieRoll(2) - 1;
    const chosen = keys[roll];
    const chosen2 = keys.filter((x)=>x !== chosen)[roll2];
    return `${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).infernal[chosen]))}${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).infernal[chosen2])}`;
};
const $be7d6440f987b85e$export$1776144b47d3fcbf = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).draconic;
    const name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixes));
    let suffix = $be7d6440f987b85e$var$sample(nameArr.suffixes);
    if (gender === "female") {
        if (suffix === "bazius") suffix = "bazia";
        else if ($9a926653c32dbfd1$exports(suffix, "os")) suffix += "sa";
        else suffix = "is";
    }
    return name + suffix;
};
const $be7d6440f987b85e$export$759caa9319039385 = (gender)=>{
    const nameArr = (0, $df375085b7c59381$export$e4b2ac9215619f8d).empyreal;
    const roll = $be7d6440f987b85e$var$dieRoll(12);
    let name = $a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.prefixes));
    if (roll === 1) {
        if (gender === "female") {
            const aIndex = name.lastIndexOf("a");
            name = name.substr(0, aIndex) + "e" + name.substr(aIndex + 1);
        }
        name = `${$a005f386d8246fce$exports($be7d6440f987b85e$var$sample(nameArr.titles))}${name}`;
    } else if (nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)]) name = `${name}${$be7d6440f987b85e$var$sample(nameArr[$be7d6440f987b85e$var$genderSuffixesKey(gender)])}`;
    return name;
};
const $be7d6440f987b85e$export$2c5e0952da356af6 = (allowMultipleNames)=>{
    const roll = $be7d6440f987b85e$var$dieRoll(20);
    if (roll < 3) return $be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.one);
    if (roll < 12) return $be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.two);
    if (roll < 17) return $be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.three);
    if (roll === 17) return $be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.more);
    if (roll === 18 && allowMultipleNames) return `${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.one)} ${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.two)}`;
    if (roll === 19 && allowMultipleNames) return `${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.two)} ${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human.one)}`;
    if (roll === 20 && allowMultipleNames) {
        const keys = Object.keys((0, $df375085b7c59381$export$e4b2ac9215619f8d).human);
        return `${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human[$be7d6440f987b85e$var$sample(keys)])} ${$be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human[$be7d6440f987b85e$var$sample(keys)])}`;
    }
    return $be7d6440f987b85e$var$sample((0, $df375085b7c59381$export$e4b2ac9215619f8d).human[$be7d6440f987b85e$var$sample(Object.keys((0, $df375085b7c59381$export$e4b2ac9215619f8d).human))]);
};


const $f93bb81604774744$var$racesWithGender = [
    "cavePerson",
    "dwarf",
    "halfling",
    "gnome",
    "elf",
    "highelf",
    "fairy",
    "highfairy",
    "darkelf",
    "drow",
    "halfdemon",
    "dragon",
    "angel"
];
const $f93bb81604774744$var$otherRaces = [
    "demon",
    "human",
    "goblin",
    "ogre",
    "orc"
];
const $f93bb81604774744$export$b7f30c4d8e7172b2 = {
    otherRaces: $f93bb81604774744$var$otherRaces,
    racesWithGender: $f93bb81604774744$var$racesWithGender,
    sorted: ()=>$f93bb81604774744$var$racesWithGender.concat($f93bb81604774744$var$otherRaces).sort()
};
const $f93bb81604774744$export$5d832d6580b26c5 = (race, options = {})=>{
    const { gender: gender, allowMultipleNames: allowMultipleNames } = options;
    if ($f93bb81604774744$var$racesWithGender.includes(race) && gender !== undefined) switch(race){
        case "angel":
            return (0, $be7d6440f987b85e$export$759caa9319039385)(gender);
        case "cavePerson":
            return (0, $be7d6440f987b85e$export$fc734a8352e8f082)(gender);
        case "darkelf":
            return (0, $be7d6440f987b85e$export$aa1fcb80c0fc6987)(gender);
        case "dragon":
            return (0, $be7d6440f987b85e$export$1776144b47d3fcbf)(gender);
        case "drow":
            return (0, $be7d6440f987b85e$export$ee2ecd3ff60576bc)(gender);
        case "dwarf":
            return (0, $be7d6440f987b85e$export$b7a6217d119153b2)(gender);
        case "elf":
            return (0, $be7d6440f987b85e$export$1ad0edd53e6ef91)(gender);
        case "fairy":
            return (0, $be7d6440f987b85e$export$166a844384d7abeb)(gender);
        case "gnome":
            return (0, $be7d6440f987b85e$export$6fb065e3009500e1)(gender);
        case "halfdemon":
            return (0, $be7d6440f987b85e$export$9e2da7d9137ba6f2)(gender);
        case "halfling":
            return (0, $be7d6440f987b85e$export$b6dba0b78ba793e2)(gender);
        case "highelf":
            return (0, $be7d6440f987b85e$export$e251ffd6d5b8e509)(gender);
        case "highfairy":
            return (0, $be7d6440f987b85e$export$8e76d4779b05a9b7)(gender);
        default:
            break;
    }
    switch(race){
        case "demon":
            return (0, $be7d6440f987b85e$export$f1fd645118ed8be8)();
        case "goblin":
            return (0, $be7d6440f987b85e$export$f330661115510edf)();
        case "human":
            return (0, $be7d6440f987b85e$export$2c5e0952da356af6)(allowMultipleNames);
        case "ogre":
            return (0, $be7d6440f987b85e$export$cbca8355c5841452)();
        case "orc":
            return (0, $be7d6440f987b85e$export$164e3face987268c)();
        default:
            break;
    }
    return new Error("Must provide a gender!");
};


var $46cd47a21442bee6$exports = {};
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $2ZTWb = parcelRequire("2ZTWb");

var $xnasA = parcelRequire("xnasA");

var $huIqu = parcelRequire("huIqu");

var $jSeQD = parcelRequire("jSeQD");

var $cEbON = parcelRequire("cEbON");

var $iBJuF = parcelRequire("iBJuF");
var $4b474a497f635269$exports = {};

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = 'random', startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == 'object') {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == 'string' ? obj : obj + '\0';
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if ($4b474a497f635269$exports) {
        $4b474a497f635269$exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("5Io6y"));
        } catch (ex) {}
    } else if (typeof define == 'function' && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math['seed' + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== 'undefined' ? self : $4b474a497f635269$exports, [], Math // math: package containing random, pow, and seedrandom
);


$4b474a497f635269$exports.alea = $2ZTWb;
$4b474a497f635269$exports.xor128 = $xnasA;
$4b474a497f635269$exports.xorwow = $huIqu;
$4b474a497f635269$exports.xorshift7 = $jSeQD;
$4b474a497f635269$exports.xor4096 = $cEbON;
$4b474a497f635269$exports.tychei = $iBJuF;
$46cd47a21442bee6$exports = $4b474a497f635269$exports;


let $a80d0b17b615d6f7$var$RANDOM_NUMBER_GENERATOR = undefined;
const $a80d0b17b615d6f7$export$3301a959d36e944c = (seed)=>{
    $a80d0b17b615d6f7$var$RANDOM_NUMBER_GENERATOR = $46cd47a21442bee6$exports(seed);
};
const $a80d0b17b615d6f7$export$5cc7dd0a77110dbe = (seed)=>$46cd47a21442bee6$exports(seed);
const $a80d0b17b615d6f7$export$c45e8adbbf82647d = (min, max, seed)=>{
    if (seed) {
        const randomFloat = $a80d0b17b615d6f7$export$5cc7dd0a77110dbe(seed)();
        return Math.floor(randomFloat * (max - min + 1) + min);
    }
    if ($a80d0b17b615d6f7$var$RANDOM_NUMBER_GENERATOR === undefined) return (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(min, max);
    const randomFloat = $a80d0b17b615d6f7$var$RANDOM_NUMBER_GENERATOR();
    // min and max included
    return Math.floor(randomFloat * (max - min + 1) + min);
};
const $a80d0b17b615d6f7$export$2b048c255d2e69f3 = ()=>{
    if ($a80d0b17b615d6f7$var$RANDOM_NUMBER_GENERATOR === undefined) return Math.random();
    const randomFloat = $a80d0b17b615d6f7$var$RANDOM_NUMBER_GENERATOR();
    // min and max included
    return randomFloat;
};
const $a80d0b17b615d6f7$export$b363da9ded343252 = (p1, p2)=>Math.atan2(p2.y - p1.y, p2.x - p1.x) + Math.PI;
const $a80d0b17b615d6f7$export$3cb92a2060a7aca2 = (degrees)=>{
    const pi = Math.PI;
    return degrees * (pi / 180);
};
const $a80d0b17b615d6f7$export$32b1497b7aadef08 = (radians)=>{
    const pi = Math.PI;
    return radians * (180 / pi);
};
const $a80d0b17b615d6f7$export$5ebc7cf9991d3d13 = (radians)=>{
    function round5(x) {
        return Math.ceil(x / 25) * 25;
    }
    // atan2 returns signed angles; sprite directions use a full clockwise turn.
    const normalized = (radians % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI);
    const degrees = round5($a80d0b17b615d6f7$export$32b1497b7aadef08(normalized));
    let result = "right";
    if ($a80d0b17b615d6f7$export$cf95c51b03f10bae(degrees, 45, 135)) result = "front";
    if ($a80d0b17b615d6f7$export$cf95c51b03f10bae(degrees, 225, 315)) result = "back";
    if ($a80d0b17b615d6f7$export$cf95c51b03f10bae(degrees, 136, 224)) result = "left";
    return result;
};
const $a80d0b17b615d6f7$export$c71726d9d0282622 = (radians)=>{
    const dir = $a80d0b17b615d6f7$export$5ebc7cf9991d3d13(radians);
    switch(dir){
        case "front":
            return "south";
        case "back":
            return "north";
        case "right":
            return "east";
        case "left":
            return "west";
    }
    return "north";
};
const $a80d0b17b615d6f7$export$94d6114d0f45bc7e = (radians)=>{
    const orientation = $a80d0b17b615d6f7$export$5ebc7cf9991d3d13(radians);
    switch(orientation){
        case "front":
            return "Down";
        case "back":
            return "Up";
        case "right":
            return "Right";
        case "left":
            return "Left";
    }
    return "Up";
};
const $a80d0b17b615d6f7$export$df50878468f09592 = (radians)=>{
    const degrees = $a80d0b17b615d6f7$export$32b1497b7aadef08(radians);
    return ![
        90,
        180,
        270,
        360
    ].includes(degrees);
};
const $a80d0b17b615d6f7$export$9dac2d59bba1062a = (direction)=>{
    switch(direction){
        case "Down":
            return "Up";
        case "Up":
            return "Down";
        case "Right":
            return "Left";
        case "Left":
            return "Right";
    }
    return "Up";
};
const $a80d0b17b615d6f7$export$cf95c51b03f10bae = (x, a, b)=>x >= a && (b === undefined || x <= b);
const $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4 = (num, min, max)=>Math.max(min, Math.min(max, num));
const $a80d0b17b615d6f7$export$504709cb2a8295d2 = (fineCoordinate)=>{
    return !fineCoordinate ? undefined : {
        x: $a80d0b17b615d6f7$export$b240a5f8651dffb4(fineCoordinate.x),
        y: $a80d0b17b615d6f7$export$b240a5f8651dffb4(fineCoordinate.y)
    };
};
const $a80d0b17b615d6f7$export$566fe05fdbb514ba = (x)=>x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
const $a80d0b17b615d6f7$export$b240a5f8651dffb4 = (x)=>Math.floor(x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
const $a80d0b17b615d6f7$export$dd08c3a9a1f05e0c = (roomWidth, roomHeight, roomId, fineCoordinate)=>{
    const globalCoordinate = $a80d0b17b615d6f7$export$b03ec757ccd6a9ce();
    $a80d0b17b615d6f7$export$bd1cca3d8706a4e0(roomWidth, roomHeight, roomId, fineCoordinate, globalCoordinate);
    return globalCoordinate;
};
const $a80d0b17b615d6f7$export$f4f894b5dc700a2d = (x, y, roomWidth, roomHeight)=>{
    const roomX = Math.floor(x / roomWidth);
    const roomY = Math.floor(y / roomHeight);
    const roomId = `room-${roomX}-${roomY}`;
    const localX = x % roomWidth;
    const localY = y % roomHeight;
    return {
        roomId: roomId,
        x: localX,
        y: localY
    };
};
const $a80d0b17b615d6f7$export$138ae9036b843d3d = (roomWidth, roomHeight, roomX, roomY, fineCoordinate)=>{
    const globalCoordinate = $a80d0b17b615d6f7$export$b03ec757ccd6a9ce();
    const roomWidthFine = roomWidth * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const roomHeightFine = roomHeight * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const x = roomWidthFine * roomX + fineCoordinate.x;
    const y = roomHeightFine * roomY + fineCoordinate.y;
    globalCoordinate.x = x;
    globalCoordinate.y = y;
    return globalCoordinate;
};
const $a80d0b17b615d6f7$export$3463efbf94c3b6e1 = (roomId)=>{
    const [_, _roomX, _roomY] = roomId.split("-");
    return {
        x: Number(_roomX),
        y: Number(_roomY)
    };
};
const $a80d0b17b615d6f7$export$bd1cca3d8706a4e0 = (roomWidth, roomHeight, roomId, fineCoordinate, globalCoordinate)=>{
    const [_, _roomX, _roomY] = roomId.split("-");
    const roomX = Number(_roomX);
    const roomY = Number(_roomY);
    const roomWidthFine = roomWidth * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const roomHeightFine = roomHeight * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const x = roomWidthFine * roomX + fineCoordinate.x;
    const y = roomHeightFine * roomY + fineCoordinate.y;
    globalCoordinate.x = x;
    globalCoordinate.y = y;
};
const $a80d0b17b615d6f7$export$ead25a0ad81e18f0 = (coordinate)=>{
    return !coordinate || coordinate.x < 0 && coordinate.y < 0;
};
const $a80d0b17b615d6f7$export$b03ec757ccd6a9ce = ()=>{
    return {
        x: -1,
        y: -1
    };
};
const $a80d0b17b615d6f7$export$246e0d97ef73b196 = (coordinate)=>{
    if (!coordinate) return;
    coordinate.x = -1;
    coordinate.y = -1;
};
const $a80d0b17b615d6f7$export$dc04a47621b9cd74 = (c1, c2)=>c1.x !== c2.x || c1.y !== c2.y;
const $a80d0b17b615d6f7$export$74d4b819b66b5c70 = (fineCoordinate, roughCoordinate)=>{
    if (!fineCoordinate || !roughCoordinate) return;
    roughCoordinate.x = $a80d0b17b615d6f7$export$b240a5f8651dffb4(fineCoordinate.x);
    roughCoordinate.y = $a80d0b17b615d6f7$export$b240a5f8651dffb4(fineCoordinate.y);
};
const $a80d0b17b615d6f7$export$5afd74d1b598607d = (source, target)=>{
    if (!source || !target) return;
    target.x = source.x;
    target.y = source.y;
};
const $a80d0b17b615d6f7$export$989f786e03c2b51d = (meta, fineBounds, tileSize = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))=>{
    // console.trace()
    const f = (y)=>{
        return Math.floor(y * tileSize) + tileSize / 2;
    };
    const maxX = f(meta.width());
    const maxY = f(meta.height());
    const xStart = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.x1, 0, maxX) / tileSize);
    const yStart = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.y1, 0, maxY) / tileSize);
    const xEnd = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.x2, 0, maxX) / tileSize);
    const yEnd = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.y2, 0, maxY) / tileSize);
    return new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(xStart, yStart, xEnd, yEnd);
};
const $a80d0b17b615d6f7$export$7b8c2026ce8c6d5e = (dimensions, fineBounds, tileSize = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))=>{
    // console.trace()
    const f = (y)=>{
        return Math.floor(y * tileSize) + tileSize / 2;
    };
    const xStart = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.x1, 0, f(dimensions.w)) / tileSize);
    const yStart = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.y1, 0, f(dimensions.h)) / tileSize);
    const xEnd = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.x2, 0, f(dimensions.w)) / tileSize);
    const yEnd = Math.floor($a80d0b17b615d6f7$export$7d15b64cf5a3a4c4(fineBounds.y2, 0, f(dimensions.h)) / tileSize);
    return new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(xStart, yStart, xEnd, yEnd);
};
const $a80d0b17b615d6f7$export$a7f7c08af4b939e9 = (coordinate, amount = 16)=>{
    return {
        ...coordinate,
        x: coordinate.x + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-amount, amount),
        y: coordinate.y + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-amount, amount)
    };
};
const $a80d0b17b615d6f7$export$3ac84d03bc812507 = (coordinate, amount = 16)=>{
    coordinate.x = coordinate.x + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-amount, amount);
    coordinate.y = coordinate.y + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-amount, amount);
};
const $a80d0b17b615d6f7$export$983829bfbdacf03f = (coordinate, perturbed, amount = 16)=>{
    perturbed.x = coordinate.x + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-amount, amount);
    perturbed.y = coordinate.y + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-amount, amount);
};
const $a80d0b17b615d6f7$export$59e9cfed91f93f03 = (coordinate)=>{
    return {
        x: Math.round(coordinate.x),
        y: Math.round(coordinate.y)
    };
};
const $a80d0b17b615d6f7$export$7d94067f6d99210b = (coordinate)=>{
    return {
        x: Math.floor(coordinate.x),
        y: Math.floor(coordinate.y)
    };
};
const $a80d0b17b615d6f7$export$afdc8e4f563fbba3 = (roughCoordinate)=>{
    return {
        x: roughCoordinate.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.5,
        y: roughCoordinate.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.5
    };
};
const $a80d0b17b615d6f7$export$c5c39d6b5122006f = (roughCoordinate, target)=>{
    target.x = $a80d0b17b615d6f7$export$87a4e8763dcd88c7(roughCoordinate.x) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.5;
    target.y = $a80d0b17b615d6f7$export$87a4e8763dcd88c7(roughCoordinate.y) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.5;
};
const $a80d0b17b615d6f7$export$ec6726e81e6754f2 = (roughCoordinate)=>{
    const fine = $a80d0b17b615d6f7$export$b03ec757ccd6a9ce();
    $a80d0b17b615d6f7$export$131bd9752b097096(roughCoordinate, fine);
    return fine;
};
const $a80d0b17b615d6f7$export$87a4e8763dcd88c7 = (i)=>i * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
const $a80d0b17b615d6f7$export$131bd9752b097096 = (roughCoordinate, target)=>{
    target.x = roughCoordinate.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    target.y = roughCoordinate.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
};
const $a80d0b17b615d6f7$export$2cb771f4116b60f3 = (location, radius)=>{
    return {
        x: Math.floor(location.x + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? 1 : -1) * (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, radius)),
        y: Math.floor(location.y + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? 1 : -1) * (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, radius))
    };
};
const $a80d0b17b615d6f7$export$eccbbeaacc82d907 = (bounds, dimension, budget, useRng)=>{
    const start = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
    while((0, $4171652afd996934$export$a86190deb5c4a8d0)() - start < budget){
        const coordinate = $a80d0b17b615d6f7$export$b1a407392a6eb119(bounds, useRng);
        const candidate = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(coordinate.x, coordinate.y, coordinate.x + dimension.w, coordinate.y + dimension.h);
        if (bounds.encloses(candidate)) return candidate;
    }
    return null;
};
const $a80d0b17b615d6f7$export$64fb0fba146182ff = (num)=>{
    return Math.ceil(num / 100) * 100;
};
const $a80d0b17b615d6f7$export$454f7a24b1943800 = (a, b)=>{
    const x = a.x - b.x;
    const y = a.y - b.y;
    return `${x === 0 ? "0" : x < 0 ? "-" : "+"}|${y === 0 ? "0" : y < 0 ? "-" : "+"}`;
};
const $a80d0b17b615d6f7$export$a18495c0c5dcb80c = (location, radius)=>{
    const angle = Math.random() * Math.PI * 2;
    const x = Math.floor(Math.cos(angle) * radius);
    const y = Math.floor(Math.sin(angle) * radius);
    return {
        x: x + location.x,
        y: y + location.y
    };
};
const $a80d0b17b615d6f7$export$44b8c8315ca17d53 = (location, radius, numberOfPoints)=>{
    const centerX = location.x;
    const centerY = location.y;
    const theta = 2.0 * Math.PI / numberOfPoints;
    const points = [];
    for(let i = 1; i <= numberOfPoints; i++){
        const pointX = radius * Math.cos(theta * i) + centerX;
        const pointY = radius * Math.sin(theta * i) + centerY;
        points.push({
            x: pointX,
            y: pointY
        });
    }
    return points;
};
const $a80d0b17b615d6f7$export$dfd5a2436df79788 = (location, dimensions, numberOfPoints)=>{
    const totalArea = dimensions.w * dimensions.h;
    const pointArea = totalArea / numberOfPoints;
    const length = Math.sqrt(pointArea);
    const points = [];
    for(let i = length / 2; i < dimensions.w; i += length)for(let j = length / 2; j < dimensions.h; j += length){
        const x = location.x - dimensions.w / 2 + i;
        const y = location.y - dimensions.h / 2 + j;
        points.push({
            x: x,
            y: y
        });
    }
    return points;
};
const $a80d0b17b615d6f7$export$fa7d4ea13578a55a = (location, dimensions, numberOfPoints)=>{
    const centerX = location.x;
    const centerY = location.y;
    const points = [];
    const perSide = Math.ceil(numberOfPoints / 4);
    // top / bottom
    for(let x = centerX - dimensions.w / 2; x < centerX + dimensions.w / 2; x += dimensions.w / perSide){
        points.push({
            x: x,
            y: centerY - dimensions.h / 2
        });
        points.push({
            x: x,
            y: centerY + dimensions.h / 2
        });
    }
    // left / right
    for(let y = centerY - dimensions.h / 2; y < centerY + dimensions.h / 2; y += dimensions.h / perSide){
        points.push({
            x: centerX - dimensions.w / 2,
            y: y
        });
        points.push({
            x: centerX + dimensions.w / 2,
            y: y
        });
    }
    return points;
};
const $a80d0b17b615d6f7$export$7072e7f224c70dc0 = (roomId, worldMetaDimensions)=>{
    const [_, roomX, roomY] = roomId.split("-");
    const x = Number(roomX);
    const y = Number(roomY);
    return {
        x: Math.floor(x / worldMetaDimensions.quadrantWidth),
        y: Math.floor(y / worldMetaDimensions.quadrantHeight)
    };
};
const $a80d0b17b615d6f7$export$b3cc75d7f0e8e565 = (coordinate)=>`${coordinate.x}-${coordinate.y}`;
const $a80d0b17b615d6f7$export$4418bd227bd6a76a = (roomId, worldDimensions)=>{
    if (!roomId.startsWith("room")) return roomId;
    return $a80d0b17b615d6f7$export$b3cc75d7f0e8e565($a80d0b17b615d6f7$export$7072e7f224c70dc0(roomId, worldDimensions));
};
const $a80d0b17b615d6f7$export$be3fee91976fb47a = (str)=>{
    if (!str || !str.includes("-")) return {
        x: 0,
        y: 0
    };
    const parts = str.split("-").map((n)=>Number(n));
    return {
        x: parts[0],
        y: parts[1]
    };
};
const $a80d0b17b615d6f7$export$5b9a5a61c784012a = (location, d)=>{
    if ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)()) return {
        x: location.x + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-d.w / 2, d.w / 2),
        y: location.y + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? d.h / 2 : -d.h / 2)
    };
    else return {
        x: location.x + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? d.w / 2 : -d.w / 2),
        y: location.y + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-d.h / 2, d.h / 2)
    };
};
const $a80d0b17b615d6f7$export$dd04b5c066c4f0ff = (region)=>{
    const x = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, region.bounds.width);
    const y = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, region.bounds.height);
    return {
        x: x + region.x,
        y: y + region.y
    };
};
const $a80d0b17b615d6f7$export$b1a407392a6eb119 = (bounds, useRng)=>{
    const fnToUs = useRng ? $a80d0b17b615d6f7$export$c45e8adbbf82647d : (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18);
    const x = fnToUs(0, bounds.width);
    const y = fnToUs(0, bounds.height);
    return {
        x: x + bounds.x1,
        y: y + bounds.y1
    };
};
const $a80d0b17b615d6f7$export$333251a5a08cdd5d = (radius, callback)=>{
    for(let i = 1; i <= radius; i++){
        const r2 = i * i;
        for(let dx = -radius; dx <= radius; dx++){
            const h = Math.sqrt(r2 - dx * dx) | 0;
            for(let dy = -h; dy <= h; dy++)callback(dx, dy);
        }
    }
};
const $a80d0b17b615d6f7$export$8971db114e4d5869 = (width, height, callback)=>{
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++)callback(x, y);
};
const $a80d0b17b615d6f7$export$9387b5218de27719 = (n)=>{
    return isNaN(n) ? 0 : n;
};
const $a80d0b17b615d6f7$export$248d38f6296296c5 = (p1, p2, rounded = false)=>{
    if (p1 && !p2) return false;
    if (!p1 && p2) return false;
    if (!p1 && !p2) return true;
    if (!rounded) return p1.x === p2.x && p1.y === p2.y;
    return Math.floor(p1.x) === Math.floor(p2.x) && Math.floor(p1.y) === Math.floor(p2.y);
};
const $a80d0b17b615d6f7$export$d7b8fa4fd9c116de = $a80d0b17b615d6f7$export$248d38f6296296c5;
const $a80d0b17b615d6f7$export$86507ea8237b37e = ()=>{
    return (0, $cb689cfa16c444ba$export$86ae6e8ac17a67c6)[(0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, (0, $cb689cfa16c444ba$export$86ae6e8ac17a67c6).length - 1)];
};
const $a80d0b17b615d6f7$export$816c81660958f502 = (coordinate, direction, increment)=>{
    switch(direction){
        case "Up":
            coordinate.y -= increment;
            break;
        case "Down":
            coordinate.y += increment;
            break;
        case "Left":
            coordinate.x -= increment;
            break;
        case "Right":
            coordinate.x += increment;
            break;
        case "UpLeft":
            coordinate.x -= increment;
            coordinate.y -= increment;
            break;
        case "DownLeft":
            coordinate.x -= increment;
            coordinate.y += increment;
            break;
        case "UpRight":
            coordinate.x += increment;
            coordinate.y -= increment;
            break;
        case "DownRight":
            coordinate.x += increment;
            coordinate.y += increment;
            break;
    }
};
const $a80d0b17b615d6f7$export$81000cfff8ea05de = (a, b)=>{
    if (!a || !b) return null;
    return $a80d0b17b615d6f7$export$36659eeff558d70a(a.x, a.y, b.x, b.y);
};
const $a80d0b17b615d6f7$export$36659eeff558d70a = (aX, aY, bX, bY)=>{
    if (aX === bX && aY === bY) return null;
    if (aX === bX) {
        if (aY < bY) return "Down";
        else return "Up";
    }
    if (aY === bY) {
        if (aX > bX) return "Left";
        else return "Right";
    }
    if (aX > bX && aY < bY) return "DownLeft";
    if (aX > bX && aY > bY) return "UpLeft";
    if (aX < bX && aY < bY) return "DownRight";
    if (aX < bX && aY > bY) return "UpRight";
    return null;
};
const $a80d0b17b615d6f7$export$26a7d0ff90c06062 = (coordinate)=>{
    if (!coordinate) return;
    return {
        x: Math.floor(coordinate.x),
        y: Math.floor(coordinate.y)
    };
};
const $a80d0b17b615d6f7$export$42481bb7a9507ce8 = (coordinate, target)=>{
    if (!coordinate || !target) return;
    target.x = Math.floor(coordinate.x);
    target.y = Math.floor(coordinate.y);
};
const $a80d0b17b615d6f7$export$1fea460ac49b9e42 = (oldLocation, newLocation, dir, dist, fine = false)=>{
    const multiplier = !fine ? (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) : 1;
    $a80d0b17b615d6f7$export$5afd74d1b598607d(oldLocation, newLocation);
    switch(dir){
        case "Up":
            newLocation.y = Math.floor(oldLocation.y + multiplier * -dist);
            return;
        case "Down":
            newLocation.y = Math.floor(oldLocation.y + multiplier * dist);
            return;
        case "Left":
            newLocation.x = Math.floor(oldLocation.x + multiplier * -dist);
            return;
        case "Right":
            newLocation.x = Math.floor(oldLocation.x + multiplier * dist);
            return;
        case "UpLeft":
            newLocation.x = Math.floor(oldLocation.x + multiplier * -dist);
            newLocation.y = Math.floor(oldLocation.y + multiplier * -dist);
            return;
        case "UpRight":
            newLocation.x = Math.floor(oldLocation.x + multiplier * dist);
            newLocation.y = Math.floor(oldLocation.y + multiplier * -dist);
            return;
        case "DownLeft":
            newLocation.x = Math.floor(oldLocation.x + multiplier * -dist);
            newLocation.y = Math.floor(oldLocation.y + multiplier * dist);
            return;
        case "DownRight":
            newLocation.x = Math.floor(oldLocation.x + multiplier * dist);
            newLocation.y = Math.floor(oldLocation.y + multiplier * dist);
            return;
    }
};
class $a80d0b17b615d6f7$export$6cbae62f94a3133d {
    constructor({ durationWindow: durationWindow = 10000, label: label, average: average }){
        this.readings = 0;
        this.latest = 0;
        this.count = 0;
        /** `now` is an optional already-taken clock reading -- see Latch.expired. */ this.offer = (value, now)=>{
            this.readings += value;
            this.count++;
            if (this.latch.expired(true, now)) {
                const averageOverDuration = this.average ? Math.round(this.readings / this.count) : Math.round(this.readings / (this.durationWindow / 1000));
                // clear readings
                this.readings = 0;
                this.count = 0;
                this.latest = averageOverDuration;
                return averageOverDuration;
            }
            return null;
        };
        this.emitMessage = ()=>{
            console.log(this.average ? `${this.label} average: ${this.latest} / ${this.durationWindow / 1000} sec window` : `${this.label} thruput: ${this.latest} /sec`);
        };
        this.durationWindow = durationWindow;
        this.latch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(durationWindow, (0, $4171652afd996934$export$a86190deb5c4a8d0)());
        this.label = label;
        this.average = average;
    }
}
class $a80d0b17b615d6f7$export$336b4c97e7741c1a {
    constructor(v){
        this.set = (v)=>this.v = v;
        this.get = ()=>this.v;
        this.v = v;
    }
}
const $a80d0b17b615d6f7$export$81c40ebfe660d3ca = (array, terminates, index)=>{
    index = index || new $a80d0b17b615d6f7$export$336b4c97e7741c1a(-1);
    return {
        next: ()=>{
            if (array.length < 1) return {
                value: undefined,
                done: true
            };
            index.set(index.get() + 1);
            if (!terminates) {
                if (index.get() > array.length - 1) index.set(0);
                return {
                    value: array[index.get()],
                    done: false
                };
            } else {
                if (index.get() > array.length - 1) return {
                    value: undefined,
                    done: true
                };
                return {
                    value: array[index.get()],
                    done: false
                };
            }
        }
    };
};
class $a80d0b17b615d6f7$export$37a78dc06a7d1e2e {
    constructor(values, terminates = true){
        this.reset = ()=>{
            this.index.set(-1);
        };
        this.add = (item)=>{
            this.values.push(item);
            this.iterator = $a80d0b17b615d6f7$export$81c40ebfe660d3ca(this.values, this.terminates, this.index);
            this.reset();
        };
        this.remove = (item)=>{
            this.values = this.values.filter((next)=>next !== item);
            this.iterator = $a80d0b17b615d6f7$export$81c40ebfe660d3ca(this.values, this.terminates, this.index);
            this.reset();
        };
        this.next = ()=>{
            return this.iterator.next();
        };
        this.index = new $a80d0b17b615d6f7$export$336b4c97e7741c1a(-1);
        this.terminates = terminates;
        this.values = values;
        this.iterator = $a80d0b17b615d6f7$export$81c40ebfe660d3ca(values, terminates, this.index);
    }
}
const $a80d0b17b615d6f7$export$81e29c5651a28578 = (val)=>{
    if (val === "true") return true;
    if (val === "false") return false;
    if (val === "") return val;
    const nan = isNaN(Number(val));
    if (!nan) return parseInt(val);
    // its a string
    return val;
};
const $a80d0b17b615d6f7$export$e37b4dbfadf1f2de = (list, options)=>{
    if (!list || list.length < 0) return;
    const min = 0 + (options?.leftBoundIdx || 0);
    const max = list.length - 1 - (options?.rightBoundIdx || 0);
    if (options?.rngFn) {
        const pos = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(min, max, {
            rngFn: options.rngFn
        });
        return list[pos];
    }
    const rndFunctionToUse = options?.randomIntBetween ? options.randomIntBetween : (min, max)=>(0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(min, max, options);
    const pos = rndFunctionToUse(min, max);
    return list[pos];
};
function $a80d0b17b615d6f7$export$7ac3a88d34a76e7(array) {
    for(let i = array.length - 1; i > 0; i--){
        // Pick a random index from 0 to i
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [
            array[j],
            array[i]
        ];
    }
    return array;
}
function $a80d0b17b615d6f7$export$d2520d12c9d147e4(inputArray, process, timeLimitMs, limit) {
    const startTime = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
    const collectorArray = [];
    // Function to check if the time limit has been reached
    const timeLimitReached = ()=>(0, $4171652afd996934$export$a86190deb5c4a8d0)() - startTime >= timeLimitMs;
    while(inputArray.length > 0 && !timeLimitReached() && collectorArray.length < limit){
        // Pick a random index from the input array
        const randomIndex = Math.floor(Math.random() * inputArray.length);
        // Extract the element at the random index
        const [element] = inputArray.splice(randomIndex, 1);
        // Execute the process function on the extracted element
        if (process(element)) // If process returns true and we haven't reached the limit, add the element to the collector array
        collectorArray.push(element);
    // The loop will continue until the input array is exhausted, the time limit is reached, or the collector array reaches the specified limit.
    }
    return collectorArray;
}
const $a80d0b17b615d6f7$export$b8b3234b4edfc4c2 = (src, str, newStr)=>{
    // If a regex pattern
    if (Object.prototype.toString.call(str).toLowerCase() === "[object regexp]") return src.replace(str, newStr);
    // If a string
    return src.replace(new RegExp(str, "g"), newStr);
};
const $a80d0b17b615d6f7$export$dde5f197d352347c = (flt)=>flt * 100;
const $a80d0b17b615d6f7$export$4fece460db87ee7b = (width, height, blankValue)=>{
    const matrix = [];
    for(let x = 0; x < width; x++){
        const column = [];
        matrix.push(column);
        for(let y = 0; y < height; y++)column.push(blankValue);
    }
    return matrix;
};
const $a80d0b17b615d6f7$export$edde49207b897324 = (str = "", lineLength)=>{
    const arr = [
        ""
    ];
    str.split(" ").forEach((word)=>{
        if (arr[arr.length - 1].length + word.length > lineLength) arr.push("");
        arr[arr.length - 1] += word + " ";
    });
    return arr.map((v)=>v.trim());
};
const $a80d0b17b615d6f7$export$76d90c956114f2c2 = (fn, times)=>{
    const returned = [];
    for(let i = 0; i < times; i++){
        const val = fn();
        if (val) returned.push(val);
    }
    return returned;
};
const $a80d0b17b615d6f7$export$cefb40c9962541b5 = (str, amt)=>amt > 1 ? `${str}s` : `${str}`;
const $a80d0b17b615d6f7$export$9a00dee1beb8f576 = (str)=>str.charAt(0).toUpperCase() + str.substring(1);
const $a80d0b17b615d6f7$export$32ed0561867ec8a1 = (src, other)=>{
    other.forEach((o)=>src.push(o));
};
const $a80d0b17b615d6f7$export$f416efe173c6901c = (src = [])=>{
    const set = new Set();
    src.forEach((t)=>set.add(t));
    return set;
};
const $a80d0b17b615d6f7$export$ab4dce56041c583d = (str)=>str ? JSON.parse(str) : undefined;
const $a80d0b17b615d6f7$export$5e699d18035b41af = (0, $87befc68df50040c$export$2e2bcd8739ae039);
const $a80d0b17b615d6f7$export$c0cc6ee9538309d2 = (arr)=>arr?.length > 0 ? arr[0] : null;
const $a80d0b17b615d6f7$export$9a81a17686f0f9cf = (0, $f93bb81604774744$export$5d832d6580b26c5);
const $a80d0b17b615d6f7$export$bf81c9a7c069ded7 = (str)=>{
    return str.replace(/\s+/gi, "-").replace(/[^a-z0-9]/gi, "");
};
const $a80d0b17b615d6f7$export$9cb4719e2e525b7a = (a, b)=>{
    if (a === b) return true;
    if (typeof a !== "object" || a === null || typeof b !== "object" || b === null) return false;
    const keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!keysB.includes(key) || !$a80d0b17b615d6f7$export$9cb4719e2e525b7a(a[key], b[key])) return false;
    }
    return true;
};
const $a80d0b17b615d6f7$export$a132fd33caa05413 = (obj, processFn)=>{
    return JSON.parse(processFn(JSON.stringify(obj)));
};
const $a80d0b17b615d6f7$export$f2101ed45d400a36 = (location)=>{
    return `${location.roomId}/${location.x}/${location.y}`;
};
const $a80d0b17b615d6f7$export$4a09470303eb5fc5 = (start, end, distance)=>{
    // Calculate the direction vector (dx, dy)
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    // Calculate the length of the vector
    const length = Math.sqrt(dx * dx + dy * dy);
    // Normalize the vector to get the unit vector
    const ux = dx / length;
    const uy = dy / length;
    // Scale the unit vector by the desired distance
    const vx = ux * distance;
    const vy = uy * distance;
    // Calculate the target coordinate
    const targetX = start.x + vx;
    const targetY = start.y + vy;
    return {
        x: Math.floor(targetX),
        y: Math.floor(targetY)
    };
};
const $a80d0b17b615d6f7$export$7758e9150891e0a1 = (start, angleRadians, distance)=>{
    // Calculate the change in x and y using the angle in radians
    const dx = Math.cos(angleRadians) * distance;
    const dy = Math.sin(angleRadians) * distance;
    // Calculate the new coordinate
    const newX = start.x + dx;
    const newY = start.y + dy;
    return {
        x: Math.floor(newX),
        y: Math.floor(newY)
    };
};
const $a80d0b17b615d6f7$export$dde4c7d71e75ad22 = (locationStr)=>{
    if (locationStr) {
        const [roomId, xStr, yStr] = locationStr.split("/");
        return {
            roomId: roomId,
            x: Number(xStr),
            y: Number(yStr)
        };
    }
};
const $a80d0b17b615d6f7$export$ef8d2ed002d536c3 = (x)=>{
    if (Array.isArray(x)) return x;
    return [
        x
    ];
};
function $a80d0b17b615d6f7$var$isNumber(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
}
const $a80d0b17b615d6f7$export$b001a87b1518a69d = (str)=>{
    if (typeof str === "object") return str;
    if (!str) return;
    if ($a80d0b17b615d6f7$var$isNumber(str)) return undefined;
    try {
        return JSON.parse(str);
    } catch (e) {}
};
const $a80d0b17b615d6f7$export$ded26c9c1231eee6 = (center, points, directionMap)=>{
    const results = [];
    for (const point of points){
        // Calculate angle from center to point
        const angleRadians = Math.atan2(point.y - center.y, point.x - center.x);
        const angleDegrees = $a80d0b17b615d6f7$export$32b1497b7aadef08(angleRadians);
        // Normalize angle to 0-360 range
        const normalizedAngle = angleDegrees < 0 ? angleDegrees + 360 : angleDegrees;
        // Find the closest direction
        let closestDirection = "";
        let smallestDifference = 360;
        for (const [direction, info] of Object.entries(directionMap)){
            const difference = Math.abs(normalizedAngle - info.angle);
            const wrappedDifference = Math.min(difference, 360 - difference);
            if (wrappedDifference < smallestDifference) {
                smallestDifference = wrappedDifference;
                closestDirection = direction;
            }
        }
        results.push({
            point: point,
            direction: closestDirection,
            directionInfo: directionMap[closestDirection]
        });
    }
    return results;
};


const $968cce787b06be95$export$9f6bb360d30ad5dc = 450;
const $968cce787b06be95$export$b0d3251cc72aa09d = 80;
const $968cce787b06be95$export$64292ccd7650dcfd = 76;
const $968cce787b06be95$export$a29aefde2f9c4e18 = 32;
const $968cce787b06be95$export$b4ad6eb9af7522f2 = $968cce787b06be95$export$a29aefde2f9c4e18 / $968cce787b06be95$export$b0d3251cc72aa09d * 1000;
const $968cce787b06be95$export$2bec297270f19bd9 = (view)=>{
    const elapsed = view.climb?.elapsedMs ?? view.durationMs - view.remainingMs;
    const progress = Math.max(0, Math.min(1, (elapsed - (view.phase === "depart" ? view.walkMs : 0)) / Math.max(1, view.transitionMs)));
    return view.flight.from + (view.flight.to - view.flight.from) * progress;
};
const $968cce787b06be95$export$4f94aa92bb9eb34c = (view, roomId)=>{
    const flight = view?.flight;
    if (!flight?.surface || flight.continuous || ![
        flight.lowerRoomId,
        flight.upperRoomId
    ].includes(roomId)) return undefined;
    return {
        ...view,
        roomId: roomId,
        projection: true
    };
};
const $968cce787b06be95$export$d9d9364aee075d84 = (view, elapsedMs)=>{
    const elapsed = Math.max(0, Math.min(view.durationMs, view.climb?.elapsedMs ?? elapsedMs));
    const departing = view.phase === "depart";
    const walkElapsed = departing ? elapsed : elapsed - view.transitionMs;
    const walking = (!view.climb || view.climb.moving) && view.walkMs > 0 && (departing ? elapsed < view.walkMs : elapsed >= view.transitionMs && elapsed < view.durationMs);
    const walkProgress = view.walkMs ? Math.max(0, Math.min(1, walkElapsed / view.walkMs)) : 1;
    const transition = Math.max(0, Math.min(1, (departing ? elapsed - view.walkMs : elapsed) / view.transitionMs));
    const smooth = view.climb ? transition : transition * transition * (3 - 2 * transition);
    const depth = departing ? smooth : 1 - smooth;
    const below = departing ? view.direction === "down" : view.direction === "up";
    const transitioning = departing ? elapsed >= view.walkMs : elapsed < view.transitionMs;
    const ramp = view.ramp;
    const upTile = departing ? view.direction === "up" : view.direction === "down";
    if (view.flight) {
        const flight = view.flight;
        const height = $968cce787b06be95$export$2bec297270f19bd9({
            ...view,
            remainingMs: view.durationMs - elapsed
        });
        const upper = view.roomId === flight.upperRoomId;
        const atEnd = !view.projection && !departing && elapsed >= view.durationMs;
        // Crossing the upstairs lip already means gripping the ladder, even
        // while the player is still aligning with the shaft before descending.
        const climbing = transitioning || departing && upper && view.direction === "down";
        const location = atEnd ? view.end : transitioning ? flight.base : {
            x: view.start.x + (view.end.x - view.start.x) * walkProgress,
            y: view.start.y + (view.end.y - view.start.y) * walkProgress
        };
        const bodyOffset = atEnd || !transitioning ? 0 : (upper ? flight.rise : 0) - height;
        // Include the entry alignment in the animation's travel distance so the
        // arms move with up/down input there too, then join the vertical cycle.
        const entryDistance = departing && !transitioning && climbing ? Math.hypot(view.end.x - view.start.x, view.end.y - view.start.y) * (1 - walkProgress) : 0;
        // Map the upper hatch rim to the top of the lower ladder. Building floor
        // spacing is compressed for perspective and does not measure ladder height.
        const edge = (0, $afc439431837457b$export$736d42feedf23b37)({
            x: Math.floor(flight.base.x / 32),
            y: Math.floor(flight.base.y / 32)
        }).south - (upper ? 0 : flight.rise);
        return {
            location: location,
            bodyOffset: bodyOffset,
            walking: walking || transitioning && elapsed < view.durationMs && (!view.climb || view.climb.moving),
            transitioning: transitioning,
            ladderRise: climbing && !atEnd ? height + entryDistance : undefined,
            below: upper,
            entranceOffset: 0,
            headClip: undefined,
            split: climbing && !atEnd && flight.surface && !flight.continuous ? {
                edge: edge,
                above: upper
            } : undefined,
            direction: view.climb?.direction ?? (view.direction === "up" ? "Up" : "Down"),
            angle: (view.climb?.direction ?? (view.direction === "up" ? "Up" : "Down")) === "Up" ? -Math.PI / 2 : Math.PI / 2
        };
    }
    // Upright stairs keep floor coordinates at the base while the body climbs.
    // Keep the climbing body visible in either direction through the room handoff.
    if (ramp && upTile) {
        const transitionElapsed = Math.max(0, Math.min(view.transitionMs, departing ? elapsed - view.walkMs : elapsed));
        const progress = Math.min(1, transitionElapsed / Math.max(1, view.transitionMs));
        const climb = departing ? progress : 1 - progress;
        const start = departing ? view.start : ramp.entry;
        const end = departing ? ramp.entry : view.end;
        const climbing = transitioning && elapsed < view.durationMs;
        return {
            location: transitioning ? {
                ...ramp.entry
            } : {
                x: start.x + (end.x - start.x) * walkProgress,
                y: start.y + (end.y - start.y) * walkProgress
            },
            walking: walking || climbing && (!view.climb || view.climb.moving),
            transitioning: transitioning,
            bodyOffset: -$968cce787b06be95$export$a29aefde2f9c4e18 * climb,
            // How far up the ladder the body is while on it: a body that draws a climb times it by this.
            ladderRise: transitioning ? $968cce787b06be95$export$a29aefde2f9c4e18 * climb : undefined,
            below: below,
            entranceOffset: 0,
            headClip: undefined,
            direction: view.climb?.direction ?? (transitioning ? departing ? "Up" : "Down" : view.exitDirection),
            angle: transitioning ? view.climb?.direction === "Up" || !view.climb?.direction && departing ? -Math.PI / 2 : Math.PI / 2 : view.exitAngle
        };
    }
    // A floor opening uses the same fixed-ground rise on arrival and sink on
    // departure. Finish walking to its center before moving the body vertically.
    if (ramp && !upTile) {
        const center = departing ? view.end : view.start;
        const start = departing ? view.start : center;
        const end = departing ? center : view.end;
        const entranceOffset = view.climb ? 0 : 12 * (transitioning ? 1 : departing ? walkProgress : 1 - walkProgress);
        return {
            location: transitioning ? {
                ...center
            } : {
                x: start.x + (end.x - start.x) * walkProgress,
                y: start.y + (end.y - start.y) * walkProgress
            },
            walking: walking,
            transitioning: transitioning,
            bodyOffset: 64 * depth - entranceOffset,
            below: true,
            entranceOffset: entranceOffset,
            // Keep hands and feet on the rungs while passing through the floor opening too.
            ladderRise: transitioning ? -64 * depth : undefined,
            headClip: undefined,
            direction: view.climb?.direction ?? view.exitDirection,
            angle: view.climb?.direction ? view.climb.direction === "Up" ? -Math.PI / 2 : Math.PI / 2 : view.exitAngle
        };
    }
    const approachEnd = ramp ? upTile ? ramp.entry : ramp.top : view.end;
    const exitStart = ramp ? upTile ? ramp.entry : ramp.top : view.start;
    const start = !departing ? exitStart : view.start;
    const end = departing ? approachEnd : view.end;
    const departureHeight = view.direction === "down" ? 8 : 16;
    const entranceOffset = departing && (ramp || view.direction === "down") ? departureHeight * walkProgress : ramp ? 16 * (transitioning ? 1 : 1 - walkProgress) : 0;
    const from = ramp ? departing === upTile ? ramp.entry : ramp.top : view.start;
    const to = ramp ? departing === upTile ? ramp.top : ramp.entry : view.end;
    const location = ramp && transitioning ? {
        x: from.x + (to.x - from.x) * transition,
        y: from.y + (to.y - from.y) * transition
    } : {
        x: start.x + (end.x - start.x) * walkProgress,
        y: start.y + (end.y - start.y) * walkProgress
    };
    return {
        location: location,
        walking: walking || !!ramp && transitioning && elapsed < view.durationMs,
        transitioning: // Downstairs departure starts 8px south of the usual 16px raised entrance.
        transitioning,
        bodyOffset: (ramp && upTile ? -24 * depth : (below ? 1 : -1) * 64 * depth) - entranceOffset,
        below: below,
        entranceOffset: entranceOffset,
        headClip: ramp && upTile && transitioning ? depth : undefined,
        direction: ramp && transitioning ? (0, $a80d0b17b615d6f7$export$36659eeff558d70a)(from.x, from.y, to.x, to.y) ?? view.exitDirection : view.exitDirection,
        angle: ramp && transitioning ? Math.atan2(to.y - from.y, to.x - from.x) : view.exitAngle
    };
};
const $968cce787b06be95$export$6816d1b3672c3e0b = (entity)=>{
    if (entity.stairTravel || entity.stairTravelArrival || entity.stairTravelDestination) entity.lastUpdateTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
    entity.stairTravel = undefined;
    entity.stairTravelUntilTs = undefined;
    entity.stairTravelDestination = undefined;
    entity.stairTravelArrival = undefined;
};
const $968cce787b06be95$export$f9a531daa6365cbf = (entity)=>{
    const view = entity.stairTravel;
    if (!view) return;
    const pose = $968cce787b06be95$export$d9d9364aee075d84(view, 0);
    const upright = view.phase === "depart" === (view.direction === "up");
    const roomId = view.flight?.lowerRoomId ?? (!upright && view.lowerLanding ? view.lowerLanding.roomId : entity.roomId);
    const height = view.flight ? $968cce787b06be95$export$2bec297270f19bd9(view) : Math.max(0, upright ? -pose.bodyOffset : 64 - pose.bodyOffset);
    if (height > 0) {
        const gravity = .0015;
        const durationMs = Math.sqrt(2 * height / gravity);
        entity.floorFall = {
            id: `${view.id}:jump`,
            roomId: roomId,
            stairJump: true,
            fromAbove: true,
            phase: "arriving",
            durationMs: durationMs,
            remainingMs: durationMs,
            distance: height,
            levelsFallen: 0,
            trajectory: {
                gravity: gravity,
                distanceBefore: 0,
                endElapsedMs: durationMs,
                totalDistance: height
            }
        };
        entity.floorFallUntilTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)() + durationMs;
        entity.floorFallRoomId = roomId;
    }
    $968cce787b06be95$export$6816d1b3672c3e0b(entity);
};
const $968cce787b06be95$export$96236591fbe9bc32 = (entity, input, seconds)=>{
    const view = entity.stairTravel;
    if (!view?.climb) return false;
    // Ignore room-refresh nudges; intentional sideways input leaves the ladder.
    if (Math.abs(input?.x ?? 0) > 1) {
        $968cce787b06be95$export$f9a531daa6365cbf(entity);
        return false;
    }
    const vertical = Math.sign(input?.y || 0);
    const forward = view.direction === "up" ? -vertical : vertical;
    const dt = Math.max(0, Math.min(.1, Number.isFinite(seconds) ? seconds : 0));
    const speed = Number.isFinite(input?.y) ? Math.abs(input.y) : 0;
    const previous = view.climb.elapsedMs;
    // Convert the timeline to travelled pixels so stairs use the same input speed as the floor.
    // Upright stairs span 32px; the passage through the opening spans 64px.
    const walkPx = view.walkMs > 0 ? Math.hypot(view.end.x - view.start.x, view.end.y - view.start.y) : 0;
    const climbPx = view.flight ? Math.abs(view.flight.to - view.flight.from) : view.phase === "depart" === (view.direction === "up") ? $968cce787b06be95$export$a29aefde2f9c4e18 : 64;
    const firstMs = view.phase === "depart" ? view.walkMs : view.transitionMs;
    const firstPx = view.phase === "depart" ? walkPx : climbPx;
    const lastMs = view.phase === "depart" ? view.transitionMs : view.walkMs;
    const lastPx = view.phase === "depart" ? climbPx : walkPx;
    const distance = previous < firstMs && firstMs > 0 ? previous / firstMs * firstPx : firstPx + (lastMs > 0 ? (previous - firstMs) / lastMs * lastPx : 0);
    const next = Math.max(0, Math.min(firstPx + lastPx, distance + forward * speed * dt));
    view.climb.elapsedMs = next <= 0 ? 0 : next >= firstPx + lastPx ? view.durationMs : next < firstPx && firstPx > 0 ? next / firstPx * firstMs : firstMs + (lastPx > 0 ? (next - firstPx) / lastPx * lastMs : 0);
    view.climb.moving = previous !== view.climb.elapsedMs;
    if (vertical) view.climb.direction = vertical < 0 ? "Up" : "Down";
    const pose = $968cce787b06be95$export$d9d9364aee075d84(view, 0);
    Object.assign(entity.location, pose.location);
    entity.movement.moving = pose.walking;
    entity.movement.direction = vertical < 0 ? "Up" : vertical > 0 ? "Down" : pose.direction;
    entity.movement.angle = vertical < 0 ? -Math.PI / 2 : Math.PI / 2;
    entity.speed2 = {
        x: 0,
        y: 0
    };
    if (forward < 0 && view.climb.elapsedMs === 0) {
        if (view.phase === "depart") $968cce787b06be95$export$6816d1b3672c3e0b(entity);
        else view.climb.reverse = true;
    }
    return true;
};



const $6bc06c112d672e46$export$28144b69b93eae80 = (data, baselines)=>{
    const visit = (value)=>{
        if (Array.isArray(value)) return value.map(visit);
        if (value && typeof value === "object") {
            if (value.baseline !== undefined) {
                const base = baselines[value.baseline];
                if (!base) throw new Error(`Unknown engine baseline ${value.baseline}`);
                const amount = value.pctOfMax === undefined ? base.minimum : base.fromPctOfMax?.(value.pctOfMax);
                if (amount === undefined) throw new Error(`Baseline ${value.baseline} does not support percentage scaling`);
                return amount * (value.multiplier ?? 1);
            }
            return Object.fromEntries(Object.entries(value).map(([key, v])=>[
                    key,
                    visit(v)
                ]));
        }
        return value;
    };
    return visit(data);
};




class $bc8613e262b54793$export$72650553bea9c295 {
    constructor(size = 1000){
        this.items = [];
        this.ptr = -1;
        this.grow = (size = 1000)=>{
            for(let i = 0; i < size; i++)this.items.push(this.create());
        };
        this.checkout = ()=>{
            if (this.releasing) alert("BAD!");
            this.ptr++;
            if (this.ptr > this.items.length - 1) // grow the array
            this.grow(1000);
            const item = this.items[this.ptr];
            item.free = false;
            return item;
        };
        this.releaseAll = (visitor)=>{
            let count = 0;
            this.releasing = true;
            const now = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
            // Release the whole stack down to AND INCLUDING index 0. The old bound `this.ptr > 0`
            // (together with release()'s `ptr < 0 -> 0` clamp) left items[0] permanently checked out:
            // it was never removed from its parent nor handed back out, leaving a stale "ghost" sprite
            // on the surface plus a one-slot leak per pool.
            while(this.ptr >= 0 && (0, $4171652afd996934$export$a86190deb5c4a8d0)() - now < 2000){
                const toRelease = this.items[this.ptr];
                if (toRelease.free) {
                    // Defensive: release() no-ops on an already-free item without moving ptr, which
                    // would spin forever here. Step past it manually.
                    this.ptr--;
                    continue;
                }
                if (visitor) visitor(toRelease);
                this.release(toRelease);
                count++;
            }
            this.ptr = -1;
            this.releasing = false;
            return count;
        };
        this.release = (item)=>{
            if (item.free) // already free, noop
            return;
            item.free = true;
            this.clear(item);
            this.ptr--;
            if (this.ptr < 0) this.ptr = 0;
        };
        this.grow(size);
    }
}



class $22a1b96ddeb2d28f$export$90f229f3a0c9abea extends (0, $bc8613e262b54793$export$72650553bea9c295) {
    static{
        this.instance = new $22a1b96ddeb2d28f$export$90f229f3a0c9abea();
    }
    constructor(size = 1000){
        super(size);
    }
    create() {
        return {
            free: true,
            data: {
                adjust: {
                    x: -1,
                    y: -1
                },
                collided: false,
                collision: {
                    x: -1,
                    y: -1
                },
                intersection: {
                    x: -1,
                    y: -1,
                    intersectionType: ""
                }
            }
        };
    }
    clear(item) {
        (0, $a80d0b17b615d6f7$export$246e0d97ef73b196)(item.data.adjust);
        item.data.collided = false, (0, $a80d0b17b615d6f7$export$246e0d97ef73b196)(item.data.collision);
        (0, $a80d0b17b615d6f7$export$246e0d97ef73b196)(item.data.intersection);
        item.data.intersection.intersectionType = "";
    }
}



class $044ce6b9ee544b01$export$ca8a4d4f8adbc954 extends (0, $bc8613e262b54793$export$72650553bea9c295) {
    static{
        this.instance = new $044ce6b9ee544b01$export$ca8a4d4f8adbc954();
    }
    constructor(size = 1000){
        super(size);
    }
    create() {
        return {
            free: true,
            data: {
                x: -1,
                y: -1
            }
        };
    }
    clear(item) {
        item.data.x = -1;
        item.data.y = -1;
    }
}




let $30de942853303b03$export$fe4d3316a144eea6 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.sprites.registration;
let $30de942853303b03$export$9add49f5ed926deb = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.sprites.dimensions;
let $30de942853303b03$export$38495bb8ad3f939b = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.sprites.weapons;
let $30de942853303b03$export$b99fafb3f89f054a = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.sprites.creatures;
let $30de942853303b03$export$cb418cdf24d0dd3e = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).spriteColors;
let $30de942853303b03$export$5bfd8bfbf03dc8d7 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.registry;
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        REGISTRATION: catalog.source.sprites.registration,
        SPRITE_DIMENSIONS: catalog.source.sprites.dimensions,
        AUTHORED_WEAPONS: catalog.source.sprites.weapons,
        AUTHORED_CREATURES: catalog.source.sprites.creatures,
        SPRITE_COLORS: catalog.spriteColors,
        SPRITE_REGISTRY: catalog.source.registry
    }), (next)=>{
    $30de942853303b03$export$fe4d3316a144eea6 = next.REGISTRATION;
    $30de942853303b03$export$9add49f5ed926deb = next.SPRITE_DIMENSIONS;
    $30de942853303b03$export$38495bb8ad3f939b = next.AUTHORED_WEAPONS;
    $30de942853303b03$export$b99fafb3f89f054a = next.AUTHORED_CREATURES;
    $30de942853303b03$export$cb418cdf24d0dd3e = next.SPRITE_COLORS;
    $30de942853303b03$export$5bfd8bfbf03dc8d7 = next.SPRITE_REGISTRY;
});


const $bf6244e5cc9aa116$var$authored = (value)=>JSON.parse(JSON.stringify(value));
let $bf6244e5cc9aa116$export$2a4812914c68f73e = (0, $30de942853303b03$export$fe4d3316a144eea6).HumanoidRaceTypes;
let $bf6244e5cc9aa116$export$46125ee88f7f0638 = (0, $30de942853303b03$export$fe4d3316a144eea6).RaceTypes;
const $bf6244e5cc9aa116$export$32cdec3d782e201f = [
    "male",
    "female"
];
let $bf6244e5cc9aa116$export$1625117e6bf800e7 = $bf6244e5cc9aa116$var$authored((0, $30de942853303b03$export$fe4d3316a144eea6).RaceSexes);
let $bf6244e5cc9aa116$export$4eb09b1c0a6dec24 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.vocabularies.colors;
/**
 * The colour tables below are DERIVED from the sprite registry, not written here.
 *
 * Which colours a component comes in is a fact about the art on disk, and keeping it by hand is
 * what made importing a new colour a code change in three places. Each table is the registry
 * entries' `colors` (content/game/sprites/registry.json), read back out of the compiled content
 * catalog's `spriteColors`; edit the registry (or use the sprite lab) and run `yarn compile:lpc`,
 * which checks the registry and then compiles content.
 *
 * Types and eligibility are authored in content/game/sprites/definitions.json and arrive through
 * the same catalog (`REGISTRATION`).
 */ /** Widen one slot's readonly literal tuples to the `Color[]` every caller already expects. */ const $bf6244e5cc9aa116$var$derive = (table)=>Object.keys(table).reduce((out, key)=>{
        out[key] = [
            ...table[key]
        ];
        return out;
    }, {});
let $bf6244e5cc9aa116$export$af1b56af8a451d06 = $bf6244e5cc9aa116$var$derive((0, $30de942853303b03$export$cb418cdf24d0dd3e).body);
let $bf6244e5cc9aa116$export$d45f4a0015a82408 = (0, $30de942853303b03$export$fe4d3316a144eea6).EyeTypes;
let $bf6244e5cc9aa116$export$ffaabf2abfa69206 = $bf6244e5cc9aa116$var$derive((0, $30de942853303b03$export$cb418cdf24d0dd3e).eyes);
let $bf6244e5cc9aa116$export$a64d361fad6262d3 = (0, $30de942853303b03$export$fe4d3316a144eea6).NoseTypes;
const $bf6244e5cc9aa116$var$commonNoseColor = [
    "white",
    "tan",
    "gray"
];
let $bf6244e5cc9aa116$export$f5fdec393d34621 = {
    ...$bf6244e5cc9aa116$var$derive((0, $30de942853303b03$export$cb418cdf24d0dd3e).nose),
    // "none" is a Nose, not a component: it means the slot is empty, and the
    // forge returns no sheets for it. The art has nothing to say about it.
    none: []
};
let $bf6244e5cc9aa116$export$523e552deae170d8 = $bf6244e5cc9aa116$var$authored((0, $30de942853303b03$export$fe4d3316a144eea6).RaceNoses);
let $bf6244e5cc9aa116$export$4f6565fe06691e22 = $bf6244e5cc9aa116$var$authored((0, $30de942853303b03$export$fe4d3316a144eea6).RaceEyes);
let $bf6244e5cc9aa116$export$45b2c5ee636d8393 = (0, $30de942853303b03$export$fe4d3316a144eea6).WeaponTypes;
const $bf6244e5cc9aa116$var$commonWeapons = [
    "spear",
    "bow",
    "staff",
    "axe",
    "warhammer",
    "none"
];
let $bf6244e5cc9aa116$export$448f4eb18cb556ce = $bf6244e5cc9aa116$var$authored((0, $30de942853303b03$export$fe4d3316a144eea6).WeaponAction);
let $bf6244e5cc9aa116$export$3f4c28cf92a4cf37 = $bf6244e5cc9aa116$var$authored((0, $30de942853303b03$export$fe4d3316a144eea6).WeaponAmmo);
let $bf6244e5cc9aa116$export$489aea052d2c5de8 = $bf6244e5cc9aa116$var$derive((0, $30de942853303b03$export$cb418cdf24d0dd3e).weapon);
let $bf6244e5cc9aa116$export$cd29cf568087531c = $bf6244e5cc9aa116$var$authored((0, $30de942853303b03$export$fe4d3316a144eea6).RaceWeapons);
let $bf6244e5cc9aa116$export$2eff43e195cfa29d = $bf6244e5cc9aa116$var$authored((0, $30de942853303b03$export$fe4d3316a144eea6).DefaultAttackActionType);
let $bf6244e5cc9aa116$export$abac18ec637a6d99 = (0, $30de942853303b03$export$fe4d3316a144eea6).HairTypes;
const $bf6244e5cc9aa116$var$commonHairColor = [
    "white",
    "blonde",
    "gold",
    "green",
    "blue",
    "red",
    "orange",
    "purple",
    "brown",
    "lightbrown",
    "gray",
    "black"
];
let $bf6244e5cc9aa116$export$c2ef2c5bddebe408 = $bf6244e5cc9aa116$var$derive((0, $30de942853303b03$export$cb418cdf24d0dd3e).hair);
let $bf6244e5cc9aa116$export$46ee3469290462e6 = $bf6244e5cc9aa116$var$authored((0, $30de942853303b03$export$fe4d3316a144eea6).SexHair);
let $bf6244e5cc9aa116$export$f984f9e37c2404ad = (0, $30de942853303b03$export$fe4d3316a144eea6).PantsTypes;
let $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3 = $bf6244e5cc9aa116$var$authored((0, $30de942853303b03$export$fe4d3316a144eea6).SexPants);
let $bf6244e5cc9aa116$export$7ef85edc405cda8b = $bf6244e5cc9aa116$var$derive((0, $30de942853303b03$export$cb418cdf24d0dd3e).pants);
let $bf6244e5cc9aa116$export$16d380a34afbfbed = (0, $30de942853303b03$export$fe4d3316a144eea6).ShirtTypes;
let $bf6244e5cc9aa116$export$6e1561754c81021d = $bf6244e5cc9aa116$var$authored((0, $30de942853303b03$export$fe4d3316a144eea6).SexShirts);
const $bf6244e5cc9aa116$var$commonShirtColors = [
    "black",
    "blue",
    "green",
    "maroon",
    "purple",
    "red",
    "teal",
    "white",
    "yellow"
];
let $bf6244e5cc9aa116$export$b4dd93b72d5ba14d = $bf6244e5cc9aa116$var$derive((0, $30de942853303b03$export$cb418cdf24d0dd3e).shirt);
let $bf6244e5cc9aa116$export$e373170f06c14189 = (0, $30de942853303b03$export$fe4d3316a144eea6).ArmorTypes;
let $bf6244e5cc9aa116$export$174697130974693e = $bf6244e5cc9aa116$var$derive((0, $30de942853303b03$export$cb418cdf24d0dd3e).armor);
let $bf6244e5cc9aa116$export$9b1a926f698aa2eb = (0, $30de942853303b03$export$fe4d3316a144eea6).ShoeTypes;
let $bf6244e5cc9aa116$export$14c4cc2ba117f70c = $bf6244e5cc9aa116$var$authored((0, $30de942853303b03$export$fe4d3316a144eea6).SexShoes);
let $bf6244e5cc9aa116$export$d9113a8608ba3a3c = $bf6244e5cc9aa116$var$derive((0, $30de942853303b03$export$cb418cdf24d0dd3e).shoes);
let $bf6244e5cc9aa116$export$22f463049e3f0484 = (0, $30de942853303b03$export$fe4d3316a144eea6).ShieldTypes;
let $bf6244e5cc9aa116$export$52cb84e67504327c = $bf6244e5cc9aa116$var$derive((0, $30de942853303b03$export$cb418cdf24d0dd3e).shield);
let $bf6244e5cc9aa116$export$e3843218012e8124 = (0, $30de942853303b03$export$fe4d3316a144eea6).CapeTypes;
let $bf6244e5cc9aa116$export$bacf1c742d99cac9 = $bf6244e5cc9aa116$var$authored((0, $30de942853303b03$export$fe4d3316a144eea6).SexCapes);
let $bf6244e5cc9aa116$export$6fae0646c1b2ea33 = $bf6244e5cc9aa116$var$derive((0, $30de942853303b03$export$cb418cdf24d0dd3e).cape);
const $bf6244e5cc9aa116$export$789f63764a0c7819 = {
    castlekey: [
        "gold"
    ]
};
let $bf6244e5cc9aa116$export$2e16043d24eb3a5c = $bf6244e5cc9aa116$var$derive((0, $30de942853303b03$export$cb418cdf24d0dd3e).bauldron);
/**
 * Guards on the generated colour data. Both are compile-time only; neither runs.
 *
 * Without them "derived from data" would mean "unchecked", which is worse than the hand-written
 * tables it replaced.
 */ /**
 * 1. No value may be a colour the game does not have a name for. A registry that imported
 *    upstream's `chartreuse` fails the build here, naming it, rather than resolving to a path
 *    nothing renders.
 */ const $bf6244e5cc9aa116$var$_spriteColorsAreRealColors = (0, $30de942853303b03$export$cb418cdf24d0dd3e);
/**
 * 2. Every declared component must have an entry. This is the exhaustiveness `Record<Race, ...>`
 *    used to give for free when the table was written out by hand: drop a race from the registry
 *    and the build fails instead of that race rendering nothing.
 */ const $bf6244e5cc9aa116$var$_everyComponentHasColours = [
    (0, $30de942853303b03$export$cb418cdf24d0dd3e).body,
    (0, $30de942853303b03$export$cb418cdf24d0dd3e).hair,
    (0, $30de942853303b03$export$cb418cdf24d0dd3e).weapon,
    (0, $30de942853303b03$export$cb418cdf24d0dd3e).pants,
    (0, $30de942853303b03$export$cb418cdf24d0dd3e).shirt,
    (0, $30de942853303b03$export$cb418cdf24d0dd3e).armor,
    (0, $30de942853303b03$export$cb418cdf24d0dd3e).shoes,
    (0, $30de942853303b03$export$cb418cdf24d0dd3e).shield,
    (0, $30de942853303b03$export$cb418cdf24d0dd3e).cape,
    (0, $30de942853303b03$export$cb418cdf24d0dd3e).bauldron
];
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        HumanoidRaceTypes: catalog.source.sprites.registration.HumanoidRaceTypes,
        RaceTypes: catalog.source.sprites.registration.RaceTypes,
        RaceSexes: $bf6244e5cc9aa116$var$authored(catalog.source.sprites.registration.RaceSexes),
        ColorTypes: catalog.source.vocabularies.colors,
        RaceColors: $bf6244e5cc9aa116$var$derive(catalog.spriteColors.body),
        EyeTypes: catalog.source.sprites.registration.EyeTypes,
        EyesColors: $bf6244e5cc9aa116$var$derive(catalog.spriteColors.eyes),
        NoseTypes: catalog.source.sprites.registration.NoseTypes,
        RaceNoses: $bf6244e5cc9aa116$var$authored(catalog.source.sprites.registration.RaceNoses),
        RaceEyes: $bf6244e5cc9aa116$var$authored(catalog.source.sprites.registration.RaceEyes),
        WeaponTypes: catalog.source.sprites.registration.WeaponTypes,
        WeaponAction: $bf6244e5cc9aa116$var$authored(catalog.source.sprites.registration.WeaponAction),
        WeaponAmmo: $bf6244e5cc9aa116$var$authored(catalog.source.sprites.registration.WeaponAmmo),
        WeaponColors: $bf6244e5cc9aa116$var$derive(catalog.spriteColors.weapon),
        RaceWeapons: $bf6244e5cc9aa116$var$authored(catalog.source.sprites.registration.RaceWeapons),
        DefaultAttackActionType: $bf6244e5cc9aa116$var$authored(catalog.source.sprites.registration.DefaultAttackActionType),
        HairTypes: catalog.source.sprites.registration.HairTypes,
        HairColors: $bf6244e5cc9aa116$var$derive(catalog.spriteColors.hair),
        SexHair: $bf6244e5cc9aa116$var$authored(catalog.source.sprites.registration.SexHair),
        PantsTypes: catalog.source.sprites.registration.PantsTypes,
        SexPants: $bf6244e5cc9aa116$var$authored(catalog.source.sprites.registration.SexPants),
        PantsColors: $bf6244e5cc9aa116$var$derive(catalog.spriteColors.pants),
        ShirtTypes: catalog.source.sprites.registration.ShirtTypes,
        SexShirts: $bf6244e5cc9aa116$var$authored(catalog.source.sprites.registration.SexShirts),
        ShirtColors: $bf6244e5cc9aa116$var$derive(catalog.spriteColors.shirt),
        ArmorTypes: catalog.source.sprites.registration.ArmorTypes,
        ArmorColors: $bf6244e5cc9aa116$var$derive(catalog.spriteColors.armor),
        ShoeTypes: catalog.source.sprites.registration.ShoeTypes,
        SexShoes: $bf6244e5cc9aa116$var$authored(catalog.source.sprites.registration.SexShoes),
        ShoeColors: $bf6244e5cc9aa116$var$derive(catalog.spriteColors.shoes),
        ShieldTypes: catalog.source.sprites.registration.ShieldTypes,
        ShieldColors: $bf6244e5cc9aa116$var$derive(catalog.spriteColors.shield),
        CapeTypes: catalog.source.sprites.registration.CapeTypes,
        SexCapes: $bf6244e5cc9aa116$var$authored(catalog.source.sprites.registration.SexCapes),
        CapeColors: $bf6244e5cc9aa116$var$derive(catalog.spriteColors.cape),
        BauldronColors: $bf6244e5cc9aa116$var$derive(catalog.spriteColors.bauldron),
        NoseColors: {
            ...$bf6244e5cc9aa116$var$derive(catalog.spriteColors.nose),
            none: []
        }
    }), (next)=>{
    $bf6244e5cc9aa116$export$2a4812914c68f73e = next.HumanoidRaceTypes;
    $bf6244e5cc9aa116$export$46125ee88f7f0638 = next.RaceTypes;
    $bf6244e5cc9aa116$export$1625117e6bf800e7 = next.RaceSexes;
    $bf6244e5cc9aa116$export$4eb09b1c0a6dec24 = next.ColorTypes;
    $bf6244e5cc9aa116$export$af1b56af8a451d06 = next.RaceColors;
    $bf6244e5cc9aa116$export$d45f4a0015a82408 = next.EyeTypes;
    $bf6244e5cc9aa116$export$ffaabf2abfa69206 = next.EyesColors;
    $bf6244e5cc9aa116$export$a64d361fad6262d3 = next.NoseTypes;
    $bf6244e5cc9aa116$export$523e552deae170d8 = next.RaceNoses;
    $bf6244e5cc9aa116$export$4f6565fe06691e22 = next.RaceEyes;
    $bf6244e5cc9aa116$export$45b2c5ee636d8393 = next.WeaponTypes;
    $bf6244e5cc9aa116$export$448f4eb18cb556ce = next.WeaponAction;
    $bf6244e5cc9aa116$export$3f4c28cf92a4cf37 = next.WeaponAmmo;
    $bf6244e5cc9aa116$export$489aea052d2c5de8 = next.WeaponColors;
    $bf6244e5cc9aa116$export$cd29cf568087531c = next.RaceWeapons;
    $bf6244e5cc9aa116$export$2eff43e195cfa29d = next.DefaultAttackActionType;
    $bf6244e5cc9aa116$export$abac18ec637a6d99 = next.HairTypes;
    $bf6244e5cc9aa116$export$c2ef2c5bddebe408 = next.HairColors;
    $bf6244e5cc9aa116$export$46ee3469290462e6 = next.SexHair;
    $bf6244e5cc9aa116$export$f984f9e37c2404ad = next.PantsTypes;
    $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3 = next.SexPants;
    $bf6244e5cc9aa116$export$7ef85edc405cda8b = next.PantsColors;
    $bf6244e5cc9aa116$export$16d380a34afbfbed = next.ShirtTypes;
    $bf6244e5cc9aa116$export$6e1561754c81021d = next.SexShirts;
    $bf6244e5cc9aa116$export$b4dd93b72d5ba14d = next.ShirtColors;
    $bf6244e5cc9aa116$export$e373170f06c14189 = next.ArmorTypes;
    $bf6244e5cc9aa116$export$174697130974693e = next.ArmorColors;
    $bf6244e5cc9aa116$export$9b1a926f698aa2eb = next.ShoeTypes;
    $bf6244e5cc9aa116$export$14c4cc2ba117f70c = next.SexShoes;
    $bf6244e5cc9aa116$export$d9113a8608ba3a3c = next.ShoeColors;
    $bf6244e5cc9aa116$export$22f463049e3f0484 = next.ShieldTypes;
    $bf6244e5cc9aa116$export$52cb84e67504327c = next.ShieldColors;
    $bf6244e5cc9aa116$export$e3843218012e8124 = next.CapeTypes;
    $bf6244e5cc9aa116$export$bacf1c742d99cac9 = next.SexCapes;
    $bf6244e5cc9aa116$export$6fae0646c1b2ea33 = next.CapeColors;
    $bf6244e5cc9aa116$export$2e16043d24eb3a5c = next.BauldronColors;
    $bf6244e5cc9aa116$export$f5fdec393d34621 = next.NoseColors;
});








/** Stable content adapter; authoring never rewrites this module. */ 
let $cdf806a94d4c01be$export$d7f6fa5288114206 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.tiles.types;
let $cdf806a94d4c01be$export$4783a51780b31483 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).tiles;
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        EntityTileTypes: catalog.source.tiles.types,
        EntityTileCharacteristics: catalog.tiles
    }), (next)=>{
    $cdf806a94d4c01be$export$d7f6fa5288114206 = next.EntityTileTypes;
    $cdf806a94d4c01be$export$4783a51780b31483 = next.EntityTileCharacteristics;
});


const $f684496fff50a7a1$export$618460892f1ada62 = 30;
const $f684496fff50a7a1$export$9cd6a2cdd0639728 = {
    npc: true,
    player: true
};
const $f684496fff50a7a1$export$b423c5fc832040e7 = {
    resource: true,
    structure: true
};
let $f684496fff50a7a1$export$7608a36d9e6299e1 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).items.resolvedMetadata;
const $f684496fff50a7a1$export$9efb6bfe58196888 = (itemType, color, random)=>{
    // Directional IDs belong to stair tiles, which share one inventory item and icon.
    if (itemType === "stairs-up" || itemType === "stairs-down") itemType = "stairs";
    const range = $f684496fff50a7a1$export$7608a36d9e6299e1[itemType];
    if (!range?.length) throw new Error(`Unknown or non-inventory item ID: ${itemType}`);
    if (color) return range?.find((item)=>item.color === color);
    return random ? (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(range) : range[0];
};
const $f684496fff50a7a1$export$c71b1b663c9749e1 = (itemType)=>$f684496fff50a7a1$export$7608a36d9e6299e1[itemType];
const $f684496fff50a7a1$export$3f10b5fead7f11c3 = (meta, itemType)=>{
    if (meta?.color) return meta;
    // Range-then-[0], not resolveItemTypeToMeta(), which THROWS for an unknown type (it indexes
    // into an undefined range).
    const resolved = $f684496fff50a7a1$export$c71b1b663c9749e1(meta?.type || itemType)?.[0];
    if (!resolved) return meta;
    return {
        ...resolved,
        ...meta,
        color: resolved.color
    };
};
let $f684496fff50a7a1$export$be8fdcbd37253b73 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.profiles.effects;
const $f684496fff50a7a1$export$6f33aefd40985973 = (sex, clazz, pool, colorPool, defaultColor)=>{
    const shirt = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(pool[sex]);
    return {
        type: shirt,
        class: clazz,
        color: defaultColor && colorPool[shirt].find((c)=>c === defaultColor) ? defaultColor : (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(colorPool[shirt])
    };
};
const $f684496fff50a7a1$export$2029786d851276f2 = (sex, color)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "armor", {
        male: (0, $bf6244e5cc9aa116$export$e373170f06c14189),
        female: (0, $bf6244e5cc9aa116$export$e373170f06c14189)
    }, (0, $bf6244e5cc9aa116$export$174697130974693e), color);
const $f684496fff50a7a1$export$6b5dfa9b69d47914 = (sex)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "shield", {
        male: (0, $bf6244e5cc9aa116$export$22f463049e3f0484),
        female: (0, $bf6244e5cc9aa116$export$22f463049e3f0484)
    }, (0, $bf6244e5cc9aa116$export$52cb84e67504327c));
const $f684496fff50a7a1$export$d9e877656949a349 = (sex, color)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "pants", (0, $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3), (0, $bf6244e5cc9aa116$export$7ef85edc405cda8b), color);
const $f684496fff50a7a1$export$66784139126343e5 = (sex, color)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "shirt", (0, $bf6244e5cc9aa116$export$6e1561754c81021d), (0, $bf6244e5cc9aa116$export$b4dd93b72d5ba14d), color);
const $f684496fff50a7a1$export$682f83b7ac786c71 = (sex, color)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "shoes", (0, $bf6244e5cc9aa116$export$14c4cc2ba117f70c), (0, $bf6244e5cc9aa116$export$d9113a8608ba3a3c), color);
const $f684496fff50a7a1$export$fa093afaede310d2 = (sex, color)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "cape", (0, $bf6244e5cc9aa116$export$bacf1c742d99cac9), (0, $bf6244e5cc9aa116$export$6fae0646c1b2ea33), color);
const $f684496fff50a7a1$export$34482bdcc23ddb1c = (sex)=>$f684496fff50a7a1$export$6f33aefd40985973(sex, "bauldron", {
        female: [
            "bauldron"
        ],
        male: [
            "bauldron"
        ]
    }, (0, $bf6244e5cc9aa116$export$2e16043d24eb3a5c));
const $f684496fff50a7a1$export$eb64c22ff8ddddd4 = (sex, spec)=>{
    const itemTypes = [];
    const averageColor = spec?.averageColor;
    const randomWeapon = ()=>{
        const weapon = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$45b2c5ee636d8393));
        return {
            type: weapon,
            class: "weapon",
            color: (0, $bf6244e5cc9aa116$export$489aea052d2c5de8)[weapon]?.find((c)=>c === averageColor) ? averageColor : (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$489aea052d2c5de8)[weapon])
        };
    };
    const weapon = !spec || spec.weapon ? typeof spec.weapon === "boolean" ? randomWeapon() : $f684496fff50a7a1$export$9efb6bfe58196888(spec.weapon) : undefined;
    const pants = !spec || spec.pants ? typeof spec.pants === "boolean" ? $f684496fff50a7a1$export$d9e877656949a349(sex, averageColor) : $f684496fff50a7a1$export$9efb6bfe58196888(spec.pants) : undefined;
    const shirt = !spec || spec.shirt ? typeof spec.shirt === "boolean" ? $f684496fff50a7a1$export$66784139126343e5(sex, averageColor) : $f684496fff50a7a1$export$9efb6bfe58196888(spec.shirt) : undefined;
    const armor = !spec || spec.armor ? typeof spec.armor === "boolean" ? $f684496fff50a7a1$export$2029786d851276f2(sex, averageColor) : $f684496fff50a7a1$export$9efb6bfe58196888(spec.armor) : undefined;
    const shoe = !spec || spec.shoe ? typeof spec.shoe === "boolean" ? $f684496fff50a7a1$export$682f83b7ac786c71(sex, averageColor) : $f684496fff50a7a1$export$9efb6bfe58196888(spec.shoe) : undefined;
    const shield = !spec || spec.shield ? $f684496fff50a7a1$export$6b5dfa9b69d47914(sex) : undefined;
    const cape = !spec || spec.cape ? $f684496fff50a7a1$export$fa093afaede310d2(sex, averageColor) : undefined;
    const bauldron = !spec || spec.bauldron ? typeof spec.bauldron === "boolean" ? $f684496fff50a7a1$export$34482bdcc23ddb1c(sex) : $f684496fff50a7a1$export$9efb6bfe58196888(spec.bauldron) : undefined;
    if (weapon) itemTypes.push(weapon);
    if (pants) itemTypes.push(pants);
    if (shirt) itemTypes.push(shirt);
    if (armor) itemTypes.push(armor);
    if (shoe) itemTypes.push(shoe);
    if (shield) itemTypes.push(shield);
    if (cape) itemTypes.push(cape);
    if (bauldron) itemTypes.push(bauldron);
    if (spec.chicken) itemTypes.push($f684496fff50a7a1$export$9efb6bfe58196888("drumstick"));
    if (spec.shards) itemTypes.push($f684496fff50a7a1$export$9efb6bfe58196888("shard-metal"));
    return itemTypes.map((itemTypeMeta)=>{
        return {
            itemType: "none",
            itemTypeMeta: itemTypeMeta,
            active: itemTypeMeta.class !== "resource",
            id: (0, $87befc68df50040c$export$2e2bcd8739ae039)()
        };
    });
};
const $f684496fff50a7a1$export$3c1e3d239c13de64 = (sex, noWeapon)=>{
    const itemTypes = [];
    const weapon = !noWeapon && (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$45b2c5ee636d8393)) : undefined;
    const pants = $f684496fff50a7a1$export$d9e877656949a349(sex);
    const shirt = sex === "female" ? $f684496fff50a7a1$export$66784139126343e5(sex) : (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? $f684496fff50a7a1$export$66784139126343e5(sex) : undefined;
    const armor = $f684496fff50a7a1$export$2029786d851276f2(sex);
    const shoe = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? $f684496fff50a7a1$export$682f83b7ac786c71(sex) : undefined;
    const shield = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$22f463049e3f0484)) : undefined;
    const cape = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? $f684496fff50a7a1$export$fa093afaede310d2(sex) : undefined;
    const bauldron = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? $f684496fff50a7a1$export$34482bdcc23ddb1c(sex) : undefined;
    if (weapon) itemTypes.push({
        type: weapon,
        class: "weapon",
        color: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$489aea052d2c5de8)[weapon])
    });
    if (pants) itemTypes.push(pants);
    if (shirt) itemTypes.push(shirt);
    if (armor) itemTypes.push(armor);
    if (shoe) itemTypes.push(shoe);
    if (shield) itemTypes.push({
        type: shield,
        class: "shield",
        color: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$52cb84e67504327c)[shield])
    });
    if (cape) itemTypes.push(cape);
    if (bauldron) itemTypes.push(bauldron);
    return itemTypes;
};
const $f684496fff50a7a1$export$429c16c642745fa3 = (inventory, itemClass)=>inventory?.items?.filter((item)=>item.itemTypeMeta?.class === itemClass) || [];
const $f684496fff50a7a1$export$58361cde22f3aa43 = (inventory, itemClass)=>$f684496fff50a7a1$export$ff6824850c0111da(inventory, itemClass)?.itemTypeMeta;
const $f684496fff50a7a1$export$ff6824850c0111da = (inventory, itemClass)=>inventory?.items?.find((item)=>item.itemTypeMeta?.class === itemClass && item.active);
const $f684496fff50a7a1$export$696bbd6109262d72 = (inventory, itemClass)=>inventory?.items?.filter((item)=>(!itemClass || item.itemTypeMeta?.class === itemClass) && item.readied) || [];
const $f684496fff50a7a1$export$fa05f8393ebad006 = (inventory)=>inventory?.items?.find((item)=>item.active && item.readied && (item.quantity === undefined || item.quantity > 0) && item.itemTypeMeta && [
            "structure",
            "resource",
            "key",
            "weapon"
        ].includes(item.itemTypeMeta.class) && !(0, $bf6244e5cc9aa116$export$45b2c5ee636d8393).includes(item.itemTypeMeta.type))?.itemTypeMeta;
const $f684496fff50a7a1$export$1a3bcf908754c4b4 = (inventory)=>{
    const held = $f684496fff50a7a1$export$fa05f8393ebad006(inventory);
    return held ? held.spriteId || `${held.type}-${held.color}.png` : null;
};
const $f684496fff50a7a1$export$2ed57f5a5ffde406 = (entity)=>entity.appearance?.heldObjectSpriteId !== undefined ? entity.appearance.heldObjectSpriteId : $f684496fff50a7a1$export$1a3bcf908754c4b4(entity.inventory);
const $f684496fff50a7a1$export$4c2157e8933c20e3 = (inventory, itemType)=>inventory?.items?.find((item)=>item.itemTypeMeta?.type === itemType);
/** Find a stack with matching item metadata and per-item state. Flags are part of its identity. */ // A seed tells grass from a tree by `originEntityTileId` alone, so that flag splits stacks. But every
// long-grass clump (the `grass: "long"` tag -- six meadow variants and tallGrass) grows the same grass,
// so their seeds share ONE stack rather than six identical-looking ones; planting grows whichever clump
// the stack's first seed came from.
const $f684496fff50a7a1$var$stackingFlags = (flags)=>{
    const origin = flags?.originEntityTileId;
    return origin && (0, $cdf806a94d4c01be$export$4783a51780b31483)[origin]?.grass === "long" ? {
        ...flags,
        originEntityTileId: "grass:long"
    } : flags || {};
};
const $f684496fff50a7a1$export$42ef252fc2f3d24d = (inventory, meta, maxQuantity, flags)=>inventory?.items?.find((item)=>(!maxQuantity || (item.quantity || 1) < maxQuantity) && item.itemTypeMeta?.type === meta.type && item.itemTypeMeta?.class === meta.class && item.itemTypeMeta?.color === meta.color && (0, $a80d0b17b615d6f7$export$9cb4719e2e525b7a)($f684496fff50a7a1$var$stackingFlags(item.flags), $f684496fff50a7a1$var$stackingFlags(flags)));
const $f684496fff50a7a1$export$21ed2b172ef02352 = (entity, itemId)=>{
    return $f684496fff50a7a1$var$changeInventoryItemFlags(entity, itemId, {
        readied: true
    });
};
const $f684496fff50a7a1$export$51ddac4ba8a102f9 = (entity, itemId)=>{
    return $f684496fff50a7a1$var$changeInventoryItemFlags(entity, itemId, {
        readied: false
    });
};
const $f684496fff50a7a1$export$9708f70dc8060636 = (entity, itemId)=>{
    const { inventory: inventory } = entity;
    const item = inventory.items?.find((item)=>item.id === itemId);
    if (!item) return entity;
    const { itemTypeMeta: itemTypeMeta } = item;
    (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.disallowedClassesOnActive(itemTypeMeta).map((klass)=>$f684496fff50a7a1$export$ff6824850c0111da(entity.inventory, klass)).filter((n)=>!!n).forEach((conflict)=>{
        const currentlyActiveItem = $f684496fff50a7a1$export$ff6824850c0111da(entity.inventory, conflict.itemTypeMeta.class);
        if (currentlyActiveItem) entity = $f684496fff50a7a1$export$9f1dc835e66373fa(entity, currentlyActiveItem.id);
    });
    if ((0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.exclusiveReadiness(itemTypeMeta)) {
        // can only have one active at a time per class
        const currentlyActiveItem = $f684496fff50a7a1$export$ff6824850c0111da(entity.inventory, itemTypeMeta.class);
        if (currentlyActiveItem) entity = $f684496fff50a7a1$export$9f1dc835e66373fa(entity, currentlyActiveItem.id);
    }
    return $f684496fff50a7a1$var$changeInventoryItemFlags(entity, itemId, {
        active: true
    });
};
const $f684496fff50a7a1$export$9f1dc835e66373fa = (entity, itemId)=>{
    const itemToDeactiate = entity.inventory?.items?.find((item)=>item.id === itemId);
    let updatedEntity = $f684496fff50a7a1$var$changeInventoryItemFlags(entity, itemId, {
        active: false
    });
    if (itemToDeactiate?.itemTypeMeta?.class === "weapon" && updatedEntity.weapon) updatedEntity.weapon.weaponType = "none";
    return updatedEntity;
};
const $f684496fff50a7a1$export$9bccf79e85d1f187 = (item, props)=>{
    // Directional stair IDs describe map tiles; both salvage into the same inventory item.
    if (item.type === "stairs-up" || item.type === "stairs-down") item = $f684496fff50a7a1$export$9efb6bfe58196888("stairs");
    const { sourceItem: sourceItem, quantity: quantity, hp: hp, id: id, flags: flags } = props;
    const inventoryItem = {
        id: id || sourceItem?.entityId || (0, $87befc68df50040c$export$2e2bcd8739ae039)(),
        itemType: item.class === "weapon" ? item.type : "none",
        itemTypeMeta: {
            ...item
        },
        flags: sourceItem?.flags ? {
            ...sourceItem.flags
        } : flags,
        quantity: quantity || sourceItem?.quantity,
        hp: sourceItem?.hp || hp || (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.durability.computeMaxDurability(item)
    };
    return inventoryItem;
};
const $f684496fff50a7a1$export$73ce97a5e6b0458a = (entity, item)=>{
    const { inventory: inventory } = entity;
    inventory.items?.push(item);
    return $f684496fff50a7a1$var$updateInventorySideEffects(entity);
};
const $f684496fff50a7a1$export$be412759309c8c0f = (entity, item, quantity)=>{
    const updatedQuantity = (item.quantity || 1) + quantity;
    item.quantity = updatedQuantity;
    return $f684496fff50a7a1$var$updateInventorySideEffects(entity);
};
const $f684496fff50a7a1$export$8d789f57f08f90fd = (entity, item, hp)=>{
    const updatedHp = (item.hp || 1) + hp;
    item.hp = Math.max(0, updatedHp);
    return $f684496fff50a7a1$var$updateInventorySideEffects(entity);
};
const $f684496fff50a7a1$export$6d9780a2b50e0c6e = (entity, itemId)=>{
    const { inventory: inventory } = entity;
    const item = inventory?.items.find((n)=>n.id === itemId);
    if (item?.active && item.itemTypeMeta.class === "weapon") entity.weapon.weaponType = "none";
    const updatedItems = inventory.items?.filter((i)=>i.id !== itemId);
    inventory.items = updatedItems;
    return $f684496fff50a7a1$var$updateInventorySideEffects(entity);
};
const $f684496fff50a7a1$var$changeInventoryItemFlags = (entity, itemId, { active: active, readied: readied })=>{
    const { inventory: inventory } = entity;
    const item = inventory.items?.find((item)=>item.id === itemId);
    if (!item) return entity;
    item.active = active !== undefined ? active : item.active;
    item.readied = readied !== undefined ? readied : item.readied;
    return $f684496fff50a7a1$var$updateInventorySideEffects(entity);
};
const $f684496fff50a7a1$var$updateInventorySideEffects = (entity)=>{
    const { inventory: inventory } = entity;
    if (entity.appearance) {
        entity.appearance.inventoryAppearanceHash = $f684496fff50a7a1$export$fe4683c17d6b2a37(inventory);
        entity.inventory.lastUpdateTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
    }
    return entity;
};
const $f684496fff50a7a1$export$fe4683c17d6b2a37 = (inventory)=>{
    if (!inventory) return "";
    const weapon = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "weapon");
    const pants = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "pants");
    const shirt = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "shirt");
    const armor = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "armor");
    const shoes = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "shoes");
    const shield = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "shield");
    const cape = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "cape");
    const bauldron = $f684496fff50a7a1$export$58361cde22f3aa43(inventory, "bauldron");
    const heldObject = $f684496fff50a7a1$export$fa05f8393ebad006(inventory);
    return [
        weapon,
        pants,
        shirt,
        armor,
        shoes,
        shield,
        cape,
        bauldron,
        heldObject
    ].filter((n)=>!!n).map((n)=>`${n.class}/${n.color}/${n.type}`).join("-");
};
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        AllItemTypesToMetaByColor: catalog.items.resolvedMetadata,
        ItemEffects: catalog.source.profiles.effects
    }), (next)=>{
    $f684496fff50a7a1$export$7608a36d9e6299e1 = next.AllItemTypesToMetaByColor;
    $f684496fff50a7a1$export$be8fdcbd37253b73 = next.ItemEffects;
});


/** Stable content adapter; authoring never rewrites this module. */ 
let $b5d7776bdc108009$export$6a0fc7ad27079d24 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).items.classes;
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        ItemClassTypes: catalog.items.classes
    }), (next)=>{
    $b5d7776bdc108009$export$6a0fc7ad27079d24 = next.ItemClassTypes;
});


/** Stable content adapter; authoring never rewrites this module. */ 
let $9289c16b39bc1929$export$cf55c200a2cf1225 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).items.classCharacteristics;
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        ItemClassCharacteristics: catalog.items.classCharacteristics
    }), (next)=>{
    $9289c16b39bc1929$export$cf55c200a2cf1225 = next.ItemClassCharacteristics;
});



let $29a7cd3edffb5113$var$presentation = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.presentation.crafting;
let $29a7cd3edffb5113$export$4079d59f0101220 = $29a7cd3edffb5113$var$presentation.groups;
let $29a7cd3edffb5113$export$b516a3f6baae9008 = $29a7cd3edffb5113$var$presentation.labels;
let $29a7cd3edffb5113$export$4e9ef2fe1b930332 = $29a7cd3edffb5113$var$presentation.sourceHints;
let $29a7cd3edffb5113$export$5ea6e64b0f984a99 = new Set($29a7cd3edffb5113$var$presentation.undisclosedSources ?? []);
const $29a7cd3edffb5113$export$f9bfef13afc2f4b3 = (itemTypeMeta)=>$29a7cd3edffb5113$var$presentation.overrides[itemTypeMeta.type] ?? $29a7cd3edffb5113$var$presentation.byClass[itemTypeMeta.class] ?? $29a7cd3edffb5113$var$presentation.defaultGroup;
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>catalog.source.presentation.crafting, (next)=>{
    $29a7cd3edffb5113$var$presentation = next;
    $29a7cd3edffb5113$export$4079d59f0101220 = next.groups;
    $29a7cd3edffb5113$export$b516a3f6baae9008 = next.labels;
    $29a7cd3edffb5113$export$4e9ef2fe1b930332 = next.sourceHints;
    $29a7cd3edffb5113$export$5ea6e64b0f984a99 = new Set(next.undisclosedSources ?? []);
});


/** Stable content adapter; authoring never rewrites this module. */ 
let $4ea3e677cece9ece$export$26748d48fafe06ef = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).items.recipes;
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        itemRecipes: catalog.items.recipes
    }), (next)=>{
    $4ea3e677cece9ece$export$26748d48fafe06ef = next.itemRecipes;
});


/** Stable content adapter; authoring never rewrites this module. */ 
let $7724856bf35f34f1$export$1fe1df41c32a19a1 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).items.trade;
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        BaseTradeValue: catalog.items.trade
    }), (next)=>{
    $7724856bf35f34f1$export$1fe1df41c32a19a1 = next.BaseTradeValue;
});


/** Stable compatibility names over open content IDs. New subclasses use itemTypesForSubclass. */ 
let $6bf155bafb42c3cf$export$e373170f06c14189 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("armor")
];
let $6bf155bafb42c3cf$export$57c30af6f9fcc7b6 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("ammo")
];
let $6bf155bafb42c3cf$export$ca2d6f27625f4d2d = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("ore")
];
let $6bf155bafb42c3cf$export$9cf77232fcbf2cb2 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("drumstick")
];
let $6bf155bafb42c3cf$export$321076f3c47f280e = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("craftResource")
];
let $6bf155bafb42c3cf$export$8e1ac98f867fcfc9 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("flower")
];
let $6bf155bafb42c3cf$export$e89e4a3be320fab7 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("hide")
];
let $6bf155bafb42c3cf$export$bb3a39dc2895520e = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("metalBar")
];
let $6bf155bafb42c3cf$export$3b1ebfa8738bb7c9 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("mushroom")
];
let $6bf155bafb42c3cf$export$b3621abeadb119aa = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("seed")
];
let $6bf155bafb42c3cf$export$a9d986fd459d538f = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("shard")
];
let $6bf155bafb42c3cf$export$13000b609864108d = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("straw")
];
let $6bf155bafb42c3cf$export$818357a46d9426f0 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("torch")
];
let $6bf155bafb42c3cf$export$1bfe670ceaa0e353 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("wood")
];
let $6bf155bafb42c3cf$export$e576fc74ec8de9d1 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("resource")
];
let $6bf155bafb42c3cf$export$45b2c5ee636d8393 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("weapon")
];
let $6bf155bafb42c3cf$export$9d5bd4d7c47ce3e4 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("bauldron")
];
let $6bf155bafb42c3cf$export$16d380a34afbfbed = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("shirt")
];
let $6bf155bafb42c3cf$export$dabd8295a5dbc844 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("shoes")
];
let $6bf155bafb42c3cf$export$2aceca917aabe38d = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("structure")
];
let $6bf155bafb42c3cf$export$c47ca3b04298be3 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("chest")
];
let $6bf155bafb42c3cf$export$f20e27ccf12c03d8 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("door")
];
let $6bf155bafb42c3cf$export$ba4f89177a877ab0 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("floor")
];
let $6bf155bafb42c3cf$export$49173db6f9847db8 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("roof")
];
let $6bf155bafb42c3cf$export$2862e2cd7420502d = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("wall")
];
let $6bf155bafb42c3cf$export$e3843218012e8124 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("cape")
];
let $6bf155bafb42c3cf$export$4129953fbdeabac2 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("key")
];
let $6bf155bafb42c3cf$export$f984f9e37c2404ad = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("pants")
];
let $6bf155bafb42c3cf$export$22f463049e3f0484 = [
    ...(0, $e5c675b7b9585b42$export$68aaae2ac04b8328)("shield")
];
let $6bf155bafb42c3cf$export$560c482cf16d1d03 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).items.all;
let $6bf155bafb42c3cf$export$6144f869cd49287b = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).items.classToTypes;
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        ArmorTypes: [
            ...catalog.items.subClasses["armor"] || []
        ],
        AmmoTypes: [
            ...catalog.items.subClasses["ammo"] || []
        ],
        OreTypes: [
            ...catalog.items.subClasses["ore"] || []
        ],
        DrumstickTypes: [
            ...catalog.items.subClasses["drumstick"] || []
        ],
        CraftResourceTypes: [
            ...catalog.items.subClasses["craftResource"] || []
        ],
        FlowerTypes: [
            ...catalog.items.subClasses["flower"] || []
        ],
        HideTypes: [
            ...catalog.items.subClasses["hide"] || []
        ],
        MetalBarTypes: [
            ...catalog.items.subClasses["metalBar"] || []
        ],
        MushroomTypes: [
            ...catalog.items.subClasses["mushroom"] || []
        ],
        SeedTypes: [
            ...catalog.items.subClasses["seed"] || []
        ],
        ShardTypes: [
            ...catalog.items.subClasses["shard"] || []
        ],
        StrawTypes: [
            ...catalog.items.subClasses["straw"] || []
        ],
        TorchTypes: [
            ...catalog.items.subClasses["torch"] || []
        ],
        WoodTypes: [
            ...catalog.items.subClasses["wood"] || []
        ],
        ResourceTypes: [
            ...catalog.items.subClasses["resource"] || []
        ],
        WeaponTypes: [
            ...catalog.items.subClasses["weapon"] || []
        ],
        BauldronTypes: [
            ...catalog.items.subClasses["bauldron"] || []
        ],
        ShirtTypes: [
            ...catalog.items.subClasses["shirt"] || []
        ],
        ShoesTypes: [
            ...catalog.items.subClasses["shoes"] || []
        ],
        StructureTypes: [
            ...catalog.items.subClasses["structure"] || []
        ],
        ChestTypes: [
            ...catalog.items.subClasses["chest"] || []
        ],
        DoorTypes: [
            ...catalog.items.subClasses["door"] || []
        ],
        FloorTypes: [
            ...catalog.items.subClasses["floor"] || []
        ],
        RoofTypes: [
            ...catalog.items.subClasses["roof"] || []
        ],
        WallTypes: [
            ...catalog.items.subClasses["wall"] || []
        ],
        CapeTypes: [
            ...catalog.items.subClasses["cape"] || []
        ],
        KeyTypes: [
            ...catalog.items.subClasses["key"] || []
        ],
        PantsTypes: [
            ...catalog.items.subClasses["pants"] || []
        ],
        ShieldTypes: [
            ...catalog.items.subClasses["shield"] || []
        ],
        AllItemTypes: catalog.items.all,
        ItemClassToTypes: catalog.items.classToTypes
    }), (next)=>{
    $6bf155bafb42c3cf$export$e373170f06c14189 = next.ArmorTypes;
    $6bf155bafb42c3cf$export$57c30af6f9fcc7b6 = next.AmmoTypes;
    $6bf155bafb42c3cf$export$ca2d6f27625f4d2d = next.OreTypes;
    $6bf155bafb42c3cf$export$9cf77232fcbf2cb2 = next.DrumstickTypes;
    $6bf155bafb42c3cf$export$321076f3c47f280e = next.CraftResourceTypes;
    $6bf155bafb42c3cf$export$8e1ac98f867fcfc9 = next.FlowerTypes;
    $6bf155bafb42c3cf$export$e89e4a3be320fab7 = next.HideTypes;
    $6bf155bafb42c3cf$export$bb3a39dc2895520e = next.MetalBarTypes;
    $6bf155bafb42c3cf$export$3b1ebfa8738bb7c9 = next.MushroomTypes;
    $6bf155bafb42c3cf$export$b3621abeadb119aa = next.SeedTypes;
    $6bf155bafb42c3cf$export$a9d986fd459d538f = next.ShardTypes;
    $6bf155bafb42c3cf$export$13000b609864108d = next.StrawTypes;
    $6bf155bafb42c3cf$export$818357a46d9426f0 = next.TorchTypes;
    $6bf155bafb42c3cf$export$1bfe670ceaa0e353 = next.WoodTypes;
    $6bf155bafb42c3cf$export$e576fc74ec8de9d1 = next.ResourceTypes;
    $6bf155bafb42c3cf$export$45b2c5ee636d8393 = next.WeaponTypes;
    $6bf155bafb42c3cf$export$9d5bd4d7c47ce3e4 = next.BauldronTypes;
    $6bf155bafb42c3cf$export$16d380a34afbfbed = next.ShirtTypes;
    $6bf155bafb42c3cf$export$dabd8295a5dbc844 = next.ShoesTypes;
    $6bf155bafb42c3cf$export$2aceca917aabe38d = next.StructureTypes;
    $6bf155bafb42c3cf$export$c47ca3b04298be3 = next.ChestTypes;
    $6bf155bafb42c3cf$export$f20e27ccf12c03d8 = next.DoorTypes;
    $6bf155bafb42c3cf$export$ba4f89177a877ab0 = next.FloorTypes;
    $6bf155bafb42c3cf$export$49173db6f9847db8 = next.RoofTypes;
    $6bf155bafb42c3cf$export$2862e2cd7420502d = next.WallTypes;
    $6bf155bafb42c3cf$export$e3843218012e8124 = next.CapeTypes;
    $6bf155bafb42c3cf$export$4129953fbdeabac2 = next.KeyTypes;
    $6bf155bafb42c3cf$export$f984f9e37c2404ad = next.PantsTypes;
    $6bf155bafb42c3cf$export$22f463049e3f0484 = next.ShieldTypes;
    $6bf155bafb42c3cf$export$560c482cf16d1d03 = next.AllItemTypes;
    $6bf155bafb42c3cf$export$6144f869cd49287b = next.ItemClassToTypes;
});


/** Stable content adapter; authoring never rewrites this module. */ 
let $7a0964f649e0c77d$export$5f8f4df3a4ea6bd = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).items.characteristics;
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        ItemTypeCharacteristics: catalog.items.characteristics
    }), (next)=>{
    $7a0964f649e0c77d$export$5f8f4df3a4ea6bd = next.ItemTypeCharacteristics;
});


/** Stable content adapter; authoring never rewrites this module. */ 
let $94ca5c6c04d9c167$export$b7032dafe57f8d33 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).items.protection;
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        ItemTypesProtection: catalog.items.protection
    }), (next)=>{
    $94ca5c6c04d9c167$export$b7032dafe57f8d33 = next.ItemTypesProtection;
});


/** Stable content adapter; authoring never rewrites this module. */ 
let $56a75f3d82405d26$export$86a8c920ac50eefc = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).items.weight;
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        ItemTypesWeight: catalog.items.weight
    }), (next)=>{
    $56a75f3d82405d26$export$86a8c920ac50eefc = next.ItemTypesWeight;
});







var $5Io6y = parcelRequire("5Io6y");

const $c5de4107a36072bd$var$MAX_HEIGHT = 255;
class $c5de4107a36072bd$var$BiomeRange {
    constructor(min, max){
        this.fits = (value)=>{
            return this.min <= value && value <= this.max;
        };
        this.eval = (value)=>{
            const spread = this.max - this.min;
            const subRangeWidth = Math.floor(spread / 3);
            const mid = this.min + Math.floor((this.max - this.min) / 2);
            if (value < this.min) return {
                subRange: new $c5de4107a36072bd$var$BiomeRange(this.min, this.min + subRangeWidth),
                evaluation: "low"
            };
            if (value > this.max) return {
                subRange: new $c5de4107a36072bd$var$BiomeRange(this.min + subRangeWidth + subRangeWidth, this.max),
                evaluation: "high"
            };
            if ((0, $a80d0b17b615d6f7$export$cf95c51b03f10bae)(value, this.min, this.min + subRangeWidth)) return {
                subRange: new $c5de4107a36072bd$var$BiomeRange(this.min, this.min + subRangeWidth),
                evaluation: "low"
            };
            if ((0, $a80d0b17b615d6f7$export$cf95c51b03f10bae)(value, this.min + subRangeWidth, this.min + subRangeWidth + subRangeWidth)) return {
                subRange: new $c5de4107a36072bd$var$BiomeRange(this.min + subRangeWidth, this.min + subRangeWidth + subRangeWidth),
                evaluation: "mid"
            };
            if ((0, $a80d0b17b615d6f7$export$cf95c51b03f10bae)(value, this.min + subRangeWidth + subRangeWidth, this.max)) return {
                subRange: new $c5de4107a36072bd$var$BiomeRange(this.min + subRangeWidth + subRangeWidth, this.max),
                evaluation: "high"
            };
            return {
                subRange: new $c5de4107a36072bd$var$BiomeRange(this.min + subRangeWidth, this.min + subRangeWidth + subRangeWidth),
                evaluation: "mid"
            };
        };
        this.min = min;
        this.max = max;
    }
}
class $c5de4107a36072bd$export$5b2d0fecb894d8ae {
    constructor(name, heightRange, tempRange, humidityRange, color){
        this.name = name;
        this.heightRange = heightRange;
        this.tempRange = tempRange;
        this.humidityRange = humidityRange;
        this.color = color;
    }
}
const $c5de4107a36072bd$export$251db8ae84045744 = [
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Abyss", new $c5de4107a36072bd$var$BiomeRange(0, 39), new $c5de4107a36072bd$var$BiomeRange(-10, 50), new $c5de4107a36072bd$var$BiomeRange(-10, Number.MAX_VALUE), 0x090140ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Ocean", new $c5de4107a36072bd$var$BiomeRange(40, 129), new $c5de4107a36072bd$var$BiomeRange(-10, 50), new $c5de4107a36072bd$var$BiomeRange(-10, Number.MAX_VALUE), 0x2107d8ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("IceLands", new $c5de4107a36072bd$var$BiomeRange(0, 170), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, Number.MAX_VALUE), 0x75fcf2ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Shore", new $c5de4107a36072bd$var$BiomeRange(130, 135), new $c5de4107a36072bd$var$BiomeRange(0, 50), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 50), 0xc7ce00ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("SnowyShore", new $c5de4107a36072bd$var$BiomeRange(130, 135), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, Number.MAX_VALUE), 0xedfca8ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Forest", new $c5de4107a36072bd$var$BiomeRange(140, 169), new $c5de4107a36072bd$var$BiomeRange(0, 25), new $c5de4107a36072bd$var$BiomeRange(5, 30), 0x128b03ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Plains", new $c5de4107a36072bd$var$BiomeRange(135, 169), new $c5de4107a36072bd$var$BiomeRange(0, 50), new $c5de4107a36072bd$var$BiomeRange(0, 50), 0x40d115ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("FireLands", new $c5de4107a36072bd$var$BiomeRange(135, 169), new $c5de4107a36072bd$var$BiomeRange(50, Number.MAX_VALUE), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 30), 0xe57307ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Tundra", new $c5de4107a36072bd$var$BiomeRange(140, 169), new $c5de4107a36072bd$var$BiomeRange(-10, 0), new $c5de4107a36072bd$var$BiomeRange(5, Number.MAX_VALUE), 0x745f4eff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Desert", new $c5de4107a36072bd$var$BiomeRange(135, 169), new $c5de4107a36072bd$var$BiomeRange(30, Number.MAX_VALUE), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 5), 0xcbb848ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("GrassyHills", new $c5de4107a36072bd$var$BiomeRange(160, 189), new $c5de4107a36072bd$var$BiomeRange(5, 25), new $c5de4107a36072bd$var$BiomeRange(5, 30), 0x2e7612ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("ForestyHills", new $c5de4107a36072bd$var$BiomeRange(160, 189), new $c5de4107a36072bd$var$BiomeRange(5, 30), new $c5de4107a36072bd$var$BiomeRange(0, 30), 0x1b5504ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("MuddyHills", new $c5de4107a36072bd$var$BiomeRange(170, 189), new $c5de4107a36072bd$var$BiomeRange(0, 40), new $c5de4107a36072bd$var$BiomeRange(0, 50), 0x984319ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("DryHills", new $c5de4107a36072bd$var$BiomeRange(140, 189), new $c5de4107a36072bd$var$BiomeRange(10, 40), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), 0xc6950aff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("SnowyHills", new $c5de4107a36072bd$var$BiomeRange(170, 189), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, Number.MAX_VALUE), 0x1fa27cff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("DesertDunes", new $c5de4107a36072bd$var$BiomeRange(170, 189), new $c5de4107a36072bd$var$BiomeRange(30, Number.MAX_VALUE), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), 0x7e7109ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Volcano", new $c5de4107a36072bd$var$BiomeRange(170, $c5de4107a36072bd$var$MAX_HEIGHT), new $c5de4107a36072bd$var$BiomeRange(30, Number.MAX_VALUE), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 35), 0xaf1109ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("RockyMountains", new $c5de4107a36072bd$var$BiomeRange(180, $c5de4107a36072bd$var$MAX_HEIGHT), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 30), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 40), 0x43100dff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("IceMountains", new $c5de4107a36072bd$var$BiomeRange(180, $c5de4107a36072bd$var$MAX_HEIGHT), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), new $c5de4107a36072bd$var$BiomeRange(5, Number.MAX_VALUE), 0x5b6a63ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Swamp", new $c5de4107a36072bd$var$BiomeRange(130, 170), new $c5de4107a36072bd$var$BiomeRange(0, 35), new $c5de4107a36072bd$var$BiomeRange(40, Number.MAX_VALUE), 0x052403ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("RainForest", new $c5de4107a36072bd$var$BiomeRange(140, 180), new $c5de4107a36072bd$var$BiomeRange(30, 40), new $c5de4107a36072bd$var$BiomeRange(40, Number.MAX_VALUE), 0x324b28ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("DryLands", new $c5de4107a36072bd$var$BiomeRange(0, 150), new $c5de4107a36072bd$var$BiomeRange(0, 40), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, 0), 0x834c10ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("Savannah", new $c5de4107a36072bd$var$BiomeRange(135, 169), new $c5de4107a36072bd$var$BiomeRange(20, 50), new $c5de4107a36072bd$var$BiomeRange(-10, 10), 0x767618ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("GeyserLand", new $c5de4107a36072bd$var$BiomeRange(130, 170), new $c5de4107a36072bd$var$BiomeRange(40, Number.MAX_VALUE), new $c5de4107a36072bd$var$BiomeRange(40, Number.MAX_VALUE), 0x3a3b55ff),
    new $c5de4107a36072bd$export$5b2d0fecb894d8ae("None", new $c5de4107a36072bd$var$BiomeRange(0, $c5de4107a36072bd$var$MAX_HEIGHT), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, Number.MAX_VALUE), new $c5de4107a36072bd$var$BiomeRange(-Number.MAX_VALUE, Number.MAX_VALUE), 0xe513c3ff)
];
const $c5de4107a36072bd$export$b4c1b9814b3bc6d2 = new Map();
$c5de4107a36072bd$export$251db8ae84045744.forEach((biome)=>$c5de4107a36072bd$export$b4c1b9814b3bc6d2.set(biome.name, biome));
const $c5de4107a36072bd$export$3a358f8b3ccaa20d = new Map();
$c5de4107a36072bd$export$251db8ae84045744.forEach((biome)=>$c5de4107a36072bd$export$3a358f8b3ccaa20d.set(biome.color >> 8, biome));
const $c5de4107a36072bd$export$93a7a078fd42971c = (h, temp, humidity)=>{
    const found = $c5de4107a36072bd$export$251db8ae84045744.find((biome)=>{
        if (biome.heightRange.fits(h)) {
            if (biome.tempRange.fits(temp)) {
                if (biome.humidityRange.fits(humidity)) return biome;
            }
        }
    });
    if (found) return found;
// throw Error("No biome fits the following parameters: height: " + h + ", temperature: " + temp + ", humidity: " + humidity)
};





//
// https://github.com/tlhunter/node-autotile
//
//
// The 47-index autotile bitmask (https://github.com/tlhunter/node-autotile).
//
// A leaf with no imports: autotiler.ts computes indices with it, and autotile_library.ts decodes
// them, and autotiler.ts also reads the wall definitions out of autotile_library.ts -- so the
// table cannot live in either without an import cycle.
//
const $a1574d49bcae8132$export$b581afc2e4967d38 = Math.pow(2, 0);
const $a1574d49bcae8132$export$a07804094c3ecf2d = Math.pow(2, 1);
const $a1574d49bcae8132$export$8719acbfb72c829 = Math.pow(2, 2);
const $a1574d49bcae8132$export$71cec2538cb2c617 = Math.pow(2, 3);
const $a1574d49bcae8132$export$a9c23c6ac3fc3eca = Math.pow(2, 4);
const $a1574d49bcae8132$export$ebd82301e7ce9d4d = Math.pow(2, 5);
const $a1574d49bcae8132$export$25ce5a424b770e84 = Math.pow(2, 6);
const $a1574d49bcae8132$export$88d2e60d4be28663 = Math.pow(2, 7);
const $a1574d49bcae8132$export$192e63def39d6ec0 = {
    2: 1,
    8: 2,
    10: 3,
    11: 4,
    16: 5,
    18: 6,
    22: 7,
    24: 8,
    26: 9,
    27: 10,
    30: 11,
    31: 12,
    64: 13,
    66: 14,
    72: 15,
    74: 16,
    75: 17,
    80: 18,
    82: 19,
    86: 20,
    88: 21,
    90: 22,
    91: 23,
    94: 24,
    95: 25,
    104: 26,
    106: 27,
    107: 28,
    120: 29,
    122: 30,
    123: 31,
    126: 32,
    127: 33,
    208: 34,
    210: 35,
    214: 36,
    216: 37,
    218: 38,
    219: 39,
    222: 40,
    223: 41,
    248: 42,
    250: 43,
    251: 44,
    254: 45,
    255: 46,
    0: 47
};
// The neighbour sum each index stands for (the inverse of BITMASK), for anything that has to read
// an index back into the rims and notches it encodes -- see decodeAutotileIndex in
// autotile_library.ts.
const $a1574d49bcae8132$var$INDEX_TO_BITMASK = {};
Object.keys($a1574d49bcae8132$export$192e63def39d6ec0).forEach((sum)=>$a1574d49bcae8132$var$INDEX_TO_BITMASK[$a1574d49bcae8132$export$192e63def39d6ec0[sum]] = Number(sum));
const $a1574d49bcae8132$export$65ef21f6c2d0a519 = (index)=>$a1574d49bcae8132$var$INDEX_TO_BITMASK[index];


/**
 * Terrain autotiles: the definitions are CONTENT (content/game/maps/autotiles.json), the mechanics are here.
 *
 * A definition says which tiles to draw for which autotile index; how those tiles are written
 * into a map stays in code, selected by the definition's `kind`:
 *
 *   bitmask   index -> one tile (grass, swamp, lava, the two Tiled-template sets)
 *   uniform   the same tile at every listed index (forest dirt: patches need no transitions)
 *   platform  a 23-entry variant list expanded into tiles WITH decorations: cliff faces one and two
 *             rows below the cell, a blocking (and optionally an occlusion) marker (cave walls,
 *             mountain cliffs)
 *   wall      a building wall material: per-index rules emitting tiles at offsets from the wall's
 *             cell, grouped under it as their parent (autotile_wall.ts; HouseBuilder runs them)
 *
 *   roof      a building roof material: all 47 neighbour indices mapped to sky-layer pieces
 *
 * Every definition has `id`, `name` and `kind`; every other field belongs to its kind, so a new
 * kind (a fragment-stamping tunnel, say) is a new entry shape and never a migration of the existing
 * ones. See "Walls" in docs/sprite-lab.md.
 *
 * This is a LEAF module on purpose. The map builder, the game client and Sprite Lab's browser
 * bundle all import it, so it must not reach for models, mechanics, the map builder or the file
 * system. The one per-cell decision the builder makes (`resolveAutotileCell`) and what it writes
 * for that decision (`autotileCellEffect` / `applyAutotileCellEffect`) live here so the Lab's
 * preview is the game's own code, not a copy kept in step by hand.
 *
 * The definitions arrive through the runtime content catalog (`contentCatalog.source.autotiles`), the
 * one import here outside the autotile modules. Editing them is a content save (Sprite Lab's
 * ContentRepository review/apply, or a hand edit) followed by `compile:content`; never a TS change.
 */ 



const $4d955fa5af64f75a$export$a901f188b8d1362b = (definition, index, x, y, storey = 0, placed)=>{
    const ornaments = definition.ornaments || {};
    if (placed && ornaments[placed]?.tiles[index] !== undefined) return ornaments[placed].tiles[index];
    const name = Object.keys(ornaments).sort().find((name)=>ornaments[name].tiles[index] !== undefined && (0, $d06e01c1880d4b6a$export$414e0c962a37354b)(x, y, storey, `${definition.id}:${name}`) < (ornaments[name].scatter ?? 0));
    return name ? ornaments[name].tiles[index] : definition.tiles[index];
};
const $4d955fa5af64f75a$export$62c64c0877f888c5 = (file)=>{
    const parsed = (0, $c5e6b310c34d168e$export$93c6fbb13078b3a5)(file);
    return {
        file: file,
        terrain: parsed.filter((d)=>d.kind !== "wall" && d.kind !== "roof"),
        roofs: parsed.filter((d)=>d.kind === "roof"),
        walls: parsed.filter((d)=>d.kind === "wall")
    };
};
let $4d955fa5af64f75a$export$ade0296dee419734 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.autotiles;
let $4d955fa5af64f75a$export$2c6be372bd66e1dc = [];
let $4d955fa5af64f75a$export$7f5e211f9738e851 = [];
let $4d955fa5af64f75a$export$11b99b57097122cd = [];
let $4d955fa5af64f75a$export$6551c605d612f177 = new Set();
const $4d955fa5af64f75a$export$75fb74fb4e930474 = (id)=>{
    const definition = $4d955fa5af64f75a$export$2c6be372bd66e1dc.find((d)=>d.id === id);
    if (!definition) throw new Error(`No autotile definition "${id}"`);
    return definition;
};
const $4d955fa5af64f75a$export$8c4be7951e91195d = (id)=>{
    const definition = $4d955fa5af64f75a$export$7f5e211f9738e851.find((d)=>d.id === id);
    if (!definition) throw new Error(`No wall autotile definition "${id}"`);
    return definition;
};
const $4d955fa5af64f75a$export$f9fae3e65c576dac = (definitions = $4d955fa5af64f75a$export$7f5e211f9738e851)=>new Map(definitions.filter((d)=>d.itemType).map((d)=>[
            d.itemType,
            d.id
        ]));
const $4d955fa5af64f75a$export$faa4ca2ed2ad2b60 = (definitions = $4d955fa5af64f75a$export$11b99b57097122cd)=>[
        ...new Set([
            "roof-wood",
            ...definitions.map((d)=>d.itemType).filter(Boolean)
        ])
    ];
const $4d955fa5af64f75a$export$b0bd9af80af1a6dd = (definitions = $4d955fa5af64f75a$export$7f5e211f9738e851)=>{
    if (definitions.length === 0) return [];
    const [first, ...rest] = definitions.map((0, $d06e01c1880d4b6a$export$f0c21dc345122cf3));
    return first.filter((index)=>rest.every((list)=>list.includes(index)));
};
const $4d955fa5af64f75a$var$numericTiles = (tiles)=>{
    const out = {};
    Object.keys(tiles).forEach((index)=>out[Number(index)] = tiles[index]);
    return out;
};
const $4d955fa5af64f75a$export$f2cf1ad3b6df911 = (definition)=>$4d955fa5af64f75a$var$numericTiles(definition.tiles);
const $4d955fa5af64f75a$export$bfa93016a68bf4bc = (definition, tilePos)=>{
    const tiles = {};
    definition.indices.forEach((index)=>tiles[index] = tilePos);
    return tiles;
};
const $4d955fa5af64f75a$export$c394034174d3b490 = ({ tile: tile, tilesetId: tilesetId, variants: variants, autoBlocking: autoBlocking = true, autoOcclusion: autoOcclusion = false })=>{
    const blocking = autoBlocking ? {
        tilesetId: "lpc-terrain",
        namedTileLayerId: "blocking",
        tile: 121
    } : undefined;
    const occlusion = autoOcclusion ? {
        tilesetId: "lpc-terrain",
        namedTileLayerId: "occlusion",
        tile: 121
    } : undefined;
    const faces = (first, second, mapLayerYDelta)=>[
            variants[first] != -1 ? {
                ...mapLayerYDelta === undefined ? {} : {
                    mapLayerYDelta: mapLayerYDelta
                },
                offsetX: 0,
                offsetY: 1,
                tile: variants[first]
            } : undefined,
            variants[second] != -1 ? {
                ...mapLayerYDelta === undefined ? {} : {
                    mapLayerYDelta: mapLayerYDelta
                },
                offsetX: 0,
                offsetY: 2,
                tile: variants[second]
            } : undefined
        ];
    const autotileMap = {
        tilePos: tile,
        tilesetId: tilesetId,
        mapLayerYDelta: 2,
        tiles: {
            34: {
                tile: variants[0],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            43: {
                tile: variants[1],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            42: {
                tile: variants[1],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            26: {
                tile: variants[2],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            36: {
                tile: variants[3],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            40: {
                tile: variants[3],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            28: {
                tile: variants[4],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            31: {
                tile: variants[4],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            7: {
                tile: variants[5],
                decorations: [
                    ...faces(8, 11),
                    blocking,
                    occlusion
                ]
            },
            12: {
                tile: variants[6],
                decorations: [
                    ...faces(9, 12),
                    blocking,
                    occlusion
                ]
            },
            25: {
                tile: variants[6],
                decorations: [
                    ...faces(9, 12),
                    blocking,
                    occlusion
                ]
            },
            4: {
                tile: variants[7],
                decorations: [
                    ...faces(10, 13),
                    blocking,
                    occlusion
                ]
            },
            33: {
                tile: variants[14],
                decorations: [
                    ...faces(9, 12, -1),
                    blocking,
                    occlusion
                ]
            },
            41: {
                tile: variants[15],
                decorations: [
                    ...faces(9, 12, -1),
                    blocking,
                    occlusion
                ]
            },
            44: {
                tile: variants[16],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            45: {
                tile: variants[17],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            // top left
            35: {
                tile: variants[19]
            },
            37: {
                tile: variants[19]
            },
            // top right
            27: {
                tile: variants[20],
                decorations: blocking ? [
                    blocking
                ] : undefined
            },
            29: {
                tile: variants[20],
                decorations: [
                    blocking,
                    occlusion
                ]
            },
            // bottom left
            32: {
                tile: variants[21],
                decorations: [
                    ...faces(8, 11),
                    blocking,
                    occlusion
                ]
            },
            11: {
                tile: variants[21],
                decorations: [
                    ...faces(8, 11),
                    blocking,
                    occlusion
                ]
            },
            20: {
                tile: variants[21],
                decorations: [
                    ...faces(8, 11),
                    blocking,
                    occlusion
                ]
            },
            // bottom right
            10: {
                tile: variants[22],
                decorations: [
                    ...faces(10, 13),
                    blocking,
                    occlusion
                ]
            },
            17: {
                tile: variants[22],
                decorations: [
                    ...faces(10, 13),
                    blocking,
                    occlusion
                ]
            }
        }
    };
    Object.values(autotileMap.tiles).forEach((t)=>t.noUndertile = true);
    return autotileMap;
};
const $4d955fa5af64f75a$export$6ed03ceee4fa6725 = (definition, options = {})=>{
    switch(definition.kind){
        case "bitmask":
            if (definition.tiledTemplate) return {
                tilesetId: definition.tilesetId,
                tiles: $4d955fa5af64f75a$export$f2cf1ad3b6df911(definition)
            };
            return {
                tilePos: definition.tilePos,
                tilesetId: definition.tilesetId,
                tiles: $4d955fa5af64f75a$export$f2cf1ad3b6df911(definition),
                autoTileFallback: definition.fallback,
                ...definition.ornaments ? {
                    ornaments: definition.ornaments,
                    ornamentSeed: definition.id
                } : {},
                ...definition.mapLayerYDelta === undefined ? {} : {
                    mapLayerYDelta: definition.mapLayerYDelta
                }
            };
        case "uniform":
            {
                const tilePos = options.tilePos ?? definition.previewTilePos;
                return {
                    tilePos: tilePos,
                    tilesetId: definition.tilesetId,
                    tiles: $4d955fa5af64f75a$export$bfa93016a68bf4bc(definition, tilePos),
                    autoTileFallback: tilePos
                };
            }
        case "platform":
            return $4d955fa5af64f75a$export$c394034174d3b490({
                tile: definition.tilePos,
                tilesetId: definition.tilesetId,
                variants: definition.variants,
                autoBlocking: options.autoBlocking ?? definition.preview?.autoBlocking,
                autoOcclusion: options.autoOcclusion ?? definition.preview?.autoOcclusion
            });
    }
};
const $4d955fa5af64f75a$export$42d301ed2ae8dc97 = (definition, options = {})=>definition.kind === "uniform" ? options.tilePos ?? definition.previewTilePos : definition.tilePos;
const $4d955fa5af64f75a$export$8a3bb9ee8fb5cd83 = (definition)=>definition.kind === "platform" ? definition.preview?.layerId || "map1" : definition.layerId || "map1";
const $4d955fa5af64f75a$export$c0c5793910cbfddb = (layerId)=>{
    const match = /^map(\d+)$/.exec(layerId);
    return match ? Number(match[1]) : undefined;
};
const $4d955fa5af64f75a$export$e68e86a23ef1145c = (spec, layerId, layerNumber, index, position = {
    x: 0,
    y: 0
})=>{
    const layerUpNumber = layerNumber + (spec.mapLayerYDelta || 1);
    const layerUpId = `map${layerUpNumber}`;
    const variant = spec.ornaments ? $4d955fa5af64f75a$export$a901f188b8d1362b({
        id: spec.ornamentSeed || spec.tilesetId,
        tiles: spec.tiles,
        ornaments: spec.ornaments
    }, index, position.x, position.y, position.storey, position.ornament) : spec.tiles[index];
    const layerIdToUse = typeof variant === "number" ? layerUpId : typeof variant?.tile === "number" ? layerUpId : variant?.tile?.namedTileLayerId || layerUpId;
    if (variant !== undefined) return {
        kind: "mapped",
        index: index,
        tilesetId: spec.tilesetId,
        variant: variant,
        variantPos: index,
        layerUpNumber: layerUpNumber,
        layerUpId: layerIdToUse
    };
    if (index === 46 || index === 0) return {
        kind: "skip",
        index: index
    };
    if (layerId === "map1") return {
        kind: "fallback",
        index: index,
        tilesetId: "lpc-terrain",
        variant: spec.autoTileFallback || 100,
        variantPos: -1,
        layerUpNumber: layerUpNumber,
        layerUpId: layerIdToUse
    };
    return {
        kind: "miss",
        index: index,
        tilesetId: spec.tilesetId,
        variant: -1,
        variantPos: index,
        layerUpNumber: layerUpNumber,
        layerUpId: layerIdToUse
    };
};
// The neighbour whose ground goes UNDER an edge tile once the edge has moved up a layer.
const $4d955fa5af64f75a$var$undertileOffset = (variantPos)=>{
    switch(variantPos){
        case 2:
        case 3:
        case 15:
        case 27:
        case 28:
        case 31:
            return [
                1,
                0
            ];
        case 26:
        case 44:
            return [
                1,
                -1
            ];
        case 12:
        case 13:
            return [
                0,
                1
            ];
        case 5:
        case 8:
        case 10:
        case 42:
            return [
                0,
                -1
            ];
        case 36:
            return [
                -1,
                0
            ];
        case 25:
        case 1:
            return [
                -1,
                0
            ];
        case 4:
        case 33:
            return [
                1,
                1
            ];
        case 45:
            return [
                -1,
                -1
            ];
        case 11:
        case 41:
            return [
                -1,
                1
            ];
        case 7:
        case 17:
        case 35:
        case 14:
        case 18:
        case 20:
        case 29:
        case 40:
        case 34:
        case 32:
            return [
                -1,
                0
            ];
    }
    return [
        0,
        0
    ];
};
const $4d955fa5af64f75a$export$d8a42fdf61018dcb = (draw, sourceLayerId)=>{
    const { tilesetId: tilesetId, variant: variant, variantPos: variantPos, layerUpNumber: layerUpNumber, layerUpId: layerUpId } = draw;
    const tileMeta = typeof variant === "number" ? variant : variant.tile;
    const decorations = (typeof variant === "number" ? [] : variant.decorations || []).filter((n)=>!!n);
    const baseTile = typeof tileMeta === "number" ? tileMeta : tileMeta?.tile;
    if (baseTile === -1) // erase
    return [
        {
            op: "input",
            layerId: layerUpId,
            dx: 0,
            dy: 0,
            tile: null
        },
        {
            op: "set",
            layerId: sourceLayerId,
            dx: 0,
            dy: 0,
            tile: null,
            role: "clear"
        }
    ];
    const art = {
        tilesetId: tilesetId,
        tilePos: baseTile
    };
    const ops = [
        // paste it into the next layer up
        {
            op: "input",
            layerId: layerUpId,
            dx: 0,
            dy: 0,
            tile: art
        },
        {
            op: "set",
            layerId: layerUpId,
            dx: 0,
            dy: 0,
            tile: art,
            role: "art"
        },
        // remove original
        {
            op: "set",
            layerId: sourceLayerId,
            dx: 0,
            dy: 0,
            tile: null,
            role: "clear"
        }
    ];
    decorations.forEach((decoration)=>{
        ops.push({
            op: "set",
            layerId: decoration.namedTileLayerId || `map${(decoration.mapLayerYDelta || 0) + layerUpNumber}`,
            dx: decoration.offsetX || 0,
            dy: decoration.offsetY || 0,
            tile: {
                tilesetId: decoration.tilesetId || tilesetId,
                tilePos: decoration.tile
            },
            role: "decoration"
        });
    });
    const noUndertile = typeof variant === "number" ? false : variant.noUndertile;
    if (!noUndertile) {
        const [fromDx, fromDy] = $4d955fa5af64f75a$var$undertileOffset(variantPos);
        if (fromDx || fromDy) ops.push({
            op: "undertile",
            layerId: sourceLayerId,
            fromDx: fromDx,
            fromDy: fromDy
        });
    }
    return ops;
};
const $4d955fa5af64f75a$export$f8a32194ceb47840 = (store, ops, x, y)=>{
    ops.forEach((op)=>{
        switch(op.op){
            case "input":
                store.setInput(op.layerId, x + op.dx, y + op.dy, op.tile ? store.encode(op.tile) : store.empty);
                break;
            case "set":
                store.set(op.layerId, x + op.dx, y + op.dy, op.tile ? store.encode(op.tile) : store.empty);
                break;
            case "undertile":
                {
                    const replaceTile = store.get(op.layerId, x + op.fromDx, y + op.fromDy);
                    if (replaceTile !== store.empty) store.set(op.layerId, x, y, replaceTile);
                    break;
                }
        }
    });
};
const $4d955fa5af64f75a$export$328c96ac62c051dd = (index)=>{
    const sum = (0, $a1574d49bcae8132$export$65ef21f6c2d0a519)(index);
    if (sum === undefined) return undefined;
    const has = (bit)=>(sum & bit) !== 0;
    const [NW, N, NE, W, E, SW, S, SE] = [
        1,
        2,
        4,
        8,
        16,
        32,
        64,
        128
    ];
    const rims = [];
    if (!has(N)) rims.push("N");
    if (!has(E)) rims.push("E");
    if (!has(S)) rims.push("S");
    if (!has(W)) rims.push("W");
    const notches = [];
    if (has(N) && has(W) && !has(NW)) notches.push("NW");
    if (has(N) && has(E) && !has(NE)) notches.push("NE");
    if (has(S) && has(W) && !has(SW)) notches.push("SW");
    if (has(S) && has(E) && !has(SE)) notches.push("SE");
    return {
        sum: sum,
        rims: rims,
        notches: notches
    };
};
const $4d955fa5af64f75a$export$d3490f5cbde1132f = (entry)=>{
    const refs = new Map();
    const add = (tilesetId, tilePos)=>{
        if (typeof tilePos === "number" && Number.isInteger(tilePos) && tilePos >= 0) refs.set(`${tilesetId}:${tilePos}`, {
            tilesetId: tilesetId,
            tilePos: tilePos
        });
    };
    switch(entry.kind){
        case "roof":
            Object.values(entry.tiles).forEach((tile)=>add(entry.tilesetId, tile));
            Object.values(entry.pitched || {}).forEach((tile)=>add(entry.tilesetId, tile));
            Object.values(entry.ornaments || {}).forEach((ornament)=>Object.values(ornament?.pieces || {}).forEach((tile)=>add(entry.tilesetId, tile)));
            break;
        case "bitmask":
            add(entry.tilesetId, entry.tilePos);
            Object.values(entry.tiles || {}).forEach((tile)=>add(entry.tilesetId, tile));
            Object.values(entry.ornaments || {}).forEach((ornament)=>Object.values(ornament.tiles).forEach((tile)=>add(entry.tilesetId, tile)));
            if (entry.fallback !== undefined) add("lpc-terrain", entry.fallback);
            break;
        case "uniform":
            add(entry.tilesetId, entry.previewTilePos);
            break;
        case "platform":
            add(entry.tilesetId, entry.tilePos);
            (entry.variants || []).forEach((tile)=>add(entry.tilesetId, tile));
            add("lpc-terrain", 121);
            break;
        case "wall":
            {
                const emit = (emits)=>emits.forEach((e)=>add(entry.tilesetId, e.tile));
                Object.values(entry.rules || {}).forEach((steps)=>steps.forEach((step)=>"choose" in step ? step.choose.forEach((alternative)=>emit(alternative.emit || [])) : emit([
                            step
                        ])));
                Object.values(entry.cell || {}).forEach((ref)=>ref && add(ref.tilesetId, ref.tilePos));
                Object.values(entry.upperTiles || {}).forEach((tile)=>add(entry.tilesetId, tile));
                Object.values(entry.ornaments || {}).forEach((ornament)=>Object.values(ornament?.tiles || {}).forEach((tile)=>add(entry.tilesetId, tile)));
                [
                    ...Object.values(entry.seams?.covered || {}),
                    ...Object.values(entry.seams?.continued || {}),
                    ...Object.values(entry.seams?.joints || {}),
                    entry.seams?.lintel
                ].forEach((ref)=>ref && add(ref.tilesetId, ref.tilePos));
                break;
            }
    }
    return [
        ...refs.values()
    ];
};
const $4d955fa5af64f75a$export$5558f7940f25cdb7 = ()=>{
    const out = {};
    $4d955fa5af64f75a$export$2c6be372bd66e1dc.forEach((definition)=>{
        if (definition.kind === "bitmask" && definition.tiledTemplate) {
            out[definition.tilesetId] = out[definition.tilesetId] || {};
            out[definition.tilesetId][definition.tilePos] = $4d955fa5af64f75a$export$f2cf1ad3b6df911(definition);
        }
    });
    return out;
};
const $4d955fa5af64f75a$export$1ed5e50b752234eb = ()=>{
    const out = {};
    $4d955fa5af64f75a$export$2c6be372bd66e1dc.forEach((definition)=>{
        if (definition.kind === "platform") {
            out[definition.tilesetId] = out[definition.tilesetId] || {};
            out[definition.tilesetId][definition.tilePos] = [
                ...definition.variants
            ];
        }
    });
    return out;
};
const $4d955fa5af64f75a$export$4556b3417e30cb24 = (id)=>{
    const definition = $4d955fa5af64f75a$export$75fb74fb4e930474(id);
    if (definition.kind !== "bitmask" || !definition.layerId) throw new Error(`Autotile definition "${id}" is not a generator-painted bitmask set`);
    return {
        tilesetId: definition.tilesetId,
        tilePos: definition.tilePos,
        layerId: definition.layerId,
        autotileMap: $4d955fa5af64f75a$export$f2cf1ad3b6df911(definition),
        autoTileFallback: definition.fallback
    };
};
const $4d955fa5af64f75a$export$d0efefe3f5b7b5e9 = (id, tilePos)=>{
    const definition = $4d955fa5af64f75a$export$75fb74fb4e930474(id);
    if (definition.kind !== "uniform") throw new Error(`Autotile definition "${id}" is not a uniform set`);
    return {
        tilesetId: definition.tilesetId,
        tilePos: tilePos,
        layerId: definition.layerId,
        autotileMap: $4d955fa5af64f75a$export$bfa93016a68bf4bc(definition, tilePos),
        autoTileFallback: tilePos
    };
};
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>{
    const tables = $4d955fa5af64f75a$export$62c64c0877f888c5(catalog.source.autotiles);
    return {
        ...tables,
        computable: new Set($4d955fa5af64f75a$export$b0bd9af80af1a6dd(tables.walls))
    };
}, (next)=>{
    $4d955fa5af64f75a$export$ade0296dee419734 = next.file;
    $4d955fa5af64f75a$export$2c6be372bd66e1dc = next.terrain;
    $4d955fa5af64f75a$export$7f5e211f9738e851 = next.walls;
    $4d955fa5af64f75a$export$11b99b57097122cd = next.roofs;
    $4d955fa5af64f75a$export$6551c605d612f177 = next.computable;
});


function $5cfd87a852590fa6$var$autotileLookup(map, x_boundary, y_boundary, x, y, joins) {
    const at = (nx, ny)=>!!map[ny][nx] && (!joins || joins(x, y, nx, ny));
    let sum = 0;
    let n = false;
    let e = false;
    let s = false;
    let w = false;
    if (!map[y][x]) return 0;
    if (y > 0 && at(x, y - 1)) {
        n = true;
        sum += (0, $a1574d49bcae8132$export$a07804094c3ecf2d);
    }
    if (x > 0 && at(x - 1, y)) {
        w = true;
        sum += (0, $a1574d49bcae8132$export$71cec2538cb2c617);
    }
    if (x < x_boundary && at(x + 1, y)) {
        e = true;
        sum += (0, $a1574d49bcae8132$export$a9c23c6ac3fc3eca);
    }
    if (y < y_boundary && at(x, y + 1)) {
        s = true;
        sum += (0, $a1574d49bcae8132$export$25ce5a424b770e84);
    }
    if (n && w && y > 0 && x > 0 && at(x - 1, y - 1)) sum += (0, $a1574d49bcae8132$export$b581afc2e4967d38);
    if (n && e && y > 0 && x < x_boundary && at(x + 1, y - 1)) sum += (0, $a1574d49bcae8132$export$8719acbfb72c829);
    if (s && w && y < y_boundary && x > 0 && at(x - 1, y + 1)) sum += (0, $a1574d49bcae8132$export$ebd82301e7ce9d4d);
    if (s && e && x < x_boundary && y < y_boundary && at(x + 1, y + 1)) sum += (0, $a1574d49bcae8132$export$88d2e60d4be28663);
    return (0, $a1574d49bcae8132$export$192e63def39d6ec0)[sum];
}
const $5cfd87a852590fa6$export$a936a6c53c1608e9 = (idx)=>{
    if (idx === 0) return true // no wall here
    ;
    if (idx === undefined) return false // wall with an unmapped neighbor configuration
    ;
    return (0, $4d955fa5af64f75a$export$6551c605d612f177).has(idx);
};
const $5cfd87a852590fa6$export$19a7a8d2d9b0fbb7 = (map, joins)=>{
    const tiles = [];
    const height = map.length;
    const width = map[0].length;
    const x_boundary = width - 1;
    const y_boundary = height - 1;
    for(let y = 0; y < height; y++){
        tiles[y] = [];
        for(let x = 0; x < width; x++)tiles[y][x] = $5cfd87a852590fa6$var$autotileLookup(map, x_boundary, y_boundary, x, y, joins);
    }
    return tiles;
};
const $5cfd87a852590fa6$export$d004d5a0cbfa247b = (map, own)=>{
    const kinds = new Set();
    map.forEach((row)=>row.forEach((cell)=>{
            const kind = cell ? own(cell) : undefined;
            if (kind) kinds.add(kind);
        }));
    if (!kinds.size) {
        const indices = $5cfd87a852590fa6$export$19a7a8d2d9b0fbb7(map);
        return {
            indices: indices,
            gridAt: ()=>indices
        };
    }
    const only = (kind)=>map.map((row)=>row.map((cell)=>cell && own(cell) === kind ? cell : undefined));
    const common = $5cfd87a852590fa6$export$19a7a8d2d9b0fbb7(only(undefined));
    const grids = new Map([
        ...kinds
    ].map((kind)=>[
            kind,
            $5cfd87a852590fa6$export$19a7a8d2d9b0fbb7(only(kind))
        ]));
    const gridAt = (x, y)=>{
        const cell = map[y]?.[x];
        const kind = cell ? own(cell) : undefined;
        return kind && grids.get(kind) || common;
    };
    return {
        indices: map.map((row, y)=>row.map((_, x)=>gridAt(x, y)[y][x])),
        gridAt: gridAt
    };
};





const $23e67fb1a742a4ea$export$96afdb68a4534bc1 = 16;
// A ray meeting a face obliquely only gets WallFaceReveal * cos(angle) into the rock, so a
// wall seen along its length would show as a sliver rather than half a tile. Dividing the
// push by that cosine restores the depth, and this caps the correction: a ray grazing a face
// almost parallel would otherwise be pushed an unbounded distance past the corner it grazes.
const $23e67fb1a742a4ea$var$MaxRevealStretch = 2.5;
const $23e67fb1a742a4ea$export$f3fbecc1278222f3 = $23e67fb1a742a4ea$export$96afdb68a4534bc1 * $23e67fb1a742a4ea$var$MaxRevealStretch;
// Rays aimed exactly at a shared endpoint can land a few trillionths past it after rounding.
// Rejecting both meeting segments opens a bright wedge, so allow this much slop along a segment.
const $23e67fb1a742a4ea$var$EndpointSlop = 1e-8;
// Below this the ray and the segment are parallel: no single intersection point.
const $23e67fb1a742a4ea$var$ParallelEpsilon = 1e-10;
// How far either side of a vertex the flanking rays are aimed. Each one has to slip PAST the
// corner and carry on to whatever stands behind it, so the miss distance it buys at the corner
// (distance * this) must stay clear of EndpointSlop scaled to the segment's length.
const $23e67fb1a742a4ea$var$CornerNudge = 0.00001;
// Scratch buffers. getSightPolygon is called several times per frame (once for the viewer, once
// per light) and used to allocate one object per ray/segment hit test -- ~300k allocations a frame
// in a cave. These are reused across calls instead; the function never recurses, so a single set
// is enough. They grow to the largest scene seen and are never shrunk.
let $23e67fb1a742a4ea$var$segAx = new Float64Array(0);
let $23e67fb1a742a4ea$var$segAy = new Float64Array(0);
let $23e67fb1a742a4ea$var$segBx = new Float64Array(0);
let $23e67fb1a742a4ea$var$segBy = new Float64Array(0);
let $23e67fb1a742a4ea$var$segInvLen = new Float64Array(0);
let $23e67fb1a742a4ea$var$rayAngles = new Float64Array(0);
const $23e67fb1a742a4ea$var$ensureSegmentCapacity = (n)=>{
    if ($23e67fb1a742a4ea$var$segAx.length >= n) return;
    const size = Math.max(n, $23e67fb1a742a4ea$var$segAx.length * 2, 64);
    $23e67fb1a742a4ea$var$segAx = new Float64Array(size);
    $23e67fb1a742a4ea$var$segAy = new Float64Array(size);
    $23e67fb1a742a4ea$var$segBx = new Float64Array(size);
    $23e67fb1a742a4ea$var$segBy = new Float64Array(size);
    $23e67fb1a742a4ea$var$segInvLen = new Float64Array(size);
};
const $23e67fb1a742a4ea$var$ensureAngleCapacity = (n)=>{
    if ($23e67fb1a742a4ea$var$rayAngles.length >= n) return;
    $23e67fb1a742a4ea$var$rayAngles = new Float64Array(Math.max(n, $23e67fb1a742a4ea$var$rayAngles.length * 2, 192));
};
// castRay's results. Returning an object per ray is what this rewrite exists to avoid, and
// neither caster recurses, so a pair of scalars read straight after the call is enough.
let $23e67fb1a742a4ea$var$hitParam = 0;
let $23e67fb1a742a4ea$var$hitNormalCos = 0;
/**
 * Nearest of the flattened segments that the unit ray (rdx, rdy) from (sightX, sightY) crosses,
 * left in hitParam (a distance in world pixels, since the ray is a unit vector) and hitNormalCos
 * (how square-on it met that segment: 1 head-on, 0 grazing).
 */ const $23e67fb1a742a4ea$var$castRay = (sightX, sightY, rdx, rdy, segmentCount)=>{
    let bestParam = Infinity;
    let bestNormalCos = 0;
    for(let i = 0; i < segmentCount; i++){
        const sdx = $23e67fb1a742a4ea$var$segBx[i] - $23e67fb1a742a4ea$var$segAx[i];
        const sdy = $23e67fb1a742a4ea$var$segBy[i] - $23e67fb1a742a4ea$var$segAy[i];
        // Already |segment| * sin(between them), which is why normalCos below only has to divide
        // the segment's length back out.
        const denominator = rdx * sdy - rdy * sdx;
        if (denominator > -$23e67fb1a742a4ea$var$ParallelEpsilon && denominator < $23e67fb1a742a4ea$var$ParallelEpsilon) continue;
        const offsetX = $23e67fb1a742a4ea$var$segAx[i] - sightX;
        const offsetY = $23e67fb1a742a4ea$var$segAy[i] - sightY;
        const T1 = (offsetX * sdy - offsetY * sdx) / denominator;
        // Reject before computing T2: a hit further away than the best so far cannot win. The
        // negated form also rejects a NaN T1, which is what the old explicit finite checks caught.
        if (!(T1 >= 0) || T1 >= bestParam) continue;
        const T2 = (offsetX * rdy - offsetY * rdx) / denominator;
        if (T2 < -$23e67fb1a742a4ea$var$EndpointSlop || T2 > 1 + $23e67fb1a742a4ea$var$EndpointSlop) continue;
        bestParam = T1;
        bestNormalCos = Math.abs(denominator) * $23e67fb1a742a4ea$var$segInvLen[i];
    }
    if (bestParam === Infinity) return false;
    $23e67fb1a742a4ea$var$hitParam = bestParam;
    $23e67fb1a742a4ea$var$hitNormalCos = bestNormalCos;
    return true;
};
// A ray meeting a face obliquely only gets `reveal` * cos(angle) into it, so dividing by that
// cosine restores the depth -- capped, or a ray grazing a face almost parallel to it would be
// pushed an unbounded distance past the corner it grazed.
const $23e67fb1a742a4ea$var$revealAlong = (reveal, normalCos)=>reveal / Math.max(normalCos, 1 / $23e67fb1a742a4ea$var$MaxRevealStretch);
const $23e67fb1a742a4ea$export$a30470b4ef717782 = (segments, sightX, sightY, reveal = 0)=>{
    const segmentCount = segments.length;
    $23e67fb1a742a4ea$var$ensureSegmentCapacity(segmentCount);
    $23e67fb1a742a4ea$var$ensureAngleCapacity(segmentCount * 6);
    // Flatten the segments and collect three ray angles per endpoint.
    let angleCount = 0;
    for(let i = 0; i < segmentCount; i++){
        const { a: a, b: b } = segments[i];
        $23e67fb1a742a4ea$var$segAx[i] = a.x;
        $23e67fb1a742a4ea$var$segAy[i] = a.y;
        $23e67fb1a742a4ea$var$segBx[i] = b.x;
        $23e67fb1a742a4ea$var$segBy[i] = b.y;
        const dx = b.x - a.x;
        const dy = b.y - a.y;
        const length = Math.sqrt(dx * dx + dy * dy);
        $23e67fb1a742a4ea$var$segInvLen[i] = length > 0 ? 1 / length : 0;
        for(let e = 0; e < 2; e++){
            const angle = Math.atan2((e === 0 ? a.y : b.y) - sightY, (e === 0 ? a.x : b.x) - sightX);
            $23e67fb1a742a4ea$var$rayAngles[angleCount++] = angle - $23e67fb1a742a4ea$var$CornerNudge;
            $23e67fb1a742a4ea$var$rayAngles[angleCount++] = angle;
            $23e67fb1a742a4ea$var$rayAngles[angleCount++] = angle + $23e67fb1a742a4ea$var$CornerNudge;
        }
    }
    // Sorting the ANGLES once is the same ordering the vertices used to be sorted into after the
    // fact, minus a comparator call per output vertex. Descending, to keep the winding the
    // callers' Graphics fills and Polygon.contains checks have always seen.
    //
    // It also subsumes deduplication, which used to be a Set of "x-y" keys over the endpoints --
    // two strings and a hash per segment, and the single biggest cost left in a small scene once
    // the hit loop got cheap. Equal angles are adjacent after the sort, so the skip below collapses
    // them for nothing. Deduping by ANGLE rather than by point is also strictly better: two
    // DIFFERENT endpoints that happen to line up behind each other from here share an angle, and
    // those used to get a second set of rays that could only add a zero-width spike to the result.
    const angles = $23e67fb1a742a4ea$var$rayAngles.subarray(0, angleCount);
    angles.sort();
    const points = [];
    for(let k = angleCount - 1; k >= 0; k--){
        const angle = angles[k];
        if (k < angleCount - 1 && angle === angles[k + 1]) continue;
        const rdx = Math.cos(angle);
        const rdy = Math.sin(angle);
        if (!$23e67fb1a742a4ea$var$castRay(sightX, sightY, rdx, rdy, segmentCount)) continue;
        const param = reveal ? $23e67fb1a742a4ea$var$hitParam + $23e67fb1a742a4ea$var$revealAlong(reveal, $23e67fb1a742a4ea$var$hitNormalCos) : $23e67fb1a742a4ea$var$hitParam;
        points.push({
            x: sightX + rdx * param,
            y: sightY + rdy * param,
            param: param,
            normalCos: $23e67fb1a742a4ea$var$hitNormalCos,
            angle: angle
        });
    }
    return points;
};
const $23e67fb1a742a4ea$export$3a4b253c0ba86d15 = (blockers, lightX, lightY, reach, reveal = 0, arcSamples = 32)=>{
    const segmentCount = blockers.length;
    $23e67fb1a742a4ea$var$ensureSegmentCapacity(segmentCount);
    $23e67fb1a742a4ea$var$ensureAngleCapacity(segmentCount * 6 + arcSamples);
    let angleCount = 0;
    for(let i = 0; i < segmentCount; i++){
        const { a: a, b: b } = blockers[i];
        $23e67fb1a742a4ea$var$segAx[i] = a.x;
        $23e67fb1a742a4ea$var$segAy[i] = a.y;
        $23e67fb1a742a4ea$var$segBx[i] = b.x;
        $23e67fb1a742a4ea$var$segBy[i] = b.y;
        const dx = b.x - a.x;
        const dy = b.y - a.y;
        const length = Math.sqrt(dx * dx + dy * dy);
        $23e67fb1a742a4ea$var$segInvLen[i] = length > 0 ? 1 / length : 0;
        for(let e = 0; e < 2; e++){
            const angle = Math.atan2((e === 0 ? a.y : b.y) - lightY, (e === 0 ? a.x : b.x) - lightX);
            $23e67fb1a742a4ea$var$rayAngles[angleCount++] = angle - $23e67fb1a742a4ea$var$CornerNudge;
            $23e67fb1a742a4ea$var$rayAngles[angleCount++] = angle;
            $23e67fb1a742a4ea$var$rayAngles[angleCount++] = angle + $23e67fb1a742a4ea$var$CornerNudge;
        }
    }
    // One ray per arc sample, not three: there is no corner here to slip past, only a smooth rim
    // to trace wherever no blocker interrupts it.
    for(let i = 0; i < arcSamples; i++)$23e67fb1a742a4ea$var$rayAngles[angleCount++] = -Math.PI + i * 2 * Math.PI / arcSamples;
    const angles = $23e67fb1a742a4ea$var$rayAngles.subarray(0, angleCount);
    angles.sort();
    const points = [];
    for(let k = angleCount - 1; k >= 0; k--){
        const angle = angles[k];
        if (k < angleCount - 1 && angle === angles[k + 1]) continue;
        const rdx = Math.cos(angle);
        const rdy = Math.sin(angle);
        // A blocker at or beyond `reach` cannot shade anything the light touches, so the rim wins.
        // The rim is met square-on from the centre, hence the undiminished reveal there.
        const stopped = $23e67fb1a742a4ea$var$castRay(lightX, lightY, rdx, rdy, segmentCount) && $23e67fb1a742a4ea$var$hitParam < reach;
        const normalCos = stopped ? $23e67fb1a742a4ea$var$hitNormalCos : 1;
        const param = (stopped ? $23e67fb1a742a4ea$var$hitParam : reach) + (reveal ? $23e67fb1a742a4ea$var$revealAlong(reveal, normalCos) : 0);
        points.push({
            x: lightX + rdx * param,
            y: lightY + rdy * param,
            param: param,
            normalCos: normalCos,
            angle: angle
        });
    }
    return points;
};
const $23e67fb1a742a4ea$export$691dec627034f05a = (segments, sightX, sightY, size = 100, skip = 0)=>{
    const left = sightX - size;
    const right = sightX + size;
    const top = sightY - size;
    const bottom = sightY + size;
    return segments.filter(({ a: a, b: b }, i)=>i <= skip || Math.min(a.x, b.x) <= right && Math.max(a.x, b.x) >= left && Math.min(a.y, b.y) <= bottom && Math.max(a.y, b.y) >= top);
};
const $23e67fb1a742a4ea$export$86ea038b7dd84d57 = (segments, reserved = 0)=>{
    const horizontal = new Map();
    const vertical = new Map();
    const merged = [];
    const span = (map, at, from, to)=>{
        const spans = map.get(at);
        const entry = from <= to ? [
            from,
            to
        ] : [
            to,
            from
        ];
        if (spans) spans.push(entry);
        else map.set(at, [
            entry
        ]);
    };
    segments.forEach(({ a: a, b: b }, i)=>{
        if (i < reserved) {
            merged.push({
                a: a,
                b: b
            });
            return;
        }
        if (a.y === b.y && a.x !== b.x) span(horizontal, a.y, a.x, b.x);
        else if (a.x === b.x && a.y !== b.y) span(vertical, a.x, a.y, b.y);
        else merged.push({
            a: a,
            b: b
        });
    });
    const flush = (map, isHorizontal)=>{
        map.forEach((spans, at)=>{
            spans.sort((one, other)=>one[0] - other[0]);
            let [from, to] = spans[0];
            const emit = ()=>merged.push(isHorizontal ? {
                    a: {
                        x: from,
                        y: at
                    },
                    b: {
                        x: to,
                        y: at
                    }
                } : {
                    a: {
                        x: at,
                        y: from
                    },
                    b: {
                        x: at,
                        y: to
                    }
                });
            for(let i = 1; i < spans.length; i++){
                const [nextFrom, nextTo] = spans[i];
                if (nextFrom <= to) {
                    if (nextTo > to) to = nextTo;
                    continue;
                }
                emit();
                from = nextFrom;
                to = nextTo;
            }
            emit();
        });
    };
    flush(horizontal, true);
    flush(vertical, false);
    return merged;
};







const $5ff29e9b920ad43b$export$1bb592e1e2038ca8 = new Set([
    344,
    345,
    346
]);
const $5ff29e9b920ad43b$export$b3c6c04580b0bd54 = (rects)=>{
    if (!Array.isArray(rects) || !rects.length || rects.some((rect)=>!rect || ![
            rect.x,
            rect.y,
            rect.width,
            rect.height
        ].every(Number.isFinite) || rect.width <= 0 || rect.height <= 0 || rect.x < -32 || rect.y < -32 || rect.bodyInsetBottom !== undefined && (!Number.isFinite(rect.bodyInsetBottom) || rect.bodyInsetBottom < 0 || rect.bodyInsetBottom > 32) || rect.x + rect.width > 64 || rect.y + rect.height > 64)) throw new Error("blockingRects must contain positive finite rectangles within one tile of the parent cell");
    return rects;
};
const $5ff29e9b920ad43b$export$8e55369286cb464 = (position, parentPosition, parentBlocking)=>{
    if (!parentBlocking || position !== 440 && position !== 442 || parentPosition !== (position === 440 ? 408 : 410)) return undefined;
    return [
        {
            x: position === 440 ? 16 : 0,
            y: 0,
            width: 16,
            height: 32
        }
    ];
};
const $5ff29e9b920ad43b$export$4a8503c515ddb75 = new Set([
    344,
    376,
    408,
    440,
    472
]);
const $5ff29e9b920ad43b$export$8af65a70f4144267 = new Set([
    346,
    378,
    410,
    442,
    474
]);
const $5ff29e9b920ad43b$export$420826986f821865 = (variant, northConnected)=>{
    const vertical = {
        x: 12,
        y: 0,
        width: 8,
        height: 32
    };
    // The horizontal wall's ground plane sits toward the north of its base tile.
    // This lets bodies approach beneath the raised face without exposing feet behind it.
    const horizontal = {
        x: 0,
        y: 4,
        width: 32,
        height: 8
    };
    const right = {
        x: 12,
        y: 4,
        width: 20,
        height: 8
    };
    const left = {
        x: 0,
        y: 4,
        width: 20,
        height: 8
    };
    const north = {
        x: 12,
        y: 0,
        width: 8,
        height: 12
    };
    const south = {
        x: 12,
        y: 4,
        width: 8,
        height: 28
    };
    switch(variant){
        case 0:
            return [
                vertical
            ];
        case 1:
            return northConnected ? [
                horizontal,
                north
            ] : [
                horizontal
            ];
        case 12:
            return [
                horizontal,
                northConnected ? vertical : south
            ];
        case 2:
            return [
                right,
                northConnected ? vertical : south
            ];
        case 3:
        case 4:
            return [
                left,
                northConnected ? vertical : south
            ];
        case 5:
            return [
                north,
                right
            ];
        case 6:
            return [
                north,
                left
            ];
        case 7:
        case 8:
            return [
                {
                    x: 12,
                    y: 12,
                    width: 8,
                    height: 20
                }
            ];
        case 9:
            return [
                {
                    x: 12,
                    y: 0,
                    width: 8,
                    height: 20
                }
            ];
        case 10:
            return [
                right
            ];
        case 11:
            return [
                left
            ];
        default:
            return [];
    }
};
const $5ff29e9b920ad43b$export$29da78b220ab8d4d = (y1, y2, rect)=>rect.groundSupport ? (y1 + y2) / 2 + (0, $9667a1379a787b5e$export$5985b04c8e71b763) : y2 - Math.min(rect.bodyInsetBottom || 0, Math.max(0, (y2 - y1) / 2 - 0.5));
const $5ff29e9b920ad43b$export$197d934ee3c39f4d = (y1, y2, rect)=>rect.groundSupport ? (y1 + y2) / 2 + (0, $9667a1379a787b5e$export$5985b04c8e71b763) : y1;
const $5ff29e9b920ad43b$export$9a7c8908712261a1 = (x1, y1, x2, y2, rect)=>(rect.groundSupport ? (x1 + x2) / 2 < rect.x + rect.width && (x1 + x2) / 2 > rect.x : x1 < rect.x + rect.width && x2 > rect.x) && $5ff29e9b920ad43b$export$197d934ee3c39f4d(y1, y2, rect) < rect.y + rect.height && $5ff29e9b920ad43b$export$29da78b220ab8d4d(y1, y2, rect) > rect.y;


/**
 * THE ORGANIC CAVE'S PLAN: where the rock is, which of it carries iron, and what is sealed inside it.
 *
 * The cave is solid basalt you dig through, not a carved maze: one arrival chamber round the landing, a ring of
 * bedrock round the edge, and everything else breakable rock. Inside the rock are SEALED POCKETS -- natural
 * grottos with crystals and still pools, invisible until a swing breaks into one; the deepest are the ember
 * cave's VOIDS (the armory, the armed dead) -- and ORE VEINS, wandering lines that tend to run toward a pocket,
 * so following a vein is how you find one. Each vein is one mineral, laid at the mining depth the ember mine
 * promises it (coal near, gold deep) and sized to pay the mine's minimum yields exactly: the ore you can see is
 * the ore that pays (organicMineRewards).
 *
 * Pure and seeded: the same (width, height, landing, seed) always plans the same cave. The server turns the plan
 * into rock tiles (organic_cave_service.ts); the client draws the rock from the `organicRock` layer it becomes
 * and reads the veins/crystals/pools from the room's `organicCave` property (rendering/impl/pixijs/rock_mass.ts).
 */ /** One character per cell of the `organicRock` layer. */ const $db27c988dce6c705$export$6aae37938a31c4be = {
    /** Open from the start: the arrival chamber. */ Open: "0",
    Rock: "1",
    /** Rock with iron in it (and below, the other ores). */ Iron: "2",
    /** The unbreakable ring round the edge. */ Bedrock: "3",
    /** Open from the start but sealed in the rock: a pocket's floor. */ Pocket: "4",
    /** The way home: unbreakable rock with an opening drawn in its face (the exit region sits in front of it). */ Mouth: "5",
    Coal: "6",
    Copper: "7",
    Silver: "8",
    Gold: "9"
};
const $db27c988dce6c705$export$aedc331e5473cecb = {
    coal: $db27c988dce6c705$export$6aae37938a31c4be.Coal,
    iron: $db27c988dce6c705$export$6aae37938a31c4be.Iron,
    copper: $db27c988dce6c705$export$6aae37938a31c4be.Copper,
    silver: $db27c988dce6c705$export$6aae37938a31c4be.Silver,
    gold: $db27c988dce6c705$export$6aae37938a31c4be.Gold
};
const $db27c988dce6c705$export$aca16b4355ea8af8 = (code)=>code === $db27c988dce6c705$export$6aae37938a31c4be.Coal ? "coal" : code === $db27c988dce6c705$export$6aae37938a31c4be.Iron ? "iron" : code === $db27c988dce6c705$export$6aae37938a31c4be.Copper ? "copper" : code === $db27c988dce6c705$export$6aae37938a31c4be.Silver ? "silver" : code === $db27c988dce6c705$export$6aae37938a31c4be.Gold ? "gold" : undefined;
const $db27c988dce6c705$export$c58ed4512dccfdc2 = "organicRock";
const $db27c988dce6c705$export$876746fef84dc8d2 = "organicCave";
const $db27c988dce6c705$export$8c5d5ba2f2e41b84 = (code)=>code === undefined || $db27c988dce6c705$export$7787969e753c67e2(code) || code === $db27c988dce6c705$export$6aae37938a31c4be.Bedrock || code === $db27c988dce6c705$export$6aae37938a31c4be.Mouth;
const $db27c988dce6c705$export$7787969e753c67e2 = (code)=>code === $db27c988dce6c705$export$6aae37938a31c4be.Rock || $db27c988dce6c705$export$aca16b4355ea8af8(code) !== undefined;
const $db27c988dce6c705$export$16c9140358b57444 = [
    {
        material: "coal",
        cells: 4,
        minDepth: 0,
        maxDepth: 1,
        entrance: true
    },
    {
        material: "gold",
        cells: 4,
        minDepth: 0.75,
        maxDepth: 1
    },
    {
        material: "silver",
        cells: 4,
        minDepth: 0.5,
        maxDepth: 1
    },
    {
        material: "copper",
        cells: 7,
        minDepth: 0.2,
        maxDepth: 0.8
    },
    {
        material: "iron",
        cells: 10,
        minDepth: 0.1,
        maxDepth: 0.65
    },
    {
        material: "coal",
        cells: 9,
        minDepth: 0.05,
        maxDepth: 0.45
    }
];
const $db27c988dce6c705$export$29c904cae41a138c = 2;
const $db27c988dce6c705$export$37b87167bb7514ba = 0.85;
const $db27c988dce6c705$export$a04c890ad28ef813 = 52;
const $db27c988dce6c705$var$seededRandom = (seed)=>{
    let h = 1779033703 ^ seed.length;
    for(let i = 0; i < seed.length; i++){
        h = Math.imul(h ^ seed.charCodeAt(i), 3432918353);
        h = h << 13 | h >>> 19;
    }
    let a = h >>> 0;
    return ()=>{
        a = a + 0x6d2b79f5 | 0;
        let t = Math.imul(a ^ a >>> 15, 1 | a);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
};
const $db27c988dce6c705$export$bcd9e57734e26fab = (px, py, line)=>{
    let best = Infinity;
    for(let i = 0; i + 1 < line.length; i++){
        const a = line[i], b = line[i + 1];
        const dx = b.x - a.x, dy = b.y - a.y;
        const len = dx * dx + dy * dy;
        const t = len ? Math.max(0, Math.min(1, ((px - a.x) * dx + (py - a.y) * dy) / len)) : 0;
        best = Math.min(best, Math.hypot(px - (a.x + t * dx), py - (a.y + t * dy)));
    }
    return best;
};
/** A blob of cells round (cx, cy): an ellipse whose radius wanders with the angle, so no two look alike. */ const $db27c988dce6c705$var$blob = (cx, cy, rx, ry, random)=>{
    const p1 = random() * Math.PI * 2, p2 = random() * Math.PI * 2;
    const a1 = 0.14 + random() * 0.12, a2 = 0.06 + random() * 0.08;
    const out = [];
    for(let y = Math.floor(cy - ry - 2); y <= Math.ceil(cy + ry + 2); y++)for(let x = Math.floor(cx - rx - 2); x <= Math.ceil(cx + rx + 2); x++){
        const dx = (x + 0.5 - cx) / rx, dy = (y + 0.5 - cy) / ry;
        const theta = Math.atan2(dy, dx);
        const reach = 1 + a1 * Math.sin(3 * theta + p1) + a2 * Math.sin(5 * theta + p2);
        if (Math.hypot(dx, dy) < reach) out.push({
            x: x,
            y: y
        });
    }
    return out;
};
const $db27c988dce6c705$export$f5816eb12d0e8478 = (width, height, landing, seed, mouth, voids = $db27c988dce6c705$export$29c904cae41a138c)=>{
    const random = $db27c988dce6c705$var$seededRandom(seed);
    const cells = Array.from({
        length: width
    }, (_, x)=>Array.from({
            length: height
        }, (_, y)=>x === 0 || y === 0 || x === width - 1 || y === height - 1 ? $db27c988dce6c705$export$6aae37938a31c4be.Bedrock : $db27c988dce6c705$export$6aae37938a31c4be.Rock));
    const inside = (x, y, pad = 1)=>x >= pad && y >= pad && x < width - pad && y < height - pad;
    const lx = Math.max(5, Math.min(width - 6, Math.floor(landing.x))), ly = Math.max(5, Math.min(height - 6, Math.floor(landing.y)));
    const centre = {
        x: lx + 0.5,
        y: ly + 0.5
    };
    // The arrival chamber: room to stand and swing in, its walls in every direction.
    for (const c of $db27c988dce6c705$var$blob(centre.x, centre.y, 4.4, 3.3, random))if (inside(c.x, c.y, 2)) cells[c.x][c.y] = $db27c988dce6c705$export$6aae37938a31c4be.Open;
    cells[lx][ly] = $db27c988dce6c705$export$6aae37938a31c4be.Open;
    if (mouth) {
        // The mouth sits in a wall: no chamber cut above or beside it.
        for(let y = 1; y <= mouth.y; y++)for(let x = mouth.x - 2; x <= mouth.x + 3; x++)if (inside(x, y, 1) && cells[x][y] === $db27c988dce6c705$export$6aae37938a31c4be.Open) cells[x][y] = $db27c988dce6c705$export$6aae37938a31c4be.Rock;
        // The mouth's face, and the ground in front of it that walks into the exit region.
        for (const dx of [
            0,
            1
        ]){
            if (!inside(mouth.x + dx, mouth.y, 1)) continue;
            cells[mouth.x + dx][mouth.y] = $db27c988dce6c705$export$6aae37938a31c4be.Mouth;
            for(let dy = 1; dy <= 2; dy++)if (inside(mouth.x + dx, mouth.y + dy, 1)) cells[mouth.x + dx][mouth.y + dy] = $db27c988dce6c705$export$6aae37938a31c4be.Open;
        }
    }
    // Sealed pockets, never touching the chamber or each other.
    const placed = [];
    const wanted = Math.max(voids + 1, Math.round(width * height / 450));
    for(let tries = 0; tries < 600 && placed.length < wanted; tries++){
        const r = 1.8 + random() * 1.5;
        const x = 3 + r + random() * (width - 6 - 2 * r), y = 3 + r + random() * (height - 6 - 2 * r);
        if (Math.hypot(x - centre.x, y - centre.y) < 9 + r) continue;
        if (placed.some((p)=>Math.hypot(p.x - x, p.y - y) < p.r + r + 3)) continue;
        const shape = $db27c988dce6c705$var$blob(x, y, r * (1.1 + random() * 0.3), r * (0.75 + random() * 0.2), random).filter((c)=>inside(c.x, c.y, 2));
        const sealed = shape.every((c)=>{
            for(let dy = -1; dy <= 1; dy++)for(let dx = -1; dx <= 1; dx++){
                const v = cells[c.x + dx]?.[c.y + dy];
                if (v === $db27c988dce6c705$export$6aae37938a31c4be.Open || v === $db27c988dce6c705$export$6aae37938a31c4be.Pocket) return false;
            }
            return true;
        });
        if (!sealed || shape.length < 9) continue;
        shape.forEach((c)=>cells[c.x][c.y] = $db27c988dce6c705$export$6aae37938a31c4be.Pocket);
        placed.push({
            x: x,
            y: y,
            r: r,
            cells: shape
        });
    }
    // Mining depth: blocks to break from the landing (open ground and pockets cost nothing), as the mine counts it.
    const depth = $db27c988dce6c705$var$miningDepths(cells, width, height, {
        x: lx,
        y: ly
    });
    const deepest = Math.max(1, ...depth.filter((d)=>d < Infinity));
    const depthOf = (x, y)=>depth[y * width + x];
    // The deepest pockets are the voids. A pocket's depth is the cheapest way into it.
    const pocketDepth = (p)=>Math.min(...p.cells.map((c)=>depthOf(c.x, c.y)));
    const pockets = placed.map((p)=>({
            x: p.x,
            y: p.y,
            cells: p.cells,
            void: false
        })).sort((a, b)=>pocketDepth(b) - pocketDepth(a));
    pockets.slice(0, voids).forEach((p)=>p.void = true);
    // Veins: each grows from a start in its depth band, drifting toward a pocket, claiming rock in band until it
    // holds its cells. A vein that cannot find room in its band is tried again from elsewhere.
    const veins = [];
    for (const spec of $db27c988dce6c705$export$16c9140358b57444){
        const code = $db27c988dce6c705$export$aedc331e5473cecb[spec.material];
        const inBand = (x, y)=>{
            const d = depthOf(x, y);
            if (!(d < Infinity) || cells[x][y] !== $db27c988dce6c705$export$6aae37938a31c4be.Rock) return false;
            if (spec.entrance) return d <= 3;
            return d / deepest >= spec.minDepth && d / deepest <= spec.maxDepth;
        };
        const starts = [];
        for(let y = 2; y < height - 2; y++)for(let x = 2; x < width - 2; x++)if (inBand(x, y)) starts.push({
            x: x,
            y: y
        });
        for(let attempt = 0; attempt < 24 && starts.length; attempt++){
            const s0 = starts[Math.floor(random() * starts.length)];
            const towards = pockets.length ? pockets[Math.floor(random() * pockets.length)] : {
                x: random() * width,
                y: random() * height
            };
            let p = {
                x: s0.x + 0.5,
                y: s0.y + 0.5
            };
            let heading = Math.atan2(towards.y - p.y, towards.x - p.x) + (random() - 0.5) * 1.2;
            const line = [
                p
            ];
            const claimed = [];
            const claim = (from, to)=>{
                for(let y = Math.floor(Math.min(from.y, to.y) - 1); y <= Math.ceil(Math.max(from.y, to.y) + 1); y++)for(let x = Math.floor(Math.min(from.x, to.x) - 1); x <= Math.ceil(Math.max(from.x, to.x) + 1); x++){
                    if (claimed.length >= spec.cells || !inside(x, y, 1) || !inBand(x, y)) continue;
                    if (claimed.some((c)=>c.x === x && c.y === y)) continue;
                    if ($db27c988dce6c705$export$bcd9e57734e26fab(x + 0.5, y + 0.5, [
                        from,
                        to
                    ]) < $db27c988dce6c705$export$37b87167bb7514ba) claimed.push({
                        x: x,
                        y: y
                    });
                }
            };
            claim(p, p);
            for(let step = 0; step < 40 && claimed.length < spec.cells; step++){
                heading += (random() - 0.5) * 0.8;
                const next = {
                    x: p.x + Math.cos(heading) * 1.1,
                    y: p.y + Math.sin(heading) * 1.1
                };
                if (!inside(Math.floor(next.x), Math.floor(next.y), 2)) {
                    heading += Math.PI / 2;
                    continue;
                }
                claim(p, next);
                line.push(next);
                p = next;
            }
            if (claimed.length < spec.cells) continue;
            claimed.forEach((c)=>cells[c.x][c.y] = code);
            veins.push({
                material: spec.material,
                points: line.map((q)=>({
                        x: Math.round(q.x * 100) / 100,
                        y: Math.round(q.y * 100) / 100
                    }))
            });
            break;
        }
    }
    // What a pocket holds: crystals along its back wall (always, in a void), a still pool in its middle.
    const crystals = [];
    const pools = [];
    pockets.forEach((pocket)=>{
        const backWall = pocket.cells.filter((c)=>cells[c.x][c.y - 1] !== $db27c988dce6c705$export$6aae37938a31c4be.Pocket);
        if ((pocket.void || random() < 0.6) && backWall.length) {
            const count = (pocket.void ? 2 : 1) + Math.floor(random() * Math.min(2, backWall.length));
            const used = new Set();
            for(let i = 0; i < count * 3 && used.size < count; i++){
                const c = backWall[Math.floor(random() * backWall.length)];
                if (used.has(c.x)) continue;
                used.add(c.x);
                crystals.push({
                    x: c.x + 0.3 + random() * 0.4,
                    y: c.y + 0.12,
                    scale: Math.round((0.6 + random() * 0.4) * 100) / 100
                });
            }
        }
        const middle = pocket.cells.filter((c)=>[
                [
                    1,
                    0
                ],
                [
                    -1,
                    0
                ],
                [
                    0,
                    1
                ],
                [
                    0,
                    -1
                ]
            ].every(([dx, dy])=>cells[c.x + dx]?.[c.y + dy] === $db27c988dce6c705$export$6aae37938a31c4be.Pocket) && cells[c.x][c.y - 1] === $db27c988dce6c705$export$6aae37938a31c4be.Pocket);
        if (!pocket.void && random() < 0.5 && middle.length) {
            const c = middle[Math.floor(random() * middle.length)];
            pools.push({
                x: c.x + 0.5,
                y: c.y + 0.5,
                rx: 0.65,
                ry: 0.27
            });
        }
    });
    return {
        width: width,
        height: height,
        cells: cells,
        landing: centre,
        pockets: pockets,
        faceHeight: $db27c988dce6c705$export$a04c890ad28ef813,
        veins: veins,
        crystals: crystals,
        pools: pools
    };
};
/**
 * Blocks to break from `start` to reach each cell (0-1 BFS: rock costs one, open ground and pockets nothing,
 * bedrock and the mouth are walls) -- the ember mine's own measure (mine_director computeMiningDepths).
 */ const $db27c988dce6c705$var$miningDepths = (cells, width, height, start)=>{
    const depth = new Array(width * height).fill(Infinity);
    const passable = (x, y)=>x >= 0 && y >= 0 && x < width && y < height && cells[x][y] !== $db27c988dce6c705$export$6aae37938a31c4be.Bedrock && cells[x][y] !== $db27c988dce6c705$export$6aae37938a31c4be.Mouth;
    const queue = [
        start.y * width + start.x
    ];
    depth[queue[0]] = 0;
    while(queue.length){
        const i = queue.shift();
        const x = i % width, y = Math.floor(i / width);
        for (const [dx, dy] of [
            [
                1,
                0
            ],
            [
                -1,
                0
            ],
            [
                0,
                1
            ],
            [
                0,
                -1
            ]
        ]){
            const nx = x + dx, ny = y + dy;
            if (!passable(nx, ny)) continue;
            const cost = $db27c988dce6c705$export$7787969e753c67e2(cells[nx][ny]) ? 1 : 0;
            const j = ny * width + nx, d = depth[i] + cost;
            if (d >= depth[j]) continue;
            depth[j] = d;
            if (cost) queue.push(j);
            else queue.unshift(j);
        }
    }
    return depth;
};
const $db27c988dce6c705$export$b55da97f777f57bf = (plan)=>{
    const rewards = {};
    for(let y = 0; y < plan.height; y++)for(let x = 0; x < plan.width; x++){
        const code = plan.cells[x][y];
        if (!$db27c988dce6c705$export$7787969e753c67e2(code)) continue;
        const material = $db27c988dce6c705$export$aca16b4355ea8af8(code);
        rewards[`${x},${y}`] = material ? {
            material: material,
            quantity: 1,
            seamId: `organic-${material}`
        } : null;
    }
    return rewards;
};


/** The drawn lip above an organic cave's wall face that the sightline should still reach. */ const $2f4c91f2e2ac27f6$var$ORGANIC_LIP = 6;
const $2f4c91f2e2ac27f6$export$31f783804ea72f93 = (tilemapMetaProvider, { insetWalls: insetWalls = false } = {})=>{
    const { isOcclusionAt: isOcclusionAt } = tilemapMetaProvider;
    let polyMap = [];
    polyMap[0] = polyMap[1] = polyMap[2] = polyMap[3] = {
        a: {
            x: 0,
            y: 0
        },
        b: {
            x: 0,
            y: 0
        }
    };
    const occlusionMap = (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(tilemapMetaProvider.width(), tilemapMetaProvider.height());
    const blockMap = (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(tilemapMetaProvider.width(), tilemapMetaProvider.height());
    for(let x = 0; x < tilemapMetaProvider.width(); x++)for(let y = 0; y < tilemapMetaProvider.height(); y++){
        occlusionMap[y][x] = isOcclusionAt(x, y) ? 1 : 0;
        blockMap[y][x] = occlusionMap[y][x] && (insetWalls || tilemapMetaProvider.getEntityTileAt(x, y)) ? 1 : 0;
    }
    const blockingAuto = (0, $5cfd87a852590fa6$export$19a7a8d2d9b0fbb7)(occlusionMap);
    // Outdoor blocks pull every exposed face back to the tile's midline so the near half of
    // the block stays lit.
    const inset = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 - 0.5;
    const blockBounds = (x, y)=>{
        if (!blockMap[y]?.[x]) return undefined;
        return {
            left: x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (blockMap[y][x - 1] ? 0 : inset),
            right: (x + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - (blockMap[y][x + 1] ? 0 : inset),
            top: y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (blockMap[y - 1]?.[x] ? 0 : inset),
            bottom: (y + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - (blockMap[y + 1]?.[x] ? 0 : inset)
        };
    };
    // A cave wall occludes along its DRAWN surface, not its square's boundary. The generated
    // cave's platform art lives in map5, and the variants listed in CaveArtSetBack* leave the
    // far half of their square transparent so the rock reads as a face with cave floor in
    // front of it. An occluder on the square's boundary makes the reveal light those
    // transparent pixels, and the wall reads as solid black however close you stand to it.
    // Which side is set back is a property of the ARTWORK, so it is read off the tile that
    // was actually placed -- a wall one square thin still uses a drawn-back edge tile, so it
    // cannot be inferred from the shape of the rock around it.
    const caveWalls = insetWalls ? tilemapMetaProvider.resolveTileMapFromLayerId("map5") : undefined;
    const terrain = insetWalls ? tilemapMetaProvider.getTilesetById("lpc-terrain") : undefined;
    const surfaceInset = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
    const caveArt = (x, y)=>{
        const gid = caveWalls?.[x]?.[y];
        // A deposit's sprite fills its whole square, so it is never set back.
        if (!gid || !terrain || tilemapMetaProvider.getEntityTileAt(x, y)) return undefined;
        return Number(gid) - terrain.firstGid;
    };
    // AN ORGANIC CAVE draws each wall face INSIDE the rock's own footprint: the bottom FACE_H px of every
    // run of rock above open ground (client rock_mass.ts). See organicOutline.
    const organic = insetWalls && !!tilemapMetaProvider.getOrganicRockLayer?.();
    if (organic) {
        const faceHeight = tilemapMetaProvider.getOrganicCave?.()?.faceHeight ?? (0, $db27c988dce6c705$export$a04c890ad28ef813);
        $2f4c91f2e2ac27f6$var$organicOutline(blockMap, tilemapMetaProvider.width(), tilemapMetaProvider.height(), faceHeight + $2f4c91f2e2ac27f6$var$ORGANIC_LIP - (0, $23e67fb1a742a4ea$export$96afdb68a4534bc1), polyMap);
        return {
            vectorLines: (0, $23e67fb1a742a4ea$export$86ea038b7dd84d57)(polyMap, 4),
            autotileMap: (0, $5cfd87a852590fa6$export$19a7a8d2d9b0fbb7)(occlusionMap)
        };
    }
    const caveBounds = (x, y)=>{
        if (!blockMap[y]?.[x]) return undefined;
        const art = caveArt(x, y);
        // Only a side fronting open ground is set back, so two neighboring occluders still
        // meet exactly on the side they share and the outline around the rock stays closed.
        // No variant is set back on BOTH its left and its right, so an occluder is always at
        // least half a tile across -- which is what the first version of this got wrong. It
        // set back all four faces, so an exposed square shrank to a one-pixel speck that a
        // steep ray sailed straight past, and once a ray was inside the rock nothing stopped
        // it (interior squares have no faces at all): it tunnelled through the whole mass and
        // lit the floor far beyond as a long wedge.
        const back = (open, setBack)=>open && art !== undefined && setBack.has(art) ? surfaceInset : 0;
        const openAt = (atX, atY)=>!blockMap[atY]?.[atX];
        return {
            left: x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + back(openAt(x - 1, y), (0, $5ff29e9b920ad43b$export$4a8503c515ddb75)),
            right: (x + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - back(openAt(x + 1, y), (0, $5ff29e9b920ad43b$export$8af65a70f4144267)),
            top: y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + back(openAt(x, y - 1), (0, $5ff29e9b920ad43b$export$1bb592e1e2038ca8)),
            bottom: (y + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
        };
    };
    const face = (from, to, at, horizontal)=>polyMap.push(horizontal ? {
            a: {
                x: from,
                y: at
            },
            b: {
                x: to,
                y: at
            }
        } : {
            a: {
                x: at,
                y: from
            },
            b: {
                x: at,
                y: to
            }
        });
    const outline = (from, to, at, horizontal, neighborFrom, neighborTo)=>{
        const add = (start, end)=>{
            if (end <= start) return;
            face(start, end, at, horizontal);
        };
        if (neighborFrom === undefined) add(from, to);
        else {
            // Remove the shared part only. The remaining spans close concave corners.
            add(from, Math.min(to, neighborFrom));
            add(Math.max(from, neighborTo), to);
        }
    };
    const evaluteAutotile = (x, y, autoId)=>{
        const polyMap = [];
        const o = {
            x: x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
            y: y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
        };
        const offset = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
        if (autoId === 18) {
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                },
                b: {
                    x: o.x + offset,
                    y: o.y + offset
                }
            });
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + offset
                },
                b: {
                    x: o.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: o.y + offset
                }
            });
        }
        if (autoId === 8) polyMap.push({
            a: {
                x: o.x,
                y: o.y - offset + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            },
            b: {
                x: o.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                y: o.y - offset + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            }
        });
        if (autoId === 14) polyMap.push({
            a: {
                x: o.x + offset,
                y: o.y
            },
            b: {
                x: o.x + offset,
                y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            }
        });
        if (autoId === 15) {
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                },
                b: {
                    x: o.x + offset,
                    y: o.y + offset
                }
            });
            polyMap.push({
                a: {
                    x: o.x - offset,
                    y: o.y + offset
                },
                b: {
                    x: o.x + offset,
                    y: o.y + offset
                }
            });
        }
        if (autoId === 6) {
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y - offset
                },
                b: {
                    x: o.x + offset,
                    y: o.y + offset
                }
            });
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + offset
                },
                b: {
                    x: o.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: o.y + offset
                }
            });
        }
        if (autoId === 3) {
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y - offset
                },
                b: {
                    x: o.x + offset,
                    y: o.y + offset
                }
            });
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + offset
                },
                b: {
                    x: o.x - offset,
                    y: o.y + offset
                }
            });
        }
        if (autoId === 5) polyMap.push({
            a: {
                x: o.x + offset,
                y: o.y + offset
            },
            b: {
                x: o.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                y: o.y + offset
            }
        });
        if (autoId === 2) polyMap.push({
            a: {
                x: o.x - offset,
                y: o.y + offset
            },
            b: {
                x: o.x + offset,
                y: o.y + offset
            }
        });
        if (autoId === 13) polyMap.push({
            a: {
                x: o.x + offset,
                y: o.y
            },
            b: {
                x: o.x + offset,
                y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            }
        });
        if (autoId === 1) polyMap.push({
            a: {
                x: o.x + offset,
                y: o.y
            },
            b: {
                x: o.x + offset,
                y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            }
        });
        if (autoId === 19) {
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y
                },
                b: {
                    x: o.x + offset,
                    y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                }
            });
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + offset
                },
                b: {
                    x: o.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: o.y + offset
                }
            });
        }
        if (autoId === 21) {
            polyMap.push({
                a: {
                    x: o.x + offset,
                    y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                },
                b: {
                    x: o.x + offset,
                    y: o.y + offset
                }
            });
            polyMap.push({
                a: {
                    x: o.x - offset,
                    y: o.y + offset
                },
                b: {
                    x: o.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: o.y + offset
                }
            });
        }
        // Every other shape -- a T opening west (N, W, S) or north (W, N, E), a cross, the variants
        // with filled corners -- had NO occluder at all, so sight passed straight through the cell:
        // where a room's partition met its outer wall, the room saw out past the corner. Run a midline
        // from the centre to each side with a wall beyond it; the neighbour's own midline meets it there.
        if (!polyMap.length) {
            const sum = (0, $a1574d49bcae8132$export$65ef21f6c2d0a519)(autoId) ?? 0;
            const centre = {
                x: o.x + offset,
                y: o.y + offset
            };
            if (sum & (0, $a1574d49bcae8132$export$a07804094c3ecf2d)) polyMap.push({
                a: centre,
                b: {
                    x: centre.x,
                    y: o.y
                }
            });
            if (sum & (0, $a1574d49bcae8132$export$25ce5a424b770e84)) polyMap.push({
                a: centre,
                b: {
                    x: centre.x,
                    y: o.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                }
            });
            if (sum & (0, $a1574d49bcae8132$export$71cec2538cb2c617)) polyMap.push({
                a: centre,
                b: {
                    x: o.x,
                    y: centre.y
                }
            });
            if (sum & (0, $a1574d49bcae8132$export$a9c23c6ac3fc3eca)) polyMap.push({
                a: centre,
                b: {
                    x: o.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: centre.y
                }
            });
        }
        return polyMap;
    };
    for(let x = 0; x < tilemapMetaProvider.width(); x++)for(let y = 0; y < tilemapMetaProvider.height(); y++){
        if (blockMap[y][x]) {
            // Trace the outline of the solid region, dropping the span each face shares
            // with its neighbor. Because neighboring bounds always meet exactly on a
            // shared side, what is left is a closed curve: no sightline can get inside it.
            const bounds = insetWalls ? caveBounds : blockBounds;
            const { left: left, right: right, top: top, bottom: bottom } = bounds(x, y);
            const above = bounds(x, y - 1);
            const below = bounds(x, y + 1);
            const west = bounds(x - 1, y);
            const east = bounds(x + 1, y);
            outline(left, right, top, true, above?.left, above?.right);
            outline(left, right, bottom, true, below?.left, below?.right);
            outline(top, bottom, left, false, west?.top, west?.bottom);
            outline(top, bottom, right, false, east?.top, east?.bottom);
            if (insetWalls) continue;
            // Outdoor blocks are set back on every side, so two touching diagonally leave
            // a slit between their cores through which rays escape. Bridge it, visiting
            // only eastward joins so each bridge is emitted once.
            if (!east && !above) {
                const northeast = blockBounds(x + 1, y - 1);
                if (northeast) polyMap.push({
                    a: {
                        x: right,
                        y: top
                    },
                    b: {
                        x: northeast.left,
                        y: northeast.bottom
                    }
                });
            }
            if (!east && !below) {
                const southeast = blockBounds(x + 1, y + 1);
                if (southeast) polyMap.push({
                    a: {
                        x: right,
                        y: bottom
                    },
                    b: {
                        x: southeast.left,
                        y: southeast.top
                    }
                });
            }
            continue;
        }
        const autoId = blockingAuto[y][x];
        if (autoId) polyMap = polyMap.concat(evaluteAutotile(x, y, autoId));
    }
    return {
        // One straight wall arrives above as one face per tile it spans, and neighbouring faces
        // overlap. Joining them is free -- the join between two collinear faces is never a
        // silhouette corner -- and it is the difference between a few hundred occluders and a few
        // dozen, which every sightline then pays for twice over (one ray target, one hit test per
        // ray). Slots 0-3 are the view boundary, which callers overwrite by index.
        vectorLines: (0, $23e67fb1a742a4ea$export$86ea038b7dd84d57)(polyMap, 4),
        autotileMap: blockingAuto
    };
};
const $2f4c91f2e2ac27f6$export$57242d3f2812734b = (roomId, json, regionClass = [
    "REGION"
])=>{
    const { layers: layers } = json;
    const objectLayer = layers.find((layer)=>layer.name === "objects");
    if (!objectLayer) return {};
    return objectLayer.objects.filter((object)=>regionClass.includes(object.class)).reduce((acc, meta)=>{
        return {
            ...acc,
            [meta.name]: [
                ...acc[meta.name] || [],
                {
                    locationId: meta.name,
                    roomId: roomId,
                    x: Math.floor(meta.x),
                    y: Math.floor(meta.y),
                    bounds: new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(Math.floor(meta.x), Math.floor(meta.y), Math.floor(meta.x) + meta.width, Math.floor(meta.y) + meta.height),
                    context: (meta.properties || []).reduce((acc, next)=>({
                            ...acc,
                            [next.name]: next.value
                        }), {})
                }
            ]
        };
    }, {});
};
const $2f4c91f2e2ac27f6$export$8fcfa3699d7f98f4 = (roomId, json, regionClass = "REGION")=>{
    const regions = Object.values($2f4c91f2e2ac27f6$export$57242d3f2812734b(roomId, json, [
        "BIOMEREGION"
    ])).flat();
    return regions.reduce((acc, next)=>{
        return {
            ...acc,
            [next.context.biome]: [
                ...acc[next.context.biome] || [],
                next
            ]
        };
    }, {});
};
/**
 * An organic cave's occluders, one run of rock per column at a time.
 *
 * Its wall face is the bottom FACE_H px of the run (drawn inside the rock's own footprint, foot on the
 * collision line) and can be taller than a cell. A south side flush on the square would leave all but the
 * reveal of that face in shadow, so each run occludes only from its north edge down to `reach` px above its
 * south edge -- the reveal then lights exactly the face and its lip -- and never less than a pixel, so a wall
 * thinner than its face still blocks what is behind it. The band of face below is closed wherever it fronts
 * open ground, and wherever it meets a neighbouring column's occluder at a different height, so a sightline can
 * enter it only from the floor in front of the face and never slip under a thin wall into the space beside it.
 */ const $2f4c91f2e2ac27f6$var$organicOutline = (blockMap, width, height, reach, polyMap)=>{
    const T = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const occBottom = Array.from({
        length: height
    }, ()=>new Array(width).fill(0));
    const add = (a, b)=>{
        if (a.x !== b.x || a.y !== b.y) polyMap.push({
            a: a,
            b: b
        });
    };
    for(let x = 0; x < width; x++)for(let y = 0; y < height; y++){
        if (!blockMap[y]?.[x] || blockMap[y - 1]?.[x]) continue;
        let ys = y;
        while(blockMap[ys + 1]?.[x])ys++;
        const bottom = Math.max(y * T + 1, (ys + 1) * T - reach);
        for(let k = y; k <= ys; k++)occBottom[k][x] = bottom;
        add({
            x: x * T,
            y: y * T
        }, {
            x: (x + 1) * T,
            y: y * T
        }) // the run's north edge
        ;
        add({
            x: x * T,
            y: bottom
        }, {
            x: (x + 1) * T,
            y: bottom
        }) // where its face begins
        ;
    }
    for(let x = 0; x <= width; x++)for(let y = 0; y < height; y++){
        const a = !!blockMap[y]?.[x - 1], b = !!blockMap[y]?.[x];
        if (a === b && !a) continue;
        if (a !== b) {
            add({
                x: x * T,
                y: y * T
            }, {
                x: x * T,
                y: (y + 1) * T
            }) // rock beside open ground
            ;
            continue;
        }
        // Rock on both sides: close the rows where one column occludes and the other is face band.
        const clamp = (v)=>Math.max(y * T, Math.min((y + 1) * T, v));
        const ea = clamp(occBottom[y][x - 1]), eb = clamp(occBottom[y][x]);
        if (ea !== eb) add({
            x: x * T,
            y: Math.min(ea, eb)
        }, {
            x: x * T,
            y: Math.max(ea, eb)
        });
    }
};


const $2db7e29a401f47a7$export$8eb3560959709dcf = "map3";
const $2db7e29a401f47a7$export$89f24ee63398b793 = {
    "bonecaller-stones": {
        tilesetId: "bonecaller-stones",
        firstgid: 104000
    },
    "lpc-terrain": {
        tilesetId: "lpc-terrain",
        firstgid: 1000
    },
    plants: {
        tilesetId: "plants",
        firstgid: 3000
    },
    "lpc-flowers-plants-fungi-wood": {
        tilesetId: "lpc-flowers-plants-fungi-wood",
        firstgid: 5000
    },
    "mountains-v6": {
        tilesetId: "mountains-v6",
        firstgid: 7000
    },
    ore: {
        tilesetId: "ore",
        firstgid: 10000
    },
    "jungle-ruins": {
        tilesetId: "jungle-ruins",
        firstgid: 12000
    },
    build_atlas: {
        tilesetId: "build_atlas",
        firstgid: 14000
    },
    "decorations-medieval": {
        tilesetId: "decorations-medieval",
        firstgid: 16000
    },
    roofs: {
        tilesetId: "roofs",
        firstgid: 19000
    },
    cottage: {
        tilesetId: "cottage",
        firstgid: 24000
    },
    walls: {
        tilesetId: "walls",
        firstgid: 34000
    },
    fence_medieval: {
        tilesetId: "fence_medieval",
        firstgid: 44000
    },
    container: {
        tilesetId: "container",
        firstgid: 54000
    },
    "furniture-blonde-wood": {
        tilesetId: "furniture-blonde-wood",
        firstgid: 64000
    },
    "beach-desert": {
        tilesetId: "beach-desert",
        firstgid: 74000
    },
    floors: {
        tilesetId: "floors",
        firstgid: 84000
    },
    walls2: {
        tilesetId: "walls2",
        firstgid: 94000
    },
    // Registered ONCE by hand: the sheet Sprite Lab saves drafted terrain autotiles into (art in free
    // cells, a definition in content/game/maps/autotiles.json). Saving one never edits this table.
    // Clear of every range above, including mountains-v6's (7000 + 5120 tiles runs past ore and
    // jungle-ruins); tileset_gid_ranges.test.ts keeps it that way.
    "authored-terrain": {
        tilesetId: "authored-terrain",
        firstgid: 114000
    },
    "forest-grass": {
        tilesetId: "forest-grass",
        firstgid: 116000
    },
    // The ember dirt (forest_dirt_ground.ts): clear of forest-grass's 4096 tiles from 116000.
    "forest-dirt": {
        tilesetId: "forest-dirt",
        firstgid: 121000
    }
};
const $2db7e29a401f47a7$export$bf11c92109ea6096 = (0, $4d955fa5af64f75a$export$5558f7940f25cdb7)();
const $2db7e29a401f47a7$export$8ac3ec24b9478bb2 = (0, $4d955fa5af64f75a$export$1ed5e50b752234eb)();
class $2db7e29a401f47a7$var$MapLayerSpec {
    constructor(mapId, mapNumber, mapSizeX, mapSizeY){
        this.blank = true;
        this.autoTiles = new Map();
        this.toRowsWiseArray = (tile)=>{
            const rows = [];
            for(let y = 0; y < this.mapSizeY; y++){
                const row = [];
                rows.push(row);
                for(let x = 0; x < this.mapSizeX; x++){
                    const column = this.columns[x];
                    if (column) row.push(column[y] === tile ? 1 : 0);
                    else row.push(0);
                }
            }
            return rows;
        };
        this.toArray = ()=>{
            const array = [];
            for(let y = 0; y < this.mapSizeY; y++)for(let x = 0; x < this.mapSizeX; x++){
                const column = this.columns[x];
                if (column) array.push(column[y]);
            }
            return array;
        };
        this.get = (x, y)=>{
            const column = this.columns[x];
            if (column) return column[y] || 0;
            return 0;
        };
        this.set = (x, y, tile)=>{
            const column = this.columns[x];
            if (column) {
                column[y] = tile;
                return true;
            }
        };
        this.layerId = mapId;
        this.layerNumber = mapNumber;
        this.mapSizeX = mapSizeX;
        this.mapSizeY = mapSizeY;
        this.columns = (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(mapSizeX, mapSizeY, 0);
    }
}
const $2db7e29a401f47a7$export$374a4bb324ec5c8 = {
    tilesetId: "lpc-terrain",
    tilePos: 121
};
/**
 * Offline generators stage the rooms and world metadata they build in this directory; the tools
 * then publish them into content through a reviewed transaction. Nothing writes shipped rooms
 * directly, so a runtime builder must use writeTarget "data" or "none".
 */ let $2db7e29a401f47a7$var$generatedMapOutput;
const $2db7e29a401f47a7$export$1bfc6cbd8d3e6a94 = (directory)=>{
    $2db7e29a401f47a7$var$generatedMapOutput = directory;
};
const $2db7e29a401f47a7$var$stagedMapPath = (relative)=>{
    if (!$2db7e29a401f47a7$var$generatedMapOutput) throw new Error(`Generated maps are staged by the content tools; call setGeneratedMapOutput before writing ${relative}`);
    return `${$2db7e29a401f47a7$var$generatedMapOutput}/${relative}`;
};
const $2db7e29a401f47a7$export$88e20c7c15a4abb = (tilesetId)=>{
    const tileset = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.maps.tilesets.find((t)=>t.id === tilesetId);
    if (!tileset) throw new Error(`Unknown tileset ${tilesetId}`);
    return `../tilesets/${tileset.file.split("/").pop()}`;
};
class $2db7e29a401f47a7$export$2ca8f2f4218485cb {
    get featureCatalogs() {
        return (0, $adc2b7d4f0244689$export$cfd1f8c409da7c62).instance();
    }
    /**
     * Create a basic set of layers for a room (map1-6, sprite, blocking)
     */ static createBasicLayers(mapSizeX, mapSizeY) {
        const layers = {};
        // Create map layers (map1-6)
        for(let i = 1; i <= 6; i++)layers[`map${i}`] = new $2db7e29a401f47a7$var$MapLayerSpec(`map${i}`, i, mapSizeX, mapSizeY);
        // Create sprite layer
        const sprite = new $2db7e29a401f47a7$var$MapLayerSpec(`sprite`, 7, mapSizeX, mapSizeY);
        sprite.sprite = true;
        layers.sprite = sprite;
        // Create blocking layer
        const blocking = new $2db7e29a401f47a7$var$MapLayerSpec(`blocking`, 8, mapSizeX, mapSizeY);
        blocking.blocking = true;
        layers.blocking = blocking;
        return layers;
    }
    /**
     * Create a complete set of layers including sky, occlusion, etc.
     */ static createFullLayers(mapSizeX, mapSizeY) {
        const subMapCount = 6;
        const sky3 = new $2db7e29a401f47a7$var$MapLayerSpec(`sky3`, subMapCount + 9, mapSizeX, mapSizeY);
        sky3.sky = true;
        const sky2 = new $2db7e29a401f47a7$var$MapLayerSpec(`sky2`, subMapCount + 8, mapSizeX, mapSizeY);
        sky2.sky = true;
        const sky = new $2db7e29a401f47a7$var$MapLayerSpec(`sky`, subMapCount + 7, mapSizeX, mapSizeY);
        sky.sky = true;
        const skyTrigger = new $2db7e29a401f47a7$var$MapLayerSpec(`skyTrigger`, subMapCount + 6, mapSizeX, mapSizeY);
        skyTrigger.skyTrigger = true;
        const occlusion = new $2db7e29a401f47a7$var$MapLayerSpec(`occlusion`, subMapCount + 5, mapSizeX, mapSizeY);
        occlusion.occlusion = true;
        const blocking = new $2db7e29a401f47a7$var$MapLayerSpec(`blocking`, subMapCount + 4, mapSizeX, mapSizeY);
        blocking.blocking = true;
        const sprite3 = new $2db7e29a401f47a7$var$MapLayerSpec(`sprite3`, subMapCount + 3, mapSizeX, mapSizeY);
        sprite3.sprite = true;
        const sprite2 = new $2db7e29a401f47a7$var$MapLayerSpec(`sprite2`, subMapCount + 2, mapSizeX, mapSizeY);
        sprite2.sprite = true;
        const sprite = new $2db7e29a401f47a7$var$MapLayerSpec(`sprite`, subMapCount + 1, mapSizeX, mapSizeY);
        sprite.sprite = true;
        const layers = {
            sky: sky,
            sky2: sky2,
            sky3: sky3,
            skyTrigger: skyTrigger,
            occlusion: occlusion,
            blocking: blocking,
            sprite: sprite,
            sprite2: sprite2,
            sprite3: sprite3
        };
        for(let i = 1; i <= subMapCount; i++)layers[`map${i}`] = new $2db7e29a401f47a7$var$MapLayerSpec(`map${i}`, i, mapSizeX, mapSizeY);
        return layers;
    }
    /**
     * Create a blank room with specified dimensions and layer configuration
     */ static createBlankRoom(roomId, mapX, mapY, mapSizeX, mapSizeY, useFullLayers = true) {
        const layers = useFullLayers ? $2db7e29a401f47a7$export$2ca8f2f4218485cb.createFullLayers(mapSizeX, mapSizeY) : $2db7e29a401f47a7$export$2ca8f2f4218485cb.createBasicLayers(mapSizeX, mapSizeY);
        return {
            mapX: mapX,
            mapY: mapY,
            mapSizeX: mapSizeX,
            mapSizeY: mapSizeY,
            roomId: roomId,
            layers: layers,
            fineBiomes: (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(mapSizeX, mapSizeY, "")
        };
    }
    constructor(props){
        this.maps = {};
        this.objectId = 1;
        this.regionId = 1;
        this.objectSequenceId = 1;
        this.deferredMapEntries = [];
        this.finalizationEntries = [];
        this.featureEntries = [];
        this.pctChance = (pct)=>{
            // min and max included
            return (0, $a80d0b17b615d6f7$export$c45e8adbbf82647d)(0, 100) >= 100 - pct;
        };
        this.randomIntBetween = (min, max)=>(0, $a80d0b17b615d6f7$export$c45e8adbbf82647d)(min, max);
        this.random = ()=>(0, $a80d0b17b615d6f7$export$2b048c255d2e69f3)();
        this.randomOneOf = (list, options)=>{
            return (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(list, {
                ...options ? {} : options,
                randomIntBetween: this.randomIntBetween
            });
        };
        this.randomFloatBetween = (min, max)=>{
            const str = (this.random() * (max - min) + min).toFixed(3);
            return parseFloat(str);
        };
        this.randomCoordinateWithinBounds = (bounds)=>{
            return (0, $a80d0b17b615d6f7$export$b1a407392a6eb119)(bounds, true);
        };
        this.getGlobal = (gX, gY, layerId, tilesetId)=>{
            const layer = this.getGlobalLayerFor(gX, gY, layerId);
            if (!layer) return 0;
            const x = gX % this.mapSize;
            const y = gY % this.mapSize;
            const absoluteTilePos = layer.get(x, y);
            if (tilesetId) {
                const tileset = $2db7e29a401f47a7$export$89f24ee63398b793[tilesetId];
                if (tileset) return absoluteTilePos - tileset.firstgid;
            }
            return absoluteTilePos;
        };
        this.setGlobal = (gX, gY, layerId, tile)=>{
            const layer = this.getGlobalLayerFor(gX, gY, layerId);
            if (!layer) return;
            const x = gX % this.mapSize;
            const y = gY % this.mapSize;
            return layer.set(x, y, tile);
        };
        this.getGlobalLayerFor = (gX, gY, layerId)=>{
            const roomId = `${this.roomPrefix}-${Math.floor(gX / this.mapSize)}-${Math.floor(gY / this.mapSize)}`;
            const map = this.maps[roomId];
            if (!map) return;
            return map.layers[layerId];
        };
        // random mountain
        this.scanPoint = (biome, gX, gY)=>{
            const bX = this.biomeMap[gX];
            const bY = bX ? bX[gY] : undefined;
            if (bY && bY.name === biome) return true;
            return false;
        };
        this.applyEntries = (mapEntries = [], roomMetas)=>{
            const meetsContainment = (x, y, containmentBiome, containmentRange)=>{
                let contained = true;
                const stride = containmentRange;
                for(let sY = -stride; sY <= stride; sY++){
                    for(let sX = -stride; sX <= stride; sX++)if (!this.scanPoint(containmentBiome, sX + x, sY + y)) {
                        contained = false;
                        break;
                    }
                    if (!contained) break;
                }
                return contained;
            };
            mapEntries.forEach((entry)=>{
                const { tileSpec: tileSpec, layerId: layerId, x: x, y: y, containmentBiome: containmentBiome, containmentRange: containmentRange, forcedContainmentOk: forcedContainmentOk, replacer: replacer, adder: adder, feature: feature } = entry;
                if (tileSpec.tilePos < 0) {
                    // remove
                    const mapLayer = this.globalMap.layers[layerId];
                    mapLayer.set(x, y, 0);
                    this.setGlobal(x, y, layerId, 0);
                } else if (feature) {
                    const needsContainment = !!containmentBiome && !!containmentRange;
                    const contained = forcedContainmentOk || !needsContainment || meetsContainment(x, y, containmentBiome, containmentRange);
                    if (contained) feature();
                } else if (replacer) {
                    // replace
                    const firstgid = $2db7e29a401f47a7$export$89f24ee63398b793[tileSpec.tilesetId].firstgid;
                    const mapLayer = this.globalMap.layers[layerId];
                    const absoluteTilePos = mapLayer.get(x, y);
                    const currentTilePos = absoluteTilePos - firstgid;
                    const needsContainment = !!containmentBiome && !!containmentRange;
                    const contained = !needsContainment || meetsContainment(x, y, containmentBiome, containmentRange);
                    if (contained) {
                        const updatedTileSpec = replacer(currentTilePos);
                        if (updatedTileSpec !== undefined) {
                            const replacementFirstgid = $2db7e29a401f47a7$export$89f24ee63398b793[updatedTileSpec.tilesetId].firstgid;
                            const updatedTileId = replacementFirstgid + updatedTileSpec.tilePos;
                            mapLayer.set(x, y, updatedTileId);
                            this.setGlobal(x, y, layerId, updatedTileId);
                        }
                    }
                } else if (adder) {
                    /// add
                    const firstgid = $2db7e29a401f47a7$export$89f24ee63398b793[tileSpec.tilesetId].firstgid;
                    const mapLayer = this.globalMap.layers[layerId];
                    const absoluteTilePos = mapLayer.get(x, y);
                    const currentTilePos = absoluteTilePos - firstgid;
                    const needsContainment = !!containmentBiome && !!containmentRange;
                    const contained = forcedContainmentOk || !needsContainment || meetsContainment(x, y, containmentBiome, containmentRange);
                    if (contained) {
                        const { tiles: addedTileSpecs, featureRegionMeta: featureRegionMeta, pointMeta: pointMeta } = adder(currentTilePos, entry.mapId, x, y) || {
                            tiles: []
                        };
                        if (pointMeta && roomMetas) {
                            const roomMeta = roomMetas.get(entry.mapId);
                            pointMeta.forEach((point)=>{
                                roomMeta.featurePoints.push(point);
                            });
                        }
                        if (featureRegionMeta && roomMetas) {
                            const roomMeta = roomMetas.get(entry.mapId);
                            featureRegionMeta.forEach((regionMeta)=>{
                                const found = roomMeta.features.find((n)=>n.region.x === regionMeta.x && n.region.y === regionMeta.y);
                                if (found) return;
                                const region = this.toFeatureRegion(regionMeta.x, regionMeta.y, regionMeta.width, regionMeta.height, regionMeta.id || (0, $a80d0b17b615d6f7$export$5e699d18035b41af)(), regionMeta.context);
                                const feature = {
                                    roomId: entry.mapId,
                                    spawnLocation: {
                                        x: regionMeta.x,
                                        y: regionMeta.y
                                    },
                                    type: "feature",
                                    region: region,
                                    bounds: new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(regionMeta.x, regionMeta.y, regionMeta.x + regionMeta.width, regionMeta.y + regionMeta.height),
                                    featureSpriteMeta: [],
                                    subFeaturesMeta: [],
                                    subFeaturesRegions: [],
                                    featurePoints: [],
                                    postFeatureMapEntries: [],
                                    mapFeature: regionMeta.mapFeature
                                };
                                roomMeta.features.push(feature);
                            });
                        }
                        addedTileSpecs.forEach((addedTileSpec)=>{
                            const addedTileContainmentBiome = addedTileSpec.containmentBiome || containmentBiome;
                            const addedContaimentRange = addedTileSpec.containmentRange || containmentRange;
                            const addedTileX = addedTileSpec?.x || x;
                            const addedTileY = addedTileSpec?.y || y;
                            const addedNeedsContainment = !!addedTileContainmentBiome && !!addedContaimentRange;
                            const addedContained = !addedNeedsContainment || meetsContainment(addedTileX, addedTileY, addedTileContainmentBiome, addedContaimentRange);
                            if (addedContained) {
                                const replacementFirstgid = $2db7e29a401f47a7$export$89f24ee63398b793[addedTileSpec.tilesetId].firstgid;
                                const updatedTileId = replacementFirstgid + addedTileSpec.tilePos;
                                const updatedTileMapLayer = this.globalMap.layers[addedTileSpec.mapLayerId];
                                const current = updatedTileMapLayer.get(addedTileX, addedTileY);
                                if (addedTileSpec.overwrite || !current) {
                                    if (addedTileSpec.tilePos < 1) {
                                        // remove
                                        updatedTileMapLayer.set(addedTileX, addedTileY, 0);
                                        this.setGlobal(addedTileX, addedTileY, addedTileSpec.mapLayerId, 0);
                                    } else {
                                        updatedTileMapLayer.set(addedTileX, addedTileY, updatedTileId);
                                        this.setGlobal(addedTileX, addedTileY, addedTileSpec.mapLayerId, updatedTileId);
                                    }
                                }
                            }
                        });
                    }
                } else {
                    // set
                    const firstgid = $2db7e29a401f47a7$export$89f24ee63398b793[tileSpec.tilesetId].firstgid;
                    const tileId = firstgid + tileSpec.tilePos;
                    const needsContainment = !!containmentBiome && !!containmentRange;
                    const contained = !needsContainment || meetsContainment(x, y, containmentBiome, containmentRange);
                    if (contained) {
                        const mapLayer = this.globalMap.layers[layerId];
                        mapLayer.set(x, y, tileId);
                        if (tileSpec.autotileMap) mapLayer.autoTiles.set(tileId, tileSpec.autotileMap);
                        this.setGlobal(x, y, layerId, tileId);
                        this.getGlobalLayerFor(x, y, layerId)?.autoTiles.set(tileId, tileSpec.autotileMap);
                    }
                }
            });
        };
        this.applyAutotiling = (mapSpec, callback)=>{
            const s = new Set();
            for (let tileId of mapSpec.autoTiles.keys()){
                const autoTileSpec = mapSpec.autoTiles.get(tileId);
                const rowsWise = mapSpec.toRowsWiseArray(tileId);
                const autoTiled = (0, $5cfd87a852590fa6$export$19a7a8d2d9b0fbb7)(rowsWise);
                for(let y = 0; y < mapSpec.mapSizeY; y++){
                    const row = autoTiled[y];
                    for(let x = 0; x < mapSpec.mapSizeX; x++){
                        const colValue = row[x];
                        // The per-cell decision is shared with Sprite Lab's preview: autotile_library.ts.
                        const decision = (0, $4d955fa5af64f75a$export$e68e86a23ef1145c)(autoTileSpec, mapSpec.layerId, mapSpec.layerNumber, colValue, {
                            x: x,
                            y: y
                        });
                        if (decision.kind === "mapped") {
                            callback(x, y, decision.tilesetId, decision.variant, decision.variantPos, decision.layerUpNumber, decision.layerUpId);
                            continue;
                        }
                        if (autoTileSpec.tilePos === 353) s.add(colValue);
                        if (decision.kind !== "skip") {
                            // record
                            const tilesetId = autoTileSpec.tilesetId;
                            const tileset = $2db7e29a401f47a7$export$89f24ee63398b793[tilesetId];
                            console.log("miss", tilesetId, tileId - tileset.firstgid, (0, $a80d0b17b615d6f7$export$f4f894b5dc700a2d)(x, y, this.mapSize, this.mapSize), `global ${x}, ${y}`, colValue);
                            // map1 draws the fallback; any other layer is handed -1, which erases the cell.
                            callback(x, y, decision.tilesetId, decision.variant, decision.variantPos, decision.layerUpNumber, decision.layerUpId);
                        }
                    }
                }
            }
            if (s.size > 0) console.log("missing", s);
        };
        this.toTiledLayer = (mapSpec)=>{
            const campaigns = (this.globalMapProperties.campaigns || []).map((campaign)=>({
                    name: `campaign:${campaign}`,
                    type: "string",
                    value: ""
                }));
            const tiled = {
                data: mapSpec.toArray(),
                height: mapSpec.mapSizeY,
                id: mapSpec.layerNumber,
                name: mapSpec.layerId,
                opacity: mapSpec.blocking || mapSpec.occlusion ? 0.175 : 1,
                properties: [
                    mapSpec.blocking ? {
                        name: "blocking",
                        type: "boolean",
                        value: true
                    } : undefined,
                    mapSpec.sky ? {
                        name: "sky",
                        type: "boolean",
                        value: true
                    } : undefined,
                    mapSpec.skyTrigger ? {
                        name: "skyTrigger",
                        type: "boolean",
                        value: true
                    } : undefined,
                    mapSpec.sprite ? {
                        name: "sprite",
                        type: "boolean",
                        value: true
                    } : undefined,
                    mapSpec.layerId === $2db7e29a401f47a7$export$8eb3560959709dcf ? {
                        name: "entityTileSurface",
                        type: "boolean",
                        value: true
                    } : undefined,
                    mapSpec.layerId === "map1" ? {
                        name: "campaign:encounters",
                        type: "string",
                        value: ""
                    } : undefined,
                    mapSpec.layerId === "map1" ? {
                        name: "campaign:default",
                        type: "string",
                        value: "hide_room_name:true"
                    } : undefined,
                    mapSpec.layerId === "map1" ? {
                        name: "campaign:standard",
                        type: "string",
                        value: ""
                    } : undefined,
                    mapSpec.layerId === "map1" ? {
                        name: "campaign:respawn",
                        type: "string",
                        value: ""
                    } : undefined,
                    ...campaigns
                ].filter((n)=>!!n),
                type: "tilelayer",
                visible: true,
                width: mapSpec.mapSizeX,
                x: 0,
                y: 0
            };
            return tiled;
        };
        this.toTiledTileset = (tileSetSpec)=>{
            const tiled = {
                firstgid: tileSetSpec.firstgid,
                source: $2db7e29a401f47a7$export$88e20c7c15a4abb(tileSetSpec.tilesetId)
            };
            return tiled;
        };
        this.toWorldMetaPath = ()=>{
            return $2db7e29a401f47a7$var$stagedMapPath("world/world_meta.json");
        };
        this.toSpawnRegion = (x, y, width, height, spawner)=>{
            return {
                class: "REGION",
                height: height,
                id: ++this.objectId,
                name: `spawn-region-${++this.objectSequenceId}`,
                properties: [
                    {
                        name: "spawner",
                        type: "string",
                        value: JSON.stringify(spawner, null, 1)
                    }
                ],
                rotation: 0,
                visible: true,
                width: width,
                x: x,
                y: y
            };
        };
        this.toMapSpriteCap = (x, y, context)=>{
            return {
                class: "mapSpriteCap",
                height: 0,
                id: ++this.objectId,
                name: "",
                point: true,
                rotation: 0,
                visible: true,
                width: 0,
                x: x,
                y: y,
                properties: context ? [
                    {
                        name: "context",
                        type: "string",
                        value: JSON.stringify(context, null, 1)
                    }
                ] : undefined
            };
        };
        this.toDebugObject = (text, x, y)=>{
            return {
                class: "",
                height: 18,
                id: ++this.objectId,
                name: "",
                rotation: 0,
                text: {
                    text: text,
                    wrap: true,
                    color: "#ff2600"
                },
                visible: true,
                width: 84,
                x: x + 8,
                y: y + 8
            };
        };
        this.toFeatureRegion = (x, y, width, height, feature, context)=>{
            return {
                class: "FEATURE_REGION",
                height: height,
                id: ++this.objectId,
                name: `feature-region-${++this.objectSequenceId}`,
                properties: [
                    {
                        name: "feature",
                        type: "string",
                        value: feature
                    },
                    context ? {
                        name: "context",
                        type: "string",
                        value: JSON.stringify(context, null, 1)
                    } : undefined
                ].filter((n)=>!!n),
                rotation: 0,
                visible: true,
                width: width,
                x: x,
                y: y
            };
        };
        this.toFeatureSpriteRegion = (fragmentSpriteMeta)=>{
            const properties = fragmentSpriteMeta.spriteEntries.map((next)=>{
                return {
                    name: `${next.x},${next.y}^${next.id}`,
                    type: "string",
                    value: JSON.stringify({
                        context: next.context,
                        tileId: next.tilePos
                    })
                };
            });
            if (!!fragmentSpriteMeta.context) properties.push({
                name: "context",
                type: "string",
                value: JSON.stringify(fragmentSpriteMeta.context)
            });
            return {
                class: "FEATURE_SPRITE_REGION",
                height: fragmentSpriteMeta.height * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                id: ++this.objectId,
                name: `feature-sprite-region-${++this.objectSequenceId}`,
                properties: properties,
                rotation: 0,
                visible: true,
                width: fragmentSpriteMeta.width * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                x: fragmentSpriteMeta.location.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                y: fragmentSpriteMeta.location.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            };
        };
        this.toBiomeRegion = (x, y, width, height, biome)=>{
            return {
                class: "BIOMEREGION",
                height: height,
                id: ++this.objectId,
                name: `biome-region-${++this.objectSequenceId}`,
                properties: [
                    {
                        name: "biome",
                        type: "string",
                        value: biome
                    }
                ],
                rotation: 0,
                visible: true,
                width: width,
                x: x,
                y: y
            };
        };
        this.toNavRegion = (x, y, width, height, map, deltaMapX, deltaMapY)=>{
            const nextMapX = map.mapX + deltaMapX;
            const nextMapY = map.mapY + deltaMapY;
            if (nextMapX < 0 || nextMapY < 0 || nextMapX > this.mapWidth || nextMapY > this.mapHeight) return null;
            const nextRoomId = `${this.roomPrefix}-${nextMapX}-${nextMapY}`;
            return {
                class: "REGION",
                height: height,
                id: ++this.objectId,
                name: `nav-region-${++this.regionId}`,
                properties: [
                    {
                        name: "navToRoomId",
                        type: "string",
                        value: nextRoomId
                    },
                    {
                        name: "deltaMapX",
                        type: "number",
                        value: deltaMapX
                    },
                    {
                        name: "deltaMapY",
                        type: "number",
                        value: deltaMapY
                    }
                ],
                rotation: 0,
                visible: true,
                width: width,
                x: x,
                y: y
            };
        };
        this.toObjectLayer = (map, biomes, biomeSpawners, features, featurePoints)=>{
            return {
                draworder: "topdown",
                id: 1,
                name: "objects",
                objects: [
                    {
                        class: "LOCATION",
                        height: 0,
                        id: ++this.objectId,
                        name: "spawn",
                        point: true,
                        rotation: 0,
                        visible: true,
                        width: 0,
                        x: this.defaultSpawnCoordinate?.x || 800,
                        y: this.defaultSpawnCoordinate?.y || 800
                    },
                    // north
                    this.toNavRegion(0, 0, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * map.mapSizeX, 4, map, 0, -1),
                    // south
                    this.toNavRegion(0, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (map.mapSizeY - 1) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 4, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * map.mapSizeX, 4, map, 0, 1),
                    // east
                    this.toNavRegion((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (map.mapSizeX - 1) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 4, 0, 4, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * map.mapSizeY, map, 1, 0),
                    // west
                    this.toNavRegion(0, 0, 4, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * map.mapSizeY, map, -1, 0),
                    ...biomes,
                    ...biomeSpawners,
                    ...features.map((feature)=>feature.region),
                    ...features.map((feature)=>feature.featureSpriteMeta).flat(),
                    ...features.map((feature)=>{
                        return feature.subFeaturesRegions.flat();
                    }).flat(),
                    ...features.map((feature)=>feature.featurePoints).flat().map((point)=>({
                            class: "LOCATION",
                            height: 0,
                            id: ++this.objectId,
                            name: point.id,
                            point: true,
                            rotation: 0,
                            visible: true,
                            width: 0,
                            x: point.location.x,
                            y: point.location.y,
                            properties: [
                                {
                                    name: "context",
                                    value: point.context
                                }
                            ]
                        })),
                    ...features.map((feature)=>feature.debug).flat(),
                    ...featurePoints.flat().map((point)=>({
                            class: "LOCATION",
                            height: 0,
                            id: ++this.objectId,
                            name: point.id,
                            point: true,
                            rotation: 0,
                            visible: true,
                            width: 0,
                            x: point.location.x,
                            y: point.location.y,
                            properties: [
                                {
                                    name: "context",
                                    value: point.context
                                }
                            ]
                        }))
                ].filter((n)=>!!n),
                opacity: 1,
                type: "objectgroup",
                visible: true,
                x: 0,
                y: 0
            };
        };
        this.toVisibility = (id)=>{
            return {
                draworder: "topdown",
                id: id,
                name: "visibility",
                objects: [],
                opacity: 1,
                properties: [
                    this.globalMapProperties.autoVisibility !== undefined ? {
                        name: "auto",
                        type: "bool",
                        value: this.globalMapProperties.autoVisibility
                    } : undefined,
                    this.globalMapProperties.fullOcclusion !== undefined ? {
                        name: "fullOcclusion",
                        type: "bool",
                        value: this.globalMapProperties.fullOcclusion
                    } : undefined,
                    this.globalMapProperties.darkness !== undefined ? {
                        name: "darkness",
                        type: "number",
                        value: this.globalMapProperties.darkness
                    } : undefined
                ].filter((n)=>!!n),
                type: "objectgroup",
                visible: true,
                x: 0,
                y: 0
            };
        };
        this.analyzeBiomeSector = (map, bX, bY)=>{
            const biomeCounts = {};
            for(let gX = bX * 10; gX < bX * 10 + 10; gX++)for(let gY = bY * 10; gY < bY * 10 + 10; gY++){
                const biomeName = map.fineBiomes[gX][gY];
                let count = biomeCounts[biomeName] || 0;
                biomeCounts[biomeName] = count + 1;
            }
            let maxCount = 0;
            let max = "";
            Object.keys(biomeCounts).forEach((biome)=>{
                const count = biomeCounts[biome];
                if (count > maxCount) {
                    max = biome;
                    maxCount = count;
                }
            });
            return max;
        };
        this.biomeSpawnMeta = (biome)=>{
            if (biome === "Plains_high") return {
                strategy: "lineOfSight",
                diurnal: {
                    creatures: [
                        {
                            race: "rabbit",
                            probability: 0.5
                        },
                        {
                            race: "snake",
                            probability: 0.1
                        },
                        {
                            race: "chicken",
                            probability: 0.5
                        },
                        {
                            race: "bee",
                            probability: 0.5
                        },
                        {
                            race: "wasp",
                            probability: 0.1,
                            hp: 1,
                            minQuantity: 5,
                            maxQuantity: 8,
                            exemptFromMax: true
                        }
                    ],
                    max: 2
                },
                nocturnal: {
                    creatures: [
                        {
                            race: "skeleton",
                            probability: 0.8,
                            hp: 3,
                            bufferTs: 5000,
                            maxQuantity: 2,
                            weaponTypeRange: [
                                "dagger",
                                "spear",
                                "none",
                                "none",
                                "none",
                                "bow"
                            ]
                        }
                    ],
                    max: 2
                }
            };
            if (biome === "Plains_mid") return {
                strategy: "lineOfSight",
                diurnal: {
                    creatures: [
                        {
                            race: "rabbit",
                            probability: 0.5
                        },
                        {
                            race: "rabbit",
                            probability: 0.5
                        },
                        {
                            race: "chicken",
                            probability: 0.5
                        },
                        {
                            race: "deer",
                            probability: 0.5
                        },
                        {
                            race: "bee",
                            probability: 0.3
                        },
                        {
                            race: "wasp",
                            probability: 0.1,
                            hp: 2,
                            minQuantity: 3,
                            maxQuantity: 5,
                            exemptFromMax: true
                        }
                    ],
                    max: 1
                },
                nocturnal: {
                    creatures: [
                        {
                            race: "skeleton",
                            probability: 0.8,
                            hp: 2,
                            bufferTs: 5000,
                            weaponTypeRange: [
                                "dagger",
                                "spear",
                                "none",
                                "none",
                                "none",
                                "bow"
                            ]
                        }
                    ],
                    max: 1
                }
            };
            if (biome === "Forest") return {
                strategy: "random",
                diurnal: {
                    creatures: [
                        {
                            race: "slime",
                            probability: 1.0
                        },
                        {
                            race: "chicken",
                            probability: 0.5
                        },
                        {
                            race: "bee",
                            probability: 0.2
                        }
                    ],
                    max: 4
                },
                nocturnal: {
                    creatures: [
                        {
                            race: "skeleton",
                            probability: 1.0,
                            hp: 3,
                            weaponTypeRange: [
                                "dagger",
                                "spear",
                                "none",
                                "none",
                                "none",
                                "bow"
                            ]
                        }
                    ],
                    max: 1
                }
            };
            if (biome === "Swamp") return {
                strategy: "lineOfSight",
                diurnal: {
                    creatures: [
                        {
                            race: "redspider",
                            probability: 0.5
                        },
                        {
                            race: "slime",
                            probability: 0.5
                        }
                    ],
                    max: 4
                },
                nocturnal: {
                    creatures: [
                        {
                            race: "skeleton",
                            probability: 1.0,
                            hp: 3,
                            weaponTypeRange: [
                                "dagger",
                                "spear",
                                "none",
                                "none",
                                "none",
                                "bow"
                            ]
                        },
                        {
                            race: "redspider",
                            probability: 1.0
                        }
                    ],
                    max: 1
                }
            };
            return null;
        };
        this.analyzeMapBiomeSectors = (map)=>{
            const width = map.mapSizeX;
            const height = map.mapSizeY;
            const spawners = [];
            const biomes = [];
            for(let bX = 0; bX < Math.floor(width / 10); bX++)for(let bY = 0; bY < Math.floor(height / 10); bY++){
                // const mapId = map.roomId
                const biome = this.analyzeBiomeSector(map, bX, bY);
                if (biome) {
                    const region = this.toBiomeRegion(bX * 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), bY * 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), biome);
                    biomes.push(region);
                }
                const biomeMeta = this.biomeSpawnMeta(biome);
                if (biomeMeta) {
                    const region = this.toSpawnRegion(bX * 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), bY * 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), biomeMeta);
                    spawners.push(region);
                }
            }
            return {
                spawners: spawners,
                biomes: biomes,
                features: [],
                featurePoints: []
            };
        };
        this.extractWorldMeta = ()=>{
            const worldMeta = {
                id: `world-${this.random()}`,
                dimensions: {
                    width: this.globalWidth,
                    height: this.globalHeight,
                    roomWidth: this.mapSize,
                    roomHeight: this.mapSize,
                    quadrantWidth: this.quadrantDimensions.w,
                    quadrantHeight: this.quadrantDimensions.h,
                    roomsCountX: Math.floor(this.globalWidth / this.mapSize),
                    roomsCountY: Math.floor(this.globalHeight / this.mapSize),
                    sectorWidth: 10,
                    sectorHeight: 10
                },
                roomBiomesDirectory: {},
                biomesToRooms: {},
                allBiomes: [],
                biomeColorMap: [],
                locationIconsMap: {},
                geographicFeatures: {},
                mapFeatures: {}
            };
            const roomMeta = new Map();
            //
            // establish world room biomes
            //
            const biomesSet = new Set();
            Object.values(this.maps).forEach((map)=>{
                const roomId = map.roomId;
                const meta = this.analyzeMapBiomeSectors(map);
                meta.id = roomId;
                roomMeta.set(roomId, meta);
                const { biomes: biomes } = meta;
                const roomBiomes = biomes.reduce((acc, next)=>acc.indexOf(next.properties[0].value) > -1 ? acc : [
                        ...acc,
                        next.properties[0].value
                    ], []);
                roomBiomes.forEach((biome)=>{
                    biomesSet.add(biome);
                    if (!worldMeta.biomesToRooms[biome]) worldMeta.biomesToRooms[biome] = [];
                    if (worldMeta.biomesToRooms[biome].indexOf(roomId) < 0) worldMeta.biomesToRooms[biome].push(roomId);
                });
                worldMeta.roomBiomesDirectory[roomId] = roomBiomes;
            });
            worldMeta.allBiomes = Array.from(biomesSet);
            return {
                worldMeta: worldMeta,
                roomMeta: roomMeta
            };
        };
        this.fillFragmentDetails = (roomId, mapX, mapY, x, y, offset, fragmentMaps, renderStrategy, mapEntries, spriteEntries, context, locationCallback, logIt)=>{
            const bounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(-1, -1, -1, -1);
            Object.keys(fragmentMaps).forEach((layer)=>{
                const fragmentMap = fragmentMaps[layer];
                bounds.widenViaCoordinate({
                    x: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (x + offset.x),
                    y: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (y + offset.y)
                });
                bounds.widenViaCoordinate({
                    x: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (x + fragmentMap.length + offset.x),
                    y: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (y + fragmentMap[0].length + offset.y)
                });
                for(let rx = 0; rx < fragmentMap.length; rx++)for(let ry = 0; ry < fragmentMap[0].length; ry++){
                    const value = fragmentMap[rx][ry];
                    if (!!value) {
                        if (renderStrategy === "default" || layer === "blocking") {
                            const gX = mapX * this.mapSize + x + rx + offset.x;
                            const gY = mapY * this.mapSize + y + ry + offset.y;
                            if (locationCallback) locationCallback(gX, gY);
                            const tilesetPlatformAutotile = $2db7e29a401f47a7$export$8ac3ec24b9478bb2[value.tilesetId];
                            const platformAutoTileMeta = tilesetPlatformAutotile ? tilesetPlatformAutotile[value.tilePos] : undefined;
                            if (platformAutoTileMeta) mapEntries.push($2db7e29a401f47a7$export$f4de484c835405db({
                                mapId: roomId,
                                tilesetId: value.tilesetId,
                                layerId: layer,
                                tile: value.tilePos,
                                variants: platformAutoTileMeta,
                                x: gX,
                                y: gY
                            }));
                            else mapEntries.push({
                                mapId: roomId,
                                tileSpec: value,
                                layerId: layer,
                                x: gX,
                                y: gY
                            });
                        }
                        if (renderStrategy === "sprite" && layer !== "blocking") {
                            const mapEntry = {
                                id: `${offset.x},${offset.y}`,
                                x: x + rx + offset.x,
                                y: y + ry + offset.y,
                                tilePos: value.tilePos + $2db7e29a401f47a7$export$89f24ee63398b793[value.tilesetId].firstgid,
                                context: context
                            };
                            spriteEntries.push(mapEntry);
                        }
                    }
                }
            });
            return bounds;
        };
        this.buildFeatureFragment = (featureFragment, x, y, mapX, mapY, roomId, featurePoints, mapSpriteCaps)=>{
            const { fragmentMaps: fragmentMaps, renderStrategy: renderStrategy, id: id, dimensions: dimensions, points: points, fragmentPointers: fragmentPointers, mapSpriteCaps: mapSpriteCapsRaw, context: context } = featureFragment;
            points.filter((p)=>!p.context?.fragmentPointer).forEach((point)=>{
                const fineMapX = x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + point.location.x;
                const fineMapY = y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + point.location.y;
                const p = {
                    ...point,
                    location: {
                        x: fineMapX,
                        y: fineMapY
                    }
                };
                featurePoints.push(p);
            });
            // record map mutations
            const mapEntries = [];
            const postFeatureMapEntries = [];
            const subFeatures = [];
            const fragmentSpriteMeta = {
                id: id,
                width: dimensions.w,
                height: dimensions.h,
                mapEntries: mapEntries,
                postFeatureMapEntries: postFeatureMapEntries,
                spriteEntries: [],
                location: {
                    x: x,
                    y: y
                },
                context: context,
                subFeatures: subFeatures
            };
            fragmentPointers.forEach((pointer)=>{
                const context = pointer.context ? JSON.parse(pointer.context) : undefined;
                if (context?.fragmentPointer) {
                    const { catalog: catalog, category: category, subCategory: subCategory, tag: tagRaw, context: fragmentPointerContext } = context.fragmentPointer;
                    let tag = tagRaw;
                    if (tagRaw?.includes("|")) tag = this.randomOneOf(tagRaw.split("|"));
                    const fragment = this.featureCatalogs.randomFeature(catalog, category, subCategory, tag);
                    if (fragment) {
                        const contextToUse = {
                            ...fragment?.context || {},
                            ...fragmentPointerContext || {}
                        };
                        const rough = (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(pointer.location);
                        const fragmentMaps = fragment.fragmentMaps;
                        const bounds = this.fillFragmentDetails(roomId, mapX, mapY, x, y, rough, fragmentMaps, fragment.renderStrategy, postFeatureMapEntries, fragmentSpriteMeta.spriteEntries, contextToUse, undefined, fragment.tag === "bucket2");
                        // fragment pointers can be things like doors, so we should capture
                        // enough information about them to create regions
                        const regionMeta = {
                            id: `${roomId}-${fragment.category || "category"}-${fragment.subcategory || "subcategory"}-${fragment.tag || "tag"}`,
                            fragment: fragment,
                            bounds: bounds,
                            context: contextToUse
                        };
                        subFeatures.push(regionMeta);
                    }
                }
            });
            if (mapSpriteCapsRaw) mapSpriteCapsRaw.forEach((point)=>{
                const fineMapX = x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + point.location.x;
                const fineMapY = y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + point.location.y;
                const p = {
                    x: fineMapX,
                    y: fineMapY
                };
                mapSpriteCaps.push(p);
            });
            this.fillFragmentDetails(roomId, mapX, mapY, x, y, {
                x: 0,
                y: 0
            }, fragmentMaps, renderStrategy, mapEntries, fragmentSpriteMeta.spriteEntries);
            return fragmentSpriteMeta;
        };
        this.printFeature = (featureFragment, featureLocation, mapX, mapY, roomId, featureSprites, featurePoints, postFeatureMapEntries, mapSpriteCaps)=>{
            const fragmentSpriteMeta = this.buildFeatureFragment(featureFragment, featureLocation.x, featureLocation.y, mapX, mapY, roomId, featurePoints, mapSpriteCaps);
            const { mapEntries: mapEntries, spriteEntries: spriteEntries, subFeatures: subFeatures, postFeatureMapEntries: postMapEntries } = fragmentSpriteMeta;
            this.applyEntries(mapEntries);
            if (spriteEntries.length > 0 || subFeatures.length > 0) featureSprites.push(fragmentSpriteMeta);
            postMapEntries.forEach((entry)=>postFeatureMapEntries.push(entry));
        };
        this.createDefenders = ()=>{
            const context = {
                npcMeta: {
                    npc: {
                        type: "zombie",
                        weaponTypeRange: [
                            "axe",
                            "dagger",
                            "dagger",
                            "spear",
                            "bow"
                        ],
                        faction: "wild",
                        appearance: {
                            race: "wolfman",
                            sex: "male",
                            bodyColor: "brown",
                            inventoryAppearanceHash: ""
                        },
                        speed: (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.speed.fromPctOfMax(Math.random())
                    },
                    brainProps: {
                        shooter: true,
                        scanner: true,
                        seeker: "astar",
                        scanPlayersOnly: false,
                        psychProfile: {
                            hostility: (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.psych.hostility().fromPctOfMax(this.randomFloatBetween(0.1, 0.5)),
                            aggroResponse: "pause"
                        },
                        targetLocationOffset: {
                            x: this.randomIntBetween(-(0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
                            y: this.randomIntBetween(-(0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))
                        },
                        targetLocationMaxDistance: 5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                    }
                }
            };
            return context;
        };
        this.buildFeatures = (worldMeta, roomMeta)=>{
        // todo
        };
        this.roomBounds = ()=>{
            const roomBounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(0, 0, this.mapSize * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), this.mapSize * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            return roomBounds;
        };
        this.applyGlobalBoundaries = ()=>{
            for(let x = 0; x < this.globalWidth; x++){
                this.setGlobal(x, 0, "blocking", 121);
                this.setGlobal(x, this.globalHeight - 1, "blocking", 121);
            }
            for(let y = 0; y < this.globalHeight; y++){
                this.setGlobal(0, y, "blocking", 121);
                this.setGlobal(this.globalWidth - 1, y, "blocking", 121);
            }
        };
        this.buildResources = (worldMeta, roomMetas)=>{
            Array.from(roomMetas.keys()).forEach((roomId)=>{
                const roomMeta = roomMetas.get(roomId);
                roomMeta.biomes.forEach((biome)=>{
                    const biomeType = biome.properties.find((p)=>p.name === "biome")?.value;
                    if (biomeType === "Plains_mid") {
                        const biomeBounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(biome.x, biome.y, biome.x + biome.width, biome.y + biome.height);
                        (0, $a80d0b17b615d6f7$export$76d90c956114f2c2)(()=>{
                            roomMeta.featurePoints.push({
                                id: "RESOURCE",
                                location: (0, $a80d0b17b615d6f7$export$b1a407392a6eb119)(biomeBounds, true),
                                context: JSON.stringify({
                                    itemType: this.pctChance(60) ? "flower-single-purple" : this.randomOneOf([
                                        "flower-single-blue",
                                        "flower-single-red",
                                        "flower-single-yellow"
                                    ])
                                })
                            });
                        }, this.randomIntBetween(2, 4));
                    }
                    if (biomeType === "Forest") {
                        const biomeBounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(biome.x, biome.y, biome.x + biome.width, biome.y + biome.height);
                        (0, $a80d0b17b615d6f7$export$76d90c956114f2c2)(()=>{
                            roomMeta.featurePoints.push({
                                id: "RESOURCE",
                                location: (0, $a80d0b17b615d6f7$export$b1a407392a6eb119)(biomeBounds, true),
                                context: JSON.stringify({
                                    itemType: this.pctChance(60) ? "mushroom-red" : this.randomOneOf([
                                        "mushroom-purple",
                                        "mushroom-yellow"
                                    ])
                                })
                            });
                        }, this.randomIntBetween(1, 2));
                    }
                });
            });
        };
        // Where autotiling writes: absolute gids, the room's layers via set/getGlobal, and the global
        // layer that later autotile passes read as their input.
        this.autotileStore = ()=>({
                encode: (tile)=>$2db7e29a401f47a7$export$89f24ee63398b793[tile.tilesetId].firstgid + tile.tilePos,
                empty: 0,
                set: (layerId, x, y, value)=>this.setGlobal(x, y, layerId, value),
                get: (layerId, x, y)=>this.getGlobal(x, y, layerId),
                setInput: (layerId, x, y, value)=>this.globalMap.layers[layerId].set(x, y, value)
            });
        this.mapPropertyBuilder = (map)=>{
            return [];
        };
        this.genLocationIcons = (output)=>{
            const rooms = Array.from(output.roomMaps.keys()).map((mapId)=>output.roomMaps.get(mapId));
            const locationIconsMap = {};
            const toMinimapCoordinates = (roomId, fineCoordinate)=>{
                const [_, roomX, roomY] = roomId.split("-");
                const rough = (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(fineCoordinate);
                const roughRoomX = rough.x;
                const roughRoomY = rough.y;
                const biomeX = roughRoomX / 10;
                const biomeY = roughRoomY / 10;
                const x = Math.floor(Number(roomX) * 5 + biomeX);
                const y = Math.floor(Number(roomY) * 5 + biomeY);
                return {
                    x: x,
                    y: y
                };
            };
            rooms.forEach((roomJson)=>{
                const roomIdToUse = roomJson?.properties?.find((property)=>property.name === "roomId")?.value;
                Object.values((0, $2f4c91f2e2ac27f6$export$57242d3f2812734b)(roomIdToUse, roomJson, [
                    "REGION",
                    "FEATURE_REGION"
                ])).flat().forEach((region)=>{
                    if (region.context?.context) {
                        const regionExtraContext = JSON.parse(region.context.context);
                        if (regionExtraContext.locationIcon) {
                            const location = region.bounds.center();
                            const minimapCoordinates = toMinimapCoordinates(roomIdToUse, location);
                            const { x: x, y: y } = minimapCoordinates;
                            const locationIcon = {
                                id: `${roomIdToUse}-${x}-${y}-${regionExtraContext.locationName}`,
                                roomId: roomIdToUse,
                                x: x,
                                y: y,
                                icon: regionExtraContext.locationIcon,
                                initialMapFeature: regionExtraContext.initialMapFeature,
                                noProximitySpawn: regionExtraContext.noProximitySpawn,
                                name: regionExtraContext.locationName
                            };
                            locationIconsMap[`${x}-${y}`] = locationIcon;
                        }
                    }
                });
            });
            return locationIconsMap;
        };
        const { w: width, h: height } = props.globalSize;
        this.globalWidth = width;
        this.globalHeight = height;
        this.globalMapProperties = props.mapProperties;
        this.roomPrefix = props.roomPrefix;
        this.quadrantDimensions = props.quadrantSize;
        this.mapSize = props.mapSize;
        this.mapWidth = width / props.mapSize;
        this.mapHeight = height / props.mapSize;
        for(let x = 0; x < this.mapWidth; x++)for(let y = 0; y < this.mapHeight; y++){
            const roomId = `${this.roomPrefix}-${x}-${y}`;
            this.maps[roomId] = $2db7e29a401f47a7$export$2ca8f2f4218485cb.createBlankRoom(roomId, x, y, this.mapSize, this.mapSize, true);
        }
        this.globalMap = $2db7e29a401f47a7$export$2ca8f2f4218485cb.createBlankRoom("global", 0, 0, width, height, true);
    }
    toRoomOutputPath(roomId) {
        return $2db7e29a401f47a7$var$stagedMapPath(`rooms/${roomId}.tmj`);
    }
    finalize() {
        const { worldMeta: worldMeta, roomMeta: roomMeta } = this.extractWorldMeta();
        this.roomMeta = roomMeta;
        const output = {
            worldMeta: worldMeta,
            roomMaps: new Map()
        };
        // apply post-terraforming features
        // baseline tiles
        this.applyGlobalBoundaries();
        this.applyEntries(this.deferredMapEntries);
        this.buildFeatures(worldMeta, roomMeta);
        this.buildResources(worldMeta, roomMeta);
        this.applyEntries(this.featureEntries);
        // apply autotiling
        // What each drawn cell writes -- the variant up a layer, its decorations, the ground copied
        // under an edge -- is autotileCellEffect in autotile_library.ts, shared with Sprite Lab.
        const store = this.autotileStore();
        Object.values(this.globalMap.layers).forEach((layer)=>{
            this.applyAutotiling(layer, (gX, gY, tilesetId, autotileVariantTile, variantPos, layerUpNumber, layerUpId)=>{
                const ops = (0, $4d955fa5af64f75a$export$d8a42fdf61018dcb)({
                    tilesetId: tilesetId,
                    variant: autotileVariantTile,
                    variantPos: variantPos,
                    layerUpNumber: layerUpNumber,
                    layerUpId: layerUpId
                }, layer.layerId);
                (0, $4d955fa5af64f75a$export$f8a32194ceb47840)(store, ops, gX, gY);
            });
        });
        this.applyEntries(this.finalizationEntries, roomMeta);
        //
        // finalize rooms
        //
        Object.values(this.maps).forEach((map)=>{
            const { biomes: biomes, spawners: spawners, features: features, featurePoints: featurePoints } = roomMeta.get(map.roomId);
            features.forEach((feature)=>{
                const mapEntries = feature.postFeatureMapEntries;
                this.applyEntries(mapEntries);
            });
            const layers = [
                ...Object.values(map.layers).sort((a, b)=>a.layerNumber - b.layerNumber).map((layer)=>this.toTiledLayer(layer)),
                this.toObjectLayer(map, biomes, spawners, features, featurePoints)
            ];
            layers.push(this.toVisibility(layers.length + 1));
            const tiled = {
                compressionlevel: -1,
                height: map.mapSizeY,
                infinite: false,
                layers: layers,
                nextlayerid: 2,
                nextobjectid: this.objectId + 1,
                orientation: "orthogonal",
                properties: [
                    {
                        name: "name",
                        type: "string",
                        value: this.globalMapProperties?.name || map.roomId
                    },
                    {
                        name: "roomId",
                        type: "string",
                        value: map.roomId
                    },
                    {
                        name: "triggers",
                        type: "string",
                        value: "[]"
                    },
                    {
                        name: "dayPhaseSupported",
                        type: "boolean",
                        value: this.globalMapProperties?.dayPhaseSupported
                    },
                    {
                        name: "suppressMinimap",
                        type: "boolean",
                        value: this.globalMapProperties?.suppressMinimap
                    },
                    {
                        name: "mapX",
                        type: "string",
                        value: map.mapX
                    },
                    {
                        name: "mapY",
                        type: "string",
                        value: map.mapY
                    },
                    ...this.mapPropertyBuilder(map)
                ],
                renderorder: "right-down",
                tiledversion: "1.9.0",
                tileheight: 32,
                tilesets: Object.values($2db7e29a401f47a7$export$89f24ee63398b793).map((next)=>this.toTiledTileset(next)),
                tilewidth: 32,
                type: "map",
                version: "1.9",
                width: map.mapSizeX
            };
            output.roomMaps.set(map.roomId, tiled);
            const stringified = JSON.stringify(tiled);
            const roomOutputPath = this.toRoomOutputPath(map.roomId);
            if (roomOutputPath) {
                $5Io6y.mkdirSync(roomOutputPath.slice(0, roomOutputPath.lastIndexOf("/")), {
                    recursive: true
                });
                $5Io6y.writeFileSync(roomOutputPath, stringified);
            }
        });
        worldMeta.biomeColorMap = this.genBiomeColorMap(output);
        worldMeta.locationIconsMap = this.genLocationIcons(output);
        worldMeta.geographicFeatures = this.genGeographicFeatures(output);
        worldMeta.mapFeatures = this.genMapFeatures(output, roomMeta);
        // persist worldmeta
        const worldMetaPath = this.toWorldMetaPath();
        if (worldMetaPath) {
            $5Io6y.mkdirSync(worldMetaPath.slice(0, worldMetaPath.lastIndexOf("/")), {
                recursive: true
            });
            $5Io6y.writeFileSync(worldMetaPath, JSON.stringify(worldMeta, null, 1));
        }
        return output;
    }
    genBiomeColorMap(output) {
        const rooms = Array.from(output.roomMaps.keys()).map((mapId)=>output.roomMaps.get(mapId));
        const biomeWidth = 10;
        const biomeHeight = 10;
        const { worldMeta: worldMeta } = output;
        const dimensions = worldMeta.dimensions;
        const width = dimensions.roomsCountX * (dimensions.roomWidth / biomeWidth);
        const height = dimensions.roomsCountY * (dimensions.roomHeight / biomeHeight);
        const roomBiomeHeight = Math.floor(dimensions.roomHeight / biomeHeight);
        const roomBiomeWidth = Math.floor(dimensions.roomWidth / biomeWidth);
        const colorMap = (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(width, height, 0);
        rooms.forEach((roomJson)=>{
            const roomIdToUse = roomJson?.properties?.find((property)=>property.name === "roomId")?.value;
            const biomeRegions = Object.values((0, $2f4c91f2e2ac27f6$export$8fcfa3699d7f98f4)(roomIdToUse, roomJson)).flat();
            const worldMapX = roomJson.properties.find((property)=>property.name === "mapX")?.value;
            const worldMapY = roomJson.properties.find((property)=>property.name === "mapY")?.value;
            biomeRegions.forEach((region)=>{
                const roughBounds = (0, $a80d0b17b615d6f7$export$7b8c2026ce8c6d5e)({
                    w: dimensions.roomWidth,
                    h: dimensions.roomHeight
                }, region.bounds);
                const biomeNameFull = region.context?.biome;
                const biomeName = biomeNameFull.split("_")[0];
                const biomeColor = (0, $c5de4107a36072bd$export$b4c1b9814b3bc6d2).get(biomeName).color >> 8;
                const biomeX = Math.floor(roughBounds.x1 / biomeWidth);
                const biomeY = Math.floor(roughBounds.y1 / biomeHeight);
                const x = worldMapX * roomBiomeWidth + biomeX;
                const y = worldMapY * roomBiomeHeight + biomeY;
                colorMap[x][y] = biomeColor;
            });
        });
        return colorMap;
    }
    genMapFeatures(output, roomMetas) {
        const featureTypeMap = new Map();
        const worldFeatures = {};
        roomMetas.forEach((roomMeta, key)=>{
            roomMeta.features?.forEach((feature)=>{
                const mapFeature = feature.mapFeature;
                if (mapFeature) {
                    const ff = featureTypeMap.get(mapFeature.type) || [];
                    ff.push(mapFeature);
                    featureTypeMap.set(mapFeature.type, ff);
                }
            });
        });
        featureTypeMap.forEach((ff, type)=>{
            worldFeatures[type] = ff;
        });
        return worldFeatures;
    }
    genGeographicFeatures(output) {
        const { worldMeta: worldMeta } = output;
        function detectFeatures(image, threshold) {
            let features = [];
            for(let y = 0; y < image.length; y++){
                for(let x = 0; x < image[0].length; x++)if (!belongsToExistingFeature([
                    x,
                    y
                ], features)) {
                    let newFeature = regionGrowing(image, [
                        x,
                        y
                    ], threshold);
                    features.push(newFeature);
                }
            }
            return features;
        }
        function belongsToExistingFeature(point, features) {
            for (let feature of features){
                if (feature.some((p)=>p[0] === point[0] && p[1] === point[1])) return true;
            }
            return false;
        }
        function regionGrowing(image, seed, threshold) {
            let region = [
                seed
            ];
            let stack = [
                seed
            ];
            while(stack.length > 0){
                let point = stack.pop();
                let neighbors = getNeighbors(point);
                for (let neighbor of neighbors)if (isSimilar(image[point[0]]?.[point[1]], image[neighbor[0]]?.[neighbor[1]], threshold) && !region.some((p)=>p[0] === neighbor[0] && p[1] === neighbor[1])) {
                    region.push(neighbor);
                    stack.push(neighbor);
                }
            }
            return region;
        }
        function getNeighbors(point) {
            let [x, y] = point;
            return [
                [
                    x - 1,
                    y
                ],
                [
                    x + 1,
                    y
                ],
                [
                    x,
                    y - 1
                ],
                [
                    x,
                    y + 1
                ]
            ] // 4-connectivity
            ;
        }
        function isSimilar(color1, color2, threshold) {
            return Math.abs(color1 - color2) <= threshold;
        }
        const f = detectFeatures(worldMeta.biomeColorMap, 0).filter((n)=>n.length > 10 && n.length < 200);
        const biomeFeatures = {};
        f.forEach((feature)=>{
            const [x, y] = feature[0];
            // console.log(i, x, ",", y)
            const color = worldMeta.biomeColorMap[x][y];
            const biome = (0, $c5de4107a36072bd$export$3a358f8b3ccaa20d).get(color);
            if (biome) {
                const name = (0, $a80d0b17b615d6f7$export$9a81a17686f0f9cf)("elf", {
                    gender: "male"
                }).toString();
                const biomeCoordinates = [];
                const geographicFeature = {
                    id: `${x}-${y}-${biome.name}`,
                    biome: biome.name,
                    name: name,
                    biomeCoordinates: biomeCoordinates
                };
                feature.forEach((coordinate)=>{
                    const [cx, cy] = coordinate;
                    geographicFeature.biomeCoordinates.push({
                        x: cx,
                        y: cy
                    });
                });
                const features = biomeFeatures[biome.name] || [];
                features.push(geographicFeature);
                biomeFeatures[biome.name] = features;
            }
        });
        return biomeFeatures;
    }
}
const $2db7e29a401f47a7$export$f4de484c835405db = ({ mapId: mapId, tile: tile, tilesetId: tilesetId, layerId: layerId, variants: variants, x: x, y: y, containmentBiome: containmentBiome, containmentRange: containmentRange, autoBlocking: autoBlocking = true, autoOcclusion: autoOcclusion = false })=>{
    // The expansion (which index draws which variant, and the cliff faces below it) is the
    // platform kind's mechanic in autotile_library.ts; the variant lists are data.
    const autotileMap = (0, $4d955fa5af64f75a$export$c394034174d3b490)({
        tile: tile,
        tilesetId: tilesetId,
        variants: variants,
        autoBlocking: autoBlocking,
        autoOcclusion: autoOcclusion
    });
    const tileSpec = {
        tilesetId: tilesetId,
        tilePos: tile,
        autotileMap: autotileMap
    };
    const mapEntry = {
        mapId: mapId,
        tileSpec: tileSpec,
        layerId: layerId,
        x: x,
        y: y,
        containmentRange: containmentRange,
        containmentBiome: containmentBiome
    };
    return mapEntry;
};


class $adc2b7d4f0244689$export$cfd1f8c409da7c62 {
    static{
        this.globalFeatureCatalog = null;
    }
    static{
        this.generation = -1;
    }
    static{
        this.instance = ()=>{
            if (!this.globalFeatureCatalog || this.generation !== (0, $e5c675b7b9585b42$export$eca3444cf0ef4f9a)()) {
                this.globalFeatureCatalog = new $adc2b7d4f0244689$export$cfd1f8c409da7c62();
                this.generation = (0, $e5c675b7b9585b42$export$eca3444cf0ef4f9a)();
            }
            return this.globalFeatureCatalog;
        };
    }
    constructor(){
        this.catalogs = {};
        this.fragmentByItemType = {};
        this.itemTypeMetaDescriptors = [];
        this.featureByTag = (catalog, tag)=>this.randomFeature(catalog, null, null, tag);
        this.featureByFragmentPointer = (fragmentPointer)=>this.featureByTag(fragmentPointer.catalog, fragmentPointer.tag);
        this.randomFeature = (catalog, category, subCategory, tag)=>{
            const catalogMeta = this.catalogs[catalog];
            if (!catalogMeta) return;
            const matches = catalogMeta.fragments.filter((n)=>(!category || n.category === category) && (!subCategory || n.subcategory === subCategory) && (!tag || n.tag === tag));
            if (matches?.length < 1) return;
            return (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(matches, {
                randomIntBetween: (0, $a80d0b17b615d6f7$export$c45e8adbbf82647d)
            });
        };
        this.analyze = (catalogId, mapObj)=>{
            const mapLayers = {};
            const { width: width, height: height, layers: layers, tilesets: tilesets } = mapObj;
            //
            // parse tileset specs
            //
            const tilesetSpecs = tilesets.map((meta)=>{
                const tilesetParts = meta.source.split("/");
                const tilesetId = tilesetParts[tilesetParts.length - 1].split(".")[0];
                return {
                    tilesetId: tilesetId,
                    firstgid: meta.firstgid
                };
            }).sort((a, b)=>b.firstgid - a.firstgid);
            const resolveTileSet = (tileId)=>{
                const id = Number(tileId);
                for(let i = 0; i < tilesetSpecs.length; i++){
                    const tileset = tilesetSpecs[i];
                    if (id >= tileset.firstgid) return tileset;
                }
            };
            //
            // parse tilemaps and fragments
            //
            let fragments = [];
            let featurePoints = [];
            let mapSpriteCaps = [];
            layers.forEach((mapLayer)=>{
                const matrix = $adc2b7d4f0244689$var$blankTileMap(width, height);
                let hasData = false;
                mapLayer.data?.forEach((next, index)=>{
                    const x = index % width;
                    const y = Math.floor(index / width);
                    const tileset = resolveTileSet(`${next}`);
                    const rawId = tileset ? Math.max(0, next - tileset.firstgid) : 0;
                    if (rawId) {
                        hasData = true;
                        const autotileMapTileset = (0, $2db7e29a401f47a7$export$bf11c92109ea6096)[tileset.tilesetId];
                        const autotileMap = autotileMapTileset ? autotileMapTileset[rawId] : undefined;
                        matrix[x][y] = {
                            tilesetId: tileset.tilesetId,
                            tilePos: rawId,
                            autotileMap: autotileMap ? {
                                tilesetId: tileset.tilesetId,
                                tiles: autotileMap
                            } : undefined
                        };
                    }
                });
                if (hasData && mapLayer.type === "tilelayer") mapLayers[mapLayer.name] = matrix;
                if (mapLayer.type === "objectgroup") {
                    fragments = mapLayer.objects.filter((next)=>next.class === "FRAGMENT");
                    featurePoints = mapLayer.objects.filter((next)=>next.class === "FRAGMENT_POINT");
                    mapSpriteCaps = mapLayer.objects.filter((next)=>next.class === "mapSpriteCap");
                }
            });
            const featureFragments = fragments.filter((fragment)=>!fragment.point).map((fragment)=>{
                const fragmentBounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(fragment.x, fragment.y, fragment.x + fragment.width, fragment.y + fragment.height);
                const fragX = Math.floor(fragment.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                const fragY = Math.floor(fragment.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                const fragWidth = Math.floor(fragment.width / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                const fragHeight = Math.floor(fragment.height / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                const fragmentMaps = {};
                Object.keys(mapLayers).forEach((layer)=>{
                    const fragmentMap = $adc2b7d4f0244689$var$blankTileMap(fragWidth, fragHeight);
                    fragmentMaps[layer] = fragmentMap;
                });
                // extract map slices
                let fx = 0;
                let fy = 0;
                let good = new Set();
                for(let x = fragX; x < fragX + fragWidth; x++){
                    fy = 0;
                    for(let y = fragY; y < fragY + fragHeight; y++){
                        Object.keys(mapLayers).forEach((layer)=>{
                            const value = mapLayers[layer][x][y];
                            fragmentMaps[layer][fx][fy] = value;
                            if (value) good.add(layer);
                        });
                        fy++;
                    }
                    fx++;
                }
                Object.keys(fragmentMaps).filter((k)=>!good.has(k)).forEach((layer)=>{
                    delete fragmentMaps[layer];
                });
                const mapSpriteCapsPoints = mapSpriteCaps.filter((p)=>{
                    return fragmentBounds.includes({
                        x: p.x,
                        y: p.y
                    });
                }).map((p)=>{
                    const contextRaw = p.properties?.find((property)=>property.name === "context")?.value;
                    const context = contextRaw ? JSON.parse(contextRaw) : undefined;
                    return {
                        id: p.name,
                        location: {
                            x: p.x - fragment.x,
                            y: p.y - fragment.y
                        },
                        context: context
                    };
                });
                const points = featurePoints.filter((p)=>{
                    const contextRaw = p.properties?.find((property)=>property.name === "context")?.value;
                    const context = contextRaw ? JSON.parse(contextRaw) : undefined;
                    return !context?.fragmentPointer && fragmentBounds.includes({
                        x: p.x,
                        y: p.y
                    });
                }).map((p)=>{
                    const contextRaw = p.properties?.find((property)=>property.name === "context")?.value;
                    return {
                        id: p.name,
                        location: {
                            x: p.x - fragment.x,
                            y: p.y - fragment.y
                        },
                        context: contextRaw
                    };
                });
                const fragmentPointers = featurePoints.filter((p)=>{
                    const contextRaw = p.properties?.find((property)=>property.name === "context")?.value;
                    const context = contextRaw ? JSON.parse(contextRaw) : undefined;
                    return !!context?.fragmentPointer && fragmentBounds.includes({
                        x: p.x,
                        y: p.y
                    });
                }).map((p)=>{
                    const contextRaw = p.properties?.find((property)=>property.name === "context")?.value;
                    return {
                        id: p.name,
                        location: {
                            x: p.x - fragment.x,
                            y: p.y - fragment.y
                        },
                        context: contextRaw
                    };
                });
                const fragmentContextRaw = fragment.properties.find((p)=>p.name === "context")?.value;
                const craftableMetaRaw = fragment.properties.find((p)=>p.name === "craftableMeta")?.value;
                const itemId = fragment.properties.find((p)=>p.name === "itemId")?.value;
                const craftableMeta = craftableMetaRaw ? JSON.parse(craftableMetaRaw) : undefined;
                const metadata = itemId && (0, $e5c675b7b9585b42$export$8952b416ba38edb4).items.resolvedMetadata[itemId]?.[0];
                if (itemId && !metadata) throw new Error(`Unknown placed item ID: ${itemId}`);
                const itemTypeMetaDescriptor = metadata ? {
                    ...metadata,
                    characteristics: (0, $e5c675b7b9585b42$export$8952b416ba38edb4).items.characteristics[itemId]
                } : undefined;
                const fragmentMeta = {
                    id: fragment.name,
                    fragmentMaps: fragmentMaps,
                    category: fragment.properties.find((p)=>p.name === "category").value,
                    subcategory: fragment.properties.find((p)=>p.name === "subcategory")?.value,
                    renderStrategy: fragment.properties.find((p)=>p.name === "renderStrategy")?.value || "default",
                    tag: fragment.properties.find((p)=>p.name === "tag")?.value || undefined,
                    dimensions: {
                        w: fragWidth,
                        h: fragHeight
                    },
                    points: points,
                    fragmentPointers: fragmentPointers,
                    mapSpriteCaps: mapSpriteCapsPoints,
                    context: fragmentContextRaw ? JSON.parse(fragmentContextRaw) : undefined,
                    craftableMeta: craftableMeta,
                    itemTypeMetaDescriptor: itemTypeMetaDescriptor
                };
                if (craftableMeta) this.fragmentByItemType[craftableMeta.itemType] = {
                    catalog: catalogId,
                    tag: fragmentMeta.tag
                };
                if (itemTypeMetaDescriptor) this.itemTypeMetaDescriptors.push(itemTypeMetaDescriptor);
                return fragmentMeta;
            });
            const featureCatalog = {
                id: catalogId,
                fragments: featureFragments
            };
            this.catalogs[catalogId] = featureCatalog;
            return featureCatalog;
        };
        for (const [id, map] of Object.entries((0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTemplates))this.analyze(id, map);
        // Sprite Lab entity tiles place one parent cell; the composite renderer raises its art.
        const authored = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets["authored-terrain"];
        const fragments = [];
        for (const tile of authored?.tiles || []){
            const item = tile.properties?.find((p)=>p.name === "labItemType")?.value;
            // Stair tiles retain their direction while both inventory IDs alias to "stairs".
            const inventoryItem = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.ids.aliases.items[item] ?? item;
            if (!item || !(0, $e5c675b7b9585b42$export$8952b416ba38edb4).items.all.includes(inventoryItem)) continue;
            const pointer = {
                catalog: "lab-entity-tiles",
                tag: item
            };
            this.fragmentByItemType[item] = pointer;
            fragments.push({
                id: item,
                tag: item,
                category: "object",
                subcategory: "small",
                renderStrategy: "default",
                dimensions: {
                    w: 1,
                    h: 1
                },
                points: [],
                fragmentPointers: [],
                mapSpriteCaps: [],
                fragmentMaps: {
                    sprite2: [
                        [
                            {
                                tilesetId: "authored-terrain",
                                tilePos: tile.id
                            }
                        ]
                    ]
                },
                craftableMeta: {
                    itemType: item,
                    buildType: "entity",
                    fragmentPointer: pointer
                }
            });
        }
        this.catalogs["lab-entity-tiles"] = {
            id: "lab-entity-tiles",
            fragments: fragments
        };
    }
}
const $adc2b7d4f0244689$var$blankTileMap = (width, height)=>{
    const matrix = [];
    for(let x = 0; x < width; x++){
        const column = [];
        matrix.push(column);
        for(let y = 0; y < height; y++)column.push();
    }
    return matrix;
};





// Recipes held back from the crafting list. The ONE escape hatch now that everything else is shown.
//
// wall-stone costs 3 planks -- exactly what a wooden wall costs, with no stone in it at all. Hidden,
// that was a data quirk; shown, it is two walls at the same price where one sounds strictly better.
// It comes back when it costs something of its own.
//
// Note this is a real hide, not the old half-hide: under the previous rule wall-stone was skipped by
// the always-list pass and then walked straight back in through "holds some of every ingredient", so
// it appeared for anyone carrying planks -- which is everyone who has built anything.
const $6db9b00381e87aee$var$UNLISTED_RECIPES = [
    "wall-stone"
];
class $6db9b00381e87aee$var$Weight {
    static{
        this.maximumItemWeight = 15;
    }
    static{
        /**
     * The heaviest of a class's weights, by VALUE. It used to `.sort()` them, which sorts numbers as
     * text -- 10 before 4 -- so a weight of 10 or more lost to any lighter one that started with a
     * bigger digit, and the class's ceiling came out wrong.
     */ this.heaviest = (weights)=>weights.reduce((max, next)=>next > max ? next : max, 0);
    }
    static get maximumTotalItemWeight() {
        const generation = (0, $e5c675b7b9585b42$export$eca3444cf0ef4f9a)();
        if (this.maximumTotalCache?.generation === generation && this.maximumTotalCache.multiplier === this.maximumItemWeight) return this.maximumTotalCache.value;
        const value = (0, $b5d7776bdc108009$export$6a0fc7ad27079d24).map((type)=>this.heaviest(Object.values((0, $56a75f3d82405d26$export$86a8c920ac50eefc)[type] || {}))).reduce((a, n)=>a + n * this.maximumItemWeight, 0);
        this.maximumTotalCache = {
            generation: generation,
            multiplier: this.maximumItemWeight,
            value: value
        };
        return value;
    }
    static{
        this.computeItemWeight = (item)=>{
            const { itemTypeMeta: itemTypeMeta } = item;
            if (!itemTypeMeta) return 0;
            const { type: type } = itemTypeMeta;
            const itemTypes = (0, $56a75f3d82405d26$export$86a8c920ac50eefc)[itemTypeMeta.class];
            if (!itemTypes) return 0;
            return (itemTypes[type] || 0) * this.maximumItemWeight;
        };
    }
    static{
        this.computeWeight = (inventory)=>{
            // only consider active (equipped) items
            const activeItems = inventory.items?.filter((item)=>item.active);
            return activeItems?.map((i)=>this.computeItemWeight(i)).reduce((a, n)=>a + n, 0);
        };
    }
    static{
        this.computeWeightPctOfMax = (inventory)=>{
            const f = this.computeWeight(inventory);
            return f / this.maximumTotalItemWeight;
        };
    }
}
class $6db9b00381e87aee$var$Protection {
    static{
        this.maximumItemProtection = 15;
    }
    static get maximumTotalItemProtection() {
        const generation = (0, $e5c675b7b9585b42$export$eca3444cf0ef4f9a)();
        if (this.maximumTotalCache?.generation === generation && this.maximumTotalCache.multiplier === this.maximumItemProtection) return this.maximumTotalCache.value;
        // By value, for the reason Weight.heaviest gives.
        const value = (0, $b5d7776bdc108009$export$6a0fc7ad27079d24).map((type)=>$6db9b00381e87aee$var$Weight.heaviest(Object.values((0, $94ca5c6c04d9c167$export$b7032dafe57f8d33)[type] || {}))).reduce((a, n)=>a + n * this.maximumItemProtection, 0);
        this.maximumTotalCache = {
            generation: generation,
            multiplier: this.maximumItemProtection,
            value: value
        };
        return value;
    }
    static{
        this.computeItemProtection = (item)=>{
            return this.computeItemProtectionPct(item.itemTypeMeta) * this.maximumItemProtection;
        };
    }
    static{
        this.computeItemProtectionPct = (itemTypeMeta)=>{
            if (!itemTypeMeta) return 0;
            const { type: type } = itemTypeMeta;
            const itemTypes = (0, $94ca5c6c04d9c167$export$b7032dafe57f8d33)[itemTypeMeta.class];
            if (!itemTypes) return 0;
            return itemTypes[type] || 0;
        };
    }
    static{
        this.computeProtection = (inventory)=>{
            // only consider active (equipped) items
            const activeItems = inventory.items?.filter((item)=>item.active) || [];
            return activeItems.map((i)=>this.computeItemProtection(i)).reduce((a, n)=>a + n, 0);
        };
    }
    static{
        this.computeProtectionPctOfMax = (inventory)=>{
            const f = this.computeProtection(inventory);
            return f / this.maximumTotalItemProtection;
        };
    }
}
class $6db9b00381e87aee$var$Properties {
    static{
        this.hasProperty = (itemTypeMeta, prop)=>{
            if (prop === "disallowedClassesOnActive" || prop === "buildType") return !!(0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemTypeMeta.type]?.[prop] || !!(0, $9289c16b39bc1929$export$cf55c200a2cf1225)[itemTypeMeta.class]?.[prop];
            if ((0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemTypeMeta.type]?.[prop] !== undefined) return (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemTypeMeta.type][prop];
            const klass = (0, $9289c16b39bc1929$export$cf55c200a2cf1225)[itemTypeMeta.class];
            return klass?.[prop];
        };
    }
    static{
        this.toItemTypeMeta = (itemType, color)=>{
            return (0, $f684496fff50a7a1$export$9efb6bfe58196888)(itemType, color, true);
        };
    }
    static{
        this.toSpriteId = (itemType, color)=>{
            const itemTypeMeta = this.toItemTypeMeta(itemType, color);
            if (!itemTypeMeta) return "";
            return itemTypeMeta.spriteId || `${itemTypeMeta.type}-${itemTypeMeta.color}.png`;
        };
    }
    static{
        this.buildable = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "buildable");
        };
    }
    static{
        this.deactivateAfterPlacement = (itemTypeMeta)=>this.hasProperty(itemTypeMeta, "deactivateAfterPlacement");
    }
    static{
        this.exclusiveReadiness = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "exclusiveReadiness");
        };
    }
    static{
        this.buildType = (itemTypeMeta)=>{
            return (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemTypeMeta.type].buildType;
        };
    }
    static{
        /** The wall ornament an item places (a window), if it is one. */ this.ornament = (itemTypeMeta)=>(0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemTypeMeta?.type]?.ornament;
    }
    static{
        this.disallowedClassesOnActive = (itemTypeMeta)=>{
            if (!this.hasProperty(itemTypeMeta, "disallowedClassesOnActive")) return [];
            return (0, $9289c16b39bc1929$export$cf55c200a2cf1225)[itemTypeMeta.class]["disallowedClassesOnActive"] || (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemTypeMeta.type]["disallowedClassesOnActive"] || [];
        };
    }
    static{
        this.useable = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "useable");
        };
    }
    static{
        /** Items selected for use with the primary world action. */ this.primaryUseable = (itemTypeMeta)=>!!itemTypeMeta && (this.hasProperty(itemTypeMeta, "primaryUseable") || this.placement(itemTypeMeta)?.action === "use");
    }
    static{
        this.campfireFuel = (itemTypeMeta)=>!!itemTypeMeta && this.hasProperty(itemTypeMeta, "campfireFuel");
    }
    static{
        this.placement = (itemTypeMeta)=>{
            const type = (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemTypeMeta?.type];
            const klass = (0, $9289c16b39bc1929$export$cf55c200a2cf1225)[itemTypeMeta?.class];
            const range = type?.placementRange ?? klass?.placementRange;
            const action = type?.placementAction ?? klass?.placementAction;
            // Placement actions without a range can target any build cell.
            return action ? {
                range: range ?? Infinity,
                action: action
            } : undefined;
        };
    }
    static{
        this.readyable = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "readyable");
        };
    }
    static{
        this.showWorldOnUse = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "useHasWorldEffect");
        };
    }
    static{
        this.stackable = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "stackable");
        };
    }
    static{
        this.unsellable = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "unsellable");
        };
    }
    static{
        this.unbuyable = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "unbuyable");
        };
    }
    static{
        this.hasDurability = (itemTypeMeta)=>{
            return this.hasProperty(itemTypeMeta, "hasDurability");
        };
    }
    static{
        this.currency = (itemTypeMeta)=>{
            // todo make this less brittle
            if (itemTypeMeta.type === "shard-metal") return true;
            return false;
        };
    }
    static{
        this.equippable = (itemTypeMeta, entity)=>{
            if (!(0, $9289c16b39bc1929$export$cf55c200a2cf1225)[itemTypeMeta.class]?.equippable) return false;
            if (itemTypeMeta.class === "shirt") {
                const items = (0, $bf6244e5cc9aa116$export$6e1561754c81021d)[entity.appearance?.sex];
                return !!items && !!items.find((i)=>i === itemTypeMeta.type);
            }
            if (itemTypeMeta.class === "pants") {
                const items = (0, $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3)[entity.appearance?.sex];
                return !!items && !!items.find((i)=>i === itemTypeMeta.type);
            }
            if (itemTypeMeta.class === "shoes") {
                const items = (0, $bf6244e5cc9aa116$export$14c4cc2ba117f70c)[entity.appearance?.sex];
                return !!items && !!items.find((i)=>i === itemTypeMeta.type);
            }
            if (itemTypeMeta.class === "cape") {
                const items = (0, $bf6244e5cc9aa116$export$bacf1c742d99cac9)[entity.appearance?.sex];
                return !!items && !!items.find((i)=>i === itemTypeMeta.type);
            }
            return true;
        };
    }
    static{
        this.itemSex = (itemTypeMeta)=>{
            const { type: type, class: itemClass } = itemTypeMeta;
            const evaluator = (male, female)=>{
                if (male && female) return "both";
                if (!male && female) return "female";
                if (male && !female) return "male";
                return "na";
            };
            if (itemClass === "cape") return evaluator((0, $bf6244e5cc9aa116$export$bacf1c742d99cac9)["male"]?.includes(type), (0, $bf6244e5cc9aa116$export$bacf1c742d99cac9)["female"]?.includes(type));
            if (itemClass === "pants") return evaluator((0, $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3)["male"]?.includes(type), (0, $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3)["female"]?.includes(type));
            if (itemClass === "shirt") return evaluator((0, $bf6244e5cc9aa116$export$6e1561754c81021d)["male"]?.includes(type), (0, $bf6244e5cc9aa116$export$6e1561754c81021d)["female"]?.includes(type));
            if (itemClass === "shoes") return evaluator((0, $bf6244e5cc9aa116$export$14c4cc2ba117f70c)["male"]?.includes(type), (0, $bf6244e5cc9aa116$export$14c4cc2ba117f70c)["female"]?.includes(type));
            return "na";
        };
    }
}
class $6db9b00381e87aee$var$Trading {
    static{
        this.isCurrency = (item)=>{
            return (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[item.itemTypeMeta.type]?.isCurrency;
        };
    }
    static{
        this.isAmmo = (item)=>{
            return (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[item.itemTypeMeta.type]?.isAmmo;
        };
    }
    static{
        this.isItemSellable = (item)=>{
            if ($6db9b00381e87aee$var$Properties.unsellable(item.itemTypeMeta)) return false;
            const baseTradeValue = (0, $7724856bf35f34f1$export$1fe1df41c32a19a1)[item.itemTypeMeta.type];
            if (baseTradeValue && (0, $7724856bf35f34f1$export$1fe1df41c32a19a1)[item.itemTypeMeta.type]?.quantity < 1) return false;
            return true;
        };
    }
    static{
        this.computeSellValueCost = (itemTypeMeta, quantity)=>{
            const base = (0, $7724856bf35f34f1$export$1fe1df41c32a19a1)[itemTypeMeta.type];
            if (base) {
                // markdown; todo, this might depend on the seller and the buyer
                const markup = 1;
                return {
                    itemType: base.itemType,
                    quantity: Math.ceil(base.quantity * markup * quantity)
                };
            }
            if (itemTypeMeta.class === "resource") return {
                itemType: "shard-metal",
                quantity: 1
            };
            return {
                itemType: "shard-metal",
                quantity: 10
            };
        };
    }
    static{
        this.isItemBuyable = (itemTypeMeta)=>{
            return true;
        };
    }
    static{
        this.computeBuyValueCost = (itemType, quantity)=>{
            const base = (0, $7724856bf35f34f1$export$1fe1df41c32a19a1)[itemType];
            if (!base) return {
                itemType: "shard-metal",
                quantity: 10
            };
            // markup; todo, this might depend on the seller and the buyer
            const markup = 1.25;
            return {
                itemType: base.itemType,
                quantity: Math.ceil(base.quantity * markup * quantity)
            };
        };
    }
    static{
        this.getTradableItemTypes = ()=>{
            const buyable = [];
            Object.keys((0, $6bf155bafb42c3cf$export$560c482cf16d1d03)).forEach((itemType)=>{
                const itemTypeMeta = $6db9b00381e87aee$export$ad15344118fbba9b.properties.toItemTypeMeta(itemType);
                if (!$6db9b00381e87aee$export$ad15344118fbba9b.properties.unbuyable(itemTypeMeta)) buyable.push(itemTypeMeta);
            });
            return buyable;
        };
    }
}
const $6db9b00381e87aee$export$856f32592e87f3a6 = [
    "wall",
    "decor",
    "entity",
    "roof",
    "floor",
    "floor2"
];
class $6db9b00381e87aee$var$Crafting {
    static{
        this.toKey = (next)=>next.class + "-" + next.type + "-" + next.color;
    }
    static{
        /**
     * How much of each resource the player is holding, keyed the way a recipe's ingredients are.
     *
     * SUMMED across stacks, which is the whole point of pulling this out. Both callers used to build
     * this with `{...acc, [key]: quantity}` -- an overwrite, not an add -- so only the LAST stack of a
     * resource counted. 8 sticks and then 2 read as 2, which greyed out a recipe needing 5 while the
     * cost line beside it (which does sum, by type) said "have 10". The verdict even depended on the
     * order the stacks sat in the pack: 2-then-8 crafted, 8-then-2 did not.
     *
     * Stacks of one resource normally merge, so this bit past the 50-item stack limit or wherever a
     * colour split one type into two keys -- but the symptom was a recipe the panel swore you could
     * afford and would not make.
     */ this.heldResources = (inventory)=>(inventory?.items || []).filter((item)=>item.itemTypeMeta?.class === "resource").reduce((acc, next)=>{
                const key = this.toKey(next.itemTypeMeta);
                acc[key] = (acc[key] || 0) + (next.quantity || 1);
                return acc;
            }, {});
    }
    static{
        this.getRecipeFor = (toFind)=>{
            return (0, $4ea3e677cece9ece$export$26748d48fafe06ef).find((next)=>this.toKey(next.itemTypeMeta) === this.toKey(toFind));
        };
    }
    static{
        this.isCraftable = (itemTypeMeta, inventory, skills = [])=>{
            const recipe = (0, $4ea3e677cece9ece$export$26748d48fafe06ef).find((r)=>r.itemTypeMeta.type === itemTypeMeta.type && itemTypeMeta.color == r.itemTypeMeta.color);
            if (!recipe) return {
                craftable: false,
                isValid: false
            };
            const resourceMap = this.heldResources(inventory);
            const { requiredSkills: requiredSkills = [] } = recipe;
            if (requiredSkills.length > 0 && !!requiredSkills.find((s)=>!skills.includes(s))) return {
                craftable: false,
                isValid: false
            };
            const missingIngredients = [];
            const cost = [];
            const foundIngredients = recipe.ingredients.filter((required)=>{
                const toLookupKey = this.toKey(required.itemTypeMeta);
                const ownedQuantity = resourceMap[toLookupKey] || 0;
                const found = ownedQuantity >= required.quantity;
                const ingredientType = required.itemTypeMeta.type;
                const hasRecipe = !!this.getRecipeFor(required.itemTypeMeta);
                // Some materials are left for the player to find out about (shard-metal: kill a slime),
                // so the card names them and stops there -- no hint, and no jump to a recipe that would
                // give the answer away.
                const disclosed = !(0, $29a7cd3edffb5113$export$5ea6e64b0f984a99).has(ingredientType);
                cost.push({
                    itemType: ingredientType,
                    required: required.quantity,
                    held: ownedQuantity,
                    craftable: hasRecipe && disclosed,
                    // Only for a LEAF. A material with a recipe already has its next step, and two
                    // answers to "how do I get this" is worse than one.
                    source: hasRecipe || !disclosed ? undefined : (0, $29a7cd3edffb5113$export$4e9ef2fe1b930332)[ingredientType]
                });
                if (!found) // From the RECIPE, not from resourceMap. resourceMap only holds what the player is
                // carrying, so an ingredient they have NONE of -- the common case for anything worth
                // showing them -- resolved to undefined and printed as "undefined x3". It was masked
                // while the list only offered recipes you already held every ingredient for.
                missingIngredients.push({
                    itemType: required.itemTypeMeta.type,
                    quantity: Math.abs(ownedQuantity - required.quantity)
                });
                return found;
            });
            const craftable = foundIngredients.length === recipe.ingredients.length;
            return {
                craftable: craftable,
                isValid: true,
                missingIngredients: missingIngredients,
                cost: cost,
                yield: recipe.quantity
            };
        };
    }
    static{
        /**
     * Which of the recipes a player is PERMITTED to see are actually offered.
     *
     * All of them, minus UNLISTED_RECIPES.
     *
     * It used to answer one question with another: a recipe appeared only once you already held every
     * ingredient for it (structures excepted), so the tree hid behind itself. An arrow is 2 sticks, 3
     * feathers and 2 metal shards, which meant the recipe did not EXIST until the moment a player
     * happened to be carrying all three at once -- and a player with no reason to keep feathers never
     * had that moment. From a playtest: "I didn't see a way to craft arrows." The same rule hid the
     * stick dagger, which costs five sticks and nothing else, from anyone not holding a stick.
     *
     * The crafting screen is where you go to find out what to COLLECT. Gating it on what you are
     * already carrying is backwards, and it is not a volume problem either: this is twenty-odd
     * recipes across four groups, a page rather than a catalogue.
     *
     * A ROOM can still narrow it, and that is the second lever: `absentMaterials` names the raw
     * materials this place does not have, and any recipe whose tree bottoms out in one of them drops
     * off the list. An ember camp is a forest with no ore in it, so the whole metal branch -- the
     * bars, and the axe and swords made from them -- is not a goal a camper can form. Expressed as
     * MATERIALS rather than as a list of recipes so that it keeps up on its own: a pickaxe added
     * tomorrow is absent from a camp without anybody remembering to say so.
     *
     * Staging is a third question with a third answer. `requiredSkills` is applied before both and is
     * the lever for deliberately holding content back -- a thing that is TRUE of a player
     * ("you have not learned smithing") rather than an accident of their pockets. Nothing uses it in
     * the data yet; the metal tree is the obvious first customer, and it sorts to the bottom of
     * Materials in the meantime because the panel offers what is craftable first.
     */ this.computeListedRecipes = (permitted, absentMaterials = [])=>{
            const absent = new Set(absentMaterials.map((material)=>material.trim()).filter(Boolean));
            return permitted.filter((recipe)=>{
                if ($6db9b00381e87aee$var$UNLISTED_RECIPES.includes(recipe.itemTypeMeta.type)) return false;
                if (absent.size < 1) return true;
                const raw = this.rawMaterialsFor(recipe);
                return ![
                    ...raw
                ].some((material)=>absent.has(material));
            });
        };
    }
    static{
        // Memoised per content generation: recipe edits invalidate the raw-material dependency tree.
        this.rawMaterialCache = new Map();
    }
    static{
        this.rawMaterialGeneration = -1;
    }
    static{
        /**
     * Every material a recipe bottoms out in -- the leaves of its tree, not its direct ingredients.
     *
     * This is what lets a room say "there is no ore here" and have the whole metal branch follow. An
     * axe's ingredients are an iron bar and a stick, neither of which is ore; it is only two steps
     * down that the iron appears. Listing the axe as unavailable by hand would work until somebody
     * added a recipe for a pickaxe.
     *
     * Cycle-safe by construction: `seen` guards a material that is (directly or otherwise) made of
     * itself, which the data does not do today but which would otherwise hang the server rather than
     * draw a wrong list.
     */ this.rawMaterialsFor = (recipe)=>{
            if (this.rawMaterialGeneration !== (0, $e5c675b7b9585b42$export$eca3444cf0ef4f9a)()) {
                this.rawMaterialCache.clear();
                this.rawMaterialGeneration = (0, $e5c675b7b9585b42$export$eca3444cf0ef4f9a)();
            }
            const key = this.toKey(recipe.itemTypeMeta);
            const cached = this.rawMaterialCache.get(key);
            if (cached) return cached;
            const raw = new Set();
            const seen = new Set();
            const walk = (next)=>{
                const nextKey = this.toKey(next.itemTypeMeta);
                if (seen.has(nextKey)) return;
                seen.add(nextKey);
                next.ingredients.forEach((ingredient)=>{
                    const type = ingredient.itemTypeMeta.type;
                    const made = this.getRecipeFor(ingredient.itemTypeMeta);
                    // A material that is FOUND as well as made stops the walk here, because finding it
                    // is enough: shard-metal drops from slimes AND is smelted from mine iron, and an
                    // ore-less camp still gets arrows from its slimes. Walking into the iron recipe would
                    // take every shard recipe off that camp's list. "Found" is what a source hint says --
                    // the hints are already required for every material nothing makes.
                    if (made && !(0, $29a7cd3edffb5113$export$4e9ef2fe1b930332)[type]) {
                        walk(made);
                        return;
                    }
                    // No recipe (or one it does not need): this is something the player goes and finds,
                    // which is exactly what a room can be without.
                    raw.add(type);
                });
            };
            walk(recipe);
            this.rawMaterialCache.set(key, raw);
            return raw;
        };
    }
    static{
        this.computeCraftableItemTypes = (inventory, skills = [], options = {})=>{
            const resourceMap = this.heldResources(inventory);
            // Permission is a separate question from affordability, and `requiredSkills` answers it. It
            // is applied FIRST and on its own, so a recipe the player may not see cannot drag its
            // ingredients onto the list either -- which is how the deep tree gets staged later.
            const permitted = (0, $4ea3e677cece9ece$export$26748d48fafe06ef).filter((recipe)=>{
                const { requiredSkills: requiredSkills = [] } = recipe;
                return requiredSkills.length < 1 || !requiredSkills.find((s)=>!skills.includes(s));
            });
            return this.computeListedRecipes(permitted, options.absentMaterials).map((recipe)=>{
                const foundIngredients = recipe.ingredients.filter((required)=>{
                    const toLookupKey = this.toKey(required.itemTypeMeta);
                    const ownedQuantity = resourceMap[toLookupKey] || 0;
                    return ownedQuantity >= required.quantity;
                });
                return {
                    itemTypeMeta: recipe.itemTypeMeta,
                    craftable: foundIngredients.length === recipe.ingredients.length
                };
            });
        };
    }
    static{
        this.computeCraftableMeta = (item)=>{
            if (item?.itemTypeMeta?.type === "stairs") return this.computeCraftableMetaFromItemType(item.flags?.stairDirection === "down" ? "stairs-down" : "stairs-up");
            return this.computeCraftableMetaFromItemType(item?.itemTypeMeta?.type);
        };
    }
    static{
        this.computeCraftableMetaFromItemType = (itemType)=>{
            if (!itemType) return null;
            if (itemType === "stairs") itemType = "stairs-up";
            const pointer = (0, $adc2b7d4f0244689$export$cfd1f8c409da7c62).instance().fragmentByItemType[itemType];
            if (pointer) {
                const feature = (0, $adc2b7d4f0244689$export$cfd1f8c409da7c62).instance().featureByTag(pointer.catalog, pointer.tag);
                return feature?.craftableMeta;
            }
            const itemTypeMeta = (0, $f684496fff50a7a1$export$9efb6bfe58196888)(itemType);
            const buildType = (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildType(itemTypeMeta);
            if (buildType) return {
                itemType: itemType,
                buildType: buildType
            };
            return null;
        };
    }
}
class $6db9b00381e87aee$var$Projectile {
    static{
        this.resolveAmmoMetaFromAmmo = (ammoType)=>{
            if (!this.ammoTypeToMeta) {
                this.ammoTypeToMeta = new Map();
                this.ammoTypeToMeta.set("webAmmo", {
                    spriteId: "arrow-brown.png",
                    effects: [
                        "webslow"
                    ],
                    createNpcProps: {
                        spriteId: "spiderweb-exact.png",
                        flags: {
                            contactEffects: [
                                "webslow"
                            ]
                        },
                        msUntilExpiration: 5000,
                        dimensions: {
                            w: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2,
                            h: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2
                        }
                    }
                });
                this.ammoTypeToMeta.set("arrow", {
                    spriteId: "arrow-brown.png"
                });
            }
            return this.ammoTypeToMeta.get(ammoType);
        };
    }
    static{
        this.resolveProjectileSpriteId = (weaponType)=>{
            const characteristic = (0, $cb689cfa16c444ba$export$6e47733a887561b3)[weaponType];
            if (!characteristic) return;
            const spriteId = characteristic.bulletSpriteId;
            if (spriteId) return spriteId;
            const bulletType = characteristic.bulletType;
            if (!bulletType) return;
            let ammoMeta;
            return ammoMeta?.spriteId;
        };
    }
    static{
        this.isStunTypeWeapon = (weaponType)=>{
            const characteristic = (0, $cb689cfa16c444ba$export$6e47733a887561b3)[weaponType];
            if (!characteristic) return false;
            const bulletType = characteristic.bulletType;
            if (!bulletType) return false;
            return this.resolveAmmoMetaFromAmmo(bulletType)?.effects?.includes("webslow");
        };
    }
}
class $6db9b00381e87aee$var$Durability {
    static{
        /**
     * How many seconds of sustained fire a launcher's durability is worth.
     *
     * A LAUNCHER IS PAID PER SHOT, NOT PER HIT, so its durability is a budget of trigger pulls and
     * the material rule cannot price it. A bow resolves to colour brown, brown is wood, and wood is
     * 70 -- which at the bow's 400ms latch is twenty-eight seconds of holding the button for the
     * whole life of the weapon. Measured against the wave table that is a bow dead in wave 7 for a
     * player landing 60% of their shots, needing 8 bows across the siege set; and 8 bows cost 40
     * shard-metal when the entire twenty-wave run pays out 39. The weapon was not expensive, it was
     * unobtainable.
     *
     * Sixty seconds is the call: four bows across the siege set, 20 of the 39 shard, leaving 19 to
     * craft ammunition with. Breakage stays a real event that interrupts a fight and has to be
     * planned around, without being a treadmill.
     *
     * Expressed as TIME rather than as a point count on purpose. The points are only meaningful
     * next to the firing latch, so a slower launcher would otherwise be punished for being slow --
     * every launcher is 400ms today, and this keeps them equal if one stops being.
     */ this.LAUNCHER_SECONDS_OF_FIRE = 60;
    }
    static{
        this.computeMaxDurability = (itemTypeMeta)=>{
            if (!$6db9b00381e87aee$var$Properties.hasDurability(itemTypeMeta)) return;
            // Keyed off the ammunition map rather than a hand-listed set of weapons, so that the rule
            // and the behaviour it pays for cannot drift apart: anything that eats ammunition wears at
            // the trigger (server weapon.ts) and so needs a per-shot budget, including a launcher added
            // after this was written.
            const weaponType = itemTypeMeta?.type;
            if (weaponType && (0, $bf6244e5cc9aa116$export$3f4c28cf92a4cf37)[weaponType]) {
                const latchMs = (0, $cb689cfa16c444ba$export$6e47733a887561b3)[weaponType]?.firingLatchMs;
                if (latchMs && latchMs > 0) // To the nearest ten, so the number stays legible in a condition gauge.
                return Math.round(this.LAUNCHER_SECONDS_OF_FIRE * 1000 / latchMs / 10) * 10;
            }
            const material = $6db9b00381e87aee$var$Material.computeItemMaterial(itemTypeMeta);
            if (material === "metal") return 100;
            if (material === "wood") return 70;
            // todo - this should be more sophisticated, based on type and composition of the item
            return 100;
        };
    }
    static{
        this.computeItemConditionPct = (inventoryItem)=>{
            // Explicit condition is useful for any recoverable item, even if using it never wears it.
            const condition = inventoryItem.flags?.condition;
            if (Number.isFinite(condition?.hp) && Number.isFinite(condition?.hpMax) && condition.hpMax > 0) return Math.max(0, Math.min(1, condition.hp / condition.hpMax));
            const maxDurabilty = this.computeMaxDurability(inventoryItem.itemTypeMeta);
            if (maxDurabilty === undefined) return;
            const { hp: hp = 0 } = inventoryItem;
            const pct = hp / maxDurabilty;
            return pct;
        };
    }
    static{
        this.computeItemCondition = (inventoryItem)=>{
            const pct = this.computeItemConditionPct(inventoryItem);
            if (pct === undefined) return;
            return this.conditionForPct(pct);
        };
    }
    static{
        /**
     * The tier a 0..1 condition fraction falls in.
     *
     * Split out of `computeItemCondition` because the CLIENT names the same tiers -- the item
     * menu prints the word beside its gauge, and the readied-item tray decides from it which
     * weapon is close enough to breaking to warrant a warning (client gui/durability.ts). Two
     * copies of these thresholds is two answers to "is this axe worn or fragile?".
     */ this.conditionForPct = (pct)=>{
            if (pct > 0.75) return "new";
            if (pct > 0.5) return "sturdy";
            if (pct > 0.25) return "worn";
            return "fragile";
        };
    }
}
class $6db9b00381e87aee$var$Material {
    static{
        // todo - make this better
        this.computeItemMaterial = (itemTypeMeta)=>{
            if (itemTypeMeta.class === "weapon") {
                if ([
                    "brown",
                    "lightbrown"
                ].includes(itemTypeMeta.color)) return "wood";
            }
            return "metal";
        };
    }
}
class $6db9b00381e87aee$var$InventoryMechanics {
    static{
        this.stackLimit = ()=>50;
    }
    static{
        this.inventoryFull = (entity)=>{
            return entity.inventory?.items?.length > (0, $f684496fff50a7a1$export$618460892f1ada62);
        };
    }
    static{
        this.canReceive = (receiver, itemType, quantity)=>{
            const isStackable = $6db9b00381e87aee$var$Properties.stackable(itemType);
            const stackLimit = this.stackLimit();
            const inventorySize = receiver.inventory?.items?.length;
            const allSlotsOccupied = inventorySize >= (0, $f684496fff50a7a1$export$618460892f1ada62);
            if (!isStackable && allSlotsOccupied) return false;
            const existingItem = (0, $f684496fff50a7a1$export$42ef252fc2f3d24d)(receiver.inventory, itemType, stackLimit);
            const maximumNumberOfNewSlots = (0, $f684496fff50a7a1$export$618460892f1ada62) - inventorySize;
            let quantityForExistingItem = 0;
            if (existingItem) // update the existing item up to its capacity
            quantityForExistingItem = stackLimit - (existingItem.quantity || 1);
            const quantityForNewItems = quantity - quantityForExistingItem;
            const numberOfNewItems = Math.ceil(quantityForNewItems / stackLimit);
            if (numberOfNewItems > maximumNumberOfNewSlots) return false;
            return true;
        };
    }
    static{
        // The largest slice of `desired` the receiver can actually hold. canReceive is monotonic in
        // quantity -- room for n implies room for anything smaller -- so this binary searches it rather
        // than restating its slot/stack arithmetic. Used to size the transfer quantity picker: the slider
        // must not offer an amount that would be silently trimmed on arrival.
        this.receivableQuantity = (receiver, itemType, desired)=>{
            const want = Math.floor(desired);
            if (want < 1) return 0;
            if (this.canReceive(receiver, itemType, want)) return want;
            let low = 0;
            let high = want - 1;
            while(low < high){
                const mid = Math.ceil((low + high) / 2);
                if (this.canReceive(receiver, itemType, mid)) low = mid;
                else high = mid - 1;
            }
            return low;
        };
    }
    static{
        this.createNewItem = ({ entity: entity, sourceItemEntity: sourceItemEntity, sourceItem: sourceItem, item: item, quantity: quantity })=>{
            // create new item because there's no existing stackable item to add to,
            // or that item is full up wrto stackable limit
            const isStackable = $6db9b00381e87aee$export$ad15344118fbba9b.properties.stackable(item);
            const hp = !isStackable ? sourceItem?.hp : sourceItemEntity?.hp;
            const newItem = (0, $f684496fff50a7a1$export$9bccf79e85d1f187)(item, {
                sourceItem: sourceItemEntity,
                quantity: quantity,
                hp: hp,
                id: (0, $a80d0b17b615d6f7$export$5e699d18035b41af)(),
                flags: sourceItem?.flags
            });
            let updatedEntity = (0, $f684496fff50a7a1$export$73ce97a5e6b0458a)(entity, newItem);
            if (item.class === "weapon" && !entity.weapon && (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.inventory.canEquipWeapon(entity)) {
                const weaponType = item.type;
                entity.weapon = {
                    weaponType: weaponType
                };
                updatedEntity = (0, $f684496fff50a7a1$export$9708f70dc8060636)(updatedEntity, newItem.id);
            }
            if (item.class === "armor") {
                const activeItem = (0, $f684496fff50a7a1$export$ff6824850c0111da)(entity.inventory, "armor");
                if (!activeItem) updatedEntity = (0, $f684496fff50a7a1$export$9708f70dc8060636)(updatedEntity, newItem.id);
            }
            return {
                updatedEntity: updatedEntity,
                createdItem: newItem
            };
        };
    }
    static{
        this.addItemToInventory = ({ entity: entity, sourceItemEntity: sourceItemEntity, sourceItem: sourceItem, item: item, quantity: quantity = 1 })=>{
            const currentInventorySize = entity?.inventory?.items.length;
            const isFull = currentInventorySize >= (0, $f684496fff50a7a1$export$618460892f1ada62);
            const isStackable = $6db9b00381e87aee$export$ad15344118fbba9b.properties.stackable(item);
            const stackLimit = isStackable ? $6db9b00381e87aee$var$InventoryMechanics.stackLimit() : 1;
            // Same precedence createNewItem/createInventoryItem use when they decide which flags the new
            // slot carries, so the slot we stack ONTO is the slot we would have created.
            const incomingFlags = sourceItemEntity?.flags ? sourceItemEntity.flags : sourceItem?.flags;
            const existingItem = (0, $f684496fff50a7a1$export$42ef252fc2f3d24d)(entity.inventory, item, stackLimit, incomingFlags);
            const totalQuantity = (existingItem ? existingItem.quantity || 1 : 0) + quantity;
            if (totalQuantity < 1) return {
                success: false
            };
            if (totalQuantity < stackLimit) {
                // the total amount fits within the slot
                if (existingItem) {
                    // an existing item exists, update it
                    const updatedEntity = (0, $f684496fff50a7a1$export$be412759309c8c0f)(entity, existingItem, quantity);
                    return {
                        success: true,
                        updatedEntity: updatedEntity,
                        updatedItem: existingItem
                    };
                } else {
                    if (isFull) return {
                        success: false
                    };
                    else {
                        // an existing item doesn't exist, create one
                        const { updatedEntity: updatedEntity, createdItem: createdItem } = this.createNewItem({
                            entity: entity,
                            sourceItemEntity: sourceItemEntity,
                            sourceItem: sourceItem,
                            item: item,
                            quantity: quantity
                        });
                        return {
                            success: true,
                            updatedEntity: updatedEntity,
                            addedItems: [
                                createdItem
                            ]
                        };
                    }
                }
            } else {
                // the total amount exceeds the slot, overflow other items if its possible
                const maximumNumberOfNewSlots = (0, $f684496fff50a7a1$export$618460892f1ada62) - entity.inventory.items.length;
                let updatedEntity;
                let quantityForExistingItem = 0;
                let createdItems = [];
                if (existingItem) {
                    // update the existing item up to its capacity
                    quantityForExistingItem = stackLimit - (existingItem.quantity || 1);
                    updatedEntity = (0, $f684496fff50a7a1$export$be412759309c8c0f)(entity, existingItem, quantityForExistingItem);
                }
                // spread the rest to new items
                const quantityForNewItems = quantity - quantityForExistingItem;
                const numberOfNewItems = Math.ceil(quantityForNewItems / stackLimit);
                if (isFull && numberOfNewItems > 0) return {
                    success: false,
                    updatedEntity: updatedEntity,
                    updatedItem: existingItem,
                    excessQuantity: quantityForNewItems
                };
                let totalAdded = 0;
                for(let i = 0; i < numberOfNewItems; i++){
                    if (i > maximumNumberOfNewSlots - 1) break;
                    const itemsToAdd = i == numberOfNewItems - 1 ? quantityForNewItems - i * stackLimit : stackLimit;
                    const createResults = this.createNewItem({
                        entity: updatedEntity || entity,
                        sourceItemEntity: sourceItemEntity,
                        sourceItem: sourceItem,
                        item: item,
                        quantity: itemsToAdd
                    });
                    updatedEntity = createResults.updatedEntity;
                    createdItems.push(createResults.createdItem);
                    totalAdded += itemsToAdd;
                }
                return {
                    success: true,
                    excessQuantity: quantityForNewItems - totalAdded,
                    updatedItem: existingItem,
                    updatedEntity: updatedEntity,
                    addedItems: createdItems
                };
            }
        };
    }
}
class $6db9b00381e87aee$export$ad15344118fbba9b {
    static{
        this.weight = $6db9b00381e87aee$var$Weight;
    }
    static{
        this.protection = $6db9b00381e87aee$var$Protection;
    }
    static{
        this.crafting = $6db9b00381e87aee$var$Crafting;
    }
    static{
        this.trading = $6db9b00381e87aee$var$Trading;
    }
    static{
        this.properties = $6db9b00381e87aee$var$Properties;
    }
    static{
        this.projectile = $6db9b00381e87aee$var$Projectile;
    }
    static{
        this.durability = $6db9b00381e87aee$var$Durability;
    }
    static{
        this.material = $6db9b00381e87aee$var$Material;
    }
    static{
        this.inventory = $6db9b00381e87aee$var$InventoryMechanics;
    }
}


class $bfabb40259688a2c$var$Defense {
    static{
        this.maximumDefenseProbability = 0.8;
    }
    static{
        this.calculateDefenseProbability = (entity)=>{
            const pctOfTotalProtection = Math.min(this.maximumDefenseProbability, (0, $6db9b00381e87aee$export$ad15344118fbba9b).protection.computeProtectionPctOfMax(entity.inventory));
            return pctOfTotalProtection;
        };
    }
}
const $bfabb40259688a2c$export$6d75a3bc04682d1b = [
    "square",
    "circle",
    "random"
];
const $bfabb40259688a2c$export$b8160b859f21cc45 = [
    "defense",
    "strategic",
    "aggressive"
];
class $bfabb40259688a2c$var$Squad {
}
/**
 * How a fighting npc's walking speed is modulated, as multiples of its forged `maxSpeed`.
 *
 * `maxSpeed` is what a spawn is built with and never moves; `speed` is live, and CombatBrain is what
 * moves it -- faster for the duration of an attack, slower while circling a target it is not currently
 * swinging at. Both are written as `maxSpeed * <multiplier>`, which is the property anything reasoning
 * about npc pace depends on.
 *
 * They live down here in mechanics, rather than in the brain that applies them, because they are read
 * from two layers that must not import each other: `npc/brains/combat.ts` applies them, and the ember
 * wave table's approach ceiling has to account for them (`services/ember_wave_approach.ts`) -- a wave
 * whose approach sits just under the player's pace still LUNGES at 1.5x it, so a ceiling that ignored
 * this would only hold while nothing was being attacked.
 */ class $bfabb40259688a2c$var$NpcSpeed {
    static{
        /** While an attack is underway. */ this.attackMultiplier = 1.5;
    }
    static{
        /** While circling a target rather than closing on it. */ this.circleMultiplier = 0.5;
    }
}
class $bfabb40259688a2c$export$f1c3b8c7f0c3e30a {
    static{
        this.defense = $bfabb40259688a2c$var$Defense;
    }
    static{
        this.squad = $bfabb40259688a2c$var$Squad;
    }
    static{
        this.npcSpeed = $bfabb40259688a2c$var$NpcSpeed;
    }
}




const $831ce8568a4294bd$export$267e9a54988f18f1 = [
    "light",
    "webslow",
    "pushslow",
    "firehalo"
];
const $831ce8568a4294bd$export$49025350b8775b63 = [
    "light"
];
class $831ce8568a4294bd$export$b71c2cb4d3bdb35f {
    static{
        this.itemTypeToEffect = (itemTypeMeta)=>{
            return (0, $f684496fff50a7a1$export$be8fdcbd37253b73)[itemTypeMeta.type];
        };
    }
    static{
        this.getEntityEffects = (entity)=>{
            return entity?.flags?.appliedEffects || [];
        };
    }
    static{
        this.getEntityEffect = (entity, effect)=>{
            return this.getEntityEffects(entity).find((appliedEffect)=>appliedEffect.effect === effect);
        };
    }
    static{
        this.removeEntityEffect = (entity, effect)=>{
            if (!entity) return;
            const effects = this.getEntityEffects(entity).filter((appliedEffect)=>appliedEffect.effect !== effect);
            entity.lastStatsUpdateTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
            entity.flags.appliedEffects = effects;
        };
    }
    static{
        this.hasEntityEffect = (entity, effect)=>{
            return !!this.getEntityEffects(entity).find((appliedEffect)=>appliedEffect.effect === effect);
        };
    }
    static{
        this.persistableEffects = (effect)=>effect ? effect.filter((n)=>$831ce8568a4294bd$export$49025350b8775b63.includes(n)) : [];
    }
    static{
        this.addEntityEffect = (entity, effectDescriptor)=>{
            if (!entity || [
                "bullet",
                "system"
            ].includes(entity.entityType)) return [];
            const effects = this.getEntityEffects(entity).filter((appliedEffect)=>appliedEffect.effect !== effectDescriptor.effect);
            entity.lastStatsUpdateTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
            entity.flags.appliedEffects = [
                ...effects,
                {
                    ...effectDescriptor
                }
            ];
            return entity.flags.appliedEffects;
        };
    }
    static{
        this.contactEffectsFrom = (entity)=>{
            if (!entity) return [];
            return entity.flags?.contactEffects || [];
        };
    }
    static{
        this.isAffected = (entity, effect)=>{
            const race = entity?.appearance?.race;
            if (effect === "webslow") {
                if (race === "redspider") return false;
            }
            return true;
        };
    }
}



/** Authored additions reuse existing behavior, with explicit overrides. */ 
const $bcc08db80bb560e5$export$1efc94ac0295d345 = (race)=>{
    const visited = new Set();
    while((0, $30de942853303b03$export$b99fafb3f89f054a)[race] && !visited.has(race)){
        visited.add(race);
        race = (0, $30de942853303b03$export$b99fafb3f89f054a)[race].template;
    }
    return race;
};
const $bcc08db80bb560e5$export$6362571790b734f2 = (weapon)=>{
    const visited = new Set();
    while((0, $30de942853303b03$export$38495bb8ad3f939b)[weapon] && !visited.has(weapon)){
        visited.add(weapon);
        weapon = (0, $30de942853303b03$export$38495bb8ad3f939b)[weapon];
    }
    return weapon;
};







class $0fb3f7f2a67be6e3$var$Speed {
    static{
        this.minimum = 100;
    }
    static{
        this.maximum = 200;
    }
    static{
        this.pctIncrease = 0.045;
    }
    static{
        this.maximumSpeedEncumberancePct = 0.2;
    }
    static{
        /**
     * How long a player must ACTUALLY RUN before the game treats the run as learned.
     *
     * Running means both things at once: the run key held AND the body moving. Pressing the key is
     * not enough and never was a good proxy -- Shift also opens the building shape palette, so a
     * player laying a wall taps it without ever having run a step. That proxy decided two separate
     * things, and got both wrong: whether to RAISE the camp's run hint (server
     * campaigns/ember/run_hint.ts, via `Entity.hasBoosted`) and whether to DISMISS it (client
     * player.ts). A hint that vanishes before it has been read teaches nobody.
     *
     * A second is long enough to be a deliberate act rather than a stray keypress, and short enough
     * that nobody who meant to run has to hold it twice.
     *
     * Lives in common because both ends measure it and they must not drift: the client dismisses the
     * clue locally (no round trip, so the hint goes the moment the player has earned it) while the
     * server independently decides whether to raise it at all.
     */ this.runLearnedMs = 1000;
    }
    static{
        this.perPointIncrease = ()=>{
            const range = this.range();
            const upgradeAmount = Math.round(range * this.pctIncrease);
            return upgradeAmount;
        };
    }
    static{
        this.maximumNumberOfUpgrades = ()=>{
            return Math.floor(this.maximum / this.perPointIncrease());
        };
    }
    static{
        this.increaseCostFrom = (speed)=>{
            const diffFromMinimum = speed - this.minimum;
            const numberOfInceases = Math.floor(diffFromMinimum / this.perPointIncrease());
            return Math.max(1, Math.floor(Math.log2(numberOfInceases)));
        };
    }
    static{
        this.maxNormalizedSpeed = ()=>Math.floor((this.maximum - this.minimum) / this.perPointIncrease());
    }
    static{
        this.toNormalizedSpeed = (rawSpeed)=>Math.floor((rawSpeed - this.minimum) / this.perPointIncrease());
    }
    static{
        this.range = ()=>this.maximum - this.minimum;
    }
    static{
        this.toNormalizedSpeedPctOfMax = (rawSpeed)=>(rawSpeed - this.minimum) / this.range();
    }
    static{
        this.toNormalizedSpeedPctOfMin = (rawSpeed)=>rawSpeed / this.minimum;
    }
    static{
        this.fromPctOfMax = (pct)=>this.minimum + this.range() * pct;
    }
    static{
        this.upgrade = (fromSpeed)=>{
            if (fromSpeed >= this.maximum) return;
            const upgradeAmount = this.perPointIncrease();
            let updatedMax = fromSpeed + upgradeAmount;
            const diff = this.maximum - updatedMax;
            if (diff < upgradeAmount) updatedMax = this.maximum;
            if (updatedMax > this.maximum) return;
            return updatedMax;
        };
    }
    static{
        this.needsSpeedRecomputation = (entity, lastComputationTs)=>{
            const toCmpare = Math.max(entity.inventory.lastUpdateTs || 0, entity.lastStatsUpdateTs || 0);
            return toCmpare > lastComputationTs;
        };
    }
    static{
        this.effectiveSpeed = (entity, ignoreInventoryWeight = false)=>{
            if (entity.isPlayer()) {
                const baselineSpeed = entity.boosted ? entity.maxSpeed + Math.floor(entity.maxSpeed * Math.min(1.0, 0.6 + entity.boostPct)) : entity.maxSpeed;
                const weightSpeedReductionBudget = this.maximumSpeedEncumberancePct * this.maximum;
                const weightPctOfMax = ignoreInventoryWeight ? 0 : (0, $6db9b00381e87aee$export$ad15344118fbba9b).weight.computeWeightPctOfMax(entity.inventory);
                const speedReduction = Math.min(weightSpeedReductionBudget * weightPctOfMax, baselineSpeed * 0.65);
                const weightBased = baselineSpeed - speedReduction;
                const speed = weightBased * (entity.movingBackwards ? 0.7 : 1.0) * (entity.weaponCharge?.movementMultiplier ?? 1);
                const isSlowed = (0, $d3527b517d667178$export$4cfe0674a42ef84e).effect.hasEntityEffect(entity, "webslow");
                const isPushSlowed = (0, $d3527b517d667178$export$4cfe0674a42ef84e).effect.hasEntityEffect(entity, "pushslow");
                if (isSlowed) return speed * 0.2;
                else if (isPushSlowed) {
                    const pushSlowEffect = (0, $d3527b517d667178$export$4cfe0674a42ef84e).effect.getEntityEffect(entity, "pushslow");
                    const speedMultiplier = pushSlowEffect?.speedMultiplier || 0.7;
                    return speed * speedMultiplier;
                }
                return speed;
            } else {
                // for now ... entities aren't affected by boosts or weight
                const speed = entity.speed * (entity.movingBackwards ? 0.7 : 1.0) * (entity.weaponCharge?.movementMultiplier ?? 1);
                const isSlowed = (0, $d3527b517d667178$export$4cfe0674a42ef84e).effect.hasEntityEffect(entity, "webslow");
                return isSlowed ? speed * 0.2 : speed;
            }
        };
    }
}
class $0fb3f7f2a67be6e3$var$HitPoints {
    static{
        this.minimum = 3;
    }
    static{
        this.maximum = 50;
    }
    static{
        this.range = ()=>this.maximum - this.minimum;
    }
    static{
        this.perPointIncrease = ()=>1;
    }
    static{
        this.increaseCostFrom = (hp)=>{
            const diffFromMinimum = hp - this.minimum;
            const numberOfInceases = Math.floor(diffFromMinimum / this.perPointIncrease());
            return Math.max(1, Math.floor(Math.log2(numberOfInceases)));
        };
    }
    static{
        this.upgrade = (fromHp)=>{
            if (fromHp >= this.maximum) return;
            const upgradeAmount = this.perPointIncrease();
            let updatedMax = fromHp + upgradeAmount;
            const diff = this.maximum - updatedMax;
            if (diff < upgradeAmount) updatedMax = this.maximum;
            if (updatedMax > this.maximum) return;
            return updatedMax;
        };
    }
    static{
        this.fromPctOfMax = (pct)=>this.minimum + this.range() * pct;
    }
}
class $0fb3f7f2a67be6e3$var$Levels {
    static{
        this.maximum = 600;
    }
    static{
        this.upgradePointsForLevel = (level)=>{
            return Math.max(1, Math.floor(Math.log1p(level)));
        };
    }
    static{
        this.totalUpgradePointsPerLevel = {};
    }
    static{
        this.ugradePointsAtLevel = {};
    }
    static{
        let totalUpgradePoints = 0;
        for(let i = 1; i <= this.maximum; i++){
            const upgradePoints = this.upgradePointsForLevel(i);
            this.ugradePointsAtLevel[i] = upgradePoints;
            totalUpgradePoints += upgradePoints;
            this.totalUpgradePointsPerLevel[i] = totalUpgradePoints;
        }
    }
}
class $0fb3f7f2a67be6e3$var$MinMax {
    constructor(min, max){
        this.maximum = 100;
        this.minimum = 0;
        this.range = ()=>this.maximum - this.minimum;
        this.fromPctOfMax = (pct)=>this.minimum + this.range() * pct;
        this.toPctOfMax = (aggression)=>aggression / this.maximum;
        this.minimum = min;
        this.maximum = max;
    }
}
class $0fb3f7f2a67be6e3$var$Inventory {
    static{
        this.inventoryBearingNpcTypes = new Set();
    }
    static{
        this.inventoryBearingNpcTypes.add("zombie");
        this.inventoryBearingNpcTypes.add("outpost");
    }
    static{
        this.canEquipWeapon = (entity)=>{
            if ([
                "zombie"
            ].includes(entity.npcType)) return true;
            return false;
        };
    }
    static{
        this.hasEquipment = (entity)=>{
            if (entity.npcType) {
                if (entity.flags.forcePersist) return true;
                if (!this.inventoryBearingNpcTypes.has(entity.npcType)) return false;
                if (entity.npcType === "outpost") return true;
            }
            // for now ... only humanoids can have equipment
            // if (!Body.isHumanoid(entity?.appearance?.race)) {
            //     return false
            // }
            return true;
        };
    }
}
class $0fb3f7f2a67be6e3$var$Body {
    static{
        this.isStationary = (entity)=>{
            if ([
                "spikes1"
            ].includes(entity?.appearance?.race)) return true;
            return false;
        };
    }
    static{
        this.isHumanoid = (race)=>{
            return (0, $bf6244e5cc9aa116$export$2a4812914c68f73e).includes(race);
        };
    }
    static{
        this.isShort = (entity)=>{
            return !this.isHumanoid(entity?.appearance?.race);
        };
    }
    static{
        this.isFlat = (entity)=>{
            const race = (0, $bcc08db80bb560e5$export$1efc94ac0295d345)(entity?.appearance?.race);
            if (!race) return false;
            return [
                "spikes1"
            ].includes(race);
        };
    }
    static{
        this.isSmall = (entity)=>{
            const race = (0, $bcc08db80bb560e5$export$1efc94ac0295d345)(entity?.appearance?.race);
            if (!race) return false;
            if (this.isHumanoid(race)) return false;
            return [
                "slime",
                "rabbit",
                "chicken",
                "snake",
                "wasp"
            ].includes(race);
        };
    }
    static{
        this.hasAppearance = (npcType)=>{
            return ![
                "outpost",
                "collectable",
                "marker"
            ].includes(npcType);
        };
    }
    static{
        this.dimensions = (entity)=>{
            if (this.isHumanoid(entity?.appearance?.race)) return {
                w: 25,
                h: 50
            };
            return (0, $cb689cfa16c444ba$export$5b5223867019c37b)[entity.entityType];
        };
    }
    static{
        this.calculateCollisionBounds = (entity, bounds)=>{
            const isHorselike = [
                "deer",
                "horse"
            ].includes((0, $bcc08db80bb560e5$export$1efc94ac0295d345)(entity.appearance?.race) || "");
            const x = entity.location.x;
            const y = entity.location.y;
            if (isHorselike) {
                const direction = entity.getGrossOrientation();
                if (direction === "LeftRight") {
                    bounds.x1 = x - entity.dimensions.w;
                    bounds.y1 = y - entity.dimensions.h * 1.5;
                    bounds.x2 = x + entity.dimensions.w;
                    bounds.y2 = y + entity.dimensions.h * 0.5;
                } else {
                    bounds.x1 = x - entity.dimensions.w / 2;
                    bounds.y1 = y - entity.dimensions.h * 1.5;
                    bounds.x2 = x + entity.dimensions.w / 2;
                    bounds.y2 = y + entity.dimensions.h / 2;
                }
                return true;
            }
            return false;
        };
    }
    static{
        this.calculateZIndexBoost = (entity)=>{
            if (entity.npcType === "collectable") return 0;
            else // Standing bodies share the wall sprites' ground-depth origin. A size/race
            // penalty puts small creatures behind walls they have already walked in front of.
            return 100 + entity.location.y + ((0, $30de942853303b03$export$5bfd8bfbf03dc8d7).body?.[entity.appearance?.race]?.depthBias ?? 0);
        };
    }
}
class $0fb3f7f2a67be6e3$var$Psych {
    static{
        this.hostilityMinMax = new $0fb3f7f2a67be6e3$var$MinMax(0, 100);
    }
    static{
        this.hostility = ()=>this.hostilityMinMax;
    }
    static{
        this.attackPattern = (race)=>(0, $d3527b517d667178$export$4cfe0674a42ef84e).population.psych(race)?.attackPattern || "default";
    }
    static{
        this.aggroResponse = (race)=>(0, $d3527b517d667178$export$4cfe0674a42ef84e).population.psych(race)?.aggroResponse || "default";
    }
    static{
        this.closeOnStun = (race)=>(0, $d3527b517d667178$export$4cfe0674a42ef84e).population.psych(race)?.closeOnStun;
    }
}
const $0fb3f7f2a67be6e3$export$3a513633d965417d = [
    "burn",
    "take",
    "chat",
    "inventory",
    "crown",
    "button",
    "command",
    "food",
    "help",
    "descend"
];
const $0fb3f7f2a67be6e3$export$df3562c123d9be63 = {
    take: {
        label: "Take",
        priority: 70,
        neverPrimary: false
    },
    inventory: {
        label: "Items",
        priority: 65,
        neverPrimary: false
    },
    burn: {
        label: "Light",
        priority: 60,
        neverPrimary: false
    },
    button: {
        label: "Use",
        priority: 55,
        neverPrimary: false
    },
    crown: {
        label: "Crown",
        priority: 50,
        neverPrimary: false
    },
    command: {
        label: "Orders",
        priority: 45,
        neverPrimary: false
    },
    food: {
        label: "Give Food",
        priority: 40,
        neverPrimary: true
    },
    chat: {
        label: "Talk",
        priority: 10,
        neverPrimary: false
    },
    help: {
        label: "Hold to help up",
        priority: 80,
        neverPrimary: false
    },
    // High, and a bare tap takes it: standing at a hole in the ground, going in is the only thing
    // you came for. The label is overridden per entity ("Enter the mine").
    descend: {
        label: "Go down",
        priority: 75,
        neverPrimary: false
    }
};
const $0fb3f7f2a67be6e3$export$84e151b22524d21c = (descriptor)=>descriptor.label || $0fb3f7f2a67be6e3$export$df3562c123d9be63[descriptor.type]?.label || descriptor.type;
const $0fb3f7f2a67be6e3$export$73e01e1322ad10af = (descriptor)=>descriptor.priority ?? $0fb3f7f2a67be6e3$export$df3562c123d9be63[descriptor.type]?.priority ?? 0;
const $0fb3f7f2a67be6e3$export$70974b3c417d9dc7 = (descriptor)=>descriptor.neverPrimary ?? $0fb3f7f2a67be6e3$export$df3562c123d9be63[descriptor.type]?.neverPrimary ?? false;
const $0fb3f7f2a67be6e3$export$781c5ce8077cf3d7 = (descriptor)=>descriptor.holdDurationMs > 0;
const $0fb3f7f2a67be6e3$export$65634e3ec6b442de = (interactions)=>interactions.filter((descriptor)=>!$0fb3f7f2a67be6e3$export$781c5ce8077cf3d7(descriptor));
const $0fb3f7f2a67be6e3$export$d915060d878a7a90 = 12;
const $0fb3f7f2a67be6e3$export$3799b383fc0956ea = (type)=>type === "food";
const $0fb3f7f2a67be6e3$export$279c35a8a516c7b3 = (interactions)=>{
    if (!interactions) return [];
    const normalized = [];
    interactions.forEach((next)=>{
        const descriptor = typeof next === "string" ? {
            type: next
        } : next && typeof next === "object" ? next : undefined;
        if (!descriptor?.type || !$0fb3f7f2a67be6e3$export$3a513633d965417d.includes(descriptor.type)) return;
        normalized.push(descriptor);
    });
    return normalized;
};
const $0fb3f7f2a67be6e3$export$112177784473fc2f = (interactions)=>[
        ...interactions
    ].sort((a, b)=>{
        const byPriority = $0fb3f7f2a67be6e3$export$73e01e1322ad10af(b) - $0fb3f7f2a67be6e3$export$73e01e1322ad10af(a);
        if (byPriority !== 0) return byPriority;
        return $0fb3f7f2a67be6e3$export$3a513633d965417d.indexOf(a.type) - $0fb3f7f2a67be6e3$export$3a513633d965417d.indexOf(b.type);
    });
const $0fb3f7f2a67be6e3$export$24cb1bac32828cd1 = (interactions)=>{
    const ranked = $0fb3f7f2a67be6e3$export$112177784473fc2f($0fb3f7f2a67be6e3$export$279c35a8a516c7b3(interactions));
    if (ranked.length === 0) return {
        kind: "none"
    };
    if (ranked.length === 1 && !$0fb3f7f2a67be6e3$export$70974b3c417d9dc7(ranked[0])) return {
        kind: "single",
        interaction: ranked[0]
    };
    return {
        kind: "menu",
        interactions: ranked
    };
};
class $0fb3f7f2a67be6e3$var$Flags {
    static{
        this.updateFlag = (entity, flags)=>{
            const updateFlags = (entity, flag)=>{
                const value = flags[flag];
                if (value === null) // delete flag
                delete entity.flags[flag];
                else if (typeof value !== "string") entity.flags[flag] = value;
                else {
                    const result = value.matchAll(/\{(.*?)\}/g).next().value;
                    if (result) {
                        const matched = result[1];
                        const [operand, impact] = matched.split(":");
                        if (operand === "increment") {
                            const updatedValue = (entity.flags[flag] || 0) + parseInt(impact);
                            entity.flags[flag] = updatedValue;
                        }
                        if (operand === "decrement") {
                            const updatedValue = Math.max(0, (entity.flags[flag] || 0) - parseInt(impact));
                            entity.flags[flag] = updatedValue;
                        }
                        if (operand === "timestamp") entity.flags[flag] = (0, $4171652afd996934$export$a86190deb5c4a8d0)() + parseInt(impact);
                    } else entity.flags[flag] = value;
                }
            };
            if (entity) Object.keys(flags).forEach((flag)=>{
                updateFlags(entity, flag);
            });
            return entity;
        };
    }
}
class $0fb3f7f2a67be6e3$var$Interactions {
}
class $0fb3f7f2a67be6e3$export$bf48cba06b920fc0 {
    static{
        this.inventory = $0fb3f7f2a67be6e3$var$Inventory;
    }
    static{
        this.body = $0fb3f7f2a67be6e3$var$Body;
    }
    static{
        this.speed = $0fb3f7f2a67be6e3$var$Speed;
    }
    static{
        this.hitPoints = $0fb3f7f2a67be6e3$var$HitPoints;
    }
    static{
        this.levels = $0fb3f7f2a67be6e3$var$Levels;
    }
    static{
        this.psych = $0fb3f7f2a67be6e3$var$Psych;
    }
    static{
        this.interactions = $0fb3f7f2a67be6e3$var$Interactions;
    }
    static{
        this.flags = $0fb3f7f2a67be6e3$var$Flags;
    }
}



/** Stable content adapter; authoring never rewrites this module. */ 
let $7d8209f3c8c41e8b$export$40dde5e0c1bbd734 = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.tiles.damageDefaults;
let $7d8209f3c8c41e8b$export$166d0675377eb5ce = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.tiles.damageSpecifics;
// Rebuild the complete table group during preparation; activation only assigns bindings.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        EntityTilesDamageDefaults: catalog.source.tiles.damageDefaults,
        EntityTileDamageSpecifics: catalog.source.tiles.damageSpecifics
    }), (next)=>{
    $7d8209f3c8c41e8b$export$40dde5e0c1bbd734 = next.EntityTilesDamageDefaults;
    $7d8209f3c8c41e8b$export$166d0675377eb5ce = next.EntityTileDamageSpecifics;
});


class $e268b8ad73f8592a$export$ac354329a62081f3 {
    static{
        this.canRegen = (entityTile)=>{
            // can regen if there is a growth sequence defined
            return (0, $cdf806a94d4c01be$export$4783a51780b31483)[entityTile]?.growthSequence?.length > 0;
        };
    }
    static{
        this.hpDecrementOnHit = (entityTile, weaponType)=>{
            const specificDamage = (0, $7d8209f3c8c41e8b$export$166d0675377eb5ce)[entityTile]?.find((next)=>next.weaponType === weaponType)?.damage;
            if (specificDamage !== undefined) return specificDamage;
            const defaultDamage = (0, $7d8209f3c8c41e8b$export$40dde5e0c1bbd734)[entityTile];
            if (defaultDamage !== undefined) return defaultDamage;
            return 0;
        };
    }
}



const $fb270787c5863f7d$var$forcedPhase = null;
// "night"
// "day"
const $fb270787c5863f7d$var$dayLengthMinutes = 4;
const $fb270787c5863f7d$export$ddbab1c756f33643 = $fb270787c5863f7d$var$forcedPhase === "night" ? {
    night: {
        name: "night",
        brightness: 0.4,
        dayPct: 1.0
    }
} : $fb270787c5863f7d$var$forcedPhase === "day" ? {
    day: {
        name: "day",
        brightness: 1.0,
        dayPct: 1.0
    }
} : {
    dawn: {
        name: "dawn",
        brightness: 0.4,
        dayPct: 0.05
    },
    morning: {
        name: "morning",
        brightness: 0.7,
        dayPct: 0.2
    },
    day: {
        name: "day",
        brightness: 1.0,
        dayPct: 0.55
    },
    dusk: {
        name: "dusk",
        brightness: 0.5,
        dayPct: 0.6
    },
    night: {
        name: "night",
        brightness: 0.3,
        dayPct: 0.8
    },
    darkestNight: {
        name: "darkestNight",
        brightness: 0.2,
        dayPct: 1.0
    }
};
const $fb270787c5863f7d$export$fca8416b8f6d5cbe = Object.keys($fb270787c5863f7d$export$ddbab1c756f33643).map((n)=>n);
class $fb270787c5863f7d$export$c2f3c8cbbf29966c {
    static{
        this.pushable = (target)=>{
            return (target.npcType === "zombie" || target.npcType === "collectable" || target.entityType === "npc" || target.entityType === "player") && !target.immoveable && !target.isDownedForMovement();
        };
    }
    static{
        this.dayLengthClockCycles = ()=>$fb270787c5863f7d$var$dayLengthMinutes * 60;
    }
    static{
        this.computeDayPct = (clockTime)=>{
            const dayTick = clockTime % this.dayLengthClockCycles();
            const dayPct = dayTick / this.dayLengthClockCycles();
            return dayPct;
        };
    }
    static{
        this.computeDayPhase = (clockTime)=>{
            const dayPct = this.computeDayPct(clockTime);
            for(let i = 0; i < $fb270787c5863f7d$export$fca8416b8f6d5cbe.length; i++){
                const isFirst = i === 0;
                const isLast = i === $fb270787c5863f7d$export$fca8416b8f6d5cbe.length - 1;
                const thisPhase = $fb270787c5863f7d$export$ddbab1c756f33643[$fb270787c5863f7d$export$fca8416b8f6d5cbe[i]];
                const start = isFirst ? 0 : $fb270787c5863f7d$export$ddbab1c756f33643[$fb270787c5863f7d$export$fca8416b8f6d5cbe[i - 1]].dayPct;
                const end = thisPhase.dayPct;
                if (dayPct >= start && (isLast ? dayPct <= end : dayPct < end)) return thisPhase;
            }
            return null;
        };
    }
    static{
        this.isDay = (dayPhase)=>{
            return dayPhase?.name === "day" || dayPhase?.name === "morning";
        };
    }
    static{
        this.isNight = (dayPhase)=>{
            return dayPhase?.name === "night";
        };
    }
    static{
        this.campfireDurationClockCycles = ()=>this.dayLengthClockCycles() * 0.30;
    }
}




const $6c76a907098dd9e4$export$113856599367fb6f = (source, race, baselines)=>{
    const seen = new Set();
    const resolve = (id)=>{
        if (seen.has(id)) throw new Error(`Cyclic creature template: ${id}`);
        seen.add(id);
        const authored = source.sprites.creatures[id];
        const profile = source.profiles.population[id] || (!authored ? source.profiles.populationDefault : undefined);
        const base = profile ? (0, $6bc06c112d672e46$export$28144b69b93eae80)(profile, baselines) : resolve(authored.template);
        if (!authored) return base;
        return {
            ...base,
            preSpawnEffect: authored.preSpawnEffect !== undefined ? authored.preSpawnEffect : base.preSpawnEffect,
            maxSpeed: authored.speed ?? base.maxSpeed,
            hp: authored.hp ?? base.hp,
            scanDistanceTiles: authored.scanDistanceTiles ?? base.scanDistanceTiles,
            psych: {
                ...base.psych,
                hostility: authored.hostility ?? base.psych.hostility
            }
        };
    };
    return resolve(race);
};




class $0c969a2957f131f5$export$1bb73b2ee4464e6d {
    static{
        this.engineValues = ()=>({
                speed: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).speed,
                hp: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).hitPoints,
                hostility: (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0).psych.hostility(),
                tileSize: {
                    minimum: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                }
            });
    }
    static{
        this.resolved = new Map();
    }
    static{
        this.generation = -1;
    }
    static{
        this.baseline = (race)=>{
            if (this.generation !== (0, $e5c675b7b9585b42$export$eca3444cf0ef4f9a)()) {
                this.resolved.clear();
                this.generation = (0, $e5c675b7b9585b42$export$eca3444cf0ef4f9a)();
            }
            if (!this.resolved.has(race)) this.resolved.set(race, (0, $6c76a907098dd9e4$export$113856599367fb6f)((0, $e5c675b7b9585b42$export$8952b416ba38edb4).source, race, this.engineValues()));
            return this.resolved.get(race);
        };
    }
    static{
        this.speed = (race, pctOfMax = 1.0)=>{
            const baseline = this.baseline(race);
            return baseline.maxSpeed * pctOfMax;
        };
    }
    static{
        this.hp = (race, pctOfMax = 1.0)=>{
            const baseline = this.baseline(race);
            return baseline.hp * pctOfMax;
        };
    }
    static{
        this.scanDistanceTiles = (race)=>{
            const baseline = this.baseline(race);
            return baseline.scanDistanceTiles || 5;
        };
    }
    static{
        this.preSpawnEffect = (race)=>this.baseline(race).preSpawnEffect;
    }
    static{
        this.psych = (race)=>this.baseline(race).psych;
    }
}




class $f28fc484d2ef7500$export$4824be15bd3c96e6 {
    static{
        this.npcTypesAllowingDisposition = new Set();
    }
    static{
        this.npcTypesAllowingDisposition.add("zombie");
        this.npcTypesAllowingDisposition.add("marker");
    }
    static{
        this.isOutpostFaction = (f)=>f.startsWith("outpost");
    }
    static{
        this.parseStemFaction = (f)=>f.split("-")[0];
    }
    static{
        this.computeFactionDisposition = (aFaction, bFaction)=>{
            if (!aFaction || aFaction === "none") return "neutral";
            if (!bFaction || bFaction === "none") return "neutral";
            // if they don't belong to the same faction
            // or if neither belong to a faction
            if (aFaction !== bFaction) {
                // outpost isn't aggressive towards neutral faction
                if (this.isOutpostFaction(aFaction) && bFaction === "neutral") return "neutral";
                if (this.parseStemFaction(aFaction) === this.parseStemFaction(bFaction)) // recognize each other as neutral, if they have the same
                // stem faction
                return "neutral";
                // but everyone else is hostile to a different faction
                return "hostile";
            }
            return "neutral";
        };
    }
    static{
        this.addUnilateralDisposition = (entity, disposition)=>{
            if (!disposition) {
                delete entity.flags.unilateralDisposition;
                return;
            }
            entity.flags.unilateralDisposition = disposition;
        };
    }
    static{
        this.uniLateralDisposition = (entity)=>entity?.flags.unilateralDisposition;
    }
    static{
        this.hardCodedDisposition = (entity, other)=>{
            if (!other) return "neutral";
            if (entity.flags.entityDispositions) return entity.flags.entityDispositions[other.entityId] || "neutral";
            return "neutral";
        };
    }
    static{
        this.addHardCodedDisposition = (entity, other, disposition)=>{
            if (!other) return;
            if (!entity.flags.entityDispositions) entity.flags.entityDispositions = {};
            const otherEntityId = typeof other === "object" ? other.entityId : other;
            entity.flags.entityDispositions[otherEntityId] = disposition;
        };
    }
    static{
        this.removeHardCodedDisposition = (entity, other)=>{
            if (!entity.flags.entityDispositions) entity.flags.entityDispositions = {};
            delete entity.flags.entityDispositions[other.entityId];
        };
    }
    static{
        //
        // FACTION-WIDE DISPOSITION OVERRIDES
        //
        // `entity.flags.factionDispositions` maps a faction name to how THIS entity regards
        // everyone in it, overriding the default faction-vs-faction rules:
        //
        //     flags: { factionDispositions: { wild: "neutral" } }
        //
        // The common case is "ignore that faction entirely" (map it to "neutral"), which is how
        // the ember wave enemies stop getting distracted by "wild" wilderness creatures on their
        // way to the camp. It's the faction-wide sibling of `entityDispositions` (keyed by
        // entityId); the per-entity map is more specific and still wins.
        //
        // The override is ONE-WAY by design: configuring it on A changes how A regards B, not how
        // B regards A. In practice that's usually enough for both directions, because the hostile
        // scans (findHostilesNear, proximity scans) ask "does the OTHER entity regard me as
        // hostile" — so an entity that ignores a faction also drops out of that faction's scans.
        this.factionDisposition = (entity, otherFaction)=>{
            if (!entity || !otherFaction) return undefined;
            return entity.flags?.factionDispositions?.[otherFaction];
        };
    }
    static{
        // True when `entity` is configured to regard `other`'s whole faction as anything but
        // hostile — i.e. it should never pick `other` as a target. Targeting paths that bypass
        // computeDisposition (proximity scans, script hostile scans) consult this directly.
        this.ignoresFaction = (entity, other)=>{
            const disposition = this.factionDisposition(entity, other?.faction);
            return !!disposition && disposition !== "hostile";
        };
    }
    static{
        this.addFactionDisposition = (entity, faction, disposition)=>{
            if (!faction) return;
            if (!entity.flags.factionDispositions) entity.flags.factionDispositions = {};
            entity.flags.factionDispositions[faction] = disposition;
        };
    }
    static{
        this.removeFactionDisposition = (entity, faction)=>{
            if (!entity.flags.factionDispositions) return;
            delete entity.flags.factionDispositions[faction];
        };
    }
    static{
        // Faction-level disposition between two entities: the regarding entity's own faction
        // override first, then the default faction-vs-faction rules. Use this instead of
        // computeFactionDisposition wherever both entities are in hand.
        this.computeEntityFactionDisposition = (entity, other)=>{
            const override = this.factionDisposition(entity, other?.faction);
            return override !== undefined ? override : this.computeFactionDisposition(entity?.faction, other?.faction);
        };
    }
    static{
        this.makeNpcSafe = (entity, durationMs)=>{
            entity.npcSafeUntilTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)() + durationMs;
        };
    }
    static{
        this.computeDisposition = (entity, other, now)=>{
            // both need to be present to calculate
            if (!entity || !other) return "neutral";
            // its the same entity
            if (entity.entityId === other.entityId) return "neutral";
            // if the other is marked to be safe
            if (other.isNpcSafe()) return "neutral";
            // if the other is marked away from keyboard
            if (other.afk) return "neutral";
            // there's an explicit unilateral disposition
            if (!!other?.flags.unilateralDisposition) {
                if (entity.lastStruckEntityId === other.entityId && other.flags.undefined !== "hostile") return "hostile";
                return other?.flags.unilateralDisposition;
            }
            // there's a hardcoded disposition
            if (!!entity.flags.entityDispositions && entity.flags.entityDispositions[other.entityId]) return entity.flags.entityDispositions[other.entityId];
            // the entity leads the other entity
            if (other.leaderEntityId && entity.entityId === other.leaderEntityId) return "friendly";
            // if the other entity has the same leader
            if (entity.leaderEntityId && other.leaderEntityId && entity.leaderEntityId === other.leaderEntityId) return "friendly";
            // if the entity's leader is the other entity
            if (entity.leaderEntityId && entity.leaderEntityId === other.entityId) return "defender";
            // a faction-wide override on this entity (e.g. an ember wave enemy configured to
            // ignore the "wild" wilderness creatures it passes on its way to the camp). The more
            // specific relationships above — hardcoded per-entity dispositions, leader/squad ties —
            // still win.
            const factionOverride = this.factionDisposition(entity, other.faction);
            if (factionOverride) return factionOverride;
            if (other.faction === "none") return "neutral";
            if (entity.faction && other.faction && entity.faction === other.faction && entity.faction !== "neutral") return "friendly";
            // if they don't belong to the same faction
            // or if neither belong to a faction
            if (!entity.faction && !other.faction || entity.faction !== other.faction) return this.computeFactionDisposition(entity.faction, other.faction);
            // if struck by other entity recently -- hostility
            if (entity.lastStruckByEntityId && entity.lastStruckByEntityId === other.entityId) {
                const occurrenceTs = (now || (0, $4171652afd996934$export$a86190deb5c4a8d0)()) - entity.lastStruckTs;
                const distance = (0, $cb689cfa16c444ba$export$9d23471d635d220b)(entity, other);
                if (occurrenceTs < 10000) return "hostile";
            }
            // if my leader struck by other entity recently -- hostility
            if (entity.leaderEntityId && entity.leaderEntityId === other.lastStruckEntityId) {
                const occurrenceTs = (now || (0, $4171652afd996934$export$a86190deb5c4a8d0)()) - other.lastStruckEntityTs;
                if (occurrenceTs < 10000) return "hostile";
            }
            // if my leader struck the other entity recently -- hostility
            if (entity.leaderEntityId && entity.leaderEntityId === other.lastStruckByEntityId) {
                const occurrenceTs = (now || (0, $4171652afd996934$export$a86190deb5c4a8d0)()) - other.lastStruckTs;
                if (occurrenceTs < 10000) return "hostile";
            }
            // its NPC but its not something you can develop a disposition about (eg. inanimate object)
            if (!!other.npcType && !this.npcTypesAllowingDisposition.has(other.npcType)) return "neutral";
            // its NPC but its not something you can develop a disposition about (eg. inanimate object)
            if (!!entity.npcType && !this.npcTypesAllowingDisposition.has(entity.npcType)) return "neutral";
            // // aron is for debugging
            // if (other.name === "aron") {
            //     return "neutral"
            // }
            if (entity.flags?.attackNeutral) return "hostile";
            // no relationship ... by default its neutral
            return "neutral";
        };
    }
}


class $33f5907b647b6bf7$export$9840549df5e88ecc {
    static{
        this.getCurrentQuest = (entity)=>{
            const currentQuestId = entity?.context?.questsContainer?.currentQuestId;
            if (!currentQuestId) return;
            return entity?.context?.questsContainer?.activeQuests?.find((n)=>n.entityId === currentQuestId);
        };
    }
    static{
        this.setCurrentQuest = (entity, quest)=>{
            if (!entity.context) entity.context = {};
            const container = entity.context.questsContainer || {
                activeQuests: [],
                completedQuests: []
            };
            entity.context.questsContainer = container;
            container.currentQuestId = quest.entityId;
        };
    }
    static{
        this.getQuest = (entity, questId)=>{
            return entity?.context?.questsContainer?.activeQuests?.find((n)=>n.entityId === questId);
        };
    }
    static{
        this.isCurrentQuest = (entity, quest)=>{
            return this.getCurrentQuest(entity)?.entityId === quest.entityId;
        };
    }
    static{
        this.setActiveQuestMarker = (entity, questMarker)=>{
            if (!entity.context) entity.context = {};
            entity.context.questActiveMarkerId = questMarker.id;
            return entity;
        };
    }
    static{
        this.getActiveQuestMarkerId = (entity)=>{
            return entity.context?.questActiveMarkerId;
        };
    }
    static{
        this.setActiveQuestObjective = (originEntity, questId, objectiveId, markerLocation)=>{
            const quest = originEntity.context?.questsContainer?.activeQuests.find((n)=>n.entityId === questId);
            if (!quest) return originEntity;
            const active = quest.objectives?.find((n)=>n.status === "active");
            if (active) active.status = "complete";
            const objective = quest.objectives?.find((n)=>n.id === objectiveId);
            if (objective) {
                objective.status = "active";
                objective.markerLocation = markerLocation;
                // also set the current quest
                originEntity.context.questsContainer.currentQuestId = quest.entityId;
            }
            return originEntity;
        };
    }
    static{
        this.getActiveQuestObjective = (originEntity, questId)=>{
            const quest = originEntity.context?.questsContainer?.activeQuests.find((n)=>n.entityId === questId);
            return quest.objectives?.find((n)=>n.status === "active");
        };
    }
    static{
        this.addQuest = (entity, quest, setCurrent)=>{
            if (!entity.context) entity.context = {};
            const container = entity.context.questsContainer || {
                activeQuests: [],
                completedQuests: []
            };
            entity.context.questsContainer = container;
            if (!container.activeQuests.find((n)=>n.entityId === quest.entityId)) container.activeQuests.push(quest);
            if (setCurrent) container.currentQuestId = quest.entityId;
            return entity;
        };
    }
    static{
        this.completeQuest = (entity, questId)=>{
            if (!entity.context) entity.context = {};
            const container = entity.context.questsContainer || {
                activeQuests: [],
                completedQuests: []
            };
            entity.context.questsContainer = container;
            const quest = container.activeQuests.find((n)=>n.entityId === questId);
            if (quest) {
                quest.status = "complete";
                container.activeQuests = container.activeQuests.filter((n)=>n.entityId !== questId);
                if (!container.completedQuests.find((n)=>n.entityId === questId)) container.completedQuests.push(quest);
                // clear current quest id
                container.currentQuestId = undefined;
            }
            return entity;
        };
    }
    static{
        this.findActiveQuest = (entity)=>{
            return entity.context?.questsContainer?.activeQuests?.find((n)=>n.status === "active");
        };
    }
    static{
        this.destroyQuest = (entity, questId)=>{
            const quest = this.getQuest(entity, questId);
            if (!quest) return;
            entity.context.questsContainer.activeQuests = entity?.context?.questsContainer.activeQuests?.filter((n)=>n.entityId !== questId);
            return entity;
        };
    }
}


class $d3527b517d667178$export$4cfe0674a42ef84e {
    static{
        this.version = "1.0.0";
    }
    static{
        this.item = (0, $6db9b00381e87aee$export$ad15344118fbba9b);
    }
    static{
        this.entity = (0, $0fb3f7f2a67be6e3$export$bf48cba06b920fc0);
    }
    static{
        this.entityTile = (0, $e268b8ad73f8592a$export$ac354329a62081f3);
    }
    static{
        this.combat = (0, $bfabb40259688a2c$export$f1c3b8c7f0c3e30a);
    }
    static{
        this.social = (0, $f28fc484d2ef7500$export$4824be15bd3c96e6);
    }
    static{
        this.physics = (0, $fb270787c5863f7d$export$c2f3c8cbbf29966c);
    }
    static{
        this.population = (0, $0c969a2957f131f5$export$1bb73b2ee4464e6d);
    }
    static{
        this.effect = (0, $831ce8568a4294bd$export$b71c2cb4d3bdb35f);
    }
    static{
        this.quest = (0, $33f5907b647b6bf7$export$9840549df5e88ecc);
    }
}




const $992283fa114d4140$export$2dc9881c7e015178 = (provider, bounds, translate, result, allowAdjust)=>{
    if (!provider.getTileBlockingProfile) return false;
    // Composite roots can overhang their owner cell by up to one tile.
    const x1 = Math.max(0, Math.floor(Math.min(bounds.x1, bounds.x1 + translate.x) / 32) - 1);
    const x2 = Math.min(provider.width() - 1, Math.floor(Math.max(bounds.x2, bounds.x2 + translate.x) / 32) + 1);
    const y1 = Math.max(0, Math.floor(Math.min(bounds.y1, bounds.y1 + translate.y) / 32) - 1);
    const y2 = Math.min(provider.height() - 1, Math.floor(Math.max(bounds.y2, bounds.y2 + translate.y) / 32) + 1);
    const cells = [];
    let hasProfile = false;
    for(let x = x1; x <= x2; x++)for(let y = y1; y <= y2; y++){
        const profile = provider.getTileBlockingProfile(x, y);
        if (!provider.isCollisionAt(x, y) && !profile?.length) continue;
        if (profile) hasProfile = true;
        cells.push({
            x: x,
            y: y,
            profile: profile
        });
    }
    if (!hasProfile) return false;
    result.collided = false;
    const sweep = (axis, delta)=>{
        if (!delta) return;
        let accepted = delta;
        let hit;
        const direction = axis === "x" ? delta > 0 ? "Right" : "Left" : delta > 0 ? "Down" : "Up";
        for (const cell of cells){
            if (!cell.profile && !provider.isCollisionAt(cell.x, cell.y, bounds.centerCoordinate.x + (axis === "x" ? delta : 0), bounds.centerCoordinate.y + (axis === "y" ? delta : 0), direction)) continue;
            for (const local of cell.profile || [
                {
                    x: 0,
                    y: 0,
                    width: 32,
                    height: 32
                }
            ]){
                const bodyLeft = local.groundSupport ? (bounds.x1 + bounds.x2) / 2 : bounds.x1;
                const bodyRight = local.groundSupport ? bodyLeft : bounds.x2;
                const bodyTop = (0, $5ff29e9b920ad43b$export$197d934ee3c39f4d)(bounds.y1, bounds.y2, local);
                const bodyBottom = (0, $5ff29e9b920ad43b$export$29da78b220ab8d4d)(bounds.y1, bounds.y2, local);
                const left = cell.x * 32 + local.x, top = cell.y * 32 + local.y;
                const right = left + local.width, bottom = top + local.height;
                const near = axis === "x" ? bodyLeft : bodyTop;
                const far = axis === "x" ? bodyRight : bodyBottom;
                const obstacleNear = axis === "x" ? left : top;
                const obstacleFar = axis === "x" ? right : bottom;
                // A sole is a point: include tile seams in the perpendicular span so it
                // cannot slip between two touching support barriers. Inner band
                // boundaries stay open, allowing movement along the inset edge.
                const outsideSpan = local.groundSupport ? axis === "x" ? bodyTop > bottom || bodyBottom < top || bodyTop === bottom && local.y + local.height !== 32 || bodyBottom === top && local.y !== 0 : bodyLeft > right || bodyRight < left || bodyLeft === right && local.x + local.width !== 32 || bodyRight === left && local.x !== 0 : axis === "x" ? bodyTop >= bottom || bodyBottom <= top : bodyLeft >= right || bodyRight <= left;
                if (outsideSpan) continue;
                // Contact is legal; entry beyond it is not. Permit escape from a pre-existing overlap.
                let distance;
                if (delta > 0) {
                    if (near >= obstacleFar) continue;
                    if (far > obstacleNear && (near + far) / 2 > (obstacleNear + obstacleFar) / 2) continue;
                    distance = Math.max(0, obstacleNear - far);
                    if (distance >= accepted) continue;
                } else {
                    if (far <= obstacleNear) continue;
                    if (near < obstacleFar && (near + far) / 2 < (obstacleNear + obstacleFar) / 2) continue;
                    distance = Math.min(0, obstacleFar - near);
                    if (distance <= accepted) continue;
                }
                accepted = distance;
                hit = cell;
            }
        }
        if (hit) {
            result.collided = true;
            result.collision.x = hit.x;
            result.collision.y = hit.y;
            if (!allowAdjust) accepted = 0;
        }
        if (axis === "x") {
            bounds.x1 += accepted;
            bounds.x2 += accepted;
        } else {
            bounds.y1 += accepted;
            bounds.y2 += accepted;
        }
    };
    sweep("x", translate.x);
    sweep("y", translate.y);
    result.adjust.x = (bounds.x1 + bounds.x2) / 2;
    result.adjust.y = (bounds.y1 + bounds.y2) / 2;
    const probeX = result.collided ? result.collision.x : Math.floor((translate.x > 0 ? bounds.x2 : translate.x < 0 ? bounds.x1 : result.adjust.x) / 32);
    const probeY = result.collided ? result.collision.y : Math.floor((translate.y > 0 ? bounds.y2 : translate.y < 0 ? bounds.y1 : result.adjust.y) / 32);
    const intersection = provider.intersectionAt(probeX, probeY);
    if (intersection) {
        result.intersection.x = probeX;
        result.intersection.y = probeY;
        result.intersection.intersectionType = intersection;
    }
    return true;
};


const $cb689cfa16c444ba$export$29abb25bc3a2a243 = 32;
const $cb689cfa16c444ba$export$21eac3dda76c7241 = {
    ENABLED: true,
    FRICTION: 0.815,
    ACCELERATION: 0.4,
    MIN_VELOCITY_THRESHOLD: 0.01,
    UPDATE_FPS: 60
};
const $cb689cfa16c444ba$export$3b5e9888a97104e7 = [
    "Up",
    "Down",
    "Left",
    "Right"
];
const $cb689cfa16c444ba$export$86ae6e8ac17a67c6 = [
    ...$cb689cfa16c444ba$export$3b5e9888a97104e7,
    "DownRight",
    "DownLeft",
    "UpRight",
    "UpLeft"
];
const $cb689cfa16c444ba$var$weaponCharacteristicsFor = (catalog)=>{
    const base = (0, $6bc06c112d672e46$export$28144b69b93eae80)(catalog.source.profiles.weapons, {
        tileSize: {
            minimum: $cb689cfa16c444ba$export$29abb25bc3a2a243
        },
        speed: {
            minimum: 0
        },
        hp: {
            minimum: 0
        },
        hostility: {
            minimum: 0
        }
    });
    return {
        ...base,
        ...Object.fromEntries(Object.entries(catalog.weapons).map(([weapon, template])=>[
                weapon,
                {
                    ...base[template],
                    ...base[weapon]
                }
            ]))
    };
};
let $cb689cfa16c444ba$export$6e47733a887561b3 = $cb689cfa16c444ba$var$weaponCharacteristicsFor((0, $e5c675b7b9585b42$export$8952b416ba38edb4));
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)($cb689cfa16c444ba$var$weaponCharacteristicsFor, (next)=>{
    $cb689cfa16c444ba$export$6e47733a887561b3 = next;
});
const $cb689cfa16c444ba$export$1cd76c5103dfeb09 = {
    bomb: {
        equipOrder: 0,
        shortcutKey: "b",
        maxCarried: 20
    },
    heal: {
        equipOrder: 1,
        shortcutKey: "q",
        maxCarried: 3
    },
    mana: {
        equipOrder: 2,
        shortcutKey: "e",
        maxCarried: 2
    },
    speed: {
        equipOrder: 3,
        shortcutKey: "r"
    }
};
const $cb689cfa16c444ba$export$dd7412b0a9bf9701 = {
    showRoomName: false
};
const $cb689cfa16c444ba$export$ede76e7dc512924d = [
    "player",
    "bullet",
    "npc",
    "bomb"
];
const $cb689cfa16c444ba$export$e7d8be01a25416cb = [
    ...$cb689cfa16c444ba$export$ede76e7dc512924d,
    "system"
];
const $cb689cfa16c444ba$export$c894fd4e81634c0f = {
    w: 640,
    h: 360
};
const $cb689cfa16c444ba$export$5b5223867019c37b = {
    player: {
        w: 25,
        h: 25
    },
    npc: {
        w: 25,
        h: 25
    },
    bullet: {
        w: 15,
        h: 15
    },
    bomb: {
        w: 20,
        h: 20
    },
    system: {
        w: 0,
        h: 0
    }
};
class $cb689cfa16c444ba$export$cc41417b72b96611 {
    constructor(id, x, y){
        this.id = id;
        this.coordinate = {
            x: x,
            y: y
        };
    }
}
class $cb689cfa16c444ba$export$cbcb4f84fc8dd985 {
    set(id, item, unshift = false) {
        const isNew = !this._map[id];
        this._map[id] = item;
        if (isNew) {
            if (unshift) this.list.unshift(id);
            else this.list.push(id);
        }
    }
    remove(id) {
        const toRemove = this._map[id];
        if (toRemove) {
            delete this._map[id];
            // splice in place rather than this.list.filter(...), which allocated a new
            // array on every removal. EntityManager.remove calls this once per entity
            // TYPE (8x) per entity removed, and all but one of those calls is a miss --
            // indexOf returns -1 and we now allocate nothing at all for those.
            const idx = this.list.indexOf(id);
            if (idx > -1) this.list.splice(idx, 1);
        }
        return toRemove;
    }
    constructor(){
        this._map = {};
        this.list = [];
        this.clear = ()=>{
            this._map = {};
            this.list = [];
        };
        this.get = (id)=>{
            return this._map[id];
        };
        this.has = (id)=>{
            return !!this.get(id);
        };
        this.includes = (id)=>{
            return !!this.get(id);
        };
        this.getAtIdx = (idx)=>{
            if (idx > this.list.length - 1) return undefined;
            return this._map[this.list[idx]];
        };
        this.pop = ()=>{
            const obj = this.getAtIdx(0);
            if (obj) this.remove(obj.entityId);
            return obj;
        };
        this.keys = ()=>Object.keys(this._map);
        this.contains = (id)=>!!this._map[id];
        this.size = ()=>this.list.length;
        this.empty = ()=>this.size() < 1;
        this.add = (item)=>{
            return this.set(item.entityId, item);
        };
        this.iterate = (visitor, predicate)=>{
            this.list.forEach((n)=>{
                if (predicate) {
                    if (predicate(this._map[n])) visitor(this._map[n]);
                } else visitor(this._map[n]);
            });
        };
        this.forEach = this.iterate;
        this.map = (op)=>{
            return this.list.map((k)=>this._map[k]).map(op);
        };
        this.push = (item)=>{
            this.set(item.entityId, item);
        };
        this.filter = (predicate)=>{
            return this.list.map((n)=>this._map[n]).filter(predicate);
        };
        this.find = (predicate)=>{
            const key = this.list.find((n)=>{
                const item = this._map[n];
                if (predicate(item)) return true;
            });
            return key ? this._map[key] : undefined;
        };
        this.collect = (predicate)=>{
            if (!predicate) return [
                ...this.list.map((n)=>this._map[n])
            ];
            const collection = [];
            this.iterate((item)=>{
                collection.push(item);
            }, predicate);
            return collection;
        };
    }
}
class $cb689cfa16c444ba$export$7230fbaff49306c8 extends $cb689cfa16c444ba$export$cbcb4f84fc8dd985 {
    constructor(...args){
        super(...args), this.ctr = -1, this.next = ()=>{
            this.ctr++;
            if (this.ctr > this.size() - 1) this.ctr = 0;
            return this.getAtIdx(this.ctr);
        }, // -1, not 0, because next() PRE-increments: the counter starts life at -1 so the first next()
        // returns index 0, and a reset has to put it back in that same state. Setting it to 0 made the
        // next() after a reset return index 1, so element 0 was skipped every time round. Its one caller
        // is Metabrain.advance, where that meant the FIRST always-run trait of any npc whose pipeline
        // contains a "reset"-returning behaviour never ran at all -- see
        // docs/ember-wave-enemy-stall-analysis.md.
        this.reset = ()=>{
            this.ctr = -1;
        };
    }
}
class $cb689cfa16c444ba$export$aa8c1c798dd2d10a {
    constructor(){
        this.key1Map = new Map();
        this.key2Map = new Map();
        this.set = (val, key1, key2)=>{
            if (key1) this.key1Map.set(key1, val);
            if (key2) this.key2Map.set(key2, val);
        };
        this.remove = (key)=>{
            this.key1Map.delete(key);
            this.key2Map.delete(key);
        };
        this.get = (key)=>{
            const v1 = this.key1Map.get(key);
            const v2 = this.key2Map.get(key);
            return v1 || v2;
        };
        this.getExact = (key, key2)=>{
            const v1 = this.key1Map.get(key);
            const v2 = this.key2Map.get(key2);
            return v1 && v2 ? v1 : undefined;
        };
        this.has = (key)=>{
            return !!this.get(key);
        };
    }
}
class $cb689cfa16c444ba$export$ccc1bed6c7489102 extends $cb689cfa16c444ba$export$cbcb4f84fc8dd985 {
    set(id, item, unshift = false) {
        super.set(id, item, unshift);
        this.lastUpdatedTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
    }
    remove(id) {
        const removed = super.remove(id);
        // Only advance the "lights changed" timestamp when a light was actually
        // removed. Entity teardown calls lights.remove() for EVERY entity, including
        // non-light collectables (dropped wood/seeds). Bumping unconditionally
        // invalidated the shadow/visibility cache (the ts is part of its hash), forcing
        // a synchronous sight-polygon recompute + generateTexture on the next frame --
        // a visible hitch each time you walk over a dropped item.
        if (removed) this.lastUpdatedTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
        return removed;
    }
}
class $cb689cfa16c444ba$export$c4e9d269599ab4b4 {
    constructor(x1, y1, x2, y2){
        this.centerCoordinate = (0, $a80d0b17b615d6f7$export$b03ec757ccd6a9ce)();
        this.update = (x, y)=>{
            this.x1 = x - this.width / 2;
            this.y1 = y - this.height / 2;
            this.x2 = x + this.width / 2;
            this.y2 = x + this.height / 2;
            this.centerCoordinate.x = Math.floor(this.x1 + this.width / 2);
            this.centerCoordinate.y = Math.floor(this.y1 + this.height / 2);
            return this;
        };
        this.center = ()=>{
            return this.centerCoordinate;
        };
        this.clone = ()=>{
            return new $cb689cfa16c444ba$export$c4e9d269599ab4b4(this.x1, this.y1, this.x2, this.y2);
        };
        this.toString = ()=>{
            return `${this.x1},${this.y1},${this.x2},${this.y2}`;
        };
        this.expand = (amount)=>{
            this.x1 -= amount;
            this.y1 -= amount;
            this.x2 += amount;
            this.y2 += amount;
            this.recompute();
            return this;
        };
        this.shrink = (amount)=>{
            this.x1 += amount;
            this.y1 += amount;
            this.x2 -= amount;
            this.y2 -= amount;
            this.recompute();
            return this;
        };
        this.translate = (x, y)=>{
            this.x1 += x;
            this.x2 += x;
            this.y1 += y;
            this.y2 += y;
            this.recompute();
        };
        this.isCorner = (x, y)=>{
            if (this.x1 === x && this.y1 === y) return true;
            if (this.x2 - 1 === x && this.y1 === y) return true;
            if (this.x1 === x && this.y2 - 1 === y) return true;
            if (this.x2 - 1 === x && this.y2 - 1 === y) return true;
            return false;
        };
        this.visitEdges = (visitor, edge)=>{
            for(let x = this.topLeft().x; x < this.topLeft().x + this.width; x++){
                if (!edge || edge === "Up") visitor(x, this.topLeft().y);
                if (!edge || edge === "Down") visitor(x, this.topLeft().y + this.height - 1);
            }
            for(let y = this.topLeft().y; y < this.topLeft().y + this.height; y++){
                if (!edge || edge === "Left") visitor(this.topLeft().x + this.width - 1, y);
                if (!edge || edge === "Right") visitor(this.topLeft().x, y);
            }
        };
        this.randomEdge = (edge)=>{
            if (edge === "Up") return {
                x: $cb689cfa16c444ba$export$7bddc4d01a7cbd18(this.topLeft().x, this.topLeft().x + this.width),
                y: this.topLeft().y
            };
            if (edge === "Down") return {
                x: $cb689cfa16c444ba$export$7bddc4d01a7cbd18(this.topLeft().x, this.topLeft().x + this.width),
                y: this.topLeft().y + this.height - 1
            };
            if (edge === "Left") return {
                x: this.topLeft().x,
                y: $cb689cfa16c444ba$export$7bddc4d01a7cbd18(this.topLeft().y, this.topLeft().y + this.height)
            };
            if (edge === "Right") return {
                x: this.topLeft().x + this.width,
                y: $cb689cfa16c444ba$export$7bddc4d01a7cbd18(this.topLeft().y, this.topLeft().y + this.height)
            };
            return null;
        };
        this.getAllCoordinates = ()=>{
            const all = [];
            for(let x = this.topLeft().x; x < this.topLeft().x + this.width; x++)for(let y = this.topLeft().y; y < this.topLeft().y + this.height; y++)all.push({
                x: x,
                y: y
            });
            return all;
        };
        this.edgesAreClose = (other, threshold)=>{
            let failed = false;
            this.visitEdges((x, y)=>{
                if (failed) return;
                other.visitEdges((oX, oY)=>{
                    if (failed) return;
                    failed = $cb689cfa16c444ba$export$79376507b09a66f(x, y, oX, oY) < threshold;
                });
            });
            return failed;
        };
        this.widen = (otherBounds)=>{
            otherBounds.forEach((other, i)=>{
                if (i === 0) {
                    this.x1 = other.x1;
                    this.y1 = other.y1;
                    this.x2 = other.x2;
                    this.y2 = other.y2;
                } else {
                    if (other.x1 < this.x1) this.x1 = other.x1;
                    if (other.x2 > this.x2) this.x2 = other.x2;
                    if (other.y1 < this.y1) this.y1 = other.y1;
                    if (other.y2 > this.y2) this.y2 = other.y2;
                }
            });
            this.recompute();
        };
        this.topLeft = ()=>({
                x: this.x1,
                y: this.y1
            });
        this.topRight = ()=>({
                x: this.x2,
                y: this.y1
            });
        this.bottomLeft = ()=>({
                x: this.x1,
                y: this.y2
            });
        this.bottomRight = ()=>({
                x: this.x2,
                y: this.y2
            });
        this.widenViaCoordinate = (coordinate)=>{
            if (this.x1 === -1 || this.y1 === -1 || this.x2 === -1 || this.y2 === -1) {
                this.x1 = coordinate.x;
                this.y1 = coordinate.y;
                this.x2 = coordinate.x;
                this.y2 = coordinate.y;
            } else {
                if (this.includes(coordinate)) return;
                if (coordinate.x < this.x1) this.x1 = coordinate.x;
                if (coordinate.y < this.y1) this.y1 = coordinate.y;
                if (coordinate.x > this.x2) this.x2 = coordinate.x;
                if (coordinate.y > this.y2) this.y2 = coordinate.y;
            }
            this.recompute();
        };
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
        this.width = this.x2 - this.x1;
        this.height = this.y2 - this.y1;
        this.centerCoordinate.x = Math.floor(this.x1 + this.width / 2);
        this.centerCoordinate.y = Math.floor(this.y1 + this.height / 2);
    }
    static from(x, y, width, height) {
        return new $cb689cfa16c444ba$export$c4e9d269599ab4b4(x, y, x + width, y + height);
    }
    collision(other) {
        if (!other) return false;
        // Optimized AABB collision detection - early exit on non-collision
        // Check if bounds are separated on any axis (using > instead of >= to maintain touching behavior)
        return !(other.x1 > this.x2 || other.x2 < this.x1 || other.y1 > this.y2 || other.y2 < this.y1);
    }
    encloses(other) {
        return this.x1 <= other.x1 && this.x2 >= other.x2 && this.y1 <= other.y1 && this.y2 >= other.y2;
    }
    hasNegative() {
        return this.x1 < 0 || this.x2 < 0 || this.y1 < 0 || this.y2 < 0;
    }
    includes(other) {
        return !(other.x > this.x2 || other.x < this.x1 || other.y > this.y2 || other.y < this.y1);
    }
    recompute() {
        this.width = this.x2 - this.x1;
        this.height = this.y2 - this.y1;
        this.centerCoordinate.x = Math.floor(this.x1 + this.width / 2);
        this.centerCoordinate.y = Math.floor(this.y1 + this.height / 2);
    }
    static{
        this.createCenteredBounds = (x, y, width, height)=>{
            return new $cb689cfa16c444ba$export$c4e9d269599ab4b4(x - width / 2, y - height / 2, x + width / 2, y + height / 2);
        };
    }
}
const $cb689cfa16c444ba$export$9c8df8edf5099d2f = 600;
const $cb689cfa16c444ba$export$5ba2a289d3a4278 = 6;
const $cb689cfa16c444ba$export$b561b6feb9d8b940 = 200;
const $cb689cfa16c444ba$export$505f8954cbaa597 = 2;
class $cb689cfa16c444ba$export$57999cdfb043a089 {
}
class $cb689cfa16c444ba$export$bc644a473284d944 {
    constructor(){
        // Client-side interest lifecycle. Server entities remain authoritative; this is only the
        // render/update contract used to prevent stale cached positions from becoming visible.
        this.interestState = "active";
        this.maxSpeed = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.speed.minimum;
        this.speed = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.speed.minimum;
        this.speed2 = {
            x: 0,
            y: 0
        };
        this.position_buffer = [];
        this.input_sequence_number = 0;
        this.pending_inputs = [];
        this.entityState = "live";
        this.lastMoveTs = 0;
        this.hitByEntityIdTs = {};
        this.maxHp = 3;
        this.hp = 3;
        this.mana = 20;
        this.maxMana = 20;
        this.hunger = 20;
        this.maxHunger = 20;
        this.manaRecoveryDelay = 600;
        this.boostPct = 0.0;
        this.boostCost = $cb689cfa16c444ba$export$5ba2a289d3a4278;
        this.weight = 0;
        this.damage = 1;
        this.visible = true;
        this.flags = {};
        this.lastUpdateTs = null;
        this.lastRoomUpdateTs = 0;
        this.fromEntity = (entity)=>{
            this.fromJson(JSON.parse(JSON.stringify(entity)));
        };
        this.fromJson = (json)=>{
            if (!json) return;
            Object.keys(json).forEach((key)=>{
                const value = json[key];
                if (typeof this[key] !== "function") this[key] = value;
            });
            const fixedBounds = json.fixedBounds;
            this.bounds = undefined;
            if (fixedBounds) {
                this.fixedBounds = fixedBounds;
                this.bounds = new $cb689cfa16c444ba$export$c4e9d269599ab4b4(fixedBounds.x1, fixedBounds.y1, fixedBounds.x2, fixedBounds.y2);
            }
        };
        this.serializeToString = ()=>{
            return `${this.entityId}|${this.entityType}|${this.npcType || ""}|${this.faction || ""}|${this.entityState || ""}|${this.location.x}|${this.location.y}|${this.visible === true}|${this.strikeable}|${this.leaderEntityId || ""}|${this.dimensions.w}|${this.dimensions.h}|${this.expirationTs}|${this.flags ? JSON.stringify(this.flags) : ""}|${this.fixedBounds ? JSON.stringify(this.fixedBounds) : ""}|${JSON.stringify(this.movement)}|${this.paralyzeUntilTs}|${this.npcSafeUntilTs}|${this.afk === true}|${this.carried === true}|${this.speed}|${this.maxSpeed}|${this.lastStruckByEntityId || ""}|${this.lastStruckTs}|${this.lastStruckEntityId || ""}|${this.lastStruckEntityTs}`;
        };
        this.getGrossOrientation = ()=>{
            const direction = (0, $a80d0b17b615d6f7$export$94d6114d0f45bc7e)(this.movement.angle);
            if ([
                "Left",
                "Right"
            ].includes(direction)) return "LeftRight";
            else return "UpDown";
        };
        this.getCollisionBounds = (_x, _y)=>{
            if (this.fixedBounds) return this.bounds;
            const x = _x || this.location.x;
            const y = _y || this.location.y;
            if (!this.bounds) this.bounds = new $cb689cfa16c444ba$export$c4e9d269599ab4b4(0, 0, 0, 0);
            if ((0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.calculateCollisionBounds(this, this.bounds)) ;
            else {
                this.bounds.x1 = x - this.dimensions.w / 2;
                this.bounds.y1 = y - this.dimensions.h / 2;
                this.bounds.x2 = x + this.dimensions.w / 2;
                this.bounds.y2 = y + this.dimensions.h / 2;
            }
            this.bounds.recompute();
            return this.bounds;
        };
        this.getBounds = (_x, _y)=>{
            if (this.fixedBounds) return this.bounds;
            const x = _x || this.location.x;
            const y = _y || this.location.y;
            if (!this.bounds) this.bounds = new $cb689cfa16c444ba$export$c4e9d269599ab4b4(0, 0, 0, 0);
            this.bounds.x1 = x - (this.dimensions?.w || $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
            this.bounds.y1 = y - (this.dimensions?.h || $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
            this.bounds.x2 = x + (this.dimensions?.w || $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
            this.bounds.y2 = y + (this.dimensions?.h || $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
            this.bounds.recompute();
            return this.bounds;
        };
        this.getNavigationBounds = (_x, _y)=>{
            if (this.fixedBounds) return this.bounds;
            const x = _x || this.location.x;
            const y = _y || this.location.y;
            if (!this.bounds) this.bounds = new $cb689cfa16c444ba$export$c4e9d269599ab4b4(0, 0, 0, 0);
            // Always use standard 25x25 for navigation, same as players
            this.bounds.x1 = x - 12.5;
            this.bounds.y1 = y - 12.5;
            this.bounds.x2 = x + 12.5;
            this.bounds.y2 = y + 12.5;
            this.bounds.recompute();
            return this.bounds;
        };
        this.updateDimensions = (w, h)=>{
            this.dimensions = {
                w: w,
                h: h
            };
            return this.getBounds();
        };
        this.travelledDistance = ()=>{
            return $cb689cfa16c444ba$export$79376507b09a66f(this.origin?.x, this.origin?.y, this.location.x, this.location.y);
        };
        this.updateMana = (amt)=>{
            this.mana = Math.max(0, Math.min(this.maxMana, this.mana + amt));
        };
        this.updateHp = (amt)=>{
            this.hp = Math.max(0, Math.min(this.maxHp, this.hp + amt));
        };
        this.updateHunger = (amt)=>{
            this.hunger = Math.max(0, Math.min(this.maxHunger, this.hunger + amt));
        };
        this.hungerPct = ()=>{
            return this.hunger / this.maxHunger;
        };
        this.isDead = ()=>this.entityState === "dead";
        this.markDead = ()=>{
            (0, $968cce787b06be95$export$6816d1b3672c3e0b)(this);
            return this.entityState = "dead";
        };
        this.isPlayer = ()=>this.entityType === "player";
        this.isParalyzed = ()=>(this.paralyzeUntilTs || 0) > (0, $4171652afd996934$export$a86190deb5c4a8d0)();
        this.isDowned = ()=>(this.downedUntilTs || 0) > (0, $4171652afd996934$export$a86190deb5c4a8d0)();
        // Includes the server's fallen NPC states and their client-side pose mirrors.
        // Keep isDowned's respawn deadline semantics separate from these movement rules.
        this.isDownedForMovement = ()=>!!this.floorFall && !this.floorFall.stairJump || !!this.stairTravel || this.isDowned() || this.downed === true || this.rescuePose === "downed" || !!this.flags?.isSurvivor && !this.flags?.rescueFollowing || this.flags?.isLord === true && !this.isDead() && this.maxHp > 0 && this.hp < this.maxHp * 0.2;
        /**
     * Has this body FALLEN -- dead, or downed by either road: the server's own deadline
     * (`downedUntilTs`) or the per-message verdict the client mirrors onto `downed`. A client only
     * ever sees the second of those, which is why asking `isDowned()` alone answers no on the very
     * machine that is drawing the death screen.
     *
     * Deliberately NOT isDownedForMovement: that also counts a Lord at critical health and a
     * survivor awaiting rescue, which are movement rules. A Lord on 19% hp is very much still alive
     * as far as a health meter is concerned, and must not be drawn with empty hearts.
     */ this.hasFallen = ()=>this.isDead() || this.isDowned() || this.downed === true;
        this.isNpcSafe = ()=>(this.npcSafeUntilTs || 0) > (0, $4171652afd996934$export$a86190deb5c4a8d0)();
        this.safeName = ()=>{
            let name = this.name;
            if (!name) {
                name = this.appearance?.race || (this.flags?.isCampfire ? "campfire" : undefined) || (this.flags?.isFire ? "fire" : undefined) || this.npcType || this.entityType;
                name = this.isPlayer() ? `${name} player` : name;
            }
            const max = 15;
            if (name?.length > max) return name.substring(0, max - 3) + "...";
            return name;
        };
        this.resetHitByEntityIdTs = ()=>{
            this.hitByEntityIdTs = {};
        };
        this.canPersist = ()=>{
            return this.expirationTs === undefined && this.persistable === true;
        };
        this.lightIntensity = ()=>{
            return this.npcType === "light" ? 0.8 : this.lightMeta ? this.lightMeta.intensity : 0.6;
        };
        this.lightRadius = ()=>{
            return this.npcType === "light" ? 50 : this.lightMeta ? this.lightMeta.radius : 30;
        };
        this.location = {
            x: -1,
            y: -1
        };
        this.roomId = "tutorial1";
        this.origin = {
            x: -1,
            y: -1
        };
        this.movement = {
            moving: false,
            direction: "Up",
            angle: 0
        };
        this.position_buffer = [];
        this.inventory = {
            items: [],
            abilities: {},
            lastUpdateTs: (0, $4171652afd996934$export$a86190deb5c4a8d0)()
        };
        this.upgradePoints = 0;
        this.level = 1;
    }
    static{
        this.fromJson = (json)=>{
            if (!json) return;
            const entity = new $cb689cfa16c444ba$export$bc644a473284d944();
            entity.fromJson(json);
            return entity;
        };
    }
    static{
        this.fromString = (roomId, text)=>{
            if (!text) return;
            const [entityId, entityType, npcType, faction, entityState, x, y, visible, strikeable, leaderEntityId, dimensionsW, dimensionsH, expirationTs, flags, fixedBounds, movement, paralyzeUntilTs, npcSafeUntilTs, afk, carried, speed, maxSpeed, lastStruckByEntityId, lastStruckTs, lastStruckEntityId, lastStruckEntityTs] = text.split("|");
            const entity = new $cb689cfa16c444ba$export$bc644a473284d944();
            entity.entityId = entityId;
            entity.entityType = entityType;
            entity.npcType = npcType !== "null" && npcType !== "undefined" && npcType !== "" ? npcType : undefined;
            entity.faction = faction !== "null" && faction !== "undefined" && faction !== "" ? faction : undefined;
            entity.entityState = entityState !== "null" && entityState !== "undefined" && entityState !== "" ? entityState : undefined;
            entity.leaderEntityId = leaderEntityId !== "null" && leaderEntityId !== "undefined" && leaderEntityId !== "" ? leaderEntityId : undefined;
            entity.expirationTs = expirationTs !== "null" && expirationTs !== "undefined" ? parseInt(expirationTs) : undefined;
            entity.flags = flags !== "" ? JSON.parse(flags) : undefined;
            entity.paralyzeUntilTs = paralyzeUntilTs !== "null" && paralyzeUntilTs !== "undefined" ? Number.parseInt(paralyzeUntilTs) : undefined;
            entity.npcSafeUntilTs = npcSafeUntilTs !== "null" && npcSafeUntilTs !== "undefined" ? Number.parseInt(npcSafeUntilTs) : undefined;
            entity.carried = carried !== "null" && carried !== "undefined" ? carried === "true" : undefined;
            entity.afk = afk === "true";
            const location = {
                x: parseFloat(x),
                y: parseFloat(y)
            };
            entity.location = location;
            entity.roomId = roomId;
            entity.visible = visible === "true";
            entity.strikeable = strikeable === "true";
            entity.dimensions = {
                w: parseInt(dimensionsW),
                h: parseInt(dimensionsH)
            };
            if (fixedBounds) {
                entity.fixedBounds = JSON.parse(fixedBounds);
                const { x1: x1, y1: y1, x2: x2, y2: y2 } = entity.fixedBounds;
                entity.bounds = new $cb689cfa16c444ba$export$c4e9d269599ab4b4(x1, y1, x2, y2);
            }
            if (movement) entity.movement = JSON.parse(movement);
            entity.speed = Number(speed);
            entity.maxSpeed = Number(maxSpeed);
            entity.lastStruckByEntityId = lastStruckByEntityId;
            entity.lastStruckTs = lastStruckTs !== "null" && lastStruckTs !== "undefined" ? parseInt(lastStruckTs) : undefined;
            entity.lastStruckEntityId = lastStruckEntityId;
            entity.lastStruckEntityTs = lastStruckEntityTs !== "null" && lastStruckEntityTs !== "undefined" ? parseInt(lastStruckEntityTs) : undefined;
            return entity;
        };
    }
    applyInput(angle, press_timeRaw, speed2, applyInputResult, collisionMover, allowAdjust, allowSlide, useNavigationBounds) {
        if (this.stairTravel?.climb && !this.isDead() && !this.isDowned() && !this.downed && !this.floorFall && this.emberChapterAnnouncement === undefined) {
            if ((0, $968cce787b06be95$export$96236591fbe9bc32)(this, speed2, press_timeRaw)) {
                applyInputResult.movedX = false;
                applyInputResult.movedY = false;
                return;
            }
        }
        if (this.isDownedForMovement() || this.emberChapterAnnouncement !== undefined) {
            this.speed2.x = 0;
            this.speed2.y = 0;
            applyInputResult.movedX = false;
            applyInputResult.movedY = false;
            return;
        }
        const a = !speed2 ? undefined : (0, $a80d0b17b615d6f7$export$b363da9ded343252)(speed2, {
            x: 0,
            y: 0
        });
        const diagonal = a === undefined ? false : this.isPlayer() ? (0, $a80d0b17b615d6f7$export$df50878468f09592)(a) : false;
        const press_time = diagonal ? press_timeRaw * 0.7 : press_timeRaw;
        let x = 0, y = 0;
        let intersection = applyInputResult.intersection;
        if (angle !== undefined) this.movement.angle = angle;
        const initialX = this.location.x;
        const initialY = this.location.y;
        if (speed2 !== undefined) {
            if (allowSlide) {
                const xItem = (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.checkout();
                const yItem = (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.checkout();
                const resultX = (0, $22a1b96ddeb2d28f$export$90f229f3a0c9abea).instance.checkout();
                const resultY = (0, $22a1b96ddeb2d28f$export$90f229f3a0c9abea).instance.checkout();
                try {
                    x += speed2.x * press_time;
                    xItem.data.x = x;
                    xItem.data.y = 0;
                    const boundsToUseX = useNavigationBounds ? this.getNavigationBounds() : this.getBounds();
                    collisionMover(boundsToUseX, xItem.data, resultX.data, allowAdjust);
                    const { adjust: adjustX, collided: collidedX, collision: c1, intersection: i1 } = resultX.data;
                    y += speed2.y * press_time;
                    yItem.data.x = 0;
                    yItem.data.y = y;
                    this.location.x = Math.max(adjustX.x, 0);
                    const boundsToUseY = useNavigationBounds ? this.getNavigationBounds() : this.getBounds();
                    collisionMover(boundsToUseY, yItem.data, resultY.data, allowAdjust);
                    const { adjust: adjustY, collided: collidedY, collision: c2, intersection: i2 } = resultY.data;
                    this.location.y = Math.max(adjustY.y, 0);
                    const collision = collidedX ? c1 : c2;
                    applyInputResult.collision.x = collision?.x;
                    applyInputResult.collision.y = collision?.y;
                    applyInputResult.intersection.x = (!(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(i1) ? i1 : !(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(i2) ? i2 : undefined)?.x;
                    applyInputResult.intersection.y = (!(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(i1) ? i1 : !(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(i2) ? i2 : undefined)?.y;
                    applyInputResult.intersection.intersectionType = (!(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(i1) ? i1 : !(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(i2) ? i2 : undefined)?.intersectionType;
                } finally{
                    (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.release(xItem);
                    (0, $22a1b96ddeb2d28f$export$90f229f3a0c9abea).instance.release(resultX);
                    (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.release(yItem);
                    (0, $22a1b96ddeb2d28f$export$90f229f3a0c9abea).instance.release(resultY);
                }
            } else {
                const item = (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.checkout();
                const result = (0, $22a1b96ddeb2d28f$export$90f229f3a0c9abea).instance.checkout();
                try {
                    x += speed2.x * press_time;
                    y += speed2.y * press_time;
                    item.data.x = x;
                    item.data.y = y;
                    const boundsToUse = useNavigationBounds ? this.getNavigationBounds() : this.getBounds();
                    collisionMover(boundsToUse, item.data, result.data, allowAdjust);
                    const { adjust: adjust, collided: collided, collision: collision, intersection: i1 } = result.data;
                    (0, $a80d0b17b615d6f7$export$5afd74d1b598607d)(i1, intersection);
                    intersection.intersectionType = i1.intersectionType;
                    if (collided) {
                        applyInputResult.movedX = false;
                        applyInputResult.movedY = false;
                        applyInputResult.collision.x = collision.x;
                        applyInputResult.collision.y = collision.y;
                        (0, $a80d0b17b615d6f7$export$5afd74d1b598607d)(intersection, applyInputResult.intersection);
                        applyInputResult.intersection.intersectionType = intersection.intersectionType;
                        return;
                    }
                    this.location.x = Math.max(adjust.x, 0);
                    this.location.y = Math.max(adjust.y, 0);
                } finally{
                    (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.release(item);
                    (0, $22a1b96ddeb2d28f$export$90f229f3a0c9abea).instance.release(result);
                }
            }
            applyInputResult.movedX = this.location.x !== initialX;
            applyInputResult.movedY = this.location.y !== initialY;
            if (applyInputResult.movedX || applyInputResult.movedY) this.lastMoveTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
        } else {
            // No movement input, so no movement
            applyInputResult.movedX = false;
            applyInputResult.movedY = false;
        }
    }
}
const $cb689cfa16c444ba$export$79376507b09a66f = (x1, y1, x2, y2)=>{
    let y = x2 - x1;
    let x = y2 - y1;
    return Math.sqrt(x * x + y * y);
};
const $cb689cfa16c444ba$export$72a3639d5dd4d5f8 = (a, b)=>$cb689cfa16c444ba$export$79376507b09a66f(a.x, a.y, b.x, b.y);
const $cb689cfa16c444ba$export$9d23471d635d220b = (e1, e2)=>{
    return $cb689cfa16c444ba$export$79376507b09a66f(e1.location.x, e1.location.y, e2.location.x, e2.location.y);
};
const $cb689cfa16c444ba$export$7bddc4d01a7cbd18 = (min, max, options)=>{
    // min and max included
    if (options?.seed) return (0, $a80d0b17b615d6f7$export$c45e8adbbf82647d)(min, max, options.seed);
    const fnToUse = options?.rngFn || Math.random;
    return Math.floor(fnToUse() * (max - min + 1) + min);
};
const $cb689cfa16c444ba$export$3fd68433dc33f3f9 = (min, max)=>{
    const str = (Math.random() * (max - min) + min).toFixed(3);
    return parseFloat(str);
};
const $cb689cfa16c444ba$export$30be1f861efc6479 = (pct, options)=>{
    // min and max included
    if (options?.randomIntBetween) return options.randomIntBetween(0, 100) >= 100 - pct;
    if (options?.seed) return $cb689cfa16c444ba$export$7bddc4d01a7cbd18(0, 100, {
        seed: options.seed
    }) >= 100 - pct;
    return $cb689cfa16c444ba$export$7bddc4d01a7cbd18(0, 100) >= 100 - pct;
};
const $cb689cfa16c444ba$export$b3b584c8d6ffe165 = ()=>{
    return $cb689cfa16c444ba$export$30be1f861efc6479(50);
};
const $cb689cfa16c444ba$export$403e7832f3d01519 = ()=>{
    return {
        tileTypes: []
    };
};
const $cb689cfa16c444ba$export$e08736116838d313 = (tilemapMeta)=>{
    const { isCollisionAt: isCollisionAt } = tilemapMeta;
    const func = (bounds)=>{
        const x = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMeta.width());
        const y1 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMeta.height());
        const y2 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMeta.height());
        for(let y = y1; y <= y2; y++){
            if (x > tilemapMeta.width() - 1 || y > tilemapMeta.height() - 1) continue;
            if (isCollisionAt(x, y)) return true;
        }
        const x1 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMeta.width());
        const x2 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMeta.height());
        const y = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMeta.height());
        for(let x = x1; x <= x2; x++){
            if (x > tilemapMeta.width() - 1 || y > tilemapMeta.height() - 1) continue;
            if (isCollisionAt(x, y)) return true;
        }
    };
    return func;
};
const $cb689cfa16c444ba$export$7e89f2bfd67dd894 = (tilemapMetaProvider, allowAdjust, useGroundFootprints = true, allowEscapeFromOverlap = false)=>{
    const { isCollisionAt: isCollisionAt, intersectionAt: intersectionAt } = tilemapMetaProvider;
    const func = (bounds, translate, result, adjust = allowAdjust)=>{
        if (useGroundFootprints && (0, $992283fa114d4140$export$2dc9881c7e015178)(tilemapMetaProvider, bounds, translate, result, !!adjust)) return;
        let blocked = false;
        const start = {
            x1: bounds.x1,
            y1: bounds.y1,
            x2: bounds.x2,
            y2: bounds.y2
        };
        const collidesAt = !allowEscapeFromOverlap ? isCollisionAt : (x, y)=>{
            if (!isCollisionAt(x, y)) return false;
            const left = x * $cb689cfa16c444ba$export$29abb25bc3a2a243, top = y * $cb689cfa16c444ba$export$29abb25bc3a2a243;
            const overlaps = start.x1 < left + $cb689cfa16c444ba$export$29abb25bc3a2a243 && start.x2 > left && start.y1 < top + $cb689cfa16c444ba$export$29abb25bc3a2a243 && start.y2 > top;
            // A projectile can start inside the full-cell wall box while its shooter
            // stands legally beneath the raised wall face. Let it move out of that
            // overlap; an approaching shot or one aimed deeper into the wall still hits.
            const away = ((start.x1 + start.x2) / 2 - left - $cb689cfa16c444ba$export$29abb25bc3a2a243 / 2) * translate.x + ((start.y1 + start.y2) / 2 - top - $cb689cfa16c444ba$export$29abb25bc3a2a243 / 2) * translate.y;
            return !(overlaps && away > 0);
        };
        if (allowEscapeFromOverlap && (translate.x || translate.y)) {
            // Check the starting cells too: a long server tick can otherwise jump from
            // an embedded muzzle straight past the wall without probing its cell.
            for(let x = Math.max(0, Math.floor(start.x1 / $cb689cfa16c444ba$export$29abb25bc3a2a243)); x < Math.ceil(start.x2 / $cb689cfa16c444ba$export$29abb25bc3a2a243); x++)for(let y = Math.max(0, Math.floor(start.y1 / $cb689cfa16c444ba$export$29abb25bc3a2a243)); y < Math.ceil(start.y2 / $cb689cfa16c444ba$export$29abb25bc3a2a243); y++){
                if (!collidesAt(x, y)) continue;
                result.collided = true;
                result.collision.x = x;
                result.collision.y = y;
                result.adjust.x = (start.x1 + start.x2) / 2;
                result.adjust.y = (start.y1 + start.y2) / 2;
                const intersection = intersectionAt(x, y);
                if (intersection) {
                    result.intersection.x = x;
                    result.intersection.y = y;
                    result.intersection.intersectionType = intersection;
                }
                return;
            }
        }
        // going right
        if (translate.x > 0) {
            const x = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor((bounds.x2 + translate.x) / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.width());
            const y1 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            const y2 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            let adjust = undefined;
            for(let y = y1; y <= y2; y++){
                if (x > tilemapMetaProvider.width() - 1 || y > tilemapMetaProvider.height() - 1) continue;
                const collides = collidesAt(x, y, bounds.centerCoordinate.x + translate.x, bounds.centerCoordinate.y + translate.y, "Right");
                if (collides) {
                    blocked = true;
                    adjust = x * $cb689cfa16c444ba$export$29abb25bc3a2a243 - 1;
                    result.collision.x = x;
                    result.collision.y = y;
                }
            }
            if (!blocked) {
                bounds.x1 += translate.x;
                bounds.x2 += translate.x;
            } else if (allowAdjust) {
                bounds.x2 = adjust;
                bounds.x1 = adjust - bounds.width;
            }
        }
        // // going left
        if (translate.x < 0) {
            const x = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor((bounds.x1 + translate.x) / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.width());
            const y1 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            const y2 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.y2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            let adjust = undefined;
            for(let y = y1; y <= y2; y++){
                if (x > tilemapMetaProvider.width() - 1 || y > tilemapMetaProvider.height() - 1) continue;
                if (collidesAt(x, y, bounds.centerCoordinate.x + translate.x, bounds.centerCoordinate.y + translate.y, "Left")) {
                    blocked = true;
                    adjust = x * $cb689cfa16c444ba$export$29abb25bc3a2a243 + $cb689cfa16c444ba$export$29abb25bc3a2a243 + 1;
                    result.collision.x = x;
                    result.collision.y = y;
                }
            }
            if (!blocked) {
                bounds.x1 += translate.x;
                bounds.x2 += translate.x;
            } else if (allowAdjust) {
                bounds.x1 = adjust;
                bounds.x2 = adjust + bounds.width;
            }
        }
        // going up
        if (translate.y < 0) {
            const x1 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.width());
            const x2 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.width());
            const y = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor((bounds.y1 + translate.y) / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            let adjust = undefined;
            for(let x = x1; x <= x2; x++){
                if (x > tilemapMetaProvider.width() - 1 || y > tilemapMetaProvider.height() - 1) continue;
                if (collidesAt(x, y, bounds.centerCoordinate.x + translate.x, bounds.centerCoordinate.y + translate.y, "Up")) {
                    blocked = true;
                    adjust = y * $cb689cfa16c444ba$export$29abb25bc3a2a243 + $cb689cfa16c444ba$export$29abb25bc3a2a243 + 1;
                    result.collision.x = x;
                    result.collision.y = y;
                }
            }
            if (!blocked) {
                bounds.y1 += translate.y;
                bounds.y2 += translate.y;
            } else if (allowAdjust) {
                bounds.y1 = adjust;
                bounds.y2 = adjust + bounds.height;
            }
        }
        // going down
        if (translate.y > 0) {
            const x1 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x1 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            const x2 = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor(bounds.x2 / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            const y = (0, $a80d0b17b615d6f7$export$7d15b64cf5a3a4c4)(Math.floor((bounds.y2 + translate.y) / $cb689cfa16c444ba$export$29abb25bc3a2a243), 0, tilemapMetaProvider.height());
            let adjust = undefined;
            for(let x = x1; x <= x2; x++){
                if (x > tilemapMetaProvider.width() - 1 || y > tilemapMetaProvider.height() - 1) continue;
                if (collidesAt(x, y, bounds.centerCoordinate.x + translate.x, bounds.centerCoordinate.y + translate.y, "Down")) {
                    blocked = true;
                    adjust = y * $cb689cfa16c444ba$export$29abb25bc3a2a243 - 1;
                    result.collision.x = x;
                    result.collision.y = y;
                }
            }
            if (!blocked) {
                bounds.y1 += translate.y;
                bounds.y2 += translate.y;
            } else if (allowAdjust) {
                bounds.y1 = adjust - bounds.height;
                bounds.y2 = adjust;
            }
        }
        result.collided = blocked;
        const x = bounds.x1 + bounds.width / 2;
        const y = bounds.y1 + bounds.height / 2;
        // The bounds already contain the accepted movement. Probe the leading edge,
        // using the centre on a stationary axis, or the actual blocking cell on impact.
        const probeX = translate.x > 0 ? bounds.x2 : translate.x < 0 ? bounds.x1 : x;
        const probeY = translate.y > 0 ? bounds.y2 : translate.y < 0 ? bounds.y1 : y;
        const xx = blocked ? result.collision.x : Math.floor(probeX / $cb689cfa16c444ba$export$29abb25bc3a2a243);
        const yy = blocked ? result.collision.y : Math.floor(probeY / $cb689cfa16c444ba$export$29abb25bc3a2a243);
        const intersection = intersectionAt(xx, yy);
        if (intersection) {
            result.intersection.x = xx;
            result.intersection.y = yy;
            result.intersection.intersectionType = intersection;
        }
        result.adjust.x = x;
        result.adjust.y = y;
    };
    return func;
};
class $cb689cfa16c444ba$export$b56caa74c129a90c {
    constructor(threshold, now, expireCallback){
        /**
     * `now` lets a caller that has ALREADY read the clock hand its reading in rather than paying for
     * another one. Same semantics either way; it exists for hot loops that read the clock anyway
     * (see NpcManager.advanceNpcs, where the latch behind a Thruput was the fourth reading per npc).
     */ this.expired = (write = true, now = (0, $4171652afd996934$export$a86190deb5c4a8d0)())=>{
            if (now - this.ts > this.threshold) {
                if (!this.singleUse && write) this.ts = now;
                if (this.expireCallback) this.expireCallback();
                return true;
            }
            return false;
        };
        this.update = (threshold)=>{
            this.threshold = threshold;
        };
        this.reset = ()=>this.ts = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
        this.clear = ()=>this.ts = 0;
        this.ts = now || 0;
        this.threshold = threshold;
        this.expireCallback = expireCallback;
    }
}
const $cb689cfa16c444ba$export$c8c6d6e2d9b5390d = "sigil";
const $cb689cfa16c444ba$export$1bb94dd20d93df2d = "Limbo";
const $cb689cfa16c444ba$export$d63e9b5687ab18eb = "possession";
const $cb689cfa16c444ba$export$31a13f058b1e12c3 = "possessedBy";
const $cb689cfa16c444ba$export$ce7e2d4b62e55311 = "possessedPresence";
const $cb689cfa16c444ba$export$ec1f55a13cc9f82d = (entity)=>!!entity?.flags?.[$cb689cfa16c444ba$export$d63e9b5687ab18eb];
const $cb689cfa16c444ba$export$1b6f57988e845c = (entity)=>!!entity?.flags?.[$cb689cfa16c444ba$export$31a13f058b1e12c3];
const $cb689cfa16c444ba$export$8e84fd862f8e00d4 = (entity)=>entity?.flags?.[$cb689cfa16c444ba$export$d63e9b5687ab18eb]?.vesselEntityId;
const $cb689cfa16c444ba$export$13ed58ba57f3fe76 = (entity)=>entity?.flags?.[$cb689cfa16c444ba$export$31a13f058b1e12c3];
const $cb689cfa16c444ba$export$393c772047e6bffb = "invasion";
const $cb689cfa16c444ba$export$5fab807a8414b6a0 = (entity)=>!!entity?.flags?.[$cb689cfa16c444ba$export$393c772047e6bffb];
const $cb689cfa16c444ba$export$6973a44df0ae6af3 = "openToTheDead";
const $cb689cfa16c444ba$export$ded21fbd09134750 = (entity)=>!!entity?.flags?.[$cb689cfa16c444ba$export$6973a44df0ae6af3];
const $cb689cfa16c444ba$export$e2bee4d6bf0aad4f = (entity)=>entity?.flags?.[$cb689cfa16c444ba$export$393c772047e6bffb];
const $cb689cfa16c444ba$export$8e7d91cd700396c0 = [
    "ember-run",
    "ember-ready",
    "ember-wood",
    "ember-wood-items",
    "ember-wood-pack",
    "ember-wood-use",
    "ember-items",
    "ember-planks-items",
    "ember-crafting",
    "ember-planks-recipe",
    "ember-wall-recipe",
    "ember-wall-pack",
    "ember-wall-use",
    "ember-roof-recipe",
    "ember-roof-pack",
    "ember-roof-use",
    "ember-recipe",
    "ember-pack",
    "ember-use",
    "ember-close"
];
const $cb689cfa16c444ba$export$a35d0571df2da201 = (tutorialType)=>!!tutorialType && $cb689cfa16c444ba$export$8e7d91cd700396c0.includes(tutorialType);
const $cb689cfa16c444ba$export$ae5c2924da49a08c = 6;
const $cb689cfa16c444ba$export$d84fb6ad88214660 = (tileMap, visitor)=>{
    for(let y = 0; y < tileMap.length; y++)for(let x = 0; x < tileMap[y].length; x++)visitor(x, y, tileMap[y][x]);
};
const $cb689cfa16c444ba$export$5a0c0bb94c271893 = "emberAnxietySense";



parcelRequire("1avo5");
var $kXE1p = parcelRequire("kXE1p");
/** A cached low-frequency noise buffer, played through the existing audio context. */ class $f1bdd10a2a9b0ff6$export$6603c70e99928aec {
    constructor(){
        this.play = (context, destination, volume)=>{
            if (context.state !== "running") return;
            this.stop();
            if (!this.buffer) {
                this.buffer = context.createBuffer(1, 48000, 16000);
                const data = this.buffer.getChannelData(0);
                let low = 0;
                for(let i = 0; i < data.length; i++){
                    low = low * 0.94 + (Math.random() * 2 - 1) * 0.06;
                    data[i] = low * 4 * Math.exp(-i / 18000);
                }
            }
            const source = context.createBufferSource();
            const gain = context.createGain();
            source.buffer = this.buffer;
            gain.gain.setValueAtTime(0, context.currentTime);
            gain.gain.linearRampToValueAtTime(volume, context.currentTime + 0.08);
            gain.gain.exponentialRampToValueAtTime(0.001, context.currentTime + 3);
            source.connect(gain);
            gain.connect(destination);
            source.onended = ()=>{
                source.disconnect();
                gain.disconnect();
                if (this.source === source) this.source = undefined;
            };
            this.source = source;
            this.gain = gain;
            source.start();
        };
        this.stop = ()=>{
            this.source?.stop();
            this.source = undefined;
            this.gain?.disconnect();
            this.gain = undefined;
        };
    }
}


class $c4544ebb4d826faa$export$bded0763316335f6 {
    constructor(play){
        this.play = play;
        this.lastAt = 0;
        this.retryAt = 0;
        this.stop = ()=>{
            const track = this.track;
            this.track = undefined;
            track?.player?.stop();
        };
        this.update = (key, volume, now)=>{
            const elapsed = Math.min(100, Math.max(0, now - this.lastAt));
            this.lastAt = now;
            if (!key) {
                this.stop();
                return;
            }
            if (this.track && this.track.key !== key) this.stop();
            if (!this.track && volume > 0 && now >= this.retryAt) {
                const track = {
                    key: key,
                    volume: 0,
                    player: undefined
                };
                this.track = track;
                // A stopped/replaced request must never start sounding when decoding finishes.
                Promise.resolve().then(()=>this.track === track ? this.play() : undefined).then((player)=>{
                    if (!player) return;
                    if (this.track !== track) {
                        player.stop();
                        return;
                    }
                    track.player = player;
                    player.set("volume", track.volume);
                }).catch(()=>{
                    if (this.track === track) {
                        this.track = undefined;
                        this.retryAt = now + 1000;
                    }
                });
            }
            const track = this.track;
            if (!track) return;
            if (!track.player && volume === 0) {
                this.stop();
                return;
            }
            track.volume += (volume - track.volume) * (1 - Math.exp(-elapsed / 200));
            track.player?.set("volume", track.volume);
            if (volume === 0 && track.volume < 0.001) this.stop();
        };
    }
}


/**
 * The Ember Core's furnace loop, owned the same way BonecallerChant owns the ritual chant: one
 * instance, started lazily, and safe against a stop that lands while the audio is still decoding.
 *
 * What it adds is PITCH. The loop itself is deliberately steady (see ember_core_charge in gen.py);
 * the rising tension of a charge comes from ramping playback rate and gain together across the hold.
 * That is also why it is a loop and not a one-shot 800ms sample: the hold can be released early, the
 * profile's chargeMs is configurable per weapon, and a sample would have to be re-cut for each.
 *
 * Volume and speed are both eased toward their targets rather than set, so the step between server
 * messages never clicks.
 */ const $8efbf1343258f651$var$EASE_MS = 80;
const $8efbf1343258f651$var$MIN_SPEED = 0.72;
class $8efbf1343258f651$export$9b6070b6b1b7ddd8 {
    constructor(play){
        this.play = play;
        this.lastAt = 0;
        this.retryAt = 0;
        this.stop = ()=>{
            const track = this.track;
            this.track = undefined;
            track?.player?.stop();
        };
        this.update = (key, volume, speed, now)=>{
            const elapsed = Math.min(100, Math.max(0, now - this.lastAt));
            this.lastAt = now;
            if (!key) {
                this.stop();
                return;
            }
            if (this.track && this.track.key !== key) this.stop();
            if (!this.track && volume > 0 && now >= this.retryAt) {
                const track = {
                    key: key,
                    volume: 0,
                    speed: $8efbf1343258f651$var$MIN_SPEED,
                    player: undefined
                };
                this.track = track;
                // A stopped/replaced request must never start sounding when decoding finishes.
                Promise.resolve().then(()=>this.track === track ? this.play() : undefined).then((player)=>{
                    if (!player) return;
                    if (this.track !== track) {
                        player.stop();
                        return;
                    }
                    track.player = player;
                    player.set("volume", track.volume);
                    player.set("speed", track.speed);
                }).catch(()=>{
                    if (this.track === track) {
                        this.track = undefined;
                        this.retryAt = now + 1000;
                    }
                });
            }
            const track = this.track;
            if (!track) return;
            if (!track.player && volume === 0) {
                this.stop();
                return;
            }
            const ease = 1 - Math.exp(-elapsed / $8efbf1343258f651$var$EASE_MS);
            track.volume += (volume - track.volume) * ease;
            track.speed += (speed - track.speed) * ease;
            track.player?.set("volume", track.volume);
            track.player?.set("speed", track.speed);
            if (volume === 0 && track.volume < 0.001) this.stop();
        };
    }
}


class $479d799412e4e1cb$export$153755f98d9861de {
    static{
        this.soundOptions = {};
    }
    constructor(logic){
        this.walkSoundEffectLatch = new Map();
        this.playingSoundtrack = {};
        this.thunder = new (0, $f1bdd10a2a9b0ff6$export$6603c70e99928aec)();
        this.volume = 0.7;
        this.devSoundEnabled = false;
        this.devSoundHinted = false;
        this.bonecallerAudioConnected = true;
        this.bonecallerChant = new (0, $c4544ebb4d826faa$export$bded0763316335f6)(()=>(0, $8Odl4.sound).play("bonecaller_chant", {
                loop: true,
                volume: 0
            }));
        // The Ember Core's charge loop, and the hold it is currently following. The anchor is this
        // class's own copy of the trick every charged-weapon renderer plays: the server's remainingMs
        // is re-anchored to local time when it changes and counted down locally in between, so the
        // pitch ramp is continuous instead of stepping once per message.
        this.emberCoreCharge = new (0, $8efbf1343258f651$export$9b6070b6b1b7ddd8)(()=>(0, $8Odl4.sound).play("ember_core_charge", {
                loop: true,
                volume: 0,
                speed: 0.72
            }));
        /** Enable or mute all client effects and music. */ this.setSoundEnabled = (enabled)=>{
            this.commandSoundEnabled = enabled;
            if (enabled) {
                (0, $8Odl4.sound).unmuteAll();
                return;
            }
            this.thunder.stop();
            (0, $8Odl4.sound).muteAll();
            this.stopBonecallerChant();
            this.stopEmberCoreCharge();
        };
        // Sound is off outside production so a dev session isn't noisy by default -- which also makes
        // it impossible to hear an effect you're working on. `devSound` opens it back up; see
        // installDevSoundToggle. Production is always audible and ignores the switch.
        this.audible = ()=>{
            if (this.commandSoundEnabled !== undefined) return this.commandSoundEnabled;
            if (this.logic.runLevel === "prod" || this.devSoundEnabled) return true;
            // Say why exactly once, the first time something tries to make a noise, so the silence
            // isn't a mystery to anyone who doesn't already know the toggle exists.
            if (!this.devSoundHinted) {
                this.devSoundHinted = true;
                console.log("[devSound] sound is muted outside production -- set `devSound = true` to hear it");
            }
            return false;
        };
        // Browser-console switch, in the same shape as window.playerRing / window.spriteShadow:
        //
        //     devSound = true     // unmute this session
        //     devSound = 0.3      // unmute at 30% volume
        //     devSound = false    // mute again
        //     devSound            // read the current state back
        //
        // Dev only: in production sound is already on, so the setter refuses rather than pretending
        // to do something. Guarded so it is a no-op in the Node test harness.
        this.installDevSoundToggle = ()=>{
            if (typeof window === "undefined") return;
            Object.defineProperty(window, "devSound", {
                get: ()=>({
                        enabled: this.devSoundEnabled,
                        volume: this.volume
                    }),
                set: (next)=>{
                    if (this.logic.runLevel === "prod") {
                        console.log("[devSound] production already plays sound; nothing to toggle");
                        return;
                    }
                    if (typeof next === "number") {
                        this.devSoundEnabled = next > 0;
                        this.volume = Math.max(0, Math.min(1, next));
                    } else this.devSoundEnabled = !!next;
                    console.log("[devSound]", {
                        enabled: this.devSoundEnabled,
                        volume: this.volume
                    });
                    if (!this.devSoundEnabled) {
                        this.thunder.stop();
                        this.stopBonecallerChant();
                        this.stopEmberCoreCharge();
                    }
                },
                configurable: true
            });
        };
        this.walking = (entity)=>{
        //
        };
        this.stopBonecallerChant = ()=>this.bonecallerChant.stop();
        this.setBonecallerAudioConnected = (connected)=>{
            this.bonecallerAudioConnected = connected;
            if (!connected) this.stopBonecallerChant();
        };
        this.updateBonecallerChant = (now = Date.now())=>{
            const listener = this.logic.playerEntity;
            if (!this.bonecallerAudioConnected || !listener || listener.hp <= 0 || !this.logic.roomId || typeof document !== "undefined" && document.hidden) {
                this.stopBonecallerChant();
                return;
            }
            let shrine, nearest = Infinity;
            this.logic.entityManager.iterate(null, (entity)=>{
                if (entity.roomId !== this.logic.roomId) return;
                if (entity.bonecallerRitual?.phase !== "active") return;
                const distance = Math.hypot(entity.location.x - listener.location.x, entity.location.y - listener.location.y);
                if (distance < nearest) {
                    shrine = entity;
                    nearest = distance;
                }
            });
            if (!shrine || !this.audible()) {
                this.stopBonecallerChant();
                return;
            }
            const stageVolume = [
                0,
                0.09,
                0.14,
                0.2
            ][shrine.bonecallerRitual.stage];
            const attenuation = Math.max(0, 1 - nearest / 640) ** 2;
            this.bonecallerChant.update(`${this.logic.roomId}:${shrine.entityId}`, stageVolume * attenuation * this.volume, now);
        };
        this.stopEmberCoreCharge = ()=>{
            this.emberCoreCharge.stop();
            this.emberChargeAnchor = undefined;
            this.emberReadyAnnounced = undefined;
        };
        /**
     * How loud something happening at `source` should be for the player. Squared falloff, because
     * linear makes everything in the room sound like it is on top of you, and a floor of zero so a
     * blast across the camp is genuinely silent rather than a mystery thud.
     */ this.distanceGain = (source, range)=>{
            const listener = this.logic.playerEntity?.location;
            if (!source || !listener) return 1;
            return Math.max(0, 1 - Math.hypot(source.x - listener.x, source.y - listener.y) / range) ** 2;
        };
        /**
     * The furnace loop under a charged weapon being held, and the cue when it finishes charging.
     *
     * Follows the NEAREST charging entity rather than only the local player: an ally winding up an
     * Ember Core beside you is worth hearing, and a shot about to be thrown at you even more so.
     * One loop, as with the ritual chant -- two people charging is one furnace getting louder, which
     * is the right answer anyway.
     */ this.updateEmberCoreCharge = (now = Date.now())=>{
            const listener = this.logic.playerEntity;
            if (!listener || listener.hp <= 0 || !this.logic.roomId || !this.audible() || typeof document !== "undefined" && document.hidden) {
                this.stopEmberCoreCharge();
                return;
            }
            let charging, nearest = Infinity;
            this.logic.entityManager.iterate(null, (entity)=>{
                if (entity.roomId !== this.logic.roomId || !entity.weaponCharge) return;
                const distance = Math.hypot(entity.location.x - listener.location.x, entity.location.y - listener.location.y);
                if (distance < nearest) {
                    charging = entity;
                    nearest = distance;
                }
            });
            const view = charging?.weaponCharge;
            if (!view) {
                this.stopEmberCoreCharge();
                return;
            }
            // Re-anchor whenever the server restates the hold, then count down locally in between.
            const anchor = this.emberChargeAnchor;
            if (!anchor || anchor.id !== view.id || anchor.remainingMs !== view.remainingMs) this.emberChargeAnchor = {
                id: view.id,
                remainingMs: view.remainingMs,
                at: now
            };
            const remaining = Math.max(0, this.emberChargeAnchor.remainingMs - now + this.emberChargeAnchor.at);
            const progress = view.durationMs ? Math.max(0, Math.min(1, 1 - remaining / view.durationMs)) : 1;
            const attenuation = this.distanceGain(charging.location, 520);
            const base = $479d799412e4e1cb$export$153755f98d9861de.soundOptions["ember_core_charge"]?.volume || 0.3;
            // Gain and pitch both climb with the hold; the loop itself is flat (see gen.py).
            this.emberCoreCharge.update(`${this.logic.roomId}:${charging.entityId}:${view.id}`, base * (0.35 + 0.65 * progress) * attenuation * this.volume, 0.72 + 0.5 * progress, now);
            if (progress >= 1 && this.emberReadyAnnounced !== view.id) {
                this.emberReadyAnnounced = view.id;
                this.play("ember_core_ready", {
                    volume: ($479d799412e4e1cb$export$153755f98d9861de.soundOptions["ember_core_ready"]?.volume || 0.22) * Math.max(0.3, attenuation)
                });
            }
            if (progress < 1 && this.emberReadyAnnounced === view.id) this.emberReadyAnnounced = undefined;
        };
        this.groundRupture = (at)=>{
            const gain = this.distanceGain(at, 640);
            if (gain > 0) this.play("ground_rupture", {
                volume: ($479d799412e4e1cb$export$153755f98d9861de.soundOptions["ground_rupture"]?.volume || 0.22) * gain
            });
        };
        // The three moments of a shot, routed here from the projectile's renderable through
        // effects/ember_core_feedback. All three are positional: a blast on the far side of the camp
        // should not sound like one at your feet.
        this.bombLanded = (at)=>{
            this.play("clocktick", {
                volume: 0.25 * this.distanceGain(at, 440)
            });
        };
        this.bombBlast = (at)=>{
            this.play("explosion", {
                volume: 0.5 * this.distanceGain(at, 1000)
            });
        };
        this.emberCoreFired = (at)=>{
            this.play("ember_core_fire", {
                volume: ($479d799412e4e1cb$export$153755f98d9861de.soundOptions["ember_core_fire"]?.volume || 0.3) * this.distanceGain(at, 700),
                speed: 0.97 + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? -1 : 1) * (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(0.0, 0.05)
            });
        };
        this.emberCoreLanded = (at)=>{
            this.play("ember_core_fuse", {
                volume: ($479d799412e4e1cb$export$153755f98d9861de.soundOptions["ember_core_fuse"]?.volume || 0.18) * this.distanceGain(at, 440)
            });
        };
        this.emberCoreBlast = (at)=>{
            this.play("ember_core_blast", {
                volume: ($479d799412e4e1cb$export$153755f98d9861de.soundOptions["ember_core_blast"]?.volume || 0.55) * Math.max(0.08, this.distanceGain(at, 1100)),
                speed: 0.95 + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? -1 : 1) * (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(0.0, 0.06)
            });
        };
        this.emp = (entity)=>{
            if (!this.logic.isTooDistantFromPlayer(entity)) this.play("emp", {
                volume: 0.25
            });
        };
        this.attack = (entity)=>{
            if (!this.logic.isTooDistantFromPlayer(entity)) this.play([
                "bow",
                "crossbow"
            ].includes(entity.weapon?.weaponType) ? "bowshot" : "swordswing", {
                volume: 0.05,
                speed: 0.85 + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? -1 : 1) * (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(0.0, 0.03)
            });
        };
        this.hit = (entity)=>{
            this.play(`hit${(0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)([
                1,
                2
            ])}`, {
                volume: 0.075,
                speed: 0.75 + Math.min(0.25, Math.random())
            });
        // if (entity.npcType === "zombie") {
        //     if (randomIntBetween(0, 2) === 0) {
        //         this.play(`zombie-hit-${randomIntBetween(1, 6)}`, {
        //             volume: 0.20,
        //             speed: 0.85 + Math.min(0.15, Math.random())
        //         })
        //     }
        // }
        };
        this.death = (entity)=>{
        // if (entity.npcType === "zombie") {
        //     if (randomBool()) {
        //         this.play(`zombie-death-${randomIntBetween(1, 6)}`, {
        //             volume: 0.20,
        //             speed: 0.85 + Math.min(0.15, Math.random())
        //         })
        //     }
        // }
        };
        this.destroy = (entity)=>{
            this.walkSoundEffectLatch.delete(entity.entityId);
        };
        this.walk = (entity)=>{
            const baseline = 300;
            let meta = this.walkSoundEffectLatch.get(entity.entityId);
            if (!meta) {
                meta = {
                    latch: new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(baseline),
                    soundIdx: -1,
                    soundIdxMax: 2
                };
                this.walkSoundEffectLatch.set(entity.entityId, meta);
            }
            meta.latch.update(baseline);
            if (meta.latch.expired()) {
                meta.soundIdx++;
                if (meta.soundIdx > meta.soundIdxMax - 1) meta.soundIdx = 0;
                const footstep = entity.submerged || entity.wading ? `swamp${meta.soundIdx}` : `footsteps${meta.soundIdx}`;
                this.play(footstep, {
                    volume: 0.08 + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? -1 : 1) * (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(0.01, 0.03),
                    speed: 0.85 + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? -1 : 1) * (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(0.0, 0.15)
                });
            }
        };
        // Command-wheel / role-picker confirmation. Pitched a touch at random so repeated
        // selections don't sound machine-gunned.
        // Somebody has walked in out of the cold and is standing at the camp's fire asking to be taken
        // on. Played off the roster, not off the world, because the whole point of it is to reach a
        // player who is nowhere near the fire -- so unlike the hit and attack sounds it is deliberately
        // NOT gated on distance from the listener.
        this.visitorArrives = ()=>{
            this.play("visitor_arrives");
        };
        // A chapter-checklist task was just completed: the reward itself, played the instant it happens.
        this.chapterTaskComplete = ()=>{
            this.play("chapter_task_complete");
        };
        // ...and its gold check landing in the checklist row a beat later. Quiet on purpose: it is the
        // same reward settling, not a second one.
        this.chapterTaskStamp = ()=>{
            this.play("chapter_task_stamp");
        };
        // The last task of a chapter is done. Once per chapter, so it is allowed to be the big one.
        this.chapterComplete = ()=>{
            this.play("chapter_complete");
        };
        // A new chapter's title card: its crest igniting (a chord left hanging), and Begin answering it.
        this.chapterAnnounce = ()=>{
            this.play("chapter_announce");
        };
        this.chapterBegin = ()=>{
            this.play("chapter_begin");
        };
        // A planned build group was printed (the server accepted it). Played once per group, however
        // many tiles it held: a bigger group lands lower and fuller, so a whole room going up sounds
        // heavier than one wall piece (the drop bottoms out at 32 tiles, ~12% down and ~35% louder).
        // Pitch is jittered so a run of prints doesn't sound machine-gunned.
        this.buildPrinted = (tiles = 1)=>{
            const weight = Math.min(1, Math.log2(Math.max(1, tiles)) / 5);
            this.play("build_printed", {
                volume: ($479d799412e4e1cb$export$153755f98d9861de.soundOptions["build_printed"]?.volume || 0.2) * (1 + 0.35 * weight),
                speed: 1.03 - 0.12 * weight + (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(-0.03, 0.03)
            });
        };
        // A felled tree's two moments (effects/tree_fall.ts, through tree_fall_feedback). Positional: a
        // woodcutter felling across the camp is a distant crack, not one at your elbow. `weight` is ~1 for
        // a full-size tree, so a sapling lands lighter and higher.
        this.treeCreak = (at)=>{
            const gain = this.distanceGain(at, 560);
            if (gain > 0) this.play("tree_creak", {
                volume: ($479d799412e4e1cb$export$153755f98d9861de.soundOptions["tree_creak"]?.volume || 0.22) * gain,
                speed: 0.96 + (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(0, 0.08)
            });
        };
        this.treeFall = (at, weight = 1)=>{
            const gain = this.distanceGain(at, 720);
            if (gain > 0) this.play("tree_fall", {
                volume: ($479d799412e4e1cb$export$153755f98d9861de.soundOptions["tree_fall"]?.volume || 0.34) * gain * (0.6 + 0.4 * Math.min(1.2, weight)),
                speed: 1.08 - 0.12 * Math.min(1, weight) + (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(-0.03, 0.03)
            });
        };
        this.uiSelect = ()=>{
            this.play("wheel_select", {
                speed: 1.0 + ((0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)() ? -1 : 1) * (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(0.0, 0.04)
            });
        };
        // The pointer crossing onto another command-wheel order: the select bell, pitched well up and
        // barely there, so aiming ticks under the hand and the pick that follows sounds like the same
        // object answering. Played on every crossing, so it must stay quiet.
        this.uiHover = ()=>{
            this.play("wheel_select", {
                volume: ($479d799412e4e1cb$export$153755f98d9861de.soundOptions["wheel_select"]?.volume || 0.12) * 0.3,
                speed: 1.75 + (0, $cb689cfa16c444ba$export$3fd68433dc33f3f9)(0.0, 0.06)
            });
        };
        this.mapLocationFound = ()=>{
            this.play("map_location", {
                volume: 0.5
            });
        };
        this.pickup = (itemTypeMeta)=>{
            if (itemTypeMeta.type === "shard-metal") this.play("coins", {
                volume: 0.1
            });
            else this.play("cloth", {
                volume: 0.05
            });
        };
        this.soundEffect = async (effect, loop, target, source)=>{
            if (!this.audible()) return;
            if ([
                "bonecaller_spike_windup",
                "bonecaller_spike_impact",
                "bonecaller_sweep_windup",
                "bonecaller_sweep_impact"
            ].includes(effect)) {
                const gain = source ? this.distanceGain(source, 640) : 1;
                if (gain > 0) this.play(effect, {
                    volume: ($479d799412e4e1cb$export$153755f98d9861de.soundOptions[effect]?.volume || 0.25) * gain
                });
                return;
            }
            if (effect === "bonecaller_complete") {
                const listener = this.logic.playerEntity?.location;
                const distance = source && listener ? Math.hypot(source.x - listener.x, source.y - listener.y) : 0;
                this.play(effect, {
                    volume: 0.5 * Math.max(0.2, 1 - distance / 960)
                });
                return;
            }
            if ($479d799412e4e1cb$export$153755f98d9861de.isSoundtrack(effect)) {
                const targetSoundtrack = this.playingSoundtrack[target];
                if (targetSoundtrack && (!effect || targetSoundtrack?.trackId !== effect)) {
                    // if no effect, or its a different track for the target
                    // then halt it
                    if (!effect) delete this.playingSoundtrack[target];
                    const player = targetSoundtrack?.player;
                    // halt the currently played soundtrack
                    if (player) {
                        const maxVolume = player.volume;
                        const incr = Math.max(0.01, maxVolume / 50);
                        let prev = -1;
                        const volInterval = setInterval(()=>{
                            if (player.volume < 0.01 || prev === player.volume) {
                                clearInterval(volInterval);
                                player.stop();
                                return;
                            }
                            prev = player.volume;
                            player.set("volume", player.volume - incr);
                        }, 50);
                    }
                }
                if (!effect) return;
                if (targetSoundtrack && targetSoundtrack.trackId === effect) // soundtrack already playing for the target
                return;
                const targetVolume = ($479d799412e4e1cb$export$153755f98d9861de.soundOptions[effect]?.volume || 1.0) * this.volume;
                const incr = Math.max(0.01, targetVolume / 50);
                const track = {
                    trackId: effect,
                    player: null
                };
                this.playingSoundtrack[target] = track;
                const instance = await (0, $8Odl4.sound).play(effect, {
                    ...$479d799412e4e1cb$export$153755f98d9861de.soundOptions[effect] || {},
                    volume: 0.01 * this.volume,
                    loop: loop
                });
                const volInterval = setInterval(()=>{
                    if (instance.volume >= targetVolume) {
                        clearInterval(volInterval);
                        return;
                    }
                    instance.set("volume", (instance.volume + incr) * this.volume);
                }, 50);
                track.player = instance;
                return;
            }
            const playOptions = {
                ...$479d799412e4e1cb$export$153755f98d9861de.soundOptions[effect] || {}
            };
            const volume = (playOptions.volume || 1.0) * this.volume;
            await (0, $8Odl4.sound).play(effect, {
                ...playOptions,
                volume: volume
            });
        };
        // stopSoundtrack = () => {
        //     this.activeSoundtrackId = null
        //     this.playingSoundtrack.stop()
        // }
        this.play = (s, options = {})=>{
            if (!this.audible()) return;
            const volume = (options.volume === undefined ? ($479d799412e4e1cb$export$153755f98d9861de.soundOptions[s]?.volume || 1.0) * this.volume : options.volume) * this.volume;
            (0, $8Odl4.sound)?.play(s, {
                ...options,
                volume: volume
            });
        };
        this.playWeatherThunder = ()=>{
            if (!this.audible() || document.hidden || (0, $8Odl4.sound).context.muted || (0, $8Odl4.sound).context.paused) return;
            const context = (0, $8Odl4.sound).context;
            if (context.audioContext && context.compressor) this.thunder.play(context.audioContext, context.compressor, this.volume * 0.65);
        };
        this.stopWeatherThunder = ()=>this.thunder.stop();
        this.setVolume = (volume)=>{
            this.thunder.stop();
            this.volume = volume;
            Object.values(this.playingSoundtrack).forEach((track)=>{
                if (track.player) {
                    const updatedVolume = ($479d799412e4e1cb$export$153755f98d9861de.soundOptions[track.trackId]?.volume || 1.0) * volume;
                    track.player.set("volume", updatedVolume);
                }
            });
        };
        this.logic = logic;
        this.installDevSoundToggle();
        if (typeof document !== "undefined") document.addEventListener("visibilitychange", ()=>{
            if (document.hidden) {
                this.thunder.stop();
                this.stopBonecallerChant();
                this.stopEmberCoreCharge();
            }
        });
    }
    static{
        this.loadAssets = ()=>{
            // sound effects
            // for (let i = 0; i <= 8; i++) {
            //     Loader.shared.add(`footsteps${i}`, contentAssetUrl(`assets/boots/${i}.ogg`))
            // }
            for(let i = 0; i <= 1; i++)(0, $kXE1p.Loader).shared.add(`footsteps${i}`, (0, $e5c675b7b9585b42$export$bab18279d67f8654)(`assets/grass/${i}.ogg`));
            for(let i = 0; i <= 1; i++)(0, $kXE1p.Loader).shared.add(`swamp${i}`, (0, $e5c675b7b9585b42$export$bab18279d67f8654)(`assets/swamp/${i}.ogg`));
            const audioPopulator = (category, action, numAssets, extension = "mp3")=>{
                for(let i = 1; i <= numAssets; i++)(0, $kXE1p.Loader).shared.add(`${category}-${action}-${i}`, (0, $e5c675b7b9585b42$export$bab18279d67f8654)(`assets/${category}/${action}/${i}.${extension}`));
            };
            // audioPopulator("zombie", "attack", 7)
            // audioPopulator("zombie", "death", 6)
            // audioPopulator("zombie", "detect", 5)
            // audioPopulator("zombie", "hit", 6)
            // audioPopulator("human", "death", 8, "ogg")
            // soundtrack
            // Loader.shared.add('dome1.ogg', 'assets/dome1.ogg')
            (0, $kXE1p.Loader).shared.add("overworld1.ogg", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/overworld1.ogg"));
            (0, $kXE1p.Loader).shared.add("overworld-day-noises.ogg", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/overworld-day-noises.ogg"));
            (0, $kXE1p.Loader).shared.add("overworld-night-noises.ogg", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/overworld-night-noises.ogg"));
            (0, $kXE1p.Loader).shared.add("dungeon-ambience.ogg", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/dungeon-ambience.ogg"));
            (0, $kXE1p.Loader).shared.add("door-open.ogg", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/door-open.ogg"));
            (0, $kXE1p.Loader).shared.add("to_battle.ogg", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/to_battle.ogg"));
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["overworld1.ogg"] = {
                volume: 0.15
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["overworld-day-noises.ogg"] = {
                volume: 3.8
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["overworld-night-noises.ogg"] = {
                volume: 0.25
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["dungeon-ambience.ogg"] = {
                volume: 0.5
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["powerup"] = {
                volume: 0.5
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["door_close"] = {
                volume: 0.05
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["door_open"] = {
                volume: 0.05
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["door-open.ogg"] = {
                volume: 0.25
            };
            // Procedurally synthesized one-shots (packages/tools/src/sfx/gen.py). These are peak
            // normalized in the generator, so the balance against the older, quieter assets lives
            // here rather than in the files.
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["campfire_lit"] = {
                volume: 0.3
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["campfire_fed"] = {
                volume: 0.25
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["wheel_select"] = {
                volume: 0.12
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["item_crafted"] = {
                volume: 0.25
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["wave_starting"] = {
                volume: 0.4
            };
            // Quieter than the wave horn by a long way, on purpose: a stranger at the fire is a thing
            // to notice, not a thing to be startled by, and it can land while the player is mid-fight.
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["visitor_arrives"] = {
                volume: 0.22
            };
            // The story checklist's rewards. The tick is high and bright, so it sits a shade under
            // item_crafted to land at the same loudness; the stamp is an afterthought to it and stays
            // down at the command wheel's level. The chapter fanfare is the one that is meant to be
            // heard over a camp -- a little above the wave horn, and it comes once per chapter.
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["chapter_task_complete"] = {
                volume: 0.24
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["chapter_task_stamp"] = {
                volume: 0.16
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["chapter_complete"] = {
                volume: 0.4
            };
            // The chapter title card: its crest catching light, then the Begin press answering it.
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["chapter_announce"] = {
                volume: 0.3
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["chapter_begin"] = {
                volume: 0.26
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["bonecaller_spike_windup"] = {
                volume: 0.22
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["bonecaller_spike_impact"] = {
                volume: 0.4
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["bonecaller_sweep_windup"] = {
                volume: 0.2
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["bonecaller_sweep_impact"] = {
                volume: 0.35
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["ground_rupture"] = {
                volume: 0.22
            };
            // A planned build turning solid. It comes every few seconds while a camp is being laid out,
            // so it sits with the short UI ticks (wheel_select, chapter_task_stamp), a shade above them.
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["build_printed"] = {
                volume: 0.2
            };
            // A felled tree: the hinge giving way, then the crash. The crash is the payoff of a run of axe
            // strokes, so it is the louder of the two -- about a blow's woodhit plus half again -- but it
            // stays well under the blasts: in a forest camp it comes several times a minute.
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["tree_creak"] = {
                volume: 0.22
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["tree_fall"] = {
                volume: 0.34
            };
            // The Ember Core. The blast is the loudest thing the game makes on purpose -- it is a
            // once-every-two-seconds, ammunition-limited payoff, and it has to beat a wave of enemies
            // and a burning camp. The fuse is quiet by comparison because it plays UNDER the moment the
            // player is reading the warning circle, and a loud sizzle there just masks the blast.
            // These are the base levels; the one-shots scale them by distance at the call site.
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["ember_core_blast"] = {
                volume: 0.55
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["ember_core_fire"] = {
                volume: 0.3
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["ember_core_fuse"] = {
                volume: 0.18
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["ember_core_ready"] = {
                volume: 0.22
            };
            $479d799412e4e1cb$export$153755f98d9861de.soundOptions["ember_core_charge"] = {
                volume: 0.3
            };
        };
    }
    static{
        this.isSoundtrack = (effect)=>{
            if (!effect) return true;
            if (effect === "overworld1.ogg") return true;
            if (effect === "overworld-day-noises.ogg") return true;
            if (effect === "overworld-night-noises.ogg") return true;
            if (effect === "dungeon-ambience.ogg") return true;
            if (effect === "to_battle.ogg") return true;
            return false;
        };
    }
}



function $13b02b984dcf834a$export$137ebbe236578701(state, x, y, now) {
    if (!state) return {
        x: x,
        y: y,
        ts: now
    };
    const elapsed = now - state.ts;
    state.ts = now;
    const dx = x - state.x, dy = y - state.y;
    const distanceSq = dx * dx + dy * dy;
    // Large corrections are teleports. Settle within a quarter pixel so a stopped
    // character finishes walking instead of animating ever-smaller steps forever.
    if (elapsed <= 0 || distanceSq > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) || distanceSq < 0.0625) {
        state.x = x;
        state.y = y;
    } else {
        const alpha = 1 - Math.exp(-elapsed / 55);
        state.x += dx * alpha;
        state.y += dy * alpha;
    }
    return state;
}



class $a652698944c1b693$export$30b004862838cfad {
    constructor(runtime, send, quarantine, now = Date.now, timeoutMs = 30000, prepareTimeoutMs = timeoutMs){
        this.runtime = runtime;
        this.send = send;
        this.quarantine = quarantine;
        this.now = now;
        this.timeoutMs = timeoutMs;
        this.prepareTimeoutMs = prepareTimeoutMs;
        this.sequence = 0;
        this.blocked = new Set();
    }
    get identity() {
        return this.pending && {
            ...this.pending.identity
        };
    }
    get committed() {
        return this.pending?.committed === true;
    }
    prepare(manifest, catalog, peers) {
        if (this.pending?.committed) throw new Error("Content activation acknowledgements are still pending");
        if (new Set(peers).size !== peers.length) throw new Error("Duplicate publication participants");
        if (peers.some((peer)=>this.blocked.has(peer))) throw new Error("Quarantined connection cannot participate");
        // Invalid candidates leave an earlier preparation usable.
        const handle = this.runtime.prepare(manifest, catalog);
        this.abort("a newer publication replaced it");
        this.abortReason = undefined;
        const identity = Object.freeze({
            id: `content-${++this.sequence}`,
            revision: handle.revision
        });
        const pending = {
            identity: identity,
            handle: handle,
            peers: new Map(peers.map((peer)=>[
                    peer,
                    "preparing"
                ])),
            deadline: this.now() + this.prepareTimeoutMs,
            committed: false
        };
        this.pending = pending;
        for (const peer of peers){
            if (this.pending !== pending) break;
            try {
                this.send(peer, {
                    ...identity,
                    kind: "prepare"
                });
            } catch  {
                this.abort(`could not reach player connection ${peer}`);
                throw new Error(`Cannot prepare content on peer ${peer}`);
            }
        }
        return identity;
    }
    receive(peer, reply) {
        const p = this.pending;
        if (!p || reply.id !== p.identity.id || reply.revision !== p.identity.revision || !p.peers.has(peer)) return;
        if (this.expire()) return;
        if (reply.kind === "failed") {
            if (!p.committed) this.abort(`a player's game could not prepare it: ${typeof reply.reason === "string" && reply.reason ? reply.reason.slice(0, 300) : "no reason given (an older game client sends none; reload it)"}`);
            else {
                p.peers.delete(peer);
                this.blockPeer(peer, "contentActivationFailed");
                this.finish();
            }
        } else if (reply.kind === "ready" && p.peers.get(peer) === "preparing") p.peers.set(peer, "ready");
        else if (reply.kind === "activated" && p.peers.get(peer) === "activating") {
            p.peers.set(peer, "activated");
            this.finish();
        }
    }
    /** The caller must supply the current authenticated connection IDs, including suspended peers.
     * Membership changes abort preparation; joins should wait until the barrier finishes. */ commit(peers) {
        const p = this.pending;
        if (!p || p.committed || this.expire()) return false;
        if (peers.length !== p.peers.size || new Set(peers).size !== peers.length || peers.some((peer)=>!p.peers.has(peer))) {
            this.abort("a player joined or left while it was being prepared; try again");
            return false;
        }
        if ([
            ...p.peers.values()
        ].some((state)=>state !== "ready")) return false;
        try {
            this.runtime.activate(p.handle);
        } catch (error) {
            this.abort();
            throw error;
        }
        p.committed = true;
        p.deadline = this.now() + this.timeoutMs;
        // Set all states before sending; a test/local transport may reply synchronously.
        for (const peer of p.peers.keys())p.peers.set(peer, "activating");
        for (const peer of [
            ...p.peers.keys()
        ])try {
            this.send(peer, {
                ...p.identity,
                kind: "activate"
            });
        } catch  {
            p.peers.delete(peer);
            this.blockPeer(peer, "contentActivationFailed");
        }
        this.finish();
        return true;
    }
    canUseActiveContent(peer) {
        if (this.blocked.has(peer)) return false;
        const p = this.pending;
        return !p?.committed || p.peers.get(peer) === "activated";
    }
    /** Poll even when the simulation is paused. After commit there is no distributed rollback:
     * peers that cannot acknowledge must leave before gameplay resumes for them. */ expire() {
        const p = this.pending;
        if (!p || this.now() < p.deadline) return false;
        if (!p.committed) this.abort("a player's game did not finish preparing it in time");
        else {
            for (const [peer, state] of p.peers)if (state !== "activated") this.blockPeer(peer, "contentActivationTimeout");
            this.pending = undefined;
        }
        return true;
    }
    abort(reason = "it was cancelled") {
        const p = this.pending;
        if (!p) return;
        if (p.committed) throw new Error("Committed publication cannot be aborted");
        this.pending = undefined;
        this.abortReason = reason;
        this.runtime.discard(p.handle);
        for (const peer of p.peers.keys())try {
            this.send(peer, {
                ...p.identity,
                kind: "abort"
            });
        } catch  {}
    }
    finish() {
        if (this.pending?.committed && [
            ...this.pending.peers.values()
        ].every((state)=>state === "activated")) this.pending = undefined;
    }
    blockPeer(peer, reason) {
        this.blocked.add(peer);
        try {
            this.quarantine(peer, reason);
        } catch  {}
    }
}
class $a652698944c1b693$export$d699fc72b406c0aa {
    constructor(runtime, stage, reply){
        this.runtime = runtime;
        this.stage = stage;
        this.reply = reply;
    }
    async prepare(identity, manifest, catalog, inline) {
        this.dispose();
        const p = {
            identity: {
                id: identity.id,
                revision: identity.revision
            },
            controller: new AbortController()
        };
        this.pending = p;
        try {
            // Validate and detach before awaiting downloads. Runtime selectors are prepared last,
            // after any modules imported during staging have registered their bindings.
            const candidate = new (0, $37c55e30895d384f$export$66497b07577dd981)(manifest, catalog).active;
            if (candidate.catalog.revision !== identity.revision || !identity.id) throw new Error("Publication identity mismatch");
            const resources = await this.stage(candidate, p.controller.signal, inline);
            if (this.pending !== p) {
                resources.discard();
                return;
            }
            p.resources = resources;
            p.handle = this.runtime.prepare(candidate.manifest, candidate.catalog);
            this.reply({
                ...p.identity,
                kind: "ready"
            });
        } catch (error) {
            if (this.pending !== p) return;
            this.dispose();
            this.reply({
                ...p.identity,
                kind: "failed",
                reason: String(error?.message || error).slice(0, 300)
            });
        }
    }
    activate(identity) {
        const p = this.pending;
        if (!p || p.identity.id !== identity.id || p.identity.revision !== identity.revision) return false;
        let undo;
        try {
            if (!p.handle || !p.resources) throw new Error("Content is not ready");
            undo = p.resources.activate();
            this.runtime.activate(p.handle);
        } catch  {
            try {
                undo?.();
            } finally{
                this.dispose();
            }
            this.reply({
                ...p.identity,
                kind: "failed"
            });
            return false;
        }
        this.pending = undefined;
        this.reply({
            ...p.identity,
            kind: "activated"
        });
        return true;
    }
    abort(identity) {
        if (this.pending?.identity.id === identity.id && this.pending.identity.revision === identity.revision) this.dispose();
    }
    dispose() {
        const p = this.pending;
        this.pending = undefined;
        if (!p) return;
        p.controller.abort();
        if (p.handle) this.runtime.discard(p.handle);
        p.resources?.discard();
    }
}





class $5f3ac23de5b4365c$export$d565f58bc438286b extends (0, $bc8613e262b54793$export$72650553bea9c295) {
    static{
        this.instance = new $5f3ac23de5b4365c$export$d565f58bc438286b();
    }
    constructor(size = 1000){
        super(size);
    }
    create() {
        return {
            free: true,
            data: {
                movedX: false,
                movedY: false,
                collision: (0, $a80d0b17b615d6f7$export$b03ec757ccd6a9ce)(),
                intersection: {
                    ...(0, $a80d0b17b615d6f7$export$b03ec757ccd6a9ce)(),
                    intersectionType: ""
                }
            }
        };
    }
    clear(item) {
        item.data.movedX = false;
        item.data.movedY = false;
        (0, $a80d0b17b615d6f7$export$246e0d97ef73b196)(item.data.collision);
        (0, $a80d0b17b615d6f7$export$246e0d97ef73b196)(item.data.intersection);
        item.data.intersection.intersectionType = "";
    }
}



class $04dfe581ed7487ef$export$377bbedb5576dfa8 {
    static{
        this.type_spriteLabRequest = "spriteLabRequest";
    }
    static{
        this.type_spriteLabState = "spriteLabState";
    }
    static{
        this.type_contentRequest = "contentRequest";
    }
    static{
        this.type_contentCommand = "contentCommand";
    }
    static{
        this.type_contentReply = "contentReply";
    }
    static{
        this.type_setEntityId = "0";
    }
    static{
        this.type_destroyEntityId = "1";
    }
    static{
        this.type_ping = "2";
    }
    static{
        this.type_struckEntityId = "3";
    }
    static{
        this.type_worldState = "4";
    }
    static{
        this.type_entityDisconnected = "5";
    }
    static{
        this.type_dropAction = "6";
    }
    static{
        this.type_screenMessage = "7";
    }
    static{
        this.type_detonate = "8";
    }
    static{
        this.type_chatMessage = "9";
    }
    static{
        this.type_resetAction = "10";
    }
    static{
        this.type_boostAction = "11";
    }
    static{
        this.type_aStarResult = "12";
    }
    static{
        this.type_aStarRequest = "14";
    }
    static{
        this.type_attack = "15";
    }
    static{
        this.type_killed = "16";
    }
    static{
        this.type_respawned = "17";
    }
    static{
        this.type_orientation = "18";
    }
    static{
        this.type_fadeInOut = "19";
    }
    static{
        this.type_fireWeapon = "20";
    }
    static{
        this.type_activateInventoryItem = "21";
    }
    static{
        this.type_entityEmp = "22";
    }
    static{
        this.type_hideRoomName = "23";
    }
    static{
        this.type_sendUpdateLocation = "24";
    }
    static{
        this.type_createLocalEntity = "25";
    }
    static{
        this.type_soundEffect = "26";
    }
    static{
        this.type_destroyLocalEntity = "27";
    }
    static{
        this.type_sendAnimateLocalEntityCollection = "28";
    }
    static{
        this.type_activateAbility = "29";
    }
    static{
        this.type_animateAbility = "30";
    }
    static{
        this.type_updateName = "31";
    }
    static{
        this.type_upgradeGuest = "32";
    }
    static{
        this.type_login = "33";
    }
    static{
        this.type_logActivity = "34";
    }
    static{
        this.type_playerEvent = "35";
    }
    static{
        this.type_showStatUpgradeUI = "36";
    }
    static{
        this.type_entityClicked = "37";
    }
    static{
        this.type_inventoryAction = "38";
    }
    static{
        this.type_requestEntityDetail = "39";
    }
    static{
        this.type_requestItemPickup = "40";
    }
    static{
        this.type_saveAppearance = "41";
    }
    static{
        this.type_mapDelta = "42";
    }
    static{
        this.type_entityTileEffect = "43";
    }
    static{
        this.type_dayPhase = "44";
    }
    static{
        this.type_startSession = "45";
    }
    static{
        this.type_updatePlayerEntityId = "46";
    }
    static{
        this.type_updateSquadState = "47";
    }
    static{
        this.type_requestEntityInteractions = "48";
    }
    static{
        this.type_updateEntityInteractions = "49";
    }
    static{
        this.type_updateEntityPointerIcon = "50";
    }
    static{
        this.type_buildCharacter = "51";
    }
    static{
        this.type_finalizeCharacter = "52";
    }
    static{
        this.type_itemPickedUp = "53";
    }
    static{
        this.type_showTutorial = "54";
    }
    static{
        this.type_updatePlayerBiomeColorMap = "55";
    }
    static{
        this.type_pulseInventoryItem = "56";
    }
    static{
        this.type_fragmentAnimation = "57";
    }
    static{
        this.type_entityFeedback = "58";
    }
    static{
        this.type_onDialogClose = "59";
    }
    static{
        this.type_sendVisibility = "60";
    }
    static{
        this.type_sendTeleported = "61";
    }
    static{
        this.type_locationIconEffect = "62";
    }
    static{
        this.type_updateAudio = "63";
    }
    static{
        this.type_submitFeedback = "64";
    }
    static{
        this.type_sendPleaseWait = "65";
    }
    static{
        this.type_requestPlayerLocations = "66";
    }
    static{
        this.type_activateWorldPoint = "67";
    }
    static{
        this.type_commitWorldEdits = "68";
    }
    static{
        this.type_redrawClient = "69";
    }
    static{
        this.type_getBuildingTilePreview = "70";
    }
    static{
        this.type_sendBuildingTilePreview = "71";
    }
    static{
        this.type_requestVisibility = "72";
    }
    static{
        this.type_builderAction = "73";
    }
    static{
        this.type_requestWorldMap = "74";
    }
    static{
        this.type_sendWorldMap = "75";
    }
    static{
        this.type_requestDropActiveItem = "76";
    }
    static{
        this.type_worldMapClicked = "77";
    }
    static{
        this.type_removeLocationIcon = "78";
    }
    static{
        this.type_addLocationIcon = "79";
    }
    static{
        this.type_startAttack = "80";
    }
    static{
        this.type_entityTileStrikeAt = "81";
    }
    static{
        this.type_attackComplete = "82";
    }
    static{
        this.type_updateActivation = "83";
    }
    static{
        // Cosmetic: make an entity play its attack (swing) animation with no damage/gameplay effect
        // (e.g. a player swinging while placing a building tile).
        this.type_playAttackAnimation = "84";
    }
    static{
        // Configure client-side faction tracking (offscreen edge arrows toward faction members).
        this.type_factionTracking = "85";
    }
    static{
        // Server-initiated: open the command wheel bound to a specific NPC, locked to its role
        // (forager/defender). Payload: { entityId, role }.
        this.type_openCommandWheel = "86";
    }
    static{
        // Per-room roster of notable NPCs (ember defenders/foragers/lord) for a clickable HUD
        // strip. Only emitted for rooms that opt in (room.emberRosterEnabled). Payload: { roster }.
        this.type_updateEmberRoster = "87";
    }
    static{
        // Client-initiated: follow-cam focus. Promotes the given entity + its neighbors to the
        // detailed, every-tick sync tier so a picture-in-picture view can watch it in real time.
        // Payload: { entityId } to focus, or { entityId: null } to clear.
        this.type_setFocusEntity = "88";
    }
    static{
        // Server-initiated one-shot cosmetic: play a green "sparkle halo" over an entity (e.g.
        // when a campfire is refreshed with wood). Payload: { entityId }.
        this.type_entitySparkle = "89";
    }
    static{
        // Server-initiated: open the recruit ROLE PICKER over a specific NPC, so the player can assign
        // it a role (forager/defender). Payload: { entityId, currentRole?, weapon? }.
        //
        // `currentRole` is what turns the same widget into a CHANGE: sent only by an already-hired
        // member's "Change Role" order, it names the job that member holds now, and the picker then
        // offers just the other one (see lib/role_change.js). Absent at a hire, where neither job is
        // held yet and both are on offer.
        //
        // `weapon` is the weapon type the NPC would fight with (the one in its hand), read off the
        // server's copy of its pack; the Defender card names it and says what it is good at.
        this.type_openRolePicker = "90";
    }
    static{
        // Server-initiated: the player's ember run is over -- show the centered end-of-run summary
        // panel (time survived, waves, kills, camp work) with its "Try again" button.
        // Payload: { summary: EmberRunSummary }.
        this.type_showRunSummary = "91";
    }
    static{
        // Server-initiated: put up (or take down) the first-run ember tutorial invitation -- a small
        // stage-anchored bar with "show me"/"skip" and a visible countdown that resolves to "show me".
        // Payload: { prompt: EmberTutorialPrompt } to show, { prompt: null } to dismiss.
        this.type_showTutorialPrompt = "92";
    }
    static{
        // Per-room positions for the ember minimap: every camp member and every wave attacker in the
        // room, plus the room's extent. Only emitted for rooms that opt in (room.emberRosterEnabled).
        // Payload: { minimap: EmberMinimapState }.
        this.type_updateEmberMinimap = "93";
    }
    static{
        // Who ELSE is logged into the server right now, and which wave their camp is on. Sent to each
        // player in an ember room by the EMBER_PLAYERS campaign; the list a player receives never
        // contains themselves. Payload: { players: EmberPlayerEntry[] }.
        this.type_updateEmberPlayers = "94";
    }
    static{
        // Client-initiated: invite another online player into this player's ember camp. The server
        // (EMBER_PLAYERS) decides whether the invite is allowed and where the guest lands.
        // Payload: { entityId }.
        this.type_inviteEmberPlayer = "95";
    }
    static{
        // Server-initiated: put up (or take down) the invitation prompt on the INVITED player -- who is
        // asking, and how long they have to answer. Reaches that player wherever they are, camp or not.
        // Payload: { invite: EmberInvite } to show, { invite: null } to dismiss.
        this.type_updateEmberInvite = "96";
    }
    static{
        // Client-initiated: the invited player's answer. Only an accepted one moves anybody.
        // Payload: { entityId (who invited them), accepted }.
        this.type_answerEmberInvite = "97";
    }
    static{
        // Everything a room says about its own atmosphere, in one payload (RoomAmbience): the windblown
        // leaves, the night fog, the butterflies. Sent on EVERY room entry, including an empty one, so a
        // camp's weather cannot follow the player out into a room that has none of it. Payload:
        // { ambience }.
        //
        // 98, 99 and 100 were one of these each before they were collapsed into this.
        this.type_roomAmbience = "101";
    }
    static{
        // Server-initiated: open the NAME PROMPT over a specific entity so the player can name it --
        // a small field floating over the NPC, pre-filled with the name it already has. Sent when a
        // recruit is hired (the last beat of the role picker), which is the one moment it is offered.
        // Payload: { entityId, name } -- `name` is what the field starts with.
        this.type_openNamePrompt = "102";
    }
    static{
        // Server-initiated: open (or dismiss) the INVASION PICKER on a player whose ember run is over --
        // the camps they could rise in as one of the wave's attackers. Up to three, each a defending
        // player's name plus where their run is up to. Payload: { candidates: EmberInvasionCandidate[] };
        // an EMPTY list is a real answer ("no camp is open to the dead"), and null dismisses the picker.
        this.type_updateInvasionOffer = "105";
    }
    static{
        // Client-initiated: stop sending me world state, nobody is drawing it. Sent once the page has
        // been in the BACKGROUND for a couple of seconds. The client's frame loop is
        // requestAnimationFrame, which a hidden tab does not get, so an unsuspended stream piles up in
        // a queue nothing drains until the tab is killed for its memory -- taking the socket with it.
        // The socket itself stays open and keeps answering pings throughout. No payload.
        this.type_suspendUpdates = "103";
    }
    static{
        // Client-initiated: start sending again, and RESEND EVERYTHING. World state is a delta stream,
        // so a client that stopped listening cannot simply pick it back up -- every change it missed is
        // one the server already considers delivered (see Server.resyncClient). No payload.
        this.type_resumeUpdates = "104";
    }
    static{
        // Server-initiated, last thing before the socket is closed: this session is OVER, and here is
        // why. Sent when the same account logs in again somewhere else ("signedInElsewhere"), which
        // takes the account off this socket. It matters that the client is TOLD: a close on its own is
        // indistinguishable from the wifi blinking, and the client now redials one of those by itself
        // (connection_lifecycle.ts) -- which would take the account straight back off the tab that just
        // claimed it, with both sockets live and both driving the same avatar.
        // Payload: { reason }.
        this.type_sessionEnded = "106";
    }
    static{
        // Client-initiated: change an invited guest's mode. Payload: { entityId, playMode }.
        this.type_setEmberPlayMode = "108";
    }
    static{
        // Client-initiated: eject an invited guest into a fresh Ember room. Payload: { entityId }.
        this.type_kickEmberPlayer = "107";
    }
    static{
        // Owner sends a pending building snapshot; server sends resolved visual-only ghosts to peers.
        this.type_shareBuildingPreview = "109";
    }
    static{
        this.type_updateEmberAnxiety = "111";
    }
    static{
        this.type_sharedBuildingPreview = "110";
    }
    static{
        // Client-initiated, on every connection: what this client can do. Payload: { levelHandOff }, true
        // when it keeps every storey of a house drawn through a change of level (the active map and the
        // destination's passive map swap roles), so the server can leave both maps out of that snapshot.
        this.type_clientCapabilities = "112";
    }
    static{
        // Client-initiated: send my room again, whole, with all of its storeys. For a client that was told
        // to reuse a storey it turned out not to have (see WorldState.levelHandOff). No payload.
        this.type_requestRoomSnapshot = "113";
    }
}





var $5UG8I = parcelRequire("5UG8I");
/**
 * Where this build talks to, and what it is running inside.
 *
 * The client has always derived both from `document.location.hostname`, which works fine for the
 * only two things that existed: a browser tab on projectsamsara.com, and a dev tab on localhost.
 * The native shell breaks that assumption. Capacitor serves the bundled page from
 * `capacitor://localhost` on iOS and `https://localhost` on Android, so a hostname check reads the
 * shipped app as a developer's laptop -- it would dial `ws://localhost:8080` at the phone itself
 * and show the dev name gate to every player. Hence the native check comes FIRST below and the
 * local-dev branch is explicitly gated on it.
 *
 * Everything is overridable through `window.__SAMSARA_CONFIG__`, which the mobile build writes
 * into the bundle. That is how a device build is pointed at a laptop on the LAN for profiling --
 * the thing `API_HOST` was supposed to do and never did, because `process?.env?.API_HOST` is
 * optional-chained and Parcel only substitutes the bare `process.env.X` form. The old expression
 * therefore always fell through to the production default, and a build made with API_HOST set
 * silently talked to production anyway.
 *
 * Reading the environment and deciding from it are kept apart: `resolveConfig` is pure, so the
 * decisions can be tested directly. jsdom will not let a test change `location.hostname` -- it is
 * an unforgeable property -- so a seam is the only way to cover the case this module exists for.
 */ /** Production endpoints, used by the web build and by a release shell alike. */ const $a8f3c0c196817c22$var$PRODUCTION_API_HOST = "wss://api.projectsamsara.com";
const $a8f3c0c196817c22$var$PRODUCTION_ORIGIN = "https://projectsamsara.com";
/** The port `yarn workspace server start` listens on. */ const $a8f3c0c196817c22$var$LOCAL_SERVER_PORT = 8080;
const $a8f3c0c196817c22$export$23531c8df2a01f5e = ()=>({
        hostname: typeof document !== "undefined" ? document.location.hostname : "",
        // The bridge is injected at document start, before any page script runs, so this is reliable
        // from the very first line -- including the inline bootstrap in index.html, which asks the
        // same question before the bundle has loaded.
        hasNativeBridge: typeof window !== "undefined" && !!window.Capacitor,
        injected: typeof window !== "undefined" && window.__SAMSARA_CONFIG__ || {}
    });
const $a8f3c0c196817c22$export$7eca4ea16d4c8343 = (env = $a8f3c0c196817c22$export$23531c8df2a01f5e())=>{
    const { hostname: hostname, hasNativeBridge: hasNativeBridge, injected: injected } = env;
    const native = injected.isNative ?? hasNativeBridge;
    // A dev build in a browser tab: Parcel on localhost, or the LAN address a phone on the same
    // wifi uses to reach it. Deliberately false in the shell, whose origin is also "localhost".
    const localDev = !native && (hostname === "localhost" || hostname.startsWith("10.0"));
    return {
        apiHost: injected.apiHost ?? (localDev ? `ws://${hostname}:${$a8f3c0c196817c22$var$LOCAL_SERVER_PORT}/` : $a8f3c0c196817c22$var$PRODUCTION_API_HOST),
        // A browser build is served beside its own assets; only the shell has to reach out.
        assetBase: injected.assetBase ?? (native ? $a8f3c0c196817c22$var$PRODUCTION_ORIGIN : ""),
        isNative: native,
        // There is no name gate in the shell -- nobody ships a dev prompt -- and no url to put
        // `?guest=true` in either, so the shell always enters as a guest.
        autoGuest: injected.autoGuest ?? native
    };
};
const $a8f3c0c196817c22$export$43ab85c863381e0 = ()=>$a8f3c0c196817c22$export$7eca4ea16d4c8343().isNative;


const $10da07838e6d507c$export$7d15b64cf5a3a4c4 = (num, min, max)=>Math.min(Math.max(num, min), max);
const $10da07838e6d507c$export$d0a8044dce8ff2fc = ()=>/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const $10da07838e6d507c$export$3dc8fb2aae1f259d = ()=>{
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent;
    if (/CrOS|iPad|Tablet|Silk/i.test(ua)) return false;
    return /iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua) || /Android.*Mobile/i.test(ua);
};
const $10da07838e6d507c$export$6786c0480bb11ee9 = 0.9;
const $10da07838e6d507c$export$84bfe54394ef8e9d = 1.6;
const $10da07838e6d507c$export$37f678e26ae1e8b8 = (vector, power)=>power >= $10da07838e6d507c$export$6786c0480bb11ee9 ? {
        x: vector.x * $10da07838e6d507c$export$84bfe54394ef8e9d,
        y: vector.y * $10da07838e6d507c$export$84bfe54394ef8e9d
    } : vector;
const $10da07838e6d507c$export$c6ec669adaa5980d = 1.3;
const $10da07838e6d507c$export$e4369cabd7e84cd9 = ()=>{
    const letters = "0123456789ABCDEF".split("");
    let color = "0x";
    for(var i = 0; i < 6; i++)color += letters[Math.round(Math.random() * 15)];
    return color;
};
const $10da07838e6d507c$export$aa707847c2571374 = {
    scale: $10da07838e6d507c$export$c6ec669adaa5980d,
    surfaceZoom: 2.0,
    viewportX: 7,
    viewportY: 5,
    // Extra world units revealed on each edge by the mobile canvas. Kept separate from
    // viewportX/Y, which also control the camera's fixed position and map-edge clamping.
    viewportPaddingX: 0,
    viewportPaddingY: 0
};



var $5UG8I = parcelRequire("5UG8I");
/**
 * "You are not connected", with a way back.
 *
 * Deliberately DOM rather than pixi. This is the screen for when things are already broken -- the
 * server is down, the wifi dropped, the app was asleep for an hour -- and the renderer is exactly
 * the thing that may be mid-collapse or never started. A div needs nothing but a document.
 *
 * It exists because the native shell has nowhere to go. In a browser a lost socket redirects to the
 * portal, but the shell's origin IS the app bundle: "/" would reload the app, and an alert() would
 * freeze the WebView behind a modal the player cannot dismiss into anything useful. So the shell
 * sat there silently on a dead socket, which looks exactly like the game having hung.
 */ const $69f7ea6451029ed5$var$OVERLAY_ID = "samsara-disconnected";
const $69f7ea6451029ed5$var$style = (el, css)=>{
    Object.entries(css).forEach(([key, value])=>el.style.setProperty(key, value));
};
const $69f7ea6451029ed5$export$1609d5d6ccae23cd = ()=>typeof document !== "undefined" && !!document.getElementById($69f7ea6451029ed5$var$OVERLAY_ID);
const $69f7ea6451029ed5$export$b6aef85896caf7b2 = ()=>{
    if (typeof document === "undefined") return;
    document.getElementById($69f7ea6451029ed5$var$OVERLAY_ID)?.remove();
};
const $69f7ea6451029ed5$export$4237b8ea75e6554 = (reason)=>{
    if (typeof document === "undefined") return;
    // Takes over from the generic panel if a close got here first: this is the more specific story,
    // and the one with no retry.
    $69f7ea6451029ed5$export$b6aef85896caf7b2();
    const signedInElsewhere = reason === "signedInElsewhere";
    const contentMismatch = [
        "contentRevisionMismatch",
        "contentActivationFailed",
        "contentActivationTimeout"
    ].includes(reason);
    $69f7ea6451029ed5$var$renderOverlay({
        heading: contentMismatch ? "Game update required" : signedInElsewhere ? "Signed in somewhere else" : "Session ended",
        body: contentMismatch ? "Your game content differs from the server. Reload to get the current version." : signedInElsewhere ? "This account was signed in from another window or device, so this one has been signed out." : "The server ended this session.",
        buttonLabel: contentMismatch ? "Reload game" : "Log in again",
        onPress: ()=>window.location.reload(),
        // A reload leaves, so there is nothing to re-arm.
        rearm: false
    });
};
const $69f7ea6451029ed5$export$5f7f27f369ebe35d = ({ everConnected: everConnected, onRetry: onRetry })=>{
    if (typeof document === "undefined" || $69f7ea6451029ed5$export$1609d5d6ccae23cd()) // Already up: a dead socket can report itself more than once (an error, then a close), and
    // the player should not watch the panel flicker or lose a retry they are mid-press on.
    return;
    $69f7ea6451029ed5$var$renderOverlay({
        heading: everConnected ? "Connection lost" : "Can't reach the server",
        body: everConnected ? "You have been disconnected from the world." : "The server may be down, or this device may be offline.",
        buttonLabel: "Try again",
        onPress: onRetry,
        rearm: true
    });
};
const $69f7ea6451029ed5$var$renderOverlay = ({ heading: headingText, body: bodyText, buttonLabel: buttonLabel, onPress: onPress, rearm: rearm })=>{
    if ($69f7ea6451029ed5$export$1609d5d6ccae23cd()) return;
    const overlay = document.createElement("div");
    overlay.id = $69f7ea6451029ed5$var$OVERLAY_ID;
    $69f7ea6451029ed5$var$style(overlay, {
        position: "fixed",
        inset: "0",
        // Not fully opaque: the world behind stays faintly visible, so this reads as something
        // laid over the game rather than as the app having quit.
        background: "rgba(7, 9, 13, 0.92)",
        display: "flex",
        "align-items": "center",
        "justify-content": "center",
        "font-family": "'Jost', Verdana, Geneva, sans-serif",
        "z-index": "20",
        padding: "16px",
        "box-sizing": "border-box"
    });
    const card = document.createElement("div");
    $69f7ea6451029ed5$var$style(card, {
        width: "min(380px, 100%)",
        "box-sizing": "border-box",
        padding: "26px",
        background: "rgba(17, 21, 27, 0.95)",
        border: "1px solid rgba(122, 136, 158, 0.45)",
        "border-radius": "10px",
        "text-align": "center"
    });
    const heading = document.createElement("div");
    heading.textContent = headingText;
    $69f7ea6451029ed5$var$style(heading, {
        "font-weight": "300",
        "font-size": "22px",
        "letter-spacing": "0.12em",
        color: "#f2f4ef"
    });
    const body = document.createElement("div");
    body.textContent = bodyText;
    $69f7ea6451029ed5$var$style(body, {
        "margin-top": "10px",
        "font-size": "14px",
        "line-height": "1.45",
        color: "#a9b2bf"
    });
    const button = document.createElement("button");
    button.textContent = buttonLabel;
    $69f7ea6451029ed5$var$style(button, {
        "margin-top": "22px",
        width: "100%",
        // Tall enough to be a real touch target. It is the only control on the screen, and the
        // player is already unhappy by the time they are looking at it.
        height: "48px",
        background: "#8fd66b",
        border: "0",
        "border-radius": "8px",
        "font-family": "inherit",
        "font-size": "16px",
        "font-weight": "600",
        color: "#12210a",
        cursor: "pointer"
    });
    let pressed = false;
    const press = ()=>{
        if (pressed) return;
        pressed = true;
        button.textContent = rearm ? "Reconnecting..." : "One moment...";
        button.disabled = true;
        $69f7ea6451029ed5$var$style(button, {
            background: "#5c7a49",
            color: "#0d1607",
            cursor: "default"
        });
        try {
            onPress();
        } catch (e) {
            (0, $5UG8I.logger).error({
                tags: [
                    "websocket",
                    "connection"
                ]
            }, "Retry threw", String(e));
        }
        if (!rearm) return;
        // A refused connection can fail faster than the player lets go of the button, so re-arming
        // from the close handler would race this. Re-arm on a timer instead: the control always
        // comes back, and a second press is always possible.
        setTimeout(()=>{
            if (!$69f7ea6451029ed5$export$1609d5d6ccae23cd()) return;
            pressed = false;
            button.textContent = buttonLabel;
            button.disabled = false;
            $69f7ea6451029ed5$var$style(button, {
                background: "#8fd66b",
                color: "#12210a",
                cursor: "pointer"
            });
        }, 3000);
    };
    button.addEventListener("click", press);
    card.append(heading, body, button);
    overlay.append(card);
    document.body.append(overlay);
};


// Browser-side agent that remote-controls the logged-in player. A `/agent <goal>` chat
// command starts it; `/agent stop` returns control to the human. While active it:
//   1. fully takes over input (disables the human keyboard/mouse handlers),
//   2. every ~DECISION_INTERVAL_MS: builds an observation from the client's own view,
//      POSTs it to the server's /agent/decide proxy (which calls Claude), and applies the
//      returned action via the existing Client input methods,
//   3. re-applies its held movement intent every frame (onFrame), because reconciliation
//      overwrites the local player's speed2 each frame.
// The human watches everything in their own browser — the agent's inputs produce the same
// server updates and rendering a human's would.
// Maps a semantic AgentAction to the existing Client input methods. The agent never issues
// raw keyboard/mouse — every action here is something a human player could also do.
//
// Movement actions set a *held intent* (a unit velocity vector) on the controller; the
// controller re-applies it each frame (see agent_controller.onFrame), because client-side
// reconciliation overwrites the local player's speed2 every frame. One-shot actions (attack,
// ability, pickup, etc.) call the corresponding Client sender immediately.

// Item types that restore hunger when "use"d (mirrors packages/server/.../atoms/hunger.ts).
const $6b64ef7e2f784083$var$FOOD_ITEMS = new Set([
    "drumstick",
    "mushroom-purple",
    "mushroom-yellow",
    "mushroom-red"
]);
/** Unit vectors for the compass directions the LLM may use. +y is south. */ const $6b64ef7e2f784083$var$DIR_VECTORS = {
    N: {
        x: 0,
        y: -1
    },
    S: {
        x: 0,
        y: 1
    },
    E: {
        x: 1,
        y: 0
    },
    W: {
        x: -1,
        y: 0
    },
    NE: {
        x: 0.7071,
        y: -0.7071
    },
    NW: {
        x: -0.7071,
        y: -0.7071
    },
    SE: {
        x: 0.7071,
        y: 0.7071
    },
    SW: {
        x: -0.7071,
        y: 0.7071
    }
};
function $6b64ef7e2f784083$export$79fc7e923089e4c6(client, sink, action) {
    const player = client.clientGameLogic.playerEntity;
    switch(action.type){
        case "move_toward":
            {
                if (!player?.location) return "move_toward: no player";
                const dx = action.x - player.location.x;
                const dy = action.y - player.location.y;
                const mag = Math.sqrt(dx * dx + dy * dy);
                if (mag < 1) {
                    sink.setHeldMovement(null);
                    return "move_toward: already there";
                }
                sink.setHeldMovement({
                    x: dx / mag,
                    y: dy / mag
                });
                return `move_toward (${Math.round(action.x)}, ${Math.round(action.y)})`;
            }
        case "move":
            {
                const v = $6b64ef7e2f784083$var$DIR_VECTORS[action.dir?.toUpperCase?.() || ""];
                if (!v) return `move: unknown dir ${action.dir}`;
                sink.setHeldMovement(v);
                return `move ${action.dir}`;
            }
        case "stop":
            sink.setHeldMovement(null);
            return "stop";
        case "attack":
            if (!action.entityId) return "attack: no target";
            client.startAttack(action.entityId);
            return `attack ${action.entityId}`;
        case "chop":
            // Strike a harvestable map tile (e.g. a tree) at the given world point. The server
            // only lands the strike if the player is adjacent, so aim at a nearby feature.
            client.entityTileStrike({
                x: action.x,
                y: action.y
            });
            return `chop (${Math.round(action.x)}, ${Math.round(action.y)})`;
        case "eat":
            {
                // Find a food item in the live inventory and "use" it (restores hunger server-side).
                const food = (player?.inventory?.items || []).find((i)=>i.itemType && $6b64ef7e2f784083$var$FOOD_ITEMS.has(i.itemType));
                if (!player || !food) return "eat: no food";
                client.inventoryAction(player.entityId, food.id, "use");
                return `eat ${food.itemType}`;
            }
        case "use_ability":
            client.activateAbility(action.key);
            return `use_ability ${action.key}`;
        case "pickup":
            client.itemPickupAction();
            return "pickup";
        case "drop":
            client.dropAction();
            return "drop";
        case "command_squad":
            client.sendCommandWheelSelection(action.command, action.npcType, action.targetEntityId);
            return `command_squad ${action.command} (${action.npcType})`;
        case "say":
            if (!player) return "say: no player";
            client.send({
                entityId: player.entityId,
                message: action.message
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_chatMessage);
            return `say "${action.message}"`;
        case "wait":
            return "wait";
        default:
            return `unknown action ${action.type}`;
    }
}


// Builds an AgentObservation from the client's own view of the world. This is deliberately
// sourced from ClientGameLogic (the client's partial replica) rather than server truth, so
// the agent perceives exactly what the human player's client knows — natural fog-of-war.

// Trees are tagged in their tile definition (`tree` in content/game/entities/tiles.json), so a new
// tree -- a Sprite Lab one included -- needs no code change and is never recognised by its name.
const $ff74dc2a666565c1$var$treeKind = (tile)=>tile ? (0, $cdf806a94d4c01be$export$4783a51780b31483)[tile]?.tree : undefined;
const $ff74dc2a666565c1$export$1db3e4d273a27613 = (tile)=>$ff74dc2a666565c1$var$treeKind(tile) === "grown";
const $ff74dc2a666565c1$export$81d865d97cd78a4a = (tile)=>!!$ff74dc2a666565c1$var$treeKind(tile);
const $ff74dc2a666565c1$export$d4f2a8ae858ec9dd = ()=>(0, $cdf806a94d4c01be$export$d7f6fa5288114206).filter((tile)=>$ff74dc2a666565c1$export$1db3e4d273a27613(tile));
const $ff74dc2a666565c1$export$84fb81d7a74c390f = (tile)=>tile ? (0, $cdf806a94d4c01be$export$4783a51780b31483)[tile]?.grass : undefined;
const $ff74dc2a666565c1$export$3bd84e90c0698644 = (tile)=>$ff74dc2a666565c1$export$84fb81d7a74c390f(tile) === "long";
const $ff74dc2a666565c1$export$59557e9589aeede8 = (tile)=>!!$ff74dc2a666565c1$export$84fb81d7a74c390f(tile);
const $ff74dc2a666565c1$export$81defb755c513edb = (tile)=>[
        "ore-coal",
        "testore"
    ].includes(tile);




const $836ee63355e500c0$var$NEARBY_RADIUS_TILES = 16 // matches the server's detail range (15 tiles)
;
const $836ee63355e500c0$var$MAX_NEARBY = 20;
const $836ee63355e500c0$var$FEATURE_RADIUS_TILES = 5;
// Compass directions as (dx, dy) tile steps. +y is south (screen down).
const $836ee63355e500c0$var$DIRS = {
    N: [
        0,
        -1
    ],
    S: [
        0,
        1
    ],
    E: [
        1,
        0
    ],
    W: [
        -1,
        0
    ],
    NE: [
        1,
        -1
    ],
    NW: [
        -1,
        -1
    ],
    SE: [
        1,
        1
    ],
    SW: [
        -1,
        1
    ]
};
const $836ee63355e500c0$var$round = (n, dp = 1)=>{
    const f = Math.pow(10, dp);
    return Math.round(n * f) / f;
};
function $836ee63355e500c0$var$buildTerrain(logic, playerTileX, playerTileY) {
    const tmp = logic.tilemapMetaProvider;
    // Sparse: list only the BLOCKED directions (open ground is the common case, so emitting
    // all-false entries every tick is pure token waste). Empty array = fully open.
    const blocked1 = [];
    const blocked2 = [];
    const isBlocked = (tx, ty)=>{
        if (!tmp) return false;
        // No approach coords => "blocked no matter what" (pure wall/water test).
        return tmp.isCollisionAt(tx, ty) || (tmp.isDeepAt ? tmp.isDeepAt(tx, ty) : false);
    };
    for (const [dir, [dx, dy]] of Object.entries($836ee63355e500c0$var$DIRS)){
        if (isBlocked(playerTileX + dx, playerTileY + dy)) blocked1.push(dir);
        if (isBlocked(playerTileX + dx * 2, playerTileY + dy * 2)) blocked2.push(dir);
    }
    const features = [];
    if (tmp?.getEntityTileAt) {
        for(let dx = -$836ee63355e500c0$var$FEATURE_RADIUS_TILES; dx <= $836ee63355e500c0$var$FEATURE_RADIUS_TILES && features.length < 12; dx++)for(let dy = -$836ee63355e500c0$var$FEATURE_RADIUS_TILES; dy <= $836ee63355e500c0$var$FEATURE_RADIUS_TILES && features.length < 12; dy++){
            if (dx === 0 && dy === 0) continue;
            let hit;
            try {
                hit = tmp.getEntityTileAt(playerTileX + dx, playerTileY + dy);
            } catch  {
                hit = undefined;
            }
            // Harvestable trees, by their tile metadata. (This read `tileId`, a numeric tile id,
            // so it never matched a tree name and the agent was never told about one.)
            const kind = hit?.entityTile;
            if ((0, $ff74dc2a666565c1$export$1db3e4d273a27613)(kind)) features.push({
                kind: kind,
                dxTiles: dx,
                dyTiles: dy
            });
        }
    }
    return {
        blocked1: blocked1,
        blocked2: blocked2,
        features: features
    };
}
function $836ee63355e500c0$export$4f720bc779752b6f(logic, goal, tick, recentChat = []) {
    const player = logic.playerEntity;
    if (!player || !player.location) return null;
    const px = player.location.x;
    const py = player.location.y;
    const playerTileX = Math.floor(px / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    const playerTileY = Math.floor(py / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    const nearby = [];
    logic.entityManager.iterate([
        "npc",
        "player"
    ], (e)=>{
        if (!e || e.entityId === player.entityId || !e.location) return;
        if (e.entityState === "dead") return;
        const dxPx = e.location.x - px;
        const dyPx = e.location.y - py;
        const distTiles = Math.sqrt(dxPx * dxPx + dyPx * dyPx) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        if (distTiles > $836ee63355e500c0$var$NEARBY_RADIUS_TILES) return;
        let disposition = "neutral";
        try {
            disposition = (0, $d3527b517d667178$export$4cfe0674a42ef84e).social.computeDisposition(e, player);
        } catch  {
            disposition = "neutral";
        }
        nearby.push({
            entityId: e.entityId,
            name: e.safeName ? e.safeName() : e.name || e.npcType || e.entityType,
            npcType: e.npcType,
            x: $836ee63355e500c0$var$round(e.location.x, 0),
            y: $836ee63355e500c0$var$round(e.location.y, 0),
            dxTiles: $836ee63355e500c0$var$round(dxPx / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
            dyTiles: $836ee63355e500c0$var$round(dyPx / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
            distanceTiles: $836ee63355e500c0$var$round(distTiles),
            hp: e.hp,
            maxHp: e.maxHp,
            faction: e.faction || undefined,
            disposition: disposition
        });
    });
    nearby.sort((a, b)=>a.distanceTiles - b.distanceTiles);
    if (nearby.length > $836ee63355e500c0$var$MAX_NEARBY) nearby.length = $836ee63355e500c0$var$MAX_NEARBY;
    const inventory = (player.inventory?.items || []).filter((i)=>!!i.itemType).map((i)=>({
            itemType: i.itemType,
            quantity: i.quantity,
            readied: i.readied
        }));
    return {
        goal: goal,
        tick: tick,
        roomName: logic.roomName,
        dayPhase: logic.dayPhase ? logic.dayPhase.phase || undefined : undefined,
        self: {
            entityId: player.entityId,
            x: $836ee63355e500c0$var$round(px, 0),
            y: $836ee63355e500c0$var$round(py, 0),
            hp: player.hp,
            maxHp: player.maxHp,
            mana: player.mana,
            hunger: player.hunger,
            roomId: player.roomId,
            faction: player.faction || undefined,
            moving: !!player.movement?.moving,
            inventory: inventory
        },
        nearby: nearby,
        terrain: $836ee63355e500c0$var$buildTerrain(logic, playerTileX, playerTileY),
        recentChat: recentChat.slice(-8)
    };
}


// Tick cadence floor (ms). Overridable via AGENT_INTERVAL_MS to trade cost vs. responsiveness.
const $b9d4ad6eac1471db$var$DECISION_INTERVAL_MS = Number("") || 1100;
const $b9d4ad6eac1471db$var$HISTORY_LIMIT = 8;
const $b9d4ad6eac1471db$var$CHAT_LIMIT = 16;
// Named goal presets so common objectives don't have to be typed out in full.
// `/agent <preset>` (e.g. `/agent survive`) expands to the mapped goal; any other text is
// used verbatim as a free-form goal.
const $b9d4ad6eac1471db$var$PRESETS = {
    survive: "Survive and sustain the camp indefinitely: keep the campfire fed with wood (chop nearby trees yourself and/or send foragers to forage and feed the fire), defend the camp and yourself from hostiles (attack them, or command defenders to engage), eat food when your hunger gets low, pick up any wood or food nearby, and retreat if your hp gets low.",
    defend: "Protect the camp: watch for hostiles and deal with them fast \u2014 attack the nearest threat yourself and command the defenders to engage, hold the line near the Lord and campfire, and retreat to heal only if your hp gets critically low.",
    gather: "Keep the camp supplied: chop nearby trees for wood and/or command foragers to forage wood and feed the campfire so it never dies down, and pick up any wood or food lying around."
};
function $b9d4ad6eac1471db$var$decideEndpoint() {
    // Prod: derive from the WS API host (wss://host -> https://host). Local dev (Parcel on
    // :1234, server on :8080): talk to the server's HTTP port on the same hostname.
    const apiHost = "";
    if (apiHost) return apiHost.replace(/^ws/, "http").replace(/\/?$/, "") + "/agent/decide";
    const loc = typeof location !== "undefined" ? location : {
        protocol: "http:",
        hostname: "localhost"
    };
    return `${loc.protocol}//${loc.hostname}:8080/agent/decide`;
}
class $b9d4ad6eac1471db$export$433d8951d222f317 {
    constructor(client){
        this.client = client;
        this.active = false;
        this.goal = "";
        this.tick = 0;
        this.heldSpeed2 = null;
        this.history = [];
        this.recentChat = [];
        this.loopTimer = null;
        this.inFlight = false;
    }
    isActive() {
        return this.active;
    }
    /** Handle a `/agent ...` chat command. Returns true if it was consumed. */ handleCommand(raw) {
        const rest = raw.replace(/^\/agent\b/, "").trim();
        if (rest === "" || rest === "help") {
            const presets = Object.keys($b9d4ad6eac1471db$var$PRESETS).join(", ");
            this.say(`Agent: \`/agent <goal>\` to play a free-form goal, \`/agent stop\` to take back over. ` + `Presets: ${presets} (e.g. \`/agent survive\`).`);
            return true;
        }
        if (rest === "stop" || rest === "off") {
            this.stop("You have control again.");
            return true;
        }
        // Expand a known preset keyword; otherwise use the text as a free-form goal.
        const preset = $b9d4ad6eac1471db$var$PRESETS[rest.toLowerCase()];
        this.start(preset || rest);
        return true;
    }
    start(goal) {
        this.goal = goal;
        this.tick = 0;
        this.history = [];
        this.heldSpeed2 = null;
        this.active = true;
        this.setTakeover(true);
        this.say(`Agent taking over: "${goal}". Say \`/agent stop\` to reclaim control.`);
        this.scheduleNext(0);
    }
    stop(message = "Agent stopped.") {
        this.active = false;
        if (this.loopTimer) {
            clearTimeout(this.loopTimer);
            this.loopTimer = null;
        }
        this.heldSpeed2 = null;
        const p = this.client.clientGameLogic.playerEntity;
        if (p) {
            p.speed2 = {
                x: 0,
                y: 0
            };
            if (p.movement) p.movement.moving = false;
        }
        this.setTakeover(false);
        this.say(message);
    }
    /** Record chat the player heard, so the agent has recent context. */ noteChat(from, message) {
        if (!message) return;
        this.recentChat.push({
            from: from,
            message: message
        });
        if (this.recentChat.length > $b9d4ad6eac1471db$var$CHAT_LIMIT) this.recentChat.shift();
    }
    /** Called every frame from Client.update(), between reconciliation and processInputs. */ onFrame() {
        if (!this.active || !this.heldSpeed2) return;
        const p = this.client.clientGameLogic.playerEntity;
        if (!p) return;
        p.speed2 = {
            x: this.heldSpeed2.x,
            y: this.heldSpeed2.y
        };
        p.speed = p.maxSpeed;
        p.movement = {
            direction: p.movement?.direction,
            ...p.movement || {},
            moving: true,
            angle: Math.atan2(this.heldSpeed2.y, this.heldSpeed2.x)
        };
    }
    // --- MovementSink for the action dispatcher ---
    setHeldMovement(v) {
        this.heldSpeed2 = v;
        if (!v) {
            const p = this.client.clientGameLogic.playerEntity;
            if (p) {
                p.speed2 = {
                    x: 0,
                    y: 0
                };
                if (p.movement) p.movement.moving = false;
            }
        }
    }
    setTakeover(on) {
        const pc = this.client.clientGameLogic.playerController;
        if (!pc) return;
        pc.enabledKeyboardAction(!on);
        pc.enabledMouseAction(!on);
    }
    scheduleNext(delayMs) {
        if (!this.active) return;
        this.loopTimer = setTimeout(()=>this.runTick(), delayMs);
    }
    async runTick() {
        if (!this.active) return;
        const started = Date.now();
        try {
            const obs = (0, $836ee63355e500c0$export$4f720bc779752b6f)(this.client.clientGameLogic, this.goal, this.tick, this.recentChat);
            if (obs && !this.inFlight) {
                this.inFlight = true;
                const action = await this.decide(obs);
                this.inFlight = false;
                if (this.active && action) {
                    const desc = (0, $6b64ef7e2f784083$export$79fc7e923089e4c6)(this.client, this, action);
                    // eslint-disable-next-line no-console
                    console.log(`[agent tick ${this.tick}] ${desc}${action.reasoning ? " \u2014 " + action.reasoning : ""}`);
                    this.history.push({
                        tick: this.tick,
                        action: action
                    });
                    if (this.history.length > $b9d4ad6eac1471db$var$HISTORY_LIMIT) this.history.shift();
                }
            }
        } catch (e) {
            this.inFlight = false;
            // eslint-disable-next-line no-console
            console.warn("[agent] decide failed:", e?.message || e);
        }
        this.tick++;
        const elapsed = Date.now() - started;
        this.scheduleNext(Math.max(0, $b9d4ad6eac1471db$var$DECISION_INTERVAL_MS - elapsed));
    }
    async decide(observation) {
        // Strip `reasoning` from history before sending — the model doesn't need its own past
        // rationales replayed each tick, and they add up over the rolling window.
        const history = this.history.map((h)=>{
            const { reasoning: reasoning, ...action } = h.action;
            return {
                tick: h.tick,
                action: action
            };
        });
        const body = {
            observation: observation,
            history: history
        };
        const operatorToken = window.sessionStorage.getItem("samsara.admin.token");
        const resp = await fetch($b9d4ad6eac1471db$var$decideEndpoint(), {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...operatorToken ? {
                    Authorization: `Bearer ${operatorToken}`
                } : {}
            },
            body: JSON.stringify(body)
        });
        if (resp.status === 401 || resp.status === 429) {
            this.stop("Agent requires an operator session and an available request budget.");
            return null;
        }
        if (!resp.ok) throw new Error(`decide HTTP ${resp.status}`);
        const data = await resp.json();
        return data?.action ?? null;
    }
    say(message) {
        // eslint-disable-next-line no-console
        console.log(`[agent] ${message}`);
        const gui = this.client.clientGameLogic.clientRenderer?.gui?.();
        if (gui?.showScreenMessage) try {
            gui.showScreenMessage(message);
        } catch  {
        /* best-effort UI feedback */ }
    }
}




/**
 * Fullscreen, and the little of it the browsers actually hand us.
 *
 * Two constraints shape everything here:
 *
 *  - It does not exist on iPhone. Every iOS browser is WebKit underneath, and WebKit only lets a
 *    <video> element go fullscreen there. It is also switched off when we are framed without
 *    allowfullscreen (the itch.io embed). `fullscreenSupported` is the check for both.
 *  - It cannot be entered on load. Every browser that supports it demands a transient user
 *    activation, so the earliest a phone can expand is the player's first tap -- which is what
 *    `enterFullscreenIfMobile` and `enterFullscreenOnFirstGesture` are for. Call them from
 *    inside a tap/click/key handler; outside one the request is refused and the activation is
 *    spent for nothing.
 */ const $0f29b5a53cc88186$var$el = ()=>document.documentElement;
const $0f29b5a53cc88186$var$dom = ()=>document;
const $0f29b5a53cc88186$var$request = ()=>{
    const e = $0f29b5a53cc88186$var$el();
    return e.requestFullscreen?.bind(e) || e.webkitRequestFullscreen?.bind(e) || e.msRequestFullscreen?.bind(e);
};
const $0f29b5a53cc88186$var$release = ()=>{
    const d = $0f29b5a53cc88186$var$dom();
    return d.exitFullscreen?.bind(d) || d.webkitExitFullscreen?.bind(d) || d.msExitFullscreen?.bind(d);
};
/** A refused request rejects rather than throws; none of this is worth an unhandled rejection. */ const $0f29b5a53cc88186$var$swallow = (result)=>{
    if (result && typeof result.catch === "function") result.catch(()=>undefined);
};
const $0f29b5a53cc88186$export$efad50a2596de3ba = ()=>{
    // The native shell has no browser chrome to escape -- it launches fullscreen, with the status
    // bar hidden by Info.plist and the Android system bars by MainActivity. WebKit still exposes
    // requestFullscreen inside the WebView, so without this the login screen would draw an expand
    // chip that can only ever be a no-op. Same principle as the iPhone case below: better an
    // absent control than one that visibly lies.
    if ((0, $a8f3c0c196817c22$export$43ab85c863381e0)()) return false;
    if (typeof document === "undefined" || !$0f29b5a53cc88186$var$request()) return false;
    // false inside an iframe embedded without allowfullscreen.
    return $0f29b5a53cc88186$var$dom().fullscreenEnabled ?? $0f29b5a53cc88186$var$dom().webkitFullscreenEnabled ?? true;
};
const $0f29b5a53cc88186$export$72fee83dd1572775 = ()=>{
    if (typeof window === "undefined") return false;
    if (window.navigator?.standalone === true) return true;
    const match = window.matchMedia?.("(display-mode: standalone)");
    return !!match?.matches;
};
const $0f29b5a53cc88186$export$d0667092c1237a4c = ()=>(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() && !(0, $a8f3c0c196817c22$export$43ab85c863381e0)() && !$0f29b5a53cc88186$export$72fee83dd1572775() && !$0f29b5a53cc88186$export$efad50a2596de3ba();
const $0f29b5a53cc88186$export$d7e5f5607a21fc72 = ()=>typeof document !== "undefined" && !!($0f29b5a53cc88186$var$dom().fullscreenElement || $0f29b5a53cc88186$var$dom().webkitFullscreenElement || $0f29b5a53cc88186$var$dom().msFullscreenElement);
const $0f29b5a53cc88186$export$859c5997fce6d45 = ()=>{
    if (!$0f29b5a53cc88186$export$efad50a2596de3ba() || $0f29b5a53cc88186$export$d7e5f5607a21fc72()) return;
    $0f29b5a53cc88186$var$swallow($0f29b5a53cc88186$var$request()());
};
const $0f29b5a53cc88186$export$1aba1ee5e6dc1474 = ()=>{
    if (!$0f29b5a53cc88186$export$efad50a2596de3ba()) return;
    // Ask the document which way it is rather than keeping our own flag: Esc, the system back
    // gesture and the browser's own control all leave fullscreen without telling us, and a stale
    // flag turns the next tap into an exit that does nothing -- a button that looks dead.
    $0f29b5a53cc88186$var$swallow($0f29b5a53cc88186$export$d7e5f5607a21fc72() ? $0f29b5a53cc88186$var$release()?.() : $0f29b5a53cc88186$var$request()());
};
/**
 * How many gestures the arming below is allowed to spend. More than one because a request can be
 * refused for want of a user activation and says nothing when it is -- measured in Chrome, a
 * handler on `pointerup` can run a beat before the browser marks the activation, and the request
 * rejects with a bare "Permissions check failed". Few, because past the opening taps the player
 * is likelier to have left fullscreen deliberately than to have been refused, and expanding the
 * page under them would be its own kind of broken.
 */ const $0f29b5a53cc88186$var$FIRST_GESTURE_ATTEMPTS = 3;
const $0f29b5a53cc88186$export$48ce62c637877209 = ()=>{
    if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() || !$0f29b5a53cc88186$export$efad50a2596de3ba()) return;
    // A single tap arrives as both a touchend and a pointerup. Whichever a browser sends first is
    // the family we keep, so the taps after it are counted once each.
    const events = [
        "touchend",
        "pointerup"
    ];
    let attempts = 0;
    const stop = ()=>events.forEach((type)=>window.removeEventListener(type, onGesture));
    function onGesture(event) {
        events.filter((type)=>type !== event.type).forEach((type)=>window.removeEventListener(type, onGesture));
        if ($0f29b5a53cc88186$export$d7e5f5607a21fc72()) {
            stop();
            return;
        }
        attempts += 1;
        $0f29b5a53cc88186$export$859c5997fce6d45();
        if (attempts >= $0f29b5a53cc88186$var$FIRST_GESTURE_ATTEMPTS) stop();
    }
    events.forEach((type)=>window.addEventListener(type, onGesture));
};
const $0f29b5a53cc88186$export$1bfbbc26cf37a585 = ()=>{
    if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) return;
    $0f29b5a53cc88186$export$859c5997fce6d45();
    // Arm after the current gesture has finished, or the listener catches this very tap and
    // spends a retry on a request we have already made.
    setTimeout($0f29b5a53cc88186$export$48ce62c637877209, 0);
};


// Fake a slow connection on a local dev socket, so "how does this look at 90ms?" is a question
// you can answer at your desk instead of guessing.
//
// Everything about how other players look -- interpolation, the size of the update gaps a client
// has to bridge, reconciliation on the local player -- only misbehaves once frames stop arriving
// the instant they are sent. On localhost they always do, which is exactly the case that hides
// every latency bug. The headless harness conditions its loopback the same way (see
// __tests__/integration/loopback.ts) and is the right place to MEASURE; this is for looking.
//
// Only installed against a local server, and idle until somebody asks for latency:
//
//     netsim.set({ rttMs: 90, jitterMs: 20 })   // both directions, so 90ms round trip
//     netsim.off()
//
// Delay never reorders, because a WebSocket runs over TCP and neither would a real one.
const $789f2cfb0ccfe259$var$settings = {
    rttMs: 0,
    jitterMs: 0
};
/** Last scheduled delivery time per direction, so a jittered frame never overtakes its predecessor. */ const $789f2cfb0ccfe259$var$watermark = {
    inbound: 0,
    outbound: 0
};
const $789f2cfb0ccfe259$var$oneWayDelay = ()=>{
    const base = $789f2cfb0ccfe259$var$settings.rttMs / 2;
    if (base <= 0 && $789f2cfb0ccfe259$var$settings.jitterMs <= 0) return 0;
    const jitter = $789f2cfb0ccfe259$var$settings.jitterMs > 0 ? (Math.random() * 2 - 1) * $789f2cfb0ccfe259$var$settings.jitterMs : 0;
    return Math.max(0, base + jitter);
};
const $789f2cfb0ccfe259$var$schedule = (direction, deliver)=>{
    const delay = $789f2cfb0ccfe259$var$oneWayDelay();
    if (delay <= 0) {
        deliver();
        return;
    }
    const now = Date.now();
    const at = Math.max(now + delay, $789f2cfb0ccfe259$var$watermark[direction]);
    $789f2cfb0ccfe259$var$watermark[direction] = at;
    setTimeout(deliver, at - now);
};
const $789f2cfb0ccfe259$export$1e138c080884cecd = (ws)=>{
    let handler = null;
    Object.defineProperty(ws, "onmessage", {
        configurable: true,
        get: ()=>handler,
        set: (fn)=>{
            handler = fn;
        }
    });
    ws.addEventListener("message", (event)=>{
        $789f2cfb0ccfe259$var$schedule("inbound", ()=>handler?.(event));
    });
    const send = ws.send.bind(ws);
    ws.send = (data)=>$789f2cfb0ccfe259$var$schedule("outbound", ()=>{
            // A held frame can come due after the socket has closed, which the real send()
            // answers with a throw. Nothing upstream expects that from a send it made a moment
            // ago, and the frame is moot either way.
            if (ws.readyState !== WebSocket.OPEN) return;
            send(data);
        });
    const api = {
        set: (next)=>{
            Object.assign($789f2cfb0ccfe259$var$settings, next);
            return {
                ...$789f2cfb0ccfe259$var$settings
            };
        },
        off: ()=>{
            $789f2cfb0ccfe259$var$settings.rttMs = 0;
            $789f2cfb0ccfe259$var$settings.jitterMs = 0;
            return {
                ...$789f2cfb0ccfe259$var$settings
            };
        },
        get: ()=>({
                ...$789f2cfb0ccfe259$var$settings
            })
    };
    window.netsim = api;
    return api;
};


/**
 * Staying connected across a backgrounded game.
 *
 * Two different things go wrong when the player switches away, and this module is the shared
 * machinery for both.
 *
 * The first was ours. `client.update()` runs on the pixi ticker, which is requestAnimationFrame,
 * and a hidden tab is given no frames at all -- but `ws.onmessage` keeps firing, because a
 * background tab still receives network events. So `incomingWorldStates` filled at the server's
 * tick rate (~58 frames a second) with nothing on the other end to drain it, until the renderer
 * process was killed for its memory and took the socket down with it. From the player's seat the
 * websocket "died when the game was backgrounded"; what actually died was the tab. The answer is
 * to stop the stream at its SOURCE while nobody is drawing it (type_suspendUpdates) rather than to
 * buffer it more cleverly, which also hands the server back the broadcast work for an idle player.
 *
 * The second is not ours and cannot be prevented: iOS and Android suspend a backgrounded app and
 * the socket goes with it. What can be fixed is NOTICING. A resumed WebView routinely holds a
 * socket that still reports OPEN, will never deliver another byte, and never fires `close` -- so
 * nothing tells the client anything is wrong and the game just sits there. Hence the watchdog:
 * traffic is the liveness signal, and silence while the page is in the FOREGROUND is the symptom.
 *
 * Both reconnect, so one object owns every reason to dial. Two schedulers racing here would
 * double-dial, and on this server a second socket is a second session.
 */ /** The events that mean "the player may be looking at this again". */ const $06a32a8a2cf2cac8$export$4227747d94937b6e = {
    hiddenGraceMs: 2000,
    staleAfterMs: 15000,
    resumeStaleAfterMs: 5000,
    checkEveryMs: 2500,
    retryDelaysMs: [
        1000,
        2000,
        4000,
        8000,
        15000
    ]
};
const $06a32a8a2cf2cac8$export$c7ee3fdd01415f96 = ()=>({
        // visibilityState is the modern spelling; document.hidden is kept for older Android WebViews,
        // which is the environment that most needs this to work.
        hidden: ()=>typeof document === "undefined" ? false : document.visibilityState ? document.visibilityState === "hidden" : !!document.hidden,
        now: ()=>Date.now(),
        setTimer: (fn, ms)=>setTimeout(fn, ms),
        clearTimer: (handle)=>clearTimeout(handle),
        setPoll: (fn, ms)=>setInterval(fn, ms),
        clearPoll: (handle)=>clearInterval(handle),
        listen: (type, fn)=>{
            // visibilitychange is a document event; the rest are window events. Getting this wrong
            // fails silently, which is the worst way for a reconnect path to fail.
            const target = type === "visibilitychange" ? document : window;
            target.addEventListener(type, fn);
            return ()=>target.removeEventListener(type, fn);
        }
    });
class $06a32a8a2cf2cac8$export$5be6ec909ad606e6 {
    constructor(delegate, host = $06a32a8a2cf2cac8$export$c7ee3fdd01415f96(), timings = $06a32a8a2cf2cac8$export$4227747d94937b6e){
        this.teardowns = [];
        /** True once the server has been told to stop sending. */ this.suspended = false;
        /** Last moment anything at all arrived from the server. */ this.lastTrafficTs = 0;
        /** Consecutive failed redials, for the backoff. */ this.retryCount = 0;
        /** A dial is in flight. Nothing else may start one. */ this.dialling = false;
        this.start = ()=>{
            if (this.teardowns.length > 0) return;
            this.teardowns.push(this.host.listen("visibilitychange", ()=>{
                if (this.host.hidden()) this.armHiddenTimer();
                else this.resumed();
            }));
            // Belt and braces around visibilitychange, which a WebView does not always deliver on the
            // way back in. Each of these is a resume in its own right, and `resumed` is idempotent.
            const alsoResume = [
                "focus",
                "online",
                "pageshow"
            ];
            alsoResume.forEach((type)=>this.teardowns.push(this.host.listen(type, ()=>{
                    if (!this.host.hidden()) this.resumed();
                })));
            this.pollHandle = this.host.setPoll(this.check, this.timings.checkEveryMs);
        };
        this.stop = ()=>{
            this.teardowns.forEach((teardown)=>teardown());
            this.teardowns = [];
            this.host.clearPoll(this.pollHandle);
            this.pollHandle = undefined;
            this.clearHiddenTimer();
            this.clearRetryTimer();
        };
        /** Anything arrived from the server. The one signal that the socket is really alive. */ this.noteTraffic = ()=>{
            this.lastTrafficTs = this.host.now();
            this.staleAfterMs = this.timings.staleAfterMs;
        };
        /** A socket opened. */ this.noteConnected = ()=>{
            this.dialling = false;
            this.retryCount = 0;
            this.suspended = false;
            this.noteTraffic();
            // A socket that finishes opening when the page is ALREADY hidden -- the player dialled and
            // switched away during the handshake -- still has a stream to stop.
            if (this.host.hidden()) this.armHiddenTimer();
        };
        /** The current socket closed, or a dial failed. */ this.noteConnectionLost = ()=>{
            const dialFailed = this.dialling;
            this.dialling = false;
            this.suspended = false;
            this.clearHiddenTimer();
            // A failed retry backs off; a live socket dying starts the ladder from the bottom, because
            // most lost sockets come back on the first try.
            this.retryCount = dialFailed ? this.retryCount + 1 : 0;
            this.scheduleRetry();
        };
        /** The player pressed "Try again". Skip the ladder. */ this.retryNow = ()=>{
            this.clearRetryTimer();
            this.retryCount = 0;
            this.dial("player asked");
        };
        this.armHiddenTimer = ()=>{
            if (this.hiddenHandle || this.suspended) return;
            this.hiddenHandle = this.host.setTimer(()=>{
                this.hiddenHandle = undefined;
                // Back already, or gone before the socket was up: either way there is nothing to stop.
                if (!this.host.hidden() || this.suspended || !this.delegate.isConnected()) return;
                this.suspended = true;
                this.delegate.suspendUpdates();
            }, this.timings.hiddenGraceMs);
        };
        this.clearHiddenTimer = ()=>{
            if (this.hiddenHandle) {
                this.host.clearTimer(this.hiddenHandle);
                this.hiddenHandle = undefined;
            }
        };
        this.clearRetryTimer = ()=>{
            if (this.retryHandle) {
                this.host.clearTimer(this.retryHandle);
                this.retryHandle = undefined;
            }
        };
        this.resumed = ()=>{
            this.clearHiddenTimer();
            if (!this.delegate.isConnected()) {
                // The socket did not survive. Dial straight away rather than serving out a backoff the
                // player experiences as the game having hung.
                this.clearRetryTimer();
                this.retryCount = 0;
                this.dial("resumed on a closed socket");
                return;
            }
            if (this.suspended) {
                this.suspended = false;
                this.delegate.resumeUpdates();
                // We have just asked for a resend, so it is owed immediately. If nothing comes, this
                // socket is one of the corpses that still reports OPEN.
                this.lastTrafficTs = this.host.now();
                this.staleAfterMs = this.timings.resumeStaleAfterMs;
                return;
            }
            // Never suspended (a quick flick away), so the stream never stopped and the ordinary
            // deadline applies -- but the clock restarts here, because any silence up to now was the
            // background's and says nothing about the socket.
            this.lastTrafficTs = this.host.now();
            this.staleAfterMs = this.timings.staleAfterMs;
        };
        this.scheduleRetry = ()=>{
            if (this.retryHandle || this.dialling) return;
            // No dialling while hidden: on a suspended phone it cannot succeed, and on a desktop
            // nobody is watching the result. `resumed` dials immediately instead.
            if (this.host.hidden()) return;
            const delays = this.timings.retryDelaysMs;
            const delay = delays[Math.min(this.retryCount, delays.length - 1)];
            this.retryHandle = this.host.setTimer(()=>{
                this.retryHandle = undefined;
                this.dial(`retry ${this.retryCount + 1}`);
            }, delay);
        };
        this.dial = (why)=>{
            if (this.dialling) return;
            this.dialling = true;
            // Start the liveness clock from the dial, so a socket that opens and says nothing is
            // judged on its own silence rather than on the previous socket's.
            this.lastTrafficTs = this.host.now();
            this.staleAfterMs = this.timings.staleAfterMs;
            this.delegate.log?.(`reconnecting: ${why}`);
            this.delegate.reconnect();
        };
        this.check = ()=>{
            // Nothing is being drawn and the stream was stopped on purpose, so silence here is
            // expected rather than evidence. Background timers are throttled to a crawl anyway.
            if (this.host.hidden() || this.dialling) return;
            if (!this.delegate.isConnected()) {
                // A close we were never told about, or a retry that is overdue.
                this.scheduleRetry();
                return;
            }
            if (this.host.now() - this.lastTrafficTs < this.staleAfterMs) return;
            // Open, in the foreground, and silent for longer than the server's own ping interval
            // allows. This is the resumed-but-dead socket: no close event is ever coming for it.
            this.retryCount = 0;
            this.dial("no traffic");
        };
        this.delegate = delegate;
        this.host = host;
        this.timings = timings;
        this.staleAfterMs = timings.staleAfterMs;
        this.lastTrafficTs = host.now();
    }
}


class $67f7e8116a91e4e7$export$1f2bb630327ac4b6 {
    static{
        this.POSITION_ERROR_DECAY = 0.8 // per-frame; ~200ms ease at 60fps
        ;
    }
    static{
        this.POSITION_ERROR_SNAP_EPSILON = 0.05 // px; below this, clear the error
        ;
    }
    static{
        this.SERVER_CLOCK_CREEP = 0.0005;
    }
    static{
        // How far behind the server's clock other entities are drawn. The buffer has to hold at
        // least one sample older than this for interpolation to have something to work with, so it
        // must cover the one-way latency plus the gap between updates for that entity.
        this.INTERPOLATION_DELAY_MS = 150;
    }
    static{
        /**
     * Hard ceiling on the queue above. The drain is `update()`, which runs on the pixi ticker --
     * requestAnimationFrame -- and a BACKGROUNDED tab is given no frames at all, while
     * `ws.onmessage` keeps firing because a hidden tab still receives network events. So this
     * queue grew at the server's tick rate with nothing taking anything off it, until the renderer
     * was killed for its memory and the socket died with it. That is the "websocket dies when the
     * game is backgrounded" report.
     *
     * The real fix is to stop the stream at the source (see ConnectionLifecycle and
     * type_suspendUpdates). This cap is the backstop for the gap that is left: the couple of
     * seconds before the suspend is sent, a server too old to honour it, a resume message that
     * never arrives. Sized at roughly a third of a second of frames -- far more than any drawn
     * frame needs, far less than it takes to matter -- and overflow drops the OLDEST, because the
     * newest frame is the only one worth drawing. Dropping any frame leaves the picture
     * incomplete (the stream is deltas), so it also sets `desynced`, and the resume path turns
     * that into a full resend rather than letting the player wander round a stale world.
     */ this.MAX_QUEUED_WORLD_STATES = 20;
    }
    constructor(clientGameLogic){
        this.spriteLabVisible = false;
        this.spriteLabPollAt = 0;
        // Whether a socket has ever opened this session. Only used to word the disconnected panel:
        // "connection lost" and "can't reach the server" are different situations to be in, and the
        // second one usually means the server rather than the player's wifi.
        this.everConnected = false;
        this.lastState = undefined;
        this.incompleteEntityLatch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(2000);
        // Reconciliation error-smoothing for the local player. When an authoritative
        // update disagrees with the client's predicted position (e.g. the server has
        // slowed the player during a push that the client predicted at full speed),
        // we don't snap the rendered position to the correction -- that reads as a
        // shudder because the camera follows the player. Instead we keep the
        // authoritative/predicted position as truth in entity.location and carry the
        // visual delta here, decaying it toward zero over a few frames so the camera
        // eases into the correction. Large deltas (teleports/room changes) bypass this.
        this.playerPositionError = {
            x: 0,
            y: 0
        };
        // Interpolation can only ever be as even as the samples it is fed, and the samples are not
        // even: the server advances a player when it dequeues one of that player's input frames
        // (~16ms apart) but photographs the world on its own 10ms tick, so consecutive samples are
        // one step of movement over alternately 10ms and 20ms. Replayed literally that is a real
        // ±25% speed ripple at ~12Hz -- a visible shimmer on anything moving. So the interpolated
        // point is a TARGET, and the drawn position chases it through a first-order filter, which
        // attenuates the ripple to a few percent. The cost is TAU more latency on top of the
        // interpolation delay, which nothing about this game is tight enough to notice.
        this.renderSmoothing = new Map();
        this.incomingWorldStates = [];
        /** A world-state frame was dropped, so this client's picture has a hole in it. */ this.desynced = false;
        /**
     * Rate limit on asking the server to resend the world. A resync is a burst of work for one
     * player on a box that has a tick to make, so it is worth being certain it cannot be asked for
     * repeatedly. (It cannot in practice -- the only thing that drops frames is the drain not
     * running, and the request is made FROM the drain -- but this costs nothing to be sure of.)
     */ this.resyncRequestLatch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(5000);
        /**
     * How often a WALKING player's own position is reconciled against the server's. It was 100ms,
     * which meant a player holding a direction ignored nine out of every ten authoritative
     * positions -- fine while the only thing moving them is their own input, which they predict
     * exactly, but not when the server applies a force they cannot predict. A push is such a force:
     * the gap grew for a whole 100ms before anything was folded in, and a correction that big is
     * over the half-tile "that was a teleport" line in accumulatePlayerPositionError, so it was
     * snapped rather than eased -- 21px in one 16ms frame, against a 1.4px stride. Reconciling once
     * per drawn frame keeps each correction down to a pixel or two, which the smoothing absorbs
     * invisibly, and costs no more than the prediction already running every frame.
     */ this.interpolationTs = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(16);
        this.interpolatable = new Set();
        this.interpolationLogLatch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(3000) // Log every 3 seconds
        ;
        this.interpolationStats = {
            totalInterpolatable: 0,
            culledEntities: 0,
            actuallyInterpolated: 0,
            skippedNoBuffer: 0,
            skippedNotInterpolatable: 0,
            // Frames where the buffer could not bracket the render timestamp, so the entity was
            // drawn holding a sample instead of moving between two. A nonzero rate here means the
            // interpolation delay no longer covers this connection's latency plus update gap.
            underran: 0
        };
        this.boost = (on)=>{
            this.send({
                entityId: this.clientGameLogic.playerEntity.entityId,
                boost: on
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_boostAction);
        };
        this.chargedWeaponAction = (chargeAction, chargeId, target)=>{
            this.send({
                message: {
                    chargedWeaponAction: {
                        chargeAction: chargeAction,
                        chargeId: chargeId,
                        target: target
                    }
                }
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_fireWeapon);
        };
        this.fireBullet = ()=>{
            const player = this.clientGameLogic.playerEntity;
            if (!player) return;
            if (player.weapon?.profileId) return;
            if (!this.clientGameLogic.canFireBulletFrom(player)) return;
            this.clientGameLogic.attack(player.entityId, ()=>{
                const projectileTarget = [
                    "bow",
                    "crossbow"
                ].includes(player.weapon?.weaponType) ? this.clientGameLogic.playerController?.rangedAimPoint?.() : undefined;
                const bullets = this.clientGameLogic.createBulletFrom(player);
                if (!bullets?.length) // could not fire bullet
                return;
                this.clientGameLogic.clientRenderer.gui().targetingShot?.();
                const crossFloorAim = (player.weapon?.weaponType === "bow" || player.weapon?.weaponType === "crossbow") && this.clientGameLogic.tilemapMetaProvider?.twoStoreyHouse ? this.clientGameLogic.clientRenderer.map().crossFloorAim?.(this.clientGameLogic.clientRenderer.gui().worldPointAtPointer()) : undefined;
                bullets.forEach((bullet)=>{
                    bullet.entityId = (0, $a80d0b17b615d6f7$export$5e699d18035b41af)();
                    if (crossFloorAim) return;
                    bullet.projectileTarget = projectileTarget;
                    this.clientGameLogic.entityManager.set(bullet);
                    if (bullet.spriteId !== "none") this.clientGameLogic.clientRenderer.entity().create(bullet);
                });
                const entities = bullets.map((bullet)=>{
                    let message = {
                        entityId: bullet.entityId
                    };
                    return message;
                });
                this.send({
                    message: {
                        entities: entities,
                        crossFloorAim: crossFloorAim,
                        projectileTarget: projectileTarget,
                        origin: {
                            ...player.location
                        },
                        roomId: player.roomId,
                        movement: {
                            ...player.movement
                        },
                        weapon: player.weapon
                    }
                }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_fireWeapon);
            });
        };
        this.spawnNpc = ()=>{
            // if (this.clientGameLogic.playerEntity.name?.trim() !== "aron") {
            //     return
            // }
            this.send({
                entityId: this.clientGameLogic.playerEntity.entityId
            }, "spawn");
        };
        this.dropAction = ()=>{
            this.send({
                entityId: this.clientGameLogic.playerEntity.entityId
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_dropAction);
        };
        this.resetAction = ()=>{
            this.send({
                entityId: this.clientGameLogic.playerEntity.entityId
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_resetAction);
        };
        this.activateInventoryItem = (item)=>{
            this.send({
                message: {
                    item: item,
                    originEntityId: this.clientGameLogic.playerEntity.entityId
                }
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_activateInventoryItem);
        };
        this.activateAbility = (shortcutKey)=>{
            this.send({
                message: {
                    shortcutKey: shortcutKey,
                    originEntityId: this.clientGameLogic.playerEntity.entityId
                }
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_activateAbility);
        };
        this.dropActiveItem = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestDropActiveItem);
        };
        this.startChat = ()=>{
            this.clientGameLogic.clientRenderer.gui().startChat();
        };
        this.stopChat = ()=>{
            const message = this.clientGameLogic.clientRenderer.gui().stopChat();
            this.sendChatMessage(message);
        };
        // One line of chat, from whichever field the player typed it into -- the inline one the Enter
        // key opens or the composer a phone gets (gui/chat_composer.ts). Everything the game does with
        // a typed line beyond putting it on the wire lives here, so neither field has to know about it.
        this.sendChatMessage = (message)=>{
            if (!message) return;
            // Intercept `/agent ...` client-side: the AgentController handles it locally instead
            // of sending it to the server as a normal chat message.
            if (message.startsWith("/agent") && this.agentController) {
                this.agentController.handleCommand(message);
                return;
            }
            this.send({
                entityId: this.clientGameLogic.playerEntity.entityId,
                message: message
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_chatMessage);
        };
        this.captureKeystroke = (c, mods)=>{
            if (c.length > 1 && !$67f7e8116a91e4e7$export$1f2bb630327ac4b6.CHAT_EDIT_KEYS.includes(c)) return;
            this.clientGameLogic.clientRenderer.gui().captureKeystroke(c, mods);
        };
        this.pasteIntoChat = (text)=>{
            this.clientGameLogic.clientRenderer.gui().insertChatText(text);
        };
        this.updateName = (name)=>{
            this.send({
                message: {
                    name: name,
                    originEntityId: this.clientGameLogic.playerEntity.entityId
                }
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateName);
        };
        this.updateEntityFromMessage = (message, entity, now)=>{
            if (message.floorFall?.fromAbove && (entity.floorFall?.id !== message.floorFall.id || entity.roomId !== message.roomId)) {
                // Arrival coordinates and the falling pose must reach the renderer together.
                // Inputs and interpolation samples from the previous floor cannot move this arrival.
                const predicted = entity.location;
                entity.location = {
                    x: message.position[0],
                    y: message.position[1]
                };
                entity.position_buffer = [];
                if (entity.entityId === this.clientGameLogic.playerEntity?.entityId) {
                    entity.pending_inputs.length = 0;
                    // Floors share coordinates. Ease out the steps predicted past the edge instead of
                    // jumping the body and camera back by them as the drop begins.
                    this.accumulatePlayerPositionError(predicted, entity.location);
                }
                this.renderSmoothing.delete(entity.entityId);
                this.clientGameLogic.invalidateEntitySortCache();
                this.clientGameLogic.invalidateViewportCache();
            }
            entity.lastUpdateTs = now;
            entity.entityState = message.entityState;
            entity.roomId = message.roomId;
            entity.speed = message.speed;
            entity.maxSpeed = message.maxSpeed;
            entity.name = message.name;
            entity.faction = message.faction;
            entity.color = message.color;
            entity.hp = message.hp;
            entity.hunger = message.hunger;
            entity.maxHunger = message.maxHunger;
            entity.maxHp = message.hpMax;
            entity.joinedTeam = message.joinedTeam;
            entity.score = message.score;
            entity.level = message.level;
            entity.scoreTilNextLevel = message.scoreTillNextLevel;
            entity.weapon = message.weapon;
            entity.paralyzeUntilTs = message.paralyzeUntilTs;
            entity.appearance = message.appearance;
            entity.clickable = message.clickable;
            entity.spriteId = message.spriteId;
            entity.noGlint = message.noGlint;
            entity.expirationTs = message.expirationTs;
            entity.quantity = message.quantity;
            entity.lightMeta = message.lightMeta;
            entity.spriteScale = message.spriteScale;
            entity.leaderEntityId = message.leaderEntityId;
            entity.rescuePose = message.rescuePose;
            entity.rescueHelpHint = message.rescueHelpHint;
            entity.chargedWeaponDefinition = message.chargedWeaponDefinition;
            entity.weaponCharge = message.weaponCharge;
            entity.areaProjectile = message.areaProjectile;
            entity.crossFloorProjectile = message.crossFloorProjectile;
            entity.projectileTarget = message.projectileTarget;
            entity.landedArrow = message.landedArrow;
            entity.ownerEntityId = message.ownerEntityId;
            entity.visualEffects = message.visualEffects;
            entity.floorFall = message.floorFall;
            entity.stairTravel = message.stairTravel;
            entity.animationPose = message.animationPose;
            entity.attackWindup = message.attackWindup;
            entity.bonecallerAttack = message.bonecallerAttack;
            entity.bonecallerCombatRadius = message.bonecallerCombatRadius;
            entity.bonecallerRitual = message.bonecallerRitual;
            entity.preSpawnEffectView = message.preSpawnEffectView;
            entity.bonecallerEmergenceRemainingMs = message.bonecallerEmergenceRemainingMs;
            entity.downed = message.downed;
            // Run or walk, for every body including this client's own (see Message.boosted).
            entity.boosted = message.boosted;
            entity.holdRemainingMs = message.holdRemainingMs;
            entity.holdDurationMs = message.holdDurationMs;
            entity.rainDamaged = !!message.rainDamaged;
            entity.contextMenuSubject = message.contextMenuSubject;
            entity.campfireMenuLearned = message.campfireMenuLearned;
            entity.recruitMenuLearned = message.recruitMenuLearned;
            entity.flags = {};
            entity.flags[0, $cb689cfa16c444ba$export$c8c6d6e2d9b5390d] = message.sigilIcon;
            entity.dimensions = message.dimensions;
            entity.debug = message.debug;
            entity.afk = message.afk;
            entity.active = message.active;
            if (message.inventory) entity.inventory = message.inventory;
            this.clientGameLogic.clientRenderer.entity().update(entity);
        };
        // Fold one freshly arrived frame's send timestamp into the server clock estimate.
        this.observeServerClock = (serverTs)=>{
            if (typeof serverTs !== "number") return;
            const observed = Date.now() - serverTs;
            if (this.serverClockOffset === undefined || observed < this.serverClockOffset) {
                this.serverClockOffset = observed;
                return;
            }
            this.serverClockOffset += (observed - this.serverClockOffset) * $67f7e8116a91e4e7$export$1f2bb630327ac4b6.SERVER_CLOCK_CREEP;
        };
        // The server's clock, as best we can read it from here. Position buffers are kept on THIS
        // timeline rather than on ours: server timestamps are evenly spaced and monotonic by
        // construction, so a re-estimate of the offset moves the playback cursor instead of
        // corrupting samples already in the buffer.
        this.serverNow = ()=>Date.now() - (this.serverClockOffset ?? 0);
        /**
     * Put one freshly arrived frame on the queue, never letting it grow without bound.
     *
     * See MAX_QUEUED_WORLD_STATES for why a bound is needed at all. The oldest goes rather than the
     * newest: a stale frame has nothing to offer a renderer that is about to be handed a newer one,
     * and REPLAYING a long backlog would be worse than dropping it -- every frame runs
     * reconciliation and re-applies pending inputs, so a thousand of them arrive as a thousand
     * frames of prediction in a single tick.
     */ this.enqueueWorldState = (message)=>{
            this.incomingWorldStates.push(message);
            while(this.incomingWorldStates.length > $67f7e8116a91e4e7$export$1f2bb630327ac4b6.MAX_QUEUED_WORLD_STATES){
                this.incomingWorldStates.shift();
                this.desynced = true;
            }
        };
        /**
     * Throw away everything that went stale while the player was not looking, and ask the server
     * for a fresh picture of the world.
     *
     * Called on resume. The dropped frames cannot simply be caught up on: world state is a DELTA
     * stream, and the server marks each entity as sent per player (Server.playerEntitySentCache),
     * so a change that was broadcast while this client was ignoring it is one the server will never
     * mention again. Only a resend closes that gap, which is what type_resumeUpdates asks for.
     *
     * The local timing state goes too. The server-clock estimate creeps towards the truth over many
     * frames and is now minutes out of date; the interpolation buffers hold samples stamped on that
     * old estimate, and the render smoother holds positions from before the gap. Fed to
     * interpolateEntities as they are, they would draw every remote entity skating in from wherever
     * it stood when the player looked away.
     */ this.resyncAfterGap = ()=>{
            this.incomingWorldStates.length = 0;
            this.desynced = false;
            this.serverClockOffset = undefined;
            this.renderSmoothing.clear();
            this.clientGameLogic.entityManager.iterate(null, (entity)=>{
                entity.position_buffer = [];
            });
        };
        /**
     * Send something the game can do without, on a socket that may already be gone.
     *
     * The lifecycle's messages are all sent from timers, so the socket can close between the check
     * that it was open and the send itself -- and `send` goes straight at it. An exception thrown
     * out of a timer callback would take the rest of that callback with it, including the state
     * that decides whether to reconnect.
     */ this.sendIfOpen = (payload, payloadType)=>{
            if (this.ws?.readyState !== WebSocket.OPEN) return;
            try {
                this.send(payload, payloadType);
            } catch (e) {
                (0, $5UG8I.logger).error({
                    tags: [
                        "websocket",
                        "error"
                    ]
                }, `Sending ${payloadType} threw`, String(e));
            }
        };
        /** The lifecycle's view of this client: what to do, and whether the socket is up. */ this.lifecycleDelegate = ()=>({
                suspendUpdates: ()=>this.sendIfOpen({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_suspendUpdates),
                resumeUpdates: ()=>{
                    this.resyncAfterGap();
                    this.sendIfOpen({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_resumeUpdates);
                },
                reconnect: ()=>this.redialNow(),
                isConnected: ()=>this.ws?.readyState === WebSocket.OPEN,
                log: (message)=>(0, $5UG8I.logger).info({
                        tags: [
                            "websocket",
                            "connection"
                        ]
                    }, message)
            });
        /**
     * Drop the current socket and dial again with the same credentials.
     *
     * The old socket is closed with its handlers detached first. A socket being replaced because it
     * went silent is not necessarily dead, and its `close` landing after the replacement is up would
     * otherwise put the disconnected panel over a working connection.
     *
     * The client's own world is torn down with it. A new socket is a NEW SESSION -- the server
     * destroys the player on close, so there is nothing to resume into -- and it arrives with a
     * different entityId. Without this the previous avatar stays in the entity manager and drawn on
     * the stage, because the room-change teardown in updateFromWorldState deliberately spares
     * whatever `playerEntity` points at.
     */ this.redialNow = ()=>{
            if (!this.redial || this.injectedSocket) return;
            const old = this.ws;
            if (old) {
                old.onopen = null;
                old.onmessage = null;
                old.onerror = null;
                old.onclose = null;
                try {
                    old.close();
                } catch (e) {
                    (0, $5UG8I.logger).error({
                        tags: [
                            "websocket",
                            "connection"
                        ]
                    }, "Closing the old socket threw", String(e));
                }
            }
            this.resyncAfterGap();
            this.clientGameLogic.prepareForReconnect();
            this.redial();
        };
        /**
     * The server has ended this session and told us why. Stay down.
     *
     * Everything that would dial again is taken away: the lifecycle (its poll sees a closed socket
     * and schedules a retry) and the credentials behind `redial`. Without that, being signed out by
     * a login somewhere else turns into a tug of war -- each tab's redial evicts the other about once
     * a second, forever, with both sockets live in between and both driving the same avatar.
     *
     * The panel goes up HERE rather than waiting for the close, so the player reads why they were
     * signed out instead of a "Connection lost / Try again" that is not true and whose retry would
     * take the account back off the window they moved to.
     */ this.handleSessionEnded = (reason)=>{
            this.sessionEndReason = reason || "ended";
            (0, $5UG8I.logger).info({
                tags: [
                    "websocket",
                    "session"
                ]
            }, `session ended by the server: ${this.sessionEndReason}`);
            this.lifecycle?.stop();
            this.lifecycle = undefined;
            this.redial = undefined;
            if (!this.injectedSocket) (0, $69f7ea6451029ed5$export$4237b8ea75e6554)(this.sessionEndReason);
        };
        // Handles messages from the server and updates client state
        this.processServerMessages = ()=>{
            // A frame was dropped somewhere, so parts of this world are as the player last saw them
            // rather than as they are. Deltas cannot fill that in; only a resend can. The usual cause
            // is the queue overflowing during the couple of seconds between the page being hidden and
            // the suspend taking effect, but a long main-thread stall does it too.
            if (this.desynced && this.resyncRequestLatch.expired()) {
                this.resyncAfterGap();
                this.sendIfOpen({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_resumeUpdates);
            }
            const now = Date.now();
            while(true){
                const worldState = this.incomingWorldStates.shift();
                if (!worldState) break;
                // A level change sent without its map needs the storey drawn here already. Without it, ask
                // for the whole room and drop what arrives for that room until it does.
                if (worldState.levelHandOff && !this.clientGameLogic.clientRenderer.map().drawnFloorProvider?.(worldState.roomId)) this.requestRoomSnapshot(worldState.roomId);
                if (this.awaitingRoomSnapshot) {
                    if (worldState.tilemaps && worldState.tilemapMeta) this.awaitingRoomSnapshot = undefined;
                    else if (worldState.roomId === this.awaitingRoomSnapshot) continue;
                }
                const updatedRoom = this.clientGameLogic.updateFromWorldState(worldState);
                if (updatedRoom) this.declareCapabilities();
                const { messages: messages } = worldState;
                // World state is a list of entity states.
                for(let i = 0; i < messages.length; i++){
                    const message = messages[i];
                    if (message.interest === "leave") {
                        const leaving = this.clientGameLogic.getEntity(message.entityId);
                        if (leaving) {
                            // Fully evict out-of-interest entities. Keeping the renderable alive allows
                            // a stale sprite/interpolation state to resurface before the next snapshot.
                            this.clientGameLogic.clientRenderer.entity().destroy(leaving);
                            this.clientGameLogic.entityManager.remove(leaving.entityId);
                        }
                        this.interpolatable.delete(message.entityId);
                        this.renderSmoothing.delete(message.entityId);
                        this.clientGameLogic.invalidateEntitySortCache();
                        this.clientGameLogic.invalidateViewportCache();
                        continue;
                    }
                    if (this.clientGameLogic.isDestroyed(message.entityId)) continue;
                    // If this is the first time we see this entity, create a local representation.
                    if (!this.clientGameLogic.hasEntity(message.entityId)) this.clientGameLogic.createEntity(message);
                    const entity = this.clientGameLogic.getEntity(message.entityId);
                    if (!entity) continue;
                    this.updateEntityFromMessage(message, entity, now);
                    // No `interest` field at all means the server is not interest-managing this entity
                    // -- an immoveable npc, a player, a bullet -- so it is always live, the same reading
                    // createEntity gives a first message that carries no interest. It is not only belt
                    // and braces: an entity can STOP being interest-managed after the client has
                    // already filed it as dormant. The server drops management the moment `immoveable`
                    // turns true (see interestManaged in server.ts), so an npc spawned moveable out of
                    // detail range -- the ember rescue survivor, revealed at the wreck while the player
                    // is still at the fire -- and then pinned in place arrives dormant and is never
                    // sent an "enter" edge again. Without this it stays dormant for the rest of the
                    // session and render() hides it every frame, however close the player walks.
                    const resumingInterest = message.interest === "enter" || message.interest === undefined && entity.interestState === "dormant";
                    if (resumingInterest) {
                        entity.interestState = "active";
                        entity.position_buffer = [];
                        this.renderSmoothing.delete(entity.entityId);
                        this.clientGameLogic.invalidateEntitySortCache();
                        this.clientGameLogic.invalidateViewportCache();
                    } else if (message.interest === "update" && entity.interestState === "dormant") continue;
                    if ((0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isStationary(entity)) this.interpolatable.delete(entity.entityId);
                    else this.interpolatable.add(entity.entityId);
                    const player = this.clientGameLogic.playerEntity;
                    const isPlayer = message.entityId == player?.entityId;
                    // update other players locally
                    if (isPlayer) {
                        if (!updatedRoom) {
                            const updatedLocation = {
                                x: message.position[0],
                                y: message.position[1]
                            };
                            const positionUpdated = updatedLocation.x !== this.clientGameLogic.playerEntity.location.x || updatedLocation.y !== this.clientGameLogic.playerEntity.location.y;
                            this.clientGameLogic.updateFromPlayerMessage(message);
                            // At most one reconciliation per drawn frame (see interpolationTs). A
                            // standing player skips this and reconciles on every message: with no
                            // pending inputs there is nothing to replay, so it is nearly free.
                            if (player.pending_inputs.length > 0 && !this.interpolationTs.expired()) continue;
                            // Received the authoritative position of this client's entity.
                            if (player.pending_inputs.length < 1 && positionUpdated) {
                                (0, $5UG8I.logger).debug({
                                    tags: [
                                        "player",
                                        "position"
                                    ]
                                }, "Player position updating from", entity.location, "to", updatedLocation);
                                const renderedBefore = {
                                    x: entity.location.x,
                                    y: entity.location.y
                                };
                                entity.location = updatedLocation;
                                this.accumulatePlayerPositionError(renderedBefore, entity.location);
                                this.clientGameLogic.clientRenderer.updatePlayerLocation(entity);
                                // Invalidate caches when player position updates
                                this.clientGameLogic.invalidateEntitySortCache();
                                this.clientGameLogic.invalidateViewportCache();
                                (0, $5UG8I.logger).debug({
                                    tags: [
                                        "player",
                                        "initialization"
                                    ]
                                }, "Player initialized:", this.clientGameLogic.isPlayerInitialized());
                                continue;
                            }
                            if ((0, $cb689cfa16c444ba$export$72a3639d5dd4d5f8)(entity.location, updatedLocation) > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2) this.primingLatch = null;
                            // Capture where the player is currently rendered (last frame's predicted
                            // position) so we can measure the visual correction after reconciliation.
                            const renderedBefore = {
                                x: entity.location.x,
                                y: entity.location.y
                            };
                            entity.location = updatedLocation;
                            // Also invalidate caches in the fallback case
                            this.clientGameLogic.invalidateEntitySortCache();
                            this.clientGameLogic.invalidateViewportCache();
                            // Server Reconciliation. Re-apply all the inputs not yet processed by
                            // the server.
                            let j = 0;
                            while(j < player.pending_inputs.length){
                                const input = player.pending_inputs[j];
                                if (input.input_sequence_number <= message.last_processed_input) // Already processed. Its effect is already taken into account into the world update
                                // we just got, so we can drop it.
                                player.pending_inputs.splice(j, 1);
                                else {
                                    // Not processed by the server yet. Re-apply it.
                                    const resultItem = (0, $5f3ac23de5b4365c$export$d565f58bc438286b).instance.checkout();
                                    this.clientGameLogic.advanceEntity(resultItem.data, entity, input, true);
                                    (0, $5f3ac23de5b4365c$export$d565f58bc438286b).instance.release(resultItem);
                                    j++;
                                }
                            }
                            // entity.location is now the corrected predicted position (truth). Fold the
                            // delta from where we were rendering into the smoothing offset instead of
                            // letting the camera jump. accumulatePlayerPositionError() snaps outright on
                            // large corrections (teleports/room changes).
                            this.accumulatePlayerPositionError(renderedBefore, entity.location);
                        } else {
                            // Apply arrival coordinates before updating the body and its light.
                            // Delaying this left the new room lit from the old position for 100ms.
                            entity.position_buffer = [];
                            entity.location = {
                                x: message.position[0],
                                y: message.position[1]
                            };
                            this.clientGameLogic.updateFromPlayerMessage(message);
                            this.clientGameLogic.clientRenderer.updatePlayerLocation(entity, true);
                        }
                    } else {
                        this.clientGameLogic.updateFromNonPlayerMessage(message);
                        // Received the position of an entity other than this client's.
                        const updatedLocation = {
                            x: message.position[0],
                            y: message.position[1]
                        };
                        // Stamp the sample with when the SERVER took it, not with `now`. `now` is the
                        // moment this frame got round to draining the queue, so it quantizes every
                        // sample to the frame period and collapses two frames drained together onto
                        // one timestamp. Interpolating over that renders a constant-speed walk as one
                        // that alternates between half speed and a jump.
                        const timestamp = worldState.serverTs ?? this.serverNow();
                        entity.location = updatedLocation;
                        this.clientGameLogic.entityManager.set(entity);
                        if (!this.clientGameLogic.isTooDistantFromPlayerByLocation(entity.entityId, updatedLocation)) {
                            const buffer = entity.position_buffer;
                            const previous = buffer[buffer.length - 1];
                            if (previous && previous[0] >= timestamp) // Two samples stamped the same server millisecond. A zero-length
                            // segment has no meaningful velocity and divides by zero in the lerp,
                            // so keep the newer position and drop the older.
                            buffer.pop();
                            buffer.push([
                                timestamp,
                                message.position[0],
                                message.position[1],
                                message.direction,
                                message.angle,
                                message.areaProjectile
                            ]);
                        } else {
                            // Interpolation is paused outside the viewport. Discard history and the
                            // render smoother there, or re-entry blends the new position from an old
                            // sample and can make an ordinary walking NPC jump several tiles.
                            entity.position_buffer.length = 0;
                            this.renderSmoothing.delete(entity.entityId);
                        }
                        if (!message.complete) this.clientGameLogic.incompleteEntity(entity);
                        else this.clientGameLogic.clearIncompleteEntities([
                            entity.entityId
                        ]);
                    }
                    entity.visible = message.visible;
                    // Beside `visible`, and for the same reason: a verdict about somebody ELSE that the
                    // renderer has to act on. See Entity.invading -- it is what keeps the player ring off
                    // a possessed attacker.
                    entity.invading = message.invading;
                    // Also always-on: the survivor crouch must be right on a brief message too.
                    entity.rescuePose = message.rescuePose;
                    // ...and the prompt to hold on her, for the same reason: it is sent on every
                    // message, and a prompt that blinked out between detailed ones -- she waits at the
                    // far end of the map, right at the edge of detail range -- would read as a bug.
                    entity.rescueHelpHint = message.rescueHelpHint;
                    entity.chargedWeaponDefinition = message.chargedWeaponDefinition;
                    entity.weaponCharge = message.weaponCharge;
                    entity.areaProjectile = message.areaProjectile;
                    entity.visualEffects = message.visualEffects;
                    entity.floorFall = message.floorFall;
                    entity.stairTravel = message.stairTravel;
                    entity.animationPose = message.animationPose;
                    entity.attackWindup = message.attackWindup;
                    entity.bonecallerAttack = message.bonecallerAttack;
                    entity.bonecallerCombatRadius = message.bonecallerCombatRadius;
                    entity.bonecallerRitual = message.bonecallerRitual;
                    entity.noGlint = message.noGlint;
                    entity.preSpawnEffectView = message.preSpawnEffectView;
                    entity.bonecallerEmergenceRemainingMs = message.bonecallerEmergenceRemainingMs;
                    // Likewise the fallen pose. `downed` is one of the few verdicts the server puts on
                    // EVERY message rather than only the detailed ones (see fillMessageFromEntity), and
                    // a body left standing for the seconds between detailed messages is the whole tell.
                    entity.downed = message.downed;
                    entity.rainDamaged = !!message.rainDamaged;
                    entity.contextMenuSubject = message.contextMenuSubject;
                    entity.campfireMenuLearned = message.campfireMenuLearned;
                    entity.recruitMenuLearned = message.recruitMenuLearned;
                }
            }
        };
        this.toSendState = (player)=>{
            const { speed2: c, movement: movement } = player;
            if (!this.lastMovement) this.lastMovement = {
                ...movement
            };
            const dontSend = c.x === 0 && c.y === 0 && movement.angle === this.lastMovement.angle;
            this.lastMovement.angle = movement.angle;
            this.lastMovement.direction = movement.direction;
            this.lastMovement.moving = movement.moving;
            return !dontSend;
        };
        this.refreshStairClimbInput = ()=>{
            // Climb prediction clears speed2 and reconciliation can overwrite it too.
            // Restore intent each frame instead of waiting for the independent velocity timer.
            if (this.clientGameLogic.playerEntity?.stairTravel?.climb) this.clientGameLogic.playerController?.updatePlayerVelocity();
        };
        // Process user inputs and send updated to the server
        this.processInputs = ()=>{
            const now_ts = Date.now();
            const last_ts = this.last_ts || now_ts;
            const dt_sec = (now_ts - last_ts) / 1000.0;
            this.last_ts = now_ts;
            // dt_sec is the delta seconds since last update
            this.clientGameLogic.processEntities(dt_sec);
            const player = this.clientGameLogic.playerEntity;
            // handle player movement
            if (player) {
                const ladder = this.clientGameLogic.ladderApproach;
                if (player.stairTravel?.climb) ladder.release();
                else if (player.isDead() || player.isDownedForMovement()) {
                    ladder.release();
                    ladder.reset();
                } else if (ladder.holdingPosition(player.roomId, Date.now())) {
                    // Hold the ladder while the server accepts its climb, including descent
                    // in a bare shaft. Ordinary downward floor openings remain walkable.
                    player.speed2.x = 0;
                    player.speed2.y = 0;
                    player.movement.moving = false;
                }
                const { movement: movement, speed: speed } = player;
                const thisState = this.toSendState(player);
                const changed = thisState !== this.lastState || this.lastState === undefined;
                if (changed) this.sendState = thisState;
                this.lastState = thisState;
                if (!this.primingLatch) {
                    this.primingLatch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(2000, Date.now());
                    this.primingLatch.singleUse = true;
                }
                if (player.stairTravel?.climb || this.sendState || this.primingLatch && !this.primingLatch.expired()) {
                    const speed2 = {
                        x: player.speed2.x * speed,
                        y: player.speed2.y * speed
                    };
                    let message = {
                        entityType: "player",
                        press_time: dt_sec,
                        direction: movement.direction,
                        angle: movement.angle,
                        speed2: speed2,
                        input_sequence_number: player.input_sequence_number++,
                        entityId: player.entityId,
                        roomId: player.roomId
                    };
                    const { x: x, y: y } = player.location;
                    const resultItem = (0, $5f3ac23de5b4365c$export$d565f58bc438286b).instance.checkout();
                    this.clientGameLogic.advancePlayer(resultItem.data, message);
                    const movedX = resultItem.data?.movedX;
                    const movedY = resultItem.data?.movedY;
                    (0, $5f3ac23de5b4365c$export$d565f58bc438286b).instance.release(resultItem);
                    if (!movedX && movedY || movedX && !movedY && (x !== player.location.x || y !== player.location.y)) {
                        if (movedX) {
                            const speed2 = {
                                x: player.speed2.x * speed,
                                y: 0
                            };
                            message.speed2 = speed2;
                        }
                        if (movedY) {
                            const speed2 = {
                                x: 0,
                                y: player.speed2.y * speed
                            };
                            message.speed2 = speed2;
                        }
                    }
                    this.ws.send(JSON.stringify({
                        recv_ts: Date.now(),
                        contentRevision: $e5c675b7b9585b42$export$43829b1119ccb642,
                        contentProtocol: 1,
                        payload: message
                    }));
                    // Save this input for later reconciliation.
                    player.pending_inputs.push(message);
                }
                const provider = this.clientGameLogic.tilemapMetaProvider;
                const climb = provider && !player.isDead() && !player.floorFall && !player.isDownedForMovement() && ladder.update(provider, player.roomId, player.location, player.speed2, Date.now());
                if (climb) this.emitPlayerEvent({
                    playerEventType: "ACTIVATE_TILE_INTERACTION",
                    context: {
                        coordinate: climb.coordinate,
                        layerId: "sprite2",
                        roomId: climb.roomId,
                        interaction: climb.interaction,
                        inputSequenceNumber: player.input_sequence_number - 1
                    }
                });
            }
        };
        this.renderWorld = ()=>this.clientGameLogic.renderScene();
        // Ease the drawn position of one entity toward where interpolation says it is. Frame-rate
        // independent: the same time constant whatever the refresh rate.
        this.smoothRenderPosition = (entityId, targetX, targetY, now)=>{
            const state = (0, $13b02b984dcf834a$export$137ebbe236578701)(this.renderSmoothing.get(entityId), targetX, targetY, now);
            this.renderSmoothing.set(entityId, state);
            return state;
        };
        this.interpolateEntities = ()=>{
            // Compute render timestamp, on the server's timeline (that is what position buffers are
            // stamped with -- see processServerMessages).
            const now = Date.now();
            const render_timestamp = this.serverNow() - $67f7e8116a91e4e7$export$1f2bb630327ac4b6.INTERPOLATION_DELAY_MS;
            // Reset stats for this frame
            this.interpolationStats.totalInterpolatable = this.interpolatable.size;
            this.interpolationStats.culledEntities = 0;
            this.interpolationStats.actuallyInterpolated = 0;
            this.interpolationStats.skippedNoBuffer = 0;
            this.interpolationStats.skippedNotInterpolatable = 0;
            this.interpolationStats.underran = 0;
            this.interpolatable.forEach((entityId)=>{
                const entity = this.clientGameLogic.entityManager.get(entityId);
                if (!entity) return;
                // No point in interpolating local things
                if (!this.clientGameLogic.shouldInterpolate(entity)) {
                    this.interpolationStats.skippedNotInterpolatable++;
                    return;
                }
                // Skip interpolation for culled entities
                if (this.clientGameLogic.isTooDistantFromPlayer(entity)) {
                    this.interpolationStats.culledEntities++;
                    return;
                }
                this.interpolationStats.actuallyInterpolated++;
                // Find the two authoritative positions surrounding the rendering timestamp.
                const buffer = entity.position_buffer || [];
                if (buffer.length < 1) {
                    this.interpolationStats.skippedNoBuffer++;
                    return;
                }
                // Drop samples already played past, keeping the one that brackets the render
                // timestamp from below.
                while(buffer.length >= 2 && buffer[1][0] <= render_timestamp)buffer.shift();
                // Always produce a position, even when the buffer cannot bracket the render
                // timestamp -- it runs dry whenever an update is late, and it has nothing old
                // enough for the first INTERPOLATION_DELAY_MS after an entity appears. Leaving
                // the entity alone on those frames used to hand the drawing over to the raw
                // latest position that processServerMessages had written straight onto it, so
                // the entity jumped a whole interpolation delay forward and then back again on
                // the next frame. Holding the nearest sample we do have and letting the smoother
                // ease into it is both continuous and closer to the truth.
                const from = buffer[0];
                const to = buffer.length >= 2 ? buffer[1] : undefined;
                let targetX = from[1];
                let targetY = from[2];
                let facing = from;
                if (to && from[0] <= render_timestamp) {
                    const span = to[0] - from[0];
                    const progress = span > 0 ? (render_timestamp - from[0]) / span : 1;
                    targetX = from[1] + (to[1] - from[1]) * progress;
                    targetY = from[2] + (to[2] - from[2]) * progress;
                    facing = to;
                } else this.interpolationStats.underran++;
                // Projectiles follow the authoritative straight path. Character easing makes a
                // stopped charge creep toward its landing spot; its phase must also follow the
                // buffered timeline so the warning does not begin while the orb is still travelling.
                let drawn;
                if (entity.areaProjectile) {
                    this.renderSmoothing.delete(entityId);
                    const phase = from[5];
                    if (phase) entity.areaProjectile = {
                        ...phase,
                        remainingMs: Math.max(0, phase.remainingMs - Math.max(0, render_timestamp - from[0]))
                    };
                    drawn = {
                        x: targetX,
                        y: targetY
                    };
                } else drawn = this.smoothRenderPosition(entityId, targetX, targetY, now);
                entity.location.x = drawn.x;
                entity.location.y = drawn.y;
                entity.movement.direction = facing[3];
                entity.movement.angle = facing[4];
            });
            // Log interpolation stats periodically
            if (this.interpolationLogLatch.expired()) {
                const stats = this.interpolationStats;
                const cullRate = stats.totalInterpolatable > 0 ? (stats.culledEntities / stats.totalInterpolatable * 100).toFixed(1) : "0";
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, "\uD83D\uDD04 Interpolation Stats:");
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Total interpolatable: ${stats.totalInterpolatable}`);
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Culled (too far): ${stats.culledEntities} (${cullRate}%)`);
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Actually interpolated: ${stats.actuallyInterpolated}`);
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Skipped (no buffer): ${stats.skippedNoBuffer}`);
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Skipped (not interpolatable): ${stats.skippedNotInterpolatable}`);
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Buffer underran (held a sample): ${stats.underran}`);
                (0, $5UG8I.logger).info({
                    tags: [
                        "interpolation",
                        "stats"
                    ]
                }, `  Performance: ${stats.actuallyInterpolated}/${stats.totalInterpolatable} entities processed`);
            }
        };
        this.incompleteEntities = ()=>{
            if (this.incompleteEntityLatch.expired()) {
                const nearby = this.clientGameLogic.nearbyIncompleteEntities();
                if (nearby.length > 0) this.requestEntityDetail(nearby);
            }
        };
        // Accumulate the visual delta between where the player was being rendered and the
        // freshly reconciled (authoritative/predicted) position. Instead of letting the camera
        // jump to the correction, we carry the delta as an offset that decays over a few frames.
        // A correction larger than half a tile is treated as a teleport/room-change and snapped
        // outright (clearing any pending offset) rather than rubber-banded.
        this.accumulatePlayerPositionError = (renderedBefore, corrected)=>{
            if ((0, $cb689cfa16c444ba$export$72a3639d5dd4d5f8)(renderedBefore, corrected) > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2) {
                this.playerPositionError.x = 0;
                this.playerPositionError.y = 0;
                return;
            }
            this.playerPositionError.x += renderedBefore.x - corrected.x;
            this.playerPositionError.y += renderedBefore.y - corrected.y;
        };
        /**
     * Where the local player is actually DRAWN this frame: the predicted/reconciled truth plus the
     * decaying correction offset. `playerEntity.location` on its own is NOT what the player sees --
     * a reconciliation moves it in a single step and this offset is precisely what hides that -- so
     * anything asking "did the screen jump" has to ask here. The render pass below computes the
     * same sum inline; this is the read-only way to sample it.
     */ this.renderedPlayerLocation = ()=>{
            const player = this.clientGameLogic.playerEntity;
            if (!player) return undefined;
            return {
                x: player.location.x + this.playerPositionError.x,
                y: player.location.y + this.playerPositionError.y
            };
        };
        // Decay the smoothing offset toward zero by one frame. Called at the TOP of the frame
        // (before reconciliation folds in any fresh error) so that on the frame a correction
        // arrives the offset renders at full strength -- exactly cancelling the positional jump --
        // and only begins easing on subsequent frames. Not private: the headless harness drives the
        // frame loop a piece at a time and has to run this one too, or its clients accumulate a
        // correction offset that never eases and stop resembling a real client.
        this.decayPlayerPositionError = ()=>{
            this.playerPositionError.x *= $67f7e8116a91e4e7$export$1f2bb630327ac4b6.POSITION_ERROR_DECAY;
            this.playerPositionError.y *= $67f7e8116a91e4e7$export$1f2bb630327ac4b6.POSITION_ERROR_DECAY;
            if (Math.abs(this.playerPositionError.x) < $67f7e8116a91e4e7$export$1f2bb630327ac4b6.POSITION_ERROR_SNAP_EPSILON) this.playerPositionError.x = 0;
            if (Math.abs(this.playerPositionError.y) < $67f7e8116a91e4e7$export$1f2bb630327ac4b6.POSITION_ERROR_SNAP_EPSILON) this.playerPositionError.y = 0;
        };
        // Game update loop
        this.update = ()=>{
            // Decay first, then let processServerMessages() fold in this frame's correction.
            this.decayPlayerPositionError();
            this.processServerMessages();
            if (!this.clientGameLogic.playerEntity) return;
            const roomId = this.clientGameLogic.playerEntity.roomId;
            const changedRoom = roomId !== this.spriteLabRoomId;
            if (changedRoom) {
                this.spriteLabRoomId = roomId;
                this.spriteLabVisible = false;
                this.updateSpriteLab(null);
            }
            if (changedRoom || (this.spriteLabVisible || roomId?.startsWith("spritelab-")) && Date.now() >= this.spriteLabPollAt) {
                this.spriteLabPollAt = Date.now() + 2000;
                this.send({
                    action: "status"
                }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_spriteLabRequest);
            }
            this.refreshStairClimbInput();
            // Re-apply the agent's held movement intent after reconciliation and before
            // processInputs reads speed2 (reconciliation overwrites it every frame). No-op
            // unless the agent is actively driving.
            this.agentController?.onFrame();
            this.processInputs();
            this.interpolateEntities();
            this.incompleteEntities();
            // Render the player (and camera, which follows it) at the smoothed position:
            // truth + the decaying error offset. entity.location stays the authoritative/predicted
            // truth so the next frame's prediction and reconciliation are unaffected; we offset
            // only for the render/camera pass and restore truth immediately after.
            const player = this.clientGameLogic.playerEntity;
            const offset = this.playerPositionError;
            const hasOffset = offset.x !== 0 || offset.y !== 0;
            if (hasOffset) {
                const truthX = player.location.x;
                const truthY = player.location.y;
                player.location.x = truthX + offset.x;
                player.location.y = truthY + offset.y;
                this.clientGameLogic.clientRenderer.updatePlayerLocation(player);
                this.renderWorld();
                player.location.x = truthX;
                player.location.y = truthY;
            } else this.renderWorld();
            this.clientGameLogic.cleanup();
            // Last, so it judges the scene the frame just drew: a room held black since it landed is
            // opened on the frame its map and its bodies are all actually there. See RoomReveal.
            this.clientGameLogic.tickRoomReveal();
        };
        /** Tell the server, once per connection and once the map exists, that this client keeps storeys drawn. */ this.declareCapabilities = ()=>{
            const levelHandOff = !!this.clientGameLogic.clientRenderer?.map()?.keepsLevelsDrawn?.();
            if (!levelHandOff || this.declaredCapabilitiesTo === this.ws) return;
            this.declaredCapabilitiesTo = this.ws;
            this.sendIfOpen({
                levelHandOff: levelHandOff
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_clientCapabilities);
        };
        this.requestRoomSnapshot = (roomId)=>{
            if (this.awaitingRoomSnapshot === roomId) return;
            this.awaitingRoomSnapshot = roomId;
            this.sendIfOpen({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestRoomSnapshot);
        };
        this.send = (payload, payloadType)=>{
            this.ws.send(JSON.stringify({
                recv_ts: Date.now(),
                contentRevision: $e5c675b7b9585b42$export$43829b1119ccb642,
                contentProtocol: 1,
                payloadType: payloadType,
                payload: payload
            }));
        };
        this.register = (username, password, email)=>{
            this.send({
                username: username,
                password: password,
                email: email
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_upgradeGuest);
        };
        this.login = (username, password)=>{
            this.send({
                username: username,
                password: password
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_login);
        };
        this.logActivity = (activity)=>{
            this.send({
                activity: activity
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_logActivity);
        };
        this.submitFeedback = (feedback)=>{
            this.send({
                feedback: feedback
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_submitFeedback);
        };
        this.handleGuest = (userAgent)=>{
            this.clientGameLogic.clientRenderer.gui().getIntro().init((playerName, password)=>{
                if (!password) this.connectImpl("", undefined, true, ()=>{
                    this.send({
                        playerName: playerName,
                        userAgent: userAgent
                    }, "guest");
                });
                else this.connectImpl("", undefined, true, ()=>{
                    this.login(playerName, password);
                });
            });
        };
        this.invokeStatUpgradeUI = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_showStatUpgradeUI);
        };
        this.entityClicked = (entity)=>{
            this.send({
                entityId: entity.entityId
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entityClicked);
        };
        this.emitPlayerEvent = (playerEvent)=>{
            this.send(playerEvent, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_playerEvent);
        };
        // `location` is the fine world coordinate the player chose for orders that need a place as well
        // as an order -- "Hold Position" is the one that does. Sent as two flat numbers rather than a
        // nested object: this context is spread straight into a MARKER_EVENT and read by @when
        // conditions, and flat scalars are what every other field on this channel already is.
        // A name typed into the name prompt, for the entity it was opened over. The server hands it to
        // that entity's own script (which is what decides whether this player may name it) and cleans
        // the string on the way in -- the cap here only keeps the field honest.
        this.sendEntityName = (targetEntityId, name)=>{
            this.emitPlayerEvent({
                playerEventType: "RENAME_ENTITY",
                context: {
                    targetEntityId: targetEntityId,
                    name: name
                }
            });
        };
        this.sendCommandWheelSelection = (command, npcType, targetEntityId, location)=>{
            this.emitPlayerEvent({
                playerEventType: "SQUAD_COMMAND",
                context: {
                    command: command,
                    npcType: npcType,
                    source: "command_wheel",
                    targetEntityId: // Present only for the per-entity wheel; the server scopes the MARKER_EVENT to this
                    // NPC when set, otherwise the command broadcasts to the whole role.
                    targetEntityId,
                    ...location ? {
                        locationX: Math.round(location.x),
                        locationY: Math.round(location.y)
                    } : {}
                }
            });
        };
        // The player's answer to the first-run tutorial invitation: "accept" or "skip", and whether
        // they clicked it or let the countdown run out. Rides the generic player-event channel, which
        // the server turns into a room-wide MARKER_EVENT that ember-tutorial.js listens for.
        this.sendEmberTutorialCommand = (command, reason = "click", chapter)=>{
            this.emitPlayerEvent({
                playerEventType: "EMBER_TUTORIAL_COMMAND",
                context: {
                    command: command,
                    reason: reason,
                    ...chapter !== undefined ? {
                        chapter: chapter
                    } : {}
                }
            });
        };
        // The player pressed "Next" on a held speech bubble (see AvatarHud.spoke), so the speaker may go
        // on. Rides the generic player-event channel, which the server turns into a room-wide
        // MARKER_EVENT; a script that paces a conversation off these (ember-tutorial.js) then speaks at
        // the player's reading speed rather than its own clock.
        this.sendSpeechDismissed = (speakerEntityId, holdId)=>{
            this.emitPlayerEvent({
                playerEventType: "SPEECH_DISMISSED",
                context: {
                    speakerEntityId: speakerEntityId,
                    holdId: holdId
                }
            });
        };
        // A button on the ember end-of-run summary panel ("retry"). Rides the generic player-event
        // channel, which the server turns into a room-wide MARKER_EVENT the ember controller listens for.
        this.sendEmberRunCommand = (command)=>{
            this.emitPlayerEvent({
                playerEventType: "EMBER_RUN_COMMAND",
                context: {
                    command: command
                }
            });
        };
        // The invasion handshake's four presses, all on the generic player-event channel (which the
        // server turns into a room-wide MARKER_EVENT) exactly like sendEmberRunCommand -- so none of
        // them needs a protocol number of its own:
        //   seek    -- "Resurrect as Undead!" on the end-of-run panel. A nudge for a fresher offer; the
        //              picker does NOT wait on it, because the client already holds the list.
        //   join    -- a card was picked. `entityId` is the DEFENDING player, which is how a pick names
        //              the camp it means (a room is not addressable from a client).
        //   cancel  -- the picker was dismissed.
        //   release -- "Let go" while wearing one of another camp's attackers.
        this.sendEmberInvasionCommand = (command, entityId)=>{
            this.emitPlayerEvent({
                playerEventType: "EMBER_INVASION_COMMAND",
                context: {
                    command: command,
                    entityId: entityId
                }
            });
        };
        this.startAttack = (entityId)=>{
            this.send({
                entityId: entityId
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_startAttack);
        };
        // `tileHold`: the swing works a held tile loose, which the server relays without material in hand.
        this.playBuildSwing = (roomId, tileHold = false)=>{
            this.send(tileHold ? {
                roomId: roomId,
                tileHold: tileHold
            } : {
                roomId: roomId
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_playAttackAnimation);
        };
        this.inventoryAction = (entityId, itemId, action, mapRoughCoordinates)=>{
            this.send({
                entityId: entityId,
                itemId: itemId,
                action: action,
                ...mapRoughCoordinates ? {
                    mapRoughCoordinates: mapRoughCoordinates
                } : {}
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_inventoryAction);
        };
        this.activateWorldPoint = (roomFinePoint, options)=>{
            this.send({
                roomFinePoint: roomFinePoint,
                options: options
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_activateWorldPoint);
        };
        this.commitWorldEdits = (roughCoordinate, pending = false, level)=>{
            this.send({
                roughCoordinate: roughCoordinate,
                pending: pending,
                level: level
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_commitWorldEdits);
        };
        // `level`: the storey the walls go on when it is not the player's own (laid atop walls).
        // `swung`: printed at the click, whose swing already played, so the server doesn't swing again as it lands.
        this.commitWorldEditGroup = (roughCoordinates, itemId, level, swung = false)=>{
            if (!roughCoordinates.length) return;
            this.send({
                roughCoordinate: roughCoordinates[0],
                roughCoordinates: roughCoordinates,
                itemId: itemId,
                pending: true,
                level: level,
                swung: swung || undefined
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_commitWorldEdits);
        };
        this.getBuildingTilePreview = (roughCoordinate, pendingCoordinates = [], previewRevision, itemId, level)=>{
            this.send({
                roughCoordinate: roughCoordinate,
                pendingCoordinates: pendingCoordinates,
                previewRevision: previewRevision,
                itemId: itemId,
                level: level
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_getBuildingTilePreview);
        };
        this.shareBuildingPreview = (roomId, itemId, tiles)=>{
            this.send({
                roomId: roomId,
                itemId: itemId,
                tiles: tiles
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_shareBuildingPreview);
        };
        this.requestEntityDetail = (entityIds)=>{
            this.send({
                entityIds: entityIds
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestEntityDetail);
        };
        // Follow-cam: ask the server to sync this entity + its neighbors in full detail every tick
        // (pass null to stop). Drives the picture-in-picture view opened from the ember roster.
        // Ask the server to pull another online player into this player's ember camp. Nothing is checked
        // here: whether the invite is allowed, and where the guest lands, are the server's to decide (see
        // the EMBER_PLAYERS campaign).
        // The SpriteLab room's panel: make, spawn, leave, or just ask for the latest status. The server
        // checks room membership itself (see SpriteLabRoomService.request).
        this.sendSpriteLabRequest = (request)=>{
            this.send(request, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_spriteLabRequest);
        };
        // Also runs from socket teardown, where a renderer (or a test's stand-in) may have no GUI.
        this.updateSpriteLab = (state, message)=>this.clientGameLogic.clientRenderer?.gui?.()?.updateSpriteLab?.(state, message);
        this.inviteEmberPlayer = (entityId, playMode = "pvp")=>{
            this.send({
                entityId: entityId,
                playMode: playMode
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_inviteEmberPlayer);
        };
        // The invited player's answer to an invitation. Only an accepted one moves them, and it is the
        // server that moves them -- see the EMBER_PLAYERS campaign.
        this.setEmberPlayMode = (entityId, playMode)=>{
            this.send({
                entityId: entityId,
                playMode: playMode
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_setEmberPlayMode);
        };
        this.kickEmberPlayer = (entityId)=>{
            this.send({
                entityId: entityId
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_kickEmberPlayer);
        };
        this.answerEmberInvite = (entityId, accepted)=>{
            this.send({
                entityId: entityId,
                accepted: accepted
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_answerEmberInvite);
        };
        this.setFocusEntity = (entityId)=>{
            this.send({
                entityId: entityId
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_setFocusEntity);
        };
        this.requestWorldMap = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestWorldMap);
        };
        this.worldMapClicked = (coordinate)=>{
            this.send({
                coordinate: coordinate
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_worldMapClicked);
        };
        this.requestVisibility = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestVisibility);
        };
        this.itemPickupAction = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestItemPickup);
        };
        this.saveAppearance = (appearance, inventory)=>{
            this.send({
                appearance: appearance,
                inventory: inventory
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_saveAppearance);
        };
        this.finalizeCharacter = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_finalizeCharacter);
        };
        this.requestPlayerLocations = ()=>{
            this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestPlayerLocations);
        };
        this.onDialogClose = ()=>{
            this.emitPlayerEvent({
                playerEventType: "DIALOG_CLOSE",
                context: {}
            });
        };
        this.entityTileStrike = (location)=>{
            const player = this.clientGameLogic.playerEntity;
            if (player) this.clientGameLogic.clientRenderer.map().predictTreeStrike?.(location, player);
            this.send({
                location: location
            }, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entityTileStrikeAt);
        };
        // Shadow performance debugging methods
        this.getShadowPerformanceMetrics = ()=>{
            return this.clientGameLogic.getShadowPerformanceMetrics();
        };
        this.forceShadowTextureUpdate = ()=>{
            this.clientGameLogic.forceShadowTextureUpdate();
        };
        this.clientGameLogic = clientGameLogic;
        this.clientGameLogic.entityManager.registerRemoveListener((entity)=>{
            this.interpolatable.delete(entity.entityId);
            this.renderSmoothing.delete(entity.entityId);
        });
        this.agentController = new (0, $b9d4ad6eac1471db$export$433d8951d222f317)(this);
    }
    static{
        // Keys that mean something to the chat input even though they type no character. Anything
        // else with a multi-character name is a modifier or a function key and never reaches the line.
        this.CHAT_EDIT_KEYS = [
            "Backspace",
            "Delete",
            "Escape",
            "Home",
            "End",
            "ArrowUp",
            "ArrowDown",
            "ArrowLeft",
            "ArrowRight"
        ];
    }
    connect(playerName, accessToken, guest) {
        if (guest) {
            const userAgent = navigator?.userAgent;
            this.handleGuest(userAgent);
        } else {
            // No login screen on this path, so there is no Play button to expand from -- take the
            // next tap instead. handleGuest's intro hangs it off Play/Log in itself.
            (0, $0f29b5a53cc88186$export$48ce62c637877209)();
            this.connectImpl(playerName, accessToken, false);
        }
    }
    /**
     * Headless/testing entry point: drive the REAL client protocol over an injected,
     * WebSocket-shaped transport (e.g. an in-memory loopback) instead of a browser socket.
     * Reuses the exact onmessage handshake/netcode; only socket construction and DOM
     * redirects are bypassed. Not used in the browser.
     */ connectHeadless(ws, auth) {
        this.injectedSocket = ws;
        if (auth.mode === "login") {
            this.loginCredentials = {
                username: auth.username,
                password: auth.password
            };
            this.connectImpl("", undefined, false);
        } else if (auth.mode === "guest") {
            // Mirror handleGuest: the browser's guest flow sends the "guest" payload after
            // the negotiated session greeting (the intro screen supplies the name). Without
            // that callback the only payload was "initializeGuest", which the server does not act
            // on, so a headless guest never actually joined.
            const userAgent = navigator?.userAgent;
            const playerName = auth.playerName;
            this.connectImpl("", undefined, true, ()=>{
                this.send({
                    playerName: playerName,
                    userAgent: userAgent
                }, "guest");
            });
        } else this.connectImpl(auth.playerName, undefined, false);
    }
    connectImpl(playerName, accessToken, guest, onConnect) {
        // What a redial means: the same door, the same credentials. Recorded here rather than
        // threaded through every caller, so the lifecycle and the disconnected panel can both ask
        // for one without knowing how this client got connected in the first place.
        this.redial = ()=>this.connectImpl(playerName, accessToken, guest, onConnect);
        const hostname = document.location.hostname;
        const config = (0, $a8f3c0c196817c22$export$7eca4ea16d4c8343)();
        // Both the dev-vs-production split and the ws:// vs wss:// choice now live in
        // runtime_config, because the shell is served from "localhost" too and a hostname test
        // here cannot tell it apart from a laptop.
        const isLocal = !config.isNative && (hostname === "localhost" || hostname.startsWith("10.0"));
        const ws = this.injectedSocket ? this.injectedSocket : new WebSocket(config.apiHost);
        if (isLocal && !this.injectedSocket) (0, $789f2cfb0ccfe259$export$1e138c080884cecd)(ws);
        const redirectToPortal = ()=>{
            if (accessToken) {
                if (isLocal) window.location.href = "http://localhost:3000/account/login";
                else window.location.href = "https://projectsamsara.com/?guest=true";
            } else {
                if (!isLocal) alert("The server might be down, please try again in a few minutes.");
                window.location.href = "/";
            }
        };
        // Where a lost socket leaves the player. A desktop browser can send them back to the
        // portal, which is a real place with a real login. The shell cannot: its origin IS the app
        // bundle, so "/" reloads the app and an alert() freezes the WebView behind a modal that
        // dismisses into nothing. And on a phone generally, answering "the wifi blinked" by
        // discarding the session and reloading is hostile. Both get a panel with a retry instead.
        const offerRetryRatherThanRedirect = config.isNative || (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)();
        const connectionLost = ()=>{
            // Not lost: ENDED, by the server, for a reason the player has already been given. Its
            // panel is up and there is nothing to retry.
            if (this.sessionEndReason) return;
            // A connection we HAD and lost is a different situation from one we never made, and
            // navigating away is only ever right for the second. The server destroys the player --
            // and with them their ember camp -- the moment a socket closes, so a reload spends a
            // run that a reconnect in place would have let the player start again from the panel.
            // A first connection that never opened is still the portal's business: an expired
            // access token looks exactly like this, and the portal is where a new one comes from.
            if (this.everConnected) {
                (0, $69f7ea6451029ed5$export$5f7f27f369ebe35d)({
                    everConnected: true,
                    onRetry: ()=>{
                        // The lifecycle owns dialling, so that a press and a pending backoff
                        // cannot both fire. It only exists in the browser.
                        if (this.lifecycle) this.lifecycle.retryNow();
                        else this.redialNow();
                    }
                });
                return;
            }
            if (offerRetryRatherThanRedirect) {
                (0, $69f7ea6451029ed5$export$5f7f27f369ebe35d)({
                    everConnected: false,
                    // Dial the same way, with the same credentials. The panel stays up until a
                    // socket actually opens, so a failed retry needs no handling of its own.
                    onRetry: ()=>this.connectImpl(playerName, accessToken, guest, onConnect)
                });
                return;
            }
            redirectToPortal();
        };
        // Only the socket this client is currently holding gets to report anything. A socket
        // replaced because it went silent (see redialNow) is not necessarily dead, and its events
        // arriving late would otherwise tear down the connection that replaced it.
        const isCurrent = ()=>this.ws === ws;
        this.contentParticipant?.dispose();
        this.ws = ws;
        ws.onopen = ()=>{
            if (!isCurrent()) return;
            (0, $5UG8I.logger).info({
                tags: [
                    "websocket",
                    "connection"
                ]
            }, "Connected");
            this.everConnected = true;
            // Covers the first connection as well as a retry: if the panel is not up, this is a
            // no-op.
            (0, $69f7ea6451029ed5$export$b6aef85896caf7b2)();
            this.clientGameLogic.audio.setBonecallerAudioConnected(true);
            this.lifecycle?.noteConnected();
        };
        ws.onerror = (e)=>(0, $5UG8I.logger).error({
                tags: [
                    "websocket",
                    "error"
                ]
            }, JSON.stringify(e));
        ws.onclose = ()=>{
            if (!isCurrent()) return;
            this.updateSpriteLab(null);
            this.spriteLabRoomId = undefined;
            this.spriteLabVisible = false;
            this.contentParticipant?.dispose();
            this.clientGameLogic.audio.setBonecallerAudioConnected(false);
            // Headless/test sockets have no browser portal to redirect to, and no document to put
            // a panel in.
            if (!this.injectedSocket) {
                this.lifecycle?.noteConnectionLost();
                connectionLost();
            }
        };
        // One lifecycle for the whole session, however many sockets it gets through. Not in
        // headless mode: there is no page to hide and no socket to replace.
        if (!this.injectedSocket && !this.lifecycle) {
            this.lifecycle = new (0, $06a32a8a2cf2cac8$export$5be6ec909ad606e6)(this.lifecycleDelegate());
            this.lifecycle.start();
        }
        const userAgent = navigator?.userAgent;
        let negotiating = false;
        const authenticate = ()=>{
            (0, $5UG8I.logger).debug({
                tags: [
                    "websocket",
                    "session"
                ]
            }, "Received start session");
            if (this.loginCredentials) // Headless/test login: authenticate an existing account by username/password.
            this.login(this.loginCredentials.username, this.loginCredentials.password);
            else if (guest) this.send({
                userAgent: userAgent
            }, "initializeGuest");
            else if (accessToken) {
                (0, $5UG8I.logger).debug({
                    tags: [
                        "websocket",
                        "auth"
                    ]
                }, "Sent access token");
                this.send({
                    accessToken: accessToken,
                    userAgent: userAgent
                }, "accessToken");
            } else {
                (0, $5UG8I.logger).debug({
                    tags: [
                        "websocket",
                        "auth"
                    ]
                }, "Sent playername", playerName);
                this.send({
                    playerName: playerName,
                    userAgent: userAgent
                }, "name");
            }
            onConnect?.();
        };
        const participant = new (0, $a652698944c1b693$export$d699fc72b406c0aa)((0, $e5c675b7b9585b42$export$6a6f8fa24d5c0853), (snapshot, signal, inline)=>{
            const stage = this.clientGameLogic.clientRenderer.stageContent;
            if (!stage) return Promise.reject(new Error("Renderer does not support live content"));
            return stage(snapshot, signal, inline);
        }, (reply)=>{
            if (!isCurrent()) return;
            if (reply.kind === "failed") (0, $5UG8I.logger).warn({
                tags: [
                    "content"
                ]
            }, `Could not prepare published content ${reply.revision}: ${reply.reason}`);
            if (reply.kind === "activated") {
                this.resyncAfterGap();
                this.playerPositionError = {
                    x: 0,
                    y: 0
                };
                if (this.clientGameLogic.playerEntity) this.clientGameLogic.playerEntity.pending_inputs = [];
                this.clientGameLogic.clientRenderer.refreshContent?.();
            }
            this.send(reply, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_contentReply);
            if (reply.kind === "failed") {
                // A client that cannot use the current content must reload, not keep playing
                // against an older release or repeatedly retry the same incompatible bundle.
                this.handleSessionEnded("contentRevisionMismatch");
                ws.close();
                return;
            }
            if (reply.kind === "activated" && negotiating) {
                negotiating = false;
                authenticate();
            }
        });
        this.contentParticipant = participant;
        ws.onmessage = (message)=>{
            if (!isCurrent()) return;
            // Anything at all arriving is the only proof this socket is alive -- a resumed WebView
            // holds one that reports OPEN forever and delivers nothing.
            this.lifecycle?.noteTraffic();
            const parsedMessage = JSON.parse(message.data);
            const { payloadType: payloadType, payload: payload } = parsedMessage;
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_contentCommand) {
                if (!payload || typeof payload.id !== "string" || typeof payload.revision !== "string") return;
                if (payload.kind === "prepare") participant.prepare(payload, payload.manifest, payload.catalog, payload.files);
                else if (payload.kind === "activate") participant.activate(payload);
                else if (payload.kind === "abort") participant.abort(payload);
                return;
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_worldState && parsedMessage.contentRevision && parsedMessage.contentRevision !== (0, $e5c675b7b9585b42$export$43829b1119ccb642)) return;
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_startSession) {
                try {
                    (0, $e5c675b7b9585b42$export$778b0dfe23702ce7)(payload?.contentRevision);
                } catch (error) {
                    if (payload?.contentProtocol === 1 && this.clientGameLogic.clientRenderer.stageContent) {
                        negotiating = true;
                        this.send({}, (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_contentRequest);
                        return;
                    }
                    (0, $5UG8I.logger).error({
                        tags: [
                            "websocket",
                            "content"
                        ]
                    }, String(error));
                    this.handleSessionEnded("contentRevisionMismatch");
                    ws.close();
                    return;
                }
                authenticate();
                return;
            }
            // The server is ending this session on purpose, and said so before closing. The close
            // that follows must NOT be answered with a redial: it is not a dropped connection, and
            // dialling back in would take the account off whoever claimed it.
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sessionEnded) {
                participant.dispose();
                this.handleSessionEnded(payload?.reason);
                return;
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_setEntityId) {
                (0, $5UG8I.logger).debug({
                    tags: [
                        "websocket",
                        "entity"
                    ]
                }, "Received entityId; guest:", guest === true);
                const { entityId: entityId, chapterAnnouncement: chapterAnnouncement } = payload;
                this.clientGameLogic.initializePlayer(entityId, this, guest === true);
                if (chapterAnnouncement) this.clientGameLogic.clientRenderer.gui().showTutorialPrompt(chapterAnnouncement);
                if (guest) this.clientGameLogic.clientRenderer.gui().getIntro().loginSuccess();
                return;
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updatePlayerEntityId) {
                (0, $5UG8I.logger).debug({
                    tags: [
                        "websocket",
                        "entity"
                    ]
                }, "Received update entityId");
                const { entityId: entityId } = payload;
                this.clientGameLogic.updatePlayerEntityId(entityId);
                return;
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_destroyEntityId) {
                const { entityId: entityId, roomId: roomId } = payload;
                if (this.clientGameLogic.playerEntity?.roomId === roomId) this.clientGameLogic.scheduleForDestruction(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_ping) {
                const { entityId: entityId, creationTs: creationTs } = payload;
                this.send({
                    creationTs: creationTs,
                    entityId: entityId
                }, "pong");
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendPleaseWait) this.clientGameLogic.pleaseWait();
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_fragmentAnimation) {
                const { spriteId: spriteId, location: location } = payload;
                this.clientGameLogic.clientRenderer.entity().fragment(spriteId, location);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_struckEntityId) {
                const { entityId: entityId, strikerEntityId: strikerEntityId } = payload;
                this.clientGameLogic.doStruck(entityId, strikerEntityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entityTileEffect) {
                const { effect: effect } = payload;
                this.clientGameLogic.tileEffect(effect);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_detonate) {
                const { entityId: entityId } = payload;
                this.clientGameLogic.detonate(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_attack) {
                const { entityId: entityId } = payload;
                // Add callback for weapon attack effects
                this.clientGameLogic.attack(entityId, ()=>{
                    // Callback for attack completion - can be used for weapon effects
                    (0, $5UG8I.logger).debug({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Server-triggered attack completed for entity ${entityId}`);
                });
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_playAttackAnimation) {
                // Cosmetic swing (e.g. another player placing a build tile). Play ONLY the sprite
                // animation -- not clientGameLogic.attack, which would also fire startAttack + audio.
                const { entityId: entityId } = payload;
                const entity = this.clientGameLogic.getAnimationEntity(entityId);
                if (entity) this.clientGameLogic.clientRenderer.entity().attack(entity);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateActivation) {
                const { entityId: entityId, active: active } = payload;
                this.clientGameLogic.updateActivation(entityId, active);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_orientation) {
                const { orientation: orientation } = payload;
                this.clientGameLogic.orientation(orientation);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_killed) {
                const { entityId: entityId } = payload;
                this.clientGameLogic.killed(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_respawned) {
                const { entityId: entityId } = payload;
                this.clientGameLogic.respawned(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendTeleported) {
                const { entityId: entityId } = payload;
                this.clientGameLogic.teleported(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entityEmp) {
                const { entityId: entityId, range: range } = payload;
                this.clientGameLogic.emp(entityId, range);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entitySparkle) {
                const { entityId: entityId } = payload;
                this.clientGameLogic.sparkle(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_fadeInOut) {
                const { direction: direction, transition: transition } = payload;
                // this is a hack; we do this so that the
                // map renderer is in charge of the "in" fade in after it does all its work
                if (direction === "out") // `transition`, when there is one, turns this into a scene change rather than a
                // snap to black: see Protocol.TransitFade. The "in" stays the map renderer's.
                this.clientGameLogic.fadeInOut(direction, undefined, transition);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_worldState) {
                const message = payload;
                // Carry the server's own send timestamp through to interpolation, and update the
                // clock estimate from it HERE rather than in processServerMessages: the offset is
                // only meaningful against the moment the frame landed, not the moment the next
                // frame got round to draining the queue.
                message.serverTs = parsedMessage.recv_ts;
                this.observeServerClock(parsedMessage.recv_ts);
                this.enqueueWorldState(message);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entityDisconnected) {
                const { entityId: entityId } = payload;
                (0, $5UG8I.logger).info({
                    tags: [
                        "websocket",
                        "disconnect"
                    ]
                }, "disconnect", entityId);
                this.clientGameLogic.scheduleForDestruction(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_screenMessage) {
                const { message: message } = payload;
                if (message) this.clientGameLogic.clientRenderer.gui().addScreenMessage(message);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_chatMessage) {
                const { message: message, originEntityName: originEntityName, originEntityId: originEntityId, hold: hold, holdId: holdId, autoAdvance: autoAdvance } = payload;
                this.clientGameLogic.handleChat(message, originEntityId, originEntityName, hold, holdId, autoAdvance);
                this.agentController?.noteChat(originEntityName || originEntityId || "?", message);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_roomAmbience) {
                const { ambience: ambience } = payload;
                if (ambience) this.clientGameLogic.setRoomAmbience(ambience);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_factionTracking) {
                const { config: config } = payload;
                if (config) this.clientGameLogic.setFactionTracking(config);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_redrawClient) // Incremental repaint of just the delta-changed cells (falls back to a full rerender
            // internally if a tilemap-layer cell changed). Replaces the old full map().rerender().
            this.clientGameLogic.clientRenderer.map().onRedraw();
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_hideRoomName) {
                const { hidden: hidden, roomName: roomName } = payload;
                this.clientGameLogic.hideRoomName(hidden);
                if (!hidden && roomName) this.clientGameLogic.updateLocation(roomName);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendUpdateLocation) {
                const { location: location, roomId: roomId } = payload;
                this.clientGameLogic.updateLocation(location, roomId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_createLocalEntity) {
                const { entity: entity } = payload;
                this.clientGameLogic.createLocalEntity(entity);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_destroyLocalEntity) {
                const { flags: flags } = payload;
                this.clientGameLogic.destroyLocalEntity(flags);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_soundEffect) {
                const { effect: effect, loop: loop, target: target, source: source } = payload;
                this.clientGameLogic.playSoundEffect(effect, loop, target, source);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendAnimateLocalEntityCollection) {
                const { entityId: entityId, target: target, position: position } = payload;
                this.clientGameLogic.animateLocalEntityCollection(entityId, target, position);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_animateAbility) {
                const { abilityType: abilityType, duration: duration } = payload;
                this.clientGameLogic.animateAbility(abilityType, duration);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_upgradeGuest) this.clientGameLogic.upgradedAccount();
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_dayPhase) {
                const { dayPhase: dayPhase, dayPct: dayPct, roomId: roomId } = payload;
                const scene = this.clientGameLogic.scene;
                if (!scene.id || scene.contains(roomId)) {
                    this.clientGameLogic.updateDayPhase(dayPhase);
                    this.clientGameLogic.clientRenderer.gui().updateDayPct(dayPct);
                }
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_requestEntityDetail) {
                const { messages: messages } = payload;
                if (messages) {
                    const now = Date.now();
                    messages.forEach((message)=>{
                        const entity = this.clientGameLogic.getEntity(message.entityId);
                        if (entity) {
                            this.updateEntityFromMessage(message, entity, now);
                            this.clientGameLogic.clearIncompleteEntities([
                                entity.entityId
                            ]);
                        }
                    });
                }
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_login) {
                const { entityId: entityId, chapterAnnouncement: chapterAnnouncement } = payload;
                if (entityId) {
                    this.clientGameLogic.initializePlayer(entityId, this, false);
                    if (chapterAnnouncement) this.clientGameLogic.clientRenderer.gui().showTutorialPrompt(chapterAnnouncement);
                    this.clientGameLogic.clientRenderer.gui().getIntro().loginSuccess();
                    if (!chapterAnnouncement) this.clientGameLogic.clientRenderer.gui().addScreenMessage({
                        target: "important",
                        text: "Welcome back!",
                        delay: 1000
                    });
                } else {
                    // The intro shows the failure under the password field and keeps what was
                    // typed; only fall back to the screen-wide banner if it could not.
                    const shownInline = this.clientGameLogic.clientRenderer.gui().getIntro().loginFailed();
                    if (!shownInline) this.clientGameLogic.clientRenderer.gui().addScreenMessage({
                        target: "important",
                        text: "Invalid player name or password."
                    });
                }
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_mapDelta) {
                const deltas = payload.delta;
                this.clientGameLogic.clientRenderer.map().queueMapDelta(deltas);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateSquadState) {
                const { squadState: squadState } = payload;
                this.clientGameLogic.clientRenderer.gui().updateSquadState(squadState);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateEmberAnxiety) this.clientGameLogic.clientRenderer.gui().updateEmberAnxiety(payload.anxiety || null, payload.roomId);
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateEmberRoster) {
                const { roster: roster } = payload;
                this.clientGameLogic.clientRenderer.gui().updateEmberRoster(roster || []);
                this.clientGameLogic.setEmberRoster(roster || []);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateEmberMinimap) {
                const { minimap: minimap } = payload;
                this.clientGameLogic.clientRenderer.gui().updateEmberMinimap(minimap || null);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_spriteLabState) {
                const state = payload.state;
                if (!state || state.roomId === this.clientGameLogic.playerEntity?.roomId) {
                    this.spriteLabVisible = !!state;
                    this.updateSpriteLab(state, payload.message);
                }
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateEmberPlayers) {
                const { players: players } = payload;
                this.clientGameLogic.clientRenderer.gui().updateEmberPlayers(players || []);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateEmberInvite) {
                const { invite: invite } = payload;
                this.clientGameLogic.clientRenderer.gui().updateEmberInvite(invite || null);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateEntityInteractions) {
                const { entityId: entityId, interactions: interactions, colliding: colliding } = payload;
                this.clientGameLogic.clientRenderer.entity().updateEntityInteractions(entityId, interactions, colliding);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_openCommandWheel) {
                const { entityId: entityId, role: role, commands: commands } = payload;
                this.clientGameLogic.clientRenderer.gui().showCommandWheel({
                    targetEntityId: entityId,
                    role: role,
                    commands: commands
                });
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_openRolePicker) {
                // `currentRole` is present only for a "Change Role" order on an already-hired member,
                // and narrows the picker to the job it is NOT doing. `weapon` is what it would fight
                // with, for the Defender card -- sent by the server because this client may not hold
                // the member's pack at all (only NPCs within detail range carry one here).
                const { entityId: entityId, currentRole: currentRole, weapon: weapon, availableRoles: availableRoles } = payload;
                this.clientGameLogic.clientRenderer.gui().showRolePicker(entityId, currentRole, {
                    weapon: weapon,
                    availableRoles: availableRoles
                });
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_openNamePrompt) {
                const { entityId: entityId, name: name } = payload;
                this.clientGameLogic.clientRenderer.gui().showNamePrompt(entityId, name);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_showRunSummary) {
                const { summary: summary } = payload;
                this.clientGameLogic.clientRenderer.gui().showRunSummary(summary);
            }
            // Which camps a fallen player could rise in. An interval FEED (~2s) rather than a reply
            // to a press, so the scorecard's "Resurrect as Undead!" button lights up by itself when
            // one opens, and an open picker gains and loses cards as it is read. An empty list is a
            // real answer ("no camp is open to the dead"); null forgets the offer.
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateInvasionOffer) {
                const { candidates: candidates } = payload;
                this.clientGameLogic.clientRenderer.gui().updateInvasionOffer(candidates || null);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_showTutorialPrompt) {
                const { prompt: prompt } = payload;
                this.clientGameLogic.clientRenderer.gui().showTutorialPrompt(prompt || null);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateEntityPointerIcon) {
                const { entityId: entityId, show: show, angle: angle } = payload;
                const entity = this.clientGameLogic.entityManager.get(entityId);
                if (entity) this.clientGameLogic.clientRenderer.entity().updateEntityPointerIcon(entity, show, angle);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_buildCharacter) {
                const { entityId: entityId } = payload;
                this.clientGameLogic.clientRenderer.gui().buildCharacter(entityId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_itemPickedUp) {
                const { entityId: entityId, itemTypeMeta: itemTypeMeta, quantity: quantity } = payload;
                const entity = this.clientGameLogic.entityManager.get(entityId);
                if (entity) this.clientGameLogic.itemPickup(entity, itemTypeMeta, quantity);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_showTutorial) {
                // A null tutorialType is the server taking the ember clues back down (see
                // client_proxy.showTutorial); timeoutMs is how long a raised clue holds.
                const { tutorialType: tutorialType, timeoutMs: timeoutMs } = payload;
                this.clientGameLogic.clientRenderer.gui().showTutorial(tutorialType || null, timeoutMs);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_builderAction) {
                const { active: active } = payload;
                this.clientGameLogic.playerController.builderActivation(active);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendWorldMap) {
                const { map: map } = payload;
                this.clientGameLogic.clientRenderer.gui().showWorldMap(map);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_removeLocationIcon) this.clientGameLogic.clientRenderer.map().removeLocationIcon(payload.iconId);
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_addLocationIcon) this.clientGameLogic.clientRenderer.entity().updateLocationIcons(payload.icon);
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updatePlayerBiomeColorMap) {
                const points = payload.meta?.points || [];
                const icons = payload.meta?.icons || [];
                const clear = payload?.meta?.clear === true;
                if (clear) {
                    const biomeColorMap = this.clientGameLogic.tilemapMetaProvider?.biomeColorMap;
                    if (biomeColorMap) {
                        for(let x = 0; x < biomeColorMap.length; x++)for(let y = 0; y < biomeColorMap[0].length; y++)biomeColorMap[x][y] = 0;
                        this.clientGameLogic.clientRenderer.map().updateMinimap(this.clientGameLogic.tilemapMetaProvider);
                    }
                }
                points.forEach((point)=>{
                    if (this.clientGameLogic.tilemapMetaProvider && this.clientGameLogic.tilemapMetaProvider.minimapConfig?.biomeBased && this.clientGameLogic.tilemapMetaProvider.biomeColorMap) this.clientGameLogic.tilemapMetaProvider.biomeColorMap[point.biomeCoordinate.x][point.biomeCoordinate.y] = point.color;
                    this.clientGameLogic.clientRenderer.map().updateBiomeColorMap(point.biomeCoordinate, point.color);
                });
                icons.forEach((icon)=>{
                    if (this.clientGameLogic.tilemapMetaProvider) {
                        if (!this.clientGameLogic.tilemapMetaProvider.locationIcons.find((next)=>next.x === icon.x && next.y === icon.y)) this.clientGameLogic.tilemapMetaProvider.locationIcons.push(icon);
                    }
                    this.clientGameLogic.clientRenderer.entity().updateLocationIcons(icon);
                });
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_pulseInventoryItem) {
                const { itemId: itemId } = payload;
                this.clientGameLogic.clientRenderer.gui().pulseInventoryItem(itemId);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_entityFeedback) {
                const { entityId: entityId, image: image, label: label, params: params } = payload;
                const entity = this.clientGameLogic.getAnimationEntity(entityId);
                if (entity) this.clientGameLogic.clientRenderer.entity().feedback(entity, image, label, params);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendVisibility) {
                const { visibility: visibility } = payload;
                this.clientGameLogic.updateVisibility(visibility);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_locationIconEffect) {
                const { locationId: locationId, expires: expires } = payload;
                this.clientGameLogic.clientRenderer.entity().pulseLocation(locationId, expires);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_updateAudio) {
                const { volume: volume } = payload;
                this.clientGameLogic.audio.setVolume(volume);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sendBuildingTilePreview) {
                if (payload.committed !== undefined) this.clientGameLogic.playerController.buildingCommitResult(payload.roughCoordinate, payload.committed);
                else this.clientGameLogic.playerController.updateTerrainPointer(payload.deltas, payload.roughCoordinate, payload.tooFar, payload.illegal, payload.previewRevision, payload.itemId, Number.isInteger(payload.level) ? payload.level : undefined);
            }
            if (payloadType === (0, $04dfe581ed7487ef$export$377bbedb5576dfa8).type_sharedBuildingPreview) {
                if (payload.roomId === this.clientGameLogic.playerEntity?.roomId) this.clientGameLogic.playerController.updateSharedBuildingPreview(payload.entityId, payload.tiles);
            }
        };
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
parcelRequire("1avo5");
var $P8XPi = parcelRequire("P8XPi");
var $1avo5 = parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
/**
 * The one pixi Application, held apart from the renderer that builds it.
 *
 * `PixiJsClientRenderer` owns the Application, but several low-level modules need nothing from
 * that class except `app.renderer` -- somewhere to bake a texture. Reaching for the class to get
 * it drags its entire import graph along (client_game_logic, audio, the GUI, every effect), which
 * is why `lpc_composite_generator`'s own test has to `jest.mock` the module before it can load.
 *
 * Keeping the handle here instead means the composite generator depends on a two-function module,
 * so it can be driven from anywhere that has a pixi Application -- a test, or the sprite lab --
 * without standing up the game.
 */ let $065c5647ab3ff4dc$var$rendererApp;
let $065c5647ab3ff4dc$var$rendererGeneration = 0;
const $065c5647ab3ff4dc$export$a54b2446196f1812 = ()=>$065c5647ab3ff4dc$var$rendererGeneration;
const $065c5647ab3ff4dc$export$6a54bfeffaafa5f7 = (app)=>{
    if ($065c5647ab3ff4dc$var$rendererApp !== app) $065c5647ab3ff4dc$var$rendererGeneration++;
    $065c5647ab3ff4dc$var$rendererApp = app;
};
const $065c5647ab3ff4dc$export$90e89a86e46f5ae3 = ()=>$065c5647ab3ff4dc$var$rendererApp;
const $065c5647ab3ff4dc$export$56359d4511c7424 = ()=>{
    if (!$065c5647ab3ff4dc$var$rendererApp) throw new Error("No pixi Application registered -- call setRendererApp() before rendering");
    return $065c5647ab3ff4dc$var$rendererApp;
};


class $ff77f0e96218c7e7$export$6bfce3b6985f9a3d extends (0, $gwPoJ.Graphics) {
    /**
     * `blend` is how the softened picture lands on what is under it (MULTIPLY for shade: the floor's
     * own colours times the shade's), kept by the live blur and by the bake. `resolution` is the bake's
     * (and the live blur's) pixels per world pixel: soft art loses nothing at half, and costs a quarter.
     */ constructor(strength, quality, blend = (0, $P8XPi.BLEND_MODES).NORMAL, resolution = 1){
        super(), this.blend = blend, this.stamps = [];
        this.blur = new (0, $1avo5.filters).BlurFilter(strength, quality, resolution);
        // Only what lands on the world blends: the drawing itself renders plainly into the blur's buffer (a
        // MULTIPLY into that empty buffer drew nothing, so a re-drawn shadow vanished until its bake).
        this.blur.blendMode = blend;
    }
    /**
     * Art drawn and baked along with the drawing, through `matrix` in local space: a shadow cast by a
     * picture rather than a shape. It shows live, under the same blur, until the bake lands. The
     * texture stays the caller's.
     */ stamp(texture, matrix, tint = 0xffffff) {
        const sprite = new (0, $7Bs2Z.Sprite)(texture);
        sprite.transform.setFromMatrix(matrix);
        sprite.tint = tint;
        this.addChild(sprite);
        this.stamps.push({
            sprite: sprite,
            matrix: matrix,
            tint: tint
        });
    }
    /**
     * How the picture lands on what is under it (by default the `blend` it was made with). BakedGroups
     * lands its groups NORMAL into one buffer while it fades them, and multiplies that buffer once.
     */ setLanding(blend = this.blend) {
        this.blur.blendMode = blend;
        if (this.baked) this.baked.blendMode = blend;
    }
    /**
     * Keep the stamps inside these rectangles (local space), applied when baking: a picture cannot be cut
     * like a polygon, and a live mask would cost a stencil pass every frame.
     */ maskStamps(area) {
        this.stampArea = area;
    }
    /** Call after drawing. `ready` runs once the bake has landed (at once when there is nothing to bake, or no renderer). */ soften(ready) {
        this.discardBake();
        if (!this.geometry.graphicsData.length && !this.stamps.length) {
            ready?.();
            return;
        }
        this.filters = [
            this.blur
        ];
        const renderer = (0, $065c5647ab3ff4dc$export$90e89a86e46f5ae3)()?.renderer;
        if (!renderer || typeof requestAnimationFrame === "undefined") {
            ready?.();
            return;
        }
        this.pendingBake = requestAnimationFrame(()=>{
            this.pendingBake = undefined;
            if (this.destroyed) return;
            this.bake(renderer);
            ready?.();
        });
    }
    clear() {
        this.discardBake();
        this.stamps.forEach(({ sprite: sprite })=>sprite.destroy());
        this.stamps = [];
        return super.clear();
    }
    destroy(options) {
        this.discardBake();
        this.blur.destroy();
        super.destroy(options);
    }
    _render(renderer) {
        // Once baked, only the softened child is drawn.
        if (!this.baked) super._render(renderer);
    }
    bake(renderer) {
        // Nothing left to soften (cleared since): no picture. A bake of nothing is still a texture the blur's
        // padding wide at the origin, and it stretched its storey's bounds from the map's corner to its art.
        if (!this.geometry.graphicsData.length && !this.stamps.length) return;
        // generateTexture keeps the world transform of a parented object, which would bake the camera in.
        let brush = new (0, $gwPoJ.Graphics)(this.geometry);
        if (this.stamps.length && (!this.stampArea || this.stampArea.length)) {
            const drawing = brush;
            brush = new (0, $8t5Gy.Container)();
            brush.addChild(drawing);
            const stamps = new (0, $8t5Gy.Container)();
            this.stamps.forEach(({ sprite: sprite, matrix: matrix, tint: tint })=>{
                const copy = new (0, $7Bs2Z.Sprite)(sprite.texture);
                copy.transform.setFromMatrix(matrix);
                copy.tint = tint;
                stamps.addChild(copy);
            });
            if (this.stampArea) {
                const mask = new (0, $gwPoJ.Graphics)().beginFill(0xffffff, 1);
                this.stampArea.forEach(({ x: x, y: y, width: width, height: height })=>mask.drawRect(x, y, width, height));
                mask.endFill();
                stamps.addChild(mask);
                stamps.mask = mask;
            }
            brush.addChild(stamps);
        }
        // The picture itself is baked plainly; only the baked sprite lands with `blend` (a MULTIPLY into
        // an empty texture would bake nothing but black).
        this.blur.blendMode = (0, $P8XPi.BLEND_MODES).NORMAL;
        brush.filters = [
            this.blur
        ];
        const region = brush.getLocalBounds().clone().pad(this.blur.padding);
        region.ceil();
        const texture = renderer.generateTexture(brush, {
            region: region,
            resolution: this.blur.resolution
        });
        this.blur.blendMode = this.blend;
        brush.filters = null;
        brush.destroy({
            children: true
        });
        this.filters = null;
        this.stamps.forEach(({ sprite: sprite })=>{
            sprite.visible = false;
        });
        this.baked = new (0, $7Bs2Z.Sprite)(texture);
        this.baked.blendMode = this.blend;
        this.baked.position.set(region.x, region.y);
        this.addChild(this.baked);
    }
    discardBake() {
        if (this.pendingBake !== undefined) {
            cancelAnimationFrame(this.pendingBake);
            this.pendingBake = undefined;
        }
        this.filters = null;
        this.stamps.forEach(({ sprite: sprite })=>{
            sprite.visible = true;
        });
        if (!this.baked) return;
        this.baked.destroy({
            texture: true,
            baseTexture: true
        });
        this.baked = undefined;
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");

var $5UG8I = parcelRequire("5UG8I");

// Alpha at or below this counts as empty. Matches the threshold the death-crumble effect uses for
// the same question ("where does the art actually stop").
const $35a6592763403c18$var$CONTENT_ALPHA_THRESHOLD = 8;
// Keyed by the caller's texture id. A composite tile texture is built once and shared by every
// sprite drawn from it, so its content bounds are worth computing once for the whole session --
// the readback is a GPU stall, and a null result (no renderer, e.g. in tests) is cached too so a
// failing lookup isn't retried on every sprite.
// Logical IDs can survive an art change. Texture identity prevents bounds for an older
// generation leaking into its replacement and allows retired textures to be collected.
const $35a6592763403c18$var$cache = new WeakMap();
const $35a6592763403c18$var$trimmedTextures = new WeakMap();
// Bounds measured where the pixels were made, for any caller: art rasterised on the CPU (an Ember frame is drawn in
// JS and uploaded from a buffer) never needs reading back. That readback was the castle's hitch: the occlusion
// outline met each new Ember pose that way every 300ms while walking, and the read waited 20-47ms on the GPU queue.
const $35a6592763403c18$var$known = new WeakMap();
const $35a6592763403c18$export$742f20ba795461b9 = (texture, bounds)=>{
    $35a6592763403c18$var$known.set(texture, bounds);
};
const $35a6592763403c18$export$89d9314d15db4cff = (texture, data, width, height)=>{
    $35a6592763403c18$var$known.set(texture, $35a6592763403c18$var$alphaBounds(data, width, height, texture));
};
const $35a6592763403c18$export$18f5cc6e613e3ff2 = (texture)=>{
    const cached = $35a6592763403c18$var$trimmedTextures.get(texture);
    if (cached) return cached;
    // Do not cache a missing renderer: a sprite may be requested before initialization.
    try {
        if (!(0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer?.plugins?.extract || !texture.valid) return texture;
    } catch  {
        return texture;
    }
    const content = $35a6592763403c18$var$known.has(texture) ? $35a6592763403c18$var$known.get(texture) : $35a6592763403c18$var$measure(texture);
    if (!content) {
        $35a6592763403c18$var$trimmedTextures.set(texture, texture);
        return texture;
    }
    const area = texture.trim ?? new (0, $6qzqq.Rectangle)(0, 0, texture.orig.width, texture.orig.height);
    // Map the crop through the texture UVs, handling trimmed and rotated atlases
    // without copying pixels or uploading a second image to the GPU.
    const uv = texture._uvs;
    const corners = [
        [
            content.x,
            content.y
        ],
        [
            content.right,
            content.y
        ],
        [
            content.x,
            content.bottom
        ],
        [
            content.right,
            content.bottom
        ]
    ].map(([x, y])=>{
        const u = (x - area.x) / area.width;
        const v = (y - area.y) / area.height;
        return {
            x: (uv.x0 + (uv.x1 - uv.x0) * u + (uv.x3 - uv.x0) * v) * texture.baseTexture.width,
            y: (uv.y0 + (uv.y1 - uv.y0) * u + (uv.y3 - uv.y0) * v) * texture.baseTexture.height
        };
    });
    const minX = Math.min(...corners.map((p)=>p.x));
    const minY = Math.min(...corners.map((p)=>p.y));
    const width = Math.max(...corners.map((p)=>p.x)) - minX;
    const height = Math.max(...corners.map((p)=>p.y)) - minY;
    const trimmed = new (0, $klOfb.Texture)(texture.baseTexture, new (0, $6qzqq.Rectangle)(minX, minY, width, height), new (0, $6qzqq.Rectangle)(0, 0, content.width, content.height), undefined, texture.rotate);
    $35a6592763403c18$var$trimmedTextures.set(texture, trimmed);
    return trimmed;
};
const $35a6592763403c18$export$46429b068ef0a2d5 = (texture, cacheKey)=>{
    if ($35a6592763403c18$var$known.has(texture)) return $35a6592763403c18$var$known.get(texture);
    let entries = $35a6592763403c18$var$cache.get(texture);
    if (!entries) {
        entries = new Map();
        $35a6592763403c18$var$cache.set(texture, entries);
    }
    if (entries.has(cacheKey)) return entries.get(cacheKey);
    const bounds = $35a6592763403c18$var$measure(texture);
    entries.set(cacheKey, bounds);
    return bounds;
};
// Textures waiting for an idle readback (textureContentBoundsWhenIdle), oldest first.
const $35a6592763403c18$var$idleQueue = [];
const $35a6592763403c18$var$queued = new WeakMap();
let $35a6592763403c18$var$idleScheduled = false;
// Readbacks the GPU has yet to finish (WebGL2): the art copied into a pack buffer, read once it passes `fence`.
const $35a6592763403c18$var$inFlight = [];
/** Readbacks started per pass: each is a small draw and copy, with nothing to wait for. */ const $35a6592763403c18$var$READBACKS_PER_PASS = 8;
/** How often finished readbacks are collected (ms). */ const $35a6592763403c18$var$READBACK_POLL_MS = 16;
let $35a6592763403c18$var$pollScheduled = false;
const $35a6592763403c18$export$437cb752f6483367 = (texture, cacheKey)=>{
    if ($35a6592763403c18$var$known.has(texture)) return $35a6592763403c18$var$known.get(texture);
    const entries = $35a6592763403c18$var$cache.get(texture);
    if (entries?.has(cacheKey)) return entries.get(cacheKey);
    if (!texture?.valid) return null;
    // Read from the image it was loaded from, on the CPU, at once: nothing to wait for and no GPU queue to drain.
    const fromImage = $35a6592763403c18$var$imageContentBounds(texture);
    if (fromImage !== undefined) {
        let entries = $35a6592763403c18$var$cache.get(texture);
        if (!entries) $35a6592763403c18$var$cache.set(texture, entries = new Map());
        entries.set(cacheKey, fromImage);
        return fromImage;
    }
    // Nothing can read it (no renderer yet, or none at all in tests): there is nothing to wait for.
    if (!$35a6592763403c18$var$canReadPixels()) return null;
    let keys = $35a6592763403c18$var$queued.get(texture);
    if (!keys) $35a6592763403c18$var$queued.set(texture, keys = new Set());
    if (!keys.has(cacheKey)) {
        keys.add(cacheKey);
        $35a6592763403c18$var$idleQueue.push({
            texture: texture,
            cacheKey: cacheKey
        });
        $35a6592763403c18$var$scheduleIdleReadback();
    }
    return undefined;
};
const $35a6592763403c18$export$88af26d0ff4d35cd = ()=>{
    $35a6592763403c18$var$collectReadbacks(true);
    while($35a6592763403c18$var$idleQueue.length){
        const next = $35a6592763403c18$var$idleQueue.shift();
        $35a6592763403c18$var$queued.get(next.texture)?.delete(next.cacheKey);
        if (next.texture.baseTexture && next.texture.valid) $35a6592763403c18$export$46429b068ef0a2d5(next.texture, next.cacheKey);
    }
};
const $35a6592763403c18$var$canReadPixels = ()=>{
    try {
        return !!(0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer?.plugins?.extract;
    } catch  {
        return false;
    }
};
const $35a6592763403c18$var$scheduleIdleReadback = ()=>{
    if ($35a6592763403c18$var$idleScheduled) return;
    $35a6592763403c18$var$idleScheduled = true;
    const run = (deadline)=>{
        $35a6592763403c18$var$idleScheduled = false;
        let started = 0;
        do {
            const next = $35a6592763403c18$var$idleQueue.shift();
            if (!next) break;
            if (!next.texture.baseTexture || !next.texture.valid) {
                $35a6592763403c18$var$queued.get(next.texture)?.delete(next.cacheKey);
                continue;
            }
            if ($35a6592763403c18$var$startReadback(next.texture, next.cacheKey)) {
                started++;
                continue;
            }
            // No WebGL2: one blocking readback per idle period unless there is clearly room for more.
            $35a6592763403c18$var$queued.get(next.texture)?.delete(next.cacheKey);
            $35a6592763403c18$export$46429b068ef0a2d5(next.texture, next.cacheKey);
            if (!(deadline && deadline.timeRemaining() > 12)) break;
        }while ($35a6592763403c18$var$idleQueue.length && started < $35a6592763403c18$var$READBACKS_PER_PASS);
        if ($35a6592763403c18$var$inFlight.length) $35a6592763403c18$var$schedulePoll();
        if ($35a6592763403c18$var$idleQueue.length) $35a6592763403c18$var$scheduleIdleReadback();
    };
    if (typeof requestIdleCallback === "function") requestIdleCallback(run, {
        timeout: 1000
    });
    else setTimeout(run, 0);
};
const $35a6592763403c18$var$webgl2 = ()=>{
    let renderer;
    try {
        renderer = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer;
    } catch  {
        return undefined;
    }
    const gl = renderer?.gl;
    if (!gl || renderer.context?.webGLVersion !== 2 || typeof gl.fenceSync !== "function" || gl.isContextLost()) return undefined;
    return {
        renderer: renderer,
        gl: gl
    };
};
/**
 * Copies the texture's pixels into a pack buffer without waiting for them: a plain readPixels
 * returns only once the GPU has worked through every command queued before it. Behind a tall
 * building that queue was most of a second deep (two seconds on a player's machine), and the frame
 * that asked for the pixels -- the one climbing a ladder -- stalled for all of it.
 */ const $35a6592763403c18$var$startReadback = (texture, cacheKey)=>{
    const context = $35a6592763403c18$var$webgl2();
    if (!context) return false;
    $35a6592763403c18$export$64a81b232683d404.gpu++;
    const { renderer: renderer, gl: gl } = context;
    const probe = new (0, $7Bs2Z.Sprite)(texture);
    let target;
    try {
        target = renderer.generateTexture(probe, {
            resolution: 1
        });
        const width = Math.floor(target.frame.width + 1e-4), height = Math.floor(target.frame.height + 1e-4);
        if (!width || !height) return false;
        renderer.renderTexture.bind(target);
        const buffer = gl.createBuffer();
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buffer);
        gl.bufferData(gl.PIXEL_PACK_BUFFER, width * height * 4, gl.STREAM_READ);
        gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, 0);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
        renderer.renderTexture.bind(null);
        const fence = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
        if (!buffer || !fence) {
            gl.deleteBuffer(buffer);
            return false;
        }
        gl.flush();
        $35a6592763403c18$var$inFlight.push({
            texture: texture,
            cacheKey: cacheKey,
            buffer: buffer,
            fence: fence,
            width: width,
            height: height
        });
        return true;
    } catch (e) {
        (0, $5UG8I.logger).error({
            tags: [
                "sprite",
                "error"
            ]
        }, e);
        return false;
    } finally{
        probe.destroy();
        // Queued after the copy: the GPU reads the art before it lets the target go.
        target?.destroy(true);
    }
};
/** Reads the readbacks the GPU has finished; with `all`, every one (a caller about to stall anyway). */ const $35a6592763403c18$var$collectReadbacks = (all = false)=>{
    if (!$35a6592763403c18$var$inFlight.length) return;
    const context = $35a6592763403c18$var$webgl2();
    for(let i = 0; i < $35a6592763403c18$var$inFlight.length;){
        const readback = $35a6592763403c18$var$inFlight[i];
        const { texture: texture, cacheKey: cacheKey, buffer: buffer, fence: fence, width: width, height: height } = readback;
        if (!context) {
            // Lost with its context: asked for again, it is queued again.
            $35a6592763403c18$var$inFlight.splice(i, 1);
            $35a6592763403c18$var$queued.get(texture)?.delete(cacheKey);
            continue;
        }
        const { gl: gl } = context;
        if (!all && gl.getSyncParameter(fence, gl.SYNC_STATUS) !== gl.SIGNALED) {
            i++;
            continue;
        }
        const pixels = new Uint8Array(width * height * 4);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buffer);
        gl.getBufferSubData(gl.PIXEL_PACK_BUFFER, 0, pixels);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
        gl.deleteBuffer(buffer);
        gl.deleteSync(fence);
        $35a6592763403c18$var$inFlight.splice(i, 1);
        $35a6592763403c18$var$queued.get(texture)?.delete(cacheKey);
        if (!texture.baseTexture || !texture.valid) continue;
        let entries = $35a6592763403c18$var$cache.get(texture);
        if (!entries) $35a6592763403c18$var$cache.set(texture, entries = new Map());
        if (!entries.has(cacheKey)) entries.set(cacheKey, $35a6592763403c18$var$alphaBounds(pixels, width, height, texture));
    }
};
const $35a6592763403c18$var$schedulePoll = ()=>{
    if ($35a6592763403c18$var$pollScheduled) return;
    $35a6592763403c18$var$pollScheduled = true;
    setTimeout(()=>{
        $35a6592763403c18$var$pollScheduled = false;
        $35a6592763403c18$var$collectReadbacks();
        if ($35a6592763403c18$var$inFlight.length) $35a6592763403c18$var$schedulePoll();
    }, $35a6592763403c18$var$READBACK_POLL_MS);
};
const $35a6592763403c18$export$64a81b232683d404 = {
    image: 0,
    imageMs: 0,
    gpu: 0
};
// Where image-backed art is read on the CPU: `willReadFrequently` keeps the canvas in memory, off the GPU.
let $35a6592763403c18$var$scratch;
/**
 * The bounds read from the image a texture was loaded from (an atlas PNG), on the CPU; undefined when its pixels
 * live only on the GPU (rendered art) or cannot be read here. A GPU readback waits out every command queued before
 * it, which in a busy castle is 20-50ms; drawing a cell of an already decoded image into a canvas is a fraction of one.
 */ const $35a6592763403c18$var$imageContentBounds = (texture)=>{
    const source = texture.baseTexture?.resource?.source;
    const isImage = typeof HTMLImageElement !== "undefined" && source instanceof HTMLImageElement || typeof ImageBitmap !== "undefined" && source instanceof ImageBitmap;
    if (!isImage || texture.rotate) return undefined;
    const resolution = texture.baseTexture.resolution || 1;
    const { x: x, y: y, width: width, height: height } = texture.frame;
    const w = Math.round(width * resolution), h = Math.round(height * resolution);
    if (!w || !h) return undefined;
    try {
        $35a6592763403c18$var$scratch ||= document.createElement("canvas").getContext("2d", {
            willReadFrequently: true
        });
        if (!$35a6592763403c18$var$scratch) return undefined;
        const canvas = $35a6592763403c18$var$scratch.canvas;
        if (canvas.width < w) canvas.width = w;
        if (canvas.height < h) canvas.height = h;
        const t0 = performance.now();
        $35a6592763403c18$var$scratch.clearRect(0, 0, w, h);
        $35a6592763403c18$var$scratch.drawImage(source, x * resolution, y * resolution, w, h, 0, 0, w, h);
        const bounds = $35a6592763403c18$var$alphaBounds($35a6592763403c18$var$scratch.getImageData(0, 0, w, h).data, w, h, texture);
        $35a6592763403c18$export$64a81b232683d404.image++;
        $35a6592763403c18$export$64a81b232683d404.imageMs += performance.now() - t0;
        return bounds;
    } catch  {
        return undefined;
    }
};
/** A texture's bounds, from its image when it has one, else read back from the GPU. */ const $35a6592763403c18$var$measure = (texture)=>{
    const fromImage = texture?.valid ? $35a6592763403c18$var$imageContentBounds(texture) : undefined;
    return fromImage !== undefined ? fromImage : $35a6592763403c18$var$computeContentBounds(texture);
};
const $35a6592763403c18$var$computeContentBounds = (texture)=>{
    let extract;
    try {
        extract = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer?.plugins?.extract;
    } catch  {
        return null;
    }
    if (!extract || !texture?.valid) return null;
    $35a6592763403c18$export$64a81b232683d404.gpu++;
    const probe = new (0, $7Bs2Z.Sprite)(texture);
    try {
        const canvas = extract.canvas(probe);
        const ctx = canvas.getContext("2d");
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        if (!ctx || canvasWidth === 0 || canvasHeight === 0) return null;
        return $35a6592763403c18$var$alphaBounds(ctx.getImageData(0, 0, canvasWidth, canvasHeight).data, canvasWidth, canvasHeight, texture);
    } catch (e) {
        (0, $5UG8I.logger).error({
            tags: [
                "sprite",
                "error"
            ]
        }, e);
        return null;
    } finally{
        probe.destroy();
    }
};
/** The bounds of the pixels above the alpha threshold in RGBA rows (top first) read from `texture`. */ const $35a6592763403c18$var$alphaBounds = (data, width, height, texture)=>{
    let minX = width;
    let minY = height;
    let maxX = -1;
    let maxY = -1;
    for(let y = 0; y < height; y++){
        const rowOffset = y * width * 4;
        for(let x = 0; x < width; x++)if (data[rowOffset + x * 4 + 3] > $35a6592763403c18$var$CONTENT_ALPHA_THRESHOLD) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
        }
    }
    if (maxX < 0) // Entirely transparent (a blank stand-in marker). No content to point at.
    return null;
    // The pixels can be at a different resolution than the texture, so map back through
    // their own dimensions rather than assuming 1:1.
    const area = texture.trim ?? new (0, $6qzqq.Rectangle)(0, 0, texture.orig.width, texture.orig.height);
    const scaleX = area.width / width;
    const scaleY = area.height / height;
    return new (0, $6qzqq.Rectangle)(area.x + minX * scaleX, area.y + minY * scaleY, (maxX - minX + 1) * scaleX, (maxY - minY + 1) * scaleY);
};
const $35a6592763403c18$export$92de05754e03fcc2 = (sprite, out)=>{
    const content = $35a6592763403c18$export$437cb752f6483367(sprite.texture, "occlusion");
    if (!content) return content;
    // The caller's broad bounds query has already updated the world transform.
    const matrix = sprite.worldTransform;
    const x = content.x - sprite.anchor.x * sprite.texture.orig.width;
    const y = content.y - sprite.anchor.y * sprite.texture.orig.height;
    const originX = matrix.a * x + matrix.c * y + matrix.tx;
    const originY = matrix.b * x + matrix.d * y + matrix.ty;
    const widthX = matrix.a * content.width, widthY = matrix.b * content.width;
    const heightX = matrix.c * content.height, heightY = matrix.d * content.height;
    out.x = originX + Math.min(0, widthX) + Math.min(0, heightX);
    out.y = originY + Math.min(0, widthY) + Math.min(0, heightY);
    out.width = Math.abs(widthX) + Math.abs(heightX);
    out.height = Math.abs(widthY) + Math.abs(heightY);
    return out;
};


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $P8XPi = parcelRequire("P8XPi");
var $9Tsx3 = parcelRequire("9Tsx3");
// Texture coordinates from the source texture's own size: pooled textures at other resolutions can differ
// in logical size from the filter's input, which the global `inputSize` describes. `uShift` moves the
// drawn quad without moving what it samples (the snap of the last pass).
const $65ff58edc75cc05c$var$VERTEX = `
attribute vec2 aVertexPosition;
uniform mat3 projectionMatrix;
uniform vec4 outputFrame;
uniform vec2 uSourceScale;
uniform vec2 uShift;
varying vec2 vTextureCoord;

void main(void) {
    vec2 position = aVertexPosition * max(outputFrame.zw, vec2(0.)) + outputFrame.xy - uShift;
    gl_Position = vec4((projectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aVertexPosition * uSourceScale;
}`;
const $65ff58edc75cc05c$var$COPY = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 uClamp;

void main(void) {
    gl_FragColor = texture2D(uSampler, clamp(vTextureCoord, uClamp.xy, uClamp.zw));
}`;
// pixi's own 5-tap kernel: one pass spreads by 1.29 taps.
const $65ff58edc75cc05c$var$GAUSS = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 uClamp;
uniform vec2 uStep;

vec4 tap(float i) { return texture2D(uSampler, clamp(vTextureCoord + i * uStep, uClamp.xy, uClamp.zw)); }

void main(void) {
    gl_FragColor = (tap(-2.0) + tap(2.0)) * 0.153388 + (tap(-1.0) + tap(1.0)) * 0.221461 + tap(0.0) * 0.250301;
}`;
// The blurred storey laid over the screen through a cubic B-spline, from four bilinear taps (four texels a side).
// Bilinear alone left a ridge at every texel edge of a halved texture (faint stripes four pixels apart), and its
// own softening varied with where the screen's pixels fell between texels, so as the camera glided the storey's
// sharpness pulsed. The B-spline is smooth, and it softens by the same variance (a third of a texel) at any phase.
const $65ff58edc75cc05c$var$BSPLINE = `
varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 uClamp;
uniform vec2 uTexel;

vec4 at(vec2 uv) { return texture2D(uSampler, clamp(uv, uClamp.xy, uClamp.zw)); }

void main(void) {
    vec2 p = vTextureCoord / uTexel - 0.5;
    vec2 i = floor(p), f = p - i, f2 = f * f, f3 = f2 * f;
    vec2 w0 = (1.0 - 3.0 * f + 3.0 * f2 - f3) / 6.0;
    vec2 w1 = (4.0 - 6.0 * f2 + 3.0 * f3) / 6.0;
    vec2 w2 = (1.0 + 3.0 * f + 3.0 * f2 - 3.0 * f3) / 6.0;
    vec2 w3 = f3 / 6.0;
    vec2 g0 = w0 + w1, g1 = w2 + w3;
    vec2 a = (i - 0.5 + w1 / g0) * uTexel, b = (i + 1.5 + w3 / g1) * uTexel;
    gl_FragColor = g0.y * (g0.x * at(a) + g1.x * at(vec2(b.x, a.y))) + g1.y * (g0.x * at(vec2(a.x, b.y)) + g1.x * at(b));
}`;
// A kept snapshot laid on the screen the way the filter's last pass lays its result: the same B-spline.
const $65ff58edc75cc05c$var$SNAPSHOT_VERTEX = `
attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
uniform mat3 projectionMatrix;
uniform mat3 translationMatrix;
varying vec2 vTextureCoord;

void main(void) {
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
    vTextureCoord = aTextureCoord;
}`;
/** A snapshot's texture grows in steps of this many texels. */ const $65ff58edc75cc05c$var$SNAPSHOT_STEP = 128;
const $65ff58edc75cc05c$var$KERNEL_SPREAD = 1.29;
/** The widest step between taps, in texels, before a blur shows its taps as ghosts. */ const $65ff58edc75cc05c$var$MAX_TAP_STEP = 1.5;
/** The B-spline's own softening, and the 2x2 averaging of the halvings, as variance in final texels. */ const $65ff58edc75cc05c$var$BSPLINE_VARIANCE = 1 / 3;
const $65ff58edc75cc05c$var$HALVING_VARIANCE = 1 / 12;
const $65ff58edc75cc05c$var$MAX_HALVINGS = 3;
const $65ff58edc75cc05c$export$b5c8fc152fa0c719 = 2 ** $65ff58edc75cc05c$var$MAX_HALVINGS;
const $65ff58edc75cc05c$export$ed687684cf543fbe = (at, resolution)=>at - Math.ceil(at * resolution - 0.5) / resolution;
const $65ff58edc75cc05c$export$c21536e801e762b6 = (sigma)=>{
    const reach = $65ff58edc75cc05c$var$KERNEL_SPREAD * $65ff58edc75cc05c$var$MAX_TAP_STEP;
    const gaussAt = (halvings)=>Math.sqrt(Math.max(0, (sigma / 2 ** halvings) ** 2 - $65ff58edc75cc05c$var$BSPLINE_VARIANCE - (halvings ? $65ff58edc75cc05c$var$HALVING_VARIANCE : 0)));
    let halvings = 0;
    while(halvings < $65ff58edc75cc05c$var$MAX_HALVINGS && gaussAt(halvings) > reach)halvings++;
    const gauss = gaussAt(halvings);
    const passes = Math.max(1, Math.ceil((gauss / reach) ** 2));
    return {
        halvings: halvings,
        passes: passes,
        step: gauss / ($65ff58edc75cc05c$var$KERNEL_SPREAD * Math.sqrt(passes))
    };
};
class $65ff58edc75cc05c$var$Pass extends (0, $klOfb.Filter) {
    constructor(fragment){
        super($65ff58edc75cc05c$var$VERTEX, fragment, {
            uSourceScale: new Float32Array(2),
            uClamp: new Float32Array(4),
            uStep: new Float32Array(2),
            uTexel: new Float32Array(2),
            uShift: new Float32Array(2)
        });
    }
    run(filterManager, from, to, clear, step, shift = [
        0,
        0
    ]) {
        // The area being filtered, in logical px (pixi keeps it protected; it is the `outputFrame` shaders get).
        const frame = filterManager.activeState.sourceFrame;
        const sx = frame.width / from.width, sy = frame.height / from.height;
        const px = 1 / from.baseTexture.realWidth, py = 1 / from.baseTexture.realHeight;
        this.uniforms.uSourceScale[0] = sx;
        this.uniforms.uSourceScale[1] = sy;
        this.uniforms.uClamp[0] = px / 2;
        this.uniforms.uClamp[1] = py / 2;
        this.uniforms.uClamp[2] = sx - px / 2;
        this.uniforms.uClamp[3] = sy - py / 2;
        this.uniforms.uTexel[0] = px;
        this.uniforms.uTexel[1] = py;
        this.uniforms.uShift[0] = shift[0];
        this.uniforms.uShift[1] = shift[1];
        if (step) {
            this.uniforms.uStep[0] = step[0] * px;
            this.uniforms.uStep[1] = step[1] * py;
        }
        filterManager.applyFilter(this, from, to, clear);
    }
}
class $65ff58edc75cc05c$export$a64017bf69403efb extends (0, $klOfb.Filter) {
    constructor(){
        super(), this.copy = new $65ff58edc75cc05c$var$Pass($65ff58edc75cc05c$var$COPY), this.gauss = new $65ff58edc75cc05c$var$Pass($65ff58edc75cc05c$var$GAUSS), this.bspline = new $65ff58edc75cc05c$var$Pass($65ff58edc75cc05c$var$BSPLINE), this._sigma = 0, /** How far past the art the blur reaches, in logical px: the container widens its area by this. */ this.margin = 0, /** The resolution of the screen the result is laid on (`resolution` is the storey's, see `focus`). */ this.screenResolution = 1, /** What the storey shows, from its renderer: its art's version (a change redraws at once), and when anything on it last moved. */ this.contentVersion = "", this.contentChangedAt = 0;
        // The container hands this filter its area, already widened and anchored (BoundedStoreyContainer).
        this.autoFit = false;
        this.padding = 0;
    }
    get sigma() {
        return this._sigma;
    }
    set sigma(value) {
        this._sigma = value;
        this.margin = Math.ceil(3 * value);
    }
    /**
     * Blur by `sigma` logical px for a screen at `screenResolution`. A blur wide enough to be worked on a halved
     * texture takes the storey at that size to begin with, rather than drawing it whole and averaging it down:
     * behind a nine-storey house, eight storeys drawn at full size cost the GPU as much again as the scene.
     * A quarter or a sixteenth of the pixels and no halving passes; anchored to the art, the coarser draw is still
     * the same every frame, and what its nearest sampling drops is lost in the blur.
     */ focus(sigma, screenResolution) {
        this.sigma = sigma;
        this.screenResolution = screenResolution;
        this.resolution = screenResolution / 2 ** $65ff58edc75cc05c$export$c21536e801e762b6(sigma * screenResolution).halvings;
    }
    apply(filterManager, input, output, clearMode) {
        const resolution = input.baseTexture.resolution;
        const { halvings: halvings, passes: passes, step: step } = $65ff58edc75cc05c$export$c21536e801e762b6(this._sigma * resolution);
        const borrowed = [];
        const modes = new Map();
        const smooth = (texture)=>{
            if (!modes.has(texture.baseTexture)) modes.set(texture.baseTexture, texture.baseTexture.scaleMode);
            texture.baseTexture.scaleMode = (0, $P8XPi.SCALE_MODES).LINEAR;
            return texture;
        };
        const texture = (scale)=>{
            const next = smooth(filterManager.getFilterTexture(input, resolution / scale));
            borrowed.push(next);
            return next;
        };
        smooth(input);
        let source = input;
        for(let i = 1; i <= halvings; i++){
            const half = texture(2 ** i);
            this.copy.run(filterManager, source, half, (0, $P8XPi.CLEAR_MODES).CLEAR);
            source = half;
        }
        if (step > 0) {
            const spare = texture(2 ** halvings);
            for(let i = 0; i < passes; i++){
                this.gauss.run(filterManager, source, spare, (0, $P8XPi.CLEAR_MODES).CLEAR, [
                    step,
                    0
                ]);
                this.gauss.run(filterManager, spare, source, (0, $P8XPi.CLEAR_MODES).CLEAR, [
                    0,
                    step
                ]);
            }
        }
        const frame = filterManager.activeState.sourceFrame;
        if (this.keep) this.keepSnapshot(filterManager, source, frame);
        this.bspline.run(filterManager, source, output, clearMode, undefined, [
            $65ff58edc75cc05c$export$ed687684cf543fbe(frame.x, this.screenResolution),
            $65ff58edc75cc05c$export$ed687684cf543fbe(frame.y, this.screenResolution)
        ]);
        modes.forEach((mode, base)=>{
            base.scaleMode = mode;
        });
        borrowed.forEach((texture)=>filterManager.returnFilterTexture(texture));
    }
    /**
     * Lay the kept snapshot down again where the storey now stands: `x`, `y` is its area's corner in global
     * logical px. One quad, no pass of its own, nothing of the storey drawn: what a frame costs between redraws.
     */ drawSnapshot(renderer, x, y) {
        const snapshot = this.snapshot;
        if (!snapshot) return;
        const { width: width, height: height } = snapshot.frame;
        const realWidth = snapshot.texture.baseTexture.realWidth, realHeight = snapshot.texture.baseTexture.realHeight;
        // The picture fills the texture's top-left corner: the texture is kept with room to spare (keepSnapshot).
        const u = width / snapshot.texture.width, v = height / snapshot.texture.height;
        if (!this.quad) {
            const geometry = new (0, $9Tsx3.MeshGeometry)(new Float32Array(8), new Float32Array([
                0,
                0,
                1,
                0,
                1,
                1,
                0,
                1
            ]), new Uint16Array([
                0,
                1,
                2,
                0,
                2,
                3
            ]));
            const shader = (0, $klOfb.Shader).from($65ff58edc75cc05c$var$SNAPSHOT_VERTEX, $65ff58edc75cc05c$var$BSPLINE, {
                uSampler: snapshot.texture,
                uTexel: new Float32Array(2),
                uClamp: new Float32Array(4)
            });
            this.quad = new (0, $9Tsx3.Mesh)(geometry, shader);
        }
        const quad = this.quad, uniforms = quad.shader.uniforms;
        const vertices = quad.geometry.getBuffer("aVertexPosition"), uvs = quad.geometry.getBuffer("aTextureCoord");
        const data = vertices.data, uvData = uvs.data;
        if (data[2] !== width || data[5] !== height) {
            data.set([
                0,
                0,
                width,
                0,
                width,
                height,
                0,
                height
            ]);
            vertices.update();
        }
        if (uvData[2] !== u || uvData[5] !== v) {
            uvData.set([
                0,
                0,
                u,
                0,
                u,
                v,
                0,
                v
            ]);
            uvs.update();
        }
        uniforms.uSampler = snapshot.texture;
        uniforms.uTexel[0] = 1 / realWidth;
        uniforms.uTexel[1] = 1 / realHeight;
        uniforms.uClamp[0] = 0.5 / realWidth;
        uniforms.uClamp[1] = 0.5 / realHeight;
        uniforms.uClamp[2] = u - 0.5 / realWidth;
        uniforms.uClamp[3] = v - 0.5 / realHeight;
        const at = (value)=>value - $65ff58edc75cc05c$export$ed687684cf543fbe(value, this.screenResolution);
        quad.transform.worldTransform.set(1, 0, 0, 1, at(x), at(y));
        quad.worldAlpha = 1;
        quad._render(renderer);
        renderer.batch.flush();
    }
    dropSnapshot() {
        this.snapshot?.texture.destroy(true);
        this.snapshot = undefined;
    }
    keepSnapshot(filterManager, source, frame) {
        const resolution = source.baseTexture.resolution;
        let texture = this.snapshot?.texture;
        // Kept with room to spare (whole SNAPSHOT_STEP texels), so a redraw as the camera moves reuses it.
        const fits = texture && texture.baseTexture.resolution === resolution && texture.width >= frame.width && texture.height >= frame.height && texture.width <= frame.width + 2 * $65ff58edc75cc05c$var$SNAPSHOT_STEP / resolution;
        if (!fits) {
            texture?.destroy(true);
            const size = (logical)=>Math.ceil(logical * resolution / $65ff58edc75cc05c$var$SNAPSHOT_STEP) * $65ff58edc75cc05c$var$SNAPSHOT_STEP / resolution;
            texture = (0, $klOfb.RenderTexture).create({
                width: size(frame.width),
                height: size(frame.height),
                resolution: resolution,
                scaleMode: (0, $P8XPi.SCALE_MODES).LINEAR
            });
        }
        texture.filterFrame = frame;
        this.copy.run(filterManager, source, texture, (0, $P8XPi.CLEAR_MODES).CLEAR);
        texture.filterFrame = null;
        this.snapshot = {
            texture: texture,
            frame: frame.clone(),
            origin: this.keep.origin,
            key: this.keep.key,
            madeAt: this.keep.at
        };
        this.keep = undefined;
    }
    destroy() {
        this.copy.destroy();
        this.gauss.destroy();
        this.bspline.destroy();
        this.dropSnapshot();
        this.quad?.destroy();
        super.destroy();
    }
}


const $4f4274c559724179$var$percentile = (sorted, p)=>sorted.length ? sorted[Math.min(sorted.length - 1, Math.floor(p * sorted.length))] : 0;
const $4f4274c559724179$var$round = (n, places = 2)=>{
    const scale = 10 ** places;
    return Math.round(n * scale) / scale;
};
const $4f4274c559724179$var$pct = (values)=>{
    const sorted = [
        ...values
    ].sort((a, b)=>a - b);
    return {
        p50: $4f4274c559724179$var$round($4f4274c559724179$var$percentile(sorted, 0.5)),
        p90: $4f4274c559724179$var$round($4f4274c559724179$var$percentile(sorted, 0.9)),
        p99: $4f4274c559724179$var$round($4f4274c559724179$var$percentile(sorted, 0.99)),
        max: $4f4274c559724179$var$round(sorted[sorted.length - 1] ?? 0)
    };
};
const $4f4274c559724179$export$55ba19f9c7096c62 = (recorded, worstCount = 25)=>{
    // The last frame has no next frame to close its span.
    const frames = recorded.filter((f)=>f.span > 0);
    const spans = frames.map((f)=>f.span).sort((a, b)=>a - b);
    const medianSpan = $4f4274c559724179$var$percentile(spans, 0.5);
    // A quarter of a refresh past the typical frame: vsync puts a frame that missed at a whole extra refresh.
    const slowThreshold = medianSpan * 1.25;
    const isSlow = (f)=>f.span > slowThreshold;
    const slow = frames.filter(isSlow);
    const normal = frames.filter((f)=>!isSlow(f));
    const total = frames.reduce((sum, f)=>sum + f.span, 0);
    const phaseNames = new Set();
    const countNames = new Set();
    for (const f of frames){
        Object.keys(f.phases).forEach((k)=>phaseNames.add(k));
        Object.keys(f.counts).forEach((k)=>countNames.add(k));
    }
    const mean = (set, read)=>set.length ? set.reduce((sum, f)=>sum + read(f), 0) / set.length : 0;
    const phases = [
        ...phaseNames
    ].map((name)=>{
        const values = frames.map((f)=>f.phases[name] ?? 0).sort((a, b)=>a - b);
        return {
            name: name,
            mean: $4f4274c559724179$var$round(mean(frames, (f)=>f.phases[name] ?? 0), 3),
            p95: $4f4274c559724179$var$round($4f4274c559724179$var$percentile(values, 0.95), 3),
            max: $4f4274c559724179$var$round(values[values.length - 1] ?? 0, 3)
        };
    }).sort((a, b)=>b.mean - a.mean);
    const contrastOf = (metric, read)=>{
        const s = mean(slow, read);
        const n = mean(normal, read);
        return {
            metric: metric,
            slow: $4f4274c559724179$var$round(s, 3),
            normal: $4f4274c559724179$var$round(n, 3),
            delta: $4f4274c559724179$var$round(s - n, 3)
        };
    };
    const contrast = [
        contrastOf("js", (f)=>f.js),
        ...[
            ...phaseNames
        ].map((name)=>contrastOf(name, (f)=>f.phases[name] ?? 0)),
        ...[
            ...countNames
        ].map((name)=>contrastOf(`#${name}`, (f)=>f.counts[name] ?? 0))
    ].filter((c)=>Math.abs(c.delta) > 0.001).sort((a, b)=>Math.abs(b.delta) / (Math.abs(b.normal) + 1) - Math.abs(a.delta) / (Math.abs(a.normal) + 1));
    const beats = new Map();
    let last = -1;
    frames.forEach((f, i)=>{
        if (!isSlow(f)) return;
        if (last >= 0) beats.set(i - last, (beats.get(i - last) ?? 0) + 1);
        last = i;
    });
    const beat = [
        ...beats
    ].map(([every, times])=>({
            every: every,
            times: times
        })).sort((a, b)=>b.times - a.times).slice(0, 8);
    const byTile = new Map();
    for (const f of frames){
        const tile = `${Math.floor(f.x / 32)},${Math.floor(f.y / 32)}${f.floor ? `@${f.floor}` : ""}`;
        const entry = byTile.get(tile) ?? {
            frames: 0,
            slow: 0
        };
        entry.frames++;
        if (isSlow(f)) entry.slow++;
        byTile.set(tile, entry);
    }
    const tiles = [
        ...byTile
    ].filter(([, e])=>e.frames >= 8).map(([tile, e])=>({
            tile: tile,
            frames: e.frames,
            slow: e.slow,
            share: $4f4274c559724179$var$round(e.slow / e.frames)
        })).sort((a, b)=>b.share - a.share);
    return {
        frames: frames.length,
        seconds: $4f4274c559724179$var$round(total / 1000, 1),
        fps: $4f4274c559724179$var$round(total ? frames.length * 1000 / total : 0, 1),
        medianSpan: $4f4274c559724179$var$round(medianSpan),
        slowThreshold: $4f4274c559724179$var$round(slowThreshold),
        slowFrames: slow.length,
        slowPct: $4f4274c559724179$var$round(frames.length ? 100 * slow.length / frames.length : 0, 1),
        spanPct: $4f4274c559724179$var$pct(frames.map((f)=>f.span)),
        jsPct: $4f4274c559724179$var$pct(frames.map((f)=>f.js)),
        phases: phases,
        contrast: contrast,
        beat: beat,
        tiles: tiles,
        worst: [
            ...frames
        ].sort((a, b)=>b.span - a.span).slice(0, worstCount)
    };
};
const $4f4274c559724179$export$fe6fd3e7f8a505ff = (s, label)=>{
    const lines = [];
    lines.push(`hitch probe${label ? ` [${label}]` : ""}: ${s.frames} frames in ${s.seconds}s, ${s.fps} fps`);
    lines.push(`span ms p50 ${s.spanPct.p50} p90 ${s.spanPct.p90} p99 ${s.spanPct.p99} max ${s.spanPct.max}; ` + `slow (> ${s.slowThreshold}ms): ${s.slowFrames} (${s.slowPct}%)`);
    lines.push(`js ms p50 ${s.jsPct.p50} p90 ${s.jsPct.p90} p99 ${s.jsPct.p99} max ${s.jsPct.max}`);
    lines.push("", "phases (mean / p95 / max ms):");
    s.phases.slice(0, 24).forEach((p)=>lines.push(`  ${p.name.padEnd(34)} ${String(p.mean).padStart(7)} ${String(p.p95).padStart(7)} ${String(p.max).padStart(8)}`));
    lines.push("", "slow vs normal frames (mean per frame; # = calls):");
    s.contrast.slice(0, 24).forEach((c)=>lines.push(`  ${c.metric.padEnd(34)} ${String(c.slow).padStart(9)} vs ${String(c.normal).padStart(9)}`));
    lines.push("", `slow-frame beat (frames apart x times): ${s.beat.map((b)=>`${b.every}x${b.times}`).join("  ") || "none"}`);
    lines.push("", "worst tiles (tile: slow/frames):");
    s.tiles.slice(0, 12).forEach((t)=>lines.push(`  ${t.tile.padEnd(12)} ${t.slow}/${t.frames} (${Math.round(t.share * 100)}%)`));
    lines.push("", "worst frames:");
    s.worst.slice(0, 12).forEach((f)=>{
        const top = Object.entries(f.phases).filter(([, ms])=>ms >= 0.25).sort((a, b)=>b[1] - a[1]).slice(0, 8).map(([name, ms])=>`${name} ${$4f4274c559724179$var$round(ms, 1)}`).join(", ");
        const counts = Object.entries(f.counts).filter(([name])=>!name.startsWith("filter.")).map(([name, n])=>`${name}:${n}`).join(" ");
        lines.push(`  t=${$4f4274c559724179$var$round(f.t / 1000, 2)}s span ${$4f4274c559724179$var$round(f.span, 1)} js ${$4f4274c559724179$var$round(f.js, 1)} at ${Math.round(f.x)},${Math.round(f.y)}${f.floor ? `@${f.floor}` : ""}`);
        if (top) lines.push(`    ${top}`);
        lines.push(`    ${counts}`);
        if (f.events.length) lines.push(`    events: ${f.events.slice(0, 8).join("; ")}`);
    });
    return lines.join("\n");
};
// The GL calls counted every frame, under a short name.
const $4f4274c559724179$var$COUNTED_GL = {
    bindFramebuffer: "fb",
    drawElements: "draw",
    drawArrays: "draw",
    drawElementsInstanced: "draw",
    drawArraysInstanced: "draw",
    clear: "clear",
    useProgram: "program",
    bindTexture: "bindTex"
};
// GL calls that make the main thread wait for the GPU process (or are worth seeing when they happen at all): timed.
const $4f4274c559724179$var$TIMED_GL = [
    "readPixels",
    "getBufferSubData",
    "clientWaitSync",
    "getSyncParameter",
    "fenceSync",
    "finish",
    "getError",
    "getParameter",
    "getShaderParameter",
    "getProgramParameter",
    "checkFramebufferStatus",
    "compileShader",
    "linkProgram"
];
const $4f4274c559724179$var$UPLOAD_GL = [
    "texImage2D",
    "texSubImage2D",
    "compressedTexImage2D",
    "texImage3D",
    "texSubImage3D"
];
const $4f4274c559724179$var$BUFFER_GL = [
    "bufferData",
    "bufferSubData"
];
// Big texture uploads and render targets get an event of their own: one is enough to drop a frame.
const $4f4274c559724179$var$NOTABLE_BYTES = 262144;
const $4f4274c559724179$var$uploadSize = (name, args)=>{
    // texImage2D(target, level, internalformat, width, height, border, format, type, pixels)
    // texImage2D(target, level, internalformat, format, type, source)
    // texSubImage2D(target, level, x, y, width, height, format, type, pixels)
    // texSubImage2D(target, level, x, y, format, type, source)
    if (name === "texImage2D" || name === "compressedTexImage2D") {
        if (args.length >= 8 || name === "compressedTexImage2D") return [
            args[3] | 0,
            args[4] | 0
        ];
        const source = args[5];
        return [
            source?.width | 0,
            source?.height | 0
        ];
    }
    if (name === "texSubImage2D") {
        if (args.length >= 9) return [
            args[4] | 0,
            args[5] | 0
        ];
        const source = args[6];
        return [
            source?.width | 0,
            source?.height | 0
        ];
    }
    return [
        args[3] | 0,
        args[4] | 0
    ];
};
// Ticker priorities that bracket every listener pixi and the game add (the stage render is LOW, -25).
const $4f4274c559724179$var$FIRST = 1000;
const $4f4274c559724179$var$LAST = -1000;
class $4f4274c559724179$var$HitchProbe {
    fail(error) {
        if (this.failed) return;
        this.failed = true;
        console.warn("[hitch probe] frame hook failed; recording what it can", error);
    }
    constructor(app, client){
        this.app = app;
        this.client = client;
        this.frames = [];
        this.frameStart = 0;
        this.origin = 0;
        this.restorers = [];
        this.running = false;
        this.wrappedStoreys = new WeakSet();
        this.wrappedProviders = new WeakSet();
        this.boundsReadsAt = {
            ...(0, $35a6592763403c18$export$64a81b232683d404)
        };
        this.begin = ()=>{
            try {
                this.beginFrame();
            } catch (error) {
                this.fail(error);
            }
        };
        this.end = ()=>{
            try {
                this.endFrame();
            } catch (error) {
                this.fail(error);
            }
        };
        this.failed = false;
        this.record = (seconds = 20, label)=>{
            this.start(label);
            return new Promise((resolve)=>{
                this.timer = setTimeout(()=>{
                    const summary = this.stop();
                    this.save(summary);
                    resolve(summary);
                }, seconds * 1000);
            });
        };
        this.start = (label)=>{
            if (this.running) this.stop();
            this.running = true;
            this.label = label;
            this.frames = [];
            this.current = undefined;
            this.origin = performance.now();
            this.lastHeap = undefined;
            this.sceneAtStart = this.scene();
            this.boundsReadsAt = {
                ...(0, $35a6592763403c18$export$64a81b232683d404)
            };
            this.wrappedStoreys = new WeakSet();
            this.wrappedProviders = new WeakSet();
            this.app.ticker.add(this.begin, undefined, $4f4274c559724179$var$FIRST);
            this.app.ticker.add(this.end, undefined, $4f4274c559724179$var$LAST);
            this.restorers.push(()=>{
                this.app.ticker.remove(this.begin);
                this.app.ticker.remove(this.end);
            });
            this.wrapRenderer();
            this.wrapGl();
            this.wrapClient();
            this.wrapPrototypes();
            console.log(`[hitch probe] recording${label ? ` "${label}"` : ""}... hitchProbe.stop() for the report`);
        };
        this.stop = ()=>{
            if (this.timer) clearTimeout(this.timer);
            this.timer = undefined;
            this.running = false;
            // Undo in reverse, so a method wrapped twice (a prototype and its instance) comes back as it was.
            this.restorers.reverse().forEach((restore)=>{
                try {
                    restore();
                } catch (error) {
                    console.warn("[hitch probe] restore failed", error);
                }
            });
            this.restorers = [];
            this.wrappedMap = undefined;
            const summary = $4f4274c559724179$export$55ba19f9c7096c62(this.frames);
            console.log($4f4274c559724179$export$fe6fd3e7f8a505ff(summary, this.label));
            return summary;
        };
        this./**
     * What drawing the scene costs, layer by layer: `await hitchProbe.drawCost()` while standing somewhere typical.
     * Pauses the game, draws the stage back to back (each batch ended by a one-pixel readback, so the time is the
     * GPU's and not the refresh rate's), then again with each named layer hidden, each filter dropped and each mask
     * lifted in turn. A layer's `saves` is what it costs to draw. Prints a table and returns the rows.
     */ drawCost = async (renders = 12, only, pairs = 5)=>{
            const app = this.app, renderer = this.app.renderer, gl = renderer.gl;
            const pixel = new Uint8Array(4);
            const draw = ()=>renderer.render(app.stage);
            const sync = ()=>gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
            const once = ()=>{
                draw();
                sync();
                const t0 = performance.now();
                for(let i = 0; i < renders; i++)draw();
                sync();
                return (performance.now() - t0) / renders;
            };
            const measure = ()=>{
                const runs = [
                    once(),
                    once(),
                    once()
                ].sort((a, b)=>a - b);
                return runs[1];
            };
            const names = this.layerNames();
            const label = (node, path)=>names.get(node) ?? `${path} ${node.constructor?.name ?? "?"}${node.children?.length ? `(${node.children.length})` : ""}`;
            // The layers worth measuring: every named layer wherever it is, and the containers (not single sprites: a
            // castle's map holds thousands) two deep. Named ones first; at most MAX of them.
            const MAX = 60;
            const named = [], unnamed = [];
            const walk = (node, path, depth)=>{
                const children = node.children ?? [];
                // A crowd (a map's thousands of sprites): only its named layers, and no further down the unnamed.
                const crowd = children.length > 200;
                children.forEach((child, i)=>{
                    const at = `${path}/${i}`;
                    if (!child.visible || child.worldAlpha === 0) return;
                    if (names.has(child)) named.push({
                        node: child,
                        path: at
                    });
                    else if (crowd) return;
                    else if (depth < 3 && child.children?.length) unnamed.push({
                        node: child,
                        path: at
                    });
                    if (depth < 5) walk(child, at, depth + 1);
                });
            };
            walk(app.stage, "", 1);
            const candidates = [
                ...named,
                ...unnamed
            ].filter(({ node: node, path: path })=>!only || only.some((text)=>label(node, path).includes(text))).slice(0, MAX);
            const deadline = performance.now() + 60000;
            app.ticker.stop();
            try {
                const base = measure();
                const rows = [
                    {
                        label: "everything",
                        ms: base,
                        saves: 0
                    }
                ];
                // Interleaved: the baseline is measured again beside each layer, and the saving is the median of the pairs'
                // differences, so drift (the GPU's clocks, another tab) cancels out rather than landing on whichever layer
                // happened to be measured during it.
                const without = (text, apply)=>{
                    const diffs = [], hidden = [];
                    for(let pair = 0; pair < pairs; pair++){
                        const before = once();
                        const restore = apply();
                        let ms;
                        try {
                            ms = once();
                        } finally{
                            restore();
                        }
                        const after = once();
                        hidden.push(ms);
                        diffs.push((before + after) / 2 - ms);
                    }
                    diffs.sort((a, b)=>a - b);
                    hidden.sort((a, b)=>a - b);
                    rows.push({
                        label: text,
                        ms: hidden[pairs >> 1],
                        saves: diffs[pairs >> 1]
                    });
                };
                for (const { node: node, path: path } of candidates){
                    if (performance.now() > deadline) break;
                    // Let the page breathe between layers (the game itself stays paused).
                    await new Promise((resolve)=>setTimeout(resolve, 0));
                    without(`hide ${label(node, path)}`, ()=>{
                        node.visible = false;
                        return ()=>{
                            node.visible = true;
                        };
                    });
                    if (node.filters?.length) without(`no filters on ${label(node, path)} [${node.filters.map((f)=>f?.constructor?.name).join(",")}]`, ()=>{
                        const was = node.filters;
                        node.filters = null;
                        return ()=>{
                            node.filters = was;
                        };
                    });
                    if (node.mask) without(`no mask on ${label(node, path)}`, ()=>{
                        const was = node.mask;
                        node.mask = null;
                        return ()=>{
                            node.mask = was;
                        };
                    });
                }
                rows.sort((a, b)=>b.saves - a.saves);
                const shown = rows.filter((row)=>row.label === "everything" || row.saves > 0.05);
                console.table(shown.map((row)=>({
                        layer: row.label,
                        ms: $4f4274c559724179$var$round(row.ms, 2),
                        saves: $4f4274c559724179$var$round(row.saves, 2)
                    })));
                return rows.map((row)=>({
                        ...row,
                        ms: $4f4274c559724179$var$round(row.ms, 3),
                        saves: $4f4274c559724179$var$round(row.saves, 3)
                    }));
            } finally{
                app.ticker.start();
            }
        };
        this./** Downloads the report and every frame as JSON (to ~/Downloads in a desktop browser). */ save = (summary = $4f4274c559724179$export$55ba19f9c7096c62(this.frames))=>{
            const renderer = this.app.renderer;
            const w = window;
            const toggles = {};
            for (const key of [
                "buildingShadow",
                "foliageShadow",
                "spriteShadow",
                "storeyFocus",
                "storeyEdges",
                "storeyTone",
                "indoorSight",
                "occluderFade",
                "occlusionOutline",
                "nightFog"
            ]){
                const value = w[key];
                toggles[key] = value === undefined ? "default" : value === false ? false : typeof value === "object" ? value.enabled ?? "on" : value;
            }
            const report = {
                label: this.label,
                at: new Date().toISOString(),
                userAgent: navigator.userAgent,
                devicePixelRatio: window.devicePixelRatio,
                canvas: {
                    width: renderer.view.width,
                    height: renderer.view.height,
                    resolution: renderer.resolution
                },
                toggles: toggles,
                sceneAtStart: this.sceneAtStart,
                sceneAtEnd: this.scene(),
                summary: summary,
                frames: this.frames.filter((f)=>f.span > 0)
            };
            const blob = new Blob([
                JSON.stringify(report)
            ], {
                type: "application/json"
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            const stamp = report.at.replace(/[:.]/g, "-");
            link.download = `hitch-probe-${this.label ? `${this.label.replace(/[^a-z0-9-]+/gi, "_")}-` : ""}${stamp}.json`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(()=>URL.revokeObjectURL(link.href), 10000);
            console.log(`[hitch probe] saved ${link.download}`);
        };
    }
    /** The display objects the game keeps by name (its renderers' fields), so a cost table can say what they are. */ layerNames() {
        const names = new Map();
        const isDisplay = (value)=>!!value && typeof value === "object" && "worldTransform" in value && typeof value.render === "function";
        const scan = (owner, prefix)=>{
            if (!owner) return;
            for (const key of Object.keys(owner)){
                let value;
                try {
                    value = owner[key];
                } catch  {
                    continue;
                }
                if (isDisplay(value) && !names.has(value)) names.set(value, `${prefix}.${key}`);
            }
        };
        const renderer = this.client.clientGameLogic?.clientRenderer;
        scan(renderer, "renderer");
        const map = renderer?.map?.();
        scan(map, "map");
        scan(renderer?.entity?.(), "entities");
        scan(renderer?.gui?.(), "gui");
        scan(renderer?.shadowRendering, "light");
        const floors = map?.sceneRenderer?.floors;
        floors?.forEach((floor)=>{
            const f = floor?.provider?.twoStoreyHouse?.floor ?? "?";
            if (floor?.root) names.set(floor.root, `storey ${f}`);
            scan(floor?.map, `storey ${f} map`);
        });
        return names;
    }
    beginFrame() {
        const now = performance.now();
        if (this.current) {
            this.current.span = now - this.frameStart;
            // Texture bounds measured during that span: from images on the CPU, and read back from the GPU.
            const reads = (0, $35a6592763403c18$export$64a81b232683d404), was = this.boundsReadsAt;
            if (reads.image > was.image) {
                this.current.counts["bounds.image"] = reads.image - was.image;
                this.current.phases["bounds.image"] = reads.imageMs - was.imageMs;
            }
            if (reads.gpu > was.gpu) this.current.counts["bounds.gpu"] = reads.gpu - was.gpu;
            this.boundsReadsAt = {
                ...reads
            };
            this.frames.push(this.current);
        }
        this.frameStart = now;
        const logic = this.client.clientGameLogic;
        const player = logic?.playerEntity;
        const map = logic?.clientRenderer?.map?.();
        const frame = {
            t: now - this.origin,
            span: 0,
            js: 0,
            phases: {},
            counts: {},
            events: [],
            x: player?.location?.x ?? 0,
            y: player?.location?.y ?? 0,
            room: player?.roomId,
            floor: map?.tilemapMetaProvider?.twoStoreyHouse?.floor ?? 0
        };
        const heap = performance.memory?.usedJSHeapSize;
        if (typeof heap === "number") {
            frame.heapMb = $4f4274c559724179$var$round(heap / 1048576, 1);
            // The heap only shrinks when the collector runs: a drop is a GC somewhere in the last span.
            if (this.lastHeap !== undefined && this.lastHeap - heap > 1048576 && this.frames.length) this.frames[this.frames.length - 1].events.push(`gc -${$4f4274c559724179$var$round((this.lastHeap - heap) / 1048576, 1)}MB`);
            this.lastHeap = heap;
        }
        this.current = frame;
        // The map is replaced on a storey hand-off: follow it.
        if (map && map !== this.wrappedMap) {
            if (this.wrappedMap) frame.events.push("map hand-off");
            this.wrapMap(map);
        }
        if (map) this.wrapStoreys(map);
    }
    endFrame() {
        if (this.current) this.current.js = performance.now() - this.frameStart;
    }
    add(phase, ms) {
        const frame = this.current;
        // The clock is coarsened to 0.1ms outside a cross-origin-isolated page: most calls read 0, and need no entry.
        if (!frame || ms <= 0) return;
        frame.phases[phase] = (frame.phases[phase] ?? 0) + ms;
    }
    count(name, n = 1) {
        const frame = this.current;
        if (!frame) return;
        frame.counts[name] = (frame.counts[name] ?? 0) + n;
    }
    event(text) {
        this.current?.events.push(text);
    }
    /** The local player's sprite (a composite whose `animations` hold its baked frames), if drawn. */ playerSprite() {
        const logic = this.client.clientGameLogic;
        const player = logic?.playerEntity;
        return player && logic?.clientRenderer?.entity?.()?.get?.(player)?.sprite;
    }
    /** What a texture is: one of the player's poses (and which), or its kind, size and cache id. */ describeTexture(texture) {
        const sprite = this.playerSprite();
        for (const [action, result] of Object.entries(sprite?.animations ?? {})){
            if (result?.animation?.textures?.includes(texture) || result?.sprite?.texture === texture) return `player pose ${action} (${sprite.constructor?.name})`;
        }
        const base = texture.baseTexture;
        const kind = texture instanceof (0, $klOfb.RenderTexture) ? "RenderTexture" : base?.resource?.constructor?.name ?? "?";
        const id = texture.textureCacheIds?.[0] ?? base?.textureCacheIds?.[0] ?? "";
        return `${kind} ${Math.round(texture.width ?? 0)}x${Math.round(texture.height ?? 0)}${id ? ` ${String(id).slice(-48)}` : ""}`;
    }
    scene() {
        const logic = this.client.clientGameLogic;
        const sprite = this.playerSprite();
        return {
            brightness: logic?.currentBrightness,
            playerSprite: sprite?.constructor?.name,
            spriteName: sprite?.spriteName,
            appearance: logic?.playerEntity?.appearance
        };
    }
    /** Times every call of obj[name] as `label`, and counts it. */ wrap(obj, name, label, after, before) {
        if (!obj) return;
        const original = obj[name];
        if (typeof original !== "function" || original.__hitchProbe) return;
        const own = Object.prototype.hasOwnProperty.call(obj, name);
        const probe = this;
        const wrapped = function(...args) {
            const state = before?.();
            const t0 = performance.now();
            try {
                return original.apply(this, args);
            } finally{
                const ms = performance.now() - t0;
                probe.add(label, ms);
                probe.count(label);
                after?.(args, ms, state);
            }
        };
        wrapped.__hitchProbe = true;
        obj[name] = wrapped;
        this.restorers.push(()=>{
            if (own) obj[name] = original;
            else delete obj[name];
        });
    }
    wrapRenderer() {
        const renderer = this.app.renderer;
        const probe = this;
        const render = renderer.render;
        renderer.render = function(displayObject, options, ...rest) {
            const target = options instanceof (0, $klOfb.RenderTexture) ? options : options?.renderTexture;
            const t0 = performance.now();
            try {
                return render.call(this, displayObject, options, ...rest);
            } finally{
                const ms = performance.now() - t0;
                const label = target ? "rt.render" : "stage.render";
                probe.add(label, ms);
                probe.count(label);
                if (target && target.width * target.height * renderer.resolution ** 2 * 4 >= $4f4274c559724179$var$NOTABLE_BYTES && ms > 1) probe.event(`rt.render ${Math.round(target.width)}x${Math.round(target.height)} ${$4f4274c559724179$var$round(ms, 1)}ms`);
            }
        };
        this.restorers.push(()=>{
            renderer.render = render;
        });
        this.wrap(renderer, "generateTexture", "generateTexture", (args, ms)=>{
            // A lone sprite is a texture being copied out to be read (texture_content_bounds): say whose.
            const texture = args[0]?.texture;
            if (texture && !args[0].children?.length) {
                this.event(`generateTexture of ${this.describeTexture(texture)} ${$4f4274c559724179$var$round(ms, 1)}ms`);
                return;
            }
            if (ms <= 0.5) return;
            const region = args[1]?.region ?? args[3] ?? args[0]?.getLocalBounds?.();
            this.event(`generateTexture ${Math.round(region?.width ?? 0)}x${Math.round(region?.height ?? 0)} ${$4f4274c559724179$var$round(ms, 1)}ms`);
        });
        const filterSystem = renderer.filter;
        const push = filterSystem.push;
        filterSystem.push = function(target, filters) {
            probe.count("filter.push");
            for (const filter of filters ?? [])probe.count(`filter.${filter?.constructor?.name ?? "?"}`);
            return push.apply(this, arguments);
        };
        this.restorers.push(()=>{
            filterSystem.push = push;
        });
    }
    wrapGl() {
        const gl = this.app.renderer.gl;
        if (!gl) return;
        const probe = this;
        const own = (name)=>{
            const original = gl[name];
            if (typeof original !== "function") return undefined;
            this.restorers.push(()=>{
                delete gl[name];
            });
            return original;
        };
        for (const [name, short] of Object.entries($4f4274c559724179$var$COUNTED_GL)){
            const original = own(name);
            if (!original) continue;
            gl[name] = function() {
                probe.count(short);
                return original.apply(gl, arguments);
            };
        }
        for (const name of $4f4274c559724179$var$TIMED_GL){
            const original = own(name);
            if (!original) continue;
            gl[name] = function() {
                const t0 = performance.now();
                try {
                    return original.apply(gl, arguments);
                } finally{
                    const ms = performance.now() - t0;
                    probe.add(`gl.${name}`, ms);
                    probe.count(`gl.${name}`);
                    if (name === "compileShader" || name === "linkProgram" || ms > 2) probe.event(`gl.${name} ${$4f4274c559724179$var$round(ms, 1)}ms`);
                }
            };
        }
        for (const name of $4f4274c559724179$var$UPLOAD_GL){
            const original = own(name);
            if (!original) continue;
            gl[name] = function(...args) {
                const t0 = performance.now();
                try {
                    return original.apply(gl, args);
                } finally{
                    const ms = performance.now() - t0;
                    const [w, h] = $4f4274c559724179$var$uploadSize(name, args);
                    probe.count("upload");
                    probe.count("uploadKB", Math.round(w * h * 4 / 1024));
                    probe.add("gl.upload", ms);
                    if (w * h * 4 >= $4f4274c559724179$var$NOTABLE_BYTES) probe.event(`${name} ${w}x${h} ${$4f4274c559724179$var$round(ms, 1)}ms`);
                }
            };
        }
        for (const name of $4f4274c559724179$var$BUFFER_GL){
            const original = own(name);
            if (!original) continue;
            gl[name] = function(...args) {
                const data = args[name === "bufferData" ? 1 : 2];
                const bytes = typeof data === "number" ? data : data?.byteLength ?? 0;
                probe.count("bufferKB", Math.round(bytes / 1024));
                return original.apply(gl, args);
            };
        }
    }
    wrapClient() {
        const client = this.client;
        this.wrap(client, "update", "client.update");
        this.wrap(client, "processServerMessages", "client.processServerMessages");
        this.wrap(client, "processInputs", "client.processInputs");
        this.wrap(client, "interpolateEntities", "client.interpolateEntities");
        this.wrap(client, "renderWorld", "client.renderWorld");
        // Socket messages are parsed as they arrive, between frames.
        const ws = client.ws;
        if (ws && typeof ws.onmessage === "function") {
            const onmessage = ws.onmessage;
            const probe = this;
            ws.onmessage = function(message) {
                const t0 = performance.now();
                try {
                    return onmessage.call(this, message);
                } finally{
                    probe.add("net.onmessage", performance.now() - t0);
                    probe.count("net.messages");
                    probe.count("net.KB", Math.round((typeof message.data === "string" ? message.data.length : 0) / 1024));
                }
            };
            this.restorers.push(()=>{
                if (ws.onmessage !== onmessage) ws.onmessage = onmessage;
            });
        }
        const renderer = client.clientGameLogic?.clientRenderer;
        if (!renderer) return;
        this.wrap(renderer, "render", "renderer.render");
        this.wrap(renderer, "renderEntitiesOptimized", "renderer.entities");
        this.wrap(renderer, "updateFollowCam", "renderer.followCam");
        this.wrap(renderer.shadowRendering, "renderVisibility", "lightMask.renderVisibility");
        const entity = renderer.entity?.();
        this.wrap(entity, "render", "entity.render");
        this.wrap(entity, "update", "entity.update");
        this.wrap(entity, "beginFrame", "entity.beginFrame");
        this.wrap(entity, "endFrame", "entity.endFrame");
        this.wrap(entity, "updatePlayerOcclusionOutline", "entity.occlusionOutline");
        this.wrap(entity, "updateInteractionFocus", "entity.interactionFocus");
        // The ambient effects and overlays, whatever this build has: every `_name` field with an update().
        for (const key of Object.keys(renderer)){
            const field = renderer[key];
            if (!key.startsWith("_") || !field || typeof field !== "object") continue;
            if (typeof field.update === "function" && key !== "_map" && key !== "_entity" && key !== "_gui") this.wrap(field, "update", `fx.${key.slice(1)}`);
        }
        const overlay = renderer._worldOverlay;
        if (overlay) for (const name of [
            "animateHoldTimers",
            "animateRescueHints",
            "animateBonecallerWarnings",
            "animateDroppedItemGlints"
        ])this.wrap(overlay, name, `overlay.${name}`);
    }
    /**
     * Times a map's sun-shadow update and, when it re-cast the shadows, says why: which part of its cache key changed
     * (a storey's walls are `room:version`; the light is `x:y`), or that it was looking again for plant art still loading.
     */ wrapShadow(map, label) {
        this.wrap(map, "updateBuildingShadow", label, (_args, ms, before)=>{
            const after = map.checkedShadowVersion;
            if (after === before.version && !before.retry) return;
            const was = String(before.version ?? "").split("|"), now = String(after ?? "").split("|");
            const changed = now.map((part, i)=>part === was[i] ? undefined : `${was[i] ?? "-"} -> ${part}`).filter(Boolean);
            const why = before.retry ? "plant art retry" : before.version === undefined ? "first cast" : changed.join(", ");
            this.event(`shadow recast ${map.tilemapMetaProvider?.roomId ?? "?"} ${$4f4274c559724179$var$round(ms, 1)}ms: ${why}`);
        }, ()=>({
                version: map.checkedShadowVersion,
                retry: map.foliageRetryAt !== undefined && performance.now() >= map.foliageRetryAt
            }));
    }
    /** Notes every change to a storey's tile data -- what moves its presentation version -- and what made it. */ wrapProvider(provider) {
        if (!provider || this.wrappedProviders.has(provider)) return;
        this.wrappedProviders.add(provider);
        const room = String(provider.roomId ?? "?").slice(-12);
        for (const name of [
            "addTileAt",
            "removeTileAt",
            "updateBlockingAt",
            "setMapDeltaHealth"
        ])this.wrap(provider, name, `tiles.${name}`, (args, _ms, caller)=>{
            const [x, y] = args;
            const tile = name === "addTileAt" ? ` ${args[4]}@${args[5]}` : name === "removeTileAt" ? ` @${args[2]}` : "";
            const hp = name === "addTileAt" && args[9]?.hp !== undefined ? ` hp ${args[9].hp}/${args[9].hpMax}` : name === "setMapDeltaHealth" ? ` hp ${args[1]}/${args[2]}` : "";
            this.event(`${name} ${room} ${x?.x ?? x},${x?.y ?? y}${tile}${hp} <- ${caller}`);
        }, ()=>(new Error().stack ?? "").split("\n").slice(3, 7).map((line)=>line.trim().replace(/^at /, "").replace(/\s*\(.*$/, "")).join(" < "));
    }
    /** The other storeys' maps, drawn inside the scene render: their own shadow updates and roof overlaps. */ wrapStoreys(map) {
        const floors = map.sceneRenderer?.floors;
        if (!floors) return;
        for (const floor of floors.values()){
            const storey = floor?.map;
            if (!storey || storey === map || this.wrappedStoreys.has(storey)) continue;
            this.wrappedStoreys.add(storey);
            this.wrapProvider(storey.tilemapMetaProvider);
            this.wrapShadow(storey, "storey.updateBuildingShadow");
            this.wrap(storey, "renderTileMap", "storey.renderTileMap");
            this.wrap(storey, "renderAllLayers", "storey.renderAllLayers", (_args, ms)=>this.event(`storey full render ${$4f4274c559724179$var$round(ms, 1)}ms`));
            this.wrap(storey.roofCompositeOverlap, "rebuild", "storey.roofOverlap.rebuild", (_args, ms)=>{
                if (ms > 1) this.event(`storey roofOverlap.rebuild ${$4f4274c559724179$var$round(ms, 1)}ms`);
            });
        }
    }
    wrapMap(map) {
        this.wrappedMap = map;
        this.wrapProvider(map.tilemapMetaProvider);
        this.wrapShadow(map, "map.updateBuildingShadow");
        for (const name of [
            "renderTileMap",
            "processPendingDeltas",
            "repaintDirtyCells",
            "applyOccluderFade",
            "updateTileEffects",
            "updateLandings",
            "syncSceneComposites",
            "rebuildRoofComposites",
            "applyLadderVeils",
            "syncDownstairsVisibility",
            "updateHatches",
            "artworkSignature"
        ])this.wrap(map, name, `map.${name}`);
        this.wrap(map, "renderAllLayers", "map.renderAllLayers", (_args, ms)=>this.event(`map full render ${$4f4274c559724179$var$round(ms, 1)}ms`));
        this.wrap(map, "rerender", "map.rerender", ()=>this.event("map.rerender"));
        this.wrap(map.sceneRenderer, "render", "map.scene.render");
        this.wrap(map.roofCompositeOverlap, "sync", "map.roofOverlap.sync");
        this.wrap(map.roofCompositeOverlap, "rebuild", "map.roofOverlap.rebuild", (_args, ms)=>this.event(`roofOverlap.rebuild ${$4f4274c559724179$var$round(ms, 1)}ms`));
        this.wrap(map.storeyEdges, "sync", "map.storeyEdges.sync");
        this.wrap(map.groundRise, "tick", "map.groundRise.tick");
        this.wrap(map.water, "tick", "map.water.tick");
        this.wrap(map.rockMass, "tick", "map.rockMass.tick");
        this.wrap(map.skyManager, "updatePlayerLocation", "map.sky.updatePlayerLocation");
    }
    wrapPrototypes() {
        // A storey above the player re-blurring its picture (its snapshot went stale), vs drawing the one it kept.
        this.wrap((0, $65ff58edc75cc05c$export$a64017bf69403efb).prototype, "apply", "focus.blur");
        this.wrap((0, $65ff58edc75cc05c$export$a64017bf69403efb).prototype, "drawSnapshot", "focus.snapshot");
        // A softened shadow layer baking its blur.
        this.wrap((0, $ff77f0e96218c7e7$export$6bfce3b6985f9a3d).prototype, "bake", "softened.bake", (_args, ms)=>{
            if (ms > 0.5) this.event(`softened.bake ${$4f4274c559724179$var$round(ms, 1)}ms`);
        });
    }
}
const $4f4274c559724179$export$acffefb7cc72d617 = (app, client)=>{
    if (typeof window === "undefined") return;
    window.hitchProbe = new $4f4274c559724179$var$HitchProbe(app, client);
};




function $691ebdd330b4ed0d$export$fd79ea94fab2dcf1(bullet, dt, map) {
    if (bullet.isDead()) return false;
    if (dt <= 0) return true;
    if (bullet.crossFloorProjectile) {
        bullet.location.x += bullet.speed2.x * dt;
        bullet.location.y += bullet.speed2.y * dt;
        return true;
    }
    const result = (0, $5f3ac23de5b4365c$export$d565f58bc438286b).instance.checkout();
    try {
        bullet.applyInput(undefined, dt, bullet.speed2, result.data, (0, $cb689cfa16c444ba$export$7e89f2bfd67dd894)(map, false, false, bullet.spriteId === (0, $cb689cfa16c444ba$export$6e47733a887561b3).bow.bulletSpriteId), true);
        return !!(result.data.movedX || result.data.movedY) && !(bullet.maxDistance !== undefined && bullet.travelledDistance() > bullet.maxDistance);
    } finally{
        (0, $5f3ac23de5b4365c$export$d565f58bc438286b).instance.release(result);
    }
}




class $7b78839962f6da5d$export$c7b7134fd828a5 {
    constructor(entityTypes){
        this.entities = new (0, $cb689cfa16c444ba$export$cbcb4f84fc8dd985)();
        this.entityTypes = [];
        this.setEventListeners = new Set();
        this.removeEventListeners = new Set();
        this.nextCounter = 0;
        this.clear = ()=>{
            this.entities.clear();
            this.entitiesByType = this.initEntitiesByType();
        };
        this.initEntitiesByType = ()=>{
            return this.entityTypes.reduce((acc, next)=>{
                const players = new (0, $cb689cfa16c444ba$export$cbcb4f84fc8dd985)();
                return {
                    ...acc,
                    [next]: players
                };
            }, {});
        };
        this.size = (entityType, predicate)=>{
            if (entityType) {
                const set = this.entitiesByType[entityType];
                if (!predicate) return set.size();
                return set.filter(predicate).length;
            }
            if (!predicate) return this.entities.size();
            else return this.entities.filter(predicate).length;
        };
        this.get = (entityId)=>{
            if (!entityId) return undefined;
            return this.entities.get(entityId);
        };
        this.contains = (entityId, entityType)=>{
            if (!entityType) return !!this.get(entityId);
            return !!this.entitiesByType[entityType]?.get(entityId);
        };
        this.getAtIdx = (idx, entityType)=>{
            if (entityType) return this.entitiesByType[entityType].getAtIdx(idx);
            return this.entities.getAtIdx(idx);
        };
        this.set = (entity, unshift, context)=>{
            const existed = this.entities.has(entity.entityId);
            this.entities.set(entity.entityId, entity, unshift);
            this.entitiesByType[entity.entityType].set(entity.entityId, entity, unshift);
            this.setEventListeners.forEach((next)=>next(entity, context, existed));
            entity.lastUpdateTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
        };
        this.remove = (entityId, context)=>{
            // remove it from all types
            this.entityTypes.forEach((next)=>this.entitiesByType[next].remove(entityId));
            const entity = this.entities.remove(entityId);
            if (entity) this.removeEventListeners.forEach((next)=>next(entity, context));
        };
        this.count = (entityType)=>this.entitiesByType?.[entityType]?.size() || 0;
        this.iterate = (entityType, visitor, predicate)=>{
            if (entityType) {
                if (Array.isArray(entityType)) entityType.forEach((nextType)=>this.entitiesByType[nextType]?.iterate(visitor, predicate));
                else this.entitiesByType[entityType]?.iterate(visitor, predicate);
            } else this.entities.iterate(visitor, predicate);
        };
        this.next = ()=>{
            this.nextCounter++;
            if (this.nextCounter > this.entities.size()) this.nextCounter = 0;
            // console.log(this.nextCounter)
            return this.getAtIdx(this.nextCounter);
        };
        this.collect = (predicate)=>this.entities.collect(predicate);
        this.find = (predicate, entityType)=>{
            if (entityType) return this.entitiesByType[entityType]?.find(predicate);
            return this.entities.find(predicate);
        };
        this.registerSetListener = (listener)=>{
            this.setEventListeners.add(listener);
        };
        this.unregisterSetListener = (listener)=>{
            this.setEventListeners.delete(listener);
        };
        this.registerRemoveListener = (listener)=>{
            this.removeEventListeners.add(listener);
        };
        this.unregisterRemoveListener = (listener)=>{
            this.removeEventListeners.delete(listener);
        };
        this.entityTypes = entityTypes;
        this.entitiesByType = this.initEntitiesByType();
    }
}


const $30c0c3cc99c65923$export$5f2cb0f098ee5881 = (fromRoomId, from, toRoomId, to)=>{
    if (!fromRoomId || fromRoomId === toRoomId || !from?.groundRoomId || from.groundRoomId !== to?.groundRoomId) return false;
    const rooms = (house)=>house.floorRoomIds ?? [
            house.groundRoomId,
            house.upperRoomId
        ];
    return rooms(from).includes(fromRoomId) && rooms(from).includes(toRoomId) && rooms(to).includes(fromRoomId) && rooms(to).includes(toRoomId);
};






const $2a9143f8f6144bf2$var$cellKey = (x, y)=>`${x},${y}`;
const $2a9143f8f6144bf2$var$indexes = new WeakMap();
const $2a9143f8f6144bf2$export$b0aa76c0958f55ce = (rects, feet)=>{
    if (!rects) return true;
    let index = $2a9143f8f6144bf2$var$indexes.get(rects);
    if (!index) {
        index = new Map(rects.map((rect)=>[
                $2a9143f8f6144bf2$var$cellKey(Math.floor(rect.left / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.floor(rect.top / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))),
                rect
            ]));
        $2a9143f8f6144bf2$var$indexes.set(rects, index);
    }
    const rect = index.get($2a9143f8f6144bf2$var$cellKey(Math.floor(feet.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.floor(feet.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))));
    return !!rect && feet.x >= rect.left && feet.x < rect.right && feet.y >= rect.top && feet.y < rect.bottom;
};
const $2a9143f8f6144bf2$export$79c9eb92e591a971 = (roof, walls)=>{
    if (!roof.length || !walls.length) return undefined;
    const bounds = new Map(roof.map(({ x: x, y: y })=>[
            $2a9143f8f6144bf2$var$cellKey(x, y),
            {
                left: x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                right: (x + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                top: y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                bottom: (y + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            }
        ]));
    const wallByCell = new Map(walls.map((wall)=>[
            $2a9143f8f6144bf2$var$cellKey(wall.x, wall.y),
            wall
        ]));
    let trimmed = false;
    for (const side of [
        "north",
        "south",
        "west",
        "east"
    ]){
        const horizontal = side === "north" || side === "south";
        const outward = side === "north" || side === "west" ? -1 : 1;
        const groups = new Map();
        for (const cell of roof){
            if (bounds.has($2a9143f8f6144bf2$var$cellKey(cell.x + (horizontal ? 0 : outward), cell.y + (horizontal ? outward : 0)))) continue;
            const row = horizontal ? cell.y : cell.x;
            const group = groups.get(row) ?? [];
            group.push(cell);
            groups.set(row, group);
        }
        const along = (cell)=>horizontal ? cell.x : cell.y;
        for (const group of groups.values()){
            group.sort((a, b)=>along(a) - along(b));
            const runs = [];
            for (const cell of group){
                const last = runs[runs.length - 1];
                if (last && along(cell) === along(last[last.length - 1]) + 1) last.push(cell);
                else runs.push([
                    cell
                ]);
            }
            for (const run of runs){
                const posts = run.map((cell)=>wallByCell.get($2a9143f8f6144bf2$var$cellKey(cell.x, cell.y)));
                const guides = posts.map((post)=>post?.profiles.find((rect)=>horizontal ? rect.width > rect.height : rect.height > rect.width));
                // Nearest posts/guides on each side, found in linear passes.
                const leftPosts = [], rightPosts = [], leftGuides = [], rightGuides = [];
                let post = -1, guide = -1;
                for(let i = 0; i < run.length; i++){
                    if (posts[i]) post = i;
                    if (guides[i]) guide = i;
                    leftPosts[i] = post;
                    leftGuides[i] = guide;
                }
                post = guide = -1;
                for(let i = run.length - 1; i >= 0; i--){
                    if (posts[i]) post = i;
                    if (guides[i]) guide = i;
                    rightPosts[i] = post;
                    rightGuides[i] = guide;
                }
                for(let i = 0; i < run.length; i++){
                    // An open end has no implied doorway boundary.
                    if (!posts[i] && (leftPosts[i] < 0 || rightPosts[i] < 0)) continue;
                    const left = leftGuides[i], right = rightGuides[i];
                    const nearest = left < 0 ? right : right < 0 || i - left <= right - i ? left : right;
                    let profile = nearest < 0 ? undefined : guides[nearest];
                    if (!profile) {
                        profile = (posts[i] ?? posts[leftPosts[i]])?.profiles[0];
                        if (!profile) continue;
                        // A corner end post has no run-facing profile; its actual
                        // thickness supplies the short perpendicular wall line.
                        const thickness = Math.min(profile.width, profile.height);
                        profile = {
                            ...profile,
                            width: horizontal ? profile.width : thickness,
                            height: horizontal ? thickness : profile.height
                        };
                    }
                    const cell = run[i];
                    const base = (horizontal ? cell.y : cell.x) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                    const low = base + (horizontal ? profile.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763) : profile.x);
                    const high = low + (horizontal ? profile.height : profile.width);
                    const boundary = outward < 0 ? high : low;
                    // The feet offset can carry a north boundary into the next
                    // tile. Trim that tile too, stopping once the line is passed.
                    for(let step = 0;; step++){
                        const x = cell.x - (horizontal ? 0 : outward * step);
                        const y = cell.y - (horizontal ? outward * step : 0);
                        const rect = bounds.get($2a9143f8f6144bf2$var$cellKey(x, y));
                        if (!rect) break;
                        const near = horizontal ? outward < 0 ? rect.top : rect.bottom : outward < 0 ? rect.left : rect.right;
                        if (outward < 0 ? near >= boundary : near <= boundary) break;
                        if (side === "north") rect.top = Math.max(rect.top, boundary);
                        if (side === "south") rect.bottom = Math.min(rect.bottom, boundary);
                        if (side === "west") rect.left = Math.max(rect.left, boundary);
                        if (side === "east") rect.right = Math.min(rect.right, boundary);
                        trimmed = true;
                    }
                }
            }
        }
    }
    return trimmed ? [
        ...bounds.values()
    ].filter((rect)=>rect.left < rect.right && rect.top < rect.bottom) : undefined;
};


const $2751e0027a1b432f$export$d3423e7ce2638637 = (at)=>`${at.x},${at.y}`;
const $2751e0027a1b432f$export$149797a16feb3a10 = (house)=>{
    if (house.roofCells) return house.roofCells;
    // Earlier prototype camps only recorded the floor footprint. Include a southern eave
    // so the raised roof's bottom tiles reach the top of the front wall.
    const cells = new Map(house.floorCells.map((cell)=>[
            $2751e0027a1b432f$export$d3423e7ce2638637(cell),
            cell
        ]));
    house.floorCells.forEach(({ x: x, y: y })=>cells.set(`${x},${y + 1}`, {
            x: x,
            y: y + 1
        }));
    return [
        ...cells.values()
    ];
};
const $2751e0027a1b432f$export$2c01c05cc2cc0271 = (house, at)=>{
    const x = Math.floor(at.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    const feetY = Math.floor((at.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763)) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    // The ground anchor needs a covered tile and the interior side of its walls.
    // Derived per-tile bounds already include the roof-coverage requirement.
    if (house.interiorRects) return (0, $2a9143f8f6144bf2$export$b0aa76c0958f55ce)(house.interiorRects, {
        x: at.x,
        y: at.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763)
    });
    return house.interiorCells.some((cell)=>cell.x === x && cell.y === feetY);
};
const $2751e0027a1b432f$export$aee6c94735f39f8f = (house)=>house.stairs ?? (house.upperRoomId ? [
        {
            coordinate: house.stair,
            landing: house.landing,
            label: house.floor === 0 ? "UP" : "DOWN"
        }
    ] : []);
const $2751e0027a1b432f$export$bec9e2f2535fb41 = (house)=>!!house && (house.roofCells !== undefined ? house.roofCells.length > 0 : house.floor === 0 || !!house.floorRoomIds?.[house.floor + 1]);
const $2751e0027a1b432f$export$85b5342340fc2d92 = (house, at)=>Math.floor(at.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) === house.stair.x && Math.floor(at.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) === house.stair.y;
const $2751e0027a1b432f$export$926470d6e4a2beb5 = (house, x, y)=>house.wallCells.some((cell)=>cell.x === x && cell.y === y);
const $2751e0027a1b432f$export$bf857c33d43aab9d = (active, at)=>active.floor > 0 || !$2751e0027a1b432f$export$2c01c05cc2cc0271(active, at);
let $2751e0027a1b432f$export$de62489b685ceb = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
const $2751e0027a1b432f$export$ce555363cb8c17cc = (rise)=>{
    if (Number.isFinite(rise)) $2751e0027a1b432f$export$de62489b685ceb = Math.round(rise);
};
let $2751e0027a1b432f$export$42b4af315a0c8aa1 = 36;
const $2751e0027a1b432f$export$f4b3b3d0fcdde576 = (uplift)=>{
    if (Number.isFinite(uplift)) $2751e0027a1b432f$export$42b4af315a0c8aa1 = Math.round(uplift);
};
const $2751e0027a1b432f$export$815ba2e910747d11 = (house)=>Math.max(0, house.floor) * house.rise * $2751e0027a1b432f$export$de62489b685ceb;
const $2751e0027a1b432f$export$9f4b491aa2a94a16 = (active, companion)=>$2751e0027a1b432f$export$815ba2e910747d11(active) - $2751e0027a1b432f$export$815ba2e910747d11(companion);
const $2751e0027a1b432f$export$5b9b003c5dc616cd = (_house, _viewFloor)=>-$2751e0027a1b432f$export$42b4af315a0c8aa1;








const $66e35324756c76b6$export$b4792961ac683a30 = (weapon, originLocation, originMovement)=>{
    const characteristics = (0, $cb689cfa16c444ba$export$6e47733a887561b3)[weapon?.weaponType || "none"];
    if (!characteristics) return [];
    const originLocationToUse = {
        ...originLocation
    };
    if (characteristics.muzzleFireOffset) {
        const speed2X = characteristics.muzzleFireOffset * Math.cos(originMovement.angle);
        const speed2Y = characteristics.muzzleFireOffset * Math.sin(originMovement.angle);
        originLocationToUse.x += speed2X;
        originLocationToUse.y += speed2Y;
    }
    if (characteristics.maxParticles === 1) {
        const bullet = $66e35324756c76b6$export$2f6172ad7e10238b(weapon, originLocationToUse, originMovement);
        bullet.spriteId = characteristics.bulletSpriteId;
        bullet.flags.originWeaponType = weapon?.weaponType || "none";
        return bullet ? [
            bullet
        ] : [];
    }
    const bullets = [];
    const originAngle = originMovement.angle;
    const bulletBatch = (0, $a80d0b17b615d6f7$export$5e699d18035b41af)();
    const particles = characteristics.maxParticles;
    for(let i = -(particles / 2); i < particles - particles / 2; i++){
        let degrees = (0, $a80d0b17b615d6f7$export$32b1497b7aadef08)(originAngle) + 15 + i * 30;
        const bullet = $66e35324756c76b6$export$2f6172ad7e10238b(weapon, originLocationToUse, {
            ...originMovement,
            angle: (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)(degrees)
        });
        if (bullet) {
            bullet.flags.originWeaponType = weapon?.weaponType || "none";
            bullet.spriteId = characteristics.bulletSpriteId;
            bullet.context = {
                bullet: {
                    batchId: bulletBatch
                }
            };
            bullets.push(bullet);
        }
    }
    return bullets;
};
const $66e35324756c76b6$export$2f6172ad7e10238b = (weapon, originLocation, originMovement)=>{
    if (!originLocation || !originMovement) return;
    const characteristics = (0, $cb689cfa16c444ba$export$6e47733a887561b3)[weapon?.weaponType || "none"];
    if (!characteristics) return;
    // Cardinal headings must have a truly stationary perpendicular axis. Floating-point
    // cos(PI / 2) otherwise triggers a sideways wall probe while the arrow moves south.
    const cos = Math.cos(originMovement.angle), sin = Math.sin(originMovement.angle);
    const dx = Math.abs(cos) < 1e-10 ? 0 : cos;
    const dy = Math.abs(sin) < 1e-10 ? 0 : sin;
    const bullet = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
    bullet.maxDistance = characteristics.maxDistance;
    bullet.entityType = "bullet";
    bullet.origin = {
        x: originLocation.x + dx,
        y: originLocation.y + dy
    };
    bullet.location = {
        x: bullet.origin?.x,
        y: bullet.origin?.y
    };
    bullet.movement = {
        ...originMovement
    };
    bullet.dimensions = characteristics.collisionDimensions || {
        ...(0, $cb689cfa16c444ba$export$5b5223867019c37b)[bullet.entityType]
    };
    bullet.speed = characteristics.bulletSpeed;
    bullet.speed2.x = dx * characteristics.bulletSpeed;
    bullet.speed2.y = dy * characteristics.bulletSpeed;
    bullet.roomId = originLocation.roomId;
    bullet.flags = {};
    return bullet;
};






// Floor silhouettes in floors.png (wood rows 0-2; stone and cobble repeat them at +96 and +192). Each row describes the west, centre,
// and east bands (0..12, 12..20, 20..32); rows use the same north/south bands.
// Retain the corner cutouts too: a bounding rectangle would still support air.
const $1bd658348d22f69a$var$woodenFloorBands = {
    0: [
        0,
        3,
        3
    ],
    1: [
        0,
        7,
        7
    ],
    2: [
        0,
        6,
        6
    ],
    3: [
        7,
        7,
        6
    ],
    4: [
        7,
        7,
        3
    ],
    5: [
        0,
        3,
        2
    ],
    6: [
        0,
        7,
        0
    ],
    7: [
        0,
        6,
        2
    ],
    9: [
        2,
        7,
        7
    ],
    32: [
        3,
        3,
        3
    ],
    33: [
        7,
        7,
        7
    ],
    34: [
        6,
        6,
        6
    ],
    35: [
        6,
        7,
        7
    ],
    36: [
        3,
        7,
        7
    ],
    37: [
        2,
        2,
        2
    ],
    38: [
        0,
        2,
        0
    ],
    39: [
        2,
        2,
        0
    ],
    40: [
        3,
        7,
        3
    ],
    41: [
        7,
        7,
        7
    ],
    42: [
        6,
        7,
        6
    ],
    64: [
        3,
        3,
        0
    ],
    65: [
        7,
        7,
        0
    ],
    66: [
        6,
        6,
        0
    ],
    67: [
        0,
        3,
        0
    ],
    68: [
        0,
        6,
        0
    ],
    69: [
        2,
        3,
        0
    ],
    70: [
        2,
        6,
        0
    ],
    71: [
        0,
        2,
        2
    ],
    73: [
        7,
        7,
        2
    ]
};
const $1bd658348d22f69a$export$18e4de71c2fdcd7c = (tilesetId, position, x, y)=>{
    // Every floor material in the sheet reuses the wood's silhouettes, a block of three rows (96 cells) apart.
    const bands = tilesetId === "floors" ? $1bd658348d22f69a$var$woodenFloorBands[position % 96] : undefined;
    if (!bands) return true;
    const row = y < 12 ? 0 : y < 20 ? 1 : 2;
    const bit = x < 12 ? 4 : x < 20 ? 2 : 1;
    return (bands[row] & bit) !== 0;
};





const $38e3841ccf0130e3$export$1d98526e3ed2ebf7 = (tilesetId, id)=>`${tilesetId}#${id}`;
const $38e3841ccf0130e3$export$6eb5ff9343d6a08a = (tilesetId, tiles = [])=>{
    const meta = {};
    tiles.forEach((tile)=>{
        const tileId = tile.id + 1;
        let tileMeta = meta[tileId];
        if (!tileMeta) {
            tileMeta = (0, $cb689cfa16c444ba$export$403e7832f3d01519)();
            meta[tileId] = tileMeta;
        }
        (tile.properties || []).forEach((p)=>{
            if (p.name === "blockingRects") tileMeta.blockingRects = (0, $5ff29e9b920ad43b$export$b3c6c04580b0bd54)(JSON.parse(p.value));
            if (p.name === "blocking" && p.value === true) tileMeta.tileTypes.push("blocking");
            if (p.name === "deep" && p.value === true) tileMeta.tileTypes.push("deep");
            if (p.name === "lava" && p.value === true) tileMeta.tileTypes.push("lava");
            if (p.name === "floor" && p.value === true) tileMeta.tileTypes.push("floor");
            if (p.name === "compositeTileId" && !!p.value) {
                tileMeta.tileTypes.push("hidden");
                tileMeta.compositeTileId = p.value;
            }
            if (p.name === "compositeTileIdParent") {
                tileMeta.compositeTileId = p.value || $38e3841ccf0130e3$export$1d98526e3ed2ebf7(tilesetId, tile.id);
                tileMeta.compositeTileParent = true;
            }
            if (p.name === "breakageMeta" && !!p.value) tileMeta.breakageMeta = JSON.parse(p.value);
            if (p.name === "compositeTileDense" && p.value === true) {
                tileMeta.compositeTileParent = true;
                tileMeta.tileTypes.push("dense");
            }
            if (p.name === "densityStrategy" && !!p.value) tileMeta.tileTypes.push(p.value);
            if (p.name === "variant" && !!p.value) tileMeta.variant = p.value;
            if (p.name === "malleable" && p.value === true) {
                tileMeta.malleable = true;
                tileMeta.tileTypes.push("entityTile");
            }
            if (p.name === "spriteId" && !!p.value) tileMeta.spriteId = p.value;
            if (p.name === "entityTileId" && !!p.value) {
                tileMeta.entityTileId = p.value;
                tileMeta.tileTypes.push("entityTile");
            }
            if (p.name === "renderZIdxOffset" && !!p.value) tileMeta.renderZIdxOffset = Number(p.value);
            if (p.name === "renderYOffset" && !!p.value) tileMeta.renderYOffset = Number(p.value);
            if (p.name === "renderXOffset" && !!p.value) tileMeta.renderXOffset = Number(p.value);
            if (p.name === "denseCopies" && Number(p.value) > 0) tileMeta.denseCopies = Math.round(Number(p.value));
            if (p.name === "castsShadow" && p.value === true) tileMeta.castsShadow = true;
        });
    });
    return meta;
};





class $dec24d361621cd9a$export$8456fdc59dbd1ef9 extends (0, $bc8613e262b54793$export$72650553bea9c295) {
    static{
        this.instance = new $dec24d361621cd9a$export$8456fdc59dbd1ef9();
    }
    constructor(size = 1000){
        super(size);
    }
    create() {
        return {
            free: true,
            data: []
        };
    }
    clear(item) {
        item.data.length = 0;
    }
    // Convenience method to get a fresh array
    checkoutArray() {
        return this.checkout();
    }
}





/**
 * Which tiles are pieces of a WOODEN wall, and which piece, as the content's tilesets say: a tile
 * whose `woodenWall` property is 0-12 is a base piece (see woodenWallFootprint for what each one
 * blocks), 13 a cap. A wooden wall blocks only a strip of ground under its raised face, so bodies
 * can walk up beneath it; any other blocking wall tile blocks its whole cell. Being tile metadata, a
 * wall material drawn on new art keeps those footprints by marking its tiles, with no code change.
 */ let $c3e6e81239a7bc85$var$pieces = new Map();
const $c3e6e81239a7bc85$export$25e940756fc50f5 = (mapTilesets)=>{
    const out = new Map();
    Object.entries(mapTilesets || {}).forEach(([tilesetId, tileset])=>{
        (tileset?.tiles || []).forEach((tile)=>(tile.properties || []).forEach((p)=>{
                if (p.name !== "woodenWall" || !Number.isInteger(Number(p.value))) return;
                if (!out.has(tilesetId)) out.set(tilesetId, new Map());
                out.get(tilesetId).set(tile.id, Number(p.value));
            }));
    });
    return out;
};
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>$c3e6e81239a7bc85$export$25e940756fc50f5(catalog.mapTilesets), (next)=>{
    $c3e6e81239a7bc85$var$pieces = next;
});
const $c3e6e81239a7bc85$export$59bd1dfb16da1c8a = (tilesetId, position)=>$c3e6e81239a7bc85$var$pieces.get(tilesetId)?.get(position) ?? -1;



class $93a024e1e74df758$export$c8df09a865c1d736 {
    get twoStoreyHouse() {
        const house = this.tilemaps.twoStoreyHouse;
        // Upgrade already-running rooms and saved/received snapshots too. Changing
        // room creation alone leaves the old two-tile lift on existing buildings.
        if (house?.rise === 2) {
            house.rise = 1;
            this.housePresentationVersion = undefined;
        }
        return house;
    }
    set twoStoreyHouse(house) {
        this.tilemaps.twoStoreyHouse = house;
        this.touchTileTypes();
    }
    constructor(roomId, tilesets, tileMapDirectory, worldMetaDimensions, // Each room pins its current collision metadata; activation of existing rooms is separate.
    collisionOverrides = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.maps.collisionOverrides){
        this.collisionOverrides = collisionOverrides;
        this.lastEditedTs = 0;
        this.collisionVersion = 0;
        this.presentationVersion = 0;
        this.getPresentationVersion = ()=>this.presentationVersion;
        this.removalVersion = 0;
        this.getRemovalVersion = ()=>this.removalVersion;
        this.setUpperFloorProvider = (provider)=>{
            if (this.upperFloorProvider === provider) return;
            this.upperFloorProvider = provider;
            this.housePresentationVersion = undefined;
        };
        this./**
     * Whether the storey above stands on this cell: its floor (not an opening) is drawn over this
     * storey's roof there, so that roof piece is a ceiling no one sees. It still counts as a roof:
     * floor support, enclosure and the cutaway are unchanged.
     */ isRoofCoveredAt = (x, y)=>{
            const upper = this.upperFloorProvider;
            if (!upper) return false;
            const floor = upper.resolveTileMapFromLayerId("map2")?.[x]?.[y];
            return !!floor && floor !== "0" && !upper.isFloorOpeningAt(x, y);
        };
        this.getUpperFloorProvider = ()=>this.upperFloorProvider;
        this./**
     * The material of the built wall standing on cell (x, y) of this room: the item of the piece drawn
     * on the cell itself (its base, stamped with the cell as its parent). Undefined: no wall stands there.
     */ wallItemAt = (x, y)=>{
            const delta = this.getMapDeltaAt(x, y, "sprite");
            const parent = delta?.context?.parent;
            if (!delta || delta.removed || delta.context?.previewTarget || parent?.x !== x || parent?.y !== y) return undefined;
            const itemType = delta.context?.itemType;
            return (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemType]?.buildType === "wall" ? itemType : undefined;
        };
        this./** Changes whenever the storey above is edited, or another room becomes the storey above. */ getUpperFloorVersion = ()=>this.upperFloorProvider ? `${this.upperFloorProvider.roomId}:${this.upperFloorProvider.getPresentationVersion()}` : undefined;
        this.getFloorSupportProvider = ()=>this.floorSupportProvider;
        this.setFloorSupportProvider = (provider)=>{
            if (this.floorSupportProvider === provider) return;
            this.floorSupportProvider = provider;
            this.floorSupportVersion = provider?.getPresentationVersion();
            this.touchTileTypes();
        };
        this./** Openings are passable so an entity can enter them and fall, rather than hitting a void wall. */ isFloorOpeningAt = (x, y)=>{
            const tile = this.resolveTileMapFromLayerId("sprite2")?.[x]?.[y];
            return !!tile && tile !== "0" && this.resolveTileMeta(tile).entityTileId === "floor-opening";
        };
        this./** Both stair directions supply a standing surface even without a roof or floor. */ isStairAt = (x, y)=>{
            const tile = this.resolveTileMapFromLayerId("sprite2")?.[x]?.[y];
            if (!tile || tile === "0") return false;
            const type = this.resolveTileMeta(tile).entityTileId;
            return type === "stairs-up" || type === "stairs-down";
        };
        this.isUnsupportedFloorAt = (x, y)=>{
            if (!this.twoStoreyHouse || this.twoStoreyHouse.floor <= 0 || this.isFloorOpeningAt(x, y) || this.isStairAt(x, y)) return false;
            const tile = this.resolveTileMapFromLayerId("map2")?.[x]?.[y];
            if (tile && tile !== "0") return false;
            // A roof is the walking surface of the immediately higher room. Never borrow
            // a roof several storeys below: it sits at a different height.
            const roof = this.floorSupportProvider?.resolveTileMapFromLayerId("sky")?.[x]?.[y];
            return !roof || roof === "0";
        };
        this./** Test the soles against the walking surfaces at their rendered heights. */ isUnsupportedFloorAtPosition = (feet)=>{
            const house = this.twoStoreyHouse;
            if (!house || house.floor <= 0) return false;
            const x = Math.floor(feet.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), y = Math.floor(feet.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            if (this.isStairAt(x, Math.floor((feet.y - (0, $9667a1379a787b5e$export$5985b04c8e71b763)) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)))) return false;
            const floor = this.resolveTileMapFromLayerId("map2")?.[x]?.[y];
            if (floor && floor !== "0" && !this.isFloorOpeningAt(x, y) && (this.floorArtSupportsAt(floor, feet.x - x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), feet.y - y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) || this.floorBeyondRim(x, y, feet.x - x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), feet.y - y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)))) return false;
            const below = this.floorSupportProvider;
            // Placement previews have a support provider before the lower room has
            // joined a floor stack. Its roof still belongs exactly one storey below.
            const lowerHouse = below?.twoStoreyHouse ?? {
                ...house,
                floor: house.floor - 1
            };
            const offset = below ? (0, $2751e0027a1b432f$export$9f4b491aa2a94a16)(house, lowerHouse) + (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)(lowerHouse) : 0;
            const roofY = Math.floor((feet.y - offset) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            const roof = below?.resolveTileMapFromLayerId("sky")?.[x]?.[roofY];
            return !roof || roof === "0" || !below.floorArtSupportsAt(roof, feet.x - x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), feet.y - offset - roofY * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
        };
        this.floorBeyondRim = (x, y, px, py)=>{
            const dx = px < 12 ? -1 : px >= 20 ? 1 : 0, dy = py < 12 ? -1 : py >= 20 ? 1 : 0;
            if (!dx && !dy) return false;
            const floored = (cx, cy)=>{
                const tile = this.resolveTileMapFromLayerId("map2")?.[cx]?.[cy];
                return !!tile && tile !== "0" && !this.isFloorOpeningAt(cx, cy);
            };
            return (!dx || floored(x + dx, y)) && (!dy || floored(x, y + dy)) && (!dx || !dy || floored(x + dx, y + dy));
        };
        this.floorArtSupportsAt = (tile, x, y)=>{
            const art = this.artPosition(tile);
            return !art || (0, $1bd658348d22f69a$export$18e4de71c2fdcd7c)(art.tilesetId, art.position, x, y);
        };
        this.footprintVersion = -1;
        this.footprints = new Map();
        this.removeEventListeners = new Set();
        this.addEventListeners = new Set();
        this./** Derive the rendered building from live layers, independently of its original plot.
     * Metadata retains room links/stairs; geometry is cached only until the next tile edit. */ getHousePresentation = ()=>{
            const house = this.twoStoreyHouse;
            if (!house) return undefined;
            const upperFloors = [];
            const visited = new Set([
                this
            ]);
            for(let upper = this.upperFloorProvider; upper && !visited.has(upper); upper = upper.upperFloorProvider){
                visited.add(upper);
                upperFloors.push(upper);
            }
            const version = `${this.presentationVersion}:${this.getCollisionVersion()}:${this.floorSupportProvider?.getPresentationVersion()}:` + upperFloors.map((upper)=>`${upper.roomId}:${upper.getPresentationVersion()}`).join(":");
            if (this.housePresentationSource === house && this.housePresentationVersion === version) return this.housePresentation;
            const cellsIn = (layer)=>{
                const cells = [];
                this.resolveTileMapFromLayerId(layer)?.forEach((column, x)=>column.forEach((tile, y)=>{
                        if (tile && tile !== "0") cells.push({
                            x: x,
                            y: y
                        });
                    }));
                return cells;
            };
            const floorCells = cellsIn("map2");
            const liveRoof = cellsIn("sky");
            // Pre-roof prototype saves have no authored sky at all. Retain their visual
            // reconstruction until the builder writes roof tiles (including removals).
            const legacyRoof = house.roofCells === undefined && !liveRoof.length && !Object.keys(this.tilemaps.deltas?.sky || {}).length;
            const roofCells = legacyRoof ? (0, $2751e0027a1b432f$export$149797a16feb3a10)(house) : liveRoof;
            // A ceiling may belong to any higher room, including its floor. Combine live
            // coverage for enclosure without inventing roof artwork in the active room.
            const overhead = new Map(roofCells.map((cell)=>[
                    (0, $2751e0027a1b432f$export$d3423e7ce2638637)(cell),
                    cell
                ]));
            upperFloors.forEach((upper)=>[
                    "map2",
                    "sky"
                ].forEach((layer)=>upper.resolveTileMapFromLayerId(layer)?.forEach((column, x)=>column.forEach((tile, y)=>{
                            if (tile && tile !== "0") overhead.set(`${x},${y}`, {
                                x: x,
                                y: y
                            });
                        }))));
            const wallCells = cellsIn("sprite").filter(({ x: x, y: y })=>{
                const delta = this.getMapDeltaAt(x, y, "sprite");
                const parent = delta?.context?.parent;
                if (parent && (parent.x !== x || parent.y !== y) && !delta.blocking) return false;
                return (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[delta?.context?.itemType]?.buildType === "wall" || this.woodAt(x, y) >= 0;
            });
            // Roof cells retain overhead coverage; fine wall boundaries distinguish
            // exterior portions of those cells from the building's interior.
            const interiorCells = [
                ...overhead.values()
            ];
            const interiorRects = (0, $2a9143f8f6144bf2$export$79c9eb92e591a971)(interiorCells, this.roofWalls(wallCells));
            const footprint = [
                ...floorCells,
                ...wallCells,
                ...roofCells
            ];
            const extent = footprint.reduce((box, { x: x, y: y })=>({
                    left: Math.min(box.left, x),
                    top: Math.min(box.top, y),
                    right: Math.max(box.right, x),
                    bottom: Math.max(box.bottom, y)
                }), {
                left: Infinity,
                top: Infinity,
                right: -Infinity,
                bottom: -Infinity
            });
            this.housePresentation = {
                ...house,
                ...footprint.length ? {
                    left: extent.left,
                    top: extent.top,
                    width: extent.right - extent.left + 1,
                    depth: extent.bottom - extent.top + 1
                } : {},
                floorCells: floorCells,
                wallCells: wallCells,
                roofCells: roofCells,
                interiorCells: interiorCells,
                interiorRects: interiorRects
            };
            this.housePresentationSource = house;
            this.housePresentationVersion = version;
            return this.housePresentation;
        };
        this.compositeTileMetaLookup = {};
        this.tilesetsById = {};
        this.authoredGeneration = -1;
        this.refreshAuthoredTiles = ()=>{
            const generation = (0, $e5c675b7b9585b42$export$eca3444cf0ef4f9a)();
            if (this.authoredGeneration === generation) return;
            this.authoredGeneration = generation;
            const set = this.tilesets.find((t)=>t.tilesetId === "authored-terrain");
            const data = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets["authored-terrain"];
            if (!set || !data) return;
            const additions = (0, $38e3841ccf0130e3$export$6eb5ff9343d6a08a)("authored-terrain", data.tiles);
            for (const [id, meta] of Object.entries(additions))if (!set.tiles[id]) set.tiles[id] = meta;
            this.tilesetsById[set.tilesetId] = set;
            for (const [id, meta] of Object.entries(set.tiles)){
                if (!meta.compositeTileParent || !meta.compositeTileId) continue;
                const key = `${set.tilesetId}-${meta.compositeTileId}`;
                if (!this.compositeTileMetaLookup[key]) this.compositeTileMetaLookup[key] = {
                    tileMeta: meta,
                    tileNumber: Number(id),
                    children: Object.entries(set.tiles).filter(([, child])=>child.compositeTileId === meta.compositeTileId).map(([id, child])=>({
                            tileMeta: child,
                            tileNumber: Number(id)
                        }))
                };
            }
        };
        this.resolveCompositeTileIdTileMeta = (compositeTileId, tilesetId)=>{
            this.refreshAuthoredTiles();
            return this.compositeTileMetaLookup[`${tilesetId}-${compositeTileId}`];
        };
        this.getTilesetById = (tilesetId)=>{
            this.refreshAuthoredTiles();
            return this.tilesetsById[tilesetId];
        };
        this.resolveTileSet = (tileId)=>{
            this.refreshAuthoredTiles();
            // tileId: 505
            // tileset 3: gid 1025
            //  505 >= 1025 ? no
            // tileset 2: gid 500
            //  505 >= 500 ? yes
            // ====== tileset 2
            // tileset 1: gid 1
            // tileId: 305
            // tileset 3: gid 1025
            //  305 >= 1025 ? no
            // tileset 2: gid 500
            //  305 >= 500 ? no
            // tileset 1: gid 1
            //  305 >= 1 ? no
            // ... must be first one, since we couldn't resolve any
            const id = Number(tileId);
            for(let i = 0; i < this.tilesets.length; i++){
                const tileset = this.tilesets[i];
                if (id >= tileset.firstGid) return tileset;
            }
            const first = this.tilesets[this.tilesets.length - 1];
            return first;
        };
        this.resolveTileMeta = (tileId)=>{
            this.refreshAuthoredTiles();
            if (!tileId) return (0, $cb689cfa16c444ba$export$403e7832f3d01519)();
            if (tileId.includes(":")) {
                const [tilesetId, id] = tileId.split(":");
                const tileset = this.tilesets.find((t)=>t.tilesetId == tilesetId);
                if (tileset) return tileset.tiles[Number(id)] || (0, $cb689cfa16c444ba$export$403e7832f3d01519)();
            }
            const id = Number(tileId);
            const tileset = this.resolveTileSet(tileId);
            if (!tileset) return (0, $cb689cfa16c444ba$export$403e7832f3d01519)();
            const { firstGid: firstGid } = tileset;
            const tilesetMemberId = `${id - firstGid + 1}`;
            return tileset.tiles[tilesetMemberId] || (0, $cb689cfa16c444ba$export$403e7832f3d01519)();
        };
        this.resolveTilesetTileId = (tile)=>{
            const tileset = this.resolveTileSet(tile);
            const tileId = Number(tile);
            const adjustedTileId = tileId - tileset.firstGid + 1;
            return `${tileset.tilesetId}-${adjustedTileId}`;
        };
        this.toSerialiazeableMeta = ()=>{
            this.refreshAuthoredTiles();
            return {
                atlas: this.tilesets,
                tilemaps: this.tilemaps,
                minimapConfig: this.minimapConfig
            };
        };
        this.drawableTile = (tile)=>tile !== "0" && !!tile;
        this.removeableTile = (tile)=>{
            return this.resolveTileMeta(tile)?.malleable;
        };
        this.hasRemovedDelta = (x, y, tileId, layerId)=>{
            if (this.tilemaps.deltas) {
                const layerDeltas = this.tilemaps.deltas[layerId];
                if (!layerDeltas) return false;
                const delta = layerDeltas[`${x}-${y}`];
                if (!!delta?.removed && delta.tileId === tileId) return true;
            }
            return false;
        };
        this.shouldDrawTileAt = (x, y, layerId, tilemap)=>{
            const id = tilemap[x][y];
            if (!this.drawableTile(id)) return false;
            if (this.tilemaps.deltas) {
                const delta = this.getMapDeltaAt(x, y, layerId);
                if (!!delta?.removed && delta.tileId === id) return false;
            }
            return true;
        };
        this.getMapDeltas = ()=>{
            const deltas = [];
            Object.keys(this.tilemaps.deltas).forEach((layerId)=>{
                const deltaLayer = this.tilemaps.deltas[layerId];
                Object.values(deltaLayer).forEach((delta)=>{
                    deltas.push(delta);
                });
            });
            return deltas;
        };
        this.getSpriteMapDeltas = ()=>{
            const deltaArray = (0, $dec24d361621cd9a$export$8456fdc59dbd1ef9).instance.checkoutArray();
            // Iterate through all layers in the deltas
            Object.keys(this.tilemaps.deltas).forEach((layerId)=>{
                const layerMapping = this.resolveLayerMapping(layerId);
                // Only process sprite layers (sprited maptype)
                if (layerMapping?.maptype === "sprited") {
                    const layerDeltas = this.tilemaps.deltas[layerId];
                    Object.values(layerDeltas).forEach((delta)=>{
                        deltaArray.data.push(delta);
                    });
                }
            });
            return deltaArray;
        };
        this.getMapDeltaAt = (x, y, layerId)=>{
            return this.tilemaps.deltas[layerId]?.[`${x}-${y}`];
        };
        this.findMapDeltaAt = (x, y)=>{
            // Check all available layers for a map delta at the given coordinates
            const layerIds = Object.keys(this.tilemaps.deltas);
            for (const layerId of layerIds){
                const delta = this.getMapDeltaAt(x, y, layerId);
                if (delta) return delta;
            }
            return null;
        };
        this.setMapDeltas = (deltas, broadcast)=>{
            deltas.forEach((delta)=>{
                const { x: x, y: y, blocking: blocking, occlusion: occlusion, tileId: tileId, layerId: layerId, mapSpriteCap: mapSpriteCap, temporary: temporary, collideable: collideable, context: context } = delta;
                if (tileId) {
                    if (delta.removed) this.removeTileAt(x, y, delta.layerId, broadcast);
                    else this.addTileAt(x, y, blocking, occlusion, tileId, layerId, mapSpriteCap, temporary, collideable, context, broadcast);
                } else // update blocking
                this.updateBlockingAt(x, y, blocking, broadcast);
            });
        };
        this.visit = (callback)=>{
            this.layerIndexedMap.iterate((next)=>{
                if (next.layerClass.maptype === "tilemap") callback({
                    tilemap: next.tilemap,
                    layerId: next.entityId
                });
                if (next.layerClass.maptype === "sprited") callback({
                    tilemap: next.tilemap,
                    sprited: true,
                    mapSpriteCaps: this.tilemaps.mapSpriteCaps,
                    index: next.layerClass.idx + 1,
                    layerId: next.entityId
                });
            }, (n)=>n.layerClass.maptype === "tilemap" || n.layerClass.maptype === "sprited");
            if (this.tilemaps.spriteFragments?.length > 0) callback({
                spriteFragments: this.tilemaps.spriteFragments
            });
            this.layerIndexedMap.iterate((next)=>{
                callback({
                    tilemap: next.tilemap,
                    sky: true,
                    index: next.layerClass.idx + 1,
                    layerId: next.entityId
                });
            }, (n)=>n.layerClass.maptype === "sky");
        };
        this.isOcclusionAt = (x, y)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return false;
            if (!_x[y]?.has("occlusion")) return false;
            return true;
        };
        this.// Version of the tile grid as far as collision is concerned. Changes whenever any
        // tileTypesMap cell changes; does NOT change when entities move (entity obstacles are
        // applied to the A* Grid after the matrix is built, never baked into it).
        getCollisionVersion = ()=>{
            const version = this.floorSupportProvider?.getPresentationVersion();
            if (version !== this.floorSupportVersion) {
                this.floorSupportVersion = version;
                this.touchTileTypes();
            }
            return this.collisionVersion;
        };
        this.touchTileTypes = ()=>{
            this.collisionVersion++;
        };
        this.artPosition = (tile)=>{
            if (!tile || tile === "0") return undefined;
            if (tile.includes(":")) {
                const [tilesetId, position] = tile.split(":");
                return {
                    tilesetId: tilesetId,
                    position: Number(position)
                };
            }
            const tileset = this.resolveTileSet(tile);
            return tileset && {
                tilesetId: tileset.tilesetId,
                position: Number(tile) - tileset.firstGid
            };
        };
        this.woodAt = (x, y)=>{
            if (!this.tileTypesMap[x]?.[y]?.has("blocking")) return -1;
            for (const map of this.tilemaps.sprited || []){
                const art = this.artPosition(map[x]?.[y]);
                const variant = art ? (0, $c3e6e81239a7bc85$export$59bd1dfb16da1c8a)(art.tilesetId, art.position) : -1;
                if (variant >= 0) return variant;
            }
            return -1;
        };
        this./** undefined means the legacy full-cell/directional blocker. Empty means open ground.
     * Decorative caps never acquire a footprint just because their sprite is a wall. */ getTileBlockingProfile = (x, y)=>{
            if (this.isFloorOpeningAt(x, y) && !this.tileTypesMap[x]?.[y]?.has("blocking")) return [];
            // Upper-floor air and exposed edges are passable so entities can walk off and fall.
            if (!this.tileTypesMap[x]?.[y]?.has("blocking")) return this.caveCliffFootprintAt(x, y) || [];
            if (this.footprintVersion !== this.collisionVersion) {
                this.footprints.clear();
                this.footprintVersion = this.collisionVersion;
            }
            const key = y * this._width + x;
            if (!this.footprints.has(key)) this.footprints.set(key, this.computeTileBlockingProfile(x, y));
            const footprint = this.footprints.get(key);
            return footprint;
        };
        this.caveCliffFootprintAt = (x, y)=>{
            const map = this.resolveTileMapFromLayerId("map5");
            const art = this.artPosition(map?.[x]?.[y]);
            if (art?.tilesetId !== "lpc-terrain" || ![
                440,
                442
            ].includes(art.position)) return undefined;
            const parent = this.artPosition(map?.[x]?.[y - 1]);
            if (parent?.tilesetId !== "lpc-terrain") return undefined;
            const footprint = (0, $5ff29e9b920ad43b$export$8e55369286cb464)(art.position, parent.position, !!this.tileTypesMap[x]?.[y - 1]?.has("blocking"));
            if (!footprint) return undefined;
            return this.collisionOverrides[`lpc-terrain:${art.position}`] || footprint;
        };
        this.computeTileBlockingProfile = (x, y)=>{
            let independentBlocker = false;
            // A separate runtime blocker must not be thinned by a decorative wall underneath.
            for (const [layer, deltas] of Object.entries(this.tilemaps.deltas || {})){
                const delta = deltas[`${x}-${y}`];
                if (!delta?.blocking || delta.removed) continue;
                if (this.resolveTileMeta(delta.tileId).blockingRects) continue;
                const art = this.artPosition(delta.tileId);
                if (layer !== "map5" && (!art || (0, $c3e6e81239a7bc85$export$59bd1dfb16da1c8a)(art.tilesetId, art.position) < 0)) independentBlocker = true;
            }
            const authored = [];
            let unprofiledBlocker = false;
            for (const map of [
                ...this.tilemaps.tilemaps,
                ...this.tilemaps.sprited || []
            ]){
                const meta = this.resolveTileMeta(map[x]?.[y]);
                if (meta.blockingRects) authored.push(...meta.blockingRects);
                else if (meta.tileTypes.includes("blocking")) unprofiledBlocker = true;
            }
            if (authored.length) return unprofiledBlocker || independentBlocker ? [
                {
                    x: 0,
                    y: 0,
                    width: 32,
                    height: 32
                },
                ...authored
            ] : authored;
            if (independentBlocker) return undefined;
            if (this.getEntityTileAt(x, y)) return undefined;
            const variant = this.woodAt(x, y);
            if (variant >= 0) for (const map of this.tilemaps.sprited || []){
                const art = this.artPosition(map[x]?.[y]);
                const override = art && this.collisionOverrides[`${art.tilesetId}:${art.position}`];
                if (override) {
                    const northStem = [
                        1,
                        2,
                        3,
                        4,
                        12
                    ].includes(variant) && this.woodAt(x, y - 1) >= 0 ? [
                        {
                            x: 12,
                            y: 0,
                            width: 8,
                            height: 12
                        }
                    ] : [];
                    return [
                        ...override,
                        ...northStem
                    ];
                }
            }
            // At junctions the cap of the southern wall can replace the northern base's
            // atlas cell. Recover that base's ground footprint from its wall connections.
            if (variant === 13) {
                const north = this.woodAt(x, y - 1) >= 0, south = this.woodAt(x, y + 1) >= 0;
                const west = this.woodAt(x - 1, y) >= 0, east = this.woodAt(x + 1, y) >= 0;
                if (west && east) return (0, $5ff29e9b920ad43b$export$420826986f821865)(south ? 12 : 1, north);
                if (east) return (0, $5ff29e9b920ad43b$export$420826986f821865)(south ? 2 : north ? 5 : 10, north);
                if (west) return (0, $5ff29e9b920ad43b$export$420826986f821865)(south ? 3 : north ? 6 : 11, north);
                return (0, $5ff29e9b920ad43b$export$420826986f821865)(north && south ? 0 : north ? 9 : south ? 7 : 1, north);
            }
            if (variant >= 0) return (0, $5ff29e9b920ad43b$export$420826986f821865)(variant, this.woodAt(x, y - 1) >= 0);
            const art = this.artPosition(this.resolveTileMapFromLayerId("map5")?.[x]?.[y]);
            if (art?.tilesetId !== "lpc-terrain") return undefined;
            const override = this.collisionOverrides[`lpc-terrain:${art.position}`];
            if (override) return override.map((rect)=>{
                let { x: left, y: top, width: width, height: height } = rect;
                if ((0, $5ff29e9b920ad43b$export$4a8503c515ddb75).has(art.position) && left > 0 && this.isOcclusionAt(x - 1, y)) {
                    width += left;
                    left = 0;
                }
                if ((0, $5ff29e9b920ad43b$export$8af65a70f4144267).has(art.position) && left + width < 32 && this.isOcclusionAt(x + 1, y)) width = 32 - left;
                if ((0, $5ff29e9b920ad43b$export$1bb592e1e2038ca8).has(art.position) && top > 0 && this.isOcclusionAt(x, y - 1)) {
                    height += top;
                    top = 0;
                }
                return {
                    ...rect,
                    x: left,
                    y: top,
                    width: width,
                    height: height
                };
            });
            const left = (0, $5ff29e9b920ad43b$export$4a8503c515ddb75).has(art.position) && !this.isOcclusionAt(x - 1, y) ? 16 : 0;
            const right = (0, $5ff29e9b920ad43b$export$8af65a70f4144267).has(art.position) && !this.isOcclusionAt(x + 1, y) ? 16 : 0;
            // The northern face of rock forms the room's southern border. Human soles
            // sit ~9px below the body's leading collision edge on a southward approach,
            // so stop that edge 14px before the artwork's 16px inset, including 5px
            // of visual clearance. Lighting still
            // follows the drawn surface through CaveArtSetBackTop in buildPolyMap.
            const top = (0, $5ff29e9b920ad43b$export$1bb592e1e2038ca8).has(art.position) && !this.isOcclusionAt(x, y - 1) ? 2 : 0;
            if (!left && !right && !top) return undefined;
            return [
                {
                    x: left,
                    y: top,
                    width: 32 - left - right,
                    height: 32 - top
                }
            ];
        };
        this./** Tests only authored footprints, including neighboring tiles reached by a wide body. */ overlapsTileBlockingProfile = (x1, y1, x2, y2)=>{
            for(let x = Math.max(0, Math.floor(x1 / 32) - 1); x <= Math.min(this._width - 1, Math.floor(x2 / 32) + 1); x++)for(let y = Math.max(0, Math.floor(y1 / 32) - 1); y <= Math.min(this._height - 1, Math.floor(y2 / 32) + 1); y++){
                const profile = this.getTileBlockingProfile(x, y);
                if (profile?.some((rect)=>(0, $5ff29e9b920ad43b$export$9a7c8908712261a1)(x1 - x * 32, y1 - y * 32, x2 - x * 32, y2 - y * 32, rect))) return true;
            }
            return false;
        };
        this.isCollisionAt = (x, y, approacherFineX, approacherFineY, direction)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return false;
            if (!_x[y]?.has("blocking")) return !!this.caveCliffFootprintAt(x, y);
            // there is blocking
            // if there is no approach specified, then we're blocked no matter what
            if (approacherFineX === undefined || approacherFineY === undefined) return true;
            // special inspection
            const allowed = this.tileBlockingAllowed[x]?.[y];
            const notAllowed = this.tileBlockingNotAllowed[x]?.[y];
            if (!allowed?.size) return true;
            const blockedLeft = (()=>{
                const xFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(x);
                const yFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(y);
                const diff = xFine - approacherFineX;
                const dist = Math.abs(diff);
                if (allowed.has("Left")) {
                    if (direction === "Left") {
                        // console.log("dist", dist, Date.now())
                        if (dist < 20) return true;
                        else return false;
                    } else if (direction === "Right") {
                        if (diff > 0) return true;
                        else return false;
                    }
                }
                if (notAllowed?.has("Left")) {
                    if (direction === "Left" && diff < -41) // console.log("[NOT ALLOWED LEFT] diff", diff)
                    return true;
                }
            })();
            const blockedDown = (()=>{
                if (allowed.has("Down")) {
                    const xFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(x);
                    const yFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(y);
                    const diff = yFine - approacherFineY;
                    const dist = Math.abs(diff);
                    // console.log("dir", dir)
                    if (direction === "Down") {
                        // console.log("dist down", dist, Date.now())
                        if (dist < 5) // console.log("(DOWN) blocked down")
                        return true;
                        else return false;
                    } else if (direction === "Up") {
                        // console.log("(DOWN) up diff", diff)
                        if (diff > -22) // console.log("(DOWN) blocked up")
                        return true;
                        else return false;
                    }
                }
            })();
            const blockedRight = (()=>{
                const xFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(x);
                const yFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(y);
                const diff = xFine - approacherFineX;
                const dist = Math.abs(diff);
                if (allowed.has("Right")) {
                    // console.log("dir", dir)
                    if (direction === "Right") {
                        // console.log("dist", dist, Date.now(), "diff", diff)
                        if (diff < -7) return true;
                        else return false;
                    } else if (direction === "Left") {
                        // console.log("going left, diff", diff)
                        if (diff > -40) return true;
                        else return false;
                    }
                }
                if (notAllowed?.has("Right")) {
                    if (direction === "Right" && diff < 3) // console.log("[NOT ALLOWED RIGHT] diff", diff)
                    return true;
                }
            })();
            const blockedUp = (()=>{
                if (allowed.has("Up")) {
                    const xFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(x);
                    const yFine = (0, $a80d0b17b615d6f7$export$87a4e8763dcd88c7)(y);
                    const diff = yFine - approacherFineY;
                    const dist = Math.abs(diff);
                    // console.log("dir", dir)
                    if (direction === "Up") {
                        // console.log("dist up", dist, Date.now())
                        if (dist < 22) // console.log("(UP) blocked up")
                        return true;
                        else return false;
                    } else if (direction === "Down") {
                        // console.log("(UP) down diff", diff)
                        if (diff > -22) // console.log("(UP) blocked down")
                        return true;
                        else return false;
                    }
                }
            })();
            // console.log("default block")
            return blockedDown === true || blockedLeft === true || blockedRight === true || blockedUp === true;
        };
        this.isDeepAt = (x, y)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return false;
            return !!_x[y]?.has("deep") && !_x[y]?.has("floor");
        };
        this.// Lava is terrain UNDERFOOT, and a cell's type set is a union over every layer that
        // paints there -- so the question is not "does this column contain a lava tile" but
        // "is lava the surface at (x, y)". `floor` is the project's existing marker for
        // something solid laid over the terrain (the `floors` tileset carries it; that is why
        // it cancels `deep` for a dock or a bridge over water), and it is the only cancel the
        // runtime paths already maintain: addTileAt/removeTileAt add and drop `floor` on a
        // cell as deltas come and go. docs/ember-cave-lava.md §4 requires cooling lava to be
        // modelled as ADDING a crust tile rather than removing the lava -- a `removed` delta
        // forces a full client rerender -- so an additive cancel is exactly what a cooled cell
        // will need. Hence the same guard as isDeepAt, by argument rather than by copy.
        //
        // Unlike isDeepAt this coerces: optional chaining makes that expression `undefined`
        // for an in-bounds column with no set at y, and the signature says boolean.
        isLavaAt = (x, y)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return false;
            return !!_x[y]?.has("lava") && !_x[y]?.has("floor");
        };
        this.roofWalls = (cells)=>{
            if (!cells) {
                cells = [];
                this.resolveTileMapFromLayerId("sprite")?.forEach((column, x)=>column.forEach((tile, y)=>{
                        if (!tile || tile === "0") return;
                        const delta = this.getMapDeltaAt(x, y, "sprite");
                        const parent = delta?.context?.parent;
                        if (parent && (parent.x !== x || parent.y !== y) && !delta.blocking) return;
                        if ((0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[delta?.context?.itemType]?.buildType === "wall" || this.woodAt(x, y) >= 0) cells.push({
                            x: x,
                            y: y
                        });
                    }));
            }
            return cells.map(({ x: x, y: y })=>({
                    x: x,
                    y: y,
                    profiles: this.getTileBlockingProfile(x, y) ?? [
                        {
                            x: 0,
                            y: 0,
                            width: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                            height: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                        }
                    ]
                }));
        };
        this.manualRoofInterior = ()=>{
            const version = `${this.presentationVersion}:${this.getCollisionVersion()}`;
            if (version !== this.manualRoofInteriorVersion) {
                const cells = new Map();
                for (const layer of [
                    "sky",
                    "skyTrigger"
                ])this.resolveTileMapFromLayerId(layer)?.forEach((column, x)=>column.forEach((tile, y)=>{
                        if (tile && tile !== "0") cells.set(`${x},${y}`, {
                            x: x,
                            y: y
                        });
                    }));
                this.manualRoofInteriorRects = (0, $2a9143f8f6144bf2$export$79c9eb92e591a971)([
                    ...cells.values()
                ], this.roofWalls());
                this.manualRoofInteriorVersion = version;
            }
            return this.manualRoofInteriorRects;
        };
        this./** Roofed interior at the feet, shared by server visibility and roof cutaways.
     * Gameplay contract: docs/occlusion-rules.md. */ isUnderRoofAt = (at)=>{
            const house = this.getHousePresentation();
            if (house) return (0, $2751e0027a1b432f$export$2c01c05cc2cc0271)(house, at);
            const x = Math.floor(at.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            const feetY = Math.floor((at.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763)) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            const sky = this.resolveTileMapFromLayerId("sky");
            const covered = (y)=>{
                const tile = sky?.[x]?.[y];
                // Manual roof borders may have artwork but no authored sky trigger.
                return !!tile && tile !== "0" || this.isSkyTileAt(x, y);
            };
            return covered(feetY) && (0, $2a9143f8f6144bf2$export$b0aa76c0958f55ce)(this.manualRoofInterior(), {
                x: at.x,
                y: at.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763)
            });
        };
        this.isSkyTileAt = (x, y)=>{
            if (!this.tilemaps.skyTrigger) return false;
            const _x = this.tilemaps.skyTrigger[x];
            if (!_x) return false;
            const hasSky = !!_x[y] && _x[y] !== "0";
            hasSky;
            return hasSky;
        };
        this.intersectionAt = (x, y)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return "";
            if (!_x[y]) return "";
            if (_x[y]?.has("collideable")) return "collideable";
            if (_x[y]?.has("blocking")) return "blocking";
            if (_x[y]?.has("entityTile")) return "entityTile";
            return "";
        };
        this.resolveEntityTileLayerId = ()=>this.tilemaps.entityTileLayerId;
        this.removeTileAt = (x, y, layerId, broadcast)=>{
            if (layerId === "sprite2" && (this.isFloorOpeningAt(x, y) || this.isStairAt(x, y))) this.touchTileTypes();
            this.presentationVersion++;
            this.removalVersion++;
            const _x = this.tileTypesMap[x];
            if (!_x) return null;
            // console.log(
            //     "REMOVE",
            //     x,
            //     y,
            //     layerId,
            //     "occlusion?",
            //     this.tileTypesMap[x][y]?.has("occlusion"),
            //     "blocking?",
            //     this.tileTypesMap[x][y]?.has("blocking"),
            // )
            // resolve tileId to remove
            let tileId;
            if (layerId) {
                const map = this.resolveTileMapFromLayerId(layerId);
                if (map) tileId = map[x][y];
            } else {
                const map = this.resolveTileMapFromLayerId(this.tilemaps.entityTileLayerId);
                if (map) {
                    const id = map[x][y];
                    if (this.removeableTile(id)) {
                        layerId = this.tilemaps.entityTileLayerId;
                        tileId = id;
                    }
                }
            }
            const delta = layerId && tileId && tileId !== "0" ? {
                x: x,
                y: y,
                removed: true,
                layerId: layerId,
                tileId: tileId
            } : undefined;
            const deltaKey = `${x}-${y}`;
            const existingDelta = this.tilemaps.deltas[layerId]?.[deltaKey];
            const wasTemporary = existingDelta && existingDelta.temporary;
            if (wasTemporary) // delete temporary delta
            delete this.tilemaps.deltas[layerId][deltaKey];
            if (delta) {
                _x[y]?.delete("entityTile");
                this.touchTileTypes();
                this.lastEditedTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
                if (!wasTemporary) {
                    let deltaLayer = this.tilemaps.deltas[layerId];
                    if (!deltaLayer) {
                        deltaLayer = {};
                        this.tilemaps.deltas[layerId] = deltaLayer;
                    }
                    deltaLayer[`${x}-${y}`] = delta;
                }
                const map = this.resolveTileMapFromLayerId(layerId);
                delete map[x][y];
                let blocking;
                let occlusion;
                let collideable;
                let deep;
                let lava;
                let floor;
                Object.values(this.tilemaps.deltas).map((n)=>Object.values(n).filter((n)=>n.x === x && n.y === y && !n.removed)).flat().forEach((delta)=>{
                    if (delta.blocking) blocking = true;
                    if (delta.occlusion) occlusion = true;
                    if (delta.collideable) collideable = true;
                    const tileMeta = this.resolveTileMeta(delta.tileId);
                    if (tileMeta?.tileTypes?.includes("deep")) deep = true;
                    if (tileMeta?.tileTypes?.includes("lava")) lava = true;
                    if (tileMeta?.tileTypes?.includes("floor")) floor = true;
                });
                if (!blocking) {
                    _x[y]?.delete("blocking");
                    this.touchTileTypes();
                    delete this.tilemaps?.blocking[x]?.[y];
                }
                if (!occlusion) {
                    _x[y]?.delete("occlusion");
                    delete this.tilemaps?.occlusion[x]?.[y];
                }
                if (!collideable) _x[y]?.delete("collideable");
                const thisTileMeta = this.resolveTileMeta(tileId);
                if (thisTileMeta.tileTypes.includes("deep") && !deep) _x[y]?.delete("deep");
                // Not the cancel lava is DESIGNED to use. docs/ember-cave-lava.md §4 requires
                // cooling to be modelled as ADDING a crust tile, because a `removed` delta sets
                // dirtyNeedsFull on the client and forces a full map rerender -- and §12 says
                // lava never recedes in v1 at all. The additive cancel is the `floor` pair above
                // and below, which isLavaAt already honours.
                //
                // This exists for correctness, not for the flow. removeTileAt is generic: any
                // caller that clears a cell lava happens to occupy (an erase, a temporary-delta
                // teardown, an entity tile removed on the same cell) would otherwise strand
                // `lava` in the type set forever, leaving a cell that draws rock and burns you.
                // The `!lava` guard is the one that earns its keep: it is the stacked case, where
                // two deltas paint lava on the same cell and only one is removed.
                if (thisTileMeta.tileTypes.includes("lava") && !lava) _x[y]?.delete("lava");
                if (thisTileMeta.tileTypes.includes("floor") && !floor) _x[y]?.delete("floor");
                if (broadcast) this.removeEventListeners.forEach((listener)=>listener(delta));
            }
            return delta;
        };
        this.updateBlockingAt = (x, y, blocking, broadcast)=>{
            this.presentationVersion++;
            const _x = this.tileTypesMap[x];
            if (!_x) return null;
            if (blocking) this.addTileTypeAt(x, y, "blocking");
            else _x[y]?.delete("blocking");
            this.touchTileTypes();
            let blockingDeltaLayer = this.tilemaps.deltas["blocking"];
            if (!blockingDeltaLayer) blockingDeltaLayer = {};
            const delta = blockingDeltaLayer[`${x}-${y}`] || {
                x: x,
                y: y,
                blocking: blocking
            };
            delta.blocking = blocking;
            blockingDeltaLayer[`${x}-${y}`] = delta;
            this.tilemaps.deltas["blocking"] = blockingDeltaLayer;
            this.lastEditedTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
            if (broadcast) this.removeEventListeners.forEach((listener)=>listener(delta));
            return delta;
        };
        this.getTileMeta = (tileId, tilesetId)=>{
            this.refreshAuthoredTiles();
            const tileset = this.tilesets.find((t)=>t.tilesetId === tilesetId);
            if (!tileset) return null;
            const meta = tileset.tiles[tileId];
            if (meta) return {
                tileId: `${tileset.firstGid + Number(tileId) - 1}`,
                meta: meta
            };
            return null;
        };
        this.entityTileIdToTileId = (entityTileId)=>{
            this.refreshAuthoredTiles();
            let foundId;
            let foundTileSet;
            let foundMeta;
            this.tilesets.every((tileset)=>{
                Object.keys(tileset.tiles).every((tileId)=>{
                    const meta = tileset.tiles[tileId];
                    if (meta.entityTileId === entityTileId) {
                        foundId = tileId;
                        foundTileSet = tileset;
                        foundMeta = meta;
                        return false;
                    }
                    return true;
                });
                if (foundId) return false;
                return true;
            });
            if (foundId && foundTileSet) return {
                tileId: `${foundTileSet.firstGid + Number(foundId) - 1}`,
                meta: foundMeta
            };
            return null;
        };
        this.getEntityTileAt = (x, y)=>{
            const _x = this.tileTypesMap[x];
            if (!_x) return null;
            if (this.tilemaps.tilemaps) for(let i = 0; i < this.tilemaps.tilemaps.length; i++){
                const map = this.tilemaps.tilemaps[i];
                const id = map[x][y];
                const tileMeta = this.resolveTileMeta(id);
                if (tileMeta?.entityTileId) {
                    if (this.hasRemovedDelta(x, y, id, this.tilemaps.entityTileLayerId)) return null;
                    return {
                        tileId: id,
                        entityTile: tileMeta?.entityTileId
                    };
                }
            }
        };
        this.entityTileMap = ()=>{
            return this.tilemaps.tilemaps[this.tilemaps.entityTilemapIdx];
        };
        this.addMapSpriteCapAt = (x, y, context)=>{
            this.tilemaps.mapSpriteCaps.push({
                x: x,
                y: y,
                context: context
            });
        };
        this.addTileAt = (x, y, blocking, occlusion, tileId, layerId, mapSpriteCap, temporary, collideable, context, broadcast)=>{
            this.presentationVersion++;
            if (layerId === "sprite2" && (this.isFloorOpeningAt(x, y) || this.isStairAt(x, y) || [
                "floor-opening",
                "stairs-up",
                "stairs-down"
            ].includes(this.resolveTileMeta(tileId).entityTileId))) this.touchTileTypes();
            // Adding/removing a child floor surface changes navigation even when the tile isn't a wall.
            if ((this.twoStoreyHouse?.floor ?? 0) > 0 && layerId === "map2") this.touchTileTypes();
            const _x = this.tileTypesMap[x];
            if (!_x) return null;
            // console.log("ADD", x, y, layerId, `occlusion - ${occlusion}`, `blocking - ${blocking}`)
            // Replacing art can change a footprint even when the blocking bit is unchanged.
            if (layerId === "map5" && (this.caveCliffFootprintAt(x, y) || [
                440,
                442
            ].includes(this.artPosition(tileId)?.position))) this.touchTileTypes();
            if (!blocking && (_x[y]?.has("blocking") || occlusion && !_x[y]?.has("occlusion"))) this.touchTileTypes();
            if (blocking) {
                this.addTileTypeAt(x, y, "blocking");
                this.touchTileTypes();
            }
            if (occlusion) this.addTileTypeAt(x, y, "occlusion");
            if (collideable) this.addTileTypeAt(x, y, "collideable");
            if (tileId) {
                // entityTiles
                const tileMeta = this.resolveTileMeta(tileId);
                if (tileMeta.entityTileId) {
                    this.addTileTypeAt(x, y, "entityTile");
                    this.touchTileTypes();
                }
                // add tile id to the entity tile surface
                const entityTileMap = layerId ? this.resolveTileMapFromLayerId(layerId) : this.tilemaps.tilemaps[this.tilemaps.entityTilemapIdx];
                if (entityTileMap) entityTileMap[x][y] = tileId;
                if (tileMeta.tileTypes.includes("deep")) this.addTileTypeAt(x, y, "deep");
                // Lava painted at runtime -- the flow/breach path of docs/ember-cave-lava.md
                // §5-6 -- has to reach the cell's type set or isLavaAt stays false while the
                // art renders. Deliberately shaped exactly like `deep`: no touchTileTypes()
                // call, because lava is never `blocking` (§10/§12: a hazard you cannot enter
                // is a wall) and a bump here would drop the room's whole A* collision matrix
                // -- tiledCollisionBuilder is ~92% of a re-path -- for a tile that cannot
                // change the answer. Nothing below adds `blocking` or `occlusion` for lava;
                // those come only from this method's own arguments.
                if (tileMeta.tileTypes.includes("lava")) this.addTileTypeAt(x, y, "lava");
                if (tileMeta.tileTypes.includes("floor")) this.addTileTypeAt(x, y, "floor");
            }
            //
            // update deltas
            //
            const existingMapDelta = this.getMapDeltaAt(x, y, layerId);
            if (existingMapDelta) {
                if (tileId !== existingMapDelta.tileId) existingMapDelta.tileId = tileId;
                existingMapDelta.blocking = blocking;
                existingMapDelta.occlusion = occlusion;
                existingMapDelta.mapSpriteCap = mapSpriteCap;
                delete existingMapDelta.removed;
                // Preserve existing context data (like hp, damage, etc.) when updating tiles
                if (context && existingMapDelta.context) existingMapDelta.context = {
                    ...existingMapDelta.context,
                    ...context
                };
                else if (context) existingMapDelta.context = context;
                this.addEventListeners.forEach((listener)=>listener(existingMapDelta));
                return existingMapDelta;
            }
            const delta = {
                x: x,
                y: y,
                tileId: tileId,
                blocking: blocking === false ? undefined : blocking,
                occlusion: occlusion === false ? undefined : occlusion,
                layerId: layerId,
                mapSpriteCap: mapSpriteCap,
                temporary: temporary === false ? undefined : temporary,
                collideable: collideable === false ? undefined : collideable,
                context: context
            };
            let deltaLayer = this.tilemaps.deltas[layerId];
            if (!deltaLayer) {
                deltaLayer = {};
                this.tilemaps.deltas[layerId] = deltaLayer;
            }
            deltaLayer[`${x}-${y}`] = delta;
            this.lastEditedTs = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
            if (broadcast) this.addEventListeners.forEach((listener)=>listener(delta));
            return delta;
        };
        this.resolveLayerMapping = (layerId)=>{
            if (layerId === "skyTrigger" || layerId === "occlusion") return {
                idx: 0,
                maptype: layerId
            };
            return this.layerIndexedMap?.get(layerId)?.layerClass;
        };
        this.getBlockingLayer = ()=>this.tilemaps.blocking;
        this./** Where the ground is raised -- see common/room/ember/forest_rise.ts -- or undefined when it is all flat. */ getRiseLayer = ()=>this.tilemaps?.rise;
        this./** An organic cave's per-cell plan (room/cave/organic_cave.ts); undefined in every other room. */ getOrganicRockLayer = ()=>this.tilemaps?.organicRock;
        this.getOrganicCave = ()=>this.tilemaps?.organicCave;
        this.getWaterLayer = ()=>this.tilemaps?.water;
        this.resolveTileMapFromLayerId = (layerId)=>{
            if (!layerId) return null;
            switch(layerId){
                case "skyTrigger":
                    return this.tilemaps?.skyTrigger;
                case "occlusion":
                    return this.tilemaps?.occlusion;
            }
            return this.layerIndexedMap?.get(layerId)?.tilemap;
        };
        this.isHiddenTile = (tileId)=>{
            const meta = this.resolveTileMeta(tileId);
            // Openings carry fall support metadata only; the missing surfaces expose the room below.
            return meta.entityTileId === "floor-opening" || meta.tileTypes.includes("hidden");
        };
        this.getCompositeTileId = (tileId)=>this.resolveTileMeta(tileId).compositeTileId;
        this.height = ()=>this._height;
        this.width = ()=>this._width;
        this.registerRemoveListener = (listener)=>{
            this.removeEventListeners.add(listener);
        };
        this.unregisterRemoveListener = (listener)=>{
            this.removeEventListeners.delete(listener);
        };
        this.registerAddListener = (listener)=>{
            this.addEventListeners.add(listener);
        };
        this.unregisterAddListener = (listener)=>{
            this.addEventListeners.delete(listener);
        };
        this.iterateLayer = (layerId, visitor)=>{
            const map = this.resolveTileMapFromLayerId(layerId);
            if (!map) return;
            (0, $cb689cfa16c444ba$export$d84fb6ad88214660)(map, visitor);
        };
        this.// `layerId` names the delta to write to. Without it this takes whatever findMapDeltaAt hands back,
        // which walks the layers in whatever order the map defines them -- fine for a struck tile, whose
        // caller has already resolved the layer, but wrong for a caller that knows the tile it means: the
        // ground UNDER a wall is a delta at the same cell, and would take the damage instead.
        /**
     * A tile's health, recorded on its delta and nothing more: the client's copy of a strike. Health changes no art,
     * wall, floor or roof, so the presentation version -- what the client's shadows, wall seams and storey edges are
     * worked out again from -- stays put. Re-adding the tile (updateMapDeltaWithHP) bumped it, and in a castle every
     * swing that landed on anything with health re-cast every storey's shadows: ~80ms a hit. The server keeps updateMapDeltaWithHP, whose
     * re-add is how the change is broadcast.
     */ setMapDeltaHealth = (mapRoughCoordinates, hp, hpMax, layerId)=>{
            const { x: x, y: y } = mapRoughCoordinates;
            const delta = layerId ? this.getMapDeltaAt(x, y, layerId) : this.findMapDeltaAt(x, y);
            if (!delta) return;
            if (!delta.context) delta.context = {};
            delta.context.hp = hp;
            delta.context.hpMax = hpMax;
        };
        this.updateMapDeltaWithHP = (mapRoughCoordinates, hp, hpMax, layerId)=>{
            const { x: x, y: y } = mapRoughCoordinates;
            const existingDelta = layerId ? this.getMapDeltaAt(x, y, layerId) : this.findMapDeltaAt(x, y);
            if (existingDelta) {
                // Update existing delta with HP context
                if (!existingDelta.context) existingDelta.context = {};
                existingDelta.context.hp = hp;
                existingDelta.context.hpMax = hpMax;
                // Trigger update by calling setMapDeltas with the updated delta
                this.setMapDeltas([
                    existingDelta
                ], true);
            }
        };
        this.roomId = roomId;
        this.tilemaps = tileMapDirectory;
        this.tilesets = tilesets.sort((a, b)=>b.firstGid - a.firstGid);
        const firstTileMap = tileMapDirectory.tilemaps[0];
        if (!firstTileMap) return;
        this._width = firstTileMap.length;
        this._height = firstTileMap[0].length;
        this.tileTypesMap = [];
        this.tileBlockingAllowed = [];
        this.tileBlockingNotAllowed = [];
        this.minimapConfig = {
            biomeBased: true,
            worldMetaDimensions: worldMetaDimensions
        };
        this.layerIndexedMap = new (0, $cb689cfa16c444ba$export$cbcb4f84fc8dd985)();
        if (this.tilemaps.layerIdToTileMap) Object.keys(this.tilemaps.layerIdToTileMap).forEach((layerId)=>{
            let tilemap;
            const layerClass = this.tilemaps.layerIdToTileMap[layerId];
            const { maptype: maptype, idx: idx } = layerClass;
            switch(maptype){
                case "tilemap":
                    tilemap = this.tilemaps?.tilemaps[idx];
                    break;
                case "sprited":
                    tilemap = this.tilemaps?.sprited[idx];
                    break;
                case "sky":
                    tilemap = this.tilemaps?.sky[idx];
                    break;
            }
            this.layerIndexedMap.set(layerId, {
                entityId: layerId,
                tilemap: tilemap,
                layerClass: layerClass
            });
        });
        const blockingTileSet = this.tilesets.find((n)=>n.tilesetId === "lpc-terrain");
        // Reuse empty scratch sets instead of allocating three sets per empty cell.
        let rowSet = new Set();
        let rowTileBlockingAllowedSet = new Set();
        let rowTileBlockingNotAllowedSet = new Set();
        for(let x = 0; x < this._width; x++){
            const column = new Array(this._height);
            this.tileTypesMap.push(column);
            const tileBlockingAllowedColumn = new Array(this._height);
            const tileBlockingNotAllowedColumn = new Array(this._height);
            this.tileBlockingAllowed.push(tileBlockingAllowedColumn);
            this.tileBlockingNotAllowed.push(tileBlockingNotAllowedColumn);
            for(let y = 0; y < this._height; y++){
                // inspect every map level and merge the tile types relevant to each cell in the map
                for(let i = 0; i < tileMapDirectory.tilemaps.length; i++){
                    // get the tile map
                    const tileMap = tileMapDirectory.tilemaps[i];
                    // look up the tile id of the current cell
                    const tileId = `${tileMap[x][y]}`;
                    // look up the tiletypes that tile id and merge it into the cell's tile types set
                    const tileMeta = this.resolveTileMeta(tileId);
                    const toAdd = tileMeta.tileTypes;
                    toAdd.forEach((tileType)=>rowSet.add(tileType));
                }
                // inspect blocking
                if (tileMapDirectory.blocking) {
                    const blockingTile = tileMapDirectory.blocking[x][y];
                    if (blockingTile && blockingTile !== `${0}`) {
                        rowSet.add("blocking");
                        if (blockingTileSet) {
                            const blockingTileId = Number(blockingTile) - blockingTileSet.firstGid;
                            switch(blockingTileId){
                                case 957:
                                    rowTileBlockingAllowedSet.add("Down");
                                    rowTileBlockingNotAllowedSet.add("Right");
                                    break;
                                case 958:
                                    rowTileBlockingAllowedSet.add("Down");
                                    break;
                                case 959:
                                    rowTileBlockingAllowedSet.add("Down");
                                    rowTileBlockingNotAllowedSet.add("Left");
                                    break;
                                case 989:
                                    rowTileBlockingAllowedSet.add("Left");
                                    break;
                                case 991:
                                    rowTileBlockingAllowedSet.add("Right");
                                    break;
                                case 1021:
                                    rowTileBlockingAllowedSet.add("Left");
                                    rowTileBlockingAllowedSet.add("Up");
                                    break;
                                case 1022:
                                    rowTileBlockingAllowedSet.add("Down");
                                    break;
                                case 1023:
                                    rowTileBlockingAllowedSet.add("Right");
                                    rowTileBlockingAllowedSet.add("Up");
                                    break;
                            }
                        }
                    }
                }
                if (tileMapDirectory.occlusion) {
                    const occlusionTile = tileMapDirectory.occlusion[x][y];
                    if (occlusionTile && occlusionTile !== `${0}`) rowSet.add("occlusion");
                }
                if (tileMapDirectory.sprited) tileMapDirectory.sprited.forEach((sprited)=>{
                    const spritedTileId = sprited[x][y];
                    const tileMeta = this.resolveTileMeta(spritedTileId);
                    const toAdd = tileMeta.tileTypes;
                    toAdd.forEach((tileType)=>rowSet.add(tileType));
                });
                if (rowSet.size) {
                    column[y] = rowSet;
                    rowSet = new Set();
                }
                if (rowTileBlockingAllowedSet.size) {
                    tileBlockingAllowedColumn[y] = rowTileBlockingAllowedSet;
                    rowTileBlockingAllowedSet = new Set();
                }
                if (rowTileBlockingNotAllowedSet.size) {
                    tileBlockingNotAllowedColumn[y] = rowTileBlockingNotAllowedSet;
                    rowTileBlockingNotAllowedSet = new Set();
                }
            }
        }
        const { deltas: deltas } = tileMapDirectory;
        const deltaLayers = Object.keys(deltas);
        if (deltaLayers.length > 0) deltaLayers.forEach((layerId)=>{
            const layerDeltas = deltas[layerId];
            Object.values(layerDeltas).forEach((delta)=>{
                if (delta.removed) this.removeTileAt(delta.x, delta.y, layerId);
                else {
                    this.addTileAt(delta.x, delta.y, delta.blocking, delta.occlusion, delta.tileId, delta.layerId, delta.mapSpriteCap, delta.temporary, delta.collideable, delta.context);
                    if (delta.mapSpriteCap) this.addMapSpriteCapAt(delta.x, delta.y, delta.mapSpriteCap.context);
                }
            });
        });
        this.tilesets.forEach((tileset)=>{
            this.tilesetsById[tileset.tilesetId] = tileset;
            Object.keys(tileset.tiles).forEach((tileId)=>{
                const tileMeta = tileset.tiles[tileId];
                if (tileMeta?.compositeTileId && tileMeta.compositeTileParent) {
                    const children = [];
                    this.compositeTileMetaLookup[`${tileset.tilesetId}-${tileMeta.compositeTileId}`] = {
                        tileMeta: tileMeta,
                        tileNumber: parseInt(tileId),
                        children: children
                    };
                    Object.keys(tileset.tiles).reduce((acc, childTileId)=>{
                        const childTileMeta = tileset.tiles[childTileId];
                        if (childTileMeta.compositeTileId === tileMeta.compositeTileId) children.push({
                            tileMeta: childTileMeta,
                            tileNumber: parseInt(childTileId)
                        });
                        return acc;
                    }, []);
                }
            });
        });
    }
    addTileTypeAt(x, y, type) {
        const column = this.tileTypesMap[x];
        if (!column || !Number.isInteger(y) || y < 0 || y >= this._height) return;
        const types = column[y] ?? (column[y] = new Set());
        types.add(type);
    }
}




class $3d19dbc64510cf8a$export$576380cfa99ddf20 {
    constructor(paintBrightness){
        this.paintBrightness = paintBrightness;
        this.generation = 0;
        this.roomIds = [];
        this.dayPhase = null;
        this.brightness = 0;
        this.ambience = null;
    }
    enter(roomId, house, phase, visibility) {
        const id = house?.groundRoomId ?? roomId;
        const changed = id !== this.id;
        this.id = id;
        this.roomIds = house?.floorRoomIds ?? [
            id,
            house?.upperRoomId,
            roomId
        ].filter(Boolean);
        if (changed) {
            this.generation++;
            this.stopFade();
            this.dayPhase = phase ? {
                ...phase
            } : null;
            this.brightness = phase?.brightness ?? visibility?.darkness ?? 0;
        } else if (phase) this.updateDayPhase(phase);
        return changed;
    }
    contains(roomId) {
        return !roomId || this.roomIds.includes(roomId);
    }
    get daylight() {
        return this.dayPhase ? this.brightness : undefined;
    }
    setAmbience(ambience) {
        // Repeated floor-entry packets describe the same weather. Keep its configuration stable.
        if (JSON.stringify(ambience) !== JSON.stringify(this.ambience)) this.ambience = ambience;
    }
    visibility(visibility) {
        return this.dayPhase && !visibility?.fullOcclusion ? {
            ...visibility,
            darkness: this.brightness
        } : visibility;
    }
    updateDayPhase(phase) {
        if (!phase || phase.name === this.dayPhase?.name && phase.brightness === this.dayPhase?.brightness) return;
        this.dayPhase = {
            ...phase
        };
        this.stopFade();
        const target = phase.brightness;
        this.brightnessInterval = setInterval(()=>{
            const distance = target - this.brightness;
            this.brightness += Math.sign(distance) * Math.min(.01, Math.abs(distance));
            if (Math.abs(target - this.brightness) <= .01) {
                this.brightness = target;
                this.stopFade();
            }
            this.paintBrightness(this.brightness);
        }, 60);
    }
    reset() {
        this.generation++;
        this.stopFade();
        this.id = undefined;
        this.roomIds = [];
        this.dayPhase = null;
        this.brightness = 0;
        this.ambience = null;
    }
    stopFade() {
        clearInterval(this.brightnessInterval);
        this.brightnessInterval = undefined;
    }
}


let $c934a91f663d6020$var$installed;
const $c934a91f663d6020$export$e20abd874f6b5d34 = (feedback)=>{
    $c934a91f663d6020$var$installed = feedback;
};
const $c934a91f663d6020$export$7485d82cd17991cf = {
    fired: (at, appearance)=>$c934a91f663d6020$var$installed?.fired(at, appearance),
    landed: (at, appearance)=>$c934a91f663d6020$var$installed?.landed(at, appearance),
    detonated: (at, appearance)=>$c934a91f663d6020$var$installed?.detonated(at, appearance)
};


let $2027e742bf23a011$var$installed;
const $2027e742bf23a011$export$eaa376922eb1905 = (feedback)=>{
    $2027e742bf23a011$var$installed = feedback;
};
const $2027e742bf23a011$export$d5812078266caf23 = {
    creaked: (at)=>$2027e742bf23a011$var$installed?.creaked(at),
    landed: (at, weight)=>$2027e742bf23a011$var$installed?.landed(at, weight)
};



parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");



/**
 * How visible each drawn storey is this frame, for art drawn on ANOTHER storey that belongs with it:
 * an upper floor's slab faces hang in the storey below (storey_edges.ts), so they fade with the
 * floor they belong to. The active storey publishes 1; a passive one its root's alpha, and the cells
 * of a regional cutaway (the structure the player stands under, see SceneFloorRenderer) their own fade.
 */ const $21141db879ebc35b$var$storeys = new Map();
const $21141db879ebc35b$export$f9cdf82e798d4d86 = (roomId, alpha, region, regionAlpha = 1)=>{
    $21141db879ebc35b$var$storeys.set(roomId, {
        alpha: alpha,
        region: region,
        regionAlpha: regionAlpha
    });
};
const $21141db879ebc35b$export$1479527415e8ddc1 = (roomId)=>{
    $21141db879ebc35b$var$storeys.delete(roomId);
};
const $21141db879ebc35b$export$b1e07aa98e0f145b = (roomId, x, y)=>{
    const storey = $21141db879ebc35b$var$storeys.get(roomId);
    if (!storey) return 1;
    return storey.alpha * (storey.region?.has(`${x},${y}`) ? storey.regionAlpha : 1);
};




const $d67ded9f7782cb88$export$f7609d4936bd82d6 = (provider, at, requestedDirection)=>{
    const tile = provider.resolveTileMapFromLayerId("sprite2")?.[at.x]?.[at.y];
    if (!tile || tile === "0") return undefined;
    const type = provider.resolveTileMeta(tile).entityTileId;
    if (type !== "stairs-up" && type !== "stairs-down") return undefined;
    const delta = provider.getMapDeltaAt(at.x, at.y, "sprite2");
    if (delta?.removed) return undefined;
    const direction = requestedDirection ?? (type === "stairs-up" ? "up" : "down");
    // A continuous ladder shaft has an up and a down connection on the same cell.
    const landings = delta?.context?.context?.stairLandings ?? delta?.context?.stairLandings;
    if (landings ? !landings[direction] : direction !== (type === "stairs-up" ? "up" : "down")) return undefined;
    return {
        coordinate: at,
        direction: direction,
        landing: landings?.[direction] ?? delta?.context?.context?.stairLanding ?? delta?.context?.stairLanding
    };
};
const $d67ded9f7782cb88$export$3fc3cdacb688dd76 = (map, landing)=>{
    if (!Number.isFinite(landing.x) || !Number.isFinite(landing.y)) return false;
    const x = Math.floor(landing.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    const stairY = Math.floor(landing.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    const y = map.isStairAt(x, stairY) ? stairY : Math.floor((landing.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763)) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    if (x < 0 || y < 0 || x >= map.width() || y >= map.height()) return false;
    if (map.isUnsupportedFloorAtPosition({
        x: landing.x,
        y: landing.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763)
    })) return false;
    if (map.isCollisionAt(x, y) && !map.getTileBlockingProfile(x, y)) return false;
    return !map.overlapsTileBlockingProfile(landing.x - 12.5, landing.y - 12.5, landing.x + 12.5, landing.y + 12.5);
};
const $d67ded9f7782cb88$export$eb5eae4ba85a0d2c = (map, roomId, stair)=>{
    for (const [dx, dy] of [
        [
            1,
            0
        ],
        [
            0,
            1
        ],
        [
            -1,
            0
        ],
        [
            0,
            -1
        ]
    ]){
        const at = {
            x: stair.x + dx,
            y: stair.y + dy
        };
        const landing = {
            roomId: roomId,
            x: (at.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
            y: (at.y + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
        };
        if (!$d67ded9f7782cb88$export$f7609d4936bd82d6(map, at) && $d67ded9f7782cb88$export$3fc3cdacb688dd76(map, landing)) return landing;
    }
};
const $d67ded9f7782cb88$export$821b6aaabbc063ff = (map, at)=>{
    const landing = {
        roomId: map.roomId,
        x: (at.x + .5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
        y: (at.y + .5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
    };
    return $d67ded9f7782cb88$export$f7609d4936bd82d6(map, at) && $d67ded9f7782cb88$export$3fc3cdacb688dd76(map, landing) ? landing : undefined;
};


const $f63a252d2ded274b$export$6d09a325ee084aba = (map, at)=>{
    const delta = map.getMapDeltaAt(at.x, at.y, "sprite2");
    const links = delta?.context?.context?.stairLandings ?? delta?.context?.stairLandings;
    if (delta?.removed || !links || !(0, $d67ded9f7782cb88$export$f7609d4936bd82d6)(map, at)) return undefined;
    const upper = map.getUpperFloorProvider(), lower = map.getFloorSupportProvider();
    // Local links determine the shape. Companion floors can arrive before their route
    // context, so requiring a reciprocal landing briefly adds a second hatch at the foot.
    // A loaded neighbour with its ladder removed still disconnects the artwork.
    const connected = (neighbor, roomId)=>!neighbor || neighbor.roomId !== roomId || !!(0, $d67ded9f7782cb88$export$f7609d4936bd82d6)(neighbor, at);
    const up = !!links.up && connected(upper, links.up.roomId);
    const down = !!links.down && connected(lower, links.down.roomId);
    const rise = upper?.twoStoreyHouse && map.twoStoreyHouse ? (0, $2751e0027a1b432f$export$815ba2e910747d11)(upper.twoStoreyHouse) - (0, $2751e0027a1b432f$export$815ba2e910747d11)(map.twoStoreyHouse) : (map.twoStoreyHouse?.rise ?? 1) * (0, $2751e0027a1b432f$export$de62489b685ceb);
    const hatch = down && up && $f63a252d2ded274b$export$49a6d3e52bbd6209(map, at);
    const ownRoof = map.resolveTileMapFromLayerId("sky")?.[at.x]?.[at.y];
    const upperFloor = upper?.resolveTileMapFromLayerId("map2")?.[at.x]?.[at.y];
    const throughCeiling = up && (!!ownRoof && ownRoof !== "0" || !!upperFloor && upperFloor !== "0");
    // A roof cutaway hides the neighbouring ladder sections with the upper room.
    // In that view, show the whole interior flight instead of just one compressed storey.
    const ceilingView = throughCeiling && (0, $21141db879ebc35b$export$b1e07aa98e0f145b)(links.up.roomId, at.x, at.y) < 1;
    return {
        ...ceilingView ? {
            ceiling: true
        } : {},
        ...hatch ? {
            hatch: true
        } : {},
        kind: up ? down ? "middle" : "bottom" : down ? "top" : "isolated",
        height: Math.max(8, Math.round(rise))
    };
};
const $f63a252d2ded274b$export$49a6d3e52bbd6209 = (map, at)=>{
    const surface = map.resolveTileMapFromLayerId("map2")?.[at.x]?.[at.y];
    const ceiling = map.getFloorSupportProvider()?.resolveTileMapFromLayerId("sky")?.[at.x]?.[at.y];
    return !!surface && surface !== "0" || !!ceiling && ceiling !== "0";
};
const $f63a252d2ded274b$export$eb08c2609b220aee = 6;
// Upper hatch rim from art/ladder-up/ladder-up.png, in its original wood palette.
const $f63a252d2ded274b$var$hatchPalette = [
    0x1a120c,
    0x24170f,
    0x4a3222,
    0x5c3e28,
    0x6e4a30,
    0x8f6440,
    0xb08050,
    0xd2a46c
];
const $f63a252d2ded274b$var$hatchRim = [
    "          0000000000000000000000000         ",
    "         077677666666766666767675550        ",
    "        06660553555555555555552506660       ",
    "       0777213314444434333333323137770      ",
    "       0666310000000000000000000136660      ",
    "      077730                    0236770     ",
    "     0666630                    02277760    ",
    "     4777312 730             077 0266664    ",
    "    056662107740             07700225665    ",
    "   06555554076304555555555553076405555550   ",
    "   06555554076304555555555554076405555550   ",
    "   05444444076304444444444444076404444440   ",
    "    000000007620000000000000007640000000    ",
    "           0761              07640          "
];
const $f63a252d2ded274b$export$8c9d52e1a7dbe92a = $f63a252d2ded274b$var$hatchRim.length;
const $f63a252d2ded274b$export$664fd011aec16e70 = ({ kind: kind, height: height, hatch: hatch, ceiling: ceiling })=>{
    const pixels = [];
    const rect = (x, y, width, h, color)=>pixels.push({
            x: x,
            y: y,
            width: width,
            height: h,
            color: color
        });
    const top = kind === "top" ? -$f63a252d2ded274b$export$eb08c2609b220aee : -Math.max(height, ceiling ? (0, $968cce787b06be95$export$64292ccd7650dcfd) : 0);
    const capY = ceiling ? top : kind === "isolated" ? -height : -$f63a252d2ded274b$var$hatchRim.length;
    const rims = kind === "top" || kind === "isolated" || hatch || ceiling ? ceiling && hatch ? [
        capY,
        -$f63a252d2ded274b$var$hatchRim.length
    ] : [
        capY
    ] : [];
    // Transparent pixels inside the rim would show intact floorboards. Recess the
    // opening behind the rails and rungs, including the terminating and ceiling hatches.
    for (const rimY of rims){
        rect(3, rimY + 4, 27, 10, 0x1a120c);
        rect(4, rimY + 4, 25, 2, 0x100d09);
    }
    // Match the original 64px frame: its 27px rail body sits at x=3..29,
    // with the 44px visible foot silhouette centered at x=16.
    for (const x of [
        3,
        24
    ]){
        rect(x, top, 6, -top, 0x1a120c);
        rect(x + 1, top, 4, -top, 0x8f6440);
        rect(x + 1, top, 2, -top, 0xb08050);
        rect(x + 1, top, 1, -top, 0xd2a46c);
        rect(x + 4, top, 1, -top, 0x5c3e28);
        // Broken highlights and darker grain keep the original's hand-hewn character.
        // Leave both ends unchanged so neighbouring sections still join exactly.
        for(let y = top + 5; y < -5; y += 16){
            rect(x + 1, y, 1, 5, 0x8f6440);
            rect(x + 3, y + 2, 1, 3, 0x6e4a30);
        }
    }
    for(let y = -6; y >= top; y -= 8){
        rect(7, y, 19, 4, 0x24170f);
        rect(7, y, 19, 2, 0xb08050);
        rect(8, y, 16, 1, 0xd2a46c);
        rect(7, y + 2, 19, 1, 0x6e4a30);
        rect(4, y + 1, 3, 1, 0xb08050);
        rect(26, y + 1, 3, 1, 0x8f6440);
    }
    if (kind === "bottom" || kind === "isolated") {
        // Original-style splayed braces only at the foot, never repeated at a seam.
        for(let i = 0; i < 9; i++){
            const y = -11 + i;
            rect(2 - i, y, 4, 2, 0x24170f);
            rect(26 + i, y, 4, 2, 0x24170f);
            rect(3 - i, y, 2, 1, 0xb08050);
            rect(27 + i, y, 2, 1, 0x8f6440);
        }
        rect(-6, -2, 7, 2, 0x1a120c);
        rect(31, -2, 7, 2, 0x1a120c);
        rect(-5, -2, 5, 1, 0xb08050);
        rect(32, -2, 5, 1, 0xb08050);
        // A worn, broad bottom rung, as on the freestanding original.
        rect(5, -5, 22, 3, 0x5c3e28);
        rect(6, -5, 20, 1, 0xb08050);
        for (const x of [
            8,
            13,
            21
        ])rect(x, -4, 2, 1, 0x6e4a30);
    }
    // Keep the original chunky cheeks and bevels around the recessed opening.
    rims.forEach((rimY)=>$f63a252d2ded274b$var$hatchRim.forEach((row, y)=>{
            for(let x = 0; x < row.length;){
                const shade = row[x], start = x++;
                while(x < row.length && row[x] === shade)x++;
                if (shade !== " ") rect(start - 6, rimY + y, x - start, 1, $f63a252d2ded274b$var$hatchPalette[Number(shade)]);
            }
        }));
    return pixels;
};
class $f63a252d2ded274b$export$3fce9c276dbc848 extends (0, $7Bs2Z.Sprite) {
    constructor(map, at){
        super((0, $klOfb.Texture).EMPTY), this.map = map, this.at = at, this.heightBlurExempt = true, this.art = new (0, $gwPoJ.Graphics)(), this.artworkKey = "", this.pose = ()=>{
            const state = $f63a252d2ded274b$export$6d09a325ee084aba(this.map, this.at);
            this.x = this.at.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            this.y = (this.at.y + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const key = state ? `${state.kind}:${state.height}:${!!state.hatch}:${!!state.ceiling}` : "";
            if (key === this.artworkKey) return;
            this.artworkKey = key;
            this.art.clear();
            if (!state) return;
            for (const pixel of $f63a252d2ded274b$export$664fd011aec16e70(state))this.art.beginFill(pixel.color).drawRect(pixel.x, pixel.y, pixel.width, pixel.height).endFill();
        };
        this.anchor.set(0, 1);
        this.addChild(this.art);
        this.pose();
    }
}




const $5a580aacfacf7705$export$a7fa163723092bfa = (tile)=>{
    if (!tile || tile.removed) return;
    const interactions = tile.context?.tileInteractions;
    return tile.context?.hatch ? interactions?.filter((action)=>action.name !== "install-hatch") : interactions;
};
const $5a580aacfacf7705$export$27c8f30ca81f5bc2 = (provider, cell, options = {})=>{
    if (!cell || !Number.isInteger(cell.x) || !Number.isInteger(cell.y)) return;
    const targets = (options.layerIds ?? [
        "sprite3",
        "sprite2",
        "sprite",
        "map3",
        "map2"
    ]).map((layerId)=>({
            layerId: layerId,
            cell: cell
        }));
    if (options.includeRoof !== false) targets.splice(options.roofCell ? 0 : 3, 0, {
        layerId: "sky",
        cell: options.roofCell ?? cell
    });
    for (const { layerId: layerId, cell: cell } of targets){
        const hit = provider.getMapDeltaAt(cell.x, cell.y, layerId);
        if (!hit || hit.removed) continue;
        const coordinate = hit.context?.parent || cell;
        const tile = provider.getMapDeltaAt(coordinate.x, coordinate.y, layerId);
        const interactions = $5a580aacfacf7705$export$a7fa163723092bfa(tile);
        if (interactions?.length) return {
            coordinate: {
                ...coordinate
            },
            layerId: layerId,
            interactions: interactions
        };
    }
    if (options.roofBelow) {
        const roof = options.roofBelow.provider.getMapDeltaAt(cell.x, cell.y, "sky");
        const interactions = $5a580aacfacf7705$export$a7fa163723092bfa(roof);
        if (interactions?.length) return {
            coordinate: {
                ...cell
            },
            layerId: "sky",
            roomId: options.roofBelow.roomId,
            interactions: interactions
        };
    }
};


/** The live building-height controls are only shown to the named developer. */ const $a4184bfabcb7e471$export$29fa54e0b5ca6ef1 = (name)=>name === "Aron" || name === "aron";
let $a4184bfabcb7e471$var$buildingHeightTuningEnabled = false;
const $a4184bfabcb7e471$export$6847f56b353cc6db = (name)=>$a4184bfabcb7e471$var$buildingHeightTuningEnabled && $a4184bfabcb7e471$export$29fa54e0b5ca6ef1(name);
const $a4184bfabcb7e471$export$6bc1887dc4110236 = (name)=>{
    if ($a4184bfabcb7e471$export$29fa54e0b5ca6ef1(name)) $a4184bfabcb7e471$var$buildingHeightTuningEnabled = !$a4184bfabcb7e471$var$buildingHeightTuningEnabled;
};




var $5UG8I = parcelRequire("5UG8I");



const $6590e3376f1c796a$export$f52c2d64a4628ea4 = (location, angle)=>{
    const target = (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(location);
    (0, $a80d0b17b615d6f7$export$816c81660958f502)(target, (0, $a80d0b17b615d6f7$export$94d6114d0f45bc7e)(angle), 1);
    return target;
};
const $6590e3376f1c796a$export$93bcf7afc562b94e = (origin, target, range)=>({
        x: Math.max(origin.x - range, Math.min(origin.x + range, target.x)),
        y: Math.max(origin.y - range, Math.min(origin.y + range, target.y))
    });
const $6590e3376f1c796a$export$9ee856257c99bd27 = (origin, target, range)=>!!target && Number.isInteger(target.x) && Number.isInteger(target.y) && Math.abs(target.x - origin.x) <= range && Math.abs(target.y - origin.y) <= range;


const $85e59abaaefadc89$export$508fe9565d0ddf0f = [
    "rectangle",
    "ellipse",
    "line"
];
const $85e59abaaefadc89$export$8f640e20d07486c5 = (anchor, pointer, wallAt, width, height, previous = {}, bypass = false)=>{
    const edges = {};
    if (bypass) return {
        endpoint: {
            ...pointer
        },
        edges: edges
    };
    const choose = (axis, spanEnd)=>{
        if (Math.abs(pointer[axis] - anchor[axis]) < 2) return undefined;
        const other = axis === "x" ? "y" : "x";
        const limit = axis === "x" ? width : height, spanLimit = axis === "x" ? height : width;
        const min = Math.max(0, Math.min(anchor[other], spanEnd)), max = Math.min(spanLimit - 1, Math.max(anchor[other], spanEnd));
        const eligible = (edge)=>{
            if (edge < 0 || edge >= limit || Math.sign(edge - anchor[axis]) !== Math.sign(pointer[axis] - anchor[axis])) return false;
            for(let i = min; i <= max; i++){
                const point = axis === "x" ? {
                    x: edge,
                    y: i
                } : {
                    x: i,
                    y: edge
                };
                if (wallAt(point) && (wallAt(axis === "x" ? {
                    x: edge,
                    y: i - 1
                } : {
                    x: i - 1,
                    y: edge
                }) || wallAt(axis === "x" ? {
                    x: edge,
                    y: i + 1
                } : {
                    x: i + 1,
                    y: edge
                }))) return true;
            }
            return false;
        };
        const held = previous[axis];
        if (held !== undefined && Math.abs(held - pointer[axis]) <= 2 && eligible(held)) return held;
        for (const edge of [
            pointer[axis],
            pointer[axis] - 1,
            pointer[axis] + 1
        ])if (eligible(edge)) return edge;
        return undefined;
    };
    edges.x = choose("x", pointer.y);
    edges.y = choose("y", edges.x ?? pointer.x);
    return {
        endpoint: {
            x: edges.x ?? pointer.x,
            y: edges.y ?? pointer.y
        },
        edges: edges
    };
};
const $85e59abaaefadc89$export$fd9a95d31f60f9d2 = (anchor, pointer, axis, bypass = false)=>{
    if (bypass) return {
        endpoint: {
            ...pointer
        }
    };
    const dx = Math.abs(pointer.x - anchor.x), dy = Math.abs(pointer.y - anchor.y);
    if (Math.max(dx, dy) < 2) return {
        endpoint: {
            ...pointer
        }
    };
    if (axis === "horizontal" && dy > Math.max(2, dx * 0.65)) axis = undefined;
    if (axis === "vertical" && dx > Math.max(2, dy * 0.65)) axis = undefined;
    if (!axis) {
        if (dx >= 2 && dy <= Math.max(1, dx * 0.35)) axis = "horizontal";
        else if (dy >= 2 && dx <= Math.max(1, dy * 0.35)) axis = "vertical";
    }
    return {
        axis: axis,
        endpoint: axis === "horizontal" ? {
            x: pointer.x,
            y: anchor.y
        } : axis === "vertical" ? {
            x: anchor.x,
            y: pointer.y
        } : {
            ...pointer
        }
    };
};
const $85e59abaaefadc89$export$bcd1b35adbbcb204 = (anchor, pointer, axis, wallAt, previous, bypass = false, diagonal = false)=>{
    if (bypass) return;
    const distance = (point)=>diagonal ? Math.max(Math.abs(point.x - pointer.x), Math.abs(point.y - pointer.y)) : Math.abs(point.x - pointer.x) + Math.abs(point.y - pointer.y);
    const eligible = (point)=>{
        if (point.x === anchor.x && point.y === anchor.y) return false;
        if (axis === "horizontal" && point.y !== anchor.y || axis === "vertical" && point.x !== anchor.x) return false;
        if (!wallAt(point)) return false;
        const north = wallAt({
            x: point.x,
            y: point.y - 1
        }), south = wallAt({
            x: point.x,
            y: point.y + 1
        });
        const west = wallAt({
            x: point.x - 1,
            y: point.y
        }), east = wallAt({
            x: point.x + 1,
            y: point.y
        });
        const neighbours = Number(north) + Number(south) + Number(west) + Number(east);
        return neighbours <= 1 || neighbours === 2 && !(north && south || west && east);
    };
    if (previous && distance(previous) <= 2 && eligible(previous)) return {
        ...previous
    };
    let best;
    for(let dy = -1; dy <= 1; dy++)for(let dx = -1; dx <= 1; dx++){
        const point = {
            x: pointer.x + dx,
            y: pointer.y + dy
        };
        if (distance(point) > 1 || best && distance(point) >= distance(best) || !eligible(point)) continue;
        best = point;
    }
    return best;
};
const $85e59abaaefadc89$export$75b70d6a391d14b5 = (anchor, corner, shape, hollow, width, height, limit = 256)=>{
    const result = [];
    const seen = new Set();
    const add = (x, y)=>{
        const key = `${x},${y}`;
        if (result.length >= limit || x < 0 || y < 0 || x >= width || y >= height || seen.has(key)) return;
        seen.add(key);
        result.push({
            x: x,
            y: y
        });
    };
    const dx = corner.x - anchor.x, dy = corner.y - anchor.y;
    const connect = (from, to)=>{
        const dx = to.x - from.x, dy = to.y - from.y;
        const nx = Math.abs(dx), ny = Math.abs(dy);
        let x = from.x, y = from.y, ix = 0, iy = 0;
        add(x, y);
        while((ix < nx || iy < ny) && result.length < limit){
            if (ix < nx && (iy >= ny || (1 + 2 * ix) * ny <= (1 + 2 * iy) * nx)) {
                x += Math.sign(dx);
                ix++;
            } else {
                y += Math.sign(dy);
                iy++;
            }
            add(x, y);
        }
    };
    if (shape === "line") {
        connect(anchor, corner);
        return result;
    }
    const minX = Math.max(0, Math.min(anchor.x, corner.x)), maxX = Math.min(width - 1, Math.max(anchor.x, corner.x));
    const minY = Math.max(0, Math.min(anchor.y, corner.y)), maxY = Math.min(height - 1, Math.max(anchor.y, corner.y));
    const cx = (anchor.x + corner.x) / 2, cy = (anchor.y + corner.y) / 2;
    const rx = Math.abs(dx) / 2, ry = Math.abs(dy) / 2;
    if (shape === "ellipse" && hollow && rx > 0 && ry > 0) {
        const steps = Math.max(16, Math.ceil(Math.max(rx, ry) * 16));
        const pointAt = (step)=>({
                x: Math.round(cx + rx * Math.cos(step * Math.PI * 2 / steps)),
                y: Math.round(cy + ry * Math.sin(step * Math.PI * 2 / steps))
            });
        let previous = pointAt(0);
        for(let step = 1; step <= steps && result.length < limit; step++){
            const point = pointAt(step);
            connect(previous, point);
            previous = point;
        }
        return result;
    }
    const inside = (x, y)=>{
        if (x < minX || x > maxX || y < minY || y > maxY) return false;
        if (rx === 0 || ry === 0) return true;
        return ((x - cx) / (rx + 0.5)) ** 2 + ((y - cy) / (ry + 0.5)) ** 2 <= 1 + 1e-9;
    };
    const stepX = dx >= 0 ? 1 : -1, stepY = dy >= 0 ? 1 : -1;
    for(let y = stepY > 0 ? minY : maxY; y >= minY && y <= maxY; y += stepY)for(let x = stepX > 0 ? minX : maxX; x >= minX && x <= maxX; x += stepX){
        if (shape === "ellipse") {
            if (!inside(x, y)) continue;
            if (hollow && inside(x - 1, y) && inside(x + 1, y) && inside(x, y - 1) && inside(x, y + 1)) continue;
        } else if (hollow && x !== minX && x !== maxX && y !== minY && y !== maxY) continue;
        add(x, y);
        if (result.length >= limit) return result;
    }
    return result;
};





const $48a973472fff8afa$export$d2107414ce2376d5 = (world, yOffset = 0)=>({
        x: Math.floor(world.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
        y: Math.floor((world.y - yOffset) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))
    });


// Shared with server integration tests; keep the client import path stable.





const $5b68384bc2307256$export$aa8352a64fa8b594 = (point, level)=>level === undefined ? {
        x: point.x,
        y: point.y
    } : {
        x: point.x,
        y: point.y,
        level: level
    };
const $5b68384bc2307256$export$8b521e8d432acfa6 = (a, b)=>!!a && !!b && a.x === b.x && a.y === b.y && a.level === b.level;
const $5b68384bc2307256$export$1260587bd459848c = (map, at)=>{
    const delta = map.getMapDeltaAt?.(at.x, at.y, "sprite");
    if (!delta || delta.removed || delta.context?.previewTarget) return false;
    const parent = delta.context?.parent;
    if (parent && (parent.x !== at.x || parent.y !== at.y) && !delta.blocking) return false;
    return (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[delta.context?.itemType]?.buildType === "wall";
};
const $5b68384bc2307256$export$4f775e85f0d3a04a = (map, at)=>{
    const delta = map.getMapDeltaAt?.(at.x, at.y, "sky");
    if (!delta || delta.removed || delta.context?.previewTarget) return false;
    return (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[delta.context?.itemType]?.buildType === "roof";
};
const $5b68384bc2307256$export$480915369d1e3a2d = (world, yOffset)=>({
        x: Math.floor(world.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
        y: Math.floor((world.y - yOffset) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))
    });
const $5b68384bc2307256$export$e9d18b66b1ffdc36 = (map, at, fy = 0)=>{
    const parent = map.getMapDeltaAt?.(at.x, at.y, "sprite")?.context?.parent;
    const owner = parent && $5b68384bc2307256$export$1260587bd459848c(map, parent) ? {
        x: parent.x,
        y: parent.y
    } : undefined;
    if (!$5b68384bc2307256$export$1260587bd459848c(map, at)) return owner ? [
        owner
    ] : [];
    const own = {
        x: at.x,
        y: at.y
    };
    const south = {
        x: at.x,
        y: at.y + 1
    };
    if (owner && owner.x === south.x && owner.y === south.y) return fy >= 0.5 ? [
        owner,
        own
    ] : [
        own,
        owner
    ];
    return $5b68384bc2307256$export$1260587bd459848c(map, south) ? [
        own,
        south
    ] : [
        own
    ];
};
/** The cell under `world` on a plane drawn `yOffset` from the player's, and how far down it the point is (0 to 1). */ const $5b68384bc2307256$var$pointOnPlane = (world, yOffset)=>{
    const at = $5b68384bc2307256$export$480915369d1e3a2d(world, yOffset);
    return {
        at: at,
        fy: (world.y - yOffset) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - at.y
    };
};
const $5b68384bc2307256$export$5e32782cbcd2e44c = (world, storeys, planeOffset, requireWall = false, plannedWallAt)=>{
    let builtOn;
    for(let index = 0; index < storeys.length; index++){
        const { level: level, map: map } = storeys[index];
        const { at: at, fy: fy } = $5b68384bc2307256$var$pointOnPlane(world, planeOffset(level));
        // A wall's cap can occupy an empty structural cell. Close a one-cell gap on the
        // lowest level before stacking on the wall whose artwork extends into that gap.
        const hasWall = (point)=>$5b68384bc2307256$export$1260587bd459848c(map, point) || !!plannedWallAt?.(point, level);
        const gap = !hasWall(at) && (hasWall({
            x: at.x,
            y: at.y - 1
        }) && hasWall({
            x: at.x,
            y: at.y + 1
        }) || hasWall({
            x: at.x - 1,
            y: at.y
        }) && hasWall({
            x: at.x + 1,
            y: at.y
        }));
        if (requireWall && gap) {
            // Use the server's wall-shape rule: a room's center may look like a gap, but
            // filling it can create unrenderable solid wall blocks around the cap.
            const local = Array.from({
                length: 5
            }, (_, y)=>Array.from({
                    length: 5
                }, (_, x)=>x === 2 && y === 2 || hasWall({
                        x: at.x + x - 2,
                        y: at.y + y - 2
                    })));
            const indices = (0, $5cfd87a852590fa6$export$19a7a8d2d9b0fbb7)(local);
            const computable = [
                1,
                2,
                3
            ].every((y)=>[
                    1,
                    2,
                    3
                ].every((x)=>(0, $5cfd87a852590fa6$export$a936a6c53c1608e9)(indices[y][x])));
            if (computable) return {
                target: $5b68384bc2307256$export$aa8352a64fa8b594(at, level === storeys[0].level ? undefined : level),
                at: at
            };
        }
        const above = storeys.find((storey)=>storey.level === level + 1);
        for (const base of $5b68384bc2307256$export$e9d18b66b1ffdc36(map, at, fy)){
            const pick = {
                target: $5b68384bc2307256$export$aa8352a64fa8b594(base, level + 1),
                at: at
            };
            if (!(above && $5b68384bc2307256$export$1260587bd459848c(above.map, base)) && !plannedWallAt?.(base, level + 1)) return pick;
            builtOn = builtOn ?? pick;
        }
    }
    if (builtOn) return builtOn;
    if (requireWall) return undefined;
    const at = $5b68384bc2307256$export$480915369d1e3a2d(world, planeOffset(storeys[0].level));
    return {
        target: $5b68384bc2307256$export$aa8352a64fa8b594(at, storeys[0].level + 1),
        at: at
    };
};
const $5b68384bc2307256$export$a2caa11ea356d34f = (world, level, storeys, planeOffset, plannedWallAt)=>{
    const { at: at, fy: fy } = $5b68384bc2307256$var$pointOnPlane(world, planeOffset(level - 1));
    const below = storeys.find((storey)=>storey.level === level - 1);
    const destination = storeys.find((storey)=>storey.level === level);
    const candidates = below ? $5b68384bc2307256$export$e9d18b66b1ffdc36(below.map, at, fy) : [];
    const unfinished = candidates.find((point)=>!(destination && $5b68384bc2307256$export$1260587bd459848c(destination.map, point)) && !plannedWallAt?.(point, level));
    return {
        target: $5b68384bc2307256$export$aa8352a64fa8b594(unfinished || candidates[0] || at, level),
        at: at
    };
};
const $5b68384bc2307256$export$6ceade788b3368a2 = (world, storeys, planeOffset, roofOffset)=>{
    for(let index = storeys.length - 1; index >= 1; index--){
        const { level: level, map: map } = storeys[index];
        const cell = $5b68384bc2307256$export$480915369d1e3a2d(world, planeOffset(level) + roofOffset);
        if ($5b68384bc2307256$export$1260587bd459848c(map, cell) || $5b68384bc2307256$export$4f775e85f0d3a04a(map, cell)) return $5b68384bc2307256$export$aa8352a64fa8b594(cell, level);
    }
    return undefined;
};
const $5b68384bc2307256$export$aabe2728fdbf9c1a = (world, storeys, planeOffset)=>{
    for(let index = storeys.length - 1; index >= 1; index--){
        const { level: level, map: map } = storeys[index];
        const cell = $5b68384bc2307256$export$480915369d1e3a2d(world, planeOffset(level));
        if (map.isFloorOpeningAt?.(cell.x, cell.y)) continue;
        const delta = map.getMapDeltaAt?.(cell.x, cell.y, "map2");
        if (delta?.removed || delta?.context?.previewTarget) continue;
        const tile = map.resolveTileMapFromLayerId?.("map2")?.[cell.x]?.[cell.y];
        if (delta || tile && tile !== "0") return $5b68384bc2307256$export$aa8352a64fa8b594(cell, level);
    }
    return undefined;
};
const $5b68384bc2307256$export$8ea604f91abb6f7 = (world, storeys, planeOffset)=>{
    let sourceLevel = $5b68384bc2307256$export$aabe2728fdbf9c1a(world, storeys, planeOffset)?.level ?? storeys[0].level;
    for(let index = storeys.length - 1; index >= 0; index--){
        const { level: level, map: map } = storeys[index];
        if (level <= sourceLevel) break;
        const { at: at, fy: fy } = $5b68384bc2307256$var$pointOnPlane(world, planeOffset(level));
        if ($5b68384bc2307256$export$e9d18b66b1ffdc36(map, at, fy).length) {
            sourceLevel = level;
            break;
        }
    }
    const level = sourceLevel + 1;
    return $5b68384bc2307256$export$aa8352a64fa8b594($5b68384bc2307256$export$480915369d1e3a2d(world, planeOffset(level)), level);
};
const $5b68384bc2307256$export$6c0baffa48b2846c = (world, storeys, planeOffset, roofOffset, includeOwnRoof = true)=>{
    for(let index = storeys.length - 1; index >= (includeOwnRoof ? 0 : 1); index--){
        const { level: level, map: map } = storeys[index];
        const cell = $5b68384bc2307256$export$480915369d1e3a2d(world, planeOffset(level) + roofOffset);
        if ($5b68384bc2307256$export$4f775e85f0d3a04a(map, cell)) return $5b68384bc2307256$export$aa8352a64fa8b594(cell, level + 1);
    }
    return undefined;
};
const $5b68384bc2307256$export$3996d12f5871c95c = (world, storeys, planeOffset, plannedFloorAt)=>{
    for(let index = storeys.length - 1; index >= 0; index--){
        const { level: level, map: map } = storeys[index];
        const { at: at, fy: fy } = $5b68384bc2307256$var$pointOnPlane(world, planeOffset(level));
        const upper = storeys.find((storey)=>storey.level === level + 1);
        for (const wall of $5b68384bc2307256$export$e9d18b66b1ffdc36(map, at, fy)){
            if (upper && $5b68384bc2307256$var$floorCellAt(upper.map, wall, true) || plannedFloorAt?.(wall, level + 1)) continue;
            return $5b68384bc2307256$export$aa8352a64fa8b594(wall, level + 1);
        }
    }
    return undefined;
};
const $5b68384bc2307256$var$floorCellAt = (map, at, nativeFloor)=>{
    if (map.isFloorOpeningAt?.(at.x, at.y)) return false;
    const delta = map.getMapDeltaAt?.(at.x, at.y, "map2");
    if (delta?.removed || delta?.context?.previewTarget) return false;
    if (delta) return (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[delta.context?.itemType]?.buildType === "floor";
    const tile = nativeFloor && map.resolveTileMapFromLayerId?.("map2")?.[at.x]?.[at.y];
    return !!tile && tile !== "0";
};
const $5b68384bc2307256$export$a1e3993e6cfdfa04 = (world, kind, storeys, planeOffset, roofOffset, includeOwnRoof = true)=>{
    const own = storeys[0].level;
    const adjacent = (at, has)=>[
            {
                x: at.x - 1,
                y: at.y
            },
            {
                x: at.x + 1,
                y: at.y
            },
            {
                x: at.x,
                y: at.y - 1
            },
            {
                x: at.x,
                y: at.y + 1
            }
        ].some(has);
    const target = (at, level)=>$5b68384bc2307256$export$aa8352a64fa8b594(at, level === own ? undefined : level);
    for(let index = storeys.length - 1; index >= 0; index--){
        const { level: level, map: map } = storeys[index];
        if (includeOwnRoof || index > 0) {
            const cell = $5b68384bc2307256$export$480915369d1e3a2d(world, planeOffset(level) + roofOffset);
            if (adjacent(cell, (point)=>$5b68384bc2307256$export$4f775e85f0d3a04a(map, point))) return target(cell, kind === "floor" ? level + 1 : level);
        }
        const destination = kind === "floor" ? level : level - 1;
        if (destination < own) continue;
        // Pick on the destination plane, so the printed tile stays under the pointer.
        const cell = $5b68384bc2307256$export$480915369d1e3a2d(world, planeOffset(destination) + (kind === "roof" ? roofOffset : 0));
        if (adjacent(cell, (point)=>$5b68384bc2307256$var$floorCellAt(map, point, index > 0 || own > 0))) return target(cell, destination);
    }
    return undefined;
};
const $5b68384bc2307256$export$eeefffc66a89867c = (world, level, planeOffset, lift = 0)=>$5b68384bc2307256$export$aa8352a64fa8b594($5b68384bc2307256$export$480915369d1e3a2d(world, planeOffset(level) + lift), level);
const $5b68384bc2307256$export$8c9df9f5b4356b74 = (world, level, storeys, own)=>{
    const tileOn = (storey)=>{
        const layers = [
            ...storey.roofVisible === false ? [] : [
                "sky"
            ],
            "sprite3",
            "sprite2",
            "sprite",
            "map3",
            "map2"
        ];
        for (const layerId of layers){
            const yOffset = storey.yOffset + (layerId === "sky" ? (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)() : 0);
            const target = (0, $5a580aacfacf7705$export$27c8f30ca81f5bc2)(storey.map, $5b68384bc2307256$export$480915369d1e3a2d(world, yOffset), {
                includeRoof: false,
                layerIds: [
                    layerId
                ]
            });
            const interactions = target?.interactions.filter((verb)=>verb.name === "dismantle");
            if (interactions?.length) return {
                ...target,
                interactions: interactions,
                roomId: storey.roomId,
                yOffset: yOffset
            };
        }
        return undefined;
    };
    const highestFirst = storeys.slice().sort((a, b)=>b.level - a.level);
    for (const storey of highestFirst){
        const target = storey.level > level && tileOn(storey);
        if (target) return target;
    }
    const target = own();
    if (target) return target;
    for (const storey of highestFirst){
        const target = storey.level < level && tileOn(storey);
        if (target) return target;
    }
    return undefined;
};
const $5b68384bc2307256$export$f57c57f6601f6ca8 = (world, views, yOffset, options)=>{
    const pick = (at, level, hatchCenterY, hatch)=>{
        const target = {
            ...at,
            level: level
        };
        options?.onPick?.(target, {
            x: at.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
            y: hatchCenterY - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2
        }, hatch);
        return target;
    };
    const contextAt = (view, at)=>{
        const delta = view.map.getMapDeltaAt(at.x, at.y, "sprite2");
        return delta && !delta.removed ? delta.context : undefined;
    };
    for (const view of [
        ...views
    ].sort((a, b)=>b.level - a.level)){
        if (options?.visibleLevels && !options.visibleLevels.has(view.level)) continue;
        const column = Math.floor(world.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), row = Math.floor((world.y - yOffset(view.level)) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
        for(let x = column - 1; x <= column + 1; x++)for(let y = row; y <= row + 3; y++){
            const at = {
                x: x,
                y: y
            }, context = contextAt(view, at);
            if (!context || Math.abs(world.x - (x + .5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) > 22) continue;
            const links = context.context?.stairLandings ?? context.stairLandings;
            const baseline = (y + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + yOffset(view.level);
            if (context.itemType === "stairs-down" && !links?.up && Math.abs(world.y - (baseline - 8)) <= 12) return pick(at, view.level, baseline - 8, "top");
            // The cutaway draws this flight's hatch at its full interior height, while
            // the logical endpoint is on an upper storey that is intentionally hidden.
            const ceilingHeight = context.itemType === "stairs-up" && links?.up && options?.ceilingHeight?.(view, at);
            if (ceilingHeight && Math.abs(world.y - (baseline - ceilingHeight + 7)) <= 12) {
                const above = views.find((other)=>other.level === view.level + 1);
                if (!above || contextAt(above, at)?.itemType === "stairs-down") return pick(at, view.level + 1, baseline - ceilingHeight + 7, "ceiling");
            }
            // The first freestanding ladder has a taller original hatch. Aim there too.
            if (context.itemType === "stairs-up" && !links && Math.abs(world.y - (baseline - 80)) <= 10) {
                const above = views.find((other)=>other.level === view.level + 1);
                const upper = above && contextAt(above, at);
                if (upper?.itemType === "stairs-down" || !upper && (context.context?.stairLanding ?? context.stairLanding)?.roomId) return pick(at, view.level + 1, baseline - 80, "original");
            }
        }
    }
};




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $P8XPi = parcelRequire("P8XPi");
var $8t5Gy = parcelRequire("8t5Gy");
var $9Pi8W = parcelRequire("9Pi8W");
var $7Bs2Z = parcelRequire("7Bs2Z");

// The timing of the chapter checklist's rewards, as pure functions of a clock.
//
// Three beats, each a pose read off its own elapsed milliseconds (the same convention as the clue
// callouts and the wave reveal): nothing here owns a timer, so a frame-driven owner can pose any
// instant exactly and a test can assert the shape of a beat without a renderer.
//
//   * the STAMP -- a task's check landing in its row (chapter_checklist.ts)
//   * the TOAST -- the "task complete" plaque mid-screen, whose diamond then flies to that row
//   * the FANFARE -- the chapter-complete banner, which ends by flying into the checklist panel
//     (both in chapter_celebration.ts)
const $a8782f4c6450260e$export$5c5ee632c52bc4a2 = (t)=>Math.max(0, Math.min(1, t));
const $a8782f4c6450260e$export$3a89f8d6f6bf6c9f = (a, b, t)=>a + (b - a) * t;
const $a8782f4c6450260e$export$1157fb72e7fbceb5 = (t)=>1 - Math.pow(1 - $a8782f4c6450260e$export$5c5ee632c52bc4a2(t), 3);
const $a8782f4c6450260e$export$5da70c9577229d30 = (t)=>Math.pow($a8782f4c6450260e$export$5c5ee632c52bc4a2(t), 3);
const $a8782f4c6450260e$export$24656b269d8df7d6 = (t)=>{
    const x = $a8782f4c6450260e$export$5c5ee632c52bc4a2(t);
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
};
const $a8782f4c6450260e$export$3daa4a78f444687d = (t, s = 1.9)=>{
    const x = $a8782f4c6450260e$export$5c5ee632c52bc4a2(t) - 1;
    return 1 + (s + 1) * x * x * x + s * x * x;
};
const $a8782f4c6450260e$export$afc1bfabebaf28a2 = (ms, from, to)=>$a8782f4c6450260e$export$5c5ee632c52bc4a2((ms - from) / Math.max(1, to - from));
const $a8782f4c6450260e$export$671c724dbdd0c3a9 = (a, b, t)=>{
    const k = $a8782f4c6450260e$export$5c5ee632c52bc4a2(t);
    const ch = (shift)=>Math.round($a8782f4c6450260e$export$3a89f8d6f6bf6c9f(a >> shift & 0xff, b >> shift & 0xff, k));
    return ch(16) << 16 | ch(8) << 8 | ch(0);
};
const $a8782f4c6450260e$export$75c48cadd9435142 = (from, via, to, t)=>{
    const u = 1 - t;
    return {
        x: u * u * from.x + 2 * u * t * via.x + t * t * to.x,
        y: u * u * from.y + 2 * u * t * via.y + t * t * to.y
    };
};
const $a8782f4c6450260e$export$b531f3359e0b6c92 = 950;
const $a8782f4c6450260e$export$b67b2e3d2289fb95 = (ms)=>({
        // Oversized on the first frame, so the change is never a quiet swap of one sprite for another.
        socketScale: ms >= $a8782f4c6450260e$export$b531f3359e0b6c92 ? 1 : $a8782f4c6450260e$export$3a89f8d6f6bf6c9f(2.1, 1, $a8782f4c6450260e$export$3daa4a78f444687d($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 320), 2.6)),
        checkDraw: $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 60, 300)),
        ringT: $a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 520),
        sparkT: $a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 560),
        sweepT: $a8782f4c6450260e$export$24656b269d8df7d6($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 90, 640)),
        // 1 = the label in full gold, 0 = settled to the done colour.
        labelGold: ms < 120 ? 1 : 1 - $a8782f4c6450260e$export$5da70c9577229d30($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 380, $a8782f4c6450260e$export$b531f3359e0b6c92)),
        // The whole panel's rim answers the stamp, briefly.
        panelFlash: 1 - $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 700)),
        done: ms >= $a8782f4c6450260e$export$b531f3359e0b6c92
    });
const $a8782f4c6450260e$export$921e25d40d43e097 = 300;
const $a8782f4c6450260e$export$6b88bd29e71fedd0 = 1250;
const $a8782f4c6450260e$export$3285fc20e13e2402 = 520;
const $a8782f4c6450260e$export$c33daae13dc00149 = 260;
const $a8782f4c6450260e$export$e851b30477ae7112 = 560;
const $a8782f4c6450260e$export$2e4600308c0388c8 = (holdMs)=>{
    const leaveAt = $a8782f4c6450260e$export$921e25d40d43e097 + holdMs;
    const cometAt = leaveAt + 40;
    return {
        leaveAt: leaveAt,
        cometAt: cometAt,
        arriveAt: cometAt + $a8782f4c6450260e$export$e851b30477ae7112,
        endAt: cometAt + $a8782f4c6450260e$export$e851b30477ae7112 + 40
    };
};
const $a8782f4c6450260e$export$f1e303297d2a4077 = (ms, holdMs)=>{
    const { leaveAt: leaveAt, cometAt: cometAt, arriveAt: arriveAt } = $a8782f4c6450260e$export$2e4600308c0388c8(holdMs);
    const enter = $a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, $a8782f4c6450260e$export$921e25d40d43e097);
    const leave = $a8782f4c6450260e$export$afc1bfabebaf28a2(ms, leaveAt, leaveAt + $a8782f4c6450260e$export$c33daae13dc00149);
    return {
        alpha: Math.min($a8782f4c6450260e$export$1157fb72e7fbceb5(enter * 1.6), 1 - $a8782f4c6450260e$export$5da70c9577229d30(leave)),
        scale: ms < leaveAt ? $a8782f4c6450260e$export$3a89f8d6f6bf6c9f(0.45, 1, $a8782f4c6450260e$export$3daa4a78f444687d(enter, 2.2)) : $a8782f4c6450260e$export$3a89f8d6f6bf6c9f(1, 0.86, $a8782f4c6450260e$export$1157fb72e7fbceb5(leave)),
        // Rises the last few pixels into place, and lifts away as it goes.
        lift: ms < leaveAt ? 10 * (1 - $a8782f4c6450260e$export$1157fb72e7fbceb5(enter)) : -12 * $a8782f4c6450260e$export$1157fb72e7fbceb5(leave),
        burstT: $a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 40, 640),
        shineT: $a8782f4c6450260e$export$24656b269d8df7d6($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 260, 820)),
        // The diamond flies from the toast to the row: 0 before it sets off, 1 on arrival.
        cometT: ms < cometAt ? -1 : $a8782f4c6450260e$export$24656b269d8df7d6($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, cometAt, arriveAt)),
        arrived: ms >= arriveAt
    };
};
const $a8782f4c6450260e$export$f99c4575ad0d4c71 = 2600;
const $a8782f4c6450260e$export$2ce1343fc2af3271 = 620;
const $a8782f4c6450260e$export$591a652e66acb793 = ()=>{
    const dockAt = $a8782f4c6450260e$export$f99c4575ad0d4c71;
    return {
        dockAt: dockAt,
        arriveAt: dockAt + $a8782f4c6450260e$export$2ce1343fc2af3271,
        endAt: dockAt + $a8782f4c6450260e$export$2ce1343fc2af3271 + 60
    };
};
const $a8782f4c6450260e$export$5f0e9cd2ff3dbcb8 = (ms)=>{
    const { dockAt: dockAt, arriveAt: arriveAt } = $a8782f4c6450260e$export$591a652e66acb793();
    const dock = $a8782f4c6450260e$export$afc1bfabebaf28a2(ms, dockAt, arriveAt);
    return {
        flash: ms < 0 ? 0 : 1 - $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 420)),
        ringT: $a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 900),
        raysOpen: $a8782f4c6450260e$export$3daa4a78f444687d($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 60, 700), 1.4),
        raysAlpha: Math.min($a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 60, 400)), 1 - $a8782f4c6450260e$export$5da70c9577229d30($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, dockAt - 300, dockAt + 120))),
        overlineAlpha: $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 120, 420)),
        titleScale: $a8782f4c6450260e$export$3a89f8d6f6bf6c9f(1.6, 1, $a8782f4c6450260e$export$3daa4a78f444687d($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 140, 520), 1.7)),
        titleAlpha: $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 140, 340)),
        rule: $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 420, 900)),
        stampScale: ms < 620 ? 0 : $a8782f4c6450260e$export$3a89f8d6f6bf6c9f(2.4, 1, $a8782f4c6450260e$export$3daa4a78f444687d($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 620, 880), 2.4)),
        stampAlpha: $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 620, 720)),
        stampBurstT: $a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 640, 1200),
        shineT: $a8782f4c6450260e$export$24656b269d8df7d6($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 1100, 1800)),
        embers: ms > 200 && ms < dockAt + 200,
        // The banner collapsing into the comet that flies to the panel.
        bannerScale: $a8782f4c6450260e$export$3a89f8d6f6bf6c9f(1, 0.08, $a8782f4c6450260e$export$5da70c9577229d30(dock)),
        bannerAlpha: 1 - $a8782f4c6450260e$export$5da70c9577229d30($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, dockAt, dockAt + $a8782f4c6450260e$export$2ce1343fc2af3271 * 0.75)),
        cometT: ms < dockAt ? -1 : $a8782f4c6450260e$export$24656b269d8df7d6(dock),
        arrived: ms >= arriveAt
    };
};
const $a8782f4c6450260e$export$12d6e833f723515a = 140;
const $a8782f4c6450260e$export$1b9ad48ce16ad8f8 = 520;
const $a8782f4c6450260e$var$CTA_LIT_AT = $a8782f4c6450260e$export$12d6e833f723515a + $a8782f4c6450260e$export$1b9ad48ce16ad8f8;
const $a8782f4c6450260e$export$7ae8158c70919485 = (ms)=>({
        // The unlit plate settling into place before it catches.
        plateAlpha: $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 180)),
        rise: 5 * (1 - $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 260))),
        ignite: $a8782f4c6450260e$export$24656b269d8df7d6($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, $a8782f4c6450260e$export$12d6e833f723515a, $a8782f4c6450260e$var$CTA_LIT_AT)),
        // The soft edge that leads the light across.
        edge: ms > $a8782f4c6450260e$export$12d6e833f723515a && ms < $a8782f4c6450260e$var$CTA_LIT_AT + 120 ? Math.sin(Math.PI * $a8782f4c6450260e$export$afc1bfabebaf28a2(ms, $a8782f4c6450260e$export$12d6e833f723515a, $a8782f4c6450260e$var$CTA_LIT_AT + 120)) : 0,
        // A brief warmth as the light lands, gone within a second.
        glow: ms < $a8782f4c6450260e$var$CTA_LIT_AT - 80 ? 0 : 1 - $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, $a8782f4c6450260e$var$CTA_LIT_AT - 80, $a8782f4c6450260e$var$CTA_LIT_AT + 900)),
        // One shine, once.
        shineT: ms > $a8782f4c6450260e$var$CTA_LIT_AT + 100 && ms < $a8782f4c6450260e$var$CTA_LIT_AT + 800 ? $a8782f4c6450260e$export$24656b269d8df7d6($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, $a8782f4c6450260e$var$CTA_LIT_AT + 100, $a8782f4c6450260e$var$CTA_LIT_AT + 800)) : -1
    });
const $a8782f4c6450260e$export$17fa3046cb6a40e = 380;
const $a8782f4c6450260e$export$50923bb819199191 = 1050;
const $a8782f4c6450260e$export$e030a49c2fd33dd2 = $a8782f4c6450260e$export$50923bb819199191 + 200;
const $a8782f4c6450260e$export$9dfdbc72faaf548c = 820;
const $a8782f4c6450260e$export$fe9732bd9a0ade13 = 480;
const $a8782f4c6450260e$export$979371c67e3966f9 = (ms)=>({
        hearth: $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 1100)),
        crestAlpha: $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 120, 260)),
        crestScale: ms < 120 ? 0.35 : $a8782f4c6450260e$export$3a89f8d6f6bf6c9f(0.35, 1, $a8782f4c6450260e$export$3daa4a78f444687d($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 120, 460), 2.2)),
        lit: $a8782f4c6450260e$export$24656b269d8df7d6($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, $a8782f4c6450260e$export$17fa3046cb6a40e - 80, $a8782f4c6450260e$export$17fa3046cb6a40e + 120)),
        flash: ms < $a8782f4c6450260e$export$17fa3046cb6a40e ? 0 : 1 - $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, $a8782f4c6450260e$export$17fa3046cb6a40e, $a8782f4c6450260e$export$17fa3046cb6a40e + 520)),
        burstT: $a8782f4c6450260e$export$afc1bfabebaf28a2(ms, $a8782f4c6450260e$export$17fa3046cb6a40e, $a8782f4c6450260e$export$17fa3046cb6a40e + 620),
        ringT: $a8782f4c6450260e$export$afc1bfabebaf28a2(ms, $a8782f4c6450260e$export$17fa3046cb6a40e, $a8782f4c6450260e$export$17fa3046cb6a40e + 760),
        rule: $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 160, 760)),
        overlineAlpha: $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 480, 820)),
        overlineRise: 6 * (1 - $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 480, 900))),
        titleAlpha: $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 600, 980)),
        titleRise: 14 * (1 - $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 600, 1150))),
        titleScale: $a8782f4c6450260e$export$3a89f8d6f6bf6c9f(1.06, 1, $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 600, 1150))),
        // 1 = the title in full ember gold, 0 = cooled to its resting cream.
        heat: 1 - $a8782f4c6450260e$export$5da70c9577229d30($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 700, 1900)),
        titleShineT: ms > 1150 && ms < 1900 ? $a8782f4c6450260e$export$24656b269d8df7d6($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 1150, 1900)) : -1,
        bodyAlpha: $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 850, 1250)),
        bodyRise: 8 * (1 - $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 850, 1300))),
        actions: $a8782f4c6450260e$export$7ae8158c70919485(ms - $a8782f4c6450260e$export$50923bb819199191),
        ready: ms >= $a8782f4c6450260e$export$e030a49c2fd33dd2
    });
const $a8782f4c6450260e$export$e30b297803fc4af7 = (ms)=>({
        actionsAlpha: 1 - $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 200)),
        bodyAlpha: 1 - $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 260)),
        flare: ms < 110 ? $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 110)) : 1 - $a8782f4c6450260e$export$24656b269d8df7d6($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 110, 700)),
        burstT: $a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 600),
        ringT: $a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 700),
        gust: $a8782f4c6450260e$export$5da70c9577229d30($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 500)),
        push: $a8782f4c6450260e$export$5da70c9577229d30($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 120, $a8782f4c6450260e$export$9dfdbc72faaf548c)),
        contentAlpha: 1 - $a8782f4c6450260e$export$5da70c9577229d30($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 220, 680)),
        coverAlpha: 1 - $a8782f4c6450260e$export$24656b269d8df7d6($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 280, $a8782f4c6450260e$export$9dfdbc72faaf548c)),
        done: ms >= $a8782f4c6450260e$export$9dfdbc72faaf548c
    });
const $a8782f4c6450260e$export$16764a2d3c490b4a = (ms)=>({
        contentAlpha: 1 - $a8782f4c6450260e$export$1157fb72e7fbceb5($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 0, 260)),
        coverAlpha: 1 - $a8782f4c6450260e$export$24656b269d8df7d6($a8782f4c6450260e$export$afc1bfabebaf28a2(ms, 80, $a8782f4c6450260e$export$fe9732bd9a0ade13)),
        done: ms >= $a8782f4c6450260e$export$fe9732bd9a0ade13
    });
class $a8782f4c6450260e$export$f709befbd1bbaa29 {
    constructor(value, ms, mix = $a8782f4c6450260e$export$3a89f8d6f6bf6c9f, ease = $a8782f4c6450260e$export$24656b269d8df7d6){
        this.ms = ms;
        this.mix = mix;
        this.ease = ease;
        this.at = -Infinity;
        this.value = (clock)=>this.mix(this.from, this.to, this.ease($a8782f4c6450260e$export$afc1bfabebaf28a2(clock - this.at, 0, this.ms)));
        this.target = ()=>this.to;
        this.settled = (clock)=>clock - this.at >= this.ms;
        this./** Head for `target` from wherever the value is now. */ set = (target, clock)=>{
            if (target === this.to) return;
            this.from = this.value(clock);
            this.to = target;
            this.at = clock;
        };
        this.snap = (value)=>{
            this.from = this.to = value;
            this.at = -Infinity;
        };
        this.from = this.to = value;
    }
}
const $a8782f4c6450260e$export$f98af890f38e203b = (ms)=>0.5 - 0.5 * Math.cos(ms / 1600 * Math.PI * 2);


// Logical pixels. Viewport scaling is applied by the UI layout, not by these text styles.
const $ef882f0a643d87d9$export$ed6aa976aece225c = {
    tiny: 8,
    small: 12,
    medium: 14,
    normal: 16,
    large: 20
};
const $ef882f0a643d87d9$export$9b7bc1f57570b828 = {
    fontSize: $ef882f0a643d87d9$export$ed6aa976aece225c.medium
};
const $ef882f0a643d87d9$export$2653e0d5dd45b294 = "Verdana, Geneva, sans-serif";
const $ef882f0a643d87d9$export$51d6375781d583cb = "Jost, Verdana, Geneva, sans-serif";
const $ef882f0a643d87d9$export$dfb0a212724b9d91 = (value, gap = "\u2009")=>value.split(" ").map((word)=>word.split("").join(gap)).join(`${gap} ${gap}`);
const $ef882f0a643d87d9$export$f486164f64ee20e5 = 0x808080;
const $ef882f0a643d87d9$export$a57e4d4d74a95378 = {
    caption: {
        fontSize: $ef882f0a643d87d9$export$ed6aa976aece225c.small
    },
    label: {
        fontSize: $ef882f0a643d87d9$export$ed6aa976aece225c.medium
    },
    body: {
        fontSize: $ef882f0a643d87d9$export$ed6aa976aece225c.normal
    },
    title: {
        fontSize: $ef882f0a643d87d9$export$ed6aa976aece225c.large,
        bold: true
    },
    heading: {
        fontSize: 30,
        bold: true
    },
    display: {
        fontSize: 40,
        bold: true
    },
    // Dense HUD panels use the same hierarchy at a smaller logical scale.
    overline: {
        fontSize: $ef882f0a643d87d9$export$ed6aa976aece225c.tiny
    },
    compactCaption: {
        fontSize: 9
    },
    compactLabel: {
        fontSize: 11
    },
    compactBody: {
        fontSize: $ef882f0a643d87d9$export$ed6aa976aece225c.small
    },
    compactTitle: {
        fontSize: $ef882f0a643d87d9$export$ed6aa976aece225c.normal,
        bold: true
    },
    compactHeading: {
        fontSize: $ef882f0a643d87d9$export$ed6aa976aece225c.large,
        bold: true
    },
    compactDisplay: {
        fontSize: 30,
        bold: true
    },
    // World text retains its screen footprint and fixed speech rasterization under PiP rendering.
    entityName: {
        fontSize: $ef882f0a643d87d9$export$ed6aa976aece225c.small
    },
    entityLabel: {
        fontSize: $ef882f0a643d87d9$export$ed6aa976aece225c.tiny
    },
    speech: {
        fontSize: $ef882f0a643d87d9$export$ed6aa976aece225c.small,
        color: 0xffffff,
        resolutionScale: 2
    },
    effect: {
        fontSize: 10,
        color: 0x00ee00
    },
    damage: {
        fontSize: 15,
        color: 0xff0000,
        bold: true
    },
    entityImportant: {
        fontSize: 15,
        bold: true
    }
};
const $ef882f0a643d87d9$export$911e9fe6c3536bd5 = {
    ScoreFont: $ef882f0a643d87d9$export$9b7bc1f57570b828,
    NameFont: $ef882f0a643d87d9$export$9b7bc1f57570b828,
    BannerFont: {
        fontSize: 20,
        color: 0xffffff
    },
    LogoFont: {
        fontSize: 40,
        color: 0xffffff
    },
    RedChatFont: {
        fontSize: 10,
        color: 0xffa500
    },
    SmallFont: {
        fontSize: 10
    },
    AlertFont: {
        fontSize: 30,
        color: 0xff0000
    },
    DamageFont: $ef882f0a643d87d9$export$a57e4d4d74a95378.damage,
    EntityImportantFont: $ef882f0a643d87d9$export$a57e4d4d74a95378.entityImportant,
    ChatFont: $ef882f0a643d87d9$export$a57e4d4d74a95378.effect,
    BubbleChatFont: $ef882f0a643d87d9$export$a57e4d4d74a95378.speech,
    "Normal-Green-Bold": {
        fontSize: 15,
        color: 0x00ff00
    },
    ImportantFont: {
        fontSize: 30,
        color: 0xffffff
    },
    GiganticFont: {
        fontSize: 100,
        color: 0xffffff
    }
};
const $ef882f0a643d87d9$export$e67e74afd009f581 = (name)=>Object.prototype.hasOwnProperty.call($ef882f0a643d87d9$export$911e9fe6c3536bd5, name) ? name : "ScoreFont";


const $f982fe860ce57e21$export$1f06c1fa3b73c517 = {
    glide: 110,
    settle: 240,
    show: 200,
    press: 260,
    breath: 2400,
    idle: 1500,
    fade: 700
};
const $f982fe860ce57e21$export$af2729ca435ac3d2 = 0.75;
const $f982fe860ce57e21$var$CURSOR_INK = 0x18251f;
const $f982fe860ce57e21$var$CURSOR_ARM = 9;
/** One colouring of the build cursor: bracket corners, the cell's edge dotted between them, and a warm light. */ class $f982fe860ce57e21$var$BuildCursorLook extends (0, $8t5Gy.Container) {
    constructor(core, light){
        super(), this.light = new (0, $gwPoJ.Graphics)(), /** Stand the brackets `open` px off the cell's corners (negative: pinched in). At 0 they sit just inside the cell. */ this.spread = (open)=>{
            const near = 2 - open, far = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - near;
            [
                [
                    near,
                    near
                ],
                [
                    far,
                    near
                ],
                [
                    far,
                    far
                ],
                [
                    near,
                    far
                ]
            ].forEach(([x, y], i)=>this.corners[i].position.set(x, y));
        };
        if (light !== undefined) {
            // Light, not paint: added onto the ground, so the cell looks lit rather than washed over.
            this.light.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
            for(let i = 0; i < 10; i++){
                const inset = 3 + i * 1.2;
                this.light.beginFill(light, 0.05);
                this.light.drawRoundedRect(inset, inset, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 2 * inset, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 2 * inset, Math.max(2, 7 - i * 0.4));
                this.light.endFill();
            }
        }
        // Dots between the corners still mark out the whole cell, as the roof's dotted rise does.
        const edge = new (0, $gwPoJ.Graphics)().beginFill(core, 0.8);
        for (const along of [
            (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 - 2,
            (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 + 2
        ])for (const [x, y] of [
            [
                along,
                2
            ],
            [
                along,
                (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 2
            ],
            [
                2,
                along
            ],
            [
                (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 2,
                along
            ]
        ])edge.drawCircle(x, y, 0.75);
        edge.endFill();
        this.corners = [
            0,
            1,
            2,
            3
        ].map((corner)=>{
            const g = new (0, $gwPoJ.Graphics)();
            // A dark casing keeps the gold readable over bright, textured grass.
            for (const [width, color, alpha] of [
                [
                    4,
                    $f982fe860ce57e21$var$CURSOR_INK,
                    0.92
                ],
                [
                    2,
                    core,
                    1
                ]
            ]){
                g.lineStyle({
                    width: width,
                    color: color,
                    alpha: alpha,
                    cap: (0, $gwPoJ.LINE_CAP).ROUND,
                    join: (0, $gwPoJ.LINE_JOIN).ROUND
                });
                g.moveTo($f982fe860ce57e21$var$CURSOR_ARM, 0).lineTo(0, 0).lineTo(0, $f982fe860ce57e21$var$CURSOR_ARM);
            }
            g.angle = corner * 90;
            return g;
        });
        this.addChild(this.light, edge, ...this.corners);
    }
}
const $f982fe860ce57e21$var$hintText = (fill)=>{
    const text = new (0, $9Pi8W.Text)("", {
        fontFamily: (0, $ef882f0a643d87d9$export$2653e0d5dd45b294),
        fontSize: 7,
        fontWeight: "bold",
        fill: fill
    });
    // The cursor is in world space and the camera zooms it, so draw the glyphs dense enough to stay sharp.
    text.resolution = 8;
    text.anchor.set(0, 0.5);
    return text;
};
class $f982fe860ce57e21$export$67df9b6a07061a6f extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.plate = new (0, $gwPoJ.Graphics)(), this.glyphs = new (0, $gwPoJ.Graphics)(), this.label = $f982fe860ce57e21$var$hintText(0xffe7a3), this.cost = $f982fe860ce57e21$var$hintText(0xd9c08a), this.key = "", this.set = (hint)=>{
            const key = hint ? `${hint.text}|${!!hint.rise}|${hint.cost ?? ""}|${hint.lift ?? 0}` : "";
            if (key === this.key) return;
            this.key = key;
            this.visible = !!hint;
            if (!hint) return;
            this.y = -3 - (hint.lift ?? 0);
            const height = 11, middle = height / 2, pad = 3.5, gap = 2.5;
            const g = this.glyphs.clear();
            let x = pad;
            if (hint.rise) {
                g.beginFill(0xffd166, 1).drawPolygon([
                    x,
                    middle + 1.5,
                    x + 2.5,
                    middle - 1.5,
                    x + 5,
                    middle + 1.5
                ]).endFill();
                x += 5 + gap;
            }
            this.label.text = hint.text;
            this.label.position.set(x, middle);
            x += this.label.width;
            this.cost.visible = hint.cost !== undefined;
            if (hint.cost !== undefined) {
                // A dot, then a tiny ladder and how many it takes.
                x += gap;
                g.beginFill(0xd9c08a, 0.6).drawCircle(x + 0.5, middle, 0.6).endFill();
                x += 1 + gap;
                g.beginFill(0xc8935a, 1);
                g.drawRect(x, middle - 3, 0.8, 6).drawRect(x + 3.2, middle - 3, 0.8, 6);
                for (const y of [
                    -2,
                    0,
                    2
                ])g.drawRect(x + 0.8, middle + y - 0.35, 2.4, 0.7);
                g.endFill();
                x += 5.5;
                this.cost.text = String(hint.cost);
                this.cost.position.set(x, middle);
                x += this.cost.width;
            }
            const width = x + pad;
            this.plate.clear().lineStyle(1, 0xffd166, 0.55).beginFill($f982fe860ce57e21$var$CURSOR_INK, 0.9).drawRoundedRect(0, 0, width, height, 3).endFill();
            // Centred over the cell, standing just above it.
            this.pivot.set(width / 2, height);
        };
        this.addChild(this.plate, this.glyphs, this.label, this.cost);
        this.visible = false;
        this.position.set((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2, -3);
    }
    get text() {
        return this.visible ? this.label.text : "";
    }
}
class $f982fe860ce57e21$export$7e8a46a1c03ab825 extends (0, $8t5Gy.Container) {
    constructor(now = ()=>Date.now()){
        super(), this.now = now, this.body = new (0, $8t5Gy.Container)(), this.ready = new $f982fe860ce57e21$var$BuildCursorLook(0xffd166, 0x6a3c00), this.refused = new $f982fe860ce57e21$var$BuildCursorLook(0xff8174), this.cross = new (0, $gwPoJ.Graphics)(), this.hint = new $f982fe860ce57e21$export$67df9b6a07061a6f(), this./** A word over the cell about what a press does there; none takes it away. */ setHint = (hint)=>this.hint.set(hint), this.verdictValue = "ready", this.landedAt = -Infinity, this.shownAt = -Infinity, this.pressedAt = -Infinity, this.verdictAt = -Infinity, this.drawn = false, this./** How far the brackets stand off the cell's corners right now, px (negative: pinched in). */ spread = 0, this./** Mark the cell whose origin is (x, y). From a cell nearby that was just on screen, the cursor glides there. */ moveTo = (x, y)=>{
            if (x === this.x && y === this.y) return;
            const dx = this.x + this.body.x - x, dy = this.y + this.body.y - y;
            this.position.set(x, y);
            this.movedAt = this.now();
            // A long jump appears in place rather than flying across the scene.
            if (this.drawn && Math.hypot(dx, dy) <= 3 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) {
                this.glide = {
                    dx: dx,
                    dy: dy,
                    at: this.movedAt
                };
                this.landedAt = this.movedAt;
            } else this.glide = undefined;
            // Posed at once: back from an idle fade this instant, and drawn where its glide starts, never a frame
            // early at the new cell.
            this.pose(this.movedAt);
        }, this.setVerdict = (verdict)=>{
            if (verdict === this.verdictValue) return;
            this.verdictValue = verdict;
            this.verdictAt = this.now();
            this.ready.visible = verdict !== "blocked";
            this.refused.visible = verdict === "blocked";
            // Out of reach: the same target, unlit and faded, as if not yet in hand.
            this.ready.alpha = verdict === "far" ? 0.45 : 1;
            this.ready.light.visible = verdict === "ready";
        }, this./** The player placed here: the brackets stamp down, or shake their head where the cell won't take it. */ press = ()=>{
            this.pressedAt = this.movedAt = this.now();
        }, this./** Called every frame. */ animate = ()=>{
            if (!this.visible) {
                this.drawn = false;
                return;
            }
            const now = this.now();
            if (!this.drawn) {
                this.drawn = true;
                this.shownAt = this.movedAt = now;
                this.glide = undefined;
            }
            this.pose(now);
        }, this.pose = (now)=>{
            const motion = $f982fe860ce57e21$export$1f06c1fa3b73c517;
            const left = this.glide ? 1 - (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((now - this.glide.at) / motion.glide) : 0;
            if (left > 0) this.body.position.set(this.glide.dx * left, this.glide.dy * left);
            else {
                this.glide = undefined;
                this.body.position.set(0, 0);
            }
            const landed = (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)((now - this.landedAt) / motion.settle);
            const shown = (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)((now - this.shownAt) / motion.show);
            const pressed = (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)((now - this.pressedAt) / motion.press);
            // A press comes down fast and lets go slowly.
            const stamp = pressed >= 1 ? 0 : pressed < 0.2 ? pressed / 0.2 : (1 - (pressed - 0.2) / 0.8) ** 2;
            const breath = 0.5 - 0.5 * Math.cos(now * Math.PI * 2 / motion.breath);
            // The brackets arrive a little wide and snap shut on the cell, overshooting just inside it.
            let open = 2 * (1 - (0, $a8782f4c6450260e$export$3daa4a78f444687d)(landed, 2.2)) + 4 * (1 - (0, $a8782f4c6450260e$export$3daa4a78f444687d)(shown, 2.2)) - $f982fe860ce57e21$export$af2729ca435ac3d2 * breath * landed * shown;
            if (this.verdictValue === "blocked") this.body.x += 1.5 * Math.sin(pressed * Math.PI * 5) * (1 - pressed);
            else open -= 1.75 * stamp;
            this.spread = open;
            this.ready.spread(open);
            this.refused.spread(open);
            this.ready.light.alpha = (0.55 + 0.45 * landed) * (1 - 0.15 * breath) + 0.5 * stamp;
            this.cross.scale.set(0.5 + 0.5 * (0, $a8782f4c6450260e$export$3daa4a78f444687d)((now - this.verdictAt) / 160, 2.2));
            // Left still, it eases away; it never lingers half-faded.
            const idle = (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)((now - this.movedAt - motion.idle) / motion.fade);
            this.body.alpha = (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)((now - this.shownAt) / 120) * (1 - idle * idle * (3 - 2 * idle));
        };
        const center = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2, reach = 3.5;
        for (const [width, color] of [
            [
                4,
                $f982fe860ce57e21$var$CURSOR_INK
            ],
            [
                2,
                0xff8174
            ]
        ]){
            this.cross.lineStyle({
                width: width,
                color: color,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            this.cross.moveTo(-reach, -reach).lineTo(reach, reach).moveTo(reach, -reach).lineTo(-reach, reach);
        }
        this.cross.position.set(center, center);
        this.refused.addChild(this.cross);
        this.refused.visible = false;
        this.body.addChild(this.ready, this.refused, this.hint);
        this.addChild(this.body);
        this.movedAt = this.now();
        this.pose(this.movedAt);
    }
    get verdict() {
        return this.verdictValue;
    }
}
const $f982fe860ce57e21$export$3409d6ec6e2eb170 = (g)=>{
    for (const x of [
        (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.25,
        (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.5,
        (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.75
    ]){
        // Straddle the edge, in the cursor's gold over a thin casing, so they read over the wall below.
        g.lineStyle(1, 0x18251f, 0.9);
        g.beginFill(0xffd166, 1);
        g.drawPolygon([
            x - 3.5,
            (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 0.5,
            x,
            (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 4.5,
            x + 3.5,
            (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 0.5
        ]);
        g.endFill();
    }
    return g;
};
const $f982fe860ce57e21$export$e8b66bd3be85c67 = 1600;
const $f982fe860ce57e21$export$8342a8def31b6704 = 10;
const $f982fe860ce57e21$export$c54bfeee02f5cd44 = (now)=>{
    const t = (now % $f982fe860ce57e21$export$e8b66bd3be85c67 + $f982fe860ce57e21$export$e8b66bd3be85c67) % $f982fe860ce57e21$export$e8b66bd3be85c67 / $f982fe860ce57e21$export$e8b66bd3be85c67;
    const eased = t * (2 - t);
    const alpha = t < 0.15 ? t / 0.15 : t < 0.45 ? 1 : 1 - (t - 0.45) / 0.55;
    return {
        y: -$f982fe860ce57e21$export$8342a8def31b6704 * eased,
        alpha: alpha
    };
};
class $f982fe860ce57e21$export$4f74dc6ed96966c4 {
    constructor(cursor){
        this.arrows = $f982fe860ce57e21$export$3409d6ec6e2eb170(new (0, $gwPoJ.Graphics)());
        this.label = new (0, $9Pi8W.Text)("", {
            fontFamily: "Arial",
            fontSize: 7,
            fontWeight: "bold",
            fill: 0xffe7a3,
            stroke: 0x18251f,
            strokeThickness: 2
        });
        /** `shown` false: the cell says what it does in words (a ladder hatch), so the cue stands aside. */ this.update = (atop, level, shown = true)=>{
            this.arrows.visible = atop && shown;
            this.label.visible = shown;
            const text = String(level);
            if (this.label.text !== text) this.label.text = text;
        };
        /** Called every frame: the arrows keep climbing out of the bottom edge, so the cell reads as building up. */ this.animate = (now)=>{
            if (!this.arrows.visible) return;
            const { y: y, alpha: alpha } = $f982fe860ce57e21$export$c54bfeee02f5cd44(now);
            this.arrows.y = y;
            this.arrows.alpha = alpha;
        };
        this.arrows.visible = false;
        // The cursor is in world space and the camera zooms it, so draw the glyphs dense enough to stay sharp.
        this.label.resolution = 8;
        // Inside the top right corner, so the cursor still outlines exactly its cell.
        this.label.anchor.set(1, 0);
        this.label.position.set((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 4, 3);
        cursor.addChild(this.arrows, this.label);
    }
}
const $f982fe860ce57e21$export$ee41eff74b98381e = (g, lift)=>{
    g.beginFill(0xffd166, 0.95);
    for(let y = 0; y >= lift; y -= 4)g.drawCircle(0, y, 1);
    g.drawPolygon([
        0,
        lift,
        -4,
        lift + 7,
        4,
        lift + 7
    ]);
    g.endFill();
    return g;
};
class $f982fe860ce57e21$export$dd4b4b25282569d2 {
    // `now` is the clock every footprint, spark and halo is timed against. The game runs on the
    // wall clock; the building tutorial poses the same effect on its own demo clock.
    constructor(surface, now = ()=>Date.now()){
        this.surface = surface;
        this.now = now;
        this.root = new (0, $8t5Gy.Container)();
        this.footprints = new Map();
        this.sparks = [];
        this.areaSignature = "";
        this.areaEdges = {};
        this.lastSnapAt = -Infinity;
        this.current = new (0, $gwPoJ.Graphics)();
        this.contour = [];
        this.contourDirty = true;
        this.sheen = new (0, $gwPoJ.Graphics)();
        this.pendingGlow = new (0, $gwPoJ.Graphics)();
        this.settling = [];
        this.add = (key, coordinate, yOffset = 0, celebrate = true)=>{
            if (this.footprints.has(key)) return;
            this.attach();
            const graphic = new (0, $gwPoJ.Graphics)();
            graphic.position.set(coordinate.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), coordinate.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + yOffset);
            this.root.addChild(graphic);
            const footprint = {
                graphic: graphic,
                coordinate: {
                    ...coordinate
                },
                born: this.now(),
                state: "waiting",
                yOffset: yOffset
            };
            this.footprints.set(key, footprint);
            this.contourDirty = true;
            this.refreshContour(coordinate);
            if (celebrate) {
                this.spark(coordinate, "draw", yOffset);
                this.update();
            }
        };
        this.setState = (key, state)=>{
            const footprint = this.footprints.get(key);
            if (!footprint || footprint.state === state) return;
            footprint.state = state;
            this.drawFootprint(footprint);
        };
        this.setCounting = (key, startedAt, groupId = startedAt)=>{
            const footprint = this.footprints.get(key);
            if (footprint) {
                footprint.countingAt = startedAt;
                footprint.groupId = groupId;
            }
        };
        this.pauseCounting = (key)=>{
            const footprint = this.footprints.get(key);
            if (footprint) {
                footprint.countingAt = undefined;
                footprint.groupId = undefined;
            }
        };
        this.setResizeHandles = (coordinates, yOffset = 0)=>{
            this.attach();
            if (!this.resizeHandle) {
                const handle = new (0, $gwPoJ.Graphics)();
                this.root.addChild(handle);
                this.resizeHandle = handle;
            }
            const handle = this.resizeHandle;
            handle.clear();
            handle.y = yOffset;
            for (const coordinate of coordinates){
                const x = (coordinate.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y = (coordinate.y + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                handle.lineStyle(1.5, 0xffe7a3, 1);
                handle.beginFill(0x18251f, 0.9);
                handle.drawPolygon([
                    x,
                    y - 6,
                    x + 6,
                    y,
                    x,
                    y + 6,
                    x - 6,
                    y
                ]);
                handle.endFill();
            }
        };
        this.clearResizeHandle = ()=>{
            this.resizeHandle?.destroy();
            this.resizeHandle = undefined;
        };
        this.settle = (sources)=>{
            this.attach();
            for (const source of sources){
                if (this.settling.length >= 48) this.settling.shift()?.sprite.destroy();
                const sprite = new (0, $7Bs2Z.Sprite)(source.texture);
                sprite.position.copyFrom(source.position);
                sprite.scale.copyFrom(source.scale);
                sprite.anchor.copyFrom(source.anchor);
                sprite.pivot.copyFrom(source.pivot);
                sprite.skew.copyFrom(source.skew);
                sprite.rotation = source.rotation;
                sprite.tint = source.tint;
                this.root.addChild(sprite);
                this.settling.push({
                    sprite: sprite,
                    y: source.y,
                    born: this.now()
                });
                sprite.y -= 2;
            }
        };
        this.setOffset = (key, yOffset)=>{
            const footprint = this.footprints.get(key);
            if (!footprint || footprint.yOffset === yOffset) return;
            footprint.graphic.y += yOffset - footprint.yOffset;
            footprint.yOffset = yOffset;
            this.contourDirty = true;
            this.refreshContour(footprint.coordinate);
        };
        this.remove = (key)=>{
            const footprint = this.footprints.get(key);
            footprint?.graphic.destroy();
            this.footprints.delete(key);
            this.contourDirty = true;
            if (footprint) this.refreshContour(footprint.coordinate);
            if (!this.footprints.size) {
                this.current.clear();
                this.sheen.clear();
                this.pendingGlow.clear();
            }
        };
        this.setLineEnd = (coordinate, axis, connection, yOffset = 0)=>{
            this.attach();
            const connectionKey = connection && `${connection.x},${connection.y}`;
            if (!this.lineEnd) {
                this.lineEnd = new (0, $gwPoJ.Graphics)();
                this.root.addChild(this.lineEnd);
                this.drawLineEnd(axis, !!connection);
            } else if (this.lineAxis !== axis || this.lineConnection !== connectionKey) this.drawLineEnd(axis, !!connection);
            this.lineEnd.position.set(coordinate.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), coordinate.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + yOffset);
            const joined = connectionKey && connectionKey !== this.lineConnection;
            if (joined || !connectionKey && axis && axis !== this.lineAxis && this.now() - this.lastSnapAt >= 180) {
                this.spark(coordinate, connection ? "connect" : "snap", yOffset);
                this.lastSnapAt = this.now();
            }
            this.lineAxis = axis;
            this.lineConnection = connectionKey;
        };
        this.clearLineEnd = ()=>{
            this.lineEnd?.destroy();
            this.lineEnd = undefined;
            this.lineAxis = undefined;
            this.lineConnection = undefined;
            this.lastSnapAt = -Infinity;
        };
        this.setAreaFootprint = (anchor, endpoint, edges, yOffset = 0)=>{
            this.attach();
            const signature = `${anchor.x},${anchor.y}:${endpoint.x},${endpoint.y}:${edges.x}:${edges.y}:${yOffset}`;
            if (signature === this.areaSignature) return;
            if (!this.areaFootprint) {
                this.areaFootprint = new (0, $gwPoJ.Graphics)();
                this.root.addChild(this.areaFootprint);
            }
            const graphic = this.areaFootprint;
            graphic.y = yOffset;
            graphic.clear();
            const left = Math.min(anchor.x, endpoint.x) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 2;
            const top = Math.min(anchor.y, endpoint.y) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 2;
            const right = (Math.max(anchor.x, endpoint.x) + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 2;
            const bottom = (Math.max(anchor.y, endpoint.y) + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 2;
            const movingX = endpoint.x >= anchor.x ? right : left;
            const movingY = endpoint.y >= anchor.y ? bottom : top;
            // The tile contour already outlines the actual cells. Keep only the anchor and snap accents here.
            graphic.lineStyle(2, 0xcaf0e4, 1);
            if (edges.x !== undefined) graphic.moveTo(movingX, top).lineTo(movingX, bottom);
            if (edges.y !== undefined) graphic.moveTo(left, movingY).lineTo(right, movingY);
            // A fixed pin identifies the starting corner while the opposite edges stretch.
            const x = (anchor.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y = (anchor.y + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            graphic.lineStyle(1.5, 0x18251f, 1);
            graphic.beginFill(0xffe7a3, 1);
            graphic.drawPolygon([
                x,
                y - 4,
                x + 4,
                y,
                x,
                y + 4,
                x - 4,
                y
            ]);
            graphic.endFill();
            if (edges.x !== undefined && edges.x !== this.areaEdges.x || edges.y !== undefined && edges.y !== this.areaEdges.y) this.spark(endpoint, "connect", yOffset);
            this.areaEdges = {
                ...edges
            };
            this.areaSignature = signature;
        };
        this.clearAreaFootprint = ()=>{
            this.areaFootprint?.destroy();
            this.areaFootprint = undefined;
            this.areaSignature = "";
            this.areaEdges = {};
        };
        this.setEraseTarget = (coordinate, yOffset = 0)=>{
            this.attach();
            if (!this.eraseTarget) {
                const marker = new (0, $gwPoJ.Graphics)();
                marker.lineStyle(1.5, 0xb9e2e5, 0.95);
                marker.drawRoundedRect(2, 2, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 4, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 4, 3);
                const center = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
                marker.beginFill(0x233b40, 0.9).drawCircle(center, center, 6).endFill();
                marker.lineStyle(2, 0xd7f3f0, 1);
                marker.moveTo(center - 3, center).lineTo(center + 3, center);
                this.eraseTarget = marker;
                this.root.addChild(marker);
            }
            this.eraseTarget.position.set(coordinate.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), coordinate.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + yOffset);
        };
        this.clearEraseTarget = ()=>{
            this.eraseTarget?.destroy();
            this.eraseTarget = undefined;
        };
        this.drawLineEnd = (axis, connected = false)=>{
            const marker = this.lineEnd;
            marker.clear();
            const ink = connected ? 0xcaf0e4 : axis ? 0xffe4a1 : 0xb9e2e5;
            const edge = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 2, length = 6;
            for (const [width, color] of [
                [
                    4,
                    0x18251f
                ],
                [
                    2,
                    ink
                ]
            ]){
                marker.lineStyle(width, color, 0.95);
                for (const [x, y, dx, dy] of [
                    [
                        2,
                        2,
                        1,
                        1
                    ],
                    [
                        edge,
                        2,
                        -1,
                        1
                    ],
                    [
                        2,
                        edge,
                        1,
                        -1
                    ],
                    [
                        edge,
                        edge,
                        -1,
                        -1
                    ]
                ])marker.moveTo(x + dx * length, y).lineTo(x, y).lineTo(x, y + dy * length);
            }
            const center = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
            if (connected) {
                marker.lineStyle(3, 0x18251f, 0.95);
                marker.drawRoundedRect(center - 6, center - 3, 7, 6, 2);
                marker.drawRoundedRect(center - 1, center - 3, 7, 6, 2);
                marker.lineStyle(1, ink, 1);
                marker.drawRoundedRect(center - 6, center - 3, 7, 6, 2);
                marker.drawRoundedRect(center - 1, center - 3, 7, 6, 2);
                return;
            }
            marker.lineStyle(0);
            marker.beginFill(ink, 0.95);
            marker.drawPolygon([
                center,
                center - 2,
                center + 2,
                center,
                center,
                center + 2,
                center - 2,
                center
            ]);
            marker.endFill();
        };
        this.spark = (coordinate, kind, yOffset = 0)=>{
            this.attach();
            // Long strokes cannot flood the scene with particles or display objects.
            if (this.sparks.length >= 48) this.sparks.shift()?.graphic.destroy();
            const graphic = new (0, $gwPoJ.Graphics)();
            const half = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
            const color = kind === "erase" ? 0x9dc7c9 : kind === "connect" ? 0xcaf0e4 : 0xffd989;
            graphic.lineStyle(kind === "draw" || kind === "erase" ? 1 : 1.5, color, 0.9);
            if (kind === "draw") graphic.drawPolygon([
                0,
                -3,
                3,
                0,
                0,
                3,
                -3,
                0
            ]);
            else if (kind !== "built") graphic.drawRoundedRect(-half + 3, -half + 3, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 6, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 6, 3);
            if (kind === "built") {
                graphic.lineStyle(1, 0xfff4cf, 1);
                for (const [x, y] of [
                    [
                        -half + 3,
                        -half + 3
                    ],
                    [
                        half - 3,
                        -half + 3
                    ],
                    [
                        half - 3,
                        half - 3
                    ]
                ]){
                    graphic.moveTo(x - 2, y).lineTo(x + 2, y);
                    graphic.moveTo(x, y - 2).lineTo(x, y + 2);
                }
            }
            graphic.position.set((coordinate.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (coordinate.y + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + yOffset);
            this.root.addChild(graphic);
            this.sparks.push({
                graphic: graphic,
                born: this.now(),
                duration: kind === "built" ? 420 : 220,
                kind: kind
            });
        };
        this.update = ()=>{
            if (!this.footprints.size && !this.sparks.length && !this.settling.length && !this.lineEnd && !this.eraseTarget && !this.areaFootprint && !this.resizeHandle) return;
            this.attach();
            const now = this.now();
            this.footprints.forEach(({ graphic: graphic, born: born, state: state, countingAt: countingAt })=>{
                const arrival = Math.max(0, 1 - (now - born) / 180);
                const drawingAlpha = (state === "valid" ? 0.72 : 0.85) + arrival * 0.15;
                // Once the plan pulses, its art and countdown take priority over the contour.
                const fade = countingAt !== undefined && state === "valid" ? Math.min(1, Math.max(0, (now - countingAt) / 1750)) : 0;
                graphic.alpha = drawingAlpha * (1 - fade);
            });
            this.drawCurrent(now);
            this.drawPendingGlow(now);
            this.drawSheen(now);
            this.settling = this.settling.filter((entry)=>{
                const progress = Math.min(1, (now - entry.born) / 240);
                if (progress >= 1) {
                    entry.sprite.destroy();
                    return false;
                }
                entry.sprite.y = entry.y - 2 * (1 - progress) ** 3;
                entry.sprite.alpha = 1 - progress;
                return true;
            });
            this.sparks = this.sparks.filter((spark)=>{
                const progress = Math.min(1, (now - spark.born) / spark.duration);
                if (progress >= 1) {
                    spark.graphic.destroy();
                    return false;
                }
                const eased = 1 - (1 - progress) ** 3;
                spark.graphic.alpha = (1 - progress) ** 2 * 0.8;
                spark.graphic.scale.set(spark.kind === "erase" ? 1 - eased * 0.18 : 0.92 + eased * 0.2);
                return true;
            });
        };
        this.clear = ()=>{
            this.clearResizeHandle();
            this.clearLineEnd();
            this.clearAreaFootprint();
            this.clearEraseTarget();
            this.footprints.forEach((footprint)=>footprint.graphic.destroy());
            this.sparks.forEach((spark)=>spark.graphic.destroy());
            this.footprints.clear();
            if (!this.current.destroyed) this.current.clear();
            if (!this.sheen.destroyed) this.sheen.clear();
            if (!this.pendingGlow.destroyed) this.pendingGlow.clear();
            this.settling.forEach((entry)=>entry.sprite.destroy());
            this.settling = [];
            this.contour = [];
            this.contourDirty = true;
            this.sparks = [];
            this.root.parent?.removeChild(this.root);
        };
        this.destroy = ()=>{
            this.clear();
            if (!this.current.destroyed) this.current.destroy();
            if (!this.sheen.destroyed) this.sheen.destroy();
            if (!this.pendingGlow.destroyed) this.pendingGlow.destroy();
            if (!this.root.destroyed) this.root.destroy();
        };
        this.attach = ()=>{
            const surface = this.surface();
            if (this.root.parent !== surface) surface.addChild(this.root);
        };
        this.refreshContour = (coordinate)=>{
            for (const [dx, dy] of [
                [
                    0,
                    0
                ],
                [
                    -1,
                    0
                ],
                [
                    1,
                    0
                ],
                [
                    0,
                    -1
                ],
                [
                    0,
                    1
                ]
            ]){
                const footprint = this.footprints.get(`${coordinate.x + dx},${coordinate.y + dy}`);
                if (footprint) this.drawFootprint(footprint);
            }
        };
        this.drawSheen = (now)=>{
            const graphic = this.sheen;
            graphic.clear();
            const groups = new Map();
            this.footprints.forEach((footprint)=>{
                if (footprint.countingAt === undefined || footprint.groupId === undefined || footprint.state !== "valid") return;
                const elapsed = now - footprint.countingAt;
                if (elapsed < 800 || elapsed >= 2400) return;
                const origin = (footprint.coordinate.x + footprint.coordinate.y) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + footprint.yOffset;
                const group = groups.get(footprint.groupId);
                if (group) {
                    group.min = Math.min(group.min, origin);
                    group.max = Math.max(group.max, origin + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2);
                    group.cells.push(footprint);
                } else groups.set(footprint.groupId, {
                    startedAt: footprint.countingAt,
                    min: origin,
                    max: origin + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2,
                    cells: [
                        footprint
                    ]
                });
            });
            if (!groups.size) return;
            if (this.root.children[this.root.children.length - 1] !== graphic) this.root.addChild(graphic);
            groups.forEach((group)=>{
                const progress = (now - group.startedAt - 800) / 1600;
                const center = group.min - 20 + (group.max - group.min + 40) * progress;
                for (const footprint of group.cells){
                    const x = footprint.coordinate.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y = footprint.coordinate.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + footprint.yOffset;
                    if (x + y > center + 20 || x + y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2 < center - 20) continue;
                    // Clip the moving light to actual cells, preserving holes and warning markers.
                    for(let band = 0; band < 5; band++){
                        const low = center - 20 + band * 8, high = low + 8;
                        let polygon = [
                            [
                                x,
                                y
                            ],
                            [
                                x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                                y
                            ],
                            [
                                x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                                y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                            ],
                            [
                                x,
                                y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                            ]
                        ];
                        for (const [limit, sign] of [
                            [
                                low,
                                1
                            ],
                            [
                                high,
                                -1
                            ]
                        ]){
                            const clipped = [];
                            polygon.forEach((a, index)=>{
                                const b = polygon[(index + 1) % polygon.length];
                                const da = (a[0] + a[1] - limit) * sign, db = (b[0] + b[1] - limit) * sign;
                                if (da >= 0) clipped.push(a);
                                if (da >= 0 !== db >= 0) {
                                    const t = da / (da - db);
                                    clipped.push([
                                        a[0] + (b[0] - a[0]) * t,
                                        a[1] + (b[1] - a[1]) * t
                                    ]);
                                }
                            });
                            polygon = clipped;
                        }
                        if (polygon.length < 3) continue;
                        graphic.beginFill(0xfff4cf, [
                            0.025,
                            0.05,
                            0.075,
                            0.05,
                            0.025
                        ][band] * Math.sin(progress * Math.PI));
                        graphic.drawPolygon(polygon.flat());
                        graphic.endFill();
                    }
                }
            });
        };
        this.rebuildCurrentContour = ()=>{
            // Clockwise edges keep the current continuous around corners and around hollow rooms.
            const edges = [];
            this.footprints.forEach((footprint)=>{
                const { coordinate: coordinate, yOffset: yOffset } = footprint;
                for (const [nx, ny, x, y, dx, dy, direction] of [
                    [
                        0,
                        -1,
                        0,
                        0,
                        1,
                        0,
                        0
                    ],
                    [
                        1,
                        0,
                        1,
                        0,
                        0,
                        1,
                        1
                    ],
                    [
                        0,
                        1,
                        1,
                        1,
                        -1,
                        0,
                        2
                    ],
                    [
                        -1,
                        0,
                        0,
                        1,
                        0,
                        -1,
                        3
                    ]
                ]){
                    if (this.footprints.get(`${coordinate.x + nx},${coordinate.y + ny}`)?.yOffset === yOffset) continue;
                    const vx = coordinate.x + x, vy = coordinate.y + y;
                    edges.push({
                        footprint: footprint,
                        x: vx * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                        y: vy * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + yOffset,
                        dx: dx,
                        dy: dy,
                        direction: direction,
                        start: `${yOffset}:${vx},${vy}`,
                        end: `${yOffset}:${vx + dx},${vy + dy}`,
                        distance: 0,
                        period: 0
                    });
                }
            });
            const outgoing = new Map();
            edges.forEach((edge)=>{
                const list = outgoing.get(edge.start) || [];
                list.push(edge);
                outgoing.set(edge.start, list);
            });
            const visited = new Set();
            edges.forEach((start)=>{
                if (visited.has(start)) return;
                const loop = [];
                let edge = start;
                while(edge && !visited.has(edge)){
                    visited.add(edge);
                    edge.distance = loop.length * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                    loop.push(edge);
                    const direction = edge.direction;
                    // At a diagonal touch, turn right to follow this boundary rather than crossing it.
                    edge = outgoing.get(edge.end)?.filter((next)=>!visited.has(next)).sort((a, b)=>{
                        const turn = (value)=>[
                                1,
                                0,
                                3,
                                2
                            ].indexOf((value - direction + 4) % 4);
                        return turn(a.direction) - turn(b.direction);
                    })[0];
                }
                const length = loop.length * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                const period = length / Math.max(1, Math.round(length / 160));
                loop.forEach((edge)=>{
                    edge.period = period;
                });
            });
            this.contour = edges;
            this.contourDirty = false;
        };
        this.drawCurrent = (now)=>{
            if (this.contourDirty) this.rebuildCurrentContour();
            const graphic = this.current;
            graphic.clear();
            if (!this.contour.length) return;
            // One reused overlay; only exposed edges animate, never the internal tile grid.
            if (this.root.children[this.root.children.length - 1] !== graphic) this.root.addChild(graphic);
            for (const edge of this.contour){
                if (edge.footprint.graphic.alpha <= 0 || ![
                    "waiting",
                    "valid"
                ].includes(edge.footprint.state)) continue;
                const phase = (now * 0.064 - edge.distance) % edge.period;
                const head = (phase + edge.period) % edge.period;
                for(let pulse = head - edge.period; pulse < (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 12; pulse += edge.period)for(let part = 0; part < 3; part++){
                    const from = Math.max(0, pulse - 12 + part * 4);
                    const to = Math.min((0, $cb689cfa16c444ba$export$29abb25bc3a2a243), pulse - 8 + part * 4);
                    if (to <= from) continue;
                    graphic.lineStyle(1.5, 0xfff4cf, edge.footprint.graphic.alpha * (part + 1) / 3);
                    graphic.moveTo(edge.x + edge.dx * from, edge.y + edge.dy * from).lineTo(edge.x + edge.dx * to, edge.y + edge.dy * to);
                }
            }
        };
        this.drawPendingGlow = (now)=>{
            const graphic = this.pendingGlow;
            graphic.clear();
            if (!this.contour.length) return;
            if (this.root.children[this.root.children.length - 1] !== graphic) this.root.addChild(graphic);
            for (const edge of this.contour){
                const { countingAt: countingAt, state: state } = edge.footprint;
                if (countingAt === undefined || state !== "valid") continue;
                const elapsed = now - countingAt;
                // A moving halo traces the plan without reinstating a full guideline or blinking the art.
                const alpha = Math.max(0, Math.min(1, elapsed / 250, (5000 - elapsed) / 350));
                if (!alpha) continue;
                const phase = (now * 0.048 - edge.distance) % edge.period;
                const head = (phase + edge.period) % edge.period;
                for(let pulse = head - edge.period; pulse < (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 24; pulse += edge.period)for(let part = 0; part < 6; part++){
                    const from = Math.max(0, pulse - 24 + part * 4);
                    const to = Math.min((0, $cb689cfa16c444ba$export$29abb25bc3a2a243), pulse - 20 + part * 4);
                    if (to <= from) continue;
                    const strength = alpha * ((part + 1) / 6) ** 2;
                    // Low-opacity layers form a soft halo around one bright core.
                    for (const [width, opacity] of [
                        [
                            7,
                            0.025
                        ],
                        [
                            4,
                            0.07
                        ],
                        [
                            1.5,
                            0.45
                        ]
                    ]){
                        graphic.lineStyle(width, 0xffe5ae, strength * opacity);
                        graphic.moveTo(edge.x + edge.dx * from, edge.y + edge.dy * from).lineTo(edge.x + edge.dx * to, edge.y + edge.dy * to);
                    }
                }
            }
        };
        this.drawFootprint = ({ graphic: graphic, state: state, coordinate: coordinate, yOffset: yOffset })=>{
            const color = state === "blocked" ? 0xff8174 : state === "shortage" ? 0xffc35a : 0xffe7a3;
            graphic.clear();
            if (state === "waiting" || state === "valid") {
                // Connected tiles read as one silhouette, including holes and stepped edges.
                graphic.lineStyle(0);
                graphic.beginFill(color, state === "waiting" ? 0.12 : 0.04);
                graphic.drawRect(0, 0, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                graphic.endFill();
                const edges = [
                    [
                        -1,
                        0,
                        0,
                        0,
                        0,
                        (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                    ],
                    [
                        1,
                        0,
                        (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                        0,
                        (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                        (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                    ],
                    [
                        0,
                        -1,
                        0,
                        0,
                        (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                        0
                    ],
                    [
                        0,
                        1,
                        0,
                        (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                        (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                        (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                    ]
                ];
                graphic.lineStyle(1.5, color, 1);
                for (const [dx, dy, x1, y1, x2, y2] of edges){
                    const neighbor = this.footprints.get(`${coordinate.x + dx},${coordinate.y + dy}`);
                    if (neighbor?.yOffset === yOffset) continue;
                    graphic.moveTo(x1, y1).lineTo(x2, y2);
                }
                return;
            }
            // A dark casing separates the light edge from grass without covering the tile's art.
            for (const [width, ink] of [
                [
                    3.5,
                    0x18251f
                ],
                [
                    1.5,
                    color
                ]
            ]){
                graphic.lineStyle(width, ink, 1);
                if (state === "shortage") // Preserve the whole intended footprint even without enough material.
                for(let offset = 3; offset < (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 3; offset += 6){
                    const end = Math.min(offset + 3, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 3);
                    graphic.moveTo(offset, 3).lineTo(end, 3);
                    graphic.moveTo(offset, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 3).lineTo(end, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 3);
                    graphic.moveTo(3, offset).lineTo(3, end);
                    graphic.moveTo((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 3, offset).lineTo((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 3, end);
                }
                else graphic.drawRoundedRect(3, 3, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 6, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 6, 2);
            }
            if (state !== "shortage") {
                graphic.lineStyle(0);
                graphic.beginFill(color, 0.04);
                graphic.drawRoundedRect(3, 3, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 6, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 6, 2);
                graphic.endFill();
            }
        };
        this.root.zIndex = 100000.25;
        this.root.interactive = false;
        this.root.interactiveChildren = false;
        this.pendingGlow.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
const $dd2f604be1eac3c5$export$43ccf038026ef0a1 = {
    enabled: true,
    liftMs: 90,
    fallMs: 120,
    settleMs: 170,
    /** How high an upright piece rises before it drops. */ liftPx: 7,
    /** How much a flat piece grows toward the camera at the top of its lift. */ swell: 0.07,
    /** How hard a piece squashes at impact (fraction of its height). */ squash: 0.09,
    rippleMsPerTile: 40,
    rippleMaxMs: 450,
    /** At most this many pieces of a group raise dust. */ dustCells: 8
};
if (typeof window !== "undefined") window.buildLanding = $dd2f604be1eac3c5$export$43ccf038026ef0a1;
const $dd2f604be1eac3c5$export$cc5c15f200f28fa9 = 6000;
const $dd2f604be1eac3c5$export$b4e04ab9b076b17c = ()=>$dd2f604be1eac3c5$export$43ccf038026ef0a1.liftMs + $dd2f604be1eac3c5$export$43ccf038026ef0a1.fallMs;
const $dd2f604be1eac3c5$export$e150b53ef71313fe = ()=>$dd2f604be1eac3c5$export$b4e04ab9b076b17c() + $dd2f604be1eac3c5$export$43ccf038026ef0a1.settleMs;
const $dd2f604be1eac3c5$export$934552f95b42f334 = ()=>({
        dy: 0,
        scaleX: 1,
        scaleY: 1,
        alpha: 1
    });
const $dd2f604be1eac3c5$var$easeOut = (k)=>1 - (1 - k) * (1 - k);
const $dd2f604be1eac3c5$export$b6581620621b73b7 = (elapsed, layer, from = 1)=>{
    const { liftMs: liftMs, fallMs: fallMs, settleMs: settleMs, liftPx: liftPx, swell: swell, squash: squash } = $dd2f604be1eac3c5$export$43ccf038026ef0a1;
    if (!(elapsed > 0) || elapsed >= liftMs + fallMs + settleMs) return $dd2f604be1eac3c5$export$934552f95b42f334();
    const upright = layer === "wall";
    let height, alpha = 1;
    if (elapsed < liftMs) {
        height = $dd2f604be1eac3c5$var$easeOut(elapsed / liftMs);
        alpha = from + (1 - from) * height;
    } else if (elapsed < liftMs + fallMs) {
        const k = (elapsed - liftMs) / fallMs;
        // Falling, so it gathers speed into the ground.
        height = 1 - k * k;
    } else {
        const k = (elapsed - liftMs - fallMs) / settleMs;
        // Squashed at contact, a small rebound past rest, then still.
        const s = squash * (1 - k) * (1 - k) * Math.cos(k * Math.PI * 1.5);
        return upright ? {
            dy: 0,
            scaleX: 1 + s * 0.5,
            scaleY: 1 - s,
            alpha: 1
        } : {
            dy: 0,
            scaleX: 1 - s * 0.4,
            scaleY: 1 - s * 0.4,
            alpha: 1
        };
    }
    return upright ? {
        dy: -liftPx * height,
        scaleX: 1,
        scaleY: 1,
        alpha: alpha
    } : {
        dy: 0,
        scaleX: 1 + swell * height,
        scaleY: 1 + swell * height,
        alpha: alpha
    };
};
const $dd2f604be1eac3c5$export$fdbb6e64e691678b = (cells, origin)=>{
    if (cells.length < 2) return cells.map(()=>0);
    const from = origin ?? {
        x: cells.reduce((sum, c)=>sum + c.x + 0.5, 0) / cells.length,
        y: cells.reduce((sum, c)=>sum + c.y + 0.5, 0) / cells.length
    };
    const distances = cells.map((c)=>Math.hypot(c.x + 0.5 - from.x, c.y + 0.5 - from.y));
    const nearest = Math.min(...distances);
    const raw = distances.map((d)=>(d - nearest) * $dd2f604be1eac3c5$export$43ccf038026ef0a1.rippleMsPerTile);
    const widest = Math.max(...raw);
    const fit = widest > $dd2f604be1eac3c5$export$43ccf038026ef0a1.rippleMaxMs ? $dd2f604be1eac3c5$export$43ccf038026ef0a1.rippleMaxMs / widest : 1;
    return raw.map((d)=>Math.round(d * fit));
};
const $dd2f604be1eac3c5$export$e95ce1597203b2d0 = (delays, budget = $dd2f604be1eac3c5$export$43ccf038026ef0a1.dustCells)=>{
    if (delays.length <= budget) return new Set(delays.map((_, i)=>i));
    const order = delays.map((delay, i)=>({
            delay: delay,
            i: i
        })).sort((a, b)=>a.delay - b.delay || a.i - b.i);
    const picks = new Set();
    for(let n = 0; n < budget; n++)picks.add(order[Math.round(n * (order.length - 1) / (budget - 1))].i);
    return picks;
};
const $dd2f604be1eac3c5$export$22de6e2b70e42ca9 = (itemType)=>{
    const id = (itemType || "").toLowerCase();
    if (/stone|brick|cobble|rock/.test(id)) return {
        cloud: 0xcfc8bc,
        chips: 0x8f887d
    };
    if (/thatch|straw|hay|reed/.test(id)) return {
        cloud: 0xd8caa8,
        chips: 0xd9b95c
    };
    if (/wood|timber|plank|log|beam/.test(id)) return {
        cloud: 0xd8caa8,
        chips: 0xa87a4a
    };
    return {
        cloud: 0xd8caa8,
        chips: 0xa89a80
    };
};
const $dd2f604be1eac3c5$var$destroyGhosts = (landing)=>{
    landing.ghosts?.forEach((sprite)=>{
        sprite.parent?.removeChild(sprite);
        if (!sprite.destroyed) sprite.destroy();
    });
    landing.ghosts?.clear();
};
class $dd2f604be1eac3c5$export$d81026725192cb9d {
    static{
        this.key = (storey, layer, x, y)=>`${storey}:${layer}:${x},${y}`;
    }
    constructor(){
        this.landings = new Map();
        /** Land `cells` as one group. Cells already landing (the builder's own print) keep their timeline. */ this.start = (cells, options)=>{
            if (!$dd2f604be1eac3c5$export$43ccf038026ef0a1.enabled || !cells.length) return [];
            const delays = $dd2f604be1eac3c5$export$fdbb6e64e691678b(cells, options.origin);
            const dusty = $dd2f604be1eac3c5$export$e95ce1597203b2d0(delays);
            const started = [];
            cells.forEach((cell, i)=>{
                const key = $dd2f604be1eac3c5$export$d81026725192cb9d.key(options.storey, options.layer, cell.x, cell.y);
                if (this.landings.has(key)) return;
                const landing = {
                    x: cell.x,
                    y: cell.y,
                    storey: options.storey,
                    layer: options.layer,
                    startAt: options.now + delays[i],
                    lift: options.lift ?? 0,
                    itemType: options.itemType,
                    tileId: options.tiles?.[i]?.tileId,
                    layerId: options.tiles?.[i]?.layerId,
                    dust: !dusty.has(i) ? 0 : cells.length === 1 ? 2 : 1
                };
                this.landings.set(key, landing);
                started.push(landing);
            });
            return started;
        };
        this.get = (storey, layer, x, y)=>this.landings.get($dd2f604be1eac3c5$export$d81026725192cb9d.key(storey, layer, x, y));
        /** Still tracked (not pruned or forgotten), so it will put its ghosts away. */ this.tracks = (landing)=>this.landings.get($dd2f604be1eac3c5$export$d81026725192cb9d.key(landing.storey, landing.layer, landing.x, landing.y)) === landing;
        /** A piece was taken down: building it again lands again. */ this.forget = (storey, layer, x, y)=>{
            const key = $dd2f604be1eac3c5$export$d81026725192cb9d.key(storey, layer, x, y);
            const landing = this.landings.get(key);
            if (landing?.ghostsOwned) $dd2f604be1eac3c5$var$destroyGhosts(landing);
            this.landings.delete(key);
        };
        this.forEach = (visit)=>this.landings.forEach(visit);
        this.size = ()=>this.landings.size;
        this.prune = (now)=>{
            const expiry = $dd2f604be1eac3c5$export$e150b53ef71313fe() + $dd2f604be1eac3c5$export$cc5c15f200f28fa9;
            this.landings.forEach((landing, key)=>{
                if (now - landing.startAt < expiry) return;
                if (landing.ghostsOwned) $dd2f604be1eac3c5$var$destroyGhosts(landing);
                this.landings.delete(key);
            });
        };
        this.clear = ()=>{
            this.landings.forEach((landing)=>{
                if (landing.ghostsOwned) $dd2f604be1eac3c5$var$destroyGhosts(landing);
            });
            this.landings.clear();
        };
    }
}
const $dd2f604be1eac3c5$export$6e2723a70a7a1aa7 = new $dd2f604be1eac3c5$export$d81026725192cb9d();
const $dd2f604be1eac3c5$export$c91b18faf7a209bf = (landing, now)=>{
    landing.ghostsOwned = true;
    landing.releasedAt = now;
};
const $dd2f604be1eac3c5$export$aa86d51cd3992879 = $dd2f604be1eac3c5$var$destroyGhosts;
// Each posed sprite's resting place, taken the first time it is posed (a sprite is built at rest).
const $dd2f604be1eac3c5$var$rests = new WeakMap();
const $dd2f604be1eac3c5$export$270ebf66df17de70 = (sprites, pose, pivot, withAlpha = true)=>{
    for (const sprite of sprites){
        if (sprite.destroyed) continue;
        let rest = $dd2f604be1eac3c5$var$rests.get(sprite);
        if (!rest) {
            rest = {
                x: sprite.x,
                y: sprite.y,
                scaleX: sprite.scale.x,
                scaleY: sprite.scale.y
            };
            $dd2f604be1eac3c5$var$rests.set(sprite, rest);
        }
        sprite.scale.set(rest.scaleX * pose.scaleX, rest.scaleY * pose.scaleY);
        sprite.x = pivot.x + (rest.x - pivot.x) * pose.scaleX;
        sprite.y = pivot.y + (rest.y + pose.dy - pivot.y) * pose.scaleY;
        if (withAlpha) sprite.alpha = pose.alpha;
    }
};
const $dd2f604be1eac3c5$export$b10d9a6189b2349b = (sprites, withAlpha = true)=>{
    for (const sprite of sprites){
        const rest = $dd2f604be1eac3c5$var$rests.get(sprite);
        if (!rest) continue;
        $dd2f604be1eac3c5$var$rests.delete(sprite);
        if (sprite.destroyed) continue;
        sprite.scale.set(rest.scaleX, rest.scaleY);
        sprite.position.set(rest.x, rest.y);
        if (withAlpha) sprite.alpha = 1;
    }
};
const $dd2f604be1eac3c5$var$MAX_MOTES = 96;
const $dd2f604be1eac3c5$var$GRAVITY = 1100;
// A small deterministic generator, so one landing's dust is the same every time it is drawn.
const $dd2f604be1eac3c5$var$seeded = (seed)=>()=>{
        seed = seed + 0x6d2b79f5 | 0;
        let t = Math.imul(seed ^ seed >>> 15, 1 | seed);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
class $dd2f604be1eac3c5$export$ef42757986f4090e {
    constructor(surface){
        this.surface = surface;
        this.motes = [];
        this./**
     * A puff along a piece's foot: `x` its middle, `halfWidth` how far along the ground it reaches,
     * `groundY` the line it stands on. Strength 2 is a lone piece, 1 one of a group.
     */ puff = (x, groundY, halfWidth, colors, strength, zIndex, now, seed)=>{
            const surface = this.surface();
            if (!surface || surface.destroyed) return;
            const random = $dd2f604be1eac3c5$var$seeded(seed);
            const between = (min, max)=>min + random() * (max - min);
            const clouds = strength === 2 ? 3 : 2, chips = strength === 2 ? 4 : 2;
            for(let i = 0; i < clouds + chips && this.motes.length < $dd2f604be1eac3c5$var$MAX_MOTES; i++){
                const chip = i >= clouds;
                const along = between(-halfWidth, halfWidth);
                const side = along < 0 ? -1 : 1;
                const graphic = new (0, $gwPoJ.Graphics)();
                if (chip) {
                    const size = between(1.2, 2);
                    graphic.beginFill(colors.chips, 1).drawRect(-size / 2, -size / 2, size, size).endFill();
                } else // Faint halo, body, dense core: softness without a blur filter.
                for (const [scale, alpha] of [
                    [
                        1,
                        0.22
                    ],
                    [
                        0.68,
                        0.45
                    ],
                    [
                        0.36,
                        0.9
                    ]
                ])graphic.beginFill(colors.cloud, alpha).drawEllipse(0, 0, 6 * scale, 3.4 * scale).endFill();
                graphic.zIndex = zIndex;
                surface.addChild(graphic);
                this.motes.push({
                    graphic: graphic,
                    chip: chip,
                    x: x + along,
                    groundY: groundY + between(-1, 1.5),
                    height: chip ? 2 : 0,
                    vx: side * (chip ? between(26, 46) : between(12, 24)),
                    vh: chip ? between(60, 90) : between(4, 9),
                    bornAt: now,
                    lifeMs: chip ? between(320, 420) : between(420, 540),
                    scale: chip ? 1 : between(0.45, 0.6),
                    growth: chip ? 1 : between(1.6, 2),
                    alpha: chip ? 0.95 : between(0.55, 0.75)
                });
                this.place(this.motes[this.motes.length - 1], 0);
            }
        };
        this.update = (now)=>{
            if (!this.motes.length) return;
            this.motes = this.motes.filter((mote)=>{
                const k = (now - mote.bornAt) / mote.lifeMs;
                if (k >= 1 || mote.graphic.destroyed || !mote.graphic.parent) {
                    this.retire(mote);
                    return false;
                }
                this.place(mote, Math.max(0, k));
                return true;
            });
        };
        this.count = ()=>this.motes.length;
        this.clear = ()=>{
            this.motes.forEach(this.retire);
            this.motes = [];
        };
        this.place = (mote, k)=>{
            const seconds = k * mote.lifeMs / 1000;
            const graphic = mote.graphic;
            if (mote.chip) {
                // Thrown out and up, dropped by gravity; it lies where it lands and fades.
                const landsAt = (mote.vh + Math.sqrt(mote.vh * mote.vh + 2 * $dd2f604be1eac3c5$var$GRAVITY * mote.height)) / $dd2f604be1eac3c5$var$GRAVITY;
                const flight = Math.min(seconds, landsAt);
                const height = Math.max(0, mote.height + mote.vh * flight - $dd2f604be1eac3c5$var$GRAVITY * flight * flight / 2);
                graphic.position.set(mote.x + mote.vx * flight, mote.groundY - height);
                graphic.alpha = mote.alpha * (k < 0.6 ? 1 : 1 - (k - 0.6) / 0.4);
            } else {
                // Spreading along the ground and slowing (drag), lifting a little as it thins out.
                const travel = mote.vx * (1 - Math.exp(-4 * seconds)) / 4;
                graphic.position.set(mote.x + travel, mote.groundY - mote.vh * seconds);
                graphic.scale.set(mote.scale * (1 + (mote.growth - 1) * $dd2f604be1eac3c5$var$easeOut(k)));
                const fadeIn = Math.min(1, k / 0.1);
                graphic.alpha = mote.alpha * fadeIn * (k < 0.35 ? 1 : 1 - ((k - 0.35) / 0.65) ** 1.5);
            }
        };
        this.retire = (mote)=>{
            mote.graphic.parent?.removeChild(mote.graphic);
            if (!mote.graphic.destroyed) mote.graphic.destroy();
        };
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");




const $2c4a8005c243ff16$export$b2e7bf5d596b6c29 = {
    /** The new flight's rungs appearing, the hatch riding up on them. */ grow: 340,
    /** The hatch's squash and rebound once it is up. */ land: 220,
    /** How long the grown ladder waits for the server's art before giving way anyway. */ hold: 1500,
    /** The hand-over to the real art. */ fade: 140
};
const $2c4a8005c243ff16$export$5acba7cd8bb4d08 = (layout, growing)=>layout.anchored ? undefined : {
        x: layout.at.x,
        y: layout.at.y,
        from: layout.foot ? layout.level - 1 : layout.level,
        to: layout.level + (growing ? 1 : 0)
    };
class $2c4a8005c243ff16$export$8fd64fe9d18f8104 {
    constructor(){
        this.entries = [];
        this.set = (owner, veil)=>{
            this.entries = this.entries.filter((entry)=>entry.owner !== owner);
            if (veil) this.entries.push({
                owner: owner,
                ...veil
            });
        };
        this.release = (owner)=>this.set(owner);
        /** The veils in force now. */ this.active = ()=>{
            this.entries = this.entries.filter((entry)=>!entry.owner.destroyed);
            return this.entries.filter((entry)=>entry.owner.worldVisible).map(({ x: x, y: y, from: from, to: to })=>({
                    x: x,
                    y: y,
                    from: from,
                    to: to
                }));
        };
    }
}
const $2c4a8005c243ff16$export$9fbd56626b49c812 = new $2c4a8005c243ff16$export$8fd64fe9d18f8104();
/** How far a new hatch drops into a floor it opens in. */ const $2c4a8005c243ff16$var$HATCH_DROP_PX = 6;
const $2c4a8005c243ff16$var$drawPixels = (g, pixels, dx, dy, clipTop = -Infinity)=>{
    for (const pixel of pixels){
        const top = Math.max(pixel.y + dy, clipTop), bottom = pixel.y + pixel.height + dy;
        if (bottom > top) g.beginFill(pixel.color).drawRect(pixel.x + dx, top, pixel.width, bottom - top).endFill();
    }
};
class $2c4a8005c243ff16$export$6ceac85fc71eba8c extends (0, $7Bs2Z.Sprite) {
    constructor(layout, options){
        super((0, $klOfb.Texture).EMPTY), this.layout = layout, this.options = options, this.heightBlurExempt = true, this.foot = new (0, $gwPoJ.Graphics)(), this.flight = new (0, $gwPoJ.Graphics)(), this.hatch = new (0, $gwPoJ.Graphics)(), this.phase = {
            kind: "ghost"
        }, this.now = ()=>this.options.now?.() ?? Date.now(), this./** Plays the growth from now, opaque, until the server's art is drawn and can take over. */ grow = (growth)=>{
            this.phase = {
                kind: "growing",
                startAt: this.now(),
                ...growth
            };
            $2c4a8005c243ff16$export$9fbd56626b49c812.set(this, $2c4a8005c243ff16$export$5acba7cd8bb4d08(this.layout, true));
            this.animate();
        }, this./** Called every frame while growing. Returns false once it has finished and is destroyed. */ animate = ()=>{
            if (this.destroyed) return false;
            const phase = this.phase;
            if (phase.kind !== "growing") return true;
            const now = this.now();
            const elapsed = now - phase.startAt;
            const { grow: grow, land: land, hold: hold, fade: fade } = $2c4a8005c243ff16$export$b2e7bf5d596b6c29;
            if (!phase.didLand && elapsed >= grow) {
                phase.didLand = true;
                this.puff(phase.dust);
                phase.landed?.();
            }
            if (phase.fadeAt === undefined && elapsed >= grow + land && (phase.arrived() || elapsed >= grow + land + hold)) {
                phase.fadeAt = now;
                $2c4a8005c243ff16$export$9fbd56626b49c812.release(this);
            }
            if (phase.fadeAt !== undefined) {
                const k = (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)((now - phase.fadeAt) / fade);
                if (k >= 1) {
                    this.destroy();
                    return false;
                }
                this.alpha = 1 - k;
            }
            this.pose(elapsed);
            return true;
        }, this.pose = (elapsed)=>{
            const { baseline: baseline, nextBaseline: nextBaseline, standing: standing, opening: opening } = this.layout;
            const { grow: grow, land: land } = $2c4a8005c243ff16$export$b2e7bf5d596b6c29;
            const ghost = this.phase.kind === "ghost";
            const rise = ghost ? 1 : (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(elapsed / grow);
            this.flight.clear();
            $2c4a8005c243ff16$var$drawPixels(this.flight, this.flightPixels, 0, baseline, baseline - (standing + (this.flightHeight - standing) * rise));
            // With no floor to stay in, the old hatch rides the new rungs up; an opening stays and the new one settles above.
            this.hatch.y = opening ? nextBaseline - $2c4a8005c243ff16$var$HATCH_DROP_PX * (1 - rise) : baseline - this.flightHeight * rise;
            const settle = ghost ? 1 : (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)((elapsed - grow) / land);
            const squash = settle > 0 && settle < 1 ? 0.16 * (1 - settle) ** 2 * Math.cos(settle * Math.PI * 1.5) : 0;
            this.hatch.scale.set(1 + squash * 0.5, 1 - squash);
            // A ghost shows the new flight faintly, and the ladder already standing as it will look.
            const { ghostAlpha: ghostAlpha } = this.options;
            this.flight.alpha = ghost ? ghostAlpha : 1;
            this.hatch.alpha = ghost ? ghostAlpha : opening ? (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)(rise * 1.6 - 0.6) : 1;
        }, this.puff = (dust)=>{
            const { at: at, level: level, nextBaseline: nextBaseline } = this.layout;
            const seed = at.x * 73856093 ^ at.y * 19349663 ^ level * 83492791;
            dust?.puff((at.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), nextBaseline - 1, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 - 4, (0, $dd2f604be1eac3c5$export$22de6e2b70e42ca9)("wood"), 2, this.zIndex + 0.01, this.now(), seed);
        };
        this.flightHeight = Math.max(8, layout.baseline - layout.nextBaseline);
        this.flightPixels = (0, $f63a252d2ded274b$export$664fd011aec16e70)({
            kind: "middle",
            height: this.flightHeight,
            ...layout.opening ? {
                hatch: true
            } : {}
        });
        if (layout.foot) $2c4a8005c243ff16$var$drawPixels(this.foot, (0, $f63a252d2ded274b$export$664fd011aec16e70)({
            kind: "bottom",
            height: Math.max(8, layout.foot.baseline - layout.baseline)
        }), 0, layout.foot.baseline);
        // Drawn about the middle of its foot line, so it squashes onto the floor it lands in.
        $2c4a8005c243ff16$var$drawPixels(this.hatch, (0, $f63a252d2ded274b$export$664fd011aec16e70)({
            kind: "top",
            height: this.flightHeight
        }), -(0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2, 0);
        this.hatch.x = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
        this.position.set(layout.at.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 0);
        this.addChild(this.foot, this.flight, this.hatch);
        this.pose(0);
        $2c4a8005c243ff16$export$9fbd56626b49c812.set(this, $2c4a8005c243ff16$export$5acba7cd8bb4d08(layout, false));
    }
    destroy(options) {
        $2c4a8005c243ff16$export$9fbd56626b49c812.release(this);
        super.destroy(typeof options === "object" ? {
            ...options,
            children: true
        } : {
            children: true
        });
    }
    get growing() {
        return this.phase.kind === "growing";
    }
}


const $6e50b195d7f0ac79$export$b3d3da6caef67d50 = 2000;
class $6e50b195d7f0ac79$export$5968578be146f331 {
    constructor(map, /** The tile the map holds at a cell, in the same ids as a preview delta's tilePos. */ drawnTile, now = ()=>Date.now()){
        this.map = map;
        this.drawnTile = drawnTile;
        this.now = now;
        this.claims = new Map();
        this.ghosts = new Map();
        this.clock = 0;
        this./** What `owner`'s preview would change, from its server deltas. Replaces the owner's last claim. */ claim = (owner, deltas)=>{
            const cells = new Map();
            deltas.forEach((delta)=>{
                // The previewed piece itself is drawn by its own ghost; this is only what it does to its neighbours.
                if ([
                    "blocking",
                    "skyTrigger"
                ].includes(delta.layerId) || !delta.context?.highZ || delta.context?.previewTarget !== false) return;
                const tile = String(delta.tileSpec.tilePos);
                const drawn = this.drawnTile(delta.x, delta.y, delta.layerId);
                // Only a tile already standing there is reshaped, and only if it would really change.
                if (!drawn || drawn === "0" || drawn === tile) return;
                cells.set(`${delta.x}-${delta.y}-${delta.layerId}`, {
                    x: delta.x,
                    y: delta.y,
                    layerId: delta.layerId,
                    tile: tile
                });
            });
            if (cells.size) this.claims.set(owner, {
                cells: cells,
                at: ++this.clock
            });
            else this.claims.delete(owner);
        };
        this./** The preview is gone. A settling claim outlives its owner. */ release = (owner)=>{
            if (this.claims.get(owner)?.settleUntil === undefined) this.claims.delete(owner);
        };
        this./** The owner's piece was built: hold its reshaped neighbours solid until the map's tiles catch up. */ settle = (owner)=>{
            const claim = this.claims.get(owner);
            if (claim) claim.settleUntil = this.now() + $6e50b195d7f0ac79$export$b3d3da6caef67d50;
        };
        this./**
     * Once a frame: show the ghosts of the shown owners' claims, each at its owner's alpha, hide the
     * real tiles under them, and give every other tile back to the map.
     */ sync = (shown)=>{
            if (!this.claims.size && !this.ghosts.size) return;
            const map = this.map();
            const now = this.now();
            const wanted = new Map();
            this.claims.forEach((claim, owner)=>{
                if (claim.settleUntil !== undefined) {
                    // The map drew the built shape where it already matches; this claim is done there.
                    claim.cells.forEach((reshape, key)=>{
                        if (this.drawnTile(reshape.x, reshape.y, reshape.layerId) === reshape.tile) claim.cells.delete(key);
                    });
                    if (!claim.cells.size || now >= claim.settleUntil) {
                        this.claims.delete(owner);
                        return;
                    }
                }
                const alpha = claim.settleUntil !== undefined ? 1 : shown.get(owner);
                if (alpha === undefined) return;
                claim.cells.forEach((reshape, key)=>{
                    const current = wanted.get(key);
                    if (current && current.at > claim.at) {
                        current.alpha = Math.max(current.alpha, alpha);
                        return;
                    }
                    if (!map.canVeilBuildCell?.(reshape.x, reshape.y, reshape.layerId)) return;
                    wanted.set(key, {
                        reshape: reshape,
                        alpha: Math.max(alpha, current?.alpha ?? 0),
                        at: claim.at
                    });
                });
            });
            this.ghosts.forEach((ghost, key)=>{
                const want = wanted.get(key);
                if (want && want.reshape.tile === ghost.tile && !ghost.sprite.destroyed) return;
                ghost.sprite.parent?.removeChild(ghost.sprite);
                if (!ghost.sprite.destroyed) ghost.sprite.destroy();
                this.ghosts.delete(key);
            });
            const surface = map.getTileSurface();
            wanted.forEach(({ reshape: reshape, alpha: alpha }, key)=>{
                let ghost = this.ghosts.get(key);
                if (!ghost) {
                    const sprite = map.addTileAt(reshape.x, reshape.y, reshape.tile, reshape.layerId, true)?.sprite;
                    if (!sprite) return;
                    // Above the scene, as a planned piece's own ghost is.
                    sprite.zIndex = 100000;
                    ghost = {
                        sprite: sprite,
                        tile: reshape.tile
                    };
                    this.ghosts.set(key, ghost);
                }
                ghost.sprite.alpha = alpha;
                if (ghost.sprite.parent !== surface) surface.addChild(ghost.sprite);
            });
            map.setBuildVeil?.(this.ghosts.keys());
        };
        this./** Drop every claim and hand every tile back to the map. */ clear = ()=>{
            this.claims.clear();
            this.sync(new Map());
        };
    }
}



parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $P8XPi = parcelRequire("P8XPi");


var $1avo5 = parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $3YyWq = parcelRequire("3YyWq");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");
// Warm amber, the same family as the command wheel's rim (WHEEL_RIM_COLOR), so the hover cue and the
// wheel it can open read as one system.
const $95f2390044c89843$var$GLOW_COLOR = 0xf7c070;
// The outline is built by drawing the frame's shape a second time, offset in every direction: the
// union of those offsets sticks out past the art by `distance` on every side, and the art drawn on
// top hides the middle, leaving a rim. Two passes give the rim a falloff -- a tight bright edge and a
// wider faint bloom -- rather than one hard band. Kept deliberately thin and low-contrast: this is a
// "you can act on this" hint the eye should catch without the entity looking like it is on fire.
const $95f2390044c89843$var$OUTLINE_PASSES = [
    {
        distance: 1.5,
        alpha: 0.66
    },
    {
        distance: 3.5,
        alpha: 0.21
    }
];
// Eight directions: the four sides plus the diagonals at 1/sqrt(2), so the rim stays an even
// thickness around a curve instead of bulging at the corners.
const $95f2390044c89843$var$DIAGONAL = Math.SQRT1_2;
const $95f2390044c89843$var$OUTLINE_DIRECTIONS = [
    [
        1,
        0
    ],
    [
        -1,
        0
    ],
    [
        0,
        1
    ],
    [
        0,
        -1
    ],
    [
        $95f2390044c89843$var$DIAGONAL,
        $95f2390044c89843$var$DIAGONAL
    ],
    [
        -$95f2390044c89843$var$DIAGONAL,
        $95f2390044c89843$var$DIAGONAL
    ],
    [
        $95f2390044c89843$var$DIAGONAL,
        -$95f2390044c89843$var$DIAGONAL
    ],
    [
        -$95f2390044c89843$var$DIAGONAL,
        -$95f2390044c89843$var$DIAGONAL
    ]
];
// Breathing, not blinking: the glow rides between PULSE_FLOOR and full strength over PULSE_PERIOD_MS.
const $95f2390044c89843$var$PULSE_PERIOD_MS = 1600;
const $95f2390044c89843$var$PULSE_FLOOR = 0.62;
// The glow eases in and out rather than snapping, so sweeping the pointer across a crowd doesn't
// strobe. Out is slower than in: the arrival should feel responsive, the departure unhurried.
const $95f2390044c89843$var$FADE_IN_MS = 140;
const $95f2390044c89843$var$FADE_OUT_MS = 220;
// The outline passes are drawn from the entity's OWN frame texture, whose edge pixels are the art's
// dark LPC outline -- tinting those would give a dark halo, not a glow. This flattens every pass to
// the glow color while keeping its alpha, so what shows is the shape, lit. One filter instance,
// shared by every highlight: it carries no per-object state, and at most a handful are ever lit at
// once (the pointed-at entity and the selected ember roster member).
let $95f2390044c89843$var$glowFlattenFilter;
const $95f2390044c89843$var$flattenToGlowColor = ()=>{
    if (!$95f2390044c89843$var$glowFlattenFilter) {
        const r = ($95f2390044c89843$var$GLOW_COLOR >> 16 & 0xff) / 0xff;
        const g = ($95f2390044c89843$var$GLOW_COLOR >> 8 & 0xff) / 0xff;
        const b = ($95f2390044c89843$var$GLOW_COLOR & 0xff) / 0xff;
        const filter = new (0, $1avo5.filters).ColorMatrixFilter();
        // Zero every color coefficient and carry the glow color in the offset column; the alpha row
        // passes alpha straight through, so the silhouette's shape survives untouched.
        filter.matrix = [
            0,
            0,
            0,
            0,
            r,
            0,
            0,
            0,
            0,
            g,
            0,
            0,
            0,
            0,
            b,
            0,
            0,
            0,
            1,
            0
        ];
        $95f2390044c89843$var$glowFlattenFilter = filter;
    }
    return $95f2390044c89843$var$glowFlattenFilter;
};
// The highlight is pure decoration and must never move the thing it decorates. Renderables derive
// their on-screen position from their own measured height (BaseRenderable.getYOffset reads
// `this.height`, which is a bounds query over every child), so a decoration that widened the parent's
// bounds would nudge the entity the instant you pointed at it -- and nudge it back when you looked
// away. This container renders its children normally but reports no bounds of its own, which keeps
// the whole highlight out of every measurement taken of the entity.
//
// A filter still sizes itself correctly inside this: the filter system asks the FILTERED object for
// its bounds directly (FilterSystem.push -> target.getBounds), never through its parent.
class $95f2390044c89843$var$BoundlessContainer extends (0, $8t5Gy.Container) {
    calculateBounds() {
        this._bounds.clear();
    }
}
class $95f2390044c89843$export$b6cf31fac6564392 {
    constructor(opts){
        this.outlineSprites = [];
        this.on = false;
        // 0..1, eased toward `on` every frame; the glow's alpha is this times the pulse. A fade-out keeps
        // ticking until it reaches 0, which is also when the highlight finally hides itself.
        this.strength = 0;
        this.ticking = false;
        this.disposed = false;
        this.isOn = ()=>this.on;
        this.set = (on)=>{
            if (this.disposed || this.on === on) return;
            this.on = on;
            // Both directions are animated, so switching off keeps the ticker running until the fade
            // finishes -- update() hides everything and deregisters once the glow reaches zero.
            if (!this.ticking) {
                (0, $3YyWq.Ticker).shared.add(this.update);
                this.ticking = true;
            }
            this.update();
        };
        // Release the ticker registration and the borrowed frame texture. Called from the renderable's
        // cleanup so a culled or destroyed entity can't leave a callback running against a detached
        // display object, or hold a reference the sprite generator wants to reclaim.
        this.dispose = ()=>{
            this.disposed = true;
            this.on = false;
            this.strength = 0;
            this.stopTicking();
            this.hide();
        };
        this.hide = ()=>{
            this.hideOutline();
        };
        this.stopTicking = ()=>{
            if (this.ticking) {
                (0, $3YyWq.Ticker).shared.remove(this.update);
                this.ticking = false;
            }
        };
        this.hideOutline = ()=>{
            if (!this.outline) return;
            this.outline.visible = false;
            this.outlineSprites.forEach((sprite)=>{
                sprite.texture = (0, $klOfb.Texture).EMPTY;
            });
        };
        // Step `strength` toward the on/off target using real elapsed time, so the fade takes the same
        // wall-clock duration whatever the frame rate.
        this.advanceFade = ()=>{
            const elapsed = (0, $3YyWq.Ticker).shared.deltaMS || 0;
            const target = this.on ? 1 : 0;
            const duration = this.on ? $95f2390044c89843$var$FADE_IN_MS : $95f2390044c89843$var$FADE_OUT_MS;
            const step = duration > 0 ? elapsed / duration : 1;
            if (this.strength < target) this.strength = Math.min(target, this.strength + step);
            else if (this.strength > target) this.strength = Math.max(target, this.strength - step);
        };
        // 0..1, a sine that never reaches zero: the glow breathes rather than blinking out. Driven from
        // the wall clock so every highlight pulses in step and the rate doesn't follow the frame rate.
        this.pulse = ()=>{
            const phase = Date.now() % $95f2390044c89843$var$PULSE_PERIOD_MS / $95f2390044c89843$var$PULSE_PERIOD_MS;
            const wave = 0.5 - 0.5 * Math.cos(phase * Math.PI * 2);
            return $95f2390044c89843$var$PULSE_FLOOR + (1 - $95f2390044c89843$var$PULSE_FLOOR) * wave;
        };
        this.update = ()=>{
            this.advanceFade();
            if (this.strength <= 0) {
                // Fully faded out (or never faded in): nothing to draw, and nothing left to animate.
                this.hide();
                this.stopTicking();
                return;
            }
            if (!this.drawOutline(this.pulse() * this.strength)) this.hideOutline();
        };
        this.drawOutline = (pulse)=>{
            const { frame: frame } = this.opts;
            const artContainer = typeof this.opts.artContainer === "function" ? this.opts.artContainer() : this.opts.artContainer;
            if (!artContainer || artContainer.destroyed || !frame) return false;
            const current = frame();
            const frames = (Array.isArray(current) ? current : [
                current
            ]).filter((next)=>next?.texture?.valid);
            if (frames.length === 0) return false;
            // A container torn down with its children (another storey's map leaving the screen) took the
            // outline with it; start a fresh one.
            if (this.shell?.destroyed) {
                this.shell = undefined;
                this.outline = undefined;
                this.outlineSprites = [];
            }
            if (this.shell && this.shell.parent !== artContainer) artContainer.addChildAt(this.shell, 0);
            if (!this.outline) {
                const shell = new $95f2390044c89843$var$BoundlessContainer();
                const outline = new (0, $8t5Gy.Container)();
                outline.filters = [
                    $95f2390044c89843$var$flattenToGlowColor()
                ];
                this.outline = outline;
                this.shell = shell;
                shell.addChild(outline);
                // Behind the art. LPC animations are appended to their container as they finish baking, so
                // index 0 keeps the outline below whichever frames arrive later.
                artContainer.addChildAt(shell, 0);
            }
            // One copy per (frame x pass x direction). The pool grows to fit and is reused; anything left
            // over from a frame count that has since shrunk is parked empty rather than destroyed.
            let i = 0;
            frames.forEach(({ texture: texture, x: x, y: y, scaleX: scaleX, scaleY: scaleY, anchorX: anchorX = 0, anchorY: anchorY = 0 })=>{
                $95f2390044c89843$var$OUTLINE_PASSES.forEach((pass)=>{
                    $95f2390044c89843$var$OUTLINE_DIRECTIONS.forEach(([dx, dy])=>{
                        const sprite = this.outlineSpriteAt(i++, pass.alpha);
                        sprite.texture = texture;
                        sprite.scale.set(scaleX, scaleY);
                        sprite.anchor.set(anchorX, anchorY);
                        sprite.x = x + dx * pass.distance;
                        sprite.y = y + dy * pass.distance;
                        sprite.visible = true;
                    });
                });
            });
            for(let spare = i; spare < this.outlineSprites.length; spare++)this.outlineSprites[spare].visible = false;
            this.outline.alpha = pulse;
            this.outline.visible = true;
            if (this.opts.zIndex && this.shell) this.shell.zIndex = this.opts.zIndex();
            return true;
        };
        this.outlineSpriteAt = (index, alpha)=>{
            let sprite = this.outlineSprites[index];
            if (!sprite) {
                sprite = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).EMPTY);
                this.outlineSprites[index] = sprite;
                this.outline.addChild(sprite);
            }
            sprite.alpha = alpha;
            return sprite;
        };
        this.opts = opts;
    }
}


parcelRequire("1avo5");
var $9Pi8W = parcelRequire("9Pi8W");

class $30b51e7e6bcae30f$export$75ebcd2c8ed5b901 {
    constructor(){
        this.preset = (0, $ef882f0a643d87d9$export$9b7bc1f57570b828);
        // Explicit overrides always take precedence over a role or legacy variant, regardless of
        // builder call order. Among explicit size()/fontSize() calls, the last call wins.
        this.size = (size)=>{
            this._namedSize = size;
            this._size = (0, $ef882f0a643d87d9$export$ed6aa976aece225c)[size];
            return this;
        };
        this.color = (color)=>{
            if (color !== undefined) this._color = color;
            return this;
        };
        this.bold = (enabled = true)=>{
            this._bold = enabled;
            return this;
        };
        this.align = (align)=>{
            this._align = align;
            return this;
        };
        this.fontFamily = (fontFamily)=>{
            this._fontFamily = fontFamily;
            return this;
        };
        this.fontSize = (size)=>{
            this._size = size;
            return this;
        };
        // Wrap onto multiple lines at `width`, breaking inside a word if one is longer than that. Set
        // at BUILD time rather than by poking text.style afterwards, so the measured width of the
        // resulting Text is guaranteed to respect it — a caller that sizes a panel around the text
        // (see gui/roster_speech.ts) depends on that being true from the first frame.
        this.wordWrap = (width)=>{
            this._wordWrapWidth = width;
            return this;
        };
        // Outline width, in pixels, of the black stroke every Text gets by default (see render()). The
        // default earns its keep over the world, where a label has to stay readable against whatever
        // tile it happens to sit on -- but it is a liability on flat UI: a DARK glyph on a LIGHT fill
        // grows a black halo the same colour as its own ink, which fattens the stems and closes up the
        // counters of small bold type. Pass 0 for text that sits on a solid panel.
        this.strokeThickness = (thickness)=>{
            this._strokeThickness = thickness;
            return this;
        };
        this.role = (role)=>{
            this.preset = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378)[role];
            return this;
        };
        this.variant = (variant)=>{
            this.preset = (0, $ef882f0a643d87d9$export$911e9fe6c3536bd5)[variant];
            return this;
        };
        // Server-authored dynamic text carries a string. Keep unknown names compatible with the
        // historical default while typed client code uses variant() or role().
        this.legacyVariant = (name)=>{
            this.preset = (0, $ef882f0a643d87d9$export$911e9fe6c3536bd5)[(0, $ef882f0a643d87d9$export$e67e74afd009f581)(name)];
            return this;
        };
        this.render = (text)=>{
            const style = {
                fontFamily: this._fontFamily || (0, $ef882f0a643d87d9$export$2653e0d5dd45b294),
                // font: 'bold italic Sans-Serif',
                fill: "#ffffff",
                // stroke: '#000000',
                fontWeight: this._bold ?? this.preset.bold ? "bolder" : "normal",
                align: this._align || "left",
                strokeThickness: this._strokeThickness === undefined ? 1 : this._strokeThickness,
                fontSize: this._size ?? this.preset.fontSize,
                ...this._wordWrapWidth !== undefined ? {
                    wordWrap: true,
                    wordWrapWidth: this._wordWrapWidth,
                    breakWords: true
                } : {}
            };
            const someText = new (0, $9Pi8W.Text)(text || "", style);
            someText.roundPixels = true;
            const resolution = this._resolution ?? (this.preset.resolutionScale === undefined ? undefined : this.preset.resolutionScale * (typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1));
            if (resolution !== undefined) // Fixed resolution => Text.autoResolution off => it won't re-rasterize (nor glitch for a
            // frame) when rendered into a RenderTexture of a different resolution, i.e. the PiP.
            someText.resolution = resolution;
            someText.tint = this._color ?? this.preset.color ?? 0xffffff;
            someText.scale.set(1.0);
            return someText;
        };
    }
}


const $6335240112362a5a$export$e3aee9fe145238b4 = {
    delay: 250,
    appear: 160,
    complete: 320,
    cancel: 170
};
// The dial is drawn in screen pixels against a 64px tile (`root` undoes the world surface's zoom), in the build
// countdown's colours: it is the same family of dial, over the same walls. No SCALER correction: the letterbox cancels
// the stage's vertical stretch, so the world surface is already square on screen.
const $6335240112362a5a$var$RADIUS = 11;
const $6335240112362a5a$var$RING_RADIUS = $6335240112362a5a$var$RADIUS - 3;
const $6335240112362a5a$var$RING_WIDTH = 3;
const $6335240112362a5a$var$FACE_COLOR = 0x20262d;
const $6335240112362a5a$var$BORDER_COLOR = 0x8e7b58;
const $6335240112362a5a$var$GROOVE_COLOR = 0x454b54;
const $6335240112362a5a$var$RING_COLOR = 0xffd166;
const $6335240112362a5a$var$INK_COLOR = 0xffedc7;
// The hover glow's amber, for the outline of a tile with no sprite to trace.
const $6335240112362a5a$var$FOOTPRINT_COLOR = 0xf7c070;
// Space between the dial and its label, and between the cue and the top of the tile's art.
const $6335240112362a5a$var$LABEL_GAP = 4;
const $6335240112362a5a$var$LIFT = 6;
// Above the sky surface (1000000), so a roof's cue is not drawn under the roof.
const $6335240112362a5a$var$CUE_Z = 1000002;
const $6335240112362a5a$var$FOOTPRINT_Z = $6335240112362a5a$var$CUE_Z - 1;
const $6335240112362a5a$var$FOOTPRINT_FADE_IN_MS = 140;
const $6335240112362a5a$var$FOOTPRINT_FADE_OUT_MS = 220;
// The tile's art added onto itself. In a run of wall its neighbours hide the outline's sides, so this is what picks
// the pressed piece out of the run. It brightens as the hold fills, flares as the verb fires.
const $6335240112362a5a$var$LIT_FADE_IN_MS = 120;
const $6335240112362a5a$var$LIT_FADE_OUT_MS = 220;
const $6335240112362a5a$var$LIT_REST = 0.16;
const $6335240112362a5a$var$LIT_FULL = 0.42;
const $6335240112362a5a$var$LIT_FLASH = 0.7;
class $6335240112362a5a$export$8025842f200d888e {
    constructor(worldSurface){
        this.worldSurface = worldSurface;
        this.phase = "idle";
        this.startedAt = 0;
        this.endedAt = 0;
        this.releasedAt = 0;
        this.root = new (0, $8t5Gy.Container)();
        this.dial = new (0, $gwPoJ.Graphics)();
        this.bloom = new (0, $gwPoJ.Graphics)();
        this.footprint = new (0, $gwPoJ.Graphics)();
        this.footprintStrength = 0;
        this.lit = new (0, $8t5Gy.Container)();
        this.litStrength = 0;
        this.litGlow = $6335240112362a5a$var$LIT_REST;
        this.lastFrameAt = 0;
        this.art = [];
        this.highlight = new (0, $95f2390044c89843$export$b6cf31fac6564392)({
            artContainer: ()=>this.art[0]?.parent,
            frame: ()=>this.frames(),
            zIndex: ()=>Math.min(...this.art.map((sprite)=>sprite.zIndex)) - 1
        });
        this.isActive = ()=>this.phase !== "idle";
        this.begin = (press, now = Date.now())=>{
            this.press = press;
            this.phase = "holding";
            this.startedAt = now;
            this.art = [];
            this.label.text = press.label ?? "";
            this.label.visible = !!press.label;
            this.animate(now);
        };
        this./** The hold ran its course and its verb fired. */ complete = (now = Date.now())=>{
            if (this.phase !== "holding") return;
            this.phase = "complete";
            this.endedAt = now;
            this.highlight.set(false);
        };
        this./** The press ended. Before the hold was done, that throws it away; after, the completion plays on. */ cancel = (now = Date.now())=>{
            if (this.phase !== "holding") return;
            if (!this.shown(now)) {
                this.stop();
                return;
            }
            this.releasedAt = this.progress(now);
            this.phase = "cancel";
            this.endedAt = now;
            this.highlight.set(false);
        };
        this./** Called every frame. Cheap when idle. */ animate = (now = Date.now())=>{
            const elapsed = this.lastFrameAt ? Math.max(0, now - this.lastFrameAt) : 0;
            this.lastFrameAt = now;
            if (this.phase === "idle") {
                this.fadeFootprint(elapsed, false);
                this.fadeLit(elapsed, false);
                return;
            }
            const surface = this.worldSurface();
            if (!surface || surface.destroyed || !this.press) {
                this.stop();
                return;
            }
            if (this.root.parent !== surface) surface.addChild(this.root);
            if (this.footprint.parent !== surface) surface.addChild(this.footprint);
            this.art = this.press.art().filter((sprite)=>!sprite.destroyed && sprite.parent);
            const traced = this.art.length > 0;
            if (this.phase === "holding" && traced && this.shown(now)) this.highlight.set(true);
            this.footprint.position.set(this.press.cell.x, this.press.cell.y);
            this.fadeFootprint(elapsed, this.phase === "holding" && !traced && this.shown(now));
            this.fadeLit(elapsed, this.litFor(now));
            const anchor = this.anchor(surface);
            this.root.position.set(anchor.x, anchor.y);
            if (!this.drawDial(now)) this.stop();
        };
        this.destroy = ()=>{
            if (this.root.destroyed) return;
            this.stop();
            this.highlight.dispose();
            this.root.parent?.removeChild(this.root);
            this.root.destroy({
                children: true
            });
            this.footprint.parent?.removeChild(this.footprint);
            this.footprint.destroy();
            this.lit.parent?.removeChild(this.lit);
            if (!this.lit.destroyed) this.lit.destroy({
                children: true
            });
        };
        this.stop = ()=>{
            this.phase = "idle";
            this.press = undefined;
            this.root.visible = false;
            this.highlight.set(false);
        };
        this.shown = (now)=>now - this.startedAt >= $6335240112362a5a$export$e3aee9fe145238b4.delay;
        this.progress = (now)=>(0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)((now - this.startedAt) / Math.max(1, this.press?.durationMs ?? 1));
        this.drawDial = (now)=>{
            if (!this.shown(now)) {
                this.root.visible = false;
                return true;
            }
            const appear = (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)((now - this.startedAt - $6335240112362a5a$export$e3aee9fe145238b4.delay) / $6335240112362a5a$export$e3aee9fe145238b4.appear);
            let scale = 0.6 + 0.4 * (0, $a8782f4c6450260e$export$3daa4a78f444687d)(appear);
            let alpha = (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)(appear * 1.6);
            let fill = this.progress(now);
            let flash = 0;
            let bloom = -1;
            if (this.phase === "complete") {
                const t = (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)((now - this.endedAt) / $6335240112362a5a$export$e3aee9fe145238b4.complete);
                if (t >= 1) return false;
                fill = 1;
                flash = 1 - t;
                bloom = t;
                scale = 1 + 0.18 * (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(t);
                alpha = 1 - (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)((t - 0.3) / 0.7);
            } else if (this.phase === "cancel") {
                const t = (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)((now - this.endedAt) / $6335240112362a5a$export$e3aee9fe145238b4.cancel);
                if (t >= 1) return false;
                fill = this.releasedAt * (1 - (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(t));
                scale *= 1 - 0.15 * t;
                alpha *= 1 - t;
            }
            this.root.visible = true;
            this.root.alpha = alpha;
            this.root.scale.set(0.5 * scale);
            // The dial and its label make one chip, centred over the tile and standing just clear of its art.
            const width = $6335240112362a5a$var$RADIUS * 2 + (this.label.visible ? $6335240112362a5a$var$LABEL_GAP + this.label.width : 0);
            const cx = -width / 2 + $6335240112362a5a$var$RADIUS;
            const cy = -$6335240112362a5a$var$RADIUS - $6335240112362a5a$var$LIFT;
            this.label.position.set(cx + $6335240112362a5a$var$RADIUS + $6335240112362a5a$var$LABEL_GAP, cy);
            const g = this.dial;
            g.clear();
            // Dropped silhouette, so the dial reads as an object above the wall rather than a decal on it.
            g.beginFill(0x000000, 0.28).drawCircle(cx, cy + 2, $6335240112362a5a$var$RADIUS).endFill();
            g.lineStyle(1, flash > 0 ? $6335240112362a5a$var$INK_COLOR : $6335240112362a5a$var$BORDER_COLOR, 0.9);
            g.beginFill($6335240112362a5a$var$FACE_COLOR, 0.97).drawCircle(cx, cy, $6335240112362a5a$var$RADIUS - 1).endFill();
            g.lineStyle($6335240112362a5a$var$RING_WIDTH, $6335240112362a5a$var$GROOVE_COLOR, 0.9).drawCircle(cx, cy, $6335240112362a5a$var$RING_RADIUS);
            if (fill > 0) {
                // Filling, not draining: the hold is building toward something.
                const from = -Math.PI / 2;
                const to = from + Math.min(1, fill) * Math.PI * 2;
                const color = flash > 0 ? $6335240112362a5a$var$INK_COLOR : $6335240112362a5a$var$RING_COLOR;
                // A fat faint copy under the arc is the glow; this hardware cannot spare a filter.
                g.lineStyle({
                    width: $6335240112362a5a$var$RING_WIDTH + 2.5,
                    color: color,
                    alpha: 0.26,
                    cap: (0, $gwPoJ.LINE_CAP).ROUND
                }).moveTo(cx, cy - $6335240112362a5a$var$RING_RADIUS).arc(cx, cy, $6335240112362a5a$var$RING_RADIUS, from, to);
                g.lineStyle({
                    width: $6335240112362a5a$var$RING_WIDTH,
                    color: color,
                    alpha: 1,
                    cap: (0, $gwPoJ.LINE_CAP).ROUND
                }).moveTo(cx, cy - $6335240112362a5a$var$RING_RADIUS).arc(cx, cy, $6335240112362a5a$var$RING_RADIUS, from, to);
                if (fill < 1) // The moving head: a ring barely started still reads as moving.
                g.lineStyle(0).beginFill($6335240112362a5a$var$INK_COLOR).drawCircle(cx + Math.cos(to) * $6335240112362a5a$var$RING_RADIUS, cy + Math.sin(to) * $6335240112362a5a$var$RING_RADIUS, $6335240112362a5a$var$RING_WIDTH / 2 + 0.4).endFill();
            }
            if (flash > 0) // The closing ring lights the whole face for a moment.
            g.lineStyle(0).beginFill($6335240112362a5a$var$RING_COLOR, 0.45 * flash).drawCircle(cx, cy, $6335240112362a5a$var$RING_RADIUS - $6335240112362a5a$var$RING_WIDTH / 2).endFill();
            // The success bloom starts OUTSIDE the rim, so it can never be read as the gauge itself.
            const b = this.bloom;
            b.clear();
            if (bloom >= 0) {
                const radius = $6335240112362a5a$var$RADIUS + 1 + 10 * (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(bloom);
                b.lineStyle(2.5 * (1 - bloom) + 0.5, $6335240112362a5a$var$RING_COLOR, Math.pow(1 - bloom, 1.5)).drawCircle(cx, cy, radius);
            }
            return true;
        };
        this.anchor = (surface)=>{
            if (!this.art.length) return {
                x: this.press.cell.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2,
                y: this.press.cell.y
            };
            let minX = Infinity, maxX = -Infinity, minY = Infinity;
            this.frames().forEach(({ texture: texture, x: x, y: y, scaleX: scaleX, scaleY: scaleY, anchorX: anchorX = 0, anchorY: anchorY = 0 })=>{
                const w = texture.width * scaleX, h = texture.height * scaleY;
                const left = x - anchorX * w, top = y - anchorY * h;
                minX = Math.min(minX, left, left + w);
                maxX = Math.max(maxX, left, left + w);
                minY = Math.min(minY, top, top + h);
            });
            const container = this.art[0].parent;
            const top = new (0, $6qzqq.Point)((minX + maxX) / 2, minY);
            return container === surface ? top : surface.toLocal(top, container);
        };
        this.frames = ()=>this.art.filter((sprite)=>!sprite.destroyed && sprite.texture).map((sprite)=>({
                    texture: sprite.texture,
                    x: sprite.x,
                    y: sprite.y,
                    scaleX: sprite.scale.x,
                    scaleY: sprite.scale.y,
                    anchorX: sprite.anchor.x,
                    anchorY: sprite.anchor.y
                }));
        this.litFor = (now)=>{
            if (this.phase === "holding") {
                this.litGlow = $6335240112362a5a$var$LIT_REST + ($6335240112362a5a$var$LIT_FULL - $6335240112362a5a$var$LIT_REST) * this.progress(now);
                return this.shown(now);
            }
            if (this.phase === "complete") {
                const t = (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)((now - this.endedAt) / $6335240112362a5a$export$e3aee9fe145238b4.complete);
                this.litGlow = $6335240112362a5a$var$LIT_FULL + ($6335240112362a5a$var$LIT_FLASH - $6335240112362a5a$var$LIT_FULL) * (1 - t);
                return t < 0.5;
            }
            return false;
        };
        this.fadeLit = (elapsed, on)=>{
            const step = elapsed / (on ? $6335240112362a5a$var$LIT_FADE_IN_MS : $6335240112362a5a$var$LIT_FADE_OUT_MS);
            this.litStrength = on ? Math.min(1, this.litStrength + step) : Math.max(0, this.litStrength - step);
            // A container torn down with its children (another storey leaving the screen) took these copies with it.
            if (this.lit.destroyed) this.lit = new (0, $8t5Gy.Container)();
            const art = this.art.filter((sprite)=>!sprite.destroyed && sprite.parent && !sprite.parent.destroyed);
            if (this.litStrength <= 0 || !art.length) {
                this.lit.visible = false;
                return;
            }
            const container = art[0].parent;
            if (this.lit.parent !== container) container.addChild(this.lit);
            this.lit.zIndex = Math.max(...art.map((sprite)=>sprite.zIndex)) + 0.01;
            art.forEach((sprite, i)=>{
                let copy = this.lit.children[i];
                if (!copy) {
                    copy = new (0, $7Bs2Z.Sprite)();
                    copy.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
                    this.lit.addChild(copy);
                }
                copy.texture = sprite.texture;
                copy.position.copyFrom(sprite.position);
                copy.scale.copyFrom(sprite.scale);
                copy.anchor.copyFrom(sprite.anchor);
                copy.visible = true;
            });
            for(let i = art.length; i < this.lit.children.length; i++)this.lit.children[i].visible = false;
            this.lit.alpha = this.litStrength * this.litGlow;
            this.lit.visible = true;
        };
        this.fadeFootprint = (elapsed, on)=>{
            const step = elapsed / (on ? $6335240112362a5a$var$FOOTPRINT_FADE_IN_MS : $6335240112362a5a$var$FOOTPRINT_FADE_OUT_MS);
            this.footprintStrength = on ? Math.min(1, this.footprintStrength + step) : Math.max(0, this.footprintStrength - step);
            this.footprint.alpha = this.footprintStrength;
            this.footprint.visible = this.footprintStrength > 0;
        };
        this.drawFootprint = ()=>{
            const g = this.footprint;
            g.clear();
            g.lineStyle(3.5, $6335240112362a5a$var$FOOTPRINT_COLOR, 0.22).drawRoundedRect(1.5, 1.5, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 3, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 3, 4);
            g.lineStyle(1.25, $6335240112362a5a$var$FOOTPRINT_COLOR, 0.95).drawRoundedRect(1.5, 1.5, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 3, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 3, 4);
            g.lineStyle(0).beginFill($6335240112362a5a$var$FOOTPRINT_COLOR, 0.12).drawRoundedRect(2, 2, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 4, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 4, 3.5).endFill();
        };
        this.root.zIndex = $6335240112362a5a$var$CUE_Z;
        this.root.visible = false;
        this.root.addChild(this.bloom, this.dial);
        this.label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(10).color($6335240112362a5a$var$INK_COLOR).bold().strokeThickness(2).render("");
        this.label.anchor.set(0, 0.5);
        this.root.addChild(this.label);
        this.footprint.zIndex = $6335240112362a5a$var$FOOTPRINT_Z;
        this.footprint.visible = false;
        this.drawFootprint();
    }
}




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
// Touch holds open the context menu; a short touch remains an attack.
/**
 * The largest step accrueRunHint will credit in one tick of the velocity loop.
 *
 * That loop is a setInterval, and a browser throttles those hard in a backgrounded tab -- so without
 * this, a tab left alone with Shift down would return having banked the whole threshold at once.
 */ const $319b1dfd90d3ebea$var$RUN_HINT_MAX_STEP_MS = 250;
const $319b1dfd90d3ebea$var$ENTITY_PRESS_HOLD_MS = 500;
const $319b1dfd90d3ebea$var$BUILD_DRAG_THRESHOLD_PX = 4;
const $319b1dfd90d3ebea$var$HELD_ATTACK_MS = 400;
/**
 * Letting go of a diagonal is two key-ups, never one, so between them a single key is still down.
 * The facing waits this long before turning to that key: a body that stops inside it keeps facing
 * the diagonal it walked instead of snapping to a cardinal. Holding the key past it turns as before.
 */ const $319b1dfd90d3ebea$var$DIAGONAL_RELEASE_GRACE_MS = 100;
const $319b1dfd90d3ebea$export$54edab2f6fe321b1 = 3000;
const $319b1dfd90d3ebea$var$BUILD_GHOST_ALPHA = 0.4;
const $319b1dfd90d3ebea$export$412acd947dfd38f2 = undefined;
class $319b1dfd90d3ebea$var$DegreesRotator {
    constructor(targetAngle, increment, currentAngle){
        this.update = ()=>{
            const delta = this.targetAngle - this.currentAngle;
            if (delta < 0) this.currentAngle -= this.increment;
            else this.currentAngle += this.increment;
            if (Math.abs(delta) < this.increment) return true;
            return false;
        };
        this.normalizedCurrent = ()=>{
            return this.currentAngle > 360 ? this.currentAngle - 360 : this.currentAngle;
        };
        this.normalizedTarget = ()=>{
            return this.targetAngle > 360 ? this.targetAngle - 360 : this.targetAngle;
        };
        this.targetAngle = targetAngle;
        this.currentAngle = currentAngle;
        this.increment = increment;
        const delta = this.targetAngle - this.currentAngle;
        if (Math.abs(delta) >= 180) {
            if (this.targetAngle > this.currentAngle) this.currentAngle += 360;
            else this.targetAngle += 360;
        }
    }
}
class $319b1dfd90d3ebea$export$2616165974278734 {
    constructor(client, entity, mouseHandler, keyboardHandler, guest){
        this.isChat = false;
        this.lastMouseMoveTs = 0;
        this.keyboardActionEnabled = true;
        this.mouseActionEnabled = true;
        this.suppressAttackUntilTs = 0;
        /** The furthest-out deadline any outstanding paralyze request has asked for. See paralyze(). */ this.paralyzedUntilTs = 0;
        // DOWNED: the server's verdict that this player has fallen and has not been put back on their
        // feet yet (Message.downed, mirrored by ClientGameLogic.updateFromPlayerMessage). Distinct
        // from `paralyzed`, which is a short client-side beat that times itself out -- this one lasts
        // as long as the server says it does, which for an ember camp is however long the player takes
        // to answer their end-of-run panel. The server refuses their input for the same reason, so
        // stopping here is what keeps them from predicting a walk they never get to take.
        this.downed = false;
        this.randomness = undefined;
        this.mouseAttackHeld = false;
        // Whether the keys last read held both axes, and the wait after one of them came up.
        this.keyboardHeldDiagonal = false;
        this.roughCompositeTilePointer = (0, $a80d0b17b615d6f7$export$b03ec757ccd6a9ce)();
        this.longRangedEquipped = undefined;
        this.terrainPointerOn = false;
        this.buildingEquipmentRestored = false;
        this.placementPointerOn = false;
        // Whether the pointer aimed the placement item last, rather than the player's own position and facing.
        this.placementAimedByPointer = false;
        this.pendingPrintTimers = new Map();
        /** Keep a promoted floor stroke aligned with the wall/roof cell where the drag began. */ this.buildPickLift = 0;
        this.buildPrimarySuppressed = false;
        this.resumeBuildAfterTileWheel = false;
        this.mobileBuildTool = "room";
        this.mobileBuildDragging = false;
        this.buildingShape = "rectangle";
        this.buildingShapePaletteDismissed = false;
        this.buildingShapeScroll = 0;
        this.buildingShapeScrollAt = 0;
        this.buildPrintGroupId = 0;
        this.buildPreviewRevision = 0;
        this.pendingBuilds = new Map();
        this.pendingRectangles = new Map();
        this.buildPlacementFeedback = new (0, $f982fe860ce57e21$export$dd4b4b25282569d2)(()=>this.client.clientGameLogic.clientRenderer.map().getTileSurface());
        // The pressed tile lit, and a ring filling for as long as the hold has to last.
        this.tilePressCue = new (0, $6335240112362a5a$export$8025842f200d888e)(()=>this.client.clientGameLogic.clientRenderer.map?.()?.getTileSurface?.());
        this.sharedBuilds = new Map();
        this.lastSharedBuildSnapshot = "";
        this.lastSharedBuildAt = 0;
        this.terrainPointerSprites = new Set();
        // Ladders growing a storey after the builder extended them, and the sawdust they land in.
        this.ladderGrowths = new Set();
        this.ladderDust = new (0, $dd2f604be1eac3c5$export$ef42757986f4090e)(()=>this.client.clientGameLogic.clientRenderer.map().getTileSurface());
        // Existing tiles the cursor's or a plan's piece reshapes, shown in their new shape.
        this.reshapeGhosts = new (0, $6e50b195d7f0ac79$export$5968578be146f331)(()=>this.client.clientGameLogic.clientRenderer.map(), (x, y, layerId)=>this.client.clientGameLogic.tilemapMetaProvider?.resolveTileMapFromLayerId?.(layerId)?.[x]?.[y]);
        /** The pressed tile has not claimed the press yet: it is still an ordinary attack until the hold runs out. */ this.tilePressDeferred = false;
        this.pressOpenedMenu = false;
        this.targetSpeed2 = {
            x: 0,
            y: 0
        };
        // How long the player has genuinely run -- Shift held AND moving -- while the camp's run hint
        // is teachable. See accrueRunHint.
        this.runHintMs = 0;
        this.runHintLastTs = 0;
        // Held movement intent from the mobile joysticks. Their onChange only fires on pointermove,
        // so a thumb parked at full deflection produces no events at all -- the intent has to be
        // latched here and re-applied by updatePlayerVelocity every tick, exactly as a held key is.
        this.joystickSpeed2 = null;
        // Both room presentations belong to the same climb.
        this.climbId = ()=>this.entity.stairTravel?.climb ? this.entity.stairTravel.id.replace(/(:arrival)+$/, "") : undefined;
        this.movementStartTime = 0;
        this.isSustainedMovement = false;
        this.isKeyOn = (key)=>{
            // If in chat mode, don't detect movement keys
            if (this.isChat && [
                "w",
                "a",
                "s",
                "d",
                "ArrowUp",
                "ArrowDown",
                "ArrowLeft",
                "ArrowRight"
            ].includes(key)) return false;
            return this.keyboardHandler.state().get(key) || this.keyboardHandler.state().get(key.toUpperCase());
        };
        this.isButtonOn = (key)=>this.mouseHandler.state().buttons.get(key) == true;
        this.adjustEntityAngle = (entity, delta)=>(0, $a80d0b17b615d6f7$export$b363da9ded343252)({
                x: entity.location.x,
                y: entity.location.y
            }, {
                x: entity.location.x + delta.x,
                y: entity.location.y + delta.y
            });
        this.keyboardBasedAngle = (entity)=>{
            const leftRightOn = this.isKeyOn("a") || this.isKeyOn("ArrowLeft") || this.isKeyOn("d") || this.isKeyOn("ArrowRight");
            const upDownOn = this.isKeyOn("w") || this.isKeyOn("ArrowUp") || this.isKeyOn("s") || this.isKeyOn("ArrowDown");
            // One key of a diagonal has come up and the other is still down: hold the diagonal facing
            // for DIAGONAL_RELEASE_GRACE_MS, then look again. Any other key state ends the wait.
            if (this.keyboardHeldDiagonal && leftRightOn !== upDownOn) {
                if (this.diagonalReleaseTimer === undefined) this.diagonalReleaseTimer = setTimeout(()=>{
                    this.diagonalReleaseTimer = undefined;
                    this.keyboardHeldDiagonal = false;
                    if (Date.now() - this.lastMouseMoveTs > 150) this.keyboardBasedAngle(this.entity);
                }, $319b1dfd90d3ebea$var$DIAGONAL_RELEASE_GRACE_MS);
                return;
            }
            clearTimeout(this.diagonalReleaseTimer);
            this.diagonalReleaseTimer = undefined;
            this.keyboardHeldDiagonal = leftRightOn && upDownOn;
            let newTargetAngle;
            if (!leftRightOn) {
                if (this.isKeyOn("w") || this.isKeyOn("ArrowUp")) newTargetAngle = this.adjustEntityAngle(entity, {
                    x: 0,
                    y: 1
                });
                if (this.isKeyOn("s") || this.isKeyOn("ArrowDown")) newTargetAngle = this.adjustEntityAngle(entity, {
                    x: 0,
                    y: -1
                });
            } else {
                if (this.isKeyOn("w") || this.isKeyOn("ArrowUp")) {
                    if (this.isKeyOn("a") || this.isKeyOn("ArrowLeft")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: 1,
                        y: 1
                    });
                    if (this.isKeyOn("d") || this.isKeyOn("ArrowRight")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: -1,
                        y: 1
                    });
                }
                if (this.isKeyOn("s") || this.isKeyOn("ArrowDown")) {
                    if (this.isKeyOn("a") || this.isKeyOn("ArrowLeft")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: 1,
                        y: -1
                    });
                    if (this.isKeyOn("d") || this.isKeyOn("ArrowRight")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: -1,
                        y: -1
                    });
                }
            }
            if (!upDownOn) {
                if (this.isKeyOn("a") || this.isKeyOn("ArrowLeft")) newTargetAngle = this.adjustEntityAngle(entity, {
                    x: 1,
                    y: 0
                });
                if (this.isKeyOn("d") || this.isKeyOn("ArrowRight")) newTargetAngle = this.adjustEntityAngle(entity, {
                    x: -1,
                    y: 0
                });
            } else {
                if (this.isKeyOn("a") || this.isKeyOn("ArrowLeft")) {
                    if (this.isKeyOn("w") || this.isKeyOn("ArrowUp")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: 1,
                        y: 1
                    });
                    if (this.isKeyOn("s") || this.isKeyOn("ArrowDown")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: 1,
                        y: -1
                    });
                }
                if (this.isKeyOn("d") || this.isKeyOn("ArrowRight")) {
                    if (this.isKeyOn("w") || this.isKeyOn("ArrowUp")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: -1,
                        y: 1
                    });
                    if (this.isKeyOn("s") || this.isKeyOn("ArrowDown")) newTargetAngle = this.adjustEntityAngle(entity, {
                        x: -1,
                        y: -1
                    });
                }
            }
            if (newTargetAngle !== undefined && newTargetAngle !== this.targetKeyboardAngle) {
                if (this.keyboardAndleAdjustInterval) clearInterval(this.keyboardAndleAdjustInterval);
                this.targetKeyboardAngle = newTargetAngle;
                const increment = 5;
                const rotator = new $319b1dfd90d3ebea$var$DegreesRotator(Math.floor((0, $a80d0b17b615d6f7$export$32b1497b7aadef08)(newTargetAngle)), increment, Math.floor((0, $a80d0b17b615d6f7$export$32b1497b7aadef08)(this.entity.movement.angle)));
                this.keyboardAndleAdjustInterval = setInterval(()=>{
                    const done = rotator.update();
                    this.entity.movement.angle = (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)(rotator.normalizedCurrent());
                    if (done) {
                        this.entity.movement.angle = (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)(rotator.normalizedTarget());
                        clearInterval(this.keyboardAndleAdjustInterval);
                    }
                }, 5);
            }
        };
        this.updateRoom = ()=>{
            // A pick armed in the room just left has nothing to point at any more.
            this.cancelLocationPick();
            this.clearSharedBuilds();
            this.clearPendingBuilds();
            this.buildPreviewRevision++;
            this.buildPreview = undefined;
            this.clearTerrainPointer();
            this.buildPointer = undefined;
            this.placementPointer = undefined;
            this.placementPointerPose = undefined;
            if (this.pointer) this.pointer = undefined;
            if (this.roughPointer) this.roughPointer = undefined;
            this.hoveredEntity = undefined;
        };
        this.updateOrientation = (orientation)=>{
            const { entity: entity } = this;
            switch(orientation){
                case "south":
                    entity.movement.angle = this.adjustEntityAngle(entity, {
                        x: 0,
                        y: -1
                    });
                    break;
                case "north":
                    entity.movement.angle = this.adjustEntityAngle(entity, {
                        x: 0,
                        y: 1
                    });
                    break;
                case "east":
                    entity.movement.angle = this.adjustEntityAngle(entity, {
                        x: -1,
                        y: 0
                    });
                    break;
                case "west":
                    entity.movement.angle = this.adjustEntityAngle(entity, {
                        x: 1,
                        y: 0
                    });
                    break;
            }
        };
        /**
     * Open chat, asked for by something other than a key -- the SAY chip in a camp's HUD row, or
     * the chat button on the control bar.
     *
     * It picks the field the device can actually use. A phone has no Enter to open the inline field
     * with, no Escape to leave it with, and a soft keyboard does not produce the keystrokes that
     * field reads, so touch gets the composer: a real DOM <input>, which is the only thing that
     * raises the keyboard at all. A desktop gets exactly what Enter gives it, `isChat` included, so
     * a line begun with the mouse can be sent with the keyboard.
     */ this.requestChat = ()=>{
            // The tap that asked for chat is still in flight: a chip reports a `click`/`tap` on pointer
            // UP, while the world's attack arrives on a document-level `mousedown` that cannot see the
            // widget it landed on. Without this, opening chat swings whatever is in the player's hand.
            this.suppressAttack();
            const gui = this.client.clientGameLogic.clientRenderer.gui();
            if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) {
                if (gui.isChatComposerVisible()) return;
                // A stick still under a thumb when the field takes the touch would stay latched: the
                // joystick's onChange only fires on pointermove, so nothing would ever clear it and the
                // player would type while walking off into the dark.
                this.setJoystickIntent(null);
                gui.openChatComposer();
                return;
            }
            if (this.isChat) return;
            this.client.startChat();
            this.isChat = true;
        };
        // Pasted text only means anything while the chat input is open; anywhere else in the game
        // there is nothing it could be pasted INTO.
        this.respondToPaste = (text)=>{
            if (!this.isChat || !this.client.clientGameLogic.isBootstrapped()) return;
            this.client.pasteIntoChat(text);
        };
        this.respondToKeyBoard = (key, down, repeat, mods)=>{
            if (key === $319b1dfd90d3ebea$export$412acd947dfd38f2 && !down) this.buildingShapePaletteDismissed = false;
            if (!this.client.clientGameLogic.isBootstrapped()) // can't do anything unless you're bootstrapped
            return;
            if (!this.keyboardActionEnabled) return;
            const { entity: entity } = this;
            // Releases, auto-repeat and keys in the automatic climb's direction keep it going.
            const climb = entity.stairTravel?.climb && entity.stairTravel;
            const alongClimb = climb && (climb.direction === "up" ? key === "ArrowUp" || key.toLowerCase() === "w" : key === "ArrowDown" || key.toLowerCase() === "s");
            // Held-key repeats must not run the walking/facing handlers during an automatic climb.
            if (alongClimb && this.manualClimbId !== this.climbId()) return;
            if (down && !repeat && !alongClimb) this.manualClimbId = this.climbId();
            // Read before anything below closes it: an Escape that shuts a screen or the chat line does only that.
            const escapeInModal = (key === "Escape" || key === "Esc") && down && (this.isChat || this.client.clientGameLogic.clientRenderer.gui().isModalOpen?.() === true);
            if (key === " " && (entity.weapon?.profileId || this.localWeaponCharge) && !this.terrainPointerOn) {
                this.setAttackHeld(down);
                return;
            }
            if (this.isKeyOn("/") && !this.isChat) {
                this.client.startChat();
                this.isChat = true;
            }
            if (this.isKeyOn("Enter")) {
                if (this.isChat) this.client.stopChat();
                else this.client.startChat();
                this.isChat = !this.isChat;
            }
            if (this.isChat && down) this.client.captureKeystroke(key, mods);
            if (this.isKeyOn("Escape") && this.isChat) {
                this.client.stopChat();
                this.isChat = false;
            }
            if (this.isChat) return;
            // A single game key avoids the command wheel bound to holding Control.
            if (key.toLowerCase() === "z" && (this.terrainPointerOn || this.pendingBuilds.size) && !mods?.ctrl && !mods?.meta && !mods?.alt) {
                if (down && !repeat && this.canCorrectBuild()) this.undoLatestBuild();
                return;
            }
            // The snap chord should respond even when the mouse is stationary.
            if (key === "Alt" && this.buildStroke?.area) {
                this.updatedRoughPointer(this.roughPointer);
                return;
            }
            if ((0, $a4184bfabcb7e471$export$29fa54e0b5ca6ef1)(entity.name) && key === "&" && down && !repeat && !mods?.ctrl && !mods?.meta && !mods?.alt) {
                const gui = this.client.clientGameLogic.clientRenderer.gui();
                if (gui.isNamePromptVisible?.() || gui.isChatComposerVisible?.()) return;
                (0, $a4184bfabcb7e471$export$6bc1887dc4110236)(entity.name);
                return;
            }
            if ((0, $a4184bfabcb7e471$export$6847f56b353cc6db)(entity.name) && down && [
                "-",
                "=",
                "_",
                "+"
            ].includes(key) && !mods?.ctrl && !mods?.meta && !mods?.alt) {
                const gui = this.client.clientGameLogic.clientRenderer.gui();
                if (gui.isNamePromptVisible?.() || gui.isChatComposerVisible?.()) return;
                if (key === "_" || key === "+") (0, $2751e0027a1b432f$export$f4b3b3d0fcdde576)((0, $2751e0027a1b432f$export$42b4af315a0c8aa1) + (key === "_" ? -1 : 1));
                else (0, $2751e0027a1b432f$export$ce555363cb8c17cc)((0, $2751e0027a1b432f$export$de62489b685ceb) + (key === "-" ? -1 : 1));
                this.roofOffsetGuide?.destroy();
                this.roofOffsetGuide = undefined;
                this.refreshBuildPointer(true);
                return;
            }
            // Handle Control key for command wheel
            if (key === "Control" || key === "ControlLeft" || key === "ControlRight") {
                if (down) // Control key pressed - show command wheel
                this.client.clientGameLogic.clientRenderer.gui().showCommandWheel();
                else // Control key released - hide command wheel
                this.client.clientGameLogic.clientRenderer.gui().hideCommandWheel();
            }
            // Escape dismisses the per-entity command wheel (opened from an NPC's command button,
            // so it isn't tied to holding Control).
            if ((key === "Escape" || key === "Esc") && down) {
                const gui = this.client.clientGameLogic.clientRenderer.gui();
                if (gui.isCommandWheelVisible()) gui.hideCommandWheel();
                // Also dismiss the recruit role picker if it's open.
                if (gui.isRolePickerVisible()) gui.hideRolePicker();
                // ...and either possession splash, which is only ever telling the player something, so
                // Escape is simply the keyboard's dismiss button.
                if (gui.isPossessionSplashVisible()) gui.hidePossessionSplash();
                // ...and the invasion picker, which is open over the end-of-run scorecard while the
                // player is still DOWNED -- so this has to sit above the paralyzed/downed guard below,
                // where it already does. Routed through cancelInvasionPicker so the keyboard way out
                // tells the server exactly what the footer button and the scrim do.
                if (gui.isInvasionPickerVisible()) gui.cancelInvasionPicker();
                // ...and the name prompt. Escape is the one key that still reaches here while a text
                // field holds the keyboard (Keyboard.suppressTyping), precisely so that a field whose
                // focus has been clicked away can still be dismissed.
                if (gui.isNamePromptVisible()) gui.hideNamePrompt();
                // ...and the chat composer, for the same reason: its own Escape arrives only while its
                // field has focus, and a click on the world takes that away.
                if (gui.isChatComposerVisible?.()) gui.dismissChatComposer();
                // Escape backs out of build mode a layer at a time: plans still counting down are called off first,
                // the material staying in hand; with none left, the material is put away and the cursor goes too.
                const plans = Array.from(this.pendingBuilds.values()).some((pending)=>!pending.committing);
                if (this.terrainPointerOn && !plans && !escapeInModal) {
                    // Like a location pick taking over: dropped here at once, and ended server-side.
                    this.updateTerrainPointerOn(false);
                    this.client.clientGameLogic.cancelBuildPlacement();
                } else if (this.terrainPointerOn || this.pendingBuilds.size) this.cancelPendingPrinting();
                // Escape backs out of an armed location pick (the defender's "Hold Position") the same
                // way it backs out of build mode: the order is simply never sent.
                this.cancelLocationPick();
                // Also deactivate the ember follow-cam PiP / roster slot.
                gui.dismissFollowCam();
            }
            if (this.paralyzed || this.downed) {
                entity.movement.moving = false;
                entity.speed2.x = 0;
                entity.speed2.y = 0;
                return;
            }
            if (Date.now() - this.lastMouseMoveTs > 150) this.keyboardBasedAngle(entity);
            const isMoving = this.isKeyOn("w") || this.isKeyOn("ArrowUp") || this.isKeyOn("s") || this.isKeyOn("ArrowDown") || this.isKeyOn("a") || this.isKeyOn("ArrowLeft") || this.isKeyOn("d") || this.isKeyOn("ArrowRight");
            let manualControl = isMoving;
            if (isMoving) {
                clearInterval(this.autoMovingInterval);
                this.setAutoMoving(false);
            }
            // Remove immediate velocity zeroing to allow inertial slowdown
            // The updatePlayerVelocity method will handle velocity updates with inertia
            if (manualControl) {
                const wasMoving = entity.movement.moving;
                entity.movement.moving = isMoving;
                if (!wasMoving && entity.movement.moving) {
                    // started moving!
                    this.movementStartTime = Date.now();
                    this.isSustainedMovement = false;
                    if (this.movementDaemon !== undefined) clearInterval(this.movementDaemon);
                    this.movementDaemon = setInterval(()=>{
                        if (Date.now() - this.lastMouseMoveTs > 150) this.keyboardBasedAngle(entity);
                    }, 150);
                }
                if (wasMoving && !entity.movement.moving) {
                    // stopped moving
                    this.movementStartTime = 0;
                    this.isSustainedMovement = false;
                    if (this.movementDaemon !== undefined) clearInterval(this.movementDaemon);
                }
                if (!entity.afk) {
                    // Set target speed2 values
                    this.targetSpeed2 = {
                        x: 0,
                        y: 0
                    };
                    if (this.isKeyOn("w") || this.isKeyOn("ArrowUp")) this.targetSpeed2.y = -1;
                    if (this.isKeyOn("s") || this.isKeyOn("ArrowDown")) this.targetSpeed2.y = 1;
                    if (this.isKeyOn("a") || this.isKeyOn("ArrowLeft")) this.targetSpeed2.x = -1;
                    if (this.isKeyOn("d") || this.isKeyOn("ArrowRight")) this.targetSpeed2.x = 1;
                } else // If AFK, set target to zero
                this.targetSpeed2 = {
                    x: 0,
                    y: 0
                };
            }
            if (this.isKeyOn("e")) {
                if (this.terrainPointerOn) this.client.clientGameLogic.activateWorldPoint(this.pointer, {
                    delete: true
                });
            }
            if (this.isKeyOn("u")) this.client.spawnNpc();
            if (this.isKeyOn("x")) this.client.dropAction();
            if (this.isKeyOn("y")) this.client.itemPickupAction();
            if (this.isKeyOn("b")) this.activeAbility("b");
            if (this.isKeyOn(" ") && (!this.terrainPointerOn || key === " " && down && !repeat)) this.manualAttack(isMoving);
            if (this.isKeyOn("q")) this.client.dropActiveItem();
            if (this.isKeyOn("]")) this.client.activateAbility("e");
            if (this.isKeyOn("1")) this.client.clientGameLogic.clientRenderer.gui().activateInventorySlot(1);
            if (this.isKeyOn("2")) this.client.clientGameLogic.clientRenderer.gui().activateInventorySlot(2);
            if (this.isKeyOn("3")) this.client.clientGameLogic.clientRenderer.gui().activateInventorySlot(3);
            if (this.isKeyOn("4")) this.client.clientGameLogic.clientRenderer.gui().activateInventorySlot(4);
            if (this.isKeyOn("5")) this.client.clientGameLogic.clientRenderer.gui().activateInventorySlot(5);
            if (this.isKeyOn("6")) this.client.clientGameLogic.clientRenderer.gui().activateInventorySlot(6);
            const suppressTeamCommands = (this.isKeyOn("j") || this.isKeyOn("k") || this.isKeyOn("l")) && this.client.clientGameLogic.clientRenderer.map().getVisibility()?.suppressTeamCommands;
            if (!suppressTeamCommands && this.isKeyOn("j")) this.client.emitPlayerEvent({
                playerEventType: "SQUAD_COMMAND",
                context: {
                    command: "come"
                }
            });
            if (this.isKeyOn("h")) this.client.emitPlayerEvent({
                playerEventType: "SQUAD_COMMAND",
                context: {
                    command: "stopStart"
                }
            });
            if (!suppressTeamCommands && this.isKeyOn("k")) this.client.emitPlayerEvent({
                playerEventType: "SQUAD_COMMAND",
                context: {
                    command: "formation"
                }
            });
            if (!suppressTeamCommands && this.isKeyOn("l")) this.client.emitPlayerEvent({
                playerEventType: "SQUAD_COMMAND",
                context: {
                    command: "updateStance"
                }
            });
            if (key === "Shift") {
                if (down) this.client.boost(true);
                else this.client.boost(false);
                if (!repeat) this.retargetBuildPointer();
            }
            if (this.isKeyOn("~")) {
                if (this.randomness) {
                    clearInterval(this.randomness);
                    this.randomness = null;
                } else {
                    const latch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(500);
                    this.randomness = setInterval(()=>{
                        if (latch.expired()) {
                            const w = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 20);
                            this.client.fireBullet();
                        }
                        const r = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 1);
                        entity.movement.moving = true;
                        entity.speed2.x = r * ((0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 1) === 1 ? -1 : 1);
                        entity.speed2.y = r * ((0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 1) === 1 ? -1 : 1);
                    }, 100);
                }
            }
            if (this.isKeyOn("e")) this.client.clientGameLogic.clientRenderer.gui().toggleInventory();
            // Toggle the frame-rate readout. Gated on the key's own key-down, and on it not being an
            // auto-repeat, so holding `f` doesn't flip it open and shut.
            //
            // This key used to toggle the offscreen faction arrows. Those are now simply on wherever a
            // room asks for them (an ember camp), which is what players want of them -- they point at
            // your own camp and the people in it, and there is no moment where knowing less about where
            // they are is an improvement.
            if ((key === "f" || key === "F") && down && !repeat && !this.isChat) this.client.clientGameLogic.clientRenderer.gui().toggleFpsMeter();
            // Toggle the crafting screen. Gated on the key's own key-down, and on it not being an
            // auto-repeat, so holding `c` doesn't flip the screen open and shut.
            if ((key === "c" || key === "C") && down && !repeat) this.client.clientGameLogic.clientRenderer.gui().toggleCrafting();
            if (this.isKeyOn("t")) {
                if (entity.debug || entity.name === "aron") this.client.clientGameLogic.clientRenderer.gui().toggleCharacterCustomizer();
            }
        };
        this.perturb = ()=>{
            const { entity: entity } = this;
            // Room loading nudges an idle body to refresh its presentation. On stairs that
            // synthetic sideways input would dismount the player into the floor below.
            if (entity.stairTravel || entity.floorFall) return;
            entity.speed2.x = 0.001;
            setTimeout(()=>{
                entity.speed2.x = 0;
            }, 10);
        };
        this.respondToMouse = (mouseState)=>{
            if (mouseState.buttons.get("2")) this.clearUnequippedBuildMode();
            // Mobile building is driven by the touch owner, not emulated mouse events.
            if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() && this.terrainPointerOn) return;
            if (!mouseState.buttons.get("0")) this.buildPrimarySuppressed = false;
            if (!mouseState.buttons.get("2") && this.buildEraseStroke) {
                this.buildEraseStroke = undefined;
                this.buildPlacementFeedback.clearEraseTarget();
                this.refreshBuildPointer(true);
            }
            const secondaryBuildPress = mouseState.buttons.get("2") && this.terrainPointerOn && !this.buildEraseStroke && this.canCorrectBuild();
            if (secondaryBuildPress) {
                // End a held drawing gesture before erasing so it cannot refill erased cells.
                this.releasePendingBuilds();
                this.stopFiring();
                this.buildPrimarySuppressed = !!mouseState.buttons.get("0");
            }
            const mouseMoved = !this.lastPlacementMousePosition || !(0, $a80d0b17b615d6f7$export$248d38f6296296c5)(this.lastPlacementMousePosition, mouseState.position);
            this.lastPlacementMousePosition = {
                ...mouseState.position
            };
            if (!mouseState.buttons.get("0") && this.mouseAttackHeld) {
                this.releasePendingBuilds();
                this.stopFiring(true);
            }
            if (!this.mouseActionEnabled) return;
            this.lastMouseMoveTs = Date.now();
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) {
                if (!this.pointer && this.client.clientGameLogic.tilemapMetaProvider) {
                    const pointer = {
                        x: 64,
                        y: 64
                    };
                    this.pointer = pointer;
                }
                if (!this.roughPointer && this.client.clientGameLogic.tilemapMetaProvider) {
                    const pointer = {
                        x: 0,
                        y: 0
                    };
                    this.roughPointer = pointer;
                }
                this.client.clientGameLogic.clientRenderer.entity();
                const entity = this.client.clientGameLogic.playerEntity;
                const tilemapMetaProvider = this.client.clientGameLogic.tilemapMetaProvider;
                if (tilemapMetaProvider && this.pointer) {
                    const renderer = this.client.clientGameLogic.clientRenderer.map();
                    renderer.updateCompositeTilePointer?.(mouseState.position);
                    const world = this.client.clientGameLogic.clientRenderer.gui().worldPointAtPointer?.();
                    if (world) this.pointer = {
                        ...world
                    };
                    else {
                        // Compatibility for renderers that do not expose world-point conversion.
                        const X_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportX;
                        const Y_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportY - 1;
                        const location = entity.location;
                        const rightThreshold = (tilemapMetaProvider.width() - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                        const bottomThreshold = (tilemapMetaProvider.height() - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                        const isOverX = location.x > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR && location.x > rightThreshold;
                        const isOverY = location.y > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR && location.y > bottomThreshold;
                        const { modifierX: modifierX, modifierY: modifierY } = renderer.translationComputer;
                        const factor = 0.5;
                        const yfactor = 0.38;
                        this.pointer = {
                            x: Math.round(mouseState.position.x * factor) + Math.round((modifierX !== undefined ? -modifierX : 0) * 1) - (modifierX !== undefined ? Math.round((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR * factor) : isOverX ? -rightThreshold + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR : 0) - (modifierX !== undefined ? 40 : -24),
                            y: Math.round(mouseState.position.y * yfactor) + Math.round((modifierY !== undefined ? -modifierY : 0) * 1) - (modifierY !== undefined ? Math.round((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR * yfactor) : isOverY ? -bottomThreshold + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR : 0) - (modifierY !== undefined ? 0 : -30)
                        };
                        this.pointer.y += -10 + (renderer.worldProjectionOffset ?? 0);
                    }
                    const newRoughPointerX = Math.floor(this.pointer.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                    const newRoughPointerY = Math.floor(this.pointer.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                    if (this.roughPointer.x !== newRoughPointerX || this.roughPointer.y !== newRoughPointerY) {
                        this.roughPointer.x = newRoughPointerX;
                        this.roughPointer.y = newRoughPointerY;
                    }
                    if (!this.placementItem()) {
                        this.entity.movement.angle = (0, $a80d0b17b615d6f7$export$b363da9ded343252)(this.pointer, entity.location);
                        this.targetKeyboardAngle = this.entity.movement.angle;
                    } else if (mouseMoved && !this.locationPick) {
                        this.refreshBuildPointer();
                        // Use the rendered map's transform, including floor changes and camera pans,
                        // just as combat aiming does.
                        this.aimPlacementAt(this.client.clientGameLogic.clientRenderer.gui().worldPointAtPointer?.());
                    }
                    // Keep the building preview on the grid cell under the mouse.
                    const buildPoint = this.terrainPointerOn ? this.client.clientGameLogic.clientRenderer.gui().worldPointAtPointer?.() : undefined;
                    this.updatedRoughPointer(buildPoint ? this.buildingTargetAt(buildPoint) : this.roughPointer);
                    // Keep an armed location pick's verdict current as the pointer travels: the
                    // reticle is amber over ground the NPC could stand on, red over ground it
                    // could not.
                    if (this.locationPick) this.client.clientGameLogic.clientRenderer.gui().setLocationPickerBlocked(!this.locationPickable());
                    // ... and not the bow's crosshair on top of it: while a pick is armed the
                    // location reticle IS the pointer, and two of them read as a bug.
                    if (this.longRangedEquipped && !this.terrainPointerOn && !this.locationPick) {
                        const mouseSprite = this.client.clientGameLogic.clientRenderer.gui().createCursorSprite();
                        mouseSprite.visible = true;
                    }
                }
                if (!this.placementItem()) clearInterval(this.keyboardAndleAdjustInterval);
            }
            if (secondaryBuildPress) {
                // Resolve the current pointer first; the previous mouse event may be on another tile.
                if (this.pendingBuildAtPointer()) {
                    this.buildEraseStroke = {};
                    this.clearTerrainPointer();
                    this.erasePendingBuilds(this.roughPointer);
                    this.refreshBuildPointer(true);
                } else this.leaveBuildForSecondaryPress("mouse", 2);
                return;
            }
            if (this.buildEraseStroke || this.terrainPointerOn && this.isButtonOn("2")) return;
            // A tile context hold owns the entire press, including mouse moves after its timer fires.
            // Until then a deferred one leaves the press to the attack.
            if (this.pressedTile && !this.tilePressDeferred) return;
            if (this.isButtonOn("0") && !this.buildPrimarySuppressed) {
                // A click on an interaction icon (chest open/close, chat, etc.) must never also
                // trigger a world attack. The attack click arrives via a document-level mousedown
                // that can't tell it landed on a pixi interaction widget, so we suppress attacks
                // for a short window around every interaction activation (see suppressAttack).
                if (Date.now() < this.suppressAttackUntilTs) {
                    // While building, a swallowed press stays swallowed until release: held past the
                    // window, it would otherwise start laying tiles from wherever it was dragged.
                    if (this.terrainPointerOn && !this.isFiring) this.buildPrimarySuppressed = true;
                    return;
                }
                if (this.client.clientGameLogic.clientRenderer.gui().isBuildingPrintControlHovered?.()) return;
                // Check if command wheel is visible - if so, don't process mouse clicks for attacks
                if (this.client.clientGameLogic.clientRenderer.gui().isCommandWheelVisible()) return;
                // Same for the name prompt: it stands open for as long as it takes to type a name, with
                // the player's attention on a field rather than the world, so a click meant for it (or
                // for the field it just lost focus to) must not fire a shot.
                if (this.client.clientGameLogic.clientRenderer.gui().isNamePromptVisible?.()) return;
                // Same for the chat composer. Its panel swallows the pixi events over itself, but the
                // attack arrives on a document-level mousedown that cannot see what it landed on -- so
                // without this, tapping Send also swings whatever is in the player's hand.
                if (this.client.clientGameLogic.clientRenderer.gui().isChatComposerVisible?.()) return;
                // Likewise, a click on an inventory/crafting/trading screen (e.g. an item action
                // button) must not also fire a world attack. Those modals draw over the world but the
                // attack arrives via a document-level mousedown that can't see the pixi widget it hit,
                // so gate on the open screen the same way the command wheel does above.
                if (this.client.clientGameLogic.clientRenderer.gui().isItemScreenOpen()) return;
                // button pressed
                if (!this.isFiring) {
                    this.isFiring = true;
                    this.mouseAttackHeld = true;
                    // An armed location pick claims this press: it is the player answering "click a
                    // spot", not an attack on whatever happens to be under the reticle.
                    if (this.locationPick) {
                        this.completeLocationPick();
                        return;
                    }
                    // An entity touch already owns this press.
                    if (this.pressedEntityId) return;
                    if (this.terrainPointerOn) this.startWorldAction({
                        ignoreHover: true
                    });
                    else {
                        this.isFiring = false;
                        this.setAttackHeld(true);
                        this.mouseAttackHeld = this.isFiring;
                    }
                }
            }
        };
        // Primary presses attack, place build tiles, or resolve a chosen ground location.
        // ignoreHover keeps friendly interactable bodies from intercepting a combat swing.
        this.startWorldAction = (opts)=>{
            if (!this.terrainPointerOn && !this.locationPick && this.interactionsFor(this.hoveredEntity).some((i)=>i.holdDurationMs > 0)) return;
            if (this.terrainPointerOn) {
                this.refreshBuildPointer();
                const item = this.entity.inventory?.items?.find((i)=>i.active && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(i.itemTypeMeta));
                const buildType = item && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildType(item.itemTypeMeta);
                if (this.beginBuildEdit(this.buildPointer)) return;
                // Desktop drags always use the selected shape; the palette key only opens the tool picker.
                const shaped = [
                    "wall",
                    "roof",
                    "floor",
                    "floor2"
                ].includes(buildType) && (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() || this.mobileBuildTool !== "single");
                if (shaped && buildType === "roof" && ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? this.mobileBuildTool === "room" : this.buildingShape === "rectangle") && !(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() && this.isKeyOn("Alt")) {
                    // Alt assists a click near a visible wall-top corner, then pins that corner.
                    const level = this.buildPointer.level;
                    const corner = (0, $85e59abaaefadc89$export$bcd1b35adbbcb204)({
                        x: -1,
                        y: -1
                    }, this.buildPointer, undefined, (point)=>this.existingWallAt(point, level), undefined, false, true);
                    if (corner) {
                        this.buildPointer = (0, $5b68384bc2307256$export$aa8352a64fa8b594)(corner, level);
                        this.updateBuildGridMarker(this.buildPointer);
                    }
                }
                const initialKey = `${this.buildPointer.x},${this.buildPointer.y}`;
                const alreadyPending = this.pendingBuilds.has(initialKey);
                const start = {
                    ...this.buildPointer
                };
                const wallLine = shaped && buildType === "wall" && ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? this.mobileBuildTool === "line" : this.buildingShape === "line");
                if (!wallLine || !this.existingWallAt(start, start.level)) this.placeBuildTile(!shaped, true, start);
                this.buildPointer = start;
                this.updateBuildGridMarker(start);
                const visited = new Set([
                    `${this.buildPointer.x},${this.buildPointer.y}`
                ]);
                if (buildType && [
                    "wall",
                    "roof",
                    "floor",
                    "floor2"
                ].includes(buildType)) {
                    this.buildStroke = {
                        last: {
                            ...this.buildPointer
                        },
                        visited: visited,
                        level: start.level,
                        pickLift: this.buildPickLift,
                        area: shaped ? {
                            roof: buildType === "roof",
                            level: start.level,
                            anchor: {
                                x: start.x,
                                y: start.y
                            },
                            cells: new Set(!alreadyPending && this.pendingBuilds.has(initialKey) ? [
                                initialKey
                            ] : []),
                            hollow: buildType === "wall",
                            shape: (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? this.mobileBuildTool === "line" ? "line" : "rectangle" : this.buildingShape
                        } : undefined
                    };
                    this.updateBuildGridMarker(start);
                    if (this.buildStroke.area?.shape === "line") {
                        this.buildStroke.area.endpoint = {
                            x: start.x,
                            y: start.y
                        };
                        this.buildPlacementFeedback.setLineEnd(this.buildPointer, undefined, undefined, this.areaYOffset(this.buildStroke.area));
                    } else if (this.buildStroke.area?.shape === "rectangle" && !this.buildStroke.area.hollow) {
                        this.buildStroke.area.endpoint = {
                            x: start.x,
                            y: start.y
                        };
                        this.buildPlacementFeedback.setAreaFootprint(this.buildPointer, this.buildPointer, {}, this.areaYOffset(this.buildStroke.area));
                    }
                    if (shaped) {
                        this.buildingShapePaletteDismissed = true;
                        this.updateBuildingShapePalette();
                    }
                    return;
                }
                this.fireInterval = setInterval(()=>{
                    this.refreshBuildPointer();
                    const key = `${this.buildPointer.x},${this.buildPointer.y}`;
                    if (visited.has(key)) return;
                    visited.add(key);
                    this.placeBuildTile(false, true);
                }, 400);
                this.lastMouseMoveTs = Date.now();
                return;
            }
            const hoveredEntity = opts?.ignoreHover ? undefined : this.client.clientGameLogic.getEntity(this.hoveredEntity);
            let isAutoTravelling = false;
            const entityTilePointer = !(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(this.roughCompositeTilePointer) ? this.roughCompositeTilePointer : this.roughPointer;
            const entityTile = this.client.clientGameLogic.tilemapMetaProvider.getEntityTileAt(entityTilePointer.x, entityTilePointer.y);
            // Close enough to swing at. Measured to the MIDDLE of the cell, not its top-left corner:
            // `roughToFineCoordinates` hands back the corner, so the set of places you were allowed to
            // strike from was a disc around that corner -- you could cut a clump of grass standing on it,
            // from its left or from above, and not from below or from the right. Below is how a player
            // walks up to anything, the camera looking down, so the usual approach was the one that did
            // nothing: no strike, no message, the click swallowed by the walk-and-shoot fallback.
            //
            // One and a half tiles from the centre, so the whole eight-cell ring around a plant counts --
            // 32px orthogonally, 45px on the diagonal -- which is what "an adjacent entity tile" meant
            // all along.
            const entityTileAccessible = entityTile && (0, $cb689cfa16c444ba$export$72a3639d5dd4d5f8)(this.entity.location, (0, $a80d0b17b615d6f7$export$afdc8e4f563fbba3)(entityTilePointer)) < (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 1.5;
            if (!entityTileAccessible && !this.longRangedEquipped && !this.clickToMoveDisabled()) {
                // Say WHY, not just that. There are three separate reasons a click on something that
                // plainly looks strikeable sends nothing -- no composite was hovered, the cell holds no
                // entity tile, or the player is out of the one-tile reach -- and from the outside all
                // three look identical: you swing and the world ignores you.
                (0, $5UG8I.logger).info({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `Mouse click: Entity tile not accessible, not long-ranged. hoveredEntity=${!!hoveredEntity}` + ` composite=${(0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(this.roughCompositeTilePointer) ? "none" : `${this.roughCompositeTilePointer.x},${this.roughCompositeTilePointer.y}`}` + ` pointer=${this.roughPointer?.x},${this.roughPointer?.y}` + ` aimedAt=${entityTilePointer.x},${entityTilePointer.y}` + ` tile=${entityTile?.entityTile ?? "none"}` + ` reach=${Math.round((0, $cb689cfa16c444ba$export$72a3639d5dd4d5f8)(this.entity.location, (0, $a80d0b17b615d6f7$export$afdc8e4f563fbba3)(entityTilePointer)))}/${(0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 1.5}`);
                if (hoveredEntity) {
                    (0, $5UG8I.logger).info({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Mouse click: Scheduling auto-travel to hovered entity ${hoveredEntity.entityId}`);
                    isAutoTravelling = this.scheduleAutoTravelToEntity(hoveredEntity, ()=>{
                        (0, $5UG8I.logger).info({
                            tags: [
                                "callback",
                                "animation"
                            ]
                        }, `Mouse click: Firing bullet after reaching hovered entity`);
                        this.client.fireBullet();
                    });
                } else {
                    const collisionCheck = (0, $a80d0b17b615d6f7$export$7758e9150891e0a1)(this.entity.location, this.entity.movement.angle, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                    if (this.client.clientGameLogic.tilemapMetaProvider.isCollisionAt((0, $a80d0b17b615d6f7$export$b240a5f8651dffb4)(collisionCheck.x), (0, $a80d0b17b615d6f7$export$b240a5f8651dffb4)(collisionCheck.y))) {
                        (0, $5UG8I.logger).info({
                            tags: [
                                "callback",
                                "animation"
                            ]
                        }, `Mouse click: Collision detected, no auto-travel`);
                        isAutoTravelling = false;
                    } else {
                        const thePoint = (0, $a80d0b17b615d6f7$export$4a09470303eb5fc5)(this.entity.location, this.pointer, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 1.5);
                        (0, $5UG8I.logger).info({
                            tags: [
                                "callback",
                                "animation"
                            ]
                        }, `Mouse click: Scheduling auto-travel to calculated point (${thePoint.x}, ${thePoint.y})`);
                        isAutoTravelling = this.scheduleAutoTravelToPoint(thePoint, ()=>{
                            (0, $5UG8I.logger).info({
                                tags: [
                                    "callback",
                                    "animation"
                                ]
                            }, `Mouse click: Firing bullet after reaching calculated point`);
                            this.client.fireBullet();
                        }, false);
                    }
                }
            }
            if (!isAutoTravelling) {
                if (entityTileAccessible && !hoveredEntity) {
                    (0, $5UG8I.logger).info({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Mouse click: Entity tile accessible, doing strike attack`);
                    const doStrike = ()=>{
                        const s = {
                            ...this.roughCompositeTilePointer
                        };
                        this.client.clientGameLogic.attack(this.entity.entityId, ()=>{
                            this.client.entityTileStrike(s);
                        });
                    };
                    doStrike();
                    this.fireInterval = setInterval(()=>{
                        doStrike();
                    }, 400);
                } else {
                    (0, $5UG8I.logger).info({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Mouse click: No auto-travel, no accessible entity tile - firing bullet (no automatic boost - use Shift key for boost)`);
                    this.client.fireBullet();
                    this.fireInterval = setInterval(()=>{
                        (0, $5UG8I.logger).info({
                            tags: [
                                "callback",
                                "animation"
                            ]
                        }, `Mouse click: Repeating bullet fire in interval (no automatic boost)`);
                        this.client.fireBullet();
                    }, 400);
                }
            }
            this.lastMouseMoveTs = Date.now();
        };
        // Stop an in-flight press: clears the repeat so a held attack can't outlive the press. Shared by
        // the mouse-up path and the entity press handlers, because a touch that is held never produces
        // the emulated mouseup a desktop release does.
        this.stopFiring = (releaseCharge = false)=>{
            const charge = this.localWeaponCharge;
            this.localWeaponCharge = undefined;
            if (charge) {
                const valid = releaseCharge && this.canHoldAttack() && this.entity.weapon?.profileId === charge.profileId && this.entity.inventory?.items.some((item)=>item.id === charge.itemId && item.active && item.quantity > 0);
                const origin = this.entity.getBounds().center();
                const target = this.mouseAttackHeld && this.pointer ? this.pointer : {
                    x: origin.x + Math.cos(this.entity.movement.angle) * (this.entity.chargedWeaponDefinition?.maxRange || (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 6),
                    y: origin.y + Math.sin(this.entity.movement.angle) * (this.entity.chargedWeaponDefinition?.maxRange || (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 6)
                };
                this.client.chargedWeaponAction(valid ? "release" : "cancel", charge.id, target);
            }
            if (this.buildStroke?.area?.editGroupId !== undefined) this.releasePendingBuilds();
            this.buildStroke = undefined;
            this.buildPlacementFeedback.clearLineEnd();
            this.buildPlacementFeedback.clearAreaFootprint();
            this.buildEraseStroke = undefined;
            this.buildPlacementFeedback.clearEraseTarget();
            this.isFiring = false;
            this.mouseAttackHeld = false;
            clearInterval(this.fireInterval);
            this.fireInterval = undefined;
            this.updateBuildingCursor();
        };
        this.isAttacking = ()=>this.isFiring;
        /** Facing of a held ranged attack (a bow drawn, a launcher held), for the camera to lean toward. */ this.rangedAimPoint = ()=>this.mouseActionEnabled && !(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() && !this.placementItem() && this.pointer ? {
                ...this.pointer
            } : undefined;
        this.rangedAimAngle = ()=>this.isFiring && !this.buildStroke && !this.buildEraseStroke && (this.longRangedEquipped || !!this.localWeaponCharge) ? this.entity?.movement?.angle : undefined;
        this.interactionsFor = (entityId)=>{
            if (!entityId) return [];
            return this.client.clientGameLogic.clientRenderer.entity().getEntityInteractions(entityId) || [];
        };
        this.cancelHeldInteraction = ()=>{
            const held = this.heldInteraction;
            if (!held) return;
            clearInterval(held.timer);
            this.client.clientGameLogic.interactionCallback(held.entityId, held.type, "cancel");
            this.heldInteraction = undefined;
        };
        // Primary presses on tiles with verbs wait for a hold; secondary clicks open their menus.
        // A hold activates a sole verb or opens the menu. `world` is the fine point
        // pressed: with it, a wall drawn on another storey can be picked where it is drawn.
        this.beginTilePress = (cell, pointerType, button = 0, world)=>{
            const building = this.terrainPointerOn;
            const primary = pointerType === "touch" || button === 0;
            // An equipped ranged or charged weapon owns primary aim/fire (its hold IS the attack), even
            // over a raised floor's Dismantle target. Tile commands remain available through secondary clicks.
            if (primary && !building && (this.longRangedEquipped || this.entity.weapon?.profileId)) return false;
            // Stairs and furniture place on the player's floor. Finished floors and walls drawn
            // above that floor must not claim their placement press for a terrain interaction.
            const placement = this.placementItem();
            if (building && primary && placement && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.placement(placement.itemTypeMeta).action === "build") return false;
            // Shift-primary belongs to wall stacking even when the supporting wall offers Dismantle.
            if (building && primary && pointerType !== "touch" && this.stackHeld() && this.storeyBuildKind() === "wall") return false;
            if (primary && this.pendingBuildAtPointer(cell)) return false;
            if (!primary && !this.leaveBuildForSecondaryPress(pointerType, button, cell)) return false;
            const logic = this.client.clientGameLogic;
            const gui = logic.clientRenderer.gui();
            if (!primary && button !== 2 || this.locationPick || this.pressedEntityId || this.paralyzed || this.downed || this.entity.isDead() || gui.isCommandWheelVisible() || gui.isItemScreenOpen() || gui.isRolePickerVisible?.() || gui.isChatComposerVisible?.() || gui.isNamePromptVisible?.()) return false;
            const provider = logic.tilemapMetaProvider;
            const house = provider.getHousePresentation?.();
            const underRoof = house ? (0, $2751e0027a1b432f$export$2c01c05cc2cc0271)(house, this.entity.location) : provider.isSkyTileAt?.(Math.floor(this.entity.location.x / 32), Math.floor(this.entity.location.y / 32));
            const below = provider.getFloorSupportProvider?.();
            const floor = provider.resolveTileMapFromLayerId?.("map2")?.[cell.x]?.[cell.y];
            // Sky tiles are drawn above their logical cells. Invert that same lift rather
            // than using the ground pointer (or the house's independent storey rise).
            const roofCell = (0, $48a973472fff8afa$export$d2107414ce2376d5)(world ?? (0, $a80d0b17b615d6f7$export$afdc8e4f563fbba3)(cell), (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)());
            const own = ()=>(0, $5a580aacfacf7705$export$27c8f30ca81f5bc2)(provider, cell, {
                    includeRoof: !underRoof,
                    roofBelow: below && (!floor || floor === "0") ? {
                        roomId: below.roomId,
                        provider: below
                    } : undefined,
                    roofCell: roofCell
                });
            const storeys = world && logic.clientRenderer.map().drawnStoreys?.();
            const target = storeys?.length ? (0, $5b68384bc2307256$export$8c9df9f5b4356b74)(world, this.ownStorey(), storeys, own) : own();
            if (!target) return false;
            // Outside building, a mouse press attacks like any click and the tile claims it only once the
            // hold runs out -- an upper storey is floor under every step, so claiming at once meant no click
            // there ever attacked. Touch claims at once: its world attack belongs to the aim stick.
            const deferred = primary && !building && pointerType !== "touch";
            const kind = this.storeyBuildKind();
            this.cancelTilePress();
            this.pressedTile = primary ? {
                ...cell
            } : undefined;
            this.tilePressDeferred = deferred;
            if (!deferred) this.stopFiring();
            // Taps and drags build walls on floors or beneath overlapping caps; a stationary hold
            // still reaches the supporting floor or wall, just as roofing over a wall does.
            const emptyWallCell = kind === "wall" && (!target.roomId || target.roomId === this.entity.roomId) && !(0, $5b68384bc2307256$export$1260587bd459848c)(provider, cell) && (target.coordinate.x !== cell.x || target.coordinate.y !== cell.y);
            const wallOnFloor = kind === "wall" && target.layerId === "map2" && (!target.roomId || target.roomId === this.entity.roomId);
            const raisedBuild = world && this.buildingTargetAt(world).level !== undefined;
            if (building && primary && (raisedBuild || wallOnFloor || target.layerId === "sprite" && (kind === "roof" || emptyWallCell))) this.tilePressBuild = {
                start: world ? this.buildingTargetAt(world) : {
                    ...this.roughPointer
                },
                touch: pointerType === "touch",
                world: world && {
                    ...world
                }
            };
            if (this.pressedTile) {
                this.clearTerrainPointer();
                const { coordinate: coordinate, layerId: layerId, roomId: roomId, interactions: interactions } = target;
                const drawn = world ? (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(world) : cell;
                this.tilePressCue.begin({
                    durationMs: $319b1dfd90d3ebea$var$ENTITY_PRESS_HOLD_MS,
                    art: ()=>logic.clientRenderer.map?.()?.getTileArt?.(coordinate.x, coordinate.y, layerId, roomId) ?? [],
                    cell: target.layerId === "sky" && !target.roomId ? {
                        x: coordinate.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                        y: coordinate.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)()
                    } : {
                        x: drawn.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                        y: drawn.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                    },
                    label: interactions.length === 1 ? interactions[0].displayName : undefined
                });
                this.startTilePressSwings(world ?? {
                    x: (cell.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: (cell.y + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                });
            }
            if (building && primary) this.buildPrimarySuppressed = true;
            if (!deferred) this.suppressAttack(1000);
            // The right-click left building only to reach this tile's verbs (Dismantle a misplaced tile);
            // building picks up again when the wheel closes (see tileWheelClosed).
            this.resumeBuildAfterTileWheel = building && !this.terrainPointerOn;
            const open = ()=>{
                this.tilePressTimer = undefined;
                this.tilePressBuild = undefined;
                this.stopTilePressSwings();
                this.tilePressCue.complete();
                if (this.tilePressDeferred) {
                    // The hold won: the attack the click started gives way to the tile's verb.
                    this.tilePressDeferred = false;
                    this.stopFiring();
                }
                if (primary && target.interactions.length === 1) {
                    logic.audio.uiSelect();
                    this.suppressAttack();
                    this.client.emitPlayerEvent({
                        playerEventType: "ACTIVATE_TILE_INTERACTION",
                        context: {
                            coordinate: target.coordinate,
                            layerId: target.layerId,
                            roomId: target.roomId ?? this.entity.roomId,
                            interaction: target.interactions[0].name
                        }
                    });
                    return;
                }
                gui.showTileInteractionWheel?.(target);
            };
            if (primary) this.tilePressTimer = setTimeout(open, $319b1dfd90d3ebea$var$ENTITY_PRESS_HOLD_MS);
            else open();
            return true;
        };
        this.cancelTilePress = ()=>{
            this.tilePressBuild = undefined;
            const restorePreview = !!this.pressedTile && this.terrainPointerOn;
            if (this.tilePressTimer) clearTimeout(this.tilePressTimer);
            this.tilePressTimer = undefined;
            this.pressedTile = undefined;
            this.tilePressDeferred = false;
            this.stopTilePressSwings();
            this.tilePressCue.cancel();
            if (restorePreview) this.refreshBuildPointer(true);
        };
        /** A short press builds over overlapping wall art; a stationary hold interacts with it. */ this.endTilePress = ()=>{
            const build = this.tilePressBuild;
            this.cancelTilePress();
            if (!build) return;
            if (!this.startTilePressBuild(build)) return;
            this.releasePendingBuilds();
            this.stopFiring();
        };
        this.startTilePressBuild = (build)=>{
            if (!this.terrainPointerOn || !this.canCorrectBuild()) return false;
            this.buildPrimarySuppressed = false;
            this.suppressAttackUntilTs = 0;
            this.mobileBuildDragging = build.touch;
            this.isFiring = true;
            this.mouseAttackHeld = !build.touch;
            this.updatedRoughPointer(build.start);
            this.startWorldAction();
            return true;
        };
        // Cosmetic, like a build swing: the player turns to the tile and swings at it for as long as the hold runs, and
        // other players are shown the same. The server's swing as the tile comes away lands inside the last of these.
        this.startTilePressSwings = (aim)=>{
            const swing = ()=>{
                // A deferred press's own attack is already swinging for real.
                if (!this.entity || this.entity.isDead() || this.isFiring) return;
                this.entity.movement.angle = (0, $a80d0b17b615d6f7$export$b363da9ded343252)(aim, this.entity.location);
                this.targetKeyboardAngle = this.entity.movement.angle;
                this.client.clientGameLogic.clientRenderer.entity().attack(this.entity);
                this.client.playBuildSwing?.(this.entity.roomId, true);
            };
            // Not on a click: it starts as the press cue shows.
            this.tilePressSwing = setTimeout(()=>{
                swing();
                this.tilePressSwing = setInterval(swing, $319b1dfd90d3ebea$var$HELD_ATTACK_MS);
            }, (0, $6335240112362a5a$export$e3aee9fe145238b4).delay);
        };
        this.stopTilePressSwings = ()=>{
            clearTimeout(this.tilePressSwing);
            clearInterval(this.tilePressSwing);
            this.tilePressSwing = undefined;
        };
        this.moveTilePress = (cell, world)=>{
            if (!this.pressedTile) return;
            const build = this.tilePressBuild;
            const crossedCell = cell.x !== this.pressedTile.x || cell.y !== this.pressedTile.y;
            const dragged = build?.world && world && (0, $cb689cfa16c444ba$export$72a3639d5dd4d5f8)(build.world, world) >= $319b1dfd90d3ebea$var$BUILD_DRAG_THRESHOLD_PX;
            if (!crossedCell && !dragged) return;
            this.cancelTilePress();
            if (build && this.startTilePressBuild(build)) this.updatedRoughPointer(world ? this.buildingTargetAt(world) : cell);
        };
        this.beginEntityPress = (entityId, pointerType = "touch", button = 0)=>{
            const held = this.interactionsFor(entityId).find((i)=>i.holdDurationMs > 0);
            if (pointerType !== "touch" && button !== 2 && !held) return;
            if (this.interactionsFor(entityId).length === 0) return;
            if (!this.leaveBuildForSecondaryPress(pointerType, button)) return;
            // Same for an armed location pick: "hold THIS spot" has to stay available even when an NPC
            // happens to be standing on the spot being chosen.
            if (this.locationPick) return;
            const gui = this.client.clientGameLogic.clientRenderer.gui();
            // A wheel or picker already open sits directly over its entity, so a press on one of its
            // slices lands on the entity underneath too. The open widget owns that press.
            if (gui.isCommandWheelVisible() || gui.isRolePickerVisible?.() || gui.isNamePromptVisible?.() || gui.isChatComposerVisible?.() || gui.isItemScreenOpen()) return;
            if (held && (pointerType === "touch" || button === 0)) {
                this.cancelHeldInteraction();
                this.stopFiring();
                this.suppressAttack(held.holdDurationMs + 1000);
                this.pressedEntityId = entityId;
                this.client.clientGameLogic.interactionCallback(entityId, held.type, "begin");
                this.heldInteraction = {
                    entityId: entityId,
                    type: held.type,
                    timer: setInterval(()=>{
                        this.suppressAttack(1000);
                        this.client.clientGameLogic.interactionCallback(entityId, held.type, "refresh");
                    }, 250)
                };
                return;
            }
            if (pointerType !== "touch") {
                this.openEntityContextMenu(entityId);
                return;
            }
            this.clearPressHoldTimer();
            this.pressedEntityId = entityId;
            this.pressOpenedMenu = false;
            this.stopFiring();
            this.suppressAttack(800);
            this.pressHoldTimer = setTimeout(()=>{
                this.pressHoldTimer = undefined;
                this.pressOpenedMenu = true;
                this.openEntityContextMenu(entityId);
            }, $319b1dfd90d3ebea$var$ENTITY_PRESS_HOLD_MS);
        };
        this.endEntityPress = (entityId)=>{
            if (this.pressedEntityId !== entityId) return;
            const consumed = this.pressOpenedMenu || !!this.heldInteraction;
            this.releaseEntityPress();
            this.suppressAttack();
            if (!consumed) {
                this.startWorldAction({
                    ignoreHover: true
                });
                this.stopFiring();
            }
        };
        this.cancelEntityPress = (entityId)=>{
            if (this.pressedEntityId !== entityId) return;
            const openedMenu = this.pressOpenedMenu;
            this.releaseEntityPress();
            if (openedMenu) this.stopFiring();
        };
        this.releaseEntityPress = ()=>{
            this.cancelHeldInteraction();
            this.clearPressHoldTimer();
            this.pressedEntityId = undefined;
            this.pressOpenedMenu = false;
        };
        this.clearPressHoldTimer = ()=>{
            if (this.pressHoldTimer) {
                clearTimeout(this.pressHoldTimer);
                this.pressHoldTimer = undefined;
            }
        };
        this.cancelHeldAttack = ()=>{
            this.cancelTilePress();
            this.releaseEntityPress();
            this.stopFiring();
            this.releasePendingBuilds();
        };
        this.canHoldAttack = ()=>{
            const gui = this.client.clientGameLogic.clientRenderer.gui();
            return !this.heldInteraction && !this.interactionsFor(this.hoveredEntity).some((i)=>i.holdDurationMs > 0) && !this.isChat && !this.paralyzed && !this.downed && !this.entity.isDead() && !this.locationPick && Date.now() >= this.suppressAttackUntilTs && !gui.isCommandWheelVisible() && !gui.isItemScreenOpen() && !gui.isRolePickerVisible?.() && !gui.isNamePromptVisible?.() && !gui.isChatComposerVisible?.();
        };
        /** Mouse and mobile holds repeat the same action as holding Space. */ this.setAttackHeld = (held)=>{
            if (!held) {
                this.stopFiring(true);
                return;
            }
            if (this.isFiring || !this.canHoldAttack()) return;
            this.isFiring = true;
            if (this.entity.weapon?.profileId) {
                const definition = this.entity.chargedWeaponDefinition;
                const item = this.entity.inventory?.items.find((item)=>item.active && item.quantity > 0 && item.flags?.chargedWeaponId === this.entity.weapon.profileId);
                if (!definition || !item) {
                    this.stopFiring();
                    return;
                }
                const id = (0, $a80d0b17b615d6f7$export$5e699d18035b41af)();
                this.localWeaponCharge = {
                    id: id,
                    profileId: definition.id,
                    itemId: item.id
                };
                this.client.chargedWeaponAction("begin", id);
                this.fireInterval = setInterval(()=>{
                    if (!this.canHoldAttack() || this.entity.weapon?.profileId !== definition.id || !this.entity.inventory?.items.some((i)=>i.id === item.id && i.active && i.quantity > 0)) this.stopFiring();
                }, $319b1dfd90d3ebea$var$HELD_ATTACK_MS);
                return;
            }
            const attack = ()=>{
                if (!this.canHoldAttack()) {
                    this.stopFiring();
                    return;
                }
                this.manualAttack(!!this.entity.movement?.moving);
            };
            attack();
            if (this.isFiring) this.fireInterval = setInterval(attack, $319b1dfd90d3ebea$var$HELD_ATTACK_MS);
        };
        this.openEntityContextMenu = (entityId)=>{
            const gui = this.client.clientGameLogic.clientRenderer.gui();
            if (this.terrainPointerOn || this.locationPick || gui.isCommandWheelVisible() || gui.isItemScreenOpen() || gui.isChatComposerVisible?.() || gui.isRolePickerVisible?.() || gui.isNamePromptVisible?.()) return;
            // Held verbs are left out: a wheel has no way to hold a slice down, so one would be a dead
            // button (see wheelInteractions). An entity offering nothing BUT a held verb therefore has
            // no menu at all -- a secondary click on an injured survivor opens nothing, because holding
            // on her IS the interaction and a one-slice wheel saying so would do nothing when picked.
            const interactions = (0, $0fb3f7f2a67be6e3$export$65634e3ec6b442de)(this.interactionsFor(entityId));
            if (!interactions.length) return;
            this.stopFiring();
            this.suppressAttack();
            this.client.clientGameLogic.clientRenderer.gui().showInteractionWheel(entityId, interactions);
        };
        this.updatedRoughPointer = (coordinate)=>{
            this.roughPointer = {
                ...coordinate
            };
            if (this.buildEraseStroke) {
                if (this.canCorrectBuild()) this.erasePendingBuilds(coordinate);
                else this.buildEraseStroke.last = undefined;
                this.refreshBuildPointer();
                return;
            }
            const stroke = this.buildStroke;
            if (stroke && this.isFiring && this.terrainPointerOn) {
                const gui = this.client.clientGameLogic.clientRenderer.gui();
                const blocked = Date.now() < this.suppressAttackUntilTs && !this.mobileBuildDragging || gui.isBuildingPrintControlHovered?.() || gui.isItemScreenOpen() || gui.isCommandWheelVisible() || gui.isChatComposerVisible?.() || gui.isNamePromptVisible?.();
                if (!blocked) {
                    let changed = false;
                    if (stroke.area) changed = stroke.area.move ? this.updateMovedBuildArea(coordinate, stroke.area) : this.updateBuildArea(coordinate, stroke.area);
                    else {
                        const dx = coordinate.x - stroke.last.x;
                        const dy = coordinate.y - stroke.last.y;
                        const nx = Math.abs(dx), ny = Math.abs(dy);
                        let x = stroke.last.x, y = stroke.last.y, ix = 0, iy = 0;
                        // Cross grid boundaries in order. On diagonal ties, step one axis at a time
                        // so wall strokes remain cardinally connected rather than touching at corners.
                        while(ix < nx || iy < ny){
                            if (ix < nx && (iy >= ny || (1 + 2 * ix) * ny <= (1 + 2 * iy) * nx)) {
                                x += Math.sign(dx);
                                ix++;
                            } else {
                                y += Math.sign(dy);
                                iy++;
                            }
                            const key = `${x},${y}`;
                            if (stroke.visited.has(key)) continue;
                            stroke.visited.add(key);
                            this.placeBuildTile(false, true, (0, $5b68384bc2307256$export$aa8352a64fa8b594)({
                                x: x,
                                y: y
                            }, stroke.level), false);
                            changed = true;
                        }
                    }
                    if (changed) {
                        this.playBuildSwing();
                        this.clearTerrainPointer();
                        this.refreshPendingPreviews();
                        this.refreshBuildPointer(true);
                    }
                }
                stroke.last = {
                    ...coordinate
                };
            }
            this.refreshBuildPointer();
        };
        this.existingWallAt = (point, level)=>{
            if (level !== undefined) {
                // Raised storeys only ever hold walls built through the game, never authored ones.
                const storey = this.storeyViews().find((view)=>view.level === level);
                return !!storey && (0, $5b68384bc2307256$export$1260587bd459848c)(storey.map, point);
            }
            const map = this.client.clientGameLogic.tilemapMetaProvider;
            if (point.x < 0 || point.y < 0 || point.x >= map.width() || point.y >= map.height()) return false;
            const tile = map.getMapDeltaAt?.(point.x, point.y, "sprite");
            if (tile?.removed) return false;
            const parent = tile?.context?.parent;
            // Raised caps are artwork, not extra ground-level connection points.
            if (parent && (parent.x !== point.x || parent.y !== point.y) && !tile.blocking) return false;
            if ((0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[tile?.context?.itemType]?.buildType === "wall") return true;
            // Authored wooden walls can predate runtime item metadata. Use their known art and
            // ground collision together so decorative caps cannot become magnetic targets.
            const art = map.resolveTileMapFromLayerId?.("sprite")?.[point.x]?.[point.y];
            if (!art || art === "0" || !map.isCollisionAt?.(point.x, point.y)) return false;
            const parts = art.includes(":") ? art.split(":") : undefined;
            const tileset = parts ? undefined : map.resolveTileSet?.(art);
            return (0, $c3e6e81239a7bc85$export$59bd1dfb16da1c8a)(parts ? parts[0] : tileset?.tilesetId, parts ? Number(parts[1]) : Number(art) - tileset?.firstGid) >= 0;
        };
        this.updateBuildArea = (coordinate, area)=>{
            const map = this.client.clientGameLogic.tilemapMetaProvider;
            let endpoint = coordinate;
            const wallLine = area.shape === "line" && area.hollow;
            const filledRectangle = area.shape === "rectangle" && !area.hollow;
            const bypass = !!area.move || (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() || !this.isKeyOn("Alt");
            const cache = new Map();
            const wallAt = (point)=>{
                const key = `${point.x},${point.y}`;
                if (cache.has(key)) return cache.get(key);
                const pending = this.pendingBuilds.get(key);
                const item = pending && this.entity.inventory?.items?.find((i)=>i.id === pending.itemId);
                const planned = !area.cells.has(key) && pending && !pending.unfunded && pending.level === area.level && (!pending.previewResolved || pending.valid) && item && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildType(item.itemTypeMeta) === "wall";
                const result = !!planned || this.existingWallAt(point, area.level);
                cache.set(key, result);
                return result;
            };
            if (area.shape === "line") {
                const snapped = (0, $85e59abaaefadc89$export$fd9a95d31f60f9d2)(area.anchor, coordinate, area.axis, bypass);
                area.axis = snapped.axis;
                endpoint = snapped.endpoint;
                if (wallLine) {
                    area.connection = (0, $85e59abaaefadc89$export$bcd1b35adbbcb204)(area.anchor, coordinate, area.axis, wallAt, area.connection, bypass);
                    if (area.connection) endpoint = area.connection;
                }
            } else if (filledRectangle) {
                const snapped = (0, $85e59abaaefadc89$export$8f640e20d07486c5)(area.anchor, coordinate, wallAt, map.width(), map.height(), area.edges, bypass);
                area.edges = snapped.edges;
                endpoint = snapped.endpoint;
            }
            const points = (0, $85e59abaaefadc89$export$75b70d6a391d14b5)(area.anchor, endpoint, area.shape, area.hollow, map.width(), map.height());
            const desired = new Set(points.map((point)=>`${point.x},${point.y}`));
            let changed = false;
            area.cells.forEach((key)=>{
                if (!desired.has(key)) {
                    this.removePendingBuild(key, false);
                    area.cells.delete(key);
                    changed = true;
                }
            });
            for (const point of points){
                const key = `${point.x},${point.y}`;
                if (wallLine && this.existingWallAt(point, area.level)) continue;
                if (this.pendingBuilds.has(key)) continue;
                if (this.pendingBuilds.size >= 256) break;
                this.placeBuildTile(false, true, (0, $5b68384bc2307256$export$aa8352a64fa8b594)(point, area.level), false);
                if (this.pendingBuilds.has(key)) {
                    area.cells.add(key);
                    if (area.editGroupId !== undefined) this.pendingBuilds.get(key).groupId = area.editGroupId;
                }
                changed = true;
            }
            if (area.shape === "line") {
                // The endpoint must describe the actual footprint, including the tile limit.
                const drawn = points.filter((point)=>this.pendingBuilds.has(`${point.x},${point.y}`));
                area.endpoint = drawn[drawn.length - 1] || {
                    ...area.anchor
                };
                const last = points[points.length - 1];
                if (area.connection && last && (0, $a80d0b17b615d6f7$export$248d38f6296296c5)(last, area.connection) && points.every((point)=>this.existingWallAt(point, area.level) || this.pendingBuilds.has(`${point.x},${point.y}`))) area.endpoint = {
                    ...last
                };
                const connected = area.connection && (0, $a80d0b17b615d6f7$export$248d38f6296296c5)(area.endpoint, area.connection) ? area.connection : undefined;
                this.buildPlacementFeedback.setLineEnd(area.endpoint, area.axis, connected, this.areaYOffset(area));
            } else if (area.shape === "rectangle") {
                const expected = this.rectangleCellCount(area.anchor, endpoint, area.hollow);
                const complete = points.length === expected && points.every((point)=>this.pendingBuilds.has(`${point.x},${point.y}`));
                if (complete) {
                    area.endpoint = {
                        ...endpoint
                    };
                    this.buildPlacementFeedback.setAreaFootprint(area.anchor, endpoint, area.edges || {}, this.areaYOffset(area));
                } else {
                    this.buildPlacementFeedback.clearAreaFootprint();
                    area.endpoint = points.filter((point)=>this.pendingBuilds.has(`${point.x},${point.y}`)).pop() || {
                        ...area.anchor
                    };
                }
            }
            return changed;
        };
        this.updateMovedBuildArea = (coordinate, area)=>{
            const move = area.move;
            const dx = coordinate.x - move.pointer.x, dy = coordinate.y - move.pointer.y;
            const anchor = {
                x: move.anchor.x + dx,
                y: move.anchor.y + dy
            };
            const endpoint = {
                x: move.endpoint.x + dx,
                y: move.endpoint.y + dy
            };
            const map = this.client.clientGameLogic.tilemapMetaProvider;
            if ([
                anchor,
                endpoint
            ].some((p)=>p.x < 0 || p.y < 0 || p.x >= map.width() || p.y >= map.height())) return false;
            const points = (0, $85e59abaaefadc89$export$75b70d6a391d14b5)(anchor, endpoint, "rectangle", area.hollow, map.width(), map.height());
            if (points.some((p)=>{
                const pending = this.pendingBuilds.get(`${p.x},${p.y}`);
                return pending && pending.groupId !== area.editGroupId;
            })) return false;
            const shiftX = anchor.x - area.anchor.x, shiftY = anchor.y - area.anchor.y;
            if (!shiftX && !shiftY) return false;
            const entries = Array.from(this.pendingBuilds.entries());
            const moving = entries.filter(([, pending])=>pending.groupId === area.editGroupId);
            moving.forEach(([key])=>this.buildPlacementFeedback.remove(key));
            // Translate the existing ghost art immediately, then validate its new cells with the server.
            moving.forEach(([, pending])=>{
                pending.coordinate = {
                    x: pending.coordinate.x + shiftX,
                    y: pending.coordinate.y + shiftY
                };
                pending.previewResolved = false;
                pending.valid = false;
                pending.invalidMarker?.destroy();
                pending.invalidMarker = undefined;
                pending.sprites.forEach((sprite)=>{
                    sprite.x += shiftX * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                    sprite.y += shiftY * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                    sprite.tint = 0xffffff;
                });
                if (pending.shortageMarker) {
                    pending.shortageMarker.x += shiftX * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                    pending.shortageMarker.y += shiftY * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                }
            });
            this.pendingBuilds.clear();
            entries.forEach(([key, pending])=>this.pendingBuilds.set(pending.groupId === area.editGroupId ? `${pending.coordinate.x},${pending.coordinate.y}` : key, pending));
            area.cells = new Set(moving.map(([, pending])=>`${pending.coordinate.x},${pending.coordinate.y}`));
            moving.forEach(([, pending])=>this.buildPlacementFeedback.add(`${pending.coordinate.x},${pending.coordinate.y}`, pending.coordinate, this.pendingYOffset(pending), false));
            area.anchor = anchor;
            area.endpoint = endpoint;
            this.buildPreview = undefined;
            this.buildPreviewRevision++;
            this.buildPlacementFeedback.setAreaFootprint(anchor, endpoint, {}, this.areaYOffset(area));
            this.updatePendingBuildFunding();
            return true;
        };
        this.selectBuildingShape = (shape)=>{
            if (this.buildStroke || !(0, $85e59abaaefadc89$export$508fe9565d0ddf0f).includes(shape)) return;
            this.buildingShape = shape;
            this.updateBuildingCursor();
            this.buildingShapePaletteDismissed = true;
            this.updateBuildingShapePalette();
        };
        this.respondToBuildShapeWheel = (event)=>{
            if (!this.terrainPointerOn || !this.shapePaletteHeld() || !this.mouseActionEnabled || this.isChat) return;
            const gui = this.client.clientGameLogic.clientRenderer.gui();
            if (gui.isItemScreenOpen() || gui.isCommandWheelVisible() || gui.isChatComposerVisible?.() || gui.isNamePromptVisible?.()) return;
            event.preventDefault();
            if (this.buildingShapePaletteDismissed && !this.buildStroke) return;
            const delta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
            if (this.buildStroke || delta === 0) return;
            if (Date.now() - this.buildingShapeScrollAt > 250) this.buildingShapeScroll = 0;
            this.buildingShapeScrollAt = Date.now();
            this.buildingShapeScroll += delta * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? 100 : 1);
            if (Math.abs(this.buildingShapeScroll) < 40) return;
            const index = (0, $85e59abaaefadc89$export$508fe9565d0ddf0f).indexOf(this.buildingShape);
            this.selectBuildingShape((0, $85e59abaaefadc89$export$508fe9565d0ddf0f)[(index + (this.buildingShapeScroll > 0 ? 1 : -1) + (0, $85e59abaaefadc89$export$508fe9565d0ddf0f).length) % (0, $85e59abaaefadc89$export$508fe9565d0ddf0f).length]);
            this.buildingShapeScroll = 0;
        };
        this.shapePaletteHeld = ()=>!!$319b1dfd90d3ebea$export$412acd947dfd38f2 && !!this.isKeyOn($319b1dfd90d3ebea$export$412acd947dfd38f2);
        this.updateBuildingShapePalette = ()=>{
            if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) return;
            this.updateBuildingCursor();
            const held = this.shapePaletteHeld();
            if (!held) this.buildingShapePaletteDismissed = false;
            const gui = this.client.clientGameLogic.clientRenderer.gui();
            if (!gui.setBuildingShapePalette) return;
            const item = this.entity.inventory?.items?.find((i)=>i.active && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(i.itemTypeMeta));
            const buildType = item && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildType(item.itemTypeMeta);
            const visible = this.terrainPointerOn && this.mouseActionEnabled && held && !this.buildingShapePaletteDismissed && !this.isChat && !gui.isItemScreenOpen() && !gui.isCommandWheelVisible() && !gui.isChatComposerVisible?.() && !gui.isNamePromptVisible?.() && [
                "wall",
                "roof",
                "floor",
                "floor2"
            ].includes(buildType);
            gui.setBuildingShapePalette?.({
                visible: !!visible,
                shape: this.buildingShape,
                locked: !!this.buildStroke,
                hollow: buildType === "wall",
                position: this.mouseHandler.state().position
            });
        };
        this.placeBuildTile = (togglePending = true, deferTimer = false, target, refresh = true)=>{
            if (!this.terrainPointerOn) return;
            if (!target) this.refreshBuildPointer();
            const { level: level, ...coordinate } = {
                ...target || this.buildPointer
            };
            const key = `${coordinate.x},${coordinate.y}`;
            const item = this.entity.inventory?.items?.find((i)=>i.active && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(i.itemTypeMeta));
            const buildType = item && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildType(item.itemTypeMeta);
            // A raised wall never replaces one already up there (a raised roof covers its walls, as roofs do).
            if (this.pendingBuilds.has(key) || level !== undefined && buildType === "wall" && this.existingWallAt(coordinate, level)) {
                if (togglePending && this.pendingBuilds.has(key) && !this.pendingBuilds.get(key).committing) this.removePendingBuild(key, true, true);
                if (refresh) this.refreshBuildPointer(true);
                return;
            }
            if (buildType && [
                "wall",
                "roof",
                "floor",
                "floor2"
            ].includes(buildType)) {
                const pending = {
                    roof: buildType === "roof",
                    level: level,
                    coordinate: coordinate,
                    itemId: item.id,
                    roomId: this.entity.roomId,
                    sprites: new Set(),
                    valid: false,
                    committing: false
                };
                this.pendingBuilds.set(key, pending);
                this.buildPlacementFeedback.add(key, coordinate, this.pendingYOffset(pending));
                this.buildPreviewRevision++;
                if (this.buildPreview && (0, $5b68384bc2307256$export$8b521e8d432acfa6)(this.buildPreview.coordinate, (0, $5b68384bc2307256$export$aa8352a64fa8b594)(coordinate, level))) this.renderPendingBuild(pending, this.buildPreview.deltas, this.buildPreview.valid);
                if (!deferTimer) {
                    pending.groupId = ++this.buildPrintGroupId;
                    this.startReleasedBuildGroup(pending.groupId);
                }
            } else {
                this.growLadderExtension((0, $5b68384bc2307256$export$aa8352a64fa8b594)(coordinate, level));
                if (level === undefined) this.client.commitWorldEdits(coordinate);
                else this.client.commitWorldEdits(coordinate, false, level);
            }
            this.updatePendingBuildFunding();
            if (refresh) this.playBuildSwing();
            if (refresh) {
                this.clearTerrainPointer();
                this.refreshBuildPointer(true);
                this.refreshPendingPreviews();
            }
        };
        this.startPendingBuildTimer = (pending)=>{
            if (pending.startedAt !== undefined) return;
            if (pending.groupId === undefined) pending.groupId = ++this.buildPrintGroupId;
            const groupId = pending.groupId;
            const existing = Array.from(this.pendingBuilds.values()).find((p)=>p.groupId === groupId && p.startedAt !== undefined);
            pending.startedAt = existing?.startedAt ?? Date.now();
            this.buildPlacementFeedback.setCounting(`${pending.coordinate.x},${pending.coordinate.y}`, pending.startedAt, groupId);
            if (!this.pendingPrintTimers.has(groupId)) this.pendingPrintTimers.set(groupId, setTimeout(()=>this.printPendingGroup(groupId), $319b1dfd90d3ebea$export$54edab2f6fe321b1));
            this.syncBuildingPrintGroups();
        };
        // `swung`: printed at the click, which already swung (a lone tile builds at once).
        this.printPendingGroup = (groupId, swung = false)=>{
            this.updatePendingBuildFunding();
            const group = Array.from(this.pendingBuilds.values()).filter((p)=>p.groupId === groupId);
            if (!group.length) return;
            // Invalid cells are excluded individually; legal cells still print as one batch.
            group.filter((p)=>!p.valid || p.unfunded).forEach((p)=>this.removePendingBuild(`${p.coordinate.x},${p.coordinate.y}`, false));
            const printable = group.filter((p)=>p.valid && !p.unfunded);
            const first = group[0];
            const current = this.entity.inventory?.items?.find((i)=>i.id === first.itemId);
            const valid = printable.length > 0 && current && current.quantity >= printable.length && printable.every((p)=>p.valid && p.itemId === first.itemId && p.roomId === this.entity.roomId && p.level === first.level);
            if (valid) {
                printable.forEach((pending)=>{
                    pending.committing = true;
                    pending.sprites.forEach((sprite)=>{
                        sprite.alpha = 1;
                    });
                });
                this.landPrintedGroup(printable, current.itemTypeMeta);
                this.syncBuildingPrintGroups();
                // The group stays opaque until its single server acknowledgement arrives.
                this.pendingPrintTimers.set(groupId, setTimeout(()=>{
                    group.forEach((p)=>this.removePendingBuild(`${p.coordinate.x},${p.coordinate.y}`, false));
                    this.refreshPendingPreviews();
                }, 5000));
                const cells = printable.map((p)=>({
                        ...p.coordinate
                    }));
                if (swung) this.client.commitWorldEditGroup(cells, first.itemId, first.level, true);
                else if (first.level === undefined) this.client.commitWorldEditGroup(cells, first.itemId);
                else this.client.commitWorldEditGroup(cells, first.itemId, first.level);
            } else {
                group.forEach((p)=>this.removePendingBuild(`${p.coordinate.x},${p.coordinate.y}`, false));
                this.refreshPendingPreviews();
                this.refreshBuildPointer(true);
            }
        };
        this.startReleasedBuildGroup = (groupId)=>{
            if (this.buildStroke?.area?.editGroupId === groupId) return;
            this.updatePendingBuildFunding();
            const group = Array.from(this.pendingBuilds.values()).filter((p)=>p.groupId === groupId);
            // A fast release can arrive before the server previews. Wait for their verdicts
            // instead of treating unanswered cells as illegal or starting an empty print.
            if (!group.length || group.some((p)=>!p.previewResolved)) return;
            if (!group.some((p)=>p.valid)) {
                group.forEach((p)=>this.removePendingBuild(`${p.coordinate.x},${p.coordinate.y}`, false));
                this.refreshPendingPreviews();
                this.refreshBuildPointer(true);
                return;
            }
            if (!group.some((p)=>p.valid && !p.unfunded)) return;
            if (group.some((p)=>p.startedAt !== undefined)) return;
            // One piece at a time is built at once: the countdown is a window to correct a larger plan before it prints.
            if (group.length === 1) {
                this.printPendingGroup(groupId, true);
                return;
            }
            group.forEach((p)=>this.startPendingBuildTimer(p));
            this.sharePendingBuilds();
        };
        this.releasePendingBuilds = ()=>{
            const area = this.buildStroke?.area;
            if (area?.editGroupId !== undefined) {
                const groupId = area.editGroupId;
                area.editGroupId = undefined;
                this.rememberPendingRectangle(groupId, area);
                this.startReleasedBuildGroup(groupId);
                this.animatePendingBuilds();
                return;
            }
            const held = Array.from(this.pendingBuilds.values()).filter((p)=>p.startedAt === undefined && p.groupId === undefined);
            if (!held.length) return;
            const groupId = ++this.buildPrintGroupId;
            held.forEach((pending)=>{
                pending.groupId = groupId;
            });
            if (area) this.rememberPendingRectangle(groupId, area);
            this.startReleasedBuildGroup(groupId);
        };
        this.rememberPendingRectangle = (groupId, area)=>{
            this.pendingRectangles.delete(groupId);
            if (area.shape !== "rectangle" || !area.endpoint) return;
            const cells = Array.from(this.pendingBuilds.values()).filter((p)=>p.groupId === groupId);
            const expected = this.rectangleCellCount(area.anchor, area.endpoint, area.hollow);
            if (cells.length !== expected || cells.length < 2) return;
            this.pendingRectangles.set(groupId, {
                anchor: {
                    ...area.anchor
                },
                endpoint: {
                    ...area.endpoint
                },
                itemId: cells[0].itemId,
                roof: area.roof,
                level: area.level,
                hollow: area.hollow
            });
        };
        this.rectangleCellCount = (anchor, endpoint, hollow)=>{
            const width = Math.abs(anchor.x - endpoint.x) + 1, height = Math.abs(anchor.y - endpoint.y) + 1;
            return hollow && width > 1 && height > 1 ? 2 * width + 2 * height - 4 : width * height;
        };
        this.resizeCandidate = (target, cornerOnly = true)=>{
            if (!target || !this.canCorrectBuild() || (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() && this.mobileBuildTool !== "room") return;
            const pending = this.pendingBuilds.get(`${target.x},${target.y}`);
            if (!pending || pending.committing || pending.groupId === undefined) return;
            const rectangle = this.pendingRectangles.get(pending.groupId);
            const item = this.entity.inventory?.items?.find((i)=>i.active && i.id === rectangle?.itemId);
            if (!rectangle || !item) return;
            const left = Math.min(rectangle.anchor.x, rectangle.endpoint.x), right = Math.max(rectangle.anchor.x, rectangle.endpoint.x);
            const top = Math.min(rectangle.anchor.y, rectangle.endpoint.y), bottom = Math.max(rectangle.anchor.y, rectangle.endpoint.y);
            if (cornerOnly && (![
                left,
                right
            ].includes(target.x) || ![
                top,
                bottom
            ].includes(target.y))) return;
            // Erased or overlapping plans are not complete rectangles, so do not silently refill them.
            const cells = Array.from(this.pendingBuilds.values()).filter((p)=>p.groupId === pending.groupId);
            if (cells.length !== this.rectangleCellCount(rectangle.anchor, rectangle.endpoint, rectangle.hollow) || cells.some((p)=>p.committing || p.coordinate.x < left || p.coordinate.x > right || p.coordinate.y < top || p.coordinate.y > bottom)) return;
            return {
                groupId: pending.groupId,
                rectangle: rectangle,
                cells: cells,
                anchor: {
                    x: target.x === left ? right : left,
                    y: target.y === top ? bottom : top
                }
            };
        };
        this.beginBuildEdit = (target)=>{
            const candidate = this.resizeCandidate(target, false);
            if (!candidate) return false;
            const { groupId: groupId, rectangle: rectangle, cells: cells } = candidate;
            const atCorner = [
                rectangle.anchor.x,
                rectangle.endpoint.x
            ].includes(target.x) && [
                rectangle.anchor.y,
                rectangle.endpoint.y
            ].includes(target.y);
            const anchor = atCorner ? candidate.anchor : {
                ...rectangle.anchor
            };
            const endpoint = atCorner ? {
                ...target
            } : {
                ...rectangle.endpoint
            };
            clearTimeout(this.pendingPrintTimers.get(groupId));
            this.pendingPrintTimers.delete(groupId);
            cells.forEach((pending)=>{
                pending.startedAt = undefined;
                this.buildPlacementFeedback.pauseCounting(`${pending.coordinate.x},${pending.coordinate.y}`);
            });
            this.buildStroke = {
                last: {
                    ...target
                },
                visited: new Set(),
                level: rectangle.level,
                area: {
                    editGroupId: groupId,
                    roof: rectangle.roof,
                    level: rectangle.level,
                    anchor: anchor,
                    endpoint: endpoint,
                    move: atCorner ? undefined : {
                        pointer: {
                            ...target
                        },
                        anchor: {
                            ...rectangle.anchor
                        },
                        endpoint: {
                            ...rectangle.endpoint
                        }
                    },
                    cells: new Set(cells.map((p)=>`${p.coordinate.x},${p.coordinate.y}`)),
                    hollow: rectangle.hollow,
                    shape: "rectangle"
                }
            };
            this.isFiring = true;
            this.buildPreviewRevision++;
            this.buildPlacementFeedback.clearResizeHandle();
            this.buildPlacementFeedback.setAreaFootprint(anchor, endpoint, {}, this.areaYOffset(rectangle));
            this.syncBuildingPrintGroups();
            this.refreshPendingPreviews();
            this.animatePendingBuilds();
            return true;
        };
        this.cancelPendingPrinting = (groupId)=>{
            this.suppressAttack();
            this.stopFiring();
            Array.from(this.pendingBuilds.entries()).forEach(([key, pending])=>{
                if (!pending.committing && (groupId === undefined || pending.groupId === groupId)) this.removePendingBuild(key, false, true);
            });
            this.buildPreview = undefined;
            this.refreshPendingPreviews();
            this.refreshBuildPointer(true);
            this.syncBuildingPrintGroups();
        };
        this.canCorrectBuild = ()=>{
            const gui = this.client.clientGameLogic.clientRenderer.gui();
            return this.mouseActionEnabled && !this.isChat && !this.paralyzed && !this.downed && !this.entity.isDead() && !this.locationPick && !gui.isItemScreenOpen() && !gui.isCommandWheelVisible() && !gui.isRolePickerVisible?.() && !gui.isChatComposerVisible?.() && !gui.isNamePromptVisible?.();
        };
        this.pendingBuildAtPointer = (coordinate)=>{
            const world = !coordinate && this.client.clientGameLogic.clientRenderer.gui().worldPointAtPointer?.();
            const target = coordinate || (world ? this.buildingTargetAt(world) : this.roughPointer);
            return target && this.pendingBuilds.has(`${target.x},${target.y}`);
        };
        this.clearUnequippedBuildMode = ()=>{
            // Equipment snapshots and build activation arrive separately. A stale mode flag must
            // not let an old plan claim input after the player has put the material away.
            if (this.terrainPointerOn && !this.entity.inventory?.items?.some((item)=>item.active && item.quantity > 0 && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(item.itemTypeMeta))) this.updateTerrainPointerOn(false);
        };
        this.leaveBuildForSecondaryPress = (pointerType, button, coordinate)=>{
            this.clearUnequippedBuildMode();
            if (!this.terrainPointerOn) return true;
            // A right-drag starting on a plan owns the whole sweep, including empty cells and entities.
            if (pointerType === "touch" || button !== 2 || this.buildEraseStroke || this.pendingBuildAtPointer(coordinate) || !this.canCorrectBuild()) return false;
            this.updateTerrainPointerOn(false);
            this.buildPrimarySuppressed = this.isButtonOn("0");
            this.suppressAttack(1000);
            return true;
        };
        // A tile's wheel closed, picked or dismissed. If a right-click left building to open it, building resumes
        // while the material is still in hand: dismantling a misplaced tile and laying the next is one motion.
        this.tileWheelClosed = ()=>{
            if (!this.resumeBuildAfterTileWheel) return;
            this.resumeBuildAfterTileWheel = false;
            const equipped = this.entity.inventory?.items?.some((item)=>item.active && item.quantity > 0 && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(item.itemTypeMeta));
            if (!equipped || this.terrainPointerOn || this.locationPick) return;
            this.updateTerrainPointerOn(true);
            // The press that closed the wheel (a slice, or a click off it) reaches respondToMouse after this.
            this.suppressAttack();
        };
        this.erasePendingBuilds = (coordinate)=>{
            const stroke = this.buildEraseStroke;
            if (!stroke) return;
            const map = this.client.clientGameLogic.tilemapMetaProvider;
            // Traverse between sparse pointer events so a fast sweep does not leave skipped ghosts.
            const points = (0, $85e59abaaefadc89$export$75b70d6a391d14b5)(stroke.last || coordinate, coordinate, "line", false, map.width(), map.height());
            let changed = false;
            points.forEach((point)=>{
                const key = `${point.x},${point.y}`;
                const pending = this.pendingBuilds.get(key);
                if (!pending || pending.committing) return;
                this.removePendingBuild(key, false, true);
                changed = true;
            });
            stroke.last = {
                ...coordinate
            };
            if (changed) {
                this.buildPreview = undefined;
                this.clearTerrainPointer();
                this.refreshPendingPreviews();
            }
        };
        this.undoLatestBuild = ()=>{
            if (this.buildStroke?.area?.editGroupId !== undefined) {
                this.buildPrimarySuppressed = !(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() && this.isButtonOn("0");
                this.cancelPendingPrinting(this.buildStroke.area.editGroupId);
                return;
            }
            // Cancel a held gesture directly; starting its timer could discard invalid cells and
            // accidentally make an earlier stroke become the newest remaining group.
            const held = Array.from(this.pendingBuilds.values()).filter((p)=>!p.committing && p.groupId === undefined);
            if (held.length) {
                const groupId = ++this.buildPrintGroupId;
                held.forEach((p)=>{
                    p.groupId = groupId;
                });
            }
            const groups = Array.from(this.pendingBuilds.values()).filter((p)=>!p.committing && p.groupId !== undefined);
            if (!groups.length) return;
            const latest = Math.max(...groups.map((p)=>p.groupId));
            this.buildPrimarySuppressed = !(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() && this.isButtonOn("0");
            this.cancelPendingPrinting(latest);
        };
        this.syncBuildingPrintGroups = ()=>{
            const groups = new Map();
            this.pendingBuilds.forEach((pending)=>{
                if (pending.startedAt === undefined || pending.committing || !pending.valid || pending.unfunded) return;
                const id = pending.groupId;
                const existing = groups.get(id);
                if (existing) {
                    existing.count++;
                    existing.anchor = {
                        ...pending.coordinate
                    };
                } else groups.set(id, {
                    id: id,
                    startedAt: pending.startedAt,
                    duration: $319b1dfd90d3ebea$export$54edab2f6fe321b1,
                    count: 1,
                    anchor: {
                        ...pending.coordinate
                    },
                    yOffset: this.pendingYOffset(pending),
                    onCancel: ()=>this.cancelPendingPrinting(id)
                });
            });
            groups.forEach((group)=>{
                const rectangle = this.pendingRectangles.get(group.id);
                if (rectangle) group.anchor = {
                    x: (rectangle.anchor.x + rectangle.endpoint.x) / 2,
                    y: Math.min(rectangle.anchor.y, rectangle.endpoint.y) - 1
                };
            });
            this.client.clientGameLogic.clientRenderer.gui().setBuildingPrintGroups?.(Array.from(groups.values()));
        };
        this.updatePendingBuildFunding = ()=>{
            let changed = false;
            const remaining = new Map(this.entity.inventory?.items?.map((item)=>[
                    item.id,
                    item.quantity
                ]) || []);
            this.pendingBuilds.forEach((pending)=>{
                const yOffset = this.pendingYOffset(pending);
                this.buildPlacementFeedback.setOffset(`${pending.coordinate.x},${pending.coordinate.y}`, yOffset);
                const available = remaining.get(pending.itemId) || 0;
                const needsMaterial = !pending.previewResolved || pending.valid;
                const unfunded = !pending.committing && needsMaterial && available <= 0;
                if (needsMaterial && !unfunded) remaining.set(pending.itemId, available - 1);
                if (pending.unfunded !== unfunded) changed = true;
                pending.unfunded = unfunded;
                this.buildPlacementFeedback.setState(`${pending.coordinate.x},${pending.coordinate.y}`, pending.previewResolved && !pending.valid ? "blocked" : unfunded ? "shortage" : pending.previewResolved ? "valid" : "waiting");
                pending.sprites.forEach((sprite)=>{
                    sprite.visible = !unfunded;
                });
                if (unfunded && !pending.shortageMarker) {
                    // Amber corners and a minus badge distinguish shortages from the red illegal X.
                    const marker = new (0, $gwPoJ.Graphics)();
                    marker.lineStyle(2, 0xffc35a, 0.95);
                    const edge = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 2, length = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.25;
                    for (const [x, y, dx, dy] of [
                        [
                            2,
                            2,
                            1,
                            1
                        ],
                        [
                            edge,
                            2,
                            -1,
                            1
                        ],
                        [
                            2,
                            edge,
                            1,
                            -1
                        ],
                        [
                            edge,
                            edge,
                            -1,
                            -1
                        ]
                    ]){
                        marker.moveTo(x + dx * length, y);
                        marker.lineTo(x, y);
                        marker.lineTo(x, y + dy * length);
                    }
                    marker.beginFill(0x352a18, 0.9);
                    marker.drawCircle((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.18);
                    marker.endFill();
                    marker.moveTo((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.4, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2);
                    marker.lineTo((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.6, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2);
                    marker.position.set(pending.coordinate.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), pending.coordinate.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + yOffset);
                    marker.zIndex = 100000.5;
                    marker.alpha = this.pendingBuildAlpha(pending);
                    pending.shortageMarker = marker;
                    this.client.clientGameLogic.clientRenderer.map().getTileSurface().addChild(marker);
                } else if (!unfunded && pending.shortageMarker) {
                    pending.shortageMarker.destroy();
                    pending.shortageMarker = undefined;
                }
            });
            if (changed) this.syncBuildingPrintGroups();
        };
        this.renderPendingBuild = (pending, deltas, valid)=>{
            if (pending.committing) return;
            pending.valid = valid;
            pending.previewResolved = true;
            this.updatePendingBuildFunding();
            const owner = `${pending.coordinate.x},${pending.coordinate.y}`;
            // The tiles this piece joins show their new shape; a refused piece reshapes nothing.
            if (valid && pending.level === undefined) this.reshapeGhosts.claim(owner, deltas);
            else this.reshapeGhosts.release(owner);
            if (!valid) {
                // An illegal neighbour combination must not erase the stroke. Keep the last
                // server-resolved art and mark its cell, including cells with no valid art yet.
                pending.sprites.forEach((sprite)=>{
                    sprite.tint = 0xff8174;
                });
                if (!pending.invalidMarker) {
                    const marker = new (0, $gwPoJ.Graphics)();
                    marker.lineStyle(2, 0xff8174, 1);
                    marker.beginFill(0xff8174, 0.15);
                    marker.drawRect(1, 1, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 2, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 2);
                    marker.endFill();
                    const inset = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.35;
                    marker.moveTo(inset, inset);
                    marker.lineTo((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - inset, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - inset);
                    marker.moveTo((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - inset, inset);
                    marker.lineTo(inset, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - inset);
                    marker.position.set(pending.coordinate.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), pending.coordinate.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + this.pendingYOffset(pending));
                    marker.zIndex = 100000.5;
                    marker.alpha = this.pendingBuildAlpha(pending);
                    pending.invalidMarker = marker;
                    this.client.clientGameLogic.clientRenderer.map().getTileSurface().addChild(marker);
                }
                return;
            }
            pending.invalidMarker?.destroy();
            pending.invalidMarker = undefined;
            pending.sprites.forEach((sprite)=>{
                sprite.parent?.removeChild(sprite);
                sprite.destroy();
            });
            pending.sprites.clear();
            const map = this.client.clientGameLogic.clientRenderer.map();
            deltas.forEach((delta)=>{
                if ([
                    "blocking",
                    "skyTrigger"
                ].includes(delta.layerId) || !delta.context?.highZ) return;
                // Neighbour deltas belong to their own pending ghosts, not this cell's animation.
                if (delta.context?.previewTarget === false) return;
                const sprite = map.addTileAt(delta.x, delta.y, String(delta.tileSpec.tilePos), delta.layerId, true)?.sprite;
                if (sprite) {
                    // The active map draws on the player's storey; lift a raised wall to its own.
                    sprite.y += this.storeyYOffset(pending.level);
                    sprite.alpha = this.pendingBuildAlpha(pending);
                    sprite.visible = !pending.unfunded;
                    sprite.zIndex = 100000;
                    pending.sprites.add(sprite);
                }
            });
        };
        this.removePendingBuild = (key, refresh = true, dissolve = false)=>{
            const pending = this.pendingBuilds.get(key);
            if (!pending) return;
            this.buildPlacementFeedback.remove(key);
            if (dissolve) this.buildPlacementFeedback.spark(pending.coordinate, "erase", this.pendingYOffset(pending));
            pending.invalidMarker?.destroy();
            pending.shortageMarker?.destroy();
            pending.sprites.forEach((sprite)=>{
                sprite.parent?.removeChild(sprite);
                sprite.destroy();
            });
            this.pendingBuilds.delete(key);
            this.reshapeGhosts.release(key);
            if (pending.groupId !== undefined && !Array.from(this.pendingBuilds.values()).some((p)=>p.groupId === pending.groupId)) {
                this.pendingRectangles.delete(pending.groupId);
                clearTimeout(this.pendingPrintTimers.get(pending.groupId));
                this.pendingPrintTimers.delete(pending.groupId);
            }
            this.syncBuildingPrintGroups();
            this.buildPreviewRevision++;
            if (refresh) this.refreshPendingPreviews();
        };
        this.buildingCommitResult = (coordinate, committed = true)=>{
            const pending = this.pendingBuilds.get(`${coordinate.x},${coordinate.y}`);
            if (pending?.committing) {
                let printed = 0;
                let impactAt = -Infinity;
                const now = Date.now();
                Array.from(this.pendingBuilds.entries()).forEach(([key, member])=>{
                    if (member.groupId === pending.groupId) {
                        // Built: what it joined holds its new shape until the map's own tiles catch up.
                        if (committed) this.reshapeGhosts.settle(key);
                        if (committed) {
                            if (member.landing && (0, $dd2f604be1eac3c5$export$6e2723a70a7a1aa7).tracks(member.landing)) {
                                // The landing carries the ghosts on until the real piece is drawn.
                                (0, $dd2f604be1eac3c5$export$c91b18faf7a209bf)(member.landing, now);
                                member.sprites = new Set();
                                impactAt = impactAt === -Infinity ? member.landing.startAt : Math.min(impactAt, member.landing.startAt);
                            } else {
                                this.buildPlacementFeedback.settle(member.sprites);
                                this.buildPlacementFeedback.spark(member.coordinate, "built", this.pendingYOffset(member));
                            }
                            printed++;
                        } else if (member.landing) // Refused: the same cell built again lands again.
                        (0, $dd2f604be1eac3c5$export$6e2723a70a7a1aa7).forget(member.landing.storey, member.landing.layer, member.landing.x, member.landing.y);
                        this.removePendingBuild(key, false);
                    }
                });
                // One knock per printed group, on its first impact.
                if (printed) {
                    const wait = impactAt + (0, $dd2f604be1eac3c5$export$b4e04ab9b076b17c)() - now;
                    const knock = ()=>this.client.clientGameLogic.audio.buildPrinted(printed);
                    if (wait > 16) setTimeout(knock, wait);
                    else knock();
                }
                this.refreshPendingPreviews();
            }
            this.refreshBuildPointer(true);
        };
        /**
     * A printed plan lands: its ghosts, opaque now, lift and drop as a wave out from the builder. A
     * window or chimney is fitted to a piece already standing, so nothing lands for it.
     */ this.landPrintedGroup = (printed, itemTypeMeta)=>{
            if (!printed.length || (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[itemTypeMeta.type]?.ornament) return;
            const buildType = (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildType(itemTypeMeta);
            const layer = buildType === "wall" ? "wall" : buildType === "roof" ? "roof" : "floor";
            const location = this.entity.location;
            const landings = (0, $dd2f604be1eac3c5$export$6e2723a70a7a1aa7).start(printed.map((p)=>p.coordinate), {
                storey: printed[0].level ?? this.ownStorey(),
                layer: layer,
                now: Date.now(),
                origin: location && {
                    x: location.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: location.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                },
                itemType: itemTypeMeta.type,
                lift: layer === "roof" ? (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)() : 0
            });
            landings.forEach((landing)=>{
                const pending = this.pendingBuilds.get(`${landing.x},${landing.y}`);
                if (!pending) return;
                const yOffset = this.pendingYOffset(pending);
                pending.landing = landing;
                landing.ghosts = pending.sprites;
                // An upright piece squashes into its foot, a flat one about its middle.
                landing.ghostPivot = {
                    x: (landing.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: (landing.y + (layer === "wall" ? 1 : 0.5)) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + yOffset
                };
            });
        };
        this.clearPendingBuilds = ()=>{
            this.buildEraseStroke = undefined;
            Array.from(this.pendingBuilds.keys()).forEach((key)=>this.removePendingBuild(key, false));
            this.buildPlacementFeedback.clear();
            this.pendingRectangles.clear();
            this.sharePendingBuilds();
        };
        this.sharePendingBuilds = ()=>{
            this.updatePendingBuildFunding();
            // Peers draw shared ghosts on their own storey, so raised walls are not shared (yet).
            const pending = Array.from(this.pendingBuilds.values()).filter((p)=>p.level === undefined);
            if (!pending.length && !this.lastSharedBuildSnapshot) return;
            const signature = JSON.stringify([
                this.entity.roomId,
                pending.map((p)=>[
                        p.coordinate,
                        p.itemId,
                        p.startedAt,
                        p.unfunded
                    ])
            ]);
            if (signature === this.lastSharedBuildSnapshot && (!pending.length || Date.now() - this.lastSharedBuildAt < 3000)) return;
            this.lastSharedBuildSnapshot = signature;
            this.lastSharedBuildAt = Date.now();
            this.client.shareBuildingPreview?.(this.entity.roomId, pending[0]?.itemId, pending.filter((p)=>!p.unfunded).map((p)=>({
                    coordinate: {
                        ...p.coordinate
                    },
                    itemId: p.itemId,
                    elapsedMs: p.startedAt === undefined ? undefined : Math.max(0, Date.now() - p.startedAt)
                })));
        };
        this.updateSharedBuildingPreview = (entityId, tiles)=>{
            if (entityId === this.entity.entityId) return;
            this.removeSharedBuilds(entityId);
            if (!tiles?.length) return;
            const map = this.client.clientGameLogic.clientRenderer.map();
            const ghosts = tiles.map((tile)=>{
                const sprites = new Set();
                tile.deltas.forEach((delta)=>{
                    const sprite = map.addTileAt(delta.x, delta.y, String(delta.tileSpec.tilePos), delta.layerId, true)?.sprite;
                    if (!sprite) return;
                    // Pure display objects: no terrain edits, hit targets, or cancellation handlers.
                    sprite.interactive = false;
                    sprite.zIndex = 100000;
                    sprites.add(sprite);
                });
                return {
                    sprites: sprites,
                    startedAt: tile.elapsedMs === undefined ? undefined : Date.now() - tile.elapsedMs
                };
            });
            this.sharedBuilds.set(entityId, {
                receivedAt: Date.now(),
                tiles: ghosts
            });
            this.animatePendingBuilds();
        };
        this.removeSharedBuilds = (entityId)=>{
            this.sharedBuilds.get(entityId)?.tiles.forEach((tile)=>tile.sprites.forEach((sprite)=>sprite.destroy()));
            this.sharedBuilds.delete(entityId);
        };
        this.clearSharedBuilds = ()=>{
            Array.from(this.sharedBuilds.keys()).forEach((entityId)=>this.removeSharedBuilds(entityId));
        };
        this.pendingBuildAlpha = (pending)=>{
            if (pending.committing) return 1;
            if (pending.groupId !== undefined && this.buildStroke?.area?.editGroupId === pending.groupId) return 0.85;
            return this.buildGhostAlpha(pending.startedAt);
        };
        this.buildGhostAlpha = (startedAt)=>{
            if (startedAt === undefined) return $319b1dfd90d3ebea$var$BUILD_GHOST_ALPHA;
            const elapsed = Date.now() - startedAt;
            const progress = Math.max(0, Math.min(1, elapsed / $319b1dfd90d3ebea$export$54edab2f6fe321b1));
            // A steady ghost gradually gains clarity; the countdown communicates remaining time.
            const eased = progress * progress * (3 - 2 * progress);
            return $319b1dfd90d3ebea$var$BUILD_GHOST_ALPHA + (0.7 - $319b1dfd90d3ebea$var$BUILD_GHOST_ALPHA) * eased;
        };
        this.requestBuildPreview = (coordinate)=>{
            const pending = this.pendingBuilds.get(`${coordinate.x},${coordinate.y}`);
            const level = pending ? pending.level : coordinate.level;
            const itemId = pending?.itemId || this.entity.inventory?.items?.find((i)=>i.active && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(i.itemTypeMeta))?.id;
            const pendingCoordinates = Array.from(this.pendingBuilds.values()).filter((p)=>p.itemId === itemId && p.level === level).map((p)=>p.coordinate);
            const cell = {
                x: coordinate.x,
                y: coordinate.y
            };
            if (level !== undefined) this.client.getBuildingTilePreview(cell, pendingCoordinates, this.buildPreviewRevision, pending?.itemId, level);
            else if (pending) this.client.getBuildingTilePreview(cell, pendingCoordinates, this.buildPreviewRevision, pending.itemId);
            else this.client.getBuildingTilePreview(cell, pendingCoordinates, this.buildPreviewRevision);
        };
        this.refreshPendingPreviews = ()=>{
            this.sharePendingBuilds();
            this.pendingBuilds.forEach((pending)=>{
                if (!pending.committing) this.requestBuildPreview(pending.coordinate);
            });
        };
        this.animatePendingBuilds = ()=>{
            this.tilePressCue.animate();
            if (this.buildGridMarker) {
                this.buildGridMarker.animate();
                this.storeyCursorCue?.animate(Date.now());
                // The roof's dotted rise travels with the cursor as it glides between cells, and fades with it.
                const { x: x, y: y, alpha: alpha } = this.buildGridMarker.body;
                this.roofOffsetGuide?.pivot.set(-x, -y);
                if (this.roofOffsetGuide) this.roofOffsetGuide.alpha = alpha;
            }
            this.updatePendingBuildFunding();
            this.buildPlacementFeedback.update();
            this.ladderGrowths.forEach((growth)=>{
                if (growth.animate()) return;
                this.ladderGrowths.delete(growth);
                this.reaimBuildPointer();
            });
            this.ladderDust.update(Date.now());
            this.syncReshapeGhosts();
            this.sharedBuilds.forEach((preview, entityId)=>{
                // A disconnected owner cannot send the clear snapshot. Heartbeats keep live
                // held previews visible; abandoned previews expire without touching the map.
                if (Date.now() - preview.receivedAt > 15000) {
                    this.removeSharedBuilds(entityId);
                    return;
                }
                preview.tiles.forEach((tile)=>tile.sprites.forEach((sprite)=>{
                        sprite.alpha = this.buildGhostAlpha(tile.startedAt);
                        const surface = this.client.clientGameLogic.clientRenderer.map().getTileSurface();
                        if (sprite.parent !== surface) surface.addChild(sprite);
                    }));
            });
            this.pendingBuilds.forEach((pending)=>{
                const alpha = this.pendingBuildAlpha(pending);
                for (const marker of [
                    pending.invalidMarker,
                    pending.shortageMarker
                ]){
                    if (!marker) continue;
                    marker.alpha = alpha;
                    marker.y = pending.coordinate.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + this.pendingYOffset(pending);
                    const surface = this.client.clientGameLogic.clientRenderer.map().getTileSurface();
                    if (marker.parent !== surface) surface.addChild(marker);
                }
                pending.sprites.forEach((sprite)=>{
                    sprite.alpha = alpha;
                    const surface = this.client.clientGameLogic.clientRenderer.map().getTileSurface();
                    if (sprite.parent !== surface) surface.addChild(sprite);
                });
            });
        };
        /** The tiles shown previews reshape: the cursor's while it is drawn, each planned piece's while it is shown. */ this.syncReshapeGhosts = ()=>{
            const shown = new Map();
            if (this.buildGridMarker?.visible && this.buildGhostCell) shown.set("hover", $319b1dfd90d3ebea$var$BUILD_GHOST_ALPHA);
            this.pendingBuilds.forEach((pending, key)=>{
                if (pending.valid && !pending.unfunded) shown.set(key, this.pendingBuildAlpha(pending));
            });
            this.reshapeGhosts.sync(shown);
        };
        this.placementItem = ()=>this.entity?.inventory?.items?.find((item)=>item.active && item.quantity > 0 && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.placement(item.itemTypeMeta) && (item.readied || (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(item.itemTypeMeta)));
        /** A completed upward flight can hold the player at its top without ending stair travel. */ this.buildBlockedByStairTravel = ()=>{
            const view = this.entity?.stairTravel;
            if (!view) return false;
            const atop = view.phase === "depart" && view.direction === "up" && view.climb && view.flight && !view.climb.moving && (0, $968cce787b06be95$export$2bec297270f19bd9)(view) >= view.flight.total;
            return !atop;
        };
        this.refreshBuildPointer = (force = false)=>{
            if (this.pressedTile || this.buildBlockedByStairTravel()) {
                this.clearTerrainPointer();
                return;
            }
            if (this.terrainPointerOn && !this.buildStroke && this.roughPointer?.level !== undefined && this.storeyViews().some((view)=>view.level === this.roughPointer.level) && !this.placementStoreyViews().some((view)=>view.level === this.roughPointer.level)) {
                const world = this.client.clientGameLogic.clientRenderer.gui().worldPointAtPointer?.();
                if (world) this.roughPointer = this.buildingTargetAt(world);
            }
            if (this.terrainPointerOn && this.buildEraseStroke) {
                if (!this.canCorrectBuild()) {
                    this.buildPlacementFeedback.clearEraseTarget();
                    return;
                }
                const target = this.roughPointer;
                this.buildPointer = {
                    ...target
                };
                this.updateBuildGridMarker(target);
                this.buildGridMarker.visible = false;
                this.buildPlacementFeedback.setEraseTarget(target, this.buildFeedbackOffset() + this.storeyYOffset(target.level));
                return;
            }
            const area = this.buildStroke?.area;
            const lineEnd = area && (area.shape === "line" || area.shape === "rectangle" && !area.hollow) && area.endpoint && (0, $5b68384bc2307256$export$aa8352a64fa8b594)(area.endpoint, area.level);
            if (this.terrainPointerOn && lineEnd) {
                this.updateBuildGridMarker(lineEnd);
                if (force || !this.buildPointer || !(0, $5b68384bc2307256$export$8b521e8d432acfa6)(this.buildPointer, lineEnd)) {
                    this.buildPointer = {
                        ...lineEnd
                    };
                    this.requestBuildPreview(lineEnd);
                }
                return;
            }
            if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) {
                const buildable = this.entity?.inventory?.items?.some((i)=>i.active && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(i.itemTypeMeta));
                if (buildable) {
                    if (!this.terrainPointerOn) {
                        this.clearTerrainPointer();
                        return;
                    }
                    const target = this.roughPointer || (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(this.entity.location);
                    this.updateBuildGridMarker(target);
                    if (force || !this.buildPointer || !(0, $5b68384bc2307256$export$8b521e8d432acfa6)(this.buildPointer, target)) {
                        this.buildPointer = {
                            ...target
                        };
                        this.requestBuildPreview(target);
                    }
                    return;
                }
            }
            const item = this.placementItem();
            if (item && !this.locationPick) {
                if (this.placementPointer?.level !== undefined && !this.placementStoreyViews().some((view)=>view.level === this.placementPointer.level)) {
                    const world = this.client.clientGameLogic.clientRenderer.gui().worldPointAtPointer?.();
                    const ladder = [
                        "stairs",
                        "stairs-up"
                    ].includes(item.itemTypeMeta.type) && item.flags?.stairDirection !== "down";
                    this.placementPointer = world ? (ladder ? this.ladderTargetAt(world) : undefined) ?? (0, $6590e3376f1c796a$export$93bcf7afc562b94e)((0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(this.entity.location), (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(world), (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.placement(item.itemTypeMeta).range) : undefined;
                }
                const { x: x, y: y } = this.entity.location;
                const angle = this.entity.movement.angle;
                if (item.id !== this.placementPointerItemId || !this.placementPointer || !this.placementPointerPose || x !== this.placementPointerPose.x || y !== this.placementPointerPose.y || angle !== this.placementPointerPose.angle) {
                    // Aimed by where the player stands: up at the top of a ladder, the next press extends it.
                    this.placementPointer = this.ladderTopAim() ?? (0, $6590e3376f1c796a$export$f52c2d64a4628ea4)(this.entity.location, angle);
                    this.placementAimedByPointer = false;
                }
                this.placementPointerPose = {
                    x: x,
                    y: y,
                    angle: angle
                };
                this.placementPointerItemId = item.id;
                this.updateBuildGridMarker(this.placementPointer);
                this.placementPointerOn = true;
                this.client.clientGameLogic.clientRenderer.gui().createCursorSprite().visible = false;
                const rule = (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.placement(item.itemTypeMeta);
                // Only a build placement asks the server about its cell; anything else is always welcome.
                if (rule.action !== "build") this.buildGridMarker.setVerdict("ready");
                if (rule.action === "build" && this.terrainPointerOn && (force || !this.buildPointer || !(0, $5b68384bc2307256$export$8b521e8d432acfa6)(this.buildPointer, this.placementPointer))) {
                    this.buildPointer = {
                        ...this.placementPointer
                    };
                    this.requestBuildPreview(this.buildPointer);
                }
                return;
            }
            if (this.placementPointerOn) {
                if (this.buildGridMarker) this.buildGridMarker.visible = false;
                if (this.roofOffsetGuide) this.roofOffsetGuide.visible = false;
                this.placementPointerOn = false;
            }
            this.placementPointer = undefined;
            this.placementPointerPose = undefined;
            this.placementPointerItemId = undefined;
            if (!this.terrainPointerOn || !this.entity) return;
            const target = this.roughPointer || (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(this.entity.location);
            this.updateBuildGridMarker(target);
            if (force || !this.buildPointer || !(0, $5b68384bc2307256$export$8b521e8d432acfa6)(this.buildPointer, target)) {
                this.buildPointer = {
                    ...target
                };
                this.requestBuildPreview(target);
            }
        };
        this.updateBuildGridMarker = (target)=>{
            if (!this.buildGridMarker) {
                const marker = new (0, $f982fe860ce57e21$export$7e8a46a1c03ab825)();
                // Keep the target readable even when an existing wall occupies this cell.
                marker.zIndex = 100000.1;
                this.buildGridMarker = marker;
                this.storeyCursorCue = new (0, $f982fe860ce57e21$export$4f74dc6ed96966c4)(marker.body);
            }
            const marker = this.buildGridMarker;
            // The ghost rides the cursor to its next cell, but never into a plan, whose tiles ghost themselves.
            if (this.terrainPointerSprites.size && (this.buildEraseStroke || this.planningBuild() || this.pendingBuilds.has(`${target.x},${target.y}`))) this.clearBuildGhost();
            // What it reshaped around the cell it left is restored at once.
            if (this.buildGhostCell && !(0, $5b68384bc2307256$export$8b521e8d432acfa6)(this.buildGhostCell, target)) this.releaseBuildGhostCell();
            const surface = this.client.clientGameLogic.clientRenderer.map().getTileSurface();
            if (marker.parent !== surface) surface.addChild(marker);
            const item = this.entity?.inventory?.items?.find((item)=>item.active && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(item.itemTypeMeta));
            const roof = this.terrainPointerOn && item && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildType(item.itemTypeMeta) === "roof";
            const upLadder = item && [
                "stairs",
                "stairs-up"
            ].includes(item.itemTypeMeta?.type) && item.flags?.stairDirection !== "down";
            const ladderMap = upLadder ? this.storeyViews().find((view)=>view.level === (target.level ?? this.ownStorey()))?.map : undefined;
            const ladderPick = upLadder ? this.ladderPickFor(target) : undefined;
            const onHatch = !!ladderPick || ladderMap?.getMapDeltaAt(target.x, target.y, "sprite2")?.context?.itemType === "stairs-down";
            // Over the hatch the extension will open, rather than over the flight it ghosts.
            const extension = ladderPick && this.ladderExtensionLayout(target);
            marker.setHint(onHatch ? {
                text: "Extend ladder",
                rise: true,
                cost: 1,
                lift: extension ? Math.max(0, ladderPick.cursor.y - (extension.nextBaseline - (0, $f63a252d2ded274b$export$8c9d52e1a7dbe92a))) : 0
            } : undefined);
            // The cursor outlines the actual placement cell, including the raised roof plane and a roof's raised storey. A
            // wall laid atop a wall leaves it on the cell the pointer picked that wall by, on that wall's storey (a cap, or the
            // top half of a double wall, rather than the wall's own cell); its ghost shows the storey up, where it prints.
            const stacked = target.level !== undefined && !!this.stackPick && (0, $5b68384bc2307256$export$8b521e8d432acfa6)(this.stackPick.target, target);
            const plane = stacked ? target.level - 1 : target.level;
            const cell = stacked && this.stackPick && (0, $5b68384bc2307256$export$8b521e8d432acfa6)(this.stackPick.target, target) ? this.stackPick.at : target;
            const { x: wasX, y: wasY } = marker.position;
            marker.moveTo(ladderPick?.cursor.x ?? cell.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), ladderPick?.cursor.y ?? cell.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (roof ? (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)() : 0) + this.storeyYOffset(plane));
            // Over another half of the same wall, the ghost it carries stays where that wall will print.
            if (this.buildGhostCell && (0, $5b68384bc2307256$export$8b521e8d432acfa6)(this.buildGhostCell, target)) this.terrainPointerSprites.forEach((sprite)=>sprite.position.set(sprite.x + wasX - marker.x, sprite.y + wasY - marker.y));
            // Arrows on its bottom edge: this wall goes atop the wall under the pointer.
            this.storeyCursorCue.update(target.level !== undefined, target.level ?? this.ownStorey(), !onHatch);
            marker.visible = true;
            this.updateBuildingCursor();
            const resize = !this.buildStroke && !this.buildEraseStroke && marker.visible && this.resizeCandidate(target, false);
            if (resize) {
                const { anchor: anchor, endpoint: endpoint } = resize.rectangle;
                this.buildPlacementFeedback.setResizeHandles([
                    anchor,
                    {
                        x: anchor.x,
                        y: endpoint.y
                    },
                    endpoint,
                    {
                        x: endpoint.x,
                        y: anchor.y
                    }
                ], this.areaYOffset(resize.rectangle));
            } else this.buildPlacementFeedback.clearResizeHandle();
            if (roof && !this.roofOffsetGuide) {
                const guide = (0, $f982fe860ce57e21$export$ee41eff74b98381e)(new (0, $gwPoJ.Graphics)(), (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)());
                // Keep the height guide visible over roof previews and pending build ghosts.
                guide.zIndex = 100001;
                guide.interactive = false;
                this.roofOffsetGuide = guide;
            }
            if (this.roofOffsetGuide) {
                const guide = this.roofOffsetGuide;
                if (guide.parent !== surface) surface.addChild(guide);
                guide.position.set((target.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (target.y + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + this.storeyYOffset(target.level));
                guide.visible = !!roof && !this.buildStroke && !this.buildBlockedByStairTravel();
            }
        };
        this.updateBuildingCursor = (hide = false)=>{
            const marker = this.buildGridMarker;
            if (!marker) return;
            if (hide || this.pressedTile || this.buildBlockedByStairTravel() || this.cursorOnGrowingLadder()) {
                marker.visible = false;
                return;
            }
            if (!this.terrainPointerOn) return;
            const gui = this.client.clientGameLogic.clientRenderer.gui();
            marker.visible = !this.buildEraseStroke && this.mouseActionEnabled && !this.isChat && (!this.shapePaletteHeld() || !!this.buildStroke) && !gui.isItemScreenOpen() && !gui.isCommandWheelVisible() && !gui.isChatComposerVisible?.() && !gui.isNamePromptVisible?.();
        };
        this.clearTerrainPointer = ()=>{
            this.buildPlacementFeedback.clearResizeHandle();
            if (this.buildGridMarker) this.buildGridMarker.visible = false;
            if (this.roofOffsetGuide) this.roofOffsetGuide.visible = false;
            this.clearBuildGhost();
            this.updateBuildingCursor(true);
        };
        this.clearBuildGhost = ()=>{
            this.terrainPointerSprites.forEach((sprite)=>{
                sprite.parent?.removeChild(sprite);
                sprite.destroy();
            });
            this.terrainPointerSprites.clear();
            this.releaseBuildGhostCell();
        };
        // The cursor's preview no longer stands at its cell: the tiles it reshaped go back to normal.
        this.releaseBuildGhostCell = ()=>{
            this.reshapeGhosts.release("hover");
            this.buildGhostCell = undefined;
        };
        /**
     * The extension the cursor shows is built: its ghost leaves the cursor and plays the growth in place, the hatch
     * landing with a knock, then gives way to the real ladder once that is drawn.
     */ this.growLadderExtension = (target)=>{
            const ghost = [
                ...this.terrainPointerSprites
            ].find((sprite)=>sprite instanceof (0, $2c4a8005c243ff16$export$6ceac85fc71eba8c) && !sprite.growing);
            if (!ghost || !this.ladderPickFor(target) || ghost.layout.at.x !== target.x || ghost.layout.at.y !== target.y) return;
            const map = this.client.clientGameLogic.clientRenderer.map(), marker = this.buildGridMarker;
            this.terrainPointerSprites.delete(ghost);
            ghost.position.set(ghost.x + marker.x, ghost.y + marker.y);
            map.getTileSurface().addChild(ghost);
            // Sorted like the ladder standing on this storey, so a body in front of it still is; else over everything, as ghosts are.
            const standing = map.getTileArt?.(target.x, target.y, "sprite2") ?? [];
            ghost.zIndex = standing.length ? Math.max(...standing.map((sprite)=>sprite.zIndex)) + 0.01 : 100000;
            const { at: at, level: level, anchored: anchored } = ghost.layout;
            let arrived = false;
            ghost.grow({
                arrived: ()=>{
                    // Drawn, not just loaded: only then does the real art stand where this one does, and can the pointer pick it.
                    const upper = this.storeyMapAt(level + 1);
                    const drawn = anchored || this.placementStoreyViews().some((view)=>view.level === level + 1);
                    if (arrived || !upper || !drawn || !(0, $d67ded9f7782cb88$export$f7609d4936bd82d6)(upper, at)) return arrived;
                    // The hatch the pointer picked has moved up a storey under it: aim again, so it can go on extending.
                    arrived = true;
                    this.reaimBuildPointer();
                    return true;
                },
                dust: this.ladderDust,
                landed: ()=>this.client.clientGameLogic.audio.buildPrinted(1)
            });
            this.ladderGrowths.add(ghost);
        };
        /** Aims the readied placement item at `world`: a ladder's hatch, a raised floor, or the ground, within its reach. */ this.aimPlacementAt = (world)=>{
            const entity = this.entity, item = this.placementItem();
            const origin = (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(entity.location);
            const rule = (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.placement(item.itemTypeMeta);
            const upLadder = [
                "stairs",
                "stairs-up"
            ].includes(item.itemTypeMeta.type) && item.flags?.stairDirection !== "down";
            const target = !world ? this.roughPointer : this.buildingFromLadder() ? this.buildingTargetAt(world) : (upLadder ? this.ladderTargetAt(world) : undefined) ?? (0, $5b68384bc2307256$export$aabe2728fdbf9c1a)(world, this.placementStoreyViews(), this.storeyYOffset) ?? (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(world);
            this.placementPointer = (0, $5b68384bc2307256$export$aa8352a64fa8b594)((0, $6590e3376f1c796a$export$93bcf7afc562b94e)(origin, target, rule.range), target.level);
            if (!(0, $a80d0b17b615d6f7$export$248d38f6296296c5)(this.placementPointer, origin)) {
                clearInterval(this.keyboardAndleAdjustInterval);
                entity.movement.angle = (0, $a80d0b17b615d6f7$export$b363da9ded343252)((0, $a80d0b17b615d6f7$export$afdc8e4f563fbba3)(this.placementPointer), entity.location);
                this.targetKeyboardAngle = entity.movement.angle;
            }
            // Mouse aiming owns this target; only a subsequent move or turn resets it.
            this.placementPointerPose = {
                ...entity.location,
                angle: entity.movement.angle
            };
            this.placementAimedByPointer = true;
        };
        /**
     * At the top of a ladder with a ladder in hand, the hatch it would be extended by: the one under the player's feet,
     * or, perched at the top of the rungs, the one just above. Space then extends it, as a click on that hatch would.
     */ this.ladderTopAim = ()=>{
            const item = this.placementItem();
            if (!item || ![
                "stairs",
                "stairs-up"
            ].includes(item.itemTypeMeta.type) || item.flags?.stairDirection === "down") return undefined;
            const at = (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(this.entity.location), own = this.ownStorey();
            const hatch = (level)=>({
                    x: (at.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: (at.y + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + this.storeyYOffset(level) - 8
                });
            for (const level of this.entity.stairTravel ? [
                own + 1
            ] : [
                own
            ]){
                const target = this.ladderTargetAt(hatch(level));
                if (target?.x === at.x && target.y === at.y) return target.level === own ? {
                    x: at.x,
                    y: at.y
                } : target;
            }
            return undefined;
        };
        /** Whether a growth is carrying the hatch of storey `level` at `at` up, or one above it. */ this.ladderGrowingAt = (at, level)=>[
                ...this.ladderGrowths
            ].some(({ layout: layout })=>layout.at.x === at.x && layout.at.y === at.y && layout.level >= level);
        /** The cursor's cell is a hatch a growth is carrying up: it stands aside until the ladder lands and it is aimed again. */ this.cursorOnGrowingLadder = ()=>!!this.buildPointer && this.ladderGrowingAt(this.buildPointer, this.buildPointer.level ?? this.ownStorey());
        /**
     * The world changed under an aim that kept still (a ladder grew past it): aim again, by the pointer where it is, or
     * by the player's own position and facing if that is what aimed last.
     */ this.reaimBuildPointer = ()=>{
            if (!this.terrainPointerOn || this.buildStroke || this.locationPick || !this.entity) return;
            if (this.placementItem() && !this.placementAimedByPointer) {
                this.placementPointerPose = undefined;
                this.refreshBuildPointer();
                return;
            }
            const world = this.client.clientGameLogic.clientRenderer.gui().worldPointAtPointer?.();
            if (!world) return;
            if (this.placementItem()) this.aimPlacementAt(world);
            this.updatedRoughPointer(this.buildingTargetAt(world));
        };
        /** A plan is laid out (drawn, or counting down to print): its own ghosts are the whole preview. */ this.planningBuild = ()=>!!this.buildStroke || Array.from(this.pendingBuilds.values()).some((pending)=>!pending.committing);
        // Cosmetic feedback for placing a build tile: play the local player's attack (swing) animation.
        // Goes straight to the renderer's animation path (NOT clientGameLogic.attack, which would also
        // start a real server attack + audio), so there's no damage or gameplay effect. Other players
        // are shown the swing immediately through an animation-only server relay.
        this.playBuildSwing = (relay = true)=>{
            if (this.buildGridMarker?.visible) this.buildGridMarker.press();
            if (this.entity) {
                this.client.clientGameLogic.clientRenderer.entity().attack(this.entity);
                if (relay) this.client.playBuildSwing?.(this.entity.roomId);
            }
        };
        // `level`: the storey the server worked the preview out for, when not the player's own.
        this.updateTerrainPointer = (deltas, coordinate, blocked = false, illegal = false, previewRevision, itemId, level)=>{
            if (previewRevision !== undefined && previewRevision !== this.buildPreviewRevision) return;
            const target = coordinate ? (0, $5b68384bc2307256$export$aa8352a64fa8b594)(coordinate, level) : this.buildPointer;
            if (!target) return;
            const valid = !blocked && !illegal && !!deltas?.length;
            const pending = this.pendingBuilds.get(`${target.x},${target.y}`);
            // Automatic server previews after a commit lack the pending-neighbour snapshot.
            if (pending && previewRevision === undefined) return;
            if (pending && (!itemId || itemId === pending.itemId) && pending.level === target.level) {
                this.renderPendingBuild(pending, deltas, valid);
                if (pending.groupId !== undefined && !pending.committing) this.startReleasedBuildGroup(pending.groupId);
            }
            if (!this.terrainPointerOn) return;
            if (this.buildEraseStroke) {
                this.refreshBuildPointer();
                return;
            }
            const activeItemId = this.entity.inventory?.items?.find((i)=>i.active && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(i.itemTypeMeta))?.id;
            if (itemId && itemId !== activeItemId) return;
            // A delayed response for another cell must not move the current preview.
            if (!this.buildPointer || !(0, $5b68384bc2307256$export$8b521e8d432acfa6)(target, this.buildPointer)) return;
            this.buildPreview = {
                coordinate: {
                    ...target
                },
                deltas: deltas,
                valid: valid
            };
            this.clearTerrainPointer();
            if (this.pressedTile || this.buildBlockedByStairTravel()) return;
            this.updateBuildGridMarker(target);
            // Out of reach is the one refusal a few steps closer fixes, so it reads apart from a cell that won't take it.
            this.buildGridMarker.setVerdict(valid ? "ready" : blocked && !illegal ? "far" : "blocked");
            // A plan shows its own ghosts and nothing more. Otherwise the one tile a press would plant is
            // ghosted here, drawn exactly as its pending ghost will be, and the tiles it would reshape show their new shape.
            if (!valid || pending || this.planningBuild()) return;
            const marker = this.buildGridMarker;
            const map = this.client.clientGameLogic.clientRenderer.map();
            deltas.forEach((delta)=>{
                if ([
                    "blocking",
                    "skyTrigger"
                ].includes(delta.layerId) || !delta.context?.highZ || delta.context?.previewTarget === false) return;
                const extension = delta.context?.ladderExtension && this.ladderExtensionLayout(target);
                // One ghost per extension, and none for a hatch a growth is already carrying up (the pointer is re-aimed once it lands).
                if (extension && ([
                    ...this.terrainPointerSprites
                ].some((sprite)=>sprite instanceof (0, $2c4a8005c243ff16$export$6ceac85fc71eba8c)) || this.ladderGrowingAt(extension.at, extension.level))) return;
                const sprite = extension ? new (0, $2c4a8005c243ff16$export$6ceac85fc71eba8c)(extension, {
                    ghostAlpha: $319b1dfd90d3ebea$var$BUILD_GHOST_ALPHA
                }) : map.addTileAt(delta.x, delta.y, String(delta.tileSpec.tilePos), delta.layerId, true)?.sprite;
                if (!sprite) return;
                // Carried by the cursor, under its brackets: it hides with it, and moves with it to the next
                // cell at once while that cell's own preview is on its way. It holds steady through the
                // cursor's idle fade, as the reshaped tiles around it must. An extension lays itself out
                // on the surface, storeys included, and shows the ladder already standing at full strength.
                if (extension) sprite.position.set(sprite.x - marker.x, -marker.y);
                else {
                    sprite.position.set(sprite.x - marker.x, sprite.y + this.storeyYOffset(target.level) - marker.y);
                    sprite.alpha = $319b1dfd90d3ebea$var$BUILD_GHOST_ALPHA;
                }
                marker.addChildAt(sprite, 0);
                this.terrainPointerSprites.add(sprite);
            });
            // Only this storey's own tiles can be hidden for their new shape.
            this.buildGhostCell = {
                ...target
            };
            if (target.level === undefined) this.reshapeGhosts.claim("hover", deltas);
        };
        this.enabledMouseAction = (enabled)=>{
            this.mouseActionEnabled = enabled;
            this.updateBuildingCursor(!enabled);
            if (!enabled) {
                if (this.buildEraseStroke) {
                    this.buildEraseStroke.last = undefined;
                    this.buildPlacementFeedback.clearEraseTarget();
                }
                if (this.mouseAttackHeld) this.stopFiring();
                // Whatever took the world's mouse away (a modal, a dialog) also took the pointer the
                // pick was waiting on, and respondToMouse stops running -- a reticle left up would just
                // hang wherever it was.
                this.cancelLocationPick();
            }
        };
        // Briefly suppress click-to-attack (strike / ranged / build). Called right after an interaction
        // is activated so the same press — or a rapid follow-up tap on the same entity (open then close a
        // chest) — can't fall through to a world attack. Needed because the attack click comes from a
        // document-level mousedown, which can't see that the press was claimed by an entity.
        /** A DOM control owns this interaction: cancel a held/charged attack without firing it. */ this.cancelAttackForUi = ()=>{
            this.suppressAttack();
            this.stopFiring();
        };
        this.suppressAttack = (durationMs = 300)=>{
            this.suppressAttackUntilTs = Date.now() + durationMs;
        };
        /**
     * The entity under the pointer -- never YOURSELF.
     *
     * Hovering something is read as "you mean that creature, not the ground under it": it suppresses
     * the melee strike on an adjacent entity tile and sends a click to walk at the thing instead. Your
     * own sprite is an entity like any other, so standing on top of what you are trying to hit turned
     * every click into a no-op -- the strike was suppressed in favour of auto-travelling to yourself,
     * which goes nowhere and swings at nothing. Long grass is exactly where that bites: it does not
     * block, so you walk INTO a clump to reach it, which puts your own body under the cursor and makes
     * the grass uncuttable for as long as you stand there.
     *
     * Filtered here rather than at each use so auto-travel and the interaction wheel get it too; there
     * is nothing anywhere that wants to target the person doing the targeting.
     */ this.setHoveredEntity = (entityId)=>{
            this.hoveredEntity = entityId === this.entity?.entityId ? undefined : entityId;
        };
        this.unHoveredEntity = (entityId)=>{
            // Only clear if this is still the hovered entity. When the pointer moves
            // straight from one entity to another, the new entity's mouseover can run
            // before the old entity's mouseout; an unconditional clear would then wipe the
            // freshly-set hover and break click auto-travel.
            if (this.hoveredEntity === entityId) this.hoveredEntity = undefined;
        };
        // Called when a hovered entity is removed or culled out of range. Releases the hover reference
        // and re-enables world mouse actions so they can't stay stuck disabled if the entity vanished
        // mid-press, and drops any press being arbitrated against it -- an entity that no longer exists
        // will never send the pointer-up that would otherwise resolve or cancel its press.
        this.clearHoverForEntity = (entityId)=>{
            this.cancelEntityPress(entityId);
            if (this.hoveredEntity === entityId) {
                this.hoveredEntity = undefined;
                this.mouseActionEnabled = true;
            }
        };
        this.isMouseActionEnabled = ()=>this.mouseActionEnabled;
        this.enabledKeyboardAction = (enabled)=>{
            this.keyboardActionEnabled = enabled;
        };
        /**
     * Lock the player out of moving for `timeout`, or let them go again.
     *
     * THE LOCK IS A DEADLINE, not a timer, because the same screen transition raises it twice. A
     * teleport with a scene change asks for a long lock up front (the dissolve, the dark, the fade
     * back in) and then `ServerGameLogic.teleportEntity` sends its own plain fade-out when the move
     * actually happens -- and that one's default 1000ms used to expire FIRST and hand movement back
     * in the middle of a 1.5s dark hold. Keeping the furthest deadline means a later, shorter request
     * can never shorten a longer one; it can only extend it.
     */ this.paralyze = (value, timeout = 1000)=>{
            if (!value) {
                this.paralyzedUntilTs = 0;
                this.paralyzed = false;
                return;
            }
            this.paralyzed = true;
            const until = Date.now() + timeout;
            if (until <= this.paralyzedUntilTs) return;
            this.paralyzedUntilTs = until;
            setTimeout(()=>{
                // Only the request that owns the current deadline may lift it.
                if (Date.now() >= this.paralyzedUntilTs) {
                    this.paralyzed = false;
                    this.paralyzedUntilTs = 0;
                }
            }, timeout);
        };
        // Mirrors the server's DOWNED verdict. Every world-state message for this player carries it,
        // so it clears itself the moment the server stops saying it -- there is no client-side timer
        // to get out of step with, and nothing here that can hold a player down on its own.
        this.setDowned = (value)=>{
            if (value === this.downed) return;
            this.downed = value;
            if (value) {
                this.cancelLocationPick();
                const { entity: entity } = this;
                entity.movement.moving = false;
                entity.speed2.x = 0;
                entity.speed2.y = 0;
                this.targetSpeed2 = {
                    x: 0,
                    y: 0
                };
                this.joystickSpeed2 = null;
                clearInterval(this.autoMovingInterval);
                this.setAutoMoving(false);
            }
        };
        this.fireBullet = ()=>{
            this.client.fireBullet();
        };
        this.selectSlot = (itemId)=>{
            this.client.clientGameLogic.selectSlot(itemId);
        };
        this.activeAbility = (shortcutKey)=>{
            this.client.activateAbility(shortcutKey);
        };
        this.isGuest = ()=>this.guest;
        this.setIsGuest = (guest)=>{
            this.guest = guest;
        };
        this.updateLongRangedEquippedState = (equipped)=>{
            if (this.longRangedEquipped !== equipped) {
                this.longRangedEquipped = equipped;
                const mouseSprite = this.client.clientGameLogic.clientRenderer.gui().createCursorSprite();
                if (!equipped && mouseSprite) mouseSprite.visible = false;
            }
        };
        this.updateTerrainPointerOn = (on)=>{
            this.mobileBuildDragging = false;
            // Changing equipment ends the gesture, while its original material keeps printing.
            this.releasePendingBuilds();
            this.buildPreviewRevision++;
            this.buildPreview = undefined;
            this.terrainPointerOn = on;
            this.buildPointer = undefined;
            this.stopFiring();
            this.refreshPendingPreviews();
            if (on) {
                this.refreshBuildPointer(true);
                this.client.clientGameLogic.clientRenderer.gui().createCursorSprite().visible = false;
            } else this.clearTerrainPointer();
        };
        // ---- location pick ---------------------------------------------------------------------------
        // "Click a spot on the ground, then do something with it." The defender's "Hold Position" order
        // is the first user: the wheel selects the order, this chooses the post, and only then does the
        // command go to the server (see GuiManager's onCommandSelect).
        //
        // The gesture deliberately sits at the same level as build mode rather than inside the command
        // wheel: both take the pointer away from attacking for one press, both are backed out of with
        // Escape, and both have to hold back the entity-press arbitration while they are armed.
        this.beginLocationPick = (request)=>{
            // Build mode and a location pick both own the pointer. The newer intent wins, and build mode
            // has to be ENDED server-side too, not just visually dropped (see the Escape path).
            if (this.terrainPointerOn) {
                this.updateTerrainPointerOn(false);
                this.client.clientGameLogic.cancelBuildPlacement();
            }
            // A press already being arbitrated against an entity would turn into an attack under the
            // reticle when its hold timer fired. Arming the pick ends it.
            this.releaseEntityPress();
            this.locationPick = request;
            const gui = this.client.clientGameLogic.clientRenderer.gui();
            const cursorSprite = gui.createCursorSprite();
            if (cursorSprite) cursorSprite.visible = false;
            gui.showLocationPicker(request.caption, request.blockedCaption);
            gui.setLocationPickerBlocked(!this.locationPickable());
            // The press that picked the order off the command wheel is still travelling through the
            // document-level mouse listeners (pixi's pointerdown on the wheel runs first). Without this
            // it would arrive here as the pick itself and post the NPC under the wheel slice.
            this.suppressAttack();
        };
        this.cancelLocationPick = ()=>{
            if (!this.locationPick) return;
            this.locationPick = undefined;
            this.client.clientGameLogic.clientRenderer.gui().hideLocationPicker();
        };
        this.isPickingLocation = ()=>!!this.locationPick;
        // The fine world coordinate under the pointer. Asked of the GUI rather than read off
        // `this.pointer`: keyboard facing can clear that cached combat target.
        this.locationPickTarget = ()=>this.client.clientGameLogic.clientRenderer.gui().worldPointAtPointer();
        // Could an NPC actually stand where the pointer is? A post inside a wall would leave the NPC
        // walking into it forever, so blocked ground is refused at the click instead of being sent and
        // quietly ignored -- and the reticle says so in red before the player commits to it.
        this.locationPickable = ()=>{
            const point = this.locationPickTarget();
            if (!point) return false;
            const tilemap = this.client.clientGameLogic.tilemapMetaProvider;
            if (!tilemap) return false;
            const rough = (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(point);
            if (rough.x < 0 || rough.y < 0 || rough.x >= tilemap.width() || rough.y >= tilemap.height()) return false;
            return !tilemap.isCollisionAt(rough.x, rough.y);
        };
        this.completeLocationPick = ()=>{
            const request = this.locationPick;
            if (!request) return;
            const point = this.locationPickTarget();
            if (!point || !this.locationPickable()) // A click on ground nothing can stand on is not an answer. Stay armed so the player can
            // just click somewhere else -- the reticle is already red, so it isn't a silent refusal.
            return;
            this.cancelLocationPick();
            request.onPick((0, $a80d0b17b615d6f7$export$59e9cfed91f93f03)(point));
        };
        this.mobileBuildingState = ()=>{
            const item = this.entity?.inventory?.items?.find((i)=>i.active && i.quantity > 0 && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(i.itemTypeMeta));
            return {
                available: !!item,
                active: (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() && this.terrainPointerOn,
                tool: this.mobileBuildTool,
                canUndo: Array.from(this.pendingBuilds.values()).some((p)=>!p.committing),
                material: item?.itemType || "Material"
            };
        };
        this.buildFeedbackOffset = ()=>{
            const item = this.entity?.inventory?.items?.find((i)=>i.active && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(i.itemTypeMeta));
            return item && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildType(item.itemTypeMeta) === "roof" ? (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)() : 0;
        };
        /** Pick existing surfaces, promote floors above walls, and extend adjacent ceilings. A stroke keeps its starting level. */ this.buildingTargetAt = (world)=>{
            const target = this.pickBuildingTargetAt(world);
            // Helpers use the lowest supplied storey as their default plane. On a ladder
            // that is the ground, even when the player's simulation room is higher up.
            return this.buildingFromLadder() ? (0, $5b68384bc2307256$export$aa8352a64fa8b594)(target, target.level ?? this.placementStoreyViews()[0].level) : target;
        };
        this.pickBuildingTargetAt = (world)=>{
            const lift = this.buildFeedbackOffset();
            const base = this.buildingFromLadder() ? this.placementStoreyViews()[0].level : this.ownStorey();
            const plain = (0, $5b68384bc2307256$export$aa8352a64fa8b594)((0, $48a973472fff8afa$export$d2107414ce2376d5)(world, lift + this.storeyYOffset(base)), base === this.ownStorey() ? undefined : base);
            const kind = this.storeyBuildKind();
            const ladderItem = this.entity?.inventory?.items?.find((item)=>item.active && [
                    "stairs",
                    "stairs-up"
                ].includes(item.itemTypeMeta?.type) && item.flags?.stairDirection !== "down");
            if (ladderItem && !this.buildStroke) {
                const hatch = this.ladderTargetAt(world);
                if (hatch) return !this.buildingFromLadder() && hatch.level === this.ownStorey() ? {
                    x: hatch.x,
                    y: hatch.y
                } : hatch;
            }
            const stacking = !!this.stackPick;
            this.stackPick = undefined;
            const stroke = this.buildStroke;
            if (stroke?.level !== undefined && kind === "wall" && stacking) {
                this.stackPick = (0, $5b68384bc2307256$export$a2caa11ea356d34f)(world, stroke.level, this.placementStoreyViews(), this.storeyYOffset, this.plannedWallAt);
                return this.stackPick.target;
            }
            if (stroke?.level !== undefined) return (0, $5b68384bc2307256$export$eeefffc66a89867c)(world, stroke.level, this.storeyYOffset, lift + (stroke.pickLift ?? 0));
            if (stroke) return plain;
            this.buildPickLift = 0;
            if (kind === "wall") {
                this.stackPick = (0, $5b68384bc2307256$export$5e32782cbcd2e44c)(world, this.placementStoreyViews(), this.storeyYOffset, !this.stackHeld(), this.plannedWallAt);
                if (this.stackPick) return this.stackPick.target;
            }
            // Pick on the destination plane so cursor, ghost and printed floor all stay under the pointer.
            if (kind === "floor" && this.stackHeld()) return (0, $5b68384bc2307256$export$8ea604f91abb6f7)(world, this.placementStoreyViews(), this.storeyYOffset);
            const surface = (0, $5b68384bc2307256$export$aabe2728fdbf9c1a)(world, this.placementStoreyViews(), this.storeyYOffset);
            const roofVisible = this.client.clientGameLogic.clientRenderer.map().isRoofVisibleForPlacement?.() ?? true;
            if (kind === "floor") {
                const views = this.placementStoreyViews();
                const aboveWall = (0, $5b68384bc2307256$export$3996d12f5871c95c)(world, views, this.storeyYOffset, (point, level)=>{
                    const pending = this.pendingBuilds.get(`${point.x},${point.y}`);
                    if (!pending?.valid || pending.unfunded || (pending.level ?? this.ownStorey()) !== level) return false;
                    const item = this.entity.inventory?.items?.find((item)=>item.id === pending.itemId);
                    return !!item && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildType(item.itemTypeMeta) === "floor";
                });
                const aboveRoof = (0, $5b68384bc2307256$export$6c0baffa48b2846c)(world, views, this.storeyYOffset, (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)(), roofVisible);
                // A side column shares its lower rail with the corner below. That corner's finished
                // floor must not hide the uncovered side wall, but ordinary finished floors still win.
                const wallLevel = aboveWall && aboveWall.level - 1;
                const wallMap = aboveWall && views.find((view)=>view.level === wallLevel)?.map;
                const wallCell = aboveWall && (0, $5b68384bc2307256$export$eeefffc66a89867c)(world, wallLevel, this.storeyYOffset);
                const owner = wallMap?.getMapDeltaAt?.(wallCell.x, wallCell.y, "sprite")?.context?.parent;
                const coveredRail = aboveWall && surface && aboveWall.level === surface.level && owner?.x === surface.x && owner?.y === surface.y && (owner.x !== aboveWall.x || owner.y !== aboveWall.y);
                const direct = (coveredRail ? [
                    aboveWall,
                    aboveRoof,
                    surface
                ] : [
                    surface,
                    aboveRoof,
                    aboveWall
                ]).filter((target)=>!!target).sort((a, b)=>(b.level ?? base) - (a.level ?? base))[0];
                const target = direct ?? (0, $5b68384bc2307256$export$a1e3993e6cfdfa04)(world, kind, views, this.storeyYOffset, (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)(), roofVisible) ?? plain;
                if (target.level !== undefined) this.buildPickLift = ((0, $5b68384bc2307256$export$eeefffc66a89867c)(world, target.level, this.storeyYOffset).y - target.y) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                return target;
            }
            if (surface) return surface;
            if (kind === "wall") return (0, $5b68384bc2307256$export$6c0baffa48b2846c)(world, this.placementStoreyViews(), this.storeyYOffset, (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)(), roofVisible) ?? plain;
            if (kind === "roof") return (0, $5b68384bc2307256$export$6ceade788b3368a2)(world, this.placementStoreyViews(), this.storeyYOffset, lift) ?? (0, $5b68384bc2307256$export$a1e3993e6cfdfa04)(world, kind, this.placementStoreyViews(), this.storeyYOffset, lift, roofVisible) ?? plain;
            return plain;
        };
        /** Unresolved plans reserve their cell too; rejected or unfunded plans do not block a correction. */ this.plannedWallAt = (point, level)=>{
            const pending = this.pendingBuilds.get(`${point.x},${point.y}`);
            if (!pending || pending.unfunded || pending.previewResolved && !pending.valid || (pending.level ?? this.ownStorey()) !== level) return false;
            const item = this.entity.inventory?.items?.find((item)=>item.id === pending.itemId);
            return !!item && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildType(item.itemTypeMeta) === "wall" && !(0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[item.itemTypeMeta.type]?.ornament;
        };
        /** Shift raises walls or selects the next floor plane (desktop, outside chat). */ this.stackHeld = ()=>!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() && !this.isChat && !!this.isKeyOn("Shift");
        /** Aims the build cursor again at the pointer where it rests, as Shift flips it onto and off the top of a wall. */ this.retargetBuildPointer = ()=>{
            if (!this.terrainPointerOn || this.buildStroke || this.buildEraseStroke || (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) return;
            const world = this.client.clientGameLogic.clientRenderer.gui().worldPointAtPointer?.();
            if (world) this.updatedRoughPointer(this.buildingTargetAt(world));
        };
        /** The active structural build type that can target another storey (a window only marks a wall). */ this.storeyBuildKind = ()=>{
            const item = this.entity?.inventory?.items?.find((i)=>i.active && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(i.itemTypeMeta));
            const buildType = item && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildType(item.itemTypeMeta);
            if (buildType === "roof" || buildType === "floor") return buildType;
            return buildType === "wall" && !(0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[item.itemTypeMeta.type]?.ornament ? "wall" : undefined;
        };
        /** The storey the player stands on; 0 is the ground. */ this.ownStorey = ()=>this.client.clientGameLogic.tilemapMetaProvider?.twoStoreyHouse?.floor ?? 0;
        /** How far storey `level` is drawn from the player's own; up is negative. */ this.storeyYOffset = (level)=>level === undefined ? 0 : -(level - this.ownStorey()) * (0, $2751e0027a1b432f$export$de62489b685ceb);
        this.buildingFromLadder = ()=>!!this.entity?.stairTravel?.climb || !!this.client.clientGameLogic.tilemapMetaProvider?.isStairAt?.(Math.floor(this.entity.location.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.floor(this.entity.location.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)));
        /** The player's storey and each one linked above it, lowest first. */ this.storeyViews = ()=>{
            const views = [];
            const seen = new Set();
            let level = this.ownStorey();
            let first = this.client.clientGameLogic.tilemapMetaProvider;
            if (this.buildingFromLadder()) {
                const belowSeen = new Set();
                while(level > 0 && first?.getFloorSupportProvider?.() && !belowSeen.has(first)){
                    belowSeen.add(first);
                    first = first.getFloorSupportProvider();
                    level--;
                }
            }
            for(let map = first; map && !seen.has(map); map = map.getUpperFloorProvider?.()){
                seen.add(map);
                views.push({
                    level: level,
                    map: map
                });
                level++;
            }
            return views;
        };
        /** A visible interior hatch can belong to an endpoint on a cut-away upper storey. */ this.ladderTargetAt = (world)=>{
            this.ladderPick = undefined;
            return (0, $5b68384bc2307256$export$f57c57f6601f6ca8)(world, this.storeyViews(), this.storeyYOffset, {
                onPick: (target, cursor, hatch)=>{
                    this.ladderPick = {
                        target: target,
                        cursor: cursor,
                        hatch: hatch
                    };
                },
                visibleLevels: new Set(this.placementStoreyViews().map((view)=>view.level)),
                ceilingHeight: (view, at)=>{
                    const map = view.map;
                    if (typeof map.resolveTileMeta !== "function" || typeof map.getUpperFloorProvider !== "function") return undefined;
                    const state = (0, $f63a252d2ded274b$export$6d09a325ee084aba)(map, at);
                    return state?.ceiling ? Math.max(state.height, (0, $968cce787b06be95$export$64292ccd7650dcfd)) : undefined;
                }
            });
        };
        /** The hatch the pointer picked `target` by, when it aimed a ladder extension. */ this.ladderPickFor = (target)=>{
            const pick = this.ladderPick;
            return pick && pick.target.x === target.x && pick.target.y === target.y && pick.target.level === (target.level ?? this.ownStorey()) ? pick : undefined;
        };
        /** A storey's map, when it is a live one (not a bare view) that a ladder's art can be read from. */ this.storeyMapAt = (level)=>{
            const map = this.storeyViews().find((view)=>view.level === level)?.map;
            return map && typeof map.getUpperFloorProvider === "function" && typeof map.resolveTileMapFromLayerId === "function" ? map : undefined;
        };
        /**
     * Where the server will draw the ladder extended from the hatch `target` was picked by, on this map's
     * surface: the hatch's storey grows a full flight, and a new hatch opens on the storey above.
     */ this.ladderExtensionLayout = (target)=>{
            const pick = this.ladderPickFor(target);
            if (!pick) return undefined;
            const at = {
                x: pick.target.x,
                y: pick.target.y
            }, level = pick.target.level;
            // A cutaway hides the storeys the flight really reaches: the new one is shown standing on the hatch it draws.
            if (pick.hatch === "ceiling") {
                const baseline = pick.cursor.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 + (0, $f63a252d2ded274b$export$8c9d52e1a7dbe92a) / 2;
                return {
                    at: at,
                    level: level,
                    baseline: baseline,
                    nextBaseline: baseline - (0, $2751e0027a1b432f$export$de62489b685ceb),
                    standing: 0,
                    opening: true,
                    anchored: true
                };
            }
            const baselineOf = (storey)=>(at.y + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + this.storeyYOffset(storey);
            const own = this.storeyMapAt(level), below = this.storeyMapAt(level - 1);
            // The first ladder still wears its original, taller artwork: extended, it is redrawn as the flight's foot.
            const freestanding = !!below && !!(0, $d67ded9f7782cb88$export$f7609d4936bd82d6)(below, at, "up") && !(0, $f63a252d2ded274b$export$6d09a325ee084aba)(below, at);
            return {
                at: at,
                level: level,
                baseline: baselineOf(level),
                nextBaseline: baselineOf(level + 1),
                standing: own && (0, $f63a252d2ded274b$export$6d09a325ee084aba)(own, at)?.kind === "top" ? (0, $f63a252d2ded274b$export$eb08c2609b220aee) : 0,
                opening: !!own && (0, $f63a252d2ded274b$export$49a6d3e52bbd6209)(own, at),
                ...freestanding ? {
                    foot: {
                        baseline: baselineOf(level - 1)
                    }
                } : {}
            };
        };
        /** Hidden companion floors still simulate, but cannot intercept a placement in the visible room. */ this.placementStoreyViews = ()=>{
            const views = this.storeyViews();
            const drawn = this.client.clientGameLogic.clientRenderer.map().drawnStoreys?.();
            return drawn ? views.filter((view)=>view.level === this.ownStorey() || this.buildingFromLadder() && view.level === views[0].level || drawn.some((storey)=>storey.level === view.level)) : views;
        };
        this.pendingYOffset = (pending)=>(pending.roof ? (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)() : 0) + this.storeyYOffset(pending.level);
        this.areaYOffset = (area)=>this.pendingYOffset(area);
        this.setMobileBuildMode = (on)=>{
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() || on && !this.mobileBuildingState().available) return;
            this.endMobileBuildTouch();
            this.cancelLocationPick();
            this.updateTerrainPointerOn(on);
            this.suppressAttack();
        };
        this.selectMobileBuildTool = (tool)=>{
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) return;
            this.endMobileBuildTouch();
            this.mobileBuildTool = tool;
            this.suppressAttack();
        };
        this.undoMobileBuild = ()=>{
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) return;
            this.endMobileBuildTouch();
            this.undoLatestBuild();
        };
        this.beginMobileBuildTouch = (coordinate, world)=>{
            const gui = this.client.clientGameLogic.clientRenderer.gui();
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() || !this.terrainPointerOn || this.isChat || this.paralyzed || this.downed || this.entity.isDead() || gui.isRolePickerVisible?.() || gui.isItemScreenOpen() || gui.isCommandWheelVisible() || gui.isChatComposerVisible?.() || gui.isNamePromptVisible?.()) return false;
            // Finished tiles own their context hold before building can place over them. Pending
            // previews still belong to the build tools, including tap-to-remove and resizing.
            if (!this.pendingBuildAtPointer(coordinate) && this.beginTilePress(world ? (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(world) : coordinate, "touch", 0, world)) return true;
            this.mobileBuildDragging = true;
            this.roughPointer = {
                ...coordinate
            };
            this.refreshBuildPointer(true);
            if (this.beginBuildEdit(coordinate)) return true;
            const key = `${coordinate.x},${coordinate.y}`;
            const pending = this.pendingBuilds.get(key);
            if (pending && this.mobileBuildTool !== "single") // Shape tools remove a tapped preview; freehand uses the desktop toggle-and-drag path.
            {
                if (!pending.committing) {
                    this.removePendingBuild(key, true, true);
                    this.refreshBuildPointer(true);
                }
            } else {
                this.isFiring = true;
                this.startWorldAction();
            }
            return true;
        };
        this.moveMobileBuildTouch = (coordinate, world)=>{
            this.moveTilePress(world ? (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(world) : coordinate, world);
            if (!this.mobileBuildDragging) return;
            this.roughPointer = {
                ...coordinate
            };
            // Freehand and shape tools share the desktop grid traversal, including sparse touch moves.
            this.updatedRoughPointer(coordinate);
        };
        this.endMobileBuildTouch = ()=>{
            this.cancelTilePress();
            if (!this.mobileBuildDragging) return;
            this.mobileBuildDragging = false;
            this.releasePendingBuilds();
            this.stopFiring();
        };
        this.isBuilding = ()=>this.terrainPointerOn;
        this.builderActivation = (on)=>{
            this.updateTerrainPointerOn(on);
        };
        this.restoreBuildingEquipment = ()=>{
            if (this.buildingEquipmentRestored) return;
            this.buildingEquipmentRestored = true;
            // Login restores equipment through the inventory snapshot, without an equip action.
            // Do this once per controller so later snapshots don't reset a pending stroke.
            const equipped = this.entity.inventory?.items?.some((item)=>item.active && item.quantity > 0 && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(item.itemTypeMeta));
            if (equipped && !this.terrainPointerOn) this.builderActivation(true);
        };
        this.manualAttack = (isMoving)=>{
            if (this.entity.weapon?.profileId && !this.terrainPointerOn) {
                this.setAttackHeld(true);
                return;
            }
            const consumable = this.entity.inventory?.items?.find((item)=>item.active && item.readied && item.quantity > 0 && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.primaryUseable(item.itemTypeMeta));
            if (consumable) {
                const now = Date.now();
                if (this.lastPrimaryItemUseTs !== undefined && now - this.lastPrimaryItemUseTs < (0, $cb689cfa16c444ba$export$6e47733a887561b3).none.firingLatchMs) return;
                this.lastPrimaryItemUseTs = now;
                // Accepted item use relays its own cosmetic swing from the server.
                this.playBuildSwing(false);
                if ((0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.placement(consumable.itemTypeMeta)) {
                    this.refreshBuildPointer();
                    this.client.inventoryAction(this.entity.entityId, consumable.id, "primary-use", this.placementPointer);
                } else this.client.inventoryAction(this.entity.entityId, consumable.id, "primary-use");
                return;
            }
            if (this.terrainPointerOn) {
                if (this.buildEraseStroke || this.buildPrimarySuppressed) return;
                this.placeBuildTile();
                return;
            }
            (0, $5UG8I.logger).info({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `manualAttack: Spacebar pressed, isMoving=${isMoving}`);
            const useMousePointer = Date.now() - this.lastMouseMoveTs < 150;
            const collisionCheck = (0, $a80d0b17b615d6f7$export$7758e9150891e0a1)(this.entity.location, this.entity.movement.angle, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            if (this.client.clientGameLogic.tilemapMetaProvider.isCollisionAt((0, $a80d0b17b615d6f7$export$b240a5f8651dffb4)(collisionCheck.x), (0, $a80d0b17b615d6f7$export$b240a5f8651dffb4)(collisionCheck.y))) {
                (0, $5UG8I.logger).info({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `manualAttack: Collision detected, firing bullet directly`);
                this.client.fireBullet();
                return;
            }
            if (isMoving || this.clickToMoveDisabled()) {
                (0, $5UG8I.logger).info({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `manualAttack: Firing from current position (use Shift key for boost)`);
                this.client.fireBullet();
                return;
            }
            (0, $5UG8I.logger).info({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `manualAttack: Player not moving, scheduling auto-travel`);
            const distance = this.longRangedEquipped ? 0 : (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 1.5;
            const thePoint = useMousePointer ? (0, $a80d0b17b615d6f7$export$4a09470303eb5fc5)(this.entity.location, this.pointer, distance) : (0, $a80d0b17b615d6f7$export$7758e9150891e0a1)(this.entity.location, this.entity.movement.angle, distance);
            this.scheduleAutoTravelToPoint(thePoint, ()=>{
                this.client.fireBullet();
            }, false);
        };
        this.setAutoMoving = (moving)=>{
            this.isAutoMoving = moving;
        };
        this.clickToMoveDisabled = ()=>this.client.clientGameLogic.clientRenderer.map?.()?.getVisibility()?.suppressClickToMove === true;
        this.joystickBoostHeld = false;
        // The mobile joystick's held movement intent, as the same per-axis -1/0/1 vector a WASD
        // combination produces, or null when the thumb is off the stick. updatePlayerVelocity treats
        // it exactly like a held key. See GuiManager.setupJoystick for why it must be latched rather
        // than written straight onto entity.speed2.
        this.setJoystickIntent = (intent)=>{
            const wasHeld = this.joystickSpeed2 !== null;
            if (intent && (intent.x !== this.joystickSpeed2?.x || intent.y !== this.joystickSpeed2?.y)) this.manualClimbId = this.climbId();
            this.joystickSpeed2 = intent;
            if (intent && !wasHeld) {
                // Started moving: take over from any auto-travel and start the same 700ms-then-inertia
                // ramp the keyboard path starts, so both input sources feel the same.
                clearInterval(this.autoMovingInterval);
                this.setAutoMoving(false);
                this.movementStartTime = Date.now();
                this.isSustainedMovement = false;
            }
        };
        this.scheduleAutoTravelToEntity = (entity, travelCallback)=>{
            if (!entity || this.clickToMoveDisabled()) return false;
            if (this.autoMovingInterval) clearInterval(this.autoMovingInterval);
            const { entity: playerEntity } = this;
            const distance = (0, $cb689cfa16c444ba$export$9d23471d635d220b)(playerEntity, entity);
            const tooClose = distance < 24;
            const tooFar = distance > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2;
            if (!tooClose && !tooFar) {
                // console.log("distance", distance)
                this.autoTravelToEntity(entity, travelCallback);
                return true;
            }
            return false;
        };
        this.scheduleAutoTravelToPoint = (point, travelCallback, restricted = true)=>{
            if (!point || this.clickToMoveDisabled()) return false;
            if (this.autoMovingInterval) clearInterval(this.autoMovingInterval);
            const { entity: playerEntity } = this;
            const distance = (0, $cb689cfa16c444ba$export$79376507b09a66f)(point.x, point.y, playerEntity.location.x, playerEntity.location.y);
            const tooClose = distance < 24;
            const tooFar = distance > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2;
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `scheduleAutoTravelToPoint: distance=${distance}, tooClose=${tooClose}, tooFar=${tooFar}, restricted=${restricted}`);
            if (!restricted || !tooClose && !tooFar) {
                (0, $5UG8I.logger).info({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `Starting auto-travel to point (${point.x}, ${point.y}) from (${playerEntity.location.x}, ${playerEntity.location.y})`);
                this.autoTravelTo(point, travelCallback);
                return true;
            }
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Auto-travel blocked: tooClose=${tooClose}, tooFar=${tooFar}`);
            return false;
        };
        this.autoTravelToEntity = (entity, arriveCallback)=>{
            const targetCoordinate = (0, $a80d0b17b615d6f7$export$7d94067f6d99210b)(entity.location);
            return this.autoTravelTo(targetCoordinate, arriveCallback);
        };
        this.autoTravelTo = (targetCoordinate, arriveCallback)=>{
            if (this.clickToMoveDisabled()) return false;
            const { entity: playerEntity } = this;
            this.setAutoMoving(true);
            this.client.boost(true);
            (0, $5UG8I.logger).info({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `autoTravelTo: Starting travel to (${targetCoordinate.x}, ${targetCoordinate.y}) from (${playerEntity.location.x}, ${playerEntity.location.y}) - CALLBACK EXECUTED IMMEDIATELY`);
            // BUG: This callback is executed immediately, not when arriving!
            arriveCallback();
            let startTs = Date.now();
            this.autoMovingInterval = setInterval(()=>{
                const distance = Math.floor((0, $cb689cfa16c444ba$export$72a3639d5dd4d5f8)(playerEntity.location, targetCoordinate));
                const tooClose = distance < 24;
                const tooFar = distance > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2;
                const isThere = (0, $a80d0b17b615d6f7$export$248d38f6296296c5)(targetCoordinate, playerEntity.location);
                const disabled = this.clickToMoveDisabled();
                if (disabled || tooClose || isThere || tooFar) {
                    (0, $5UG8I.logger).info({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `autoTravelTo: Arrived at destination! distance=${distance}, tooClose=${tooClose}, tooFar=${tooFar}, isThere=${isThere}`);
                    clearInterval(this.autoMovingInterval);
                    this.setAutoMoving(false);
                    this.targetSpeed2 = {
                        x: 0,
                        y: 0
                    };
                    this.client.boost(disabled && !!this.isKeyOn("Shift"));
                    return;
                }
                if (Date.now() - startTs < 200) return;
                // Set target speed2 for auto-travel
                this.targetSpeed2 = {
                    x: 0,
                    y: 0
                };
                if (Math.floor(playerEntity.location.x) > targetCoordinate.x) this.targetSpeed2.x = -1;
                else if (Math.floor(playerEntity.location.x) < targetCoordinate.x) this.targetSpeed2.x = 1;
                if (Math.floor(playerEntity.location.y) > targetCoordinate.y) this.targetSpeed2.y = -1;
                else if (Math.floor(playerEntity.location.y) < targetCoordinate.y) this.targetSpeed2.y = 1;
            }, 5);
        };
        /**
     * The composite under the cursor, as (x, y) -- its PARENT cell, which is the one a strike is
     * aimed at and the only cell of it that carries the entity tile.
     *
     * The test is on that parent rather than on `roughPointer`, and the difference is the whole point
     * of the callback. A plant is taller than the cell it is rooted in: long grass is 1x2 and a tree
     * is bigger still, with the entity tile on the bottom cell and the art drawn over cells the map
     * array holds nothing in. CompositeTileRenderer resolves the art's geometry to its parent
     * without taking pointer events. Previously this asked the map about the cell the cursor was
     * literally over, found it empty, and CLEARED the pointer. So a click on the blades of a clump of
     * grass, or on a tree's canopy, sent no strike at all and fell through to walk-and-shoot: the
     * plant read as something that could not be cut rather than something being missed. Only the one
     * rooting cell worked, which for long grass is the thin strip under the leaves.
     *
     * A composite whose parent carries no entity tile (the decorative grass tufts, say) still clears,
     * which is what the renderer's own mouseout does by passing (-1, -1).
     */ this.updateCompositeTile = (x, y)=>{
            const entityTile = x > -1 && y > -1 ? this.client.clientGameLogic.tilemapMetaProvider.getEntityTileAt(x, y) : undefined;
            if (entityTile) {
                this.roughCompositeTilePointer.x = x;
                this.roughCompositeTilePointer.y = y;
            } else (0, $a80d0b17b615d6f7$export$246e0d97ef73b196)(this.roughCompositeTilePointer);
        };
        /**
     * Dismisses the camp's run hint once the player has actually RUN for a second.
     *
     * Running is the key held AND the body moving; neither alone is the lesson. Measured here rather
     * than on the keydown because that dismissed the hint on a keypress, and Shift is not only the
     * run key -- it opens the building shape palette too, so the hint disappeared unread in front of
     * a player laying their first wall.
     *
     * A satisfied clue is disarmed rather than merely hidden, so this cannot come back on a later
     * wave's countdown, and calling it when no hint is up is harmless. Done locally, with no round
     * trip, so the hint goes the instant it has been earned; the server decides separately whether
     * to raise it at all, from the same threshold in common (Mechanics.entity.speed.runLearnedMs).
     *
     * Time accumulates rather than needing to be unbroken -- see the mechanics constant for why --
     * and the step is clamped, because a backgrounded tab throttles this interval and must not come
     * back having silently banked the whole second.
     */ this.accrueRunHint = (isMoving)=>{
            const threshold = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.speed.runLearnedMs;
            if (this.runHintMs >= threshold) return;
            const now = Date.now();
            const previous = this.runHintLastTs;
            this.runHintLastTs = now;
            if (!isMoving || !this.isKeyOn("Shift")) return;
            // No previous sample means this is the first tick of the run; nothing to credit yet.
            const elapsed = previous > 0 ? Math.min(now - previous, $319b1dfd90d3ebea$var$RUN_HINT_MAX_STEP_MS) : 0;
            this.runHintMs += elapsed;
            if (this.runHintMs >= threshold) this.client.clientGameLogic.clientRenderer.gui()?.tutorialClues()?.satisfyClue("ember-run");
        };
        this.startVelocityUpdates = ()=>{
            const updateInterval = 1000 / (0, $cb689cfa16c444ba$export$21eac3dda76c7241).UPDATE_FPS;
            this.velocityUpdateInterval = setInterval(()=>{
                this.updatePlayerVelocity();
                this.refreshBuildPointer();
                this.animatePendingBuilds();
                this.updateBuildingShapePalette();
                if (this.pendingBuilds.size) this.sharePendingBuilds();
            }, updateInterval);
        };
        this.stopVelocityUpdates = ()=>{
            if (this.velocityUpdateInterval) {
                clearInterval(this.velocityUpdateInterval);
                this.velocityUpdateInterval = null;
            }
        };
        this.updatePlayerVelocity = ()=>{
            if (!this.entity || !(0, $cb689cfa16c444ba$export$21eac3dda76c7241).ENABLED) return;
            // Stop movement if player is dead, downed or paralyzed. This loop OWNS entity.speed2, so
            // it is the one gate every kind of movement intent passes through -- held keys, a parked
            // joystick thumb, an auto-travel in progress.
            if (this.entity.isDead() || this.paralyzed || this.downed) {
                this.entity.speed2.x = 0;
                this.entity.speed2.y = 0;
                this.entity.movement.moving = false;
                return;
            }
            const friction = (0, $cb689cfa16c444ba$export$21eac3dda76c7241).FRICTION;
            const minThreshold = (0, $cb689cfa16c444ba$export$21eac3dda76c7241).MIN_VELOCITY_THRESHOLD;
            const acceleration = (0, $cb689cfa16c444ba$export$21eac3dda76c7241).ACCELERATION;
            // Check if any keys are pressed
            const keyboardMoving = this.isKeyOn("w") || this.isKeyOn("ArrowUp") || this.isKeyOn("s") || this.isKeyOn("ArrowDown") || this.isKeyOn("a") || this.isKeyOn("ArrowLeft") || this.isKeyOn("d") || this.isKeyOn("ArrowRight");
            // A held joystick is a held input too, and it owns the target vector while it is down:
            // its onChange fires only while the thumb actually moves, so nothing else would keep
            // targetSpeed2 current. The keyboard wins if somehow both are active.
            const joystick = this.joystickSpeed2;
            const isMoving = keyboardMoving || joystick !== null;
            this.accrueRunHint(isMoving);
            const staminaRunning = this.client.clientGameLogic.clientRenderer.map?.()?.getVisibility()?.staminaRunning;
            const stickMagnitude = joystick ? Math.max(Math.abs(joystick.x), Math.abs(joystick.y)) : 0;
            const joystickBoost = !!staminaRunning && !keyboardMoving && stickMagnitude > 1;
            if (joystickBoost !== this.joystickBoostHeld) {
                this.joystickBoostHeld = joystickBoost;
                this.client.boost(joystickBoost || !!this.isKeyOn("Shift"));
            }
            if (joystick && !keyboardMoving) {
                // In Ember the server's boosted speed supplies the run multiplier, so an exhausted
                // thumb at the rim walks instead of bypassing stamina with a longer input vector.
                const divisor = staminaRunning ? Math.max(1, stickMagnitude) : 1;
                this.targetSpeed2 = this.entity.afk ? {
                    x: 0,
                    y: 0
                } : {
                    x: joystick.x / divisor,
                    y: joystick.y / divisor
                };
            }
            // Finish the climb after forward input is released. A different key press or stick
            // movement restores manual control for this climb, across the room handoff too.
            if (this.entity.stairTravel?.climb) {
                const automatic = this.manualClimbId !== this.climbId();
                this.entity.speed2 = automatic ? {
                    x: 0,
                    y: this.entity.stairTravel.direction === "up" ? -1 : 1
                } : isMoving ? {
                    ...this.targetSpeed2
                } : {
                    x: 0,
                    y: 0
                };
                // Climbing must never leave walking inertia on the landing.
                this.movementStartTime = 0;
                this.isSustainedMovement = false;
                return;
            }
            // Ember responds immediately even after sustained movement.
            const movementDuration = this.movementStartTime > 0 ? Date.now() - this.movementStartTime : 0;
            const shouldUseInertia = movementDuration > 700 && !this.client.clientGameLogic.clientRenderer.map?.()?.getVisibility()?.suppressMovementInertia;
            if (isMoving) {
                // Update sustained movement state
                if (shouldUseInertia && !this.isSustainedMovement) this.isSustainedMovement = true;
                if (shouldUseInertia) {
                    // Keys are pressed and we've been moving for >1s - smoothly interpolate toward target
                    const diffX = this.targetSpeed2.x - this.entity.speed2.x;
                    const diffY = this.targetSpeed2.y - this.entity.speed2.y;
                    this.entity.speed2.x += diffX * acceleration;
                    this.entity.speed2.y += diffY * acceleration;
                } else {
                    // Keys are pressed but <1s - immediate response
                    this.entity.speed2.x = this.targetSpeed2.x;
                    this.entity.speed2.y = this.targetSpeed2.y;
                }
            } else // No keys pressed
            if (shouldUseInertia && this.isSustainedMovement) {
                // Apply friction to slow down only if we were in sustained movement
                this.entity.speed2.x *= friction;
                this.entity.speed2.y *= friction;
                // Stop movement if below threshold
                const speed = Math.sqrt(this.entity.speed2.x * this.entity.speed2.x + this.entity.speed2.y * this.entity.speed2.y);
                if (speed < minThreshold) {
                    this.entity.speed2.x = 0;
                    this.entity.speed2.y = 0;
                }
            } else {
                // Immediate stop for short movements
                this.entity.speed2.x = 0;
                this.entity.speed2.y = 0;
            }
            // Update movement state
            const speed = Math.sqrt(this.entity.speed2.x * this.entity.speed2.x + this.entity.speed2.y * this.entity.speed2.y);
            this.entity.movement.moving = speed > minThreshold;
        };
        this.destroy = ()=>{
            this.cancelTilePress();
            this.tilePressCue.destroy();
            this.stopFiring();
            this.cancelHeldInteraction();
            document.removeEventListener("wheel", this.respondToBuildShapeWheel);
            window.removeEventListener("blur", this.cancelHeldAttack);
            this.releaseEntityPress();
            this.terrainPointerOn = false;
            this.updateBuildingShapePalette();
            this.clearSharedBuilds();
            this.clearPendingBuilds();
            this.clearTerrainPointer();
            this.reshapeGhosts.clear();
            this.buildPlacementFeedback.destroy();
            this.ladderGrowths.forEach((growth)=>growth.destroy());
            this.ladderGrowths.clear();
            this.ladderDust.clear();
            this.buildGridMarker?.parent?.removeChild(this.buildGridMarker);
            this.buildGridMarker?.destroy({
                children: true
            });
            this.buildGridMarker = undefined;
            this.storeyCursorCue = undefined;
            this.roofOffsetGuide?.parent?.removeChild(this.roofOffsetGuide);
            this.roofOffsetGuide?.destroy();
            this.roofOffsetGuide = undefined;
            // Hand the input back. A reconnect builds a NEW Player (ClientGameLogic.initializePlayer)
            // and the keyboard's listener list is static, so a controller that leaves its listeners
            // behind has every keystroke answered twice from then on -- which reads, in chat, as every
            // character you type appearing twice.
            this.keyboardHandler.removeListener(this.respondToKeyBoard);
            this.keyboardHandler.removePasteListener(this.respondToPaste);
            this.mouseHandler.removeListener(this.respondToMouse);
            this.stopVelocityUpdates();
            if (this.movementDaemon) clearInterval(this.movementDaemon);
            if (this.autoMovingInterval) clearInterval(this.autoMovingInterval);
            if (this.keyboardAndleAdjustInterval) clearInterval(this.keyboardAndleAdjustInterval);
            clearTimeout(this.diagonalReleaseTimer);
            if (this.fireInterval) clearInterval(this.fireInterval);
        };
        this.client = client;
        this.entity = entity;
        this.mouseHandler = mouseHandler;
        this.keyboardHandler = keyboardHandler;
        this.guest = guest;
        keyboardHandler.addListener(this.respondToKeyBoard);
        keyboardHandler.addPasteListener(this.respondToPaste);
        mouseHandler.addListener(this.respondToMouse);
        document.addEventListener("wheel", this.respondToBuildShapeWheel, {
            passive: false
        });
        window.addEventListener("blur", this.cancelHeldAttack);
        // Start velocity update loop
        this.startVelocityUpdates();
    }
}




class $752781dc0ac4b8dc$export$2e2bcd8739ae039 {
    constructor(bounds, max_objects, max_levels, level){
        /**
     * Split the node into 4 subnodes
     */ this.split = ()=>{
            const nextLevel = this.level + 1, subWidth = this.bounds.width / 2, subHeight = this.bounds.height / 2, x = this.bounds.x, y = this.bounds.y;
            //top right node
            this.nodes[0] = new $752781dc0ac4b8dc$export$2e2bcd8739ae039({
                x: x + subWidth,
                y: y,
                width: subWidth,
                height: subHeight
            }, this.max_objects, this.max_levels, nextLevel);
            //top left node
            this.nodes[1] = new $752781dc0ac4b8dc$export$2e2bcd8739ae039({
                x: x,
                y: y,
                width: subWidth,
                height: subHeight
            }, this.max_objects, this.max_levels, nextLevel);
            //bottom left node
            this.nodes[2] = new $752781dc0ac4b8dc$export$2e2bcd8739ae039({
                x: x,
                y: y + subHeight,
                width: subWidth,
                height: subHeight
            }, this.max_objects, this.max_levels, nextLevel);
            //bottom right node
            this.nodes[3] = new $752781dc0ac4b8dc$export$2e2bcd8739ae039({
                x: x + subWidth,
                y: y + subHeight,
                width: subWidth,
                height: subHeight
            }, this.max_objects, this.max_levels, nextLevel);
        };
        /**
     * Determine which node the object belongs to
     */ this.getIndex = (pRect)=>{
            const indexes = [];
            const verticalMidpoint = this.bounds.x + this.bounds.width / 2;
            const horizontalMidpoint = this.bounds.y + this.bounds.height / 2;
            const startIsNorth = pRect.y < horizontalMidpoint;
            const startIsWest = pRect.x < verticalMidpoint;
            const endIsEast = pRect.x + pRect.width > verticalMidpoint;
            const endIsSouth = pRect.y + pRect.height > horizontalMidpoint;
            // Use bitwise operations for better performance
            //top-right quad
            if (startIsNorth && endIsEast) indexes.push(0);
            //top-left quad
            if (startIsWest && startIsNorth) indexes.push(1);
            //bottom-left quad
            if (startIsWest && endIsSouth) indexes.push(2);
            //bottom-right quad
            if (endIsEast && endIsSouth) indexes.push(3);
            return indexes;
        };
        /**
     * Insert the object into the node. If the node
     * exceeds the capacity, it will split and add all
     * objects to their corresponding subnodes.
     */ this.insert = (pRect)=>{
            //if we have subnodes, call insert on matching subnodes
            if (this.nodes.length) {
                const indexes = this.getIndex(pRect);
                for(let i = 0; i < indexes.length; i++)this.nodes[indexes[i]].insert(pRect);
                return;
            }
            //otherwise, store object here
            this.objects.push(pRect);
            //max_objects reached
            if (this.objects.length > this.max_objects && this.level < this.max_levels) {
                //   if we don't already have subnodes
                if (!this.nodes.length) this.split();
                //add all objects to their corresponding subnode
                const objectsToProcess = this.objects;
                this.objects = [] // Clear immediately to free memory
                ;
                for(let i = 0; i < objectsToProcess.length; i++){
                    const indexes = this.getIndex(objectsToProcess[i]);
                    for(let k = 0; k < indexes.length; k++)this.nodes[indexes[k]].insert(objectsToProcess[i]);
                }
            }
        };
        /**
     * Remove the exact rectangle from every leaf containing it. Use its old bounds
     * before changing its position, since rectangles can span multiple nodes.
     */ this.remove = (pRect)=>{
            if (this.nodes.length) {
                for (const index of this.getIndex(pRect))this.nodes[index].remove(pRect);
                return;
            }
            const index = this.objects.indexOf(pRect);
            if (index !== -1) this.objects.splice(index, 1);
        };
        /**
     * Return all objects that could collide with the given object
     */ this.retrieve = (pRect)=>{
            // Early return if no objects in this node
            if (this.objects.length === 0 && this.nodes.length === 0) return [];
            let returnObjects = this.objects;
            //if we have subnodes, retrieve their objects
            if (this.nodes.length) {
                const indexes = this.getIndex(pRect);
                for(let i = 0; i < indexes.length; i++){
                    const subObjects = this.nodes[indexes[i]].retrieve(pRect);
                    if (subObjects.length > 0) returnObjects = returnObjects.concat(subObjects);
                }
            }
            // Use Set for O(1) duplicate removal instead of O(n²) indexOf
            if (returnObjects.length > 1) {
                const seen = new Set();
                const uniqueObjects = [];
                for (const obj of returnObjects)if (!seen.has(obj)) {
                    seen.add(obj);
                    uniqueObjects.push(obj);
                }
                return uniqueObjects;
            }
            return returnObjects;
        };
        /**
     * Clear the quadtree
     */ this.clear = ()=>{
            this.objects = [];
            for(let i = 0; i < this.nodes.length; i++)if (this.nodes.length) this.nodes[i].clear();
            this.nodes = [];
        };
        this.max_objects = max_objects || 10;
        this.max_levels = max_levels || 4;
        this.level = level || 0;
        this.bounds = bounds;
        this.objects = [];
        this.nodes = [];
    }
}



class $aa05461586bc3fba$export$8b098ebd5e242ae7 {
    constructor(entityManager, worldWidth, worldHeight){
        this.cachedVisibleEntities = null;
        this.lastPlayerPos = null;
        this.cacheValid = false;
        // Reprioritize moving visible entities at most four times per second.
        this.SORT_INTERVAL_MS = 250;
        this.prioritiesChanged = false;
        this.visibleEntities = new Map();
        this.MOVEMENT_THRESHOLD = 16 // 16 pixels movement threshold
        ;
        // Entity movement tracking for efficient updates
        this.entityRects = new Map();
        // Performance tracking
        this.cacheHits = 0;
        this.cacheMisses = 0;
        this.totalQueries = 0;
        this.entityManager = entityManager;
        this.worldWidth = worldWidth;
        this.worldHeight = worldHeight;
        // Store bound listeners for proper cleanup
        this.boundUpdateListener = this.onEntityUpdate.bind(this);
        this.boundRemoveListener = this.onEntityRemove.bind(this);
        // Initialize quadtree for the entire world
        this.viewportQuadTree = new (0, $752781dc0ac4b8dc$export$2e2bcd8739ae039)({
            x: 0,
            y: 0,
            width: worldWidth,
            height: worldHeight
        }, 10, 6) // 10 objects per node, 6 levels deep
        ;
        // Register entity listeners for efficient updates
        this.setupEntityListeners();
        // Initial population of quadtree
        this.populateQuadTree();
    }
    setupEntityListeners() {
        // Listen for entity updates to keep quadtree in sync
        this.entityManager.registerSetListener(this.boundUpdateListener);
        this.entityManager.registerRemoveListener(this.boundRemoveListener);
    }
    onEntityUpdate(entity) {
        // Skip entities without valid location or entityId
        if (!entity || !entity.location || !entity.entityId) return;
        const oldRect = this.entityRects.get(entity.entityId);
        const width = entity.dimensions?.w || (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        const height = entity.dimensions?.h || (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        const x = entity.location.x - width / 2;
        const y = entity.location.y - height / 2;
        const moved = !oldRect || oldRect.x !== x || oldRect.y !== y || oldRect.width !== width || oldRect.height !== height;
        if (moved) {
            if (oldRect) this.viewportQuadTree.remove(oldRect);
            this.addEntityToQuadTree(entity);
        }
        const bounds = this.cachedVisibleEntities?.viewportBounds;
        if (!bounds) return;
        const wasVisible = this.visibleEntities.has(entity.entityId);
        const isVisible = this.isEntityInViewport(entity, bounds);
        if (wasVisible !== isVisible) this.invalidateCache();
        else if (isVisible) {
            // Keep the cached references current if an entity object was replaced.
            if (this.visibleEntities.get(entity.entityId) !== entity) this.invalidateCache();
            else if (moved) this.prioritiesChanged = true;
        }
    }
    onEntityRemove(entity) {
        if (!entity?.entityId) return;
        const rect = this.entityRects.get(entity.entityId);
        if (rect) this.viewportQuadTree.remove(rect);
        this.entityRects.delete(entity.entityId);
        if (this.visibleEntities.has(entity.entityId)) this.invalidateCache();
    }
    populateQuadTree() {
        this.viewportQuadTree.clear();
        this.entityRects.clear();
        this.entityManager.iterate(null, (entity)=>this.addEntityToQuadTree(entity));
    }
    addEntityToQuadTree(entity) {
        if (!entity?.location || !entity.entityId) return;
        const width = entity.dimensions?.w || (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        const height = entity.dimensions?.h || (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        const rect = {
            x: entity.location.x - width / 2,
            y: entity.location.y - height / 2,
            width: width,
            height: height,
            entityId: entity.entityId
        };
        this.entityRects.set(entity.entityId, rect);
        this.viewportQuadTree.insert(rect);
    }
    invalidateCache() {
        this.cacheValid = false;
        this.cachedVisibleEntities = null;
    }
    // The renderer uses this to decide whether to replace its cached render list.
    needsVisibleEntitiesRefresh(playerPos) {
        return !this.cacheValid || !this.isCacheStillValid(playerPos);
    }
    getVisibleEntities(playerPos, viewportSize) {
        this.totalQueries++;
        // Check if cache is still valid
        if (!this.needsVisibleEntitiesRefresh(playerPos)) {
            this.cacheHits++;
            return this.cachedVisibleEntities.entities;
        }
        this.cacheMisses++;
        // Calculate viewport bounds
        const viewportBounds = this.calculateViewportBounds(playerPos, viewportSize);
        // Use quadtree to find entities in viewport area - MUCH faster than iterating all entities
        const foundRects = this.viewportQuadTree.retrieve({
            x: viewportBounds.x1 - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2,
            y: viewportBounds.y1 - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2,
            width: viewportBounds.width + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
            height: viewportBounds.height + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
        });
        // Convert rects to entities and filter to actual visible entities
        const entitiesWithDistance = [];
        for (const rect of foundRects){
            if (!rect.entityId) continue;
            const entity = this.entityManager.get(rect.entityId);
            if (!entity) continue;
            // Additional viewport bounds check for precision
            if (this.isEntityInViewport(entity, viewportBounds)) {
                // Calculate distance for sorting
                const dx = entity.location.x - playerPos.x;
                const dy = entity.location.y - playerPos.y;
                const distSquared = dx * dx + dy * dy;
                entitiesWithDistance.push({
                    entity: entity,
                    distSquared: distSquared
                });
            }
        }
        // Sort by distance (closest first)
        entitiesWithDistance.sort((a, b)=>a.distSquared - b.distSquared);
        // Cache the result
        this.cachedVisibleEntities = {
            entities: entitiesWithDistance,
            playerPos: {
                x: playerPos.x,
                y: playerPos.y
            },
            timestamp: Date.now(),
            viewportBounds: viewportBounds
        };
        this.visibleEntities = new Map(entitiesWithDistance.map((next)=>[
                next.entity.entityId,
                next.entity
            ]));
        this.prioritiesChanged = false;
        this.cacheValid = true;
        this.lastPlayerPos = {
            x: playerPos.x,
            y: playerPos.y
        };
        return entitiesWithDistance;
    }
    isCacheStillValid(playerPos) {
        if (!this.cachedVisibleEntities || !this.lastPlayerPos) return false;
        // Static scenes keep their list indefinitely; only moving bodies need reprioritizing.
        if (this.prioritiesChanged && Date.now() - this.cachedVisibleEntities.timestamp >= this.SORT_INTERVAL_MS) return false;
        // Check if player moved significantly
        const dx = Math.abs(playerPos.x - this.lastPlayerPos.x);
        const dy = Math.abs(playerPos.y - this.lastPlayerPos.y);
        return dx <= this.MOVEMENT_THRESHOLD && dy <= this.MOVEMENT_THRESHOLD;
    }
    calculateViewportBounds(playerPos, viewportSize) {
        const X_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportX;
        const Y_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportY - 1;
        // Use provided viewport size or default
        const viewportWidth = viewportSize?.width || X_FACTOR * 2 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $10da07838e6d507c$export$aa707847c2571374).viewportPaddingX * 2;
        const viewportHeight = viewportSize?.height || Y_FACTOR * 2 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $10da07838e6d507c$export$aa707847c2571374).viewportPaddingY * 2;
        // Calculate viewport center
        let viewportCenterX = playerPos.x;
        let viewportCenterY = playerPos.y;
        // Handle edge cases (player at map boundaries)
        const inBoundsX = playerPos.x > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR && playerPos.x < (this.worldWidth - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        const inBoundsY = playerPos.y > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR && playerPos.y < (this.worldHeight - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        if (!inBoundsX) {
            if (playerPos.x <= (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR) viewportCenterX = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR;
            else viewportCenterX = (this.worldWidth - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        }
        if (!inBoundsY) {
            if (playerPos.y <= (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR) viewportCenterY = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR;
            else viewportCenterY = (this.worldHeight - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
        }
        const x1 = viewportCenterX - viewportWidth / 2;
        const y1 = viewportCenterY - viewportHeight / 2;
        const x2 = viewportCenterX + viewportWidth / 2;
        const y2 = viewportCenterY + viewportHeight / 2;
        return {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            width: viewportWidth,
            height: viewportHeight
        };
    }
    isEntityInViewport(entity, viewportBounds) {
        const entityX = entity.location.x;
        const entityY = entity.location.y;
        // Add small padding for entities that might be partially visible
        const padding = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
        return entityX >= viewportBounds.x1 - padding && entityX <= viewportBounds.x2 + padding && entityY >= viewportBounds.y1 - padding && entityY <= viewportBounds.y2 + padding;
    }
    /**
     * Force cache invalidation (useful when world changes)
     */ forceInvalidateCache() {
        this.invalidateCache();
    }
    /**
     * Reset the viewport manager for a new room - clears all data but keeps the instance
     * More efficient than destroying and recreating
     */ reset(newWorldWidth, newWorldHeight) {
        // Update world dimensions if provided
        if (newWorldWidth !== undefined) this.worldWidth = newWorldWidth;
        if (newWorldHeight !== undefined) this.worldHeight = newWorldHeight;
        // Clear all data
        this.viewportQuadTree.clear();
        this.entityRects.clear();
        this.visibleEntities.clear();
        this.prioritiesChanged = false;
        this.cachedVisibleEntities = null;
        this.cacheValid = false;
        this.lastPlayerPos = null;
        // Reset performance counters
        this.cacheHits = 0;
        this.cacheMisses = 0;
        this.totalQueries = 0;
        // Repopulate with current entities
        this.populateQuadTree();
    }
    /**
     * Get performance statistics
     */ getPerformanceStats() {
        const hitRate = this.totalQueries > 0 ? this.cacheHits / this.totalQueries * 100 : 0;
        return {
            cacheHits: this.cacheHits,
            cacheMisses: this.cacheMisses,
            totalQueries: this.totalQueries,
            hitRate: Math.round(hitRate * 100) / 100,
            quadtreeSize: this.entityRects.size
        };
    }
    /**
     * Cleanup resources
     */ destroy() {
        // Properly unregister listeners using stored references
        this.entityManager.unregisterSetListener(this.boundUpdateListener);
        this.entityManager.unregisterRemoveListener(this.boundRemoveListener);
        this.viewportQuadTree.clear();
        this.entityRects.clear();
        this.visibleEntities.clear();
        this.prioritiesChanged = false;
        this.cachedVisibleEntities = null;
        this.cacheValid = false;
    }
}


/**
 * The hold between a room landing and the screen opening on it.
 *
 * A room arrives in pieces. The tilemap comes first, in the world state that announces the room;
 * the entities standing in it follow a tick or two later; and a character is not DRAWABLE even
 * then -- an LPC body is composited from spritesheets that are fetched on demand (see
 * SpriteSheetLoader) and baked after they land. Measured in the browser on a character-creation
 * drop into an ember camp: the map was painted 19ms after the room message, and the camp's lord
 * only had a sprite 510ms after that. The screen used to start opening the instant the tilemap
 * arrived, so the half second the rest of the camp took to assemble was spent in plain sight --
 * bare ground, then bodies popping in one by one, over an already-lifting curtain.
 *
 * So: when the room lands, hold the curtain and ask every frame whether the scene is worth looking
 * at yet. The answer is yes when the map has been painted, nothing the renderer is SHOWING is still
 * waiting on a sprite, and no new entity has arrived for a moment (the stragglers of a room load
 * come in a burst, and the first of them must not be mistaken for the last).
 *
 * The cap is what makes this safe. Everything above can fail to settle -- a sheet that 404s and
 * retries, a server that goes quiet mid-load, a camp that keeps spawning -- and a curtain nothing
 * lifts is a worse bug than the pop-in it was closed against. At MAX_HOLD_MS the screen opens on
 * whatever is there.
 */ class $5c0480e062007d96$export$67d3b0fae8e525cf {
    static{
        /**
     * The longest the screen is held black waiting for a room to finish arriving. Generous against
     * the measured ~0.5s (a slow link fetching a dozen sheets is the case that needs the room),
     * short enough that a hold nothing ever satisfies still reads as a load rather than a crash.
     */ this.MAX_HOLD_MS = 1200;
    }
    static{
        /**
     * How long the scene has to stand still before it counts as complete. A room's entities arrive
     * over a few server ticks, so "nothing on screen is waiting on a sprite" is true -- briefly and
     * meaninglessly -- in the gap before the first of them lands.
     */ this.SETTLE_MS = 120;
    }
    constructor(){
        this.lastArrivalTs = 0;
        /** A room has landed: close the curtain on it until the scene is ready to be looked at. */ this.arm = (now)=>{
            this.armedTs = now;
            this.lastArrivalTs = now;
        };
        /** Something new turned up in the room. Resets the settle window, never starts one. */ this.noteArrival = (now)=>{
            if (this.armedTs === undefined) return;
            this.lastArrivalTs = now;
        };
        this.isHolding = ()=>this.armedTs !== undefined;
        /** Abandon the hold without opening the screen (a second room load overtakes the first). */ this.cancel = ()=>{
            this.armedTs = undefined;
        };
        /**
     * Should the screen open now? Disarms the hold when it answers yes, so the caller can drive this
     * straight from the frame loop and fade in on the one frame it returns true.
     */ this.shouldReveal = (now, scene)=>{
            if (this.armedTs === undefined) return false;
            // The cap: whatever the scene is doing, this is as long as the screen stays shut.
            if (now - this.armedTs >= $5c0480e062007d96$export$67d3b0fae8e525cf.MAX_HOLD_MS) {
                this.armedTs = undefined;
                return true;
            }
            if (scene.mapPending || scene.spritesPending > 0) return false;
            if (now - this.lastArrivalTs < $5c0480e062007d96$export$67d3b0fae8e525cf.SETTLE_MS) return false;
            this.armedTs = undefined;
            return true;
        };
    }
}






const $da5649d79a6bbe55$export$6cfbffbfbde993de = 550;
const $da5649d79a6bbe55$export$8090247a39a06ef1 = 850;
const $da5649d79a6bbe55$export$b2d35e74b04a84a5 = 16;
const $da5649d79a6bbe55$export$a61db5a7156a8afa = 1200;
const $da5649d79a6bbe55$export$f8c9abc7ed897461 = 3000;
const $da5649d79a6bbe55$export$c4ac2bf49c6c1267 = (hatch)=>hatch.hp ?? $da5649d79a6bbe55$export$b2d35e74b04a84a5;
const $da5649d79a6bbe55$export$c8dc180c2e5db7f9 = (map, at)=>{
    const delta = map.getMapDeltaAt(at.x, at.y, "sprite2");
    return !delta?.removed ? delta?.context?.hatch : undefined;
};
const $da5649d79a6bbe55$export$f8f165c822803fe9 = (hatch, now = (0, $4171652afd996934$export$a86190deb5c4a8d0)())=>hatch.changedAt !== undefined && hatch.fromOpen !== hatch.open && now < hatch.changedAt + $da5649d79a6bbe55$export$6cfbffbfbde993de;
const $da5649d79a6bbe55$export$31f5ce9ba7d58215 = (map, at, now = (0, $4171652afd996934$export$a86190deb5c4a8d0)())=>{
    const hatch = $da5649d79a6bbe55$export$c8dc180c2e5db7f9(map, at);
    return !!hatch && (!hatch.open || $da5649d79a6bbe55$export$f8f165c822803fe9(hatch, now));
};
const $da5649d79a6bbe55$export$ba4449ea24c4ee75 = (hatch, now = (0, $4171652afd996934$export$a86190deb5c4a8d0)())=>{
    if (!$da5649d79a6bbe55$export$f8f165c822803fe9(hatch, now)) return hatch.open ? 1 : 0;
    const t = Math.max(0, Math.min(1, (now - hatch.changedAt) / $da5649d79a6bbe55$export$6cfbffbfbde993de));
    const ease = t * t * (3 - 2 * t);
    return hatch.open ? ease : 1 - ease;
};
const $da5649d79a6bbe55$export$77a3b6ea3f0198d7 = (direction, hatch)=>[
        {
            name: direction === "up" ? "ascend" : "descend",
            displayName: direction === "up" ? "Take stairs up" : "Take stairs down"
        },
        ...hatch ? [
            {
                name: hatch.open ? "close-hatch" : "open-hatch",
                displayName: hatch.open ? "Close hatch" : "Open hatch"
            }
        ] : [
            {
                name: "install-hatch",
                displayName: "Install wooden hatch"
            }
        ],
        ...hatch && $da5649d79a6bbe55$export$c4ac2bf49c6c1267(hatch) < $da5649d79a6bbe55$export$b2d35e74b04a84a5 ? [
            {
                name: "repair-hatch",
                displayName: "Repair hatch (1 plank)"
            }
        ] : hatch ? [
            {
                name: "remove-hatch",
                displayName: "Remove hatch"
            }
        ] : [],
        {
            name: "dismantle",
            displayName: "Dismantle"
        }
    ];





// The upright ladder's feet stand 4px above the bottom of their cell.
const $26d0ece89bd5192d$var$FOOT_GROUND_OFFSET = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 - 4;
const $26d0ece89bd5192d$export$ec8a50151a395259 = 20.5;
const $26d0ece89bd5192d$export$fcbd4805a0d7e824 = 12.5 * Math.SQRT2;
/** The part of the player's footprint that has to be over the foot before they climb. */ const $26d0ece89bd5192d$var$CLIMB_OVERLAP = 0.5;
/** One frame never walks further than this. A longer jump is a teleport or a correction. */ const $26d0ece89bd5192d$var$MAX_STEP = 48;
/** Stand at the ladder's foot until the server starts the climb, or give up after this. */ const $26d0ece89bd5192d$var$HOLD_MS = 750;
/** Entry is 18px south of the former one-pixel inset from the north lip. */ const $26d0ece89bd5192d$var$DESCENT_ENTRY_INSET = 19;
const $26d0ece89bd5192d$export$f303b6bf0a195046 = (d, a, b)=>{
    if (d >= a + b) return 0;
    if (d <= Math.abs(a - b)) return 1;
    const lens = a * a * Math.acos((d * d + a * a - b * b) / (2 * d * a)) + b * b * Math.acos((d * d + b * b - a * a) / (2 * d * b)) - Math.sqrt((-d + a + b) * (d + a - b) * (d - a + b) * (d + a + b)) / 2;
    return lens / (Math.PI * Math.min(a, b) ** 2);
};
const $26d0ece89bd5192d$export$79006061ff2eccd2 = (()=>{
    let near = Math.abs($26d0ece89bd5192d$export$ec8a50151a395259 - $26d0ece89bd5192d$export$fcbd4805a0d7e824), far = $26d0ece89bd5192d$export$ec8a50151a395259 + $26d0ece89bd5192d$export$fcbd4805a0d7e824;
    for(let i = 0; i < 50; i++){
        const mid = (near + far) / 2;
        if ($26d0ece89bd5192d$export$f303b6bf0a195046(mid, $26d0ece89bd5192d$export$ec8a50151a395259, $26d0ece89bd5192d$export$fcbd4805a0d7e824) >= $26d0ece89bd5192d$var$CLIMB_OVERLAP) near = mid;
        else far = mid;
    }
    return near;
})();
/** A stair the player may take, with the verb its tile offers for it. */ const $26d0ece89bd5192d$var$usableStairAt = (provider, at, direction)=>{
    const stair = (0, $d67ded9f7782cb88$export$f7609d4936bd82d6)(provider, at, direction) ?? (0, $d67ded9f7782cb88$export$f7609d4936bd82d6)(provider, at);
    if (!stair || (0, $da5649d79a6bbe55$export$31f5ce9ba7d58215)(provider, at)) return undefined;
    const delta = provider.getMapDeltaAt(at.x, at.y, "sprite2");
    const interactions = !delta?.removed && delta?.context?.tileInteractions;
    const name = stair.direction === "up" ? "ascend" : "descend";
    const command = interactions && interactions.find((action)=>action.name === name);
    // Include the top/bottom endpoints: they share the shaft's grip even with one exit.
    const continuous = !!(delta?.context?.context?.stairLandings ?? delta?.context?.stairLandings);
    return command ? {
        stair: stair,
        command: command,
        continuous: continuous,
        interaction: name
    } : undefined;
};
class $26d0ece89bd5192d$export$c48135296a19d309 {
    constructor(){
        // Stairs ("x,y" in roomId) the player stands on but may not climb yet.
        this.blocked = new Set();
        /** Forget the walk so far: the next frame starts a new one. */ this.reset = ()=>{
            this.previous = undefined;
            this.blocked.clear();
        };
        /** A climb was asked for and the server has not started it yet. */ this.holding = (roomId, now, interaction)=>{
            if (this.pending && (this.pending.roomId !== roomId || now >= this.pending.until)) this.pending = undefined;
            return !!this.pending && (!interaction || this.pending.interaction === interaction);
        };
        /** Keep hold of a shaft while its descent request is in flight, rather than stepping into air. */ this.holdingPosition = (roomId, now)=>this.holding(roomId, now) && (this.pending.interaction === "ascend" || !!this.pending.shaft);
        /** The server started a climb (or the player otherwise left the ground): nothing to wait for. */ this.release = ()=>{
            this.pending = undefined;
        };
        /** Feed one frame of movement; returns the climb to ask for, at most once per approach. */ this.update = (provider, roomId, location, intent, now)=>{
            const sameRoom = roomId === this.roomId;
            // Arriving somewhere (a room, a teleport) is not walking there: a foot it lands on is not one
            // it pressed up on.
            const fresh = !this.previous || !sameRoom || Math.hypot(location.x - this.previous.x, location.y - this.previous.y) > $26d0ece89bd5192d$var$MAX_STEP;
            this.roomId = roomId;
            this.previous = {
                x: location.x,
                y: location.y
            };
            if (!sameRoom) this.pending = undefined;
            if (this.holding(roomId, now)) return undefined;
            const vertical = intent.y !== 0 && Math.abs(intent.x) <= Math.abs(intent.y);
            const northward = vertical && intent.y < 0;
            const soles = {
                x: location.x,
                y: location.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763)
            };
            const reach = $26d0ece89bd5192d$export$79006061ff2eccd2;
            const blocked = new Set();
            let climb;
            const x0 = Math.floor((soles.x - reach) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), x1 = Math.floor((soles.x + reach) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            const y0 = Math.floor((soles.y - $26d0ece89bd5192d$var$FOOT_GROUND_OFFSET - reach) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            const y1 = Math.floor((soles.y - $26d0ece89bd5192d$var$FOOT_GROUND_OFFSET + reach) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            for(let x = x0; x <= x1; x++)for(let y = y0; y <= y1; y++){
                const usable = $26d0ece89bd5192d$var$usableStairAt(provider, {
                    x: x,
                    y: y
                }, vertical ? northward ? "up" : "down" : undefined);
                if (!usable) continue;
                const key = `${x},${y}`;
                const pressing = usable.stair.direction === "up" ? northward : vertical && intent.y > 0;
                const opening = usable.stair.direction === "down" && !usable.continuous ? (0, $afc439431837457b$export$736d42feedf23b37)({
                    x: x,
                    y: y
                }) : undefined;
                const distance = usable.continuous ? Math.hypot(location.x - (x + .5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), location.y - (y + .5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) : opening ? Math.abs(soles.x - (x + .5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) : Math.hypot(soles.x - (x + .5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), soles.y - ((y + .5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + $26d0ece89bd5192d$var$FOOT_GROUND_OFFSET));
                const touching = usable.continuous ? Math.floor(location.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) === x && Math.floor(location.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) === y : opening ? soles.x >= opening.left && soles.x <= opening.right && soles.y >= opening.north + $26d0ece89bd5192d$var$DESCENT_ENTRY_INSET && soles.y < opening.south : distance <= $26d0ece89bd5192d$export$79006061ff2eccd2;
                if (!touching) continue;
                if (!usable.continuous && (fresh || this.blocked.has(key))) blocked.add(key);
                else if (pressing && (!climb || distance < climb.distance)) climb = {
                    climb: {
                        roomId: roomId,
                        coordinate: {
                            x: x,
                            y: y
                        },
                        interaction: usable.interaction,
                        ...usable.continuous ? {
                            shaft: true
                        } : {}
                    },
                    distance: distance
                };
            }
            this.blocked = blocked;
            if (!climb) return undefined;
            blocked.add(`${climb.climb.coordinate.x},${climb.climb.coordinate.y}`);
            this.pending = {
                ...climb.climb,
                until: now + $26d0ece89bd5192d$var$HOLD_MS
            };
            return climb.climb;
        };
    }
}


const $1e46c45e333c583b$export$e1d138f8777c998e = {
    value: ""
};
// How far an Ember Core blast can still be felt in the camera, in world pixels. A little under
// the Core's own 192px range, so a shot thrown as far as it will go still registers faintly
// and one that lands on the player is a full kick.
const $1e46c45e333c583b$var$BLAST_SHAKE_RANGE = 320;
// How far a felled tree hitting the ground is felt, in world pixels: about the length of a big tree
// lying down, twice over. A tree is a thump, not a blast -- a third of the Core's kick at most.
const $1e46c45e333c583b$var$TREE_SHAKE_RANGE = 260;
class $1e46c45e333c583b$export$99cd19a42c3acc3f {
    get dayPhase() {
        return this.scene.dayPhase;
    }
    set dayPhase(phase) {
        this.scene.dayPhase = phase;
    }
    get currentBrightness() {
        return this.scene.brightness;
    }
    set currentBrightness(brightness) {
        this.scene.brightness = brightness;
    }
    // Compatibility accessors; the scene owns weather shared by every rendered floor.
    get ambience() {
        return this.scene.ambience;
    }
    set ambience(ambience) {
        this.scene.ambience = ambience;
    }
    static{
        // Radius (px) around the focused entity kept live for the PiP. Slightly larger than the PiP
        // viewport so entities entering frame are already interpolating. Tune with the PiP size.
        this.FOCUS_RENDER_RADIUS = 14 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    constructor(factory){
        this.destroyedEntities = new Set();
        this.destroyedEntitiesLagBuffer = new Set();
        // Viewport bounds caching
        this.cachedViewportBounds = {
            minX: 0,
            maxX: 0,
            minY: 0,
            maxY: 0
        };
        this.viewportBoundsValid = false;
        this.VIEWPORT_CACHE_THRESHOLD = 16 // Only recalculate if player moves more than 16 pixels
        ;
        this.expiredTs = 0;
        this.lagbufferTs = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(1500);
        this.quadrantId = "";
        this.entityManager = new (0, $7b78839962f6da5d$export$c7b7134fd828a5)((0, $cb689cfa16c444ba$export$ede76e7dc512924d));
        // Walking into the front of a stair takes it (Client.processInputs feeds it every frame).
        this.ladderApproach = new (0, $26d0ece89bd5192d$export$c48135296a19d309)();
        this.scene = new (0, $3d19dbc64510cf8a$export$576380cfa99ddf20)((brightness)=>{
            const visibility = this.clientRenderer.map().getVisibility();
            if (!visibility?.fullOcclusion) this.clientRenderer.map().update(null, {
                ...visibility,
                darkness: brightness
            });
        });
        // Faction tracking: offscreen edge arrows pointing to members of a faction. Both are set by the
        // server (per-room) on room entry and are not the player's to turn off -- in the one room type
        // that asks for them, an ember camp, they point at the player's own camp and crew, and there is
        // no moment where losing track of those is an improvement. (`f` used to toggle them; it is the
        // frame-rate readout now.)
        this.trackedFaction = null;
        this.trackingEnabled = false;
        // Recent speech per entity, so the faction tracker can show a chat bubble on the
        // arrow when a tracked member speaks while offscreen (its own world-space bubble
        // would be off-screen). Expires like the avatar HUD bubble.
        this.recentSpeech = new Map();
        // Last line each entity said, kept a fixed ~10s (longer than recentSpeech's ~3s window), for the
        // follow-cam PiP caption so a distant roster member's last words linger there a while.
        this.lastSpeech = new Map();
        // Ember roster role per entity, mirrored from the roster broadcast so the offscreen
        // faction tracker can show each member's role glyph (crown/shield/axe). The roster itself is
        // routed to the HUD widget; here we keep only the entityId -> role lookup.
        this.emberRoles = new Map();
        // And the same for each member's STATUS, which the in-world ground halo reads (see
        // MemberStatusHalo) so the world can mark which body a problem chip in the strip belongs to.
        // Mirrored from the same broadcast for the same reason: status is a roster fact, not an entity
        // field, so there is nowhere on the synced entity to read it from.
        this.emberStatuses = new Map();
        // Follow-cam: the entity the picture-in-picture view is watching (set by the ember roster
        // click). While set, its neighborhood is kept "near" for rendering/interpolation so the PiP
        // shows it live, wherever it is in the room.
        this.focusEntityId = null;
        this.incompleteEntities = new Set();
        /**
     * A scene change in progress (Protocol.TransitFade). `transitHoldUntilTs` is the earliest the
     * screen may open again -- it outranks the room being ready -- and `transitBodyMs` is how long
     * the body took to dissolve, kept so it takes the same time to come back.
     */ this.transitHoldUntilTs = 0;
        this.transitBodyMs = 0;
        // The curtain over a room that has landed but not finished arriving. See RoomReveal.
        this.roomReveal = new (0, $5c0480e062007d96$export$67d3b0fae8e525cf)();
        // Unified culling system - single source of truth for entity distance culling
        this.CULLING_DISTANCE_TILES = 3;
        this.cullingDistanceSquared = this.CULLING_DISTANCE_TILES * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (this.CULLING_DISTANCE_TILES * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
        // Entity sorting cache invalidation tracking
        this.entitySortCacheInvalidated = false;
        // Spatial indexing for efficient culling
        this.viewportManager = null;
        /** A felled tree's crack and crash become sound and, close by, a camera thump. See effects/tree_fall_feedback. */ this.wireTreeFallFeedback = ()=>{
            (0, $2027e742bf23a011$export$eaa376922eb1905)({
                creaked: (at)=>this.audio.treeCreak(at),
                landed: (at, weight)=>{
                    this.audio.treeFall(at, weight);
                    const player = this.playerEntity;
                    if (!player) return;
                    const distance = Math.hypot(at.x - player.location.x, at.y - player.location.y);
                    const near = Math.max(0, 1 - distance / $1e46c45e333c583b$var$TREE_SHAKE_RANGE) ** 2;
                    if (near > 0.03) this.clientRenderer.map().screenShakeImpulse(player, (1 + 2.5 * near) * Math.min(1.2, weight), 220);
                }
            });
        };
        /**
     * An area projectile's three moments become sound and a camera kick here, because this is the
     * only object that holds both channels. The projectile's renderable is what detects them -- it
     * watches the server's phase field every frame -- and it reaches this code through a registered
     * sink rather than an import, which would close a cycle. See effects/area_projectile_feedback.
     */ this.wireAreaProjectileFeedback = ()=>{
            (0, $c934a91f663d6020$export$e20abd874f6b5d34)({
                fired: (at, appearance)=>{
                    if (appearance !== "bomb") this.audio.emberCoreFired(at);
                },
                landed: (at, appearance)=>appearance === "bomb" ? this.audio.bombLanded(at) : this.audio.emberCoreLanded(at),
                detonated: (at, appearance)=>{
                    if (appearance === "bomb") this.audio.bombBlast(at);
                    else this.audio.emberCoreBlast(at);
                    // The kick is the half of a blast the player feels rather than sees, so it is scaled
                    // by how close it went off: a wallop at your feet, nothing at all across the camp.
                    // BLAST_SHAKE_RANGE is a little under the Core's own six-tile range, so a shot at
                    // maximum distance still registers faintly.
                    const player = this.playerEntity;
                    if (!player) return;
                    const distance = Math.hypot(at.x - player.location.x, at.y - player.location.y);
                    const near = Math.max(0, 1 - distance / $1e46c45e333c583b$var$BLAST_SHAKE_RANGE) ** 2;
                    if (near > 0.02) this.clientRenderer.map().screenShakeImpulse(player, 1 + 9 * near, 260);
                }
            });
        };
        this.hasEntity = (entityId)=>!!this.entityManager.get(entityId);
        this.getEntity = (entityId)=>this.entityManager.get(entityId);
        this.updateScores = (scores)=>{
            const scoreEntityIds = Object.keys(scores);
            scoreEntityIds.forEach((entityId)=>{
                const entity = this.getEntity(entityId);
                if (entity) this.clientRenderer.entity().update(entity, scores[entityId]);
            });
        };
        /**
     * Empty the world out before a reconnect hands us a new one.
     *
     * A new socket is a NEW session: the server destroys the player on close, so a reconnect comes
     * back with a different entityId and (for an ember player) a different room. Everything drawn
     * right now belongs to the session that just ended.
     *
     * initializePlayer cannot do this itself -- it only overwrites the `playerEntity` POINTER,
     * leaving the previous avatar in the entity manager and on the stage -- and neither can the
     * room-change teardown in updateFromWorldState, which deliberately spares whatever
     * `playerEntity` points at so a player survives walking between rooms. So the old player has to
     * go from here, explicitly, before anybody takes their place.
     *
     * `roomId` is cleared too, so the first world state of the new session reads as a room change
     * and rebuilds the tilemap rather than being taken for more of the room we just left.
     */ this.prepareForReconnect = ()=>{
            this.scene.reset();
            this.audio.stopBonecallerChant();
            const toRemove = [];
            this.entityManager.iterate(null, (next)=>{
                this.clientRenderer.entity().destroy(next);
                toRemove.push(next.entityId);
            });
            toRemove.forEach((entityId)=>this.entityManager.remove(entityId));
            this.playerEntity = undefined;
            this.roomId = undefined;
            this.incompleteEntities.clear();
            this.destroyedEntities.clear();
            this.destroyedEntitiesLagBuffer.clear();
            this.viewportManager?.reset();
            this.invalidateViewportCache();
            this.invalidateEntitySortCache();
        };
        this.initializePlayer = (entityId, client, guest)=>{
            $1e46c45e333c583b$export$e1d138f8777c998e.value = entityId;
            const playerEntity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
            playerEntity.entityType = "player";
            playerEntity.entityId = entityId;
            playerEntity.dimensions = {
                ...(0, $cb689cfa16c444ba$export$5b5223867019c37b)["player"]
            };
            playerEntity.hp = -1;
            playerEntity.mana = -1;
            playerEntity.hunger = -1;
            playerEntity.visible = false;
            this.playerEntity = playerEntity;
            this.entityManager.set(this.playerEntity);
            // A reconnect comes back through here with the old controller still listening to the
            // keyboard and mouse. Letting it go first is what stops its listeners doubling up with the
            // new one's.
            this.playerController?.destroy();
            this.playerController = new (0, $319b1dfd90d3ebea$export$2616165974278734)(client, playerEntity, this.clientRenderer.mouse(), this.clientRenderer.keyboard(), guest);
            this.clientRenderer.entity().create(playerEntity);
            this.clientRenderer.gui().helpMessaging();
            if (this.clientRenderer.gui().isChapterAnnouncementVisible?.()) {
                this.playerController.enabledKeyboardAction(false);
                this.playerController.enabledMouseAction(false);
            }
        };
        this.updatePlayerEntityId = (entityId)=>{
            if (!this.playerEntity) return;
            const originalEntityId = this.playerEntity.entityId;
            this.playerEntity.entityId = entityId;
            this.clientRenderer.entity().updateEntityId(originalEntityId, entityId);
        };
        this.shouldInterpolate = (entity)=>{
            // No point in interpolating this client"s entity.
            if (entity.entityId == this.playerEntity?.entityId) return false;
            // its a local bullet; don"t interpolate
            if (this.entityManager.contains(entity.entityId, "bullet")) return false;
            return true;
        };
        this.createEntity = (message)=>{
            const { entityId: entityId, entityType: entityType } = message;
            if (this.destroyedEntitiesLagBuffer.has(entityId) || message.entityState === "dead") return;
            if (entityId === this.playerEntity?.entityId) return this.playerEntity;
            // Keeps a room that is still arriving behind the curtain: the first of a load's entities
            // must not be mistaken for the last. No-op unless a room reveal is being held.
            this.roomReveal.noteArrival(Date.now());
            // create a local client entity based on the remote message from the server
            const entity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
            entity.entityType = entityType;
            entity.chargedWeaponDefinition = message.chargedWeaponDefinition;
            entity.weaponCharge = message.weaponCharge;
            entity.areaProjectile = message.areaProjectile;
            entity.crossFloorProjectile = message.crossFloorProjectile;
            entity.projectileTarget = message.projectileTarget;
            entity.landedArrow = message.landedArrow;
            entity.ownerEntityId = message.ownerEntityId;
            entity.floorFall = message.floorFall;
            entity.stairTravel = message.stairTravel;
            entity.npcType = message.npcType;
            entity.contextMenuSubject = message.contextMenuSubject;
            entity.campfireMenuLearned = message.campfireMenuLearned;
            entity.recruitMenuLearned = message.recruitMenuLearned;
            entity.spriteId = message.spriteId;
            entity.noGlint = message.noGlint;
            entity.entityId = entityId;
            entity.position_buffer = [];
            if (message.origin) entity.origin = {
                ...message.origin
            };
            entity.maxDistance = message.maxDistance;
            entity.location = {
                x: message?.position[0],
                y: message?.position[1]
            };
            entity.movement.direction = message.direction;
            entity.movement.angle = message.angle;
            entity.speed = message.speed;
            entity.speed2 = message.speed2;
            entity.color = message.color;
            entity.dimensions = message.dimensions || {
                ...(0, $cb689cfa16c444ba$export$5b5223867019c37b)[entityType]
            };
            entity.hp = -1;
            entity.roomId = message.entityId;
            entity.clickable = message.clickable;
            entity.inventory = message.inventory;
            entity.expirationTs = message.expirationTs;
            entity.debug = message.debug;
            entity.active = message.active;
            entity.interestState = message.interest === "update" ? "dormant" : "active";
            // abort entity creation if its already travelled the maximum distance; should only
            // in theory apply to bullets
            if (entity.maxDistance !== undefined && entity.travelledDistance() > entity.maxDistance) return;
            this.entityManager.set(entity);
            // Check if the new entity is within viewport - if so, invalidate cache
            if (!this.isTooDistantFromPlayer(entity)) this.entitySortCacheInvalidated = true;
            //// for any created entity -- create a renderable representation
            //// and add it onto the displayable surface
            this.clientRenderer.entity().create(entity);
            return entity;
        };
        this.canFireBulletFrom = (source)=>{
            if (!this.playerEntity.visible) // can"t fire bullets when you are visible
            // todo - serverside enforcement
            return false;
            if (!source.canShootBullets) return false;
            const { weapon: weapon } = source;
            const weaponType = weapon?.weaponType || "none";
            const characteristics = (0, $cb689cfa16c444ba$export$6e47733a887561b3)[weaponType];
            if (!characteristics) return false;
            if (source.mana < characteristics.manaCost) return false;
            if (this.lastWeapon?.weaponType !== weaponType) {
                this.lastFireTs = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(characteristics.firingLatchMs);
                this.lastWeapon = weapon;
            }
            if (!this.lastFireTs.expired()) return false;
            const ammoNeeded = (0, $bf6244e5cc9aa116$export$3f4c28cf92a4cf37)[weaponType];
            if (ammoNeeded) {
                const foundAmmo = (0, $f684496fff50a7a1$export$4c2157e8933c20e3)(source.inventory, ammoNeeded);
                if (!foundAmmo || foundAmmo.quantity < 1) {
                    this.handleChat("I need craft or buy more " + ammoNeeded + "s.", source.entityId, "");
                    let foundSlot;
                    (0, $f684496fff50a7a1$export$696bbd6109262d72)(source.inventory).find((item, slot)=>{
                        if (!(0, $bf6244e5cc9aa116$export$3f4c28cf92a4cf37)[item.itemType]) {
                            foundSlot = slot;
                            return item;
                        }
                    });
                    if (foundSlot !== undefined) this.clientRenderer.gui().activateInventorySlot(foundSlot + 1);
                    return false;
                }
            }
            return true;
        };
        this.createBulletFrom = (source)=>{
            const bullets = (0, $66e35324756c76b6$export$b4792961ac683a30)(this.lastWeapon, {
                ...source.location,
                roomId: source.roomId
            }, source.movement);
            bullets.forEach((bullet)=>{
                bullet.ownerEntityId = source.entityId;
            });
            return bullets;
        };
        this.createBombFrom = (source)=>{
            if (!this.playerEntity.visible) // can"t fire bullets when you are visible
            // todo - serverside enforcement
            return;
            if (!source.canLayBomb) return;
            if (source.mana < 3) return;
            if (!source.inventory?.items.find((item)=>item.itemType === "bomb")) return;
            const bomb = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
            bomb.entityType = "bomb";
            bomb.location = {
                ...source.location
            };
            bomb.entityId = (0, $87befc68df50040c$export$2e2bcd8739ae039)();
            bomb.dimensions = {
                ...(0, $cb689cfa16c444ba$export$5b5223867019c37b)[bomb.entityType]
            };
            bomb.speed = 600;
            bomb.roomId = source.roomId;
            this.entityManager.set(bomb);
            ////
            this.clientRenderer.entity().create(bomb);
            return bomb;
        };
        this.isBootstrapped = ()=>{
            return this.roomId && this.tilemapMetaProvider;
        };
        this.updateFromWorldState = (worldState)=>{
            const { scores: scores, tilemaps: tilemaps, worldMetaDimensions: worldMetaDimensions, tilemapMeta: tilemapMeta, visibility: visibility, roomId: roomId, roomName: roomName, leaderboards: leaderboards, dayPhase: dayPhase, dayPct: dayPct, biomeColorMap: biomeColorMap, locationIcons: locationIcons, playerLocations: playerLocations, minimapConfig: minimapConfig, runLevel: runLevel } = worldState;
            // A full map snapshot replaces the scene even when the room ID is unchanged
            // (e.g. resetting an Ember camp). Ignoring it leaves the old map/entities in place
            // and never arms the reveal that completes the server's teleport fade-out.
            const updatedRoom = this.roomId !== roomId || !!(tilemaps && tilemapMeta);
            // A level change to a storey drawn here already arrives without its map (WorldState.levelHandOff).
            const drawnFloor = worldState.levelHandOff && !tilemaps ? this.clientRenderer.map().drawnFloorProvider?.(roomId) : undefined;
            const previousHouse = this.tilemapMetaProvider?.twoStoreyHouse;
            const nextHouse = tilemaps?.twoStoreyHouse ?? drawnFloor?.twoStoreyHouse;
            const isLevelTransfer = updatedRoom && (0, $30c0c3cc99c65923$export$5f2cb0f098ee5881)(this.roomId, previousHouse, roomId, nextHouse);
            const sceneChanged = updatedRoom ? this.scene.enter(roomId, nextHouse, dayPhase, visibility) : false;
            // The destination mask must have brightness on its first frame. Level snapshots
            // can arrive before their day-cycle event, and an absent value removes the mask.
            const roomVisibility = updatedRoom ? this.scene.visibility({
                ...visibility || {},
                darkness: visibility?.darkness ?? this.dayPhase?.brightness ?? (isLevelTransfer ? this.clientRenderer.map().getVisibility()?.darkness : undefined)
            }) : visibility;
            let updatedQuadrant = false;
            if (updatedRoom) {
                this.clientRenderer.entity().beginLevelTransfer?.(!!isLevelTransfer, isLevelTransfer ? (0, $2751e0027a1b432f$export$9f4b491aa2a94a16)(nextHouse, previousHouse) : 0);
                if (sceneChanged) {
                    this.audio.stopBonecallerChant();
                    this.emberRoles.clear();
                    this.emberStatuses.clear();
                }
                //
                // we"re in a new room
                //
                this.runLevel = runLevel;
                this.roomId = roomId;
                // Reset viewport manager for new room (more efficient than destroying/recreating)
                if (this.viewportManager) this.viewportManager.reset();
                // Clear viewport cache when room changes since map dimensions may change
                this.invalidateViewportCache();
                const currentQuardrantId = (0, $a80d0b17b615d6f7$export$4418bd227bd6a76a)(roomId, worldMetaDimensions);
                if (this.quadrantId !== currentQuardrantId) {
                    this.quadrantId = currentQuardrantId;
                    updatedQuadrant = true;
                }
                const toRemove = [];
                this.entityManager.iterate(null, (next)=>{
                    if (next.entityId !== this.playerEntity.entityId) {
                        this.clientRenderer.entity().destroy(next);
                        toRemove.push(next.entityId);
                    }
                });
                for(let i = 0; i < toRemove.length; i++)this.entityManager.remove(toRemove[i]);
                this.incompleteEntities.clear();
                this.clientRenderer.gui().roomUpdated(roomId, roomName, visibility?.suppressMinimap, visibility?.suppressDayCycle, visibility?.suppressControlBar, visibility?.suppressLevelUp, visibility?.suppressMana, visibility?.suppressFood, visibility?.suppressShards, visibility?.suppressPlayerName, visibility?.suppressTutorial, visibility?.suppressGuestPrompt, visibility?.suppressTeamCommands);
                this.clientRenderer.gui().updateLeaderboard(null);
                if (dayPct !== undefined) this.clientRenderer.gui().updateDayPct(dayPct);
                this.playerController.updateRoom();
            }
            if (scores) this.updateScores(scores);
            const roomMap = !updatedRoom ? undefined : tilemaps && tilemapMeta ? new (0, $93a024e1e74df758$export$c8df09a865c1d736)(roomId, tilemapMeta, tilemaps, worldMetaDimensions) : drawnFloor;
            if (roomMap) {
                this.tilemapMetaProvider = roomMap;
                this.tilemapMetaProvider.biomeColorMap = biomeColorMap;
                this.tilemapMetaProvider.locationIcons = locationIcons;
                this.tilemapMetaProvider.minimapConfig = minimapConfig;
                this.entitySortCacheInvalidated = true;
                // Initialize spatial indexing for efficient culling
                this.initializeViewportManager();
                const handedOff = this.clientRenderer.map().update(this.tilemapMetaProvider, roomVisibility, !!drawnFloor) === true;
                // The server left out the storey just left too; without the swap there is no drawing of it.
                if (drawnFloor && !handedOff) this.playerController.client.requestRoomSnapshot(roomId);
                this.playerController.enabledMouseAction(true);
                this.playerController.enabledKeyboardAction(true);
                // Landing in a room is landing on your feet -- an ember "restart" arrives this way
                // rather than as a respawn, and nothing else in a whole-room load would lift the
                // death freeze the run before left behind.
                this.standUp();
                // The tilemap is here, which is NOT the same as the room being here: its entities are
                // still on the wire and their bodies still have spritesheets to fetch. Opening the
                // screen now shows the player bare ground and then half a second of pop-in, so hold the
                // black and let the frame loop decide when the scene is worth looking at (see
                // tickRoomReveal / RoomReveal).
                if (isLevelTransfer) {
                    this.roomReveal.cancel();
                    this.fadeInOut("in", 0);
                } else {
                    this.clientRenderer.gui().holdBlackout();
                    this.roomReveal.arm(Date.now());
                    this.playerController.paralyze(true, (0, $5c0480e062007d96$export$67d3b0fae8e525cf).MAX_HOLD_MS);
                }
                setTimeout(()=>{
                    this.playerController.perturb();
                }, 100);
            }
            if (leaderboards) this.clientRenderer.gui().updateLeaderboard(leaderboards);
            if (playerLocations) this.clientRenderer.entity().updatePlayerLocations(playerLocations);
            if (updatedRoom) {
                this.playerController.client.requestPlayerLocations();
                this.playerController.client.requestVisibility();
            }
            if (worldState.twoStoreyHouse && this.tilemapMetaProvider) this.tilemapMetaProvider.twoStoreyHouse = worldState.twoStoreyHouse;
            if (worldState.sceneRooms) this.clientRenderer.map().updateSceneRooms?.(worldState.sceneRooms);
            if (isLevelTransfer) this.clientRenderer.entity().endLevelTransfer?.();
            if (worldState.observation !== undefined) this.updateObservation(worldState.observation);
            updatedQuadrant;
            return updatedRoom;
        };
        this.updateFromPlayerMessage = (message)=>{
            if (this.playerEntity.entityId !== message.entityId) return;
            if (message.roomId !== this.playerEntity.roomId) this.playerEntity.roomId = message.roomId;
            this.playerEntity.campfireMenuLearned = message.campfireMenuLearned;
            this.playerEntity.recruitMenuLearned = message.recruitMenuLearned;
            this.playerEntity.mana = message.mana;
            this.playerEntity.visible = message.visible;
            this.playerEntity.canShootBullets = message.canShootBullets;
            this.playerEntity.canLayBomb = message.canLayBomb;
            // A fallen player who hasn't been stood back up yet doesn't get to walk around. Taken
            // from the server's verdict on every message rather than from a local timer, so it lifts
            // the instant the server lifts it -- and can't outlive it, which is what would strand a
            // player who was already alive again behind a controller that still thought otherwise.
            this.playerController.setDowned(!!message.downed);
            // ...and onto the entity itself, which is what the RENDERER reads: the controller freezes
            // the legs, this lays the body down (see Entity.downed). Your own character is drawn from
            // `playerEntity` and never goes through updateEntityFromMessage, so it needs saying here
            // too or everyone else's fallen body lies down and yours alone stays standing.
            this.playerEntity.downed = !!message.downed;
            this.playerEntity.floorFall = message.floorFall;
            if (message.stairTravel || this.playerEntity.stairTravel) {
                this.playerEntity.movement.direction = message.direction;
                this.playerEntity.movement.angle = message.angle;
            }
            this.playerEntity.stairTravel = message.stairTravel;
            // ...and whether they are wearing one of another camp's attackers, which is what puts the
            // "Let go" button on the screen. Same shape as `downed` for the same reason: it is the
            // server's verdict on every message, so the only way out of a body cannot outlive it (or
            // go missing while it lives) because of a local timer disagreeing.
            this.clientRenderer.gui().setInvading(!!message.invading);
            // this.playerController.paralyze(message.paralyzeUntilTs > Date.now())
            this.playerEntity.upgradePoints = message.upgradePoints;
            this.clientRenderer.entity().update(this.playerEntity);
            if (message.inventory) {
                this.updateInventoryFrom(this.playerEntity, message);
                this.playerController.restoreBuildingEquipment();
            }
            this.started = true;
        };
        this.updateFromNonPlayerMessage = (message)=>{
            if (this.playerEntity.entityId === message.entityId) return;
            if (message.roomId !== this.playerEntity.roomId) return;
            const entity = this.entityManager.get(message.entityId);
            if (!entity) return;
            if (message.inventory) this.updateInventoryFrom(entity, message);
        };
        this.updateInventoryFrom = (entity, message)=>{
            if (this.clientRenderer.gui().updateInventory(entity, message.inventory)) {
                entity.inventory = {
                    ...message.inventory
                };
                return true;
            }
            return false;
        };
        this.scheduleForDestruction = (entityId)=>{
            this.destroyedEntities.add(entityId);
            this.destroyedEntitiesLagBuffer.add(entityId);
        };
        this.isDestroyed = (entityId)=>this.destroyedEntities.has(entityId);
        this.destroyEntity = (entity)=>{
            if (entity) {
                this.entitySortCacheInvalidated = true;
                this.clientRenderer.entity().destroy(entity);
            }
        };
        this.processEntities = (dt_sec)=>{
            // process bullets
            this.entityManager.iterate("bullet", (bullet)=>{
                if (bullet.isDead()) {
                    this.scheduleForDestruction(bullet.entityId);
                    return;
                }
                if (!(0, $691ebdd330b4ed0d$export$fd79ea94fab2dcf1)(bullet, dt_sec, this.tilemapMetaProvider)) this.scheduleForDestruction(bullet.entityId);
            });
        };
        this.cleanup = ()=>{
            const now = Date.now();
            if (now - this.expiredTs > 3000) this.entityManager.iterate(null, (next)=>{
                this.scheduleForDestruction(next.entityId);
            }, (next)=>next.entityId !== this.playerEntity.entityId && next.roomId !== this.roomId);
            this.destroyedEntities.forEach((entityId)=>{
                const entity = this.entityManager.get(entityId);
                if (entity) {
                    this.destroyEntity(entity);
                    this.entityManager.remove(entity.entityId);
                }
            });
            this.destroyedEntities.clear();
            if (this.lagbufferTs.expired()) this.destroyedEntitiesLagBuffer.clear();
        };
        this.focusPendingUntil = 0;
        this.getFollowCamEntity = (id)=>{
            if (id === this.focusEntityId && this.observedFocus) return this.observedFocus;
            const local = this.getEntity(id);
            return local?.roomId === this.playerEntity?.roomId ? local : undefined;
        };
        this.isFocusPending = ()=>Date.now() < this.focusPendingUntil;
        this.updateObservation = (observation)=>{
            if (observation && observation.entityId !== this.focusEntityId) return;
            this.observation = observation;
            this.observedFocus = undefined;
            this.focusPendingUntil = 0;
            const message = observation?.room?.messages.find((entity)=>entity.entityId === this.focusEntityId);
            if (message?.position) {
                const entity = Object.assign(new (0, $cb689cfa16c444ba$export$bc644a473284d944)(), message);
                entity.location = Object.assign({
                    x: message.position[0],
                    y: message.position[1]
                }, {
                    roomId: observation.room.roomId
                });
                entity.roomId = observation.room.roomId;
                entity.movement.direction = message.direction;
                entity.movement.angle = message.angle;
                entity.maxHp = message.hpMax;
                this.observedFocus = entity;
            }
            this.clientRenderer.updateObservation?.(observation);
        };
        // Unified culling system methods
        this.setFocusEntityId = (entityId)=>{
            this.focusEntityId = entityId;
            this.observation = null;
            this.observedFocus = undefined;
            this.focusPendingUntil = entityId ? Date.now() + 3000 : 0;
            this.clientRenderer.updateObservation?.(null);
        };
        // True if a follow-cam focus is active and the given location is within the focus render
        // radius of it — used to keep the focused entity's neighborhood rendering/interpolating even
        // when it is far from the player (so the PiP view is live).
        this.isNearFocus = (location)=>{
            if (!this.focusEntityId) return false;
            const focus = this.entityManager.get(this.focusEntityId);
            if (!focus) return false;
            return (0, $cb689cfa16c444ba$export$79376507b09a66f)(location.x, location.y, focus.location.x, focus.location.y) < $1e46c45e333c583b$export$99cd19a42c3acc3f.FOCUS_RENDER_RADIUS;
        };
        this.isTooDistantFromPlayer = (entity)=>{
            return this.isTooDistantFromPlayerByLocation(entity.entityId, entity.location);
        };
        // Unified culling system methods
        this.isTooDistantFromPlayerByLocation = (entityId, entityLocation)=>{
            if (entityId === this.playerEntity.entityId) return false // Never cull the player
            ;
            return !this.isEntityWithinCullingDistance(entityId, entityLocation, this.playerEntity.location);
        };
        this.isPlayerInitialized = ()=>{
            return !(this.playerEntity.location?.x === -1 && this.playerEntity.location?.y === -1);
        };
        // Efficient culling check that combines distance and viewport-based culling
        this.isEntityWithinCullingDistance = (entityId, entityLocation, playerPos)=>{
            if (entityId === this.playerEntity.entityId) return true // Always include player
            ;
            // Keep the follow-cam focus neighborhood live even when it is off the main viewport, so
            // the picture-in-picture view renders and interpolates it.
            if (this.isNearFocus(entityLocation)) return true;
            // // First check: distance-based culling (existing)
            // const dx = entity.location.x - playerPos.x
            // const dy = entity.location.y - playerPos.y
            // const distSquared = dx * dx + dy * dy
            // if (distSquared > this.cullingDistanceSquared) {
            //     return false
            // }
            // Second check: viewport-based culling (new)
            const viewportBounds = this.getViewportBounds(playerPos);
            const entityX = entityLocation.x;
            const entityY = entityLocation.y;
            const isWithinViewport = entityX >= viewportBounds.minX && entityX <= viewportBounds.maxX && entityY >= viewportBounds.minY && entityY <= viewportBounds.maxY;
            return isWithinViewport;
        };
        // Pure viewport test against the player's current position (no follow-cam focus exemption).
        // Used by the follow-cam PiP to hide itself once the watched entity is visible on the main screen.
        this.isWithinPlayerViewport = (location)=>{
            if (location.roomId && location.roomId !== this.playerEntity?.roomId) return false;
            const bounds = this.getViewportBounds(this.playerEntity.location);
            return location.x >= bounds.minX && location.x <= bounds.maxX && location.y >= bounds.minY && location.y <= bounds.maxY;
        };
        // Get culling distance for other systems
        this.getCullingDistanceTiles = ()=>{
            return this.CULLING_DISTANCE_TILES;
        };
        this.getCullingDistanceSquared = ()=>{
            return this.cullingDistanceSquared;
        };
        // Check if entities need to be resorted for rendering optimization
        this.shouldResortEntities = (playerPos)=>{
            // Check if player moved significantly
            const playerMoved = !this.lastPlayerPosForViewport || Math.abs(playerPos.x - this.lastPlayerPosForViewport.x) > 25 || Math.abs(playerPos.y - this.lastPlayerPosForViewport.y) > 25;
            // The renderer caches this viewport query too. Honor its invalidation when another
            // entity moves, appears or disappears, even while the player stands still.
            const viewportChanged = this.viewportManager?.needsVisibleEntitiesRefresh(playerPos) ?? false;
            const playerInitialized = this.isPlayerInitialized();
            const shouldResort = !playerInitialized || playerMoved || this.entitySortCacheInvalidated || viewportChanged;
            if (shouldResort) {
                this.lastPlayerPosForViewport = {
                    x: playerPos.x,
                    y: playerPos.y
                };
                this.entitySortCacheInvalidated = false;
            }
            return shouldResort;
        };
        // Invalidate viewport cache when needed (e.g., when map changes)
        this.invalidateViewportCache = ()=>{
            this.viewportBoundsValid = false;
            // A camera update changes the query, not the indexed entity positions.
            // Room transitions reset the index separately when initializing the new map.
            this.viewportManager?.forceInvalidateCache();
        };
        // Invalidate entity sort cache when needed (e.g., when player position updates)
        this.invalidateEntitySortCache = ()=>{
            this.entitySortCacheInvalidated = true;
        };
        // Optimized viewport bounds calculation with caching
        this.getViewportBounds = (playerPos)=>{
            // Cull around the displayed camera while it eases toward a new position.
            playerPos = this.clientRenderer.map().getCameraCenter?.() ?? playerPos;
            // Check if we need to recalculate based on player movement
            const playerMoved = this.lastPlayerPosForViewport && (Math.abs(playerPos.x - this.lastPlayerPosForViewport.x) > this.VIEWPORT_CACHE_THRESHOLD || Math.abs(playerPos.y - this.lastPlayerPosForViewport.y) > this.VIEWPORT_CACHE_THRESHOLD);
            if (!this.viewportBoundsValid || playerMoved) {
                this.calculateViewportBounds(playerPos);
                this.lastPlayerPosForViewport = {
                    x: playerPos.x,
                    y: playerPos.y
                };
                this.viewportBoundsValid = true;
            }
            return this.cachedViewportBounds;
        };
        this.calculateViewportBounds = (playerPos)=>{
            const X_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportX;
            const Y_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportY - 1;
            // Calculate viewport center based on TranslationComputer logic
            let viewportCenterX = playerPos.x;
            let viewportCenterY = playerPos.y;
            // Check if player is in bounds (not at edges)
            const inBoundsX = playerPos.x > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR && playerPos.x < (this.tilemapMetaProvider.width() - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const inBoundsY = playerPos.y > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR && playerPos.y < (this.tilemapMetaProvider.height() - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            // If not in bounds, use edge positions (like TranslationComputer)
            if (!inBoundsX) {
                if (playerPos.x <= (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR) viewportCenterX = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR;
                else viewportCenterX = (this.tilemapMetaProvider.width() - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            }
            if (!inBoundsY) {
                if (playerPos.y <= (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR) viewportCenterY = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR;
                else viewportCenterY = (this.tilemapMetaProvider.height() - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            }
            // Calculate viewport bounds
            const offsetWidth = X_FACTOR * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $10da07838e6d507c$export$aa707847c2571374).viewportPaddingX;
            const offsetHeight = Y_FACTOR * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $10da07838e6d507c$export$aa707847c2571374).viewportPaddingY;
            // Update the cached bounds object instead of creating a new one
            this.cachedViewportBounds.minX = viewportCenterX - offsetWidth;
            this.cachedViewportBounds.maxX = viewportCenterX + offsetWidth;
            this.cachedViewportBounds.minY = viewportCenterY - offsetHeight;
            this.cachedViewportBounds.maxY = viewportCenterY + offsetHeight;
        };
        // Passive floors own separate entity snapshots; cosmetic events must reach those bodies too.
        this.getAnimationEntity = (entityId)=>{
            const local = this.entityManager.get(entityId);
            if (local?.roomId === this.playerEntity?.roomId) return local;
            return this.clientRenderer.map().getSceneEntity?.(entityId) ?? local;
        };
        this.doStruck = (entityId, strikerEntityId)=>{
            const entity = this.getAnimationEntity(entityId);
            if (!entity) return;
            if (!this.isTooDistantFromPlayer(entity)) {
                this.clientRenderer.entity().animateStrikeOn(entity);
                this.audio.hit(entity);
            }
            const strikerEntity = this.entityManager.get(strikerEntityId);
            if (strikerEntity) this.scheduleForDestruction(strikerEntityId);
            if (entity.entityId === this.playerEntity.entityId) {
                this.clientRenderer.map().screenShake(entity);
                if (entity.hp < Math.max(3, Math.ceil(entity.maxHp * 0.6))) this.clientRenderer.gui().pulseDamage();
            }
        };
        this.tileEffect = (effect)=>{
            if (effect.roomId && effect.roomId !== this.tilemapMetaProvider?.roomId) // Another storey of this building: it plays on that storey, where it is drawn.
            this.clientRenderer.map().sceneTileEffect?.(effect);
            else {
                if (effect.hp !== undefined && effect.hpMax !== undefined && (effect.effectType === "damage" || effect.effectType === "repair")) this.tilemapMetaProvider.setMapDeltaHealth(effect.mapRoughCoordinates, effect.hp, effect.hpMax, effect.layerId);
                this.clientRenderer.map().tileEffect(effect);
            }
            if (effect.effectType === "arrow-impact") this.audio.play("woodhit", {
                volume: .18,
                speed: .65 + Math.random() * .08
            });
            else if (effect.effectType !== "repair" && !(0, $ff74dc2a666565c1$export$59557e9589aeede8)(effect.entityTile) && effect.entityTile !== "tallReeds") this.audio.play("woodhit", {
                volume: 0.125,
                speed: 0.85 + Math.min(0.15, Math.random())
            });
        };
        this.detonate = (entityId)=>{
            const entity = this.getAnimationEntity(entityId);
            if (entity) {
                if (!this.isTooDistantFromPlayer(entity)) this.clientRenderer.entity().detonate(entity);
            }
        };
        this.attack = (entityId, trigger)=>{
            const entity = this.getAnimationEntity(entityId);
            if (entity) {
                if (!this.isTooDistantFromPlayer(entity)) {
                    if (entity.roomId === this.playerEntity.roomId) this.playerController.client.startAttack(entityId);
                    this.clientRenderer.entity().attack(entity, trigger);
                    this.audio.attack(entity);
                }
            }
        };
        this.updateActivation = (entityId, active)=>{
            const entity = this.getAnimationEntity(entityId);
            if (entity) this.clientRenderer.entity().updateActivation(entity, active);
        };
        this.itemPickup = (entity, itemTypeMeta, quantity)=>{
            this.clientRenderer.entity().itemPickedUp(entity, itemTypeMeta, quantity);
            this.audio.pickup(itemTypeMeta);
        };
        this.orientation = (orientation)=>{
            this.playerController.updateOrientation(orientation);
        };
        this.emp = (entityId, range)=>{
            const entity = this.getAnimationEntity(entityId);
            if (entity) {
                this.clientRenderer.entity().emp(entity, range);
                this.audio.emp(entity);
            }
        };
        this.sparkle = (entityId)=>{
            const entity = this.getAnimationEntity(entityId);
            if (entity) {
                if (!this.isTooDistantFromPlayer(entity)) this.clientRenderer.entity().sparkle(entity);
            }
        };
        this.killed = (entityId)=>{
            const entity = this.getAnimationEntity(entityId);
            if (entityId === this.playerEntity.entityId) {
                this.clientRenderer.entity().death(this.playerEntity);
                this.playerController.paralyze(true, 5000);
            // this.clientRenderer.gui().fadeOut()
            } else if (entity) {
                this.clientRenderer.entity().death(entity);
                this.audio.death(entity);
            }
        };
        /**
     * Lift the death freeze. TWO flags, not one, and they are what updateFromPlayerMessage sets
     * together: the CONTROLLER's, which refuses input, and the ENTITY's mirror, which everything
     * that draws the player reads -- it is what lays the body down, and what the health meter reads
     * to know that the hp it is being handed is not the number to draw.
     *
     * Clearing only the controller's is why "Try again" and "Restart" left the player standing and
     * walking with an empty heart row: the mirror was still saying they were face down, and nothing
     * in either path was ever going to say otherwise.
     */ this.standUp = ()=>{
            this.playerController.setDowned(false);
            this.playerEntity.downed = false;
        };
        this.respawned = (entityId)=>{
            if (entityId === this.playerEntity.entityId) {
                // Alive again: lift the death freeze here rather than waiting for the next world-state
                // message to say so. The server cleared it before sending this, so the two agree --
                // this just spares the player a beat of being stood up but unable to move.
                this.standUp();
                this.fadeInOut("in");
                setTimeout(()=>{
                    this.playerController.perturb();
                }, 100);
            }
        };
        this.teleported = (entityId)=>{
            if (entityId === this.playerEntity.entityId) {
                // This notification arrives before the destination map and has no room context.
                // Let TranslationComputer.update preserve linked-floor pans or reset unrelated rooms.
                this.invalidateViewportCache();
                this.invalidateEntitySortCache();
            }
        };
        this.pleaseWait = ()=>{
            this.clientRenderer.gui().addScreenMessage({
                text: "Loading, please wait...",
                target: "important"
            });
            this.fadeInOut("inOut", 10000);
        };
        /**
     * One frame's worth of "is the room ready to be looked at yet?", driven from the end of the
     * frame loop so it reads the scene the player would have just been shown.
     *
     * Does nothing unless a room load is being held (see RoomReveal) -- which is the only state in
     * which the screen is deliberately black with nothing scheduled to lift it.
     */ /** The room-load curtain is down (RoomReveal): work done now is unseen. */ this.isRoomRevealHolding = ()=>this.roomReveal.isHolding();
        this.canRenderFloorFallArrival = ()=>!this.roomReveal.isHolding() && !this.clientRenderer.gui().isBlackoutVisible?.();
        this.tickRoomReveal = ()=>{
            if (!this.roomReveal.isHolding()) return;
            // Falls reveal as soon as the destination map and our own body can draw.
            // Other entities and the ordinary room settle/fade must not delay the drop.
            if (this.playerEntity?.floorFall?.fromAbove && this.playerEntity.roomId === this.roomId) {
                if (this.clientRenderer.map().hasPendingRender() || !(this.clientRenderer.entity().isPlayerReadyToShow?.() ?? true)) return;
                this.roomReveal.cancel();
                this.fadeInOut("in", 0);
                return;
            }
            // A scene change's own dark hold outranks the room being ready. A room load usually settles
            // faster than the hold does, and opening the moment it does is exactly the cut a transition
            // exists to avoid -- see Protocol.TransitFade. Checked BEFORE shouldReveal, which disarms the
            // hold when it answers yes.
            if (this.transitHoldUntilTs && Date.now() < this.transitHoldUntilTs) return;
            const ready = this.roomReveal.shouldReveal(Date.now(), {
                mapPending: this.clientRenderer.map().hasPendingRender(),
                spritesPending: this.clientRenderer.entity().pendingSpriteCount()
            });
            if (ready) this.fadeInOut("in");
        };
        /**
     * The screen between one place and another.
     *
     * Plain "out" is what every teleport has always done: snap to black, lock the controls, and let
     * the room load lift the curtain. With a `transition` the mover is asking for a scene change
     * instead -- see Protocol.TransitFade, and `beginTransit` below for the shape of it.
     */ this.fadeInOut = (direction, timeOut = 1000, transition)=>{
            if (direction === "in") {
                if (this.blackedOutTimeout) {
                    clearTimeout(this.blackedOutTimeout);
                    this.blackedOutTimeout = undefined;
                }
                this.transitHoldUntilTs = 0;
                this.clientRenderer.gui().fadeIn(timeOut === 0);
                this.playerController.paralyze(false);
                if (this.transitBodyMs) {
                    this.clientRenderer.entity().fadePlayer("in", this.transitBodyMs);
                    this.transitBodyMs = 0;
                }
            }
            if (direction === "out") {
                if (transition) {
                    this.beginTransit(transition);
                    return;
                }
                this.clientRenderer.gui().fadeOut(true);
                this.playerController.paralyze(true, timeOut);
            }
            if (direction === "inOut") {
                this.fadeInOut("out", timeOut);
                this.blackedOutTimeout = setTimeout(()=>{
                    this.fadeInOut("in");
                }, timeOut);
            }
        };
        /**
     * Going somewhere, as something the player watches: dissolve, curtain, hold, and back.
     *
     * The three numbers come from whoever is moving the player (Protocol.TransitFade). The one thing
     * this CANNOT do is defer the move itself -- the client is not told a teleport is coming -- so the
     * mover owes the body `bodyMs + screenMs` of standing still before it teleports, or the dissolve
     * plays in a room the player has already left.
     *
     * The controls are locked for the whole of it and then some: the lock is a deadline rather than a
     * timer (see Player.paralyze), which matters because the teleport, when it lands, sends its own
     * plain fade-out whose default 1s lock would otherwise expire inside the dark and hand movement
     * back early.
     */ this.beginTransit = (transition)=>{
            const { bodyMs: bodyMs, screenMs: screenMs, holdMs: holdMs } = transition;
            this.transitBodyMs = bodyMs;
            this.transitHoldUntilTs = Date.now() + bodyMs + screenMs + holdMs;
            this.playerController.paralyze(true, bodyMs + screenMs + holdMs + (0, $5c0480e062007d96$export$67d3b0fae8e525cf).MAX_HOLD_MS);
            this.clientRenderer.entity().fadePlayer("out", bodyMs);
            if (this.transitScreenTimeout) clearTimeout(this.transitScreenTimeout);
            // The curtain follows the body down rather than covering it: the dissolve is the half of a
            // departure that a snap to black has no room for.
            this.transitScreenTimeout = setTimeout(()=>{
                this.transitScreenTimeout = undefined;
                this.clientRenderer.gui().fadeOut(false, screenMs);
            }, bodyMs);
            // THE CAP, for the same reason RoomReveal has one: a curtain nothing lifts is a worse bug
            // than whatever it was closed against. Everything that would normally open this screen is on
            // the far side of a move that has not happened yet -- so a descent that is called off in the
            // pause (the player logged out, died, was teleported by something else) would otherwise leave
            // them black, blind and unable to walk with nothing scheduled to free them. Cleared by the
            // ordinary fade in, which is what happens every other time.
            if (this.blackedOutTimeout) clearTimeout(this.blackedOutTimeout);
            this.blackedOutTimeout = setTimeout(()=>this.fadeInOut("in"), bodyMs + screenMs + holdMs + (0, $5c0480e062007d96$export$67d3b0fae8e525cf).MAX_HOLD_MS);
        };
        this.advanceEntity = (result, entity, message, allowSlide)=>{
            // Reconciliation also replays packets from before the stair request.
            if (message.input_sequence_number < entity.stairTravel?.climb?.inputSequenceNumber) return;
            if (!this.tilemapMetaProvider) return;
            return entity.applyInput(message.angle, message.press_time, message.speed2, result, (0, $cb689cfa16c444ba$export$7e89f2bfd67dd894)(this.tilemapMetaProvider), allowSlide, allowSlide);
        };
        this.advancePlayer = (result, message)=>{
            const { x: originalX, y: originalY } = this.playerEntity.location;
            this.advanceEntity(result, this.playerEntity, message, true);
            this.clientRenderer.updatePlayerLocation(this.playerEntity);
            if (originalX !== this.playerEntity.location.x || originalY !== this.playerEntity.location.y) this.audio.walk(this.playerEntity);
        };
        // `hold` marks a line the player dismisses themselves: its bubble grows a "Next" button and
        // stays up until pressed, and anything the same entity says meanwhile queues behind it (see
        // AvatarHud.spoke). `holdId` is the token the speaker gave that line; pressing Next sends it
        // back so a script pacing a conversation off the player (ember-tutorial.js) knows WHICH line was
        // read and may speak the next one. The HUD-side copies below still expire on the usual clock --
        // they are captions for a speaker the player can't see, not the bubble itself.
        this.handleChat = (message, entityId, entityName, hold, holdId, autoAdvance)=>{
            const soundCommand = message.match(/^\u0000sound:(on|off)$/);
            if (soundCommand && entityId === this.playerEntity?.entityId) {
                this.audio.setSoundEnabled(soundCommand[1] === "on");
                return;
            }
            const entity = this.entityManager.get(entityId);
            // Player chat is server-wide by design, so the LOG takes every line it is given, wherever
            // the speaker is standing. Nothing SPATIAL does: a bubble, an offscreen arrow's caption, the
            // PiP caption -- those all claim the speaker is somewhere near, and for a speaker in another
            // room that is simply false.
            //
            // The server already keeps out-of-room lines off the wire (ServerGameLogic
            // .broadcastChatMessage), but a client can still be HOLDING a speaker it has just left
            // behind: entities are discarded lazily on a room change, so for a moment the camp the
            // player walked out of is still in the entity manager. A HELD line landing there never
            // fades -- it sits and everything after it queues up, which is the "the other camp's Lord is
            // collecting in mine" bug.
            const elsewhere = !!entity?.roomId && entity.roomId !== this.playerEntity?.roomId;
            if (entityName) this.clientRenderer.gui().appendChatHistory(message, entityName);
            if (entity && !elsewhere) this.clientRenderer.entity().spoke(entity, message, {
                hold: hold,
                autoAdvance: autoAdvance,
                onDismissed: hold ? ()=>this.playerController?.client?.sendSpeechDismissed(entityId, holdId) : undefined
            });
            if (elsewhere) return;
            // Record speech so an offscreen tracked member's bubble can ride its arrow.
            // Duration mirrors the avatar HUD bubble (avatar_hud.spokeImpl).
            const wordCount = message.split(" ").length;
            const durationMs = Math.max(3000, wordCount * 60 / 200 * 1250);
            this.recentSpeech.set(entityId, {
                text: message,
                expiresAt: Date.now() + durationMs
            });
            // Longer-lived copy for the follow-cam PiP caption.
            this.lastSpeech.set(entityId, {
                text: message,
                expiresAt: Date.now() + 10000
            });
        };
        // Returns the entity's current speech-bubble text, or null if none/expired.
        this.getRecentSpeech = (entityId)=>{
            const s = this.recentSpeech.get(entityId);
            if (!s) return null;
            if (Date.now() >= s.expiresAt) {
                this.recentSpeech.delete(entityId);
                return null;
            }
            return s.text;
        };
        // Returns the entity's last spoken line for the follow-cam PiP caption, or null once it's older
        // than ~10s. Outlives getRecentSpeech so the PiP keeps showing the last words a while.
        this.getLastSpeech = (entityId)=>{
            const s = this.lastSpeech.get(entityId);
            if (!s) return null;
            if (Date.now() >= s.expiresAt) {
                this.lastSpeech.delete(entityId);
                return null;
            }
            return s.text;
        };
        // Mirror the latest ember roster into the entityId -> role lookup used by the offscreen
        // faction tracker. Called alongside the HUD widget update from the roster broadcast.
        this.setEmberRoster = (roster)=>{
            this.emberRoles.clear();
            this.emberStatuses.clear();
            for (const entry of roster){
                this.emberRoles.set(entry.entityId, entry.role);
                if (entry.status) this.emberStatuses.set(entry.entityId, entry.status);
            }
        };
        this.getEmberRole = (entityId)=>this.emberRoles.get(entityId) ?? null;
        this.getEmberStatus = (entityId)=>this.emberStatuses.get(entityId) ?? null;
        this.hideRoomName = (hidden)=>{
            this.clientRenderer.gui().hideRoomName(hidden);
        };
        this.updateLocation = (location, roomId)=>{
            if (this.scene.contains(roomId)) this.clientRenderer.gui().updateLocation(location);
        };
        this.renderScene = ()=>{
            this.clientRenderer.updatePlayerLocation(this.playerEntity);
            // one ring to rule them all
            this.clientRenderer.render();
        };
        // Get shadow performance metrics for debugging
        this.getShadowPerformanceMetrics = ()=>{
            return this.clientRenderer.getShadowPerformanceMetrics();
        };
        // Force shadow texture update (useful for debugging)
        this.forceShadowTextureUpdate = ()=>{
            this.clientRenderer.forceShadowTextureUpdate();
        };
        this.createLocalEntity = (entitySrc)=>{
            const entity = (0, $cb689cfa16c444ba$export$bc644a473284d944).fromJson(entitySrc);
            setTimeout(()=>{
                this.entityManager.set(entity);
                this.clientRenderer.entity().create(entity);
            }, 250);
        };
        this.destroyLocalEntity = (targetFlags)=>{
            this.entityManager.collect((entity)=>{
                return !Object.keys(targetFlags).find((flag)=>targetFlags[flag] !== entity.flags[flag]);
            }).forEach((entity)=>{
                entity.visible = false;
                this.scheduleForDestruction(entity.entityId);
            });
        };
        this.playSoundEffect = (effect, loop, target, source)=>{
            this.audio.soundEffect(effect, loop, target, source);
            // The fire flares with the knock of the log going on, seen and heard as one moment.
            if (effect === "campfire_fed" || effect === "campfire_lit") this.clientRenderer?.entity?.()?.flareFires?.();
        };
        this.enablePlayerMouseAction = (enabled)=>this.playerController?.enabledMouseAction(enabled);
        this.animateLocalEntityCollection = (entityId, target, position)=>{
            const entity = this.entityManager.get(entityId);
            if (!entity) return;
            entity.visible = false;
            this.clientRenderer.gui().animateLocalEntityCollection(entity, target, position);
        };
        this.animateAbility = (abilityType, duration)=>{
            this.clientRenderer.gui().animateAbility(abilityType, duration);
        };
        this.upgradedAccount = ()=>{
            this.playerController.setIsGuest(false);
            this.clientRenderer.gui().helpMessaging();
        };
        this.updateVisibility = (visibility)=>{
            const currentVisibility = this.clientRenderer.map().getVisibility();
            const nextVisibility = this.scene.visibility({
                ...currentVisibility || {},
                ...visibility
            });
            this.clientRenderer.map().update(null, nextVisibility);
        };
        this.updateDayPhase = (phase)=>{
            this.scene.updateDayPhase(phase);
        };
        this.log = (text)=>{
            this.playerController.client.logActivity(text);
        };
        this.incompleteEntity = (entity)=>{
            this.incompleteEntities.add(entity.entityId);
        };
        this.nearbyIncompleteEntities = ()=>{
            const entities = [];
            this.incompleteEntities.forEach((e)=>{
                if (e === this.playerEntity.entityId) return false;
                const inc = this.entityManager.get(e);
                if (!inc) return false;
                const distance = (0, $cb689cfa16c444ba$export$79376507b09a66f)(inc.location.x, inc.location.y, this.playerEntity.location.x, this.playerEntity.location.y);
                if (distance < 10 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) entities.push(e);
            });
            return entities;
        };
        this.clearIncompleteEntities = (entityIds)=>{
            entityIds.forEach((id)=>{
                this.incompleteEntities.delete(id);
            });
        };
        this.saveAppearance = (appearance)=>{
            this.playerController.client.saveAppearance(appearance);
        };
        this.invokeCrafting = ()=>{
            this.playerController.client.emitPlayerEvent({
                playerEventType: "REQUEST_CRAFTING",
                context: {}
            });
        };
        this.invokeInventory = (inventoryActionToken)=>{
            this.playerController.client.emitPlayerEvent({
                playerEventType: "REQUEST_INVENTORY",
                context: {
                    actionToken: inventoryActionToken
                }
            });
        };
        this.invokeQuests = ()=>{
            this.playerController.client.emitPlayerEvent({
                playerEventType: "REQUEST_QUESTS",
                context: {}
            });
        };
        this.emitConversationResponse = (response)=>{
            this.playerController.client.emitPlayerEvent({
                playerEventType: "CONVERSATION_RESPONSE",
                context: response
            });
        };
        this.requestEntityInteractions = (entityId)=>{
            this.playerController.client.emitPlayerEvent({
                playerEventType: "REQUEST_ENTITY_INTERACTIONS",
                context: {
                    entityId: entityId
                }
            });
        };
        this.interactionCallback = (entityId, interaction, holdPhase)=>{
            // Clicking an interaction icon must never also trigger a world attack. The click that
            // fires attacks originates from a document-level mousedown that doesn't know a pixi
            // interaction widget was hit, so briefly suppress attacks around the activation.
            this.playerController.suppressAttack();
            this.playerController.client.emitPlayerEvent({
                playerEventType: "ACTIVATE_ENTITY_INTERACTION",
                context: {
                    interaction: interaction,
                    entityId: entityId,
                    holdPhase: holdPhase
                }
            });
        };
        this.selectSlot = (itemId)=>{
            const item = this.playerEntity.inventory?.items.find((i)=>i.id === itemId);
            if (!item) return;
            this.playerController.client.inventoryAction(this.playerEntity.entityId, itemId, item.active ? "deactivate" : "activate");
        };
        // Back out of an armed placement (the "Ready" option on a buildable item, or a build the player
        // no longer wants to commit). Deactivating the item is what actually ends build mode: the server's
        // building atom turns the terrain pointer back off when it sees INACTIVATE_ITEM.
        this.cancelBuildPlacement = ()=>{
            const item = this.playerEntity?.inventory?.items?.find((i)=>i.active && (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.buildable(i.itemTypeMeta));
            if (!item) return;
            this.playerController.client.inventoryAction(this.playerEntity.entityId, item.id, "deactivate");
        };
        this.activateWorldPoint = (roomFinePoint, options)=>{
            if ((0, $a80d0b17b615d6f7$export$ead25a0ad81e18f0)(roomFinePoint)) return;
            this.playerController.client.activateWorldPoint(roomFinePoint, options);
        };
        this.entityClicked = (entity)=>{
            if (entity.clickable) // todo - rename this, entity.clickable means that the server has some
            // plan for whenever the player explicitly clicks on the entity
            this.playerController.client.entityClicked(entity);
        };
        // Spatial indexing methods for efficient culling
        this.initializeViewportManager = ()=>{
            if (!this.tilemapMetaProvider) return;
            // Get world dimensions
            const worldWidth = this.tilemapMetaProvider.width() * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const worldHeight = this.tilemapMetaProvider.height() * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            // Reuse existing viewport manager if it exists, otherwise create new one
            if (this.viewportManager) // Reset with new dimensions
            this.viewportManager.reset(worldWidth, worldHeight);
            else // Create new viewport manager
            this.viewportManager = new (0, $aa05461586bc3fba$export$8b098ebd5e242ae7)(this.entityManager, worldWidth, worldHeight);
        };
        // Apply a server-sent faction-tracking config (e.g. on entering an ember room).
        this.setFactionTracking = (config)=>{
            this.trackedFaction = config.faction;
            this.trackingEnabled = config.enabled && !!config.faction;
        };
        // Apply scene weather, including the empty configuration sent when leaving a camp.
        this.setRoomAmbience = (ambience)=>{
            this.scene.setAmbience(ambience);
        };
        // Get visible entities using spatial indexing - O(log n) instead of O(n)
        this.getVisibleEntities = (playerPos)=>{
            if (!this.viewportManager) // Fallback to old method if viewport manager not initialized
            return this.getVisibleEntitiesFallback(playerPos);
            return this.viewportManager.getVisibleEntities(playerPos);
        };
        // Fallback method using the old O(n) approach
        this.getVisibleEntitiesFallback = (playerPos)=>{
            const allEntities = this.entityManager.collect(()=>true);
            const entitiesWithDistance = [];
            for (const entity of allEntities)if (this.isEntityWithinCullingDistance(entity.entityId, entity.location, playerPos)) {
                const dx = entity.location.x - playerPos.x;
                const dy = entity.location.y - playerPos.y;
                const distSquared = dx * dx + dy * dy;
                entitiesWithDistance.push({
                    entity: entity,
                    distSquared: distSquared
                });
            }
            entitiesWithDistance.sort((a, b)=>a.distSquared - b.distSquared);
            return entitiesWithDistance;
        };
        // Get performance statistics for the viewport manager
        this.getViewportManagerStats = ()=>{
            return this.viewportManager?.getPerformanceStats() || null;
        };
        // Force cache invalidation (useful for debugging)
        this.forceInvalidateViewportCache = ()=>{
            this.viewportManager?.forceInvalidateCache();
        };
        this.clientRenderer = factory.create(this);
        this.audio = new (0, $479d799412e4e1cb$export$153755f98d9861de)(this);
        this.wireAreaProjectileFeedback();
        this.wireTreeFallFeedback();
    }
}




const $167efe97b4119a5d$export$b0f20d83cec42115 = ()=>{
    const inset = (0, $10da07838e6d507c$export$aa707847c2571374).viewportPaddingX * (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
    const insetY = (0, $10da07838e6d507c$export$aa707847c2571374).viewportPaddingY * (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
    return {
        left: -inset,
        right: 800 + inset,
        width: 800 + inset * 2,
        inset: inset,
        top: -insetY,
        bottom: 600 / (0, $10da07838e6d507c$export$c6ec669adaa5980d) + insetY,
        height: 600 / (0, $10da07838e6d507c$export$c6ec669adaa5980d) + insetY * 2,
        insetY: insetY
    };
};
const $167efe97b4119a5d$var$VIRTUAL_W = 800;
const $167efe97b4119a5d$var$VIRTUAL_H = 600;
const $167efe97b4119a5d$var$DISPLAY_RATIO = $167efe97b4119a5d$var$VIRTUAL_W / ($167efe97b4119a5d$var$VIRTUAL_H / (0, $10da07838e6d507c$export$c6ec669adaa5980d));
const $167efe97b4119a5d$var$MAX_BUFFER_PIXELS = 5000000;
const $167efe97b4119a5d$export$732c3502c7f18a71 = (width, height, dpr, mobile)=>{
    const wide = width / height >= $167efe97b4119a5d$var$DISPLAY_RATIO;
    const fillWidth = mobile && wide;
    const cssWidth = wide && !fillWidth ? height * $167efe97b4119a5d$var$DISPLAY_RATIO : width;
    const cssHeight = mobile || wide ? height : width / $167efe97b4119a5d$var$DISPLAY_RATIO;
    const virtualWidth = fillWidth ? width / height * ($167efe97b4119a5d$var$VIRTUAL_H / (0, $10da07838e6d507c$export$c6ec669adaa5980d)) : $167efe97b4119a5d$var$VIRTUAL_W;
    const virtualHeight = mobile && !wide ? height / width * $167efe97b4119a5d$var$VIRTUAL_W * (0, $10da07838e6d507c$export$c6ec669adaa5980d) : $167efe97b4119a5d$var$VIRTUAL_H;
    const stageX = (virtualWidth - $167efe97b4119a5d$var$VIRTUAL_W) / 2;
    const stageY = (virtualHeight - $167efe97b4119a5d$var$VIRTUAL_H) / 2;
    const maxResolution = Math.sqrt($167efe97b4119a5d$var$MAX_BUFFER_PIXELS / (virtualWidth * virtualHeight));
    return {
        cssWidth: cssWidth,
        cssHeight: cssHeight,
        virtualWidth: virtualWidth,
        virtualHeight: virtualHeight,
        stageX: stageX,
        stageY: stageY,
        resolution: Math.max(1, Math.min(cssWidth * dpr / virtualWidth, maxResolution))
    };
};


/** Follow the actual canvas host as a standalone iOS viewport settles after launch or resume. */ const $235fc386ca59d431$export$98b8b75b24ddd4c0 = (host, onResize)=>{
    let frame;
    const schedule = ()=>{
        if (frame !== undefined) return;
        frame = window.requestAnimationFrame(()=>{
            frame = undefined;
            onResize();
        });
    };
    const onVisible = ()=>{
        if (!document.hidden) schedule();
    };
    const observer = typeof ResizeObserver === "undefined" ? undefined : new ResizeObserver(schedule);
    observer?.observe(host);
    const viewport = window.visualViewport;
    viewport?.addEventListener("resize", schedule);
    window.addEventListener("resize", schedule);
    window.addEventListener("orientationchange", schedule);
    window.addEventListener("pageshow", schedule);
    document.addEventListener("visibilitychange", onVisible);
    // The first measurement can precede the Home Screen app's transition into its final size.
    schedule();
    return ()=>{
        if (frame !== undefined) window.cancelAnimationFrame(frame);
        observer?.disconnect();
        viewport?.removeEventListener("resize", schedule);
        window.removeEventListener("resize", schedule);
        window.removeEventListener("orientationchange", schedule);
        window.removeEventListener("pageshow", schedule);
        document.removeEventListener("visibilitychange", onVisible);
    };
};


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");



const $0d2b5753435eae0a$export$8877eac68a40feb8 = 44;
const $0d2b5753435eae0a$export$890f8dd7b4286392 = ({ viewport: viewport, cssScaleX: cssScaleX, cssScaleY: cssScaleY, touch: touch, phone: phone = (0, $10da07838e6d507c$export$3dc8fb2aae1f259d)(), safeInsets: safeInsets })=>{
    const scaleX = cssScaleX > 0 ? cssScaleX : 1;
    const scaleY = cssScaleY > 0 ? cssScaleY : 1;
    const inset = safeInsets ?? {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    const left = Math.min(viewport.width, Math.max(0, inset.left) / scaleX);
    const top = Math.min(viewport.height, Math.max(0, inset.top) / scaleY);
    const width = Math.max(0, viewport.width - left - Math.max(0, inset.right) / scaleX);
    const height = Math.max(0, viewport.height - top - Math.max(0, inset.bottom) / scaleY);
    return {
        viewport: viewport,
        scaleX: scaleX,
        scaleY: scaleY,
        touch: touch,
        phone: phone,
        density: width * scaleX < 700 || height * scaleY < 400 ? "compact" : "regular",
        safeViewport: {
            left: viewport.left + left,
            top: viewport.top + top,
            width: width,
            height: height,
            right: viewport.left + left + width,
            bottom: viewport.top + top + height
        },
        touchWidth: touch ? $0d2b5753435eae0a$export$8877eac68a40feb8 / scaleX : 0,
        touchHeight: touch ? $0d2b5753435eae0a$export$8877eac68a40feb8 / scaleY : 0
    };
};
const $0d2b5753435eae0a$export$f6b61e4228c6fc3e = ()=>typeof navigator !== "undefined" && (navigator.maxTouchPoints > 0 || (typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia("(any-pointer: coarse)").matches : (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()));
let $0d2b5753435eae0a$var$current = $0d2b5753435eae0a$export$890f8dd7b4286392({
    viewport: (0, $167efe97b4119a5d$export$b0f20d83cec42115)(),
    cssScaleX: 1,
    cssScaleY: 1,
    touch: $0d2b5753435eae0a$export$f6b61e4228c6fc3e()
});
let $0d2b5753435eae0a$var$rendererScaleX = 1;
let $0d2b5753435eae0a$var$rendererScaleY = 1;
const $0d2b5753435eae0a$export$f8d7a330bfe28b29 = ()=>$0d2b5753435eae0a$var$current;
const $0d2b5753435eae0a$export$8e3dbe48ecd549f5 = (input, stageScaleY = 1)=>{
    $0d2b5753435eae0a$var$current = $0d2b5753435eae0a$export$890f8dd7b4286392(input);
    $0d2b5753435eae0a$var$rendererScaleX = $0d2b5753435eae0a$var$current.scaleX;
    $0d2b5753435eae0a$var$rendererScaleY = $0d2b5753435eae0a$var$current.scaleY / stageScaleY;
};
const $0d2b5753435eae0a$export$7fe45ffd4b732106 = (control)=>{
    if (!control.parent) return {
        x: $0d2b5753435eae0a$var$current.scaleX * Math.abs(control.scale.x) || 1,
        y: $0d2b5753435eae0a$var$current.scaleY * Math.abs(control.scale.y) || 1
    };
    control.toGlobal({
        x: 0,
        y: 0
    });
    const m = control.worldTransform;
    return {
        x: Math.hypot(m.a * $0d2b5753435eae0a$var$rendererScaleX, m.b * $0d2b5753435eae0a$var$rendererScaleY) || 1,
        y: Math.hypot(m.c * $0d2b5753435eae0a$var$rendererScaleX, m.d * $0d2b5753435eae0a$var$rendererScaleY) || 1
    };
};
const $0d2b5753435eae0a$export$f71286780f6a70a = (control, width, height, maxPadding = Infinity)=>{
    const scale = $0d2b5753435eae0a$export$7fe45ffd4b732106(control);
    const limitX = typeof maxPadding === "number" ? maxPadding : maxPadding.x;
    const limitY = typeof maxPadding === "number" ? maxPadding : maxPadding.y;
    const padX = $0d2b5753435eae0a$var$current.touch ? Math.min(limitX, Math.max(0, ($0d2b5753435eae0a$export$8877eac68a40feb8 / scale.x - width) / 2)) : 0;
    const padY = $0d2b5753435eae0a$var$current.touch ? Math.min(limitY, Math.max(0, ($0d2b5753435eae0a$export$8877eac68a40feb8 / scale.y - height) / 2)) : 0;
    return new (0, $6qzqq.Rectangle)(-padX, -padY, width + padX * 2, height + padY * 2);
};
class $0d2b5753435eae0a$export$ca88597b86c9a1dc extends (0, $6qzqq.Rectangle) {
    constructor(measure){
        super(), this.measure = measure, this.refresh = ()=>{
            this.copyFrom(this.measure());
        };
        this.refresh();
    }
    contains(x, y) {
        this.refresh();
        return super.contains(x, y);
    }
}
const $0d2b5753435eae0a$export$495bff943178518d = (canvas, virtualWidth, virtualHeight, stageScaleY)=>{
    const bounds = canvas.getBoundingClientRect();
    const css = getComputedStyle(document.documentElement);
    const safe = (side)=>parseFloat(css.getPropertyValue(`--ui-safe-${side}`)) || 0;
    $0d2b5753435eae0a$export$8e3dbe48ecd549f5({
        viewport: (0, $167efe97b4119a5d$export$b0f20d83cec42115)(),
        touch: $0d2b5753435eae0a$export$f6b61e4228c6fc3e(),
        cssScaleX: bounds.width / virtualWidth,
        cssScaleY: bounds.height / virtualHeight * stageScaleY,
        safeInsets: {
            left: Math.max(0, safe("left") - bounds.left),
            right: Math.max(0, safe("right") - (window.innerWidth - bounds.right)),
            top: Math.max(0, safe("top") - bounds.top),
            bottom: Math.max(0, safe("bottom") - (window.innerHeight - bounds.bottom))
        }
    }, stageScaleY);
};
const $0d2b5753435eae0a$export$80d247c8fac4e59d = ()=>{
    const scale = Math.min(1, $0d2b5753435eae0a$var$current.scaleX, $0d2b5753435eae0a$var$current.scaleY);
    return $0d2b5753435eae0a$var$current.phone ? {
        padX: 10,
        padY: 8,
        glyphSize: Math.max((0, $ef882f0a643d87d9$export$a57e4d4d74a95378).title.fontSize, (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).compactLabel.fontSize / scale),
        labelSize: Math.max((0, $ef882f0a643d87d9$export$a57e4d4d74a95378).body.fontSize, (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).compactCaption.fontSize / scale),
        gap: 6,
        minWidth: Math.max(52, $0d2b5753435eae0a$var$current.touchWidth),
        minHeight: Math.max(52, $0d2b5753435eae0a$var$current.touchHeight),
        hitPad: 3,
        corner: 8,
        rowGap: 8
    } : {
        padX: 6,
        padY: 4,
        glyphSize: (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).compactLabel.fontSize,
        labelSize: (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).overline.fontSize,
        gap: 4,
        minWidth: 0,
        minHeight: 0,
        hitPad: 3,
        corner: 5,
        rowGap: 5
    };
};
const $0d2b5753435eae0a$export$eb43af23fb6f2b4a = ()=>$0d2b5753435eae0a$var$current.touch ? 17 : 11;



var $5UG8I = parcelRequire("5UG8I");
// Keys the page must not act on while the game has them. Tab is the one that actually bites: the
// browser's answer to it is to move focus off the canvas, after which these document-level
// handlers stop seeing anything at all and the game looks like it has frozen. A field that owns
// the keyboard is let through above, so tabbing inside the name prompt still works.
const $ea3f90e500565ae9$var$SWALLOWED = new Set([
    "Tab"
]);
class $ea3f90e500565ae9$export$16e4d70cc375e707 {
    static{
        this.state = new Map();
    }
    static{
        this.listeners = [];
    }
    static{
        this.pasteListeners = [];
    }
    static{
        // Set while a text field owns the keyboard (the name prompt). Keystrokes then reach only that
        // field: without this, naming a defender "Bryn" walks the player north-east and opens their
        // inventory, because every key the game reads is read from a document-level listener that
        // cannot see which DOM element has focus.
        this.typingSuppressed = false;
    }
    /**
     * Hand the keyboard to (or take it back from) a focused text field.
     *
     * Escape is deliberately NOT suppressed: it is how a player gets out of whatever is holding
     * the keyboard, so it has to keep reaching the handlers that close things.
     */ static suppressTyping(suppressed) {
        $ea3f90e500565ae9$export$16e4d70cc375e707.typingSuppressed = suppressed;
        if (suppressed) // Whatever was held when the field opened is released -- otherwise a key still down at
        // that moment would read as held for as long as the field is up (the movement loop
        // reads this map every frame, so clearing it is what stops the player walking).
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.clear();
    }
    static isSuppressed(key) {
        return $ea3f90e500565ae9$export$16e4d70cc375e707.typingSuppressed && key !== "Escape" && key !== "Esc";
    }
    static initialize() {
        // The `.bind(this)` here isn't necesary as these functions won't use `this`!
        document.addEventListener("keydown", $ea3f90e500565ae9$export$16e4d70cc375e707.keyDown);
        document.addEventListener("keyup", $ea3f90e500565ae9$export$16e4d70cc375e707.keyUp);
        // Paste. The game is a canvas, not a text field, so cmd/ctrl+V produces no keystroke that
        // anything upstream could use -- the pasted text only ever arrives on this event. It goes
        // to the listeners (the chat input is the only one today) and is dropped otherwise.
        document.addEventListener("paste", (event)=>{
            if ($ea3f90e500565ae9$export$16e4d70cc375e707.typingSuppressed) // A focused DOM text field (the name prompt) is handling its own paste.
            return;
            const text = event.clipboardData?.getData("text") || "";
            if (!text) return;
            $ea3f90e500565ae9$export$16e4d70cc375e707.pasteListeners.forEach((listener)=>listener(text));
        });
        document.addEventListener("mouseleave", (event)=>{
            if (event.clientY <= 0 || event.clientX <= 0 || event.clientX >= window.innerWidth || event.clientY >= window.innerHeight) $ea3f90e500565ae9$export$16e4d70cc375e707.state.clear();
        });
        window.addEventListener("blur", ()=>{
            $ea3f90e500565ae9$export$16e4d70cc375e707.state.clear();
        });
    }
    static modifiersOf(e) {
        return {
            shift: e.shiftKey,
            alt: e.altKey,
            ctrl: e.ctrlKey,
            meta: e.metaKey
        };
    }
    static keyDown(e) {
        if ($ea3f90e500565ae9$export$16e4d70cc375e707.isSuppressed(e.key)) return;
        if ($ea3f90e500565ae9$var$SWALLOWED.has(e.key)) e.preventDefault();
        const isUppercase = e.key == e.key.toUpperCase();
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.delete(e.key.toLowerCase());
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.delete(e.key.toUpperCase());
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.set(e.key, true);
        $ea3f90e500565ae9$export$16e4d70cc375e707.listeners.forEach((listener)=>listener(e.key, true, e.repeat, $ea3f90e500565ae9$export$16e4d70cc375e707.modifiersOf(e)));
    }
    static keyUp(e) {
        if ($ea3f90e500565ae9$export$16e4d70cc375e707.isSuppressed(e.key)) return;
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.delete(e.key.toLowerCase());
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.delete(e.key.toUpperCase());
        $ea3f90e500565ae9$export$16e4d70cc375e707.state.delete(e.key);
        $ea3f90e500565ae9$export$16e4d70cc375e707.listeners.forEach((listener)=>listener(e.key, false, false, $ea3f90e500565ae9$export$16e4d70cc375e707.modifiersOf(e)));
    }
    constructor(){
        this.addListener = (listener)=>{
            if ($ea3f90e500565ae9$export$16e4d70cc375e707.listeners.indexOf(listener) < 0) $ea3f90e500565ae9$export$16e4d70cc375e707.listeners.push(listener);
        };
        this.removeListener = (listener)=>{
            $ea3f90e500565ae9$export$16e4d70cc375e707.listeners = $ea3f90e500565ae9$export$16e4d70cc375e707.listeners.filter((l)=>l != listener);
        };
        this.addPasteListener = (listener)=>{
            if ($ea3f90e500565ae9$export$16e4d70cc375e707.pasteListeners.indexOf(listener) < 0) $ea3f90e500565ae9$export$16e4d70cc375e707.pasteListeners.push(listener);
        };
        this.removePasteListener = (listener)=>{
            $ea3f90e500565ae9$export$16e4d70cc375e707.pasteListeners = $ea3f90e500565ae9$export$16e4d70cc375e707.pasteListeners.filter((l)=>l != listener);
        };
        this.state = ()=>$ea3f90e500565ae9$export$16e4d70cc375e707.state;
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
class $f246f635ee3b2e66$export$7caecd373b84cec3 {
    static{
        this.listeners = [];
    }
    static{
        this.state = {
            position: new (0, $6qzqq.Point)(),
            buttons: new Map()
        };
    }
    static{
        this.worldRoots = [];
    }
    static{
        // True while a press that STARTED on the HUD is still held. The release has to be swallowed too,
        // or letting go over open ground would arrive as a world click the player never made.
        this.guiPress = false;
    }
    static setWorldRoots(roots) {
        $f246f635ee3b2e66$export$7caecd373b84cec3.worldRoots = roots.filter(Boolean);
    }
    /**
     * Did this press land on the HUD rather than on the world?
     *
     * Button presses are bound to the DOCUMENT, not to the stage, so pixi never hit-tests them and
     * every click reached the player controller wherever it landed: pressing Items, or the skip button
     * on the intro prompt, swung the player's weapon at whatever was behind it. Hovering used to be
     * the only defence (GuiManager.mouseOverControl), which meant every control had to remember to opt
     * in, and most never did.
     *
     * Asking pixi what is under the pointer settles it in one place instead. Nothing under the pointer,
     * or something belonging to a world layer, is a world press as before.
     */ static pressIsOnGui() {
        const interaction = $f246f635ee3b2e66$export$7caecd373b84cec3.app?.renderer?.plugins?.interaction;
        if (!interaction?.hitTest || $f246f635ee3b2e66$export$7caecd373b84cec3.worldRoots.length === 0) return false;
        return !$f246f635ee3b2e66$export$7caecd373b84cec3.isWorldPoint($f246f635ee3b2e66$export$7caecd373b84cec3.state.position);
    }
    /** Whether a canvas point is over the world, including empty ground, rather than HUD controls. */ static isWorldPoint(point) {
        const interaction = $f246f635ee3b2e66$export$7caecd373b84cec3.app?.renderer?.plugins?.interaction;
        if (!interaction?.hitTest || $f246f635ee3b2e66$export$7caecd373b84cec3.worldRoots.length === 0) return false;
        const hit = interaction.hitTest(point);
        if (!hit || hit === $f246f635ee3b2e66$export$7caecd373b84cec3.app?.stage) return true;
        for(let node = hit; node; node = node.parent){
            if ($f246f635ee3b2e66$export$7caecd373b84cec3.worldRoots.indexOf(node) >= 0) return true;
        }
        return false;
    }
    /**
     * What a DOM-level press landed on, in the display tree, or null for empty canvas.
     *
     * Presses are bound to the DOCUMENT rather than the stage (see pressIsOnGui), so pixi never
     * hit-tests them and a widget has no way of its own to tell whether a click belongs to it. This
     * answers that for any listener that needs it -- e.g. the HUD dismissing an open command wheel
     * on a press that landed anywhere else.
     *
     * `undefined` means the question can't be answered here (no interaction plugin, i.e. headless
     * tests). Callers should read that as "don't act", never as "landed on nothing".
     */ static pressTarget(at) {
        const interaction = $f246f635ee3b2e66$export$7caecd373b84cec3.app?.renderer?.plugins?.interaction;
        if (!interaction?.hitTest || !interaction?.mapPositionToPoint) return undefined;
        const point = new (0, $6qzqq.Point)();
        interaction.mapPositionToPoint(point, at.clientX, at.clientY);
        return interaction.hitTest(point) || null;
    }
    static initialize(app) {
        $f246f635ee3b2e66$export$7caecd373b84cec3.app = app;
        app.stage.on("pointermove", $f246f635ee3b2e66$export$7caecd373b84cec3.movePointer);
        // The canvas owns secondary clicks, including trackpad two-finger taps.
        app.view.addEventListener("contextmenu", (event)=>event.preventDefault());
        document.addEventListener("mousedown", $f246f635ee3b2e66$export$7caecd373b84cec3.pointerDown);
        document.addEventListener("mouseup", $f246f635ee3b2e66$export$7caecd373b84cec3.pointerUp);
        window.addEventListener("blur", ()=>{
            $f246f635ee3b2e66$export$7caecd373b84cec3.guiPress = false;
            $f246f635ee3b2e66$export$7caecd373b84cec3.state.buttons.clear();
            $f246f635ee3b2e66$export$7caecd373b84cec3.listeners.forEach((listener)=>listener($f246f635ee3b2e66$export$7caecd373b84cec3.state));
        });
    }
    static movePointer(e) {
        $f246f635ee3b2e66$export$7caecd373b84cec3.state.position = e.data.global;
        $f246f635ee3b2e66$export$7caecd373b84cec3.listeners.forEach((listener)=>listener($f246f635ee3b2e66$export$7caecd373b84cec3.state));
    }
    static pointerUp(e) {
        // The release of a press that began on the HUD is swallowed with it, and the button is left
        // false so nothing downstream thinks it is still being held.
        if ($f246f635ee3b2e66$export$7caecd373b84cec3.guiPress) {
            $f246f635ee3b2e66$export$7caecd373b84cec3.guiPress = false;
            $f246f635ee3b2e66$export$7caecd373b84cec3.state.buttons.set(e.button.toString(), false);
            return;
        }
        $f246f635ee3b2e66$export$7caecd373b84cec3.state.buttons.set(e.button.toString(), false);
        $f246f635ee3b2e66$export$7caecd373b84cec3.listeners.forEach((listener)=>listener($f246f635ee3b2e66$export$7caecd373b84cec3.state));
    }
    static pointerDown(e) {
        if ($f246f635ee3b2e66$export$7caecd373b84cec3.pressIsOnGui()) {
            // Never set the button: the world should not see this press at all, and a pointermove
            // arriving while it is held would otherwise read as a swing.
            $f246f635ee3b2e66$export$7caecd373b84cec3.guiPress = true;
            $f246f635ee3b2e66$export$7caecd373b84cec3.state.buttons.set(e.button.toString(), false);
            return;
        }
        $f246f635ee3b2e66$export$7caecd373b84cec3.state.buttons.set(e.button.toString(), true);
        $f246f635ee3b2e66$export$7caecd373b84cec3.listeners.forEach((listener)=>listener($f246f635ee3b2e66$export$7caecd373b84cec3.state));
    }
    constructor(){
        this.addListener = (listener)=>{
            if ($f246f635ee3b2e66$export$7caecd373b84cec3.listeners.indexOf(listener) < 0) $f246f635ee3b2e66$export$7caecd373b84cec3.listeners.push(listener);
        };
        this.removeListener = (listener)=>{
            $f246f635ee3b2e66$export$7caecd373b84cec3.listeners = $f246f635ee3b2e66$export$7caecd373b84cec3.listeners.filter((l)=>l != listener);
        };
        this.updateButton = (buttonId, val)=>{
            $f246f635ee3b2e66$export$7caecd373b84cec3.state.buttons.set(buttonId, val);
        };
        this.state = ()=>{
            return $f246f635ee3b2e66$export$7caecd373b84cec3.state;
        };
    }
}



/** Capabilities belong to a view, not to a second implementation of its artwork. */ const $1704411fa88dc9bf$export$e5daf445bbba1e2f = Object.freeze({
    interactions: true,
    minimap: true,
    camera: true,
    roofCutaway: true,
    occluderFade: true,
    grassSway: true,
    nameplates: true,
    healthBars: true,
    levelLabels: true,
    leaderHalo: true
});
const $1704411fa88dc9bf$export$784ce4bd6fedbedf = Object.freeze({
    ...$1704411fa88dc9bf$export$e5daf445bbba1e2f,
    interactions: false,
    minimap: false,
    camera: false,
    roofCutaway: false,
    occluderFade: false,
    grassSway: false,
    levelLabels: false,
    leaderHalo: false
});
const $1704411fa88dc9bf$export$5f95b9c185ae9263 = Object.freeze({
    ...$1704411fa88dc9bf$export$784ce4bd6fedbedf,
    roofCutaway: true
});


/**
 * Work too heavy for two of it to share a frame -- a storey drawn afresh, a storey's sun shadows re-cast -- takes turns:
 * the first job of a frame claims it, and the rest wait for the frames after. A block laid in a castle redrew two storeys
 * and re-cast their shadows all in one or two frames (~170ms of script); taking turns, the same work lands one job a
 * frame, each a fraction of that, and the block itself is drawn in the first.
 *
 * Callers exempt a storey's FIRST drawing and first cast in a room: a room arriving should be whole when it is revealed,
 * not filled in storey by storey.
 */ let $a17a83e5cb2d0838$var$frame = 0;
let $a17a83e5cb2d0838$var$claimedFrame = -1;
const $a17a83e5cb2d0838$export$c68a19ffc4e6cc19 = ()=>{
    $a17a83e5cb2d0838$var$frame++;
};
const $a17a83e5cb2d0838$export$666b3b940e8c9ba8 = ()=>{
    if ($a17a83e5cb2d0838$var$frame === 0) return true;
    if ($a17a83e5cb2d0838$var$claimedFrame === $a17a83e5cb2d0838$var$frame) return false;
    $a17a83e5cb2d0838$var$claimedFrame = $a17a83e5cb2d0838$var$frame;
    return true;
};
const $a17a83e5cb2d0838$export$63bf454cb404d2ce = ()=>$a17a83e5cb2d0838$var$frame > 0;
const $a17a83e5cb2d0838$export$9e9e4b1a7eab0b54 = ()=>{
    $a17a83e5cb2d0838$var$frame = 0;
    $a17a83e5cb2d0838$var$claimedFrame = -1;
};


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

// The body finishes on the authoritative deadline; disturbed soil gets time to settle afterward.
const $ab66af423f686729$var$SOIL_FADE_TAIL_MS = 350;
function $ab66af423f686729$export$5aae9beeefa90c8c(entity, body, surface, effects, completed, onStart) {
    let effect = effects.get(entity.entityId);
    if (!effect && !completed.has(entity.entityId) && entity.preSpawnEffectView?.type === "ground-rupture") {
        effect = new $ab66af423f686729$export$64fd5f90585b0412(surface, body, entity);
        effects.set(entity.entityId, effect);
        if (entity.hp > 0 && !entity.isDead() && entity.preSpawnEffectView.remainingMs > 0) onStart?.();
    }
    if (effect && !effect.update(entity)) {
        effect.destroy();
        effects.delete(entity.entityId);
        completed.add(entity.entityId);
    }
}
function $ab66af423f686729$export$33fd9cf5c2957616(effects, completed, visible) {
    effects.forEach((effect, id)=>{
        effect.art.visible = effect.debris.visible = !!visible(id);
        if (effect.isExpired()) {
            effect.destroy();
            effects.delete(id);
            completed.add(id);
        }
    });
}
class $ab66af423f686729$export$64fd5f90585b0412 {
    constructor(surface, body, entity, now = Date.now()){
        this.body = body;
        this.art = new (0, $gwPoJ.Graphics)();
        this.debris = new (0, $gwPoJ.Graphics)();
        this.clip = new (0, $gwPoJ.Graphics)();
        this.bodyInHole = true;
        this.rim = [];
        this.clods = [];
        this.durationMs = entity.preSpawnEffectView.durationMs;
        this.endsAt = now + entity.preSpawnEffectView.remainingMs;
        this.previousMask = body.mask;
        this.anchor = {
            x: entity.location.x,
            y: entity.location.y,
            groundY: entity.location.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763),
            size: Math.max(0.5, entity.spriteScale || 1),
            zIndex: body.zIndex
        };
        // Stable variation per spawn, so shapes neither flicker per frame nor repeat across a wave.
        let seed = 2166136261;
        for (const ch of entity.entityId)seed = Math.imul(seed ^ ch.charCodeAt(0), 16777619);
        const random = ()=>{
            seed = Math.imul(seed, 1664525) + 1013904223 | 0;
            return (seed >>> 0) / 4294967296;
        };
        this.rim = Array.from({
            length: 24
        }, ()=>0.82 + random() * 0.3);
        const earth = [
            0x423022,
            0x60442d,
            0x79573a,
            0x97714b
        ];
        this.clods = Array.from({
            length: 18
        }, (_, i)=>({
                angle: random() * Math.PI * 2,
                delay: 0.08 + random() * 0.3,
                life: 0.35 + random() * 0.35,
                kick: 10 + random() * 24,
                lift: 8 + random() * 22,
                size: 1 + random() * 2.5,
                spin: (random() - 0.5) * 6,
                color: earth[i % earth.length]
            }));
        // This is mask geometry only; it must never become ordinary world art.
        const { x: x, groundY: groundY, size: size } = this.anchor;
        this.clip.beginFill(0xffffff).drawRect(-256 * size, -512 * size, 512 * size, 512 * size).endFill();
        this.clip.position.set(x, groundY);
        surface.addChild(this.art, this.debris, this.clip);
        body.mask = this.clip;
    }
    // Called after the renderer sets the body's ordinary location each frame.
    update(entity, now = Date.now()) {
        const view = entity.preSpawnEffectView;
        if (entity.isDead() || entity.hp <= 0) return false;
        // A repeated/stale snapshot must never restart or extend the effect.
        if (view) this.endsAt = Math.min(this.endsAt, now + view.remainingMs);
        // An expired wire view ends emergence, not the local soil's fade-out.
        if (this.isExpired(now)) return false;
        const remaining = this.endsAt - now;
        const age = Math.max(0, 1 - remaining / this.durationMs);
        const t = Math.min(1, age);
        const { x: x, y: y, groundY: groundY, size: size, zIndex: zIndex } = this.anchor;
        // Once displaced beyond the opening, release the body rather than dragging the hole
        // or cutting a moved zombie in half at the original ground line.
        const dx = (entity.location.x - x) / (22 * size);
        const dy = (entity.location.y - y) / (8 * size);
        if (this.bodyInHole && (remaining <= 0 || dx * dx + dy * dy > 1)) this.releaseBody();
        const rise = Math.max(0, Math.min(1, (t - 0.16) / 0.74));
        // Hesitate under the crust, push upward, then settle into the standing position.
        const push = rise * rise * (3 - 2 * rise);
        if (this.bodyInHole) this.body.y += (1 - push) * 64 * size;
        this.art.position.set(x, groundY);
        this.art.zIndex = zIndex - 1;
        this.debris.zIndex = zIndex + 1;
        this.debris.position.copyFrom(this.art.position);
        this.debris.scale.set(size);
        this.debris.visible = this.body.visible;
        this.debris.clear();
        this.art.scale.set(size);
        this.art.visible = this.body.visible;
        this.art.clear();
        const fadeLeadMs = this.durationMs * 0.2;
        const fadeProgress = Math.max(0, Math.min(1, (now - (this.endsAt - fadeLeadMs)) / (fadeLeadMs + $ab66af423f686729$var$SOIL_FADE_TAIL_MS)));
        const fade = 1 - fadeProgress * fadeProgress * (3 - 2 * fadeProgress);
        const open = Math.min(1, t / 0.26);
        // Broken soil around a recessed, irregular opening. The inner dark edge is below the body.
        const outline = [], inner = [];
        this.rim.forEach((r, i)=>{
            const a = i * Math.PI * 2 / this.rim.length;
            outline.push(Math.cos(a) * 22 * r * open, Math.sin(a) * 8 * r * open);
            inner.push(Math.cos(a) * 17 * r * open, Math.sin(a) * 5.5 * r * open - 1);
        });
        this.art.beginFill(0x60452f, fade * 0.75).drawPolygon(outline).endFill();
        this.art.beginFill(0x211b16, fade * 0.92).drawPolygon(inner).endFill();
        this.art.beginFill(0x100e0b, fade * 0.45).drawEllipse(0, -1, 12 * open, 3.5 * open).endFill();
        // Sparse branching cracks, rather than a symmetrical starburst.
        for(let i = 0; i < 6; i++){
            const clod = this.clods[i], a = clod.angle, c = Math.cos(a), s = Math.sin(a);
            const reach = (23 + clod.kick * 0.35) * open;
            this.art.lineStyle(1, 0x352a20, fade * 0.7);
            this.art.moveTo(c * 17 * open, s * 6 * open);
            this.art.lineTo(c * reach * 0.8 + s * 2, s * reach * 0.3);
            this.art.lineTo(c * reach, s * reach * 0.4);
        }
        this.art.lineStyle(0);
        // Only the near lip overlaps the feet. Angular soil plates make the hole read as depth.
        for(let i = 1; i < 12; i++){
            const a = i * Math.PI / 12, r = this.rim[i];
            const x = Math.cos(a) * 19 * r * open, y = Math.sin(a) * 6.5 * r * open;
            this.debris.beginFill(i % 2 ? 0x755338 : 0x523c29, fade);
            this.debris.drawPolygon([
                x - 3,
                y - 1,
                x - 1,
                y - 3,
                x + 3,
                y - 1,
                x + 2,
                y + 2,
                x - 2,
                y + 2
            ]).endFill();
        }
        for (const clod of this.clods){
            const u = (age - clod.delay) / clod.life;
            if (u < 0 || u >= 1) continue;
            const c = Math.cos(clod.angle), s = Math.sin(clod.angle);
            const travel = clod.kick * (1 - Math.exp(-3 * u));
            const x = c * (12 * open + travel);
            const floorY = s * (4 * open + travel * 0.35);
            // Parabolic height is separate from the ground footprint: clods fall back to earth.
            const y = floorY - 4 * clod.lift * u * (1 - u);
            const alpha = fade * Math.min(1, (1 - u) / 0.2);
            const layer = s < 0 ? this.art : this.debris;
            const points = [];
            for(let j = 0; j < 5; j++){
                const a = j * Math.PI * 2 / 5 + u * clod.spin;
                const r = clod.size * (j % 2 ? 0.65 : 1);
                points.push(x + Math.cos(a) * r, y + Math.sin(a) * r);
            }
            layer.beginFill(clod.color, alpha).drawPolygon(points).endFill();
            // A lit upper facet and grounded shadow distinguish solid dirt from flat confetti.
            layer.beginFill(0xb18a5c, alpha * 0.5).drawRect(x - clod.size * 0.4, y - clod.size * 0.6, clod.size, 0.8).endFill();
            this.art.beginFill(0x211b16, alpha * 0.12 * (1 - u)).drawEllipse(x, floorY, clod.size * 1.2, 0.7).endFill();
            // Low, diffuse dust spreads sideways after each break through the crust.
            const dustAlpha = Math.sin(u * Math.PI) * fade * 0.045;
            const dustY = floorY - Math.sin(u * Math.PI) * 4;
            const radius = 2 + u * 7;
            for(let j = 0; j < 3; j++){
                layer.beginFill(0x9c805c, dustAlpha * (1 - j * 0.22));
                layer.drawEllipse(x + c * u * 5, dustY, radius + j * 2, (radius + j * 2) * 0.55).endFill();
            }
        }
        return true;
    }
    isExpired(now = Date.now()) {
        return now >= this.endsAt + $ab66af423f686729$var$SOIL_FADE_TAIL_MS;
    }
    releaseBody() {
        this.bodyInHole = false;
        if (this.body.mask === this.clip) this.body.mask = this.previousMask;
        // Pixi's mask setter restores renderable=true when the mask loses its last owner.
        // Remove and clear it immediately, including during the soil's fade tail.
        this.clip.parent?.removeChild(this.clip);
        this.clip.clear();
        this.clip.renderable = false;
        this.clip.visible = false;
    }
    destroy() {
        this.releaseBody();
        this.art.parent?.removeChild(this.art);
        this.debris.parent?.removeChild(this.debris);
        this.clip.parent?.removeChild(this.clip);
        this.art.destroy();
        this.debris.destroy();
        this.clip.destroy();
    }
}






parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $P8XPi = parcelRequire("P8XPi");
var $6qzqq = parcelRequire("6qzqq");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $d3fD1 = parcelRequire("d3fD1");
parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
class $a64b70167386625f$export$98e91636974d835d extends (0, $gwPoJ.Graphics) {
    doMovement(entity) {
    //
    }
    /**
     * Can this draw itself yet? Everything whose art is a texture it already holds answers yes the
     * moment it is constructed; an LPC composite has to fetch and bake its spritesheets first and
     * answers no until it has (see LpcComposite.isReadyToShow).
     *
     * Asked of the entities on screen while a freshly loaded room is held behind the curtain -- the
     * difference between opening the screen on a camp and opening it on the ground the camp will be
     * standing on half a second later. See RoomReveal.
     */ isReadyToShow() {
        return true;
    }
    update(hp, hpMax) {
    //
    }
    updateName(name) {
    //
    }
    updateSubmerged(submerged) {
    //
    }
    // Only the LPC composite draws a ground ring, so everything else ignores this. See
    // LpcComposite.updatePlayerRing and Entity.invading.
    updatePlayerRing(entity) {
    //
    }
    setId(id) {
    //
    }
    recolor(color) {
    //
    }
    updateBlinking(blinking) {
    //
    }
    updateScale(scale) {
    //
    }
    addTag() {
    //
    }
    removeTag() {
    //
    }
    updateSigil(sigil) {
    //
    }
    updateRole(role) {
    //
    }
    // Only the LPC composite draws a ground disc, so everything else ignores this -- same as the
    // player ring above it. The TIER is resolved by the rendering manager, which is the only place
    // that can see both of the channels feeding it. See MemberStatusHalo.
    updateStatusHalo(tier) {
    //
    }
    remove() {
        this.parent?.removeChild(this);
    }
    detonate() {
    //
    }
    updateLevel(level) {
    //
    }
    doAttack(entity, callback) {
    //
    }
    cleanup() {
    // Override in subclasses for cleanup logic
    }
    updateActivation(entity, active, callback) {
    //
    }
    doDamaged(entity) {
    //
    }
    spoke(message, options) {
    //
    }
    // Drop a held bubble and anything queued behind it, without acking the speaker (see
    // AvatarHud.releaseHeldSpeech).
    releaseHeldSpeech() {
    //
    }
    getDrawableSurface() {
        return null;
    //
    }
    /** The single frame this art is showing now, for the water to reflect; undefined when it has none. */ reflectionArt() {
        return undefined;
    }
    /** Ground contact in the world surface's coordinates, when this art has feet. */ grassContact() {
        return undefined;
    }
    updatePaperdoll(entity) {
    //
    }
    updateHalo(entity, enabled) {
    //
    }
    updateSpeed(factor) {
    //
    }
    fragment(entity, callback) {
    //
    }
    updateRotating(rotating) {
    //
    }
    onMouseOver(show) {
    //
    }
    // Warm outline glow shown while this entity is the one the player is pointing at (or, on touch,
    // the nearest interactable). Returns false when this renderable has no art of its own to trace --
    // an invisible marker standing on tile-drawn art -- so the caller can outline the map tiles
    // instead. See EntityHighlight.
    occlusionBody() {
        return undefined;
    }
    setHighlighted(on) {
        return false;
    }
    fadeIn() {
        this.alpha = 0;
        const t = setInterval(()=>{
            this.alpha += 0.1;
            if (this.alpha >= 1.0) {
                this.alpha = 1.0;
                clearInterval(t);
            }
        }, 25);
    }
    fadeOut(callback) {
        const t = setInterval(()=>{
            this.alpha -= 0.1;
            if (this.alpha <= 0.0) {
                this.alpha = 0;
                clearInterval(t);
                if (callback) callback();
            }
        }, 25);
    }
    getClickSurface() {
        return this;
    }
    setWorldOverlayItem(item) {
    //
    }
    updatePointerIcon(show, angle) {
    //
    }
    itemPickedUp(entity, itemTypeMeta, quantity) {
    //
    }
    feedback(entity, image, label, params) {
    //
    }
    updateSpriteId(spriteId) {
    //
    }
    updateAfk(afk) {
    //
    }
    addSidecar(entity) {
        if (entity.debug) {
            let g = this.sideCar;
            if (!g) {
                g = new $a64b70167386625f$export$98e91636974d835d();
                this.parent.addChild(g);
                this.sideCar = g;
            }
            g.clear();
            g.beginFill(0xff0000);
            g.alpha = 0.6;
            const bounds = entity.getCollisionBounds();
            // console.log(bounds.x1, bounds.y1, bounds.width, bounds.height)
            g.drawRect(bounds.x1, bounds.y1, bounds.width, bounds.height);
            g.endFill();
        }
    }
    getYOffset() {
        return -this.height * 0.25;
    }
    updateRenderedLocationFrom(entity) {
        this.x = entity.location.x;
        this.y = entity.location.y + this.getYOffset();
        this.addSidecar(entity);
    }
    constructor(...args){
        super(...args), this.defaultZIndex = 0, this.getCurrentColor = ()=>this.tint;
    }
}


// Pixel art for the campfire's flame, generated as plain RGBA so it can be baked into one texture
// strip per (style, size) and so a preview script can render exactly what the game draws.
//
// One frame holds everything that BURNS, laid over the cold pit art (packages/tools/src/campfire):
// a bed of coals that flicker on the crossed logs, flame tongues in hard-edged palette bands (the
// LPC look -- no soft blobs), sparks, and for a rain-damaged fire, smoke. The warm light the fire
// throws on the stones and ground is a separate additive halo (fireHalo), because a Graphics or a
// sprite has one blend mode and the flame must stay opaque to read in daylight.
//
// SEAMLESS LOOP: every frame is a pure function of a loop phase u in [0,1). The flame's noise is
// tileable in y and scrolls up exactly one period per loop; sways are whole-number multiples of
// 2*pi*u; sparks and smoke age as frac(u - birth). So frame N wraps to frame 0 with no jump.
//
// SIZE IS A LEVEL, NOT A SCALE: a dying fire draws a lower, narrower flame with fewer sparks, baked
// at one texel per world pixel. Scaling pixel art by 0.6 would drop rows and shimmer as it animates.
const $62714e84cc67bb35$export$e1ee5e6c989c9909 = 40;
const $62714e84cc67bb35$export$d7c63b2dfb321550 = 60;
const $62714e84cc67bb35$export$30963c68fc034da1 = 24;
const $62714e84cc67bb35$export$affdfacebd2f1c48 = 5;
const $62714e84cc67bb35$export$7e891f0f1feb4c8c = 20;
const $62714e84cc67bb35$export$1cbfc86cc98020e7 = 53;
const $62714e84cc67bb35$export$4ddc08c2df49c83d = 64;
const $62714e84cc67bb35$export$4537779a980f9fd8 = 44;
const $62714e84cc67bb35$export$50e96cc4dbddde02 = 32 // the halo's centre, also seated on the coals
;
const $62714e84cc67bb35$export$58b165dfc595b91b = 26;
// Full-size flame. Height is from the coals to the tallest tongue tips.
const $62714e84cc67bb35$var$FLAME_MAX_H = 34;
const $62714e84cc67bb35$var$FLAME_HALF_W = 8;
const $62714e84cc67bb35$var$rgb = (hex)=>[
        hex >> 16 & 0xff,
        hex >> 8 & 0xff,
        hex & 0xff
    ];
const $62714e84cc67bb35$var$PALETTE = {
    flame: [
        0xa8240c,
        0xe8501a,
        0xff8f1f,
        0xffc93c,
        0xfff1b0
    ].map($62714e84cc67bb35$var$rgb),
    coal: [
        0x6b1a0c,
        0xb8320e,
        0xf06a1a,
        0xffb43a
    ].map($62714e84cc67bb35$var$rgb),
    spark: [
        0xffe27a,
        0xffa02a,
        0xd8461a
    ].map($62714e84cc67bb35$var$rgb),
    halo: $62714e84cc67bb35$var$rgb(0xff4a0c)
};
const $62714e84cc67bb35$var$frac = (n)=>n - Math.floor(n);
const $62714e84cc67bb35$var$mod = (n, m)=>(n % m + m) % m;
const $62714e84cc67bb35$var$TAU = Math.PI * 2;
// Deterministic integer hash -> [0,1). Bakes are reproducible (and testable); fires still differ
// because each one starts on a random frame.
const $62714e84cc67bb35$var$hash = (x, y, seed)=>{
    let h = x * 374761393 + y * 668265263 + seed * 2147483647 | 0;
    h = Math.imul(h ^ h >>> 13, 1274126177);
    h ^= h >>> 16;
    return (h >>> 0) / 4294967296;
};
// Value noise whose lattice repeats every `period` cells in y, so scrolling it by exactly one period
// over the loop is seamless.
const $62714e84cc67bb35$var$loopNoise = (x, y, period, seed)=>{
    const x0 = Math.floor(x), y0 = Math.floor(y);
    let tx = x - x0, ty = y - y0;
    tx = tx * tx * (3 - 2 * tx);
    ty = ty * ty * (3 - 2 * ty);
    const ya = $62714e84cc67bb35$var$mod(y0, period), yb = $62714e84cc67bb35$var$mod(y0 + 1, period);
    const a = $62714e84cc67bb35$var$hash(x0, ya, seed) * (1 - tx) + $62714e84cc67bb35$var$hash(x0 + 1, ya, seed) * tx;
    const b = $62714e84cc67bb35$var$hash(x0, yb, seed) * (1 - tx) + $62714e84cc67bb35$var$hash(x0 + 1, yb, seed) * tx;
    return a * (1 - ty) + b * ty;
};
const $62714e84cc67bb35$var$levelFraction = (level)=>Math.max(1, Math.min($62714e84cc67bb35$export$affdfacebd2f1c48, level)) / $62714e84cc67bb35$export$affdfacebd2f1c48;
const $62714e84cc67bb35$export$aa2a5e3c476e8271 = (strength)=>Math.max(1, Math.min($62714e84cc67bb35$export$affdfacebd2f1c48, Math.ceil(Math.max(0, strength) * $62714e84cc67bb35$export$affdfacebd2f1c48 - 1e-6)));
const $62714e84cc67bb35$var$blend = (out, i, c, alpha)=>{
    if (alpha <= 0) return;
    const a0 = out[i + 3] / 255;
    const a = alpha + a0 * (1 - alpha);
    for(let k = 0; k < 3; k++)out[i + k] = Math.round((c[k] * alpha + out[i + k] * a0 * (1 - alpha)) / a);
    out[i + 3] = Math.round(a * 255);
};
const $62714e84cc67bb35$var$put = (out, stride, ox, x, y, c, alpha = 1)=>{
    if (x < 0 || x >= $62714e84cc67bb35$export$e1ee5e6c989c9909 || y < 0 || y >= $62714e84cc67bb35$export$d7c63b2dfb321550) return;
    $62714e84cc67bb35$var$blend(out, (y * stride + ox + x) * 4, c, alpha);
};
// The coals: a flat bed on the crossed logs, every coal breathing on its own slow cycle.
const $62714e84cc67bb35$var$drawCoals = (out, stride, ox, u, pal, lf)=>{
    const rx = 7 + 5 * lf, ry = 2.4 + 1.4 * lf;
    for(let y = Math.floor($62714e84cc67bb35$export$1cbfc86cc98020e7 - ry - 1); y <= $62714e84cc67bb35$export$1cbfc86cc98020e7 + ry + 1; y++)for(let x = Math.floor($62714e84cc67bb35$export$7e891f0f1feb4c8c - rx - 1); x <= $62714e84cc67bb35$export$7e891f0f1feb4c8c + rx + 1; x++){
        const dx = (x + 0.5 - $62714e84cc67bb35$export$7e891f0f1feb4c8c) / rx, dy = (y + 0.5 - $62714e84cc67bb35$export$1cbfc86cc98020e7) / ry;
        const d = dx * dx + dy * dy;
        if (d > 1) continue;
        const seed = $62714e84cc67bb35$var$hash(x, y, 7);
        if (seed < 0.25 + 0.35 * d) continue; // sparse at the rim
        const cycles = 1 + Math.floor($62714e84cc67bb35$var$hash(x, y, 8) * 3);
        const breathe = 0.5 + 0.5 * Math.sin($62714e84cc67bb35$var$TAU * (u * cycles + $62714e84cc67bb35$var$hash(x, y, 9)));
        const heat = (1 - d) * 0.75 + breathe * 0.45 + (seed - 0.5) * 0.3;
        const c = heat > 0.95 ? pal.coal[3] : heat > 0.65 ? pal.coal[2] : heat > 0.38 ? pal.coal[1] : pal.coal[0];
        $62714e84cc67bb35$var$put(out, stride, ox, x, y, c);
    }
};
// The flame is a few tongues licking up out of one base, each leaning and pulsing on its own
// whole-number cycle; the tallest stands in the middle. Their union is then carved by rising noise.
const $62714e84cc67bb35$var$TONGUES = [
    {
        dx: 0,
        height: 1,
        width: 0.8,
        cycles: 1,
        phase: 0
    },
    {
        dx: -0.45,
        height: 0.66,
        width: 0.55,
        cycles: 2,
        phase: 1.7
    },
    {
        dx: 0.5,
        height: 0.74,
        width: 0.5,
        cycles: 3,
        phase: 3.9
    },
    {
        dx: 0.15,
        height: 0.86,
        width: 0.42,
        cycles: 2,
        phase: 5.1
    }
];
const $62714e84cc67bb35$var$drawFlame = (out, stride, ox, u, pal, lf, pulse)=>{
    const flameH = $62714e84cc67bb35$var$FLAME_MAX_H * (0.3 + 0.7 * lf) * pulse;
    const halfW = $62714e84cc67bb35$var$FLAME_HALF_W * (0.55 + 0.45 * lf) * (0.75 + 0.25 * pulse);
    const baseY = $62714e84cc67bb35$export$1cbfc86cc98020e7 - 0.5;
    const cx = $62714e84cc67bb35$export$7e891f0f1feb4c8c;
    const tongues = $62714e84cc67bb35$var$TONGUES.map((t)=>({
            ...t,
            h: flameH * t.height * (0.86 + 0.14 * Math.sin($62714e84cc67bb35$var$TAU * t.cycles * u + t.phase))
        }));
    for(let y = 0; y < $62714e84cc67bb35$export$d7c63b2dfb321550; y++){
        const h = (baseY - (y + 0.5)) / flameH // 0 at the coals, 1 at the tallest tips
        ;
        if (h < -0.12 || h > 1.35) continue;
        for(let x = 0; x < $62714e84cc67bb35$export$e1ee5e6c989c9909; x++){
            let body = -1;
            for (const t of tongues){
                const th = (baseY - (y + 0.5)) / t.h;
                if (th > 1.2) continue;
                // each tongue leans out with height and licks side to side (periodic in u)
                const sway = th * (t.dx * 0.5 + 0.2 * Math.sin($62714e84cc67bb35$var$TAU * u + th * 2.4 + t.phase) + 0.08 * Math.sin($62714e84cc67bb35$var$TAU * 3 * u + th * 5.5 + 1.3 + t.phase));
                const width = th < 0 ? Math.sqrt(Math.max(0, 1 - (th / 0.14) ** 2)) : Math.pow(Math.max(0, 1 - th), 0.75);
                const xn = (x + 0.5 - cx) / halfW - t.dx * Math.min(1, th * 2) - sway;
                body = Math.max(body, 1 - Math.abs(xn) / Math.max(width * t.width, 0.04));
            }
            if (body < -0.6) continue;
            // Two octaves rising through the flame, one loop period each (seamless). The coarse one
            // carves the tongues, the fine one ragged edges and the bits that break away.
            const n = 0.62 * $62714e84cc67bb35$var$loopNoise((x - cx) / 3.2 + 40, (y + 0.5) / 6 + u * 12, 12, 1) + 0.38 * $62714e84cc67bb35$var$loopNoise((x - cx) / 1.7 + 40, (y + 0.5) / 3 + u * 36, 36, 2);
            const hh = Math.max(0, h);
            const heat = body * 0.95 + (1 - hh) * 0.42 - hh * 0.18 - n * (0.5 + 0.45 * hh) + 0.05;
            const band = heat > 0.92 ? 4 : heat > 0.72 ? 3 : heat > 0.5 ? 2 : heat > 0.3 ? 1 : heat > 0.16 ? 0 : -1;
            if (band < 0) continue;
            $62714e84cc67bb35$var$put(out, stride, ox, x, y, pal.flame[band]);
        }
    }
};
// Sparks spat up out of the fire: each a pixel with a lifetime, drifting and fading. A fuller fire
// throws more and throws them higher.
const $62714e84cc67bb35$var$drawSparks = (out, stride, ox, u, pal, lf)=>{
    const count = Math.round(2 + 5 * lf);
    for(let i = 0; i < count; i++){
        const birth = $62714e84cc67bb35$var$hash(i, 0, 21);
        const lifetimes = 1 + Math.floor($62714e84cc67bb35$var$hash(i, 1, 21) * 2) // whole number per loop: seamless
        ;
        const age = $62714e84cc67bb35$var$frac((u - birth) * lifetimes);
        if (age > 0.92) continue;
        const rise = (16 + 26 * lf) * (0.7 + 0.5 * $62714e84cc67bb35$var$hash(i, 2, 21));
        const x = $62714e84cc67bb35$export$7e891f0f1feb4c8c + ($62714e84cc67bb35$var$hash(i, 3, 21) - 0.5) * 10 + Math.sin($62714e84cc67bb35$var$TAU * (age * 1.5 + $62714e84cc67bb35$var$hash(i, 4, 21))) * 2.5 + ($62714e84cc67bb35$var$hash(i, 5, 21) - 0.5) * 8 * age;
        const y = $62714e84cc67bb35$export$1cbfc86cc98020e7 - 6 - rise * age;
        const c = age < 0.35 ? pal.spark[0] : age < 0.7 ? pal.spark[1] : pal.spark[2];
        $62714e84cc67bb35$var$put(out, stride, ox, Math.round(x), Math.round(y), c, age > 0.75 ? 0.6 : 1);
    }
};
const $62714e84cc67bb35$var$SMOKE = [
    0x6e6466,
    0x8a8082
].map($62714e84cc67bb35$var$rgb);
// A doused fire smokes: soft grey puffs that swell and thin as they rise.
const $62714e84cc67bb35$var$drawSmoke = (out, stride, ox, u)=>{
    for(let i = 0; i < 4; i++){
        const age = $62714e84cc67bb35$var$frac(u - i / 4);
        const r = 1.5 + age * 4;
        const px = $62714e84cc67bb35$export$7e891f0f1feb4c8c + Math.sin($62714e84cc67bb35$var$TAU * (age + i * 0.3)) * 3 + age * 4;
        const py = $62714e84cc67bb35$export$1cbfc86cc98020e7 - 8 - age * 34;
        const alpha = 0.45 * Math.sin(Math.PI * age);
        for(let y = Math.floor(py - r); y <= py + r; y++)for(let x = Math.floor(px - r); x <= px + r; x++){
            const d = Math.hypot(x + 0.5 - px, y + 0.5 - py) / r;
            if (d > 1) continue;
            $62714e84cc67bb35$var$put(out, stride, ox, x, y, $62714e84cc67bb35$var$SMOKE[d < 0.5 ? 1 : 0], alpha);
        }
    }
};
const $62714e84cc67bb35$var$drawFrame = (rgba, stride, ox, style, level, u)=>{
    const lf = $62714e84cc67bb35$var$levelFraction(level);
    // Rain-damaged: the flame gutters (a periodic pulse with dead moments) and smokes.
    const pulse = style === "sputtering" ? 0.3 + 0.55 * Math.pow(0.5 + 0.5 * Math.sin($62714e84cc67bb35$var$TAU * 3 * u + Math.sin($62714e84cc67bb35$var$TAU * u)), 2) : 1;
    if (style === "sputtering") $62714e84cc67bb35$var$drawSmoke(rgba, stride, ox, u);
    $62714e84cc67bb35$var$drawCoals(rgba, stride, ox, u, $62714e84cc67bb35$var$PALETTE, lf);
    $62714e84cc67bb35$var$drawFlame(rgba, stride, ox, u, $62714e84cc67bb35$var$PALETTE, lf, pulse);
    $62714e84cc67bb35$var$drawSparks(rgba, stride, ox, u, $62714e84cc67bb35$var$PALETTE, style === "sputtering" ? lf * 0.3 : lf);
};
const $62714e84cc67bb35$export$305c90a52ed91da7 = (style, level, u)=>{
    const rgba = new Uint8Array($62714e84cc67bb35$export$e1ee5e6c989c9909 * $62714e84cc67bb35$export$d7c63b2dfb321550 * 4);
    $62714e84cc67bb35$var$drawFrame(rgba, $62714e84cc67bb35$export$e1ee5e6c989c9909, 0, style, level, u);
    return rgba;
};
const $62714e84cc67bb35$export$f5d747cbba404acd = (style, level)=>{
    const width = $62714e84cc67bb35$export$e1ee5e6c989c9909 * $62714e84cc67bb35$export$30963c68fc034da1;
    const height = $62714e84cc67bb35$export$d7c63b2dfb321550;
    const rgba = new Uint8Array(width * height * 4);
    for(let f = 0; f < $62714e84cc67bb35$export$30963c68fc034da1; f++)$62714e84cc67bb35$var$drawFrame(rgba, width, f * $62714e84cc67bb35$export$e1ee5e6c989c9909, style, level, f / $62714e84cc67bb35$export$30963c68fc034da1);
    return {
        rgba: rgba,
        width: width,
        height: height
    };
};
const $62714e84cc67bb35$export$a9602d5e08df4177 = ()=>{
    const width = $62714e84cc67bb35$export$4ddc08c2df49c83d, height = $62714e84cc67bb35$export$4537779a980f9fd8;
    const rgba = new Uint8Array(width * height * 4);
    const c = $62714e84cc67bb35$var$PALETTE.halo;
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
        const gx = (x + 0.5 - $62714e84cc67bb35$export$50e96cc4dbddde02) / 30, gy = (y + 0.5 - $62714e84cc67bb35$export$58b165dfc595b91b) / 13;
        const ground = Math.max(0, 1 - Math.sqrt(gx * gx + gy * gy));
        const fx = (x + 0.5 - $62714e84cc67bb35$export$50e96cc4dbddde02) / 13, fy = (y + 0.5 - ($62714e84cc67bb35$export$58b165dfc595b91b - 12)) / 17;
        const flame = Math.max(0, 1 - Math.sqrt(fx * fx + fy * fy));
        const a = Math.min(1, 0.55 * ground * ground + 0.35 * flame * flame);
        const i = (y * width + x) * 4;
        rgba[i] = c[0];
        rgba[i + 1] = c[1];
        rgba[i + 2] = c[2];
        rgba[i + 3] = Math.round(a * 255);
    }
    return {
        rgba: rgba,
        width: width,
        height: height
    };
};
const $62714e84cc67bb35$export$d3b06dcc28dd8eff = (frame)=>{
    const u = frame / $62714e84cc67bb35$export$30963c68fc034da1;
    return 0.82 + 0.1 * Math.sin($62714e84cc67bb35$var$TAU * 2 * u) + 0.08 * Math.sin($62714e84cc67bb35$var$TAU * 5 * u + 1.7);
};
const $62714e84cc67bb35$export$db9cfecf7bc006d8 = (frame)=>($62714e84cc67bb35$export$d3b06dcc28dd8eff(frame) - 0.82) / 0.18;


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $P8XPi = parcelRequire("P8XPi");
var $8t5Gy = parcelRequire("8t5Gy");
var $7Bs2Z = parcelRequire("7Bs2Z");
const $4fe000d23bc94d81$export$feddcc54305fe7dd = {
    // The bow's release: a faint glint at the grip and a whisper of a streak along the shot, gone in
    // a tenth of a second. A bow is not a gun -- the first version (a hot warm dot, a lit archer at
    // night) read as a muzzle flash. So no heart, no light in the dark, and barely any glow: it is
    // felt as the string snapping, not seen as a flash.
    arrow: {
        glow: 0xff5a10,
        core: 0xfff0d0,
        glowRadius: 9,
        coreRadius: 3,
        glowAlpha: 0.16,
        coreAlpha: 0.3,
        attackMs: 0,
        decayMs: 110,
        coreDecayMs: 50,
        lightRadius: 0,
        lightIntensity: 0,
        rise: 0,
        squash: 1,
        flicker: 0,
        heartAlpha: 0,
        streak: {
            length: 20,
            width: 0.2,
            alpha: 0.22
        }
    },
    // A beast or a bandit going down: an ember-coloured burst that lifts as it dies.
    //
    // The three deaths run at HALF their first brightness (glow, core, heart and the light in the
    // dark alike): at full strength they out-shouted the fight -- a kill should register, not flash.
    kill: {
        glow: 0xff3d08,
        core: 0xffc890,
        glowRadius: 46,
        coreRadius: 13,
        glowAlpha: 0.38,
        coreAlpha: 0.48,
        attackMs: 40,
        decayMs: 520,
        coreDecayMs: 180,
        lightRadius: 84,
        lightIntensity: 0.43,
        rise: 10,
        squash: 1,
        flicker: 0,
        heartAlpha: 0.4
    },
    // The dead going back: the same grave light they rose in (see graveRise). The Bonecaller's
    // violet, with NO green in it at all -- added to grass, any green turns it lavender-white, and
    // the venom green the shrine uses vanishes into the grass outright.
    graveKill: {
        glow: 0xb000ff,
        core: 0xf0d8ff,
        glowRadius: 50,
        coreRadius: 12,
        glowAlpha: 0.4,
        coreAlpha: 0.45,
        attackMs: 50,
        decayMs: 640,
        coreDecayMs: 220,
        lightRadius: 88,
        lightIntensity: 0.43,
        rise: 16,
        squash: 1,
        flicker: 0,
        heartAlpha: 0.4
    },
    // One of ours: cold, slower in and much slower out, lifting further. A light going out, not a hit.
    fallen: {
        glow: 0x2048ff,
        core: 0xe0ecff,
        glowRadius: 54,
        coreRadius: 14,
        glowAlpha: 0.3,
        coreAlpha: 0.43,
        attackMs: 140,
        decayMs: 1200,
        coreDecayMs: 420,
        lightRadius: 96,
        lightIntensity: 0.4,
        rise: 22,
        squash: 1,
        flicker: 0,
        heartAlpha: 0.4
    },
    // The ground opening under a rising skeleton or zombie. Builds while the body climbs (the attack
    // is set per spawn from the rupture's own clock), guttering, flat on the ground, with a shaft of
    // light standing up out of the hole.
    graveRise: {
        glow: 0xa000ff,
        core: 0xe8c8ff,
        glowRadius: 40,
        coreRadius: 12,
        glowAlpha: 0.8,
        coreAlpha: 0.8,
        attackMs: 540,
        decayMs: 650,
        coreDecayMs: 260,
        lightRadius: 72,
        lightIntensity: 0.7,
        rise: 0,
        squash: 0.5,
        flicker: 0.35,
        streak: {
            length: 34,
            width: 0.42,
            alpha: 0.7,
            angle: -Math.PI / 2
        }
    }
};
const $4fe000d23bc94d81$export$9fbda5b3d06f6525 = (ageMs, attackMs, decayMs)=>{
    if (!(ageMs >= 0)) return 0;
    if (ageMs < attackMs) {
        const t = ageMs / attackMs;
        return t * t * (3 - 2 * t);
    }
    const t = decayMs > 0 ? (ageMs - attackMs) / decayMs : 1;
    return t >= 1 ? 0 : (1 - t) * (1 - t);
};
// The dead that rise out of the ground (their population profile's preSpawnEffect is a
// ground-rupture) go back into it in the same light.
const $4fe000d23bc94d81$var$GRAVE_RACES = new Set([
    "skeleton",
    "zombie"
]);
// Things a fraction of a person's size: a full-sized burst over a rabbit is a bomb going off.
const $4fe000d23bc94d81$var$SMALL_RACES = new Set([
    "rabbit",
    "chicken",
    "snake",
    "slime",
    "redspider"
]);
const $4fe000d23bc94d81$export$6ddfb1d6399ca295 = (entity, ally)=>{
    const race = entity.appearance?.race;
    if (entity.entityType !== "player" && !race) return undefined;
    const size = Math.max(0.5, Math.min(1.6, entity.spriteScale || 1));
    if (ally || entity.entityType === "player") return {
        kind: "fallen",
        scale: size
    };
    if ($4fe000d23bc94d81$var$GRAVE_RACES.has(race)) return {
        kind: "graveKill",
        scale: size
    };
    return {
        kind: "kill",
        scale: ($4fe000d23bc94d81$var$SMALL_RACES.has(race) ? 0.6 : 1) * size
    };
};
// The glow texture: a soft radial falloff, white so every flash tints it. Gaussian-ish rather than a
// cone so the bloom has no visible edge or point, forced to zero at the rim so the square never shows.
const $4fe000d23bc94d81$var$TEXTURE_SIZE = 64;
const $4fe000d23bc94d81$var$TEXTURE_RADIUS = $4fe000d23bc94d81$var$TEXTURE_SIZE / 2;
const $4fe000d23bc94d81$export$c5c3ac54aea62934 = ()=>{
    const rgba = new Uint8Array($4fe000d23bc94d81$var$TEXTURE_SIZE * $4fe000d23bc94d81$var$TEXTURE_SIZE * 4);
    for(let y = 0; y < $4fe000d23bc94d81$var$TEXTURE_SIZE; y++)for(let x = 0; x < $4fe000d23bc94d81$var$TEXTURE_SIZE; x++){
        const dx = (x + 0.5 - $4fe000d23bc94d81$var$TEXTURE_RADIUS) / $4fe000d23bc94d81$var$TEXTURE_RADIUS;
        const dy = (y + 0.5 - $4fe000d23bc94d81$var$TEXTURE_RADIUS) / $4fe000d23bc94d81$var$TEXTURE_RADIUS;
        const r = Math.sqrt(dx * dx + dy * dy);
        const edge = r >= 1 ? 0 : r <= 0.8 ? 1 : 1 - (r - 0.8) / 0.2;
        const a = Math.exp(-r * r * 4) * edge;
        const i = (y * $4fe000d23bc94d81$var$TEXTURE_SIZE + x) * 4;
        rgba[i] = rgba[i + 1] = rgba[i + 2] = 255;
        rgba[i + 3] = Math.round(a * 255);
    }
    return rgba;
};
let $4fe000d23bc94d81$var$sharedTexture;
const $4fe000d23bc94d81$var$flashTexture = ()=>{
    if (!$4fe000d23bc94d81$var$sharedTexture) $4fe000d23bc94d81$var$sharedTexture = (0, $klOfb.Texture).fromBuffer($4fe000d23bc94d81$export$c5c3ac54aea62934(), $4fe000d23bc94d81$var$TEXTURE_SIZE, $4fe000d23bc94d81$var$TEXTURE_SIZE, {
        scaleMode: (0, $P8XPi.SCALE_MODES).LINEAR
    });
    return $4fe000d23bc94d81$var$sharedTexture;
};
const $4fe000d23bc94d81$var$LIGHT_ID_PREFIX = "flash:";
// The normal-blend heart, against the core's radius and peak. Small and short (it lives on the core's
// clock): any bigger or longer and an opaque disc reads as a sticker on the ground, not as light.
const $4fe000d23bc94d81$var$HEART_SIZE = 1.1;
const $4fe000d23bc94d81$var$HEART_ALPHA = 0.8;
const $4fe000d23bc94d81$var$option = (key, fallback)=>{
    const value = typeof window === "undefined" ? undefined : window[key];
    return typeof value === "number" && Number.isFinite(value) ? value : fallback;
};
class $4fe000d23bc94d81$export$2626a6f34c87e254 {
    static{
        this.Z_INDEX = 880001;
    }
    static{
        // A wave's worth of risings plus the fight around them. Past this the oldest flash is recycled,
        // which near the end of its tail nobody sees go.
        this.MAX_FLASHES = 24;
    }
    static{
        // Lights the mask carries at once. In a cave each one is shaped against the rock.
        this.MAX_MASK_LIGHTS = 8;
    }
    static{
        this.DAY_GAIN = 0.65;
    }
    constructor(lights, makeTexture = $4fe000d23bc94d81$var$flashTexture){
        this.lights = lights;
        this.makeTexture = makeTexture;
        this.container = new (0, $8t5Gy.Container)();
        this.heartLayer = new (0, $8t5Gy.Container)();
        this.glowLayer = new (0, $8t5Gy.Container)();
        this.flashes = [];
        this.registered = new Set();
        this./** Light one. `x`/`y` are in the world surface's space -- the same space as the mask's lights. */ flash = (kind, x, y, opts = {}, nowMs = performance.now())=>{
            if (!this.enabled() || !Number.isFinite(x) || !Number.isFinite(y)) return;
            const preset = $4fe000d23bc94d81$export$feddcc54305fe7dd[kind];
            const flash = this.take(nowMs);
            flash.live = true;
            flash.preset = preset;
            flash.x = x;
            flash.y = y;
            flash.bornMs = nowMs;
            flash.attackMs = Math.max(0, opts.attackMs ?? preset.attackMs);
            flash.scale = Math.max(0.1, opts.scale ?? 1);
            flash.angle = preset.streak?.angle ?? opts.angle ?? 0;
            flash.seed = Math.random() * 1000;
            flash.glow.tint = preset.glow;
            flash.core.tint = preset.core;
            flash.heart.tint = preset.core;
            flash.streak.tint = preset.glow;
            this.container.visible = true;
        };
        this./**
     * Advance every live flash and keep the mask's entries in step. `ambient` is the room's
     * visibility darkness as the mask reads it: 1 (or more) is broad day with no mask at all.
     */ update = (ambient, roomId, nowMs = performance.now())=>{
            if (roomId !== this.roomId) {
                // The first room seen is not a change: anything lit before it belongs to it.
                if (this.roomId !== undefined) this.clear();
                this.roomId = roomId;
            }
            if (!this.enabled()) {
                this.clear();
                return;
            }
            const light = Number.isFinite(ambient) ? Math.max(0, Math.min(1, ambient)) : 1;
            const dark = light < 1;
            const gain = $4fe000d23bc94d81$var$option("flashGain", 1) * (1 + ($4fe000d23bc94d81$var$option("flashDayGain", $4fe000d23bc94d81$export$2626a6f34c87e254.DAY_GAIN) - 1) * light);
            let anyLive = false;
            let maskLights = 0;
            for(let i = 0; i < this.flashes.length; i++){
                const flash = this.flashes[i];
                if (!flash.live) continue;
                const age = nowMs - flash.bornMs;
                const p = flash.preset;
                const level = $4fe000d23bc94d81$export$9fbda5b3d06f6525(age, flash.attackMs, p.decayMs);
                if (level <= 0 && age > 0) {
                    this.retire(i);
                    continue;
                }
                anyLive = true;
                const building = age < flash.attackMs;
                const gutter = building && p.flicker > 0 ? 1 - p.flicker * (0.5 + 0.5 * Math.sin(age * 0.031 + flash.seed) * Math.sin(age * 0.053 + flash.seed * 1.7)) : 1;
                const power = level * gutter;
                const total = flash.attackMs + p.decayMs;
                const y = flash.y - p.rise * flash.scale * Math.min(1, total > 0 ? age / total : 1);
                const coreLevel = $4fe000d23bc94d81$export$9fbda5b3d06f6525(age, flash.attackMs, p.coreDecayMs) * gutter;
                const glowScale = p.glowRadius * flash.scale / $4fe000d23bc94d81$var$TEXTURE_RADIUS;
                flash.glow.position.set(flash.x, y);
                flash.glow.scale.set(glowScale, glowScale * p.squash);
                flash.glow.alpha = Math.min(1, p.glowAlpha * power * gain);
                const coreScale = p.coreRadius * flash.scale / $4fe000d23bc94d81$var$TEXTURE_RADIUS;
                flash.core.position.set(flash.x, y);
                flash.core.scale.set(coreScale, coreScale);
                flash.core.alpha = Math.min(1, p.coreAlpha * coreLevel * gain);
                flash.core.visible = flash.core.alpha > 0.004;
                // The heart keeps its strength by day -- daylight is exactly when it is needed.
                flash.heart.position.set(flash.x, y);
                flash.heart.scale.set(coreScale * $4fe000d23bc94d81$var$HEART_SIZE, coreScale * $4fe000d23bc94d81$var$HEART_SIZE);
                flash.heart.alpha = Math.min(1, (p.heartAlpha ?? $4fe000d23bc94d81$var$HEART_ALPHA) * coreLevel * $4fe000d23bc94d81$var$option("flashGain", 1));
                flash.heart.visible = flash.heart.alpha > 0.004;
                if (p.streak) {
                    const length = p.streak.length * flash.scale;
                    const cos = Math.cos(flash.angle), sin = Math.sin(flash.angle);
                    flash.streak.visible = true;
                    flash.streak.rotation = flash.angle;
                    flash.streak.position.set(flash.x + cos * length * 0.5, y + sin * length * 0.5);
                    flash.streak.scale.set(length / $4fe000d23bc94d81$var$TEXTURE_SIZE, p.streak.width * length / $4fe000d23bc94d81$var$TEXTURE_SIZE);
                    flash.streak.alpha = Math.min(1, p.streak.alpha * power * gain);
                } else flash.streak.visible = false;
                if (dark && maskLights < $4fe000d23bc94d81$export$2626a6f34c87e254.MAX_MASK_LIGHTS && p.lightIntensity * power > 0.01) {
                    maskLights++;
                    this.registered.add(i);
                    this.lights.set($4fe000d23bc94d81$var$LIGHT_ID_PREFIX + i, {
                        entityId: $4fe000d23bc94d81$var$LIGHT_ID_PREFIX + i,
                        location: {
                            x: flash.x,
                            y: y
                        },
                        radius: p.lightRadius * flash.scale * (0.7 + 0.3 * level),
                        intensity: Math.min(1, p.lightIntensity * power)
                    });
                } else this.unregister(i);
            }
            this.container.visible = anyLive;
        };
        this./** Put every flash out now and take its light out of the mask: a room change, or switched off. */ clear = ()=>{
            for(let i = 0; i < this.flashes.length; i++)if (this.flashes[i].live) this.retire(i);
            this.container.visible = false;
        };
        this.// Exposed for tests.
        liveCount = ()=>this.flashes.filter((f)=>f.live).length;
        this.maskLightCount = ()=>this.registered.size;
        this.enabled = ()=>typeof window === "undefined" || window.transientLights !== false;
        this.take = (nowMs)=>{
            const free = this.flashes.find((f)=>!f.live);
            if (free) return free;
            if (this.flashes.length < $4fe000d23bc94d81$export$2626a6f34c87e254.MAX_FLASHES) {
                const texture = this.makeTexture();
                const sprite = (layer, blendMode)=>{
                    const s = new (0, $7Bs2Z.Sprite)(texture);
                    s.anchor.set(0.5);
                    s.alpha = 0;
                    s.blendMode = blendMode;
                    layer.addChild(s);
                    return s;
                };
                const add = ()=>sprite(this.glowLayer, (0, $P8XPi.BLEND_MODES).ADD);
                const flash = {
                    live: false,
                    preset: $4fe000d23bc94d81$export$feddcc54305fe7dd.kill,
                    x: 0,
                    y: 0,
                    bornMs: 0,
                    attackMs: 0,
                    scale: 1,
                    angle: 0,
                    seed: 0,
                    heart: sprite(this.heartLayer, (0, $P8XPi.BLEND_MODES).NORMAL),
                    glow: add(),
                    core: add(),
                    streak: add()
                };
                this.flashes.push(flash);
                return flash;
            }
            // Full: recycle whichever is furthest through its life.
            let oldest = this.flashes[0];
            let oldestProgress = -Infinity;
            for (const flash of this.flashes){
                const progress = (nowMs - flash.bornMs) / Math.max(1, flash.attackMs + flash.preset.decayMs);
                if (progress > oldestProgress) {
                    oldestProgress = progress;
                    oldest = flash;
                }
            }
            return oldest;
        };
        this.retire = (i)=>{
            const flash = this.flashes[i];
            flash.live = false;
            flash.heart.alpha = flash.glow.alpha = flash.core.alpha = flash.streak.alpha = 0;
            this.unregister(i);
        };
        this.unregister = (i)=>{
            if (!this.registered.delete(i)) return;
            this.lights.remove($4fe000d23bc94d81$var$LIGHT_ID_PREFIX + i);
        };
        this.container.zIndex = $4fe000d23bc94d81$export$2626a6f34c87e254.Z_INDEX;
        this.container.interactiveChildren = false;
        this.container.visible = false;
        this.container.addChild(this.heartLayer, this.glowLayer);
    }
}


// In-world campfire flame: pixel-art frames generated by fire_art.ts (coals, flame tongues, sparks,
// smoke when rained on) played back through a plain AnimatedSprite over an additive halo that warms
// the pit and the ground. Playback is a texture swap per frame -- no per-frame drawing.
//
// Each (style, level) is ONE texture strip, generated the first time any fire needs it and shared by
// every fire after; a fire that burns down walks through the levels rather than being scaled.
// Where the coals land relative to the fire entity's location. The server puts the fire 3px right of
// and 16px above its campfire (campfire.ts), and the pit art's logs cross 6px above the campfire's
// location (packages/tools/src/campfire/gen.py: the art's top is drawn at location.y - 22 and the
// logs cross on its row 16, column 48 = the location's x).
const $2ea1527dda10caae$var$COAL_OFFSET_X = -3;
const $2ea1527dda10caae$var$COAL_OFFSET_Y = 10;
// 15fps at 60Hz: a 24-frame loop lasts 1.6s, and each fire starts on a random frame.
const $2ea1527dda10caae$var$ANIMATION_SPEED = 0.25;
// The halo's brightness at full strength; a dying fire lights less.
const $2ea1527dda10caae$var$HALO_ALPHA = 0.9;
// One flame frame, at the animation's 15fps.
const $2ea1527dda10caae$var$FRAME_MS = 1000 / (60 * $2ea1527dda10caae$var$ANIMATION_SPEED);
// Rain makes a fire gutter: its light breathes harder.
const $2ea1527dda10caae$var$SPUTTER_BREATH = 1.8;
// The flare when the fire is fed or lit: up fast, settling over about a second. The bloom is a second,
// larger copy of the halo that swells out of it -- it is what the flare looks like by day, when there
// is no darkness for the light (living_firelight.ts) to push back.
const $2ea1527dda10caae$var$FLARE_ATTACK_MS = 160;
const $2ea1527dda10caae$var$FLARE_DECAY_MS = 1100;
const $2ea1527dda10caae$var$BLOOM_ALPHA = 0.55;
const $2ea1527dda10caae$var$BLOOM_GROW = 0.45;
const $2ea1527dda10caae$var$strips = new Map();
const $2ea1527dda10caae$var$framesFor = (style, level)=>{
    const key = `${style}:${level}`;
    let frames = $2ea1527dda10caae$var$strips.get(key);
    if (!frames) {
        const { rgba: rgba, width: width, height: height } = (0, $62714e84cc67bb35$export$f5d747cbba404acd)(style, level);
        const base = (0, $klOfb.Texture).fromBuffer(rgba, width, height, {
            scaleMode: (0, $P8XPi.SCALE_MODES).NEAREST
        }).baseTexture;
        frames = Array.from({
            length: (0, $62714e84cc67bb35$export$30963c68fc034da1)
        }, (_, f)=>new (0, $klOfb.Texture)(base, new (0, $6qzqq.Rectangle)(f * (0, $62714e84cc67bb35$export$e1ee5e6c989c9909), 0, (0, $62714e84cc67bb35$export$e1ee5e6c989c9909), (0, $62714e84cc67bb35$export$d7c63b2dfb321550))));
        $2ea1527dda10caae$var$strips.set(key, frames);
    }
    return frames;
};
let $2ea1527dda10caae$var$haloTexture;
const $2ea1527dda10caae$var$halo = ()=>{
    if (!$2ea1527dda10caae$var$haloTexture) {
        const { rgba: rgba, width: width, height: height } = (0, $62714e84cc67bb35$export$a9602d5e08df4177)();
        $2ea1527dda10caae$var$haloTexture = (0, $klOfb.Texture).fromBuffer(rgba, width, height, {
            scaleMode: (0, $P8XPi.SCALE_MODES).LINEAR
        });
    }
    return $2ea1527dda10caae$var$haloTexture;
};
class $2ea1527dda10caae$export$5d3e6a2d155f61d0 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(){
        super(), this.frameChangedMs = 0, this.style = "campfire", this.intensity = 1, this.burn = 1, this.setSputtering = (enabled)=>{
            const style = enabled ? "sputtering" : "campfire";
            if (this.style === style) return;
            this.style = style;
            this.refresh(true);
        }, // Fire strength (0..1) for a caller that animates it directly (the forager tutorial's diorama).
        this.setIntensity = (strength)=>{
            this.intensity = Math.max(0, Math.min(1, strength));
            this.refresh();
        }, this.strength = ()=>this.intensity * this.burn;
        // Sort just above the pit it burns in: the two share a z (the campfire's tile offset cancels
        // the fire's 16px lift), and the flame has to win that tie.
        this.defaultZIndex = 1;
        this.glow = new (0, $7Bs2Z.Sprite)($2ea1527dda10caae$var$halo());
        this.glow.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.glow.position.set($2ea1527dda10caae$var$COAL_OFFSET_X - (0, $62714e84cc67bb35$export$50e96cc4dbddde02), -(0, $62714e84cc67bb35$export$58b165dfc595b91b));
        this.addChild(this.glow);
        // Pivoted on the halo's own centre so it swells in place around the coals.
        this.bloom = new (0, $7Bs2Z.Sprite)($2ea1527dda10caae$var$halo());
        this.bloom.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.bloom.pivot.set((0, $62714e84cc67bb35$export$50e96cc4dbddde02), (0, $62714e84cc67bb35$export$58b165dfc595b91b));
        this.bloom.position.set($2ea1527dda10caae$var$COAL_OFFSET_X, 0);
        this.bloom.visible = false;
        this.addChild(this.bloom);
        this.level = (0, $62714e84cc67bb35$export$aa2a5e3c476e8271)(1);
        const frames = $2ea1527dda10caae$var$framesFor(this.style, this.level);
        this.animation = new (0, $d3fD1.AnimatedSprite)(frames);
        this.animation.position.set($2ea1527dda10caae$var$COAL_OFFSET_X - (0, $62714e84cc67bb35$export$7e891f0f1feb4c8c), -(0, $62714e84cc67bb35$export$1cbfc86cc98020e7));
        this.animation.animationSpeed = $2ea1527dda10caae$var$ANIMATION_SPEED;
        this.animation.onFrameChange = (frame)=>{
            this.frameChangedMs = performance.now();
            this.updateGlow(frame);
        };
        // Start on a random frame so neighbouring fires don't flicker in lockstep.
        this.animation.gotoAndPlay(Math.floor(Math.random() * frames.length));
        this.addChild(this.animation);
        this.updateGlow(this.animation.currentFrame);
    }
    // The campfire drives its burn-down through the entity's spriteScale (1 -> 0 as the fire ages).
    // A dying fire is drawn as a lower flame at the same pixel size -- the container is never scaled.
    updateScale(scale) {
        this.burn = Number.isFinite(scale) ? Math.max(0, Math.min(1, scale)) : 1;
        this.scale.set(1, 1);
        this.refresh();
    }
    // The coals are seated by the child offsets above, so the container sits on the location itself.
    getYOffset() {
        return $2ea1527dda10caae$var$COAL_OFFSET_Y;
    }
    /** Where the flame is in its flicker, -1..1, smooth between frames. Drives the firelight's breath. */ breath(nowMs = performance.now()) {
        const into = Math.max(0, Math.min(1, (nowMs - this.frameChangedMs) / $2ea1527dda10caae$var$FRAME_MS));
        return (0, $62714e84cc67bb35$export$db9cfecf7bc006d8)(this.animation.currentFrame + into) * (this.style === "sputtering" ? $2ea1527dda10caae$var$SPUTTER_BREATH : 1);
    }
    /** Fed or lit: flare. Restarts one already running -- two logs in quick succession flare twice. */ flare(nowMs = performance.now()) {
        this.flareStartMs = nowMs;
    }
    flareLevel(nowMs = performance.now()) {
        if (this.flareStartMs === undefined) return 0;
        const level = (0, $4fe000d23bc94d81$export$9fbda5b3d06f6525)(nowMs - this.flareStartMs, $2ea1527dda10caae$var$FLARE_ATTACK_MS, $2ea1527dda10caae$var$FLARE_DECAY_MS);
        if (level <= 0 && nowMs > this.flareStartMs) this.flareStartMs = undefined;
        return level;
    }
    /** Per drawn frame (EntityRenderingManager.endFrame): the flare's bloom. */ tick(nowMs = performance.now()) {
        const level = this.flareLevel(nowMs);
        this.bloom.visible = level > 0.003;
        if (!this.bloom.visible) return;
        this.bloom.scale.set(1 + $2ea1527dda10caae$var$BLOOM_GROW * level);
        this.bloom.alpha = $2ea1527dda10caae$var$BLOOM_ALPHA * level;
    }
    // Detach from the shared ticker when the fire entity is destroyed (AnimatedSprite.play registers
    // it there); the cached textures are shared and intentionally left alive.
    cleanup() {
        this.animation.stop();
    }
    refresh(styleChanged = false) {
        const level = (0, $62714e84cc67bb35$export$aa2a5e3c476e8271)(this.strength());
        if (level !== this.level || styleChanged) {
            this.level = level;
            // Keep the loop phase: a new level mid-flicker shouldn't jump back to frame 0.
            const frame = this.animation.currentFrame;
            this.animation.textures = $2ea1527dda10caae$var$framesFor(this.style, level);
            this.animation.gotoAndPlay(frame);
        }
        this.updateGlow(this.animation.currentFrame);
    }
    updateGlow(frame) {
        const s = this.strength();
        this.glow.alpha = $2ea1527dda10caae$var$HALO_ALPHA * (0, $62714e84cc67bb35$export$d3b06dcc28dd8eff)(frame) * (0.35 + 0.65 * s) * (this.style === "sputtering" ? 0.6 : 1);
    }
}


const $6025e3108d833e99$export$fcd73faa0d440ba6 = (sprite, entity, previous)=>{
    if (previous.spriteId !== entity.spriteId) sprite.updateSpriteId?.(entity.spriteId);
    if (previous.expirationTs !== entity.expirationTs || previous.landedArrow !== entity.landedArrow) sprite.updateRotating?.(!entity.landedArrow && entity.expirationTs !== undefined);
    if (previous.quantity !== entity.quantity) sprite.updateName?.(entity.quantity > 1 ? `${entity.quantity}` : "");
    if (sprite instanceof (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)) sprite.setSputtering(!!entity.rainDamaged);
    return {
        spriteId: entity.spriteId,
        expirationTs: entity.expirationTs,
        quantity: entity.quantity,
        landedArrow: entity.landedArrow
    };
};
const $6025e3108d833e99$export$e4a173e8d3dd312c = (entity)=>`${entity.submerged}-` + `${entity?.weapon?.weaponType}-` + `${entity?.appearance?.race}-` + `${entity?.appearance?.sex}-` + `${entity?.appearance?.hair}-` + `${entity?.appearance?.hairColor}-` + `${entity?.appearance?.inventoryAppearanceHash}-` + `${entity?.appearance?.emberSprite}-` + // Equipment can arrive after appearance, without changing the server's appearance hash.
    `${(0, $f684496fff50a7a1$export$fe4683c17d6b2a37)(entity.inventory)}-` + `${(0, $f684496fff50a7a1$export$2ed57f5a5ffde406)(entity)}`;



// A retained sprite can move between controllers; its last visual state must move with it.
const $e016b4679cd99b2f$var$states = new WeakMap();
class $e016b4679cd99b2f$export$c04a1bedc59d4447 {
    updateRole(sprite, role) {
        const state = $e016b4679cd99b2f$var$states.get(sprite);
        if (!state || state.role !== role) sprite.updateRole?.(role);
        if (state) state.role = role;
    }
    update(sprite, entity, features = (0, $1704411fa88dc9bf$export$e5daf445bbba1e2f), context = {}) {
        const previous = $e016b4679cd99b2f$var$states.get(sprite) ?? {};
        const next = {
            name: features.nameplates ? entity.name || "" : "",
            color: entity.color ?? 0xffffff,
            scale: entity.spriteScale ?? 1,
            submerged: entity.submerged,
            invading: entity.invading,
            appearance: (0, $6025e3108d833e99$export$e4a173e8d3dd312c)(entity),
            hp: entity.hp,
            maxHp: entity.maxHp,
            speed: entity.speed,
            maxSpeed: entity.maxSpeed,
            joinedTeam: entity.joinedTeam,
            sigil: entity.flags?.[0, $cb689cfa16c444ba$export$c8c6d6e2d9b5390d],
            afk: entity.afk,
            level: features.levelLabels ? context.level ?? entity.level ?? 1 : 0,
            role: context.role === undefined ? previous.role : context.role,
            leader: features.leaderHalo && !!context.playerId && entity.leaderEntityId === context.playerId,
            spriteId: entity.spriteId,
            expirationTs: entity.expirationTs,
            quantity: entity.quantity,
            landedArrow: entity.landedArrow,
            nameplates: features.nameplates,
            healthBars: features.healthBars
        };
        if (previous.name !== next.name) sprite.updateName?.(next.name);
        if (previous.color !== next.color) sprite.recolor?.(next.color);
        if (previous.scale !== next.scale) sprite.updateScale?.(next.scale);
        (0, $6025e3108d833e99$export$fcd73faa0d440ba6)(sprite, entity, previous);
        if (previous.submerged !== next.submerged) sprite.updateSubmerged?.(next.submerged);
        if (previous.invading !== next.invading) sprite.updatePlayerRing?.(entity);
        if (previous.appearance !== next.appearance) sprite.updatePaperdoll?.(entity);
        if (features.healthBars && (previous.hp !== next.hp || previous.maxHp !== next.maxHp || !previous.healthBars)) sprite.update?.(entity.hp, entity.maxHp);
        else if (!features.healthBars && previous.healthBars) sprite.update?.(0, 0);
        if (previous.speed !== next.speed || previous.maxSpeed !== next.maxSpeed) sprite.updateSpeed?.(entity.maxSpeed > 0 ? entity.speed / entity.maxSpeed : 1);
        if (previous.joinedTeam !== next.joinedTeam) {
            if (next.joinedTeam) sprite.addTag?.();
            else sprite.removeTag?.();
        }
        if (previous.sigil !== next.sigil) sprite.updateSigil?.(next.sigil);
        if (previous.afk !== next.afk) sprite.updateAfk?.(next.afk);
        if (previous.level !== next.level) sprite.updateLevel?.(next.level);
        if (previous.role !== next.role) sprite.updateRole?.(next.role);
        if (previous.leader !== next.leader) sprite.updateHalo?.(entity, next.leader);
        $e016b4679cd99b2f$var$states.set(sprite, next);
    }
}




const $9b85be211484fac5$export$4a8c8628e4e44ada = (view)=>view?.exterior === true && view.phase !== "landed";
const $9b85be211484fac5$export$7bc07e5774dde039 = (view, elapsedMs)=>{
    if (!view.trajectory || view.phase === "landed") return 0;
    const { gravity: gravity, distanceBefore: distanceBefore, endElapsedMs: endElapsedMs, totalDistance: totalDistance } = view.trajectory;
    const elapsed = Math.max(0, view.phase === "falling" && totalDistance !== undefined ? elapsedMs : Math.min(endElapsedMs, elapsedMs));
    // During a delayed room snapshot the already streamed lower floors remain in
    // view. Continue through them, but never extrapolate beyond supported ground.
    const fallen = Math.min(totalDistance ?? distanceBefore + view.distance, gravity * elapsed * elapsed / 2);
    return fallen - distanceBefore - view.distance;
};


const $7f7f5b693e82869c$var$ARRIVAL_HEIGHT_PX = 48;
const $7f7f5b693e82869c$var$playback = new WeakMap();
const $7f7f5b693e82869c$var$arrivals = new WeakMap();
// The camera has the entity, not its sprite, and rides the same arrival the body plays.
const $7f7f5b693e82869c$var$bodyArrivals = new WeakMap();
const $7f7f5b693e82869c$var$trajectories = new WeakMap();
const $7f7f5b693e82869c$export$e4e5f54dca5ae9f1 = 500;
// The wire drops the fall for a message or two at every floor crossing (its view names the room
// below before the body has been moved there) and again just before "landed". A limp body held
// through that gap does not stand up and collapse again at each floor.
const $7f7f5b693e82869c$var$KNOCKDOWN_GAP_MS = 200;
// The fall that laid this sprite's body down, kept per sprite like arrivals. It hands over to
// "landed", which holds the same pose until the recovery ends.
const $7f7f5b693e82869c$var$knockedDown = new WeakMap();
const $7f7f5b693e82869c$export$34b6d9b448395805 = (entity)=>entity.airborne === true;
// The entity each render view below was made from. A view is a fresh object every frame, so state
// kept per entity -- the fall's clock -- is kept against where it came from, or a body drawn limp or
// airborne would restart its fall every frame.
const $7f7f5b693e82869c$var$viewOrigins = new WeakMap();
const $7f7f5b693e82869c$var$originOf = (entity)=>$7f7f5b693e82869c$var$viewOrigins.get(entity) ?? entity;
/** This frame's view of `entity` with `fields` drawn differently; the entity itself is never touched. */ const $7f7f5b693e82869c$var$renderView = (entity, fields)=>{
    const view = Object.assign(Object.create(entity), fields);
    $7f7f5b693e82869c$var$viewOrigins.set(view, $7f7f5b693e82869c$var$originOf(entity));
    return view;
};
const $7f7f5b693e82869c$export$737bd19b63291ccf = (entity, now = Date.now())=>{
    const view = entity.floorFall;
    // Room crossings briefly omit the fall. Keep its clock so the next delayed snapshot
    // cannot restart airborne time; a different fall id replaces it in trajectoryElapsedMs.
    if (!view?.trajectory) return 0;
    if (view.phase === "landed") return 0;
    return (0, $9b85be211484fac5$export$7bc07e5774dde039)(view, $7f7f5b693e82869c$var$trajectoryElapsedMs(entity, view, now));
};
const $7f7f5b693e82869c$var$trajectoryElapsedMs = (entity, view, now)=>{
    let state = $7f7f5b693e82869c$var$trajectories.get($7f7f5b693e82869c$var$originOf(entity));
    const wireElapsedMs = view.trajectory.endElapsedMs - view.remainingMs;
    if (!state || state.view.id !== view.id) {
        state = {
            view: view,
            elapsedMs: wireElapsedMs,
            receivedAt: now
        };
        $7f7f5b693e82869c$var$trajectories.set($7f7f5b693e82869c$var$originOf(entity), state);
    } else if (state.view !== view) {
        state.elapsedMs = Math.max(wireElapsedMs, state.elapsedMs + now - state.receivedAt);
        state.receivedAt = now;
        state.view = view;
    }
    return state.elapsedMs + now - state.receivedAt;
};
/** Time spent in the air: stops where the body meets the ground it is falling towards (see floorFallOffsetAt). */ const $7f7f5b693e82869c$var$airborneMs = (view, elapsedMs)=>{
    const { gravity: gravity, endElapsedMs: endElapsedMs, totalDistance: totalDistance } = view.trajectory;
    return Math.min(elapsedMs, view.phase === "falling" && totalDistance !== undefined ? Math.sqrt(2 * totalDistance / gravity) : endElapsedMs);
};
// LpcComposite lays a `downed` body down; the authoritative entity is never touched.
const $7f7f5b693e82869c$var$limp = (view, sprite)=>$7f7f5b693e82869c$var$knockedDown.has(sprite) ? $7f7f5b693e82869c$var$renderView(view, {
        downed: true
    }) : view;
// When this sprite's body was last seen part way down a chained fall, with another floor below it.
const $7f7f5b693e82869c$var$midFall = new WeakMap();
/**
 * Whether the body is drawn in the air: the drop it is shown taking says so (the wire's, or the
 * local arrival's), and so does a destination still loading -- it is between floors. A fall on the
 * wire's clock touches down when it reaches the floor it is falling to, however late the server's
 * `landed` gets here. Seen part way down a chain of floors, the body stays in the air through the
 * message or two the wire drops at each crossing.
 */ const $7f7f5b693e82869c$var$inTheAir = (entity, view, sprite, now, roomId)=>{
    const wire = entity.floorFall;
    const pending = !!wire?.fromAbove && !!wire.roomId && wire.roomId !== roomId && wire.phase !== "landed";
    const shown = view.floorFall;
    const dropping = !!shown && shown.phase !== "landed" && // (Never yet on the ground, the time in the air is the whole fall: when it touches down.)
    (!shown.trajectory || $7f7f5b693e82869c$var$trajectoryElapsedMs(entity, shown, now) < $7f7f5b693e82869c$var$airborneMs(shown, Infinity));
    if (pending || dropping) {
        if (wire?.phase === "falling") $7f7f5b693e82869c$var$midFall.set(sprite, now);
        else $7f7f5b693e82869c$var$midFall.delete(sprite);
        return true;
    }
    const seen = $7f7f5b693e82869c$var$midFall.get(sprite);
    if (!wire && seen !== undefined && now - seen <= $7f7f5b693e82869c$var$KNOCKDOWN_GAP_MS) return true;
    $7f7f5b693e82869c$var$midFall.delete(sprite);
    return false;
};
const $7f7f5b693e82869c$export$21de360e152e5aec = (entity, sprite, visible = true, now = Date.now(), roomId = entity.roomId)=>{
    const view = $7f7f5b693e82869c$var$fallView(entity, sprite, visible, now, roomId);
    if (!$7f7f5b693e82869c$var$inTheAir(entity, view, sprite, now, roomId)) return view;
    return $7f7f5b693e82869c$var$renderView(view, {
        airborne: true
    });
};
const $7f7f5b693e82869c$var$fallView = (entity, sprite, visible, now, roomId)=>{
    const view = entity.floorFall;
    const knock = $7f7f5b693e82869c$var$knockedDown.get(sprite);
    if (knock && (view ? view.id !== knock.id || view.phase === "landed" : now - knock.seenAt > $7f7f5b693e82869c$var$KNOCKDOWN_GAP_MS)) $7f7f5b693e82869c$var$knockedDown.delete(sprite);
    else if (knock && view) knock.seenAt = now;
    // Advance the shared airborne clock through short gaps at floor crossings too.
    // With network delay the 500ms threshold can fall entirely between two snapshots.
    const previous = $7f7f5b693e82869c$var$trajectories.get(entity);
    const airborne = view?.trajectory ? view : !view && previous && now - previous.receivedAt <= $7f7f5b693e82869c$var$KNOCKDOWN_GAP_MS ? previous.view : undefined;
    if (airborne?.fromAbove && airborne.phase !== "landed" && !$7f7f5b693e82869c$var$knockedDown.has(sprite) && $7f7f5b693e82869c$var$airborneMs(airborne, $7f7f5b693e82869c$var$trajectoryElapsedMs(entity, airborne, now)) > $7f7f5b693e82869c$export$e4e5f54dca5ae9f1) $7f7f5b693e82869c$var$knockedDown.set(sprite, {
        id: airborne.id,
        seenAt: now
    });
    // Messages and the active map can switch rooms on different frames. Do not
    // lift the body or start arrival playback while its destination is pending.
    if (view?.fromAbove && view.roomId && view.roomId !== roomId) return $7f7f5b693e82869c$var$limp($7f7f5b693e82869c$var$renderView(entity, {
        floorFall: undefined
    }), sprite);
    if (!view?.fromAbove) {
        $7f7f5b693e82869c$var$arrivals.delete(sprite);
        return $7f7f5b693e82869c$var$limp(entity, sprite);
    }
    // Chained floors use wire time, including late arrivals and intermediate rooms.
    // Replaying a local arrival would restart velocity on every room crossing.
    // Only these last long enough to go limp: a one-floor arrival is a fixed short drop.
    if (view.trajectory) {
        $7f7f5b693e82869c$var$arrivals.delete(sprite);
        return $7f7f5b693e82869c$var$limp(entity, sprite);
    }
    let arrival = $7f7f5b693e82869c$var$arrivals.get(sprite);
    if (!arrival || arrival.id !== view.id) {
        arrival = {
            id: view.id,
            durationMs: view.arrivalDurationMs ?? 300,
            complete: false
        };
        $7f7f5b693e82869c$var$arrivals.set(sprite, arrival);
    }
    $7f7f5b693e82869c$var$bodyArrivals.set(entity, arrival);
    if (arrival.complete) return $7f7f5b693e82869c$var$landedArrival(entity);
    if (visible && arrival.startedAt === undefined) arrival.startedAt = now;
    const durationMs = arrival.durationMs;
    const elapsed = arrival.startedAt === undefined ? 0 : now - arrival.startedAt;
    if (elapsed >= durationMs) {
        arrival.complete = true;
        return $7f7f5b693e82869c$var$landedArrival(entity);
    }
    // Render a temporary view without changing the authoritative movement/recovery state.
    return $7f7f5b693e82869c$var$renderView(entity, {
        floorFall: {
            ...view,
            id: arrival.startedAt === undefined ? `${view.id}:waiting` : view.id,
            phase: "arriving",
            durationMs: durationMs,
            remainingMs: durationMs - elapsed
        }
    });
};
/**
 * Local playback usually ends a frame or two before the server's "arriving" phase does. Handing the
 * wire view back then re-applied its stale remaining time and lifted the body again for a frame.
 */ const $7f7f5b693e82869c$var$landedArrival = (entity)=>entity.floorFall?.phase === "arriving" ? $7f7f5b693e82869c$var$renderView(entity, {
        floorFall: undefined
    }) : entity;
const $7f7f5b693e82869c$var$arrivalLift = (progress)=>-$7f7f5b693e82869c$var$ARRIVAL_HEIGHT_PX * (1 - progress * progress);
const $7f7f5b693e82869c$export$b9937d18fdb36290 = (entity, roomId, now = Date.now())=>{
    const view = entity.floorFall;
    if (!view || view.stairJump || view.phase === "landed" || view.fromAbove && view.roomId && view.roomId !== roomId) return undefined;
    if (view.trajectory) return $7f7f5b693e82869c$export$737bd19b63291ccf(entity, now);
    if (!view.fromAbove) return undefined;
    const arrival = $7f7f5b693e82869c$var$bodyArrivals.get(entity);
    if (arrival?.id !== view.id) return $7f7f5b693e82869c$var$arrivalLift(0);
    if (arrival.complete) return undefined;
    return $7f7f5b693e82869c$var$arrivalLift(arrival.startedAt === undefined ? 0 : Math.min(1, (now - arrival.startedAt) / arrival.durationMs));
};
const $7f7f5b693e82869c$export$e434a799c1761144 = (entity, normal)=>entity.floorFall?.phase === "falling" && !entity.floorFall.fromAbove ? -1 : normal;
const $7f7f5b693e82869c$export$20875ff3d4f6df11 = (entity, sprite, now = Date.now())=>{
    let state = $7f7f5b693e82869c$var$playback.get(sprite);
    if (state?.outgoing) {
        sprite.alpha = state.alpha;
        sprite.scale?.set(state.sx, state.sy);
    }
    const view = entity.floorFall;
    if (!view || view.phase === "landed") {
        $7f7f5b693e82869c$var$playback.delete(sprite);
        return;
    }
    if (!state) {
        state = {
            view: view,
            receivedAt: now,
            alpha: sprite.alpha,
            sx: sprite.scale?.x ?? 1,
            sy: sprite.scale?.y ?? 1,
            outgoing: false
        };
        $7f7f5b693e82869c$var$playback.set(sprite, state);
    } else if (state.view !== view) {
        state.view = view;
        state.receivedAt = now;
    }
    const incoming = view.phase === "arriving" || view.fromAbove;
    state.outgoing = !incoming;
    if (view.trajectory) {
        sprite.y += $7f7f5b693e82869c$export$737bd19b63291ccf(entity, now);
        return;
    }
    const progress = Math.max(0, Math.min(1, 1 - (view.remainingMs - (now - state.receivedAt)) / view.durationMs));
    if (incoming) {
        sprite.y += $7f7f5b693e82869c$var$arrivalLift(progress);
        return;
    }
    sprite.y += view.distance * progress * progress;
    sprite.alpha = state.alpha * (1 - .65 * progress);
    sprite.scale?.set(state.sx * (1 - .18 * progress), state.sy * (1 - .18 * progress));
};


function $aa4dbab34fec03c9$export$1b5e6173667b4c9b(entity, sprite, provider) {
    if (entity.npcType !== "marker" || !entity.spriteId) return;
    const offset = provider?.resolveTileMeta(entity.spriteId)?.renderZIdxOffset;
    if (offset !== undefined) sprite.defaultZIndex = offset;
    sprite.zIndex = $aa4dbab34fec03c9$export$e44b69026e85417f(entity, sprite.defaultZIndex, provider);
}
const $aa4dbab34fec03c9$export$e44b69026e85417f = (entity, defaultZIndex = 0, provider)=>{
    // A shaft spans several floor renderings; its climber must draw over every section.
    // Standing on either endpoint keeps this priority until the entity steps off.
    if (!entity.floorFall && (entity.stairTravel || provider?.isStairAt(Math.floor(entity.location.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.floor(entity.location.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))))) return 999998;
    const flat = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isFlat(entity) || entity.downed || entity.floorFall?.phase === "landed" || entity.rescuePose === "downed";
    const depth = flat ? 0 : (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.calculateZIndexBoost(entity) + defaultZIndex || 0;
    return (0, $7f7f5b693e82869c$export$e434a799c1761144)(entity, depth);
};




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");



const $5af76956b9282cac$var$playback = new WeakMap();
const $5af76956b9282cac$var$stateFor = (view, sprite, now)=>{
    let state = $5af76956b9282cac$var$playback.get(sprite);
    if (!state || state.id !== view.id) {
        $5af76956b9282cac$var$release(sprite);
        state = {
            id: view.id,
            endsAt: now + view.remainingMs
        };
        $5af76956b9282cac$var$playback.set(sprite, state);
    } else state.endsAt = Math.min(state.endsAt, now + view.remainingMs);
    return state;
};
const $5af76956b9282cac$var$elapsedFor = (view, sprite, now)=>view.climb?.elapsedMs ?? view.durationMs - ($5af76956b9282cac$var$stateFor(view, sprite, now).endsAt - now);
const $5af76956b9282cac$var$poseFor = (view, sprite, now)=>(0, $968cce787b06be95$export$d9d9364aee075d84)(view, $5af76956b9282cac$var$elapsedFor(view, sprite, now));
const $5af76956b9282cac$export$aa044ab2f0c2781d = (entity)=>entity.ladderRise;
const $5af76956b9282cac$export$e44a43d45ae26d6 = (entity, sprite, now = Date.now(), roomId = entity.roomId)=>!!entity.stairTravel && entity.stairTravel.roomId === roomId && !entity.floorFall && (!entity.stairTravel.projection || (entity.stairTravel.phase === "depart" ? $5af76956b9282cac$var$elapsedFor(entity.stairTravel, sprite, now) >= entity.stairTravel.walkMs : $5af76956b9282cac$var$elapsedFor(entity.stairTravel, sprite, now) < entity.stairTravel.durationMs)) && (!!entity.stairTravel.climb || entity.stairTravel.phase === "depart" || $5af76956b9282cac$var$stateFor(entity.stairTravel, sprite, now).endsAt > now);
const $5af76956b9282cac$export$692282562ae49d65 = (entity, sprite, now = Date.now(), roomId = entity.roomId)=>{
    if (!$5af76956b9282cac$export$e44a43d45ae26d6(entity, sprite, now, roomId)) return entity;
    const view = entity.stairTravel;
    const pose = $5af76956b9282cac$var$poseFor(view, sprite, now);
    const climb = {
        ladderRise: "ladderRise" in pose ? pose.ladderRise : undefined
    };
    return Object.assign(Object.create(entity), {
        location: {
            ...entity.location,
            ...pose.location
        },
        movement: {
            ...entity.movement,
            moving: pose.walking,
            direction: pose.direction,
            angle: pose.angle
        },
        ...climb
    });
};
const $5af76956b9282cac$var$releaseClip = (sprite, state)=>{
    if (!state.clip) return;
    if (sprite.mask === state.clip) sprite.mask = state.previousMask;
    state.clip.parent?.removeChild(state.clip);
    state.clip.destroy();
    state.clip = undefined;
};
const $5af76956b9282cac$var$release = (sprite)=>{
    const state = $5af76956b9282cac$var$playback.get(sprite);
    if (state) $5af76956b9282cac$var$releaseClip(sprite, state);
    $5af76956b9282cac$var$playback.delete(sprite);
};
const $5af76956b9282cac$export$73f8e5a2be3bf548 = (entity, sprite, now = Date.now(), roomId = entity.roomId)=>{
    if (!$5af76956b9282cac$export$e44a43d45ae26d6(entity, sprite, now, roomId)) {
        $5af76956b9282cac$var$release(sprite);
        if (entity.stairTravel?.projection) {
            const state = $5af76956b9282cac$var$stateFor(entity.stairTravel, sprite, now);
            state.previousMask = sprite.mask;
            state.clip = new (0, $gwPoJ.Graphics)();
            sprite.addChild?.(state.clip);
            sprite.mask = state.clip;
        }
        return;
    }
    const state = $5af76956b9282cac$var$stateFor(entity.stairTravel, sprite, now);
    const pose = $5af76956b9282cac$var$poseFor(entity.stairTravel, sprite, now);
    const scale = Math.abs(sprite.scale?.y || 1);
    sprite.x += pose.location.x - entity.location.x;
    sprite.y += pose.location.y - entity.location.y + pose.bodyOffset * scale;
    const split = "split" in pose ? pose.split : undefined;
    if (entity.stairTravel.flight && !split || !entity.stairTravel.flight && "ladderRise" in pose && !pose.below) {
        $5af76956b9282cac$var$releaseClip(sprite, state);
        return;
    }
    if (!pose.transitioning && !split) {
        $5af76956b9282cac$var$releaseClip(sprite, state);
        return;
    }
    if (!sprite.addChild) return;
    if (!state.clip) {
        state.previousMask = sprite.mask;
        state.clip = new (0, $gwPoJ.Graphics)();
        sprite.addChild(state.clip);
        sprite.mask = state.clip;
    }
    // A child mask is cleaned up automatically when its sprite is destroyed.
    // Compensate for body movement so the clipping plane stays fixed at the stair.
    const view = entity.stairTravel;
    const opening = view.ramp && pose.below ? view.phase === "depart" ? view.end : view.start : undefined;
    const plane = split ? (split.edge - sprite.y) / scale : opening ? ((0, $afc439431837457b$export$736d42feedf23b37)({
        x: Math.floor(opening.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
        y: Math.floor(opening.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))
    }).south - sprite.y) / scale : pose.headClip !== undefined ? pose.below ? (0, $9667a1379a787b5e$export$5985b04c8e71b763) - 64 * pose.headClip : (0, $9667a1379a787b5e$export$5985b04c8e71b763) - 64 + 64 * pose.headClip : (pose.below ? (0, $9667a1379a787b5e$export$5985b04c8e71b763) : (0, $9667a1379a787b5e$export$5985b04c8e71b763) - 64) - pose.bodyOffset - pose.entranceOffset;
    const above = split ? split.above : pose.below;
    state.clip.clear().beginFill(0xffffff).drawRect(-256, above ? plane - 512 : plane, 512, 512).endFill();
};


function $a3da31b418d2b1ed$export$4725754a4127b437(entity, sprite, roomId, canShowArrival = true, now = Date.now(), provider) {
    sprite.updateRenderedLocationFrom(entity);
    const view = (0, $7f7f5b693e82869c$export$21de360e152e5aec)(entity, sprite, canShowArrival && (sprite.isReadyToShow?.() ?? true), now, roomId);
    sprite.zIndex = (0, $aa4dbab34fec03c9$export$e44b69026e85417f)(view, sprite.defaultZIndex, provider);
    sprite.doMovement((0, $5af76956b9282cac$export$692282562ae49d65)(view, sprite, now, roomId));
    (0, $7f7f5b693e82869c$export$20875ff3d4f6df11)(view, sprite, now);
    (0, $5af76956b9282cac$export$73f8e5a2be3bf548)(entity, sprite, now, roomId);
}







parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $1avo5 = parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");





parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");


const $97475243e21a0995$export$a51cff52e7be40d7 = {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24
};
const $97475243e21a0995$export$87e976d9ca6a6dc5 = {
    control: 5,
    card: 8,
    panel: 10
};
// Sizes own the label/subtitle hierarchy as well as the visible control dimensions.
const $97475243e21a0995$var$buttonSize = (height, paddingX, labelRole, subtitleRole)=>({
        height: height,
        paddingX: paddingX,
        labelRole: labelRole,
        subtitleRole: subtitleRole,
        fontSize: (0, $ef882f0a643d87d9$export$a57e4d4d74a95378)[labelRole].fontSize,
        subtitleFontSize: (0, $ef882f0a643d87d9$export$a57e4d4d74a95378)[subtitleRole].fontSize
    });
const $97475243e21a0995$var$SMALL_BUTTON = $97475243e21a0995$var$buttonSize(24, $97475243e21a0995$export$a51cff52e7be40d7.sm, "compactBody", "overline");
const $97475243e21a0995$var$MEDIUM_BUTTON = $97475243e21a0995$var$buttonSize(32, $97475243e21a0995$export$a51cff52e7be40d7.md, "label", "compactCaption");
const $97475243e21a0995$export$73e83bf2b7e02467 = {
    extraSmall: $97475243e21a0995$var$buttonSize(16, $97475243e21a0995$export$a51cff52e7be40d7.xs, "overline", "overline"),
    small: $97475243e21a0995$var$SMALL_BUTTON,
    medium: $97475243e21a0995$var$MEDIUM_BUTTON,
    large: $97475243e21a0995$var$buttonSize(40, $97475243e21a0995$export$a51cff52e7be40d7.lg, "body", "caption"),
    extraLarge: $97475243e21a0995$var$buttonSize(48, $97475243e21a0995$export$a51cff52e7be40d7.xl, "title", "label"),
    // Compatibility aliases for existing integrations; new callers use the names above.
    compact: $97475243e21a0995$var$SMALL_BUTTON,
    regular: $97475243e21a0995$var$MEDIUM_BUTTON
};
const $97475243e21a0995$export$ae463dc3cc7e810b = 0x1b1512;
const $97475243e21a0995$export$cac838e5dd111a30 = 0x8e7b58;
const $97475243e21a0995$export$92999bc7164f195e = 0xfff3e0;
const $97475243e21a0995$export$4569a0b09aa32d6c = 0xcbb49a;
const $97475243e21a0995$export$b1586623fe466c29 = {
    slate: {
        text: 0xe6e9f0,
        onAccent: 0x1b2030,
        fill: 0x2f3648,
        hoverFill: 0x3f4a63,
        pressedFill: 0x232a3d,
        border: 0x3a4256,
        accent: 0xd9a441,
        success: 0x7be08a,
        danger: 0xd98a8a
    },
    ember: {
        text: 0xfff3e0,
        onAccent: 0x2a1a0c,
        fill: 0x2a201a,
        hoverFill: 0x3a2c21,
        pressedFill: 0x1b1512,
        border: 0x6b4f38,
        accent: 0xf2a94e,
        success: 0x7be08a,
        danger: 0xe8745a
    }
};
const $97475243e21a0995$export$ee8cee785341f31a = 0.45;


/**
 * The countdown dial over the target of a HELD interaction -- "hold to help up" on an injured ember
 * survivor, and anything else that ever asks a player to keep the button down.
 *
 * It answers the one question a hold cannot answer for itself: how much longer. Without it the
 * player presses, nothing visible happens for two seconds, and the natural reading is that the
 * interaction is broken -- so they let go, which is exactly the thing that cancels it.
 *
 * The time it shows is the SERVER's (see HeldInteraction and Message.holdRemainingMs), never a local
 * timer started on the press. The server decides whether a hold is running at all -- close enough,
 * nobody standing over the body, refreshes still arriving -- and a ring run off the client's own
 * clock would fill up just as convincingly for a hold that had been refused before it began.
 *
 * One of these is parented to the target's world-overlay item (see WorldOverlaySurface), so it
 * travels with the entity for free and needs no per-frame position arithmetic of its own.
 */ // Geometry in world-overlay pixels. That surface is unit-scaled and pre-multiplies world
// coordinates itself, so these are screen pixels at the default zoom -- the same frame the
// nameplate and the role glyph are laid out in.
const $a34e00af51b35619$var$RADIUS = 13;
const $a34e00af51b35619$var$RING = 3.5;
const $a34e00af51b35619$var$FACE_RADIUS = $a34e00af51b35619$var$RADIUS + $a34e00af51b35619$var$RING / 2;
// Centred over the entity and lifted clear of the name plate, which is up for the whole of a hold:
// the pointer has to be ON the entity to hold it, so the hover label is always showing underneath.
//
// The x is exact rather than tuned: WorldOverlaySurface parks the item half a tile to the LEFT of
// the entity (TileSize * 0.25 * surfaceZoom), so +16 is the entity's own centre line.
const $a34e00af51b35619$var$CENTER_X = 16;
const $a34e00af51b35619$var$CENTER_Y = -18;
// How far the server's remaining time must disagree with the local run-down before the ring is
// re-anchored to it. Under this it is flight-time jitter on a 10Hz feed, and taking every message
// at its word makes the sweep stutter instead of run.
const $a34e00af51b35619$var$REANCHOR_TOLERANCE_MS = 90;
// The two ways a dial ends, and how long each takes. They are deliberately different animations:
// "it worked" and "you let go too early" are the only two outcomes of a hold, and the dial is where
// the player is already looking.
const $a34e00af51b35619$var$COMPLETE_MS = 260;
const $a34e00af51b35619$var$CANCEL_MS = 130;
// Remaining time at or below which a dial that stops counts as COMPLETED rather than released. One
// server message (100ms) plus its flight: the last message before the help lands still has a few
// milliseconds on the clock, and that must not read as a cancellation.
const $a34e00af51b35619$var$COMPLETE_SLACK_MS = 160;
const $a34e00af51b35619$var$THEME = (0, $97475243e21a0995$export$b1586623fe466c29).ember;
class $a34e00af51b35619$export$ba3e434c578b930c extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.dial = new (0, $gwPoJ.Graphics)(), // When the hold runs out, on THIS machine's clock. Anchored from the server's remaining time
        // (see reanchor) rather than from a server timestamp, so the two clocks never have to agree.
        this.endsAt = 0, this.durationMs = 1, /** The server says a hold is under way, with this much of it left. */ this.setRemaining = (remainingMs, durationMs)=>{
            this.ending = undefined;
            this.durationMs = Math.max(1, durationMs || remainingMs);
            this.reanchor(remainingMs);
            this.alpha = 1;
            this.scale.set(1);
            this.visible = true;
        }, /**
     * The server has stopped reporting a hold on this entity. Which ending that is depends on how
     * much time the dial still had: run out means the help landed, anything more means the player
     * let go (or walked out of reach, or something stood over the body again).
     */ this.stop = (now = Date.now())=>{
            if (this.ending) return;
            const remaining = this.endsAt - now;
            const kind = remaining <= $a34e00af51b35619$var$COMPLETE_SLACK_MS ? "complete" : "cancel";
            this.ending = {
                kind: kind,
                startedAt: now,
                progress: kind === "complete" ? 1 : this.sweep(now)
            };
        }, /** Whether this dial still has something to draw. False once its ending has played out. */ this.animate = (now = Date.now())=>{
            if (this.ending) {
                const { kind: kind, startedAt: startedAt, progress: progress } = this.ending;
                const span = kind === "complete" ? $a34e00af51b35619$var$COMPLETE_MS : $a34e00af51b35619$var$CANCEL_MS;
                const t = Math.min(1, (now - startedAt) / span);
                this.alpha = 1 - t;
                if (kind === "complete") {
                    // Full, and blooming outward as it goes: the ring closing is the success.
                    this.scale.set(1 + t * 0.3);
                    this.draw(1, "");
                } else // Draining back to nothing, which is what was just thrown away.
                this.draw(progress * (1 - t), "");
                if (t >= 1) {
                    this.visible = false;
                    return false;
                }
                return true;
            }
            const remaining = Math.max(0, this.endsAt - now);
            this.draw(this.sweep(now), `${(remaining / 1000).toFixed(1)}s`);
            return true;
        }, /** How much of the hold is done, 0..1. */ this.sweep = (now)=>{
            const remaining = Math.max(0, this.endsAt - now);
            return Math.max(0, Math.min(1, 1 - remaining / this.durationMs));
        }, this.reanchor = (remainingMs)=>{
            const endsAt = Date.now() + Math.max(0, remainingMs);
            if (Math.abs(endsAt - this.endsAt) > $a34e00af51b35619$var$REANCHOR_TOLERANCE_MS) this.endsAt = endsAt;
        }, this.draw = (progress, text)=>{
            const g = this.dial;
            g.clear();
            // A dark face, because this lands over whatever the entity is standing on.
            g.beginFill(0x000000, 0.25).drawCircle(0, 1.5, $a34e00af51b35619$var$FACE_RADIUS).endFill();
            g.lineStyle(1, $a34e00af51b35619$var$THEME.border).beginFill($a34e00af51b35619$var$THEME.fill, 0.94).drawCircle(0, 0, $a34e00af51b35619$var$FACE_RADIUS).endFill();
            // The unfilled track, so how much is left is readable as a gap and not only as a number.
            g.lineStyle($a34e00af51b35619$var$RING, 0x000000, 0.35).drawCircle(0, 0, $a34e00af51b35619$var$RADIUS);
            if (progress > 0) {
                const from = -Math.PI / 2;
                const to = from + Math.min(1, progress) * Math.PI * 2;
                // moveTo first, or pixi strokes a spoke from the centre out to where the arc starts.
                g.lineStyle($a34e00af51b35619$var$RING, $a34e00af51b35619$var$THEME.accent).moveTo(0, -$a34e00af51b35619$var$RADIUS).arc(0, 0, $a34e00af51b35619$var$RADIUS, from, to);
                // The moving head of the sweep. It is what makes a ring that is barely started still
                // read as moving, which is the whole point in the first half-second of a hold.
                g.lineStyle(0).beginFill($a34e00af51b35619$var$THEME.text).drawCircle(Math.cos(to) * $a34e00af51b35619$var$RADIUS, Math.sin(to) * $a34e00af51b35619$var$RADIUS, $a34e00af51b35619$var$RING / 2 + 0.4).endFill();
            }
            this.label.text = text;
            this.label.visible = !!text;
        };
        this.position.set($a34e00af51b35619$var$CENTER_X, $a34e00af51b35619$var$CENTER_Y);
        this.addChild(this.dial);
        this.label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(10).bold().color($a34e00af51b35619$var$THEME.text).render("");
        this.label.anchor.set(0.5);
        this.label.roundPixels = true;
        // Pinned so the glyphs are not re-rasterized -- and so do not glitch for a frame -- when
        // this is rendered into the follow-cam PiP's RenderTexture at its own resolution.
        this.label.resolution = 2 * (typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1);
        this.addChild(this.label);
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");



/**
 * The prompt over an injured ember survivor: how to get her on her feet.
 *
 * It answers the one question she cannot answer herself. She asks for help in her own words, over
 * and over, for as long as she is lying at the wreck ("Help me! I can't get up.") -- and a player
 * who walks up to her, swings at her, taps her and gets a refusal has still not been told the one
 * thing that works, because "hold the button down on a person" is not a gesture this game has asked
 * for anywhere else. Her interaction LABEL says it ("Hold to help up"), but that label only exists
 * inside a menu she has no reason to open, and it is a menu she deliberately does not have.
 *
 * WHEN it is up is the server's call, not this widget's: it goes up when the last skeleton at the
 * wreck falls, because until then the hold is refused outright and a prompt would be a lie. See
 * Message.rescueHelpHint and RescueDirector.publishHelpHint.
 *
 * One of these is parented to the survivor's world-overlay item (see WorldOverlaySurface), like the
 * countdown dial that replaces it the moment somebody starts holding, so it travels with her for
 * free and needs no per-frame position arithmetic of its own.
 */ // Geometry in world-overlay pixels: that surface is unit-scaled and pre-multiplies world
// coordinates itself, so these are screen pixels at the default zoom -- the same frame the hold
// dial and the role glyph are laid out in.
//
// UNDER THE BODY, not over it. Above her head is taken: it is where her own speech bubble opens,
// and she is speaking the whole time this is up -- the pleas ARE the reason the player comes over.
// A prompt sharing that air would be covered by half the lines it exists to explain, so it sits
// below her instead, where a prone body leaves the ground clear and where a UI label reads as a
// label rather than as one more thing she is saying.
const $2625ff0d109c91d3$var$CENTER_X = 16 // the entity's own centre line: the item is parked half a tile to its left
;
const $2625ff0d109c91d3$var$TOP_Y = 58 // just clear of the soles (the item origin is a tile and a quarter above the hip)
;
const $2625ff0d109c91d3$var$PAD_X = 7;
const $2625ff0d109c91d3$var$PAD_Y = 4;
const $2625ff0d109c91d3$var$RADIUS = 4;
const $2625ff0d109c91d3$var$FONT_SIZE = 10;
// The breathing that makes a static box read as "do this". One slow cycle; the amplitude is small
// on purpose -- this is a label on a quiet beat after a fight, not an alarm.
const $2625ff0d109c91d3$var$PULSE_MS = 1500;
const $2625ff0d109c91d3$var$PULSE_MIN_ALPHA = 0.74;
const $2625ff0d109c91d3$var$FADE_IN_MS = 220;
// How long the ending takes. It is cut short rather than faded out when the hold begins, since the
// dial comes up in the same instant and two overlapping prompts about the same gesture is noise.
const $2625ff0d109c91d3$var$FADE_OUT_MS = 120;
const $2625ff0d109c91d3$var$THEME = (0, $97475243e21a0995$export$b1586623fe466c29).ember;
class $2625ff0d109c91d3$export$a119cd05626ba765 extends (0, $8t5Gy.Container) {
    constructor(touch = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()){
        super(), this.panel = new (0, $gwPoJ.Graphics)(), this.startedAt = 0, /** The server says the prompt belongs on screen. Idempotent: it arrives on every message. */ this.show = (now = Date.now())=>{
            this.endingAt = undefined;
            if (this.visible) return;
            this.startedAt = now;
            this.visible = true;
            this.alpha = 0;
        }, /** The server has stopped asking for it -- the hold began, or she is up, or she is gone. */ this.stop = (now = Date.now())=>{
            if (!this.visible || this.endingAt !== undefined) return;
            this.endingAt = now;
        }, /** Whether this prompt still has something to draw. False once its ending has played out. */ this.animate = (now = Date.now())=>{
            if (!this.visible) return false;
            if (this.endingAt !== undefined) {
                const t = Math.min(1, (now - this.endingAt) / $2625ff0d109c91d3$var$FADE_OUT_MS);
                this.alpha = (1 - t) * $2625ff0d109c91d3$var$PULSE_MIN_ALPHA;
                if (t >= 1) {
                    this.visible = false;
                    return false;
                }
                return true;
            }
            const elapsed = now - this.startedAt;
            const pulse = $2625ff0d109c91d3$var$PULSE_MIN_ALPHA + (1 - $2625ff0d109c91d3$var$PULSE_MIN_ALPHA) * (0.5 - 0.5 * Math.cos(2 * Math.PI * elapsed / $2625ff0d109c91d3$var$PULSE_MS));
            this.alpha = elapsed < $2625ff0d109c91d3$var$FADE_IN_MS ? elapsed / $2625ff0d109c91d3$var$FADE_IN_MS * pulse : pulse;
            return true;
        }, this.draw = ()=>{
            const w = Math.round(this.label.width) + 2 * $2625ff0d109c91d3$var$PAD_X;
            const h = Math.round(this.label.height) + 2 * $2625ff0d109c91d3$var$PAD_Y;
            const x = $2625ff0d109c91d3$var$CENTER_X - w / 2;
            this.label.position.set(Math.round(x + $2625ff0d109c91d3$var$PAD_X), Math.round($2625ff0d109c91d3$var$TOP_Y + $2625ff0d109c91d3$var$PAD_Y));
            const g = this.panel;
            g.clear();
            // A dark plate first, because this lands on whatever ground she is lying on.
            g.beginFill(0x000000, 0.35).drawRoundedRect(x, $2625ff0d109c91d3$var$TOP_Y + 1.5, w, h, $2625ff0d109c91d3$var$RADIUS).endFill();
            g.lineStyle(1, $2625ff0d109c91d3$var$THEME.accent, 0.85).beginFill($2625ff0d109c91d3$var$THEME.fill, 0.94).drawRoundedRect(x, $2625ff0d109c91d3$var$TOP_Y, w, h, $2625ff0d109c91d3$var$RADIUS).endFill();
        };
        this.addChild(this.panel);
        this.label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize($2625ff0d109c91d3$var$FONT_SIZE).bold().color($2625ff0d109c91d3$var$THEME.text).render(touch ? "Touch and hold to help them up" : "Click and hold to help them up");
        this.label.roundPixels = true;
        // Pinned so the glyphs are not re-rasterized -- and so do not glitch for a frame -- when
        // this is rendered into the follow-cam PiP's RenderTexture at its own resolution.
        this.label.resolution = 2 * (typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1);
        this.addChild(this.label);
        this.draw();
        this.visible = false;
    }
}




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
class $030505ced35b08e9$export$228fc91891ee71a3 extends (0, $gwPoJ.Graphics) {
    constructor(...args){
        super(...args), this.animate = (now = Date.now())=>{
            this.clear();
            const t = now / 1000;
            this.lineStyle(5, 0xff5b16, 0.16);
            this.drawEllipse(0, 0, 12, 9);
            this.lineStyle(2, 0xff8b24, 0.85);
            this.drawEllipse(0, 0, 11, 8);
            this.lineStyle(1, 0xffe9a1, 0.9);
            this.drawEllipse(0, 0, 9, 6);
            this.lineStyle(0);
            for(let i = 0; i < 12; i++){
                const angle = i * Math.PI * 2 / 12;
                const x = Math.cos(angle) * 11, y = Math.sin(angle) * 8;
                const flicker = 0.5 + 0.5 * Math.sin(t * 9 + i * 2.3);
                const height = 4 + flicker * 5;
                this.beginFill(i % 2 ? 0xffa132 : 0xff5b16, 0.85);
                this.drawPolygon([
                    x - 2,
                    y + 1,
                    x - 1,
                    y - height * 0.45,
                    x + Math.sin(t * 7 + i) * 2,
                    y - height,
                    x + 2,
                    y + 1
                ]);
                this.endFill();
                this.beginFill(0xffedb4, 0.85);
                this.drawRect(Math.round(x), Math.round(y - 1), 1, 2);
                this.endFill();
            }
            // Small rising embers; deterministic phase keeps render frames allocation-free.
            for(let i = 0; i < 4; i++){
                const phase = (t * 0.8 + i * 0.27) % 1;
                this.beginFill(0xffcc64, (1 - phase) * 0.8);
                this.drawRect(Math.round(Math.sin(i * 2 + t) * 9), Math.round(-8 - phase * 12), 1, 1);
                this.endFill();
            }
        };
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

/** Shared presentation geometry for lobbed projectiles and their trajectory preview. */ const $ecfe6790c484f97d$export$c9a7b72071b071a6 = (progress)=>Math.sin(Math.PI * Math.max(0, Math.min(1, progress))) * 40;


class $86830f5b18cb1296$export$4301878a36019287 extends (0, $gwPoJ.Graphics) {
    constructor(...args){
        super(...args), this.show = (origin, target)=>{
            this.origin = {
                ...origin
            };
            this.target = {
                ...target
            };
            this.fadingAt = undefined;
            this.alpha = 1;
        }, this.fade = (now = Date.now())=>{
            if (this.fadingAt === undefined) this.fadingAt = now;
        }, this.finished = (now = Date.now())=>!this.target || this.fadingAt !== undefined && now - this.fadingAt >= 1000, this.animate = (now = Date.now(), visible = true)=>{
            this.clear();
            this.visible = visible && !this.finished(now);
            this.alpha = this.fadingAt === undefined ? 1 : Math.max(0, 1 - (now - this.fadingAt) / 1000);
            if (!this.visible || !this.target || !this.origin) return;
            const scale = (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
            this.position.set(this.target.x * scale, this.target.y * scale);
            this.scale.set(scale);
            const dx = this.origin.x - this.target.x, dy = this.origin.y - this.target.y;
            const count = Math.max(8, Math.min(64, Math.ceil((Math.hypot(dx, dy) + 80) / 10)));
            const phase = now / 450 % 1;
            this.lineStyle(0);
            this.beginFill(0xffdda1, 0.38);
            for(let i = 0; i < count; i++){
                const progress = (i + phase) / count;
                this.drawCircle(dx * (1 - progress), dy * (1 - progress) - (0, $ecfe6790c484f97d$export$c9a7b72071b071a6)(progress) - 4, 1.5);
            }
            this.endFill();
        };
    }
}


const $6b36cb767b4a8ec4$export$b779cd893e8948bb = (art, x, y, now, flash = false, opacity = 1)=>{
    art.lineStyle(1.5, 0x080b0f, opacity);
    art.beginFill(flash ? 0x9c4826 : 0x232a34, opacity);
    art.drawCircle(x, y, 7);
    art.endFill();
    art.lineStyle(0);
    art.beginFill(0x72808e, 0.85 * opacity);
    art.drawEllipse(x - 2, y - 2, 2, 3);
    art.drawRect(x - 2, y - 9, 4, 3);
    art.endFill();
    art.lineStyle(2, 0xd8b77c, opacity);
    art.moveTo(x, y - 8);
    art.lineTo(x + 3, y - 12);
    art.lineTo(x + 6, y - 11);
    const pulse = 1 + Math.sin(now / 65) * 0.4;
    art.lineStyle(0);
    art.beginFill(0xffb942, opacity);
    art.drawCircle(x + 6, y - 11, 2 * pulse);
    art.endFill();
};
const $6b36cb767b4a8ec4$export$8b1f73421951abcd = (art, x, y, now, progress)=>{
    const t = Math.max(0, Math.min(1, progress / 0.7));
    const opacity = t * t * (3 - 2 * t);
    $6b36cb767b4a8ec4$export$b779cd893e8948bb(art, x, y, now, false, opacity);
    const forming = 1 - opacity;
    if (forming <= 0) return;
    art.lineStyle(1, 0xc4f5ff, forming * 0.6);
    art.drawCircle(x, y, 7);
    art.lineStyle(0);
    for(let i = 0; i < 8; i++){
        const phase = (now / 600 + i / 8) % 1;
        const angle = i * Math.PI / 4 + Math.sin(now / 150 + i) * 0.2;
        const radius = 7 + (1 - phase) * 9 * forming;
        art.beginFill(i % 2 ? 0xd7f7ff : 0x358dff, forming * phase * 0.8);
        art.drawRect(x + Math.cos(angle) * radius - 0.5, y + Math.sin(angle) * radius - 0.5, 1.5, 1.5);
        art.endFill();
    }
};


class $ea809ed91fb9059b$export$4563ec8c307f7b62 extends (0, $gwPoJ.Graphics) {
    constructor(...args){
        super(...args), this.heldBomb = new (0, $gwPoJ.Graphics)(), this.tracer = new (0, $86830f5b18cb1296$export$4301878a36019287)(), this.receivedAt = 0, this.origin = {
            x: 0,
            y: 0
        }, this.update = (entity, now = Date.now())=>{
            if (entity.attackWindup !== this.view) this.receivedAt = now;
            this.view = entity.hp > 0 && !entity.isDead() ? entity.attackWindup : undefined;
            this.origin = entity.getBounds().center();
            this.animate(now);
        }, this.animate = (now = Date.now(), visible = true, grip)=>{
            this.clear();
            this.heldBomb.clear();
            this.heldBomb.visible = false;
            this.visible = visible;
            const view = this.view;
            if (!view || view.phase === "recovery" || view.remainingMs <= now - this.receivedAt) {
                this.tracer.fade(now);
                this.tracer.animate(now, visible);
                return;
            }
            this.tracer.show(this.origin, view.target);
            this.tracer.animate(now, visible);
            if (!visible) return;
            const scale = (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
            this.position.set(view.target.x * scale, view.target.y * scale);
            this.scale.set(scale);
            this.lineStyle(3, 0x18100a, 0.9);
            this.beginFill(0xe36c24, 0.12);
            this.drawCircle(0, 0, view.radius);
            this.endFill();
            this.lineStyle(1.5, 0xffba55, 0.95);
            this.drawCircle(0, 0, view.radius);
            this.moveTo(-6, 0);
            this.lineTo(6, 0);
            const t = Math.max(0, Math.min(1, 1 - (view.remainingMs - now + this.receivedAt) / view.durationMs));
            this.lineStyle(3, 0xffe8aa, 0.9);
            this.moveTo(0, -view.radius);
            this.arc(0, 0, view.radius, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * t);
            const remaining = Math.max(0, view.remainingMs - now + this.receivedAt);
            const holding = view.phase === "windup" || view.phase === "throw" && remaining > view.durationMs / 2;
            if (holding && grip && this.parent) {
                const north = (0, $a80d0b17b615d6f7$export$94d6114d0f45bc7e)(view.angle) === "Up";
                this.heldBomb.visible = view.phase === "windup" || !north;
                this.heldBomb.position.copyFrom(this.parent.toLocal(grip));
                // The held bomb is smaller than the committed projectile so it fits between the palms.
                this.heldBomb.scale.set(grip.scale * 0.6);
                if (!north) {
                    if (view.phase === "windup") (0, $6b36cb767b4a8ec4$export$8b1f73421951abcd)(this.heldBomb, 0, 0, now, t);
                    else (0, $6b36cb767b4a8ec4$export$b779cd893e8948bb)(this.heldBomb, 0, 0, now);
                }
                if (view.phase === "windup") grip.hands?.forEach((hand, index)=>{
                    const start = this.heldBomb.toLocal(hand);
                    $ea809ed91fb9059b$export$765237baae2c2b52(this.heldBomb, start.x, start.y, now, index, north);
                });
            }
        };
    }
}
const $ea809ed91fb9059b$export$765237baae2c2b52 = (art, x, y, now, seed, aroundHead = false)=>{
    const distance = Math.hypot(x, y);
    if (distance < 1) return;
    const endX = aroundHead ? Math.sign(x) * 6 : x / distance * 6;
    const endY = aroundHead ? 0 : y / distance * 6;
    const phase = Math.floor(now / 55);
    // Keep the northern arcs outside the skull until below it, then converge behind the body.
    const route = aroundHead ? [
        [
            x,
            y
        ],
        [
            x,
            Math.max(y, 6)
        ],
        [
            endX,
            Math.max(y, 6)
        ],
        [
            endX,
            endY
        ]
    ] : [
        [
            x,
            y
        ],
        [
            endX,
            endY
        ]
    ];
    const points = [
        route[0]
    ];
    for(let segment = 1; segment < route.length; segment++){
        const from = route[segment - 1], to = route[segment];
        const dx = to[0] - from[0], dy = to[1] - from[1];
        const length = Math.hypot(dx, dy) || 1;
        for(let i = 1; i < 5; i++){
            const t = i / 5;
            const jitter = Math.sin(phase * 2.7 + seed * 4.1 + i * 7.3 + segment) * 2.5;
            points.push([
                from[0] + dx * t - dy / length * jitter,
                from[1] + dy * t + dx / length * jitter
            ]);
        }
        points.push(to);
    }
    for (const [width, color, alpha] of [
        [
            3,
            0x358dff,
            0.35
        ],
        [
            1,
            0xd7f7ff,
            0.95
        ]
    ]){
        art.lineStyle(width, color, alpha);
        art.moveTo(points[0][0], points[0][1]);
        for (const point of points.slice(1))art.lineTo(point[0], point[1]);
    }
};


parcelRequire("1avo5");
var $d3fD1 = parcelRequire("d3fD1");
var $P8XPi = parcelRequire("P8XPi");
var $gwPoJ = parcelRequire("gwPoJ");

parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $klOfb = parcelRequire("klOfb");
// The Bonecaller's boundary flames: a pool of soft rising particles in the ritual's green and violet,
// baked once into RenderTextures and played back by plain AnimatedSprites (see bonecaller_warning).
// This is the bake the campfire used before it got pixel-art flames of its own (fire_art.ts); the
// ritual keeps the soft look, which reads as spell-light rather than burning wood.
//
// SEAMLESS LOOP: every particle is a pure function of a loop phase u in [0,1): its age is
// frac(u - birthPhase), so the frame at u=1 is identical to u=0. Particles fade to zero alpha just
// before their age wraps (top -> bottom), and staggered birth phases mean no two reset together.
const $d0d4547f76bf89f1$var$FRAME_W = 48;
const $d0d4547f76bf89f1$var$FRAME_H = 64;
const $d0d4547f76bf89f1$var$FRAME_COUNT = 30;
const $d0d4547f76bf89f1$var$PARTICLE_COUNT = 52;
// Young -> old: pale venom green -> green -> violet -> deep plum.
const $d0d4547f76bf89f1$var$ritualColor = (lifeFrac)=>lifeFrac > 0.85 ? 0xd6ffbe : lifeFrac > 0.58 ? 0x82ef45 : lifeFrac > 0.3 ? 0x9654d8 : 0x43145f;
const $d0d4547f76bf89f1$var$frac = (n)=>n - Math.floor(n);
const $d0d4547f76bf89f1$var$makeLoopParticles = ()=>{
    const cx = $d0d4547f76bf89f1$var$FRAME_W / 2;
    const particles = [];
    for(let i = 0; i < $d0d4547f76bf89f1$var$PARTICLE_COUNT; i++)particles.push({
        // Evenly staggered around the loop (+ small jitter) so density is steady, not pulsing.
        birthPhase: $d0d4547f76bf89f1$var$frac(i / $d0d4547f76bf89f1$var$PARTICLE_COUNT + (Math.random() - 0.5) * (0.4 / $d0d4547f76bf89f1$var$PARTICLE_COUNT)),
        baseX: cx + (Math.random() - 0.5) * $d0d4547f76bf89f1$var$FRAME_W * 0.3,
        baseY: $d0d4547f76bf89f1$var$FRAME_H - Math.random() * 5,
        rise: $d0d4547f76bf89f1$var$FRAME_H * (0.55 + Math.random() * 0.5),
        size: 3.5 + Math.random() * 3.5,
        drift: (Math.random() - 0.5) * $d0d4547f76bf89f1$var$FRAME_W * 0.1,
        converge: 0.3 + Math.random() * 0.4,
        wobbleAmp: 1.5 + Math.random() * 3,
        wobbleFreq: 0.5 + Math.random() * 1.5,
        wobblePhase: Math.random() * Math.PI * 2
    });
    return particles;
};
// One loop frame: each particle a soft circle whose alpha envelope is 0 at both ends of its life
// (so the top->bottom wrap is invisible) and brightest near the base.
const $d0d4547f76bf89f1$var$drawLoopFrame = (g, particles, phase)=>{
    g.clear();
    const cx = $d0d4547f76bf89f1$var$FRAME_W / 2;
    for (const p of particles){
        const age = $d0d4547f76bf89f1$var$frac(phase - p.birthPhase) // 0 (youngest, at base) -> 1 (oldest, at top)
        ;
        const lifeFrac = 1 - age;
        const fadeIn = Math.min(1, age / 0.12);
        const env = fadeIn * (1 - age);
        if (env <= 0.02) continue;
        const y = p.baseY - p.rise * age;
        const xBase = p.baseX + (cx - p.baseX) * (age * p.converge) + p.drift * age;
        const x = xBase + p.wobbleAmp * Math.sin(p.wobbleFreq * age * Math.PI * 2 + p.wobblePhase);
        const r = p.size * (0.5 + 0.5 * lifeFrac);
        g.beginFill($d0d4547f76bf89f1$var$ritualColor(lifeFrac), env * 0.9);
        g.drawCircle(x, y, r);
        g.endFill();
    }
};
let $d0d4547f76bf89f1$var$cachedFrames;
const $d0d4547f76bf89f1$export$3c87dfdb8e396b = (renderer)=>{
    if ($d0d4547f76bf89f1$var$cachedFrames) return $d0d4547f76bf89f1$var$cachedFrames;
    const particles = $d0d4547f76bf89f1$var$makeLoopParticles();
    const g = new (0, $gwPoJ.Graphics)();
    const frames = [];
    for(let i = 0; i < $d0d4547f76bf89f1$var$FRAME_COUNT; i++){
        $d0d4547f76bf89f1$var$drawLoopFrame(g, particles, i / $d0d4547f76bf89f1$var$FRAME_COUNT);
        const rt = (0, $klOfb.RenderTexture).create({
            width: $d0d4547f76bf89f1$var$FRAME_W,
            height: $d0d4547f76bf89f1$var$FRAME_H
        });
        renderer.render(g, {
            renderTexture: rt,
            clear: true
        });
        frames.push(rt);
    }
    g.destroy();
    $d0d4547f76bf89f1$var$cachedFrames = frames;
    return frames;
};



const $38e1968085fe9980$export$1cf50eb618b47754 = 24;
const $38e1968085fe9980$export$afcb8c943d23ce3a = 1000;
const $38e1968085fe9980$export$266e9dd1be6b634e = 600;
const $38e1968085fe9980$export$e329cd216bf848e = 500;
const $38e1968085fe9980$export$7336c5d181ac620e = 500;
// One palette for the whole encounter: grave bone, the ritual's venom green, and the violet the
// shrine and its stones already burn with. Every piece of caster art mixes from these, so the
// telegraphs, the staff and the shrine read as one spell rather than three overlays.
const $38e1968085fe9980$var$INK = {
    bone: 0xf3e9cf,
    boneShade: 0x8e7d5d,
    boneDim: 0xbda87f,
    venom: 0x9ff55c,
    venomPale: 0xdcffb0,
    violet: 0x8539c9,
    plum: 0x6a306c,
    orchid: 0x8436b4,
    shadow: 0x120d18,
    crack: 0x160f1d,
    staff: 0x241d2e,
    white: 0xffffff
};
// Where the ground splits before a grave spike erupts. Deliberately NOT evenly spaced: six spokes
// at 60 degrees drew a wagon wheel, which is what this art used to look like.
const $38e1968085fe9980$var$CRACK_ANGLES = [
    0.4,
    1.55,
    2.5,
    3.6,
    5.1
];
// The shards that stand up on impact, as (x, y) fractions of the mark's radius plus a height and a
// half-width in world pixels. A fixed scatter rather than a ring: bone coming out of the ground is
// not symmetrical, and anything symmetrical reads as a wheel again.
const $38e1968085fe9980$var$SHARDS = [
    [
        -0.62,
        0.26,
        22,
        6
    ],
    [
        -0.26,
        -0.4,
        16,
        5
    ],
    [
        0.18,
        0.4,
        28,
        7
    ],
    [
        0.6,
        -0.08,
        20,
        6
    ],
    [
        0.82,
        0.3,
        12,
        4
    ],
    [
        -0.86,
        -0.06,
        12,
        4
    ],
    [
        -0.02,
        0.04,
        33,
        8
    ],
    [
        0.38,
        -0.46,
        11,
        3.5
    ]
];
class $38e1968085fe9980$export$2bd8e7543a46a0cc extends (0, $gwPoJ.Graphics) {
    constructor(renderer = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer){
        super(), this.receivedAt = 0, this.caster = {
            x: 0,
            y: 0
        }, this.combatRadius = 0, this.flames = [], this.fadeFrom = 1, this.fadeTo = 1, this.fadeStartedAt = 0, this.update = (entity, now = Date.now())=>{
            if (this.attack !== entity.bonecallerAttack) this.receivedAt = now;
            this.attack = entity.bonecallerAttack;
            this.combatRadius = entity.bonecallerCombatRadius || 0;
            this.caster = {
                ...entity.location
            };
            this.animate(now);
        }, this.viewerInside = (point)=>Math.hypot(point.x - this.caster.x, point.y - this.caster.y) <= this.combatRadius, this.setBoundaryVisible = (visible, now = Date.now())=>{
            const target = visible ? 1 : 0;
            if (target === this.fadeTo) return;
            this.fadeFrom = this.boundaryOpacity(now);
            this.fadeTo = target;
            this.fadeStartedAt = now;
        }, this.boundaryOpacity = (now)=>{
            const t = Math.max(0, Math.min(1, (now - this.fadeStartedAt) / $38e1968085fe9980$export$266e9dd1be6b634e));
            const smooth = t * t * (3 - 2 * t);
            return this.fadeFrom + (this.fadeTo - this.fadeFrom) * smooth;
        }, this.animate = (now = Date.now(), showWarnings = true)=>{
            this.clear();
            const opacity = this.boundaryOpacity(now);
            this.visible = showWarnings || opacity > 0;
            const scale = (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
            this.position.set(this.caster.x * scale, this.caster.y * scale);
            this.scale.set(scale);
            // Shared baked particles, with staggered phases. Manual playback avoids 24 ticker listeners
            // and pauses naturally when the encounter is culled. No boundary strokes remain.
            this.flames.forEach((flame, i)=>{
                const a = i * Math.PI * 2 / this.flames.length;
                flame.position.set(Math.cos(a) * this.combatRadius, Math.sin(a) * this.combatRadius);
                flame.alpha = opacity;
                flame.gotoAndStop((Math.floor(now * 24 / 1000) + i * 7) % flame.textures.length);
            });
            // Culled caster warnings disappear immediately, but its flames finish their own fade.
            if (!showWarnings) return;
            const attack = this.attack;
            if (!attack) {
                this.fadeCircle(now);
                return;
            }
            const remaining = Math.max(0, attack.remainingMs - (now - this.receivedAt));
            const progress = Math.min(1, 1 - remaining / attack.durationMs);
            if (remaining === 0) {
                this.fadeCircle(now);
                return;
            }
            const top = -35 - progress * 12;
            if (attack.phase === "anticipation" || attack.phase === "windup") this.drawChannel(top, progress, now);
            if (attack.phase === "anticipation" || attack.phase === "recovery") {
                this.fadeCircle(now);
                return;
            }
            if (attack.kind !== "spike") this.fadeCircle(now);
            // A stale warning must never invent a local impact: only the server publishes impact.
            const x = attack.x - this.caster.x, y = attack.y - this.caster.y;
            const impact = attack.phase === "impact";
            if (attack.kind === "spike") {
                const opening = impact ? 1 : Math.max(0, Math.min(1, (attack.durationMs - remaining) / $38e1968085fe9980$export$e329cd216bf848e));
                const reveal = opening * opening * (3 - 2 * opening);
                const radius = attack.radius * reveal;
                const inner = impact ? 3 : radius * (0.85 - 0.65 * progress);
                this.circleFadeStartedAt = undefined;
                this.fadingCircle = {
                    x: attack.x,
                    y: attack.y,
                    radius: radius,
                    inner: inner,
                    color: impact ? $38e1968085fe9980$var$INK.white : $38e1968085fe9980$var$INK.bone,
                    strokeAlpha: (impact ? 1 : 0.7 + 0.3 * Math.sin(progress * Math.PI * 8) ** 2) * reveal,
                    fillAlpha: (impact ? 0.4 : 0.16) * reveal,
                    expiresAt: this.receivedAt + attack.remainingMs,
                    progress: progress,
                    impact: impact
                };
                this.drawSpikeMark(this.fadingCircle, 1, now);
            } else this.drawSweep(attack, progress, impact, now);
            // Drawn last so the bolt lands ON the mark it is aimed at, never under it.
            if (attack.kind === "spike" && attack.phase === "windup" && remaining <= $38e1968085fe9980$export$afcb8c943d23ce3a) this.drawLightning(x, y, top, attack.id, attack.durationMs - remaining);
        }, this.fadeCircle = (now)=>{
            const circle = this.fadingCircle;
            if (!circle) return;
            if (this.circleFadeStartedAt === undefined) this.circleFadeStartedAt = Math.min(now, circle.expiresAt);
            const t = Math.max(0, Math.min(1, (now - this.circleFadeStartedAt) / $38e1968085fe9980$export$7336c5d181ac620e));
            if (t === 1) {
                this.fadingCircle = undefined;
                return;
            }
            const closing = 1 - t * t * (3 - 2 * t);
            this.drawSpikeMark({
                ...circle,
                radius: circle.radius * closing,
                inner: circle.inner * closing
            }, closing, now, true);
        }, /**
     * The grave-spike ground mark: a rune circle whose glyphs turn, ground cracks that reach the rim
     * as the windup runs out, and a bone ring that closes on the centre -- then, on impact, shards
     * standing up out of the dirt.
     *
     * The first circle drawn here is the server's own geometry, at the server's radius and with the
     * stroke and fill the countdown is encoded in; everything else is decoration laid around it.
     */ this.drawSpikeMark = (mark, opacity, now, closing = false)=>{
            const x = mark.x - this.caster.x, y = mark.y - this.caster.y;
            const r = mark.radius;
            this.lineStyle(0);
            this.beginFill($38e1968085fe9980$var$INK.shadow, (mark.impact ? 0.22 : 0.38) * opacity);
            this.drawEllipse(x, y, r * 1.08, r * 0.94);
            this.endFill();
            this.lineStyle(3, mark.color, mark.strokeAlpha * opacity);
            this.beginFill($38e1968085fe9980$var$INK.plum, mark.fillAlpha * opacity);
            this.drawCircle(x, y, r);
            this.endFill();
            this.lineStyle(0);
            this.beginFill($38e1968085fe9980$var$INK.orchid, (mark.impact ? 0.28 : 0.1) * opacity);
            this.drawCircle(x, y, r * 0.58);
            this.endFill();
            this.lineStyle(8, $38e1968085fe9980$var$INK.violet, (mark.impact ? 0.2 : 0.1) * opacity);
            this.drawCircle(x, y, r + 2);
            if (mark.impact) {
                this.lineStyle(2, $38e1968085fe9980$var$INK.white, 0.3 * opacity);
                this.drawCircle(x, y, r * 1.2);
            } else this.runeRing(x, y, r, now / 2600, $38e1968085fe9980$var$INK.bone, 0.9 * opacity);
            const reach = mark.impact ? 0.95 : 0.9 * mark.progress;
            for(let i = 0; i < $38e1968085fe9980$var$CRACK_ANGLES.length; i++){
                this.crack(x, y, $38e1968085fe9980$var$CRACK_ANGLES[i], r * reach, i + 1, $38e1968085fe9980$var$INK.crack, mark.impact ? 3.6 : 3.2, (mark.impact ? 0.85 : 0.75) * opacity);
                if (!mark.impact) this.crack(x, y, $38e1968085fe9980$var$CRACK_ANGLES[i], r * reach, i + 1, $38e1968085fe9980$var$INK.venom, 1.3, (0.35 + 0.5 * mark.progress) * opacity);
            }
            if (!mark.impact) {
                this.dashedRing(x, y, mark.inner, 10, 0.42, 2, $38e1968085fe9980$var$INK.bone, (0.5 + 0.45 * mark.progress) * opacity, now / 900);
                this.lineStyle(0);
                this.beginFill($38e1968085fe9980$var$INK.venom, (0.16 + 0.3 * mark.progress) * opacity);
                this.drawCircle(x, y, 3 + 7 * mark.progress);
                this.endFill();
                this.beginFill($38e1968085fe9980$var$INK.venomPale, (0.4 + 0.5 * mark.progress) * opacity);
                this.drawCircle(x, y, 1.4 + 3 * mark.progress);
                this.endFill();
                return;
            }
            this.lineStyle(0);
            this.beginFill($38e1968085fe9980$var$INK.venomPale, 0.14 * opacity);
            this.drawEllipse(x, y + r * 0.12, r * 0.8, r * 0.26);
            this.endFill();
            // The shards only belong to the impact itself: a mark that is closing has nothing left to
            // stand up, and drawing them shrinking looks like the ground swallowing them again.
            if (closing) return;
            for (const [dx, dy, height, halfWidth] of $38e1968085fe9980$var$SHARDS)this.shard(x + dx * r, y + dy * r * 0.78, height, halfWidth, dx * 3, opacity);
            this.beginFill($38e1968085fe9980$var$INK.white, 0.85 * opacity);
            this.drawCircle(x, y, 3.5);
            this.endFill();
        }, /** A single bone shard standing out of the ground, lit from the left. */ this.shard = (bx, by, height, halfWidth, lean, alpha)=>{
            const tx = bx + lean, ty = by - height;
            this.lineStyle(0);
            this.beginFill($38e1968085fe9980$var$INK.boneShade, alpha);
            this.drawPolygon([
                bx + halfWidth * 0.1,
                by,
                tx,
                ty,
                bx + halfWidth,
                by + 1
            ]);
            this.endFill();
            this.beginFill($38e1968085fe9980$var$INK.bone, alpha);
            this.drawPolygon([
                bx - halfWidth,
                by + 1,
                tx,
                ty,
                bx + halfWidth * 0.1,
                by
            ]);
            this.endFill();
            this.lineStyle(1, $38e1968085fe9980$var$INK.staff, alpha * 0.5);
            this.moveTo(bx - halfWidth, by + 1);
            this.lineTo(tx, ty);
            this.lineTo(bx + halfWidth, by + 1);
        }, /** A jagged split in the ground, drawn flattened into the ground plane. */ this.crack = (x, y, angle, length, seed, color, width, alpha)=>{
            if (length <= 0 || alpha <= 0) return;
            this.lineStyle(width, color, alpha);
            this.moveTo(x, y);
            for(let s = 1; s <= 4; s++){
                const t = s / 4, wobble = Math.sin(seed * 7.3 + s * 2.1) * 0.26 * (1 - t);
                this.lineTo(x + Math.cos(angle + wobble) * length * t, y + Math.sin(angle + wobble) * length * t * 0.8);
            }
        }, /**
     * A turning band of glyphs just inside the rim: tangential strokes between two thin rings, with
     * three longer runes among them. Tangential rather than radial -- radial ticks drew a clock face.
     *
     * Every stroke stays INSIDE the server's radius. The brightest edge a player can see has to be
     * the edge they are actually safe outside of, so nothing decorative may overhang it.
     */ this.runeRing = (cx, cy, r, rot, color, alpha)=>{
            if (r <= 0 || alpha <= 0) return;
            const band = r * 0.9, inner = r * 0.8;
            this.lineStyle(1.6, color, alpha * 0.45);
            this.drawCircle(cx, cy, inner);
            this.lineStyle(3, color, alpha * 0.85);
            for(let i = 0; i < 11; i++){
                const a0 = rot + i * (Math.PI * 2 / 11), span = 0.12 + 0.09 * Math.abs(Math.sin(i * 2.7));
                this.moveTo(cx + Math.cos(a0) * band, cy + Math.sin(a0) * band);
                this.arc(cx, cy, band, a0, a0 + span);
            }
            this.lineStyle(2, color, alpha * 0.95);
            for(let i = 0; i < 3; i++){
                const a = rot * -0.6 + i * 2.094;
                const px = cx + Math.cos(a) * band, py = cy + Math.sin(a) * band;
                const ox = Math.cos(a), oy = Math.sin(a), tx = -oy, ty = ox;
                this.moveTo(px - ox * 4 + tx * 3, py - oy * 4 + ty * 3);
                this.lineTo(px + ox * 4, py + oy * 4);
                this.lineTo(px - ox * 4 - tx * 3, py - oy * 4 - ty * 3);
            }
        }, /** A broken ring: `count` arcs with `gap` of each step left empty, turned by `rot`. */ this.dashedRing = (cx, cy, r, count, gap, width, color, alpha, rot)=>{
            if (r <= 0 || alpha <= 0) return;
            this.lineStyle(width, color, alpha);
            const step = Math.PI * 2 / count;
            for(let i = 0; i < count; i++){
                const a0 = rot + i * step, a1 = a0 + step * (1 - gap);
                this.moveTo(cx + Math.cos(a0) * r, cy + Math.sin(a0) * r);
                this.arc(cx, cy, r, a0, a1);
            }
        }, /**
     * The bone sweep: a fan at the caster's feet whose swept side brightens as the blow travels
     * across it. On impact three claw trails sweep across the fan, shedding bone chips
     * that fly outward and fade over the authoritative impact phase.
     */ this.drawSweep = (attack, progress, impact, now)=>{
            const s0 = attack.angle - attack.halfArc, s1 = attack.angle + attack.halfArc;
            const r = attack.radius;
            const opacity = impact ? 1 - progress : 1;
            this.lineStyle(0);
            this.beginFill($38e1968085fe9980$var$INK.shadow, (impact ? 0.18 : 0.32) * opacity);
            this.wedge(r * 1.05, s0 - 0.05, s1 + 0.05);
            this.endFill();
            this.beginFill(impact ? 0xa468d8 : $38e1968085fe9980$var$INK.plum, (impact ? 0.2 : 0.16) * opacity);
            this.wedge(r, s0, s1);
            this.endFill();
            this.beginFill(impact ? 0xc9a2ff : $38e1968085fe9980$var$INK.orchid, (impact ? 0.15 : 0.1) * opacity);
            this.wedge(r * 0.62, s0, s1);
            this.endFill();
            if (!impact) {
                const lead = s0 + 2 * attack.halfArc * progress;
                this.beginFill($38e1968085fe9980$var$INK.venom, 0.14);
                this.wedge(r, s0, lead);
                this.endFill();
                this.lineStyle(8, $38e1968085fe9980$var$INK.violet, 0.12);
                this.arcAt(r, s0, s1);
                this.lineStyle(1.6, $38e1968085fe9980$var$INK.bone, 0.5);
                this.arcAt(r, s0, s1);
                this.lineStyle(1.4, $38e1968085fe9980$var$INK.bone, 0.35);
                for (const edge of [
                    s0,
                    s1
                ]){
                    this.moveTo(0, 0);
                    this.lineTo(Math.cos(edge) * r, Math.sin(edge) * r);
                }
                this.lineStyle(3, $38e1968085fe9980$var$INK.venomPale, 0.9);
                this.arcAt(r, s0, lead);
                this.lineStyle(2.4, $38e1968085fe9980$var$INK.venomPale, 0.95);
                this.moveTo(Math.cos(lead) * r * 0.2, Math.sin(lead) * r * 0.2);
                this.lineTo(Math.cos(lead) * r * 1.04, Math.sin(lead) * r * 1.04);
                this.lineStyle(0);
                this.beginFill($38e1968085fe9980$var$INK.venomPale, 0.9);
                this.drawCircle(Math.cos(lead) * r, Math.sin(lead) * r, 2.6);
                this.endFill();
                for(let i = 0; i < 5; i++){
                    const a = s0 + (i + 0.5) * (2 * attack.halfArc / 5);
                    this.lineStyle(2, $38e1968085fe9980$var$INK.bone, a <= lead ? 0.85 : 0.3);
                    this.moveTo(Math.cos(a) * r * 0.93, Math.sin(a) * r * 0.93);
                    this.lineTo(Math.cos(a) * r * 1.06, Math.sin(a) * r * 1.06);
                }
                return;
            }
            // Fast travel followed by a fading follow-through. Progress comes from the server's
            // remaining phase time, so receiving another snapshot cannot restart the swing.
            const travel = Math.min(1, progress / 0.8);
            const lead = s0 + (s1 - s0) * (1 - (1 - travel) ** 2);
            const tail = Math.max(s0, lead - attack.halfArc * 0.75);
            this.lineStyle(10, $38e1968085fe9980$var$INK.violet, 0.3 * opacity);
            this.arcAt(r * 0.98, tail, lead);
            this.lineStyle(5, $38e1968085fe9980$var$INK.white, opacity);
            this.arcAt(r * 0.98, tail, lead);
            for(let i = 0; i < 3; i++){
                const f = 0.42 + i * 0.24;
                this.lineStyle(4 - i * 0.9, $38e1968085fe9980$var$INK.bone, (0.95 - i * 0.18) * opacity);
                this.arcAt(r * f, tail, lead);
            }
            this.lineStyle(2, $38e1968085fe9980$var$INK.venomPale, opacity);
            this.moveTo(Math.cos(lead) * r * 0.2, Math.sin(lead) * r * 0.2);
            this.lineTo(Math.cos(lead) * r, Math.sin(lead) * r);
            this.lineStyle(0);
            for(let i = 0; i < 6; i++){
                const a = s0 + (i + 0.5) * (2 * attack.halfArc / 6);
                if (a > lead) continue;
                const releasedAt = 0.8 * (1 - Math.sqrt(1 - (a - s0) / (s1 - s0)));
                const age = Math.max(0, progress - releasedAt);
                const chip = r * (0.72 + 0.18 * (i * 53 % 5) / 5) + age * 24;
                this.beginFill($38e1968085fe9980$var$INK.bone, 0.9 * (1 - age) * opacity);
                this.drawCircle(Math.cos(a) * chip, Math.sin(a) * chip - Math.sin(age * Math.PI) * 8, (1.6 + i % 2) * (1 - age * 0.5));
                this.endFill();
            }
        }, this.wedge = (r, a0, a1)=>{
            this.moveTo(0, 0);
            this.arc(0, 0, r, a0, a1);
            this.lineTo(0, 0);
        }, this.arcAt = (r, a0, a1)=>{
            this.moveTo(Math.cos(a0) * r, Math.sin(a0) * r);
            this.arc(0, 0, r, a0, a1);
        }, /**
     * The caster itself charging: a pool of light gathering at its soles, motes rising out of it,
     * and a staff head that brightens and draws its orbiting sparks in as the blow nears. The staff
     * head is where every bolt is fired from, so it has to be the brightest thing on the caster.
     */ this.drawChannel = (top, progress, now)=>{
            this.lineStyle(0);
            this.beginFill($38e1968085fe9980$var$INK.venom, 0.1 + 0.12 * progress);
            this.drawEllipse(0, 20, 11 + 7 * progress, 4.5 + 3 * progress);
            this.endFill();
            this.lineStyle(1.5, $38e1968085fe9980$var$INK.venom, 0.3 + 0.35 * progress);
            this.drawEllipse(0, 20, 16 + 9 * progress, 6.5 + 3.5 * progress);
            this.lineStyle(1.4, $38e1968085fe9980$var$INK.venomPale, 0.35 + 0.4 * progress);
            for(let i = 0; i < 3; i++){
                const rise = (now / 420 + i * 0.333) % 1 * 26, mx = Math.sin(now / 300 + i * 2.1) * 12;
                this.moveTo(mx, 20 - rise);
                this.lineTo(mx + 1.5, 20 - rise - 4);
            }
            this.lineStyle(4.5, $38e1968085fe9980$var$INK.staff, 0.8);
            this.moveTo(10, -6);
            this.lineTo(10, top + 5);
            this.lineStyle(1.8, $38e1968085fe9980$var$INK.boneDim, 0.95);
            this.moveTo(9.2, -6);
            this.lineTo(9.2, top + 5);
            this.lineStyle(0);
            this.beginFill($38e1968085fe9980$var$INK.violet, 0.12 + 0.16 * progress);
            this.drawCircle(10, top, 11 + 9 * progress);
            this.endFill();
            this.beginFill($38e1968085fe9980$var$INK.venom, 0.18 + 0.28 * progress);
            this.drawCircle(10, top, 5.5 + 5 * progress);
            this.endFill();
            this.beginFill($38e1968085fe9980$var$INK.venomPale, 0.95);
            this.drawCircle(10, top, 1.8 + 2.8 * progress);
            this.endFill();
            this.lineStyle(1.5, $38e1968085fe9980$var$INK.venom, 0.8);
            for(let i = 0; i < 3; i++){
                const a = now / 240 + i * 2.094, r = 19 - 13 * progress;
                this.moveTo(10 + Math.cos(a) * r, top + Math.sin(a) * r * 0.8);
                this.lineTo(10 + Math.cos(a + 0.6) * (r * 0.66), top + Math.sin(a + 0.6) * (r * 0.66) * 0.8);
            }
        }, this.drawLightning = (x, y, staffY, id, elapsedMs)=>{
            const sx = 10, sy = staffY, dx = x - sx, dy = y - sy;
            const length = Math.hypot(dx, dy) || 1;
            const frame = Math.floor(elapsedMs / 45);
            const points = [
                {
                    x: sx,
                    y: sy
                }
            ];
            for(let i = 1; i < 8; i++){
                const t = i / 8;
                const jag = Math.sin(id * 17.1 + frame * 13.7 + i * 9.3) * 10 * Math.sin(t * Math.PI);
                points.push({
                    x: sx + dx * t - dy / length * jag,
                    y: sy + dy * t + dx / length * jag
                });
            }
            points.push({
                x: x,
                y: y
            });
            // Four passes over ONE path so the halo stays welded to the core: a wide violet bloom, the
            // 7px body the fork test pins, a venom-green channel, and a white-hot filament. Fewer, longer
            // segments than before -- a tight zigzag at 7px mitres itself apart into two scribbles.
            for (const [width, color, alpha] of [
                [
                    9,
                    $38e1968085fe9980$var$INK.violet,
                    0.16
                ],
                [
                    7,
                    $38e1968085fe9980$var$INK.violet,
                    0.34
                ],
                [
                    3,
                    $38e1968085fe9980$var$INK.venom,
                    0.85
                ],
                [
                    1.2,
                    0xeeffcf,
                    1
                ]
            ]){
                this.lineStyle(width, color, alpha);
                this.moveTo(sx, sy);
                for (const point of points.slice(1))this.lineTo(point.x, point.y);
            }
            this.lineStyle(1.4, $38e1968085fe9980$var$INK.venom, 0.6);
            for (const index of [
                3,
                5
            ]){
                const p = points[index];
                const side = index === 3 ? 1 : -1;
                this.moveTo(p.x, p.y);
                this.lineTo(p.x - dy / length * 11 * side, p.y + dx / length * 11 * side);
                this.lineTo(p.x - dy / length * 17 * side + dx / length * 7, p.y + dx / length * 17 * side + dy / length * 7);
            }
        };
        const frames = (0, $d0d4547f76bf89f1$export$3c87dfdb8e396b)(renderer);
        for(let i = 0; i < $38e1968085fe9980$export$1cf50eb618b47754; i++){
            const flame = new (0, $d3fD1.AnimatedSprite)(frames, false);
            flame.anchor.set(0.5, 1);
            flame.scale.set(0.32);
            flame.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
            this.addChild(flame);
            this.flames.push(flame);
        }
    }
}


/** Public attack geometry, shared by authoritative hit tests and client warnings. */ const $0d31e53335c391b0$export$31a49faa74379420 = 192;
const $0d31e53335c391b0$export$103bda3b7c5a2a8f = [
    {
        x: -64,
        y: -32
    },
    {
        x: 0,
        y: -64
    },
    {
        x: 64,
        y: -32
    }
];
const $0d31e53335c391b0$export$448fd8468429ea22 = 42;
const $0d31e53335c391b0$export$e0f0fe6373bc56ed = 80;
const $0d31e53335c391b0$export$fb2e601e134a379e = Math.PI / 3;
const $0d31e53335c391b0$export$3aae1f8e011944ff = (attack, point)=>{
    const dx = point.x - attack.x, dy = point.y - attack.y;
    if (Math.hypot(dx, dy) > attack.radius) return false;
    if (attack.kind === "spike" || dx === 0 && dy === 0) return true;
    const delta = Math.atan2(Math.sin(Math.atan2(dy, dx) - attack.angle), Math.cos(Math.atan2(dy, dx) - attack.angle));
    return Math.abs(delta) <= attack.halfArc;
};


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

const $d853927d8c1129f4$export$ebd82e9241102481 = 1400;
const $d853927d8c1129f4$export$cf4f869f26538686 = (0, $0d31e53335c391b0$export$103bda3b7c5a2a8f);
class $d853927d8c1129f4$export$84351d8b4390f518 extends (0, $gwPoJ.Graphics) {
    constructor(coordinateScale = (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom){
        super(), this.coordinateScale = coordinateScale, this.receivedAt = 0, this.update = (entity, now = Date.now())=>{
            if (entity.bonecallerRitual !== this.ritual) this.receivedAt = now;
            this.ritual = entity.bonecallerRitual;
            const scale = this.coordinateScale;
            // Humanoid soles sit about 22px below the entity origin; the altar's centre adds another 6.
            this.position.set(entity.location.x * scale, (entity.location.y + 16) * scale);
            this.scale.set(scale);
            this.animate(now);
        }, this.animate = (now = Date.now())=>{
            this.clear();
            const ritual = this.ritual;
            if (!ritual) return;
            const age = ritual.transitionAgeMs === undefined ? Infinity : ritual.transitionAgeMs + now - this.receivedAt;
            const t = Math.min(1, age / $d853927d8c1129f4$export$ebd82e9241102481);
            const ending = ritual.phase !== "active";
            const collapse = ritual.phase === "interrupted";
            const glow = !ending ? 1 : Math.max(0, 1 - t);
            // An engraved altar and scattered bone fragments give the rooted caster a physical shrine.
            this.lineStyle(2, 0x686072, 0.9);
            this.beginFill(0x24212e, 0.85);
            this.drawEllipse(0, 6, 39, 24);
            this.endFill();
            this.lineStyle(1.5, ending ? 0x6a6171 : 0x925ab4, 0.8);
            this.drawEllipse(0, 4, 30, 17);
            for(let i = 0; i < 8; i++){
                const a = i * Math.PI / 4;
                const x = Math.cos(a) * 45, y = Math.sin(a) * 29 + 6;
                this.lineStyle(2, 0xb4ada0, 0.8);
                this.moveTo(x - 3, y - 3);
                this.lineTo(x + 4, y + 2);
                this.drawCircle(x - 3, y - 3, 1.5);
            }
            $d853927d8c1129f4$export$cf4f869f26538686.forEach((stone, index)=>{
                const lit = index < ritual.stage;
                const energy = lit ? glow * (0.8 + 0.2 * Math.sin(now / 200 + index)) : 0;
                const x = stone.x, y = stone.y;
                if (energy > 0) {
                    this.lineStyle(0);
                    this.beginFill(0x8436b4, energy * 0.2);
                    this.drawEllipse(x, y, 18, 22);
                    this.endFill();
                    this.lineStyle(1, 0x95ec64, energy * 0.4);
                    this.moveTo(x, y);
                    this.lineTo(0, 6);
                }
            });
            if (!ending || age >= $d853927d8c1129f4$export$ebd82e9241102481) return;
            const alpha = (1 - t) ** 2;
            const radius = collapse ? 90 * (1 - t) : 18 + 140 * t;
            this.lineStyle(3, collapse ? 0xb98acd : 0xb6ff75, alpha);
            this.drawEllipse(0, 6, radius, radius * 0.7);
            for(let i = 0; i < 18; i++){
                const a = i * Math.PI / 9;
                const r = collapse ? 85 * (1 - t) : 25 + 120 * t;
                const x = Math.cos(a) * r, y = Math.sin(a) * r * 0.7 + 6 - Math.sin(t * Math.PI) * 24;
                this.lineStyle(0);
                this.beginFill(i % 2 ? 0x9150bc : 0xd0ffa0, alpha);
                this.drawCircle(x, y, 2.5);
                this.endFill();
            }
        };
    }
}
class $d853927d8c1129f4$export$c1cc1ba971a715b4 extends (0, $gwPoJ.Graphics) {
    constructor(...args){
        super(...args), this.endsAt = 0, this.update = (entity, now = Date.now())=>{
            if (this.sample !== entity.bonecallerEmergenceRemainingMs) {
                this.sample = entity.bonecallerEmergenceRemainingMs;
                this.endsAt = now + (this.sample || 0);
            }
            const scale = (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
            this.position.set(entity.location.x * scale, entity.location.y * scale);
            this.scale.set(scale);
            this.animate(now);
        }, this.animate = (now = Date.now())=>{
            this.clear();
            const remaining = Math.max(0, this.endsAt - now);
            if (!remaining) return;
            const t = 1 - remaining / 900, alpha = (1 - t) ** 2;
            this.lineStyle(2, 0x9ef367, alpha);
            this.drawEllipse(0, 10, 12 + t * 25, 5 + t * 10);
            for(let i = 0; i < 6; i++){
                const a = i * Math.PI / 3;
                const x = Math.cos(a) * (8 + 20 * t), y = 10 + Math.sin(a) * 10 - Math.sin(t * Math.PI) * 25;
                this.lineStyle(2, 0xe0dfc6, alpha);
                this.moveTo(x, y);
                this.lineTo(x + 3, y - 6);
                this.drawCircle(x + 3, y - 6, 1.5);
            }
        };
    }
}


parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $gwPoJ = parcelRequire("gwPoJ");
var $P8XPi = parcelRequire("P8XPi");
var $8t5Gy = parcelRequire("8t5Gy");

const $1f8db90fd216ae4e$export$d61a488fa38d3e42 = 3400;
const $1f8db90fd216ae4e$export$b91beae189032d57 = 850;
/** Fast attack, long tail: a symmetrical sine looks like a lamp being turned up and down. */ const $1f8db90fd216ae4e$var$RISE = 0.16;
const $1f8db90fd216ae4e$var$FALL = 1.7;
// Warm, and starved of green: additive orange over grass lands on lime if the green is left in
// (the Ember Core blast learned this the hard way), so the outer glow is pushed towards red and
// only the tight fringe and the sparkle are allowed near white.
const $1f8db90fd216ae4e$var$INK = {
    glow: 0xff8a24,
    spark: 0xffb347,
    hot: 0xfff0dc,
    pool: 0xffa83c,
    white: 0xffffff
};
const $1f8db90fd216ae4e$var$GLOW_PX = 6 // how far the soft outer glow reaches past the silhouette, in world pixels
;
const $1f8db90fd216ae4e$var$GLOW_ALPHA = 0.13;
const $1f8db90fd216ae4e$var$HALO_PX = 2.5 // the tight hot fringe that actually draws the shape
;
const $1f8db90fd216ae4e$var$HALO_ALPHA = 0.55;
const $1f8db90fd216ae4e$var$SHINE_ALPHA = 0.2 // the item's own pixels, lifted -- deliberately small
;
const $1f8db90fd216ae4e$var$POOL_ALPHA = 0.1;
const $1f8db90fd216ae4e$var$POOL_IDLE = 0.12 // what is left on the ground between flashes
;
const $1f8db90fd216ae4e$var$SPARK_ARM = 7;
const $1f8db90fd216ae4e$var$SPARK_ASPECT = 0.7 // short axis over long: nearly square, or it reads as a scratch
;
const $1f8db90fd216ae4e$var$SPARK_WAIST = 0.26;
const $1f8db90fd216ae4e$var$SPARK_TRAVEL = 0.8 // how far along the item's long axis the sparkle slides, as a fraction
;
const $1f8db90fd216ae4e$var$smoothstep = (t)=>t <= 0 ? 0 : t >= 1 ? 1 : t * t * (3 - 2 * t);
const $1f8db90fd216ae4e$export$be70ea69738dea47 = (elapsed)=>{
    const u = elapsed / $1f8db90fd216ae4e$export$b91beae189032d57;
    if (u < 0 || u > 1) return 0;
    return u < $1f8db90fd216ae4e$var$RISE ? $1f8db90fd216ae4e$var$smoothstep(u / $1f8db90fd216ae4e$var$RISE) : Math.pow(1 - (u - $1f8db90fd216ae4e$var$RISE) / (1 - $1f8db90fd216ae4e$var$RISE), $1f8db90fd216ae4e$var$FALL);
};
/** A four-point star: `arm` along `rot`, `arm * aspect` across it, pinched to `arm * waist`. */ const $1f8db90fd216ae4e$var$star = (g, cx, cy, arm, rot, color, alpha, aspect, waist)=>{
    const points = [];
    for(let i = 0; i < 4; i++){
        const tip = rot + i * Math.PI / 2;
        const len = i % 2 === 0 ? arm : arm * aspect;
        points.push(cx + Math.cos(tip) * len, cy + Math.sin(tip) * len);
        const between = tip + Math.PI / 4;
        points.push(cx + Math.cos(between) * arm * waist, cy + Math.sin(between) * arm * waist);
    }
    g.beginFill(color, alpha);
    g.drawPolygon(points);
    g.endFill();
};
class $1f8db90fd216ae4e$export$a41694209750058e extends (0, $8t5Gy.Container) {
    constructor(entityId, subject){
        super(), this.texWidth = 1, this.texHeight = 1, this.baseScaleX = 1, this.baseScaleY = 1, this.poolRadius = 10, this.poolY = 6, // Where the art's middle sits inside the item's container. Zero for an atlas item
        // (the frame carries its own centred anchor), but a `tileset:id` sprite is placed by
        // hand -- half its width left and a flat 14px up -- and the ground pool and the
        // sparkle belong on the ART, not on the container's origin.
        this.artX = 0, this.artY = 0, this.lit = -1, this.silhouette = (blendMode)=>{
            const sprite = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).EMPTY);
            sprite.blendMode = blendMode;
            this.turned.addChild(sprite);
            return sprite;
        }, /** True while the item this belongs to is still on the world surface. */ this.alive = ()=>!this.destroyed && !!this.subject.parent, /**
     * Point the copies at the item's current art. Re-run whenever the texture changes, which it
     * does when the sprite behind an item is rebuilt -- otherwise the glow traces a shape the item
     * no longer wears.
     */ this.trace = (model)=>{
            const texture = model.texture;
            this.tracing = texture;
            this.texWidth = Math.max(1, texture.width);
            this.texHeight = Math.max(1, texture.height);
            this.baseScaleX = model.scale.x;
            this.baseScaleY = model.scale.y;
            // Art this size wants a pool roughly as wide as it is, sitting just under its lowest edge.
            this.poolRadius = 6 + Math.max(this.texWidth, this.texHeight) * 0.25;
            this.poolY = 2 + Math.min(this.texWidth, this.texHeight) * 0.35;
            this.artX = model.position.x + (0.5 - model.anchor.x) * this.texWidth * this.baseScaleX;
            this.artY = model.position.y + (0.5 - model.anchor.y) * this.texHeight * this.baseScaleY;
            for (const sprite of [
                this.glow,
                this.halo,
                this.body,
                this.shine
            ]){
                sprite.texture = texture;
                sprite.anchor.copyFrom(model.anchor);
                sprite.position.copyFrom(model.position);
            }
            this.lit = -1;
        }, /** Grow a copy `px` world pixels past the item's edge on every side. */ this.grow = (sprite, px)=>{
            sprite.scale.set(this.baseScaleX * (1 + 2 * px / this.texWidth), this.baseScaleY * (1 + 2 * px / this.texHeight));
        }, this.animate = (now, zoom = (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom)=>{
            const art = this.subject.glintArt();
            this.visible = this.subject.visible && !!this.subject.parent && !!art;
            if (!this.visible) return;
            if (art.sprite.texture !== this.tracing) this.trace(art.sprite);
            this.position.set(this.subject.x * zoom, this.subject.y * zoom);
            this.scale.set(zoom);
            this.turned.rotation = art.rotation;
            const elapsed = (now + this.phaseOffset) % $1f8db90fd216ae4e$export$d61a488fa38d3e42;
            const a = $1f8db90fd216ae4e$export$be70ea69738dea47(elapsed);
            // Most frames of most items land here: between flashes nothing about this drawing changes,
            // so a camp floor full of loot costs a modulo each rather than a geometry rebuild each.
            if (a === 0 && this.lit === 0) return;
            this.lit = a;
            // The art's middle, carried round by whatever angle the item is lying at.
            const cos = Math.cos(art.rotation);
            const sin = Math.sin(art.rotation);
            const cx = cos * this.artX - sin * this.artY;
            const cy = sin * this.artX + cos * this.artY;
            this.pool.clear();
            const lit = $1f8db90fd216ae4e$var$POOL_ALPHA * ($1f8db90fd216ae4e$var$POOL_IDLE + (1 - $1f8db90fd216ae4e$var$POOL_IDLE) * a);
            const radius = this.poolRadius * (1 + 0.25 * a);
            this.pool.beginFill($1f8db90fd216ae4e$var$INK.pool, lit);
            this.pool.drawEllipse(cx, cy + this.poolY, radius, radius * 0.42);
            this.pool.endFill();
            this.pool.beginFill($1f8db90fd216ae4e$var$INK.hot, lit * 0.9);
            this.pool.drawEllipse(cx, cy + this.poolY, radius * 0.5, radius * 0.22);
            this.pool.endFill();
            // The item's shape only exists over the world while the light is on it; the rest of the
            // time the drop is whatever the world surface makes of it, at its own depth.
            this.turned.visible = a > 0;
            if (a > 0) {
                this.glow.alpha = $1f8db90fd216ae4e$var$GLOW_ALPHA * a;
                this.glow.tint = $1f8db90fd216ae4e$var$INK.glow;
                this.grow(this.glow, $1f8db90fd216ae4e$var$GLOW_PX * (0.5 + 0.5 * a));
                this.halo.alpha = $1f8db90fd216ae4e$var$HALO_ALPHA * a;
                this.halo.tint = $1f8db90fd216ae4e$var$INK.hot;
                this.grow(this.halo, $1f8db90fd216ae4e$var$HALO_PX * (0.4 + 0.6 * a));
                this.body.alpha = a;
                this.body.tint = art.sprite.tint;
                this.body.scale.set(this.baseScaleX, this.baseScaleY);
                this.shine.alpha = $1f8db90fd216ae4e$var$SHINE_ALPHA * a;
                this.shine.tint = $1f8db90fd216ae4e$var$INK.hot;
                this.shine.scale.set(this.baseScaleX, this.baseScaleY);
            }
            this.spark.clear();
            if (a <= 0.02) return;
            // The sparkle slides along the item's long axis over the first half of the window: a
            // highlight travelling across a thing is what says "this caught the light", where a
            // highlight sitting still says "something is drawn on top of this".
            const u = elapsed / $1f8db90fd216ae4e$export$b91beae189032d57;
            const reach = $1f8db90fd216ae4e$var$smoothstep(Math.min(1, u / 0.55)) * 2 - 1;
            const distance = reach * (this.texWidth / 2) * this.baseScaleX * $1f8db90fd216ae4e$var$SPARK_TRAVEL;
            const sx = cx + cos * distance;
            const sy = cy + sin * distance;
            const k = Math.sin(Math.min(1, u / 0.7) * Math.PI);
            const arm = $1f8db90fd216ae4e$var$SPARK_ARM * (0.3 + 0.7 * k);
            this.spark.beginFill($1f8db90fd216ae4e$var$INK.spark, 0.3 * k);
            this.spark.drawCircle(sx, sy, arm * 0.42);
            this.spark.endFill();
            $1f8db90fd216ae4e$var$star(this.spark, sx, sy, arm, this.tilt, $1f8db90fd216ae4e$var$INK.hot, 0.8 * k, $1f8db90fd216ae4e$var$SPARK_ASPECT, $1f8db90fd216ae4e$var$SPARK_WAIST);
            $1f8db90fd216ae4e$var$star(this.spark, sx, sy, arm * 0.45, this.tilt + Math.PI / 4, $1f8db90fd216ae4e$var$INK.spark, 0.45 * k, 0.55, 0.1);
            this.spark.beginFill($1f8db90fd216ae4e$var$INK.white, 0.9 * k);
            this.spark.drawCircle(sx, sy, 0.8 + 0.7 * k);
            this.spark.endFill();
            // Three specks lifting off the item: what turns a flash into an ember.
            for(let i = 0; i < 3; i++){
                const m = (u - 0.08 * i) / 0.75;
                if (m <= 0 || m >= 1) continue;
                this.spark.beginFill($1f8db90fd216ae4e$var$INK.hot, 0.8 * (1 - m) * (1 - m));
                this.spark.drawCircle(cx + Math.sin(this.drift + i * 2.1) * 5, cy + 2 - m * 13 - i * 1.5, 0.9 - 0.4 * m);
                this.spark.endFill();
            }
        };
        this.subject = subject;
        // A stable per-item phase: a pile of loot that all flashed on the same frame would read as
        // one blinking object rather than as several things worth picking up.
        let hash = 0;
        for(let i = 0; i < entityId.length; i++)hash = Math.imul(hash, 31) + entityId.charCodeAt(i) >>> 0;
        // ...which needs the hash AVALANCHED, not just accumulated. A plain polynomial hash turns a
        // one-character difference into a one-unit difference, and the ids a single drop event mints
        // share every character but their last few -- six items dropped together came out with
        // phases a millisecond apart and flashed as one thing. Seen in the running game.
        hash ^= hash >>> 16;
        hash = Math.imul(hash, 0x45d9f3b) >>> 0;
        hash ^= hash >>> 16;
        this.phaseOffset = hash % $1f8db90fd216ae4e$export$d61a488fa38d3e42;
        this.tilt = (hash % 97 / 97 - 0.5) * 0.5;
        this.drift = hash % 61 / 61 * Math.PI * 2;
        this.interactive = false;
        this.interactiveChildren = false;
        // Over the world, under the overlay's own nameplates and prompts.
        this.zIndex = -1;
        this.visible = false;
        this.pool = new (0, $gwPoJ.Graphics)();
        this.pool.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.addChild(this.pool);
        this.turned = new (0, $8t5Gy.Container)();
        this.addChild(this.turned);
        this.glow = this.silhouette((0, $P8XPi.BLEND_MODES).ADD);
        this.halo = this.silhouette((0, $P8XPi.BLEND_MODES).ADD);
        // The item itself, over its own fringe: this is the copy that shows through a tree.
        this.body = this.silhouette((0, $P8XPi.BLEND_MODES).NORMAL);
        this.shine = this.silhouette((0, $P8XPi.BLEND_MODES).ADD);
        this.spark = new (0, $gwPoJ.Graphics)();
        this.spark.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.addChild(this.spark);
    }
}



class $b11c64d757fefaba$export$ca9afcfe841d52c9 extends (0, $a64b70167386625f$export$98e91636974d835d) {
}
const $b11c64d757fefaba$var$SCALING_CONSTANT = (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
class $b11c64d757fefaba$export$198fa1625abb29ee extends (0, $gwPoJ.Graphics) {
    constructor(logic, groundSurface, features = (0, $1704411fa88dc9bf$export$e5daf445bbba1e2f)){
        super(), this.groundSurface = groundSurface, this.features = features, this.entityIdToOverlayItem = new Map(), this.holdTimers = new Map(), this.rescueHints = new Map(), this.fireHalos = new Map(), this.fadingTracers = new Set(), this.attackWarnings = new Map(), this.bonecallerWarnings = new Map(), this.bonecallerShrines = new Map(), this.bonecallerEmergences = new Map(), this.droppedItems = new Map(), this.droppedItemGlints = new Map(), this.offer = (entity)=>{
            const renderable = new $b11c64d757fefaba$export$ca9afcfe841d52c9();
            renderable.zIndex = 0;
            // A renderable can be rebuilt under a live entity (an appearance change), which lands here
            // again with a fresh item. Any dial is still inside the OLD one, where nothing will ever
            // move it again; drop it and the next message raises it on the new item.
            this.dropHoldTimer(entity.entityId);
            this.dropRescueHint(entity.entityId);
            this.dropFireHalo(entity.entityId);
            this.entityIdToOverlayItem.set(entity.entityId, renderable);
            const f = 32 * $b11c64d757fefaba$var$SCALING_CONSTANT;
            renderable.beginFill(0xff0000, 0.01);
            renderable.drawRect(0, 0, f, f);
            renderable.endFill();
            renderable.width = f;
            renderable.height = f;
            this.addChild(renderable);
            return renderable;
        }, this.remove = (entity)=>{
            if (!entity) return;
            this.dropFireHalo(entity.entityId);
            this.dropAttackWarning(entity.entityId);
            this.dropBonecallerWarning(entity.entityId);
            this.dropDroppedItemGlint(entity.entityId);
            this.droppedItems.delete(entity.entityId);
            this.dropRitualArt(entity.entityId);
            const renderable = this.entityIdToOverlayItem.get(entity.entityId);
            if (!renderable) return;
            renderable.remove();
            this.entityIdToOverlayItem.delete(entity.entityId);
            this.dropHoldTimer(entity.entityId);
            this.dropRescueHint(entity.entityId);
        }, this.exposeHoldTimerTrigger = ()=>{
            if (typeof window === "undefined") return;
            window.holdTimer = (name, durationMs = 2000)=>{
                const match = this.logic?.entityManager?.collect((e)=>!name || (e.name || "").toLowerCase().includes(name.toLowerCase())).find((e)=>this.entityIdToOverlayItem.has(e.entityId));
                if (!match) return `[holdTimer] no on-screen entity matching ${name ?? "(any)"}`;
                this.updateHoldTimer({
                    ...match,
                    holdRemainingMs: durationMs,
                    holdDurationMs: durationMs
                });
                return `[holdTimer] ${match.name || match.entityId} for ${durationMs}ms`;
            };
        }, this.dropHoldTimer = (entityId)=>{
            const timer = this.holdTimers.get(entityId);
            if (!timer) return;
            this.holdTimers.delete(entityId);
            timer.parent?.removeChild(timer);
            if (!timer.destroyed) timer.destroy({
                children: true
            });
        }, this.dropRescueHint = (entityId)=>{
            const hint = this.rescueHints.get(entityId);
            if (!hint) return;
            this.rescueHints.delete(entityId);
            hint.parent?.removeChild(hint);
            if (!hint.destroyed) hint.destroy({
                children: true
            });
        }, this.updateEntityId = (originalEntityId, updatedEntityId)=>{
            this.entityIdToOverlayItem.set(updatedEntityId, this.entityIdToOverlayItem.get(originalEntityId));
            this.entityIdToOverlayItem.delete(originalEntityId);
            const halo = this.fireHalos.get(originalEntityId);
            if (halo) {
                this.fireHalos.set(updatedEntityId, halo);
                this.fireHalos.delete(originalEntityId);
            }
            const glint = this.droppedItemGlints.get(originalEntityId);
            if (glint) {
                this.droppedItemGlints.set(updatedEntityId, glint);
                this.droppedItemGlints.delete(originalEntityId);
            }
            const dropped = this.droppedItems.get(originalEntityId);
            if (dropped) {
                this.droppedItems.set(updatedEntityId, dropped);
                this.droppedItems.delete(originalEntityId);
            }
            const warning = this.bonecallerWarnings.get(originalEntityId);
            if (warning) {
                this.bonecallerWarnings.set(updatedEntityId, warning);
                this.bonecallerWarnings.delete(originalEntityId);
            }
            for (const map of [
                this.bonecallerShrines,
                this.bonecallerEmergences
            ]){
                const art = map.get(originalEntityId);
                if (art) {
                    map.set(updatedEntityId, art);
                    map.delete(originalEntityId);
                }
            }
            // The dial travels with the item it is parented to, so only its key moves.
            const timer = this.holdTimers.get(originalEntityId);
            if (timer) {
                this.holdTimers.set(updatedEntityId, timer);
                this.holdTimers.delete(originalEntityId);
            }
            const hint = this.rescueHints.get(originalEntityId);
            if (hint) {
                this.rescueHints.set(updatedEntityId, hint);
                this.rescueHints.delete(originalEntityId);
            }
        }, this.updateEntity = (entity)=>{
            if (!entity) return;
            // Before the early return below: a dropped item has a glint but no overlay item of its own.
            this.updateDroppedItemGlint(entity);
            const renderable = this.entityIdToOverlayItem.get(entity.entityId);
            if (!renderable) return;
            const yScaler = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isShort(entity) ? 0.75 : 1.25;
            renderable.visible = entity.visible;
            renderable.x = entity.location.x * $b11c64d757fefaba$var$SCALING_CONSTANT - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.25 * $b11c64d757fefaba$var$SCALING_CONSTANT;
            renderable.y = entity.location.y * $b11c64d757fefaba$var$SCALING_CONSTANT - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * yScaler * $b11c64d757fefaba$var$SCALING_CONSTANT;
            this.updateFireHalo(entity);
            this.updateAttackWarning(entity);
            this.updateBonecallerWarning(entity);
            this.updateRitualArt(entity);
        }, this./**
     * Register a dropped item so it can glint. Called once, when its renderable is built; the
     * glint reads the renderable's live transform and texture rather than the entity's location,
     * so a spinning collectable's light turns with it.
     */ offerDroppedItemGlint = (entityId, subject)=>{
            this.droppedItems.set(entityId, subject);
        }, this.updateDroppedItemGlint = (entity)=>{
            const subject = this.droppedItems.get(entity.entityId);
            if (!subject) return;
            // The catalog says some drops are too common to be worth announcing (wood, straw, seed),
            // and the flag rides on ordinary entity messages, so it can flip either way under us.
            if (entity.noGlint === true) {
                this.dropDroppedItemGlint(entity.entityId);
                return;
            }
            if (this.droppedItemGlints.has(entity.entityId)) return;
            const glint = new (0, $1f8db90fd216ae4e$export$a41694209750058e)(entity.entityId, subject);
            this.addChild(glint);
            this.droppedItemGlints.set(entity.entityId, glint);
        }, this.dropDroppedItemGlint = (entityId)=>{
            const glint = this.droppedItemGlints.get(entityId);
            if (!glint) return;
            this.droppedItemGlints.delete(entityId);
            glint.parent?.removeChild(glint);
            glint.destroy({
                children: true
            });
        }, this.animateDroppedItemGlints = (now = Date.now())=>{
            this.droppedItemGlints.forEach((glint, entityId)=>{
                if (!glint.alive()) {
                    this.dropDroppedItemGlint(entityId);
                    this.droppedItems.delete(entityId);
                    return;
                }
                glint.animate(now);
            });
        }, this.updateRitualArt = (entity)=>{
            if (entity.bonecallerRitual) {
                let shrine = this.bonecallerShrines.get(entity.entityId);
                if (!shrine) {
                    // Ground tiles sort below 50 and characters above 100 + feet-y. The HUD overlay
                    // sits above the whole world, so a negative overlay zIndex still covers bodies.
                    shrine = new (0, $d853927d8c1129f4$export$84351d8b4390f518)(this.groundSurface ? 1 : $b11c64d757fefaba$var$SCALING_CONSTANT);
                    shrine.zIndex = this.groundSurface ? 50 : -2;
                    (this.groundSurface || this).addChild(shrine);
                    this.bonecallerShrines.set(entity.entityId, shrine);
                }
                shrine.update(entity);
            }
            if (entity.bonecallerEmergenceRemainingMs && !entity.preSpawnEffectView) {
                let emergence = this.bonecallerEmergences.get(entity.entityId);
                if (!emergence) {
                    emergence = new (0, $d853927d8c1129f4$export$c1cc1ba971a715b4)();
                    emergence.zIndex = -1;
                    this.addChild(emergence);
                    this.bonecallerEmergences.set(entity.entityId, emergence);
                }
                emergence.update(entity);
            } else {
                const emergence = this.bonecallerEmergences.get(entity.entityId);
                if (emergence) {
                    this.bonecallerEmergences.delete(entity.entityId);
                    emergence.destroy();
                }
            }
        }, this.dropRitualArt = (id)=>{
            for (const map of [
                this.bonecallerShrines,
                this.bonecallerEmergences
            ]){
                const art = map.get(id);
                if (!art) continue;
                map.delete(id);
                art.parent?.removeChild(art);
                art.destroy();
            }
        }, this.updateBonecallerWarning = (entity)=>{
            if (!entity.bonecallerCombatRadius) {
                this.dropBonecallerWarning(entity.entityId);
                return;
            }
            let warning = this.bonecallerWarnings.get(entity.entityId);
            if (!warning) {
                warning = new (0, $38e1968085fe9980$export$2bd8e7543a46a0cc)();
                warning.zIndex = -1;
                this.addChild(warning);
                this.bonecallerWarnings.set(entity.entityId, warning);
            }
            warning.update(entity);
        }, this.dropBonecallerWarning = (id)=>{
            const warning = this.bonecallerWarnings.get(id);
            if (!warning) return;
            this.bonecallerWarnings.delete(id);
            warning.parent?.removeChild(warning);
            warning.destroy({
                children: true
            });
        }, this.updateFireHalo = (entity)=>{
            if (entity.hp <= 0 || entity.isDead() || !entity.visualEffects?.includes("firehalo")) {
                this.dropFireHalo(entity.entityId);
                return;
            }
            if (this.fireHalos.has(entity.entityId)) return;
            const item = this.entityIdToOverlayItem.get(entity.entityId);
            if (!item) return;
            const halo = new (0, $030505ced35b08e9$export$228fc91891ee71a3)();
            halo.position.set((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.25 * $b11c64d757fefaba$var$SCALING_CONSTANT, 22 * $b11c64d757fefaba$var$SCALING_CONSTANT);
            halo.scale.set($b11c64d757fefaba$var$SCALING_CONSTANT);
            item.addChild(halo);
            this.fireHalos.set(entity.entityId, halo);
            halo.animate();
        }, this.dropFireHalo = (id)=>{
            const halo = this.fireHalos.get(id);
            if (!halo) return;
            this.fireHalos.delete(id);
            halo.parent?.removeChild(halo);
            halo.destroy();
        }, this.updateAttackWarning = (entity)=>{
            if (!entity.attackWindup || entity.hp <= 0 || entity.isDead()) {
                this.dropAttackWarning(entity.entityId);
                return;
            }
            let warning = this.attackWarnings.get(entity.entityId);
            if (!warning) {
                warning = new (0, $ea809ed91fb9059b$export$4563ec8c307f7b62)();
                warning.zIndex = -1;
                this.addChild(warning);
                warning.tracer.zIndex = -1;
                this.addChild(warning.tracer);
                warning.heldBomb.zIndex = 1;
                this.addChild(warning.heldBomb);
                this.attackWarnings.set(entity.entityId, warning);
            }
            warning.update(entity);
        }, this.dropAttackWarning = (id)=>{
            const warning = this.attackWarnings.get(id);
            if (!warning) return;
            this.attackWarnings.delete(id);
            warning.tracer.fade();
            if (warning.tracer.finished()) {
                warning.tracer.parent?.removeChild(warning.tracer);
                warning.tracer.destroy();
            } else this.fadingTracers.add(warning.tracer);
            warning.parent?.removeChild(warning);
            warning.heldBomb.parent?.removeChild(warning.heldBomb);
            warning.heldBomb.destroy();
            warning.destroy();
        }, this.animateBonecallerWarnings = ()=>{
            this.fadingTracers.forEach((tracer)=>{
                if (tracer.destroyed || tracer.finished()) {
                    this.fadingTracers.delete(tracer);
                    tracer.parent?.removeChild(tracer);
                    if (!tracer.destroyed) tracer.destroy();
                } else tracer.animate();
            });
            this.fireHalos.forEach((halo, id)=>{
                const item = this.entityIdToOverlayItem.get(id);
                if (!item || halo.destroyed) {
                    this.dropFireHalo(id);
                    return;
                }
                const head = item.headAttachmentWorld?.();
                if (head) halo.position.copyFrom(item.toLocal(head));
                if (item.visible) halo.animate();
            });
            this.attackWarnings.forEach((warning, id)=>{
                const item = this.entityIdToOverlayItem.get(id);
                if (!item || warning.destroyed) {
                    this.dropAttackWarning(id);
                    return;
                }
                warning.animate(Date.now(), item.visible, item.heldAttackGripWorld?.());
            });
            for (const map of [
                this.bonecallerShrines,
                this.bonecallerEmergences
            ])map.forEach((art, id)=>{
                const item = this.entityIdToOverlayItem.get(id);
                if (!item || art.destroyed) {
                    this.dropRitualArt(id);
                    return;
                }
                art.visible = item.visible;
                if (art.visible) art.animate();
            });
            this.bonecallerWarnings.forEach((warning, id)=>{
                const item = this.entityIdToOverlayItem.get(id);
                if (!item || warning.destroyed) {
                    this.dropBonecallerWarning(id);
                    return;
                }
                const player = this.logic?.playerEntity;
                warning.setBoundaryVisible(item.visible && (!player || warning.viewerInside(player.location)));
                warning.animate(Date.now(), item.visible);
            });
        }, this.getEntityRenderable = (entityId)=>{
            return this.entityIdToOverlayItem.get(entityId);
        }, this./**
     * The server's verdict on whether a held interaction is running against this entity, straight
     * off the wire (see Message.holdRemainingMs). A remaining time raises the dial and keeps it
     * anchored; no remaining time ends whichever one is up.
     *
     * Called for every entity message, so it has to be cheap and idempotent in the common case of
     * no hold at all: that is a single failed Map lookup.
     */ updateHoldTimer = (entity)=>{
            if (!this.features.interactions) return;
            const existing = this.holdTimers.get(entity.entityId);
            if (!(entity.holdRemainingMs > 0)) {
                // The dial is not dropped here -- `stop` starts its ending, and animateHoldTimers takes
                // it down once that has played. Stopping twice is a no-op, which matters because this
                // arrives on every message for as long as the entity is in range.
                existing?.stop();
                return;
            }
            const timer = existing || this.attachHoldTimer(entity.entityId);
            timer?.setRemaining(entity.holdRemainingMs, entity.holdDurationMs);
        }, this./**
     * The server's verdict on whether the "hold on her to help her up" prompt belongs over this
     * entity, straight off the wire (see Message.rescueHelpHint). Raising it is the rescue's
     * decision, never this surface's: the hold is refused while a skeleton still stands over the
     * wreck, so the prompt waits for the fight to end.
     *
     * Called for every entity message, so -- like updateHoldTimer above -- it has to be cheap and
     * idempotent in the common case of no prompt at all: one failed Map lookup.
     */ updateRescueHint = (entity)=>{
            if (!this.features.interactions) return;
            const existing = this.rescueHints.get(entity.entityId);
            if (!entity.rescueHelpHint) {
                // Not dropped here: `stop` starts its ending and animateRescueHints takes it down once
                // that has played. Stopping twice is a no-op, which matters because this arrives on
                // every message for as long as the entity is in range.
                existing?.stop();
                return;
            }
            const hint = existing || this.attachRescueHint(entity.entityId);
            hint?.show();
        }, this.attachRescueHint = (entityId)=>{
            const item = this.entityIdToOverlayItem.get(entityId);
            if (!item) return undefined;
            const hint = new (0, $2625ff0d109c91d3$export$a119cd05626ba765)();
            // Added after the hud, so it draws over the name plate rather than under it.
            item.addChild(hint);
            this.rescueHints.set(entityId, hint);
            return hint;
        }, this./**
     * Sweep the live prompt, once a frame. There is at most one in a room and only during the beat
     * between the wreck being cleared and the survivor being helped up, so this is empty almost
     * always -- the early return is what keeps it off the frame budget the rest of the time.
     */ animateRescueHints = ()=>{
            if (this.rescueHints.size === 0) return;
            const now = Date.now();
            this.rescueHints.forEach((hint, entityId)=>{
                // An entity that left took its overlay item -- and this prompt with it -- so there is
                // nothing left to animate and the entry would otherwise be held for the session.
                if (hint.destroyed || !this.entityIdToOverlayItem.has(entityId)) {
                    this.dropRescueHint(entityId);
                    return;
                }
                if (!hint.animate(now)) this.dropRescueHint(entityId);
            });
        }, this.attachHoldTimer = (entityId)=>{
            const item = this.entityIdToOverlayItem.get(entityId);
            if (!item) return undefined;
            const timer = new (0, $a34e00af51b35619$export$ba3e434c578b930c)();
            // Added after the hud, so it draws over the name plate it sits above.
            item.addChild(timer);
            this.holdTimers.set(entityId, timer);
            return timer;
        }, this./**
     * Sweep every live dial, once a frame. A hold lasts a couple of seconds and only one entity at
     * a time is usually being held, so this is empty almost always and tiny when it is not.
     */ animateHoldTimers = ()=>{
            if (this.holdTimers.size === 0) return;
            const now = Date.now();
            this.holdTimers.forEach((timer, entityId)=>{
                // An entity that left the room took its overlay item -- and this dial with it -- down
                // with it, so there is nothing left to animate and the entry would otherwise be held
                // for the session.
                if (timer.destroyed || !this.entityIdToOverlayItem.has(entityId)) {
                    this.dropHoldTimer(entityId);
                    return;
                }
                if (!timer.animate(now)) this.dropHoldTimer(entityId);
            });
        }, this.computeLocation = (x, y)=>{
            return {
                x: x * $b11c64d757fefaba$var$SCALING_CONSTANT,
                y: y * $b11c64d757fefaba$var$SCALING_CONSTANT
            };
        }, this.// Convert an overlay-local pointer into the frame that actually draws the world.
        // HUD coordinates use surfaceZoom, but its pivot is independent of the ground's:
        // dividing by surfaceZoom alone is 16 world pixels off with the house's 32px pivot.
        worldLocation = (x, y)=>{
            if (this.groundSurface) {
                const point = this.groundSurface.toLocal(this.toGlobal({
                    x: x,
                    y: y
                }));
                return {
                    x: point.x,
                    y: point.y
                };
            }
            return {
                x: x / $b11c64d757fefaba$var$SCALING_CONSTANT,
                y: y / $b11c64d757fefaba$var$SCALING_CONSTANT
            };
        };
        this.logic = logic;
        if (features.interactions) this.exposeHoldTimerTrigger();
        // Overlay items paint by zIndex so a speaking entity can lift its HUD (chat bubble) above the
        // nameplates/role glyphs of the entities around it -- see AvatarHud.liftOverlay. Items all rest
        // at zIndex 0, where pixi's stable sort keeps the old insertion order.
        this.sortableChildren = true;
    }
}


const $f938f025cf72352a$export$7f792cf86dd949d9 = 220;
class $f938f025cf72352a$export$6377df4ac9e9e40f {
    reset() {
        this.target = undefined;
        this.alpha = 1;
        this.visible = true;
    }
    update(show, now = Date.now()) {
        const target = show ? 1 : 0;
        if (this.target === undefined) {
            // A newly loaded, already hidden level should never flash on screen.
            this.alpha = target;
            this.from = target;
            this.target = target;
            this.startedAt = now;
        } else {
            if (this.target !== target) {
                this.from = this.alpha;
                this.target = target;
                this.startedAt = now;
            }
            const progress = Math.max(0, Math.min(1, (now - this.startedAt) / $f938f025cf72352a$export$7f792cf86dd949d9));
            this.alpha = this.from + (target - this.from) * progress;
        }
        this.visible = show || this.alpha > 0;
    }
    constructor(){
        this.alpha = 1;
        this.visible = true;
        this.from = 1;
        this.startedAt = 0;
    }
}





const $097c8f680b47a2c7$export$88ac54f1f217b5ed = (southRow)=>100 + southRow * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 3 + 3;
const $097c8f680b47a2c7$export$293bb924496daa6 = (southRow, floor)=>$097c8f680b47a2c7$export$88ac54f1f217b5ed(southRow) + 1 + floor / (floor + 1);


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $P8XPi = parcelRequire("P8XPi");
var $1avo5 = parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");

const $9242e6e157236a04$var$inverseProjection = new (0, $6qzqq.Matrix)();
/** The area the current render target shows, in the global coordinates filters work in. */ const $9242e6e157236a04$var$viewArea = (renderer, area)=>{
    area.copyFrom(renderer.renderTexture.sourceFrame);
    // FilterSystem expects global coordinates before the optional render projection.
    // Read the current target here so resize, nested filters and PiP renders all work.
    const projection = renderer.projection.transform;
    if (projection) {
        const matrix = $9242e6e157236a04$var$inverseProjection.copyFrom(projection).invert();
        const left = area.x, top = area.y, right = area.right, bottom = area.bottom;
        const x1 = matrix.a * left + matrix.c * top + matrix.tx;
        const x2 = matrix.a * right + matrix.c * top + matrix.tx;
        const x3 = matrix.a * left + matrix.c * bottom + matrix.tx;
        const x4 = matrix.a * right + matrix.c * bottom + matrix.tx;
        const y1 = matrix.b * left + matrix.d * top + matrix.ty;
        const y2 = matrix.b * right + matrix.d * top + matrix.ty;
        const y3 = matrix.b * left + matrix.d * bottom + matrix.ty;
        const y4 = matrix.b * right + matrix.d * bottom + matrix.ty;
        area.x = Math.min(x1, x2, x3, x4);
        area.y = Math.min(y1, y2, y3, y4);
        area.width = Math.max(x1, x2, x3, x4) - area.x;
        area.height = Math.max(y1, y2, y3, y4) - area.y;
    }
    return area;
};
/**
 * A filtered storey is drawn into an empty texture first, then laid over the scene. Pixi's MULTIPLY and ADD
 * add their own alpha to what they land on, so in that texture a shade with none of the storey's art under
 * it (a roof's shading spilling onto the storey below) came out opaque black, and a glow covered what it
 * should have lit. Keeping the texture's alpha leaves such a shade out and lets a glow add to the scene when
 * the texture is laid down; over the opaque screen it is what pixi draws.
 */ const $9242e6e157236a04$var$LIGHTING_BLENDS = [
    (0, $P8XPi.BLEND_MODES).MULTIPLY,
    (0, $P8XPi.BLEND_MODES).ADD
];
const $9242e6e157236a04$var$withStoreyBlends = (renderer, draw)=>{
    const modes = renderer.state?.blendModes, gl = renderer.gl;
    if (!modes || !gl) {
        draw();
        return;
    }
    const original = $9242e6e157236a04$var$LIGHTING_BLENDS.map((blend)=>modes[blend]);
    const swap = (next)=>{
        renderer.batch.flush();
        $9242e6e157236a04$var$LIGHTING_BLENDS.forEach((blend, i)=>{
            modes[blend] = next[i];
        });
        // The state caches the mode by number: forget it, so the next batch applies the swap.
        renderer.state.blendMode = -1;
    };
    swap(original.map(([source, destination])=>[
            source,
            destination,
            gl.ZERO,
            gl.ONE
        ]));
    try {
        draw();
    } finally{
        swap(original);
    }
};
const $9242e6e157236a04$var$isHeightBlur = (filter)=>filter instanceof (0, $1avo5.filters).BlurFilter || filter instanceof (0, $65ff58edc75cc05c$export$a64017bf69403efb);
/**
 * The children a storey's blur leaves sharp. Looking down, the stairs and ladders (`heightBlurExempt`) stay
 * crisp: they are the way between the storeys. A storey above the player is out of focus as a whole, its
 * stairs included; only what is marked `focusBlurExempt` (the nameplates) stays sharp there.
 */ const $9242e6e157236a04$var$exemptFrom = (blur)=>blur instanceof (0, $65ff58edc75cc05c$export$a64017bf69403efb) ? "focusBlurExempt" : "heightBlurExempt";
class $9242e6e157236a04$export$f08e4f53904fcf75 extends (0, $8t5Gy.Container) {
    /** Only the children `flag` exempts, through the floor's filters but its height blur: what stays sharp over it. */ renderExempt(renderer, flag) {
        const sharp = this.children.filter((child)=>child[flag] && child.renderable);
        if (!sharp.length) return;
        const renderable = this.children.map((child)=>child.renderable), filters = this.filters;
        try {
            const sharpSet = new Set(sharp);
            this.children.forEach((child)=>{
                child.renderable = sharpSet.has(child);
            });
            this.filters = filters?.filter((filter)=>!$9242e6e157236a04$var$isHeightBlur(filter)) ?? null;
            super.renderAdvanced(renderer);
        } finally{
            this.filters = filters;
            this.children.forEach((child, index)=>{
                child.renderable = renderable[index];
            });
        }
    }
    renderAdvanced(renderer) {
        const originalFilters = this.filters;
        const blur = originalFilters?.find((filter)=>filter.enabled && $9242e6e157236a04$var$isHeightBlur(filter));
        const flag = blur && $9242e6e157236a04$var$exemptFrom(blur);
        const sharp = flag ? this.children.filter((child)=>child[flag] && child.renderable) : [];
        const renderable = sharp.length ? this.children.map((child)=>child.renderable) : [];
        const draw = ()=>{
            // Draw the scenery through the height blur, then the exempt children through shade only.
            // Both passes retain the floor's transform, alpha and cutaway mask.
            sharp.forEach((child)=>{
                child.renderable = false;
            });
            super.renderAdvanced(renderer);
            if (sharp.length) {
                const sharpSet = new Set(sharp);
                this.children.forEach((child)=>{
                    child.renderable = sharpSet.has(child);
                });
                this.filters = originalFilters.filter((filter)=>!$9242e6e157236a04$var$isHeightBlur(filter));
                super.renderAdvanced(renderer);
            }
        };
        try {
            if (originalFilters?.some((filter)=>filter.enabled)) $9242e6e157236a04$var$withStoreyBlends(renderer, draw);
            else draw();
        } finally{
            this.filters = originalFilters;
            if (sharp.length) this.children.forEach((child, index)=>{
                child.renderable = renderable[index];
            });
        }
    }
}
const $9242e6e157236a04$export$35ff2aac0f7c1347 = (origin, bounds, view, margin, cell, out = new (0, $6qzqq.Rectangle)())=>{
    const left = Math.max(bounds.x - margin, view.x - cell), top = Math.max(bounds.y - margin, view.y - cell);
    const right = Math.min(bounds.right + margin, view.right + cell), bottom = Math.min(bounds.bottom + margin, view.bottom + cell);
    if (right <= view.x || left >= view.right || bottom <= view.y || top >= view.bottom || right <= left || bottom <= top) return undefined;
    const snap = (value, from, round)=>from + round((value - from) / cell) * cell;
    out.x = snap(left, origin.x, Math.floor);
    out.y = snap(top, origin.y, Math.floor);
    out.width = snap(right, origin.x, Math.ceil) - out.x;
    out.height = snap(bottom, origin.y, Math.ceil) - out.y;
    return out;
};
const $9242e6e157236a04$export$257c375c8dce6842 = 50;
const $9242e6e157236a04$export$6771b485b6a72145 = 1000;
/** Stale snapshots are redrawn one storey at a time, at least this far apart (about a frame at 120Hz). */ const $9242e6e157236a04$var$FOCUS_REFRESH_GAP_MS = 7;
/** How far past the view a redrawn snapshot reaches, as a share of the view: the camera may travel that far on it. */ const $9242e6e157236a04$var$FOCUS_SLACK = 0.25;
/** The widest texture a redraw may need, in texels: slack past it would double a pooled texture again. */ const $9242e6e157236a04$var$FOCUS_MAX_TEXELS = 2048;
let $9242e6e157236a04$var$lastStaleRefresh = -Infinity;
const $9242e6e157236a04$export$3b8d9af3c4af9938 = (placed, needs, key, now, changedAt)=>{
    if (!placed || placed.key !== key) return "unusable";
    const covers = placed.x <= needs.x + 1e-6 && placed.y <= needs.y + 1e-6 && placed.x + placed.width >= needs.right - 1e-6 && placed.y + placed.height >= needs.bottom - 1e-6;
    if (!covers) return "unusable";
    const age = now - placed.madeAt;
    if (age >= $9242e6e157236a04$export$6771b485b6a72145) return "stale";
    return changedAt > placed.madeAt && age >= $9242e6e157236a04$export$257c375c8dce6842 ? "stale" : "fresh";
};
class $9242e6e157236a04$export$bd5c976caf9abcbb extends $9242e6e157236a04$export$f08e4f53904fcf75 {
    renderAdvanced(renderer) {
        if (this.filterArea || !this.filters?.some((filter)=>filter.enabled)) {
            super.renderAdvanced(renderer);
            return;
        }
        // The bounds the filter would measure anyway, measured once and reused as its area.
        const bounds = this.bounds.copyFrom(this.getBounds(true));
        const view = $9242e6e157236a04$var$viewArea(renderer, this.view);
        const focus = this.filters.find((filter)=>filter.enabled && filter instanceof (0, $65ff58edc75cc05c$export$a64017bf69403efb));
        if (focus) {
            const origin = {
                x: this.worldTransform.tx,
                y: this.worldTransform.ty
            };
            const cell = (0, $65ff58edc75cc05c$export$b5c8fc152fa0c719) / focus.resolution;
            const needs = $9242e6e157236a04$export$35ff2aac0f7c1347(origin, bounds, view, focus.margin, cell, this.area);
            if (!needs) return;
            const mask = this.mask?.texture?.baseTexture;
            const key = `${focus.sigma}|${focus.resolution}|${this.worldAlpha}|${mask?.uid ?? "-"}|${focus.contentVersion}`;
            const now = performance.now(), snapshot = focus.snapshot;
            const placed = snapshot && {
                x: snapshot.frame.x - snapshot.origin.x + origin.x,
                y: snapshot.frame.y - snapshot.origin.y + origin.y,
                width: snapshot.frame.width,
                height: snapshot.frame.height,
                key: snapshot.key,
                madeAt: snapshot.madeAt
            };
            const state = $9242e6e157236a04$export$3b8d9af3c4af9938(placed, needs, key, now, focus.contentChangedAt);
            if (state === "fresh" || state === "stale" && now - $9242e6e157236a04$var$lastStaleRefresh < $9242e6e157236a04$var$FOCUS_REFRESH_GAP_MS) {
                renderer.batch.flush();
                focus.drawSnapshot(renderer, placed.x, placed.y);
                this.renderExempt(renderer, "focusBlurExempt");
                return;
            }
            if (state === "stale") $9242e6e157236a04$var$lastStaleRefresh = now;
            // Redrawn past the view by some slack, so the camera can move on the snapshot before it must redraw.
            const room = (size)=>Math.min(size * $9242e6e157236a04$var$FOCUS_SLACK, Math.max(0, ($9242e6e157236a04$var$FOCUS_MAX_TEXELS / focus.resolution - size) / 2 - 2 * cell));
            const wide = this.wide.copyFrom(view).pad(room(view.width), room(view.height));
            const area = $9242e6e157236a04$export$35ff2aac0f7c1347(origin, bounds, wide, focus.margin, cell, this.area);
            focus.keep = {
                key: key,
                at: now,
                origin: origin
            };
            this.filterArea = area;
            // pixi would round the anchored area back onto the screen's pixels.
            const system = renderer.filter;
            const round = system.roundFrame;
            system.roundFrame = ()=>undefined;
            try {
                super.renderAdvanced(renderer);
            } finally{
                system.roundFrame = round;
                this.filterArea = null;
            }
            return;
        }
        if (bounds.right <= view.x || bounds.x >= view.right || bounds.bottom <= view.y || bounds.y >= view.bottom) return;
        this.filterArea = bounds;
        try {
            super.renderAdvanced(renderer);
        } finally{
            this.filterArea = null;
        }
    }
    constructor(...args){
        super(...args), this.view = new (0, $6qzqq.Rectangle)(), this.wide = new (0, $6qzqq.Rectangle)(), this.bounds = new (0, $6qzqq.Rectangle)(), this.area = new (0, $6qzqq.Rectangle)();
    }
}
class $9242e6e157236a04$export$2a88e024fe7c8b5e extends $9242e6e157236a04$export$f08e4f53904fcf75 {
    renderAdvanced(renderer) {
        const previousArea = this.filterArea;
        if (!previousArea && this.filters?.some((filter)=>filter.enabled)) this.filterArea = $9242e6e157236a04$var$viewArea(renderer, this.area);
        try {
            super.renderAdvanced(renderer);
        } finally{
            // Do not constrain bounds queries outside this draw (occlusion and hit testing).
            this.filterArea = previousArea;
        }
    }
    constructor(...args){
        super(...args), this.area = new (0, $6qzqq.Rectangle)();
    }
}




/**
 * WHICH PART OF A STOREY TO CUT AWAY over a player standing under it. Every building of a room shares
 * one stack of storey rooms, so a storey can hold several separate structures: a castle's four tower
 * tops, two neighbours' upper floors. Going inside one used to hide the whole storey -- every other
 * tower top, the house next door. Now only the structures standing over the covered area the player is
 * in are cut away; one that reaches nowhere near it stays drawn. A storey that is all one structure
 * (any ordinary house) is still cut away whole, exactly as before.
 */ const $aa06bd5ff41c23e7$var$key = (x, y)=>`${x},${y}`;
const $aa06bd5ff41c23e7$var$component = (cells, start)=>{
    const seen = new Set();
    const queue = [
        start
    ];
    for(let i = 0; i < queue.length; i++){
        const { x: x, y: y } = queue[i];
        const id = $aa06bd5ff41c23e7$var$key(x, y);
        if (seen.has(id) || !cells.has(id)) continue;
        seen.add(id);
        queue.push({
            x: x + 1,
            y: y
        }, {
            x: x - 1,
            y: y
        }, {
            x: x,
            y: y + 1
        }, {
            x: x,
            y: y - 1
        });
    }
    return seen;
};
const $aa06bd5ff41c23e7$var$coverCache = new WeakMap();
const $aa06bd5ff41c23e7$export$6d3cf4b9c249b755 = (house, at)=>{
    const interior = house.interiorCells;
    if (!interior?.length) return undefined;
    let cached = $aa06bd5ff41c23e7$var$coverCache.get(interior);
    if (!cached) $aa06bd5ff41c23e7$var$coverCache.set(interior, cached = {
        cells: new Set(interior.map((cell)=>$aa06bd5ff41c23e7$var$key(cell.x, cell.y))),
        parts: new Map()
    });
    const feet = {
        x: Math.floor(at.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
        y: Math.floor((at.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763)) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))
    };
    const id = $aa06bd5ff41c23e7$var$key(feet.x, feet.y);
    if (!cached.cells.has(id)) return undefined;
    for (const part of cached.parts.values())if (part.has(id)) return part;
    const part = $aa06bd5ff41c23e7$var$component(cached.cells, feet);
    cached.parts.set(id, part);
    return part;
};
const $aa06bd5ff41c23e7$export$9522235727539d8f = (footprint, cover)=>{
    const cells = new Set(footprint.map((cell)=>$aa06bd5ff41c23e7$var$key(cell.x, cell.y)));
    const seen = new Set();
    const cut = new Set();
    let whole = true;
    for (const cell of footprint){
        if (seen.has($aa06bd5ff41c23e7$var$key(cell.x, cell.y))) continue;
        const piece = $aa06bd5ff41c23e7$var$component(cells, cell);
        piece.forEach((id)=>seen.add(id));
        if ([
            ...piece
        ].some((id)=>cover.has(id))) piece.forEach((id)=>cut.add(id));
        else whole = false;
    }
    return {
        cut: cut,
        whole: whole
    };
};
const $aa06bd5ff41c23e7$export$d109d2cb68a119cd = 2;
const $aa06bd5ff41c23e7$export$d15d1dc2c8ba436b = (cut, alpha, left, top, right, bottom)=>{
    const runs = [];
    for(let y = top; y < bottom; y++){
        let start = left, current;
        for(let x = left; x <= right; x++){
            let value;
            if (x < right) {
                value = 1;
                for(let reach = 0; reach <= $aa06bd5ff41c23e7$export$d109d2cb68a119cd; reach++)if (cut.has($aa06bd5ff41c23e7$var$key(x, y + reach))) {
                    value = alpha;
                    break;
                }
            }
            if (value !== current) {
                if (current !== undefined) runs.push({
                    x0: start,
                    x1: x,
                    y: y,
                    alpha: current
                });
                start = x;
                current = value;
            }
        }
    }
    return runs;
};




parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");

class $1c935e758fdc5c1b$export$c91a30cd3333b2fb {
    clear() {
        this.groups.clear();
    }
    add(container, bounds) {
        let group = this.groups.get(container);
        if (!group) {
            group = {
                container: container,
                cells: new Map(),
                left: Infinity,
                top: Infinity,
                right: -Infinity,
                bottom: -Infinity
            };
            this.groups.set(container, group);
        }
        group.left = Math.min(group.left, bounds.x);
        group.top = Math.min(group.top, bounds.y);
        group.right = Math.max(group.right, bounds.right);
        group.bottom = Math.max(group.bottom, bounds.bottom);
        for(let x = Math.floor(bounds.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)); x < Math.ceil(bounds.right / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)); x++)for(let y = Math.floor(bounds.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)); y < Math.ceil(bounds.bottom / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)); y++){
            const key = `${x},${y}`;
            let tiles = group.cells.get(key);
            if (!tiles) group.cells.set(key, tiles = []);
            tiles.push(bounds);
        }
    }
    overlaps(bounds) {
        return this.find(bounds, ()=>true);
    }
    /** Pushes each drawn tile over `bounds` onto `out` as a screen-space [left, top, right, bottom] run. */ collect(bounds, out) {
        this.find(bounds, (tile, container)=>{
            const matrix = container.worldTransform;
            const left = matrix.a * tile.x + matrix.c * tile.y + matrix.tx;
            const top = matrix.b * tile.x + matrix.d * tile.y + matrix.ty;
            const right = matrix.a * tile.right + matrix.c * tile.bottom + matrix.tx;
            const bottom = matrix.b * tile.right + matrix.d * tile.bottom + matrix.ty;
            out.push(Math.min(left, right), Math.min(top, bottom), Math.max(left, right), Math.max(top, bottom));
            return false;
        });
    }
    /** Visits the drawn tiles over `bounds` (in their container's space) until `visit` returns true. */ find(bounds, visit) {
        this.topLeft.set(bounds.x, bounds.y);
        this.bottomRight.set(bounds.right, bounds.bottom);
        for (const group of this.groups.values()){
            const { container: container, cells: cells } = group;
            if (!container.worldVisible) continue;
            container.toLocal(this.topLeft, undefined, this.localTopLeft);
            container.toLocal(this.bottomRight, undefined, this.localBottomRight);
            if (container.worldAlpha <= 0.15) continue;
            const left = Math.min(this.localTopLeft.x, this.localBottomRight.x);
            const top = Math.min(this.localTopLeft.y, this.localBottomRight.y);
            const right = Math.max(this.localTopLeft.x, this.localBottomRight.x);
            const bottom = Math.max(this.localTopLeft.y, this.localBottomRight.y);
            if (left >= group.right || right <= group.left || top >= group.bottom || bottom <= group.top) continue;
            for(let x = Math.floor(left / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)); x < Math.ceil(right / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)); x++)for(let y = Math.floor(top / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)); y < Math.ceil(bottom / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)); y++){
                const tiles = cells.get(`${x},${y}`);
                if (!tiles) continue;
                for (const tile of tiles){
                    if (tile.x < right && tile.right > left && tile.y < bottom && tile.bottom > top && visit(tile, container)) return true;
                }
            }
        }
        return false;
    }
    constructor(){
        this.groups = new Map();
        this.topLeft = new (0, $6qzqq.Point)();
        this.bottomRight = new (0, $6qzqq.Point)();
        this.localTopLeft = new (0, $6qzqq.Point)();
        this.localBottomRight = new (0, $6qzqq.Point)();
    }
}
class $1c935e758fdc5c1b$export$871d1b476f60b319 {
    reset(bounds) {
        this.bounds.copyFrom(bounds);
        this.parents.forEach((box)=>this.spare.push(box));
        this.parents.clear();
        this.lastParent = this.lastBox = undefined;
        return this;
    }
    /** False only when the sprite's quad lies wholly outside the bounds; anything it cannot tell, true. */ mayOverlap(sprite) {
        const parent = sprite.parent, texture = sprite.texture;
        if (!parent || !texture || sprite.rotation || sprite.skew.x || sprite.skew.y || sprite.children.length) return true;
        const box = parent === this.lastParent ? this.lastBox : this.boxIn(parent);
        const { width: width, height: height } = texture.orig;
        const x0 = sprite.position.x + sprite.scale.x * (-sprite.anchor.x * width - sprite.pivot.x);
        const x1 = x0 + sprite.scale.x * width;
        const y0 = sprite.position.y + sprite.scale.y * (-sprite.anchor.y * height - sprite.pivot.y);
        const y1 = y0 + sprite.scale.y * height;
        // Written as a miss, so a degenerate parent (NaN) never rejects anything.
        return !(Math.max(x0, x1) <= box.x || Math.min(x0, x1) >= box.right || Math.max(y0, y1) <= box.y || Math.min(y0, y1) >= box.bottom);
    }
    boxIn(parent) {
        let box = this.parents.get(parent);
        if (!box) {
            box = this.spare.pop() ?? new (0, $6qzqq.Rectangle)();
            const { x: x, y: y, right: right, bottom: bottom } = this.bounds;
            let left = Infinity, top = Infinity, far = -Infinity, low = -Infinity;
            for(let i = 0; i < 4; i++){
                this.corner.set(i & 1 ? right : x, i & 2 ? bottom : y);
                // The first corner brings the parent's transform up to date; the rest reuse it.
                parent.toLocal(this.corner, undefined, this.local, i > 0);
                left = Math.min(left, this.local.x);
                far = Math.max(far, this.local.x);
                top = Math.min(top, this.local.y);
                low = Math.max(low, this.local.y);
            }
            box.x = left;
            box.y = top;
            box.width = far - left;
            box.height = low - top;
            this.parents.set(parent, box);
        }
        this.lastParent = parent;
        this.lastBox = box;
        return box;
    }
    constructor(){
        this.bounds = new (0, $6qzqq.Rectangle)();
        this.parents = new Map();
        this.spare = [];
        this.corner = new (0, $6qzqq.Point)();
        this.local = new (0, $6qzqq.Point)();
    }
}
const $1c935e758fdc5c1b$var$xs = [];
const $1c935e758fdc5c1b$var$ys = [];
const $1c935e758fdc5c1b$export$1bfece1b8dc499c4 = (bounds, rects, slack = 1)=>{
    if (bounds.width <= 0 || bounds.height <= 0) return false;
    // Every run edge inside the bounds splits them into cells each wholly in or out of every run.
    $1c935e758fdc5c1b$var$xs.length = $1c935e758fdc5c1b$var$ys.length = 0;
    $1c935e758fdc5c1b$var$xs.push(bounds.x, bounds.right);
    $1c935e758fdc5c1b$var$ys.push(bounds.y, bounds.bottom);
    for(let i = 0; i < rects.length; i += 4){
        if (rects[i] > bounds.x && rects[i] < bounds.right) $1c935e758fdc5c1b$var$xs.push(rects[i]);
        if (rects[i + 2] > bounds.x && rects[i + 2] < bounds.right) $1c935e758fdc5c1b$var$xs.push(rects[i + 2]);
        if (rects[i + 1] > bounds.y && rects[i + 1] < bounds.bottom) $1c935e758fdc5c1b$var$ys.push(rects[i + 1]);
        if (rects[i + 3] > bounds.y && rects[i + 3] < bounds.bottom) $1c935e758fdc5c1b$var$ys.push(rects[i + 3]);
    }
    $1c935e758fdc5c1b$var$xs.sort((a, b)=>a - b);
    $1c935e758fdc5c1b$var$ys.sort((a, b)=>a - b);
    for(let i = 0; i + 1 < $1c935e758fdc5c1b$var$xs.length; i++){
        const width = $1c935e758fdc5c1b$var$xs[i + 1] - $1c935e758fdc5c1b$var$xs[i];
        if (width <= 0) continue;
        const x = $1c935e758fdc5c1b$var$xs[i] + width / 2;
        for(let j = 0; j + 1 < $1c935e758fdc5c1b$var$ys.length; j++){
            const height = $1c935e758fdc5c1b$var$ys[j + 1] - $1c935e758fdc5c1b$var$ys[j];
            if (height <= 0) continue;
            const y = $1c935e758fdc5c1b$var$ys[j] + height / 2;
            let covered = false;
            for(let k = 0; k < rects.length && !covered; k += 4)covered = rects[k] <= x && rects[k + 2] >= x && rects[k + 1] <= y && rects[k + 3] >= y;
            if (!covered && width >= slack && height >= slack) return false;
        }
    }
    return true;
};



const $55d4eaeb8e7150fb$export$13023d0a5a758c59 = 4;
/** How far above the storey it stands on a storey is raised when its own edge would sort it lower. */ const $55d4eaeb8e7150fb$var$STOREY_STACK_STEP = 0.001;
const $55d4eaeb8e7150fb$export$1bff3964dc9ff07d = {
    indoors: 0.88,
    outdoors: 0.82,
    cool: [
        0.94,
        0.97,
        1
    ],
    above: 1,
    floor: 0.5
};
const $55d4eaeb8e7150fb$export$5d9655834e6a5690 = {
    perStorey: 0.64,
    max: 3.2
};
const $55d4eaeb8e7150fb$var$storeyFocusConfig = ()=>{
    if (typeof window === "undefined") return $55d4eaeb8e7150fb$export$5d9655834e6a5690;
    const w = window;
    if (w.storeyFocus === undefined) w.storeyFocus = $55d4eaeb8e7150fb$export$5d9655834e6a5690;
    return w.storeyFocus && typeof w.storeyFocus === "object" ? {
        ...$55d4eaeb8e7150fb$export$5d9655834e6a5690,
        ...w.storeyFocus
    } : undefined;
};
const $55d4eaeb8e7150fb$export$e3bdeac3d9e111c = (above, config = $55d4eaeb8e7150fb$var$storeyFocusConfig())=>{
    if (!config || above <= 0) return undefined;
    const sigma = Math.min(config.max, above * config.perStorey);
    return sigma > 0 ? sigma : undefined;
};
const $55d4eaeb8e7150fb$var$storeyToneConfig = ()=>{
    if (typeof window === "undefined") return $55d4eaeb8e7150fb$export$1bff3964dc9ff07d;
    const w = window;
    if (w.storeyTone === undefined) w.storeyTone = $55d4eaeb8e7150fb$export$1bff3964dc9ff07d;
    return w.storeyTone && typeof w.storeyTone === "object" ? {
        ...$55d4eaeb8e7150fb$export$1bff3964dc9ff07d,
        ...w.storeyTone
    } : $55d4eaeb8e7150fb$export$1bff3964dc9ff07d;
};
const $55d4eaeb8e7150fb$export$4bedbbb6f105b9ee = (below, enclosed, config = $55d4eaeb8e7150fb$var$storeyToneConfig())=>{
    const storey = $55d4eaeb8e7150fb$export$6869b5e62b63cc64(below, enclosed, config);
    if (!storey) return undefined;
    const roof = $55d4eaeb8e7150fb$export$6869b5e62b63cc64(below - 1, enclosed, config) ?? [
        1,
        1,
        1
    ];
    const gain = Math.min(roof[0] / storey[0], roof[1] / storey[1], roof[2] / storey[2]);
    return [
        gain,
        gain,
        gain
    ];
};
const $55d4eaeb8e7150fb$export$6869b5e62b63cc64 = (below, enclosed, config = $55d4eaeb8e7150fb$var$storeyToneConfig())=>{
    if (below < 0) return config.above === 1 ? undefined : [
        config.above,
        config.above,
        config.above
    ];
    if (below === 0) return undefined;
    const shade = Math.max(config.floor, Math.pow(enclosed ? config.indoors : config.outdoors, below));
    return enclosed ? [
        shade,
        shade,
        shade
    ] : [
        shade * config.cool[0],
        shade * config.cool[1],
        shade * config.cool[2]
    ];
};
class $55d4eaeb8e7150fb$export$cdeb03331aa0daa {
    constructor(surface, createMap, createEntity, observation = false, retainEntity, getRole = ()=>null, features = observation ? (0, $1704411fa88dc9bf$export$5f95b9c185ae9263) : (0, $1704411fa88dc9bf$export$784ce4bd6fedbedf)){
        this.surface = surface;
        this.createMap = createMap;
        this.createEntity = createEntity;
        this.observation = observation;
        this.retainEntity = retainEntity;
        this.getRole = getRole;
        this.features = features;
        this.visuals = new (0, $e016b4679cd99b2f$export$c04a1bedc59d4447)();
        this.spawnEffects = new Map();
        this.completedSpawns = new Set();
        this.contentSignature = "";
        this.contentChangedAt = 0;
        this.regionFade = new (0, $f938f025cf72352a$export$6377df4ac9e9e40f)();
        this.cutRegionVersion = 0;
        this.footprintCells = [];
        this.adopted = false;
        this.visibilityFade = new (0, $f938f025cf72352a$export$6377df4ac9e9e40f)();
        this.entities = new Map();
    }
    clear() {
        this.spawnEffects.forEach((effect)=>effect.destroy());
        this.spawnEffects.clear();
        this.completedSpawns.clear();
        this.entities.forEach(({ entity: entity, sprite: sprite, overlay: overlay })=>{
            if (!this.retainEntity?.(entity, sprite)) {
                sprite.cleanup?.();
                sprite.destroy({
                    children: true
                });
            }
            this.overlays?.remove(entity);
            overlay.destroy({
                children: true
            });
        });
        this.entities.clear();
        this.dropCutMask();
        this.map?.destroy();
        this.root?.parent?.removeChild(this.root);
        this.root?.destroy({
            children: true
        });
        this.groundBlur?.destroy();
        this.groundBlur = undefined;
        this.focusBlur?.destroy();
        this.focusBlur = undefined;
        this.groundShade?.destroy();
        this.groundShade = undefined;
        this.groundTone = undefined;
        this.cutRegion = undefined;
        this.regionFade.reset();
        this.footprintSource = undefined;
        this.footprintCells = [];
        if (this.roomId && !this.observation) (0, $21141db879ebc35b$export$1479527415e8ddc1)(this.roomId);
        this.map = undefined;
        this.root = undefined;
        this.overlays = undefined;
        this.provider = undefined;
        this.roomId = undefined;
        this.clockOffset = undefined;
        this.visibilityFade.reset();
    }
    update(frames, active) {
        const frame = frames[0];
        if (!active && !this.observation || !frame) {
            this.clear();
            return;
        }
        if (this.roomId !== frame.roomId) this.clear();
        if (!this.root) {
            if (!frame.tilemaps || !frame.tilemapMeta) return;
            this.roomId = frame.roomId;
            const sky = this.createRoot(frame.tilemaps?.twoStoreyHouse?.floor === 0);
            this.map = this.createMap(this.root, sky);
        }
        const adopted = this.adopted;
        this.adopted = false;
        if (frame.tilemaps && frame.tilemapMeta && !adopted) {
            // Full snapshots also arrive after roof/floor deletions. Keep the container,
            // fade and entity playback buffers when refreshing the same passive room.
            this.provider = new (0, $93a024e1e74df758$export$c8df09a865c1d736)(frame.roomId, frame.tilemapMeta, frame.tilemaps, undefined);
            this.map.setProjectionFloor?.(this.observation ? this.provider.twoStoreyHouse?.floor : active.floor);
            this.map.update(this.provider);
            if (this.root.visible || !this.map.flushMapDeltas) this.map.renderTileMap();
        }
        if (!this.root || !this.provider) return;
        if (this.observation) active = this.provider.getHousePresentation();
        if (!active) return;
        const now = Date.now();
        const timestamp = frame.serverTs ?? now - (this.clockOffset ?? 0);
        const offset = now - timestamp;
        this.clockOffset = Math.min(this.clockOffset ?? offset, offset);
        this.root.y = this.observation ? 0 : (0, $2751e0027a1b432f$export$9f4b491aa2a94a16)(active, this.provider.twoStoreyHouse);
        const floor = this.provider.twoStoreyHouse.floor;
        this.root.zIndex = this.floorZIndex(active);
        const blur = this.heightBlur(floor, active.floor);
        this.setBackgroundFilters(blur, this.groundShade && this.root.filters?.includes(this.groundShade) ? this.groundShade : undefined);
        if (frame.mapDeltas?.length) {
            this.map.queueMapDelta(frame.mapDeltas);
            this.map.rerender();
            if (this.root.visible || !this.map.flushMapDeltas) this.map.renderTileMap();
            else this.map.flushMapDeltas();
        }
        const present = new Set();
        for (const message of frame.messages){
            if (!message.position || message.entityType === "system") continue;
            if (message.entityType === "bullet" && message.entityState === "dead") continue;
            present.add(message.entityId);
            let item = this.entities.get(message.entityId);
            if (!item) {
                const entity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
                Object.assign(entity, message);
                entity.location = Object.assign({
                    x: message.position[0],
                    y: message.position[1]
                }, {
                    roomId: frame.roomId
                });
                const sprite = this.createEntity(entity, this.provider);
                (0, $aa4dbab34fec03c9$export$1b5e6173667b4c9b)(entity, sprite, this.provider);
                const overlay = this.overlays.offer(entity);
                sprite.setWorldOverlayItem(overlay);
                sprite.interactive = false;
                sprite.interactiveChildren = false;
                this.root.addChild(sprite);
                item = {
                    entity: entity,
                    sprite: sprite,
                    overlay: overlay,
                    samples: [],
                    bulletTs: entity.entityType === "bullet" ? now : undefined
                };
                this.entities.set(message.entityId, item);
            }
            const { entity: entity, sprite: sprite } = item;
            // Stair playback uses current phase coordinates, so old delayed samples
            // must not pull the actor back toward the opening when the walk finishes.
            if (message.stairTravel || entity.stairTravel) {
                item.samples.length = 0;
                item.renderPosition = undefined;
            }
            Object.assign(entity, message);
            entity.floorFall = message.floorFall;
            entity.stairTravel = message.stairTravel;
            if (entity.entityType !== "bullet") {
                // Keep authoritative positions off the drawn entity between snapshots.
                const previous = item.samples[item.samples.length - 1];
                const sample = {
                    ts: timestamp,
                    x: message.position[0],
                    y: message.position[1],
                    direction: message.direction,
                    angle: message.angle
                };
                // Idle companion snapshots are suppressed between heartbeats. When
                // movement resumes, the prior position was still current at the last
                // 100ms server check; do not interpolate over the whole quiet period.
                if (!this.observation && previous && timestamp - previous.ts > 250) {
                    item.samples.splice(0, item.samples.length - 1);
                    previous.ts = timestamp - 100;
                }
                if (previous && Math.hypot(sample.x - previous.x, sample.y - previous.y) > 4 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) {
                    item.samples.length = 0;
                    item.renderPosition = undefined;
                    entity.location = {
                        x: sample.x,
                        y: sample.y
                    };
                }
                if (item.samples.length && item.samples[item.samples.length - 1].ts >= timestamp) item.samples.pop();
                item.samples.push(sample);
                if (item.samples.length > 32) item.samples.shift();
            }
            entity.movement.direction = message.direction;
            entity.movement.angle = message.angle;
            entity.roomId = frame.roomId;
            entity.maxHp = message.hpMax;
            item.visualDirty = true;
            if (this.root.visible) {
                this.visuals.update(sprite, entity, this.features);
                item.visualDirty = false;
            }
            sprite.visible = message.visible !== false && !item.bulletStopped;
            const subject = sprite;
            if (entity.npcType === "collectable" && subject.glintArt) this.overlays.offerDroppedItemGlint(entity.entityId, subject);
            if (this.root.visible) this.overlays.updateEntity(entity);
        }
        this.entities.forEach((item, id)=>{
            if (present.has(id)) return;
            this.spawnEffects.get(id)?.destroy();
            this.spawnEffects.delete(id);
            this.completedSpawns.delete(id);
            item.sprite.parent?.removeChild(item.sprite);
            item.sprite.cleanup?.();
            item.sprite.destroy({
                children: true
            });
            this.overlays.remove(item.entity);
            item.overlay.destroy({
                children: true
            });
            this.entities.delete(id);
        });
    }
    /** The floor's root, with its sky layer above everything in it, added to the scene. Returns the sky. */ createRoot(ground) {
        // The ground room contains the whole forest. Small upper rooms keep their
        // artwork bounds so their filters do not allocate a full viewport texture.
        this.root = ground ? new (0, $9242e6e157236a04$export$2a88e024fe7c8b5e)() : new (0, $9242e6e157236a04$export$bd5c976caf9abcbb)();
        this.root.sortableChildren = true;
        this.root.interactiveChildren = false;
        const sky = new (0, $8t5Gy.Container)();
        sky.zIndex = 1000000;
        this.root.addChild(sky);
        this.overlays = new (0, $b11c64d757fefaba$export$198fa1625abb29ee)(undefined, this.root, this.features);
        this.overlays.scale.set(1 / (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom);
        this.overlays.zIndex = 2000000;
        // Nameplates and health bars stay legible on a storey seen through either height blur.
        Object.assign(this.overlays, {
            heightBlurExempt: true,
            focusBlurExempt: true
        });
        this.root.addChild(this.overlays);
        this.surface.addChild(this.root);
        return sky;
    }
    /** Draw this floor with a map that already shows it (see SceneRoomRenderer.exchange). */ adopt(provider, map) {
        this.roomId = provider.roomId;
        this.provider = provider;
        this.map = map;
        this.adopted = true;
    }
    /** Give up the map, without destroying what it drew, ahead of clear(). */ releaseMap() {
        const map = this.map;
        this.map = undefined;
        return map;
    }
    backgroundBlur(floor, activeFloor) {
        const distance = activeFloor - floor;
        // Only the overworld softens; intermediate storeys stay sharp. Each blurred floor is a
        // full-view filter pass, so blurring every storey made each climb cost frames.
        if (this.observation || floor !== 0 || distance < 3) return undefined;
        // Floors 1 and 2 stay sharp; floor 3 and above soften with a readability cap.
        // Distant artwork is already softened. Half-resolution filter targets
        // process a quarter of the pixels without reducing nearby-floor detail.
        // Pixi's blur strength uses logical coordinates, so its radius is unchanged.
        this.groundBlur ||= new (0, $1avo5.filters).BlurFilter(0.375, 2, 0.5);
        this.groundBlur.blur = Math.min(1.125, 0.375 + (distance - 1) * 0.25);
        return this.groundBlur;
    }
    /** The floor's height blur: the overworld far below, or a storey above the player out of focus. */ heightBlur(floor, activeFloor) {
        return this.backgroundBlur(floor, activeFloor) ?? this.foregroundBlur(floor, activeFloor);
    }
    foregroundBlur(floor, activeFloor) {
        const sigma = this.observation ? undefined : $55d4eaeb8e7150fb$export$e3bdeac3d9e111c(floor - activeFloor);
        if (!sigma) return undefined;
        this.focusBlur ||= new (0, $65ff58edc75cc05c$export$a64017bf69403efb)();
        this.focusBlur.focus(sigma, (0, $065c5647ab3ff4dc$export$90e89a86e46f5ae3)()?.renderer.resolution ?? 1);
        this.focusBlur.contentVersion = String(this.map?.getArtworkVersion?.() ?? 0);
        this.focusBlur.contentChangedAt = this.contentChangedAt;
        return this.focusBlur;
    }
    setBackgroundFilters(blur, shade) {
        const current = this.root.filters;
        const count = Number(!!blur) + Number(!!shade);
        if ((current?.length ?? 0) === count && (!blur || current[0] === blur) && (!shade || current[count - 1] === shade)) return;
        this.root.filters = blur ? shade ? [
            blur,
            shade
        ] : [
            blur
        ] : shade ? [
            shade
        ] : null;
    }
    floorZIndex(active) {
        const house = this.provider.getHousePresentation();
        const floor = house.floor;
        if (floor < active.floor) return -1000 + floor;
        // A recessed or edited storey must sort at its own live southern edge.
        // Borrowing the active floor's extent puts northern upper tiles over
        // trees whose trunks stand in front of that storey.
        return (0, $097c8f680b47a2c7$export$293bb924496daa6)(house.top + house.depth - 1, floor);
    }
    /** Whether anything on this storey moved or changed its look since last frame (see contentChangedAt). */ noteContentChange(now) {
        let signature = "";
        this.entities.forEach(({ entity: entity, sprite: sprite })=>{
            signature += `${entity.entityId}:${sprite.visible ? 1 : 0}:${Math.round(entity.location.x * 2)},${Math.round(entity.location.y * 2)}:` + `${entity.movement.direction}:${entity.entityState}:${entity.hp};`;
        });
        if (signature === this.contentSignature) return;
        this.contentSignature = signature;
        this.contentChangedAt = now;
    }
    getEntity(id) {
        return this.entities.get(id)?.entity;
    }
    getRenderable(id) {
        return this.entities.get(id)?.sprite;
    }
    /** Part of this storey is cut away over the player: it no longer covers them there. */ get cutting() {
        return !!this.cutRegion && this.regionFade.alpha < 0.5;
    }
    structuresOver(footprint, cover) {
        const memo = this.structuresOverMemo;
        if (memo?.footprint === footprint && memo.cover === cover) return memo.over;
        const over = (0, $aa06bd5ff41c23e7$export$9522235727539d8f)(footprint, cover);
        this.structuresOverMemo = {
            footprint: footprint,
            cover: cover,
            over: over
        };
        return over;
    }
    footprint() {
        const house = this.provider?.getHousePresentation();
        if (house !== this.footprintSource) {
            this.footprintSource = house;
            this.footprintCells = house ? [
                ...house.floorCells,
                ...house.wallCells,
                ...house.roofCells
            ] : [];
        }
        return this.footprintCells;
    }
    sameRegion(cells) {
        const current = this.cutRegion;
        if (!current || current.size !== cells.size) return false;
        for (const cell of cells)if (!current.has(cell)) return false;
        return true;
    }
    /**
     * The cut region faded out through a soft mask over the storey: opaque everywhere, the region (and the
     * art it reaches up into) at the region's fade. Baked small and smoothed by scaling, re-baked only while
     * the fade moves; no mask at all once the region is back.
     */ updateCutMask() {
        const region = this.cutRegion, alpha = this.regionFade.alpha;
        const renderer = (0, $065c5647ab3ff4dc$export$90e89a86e46f5ae3)()?.renderer;
        if (!region || alpha >= 1 || !this.root?.visible || !this.provider || !renderer) {
            this.dropCutMask();
            return;
        }
        const level = Math.round(alpha * 24) / 24;
        const maskKey = `${this.cutRegionVersion}:${level}`;
        if (maskKey === this.cutMaskKey && this.root.mask === this.cutMask) return;
        this.cutMaskKey = maskKey;
        const margin = 4;
        const left = -margin, top = -margin, right = this.provider.width() + margin, bottom = this.provider.height() + margin;
        const shape = new (0, $gwPoJ.Graphics)();
        for (const run of (0, $aa06bd5ff41c23e7$export$d15d1dc2c8ba436b)(region, level, left, top, right, bottom)){
            if (run.alpha <= 0) continue;
            shape.beginFill(0xffffff, run.alpha).drawRect(run.x0 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), run.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (run.x1 - run.x0) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)).endFill();
        }
        const bounds = new (0, $6qzqq.Rectangle)(left * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), top * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (right - left) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (bottom - top) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
        const texture = renderer.generateTexture(shape, {
            region: bounds,
            resolution: 1 / 8
        });
        shape.destroy();
        if (!this.cutMask || this.cutMask.destroyed) {
            this.cutMask = new (0, $7Bs2Z.Sprite)();
            this.root.addChild(this.cutMask);
        }
        const previous = this.cutMask.texture;
        this.cutMask.texture = texture;
        this.cutMask.position.set(bounds.x, bounds.y);
        if (previous !== (0, $klOfb.Texture).EMPTY) previous.destroy(true);
        this.root.mask = this.cutMask;
    }
    dropCutMask() {
        const mask = this.cutMask;
        if (this.root && !this.root.destroyed && this.root.mask === mask) this.root.mask = null;
        this.cutMask = undefined;
        this.cutMaskKey = undefined;
        if (!mask) return;
        const texture = mask.texture;
        if (!mask.destroyed) {
            mask.parent?.removeChild(mask);
            mask.destroy();
        }
        if (texture && texture !== (0, $klOfb.Texture).EMPTY) texture.destroy(true);
    }
    getLights() {
        const lights = new (0, $cb689cfa16c444ba$export$ccc1bed6c7489102)();
        this.entities.forEach(({ entity: entity })=>{
            if ((entity.lightMeta || entity.npcType === "light") && entity.visible !== false && !entity.isDead()) lights.set(entity.entityId, {
                entityId: entity.entityId,
                location: entity.location,
                radius: entity.lightRadius(),
                intensity: entity.lightIntensity()
            });
        });
        return lights;
    }
    /** A crumble, shake or repair on this storey plays on its own map, so it shows where the storey is drawn. */ tileEffect(effect) {
        if (!this.map || !this.provider) return;
        if (effect.hp !== undefined && effect.hpMax !== undefined && (effect.effectType === "damage" || effect.effectType === "repair")) this.provider.setMapDeltaHealth(effect.mapRoughCoordinates, effect.hp, effect.hpMax, effect.layerId);
        this.map.tileEffect?.(effect);
    }
    projectileAim(point, active) {
        if (!this.root?.visible || this.root.alpha <= .15 || !this.provider || this.provider.twoStoreyHouse.floor === active.floor) return;
        const localY = point.y - this.root.y;
        // Only run on a trigger pull; passive scenes remain non-interactive.
        for (const { entity: entity, sprite: sprite } of this.entities.values()){
            if (!sprite.visible || entity.visible === false || entity.isDead() || entity.floorFall || entity.stairTravel || ![
                "player",
                "npc"
            ].includes(entity.entityType) || !entity.strikeable) continue;
            const bounds = entity.getBounds();
            // All LPC bodies share the same sole line, including small creatures whose
            // visible bodies sit below their simulation centre. Centre-based bounds miss
            // their feet and silently turn a downstairs shot into a same-floor shot.
            // Humanoids additionally need their full 25x50 body rather than 25x25 bounds.
            const humanoid = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isHumanoid(entity.appearance?.race);
            const body = entity.appearance?.race ? humanoid ? (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.dimensions(entity) : entity.dimensions : undefined;
            const scale = Number.isFinite(entity.spriteScale) && entity.spriteScale > 0 ? entity.spriteScale : 1;
            const x1 = body ? entity.location.x - body.w * scale / 2 : bounds.x1;
            const x2 = body ? entity.location.x + body.w * scale / 2 : bounds.x2;
            const y2 = body ? entity.location.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763) : bounds.y2;
            const y1 = body ? y2 - body.h * scale : bounds.y1;
            if (point.x >= x1 && point.x <= x2 && localY >= y1 && localY <= y2 && !this.provider.isUnderRoofAt(entity.location)) return {
                roomId: this.roomId,
                x: entity.location.x,
                y: entity.location.y
            };
        }
    }
    /** `cover`: the covered area the player stands in (storey_cutaway.ts coverAt), shared by every floor. */ /** `prepaint`: draw this storey even while hidden, if it never has been (the room-load curtain is down). */ render(active, player, cover, prepaint = false) {
        if (this.observation) active = this.provider?.getHousePresentation();
        if (!this.root || !active || !player?.location) return;
        if (this.observation) this.map?.setViewEntity?.(player);
        this.root.y = this.observation ? 0 : (0, $2751e0027a1b432f$export$9f4b491aa2a94a16)(active, this.provider.twoStoreyHouse);
        const floor = this.provider.twoStoreyHouse.floor;
        this.root.zIndex = this.floorZIndex(active);
        const enclosed = !(0, $9b85be211484fac5$export$4a8c8628e4e44ada)(player.floorFall) && (0, $2751e0027a1b432f$export$2c01c05cc2cc0271)(active, player.location);
        // The overworld is the backdrop around the tower, visible at any height; deeper storeys
        // still supply collision and floor support while hidden.
        const inView = floor === 0 || active.floor - floor <= $55d4eaeb8e7150fb$export$13023d0a5a758c59;
        // Over a player indoors, cut away only this storey's structures standing over them, unless that is all of it.
        const over = !this.observation && floor > active.floor && enclosed && cover ? this.structuresOver(this.footprint(), cover) : undefined;
        const regional = !!over && !over.whole;
        if (regional && over.cut.size) {
            if (!this.sameRegion(over.cut)) {
                this.cutRegion = over.cut;
                this.cutRegionVersion++;
            }
        }
        this.visibilityFade.update(this.observation || (floor < active.floor ? inView : !enclosed || regional));
        this.regionFade.update(!(regional && over.cut.size));
        if (this.regionFade.alpha >= 1 && !(regional && over.cut.size)) this.cutRegion = undefined;
        this.root.alpha = this.visibilityFade.alpha;
        this.root.visible = this.visibilityFade.visible;
        const visible = this.root.visible;
        this.updateCutMask();
        if (!this.observation) (0, $21141db879ebc35b$export$f9cdf82e798d4d86)(this.roomId, visible ? this.root.alpha : 0, this.cutRegion, this.regionFade.alpha);
        const blur = visible ? this.heightBlur(floor, active.floor) : undefined;
        const tone = !this.observation && visible ? $55d4eaeb8e7150fb$export$6869b5e62b63cc64(active.floor - floor, enclosed) : undefined;
        if (tone) {
            this.groundShade ||= new (0, $1avo5.filters).ColorMatrixFilter();
            // A plain per-channel scale: restored copies of this floor's art take it as a tint (roof_composite_overlap.ts).
            const key = tone.join(",");
            if (key !== this.groundTone) {
                const [r, g, b] = tone;
                this.groundShade.matrix = [
                    r,
                    0,
                    0,
                    0,
                    0,
                    0,
                    g,
                    0,
                    0,
                    0,
                    0,
                    0,
                    b,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ];
                this.groundTone = key;
            }
        }
        this.setBackgroundFilters(blur, tone ? this.groundShade : undefined);
        this.map?.setRoofTone?.(tone ? $55d4eaeb8e7150fb$export$4bedbbb6f105b9ee(active.floor - floor, enclosed) : undefined);
        this.map?.setProjectionFloor?.(active.floor);
        // Hidden maps still supply collision and floor support to visible neighbours.
        // Keep deltas applied, while leaving the requested paint pending until reveal -- except a storey never drawn
        // while the room-load curtain is down: drawn behind it, it costs nothing when it is first revealed (walking out
        // from under a roof drew the castle's upper storeys all in one frame, ~40ms).
        if (visible || !this.map?.flushMapDeltas || prepaint && this.map.hasPainted?.() === false) this.map?.renderTileMap();
        else this.map.flushMapDeltas();
        this.map?.updateTileEffects?.();
        // Match the active room's playback delay, covering the companion's 100ms snapshot gap.
        const timestamp = Date.now() - (this.clockOffset ?? 0) - 150;
        const now = Date.now();
        this.entities.forEach((item)=>{
            const { entity: entity, sprite: sprite, overlay: overlay, samples: samples } = item;
            if (entity.entityType === "bullet") {
                // Match active-floor bullets: integrate every frame from the first
                // received position, rather than waiting on delayed snapshots. Keep
                // a locally finished bullet hidden until its authoritative removal.
                const dt = Math.max(0, now - (item.bulletTs ?? now)) / 1000;
                item.bulletTs = now;
                if (!item.bulletStopped && (entity.speed2.x || entity.speed2.y)) item.bulletStopped = !(0, $691ebdd330b4ed0d$export$fd79ea94fab2dcf1)(entity, dt, this.provider);
                sprite.visible = entity.visible !== false && !item.bulletStopped;
            } else {
                while(samples.length >= 2 && samples[1].ts <= timestamp)samples.shift();
                const from = samples[0];
                if (!from) return;
                const to = samples[1];
                const progress = to && timestamp >= from.ts ? Math.min(1, (timestamp - from.ts) / (to.ts - from.ts)) : 0;
                // NPC brains move in discrete turns, so snapshots can repeat a position before
                // jumping ahead. Match active-floor smoothing to bridge those short pauses.
                const x = from.x + ((to?.x ?? from.x) - from.x) * progress;
                const y = from.y + ((to?.y ?? from.y) - from.y) * progress;
                if (visible) {
                    item.renderPosition = (0, $13b02b984dcf834a$export$137ebbe236578701)(item.renderPosition, x, y, now);
                    entity.location.x = item.renderPosition.x;
                    entity.location.y = item.renderPosition.y;
                } else {
                    entity.location.x = x;
                    entity.location.y = y;
                }
                const facing = progress > 0 ? to : from;
                entity.movement.direction = facing.direction;
                entity.movement.angle = facing.angle;
            }
            if (!visible) {
                // Resume from the current playback position instead of easing from a
                // stale hidden sprite. Projectiles and vertical travel keep stepping.
                item.renderPosition = undefined;
                if (entity.entityType !== "bullet" && !entity.stairTravel && !entity.floorFall) return;
            }
            if (visible && item.visualDirty) {
                this.visuals.update(sprite, entity, this.features, {
                    role: this.getRole(entity.entityId)
                });
                item.visualDirty = false;
            }
            // Roster updates can arrive without a new room snapshot.
            if (visible) this.visuals.updateRole(sprite, this.getRole(entity.entityId));
            // The local player's two halves share predicted input, not two network clocks.
            if (entity.stairTravel?.sourceEntityId === player.entityId && entity.stairTravel?.projection) {
                const view = (0, $968cce787b06be95$export$4f94aa92bb9eb34c)(player.stairTravel, this.roomId);
                if (!view || player.roomId === this.roomId) {
                    sprite.visible = overlay.visible = false;
                    return;
                }
                entity.stairTravel = {
                    ...view,
                    sourceEntityId: player.entityId
                };
                entity.location = {
                    ...player.location,
                    ...(0, $968cce787b06be95$export$d9d9364aee075d84)(view, 0).location
                };
                sprite.visible = entity.visible !== false;
            }
            (0, $a3da31b418d2b1ed$export$4725754a4127b437)(entity, sprite, this.roomId, visible, now, this.provider);
            (0, $ab66af423f686729$export$5aae9beeefa90c8c)(entity, sprite, this.root, this.spawnEffects, this.completedSpawns);
            this.overlays.updateEntity(entity);
            overlay.visible = sprite.visible && !entity.stairTravel?.projection;
        });
        (0, $ab66af423f686729$export$33fd9cf5c2957616)(this.spawnEffects, this.completedSpawns, (id)=>visible && this.entities.get(id)?.sprite.visible);
        if (visible) this.noteContentChange(now);
        if (visible) {
            this.overlays.animateDroppedItemGlints(now);
            this.overlays.animateBonecallerWarnings();
        }
    }
}
class $55d4eaeb8e7150fb$export$393557a3eeefd18a {
    // The first companion remains accessible for map previews and diagnostics.
    get root() {
        return this.floors.values().next().value?.root;
    }
    get map() {
        return this.floors.values().next().value?.map;
    }
    /**
     * The art of the storeys below the active one, in the active surface's pixels: their composites (trees),
     * which may stand in front of the storeys above them, and the walls and roofs of every storey but the
     * ground, which a lower storey's tree can stand in front of.
     */ backgroundCompositeArtwork(active) {
        const versions = [];
        for (const [id, floor] of this.floors){
            if (!active || !floor.root || floor.provider?.twoStoreyHouse?.floor >= active.floor) continue;
            versions.push(`${id}:${floor.map?.getArtworkVersion?.()}:${floor.root.x}:${floor.root.y}`);
        }
        const key = versions.join("|");
        if (key !== this.backgroundArtwork.key) {
            const composites = [], ceilings = [];
            for (const floor of this.floors.values()){
                const level = floor.provider?.twoStoreyHouse?.floor;
                if (!active || !floor.root || level >= active.floor) continue;
                const root = floor.root;
                floor.map?.getCompositeSprites?.().forEach((source)=>composites.push({
                        source: source,
                        projection: root,
                        level: level
                    }));
                if (level > 0) floor.map?.getCeilingArtwork?.().forEach(({ owner: owner, bounds: bounds, upright: upright })=>ceilings.push({
                        owner: owner,
                        level: level,
                        layer: root,
                        upright: upright,
                        bounds: bounds.map((rect)=>new (0, $6qzqq.Rectangle)(rect.x + root.x, rect.y + root.y, rect.width, rect.height))
                    }));
            }
            this.backgroundArtwork = {
                key: key,
                composites: composites,
                ceilings: ceilings
            };
        }
        return this.backgroundArtwork;
    }
    constructor(surface, createMap, createEntity, retainEntity, getRole = ()=>null){
        this.surface = surface;
        this.createMap = createMap;
        this.createEntity = createEntity;
        this.retainEntity = retainEntity;
        this.getRole = getRole;
        this.floors = new Map();
        this.backgroundArtwork = {
            key: "",
            composites: [],
            ceilings: []
        };
        this.coverRuns = [];
    }
    clear() {
        this.floors.forEach((floor)=>floor.clear());
        this.floors.clear();
        this.backgroundArtwork = {
            key: "",
            composites: [],
            ceilings: []
        };
    }
    floorProvider(roomId) {
        const floor = this.floors.get(roomId);
        return floor?.map && floor.provider?.roomId === roomId ? floor.provider : undefined;
    }
    /** The sprites drawing one tile of a floor on screen (see MapRenderingManager.getTileArt). */ tileArt(roomId, x, y, layerId) {
        const floor = this.floors.get(roomId);
        return floor?.root?.visible ? floor.map?.getTileArt?.(x, y, layerId) ?? [] : [];
    }
    floorMap(roomId) {
        const floor = this.floors.get(roomId);
        return floor?.provider?.roomId === roomId ? floor.map : undefined;
    }
    /**
     * The player changed level to `destinationId`, a floor drawn here, from `leaving`, drawn by the
     * active map. `swap` hands the destination's map the active role and gives the active map the new
     * root made here for the floor being left; nothing is repainted. The destination's bodies are kept
     * for the active entity manager, as activateRoom does.
     */ exchange(destinationId, leaving, active, swap) {
        const destination = this.floors.get(destinationId);
        if (!destination?.map || !leaving.roomId) return false;
        // A late snapshot can leave an entry for the active room; it never held this floor's drawing.
        this.floors.get(leaving.roomId)?.clear();
        this.floors.delete(leaving.roomId);
        const floor = new $55d4eaeb8e7150fb$export$cdeb03331aa0daa(this.surface, this.createMap, this.createEntity, false, this.retainEntity, this.getRole);
        const sky = floor.createRoot(leaving.twoStoreyHouse?.floor === 0);
        swap(floor.root, sky);
        floor.adopt(leaving, active);
        destination.releaseMap();
        destination.clear();
        this.floors.delete(destinationId);
        this.floors.set(leaving.roomId, floor);
        return true;
    }
    activateRoom(roomId) {
        // This floor will now be drawn by the active entity manager. Retire its
        // passive map while handing its loaded bodies to that manager.
        this.floors.get(roomId)?.clear();
        this.floors.delete(roomId);
    }
    getEntity(id) {
        for (const floor of this.floors.values()){
            const entity = floor.getEntity(id);
            if (entity) return entity;
        }
    }
    getRenderable(id) {
        for (const floor of this.floors.values()){
            const sprite = floor.getRenderable(id);
            if (sprite) return sprite;
        }
    }
    projectileAim(point, active) {
        if (!point || !active) return;
        // Prefer the highest drawn storey when bodies from different floors overlap.
        let aim, highest = -1;
        for (const floor of this.floors.values()){
            const candidate = floor.projectileAim(point, active);
            if (candidate && floor.provider.twoStoreyHouse.floor > highest) {
                aim = candidate;
                highest = floor.provider.twoStoreyHouse.floor;
            }
        }
        return aim;
    }
    /** Empty ground can receive a descending shot too; pick the highest visible walking surface. */ surfaceAim(point, active) {
        if (!point || !active || active.floor <= 0) return;
        const x = Math.floor(point.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), y = Math.floor(point.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
        if (active.floorCells.some((cell)=>cell.x === x && cell.y === y)) return;
        let selected, highest = -1;
        for (const floor of this.floors.values()){
            const provider = floor.provider, root = floor.root;
            const level = provider?.twoStoreyHouse?.floor;
            if (!root?.visible || root.alpha <= .15 || level === undefined || level >= active.floor || level <= highest) continue;
            const local = {
                x: point.x,
                y: point.y - root.y
            };
            const cell = {
                x: Math.floor(local.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
                y: Math.floor(local.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))
            };
            if (cell.x < 0 || cell.y < 0 || cell.x >= provider.width() || cell.y >= provider.height()) continue;
            const tile = provider.resolveTileMapFromLayerId("map2")?.[cell.x]?.[cell.y];
            if (level > 0 && (!tile || tile === "0" || provider.isFloorOpeningAt(cell.x, cell.y))) continue;
            if (provider.isUnderRoofAt({
                x: local.x,
                y: local.y - (0, $9667a1379a787b5e$export$5985b04c8e71b763)
            })) continue;
            selected = {
                roomId: provider.roomId,
                ...local,
                surface: true
            };
            highest = level;
        }
        return selected;
    }
    tileEffect(effect) {
        if (effect.roomId) this.floors.get(effect.roomId)?.tileEffect(effect);
    }
    /** The other storeys on screen now, each where it is drawn, so a press can pick their tiles. */ drawnStoreys(active) {
        const storeys = [];
        if (!active) return storeys;
        this.floors.forEach((floor, roomId)=>{
            const level = floor.provider?.twoStoreyHouse?.floor;
            if (!floor.root?.visible || floor.root.alpha <= .15 || level === undefined || level === active.floor) return;
            storeys.push({
                roomId: roomId,
                level: level,
                yOffset: floor.root.y,
                map: floor.provider,
                roofVisible: floor.map.isRoofVisibleForPlacement?.() ?? true
            });
        });
        return storeys;
    }
    getLights() {
        const lights = [];
        this.floors.forEach((floor)=>{
            if (!floor.root?.visible || floor.root.alpha <= 0) return;
            floor.getLights().iterate((light)=>lights.push({
                    ...light,
                    location: {
                        x: light.location.x,
                        y: light.location.y + floor.root.y
                    },
                    intensity: light.intensity * floor.root.alpha
                }));
        });
        return lights;
    }
    update(frames, active) {
        if (!active || !frames.length) {
            this.clear();
            return;
        }
        const allowed = active.floorRoomIds ?? [
            active.groundRoomId,
            active.upperRoomId
        ];
        this.floors.forEach((floor, id)=>{
            if (allowed.includes(id)) return;
            floor.clear();
            this.floors.delete(id);
        });
        for (const frame of frames){
            let floor = this.floors.get(frame.roomId);
            if (!floor) {
                floor = new $55d4eaeb8e7150fb$export$cdeb03331aa0daa(this.surface, this.createMap, this.createEntity, false, this.retainEntity, this.getRole);
                this.floors.set(frame.roomId, floor);
            }
            floor.update([
                frame
            ], active);
        }
        this.stackStoreys(active);
    }
    /**
     * A storey above the player draws over the storey it stands on. Each sorts at its own southern edge, so
     * trees in front of it can draw over it, but a storey can hold several structures: a castle's third
     * storey carries all four tower tops, so its edge is the castle's south wall, twenty rows south of the
     * north-east tower's, and it was drawn over the six storeys stacked on that tower, which then showed the
     * inside of its third storey. Raise any storey that would sort below the one under it to just above it.
     */ stackStoreys(active) {
        if (!active) return;
        const above = [
            ...this.floors.values()
        ].filter((floor)=>floor.root && floor.provider && floor.provider.twoStoreyHouse.floor > active.floor);
        above.sort((a, b)=>a.provider.twoStoreyHouse.floor - b.provider.twoStoreyHouse.floor);
        let below = -Infinity;
        for (const floor of above){
            if (floor.root.zIndex <= below) floor.root.zIndex = below + $55d4eaeb8e7150fb$var$STOREY_STACK_STEP;
            below = floor.root.zIndex;
        }
    }
    hasForegroundFloor(playerZ) {
        for (const floor of this.floors.values()){
            if (this.drawsOver(floor, playerZ)) return true;
        }
        return false;
    }
    /** Bounds are in screen space, like the drawn player frame. Lower floors cannot cover it. */ occludes(bounds, playerZ) {
        for (const floor of this.floors.values()){
            if (this.drawsOver(floor, playerZ) && floor.map?.overlapsRenderedMap?.(bounds)) return true;
        }
        return false;
    }
    /** Whether the storeys over the player, between them, leave none of `bounds` (screen space) showing. */ covers(bounds, playerZ) {
        const runs = this.coverRuns;
        runs.length = 0;
        // Floor tiles are indexed by cell and nearly always settle it under a storey; the walls and other
        // sprites are measured one by one, so only when the tiles leave part of the body showing.
        for (const floor of this.floors.values())if (this.drawsOver(floor, playerZ)) floor.map?.collectRenderedTiles?.(bounds, runs);
        if ((0, $1c935e758fdc5c1b$export$1bfece1b8dc499c4)(bounds, runs)) return true;
        for (const floor of this.floors.values())if (this.drawsOver(floor, playerZ)) floor.map?.collectRenderedSprites?.(bounds, runs);
        return (0, $1c935e758fdc5c1b$export$1bfece1b8dc499c4)(bounds, runs);
    }
    drawsOver(floor, playerZ) {
        return !!floor.root?.visible && floor.root.alpha > 0.15 && floor.root.zIndex > playerZ && !floor.cutting;
    }
    linkFloorSupport(active) {
        const providers = new Map([
            [
                active.roomId,
                active
            ]
        ]);
        this.floors.forEach((floor, id)=>{
            if (floor.provider) providers.set(id, floor.provider);
        });
        providers.forEach((provider)=>{
            const house = provider.twoStoreyHouse;
            if (!house) return;
            provider.setUpperFloorProvider(providers.get(house.floorRoomIds?.[house.floor + 1] ?? (house.floor === 0 ? house.upperRoomId : undefined)));
            if (house.floor <= 0) return;
            const below = house.floorRoomIds?.[house.floor - 1] ?? house.groundRoomId;
            provider.setFloorSupportProvider(providers.get(below));
        });
    }
    /** `prepaint`: also draw the storeys never drawn yet, though hidden (SceneFloorRenderer.render). */ render(active, player, prepaint = false) {
        const cover = active && player?.location && !(0, $9b85be211484fac5$export$4a8c8628e4e44ada)(player.floorFall) ? (0, $aa06bd5ff41c23e7$export$6d3cf4b9c249b755)(active, player.location) : undefined;
        this.floors.forEach((floor)=>floor.render(active, player, cover, prepaint));
        this.stackStoreys(active);
    }
    /** Whether a storey with its map in hand has never been drawn. */ hasUnpaintedFloors() {
        for (const floor of this.floors.values())if (floor.map?.hasPainted?.() === false) return true;
        return false;
    }
}



parcelRequire("1avo5");
var $kXE1p = parcelRequire("kXE1p");
var $klOfb = parcelRequire("klOfb");
var $csytw = parcelRequire("csytw");
var $kfhEp = parcelRequire("kfhEp");
const $86b1b715e0acdf03$var$integer = (n, min = 0)=>typeof n === "number" && Number.isInteger(n) && n >= min;
const $86b1b715e0acdf03$var$finite = (n)=>typeof n === "number" && Number.isFinite(n);
const $86b1b715e0acdf03$var$record = (v)=>!!v && typeof v === "object" && !Array.isArray(v);
const $86b1b715e0acdf03$export$ad3abeeb267a6815 = (atlasDestination, image)=>{
    if (typeof image !== "string" || !image || image.includes("\\") || image.startsWith("/")) return undefined;
    const parts = atlasDestination.split("/").slice(0, -1);
    for (const part of image.split("/")){
        if (part === "..") {
            if (!parts.length) return undefined;
            parts.pop();
        } else if (part && part !== ".") parts.push(part);
    }
    return parts.join("/");
};
const $86b1b715e0acdf03$export$13c769031201ff2b = (atlas, image, options = {})=>{
    const problems = [];
    if (!$86b1b715e0acdf03$var$record(atlas) || !$86b1b715e0acdf03$var$record(atlas.meta)) return [
        "atlas must be an object with meta"
    ];
    if (!$86b1b715e0acdf03$var$record(atlas.frames) || !Object.keys(atlas.frames).length) return [
        "atlas has no frames"
    ];
    const size = atlas.meta.size;
    if (!$86b1b715e0acdf03$var$record(size) || size.w !== image.width || size.h !== image.height) problems.push(`meta.size ${size?.w}x${size?.h} differs from the image ${image.width}x${image.height}`);
    for (const [name, entry] of Object.entries(atlas.frames)){
        if (!$86b1b715e0acdf03$var$record(entry) || !$86b1b715e0acdf03$var$record(entry.frame)) {
            problems.push(`frame ${name} has no rectangle`);
            continue;
        }
        const { x: x, y: y, w: w, h: h } = entry.frame;
        if (!$86b1b715e0acdf03$var$integer(x) || !$86b1b715e0acdf03$var$integer(y) || !$86b1b715e0acdf03$var$integer(w, 1) || !$86b1b715e0acdf03$var$integer(h, 1)) {
            problems.push(`frame ${name} is not a whole-pixel rectangle`);
            continue;
        }
        // A rotated frame occupies its rectangle turned on its side.
        const [width, height] = entry.rotated === true ? [
            h,
            w
        ] : [
            w,
            h
        ];
        if (x + width > image.width || y + height > image.height) problems.push(`frame ${name} lies outside the ${image.width}x${image.height} image`);
        if (entry.rotated !== undefined && typeof entry.rotated !== "boolean") problems.push(`frame ${name} has an invalid rotation flag`);
        if (entry.anchor !== undefined && (!$86b1b715e0acdf03$var$record(entry.anchor) || !$86b1b715e0acdf03$var$finite(entry.anchor.x) || !$86b1b715e0acdf03$var$finite(entry.anchor.y))) problems.push(`frame ${name} has an invalid anchor`);
        if (entry.sourceSize !== undefined && (!$86b1b715e0acdf03$var$record(entry.sourceSize) || !$86b1b715e0acdf03$var$integer(entry.sourceSize.w, 1) || !$86b1b715e0acdf03$var$integer(entry.sourceSize.h, 1))) problems.push(`frame ${name} has an invalid source size`);
        const trim = entry.spriteSourceSize;
        if (trim !== undefined && (!$86b1b715e0acdf03$var$record(trim) || !$86b1b715e0acdf03$var$integer(trim.x) || !$86b1b715e0acdf03$var$integer(trim.y) || !$86b1b715e0acdf03$var$integer(trim.w, 1) || !$86b1b715e0acdf03$var$integer(trim.h, 1))) problems.push(`frame ${name} has an invalid trim rectangle`);
        else if (trim && $86b1b715e0acdf03$var$record(entry.sourceSize) && !options.allowTrimOutsideSource && (trim.x + trim.w > entry.sourceSize.w || trim.y + trim.h > entry.sourceSize.h)) problems.push(`frame ${name} is trimmed outside its source size`);
    }
    if (atlas.animations !== undefined) {
        if (!$86b1b715e0acdf03$var$record(atlas.animations)) problems.push("animations must be an object");
        else for (const [name, frames] of Object.entries(atlas.animations))if (!Array.isArray(frames) || frames.some((frame)=>typeof frame !== "string" || !Object.prototype.hasOwnProperty.call(atlas.frames, frame))) problems.push(`animation ${name} names a missing frame`);
    }
    return problems;
};





const $e2393925e68fc231$var$verifyBytes = async (bytes, expected, file)=>{
    if (bytes.byteLength !== expected.size) throw new Error(`Content integrity mismatch: ${file}`);
    if (!globalThis.crypto?.subtle) throw new Error("Content integrity requires Web Crypto (HTTPS or localhost)");
    const hash = await globalThis.crypto.subtle.digest("SHA-256", bytes);
    const hex = Array.from(new Uint8Array(hash), (byte)=>byte.toString(16).padStart(2, "0")).join("");
    if (hex !== expected.sha256) throw new Error(`Content integrity mismatch: ${file}`);
};
const $e2393925e68fc231$var$decodeBase64 = (text)=>{
    const binary = atob(text), bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes.buffer;
};
const $e2393925e68fc231$export$ba5971bdaa9055a3 = {
    async fetch (url, signal) {
        const response = await fetch(url, {
            signal: signal
        });
        if (!response.ok) throw new Error(`Content download failed (${response.status}): ${url}`);
        return response.arrayBuffer();
    },
    async decode (bytes, signal) {
        const url = URL.createObjectURL(new Blob([
            bytes
        ]));
        const image = new Image();
        try {
            await new Promise((resolve, reject)=>{
                const abort = ()=>{
                    image.src = "";
                    reject(new Error("Content image decode aborted"));
                };
                const cleanup = ()=>signal.removeEventListener("abort", abort);
                image.onload = ()=>{
                    cleanup();
                    resolve();
                };
                image.onerror = ()=>{
                    cleanup();
                    reject(new Error("Invalid content image"));
                };
                signal.addEventListener("abort", abort, {
                    once: true
                });
                if (signal.aborted) {
                    cleanup();
                    abort();
                    return;
                }
                image.src = url;
            });
            return {
                image: image,
                close: ()=>{
                    image.src = "";
                }
            };
        } finally{
            URL.revokeObjectURL(url);
        }
    }
};
const $e2393925e68fc231$var$IMAGE = /\.(png|webp|jpg|jpeg|gif)$/i;
// An atlas and its image become ONE texture, so new art behind an unchanged document still means
// staging the document. `X.png.json` draws X.png; the release names the image of every other atlas
// (authored-terrain.json draws authored-terrain-v2.png). A release from before that list falls back
// to guessing `X.json` for X.png -- which missed authored-terrain, so its live art never showed.
const $e2393925e68fc231$var$atlasesDrawing = (file, manifest)=>{
    if (!$e2393925e68fc231$var$IMAGE.test(file)) return [];
    const drawn = manifest.atlasImages;
    return [
        `${file}.json`,
        ...drawn ? Object.keys(drawn).filter((atlas)=>drawn[atlas] === file) : [
            file.replace($e2393925e68fc231$var$IMAGE, ".json")
        ]
    ];
};
class $e2393925e68fc231$export$646f612ab2c0b9c1 {
    constructor(revision, owner, media){
        this.revision = revision;
        this.owner = owner;
        this.media = media;
        this.bytes = new Map();
        this.images = new Map();
        this.documents = new Map();
        this.inherited = new Set();
        this.disposed = false;
        this.published = false;
    }
    activate() {
        if (this.disposed || this.published) throw new Error("Content asset generation is unavailable");
        const previous = this.owner.active;
        this.owner.active = this;
        this.published = true;
        return ()=>{
            if (!this.published || this.owner.active !== this || previous?.disposed) throw new Error("Content asset rollback is stale");
            this.owner.active = previous;
            this.published = false;
        };
    }
    discard() {
        if (this.published) throw new Error("Published content assets must be retired by the renderer");
        this.dispose();
    }
    /** Call only after the renderer has released all sprites, atlas views and asynchronous jobs
     * using this generation. The current generation cannot be retired. */ releaseRetired() {
        if (this.owner.active === this) throw new Error("Cannot retire active content assets");
        this.dispose();
    }
    dispose() {
        if (this.disposed) return;
        this.disposed = true;
        this.images.forEach((image)=>image.close());
        this.images.clear();
        this.bytes.clear();
        this.documents.clear();
    }
}
class $e2393925e68fc231$export$fd07b0d4c8118e97 {
    constructor(backend = $e2393925e68fc231$export$ba5971bdaa9055a3, assetBase = "", concurrency = 8, bundledRevision = ()=>undefined){
        this.backend = backend;
        this.assetBase = assetBase;
        this.concurrency = concurrency;
        this.bundledRevision = bundledRevision;
        this.url = (published)=>`${this.assetBase.replace(/\/$/, "")}${this.assetBase ? "/" : ""}assets/${published}`;
        this.baseline = async (signal)=>{
            if (this.active) return this.active.media && {
                revision: this.active.revision,
                media: this.active.media
            };
            const revision = this.bundledRevision();
            if (!revision) return undefined;
            if (this.bundled?.revision === revision) return this.bundled;
            try {
                const manifest = JSON.parse(new TextDecoder("utf-8", {
                    fatal: true
                }).decode(await this.backend.fetch(this.url(`content/${revision}/manifest.json`), signal)));
                if (manifest?.revision !== revision || !manifest.integrity?.media) return undefined;
                return this.bundled = {
                    revision: revision,
                    media: manifest.integrity.media
                };
            } catch  {
                return undefined;
            }
        };
        this./** `canReuse` lets the renderer refuse to inherit a file it has no loaded copy of. `inline` holds
     * files the server sent because no web host serves them; they are checked like downloads. */ stage = async (snapshot, signal, canReuse = ()=>true, inline)=>{
            const integrity = snapshot.manifest.integrity;
            if (integrity) await $e2393925e68fc231$var$verifyBytes(new TextEncoder().encode((0, $59a4975031bf42fe$export$5f7ad4bf4d14138b)(snapshot.catalog)).buffer, integrity.catalog, "catalog.json");
            const generation = new $e2393925e68fc231$export$646f612ab2c0b9c1(snapshot.catalog.revision, this, integrity?.media);
            const controller = new AbortController();
            const abort = ()=>controller.abort();
            signal.addEventListener("abort", abort, {
                once: true
            });
            if (signal.aborted) abort();
            const fetchAll = async (files)=>{
                let cursor = 0;
                const workers = Array.from({
                    length: Math.min(this.concurrency, files.length)
                }, async ()=>{
                    while(cursor < files.length){
                        if (controller.signal.aborted) throw new Error("Content download aborted");
                        const file = files[cursor++];
                        try {
                            const sent = inline && Object.prototype.hasOwnProperty.call(inline, file) ? inline[file] : undefined;
                            const bytes = typeof sent === "string" ? $e2393925e68fc231$var$decodeBase64(sent) : await this.backend.fetch(this.url(snapshot.catalog.assets[file]), controller.signal);
                            if (integrity) await $e2393925e68fc231$var$verifyBytes(bytes, integrity.media[file], file);
                            if (controller.signal.aborted) throw new Error("Content download aborted");
                            generation.bytes.set(file, bytes);
                            if (/\.json$/i.test(file)) generation.documents.set(file, JSON.parse(new TextDecoder("utf-8", {
                                fatal: true
                            }).decode(bytes)));
                            if ($e2393925e68fc231$var$IMAGE.test(file)) {
                                const image = await this.backend.decode(bytes, controller.signal);
                                if (controller.signal.aborted) {
                                    image.close();
                                    throw new Error("Content decode aborted");
                                }
                                generation.images.set(file, image);
                            }
                        } catch (error) {
                            controller.abort();
                            throw error;
                        }
                    }
                });
                // Await every worker before cleanup: late decodes cannot resurrect a discarded generation.
                const failed = (await Promise.allSettled(workers)).find((result)=>result.status === "rejected");
                if (failed) throw failed.reason;
            };
            try {
                const media = snapshot.manifest.media, listed = new Set(media);
                const baseline = integrity && !controller.signal.aborted ? await this.baseline(controller.signal) : undefined;
                const held = (file)=>{
                    const before = baseline?.media[file], after = integrity?.media[file];
                    return !!before && !!after && before.sha256 === after.sha256 && before.size === after.size && canReuse(file);
                };
                const wanted = new Set(media.filter((file)=>!held(file)));
                for (const file of [
                    ...wanted
                ])for (const atlas of $e2393925e68fc231$var$atlasesDrawing(file, snapshot.manifest))if (listed.has(atlas)) wanted.add(atlas);
                await fetchAll(media.filter((file)=>wanted.has(file)));
                // ...and the other way round: a staged atlas needs its image even when only the document changed.
                const images = new Set();
                for (const [file, document] of generation.documents){
                    const image = document?.frames && (0, $86b1b715e0acdf03$export$ad3abeeb267a6815)(file, document.meta?.image);
                    if (image && listed.has(image) && !wanted.has(image)) images.add(image);
                }
                images.forEach((image)=>wanted.add(image));
                await fetchAll([
                    ...images
                ]);
                for (const file of media)if (!wanted.has(file)) generation.inherited.add(file);
            } catch (error) {
                signal.removeEventListener("abort", abort);
                generation.discard();
                throw error;
            }
            signal.removeEventListener("abort", abort);
            if (controller.signal.aborted) {
                generation.discard();
                throw new Error("Content download aborted");
            }
            return generation;
        };
        if (!Number.isInteger(concurrency) || concurrency < 1) throw new Error("Invalid content download concurrency");
    }
}




let $1f08f7b8f85adf9e$var$namespaceSequence = 0;
let $1f08f7b8f85adf9e$var$generationSequence = 0;
/** A presentation sheet as the startup loader holds it, if it finished loading. */ const $1f08f7b8f85adf9e$var$loadedAtStartup = (id)=>{
    const resource = (0, $kXE1p.Loader).shared.resources[id];
    return resource?.textures ? resource : undefined;
};
class $1f08f7b8f85adf9e$export$e13119ecb35d8334 {
    constructor(assets, owner, previous){
        this.assets = assets;
        this.owner = owner;
        this.previous = previous;
        this.generation = ++$1f08f7b8f85adf9e$var$generationSequence;
        this.resources = new Map();
        this.textures = new Map();
        this.sheets = [];
        this.bases = [];
        this.disposed = false;
        this.published = false;
        this.heirs = 0;
        this.adoptedPrevious = false;
    }
    async build(snapshot, signal, upload) {
        if (this.previous) {
            this.previous.heirs++;
            this.adoptedPrevious = true;
            this.previous.resources.forEach((resource, key)=>this.resources.set(key, resource));
        }
        const resources = new Map();
        for (const [file, document] of this.assets.documents){
            if (signal.aborted) throw new Error("Content atlas staging aborted");
            const data = document;
            if (!data?.frames) continue;
            const imageFile = (0, $86b1b715e0acdf03$export$ad3abeeb267a6815)(file, data.meta?.image);
            const image = imageFile && this.assets.images.get(imageFile);
            if (!image) throw new Error(`Atlas ${file} names an unavailable image`);
            // New base per atlas: PIXI mutates its resolution based on atlas meta.scale.
            const base = new (0, $klOfb.BaseTexture)(image.image);
            this.bases.push(base);
            if (!base.valid) throw new Error(`Atlas image is not decoded: ${imageFile}`);
            // Legacy atlases include compiler-pinned trims outside their source rectangle.
            // These are legal PIXI textures; runtime still validates image/frame bounds.
            const problems = (0, $86b1b715e0acdf03$export$13c769031201ff2b)(data, {
                width: base.realWidth,
                height: base.realHeight
            }, {
                allowTrimOutsideSource: true
            });
            if (problems.length) throw new Error(`Invalid atlas ${file}: ${problems.join("; ")}`);
            if (data.meta.scale !== undefined) {
                const scale = data.meta.scale;
                const parsed = parseFloat(String(scale));
                if (![
                    "string",
                    "number"
                ].includes(typeof scale) || parsed !== Number(scale) || !(parsed > 0) || !Number.isFinite(parsed) || !Number.isFinite(base.realWidth / parsed) || !Number.isFinite(base.realHeight / parsed)) throw new Error(`Invalid atlas scale: ${file}`);
            }
            if (data.meta.related_multi_packs?.length) throw new Error(`Multi-pack atlas staging is unsupported: ${file}`);
            const names = Object.keys(data.frames);
            let prefix;
            do prefix = `content-stage-${++$1f08f7b8f85adf9e$var$namespaceSequence}:`;
            while (names.some((name)=>Object.prototype.hasOwnProperty.call((0, $csytw).TextureCache, prefix + name)));
            const frames = Object.fromEntries(names.map((name)=>[
                    prefix + name,
                    data.frames[name]
                ]));
            const animationNames = Object.keys(data.animations || {});
            const animations = Object.fromEntries(Object.entries(data.animations || {}).map(([name, entries])=>[
                    prefix + name,
                    entries.map((frame)=>prefix + frame)
                ]));
            const sheet = new (0, $kfhEp.Spritesheet)(base, {
                ...data,
                frames: frames,
                animations: animations
            });
            this.sheets.push(sheet);
            try {
                await new Promise((resolve)=>sheet.parse(()=>resolve()));
            } finally{
                // Spritesheet.parse writes global entries, so give it unique private names and
                // remove them after parsing. Never let late loader jobs overwrite staged frames.
                names.forEach((name)=>(0, $klOfb.Texture).removeFromCache(prefix + name));
            }
            if (signal.aborted) throw new Error("Content atlas staging aborted");
            upload(base);
            const resource = {
                textures: Object.fromEntries(names.map((name)=>[
                        name,
                        sheet.textures[prefix + name]
                    ])),
                spritesheet: {
                    animations: Object.fromEntries(animationNames.map((name)=>[
                            name,
                            sheet.animations[prefix + name]
                        ]))
                }
            };
            resources.set(file, resource);
            this.resources.set(`assets/${file}`, resource);
            this.resources.set(file, resource);
        }
        for (const { id: id, file: file } of snapshot.catalog.source.presentation.sheets){
            const resource = resources.get(file) || (this.previous ? this.previous.resources.get(file) : $1f08f7b8f85adf9e$var$loadedAtStartup(id));
            if (!resource) throw new Error(`Missing presentation atlas: ${file}`);
            this.resources.set(id, resource);
            for (const [name, texture] of Object.entries(resource.textures))this.textures.set(name, texture);
        }
        for (const file of snapshot.catalog.source.preload){
            if (!resources.has(file) && !this.assets.inherited.has(file)) throw new Error(`Missing preload atlas: ${file}`);
        }
    }
    activate() {
        if (this.disposed || this.published) throw new Error("Content texture generation is unavailable");
        const previous = this.owner.active;
        const undoAssets = this.assets.activate();
        this.owner.active = this;
        this.published = true;
        return ()=>{
            if (!this.published || this.owner.active !== this || previous?.disposed) throw new Error("Content texture rollback is stale");
            undoAssets();
            this.owner.active = previous;
            this.published = false;
        };
    }
    discard() {
        if (this.published) throw new Error("Published content textures must be retired by the renderer");
        if (this.adoptedPrevious) {
            this.adoptedPrevious = false;
            this.previous.heirs--;
        }
        this.dispose();
        this.assets.discard();
    }
    releaseRetired() {
        if (this.owner.active === this) throw new Error("Cannot retire active content textures");
        if (this.heirs) throw new Error("Retired content textures are still adopted by a newer generation");
        this.dispose();
        this.assets.releaseRetired();
    }
    dispose() {
        if (this.disposed) return;
        this.disposed = true;
        this.sheets.forEach((sheet)=>sheet.destroy(false));
        this.bases.forEach((base)=>base.destroy());
        this.sheets = [];
        this.bases = [];
        this.resources.clear();
        this.textures.clear();
    }
}
class $1f08f7b8f85adf9e$export$757e4601476fa08c {
    constructor(assets = new (0, $e2393925e68fc231$export$fd07b0d4c8118e97)(undefined, (0, $a8f3c0c196817c22$export$7eca4ea16d4c8343)().assetBase, undefined, ()=>(0, $e5c675b7b9585b42$export$43829b1119ccb642)), upload = $1f08f7b8f85adf9e$var$uploadContentBase){
        this.assets = assets;
        this.upload = upload;
        this.stage = async (snapshot, signal, inline)=>{
            const previous = this.active;
            // Presentation sheets feed the texture map built here, so one can only be inherited when a
            // loaded copy exists to adopt. Everything else falls back to the lazy loaders.
            const sheets = new Map(snapshot.catalog.source.presentation.sheets.map(({ id: id, file: file })=>[
                    file,
                    id
                ]));
            const canReuse = (file)=>!sheets.has(file) || !!(previous ? previous.resources.get(file) : $1f08f7b8f85adf9e$var$loadedAtStartup(sheets.get(file)));
            const assets = await this.assets.stage(snapshot, signal, canReuse, inline);
            const generation = new $1f08f7b8f85adf9e$export$e13119ecb35d8334(assets, this, previous);
            try {
                await generation.build(snapshot, signal, this.upload);
                return generation;
            } catch (error) {
                generation.discard();
                throw error;
            }
        };
    }
}
const $1f08f7b8f85adf9e$var$uploadContentBase = (base)=>{
    const renderer = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer;
    if (!renderer.texture || renderer.gl.isContextLost()) throw new Error("Content texture staging needs a live WebGL renderer");
    const gl = renderer.gl;
    const maximum = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    if (base.realWidth > maximum || base.realHeight > maximum) throw new Error("Content image exceeds this GPU's texture limit");
    renderer.texture.bind(base);
    if (gl.getError() !== gl.NO_ERROR) throw new Error("Content texture upload failed");
};
const $1f08f7b8f85adf9e$export$250bc44beae81773 = new $1f08f7b8f85adf9e$export$757e4601476fa08c();
const $1f08f7b8f85adf9e$export$dd4554ad7431ed50 = ()=>$1f08f7b8f85adf9e$export$250bc44beae81773.active?.generation || 0;
const $1f08f7b8f85adf9e$export$42d948b5d3f64a60 = (id)=>$1f08f7b8f85adf9e$export$250bc44beae81773.active?.resources.get(id) || (0, $kXE1p.Loader).shared.resources[id];
const $1f08f7b8f85adf9e$export$be4093a94fa236fa = (id)=>{
    return $1f08f7b8f85adf9e$export$250bc44beae81773.active ? $1f08f7b8f85adf9e$export$250bc44beae81773.active.textures.get(id) || (0, $klOfb.Texture).EMPTY : (0, $klOfb.Texture).from(id);
};


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

var $1avo5 = parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");
/**
 * Compile filter shaders before they are first needed. WebGL links a filter's program the first
 * time the filter draws, and that is a main-thread stall: 36ms for the occlusion outline on a fast
 * Mac, more on a modest machine. Its first use was landing behind a building after a fall. Programs
 * are shared by every filter with the same source, so one draw of each kind is enough.
 *
 * The filters drawn here are never destroyed: the renderer keeps a reference to the last shader it
 * bound, and a destroyed one broke the next render ("Cannot read properties of null (reading
 * 'uniforms')"). They, the probe and the 2x2 target are a few bytes, kept for the session.
 */ const $d418365bf376d48a$var$warmed = {
    filters: []
};
const $d418365bf376d48a$export$f92e084d92dcf8bb = (renderer, owned = [])=>{
    // The kinds whose first use comes mid-game: a roof fading (sky), and passive floors' blur and shade.
    const kinds = [
        new (0, $1avo5.filters).AlphaFilter(0.5),
        new (0, $1avo5.filters).BlurFilter(0.75, 2, 0.5),
        new (0, $1avo5.filters).ColorMatrixFilter()
    ];
    $d418365bf376d48a$var$warmed.filters.push(...kinds);
    $d418365bf376d48a$var$warmed.target ||= (0, $klOfb.RenderTexture).create({
        width: 2,
        height: 2
    });
    const probe = $d418365bf376d48a$var$warmed.probe ||= new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).WHITE);
    probe.width = probe.height = 2;
    try {
        for (const filter of [
            ...owned,
            ...kinds
        ]){
            probe.filters = [
                filter
            ];
            renderer.render(probe, {
                renderTexture: $d418365bf376d48a$var$warmed.target,
                clear: true
            });
        }
    } catch  {
    // No usable renderer (headless, or a lost context): they compile on first use instead.
    } finally{
        probe.filters = null;
    }
};



var $5UG8I = parcelRequire("5UG8I");
parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $8t5Gy = parcelRequire("8t5Gy");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $6qzqq = parcelRequire("6qzqq");
var $P8XPi = parcelRequire("P8XPi");



const $f111aadd6a3e5d22$export$7cacf5135251d926 = {
    enabled: true,
    faceHeight: 52,
    overhang: 16
};
const $f111aadd6a3e5d22$export$bc9d9821b03db46f = ()=>{
    if (typeof window === "undefined") return $f111aadd6a3e5d22$export$7cacf5135251d926;
    const w = window;
    if (w.rockMass === undefined) w.rockMass = $f111aadd6a3e5d22$export$7cacf5135251d926;
    const live = w.rockMass;
    if (live === false) return {
        ...$f111aadd6a3e5d22$export$7cacf5135251d926,
        enabled: false
    };
    return live && typeof live === "object" ? live : $f111aadd6a3e5d22$export$7cacf5135251d926;
};
const $f111aadd6a3e5d22$export$7aaeba3b59006fe = 128;
const $f111aadd6a3e5d22$export$4010b7a0984edab1 = 64;
// ---------------------------------------------------------------- palette (the testore face's own colours)
const $f111aadd6a3e5d22$var$hex = (s)=>[
        parseInt(s.slice(1, 3), 16),
        parseInt(s.slice(3, 5), 16),
        parseInt(s.slice(5, 7), 16)
    ];
const $f111aadd6a3e5d22$export$22ccd2f254618968 = [
    "#110e11",
    "#1f1a1e",
    "#2b262a",
    "#363036",
    "#433b40",
    "#524749",
    "#635655",
    "#766762",
    "#8a7e7c"
].map($f111aadd6a3e5d22$var$hex);
/** Each ore's lump shades (dark .. glint) and the stain it leaves in the rock round it, after ore.png's sheet. */ const $f111aadd6a3e5d22$var$ORE = {
    coal: {
        lump: [
            "#0b090b",
            "#1c181b",
            "#2e282c",
            "#5b5257",
            "#a9a1a6"
        ].map($f111aadd6a3e5d22$var$hex),
        stain: $f111aadd6a3e5d22$var$hex("#120e10")
    },
    iron: {
        lump: [
            "#5a2410",
            "#9a4519",
            "#cf6a26",
            "#f3a24f",
            "#ffd690"
        ].map($f111aadd6a3e5d22$var$hex),
        stain: $f111aadd6a3e5d22$var$hex("#4b2216")
    },
    copper: {
        lump: [
            "#3b2010",
            "#7a3f1d",
            "#b8662e",
            "#e39a55",
            "#7fd6b0"
        ].map($f111aadd6a3e5d22$var$hex),
        stain: $f111aadd6a3e5d22$var$hex("#3a2416")
    },
    silver: {
        lump: [
            "#2a2c33",
            "#5d6370",
            "#9aa2b2",
            "#d6dde8",
            "#ffffff"
        ].map($f111aadd6a3e5d22$var$hex),
        stain: $f111aadd6a3e5d22$var$hex("#2a2e38")
    },
    gold: {
        lump: [
            "#4a2f06",
            "#94660f",
            "#d39f25",
            "#f6d35a",
            "#fff3b8"
        ].map($f111aadd6a3e5d22$var$hex),
        stain: $f111aadd6a3e5d22$var$hex("#3f2a08")
    }
};
const $f111aadd6a3e5d22$var$POOL = [
    "#0f1a24",
    "#203646",
    "#4f7889"
].map($f111aadd6a3e5d22$var$hex);
// ---------------------------------------------------------------- hash / noise
const $f111aadd6a3e5d22$var$hash = (x, y, seed)=>{
    let h = Math.imul(x | 0, 374761393) ^ Math.imul(y | 0, 668265263) ^ seed;
    h = Math.imul(h ^ h >>> 13, 1274126177);
    return ((h ^ h >>> 16) >>> 0) / 4294967295;
};
const $f111aadd6a3e5d22$var$smooth = (v)=>v * v * (3 - 2 * v);
const $f111aadd6a3e5d22$var$valueNoise = (x, y, seed)=>{
    const ix = Math.floor(x), iy = Math.floor(y);
    const sx = $f111aadd6a3e5d22$var$smooth(x - ix), sy = $f111aadd6a3e5d22$var$smooth(y - iy);
    const a = $f111aadd6a3e5d22$var$hash(ix, iy, seed), b = $f111aadd6a3e5d22$var$hash(ix + 1, iy, seed), c = $f111aadd6a3e5d22$var$hash(ix, iy + 1, seed), d = $f111aadd6a3e5d22$var$hash(ix + 1, iy + 1, seed);
    const top = a + (b - a) * sx;
    return top + (c + (d - c) * sx - top) * sy;
};
const $f111aadd6a3e5d22$var$mod = (v, m)=>(v % m + m) % m;
// ---------------------------------------------------------------- the column texture, one repeating tile
/** Columns across and rows down one ROCK_CHUNK: the jittered lattice repeats exactly once per piece. */ const $f111aadd6a3e5d22$var$COLS = 9, $f111aadd6a3e5d22$var$ROWS = 12;
const $f111aadd6a3e5d22$var$COL_W = $f111aadd6a3e5d22$export$7aaeba3b59006fe / $f111aadd6a3e5d22$var$COLS, $f111aadd6a3e5d22$var$ROW_H = $f111aadd6a3e5d22$export$7aaeba3b59006fe / $f111aadd6a3e5d22$var$ROWS;
let $f111aadd6a3e5d22$var$columnTile;
const $f111aadd6a3e5d22$export$53b3c91859018cd4 = ()=>{
    if ($f111aadd6a3e5d22$var$columnTile) return $f111aadd6a3e5d22$var$columnTile;
    const S = $f111aadd6a3e5d22$export$7aaeba3b59006fe;
    const id = new Uint8Array(S * S), top = new Uint8Array(S * S);
    const point = (c, r)=>{
        const pc = $f111aadd6a3e5d22$var$mod(c, $f111aadd6a3e5d22$var$COLS), pr = $f111aadd6a3e5d22$var$mod(r, $f111aadd6a3e5d22$var$ROWS);
        return [
            c * $f111aadd6a3e5d22$var$COL_W + (r & 1) * $f111aadd6a3e5d22$var$COL_W / 2 + ($f111aadd6a3e5d22$var$hash(pc, pr, 11) - 0.5) * 5,
            r * $f111aadd6a3e5d22$var$ROW_H + ($f111aadd6a3e5d22$var$hash(pc, pr, 23) - 0.5) * 4
        ];
    };
    for(let y = 0; y < S; y++){
        const r0 = Math.floor(y / $f111aadd6a3e5d22$var$ROW_H);
        for(let x = 0; x < S; x++){
            let d1 = 1e9, d2 = 1e9, best = 0, bx = 0, by = 0;
            for(let dr = -1; dr <= 1; dr++){
                const r = r0 + dr;
                const c0 = Math.floor((x - (r & 1) * $f111aadd6a3e5d22$var$COL_W / 2) / $f111aadd6a3e5d22$var$COL_W);
                for(let dc = -1; dc <= 1; dc++){
                    const c = c0 + dc;
                    const [px, py] = point(c, r);
                    const d = Math.hypot(x - px, y - py);
                    if (d < d1) {
                        d2 = d1;
                        d1 = d;
                        best = $f111aadd6a3e5d22$var$mod(r, $f111aadd6a3e5d22$var$ROWS) * $f111aadd6a3e5d22$var$COLS + $f111aadd6a3e5d22$var$mod(c, $f111aadd6a3e5d22$var$COLS);
                        bx = px;
                        by = py;
                    } else if (d < d2) d2 = d;
                }
            }
            const i = y * S + x;
            id[i] = best;
            const tr = $f111aadd6a3e5d22$var$hash(best, 0, 31);
            const tone = tr < 0.2 ? -1 : tr > 0.8 ? 1 : 0;
            const near = d2 - d1 < 2.6;
            const upLeft = x - bx + (y - by) < 0;
            top[i] = d2 - d1 < 1.1 ? 1 : 3 + tone + (near && upLeft ? 1 : 0);
        }
    }
    return $f111aadd6a3e5d22$var$columnTile = {
        id: id,
        top: top
    };
};
const $f111aadd6a3e5d22$var$columnAt = (tile, px, py)=>tile.id[$f111aadd6a3e5d22$var$mod(py, $f111aadd6a3e5d22$export$7aaeba3b59006fe) * $f111aadd6a3e5d22$export$7aaeba3b59006fe + $f111aadd6a3e5d22$var$mod(px, $f111aadd6a3e5d22$export$7aaeba3b59006fe)];
const $f111aadd6a3e5d22$var$topAt = (tile, px, py)=>tile.top[$f111aadd6a3e5d22$var$mod(py, $f111aadd6a3e5d22$export$7aaeba3b59006fe) * $f111aadd6a3e5d22$export$7aaeba3b59006fe + $f111aadd6a3e5d22$var$mod(px, $f111aadd6a3e5d22$export$7aaeba3b59006fe)];
const $f111aadd6a3e5d22$export$81a0b09380178999 = (view, x0, y0, w, h)=>{
    const mask = new Uint8Array(w * h);
    const cx0 = Math.floor((x0 + 0.5) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 0.5) - 1, cy0 = Math.floor((y0 + 0.5) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 0.5) - 1;
    const cw = Math.ceil(w / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) + 3, ch = Math.ceil(h / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) + 3;
    const solid = new Uint8Array(cw * ch);
    for(let j = 0; j < ch; j++)for(let i = 0; i < cw; i++)solid[j * cw + i] = view.solid(cx0 + i, cy0 + j) ? 1 : 0;
    for(let y = 0; y < h; y++){
        const py = y0 + y, v = (py + 0.5) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 0.5, j0 = Math.floor(v), sv = $f111aadd6a3e5d22$var$smooth(v - j0);
        const row = (j0 - cy0) * cw;
        for(let x = 0; x < w; x++){
            const px = x0 + x, u = (px + 0.5) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 0.5, i0 = Math.floor(u), su = $f111aadd6a3e5d22$var$smooth(u - i0);
            const k = row + i0 - cx0;
            const a = solid[k], b = solid[k + 1], c = solid[k + cw], d = solid[k + cw + 1];
            if (a + b + c + d === 4) {
                mask[y * w + x] = 1;
                continue;
            }
            if (a + b + c + d === 0) continue;
            const f = (a + (b - a) * su) * (1 - sv) + (c + (d - c) * su) * sv + 0.40 * ($f111aadd6a3e5d22$var$valueNoise(px / 21, py / 21, 7) - 0.5) + 0.14 * ($f111aadd6a3e5d22$var$valueNoise(px / 6.5, py / 6.5, 9) - 0.5);
            if (f > 0.5) mask[y * w + x] = 1;
        }
    }
    return mask;
};
const $f111aadd6a3e5d22$export$5cc313b50febd860 = (view, x0, y0, w, h, margin, faceHeight = $f111aadd6a3e5d22$export$7cacf5135251d926.faceHeight)=>$f111aadd6a3e5d22$export$1aaaff5ccbbb9ebd(view, x0, y0, w, h, margin, faceHeight).base;
const $f111aadd6a3e5d22$export$90677e6761877265 = 22;
/** Shade down the east and west edges of a top, the LPC platform's hint of a side. */ const $f111aadd6a3e5d22$var$SIDE_SHADE = 2;
const $f111aadd6a3e5d22$export$1aaaff5ccbbb9ebd = (view, x0, y0, w, h, margin, faceHeight = $f111aadd6a3e5d22$export$7cacf5135251d926.faceHeight, overhang = $f111aadd6a3e5d22$export$7cacf5135251d926.overhang)=>{
    const H = Math.max(2, Math.round(faceHeight));
    const L = Math.max(0, Math.round(overhang));
    const n = w * h;
    const mask = $f111aadd6a3e5d22$export$81a0b09380178999(view, x0, y0, w, h);
    const tile = $f111aadd6a3e5d22$export$53b3c91859018cd4();
    // zt: rock pixels between this one and the footprint's south edge in its column (0 = its bottom row).
    // zn: the same from the north edge. zs: for floor, how far down the next rock starts (the overhang's reach).
    const zt = new Int32Array(n).fill(-1), zn = new Int32Array(n).fill(-1), zs = new Int32Array(n).fill(0);
    for(let x = 0; x < w; x++){
        let run = 0, gap = 1048576;
        for(let y = h - 1; y >= 0; y--){
            const i = y * w + x;
            if (mask[i]) {
                zt[i] = run++;
                gap = 0;
            } else {
                run = 0;
                gap++;
                zs[i] = gap;
            }
        }
        run = 0;
        for(let y = 0; y < h; y++){
            const i = y * w + x;
            if (mask[i]) zn[i] = run++;
            else run = 0;
        }
    }
    const isFace = (i)=>zt[i] >= 0 && zt[i] < H;
    const over = (i)=>zt[i] < 0 && zs[i] <= L;
    /** Drawn as rock: the footprint, and the top's overhang north of it. */ const solid = (i)=>zt[i] >= 0 || over(i);
    const isTop = (i)=>zt[i] >= H || over(i);
    // zv: rock pixels (as drawn) above this one in its column, overhang included (0 = the drawn north edge).
    const zv = new Int32Array(n).fill(-1);
    for(let x = 0; x < w; x++){
        let run = 0;
        for(let y = 0; y < h; y++){
            const i = y * w + x;
            if (solid(i)) zv[i] = run++;
            else run = 0;
        }
    }
    // How far a top pixel is from the nearest floor or face (3-4 chamfer, in px): the top recedes into the
    // dark away from its edges, so the mass reads as a solid ridge and not as paving round a hole.
    const edge = new Float32Array(n);
    for(let i = 0; i < n; i++)edge[i] = isTop(i) ? 1e9 : 0;
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (!edge[i]) continue;
        let d = edge[i];
        if (x > 0) d = Math.min(d, edge[i - 1] + 1);
        if (y > 0) d = Math.min(d, edge[i - w] + 1);
        if (x > 0 && y > 0) d = Math.min(d, edge[i - w - 1] + 1.4);
        if (x < w - 1 && y > 0) d = Math.min(d, edge[i - w + 1] + 1.4);
        edge[i] = d;
    }
    for(let y = h - 1; y >= 0; y--)for(let x = w - 1; x >= 0; x--){
        const i = y * w + x;
        if (!edge[i]) continue;
        let d = edge[i];
        if (x < w - 1) d = Math.min(d, edge[i + 1] + 1);
        if (y < h - 1) d = Math.min(d, edge[i + w] + 1);
        if (x < w - 1 && y < h - 1) d = Math.min(d, edge[i + w + 1] + 1.4);
        if (x > 0 && y < h - 1) d = Math.min(d, edge[i + w - 1] + 1.4);
        edge[i] = d;
    }
    const iw = w - 2 * margin, ih = h - 2 * margin;
    const size = Math.max(0, iw * ih * 4);
    const base = new Uint8ClampedArray(size), topRim = new Uint8ClampedArray(size), faceRim = new Uint8ClampedArray(size);
    let copy;
    const set = (o, c, a = 255)=>{
        base[o] = c[0];
        base[o + 1] = c[1];
        base[o + 2] = c[2];
        base[o + 3] = a;
        if (copy) {
            copy[o] = c[0];
            copy[o + 1] = c[1];
            copy[o + 2] = c[2];
            copy[o + 3] = a;
        }
    };
    for(let y = margin; y < h - margin; y++){
        const py = y0 + y;
        for(let x = margin; x < w - margin; x++){
            const px = x0 + x;
            const i = y * w + x;
            const o = ((y - margin) * iw + (x - margin)) * 4;
            if (!solid(i)) {
                copy = undefined;
                $f111aadd6a3e5d22$var$paintFloor(view, base, o, solid, zt, w, x, y, px, py, H);
                continue;
            }
            const face = isFace(i);
            copy = face ? zn[i] < $f111aadd6a3e5d22$export$90677e6761877265 ? faceRim : undefined : zv[i] < L + $f111aadd6a3e5d22$export$90677e6761877265 ? topRim : undefined;
            // Outline: any drawn rock pixel touching floor; the lit rim: a top pixel right above a face.
            if (!solid(i - 1) || !solid(i + 1) || !solid(i - w) || !solid(i + w)) {
                set(o, $f111aadd6a3e5d22$export$22ccd2f254618968[0]);
                continue;
            }
            if (!face && isFace(i + w)) {
                set(o, $f111aadd6a3e5d22$export$22ccd2f254618968[8]);
                continue;
            }
            // The rock this pixel belongs to: a face's own cell, an overhang's the rock below it.
            const rockY = face ? py + zt[i] - 1 : zt[i] < 0 ? py + zs[i] : py;
            const cellX = Math.floor(px / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), cellY = Math.floor(rockY / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            let colour;
            if (face) {
                const z = zt[i], footY = py + z;
                const id = $f111aadd6a3e5d22$var$columnAt(tile, px, footY);
                const left = $f111aadd6a3e5d22$var$columnAt(tile, px - 1, footY), right = $f111aadd6a3e5d22$var$columnAt(tile, px + 1, footY);
                let idx = 3 + Math.floor($f111aadd6a3e5d22$var$hash(id, 0, 31) * 3) - 1;
                const hz = z / (H - 1);
                idx += hz < 0.2 ? -1 : hz > 0.74 ? 1 : 0;
                if (left !== id && $f111aadd6a3e5d22$var$hash(id, 3, 57) < 0.55) idx += 1 // only some facets catch the light
                ;
                if (right !== id) idx -= 1;
                if ($f111aadd6a3e5d22$var$hash(id, px, 41) < 0.12 && $f111aadd6a3e5d22$var$hash(id, Math.floor(z / 4), 43) < 0.6) idx -= 1;
                for(let j = 0; j < 3; j++){
                    if ($f111aadd6a3e5d22$var$hash(id, 20 + j, 53) >= 0.6) continue;
                    const jz = Math.floor($f111aadd6a3e5d22$var$hash(id, 10 + j, 51) * (H - 6)) + 3;
                    const tilt = Math.floor($f111aadd6a3e5d22$var$mod(px, 4) * ($f111aadd6a3e5d22$var$hash(id, 30 + j, 59) - 0.5));
                    if (z === jz + tilt) idx = 1;
                    else if (z === jz + tilt - 1) idx += 1;
                }
                if ($f111aadd6a3e5d22$var$hash(px, py, 91) < 0.035) idx -= 2 // pits and chips
                ;
                if (z <= 2) idx = Math.min(idx, 2) // grime at the foot
                ;
                if (z === H - 1) idx = 7 // the lip
                ;
                if (z === 0) idx = 1;
                colour = $f111aadd6a3e5d22$export$22ccd2f254618968[Math.max(0, Math.min(8, idx))].slice();
                const opening = $f111aadd6a3e5d22$var$mouthOpening(view, cellX, Math.floor((footY - 1) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), px, z, H);
                if (opening >= 0) {
                    set(o, opening === 0 ? $f111aadd6a3e5d22$var$MOUTH_DARK : opening === 1 ? $f111aadd6a3e5d22$export$22ccd2f254618968[0] : $f111aadd6a3e5d22$export$22ccd2f254618968[6]);
                    continue;
                }
            } else {
                const recede = edge[i] >= 26 ? 2 : edge[i] >= 14 ? 1 : 0;
                let idx = $f111aadd6a3e5d22$var$topAt(tile, px, py + H) - recede;
                if (zv[i] === 1) idx = 6 // the top's north edge, lit
                ;
                else if (!solid(i - $f111aadd6a3e5d22$var$SIDE_SHADE) || !solid(i + $f111aadd6a3e5d22$var$SIDE_SHADE)) idx -= 1;
                colour = $f111aadd6a3e5d22$export$22ccd2f254618968[Math.max(1, idx)].slice();
            }
            // Ore where the rock is exposed: a face, the top just above one, or the top's north edge.
            const lip = !face && (isFace(i + 2 * w) || isFace(i + 4 * w) || isFace(i + 6 * w));
            const material = face || lip || !face && zv[i] <= 4 ? view.ore(cellX, cellY) : undefined;
            if (material) {
                const { lump: shades, stain: stain } = $f111aadd6a3e5d22$var$ORE[material];
                const dens = Math.pow(Math.max(0, 1 - view.veinDistance(px, rockY, material) / 24), 0.7);
                if (dens > 0.05) {
                    const k = 0.2 * (0.5 + dens);
                    for(let c = 0; c < 3; c++)colour[c] = colour[c] * 0.8 + stain[c] * k;
                    const lump = $f111aadd6a3e5d22$var$oreLump(px, py, dens);
                    if (lump === -1) colour = [
                        $f111aadd6a3e5d22$export$22ccd2f254618968[0][0] * 0.9 + stain[0] * 0.1,
                        $f111aadd6a3e5d22$export$22ccd2f254618968[0][1] * 0.9 + stain[1] * 0.1,
                        $f111aadd6a3e5d22$export$22ccd2f254618968[0][2] * 0.9 + stain[2] * 0.1
                    ];
                    else if (lump >= 0) colour = shades[lump].slice();
                }
            }
            // Cracks spread through a cell as it is struck.
            const damage = view.damage(cellX, cellY);
            if (damage > 0 && $f111aadd6a3e5d22$var$crackAt(px, py, damage)) colour = $f111aadd6a3e5d22$export$22ccd2f254618968[0].slice();
            set(o, colour);
        }
    }
    return {
        base: base,
        topRim: topRim,
        faceRim: faceRim
    };
};
const $f111aadd6a3e5d22$var$MOUTH_DARK = [
    11,
    8,
    10
];
/**
 * The way home, drawn into the face of its two mouth cells: an arch-topped opening centred on the pair.
 * -1 not in it, 0 the dark inside, 1 its outline, 2 the lit edge of the arch above the outline.
 */ const $f111aadd6a3e5d22$var$mouthOpening = (view, cx, cy, px, z, H)=>{
    if (!view.mouth?.(cx, cy)) return -1;
    const left = view.mouth(cx - 1, cy) ? cx - 1 : cx;
    const centre = (left + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const top = Math.min(H - 6, 42);
    const halfWidth = (h)=>h >= top ? -1 : 19 * Math.sqrt(1 - h / top * (h / top));
    const d = Math.abs(px + 0.5 - centre);
    const hw = halfWidth(z);
    if (d < hw - 1) return 0;
    if (d < hw) return 1;
    if (d < halfWidth(z - 1) + 0.5 && z - 1 < top) return 1;
    if (d < halfWidth(z - 2) + 0.5 && z - 2 < top) return 2;
    return -1;
};
/** -2 none, -1 the dark ring round a lump, 0..4 the lump's ORE shade. Two staggered lattices so lumps cluster. */ const $f111aadd6a3e5d22$var$oreLump = (px, py, dens)=>{
    for (const off of [
        0,
        3
    ]){
        const lx = Math.floor((px + off) / 7), ly = Math.floor((py + off) / 6);
        if ($f111aadd6a3e5d22$var$hash(lx, ly, 71 + off) >= dens * 0.75) continue;
        const bx = lx * 7 - off + 2 + Math.floor($f111aadd6a3e5d22$var$hash(lx, ly, 61 + off) * 3);
        const by = ly * 6 - off + 1 + Math.floor($f111aadd6a3e5d22$var$hash(lx, ly, 67 + off) * 3);
        const dx = px - bx, dy = py - by;
        const body = dy === 0 && dx >= -1 && dx <= 1 || dy === 1 && dx >= -1 && dx <= 0;
        if (body) {
            if (dy === 0 && dx === -1) return $f111aadd6a3e5d22$var$hash(lx, ly, 79) < 0.2 ? 4 : 3;
            return dy === 0 ? 2 : 1;
        }
        const ring = dx >= -2 && dx <= 2 && dy >= -1 && dy <= 2 && !(dx === 2 && dy === 2) && !(dx === -2 && dy === -1) && !(dx === 2 && dy === -1) && !(dx === 2 && dy === 1) && !(dx === 1 && dy === 2);
        if (ring) return -1;
    }
    return -2;
};
/** A crack network on a 6px jittered lattice; more of its edges show the more the cell is broken. */ const $f111aadd6a3e5d22$var$crackAt = (px, py, damage)=>{
    const S = 6;
    const gx = Math.floor(px / S), gy = Math.floor(py / S);
    let d1 = 1e9, d2 = 1e9, a = 0, b = 0;
    for(let j = -1; j <= 1; j++)for(let i = -1; i <= 1; i++){
        const cx = gx + i, cy = gy + j;
        const qx = (cx + 0.5 + ($f111aadd6a3e5d22$var$hash(cx, cy, 101) - 0.5) * 0.8) * S, qy = (cy + 0.5 + ($f111aadd6a3e5d22$var$hash(cx, cy, 103) - 0.5) * 0.8) * S;
        const d = Math.hypot(px - qx, py - qy);
        const id = cx * 7919 + cy;
        if (d < d1) {
            d2 = d1;
            b = a;
            d1 = d;
            a = id;
        } else if (d < d2) {
            d2 = d;
            b = id;
        }
    }
    if (d2 - d1 >= 0.9) return false;
    return $f111aadd6a3e5d22$var$hash(Math.min(a, b), Math.max(a, b), 107) < damage * 0.9;
};
/** Floor pixels the rock marks: contact shadow under a face, rubble in dug cells, a pocket's damp. */ const $f111aadd6a3e5d22$var$paintFloor = (view, rgba, o, solid, zt, w, x, y, px, py, H)=>{
    if (view.lava?.(Math.floor(px / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.floor(py / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)))) return;
    let alpha = 0;
    let colour = [
        0,
        0,
        0
    ];
    // Contact shadow: darkest right under the foot, gone four pixels down.
    const SHADOW = [
        0.72,
        0.48,
        0.26,
        0.10
    ];
    for(let k = 1; k <= 4; k++){
        const j = (y - k) * w + x;
        if (y - k >= 0 && zt[j] >= 0 && zt[j] < H) {
            alpha = SHADOW[k - 1];
            break;
        }
    }
    for (const pool of view.pools?.() ?? []){
        const e = ((px + 0.5 - pool.x) / pool.rx) ** 2 + ((py + 0.5 - pool.y) / pool.ry) ** 2;
        if (e < 1) {
            const glint = Math.abs(py + 0.5 - (pool.y - pool.ry * 0.35)) < 0.6 && Math.abs(px + 0.5 - (pool.x - pool.rx * 0.25)) < pool.rx * 0.33;
            const c = glint ? $f111aadd6a3e5d22$var$POOL[2] : e > 0.72 ? $f111aadd6a3e5d22$var$POOL[1] : $f111aadd6a3e5d22$var$POOL[0];
            rgba[o] = c[0];
            rgba[o + 1] = c[1];
            rgba[o + 2] = c[2];
            rgba[o + 3] = 255;
            return;
        }
        if (e < 1.35) alpha = Math.max(alpha, 0.3);
    }
    // The floor darkens toward the foot of every wall, deepest at the far wall's base (rock to the south of it),
    // so the floor reads as sunk between walls rather than painted round them.
    const AO_SOUTH = [
        0.5,
        0.36,
        0.25,
        0.16,
        0.09,
        0.04
    ], AO_SIDE = [
        0.34,
        0.2,
        0.1,
        0.04
    ];
    const rows = zt.length / w;
    for(let k = 1; k <= AO_SOUTH.length && y + k < rows; k++)if (solid((y + k) * w + x)) {
        alpha = Math.max(alpha, AO_SOUTH[k - 1]);
        break;
    }
    for(let k = 1; k <= AO_SIDE.length; k++)if (x - k >= 0 && solid(y * w + x - k) || x + k < w && solid(y * w + x + k)) {
        alpha = Math.max(alpha, AO_SIDE[k - 1]);
        break;
    }
    const cx = Math.floor(px / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), cy = Math.floor(py / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    if (view.pocket(cx, cy)) {
        colour = [
            0,
            8,
            26
        ];
        alpha = Math.max(alpha, 0.22);
    }
    if (view.dug(cx, cy)) {
        let nearFace = false;
        for(let k = 1; k <= 8 && !nearFace; k++){
            const j = (y - k) * w + x;
            if (y - k >= 0 && zt[j] >= 0 && zt[j] < H) nearFace = true;
        }
        const rx = Math.floor(px / 5), ry = Math.floor(py / 5);
        if ($f111aadd6a3e5d22$var$hash(rx, ry, 87) < (nearFace ? 0.75 : 0.22)) {
            const big = $f111aadd6a3e5d22$var$hash(rx, ry, 89) < 0.3;
            const dx = px - (rx * 5 + Math.floor($f111aadd6a3e5d22$var$hash(rx, ry, 81) * 4)), dy = py - (ry * 5 + Math.floor($f111aadd6a3e5d22$var$hash(rx, ry, 83) * 4));
            const wMax = big ? 2 : 1, hMax = big ? 1 : 0;
            if (dx >= 0 && dy >= 0 && dx <= wMax && dy <= hMax) {
                const c = dx === 0 && dy === 0 ? $f111aadd6a3e5d22$export$22ccd2f254618968[6] : $f111aadd6a3e5d22$export$22ccd2f254618968[4];
                rgba[o] = c[0];
                rgba[o + 1] = c[1];
                rgba[o + 2] = c[2];
                rgba[o + 3] = 255;
                return;
            }
            if (dy === hMax + 1 && dx >= 1 && dx <= wMax) {
                colour = [
                    0,
                    0,
                    0
                ];
                alpha = Math.max(alpha, 0.4);
            }
        }
    }
    if (alpha <= 0) return;
    rgba[o] = colour[0];
    rgba[o + 1] = colour[1];
    rgba[o + 2] = colour[2];
    rgba[o + 3] = Math.round(alpha * 255);
};
const $f111aadd6a3e5d22$export$474ad6f2c3eab985 = (cx, cy, faceHeight = $f111aadd6a3e5d22$export$7cacf5135251d926.faceHeight)=>{
    const reach = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 + 10;
    const x = cx * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - reach, y = cy * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - reach - Math.round(faceHeight) - 8;
    // Below the cell, a new north edge moves the rims (overhang + ROCK_RIM_OVERLAY) and the top's lit edge down.
    return {
        x: x,
        y: y,
        w: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 2 * reach,
        h: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 2 * reach + Math.round(faceHeight) + 8 + $f111aadd6a3e5d22$export$7cacf5135251d926.overhang + $f111aadd6a3e5d22$export$90677e6761877265 + 6
    };
};


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");
class $3efef98b54376b50$export$cbb847030152319 {
    constructor(size, pageSize = 1024, gap = 1){
        this.size = size;
        this.pageSize = pageSize;
        this.gap = gap;
        this.pages = [];
        this.perRow = Math.max(1, Math.floor((pageSize + gap) / (size + gap)));
    }
    /** A free slot (on a new page when every page is full); undefined without a 2D canvas. */ claim() {
        let page = this.pages.findIndex((p)=>p.free.length > 0 || p.used < this.perRow * this.perRow);
        if (page < 0) {
            const canvas = document.createElement("canvas");
            canvas.width = this.pageSize;
            canvas.height = this.pageSize;
            // In memory, not on the GPU: a painter may read its pixels back (willReadFrequently), and a big canvas on the
            // GPU makes every such read a readback.
            const context = canvas.getContext("2d", {
                willReadFrequently: true
            });
            if (!context) return undefined;
            this.pages.push({
                canvas: canvas,
                context: context,
                base: (0, $klOfb.BaseTexture).from(canvas),
                free: [],
                used: 0
            });
            page = this.pages.length - 1;
        }
        const p = this.pages[page];
        const index = p.free.length ? p.free.pop() : p.used++;
        const x = index % this.perRow * (this.size + this.gap), y = Math.floor(index / this.perRow) * (this.size + this.gap);
        return {
            texture: new (0, $klOfb.Texture)(p.base, new (0, $6qzqq.Rectangle)(x, y, this.size, this.size)),
            x: x,
            y: y,
            page: page,
            index: index
        };
    }
    /** Paints a slot's pixels (size x size RGBA), shown from the next frame. */ paint(slot, rgba) {
        const p = this.pages[slot.page];
        if (!p) return;
        p.context.putImageData(new ImageData(rgba, this.size, this.size), slot.x, slot.y);
        p.base.update();
    }
    /** The page a slot is on, to paint part of it (at the slot's x, y) or read it back; call touch() after painting. */ context(slot) {
        return this.pages[slot.page]?.context;
    }
    /** Shows what was painted into a slot through context(), from the next frame. */ touch(slot) {
        this.pages[slot.page]?.base.update();
    }
    /** Gives a slot back (cleared, so a later piece starts from nothing). */ release(slot) {
        const p = this.pages[slot.page];
        if (!p) return;
        p.context.clearRect(slot.x, slot.y, this.size, this.size);
        p.base.update();
        p.free.push(slot.index);
    }
    /** Every slot given back and the pages freed (a frame later: the sprites using them go first). */ reset() {
        const old = this.pages;
        this.pages = [];
        setTimeout(()=>old.forEach((p)=>p.base.destroy()), 0);
    }
    get pageCount() {
        return this.pages.length;
    }
}


const $882231da9d46a555$export$11e945f77e7faba3 = {
    radius: 240,
    intensity: 0.85,
    falloff: 4,
    glow: 0.22
};
const $882231da9d46a555$export$3be67ca5d794e522 = ()=>{
    if (typeof window === "undefined") return $882231da9d46a555$export$11e945f77e7faba3;
    const w = window;
    if (w.organicTorch === undefined) w.organicTorch = $882231da9d46a555$export$11e945f77e7faba3;
    return w.organicTorch && typeof w.organicTorch === "object" ? w.organicTorch : $882231da9d46a555$export$11e945f77e7faba3;
};
const $882231da9d46a555$var$BUDGET_MS = 4;
/** Above every body (chips fly in front of the swinging miner), below the ADD glows. */ const $882231da9d46a555$var$CHIP_Z = 870000;
/** In the world surface, so the darkness mask still governs it; ADD so it only ever brightens. */ const $882231da9d46a555$var$GLOW_Z = 880001;
/** Rows per depth-sorted strip of a chunk's rim. */ const $882231da9d46a555$var$RIM_BAND = 8;
const $882231da9d46a555$var$toTint = (c)=>c[0] << 16 | c[1] << 8 | c[2];
const $882231da9d46a555$var$canvasOf = (w, h)=>{
    if (typeof document === "undefined") return undefined;
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    return canvas;
};
/** A soft white disc, tinted per use. */ let $882231da9d46a555$var$glowTexture;
const $882231da9d46a555$var$glow = ()=>{
    if ($882231da9d46a555$var$glowTexture) return $882231da9d46a555$var$glowTexture;
    const canvas = $882231da9d46a555$var$canvasOf(128, 128);
    const context = canvas?.getContext("2d");
    if (!canvas || !context) return $882231da9d46a555$var$glowTexture = (0, $klOfb.Texture).WHITE;
    const gradient = context.createRadialGradient(64, 64, 0, 64, 64, 64);
    gradient.addColorStop(0, "rgba(255,255,255,1)");
    gradient.addColorStop(0.35, "rgba(255,255,255,0.45)");
    gradient.addColorStop(1, "rgba(255,255,255,0)");
    context.fillStyle = gradient;
    context.fillRect(0, 0, 128, 128);
    return $882231da9d46a555$var$glowTexture = (0, $klOfb.Texture).from(canvas);
};
// ---------------------------------------------------------------- crystals, drawn as pixel art
const $882231da9d46a555$var$CRYSTAL = [
    [
        18,
        58,
        74
    ],
    [
        31,
        111,
        136
    ],
    [
        63,
        176,
        198
    ],
    [
        142,
        230,
        239
    ],
    [
        230,
        255,
        255
    ]
];
const $882231da9d46a555$var$CRYSTAL_W = 40, $882231da9d46a555$var$CRYSTAL_H = 44;
const $882231da9d46a555$var$fillPolygon = (rgba, w, h, points, c)=>{
    const xs = points.map((p)=>p[0]), ys = points.map((p)=>p[1]);
    for(let y = Math.max(0, Math.floor(Math.min(...ys))); y <= Math.min(h - 1, Math.ceil(Math.max(...ys))); y++)for(let x = Math.max(0, Math.floor(Math.min(...xs))); x <= Math.min(w - 1, Math.ceil(Math.max(...xs))); x++){
        let inside = false;
        const px = x + 0.5, py = y + 0.5;
        for(let i = 0, j = points.length - 1; i < points.length; j = i++){
            const [xi, yi] = points[i], [xj, yj] = points[j];
            if (yi > py !== yj > py && px < (xj - xi) * (py - yi) / (yj - yi) + xi) inside = !inside;
        }
        if (!inside) continue;
        const o = (y * w + x) * 4;
        rgba[o] = c[0];
        rgba[o + 1] = c[1];
        rgba[o + 2] = c[2];
        rgba[o + 3] = 255;
    }
};
const $882231da9d46a555$export$87ba22fc0ea665ac = (scale)=>{
    const rgba = new Uint8ClampedArray($882231da9d46a555$var$CRYSTAL_W * $882231da9d46a555$var$CRYSTAL_H * 4);
    const shards = [
        [
            -1,
            -0.08,
            30
        ],
        [
            -8,
            -0.55,
            20
        ],
        [
            6,
            0.45,
            18
        ],
        [
            -12,
            -1,
            12
        ],
        [
            11,
            0.9,
            11
        ]
    ];
    for (const [bx, angle, length] of shards){
        const L = length * scale, width = 4.2 * (0.6 + 0.4 * scale);
        const cx = $882231da9d46a555$var$CRYSTAL_W / 2 + bx * scale, cy = $882231da9d46a555$var$CRYSTAL_H - 4;
        const tx = cx + Math.sin(angle) * L, ty = cy - Math.cos(angle) * L;
        const nx = Math.cos(angle) * width, ny = Math.sin(angle) * width;
        const mx = cx + (tx - cx) * 0.72, my = cy + (ty - cy) * 0.72;
        const left = [
            [
                cx - nx,
                cy - ny
            ],
            [
                mx - nx,
                my - ny
            ],
            [
                tx,
                ty
            ],
            [
                cx,
                cy
            ]
        ];
        const right = [
            [
                cx,
                cy
            ],
            [
                tx,
                ty
            ],
            [
                mx + nx,
                my + ny
            ],
            [
                cx + nx,
                cy + ny
            ]
        ];
        $882231da9d46a555$var$fillPolygon(rgba, $882231da9d46a555$var$CRYSTAL_W, $882231da9d46a555$var$CRYSTAL_H, [
            ...left,
            ...right.slice(1)
        ], $882231da9d46a555$var$CRYSTAL[0]);
        $882231da9d46a555$var$fillPolygon(rgba, $882231da9d46a555$var$CRYSTAL_W, $882231da9d46a555$var$CRYSTAL_H, left.map(([x, y])=>[
                x + 0.8,
                y
            ]), $882231da9d46a555$var$CRYSTAL[3]);
        $882231da9d46a555$var$fillPolygon(rgba, $882231da9d46a555$var$CRYSTAL_W, $882231da9d46a555$var$CRYSTAL_H, right.map(([x, y])=>[
                x - 0.8,
                y
            ]), $882231da9d46a555$var$CRYSTAL[2]);
        const steps = Math.ceil(L);
        for(let i = 0; i <= steps; i++){
            const x = Math.round(cx + (tx - cx) * i / steps - 0.5), y = Math.round(cy + (ty - cy) * i / steps - 0.5);
            if (x < 0 || y < 0 || x >= $882231da9d46a555$var$CRYSTAL_W || y >= $882231da9d46a555$var$CRYSTAL_H) continue;
            const o = (y * $882231da9d46a555$var$CRYSTAL_W + x) * 4;
            rgba[o] = $882231da9d46a555$var$CRYSTAL[1][0];
            rgba[o + 1] = $882231da9d46a555$var$CRYSTAL[1][1];
            rgba[o + 2] = $882231da9d46a555$var$CRYSTAL[1][2];
            rgba[o + 3] = 255;
        }
        const gx = Math.round(mx - nx * 0.4 - 0.5), gy = Math.round(my - 0.5);
        if (gx >= 0 && gy >= 0 && gx < $882231da9d46a555$var$CRYSTAL_W && gy < $882231da9d46a555$var$CRYSTAL_H) {
            const o = (gy * $882231da9d46a555$var$CRYSTAL_W + gx) * 4;
            rgba[o] = $882231da9d46a555$var$CRYSTAL[4][0];
            rgba[o + 1] = $882231da9d46a555$var$CRYSTAL[4][1];
            rgba[o + 2] = $882231da9d46a555$var$CRYSTAL[4][2];
            rgba[o + 3] = 255;
        }
    }
    return rgba;
};
const $882231da9d46a555$var$textureFromPixels = (rgba, w, h)=>{
    const canvas = $882231da9d46a555$var$canvasOf(w, h);
    const context = canvas?.getContext("2d");
    if (!canvas || !context) return (0, $klOfb.Texture).EMPTY;
    context.putImageData(new ImageData(rgba, w, h), 0, 0);
    return (0, $klOfb.Texture).from(canvas);
};
class $882231da9d46a555$export$395ef1bf505a6c69 extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.cols = 0, this.rows = 0, this.codes = [], this.solidCells = new Uint8Array(0), this.damageCells = new Map(), this.poolsPx = [], this.removalVersion = -1, this.presentationVersion = -1, this.lavaCells = new Uint8Array(0), this.faceHeight = 36, this.chunks = new Map(), // Chunks and their rims that differ from the shared column texture, on shared canvas pages (a texture each, a cave
        // drew from a hundred of them and broke the batch at every sixteenth).
        this.slots = new (0, $3efef98b54376b50$export$cbb847030152319)((0, $f111aadd6a3e5d22$export$7aaeba3b59006fe)), this.bakeQueue = [], this.dirty = [], this.crystalSprites = [], this.crystalGlows = [], this.crystalLights = [], this.chipLayer = new (0, $8t5Gy.Container)(), this.chips = [], this.lastTick = 0, this.view = {
            solid: (cx, cy)=>cx < 0 || cy < 0 || cx >= this.cols || cy >= this.rows || this.solidCells[cy * this.cols + cx] === 1,
            ore: (cx, cy)=>(0, $db27c988dce6c705$export$aca16b4355ea8af8)(this.codes[cx]?.[cy]),
            dug: (cx, cy)=>(0, $db27c988dce6c705$export$7787969e753c67e2)(this.codes[cx]?.[cy]) && !this.view.solid(cx, cy),
            pocket: (cx, cy)=>this.codes[cx]?.[cy] === (0, $db27c988dce6c705$export$6aae37938a31c4be).Pocket,
            damage: (cx, cy)=>this.damageCells.get(cy * this.cols + cx) ?? 0,
            veinDistance: (px, py, material)=>{
                let best = Infinity;
                for (const vein of this.features?.veins ?? [])if (vein.material === material) best = Math.min(best, (0, $db27c988dce6c705$export$bcd9e57734e26fab)(px / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), py / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), vein.points) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                return best;
            },
            mouth: (cx, cy)=>this.codes[cx]?.[cy] === (0, $db27c988dce6c705$export$6aae37938a31c4be).Mouth,
            lava: (cx, cy)=>cx >= 0 && cy >= 0 && cx < this.cols && cy < this.rows && this.lavaCells[cy * this.cols + cx] === 1,
            pools: ()=>this.poolsPx
        }, /** Whether the rock stands at (x, y) right now, per the provider. */ this.standing = (x, y)=>{
            const code = this.codes[x]?.[y];
            if (!(0, $db27c988dce6c705$export$8c5d5ba2f2e41b84)(code)) return false;
            if (!(0, $db27c988dce6c705$export$7787969e753c67e2)(code)) return true;
            const tile = this.provider?.entityTileMap()?.[x]?.[y];
            return !!tile && tile !== "0";
        }, /** Once a frame, after the frame's map deltas are applied. `player` is where the torch glow goes. */ this.tick = (provider, player)=>{
            const layer = provider?.getOrganicRockLayer?.();
            if (!provider || !layer || !(0, $f111aadd6a3e5d22$export$bc9d9821b03db46f)().enabled) {
                if (this.roomId) this.reset();
                return;
            }
            if (provider !== this.provider || provider.roomId !== this.roomId) this.load(provider, layer);
            const version = provider.getRemovalVersion();
            if (version !== this.removalVersion) {
                this.removalVersion = version;
                this.refreshStanding();
            }
            // Lava arrives as map deltas (the LAVA campaign paints it into a tunnel when a pocket is broken).
            const presentation = provider.getPresentationVersion();
            if (presentation !== this.presentationVersion) {
                this.presentationVersion = presentation;
                this.refreshLava();
            }
            this.bake();
            this.updateTorchGlow(player);
            this.updateChips();
        }, this.load = (provider, layer)=>{
            this.reset();
            this.provider = provider;
            this.roomId = provider.roomId;
            this.cols = provider.width();
            this.rows = provider.height();
            this.codes = layer;
            this.features = provider.getOrganicCave?.();
            this.faceHeight = this.features?.faceHeight ?? (0, $f111aadd6a3e5d22$export$bc9d9821b03db46f)().faceHeight;
            this.poolsPx = (this.features?.pools ?? []).map((p)=>({
                    x: p.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: p.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    rx: p.rx * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    ry: p.ry * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                }));
            this.solidCells = new Uint8Array(this.cols * this.rows);
            for(let y = 0; y < this.rows; y++)for(let x = 0; x < this.cols; x++)this.solidCells[y * this.cols + x] = this.standing(x, y) ? 1 : 0;
            this.removalVersion = provider.getRemovalVersion();
            this.lavaCells = new Uint8Array(this.cols * this.rows);
            this.presentationVersion = -1;
            this.visible = true;
            const per = (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const reach = Math.ceil((0, $f111aadd6a3e5d22$export$4010b7a0984edab1) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) + 1;
            const across = Math.ceil(this.cols / per), down = Math.ceil(this.rows / per);
            for(let cy = 0; cy < down; cy++)for(let cx = 0; cx < across; cx++){
                const sprite = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).EMPTY);
                sprite.position.set(cx * (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe), cy * (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe));
                this.addChild(sprite);
                const key = `${cx},${cy}`;
                this.chunks.set(key, {
                    x: cx,
                    y: cy,
                    sprite: sprite
                });
                let uniform = true;
                for(let y = cy * per - reach; y < (cy + 1) * per + reach && uniform; y++){
                    for(let x = cx * per - reach; x < (cx + 1) * per + reach && uniform; x++)if (!this.view.solid(x, y)) uniform = false;
                }
                if (uniform) sprite.texture = this.uniformTexture();
                else this.bakeQueue.push(key);
            }
            this.placeCrystals();
        }, /** The column texture alone: what every chunk buried in solid rock looks like. */ this.uniformTexture = ()=>{
            if (this.uniform) return this.uniform;
            const solid = {
                ...this.view,
                solid: ()=>true,
                damage: ()=>0,
                ore: ()=>undefined,
                mouth: ()=>false,
                pools: ()=>[]
            };
            const rgba = (0, $f111aadd6a3e5d22$export$5cc313b50febd860)(solid, -(0, $f111aadd6a3e5d22$export$4010b7a0984edab1), -(0, $f111aadd6a3e5d22$export$4010b7a0984edab1), (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe) + 2 * (0, $f111aadd6a3e5d22$export$4010b7a0984edab1), (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe) + 2 * (0, $f111aadd6a3e5d22$export$4010b7a0984edab1), (0, $f111aadd6a3e5d22$export$4010b7a0984edab1), this.faceHeight);
            return this.uniform = $882231da9d46a555$var$textureFromPixels(rgba, (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe), (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe));
        }, this.refreshLava = ()=>{
            const provider = this.provider;
            if (!provider) return;
            for(let y = 0; y < this.rows; y++)for(let x = 0; x < this.cols; x++){
                const i = y * this.cols + x;
                const now = provider.isLavaAt(x, y) ? 1 : 0;
                if (now === this.lavaCells[i]) continue;
                this.lavaCells[i] = now;
                // Only the cell's own floor marks change.
                this.dirty.push({
                    x: x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    w: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    h: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                });
            }
        }, this.refreshStanding = ()=>{
            for(let y = 0; y < this.rows; y++)for(let x = 0; x < this.cols; x++){
                const i = y * this.cols + x;
                const now = this.standing(x, y) ? 1 : 0;
                if (now === this.solidCells[i]) continue;
                this.solidCells[i] = now;
                if (!now) this.damageCells.delete(i);
                this.dirty.push((0, $f111aadd6a3e5d22$export$474ad6f2c3eab985)(x, y, this.faceHeight));
            }
        }, /** A strike or a break on an organic cave's rock: cracks, chips. True when this layer took it. */ this.tileEffect = (effect)=>{
            if (!this.active || effect.entityTile !== "testore") return false;
            const cell = effect.mapRoughCoordinates;
            if (!cell) return true;
            const i = cell.y * this.cols + cell.x;
            const from = effect.strikeFrom;
            if (effect.effectType === "damage") {
                const hp = effect.hp, hpMax = effect.hpMax;
                const broken = hp !== undefined && hpMax ? 1 - hp / hpMax : Math.min(1, (this.damageCells.get(i) ?? 0) + 0.25);
                this.damageCells.set(i, Math.max(0, Math.min(1, broken)));
                this.dirty.push((0, $f111aadd6a3e5d22$export$474ad6f2c3eab985)(cell.x, cell.y, this.faceHeight));
                this.spawnChips(cell, from, 7, 1);
            } else if (effect.effectType === "destroy") {
                this.damageCells.delete(i);
                this.spawnChips(cell, from, 22, 1.6);
            }
            return true;
        }, /**
     * The breakable rock cell drawn at world point `at`, if any. The face is drawn inside its rock's own
     * cell, so the pixel's own cell is the one being pointed at.
     */ this.breakableCellAt = (at)=>{
            if (!this.active) return undefined;
            const x = Math.floor(at.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            // The pixel's own cell, or -- on a top's overhang -- the rock it overhangs from.
            for (const y of [
                Math.floor(at.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
                Math.floor((at.y + this.overhang()) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))
            ]){
                if ((0, $db27c988dce6c705$export$7787969e753c67e2)(this.codes[x]?.[y]) && this.standing(x, y)) return {
                    x: x,
                    y: y
                };
            }
            return undefined;
        }, /** Crystal lights for the darkness mask: shown only while the crystal is in the player's sight. */ this.lights = ()=>this.active ? this.crystalLights : [], // ------------------------------------------------------------ baking
        this.bake = ()=>{
            // A swing's repaint first and whole: it is small, and the player is looking at it.
            while(this.dirty.length)this.paintRect(this.dirty.shift());
            const start = performance.now();
            while(this.bakeQueue.length && performance.now() - start < $882231da9d46a555$var$BUDGET_MS){
                const chunk = this.chunks.get(this.bakeQueue.shift());
                if (chunk) this.paintRect({
                    x: chunk.x * (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe),
                    y: chunk.y * (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe),
                    w: (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe),
                    h: (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe)
                });
            }
        }, this.paintRect = (rect)=>{
            const x0 = Math.max(0, rect.x), y0 = Math.max(0, rect.y);
            const x1 = Math.min(this.cols * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), rect.x + rect.w), y1 = Math.min(this.rows * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), rect.y + rect.h);
            const w = x1 - x0, h = y1 - y0;
            if (w <= 0 || h <= 0) return;
            const overhang = this.overhang();
            const { base: base, topRim: topRim, faceRim: faceRim } = (0, $f111aadd6a3e5d22$export$1aaaff5ccbbb9ebd)(this.view, x0 - (0, $f111aadd6a3e5d22$export$4010b7a0984edab1), y0 - (0, $f111aadd6a3e5d22$export$4010b7a0984edab1), w + 2 * (0, $f111aadd6a3e5d22$export$4010b7a0984edab1), h + 2 * (0, $f111aadd6a3e5d22$export$4010b7a0984edab1), (0, $f111aadd6a3e5d22$export$4010b7a0984edab1), this.faceHeight, overhang);
            const image = new ImageData(base, w, h);
            const topImage = new ImageData(topRim, w, h), faceImage = new ImageData(faceRim, w, h);
            for(let cy = Math.floor(y0 / (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe)); cy * (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe) < y1; cy++)for(let cx = Math.floor(x0 / (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe)); cx * (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe) < x1; cx++){
                const chunk = this.chunks.get(`${cx},${cy}`);
                if (!chunk) continue;
                const own = this.ownSlot(chunk);
                const context = own && this.slots.context(own);
                if (!own || !context) continue;
                const ox = cx * (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe), oy = cy * (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe);
                const sx = Math.max(x0, ox), sy = Math.max(y0, oy);
                const ex = Math.min(x1, ox + (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe)), ey = Math.min(y1, oy + (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe));
                // Into the chunk's slot only: the dirty rectangle never leaves the chunk.
                context.putImageData(image, own.x + x0 - ox, own.y + y0 - oy, sx - x0, sy - y0, ex - sx, ey - sy);
                this.slots.touch(own);
                // The top's rows stand `overhang` px further south than they are drawn (where their rock really is).
                chunk.topRim = this.paintRim(chunk, chunk.topRim, overhang, topImage, x0 - ox, y0 - oy, sx - x0, sy - y0, ex - sx, ey - sy);
                chunk.faceRim = this.paintRim(chunk, chunk.faceRim, 0, faceImage, x0 - ox, y0 - oy, sx - x0, sy - y0, ex - sx, ey - sy);
            }
        }, /**
     * Copy a repaint's rim into the chunk's rim canvas and show exactly the bands that now hold any of it. The
     * bands live in the world surface, not this layer, so each sorts against bodies by the bottom of its rows.
     */ this.paintRim = (chunk, plane, lift, image, dx, dy, sx, sy, sw, sh)=>{
            const surface = this.parent;
            if (!surface) return plane;
            if (!plane) {
                const slot = this.slots.claim();
                if (!slot) return plane;
                const base = slot.texture.baseTexture;
                plane = {
                    slot: slot,
                    bands: Array.from({
                        length: (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe) / $882231da9d46a555$var$RIM_BAND
                    }, (_, band)=>{
                        const sprite = new (0, $7Bs2Z.Sprite)(new (0, $klOfb.Texture)(base, new (0, $6qzqq.Rectangle)(slot.x, slot.y + band * $882231da9d46a555$var$RIM_BAND, (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe), $882231da9d46a555$var$RIM_BAND)));
                        sprite.position.set(chunk.x * (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe), chunk.y * (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe) + band * $882231da9d46a555$var$RIM_BAND);
                        sprite.zIndex = 100 + chunk.y * (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe) + (band + 1) * $882231da9d46a555$var$RIM_BAND + lift;
                        sprite.visible = false;
                        surface.addChild(sprite);
                        return sprite;
                    })
                };
            }
            const context = this.slots.context(plane.slot);
            if (!context) return plane;
            const { x: px, y: py } = plane.slot;
            context.putImageData(image, px + dx, py + dy, sx, sy, sw, sh);
            this.slots.touch(plane.slot);
            for(let band = Math.floor((dy + sy) / $882231da9d46a555$var$RIM_BAND); band * $882231da9d46a555$var$RIM_BAND < dy + sy + sh && band < plane.bands.length; band++){
                const rows = context.getImageData(px, py + band * $882231da9d46a555$var$RIM_BAND, (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe), $882231da9d46a555$var$RIM_BAND).data;
                let any = false;
                for(let i = 3; i < rows.length && !any; i += 4)if (rows[i]) any = true;
                plane.bands[band].visible = any;
                plane.bands[band].zIndex = 100 + chunk.y * (0, $f111aadd6a3e5d22$export$7aaeba3b59006fe) + (band + 1) * $882231da9d46a555$var$RIM_BAND + lift;
            }
            return plane;
        }, this.overhang = ()=>{
            const live = (0, $f111aadd6a3e5d22$export$bc9d9821b03db46f)().overhang;
            return Number.isFinite(live) ? Math.max(0, live) : 16;
        }, /**
     * A chunk's own picture, made the first time anything in it differs from the shared column texture: a slot on the
     * layer's shared pages (a canvas each, a cave's chunks and rims were a hundred textures breaking every batch).
     */ this.ownSlot = (chunk)=>{
            if (chunk.slot) return chunk.slot;
            const slot = this.slots.claim();
            const context = slot && this.slots.context(slot);
            if (!slot || !context) return undefined;
            const source = this.uniformTexture().baseTexture.resource?.source;
            if (source) context.drawImage(source, slot.x, slot.y);
            this.slots.touch(slot);
            chunk.slot = slot;
            chunk.sprite.texture = slot.texture;
            return slot;
        }, // ------------------------------------------------------------ crystals, torch, chips
        this.placeCrystals = ()=>{
            const surface = this.parent;
            if (!surface) return;
            surface.addChild(this.chipLayer);
            (this.features?.crystals ?? []).forEach((crystal, i)=>{
                const x = crystal.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y = crystal.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                const sprite = new (0, $7Bs2Z.Sprite)($882231da9d46a555$var$textureFromPixels($882231da9d46a555$export$87ba22fc0ea665ac(crystal.scale), $882231da9d46a555$var$CRYSTAL_W, $882231da9d46a555$var$CRYSTAL_H));
                sprite.anchor.set(0.5, ($882231da9d46a555$var$CRYSTAL_H - 4) / $882231da9d46a555$var$CRYSTAL_H);
                sprite.position.set(x, y);
                sprite.zIndex = 100 + y;
                surface.addChild(sprite);
                this.crystalSprites.push(sprite);
                const halo = new (0, $7Bs2Z.Sprite)($882231da9d46a555$var$glow());
                halo.anchor.set(0.5);
                halo.position.set(x, y - 12);
                halo.scale.set((70 + 50 * crystal.scale) / 64);
                halo.tint = 0x0aa6ff;
                halo.alpha = 0.5;
                halo.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
                halo.zIndex = $882231da9d46a555$var$GLOW_Z;
                surface.addChild(halo);
                this.crystalGlows.push(halo);
                this.crystalLights.push({
                    entityId: `organic-crystal:${this.roomId}:${i}`,
                    location: {
                        x: x,
                        y: y - 8
                    },
                    radius: Math.round(90 + 70 * crystal.scale),
                    intensity: 0.7,
                    sightGated: true
                });
            });
        }, this.updateTorchGlow = (player)=>{
            const torch = $882231da9d46a555$export$3be67ca5d794e522();
            if (!player || !this.parent || !torch.glow) {
                if (this.torchGlow) this.torchGlow.visible = false;
                return;
            }
            if (!this.torchGlow) {
                this.torchGlow = new (0, $7Bs2Z.Sprite)($882231da9d46a555$var$glow());
                this.torchGlow.anchor.set(0.5);
                this.torchGlow.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
                this.torchGlow.tint = 0xff5a10;
                this.torchGlow.zIndex = $882231da9d46a555$var$GLOW_Z;
            }
            if (this.torchGlow.parent !== this.parent) this.parent.addChild(this.torchGlow);
            this.torchGlow.visible = true;
            this.torchGlow.alpha = torch.glow;
            this.torchGlow.scale.set(torch.radius / 64);
            this.torchGlow.position.set(player.x, player.y - 16);
        }, /** Rock chips off the struck face, thrown back toward whoever struck it. */ this.spawnChips = (cell, from, count, force)=>{
            if (!this.chipLayer.parent && this.parent) this.parent.addChild(this.chipLayer);
            const faceX = (cell.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const foot = (cell.y + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const away = from ? Math.sign(from.x - faceX) || 0 : 0;
            const toward = from ? Math.sign(from.y - foot) : 1;
            for(let k = 0; k < count; k++){
                const sprite = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).WHITE);
                const size = Math.random() < 0.3 ? 2 : 1;
                sprite.width = size + (Math.random() < 0.2 ? 1 : 0);
                sprite.height = size;
                sprite.tint = $882231da9d46a555$var$toTint((0, $f111aadd6a3e5d22$export$22ccd2f254618968)[3 + Math.floor(Math.random() * 4)]);
                sprite.position.set(faceX + (Math.random() - 0.5) * 22, foot - 6 - Math.random() * 22);
                this.chipLayer.addChild(sprite);
                this.chips.push({
                    sprite: sprite,
                    vx: (away * 0.6 + (Math.random() - 0.5) * 1.6) * 70 * force,
                    vy: (-0.6 - Math.random() * 0.9) * 90 * force + (toward > 0 ? 20 : 0),
                    ground: foot + 2 + Math.random() * 14 * force,
                    life: 0.6 + Math.random() * 0.6 * force,
                    age: 0
                });
            }
        }, this.updateChips = ()=>{
            const now = performance.now();
            const dt = this.lastTick ? Math.min(0.05, (now - this.lastTick) / 1000) : 0.016;
            this.lastTick = now;
            if (!this.chips.length) return;
            this.chips = this.chips.filter((chip)=>{
                chip.age += dt;
                if (chip.age >= chip.life) {
                    chip.sprite.destroy();
                    return false;
                }
                if (chip.sprite.y < chip.ground || chip.vy < 0) {
                    chip.vy += 520 * dt;
                    chip.sprite.x += chip.vx * dt;
                    chip.sprite.y = Math.min(chip.ground, chip.sprite.y + chip.vy * dt);
                    if (chip.sprite.y >= chip.ground && chip.vy > 0) {
                        chip.vy = -chip.vy * 0.25;
                        chip.vx *= 0.5;
                        if (Math.abs(chip.vy) < 30) chip.vy = 0;
                    }
                }
                chip.sprite.alpha = Math.min(1, (chip.life - chip.age) / 0.25);
                return true;
            });
        }, // ------------------------------------------------------------ lifecycle
        this.reset = ()=>{
            this.chunks.forEach((chunk)=>{
                chunk.sprite.destroy();
                for (const plane of [
                    chunk.topRim,
                    chunk.faceRim
                ])plane?.bands.forEach((band)=>band.destroy({
                        texture: true
                    }));
            });
            this.chunks.clear();
            this.slots.reset();
            this.bakeQueue = [];
            this.dirty = [];
            this.damageCells.clear();
            this.crystalSprites.forEach((sprite)=>sprite.destroy({
                    texture: true,
                    baseTexture: true
                }));
            this.crystalSprites = [];
            this.crystalGlows.forEach((sprite)=>sprite.destroy());
            this.crystalGlows = [];
            this.crystalLights = [];
            this.chips.forEach((chip)=>chip.sprite.destroy());
            this.chips = [];
            if (this.torchGlow) this.torchGlow.visible = false;
            this.provider = undefined;
            this.roomId = undefined;
            this.codes = [];
            this.visible = false;
        };
        this.zIndex = 0.4 // above every ground tile layer (0), below floor-opening edges (0.5) and every body
        ;
        this.interactiveChildren = false;
        this.chipLayer.zIndex = $882231da9d46a555$var$CHIP_Z;
        this.chipLayer.interactiveChildren = false;
        this.visible = false;
    }
    /** True in an organic cave. */ get active() {
        return !!this.roomId;
    }
    destroy(options) {
        this.reset();
        this.uniform?.destroy(true);
        this.uniform = undefined;
        this.torchGlow?.destroy();
        this.chipLayer.destroy({
            children: true
        });
        super.destroy(options);
    }
}





parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $P8XPi = parcelRequire("P8XPi");


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $P8XPi = parcelRequire("P8XPi");
const $d9c682be559f7d89$export$567a44a77f893138 = {
    scorch: 0x140a05,
    coal: 0x2b1408,
    rust: 0x8d3a12,
    ember: 0xff6d22,
    flame: 0xffa13b,
    gold: 0xffd287,
    hot: 0xfff2d2,
    white: 0xffffff,
    // For ADDITIVE layers only. `ember` has enough green in it that adding it to grass lands on
    // lime -- an Ember Core blast over the camp lawn came out looking radioactive. Additive blending
    // adds channels, so the hot colour has to be starved of everything the ground already has.
    blaze: 0xff3d08
};
// Where the art sits in the composite's local space, which is WORLD PIXELS: the LPC frame is 64x64
// placed at (-32,-32) with no scale, so one unit here is one world pixel and (0,0) is the entity's
// own location.
//
// EVERY NUMBER BELOW WAS MEASURED OFF THE RUNNING GAME. Two earlier passes reasoned about it instead
// and both landed the core on the character's face: the first borrowed the Bonecaller's channel
// offsets, which live in the OVERLAY surface's space and are roughly twice this scale, and the
// second assumed the origin sat at the hip. On a standing LPC humanoid in THIS space the soles land
// near y=+26 and the hair line near y=-16, which puts the origin around the shoulders. The other
// anchor worth knowing is the player ring (player_ring.ts): a player's ground footprint is 27x12.5.
const $d9c682be559f7d89$var$FOOT_Y = 26;
// Chest height -- below the origin, not above it.
const $d9c682be559f7d89$var$CORE_Y = 4;
// The ground dial, sized just outside the player ring's footprint so it reads as this character's
// own patch of ground. Squash is what makes a circle lie down in this game's projection.
const $d9c682be559f7d89$var$DIAL_R = 13;
const $d9c682be559f7d89$var$SQUASH = 0.46;
// How long the lock-in flash lasts. Short: it is a punctuation mark, not a state.
const $d9c682be559f7d89$var$LOCK_FLASH_MS = 220;
const $d9c682be559f7d89$var$FADE_OUT_MS = 250;
// Sparks pulled in out of the air, and motes lifted off the ground.
const $d9c682be559f7d89$var$SPARKS = 3;
const $d9c682be559f7d89$var$MOTES = 4;
class $d9c682be559f7d89$export$7610bd9a23b10f42 extends (0, $gwPoJ.Graphics) {
    constructor(){
        super(), /**
     * The floor half of the effect. The owner must put this UNDER the body -- LpcComposite inserts
     * it at child index 0 -- and destroy it alongside this object; it is a sibling, not a child, so
     * that the sprite can sort between the two.
     */ this.ground = new (0, $gwPoJ.Graphics)(), this.receivedAt = 0, this.lockedAt = 0, this.draw = (view, now = Date.now())=>{
            if (view !== this.view) {
                if (!view && this.view) this.fadeStartedAt = now;
                this.view = view;
                this.receivedAt = now;
            }
            if (!view) {
                this.lockedId = undefined;
                // Keep the last charge frame intact as both sibling layers fade together.
                const remaining = this.fadeStartedAt === undefined ? 0 : Math.max(0, Math.min(1, 1 - (now - this.fadeStartedAt) / $d9c682be559f7d89$var$FADE_OUT_MS));
                this.alpha = this.ground.alpha = remaining * remaining;
                this.visible = this.ground.visible = remaining > 0;
                if (!remaining) {
                    this.clear();
                    this.ground.clear();
                    this.fadeStartedAt = undefined;
                }
                return;
            }
            this.fadeStartedAt = undefined;
            this.alpha = this.ground.alpha = 1;
            this.visible = this.ground.visible = true;
            this.clear();
            this.ground.clear();
            const progress = Math.max(0, Math.min(1, 1 - (view.remainingMs - now + this.receivedAt) / view.durationMs));
            const armed = progress >= 1;
            if (!armed || this.lockedId !== view.id) {
                if (armed) {
                    this.lockedId = view.id;
                    this.lockedAt = now;
                } else if (this.lockedId === view.id) // A fresh message can walk progress back a frame; it must not re-fire the flash.
                this.lockedId = undefined;
            }
            const flash = armed && this.lockedId === view.id ? Math.max(0, 1 - (now - this.lockedAt) / $d9c682be559f7d89$var$LOCK_FLASH_MS) : 0;
            this.drawPool(progress, armed, now);
            this.drawDial(progress, armed, flash, now);
            this.drawMotes(progress, now);
            this.drawCore(progress, armed, flash, now);
            this.drawSparks(progress, armed, now);
        }, /** Scorched ground under the caster: a dark bruise with heat bleeding out of it. */ this.drawPool = (progress, armed, now)=>{
            const g = this.ground;
            const r = $d9c682be559f7d89$var$DIAL_R * (0.55 + 0.45 * progress);
            g.lineStyle(0);
            g.beginFill($d9c682be559f7d89$export$567a44a77f893138.scorch, 0.06 + 0.13 * progress);
            g.drawEllipse(0, $d9c682be559f7d89$var$FOOT_Y, r * 1.5, r * 1.5 * $d9c682be559f7d89$var$SQUASH);
            g.endFill();
            g.beginFill($d9c682be559f7d89$export$567a44a77f893138.ember, 0.1 + 0.22 * progress + (armed ? 0.06 * Math.sin(now / 110) : 0));
            g.drawEllipse(0, $d9c682be559f7d89$var$FOOT_Y, r, r * $d9c682be559f7d89$var$SQUASH);
            g.endFill();
            g.beginFill($d9c682be559f7d89$export$567a44a77f893138.flame, 0.08 + 0.2 * progress);
            g.drawEllipse(0, $d9c682be559f7d89$var$FOOT_Y, r * 0.5, r * 0.5 * $d9c682be559f7d89$var$SQUASH);
            g.endFill();
        }, /**
     * The dial, lying flat on the ground. A cold iron backing ring, the heated arc burning around
     * it from due north, a travelling head spark, and tick marks that light as the arc passes.
     *
     * Armed closes the circle: the geometry changes, not just the colour.
     */ this.drawDial = (progress, armed, flash, now)=>{
            const g = this.ground;
            const start = -Math.PI / 2;
            g.lineStyle(1.4, $d9c682be559f7d89$export$567a44a77f893138.coal, 0.6);
            this.groundArc($d9c682be559f7d89$var$DIAL_R, start, start + Math.PI * 2);
            if (armed) {
                g.lineStyle(3.5, $d9c682be559f7d89$export$567a44a77f893138.flame, 0.25 + 0.45 * flash);
                this.groundArc($d9c682be559f7d89$var$DIAL_R, start, start + Math.PI * 2);
                g.lineStyle(1.5, $d9c682be559f7d89$export$567a44a77f893138.gold, 0.9);
                this.groundArc($d9c682be559f7d89$var$DIAL_R, start, start + Math.PI * 2);
            } else {
                const end = start + Math.PI * 2 * progress;
                // A wide dim pass under a narrow bright one: a fake bloom, since filters are off the
                // table here (one Graphics per charging entity, on budget hardware).
                g.lineStyle(4, $d9c682be559f7d89$export$567a44a77f893138.rust, 0.3);
                this.groundArc($d9c682be559f7d89$var$DIAL_R, start, end);
                g.lineStyle(1.8, $d9c682be559f7d89$export$567a44a77f893138.flame, 0.85);
                this.groundArc($d9c682be559f7d89$var$DIAL_R, start, end);
                g.lineStyle(0);
                g.beginFill($d9c682be559f7d89$export$567a44a77f893138.gold, 0.95);
                g.drawCircle(Math.cos(end) * $d9c682be559f7d89$var$DIAL_R, $d9c682be559f7d89$var$FOOT_Y + Math.sin(end) * $d9c682be559f7d89$var$DIAL_R * $d9c682be559f7d89$var$SQUASH, 1.6);
                g.endFill();
            }
            for(let i = 0; i < 8; i++){
                const a = start + i * Math.PI / 4;
                const lit = armed || a <= start + Math.PI * 2 * progress;
                g.lineStyle(1.2, lit ? $d9c682be559f7d89$export$567a44a77f893138.gold : $d9c682be559f7d89$export$567a44a77f893138.coal, lit ? 0.8 : 0.4);
                g.moveTo(Math.cos(a) * ($d9c682be559f7d89$var$DIAL_R - 2), $d9c682be559f7d89$var$FOOT_Y + Math.sin(a) * ($d9c682be559f7d89$var$DIAL_R - 2) * $d9c682be559f7d89$var$SQUASH);
                g.lineTo(Math.cos(a) * ($d9c682be559f7d89$var$DIAL_R + 2), $d9c682be559f7d89$var$FOOT_Y + Math.sin(a) * ($d9c682be559f7d89$var$DIAL_R + 2) * $d9c682be559f7d89$var$SQUASH);
            }
            if (flash > 0) {
                g.lineStyle(2 * flash, $d9c682be559f7d89$export$567a44a77f893138.hot, flash * 0.7);
                this.groundArc($d9c682be559f7d89$var$DIAL_R + 7 * (1 - flash), start, start + Math.PI * 2);
            }
        }, /** Embers lifted off the pool and drawn up toward the core: where the power is coming FROM. */ this.drawMotes = (progress, now)=>{
            this.lineStyle(0);
            for(let i = 0; i < $d9c682be559f7d89$var$MOTES; i++){
                const rise = (now / (560 - 220 * progress) + i / $d9c682be559f7d89$var$MOTES) % 1;
                const x = Math.sin(now / 340 + i * 2.3) * $d9c682be559f7d89$var$DIAL_R * 0.8 * (1 - rise);
                const y = $d9c682be559f7d89$var$FOOT_Y - rise * ($d9c682be559f7d89$var$FOOT_Y - $d9c682be559f7d89$var$CORE_Y);
                this.beginFill(rise > 0.6 ? $d9c682be559f7d89$export$567a44a77f893138.gold : $d9c682be559f7d89$export$567a44a77f893138.blaze, (0.3 + 0.5 * progress) * (1 - rise * 0.4));
                this.drawCircle(x, y, 0.7 + 1.0 * (1 - rise));
                this.endFill();
            }
        }, /** The charge itself, gathering at the chest. Three shells so it has an edge and a hot centre. */ this.drawCore = (progress, armed, flash, now)=>{
            const breath = armed ? 1 + 0.1 * Math.sin(now / 95) : 1;
            const r = (0.8 + 2.6 * progress) * breath;
            this.lineStyle(0);
            // Four shells, each smaller and hotter. The white is kept to the innermost one: a wide pale
            // fill is what turned the first pass into a featureless cream disc with no centre to it.
            this.beginFill($d9c682be559f7d89$export$567a44a77f893138.blaze, (0.1 + 0.2 * progress) * breath);
            this.drawCircle(0, $d9c682be559f7d89$var$CORE_Y, r * 2.6);
            this.endFill();
            this.beginFill($d9c682be559f7d89$export$567a44a77f893138.blaze, 0.35 + 0.4 * progress);
            this.drawCircle(0, $d9c682be559f7d89$var$CORE_Y, r * 1.7);
            this.endFill();
            this.beginFill($d9c682be559f7d89$export$567a44a77f893138.flame, 0.55 + 0.3 * progress);
            this.drawCircle(0, $d9c682be559f7d89$var$CORE_Y, r * 1.05);
            this.endFill();
            this.beginFill(armed ? $d9c682be559f7d89$export$567a44a77f893138.hot : $d9c682be559f7d89$export$567a44a77f893138.gold, 0.9);
            this.drawCircle(0, $d9c682be559f7d89$var$CORE_Y, r * 0.5);
            this.endFill();
            if (flash > 0) {
                this.beginFill($d9c682be559f7d89$export$567a44a77f893138.gold, flash * 0.5);
                this.drawCircle(0, $d9c682be559f7d89$var$CORE_Y, r + 11 * (1 - flash));
                this.endFill();
            }
        }, /**
     * Sparks spiralling in. Their radius collapses with progress, so the hold has a visible target:
     * the shot is ready when they arrive. Armed stops the spiral dead and holds them in a triangle
     * -- motion stopping is a louder signal than motion speeding up.
     */ this.drawSparks = (progress, armed, now)=>{
            const r = armed ? 10 : 20 - 10 * progress;
            for(let i = 0; i < $d9c682be559f7d89$var$SPARKS; i++){
                const a = (armed ? 0 : now / 260) + i * (Math.PI * 2 / $d9c682be559f7d89$var$SPARKS);
                const x = Math.cos(a) * r, y = $d9c682be559f7d89$var$CORE_Y + Math.sin(a) * r * 0.75;
                // A head and a tail, both thin: fat marks on an additive layer stop being sparks and
                // start being white pills stuck to the character.
                this.lineStyle(0.9, $d9c682be559f7d89$export$567a44a77f893138.flame, armed ? 0.8 : 0.3 + 0.45 * progress);
                this.moveTo(x, y);
                this.lineTo(x - Math.cos(a) * 5 - Math.sin(a) * 3, y - (Math.sin(a) * 5 - Math.cos(a) * 3) * 0.75);
                this.lineStyle(0);
                this.beginFill(armed ? $d9c682be559f7d89$export$567a44a77f893138.hot : $d9c682be559f7d89$export$567a44a77f893138.gold, armed ? 0.95 : 0.5 + 0.45 * progress);
                this.drawCircle(x, y, armed ? 0.9 : 0.6 + 0.5 * progress);
                this.endFill();
            }
        }, /** An arc flattened into the ground plane. Pixi's own arc() is a circle; this one lies down. */ this.groundArc = (r, a0, a1)=>{
            const span = a1 - a0;
            if (Math.abs(span) < 1e-4) return;
            const steps = Math.max(2, Math.ceil(Math.abs(span) / 0.2));
            for(let i = 0; i <= steps; i++){
                const a = a0 + span * i / steps;
                const x = Math.cos(a) * r, y = $d9c682be559f7d89$var$FOOT_Y + Math.sin(a) * r * $d9c682be559f7d89$var$SQUASH;
                if (i === 0) this.ground.moveTo(x, y);
                else this.ground.lineTo(x, y);
            }
        };
        this.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
    }
    destroy(options) {
        this.ground.destroy(options);
        super.destroy(options);
    }
}



/**
 * An Ember Core charge, from the muzzle to the crater. Three acts.
 *
 *   FLIGHT -- a molten capsule trailing fire, with a shadow running along the ground under it. The
 *     shadow is what sells the height; without it a bright dot slides across the floor.
 *   FUSE -- the 350ms the player has to read the danger and get out of it. This is the only part of
 *     the effect with a job beyond looking good, so it is built around ONE promise: the bright ring
 *     is exactly the circle the server will damage. A collapsing inner ring counts the fuse down
 *     inside it, and the strobe quickens as the time runs out.
 *   BLAST -- flash, shockwave, a torn fireball, flung embers. Over in 350ms, because the next thing
 *     the player needs to see is what survived.
 *
 * TWO LAYERS, AND THE REASON IS THE WHOLE LOOK OF IT. `glow` is an ADDITIVE child; the base Graphics
 * is normal. Fire has to be additive. Built as one normal-blend Graphics, every hot colour was just
 * a translucent orange wash over green grass, and the result read as a dust cloud with a grey ring
 * round it -- pale khaki polygons, not an explosion. Additive orange over ANY ground goes yellow and
 * then white where it piles up, which is what fire does. So: anything that emits light goes on
 * `glow`, and only things that block it -- the capsule's ground shadow, the smoke afterwards, the
 * dark backing under the warning ring -- stay on the base layer.
 *
 * NOTHING DARK OUTLIVES THE BLAST. The server deletes the projectile the instant the blast phase
 * ends, so any mark still painted on the final frame does not fade, it pops. An early version held a
 * scorch ellipse at full strength through the blast and it read as a shadow appearing after the
 * explosion and then vanishing. A crater that genuinely lingers would have to outlive the entity,
 * which means a ground-decal owner this effect does not have.
 *
 * AUTHORITATIVE GEOMETRY IS NEVER SQUASHED. The server's hit test is a true circle in world x/y
 * (ChargedWeapons.detonate), so the warning ring and the shockwave are true circles too. Only the
 * decorative ground art is flattened into the projection. A player standing just outside the ring
 * they can see has to actually be safe.
 *
 * All timing is relative: the server's remainingMs is re-anchored to local time on every message and
 * interpolated down between them. No clock sync, and no timer that can outlive the room.
 */ // The capsule flies this far above the ground point the server tracks. Its shadow stays on the
// ground, so the gap between them is the only cue for how high the shot is.
const $b7bc9eb1ec41b826$var$FLIGHT_LIFT = 13;
// How long the muzzle flash burns after the shot leaves. It is drawn at the ORIGIN, not on the
// moving projectile -- a flash that travels with the shell is a comet, not a discharge.
const $b7bc9eb1ec41b826$var$MUZZLE_MS = 190;
// Flung debris: count, and how far past the blast rim the furthest piece gets.
const $b7bc9eb1ec41b826$var$DEBRIS = 16;
const $b7bc9eb1ec41b826$var$DEBRIS_REACH = 1.45;
// Tongues around the fireball's edge. Prime-ish against DEBRIS so the two scatters never line up.
const $b7bc9eb1ec41b826$var$TONGUES = 14;
// Where the ground splits under a burning fuse. Uneven on purpose: evenly spaced spokes draw a
// wagon wheel. Five, not six, for the same reason.
const $b7bc9eb1ec41b826$var$CRACK_ANGLES = [
    0.35,
    1.5,
    2.55,
    3.7,
    5.2
];
/** Deterministic per-shot scatter: same shot draws the same debris every frame, no stored arrays. */ const $b7bc9eb1ec41b826$var$scatter = (seed)=>{
    const x = Math.sin(seed * 127.1 + 311.7) * 43758.5453;
    return x - Math.floor(x);
};
class $b7bc9eb1ec41b826$export$f02207558548248d extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(entity){
        super(), /** Everything that emits light. Additive, so fire over grass goes hot instead of muddy. */ this.glow = new (0, $gwPoJ.Graphics)(), this.receivedAt = 0, this.spawnedAt = 0, this.origin = {
            x: 0,
            y: 0
        }, this.at = {
            x: 0,
            y: 0
        }, // Smoothed travel direction, for the trail. Derived from successive positions rather than sent:
        // the server already publishes the path, and re-deriving it costs nothing.
        this.heading = {
            x: 1,
            y: 0
        }, this.announced = {
            fired: false,
            landed: false,
            detonated: false
        }, /**
     * The discharge, left behind at the muzzle. Drawn in the projectile's local space by offsetting
     * back to the origin, so it stays welded to the spot the shot was fired from while the shell
     * that carries this Graphics flies away from it.
     */ this.drawMuzzleFlash = (now)=>{
            const life = 1 - (now - this.spawnedAt) / $b7bc9eb1ec41b826$var$MUZZLE_MS;
            if (life <= 0) return;
            const g = this.glow;
            const x = this.origin.x - this.at.x, y = this.origin.y - this.at.y - 8;
            const fade = life * life;
            g.lineStyle(0);
            g.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).ember, 0.35 * fade);
            g.drawCircle(x, y, 10 + 26 * (1 - life));
            g.endFill();
            g.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).flame, 0.5 * fade);
            g.drawCircle(x, y, 5 + 13 * (1 - life));
            g.endFill();
            g.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).hot, 0.8 * fade);
            g.drawCircle(x, y, 2 + 5 * (1 - life));
            g.endFill();
            // Four spits of flame thrown back out of the housing, along the firing line.
            g.lineStyle(2 * life, (0, $d9c682be559f7d89$export$567a44a77f893138).flame, 0.6 * fade);
            for(let i = 0; i < 4; i++){
                const spread = (i - 1.5) * 0.42;
                const dx = this.heading.x * Math.cos(spread) - this.heading.y * Math.sin(spread);
                const dy = this.heading.x * Math.sin(spread) + this.heading.y * Math.cos(spread);
                const reach = (10 + 20 * (1 - life)) * (0.6 + 0.4 * $b7bc9eb1ec41b826$var$scatter(i * 7 + 1));
                g.moveTo(x, y);
                g.lineTo(x + dx * reach, y + dy * reach);
            }
        }, /** The capsule: shadow on the floor, fire behind it, molten shell, white-hot centre. */ this.drawCapsule = (phase, progress, now)=>{
            const g = this.glow;
            const flying = phase === "flight";
            // On the ground the shell settles, flattens and beats faster as the fuse burns down.
            const beat = flying ? 1 : 1 + 0.16 * Math.sin(now / (70 - 35 * progress));
            const lift = flying ? $b7bc9eb1ec41b826$var$FLIGHT_LIFT : 5;
            const r = (flying ? 6 : 6.5) * beat;
            // The one thing here that blocks light rather than emitting it, so it stays off the glow.
            this.lineStyle(0);
            this.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).scorch, flying ? 0.3 : 0.38);
            this.drawEllipse(0, 2, r * 1.25, r * 0.5);
            this.endFill();
            g.lineStyle(0);
            if (flying) {
                // The trail: three shrinking, dimming puffs laid back down the flight line, plus loose
                // sparks shedding sideways. Cheaper and steadier than a particle pool, and it cannot
                // leak when the room tears down mid-flight.
                for(let i = 1; i <= 3; i++){
                    const back = i * 9;
                    const t = 1 - i / 4;
                    g.beginFill(i === 1 ? (0, $d9c682be559f7d89$export$567a44a77f893138).flame : (0, $d9c682be559f7d89$export$567a44a77f893138).blaze, 0.4 * t);
                    g.drawCircle(-this.heading.x * back, -this.heading.y * back - lift + i, r * (1.05 - 0.2 * i) + Math.sin(now / 50 + i) * 0.8);
                    g.endFill();
                }
                for(let i = 0; i < 4; i++){
                    const age = (now / 150 + $b7bc9eb1ec41b826$var$scatter(i * 31 + 3)) % 1;
                    const back = 6 + age * 26;
                    const side = ($b7bc9eb1ec41b826$var$scatter(i * 17 + 5) - 0.5) * 16 * age;
                    g.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).gold, 0.8 * (1 - age));
                    g.drawCircle(-this.heading.x * back - this.heading.y * side, -this.heading.y * back + this.heading.x * side - lift + age * 6, 1.6 * (1 - age) + 0.4);
                    g.endFill();
                }
            }
            g.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).blaze, 0.34);
            g.drawCircle(0, -lift, r * 2.4 + Math.sin(now / 65) * 1.5);
            g.endFill();
            g.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).blaze, 0.6);
            g.drawCircle(0, -lift, r * 1.35);
            g.endFill();
            g.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).flame, 0.9);
            g.drawCircle(0, -lift, r * 0.85);
            g.endFill();
            g.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).hot, 1);
            g.drawCircle(0, -lift - r * 0.2, r * 0.42);
            g.endFill();
        }, /**
     * The warning. The outer ring is the server's blast radius, exactly; everything else is drawn
     * inside it.
     *
     * Three independent reads of the same countdown, because one of them will be the one a given
     * player notices: the ring STROBES faster as the fuse runs out, an inner ring COLLAPSES from the
     * rim to the centre, and light CRACKS outward through the ground until it reaches the edge.
     *
     * The rim is drawn twice: a dark line on the base layer and a hot one on the glow. The dark pass
     * is what keeps it legible on pale ground (sand, the camp's trodden dirt, cave rock), where an
     * additive line alone washes out -- the same trick the player ring plays with its contour.
     */ this.drawFuse = (view, progress, now)=>{
            const g = this.glow;
            const r = view.radius;
            // Strobe period falls from about 190ms to 60ms across the fuse.
            const strobe = 0.5 + 0.5 * Math.sin(now / (30 - 20 * progress));
            this.lineStyle(0);
            this.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).scorch, 0.05 + 0.1 * progress);
            this.drawEllipse(0, 0, r, r * 0.52);
            this.endFill();
            this.lineStyle(4, (0, $d9c682be559f7d89$export$567a44a77f893138).scorch, 0.4);
            this.drawCircle(0, 0, r);
            g.lineStyle(0);
            g.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).blaze, 0.09 + 0.12 * progress);
            g.drawCircle(0, 0, r);
            g.endFill();
            // Cracks reaching for the rim. Flattened into the ground plane: these are in the dirt.
            // Deliberately NOT evenly spaced and deliberately an odd number -- six at 60 degrees drew a
            // wagon wheel, which is the same trap the Bonecaller's grave mark documents.
            for(let i = 0; i < $b7bc9eb1ec41b826$var$CRACK_ANGLES.length; i++){
                const a = $b7bc9eb1ec41b826$var$CRACK_ANGLES[i];
                const reach = r * progress;
                g.lineStyle(1.3 + 1.1 * $b7bc9eb1ec41b826$var$scatter(i * 19 + 2), (0, $d9c682be559f7d89$export$567a44a77f893138).blaze, 0.45 + 0.45 * progress);
                g.moveTo(0, 0);
                for(let step = 1; step <= 3; step++){
                    const t = step / 3, wobble = Math.sin(i * 5.1 + step * 2.3) * 0.26 * (1 - t);
                    g.lineTo(Math.cos(a + wobble) * reach * t, Math.sin(a + wobble) * reach * t * 0.75);
                }
            }
            // The collapsing fuse ring.
            g.lineStyle(2, (0, $d9c682be559f7d89$export$567a44a77f893138).gold, 0.5 + 0.4 * progress);
            g.drawCircle(0, 0, r * (1 - progress));
            // The damage edge: a wide dim halo under a hard bright line, both at exactly `radius`.
            g.lineStyle(7, (0, $d9c682be559f7d89$export$567a44a77f893138).blaze, 0.24 + 0.3 * strobe);
            g.drawCircle(0, 0, r);
            g.lineStyle(2.5, (0, $d9c682be559f7d89$export$567a44a77f893138).gold, 0.7 + 0.3 * strobe);
            g.drawCircle(0, 0, r);
            g.lineStyle(0);
            for(let i = 0; i < 12; i++){
                const a = i * Math.PI / 6 + now / 1400;
                g.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).hot, 0.5 + 0.5 * strobe);
                g.drawCircle(Math.cos(a) * r, Math.sin(a) * r, 1.8);
                g.endFill();
            }
        }, /**
     * A ragged ring of points at `radius`, for one shell of the fireball. Every shell uses the same
     * generator with a different seed so they tear in different places, and the same seed gives the
     * same shape on every frame -- the fireball grows, it does not boil.
     */ this.tongues = (radius, seed)=>{
            const points = [];
            for(let i = 0; i < $b7bc9eb1ec41b826$var$TONGUES; i++){
                const a = i * Math.PI * 2 / $b7bc9eb1ec41b826$var$TONGUES;
                const reach = radius * (0.78 + 0.42 * $b7bc9eb1ec41b826$var$scatter(i * 13 + seed));
                points.push(Math.cos(a) * reach, Math.sin(a) * reach);
            }
            return points;
        }, /**
     * Detonation, in one pass over four overlapping lives: a flash that is gone in the first fifth,
     * a shockwave that overruns the damage edge, a fireball torn into tongues, and debris thrown past
     * the rim. Smoke comes in underneath as the light goes, and is the only dark thing here.
     */ this.drawBlast = (view, progress, now)=>{
            const g = this.glow;
            const r = view.radius;
            const fade = 1 - progress;
            const ease = 1 - (1 - progress) ** 3;
            g.lineStyle(0);
            // Fireball, torn rather than round. A plain circle is what made the old blast read as a
            // bubble; the radial noise is what makes it read as fire coming apart.
            const body = r * (0.26 + 0.44 * ease);
            // An OPAQUE heart first, on the base layer. Additive alone is a tint -- you could read the
            // grass and a haystack straight through the middle of the fireball, which is the one place
            // fire is least transparent. This is what the glow then blooms out of.
            //
            // It is small and it dies early, by design. Held at full strength into the second half of
            // the blast it stopped being a core and became a flat yellow sticker with visible polygon
            // facets sitting on top of the glow.
            const heart = Math.max(0, 1 - progress / 0.5) ** 1.3;
            if (heart > 0) {
                this.lineStyle(0);
                this.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).flame, 0.9 * heart);
                this.drawPolygon(this.tongues(body * 0.42, 50));
                this.endFill();
            }
            for (const [scale, color, alpha] of [
                [
                    1.3,
                    (0, $d9c682be559f7d89$export$567a44a77f893138).blaze,
                    0.34
                ],
                [
                    1.0,
                    (0, $d9c682be559f7d89$export$567a44a77f893138).blaze,
                    0.5
                ],
                [
                    0.66,
                    (0, $d9c682be559f7d89$export$567a44a77f893138).flame,
                    0.55
                ],
                [
                    0.34,
                    (0, $d9c682be559f7d89$export$567a44a77f893138).gold,
                    0.6
                ]
            ]){
                g.beginFill(color, alpha * fade);
                g.drawPolygon(this.tongues(body * scale, scale * 100));
                g.endFill();
            }
            // Shockwave. Expands past the damage edge on purpose -- the ring that MATTERED was the fuse
            // warning, and this one is the aftermath, so overrunning it reads as force rather than lying
            // about reach.
            const wave = r * (0.25 + 1.0 * ease);
            g.lineStyle(11 * fade, (0, $d9c682be559f7d89$export$567a44a77f893138).blaze, 0.34 * fade);
            g.drawCircle(0, 0, wave);
            g.lineStyle(2.5 * fade + 0.5, (0, $d9c682be559f7d89$export$567a44a77f893138).hot, 0.9 * fade);
            g.drawCircle(0, 0, wave);
            // The flash: enormous, white, and gone by a fifth of the way through.
            const flash = Math.max(0, 1 - progress / 0.2);
            if (flash > 0) {
                g.lineStyle(0);
                g.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).blaze, 0.6 * flash);
                g.drawCircle(0, 0, r * (0.5 + 0.55 * (1 - flash)));
                g.endFill();
                g.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).hot, 0.9 * flash);
                g.drawCircle(0, 0, r * 0.34 * flash + 7);
                g.endFill();
            }
            // Debris, thrown out and arcing down. Seeded per index, so it is the same throw every frame.
            g.lineStyle(0);
            for(let i = 0; i < $b7bc9eb1ec41b826$var$DEBRIS; i++){
                const a = i * Math.PI * 2 / $b7bc9eb1ec41b826$var$DEBRIS + $b7bc9eb1ec41b826$var$scatter(i * 3 + 11) * 0.4;
                const speed = 0.55 + 0.45 * $b7bc9eb1ec41b826$var$scatter(i * 5 + 23);
                const travel = r * $b7bc9eb1ec41b826$var$DEBRIS_REACH * speed * ease;
                const hop = Math.sin(Math.min(1, progress / speed) * Math.PI) * 16 * speed;
                g.beginFill($b7bc9eb1ec41b826$var$scatter(i * 9 + 7) > 0.6 ? (0, $d9c682be559f7d89$export$567a44a77f893138).hot : (0, $d9c682be559f7d89$export$567a44a77f893138).flame, fade);
                g.drawCircle(Math.cos(a) * travel, Math.sin(a) * travel * 0.85 - hop, (0.9 + 1.6 * $b7bc9eb1ec41b826$var$scatter(i * 11 + 3)) * fade);
                g.endFill();
            }
            // Smoke, last and lowest contrast: it is what is left when the light has gone. The only dark
            // shape in the blast, and it has to be gone by progress 1 -- see the note at the top.
            if (progress > 0.4) {
                const smoke = (progress - 0.4) / 0.6;
                this.lineStyle(0);
                for(let i = 0; i < 3; i++){
                    const a = i * 2.094 + 0.7;
                    this.beginFill((0, $d9c682be559f7d89$export$567a44a77f893138).coal, 0.26 * smoke * (1 - smoke) * 4);
                    this.drawCircle(Math.cos(a) * r * 0.3 * smoke, Math.sin(a) * r * 0.2 * smoke - 16 * smoke, r * (0.12 + 0.18 * smoke));
                    this.endFill();
                }
            }
        };
        this.glow.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.addChild(this.glow);
        this.spawnedAt = Date.now();
        this.origin = {
            ...entity.location
        };
        this.at = {
            ...entity.location
        };
        this.doMovement(entity);
    }
    getYOffset() {
        return 0;
    }
    doMovement(entity) {
        const view = entity?.areaProjectile;
        const now = Date.now();
        if (view !== this.view) {
            this.view = view;
            this.receivedAt = now;
        }
        if (entity) {
            const dx = entity.location.x - this.at.x, dy = entity.location.y - this.at.y;
            const moved = Math.hypot(dx, dy);
            if (moved > 0.5) this.heading = {
                x: dx / moved,
                y: dy / moved
            };
            this.at = {
                ...entity.location
            };
        }
        this.clear();
        this.glow.clear();
        if (!view) return;
        const remaining = Math.max(0, view.remainingMs - now + this.receivedAt);
        const progress = view.durationMs ? Math.max(0, Math.min(1, 1 - remaining / view.durationMs)) : 1;
        if (!this.announced.fired) {
            this.announced.fired = true;
            (0, $c934a91f663d6020$export$7485d82cd17991cf).fired(this.origin, view.appearance);
        }
        if (view.phase !== "flight" && !this.announced.landed) {
            this.announced.landed = true;
            (0, $c934a91f663d6020$export$7485d82cd17991cf).landed(this.at, view.appearance);
        }
        if (view.phase === "blast" && !this.announced.detonated) {
            this.announced.detonated = true;
            (0, $c934a91f663d6020$export$7485d82cd17991cf).detonated(this.at, view.appearance);
        }
        if (view.appearance === "bomb") {
            if (view.phase === "blast") this.drawBlast(view, progress, now);
            else {
                if (view.phase === "flight" && view.destination) {
                    const x = view.destination.x - this.at.x, y = view.destination.y - this.at.y;
                    this.lineStyle(2, 0xffba55, 0.85);
                    this.drawCircle(x, y, view.radius);
                }
                // The location is the ground point; only the iron bomb rises along the lob.
                const lift = view.phase === "flight" ? (0, $ecfe6790c484f97d$export$c9a7b72071b071a6)(view.flightProgress || 0) : 0;
                this.lineStyle(0);
                this.beginFill(0x000000, 0.3);
                this.drawEllipse(0, 0, 7, 3);
                this.endFill();
                if (view.phase === "fuse") this.drawFuse(view, progress, now);
                (0, $6b36cb767b4a8ec4$export$b779cd893e8948bb)(this, 0, -lift - 4, now, view.phase === "fuse" && Math.floor(now / 100) % 2 === 0);
            }
            return;
        }
        if (view.phase === "blast") {
            this.drawBlast(view, progress, now);
            return;
        }
        this.drawMuzzleFlash(now);
        if (view.phase === "fuse") this.drawFuse(view, progress, now);
        this.drawCapsule(view.phase, progress, now);
    }
}




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

parcelRequire("1avo5");
var $3YyWq = parcelRequire("3YyWq");
var $gwPoJ = parcelRequire("gwPoJ");
// THE GROUND HALO: "this body, right there, needs you."
//
// The ember roster already answers "is anybody in trouble?" -- it is a docked strip with a red chip
// on it. The question the strip cannot answer is the one you have while standing in the camp looking
// at six people milling around a fire: WHICH of them, and is it worth walking over. This is the
// answer to that, and only to that.
//
// Division of labour, which is the whole reason this is as plain as it is:
//
//   the role glyph (avatar_hud)  what this person's JOB is          -- permanent, above the head
//   the roster pill              WHAT is wrong with them            -- a word, in the strip
//   this halo                    WHICH body it is wrong with        -- in the world, under the feet
//
// So the halo carries no information beyond "this one, and how badly". It never needs to be read,
// only noticed, which is what lets it be quiet enough to leave on all the time.
//
// WHY THE GROUND. The lane above the head is full -- the role glyph lives there permanently, with
// the nameplate, the HP meter, the sigil, the interaction pointer and chat bubbles all sharing its
// ~20px and a hand-tuned z-order. Ground level is free, never occludes a neighbour, and a camp with
// four members in trouble still parses; four more floating icons would not.
//
// NOT AN OUTLINE GLOW: that vocabulary is the hover highlight's ("you can act on this right now").
// Not a stroked ellipse either -- a thin cool-toned ring under the feet already means "a real player
// is driving this body" (see PlayerRing). This is a soft FILLED disc in a warm alarm colour, which
// is a different enough shape and hue that the two can't be confused. They also can never co-occur:
// memberStatus() returns undefined for the `player` and `lord` roles, so only members and visitors
// ever wear a halo, and only players ever wear a ring.
//
// ONE HUE, TWO INTENSITIES. The obvious design is the roster's own amber for a warning and red for an
// alarm, and it fails exactly where it has to work: the trouble happens AT THE FIRE and AT THE CHEST,
// and amber on firelit trodden dirt is nearly invisible. So severity is carried by alpha and by how
// deeply the halo breathes, not by colour, and the one colour is the roster's alarm red -- the same
// number, so a red chip in the strip and a red floor in the world are legibly one fact.
// Geometry in the sprite's own 64x64 art space, anchored by the sprite on the same foot line the
// shadow and the player ring use. A little wider than the ring so it reads as its own mark rather
// than as a fattened one.
const $83feb2ed45960f8f$var$CORE_RX = 15;
const $83feb2ed45960f8f$var$CORE_RY = 7;
// The softness, faked with a second larger fill at a fraction of the alpha. NOT a blur filter: a
// per-entity filter allocates a render target per body, which is exactly the kind of thing that
// costs frames on the low-end machines this game targets.
const $83feb2ed45960f8f$var$HALO_RX = 20;
const $83feb2ed45960f8f$var$HALO_RY = 9.5;
const $83feb2ed45960f8f$var$HALO_ALPHA_SHARE = 0.45;
// The roster's own ALARM red (roster_status.ts), restated rather than imported: sprites must not
// depend on gui (the import cycle the role glyph's emoji are duplicated to avoid). Keep in sync.
const $83feb2ed45960f8f$var$ALARM_RED = 0xff5959;
// The selection green. In the roster's palette green is the FORAGER's colour, which would normally
// rule it out -- but only ever ONE body wears this disc at a time, and it appears exactly when the
// player has just tapped a card, so there is no moment at which it could be read as a role. Nothing
// else in the ground vocabulary is green (the player ring is cool blue, the problem disc red), so
// "green circle under someone" can only mean "the card you are looking at is this person".
const $83feb2ed45960f8f$var$SELECTED_GREEN = 0x7be08a;
const $83feb2ed45960f8f$export$a8309c3ae59d215e = {
    enabled: true,
    color: $83feb2ed45960f8f$var$ALARM_RED,
    selectedColor: $83feb2ed45960f8f$var$SELECTED_GREEN,
    scale: 1,
    // Hungry, on its way to the chest of its own accord: nothing is being lost yet, so this is barely
    // there -- you notice it when you look at the camp, not while you are looking away from it.
    warn: {
        alpha: 0.2,
        depth: 0.07,
        periodMs: 1800
    },
    // Stuck, starving at an empty chest, or standing there with no job: the camp loses this member if
    // the player does nothing. Still not a flash -- twice as present, and breathing visibly faster.
    alarm: {
        alpha: 0.38,
        depth: 0.15,
        periodMs: 1100
    },
    // The roster's selected card, answering "which of these people is that card" -- so it is DEAD
    // STILL (depth 0). The two red tiers breathe because something is wrong and is getting worse;
    // this is a standing fact about which body the player just pointed at, and a selection that
    // pulsed would read as a third alarm. `periodMs` is unused at depth 0 but must stay non-zero,
    // since the breath divides by it.
    selected: {
        alpha: 0.4,
        depth: 0,
        periodMs: 1000
    }
};
let $83feb2ed45960f8f$var$tuning = {
    ...$83feb2ed45960f8f$export$a8309c3ae59d215e
};
const $83feb2ed45960f8f$export$38745b0122a0320e = ()=>$83feb2ed45960f8f$var$tuning;
const $83feb2ed45960f8f$export$85fddcd6696f461 = {
    awaitingOrders: "alarm",
    needsFood: "alarm",
    needsJob: "alarm",
    hungry: "warn",
    wantsFood: "alarm"
};
const $83feb2ed45960f8f$export$fbb2216c6674afa7 = (status)=>status ? $83feb2ed45960f8f$export$85fddcd6696f461[status] : undefined;
// Every halo currently on screen, so console tuning repaints what is already there instead of only
// reaching members who walk into view afterwards. Entries leave in dispose().
const $83feb2ed45960f8f$var$liveHalos = new Set();
// ONE CLOCK FOR THE WHOLE CAMP, so every halo breathes in step -- two members in trouble beating
// against each other reads as two separate alarms rather than one camp needing attention (the same
// reason the roster's cards share a single `pulseMs`). It is also one ticker callback for the room
// instead of one per troubled body: the halos only read this phase, they never drive it.
let $83feb2ed45960f8f$var$phaseMs = 0;
let $83feb2ed45960f8f$var$ticking = false;
const $83feb2ed45960f8f$var$advancePhase = ()=>{
    // Ticker.shared.deltaMS is wall-clock, so the breath keeps its period through a frame-rate dip
    // instead of slowing down with the renderer.
    $83feb2ed45960f8f$var$phaseMs += (0, $3YyWq.Ticker).shared.deltaMS;
    $83feb2ed45960f8f$var$liveHalos.forEach((halo)=>halo.applyPhase());
};
// Started by the first halo that actually lights up and stopped when the last one goes dark, so a
// room with nothing wrong in it carries no per-frame work at all.
const $83feb2ed45960f8f$var$ensureTicking = ()=>{
    if (!$83feb2ed45960f8f$var$ticking) {
        (0, $3YyWq.Ticker).shared.add($83feb2ed45960f8f$var$advancePhase);
        $83feb2ed45960f8f$var$ticking = true;
    }
};
const $83feb2ed45960f8f$var$stopTickingIfIdle = ()=>{
    if ($83feb2ed45960f8f$var$ticking && !Array.from($83feb2ed45960f8f$var$liveHalos).some((halo)=>halo.isLit())) {
        (0, $3YyWq.Ticker).shared.remove($83feb2ed45960f8f$var$advancePhase);
        $83feb2ed45960f8f$var$ticking = false;
    }
};
const $83feb2ed45960f8f$export$17763425a8cc2c18 = (tier, atMs = $83feb2ed45960f8f$var$phaseMs)=>0.5 + 0.5 * Math.cos(atMs / tier.periodMs * Math.PI * 2);
const $83feb2ed45960f8f$export$580faa3cc96dd8 = (next)=>{
    const patch = typeof next === "boolean" ? {
        enabled: next
    } : next || {};
    $83feb2ed45960f8f$var$tuning = {
        ...$83feb2ed45960f8f$var$tuning,
        ...patch,
        warn: {
            ...$83feb2ed45960f8f$var$tuning.warn,
            ...patch.warn || {}
        },
        alarm: {
            ...$83feb2ed45960f8f$var$tuning.alarm,
            ...patch.alarm || {}
        },
        selected: {
            ...$83feb2ed45960f8f$var$tuning.selected,
            ...patch.selected || {}
        }
    };
    $83feb2ed45960f8f$var$liveHalos.forEach((halo)=>halo.redraw());
    return $83feb2ed45960f8f$var$tuning;
};
const $83feb2ed45960f8f$export$2cfc725035d0e5bc = ()=>$83feb2ed45960f8f$export$580faa3cc96dd8({
        ...$83feb2ed45960f8f$export$a8309c3ae59d215e
    });
class $83feb2ed45960f8f$export$3fa5036cf9319808 extends (0, $gwPoJ.Graphics) {
    constructor(){
        super();
        this.visible = false;
        $83feb2ed45960f8f$var$liveHalos.add(this);
    }
    isLit() {
        return this.tier !== undefined;
    }
    /** Light the halo at a tier, or pass nothing to put it out. */ setTier(tier) {
        if (this.tier === tier) return;
        this.tier = tier;
        if (!tier) {
            this.visible = false;
            $83feb2ed45960f8f$var$stopTickingIfIdle();
            return;
        }
        this.redraw();
        $83feb2ed45960f8f$var$ensureTicking();
        // Land on the current phase immediately rather than at the next frame, so a halo that lights
        // up never shows a single frame at the wrong opacity.
        this.applyPhase();
    }
    redraw() {
        this.visible = $83feb2ed45960f8f$var$tuning.enabled && this.tier !== undefined;
        if (!this.visible) return;
        const wanted = this.tier === "selected" ? $83feb2ed45960f8f$var$tuning.selectedColor : $83feb2ed45960f8f$var$tuning.color;
        if (this.drawnColor !== wanted) this.drawGeometry();
        this.applyPhase();
    }
    drawGeometry() {
        this.clear();
        const { scale: scale } = $83feb2ed45960f8f$var$tuning;
        const color = this.tier === "selected" ? $83feb2ed45960f8f$var$tuning.selectedColor : $83feb2ed45960f8f$var$tuning.color;
        // Outer bloom first, then the core on top of it: two flat fills whose overlap reads as a
        // soft edge. Both are drawn at full opacity and the whole Graphics is faded by `alpha`, so
        // the breath is a single property write.
        this.beginFill(color, $83feb2ed45960f8f$var$HALO_ALPHA_SHARE);
        this.drawEllipse(0, 0, $83feb2ed45960f8f$var$HALO_RX * scale, $83feb2ed45960f8f$var$HALO_RY * scale);
        this.endFill();
        this.beginFill(color, 1);
        this.drawEllipse(0, 0, $83feb2ed45960f8f$var$CORE_RX * scale, $83feb2ed45960f8f$var$CORE_RY * scale);
        this.endFill();
        this.drawnColor = color;
    }
    /** Set this frame's opacity from the shared phase. The only thing the breath touches. */ applyPhase() {
        if (!this.tier || !this.visible) return;
        const tier = $83feb2ed45960f8f$var$tuning[this.tier];
        this.alpha = tier.alpha + tier.depth * ($83feb2ed45960f8f$export$17763425a8cc2c18(tier) * 2 - 1);
    }
    // Decoration must never resize the thing it decorates. A renderable derives its on-screen y from
    // its own measured height (BaseRenderable.getYOffset reads `this.height`, a bounds query over
    // every child), so a halo that widened those bounds would nudge the very body it marks. Same
    // reasoning as PlayerRing and the hover outline's BoundlessContainer.
    calculateBounds() {
        this._bounds.clear();
    }
    // Drop the live-tuning registration. The owning sprite calls this from its cleanup, which runs on
    // a paperdoll REBUILD as well as on teardown -- and a rebuild is the common case here, because
    // the hungry brain swap re-stamps appearance -- so without this the set would grow by one entry
    // per rebuild and the shared ticker would never be able to stop.
    dispose() {
        $83feb2ed45960f8f$var$liveHalos.delete(this);
        $83feb2ed45960f8f$var$stopTickingIfIdle();
    }
    destroy(options) {
        this.dispose();
        super.destroy(options);
    }
}
const $83feb2ed45960f8f$export$425b1004859d3908 = ()=>{
    $83feb2ed45960f8f$var$phaseMs = 0;
};
const $83feb2ed45960f8f$export$5676150e74a27da2 = ()=>{
    Array.from($83feb2ed45960f8f$var$liveHalos).forEach((halo)=>halo.dispose());
    $83feb2ed45960f8f$export$425b1004859d3908();
};
// Browser-console tuning, in the same shape as window.playerRing / window.spriteShadow:
//
//     statusHalo = false                          // off
//     statusHalo = { scale: 1.4 }                 // wider footprint
//     statusHalo = { warn: { alpha: 0.35 } }      // make the quiet tier more present
//     statusHalo = { alarm: { periodMs: 2000 } }  // calm the alarm's breath down
//     statusHalo                                  // read the active values back
//
// Guarded so it is a no-op in the Node test harness.
if (typeof window !== "undefined") Object.defineProperty(window, "statusHalo", {
    get: ()=>$83feb2ed45960f8f$var$tuning,
    set: (next)=>{
        console.log("[statusHalo]", $83feb2ed45960f8f$export$580faa3cc96dd8(next));
    },
    configurable: true
});




parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $d3fD1 = parcelRequire("d3fD1");
var $7Bs2Z = parcelRequire("7Bs2Z");

var $5UG8I = parcelRequire("5UG8I");



parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
const $85a39b5d41a16ed9$export$15d4c1eea10d6840 = (artBounds)=>{
    let x1 = -(0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
    let y1 = -(0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.15;
    let x2 = x1 + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    let y2 = y1 + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    // Union in the art so objects drawn larger/taller/offset from one tile (the campfire, whose
    // sprite is centered via the "-texture.width/2" shift) get a region that matches what you see.
    if (artBounds && artBounds.width > 0 && artBounds.height > 0) {
        x1 = Math.min(x1, artBounds.x);
        y1 = Math.min(y1, artBounds.y);
        x2 = Math.max(x2, artBounds.x + artBounds.width);
        y2 = Math.max(y2, artBounds.y + artBounds.height);
    }
    return new (0, $6qzqq.Rectangle)(x1, y1, x2 - x1, y2 - y1);
};





parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $8t5Gy = parcelRequire("8t5Gy");
var $7Bs2Z = parcelRequire("7Bs2Z");

parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $klOfb = parcelRequire("klOfb");
class $78ff247413a98680$export$a8fe3fe3f52dcb5 {
    constructor(size = 2048, gap = 2){
        this.size = size;
        this.gap = gap;
        this.pages = [];
        this.transform = new (0, $6qzqq.Matrix)();
    }
    /**
     * Renders `art` (its local area `region`) into a page and returns that piece of the page; undefined when it is
     * bigger than a page, for the caller to give it a texture of its own.
     */ put(renderer, art, region) {
        const width = Math.ceil(region.width), height = Math.ceil(region.height);
        if (!width || !height || width + this.gap > this.size || height + this.gap > this.size) return undefined;
        // A stand-in renderer (tests) that cannot draw into a page: the caller makes its own texture as before.
        if (typeof renderer?.render !== "function" || !renderer.gl) return undefined;
        // A page someone destroyed (a texture freed with its base): its pieces are gone; start another.
        if (this.pages.length && this.pages[this.pages.length - 1].texture.baseTexture.destroyed) this.pages.pop();
        let page = this.pages[this.pages.length - 1];
        const fits = (p)=>{
            if (p.x + width + this.gap > this.size) {
                p.x = 0;
                p.y += p.shelf;
                p.shelf = 0;
            }
            return p.y + height + this.gap <= this.size;
        };
        // Never draw a page into itself: art sampling the page it would land on is a feedback loop on the GPU.
        if (page && $78ff247413a98680$var$samples(art, page.texture.baseTexture)) return undefined;
        if (!page || !fits(page)) {
            page = {
                texture: (0, $klOfb.RenderTexture).create({
                    width: this.size,
                    height: this.size
                }),
                x: 0,
                y: 0,
                shelf: 0
            };
            this.pages.push(page);
        }
        const x = page.x + this.gap, y = page.y + this.gap;
        this.transform.set(1, 0, 0, 1, x - region.x, y - region.y);
        renderer.render(art, {
            renderTexture: page.texture,
            clear: false,
            transform: this.transform
        });
        page.x += width + this.gap;
        page.shelf = Math.max(page.shelf, height + this.gap);
        return new (0, $klOfb.Texture)(page.texture.baseTexture, new (0, $6qzqq.Rectangle)(x, y, width, height));
    }
    get pageCount() {
        return this.pages.length;
    }
}
/** Whether any sprite in `art` draws from `base`. */ const $78ff247413a98680$var$samples = (art, base)=>{
    const node = art;
    if (node.texture?.baseTexture === base) return true;
    return !!node.children?.some((child)=>$78ff247413a98680$var$samples(child, base));
};
const $78ff247413a98680$export$af455fad27ad1f9f = new $78ff247413a98680$export$a8fe3fe3f52dcb5();
const $78ff247413a98680$export$d356f62a11a0ce0d = new $78ff247413a98680$export$a8fe3fe3f52dcb5();


class $86e9e05f3ebc1d8f$export$171acc6ba80afe2 {
    static{
        this.instance = new $86e9e05f3ebc1d8f$export$171acc6ba80afe2();
    }
    static{
        this.textureCache = new Map();
    }
    static{
        this.compositeTileSpriteBounds = new Map();
    }
    static{
        this.generation = 0;
    }
    constructor(){
        this.extract = (tilemapMetaProvider, tilesetId, compositeTileId)=>{
            if ($86e9e05f3ebc1d8f$export$171acc6ba80afe2.generation !== (0, $1f08f7b8f85adf9e$export$dd4554ad7431ed50)()) {
                $86e9e05f3ebc1d8f$export$171acc6ba80afe2.generation = (0, $1f08f7b8f85adf9e$export$dd4554ad7431ed50)();
                // Drop memoized references, not textures: visible sprites may still own the old art.
                $86e9e05f3ebc1d8f$export$171acc6ba80afe2.textureCache.clear();
                $86e9e05f3ebc1d8f$export$171acc6ba80afe2.compositeTileSpriteBounds.clear();
            }
            const parentTileSet = tilemapMetaProvider.getTilesetById(tilesetId);
            const compositeTileMeta = tilemapMetaProvider.resolveCompositeTileIdTileMeta(compositeTileId, tilesetId);
            if (!compositeTileMeta) return null;
            const fullTileId = `${parentTileSet.tilesetId}-${compositeTileId}`;
            let texture = $86e9e05f3ebc1d8f$export$171acc6ba80afe2.textureCache.get(fullTileId);
            // Only reuse a cached texture that is still valid. A DESTROYED texture (orig === null, or a
            // destroyed baseTexture) can linger in this module-level static cache -- e.g. left behind
            // across an HMR reload by code that used to evict+destroy these -- and handing it to a Sprite
            // crashes Pixi in calculateVertices/containsPoint ("Cannot read properties of null (reading
            // 'width')"). If the cached entry is stale, fall through and regenerate it below.
            if (texture && texture.orig && !texture.baseTexture?.destroyed) return texture;
            const { width: width } = parentTileSet;
            const children = compositeTileMeta.children || [];
            const bounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(0, 0, 0, 0);
            const childBounds = children.map((childTileMeta)=>{
                const tileNumber = childTileMeta.tileNumber - 1;
                const tileSetX = tileNumber % width;
                const tileSetY = Math.floor(tileNumber / width);
                const childBounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(tileSetX, tileSetY, tileSetX + 1, tileSetY + 1);
                return childBounds;
            });
            bounds.widen(childBounds);
            const xx = bounds.x1;
            const yy = bounds.y1;
            bounds.translate(-bounds.x1, -bounds.y1);
            $86e9e05f3ebc1d8f$export$171acc6ba80afe2.compositeTileSpriteBounds.set(fullTileId, bounds);
            const rect = new (0, $6qzqq.Rectangle)(0, 0, bounds.width * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), bounds.height * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            const containingSprite = new (0, $8t5Gy.Container)();
            children.forEach((childTileMeta)=>{
                const tileId = `${childTileMeta.tileNumber}`;
                const tileNumber = childTileMeta.tileNumber - 1;
                const tileSetX = tileNumber % width - xx;
                const tileSetY = Math.floor(tileNumber / width) - yy;
                const subtileSprite = new (0, $7Bs2Z.Sprite)((0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(`${parentTileSet.tilesetId}-${tileId}`));
                subtileSprite.x = tileSetX * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 0;
                subtileSprite.y = tileSetY * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 0;
                containingSprite.addChild(subtileSprite);
            });
            // Drawn into a shared page (render_texture_atlas.ts) so a storey's composites batch together; one too big for a
            // page gets a texture of its own.
            const renderer = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer;
            texture = (0, $78ff247413a98680$export$af455fad27ad1f9f).put(renderer, containingSprite, rect) ?? renderer.generateTexture(containingSprite, {
                region: rect
            });
            containingSprite.destroy({
                children: true
            });
            $86e9e05f3ebc1d8f$export$171acc6ba80afe2.textureCache.set(fullTileId, texture);
            return texture;
        };
    }
}




const $fbecd757e266ba04$export$8a3aa865a6e9fc80 = 22;
const $fbecd757e266ba04$export$c5dfed2bbbcb21c8 = 20;
const $fbecd757e266ba04$export$24848c281071b86e = 15000;
const $fbecd757e266ba04$export$2d347b3a779dba49 = (character, baseMs)=>character.trim() === "," ? baseMs * 12 : character.trim() === "." ? baseMs * 24 : baseMs;
const $fbecd757e266ba04$export$1e680ea44e7c243c = (message)=>Math.max(1500, message.split(" ").length * 187.5);
const $fbecd757e266ba04$export$600441c905c32b09 = (message, hold = false)=>{
    const lines = (0, $a80d0b17b615d6f7$export$edde49207b897324)(message, $fbecd757e266ba04$export$8a3aa865a6e9fc80);
    const revealMs = lines.reduce((total, line)=>total + line.slice(0, -1).split("").reduce((sum, char)=>sum + $fbecd757e266ba04$export$2d347b3a779dba49(char, $fbecd757e266ba04$export$c5dfed2bbbcb21c8), 0), 0) + Math.max(0, lines.length - 1);
    // The fade uses 100 timer steps; browsers clamp nested timers to at least 4ms.
    // Allow a small margin for network/render scheduling before admitting another speaker.
    return revealMs + (hold ? $fbecd757e266ba04$export$24848c281071b86e : $fbecd757e266ba04$export$1e680ea44e7c243c(message) + 400) + 250;
};


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");

parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
const $658a44ce960354bb$export$611f5967b7e8b685 = 0x3d2e20;
const $658a44ce960354bb$export$c2ea448b59bcc1de = 0x120d0a;
const $658a44ce960354bb$export$e969f1546e2d24ca = 0x15120d;
const $658a44ce960354bb$export$dd27ce85ad53c944 = 0x8e7b58;
const $658a44ce960354bb$export$6b1db5e247c0ce0 = 0xd9b483;
const $658a44ce960354bb$export$319b6132a2fafb7c = 0xffd166;
const $658a44ce960354bb$export$8eb3a98fbc1bd246 = 0xffedc7;
const $658a44ce960354bb$export$c48687f662ce7e97 = 0xa08c6c;
const $658a44ce960354bb$export$f73e3f59ba72192a = 0x0f120c;
const $658a44ce960354bb$export$82dbffd75f7d6df3 = 0x241b10;
const $658a44ce960354bb$export$f0510412e0d12cd1 = 0x4a3f30;
const $658a44ce960354bb$export$5f2755365ae1fee0 = 0x7d8a63;
const $658a44ce960354bb$export$8b477761269297db = 0xc3cbb4;
const $658a44ce960354bb$export$1574599d5500d639 = 7;
const $658a44ce960354bb$export$176f92955cca26b1 = 4;
const $658a44ce960354bb$var$PLOT_CHAMFER = 4;
const $658a44ce960354bb$export$19d17b2184543ca2 = 8;
const $658a44ce960354bb$export$99dca9ebbafa6899 = (g, x, y, w, h, c)=>{
    g.moveTo(x + c, y).lineTo(x + w - c, y).lineTo(x + w, y + c).lineTo(x + w, y + h - c).lineTo(x + w - c, y + h).lineTo(x + c, y + h).lineTo(x, y + h - c).lineTo(x, y + c).closePath();
};
const $658a44ce960354bb$export$514310343d21eee2 = (g, x, y)=>{
    g.lineStyle(0);
    g.beginFill($658a44ce960354bb$export$c2ea448b59bcc1de, 0.95).drawCircle(x, y, 2.4).endFill();
    g.beginFill($658a44ce960354bb$export$dd27ce85ad53c944, 0.95).drawCircle(x, y, 1.6).endFill();
    g.beginFill($658a44ce960354bb$export$6b1db5e247c0ce0, 0.7).drawCircle(x - 0.5, y - 0.55, 0.7).endFill();
};
const $658a44ce960354bb$export$37d7f1037ab575d0 = (g, w, h)=>{
    // The board lands over grass and wall ghosts and has to read as an object sitting on them
    // rather than a decal painted into them. (The print dial drops the same silhouette.)
    g.beginFill(0x000000, 0.32);
    $658a44ce960354bb$export$99dca9ebbafa6899(g, 0, 4, w, h, $658a44ce960354bb$export$1574599d5500d639);
    g.endFill();
    g.lineStyle({
        width: 1.5,
        color: $658a44ce960354bb$export$c2ea448b59bcc1de,
        alpha: 0.95,
        join: (0, $gwPoJ.LINE_JOIN).MITER
    });
    g.beginFill($658a44ce960354bb$export$611f5967b7e8b685, 0.98);
    $658a44ce960354bb$export$99dca9ebbafa6899(g, 0, 0, w, h, $658a44ce960354bb$export$1574599d5500d639);
    g.endFill();
    g.lineStyle({
        width: 1,
        color: $658a44ce960354bb$export$dd27ce85ad53c944,
        alpha: 0.85,
        join: (0, $gwPoJ.LINE_JOIN).MITER
    });
    g.beginFill($658a44ce960354bb$export$e969f1546e2d24ca, 0.97);
    $658a44ce960354bb$export$99dca9ebbafa6899(g, $658a44ce960354bb$export$176f92955cca26b1, $658a44ce960354bb$export$176f92955cca26b1, w - $658a44ce960354bb$export$176f92955cca26b1 * 2, h - $658a44ce960354bb$export$176f92955cca26b1 * 2, $658a44ce960354bb$export$1574599d5500d639 - 2);
    g.endFill();
    // One lit edge along the top, so the board has a direction the light falls from.
    g.lineStyle(1, $658a44ce960354bb$export$6b1db5e247c0ce0, 0.16).moveTo($658a44ce960354bb$export$176f92955cca26b1 + $658a44ce960354bb$export$1574599d5500d639, $658a44ce960354bb$export$176f92955cca26b1 + 1.5).lineTo(w - $658a44ce960354bb$export$176f92955cca26b1 - $658a44ce960354bb$export$1574599d5500d639, $658a44ce960354bb$export$176f92955cca26b1 + 1.5);
    for (const [x, y] of [
        [
            10,
            10
        ],
        [
            w - 10,
            10
        ],
        [
            10,
            h - 10
        ],
        [
            w - 10,
            h - 10
        ]
    ])$658a44ce960354bb$export$514310343d21eee2(g, x, y);
};
const $658a44ce960354bb$export$5ed3e56f5245819d = (g, x0, x1, y)=>{
    g.lineStyle(1, 0x000000, 0.6).moveTo(x0, y).lineTo(x1, y);
    g.lineStyle(1, $658a44ce960354bb$export$6b1db5e247c0ce0, 0.16).moveTo(x0, y + 1).lineTo(x1, y + 1);
};
const $658a44ce960354bb$export$d9a20d35155171c3 = (g, w, h, selected, hovered)=>{
    const rimColor = selected ? $658a44ce960354bb$export$319b6132a2fafb7c : hovered ? $658a44ce960354bb$export$dd27ce85ad53c944 : $658a44ce960354bb$export$f0510412e0d12cd1;
    // A fatter, faint copy behind the chosen plot: a glow without a filter, which this hardware
    // target cannot spare (the same trick as the print dial's arc).
    if (selected) {
        g.lineStyle({
            width: 3,
            color: $658a44ce960354bb$export$319b6132a2fafb7c,
            alpha: 0.13,
            join: (0, $gwPoJ.LINE_JOIN).MITER
        });
        $658a44ce960354bb$export$99dca9ebbafa6899(g, 0.5, 0.5, w - 1, h - 1, $658a44ce960354bb$var$PLOT_CHAMFER);
    }
    g.lineStyle({
        width: 1,
        color: rimColor,
        alpha: selected ? 1 : 0.8,
        join: (0, $gwPoJ.LINE_JOIN).MITER
    });
    g.beginFill(selected ? $658a44ce960354bb$export$82dbffd75f7d6df3 : $658a44ce960354bb$export$f73e3f59ba72192a, selected ? 0.95 : 0.8);
    $658a44ce960354bb$export$99dca9ebbafa6899(g, 0.5, 0.5, w - 1, h - 1, $658a44ce960354bb$var$PLOT_CHAMFER);
    g.endFill();
};
const $658a44ce960354bb$export$ae6afae266d469 = (g, box, cx, cy, lit)=>{
    g.lineStyle(1, $658a44ce960354bb$export$5f2755365ae1fee0, lit ? 0.3 : 0.17);
    for(let x = cx + $658a44ce960354bb$export$19d17b2184543ca2 / 2; x < box.x + box.w; x += $658a44ce960354bb$export$19d17b2184543ca2)g.moveTo(x, box.y).lineTo(x, box.y + box.h);
    for(let x = cx - $658a44ce960354bb$export$19d17b2184543ca2 / 2; x > box.x; x -= $658a44ce960354bb$export$19d17b2184543ca2)g.moveTo(x, box.y).lineTo(x, box.y + box.h);
    for(let y = cy; y < box.y + box.h; y += $658a44ce960354bb$export$19d17b2184543ca2)g.moveTo(box.x, y).lineTo(box.x + box.w, y);
    for(let y = cy - $658a44ce960354bb$export$19d17b2184543ca2; y > box.y; y -= $658a44ce960354bb$export$19d17b2184543ca2)g.moveTo(box.x, y).lineTo(box.x + box.w, y);
};
const $658a44ce960354bb$export$b6fa4f57132973f4 = (g, kind, cx, cy)=>{
    const hw = $658a44ce960354bb$export$19d17b2184543ca2 * 1.5;
    const hh = $658a44ce960354bb$export$19d17b2184543ca2;
    if (kind === "rectangle") g.drawRect(cx - hw, cy - hh, hw * 2, hh * 2);
    else if (kind === "ellipse") g.drawEllipse(cx, cy, hw, hh);
    else if (kind === "single") g.drawRect(cx - hh / 2, cy - hh / 2, hh, hh);
    else g.moveTo(cx - hw, cy + hh).lineTo(cx + hw, cy - hh);
};
const $658a44ce960354bb$export$26109819dc8e506a = (g, color)=>g.lineStyle({
        width: 2,
        color: color,
        alpha: 1,
        cap: (0, $gwPoJ.LINE_CAP).SQUARE,
        join: (0, $gwPoJ.LINE_JOIN).MITER
    });






class $ead1577967896e68$export$d714cb42a300e44f extends (0, $gwPoJ.Graphics) {
    constructor({ label: label, onClick: onClick, size: size = "medium", theme: theme = "slate", variant: variant = "secondary", width: width, height: height, fontSize: fontSize, textVariant: textVariant, textRole: textRole, mouseControlCallback: mouseControlCallback, fill: fill, enabled: enabled = true, hitPadding: hitPadding = 2, appearance: appearance = "filled", tone: tone = "neutral", shape: shape = "rounded", iconOnly: iconOnly = false, textColor: textColor, bold: bold, accent: accent, subtitle: subtitle, selected: selected = false, activation: activation = "release" }){
        super(), this.holdingMouseControl = false, this.hovered = false, this.pressed = false, this.onHover = (event)=>{
            if (!this.enabled) return;
            this.hovered = true;
            if (event?.data?.pointerType !== "touch") this.setMouseControl(true);
            this.draw();
        }, this.setMouseControl = (held)=>{
            if (!this.mouseControlCallback || this.holdingMouseControl === held) return;
            this.holdingMouseControl = held;
            this.mouseControlCallback(held);
        }, // Release only a hold acquired by this button; safe when an owner tears down a whole stack.
        this.releaseMouseControl = ()=>this.setMouseControl(false), this.resetInteraction = ()=>{
            this.releaseMouseControl();
            this.hovered = false;
            this.pressed = false;
            this.draw();
        }, this.setSelected = (selected)=>{
            this.selected = selected;
            this.draw();
        }, this.isSelected = ()=>this.selected, this.getLabel = ()=>this.labelText.text, this.getBoxSize = ()=>({
                width: this.buttonWidth,
                height: this.buttonHeight
            }), this.secondaryPointer = (event)=>event?.data?.pointerType !== "touch" && (event?.data?.button ?? 0) > 0, this.resize = (width, height)=>{
            this.autoWidth = false;
            this.autoHeight = false;
            this.autoFontSize = false;
            this.buttonWidth = width;
            this.buttonHeight = height;
            this.draw();
        }, this.setLabel = (label)=>{
            this.labelText.text = label;
            if (this.autoWidth) this.buttonWidth = this.labelText.width + this.metrics.paddingX * 2;
            this.draw();
        }, this.setEnabled = (enabled)=>{
            this.releaseMouseControl();
            this.enabled = enabled;
            this.interactive = enabled;
            this.interactiveChildren = false;
            this.cursor = enabled ? "pointer" : "default";
            this.alpha = enabled ? 1 : (0, $97475243e21a0995$export$ee8cee785341f31a);
            this.hovered = false;
            this.pressed = false;
            this.draw();
        }, this.refreshMetrics = ()=>this.draw(), this.draw = ()=>{
            const scale = (0, $0d2b5753435eae0a$export$7fe45ffd4b732106)(this);
            const touch = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().touch;
            if (this.autoFontSize) {
                const fontScale = touch ? Math.min(1, scale.x, scale.y) : 1;
                this.labelText.style.fontSize = this.baseFontSize / fontScale;
                if (this.subtitleText) this.subtitleText.style.fontSize = this.metrics.subtitleFontSize / fontScale;
            }
            const contentHeight = this.labelText.height + (this.subtitleText ? this.subtitleText.height + (0, $97475243e21a0995$export$a51cff52e7be40d7).xs : 0);
            if (this.autoHeight) this.buttonHeight = Math.max(this.metrics.height, contentHeight + (0, $97475243e21a0995$export$a51cff52e7be40d7).sm, touch ? (0, $0d2b5753435eae0a$export$8877eac68a40feb8) / scale.y : 0);
            if (this.autoWidth) this.buttonWidth = this.iconOnly ? this.buttonHeight : Math.max(Math.max(this.labelText.width, this.subtitleText?.width ?? 0) + this.metrics.paddingX * 2, touch ? (0, $0d2b5753435eae0a$export$8877eac68a40feb8) / scale.x : 0);
            if (this.autoWidth && this.iconOnly && touch) this.buttonWidth = Math.max(this.buttonWidth, (0, $0d2b5753435eae0a$export$8877eac68a40feb8) / scale.x);
            const accent = this.accent ?? (this.variant === "success" ? this.theme.success : this.variant === "danger" ? this.theme.danger : this.theme.accent);
            const border = this.hovered || this.selected || this.variant !== "secondary" ? accent : this.theme.border;
            this.clear();
            const active = this.pressed && this.enabled || this.selected;
            const fill = this.tone === "accent" ? this.backgroundFill ?? accent : active ? this.theme.pressedFill : this.hovered && this.enabled ? this.theme.hoverFill : this.backgroundFill ?? this.theme.fill;
            const fillAlpha = this.appearance === "filled" || active || this.hovered ? 1 : 0;
            this.beginFill(fill, fillAlpha);
            this.lineStyle(this.appearance === "subtle" && !active && !this.hovered ? 0 : this.tone === "accent" && (active || this.hovered) ? 2 : 1, border);
            let sink = 0;
            if (this.shape === "chamfer") sink = this.drawChamfer(fill, fillAlpha, border, active);
            else {
                const radius = this.shape === "rounded" ? (0, $97475243e21a0995$export$87e976d9ca6a6dc5).control : Math.min(this.buttonWidth, this.buttonHeight) / 2;
                if (this.shape === "circle") this.drawCircle(this.buttonWidth / 2, this.buttonHeight / 2, radius);
                else this.drawRoundedRect(0, 0, this.buttonWidth, this.buttonHeight, radius);
                this.endFill();
            }
            this.labelText.position.set((this.buttonWidth - this.labelText.width) / 2, (this.buttonHeight - contentHeight) / 2 + sink);
            if (this.subtitleText) this.subtitleText.position.set((this.buttonWidth - this.subtitleText.width) / 2, this.labelText.y + this.labelText.height + (0, $97475243e21a0995$export$a51cff52e7be40d7).xs);
            if (this.hitArea instanceof (0, $0d2b5753435eae0a$export$ca88597b86c9a1dc)) this.hitArea.refresh();
        }, // The cut-timber plate. Raised by a dropped lower edge that a press closes up -- the plate sinks a
        // pixel onto it and so does the label, which is most of what makes a click feel like it landed.
        // Returns how far the face sank, for the label.
        this.drawChamfer = (fill, fillAlpha, border, active)=>{
            const w = this.buttonWidth;
            const h = this.buttonHeight;
            const c = Math.min(5, h / 4);
            const sink = active ? 1 : 0;
            this.endFill();
            this.lineStyle(0);
            this.beginFill(0x000000, 0.4);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(this, 0, 1.5, w, h, c);
            this.endFill();
            this.lineStyle({
                width: 1,
                color: border,
                alpha: 1,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            this.beginFill(fill, Math.max(fillAlpha, this.appearance === "subtle" ? 0 : 0.96));
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(this, 0, sink, w, h, c);
            this.endFill();
            this.lineStyle(0);
            if (!active) {
                this.lineStyle(1, 0xffffff, this.tone === "accent" ? 0.3 : 0.09);
                this.moveTo(c, 1.5).lineTo(w - c, 1.5);
                this.lineStyle(0);
            }
            return sink;
        };
        this.appearance = appearance;
        this.tone = appearance === "filled" ? tone : "neutral";
        this.shape = shape;
        this.iconOnly = iconOnly;
        this.selected = selected;
        this.accent = accent;
        this.metrics = (0, $97475243e21a0995$export$73e83bf2b7e02467)[size];
        this.theme = (0, $97475243e21a0995$export$b1586623fe466c29)[theme];
        this.variant = variant;
        this.backgroundFill = fill;
        this.enabled = enabled;
        this.mouseControlCallback = mouseControlCallback;
        this.autoWidth = width === undefined;
        this.autoHeight = height === undefined;
        const variantStyle = textRole ? (0, $ef882f0a643d87d9$export$a57e4d4d74a95378)[textRole] : textVariant ? (0, $ef882f0a643d87d9$export$911e9fe6c3536bd5)[textVariant] : undefined;
        this.baseFontSize = fontSize ?? variantStyle?.fontSize ?? this.metrics.fontSize;
        this.autoFontSize = fontSize === undefined && textVariant === undefined && textRole === undefined && height === undefined;
        this.hitPadding = hitPadding;
        const labelRenderer = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role(this.metrics.labelRole).fontSize(this.baseFontSize).color(textColor ?? (this.tone === "accent" ? this.theme.onAccent : this.theme.text)).strokeThickness(0);
        if (textRole) labelRenderer.role(textRole);
        else if (textVariant) labelRenderer.variant(textVariant);
        labelRenderer.bold(bold ?? variantStyle?.bold ?? false);
        this.labelText = labelRenderer.render(label);
        this.addChild(this.labelText);
        if (subtitle !== undefined) {
            this.subtitleText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role(this.metrics.subtitleRole).color(textColor ?? (this.tone === "accent" ? this.theme.onAccent : this.theme.text)).strokeThickness(0).render(subtitle);
            this.subtitleText.alpha = 0.7;
            this.addChild(this.subtitleText);
        }
        this.buttonWidth = width ?? this.labelText.width + this.metrics.paddingX * 2;
        this.buttonHeight = height ?? this.metrics.height;
        this.setEnabled(enabled);
        this.hitArea = new (0, $0d2b5753435eae0a$export$ca88597b86c9a1dc)(()=>(0, $0d2b5753435eae0a$export$f71286780f6a70a)(this, this.buttonWidth, this.buttonHeight, this.autoWidth && this.autoHeight ? Infinity : this.hitPadding));
        this.on("added", ()=>this.draw());
        this.on("removed", ()=>{
            // Ancestor removal does not reach children; owners still release before detaching a stack.
            this.releaseMouseControl();
            this.hovered = false;
            this.pressed = false;
        });
        this.on("pointerover", this.onHover);
        this.on("mouseover", this.onHover);
        this.on("pointerout", this.resetInteraction);
        this.on("mouseout", this.resetInteraction);
        this.on("pointerdown", (event)=>{
            event?.stopPropagation();
            if (!this.enabled || this.secondaryPointer(event)) return;
            this.pressed = true;
            this.draw();
            if (activation === "press") onClick();
        });
        this.on("pointerup", ()=>{
            this.pressed = false;
            this.draw();
        });
        for (const event of [
            "pointerupoutside",
            "pointercancel"
        ])this.on(event, this.resetInteraction);
        this.on("pointertap", (event)=>{
            event?.stopPropagation();
            if (activation === "release" && this.enabled && !this.secondaryPointer(event)) onClick();
        });
    }
    destroy(options) {
        this.releaseMouseControl();
        if (!this.labelText.destroyed) this.labelText.destroy({
            texture: true,
            baseTexture: true
        });
        if (this.subtitleText && !this.subtitleText.destroyed) this.subtitleText.destroy({
            texture: true,
            baseTexture: true
        });
        super.destroy(options);
    }
}



// Presets carry common configuration; callers describe the action and only override what the
// surrounding layout actually requires. Keep rendering and interaction inside UiButton.
const $83d1a97b87afddc2$var$BUTTON_PRESETS = {
    standard: {
        size: "medium",
        variant: "secondary"
    },
    compact: {
        size: "small",
        variant: "secondary"
    },
    primary: {
        size: "medium",
        variant: "primary"
    },
    confirm: {
        size: "medium",
        variant: "success"
    },
    danger: {
        size: "medium",
        variant: "danger"
    }
};
const $83d1a97b87afddc2$export$9b6d6ca62970729f = ({ preset: preset = "standard", ...config })=>{
    const defaults = $83d1a97b87afddc2$var$BUTTON_PRESETS[preset];
    return new (0, $ead1577967896e68$export$d714cb42a300e44f)({
        ...defaults,
        ...config,
        size: config.size ?? (preset === "standard" && (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().density === "compact" ? "small" : defaults.size),
        variant: config.variant ?? defaults.variant
    });
};
const $83d1a97b87afddc2$export$48c67489f19ab119 = ({ icon: icon, ...config })=>$83d1a97b87afddc2$export$9b6d6ca62970729f({
        ...config,
        label: icon,
        iconOnly: true
    });
const $83d1a97b87afddc2$export$934057542c6ca351 = (config)=>$83d1a97b87afddc2$export$9b6d6ca62970729f(config);




parcelRequire("1avo5");
var $9Pi8W = parcelRequire("9Pi8W");
const $7fc026ed2e091ee4$export$7e4c1296b4859de0 = (node)=>{
    if (!node) return;
    if (node instanceof (0, $9Pi8W.Text)) {
        if (!node.destroyed) node.destroy({
            texture: true,
            baseTexture: true
        });
        return;
    }
    const children = node.children;
    if (children && children.length) // Copy first: destroying a child mutates the live children array.
    for (const child of [
        ...children
    ])$7fc026ed2e091ee4$export$7e4c1296b4859de0(child);
};


class $9fd6885af96d4f37$export$98d0db62fdbc7614 extends (0, $gwPoJ.Graphics) {
    constructor(text, props){
        super(), this.textRenderer = ()=>{
            const renderer = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)();
            if (this.role) renderer.role(this.role);
            else renderer.legacyVariant(this.font);
            if (this.strokeThickness !== undefined) renderer.strokeThickness(this.strokeThickness);
            return renderer.color(this.disabled ? (0, $ef882f0a643d87d9$export$f486164f64ee20e5) : this.textColor);
        }, this.stop = ()=>{
            this.active = false;
        }, this.playback = (charDelay, parent, doneCallback)=>{
            const items = this.text.split("");
            const canvas = new (0, $gwPoJ.Graphics)();
            canvas.x = this.x;
            canvas.y = this.y;
            canvas.width = this.width;
            canvas.height = this.height;
            parent.addChild(canvas);
            // Reuse ONE Text and mutate its .text each tick. PIXI re-rasterizes into the Text's own
            // canvas/texture in place, so no new canvas-backed BaseTexture is allocated per character.
            // The old code created a fresh Text (and texture) per char and only removeChildren()'d the
            // previous one -- never destroying it -- so every typed character leaked a GPU texture.
            const textObj = this.textRenderer().render("");
            canvas.addChild(textObj);
            let idx = 0;
            let str = "";
            let interval;
            let cleaned = false;
            const cleanup = ()=>{
                if (cleaned) return;
                cleaned = true;
                clearTimeout(interval);
                if (!textObj.destroyed) textObj.destroy({
                    texture: true,
                    baseTexture: true
                });
                if (canvas.parent) parent.removeChild(canvas);
                canvas.destroy();
            };
            const next = ()=>{
                if (!this.active) {
                    cleanup();
                    return;
                }
                const nextChar = items[idx];
                str += nextChar;
                textObj.text = str;
                idx++;
                if (idx > items.length - 1) {
                    doneCallback();
                    cleanup();
                    parent.addChild(this);
                    return;
                }
                const delay = (0, $fbecd757e266ba04$export$2d347b3a779dba49)(nextChar, charDelay);
                interval = setTimeout(next, delay);
            };
            next();
            return cleanup;
        };
        this.active = true;
        this.text = text;
        this.font = props?.font || "ScoreFont";
        this.role = props?.role ?? (props?.font ? undefined : "label");
        this.color = props?.color ?? 0xffffff;
        this.textColor = props?.color;
        this.strokeThickness = props?.strokeThickness;
        this.pause = props?.pause;
        this.type = props?.type || "text";
        const { textDecorations: textDecorations = [] } = props || {};
        const disabled = textDecorations.includes("disabled");
        this.disabled = disabled;
        this.interactiveChildren = !disabled;
        const isButton = this.type === "button" || this.type === "button|dynamic";
        const activate = disabled ? undefined : props?.onClick ? ()=>{
            props.onClick();
            props.extraOnClickListener?.(this.text);
        } : props?.link ? ()=>{
            props.extraOnClickListener?.(this.text);
            window.open(props.link);
        } : undefined;
        // Text and sprite links retain their parent handlers. Buttons own their one activation path.
        if (!isButton && activate) {
            this.interactive = true;
            this.on("click", activate);
            this.on("tap", activate);
            this.cursor = "pointer";
            if (props?.onClick) {
                const originalAlpha = this.alpha;
                this.on("mouseover", ()=>{
                    this.alpha = 0.7;
                });
                this.on("mouseout", ()=>{
                    this.alpha = originalAlpha;
                });
            }
        }
        if (this.type === "text") {
            const textObj = this.textRenderer().render(this.text);
            this.addChild(textObj);
            if (this.text && textDecorations.includes("underline")) {
                const underline = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).WHITE);
                underline.position.y = textObj.height;
                underline.width = textObj.width;
                underline.height = 2;
                textObj.addChild(underline);
                const spacer = new (0, $gwPoJ.Graphics)();
                spacer.drawRect(0, 0, 0, 40);
                this.addChild(spacer);
            }
        }
        if (isButton) {
            const button = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
                label: this.text,
                textRole: this.role,
                textVariant: this.role ? undefined : (0, $ef882f0a643d87d9$export$e67e74afd009f581)(this.font),
                size: "medium",
                tone: "accent",
                fill: disabled ? (0, $ef882f0a643d87d9$export$f486164f64ee20e5) : this.color,
                textColor: 0x000000,
                width: this.type === "button|dynamic" ? undefined : 100,
                enabled: !disabled,
                mouseControlCallback: props?.mouseControlCallback,
                onClick: activate ?? (()=>{})
            });
            this.on("removed", button.releaseMouseControl);
            this.addChild(button);
        }
        if (this.type === "sprite") {
            const itemSprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                name: props.spriteId,
                scale: props.scale || 1.0,
                color: disabled ? (0, $ef882f0a643d87d9$export$f486164f64ee20e5) : 0xffffff,
                rotating: false
            });
            itemSprite.y += itemSprite.height * 0.4;
            this.addChild(itemSprite);
            if (itemSprite.height < 30) {
                const spacer = new (0, $gwPoJ.Graphics)();
                spacer.drawRect(0, 0, 0, 30);
                this.addChild(spacer);
            }
        }
    }
    destroy(options) {
        // Free this node's own canvas-backed Text texture(s) before teardown. Shared Sprite textures
        // (e.g. item icons for type "sprite") are deliberately left intact by disposeTextTextures.
        (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(this);
        super.destroy({
            children: true,
            texture: false,
            baseTexture: false
        });
    }
}





class $aeae8505a2eb5f5c$export$f169141001428c70 extends (0, $gwPoJ.Graphics) {
    constructor(props){
        super(), this.progressivePlayList = [], this.opaque = false, this.wipe = ()=>{
            [
                ...this.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.removeChildren();
            this.progressivePlayList = [];
            this.previous = null;
            this.lineHasButton = false;
        }, this.append2 = (item, props = {
            sameLine: false
        })=>{
            const toAdd = typeof item === "string" ? new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(item, {
                role: props.role ?? (props.font ? undefined : this.defaultTextRole),
                font: props.font || this.defaultTextFont,
                extraOnClickListener: this.linkCallback,
                pause: props.pause,
                type: props.type,
                onClick: props.onClick,
                mouseControlCallback: props.mouseControlCallback,
                spriteId: props.spriteId,
                scale: props.scale,
                textDecorations: props.textDecorations,
                context: props.context,
                color: props.color,
                strokeThickness: props.strokeThickness
            }) : item;
            this.progressivePlayList.push(toAdd);
            const typeToUse = props.type || item.type;
            if (typeToUse === "horizontalLine") {
                toAdd.beginFill(0xffffff, 0.8);
                toAdd.drawRect(0, 0, this.width, 1);
                toAdd.endFill();
            }
            if (!this.progressive) this.addChild(toAdd);
            if (this.previous && !props?.ignorePrevious) {
                if (props.sameLine) toAdd.y = this.previous.y;
                else {
                    toAdd.y = this.previous.y + (props.preservePreviousHeight === undefined || props.preservePreviousHeight ? this.previous.height : 0);
                    // + toAdd.height
                    this.lineHasButton = false;
                }
            }
            if (typeToUse === "button" || typeToUse === "button|dynamic") this.lineHasButton = true;
            if (props.leftSpacer) toAdd.x = props.leftSpacer;
            else if (this.previous && !props?.ignorePrevious) {
                if (props.sameLine) toAdd.x = this.previous.x + (props.fixedWidth !== undefined ? props.fixedWidth : this.previous.width);
                else if (props.sameX) toAdd.x = this.previous.x;
            }
            if (props.leftMargin) toAdd.x += props.leftMargin;
            if (props.topSpacer) toAdd.y = props.topSpacer;
            if (props.topMargin) toAdd.y += props.topMargin;
            if (props.bottomMargin) {
                const spacer = new (0, $gwPoJ.Graphics)();
                spacer.drawRect(0, 0, this.width, props.bottomMargin);
                toAdd.addChild(spacer);
            }
            if (props.exactLocation) {
                toAdd.x = props.exactLocation.x;
                toAdd.y = props.exactLocation.y;
            }
            if (props.hoverText && this.hoverText && !props.textDecorations?.includes("disabled")) {
                toAdd.interactive = true;
                toAdd.on("mouseover", ()=>{
                    this.hoverText.visible = true;
                    this.hoverText.x = toAdd.x + this.x;
                    this.hoverText.y = toAdd.y + this.y;
                    this.hoverText.update(props.hoverText);
                });
            }
            if (this.progressive) {
                const g = new (0, $gwPoJ.Graphics)();
                g.drawRect(0, 0, toAdd.height, 1);
                g.x = toAdd.x;
                g.y = toAdd.y;
                this.addChild(g);
            }
            this.previous = toAdd;
            if (this.backdrop) {
                this.backdrop.clear();
                if (this.opaque) this.backdrop.lineStyle({
                    width: this.borderColor === undefined ? 1 : 2,
                    color: this.borderColor === undefined ? (0, $97475243e21a0995$export$cac838e5dd111a30) : this.borderColor,
                    alpha: this.borderColor === undefined ? 0.9 : 1
                });
                this.backdrop.beginFill(this.opaque ? (0, $97475243e21a0995$export$ae463dc3cc7e810b) : 0x000000, this.opaque ? 1 : 0.5);
                this.backdrop.drawRoundedRect(-5 - this.margin, -5 - this.margin, this.width + 10 + this.margin, this.height + 10 + this.margin, 5);
                this.backdrop.endFill();
                if (this.opaque) this.backdrop.lineStyle(0);
            }
            return this;
        }, this.append = (item, sameLine = false, leftSpacer = 0, leftMargin = 0, pause, type, onClick, mouseControlCallback)=>{
            const toAdd = typeof item === "string" ? new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(item, {
                role: this.defaultTextRole,
                font: this.defaultTextFont,
                extraOnClickListener: this.linkCallback,
                pause: pause,
                type: type,
                onClick: onClick,
                mouseControlCallback: mouseControlCallback
            }) : item;
            this.progressivePlayList.push(toAdd);
            if (!this.progressive) this.addChild(toAdd);
            if (this.previous) {
                if (sameLine) toAdd.y = this.previous.y;
                else {
                    toAdd.y = this.previous.y + toAdd.height;
                    this.lineHasButton = false;
                }
            }
            if (type === "button") this.lineHasButton = true;
            if (leftSpacer) toAdd.x = leftSpacer;
            else if (this.previous && sameLine) toAdd.x = this.previous.x + this.previous.width;
            if (leftMargin) toAdd.x += leftMargin;
            if (this.progressive) {
                const g = new (0, $gwPoJ.Graphics)();
                g.drawRect(0, 0, toAdd.height, 1);
                g.x = toAdd.x;
                g.y = toAdd.y;
                this.addChild(g);
            }
            this.previous = toAdd;
            return this;
        }, this.appendLink = (item, target, sameLine = false, leftSpacer = 0)=>{
            return this.append(new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(item, {
                color: 0x00ff00,
                link: target,
                extraOnClickListener: this.linkCallback
            }), sameLine, leftSpacer);
        }, this.cleanup = ()=>{
            this.activePlaybackId = undefined;
            if (this.currentlyPlayingLineCleaner) this.currentlyPlayingLineCleaner();
        }, this.playback = (callback)=>{
            const playlistLength = this.progressivePlayList.length;
            let idx = 0;
            const activePlaybackId = (0, $a80d0b17b615d6f7$export$5e699d18035b41af)();
            this.activePlaybackId = activePlaybackId;
            const doNext = ()=>{
                const nextElement = this.progressivePlayList[idx];
                idx++;
                const dynamicText = nextElement;
                const cleanup = dynamicText?.playback((0, $fbecd757e266ba04$export$c5dfed2bbbcb21c8), this, ()=>{
                    if (idx < playlistLength && this.activePlaybackId === activePlaybackId) setTimeout(()=>{
                        if (this.activePlaybackId === activePlaybackId) doNext();
                        else {
                            dynamicText.stop();
                            if (callback) callback();
                        }
                    }, dynamicText.pause ? dynamicText.pause : 1);
                    else {
                        dynamicText.stop();
                        if (callback) callback();
                    }
                });
                this.currentlyPlayingLineCleaner = ()=>{
                    dynamicText.active = false;
                    if (cleanup) cleanup();
                };
            };
            doNext();
        }, this.appendChunkedText = (source)=>{
            const texts = (0, $a80d0b17b615d6f7$export$edde49207b897324)(source, 95);
            texts.forEach((text)=>{
                this.append2(text, {
                    sameLine: false
                });
            });
        };
        this.defaultTextFont = props?.defaultTextFont;
        this.defaultTextRole = props?.defaultTextRole;
        this.linkCallback = props?.linkCallback;
        this.progressive = props?.progressive;
        this.activePlaybackId = undefined;
        this.lineHasButton = false;
        this.hoverText = props?.hoverText;
        this.opaque = props?.opaque === true;
        this.borderColor = props?.borderColor;
        if (props?.backdrop) {
            this.backdrop = new (0, $gwPoJ.Graphics)();
            this.addChild(this.backdrop);
        }
        this.margin = props?.margin || 0;
    }
}




class $b3798b784c33df3d$export$3b2ce821e7872e8e {
    constructor(subject, props){
        this.release = ()=>{
            this.subject.alpha = 1.0;
            if (this.releaseCallback) this.releaseCallback();
            let cycles = 0;
            const releaseInterval = setInterval(()=>{
                if (this.subject.alpha >= 1.0 && cycles > 0) {
                    clearInterval(releaseInterval);
                    return;
                }
                this.subject.alpha += this.dir ? 0.1 : -0.1;
                if (this.subject.alpha <= 0.4 || this.subject.alpha >= 1.5) {
                    this.dir = !this.dir;
                    cycles++;
                }
            }, this.blinkInterval);
        };
        this.update = ()=>{
            if (this.flasherInterval) return;
            this.flasherInterval = setInterval(()=>{
                this.subject.alpha += this.dir ? 0.1 : -0.1;
                if (this.subject.alpha <= this.minAlpha || this.subject.alpha >= this.maxAlpha) {
                    this.dir = !this.dir;
                    if (this.cycleCallback) this.cycleCallback();
                }
                if (!!this.expires && Date.now() > this.expires) {
                    this.stop();
                    return;
                }
            }, this.blinkInterval);
        };
        this.stop = ()=>{
            this.release();
            clearInterval(this.flasherInterval);
            this.flasherInterval = undefined;
        };
        this.subject = subject;
        this.expires = !props?.permanent ? Date.now() + props?.expires : undefined;
        this.releaseCallback = props?.releaseCallback;
        this.cycleCallback = props?.cycleCallback;
        this.blinkInterval = props?.blinkInterval || 100;
        this.minAlpha = props?.minAlpha || 0.4;
        this.maxAlpha = props?.maxAlpha || 1.5;
    }
}


class $5f817afe83d87a88$export$9ec831f4c1f089b1 {
    setup(x, y, image, label, parent, params = {}, spriteParent) {
        const job = ()=>{
            this.isExecuting = true;
            if (params.type === "vibrate" && spriteParent) {
                // this affects the parent
                let startTs = Date.now();
                let shakeDirLeft = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)();
                // let shakeDistance = randomIntBetween(1, 1)
                let shakeDistance = 1;
                let currentShakeDistance = shakeDistance;
                let duration = 750;
                let up = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)();
                let shakeOffsetX = 0;
                let shakeOffsetY = 0;
                let originalX = spriteParent.x;
                let originalY = spriteParent.y;
                const interval = setInterval(()=>{
                    // The body can be destroyed mid-shake (removed as it dies); a destroyed
                    // DisplayObject throws on every position write.
                    if (spriteParent.destroyed) {
                        clearInterval(interval);
                        return;
                    }
                    let elapsed = Date.now() - startTs;
                    if (elapsed > duration) {
                        clearInterval(interval);
                        shakeOffsetX = 0;
                        shakeOffsetY = 0;
                        spriteParent.x = originalX;
                        spriteParent.y = originalY;
                        return;
                    }
                    if (elapsed / duration % 0.25 === 0 || currentShakeDistance <= 0) {
                        shakeDirLeft = !shakeDirLeft;
                        shakeDistance = shakeDistance - 1;
                        currentShakeDistance = shakeDistance;
                    }
                    currentShakeDistance -= 1;
                    shakeOffsetX += shakeDirLeft ? 1 : -1;
                    // this.updatePlayerLocation(entity)
                    // shakeOffsetY += up ? -1 : 1
                    spriteParent.x = originalX + shakeOffsetX;
                    spriteParent.y = originalY + shakeOffsetY;
                    up = !up;
                }, 10);
            }
            if (image || label) {
                const sprite = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
                if (label) sprite.append2(label, {
                    leftMargin: 0,
                    color: params?.color,
                    role: params?.font ? undefined : "effect",
                    font: params?.font
                });
                if (image) {
                    const baseScale = 2.4;
                    const spriteImg = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        color: 0xffffff,
                        scale: baseScale,
                        name: image
                    });
                    // Small resource icons look right at baseScale, but crafted item art
                    // (weapons/tools) has a full-size frame that becomes gigantic at 2.4x.
                    // Shrink only when the rendered art exceeds ~1.5 tiles; never enlarge.
                    const maxDisplaySize = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 1.5;
                    const largestDim = Math.max(spriteImg.width, spriteImg.height);
                    if (largestDim > maxDisplaySize) spriteImg.updateScale(baseScale * maxDisplaySize / largestDim);
                    sprite.append2(spriteImg, {
                        sameLine: true,
                        leftMargin: 8
                    });
                }
                let throbber;
                if (params?.alignment === "center") {
                    sprite.x = parent.width / 2 + (label.length > 1 ? -(label.length * 11) : 0);
                    sprite.y = y - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                    throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(sprite, {
                        blinkInterval: 10
                    });
                    throbber.update();
                } else {
                    // default
                    sprite.x = -sprite.width / 4 + x;
                    sprite.y = y;
                }
                parent.addChild(sprite);
                const now = Date.now();
                const budget = params?.duration || 750;
                const { variant: variant = "default" } = params;
                const scrollIncrement = (params?.scrollSpeed || 1.0) * 2;
                const finish = ()=>{
                    clearInterval(interval);
                    sprite.parent?.removeChild(sprite);
                    // sprite.remove()
                    this.isExecuting = false;
                    if (this.itemPickupQueue.length < 1) {
                        clearInterval(this.itemPickupQueueInterval);
                        this.itemPickupQueueInterval = undefined;
                    }
                    if (throbber) throbber.stop();
                };
                const interval = setInterval(()=>{
                    // `parent` is the body's overlay. When the body is removed while this is still
                    // rising -- the killing blow's damage number on an entity that just died -- it is
                    // destroyed with its children, and every read of a destroyed DisplayObject's
                    // position throws. Without this the interval would throw every tick, forever.
                    if (sprite.destroyed) {
                        finish();
                        return;
                    }
                    if (variant === "default") sprite.y -= scrollIncrement;
                    const elapsed = Date.now() - now;
                    const alpha = elapsed / budget;
                    if (variant === "default") {
                        if (alpha > 0.7) sprite.alpha = 1.0 - alpha + 0.2;
                    }
                    if (elapsed > budget) finish();
                }, 20);
            }
        };
        if (params.immediate) {
            job();
            return job;
        }
        if (this.itemPickupQueueInterval) clearInterval(this.itemPickupQueueInterval);
        this.itemPickupQueueInterval = setInterval(()=>{
            if (this.itemPickupQueue.length < 1) {
                clearInterval(this.itemPickupQueueInterval);
                return;
            }
            const next = this.itemPickupQueue.shift();
            if (next) next();
        }, 50);
        if (!this.isExecuting) job();
        else this.itemPickupQueue.push(job);
        return job;
    }
    constructor(){
        this.itemPickupQueue = [];
        this.isExecuting = false;
        this.remove = (job)=>{
            this.itemPickupQueue = this.itemPickupQueue.filter((n)=>n !== job);
        };
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");
var $7Bs2Z = parcelRequire("7Bs2Z");

var $5UG8I = parcelRequire("5UG8I");


// Runtime toggle for the visual that plays when an entity dies.
//
// "explode" is the original effect: the sprite shatters into a radial burst of
// spinning, reddening fragments that fly outward and fade in ~500ms.
//
// "crumble" is the new alternative: the same fragments instead fall under
// gravity, tumble, bounce and settle into a dusty pile at the entity's feet,
// with a small puff of dust rising off the base.
//
// Both live side by side so they can be compared in-game. The default stays on
// the original "explode". Flip the active style at runtime from the browser
// console:
//
//     deathEffect = "crumble"    // then kill an NPC to watch it crumble
//     deathEffect = "explode"    // back to the original
//
// or preload a style with a ?death=crumble query param on the game URL.
const $e117ef21d9885baa$var$STYLES = [
    "explode",
    "crumble"
];
const $e117ef21d9885baa$var$isDeathEffectStyle = (value)=>typeof value === "string" && $e117ef21d9885baa$var$STYLES.includes(value);
let $e117ef21d9885baa$var$activeStyle = "crumble";
const $e117ef21d9885baa$export$a6f8340679349869 = ()=>$e117ef21d9885baa$var$activeStyle;
const $e117ef21d9885baa$export$14f53a783ad0d379 = (style)=>{
    if (!$e117ef21d9885baa$var$isDeathEffectStyle(style)) {
        console.warn(`[deathEffect] unknown style ${JSON.stringify(style)}; expected one of ${$e117ef21d9885baa$var$STYLES.join(", ")}`);
        return;
    }
    $e117ef21d9885baa$var$activeStyle = style;
    console.log(`[deathEffect] active style: ${$e117ef21d9885baa$var$activeStyle}`);
};
// Wire up the browser-console toggle + optional ?death= query param. Guarded so
// it is a no-op in the Node test harness (no window).
if (typeof window !== "undefined") {
    try {
        const param = new URLSearchParams(window.location.search).get("death");
        if ($e117ef21d9885baa$var$isDeathEffectStyle(param)) $e117ef21d9885baa$var$activeStyle = param;
    } catch  {
    // window.location may be unavailable in some embeddings; ignore.
    }
    Object.defineProperty(window, "deathEffect", {
        get: ()=>$e117ef21d9885baa$var$activeStyle,
        set: (style)=>$e117ef21d9885baa$export$14f53a783ad0d379(style),
        configurable: true
    });
}



// Shared slice-and-animate core behind every sprite's entity-death `fragment()`.
//
// Each sprite class builds + positions a `surface` Graphics and resolves the
// current animation frame `frame`, then hands both here. This slices the frame
// into a grid of little sub-sprites and animates them with whichever death
// style is currently active (see death_effect_config): the original radial
// "explode", or the new gravity-driven "crumble".
//
// The `onSpawned` hook fires once after all fragments are created (BasicSprite
// uses it to resolve its fragment callback).
const $4264eae3240561ee$var$randomFloatBetween = (min, max)=>Math.random() * (max - min) + min;
// Alpha byte above which a pixel counts as "solid" when locating the visible
// bottom (the feet) of a death frame. See computeContentBottomPx.
const $4264eae3240561ee$var$CONTENT_ALPHA_THRESHOLD = 8;
// Memoized foot line (local-pixel bottom of the visible art), keyed by a stable
// art identifier -- race for creatures, spriteId for basic sprites. The foot
// line within a cell is a static property of a species' art (outfit/action barely
// move it), so a whole species costs ONE readback for the session, then zero.
// Stores a plain number, so it's immune to the destroyed-texture staleness that
// bites texture caches here (no HMR clearing needed).
const $4264eae3240561ee$var$footLineCache = new Map();
const $4264eae3240561ee$export$cc249234599c5a64 = (surface, frame, opts = {})=>{
    const style = (0, $e117ef21d9885baa$export$a6f8340679349869)();
    const { x: origX, y: origY, width: width, height: height } = frame._frame;
    const divisor = height < 50 || width < 50 ? 3 : (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(10, 20);
    const cols = Math.floor(width / divisor);
    const rows = Math.floor(height / divisor);
    // Fragments (and, for crumble, dust motes) each drive their own timer. We
    // remove the shared `surface` only once the last one has finished.
    let awaitedCount = 0;
    const cleaner = ()=>{
        if (awaitedCount < 1) surface.parent?.removeChild(surface);
    };
    const onFinished = ()=>{
        awaitedCount--;
        cleaner();
    };
    // For crumble, locate the visible bottom (feet) of the art so every piece
    // settles at the creature's real foot line rather than the (often
    // padding-filled) bottom of the sprite-sheet cell. Cached per art identifier
    // (opts.cacheKey), so it's one GPU readback per species, then free.
    const crumbleGround = style === "crumble" ? $4264eae3240561ee$var$resolveCrumbleGround(frame, rows, divisor, opts.cacheKey) : 0;
    for(let y = 0; y < rows; y++)for(let x = 0; x < cols; x++){
        const fragX = origX + x * divisor;
        const fragY = origY + y * divisor;
        const frag = new (0, $klOfb.Texture)(frame.baseTexture, new (0, $6qzqq.Rectangle)(fragX, fragY, divisor, divisor), undefined, undefined, frame.rotate, frame.defaultAnchor);
        const fragSprite = new (0, $7Bs2Z.Sprite)(frag);
        fragSprite.x = x * divisor;
        fragSprite.y = y * divisor;
        surface.addChild(fragSprite);
        awaitedCount++;
        if (style === "crumble") $4264eae3240561ee$var$animateCrumbleFragment(fragSprite, {
            row: y,
            rows: rows,
            divisor: divisor
        }, crumbleGround, onFinished);
        else $4264eae3240561ee$var$animateExplodeFragment(fragSprite, onFinished);
    }
    const fragmentCount = awaitedCount;
    // A puff of dust rising off the base sells the crumble.
    if (style === "crumble" && fragmentCount > 0) {
        const dustCount = 6;
        for(let d = 0; d < dustCount; d++){
            awaitedCount++;
            $4264eae3240561ee$var$spawnDustMote(surface, width, crumbleGround, onFinished);
        }
    }
    // Matches the original loop's semantics: fire only once fragments exist.
    if (fragmentCount > 0) opts.onSpawned?.();
    else // Nothing to animate (frame smaller than the divisor): tear down now.
    surface.parent?.removeChild(surface);
};
// --- Original "explode": radial constant-velocity scatter, spin, red tint, fade over ~500ms. ---
const $4264eae3240561ee$var$animateExplodeFragment = (fragSprite, onFinished)=>{
    const angle = (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)((0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 360));
    const speed2 = {
        x: Math.cos(angle),
        y: Math.sin(angle)
    };
    let rotation = 0;
    const startTs = Date.now();
    let changedColor1 = false;
    let changedColor2 = false;
    const interval = setInterval(()=>{
        fragSprite.x += speed2.x * 10;
        fragSprite.y += speed2.y * 10;
        fragSprite.alpha -= 0.1;
        rotation += 1;
        if (rotation > 360) rotation = 0;
        fragSprite.angle = rotation;
        if (fragSprite.alpha < 0.7 && !changedColor1) {
            fragSprite.tint = 0xffc0c0;
            changedColor1 = true;
        }
        if (fragSprite.alpha < 0.5 && !changedColor2) {
            fragSprite.tint = 0xff0000;
            changedColor2 = true;
        }
        if (Date.now() - startTs > 500) {
            $4264eae3240561ee$var$removeFrag(fragSprite);
            clearInterval(interval);
            onFinished();
        }
    }, 50);
};
// --- New "crumble": pieces fall under gravity, tumble, bounce on the ground, settle then fade. ---
const $4264eae3240561ee$var$animateCrumbleFragment = (fragSprite, grid, groundLine, onFinished)=>{
    const gravity = 1.4;
    const bounce = 0.32;
    // Settle at the resolved foot line (bottom of the visible art), with a
    // little jitter for an uneven pile. Never above the piece's own start, so a
    // fragment already at/below the foot just settles in place instead of rising.
    const startY = grid.row * grid.divisor;
    const ground = Math.max(startY, groundLine + $4264eae3240561ee$var$randomFloatBetween(-grid.divisor * 0.4, grid.divisor * 0.25));
    // Lower rows give way first, so the figure collapses from the base upward.
    const delay = (grid.rows - 1 - grid.row) * 18;
    let vx = $4264eae3240561ee$var$randomFloatBetween(-2.2, 2.2);
    let vy = $4264eae3240561ee$var$randomFloatBetween(-1.5, 0.5);
    let spin = $4264eae3240561ee$var$randomFloatBetween(-4, 4);
    let settled = false;
    let tinted = false;
    const startTs = Date.now();
    const startAt = startTs + delay;
    const interval = setInterval(()=>{
        const now = Date.now();
        if (now < startAt) return;
        if (!settled) {
            vy += gravity;
            fragSprite.y += vy;
            fragSprite.x += vx;
            fragSprite.angle += spin;
            if (fragSprite.y >= ground && vy > 0) {
                fragSprite.y = ground;
                vy *= -bounce;
                vx *= 0.55;
                spin *= 0.5;
                if (Math.abs(vy) < 1) {
                    vy = 0;
                    settled = true;
                }
            }
        }
        // Once it has come to rest (or lingered long enough) it fades to dust.
        if (settled || now - startAt > 700) {
            fragSprite.alpha -= 0.06;
            if (fragSprite.alpha < 0.6 && !tinted) {
                fragSprite.tint = 0x9a8f80 // dusty grey-brown, not fiery red
                ;
                tinted = true;
            }
        }
        if (fragSprite.alpha <= 0 || now - startTs > 1600) {
            $4264eae3240561ee$var$removeFrag(fragSprite);
            clearInterval(interval);
            onFinished();
        }
    }, 50);
};
// Resolve the local-pixel y where crumble pieces should pile: the bottom of the
// frame's visible art (the feet), falling back to the bottom of the sprite-sheet
// cell when a pixel read isn't possible. When a cacheKey is given, the resolved
// foot line is memoized per art identifier (see footLineCache) so we do at most
// one readback per species. A failed/unavailable read is NOT cached, so we retry
// on the next death (e.g. if the renderer wasn't ready the first time).
const $4264eae3240561ee$var$resolveCrumbleGround = (frame, rows, divisor, cacheKey)=>{
    if (cacheKey) {
        const cached = $4264eae3240561ee$var$footLineCache.get(cacheKey);
        if (cached !== undefined) return cached;
    }
    // Cache miss (or no key given): pay for one pixel readback.
    const contentBottom = $4264eae3240561ee$var$computeContentBottomPx(frame);
    if (contentBottom != null && contentBottom > 0) {
        if (cacheKey) $4264eae3240561ee$var$footLineCache.set(cacheKey, contentBottom);
        return contentBottom;
    }
    return rows * divisor;
};
// Read back the frame's pixels and return the local-pixel y of the lowest row
// that still has a solid (non-transparent) pixel -- the visible bottom of the
// art. Returns null if the renderer/extract plugin is unavailable (e.g. tests)
// or the frame is empty. Resolution-independent: works off canvas-height fractions.
const $4264eae3240561ee$var$computeContentBottomPx = (frame)=>{
    const extract = (0, $065c5647ab3ff4dc$export$90e89a86e46f5ae3)()?.renderer?.plugins?.extract;
    if (!extract) return null;
    const probe = new (0, $7Bs2Z.Sprite)(frame);
    try {
        const canvas = extract.canvas(probe);
        const ctx = canvas.getContext("2d");
        const cw = canvas.width;
        const ch = canvas.height;
        if (!ctx || cw === 0 || ch === 0) return null;
        const data = ctx.getImageData(0, 0, cw, ch).data;
        const frameHeight = frame._frame.height;
        for(let y = ch - 1; y >= 0; y--){
            const rowOffset = y * cw * 4;
            for(let x = 0; x < cw; x++){
                if (data[rowOffset + x * 4 + 3] > $4264eae3240561ee$var$CONTENT_ALPHA_THRESHOLD) // Map the canvas row back into the frame's local pixel space.
                return (y + 1) / ch * frameHeight;
            }
        }
        return null;
    } catch (e) {
        (0, $5UG8I.logger).error({
            tags: [
                "sprite",
                "error"
            ]
        }, e);
        return null;
    } finally{
        probe.destroy();
    }
};
// A single dust mote off the shared WHITE texture (batches cheaply): rises, drifts, shrinks, fades.
const $4264eae3240561ee$var$spawnDustMote = (surface, width, baseY, onFinished)=>{
    const dust = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).WHITE);
    dust.tint = 0x8b7355;
    const size = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(2, 4);
    dust.width = size;
    dust.height = size;
    dust.x = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, Math.max(1, width));
    dust.y = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(Math.floor(baseY * 0.7), Math.max(1, Math.floor(baseY)));
    dust.alpha = 0.6;
    surface.addChild(dust);
    const vx = $4264eae3240561ee$var$randomFloatBetween(-0.8, 0.8);
    const vy = $4264eae3240561ee$var$randomFloatBetween(-3.5, -2);
    const interval = setInterval(()=>{
        dust.x += vx;
        dust.y += vy;
        dust.alpha -= 0.03;
        dust.scale.set(dust.scale.x * 0.97);
        if (dust.alpha <= 0) {
            $4264eae3240561ee$var$removeFrag(dust);
            clearInterval(interval);
            onFinished();
        }
    }, 50);
};
const $4264eae3240561ee$var$removeFrag = (sprite)=>{
    try {
        if (sprite?.parent) sprite.parent.removeChild(sprite);
    } catch (e) {
        (0, $5UG8I.logger).error({
            tags: [
                "sprite",
                "error"
            ]
        }, e);
    }
};


/**
 * How far below an entity's location its art meets the ground.
 *
 * A location is a sort key, not a foot position. LpcComposite draws a body's 64px frame centred on
 * its container -- so the sole row, 60px down the frame, lands 28px below the centre -- and then
 * lifts the container a tenth of the frame (see LpcComposite.getYOffset). Soles therefore sit
 * 28 - 6.4 px below `location.y`, and that is the line a prop has to touch to look like it is lying
 * on the ground rather than hovering over it.
 */ const $15caf4b106aaadb3$var$GROUND_CONTACT_OFFSET = (0, $9667a1379a787b5e$export$5985b04c8e71b763);
/**
 * Suffix that asks for the art to be drawn ON the ground: `"<tileset>:<tile>:ground"`.
 *
 * A tileset marker is otherwise drawn AROUND its location, not on it -- the texture is lifted a
 * flat 14px here and the container another quarter of its height in BaseRenderable.getYOffset --
 * which leaves a 32px cell's foot about 11px above the sole line, and more again for art that
 * does not reach the foot of its own cell (an inventory icon, say, with transparent rows under it).
 * That is what makes a prop read as floating. Those offsets are load-bearing for every marker
 * authored against them -- campfires, snares, resource nodes, chests, doors -- so this is opt-in:
 * ask for it and the art's own lowest pixel is placed on the sole line instead, measured from the
 * texture so padding in the source art cannot reintroduce the gap.
 *
 * The suffix survives the `split(":")` above it untouched (the tileset and tile number are the
 * first two segments), so it needs no new field and no change to what the server sends.
 */ const $15caf4b106aaadb3$var$GROUND_ANCHOR_SUFFIX = ":ground";
class $15caf4b106aaadb3$export$5a33d6de29791ec5 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    /** A landed projectile is centred on an exact impact point, without the pickup's hovering lift. */ anchorAtGroundPoint() {
        this.grounded = true;
        if (!this.sprite) return;
        const texture = this.sprite.texture;
        const content = (0, $35a6592763403c18$export$46429b068ef0a2d5)(texture, this.spriteId) ?? new (0, $6qzqq.Rectangle)(0, 0, texture.width, texture.height);
        this.sprite.position.set(-(content.x + content.width / 2) * this.sprite.scale.x, -(content.y + content.height / 2) * this.sprite.scale.y);
        this.updateClickAreaBounds();
    }
    // `withClickArea` gives this sprite its own hover/hit surface sized to the rendered art (see
    // updateClickAreaBounds) instead of hit-testing the whole renderable. Entities the player can
    // point at -- the interactable markers -- opt in; pure decoration doesn't.
    constructor(spriteMeta, withClickArea, scaleWholeArtwork = false){
        super(), this.scaleWholeArtwork = scaleWholeArtwork, this.grounded = false, this.updateScale = (scale = 1)=>{
            if (!Number.isFinite(scale) || scale < 0) return;
            // Tile markers scale around their world anchor; item sprites keep their art-local anchor.
            if (this.scaleWholeArtwork) {
                this.scale.set(scale);
                return;
            }
            const artScale = this.scaleValue * scale;
            if (this.animation) this.animation.scale.set(artScale);
            if (this.sprite) this.sprite.scale.set(artScale);
            if (this.grounded) this.anchorAtGroundPoint();
            this.updateClickAreaBounds();
        }, this.startRotation = ()=>{
            if (this.rotationInterval !== undefined) return;
            let angle = this.container.angle;
            this.rotationInterval = setInterval(()=>{
                if (angle > 360) angle = 0;
                this.container.angle = angle;
                angle++;
            }, 50);
        }, this.updateRotating = (rotating)=>{
            if (rotating) this.startRotation();
            else {
                this.cleanup();
                this.container.angle = 0;
            }
        }, this.getCurrentColor = ()=>this.currentColor, this.recolor = (color)=>{
            if (this.currentColor === color) return;
            this.currentColor = color;
            if (this.animation) this.animation.tint = color;
            if (this.sprite) this.sprite.tint = color;
        }, this./**
     * The art a dropped item's discovery glint traces, read fresh every frame (see GlintSubject).
     *
     * Not a copy: a collectable with an expiry spins, so its angle is only right at the moment it
     * is asked for, and its sprite is replaced outright when the item's art changes.
     */ glintArt = ()=>this.sprite ? {
                sprite: this.sprite,
                rotation: this.container.rotation
            } : undefined, this.getClickSurface = ()=>{
            if (this.clickArea) return this.clickArea;
            return super.getClickSurface();
        }, this.updateClickAreaBounds = ()=>{
            if (!this.clickArea) return;
            this.clickArea.x = 0;
            this.clickArea.y = 0;
            this.clickArea.hitArea = (0, $85a39b5d41a16ed9$export$15d4c1eea10d6840)(this.visibleArtBounds());
        }, this.visibleArtBounds = ()=>{
            const containerBounds = this.container.getLocalBounds();
            const fallback = containerBounds.width > 0 && containerBounds.height > 0 && isFinite(containerBounds.x) && isFinite(containerBounds.y) ? containerBounds : null;
            if (!this.sprite || this.animation) return fallback;
            const content = (0, $35a6592763403c18$export$46429b068ef0a2d5)(this.sprite.texture, this.spriteId);
            if (!content) return fallback;
            // content is in texture pixel space; the sprite's own position already carries the centering
            // shift applied to composite tiles, and its scale the render scale.
            return new (0, $6qzqq.Rectangle)(this.sprite.position.x + content.x * this.sprite.scale.x, this.sprite.position.y + content.y * this.sprite.scale.y, content.width * this.sprite.scale.x, content.height * this.sprite.scale.y);
        }, this.// Reports false for a blank stand-in sprite: the V2 chest draws its real art in the TILEMAP and
        // keeps only an invisible 32x32 marker here, so there is no shape here to trace and the caller
        // outlines the map tiles instead. Anything with actual art (a door, an outpost, a dropped item)
        // traces itself.
        setHighlighted = (on)=>{
            if (!this.highlightFrame()) return false;
            if (!this.entityHighlight) this.entityHighlight = new (0, $95f2390044c89843$export$b6cf31fac6564392)({
                artContainer: this.container,
                frame: this.highlightFrame
            });
            this.entityHighlight.set(on);
            return true;
        }, this.highlightFrame = ()=>{
            // A blank stand-in sprite has nothing to outline; say so and take the ring instead.
            if (!this.spriteId || this.spriteId.startsWith("blank")) return null;
            const art = this.animation ?? this.sprite;
            const texture = this.animation ? this.animation.textures[this.animation.currentFrame] : this.sprite?.texture;
            if (!art || !texture?.valid) return null;
            return {
                texture: texture,
                x: art.position.x,
                y: art.position.y,
                scaleX: art.scale.x,
                scaleY: art.scale.y,
                anchorX: art.anchor?.x ?? 0,
                anchorY: art.anchor?.y ?? 0
            };
        }, this.setWorldOverlayItem = (item)=>{
            this.worldOverlayItem = item;
        };
        this.spriteMeta = spriteMeta;
        const { color: color = 0xffffff, name: name, scale: scale = 1.0, alpha: alpha = 1.0, animated: animated, animationSpeed: animationSpeed = 0.167, rotating: rotating, looping: looping = true, rotation: rotation, onLoopDone: onLoopDone, supportLabel: supportLabel } = spriteMeta;
        this.spriteId = name;
        this.supportLabel = supportLabel;
        this.scaleValue = scale;
        if (withClickArea) {
            this.clickArea = new (0, $a64b70167386625f$export$98e91636974d835d)();
            if (this.clickArea.parent) this.clickArea.parent.removeChild(this.parentArea);
            // Hover/hit region is sized to the actual rendered art in updateClickAreaBounds()
            // (called below, after the sprite is built). We deliberately draw NOTHING here and
            // rely on pixi's `hitArea` Rectangle instead of a filled Graphics — see that method.
            this.addChild(this.clickArea);
        }
        this.container = new (0, $gwPoJ.Graphics)();
        this.addChild(this.container);
        this.originalColor = color;
        this.currentColor = color;
        let resource = (0, $1f08f7b8f85adf9e$export$42d948b5d3f64a60)("humanoid");
        // A sheet that failed to load leaves the resource present but unparsed, so `.spritesheet`
        // is undefined and reading `.animations` off it throws -- inside a constructor, on the
        // entity-creation path, which takes out every renderable in the room and leaves a world
        // with terrain and no characters in it. One unreachable file should cost one sprite, not
        // all of them, so degrade the way lpc_sprite.setup() already does.
        const sheet = resource?.spritesheet;
        const isAnimated = animated !== undefined ? animated : !!sheet?.animations[name];
        this._scale = scale;
        // `animated: true` can be passed explicitly, so the frames still have to be there before
        // this branch dereferences them.
        if (isAnimated && sheet?.animations[name]) {
            this.animation = new (0, $d3fD1.AnimatedSprite)(sheet.animations[name]);
            this.animation.scale.set(0.35);
            // set speed, start playback and add it to the stage
            this.animation.animationSpeed = animationSpeed;
            this.animation.tint = color;
            this.animation.alpha = alpha;
            this.animation.play();
            this.animation.scale.set(scale);
            this.container.addChild(this.animation);
            if (!looping) {
                this.animation.loop = false;
                if (onLoopDone) this.animation.onComplete = onLoopDone;
            }
        } else {
            let tileIdToUse = name;
            let texture;
            if (name.includes(":")) {
                const [resourceName, tileId] = name.split(":");
                tileIdToUse = `${resourceName}-${tileId}`;
                resource = (0, $1f08f7b8f85adf9e$export$42d948b5d3f64a60)(resourceName);
                const tileset = spriteMeta?.tileMapMetaProvider?.getTilesetById(resourceName);
                if (tileset) {
                    const tilesetTileMeta = tileset.tiles[Number(tileId) - 1];
                    if (tilesetTileMeta) {
                        const compositeTileId = tilesetTileMeta.compositeTileId;
                        if (compositeTileId) texture = (0, $86e9e05f3ebc1d8f$export$171acc6ba80afe2).instance.extract(spriteMeta.tileMapMetaProvider, tileset.tilesetId, compositeTileId);
                    }
                }
            }
            if (!texture) texture = resource?.textures[tileIdToUse];
            if (texture) {
                this.sprite = new (0, $7Bs2Z.Sprite)(texture);
                if (name.includes(":")) {
                    this.sprite.transform.position.x -= texture.width / 2;
                    this.sprite.transform.position.y -= name.endsWith($15caf4b106aaadb3$var$GROUND_ANCHOR_SUFFIX) ? $15caf4b106aaadb3$var$groundAnchorLift(texture, name) : 14;
                }
                this.sprite.tint = color;
                this.sprite.scale.set(scale);
                this.container.addChild(this.sprite);
            }
        }
        this.updateClickAreaBounds();
        this.labelText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("entityLabel").color(0x00ff00).render();
        this.labelText.visible = false;
        this.labelText.x = -this.container.width * 0.23;
        this.labelText.y = -this.container.height * 0.7;
        this.addChild(this.labelText);
        if (rotation !== undefined) this.container.angle = rotation;
        if (rotating) this.startRotation();
        this.animatedFeedback = new (0, $5f817afe83d87a88$export$9ec831f4c1f089b1)();
    }
    cleanup() {
        if (this.rotationInterval !== undefined) {
            clearInterval(this.rotationInterval);
            this.rotationInterval = undefined;
        }
    }
    destroy(options) {
        this.cleanup();
        super.destroy(options);
    }
    updateName(name) {
        if (!this.supportLabel) return;
        if (name) {
            this.labelText.text = name.replace(/ /g, "\n");
            this.labelText.visible = true;
        } else this.labelText.visible = false;
    }
    fragment(_, callback) {
        const surface = new (0, $gwPoJ.Graphics)();
        surface.scale.set(this._scale);
        surface.rotation = this.container.rotation;
        this.parent.addChild(surface);
        const f = this.animation ? this.animation.textures[this.animation.currentFrame] : this.sprite?.texture;
        const { width: width, height: height } = f._frame;
        surface.x -= width / 2;
        surface.y -= height / 2;
        (0, $4264eae3240561ee$export$cc249234599c5a64)(surface, f, {
            onSpawned: ()=>callback?.(),
            cacheKey: this.spriteId
        });
    }
    updateSpriteId(spriteId) {
        if (!spriteId) return;
        if (this.spriteId === spriteId) // noop, it has changed already
        return;
        // todo ... this only really supports non-animated sprites
        if (this.sprite) this.container.removeChild(this.sprite);
        if (this.animation) this.container.removeChild(this.animation);
        this.spriteId = spriteId;
        let resource = (0, $1f08f7b8f85adf9e$export$42d948b5d3f64a60)("humanoid");
        let tileIdToUse = spriteId;
        if (spriteId.includes(":")) {
            const [resourceName, tileId] = spriteId.split(":");
            tileIdToUse = `${resourceName}-${tileId}`;
            resource = (0, $1f08f7b8f85adf9e$export$42d948b5d3f64a60)(resourceName);
        }
        if (resource) {
            // `resource` being present says only that the loader knows the url, not that the sheet
            // behind it parsed -- a failed or still-parsing sheet leaves `.spritesheet` (or its
            // `.animations`) undefined, and reading through it throws inside this constructor, on
            // the entity-creation path, taking out every renderable in the room. Same reason the
            // constructor above guards; this is the second door into the same trap.
            const isAnimated = !!resource.spritesheet?.animations?.[spriteId];
            if (isAnimated) {
                const { color: color = 0xffffff, scale: scale = 1.0, alpha: alpha = 1.0, animationSpeed: animationSpeed = 0.167, looping: looping = true, onLoopDone: onLoopDone } = this.spriteMeta;
                this.animation = new (0, $d3fD1.AnimatedSprite)(resource.spritesheet.animations[spriteId]);
                this.animation.scale.set(0.35);
                // set speed, start playback and add it to the stage
                this.animation.animationSpeed = animationSpeed;
                this.animation.tint = color;
                this.animation.alpha = alpha;
                this.animation.play();
                this.animation.scale.set(scale);
                this.container.addChild(this.animation);
                if (!looping) {
                    this.animation.loop = false;
                    if (onLoopDone) this.animation.onComplete = onLoopDone;
                }
            } else {
                const texture = resource.textures?.[tileIdToUse];
                if (texture) {
                    this.sprite = new (0, $7Bs2Z.Sprite)(texture);
                    this.sprite.tint = this.currentColor;
                    this.sprite.scale.set(this.scaleValue);
                    this.container.addChild(this.sprite);
                }
            }
        }
        if (this.grounded) this.anchorAtGroundPoint();
        this.updateClickAreaBounds();
    }
    getYOffset() {
        if (this.grounded) return 0;
        // Both of these place their art themselves and must not be lifted again: "-exact" is a flat
        // decal drawn from the location down, ":ground" has already been anchored to the sole line.
        if (this.spriteId.includes("-exact") || this.spriteId.endsWith($15caf4b106aaadb3$var$GROUND_ANCHOR_SUFFIX)) return 0;
        return super.getYOffset();
    }
    // Floating feedback over this sprite. A running body's dust trail does NOT come through here --
    // see LpcComposite.feedback and FootDust: it is ground art, z-sorted in the world surface, and
    // EntityRenderingManager.feedback routes it away before it reaches a renderable.
    feedback(entity, image, label, params) {
        (0, $5UG8I.logger).debug({
            tags: [
                "sprite",
                "feedback"
            ]
        }, "Feedback");
        this.animatedFeedback.setup(0, this.worldOverlayItem.height / 2, image, label, this.worldOverlayItem, params, this.sprite);
    }
}
/**
 * How far to raise ground-anchored tile art so its lowest visible pixel lands on the sole line.
 *
 * Measured from the texture rather than assumed from its height, because tile art is not reliably
 * painted down to the foot of its cell. `textureContentBounds` caches per texture and returns null
 * with no renderer (tests, or a sprite built before init), where the cell's own foot is the right
 * answer to fall back to.
 */ const $15caf4b106aaadb3$var$groundAnchorLift = (texture, cacheKey)=>{
    const content = (0, $35a6592763403c18$export$46429b068ef0a2d5)(texture, cacheKey);
    const foot = content ? content.y + content.height : texture.height;
    return foot - $15caf4b106aaadb3$var$GROUND_CONTACT_OFFSET;
};



class $6d7a9fd00230699d$export$eb38fb18cfba1d64 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(){
        super();
        this.drawCircle(0, 0, 1);
    }
}



var $8Odl4 = parcelRequire("8Odl4");

class $a372f7647b536fce$export$3a0f78411bc2215d extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(entity){
        super(), this.startTs = 0, this.i = 0, this.size = 0, this.pulse = ()=>{
            if (this.entity?.isDead() || this.detonted) {
                this.visible = false;
                return;
            }
            this.i++;
            let color = this.i % 2 === 0 ? 0x80deea : 0xb3ebf2;
            this.drawArea(color, this.i, 2);
            if (this.pulseDelay > 50) {
                this.pulseDelay *= 0.8;
                this.pulseTimeout = setTimeout(this.pulse, this.pulseDelay);
            } else this.pulseTimeout = setTimeout(this.pulse, this.pulseDelay);
        }, this.detonate = ()=>{
            if (this.detonted) return;
            clearInterval(this.tickPlayInterval);
            clearTimeout(this.pulseTimeout);
            this.detonted = true;
            let maxRadius = 100;
            let i = 0;
            (0, $8Odl4.sound).play("explosion");
            const interval = setInterval(()=>{
                if (this.entity?.isDead() || this.size > maxRadius) {
                    this.clear();
                    clearInterval(interval);
                    return;
                }
                const increment = maxRadius / 17;
                this.size += increment;
                i++;
                this.drawArea(i % 2 === 0 ? 0xff0000 : 0xefefef, 0, this.size);
            }, 17);
        }, this.drawArea = (color, i, radius)=>{
            super.clear();
            super.beginFill(color);
            super.lineStyle(10, color);
            super.drawCircle(0, 0, radius + (i % 2 === 0 ? 0 : 1));
            super.endFill();
        };
        this.entity = entity;
        this.drawArea(0xb3ebf2, 0, 2);
        this.pulseDelay = 500;
        this.startTs = Date.now();
        this.pulse();
        this.tickPlayInterval = setInterval(()=>{
            (0, $8Odl4.sound).play("clocktick", {
                volume: 0.1,
                speed: 0.85 + Math.min(0.15, Math.random())
            });
        }, 500);
    }
    remove() {
        super.remove();
        clearInterval(this.tickPlayInterval);
    }
}




// Well short of the bow's 160px reach, with room for a 10Hz server step plus a round trip of a
// 500px/s arrow, so the player's own arrow still counts as just loosed when its first update lands.
const $8b020fb41ab0fc7e$var$FRESH_LAUNCH_PX = 100;
class $8b020fb41ab0fc7e$export$f90411c24f6aebf8 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(color = 0xff0000, alpha = 1.0, bowOffset){
        super(), this.bowOffset = bowOffset;
        super.beginFill(0xff0000, alpha);
        super.lineStyle(2, 0xff0000, alpha);
        super.drawRoundedRect(5, 0, 9, 1, 1);
        super.endFill();
        super.beginFill(0xffffff, 0.35);
        super.lineStyle(2, 0xffffff, 0.35);
        super.drawRoundedRect(2, 0, 4, 1, 1);
        super.endFill();
        super.beginFill(0xffffff, 0.1);
        super.lineStyle(2, 0xffffff, 0.1);
        super.drawRoundedRect(0, 0, 3, 1, 1);
        super.endFill();
    }
    /**
     * Where this arrow left the bow, if it is still near enough to it to have just been loosed. An
     * arrow first seen further out came into view mid-flight and has no release to show. Call after
     * the first updateRenderedLocationFrom, which is what finds the bow.
     */ launchPoint(entity, freshPx = $8b020fb41ab0fc7e$var$FRESH_LAUNCH_PX) {
        const { origin: origin, location: location } = entity;
        if (entity.spriteId !== (0, $cb689cfa16c444ba$export$6e47733a887561b3).bow.bulletSpriteId || !origin || !location) return undefined;
        // A cross-floor arrow from a shooter on another storey has no bow on this one.
        if (entity.crossFloorProjectile && !this.launchOffset) return undefined;
        if (Math.hypot(location.x - origin.x, location.y - origin.y) > freshPx) return undefined;
        const offset = this.launchOffset ?? {
            x: 0,
            y: 0
        };
        return {
            x: origin.x + offset.x,
            y: origin.y + offset.y
        };
    }
    updateRenderedLocationFrom(entity) {
        if (!this.launchOffset && entity.spriteId === (0, $cb689cfa16c444ba$export$6e47733a887561b3).bow.bulletSpriteId) {
            const grip = this.bowOffset?.(entity);
            if (grip) {
                // Project aimed arrows from the bow through the cursor below.
                const muzzle = entity.crossFloorProjectile ? 0 : ((0, $cb689cfa16c444ba$export$6e47733a887561b3).bow.muzzleFireOffset ?? 0) + 1;
                this.launchOffset = {
                    x: grip.x - Math.cos(entity.movement.angle) * muzzle,
                    y: grip.y - Math.sin(entity.movement.angle) * muzzle
                };
            }
        }
        if (entity.projectileTarget && entity.origin) {
            const dx = entity.projectileTarget.x - entity.origin.x;
            const dy = entity.projectileTarget.y - entity.origin.y;
            const lengthSquared = dx * dx + dy * dy;
            // Continue the same projection beyond the cursor. Clamping at 1 switches
            // back to the simulation's heading and puts a visible kink in the flight.
            const progress = lengthSquared > 0 ? Math.max(0, ((entity.location.x - entity.origin.x) * dx + (entity.location.y - entity.origin.y) * dy) / lengthSquared) : 1;
            const offset = this.launchOffset ?? {
                x: 0,
                y: 0
            };
            this.x = entity.location.x + offset.x * (1 - progress);
            this.y = entity.location.y + offset.y * (1 - progress);
            this.rotation = Math.atan2(dy - offset.y, dx - offset.x);
            this.addSidecar(entity);
            return;
        }
        if (entity.crossFloorProjectile) this.rotation = entity.movement.angle;
        if (!this.launchOffset) return super.updateRenderedLocationFrom(entity);
        this.x = entity.location.x + this.launchOffset.x;
        this.y = entity.location.y + this.launchOffset.y;
        this.addSidecar(entity);
    }
}




parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");

class $0a6164d33da4c314$export$462e530a9b3886e4 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(color = 0xff00ff){
        super();
        super.beginFill(color);
        super.lineStyle(4, color);
        super.drawPolygon([
            new (0, $6qzqq.Point)(0, 0),
            new (0, $6qzqq.Point)(50, 50)
        ]);
        super.drawPolygon([
            new (0, $6qzqq.Point)(50, 0),
            new (0, $6qzqq.Point)(0, 50)
        ]);
        super.endFill();
    }
}







const $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1 = (itemTypeMeta)=>{
    if (!itemTypeMeta) return;
    return {
        component: itemTypeMeta.type,
        color: itemTypeMeta.color
    };
};
const $1a2d6d21d6b0fac8$export$b7be1ee14f302b62 = (entity, raceToUse, sexToUse)=>{
    const race = raceToUse || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$2a4812914c68f73e));
    const hair = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$abac18ec637a6d99));
    const nose = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$523e552deae170d8)[race]);
    const eyes = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[race]);
    const sex = sexToUse || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$1625117e6bf800e7)[race]);
    return {
        race: race,
        bodyColor: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$af1b56af8a451d06)[race]),
        hair: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$46ee3469290462e6)[sex]),
        hairColor: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$c2ef2c5bddebe408)[hair]),
        sex: sex,
        nose: nose,
        noseColor: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$f5fdec393d34621)[nose]),
        eyes: eyes,
        eyesColor: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$ffaabf2abfa69206)[eyes]),
        inventoryAppearanceHash: (0, $f684496fff50a7a1$export$fe4683c17d6b2a37)(entity?.inventory)
    };
};
const $1a2d6d21d6b0fac8$export$f46d9a45b447180e = (appearanceSpec)=>{
    const pick = (t)=>{
        if (Array.isArray(t)) return (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)(t);
        return t;
    };
    const { race: race = "human", sex: sex = "male", age: age = "young" } = appearanceSpec;
    const eyes = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[race]);
    let hairColor;
    let hair = appearanceSpec.hair === "none" ? undefined : pick(appearanceSpec.hair) || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$abac18ec637a6d99));
    let nose = appearanceSpec.nose === "none" ? undefined : pick(appearanceSpec.nose) || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$523e552deae170d8)[race]);
    if (age === "old" && !appearanceSpec.hairColor) hairColor = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)([
        "gray",
        "white"
    ]);
    else hairColor = pick(appearanceSpec.hairColor);
    if (age === "old" && sex === "male") {
        hair = "balding";
        nose = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)([
            undefined,
            "big"
        ]);
    }
    if (age === "old" && sex === "female") // hair = "loose"
    hair = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)([
        "long_center_part",
        "loose",
        "shortknot"
    ]);
    const bodyColor = pick(appearanceSpec.bodyColor);
    return {
        race: race,
        bodyColor: bodyColor || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$af1b56af8a451d06)[race]),
        hair: hair,
        hairColor: hairColor || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$c2ef2c5bddebe408)[hair]),
        sex: sex,
        nose: nose || (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$523e552deae170d8)[race]),
        noseColor: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$f5fdec393d34621)[nose]),
        eyes: eyes,
        eyesColor: (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$ffaabf2abfa69206)[eyes]),
        inventoryAppearanceHash: "",
        ...appearanceSpec.emberSprite ? {
            emberSprite: appearanceSpec.emberSprite
        } : {}
    };
};






/**
 * The sprite registry: which sheets a component is made of, as data.
 *
 * The pipeline around this file -- what generates what, and how to change it -- is written up in
 * `docs/sprite-lab.md`.
 *
 * This is the shape `lpc-forge.ts`'s branching turns into. An entry is either
 *
 *   - **templated** -- a list of layers, each a z-index and a path over `{sex}` and `{variant}`,
 *     plus the map from the game's `Color` names to the variant names the art actually uses; or
 *   - **explicit** -- a flat `sex/colour -> sheets` table, for the handful of components whose
 *     shape no template describes.
 *
 * The two exist because the registry is DERIVED from the forge and verified against it (see
 * tools/src/derive-lpc-registry.ts): anything the template form cannot reproduce exactly falls
 * back to the table rather than shipping a near-miss.
 *
 * ## What is deliberately not here
 *
 * The colour list. `HairColors`, `RaceColors` and the rest stay the source of which colours a
 * component offers and, because the first entry is the fallback, of what an unrecognised colour
 * renders as. The registry only says where a colour's art lives. Keeping the list in one place
 * means adding a colour is still one edit, and `slot_colors.ts` is where both sides read it.
 */ const $77edb5cf00d051a9$export$9e272dc22f373a3b = (entry, requested)=>{
    const colors = entry?.colors || [];
    return colors.includes(requested) ? requested : colors[0];
};
const $77edb5cf00d051a9$export$ffcd8ef8c2ace575 = (entry, { color: color, requestedColor: requestedColor, sex: sex })=>{
    if (!entry) return [];
    if (entry.explicit) {
        // An explicit table is keyed by what was ASKED for, not by the resolved colour: it was
        // captured per requested colour and already has the fallback baked into each row.
        const found = entry.explicit[`${sex}/${requestedColor}`];
        return (found || []).map((s)=>({
                entityId: s.path,
                zIndex: s.z,
                ...s.type ? {
                    type: s.type
                } : {}
            }));
    }
    if (!entry.layers) return [];
    // A component with a variant map that has nothing for this colour has no art to point at.
    // (Only reachable when the component declares no colours at all, since the fallback otherwise
    // guarantees a supported one.)
    const variant = entry.variants ? entry.variants[color] : undefined;
    if (entry.variants && variant === undefined) return [];
    return entry.layers.map((layer)=>({
            entityId: layer.path.replace("{sex}", sex).replace("{variant}", variant ?? ""),
            zIndex: layer.z,
            ...layer.type ? {
                type: layer.type
            } : {}
        }));
};


const $71594ae8b880a354$export$cb53670f886c3e49 = (race)=>(0, $30de942853303b03$export$5bfd8bfbf03dc8d7).body?.[race]?.shadow;
const $71594ae8b880a354$export$a4bccc16e13fc57c = (race)=>(0, $30de942853303b03$export$5bfd8bfbf03dc8d7).body?.[race]?.groundAnchor;
const $71594ae8b880a354$export$a4e4c845ec201a56 = (race)=>(0, $30de942853303b03$export$5bfd8bfbf03dc8d7).body?.[race]?.depthBias ?? 0;
const $71594ae8b880a354$export$7e0cb3ff08e322d2 = (race)=>(0, $30de942853303b03$export$5bfd8bfbf03dc8d7).body?.[race]?.placement;
let $71594ae8b880a354$export$b2ae80db0884a5f7 = (0, $30de942853303b03$export$9add49f5ed926deb);
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>catalog.source.sprites.dimensions, (next)=>{
    $71594ae8b880a354$export$b2ae80db0884a5f7 = next;
});
/**
 * Every descriptor now comes from the registry. See `docs/sprite-lab.md` for the whole pipeline.
 *
 * What used to be here was 600 lines of `if (component === ...)` whose real content was a set of
 * path templates and, per component, a translation from the game's `Color` names to the ones the
 * art files actually use (`brown` -> `dark_brown`, `white` -> `beige`, `gold` -> `8`). That table
 * is data, and it now lives in the sprite registry (`content/game/sprites/registry.json`), which
 * the game reads through the compiled content catalog.
 *
 * The registry was DERIVED from this file's own answers over every descriptor the enums can
 * produce and verified by re-expanding all of them, so the swap is a capture rather than a
 * rewrite. `lpc_forge.test.ts` holds the snapshot of all 2,303 cases that proves it, and
 * `yarn derive:lpc --check` proves the registry still matches its source.
 *
 * The one rule that stayed in code is the colour fallback -- a component asked for a colour it
 * has no art for renders its first one -- because it is identical across every slot and depends
 * on the enum's declaration order. See `slot_colors.ts`.
 *
 * Behaviour note: an unknown component used to throw here for some slots (reading `colors[0]` off
 * an undefined colour list) and return `[]` for others. It is `[]` everywhere now. Saved
 * characters outlive the enums, and a removed hair type should cost that layer, not the character.
 */ const $71594ae8b880a354$var$fromRegistry = (slot, component, color, sex)=>{
    const entry = (0, $30de942853303b03$export$5bfd8bfbf03dc8d7)[slot]?.[component];
    if (!entry) return [];
    return (0, $77edb5cf00d051a9$export$ffcd8ef8c2ace575)(entry, {
        color: (0, $77edb5cf00d051a9$export$9e272dc22f373a3b)(entry, color),
        requestedColor: color,
        sex: sex
    });
};
/** Slots whose descriptor is `{component, color}` plus a sex -- everything except the body. */ const $71594ae8b880a354$var$forgeComponent = (slot)=>(descriptor, sex)=>descriptor ? $71594ae8b880a354$var$fromRegistry(slot, descriptor.component, descriptor.color, sex) : [];
const $71594ae8b880a354$export$f97c59eb28641f1e = (body)=>body ? $71594ae8b880a354$var$fromRegistry("body", body.race, body.color, body.sex) : [];
const $71594ae8b880a354$export$43128cd69e2d5491 = (weapon)=>{
    return [
        "longsword",
        "rapier",
        "mace",
        "scythe",
        "saber",
        "flail",
        "halberd",
        "waraxe"
    ].includes((0, $bcc08db80bb560e5$export$6362571790b734f2)(weapon));
};
const $71594ae8b880a354$export$eb439c7a658b0b8 = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("weapon")(descriptor, sex);
const $71594ae8b880a354$export$55464a27c08f23fe = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("hair")(descriptor, sex);
const $71594ae8b880a354$export$2d6e2f919ad84c9c = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("nose")(descriptor, sex);
const $71594ae8b880a354$export$d96ba5ecdac9f401 = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("eyes")(descriptor, sex);
const $71594ae8b880a354$export$402b088ac9ea61f6 = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("pants")(descriptor, sex);
const $71594ae8b880a354$export$3a0bfd4ad2f621c2 = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("shirt")(descriptor, sex);
const $71594ae8b880a354$export$12bd863799b8972b = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("armor")(descriptor, sex);
const $71594ae8b880a354$export$cb3c55b5933062cc = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("shoes")(descriptor, sex);
const $71594ae8b880a354$export$f27f48c85cec4c5c = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("shield")(descriptor, sex);
const $71594ae8b880a354$export$86d144b8cdae5638 = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("cape")(descriptor, sex);
const $71594ae8b880a354$export$8b17c24843c3a9ac = (descriptor, sex)=>$71594ae8b880a354$var$forgeComponent("bauldron")(descriptor, sex);
const $71594ae8b880a354$export$68fee8ec0f096607 = (appearance)=>{
    if ((0, $bcc08db80bb560e5$export$1efc94ac0295d345)(appearance.race) === "spikes1") return "inactive";
};
const $71594ae8b880a354$export$fed43fae8d163f04 = (race, weaponType)=>{
    const own = (0, $bf6244e5cc9aa116$export$2eff43e195cfa29d)[race];
    if (own && !(0, $bf6244e5cc9aa116$export$2a4812914c68f73e).includes(race)) return own;
    return (0, $bf6244e5cc9aa116$export$448f4eb18cb556ce)[weaponType || "none"] || own;
};
const $71594ae8b880a354$export$efde97289773c11d = ({ body: body, weapon: weapon, hair: hair, nose: nose, eyes: eyes, sex: sex, pants: pants, shirt: shirt, armor: armor, shoes: shoes, shield: shield, cape: cape, bauldron: bauldron })=>{
    const bodyDescriptors = $71594ae8b880a354$export$f97c59eb28641f1e(body);
    const weaponDescriptors = $71594ae8b880a354$export$eb439c7a658b0b8(weapon, sex || body.sex);
    const hairDescriptors = $71594ae8b880a354$export$55464a27c08f23fe(hair, sex || body.sex);
    const noseDescriptors = $71594ae8b880a354$export$2d6e2f919ad84c9c(nose, sex || body.sex);
    const eyesDescriptors = $71594ae8b880a354$export$d96ba5ecdac9f401(eyes, sex || body.sex);
    const pantsDescriptors = $71594ae8b880a354$export$402b088ac9ea61f6(pants, sex || body.sex);
    const shirtDescriptors = $71594ae8b880a354$export$3a0bfd4ad2f621c2(shirt, sex || body.sex);
    const armorDescriptors = $71594ae8b880a354$export$12bd863799b8972b(armor, sex || body.sex);
    const shoeDescriptors = $71594ae8b880a354$export$cb3c55b5933062cc(shoes, sex || body.sex);
    const shieldDescriptors = $71594ae8b880a354$export$f27f48c85cec4c5c(shield, sex || body.sex);
    const capeDescriptors = $71594ae8b880a354$export$86d144b8cdae5638(cape, sex || body.sex);
    const bauldronDescriptors = $71594ae8b880a354$export$8b17c24843c3a9ac(bauldron, sex || body.sex);
    let descriptors = {
        body: bodyDescriptors,
        weapon: weaponDescriptors,
        hair: hairDescriptors,
        pants: pantsDescriptors,
        shirt: shirtDescriptors,
        armor: armorDescriptors,
        shoes: shoeDescriptors,
        shield: shieldDescriptors,
        cape: capeDescriptors,
        bauldron: bauldronDescriptors,
        nose: noseDescriptors,
        eyes: eyesDescriptors
    };
    return descriptors;
};






var $1avo5 = parcelRequire("1avo5");





parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $9Pi8W = parcelRequire("9Pi8W");
var $gwPoJ = parcelRequire("gwPoJ");

parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
const $ec5c35dbffc1f325$export$2bd980d3c871717d = 24;
const $ec5c35dbffc1f325$export$46ad086a5552f2fb = (icon, size, color)=>{
    const glyph = new (0, $gwPoJ.Graphics)();
    $ec5c35dbffc1f325$export$8674a23a9be99236(glyph, icon);
    glyph.scale.set(size / $ec5c35dbffc1f325$export$2bd980d3c871717d);
    glyph.tint = color;
    return glyph;
};
// By command name: the role orders, then the entity interaction verbs (InteractionType), then the
// HUD's own slices and the tile verbs.
const $ec5c35dbffc1f325$var$COMMAND_ICONS = {
    "forager:forage": "axe",
    "forager:feed_fire": "flame",
    "forager:head_back": "tent",
    "forager:repair": "hammer",
    "defender:defend": "shield",
    "defender:hold": "flag",
    "defender:watch": "eye",
    "lord:hold": "flag",
    "lord:watch": "eye",
    "lord:talk": "speech",
    "lord:next": "speech",
    "lord:story": "speech",
    "navigation:retry": "retry",
    take: "hand",
    inventory: "sack",
    burn: "flame",
    button: "spark",
    crown: "crown",
    command: "scroll",
    food: "meat",
    chat: "speech",
    help: "hand",
    "install-hatch": "pick",
    "remove-hatch": "pick",
    "repair-hatch": "pick",
    "open-hatch": "hand",
    "close-hatch": "hand",
    descend: "stairs",
    ascend: "stairs-up",
    __watch: "eye",
    "ember:kick": "boot",
    "ember:play_mode": "swords",
    dismantle: "pick",
    inspect: "lens",
    harvest: "sickle"
};
// A few verbs mean something different on a different entity, and say so in their label: "take" on
// a chest is "Open", which deserves the chest rather than a grabbing hand.
const $ec5c35dbffc1f325$var$LABEL_ICONS = {
    Open: "chest",
    Interact: "wave"
};
const $ec5c35dbffc1f325$export$5bb74e7e1a2132f0 = (command, label)=>{
    if (label && $ec5c35dbffc1f325$var$LABEL_ICONS[label]) return $ec5c35dbffc1f325$var$LABEL_ICONS[label];
    if ($ec5c35dbffc1f325$var$COMMAND_ICONS[command]) return $ec5c35dbffc1f325$var$COMMAND_ICONS[command];
    if (command.endsWith(":change_role")) return "swap";
    if (command.endsWith(":follow")) return "footsteps";
    return "dot";
};
const $ec5c35dbffc1f325$export$37127edc63359470 = (page, emoji)=>{
    if (page === "forager") return "axe";
    if (page === "defender") return "shield";
    if (page === "lord") return "person";
    if (emoji === "\u270B") return "hand";
    if (emoji === "\uD83D\uDC64") return "person";
    return undefined;
};
const $ec5c35dbffc1f325$var$stroke = (g, width = 2.4)=>g.lineStyle({
        width: width,
        color: 0xffffff,
        alpha: 1,
        cap: (0, $gwPoJ.LINE_CAP).ROUND,
        join: (0, $gwPoJ.LINE_JOIN).ROUND
    });
const $ec5c35dbffc1f325$var$solid = (g)=>g.lineStyle(0).beginFill(0xffffff, 1);
const $ec5c35dbffc1f325$export$8674a23a9be99236 = (g, icon)=>{
    const maxLength = (0, $gwPoJ.GRAPHICS_CURVES).maxLength;
    (0, $gwPoJ.GRAPHICS_CURVES).maxLength = 1.5;
    try {
        $ec5c35dbffc1f325$var$drawGlyph(g, icon);
    } finally{
        (0, $gwPoJ.GRAPHICS_CURVES).maxLength = maxLength;
    }
};
const $ec5c35dbffc1f325$var$drawGlyph = (g, icon)=>{
    switch(icon){
        case "axe":
            $ec5c35dbffc1f325$var$stroke(g, 2.8).moveTo(-8.5, 11).lineTo(3.5, -6.5);
            $ec5c35dbffc1f325$var$solid(g).moveTo(-0.5, -9.5).lineTo(6.5, -12).quadraticCurveTo(14.5, -5.5, 11, 3).lineTo(3.8, -2.2).closePath().endFill();
            $ec5c35dbffc1f325$var$stroke(g, 2.4).moveTo(1.2, -8.2).lineTo(-2.4, -11.2);
            break;
        case "flame":
            $ec5c35dbffc1f325$var$solid(g).moveTo(0, 11).bezierCurveTo(-7, 11, -9.5, 4.5, -6.5, -0.5).bezierCurveTo(-5, -3, -3.5, -2.5, -3, -5).bezierCurveTo(-1.5, -7.5, 1, -9, 0.5, -12).bezierCurveTo(5, -9, 9.5, -3.5, 8.5, 3).bezierCurveTo(8, 8, 4.5, 11, 0, 11);
            g.beginHole().moveTo(0.5, 9.4).bezierCurveTo(-3, 9.4, -4.2, 6.2, -2.8, 3.4).bezierCurveTo(-1.8, 1.6, -0.4, 1, 0.2, -1.8).bezierCurveTo(2.4, 0.4, 4.4, 3.2, 3.8, 6).bezierCurveTo(3.4, 8.4, 2, 9.4, 0.5, 9.4);
            g.endHole().endFill();
            break;
        case "tent":
            $ec5c35dbffc1f325$var$solid(g).moveTo(-11, 9.5).lineTo(0, -7.5).lineTo(11, 9.5).closePath();
            g.beginHole().moveTo(-3.6, 9.5).lineTo(0, 2.6).lineTo(3.6, 9.5).closePath().endHole().endFill();
            $ec5c35dbffc1f325$var$stroke(g, 2).moveTo(0, -7).lineTo(-3, -11.5).moveTo(0, -7).lineTo(3, -11.5);
            break;
        case "hammer":
            $ec5c35dbffc1f325$var$stroke(g, 2.8).moveTo(-8.5, 10).lineTo(2.5, -1);
            $ec5c35dbffc1f325$var$solid(g).moveTo(1.4, -11.8).lineTo(11.8, -1.4).lineTo(7.6, 2.8).lineTo(-2.8, -7.6).closePath().endFill();
            $ec5c35dbffc1f325$var$solid(g).moveTo(-2.8, -7.6).lineTo(1.4, -11.8).lineTo(-1.6, -12.4).lineTo(-4.6, -9.4).closePath().endFill();
            break;
        case "footsteps":
            $ec5c35dbffc1f325$var$solid(g);
            g.drawEllipse(-5, 1.6, 4, 5.4);
            g.drawEllipse(-5, 9.8, 3, 2.2);
            g.drawEllipse(5, -7.8, 4, 5.4);
            g.drawEllipse(5, 0.4, 3, 2.2);
            g.endFill();
            break;
        case "swap":
            $ec5c35dbffc1f325$var$stroke(g, 2.6);
            g.moveTo(-9.5, -4.5).lineTo(8.5, -4.5).moveTo(4.2, -9).lineTo(8.8, -4.5).lineTo(4.2, 0);
            g.moveTo(9.5, 5).lineTo(-8.5, 5).moveTo(-4.2, 0.5).lineTo(-8.8, 5).lineTo(-4.2, 9.5);
            break;
        case "shield":
            $ec5c35dbffc1f325$var$solid(g).moveTo(0, -11.5).lineTo(9.5, -8.5).lineTo(9.5, -1).bezierCurveTo(9.5, 5.5, 5, 9.5, 0, 12).bezierCurveTo(-5, 9.5, -9.5, 5.5, -9.5, -1).lineTo(-9.5, -8.5).closePath();
            g.beginHole().moveTo(0, -8.6).lineTo(6.8, -6.5).lineTo(6.8, -1).bezierCurveTo(6.8, 3.8, 3.6, 6.8, 0, 8.9).bezierCurveTo(-3.6, 6.8, -6.8, 3.8, -6.8, -1).lineTo(-6.8, -6.5).closePath();
            g.endHole().endFill();
            $ec5c35dbffc1f325$var$stroke(g, 2.4).moveTo(0, -6).lineTo(0, 6).moveTo(-4.4, -1.6).lineTo(4.4, -1.6);
            break;
        case "flag":
            $ec5c35dbffc1f325$var$stroke(g, 2.4).moveTo(-6, -11).lineTo(-6, 10.5);
            $ec5c35dbffc1f325$var$solid(g).moveTo(-5, -10.8).bezierCurveTo(-1, -12.4, 3, -8.6, 9.5, -9.6).lineTo(8, -5.4).lineTo(9.5, -1.2).bezierCurveTo(3, -0.2, -1, -4, -5, -2.4).closePath().endFill();
            g.lineStyle(0).beginFill(0xffffff, 0.55).drawEllipse(-6, 10.8, 5, 1.6).endFill();
            break;
        case "retry":
            {
                const r = 8;
                const from = -Math.PI / 2 + 0.55;
                const to = from + Math.PI * 2 - 1.1;
                $ec5c35dbffc1f325$var$stroke(g, 2.6).moveTo(Math.cos(from) * r, 1 + Math.sin(from) * r);
                g.arc(0, 1, r, from, to);
                const ex = Math.cos(to) * r;
                const ey = 1 + Math.sin(to) * r;
                $ec5c35dbffc1f325$var$solid(g).moveTo(ex + 5, ey + 0.4).lineTo(ex - 1.4, ey + 4.6).lineTo(ex - 1.2, ey - 4.4).closePath().endFill();
                break;
            }
        case "hand":
            $ec5c35dbffc1f325$var$solid(g).drawRoundedRect(-6.5, -1.5, 12.5, 11, 4).endFill();
            $ec5c35dbffc1f325$var$stroke(g, 3);
            g.moveTo(-4.5, 0).lineTo(-4.5, -6.8);
            g.moveTo(-1.4, 0).lineTo(-1.4, -9.4);
            g.moveTo(1.7, 0).lineTo(1.7, -8.8);
            g.moveTo(4.6, 1).lineTo(4.6, -5.6);
            g.moveTo(-5, 4.5).lineTo(-9.6, -0.6);
            break;
        case "wave":
            // A tilted greeting hand, with two motion marks distinct from Take/Help's palm.
            $ec5c35dbffc1f325$var$solid(g).moveTo(-7, 0).lineTo(1, -2).lineTo(4, 5).quadraticCurveTo(5, 9, 1, 10).quadraticCurveTo(-3, 11, -5, 7).closePath().endFill();
            $ec5c35dbffc1f325$var$stroke(g, 2.5);
            g.moveTo(-6, 2).lineTo(-9, -4);
            g.moveTo(-4, 0).lineTo(-7, -8);
            g.moveTo(-1, -1).lineTo(-3, -10);
            g.moveTo(1, 0).lineTo(0, -7);
            g.moveTo(-5, 5).lineTo(-10, 2);
            $ec5c35dbffc1f325$var$stroke(g, 1.8);
            g.moveTo(4, -8).quadraticCurveTo(7, -6, 7, -3);
            g.moveTo(7, -11).quadraticCurveTo(11, -8, 11, -4);
            break;
        case "sack":
            $ec5c35dbffc1f325$var$solid(g).moveTo(-3.2, -5.8).bezierCurveTo(-11.5, -1.5, -11, 10.5, 0, 10.5).bezierCurveTo(11, 10.5, 11.5, -1.5, 3.2, -5.8).closePath().endFill();
            $ec5c35dbffc1f325$var$solid(g).moveTo(-3, -7.4).lineTo(-6.5, -11.2).lineTo(0, -9.4).lineTo(6.5, -11.2).lineTo(3, -7.4).closePath().endFill();
            $ec5c35dbffc1f325$var$stroke(g, 1.6).moveTo(-4.2, -6.6).lineTo(4.2, -6.6);
            break;
        case "spark":
            $ec5c35dbffc1f325$var$solid(g).moveTo(0, -11.5).quadraticCurveTo(1.6, -1.6, 11.5, 0).quadraticCurveTo(1.6, 1.6, 0, 11.5).quadraticCurveTo(-1.6, 1.6, -11.5, 0).quadraticCurveTo(-1.6, -1.6, 0, -11.5).endFill();
            break;
        case "crown":
            $ec5c35dbffc1f325$var$solid(g).moveTo(-10, 5.5).lineTo(-11, -6).lineTo(-5, -0.5).lineTo(0, -9).lineTo(5, -0.5).lineTo(11, -6).lineTo(10, 5.5).closePath();
            g.drawRect(-10, 7.5, 20, 3.2);
            g.drawCircle(-11, -7, 1.9);
            g.drawCircle(0, -10, 1.9);
            g.drawCircle(11, -7, 1.9);
            g.endFill();
            break;
        case "scroll":
            $ec5c35dbffc1f325$var$solid(g).drawRoundedRect(-7.5, -10, 15, 20, 2);
            g.beginHole();
            g.drawRect(-4.5, -5.5, 9, 1.7);
            g.drawRect(-4.5, -1.5, 9, 1.7);
            g.drawRect(-4.5, 2.5, 6, 1.7);
            g.endHole().endFill();
            $ec5c35dbffc1f325$var$solid(g).drawRoundedRect(-10, -11.5, 20, 3.4, 1.7).drawRoundedRect(-10, 8.1, 20, 3.4, 1.7).endFill();
            break;
        case "meat":
            $ec5c35dbffc1f325$var$solid(g).drawCircle(-2.8, -2.8, 7.8).endFill();
            $ec5c35dbffc1f325$var$stroke(g, 3.4).moveTo(1.5, 1.5).lineTo(7.5, 7.5);
            $ec5c35dbffc1f325$var$solid(g).drawCircle(7.6, 10.2, 2.4).drawCircle(10.2, 7.6, 2.4).endFill();
            break;
        case "speech":
            $ec5c35dbffc1f325$var$solid(g).drawRoundedRect(-11, -10, 22, 15.5, 5);
            g.beginHole();
            g.drawCircle(-5, -2.3, 1.7);
            g.drawCircle(0, -2.3, 1.7);
            g.drawCircle(5, -2.3, 1.7);
            g.endHole();
            g.moveTo(-6, 4).lineTo(-8, 10.5).lineTo(0.5, 4.5).closePath().endFill();
            break;
        case "stairs":
        case "stairs-up":
            $ec5c35dbffc1f325$var$solid(g).moveTo(-11, -3.5).lineTo(-6, -3.5).lineTo(-6, 1.5).lineTo(-1, 1.5).lineTo(-1, 6.5).lineTo(4, 6.5).lineTo(4, 11).lineTo(-11, 11).closePath().endFill();
            if (icon === "stairs-up") $ec5c35dbffc1f325$var$stroke(g, 2.4).moveTo(8.5, 11).lineTo(8.5, -11).moveTo(5, -7.5).lineTo(8.5, -11).lineTo(12, -7.5);
            else $ec5c35dbffc1f325$var$stroke(g, 2.4).moveTo(8.5, -11).lineTo(8.5, 11).moveTo(5, 7.5).lineTo(8.5, 11).lineTo(12, 7.5);
            break;
        case "eye":
            $ec5c35dbffc1f325$var$stroke(g, 2.2).moveTo(-11.5, 0).quadraticCurveTo(0, -12, 11.5, 0).quadraticCurveTo(0, 12, -11.5, 0);
            $ec5c35dbffc1f325$var$solid(g).drawCircle(0, 0, 4.8);
            g.beginHole().drawCircle(0, 0, 1.9).endHole().endFill();
            break;
        case "boot":
            $ec5c35dbffc1f325$var$solid(g).moveTo(-7, -11).lineTo(1.5, -11).lineTo(1.5, 0.5).bezierCurveTo(6.5, 1, 10.5, 3, 10.5, 7).lineTo(10.5, 8.5).lineTo(-7, 8.5).closePath();
            g.drawRect(-7, 9.8, 17.5, 2);
            g.endFill();
            break;
        case "swords":
            $ec5c35dbffc1f325$var$stroke(g, 2.8);
            g.moveTo(-10, -10).lineTo(5.5, 5.5).moveTo(2, 9).lineTo(9, 2).moveTo(6.5, 6.5).lineTo(10.5, 10.5);
            g.moveTo(10, -10).lineTo(-5.5, 5.5).moveTo(-2, 9).lineTo(-9, 2).moveTo(-6.5, 6.5).lineTo(-10.5, 10.5);
            break;
        case "pick":
            $ec5c35dbffc1f325$var$stroke(g, 2.8).moveTo(-8.5, 10.5).lineTo(3.5, -1.5);
            // A tapered crescent: two curves between the same two points, the outer one fuller.
            $ec5c35dbffc1f325$var$solid(g).moveTo(-7.5, -8.5).quadraticCurveTo(7.5, -15, 11, 3.5).quadraticCurveTo(5, -7, -7.5, -8.5).endFill();
            break;
        case "lens":
            $ec5c35dbffc1f325$var$stroke(g, 2.6).drawCircle(-2.5, -2.5, 6.8);
            $ec5c35dbffc1f325$var$stroke(g, 3.6).moveTo(2.6, 2.6).lineTo(9.5, 9.5);
            break;
        case "sickle":
            $ec5c35dbffc1f325$var$stroke(g, 2.8).moveTo(-9.5, 11).lineTo(-4.5, 5.5);
            $ec5c35dbffc1f325$var$solid(g).moveTo(-5.5, 5.5).bezierCurveTo(-12, -5, 0, -15.5, 10.5, -4.5).bezierCurveTo(3, -9.5, -6.5, -6.5, -2.5, 3.5).closePath().endFill();
            break;
        case "person":
            $ec5c35dbffc1f325$var$solid(g).drawCircle(0, -5, 5.2);
            g.moveTo(-10.5, 11.5).bezierCurveTo(-10.5, 3.5, -5.5, 1.8, 0, 1.8).bezierCurveTo(5.5, 1.8, 10.5, 3.5, 10.5, 11.5).closePath().endFill();
            break;
        case "chest":
            $ec5c35dbffc1f325$var$solid(g).moveTo(-10.5, -2.5).lineTo(-10.5, -5.5).quadraticCurveTo(0, -12.5, 10.5, -5.5).lineTo(10.5, -2.5).closePath();
            g.drawRect(-10.5, -0.8, 21, 10.8);
            g.beginHole().drawRect(-1.4, 1.2, 2.8, 4).endHole();
            g.endFill();
            break;
        case "figure":
            // Head to toe, for the body as a whole (the character's build), where "person" is a bust.
            $ec5c35dbffc1f325$var$solid(g).drawCircle(0, -8.6, 3.6);
            g.moveTo(-6.4, -2.2).quadraticCurveTo(-6.4, -4.6, -4, -4.6).lineTo(4, -4.6).quadraticCurveTo(6.4, -4.6, 6.4, -2.2).lineTo(4.3, 3.8).lineTo(-4.3, 3.8).closePath().endFill();
            $ec5c35dbffc1f325$var$stroke(g, 2.6).moveTo(-6.8, -1.4).lineTo(-8.6, 5).moveTo(6.8, -1.4).lineTo(8.6, 5);
            $ec5c35dbffc1f325$var$stroke(g, 3.2).moveTo(-2.3, 3.6).lineTo(-2.9, 10.8).moveTo(2.3, 3.6).lineTo(2.9, 10.8);
            break;
        case "hair":
            // Long hair from the front: a side-parted fringe over a faint face, the locks tapering to
            // points at the shoulders. The face is what makes it a head of hair and not an arch.
            g.lineStyle(0).beginFill(0xffffff, 0.4).drawEllipse(0, 1, 5.8, 7.6).endFill();
            $ec5c35dbffc1f325$var$solid(g).moveTo(-9.6, 11.8).bezierCurveTo(-12.8, 4, -12.4, -11.6, 0, -11.6).bezierCurveTo(12.4, -11.6, 12.8, 4, 9.6, 11.8).quadraticCurveTo(6, 6, 6.6, -2.6).quadraticCurveTo(0.6, -2.2, -2.6, -7.8).quadraticCurveTo(-4.4, -3.6, -6.6, -2.6).quadraticCurveTo(-6, 6, -9.6, 11.8).closePath().endFill();
            break;
        case "tunic":
            // Sleeved, V-necked and belted: the bodice and the skirt are two pieces with the belt
            // left as the gap between them.
            $ec5c35dbffc1f325$var$solid(g).moveTo(-3.6, -10.5).lineTo(-9.4, -8.2).lineTo(-12, -1.6).lineTo(-8, -0.2).lineTo(-7.6, 2.6).lineTo(7.6, 2.6).lineTo(8, -0.2).lineTo(12, -1.6).lineTo(9.4, -8.2).lineTo(3.6, -10.5).quadraticCurveTo(0, -4.4, -3.6, -10.5).closePath();
            g.moveTo(-7.6, 4.6).lineTo(7.6, 4.6).lineTo(9, 11).lineTo(-9, 11).closePath();
            g.endFill();
            break;
        case "trousers":
            $ec5c35dbffc1f325$var$solid(g).drawRect(-8, -11.5, 16, 3.2);
            g.moveTo(-8, -7).lineTo(8, -7).lineTo(9.5, 11.5).lineTo(2.6, 11.5).lineTo(0, -0.5).lineTo(-2.6, 11.5).lineTo(-9.5, 11.5).closePath().endFill();
            break;
        case "dot":
        default:
            $ec5c35dbffc1f325$var$solid(g).moveTo(0, -7).lineTo(7, 0).lineTo(0, 7).lineTo(-7, 0).closePath().endFill();
            break;
    }
    g.lineStyle(0);
};


const $7674b5c0a355be98$export$2bfe8e7d6057027e = {
    lord: "crown",
    defender: "shield",
    forager: "axe"
};
const $7674b5c0a355be98$export$cc2a44fcde6b220b = {
    lord: 0xffd078,
    defender: 0xff8a5c,
    forager: 0x7be08a
};
const $7674b5c0a355be98$export$68f029f6c68daa48 = (role, size, accent)=>{
    const icon = role && $7674b5c0a355be98$export$2bfe8e7d6057027e[role];
    if (icon) return (0, $ec5c35dbffc1f325$export$46ad086a5552f2fb)(icon, size, accent ?? $7674b5c0a355be98$export$cc2a44fcde6b220b[role] ?? 0xffffff);
    const glyph = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(size).render(role === "player" ? "\uD83E\uDDD1" : role === "visitor" ? "\uD83C\uDF57" : "\u2022");
    glyph.anchor.set(0.5);
    if (!role) glyph.tint = accent ?? 0xffffff;
    return glyph;
};


class $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c {
    constructor(subject, props){
        this.faderStep = 0.01;
        this.direction = "out";
        this.isActive = ()=>this.active;
        this.update = ()=>{
            this.active = true;
            if (this.interval) return;
            this.interval = setInterval(()=>{
                if (this.direction === "out") {
                    this.subject.alpha -= this.faderStep;
                    if (this.subject.alpha <= this.minAlpha) {
                        this.releaseCallback && this.releaseCallback();
                        clearInterval(this.interval);
                        this.interval = undefined;
                        return;
                    }
                } else if (this.direction === "in") {
                    this.subject.alpha += this.faderStep;
                    if (this.subject.alpha >= this.minAlpha) {
                        this.releaseCallback && this.releaseCallback();
                        clearInterval(this.interval);
                        this.interval = undefined;
                        return;
                    }
                } else {
                    // not supported, clear it right away
                    clearInterval(this.interval);
                    this.interval = undefined;
                }
            }, this.fadeInterval);
        };
        this.stop = (suppressCallback)=>{
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = undefined;
            }
            if (!suppressCallback && this.releaseCallback) this.releaseCallback();
            this.active = false;
        };
        this.subject = subject;
        this.releaseCallback = props?.releaseCallback;
        this.minAlpha = props?.minAlpha !== undefined ? props.minAlpha : this.direction === "out" ? 0.0 : 1.0;
        this.fadeInterval = props?.fadeInterval || 2;
        this.faderStep = props?.fadeAlphaDecrement || 0.01;
        this.direction = props?.direction || "out";
    }
}









class $5dbaf3682d88a932$export$46264c47e2aa11a2 {
    static{
        // Only buttons that are currently ON SCREEN are in here: register() on show, unregister() on
        // dismiss and on HUD cleanup. So "hidden for capture" can flip them wholesale without having to
        // remember which ones were visible to begin with.
        this.buttons = new Set();
    }
    static{
        // Called once by the renderer. Lazily reads the player controller: the controller does not exist
        // yet when the renderer is built.
        this.bindSuppressAttack = (suppress)=>{
            $5dbaf3682d88a932$export$46264c47e2aa11a2.suppressAttack = suppress;
        };
    }
    static{
        this.register = (button)=>{
            $5dbaf3682d88a932$export$46264c47e2aa11a2.buttons.add(button);
        };
    }
    static{
        this.unregister = (button)=>{
            $5dbaf3682d88a932$export$46264c47e2aa11a2.buttons.delete(button);
        };
    }
    static{
        // Hide/show every live Next button. Wrapped around the follow-cam's overlay render pass.
        this.setHiddenForCapture = (hidden)=>{
            $5dbaf3682d88a932$export$46264c47e2aa11a2.buttons.forEach((button)=>{
                button.visible = !hidden;
            });
        };
    }
    static{
        this.notePressed = ()=>{
            $5dbaf3682d88a932$export$46264c47e2aa11a2.suppressAttack?.();
        };
    }
    static{
        // Whether a held line is waiting on the player where they can read it: what the HUD steps back
        // for (gui/hud_presence.ts). A bubble the speaker took out of view with him (the Lord speaks at a
        // tree the player has not followed him to) is not one: dimming the HUD for it would leave the
        // player with less to look at and nothing to read. `view` is in global (stage) coordinates.
        this.anyInView = (view)=>{
            for (const button of $5dbaf3682d88a932$export$46264c47e2aa11a2.buttons){
                if (!button.worldVisible) continue;
                const b = button.getBounds();
                if (b.right > view.left && b.left < view.right && b.bottom > view.top && b.top < view.bottom) return true;
            }
            return false;
        };
    }
    static{
        // Tests only.
        this.liveCount = ()=>$5dbaf3682d88a932$export$46264c47e2aa11a2.buttons.size;
    }
}


// Keeps in-world chat bubbles from covering each other.
//
// Every bubble is pinned to its speaker (up and to the right of the head, see AvatarHud.spokeImpl),
// and a bubble is about five tiles wide, so two people talking a few tiles apart used to land one
// panel squarely on the other -- around a camp fire, with the Lord and a couple of recruits all
// talking, that was the normal case rather than the exception. Once a frame the renderer hands the
// open bubbles to arrangeBubbles(), which decides where each one sits:
//
//  - The bubble already being read keeps its place: older lines are placed first, and a HELD line
//    (one waiting on the player's Next) before everything, so the one they are working through never
//    moves out from under them.
//  - A newer line that would collide takes the cheapest free spot among: sliding sideways a little,
//    flipping to the speaker's LEFT (tail mirrored), or lifting straight up until it clears. The tail
//    tip never moves -- it stays over the speaker's head and the tail stretches to reach it.
//  - A spot whose tail would cross another bubble's tail costs extra, because crossed tails are the
//    one thing that makes it genuinely unclear who said what.
//  - A fading line is still drawn where it is but no longer claims space -- it is leaving, and a new
//    line should not be shoved aside for it.
//  - Bubbles stay on the SCREEN. A speaker near the right edge has their bubble slide or flip
//    inward; one near the top edge has it DROP beside their head (the only way down from above the
//    head -- AvatarHud then turns the tail to come out of the bubble's side). A speaker who is
//    themselves off the screen is left alone: the roster's speech lane already carries their line.
//  - A DROPPED bubble keeps off everyone else's head: a drop brings the body down to head height,
//    right where the person standing next to its speaker has their face. (Only drops: a bubble at
//    rest or risen is above the heads on its own row, and making heads block those too would shove
//    an older bubble -- the one being read -- aside for a newer speaker who walked in under it.)
//  - If there is no room anywhere, on screen beats clear of the others: the bubble takes the
//    cheapest on-screen spot and draws OVER whatever it lands on (newest on top), so the line that
//    just arrived is at least readable.
//
// The maths is pure and works in a common unit space (HUD-local units, shifted by each HUD's origin),
// which is what makes it unit-testable without a renderer. AvatarHud does the drawing and the easing.
const $a77286236663d69d$export$e0e640e055a89d3b = {
    side: "right",
    dx: 0,
    lift: 0
};
const $a77286236663d69d$export$b4bcd425bc719cf = 4;
const $a77286236663d69d$export$ea047f37dfb9c6ae = 120;
const $a77286236663d69d$export$2ecdae1e43e329a7 = 48;
const $a77286236663d69d$export$c0d570ccc8dd850b = 4;
const $a77286236663d69d$export$17d403113872e38b = 24;
const $a77286236663d69d$export$b7e1fb93c5ef21e8 = $a77286236663d69d$export$ea047f37dfb9c6ae + $a77286236663d69d$export$17d403113872e38b;
const $a77286236663d69d$var$samePlacement = (a, b)=>!!a && a.side === b.side && a.dx === b.dx && a.lift === b.lift;
const $a77286236663d69d$export$288ba05ede8a27cf = (slot, p)=>{
    const body = slot[p.side];
    return {
        x: body.x + p.dx,
        y: body.y - p.lift,
        w: body.w,
        h: body.h
    };
};
// The tail as a segment, for the crossing test -- or null once a dropped body has come down past its
// own tip, where AvatarHud draws a short tail out of the bubble's side instead (or none).
const $a77286236663d69d$var$tailAt = (slot, p)=>{
    const body = slot[p.side];
    const tip = slot.tip[p.side];
    const baseY = body.y + body.h - p.lift;
    if (tip.y <= baseY) return null;
    return {
        x1: slot.tailBaseX[p.side] + p.dx,
        y1: baseY,
        x2: tip.x,
        y2: tip.y
    };
};
const $a77286236663d69d$export$cf7de9d8468f0bb9 = (a, b)=>a.x < b.x + b.w + $a77286236663d69d$export$b4bcd425bc719cf && b.x < a.x + a.w + $a77286236663d69d$export$b4bcd425bc719cf && a.y < b.y + b.h + $a77286236663d69d$export$b4bcd425bc719cf && b.y < a.y + a.h + $a77286236663d69d$export$b4bcd425bc719cf;
// Do two tails properly cross (not merely touch at an end)?
const $a77286236663d69d$var$tailsCross = (a, b)=>{
    if (!a || !b) return false;
    const side = (px, py, s)=>Math.sign((s.x2 - s.x1) * (py - s.y1) - (s.y2 - s.y1) * (px - s.x1));
    return side(a.x1, a.y1, b) * side(a.x2, a.y2, b) < 0 && side(b.x1, b.y1, a) * side(b.x2, b.y2, a) < 0;
};
const $a77286236663d69d$var$contains = (outer, r)=>r.x >= outer.x && r.y >= outer.y && r.x + r.w <= outer.x + outer.w && r.y + r.h <= outer.y + outer.h;
const $a77286236663d69d$var$insetBy = (r, m)=>({
        x: r.x + m,
        y: r.y + m,
        w: r.w - m * 2,
        h: r.h - m * 2
    });
// The screen this slot has to keep to, or null. A speaker whose head is itself off the screen gets
// no edges: pulling their bubble in would show a line the roster lane is already showing, with a
// tail pointing at nobody.
const $a77286236663d69d$var$screenFor = (slot)=>{
    if (!slot.bounds) return null;
    const screen = $a77286236663d69d$var$insetBy(slot.bounds, $a77286236663d69d$export$c0d570ccc8dd850b);
    const tip = slot.tip.right;
    const onScreen = tip.x >= screen.x && tip.x <= screen.x + screen.w && tip.y >= screen.y && tip.y <= screen.y + screen.h;
    return onScreen ? screen : null;
};
const $a77286236663d69d$var$choosePlacement = (slot, placed, heads)=>{
    const home = slot.current?.side ?? $a77286236663d69d$export$e0e640e055a89d3b.side;
    const screen = $a77286236663d69d$var$screenFor(slot);
    const candidates = [];
    for (const side of [
        "right",
        "left"
    ]){
        const body = slot[side];
        // Sideways and vertical offsets worth trying, then every pairing of the two -- a bubble in a
        // corner can need a drop AND a flip or a slide.
        const dxs = [
            0
        ];
        const lifts = [
            0
        ];
        // Each bubble already placed offers three ways round it: just above it, or just clear of it
        // to either side.
        for (const { rect: o } of placed){
            const above = Math.ceil(body.y + body.h - (o.y - $a77286236663d69d$export$b4bcd425bc719cf));
            if (above > 0 && above <= $a77286236663d69d$export$ea047f37dfb9c6ae) lifts.push(above);
            const right = Math.ceil(o.x + o.w + $a77286236663d69d$export$b4bcd425bc719cf - body.x);
            if (right > 0 && right <= $a77286236663d69d$export$2ecdae1e43e329a7) dxs.push(right);
            const left = Math.floor(o.x - $a77286236663d69d$export$b4bcd425bc719cf - (body.x + body.w));
            if (left < 0 && left >= -$a77286236663d69d$export$2ecdae1e43e329a7) dxs.push(left);
        }
        // ...and the screen's edges offer the offsets that just bring it back inside.
        if (screen) {
            const inFromRight = Math.floor(screen.x + screen.w - (body.x + body.w));
            if (inFromRight < 0 && inFromRight >= -$a77286236663d69d$export$2ecdae1e43e329a7) dxs.push(inFromRight);
            const inFromLeft = Math.ceil(screen.x - body.x);
            if (inFromLeft > 0 && inFromLeft <= $a77286236663d69d$export$2ecdae1e43e329a7) dxs.push(inFromLeft);
            // Down from the top edge: a negative lift. At most until the body's top reaches the tail
            // tip -- it then sits beside the head, and lower than that it would be beside the knees.
            const downFromTop = Math.floor(body.y - screen.y);
            const maxDrop = slot.tip[side].y - body.y;
            if (downFromTop < 0 && -downFromTop <= maxDrop) lifts.push(downFromTop);
            const upFromBottom = Math.ceil(body.y + body.h - (screen.y + screen.h));
            if (upFromBottom > 0 && upFromBottom <= $a77286236663d69d$export$ea047f37dfb9c6ae) lifts.push(upFromBottom);
        }
        for (const dx of dxs)for (const lift of lifts)candidates.push({
            side: side,
            dx: dx,
            lift: lift
        });
    }
    if (slot.current) candidates.push(slot.current);
    // Cheapest spot that is on the screen and clear of everything placed (and, for a drop, of everyone
    // else's head); failing that, the cheapest on the screen at all (it will overlap -- newest on top
    // keeps it readable).
    let clear;
    let clearCost = Infinity;
    let onScreen;
    let onScreenCost = Infinity;
    for (const p of candidates){
        const rect = $a77286236663d69d$export$288ba05ede8a27cf(slot, p);
        if (screen && !$a77286236663d69d$var$contains(screen, rect)) continue;
        const tail = $a77286236663d69d$var$tailAt(slot, p);
        const cost = Math.abs(p.lift) + Math.abs(p.dx) + (p.side === home ? 0 : $a77286236663d69d$export$17d403113872e38b) + (placed.some((o)=>$a77286236663d69d$var$tailsCross(tail, o.tail)) ? $a77286236663d69d$export$b7e1fb93c5ef21e8 : 0);
        // On a tie, the spot the bubble already holds wins.
        const better = (best)=>cost < best || cost === best && $a77286236663d69d$var$samePlacement(slot.current, p);
        if (better(onScreenCost)) {
            onScreen = p;
            onScreenCost = cost;
        }
        const onAFace = p.lift < 0 && heads.some((h)=>$a77286236663d69d$export$cf7de9d8468f0bb9(rect, h));
        if (!placed.some((o)=>$a77286236663d69d$export$cf7de9d8468f0bb9(rect, o.rect)) && !onAFace && better(clearCost)) {
            clear = p;
            clearCost = cost;
        }
    }
    const pick = clear ?? onScreen;
    if (pick) return pick;
    // Nothing in reach is on the screen (a bubble wider than the slide limit is off the edge): pull
    // the bubble's home spot inside the screen by whatever it takes.
    const fallback = slot.current ?? $a77286236663d69d$export$e0e640e055a89d3b;
    return screen ? $a77286236663d69d$var$clampInto(slot, fallback, screen) : fallback;
};
const $a77286236663d69d$var$clampInto = (slot, p, screen)=>{
    const r = $a77286236663d69d$export$288ba05ede8a27cf(slot, p);
    const dx = r.x < screen.x ? screen.x - r.x : r.x + r.w > screen.x + screen.w ? screen.x + screen.w - (r.x + r.w) : 0;
    const dy = r.y < screen.y ? screen.y - r.y : r.y + r.h > screen.y + screen.h ? screen.y + screen.h - (r.y + r.h) : 0;
    return {
        side: p.side,
        dx: Math.round(p.dx + dx),
        lift: Math.round(p.lift - dy)
    };
};
const $a77286236663d69d$export$b1e59c8fb567b257 = (slots)=>{
    const byPriority = slots.map((_, i)=>i).sort((a, b)=>Number(slots[b].held) - Number(slots[a].held) || slots[a].order - slots[b].order);
    const placed = [];
    const placements = new Array(slots.length);
    for (const i of byPriority){
        const slot = slots[i];
        // Every OTHER speaker's head, placed yet or not: heads do not move.
        const heads = slots.filter((other, j)=>j !== i && other.head).map((other)=>other.head);
        const placement = slot.fading ? slot.current ?? $a77286236663d69d$export$e0e640e055a89d3b : $a77286236663d69d$var$choosePlacement(slot, placed, heads);
        placements[i] = placement;
        if (!slot.fading) placed.push({
            rect: $a77286236663d69d$export$288ba05ede8a27cf(slot, placement),
            tail: $a77286236663d69d$var$tailAt(slot, placement)
        });
    }
    return placements;
};
const $a77286236663d69d$export$155270fb0e434524 = (slots, placements)=>{
    const order = slots.map((_, i)=>i).sort((a, b)=>Number(placements[a].lift <= 0) - Number(placements[b].lift <= 0) || slots[a].order - slots[b].order);
    const ranks = new Array(slots.length);
    order.forEach((slotIndex, rank)=>{
        ranks[slotIndex] = rank + 1;
    });
    return ranks;
};
class $a77286236663d69d$var$SpeechBubbleRegistry {
    constructor(){
        this.open = new Set();
        this.sequence = 0;
        // A line has just opened on this bubble. Returns its order -- newer lines get higher numbers, so
        // re-opening (the speaker's next line) also makes it the newest.
        this.opened = (bubble)=>{
            this.open.add(bubble);
            return ++this.sequence;
        };
        this.closed = (bubble)=>{
            this.open.delete(bubble);
            // Nothing is open, so nothing's order needs comparing any more; start the count again rather
            // than letting it (and the paint ranks drawn from it) climb for the life of the session.
            if (!this.open.size) this.sequence = 0;
        };
        this.openCount = ()=>this.open.size;
        // Every bubble on screen right now, in global coordinates -- for HUD toasts that must not land on
        // somebody's line (chapter_celebration.ts).
        this.screenRects = ()=>{
            const rects = [];
            this.open.forEach((bubble)=>{
                const rect = bubble.bubbleScreenRect?.();
                if (rect) rects.push(rect);
            });
            return rects;
        };
        // Run once a frame, from the renderer. `screen` is the visible area in global coordinates.
        this.arrange = (now, screen)=>{
            if (!this.open.size) return;
            const members = [];
            const slots = [];
            this.open.forEach((bubble)=>{
                const slot = bubble.bubbleSlot(screen);
                if (slot) {
                    members.push(bubble);
                    slots.push(slot);
                }
            });
            const placements = $a77286236663d69d$export$b1e59c8fb567b257(slots);
            const ranks = $a77286236663d69d$export$155270fb0e434524(slots, placements);
            members.forEach((bubble, i)=>bubble.applyBubblePlacement(placements[i], ranks[i], now));
            this.open.forEach((bubble)=>bubble.animateBubblePlacement(now));
        };
        // Tests only: forget every bubble.
        this.clear = ()=>{
            this.open.clear();
            this.sequence = 0;
        };
    }
}
const $a77286236663d69d$export$54b23a9eafdee768 = new $a77286236663d69d$var$SpeechBubbleRegistry();


// Chat speech-bubble look (see spokeImpl). It is the camp's cut-timber panel -- the HUD_PANEL plate
// with build_board's chamfer and an inked bronze rim -- because it used to be the last cool-slate
// panel on screen: a blue-grey rounded rect over warm wood, beside a roster bubble (roster_speech.ts)
// that already said the same lines on the warm plate.
const $1d5c2742ca857d0e$var$BUBBLE_PAD_X = 12;
const $1d5c2742ca857d0e$var$BUBBLE_PAD_Y = 10;
const $1d5c2742ca857d0e$var$BUBBLE_SPEAKER_OFFSET_Y = 8;
// Cut corners, not a radius: a radius is a desktop dialog, a chamfer is a sawn board.
const $1d5c2742ca857d0e$var$BUBBLE_CHAMFER = 5;
// Near-solid. At 0.9 the bark of a tree behind the bubble striped through the words.
const $1d5c2742ca857d0e$var$BUBBLE_FILL = (0, $97475243e21a0995$export$ae463dc3cc7e810b);
const $1d5c2742ca857d0e$var$BUBBLE_FILL_ALPHA = 0.97;
// The rim is two strokes down the same path: a wide dark one, then a thin bronze one over its middle,
// so the bronze is inked on both sides and the outline stays seamless around the tail.
const $1d5c2742ca857d0e$var$BUBBLE_EDGE_WIDTH = 3.5;
const $1d5c2742ca857d0e$var$BUBBLE_EDGE_ALPHA = 0.95;
const $1d5c2742ca857d0e$var$BUBBLE_RIM_WIDTH = 1.25;
const $1d5c2742ca857d0e$var$BUBBLE_MITER_LIMIT = 3 // bevels the tail's tip rather than spiking it
;
const $1d5c2742ca857d0e$var$BUBBLE_TOP_LIGHT_ALPHA = 0.2;
// Dropped straight down. The old diagonal offset showed as a second, ghost tail beside the real one.
const $1d5c2742ca857d0e$var$BUBBLE_SHADOW_Y = 3;
const $1d5c2742ca857d0e$var$BUBBLE_SHADOW_ALPHA = 0.38;
const $1d5c2742ca857d0e$var$BUBBLE_TEXT_COLOR = (0, $97475243e21a0995$export$92999bc7164f195e);
// Where the body sits beside its speaker, in HUD units. At rest it is up and to the right of the head
// (BUBBLE_X is its left edge); when the layout moves it to make room for another speaker's bubble
// (see speech_bubble_layout.ts) it can slide, rise, or mirror about the head's centre onto the left.
// HEAD_CENTER_X is measured rather than taken from GLYPH_X: on an LPC body the hair spans about
// -9..37 in these units, and the role glyph -- nominally at 18 -- is drawn centred at ~14.
const $1d5c2742ca857d0e$var$BUBBLE_X = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
const $1d5c2742ca857d0e$var$HEAD_CENTER_X = 14;
// The tail, in bubble-local units, its base on the bottom edge. The tail reaches back LEFT to the
// head and its tip lands OVER the head, 8 units right of its centre (mirrored on the other side). It
// first stopped at +6 from a bubble at 1.4 tiles, which pointed at the grass beside the speaker; then
// at the head's right EDGE, which with a neighbour a tile away is right beside THEIR head -- the two
// tails met in the gap between the speakers and nobody could tell whose line was whose.
const $1d5c2742ca857d0e$var$TAIL_BASE_LEFT_X = 6;
const $1d5c2742ca857d0e$var$TAIL_BASE_RIGHT_X = 26;
const $1d5c2742ca857d0e$var$TAIL_TIP_X = $1d5c2742ca857d0e$var$HEAD_CENTER_X + 8 - $1d5c2742ca857d0e$var$BUBBLE_X;
const $1d5c2742ca857d0e$var$TAIL_DROP = 13 // tip, below the bubble's bottom edge
;
// A bubble the layout DROPS (a speaker near the top of the screen, see speech_bubble_layout.ts) comes
// down beside the head, past where a tail off its bottom edge could reach the tip. Below this much
// drop left for it, the tail comes out of the speaker-facing side instead, SIDE_TAIL_HALF either side
// of the tip's height, pointing across at the head -- and always at least SIDE_TAIL_LEN out, because
// a drop that also had to slide in from a screen edge can bring the body right up to the tip, and a
// bubble with no tail at all is only tied to its speaker by standing next to them.
const $1d5c2742ca857d0e$var$MIN_TAIL_DROP = 5;
const $1d5c2742ca857d0e$var$SIDE_TAIL_HALF = 6;
const $1d5c2742ca857d0e$var$SIDE_TAIL_LEN = 6;
// The speaker's head as the layout keeps other bubbles off it, relative to the tail tip (which sits
// level with the bottom of the role glyph, just above the hair). Measured on an LPC body: hair
// -9..37 across, chin ~46 below the tip. The box starts 8 ABOVE the tip -- the glyph's lower half;
// only a DROPPED bubble is kept off it (see speech_bubble_layout.ts).
const $1d5c2742ca857d0e$var$HEAD_HALF_W = 23;
const $1d5c2742ca857d0e$var$HEAD_ABOVE_TIP = 8;
const $1d5c2742ca857d0e$var$HEAD_BELOW_TIP = 45;
// How long a bubble takes to rise or settle when the layout moves it.
const $1d5c2742ca857d0e$var$BUBBLE_MOVE_MS = 160;
// Scratch points for bubbleSlot()'s transform reads, so the per-frame layout allocates nothing.
const $1d5c2742ca857d0e$var$LAYOUT_ORIGIN = new (0, $6qzqq.Point)(0, 0);
const $1d5c2742ca857d0e$var$LAYOUT_UNIT = new (0, $6qzqq.Point)(1, 1);
const $1d5c2742ca857d0e$var$layoutOriginOut = new (0, $6qzqq.Point)();
const $1d5c2742ca857d0e$var$layoutUnitOut = new (0, $6qzqq.Point)();
// The "Next" button on a HELD bubble (see spoke): a line the player dismisses themselves rather
// than one that fades on a timer. It hangs off the bottom-right inside edge of the panel, on its own
// row, so it can never sit over the words however they wrap.
const $1d5c2742ca857d0e$var$NEXT_BUTTON_W = 52;
const $1d5c2742ca857d0e$var$NEXT_BUTTON_H = (0, $97475243e21a0995$export$73e83bf2b7e02467).small.height;
const $1d5c2742ca857d0e$var$NEXT_BUTTON_GAP = 7 // clear air between the last line of text and the button row
;
// A held line stops the scene behind it until it is dismissed, so the button presses ITSELF after
// this long: a player who wanders off, misses the button, or can't reach it (a bubble drawn half off
// the screen) must not be able to strand the ember tutorial for good. The countdown bar along the
// bottom of the button is the only cue, and it is deliberately quiet -- the button is still the way
// you're meant to get through a conversation, not a thing to race.
const $1d5c2742ca857d0e$var$NEXT_BUTTON_AUTO_MS = (0, $fbecd757e266ba04$export$24848c281071b86e);
// Redraw cadence of that bar. Coarse on purpose: the bar is ~42px wide, so a finer tick cannot move
// it a whole pixel, and a live bubble has no business churning the GPU on a budget machine.
const $1d5c2742ca857d0e$var$NEXT_PROGRESS_TICK_MS = 250;
const $1d5c2742ca857d0e$var$NEXT_PROGRESS_H = 2;
const $1d5c2742ca857d0e$var$NEXT_PROGRESS_ROW = 4 // the bar plus its clearance from the button's bottom border
;
const $1d5c2742ca857d0e$var$NEXT_PROGRESS_INSET = 5 // keeps the bar clear of the chamfer (UiButton cuts min(5, h / 4))
;
const $1d5c2742ca857d0e$var$NEXT_PROGRESS_COLOR = (0, $658a44ce960354bb$export$319b6132a2fafb7c);
const $1d5c2742ca857d0e$var$NEXT_PROGRESS_ALPHA = 0.6;
// Ceiling on the per-entity backlog of lines waiting behind a held bubble. A player who walks away
// mid-conversation never presses Next, and the speaker (the ember Lord, mid-intro) keeps talking;
// without a cap that queue grows for as long as the run lasts. Dropping the OLDEST line keeps the
// most recent, most relevant ones.
const $1d5c2742ca857d0e$var$MAX_QUEUED_LINES = 8;
// Compact segmented HP meter drawn beneath the name (variant B) -- replaces the old "|" pipe text.
// Colours mirror the roster HP bar (ember_roster drawHpBar) so the world and roster read the same.
const $1d5c2742ca857d0e$var$HP_BAR_W = 54;
const $1d5c2742ca857d0e$var$HP_BAR_H = 7;
const $1d5c2742ca857d0e$var$HP_SEGMENTS = 6;
const $1d5c2742ca857d0e$var$HP_SEG_GAP = 2;
const $1d5c2742ca857d0e$var$HP_CASE_PAD = 2;
const $1d5c2742ca857d0e$var$HP_COLOR_FULL = 0x6fe06f;
const $1d5c2742ca857d0e$var$HP_COLOR_WARN = 0xffd23f;
const $1d5c2742ca857d0e$var$HP_COLOR_CRIT = 0xff5c5c;
// Floating role glyph (crown / shield / axe) shown above an ember-camp NPC's head. It
// rests just above the head and lifts on hover to make room for the name + HP, then drops back down.
// The Y values are the tunable bits (like the HP-bar alignment was).
const $1d5c2742ca857d0e$var$GLYPH_SIZE = 15;
const $1d5c2742ca857d0e$var$GLYPH_X = 18 // centred over the NPC (tunable)
;
const $1d5c2742ca857d0e$var$GLYPH_Y = 20 // rests just above the head; the glyph fades out on hover (it does not move)
;
const $1d5c2742ca857d0e$var$GLYPH_FADE_MS = 130;
// Players already have a ground ring, so only their roster card carries a badge.
// Draw order of the per-entity widgets inside the HUD. These only take effect because the HUD turns
// on sortableChildren in the constructor -- without it pixi paints in addChild order, which put the
// role glyph and the sigil (added later, on demand) on top of the chat bubble.
const $1d5c2742ca857d0e$var$Z_TAG = 0;
const $1d5c2742ca857d0e$var$Z_LABEL = 10 // name + HP meter
;
const $1d5c2742ca857d0e$var$Z_SIGIL = 20;
const $1d5c2742ca857d0e$var$Z_ROLE_GLYPH = 30;
const $1d5c2742ca857d0e$var$Z_POINTER = 40;
const $1d5c2742ca857d0e$var$Z_CHAT_BUBBLE = 100000 // a bubble always reads over every other widget of its entity
;
// Every entity's HUD is a separate child of the world-overlay surface, so ordering the bubble within
// its own HUD isn't enough -- a neighbour's nameplate/glyph would still paint over it. The speaking
// entity's whole overlay item is lifted above the resting ones for as long as its bubble is up, and
// among the speakers, by the paint rank the bubble layout hands out (newest line on top -- see
// bubblePaintRanks). Without that, two lifted items tied and pixi fell back to the order the
// ENTITIES were created in, so a fresh line could open underneath an old one.
const $1d5c2742ca857d0e$var$Z_OVERLAY_RESTING = 0;
const $1d5c2742ca857d0e$var$Z_OVERLAY_SPEAKING = 1000;
class $1d5c2742ca857d0e$export$5ef96c383b67a5e2 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(color = 0xff00ff, renderMeta, parentArea, suppressDetailHover){
        super(), this.currentName = "", this.currentHp = 0, this.currentHpMax = 0, this.currentRole = null, /** How far above GLYPH_Y the role glyph rests: a taller body's head (an Ember body's) needs it higher. */ this.glyphLift = 0, // The drawn bubble's size and resting y, kept so the layout can move it without re-measuring.
        this.bubbleW = 0, this.bubbleH = 0, this.bubbleRestY = 0, // Where the layout has put the bubble: `placement` is what is drawn, `placementTarget` where it
        // is heading. They differ only while a move is easing (bubbleMoveEase).
        this.placement = (0, $a77286236663d69d$export$e0e640e055a89d3b), this.placementTarget = (0, $a77286236663d69d$export$e0e640e055a89d3b), // Set when a line opens: its first placement snaps rather than eases, since nobody has seen it.
        this.placementFresh = false, // When the line on screen opened, as the layout counts it; 0 while no line is open.
        this.bubbleOrder = 0, this.nextArmedAt = 0, // Width the bar was last drawn at, so a tick that wouldn't move it draws nothing.
        this.nextProgressWidth = -1, // True from the moment a held line lands until its Next is pressed. While it is set, everything
        // this entity says queues rather than replacing what's on screen.
        this.holding = false, // Lines waiting their turn behind the held bubble, oldest first. They inherit the hold, so the
        // player cycles through the whole backlog with the same button, and each carries its OWN ack --
        // the speaker is told about the line the player actually just read, not the one at the front.
        this.speechQueue = [], // Whether the line currently on screen was drawn instantly (PiP focus) -- carried so a queued
        // line is shown the same way.
        this.lastInstant = false, this.makeBubbleText = ()=>{
            const bubbleText = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)({
                // progressive is set per-utterance in spokeImpl (typewriter on the main view, instant in
                // the PiP focus), so this is just the default.
                progressive: true,
                // The styled panel drawn in spokeImpl is the bubble background now; the old inner
                // text-hugging backdrop just muddied it with a second dark rect, so it's disabled.
                backdrop: false
            });
            bubbleText.x = $1d5c2742ca857d0e$var$BUBBLE_PAD_X;
            bubbleText.y = $1d5c2742ca857d0e$var$BUBBLE_PAD_Y;
            this.bubbleText = bubbleText;
            return bubbleText;
        }, // Show/replace the floating role glyph above the head (or remove it when the entity has no role).
        this.updateRole = (role)=>{
            if (this.currentRole === role) return;
            this.currentRole = role;
            if (this.glyphAnimInterval) {
                clearInterval(this.glyphAnimInterval);
                this.glyphAnimInterval = undefined;
            }
            if (this.roleGlyph) {
                this.removeChild(this.roleGlyph);
                if (this.roleGlyph instanceof (0, $9Pi8W.Text)) this.roleGlyph.destroy({
                    texture: true,
                    baseTexture: true
                });
                else this.roleGlyph.destroy();
                this.roleGlyph = undefined;
            }
            if (role && role !== "player") {
                const glyph = (0, $7674b5c0a355be98$export$68f029f6c68daa48)(role, $1d5c2742ca857d0e$var$GLYPH_SIZE);
                glyph.x = $1d5c2742ca857d0e$var$GLYPH_X;
                glyph.y = $1d5c2742ca857d0e$var$GLYPH_Y - this.glyphLift;
                // Hidden while the label is showing (hovered / always-on), else visible above the head.
                const hidden = this.idText.visible || this.alwaysShowLabel;
                glyph.alpha = hidden ? 0 : 1;
                glyph.visible = !hidden;
                glyph.zIndex = $1d5c2742ca857d0e$var$Z_ROLE_GLYPH;
                this.addChild(glyph);
                this.roleGlyph = glyph;
            }
        }, /** Rest the role glyph `lift` pixels higher than an LPC body's head puts it (the glyph moves now, if shown). */ this.setGlyphLift = (lift)=>{
            if (lift === this.glyphLift) return;
            this.glyphLift = lift;
            if (this.roleGlyph) this.roleGlyph.y = $1d5c2742ca857d0e$var$GLYPH_Y - lift;
        }, // Fade the glyph in/out -- it hides on hover so the name/HP take its place, and fades back when
        // the pointer leaves. Runs a short self-clearing interval only while fading, so there's no
        // per-frame timer sitting idle.
        this.fadeGlyphTo = (targetAlpha)=>{
            const glyph = this.roleGlyph;
            if (!glyph) return;
            if (this.glyphAnimInterval) {
                clearInterval(this.glyphAnimInterval);
                this.glyphAnimInterval = undefined;
            }
            if (targetAlpha > 0) glyph.visible = true // fade-in from a hidden glyph must start visible
            ;
            const startAlpha = glyph.alpha;
            const delta = targetAlpha - startAlpha;
            if (Math.abs(delta) < 0.02) {
                glyph.alpha = targetAlpha;
                glyph.visible = targetAlpha > 0;
                return;
            }
            const stepMs = 16;
            let elapsed = 0;
            this.glyphAnimInterval = setInterval(()=>{
                elapsed += stepMs;
                const t = Math.min(1, elapsed / $1d5c2742ca857d0e$var$GLYPH_FADE_MS);
                glyph.alpha = startAlpha + delta * t;
                if (t >= 1) {
                    glyph.alpha = targetAlpha;
                    glyph.visible = targetAlpha > 0;
                    clearInterval(this.glyphAnimInterval);
                    this.glyphAnimInterval = undefined;
                }
            }, stepMs);
        }, this.recolor = (color)=>{
            if (this.currentColor === color) return;
            this.currentColor = color;
            if (this.tag) this.tag.tint = color;
        }, this.updateLevel = (level)=>{
            if (this.currentLevel === level) return;
            this.currentLevel = level;
            this.calcLabel();
        }, this.updateName = (name)=>{
            if (name !== this.currentName) {
                this.currentName = name;
                this.calcLabel();
            }
        }, this.update = (hp, hpMax)=>{
            if (this.currentHp !== hp) {
                this.currentHp = hp;
                this.calcLabel();
            }
            if (this.currentHpMax !== hpMax) {
                this.currentHpMax = hpMax;
                this.calcLabel();
            }
        }, this.calcLabel = ()=>{
            let name = this.currentName || "";
            const max = 15;
            if (name.length > max) name = name.substring(0, max - 3) + "...";
            const level = !!name && this.currentLevel > 0 ? `Lv ${this.currentLevel}` : "";
            this.idText.y = 0;
            this.idText.text = (name + "  " + level).trim();
            // Left-align the HP meter to the name's left edge, just below it.
            this.hpBar.x = this.idText.x;
            this.hpBar.y = this.idText.y + this.idText.height + 2;
            this.drawHpBar();
        }, this.drawHpBar = ()=>{
            const g = this.hpBar;
            g.clear();
            if (this.currentHpMax < 1) return;
            const ratio = Math.max(0, Math.min(1, this.currentHp / this.currentHpMax));
            const color = ratio < 0.4 ? $1d5c2742ca857d0e$var$HP_COLOR_CRIT : ratio < 0.7 ? $1d5c2742ca857d0e$var$HP_COLOR_WARN : $1d5c2742ca857d0e$var$HP_COLOR_FULL;
            const innerW = $1d5c2742ca857d0e$var$HP_BAR_W - $1d5c2742ca857d0e$var$HP_CASE_PAD * 2;
            const segW = (innerW - $1d5c2742ca857d0e$var$HP_SEG_GAP * ($1d5c2742ca857d0e$var$HP_SEGMENTS - 1)) / $1d5c2742ca857d0e$var$HP_SEGMENTS;
            const segH = $1d5c2742ca857d0e$var$HP_BAR_H - $1d5c2742ca857d0e$var$HP_CASE_PAD * 2;
            // Keep at least one segment lit while alive so a near-dead entity never reads as empty.
            const lit = this.currentHp > 0 ? Math.max(1, Math.round(ratio * $1d5c2742ca857d0e$var$HP_SEGMENTS)) : 0;
            // Dark casing
            g.beginFill(0x000000, 0.72);
            g.drawRoundedRect(0, 0, $1d5c2742ca857d0e$var$HP_BAR_W, $1d5c2742ca857d0e$var$HP_BAR_H, 2);
            g.endFill();
            // Notched segments
            for(let i = 0; i < $1d5c2742ca857d0e$var$HP_SEGMENTS; i++){
                const on = i < lit;
                g.beginFill(on ? color : 0xffffff, on ? 1 : 0.1);
                g.drawRoundedRect($1d5c2742ca857d0e$var$HP_CASE_PAD + i * (segW + $1d5c2742ca857d0e$var$HP_SEG_GAP), $1d5c2742ca857d0e$var$HP_CASE_PAD, segW, segH, 1);
                g.endFill();
            }
        }, // Raise/lower this entity's world-overlay item so a live bubble clears the HUDs of neighbouring
        // entities (their nameplates and role glyphs are siblings of this HUD, not children of it), and
        // sits in its paint rank among the other speakers'.
        this.liftOverlay = (speaking, paintRank = 0)=>{
            const overlayItem = this.parent;
            if (!overlayItem) return;
            const z = speaking ? $1d5c2742ca857d0e$var$Z_OVERLAY_SPEAKING + paintRank : $1d5c2742ca857d0e$var$Z_OVERLAY_RESTING;
            // Only on a change: assigning zIndex marks the whole overlay surface for a re-sort.
            if (overlayItem.zIndex !== z) overlayItem.zIndex = z;
        }, // A line this entity just said. See SpeechOptions for what the flags mean.
        //
        // A HELD line's bubble waits for a "Next" press instead of fading on a timer sized to the word
        // count -- players were losing the ember Lord's intro to that timer. The press also calls the
        // line's `onDismissed`, which is how the SPEAKER gets to pace itself off the player's reading
        // speed rather than its own clock. If nobody presses, the button presses itself after
        // NEXT_BUTTON_AUTO_MS, so handing the pacing to the player can never stall a scene outright.
        //
        // Anything this entity says while a held line is up QUEUES behind it and is shown, in order, as
        // the player works through the backlog with the same button, so no line can be shouldered off
        // the screen before it has been read. A speaker that waits for the ack keeps that queue empty by
        // construction; it is the safety net for one that doesn't (and for a line from somewhere else
        // entirely, mid-conversation). Only this entity's lines queue -- every speaker has its own HUD.
        this.spoke = (message, options)=>{
            if (options?.autoAdvance) this.releaseHeldSpeech();
            const instant = !!options?.instant;
            const hold = !!options?.hold;
            const onDismissed = options?.onDismissed;
            if (this.holding) {
                // Don't stack a line that's already on screen or already waiting -- a nudge the script
                // re-asks on a timer ("The wood. Onto the fire.") would otherwise become a stack of
                // identical bubbles for the player to click through.
                const lastQueued = this.speechQueue[this.speechQueue.length - 1];
                if (message === lastQueued?.message || !this.speechQueue.length && message === this.currentHeldMessage) return;
                this.speechQueue.push({
                    message: message,
                    onDismissed: onDismissed
                });
                while(this.speechQueue.length > $1d5c2742ca857d0e$var$MAX_QUEUED_LINES)this.speechQueue.shift();
                // The button carries the backlog count, so the player can see there's more behind it.
                this.drawNextButton();
                return;
            }
            this.showLine(message, instant, hold, onDismissed);
        }, // Put one line on screen, replacing whatever is there. The queue is handled by spoke(); by the
        // time we get here this line is the one to show.
        this.showLine = (message, instant, hold, onDismissed)=>{
            if (this.speaking) {
                this.bubbleText.wipe();
                this.bubbleText.parent.removeChild(this.bubbleText);
                this.bubbleText = this.makeBubbleText();
                this.chatBubble.addChild(this.bubbleText);
            }
            this.speaking = true;
            this.holding = hold;
            this.lastInstant = instant;
            this.currentHeldMessage = hold ? message : undefined;
            this.heldDismissedCallback = hold ? onDismissed : undefined;
            this.hideNextButton();
            this.spokeImpl(message, instant, hold, ()=>{
                this.speaking = false;
            });
        }, // How many of this entity's lines are waiting behind the held one. Exposed for tests and for the
        // button's own label.
        this.queuedSpeechCount = ()=>this.speechQueue.length, // Take a held bubble down WITHOUT the player pressing "Next", because the conversation it
        // belonged to has been called off -- the ember tutorial's Skip. The backlog goes with it (those
        // lines are the rest of a scene nobody is playing now), and without this the sign-off that
        // follows a skip would queue behind the very button the player just declined, inherit its hold,
        // and sit there unread.
        //
        // The speaker is deliberately NOT acked: nothing here was read, and a script pacing itself off
        // the ack falls back to its own timeout, exactly as it does for a bubble that was never drawn.
        this.releaseHeldSpeech = ()=>{
            if (!this.holding && !this.speechQueue.length) return;
            this.speechQueue = [];
            this.holding = false;
            this.currentHeldMessage = undefined;
            this.heldDismissedCallback = undefined;
            this.hideNextButton();
            this.closeBubble();
        }, // "Next" pressed -- by the player, or by the button's own countdown running out. Tells the
        // speaker it may go on, then shows the next line in the backlog, or closes the bubble when there
        // is none.
        this.advanceHeldSpeech = ()=>{
            if (!this.holding) return;
            this.holding = false;
            this.currentHeldMessage = undefined;
            this.hideNextButton();
            // Ack the line the player just read BEFORE showing the next one: a speaker waiting on this
            // is holding its own tongue until it arrives.
            const dismissed = this.heldDismissedCallback;
            this.heldDismissedCallback = undefined;
            dismissed?.();
            const next = this.speechQueue.shift();
            if (next) {
                // Queued lines inherit the hold: the player has taken over the pacing of this
                // conversation, so every line of it waits for them.
                this.showLine(next.message, this.lastInstant, true, next.onDismissed);
                return;
            }
            this.closeBubble();
        }, // Cancel a pending or running fade-out without its release: whoever calls this is about to put
        // the bubble back up, or take it down itself.
        this.stopBubbleFade = ()=>{
            if (this.chatBubbleTimeout) {
                clearTimeout(this.chatBubbleTimeout);
                this.chatBubbleTimeout = undefined;
            }
            this.chatBubbleFader?.stop(true);
            this.chatBubbleFader = undefined;
        }, this.spokeImpl = (message, instant, hold, done)=>{
            this.stopBubbleFade();
            this.hpBar.visible = false;
            this.idText.visible = false;
            // A chat bubble takes over the label area; the glyph returns to its resting visible state.
            this.fadeGlyphTo(1);
            const sentences = (0, $a80d0b17b615d6f7$export$edde49207b897324)(message, (0, $fbecd757e266ba04$export$8a3aa865a6e9fc80));
            // Size the bubble to the ACTUAL rendered text rather than a per-char estimate -- the old
            // estimate under-sized the panel, so text crowded the right/top edges. Measure the wrapped
            // lines with the real bubble font and wrap the panel around them with uniform padding.
            const probe = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("speech").strokeThickness(0).render();
            const metrics = (0, $9Pi8W.TextMetrics).measureText(sentences.join("\n"), probe.style);
            probe.destroy({
                texture: true,
                baseTexture: true
            });
            // A held line needs a row at the bottom for its Next button -- grow the panel around it the
            // same way the text grows it, so the button is always BELOW the words and never over them,
            // however they wrapped. (Same lesson as the tutorial bar: buttons beside server-authored
            // copy only fits until the copy gets a few words longer.)
            const textH = Math.ceil(metrics.height);
            const buttonRowH = hold ? $1d5c2742ca857d0e$var$NEXT_BUTTON_GAP + $1d5c2742ca857d0e$var$NEXT_BUTTON_H : 0;
            const minW = hold ? $1d5c2742ca857d0e$var$NEXT_BUTTON_W + $1d5c2742ca857d0e$var$BUBBLE_PAD_X * 2 : 46;
            const bubbleW = Math.max(minW, Math.ceil(metrics.width) + $1d5c2742ca857d0e$var$BUBBLE_PAD_X * 2);
            const bubbleH = textH + buttonRowH + $1d5c2742ca857d0e$var$BUBBLE_PAD_Y * 2;
            this.bubbleText.x = $1d5c2742ca857d0e$var$BUBBLE_PAD_X;
            this.bubbleText.y = $1d5c2742ca857d0e$var$BUBBLE_PAD_Y;
            // The HUD is parented to the entity's click area, whose origin is just below the sprite's
            // top edge (see LpcComposite/LpcLayered). Keep the tail tip at the bottom of that sprite's
            // upper half; as the panel grows, move its top upward instead of letting the tail drift
            // down toward the speaker's feet.
            const spriteUpperHalfY = Math.max(0, this.parentArea.height / 2 - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.15);
            const wasShowing = this.chatBubble.visible;
            this.bubbleW = bubbleW;
            this.bubbleH = bubbleH;
            this.bubbleRestY = spriteUpperHalfY - (bubbleH + $1d5c2742ca857d0e$var$TAIL_DROP) + $1d5c2742ca857d0e$var$BUBBLE_SPEAKER_OFFSET_Y;
            if (!wasShowing) {
                // A bubble opening from nothing starts in its home spot; one replacing a line already up
                // keeps the spot that line had found, so a speaker's next line doesn't jump.
                this.placement = (0, $a77286236663d69d$export$e0e640e055a89d3b);
                this.placementTarget = (0, $a77286236663d69d$export$e0e640e055a89d3b);
            } else if (this.bubbleMoveEase) this.placement = this.placementTarget;
            this.bubbleMoveEase = undefined;
            this.placementFresh = true;
            this.chatBubble.alpha = 1.0;
            this.chatBubble.zIndex = $1d5c2742ca857d0e$var$Z_CHAT_BUBBLE;
            this.drawBubbleFrame();
            this.bubbleOrder = (0, $a77286236663d69d$export$54b23a9eafdee768).opened(this);
            // Newest on top until the next layout pass ranks it properly. The order, not the open count:
            // a speaker's next line keeps the count the same, and would tie with the newest bubble.
            this.liftOverlay(true, this.bubbleOrder);
            this.chatBubble.visible = true;
            this.bubbleText.progressive = !instant;
            this.bubbleText.wipe();
            sentences.forEach((sentence)=>{
                // Warm ink, no outline: the default black stroke is for text over the open world, and on
                // a solid panel it only thickens the letters.
                this.bubbleText.append2(sentence, {
                    role: "speech",
                    color: $1d5c2742ca857d0e$var$BUBBLE_TEXT_COLOR,
                    strokeThickness: 0
                });
            });
            const scheduleFade = ()=>{
                this.chatBubbleTimeout = setTimeout(()=>{
                    this.chatBubbleTimeout = undefined;
                    const fader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.chatBubble, {
                        releaseCallback: ()=>{
                            this.chatBubbleFader = undefined;
                            this.bubbleText.wipe();
                            this.chatBubble.visible = false;
                            this.chatBubble.alpha = 1.0;
                            this.bubbleClosed();
                            done();
                        }
                    });
                    this.chatBubbleFader = fader;
                    fader.update();
                }, (0, $fbecd757e266ba04$export$1e680ea44e7c243c)(message));
            };
            // A held line hands the dismissal to the player: arm the button once the words have all
            // arrived (no point offering "Next" over a half-typed sentence, nor starting its countdown
            // while they're still appearing) and schedule no fade at all.
            const finish = hold ? ()=>{
                this.holdDone = done;
                this.showNextButton(bubbleW, bubbleH);
            } : scheduleFade;
            if (instant) // PiP focus: the line is already fully drawn (non-progressive above), so just fade — no
            // typewriter, whose progressive-reveal objects flicker when rendered into the PiP texture.
            finish();
            else this.bubbleText.playback(finish);
        }, // Take the bubble down for good: no fade, because the player has just told us they're done with
        // it and a dismissal that lingers reads as an unresponsive button.
        this.closeBubble = ()=>{
            this.stopBubbleFade();
            this.bubbleText.cleanup();
            this.bubbleText.wipe();
            this.chatBubble.visible = false;
            this.chatBubble.alpha = 1.0;
            this.bubbleClosed();
            const done = this.holdDone;
            this.holdDone = undefined;
            done?.();
        }, // The bubble is off the screen: out of the layout, and back down among the resting HUDs.
        this.bubbleClosed = ()=>{
            (0, $a77286236663d69d$export$54b23a9eafdee768).closed(this);
            this.bubbleOrder = 0;
            this.bubbleMoveEase = undefined;
            this.liftOverlay(false);
        }, // ---------------------------------------------------------------------------------------
        // The panel itself, and where the layout puts it (see speech_bubble_layout.ts).
        // ---------------------------------------------------------------------------------------
        this.bubbleXFor = (side)=>side === "right" ? $1d5c2742ca857d0e$var$BUBBLE_X : $1d5c2742ca857d0e$var$HEAD_CENTER_X * 2 - $1d5c2742ca857d0e$var$BUBBLE_X - this.bubbleW, // Paint the panel at its current size and placement. Geometry only: the words and the Next button
        // are children laid out inside the body, so they ride along when it moves.
        //
        // The whole outline -- chamfered rect plus a tail on the bottom edge -- is ONE continuous path.
        // Filling and stroking a single path keeps the border seamless around the tail and the fill
        // uniform (drawing the tail as a separate shape left a seam + colour gap).
        this.drawBubbleFrame = ()=>{
            const g = this.chatBubble;
            const w = this.bubbleW;
            const h = this.bubbleH;
            const { side: side, dx: dx, lift: lift } = this.placement;
            const c = $1d5c2742ca857d0e$var$BUBBLE_CHAMFER;
            // The tail's x positions are authored for a bubble on the speaker's right; on the left they
            // mirror, so the tail still reaches back toward the head.
            const tailX = (x)=>side === "right" ? x : w - x;
            const baseA = tailX($1d5c2742ca857d0e$var$TAIL_BASE_RIGHT_X);
            const baseB = tailX($1d5c2742ca857d0e$var$TAIL_BASE_LEFT_X);
            // The path runs right-to-left along the bottom edge, so it meets the rightmost base first.
            const tailEnter = Math.max(baseA, baseB);
            const tailLeave = Math.min(baseA, baseB);
            // A moved body slides, rises or drops; the tip stays over the speaker, so the tail reaches it.
            const tipX = tailX($1d5c2742ca857d0e$var$TAIL_TIP_X) - dx;
            const tipY = h + $1d5c2742ca857d0e$var$TAIL_DROP + lift;
            // Which edge the tail leaves from: the bottom, normally; the speaker-facing side once a drop
            // has brought the body down level with the tip.
            const facingX = side === "right" ? 0 : w;
            const tail = tipY >= h + $1d5c2742ca857d0e$var$MIN_TAIL_DROP ? "bottom" : "side";
            const sideMid = Math.min(Math.max(tipY, c + $1d5c2742ca857d0e$var$SIDE_TAIL_HALF), h - c - $1d5c2742ca857d0e$var$SIDE_TAIL_HALF);
            const sideTipX = side === "right" ? Math.min(tipX, -$1d5c2742ca857d0e$var$SIDE_TAIL_LEN) : Math.max(tipX, w + $1d5c2742ca857d0e$var$SIDE_TAIL_LEN);
            const tracePath = (oy)=>{
                g.moveTo(c, oy);
                g.lineTo(w - c, oy);
                g.lineTo(w, oy + c);
                if (tail === "side" && side === "left") {
                    // down the right edge, out to the tip and back
                    g.lineTo(facingX, oy + sideMid - $1d5c2742ca857d0e$var$SIDE_TAIL_HALF);
                    g.lineTo(sideTipX, oy + tipY);
                    g.lineTo(facingX, oy + sideMid + $1d5c2742ca857d0e$var$SIDE_TAIL_HALF);
                }
                g.lineTo(w, oy + h - c);
                g.lineTo(w - c, oy + h);
                if (tail === "bottom") {
                    g.lineTo(tailEnter, oy + h);
                    g.lineTo(tipX, oy + tipY) // out to the tail tip, back down toward the speaker
                    ;
                    g.lineTo(tailLeave, oy + h);
                }
                g.lineTo(c, oy + h);
                g.lineTo(0, oy + h - c);
                if (tail === "side" && side === "right") {
                    // up the left edge, out to the tip and back
                    g.lineTo(facingX, oy + sideMid + $1d5c2742ca857d0e$var$SIDE_TAIL_HALF);
                    g.lineTo(sideTipX, oy + tipY);
                    g.lineTo(facingX, oy + sideMid - $1d5c2742ca857d0e$var$SIDE_TAIL_HALF);
                }
                g.lineTo(0, oy + c);
                g.closePath();
            };
            g.clear();
            g.x = this.bubbleXFor(side) + dx;
            g.y = this.bubbleRestY - lift;
            // Dropped silhouette (same path, no stroke) so the panel sits ON the world, not in it
            g.lineStyle(0);
            g.beginFill(0x000000, $1d5c2742ca857d0e$var$BUBBLE_SHADOW_ALPHA);
            tracePath($1d5c2742ca857d0e$var$BUBBLE_SHADOW_Y);
            g.endFill();
            // Panel body + tail: one path, filled with the dark edge stroke...
            g.lineStyle({
                width: $1d5c2742ca857d0e$var$BUBBLE_EDGE_WIDTH,
                color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
                alpha: $1d5c2742ca857d0e$var$BUBBLE_EDGE_ALPHA,
                join: (0, $gwPoJ.LINE_JOIN).MITER,
                miterLimit: $1d5c2742ca857d0e$var$BUBBLE_MITER_LIMIT
            });
            g.beginFill($1d5c2742ca857d0e$var$BUBBLE_FILL, $1d5c2742ca857d0e$var$BUBBLE_FILL_ALPHA);
            tracePath(0);
            g.endFill();
            // ...then the bronze rim down the middle of it
            g.lineStyle({
                width: $1d5c2742ca857d0e$var$BUBBLE_RIM_WIDTH,
                color: (0, $97475243e21a0995$export$cac838e5dd111a30),
                alpha: 1,
                join: (0, $gwPoJ.LINE_JOIN).MITER,
                miterLimit: $1d5c2742ca857d0e$var$BUBBLE_MITER_LIMIT
            });
            tracePath(0);
            // One lit edge along the top, so the panel has a direction the light falls from (build_board)
            g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), $1d5c2742ca857d0e$var$BUBBLE_TOP_LIGHT_ALPHA);
            g.moveTo(c + 1, 2.5);
            g.lineTo(w - c - 1, 2.5);
            g.lineStyle(0);
        }, // This frame's slot in the bubble layout: the body on either side of the speaker, in a unit space
        // every HUD shares (HUD units, shifted by this HUD's on-screen origin), plus the visible screen
        // in those units. Null while there is no line up or the entity is not being drawn.
        this.bubbleSlot = (screen)=>{
            if (!this.bubbleOrder || !this.chatBubble.visible || !this.worldVisible) return null;
            const origin = this.toGlobal($1d5c2742ca857d0e$var$LAYOUT_ORIGIN, $1d5c2742ca857d0e$var$layoutOriginOut);
            const unit = this.toGlobal($1d5c2742ca857d0e$var$LAYOUT_UNIT, $1d5c2742ca857d0e$var$layoutUnitOut);
            const scaleX = unit.x - origin.x;
            const scaleY = unit.y - origin.y;
            if (!(scaleX > 0) || !(scaleY > 0)) return null;
            const x = origin.x / scaleX;
            const y = origin.y / scaleY + this.bubbleRestY;
            const w = this.bubbleW;
            const h = this.bubbleH;
            const rightX = x + this.bubbleXFor("right");
            const leftX = x + this.bubbleXFor("left");
            const baseMid = ($1d5c2742ca857d0e$var$TAIL_BASE_LEFT_X + $1d5c2742ca857d0e$var$TAIL_BASE_RIGHT_X) / 2;
            const tipY = y + h + $1d5c2742ca857d0e$var$TAIL_DROP;
            return {
                order: this.bubbleOrder,
                held: this.holding,
                fading: !!this.chatBubbleFader,
                right: {
                    x: rightX,
                    y: y,
                    w: w,
                    h: h
                },
                left: {
                    x: leftX,
                    y: y,
                    w: w,
                    h: h
                },
                tailBaseX: {
                    right: rightX + baseMid,
                    left: leftX + w - baseMid
                },
                tip: {
                    right: {
                        x: rightX + $1d5c2742ca857d0e$var$TAIL_TIP_X,
                        y: tipY
                    },
                    left: {
                        x: leftX + w - $1d5c2742ca857d0e$var$TAIL_TIP_X,
                        y: tipY
                    }
                },
                current: this.placementTarget,
                head: {
                    x: rightX - $1d5c2742ca857d0e$var$BUBBLE_X + $1d5c2742ca857d0e$var$HEAD_CENTER_X - $1d5c2742ca857d0e$var$HEAD_HALF_W,
                    y: tipY - $1d5c2742ca857d0e$var$HEAD_ABOVE_TIP,
                    w: $1d5c2742ca857d0e$var$HEAD_HALF_W * 2,
                    h: $1d5c2742ca857d0e$var$HEAD_ABOVE_TIP + $1d5c2742ca857d0e$var$HEAD_BELOW_TIP
                },
                bounds: screen && {
                    x: screen.x / scaleX,
                    y: screen.y / scaleY,
                    w: screen.w / scaleX,
                    h: screen.h / scaleY
                }
            };
        }, this.bubbleScreenRect = ()=>{
            if (!this.bubbleOrder || !this.chatBubble.visible || !this.worldVisible || this.chatBubble.worldAlpha <= 0) return null;
            const bounds = this.chatBubble.getBounds();
            return bounds.width > 0 && bounds.height > 0 ? {
                x: bounds.x,
                y: bounds.y,
                w: bounds.width,
                h: bounds.height
            } : null;
        }, this.applyBubblePlacement = (placement, paintRank, now)=>{
            this.liftOverlay(true, paintRank);
            const fresh = this.placementFresh;
            this.placementFresh = false;
            const target = this.placementTarget;
            if (placement.side === target.side && Math.abs(placement.dx - target.dx) < 1 && Math.abs(placement.lift - target.lift) < 1) return;
            this.placementTarget = placement;
            if (fresh || placement.side !== this.placement.side) {
                // A line nobody has seen yet, or a change of side -- which could only be animated by
                // sliding the panel across the speaker's face: go straight there.
                this.bubbleMoveEase = undefined;
                this.placement = placement;
                this.drawBubbleFrame();
                return;
            }
            this.bubbleMoveEase = {
                from: this.placement,
                to: placement,
                startedAt: now
            };
        }, // Slide/rise toward the target, over a fixed BUBBLE_MOVE_MS whatever the distance.
        this.animateBubblePlacement = (now)=>{
            const ease = this.bubbleMoveEase;
            if (!ease) return;
            const t = Math.min(1, Math.max(0, (now - ease.startedAt) / $1d5c2742ca857d0e$var$BUBBLE_MOVE_MS));
            const k = 1 - Math.pow(1 - t, 3);
            const dx = t >= 1 ? ease.to.dx : ease.from.dx + (ease.to.dx - ease.from.dx) * k;
            const lift = t >= 1 ? ease.to.lift : ease.from.lift + (ease.to.lift - ease.from.lift) * k;
            if (t >= 1) this.bubbleMoveEase = undefined;
            else if (Math.abs(dx - this.placement.dx) < 0.25 && Math.abs(lift - this.placement.lift) < 0.25) return; // not a visible step; skip the redraw
            this.placement = {
                side: this.placement.side,
                dx: dx,
                lift: lift
            };
            this.drawBubbleFrame();
        }, // ---------------------------------------------------------------------------------------
        // The "Next" button on a held bubble.
        // ---------------------------------------------------------------------------------------
        this.makeNextButton = ()=>{
            const button = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
                label: "Next \u203A",
                theme: "ember",
                shape: "chamfer",
                size: "small",
                bold: true,
                width: $1d5c2742ca857d0e$var$NEXT_BUTTON_W,
                height: $1d5c2742ca857d0e$var$NEXT_BUTTON_H,
                activation: "press",
                onClick: ()=>{
                    // Suppress the document-level world attack before advancing the held line.
                    (0, $5dbaf3682d88a932$export$46264c47e2aa11a2).notePressed();
                    this.advanceHeldSpeech();
                }
            });
            // The bubble owns the countdown; UiButton owns its label, plate, and input behavior.
            const progress = new (0, $gwPoJ.Graphics)();
            button.addChild(progress);
            this.nextButtonProgress = progress;
            return button;
        }, this.drawNextButton = ()=>{
            const pending = this.speechQueue.length;
            this.nextButton?.setLabel(pending > 0 ? `Next ${pending + 1}\u{203A}` : "Next \u203A");
        }, this.showNextButton = (bubbleW, bubbleH)=>{
            if (!this.nextButton) this.nextButton = this.makeNextButton();
            const button = this.nextButton;
            // Bottom-right inside the panel; the tail hangs off the bottom-LEFT, so the two never meet.
            button.x = bubbleW - $1d5c2742ca857d0e$var$BUBBLE_PAD_X - $1d5c2742ca857d0e$var$NEXT_BUTTON_W;
            button.y = bubbleH - $1d5c2742ca857d0e$var$BUBBLE_PAD_Y - $1d5c2742ca857d0e$var$NEXT_BUTTON_H;
            button.visible = true;
            button.resetInteraction();
            this.drawNextButton();
            if (button.parent !== this.chatBubble) this.chatBubble.addChild(button);
            // Only a button the player can actually reach is registered -- the registry is what the
            // follow-cam hides while it composites the overlay into its texture.
            (0, $5dbaf3682d88a932$export$46264c47e2aa11a2).register(button);
            this.armNextAutoAdvance();
        }, // Start this line's countdown. When it runs out the button takes exactly the path a press takes
        // -- same ack, same backlog cycling -- so the speaker cannot tell the two apart, and a scene
        // paced off the ack keeps moving whether or not anyone is watching it.
        this.armNextAutoAdvance = ()=>{
            this.clearNextAutoAdvance();
            this.nextArmedAt = Date.now();
            this.drawNextProgress();
            this.nextProgressInterval = setInterval(this.drawNextProgress, $1d5c2742ca857d0e$var$NEXT_PROGRESS_TICK_MS);
            this.nextAutoTimeout = setTimeout(()=>{
                this.nextAutoTimeout = undefined;
                this.advanceHeldSpeech();
            }, $1d5c2742ca857d0e$var$NEXT_BUTTON_AUTO_MS);
        }, this.clearNextAutoAdvance = ()=>{
            if (this.nextAutoTimeout) {
                clearTimeout(this.nextAutoTimeout);
                this.nextAutoTimeout = undefined;
            }
            if (this.nextProgressInterval) {
                clearInterval(this.nextProgressInterval);
                this.nextProgressInterval = undefined;
            }
            this.nextButtonProgress?.clear();
            this.nextProgressWidth = -1;
        }, // The countdown, as a thin gold bar along the bottom inside edge of the button that drains from
        // full to nothing. Time is read off the clock rather than counted in ticks so a throttled
        // background tab (or a dropped frame) leaves the bar honest about the timeout it is tracking.
        this.drawNextProgress = ()=>{
            const bar = this.nextButtonProgress;
            if (!bar) return;
            const remaining = 1 - (Date.now() - this.nextArmedAt) / $1d5c2742ca857d0e$var$NEXT_BUTTON_AUTO_MS;
            const full = $1d5c2742ca857d0e$var$NEXT_BUTTON_W - $1d5c2742ca857d0e$var$NEXT_PROGRESS_INSET * 2;
            const width = Math.max(0, Math.round(full * Math.min(1, remaining)));
            if (width === this.nextProgressWidth) return;
            this.nextProgressWidth = width;
            bar.clear();
            if (width <= 0) return;
            bar.beginFill($1d5c2742ca857d0e$var$NEXT_PROGRESS_COLOR, $1d5c2742ca857d0e$var$NEXT_PROGRESS_ALPHA);
            bar.drawRect($1d5c2742ca857d0e$var$NEXT_PROGRESS_INSET, $1d5c2742ca857d0e$var$NEXT_BUTTON_H - $1d5c2742ca857d0e$var$NEXT_PROGRESS_ROW, width, $1d5c2742ca857d0e$var$NEXT_PROGRESS_H);
            bar.endFill();
        }, this.hideNextButton = ()=>{
            this.clearNextAutoAdvance();
            const button = this.nextButton;
            if (!button) return;
            (0, $5dbaf3682d88a932$export$46264c47e2aa11a2).unregister(button);
            button.visible = false;
            button.resetInteraction();
            button.parent?.removeChild(button);
        }, this.onMouseOver = (show)=>{
            if (!this.suppressDetailHover && !this.speaking) {
                if (!this.alwaysShowLabel) {
                    this.idText.visible = show;
                    this.hpBar.visible = show;
                    this.fadeGlyphTo(show ? 0 : 1);
                }
                if (show) this.calcLabel();
            }
        };
        this.parentArea = parentArea;
        this.currentColor = color;
        // Paint the HUD's widgets by zIndex (see the Z_* constants) rather than by addChild order.
        this.sortableChildren = true;
        this.alwaysShowLabel = renderMeta.alwaysShowLabel;
        this.idText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("entityName").color(0xffffff).render();
        // No backing plate (variant B): give the name a crisp black outline + soft shadow so it stays
        // legible over busy terrain.
        const nameStyle = this.idText.style;
        nameStyle.stroke = "#000000";
        nameStyle.strokeThickness = 3;
        nameStyle.lineJoin = "round";
        nameStyle.dropShadow = true;
        nameStyle.dropShadowColor = "#000000";
        nameStyle.dropShadowAlpha = 0.55;
        nameStyle.dropShadowBlur = 2;
        nameStyle.dropShadowAngle = Math.PI / 2;
        nameStyle.dropShadowDistance = 1;
        // HP as a compact segmented meter drawn below the name (replaces the old "|" pipe text).
        this.hpBar = new (0, $gwPoJ.Graphics)();
        this.suppressDetailHover = suppressDetailHover;
        const startVisible = !suppressDetailHover ? this.alwaysShowLabel : false;
        this.idText.visible = startVisible;
        this.hpBar.visible = startVisible;
        this.idText.alpha = 1;
        const tag = new (0, $gwPoJ.Graphics)();
        tag.beginFill(0xffffff);
        tag.lineStyle(1, 0xffffff);
        tag.drawCircle(-8, 8, 6);
        tag.endFill();
        tag.zIndex = $1d5c2742ca857d0e$var$Z_TAG;
        this.addChild(tag);
        tag.visible = false;
        tag.alpha = 0.7;
        this.tag = tag;
        this.idText.zIndex = $1d5c2742ca857d0e$var$Z_LABEL;
        this.hpBar.zIndex = $1d5c2742ca857d0e$var$Z_LABEL;
        this.addChild(this.idText);
        this.addChild(this.hpBar);
        this.update(3, 3);
        this.calcLabel();
        this.chatBubble = new (0, $gwPoJ.Graphics)();
        this.chatBubble.visible = true;
        this.chatBubble.x = 0;
        this.chatBubble.zIndex = $1d5c2742ca857d0e$var$Z_CHAT_BUBBLE;
        this.addChild(this.chatBubble);
        const chatBubbleHorizontalSpacer = new (0, $gwPoJ.Graphics)();
        this.chatBubble.addChild(chatBubbleHorizontalSpacer);
        const bubbleText = this.makeBubbleText();
        this.chatBubble.addChild(bubbleText);
        this.chatBubble.visible = false;
        const pointer = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
            name: "icon-arrow.png",
            color: 0xffffff,
            scale: 1.0
        });
        pointer.visible = false;
        pointer.zIndex = $1d5c2742ca857d0e$var$Z_POINTER;
        this.addChild(pointer);
        this.pointerIcon = pointer;
    }
    updateSigil(sigil) {
        // remove existing sigil
        if (this.sigil) this.sigil.parent?.removeChild(this.sigil);
        if (sigil) {
            this.sigil = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                name: sigil,
                scale: 1.8,
                color: 0xffffff
            });
            this.sigil.x += this.sigil.width * 0.3;
            this.sigil.y = -3;
            this.sigil.zIndex = $1d5c2742ca857d0e$var$Z_SIGIL;
            this.addChild(this.sigil);
        }
    }
    addTag() {
        this.tag.visible = true;
        this.tag.tint = this.currentColor;
    }
    removeTag() {
        this.tag.visible = false;
    }
    // The entity is going away (removed, or culled and discarded). Drop the HUD's own timers and,
    // above all, take any live Next button out of the shared registry -- a button left in there
    // belongs to a HUD nobody can click any more, and the follow-cam would keep toggling it forever.
    cleanup() {
        this.stopBubbleFade();
        (0, $a77286236663d69d$export$54b23a9eafdee768).closed(this);
        this.bubbleOrder = 0;
        if (this.glyphAnimInterval) {
            clearInterval(this.glyphAnimInterval);
            this.glyphAnimInterval = undefined;
        }
        if (this.pointerIconPulseInterval) {
            clearInterval(this.pointerIconPulseInterval);
            this.pointerIconPulseInterval = undefined;
        }
        if (this.pointerIconAngleInterval) {
            clearInterval(this.pointerIconAngleInterval);
            this.pointerIconAngleInterval = undefined;
        }
        this.hideNextButton();
        this.speechQueue = [];
        this.holding = false;
        this.currentHeldMessage = undefined;
        this.holdDone = undefined;
        // Deliberately NOT fired: the HUD is being discarded, which is not the player reading
        // anything. A speaker waiting on the ack falls back to its own timeout instead.
        this.heldDismissedCallback = undefined;
    }
    updatePointerIcon(show, angle) {
        if (!show) {
            clearInterval(this.pointerIconPulseInterval);
            clearInterval(this.pointerIconAngleInterval);
            this.pointerIconPulseInterval = undefined;
            this.pointerIconAngleInterval = undefined;
            this.pointerIcon.visible = false;
            this.pointerIcon.angle = 0;
        } else if (angle !== undefined) {
            this.pointerIcon.visible = true;
            this.pointerIcon.angle = angle;
            const radius = 32;
            const x = radius * Math.sin(Math.PI * 180 / 360);
            const y = radius * Math.cos(Math.PI * 180 / 360);
            this.pointerIcon.x = x + radius - 10;
            this.pointerIcon.y = y + radius + 10;
            if (!this.pointerIconPulseInterval) {
                let scale = 1.0;
                let scaleDir = 1;
                this.pointerIconPulseInterval = setInterval(()=>{
                    scale += 0.01 * scaleDir;
                    if (scale > 1.2 || scale < 1.0) scaleDir = scaleDir * -1;
                    this.pointerIcon.scale.set(scale);
                }, 50);
            }
        }
    }
}




// Ground speed in pixels per second; walk cadence includes two successive 30% increases.
const $5db32d8baa90944d$var$REFERENCE_SPEED = 100;
const $5db32d8baa90944d$var$WALK_CADENCE_MULTIPLIER = 1.69;
// Cap the final cadence, including tuning, at three times the authored rate.
const $5db32d8baa90944d$var$MAX_RATE = 3;
// Time constant of the measured ground speed: long enough to ride over uneven interpolation steps.
const $5db32d8baa90944d$var$SMOOTHING_MS = 200;
// A stall longer than this, or a jump further than TELEPORT_DISTANCE, is not walking.
const $5db32d8baa90944d$var$MAX_SAMPLE_GAP_MS = 250;
const $5db32d8baa90944d$var$TELEPORT_DISTANCE = 64;
// A body easing to a stop never drops below this share of its gameplay speed, so a hop can't hang.
const $5db32d8baa90944d$var$MIN_GAMEPLAY_SHARE = 0.5;
class $5db32d8baa90944d$export$da5eb4266422a064 {
    update(entity, now = performance.now()) {
        this.measure(entity.location, now);
        const gameplay = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.speed.effectiveSpeed(entity);
        const nominal = Number.isFinite(gameplay) && gameplay > 0 ? gameplay : 0;
        const speed = Math.max(this.groundSpeed ?? nominal, nominal * $5db32d8baa90944d$var$MIN_GAMEPLAY_SHARE);
        // A stopped entity leaves walk through the normal idle driver. Keep the cycle running
        // during that handoff rather than freezing an airborne frame.
        if (speed > 0) {
            this.rate = speed / $5db32d8baa90944d$var$REFERENCE_SPEED;
            this.settled = speed;
        }
    }
    /** Pixels per second the feet are keeping pace with; held through a stop, like the cadence. */ get speed() {
        return this.settled;
    }
    measure({ x: x, y: y }, now) {
        const anchor = this.anchor;
        const elapsed = anchor ? now - anchor.time : Infinity;
        const distance = anchor ? Math.hypot(x - anchor.x, y - anchor.y) : 0;
        if (elapsed > $5db32d8baa90944d$var$MAX_SAMPLE_GAP_MS || distance > $5db32d8baa90944d$var$TELEPORT_DISTANCE) {
            // First sight, a stop, a deferred stretch or a teleport: measure afresh from here.
            this.anchor = {
                x: x,
                y: y,
                time: now
            };
            return;
        }
        // No new position yet (interpolation waiting on the network): fold this frame into the
        // next step rather than read it as a stop.
        if (distance === 0 || elapsed <= 0) return;
        const speed = distance * 1000 / elapsed;
        const blend = 1 - Math.exp(-elapsed / $5db32d8baa90944d$var$SMOOTHING_MS);
        this.groundSpeed = this.groundSpeed === undefined ? speed : this.groundSpeed + (speed - this.groundSpeed) * blend;
        this.anchor = {
            x: x,
            y: y,
            time: now
        };
    }
    apply(action, animation) {
        if (!action.startsWith("walk-") || !animation) return;
        if (!this.authoredSpeeds.has(animation)) this.authoredSpeeds.set(animation, animation.animationSpeed);
        // Always use the authored value: repeated updates must not compound the multiplier.
        animation.animationSpeed = this.authoredSpeeds.get(animation) * Math.min($5db32d8baa90944d$var$MAX_RATE, this.rate * $5db32d8baa90944d$var$WALK_CADENCE_MULTIPLIER);
    }
    constructor(){
        this.rate = 1;
        this.settled = 0;
        this.authoredSpeeds = new WeakMap();
    }
}


const $e063f6eb3a8e708e$export$63c78c3785eee0ce = (action)=>[
        "back",
        "left",
        "right"
    ].includes(action.split("-")[1]);
// Hand sockets in canonical 64px LPC frame coordinates. Column 0 is idle;
// walk animations contain columns 1–8. Objects remain upright while the hand
// follows the walking arm, rather than rotating a wall like a weapon.
// Measured at the visible palm on the human bases; keep both sexes explicit
// because their hand motion is not a constant translation of the same cycle.
// Hand names are anatomical: south/east use the character's left hand, west
// uses the right hand. The slash table below tracks these same hands.
const $e063f6eb3a8e708e$var$HANDS = {
    male: {
        front: [
            [
                44,
                48
            ],
            [
                44,
                48
            ],
            [
                44,
                46
            ],
            [
                44,
                46
            ],
            [
                44,
                46
            ],
            [
                44,
                48
            ],
            [
                44,
                49
            ],
            [
                43,
                50
            ],
            [
                44,
                49
            ]
        ],
        back: [
            [
                43,
                48
            ],
            [
                43,
                48
            ],
            [
                43,
                46
            ],
            [
                42,
                44
            ],
            [
                43,
                46
            ],
            [
                43,
                48
            ],
            [
                43,
                49
            ],
            [
                43,
                50
            ],
            [
                43,
                49
            ]
        ],
        left: [
            [
                24,
                47
            ],
            [
                25,
                49
            ],
            [
                26,
                49
            ],
            [
                26,
                49
            ],
            [
                24,
                48
            ],
            [
                22,
                48
            ],
            [
                25,
                48
            ],
            [
                27,
                49
            ],
            [
                27,
                48
            ]
        ],
        right: [
            [
                39,
                47
            ],
            [
                38,
                49
            ],
            [
                37,
                49
            ],
            [
                37,
                49
            ],
            [
                39,
                48
            ],
            [
                41,
                48
            ],
            [
                38,
                48
            ],
            [
                36,
                49
            ],
            [
                36,
                48
            ]
        ]
    },
    female: {
        front: [
            [
                43,
                48
            ],
            [
                43,
                48
            ],
            [
                43,
                47
            ],
            [
                42,
                47
            ],
            [
                43,
                47
            ],
            [
                43,
                48
            ],
            [
                42,
                49
            ],
            [
                41,
                49
            ],
            [
                43,
                49
            ]
        ],
        back: [
            [
                42,
                49
            ],
            [
                42,
                49
            ],
            [
                42,
                48
            ],
            [
                41,
                47
            ],
            [
                42,
                48
            ],
            [
                42,
                49
            ],
            [
                42,
                50
            ],
            [
                41,
                51
            ],
            [
                42,
                50
            ]
        ],
        left: [
            [
                26,
                47
            ],
            [
                26,
                49
            ],
            [
                27,
                50
            ],
            [
                26,
                49
            ],
            [
                23,
                48
            ],
            [
                22,
                48
            ],
            [
                24,
                49
            ],
            [
                25,
                49
            ],
            [
                26,
                48
            ]
        ],
        right: [
            [
                37,
                47
            ],
            [
                37,
                49
            ],
            [
                36,
                50
            ],
            [
                37,
                49
            ],
            [
                40,
                48
            ],
            [
                41,
                48
            ],
            [
                39,
                49
            ],
            [
                38,
                49
            ],
            [
                37,
                48
            ]
        ]
    }
};
// Slash columns 0–5. These follow the gripping hand through the swing, rather
// than reusing the walking wrist position while the arm crosses the body.
const $e063f6eb3a8e708e$var$SLASH_HANDS = {
    male: {
        back: [
            [
                43,
                47
            ],
            [
                41,
                43
            ],
            [
                38,
                40
            ],
            [
                41,
                42
            ],
            [
                50,
                31
            ],
            [
                52,
                36
            ]
        ],
        left: [
            [
                24,
                45
            ],
            [
                24,
                43
            ],
            [
                22,
                46
            ],
            [
                18,
                42
            ],
            [
                20,
                24
            ],
            [
                23,
                33
            ]
        ],
        front: [
            [
                44,
                47
            ],
            [
                38,
                47
            ],
            [
                30,
                47
            ],
            [
                40,
                46
            ],
            [
                50,
                42
            ],
            [
                50,
                38
            ]
        ],
        right: [
            [
                39,
                45
            ],
            [
                43,
                47
            ],
            [
                41,
                46
            ],
            [
                47,
                43
            ],
            [
                40,
                33
            ],
            [
                40,
                33
            ]
        ]
    },
    female: {
        back: [
            [
                43,
                47
            ],
            [
                38,
                42
            ],
            [
                37,
                39
            ],
            [
                39,
                40
            ],
            [
                50,
                31
            ],
            [
                52,
                36
            ]
        ],
        left: [
            [
                26,
                45
            ],
            [
                24,
                43
            ],
            [
                22,
                47
            ],
            [
                18,
                42
            ],
            [
                22,
                24
            ],
            [
                23,
                32
            ]
        ],
        front: [
            [
                44,
                47
            ],
            [
                38,
                47
            ],
            [
                30,
                47
            ],
            [
                40,
                46
            ],
            [
                49,
                43
            ],
            [
                50,
                40
            ]
        ],
        right: [
            [
                37,
                45
            ],
            [
                43,
                48
            ],
            [
                41,
                46
            ],
            [
                47,
                43
            ],
            [
                40,
                32
            ],
            [
                40,
                32
            ]
        ]
    }
};
const $e063f6eb3a8e708e$export$70e96cb8c74dadda = (action, frame, sex)=>{
    const [verb, direction] = action.split("-");
    const hands = (verb === "slash" ? $e063f6eb3a8e708e$var$SLASH_HANDS : $e063f6eb3a8e708e$var$HANDS)[sex]?.[direction];
    if (![
        "idle",
        "walk",
        "slash"
    ].includes(verb) || !hands) return undefined;
    const column = verb === "slash" ? frame % 6 : verb === "idle" ? 0 : frame % 8 + 1;
    const [x, y] = hands[column];
    return {
        x: x,
        y: y
    };
};


/** Native 64px frame coordinates, measured from the skeleton body atlas (beige.png).
 * Head bounds exclude hands and equipment. Values follow the displayed frame, not elapsed time.
 * Other body atlases can supply equivalent attachment tracks without effect-specific logic.
 */ const $7e34d28912a06f25$var$skeletonHead = {
    "cast-back": [
        [
            32.0,
            23.0
        ],
        [
            32.0,
            23.0
        ],
        [
            32.0,
            23.0
        ],
        [
            32.0,
            23.0
        ],
        [
            32.0,
            23.0
        ],
        [
            32.0,
            23.0
        ],
        [
            32.0,
            23.0
        ]
    ],
    "cast-left": [
        [
            32.5,
            22.0
        ],
        [
            32.5,
            22.0
        ],
        [
            32.5,
            22.0
        ],
        [
            32.5,
            22.0
        ],
        [
            32.5,
            22.0
        ],
        [
            32.5,
            22.0
        ],
        [
            32.5,
            22.0
        ]
    ],
    "cast-front": [
        [
            32.0,
            22.0
        ],
        [
            32.0,
            22.0
        ],
        [
            32.0,
            22.0
        ],
        [
            32.0,
            22.0
        ],
        [
            32.0,
            22.0
        ],
        [
            32.0,
            22.0
        ],
        [
            32.0,
            22.0
        ]
    ],
    "cast-right": [
        [
            31.5,
            22.0
        ],
        [
            31.5,
            22.0
        ],
        [
            31.5,
            22.0
        ],
        [
            31.5,
            22.0
        ],
        [
            31.5,
            22.0
        ],
        [
            31.5,
            22.0
        ],
        [
            31.5,
            22.0
        ]
    ],
    "idle-back": [
        [
            32.0,
            21.0
        ]
    ],
    "walk-back": [
        [
            32.0,
            21.0
        ],
        [
            32.0,
            21.0
        ],
        [
            32.0,
            22.0
        ],
        [
            32.0,
            21.0
        ],
        [
            32.0,
            21.0
        ],
        [
            32.0,
            21.0
        ],
        [
            32.0,
            22.0
        ],
        [
            32.0,
            21.0
        ]
    ],
    "idle-left": [
        [
            32.5,
            21.0
        ]
    ],
    "walk-left": [
        [
            32.5,
            22.0
        ],
        [
            32.5,
            21.0
        ],
        [
            32.5,
            21.0
        ],
        [
            32.5,
            21.0
        ],
        [
            32.5,
            22.0
        ],
        [
            32.5,
            21.0
        ],
        [
            32.5,
            21.0
        ],
        [
            32.5,
            21.0
        ]
    ],
    "idle-front": [
        [
            32.0,
            21.0
        ]
    ],
    "walk-front": [
        [
            32.0,
            21.0
        ],
        [
            32.0,
            21.0
        ],
        [
            32.0,
            22.0
        ],
        [
            32.0,
            21.0
        ],
        [
            32.0,
            21.0
        ],
        [
            32.0,
            21.0
        ],
        [
            32.0,
            22.0
        ],
        [
            32.0,
            21.0
        ]
    ],
    "idle-right": [
        [
            31.5,
            21.0
        ]
    ],
    "walk-right": [
        [
            31.5,
            22.0
        ],
        [
            31.5,
            21.0
        ],
        [
            31.5,
            21.0
        ],
        [
            31.5,
            21.0
        ],
        [
            31.5,
            22.0
        ],
        [
            31.5,
            21.0
        ],
        [
            31.5,
            21.0
        ],
        [
            31.5,
            21.0
        ]
    ],
    "slash-back": [
        [
            32.0,
            23.0
        ],
        [
            32.0,
            24.0
        ],
        [
            31.0,
            24.0
        ],
        [
            33.0,
            23.0
        ],
        [
            34.0,
            23.0
        ],
        [
            34.0,
            23.0
        ]
    ],
    "slash-left": [
        [
            32.5,
            22.0
        ],
        [
            30.5,
            24.0
        ],
        [
            30.5,
            22.0
        ],
        [
            29.5,
            22.0
        ],
        [
            28.5,
            22.0
        ],
        [
            28.5,
            22.0
        ]
    ],
    "slash-front": [
        [
            32.0,
            22.0
        ],
        [
            32.0,
            22.0
        ],
        [
            31.0,
            24.0
        ],
        [
            34.0,
            23.0
        ],
        [
            35.0,
            22.0
        ],
        [
            35.0,
            22.0
        ]
    ],
    "slash-right": [
        [
            31.5,
            22.0
        ],
        [
            33.5,
            24.0
        ],
        [
            33.5,
            22.0
        ],
        [
            34.5,
            22.0
        ],
        [
            35.5,
            22.0
        ],
        [
            35.5,
            22.0
        ]
    ]
};
const $7e34d28912a06f25$export$83b0fb0a2abe0f79 = (race, action, frame)=>{
    if (race !== "skeleton") return undefined;
    const track = $7e34d28912a06f25$var$skeletonHead[action] || $7e34d28912a06f25$var$skeletonHead[action.replace(/^idle-/, "walk-")];
    const point = track?.[Math.max(0, Math.min(track.length - 1, frame))];
    return point && {
        x: point[0],
        y: point[1]
    };
};
// Casting grip tracks place a small held object below the skull, between the raised palms.
// North-facing grips still locate electricity; the held object itself is occluded.
const $7e34d28912a06f25$var$skeletonCastingGrip = {
    back: [
        [
            32,
            43
        ],
        [
            32,
            42
        ],
        [
            32,
            40
        ],
        [
            32,
            38
        ],
        [
            32,
            35
        ],
        [
            32,
            32
        ],
        [
            32,
            38
        ]
    ],
    front: [
        [
            32,
            43
        ],
        [
            32,
            42
        ],
        [
            32,
            40
        ],
        [
            32,
            38
        ],
        [
            32,
            35
        ],
        [
            32,
            32
        ],
        [
            32,
            38
        ]
    ],
    left: [
        [
            24,
            43
        ],
        [
            24,
            42
        ],
        [
            24,
            40
        ],
        [
            24,
            38
        ],
        [
            24,
            35
        ],
        [
            24,
            32
        ],
        [
            24,
            38
        ]
    ],
    right: [
        [
            40,
            43
        ],
        [
            40,
            42
        ],
        [
            40,
            40
        ],
        [
            40,
            38
        ],
        [
            40,
            35
        ],
        [
            40,
            32
        ],
        [
            40,
            38
        ]
    ]
};
const $7e34d28912a06f25$export$892d851620cf8272 = (race, action, frame)=>{
    if (race !== "skeleton" || !action.startsWith("cast-")) return undefined;
    const track = $7e34d28912a06f25$var$skeletonCastingGrip[action.split("-")[1]];
    const point = track?.[Math.max(0, Math.min(track.length - 1, frame))];
    return point && {
        x: point[0],
        y: point[1]
    };
};
const $7e34d28912a06f25$var$skeletonCastingHands = {
    back: [
        [
            24,
            43,
            40,
            43
        ],
        [
            20,
            43,
            44,
            43
        ],
        [
            21,
            40,
            43,
            40
        ],
        [
            19,
            38,
            45,
            38
        ],
        [
            16,
            34,
            48,
            34
        ],
        [
            17,
            27,
            47,
            27
        ],
        [
            20,
            36,
            44,
            36
        ]
    ],
    front: [
        [
            24,
            43,
            40,
            43
        ],
        [
            20,
            43,
            44,
            43
        ],
        [
            21,
            40,
            43,
            40
        ],
        [
            19,
            38,
            45,
            38
        ],
        [
            16,
            34,
            48,
            34
        ],
        [
            17,
            27,
            47,
            27
        ],
        [
            20,
            36,
            44,
            36
        ]
    ],
    left: [
        [
            24,
            43,
            35,
            43
        ],
        [
            24,
            42,
            35,
            42
        ],
        [
            23,
            40,
            36,
            40
        ],
        [
            22,
            38,
            38,
            38
        ],
        [
            21,
            35,
            40,
            33
        ],
        [
            23,
            30,
            43,
            27
        ],
        [
            22,
            37,
            38,
            35
        ]
    ],
    right: [
        [
            29,
            43,
            40,
            43
        ],
        [
            29,
            42,
            40,
            42
        ],
        [
            28,
            40,
            41,
            40
        ],
        [
            26,
            38,
            42,
            38
        ],
        [
            24,
            33,
            43,
            35
        ],
        [
            21,
            27,
            41,
            30
        ],
        [
            26,
            35,
            42,
            37
        ]
    ]
};
const $7e34d28912a06f25$export$726616493d9a5aa4 = (race, action, frame)=>{
    if (race !== "skeleton" || !action.startsWith("cast-")) return undefined;
    const track = $7e34d28912a06f25$var$skeletonCastingHands[action.split("-")[1]];
    const points = track?.[Math.max(0, Math.min(track.length - 1, frame))];
    return points && [
        {
            x: points[0],
            y: points[1]
        },
        {
            x: points[2],
            y: points[3]
        }
    ];
};




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $3YyWq = parcelRequire("3YyWq");




parcelRequire("1avo5");
var $d3fD1 = parcelRequire("d3fD1");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");

/** Editable animation sequences over a regular spritesheet grid. Pixels are never changed. */ const $9fd5a5fba85e12d7$export$30bf87f000532fc8 = (atlas)=>{
    const frames = Object.values(atlas.frames);
    const first = frames[0];
    if (!first) throw new Error("This atlas has no frame geometry to edit");
    const { w: w, h: h } = first.frame;
    if (!Number.isInteger(w) || !Number.isInteger(h) || w < 1 || h < 1 || frames.some((f)=>f.rotated || f.trimmed || f.frame.w !== w || f.frame.h !== h || f.frame.x % w || f.frame.y % h)) throw new Error("Frame selection requires an untrimmed regular grid");
    return {
        cellWidth: w,
        cellHeight: h,
        columns: Math.floor(atlas.meta.size.w / w),
        rows: Math.floor(atlas.meta.size.h / h)
    };
};
const $9fd5a5fba85e12d7$export$9414e8884116436c = (atlas, animation)=>atlas.animations?.[animation] ?? Object.keys(atlas.frames).filter((name)=>name.startsWith(`${animation}-`)).sort((a, b)=>a.localeCompare(b, "en", {
            numeric: true
        }));
const $9fd5a5fba85e12d7$export$9b8ade19b46883e8 = (atlas, animation)=>{
    const grid = $9fd5a5fba85e12d7$export$30bf87f000532fc8(atlas);
    return $9fd5a5fba85e12d7$export$9414e8884116436c(atlas, animation).filter((name)=>atlas.frames[name]).map((name)=>{
        const frame = atlas.frames[name].frame;
        return {
            column: frame.x / grid.cellWidth,
            row: frame.y / grid.cellHeight
        };
    });
};
const $9fd5a5fba85e12d7$export$9866ea4c893875bd = (atlas, mapping)=>{
    const grid = $9fd5a5fba85e12d7$export$30bf87f000532fc8(atlas);
    if (!mapping || mapping.version !== 1 || mapping.cellWidth !== grid.cellWidth || mapping.cellHeight !== grid.cellHeight || !mapping.animations || typeof mapping.animations !== "object" || Array.isArray(mapping.animations)) throw new Error("Frame mapping does not match this atlas grid");
    for (const [animation, cells] of Object.entries(mapping.animations)){
        if (!/^(idle|walk|slash|thrust|cast|shoot|hurt|activate|deactivate|active|inactive)(-(back|left|front|right))?$/.test(animation)) throw new Error("Invalid animation name");
        if (!Array.isArray(cells) || cells.length > 256) throw new Error("An animation may contain up to 256 frames");
        for (const cell of cells)if (!cell || !Number.isInteger(cell.column) || !Number.isInteger(cell.row) || cell.column < 0 || cell.row < 0 || cell.column >= grid.columns || cell.row >= grid.rows) throw new Error("Selected frame is outside the spritesheet grid");
    }
};
const $9fd5a5fba85e12d7$export$29a0201d2d2b4789 = (atlas, mapping, namespace)=>{
    $9fd5a5fba85e12d7$export$9866ea4c893875bd(atlas, mapping);
    const frames = {
        ...atlas.frames
    }, animations = {
        ...atlas.animations
    };
    // Stable unique sheet suffix avoids PIXI's global frame-name collisions.
    let hash = 0;
    for (const c of namespace)hash = (hash << 5) - hash + c.charCodeAt(0) | 0;
    for (const [animation, cells] of Object.entries(mapping.animations)){
        const existing = Object.entries(atlas.frames).filter(([name])=>name.startsWith(`${animation}-`));
        const template = existing[0]?.[1] || Object.values(atlas.frames)[0];
        for (const [name] of existing)delete frames[name];
        animations[animation] = cells.map((cell, index)=>{
            const name = `${animation}-${index}-mapped${hash}`;
            frames[name] = {
                ...template,
                frame: {
                    ...template.frame,
                    x: cell.column * mapping.cellWidth,
                    y: cell.row * mapping.cellHeight
                }
            };
            return name;
        });
    }
    if (!Object.keys(frames).length) throw new Error("Keep at least one frame in the atlas");
    return {
        ...atlas,
        frames: frames,
        animations: animations
    };
};




parcelRequire("1avo5");
var $kXE1p = parcelRequire("kXE1p");

var $5UG8I = parcelRequire("5UG8I");


// A sheet that errors (404, transient network failure) is retried on another loader up to this
// many times before we give up and unblock waiting entities so they render available layers.
const $c1d8cd49591538f1$var$MAX_LOAD_ATTEMPTS = 3;
// Base backoff between retries (multiplied by attempt count).
const $c1d8cd49591538f1$var$RETRY_DELAY_MS = 500;
class $c1d8cd49591538f1$export$8f67d857ad88efa0 {
    static{
        this.loaderNumber = 0;
    }
    static{
        // Upper bound on how long a single loader.load() batch may run before we assume it is wedged
        // (a stalled request PIXI never resolves) and hand the batch back for retry elsewhere, so one
        // hung fetch can't leave isLoading stuck true and poison this container for the session.
        this.loadTimeoutMs = 30000;
    }
    constructor(){
        this.buffer = [];
        this.inFlight = [];
        this.add = (toLoad)=>{
            // Resolve now: a debounced batch may start after content activation.
            this.buffer.push({
                ...toLoad,
                publishedUrl: toLoad.publishedUrl ?? (0, $e5c675b7b9585b42$export$bab18279d67f8654)(toLoad.url)
            });
            this.scheduleFlush();
        };
        // (Re)arm the debounce that drains the buffer into a single loader.load() call. A burst of
        // adds within the window batches into one load. No-op while a load is in flight -- the load's
        // completion handler re-drains anything that arrived meanwhile (see flush), so requests can
        // never be stranded in the buffer waiting for an incidental future add().
        this.scheduleFlush = ()=>{
            if (this.isLoading || this.loader.loading) return;
            if (this.buffer.length < 1) return;
            if (this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(this.flush, 100);
        };
        this.flush = ()=>{
            this.timer = undefined;
            // Never add to a PIXI loader that is mid-run; the completion handler will re-drain.
            if (this.isLoading || this.loader.loading || this.buffer.length < 1) return;
            const batch = this.buffer;
            this.buffer = [];
            this.inFlight = batch;
            batch.forEach((item)=>{
                const { url: url, callback: callback, publishedUrl: publishedUrl } = item;
                // A url that has been here before -- a retry that round-robined back onto this
                // container -- still occupies a slot in PIXI's resource table, and Loader.add THROWS
                // on a duplicate name rather than replacing it. Unguarded that throw escapes the
                // forEach, so every later item in the batch is silently never added while inFlight
                // still claims them: the batch can then only end at the watchdog, 30s later. Dropping
                // the stale entry first is what makes a retry actually retry.
                //
                // Only ever reached for a resource that already settled (PIXI refuses to add while
                // loading, and flush bails above if the loader is mid-run), so nothing in flight is
                // discarded here.
                if (this.loader.resources[url]) delete this.loader.resources[url];
                try {
                    this.loader.add(url, publishedUrl, callback);
                } catch (e) {
                    // Defence in depth: a failed add must not strand the rest of the batch. Report it
                    // as a load failure so the url goes back through the normal retry path.
                    (0, $5UG8I.logger).warn({
                        tags: [
                            "assets",
                            "loading"
                        ]
                    }, "Sheet could not be queued", url, String(e));
                    callback({
                        name: url,
                        url: url,
                        error: e
                    });
                }
            });
            this.isLoading = true;
            // Guards the batch against being settled twice (watchdog firing vs. the real completion).
            let settled = false;
            const finish = ()=>{
                settled = true;
                if (this.watchdog) {
                    clearTimeout(this.watchdog);
                    this.watchdog = undefined;
                }
                this.isLoading = false;
                this.inFlight = [];
                // Items added while this batch was loading were held in the buffer; kick them off now
                // instead of waiting for the next incidental add() to happen to hit this loader idle.
                if (this.buffer.length > 0) this.scheduleFlush();
            };
            this.watchdog = setTimeout(()=>{
                if (settled) return;
                const stalled = this.inFlight;
                finish();
                this.onStall?.(stalled);
            }, $c1d8cd49591538f1$export$8f67d857ad88efa0.loadTimeoutMs);
            this.loader.load(()=>{
                if (settled) return;
                finish();
            });
        };
        this.entityId = "loader-" + ++$c1d8cd49591538f1$export$8f67d857ad88efa0.loaderNumber;
        // The LPC sheets are the bulk of what the shell has to fetch from the web, and these
        // loaders are separate instances -- setting Loader.shared.baseUrl does not reach them.
        this.loader = new (0, $kXE1p.Loader)((0, $a8f3c0c196817c22$export$7eca4ea16d4c8343)().assetBase);
    }
}
class $c1d8cd49591538f1$export$18359c08ecfb12c1 {
    constructor(){
        this.sheetLoadingState = {};
        this.loaders = new (0, $cb689cfa16c444ba$export$7230fbaff49306c8)();
        this.urlLoaderMap = new Map();
        this.loadedTextures = new Set();
        // Route a stalled in-flight request through the same failure path as a real load error, so it
        // is retried on a fresh loader instead of hanging forever behind a wedged one.
        this.handleStalled = (item)=>{
            (0, $5UG8I.logger).warn({
                tags: [
                    "assets",
                    "loading"
                ]
            }, "Sheet load stalled; retrying", item.url);
            // `name` as well as `url`: loadCallback keys off name (see the comment there), and a
            // synthetic failure has to look like a real resource or the retry is dropped on the floor.
            this.loadCallback({
                name: item.url,
                url: item.url,
                error: new Error("sheet load timeout")
            });
        };
        this.suppressTextureCacheWarnings = ()=>{
            const originalWarn = console.warn;
            console.warn = (...args)=>{
                // Suppress PIXI texture cache warnings
                if (args[0] && typeof args[0] === "string" && args[0].includes("Texture added to the cache with an id")) return;
                // Allow other warnings through
                originalWarn.apply(console, args);
            };
        };
        this.bulkLoad = (urls, completeCallback)=>{
            let descriptorCountdown = urls.length;
            if (!descriptorCountdown) {
                completeCallback();
                return;
            }
            urls.forEach((url)=>{
                this.load(url, (_)=>{
                    descriptorCountdown -= 1;
                    if (descriptorCountdown <= 0) {
                        (0, $5UG8I.logger).info({
                            tags: [
                                "assets",
                                "loading"
                            ]
                        }, "Bulk asset load completed", urls.length);
                        completeCallback();
                    }
                });
            });
        };
        this.getLoaderFor = (url)=>{
            return this.urlLoaderMap.get(url);
        };
        this.getTexturesFor = (url)=>(0, $1f08f7b8f85adf9e$export$250bc44beae81773).active?.resources.get(url)?.textures || this.getLoaderFor(url)?.resources[url]?.textures;
        this.getAnimationTexturesFor = (url, action)=>{
            const resource = (0, $1f08f7b8f85adf9e$export$250bc44beae81773).active?.resources.get(url) || this.getLoaderFor(url)?.resources[url];
            const authored = resource?.spritesheet?.animations?.[action];
            if (authored !== undefined) return authored;
            const textures = this.getTexturesFor(url);
            if (!textures) return undefined;
            return (0, $9fd5a5fba85e12d7$export$9414e8884116436c)({
                frames: textures,
                animations: {}
            }, action).map((name)=>textures[name]);
        };
        this.load = (url, callback)=>{
            if ((0, $1f08f7b8f85adf9e$export$250bc44beae81773).active?.resources.has(url)) {
                // A sheet a live publication changed was prepared already, and must win over any
                // logical-name loader state (including failed/late requests) from an older release.
                // A sheet it did not stage is unchanged, so the loader's copy is the right one.
                callback(url);
                return;
            }
            const key = `${url}`;
            const loadingState = this.sheetLoadingState[key];
            // its not yet been queued for loading; setup the sheet for loading
            // add the callback
            // register loader callback
            if (!loadingState) {
                this.sheetLoadingState[key] = {
                    url: url,
                    publishedUrl: (0, $e5c675b7b9585b42$export$bab18279d67f8654)(url),
                    lifeCycle: "loading",
                    callbacks: [
                        callback
                    ],
                    attempts: 1
                };
                this.dispatch(url);
                return;
            }
            // its already been loaded; callback immediately
            if (loadingState.lifeCycle === "loaded") {
                callback(url);
                return;
            }
            // a previous attempt failed and is currently idle; piggyback and re-issue the load
            if (loadingState.lifeCycle === "failed") {
                loadingState.callbacks.push(callback);
                this.retry(url);
                return;
            }
            // queue the callback
            loadingState.callbacks.push(callback);
        };
        // (Re)assign the url to the next round-robin loader and enqueue it. Round-robin advances each
        // call, so a retry almost always lands on a loader that doesn't already hold the failed
        // resource (avoiding PIXI's "resource already exists" no-op reload).
        this.dispatch = (url)=>{
            const loaderContainer = this.loaders.next();
            this.urlLoaderMap.set(url, loaderContainer.loader);
            loaderContainer.add({
                url: url,
                publishedUrl: this.sheetLoadingState[url].publishedUrl,
                callback: this.loadCallback
            });
        };
        this.loadCallback = (resource)=>{
            // Key off the resource NAME, never its url. These loaders carry a baseUrl (the native
            // shell fetches art from the web rather than from the app bundle), and resource-loader
            // prefixes that onto `url` while leaving `name` exactly as registered -- the relative
            // "assets/..." path this class keys sheetLoadingState by. Looking up by `url` misses every
            // entry once a baseUrl is set, and the miss is silent: the waiting callbacks never fire,
            // so composite sprites never initialize, never bake, and every character renders as an
            // invisible 1x1 placeholder while the terrain around them looks perfectly fine.
            const url = resource.name || resource.url;
            const loadingState = this.sheetLoadingState[url];
            if (!loadingState) return;
            // Already settled (e.g. a wedged batch was retried elsewhere and succeeded, then the
            // original finally errored in): ignore the late duplicate.
            if (loadingState.lifeCycle === "loaded") return;
            // A failed fetch still fires this callback (PIXI sets resource.error); our watchdog also
            // routes stalls here with a synthetic error. Don't mark such a sheet "loaded" with no
            // textures -- retry it, or (once exhausted) unblock waiters so they render what did load.
            if (resource.error) {
                this.onLoadFailed(url, loadingState);
                return;
            }
            // Check for duplicate textures and prevent cache warnings
            this.validateTextureCache(resource);
            // fullfill the waiting callbacks
            loadingState.callbacks.forEach((callback)=>{
                callback(loadingState.url);
            });
            // clear them out, mark resource as loaded
            loadingState.callbacks = [];
            loadingState.lifeCycle = "loaded";
        };
        this.onLoadFailed = (url, loadingState)=>{
            if (loadingState.attempts < $c1d8cd49591538f1$var$MAX_LOAD_ATTEMPTS) {
                loadingState.lifeCycle = "failed";
                (0, $5UG8I.logger).warn({
                    tags: [
                        "assets",
                        "loading"
                    ]
                }, "Sheet load failed; scheduling retry", url, loadingState.attempts);
                setTimeout(()=>this.retry(url), $c1d8cd49591538f1$var$RETRY_DELAY_MS * loadingState.attempts);
                return;
            }
            // Exhausted retries. Unblock any waiting entities (fire their callbacks) so they render
            // with the layers that did load rather than staying fully blank forever, and mark the
            // sheet terminal so it never retries again.
            (0, $5UG8I.logger).error({
                tags: [
                    "assets",
                    "loading"
                ]
            }, "Sheet load failed permanently; unblocking waiters", url);
            loadingState.callbacks.forEach((callback)=>{
                callback(loadingState.url);
            });
            loadingState.callbacks = [];
            loadingState.lifeCycle = "loaded";
        };
        this.retry = (url)=>{
            const loadingState = this.sheetLoadingState[url];
            // Only retry from an idle failed state; a retry already in flight (or a success) wins.
            if (!loadingState || loadingState.lifeCycle !== "failed") return;
            loadingState.attempts += 1;
            loadingState.lifeCycle = "loading";
            this.dispatch(url);
        };
        this.validateTextureCache = (resource)=>{
            if (!resource.spritesheet || !resource.spritesheet.textures) return;
            const textures = resource.spritesheet.textures;
            Object.keys(textures).forEach((textureId)=>{
                // Mark as loaded
                this.loadedTextures.add(textureId);
            });
        };
        // Method to check if a texture is already loaded
        this.isTextureLoaded = (textureId)=>{
            return this.loadedTextures.has(textureId);
        };
        // Method to clear texture tracking (useful for cleanup)
        this.clearTextureTracking = ()=>{
            this.loadedTextures.clear();
        };
        // Method to restore original console.warn (useful for debugging)
        this.restoreConsoleWarn = ()=>{
        // This would need to store the original warn function
        // For now, we'll keep the suppression active
        };
        for(let i = 0; i < 8; i++){
            const container = new $c1d8cd49591538f1$export$8f67d857ad88efa0();
            // A batch that hangs past the watchdog is failed + retried on another loader.
            container.onStall = (items)=>items.forEach((item)=>this.handleStalled(item));
            this.loaders.push(container);
        }
    // Suppress PIXI texture cache warnings
    // this.suppressTextureCacheWarnings()
    }
}
const $c1d8cd49591538f1$export$cd02f82db8cdb05 = new $c1d8cd49591538f1$export$18359c08ecfb12c1();




parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");

const $196acb402f85fad6$export$e07cbb799910afb0 = 8;
const $196acb402f85fad6$export$d51c6eb8facb1100 = (spriteId)=>{
    const [sheet, tile] = spriteId.includes(":") ? spriteId.split(":") : [
        "humanoid",
        spriteId
    ];
    const key = spriteId.includes(":") ? `${sheet}-${tile}` : tile;
    const texture = (0, $1f08f7b8f85adf9e$export$42d948b5d3f64a60)(sheet)?.textures?.[key];
    return texture?.valid ? (0, $35a6592763403c18$export$18f5cc6e613e3ff2)(texture) : undefined;
};
const $196acb402f85fad6$export$1c675dcfe1e38331 = (held, action, frame)=>{
    const socket = (0, $e063f6eb3a8e708e$export$70e96cb8c74dadda)(action, frame, held.sex);
    if (!socket) return undefined;
    const trimmed = $196acb402f85fad6$export$d51c6eb8facb1100(held.spriteId);
    if (!trimmed) return undefined;
    const sprite = new (0, $7Bs2Z.Sprite)(trimmed);
    // Lower the bottom-center anchor so the icon sits in the hands rather than
    // covering the wrist/shoulder at the measured socket.
    sprite.anchor.set(0.5, 1);
    sprite.scale.set(18 / Math.max(trimmed.orig.width, trimmed.orig.height));
    sprite.position.set(socket.x - 32, socket.y + $196acb402f85fad6$export$e07cbb799910afb0 - 32);
    return sprite;
};


const $39fb998eb7d66fde$var$INTERVAL = 20;
const $39fb998eb7d66fde$export$8130c6196a172b8a = 32;
class $39fb998eb7d66fde$export$7229ffc582571c48 {
    constructor({ animation: animation, sprite: sprite }){
        // Bake-region origin in native body-frame coordinates; shared across all frames of this action.
        // Every clone, including static and scaled ones, applies the same measured correction.
        this.offsetX = 0;
        this.offsetY = 0;
        this.play = (startFrame = 0)=>{
            if (this.animation) {
                this.animation.visible = true;
                this.animation.gotoAndPlay(startFrame);
            }
            if (this.sprite) this.sprite.visible = true;
        };
        this.stop = ()=>{
            if (this.animation) {
                this.animation.visible = false;
                this.animation.stop();
            }
            if (this.sprite) this.sprite.visible = false;
        };
        /**
     * Show this action FROZEN on its last frame -- the pose a one-shot animation LEAVES the body
     * in, rather than the one it starts from. The LPC `hurt` row is a collapse, so its final frame
     * is a body lying face-down: that single frame is the whole "fallen" depiction.
     *
     * Distinct from `play()`, which starts at frame 0 by default. A body that was already down when we
     * first laid eyes on it must not replay the fall it took before we got there.
     */ this.holdFinalFrame = ()=>{
            if (this.animation) {
                this.animation.visible = true;
                this.animation.gotoAndStop(Math.max(0, this.animation.totalFrames - 1));
            }
            if (this.sprite) this.sprite.visible = true;
        };
        this.fragmentBase = ()=>{
            if (this.animation) {
                const f = this.animation.textures[this.animation.currentFrame];
                return f;
            }
            if (this.sprite) return this.sprite.texture;
        };
        /**
     * Play this action BACKWARDS, from its last frame to its first, and stop there.
     *
     * The LPC `hurt` row is a collapse, so running it in reverse is a character pushing itself up
     * off the ground -- a get-up animation for free, with no extra art, no extra bake and no second
     * cache entry. PIXI's AnimatedSprite takes a negative `animationSpeed` natively and, with
     * `loop` off, stops at frame 0 and fires `onComplete`, which is exactly the handoff back to
     * standing.
     *
     * Safe to mutate `animationSpeed` here: every live sprite gets its OWN AnimatedSprite wrapper
     * (see cloneResult) and only the baked textures are shared. The caller restores the sign, since
     * this same wrapper is reused the next time the action plays forwards.
     */ this.playReverse = ()=>{
            if (this.animation) {
                this.animation.visible = true;
                this.animation.loop = false;
                this.animation.animationSpeed = -Math.abs(this.animation.animationSpeed);
                this.animation.gotoAndPlay(Math.max(0, this.animation.totalFrames - 1));
            }
            if (this.sprite) this.sprite.visible = true;
        };
        this.recolor = (color)=>{
            if (this.animation) this.animation.tint = color;
            if (this.sprite) this.sprite.tint = color;
        };
        this.sprite = sprite;
        this.animation = animation;
    }
}
class $39fb998eb7d66fde$var$SynchronousJob {
    static{
        // Set while walking the descriptors on the BAKE path only: true when a `type: "oversize"`
        // descriptor's sheet actually contributes frames to THIS action. The gate matters -- entities
        // carry their oversize weapon descriptor during walk and idle too, where that sheet has no
        // frames and the composite stays 64x64. Consumed once, to stamp the canonical entry's offset;
        // clones read the offset from there, never from this flag (which is undefined on a cache hit).
        this.textureCache = new Map();
    }
    static{
        this.animationCache = new Map();
    }
    static{
        // Number of live (on-screen) clones per cache key. Only keys at zero may be evicted; this is
        // what makes destroying baked textures safe -- they are shared by every live clone.
        this.refCounts = new Map();
    }
    static{
        // Upper bound on cached loadout+action entries. Beyond this, unreferenced entries are evicted
        // oldest-first and their baked RenderTextures destroyed (generateTexture textures are only
        // reclaimed by explicit destroy(), never by GC).
        this.maxCachedAnimations = 512;
    }
    static{
        // Build a fresh, independent display object from a cached result, reusing its baked textures.
        // Used for BOTH cache hits and the first (miss) caller, so the cached entry is never itself
        // handed to a live sprite -- only clones are, keeping the canonical safe to evict.
        this.cloneResult = (cached, source, key)=>{
            const { scale: scale = 1, speed: speed = 0.267, color: color = 0xffffff } = source;
            let animation;
            let sprite;
            const textures = cached.animation?.textures ?? (cached.sprite ? [
                cached.sprite.texture
            ] : []);
            if (source.animated !== false) {
                animation = new (0, $d3fD1.AnimatedSprite)(textures);
                animation.scale.set(scale);
                animation.animationSpeed = speed;
                animation.visible = false;
                animation.tint = color;
                // Read off the cached entry, never recomputed here -- see LpcJobResult.offsetX.
                animation.position.set(cached.offsetX * scale, cached.offsetY * scale);
            } else {
                sprite = new (0, $7Bs2Z.Sprite)(textures[0]);
                sprite.tint = color;
                sprite.scale.set(scale);
                sprite.position.set(cached.offsetX * scale, cached.offsetY * scale);
                sprite.visible = false;
            }
            const result = new $39fb998eb7d66fde$export$7229ffc582571c48({
                animation: animation,
                sprite: sprite
            });
            result.key = key;
            result.offsetX = cached.offsetX;
            result.offsetY = cached.offsetY;
            return result;
        };
    }
    static{
        // The cache key for a loadout+action -- shared by every sprite with the same descriptors, action
        // and submerged flag. Single source of truth for both generate() and request-time retains.
        this.computeKey = (descriptors, action, lpcRenderProps)=>`generation:${(0, $e5c675b7b9585b42$export$eca3444cf0ef4f9a)()}:renderer:${(0, $065c5647ab3ff4dc$export$a54b2446196f1812)()}:` + JSON.stringify(descriptors) + "_" + action + lpcRenderProps.isSubmerged + JSON.stringify(lpcRenderProps.bodyFrame ?? {
                w: 64,
                h: 64
            }) + (lpcRenderProps.heldObject ? JSON.stringify(lpcRenderProps.heldObject) : "") + (lpcRenderProps.frameOverrides ? "_frames:" + lpcRenderProps.frameOverrides.key : "");
    }
    static{
        // Increment the live reference count for a key. Callers retain a key from the moment they REQUEST
        // its generation (see LpcCompositeSprite.doPreparation), NOT when they adopt the clone: generation
        // is async/time-budgeted and the baked textures are shared across sprites, so retaining only on
        // adopt leaves a request->adopt window in which eviction could destroy textures a soon-to-be-live
        // clone needs -- the clone then renders a destroyed texture and Pixi throws in calculateVertices.
        this.retainKey = (key)=>{
            if (!key) return;
            $39fb998eb7d66fde$var$SynchronousJob.refCounts.set(key, ($39fb998eb7d66fde$var$SynchronousJob.refCounts.get(key) || 0) + 1);
        };
    }
    static{
        // Decrement a key's reference count WITHOUT destroying any display object, then maybe evict.
        this.releaseKey = (key)=>{
            if (key) {
                const next = ($39fb998eb7d66fde$var$SynchronousJob.refCounts.get(key) || 0) - 1;
                if (next <= 0) $39fb998eb7d66fde$var$SynchronousJob.refCounts.delete(key);
                else $39fb998eb7d66fde$var$SynchronousJob.refCounts.set(key, next);
            }
            $39fb998eb7d66fde$var$SynchronousJob.maybeEvict();
        };
    }
    static{
        // Result-based convenience wrappers (used by tests and internal callers).
        this.retain = (result)=>{
            $39fb998eb7d66fde$var$SynchronousJob.retainKey(result?.key);
        };
    }
    static{
        // Decrement the count and destroy the clone's display object (textures untouched -- they belong
        // to the cache). May trigger eviction of now-unreferenced entries.
        this.release = (result)=>{
            $39fb998eb7d66fde$var$SynchronousJob.destroyClone(result);
            $39fb998eb7d66fde$var$SynchronousJob.releaseKey(result?.key);
        };
    }
    static{
        // Dispose a clone's display object without touching the refcount: either a clone that was never
        // adopted (sprite discarded before the async callback), or an adopted clone torn down at cleanup
        // where its request-time key hold is released separately via releaseKey.
        this.abandon = (result)=>{
            $39fb998eb7d66fde$var$SynchronousJob.destroyClone(result);
        };
    }
    static{
        this.destroyClone = (result)=>{
            if (!result) return;
            try {
                result.animation?.destroy({
                    children: true,
                    texture: false,
                    baseTexture: false
                });
            } catch (e) {
            // ignore -- best-effort teardown
            }
            try {
                result.sprite?.destroy({
                    children: true,
                    texture: false,
                    baseTexture: false
                });
            } catch (e) {
            // ignore -- best-effort teardown
            }
        };
    }
    static{
        // Evict unreferenced entries oldest-first until under the cap (or nothing evictable remains).
        this.maybeEvict = ()=>{
            while($39fb998eb7d66fde$var$SynchronousJob.animationCache.size > $39fb998eb7d66fde$var$SynchronousJob.maxCachedAnimations){
                let evicted = false;
                for (const key of $39fb998eb7d66fde$var$SynchronousJob.animationCache.keys())if (($39fb998eb7d66fde$var$SynchronousJob.refCounts.get(key) || 0) <= 0) {
                    $39fb998eb7d66fde$var$SynchronousJob.evictKey(key);
                    evicted = true;
                    break;
                }
                if (!evicted) break;
            }
        };
    }
    static{
        this.evictKey = (key)=>{
            const canonical = $39fb998eb7d66fde$var$SynchronousJob.animationCache.get(key);
            $39fb998eb7d66fde$var$SynchronousJob.animationCache.delete(key);
            $39fb998eb7d66fde$var$SynchronousJob.refCounts.delete(key);
            // Destroy this key's baked frame RenderTextures (safe: no live clone references them).
            const prefix = `${key}-f-`;
            for (const tKey of Array.from($39fb998eb7d66fde$var$SynchronousJob.textureCache.keys()))if (tKey.startsWith(prefix)) {
                const tex = $39fb998eb7d66fde$var$SynchronousJob.textureCache.get(tKey);
                $39fb998eb7d66fde$var$SynchronousJob.textureCache.delete(tKey);
                try {
                    tex?.destroy(true);
                } catch (e) {
                // ignore -- best-effort teardown
                }
            }
            // Drop the cache-only canonical holder (its textures were destroyed just above).
            $39fb998eb7d66fde$var$SynchronousJob.destroyClone(canonical);
        };
    }
    static{
        this.clearCaches = ()=>{
            $39fb998eb7d66fde$var$SynchronousJob.textureCache.clear();
            $39fb998eb7d66fde$var$SynchronousJob.animationCache.clear();
            $39fb998eb7d66fde$var$SynchronousJob.refCounts.clear();
        };
    }
    constructor(key, action, lpcRenderMeta, lpcRenderProps, descriptors, callback, cancelled){
        this.generation = (0, $e5c675b7b9585b42$export$eca3444cf0ef4f9a)();
        this.rendererGeneration = (0, $065c5647ab3ff4dc$export$a54b2446196f1812)();
        this.isCancelled = ()=>this.generation !== (0, $e5c675b7b9585b42$export$eca3444cf0ef4f9a)() || this.rendererGeneration !== (0, $065c5647ab3ff4dc$export$a54b2446196f1812)() || !!this.cancelled?.();
        this.process = ()=>{
            // The requesting sprite was discarded before this job ran (e.g. entity torn down on a room
            // change); skip the bake entirely -- nothing is waiting for the result.
            if (this.isCancelled()) {
                this.callback(null);
                return;
            }
            const cachedResult = $39fb998eb7d66fde$var$SynchronousJob.animationCache.get(this.key);
            if (cachedResult) {
                const source = this.lpcRenderMeta;
                if (!source) {
                    this.callback(null);
                    return;
                }
                // Refresh LRU recency so an in-use entry isn't evicted ahead of colder ones.
                $39fb998eb7d66fde$var$SynchronousJob.animationCache.delete(this.key);
                $39fb998eb7d66fde$var$SynchronousJob.animationCache.set(this.key, cachedResult);
                const result = $39fb998eb7d66fde$var$SynchronousJob.cloneResult(cachedResult, source, this.key);
                this.result = result;
                this.callback(result);
                return;
            }
            let textureLayers = [];
            const processTextureLayers = ()=>{
                const layers = textureLayers.sort((a, b)=>a.order - b.order).map((n)=>n.textures);
                const animationFrameTextures = [];
                // No layer had textures for this action (e.g. every sheet was skipped or failed to
                // load). Nothing to bake -- report failure instead of dereferencing layers[0].
                if (layers.length < 1 || !layers[0]) {
                    this.callback(null);
                    return;
                }
                const frameCount = layers[0].length;
                const body = this.lpcRenderProps.bodyFrame ?? {
                    w: 64,
                    h: 64
                };
                let left = -body.w / 2, top = -body.h / 2, right = body.w / 2, bottom = body.h / 2;
                const surfaces = [];
                for(let frame = 0; frame < frameCount; frame++){
                    const surface = new (0, $gwPoJ.Graphics)();
                    const held = this.lpcRenderProps.heldObject && (0, $196acb402f85fad6$export$1c675dcfe1e38331)(this.lpcRenderProps.heldObject, this.action, frame);
                    const heldBehind = (0, $e063f6eb3a8e708e$export$63c78c3785eee0ce)(this.action);
                    if (held) {
                        if (this.lpcRenderProps.isSubmerged) {
                            const mask = new (0, $gwPoJ.Graphics)();
                            mask.beginFill(0xffffff);
                            mask.drawRect(-40, -40, 80, 64);
                            mask.endFill();
                            held.addChild(mask);
                            held.mask = mask;
                        }
                        if (heldBehind) surface.addChild(held);
                    }
                    for(let l = 0; l < layers.length; l++){
                        const layerFrame = layers[l][frame];
                        // A layer with fewer frames than layer 0 has no texture here; skip it rather
                        // than baking an empty Sprite for it.
                        if (!layerFrame) continue;
                        const sprite = new (0, $7Bs2Z.Sprite)(layerFrame);
                        sprite.anchor.set(0.5, 0.5);
                        surface.addChild(sprite);
                        if (this.lpcRenderProps.isSubmerged) {
                            const mask = new (0, $gwPoJ.Graphics)();
                            mask.beginFill(0x000000, 1.0);
                            mask.drawRect(-40, -40, 80, 64);
                            mask.endFill();
                            sprite.addChild(mask);
                            sprite.mask = mask;
                        }
                    }
                    // North/east/west carry behind the body; south carries above it.
                    // Baking both in the same frame keeps the hand motion synchronized.
                    if (held && !heldBehind) surface.addChild(held);
                    const bounds = surface.getLocalBounds();
                    left = Math.min(left, bounds.x);
                    top = Math.min(top, bounds.y);
                    right = Math.max(right, bounds.x + bounds.width);
                    bottom = Math.max(bottom, bounds.y + bounds.height);
                    surfaces.push(surface);
                }
                // Integer edges preserve pixel sampling, even when held art has fractional bounds.
                const region = new (0, $6qzqq.Rectangle)(Math.floor(left), Math.floor(top), Math.ceil(right) - Math.floor(left), Math.ceil(bottom) - Math.floor(top));
                surfaces.forEach((surface, frame)=>{
                    const textureKey = `${this.key}-f-${frame}`;
                    let texture = $39fb998eb7d66fde$var$SynchronousJob.textureCache.get(textureKey);
                    if (!texture) {
                        texture = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer.generateTexture(surface, {
                            region: region
                        });
                        $39fb998eb7d66fde$var$SynchronousJob.textureCache.set(textureKey, texture);
                    }
                    animationFrameTextures.push(texture);
                    surface.destroy({
                        children: true
                    });
                });
                if (animationFrameTextures.length < 1) {
                    this.callback(null);
                    return;
                }
                const source = this.lpcRenderMeta;
                if (!source) {
                    this.callback(null);
                    return;
                }
                // Keep all frames in the canonical cache; clones choose static or animated display.
                const canonicalAnimation = new (0, $d3fD1.AnimatedSprite)(animationFrameTextures);
                canonicalAnimation.visible = false;
                const canonical = new $39fb998eb7d66fde$export$7229ffc582571c48({
                    animation: canonicalAnimation
                });
                canonical.key = this.key;
                // Stamped here, on the cache entry, while we still know which sheets fed this action --
                // every clone (this caller's and every later cache hit's) then reads the same numbers.
                canonical.offsetX = region.x + body.w / 2;
                canonical.offsetY = region.y + body.h / 2;
                $39fb998eb7d66fde$var$SynchronousJob.animationCache.set(this.key, canonical);
                // Safe to evict here: the caller retained this key at REQUEST time (see doPreparation),
                // so maybeEvict() cannot destroy the loadout we are about to clone and hand back.
                $39fb998eb7d66fde$var$SynchronousJob.maybeEvict();
                const result = $39fb998eb7d66fde$var$SynchronousJob.cloneResult(canonical, source, this.key);
                this.result = result;
                this.callback(result);
                return canonical;
            };
            this.descriptors.forEach((descriptor, i)=>{
                const overrides = this.lpcRenderProps.frameOverrides?.sheets[descriptor.entityId];
                if (overrides !== undefined) {
                    textureLayers.push({
                        order: i,
                        textures: overrides
                    });
                    return;
                }
                const sheetId = `lpc/spritesheets/${descriptor.entityId}.json`;
                const url = `assets/${sheetId}`;
                const textures = (0, $c1d8cd49591538f1$export$cd02f82db8cdb05).getAnimationTexturesFor(url, this.action);
                if (!textures) return;
                const x = {
                    order: i,
                    textures: textures
                };
                textureLayers.push(x);
            });
            // processTextureLayers caches the canonical entry itself (and evicts if over cap).
            processTextureLayers();
        };
        this.getResult = ()=>this.result;
        this.getKey = ()=>this.key;
        this.key = key;
        this.action = action;
        this.lpcRenderMeta = lpcRenderMeta;
        this.lpcRenderProps = lpcRenderProps;
        this.descriptors = descriptors;
        this.callback = callback;
        this.cancelled = cancelled;
        this.startTs = Date.now();
    }
}
class $39fb998eb7d66fde$var$LpcCompositeGenerator {
    // Max cached loadout+action entries before unreferenced ones are evicted.
    get maxCachedAnimations() {
        return $39fb998eb7d66fde$var$SynchronousJob.maxCachedAnimations;
    }
    set maxCachedAnimations(n) {
        $39fb998eb7d66fde$var$SynchronousJob.maxCachedAnimations = n;
        $39fb998eb7d66fde$var$SynchronousJob.maybeEvict();
    }
    constructor(){
        this.jobs = [];
        // cache: Map<string, AnimatedSprite> = new Map()
        this.processing = new Set();
        this.latch = new (0, $cb689cfa16c444ba$export$b56caa74c129a90c)(1000);
        // Per-tick wall-clock budget (ms) for building composites. Instead of a fixed one-job-per-tick
        // cap, process() drains jobs until this much time is spent, always doing at least one so the
        // queue makes progress. This is self-scaling across hardware: cache-hit clones are nearly free
        // so many drain per tick, while an expensive generateTexture bake eats the budget -- so a weak
        // GPU naturally does ~1 bake/tick (no frame hitch) and a fast one does many (rooms populate
        // near-instantly). Kept small so a single tick can't blow a 60fps frame on low-end hardware.
        this.bakeBudgetMs = 4;
        // Monotonic clock used for the budget. Prefers performance.now() (sub-ms, and NOT the mocked
        // Date.now this codebase uses for game time). Overridable in tests.
        this.now = ()=>typeof performance !== "undefined" && performance.now ? performance.now() : Date.now();
        this.generate = (priority, action, lpcRenderMeta, lpcRenderProps, descriptors, callback, cancelled)=>{
            const key = $39fb998eb7d66fde$var$SynchronousJob.computeKey(descriptors, action, lpcRenderProps);
            const job = new $39fb998eb7d66fde$var$SynchronousJob(key, action, lpcRenderMeta, lpcRenderProps, descriptors, callback, cancelled);
            if (priority) this.jobs.unshift(job);
            else this.jobs.push(job);
            if (!this.timer) this.timer = setInterval(this.process, $39fb998eb7d66fde$var$INTERVAL);
        };
        // Mark a clone as live on screen (call when a sprite adopts a generate result).
        this.retain = (result)=>$39fb998eb7d66fde$var$SynchronousJob.retain(result);
        // Mark a clone as gone (call when a sprite discards it); destroys the clone and may evict.
        this.release = (result)=>$39fb998eb7d66fde$var$SynchronousJob.release(result);
        // Dispose a clone that was never adopted (sprite discarded before the async callback arrived).
        this.abandon = (result)=>$39fb998eb7d66fde$var$SynchronousJob.abandon(result);
        // Retain a loadout key from the moment generation is REQUESTED (before the async job runs), so
        // eviction can't destroy its shared textures during the request->adopt window.
        this.retainKey = (key)=>$39fb998eb7d66fde$var$SynchronousJob.retainKey(key);
        // Release a request-time key hold (refcount-only; does not destroy any display object).
        this.releaseKey = (key)=>$39fb998eb7d66fde$var$SynchronousJob.releaseKey(key);
        // Compute the cache key for a loadout+action (same formula generate() uses).
        this.computeKey = (descriptors, action, lpcRenderProps)=>$39fb998eb7d66fde$var$SynchronousJob.computeKey(descriptors, action, lpcRenderProps);
        // Clears the static composite caches (test isolation / teardown).
        this.clearCaches = ()=>$39fb998eb7d66fde$var$SynchronousJob.clearCaches();
        this.process = ()=>{
            const start = this.now();
            // Drain jobs until the time budget is spent, always processing at least one so the queue
            // advances even if a single bake exceeds the budget on slow hardware.
            while(true){
                // Drop cancelled jobs (sprite discarded, e.g. on a room change) cheaply -- they don't
                // count against the budget. Their callbacks get null inside process(), which released
                // sprites ignore.
                let current = this.jobs.shift();
                while(current && current.isCancelled()){
                    current.process();
                    current = this.jobs.shift();
                }
                if (!current) {
                    clearInterval(this.timer);
                    this.timer = undefined;
                    return;
                }
                current.process();
                if (this.now() - start >= this.bakeBudgetMs) return;
            }
        };
    }
}
const $39fb998eb7d66fde$export$7100d33e089ec0 = new $39fb998eb7d66fde$var$LpcCompositeGenerator();




var $5UG8I = parcelRequire("5UG8I");


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
// The ground marker that says "a real person is driving this body".
//
// Other players are LPC characters exactly like every NPC in the world, so nothing about the art
// tells one apart -- and the cues that would (a permanent name plate, a chat bubble) either cost
// vertical space above the head or only appear when the player happens to speak. This is the quietest
// cue that still reads at a glance: a thin cool-toned ellipse painted on the ground under the feet,
// behind the body, so the character stands inside it. It occupies no space above the head, never
// occludes a neighbour, and a dozen of them on screen still parse -- which a dozen name plates do not.
//
// Deliberately NOT an outline glow: that vocabulary belongs to the hover/interaction highlight (see
// entity_highlight), and a permanent rim would read as "you can act on this" all the time. It is not
// animated either -- no ticker, no pulse. This is a standing fact about the entity, not an alert, and
// a static Graphics costs nothing on the low-end machines this game targets.
// Geometry lives in the sprite's own 64x64 art space; the sprite anchors the ring on the same foot
// line it draws its shadow on, so the ring sits where the character's weight is (and rides up with it
// when the body is submerged).
const $4422ba9e5bf47053$var$RING_RX = 13.5;
const $4422ba9e5bf47053$var$RING_RY = 6.25;
const $4422ba9e5bf47053$var$RING_WIDTH = 1.5;
// A darker contour under the bright ring, a pixel wider on each side, so the cue survives pale ground
// (sand, snow, the camp's trodden dirt) as well as dark grass -- the same trick the name plate plays
// with its black text stroke.
const $4422ba9e5bf47053$var$CONTOUR_COLOR = 0x0b1a26;
const $4422ba9e5bf47053$var$CONTOUR_WIDTH = $4422ba9e5bf47053$var$RING_WIDTH + 2;
// Alphas of the contour and the outer bloom, both expressed as a fraction of the ring's own alpha, so
// tuning `alpha` fades the whole marker together instead of pulling it apart.
const $4422ba9e5bf47053$var$CONTOUR_ALPHA_SHARE = 0.4;
// A very faint filled ellipse just outside the ring: it beds the marker into the ground instead of
// leaving it looking like a decal laid on top.
const $4422ba9e5bf47053$var$GLOW_RX = $4422ba9e5bf47053$var$RING_RX + 2;
const $4422ba9e5bf47053$var$GLOW_RY = $4422ba9e5bf47053$var$RING_RY + 1.5;
const $4422ba9e5bf47053$var$GLOW_ALPHA_SHARE = 0.14;
const $4422ba9e5bf47053$export$d54c1ceb0ac36b4e = {
    enabled: true,
    color: 0x8fd6ff,
    alpha: 0.8,
    scale: 1
};
let $4422ba9e5bf47053$var$tuning = {
    ...$4422ba9e5bf47053$export$d54c1ceb0ac36b4e
};
const $4422ba9e5bf47053$export$65a499c0f5c261b4 = ()=>$4422ba9e5bf47053$var$tuning;
// Every ring currently on screen. Tuning from the console repaints what is already there rather than
// only reaching players who walk into view afterwards; rings drop out of the set in dispose().
const $4422ba9e5bf47053$var$liveRings = new Set();
const $4422ba9e5bf47053$export$d7fdea8fdac98454 = (next)=>{
    const patch = typeof next === "boolean" ? {
        enabled: next
    } : next || {};
    $4422ba9e5bf47053$var$tuning = {
        ...$4422ba9e5bf47053$var$tuning,
        ...patch
    };
    $4422ba9e5bf47053$var$liveRings.forEach((ring)=>ring.redraw());
    return $4422ba9e5bf47053$var$tuning;
};
const $4422ba9e5bf47053$export$a1adf936bbb1d6bd = ()=>$4422ba9e5bf47053$export$d7fdea8fdac98454({
        ...$4422ba9e5bf47053$export$d54c1ceb0ac36b4e
    });
class $4422ba9e5bf47053$export$54b95433f33ae529 extends (0, $gwPoJ.Graphics) {
    constructor(){
        super();
        $4422ba9e5bf47053$var$liveRings.add(this);
        this.redraw();
    }
    redraw() {
        this.clear();
        const { enabled: enabled, color: color, alpha: alpha, scale: scale } = $4422ba9e5bf47053$var$tuning;
        this.visible = enabled;
        if (!enabled) return;
        const rx = $4422ba9e5bf47053$var$RING_RX * scale;
        const ry = $4422ba9e5bf47053$var$RING_RY * scale;
        // Bloom first, then the dark contour, then the bright ring on top of it.
        this.beginFill(color, alpha * $4422ba9e5bf47053$var$GLOW_ALPHA_SHARE);
        this.drawEllipse(0, 0, $4422ba9e5bf47053$var$GLOW_RX * scale, $4422ba9e5bf47053$var$GLOW_RY * scale);
        this.endFill();
        this.lineStyle($4422ba9e5bf47053$var$CONTOUR_WIDTH, $4422ba9e5bf47053$var$CONTOUR_COLOR, alpha * $4422ba9e5bf47053$var$CONTOUR_ALPHA_SHARE);
        this.drawEllipse(0, 0, rx, ry);
        this.lineStyle($4422ba9e5bf47053$var$RING_WIDTH, color, alpha);
        this.drawEllipse(0, 0, rx, ry);
        this.lineStyle(0);
    }
    // Decoration must never resize the thing it decorates. A renderable derives its on-screen y from
    // its own measured height (BaseRenderable.getYOffset reads `this.height`, a bounds query over every
    // child), so a ring that widened those bounds would nudge the very character it marks. Reporting no
    // bounds keeps the marker out of every measurement taken of the entity -- the same reasoning as the
    // hover outline's BoundlessContainer.
    calculateBounds() {
        this._bounds.clear();
    }
    // Stop tracking this ring for live tuning. The owning sprite calls this from its cleanup, which
    // runs on a paperdoll rebuild as well as on teardown -- remove() only detaches, it never destroys,
    // so without this the set would grow by one entry per rebuild.
    dispose() {
        $4422ba9e5bf47053$var$liveRings.delete(this);
    }
    destroy(options) {
        this.dispose();
        super.destroy(options);
    }
}
// Browser-console tuning, in the same shape as window.spriteShadow / window.deathEffect:
//
//     playerRing = false                 // off
//     playerRing = { scale: 1.4 }        // wider footprint
//     playerRing = { color: 0xff6688 }   // try another hue
//     playerRing                         // read the active values back
//
// Guarded so it is a no-op in the Node test harness.
if (typeof window !== "undefined") Object.defineProperty(window, "playerRing", {
    get: ()=>$4422ba9e5bf47053$var$tuning,
    set: (next)=>{
        console.log("[playerRing]", $4422ba9e5bf47053$export$d7fdea8fdac98454(next));
    },
    configurable: true
});



const $f8d5c1b1b5b3773e$export$cba6932b369e9838 = (view, elapsedMs)=>{
    if (view.loop && view.durationMs > 0) {
        const played = view.durationMs - view.remainingMs + Math.max(0, elapsedMs);
        return {
            action: view.action,
            progress: (played % view.durationMs + view.durationMs) % view.durationMs / view.durationMs
        };
    }
    const remaining = view.remainingMs - Math.max(0, elapsedMs);
    const progress = view.durationMs > 0 ? Math.max(0, Math.min(1, 1 - remaining / view.durationMs)) : 1;
    if (view.holdFrame !== undefined) return {
        action: view.action,
        progress: 0,
        frame: Math.floor(progress * view.holdFrame)
    };
    return {
        action: remaining <= 0 ? "idle" : view.action,
        progress: progress
    };
};



class $21f1d04df0291d18$export$fcc246d4cf8db2cd {
    constructor(){
        this.receivedAt = 0;
        this.update = (entity, now)=>{
            if (entity.hp <= 0 || entity.isDead() || !entity.animationPose) {
                this.view = undefined;
                return undefined;
            }
            if (entity.animationPose !== this.view) this.receivedAt = now;
            this.view = entity.animationPose;
            const sampled = (0, $f8d5c1b1b5b3773e$export$cba6932b369e9838)(this.view, now - this.receivedAt);
            if (this.view.performance) {
                // A performance (a wave, a bow) is the body's own business: once a one-off has played,
                // or while the body walks, it gives the sprite back to whatever the body is doing.
                if (sampled.action === "idle" || entity.movement?.moving) return undefined;
                return {
                    ...sampled,
                    action: `${sampled.action}-${(0, $a80d0b17b615d6f7$export$5ebc7cf9991d3d13)(this.view.angle)}`
                };
            }
            const directional = [
                "walk",
                "idle",
                "cast",
                "slash",
                "thrust",
                "shoot"
            ].includes(sampled.action);
            return {
                ...sampled,
                action: directional ? `${sampled.action}-${(0, $a80d0b17b615d6f7$export$5ebc7cf9991d3d13)(this.view.angle)}` : sampled.action
            };
        };
    }
}



class $73a6944abc919b07$export$13ce8c5ec6161fd3 {
    constructor(){
        this.receivedAt = 0;
        this.direction = "front";
        this.update = (entity, now)=>{
            if (!entity.bonecallerCombatRadius || entity.hp <= 0 || entity.isDead()) {
                this.attack = undefined;
                return undefined;
            }
            if (this.attack !== entity.bonecallerAttack) this.receivedAt = now;
            this.attack = entity.bonecallerAttack;
            const attack = this.attack;
            if (!attack || attack.remainingMs <= now - this.receivedAt) // Stale windup data must not play a strike while waiting for the next server message.
            return {
                action: `idle-${this.direction}`,
                progress: 0
            };
            this.direction = (0, $a80d0b17b615d6f7$export$5ebc7cf9991d3d13)(attack.angle);
            const t = Math.max(0, Math.min(1, 1 - (attack.remainingMs - now + this.receivedAt) / attack.durationMs));
            const progress = attack.phase === "anticipation" ? t * 0.15 : attack.phase === "windup" ? 0.15 + t * 0.15 : attack.phase === "impact" ? 0.3 + t * 0.45 : 0.75 * (1 - t);
            return {
                action: `thrust-${this.direction}`,
                progress: progress
            };
        };
    }
}


class $b14c359149a9de22$export$d861f9901197fdf3 {
    constructor(seed){
        this.strength = 0;
        let hash = 0;
        for(let i = 0; i < seed.length; i++)hash = Math.imul(hash, 31) + seed.charCodeAt(i) >>> 0;
        this.phase = hash % 1000 / 1000 * Math.PI * 2;
        this.period = 3500 + hash % 1500;
    }
    update(target, ground, now) {
        if (target !== this.target) {
            this.reset();
            this.target = target;
            if (target) this.base = {
                x: target.x,
                y: target.y,
                scaleX: target.scale.x,
                scaleY: target.scale.y
            };
        }
        if (!target || !this.base) return;
        const elapsed = this.lastTime === undefined ? 0 : Math.max(0, Math.min(100, now - this.lastTime));
        this.lastTime = now;
        this.strength = Math.min(1, this.strength + elapsed / 400);
        const breath = Math.sin(now / this.period * Math.PI * 2 + this.phase) * this.strength;
        const sx = 1 - breath * 0.002;
        const sy = 1 + breath * 0.008;
        target.scale.set(this.base.scaleX * sx, this.base.scaleY * sy);
        target.position.set(ground.x + (this.base.x - ground.x) * sx, ground.y + (this.base.y - ground.y) * sy);
    }
    reset() {
        if (this.target && this.base) {
            this.target.position.set(this.base.x, this.base.y);
            this.target.scale.set(this.base.scaleX, this.base.scaleY);
        }
        this.target = undefined;
        this.base = undefined;
        this.strength = 0;
        this.lastTime = undefined;
    }
}


/**
 * Ember animation clips: what the skeleton does over time.
 *
 * Locomotion is PROCEDURAL. A gait is a handful of numbers (step length, how long each foot stays
 * down, lift, bob, lean, arm swing), each ankle follows a planted-then-swung path and the legs
 * reach it with IK. A planted foot therefore never slides on the art, and the ground a cycle covers
 * is exact: `strideCycle`, which the client turns into cadence. More frames is a parameter, not
 * more drawing.
 *
 * Everything else is KEYFRAMED: a few key poses, eased between, sampled at any frame count.
 */ /**
 * The volumes an Ember humanoid is drawn from, hung on a solved skeleton.
 *
 * Clothing is geometry, not a painted layer: a garment re-uses the body's own volumes, slightly
 * inflated, in its own material. The raster keeps whichever surface is nearest the camera, so a
 * sleeve covers the arm, the arm passes in front of the shirt, and a cape falls behind the back,
 * frame by frame and facing by facing, with no layer order to get wrong. A new pose costs nothing
 * per garment.
 *
 * This file is the vocabulary everything is made of -- the primitive shapes, light and paint -- and
 * the engine that runs it. The body itself is data, like what it wears: content's
 * sprites/ember/bodies.json (flesh, bones, a beast's head, wounds, and the body's own volumes every
 * garment inflates), hair.json (hair), equipment.json (what it wears and holds), run here as models
 * (model.ts) by buildPrimitives and dressed().
 */ /**
 * Colour ramps for Ember sprites.
 *
 * A material is a five-step ramp plus the outline drawn where it meets the background. The shader
 * picks a step from lighting; it never invents colours, which is what keeps the output reading as
 * pixel art rather than a render. Skin ramps are sampled from the LPC bodies so Ember bodies sit
 * beside the existing art; everything else is derived from one base colour by `rampFrom`.
 */ 

const $b28f7e6af286c932$var$hex = (s)=>parseInt(s.replace("#", ""), 16);
const $b28f7e6af286c932$var$material = (light, base, shade, deep, line, outline)=>({
        light: $b28f7e6af286c932$var$hex(light),
        base: $b28f7e6af286c932$var$hex(base),
        shade: $b28f7e6af286c932$var$hex(shade),
        deep: $b28f7e6af286c932$var$hex(deep),
        line: $b28f7e6af286c932$var$hex(line),
        outline: $b28f7e6af286c932$var$hex(outline)
    });
const $b28f7e6af286c932$export$da9f99569d75238a = {};
const $b28f7e6af286c932$export$2ea2ecabe138b901 = {};
const $b28f7e6af286c932$export$c6254af65262af78 = {
    lpc: $b28f7e6af286c932$export$da9f99569d75238a,
    painted: $b28f7e6af286c932$export$2ea2ecabe138b901
};
const $b28f7e6af286c932$export$4c4520429be8c63 = {};
const $b28f7e6af286c932$export$46faf4f3596622ce = {};
const $b28f7e6af286c932$export$37ca4dbc437f02a0 = {};
const $b28f7e6af286c932$export$fd5a4937bec0d3f9 = {};
const $b28f7e6af286c932$var$fill = (target, next)=>{
    for (const k of Object.keys(target))delete target[k];
    Object.assign(target, next);
};
const $b28f7e6af286c932$var$rampOf = (r)=>$b28f7e6af286c932$var$material(...r);
const $b28f7e6af286c932$var$tonesOf = (group)=>Object.fromEntries(Object.entries(group?.tones ?? {}).map(([name, r])=>[
            name,
            $b28f7e6af286c932$var$rampOf(r)
        ]));
let $b28f7e6af286c932$var$bound;
let $b28f7e6af286c932$var$previewTones;
const $b28f7e6af286c932$export$c24818d4030bc04d = (file)=>{
    $b28f7e6af286c932$var$bound = file;
    $b28f7e6af286c932$var$applyPalettes();
    (0, $121d74fbc26f823b$export$35d5ab3d09c2908f)("palettes", file);
};
const $b28f7e6af286c932$export$39b5c3954c10cc38 = (tones)=>{
    $b28f7e6af286c932$var$previewTones = tones && Object.keys(tones).length ? tones : undefined;
    $b28f7e6af286c932$var$applyPalettes();
    (0, $121d74fbc26f823b$export$35d5ab3d09c2908f)("skin-preview", $b28f7e6af286c932$var$previewTones);
};
const $b28f7e6af286c932$var$applyPalettes = ()=>{
    const file = $b28f7e6af286c932$var$bound;
    const groups = Object.fromEntries(Object.entries(file?.ramps ?? {}).map(([name, group])=>[
            name,
            $b28f7e6af286c932$var$tonesOf(group)
        ]));
    for (const name of Object.keys($b28f7e6af286c932$export$c6254af65262af78))if (!file?.skins?.[name] && name !== "lpc" && name !== "painted") delete $b28f7e6af286c932$export$c6254af65262af78[name];
    for (const [name, list] of Object.entries(file?.skins ?? {}))$b28f7e6af286c932$var$fill($b28f7e6af286c932$export$c6254af65262af78[name] ??= {}, Object.assign({}, ...list.map((group)=>groups[group] ?? {})));
    for (const name of [
        "lpc",
        "painted"
    ])if (!file?.skins?.[name]) $b28f7e6af286c932$var$fill($b28f7e6af286c932$export$c6254af65262af78[name], {});
    $b28f7e6af286c932$var$fill($b28f7e6af286c932$export$46faf4f3596622ce, groups.bones ?? {});
    $b28f7e6af286c932$var$fill($b28f7e6af286c932$export$4c4520429be8c63, Object.fromEntries(Object.entries(file?.eye?.colors ?? {}).map(([name, c])=>[
            name,
            $b28f7e6af286c932$var$hex(c)
        ])));
    $b28f7e6af286c932$var$fill($b28f7e6af286c932$export$37ca4dbc437f02a0, {
        ...file?.dyes?.colors ?? {}
    });
    $b28f7e6af286c932$var$fill($b28f7e6af286c932$export$fd5a4937bec0d3f9, {
        ...file?.hair?.colors ?? {}
    });
    if ($b28f7e6af286c932$var$previewTones) for (const set of Object.values($b28f7e6af286c932$export$c6254af65262af78))for (const [name, r] of Object.entries($b28f7e6af286c932$var$previewTones))set[name] = $b28f7e6af286c932$var$rampOf(r);
};
const $b28f7e6af286c932$export$c8908195c93d6ce6 = (base)=>{
    const m = $b28f7e6af286c932$export$8045a65082865858(base);
    return [
        m.light,
        m.base,
        m.shade,
        m.deep,
        m.line,
        m.outline
    ].map((c)=>`#${c.toString(16).padStart(6, "0")}`);
};
const $b28f7e6af286c932$var$rgb = (c)=>[
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
const $b28f7e6af286c932$var$pack = ([r, g, b])=>Math.round(Math.max(0, Math.min(255, r))) << 16 | Math.round(Math.max(0, Math.min(255, g))) << 8 | Math.round(Math.max(0, Math.min(255, b)));
const $b28f7e6af286c932$var$toHsl = (c)=>{
    const [r, g, b] = $b28f7e6af286c932$var$rgb(c).map((v)=>v / 255);
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    const l = (max + min) / 2;
    if (max === min) return [
        0,
        0,
        l
    ];
    const d = max - min;
    const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    let h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
    return [
        h * 60,
        s,
        l
    ];
};
const $b28f7e6af286c932$var$fromHsl = (h, s, l)=>{
    const hue = (h % 360 + 360) % 360;
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(hue / 60 % 2 - 1));
    const m = l - c / 2;
    const [r, g, b] = hue < 60 ? [
        c,
        x,
        0
    ] : hue < 120 ? [
        x,
        c,
        0
    ] : hue < 180 ? [
        0,
        c,
        x
    ] : hue < 240 ? [
        0,
        x,
        c
    ] : hue < 300 ? [
        x,
        0,
        c
    ] : [
        c,
        0,
        x
    ];
    return $b28f7e6af286c932$var$pack([
        (r + m) * 255,
        (g + m) * 255,
        (b + m) * 255
    ]);
};
const $b28f7e6af286c932$export$8045a65082865858 = (base, outline = "#281820")=>{
    const [h, s, l] = $b28f7e6af286c932$var$toHsl(typeof base === "string" ? $b28f7e6af286c932$var$hex(base) : base);
    const toward = (target, amount)=>{
        let d = target - h;
        if (d > 180) d -= 360;
        if (d < -180) d += 360;
        return h + d * amount;
    };
    return {
        light: $b28f7e6af286c932$var$fromHsl(toward(55, 0.15), Math.min(1, s * 0.95), Math.min(0.93, l + 0.13)),
        base: $b28f7e6af286c932$var$fromHsl(h, s, l),
        shade: $b28f7e6af286c932$var$fromHsl(toward(265, 0.12), Math.min(1, s * 1.02), Math.max(0.05, l - 0.12)),
        deep: $b28f7e6af286c932$var$fromHsl(toward(265, 0.22), Math.min(1, s * 1.05), Math.max(0.04, l - 0.22)),
        line: $b28f7e6af286c932$var$fromHsl(toward(265, 0.3), Math.min(1, s * 0.9), Math.max(0.03, l - 0.32)),
        outline: $b28f7e6af286c932$var$hex(outline)
    };
};
const $b28f7e6af286c932$export$6e1a69eadfd1804f = (base, outline = "#281820")=>{
    const [h, s, l] = $b28f7e6af286c932$var$toHsl($b28f7e6af286c932$var$hex(base));
    return {
        light: $b28f7e6af286c932$var$fromHsl(h, s * 0.6, Math.min(0.94, l + 0.27)),
        base: $b28f7e6af286c932$var$fromHsl(h, s, l),
        shade: $b28f7e6af286c932$var$fromHsl(h, Math.min(1, s * 1.05), Math.max(0.05, l - 0.17)),
        deep: $b28f7e6af286c932$var$fromHsl(h, Math.min(1, s * 1.1), Math.max(0.04, l - 0.31)),
        line: $b28f7e6af286c932$var$fromHsl(h, Math.min(1, s * 1.1), Math.max(0.03, l - 0.4)),
        outline: $b28f7e6af286c932$var$hex(outline)
    };
};
const $b28f7e6af286c932$export$babb80d09f1c288 = (name)=>$b28f7e6af286c932$export$8045a65082865858($b28f7e6af286c932$export$37ca4dbc437f02a0[name] ?? $b28f7e6af286c932$export$37ca4dbc437f02a0.gray);
const $b28f7e6af286c932$export$6bd841329da7a610 = (name)=>$b28f7e6af286c932$export$8045a65082865858($b28f7e6af286c932$export$fd5a4937bec0d3f9[name] ?? $b28f7e6af286c932$export$fd5a4937bec0d3f9.brown);
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>catalog.source.emberPalettes, $b28f7e6af286c932$export$c24818d4030bc04d);



/**
 * Turns Ember primitives into one pixel-art frame.
 *
 * An orthographic camera pitched down by `pitch` looks at the body; each pixel's ray keeps the
 * nearest surface. Shading is banded into the material's ramp from one fixed light (upper left,
 * like the LPC art), the silhouette gets the material's outline and a surface that stands in front
 * of another gets a crease line. No antialiasing: every pixel is a palette colour or transparent.
 *
 * Frame space matches LPC: a 64px cell, the body centred on x = 32 with its soles on row 61, so an
 * Ember frame drops into the same placement, shadow and ground-anchor code.
 */ /** Small 3D vector and rotation helpers for the Ember sprite generator. Plain tuples, no classes. */ const $0a4786a5aadc3b7f$export$815b03eba529a08e = (x, y, z)=>[
        x,
        y,
        z
    ];
const $0a4786a5aadc3b7f$export$e16d8520af44a096 = (a, b)=>[
        a[0] + b[0],
        a[1] + b[1],
        a[2] + b[2]
    ];
const $0a4786a5aadc3b7f$export$f93b5905241a7cca = (a, b)=>[
        a[0] - b[0],
        a[1] - b[1],
        a[2] - b[2]
    ];
const $0a4786a5aadc3b7f$export$dcdf75081b88279d = (a, s)=>[
        a[0] * s,
        a[1] * s,
        a[2] * s
    ];
const $0a4786a5aadc3b7f$export$94132a0e348806d4 = (a, b)=>a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
const $0a4786a5aadc3b7f$export$bb646b20bb93d339 = (a, b)=>[
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
const $0a4786a5aadc3b7f$export$f24224f1c91d8156 = (a)=>Math.sqrt($0a4786a5aadc3b7f$export$94132a0e348806d4(a, a));
const $0a4786a5aadc3b7f$export$a3295358bff77e = (a)=>{
    const l = $0a4786a5aadc3b7f$export$f24224f1c91d8156(a);
    return l > 1e-9 ? $0a4786a5aadc3b7f$export$dcdf75081b88279d(a, 1 / l) : [
        0,
        0,
        0
    ];
};
const $0a4786a5aadc3b7f$export$3a89f8d6f6bf6c9f = (a, b, t)=>[
        a[0] + (b[0] - a[0]) * t,
        a[1] + (b[1] - a[1]) * t,
        a[2] + (b[2] - a[2]) * t
    ];
const $0a4786a5aadc3b7f$export$9f17032d917177de = (a, b)=>$0a4786a5aadc3b7f$export$f24224f1c91d8156($0a4786a5aadc3b7f$export$f93b5905241a7cca(a, b));
const $0a4786a5aadc3b7f$export$76c0f2b8ecfc3d8a = [
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1
];
const $0a4786a5aadc3b7f$export$6e3a27864ab166fe = (a, b)=>{
    const r = new Array(9);
    for(let i = 0; i < 3; i++)for(let j = 0; j < 3; j++)r[i * 3 + j] = a[i * 3] * b[j] + a[i * 3 + 1] * b[3 + j] + a[i * 3 + 2] * b[6 + j];
    return r;
};
const $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c = (m, v)=>[
        m[0] * v[0] + m[1] * v[1] + m[2] * v[2],
        m[3] * v[0] + m[4] * v[1] + m[5] * v[2],
        m[6] * v[0] + m[7] * v[1] + m[8] * v[2]
    ];
const $0a4786a5aadc3b7f$export$9cb09a71b7d66923 = (m)=>[
        m[0],
        m[3],
        m[6],
        m[1],
        m[4],
        m[7],
        m[2],
        m[5],
        m[8]
    ];
const $0a4786a5aadc3b7f$export$fa9f800d0752b887 = (a)=>{
    const c = Math.cos(a), s = Math.sin(a);
    return [
        1,
        0,
        0,
        0,
        c,
        -s,
        0,
        s,
        c
    ];
};
const $0a4786a5aadc3b7f$export$d4dbf6597d59367 = (a)=>{
    const c = Math.cos(a), s = Math.sin(a);
    return [
        c,
        0,
        s,
        0,
        1,
        0,
        -s,
        0,
        c
    ];
};
const $0a4786a5aadc3b7f$export$305a59a98cabc9c5 = (a)=>{
    const c = Math.cos(a), s = Math.sin(a);
    return [
        c,
        -s,
        0,
        s,
        c,
        0,
        0,
        0,
        1
    ];
};
const $0a4786a5aadc3b7f$export$53b3c91859018cd4 = (m)=>[
        [
            m[0],
            m[3],
            m[6]
        ],
        [
            m[1],
            m[4],
            m[7]
        ],
        [
            m[2],
            m[5],
            m[8]
        ]
    ];
const $0a4786a5aadc3b7f$export$61ddd819c68acdd = (d)=>d * Math.PI / 180;
const $0a4786a5aadc3b7f$export$4053e36566dd3d9a = (t)=>{
    const x = Math.max(0, Math.min(1, t));
    return x * x * (3 - 2 * x);
};
const $0a4786a5aadc3b7f$export$b0f87bb1f6530fd8 = (t)=>(1 - Math.cos(Math.PI * Math.max(0, Math.min(1, t)))) / 2;


const $bc9c62e5e9c273fc$export$3088316d51d20bbf = [
    "front",
    "back",
    "left",
    "right",
    "frontleft",
    "frontright",
    "backleft",
    "backright"
];
/** Clockwise screen directions, starting at east. Kept separate from LPC's four sheet rows. */ const $bc9c62e5e9c273fc$var$SCREEN_FACINGS = [
    "right",
    "frontright",
    "front",
    "frontleft",
    "left",
    "backleft",
    "back",
    "backright"
];
const $bc9c62e5e9c273fc$export$63b89cef1abbc46e = (angle)=>{
    const sector = Math.round(angle / (Math.PI / 4));
    return $bc9c62e5e9c273fc$var$SCREEN_FACINGS[(sector % 8 + 8) % 8];
};
const $bc9c62e5e9c273fc$export$e32225fb3fb28f1e = (facing)=>facing.startsWith("back");
const $bc9c62e5e9c273fc$export$77baadf38c8fbaf0 = 35 * Math.PI / 180;
const $bc9c62e5e9c273fc$export$3012b1de2ca8cf4e = {
    x: -1,
    y: 0
};
const $bc9c62e5e9c273fc$export$d5e55da86199c818 = 25 * Math.PI / 180;
const $bc9c62e5e9c273fc$export$376317e739a8c334 = {
    front: 0,
    frontright: Math.PI / 4,
    frontleft: -Math.PI / 4,
    backright: 3 * Math.PI / 4,
    backleft: -3 * Math.PI / 4,
    right: Math.PI / 2 - $bc9c62e5e9c273fc$export$77baadf38c8fbaf0,
    back: Math.PI,
    left: -(Math.PI / 2 - $bc9c62e5e9c273fc$export$77baadf38c8fbaf0)
};
const $bc9c62e5e9c273fc$export$32e028fba1489aa1 = {
    front: 1,
    // At 45 degrees both the projected step and screen travel have a sqrt(1/2) x component.
    frontright: 1,
    frontleft: 1,
    backright: 1,
    backleft: 1,
    back: 1,
    left: Math.cos($bc9c62e5e9c273fc$export$77baadf38c8fbaf0),
    right: Math.cos($bc9c62e5e9c273fc$export$77baadf38c8fbaf0)
};
const $bc9c62e5e9c273fc$export$4f0dcedf9ab333ca = (prim)=>prim.group === "head" || prim.group === "hair" ? "head" : prim.group === "torso" || prim.group === "bust" || prim.group === "shoulder" || prim.group === "skirt" || prim.group === "tail" ? "torso" : prim.part === "hand" || prim.group === "held" ? "hand" : prim.part === "foot" ? "foot" : prim.group === "armL" || prim.group === "armR" ? "arm" : "leg";
const $bc9c62e5e9c273fc$export$5f22db6dc00b1799 = {
    width: 64,
    height: 64,
    centerX: 32,
    // The row under the soles: the LPC body's soles are drawn on row 61.
    groundY: 61,
    // Nearly straight on, as LPC draws characters. A steeper camera shows the top of the head at the
    // cost of the face, and draws anything further from it higher: the far foot of a side-on body
    // lifts off the ground line and reads as hooked.
    pitch: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
    light: (0, $0a4786a5aadc3b7f$export$a3295358bff77e)([
        -0.55,
        0.75,
        0.5
    ]),
    // How far a part must stand in front of one it flows into (hips into thighs, chin over neck)
    // before that seam gets a line (see boundaryBetween; limbs are outlined regardless).
    creaseDepth: 1.2,
    // Light, base, shade, deep per part, measured off the LPC male body through Ember's parts in the
    // aligned standing pose (tools ember-partmix): a head is mostly base, legs mostly shade.
    shading: {
        light: 0.75,
        facing: 0.4,
        rim: 0.65,
        mix: {
            head: [
                0.05,
                0.68,
                0.2,
                0.07
            ],
            torso: [
                0.09,
                0.45,
                0.34,
                0.12
            ],
            arm: [
                0.1,
                0.38,
                0.31,
                0.21
            ],
            hand: [
                0.06,
                0.65,
                0.14,
                0.15
            ],
            leg: [
                0,
                0.27,
                0.46,
                0.27
            ],
            foot: [
                0.12,
                0.5,
                0.24,
                0.14
            ]
        }
    }
};
const $bc9c62e5e9c273fc$export$d15de0cfe42daab7 = (prims, facing)=>{
    const yaw = (0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)($bc9c62e5e9c273fc$export$376317e739a8c334[facing]);
    return prims.map((prim)=>prim.kind === "capsule" ? {
            ...prim,
            a: (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(yaw, prim.a),
            b: (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(yaw, prim.b)
        } : {
            ...prim,
            center: (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(yaw, prim.center),
            basis: (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(yaw, prim.basis)
        });
};
/**
 * The ramp step lighting picks: 0 light, 1 base, 2 shade, 3 deep. Flat on purpose: most of a body
 * is BASE, shade only where it turns from the light, a highlight only where it faces it squarely.
 * More steps follow every curve of the volumes underneath and the body melts; LPC paints a few
 * confident shapes instead.
 */ const $bc9c62e5e9c273fc$var$bandIndex = (light)=>light > 0.9 ? 0 : light > -0.12 ? 1 : light > -0.6 ? 2 : 3;
const $bc9c62e5e9c273fc$var$rampStep = (m, step)=>[
        m.light,
        m.base,
        m.shade,
        m.deep
    ][Math.min(3, step)];
const $bc9c62e5e9c273fc$var$isArm = (g)=>g === "armL" || g === "armR" || g === "held";
// A humanoid's legL and legR, and a species' legs (legFL, legHR...).
const $bc9c62e5e9c273fc$var$isLeg = (g)=>g.startsWith("leg");
/**
 * What LPC draws where one part of the body meets another, on the side of the part in front (`dz`,
 * this pixel's depth over its neighbour's, is positive). Limbs are outlined as shapes of their own:
 * an arm against the body, one leg against the other, hair against whatever it lies over. Parts
 * that flow into each other are not -- hips into thighs, the chin over the neck -- unless one
 * stands well in front, which gets the softer line colour. The shoulder bridges arm and chest and
 * is never outlined against either.
 */ const $bc9c62e5e9c273fc$var$boundaryBetween = (here, there, dz, deep)=>{
    if (here === there) return undefined;
    // The part in front takes the line. Two at the same depth -- thighs pressed together, front-on
    // and mirror-symmetric -- would each leave it to the other, so the first by name takes it.
    if (Math.abs(dz) < 1e-6 ? here > there : dz < 0) return undefined;
    if (here === "shoulder" || there === "shoulder") return undefined;
    // Hair, and a tail, are shapes of their own against whatever they lie over.
    if (here === "hair" || here === "tail") return "outline";
    if ($bc9c62e5e9c273fc$var$isArm(here) && (there === "torso" || there === "bust" || $bc9c62e5e9c273fc$var$isLeg(there) || $bc9c62e5e9c273fc$var$isArm(there))) return "outline";
    if ($bc9c62e5e9c273fc$var$isLeg(here) && $bc9c62e5e9c273fc$var$isLeg(there)) return "outline";
    // A skirt's hem over the legs it hangs round, and a knee pushed out in front of it.
    if (here === "skirt" && $bc9c62e5e9c273fc$var$isLeg(there) || $bc9c62e5e9c273fc$var$isLeg(here) && there === "skirt") return "outline";
    // Thighs into the pelvis: no seam at all. Traced, it runs hip to hip like a waistband; LPC marks
    // only the groin, with two short strokes (marks.ts).
    if ($bc9c62e5e9c273fc$var$isLeg(here) && there === "torso" || here === "torso" && $bc9c62e5e9c273fc$var$isLeg(there)) return undefined;
    return dz > deep ? "line" : undefined;
};
const $bc9c62e5e9c273fc$export$bcbbffdf78e2f935 = (pitch)=>({
        right: [
            1,
            0,
            0
        ],
        up: [
            0,
            Math.cos(pitch),
            -Math.sin(pitch)
        ],
        back: [
            0,
            Math.sin(pitch),
            Math.cos(pitch)
        ]
    });
const $bc9c62e5e9c273fc$export$98de20a72d8f134f = (p, o = $bc9c62e5e9c273fc$export$5f22db6dc00b1799)=>{
    const { right: right, up: up } = $bc9c62e5e9c273fc$export$bcbbffdf78e2f935(o.pitch);
    return {
        x: o.centerX + (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(p, right),
        y: o.groundY - (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(p, up)
    };
};
const $bc9c62e5e9c273fc$var$EPS = 1e-9;
// Primitives are moved into camera space -- x right, y up the screen, z toward the viewer -- where
// every pixel's ray is simply the line (u, v, z). The camera is orthographic, so everything that
// does not depend on the pixel is worked out once per primitive rather than per pixel.
const $bc9c62e5e9c273fc$var$prepareCapsule = (prim, cam, light)=>{
    const [ax, ay, az] = cam(prim.a);
    const [bx, by, bz] = cam(prim.b);
    const r = prim.r;
    const r2 = r * r;
    const bax = bx - ax, bay = by - ay, baz = bz - az;
    const baba = bax * bax + bay * bay + baz * baz;
    // Along the ray (0, 0, -1): the cylinder's quadratic has a constant leading term.
    const k = baba - baz * baz;
    const sphereZ = (cx, cy, cz, u, v)=>{
        const dx = u - cx, dy = v - cy;
        const h = r2 - dx * dx - dy * dy;
        return h > 0 ? cz + Math.sqrt(h) : NaN;
    };
    const hit = (u, v)=>{
        const ox = u - ax, oy = v - ay;
        let best = NaN;
        if (k > $bc9c62e5e9c273fc$var$EPS) {
            // Points (u, v, z): distance to the axis line is r. Solve for the larger z.
            // With w = z - az: |o + w e_z|^2 - ((o + w e_z)·ba)^2 / baba = r^2.
            const oba = ox * bax + oy * bay;
            const qa = 1 - baz * baz / baba;
            const qb = -(oba * baz) / baba;
            const qc = ox * ox + oy * oy - oba * oba / baba - r2;
            const h = qb * qb - qa * qc;
            if (h >= 0) {
                const w = (-qb + Math.sqrt(h)) / qa;
                const along = oba + w * baz;
                if (along > 0 && along < baba) best = az + w;
            }
        }
        if (best !== best) {
            const za = sphereZ(ax, ay, az, u, v);
            const zb = sphereZ(bx, by, bz, u, v);
            best = za !== za ? zb : zb !== zb ? za : Math.max(za, zb);
        }
        return best;
    };
    const shade = (u, v, z)=>{
        const px = u - ax, py = v - ay, pz = z - az;
        const t = baba > $bc9c62e5e9c273fc$var$EPS ? Math.max(0, Math.min(1, (px * bax + py * bay + pz * baz) / baba)) : 0;
        const nx = px - bax * t, ny = py - bay * t, nz = pz - baz * t;
        const l = Math.sqrt(nx * nx + ny * ny + nz * nz) || 1;
        return {
            light: (nx * light[0] + ny * light[1] + nz * light[2]) / l,
            facing: nz / l
        };
    };
    const reach = Math.sqrt(baba) / 2 + r;
    const cx = (ax + bx) / 2, cy = (ay + by) / 2;
    return {
        hit: hit,
        shade: shade,
        cx: cx,
        cy: cy,
        reach: reach
    };
};
const $bc9c62e5e9c273fc$var$prepareEllipsoid = (prim, cam, light)=>{
    const ex = prim.exponent;
    if (ex !== undefined && (typeof ex === "number" ? ex !== 2 : ex.some((e)=>e !== 2))) return $bc9c62e5e9c273fc$var$prepareRoundedBox(prim, cam, light);
    const [cx, cy, cz] = cam(prim.center);
    // The ellipsoid's axes in camera space, each divided by its radius squared for the quadratic.
    const axes = (0, $0a4786a5aadc3b7f$export$53b3c91859018cd4)(prim.basis).map(cam);
    const [r0, r1, r2] = prim.radii;
    const inv = [
        1 / (r0 * r0),
        1 / (r1 * r1),
        1 / (r2 * r2)
    ];
    const A = axes.reduce((sum, e, i)=>sum + e[2] * e[2] * inv[i], 0);
    let lastQ = [
        0,
        0,
        0
    ];
    let lastSign = 1;
    const local = (du, dv, w)=>[
            du * axes[0][0] + dv * axes[0][1] + w * axes[0][2],
            du * axes[1][0] + dv * axes[1][1] + w * axes[1][2],
            du * axes[2][0] + dv * axes[2][1] + w * axes[2][2]
        ];
    const hit = (u, v)=>{
        const du = u - cx, dv = v - cy;
        const a0 = du * axes[0][0] + dv * axes[0][1];
        const a1 = du * axes[1][0] + dv * axes[1][1];
        const a2 = du * axes[2][0] + dv * axes[2][1];
        const B = a0 * axes[0][2] * inv[0] + a1 * axes[1][2] * inv[1] + a2 * axes[2][2] * inv[2];
        const C = a0 * a0 * inv[0] + a1 * a1 * inv[1] + a2 * a2 * inv[2] - 1;
        const h = B * B - A * C;
        if (h < 0) return NaN;
        const root = Math.sqrt(h);
        // The outside of the shell first; if a clip removes it, the inside may still face the camera.
        for (const sign of [
            1,
            -1
        ]){
            const w = (-B + sign * root) / A;
            const q = local(du, dv, w);
            if (prim.keep && !prim.keep(q)) continue;
            lastQ = q;
            lastSign = sign;
            return cz + w;
        }
        return NaN;
    };
    const shade = (_u, _v, _z)=>{
        const q = lastQ;
        let nx = 0, ny = 0, nz = 0;
        for(let i = 0; i < 3; i++){
            const s = q[i] * inv[i];
            nx += axes[i][0] * s;
            ny += axes[i][1] * s;
            nz += axes[i][2] * s;
        }
        const l = (Math.sqrt(nx * nx + ny * ny + nz * nz) || 1) * lastSign;
        return {
            light: (nx * light[0] + ny * light[1] + nz * light[2]) / l,
            facing: nz / l,
            decal: prim.decal?.(q)
        };
    };
    return {
        hit: hit,
        shade: shade,
        cx: cx,
        cy: cy,
        reach: Math.max(r0, r1, r2)
    };
};
/**
 * A superellipsoid: no closed-form ray hit, but along any ray |x/a|^e + ... - 1 is a sum of convex
 * functions, so Newton's method from outside the shape walks monotonically onto the first surface
 * the ray meets (and from beyond it, onto the last) without overshooting. A handful of steps.
 */ const $bc9c62e5e9c273fc$var$prepareRoundedBox = (prim, cam, light)=>{
    const [cx, cy, cz] = cam(prim.center);
    const axes = (0, $0a4786a5aadc3b7f$export$53b3c91859018cd4)(prim.basis).map(cam);
    const r = prim.radii;
    // One squareness per local axis: |x/a|^ex + |y/b|^ey + |z/c|^ez = 1, still convex for each >= 2.
    const ex = prim.exponent;
    const e = typeof ex === "number" ? [
        ex,
        ex,
        ex
    ] : ex;
    // The shape lies inside its box, and the box inside this sphere.
    const R = Math.sqrt(r[0] * r[0] + r[1] * r[1] + r[2] * r[2]);
    const B = [
        0,
        1,
        2
    ].map((i)=>-axes[i][2] / r[i]);
    const A = [
        0,
        0,
        0
    ];
    let lastQ = [
        0,
        0,
        0
    ];
    let lastSign = 1;
    // Value and slope of the implicit function along the ray, at parameter t.
    const g = (t)=>{
        let value = -1, slope = 0;
        for(let i = 0; i < 3; i++){
            const q = A[i] + t * B[i];
            const m = Math.abs(q);
            const p1 = Math.pow(m, e[i] - 1);
            value += p1 * m;
            slope += e[i] * p1 * (q < 0 ? -B[i] : B[i]);
        }
        return [
            value,
            slope
        ];
    };
    const solve = (t, forward)=>{
        for(let k = 0; k < 16; k++){
            const [value, slope] = g(t);
            if (value < 1e-3) return t;
            // Moving away from the shape (or level): this ray misses it.
            if (forward ? slope >= 0 : slope <= 0) return NaN;
            t -= value / slope;
            if (t < 0 || t > 2 * R) return NaN;
        }
        return t;
    };
    // In scaled coordinates the shape lies inside a ball of this radius (its corners are the
    // farthest points), so a ray that misses the ball misses the shape -- and one that meets it can
    // start Newton at the ball rather than far out, a few steps from the surface.
    const ball = Math.pow(3, 0.5 - 1 / Math.max(e[0], e[1], e[2]));
    const BB = B[0] * B[0] + B[1] * B[1] + B[2] * B[2];
    const at = (t)=>[
            (A[0] + t * B[0]) * r[0],
            (A[1] + t * B[1]) * r[1],
            (A[2] + t * B[2]) * r[2]
        ];
    const hit = (u, v)=>{
        const du = u - cx, dv = v - cy;
        for(let i = 0; i < 3; i++)A[i] = (du * axes[i][0] + dv * axes[i][1] + R * axes[i][2]) / r[i];
        const AB = A[0] * B[0] + A[1] * B[1] + A[2] * B[2];
        const AA = A[0] * A[0] + A[1] * A[1] + A[2] * A[2];
        const h = AB * AB - BB * (AA - ball * ball);
        if (h < 0) return NaN;
        const root = Math.sqrt(h);
        const entry = solve(Math.max(0, (-AB - root) / BB), true);
        if (entry !== entry) return NaN;
        let q = at(entry);
        if (!prim.keep || prim.keep(q)) {
            lastQ = q;
            lastSign = 1;
            return cz + R - entry;
        }
        // Clipped away in front: the inside of the far wall may still face the camera.
        const exit = solve(Math.min(2 * R, (-AB + root) / BB), false);
        if (exit !== exit) return NaN;
        q = at(exit);
        if (!prim.keep(q)) return NaN;
        lastQ = q;
        lastSign = -1;
        return cz + R - exit;
    };
    const shade = (_u, _v, _z)=>{
        const q = lastQ;
        let nx = 0, ny = 0, nz = 0;
        for(let i = 0; i < 3; i++){
            const s = Math.sign(q[i]) * Math.pow(Math.abs(q[i]) / r[i], e[i] - 1) / r[i];
            nx += axes[i][0] * s;
            ny += axes[i][1] * s;
            nz += axes[i][2] * s;
        }
        const l = (Math.sqrt(nx * nx + ny * ny + nz * nz) || 1) * lastSign;
        return {
            light: (nx * light[0] + ny * light[1] + nz * light[2]) / l,
            facing: nz / l,
            decal: prim.decal?.(q)
        };
    };
    return {
        hit: hit,
        shade: shade,
        cx: cx,
        cy: cy,
        reach: R
    };
};
const $bc9c62e5e9c273fc$export$d705dada763d21f4 = (prims, o = $bc9c62e5e9c273fc$export$5f22db6dc00b1799, stamps = [])=>{
    const { width: W, height: H } = o;
    const { right: right, up: up, back: back } = $bc9c62e5e9c273fc$export$bcbbffdf78e2f935(o.pitch);
    const cam = (p)=>[
            (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(p, right),
            (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(p, up),
            (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(p, back)
        ];
    const light = cam(o.light);
    const depth = new Float32Array(W * H).fill(-Infinity);
    const owner = new Int16Array(W * H).fill(-1);
    const lightAt = new Float32Array(W * H);
    const facingAt = new Float32Array(W * H);
    const decal = new Int32Array(W * H).fill(-1);
    prims.forEach((prim, index)=>{
        const prepared = prim.kind === "capsule" ? $bc9c62e5e9c273fc$var$prepareCapsule(prim, cam, light) : $bc9c62e5e9c273fc$var$prepareEllipsoid(prim, cam, light);
        const sx = o.centerX + prepared.cx;
        const sy = o.groundY - prepared.cy;
        const x0 = Math.max(0, Math.floor(sx - prepared.reach - 1));
        const x1 = Math.min(W - 1, Math.ceil(sx + prepared.reach + 1));
        const y0 = Math.max(0, Math.floor(sy - prepared.reach - 1));
        const y1 = Math.min(H - 1, Math.ceil(sy + prepared.reach + 1));
        for(let py = y0; py <= y1; py++){
            const v = o.groundY - (py + 0.5);
            for(let px = x0; px <= x1; px++){
                const u = px + 0.5 - o.centerX;
                const z = prepared.hit(u, v);
                if (z !== z) continue;
                const i = py * W + px;
                if (z <= depth[i]) continue;
                depth[i] = z;
                owner[i] = index;
                const shaded = prepared.shade(u, v, z);
                lightAt[i] = shaded.light;
                facingAt[i] = shaded.facing;
                decal[i] = shaded.decal ?? -1;
            }
        }
    });
    const pixels = new Uint8ClampedArray(W * H * 4);
    const covered = (x, y)=>x >= 0 && y >= 0 && x < W && y < H && owner[y * W + x] >= 0;
    // Spurs: a pixel joined to the body on one side only is the corner of a round volume just
    // reaching into the next row or column. A pixel artist would never leave one; neither do we.
    for(let pass = 0; pass < 2; pass++){
        for(let y = 0; y < H; y++)for(let x = 0; x < W; x++){
            if (!covered(x, y)) continue;
            const joined = (covered(x - 1, y) ? 1 : 0) + (covered(x + 1, y) ? 1 : 0) + (covered(x, y - 1) ? 1 : 0) + (covered(x, y + 1) ? 1 : 0);
            // A held thing's string or shaft is a deliberate one-pixel line, often diagonal: kept.
            if (joined <= 1 && prims[owner[y * W + x]].group !== "held") owner[y * W + x] = -1;
        }
    }
    // Slivers: a part showing one pixel wide at the silhouette, past the part in front of it (a far
    // arm just clearing the chest), would be drawn as its own outline beside that part's line -- a
    // doubled contour. LPC draws the near part's single outline there, so the pixel joins it.
    for(let y = 0; y < H; y++)for(let x = 1; x < W - 1; x++){
        const i = y * W + x;
        if (owner[i] < 0) continue;
        const [l, r] = [
            owner[i - 1],
            owner[i + 1]
        ];
        const other = l < 0 && r >= 0 ? r : r < 0 && l >= 0 ? l : -1;
        if (other >= 0 && prims[other].group !== prims[owner[i]].group) owner[i] = other;
    }
    // The silhouette: covered pixels with an empty 4-neighbour. They take the outline colour.
    const edge = new Uint8Array(W * H);
    for(let y = 0; y < H; y++){
        for(let x = 0; x < W; x++)if (covered(x, y) && (!covered(x - 1, y) || !covered(x + 1, y) || !covered(x, y - 1) || !covered(x, y + 1))) edge[y * W + x] = 1;
    }
    const nextToEdge = (x, y)=>edge[y * W + x - 1] === 1 || edge[y * W + x + 1] === 1 || edge[(y - 1) * W + x] === 1 || edge[(y + 1) * W + x] === 1;
    const nearEdge = (x, y)=>x >= 2 && edge[y * W + x - 2] === 1 || x < W - 2 && edge[y * W + x + 2] === 1 || y >= 2 && edge[(y - 2) * W + x] === 1 || y < H - 2 && edge[(y + 2) * W + x] === 1;
    const selective = o.outline === "selective";
    const soft = o.outline === "soft";
    // Whether an edge pixel's open side faces the light, on screen (y down).
    const litEdge = (x, y)=>{
        const ox = (covered(x - 1, y) ? 0 : -1) + (covered(x + 1, y) ? 0 : 1);
        const oy = (covered(x, y - 1) ? 0 : -1) + (covered(x, y + 1) ? 0 : 1);
        return ox * light[0] - oy * light[1] > 0;
    };
    const darkness = new Float32Array(W * H);
    // First the ramp step every shaded pixel takes (-1: a fixed colour -- outline, crease or decal).
    const step = new Int8Array(W * H).fill(-1);
    const fixed = new Int32Array(W * H);
    for(let y = 0; y < H; y++)for(let x = 0; x < W; x++){
        const i = y * W + x;
        if (owner[i] < 0) continue;
        const prim = prims[owner[i]];
        const m = prim.material;
        if (edge[i]) {
            fixed[i] = soft ? litEdge(x, y) ? m.shade : m.deep : selective && litEdge(x, y) ? m.line : m.outline;
            continue;
        }
        if (decal[i] >= 0) {
            fixed[i] = decal[i];
            continue;
        }
        // Where two parts meet, the one in front is outlined against the other, as LPC outlines
        // an arm against the chest or one leg against the other: a limb is drawn as its own
        // shape, not merged into whatever it touches. Well in front, it is the full outline;
        // barely in front, the softer line colour.
        let boundary;
        for (const [nx, ny] of [
            [
                x - 1,
                y
            ],
            [
                x + 1,
                y
            ],
            [
                x,
                y - 1
            ],
            [
                x,
                y + 1
            ]
        ]){
            const j = ny * W + nx;
            const other = prims[owner[j]];
            const b = $bc9c62e5e9c273fc$var$boundaryBetween(prim.group, other.group, depth[i] - depth[j], o.creaseDepth) ?? // A joint: two segments of one limb, lined only where one overlaps the other --
            // a partial stroke, as LPC marks a knee or an elbow, not a ring round the limb.
            (other.group === prim.group && prim.part && other.part && other.part !== prim.part && prim.part !== "foot" && depth[i] - depth[j] > (o.jointLine ?? 1.0) ? "line" : undefined);
            if (b === "outline" || b === "line" && !boundary) boundary = b;
        }
        if (boundary) {
            fixed[i] = soft ? m.deep : boundary === "outline" && !selective ? m.outline : m.line;
            continue;
        }
        // How dark LPC would paint this pixel: away from the light, turned from the viewer,
        // and near the outline -- LPC rims every volume, on both sides, not only the shadow side.
        darkness[i] = 1 - o.shading.light * (lightAt[i] + 1) / 2 - o.shading.facing * Math.max(0, facingAt[i]) + (nextToEdge(x, y) ? o.shading.rim : nearEdge(x, y) ? o.shading.rim / 2 : 0);
        step[i] = 1;
    }
    // Smoothed within each part, so the steps fall in clean regions rather than a speckle.
    const smooth = new Float32Array(W * H);
    for(let i = 0; i < W * H; i++){
        if (step[i] < 0) continue;
        const region = $bc9c62e5e9c273fc$export$4f0dcedf9ab333ca(prims[owner[i]]);
        let sum = 0, n = 0;
        for (const j of [
            i,
            i - 1,
            i + 1,
            i - W,
            i + W
        ])if (j >= 0 && j < W * H && step[j] >= 0 && $bc9c62e5e9c273fc$export$4f0dcedf9ab333ca(prims[owner[j]]) === region) {
            sum += darkness[j];
            n++;
        }
        smooth[i] = sum / n;
    }
    // Each part of each material is split into light/base/shade/deep in the proportions LPC paints
    // that part with, darkest pixels deepest: the mix matches the art by construction, any pose.
    const groups = new Map();
    const materialIds = new Map();
    for(let i = 0; i < W * H; i++){
        if (step[i] < 0) continue;
        const prim = prims[owner[i]];
        if (!materialIds.has(prim.material)) materialIds.set(prim.material, materialIds.size);
        const key = `${materialIds.get(prim.material)}:${$bc9c62e5e9c273fc$export$4f0dcedf9ab333ca(prim)}`;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(i);
    }
    const cuts = o.shading.thresholds;
    if (cuts) for(let i = 0; i < W * H; i++){
        if (step[i] < 0) continue;
        step[i] = smooth[i] < cuts[0] ? 0 : smooth[i] < cuts[1] ? 1 : smooth[i] < cuts[2] ? 2 : 3;
    }
    if (!cuts) groups.forEach((list, key)=>{
        const mix = o.shading.mix[key.split(":")[1]];
        list.sort((a, b)=>smooth[a] - smooth[b]);
        let k = 0;
        mix.forEach((share, band)=>{
            const end = band === mix.length - 1 ? list.length : k + Math.round(share * list.length);
            for(; k < end; k++)step[list[k]] = band;
        });
    });
    // A highlight is a shape, not a sprinkle: a lit pixel with fewer than two lit neighbours is the
    // noise of a bumpy surface catching the light, and LPC would not have painted it.
    for(let i = 0; i < W * H; i++){
        if (step[i] !== 0) continue;
        const lit = (step[i - 1] === 0 ? 1 : 0) + (step[i + 1] === 0 ? 1 : 0) + (step[i - W] === 0 ? 1 : 0) + (step[i + W] === 0 ? 1 : 0);
        if (lit < 2) step[i] = 1;
    }
    for(let i = 0; i < W * H; i++){
        if (owner[i] < 0) continue;
        const color = step[i] >= 0 ? $bc9c62e5e9c273fc$var$rampStep(prims[owner[i]].material, step[i]) : fixed[i];
        pixels[i * 4] = color >> 16 & 255;
        pixels[i * 4 + 1] = color >> 8 & 255;
        pixels[i * 4 + 2] = color & 255;
        pixels[i * 4 + 3] = 255;
    }
    for (const stamp of stamps)stamp.rows.forEach((row, dy)=>{
        for(let dx = 0; dx < row.length; dx++){
            const color = stamp.palette[row[dx]];
            const x = stamp.x + dx, y = stamp.y + dy;
            if (color === undefined || x < 0 || y < 0 || x >= W || y >= H) continue;
            const i = y * W + x;
            if (owner[i] < 0) continue;
            const group = prims[owner[i]].group;
            if (Array.isArray(stamp.group) ? !stamp.group.includes(group) : group !== stamp.group) continue;
            if (stamp.material && prims[owner[i]].material !== stamp.material) continue;
            // Never over an outline -- the silhouette's, or an arm's against the chest: a mark
            // drawn for LPC's limb would otherwise cut into Ember's where the two part by a pixel.
            if (edge[i] || step[i] < 0 && fixed[i] === prims[owner[i]].material.outline) continue;
            pixels[i * 4] = color >> 16 & 255;
            pixels[i * 4 + 1] = color >> 8 & 255;
            pixels[i * 4 + 2] = color & 255;
        }
    });
    return {
        width: W,
        height: H,
        pixels: pixels
    };
};


/**
 * The Ember reference skeleton: proportions, the pose a clip asks for, and the solver that turns
 * that pose into joint positions.
 *
 * Model space: y up, +z the way the body faces, +x the character's LEFT. The ground is y = 0 and
 * the pelvis stands over the origin. Units are world pixels; the camera (raster.ts) foreshortens
 * height by cos(pitch), so a standing body is drawn about 46px tall, the height of an LPC body.
 *
 * Every pose is solved here and nowhere else, so the shapes that are drawn (body.ts) and the
 * numbers the game reads off a frame (sockets, soles) can never disagree.
 */ 
const $16b5b2e1f0b8662b$export$e9495ff1e036db03 = {
    ankleHeight: 2.19,
    shin: 6.5,
    thigh: 6.9,
    hipWidth: 6.0,
    hipDrop: 1.11,
    spine: 7.6,
    neck: 5,
    headCenter: 8.57,
    shoulderWidth: 9.9,
    shoulderHeight: 0.93,
    upperArm: 6.49,
    forearm: 5.19,
    footLength: 4.3,
    head: [
        10.05,
        8.7,
        9.15
    ],
    craniumLift: 0.65,
    headRoundness: [
        2.6,
        2.6,
        2.3
    ],
    earHeight: -3.71,
    eyeHeight: -2.9,
    eyeSpacing: 4.0,
    profileEyeInset: 4.8,
    torso: [
        8.6,
        6.42,
        7.13
    ],
    torsoRoundness: [
        2.7,
        2.6,
        2.1
    ],
    girdle: {
        radii: [
            12,
            4.26,
            4.0
        ],
        drop: 3,
        cut: 0,
        exponent: 2.2
    },
    deltoidRadius: 3.5,
    pelvis: [
        7.8,
        5.4,
        7.3
    ],
    pelvisRoundness: [
        2.8,
        2.8,
        2.1
    ],
    posture: 0.5,
    neckRadius: 2.8,
    upperArmRadius: 3.9,
    forearmRadius: 3,
    handRadius: 3.5,
    handInset: 1.2,
    thighRadius: 3.7,
    shinRadius: 3.5,
    footRadius: 2.8,
    footWidth: 4.3,
    footProfileWidth: 3.0
};
const $16b5b2e1f0b8662b$export$eac172ae96bff3b0 = (p)=>p.thigh + p.shin;
const $16b5b2e1f0b8662b$export$739083ff10a3e078 = 125 * Math.PI / 180;
const $16b5b2e1f0b8662b$export$afa0f8e5c42b3f10 = 22 * Math.PI / 180;
const $16b5b2e1f0b8662b$export$7bcc7ebb13416507 = [
    "L",
    "R"
];
const $16b5b2e1f0b8662b$export$4afae6b5c61ab836 = (side)=>side === "L" ? 1 : -1;
const $16b5b2e1f0b8662b$var$DOWN = [
    0,
    -1,
    0
];
const $16b5b2e1f0b8662b$export$b6e2d34de6c0868f = 0.6;
const $16b5b2e1f0b8662b$export$ea6f8a19df35d702 = 1.0;
const $16b5b2e1f0b8662b$export$c8cb7c46eca76faa = (root, target, a, b, pole)=>{
    const toTarget = (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(target, root);
    const reach = Math.max(Math.abs(a - b) + 1e-3, Math.min(a + b - 1e-4, Math.sqrt((0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(toTarget, toTarget))));
    const dir = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(toTarget);
    const end = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(root, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(dir, reach));
    // Distance along the root->end line to the foot of the knee's perpendicular.
    const along = (a * a - b * b + reach * reach) / (2 * reach);
    const out = Math.sqrt(Math.max(0, a * a - along * along));
    // The part of the pole perpendicular to the leg's line is the way the knee points.
    let bend = (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(pole, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(dir, (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(pole, dir)));
    if ((0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(bend, bend) < 1e-8) bend = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$bb646b20bb93d339)(dir, [
        1,
        0,
        0
    ]));
    const mid = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(root, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(dir, along)), (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$a3295358bff77e)(bend), out));
    return {
        mid: mid,
        end: end
    };
};
/** The share of the chest's lean the head follows. */ const $16b5b2e1f0b8662b$var$HEAD_LEAN = 0.35;
const $16b5b2e1f0b8662b$export$8e00bc1a07512ac6 = (pose, p)=>{
    const root = pose.rootRotation;
    const torsoBasis = (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(root, (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)((0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)(pose.twist), (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)((0, $0a4786a5aadc3b7f$export$fa9f800d0752b887)(pose.lean), (0, $0a4786a5aadc3b7f$export$305a59a98cabc9c5)(pose.sideBend))));
    const pelvisBasis = (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(root, (0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)(-pose.twist * $16b5b2e1f0b8662b$export$b6e2d34de6c0868f));
    const headBasis = (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(root, (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)((0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)(pose.twist * 0.4 + pose.headYaw), (0, $0a4786a5aadc3b7f$export$fa9f800d0752b887)(pose.lean * $16b5b2e1f0b8662b$var$HEAD_LEAN + pose.headPitch)));
    const pelvis = pose.root;
    const chest = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(pelvis, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(torsoBasis, [
        0,
        p.spine,
        0
    ]));
    const neck = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(chest, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(torsoBasis, [
        0,
        p.neck,
        0
    ]));
    const head = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(neck, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(headBasis, [
        0,
        p.headCenter,
        0.4
    ]));
    // Knees point the way the pelvis faces.
    const forward = (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(pelvisBasis, [
        0,
        0,
        1
    ]);
    const limb = (side)=>{
        const s = $16b5b2e1f0b8662b$export$4afae6b5c61ab836(side);
        const arm = pose.arms[side];
        const armFrame = (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(torsoBasis, (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)((0, $0a4786a5aadc3b7f$export$305a59a98cabc9c5)(s * arm.abduct), (0, $0a4786a5aadc3b7f$export$fa9f800d0752b887)(-arm.pitch)));
        const shoulder = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(chest, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(torsoBasis, [
            s * p.shoulderWidth,
            p.shoulderHeight,
            0
        ]));
        let elbow, hand, grip, edge;
        if (arm.reach) {
            const pole = (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(torsoBasis, arm.pole ?? [
                0,
                0,
                -1
            ]);
            const solved = $16b5b2e1f0b8662b$export$c8cb7c46eca76faa(shoulder, (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(shoulder, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(torsoBasis, arm.reach)), p.upperArm, p.forearm, pole);
            elbow = solved.mid;
            hand = solved.end;
            grip = arm.grip ? (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(torsoBasis, arm.grip)) : (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(hand, elbow));
            // Away from the elbow's bend, square to the grip.
            const away = (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)((0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(pole, -1), (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(grip, (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(pole, grip) * -1));
            edge = (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(away, away) > 1e-8 ? (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(away) : (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$bb646b20bb93d339)(grip, [
                1,
                0,
                0
            ]));
        } else {
            elbow = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(shoulder, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(armFrame, $16b5b2e1f0b8662b$var$DOWN), p.upperArm));
            hand = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(elbow, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)((0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(armFrame, (0, $0a4786a5aadc3b7f$export$fa9f800d0752b887)(-arm.flex)), $16b5b2e1f0b8662b$var$DOWN), p.forearm));
            const gripFrame = (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(armFrame, (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)((0, $0a4786a5aadc3b7f$export$fa9f800d0752b887)(-(arm.flex + (arm.wrist ?? $16b5b2e1f0b8662b$export$739083ff10a3e078))), (0, $0a4786a5aadc3b7f$export$305a59a98cabc9c5)(s * (arm.out ?? $16b5b2e1f0b8662b$export$afa0f8e5c42b3f10))));
            grip = (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(gripFrame, $16b5b2e1f0b8662b$var$DOWN);
            edge = (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(gripFrame, [
                0,
                0,
                -1
            ]);
        }
        const hip = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(pelvis, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(pelvisBasis, [
            s * p.hipWidth,
            -p.hipDrop,
            0
        ]));
        const leg = pose.legs[side];
        let knee;
        let ankle;
        if (leg.mode === "ik") {
            const solved = $16b5b2e1f0b8662b$export$c8cb7c46eca76faa(hip, leg.ankle, p.thigh, p.shin, forward);
            knee = solved.mid;
            ankle = solved.end;
        } else {
            const legFrame = (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(pelvisBasis, (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)((0, $0a4786a5aadc3b7f$export$305a59a98cabc9c5)(s * leg.abduct), (0, $0a4786a5aadc3b7f$export$fa9f800d0752b887)(-leg.pitch)));
            knee = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(hip, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(legFrame, $16b5b2e1f0b8662b$var$DOWN), p.thigh));
            ankle = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(knee, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)((0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(legFrame, (0, $0a4786a5aadc3b7f$export$fa9f800d0752b887)(leg.flex)), $16b5b2e1f0b8662b$var$DOWN), p.shin));
        }
        // The foot hangs off the ankle in the pelvis's heading, pitched by the clip.
        const footFrame = (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(pelvisBasis, (0, $0a4786a5aadc3b7f$export$fa9f800d0752b887)(leg.footPitch));
        const sole = p.ankleHeight - p.footRadius;
        const toe = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(ankle, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(footFrame, [
            0,
            -sole,
            p.footLength
        ]));
        const heel = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(ankle, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(footFrame, [
            0,
            -sole,
            -$16b5b2e1f0b8662b$export$ea6f8a19df35d702
        ]));
        return {
            shoulder: shoulder,
            elbow: elbow,
            hand: hand,
            hip: hip,
            knee: knee,
            ankle: ankle,
            heel: heel,
            toe: toe,
            grip: grip,
            edge: edge,
            ...arm.open ? {
                open: true
            } : {}
        };
    };
    return {
        pelvis: pelvis,
        chest: chest,
        neck: neck,
        head: head,
        pelvisBasis: pelvisBasis,
        torsoBasis: torsoBasis,
        headBasis: headBasis,
        L: limb("L"),
        R: limb("R"),
        draw: pose.draw
    };
};
const $16b5b2e1f0b8662b$export$726eaa27c3bc877e = (side, sway, twist, p)=>{
    const hip = (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)((0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)(-twist * $16b5b2e1f0b8662b$export$b6e2d34de6c0868f), [
        $16b5b2e1f0b8662b$export$4afae6b5c61ab836(side) * p.hipWidth,
        0,
        0
    ]);
    return [
        sway + hip[0],
        hip[2]
    ];
};
const $16b5b2e1f0b8662b$export$f8a8a1c830424ad0 = (ankle, hip, p)=>{
    const dx = ankle[0] - hip[0];
    const dz = ankle[2] - hip[1];
    const reach = $16b5b2e1f0b8662b$export$eac172ae96bff3b0(p) * 0.995;
    const vertical = Math.sqrt(Math.max(0, reach * reach - dx * dx - dz * dz));
    return ankle[1] + vertical + p.hipDrop;
};
const $16b5b2e1f0b8662b$export$29183f5ae8d826bb = (p)=>p.ankleHeight + $16b5b2e1f0b8662b$export$eac172ae96bff3b0(p) + p.hipDrop;
const $16b5b2e1f0b8662b$export$74231045b68dcd81 = (v)=>[
        -v[0],
        v[1],
        v[2]
    ];
const $16b5b2e1f0b8662b$export$6aa0d9142c4735e2 = {
    front: {
        pitch: 0.22,
        abduct: 0.25,
        flex: 0.3,
        feetOut: 1.3
    },
    // From behind, LPC stands its feet a little wider than from the front.
    back: {
        pitch: 0.22,
        abduct: 0.25,
        flex: 0.3,
        feetOut: 1.8
    },
    side: {
        pitch: -0.2,
        abduct: 0.11,
        flex: 0.55,
        feetOut: 0.4,
        feetSplit: 0.5
    }
};
const $16b5b2e1f0b8662b$export$79ad6a201d496f72 = (facing)=>facing?.endsWith("left") ? "R" : "L";
const $16b5b2e1f0b8662b$export$a021dd78582c0634 = (p, facing)=>{
    const side = facing === "left" || facing === "right";
    const which = side ? "side" : facing?.startsWith("back") ? "back" : "front";
    const pose = {
        feetSplit: 0,
        crouch: 0,
        lean: 0,
        ...$16b5b2e1f0b8662b$export$6aa0d9142c4735e2[which],
        ...p.stance?.[which]
    };
    // From the side the far foot leads (the body stands three-quarters on, its far hip forward).
    const far = $16b5b2e1f0b8662b$export$79ad6a201d496f72(facing);
    const stance = (s)=>({
            mode: "ik",
            ankle: [
                $16b5b2e1f0b8662b$export$4afae6b5c61ab836(s) * (p.hipWidth + pose.feetOut),
                p.ankleHeight,
                side ? (s === far ? 1 : -1) * pose.feetSplit : 0
            ],
            footPitch: 0
        });
    const arm = {
        pitch: pose.pitch,
        abduct: pose.abduct,
        flex: pose.flex
    };
    return {
        root: [
            0,
            $16b5b2e1f0b8662b$export$29183f5ae8d826bb(p) - 0.4 - pose.crouch,
            0
        ],
        rootRotation: (0, $0a4786a5aadc3b7f$export$76c0f2b8ecfc3d8a),
        lean: pose.lean,
        twist: 0,
        sideBend: 0,
        // solvePose tips the head with a share of the lean: the eyes stay level.
        headPitch: pose.lean ? -pose.lean * $16b5b2e1f0b8662b$var$HEAD_LEAN : 0,
        headYaw: 0,
        arms: {
            L: arm,
            R: arm
        },
        legs: {
            L: stance("L"),
            R: stance("R")
        }
    };
};
const $16b5b2e1f0b8662b$export$5a5e8010b6451ad = (0, $0a4786a5aadc3b7f$export$9f17032d917177de);



/**
 * The game's Ember models come from its content (`content/game/sprites/ember/`, compiled into the
 * catalog) and follow it when a release is activated live: the body layer (bodies.json, hair.json)
 * under the equipment (equipment.json). The tables they draw with -- palettes, styles, marks and
 * eyes, humanoids -- are bound by the modules that own them (palette.ts, styles.ts, marks.ts,
 * face.ts, humanoids.ts).
 */ 

(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>({
        bodies: catalog.source.emberBodies,
        hair: catalog.source.emberHair
    }), ({ bodies: bodies, hair: hair })=>(0, $121d74fbc26f823b$export$8d98c437dc3f7e0a)(bodies, hair));
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>catalog.source.ember, (0, $121d74fbc26f823b$export$65e2f1c969933753));


const $9311ef6950e6afe4$var$capsule = (a, b, r, material, group)=>({
        kind: "capsule",
        a: a,
        b: b,
        r: r,
        material: material,
        group: group
    });
const $9311ef6950e6afe4$var$ellipsoid = (center, basis, radii, material, group, extra = {})=>({
        kind: "ellipsoid",
        center: center,
        basis: basis,
        radii: radii,
        material: material,
        group: group,
        ...extra
    });
const $9311ef6950e6afe4$var$inflate = (r, by)=>[
        r[0] + by,
        r[1] + by,
        r[2] + by
    ];
/**
 * A limb segment shaped like muscle rather than pipe: an ellipsoid along the bone, fullest in the
 * middle and narrowing toward both joints, where a smaller ball (`joint`) keeps the bend filled.
 * A tube of constant radius reads as a mannequin; this reads as an upper arm, a calf.
 */ const $9311ef6950e6afe4$var$segment = (a, b, r, m, group, exponent)=>{
    const along = (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(b, a);
    const half = Math.sqrt((0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(along, along)) / 2;
    const y = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(along);
    const x = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(Math.abs(y[2]) < 0.9 ? (0, $0a4786a5aadc3b7f$export$bb646b20bb93d339)(y, [
        0,
        0,
        1
    ]) : (0, $0a4786a5aadc3b7f$export$bb646b20bb93d339)(y, [
        1,
        0,
        0
    ]));
    const z = (0, $0a4786a5aadc3b7f$export$bb646b20bb93d339)(x, y);
    const basis = [
        x[0],
        y[0],
        z[0],
        x[1],
        y[1],
        z[1],
        x[2],
        y[2],
        z[2]
    ];
    return $9311ef6950e6afe4$var$ellipsoid((0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(a, b), 0.5), basis, [
        r,
        half + r * 0.45,
        r
    ], m, group, exponent ? {
        exponent: exponent
    } : {});
};
/**
 * A foot: an ellipsoid from heel to toe, as tall as `r` and `width` across, so from the front it is
 * the broad wedge LPC draws below the ankle rather than a peg the width of the shin.
 */ const $9311ef6950e6afe4$var$foot = (heel, toe, r, width, m, group)=>{
    const along = (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(toe, heel);
    const half = Math.sqrt((0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(along, along)) / 2;
    const z = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(along);
    const x = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$bb646b20bb93d339)([
        0,
        1,
        0
    ], z));
    const y = (0, $0a4786a5aadc3b7f$export$bb646b20bb93d339)(z, x);
    const basis = [
        x[0],
        y[0],
        z[0],
        x[1],
        y[1],
        z[1],
        x[2],
        y[2],
        z[2]
    ];
    // Squared across and underneath: a flat sole, not a rocker.
    return $9311ef6950e6afe4$var$ellipsoid((0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(heel, toe), 0.5), basis, [
        width,
        r,
        half + r
    ], m, group, {
        exponent: [
            3,
            3,
            2.2
        ]
    });
};
const $9311ef6950e6afe4$var$joint = (at, r, m, group)=>$9311ef6950e6afe4$var$ellipsoid(at, [
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
    ], [
        r,
        r,
        r
    ], m, group);
/** Name the limb segment a primitive is (see PrimitiveBase.part). */ const $9311ef6950e6afe4$var$as = (prim, part)=>({
        ...prim,
        part: part
    });
/** Which arm/leg group a side's limbs belong to. */ const $9311ef6950e6afe4$var$armOf = (side)=>side === "L" ? "armL" : "armR";
const $9311ef6950e6afe4$var$legOf = (side)=>side === "L" ? "legL" : "legR";
const $9311ef6950e6afe4$export$e8bff534353f9c48 = (sk, p, side)=>{
    const j = sk[side];
    return p.handLength ? (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(j.hand, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(j.hand, j.elbow)), p.handLength / 2)) : (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(j.hand, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(sk.torsoBasis, [
        -(0, $16b5b2e1f0b8662b$export$4afae6b5c61ab836)(side) * p.handInset,
        0,
        0
    ]));
};
const $9311ef6950e6afe4$export$6e9bbc4ec5453a0a = (j)=>(0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)((0, $0a4786a5aadc3b7f$export$a3295358bff77e)(j.grip), (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(j.hand, j.elbow))));
const $9311ef6950e6afe4$export$b722afcef2c08f75 = (j)=>(0, $0a4786a5aadc3b7f$export$a3295358bff77e)(j.grip);
const $9311ef6950e6afe4$export$197003423052082 = (p)=>p.handRadius * 2;
const $9311ef6950e6afe4$var$painted = (prims, paint)=>prims.map((prim)=>{
        if (prim.kind !== "ellipsoid") return prim;
        const e = typeof prim.exponent === "number" ? [
            prim.exponent,
            prim.exponent,
            prim.exponent
        ] : prim.exponent ?? [
            2,
            2,
            2
        ];
        return {
            ...prim,
            decal: (q)=>{
                const g = q.map((v, i)=>Math.sign(v) * Math.pow(Math.abs(v) / prim.radii[i], e[i] - 1) / prim.radii[i]);
                return paint((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(prim.center, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(prim.basis, q)), (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(prim.basis, g)));
            }
        };
    });
/**
 * Metal's own light, for a body turned to `facing`. Polished metal shows what it reflects, not how
 * much light falls on it: where the reflection of the camera's view looks up at the sky it is lit,
 * brightest just above the horizon, then a hard dark band where it starts to show the ground,
 * easing a little lighter below; plus a tight glint toward the lamp. The broad lit side cloth gets
 * reads, on a cuirass, as a t-shirt.
 */ const $9311ef6950e6afe4$var$sheen = (m, facing)=>{
    const turn = (0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)((0, $bc9c62e5e9c273fc$export$376317e739a8c334)[facing]);
    const light = (0, $bc9c62e5e9c273fc$export$5f22db6dc00b1799).light;
    const view = [
        0,
        Math.sin((0, $bc9c62e5e9c273fc$export$5f22db6dc00b1799).pitch),
        Math.cos((0, $bc9c62e5e9c273fc$export$5f22db6dc00b1799).pitch)
    ];
    const half = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(light, view));
    return (normal)=>{
        const n = (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(turn, normal);
        if ((0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(n, half) > 0.95) return m.light;
        // The view reflected off the surface: how far up (sky) or down (ground) it looks.
        const skyward = 2 * (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(n, view) * n[1] - view[1];
        if ((0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(n, light) < -0.35) return m.deep;
        return skyward > 0.45 ? m.base : skyward > 0.08 ? m.light : skyward > -0.22 ? m.deep : m.shade;
    };
};
/** Paint over prims' own decals (theirs still shows wherever `paint` leaves a point alone). */ const $9311ef6950e6afe4$var$overPainted = (prims, paint)=>prims.map((prim)=>{
        if (prim.kind !== "ellipsoid") return prim;
        const own = prim.decal;
        const [over] = $9311ef6950e6afe4$var$painted([
            prim
        ], paint);
        return {
            ...over,
            decal: (q)=>over.decal(q) ?? own?.(q)
        };
    });
/** Painted light for a body turned to `facing`: a ramp step, 0 lit to 3 deep (decals skip the raster's shading). */ const $9311ef6950e6afe4$var$lighting = (facing)=>{
    const turn = (0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)((0, $bc9c62e5e9c273fc$export$376317e739a8c334)[facing]);
    const light = (0, $bc9c62e5e9c273fc$export$5f22db6dc00b1799).light;
    return (normal)=>{
        const lit = (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(turn, normal), light);
        return lit > 0.6 ? 0 : lit > 0.05 ? 1 : lit > -0.45 ? 2 : 3;
    };
};
const $9311ef6950e6afe4$var$tone = (m, step)=>[
        m.light,
        m.base,
        m.shade,
        m.deep
    ][step];
/**
 * Which way a primitive's surface faces at `q`, a point of its own frame (the superellipsoid's
 * gradient, as the raster lights it), in the body's frame: for paint that works in a volume's own
 * frame, as fur does.
 */ const $9311ef6950e6afe4$var$normalOf = (prim, q)=>{
    const e = typeof prim.exponent === "number" ? [
        prim.exponent,
        prim.exponent,
        prim.exponent
    ] : prim.exponent ?? [
        2,
        2,
        2
    ];
    const g = q.map((v, i)=>Math.sign(v) * Math.pow(Math.abs(v) / prim.radii[i], e[i] - 1) / prim.radii[i]);
    return (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(prim.basis, g));
};
/** A cell's hash, from three whole numbers: scattered noise (fur strands, curls) that keeps still on the volume. */ const $9311ef6950e6afe4$var$hash3 = (i, j, k)=>{
    let h = Math.imul(i, 374761393) + Math.imul(j, 668265263) + Math.imul(k, 1274126177);
    h = Math.imul(h ^ h >>> 13, 1274126177);
    return (h ^ h >>> 16) >>> 0;
};
const $9311ef6950e6afe4$export$cf993e3788ff9d62 = {};
const $9311ef6950e6afe4$export$6b7dfadb4f6159e3 = (style)=>(0, $121d74fbc26f823b$export$22dcbb71e9260857)(style)?.params;
let $9311ef6950e6afe4$export$56c9f9905232d5d6 = [];
let $9311ef6950e6afe4$export$fa6e205ceaf9ec1b = [];
let $9311ef6950e6afe4$export$f8a4cd30a1d616ae = [];
let $9311ef6950e6afe4$export$97868a69ac87308f = [];
let $9311ef6950e6afe4$export$3b6e816b98cc7cab = [];
let $9311ef6950e6afe4$export$ec83d7edc9c6e083 = [];
let $9311ef6950e6afe4$export$b1e35fca6919daa0 = [];
let $9311ef6950e6afe4$export$a9b51f1bd1fab061 = [];
let $9311ef6950e6afe4$export$cfaa8f2ed0c9ba36 = [];
(0, $121d74fbc26f823b$export$dde91a05cabd1edf)(()=>{
    const ids = (slot)=>(0, $121d74fbc26f823b$export$dbd794431332c1b0)(slot).map((d)=>d.id);
    $9311ef6950e6afe4$export$56c9f9905232d5d6 = ids("held");
    $9311ef6950e6afe4$export$fa6e205ceaf9ec1b = ids("shirt");
    $9311ef6950e6afe4$export$f8a4cd30a1d616ae = ids("pants");
    $9311ef6950e6afe4$export$97868a69ac87308f = ids("shoes");
    $9311ef6950e6afe4$export$3b6e816b98cc7cab = ids("armor");
    $9311ef6950e6afe4$export$ec83d7edc9c6e083 = ids("shield");
    $9311ef6950e6afe4$export$b1e35fca6919daa0 = ids("bauldron");
    $9311ef6950e6afe4$export$a9b51f1bd1fab061 = (0, $121d74fbc26f823b$export$dbd794431332c1b0)("held").filter((d)=>d.handling?.twoHanded).map((d)=>d.id);
    $9311ef6950e6afe4$export$cfaa8f2ed0c9ba36 = (0, $121d74fbc26f823b$export$dbd794431332c1b0)("held").filter((d)=>d.handling?.polearm).map((d)=>d.id);
    for (const k of Object.keys($9311ef6950e6afe4$export$cf993e3788ff9d62))delete $9311ef6950e6afe4$export$cf993e3788ff9d62[k];
    for (const style of Object.keys((0, $121d74fbc26f823b$export$f8f17b875f484d58)()))$9311ef6950e6afe4$export$cf993e3788ff9d62[style] = $9311ef6950e6afe4$export$6b7dfadb4f6159e3(style);
});
/** A worn item's look: its design's model and parameters, in the item's colour. */ const $9311ef6950e6afe4$var$worn = (slot, type)=>{
    const d = (0, $121d74fbc26f823b$export$d2c6fd47dbbb12e9)(slot, type);
    return {
        ...d?.params ?? {},
        ...d ? {
            model: d.model
        } : {}
    };
};
const $9311ef6950e6afe4$export$77ffb62114f6237d = (type, color)=>({
        dye: color,
        ...$9311ef6950e6afe4$var$worn("shirt", type)
    });
const $9311ef6950e6afe4$export$52578e0af89c75fb = (type, color)=>({
        dye: color,
        ...$9311ef6950e6afe4$var$worn("shoes", type)
    });
const $9311ef6950e6afe4$export$3ceac30571744c24 = (type, color)=>({
        dye: color,
        ...$9311ef6950e6afe4$var$worn("pants", type)
    });
const $9311ef6950e6afe4$export$1ea20f6d45609a7c = (type, color)=>({
        color: color,
        ...$9311ef6950e6afe4$var$worn("armor", type)
    });
const $9311ef6950e6afe4$export$764237bc0d65d1bc = (type, color)=>({
        color: color,
        ...$9311ef6950e6afe4$var$worn("bauldron", type)
    });
const $9311ef6950e6afe4$export$d1d6e3b3f3e4b367 = (sk, p, look, facing = "front", skins = (0, $b28f7e6af286c932$export$da9f99569d75238a))=>{
    const skin = skins[look.skin] ?? skins.light;
    const footWidth = facing === "left" || facing === "right" ? p.footProfileWidth : p.footWidth;
    // ---- body: its model (content's bodies.json) -- flesh, bones, a beast, wounds -----------------
    const context = {
        sk: sk,
        p: p,
        look: look,
        facing: facing,
        skin: skin,
        footWidth: footWidth,
        t: p.clothThickness ?? 1
    };
    const prims = (0, $121d74fbc26f823b$export$4942545267cbc1ad)("body", look.body ?? (0, $121d74fbc26f823b$export$c38d4c0d63da762e), {}, context);
    const overBody = [];
    // ---- features hung on it, in order: horns, a tail, markings (bodies.json features) ------------
    for (const feature of look.features ?? [])prims.push(...(0, $121d74fbc26f823b$export$4942545267cbc1ad)("feature", feature.model, feature.params ?? {}, context, overBody));
    prims.push(...$9311ef6950e6afe4$var$dressed(sk, p, look, facing, skin, footWidth, overBody));
    if (overBody.length) {
        // Paint a model lays over the body's own surfaces (a bauldron's strap across the chest): on
        // every primitive of its groups, skin, shirt or armour alike, once everything is built --
        // or only the bare skin of them (markings, which what is worn over them covers).
        const paints = (o, prim)=>o.groups.includes(prim.group) && (!o.skin || prim.material === skin);
        return prims.map((prim)=>overBody.reduce((at, o)=>paints(o, at) ? $9311ef6950e6afe4$var$overPainted([
                    at
                ], o.paint)[0] : at, prim));
    }
    return prims;
};
/** What the body has on: clothes, armour, hair, what it holds. */ const $9311ef6950e6afe4$var$dressed = (sk, p, look, facing, skin, footWidth, overBody = [])=>{
    const prims = [];
    // ---- garments: inflated copies of what they cover -----------------------------------------
    // How far cloth stands off the skin, scaled for bodies slimmer than LPC's.
    const t = p.clothThickness ?? 1;
    // Each slot is drawn by its model (model.ts, content's sprites/ember/equipment.json), in this order: leg
    // wear, footwear, shirt, belt, armour, bauldron, shield, then hair (the body's own) and what the
    // hand holds. A look names its garments' models and their parameters; a shield and what the
    // hand holds are item types, drawn by their designs.
    const context = {
        sk: sk,
        p: p,
        look: look,
        facing: facing,
        skin: skin,
        footWidth: footWidth,
        t: t
    };
    const wear = (slot, model, params, bind)=>prims.push(...(0, $121d74fbc26f823b$export$4942545267cbc1ad)(slot, model, params, context, overBody, bind));
    if (look.pants) wear("pants", look.pants.model ?? look.pants.cut ?? "trousers", look.pants);
    if (look.shoes) wear("shoes", look.shoes.model ?? look.shoes.cut ?? "shoes", look.shoes);
    if (look.shirt) wear("shirt", look.shirt.model ?? "shirt", look.shirt);
    if (look.belt) wear("belt", look.belt.model ?? "belt", look.belt);
    if (look.armor) wear("armor", look.armor.model ?? look.armor.kind, look.armor);
    if (look.bauldron) wear("bauldron", look.bauldron.model ?? "bauldron", look.bauldron);
    const shield = look.shield && (0, $121d74fbc26f823b$export$d2c6fd47dbbb12e9)("shield", look.shield.type);
    if (shield) wear("shield", shield.model, {
        ...shield.params,
        ...look.shield
    }, shield.bind);
    // ---- hair: its style's model (content's hair.json), a shell over the skull cut away where the
    // face shows. A skull and a beast have none.
    const hair = look.hair && !look.bones && !look.beast ? (0, $121d74fbc26f823b$export$22dcbb71e9260857)(look.hair.style) : undefined;
    if (look.hair && hair) wear("hair", hair.model, {
        ...hair.params,
        color: look.hair.color
    });
    // ---- held: what the hand holds -----------------------------------------------------------
    const held = look.held ? (0, $121d74fbc26f823b$export$d2c6fd47dbbb12e9)("held", look.held) : undefined;
    if (held) wear("held", held.model, {
        ...held.params,
        held: look.held,
        color: look.heldColor
    }, held.bind);
    return prims;
};
const $9311ef6950e6afe4$export$8925961623947896 = (sk, p, look, facing, skin)=>$9311ef6950e6afe4$var$dressed(sk, p, look, facing, skin, facing === "left" || facing === "right" ? p.footProfileWidth : p.footWidth);
const $9311ef6950e6afe4$export$55a544314ab4c0e7 = (prims, k, floor = 0.7)=>prims.map((prim)=>{
        const r = (v)=>Math.max(v * k, Math.min(v, floor));
        if (prim.kind === "capsule") return {
            ...prim,
            a: (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(prim.a, k),
            b: (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(prim.b, k),
            r: r(prim.r)
        };
        const radii = [
            r(prim.radii[0]),
            r(prim.radii[1]),
            r(prim.radii[2])
        ];
        const back = (q)=>[
                q[0] * (prim.radii[0] / radii[0]),
                q[1] * (prim.radii[1] / radii[1]),
                q[2] * (prim.radii[2] / radii[2])
            ];
        return {
            ...prim,
            center: (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(prim.center, k),
            radii: radii,
            ...prim.keep ? {
                keep: (q)=>prim.keep(back(q))
            } : {},
            ...prim.decal ? {
                decal: (q)=>prim.decal(back(q))
            } : {}
        };
    });
const $9311ef6950e6afe4$export$9b514bd132bbe430 = (prim)=>{
    if (prim.kind === "capsule") {
        const center = (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(prim.a, prim.b), 0.5);
        const half = Math.hypot(prim.a[0] - prim.b[0], prim.a[1] - prim.b[1], prim.a[2] - prim.b[2]) / 2;
        return {
            center: center,
            radius: half + prim.r
        };
    }
    return {
        center: prim.center,
        radius: Math.max(prim.radii[0], prim.radii[1], prim.radii[2])
    };
};
/**
 * What a model (model.ts) can use: the body's own volumes and the shapes, light and materials the
 * game's drawings are made of, and plain maths. Nothing else is reachable from a model.
 */ (0, $121d74fbc26f823b$export$9adde861b5055710)({
    // maths
    PI: Math.PI,
    min: Math.min,
    max: Math.max,
    abs: Math.abs,
    sqrt: Math.sqrt,
    pow: Math.pow,
    floor: Math.floor,
    ceil: Math.ceil,
    round: Math.round,
    sin: Math.sin,
    cos: Math.cos,
    tan: Math.tan,
    atan2: Math.atan2,
    hypot: Math.hypot,
    sign: Math.sign,
    add: // vectors and frames (a Mat3 is nine numbers, its columns the frame's axes)
    $0a4786a5aadc3b7f$export$e16d8520af44a096,
    sub: $0a4786a5aadc3b7f$export$f93b5905241a7cca,
    scale: $0a4786a5aadc3b7f$export$dcdf75081b88279d,
    dot: $0a4786a5aadc3b7f$export$94132a0e348806d4,
    cross: $0a4786a5aadc3b7f$export$bb646b20bb93d339,
    normalize: $0a4786a5aadc3b7f$export$a3295358bff77e,
    lerp: $0a4786a5aadc3b7f$export$3a89f8d6f6bf6c9f,
    distance: $0a4786a5aadc3b7f$export$9f17032d917177de,
    length: (0, $0a4786a5aadc3b7f$export$f24224f1c91d8156),
    apply: $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c,
    transpose: $0a4786a5aadc3b7f$export$9cb09a71b7d66923,
    mul: $0a4786a5aadc3b7f$export$6e3a27864ab166fe,
    rotX: $0a4786a5aadc3b7f$export$fa9f800d0752b887,
    rotY: $0a4786a5aadc3b7f$export$d4dbf6597d59367,
    rotZ: $0a4786a5aadc3b7f$export$305a59a98cabc9c5,
    deg: $0a4786a5aadc3b7f$export$61ddd819c68acdd,
    IDENTITY: $0a4786a5aadc3b7f$export$76c0f2b8ecfc3d8a,
    // lists
    range: (n)=>Array.from({
            length: n
        }, (_, i)=>i),
    values: (o)=>Object.values(o),
    keys: (o)=>Object.keys(o),
    SIDES: // the rig
    $16b5b2e1f0b8662b$export$7bcc7ebb13416507,
    sideSign: $16b5b2e1f0b8662b$export$4afae6b5c61ab836,
    farSide: $16b5b2e1f0b8662b$export$79ad6a201d496f72,
    legLength: $16b5b2e1f0b8662b$export$eac172ae96bff3b0,
    fistCenter: $9311ef6950e6afe4$export$e8bff534353f9c48,
    bladeAxis: $9311ef6950e6afe4$export$6e9bbc4ec5453a0a,
    swordAxis: $9311ef6950e6afe4$export$b722afcef2c08f75,
    twoHandSpan: $9311ef6950e6afe4$export$197003423052082,
    capsule: // shapes, and the surface of one (its normal at a point of its own frame)
    $9311ef6950e6afe4$var$capsule,
    ellipsoid: $9311ef6950e6afe4$var$ellipsoid,
    segment: $9311ef6950e6afe4$var$segment,
    foot: $9311ef6950e6afe4$var$foot,
    joint: $9311ef6950e6afe4$var$joint,
    inflate: $9311ef6950e6afe4$var$inflate,
    as: $9311ef6950e6afe4$var$as,
    armOf: $9311ef6950e6afe4$var$armOf,
    legOf: $9311ef6950e6afe4$var$legOf,
    normalOf: $9311ef6950e6afe4$var$normalOf,
    painted: // light and paint, and noise to scatter it by (a texture's cells)
    $9311ef6950e6afe4$var$painted,
    overPainted: $9311ef6950e6afe4$var$overPainted,
    lighting: $9311ef6950e6afe4$var$lighting,
    tone: $9311ef6950e6afe4$var$tone,
    sheen: $9311ef6950e6afe4$var$sheen,
    hash3: $9311ef6950e6afe4$var$hash3,
    // materials (`cloth(name)` is a dye's ramp: garments name their colour `dye`); bone by colour
    cloth: (0, $b28f7e6af286c932$export$babb80d09f1c288),
    dye: $b28f7e6af286c932$export$babb80d09f1c288,
    hairDye: $b28f7e6af286c932$export$6bd841329da7a610,
    rampFrom: $b28f7e6af286c932$export$8045a65082865858,
    metalFrom: $b28f7e6af286c932$export$6e1a69eadfd1804f,
    DYES: $b28f7e6af286c932$export$37ca4dbc437f02a0,
    BONES: $b28f7e6af286c932$export$46faf4f3596622ce
});





const $a1fb04dc4139ce6e$export$8ec32ae08bf1bc32 = (clip, i, n)=>clip.loop ? i / n : n <= 1 ? 0 : i / (n - 1);
const $a1fb04dc4139ce6e$var$WALK = {
    stepLength: 11.5,
    duty: 0.6,
    lift: 2.4,
    heelKick: 0.8,
    bob: 0.7,
    crouch: 0.7,
    lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(3),
    armSwing: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(28),
    armForward: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(3),
    elbow: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
    elbowSwing: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(16),
    twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(6),
    sway: 0.5,
    stanceWidth: 0.4
};
const $a1fb04dc4139ce6e$var$RUN = {
    stepLength: 14,
    duty: 0.36,
    lift: 3.6,
    heelKick: 5.5,
    bob: 1.3,
    crouch: 1.4,
    lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
    armSwing: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(46),
    armForward: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(14),
    elbow: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(82),
    elbowSwing: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(14),
    twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10),
    sway: 0.3,
    stanceWidth: 0.0
};
/**
 * The lowest the ankle may sit with the foot pitched by `pitch` (toes down positive): whichever of
 * toe or heel the pitch drops is then exactly on the ground. A planted foot sits here; a swinging
 * one never goes below it.
 */ const $a1fb04dc4139ce6e$var$groundedAnkle = (pitch, p)=>{
    const sole = p.ankleHeight - p.footRadius;
    return p.ankleHeight - sole * (1 - Math.cos(pitch)) + Math.max(p.footLength * Math.sin(pitch), -(0, $16b5b2e1f0b8662b$export$ea6f8a19df35d702) * Math.sin(pitch));
};
const $a1fb04dc4139ce6e$var$footOnPath = (q, side, g, p)=>{
    const x = (0, $16b5b2e1f0b8662b$export$4afae6b5c61ab836)(side) * (p.hipWidth + g.stanceWidth);
    const half = g.stepLength / 2;
    if (q < g.duty) {
        const s = q / g.duty;
        // Heel strike lands toes-up on the heel; the heel peels off the ground before toe-off, the
        // foot pivoting on its toe.
        const strike = -0.25 * (1 - (0, $0a4786a5aadc3b7f$export$4053e36566dd3d9a)(s / 0.25));
        const peel = 0.55 * (0, $0a4786a5aadc3b7f$export$4053e36566dd3d9a)((s - 0.7) / 0.3);
        const pitch = strike + peel;
        return {
            mode: "ik",
            ankle: [
                x,
                $a1fb04dc4139ce6e$var$groundedAnkle(pitch, p),
                half - g.stepLength * s
            ],
            footPitch: pitch,
            planted: true
        };
    }
    const s = (q - g.duty) / (1 - g.duty);
    // The foot rises behind first, then swings through: forward travel lags the lift.
    const forward = (0, $0a4786a5aadc3b7f$export$b0f87bb1f6530fd8)(Math.pow(s, 1.35));
    const kick = g.heelKick * Math.sin(Math.PI * Math.min(1, s * 1.5)) * (1 - s);
    const footPitch = 0.7 * Math.sin(Math.PI * Math.min(1, s * 1.4)) * (1 - s) - 0.25 * (0, $0a4786a5aadc3b7f$export$4053e36566dd3d9a)((s - 0.8) / 0.2);
    const y = Math.max($a1fb04dc4139ce6e$var$groundedAnkle(footPitch, p), p.ankleHeight + g.lift * Math.sin(Math.PI * s) + kick);
    return {
        mode: "ik",
        ankle: [
            x,
            y,
            -half + g.stepLength * forward
        ],
        footPitch: footPitch,
        planted: false
    };
};
const $a1fb04dc4139ce6e$var$sampleGait = (g)=>(t, p)=>{
        const L = $a1fb04dc4139ce6e$var$footOnPath(t % 1, "L", g, p);
        const R = $a1fb04dc4139ce6e$var$footOnPath((t + 0.5) % 1, "R", g, p);
        // A walk is highest over the planted foot; a run is lowest there and rises through the flight.
        const wave = Math.cos(4 * Math.PI * (t - g.duty / 2));
        let height = (0, $16b5b2e1f0b8662b$export$29183f5ae8d826bb)(p) - g.crouch + (g.duty >= 0.5 ? g.bob : -g.bob) * wave;
        const twist = -g.twist * Math.cos(2 * Math.PI * t);
        const sway = g.sway * Math.cos(2 * Math.PI * (t - g.duty / 2));
        // Never stand so tall that a planted foot is torn off the ground.
        if (L.planted) height = Math.min(height, (0, $16b5b2e1f0b8662b$export$f8a8a1c830424ad0)(L.ankle, (0, $16b5b2e1f0b8662b$export$726eaa27c3bc877e)("L", sway, twist, p), p));
        if (R.planted) height = Math.min(height, (0, $16b5b2e1f0b8662b$export$f8a8a1c830424ad0)(R.ankle, (0, $16b5b2e1f0b8662b$export$726eaa27c3bc877e)("R", sway, twist, p), p));
        // Each arm swings against its own side's leg.
        const swing = Math.cos(2 * Math.PI * t);
        const armL = g.armForward - g.armSwing * swing;
        const armR = g.armForward + g.armSwing * swing;
        const elbow = (pitch)=>g.elbow + g.elbowSwing * Math.max(0, pitch / Math.max(1e-6, g.armSwing));
        return {
            root: [
                sway,
                height,
                0
            ],
            rootRotation: (0, $0a4786a5aadc3b7f$export$76c0f2b8ecfc3d8a),
            lean: g.lean,
            twist: // The chest turns with the forward arm: left arm forward turns the left shoulder forward.
            twist,
            sideBend: 0,
            headPitch: -g.lean * 0.4,
            headYaw: 0,
            arms: {
                L: {
                    pitch: armL,
                    abduct: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(5),
                    flex: elbow(armL)
                },
                R: {
                    pitch: armR,
                    abduct: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(5),
                    flex: elbow(armR)
                }
            },
            legs: {
                L: L,
                R: R
            }
        };
    };
/** Ground one full cycle covers: during stance the body passes over the planted foot. */ const $a1fb04dc4139ce6e$var$strideOf = (g)=>g.stepLength / g.duty;
/** A curve through [s, degrees] knots, eased between them; radians out. */ const $a1fb04dc4139ce6e$var$curveAt = (knots, s)=>{
    let i = 0;
    while(i < knots.length - 2 && s > knots[i + 1][0])i++;
    const [s0, v0] = knots[i], [s1, v1] = knots[i + 1];
    return (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(v0 + (v1 - v0) * (0, $0a4786a5aadc3b7f$export$b0f87bb1f6530fd8)(s1 > s0 ? (s - s0) / (s1 - s0) : 0));
};
const $a1fb04dc4139ce6e$var$NATURAL_WALK = {
    cycle: 1.7,
    duty: 0.6,
    reach: 0.42,
    stanceWidth: -0.01,
    crouch: 0.06,
    bob: 0.035,
    lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(3),
    twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(5),
    sway: 0.02,
    strike: -0.32,
    flatBy: 0.15,
    heelOff: 0.62,
    toeOff: 0.9,
    hip: [
        [
            0,
            -8
        ],
        [
            0.2,
            8
        ],
        [
            0.5,
            26
        ],
        [
            0.75,
            31
        ],
        [
            1,
            28
        ]
    ],
    knee: [
        [
            0,
            40
        ],
        [
            0.25,
            62
        ],
        [
            0.5,
            40
        ],
        [
            0.75,
            12
        ],
        [
            0.92,
            3
        ],
        [
            1,
            5
        ]
    ],
    ankle: [
        [
            0,
            15
        ],
        [
            0.3,
            3
        ],
        [
            0.6,
            0
        ],
        [
            1,
            0
        ]
    ],
    arm: {
        swing: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(20),
        forward: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(2),
        abduct: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(8),
        elbow: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(15),
        elbowForward: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(25),
        lag: 0.03
    }
};
const $a1fb04dc4139ce6e$var$NATURAL_RUN = {
    cycle: 2.8,
    duty: 0.33,
    reach: 0.35,
    stanceWidth: -0.02,
    crouch: 0.04,
    bob: 0.04,
    lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(9),
    twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10),
    sway: 0.01,
    strike: -0.15,
    flatBy: 0.15,
    heelOff: 0.5,
    toeOff: 0.7,
    hip: [
        [
            0,
            -10
        ],
        [
            0.25,
            8
        ],
        [
            0.55,
            40
        ],
        [
            0.8,
            42
        ],
        [
            1,
            30
        ]
    ],
    knee: [
        [
            0,
            22
        ],
        [
            0.3,
            80
        ],
        [
            0.55,
            74
        ],
        [
            0.8,
            36
        ],
        [
            1,
            22
        ]
    ],
    ankle: [
        [
            0,
            25
        ],
        [
            0.35,
            8
        ],
        [
            1,
            0
        ]
    ],
    // A runner's elbow opens as the arm drives back and closes as it comes forward.
    arm: {
        swing: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30),
        forward: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(4),
        abduct: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
        elbow: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(64),
        elbowForward: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(46),
        lag: 0.02
    }
};
const $a1fb04dc4139ce6e$var$sampleStride = (g)=>(t, p)=>{
        const leg = (0, $16b5b2e1f0b8662b$export$eac172ae96bff3b0)(p);
        const travel = g.cycle * leg * g.duty;
        const ahead = travel * g.reach;
        const x = (side)=>(0, $16b5b2e1f0b8662b$export$4afae6b5c61ab836)(side) * (p.hipWidth + g.stanceWidth * leg);
        // A walk rides highest over the standing foot and dips as both feet touch; a run sinks onto
        // the standing foot and rises through the flight. Twice a cycle either way.
        const heightAt = (q)=>(0, $16b5b2e1f0b8662b$export$29183f5ae8d826bb)(p) - g.crouch * leg + (g.duty >= 0.5 ? 1 : -1) * g.bob * leg * Math.cos(4 * Math.PI * (q - g.duty / 2));
        const stancePitch = (s)=>g.strike * (1 - (0, $0a4786a5aadc3b7f$export$4053e36566dd3d9a)(s / g.flatBy)) + g.toeOff * (0, $0a4786a5aadc3b7f$export$4053e36566dd3d9a)((s - g.heelOff) / (1 - g.heelOff));
        // Where the hip and knee angles of swing put the ankle, relative to the pelvis, and the shank's tilt.
        const swingLeg = (s)=>{
            const hipY = heightAt(g.duty + s * (1 - g.duty)) - p.hipDrop;
            const thigh = $a1fb04dc4139ce6e$var$curveAt(g.hip, s);
            const shank = thigh - $a1fb04dc4139ce6e$var$curveAt(g.knee, s);
            return [
                p.thigh * Math.sin(thigh) + p.shin * Math.sin(shank),
                hipY - p.thigh * Math.cos(thigh) - p.shin * Math.cos(shank),
                shank
            ];
        };
        const [z0, y0, shank0] = swingLeg(0);
        const [z1, y1, shank1] = swingLeg(1);
        const lift = [
            ahead - travel - z0,
            $a1fb04dc4139ce6e$var$groundedAnkle(g.toeOff, p) - y0
        ];
        const land = [
            ahead - z1,
            $a1fb04dc4139ce6e$var$groundedAnkle(g.strike, p) - y1
        ];
        const free = (s, shank)=>-shank + $a1fb04dc4139ce6e$var$curveAt(g.ankle, s);
        const foot = (q, side)=>{
            if (q < g.duty) {
                const s = q / g.duty;
                const pitch = stancePitch(s);
                return {
                    mode: "ik",
                    ankle: [
                        x(side),
                        $a1fb04dc4139ce6e$var$groundedAnkle(pitch, p),
                        ahead - travel * s
                    ],
                    footPitch: pitch,
                    planted: true
                };
            }
            const s = (q - g.duty) / (1 - g.duty);
            const [z, y, shank] = swingLeg(s);
            // The recorded path, bent just enough to leave the toe-off pose and land on the strike pose.
            const footPitch = free(s, shank) + (1 - (0, $0a4786a5aadc3b7f$export$4053e36566dd3d9a)(s / 0.2)) * (g.toeOff - free(0, shank0)) + (0, $0a4786a5aadc3b7f$export$4053e36566dd3d9a)((s - 0.8) / 0.2) * (g.strike - free(1, shank1));
            const ankleY = y + (1 - s) * lift[1] + s * land[1];
            return {
                mode: "ik",
                ankle: [
                    x(side),
                    Math.max($a1fb04dc4139ce6e$var$groundedAnkle(footPitch, p), ankleY),
                    z + (1 - s) * lift[0] + s * land[0]
                ],
                footPitch: footPitch,
                planted: false
            };
        };
        const L = foot(t % 1, "L");
        const R = foot((t + 0.5) % 1, "R");
        let height = heightAt(t);
        // The chest turns with the forward arm, the pelvis against it (solvePose), the weight over the standing foot.
        const twist = -g.twist * Math.cos(2 * Math.PI * t);
        const sway = g.sway * leg * Math.cos(2 * Math.PI * (t - g.duty / 2));
        if (L.planted) height = Math.min(height, (0, $16b5b2e1f0b8662b$export$f8a8a1c830424ad0)(L.ankle, (0, $16b5b2e1f0b8662b$export$726eaa27c3bc877e)("L", sway, twist, p), p));
        if (R.planted) height = Math.min(height, (0, $16b5b2e1f0b8662b$export$f8a8a1c830424ad0)(R.ankle, (0, $16b5b2e1f0b8662b$export$726eaa27c3bc877e)("R", sway, twist, p), p));
        // Each arm swings against its own side's leg, a beat behind it, the elbow bending more forward.
        const a = g.arm;
        const swing = Math.cos(2 * Math.PI * (t - a.lag));
        const arm = (pitch)=>({
                pitch: pitch,
                abduct: a.abduct,
                flex: a.elbow + a.elbowForward * Math.max(0, (pitch - a.forward) / a.swing)
            });
        return {
            root: [
                sway,
                height,
                0
            ],
            rootRotation: (0, $0a4786a5aadc3b7f$export$76c0f2b8ecfc3d8a),
            lean: g.lean,
            twist: twist,
            sideBend: 0,
            // The head rides with the spine, leaning with it (solvePose gives it 0.35 of the lean;
            // this brings it to 0.6), eyes ahead; it does undo the chest's turn.
            headPitch: g.lean * 0.25,
            headYaw: -twist * 0.4,
            arms: {
                L: arm(a.forward - a.swing * swing),
                R: arm(a.forward + a.swing * swing)
            },
            legs: {
                L: L,
                R: R
            }
        };
    };
const $a1fb04dc4139ce6e$var$mix = (a, b, u)=>(a ?? 0) + ((b ?? 0) - (a ?? 0)) * u;
const $a1fb04dc4139ce6e$var$mix3 = (a, b, u)=>[
        $a1fb04dc4139ce6e$var$mix(a[0], b[0], u),
        $a1fb04dc4139ce6e$var$mix(a[1], b[1], u),
        $a1fb04dc4139ce6e$var$mix(a[2], b[2], u)
    ];
const $a1fb04dc4139ce6e$var$sampleKeys = (keys)=>(t, p)=>{
        let i = 0;
        while(i < keys.length - 2 && t > keys[i + 1].t)i++;
        const a = keys[i], b = keys[i + 1];
        const u = (0, $0a4786a5aadc3b7f$export$b0f87bb1f6530fd8)(b.t > a.t ? (t - a.t) / (b.t - a.t) : 0);
        const roll = $a1fb04dc4139ce6e$var$mix(a.roll, b.roll, u);
        const rest = (0, $16b5b2e1f0b8662b$export$a021dd78582c0634)(p);
        const height = (0, $16b5b2e1f0b8662b$export$29183f5ae8d826bb)(p) - 0.4 + $a1fb04dc4139ce6e$var$mix(a.rise, b.rise, u);
        const legs = (side)=>{
            const fa = side === "L" ? a.feetL : a.feetR;
            const fb = side === "L" ? b.feetL : b.feetR;
            if (fa && fb) {
                const [x, z] = $a1fb04dc4139ce6e$var$mix3([
                    fa[0],
                    fa[1],
                    0
                ], [
                    fb[0],
                    fb[1],
                    0
                ], u);
                return {
                    mode: "ik",
                    ankle: [
                        (0, $16b5b2e1f0b8662b$export$4afae6b5c61ab836)(side) * (p.hipWidth + x),
                        p.ankleHeight,
                        z
                    ],
                    footPitch: 0
                };
            }
            const la = (side === "L" ? a.legL : a.legR) ?? [
                0,
                0,
                0
            ];
            const lb = (side === "L" ? b.legL : b.legR) ?? [
                0,
                0,
                0
            ];
            const [pitch, abduct, flex] = $a1fb04dc4139ce6e$var$mix3(la, lb, u);
            return {
                mode: "fk",
                pitch: pitch,
                abduct: abduct,
                flex: flex,
                footPitch: 0.2
            };
        };
        const arm = (ka, kb)=>{
            const [pitch, abduct, flex] = $a1fb04dc4139ce6e$var$mix3(ka, kb, u);
            return {
                pitch: pitch,
                abduct: abduct,
                flex: flex,
                wrist: $a1fb04dc4139ce6e$var$mix(ka[3] ?? (0, $16b5b2e1f0b8662b$export$739083ff10a3e078), kb[3] ?? (0, $16b5b2e1f0b8662b$export$739083ff10a3e078), u)
            };
        };
        let twist = $a1fb04dc4139ce6e$var$mix(a.twist, b.twist, u);
        const pitch = $a1fb04dc4139ce6e$var$mix(a.pitch, b.pitch, u);
        let rootRotation = (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(pitch ? (0, $0a4786a5aadc3b7f$export$fa9f800d0752b887)(pitch) : (0, $0a4786a5aadc3b7f$export$76c0f2b8ecfc3d8a), roll ? (0, $0a4786a5aadc3b7f$export$305a59a98cabc9c5)(roll) : (0, $0a4786a5aadc3b7f$export$76c0f2b8ecfc3d8a));
        let headYaw = rest.headYaw;
        if (a.hips !== undefined && b.hips !== undefined) {
            // Chest at `twist`, pelvis at `hips`: solvePose turns the chest by root + twist and the
            // pelvis by root - PELVIS_COUNTER_TWIST * twist.
            const chest = twist, hips = $a1fb04dc4139ce6e$var$mix(a.hips, b.hips, u);
            twist = (chest - hips) / (1 + (0, $16b5b2e1f0b8662b$export$b6e2d34de6c0868f));
            const yaw = hips + (0, $16b5b2e1f0b8662b$export$b6e2d34de6c0868f) * twist;
            rootRotation = (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)((0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)(yaw), rootRotation);
            // The head turns by root + 0.4 twist + headYaw.
            headYaw = $a1fb04dc4139ce6e$var$mix(a.head, b.head, u) - yaw - 0.4 * twist;
        }
        const sample = {
            ...rest,
            root: [
                $a1fb04dc4139ce6e$var$mix(a.shiftX, b.shiftX, u),
                height,
                0
            ],
            rootRotation: rootRotation,
            lean: $a1fb04dc4139ce6e$var$mix(a.lean, b.lean, u),
            twist: twist,
            headYaw: headYaw,
            sideBend: $a1fb04dc4139ce6e$var$mix(a.sideBend, b.sideBend, u),
            headPitch: $a1fb04dc4139ce6e$var$mix(a.headPitch, b.headPitch, u),
            arms: {
                L: arm(a.armL, b.armL),
                R: arm(a.armR, b.armR)
            },
            legs: {
                L: legs("L"),
                R: legs("R")
            }
        };
        const ground = $a1fb04dc4139ce6e$var$mix(a.ground, b.ground, u);
        if (ground) sample.root = [
            sample.root[0],
            height - ground * $a1fb04dc4139ce6e$var$lowestPoint((0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(sample, p), p),
            0
        ];
        return sample;
    };
/** How far below its centre an ellipsoid of these radii, turned by `basis`, reaches. */ const $a1fb04dc4139ce6e$var$depthBelow = (basis, r)=>Math.hypot(basis[3] * r[0], basis[4] * r[1], basis[5] * r[2]);
/** What stands off the skull (hair, nose, jaw) and how far a fist reaches past its round, in pixels. */ const $a1fb04dc4139ce6e$var$HEAD_REACH = 1.5;
const $a1fb04dc4139ce6e$var$FIST_REACH = 1;
/** The height of the lowest of a posed body's surface: what rests on the ground when it is let down. */ const $a1fb04dc4139ce6e$var$lowestPoint = (sk, p)=>Math.min(sk.head[1] - $a1fb04dc4139ce6e$var$depthBelow(sk.headBasis, p.head) - $a1fb04dc4139ce6e$var$HEAD_REACH, sk.chest[1] - $a1fb04dc4139ce6e$var$depthBelow(sk.torsoBasis, p.torso), sk.pelvis[1] - $a1fb04dc4139ce6e$var$depthBelow(sk.pelvisBasis, p.pelvis), ...[
        sk.L,
        sk.R
    ].flatMap((limb)=>[
            limb.elbow[1] - p.forearmRadius,
            limb.hand[1] - p.handRadius - $a1fb04dc4139ce6e$var$FIST_REACH,
            limb.knee[1] - p.thighRadius,
            limb.heel[1] - p.footRadius,
            limb.toe[1] - p.footRadius
        ]));
const $a1fb04dc4139ce6e$var$READY_SLASH = {
    t: 0,
    armL: [
        (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10),
        (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(18),
        (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30)
    ],
    armR: [
        (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(25),
        (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(14),
        (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(55)
    ],
    feetL: [
        0.6,
        2.6
    ],
    feetR: [
        0.6,
        -2.4
    ]
};
/** A right-handed overhead-to-across strike. Timed like the LPC slash it stands in for (~400ms). */ const $a1fb04dc4139ce6e$var$SLASH_KEYS = [
    $a1fb04dc4139ce6e$var$READY_SLASH,
    {
        t: 0.3,
        rise: -0.4,
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-4),
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-28),
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(25),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(22),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(40)
        ],
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(150),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(70),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(90)
        ],
        feetL: [
            0.6,
            2.6
        ],
        feetR: [
            0.6,
            -2.4
        ]
    },
    {
        t: 0.55,
        rise: -1.4,
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30),
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-20),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(24),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(35)
        ],
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(75),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-25),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(8),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(20)
        ],
        feetL: [
            0.6,
            3.2
        ],
        feetR: [
            0.6,
            -2.8
        ]
    },
    {
        t: 0.75,
        rise: -1.2,
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(14),
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(34),
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-15),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(22),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(35)
        ],
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(15),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-40),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(15),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30)
        ],
        feetL: [
            0.6,
            3.2
        ],
        feetR: [
            0.6,
            -2.8
        ]
    },
    {
        ...$a1fb04dc4139ce6e$var$READY_SLASH,
        t: 1
    }
];
/**
 * LPC's `hurt` row: the knees go, the body folds down over them, pitches forward onto its hands and
 * ends flat on its face toward the camera -- the crown of the head nearest, the back and legs
 * trailing away behind, soles up -- and stays there.
 *
 * Lying truly flat it would be a sliver at this camera (12 degrees down): the fallen body lies on
 * the slope LPC's art implies instead, head down, so its length climbs the frame as depth does.
 * Every key after the first rests the body on whatever of it is lowest (Key.ground): feet, then
 * knees and hands, then face and chest.
 */ const $a1fb04dc4139ce6e$var$FALL_KEYS = [
    {
        t: 0,
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(5),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10)
        ],
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(5),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10)
        ],
        legL: [
            0,
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(3),
            0
        ],
        legR: [
            0,
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(3),
            0
        ]
    },
    // The knees buckle; the head drops.
    {
        t: 0.25,
        ground: 1,
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
        headPitch: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(16),
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(24),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(25)
        ],
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(24),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(25)
        ],
        legL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(40),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(8),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(70)
        ],
        legR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(40),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(8),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(70)
        ]
    },
    // Sunk to a crouch over the knees, hands going down to catch it.
    {
        t: 0.5,
        ground: 1,
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(32),
        headPitch: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(6),
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(40),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(28),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30)
        ],
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(40),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(28),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30)
        ],
        legL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(85),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(125)
        ],
        legR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(85),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(125)
        ]
    },
    // Pitched forward onto the hands: the crown to the camera.
    {
        t: 0.75,
        ground: 1,
        pitch: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(55),
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(18),
        headPitch: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(22),
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(75),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(40),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(35)
        ],
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(75),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(40),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(35)
        ],
        legL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(55),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(100)
        ],
        legR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(55),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(100)
        ]
    },
    // Face down, elbows out and hands by the head, legs splayed behind with the soles up.
    {
        t: 1,
        ground: 1,
        pitch: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(100),
        headPitch: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(8),
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(45),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(70),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(95)
        ],
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(45),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(70),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(95)
        ],
        legL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-6),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(18),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(6)
        ],
        legR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-6),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(18),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(6)
        ]
    }
];
/**
 * A dagger's slash, from any ready stance: the knife drawn back by the right shoulder, then cut
 * across the body at chest height, edge leading, and recovered -- quicker and closer than the axe's
 * overhead chop, which a short blade has no weight for.
 */ const $a1fb04dc4139ce6e$var$daggerSlash = (ready)=>{
    const guard = {
        ...ready,
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(15),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(70),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(80)
        ],
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(25),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(15),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(60)
        ]
    };
    return [
        guard,
        {
            ...guard,
            t: 0.3,
            rise: -0.3,
            lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-2),
            twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-22),
            hips: ready.hips !== undefined ? (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-6) : undefined,
            armR: [
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(60),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(55),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(100),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(70)
            ],
            armL: [
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(18),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(55)
            ]
        },
        {
            ...guard,
            t: 0.55,
            rise: -0.8,
            lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(6),
            twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(24),
            hips: ready.hips !== undefined ? (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(7) : undefined,
            armR: [
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(72),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-35),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(22),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(15)
            ],
            armL: [
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(15),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(20),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(50)
            ]
        },
        {
            ...guard,
            t: 0.75,
            rise: -0.7,
            lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(7),
            twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30),
            hips: ready.hips !== undefined ? (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(8) : undefined,
            armR: [
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(48),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-55),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(38),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(25)
            ],
            armL: [
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(20),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(50)
            ]
        },
        {
            ...guard,
            t: 1
        }
    ];
};
/**
 * A longsword's cut, two-handed: from the guard at the right shoulder with the blade upright, the
 * sword swung back over the shoulder, then cut down and across with both arms driving it and the
 * body turning in behind them, finishing low on the left, and recovered. The left hand's place is
 * on the grip (twoHanded), so only the right arm is keyed.
 */ const $a1fb04dc4139ce6e$var$longswordCut = (ready)=>{
    const turn = (a)=>ready.hips !== undefined ? (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(a) : undefined;
    const guard = {
        ...ready,
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(60),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(25),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(100),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(20)
        ]
    };
    return [
        guard,
        {
            ...guard,
            t: 0.3,
            rise: -0.5,
            lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-4),
            twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-35),
            hips: turn(-10),
            head: turn(-6),
            armR: [
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(130),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(90),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(40)
            ]
        },
        {
            ...guard,
            t: 0.55,
            rise: -1.6,
            lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10),
            twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(28),
            hips: turn(10),
            head: turn(6),
            armR: [
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(85),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-15),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(15),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(0)
            ]
        },
        {
            ...guard,
            t: 0.75,
            rise: -1.4,
            lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
            twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(32),
            hips: turn(12),
            head: turn(6),
            armR: [
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(35),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-30),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(25),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10)
            ]
        },
        {
            ...guard,
            t: 1
        }
    ];
};
/**
 * A saber's cut, one-handed: from a guard with the point up, the blade swung back over the right
 * shoulder, cut down and across the body with the arm straightening behind it, and recovered. The
 * free hand rests on the hip, out of the blade's way (handOnHip).
 */ const $a1fb04dc4139ce6e$var$saberCut = (ready)=>{
    const turn = (a)=>ready.hips !== undefined ? (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(a) : undefined;
    const guard = {
        ...ready,
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(14),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(60),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(45)
        ]
    };
    return [
        guard,
        {
            ...guard,
            t: 0.3,
            rise: -0.3,
            lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-3),
            twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-26),
            hips: turn(-6),
            head: turn(-5),
            armR: [
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(160),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(35),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(50),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(90)
            ]
        },
        {
            ...guard,
            t: 0.55,
            rise: -0.9,
            lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(7),
            twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(24),
            hips: turn(7),
            head: turn(5),
            armR: [
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(80),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-20),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10)
            ]
        },
        {
            ...guard,
            t: 0.75,
            rise: -0.8,
            lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(9),
            twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30),
            hips: turn(8),
            head: turn(5),
            armR: [
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-45),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(15),
                (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(20)
            ]
        },
        {
            ...guard,
            t: 1
        }
    ];
};
/**
 * Put one hand's fist at `fist` (world), the elbow bending toward `pole` (chest frame): the arm
 * reaches for the wrist that leaves the fist there (rig ArmPose.reach), corrected a few times for
 * the fist sitting past the wrist.
 */ const $a1fb04dc4139ce6e$var$placeHand = (pose, p, side, fist, pole)=>{
    const sk = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(pose, p);
    const toChest = (0, $0a4786a5aadc3b7f$export$9cb09a71b7d66923)(sk.torsoBasis);
    const reaching = (wrist)=>{
        const arm = {
            ...pose.arms[side],
            reach: (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(toChest, (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(wrist, sk[side].shoulder)),
            pole: pole
        };
        return {
            ...pose,
            arms: {
                ...pose.arms,
                [side]: arm
            }
        };
    };
    let wrist = fist;
    for(let i = 0; i < 3; i++)wrist = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(wrist, (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(fist, (0, $9311ef6950e6afe4$export$e8bff534353f9c48)((0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(reaching(wrist), p), p, side)));
    return reaching(wrist);
};
/** Both hands on the hilt: the left fist on the grip just behind the right, wherever the right arm is. */ const $a1fb04dc4139ce6e$var$twoHanded = (sample, span = (0, $9311ef6950e6afe4$export$197003423052082))=>(t, p, facing)=>{
        const pose = sample(t, p, facing);
        const sk = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(pose, p);
        const fist = (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)((0, $9311ef6950e6afe4$export$e8bff534353f9c48)(sk, p, "R"), (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $9311ef6950e6afe4$export$b722afcef2c08f75)(sk.R), span(p)));
        return $a1fb04dc4139ce6e$var$placeHand(pose, p, "L", fist, [
            0.7,
            -1,
            -0.2
        ]);
    };
/** How far apart the hands hold a pole or a great axe's haft: wider than a sword's grip. */ const $a1fb04dc4139ce6e$var$poleSpan = (p)=>p.handRadius * 3.2;
/**
 * Facing the camera: from the guard, back over the right shoulder, over the head, then down in
 * front of the body to the left, blade forward and down at the hit, and low on the left after.
 */ const $a1fb04dc4139ce6e$var$LONGSWORD_TO_CAMERA = [
    {
        t: 0,
        fist: [
            0.03,
            0.28,
            0.54
        ],
        blade: [
            0.05,
            1,
            0
        ]
    },
    {
        t: 0.3,
        fist: [
            -0.3,
            0.55,
            0.05
        ],
        blade: [
            -0.45,
            0.55,
            -0.7
        ]
    },
    {
        t: 0.43,
        fist: [
            -0.12,
            0.5,
            0.4
        ],
        blade: [
            -0.1,
            0.95,
            0.3
        ]
    },
    {
        t: 0.55,
        fist: [
            0.08,
            -0.05,
            0.65
        ],
        blade: [
            0.3,
            -0.65,
            0.7
        ]
    },
    {
        t: 0.75,
        fist: [
            0.28,
            -0.45,
            0.3
        ],
        blade: [
            0.45,
            -0.85,
            0.25
        ]
    },
    {
        t: 1,
        fist: [
            0.03,
            0.28,
            0.54
        ],
        blade: [
            0.05,
            1,
            0
        ]
    }
];
/** The saber's, one-handed: the guard out ahead, point up, and a longer reach at the hit. */ const $a1fb04dc4139ce6e$var$SABER_TO_CAMERA = [
    {
        t: 0,
        fist: [
            -0.12,
            0.05,
            0.55
        ],
        blade: [
            0.05,
            0.75,
            0.65
        ]
    },
    {
        t: 0.3,
        fist: [
            -0.32,
            0.55,
            0.05
        ],
        blade: [
            -0.4,
            0.5,
            -0.75
        ]
    },
    {
        t: 0.43,
        fist: [
            -0.15,
            0.45,
            0.42
        ],
        blade: [
            -0.15,
            0.95,
            0.25
        ]
    },
    {
        t: 0.55,
        fist: [
            0.02,
            -0.05,
            0.68
        ],
        blade: [
            0.3,
            -0.6,
            0.72
        ]
    },
    {
        t: 0.75,
        fist: [
            0.26,
            -0.42,
            0.32
        ],
        blade: [
            0.5,
            -0.8,
            0.3
        ]
    },
    {
        t: 1,
        fist: [
            -0.12,
            0.05,
            0.55
        ],
        blade: [
            0.05,
            0.75,
            0.65
        ]
    }
];
/**
 * A sword's cut by facing. Side-on it lands level, straight ahead, across the view: keyed angles.
 * Facing the camera (or away from it) a level cut points straight at the viewer and vanishes on
 * the very frame it lands, and one swept sideways reads as striking at something beside him; there
 * it comes DOWN in front of the body on a diagonal from over the right shoulder, as LPC's
 * front-facing slash does. The body turns as side-on; the hand is placed (`toCamera`), since an
 * arm raised past level abducts toward the midline and keyed angles fought the shape.
 */ const $a1fb04dc4139ce6e$var$swordCut = (keys, toCamera)=>{
    const level = $a1fb04dc4139ce6e$var$sampleKeys(keys);
    return (t, p, facing)=>{
        const pose = level(t, p);
        if (facing !== "front" && facing !== "back") return pose;
        let i = 0;
        while(i < toCamera.length - 2 && t > toCamera[i + 1].t)i++;
        const a = toCamera[i], b = toCamera[i + 1];
        const u = (0, $0a4786a5aadc3b7f$export$b0f87bb1f6530fd8)(b.t > a.t ? (t - a.t) / (b.t - a.t) : 0);
        const sk = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(pose, p);
        const fist = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(sk.chest, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)($a1fb04dc4139ce6e$var$lerp3(a.fist, b.fist, u), p.upperArm + p.forearm));
        const grip = (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)((0, $0a4786a5aadc3b7f$export$9cb09a71b7d66923)(sk.torsoBasis), $a1fb04dc4139ce6e$var$unit($a1fb04dc4139ce6e$var$lerp3($a1fb04dc4139ce6e$var$unit(a.blade), $a1fb04dc4139ce6e$var$unit(b.blade), u)));
        const holding = {
            ...pose,
            arms: {
                ...pose.arms,
                R: {
                    ...pose.arms.R,
                    grip: grip
                }
            }
        };
        return $a1fb04dc4139ce6e$var$placeHand(holding, p, "R", fist, [
            -1,
            -0.5,
            -0.2
        ]);
    };
};
/** The left fist on the hip's crest, the elbow out to the side and back. */ const $a1fb04dc4139ce6e$var$handOnHip = (sample)=>(t, p, facing)=>{
        const pose = sample(t, p, facing);
        const sk = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(pose, p);
        const crest = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(sk.pelvis, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(sk.pelvisBasis, [
            p.pelvis[0] + p.handRadius * 0.6,
            p.pelvis[1] * 0.3,
            -0.5
        ]));
        return $a1fb04dc4139ce6e$var$placeHand(pose, p, "L", crest, [
            1,
            0.1,
            -0.7
        ]);
    };
const $a1fb04dc4139ce6e$var$SHOT_KEYS = [
    {
        t: 0,
        chest: 0,
        hips: 0,
        lean: 0,
        rise: 0,
        bow: "rest",
        hand: "rest",
        draw: 0,
        feet: 0
    },
    {
        t: 0.18,
        chest: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-55),
        hips: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-35),
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(2),
        rise: -0.4,
        bow: "raise",
        hand: "nock",
        draw: 0.05,
        feet: 1
    },
    {
        t: 0.4,
        chest: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-72),
        hips: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-45),
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(3),
        rise: -0.6,
        bow: "aim",
        hand: "anchor",
        draw: 1,
        feet: 1
    },
    {
        t: 0.5,
        chest: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-72),
        hips: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-45),
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(3),
        rise: -0.6,
        bow: "aim",
        hand: "anchor",
        draw: 1,
        feet: 1
    },
    {
        t: 0.56,
        chest: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-74),
        hips: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-45),
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(3),
        rise: -0.6,
        bow: "aim",
        hand: "loose",
        draw: 0,
        feet: 1
    },
    {
        t: 0.74,
        chest: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-70),
        hips: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-45),
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(2),
        rise: -0.5,
        bow: "follow",
        hand: "loose",
        draw: 0,
        feet: 1
    },
    {
        t: 1,
        chest: 0,
        hips: 0,
        lean: 0,
        rise: 0,
        bow: "rest",
        hand: "rest",
        draw: 0,
        feet: 0
    }
];
const $a1fb04dc4139ce6e$var$lerp3 = (a, b, u)=>[
        a[0] + (b[0] - a[0]) * u,
        a[1] + (b[1] - a[1]) * u,
        a[2] + (b[2] - a[2]) * u
    ];
const $a1fb04dc4139ce6e$var$unit = (v)=>{
    const l = Math.hypot(v[0], v[1], v[2]) || 1;
    return [
        v[0] / l,
        v[1] / l,
        v[2] / l
    ];
};
/** Lower the pelvis until every planted foot is in reach from where the hips now are. */ const $a1fb04dc4139ce6e$var$grounded = (pose, p)=>{
    const sk = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(pose, p);
    let height = pose.root[1];
    for (const side of [
        "L",
        "R"
    ]){
        const leg = pose.legs[side];
        if (leg.mode === "ik" && leg.planted) height = Math.min(height, (0, $16b5b2e1f0b8662b$export$f8a8a1c830424ad0)(leg.ankle, [
            sk[side].hip[0],
            sk[side].hip[2]
        ], p));
    }
    return {
        ...pose,
        root: [
            pose.root[0],
            height,
            pose.root[2]
        ]
    };
};
const $a1fb04dc4139ce6e$var$sampleBowShot = (stance)=>(t, p, facing)=>{
        const rest = (0, $16b5b2e1f0b8662b$export$a021dd78582c0634)(p, facing);
        const still = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(rest, p);
        const arm = p.upperArm + p.forearm;
        const shoulderL = [
            p.shoulderWidth,
            p.shoulderHeight,
            0
        ];
        const shoulderR = [
            -p.shoulderWidth,
            p.shoulderHeight,
            0
        ];
        // Where a hand is, from its shoulder, in the chest's frame -- for a chest turned `chest` from the feet.
        const place = (k)=>{
            const target = [
                -Math.sin(k.chest),
                0,
                Math.cos(k.chest)
            ];
            const rightOfFace = [
                -target[2],
                0,
                target[0]
            ];
            const chin = p.neck + p.headCenter - p.head[1] * 0.75;
            const anchor = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)([
                0,
                chin,
                0
            ], (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(target, 1.0)), (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(rightOfFace, 1.4));
            const level = Math.min(0.9, (chin - p.shoulderHeight) / (arm * 0.95));
            const aimDir = $a1fb04dc4139ce6e$var$unit((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)((0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(target, Math.sqrt(1 - level * level)), [
                0,
                level,
                0
            ]));
            const bowHand = {
                rest: (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(still.L.hand, (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(still.chest, shoulderL)),
                raise: (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)($a1fb04dc4139ce6e$var$unit((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)((0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(target, 0.85), [
                    0,
                    -0.25,
                    0
                ])), arm * 0.75),
                aim: (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(aimDir, arm * 0.95),
                follow: (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)($a1fb04dc4139ce6e$var$unit((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(aimDir, [
                    0,
                    -0.12,
                    0
                ])), arm * 0.94)
            };
            const bowAt = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(shoulderL, bowHand[k.bow]);
            const drawHand = {
                rest: (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(still.R.hand, (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(still.chest, shoulderR)),
                nock: (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(bowAt, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(target, -3)), shoulderR),
                anchor: (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(anchor, shoulderR),
                loose: (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(anchor, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(target, -3)), (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(rightOfFace, 0.6)), shoulderR)
            };
            const restPole = (side)=>$a1fb04dc4139ce6e$var$unit((0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(still[side].elbow, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(still[side].shoulder, still[side].hand), 0.5)));
            return {
                bow: bowHand[k.bow],
                hand: drawHand[k.hand],
                bowPole: k.bow === "rest" ? restPole("L") : $a1fb04dc4139ce6e$var$unit((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)((0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(target, -0.2), [
                    0,
                    -1,
                    0
                ])),
                handPole: k.hand === "rest" ? restPole("R") : $a1fb04dc4139ce6e$var$unit((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)((0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(target, -1), [
                    0,
                    0.6,
                    0
                ]), (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(rightOfFace, 0.5))),
                grip: k.bow === "rest" ? still.L.grip : $a1fb04dc4139ce6e$var$unit((0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)([
                    0,
                    1,
                    0
                ], (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(rightOfFace, 0.15)))
            };
        };
        let i = 0;
        while(i < $a1fb04dc4139ce6e$var$SHOT_KEYS.length - 2 && t > $a1fb04dc4139ce6e$var$SHOT_KEYS[i + 1].t)i++;
        const a = $a1fb04dc4139ce6e$var$SHOT_KEYS[i], b = $a1fb04dc4139ce6e$var$SHOT_KEYS[i + 1];
        const u = (0, $0a4786a5aadc3b7f$export$b0f87bb1f6530fd8)(b.t > a.t ? (t - a.t) / (b.t - a.t) : 0);
        const A = place(a), B = place(b);
        const chest = $a1fb04dc4139ce6e$var$mix(a.chest, b.chest, u), hips = $a1fb04dc4139ce6e$var$mix(a.hips, b.hips, u);
        // Chest at `chest`, pelvis at `hips` (see sampleKeys).
        const twist = (chest - hips) / (1 + (0, $16b5b2e1f0b8662b$export$b6e2d34de6c0868f));
        const yaw = hips + (0, $16b5b2e1f0b8662b$export$b6e2d34de6c0868f) * twist;
        const feet = $a1fb04dc4139ce6e$var$mix(a.feet, b.feet, u);
        const foot = (side, z)=>{
            const r = rest.legs[side];
            return {
                ...r,
                ankle: [
                    r.ankle[0],
                    r.ankle[1],
                    r.ankle[2] * (1 - feet) + z * feet
                ],
                planted: true
            };
        };
        return $a1fb04dc4139ce6e$var$grounded({
            ...rest,
            root: [
                rest.root[0],
                rest.root[1] + $a1fb04dc4139ce6e$var$mix(a.rise, b.rise, u),
                rest.root[2]
            ],
            rootRotation: (0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)(yaw),
            twist: twist,
            lean: $a1fb04dc4139ce6e$var$mix(a.lean, b.lean, u),
            // Eyes on the target throughout.
            headYaw: -yaw - 0.4 * twist,
            headPitch: 0,
            arms: {
                L: {
                    ...rest.arms.L,
                    reach: $a1fb04dc4139ce6e$var$lerp3(A.bow, B.bow, u),
                    pole: $a1fb04dc4139ce6e$var$unit($a1fb04dc4139ce6e$var$lerp3(A.bowPole, B.bowPole, u)),
                    grip: $a1fb04dc4139ce6e$var$unit($a1fb04dc4139ce6e$var$lerp3(A.grip, B.grip, u))
                },
                R: {
                    ...rest.arms.R,
                    reach: $a1fb04dc4139ce6e$var$lerp3(A.hand, B.hand, u),
                    pole: $a1fb04dc4139ce6e$var$unit($a1fb04dc4139ce6e$var$lerp3(A.handPole, B.handPole, u))
                }
            },
            legs: {
                L: foot("L", stance * (0, $16b5b2e1f0b8662b$export$eac172ae96bff3b0)(p)),
                R: foot("R", -stance * (0, $16b5b2e1f0b8662b$export$eac172ae96bff3b0)(p))
            },
            draw: $a1fb04dc4139ce6e$var$mix(a.draw, b.draw, u)
        }, p);
    };
/** A real body's ready stance: feet staggered under the hips, hands up a little. */ const $a1fb04dc4139ce6e$var$READY_NATURAL = {
    t: 0,
    twist: 0,
    hips: 0,
    head: 0,
    armL: [
        (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10),
        (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(14),
        (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(25)
    ],
    armR: [
        (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(20),
        (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
        (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(45)
    ],
    feetL: [
        0.8,
        5.5
    ],
    feetR: [
        0.8,
        -4.5
    ]
};
/**
 * The same right-handed overhead-to-across strike for a body at real proportions: the feet stay
 * put, the hips turn only a little and WITH the blow, and the chest and arm do the work -- the
 * shared slash's pelvis counter-swing reads as the hips swaying on a long-legged body.
 */ const $a1fb04dc4139ce6e$var$NATURAL_SLASH_KEYS = [
    $a1fb04dc4139ce6e$var$READY_NATURAL,
    {
        ...$a1fb04dc4139ce6e$var$READY_NATURAL,
        t: 0.3,
        rise: -0.5,
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-2),
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-26),
        hips: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-8),
        head: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-6),
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(25),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(18),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(35)
        ],
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(150),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(28),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(70),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(90)
        ]
    },
    {
        ...$a1fb04dc4139ce6e$var$READY_NATURAL,
        t: 0.55,
        rise: -1.3,
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(8),
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(26),
        hips: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(8),
        head: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(6),
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-18),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(20),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30)
        ],
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(75),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-25),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(8),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(20)
        ]
    },
    {
        ...$a1fb04dc4139ce6e$var$READY_NATURAL,
        t: 0.75,
        rise: -1.1,
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10),
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30),
        hips: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(9),
        head: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(6),
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-14),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(18),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30)
        ],
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(15),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-40),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(15),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(30)
        ]
    },
    {
        ...$a1fb04dc4139ce6e$var$READY_NATURAL,
        t: 1
    }
];
/**
 * A spell cast: the hands brought together before the chest, then raised high and held there --
 * LPC's spellcast row, which the game holds on its last frame while the spell lasts.
 */ const $a1fb04dc4139ce6e$var$castKeys = (ready)=>{
    const before = {
        ...ready,
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(70),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-8),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(45)
        ],
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(70),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-8),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(45)
        ]
    };
    const raised = {
        ...ready,
        armL: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(150),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(15)
        ],
        armR: [
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(150),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
            (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(15)
        ],
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-4)
    };
    return [
        ready,
        {
            ...before,
            t: 0.35
        },
        {
            ...raised,
            t: 0.75
        },
        {
            ...raised,
            t: 1
        }
    ];
};
const $a1fb04dc4139ce6e$export$bb1c792c61cf6dee = (clip)=>({
        ...clip,
        sample: (t, p, facing)=>{
            const pose = clip.sample(t, p, facing);
            const sk = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(pose, p);
            const toChest = (0, $0a4786a5aadc3b7f$export$9cb09a71b7d66923)(sk.torsoBasis);
            const R = sk.R;
            const bend = $a1fb04dc4139ce6e$var$unit((0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(R.elbow, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(R.shoulder, R.hand), 0.5)));
            const arm = {
                ...pose.arms.R,
                reach: (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(toChest, (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(R.hand, R.shoulder)),
                pole: (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(bend, bend) > 0.5 ? (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(toChest, bend) : [
                    -0.3,
                    0,
                    -1
                ],
                grip: [
                    0,
                    1,
                    0.12
                ]
            };
            return {
                ...pose,
                arms: {
                    ...pose.arms,
                    R: arm
                }
            };
        }
    });
const $a1fb04dc4139ce6e$export$76d5823997123dfb = (clip, hold, open)=>({
        ...clip,
        sample: (t, p, facing)=>{
            const pose = clip.sample(t, p, facing);
            const arm = (side)=>{
                const a = pose.arms[side];
                if (a.reach) return a;
                const held = side === "R" && hold;
                return {
                    ...a,
                    ...held && hold.wrist !== undefined ? {
                        wrist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(hold.wrist)
                    } : {},
                    ...held && hold.out !== undefined ? {
                        out: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(hold.out)
                    } : {},
                    ...open.includes(side) ? {
                        open: true
                    } : {}
                };
            };
            return {
                ...pose,
                arms: {
                    L: arm("L"),
                    R: arm("R")
                }
            };
        }
    });
const $a1fb04dc4139ce6e$export$78ecae501ab7f21c = [
    "idle",
    "walk",
    "run"
];
const $a1fb04dc4139ce6e$export$ebfd3f7c9b179305 = (clip)=>({
        ...clip,
        sample: (t, p, facing)=>{
            const base = clip.sample(t, p, facing);
            let pose = {
                ...base,
                lean: base.lean - (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(3)
            };
            const sk = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(pose, p);
            const hand = (side)=>(0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(sk.chest, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(sk.torsoBasis, [
                    (0, $16b5b2e1f0b8662b$export$4afae6b5c61ab836)(side) * p.shoulderWidth * 0.5,
                    -p.spine * 0.6,
                    p.torso[2] + p.handRadius + 1.5
                ]));
            pose = $a1fb04dc4139ce6e$var$placeHand(pose, p, "L", hand("L"), [
                1,
                -0.8,
                -0.5
            ]);
            return $a1fb04dc4139ce6e$var$placeHand(pose, p, "R", hand("R"), [
                -1,
                -0.8,
                -0.5
            ]);
        }
    });
/**
 * A two-handed thrust (LPC's `thrust` row, the spear's and the staff's): the shaft held low across
 * the body in both hands, the right behind, drawn back, driven forward on a lean and a turn of the
 * shoulders, and recovered -- the feet staggered, the left ahead. The front hand rides the shaft
 * `span` ahead of the rear one.
 */ const $a1fb04dc4139ce6e$var$sampleThrust = (keys, span, frontHand = ()=>[
        0,
        0,
        0
    ])=>(t, p, facing)=>{
        let i = 0;
        while(i < keys.length - 2 && t > keys[i + 1].t)i++;
        const a = keys[i], b = keys[i + 1];
        const u = (0, $0a4786a5aadc3b7f$export$b0f87bb1f6530fd8)(b.t > a.t ? (t - a.t) / (b.t - a.t) : 0);
        const rest = (0, $16b5b2e1f0b8662b$export$a021dd78582c0634)(p, facing);
        const stagger = (0, $16b5b2e1f0b8662b$export$eac172ae96bff3b0)(p) * 0.12;
        const foot = (side, z)=>{
            const r = rest.legs[side];
            return {
                ...r,
                ankle: [
                    r.ankle[0],
                    r.ankle[1],
                    z
                ],
                planted: true
            };
        };
        let pose = $a1fb04dc4139ce6e$var$grounded({
            ...rest,
            lean: $a1fb04dc4139ce6e$var$mix(a.lean, b.lean, u),
            twist: $a1fb04dc4139ce6e$var$mix(a.twist, b.twist, u),
            legs: {
                L: foot("L", stagger),
                R: foot("R", -stagger)
            }
        }, p);
        const sk = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(pose, p);
        const aim = $a1fb04dc4139ce6e$var$unit($a1fb04dc4139ce6e$var$lerp3(a.aim, b.aim, u));
        const fist = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(sk.chest, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(sk.torsoBasis, $a1fb04dc4139ce6e$var$lerp3(a.fist(p), b.fist(p), u)));
        const shaft = (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(sk.torsoBasis, aim);
        pose = {
            ...pose,
            arms: {
                ...pose.arms,
                R: {
                    ...pose.arms.R,
                    grip: aim
                }
            }
        };
        pose = $a1fb04dc4139ce6e$var$placeHand(pose, p, "R", fist, [
            -0.6,
            -1,
            -0.3
        ]);
        const front = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(fist, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(shaft, span(p))), (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(sk.torsoBasis, frontHand(p)));
        return $a1fb04dc4139ce6e$var$placeHand(pose, p, "L", front, [
            0.6,
            -1,
            -0.2
        ]);
    };
const $a1fb04dc4139ce6e$var$SPEAR_THRUST = [
    {
        t: 0,
        fist: (p)=>[
                -p.shoulderWidth * 0.7,
                -p.spine * 0.55,
                p.torso[2] * 0.6
            ],
        aim: [
            0.3,
            0.3,
            1
        ],
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(2),
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-8)
    },
    {
        t: 0.35,
        fist: (p)=>[
                -p.shoulderWidth * 0.85,
                -p.spine * 0.45,
                -p.torso[2] * 0.3
            ],
        aim: [
            0.25,
            0.15,
            1
        ],
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-2),
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-18)
    },
    // (Aimed up a little: the lean and a side facing's turn toward the camera both tip it down on screen.)
    {
        t: 0.6,
        fist: (p)=>[
                -p.shoulderWidth * 0.35,
                -p.spine * 0.3,
                p.torso[2] + (p.upperArm + p.forearm) * 0.3
            ],
        aim: [
            0.12,
            0.3,
            1
        ],
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10),
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(16)
    },
    {
        t: 1,
        fist: (p)=>[
                -p.shoulderWidth * 0.7,
                -p.spine * 0.55,
                p.torso[2] * 0.6
            ],
        aim: [
            0.3,
            0.3,
            1
        ],
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(2),
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-8)
    }
];
/**
 * The crossbow's `thrust` (LPC fires it on that row): raised from the hip to the shoulder, the stock
 * along the line of sight, loosed just past halfway with a kick up, and lowered. The left hand
 * cradles the stock under its front.
 */ const $a1fb04dc4139ce6e$var$CROSSBOW_SHOT = [
    {
        t: 0,
        fist: (p)=>[
                -p.shoulderWidth * 0.6,
                -p.spine * 0.5,
                p.torso[2] * 0.7
            ],
        aim: [
            0.1,
            -0.35,
            1
        ],
        lean: 0,
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-6)
    },
    {
        t: 0.35,
        fist: (p)=>[
                -p.shoulderWidth * 0.5,
                p.shoulderHeight + 0.5,
                p.torso[2] + 1.5
            ],
        aim: [
            0.05,
            0.02,
            1
        ],
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-2),
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-10)
    },
    {
        t: 0.55,
        fist: (p)=>[
                -p.shoulderWidth * 0.5,
                p.shoulderHeight + 0.5,
                p.torso[2] + 1.5
            ],
        aim: [
            0.05,
            0.02,
            1
        ],
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-2),
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-10)
    },
    {
        t: 0.7,
        fist: (p)=>[
                -p.shoulderWidth * 0.5,
                p.shoulderHeight + 1.3,
                p.torso[2] + 0.6
            ],
        aim: [
            0.05,
            0.18,
            1
        ],
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-4),
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-10)
    },
    {
        t: 1,
        fist: (p)=>[
                -p.shoulderWidth * 0.6,
                -p.spine * 0.5,
                p.torso[2] * 0.7
            ],
        aim: [
            0.1,
            -0.35,
            1
        ],
        lean: 0,
        twist: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-6)
    }
];
const $a1fb04dc4139ce6e$var$crossbowCradle = (p)=>[
        0,
        -p.handRadius * 1.1,
        0
    ];
/** Thrusts and two-handed swings for the game's other weapons, by `<action>:<held>` (planEmberAnimation). */ const $a1fb04dc4139ce6e$var$weaponClips = (slash)=>{
    const twoHandedSlash = (held)=>({
            name: "slash",
            frames: 10,
            frameMs: 40,
            loop: false,
            sample: $a1fb04dc4139ce6e$var$twoHanded($a1fb04dc4139ce6e$var$sampleKeys(slash), $a1fb04dc4139ce6e$var$poleSpan)
        });
    const thrust = {
        name: "thrust",
        frames: 10,
        frameMs: 40,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$sampleThrust($a1fb04dc4139ce6e$var$SPEAR_THRUST, $a1fb04dc4139ce6e$var$poleSpan)
    };
    return {
        "slash:waraxe": twoHandedSlash("waraxe"),
        "slash:halberd": twoHandedSlash("halberd"),
        "slash:scythe": twoHandedSlash("scythe"),
        "thrust:spear": thrust,
        "thrust:staff": thrust,
        "thrust:crossbow": {
            name: "thrust",
            frames: 10,
            frameMs: 40,
            loop: false,
            sample: $a1fb04dc4139ce6e$var$sampleThrust($a1fb04dc4139ce6e$var$CROSSBOW_SHOT, (p)=>(0, $16b5b2e1f0b8662b$export$eac172ae96bff3b0)(p) * 0.3, $a1fb04dc4139ce6e$var$crossbowCradle)
        }
    };
};
const $a1fb04dc4139ce6e$export$dcda7fcef050bc34 = {
    walk: {
        name: "walk",
        frames: 16,
        frameMs: 60,
        loop: true,
        strideFor: (p)=>$a1fb04dc4139ce6e$var$NATURAL_WALK.cycle * (0, $16b5b2e1f0b8662b$export$eac172ae96bff3b0)(p),
        sample: $a1fb04dc4139ce6e$var$sampleStride($a1fb04dc4139ce6e$var$NATURAL_WALK)
    },
    run: {
        name: "run",
        frames: 12,
        frameMs: 50,
        loop: true,
        strideFor: (p)=>$a1fb04dc4139ce6e$var$NATURAL_RUN.cycle * (0, $16b5b2e1f0b8662b$export$eac172ae96bff3b0)(p),
        sample: $a1fb04dc4139ce6e$var$sampleStride($a1fb04dc4139ce6e$var$NATURAL_RUN)
    },
    slash: {
        name: "slash",
        frames: 10,
        frameMs: 40,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$sampleKeys($a1fb04dc4139ce6e$var$NATURAL_SLASH_KEYS)
    },
    "slash:dagger": {
        name: "slash",
        frames: 10,
        frameMs: 40,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$sampleKeys($a1fb04dc4139ce6e$var$daggerSlash($a1fb04dc4139ce6e$var$READY_NATURAL))
    },
    "shoot:bow": {
        name: "shoot",
        frames: 14,
        frameMs: 60,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$sampleBowShot(0.16)
    },
    cast: {
        name: "cast",
        frames: 7,
        frameMs: 90,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$sampleKeys($a1fb04dc4139ce6e$var$castKeys($a1fb04dc4139ce6e$var$READY_NATURAL))
    },
    "slash:longsword": {
        name: "slash",
        frames: 10,
        frameMs: 40,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$twoHanded($a1fb04dc4139ce6e$var$swordCut($a1fb04dc4139ce6e$var$longswordCut($a1fb04dc4139ce6e$var$READY_NATURAL), $a1fb04dc4139ce6e$var$LONGSWORD_TO_CAMERA))
    },
    "slash:saber": {
        name: "slash",
        frames: 10,
        frameMs: 40,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$handOnHip($a1fb04dc4139ce6e$var$swordCut($a1fb04dc4139ce6e$var$saberCut($a1fb04dc4139ce6e$var$READY_NATURAL), $a1fb04dc4139ce6e$var$SABER_TO_CAMERA))
    },
    // A rapier cuts as the saber does (the game slashes with it), one-handed, the free hand on the hip.
    "slash:rapier": {
        name: "slash",
        frames: 10,
        frameMs: 40,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$handOnHip($a1fb04dc4139ce6e$var$swordCut($a1fb04dc4139ce6e$var$saberCut($a1fb04dc4139ce6e$var$READY_NATURAL), $a1fb04dc4139ce6e$var$SABER_TO_CAMERA))
    },
    ...$a1fb04dc4139ce6e$var$weaponClips($a1fb04dc4139ce6e$var$NATURAL_SLASH_KEYS)
};
const $a1fb04dc4139ce6e$export$a42c91d6bfd37b7c = (clip, reaching)=>({
        ...clip,
        sample: (t, p, facing)=>{
            const pose = clip.sample(t, p, facing);
            const hunched = {
                ...pose,
                lean: pose.lean + (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(14),
                headPitch: pose.headPitch + (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
                sideBend: pose.sideBend + (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(3)
            };
            if (!reaching) return hunched;
            const sway = Math.sin(t * Math.PI * 2);
            // Level with the shoulders in the world: the hunch tips the chest -- and arms -- forward and down.
            const reach = (phase)=>({
                    pitch: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(100 + 6 * phase),
                    abduct: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10),
                    flex: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(10 - 4 * phase)
                });
            return {
                ...hunched,
                arms: {
                    L: reach(sway),
                    R: reach(-sway)
                }
            };
        }
    });
const $a1fb04dc4139ce6e$export$cd8e116089089e72 = (clip, raised)=>({
        ...clip,
        sample: (t, p, facing)=>{
            const pose = clip.sample(t, p, facing);
            const own = pose.arms.L;
            const swing = raised || own.reach ? 0 : (own.pitch - 0.05) * 0.3;
            const L = raised ? {
                pitch: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(42),
                abduct: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(12),
                flex: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(78)
            } : {
                pitch: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(8) + swing,
                abduct: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(14),
                flex: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(84)
            };
            return {
                ...pose,
                arms: {
                    ...pose.arms,
                    L: L
                }
            };
        }
    });
const $a1fb04dc4139ce6e$export$6f98ea285f26c534 = (upper, lower, phase, cycles)=>({
        name: `${upper.name}.${lower.name}`,
        frames: upper.frames,
        frameMs: upper.frameMs,
        loop: false,
        sample: (t, p, facing)=>{
            const top = upper.sample(t, p, facing);
            const gait = lower.sample(((phase + t * cycles) % 1 + 1) % 1, p, facing);
            const pose = {
                ...gait,
                rootRotation: top.rootRotation,
                lean: gait.lean + top.lean,
                twist: top.twist,
                headPitch: top.headPitch,
                headYaw: top.headYaw,
                arms: top.arms,
                draw: top.draw
            };
            // The attack turns the hips: a standing foot must still be reached from where they now are.
            const sk = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(pose, p);
            let height = pose.root[1];
            for (const side of [
                "L",
                "R"
            ]){
                const leg = pose.legs[side];
                if (leg.mode === "ik" && leg.planted) height = Math.min(height, (0, $16b5b2e1f0b8662b$export$f8a8a1c830424ad0)(leg.ankle, [
                    sk[side].hip[0],
                    sk[side].hip[2]
                ], p));
            }
            return {
                ...pose,
                root: [
                    pose.root[0],
                    height,
                    pose.root[2]
                ]
            };
        }
    });
const $a1fb04dc4139ce6e$export$74c5c56919281479 = 8;
const $a1fb04dc4139ce6e$export$6858458e4384d51e = 2 * $a1fb04dc4139ce6e$export$74c5c56919281479;
/**
 * Up a ladder, facing it: the left hand and right foot go up two rungs together, then the right hand
 * and left foot, the body rising a rung a step. The body's height is the sprite's to move -- the
 * client raises it as the stair travel climbs, a cycle per CLIMB_RISE -- so a hand or foot holding
 * a rung slides down the body as it rises, staying put on the ladder, and the moving one overtakes
 * it. Played backwards, it climbs down.
 */ const $a1fb04dc4139ce6e$var$sampleClimb = (t, p)=>{
    // How far above its lowest a limb is, in the body's frame, for one whose move starts at `start`:
    // carried up two rungs ahead of the body in half a cycle, then held while the body catches up.
    const lift = (start)=>{
        const u = ((t - start) % 1 + 1) % 1;
        return u < 0.5 ? $a1fb04dc4139ce6e$export$6858458e4384d51e * ((0, $0a4786a5aadc3b7f$export$4053e36566dd3d9a)(u * 2) - u) : $a1fb04dc4139ce6e$export$6858458e4384d51e * (1 - u);
    };
    const rest = (0, $16b5b2e1f0b8662b$export$a021dd78582c0634)(p, "back");
    const foot = (side, start)=>({
            mode: "ik",
            ankle: [
                (0, $16b5b2e1f0b8662b$export$4afae6b5c61ab836)(side) * (p.hipWidth + 0.4),
                p.ankleHeight + lift(start),
                p.footLength * 0.45
            ],
            footPitch: 0.15
        });
    const leaning = {
        ...rest,
        root: [
            0,
            (0, $16b5b2e1f0b8662b$export$29183f5ae8d826bb)(p) - 1.4,
            0
        ],
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(6),
        headPitch: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-12),
        legs: {
            L: foot("L", 0.5),
            R: foot("R", 0)
        }
    };
    // Each hand on a rung just inside the rails, ahead of the chest: the higher one reaching over the
    // head, the lower by the ear.
    const sk = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(leaning, p);
    const grip = (side, start)=>[
            (0, $16b5b2e1f0b8662b$export$4afae6b5c61ab836)(side) * (p.shoulderWidth + 1.2),
            sk.head[1] + p.head[1] + 3 - $a1fb04dc4139ce6e$export$74c5c56919281479 + lift(start),
            p.torso[2] + 2.5
        ];
    const elbowOut = (side)=>[
            (0, $16b5b2e1f0b8662b$export$4afae6b5c61ab836)(side),
            -0.6,
            -0.4
        ];
    const left = $a1fb04dc4139ce6e$var$placeHand(leaning, p, "L", grip("L", 0), elbowOut("L"));
    return $a1fb04dc4139ce6e$var$placeHand(left, p, "R", grip("R", 0.5), elbowOut("R"));
};
/** Turn `a` toward `b` (both unit) by the share `u` of the angle between them. */ const $a1fb04dc4139ce6e$var$slerp = (a, b, u)=>{
    const angle = Math.acos(Math.max(-1, Math.min(1, (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(a, b))));
    if (angle < 1e-4) return b;
    const s = Math.sin(angle);
    return $a1fb04dc4139ce6e$var$unit((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)((0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(a, Math.sin((1 - u) * angle) / s), (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(b, Math.sin(u * angle) / s)));
};
/** Where a falling body's hands go: from the shoulder, in the chest's frame (+x the body's left), and the elbow's give. */ const $a1fb04dc4139ce6e$var$FALLING_HAND = [
    0.5,
    0.86,
    0.12
];
const $a1fb04dc4139ce6e$var$FALLING_POLE = [
    0.9,
    -0.1,
    -0.6
];
const $a1fb04dc4139ce6e$var$FALLING_REACH = 0.985;
/**
 * In the air -- knocked off a ladder, stepped off a roof, dropped through a floor: the arms fly up
 * over the head and out, the elbows giving a little, the legs hanging loose with the toes down and
 * the head tipped back, and held there until the body lands. It sets out from the body's own
 * standing pose in its facing, so played backwards -- the recovery -- the hands come back down to
 * exactly where idle has them.
 */ const $a1fb04dc4139ce6e$var$sampleFalling = (t, p, facing)=>{
    const rest = (0, $16b5b2e1f0b8662b$export$a021dd78582c0634)(p, facing);
    if (t <= 0) return rest;
    const u = (0, $0a4786a5aadc3b7f$export$b0f87bb1f6530fd8)(t);
    const pose = {
        ...rest,
        lean: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-4) * u,
        headPitch: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(-10) * u
    };
    const still = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(rest, p);
    const toChest = (0, $0a4786a5aadc3b7f$export$9cb09a71b7d66923)(still.torsoBasis);
    const arm = p.upperArm + p.forearm;
    const raise = (side)=>{
        const s = (0, $16b5b2e1f0b8662b$export$4afae6b5c61ab836)(side);
        const from = (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(toChest, (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(still[side].hand, still[side].shoulder));
        const length = Math.hypot(from[0], from[1], from[2]);
        const to = $a1fb04dc4139ce6e$var$unit([
            s * $a1fb04dc4139ce6e$var$FALLING_HAND[0],
            $a1fb04dc4139ce6e$var$FALLING_HAND[1],
            $a1fb04dc4139ce6e$var$FALLING_HAND[2]
        ]);
        const bend = $a1fb04dc4139ce6e$var$unit((0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(still[side].elbow, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(still[side].shoulder, still[side].hand), 0.5)));
        const restPole = (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(toChest, bend);
        const pole = $a1fb04dc4139ce6e$var$unit($a1fb04dc4139ce6e$var$lerp3(restPole, [
            s * $a1fb04dc4139ce6e$var$FALLING_POLE[0],
            $a1fb04dc4139ce6e$var$FALLING_POLE[1],
            $a1fb04dc4139ce6e$var$FALLING_POLE[2]
        ], u));
        return {
            ...rest.arms[side],
            reach: (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)($a1fb04dc4139ce6e$var$slerp($a1fb04dc4139ce6e$var$unit(from), to, u), length + (arm * $a1fb04dc4139ce6e$var$FALLING_REACH - length) * u),
            pole: pole
        };
    };
    // The legs dangle: each ankle drawn up a little under its knee, the left more, toes pointing down.
    const dangle = (side, up, back, toes)=>{
        const r = rest.legs[side];
        return {
            ...r,
            ankle: [
                r.ankle[0],
                r.ankle[1] + up * u,
                r.ankle[2] - back * u
            ],
            footPitch: toes * u,
            planted: false
        };
    };
    return {
        ...pose,
        arms: {
            L: raise("L"),
            R: raise("R")
        },
        legs: {
            L: dangle("L", 4, 1.5, 0.55),
            R: dangle("R", 3, -0.5, 0.4)
        }
    };
};
const $a1fb04dc4139ce6e$export$130932a2d00959a0 = {
    idle: {
        name: "idle",
        frames: 1,
        frameMs: 1000,
        loop: true,
        sample: (_t, p, facing)=>(0, $16b5b2e1f0b8662b$export$a021dd78582c0634)(p, facing)
    },
    walk: {
        name: "walk",
        frames: 12,
        frameMs: 70,
        loop: true,
        strideCycle: $a1fb04dc4139ce6e$var$strideOf($a1fb04dc4139ce6e$var$WALK),
        sample: $a1fb04dc4139ce6e$var$sampleGait($a1fb04dc4139ce6e$var$WALK)
    },
    run: {
        name: "run",
        frames: 10,
        frameMs: 55,
        loop: true,
        strideCycle: $a1fb04dc4139ce6e$var$strideOf($a1fb04dc4139ce6e$var$RUN),
        sample: $a1fb04dc4139ce6e$var$sampleGait($a1fb04dc4139ce6e$var$RUN)
    },
    slash: {
        name: "slash",
        frames: 10,
        frameMs: 40,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$sampleKeys($a1fb04dc4139ce6e$var$SLASH_KEYS)
    },
    // An attack drawn its own way for one held weapon is keyed `<clip>:<held>` (see planEmberAnimation).
    "slash:dagger": {
        name: "slash",
        frames: 10,
        frameMs: 40,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$sampleKeys($a1fb04dc4139ce6e$var$daggerSlash($a1fb04dc4139ce6e$var$READY_SLASH))
    },
    "shoot:bow": {
        name: "shoot",
        frames: 14,
        frameMs: 60,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$sampleBowShot(0.16)
    },
    "slash:longsword": {
        name: "slash",
        frames: 10,
        frameMs: 40,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$twoHanded($a1fb04dc4139ce6e$var$swordCut($a1fb04dc4139ce6e$var$longswordCut($a1fb04dc4139ce6e$var$READY_SLASH), $a1fb04dc4139ce6e$var$LONGSWORD_TO_CAMERA))
    },
    "slash:saber": {
        name: "slash",
        frames: 10,
        frameMs: 40,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$handOnHip($a1fb04dc4139ce6e$var$swordCut($a1fb04dc4139ce6e$var$saberCut($a1fb04dc4139ce6e$var$READY_SLASH), $a1fb04dc4139ce6e$var$SABER_TO_CAMERA))
    },
    "slash:rapier": {
        name: "slash",
        frames: 10,
        frameMs: 40,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$handOnHip($a1fb04dc4139ce6e$var$swordCut($a1fb04dc4139ce6e$var$saberCut($a1fb04dc4139ce6e$var$READY_SLASH), $a1fb04dc4139ce6e$var$SABER_TO_CAMERA))
    },
    ...$a1fb04dc4139ce6e$var$weaponClips($a1fb04dc4139ce6e$var$SLASH_KEYS),
    hurt: {
        name: "hurt",
        frames: 8,
        frameMs: 70,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$sampleKeys($a1fb04dc4139ce6e$var$FALL_KEYS)
    },
    cast: {
        name: "cast",
        frames: 7,
        frameMs: 90,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$sampleKeys($a1fb04dc4139ce6e$var$castKeys($a1fb04dc4139ce6e$var$READY_SLASH))
    },
    climb: {
        name: "climb",
        frames: 8,
        frameMs: 70,
        loop: true,
        sample: $a1fb04dc4139ce6e$var$sampleClimb
    },
    // Held on its last frame while the body is in the air; the client plays it backwards as it lands.
    falling: {
        name: "falling",
        frames: 6,
        frameMs: 35,
        loop: false,
        sample: $a1fb04dc4139ce6e$var$sampleFalling
    }
};
const $a1fb04dc4139ce6e$export$413377055ae1c862 = {
    idle: "idle",
    walk: "walk",
    run: "run",
    slash: "slash",
    thrust: "slash",
    shoot: "slash",
    cast: "cast",
    hurt: "hurt",
    climb: "climb",
    falling: "falling"
};
const $a1fb04dc4139ce6e$export$dd2163ed96be013a = {
    slash: 400,
    thrust: 8 / 33 * 1000,
    get shoot () {
        return (0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.profiles.weapons.bow.firingLatchMs;
    }
};
const $a1fb04dc4139ce6e$export$ea3a8eba4ce22e88 = (keys)=>$a1fb04dc4139ce6e$var$sampleKeys(keys);
const $a1fb04dc4139ce6e$export$f434f633dbcc74b9 = {
    slash: {
        about: "The overhead-to-across strike, on an LPC-proportioned body: a ready stance with the feet planted, the arm drawn back up, the cut down and across with the chest turning into it, and back.",
        frames: 10,
        frameMs: 40,
        loop: false,
        keys: $a1fb04dc4139ce6e$var$SLASH_KEYS
    },
    "slash-natural": {
        about: "The same strike for a body at real proportions: the feet stay put, the hips turn a little with the blow, the chest and arm do the work.",
        frames: 10,
        frameMs: 40,
        loop: false,
        keys: $a1fb04dc4139ce6e$var$NATURAL_SLASH_KEYS
    },
    "slash-dagger": {
        about: "A dagger's cut: drawn back by the right shoulder, then across the body at chest height and recovered.",
        frames: 10,
        frameMs: 40,
        loop: false,
        keys: $a1fb04dc4139ce6e$var$daggerSlash($a1fb04dc4139ce6e$var$READY_NATURAL)
    },
    cast: {
        about: "A spell cast: the hands brought together before the chest, then raised high and held.",
        frames: 7,
        frameMs: 90,
        loop: false,
        keys: $a1fb04dc4139ce6e$var$castKeys($a1fb04dc4139ce6e$var$READY_NATURAL)
    },
    hurt: {
        about: "A fall: the knees buckle, the body folds over them, pitches forward onto its hands and ends face down -- each key after the first let down onto whatever of it is lowest (ground: 1).",
        frames: 8,
        frameMs: 70,
        loop: false,
        keys: $a1fb04dc4139ce6e$var$FALL_KEYS
    }
};


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
/**
 * The sun, as how far a shadow moves along the ground for each pixel of height (x across, y down).
 * It stands to the north-east and leans every shadow to the lower left, like the shading baked into the
 * tree and bush art.
 *
 * WORLD_SUN is the sun everything casts with by day -- walls, floors, roofs, trees, entity tiles and bodies
 * (building_shadow, foliage_shadow, lpc_composite_sprite) -- long enough that a merlon's shadow clears
 * its own foot and a tower's lies across the walk beside it; MOON by night. SUN is the short, compact cast bodies used
 * before; window.spriteShadowDirX / DirY bring a body-only sun back.
 *
 * Tune live: window.spriteShadowDirX / window.spriteShadowDirY (people), window.worldSunX /
 * window.worldSunY (the world); the world's shadows re-bake on the change.
 */ const $a44874d288f3eb63$export$b0483b844167706f = {
    x: -0.23,
    y: 0.13
};
const $a44874d288f3eb63$export$63a353feb061e28c = {
    x: -0.55,
    y: 0.31
};
const $a44874d288f3eb63$export$53f107bf4efd5fa6 = {
    x: 0.45,
    y: 0.38,
    strength: 0.4,
    full: 0.3
};
const $a44874d288f3eb63$export$176295348256a78b = ()=>{
    const w = typeof window === "undefined" ? undefined : window;
    if (w?.moon === false) return undefined;
    return w?.moon && typeof w.moon === "object" ? {
        ...$a44874d288f3eb63$export$53f107bf4efd5fa6,
        ...w.moon
    } : $a44874d288f3eb63$export$53f107bf4efd5fa6;
};
const $a44874d288f3eb63$export$f33d3a7b1193a664 = {
    color: 0x1b2033,
    alpha: 0.5,
    fadeMs: 200,
    softness: 1.5,
    /** How tall a body stands, for where its shadow lies (sprite_shade.ts castShadePoints). */ height: 48
};
const $a44874d288f3eb63$export$e5c36c349c8642df = (shown, target, dtMs, fadeMs)=>{
    if (fadeMs <= 0) return target;
    const step = dtMs / fadeMs;
    return shown < target ? Math.min(target, shown + step) : Math.max(target, shown - step);
};
const $a44874d288f3eb63$export$c794283427cbd942 = ()=>{
    const w = typeof window === "undefined" ? undefined : window;
    return {
        x: typeof w?.spriteShadowDirX === "number" ? w.spriteShadowDirX : $a44874d288f3eb63$export$b0483b844167706f.x,
        y: typeof w?.spriteShadowDirY === "number" ? w.spriteShadowDirY : $a44874d288f3eb63$export$b0483b844167706f.y
    };
};
const $a44874d288f3eb63$export$aa4bd1b541804cf = ()=>{
    const w = typeof window === "undefined" ? undefined : window;
    return {
        x: typeof w?.worldSunX === "number" ? w.worldSunX : $a44874d288f3eb63$export$63a353feb061e28c.x,
        y: typeof w?.worldSunY === "number" ? w.worldSunY : $a44874d288f3eb63$export$63a353feb061e28c.y
    };
};


const $7a6a96784834664b$export$e9e3e7e76042b5bf = (frameHeight, feetY)=>frameHeight / 2 + feetY - 32;
const $7a6a96784834664b$export$74987963829102f2 = (height, feetY, x, y, sx, sy, dirX = (0, $a44874d288f3eb63$export$b0483b844167706f).x, dirY = (0, $a44874d288f3eb63$export$b0483b844167706f).y)=>{
    const feet = $7a6a96784834664b$export$e9e3e7e76042b5bf(height, feetY);
    return new (0, $6qzqq.Matrix)(sx, 0, -sx * dirX, -sy * dirY, x + feet * sx * dirX, y + feet * sy * (1 + dirY));
};
const $7a6a96784834664b$export$d2a7abcc031e1aca = (sole, ground, sx = 1, sy = 1, dirX = (0, $a44874d288f3eb63$export$b0483b844167706f).x, dirY = (0, $a44874d288f3eb63$export$b0483b844167706f).y)=>new (0, $6qzqq.Matrix)(sx, 0, -sx * dirX, -sy * dirY, ground.x - sole.x * sx + sole.y * sx * dirX, ground.y + sole.y * sy * dirY);


parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");
var $8t5Gy = parcelRequire("8t5Gy");
const $b34e67be95b052b6$export$fc6ef54062927649 = (softness)=>{
    if (!(softness > 0)) return [
        {
            x: 0,
            y: 0
        }
    ];
    const offsets = [
        {
            x: 0,
            y: 0
        }
    ];
    for(let i = 0; i < 8; i++){
        const angle = i * Math.PI / 4;
        offsets.push({
            x: Math.cos(angle) * softness,
            y: Math.sin(angle) * softness
        });
    }
    return offsets;
};
const $b34e67be95b052b6$export$1bc5fdc2741a5995 = (alpha, copies)=>alpha >= 1 ? 1 : 1 - Math.pow(1 - Math.max(0, alpha), 1 / copies);
class $b34e67be95b052b6$export$4f6c8c01d6893aa0 extends (0, $8t5Gy.Container) {
    /** `texture` drawn through `matrix` at `alpha`, tinted `tint`, its edge softened over `softness` px. */ show(texture, matrix, alpha, tint, softness) {
        const offsets = $b34e67be95b052b6$export$fc6ef54062927649(softness);
        while(this.copies.length < offsets.length){
            const copy = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).EMPTY);
            this.copies.push(copy);
            this.addChild(copy);
        }
        const each = $b34e67be95b052b6$export$1bc5fdc2741a5995(alpha, offsets.length);
        this.copies.forEach((copy, i)=>{
            const offset = offsets[i];
            copy.visible = offset !== undefined;
            if (!offset) return;
            copy.texture = texture;
            if (copy.tint !== tint) copy.tint = tint;
            copy.alpha = each;
            this.place.copyFrom(matrix);
            this.place.tx += offset.x;
            this.place.ty += offset.y;
            copy.transform.setFromMatrix(this.place);
        });
        this.visible = true;
    }
    /** Hidden, and let go of the texture it drew (the generator reclaims the body's frames). */ release() {
        this.visible = false;
        this.copies.forEach((copy)=>{
            copy.texture = (0, $klOfb.Texture).EMPTY;
        });
    }
    constructor(...args){
        super(...args), this.copies = [], this.place = new (0, $6qzqq.Matrix)();
    }
}



/**
 * Where the buildings' sun shadows lie in each room, for the bodies standing in them: a body in a
 * building's shade is darkened like the ground under it, and casts no shadow of its own there (the
 * building already took the sun). Each storey's MapRenderingManager publishes its storey's shadow and
 * its strength this frame; a sprite asks about its feet. Pure: no pixi.
 */ /**
 * Where the sun's shadows of buildings fall on one storey: a pure model (no pixi), drawn by
 * BuildingShadowLayer (building_shadow.ts).
 *
 * Everything solid above a storey's floor casts onto it: walls (as boxes standing on their own
 * storey), the floor slabs of the storeys above, and roofs (a pitched roof rising to its ridge). Each
 * caster's ground footprint is swept along the sun from its lowest to its highest point, so a shadow's
 * length is the caster's height above THIS storey -- a tower's walls cast three storeys' worth onto
 * the ground and one storey's worth onto its own top floor.
 *
 * A storey only receives where it has a surface: the ground everywhere, an upper storey where its
 * floor art is drawn (floor_art.ts: the art stops short of a hole's cells, so the hole looks wider than
 * they are), and on the roofs of the storey below wherever it has no floor of its own: a roof is what it
 * walks on there (a castle keep's roof, under a house built on it). An opening in a floor is not a surface, and it is also a gap in that slab, so the storey
 * below gets the sunlight through it. Clipping to the drawn floor is what keeps an upper storey's
 * shade from hanging over a hole in mid-air; the storey below draws that shade where it really lands.
 *
 * Heights are measured in the same pixels the storeys are drawn apart in (STOREY_RISE_PX), so the sun
 * here is the people's sun: a pixel of height moves the shadow `sun.x` across and `sun.y` down.
 */ 
/**
 * Where a storey's floor art actually covers its cells. Every piece of the floors tileset stops
 * FLOOR_RIM_INSET short of a side it shares with a cell that has no floor (tucked under a wall, or
 * the rim of a hole), and is notched FLOOR_RIM_INSET square at a corner whose diagonal neighbour has
 * none -- measured on all 28 pieces HouseBuilder draws (house.ts). So an opening in a floor shows as
 * its cells widened by the inset wherever the floor runs up to it: one missing cell is a 56px hole.
 */ const $af4c175a7e8f40ad$export$ca63c48dfad28769 = 12;
const $af4c175a7e8f40ad$var$T = 32;
const $af4c175a7e8f40ad$export$7e53b5197744fc5d = (x, y, hasFloor)=>{
    const n = hasFloor(x, y - 1), s = hasFloor(x, y + 1), w = hasFloor(x - 1, y), e = hasFloor(x + 1, y);
    const nw = hasFloor(x - 1, y - 1), ne = hasFloor(x + 1, y - 1), sw = hasFloor(x - 1, y + 1), se = hasFloor(x + 1, y + 1);
    const left = x * $af4c175a7e8f40ad$var$T, right = left + $af4c175a7e8f40ad$var$T, top = y * $af4c175a7e8f40ad$var$T, bottom = top + $af4c175a7e8f40ad$var$T, I = $af4c175a7e8f40ad$export$ca63c48dfad28769;
    if (n && s && w && e && nw && ne && sw && se) return [
        {
            x0: left,
            y0: top,
            x1: right,
            y1: bottom
        }
    ];
    const bands = [];
    const band = (y0, y1, west, east)=>{
        const rect = {
            x0: west ? left : left + I,
            y0: y0,
            x1: east ? right : right - I,
            y1: y1
        };
        const above = bands[bands.length - 1];
        if (above && above.x0 === rect.x0 && above.x1 === rect.x1 && above.y1 === y0) above.y1 = y1;
        else bands.push(rect);
    };
    if (n) band(top, top + I, w && nw, e && ne);
    band(top + I, bottom - I, w, e);
    if (s) band(bottom - I, bottom, w && sw, e && se);
    return bands;
};


const $080b7304e1fb664d$var$T = 32;
const $080b7304e1fb664d$export$7796ba3689888f29 = {
    left: 10,
    right: 22,
    depth: 9
};
const $080b7304e1fb664d$export$4bbe2aa2f1c20cc6 = {
    left: 1,
    right: 31,
    depth: 12
};
const $080b7304e1fb664d$export$c36836940444fb04 = 40;
const $080b7304e1fb664d$var$parse = (key)=>{
    const comma = key.indexOf(",");
    return [
        Number(key.slice(0, comma)),
        Number(key.slice(comma + 1))
    ];
};
const $080b7304e1fb664d$export$4ca24610b3855479 = (walls, profiles)=>{
    const out = [];
    walls.forEach((cell)=>{
        const [x, y] = $080b7304e1fb664d$var$parse(cell);
        // A block stands alone on its cell, joined to nothing.
        const block = profiles?.get(cell)?.block;
        if (block) return out.push({
            x0: x * $080b7304e1fb664d$var$T + block.left,
            y0: y * $080b7304e1fb664d$var$T + block.top,
            x1: x * $080b7304e1fb664d$var$T + block.right,
            y1: y * $080b7304e1fb664d$var$T + block.bottom,
            cell: cell
        });
        const { left: left, right: right, depth: depth } = profiles?.get(cell)?.body ?? $080b7304e1fb664d$export$7796ba3689888f29;
        const n = walls.has(`${x},${y - 1}`), s = walls.has(`${x},${y + 1}`);
        const e = walls.has(`${x + 1},${y}`), w = walls.has(`${x - 1},${y}`);
        const bottom = y * $080b7304e1fb664d$var$T + $080b7304e1fb664d$var$T, top = bottom - depth;
        if (!n && !s && !e && !w) {
            out.push({
                x0: x * $080b7304e1fb664d$var$T + $080b7304e1fb664d$export$4bbe2aa2f1c20cc6.left,
                y0: bottom - $080b7304e1fb664d$export$4bbe2aa2f1c20cc6.depth,
                x1: x * $080b7304e1fb664d$var$T + $080b7304e1fb664d$export$4bbe2aa2f1c20cc6.right,
                y1: bottom,
                cell: cell
            });
            return;
        }
        // The open end of an east-west run is drawn out to the cell's edge.
        const run = !n && !s;
        const x0 = run && e && !w ? 0 : left;
        const x1 = run && w && !e ? $080b7304e1fb664d$var$T : right;
        out.push({
            x0: x * $080b7304e1fb664d$var$T + x0,
            y0: top,
            x1: x * $080b7304e1fb664d$var$T + x1,
            y1: bottom,
            cell: cell
        });
        if (e) out.push({
            x0: x * $080b7304e1fb664d$var$T + right,
            y0: top,
            x1: (x + 1) * $080b7304e1fb664d$var$T + left,
            y1: bottom,
            cell: cell
        });
        if (n) out.push({
            x0: x * $080b7304e1fb664d$var$T + left,
            y0: y * $080b7304e1fb664d$var$T,
            x1: x * $080b7304e1fb664d$var$T + right,
            y1: top,
            cell: cell
        });
    });
    return out;
};
/**
 * Whether cell (x, y), no wall itself, is a doorway: a gap of at most `span` cells in a run of walls along (dx, dy), the
 * walls either side ending the run there. A run the gap's line merely crosses (a corridor between two parallel walls,
 * like the ground between a castle's curtain and a tower) does not make one.
 */ const $080b7304e1fb664d$var$inDoorway = (walls, x, y, dx, dy, span)=>{
    const wall = (cx, cy)=>walls.has(`${cx},${cy}`);
    const ends = (cx, cy)=>!(wall(cx + dy, cy + dx) && wall(cx - dy, cy - dx));
    for(let a = 1; a <= span; a++){
        if (!wall(x - dx * a, y - dy * a)) continue;
        if (!ends(x - dx * a, y - dy * a)) return false;
        for(let b = 1; a + b - 1 <= span; b++)if (wall(x + dx * b, y + dy * b)) return ends(x + dx * b, y + dy * b);
        return false;
    }
    return false;
};
const $080b7304e1fb664d$export$6623c161ae1aa790 = (walls, profiles, x, y)=>{
    const has = (cx, cy)=>walls.has(`${cx},${cy}`);
    const n = has(x, y - 1), s = has(x, y + 1), e = has(x + 1, y), w = has(x - 1, y);
    if (!has(x, y)) {
        if ($080b7304e1fb664d$var$inDoorway(walls, x, y, 0, 1, 1)) {
            const { left: left, right: right } = profiles?.get(`${x},${y - 1}`)?.body ?? $080b7304e1fb664d$export$7796ba3689888f29;
            return {
                left: left,
                right: right,
                top: 0
            };
        }
        return $080b7304e1fb664d$var$inDoorway(walls, x, y, 1, 0, 1) ? {
            left: 0,
            right: $080b7304e1fb664d$var$T,
            top: $080b7304e1fb664d$var$T - (profiles?.get(`${x - 1},${y}`)?.body ?? $080b7304e1fb664d$export$7796ba3689888f29).depth
        } : undefined;
    }
    if (profiles?.get(`${x},${y}`)?.block) return undefined;
    if (!n && !s && !e && !w) return {
        left: $080b7304e1fb664d$export$4bbe2aa2f1c20cc6.left,
        right: $080b7304e1fb664d$export$4bbe2aa2f1c20cc6.right,
        top: $080b7304e1fb664d$var$T - $080b7304e1fb664d$export$4bbe2aa2f1c20cc6.depth
    };
    const { left: left, right: right, depth: depth } = profiles?.get(`${x},${y}`)?.body ?? $080b7304e1fb664d$export$7796ba3689888f29;
    const run = !n && !s;
    return {
        left: w || run && e ? 0 : left,
        right: e || run && w ? $080b7304e1fb664d$var$T : right,
        top: n ? 0 : $080b7304e1fb664d$var$T - depth
    };
};
/**
 * How far a pitched roof cell rises over its eave at a ground y: 45-degree slopes up to a ridge
 * halfway along its north-south run, which is where the art draws the ridge (the top row, or one row
 * down when the whole ridge drops there -- see pitchedRoofPiece).
 */ // Each roof cell's column (how far its roll runs up and down) and whether its top piece drops, per roof set: a cast samples
// the same cell many times, and working the pitched piece out afresh each time was a third of a castle's re-cast.
const $080b7304e1fb664d$var$roofColumns = new WeakMap();
const $080b7304e1fb664d$export$924d490de9185b92 = (roofs, x, y, groundY)=>{
    let columns = $080b7304e1fb664d$var$roofColumns.get(roofs);
    if (!columns) $080b7304e1fb664d$var$roofColumns.set(roofs, columns = new Map());
    const id = `${x},${y}`;
    let column = columns.get(id);
    if (!column) {
        const isRoof = (cx, cy)=>roofs.has(`${cx},${cy}`);
        let top = y, bottom = y;
        while(isRoof(x, top - 1))top--;
        while(isRoof(x, bottom + 1))bottom++;
        column = {
            top: top,
            bottom: bottom,
            drops: bottom > top && (0, $48a990ae9133d7d6$export$bb60dad4b331947b)(isRoof, x, top).startsWith("back.")
        };
        columns.set(id, column);
    }
    const { top: top, bottom: bottom, drops: drops } = column;
    const depth = bottom - top + 1;
    if (depth === 1) return $080b7304e1fb664d$var$T / 4;
    const ridge = $080b7304e1fb664d$var$T / 2 * depth - (drops ? $080b7304e1fb664d$var$T : 0);
    const middle = (top + bottom + 1) * $080b7304e1fb664d$var$T / 2;
    return Math.max(0, ridge * (1 - Math.abs(groundY - middle) / (depth * $080b7304e1fb664d$var$T / 2)));
};
const $080b7304e1fb664d$var$casters = (stack, receiver, options)=>{
    const out = [];
    const byFloor = new Map(stack.map((storey)=>[
            storey.floor,
            storey
        ]));
    stack.forEach((storey)=>{
        if (storey.floor < receiver) return;
        const base = (storey.floor - receiver) * options.rise;
        const above = byFloor.get(storey.floor + 1);
        $080b7304e1fb664d$export$4ca24610b3855479(storey.walls, storey.profiles).forEach(({ cell: cell, ...rect })=>{
            // A block is as tall as it is; a wall carrying another storey's wall runs up into it; a top wall ends at its own art.
            const block = storey.profiles?.get(cell)?.block;
            if (block) return out.push({
                ...rect,
                low: base,
                high: base + block.height
            });
            out.push({
                ...rect,
                low: base,
                high: base + (above?.walls.has(cell) ? options.rise : $080b7304e1fb664d$export$c36836940444fb04)
            });
        });
        // A slab ends flush with the outer face of a wall on its edge (its own storey's, or the one it rests on): a
        // tower's floors reaching to the cells' edges cast a step past its walls' shadow at every storey.
        const below = byFloor.get(storey.floor - 1);
        const open = (x, y)=>!storey.surface.has(`${x},${y}`);
        if (storey.floor > receiver) storey.slab.forEach((cell)=>{
            const [x, y] = $080b7304e1fb664d$var$parse(cell);
            const wall = $080b7304e1fb664d$export$6623c161ae1aa790(storey.walls, storey.profiles, x, y) ?? (below && $080b7304e1fb664d$export$6623c161ae1aa790(below.walls, below.profiles, x, y));
            const left = wall && open(x - 1, y) ? wall.left : 0, right = wall && open(x + 1, y) ? wall.right : $080b7304e1fb664d$var$T;
            const top = wall && open(x, y - 1) ? wall.top : 0;
            out.push({
                x0: x * $080b7304e1fb664d$var$T + left,
                y0: y * $080b7304e1fb664d$var$T + top,
                x1: x * $080b7304e1fb664d$var$T + right,
                y1: y * $080b7304e1fb664d$var$T + $080b7304e1fb664d$var$T,
                low: base,
                high: base
            });
        });
        storey.roofs.forEach((cell)=>{
            const [x, y] = $080b7304e1fb664d$var$parse(cell);
            const pitched = storey.pitched.has(cell);
            // A pitched cell in quarter strips, so a gable end casts its point.
            const strip = pitched ? $080b7304e1fb664d$var$T / 4 : $080b7304e1fb664d$var$T;
            for(let s = 0; s < $080b7304e1fb664d$var$T; s += strip){
                const h = base + options.roofLift + (pitched ? $080b7304e1fb664d$export$924d490de9185b92(storey.roofs, x, y, y * $080b7304e1fb664d$var$T + s + strip / 2) : 0);
                out.push({
                    x0: x * $080b7304e1fb664d$var$T,
                    y0: y * $080b7304e1fb664d$var$T + s,
                    x1: x * $080b7304e1fb664d$var$T + $080b7304e1fb664d$var$T,
                    y1: y * $080b7304e1fb664d$var$T + s + strip,
                    low: h,
                    high: h
                });
            }
        });
    });
    return out;
};
const $080b7304e1fb664d$export$b786f4033a68f961 = (points)=>{
    const pts = [];
    for(let i = 0; i < points.length; i += 2)pts.push([
        points[i],
        points[i + 1]
    ]);
    pts.sort((a, b)=>a[0] - b[0] || a[1] - b[1]);
    const cross = (o, a, b)=>(a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]);
    const lower = [], upper = [];
    for (const p of pts){
        while(lower.length >= 2 && cross(lower[lower.length - 2], lower[lower.length - 1], p) <= 0)lower.pop();
        lower.push(p);
    }
    for(let i = pts.length - 1; i >= 0; i--){
        const p = pts[i];
        while(upper.length >= 2 && cross(upper[upper.length - 2], upper[upper.length - 1], p) <= 0)upper.pop();
        upper.push(p);
    }
    return [
        ...lower.slice(0, -1),
        ...upper.slice(0, -1)
    ].flat();
};
/** A caster's footprint swept along the sun from its lowest point to its highest. */ const $080b7304e1fb664d$var$sweep = ({ x0: x0, y0: y0, x1: x1, y1: y1, low: low, high: high }, sun)=>{
    const at = (h)=>{
        const dx = sun.x * h, dy = sun.y * h;
        return [
            x0 + dx,
            y0 + dy,
            x1 + dx,
            y0 + dy,
            x1 + dx,
            y1 + dy,
            x0 + dx,
            y1 + dy
        ];
    };
    return low === high ? at(low) : $080b7304e1fb664d$export$b786f4033a68f961([
        ...at(low),
        ...at(high)
    ]);
};
const $080b7304e1fb664d$export$3cdd5061c452f39d = (polygon, x0, y0, x1, y1)=>{
    let points = polygon;
    const edges = [
        [
            (x)=>x >= x0,
            (ax, ay, bx, by)=>[
                    x0,
                    ay + (x0 - ax) / (bx - ax) * (by - ay)
                ]
        ],
        [
            (x)=>x <= x1,
            (ax, ay, bx, by)=>[
                    x1,
                    ay + (x1 - ax) / (bx - ax) * (by - ay)
                ]
        ],
        [
            (_, y)=>y >= y0,
            (ax, ay, bx, by)=>[
                    ax + (y0 - ay) / (by - ay) * (bx - ax),
                    y0
                ]
        ],
        [
            (_, y)=>y <= y1,
            (ax, ay, bx, by)=>[
                    ax + (y1 - ay) / (by - ay) * (bx - ax),
                    y1
                ]
        ]
    ];
    for (const [inside, cross] of edges){
        const out = [];
        const n = points.length / 2;
        for(let i = 0; i < n; i++){
            const ax = points[i * 2], ay = points[i * 2 + 1];
            const j = (i + 1) % n;
            const bx = points[j * 2], by = points[j * 2 + 1];
            const aIn = inside(ax, ay), bIn = inside(bx, by);
            if (aIn) out.push(ax, ay);
            if (aIn !== bIn) out.push(...cross(ax, ay, bx, by));
        }
        points = out;
        if (points.length < 6) return [];
    }
    // A polygon touching the rectangle only along its edge leaves a sliver with no area.
    let area = 0;
    for(let i = 0; i < points.length; i += 2){
        const j = (i + 2) % points.length;
        area += points[i] * points[j + 1] - points[j] * points[i + 1];
    }
    return Math.abs(area) > 1e-6 ? points : [];
};
/**
 * Cuts polygons to where storey `receiver` of `stack` can take shade: the ground everywhere, an upper
 * storey where its floor art is drawn, the roofs below it where it has no floor. `exemptIndoors` keeps
 * floors under a roof or the storey above clear (options.indoors false, for sun shadows only).
 */ /** `rects` with every part `cuts` covers taken out, as rectangles. */ const $080b7304e1fb664d$var$subtractRects = (rects, cuts)=>cuts.reduce((left, cut)=>left.flatMap((rect)=>{
            if (cut.x0 >= rect.x1 || cut.x1 <= rect.x0 || cut.y0 >= rect.y1 || cut.y1 <= rect.y0) return [
                rect
            ];
            const out = [];
            if (rect.y0 < cut.y0) out.push({
                ...rect,
                y1: cut.y0
            });
            if (cut.y1 < rect.y1) out.push({
                ...rect,
                y0: cut.y1
            });
            const y0 = Math.max(rect.y0, cut.y0), y1 = Math.min(rect.y1, cut.y1);
            if (rect.x0 < cut.x0) out.push({
                x0: rect.x0,
                y0: y0,
                x1: cut.x0,
                y1: y1
            });
            if (cut.x1 < rect.x1) out.push({
                x0: cut.x1,
                y0: y0,
                x1: rect.x1,
                y1: y1
            });
            return out;
        }), rects);
const $080b7304e1fb664d$export$7eaa8ad6359ac3ee = 3;
/**
 * Which of a storey's `covered` cells are indoors, kept out of the sun's shade: those its walls close off. Covered
 * ground open at a side to the `sky` round it -- the bailey's edge under a rampart, a porch -- is out of doors, in the
 * shade of what covers it: seen past the overhang's edge, it was a lit band between the overhang and its shadow. A
 * room's doorway (a gap of up to DOORWAY_SPAN cells in a run of walls) closes it as its walls do. `arched`: cells the
 * storey above cuts an arch over (its `undrawn`).
 */ const $080b7304e1fb664d$var$indoorCells = (self, covered, sky, arched)=>{
    const wall = (x, y)=>self.walls.has(`${x},${y}`);
    const shut = (x, y)=>wall(x, y) || $080b7304e1fb664d$var$inDoorway(self.walls, x, y, 1, 0, $080b7304e1fb664d$export$7eaa8ad6359ac3ee) || $080b7304e1fb664d$var$inDoorway(self.walls, x, y, 0, 1, $080b7304e1fb664d$export$7eaa8ad6359ac3ee);
    const stands = (x, y)=>self.ground || self.surface.has(`${x},${y}`);
    const sides = [
        [
            1,
            0
        ],
        [
            -1,
            0
        ],
        [
            0,
            1
        ],
        [
            0,
            -1
        ]
    ];
    const open = new Set();
    const pending = [];
    const reach = (x, y)=>{
        const key = `${x},${y}`;
        if (open.has(key) || shut(x, y) || !stands(x, y)) return;
        open.add(key);
        pending.push([
            x,
            y
        ]);
    };
    covered.forEach((key)=>{
        const [x, y] = $080b7304e1fb664d$var$parse(key);
        if (sides.some(([dx, dy])=>!covered.has(`${x + dx},${y + dy}`) && sky(x + dx, y + dy) && stands(x + dx, y + dy) && !shut(x + dx, y + dy))) reach(x, y);
    });
    while(pending.length){
        const [x, y] = pending.pop();
        sides.forEach(([dx, dy])=>{
            if (covered.has(`${x + dx},${y + dy}`)) reach(x + dx, y + dy);
        });
    }
    // A doorway with out of doors on both sides -- a castle's gate, under the arch, between the field and the bailey -- is
    // out of doors too, in the shade of what spans it. So is one under an arch out of doors on one side (a tower's door):
    // the threshold under the vault, as dark as the room seen through the arch (the storey above shades that). Any other
    // opening on a room stays shut.
    const outside = (x, y)=>open.has(`${x},${y}`) || !covered.has(`${x},${y}`) && sky(x, y) && stands(x, y) && !shut(x, y);
    const through = (x, y, dx, dy)=>$080b7304e1fb664d$var$inDoorway(self.walls, x, y, dx, dy, $080b7304e1fb664d$export$7eaa8ad6359ac3ee) && (arched?.has(`${x},${y}`) ? outside(x - dy, y - dx) || outside(x + dy, y + dx) : outside(x - dy, y - dx) && outside(x + dy, y + dx));
    const gates = [
        ...covered
    ].filter((key)=>{
        const [x, y] = $080b7304e1fb664d$var$parse(key);
        return !open.has(key) && !wall(x, y) && stands(x, y) && (through(x, y, 1, 0) || through(x, y, 0, 1));
    });
    gates.forEach((key)=>open.add(key));
    return open.size ? new Set([
        ...covered
    ].filter((key)=>!open.has(key))) : new Set(covered);
};
/** Where storey `receiver` can take shade, cell by cell (see receiverClip); `unclipped` when everywhere. */ const $080b7304e1fb664d$var$receiverCells = (stack, receiver, options, exemptIndoors)=>{
    const self = stack.find((storey)=>storey.floor === receiver);
    if (!self) return undefined;
    const upper = stack.find((storey)=>storey.floor === receiver + 1);
    const hasFloor = (x, y)=>self.surface.has(`${x},${y}`);
    // Under the storey above: its floor, and its stairwells (a stair stands over them, not the sky). A real
    // opening in that floor still lets the sun through.
    const covered = exemptIndoors && !options.indoors ? new Set([
        ...self.roofs,
        ...upper?.slab ?? [],
        ...upper?.surface ?? []
    ]) : undefined;
    // Open to the sky: nothing over it on any storey (an opening under a higher floor or roof is not).
    const above = stack.filter((storey)=>storey.floor > receiver);
    const sky = (x, y)=>{
        const key = `${x},${y}`;
        return !self.roofs.has(key) && !above.some((storey)=>storey.surface.has(key) || storey.slab.has(key) || storey.roofs.has(key));
    };
    const exempt = covered && $080b7304e1fb664d$var$indoorCells(self, covered, sky, upper?.undrawn);
    // The parts of a cell that receive: the whole cell on the ground, the drawn floor upstairs.
    // A roof below is drawn its uplift over its own storey, a little above this storey's plane.
    const roofShift = options.roofLift - options.rise;
    const surfaceAt = (x, y)=>{
        const key = `${x},${y}`;
        if (self.ground) return [
            {
                x0: x * $080b7304e1fb664d$var$T,
                y0: y * $080b7304e1fb664d$var$T,
                x1: x * $080b7304e1fb664d$var$T + $080b7304e1fb664d$var$T,
                y1: y * $080b7304e1fb664d$var$T + $080b7304e1fb664d$var$T
            }
        ];
        if (self.surface.has(key)) return self.undrawn?.has(key) ? [] : (0, $af4c175a7e8f40ad$export$7e53b5197744fc5d)(x, y, hasFloor);
        if (self.parapets?.has(key)) return [
            {
                x0: x * $080b7304e1fb664d$var$T,
                y0: y * $080b7304e1fb664d$var$T,
                x1: x * $080b7304e1fb664d$var$T + $080b7304e1fb664d$var$T,
                y1: y * $080b7304e1fb664d$var$T + $080b7304e1fb664d$var$T
            }
        ];
        return self.roofsBelow?.has(key) ? [
            {
                x0: x * $080b7304e1fb664d$var$T,
                y0: y * $080b7304e1fb664d$var$T - roofShift,
                x1: x * $080b7304e1fb664d$var$T + $080b7304e1fb664d$var$T,
                y1: y * $080b7304e1fb664d$var$T + $080b7304e1fb664d$var$T - roofShift
            }
        ] : [];
    };
    const upperFloor = (x, y)=>!!upper?.surface.has(`${x},${y}`);
    // Overlapping shadows ask about the same cells again and again: each cell is worked out once a cast (read-only after).
    const received = new Map();
    const receiving = (x, y)=>{
        const key = `${x},${y}`;
        let rects = received.get(key);
        if (!rects) received.set(key, rects = receivingAt(x, y));
        return rects;
    };
    const receivingAt = (x, y)=>{
        if (!exempt?.has(`${x},${y}`)) return surfaceAt(x, y);
        // Indoors is what a roof covers, all of its cell, or the storey above where its floor is drawn: that stops short of
        // its open edges (floor_art.ts), and the strip it leaves is out under the sky (the bailey's edge under a rampart's).
        const cell = {
            x0: x * $080b7304e1fb664d$var$T,
            y0: y * $080b7304e1fb664d$var$T,
            x1: x * $080b7304e1fb664d$var$T + $080b7304e1fb664d$var$T,
            y1: y * $080b7304e1fb664d$var$T + $080b7304e1fb664d$var$T
        };
        let cover = self.roofs.has(`${x},${y}`) ? [
            cell
        ] : upperFloor(x, y) ? (0, $af4c175a7e8f40ad$export$7e53b5197744fc5d)(x, y, upperFloor) : [];
        // So is a wall's cell past the wall's outer face, under a roof too (the ground west of a tower's west wall).
        // Under the wall's outer half too, so the shadow's soft edge lies under its art as it does round a wall in the open.
        // A doorway's floor shows: there it stops at the run's face.
        const wall = $080b7304e1fb664d$export$6623c161ae1aa790(self.walls, self.profiles, x, y);
        if (wall) {
            const middle = self.walls.has(`${x},${y}`) ? (wall.left + wall.right) / 2 : undefined;
            if (wall.left > 0 && !exempt.has(`${x - 1},${y}`)) cover = $080b7304e1fb664d$var$subtractRects(cover, [
                {
                    ...cell,
                    x1: x * $080b7304e1fb664d$var$T + (middle ?? wall.left)
                }
            ]);
            if (wall.right < $080b7304e1fb664d$var$T && !exempt.has(`${x + 1},${y}`)) cover = $080b7304e1fb664d$var$subtractRects(cover, [
                {
                    ...cell,
                    x0: x * $080b7304e1fb664d$var$T + (middle ?? wall.right)
                }
            ]);
        }
        return $080b7304e1fb664d$var$subtractRects(surfaceAt(x, y), cover);
    };
    /** Whether cell (x, y) receives on a roof of the storey below (no floor of this storey's there). */ const onRoofBelow = (x, y)=>{
        const key = `${x},${y}`;
        return !self.ground && !self.surface.has(key) && !self.parapets?.has(key) && !!self.roofsBelow?.has(key);
    };
    return {
        receiving: receiving,
        onRoofBelow: onRoofBelow,
        unclipped: self.ground && !exempt,
        exempt: exempt
    };
};
const $080b7304e1fb664d$export$8b64b2fbc59ce7d4 = (stack, receiver, options)=>$080b7304e1fb664d$var$receiverCells(stack, receiver, options, true)?.exempt || new Set();
const $080b7304e1fb664d$export$a2eb5f084d559d2 = (stack, receiver, options)=>{
    const cells = $080b7304e1fb664d$var$receiverCells(stack, receiver, options, true);
    if (!cells || cells.unclipped) return undefined;
    return (x0, y0, x1, y1)=>{
        const out = [];
        for(let cy = Math.floor(y0 / $080b7304e1fb664d$var$T) - 1; cy <= Math.ceil(y1 / $080b7304e1fb664d$var$T) + 1; cy++){
            for(let cx = Math.floor(x0 / $080b7304e1fb664d$var$T); cx <= Math.ceil(x1 / $080b7304e1fb664d$var$T); cx++)for (const rect of cells.receiving(cx, cy)){
                const last = out[out.length - 1];
                if (last && last.y0 === rect.y0 && last.y1 === rect.y1 && last.x1 === rect.x0) last.x1 = rect.x1;
                else out.push({
                    ...rect
                });
            }
        }
        return out;
    };
};
const $080b7304e1fb664d$var$receiverClip = (stack, receiver, options, exemptIndoors, apart)=>{
    const cells = $080b7304e1fb664d$var$receiverCells(stack, receiver, options, exemptIndoors);
    if (!cells) return undefined;
    const { receiving: receiving, onRoofBelow: onRoofBelow, unclipped: unclipped } = cells;
    const isApart = (x, y)=>!!apart?.cells.has(`${x},${y}`) && onRoofBelow(x, y);
    const whole = (rects)=>rects.length === 1 && rects[0].x1 - rects[0].x0 === $080b7304e1fb664d$var$T && rects[0].y1 - rects[0].y0 === $080b7304e1fb664d$var$T;
    return (polygon, out)=>{
        if (unclipped) {
            out.push(polygon);
            return;
        }
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        for(let i = 0; i < polygon.length; i += 2){
            minX = Math.min(minX, polygon[i]);
            maxX = Math.max(maxX, polygon[i]);
            minY = Math.min(minY, polygon[i + 1]);
            maxY = Math.max(maxY, polygon[i + 1]);
        }
        const cx0 = Math.floor(minX / $080b7304e1fb664d$var$T), cx1 = Math.ceil(maxX / $080b7304e1fb664d$var$T) - 1;
        const cy0 = Math.floor(minY / $080b7304e1fb664d$var$T), cy1 = Math.ceil(maxY / $080b7304e1fb664d$var$T) - 1;
        const rows = [];
        let all = true, anyApart = false;
        for(let cy = cy0; cy <= cy1; cy++){
            const row = [];
            for(let cx = cx0; cx <= cx1; cx++){
                const rects = receiving(cx, cy);
                const set = isApart(cx, cy);
                all = all && whole(rects);
                anyApart = anyApart || set && rects.length > 0;
                rects.forEach((rect)=>row.push({
                        ...rect,
                        apart: set
                    }));
            }
            rows.push(row);
        }
        if (all && !anyApart) {
            out.push(polygon);
            return;
        }
        // Cut it to the receiving rectangles, joined along each band of each row.
        rows.forEach((row)=>{
            const bands = new Map();
            row.forEach((rect)=>{
                const key = `${rect.apart}:${rect.y0}:${rect.y1}`;
                const band = bands.get(key);
                const last = band?.[band.length - 1];
                if (last && last.x1 === rect.x0) last.x1 = rect.x1;
                else if (band) band.push({
                    ...rect
                });
                else bands.set(key, [
                    {
                        ...rect
                    }
                ]);
            });
            bands.forEach((band)=>band.forEach(({ x0: x0, y0: y0, x1: x1, y1: y1, apart: set })=>{
                    const piece = $080b7304e1fb664d$export$3cdd5061c452f39d(polygon, x0, y0, x1, y1);
                    if (piece.length) (set ? apart.out : out).push(piece);
                }));
        });
    };
};
const $080b7304e1fb664d$export$a3c5f8cac73c364b = (stack, receiver, options, apart)=>{
    const clip = $080b7304e1fb664d$var$receiverClip(stack, receiver, options, true, apart);
    if (!clip) return [];
    const polygons = [];
    $080b7304e1fb664d$var$casters(stack, receiver, options).forEach((caster)=>clip($080b7304e1fb664d$var$sweep(caster, options.sun), polygons));
    return polygons;
};
const $080b7304e1fb664d$export$c74b9a2b068f77d7 = (stack, receiver, options, heights, apart)=>{
    const out = new Map();
    const routed = {
        cells: apart ?? new Set(),
        out: []
    };
    const clip = heights.length ? $080b7304e1fb664d$var$receiverClip(stack, receiver, options, true, routed) : undefined;
    if (!clip) return out;
    const all = $080b7304e1fb664d$var$casters(stack, receiver, options);
    heights.forEach((height)=>{
        const polygons = [];
        all.forEach((caster)=>{
            if (caster.high > height) clip($080b7304e1fb664d$var$sweep({
                ...caster,
                low: Math.max(caster.low, height)
            }, options.sun), polygons);
        });
        polygons.push(...routed.out.splice(0));
        out.set(height, polygons);
    });
    return out;
};
const $080b7304e1fb664d$export$aec4153cdb2c5450 = (stack, receiver, options, cell)=>{
    let height = 0;
    for(let floor = receiver;; floor++){
        const block = stack.find((storey)=>storey.floor === floor)?.profiles?.get(cell)?.block;
        if (block) return height + block.height;
        if (!stack.find((storey)=>storey.floor === floor + 1)?.walls.has(cell)) return height + $080b7304e1fb664d$export$c36836940444fb04;
        height += options.rise;
    }
};
const $080b7304e1fb664d$export$6578b6db898b0e14 = (stack, roofFloor, cells, options)=>{
    const covered = stack.find((storey)=>storey.floor === roofFloor + 1)?.surface;
    const roof = (x, y)=>cells.has(`${x},${y}`) && !covered?.has(`${x},${y}`);
    // Heights from the ground; the roof storey stands `lift` above it, drawn that much higher, so a point of the ground
    // lies `lift` further down in its pixels.
    const lift = roofFloor * options.rise, eave = lift + options.roofLift;
    const out = [];
    $080b7304e1fb664d$var$casters(stack.filter((storey)=>storey.floor > roofFloor), 0, options).forEach((caster)=>{
        if (caster.high <= eave) return;
        const polygon = $080b7304e1fb664d$var$sweep({
            ...caster,
            low: Math.max(caster.low, eave)
        }, options.sun).map((v, i)=>i % 2 ? v + lift : v);
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        for(let i = 0; i < polygon.length; i += 2){
            minX = Math.min(minX, polygon[i]);
            maxX = Math.max(maxX, polygon[i]);
            minY = Math.min(minY, polygon[i + 1]);
            maxY = Math.max(maxY, polygon[i + 1]);
        }
        // Each row of roof cells is drawn `roofLift` up: cut to its runs.
        const cx0 = Math.floor(minX / $080b7304e1fb664d$var$T), cx1 = Math.ceil(maxX / $080b7304e1fb664d$var$T) - 1;
        for(let y = Math.floor((minY + options.roofLift) / $080b7304e1fb664d$var$T); y < Math.ceil((maxY + options.roofLift) / $080b7304e1fb664d$var$T); y++)for(let x = cx0; x <= cx1; x++){
            if (!roof(x, y)) continue;
            let end = x;
            while(end < cx1 && roof(end + 1, y))end++;
            const piece = $080b7304e1fb664d$export$3cdd5061c452f39d(polygon, x * $080b7304e1fb664d$var$T, y * $080b7304e1fb664d$var$T - options.roofLift, (end + 1) * $080b7304e1fb664d$var$T, (y + 1) * $080b7304e1fb664d$var$T - options.roofLift);
            if (piece.length) out.push(piece);
            x = end;
        }
    });
    return out;
};
const $080b7304e1fb664d$export$2a9d9a1fbfe119 = (stack, receiver, options, reach, extra = [])=>{
    const self = stack.find((storey)=>storey.floor === receiver);
    const clip = $080b7304e1fb664d$var$receiverClip(stack, receiver, options, false);
    if (!self || !clip) return [];
    const polygons = [];
    $080b7304e1fb664d$export$4ca24610b3855479(self.walls, self.profiles).forEach(({ x0: x0, y0: y0, x1: x1, y1: y1 })=>clip([
            x0 - reach,
            y0 - reach,
            x1 + reach,
            y0 - reach,
            x1 + reach,
            y1 + reach,
            x0 - reach,
            y1 + reach
        ], polygons));
    extra.forEach((polygon)=>clip(polygon, polygons));
    return polygons;
};
const $080b7304e1fb664d$export$d619e0645ed0f317 = (stack, receiver, options)=>{
    if (!stack.find((storey)=>storey.floor === receiver)?.ground) return [];
    const byFloor = new Map(stack.map((storey)=>[
            storey.floor,
            storey
        ]));
    const out = [];
    stack.forEach((storey)=>{
        if (storey.floor <= receiver) return;
        const lift = (storey.floor - receiver) * options.rise;
        const above = byFloor.get(storey.floor + 1);
        const below = byFloor.get(storey.floor - 1);
        const has = (s, x, y)=>!!s?.walls.has(`${x},${y}`);
        $080b7304e1fb664d$export$4ca24610b3855479(storey.walls, storey.profiles).forEach(({ cell: cell, ...rect })=>{
            const [x, y] = $080b7304e1fb664d$var$parse(cell);
            if (storey.profiles?.get(cell)?.block || has(storey, x - 1, y) || has(storey, x + 1, y)) return;
            const column = has(storey, x, y - 1) || has(storey, x, y + 1) || has(below, x, y) && (has(below, x, y - 1) || has(below, x, y + 1));
            // The sun throws it west and a little south: a floor on those cells up there takes it already.
            const caught = [
                [
                    x,
                    y
                ],
                [
                    x - 1,
                    y
                ],
                [
                    x,
                    y + 1
                ],
                [
                    x - 1,
                    y + 1
                ]
            ].some(([cx, cy])=>storey.surface.has(`${cx},${cy}`));
            if (!column || caught) return;
            const polygon = $080b7304e1fb664d$var$sweep({
                ...rect,
                low: 0,
                high: above?.walls.has(cell) ? options.rise : $080b7304e1fb664d$export$c36836940444fb04
            }, options.sun);
            out.push(polygon.map((v, i)=>i % 2 ? v - lift : v));
        });
    });
    return out;
};
const $080b7304e1fb664d$export$e830aff3dca670d = (polygon, x, y)=>{
    let sign = 0;
    const n = polygon.length / 2;
    for(let i = 0; i < n; i++){
        const ax = polygon[i * 2], ay = polygon[i * 2 + 1];
        const j = (i + 1) % n;
        const bx = polygon[j * 2], by = polygon[j * 2 + 1];
        const cross = (bx - ax) * (y - ay) - (by - ay) * (x - ax);
        if (cross === 0) continue;
        if (sign === 0) sign = Math.sign(cross);
        else if (Math.sign(cross) !== sign) return false;
    }
    // A polygon with no area (every vertex on one line) holds no point.
    return sign !== 0;
};
/**
 * A key for a set of polygons that changes when any of them moves by a quarter pixel: two 32-bit
 * hashes of every vertex, rounded. Compared on every edit of a room, where a string of the vertices
 * themselves (tens of thousands of numbers once a forest casts) was most of the cost and its garbage.
 */ // A wall material's shadow profile by identity: the same definition object casts the same way.
const $080b7304e1fb664d$var$profileIds = new WeakMap();
let $080b7304e1fb664d$var$nextProfileId = 0;
const $080b7304e1fb664d$var$profileId = (shadow)=>{
    let id = $080b7304e1fb664d$var$profileIds.get(shadow);
    if (id === undefined) $080b7304e1fb664d$var$profileIds.set(shadow, id = ++$080b7304e1fb664d$var$nextProfileId);
    return id;
};
const $080b7304e1fb664d$export$fa4605c55ca778c6 = (stack)=>stack.map((storey)=>{
        const cells = (set)=>set ? [
                ...set
            ].join(";") : "-";
        const profiles = storey.profiles ? [
            ...storey.profiles
        ].map(([cell, shadow])=>`${cell}=${$080b7304e1fb664d$var$profileId(shadow)}`).join(";") : "-";
        return [
            storey.floor,
            storey.ground ? 1 : 0,
            cells(storey.walls),
            cells(storey.surface),
            cells(storey.undrawn),
            cells(storey.slab),
            cells(storey.roofs),
            cells(storey.pitched),
            cells(storey.roofsBelow),
            profiles,
            cells(storey.parapets)
        ].join("|");
    }).join("#");
const $080b7304e1fb664d$export$d0bdf2835f4bf05 = (polygons)=>{
    let a = 0x811c9dc5, b = 0x9e3779b9, count = 0;
    for (const polygon of polygons){
        for(let i = 0; i < polygon.length; i++){
            const v = Math.round(polygon[i] * 4);
            a = Math.imul(a ^ v, 0x01000193);
            b = Math.imul(b ^ v + i, 0x85ebca6b) ^ b >>> 13;
        }
        // Where one polygon ends and the next begins.
        a = Math.imul(a ^ polygon.length, 0x01000193);
        count += polygon.length;
    }
    return `${polygons.length}:${count}:${a >>> 0}:${b >>> 0}`;
};
const $080b7304e1fb664d$export$adfbd9c1e216562a = (polygons, x, y)=>polygons.some((polygon)=>$080b7304e1fb664d$export$e830aff3dca670d(polygon, x, y));


/**
 * Where the sun's shadow of a tree or bush falls: a pure model (no pixi), drawn with the buildings'
 * shadows as one (MapRenderingManager.updateBuildingShadow).
 *
 * A round crown or a bush casts its own silhouette: the art laid flat on the ground under the
 * crown's middle, `depth` as deep as it is drawn tall, and moved along the sun by the crown's
 * height. Its lumps and the see-through gaps between leaf clusters come through, so the shade is
 * leafy and a little dappled rather than a stamped oval. The trunk below the crown throws the
 * people's kind of shadow: a thin line along the sun from its foot. Both are "stamps": the art's
 * own pixels drawn through an affine map, baked with the rest of the shadow.
 *
 * A cone (a spruce) cannot do that: its silhouette laid flat is a triangle pointing north, hidden
 * under the tree, where its real shadow is a pool spreading off to the lower left. A cone, and
 * any plant when silhouettes are turned off, keeps the round-plant model instead: every row of the
 * art is a level slice of the plant, as wide as the row is drawn, at that row's height; a slice's
 * shadow is an ellipse `depth` as deep as it is wide, moved along the sun by its height, as a
 * wall's top is (building_shadow_geometry.ts). All the slices together, kept as their convex hull
 * (offline renders could not tell it from the exact union under the blur), are one polygon.
 *
 * The axis stands where the art's foot is drawn, pulled back into the ground by the foot's own
 * slice: the bottom row of a bush is the FRONT of its base, not its middle.
 */ 
const $7fbbd538ea219bbf$export$8bb3f4c5879e064 = (id, rgba, width, height, threshold = 128)=>{
    const alpha = new Uint8Array(width * height);
    for(let i = 0; i < alpha.length; i++)if (rgba[i * 4 + 3] > threshold) alpha[i] = 255;
    return {
        id: id,
        width: width,
        height: height,
        alpha: alpha,
        rows: $7fbbd538ea219bbf$export$5790fd084f06ae59(rgba, width, height, threshold)
    };
};
const $7fbbd538ea219bbf$export$5790fd084f06ae59 = (rgba, width, height, threshold = 128)=>{
    const rows = [];
    for(let y = 0; y < height; y++){
        let x0 = -1, x1 = -1;
        for(let x = 0; x < width; x++){
            if (rgba[(y * width + x) * 4 + 3] <= threshold) continue;
            if (x0 < 0) x0 = x;
            x1 = x + 1;
        }
        if (x0 >= 0) rows.push({
            y: y,
            x0: x0,
            x1: x1
        });
    }
    return rows;
};
/** A trunk row is no wider than this share of the plant's widest row. */ const $7fbbd538ea219bbf$var$TRUNK_SHARE = 0.35;
const $7fbbd538ea219bbf$export$30af45c767e2bd6e = (rows, depth)=>{
    const base = rows[rows.length - 1].y + 1;
    const width = (row)=>row.x1 - row.x0;
    const foot = rows.filter((row)=>row.y >= base - 3).reduce((widest, row)=>Math.max(widest, width(row)), 0);
    const widest = rows.reduce((max, row)=>Math.max(max, width(row)), 0);
    // The trunk: rows up from the foot while they stay narrow. Everything above is crown.
    let bottom = rows.length - 1;
    while(bottom > 0 && width(rows[bottom]) <= $7fbbd538ea219bbf$var$TRUNK_SHARE * widest)bottom--;
    const crown = rows.slice(0, bottom + 1);
    const top = crown[0].y, crownBottom = crown[crown.length - 1].y;
    const weight = crown.reduce((sum, row)=>sum + width(row), 0);
    const crownMiddle = crown.reduce((sum, row)=>sum + (row.y + 0.5) * width(row), 0) / weight;
    const widestRow = crown.reduce((best, row)=>width(row) > width(best) ? row : best);
    const quarter = crown.find((row)=>row.y >= top + (crownBottom - top) / 4) ?? widestRow;
    const span = Math.max(1, crownBottom - top);
    return {
        base: base,
        axis: base - depth * foot / 2,
        top: top,
        crownBottom: crownBottom,
        crownMiddle: crownMiddle,
        cone: (widestRow.y - top) / span > 0.75 && width(quarter) < 0.5 * width(widestRow)
    };
};
/** Points around an ellipse, enough that the hull's facets stay within a pixel of it. */ const $7fbbd538ea219bbf$var$SEGMENTS = 16;
const $7fbbd538ea219bbf$export$51f2f6be7af7dce3 = (rows, { sun: sun, depth: depth })=>{
    if (!rows.length) return [];
    const { axis: axis } = $7fbbd538ea219bbf$export$30af45c767e2bd6e(rows, depth);
    const points = [];
    rows.forEach(({ y: y, x0: x0, x1: x1 })=>{
        const h = Math.max(0, axis - (y + 0.5));
        const cx = (x0 + x1) / 2 + sun.x * h, cy = axis + sun.y * h;
        const rx = (x1 - x0) / 2, ry = depth * rx;
        for(let i = 0; i < $7fbbd538ea219bbf$var$SEGMENTS; i++){
            const a = i / $7fbbd538ea219bbf$var$SEGMENTS * Math.PI * 2;
            points.push(cx + rx * Math.cos(a), cy + ry * Math.sin(a));
        }
    });
    return (0, $080b7304e1fb664d$export$b786f4033a68f961)(points);
};
const $7fbbd538ea219bbf$export$962eb871c0a044e7 = (art, options)=>{
    const { rows: rows } = art;
    if (!rows.length) return {
        polygons: [],
        stamps: []
    };
    const { sun: sun, depth: depth } = options;
    const { base: base, axis: axis, top: top, crownBottom: crownBottom, crownMiddle: crownMiddle, cone: cone } = $7fbbd538ea219bbf$export$30af45c767e2bd6e(rows, depth);
    const foot = $7fbbd538ea219bbf$export$1e76ff809f38ffa1(rows, depth);
    if (cone || options.silhouettes === false) return {
        polygons: [
            $7fbbd538ea219bbf$export$51f2f6be7af7dce3(rows, options)
        ],
        stamps: [],
        foot: foot
    };
    // The crown laid flat with its middle over the axis, then moved by the sun as far as its middle is high.
    const lift = axis - crownMiddle;
    const stamps = [
        {
            art: art,
            y: top,
            height: crownBottom - top + 1,
            matrix: [
                1,
                0,
                0,
                depth,
                sun.x * lift,
                axis + depth * (top - crownMiddle) + sun.y * lift
            ]
        }
    ];
    // Each trunk pixel moved by the sun as far as it is high.
    const trunk = crownBottom + 1;
    if (base > trunk) stamps.push({
        art: art,
        y: trunk,
        height: base - trunk,
        matrix: [
            1,
            0,
            -sun.x,
            -sun.y,
            sun.x * (axis - trunk),
            axis + sun.y * (axis - trunk)
        ]
    });
    return {
        polygons: [],
        stamps: stamps,
        foot: foot
    };
};
const $7fbbd538ea219bbf$export$1e76ff809f38ffa1 = (rows, depth, spread = 2)=>{
    if (!rows.length) return [];
    const { base: base, axis: axis } = $7fbbd538ea219bbf$export$30af45c767e2bd6e(rows, depth);
    const foot = rows.filter((row)=>row.y >= base - 3);
    const x0 = Math.min(...foot.map((row)=>row.x0)), x1 = Math.max(...foot.map((row)=>row.x1));
    const rx = (x1 - x0) / 2 + spread, ry = Math.max(2, depth * rx);
    const cx = (x0 + x1) / 2;
    const points = [];
    for(let i = 0; i < $7fbbd538ea219bbf$var$SEGMENTS; i++){
        const a = i / $7fbbd538ea219bbf$var$SEGMENTS * Math.PI * 2;
        points.push(cx + rx * Math.cos(a), axis + ry * Math.sin(a));
    }
    return points;
};
const $7fbbd538ea219bbf$export$88cc5f0e18e22720 = (art, options, strength = 1)=>{
    const { rows: rows } = art;
    if (!rows.length) return {
        polygons: [],
        stamps: []
    };
    const { sun: sun, depth: depth } = options;
    const top = rows[0].y, base = rows[rows.length - 1].y + 1;
    return {
        polygons: [],
        stamps: [
            {
                art: art,
                y: top,
                height: base - top,
                ...strength < 1 ? {
                    strength: strength
                } : {},
                matrix: [
                    1,
                    0,
                    -sun.x,
                    -sun.y,
                    sun.x * (base - top),
                    base + sun.y * (base - top)
                ]
            }
        ],
        ...strength < 1 ? {} : {
            foot: $7fbbd538ea219bbf$export$1e76ff809f38ffa1(rows, depth)
        }
    };
};
const $7fbbd538ea219bbf$export$941ded842b08c6d2 = 0.1;
const $7fbbd538ea219bbf$export$eae896c538d79207 = (tile, rgba, width, height)=>{
    if (tile.castsShadow) return "foliage";
    if (tile.tileTypes?.includes("denseVertical")) return "grass";
    if (tile.tileTypes?.includes("dense")) return "none";
    if ((tile.renderZIdxOffset ?? 0) <= -16) return "none";
    let drawn = 0, soft = 0, minY = height, maxY = -1;
    for(let i = 0; i < width * height; i++){
        const a = rgba[i * 4 + 3];
        if (!a) continue;
        drawn++;
        if (a < 200) soft++;
        if (a > 128) {
            const y = Math.floor(i / width);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
    }
    if (!drawn || soft / drawn >= $7fbbd538ea219bbf$export$941ded842b08c6d2) return "none";
    return maxY - minY + 1 >= 6 ? "upright" : "none";
};
const $7fbbd538ea219bbf$export$bf389ed589e3a7f3 = (polygon, dx, dy)=>polygon.map((v, i)=>v + (i % 2 ? dy : dx));
const $7fbbd538ea219bbf$export$61467af1a154b2d9 = (stamp, dx, dy)=>{
    const [a, b, c, d, tx, ty] = stamp.matrix;
    return {
        ...stamp,
        matrix: [
            a,
            b,
            c,
            d,
            tx + dx,
            ty + dy
        ]
    };
};
const $7fbbd538ea219bbf$export$2e3e7392189b3267 = ({ art: art, height: height, matrix: [a, b, c, d, tx, ty] })=>{
    const w = art.width;
    return [
        tx,
        ty,
        a * w + tx,
        b * w + ty,
        a * w + c * height + tx,
        b * w + d * height + ty,
        c * height + tx,
        d * height + ty
    ];
};
const $7fbbd538ea219bbf$export$8d79dc96ab89065d = ({ art: art, y: y, height: height, matrix: [a, b, c, d, tx, ty] }, px, py)=>{
    const det = a * d - b * c;
    if (!det) return false;
    const u = Math.floor((d * (px - tx) - c * (py - ty)) / det);
    const v = Math.floor((a * (py - ty) - b * (px - tx)) / det);
    if (u < 0 || v < 0 || u >= art.width || v >= height) return false;
    return art.alpha[(y + v) * art.width + u] > 0;
};
const $7fbbd538ea219bbf$export$4afa64c4106f0e32 = (stamps)=>{
    let a = 0x811c9dc5, b = 0x9e3779b9;
    const mix = (v)=>{
        a = Math.imul(a ^ v, 0x01000193);
        b = Math.imul(b ^ v + 0x632be5ab, 0x85ebca6b) ^ b >>> 13;
    };
    for (const { art: art, y: y, height: height, matrix: matrix, strength: strength } of stamps){
        for(let i = 0; i < art.id.length; i++)mix(art.id.charCodeAt(i));
        mix(y);
        mix(height);
        mix(Math.round((strength ?? 1) * 100));
        for (const v of matrix)mix(Math.round(v * 4));
    }
    return `${stamps.length}:${a >>> 0}:${b >>> 0}`;
};


const $a1ff1a141ce12c85$var$shades = new Map();
let $a1ff1a141ce12c85$var$generation = 0;
const $a1ff1a141ce12c85$export$4b799469db4c19c = ()=>$a1ff1a141ce12c85$var$generation;
/** Bucketed by 64px squares: a lookup tests only the shapes near it (a forest casts thousands). */ const $a1ff1a141ce12c85$var$BUCKET = 64;
const $a1ff1a141ce12c85$var$bucketKey = (bx, by)=>(bx + 32768) * 65536 + (by + 32768);
const $a1ff1a141ce12c85$var$bucketsOf = (boxes, stampBoxes)=>{
    const buckets = new Map();
    const add = (box, i, id)=>{
        const b = i * 4;
        for(let bx = Math.floor(box[b] / $a1ff1a141ce12c85$var$BUCKET); bx <= Math.floor(box[b + 2] / $a1ff1a141ce12c85$var$BUCKET); bx++)for(let by = Math.floor(box[b + 1] / $a1ff1a141ce12c85$var$BUCKET); by <= Math.floor(box[b + 3] / $a1ff1a141ce12c85$var$BUCKET); by++){
            const key = $a1ff1a141ce12c85$var$bucketKey(bx, by);
            const list = buckets.get(key);
            if (list) list.push(id);
            else buckets.set(key, [
                id
            ]);
        }
    };
    for(let i = 0; i < boxes.length / 4; i++)add(boxes, i, i);
    for(let i = 0; i < stampBoxes.length / 4; i++)add(stampBoxes, i, -1 - i);
    return buckets;
};
const $a1ff1a141ce12c85$var$boxesOf = (polygons)=>{
    const boxes = new Float32Array(polygons.length * 4);
    polygons.forEach((polygon, i)=>{
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        for(let k = 0; k < polygon.length; k += 2){
            minX = Math.min(minX, polygon[k]);
            maxX = Math.max(maxX, polygon[k]);
            minY = Math.min(minY, polygon[k + 1]);
            maxY = Math.max(maxY, polygon[k + 1]);
        }
        boxes.set([
            minX,
            minY,
            maxX,
            maxY
        ], i * 4);
    });
    return boxes;
};
const $a1ff1a141ce12c85$export$5ce2d550e02675c1 = (roomId, owner, polygons, stamps = [], color = 0x000000, buildings = polygons.length)=>{
    const boxes = $a1ff1a141ce12c85$var$boxesOf(polygons), stampBoxes = $a1ff1a141ce12c85$var$boxesOf(stamps.map((0, $7fbbd538ea219bbf$export$2e3e7392189b3267)));
    $a1ff1a141ce12c85$var$shades.set(roomId, {
        owner: owner,
        polygons: polygons,
        buildings: buildings,
        boxes: boxes,
        stamps: stamps,
        stampBoxes: stampBoxes,
        buckets: $a1ff1a141ce12c85$var$bucketsOf(boxes, stampBoxes),
        alpha: $a1ff1a141ce12c85$var$shades.get(roomId)?.alpha ?? 0,
        sun: $a1ff1a141ce12c85$var$shades.get(roomId)?.sun,
        color: color
    });
    $a1ff1a141ce12c85$var$generation++;
};
const $a1ff1a141ce12c85$export$92d477a5aa3f6953 = (roomId)=>(roomId === undefined ? undefined : $a1ff1a141ce12c85$var$shades.get(roomId)?.color) ?? 0x000000;
const $a1ff1a141ce12c85$export$5359f04ca60f9df2 = (roomId)=>roomId === undefined ? undefined : $a1ff1a141ce12c85$var$shades.get(roomId)?.alpha;
const $a1ff1a141ce12c85$export$915c685ef07238e8 = (roomId)=>roomId === undefined ? undefined : $a1ff1a141ce12c85$var$shades.get(roomId)?.sun;
const $a1ff1a141ce12c85$export$274c9a44d26e84dc = (roomId, alpha, sun)=>{
    const shade = $a1ff1a141ce12c85$var$shades.get(roomId);
    if (!shade) return;
    shade.alpha = alpha;
    if (sun) shade.sun = sun;
};
const $a1ff1a141ce12c85$export$521911947bc5fb90 = (roomId, owner)=>{
    if ($a1ff1a141ce12c85$var$shades.get(roomId)?.owner !== owner) return;
    $a1ff1a141ce12c85$var$shades.delete(roomId);
    $a1ff1a141ce12c85$var$generation++;
};
const $a1ff1a141ce12c85$export$55e3e87f5132cc63 = (roomId, x, y, buildingsOnly = false)=>{
    const shade = roomId === undefined ? undefined : $a1ff1a141ce12c85$var$shades.get(roomId);
    if (!shade) return false;
    const { boxes: boxes, polygons: polygons, stampBoxes: stampBoxes, stamps: stamps } = shade;
    for (const id of shade.buckets.get($a1ff1a141ce12c85$var$bucketKey(Math.floor(x / $a1ff1a141ce12c85$var$BUCKET), Math.floor(y / $a1ff1a141ce12c85$var$BUCKET))) ?? []){
        if (buildingsOnly && (id < 0 || id >= shade.buildings)) continue;
        const box = id >= 0 ? boxes : stampBoxes, i = id >= 0 ? id : -1 - id, b = i * 4;
        if (x < box[b] || y < box[b + 1] || x > box[b + 2] || y > box[b + 3]) continue;
        // A silhouette shades only where its art is drawn: a gap between leaf clusters lets the sun through.
        if (id >= 0 ? (0, $080b7304e1fb664d$export$e830aff3dca670d)(polygons[i], x, y) : (0, $7fbbd538ea219bbf$export$8d79dc96ab89065d)(stamps[i], x, y)) return true;
    }
    return false;
};
const $a1ff1a141ce12c85$export$ca38d65fad78c9a = (roomId, x, y)=>{
    const shade = roomId === undefined ? undefined : $a1ff1a141ce12c85$var$shades.get(roomId);
    if (!shade || shade.alpha <= 0) return 0;
    return $a1ff1a141ce12c85$export$55e3e87f5132cc63(roomId, x, y) ? shade.alpha : 0;
};
const $a1ff1a141ce12c85$export$4680da062056e5ae = (tint, shade, color = 0x000000)=>{
    if (shade <= 0) return tint;
    const k = (c)=>1 - shade * (1 - c / 255);
    const r = Math.round((tint >> 16 & 0xff) * k(color >> 16 & 0xff));
    const g = Math.round((tint >> 8 & 0xff) * k(color >> 8 & 0xff));
    const b = Math.round((tint & 0xff) * k(color & 0xff));
    return r << 16 | g << 8 | b;
};


/**
 * Sprites standing in the world's shade (sun shadows of buildings, trees and entity tiles) are darkened
 * like the ground there. The shade layer is drawn under every sprite, so without this a table, a bush or
 * a wall stood in a tower's shadow stayed lit on a dark floor. Pure: no pixi.
 *
 * A sprite is asked about one point: the ground just SUNWARD of where it stands. Its own foot is no good
 * -- everything that casts stands inside its own shadow there -- and if the light is blocked before it
 * reaches the sprite, the ground on that side is in the same shade. Only low art takes it whole: a tree's
 * crown stands above most of what shades its trunk, so tall art is shaded only as high as the buildings'
 * shade climbs it (shadeClimb, drawn by MapRenderingManager's shade overlays).
 */ 
const $59778fc6a8174634$export$827cbfd2c009f1c5 = 96;
const $59778fc6a8174634$export$476c8af71dfb2a0c = (sun)=>{
    const length = Math.hypot(sun.x, sun.y) || 1;
    return {
        x: -sun.x / length,
        y: -sun.y / length
    };
};
const $59778fc6a8174634$export$7a1a89dda26432bf = (cx, cy, sun)=>({
        x: cx * 32 + ((sun?.x ?? -1) > 0 ? 6 : 26),
        y: cy * 32 + 14
    });
const $59778fc6a8174634$export$d27dc3c922b5e34d = (stack, receiver, options, apart)=>{
    const shaded = new Set();
    const self = stack.find((storey)=>storey.floor === receiver);
    if (!self) return shaded;
    const heights = new Map();
    self.walls.forEach((cell)=>heights.set(cell, (0, $080b7304e1fb664d$export$aec4153cdb2c5450)(stack, receiver, options, cell)));
    (0, $080b7304e1fb664d$export$c74b9a2b068f77d7)(stack, receiver, options, [
        ...new Set(heights.values())
    ], apart).forEach((polygons, height)=>{
        for (const polygon of polygons){
            let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
            for(let i = 0; i < polygon.length; i += 2){
                minX = Math.min(minX, polygon[i]);
                maxX = Math.max(maxX, polygon[i]);
                minY = Math.min(minY, polygon[i + 1]);
                maxY = Math.max(maxY, polygon[i + 1]);
            }
            // A piece's point lies in its own cell: only the cells the polygon reaches.
            for(let cy = Math.floor(minY / 32); cy <= Math.floor(maxY / 32); cy++)for(let cx = Math.floor(minX / 32); cx <= Math.floor(maxX / 32); cx++){
                const cell = `${cx},${cy}`;
                if (heights.get(cell) !== height || shaded.has(cell)) continue;
                const p = $59778fc6a8174634$export$7a1a89dda26432bf(cx, cy, options.sun);
                if ((0, $080b7304e1fb664d$export$e830aff3dca670d)(polygon, p.x, p.y)) shaded.add(cell);
            }
        }
    });
    return shaded;
};
const $59778fc6a8174634$export$bdcc8456024c0d74 = (cx, cy)=>[
        8,
        16,
        24
    ].map((dx)=>({
            x: cx * 32 + dx,
            y: cy * 32 + 24
        }));
const $59778fc6a8174634$export$aa26ac95af79b0da = (x, y, width, height, sun, casts = true)=>{
    if (height > $59778fc6a8174634$export$827cbfd2c009f1c5) return undefined;
    // Art that casts nothing (grass, flowers) looks at the ground right under it, where the shade is drawn.
    const toward = $59778fc6a8174634$export$476c8af71dfb2a0c(sun), reach = casts ? Math.max(10, width * 0.45) : 0;
    const cx = x + width / 2 + toward.x * reach, cy = y + height - 4 + toward.y * reach;
    const across = [
        -0.4,
        -0.2,
        0,
        0.2,
        0.4
    ].map((f)=>cx + f * width);
    if (casts) return across.map((px)=>({
            x: px,
            y: cy
        }));
    // Rows of grass overlap: three rows of points, so neighbouring rows read close shares and a shadow's
    // edge spreads over several of them instead of drawing a straight line between two.
    return [
        -16,
        0,
        16
    ].flatMap((dy)=>across.map((px)=>({
                x: px,
                y: cy + dy
            })));
};
const $59778fc6a8174634$export$9df2d71819810102 = (foot, height, sun, inShade, step = 4)=>{
    if (!inShade(foot.x, foot.y)) return 0;
    for(let h = step; h <= height; h += step){
        if (!inShade(foot.x + sun.x * h, foot.y + sun.y * h)) return h - step / 2;
    }
    return height;
};
const $59778fc6a8174634$export$a3650d57e5c29c1c = (soles, height, sun)=>[
        0.25,
        0.5,
        0.75,
        1
    ].map((f)=>({
            x: soles.x + sun.x * height * f,
            y: soles.y + sun.y * height * f
        }));
const $59778fc6a8174634$export$b30b2f234be6041e = (a, b)=>{
    const ch = (shift)=>Math.round((a >> shift & 0xff) * (b >> shift & 0xff) / 255);
    return ch(16) << 16 | ch(8) << 8 | ch(0);
};



const $d782e74b2eaa8700$export$c93e91c91768c5a2 = [
    "walk-left",
    "walk-right",
    "walk-back",
    "walk-front",
    // Run exists only for bodies that draw it (EmberCompositeSprite); LPC sheets have no run row,
    // and an LPC body is never asked for one (see locomotionAnimation).
    "run-left",
    "run-right",
    "run-back",
    "run-front",
    "idle-left",
    "idle-right",
    "idle-back",
    "idle-front",
    "cast-left",
    "cast-right",
    "cast-back",
    "cast-front",
    "thrust-left",
    "thrust-right",
    "thrust-back",
    "thrust-front",
    "slash-left",
    "slash-right",
    "slash-back",
    "slash-front",
    "shoot-left",
    "shoot-right",
    "shoot-back",
    "shoot-front",
    // Procedural Ember bodies also draw diagonal views. LPC direction selection stays cardinal.
    "walk-frontleft",
    "walk-frontright",
    "walk-backleft",
    "walk-backright",
    "run-frontleft",
    "run-frontright",
    "run-backleft",
    "run-backright",
    "idle-frontleft",
    "idle-frontright",
    "idle-backleft",
    "idle-backright",
    "cast-frontleft",
    "cast-frontright",
    "cast-backleft",
    "cast-backright",
    "thrust-frontleft",
    "thrust-frontright",
    "thrust-backleft",
    "thrust-backright",
    "slash-frontleft",
    "slash-frontright",
    "slash-backleft",
    "slash-backright",
    "shoot-frontleft",
    "shoot-frontright",
    "shoot-backleft",
    "shoot-backright",
    "hurt-front",
    // Up or down a ladder, facing it: only bodies that draw it (EmberCompositeSprite, see climbPose).
    "climb-back",
    "activate",
    "deactivate",
    "inactive",
    "active"
];
const $d782e74b2eaa8700$var$AnimationTypeToActionType = {
    activate: "activate",
    deactivate: "deactivate",
    inactive: "inactive",
    active: "activate",
    "walk-left": "walk",
    "walk-right": "walk",
    "walk-back": "walk",
    "walk-front": "walk",
    "run-left": "walk",
    "run-right": "walk",
    "run-back": "walk",
    "run-front": "walk",
    "idle-left": "idle",
    "idle-right": "idle",
    "idle-back": "idle",
    "idle-front": "idle",
    "cast-left": "cast",
    "cast-right": "cast",
    "cast-back": "cast",
    "cast-front": "cast",
    "thrust-left": "thrust",
    "thrust-right": "thrust",
    "thrust-back": "thrust",
    "thrust-front": "thrust",
    "slash-left": "slash",
    "slash-right": "slash",
    "slash-back": "slash",
    "slash-front": "slash",
    "shoot-left": "shoot",
    "shoot-right": "shoot",
    "shoot-back": "shoot",
    "shoot-front": "shoot",
    "walk-frontleft": "walk",
    "walk-frontright": "walk",
    "walk-backleft": "walk",
    "walk-backright": "walk",
    "run-frontleft": "walk",
    "run-frontright": "walk",
    "run-backleft": "walk",
    "run-backright": "walk",
    "idle-frontleft": "idle",
    "idle-frontright": "idle",
    "idle-backleft": "idle",
    "idle-backright": "idle",
    "cast-frontleft": "cast",
    "cast-frontright": "cast",
    "cast-backleft": "cast",
    "cast-backright": "cast",
    "thrust-frontleft": "thrust",
    "thrust-frontright": "thrust",
    "thrust-backleft": "thrust",
    "thrust-backright": "thrust",
    "slash-frontleft": "slash",
    "slash-frontright": "slash",
    "slash-backleft": "slash",
    "slash-backright": "slash",
    "shoot-frontleft": "shoot",
    "shoot-frontright": "shoot",
    "shoot-backleft": "shoot",
    "shoot-backright": "shoot",
    "hurt-front": "hurt",
    "climb-back": "walk"
};
/**
 * Which animation depicts each held pose, for a body facing `facing`.
 *
 * `downed` is the universal sheet's `hurt` row, which is not a flinch but a COLLAPSE: six frames of
 * a body sinking to the ground, ending face-down. Held on that last frame, it is the fallen pose.
 *
 * Two things about that row shape everything below. It exists FRONT-FACING ONLY -- there is no
 * `hurt-left`, so a fallen body cannot turn -- and every humanoid LPC sheet in the game has it
 * (body, hair, every torso/legs/feet/cape/shield), so a fallen character keeps their whole
 * wardrobe. The non-humanoid sheets (rabbit, chicken, slime, ...) have no `hurt` row at all, which
 * is why LpcComposite only ever asks for this pose on a humanoid race.
 */ const $d782e74b2eaa8700$var$heldPoseAnimation = (pose, facing)=>pose === "downed" ? "hurt-front" : `falling-${facing}`;
/**
 * `falling` is the body in the air -- off a ladder, a roof, through a floor -- its arms flung up and
 * held there until it lands, in whatever way it faced as it went. Getting back up from it is the
 * same reverse playback as the rise: the hands come back down. LPC sheets have no such row; only a
 * body that draws one takes the pose (drawsHeldPose).
 */ const $d782e74b2eaa8700$var$HELD_POSE_ACTIONS = [
    "hurt",
    "falling"
];
const $d782e74b2eaa8700$export$8280b108092dda60 = (animation)=>$d782e74b2eaa8700$var$HELD_POSE_ACTIONS.includes($d782e74b2eaa8700$var$animationToAction(animation));
const $d782e74b2eaa8700$var$defaultRenderMeta = {
    activate: {
        scale: 1,
        speed: 0.25
    },
    deactivate: {
        scale: 1,
        speed: 0.25
    },
    inactive: {
        scale: 1,
        animated: false
    },
    active: {
        scale: 1
    },
    "walk-left": {
        scale: 1,
        speed: 0.25
    },
    "walk-right": {
        scale: 1,
        speed: 0.25
    },
    "walk-back": {
        scale: 1,
        speed: 0.25
    },
    "walk-front": {
        scale: 1,
        speed: 0.25
    },
    "run-left": {
        scale: 1,
        speed: 0.25
    },
    "run-right": {
        scale: 1,
        speed: 0.25
    },
    "run-back": {
        scale: 1,
        speed: 0.25
    },
    "run-front": {
        scale: 1,
        speed: 0.25
    },
    // Frame by frame from how far up the ladder the body is (climbPose), never played on its own.
    "climb-back": {
        scale: 1,
        animated: false
    },
    "idle-left": {
        scale: 1
    },
    "idle-right": {
        scale: 1
    },
    "idle-back": {
        scale: 1
    },
    "idle-front": {
        scale: 1
    },
    "cast-left": {
        scale: 1,
        speed: 0.2
    },
    "cast-right": {
        scale: 1,
        speed: 0.2
    },
    "cast-back": {
        scale: 1,
        speed: 0.2
    },
    "cast-front": {
        scale: 1,
        speed: 0.2
    },
    "thrust-left": {
        scale: 1,
        speed: 0.55
    },
    "thrust-right": {
        scale: 1,
        speed: 0.55
    },
    "thrust-back": {
        scale: 1,
        speed: 0.55
    },
    "thrust-front": {
        scale: 1,
        speed: 0.55
    },
    "slash-left": {
        scale: 1,
        speed: 0.25
    },
    "slash-right": {
        scale: 1,
        speed: 0.25
    },
    "slash-back": {
        scale: 1,
        speed: 0.25
    },
    "slash-front": {
        scale: 1,
        speed: 0.25
    },
    "shoot-left": {
        scale: 1,
        speed: 0.85
    },
    "shoot-right": {
        scale: 1,
        speed: 0.85
    },
    "shoot-back": {
        scale: 1,
        speed: 0.85
    },
    "shoot-front": {
        scale: 1,
        speed: 0.85
    },
    "walk-frontleft": {
        scale: 1,
        speed: 0.25
    },
    "walk-frontright": {
        scale: 1,
        speed: 0.25
    },
    "walk-backleft": {
        scale: 1,
        speed: 0.25
    },
    "walk-backright": {
        scale: 1,
        speed: 0.25
    },
    "run-frontleft": {
        scale: 1,
        speed: 0.25
    },
    "run-frontright": {
        scale: 1,
        speed: 0.25
    },
    "run-backleft": {
        scale: 1,
        speed: 0.25
    },
    "run-backright": {
        scale: 1,
        speed: 0.25
    },
    "idle-frontleft": {
        scale: 1
    },
    "idle-frontright": {
        scale: 1
    },
    "idle-backleft": {
        scale: 1
    },
    "idle-backright": {
        scale: 1
    },
    "cast-frontleft": {
        scale: 1,
        speed: 0.2
    },
    "cast-frontright": {
        scale: 1,
        speed: 0.2
    },
    "cast-backleft": {
        scale: 1,
        speed: 0.2
    },
    "cast-backright": {
        scale: 1,
        speed: 0.2
    },
    "thrust-frontleft": {
        scale: 1,
        speed: 0.55
    },
    "thrust-frontright": {
        scale: 1,
        speed: 0.55
    },
    "thrust-backleft": {
        scale: 1,
        speed: 0.55
    },
    "thrust-backright": {
        scale: 1,
        speed: 0.55
    },
    "slash-frontleft": {
        scale: 1,
        speed: 0.25
    },
    "slash-frontright": {
        scale: 1,
        speed: 0.25
    },
    "slash-backleft": {
        scale: 1,
        speed: 0.25
    },
    "slash-backright": {
        scale: 1,
        speed: 0.25
    },
    "shoot-frontleft": {
        scale: 1,
        speed: 0.85
    },
    "shoot-frontright": {
        scale: 1,
        speed: 0.85
    },
    "shoot-backleft": {
        scale: 1,
        speed: 0.85
    },
    "shoot-backright": {
        scale: 1,
        speed: 0.85
    },
    "hurt-front": {
        scale: 1
    }
};
// An attack thrown on the move is named `<attack>.<gait>.<phase>-<facing>` (Ember, see
// game-common/ember_sprite/generate movingAttackName): it is still that attack.
const $d782e74b2eaa8700$var$animationToAction = (animation)=>animation.split("-")[0].split(".")[0];
const $d782e74b2eaa8700$var$isDirectional = (type)=>type.includes("-");
const $d782e74b2eaa8700$var$isAttackAnimation = (animationName)=>[
        "shoot",
        "thrust",
        "slash"
    ].includes($d782e74b2eaa8700$var$animationToAction(animationName));
const $d782e74b2eaa8700$var$isActivationAnimation = (animationName)=>[
        "activate",
        "deactivate"
    ].includes($d782e74b2eaa8700$var$animationToAction(animationName));
const $d782e74b2eaa8700$var$isWalkAnimation = (animationName)=>[
        "walk"
    ].includes($d782e74b2eaa8700$var$animationToAction(animationName));
const $d782e74b2eaa8700$var$extractDirection = (animation)=>animation.split("-")[1];
const $d782e74b2eaa8700$var$actionTypeToAnimationAction = (actionType)=>{
    if (actionType === "activate") return "activate";
    if (actionType === "deactivate") return "deactivate";
    if (actionType === "inactive") return "inactive";
    if (actionType === "active") return "active";
};
const $d782e74b2eaa8700$var$isLooped = (animation)=>{
    if ($d782e74b2eaa8700$var$isAttackAnimation(animation) || $d782e74b2eaa8700$var$isActivationAnimation(animation)) return false;
    // A held pose is a one-shot that STOPS on its final frame. Looping it would replay the collapse
    // over and over -- a body falling down, standing up and falling again -- instead of lying
    // there, which is the whole of what the pose depicts.
    if ($d782e74b2eaa8700$export$8280b108092dda60(animation)) return false;
    // A settle (an Ember body coming to rest) plays once and hands over to idle.
    if ($d782e74b2eaa8700$var$animationToAction(animation) === "settle") return false;
    return true;
};
class $d782e74b2eaa8700$export$7e6fc99bfa4004f1 {
    constructor(doneCallback){
        this.jobs = new Set();
        this.offer = (job)=>{
            this.jobs.add(job);
        };
        this.complete = (job)=>{
            this.jobs.delete(job);
            if (this.completed) return;
            if (this.jobs.size < 1) {
                this.completed = true;
                this.doneCallback();
            }
        };
        this.clear = ()=>{
            this.jobs.clear();
            this.completed = false;
        };
        this.doneCallback = doneCallback;
    }
}
// Single shared driver for every LpcCompositeSprite's periodic callback maintenance. Each sprite
// used to create its OWN setInterval(100ms) + setInterval(10s); with many sprites on screen that
// was dozens of independent timer wake-ups per second on the main thread -- a real cost on low-end
// CPUs. One shared pair of timers iterating the registered set is far cheaper, and each sprite's
// check early-returns when it has no active callbacks. The timers exist only while >=1 sprite is
// registered, so an empty scene schedules nothing.
class $d782e74b2eaa8700$var$LpcSpriteMaintenanceTicker {
    constructor(){
        this.sprites = new Set();
        this.register = (sprite)=>{
            this.sprites.add(sprite);
            if (this.missingTimer === undefined) this.missingTimer = setInterval(this.runMissingChecks, 100);
            if (this.orphanedTimer === undefined) this.orphanedTimer = setInterval(this.runOrphanedCleanup, 10000);
        };
        this.unregister = (sprite)=>{
            if (!this.sprites.delete(sprite)) return;
            if (this.sprites.size === 0) {
                clearInterval(this.missingTimer);
                clearInterval(this.orphanedTimer);
                this.missingTimer = undefined;
                this.orphanedTimer = undefined;
            }
        };
        // Iterate a snapshot and isolate each sprite so one throwing check can't stop maintenance for
        // the rest (and can't kill the shared interval).
        this.runMissingChecks = ()=>{
            Array.from(this.sprites).forEach((s)=>{
                try {
                    s.checkForMissingCallbacks();
                } catch (e) {
                // best-effort maintenance
                }
            });
        };
        this.runOrphanedCleanup = ()=>{
            Array.from(this.sprites).forEach((s)=>{
                try {
                    s.cleanupOrphanedCallbacks();
                } catch (e) {
                // best-effort maintenance
                }
            });
        };
    }
}
const $d782e74b2eaa8700$var$lpcSpriteMaintenanceTicker = new $d782e74b2eaa8700$var$LpcSpriteMaintenanceTicker();
class $d782e74b2eaa8700$export$db88fc637337eefb extends (0, $a64b70167386625f$export$98e91636974d835d) {
    // Show or hide the ground ring without rebuilding anything. Hiding rather than disposing: an
    // invader's ring comes back the moment they are their own person again, and a sprite that threw
    // the ring away would have to rebuild its layers to get one.
    setPlayerRingVisible(visible) {
        if (this.playerRing) this.playerRing.visible = visible;
    }
    setStatusHaloTier(tier) {
        this.statusHalo?.setTier(tier);
    }
    constructor({ descriptors: descriptors, renderMeta: renderMeta = $d782e74b2eaa8700$var$defaultRenderMeta, attackAction: attackAction, angle: angle, hasHalo: hasHalo, hasShadow: hasShadow, feetY: feetY, bodyFrame: bodyFrame = {
        w: 64,
        h: 64
    }, groundAnchor: groundAnchor, placement: placement = {
        x: 0,
        y: 0
    }, hasPlayerRing: hasPlayerRing, breathingSeed: breathingSeed, id: id, priority: priority, loadObserver: loadObserver, isSubmerged: isSubmerged, heldObject: heldObject, defaultAction: defaultAction, heldPose: heldPose }){
        super(), this.walkPace = new (0, $5db32d8baa90944d$export$da5eb4266422a064)(), this.spriteAngle = 0, this.shadeEased = {
            body: 0,
            cast: 0
        }, this.shadeEasedAt = 0, this.castLooked = {
            generation: -1,
            roomId: undefined,
            x: NaN,
            y: NaN,
            dirX: NaN,
            dirY: NaN,
            height: NaN,
            share: 0
        }, this.action = "idle-front", this.prevAction = "idle-front", this.animations = {}, // Set once this sprite has been discarded, so a late async generate callback disposes its
        // clone instead of adopting it (and leaking a cache reference).
        this.spriteReleased = false, // Cache key retained at request time for each action we've prepared (see doPreparation). Released
        // once per entry in cleanup() -- covers adopted, still-loading, and failed actions alike.
        this.preparedActionKeys = new Map(), this.facingDir = "front", this.attackAction = "idle", this.animationDictionaryTypeLoadingState = new Map(), this.feetY = 60, this.groundAnchor = {
            x: 32,
            y: 60
        }, this.bodyFrame = {
            w: 64,
            h: 64
        }, this.placement = {
            x: 0,
            y: 0
        }, this.spriteShadowTicking = false, this.actionCompleteListeners = new Map(), // Enhanced callback management
        this.callbackStates = new Map(), this.activeCallbacks = new Set(), this.currentAnimationCallbacks = new Set(), // Whether this sprite is registered with the shared maintenance ticker (see startCleanupTimer).
        this.registeredWithTicker = false, this.bodyPoseDriver = new (0, $73a6944abc919b07$export$13ce8c5ec6161fd3)(), this.animationPoseDriver = new (0, $21f1d04df0291d18$export$fcc246d4cf8db2cd)(), this.breathingAlive = true, // True while the NEXT activation of the held pose should play its animation through rather than
        // snap to the final frame: we watched this body go down, so the fall is worth showing. Set by
        // setHeldPose and consumed by the activation it was set for.
        this.playHeldPoseEntry = false, // True while the body is GETTING UP: the pose's own animation running backwards, from the
        // ground back to standing. `heldPose` stays set throughout, so every guard that protects a held
        // pose protects the rise too; it is cleared when the rise lands (see releaseHeldPose).
        this.rising = false, this.updateIdleBreathing = ()=>{
            const job = this.animations[this.action];
            const active = job?.animation ?? job?.sprite;
            const idle = this.action.startsWith("idle-") && !this.heldPose && !this.bodyPose && this.breathingAlive && window.playerBreathing !== false;
            this.idleBreathing?.update(idle && active?.visible ? active : undefined, this.groundAnchor, Date.now());
        }, // Per-frame: draw the active animation's current frame a second time, projected onto the ground
        // along the sun vector, as a real pose-accurate shadow. Reuses the entity's own baked frame textures
        // (shared, refcounted by the generator) -- no new bake, no filter. The projection is a planar shadow
        // matrix: every pixel of the sprite's height above the feet is displaced by (dirX, dirY) on the
        // ground, so (dirX, dirY) IS the sun angle. Defaults cast a shallow shadow toward the lower-left to
        // match the map's baked bush/tree shadows. window.spriteShadow = false falls back to the ellipse;
        // window.spriteShadow{DirX,DirY,Alpha} tune it live without a reload.
        this.updateSpriteShadow = ()=>{
            const shadow = this.spriteShadow;
            if (!shadow) return;
            // On by default; set window.spriteShadow = false to fall back to the foot ellipse.
            const w = window;
            const on = w.spriteShadow !== false;
            // Swap which shadow style is visible.
            if (this.shadow) this.shadow.visible = !on;
            if (!on) {
                if (shadow.visible) shadow.release();
                return;
            }
            const job = this.animations[this.action];
            const active = job?.animation ?? job?.sprite;
            if (!active || !active.visible) {
                shadow.visible = false;
                return;
            }
            // Sun vector: ground displacement per pixel of sprite height. dirX < 0 leans left, dirY > 0
            // stretches "south". The room's light, as its map casts with it (the sun, or the moon by night),
            // unless a body-only one is set live.
            const own = typeof w.spriteShadowDirX === "number" || typeof w.spriteShadowDirY === "number";
            const { x: dirX, y: dirY } = own ? (0, $a44874d288f3eb63$export$c794283427cbd942)() : (0, $a1ff1a141ce12c85$export$915c685ef07238e8)(this.shadeRoomId) ?? (0, $a44874d288f3eb63$export$aa4bd1b541804cf)();
            // Standing in the world's shade: darkened like the ground there, and no shadow of its own. Its shadow
            // falling into shade adds nothing there either: it fades by the share of it that does. All eased,
            // stepping in and out, rather than switched.
            // As strong as the room's shade shows (daylight); full where no map has said yet.
            const strength = (0, $a1ff1a141ce12c85$export$5359f04ca60f9df2)(this.shadeRoomId);
            const inShade = this.solesX !== undefined && (0, $a1ff1a141ce12c85$export$55e3e87f5132cc63)(this.shadeRoomId, this.solesX, this.solesY);
            const shaded = this.easeShade(inShade ? 1 : 0, this.castInShade(dirX, dirY, (0, $a44874d288f3eb63$export$f33d3a7b1193a664).height * Math.abs(active.scale.y)), w);
            const tint = (0, $a1ff1a141ce12c85$export$4680da062056e5ae)(this.currentColor ?? 0xffffff, shaded.body * (strength ?? 0), (0, $a1ff1a141ce12c85$export$92d477a5aa3f6953)(this.shadeRoomId));
            if (active.tint !== tint) active.tint = tint;
            const tex = job.animation ? job.animation.textures[job.animation.currentFrame] : job.sprite.texture;
            if (!tex || !tex.valid) {
                shadow.visible = false;
                return;
            }
            const alpha = typeof w.spriteShadowAlpha === "number" ? w.spriteShadowAlpha : (0, $a44874d288f3eb63$export$f33d3a7b1193a664).alpha;
            const softness = typeof w.spriteShadowSoftness === "number" ? w.spriteShadowSoftness : (0, $a44874d288f3eb63$export$f33d3a7b1193a664).softness;
            shadow.show(tex, (0, $7a6a96784834664b$export$d2a7abcc031e1aca)({
                x: (this.groundAnchor.x - active.x) / active.scale.x,
                y: ((0, $9667a1379a787b5e$export$334e00c898f4892e)(this.bodyFrame.w, this.bodyFrame.h, this.feetY).y - active.y) / active.scale.y
            }, this.groundAnchor, active.scale.x, active.scale.y, dirX, dirY), alpha * (strength ?? 1) * (1 - shaded.body) * (1 - shaded.cast), (0, $a44874d288f3eb63$export$f33d3a7b1193a664).color, softness);
        }, // The frame the water reflects: the active animation (or still) itself, drawn on its own, so the
        // reflection carries the pose and none of what is round it -- shadow, rings, halos, outline.
        this.reflectionArt = ()=>{
            const job = this.animations[this.action];
            const active = job?.animation ?? job?.sprite;
            return active && active.visible && !active.destroyed ? active : undefined;
        }, // The frame EntityHighlight traces for the hover outline: the active animation's current baked
        // texture plus the transform it is drawn with, so the outline lands exactly on the pose (including
        // any oversize offset already baked into active.x/scale) and follows the animation frame by frame.
        // Null while the sheets are still loading or when this sprite has no art of its own -- the caller
        // then falls back to a footprint ring.
        this.highlightFrame = ()=>{
            const result = this.animations[this.action];
            const active = result?.animation ?? result?.sprite;
            if (!active || !active.visible) return null;
            const texture = result.fragmentBase();
            if (!texture?.valid) return null;
            return {
                texture: texture,
                x: active.x,
                y: active.y,
                scaleX: active.scale.x,
                scaleY: active.scale.y,
                anchorX: active.anchor?.x ?? 0,
                anchorY: active.anchor?.y ?? 0
            };
        }, this.heldAttackGripWorld = (race)=>{
            const frame = this.animations[this.action]?.animation?.currentFrame ?? 0;
            const point = this.action.startsWith("slash-") && race === "skeleton" ? (0, $e063f6eb3a8e708e$export$70e96cb8c74dadda)(this.action, frame, "male") : (0, $7e34d28912a06f25$export$892d851620cf8272)(race, this.action, frame);
            if (!point || !this.initialized) return undefined;
            const world = this.toGlobal({
                x: point.x + this.placement.x,
                y: point.y + this.placement.y
            });
            const hands = (0, $7e34d28912a06f25$export$726616493d9a5aa4)(race, this.action, frame)?.map((hand)=>this.toGlobal({
                    x: hand.x + this.placement.x,
                    y: hand.y + this.placement.y
                }));
            return {
                x: world.x,
                y: world.y,
                scale: Math.hypot(this.worldTransform.a, this.worldTransform.b),
                hands: hands
            };
        }, this.headAttachmentWorld = (race)=>{
            const result = this.animations[this.action];
            const frame = result?.animation?.currentFrame ?? 0;
            const point = (0, $7e34d28912a06f25$export$83b0fb0a2abe0f79)(race, this.action, frame);
            if (!point || !this.initialized) return undefined;
            return this.toGlobal({
                x: point.x + this.placement.x,
                y: point.y + this.placement.y
            });
        }, this.setHighlighted = (on)=>{
            if (!this.highlight) {
                if (!on) return true;
                this.highlight = new (0, $95f2390044c89843$export$b6cf31fac6564392)({
                    artContainer: this.container,
                    frame: this.highlightFrame
                });
            }
            this.highlight.set(on);
            return true;
        }, this.logme = (msg, m2 = "", m3 = "")=>{
        // console.log(this.creationTs, "@@@", this.identifier, msg, m2, m3)
        }, this.initalize = (id, angle)=>{
            this.identifier = id;
            const f = this.calcDir(angle);
            // Asked here rather than in the constructor: a subclass's answer may rest on its own fields.
            if (this.heldPose && !this.drawsHeldPose(this.heldPose)) this.heldPose = undefined;
            // A body that is already in a held pose builds straight into it. Going through idle first
            // would bake an action nothing ever shows, and (worse) put a standing frame on screen for
            // the frame or two before the pose's own sheets finish loading.
            const action = this.heldAnimation() || $d782e74b2eaa8700$var$actionTypeToAnimationAction(this.defaultAction) || "idle-" + f;
            let descriptorCountdown = this.descriptors.length;
            this.logme("initializing sheets", id);
            const s = Date.now();
            this.loadObserver?.offer(action);
            // No sheets to wait on: the per-descriptor countdown below would never reach zero, leaving
            // the sprite permanently uninitialized (and blank). Initialize straight away instead.
            if (descriptorCountdown <= 0) {
                this.initialized = true;
                this.loadObserver?.complete(action);
                this.startCleanupTimer();
                this.activateAnimation(action, true);
                return;
            }
            this.descriptors.forEach((descriptor, i)=>{
                const sheetId = `lpc/spritesheets/${descriptor.entityId}.json`;
                const url = `assets/${sheetId}`;
                this.logme("loading", url);
                (0, $c1d8cd49591538f1$export$cd02f82db8cdb05).load(url, (_)=>{
                    descriptorCountdown -= 1;
                    if (descriptorCountdown <= 0) {
                        this.initialized = true;
                        this.logme("@@@ all sheets loaded", action);
                        this.loadObserver?.complete(action);
                        // Start cleanup timer for orphaned callbacks
                        this.startCleanupTimer();
                        const elapsed = Date.now() - s;
                        this.activateAnimation(action, true);
                    }
                });
            });
        }, this.recolor = (color)=>{
            if (this.currentColor === color) return;
            this.currentColor = color;
            const source = this.animations[`${this.action}`];
            if (source) source.recolor(color);
        }, this.postAnimation = (animation)=>{
            if ($d782e74b2eaa8700$var$isAttackAnimation(animation)) return `idle-${$d782e74b2eaa8700$var$extractDirection(this.action)}`;
            if (animation === "activate") return "active";
            if (animation === "deactivate") return "inactive";
        }, this.doPreparation = (action)=>{
            this.logme("@@@ kicked off", action);
            this.animationDictionaryTypeLoadingState.set(action, "loading");
            this.requestAnimation(action, (result)=>{
                if (result) {
                    // Sprite was discarded before this async result arrived: dispose the orphan
                    // clone rather than adopting it into a detached container.
                    if (this.spriteReleased) {
                        (0, $39fb998eb7d66fde$export$7100d33e089ec0).abandon(result);
                        return;
                    }
                    const animation = result.animation;
                    const sprite = result.sprite;
                    if (animation) {
                        animation.x += this.placement.x;
                        animation.y += this.placement.y;
                        this.container.addChild(animation);
                    }
                    if (sprite) {
                        sprite.x += this.placement.x;
                        sprite.y += this.placement.y;
                        this.container.addChild(sprite);
                    }
                    const postAnimation = this.postAnimation(action);
                    this.logme("caching", action);
                    if (animation) {
                        animation.loop = $d782e74b2eaa8700$var$isLooped(action);
                        const listeners = this.actionCompleteListeners.get($d782e74b2eaa8700$var$animationToAction(action));
                        if (listeners?.size() > 0) {
                            const totalFrames = animation.totalFrames;
                            animation.onFrameChange = (frame)=>{
                                const pct = frame / (totalFrames - 1);
                                if (pct > 0.5) // Enhanced callback execution with state tracking
                                this.executeCallbacks(listeners, $d782e74b2eaa8700$var$animationToAction(action));
                            };
                        }
                        if (postAnimation) animation.onComplete = ()=>{
                            this.activateAnimation(postAnimation);
                        };
                        else // Add completion handler for cleanup
                        animation.onComplete = ()=>{
                            this.cleanupAnimationCallbacks(action);
                        };
                    }
                    if (sprite) {
                        const listeners = this.actionCompleteListeners.get($d782e74b2eaa8700$var$animationToAction(action));
                        if (listeners?.size() > 0) listeners.forEach((listener)=>{
                            listener.callback();
                            listeners.remove(listener.entityId);
                        });
                    }
                    this.animations[action] = result;
                    // No retain here: the key was already retained at request time (requestAnimation).
                    // Retain-at-request closes the async request->adopt window that retain-on-adopt left
                    // open (eviction could destroy the shared textures before this clone went live).
                    this.logme("is all prepared for", action);
                    this.animationDictionaryTypeLoadingState.set(action, "loaded");
                    if (this.adoptsOnLoad(action)) this.activateAnimation(action, true);
                    if (sprite && postAnimation) this.activateAnimation(postAnimation);
                } else {
                    this.logme("! could not prepare", action);
                    this.animationDictionaryTypeLoadingState.set(action, "failed");
                }
            });
        }, this.prepare = (updatedAction)=>{
            this.logme("@@@ prepare", updatedAction);
            if (this.animations[updatedAction]) {
                this.logme("@@@ already exists", updatedAction);
                // already exists
                return;
            }
            const loadState = this.animationDictionaryTypeLoadingState.get(updatedAction);
            if (loadState && loadState !== "loaded" && loadState !== "failed") {
                this.logme("@@@", updatedAction, "still in progress");
                // still in progress
                return;
            }
            if (loadState === "failed") {
                this.logme("@@@", updatedAction, "failed");
                return;
            }
            // kick it off
            this.doPreparation(updatedAction);
        }, /**
     * True when activating `action` should freeze it on its last frame instead of playing it: the
     * body is held in this pose, and we did not watch it arrive there.
     */ this.holdsFinalFrame = (action)=>!!this.heldPose && action === this.heldAnimation() && !this.playHeldPoseEntry, /** The animation of the pose this body is held in, in the facing it took it in. */ this.heldAnimation = ()=>this.heldPose ? $d782e74b2eaa8700$var$heldPoseAnimation(this.heldPose, this.heldFacing ?? this.facingDir) : undefined, /**
     * Put this body into a held pose, or let it back out of one. Idempotent: re-asserting the pose
     * already held does nothing, which matters because the caller re-reads it every frame.
     *
     * `animate` chooses between the two ways a body arrives in a pose. Watching someone fall should
     * play the collapse; walking up to someone who fell before you got there should not, and nor
     * should a paperdoll rebuild -- the body would stand up and fall over again every time its
     * inventory changed.
     */ this.setHeldPose = (pose, animate = true)=>{
            // A pose this body cannot draw is no pose at all: it goes on as it was.
            if (pose && !this.drawsHeldPose(pose)) pose = undefined;
            if (pose) {
                const alreadyHeld = pose === this.heldPose;
                if (alreadyHeld && !this.rising) return;
                // Going back down, possibly from halfway up: whichever, the rise is over.
                this.endRise();
                this.heldPose = pose;
                if (!alreadyHeld) this.heldFacing = this.facingDir;
                // Falling interrupts the ladder/ability pose. Leaving its action guard in place
                // blocks hurt from becoming the current action; recovery then plays hurt in
                // reverse without ever retiring it, leaving a second body beside the idle.
                this.bodyPose = undefined;
                // A body caught halfway up and put back down does not deserve the whole fall again --
                // it is already on the floor as far as the viewer is concerned.
                this.playHeldPoseEntry = animate && !alreadyHeld;
                this.activateAnimation(this.heldAnimation(), true);
                return;
            }
            if (!this.heldPose || this.rising) // Nothing to let go of, or already on the way up.
            return;
            this.beginRise();
        }, /**
     * Start getting up: the pose's own animation, played backwards.
     *
     * `heldPose` deliberately stays set until this lands. Every guard that keeps a fallen body on
     * the ground -- the walk/idle driver, the facing change, a late bake, an attack -- is written
     * against `heldPose`, and a body halfway up needs all of them just as much as one lying still.
     */ this.beginRise = ()=>{
            const animation = this.animations[this.heldAnimation()]?.animation;
            if (!animation) {
                // The pose never baked (a sheet that failed, a race with no `hurt` row). There is no
                // collapse on screen to reverse, so stand up at once rather than wait for nothing.
                this.releaseHeldPose();
                return;
            }
            this.rising = true;
            this.riseRestoreOnComplete = animation.onComplete;
            animation.onComplete = ()=>this.releaseHeldPose();
            this.animations[this.heldAnimation()].playReverse();
        }, /** Stop rising without standing up -- the sign and the borrowed callback both go back. */ this.endRise = ()=>{
            if (!this.rising) return;
            this.rising = false;
            const animation = this.heldPose && this.animations[this.heldAnimation()]?.animation;
            if (animation) {
                animation.animationSpeed = Math.abs(animation.animationSpeed);
                animation.onComplete = this.riseRestoreOnComplete;
            }
            this.riseRestoreOnComplete = undefined;
        }, /** The rise has landed (or been cut short): the body is standing and free to act again. */ this.releaseHeldPose = ()=>{
            this.endRise();
            this.heldPose = undefined;
            // Idle rather than walk: doMovement picks the walk up again on the next frame this body
            // actually moves, and guessing otherwise would slide a standing character.
            this.activateAnimation(`idle-${this.facingDir}`, true);
        }, this.activateAnimation = (updatedAction, force)=>{
            if (!this.initialized) return;
            // A held pose OUTRANKS every other source of animation, not just the walk/idle driver that
            // doMovement already returns before. The one that bites without this is a late bake: a walk
            // requested a moment before the body went down lands asynchronously and activates itself
            // (see doPreparation), standing a fallen character back up seconds after they fell. An
            // attack swing arriving for a body that is on the ground is the same bug with a sword.
            //
            // Releasing the pose still works, because setHeldPose clears `heldPose` before it activates
            // the idle it hands back to.
            if (this.heldPose && updatedAction !== this.heldAnimation()) return;
            // And the other way round: a pose's own animation baked after the pose was let go of (a
            // short fall lands before its frames do) would put the body back in it, arms up, for good.
            if (!this.heldPose && $d782e74b2eaa8700$export$8280b108092dda60(updatedAction)) return;
            // An asynchronously baked old facing or attack may land after a phase change.
            if (this.bodyPose && updatedAction !== this.bodyPose.action) return;
            this.logme("->", updatedAction);
            if (updatedAction === this.action && !force) // noop
            return;
            // Clean up callbacks for current animation before changing
            this.cleanupCurrentAnimationCallbacks();
            const source = this.animations[`${this.action}`];
            const toUpdate = this.animations[`${updatedAction}`];
            if (!toUpdate) {
                // const currentState = this.animationDictionaryTypeLoadingState[updatedAction]
                // if (currentState === "loading" || currentState === "failed") {
                //     return
                // }
                this.logme(updatedAction, "not present, prepping");
                this.prepare(`${updatedAction}`);
                return;
            }
            this.applyPace(updatedAction, toUpdate.animation);
            if (source) {
                // Cancel callbacks before stopping animation
                this.cancelCurrentAnimationCallbacks();
                source.stop();
            }
            // Update action and start new animation
            this.action = updatedAction;
            if (this.holdsFinalFrame(updatedAction)) // Snap to the pose rather than replay the fall that put the body there. Consumed here
            // and not at setHeldPose, because the first activation after it typically finds no
            // baked animation yet and returns above having only queued the bake.
            toUpdate?.holdFinalFrame();
            else toUpdate?.play(this.animationStartFrame(updatedAction, toUpdate.animation));
            this.playHeldPoseEntry = false;
            // Reapply the current tint: each action's clone was built with whatever color was current
            // when it was baked, so an animation prepared before the last recolor() would otherwise
            // show its stale build-time color when activated.
            if (this.currentColor !== undefined) toUpdate?.recolor(this.currentColor);
            // CRITICAL FIX: Preserve listeners when changing animation directions for the same action
            this.preserveListenersForSameAction(updatedAction);
            // Set up callbacks for new animation
            this.setupNewAnimationCallbacks(updatedAction);
            // CRITICAL FIX: Ensure callbacks are set up even if animation is already loaded
            this.ensureCallbacksAreSetUp(updatedAction);
            this.applyBodyPose();
        }, this.applyBodyPose = ()=>{
            const pose = this.bodyPose;
            if (!pose || this.action !== pose.action) return;
            const animation = this.animations[this.action]?.animation;
            if (animation) animation.gotoAndStop(Math.min(animation.textures.length - 1, pose.frame ?? Math.round(pose.progress * (animation.textures.length - 1))));
        }, this.addActionListener = (action, actionListener)=>{
            const callbackId = (0, $a80d0b17b615d6f7$export$5e699d18035b41af)();
            const callbackState = {
                entityId: actionListener.entityId,
                callback: actionListener.callback,
                animationName: this.action,
                actionType: action,
                createdAt: Date.now(),
                status: "pending"
            };
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Adding action listener: ${callbackId} for action: ${action}, current animation: ${this.action}`);
            this.callbackStates.set(callbackId, callbackState);
            this.activeCallbacks.add(callbackId);
            // Store in existing system for compatibility
            let listeners = this.actionCompleteListeners.get(action);
            if (!listeners) {
                listeners = new (0, $cb689cfa16c444ba$export$cbcb4f84fc8dd985)();
                this.actionCompleteListeners.set(action, listeners);
                (0, $5UG8I.logger).debug({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `Created new listeners map for action: ${action}`);
            }
            listeners.add({
                ...actionListener,
                callbackId: callbackId
            });
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Added listener to map. Total listeners for ${action}: ${listeners.size()}`);
        }, this.fragment = (entity)=>{
            let actionToUse = this.action;
            if (!this.renderMeta[this.action]) actionToUse = `idle-${this.facingDir}`;
            if (!this.renderMeta[actionToUse]) return;
            const { scale: scale } = this.renderMeta[actionToUse];
            const surface = new (0, $gwPoJ.Graphics)();
            surface.x = this.parent?.x - this.parent.width * 0.5;
            surface.y = this.parent?.y - this.parent.height * 0.5;
            surface.scale.set(scale);
            surface.rotation = this.container.rotation;
            this.parent.parent.addChild(surface);
            const f = this.animations[`${actionToUse}`]?.fragmentBase();
            if (!f) return;
            (0, $4264eae3240561ee$export$cc249234599c5a64)(surface, f, {
                cacheKey: entity.appearance?.race
            });
        };
        // TEST: Log immediately to verify logging is working
        (0, $5UG8I.logger).info({
            tags: [
                "callback",
                "animation"
            ]
        }, `LPC Composite Sprite created for entity ${id}, action: ${this.action}`);
        this.id = id;
        this.priority = priority;
        this.renderMeta = {
            ...$d782e74b2eaa8700$var$defaultRenderMeta,
            ...renderMeta
        };
        this.renderProps = {
            bodyFrame: bodyFrame,
            isSubmerged: isSubmerged,
            heldObject: heldObject
        };
        this.attackAction = attackAction;
        this.spriteAngle = angle;
        this.facingDir = this.calcDir(angle);
        this.container = new (0, $gwPoJ.Graphics)();
        this.addChild(this.container);
        this.loadObserver = loadObserver;
        if (hasHalo) {
            const halo = new (0, $gwPoJ.Graphics)();
            halo.alpha = 0.5;
            halo.beginFill(0xffffff);
            halo.drawCircle(32, 25, 13);
            halo.endFill();
            this.halo = halo;
            this.container.addChild(halo);
        }
        // The ground line this body stands on, shared by the foot shadow and the player ring. A
        // submerged body sits higher in its frame, so its feet are higher too.
        this.feetY = feetY ?? (isSubmerged ? 55 : 60);
        this.placement = placement;
        this.bodyFrame = bodyFrame;
        const feet = this.groundAnchor = groundAnchor ?? (0, $9667a1379a787b5e$export$334e00c898f4892e)(bodyFrame.w, bodyFrame.h, this.feetY);
        if (hasShadow) {
            const shadow = new (0, $gwPoJ.Graphics)();
            shadow.alpha = 0.2;
            shadow.beginFill(0x000000);
            shadow.drawEllipse(feet.x, feet.y, 16, 8);
            shadow.endFill();
            this.shadow = shadow;
            this.container.addChild(shadow);
            // Projected silhouette shadow -- on by default (window.spriteShadow = false falls back to
            // the ellipse). Sits behind the character; the per-frame update swaps which one is visible.
            const spriteShadow = new (0, $b34e67be95b052b6$export$4f6c8c01d6893aa0)();
            spriteShadow.visible = false;
            this.spriteShadow = spriteShadow;
            this.container.addChild(spriteShadow);
            (0, $3YyWq.Ticker).shared.add(this.updateSpriteShadow);
            this.spriteShadowTicking = true;
        }
        if (hasShadow) {
            // Built here, with the shadows, and NOT lazily when a status first arrives -- the
            // container has no sortableChildren, so a child's z-order is the order it was added in,
            // and anything created later would land on top of the body instead of under it. Costs an
            // invisible Graphics with no geometry in it until something is actually wrong with this
            // member; see MemberStatusHalo.
            const halo = new (0, $83feb2ed45960f8f$export$3fa5036cf9319808)();
            halo.x = feet.x;
            halo.y = feet.y;
            this.statusHalo = halo;
            this.container.addChild(halo);
        }
        if (hasPlayerRing) {
            // Added after both shadows so neither darkens the marker, and before the animation layers
            // (which arrive later, see doPreparation) so the body occludes its middle and the character
            // reads as standing inside the ring rather than in front of a decal.
            const ring = new (0, $4422ba9e5bf47053$export$54b95433f33ae529)();
            ring.x = feet.x;
            ring.y = feet.y;
            this.playerRing = ring;
            this.container.addChild(ring);
        }
        this.descriptors = descriptors;
        this.creationTs = Date.now();
        this.defaultAction = defaultAction;
        // Set before initalize() runs so the FIRST action this sprite ever prepares is the pose
        // itself, rather than an idle frame it would immediately replace.
        this.heldPose = heldPose;
        this.heldFacing = this.facingDir;
        if (breathingSeed !== undefined) {
            this.idleBreathing = new (0, $b14c359149a9de22$export$d861f9901197fdf3)(breathingSeed);
            // Run before the shadow/outline sample the body transform.
            (0, $3YyWq.Ticker).shared.add(this.updateIdleBreathing, this, 1);
        }
    }
    // How far into the shade the body and its shadow show, eased toward `body` and `cast` over
    // BODY_SHADOW.fadeMs (smoothed at both ends). Lands at once on a body's first frame or a new room, so
    // nothing fades in on arrival.
    easeShade(body, cast, w) {
        const now = performance.now();
        const shown = this.shadeShown;
        if (!shown || this.shadeEasedRoomId !== this.shadeRoomId) this.shadeShown = {
            body: body,
            cast: cast
        };
        else {
            const fadeMs = typeof w.spriteShadowFadeMs === "number" ? w.spriteShadowFadeMs : (0, $a44874d288f3eb63$export$f33d3a7b1193a664).fadeMs;
            const dt = Math.min(100, now - this.shadeEasedAt);
            shown.body = (0, $a44874d288f3eb63$export$e5c36c349c8642df)(shown.body, body, dt, fadeMs);
            shown.cast = (0, $a44874d288f3eb63$export$e5c36c349c8642df)(shown.cast, cast, dt, fadeMs);
        }
        this.shadeEasedAt = now;
        this.shadeEasedRoomId = this.shadeRoomId;
        const smooth = (s)=>s * s * (3 - 2 * s);
        this.shadeEased.body = smooth(this.shadeShown.body);
        this.shadeEased.cast = smooth(this.shadeShown.cast);
        return this.shadeEased;
    }
    // The share of this body's shadow, `height` px of body cast along (dirX, dirY), lying in the world's
    // shade already. Looked for again only once the body moves, the sun turns or the shade changes.
    castInShade(dirX, dirY, height) {
        if (this.solesX === undefined) return 0;
        const looked = this.castLooked, generation = (0, $a1ff1a141ce12c85$export$4b799469db4c19c)();
        const x = Math.round(this.solesX), y = Math.round(this.solesY);
        if (looked.generation !== generation || looked.roomId !== this.shadeRoomId || looked.x !== x || looked.y !== y || looked.dirX !== dirX || looked.dirY !== dirY || looked.height !== height) {
            const points = (0, $59778fc6a8174634$export$a3650d57e5c29c1c)({
                x: x,
                y: y
            }, height, {
                x: dirX,
                y: dirY
            });
            looked.share = points.filter((p)=>(0, $a1ff1a141ce12c85$export$55e3e87f5132cc63)(this.shadeRoomId, p.x, p.y)).length / points.length;
            Object.assign(looked, {
                generation: generation,
                roomId: this.shadeRoomId,
                x: x,
                y: y,
                dirX: dirX,
                dirY: dirY,
                height: height
            });
        }
        return looked.share;
    }
    calcDir(angle) {
        return (0, $a80d0b17b615d6f7$export$5ebc7cf9991d3d13)(angle);
    }
    doMovement(entity) {
        this.walkPace.update(entity);
        this.applyPace(this.action, this.animations[this.action]?.animation);
        this.breathingAlive = entity.hp > 0 && !entity.isDead() && entity.faction !== "undead";
        // Where the soles stand (location.y is the hip), for the buildings' shade (updateSpriteShadow).
        this.shadeRoomId = entity.roomId;
        this.solesX = entity.location?.x;
        this.solesY = entity.location ? entity.location.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763) : undefined;
        const { movement: movement } = entity;
        if (!movement) return;
        // A body already WALKING cannot still be getting up. The server frees the legs on the same
        // message that lifts `downed`, so a player who had a direction held is moving before the
        // reverse animation is a third of the way through -- and holding the prone frames out would
        // slide a body face-down across the ground. Movement wins: cut the rise short and let the
        // ordinary driver below pick up the walk on this very frame.
        // `lastX !== undefined` guards the same thing it guards in the walk branch below: on the
        // very first frame a body is drawn there is no previous position, so every coordinate
        // "differs" and the rise would be cut short before it drew a frame.
        if (this.rising && this.lastX !== undefined && (entity.location.x !== this.lastX || entity.location.y !== this.lastY)) this.releaseHeldPose();
        if (this.heldPose) {
            // A held pose OWNS this sprite. Everything below would take it away: the walk/idle
            // driver stands a fallen body up within 50ms of it stopping, and changeDirection asks
            // for a `hurt-left` that does not exist in any LPC sheet. It owns the sprite while the
            // body is getting up too -- `heldPose` is not cleared until the rise lands.
            //
            // The bookkeeping those branches do is still kept up to date, so that letting go of the
            // pose resumes from where the body actually is rather than from wherever it was when it
            // went down: the facing it would have had, and a position that does not read as a jump.
            this.facingDir = this.calcDir(movement.angle);
            this.spriteAngle = movement.angle;
            this.lastX = entity.location.x;
            this.lastY = entity.location.y;
            return;
        }
        const previousPose = this.bodyPose;
        this.bodyPose = this.animationPoseDriver.update(entity, Date.now()) || this.bodyPoseDriver.update(entity, Date.now()) || this.climbPose(entity);
        if (this.bodyPose) {
            if (this.idleTimeout !== undefined) {
                clearTimeout(this.idleTimeout);
                this.idleTimeout = undefined;
            }
            this.facingDir = $d782e74b2eaa8700$var$extractDirection(this.bodyPose.action);
            this.lastX = entity.location.x;
            this.lastY = entity.location.y;
            this.activateAnimation(this.bodyPose.action);
            this.applyBodyPose();
            return;
        }
        if (previousPose) this.activateAnimation(`idle-${this.facingDir}`);
        if (this.spriteAngle !== movement.angle) {
            const facingDir = this.calcDir(movement.angle);
            if (facingDir !== this.facingDir) // Enhanced direction change handling
            this.changeDirection(facingDir);
            this.facingDir = facingDir;
        }
        this.spriteAngle = movement.angle;
        const { x: x, y: y } = entity.location;
        if (x !== this.lastX || y !== this.lastY) {
            if (this.idleTimeout !== undefined) {
                clearTimeout(this.idleTimeout);
                this.idleTimeout = undefined;
            }
            if (this.lastX !== undefined && this.lastY !== undefined && !$d782e74b2eaa8700$var$isAttackAnimation(this.action)) this.activateAnimation(this.locomotionAnimation());
            this.lastX = x;
            this.lastY = y;
        } else if (this.idleTimeout === undefined) this.idleTimeout = setTimeout(()=>{
            // This timer has fired even if an attack still owns the body. Let the
            // movement driver schedule another idle check after the attack finishes.
            this.idleTimeout = undefined;
            if ($d782e74b2eaa8700$var$isAttackAnimation(this.action)) return;
            if (!(0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isStationary(entity)) this.activateAnimation(this.restAnimation());
        }, 50);
    }
    /**
     * What a body that has stopped moving plays: its idle. A body that can come to rest from where
     * its stride left it plays that instead (see EmberCompositeSprite). Asked again every 50ms while
     * the body stands still.
     */ restAnimation() {
        return `idle-${this.facingDir}`;
    }
    /** What the body plays on turning to `facing`: the same action that way. */ turnedAnimation(facing) {
        return `${this.action.split("-")[0]}-${facing}`;
    }
    /**
     * Whether an animation that has just finished baking starts playing. Each one was asked for to be
     * played, so it does; a body with animations it asks for ahead of time (or that can be overtaken
     * before they bake) says otherwise.
     */ adoptsOnLoad(_action) {
        return true;
    }
    /**
     * The frame of a climb a body on a ladder is drawn at, for a body that draws one. LPC sheets have
     * no climb row: an LPC body keeps the stair travel's walk.
     */ climbPose(_entity) {
        return undefined;
    }
    /**
     * Where an action's frames come from: here, the LPC sheets composited by the generator. A body
     * drawn some other way overrides this and hands back the same kind of result (see
     * EmberCompositeSprite); everything that happens once the frames arrive is shared.
     */ requestAnimation(action, callback) {
        // Retain this loadout's cache key NOW, at request time -- generation is async/time-budgeted
        // and the baked textures are shared across sprites, so retaining only on adopt (doPreparation) leaves
        // a window where eviction could destroy textures this sprite is about to display. Released
        // once per prepared action in cleanup().
        if (!this.preparedActionKeys.has(action)) {
            const key = (0, $39fb998eb7d66fde$export$7100d33e089ec0).computeKey(this.descriptors, action, this.renderProps);
            this.preparedActionKeys.set(action, key);
            (0, $39fb998eb7d66fde$export$7100d33e089ec0).retainKey(key);
        }
        (0, $39fb998eb7d66fde$export$7100d33e089ec0).generate(this.priority, action, this.renderMeta[action], this.renderProps, this.descriptors, callback, // Lets the generator drop this job cheaply if the sprite is discarded (entity torn down
        // on a room change) before the job runs, so it never bakes a texture nobody wants.
        ()=>this.spriteReleased);
    }
    /** What a body plays while it moves. LPC has one gait; bodies with more choose by speed. */ locomotionAnimation() {
        return `walk-${this.facingDir}`;
    }
    /** What a body plays as it attacks. LPC has one; a body that can strike on the move chooses. */ attackAnimation() {
        return `${this.attackAction}-${this.facingDir}`;
    }
    /** Keep the feet in step with the ground the body is drawn crossing (see WalkAnimationPace). */ applyPace(action, animation) {
        this.walkPace.apply(action, animation);
        if (animation && $d782e74b2eaa8700$var$animationToAction(action) === "shoot") animation.animationSpeed = animation.totalFrames / ((0, $a1fb04dc4139ce6e$export$dd2163ed96be013a).shoot * 60 / 1000);
    }
    /** Frame to start at when handing between actions, such as a strike back into its stride. */ animationStartFrame(_action, _animation) {
        return 0;
    }
    /** Whether this body has frames for a held pose: LPC sheets lie down (`hurt`), but have no fall. */ drawsHeldPose(pose) {
        return pose === "downed";
    }
    doAttack(entity, callback) {
        // TEST: Log immediately to verify attack logging is working
        (0, $5UG8I.logger).info({
            tags: [
                "callback",
                "animation"
            ]
        }, `ATTACK TEST: doAttack called for entity ${entity.entityId}, callback: ${!!callback}, action: ${this.action}`);
        (0, $5UG8I.logger).debug({
            tags: [
                "callback",
                "animation"
            ]
        }, `doAttack called with callback: ${!!callback}, current action: ${this.action}`);
        // Cancel any existing attack callbacks
        this.cancelAttackCallbacks();
        if ($d782e74b2eaa8700$var$isAttackAnimation(this.action)) {
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Already attacking, replacing callback`);
            // If already attacking, replace the callback
            this.replaceAttackCallback(callback);
            return;
        }
        if (this.disallowMoveAttackAnimation && $d782e74b2eaa8700$var$isWalkAnimation(this.action)) {
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Attack blocked - disallowMoveAttackAnimation and walking`);
            return;
        }
        this.prevAction = this.action;
        const newAction = this.attackAnimation();
        (0, $5UG8I.logger).debug({
            tags: [
                "callback",
                "animation"
            ]
        }, `Starting attack animation: ${newAction}`);
        if (callback) {
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Adding callback for action: ${$d782e74b2eaa8700$var$animationToAction(newAction)}`);
            this.addActionListener($d782e74b2eaa8700$var$animationToAction(newAction), {
                entityId: (0, $a80d0b17b615d6f7$export$5e699d18035b41af)(),
                callback: callback
            });
        }
        this.activateAnimation(newAction);
    }
    // Enhanced callback management methods
    cleanupCurrentAnimationCallbacks() {
        const currentAction = $d782e74b2eaa8700$var$animationToAction(this.action);
        const listeners = this.actionCompleteListeners.get(currentAction);
        if (listeners) {
            listeners.forEach((listener)=>{
                const callbackId = listener.callbackId;
                if (callbackId) this.cancelCallback(callbackId);
            });
            listeners.clear();
        }
    }
    cancelCurrentAnimationCallbacks() {
        this.currentAnimationCallbacks.forEach((callbackId)=>{
            this.cancelCallback(callbackId);
        });
        this.currentAnimationCallbacks.clear();
    }
    setupNewAnimationCallbacks(animationName) {
        const action = $d782e74b2eaa8700$var$animationToAction(animationName);
        const listeners = this.actionCompleteListeners.get(action);
        if (listeners?.size() > 0) listeners.forEach((listener)=>{
            const callbackId = listener.callbackId;
            if (callbackId) this.currentAnimationCallbacks.add(callbackId);
        });
    }
    cancelAttackCallbacks() {
        const attackActions = [
            "thrust",
            "slash",
            "shoot"
        ];
        attackActions.forEach((action)=>{
            const listeners = this.actionCompleteListeners.get(action);
            if (listeners) {
                listeners.forEach((listener)=>{
                    const callbackId = listener.callbackId;
                    if (callbackId) this.cancelCallback(callbackId);
                });
                listeners.clear();
            }
        });
    }
    replaceAttackCallback(callback) {
        if (!callback) return;
        const currentAction = $d782e74b2eaa8700$var$animationToAction(this.action);
        const listeners = this.actionCompleteListeners.get(currentAction);
        if (listeners) {
            // Clear existing callbacks
            listeners.forEach((listener)=>{
                const callbackId = listener.callbackId;
                if (callbackId) this.cancelCallback(callbackId);
            });
            listeners.clear();
            // Add new callback
            this.addActionListener(currentAction, {
                entityId: (0, $a80d0b17b615d6f7$export$5e699d18035b41af)(),
                callback: callback
            });
        }
    }
    cancelCallback(callbackId) {
        const callbackState = this.callbackStates.get(callbackId);
        if (callbackState && callbackState.status === "pending") {
            callbackState.status = "cancelled";
            this.activeCallbacks.delete(callbackId);
            this.currentAnimationCallbacks.delete(callbackId);
        }
    }
    executeCallbacks(listeners, action) {
        listeners.forEach((listener)=>{
            const callbackId = listener.callbackId;
            if (callbackId && this.callbackStates.has(callbackId)) {
                const callbackState = this.callbackStates.get(callbackId);
                if (callbackState.status === "pending") try {
                    (0, $5UG8I.logger).debug({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Executing callback for ${callbackId}`);
                    callbackState.callback();
                    callbackState.status = "executed";
                    (0, $5UG8I.logger).info({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Callback executed successfully: ${callbackId}`);
                } catch (error) {
                    (0, $5UG8I.logger).error({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Callback execution failed for ${callbackId}:`, error);
                    callbackState.status = "cancelled";
                }
                else (0, $5UG8I.logger).debug({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `Callback ${callbackId} already ${callbackState.status}`);
                // Remove from active callbacks
                this.activeCallbacks.delete(callbackId);
                this.currentAnimationCallbacks.delete(callbackId);
            } else (0, $5UG8I.logger).warn({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Callback state not found for ${callbackId}`);
            listeners.remove(listener.entityId);
        });
        (0, $5UG8I.logger).debug({
            tags: [
                "callback",
                "animation"
            ]
        }, `Callback execution complete for action: ${action}`);
    }
    cleanupAnimationCallbacks(action) {
        const actionType = $d782e74b2eaa8700$var$animationToAction(action);
        const listeners = this.actionCompleteListeners.get(actionType);
        if (listeners) {
            listeners.forEach((listener)=>{
                const callbackId = listener.callbackId;
                if (callbackId) this.cancelCallback(callbackId);
            });
            listeners.clear();
        }
    }
    changeDirection(newFacingDir) {
        const updated = this.turnedAnimation(newFacingDir);
        // A held pose has no directional variants to change TO -- the LPC `hurt` row is front-only,
        // so this would compose `hurt-left` and bake nothing. doMovement already returns before
        // reaching here while a pose is held; this is the guard for any other caller.
        if ($d782e74b2eaa8700$export$8280b108092dda60(this.action)) return;
        // Don't change direction during attack animations - let them complete
        if ($d782e74b2eaa8700$var$isAttackAnimation(this.action)) {
            (0, $5UG8I.logger).debug({
                tags: [
                    "callback",
                    "animation"
                ]
            }, `Preventing direction change during attack: ${this.action} -> ${updated}`);
            return;
        }
        // Transfer callbacks to new direction animation
        this.transferCallbacksToNewAnimation(updated);
        this.activateAnimation(updated);
    }
    transferCallbacksToNewAnimation(newAnimation) {
        const currentAction = $d782e74b2eaa8700$var$animationToAction(this.action);
        const newAction = $d782e74b2eaa8700$var$animationToAction(newAnimation);
        // Move callbacks from current action to new action
        const currentListeners = this.actionCompleteListeners.get(currentAction);
        if (currentListeners) {
            let newListeners = this.actionCompleteListeners.get(newAction);
            if (!newListeners) {
                newListeners = new (0, $cb689cfa16c444ba$export$cbcb4f84fc8dd985)();
                this.actionCompleteListeners.set(newAction, newListeners);
            }
            // Transfer all listeners
            currentListeners.forEach((listener)=>{
                newListeners.add(listener);
            });
            currentListeners.clear();
        }
    }
    // Enhanced cleanup method
    cleanup() {
        (0, $3YyWq.Ticker).shared.remove(this.updateIdleBreathing, this);
        this.idleBreathing?.reset();
        // Same reasoning as the shadow below: drop the outline's ticker registration and its borrowed
        // texture reference before the generator reclaims the frames.
        this.highlight?.dispose();
        this.highlight = undefined;
        // Leave the shared maintenance ticker. Previously each sprite created its own 100ms + 10s
        // intervals that (if never cleared) fired for the rest of the session on every sprite ever
        // built; now the sprite just deregisters and the shared timers stop once the set is empty.
        if (this.registeredWithTicker) {
            $d782e74b2eaa8700$var$lpcSpriteMaintenanceTicker.unregister(this);
            this.registeredWithTicker = false;
        }
        // Stop tracking the (about-to-be-abandoned) animation textures and drop the borrowed
        // reference before the generator reclaims them, so the shadow never points at a dead texture.
        if (this.spriteShadowTicking) {
            (0, $3YyWq.Ticker).shared.remove(this.updateSpriteShadow);
            this.spriteShadowTicking = false;
        }
        this.spriteShadow?.release();
        // remove() only detaches the sprite, so the ring has to drop its live-tuning registration
        // here or a paperdoll rebuild would leave the old one registered forever.
        this.playerRing?.dispose();
        this.playerRing = undefined;
        // Same reasoning, and it matters more here: a halo also holds the shared breath ticker open,
        // so a leaked registration would leave a dead sprite animating for the rest of the session.
        this.statusHalo?.dispose();
        this.statusHalo = undefined;
        // Release every clone this sprite adopted: destroys the clone display objects and drops
        // their cache references so the generator can reclaim baked textures once no live sprite
        // uses that loadout. Guards a late generate callback from re-adopting into a dead sprite.
        this.spriteReleased = true;
        // Dispose the display objects of adopted clones (refcount untouched -- keys are released just
        // below). abandon(), not release(), so we don't double-drop the key retained at request time.
        Object.keys(this.animations).forEach((action)=>{
            (0, $39fb998eb7d66fde$export$7100d33e089ec0).abandon(this.animations[action]);
        });
        this.animations = {};
        // Release the request-time key hold for EVERY action we prepared (adopted, still-loading, or
        // failed) -- balances the retainKey in doPreparation exactly once per prepared action.
        this.preparedActionKeys.forEach((key)=>(0, $39fb998eb7d66fde$export$7100d33e089ec0).releaseKey(key));
        this.preparedActionKeys.clear();
        // Cancel all pending callbacks
        this.activeCallbacks.forEach((callbackId)=>{
            this.cancelCallback(callbackId);
        });
        // Clear all data structures
        this.callbackStates.clear();
        this.activeCallbacks.clear();
        this.currentAnimationCallbacks.clear();
        this.actionCompleteListeners.clear();
    }
    // Override remove so discarding a sprite (paperdoll rebuild / fade-out both call remove(),
    // not destroy()) also tears down its timers and callbacks instead of leaking them.
    remove() {
        this.cleanup();
        super.remove();
    }
    // Override destroy method
    destroy() {
        this.cleanup();
        super.destroy();
    }
    // Periodic cleanup for orphaned callbacks. Public so the shared maintenance ticker can drive it.
    cleanupOrphanedCallbacks() {
        const now = Date.now();
        const maxAge = 30000 // 30 seconds
        ;
        this.callbackStates.forEach((state, callbackId)=>{
            if (state.status === "pending" && now - state.createdAt > maxAge) {
                console.warn("Cleaning up orphaned callback:", callbackId);
                this.cancelCallback(callbackId);
            }
        });
    }
    // Register for periodic callback maintenance on the shared ticker (idempotent).
    startCleanupTimer() {
        if (this.registeredWithTicker) return;
        this.registeredWithTicker = true;
        $d782e74b2eaa8700$var$lpcSpriteMaintenanceTicker.register(this);
    }
    // CRITICAL FIX: Ensure callbacks are set up for animations that are already loaded
    ensureCallbacksAreSetUp(animationName) {
        const action = $d782e74b2eaa8700$var$animationToAction(animationName);
        const listeners = this.actionCompleteListeners.get(action);
        if (listeners?.size() > 0) {
            const animationResult = this.animations[animationName];
            if (animationResult && animationResult.animation && !animationResult.animation.onFrameChange) {
                (0, $5UG8I.logger).info({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `CRITICAL FIX: Setting up missing onFrameChange for ${animationName}`);
                const animation = animationResult.animation;
                const totalFrames = animation.totalFrames;
                animation.onFrameChange = (frame)=>{
                    const pct = frame / (totalFrames - 1);
                    (0, $5UG8I.logger).debug({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Frame change (CRITICAL FIX): ${frame}/${totalFrames - 1} (${(pct * 100).toFixed(1)}%)`);
                    if (pct > 0.5) {
                        (0, $5UG8I.logger).debug({
                            tags: [
                                "callback",
                                "animation"
                            ]
                        }, `Triggering callbacks (CRITICAL FIX) at ${(pct * 100).toFixed(1)}% completion`);
                        this.executeCallbacks(listeners, action);
                    }
                };
            }
        }
    }
    // FALLBACK: Check for missing callbacks and set them up. Public so the shared maintenance ticker
    // can drive it; early-returns cheaply when this sprite has no active callbacks.
    checkForMissingCallbacks() {
        if (this.activeCallbacks.size === 0) return; // No active callbacks to check
        const currentAction = $d782e74b2eaa8700$var$animationToAction(this.action);
        const listeners = this.actionCompleteListeners.get(currentAction);
        if (listeners?.size() > 0) {
            const animationResult = this.animations[this.action];
            if (animationResult && animationResult.animation && !animationResult.animation.onFrameChange) {
                (0, $5UG8I.logger).info({
                    tags: [
                        "callback",
                        "animation"
                    ]
                }, `FALLBACK: Detected missing onFrameChange for ${this.action}, setting up now`);
                const animation = animationResult.animation;
                const totalFrames = animation.totalFrames;
                animation.onFrameChange = (frame)=>{
                    const pct = frame / (totalFrames - 1);
                    (0, $5UG8I.logger).debug({
                        tags: [
                            "callback",
                            "animation"
                        ]
                    }, `Frame change (FALLBACK): ${frame}/${totalFrames - 1} (${(pct * 100).toFixed(1)}%)`);
                    if (pct > 0.5) {
                        (0, $5UG8I.logger).debug({
                            tags: [
                                "callback",
                                "animation"
                            ]
                        }, `Triggering callbacks (FALLBACK) at ${(pct * 100).toFixed(1)}% completion`);
                        this.executeCallbacks(listeners, currentAction);
                    }
                };
            }
        }
    }
    // CRITICAL FIX: Preserve listeners when changing animation directions for the same action
    preserveListenersForSameAction(newAnimation) {
        const newAction = $d782e74b2eaa8700$var$animationToAction(newAnimation);
        const currentAction = $d782e74b2eaa8700$var$animationToAction(this.action);
        // If we're changing to the same action, preserve listeners
        if (newAction === currentAction) // Don't clear listeners for the same action
        return;
        // For different actions, clean up current animation callbacks
        (0, $5UG8I.logger).debug({
            tags: [
                "callback",
                "animation"
            ]
        }, `Cleaning up callbacks for different action: ${currentAction} -> ${newAction}`);
        this.cleanupCurrentAnimationCallbacks();
    }
}



parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $3YyWq = parcelRequire("3YyWq");
var $d3fD1 = parcelRequire("d3fD1");


/**
 * The one entry point: a named Ember humanoid and a game animation name in, frames out.
 *
 * Pure and deterministic -- no DOM, no pixi -- so the client bakes it into textures, tests read its
 * pixels, and tools write it to PNG, all from the same code.
 */ 


/**
 * Animations made as data: PERFORMANCES -- a wave, a bow, a roar, a dance -- that any Ember body can
 * play when something asks it to (the game's `/perform` dev command; whatever sets an entity's
 * performance). Each is a keyframed clip like the game's own strikes and falls (clips.ts): a few key
 * poses of the whole body -- how it rises, leans and turns, where its arms and legs are -- eased
 * between and sampled at any frame count, in every facing, on every body. Content
 * (`content/game/sprites/ember/animations.json`), bound into EMBER_PERFORMANCES in place.
 *
 * Content writes angles in DEGREES; the engine's keys are radians (clips.ts EmberKey).
 */ 



const $e232198e56580323$export$372502e864c820f2 = /^[a-z][a-z0-9_]{1,31}$/;
const $e232198e56580323$var$ANGLES = [
    "roll",
    "pitch",
    "lean",
    "twist",
    "hips",
    "head",
    "sideBend",
    "headPitch"
];
const $e232198e56580323$var$LIMBS = [
    "armL",
    "armR",
    "legL",
    "legR"
];
const $e232198e56580323$export$fb13d935be3aa9e6 = (key)=>{
    const out = {
        ...key
    };
    for (const field of $e232198e56580323$var$ANGLES)if (typeof key[field] === "number") out[field] = (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(key[field]);
    for (const limb of $e232198e56580323$var$LIMBS)if (key[limb]) out[limb] = key[limb].map((0, $0a4786a5aadc3b7f$export$61ddd819c68acdd));
    return out;
};
const $e232198e56580323$var$toDegrees = (radians)=>Math.round(radians * 180 / Math.PI * 1e4) / 1e4;
const $e232198e56580323$export$84920c69cff1666a = (key)=>{
    const out = {};
    for (const [field, value] of Object.entries(key)){
        if (value === undefined) continue;
        if ($e232198e56580323$var$ANGLES.includes(field)) out[field] = $e232198e56580323$var$toDegrees(value);
        else if ($e232198e56580323$var$LIMBS.includes(field)) out[field] = value.map($e232198e56580323$var$toDegrees);
        else out[field] = value;
    }
    return out;
};
const $e232198e56580323$export$db33fbe949ed55bf = (name, a)=>({
        name: name,
        frames: a.frames,
        frameMs: a.frameMs,
        loop: !!a.loop,
        sample: (0, $a1fb04dc4139ce6e$export$ea3a8eba4ce22e88)(a.keys.map($e232198e56580323$export$fb13d935be3aa9e6))
    });
const $e232198e56580323$export$7d5fe1d8fc443191 = Object.create(null);
let $e232198e56580323$var$bound;
let $e232198e56580323$var$previewing;
const $e232198e56580323$var$apply = ()=>{
    for (const k of Object.keys($e232198e56580323$export$7d5fe1d8fc443191))delete $e232198e56580323$export$7d5fe1d8fc443191[k];
    for (const [name, a] of Object.entries({
        ...$e232198e56580323$var$bound?.animations ?? {},
        ...$e232198e56580323$var$previewing ?? {}
    }))$e232198e56580323$export$7d5fe1d8fc443191[name] = $e232198e56580323$export$db33fbe949ed55bf(name, a);
};
const $e232198e56580323$export$843c189d73e966e0 = (file)=>{
    $e232198e56580323$var$bound = file;
    $e232198e56580323$var$apply();
    (0, $121d74fbc26f823b$export$35d5ab3d09c2908f)("animations", file);
};
const $e232198e56580323$export$7ca7cbbf93dc4f65 = (animations)=>{
    $e232198e56580323$var$previewing = animations;
    $e232198e56580323$var$apply();
    (0, $121d74fbc26f823b$export$35d5ab3d09c2908f)("animations-preview", animations);
};
const $e232198e56580323$export$da56a348482c51f = (name)=>!!name && Object.prototype.hasOwnProperty.call($e232198e56580323$export$7d5fe1d8fc443191, name);
const $e232198e56580323$export$d607c9d6da72d19f = (name)=>{
    const clip = $e232198e56580323$export$7d5fe1d8fc443191[name];
    return clip ? clip.frames * clip.frameMs : undefined;
};
const $e232198e56580323$export$f865c9c02b42803b = ()=>$e232198e56580323$var$bound;
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>catalog.source.emberAnimations, $e232198e56580323$export$843c189d73e966e0);


/**
 * Species: bodies on a rig of their own. A humanoid is posed on the human skeleton (rig.ts) by the
 * human clips (clips.ts); a SPECIES brings everything that skeleton and those clips are, as data --
 * a deer, a wolf, a spider, a bird:
 *
 *   - its RIG: named joints at their rest positions, each hung on a parent, and which chains of them
 *     are LEGS (root, knee, ankle and optionally a foot segment below it, planted by IK);
 *   - its GAITS: locomotion generated from a handful of numbers -- how far a cycle carries it, how
 *     long each foot stays down, when each leg steps (a four-beat walk, a trot's diagonal pairs, a
 *     gallop) -- and whatever else rocks or swings in time (the body's bob, the head's nod, a tail);
 *   - its CLIPS: key poses eased between, as every keyframed clip is (an idle, an attack, a fall);
 *   - which of those plays each of the game's ACTIONS;
 *   - its BODIES: models in the expression language (model.ts, slot `species`) hung on the posed
 *     joints, drawn by the same raster in the same eight facings as everything else.
 *
 * Content: `content/game/sprites/ember/species.json`, bound here. A species body is drawn under its
 * own name (planSpeciesAnimation; generate.ts hands it any name that is not a humanoid's).
 *
 * Content writes angles in DEGREES and lengths in world pixels. Model space is the humanoid's: y up
 * (the ground is 0), +z the way the body faces, +x its left.
 */ 


/**
 * The named Ember humanoids: what `/ember appearance <name>` puts a player into.
 *
 * Each is a record of data -- a look and optional proportions -- and every frame of every animation
 * is generated from it. Adding a character is adding an entry to content
 * (`content/game/sprites/ember/humanoids.json`), with the builds they share and which one draws
 * each race. Bound into the records here in place, so every importer sees content's.
 */ 

const $3256700f2c0109f9$export$cd7bfe75b42812b5 = {};
const $3256700f2c0109f9$export$f8c8da5e39b421f3 = {
    skins: {},
    furs: {}
};
const $3256700f2c0109f9$export$a792c7116ea82b85 = [];
const $3256700f2c0109f9$var$RACES = [];
/**
 * A build scaled whole: every length and girth by `k` -- not its roundness, cloth or stance angles --
 * so the same body comes out larger or smaller.
 */ const $3256700f2c0109f9$var$scaledBy = (p, k)=>{
    const unscaled = new Set([
        "headRoundness",
        "torsoRoundness",
        "pelvisRoundness",
        "clothThickness"
    ]);
    const out = {};
    for (const [key, value] of Object.entries(p)){
        if (unscaled.has(key)) out[key] = value;
        else if (typeof value === "number") out[key] = value * k;
        else if (Array.isArray(value)) out[key] = value.map((v)=>v * k);
        else if (key === "girdle") {
            const girdle = value;
            out[key] = {
                ...girdle,
                radii: girdle.radii.map((v)=>v * k),
                drop: girdle.drop * k,
                cut: girdle.cut * k
            };
        } else if (key === "stance") {
            const scaledPose = (pose)=>({
                    ...pose,
                    ...pose.feetOut !== undefined ? {
                        feetOut: pose.feetOut * k
                    } : {},
                    ...pose.feetSplit !== undefined ? {
                        feetSplit: pose.feetSplit * k
                    } : {},
                    ...pose.crouch !== undefined ? {
                        crouch: pose.crouch * k
                    } : {}
                });
            out[key] = Object.fromEntries(Object.entries(value).map(([facing, pose])=>[
                    facing,
                    scaledPose(pose)
                ]));
        } else out[key] = value;
    }
    return out;
};
const $3256700f2c0109f9$export$a24419454560096e = (builds)=>{
    const done = {};
    const resolve = (name, seen)=>{
        if (done[name]) return done[name];
        const b = builds[name];
        if (!b) throw new Error(`Unknown build ${name}`);
        if (seen.includes(name)) throw new Error(`Build ${name} extends itself (${[
            ...seen,
            name
        ].join(" -> ")})`);
        const own = {
            ...b.extends ? resolve(b.extends, [
                ...seen,
                name
            ]) : {},
            ...b.proportions ?? {}
        };
        return done[name] = b.scale !== undefined ? $3256700f2c0109f9$var$scaledBy(own, b.scale) : own;
    };
    for (const name of Object.keys(builds))resolve(name, []);
    return done;
};
let $3256700f2c0109f9$var$bound;
let $3256700f2c0109f9$var$previewing;
/** The game's humanoids with any preview laid over them (a previewed humanoid replaces one of its name). */ const $3256700f2c0109f9$var$apply = ()=>{
    const builds = $3256700f2c0109f9$export$a24419454560096e({
        ...$3256700f2c0109f9$var$bound?.builds ?? {},
        ...$3256700f2c0109f9$var$previewing?.builds ?? {}
    });
    const shown = new Set(($3256700f2c0109f9$var$previewing?.humanoids ?? []).map((h)=>h.name));
    for (const k of Object.keys($3256700f2c0109f9$export$cd7bfe75b42812b5))delete $3256700f2c0109f9$export$cd7bfe75b42812b5[k];
    $3256700f2c0109f9$export$a792c7116ea82b85.length = 0;
    for (const { build: build, proportions: proportions, ...h } of [
        ...($3256700f2c0109f9$var$bound?.humanoids ?? []).filter((h)=>!shown.has(h.name)),
        ...$3256700f2c0109f9$var$previewing?.humanoids ?? []
    ]){
        const base = build ? builds[build] : undefined;
        $3256700f2c0109f9$export$cd7bfe75b42812b5[h.name] = {
            ...h,
            ...base || proportions ? {
                proportions: base && proportions ? {
                    ...base,
                    ...proportions
                } : base ?? proportions
            } : {}
        };
        $3256700f2c0109f9$export$a792c7116ea82b85.push(h.name);
    }
    $3256700f2c0109f9$var$RACES.length = 0;
    $3256700f2c0109f9$var$RACES.push(...$3256700f2c0109f9$var$previewing?.races ?? [], ...$3256700f2c0109f9$var$bound?.races ?? []);
    $3256700f2c0109f9$export$f8c8da5e39b421f3.skins = {
        ...$3256700f2c0109f9$var$bound?.bodyColors?.skins ?? {}
    };
    $3256700f2c0109f9$export$f8c8da5e39b421f3.furs = {
        ...$3256700f2c0109f9$var$bound?.bodyColors?.furs ?? {}
    };
};
const $3256700f2c0109f9$export$4b2783808154e92e = ()=>$3256700f2c0109f9$var$bound?.builds ?? {};
const $3256700f2c0109f9$export$b16b28bfccd3ba3b = (file)=>{
    $3256700f2c0109f9$var$bound = file;
    $3256700f2c0109f9$var$apply();
    (0, $121d74fbc26f823b$export$35d5ab3d09c2908f)("humanoids", file);
};
const $3256700f2c0109f9$export$3d79f8febe78d3be = (preview)=>{
    $3256700f2c0109f9$var$previewing = preview;
    $3256700f2c0109f9$var$apply();
    (0, $121d74fbc26f823b$export$35d5ab3d09c2908f)("humanoids-preview", preview);
};
const $3256700f2c0109f9$export$be293bd239907d43 = (name)=>!!name && Object.prototype.hasOwnProperty.call($3256700f2c0109f9$export$cd7bfe75b42812b5, name);
const $3256700f2c0109f9$export$1fe1db0540b7da4b = "lpc";
/**
 * Species bodies (species.ts) and the races they draw, as species.json says: set by species.ts
 * whenever its content binds or a preview changes. Kept here so this module needs nothing of theirs.
 */ const $3256700f2c0109f9$var$SPECIES_RACES = [];
let $3256700f2c0109f9$var$speciesBodies = new Set();
const $3256700f2c0109f9$export$9d1a5e61e44e00da = (races, bodies)=>{
    $3256700f2c0109f9$var$SPECIES_RACES.length = 0;
    $3256700f2c0109f9$var$SPECIES_RACES.push(...races);
    $3256700f2c0109f9$var$speciesBodies = new Set(bodies);
};
const $3256700f2c0109f9$export$ee2b787377c030da = (appearance)=>{
    if (!appearance || appearance.emberSprite === $3256700f2c0109f9$export$1fe1db0540b7da4b) return undefined;
    if ($3256700f2c0109f9$export$be293bd239907d43(appearance.emberSprite)) return appearance.emberSprite;
    if (appearance.emberSprite !== undefined && $3256700f2c0109f9$var$speciesBodies.has(appearance.emberSprite)) return appearance.emberSprite;
    const matches = (r)=>r.race === appearance.race && (r.sex === undefined || r.sex === appearance.sex);
    const rule = $3256700f2c0109f9$var$RACES.find(matches);
    if (rule) return $3256700f2c0109f9$export$be293bd239907d43(rule.body) ? rule.body : undefined;
    const species = $3256700f2c0109f9$var$SPECIES_RACES.find(matches);
    return species && $3256700f2c0109f9$var$speciesBodies.has(species.body) ? species.body : undefined;
};
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>catalog.source.emberHumanoids, $3256700f2c0109f9$export$b16b28bfccd3ba3b);






/**
 * How a humanoid is drawn, apart from what it is (proportions) and what it wears (look).
 *
 * `lpc` is the style fitted to sit beside LPC art: its raster, its sampled skins, and the muscle
 * marks painted on the LPC-fitted body. `realist` is Ember's own, for bodies at real human
 * proportions: picked skins with cool shadows and a plum outline, one key light cut into clean
 * steps instead of LPC's rim of shade inside every outline, and no LPC marks (they are calibrated to the
 * LPC body and would land in the wrong places on any other). The styles are content
 * (`content/game/sprites/ember/styles.json`), bound into EMBER_STYLES in place.
 */ 




const $df52b6239fb99090$export$d2ff1de39f8bd819 = {
    natural: (0, $a1fb04dc4139ce6e$export$dcda7fcef050bc34)
};
const $df52b6239fb99090$export$f93cc37bce51e09b = {};
let $df52b6239fb99090$export$38a28ac32dc22856 = "lpc";
const $df52b6239fb99090$var$isPlain = (v)=>!!v && typeof v === "object" && !Array.isArray(v);
/** `over` merged into `base` object by object; anything else (numbers, lists) replaces. */ const $df52b6239fb99090$var$merged = (base, over)=>{
    if (!over) return {
        ...base
    };
    const out = {
        ...base
    };
    for (const [k, v] of Object.entries(over))out[k] = $df52b6239fb99090$var$isPlain(v) && $df52b6239fb99090$var$isPlain(out[k]) ? $df52b6239fb99090$var$merged(out[k], v) : v;
    return out;
};
const $df52b6239fb99090$export$580009a5da2a8b4b = (file)=>{
    for (const k of Object.keys($df52b6239fb99090$export$f93cc37bce51e09b))delete $df52b6239fb99090$export$f93cc37bce51e09b[k];
    for (const [name, s] of Object.entries(file?.styles ?? {}))$df52b6239fb99090$export$f93cc37bce51e09b[name] = {
        raster: $df52b6239fb99090$var$merged((0, $bc9c62e5e9c273fc$export$5f22db6dc00b1799), s.raster),
        skins: (0, $b28f7e6af286c932$export$c6254af65262af78)[s.skins] ?? {},
        ...s.marks ? {
            marks: s.marks
        } : {},
        ...s.eyes ? {
            eyes: s.eyes
        } : {},
        ...s.clips ? {
            clips: $df52b6239fb99090$export$d2ff1de39f8bd819[s.clips]
        } : {}
    };
    $df52b6239fb99090$export$38a28ac32dc22856 = file?.default ?? "lpc";
    (0, $121d74fbc26f823b$export$35d5ab3d09c2908f)("styles", file);
};
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>catalog.source.emberStyles, $df52b6239fb99090$export$580009a5da2a8b4b);



const $2e9467226384ee42$var$hasOwn = (o, k)=>Object.prototype.hasOwnProperty.call(o, k);
const $2e9467226384ee42$export$ecc7b9f068f3bebb = (joints, legs)=>{
    const index = Object.create(null);
    const names = [], parent = [], rest = [];
    joints.forEach(([name, of, at], i)=>{
        if ($2e9467226384ee42$var$hasOwn(index, name)) throw new Error(`joint ${name} twice`);
        if (of !== null && !$2e9467226384ee42$var$hasOwn(index, of)) throw new Error(`joint ${name}: its parent ${of} comes first`);
        index[name] = i;
        names.push(name);
        parent.push(of === null ? -1 : index[of]);
        rest.push([
            at[0],
            at[1],
            at[2]
        ]);
    });
    const rigLegs = Object.entries(legs).map(([name, leg])=>{
        const chain = leg.joints.map((j)=>{
            if (!$2e9467226384ee42$var$hasOwn(index, j)) throw new Error(`leg ${name}: no joint ${j}`);
            return index[j];
        });
        for(let k = 1; k < chain.length; k++)if (parent[chain[k]] !== chain[k - 1]) throw new Error(`leg ${name}: ${names[chain[k]]} does not hang from ${names[chain[k - 1]]}`);
        const [r, m, e, tip] = chain;
        const toEnd = (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(rest[e], rest[r]);
        const along = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(toEnd);
        const off = (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(rest[m], rest[r]);
        let pole = (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(off, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(along, (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(off, along)));
        if ((0, $0a4786a5aadc3b7f$export$f24224f1c91d8156)(pole) < 1e-6) pole = [
            0,
            0,
            1
        ];
        pole = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(pole);
        return {
            name: name,
            chain: chain,
            a: (0, $0a4786a5aadc3b7f$export$f24224f1c91d8156)((0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(rest[m], rest[r])),
            b: (0, $0a4786a5aadc3b7f$export$f24224f1c91d8156)((0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(rest[e], rest[m])),
            ...tip !== undefined ? {
                footUp: (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(rest[e], rest[tip])
            } : {},
            pole: pole,
            fold: leg.fold ?? (pole[2] > 0 ? -1 : 1),
            contact: rest[tip ?? e]
        };
    });
    return {
        names: names,
        parent: parent,
        rest: rest,
        index: index,
        legs: rigLegs
    };
};
const $2e9467226384ee42$export$7243f74b0e90f2fb = (u, v, share = 1)=>{
    const a = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(u), b = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(v);
    const cosine = (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(a, b);
    const cr = (0, $0a4786a5aadc3b7f$export$bb646b20bb93d339)(a, b);
    const sine = (0, $0a4786a5aadc3b7f$export$f24224f1c91d8156)(cr);
    if (sine < 1e-9 && cosine > 0) return 0, $0a4786a5aadc3b7f$export$76c0f2b8ecfc3d8a;
    // Opposite: half a turn about any axis square to them.
    const axis = sine < 1e-9 ? (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(Math.abs(a[0]) < 0.9 ? (0, $0a4786a5aadc3b7f$export$bb646b20bb93d339)(a, [
        1,
        0,
        0
    ]) : (0, $0a4786a5aadc3b7f$export$bb646b20bb93d339)(a, [
        0,
        1,
        0
    ])) : (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(cr, 1 / sine);
    const angle = share * Math.atan2(sine, cosine);
    const c = share === 1 && sine >= 1e-9 ? cosine : Math.cos(angle);
    const s = share === 1 && sine >= 1e-9 ? sine : Math.sin(angle);
    const [x, y, z] = axis;
    const t = 1 - c;
    // Rodrigues: I + sin K + (1 - cos) K^2, about the unit axis.
    return [
        c + x * x * t,
        x * y * t - z * s,
        x * z * t + y * s,
        y * x * t + z * s,
        c + y * y * t,
        y * z * t - x * s,
        z * x * t - y * s,
        z * y * t + x * s,
        c + z * z * t
    ];
};
/** The yaw alone of a body turned by `r`: the frame its feet are planted in. */ const $2e9467226384ee42$var$headingOf = (r)=>{
    const f = (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(r, [
        0,
        0,
        1
    ]);
    if (Math.hypot(f[0], f[2]) > 1e-6) return (0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)(Math.atan2(f[0], f[2]));
    const u = (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(r, [
        0,
        1,
        0
    ]);
    return (0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)(Math.atan2(-u[0], -u[2]));
};
const $2e9467226384ee42$export$aad71541133937d6 = (rig, pose)=>{
    const n = rig.names.length;
    const P = new Array(n), R = new Array(n);
    const done = new Uint8Array(n);
    const heading = $2e9467226384ee42$var$headingOf(pose.rootRotation);
    const legAt = new Map(rig.legs.map((leg)=>[
            leg.chain[0],
            leg
        ]));
    for(let i = 0; i < n; i++){
        if (done[i]) continue;
        const q = rig.parent[i];
        const turn = pose.turns[rig.names[i]];
        if (q < 0) {
            R[i] = turn ? (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(pose.rootRotation, turn) : pose.rootRotation;
            P[i] = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(rig.rest[i], pose.root);
        } else {
            R[i] = turn ? (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(R[q], turn) : R[q];
            P[i] = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(P[q], (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(R[q], (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(rig.rest[i], rig.rest[q])));
        }
        done[i] = 1;
        const leg = legAt.get(i);
        const foot = leg && pose.feet[leg.name];
        if (!leg || !foot) continue;
        const [r, m, e, tip] = leg.chain;
        const hung = q < 0 ? pose.rootRotation : R[q];
        // The foot segment swings with the leg as a whole -- as far as the line from the foot to the
        // leg's root has turned since rest -- and folds on top of that.
        const swing = $2e9467226384ee42$export$7243f74b0e90f2fb((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(heading, (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(rig.rest[r], leg.contact)), (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(P[r], foot.at), foot.swing ?? 1);
        const ankle = leg.footUp ? (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(foot.at, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(swing, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(heading, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)((0, $0a4786a5aadc3b7f$export$fa9f800d0752b887)(foot.fold * leg.fold), leg.footUp)))) : foot.at;
        const solved = (0, $16b5b2e1f0b8662b$export$c8cb7c46eca76faa)(P[r], ankle, leg.a, leg.b, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(hung, leg.pole));
        P[m] = solved.mid;
        P[e] = solved.end;
        R[r] = (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)($2e9467226384ee42$export$7243f74b0e90f2fb((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(hung, (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(rig.rest[m], rig.rest[r])), (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(P[m], P[r])), hung);
        R[m] = (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)($2e9467226384ee42$export$7243f74b0e90f2fb((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(R[r], (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(rig.rest[e], rig.rest[m])), (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(P[e], P[m])), R[r]);
        done[m] = done[e] = 1;
        if (tip !== undefined) {
            // Out of reach, the ankle stops short and the foot comes with it.
            P[tip] = (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(P[e], (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(foot.at, ankle));
            R[e] = (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)($2e9467226384ee42$export$7243f74b0e90f2fb((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(R[m], (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(rig.rest[tip], rig.rest[e])), (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(P[tip], P[e])), R[m]);
            R[tip] = R[e];
            done[tip] = 1;
        }
    }
    const at = {}, basis = {};
    rig.names.forEach((name, i)=>{
        at[name] = P[i];
        basis[name] = R[i];
    });
    return {
        at: at,
        basis: basis,
        heading: heading
    };
};
const $2e9467226384ee42$var$turnOf = (pitch, yaw, roll)=>(0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)((0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)((0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(yaw)), (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)((0, $0a4786a5aadc3b7f$export$fa9f800d0752b887)((0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(pitch)), (0, $0a4786a5aadc3b7f$export$305a59a98cabc9c5)((0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(roll))));
const $2e9467226384ee42$var$TAU = Math.PI * 2;
const $2e9467226384ee42$export$2279fbed8f230223 = (rig, g)=>(t)=>{
        const angles = {};
        const body = {
            rise: g.rise ?? 0,
            shift: 0,
            side: 0,
            pitch: 0,
            yaw: 0,
            roll: 0
        };
        for (const m of g.motion ?? []){
            const v = (m.offset ?? 0) + m.amplitude * Math.sin($2e9467226384ee42$var$TAU * ((m.perCycle ?? 1) * t + (m.phase ?? 0)));
            if (m.joint === "root") body[m.axis] += v;
            else {
                const a = angles[m.joint] ??= [
                    0,
                    0,
                    0
                ];
                a[m.axis === "pitch" ? 0 : m.axis === "yaw" ? 1 : 2] += v;
            }
        }
        const turns = {};
        for (const [joint, [p, y, r]] of Object.entries(angles))turns[joint] = $2e9467226384ee42$var$turnOf(p, y, r);
        const feet = {};
        const step = g.stride * g.duty;
        const byLeg = (v, leg)=>typeof v === "number" ? v : v?.[leg] ?? 0;
        for (const leg of rig.legs){
            const phase = g.phases[leg.name];
            if (phase === undefined) {
                feet[leg.name] = {
                    at: leg.contact,
                    fold: 0
                };
                continue;
            }
            const q = ((t - phase) % 1 + 1) % 1;
            const reach = g.reach ?? 0;
            if (q < g.duty) {
                feet[leg.name] = {
                    at: (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(leg.contact, [
                        0,
                        0,
                        reach + step * (0.5 - q / g.duty)
                    ]),
                    fold: 0
                };
                continue;
            }
            // Carried through the air: the ankle lifts and swings forward, the foot hanging from it folded.
            const s = (q - g.duty) / (1 - g.duty);
            const arc = Math.sin(Math.PI * s);
            const fold = (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(byLeg(g.fold, leg.name)) * Math.sin(Math.PI * Math.min(1, s * 1.2));
            const lifted = [
                0,
                byLeg(g.lift, leg.name) * arc,
                reach + step * ((0, $0a4786a5aadc3b7f$export$b0f87bb1f6530fd8)(s) - 0.5)
            ];
            const hang = leg.footUp ? (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)((0, $0a4786a5aadc3b7f$export$fa9f800d0752b887)(fold * leg.fold), leg.footUp), leg.footUp) : [
                0,
                0,
                0
            ];
            feet[leg.name] = {
                at: (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(leg.contact, lifted), hang),
                fold: fold,
                swing: 1 - arc
            };
        }
        return {
            root: [
                body.side,
                body.rise,
                body.shift
            ],
            rootRotation: $2e9467226384ee42$var$turnOf(body.pitch, body.yaw, body.roll),
            turns: turns,
            feet: feet
        };
    };
const $2e9467226384ee42$var$mix = (a, b, u)=>(a ?? 0) + ((b ?? 0) - (a ?? 0)) * u;
const $2e9467226384ee42$export$e407ecc81d40131d = (rig, keys)=>(t)=>{
        let i = 0;
        while(i < keys.length - 2 && t > keys[i + 1].t)i++;
        const a = keys[i], b = keys[i + 1];
        const u = (0, $0a4786a5aadc3b7f$export$b0f87bb1f6530fd8)(b.t > a.t ? (t - a.t) / (b.t - a.t) : 0);
        const turns = {};
        for (const joint of new Set([
            ...Object.keys(a.turns ?? {}),
            ...Object.keys(b.turns ?? {})
        ])){
            const ta = a.turns?.[joint] ?? [
                0,
                0,
                0
            ], tb = b.turns?.[joint] ?? [
                0,
                0,
                0
            ];
            turns[joint] = $2e9467226384ee42$var$turnOf($2e9467226384ee42$var$mix(ta[0], tb[0], u), $2e9467226384ee42$var$mix(ta[1], tb[1], u), $2e9467226384ee42$var$mix(ta[2], tb[2], u));
        }
        const pose = {
            root: [
                $2e9467226384ee42$var$mix(a.side, b.side, u),
                $2e9467226384ee42$var$mix(a.rise, b.rise, u),
                $2e9467226384ee42$var$mix(a.shift, b.shift, u)
            ],
            rootRotation: $2e9467226384ee42$var$turnOf($2e9467226384ee42$var$mix(a.pitch, b.pitch, u), $2e9467226384ee42$var$mix(a.yaw, b.yaw, u), $2e9467226384ee42$var$mix(a.roll, b.roll, u)),
            turns: turns,
            feet: {}
        };
        const heading = $2e9467226384ee42$var$headingOf(pose.rootRotation);
        const planted = (leg, f)=>f === "free" ? undefined : {
                at: (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(leg.contact, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(heading, [
                    f?.[0] ?? 0,
                    f?.[1] ?? 0,
                    f?.[2] ?? 0
                ])),
                fold: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(f?.[3] ?? 0)
            };
        // Free legs follow the body; where one key frees a leg the other plants, blend toward the free pose.
        let free;
        for (const leg of rig.legs){
            const fa = planted(leg, a.feet?.[leg.name]), fb = planted(leg, b.feet?.[leg.name]);
            if (fa && fb) pose.feet[leg.name] = {
                at: (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(fa.at, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(fb.at, fa.at), u)),
                fold: $2e9467226384ee42$var$mix(fa.fold, fb.fold, u)
            };
            else if (fa || fb) {
                free ??= $2e9467226384ee42$export$aad71541133937d6(rig, {
                    ...pose,
                    feet: {}
                });
                const lowest = rig.names[leg.chain[leg.chain.length - 1]];
                const held = {
                    at: free.at[lowest],
                    fold: 0
                };
                const [from, to] = fa ? [
                    fa,
                    held
                ] : [
                    held,
                    fb
                ];
                pose.feet[leg.name] = {
                    at: (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(from.at, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(to.at, from.at), u)),
                    fold: $2e9467226384ee42$var$mix(from.fold, to.fold, u)
                };
            }
        }
        return pose;
    };
const $2e9467226384ee42$export$95c628438644e357 = Object.create(null);
const $2e9467226384ee42$export$d5a903a33aac0e0b = Object.create(null);
const $2e9467226384ee42$var$speciesOf = (name, source)=>{
    const rig = $2e9467226384ee42$export$ecc7b9f068f3bebb(source.joints, source.legs);
    const clips = {};
    for (const [gait, g] of Object.entries(source.gaits ?? {}))clips[gait] = {
        name: gait,
        frames: g.frames,
        frameMs: g.frameMs,
        loop: true,
        strideCycle: g.stride,
        sample: $2e9467226384ee42$export$2279fbed8f230223(rig, g)
    };
    for (const [clip, c] of Object.entries(source.clips ?? {}))clips[clip] = {
        name: clip,
        frames: c.frames,
        frameMs: c.frameMs,
        loop: !!c.loop,
        sample: $2e9467226384ee42$export$e407ecc81d40131d(rig, c.keys)
    };
    return {
        name: name,
        source: source,
        rig: rig,
        clips: clips
    };
};
let $2e9467226384ee42$var$bound;
let $2e9467226384ee42$var$previewing;
/** The game's species with any preview laid over them (a previewed species replaces one of its name). */ const $2e9467226384ee42$var$laidOver = ()=>{
    for (const k of Object.keys($2e9467226384ee42$export$95c628438644e357))delete $2e9467226384ee42$export$95c628438644e357[k];
    for (const k of Object.keys($2e9467226384ee42$export$d5a903a33aac0e0b))delete $2e9467226384ee42$export$d5a903a33aac0e0b[k];
    for (const [name, source] of Object.entries({
        ...$2e9467226384ee42$var$bound?.species ?? {},
        ...$2e9467226384ee42$var$previewing?.species ?? {}
    })){
        let species;
        // A draft being edited may not hold together yet: it is left out until it does (validation says why).
        try {
            species = $2e9467226384ee42$var$speciesOf(name, source);
        } catch  {
            continue;
        }
        $2e9467226384ee42$export$95c628438644e357[name] = species;
        for (const [body, b] of Object.entries(source.bodies ?? {}))$2e9467226384ee42$export$d5a903a33aac0e0b[body] = {
            ...b,
            species: name
        };
    }
    (0, $3256700f2c0109f9$export$9d1a5e61e44e00da)([
        ...$2e9467226384ee42$var$previewing?.races ?? [],
        ...$2e9467226384ee42$var$bound?.races ?? []
    ], Object.keys($2e9467226384ee42$export$d5a903a33aac0e0b));
};
const $2e9467226384ee42$export$1002d27273485b27 = (file)=>{
    $2e9467226384ee42$var$bound = file;
    (0, $121d74fbc26f823b$export$b77192350bd9e470)(file);
    $2e9467226384ee42$var$laidOver();
    (0, $121d74fbc26f823b$export$35d5ab3d09c2908f)("species", file);
};
const $2e9467226384ee42$export$f6422e0be4bd669b = (preview)=>{
    $2e9467226384ee42$var$previewing = preview;
    (0, $121d74fbc26f823b$export$18fb756b6accb28b)(preview ? {
        library: preview.library,
        models: preview.models
    } : undefined);
    $2e9467226384ee42$var$laidOver();
    (0, $121d74fbc26f823b$export$35d5ab3d09c2908f)("species-preview", preview);
};
const $2e9467226384ee42$export$2c94a5475a6bcc30 = ()=>$2e9467226384ee42$var$bound;
const $2e9467226384ee42$export$8eb75a72f9f497f = (name)=>!!name && $2e9467226384ee42$var$hasOwn($2e9467226384ee42$export$d5a903a33aac0e0b, name);
const $2e9467226384ee42$export$1723fce16411e77d = (facing, sideTurn)=>{
    switch(facing){
        case "front":
            return 0;
        case "back":
            return Math.PI;
        case "frontright":
            return Math.PI / 4;
        case "frontleft":
            return -Math.PI / 4;
        case "backright":
            return 3 * Math.PI / 4;
        case "backleft":
            return -3 * Math.PI / 4;
        case "right":
            return Math.PI / 2 - sideTurn;
        case "left":
            return -(Math.PI / 2 - sideTurn);
    }
};
/** The share of a stride that crosses the screen in a facing (all of it but where the body is turned toward the camera). */ const $2e9467226384ee42$var$acrossScreen = (facing, sideTurn)=>facing === "left" || facing === "right" ? Math.cos(sideTurn) : 1;
const $2e9467226384ee42$var$turned = (prims, yaw)=>prims.map((prim)=>prim.kind === "capsule" ? {
            ...prim,
            a: (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(yaw, prim.a),
            b: (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(yaw, prim.b)
        } : {
            ...prim,
            center: (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(yaw, prim.center),
            basis: (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(yaw, prim.basis)
        });
const $2e9467226384ee42$export$d30807e4c1575d23 = (s, frame = s.frame)=>{
    const style = ((0, $df52b6239fb99090$export$f93cc37bce51e09b)[s.style ?? "realist"] ?? (0, $df52b6239fb99090$export$f93cc37bce51e09b)[0, $df52b6239fb99090$export$38a28ac32dc22856]).raster;
    const { pitch: pitch, ...rest } = s.raster ?? {};
    const grow = (frame - 64) / 2;
    return {
        ...style,
        ...rest,
        width: frame,
        height: frame,
        centerX: 32 + grow,
        groundY: 61 + grow,
        ...typeof pitch === "number" ? {
            pitch: (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(pitch)
        } : {}
    };
};
/** The clip a species plays for an animation's action: its action table's, else one of its own by name. */ const $2e9467226384ee42$var$clipFor = (species, action)=>{
    const named = $2e9467226384ee42$var$hasOwn(species.source.actions, action) ? species.source.actions[action] : action;
    return $2e9467226384ee42$var$hasOwn(species.clips, named) ? species.clips[named] : undefined;
};
/** The rest direction square to a grip that faces most nearly down: a blade's edge by default. */ const $2e9467226384ee42$var$edgeFor = (grip)=>{
    const g = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(grip);
    const down = (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)([
        0,
        -1,
        0
    ], (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(g, -g[1]));
    return (0, $0a4786a5aadc3b7f$export$f24224f1c91d8156)(down) > 1e-3 ? (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(down) : (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)([
        0,
        0,
        1
    ], (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(g, g[2])));
};
const $2e9467226384ee42$export$eb5d5b7e8f2a536b = (species, sk)=>{
    const grips = species.source.grips;
    if (!grips?.R && !grips?.L) return undefined;
    const { rig: rig } = species;
    const has = (name)=>!!name && $2e9467226384ee42$var$hasOwn(rig.index, name);
    const parentOf = (name)=>{
        const q = rig.parent[rig.index[name]];
        return q >= 0 ? rig.names[q] : name;
    };
    const root = rig.names[0];
    const torso = has(grips.torso) ? grips.torso : has("chest") ? "chest" : root;
    const limb = (g)=>{
        const elbow = has(g.elbow) ? g.elbow : parentOf(g.hand);
        const shoulder = has(g.shoulder) ? g.shoulder : parentOf(elbow);
        const turn = sk.basis[g.hand];
        const hand = sk.at[g.hand];
        const ground = [
            hand[0],
            0,
            hand[2]
        ];
        return {
            shoulder: sk.at[shoulder],
            elbow: sk.at[elbow],
            hand: hand,
            hip: sk.at[root],
            knee: sk.at[root],
            ankle: ground,
            heel: ground,
            toe: ground,
            grip: (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(turn, g.grip)),
            edge: (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(turn, g.edge ?? $2e9467226384ee42$var$edgeFor(g.grip)))
        };
    };
    const R = limb(grips.R ?? grips.L);
    const L = grips.L ? limb(grips.L) : R;
    const head = has("head") ? "head" : torso;
    return {
        pelvis: sk.at[root],
        chest: sk.at[torso],
        neck: sk.at[has("neck") ? "neck" : torso],
        head: sk.at[head],
        pelvisBasis: sk.basis[root],
        torsoBasis: sk.basis[torso],
        headBasis: sk.basis[head],
        L: L,
        R: R
    };
};
/** A person's proportions as far as what is held is sized by them, at the grips' size. */ const $2e9467226384ee42$var$gripProportions = (size = 1)=>({
        ...(0, $16b5b2e1f0b8662b$export$e9495ff1e036db03),
        thigh: (0, $16b5b2e1f0b8662b$export$e9495ff1e036db03).thigh * size,
        shin: (0, $16b5b2e1f0b8662b$export$e9495ff1e036db03).shin * size,
        handRadius: 1.8 * size,
        handInset: 0.6 * size,
        torso: (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $16b5b2e1f0b8662b$export$e9495ff1e036db03).torso, size)
    });
/** What a species body holds of the entity's equipment: nothing without grips; a shield only in an off hand. */ const $2e9467226384ee42$var$heldBy = (species, equipment)=>{
    const grips = species.source.grips;
    if (!grips?.R && !grips?.L) return {};
    return {
        ...equipment.held && (0, $121d74fbc26f823b$export$d2c6fd47dbbb12e9)("held", equipment.held) ? {
            held: equipment.held,
            heldColor: equipment.heldColor
        } : {},
        ...equipment.shield && grips.L && grips.R ? {
            shield: {
                type: equipment.shield,
                color: equipment.shieldColor ?? ""
            }
        } : {}
    };
};
const $2e9467226384ee42$var$GEAR_SKIN = (0, $b28f7e6af286c932$export$8045a65082865858)("#b07a58");
const $2e9467226384ee42$export$ba8731937f6046f8 = (bodyName, sk, facing, equipment = {}, frame)=>{
    const body = $2e9467226384ee42$export$d5a903a33aac0e0b[bodyName];
    const species = $2e9467226384ee42$export$95c628438644e357[body.species];
    const s = species.source;
    const made = (0, $121d74fbc26f823b$export$550cfc25b8c4a4f7)(body.model, body.params ?? {}, {
        sk: sk,
        p: s.proportions ?? {},
        facing: facing
    });
    const holds = $2e9467226384ee42$var$heldBy(species, equipment);
    const person = Object.keys(holds).length ? $2e9467226384ee42$export$eb5d5b7e8f2a536b(species, sk) : undefined;
    if (person) made.push(...(0, $9311ef6950e6afe4$export$8925961623947896)(person, $2e9467226384ee42$var$gripProportions(s.grips?.size), {
        skin: "light",
        ...holds
    }, facing, $2e9467226384ee42$var$GEAR_SKIN));
    const prims = body.scale && body.scale !== 1 ? (0, $9311ef6950e6afe4$export$55a544314ab4c0e7)(made, body.scale) : made;
    return (0, $bc9c62e5e9c273fc$export$d705dada763d21f4)($2e9467226384ee42$var$turned(prims, (0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)($2e9467226384ee42$export$1723fce16411e77d(facing, (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(s.sideTurn ?? 10)))), $2e9467226384ee42$export$d30807e4c1575d23(s, frame));
};
/** The frame a species body is drawn on: its own, or bigger for the reach of what it holds (as a humanoid's grows). */ const $2e9467226384ee42$var$frameFor = (species, equipment)=>{
    const s = species.source;
    const held = $2e9467226384ee42$var$heldBy(species, equipment).held;
    if (!held) return s.frame;
    const reach = ((0, $121d74fbc26f823b$export$d2c6fd47dbbb12e9)("held", held)?.handling?.frame ?? 96) + (s.frame - 64);
    return Math.min(192, Math.max(s.frame, reach));
};
/**
 * Plan a species body's animation (generate.ts planEmberAnimation hands over any name a species
 * body has): `<action>-<facing>` plays the gait or clip its action table names for the action --
 * or one of its own clips by name -- in that facing. An attack on the move is played as the attack.
 */ /** The species, clip and facing an animation of a species body plays, if it plays one. */ const $2e9467226384ee42$var$speciesAnimation = (bodyName, animation)=>{
    const body = $2e9467226384ee42$export$d5a903a33aac0e0b[bodyName];
    const species = body && $2e9467226384ee42$export$95c628438644e357[body.species];
    if (!species) return undefined;
    const [name, direction] = animation.split("-");
    const facing = direction ?? "front";
    if (!(0, $bc9c62e5e9c273fc$export$3088316d51d20bbf).includes(facing)) return undefined;
    const action = name.split(".")[0];
    const clip = $2e9467226384ee42$var$clipFor(species, action);
    return clip && {
        body: body,
        species: species,
        clip: clip,
        facing: facing,
        action: action
    };
};
const $2e9467226384ee42$export$d82e76b404d6ad33 = (bodyName, animation, i)=>{
    const a = $2e9467226384ee42$var$speciesAnimation(bodyName, animation);
    if (!a) return undefined;
    const frame = Math.max(0, Math.min(a.clip.frames - 1, Math.floor(i)));
    return {
        skeleton: $2e9467226384ee42$export$aad71541133937d6(a.species.rig, a.clip.sample((0, $a1fb04dc4139ce6e$export$8ec32ae08bf1bc32)(a.clip, frame, a.clip.frames))),
        frames: a.clip.frames,
        clip: a.clip.name,
        scale: a.body.scale ?? 1
    };
};
const $2e9467226384ee42$export$cd3ee123dcc9a464 = (bodyName, animation, equipment = {})=>{
    const a = $2e9467226384ee42$var$speciesAnimation(bodyName, animation);
    if (!a) return undefined;
    const { body: body, species: species, clip: clip, facing: facing, action: action } = a;
    const s = species.source;
    const sideTurn = (0, $0a4786a5aadc3b7f$export$61ddd819c68acdd)(s.sideTurn ?? 10);
    const frame = $2e9467226384ee42$var$frameFor(species, equipment);
    const raster = $2e9467226384ee42$export$d30807e4c1575d23(s, frame);
    const k = body.scale ?? 1;
    const yaw = (0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)($2e9467226384ee42$export$1723fce16411e77d(facing, sideTurn));
    const lpcDuration = (0, $a1fb04dc4139ce6e$export$dd2163ed96be013a)[action];
    const pose = (i)=>$2e9467226384ee42$export$aad71541133937d6(species.rig, clip.sample((0, $a1fb04dc4139ce6e$export$8ec32ae08bf1bc32)(clip, i, clip.frames)));
    const at = (v)=>v ? (0, $bc9c62e5e9c273fc$export$98de20a72d8f134f)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(yaw, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(v, k)), raster) : {
            x: raster.centerX,
            y: raster.groundY
        };
    const points = s.points ?? {};
    return {
        name: animation,
        clip: clip.name,
        facing: facing,
        frameMs: lpcDuration ? lpcDuration / clip.frames : clip.frameMs,
        loop: clip.loop,
        strideCycle: clip.strideCycle && clip.strideCycle * k * $2e9467226384ee42$var$acrossScreen(facing, sideTurn),
        frameCount: clip.frames,
        renderFrame: (i)=>$2e9467226384ee42$export$ba8731937f6046f8(bodyName, pose(i), facing, equipment, frame),
        jointsAt: (i)=>{
            const sk = pose(i);
            const [l, r] = s.grips?.R || s.grips?.L ? [
                (s.grips.L ?? s.grips.R).hand,
                (s.grips.R ?? s.grips.L).hand
            ] : points.hands ?? [];
            return {
                head: at(sk.at[points.head ?? "head"]),
                hands: [
                    at(l ? sk.at[l] : undefined),
                    at(r ? sk.at[r] : undefined)
                ]
            };
        }
    };
};
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>catalog.source.emberSpecies, $2e9467226384ee42$export$1002d27273485b27);


/**
 * Settles: how a body comes to rest, instead of cutting to its standing frame.
 *
 * A body that stops walking or running is caught somewhere in its stride; one that has struck a
 * blow is left in its fighting stance. A settle is a short clip from that pose into the standing
 * one: a foot off its spot steps in (the standing one follows if it is far from its own), the hips
 * rise out of the stride's crouch, the chest rocks and comes upright, and the arms carry on a
 * little with the swing they had and come to rest. Each of those is a damped spring, so the motion
 * keeps the momentum it had and lands without a bounce.
 *
 * And the other way: a blow struck from standing eases its first frames out of the standing pose,
 * the lead foot stepping into the stance, without changing when the blow lands.
 */ 

const $bdd18b1d4b50ea61$export$fc1a3fb716667d55 = "settle";
const $bdd18b1d4b50ea61$export$4174912917740653 = "rest";
const $bdd18b1d4b50ea61$export$57583a5b8573e6df = [
    "slash",
    "thrust"
];
const $bdd18b1d4b50ea61$export$e3e0fdec67911fb1 = 50;
const $bdd18b1d4b50ea61$var$WALK_SETTLE = {
    oneStep: 0.3,
    twoSteps: 0.42,
    slideMax: 1.6,
    lift: 1.4,
    dip: 0.35,
    armMomentum: 0.55,
    leanKick: 0.5,
    period: 0.4,
    damping: 0.45,
    landing: 0.12
};
const $bdd18b1d4b50ea61$export$6dcca76cb5cf1068 = {
    walk: $bdd18b1d4b50ea61$var$WALK_SETTLE,
    run: {
        ...$bdd18b1d4b50ea61$var$WALK_SETTLE,
        oneStep: 0.4,
        twoSteps: 0.52,
        lift: 1.8,
        dip: 0.6,
        armMomentum: 0.4,
        leanKick: 0,
        period: 0.45
    }
};
const $bdd18b1d4b50ea61$export$9c55e422856a5bc = {
    ...$bdd18b1d4b50ea61$var$WALK_SETTLE,
    oneStep: 0.3,
    twoSteps: 0.3,
    lift: 1.2,
    dip: 0.3,
    armMomentum: 0,
    leanKick: 0
};
const $bdd18b1d4b50ea61$export$e2c6ffcb8d428e2 = {
    walk: 100,
    run: 160
};
const $bdd18b1d4b50ea61$export$f590991ffe484603 = 0.3;
/** An arm swinging back past its rest goes at most this far beyond it. */ const $bdd18b1d4b50ea61$var$MAX_SWING_PAST = 8 * Math.PI / 180;
const $bdd18b1d4b50ea61$var$mix = (a, b, u)=>a + (b - a) * u;
/** A damped spring's displacement `tau` seconds after leaving x0 at v0. */ const $bdd18b1d4b50ea61$var$spring = (x0, v0, tau, t)=>{
    const omega = 2 * Math.PI / t.period;
    const wd = omega * Math.sqrt(1 - t.damping * t.damping);
    const e = Math.exp(-t.damping * omega * tau);
    return e * (x0 * Math.cos(wd * tau) + (v0 + t.damping * omega * x0) / wd * Math.sin(wd * tau));
};
/** Whatever of the spring is left fades out over the last third, so a settle ends exactly at rest. */ const $bdd18b1d4b50ea61$var$fadeOut = (u)=>1 - (0, $0a4786a5aadc3b7f$export$4053e36566dd3d9a)((u - 0.65) / 0.35);
/** `past` beyond the rest it swung through, held to MAX_SWING_PAST however hard it came. */ const $bdd18b1d4b50ea61$var$capPast = (past)=>Math.sign(past) * $bdd18b1d4b50ea61$var$MAX_SWING_PAST * Math.tanh(Math.abs(past) / $bdd18b1d4b50ea61$var$MAX_SWING_PAST);
/** An angle settling on `rest` from `from`, moving at `velocity` (rad/s) when it started. */ const $bdd18b1d4b50ea61$var$settleAngle = (from, rest, velocity, tau, u, t)=>{
    const d = $bdd18b1d4b50ea61$var$spring(from - rest, velocity, tau, t) * $bdd18b1d4b50ea61$var$fadeOut(u);
    return rest + (Math.sign(d) !== Math.sign(from - rest) && d !== 0 ? $bdd18b1d4b50ea61$var$capPast(d) : d);
};
const $bdd18b1d4b50ea61$var$leg = (pose, side)=>pose.legs[side];
const $bdd18b1d4b50ea61$var$allIk = (...poses)=>poses.every((pose)=>(0, $16b5b2e1f0b8662b$export$7bcc7ebb13416507).every((s)=>pose.legs[s].mode === "ik"));
const $bdd18b1d4b50ea61$var$offFrom = (a, b)=>Math.hypot(a.ankle[0] - b.ankle[0], a.ankle[2] - b.ankle[2]);
/** A foot `s` (0..1) of the way through a step from `a` to `b`, lifted `lift` at its height. */ const $bdd18b1d4b50ea61$var$stepTo = (a, b, s, lift)=>{
    const c = Math.min(1, Math.max(0, s));
    const e = (0, $0a4786a5aadc3b7f$export$b0f87bb1f6530fd8)(c);
    const up = c > 0 && c < 1 ? lift * Math.sin(Math.PI * c) : 0;
    const ankle = [
        $bdd18b1d4b50ea61$var$mix(a.ankle[0], b.ankle[0], e),
        $bdd18b1d4b50ea61$var$mix(a.ankle[1], b.ankle[1], e) + up,
        $bdd18b1d4b50ea61$var$mix(a.ankle[2], b.ankle[2], e)
    ];
    return {
        mode: "ik",
        ankle: ankle,
        footPitch: $bdd18b1d4b50ea61$var$mix(a.footPitch, b.footPitch, e),
        planted: c <= 0 || c >= 1
    };
};
/** Keep the pelvis low enough that every foot on the ground is still reached. */ const $bdd18b1d4b50ea61$var$reachable = (pose, p)=>{
    const sk = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(pose, p);
    let height = pose.root[1];
    for (const s of (0, $16b5b2e1f0b8662b$export$7bcc7ebb13416507)){
        const l = pose.legs[s];
        if (l.mode === "ik" && l.planted !== false) height = Math.min(height, (0, $16b5b2e1f0b8662b$export$f8a8a1c830424ad0)(l.ankle, [
            sk[s].hip[0],
            sk[s].hip[2]
        ], p));
    }
    return height === pose.root[1] ? pose : {
        ...pose,
        root: [
            pose.root[0],
            height,
            pose.root[2]
        ]
    };
};
/** The body's turn about the vertical (a blow's hips turn it; nothing a settle starts from rolls or pitches it). */ const $bdd18b1d4b50ea61$var$yawOf = (pose)=>Math.atan2(pose.rootRotation[2], pose.rootRotation[0]);
/** The arm as a place for the hand -- from its shoulder, in the chest's frame -- as `pose` puts it. */ const $bdd18b1d4b50ea61$var$reachOf = (pose, side, p, sk)=>{
    const arm = pose.arms[side];
    if (arm.reach && arm.pole && arm.grip) return arm;
    const solved = sk ?? (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(pose, p);
    const toChest = (0, $0a4786a5aadc3b7f$export$9cb09a71b7d66923)(solved.torsoBasis);
    const limb = solved[side];
    const bend = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(limb.elbow, (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(limb.shoulder, limb.hand), 0.5)));
    return {
        ...arm,
        reach: arm.reach ?? (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(toChest, (0, $0a4786a5aadc3b7f$export$f93b5905241a7cca)(limb.hand, limb.shoulder)),
        pole: arm.pole ?? ((0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(bend, bend) > 0.5 ? (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(toChest, bend) : [
            0,
            0,
            -1
        ]),
        grip: arm.grip ?? (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(toChest, limb.grip)
    };
};
/** Along the great circle from `a` toward `b`: `s` past 1 carries on beyond `b`. */ const $bdd18b1d4b50ea61$var$slerpDirection = (a, b, s)=>{
    const ua = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(a), ub = (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(b);
    const angle = Math.acos(Math.max(-1, Math.min(1, (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(ua, ub))));
    if (angle < 1e-4) return (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$3a89f8d6f6bf6c9f)(ua, ub, s));
    const k = Math.sin(angle);
    return (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)((0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(ua, Math.sin((1 - s) * angle) / k), (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)(ub, Math.sin(s * angle) / k));
};
/**
 * An arm `s` of the way from how `a` holds it to how `b` does, `s` past 1 swinging on beyond `b`
 * (held to MAX_SWING_PAST). Angles mix as angles; an arm placed by its hand (a polearm carried, both
 * hands on a hilt, a load in the arms) moves its hand round the shoulder instead.
 */ const $bdd18b1d4b50ea61$var$blendArm = (a, b, side, s, p, skA, skB)=>{
    const A = a.arms[side], B = b.arms[side];
    if (!A.reach && !B.reach) {
        const angle = (x, y)=>s > 1 ? y + $bdd18b1d4b50ea61$var$capPast((s - 1) * (y - x)) : $bdd18b1d4b50ea61$var$mix(x, y, s);
        return {
            pitch: angle(A.pitch, B.pitch),
            abduct: angle(A.abduct, B.abduct),
            flex: angle(A.flex, B.flex),
            wrist: $bdd18b1d4b50ea61$var$mix(A.wrist ?? (0, $16b5b2e1f0b8662b$export$739083ff10a3e078), B.wrist ?? (0, $16b5b2e1f0b8662b$export$739083ff10a3e078), Math.min(1, s)),
            out: $bdd18b1d4b50ea61$var$mix(A.out ?? (0, $16b5b2e1f0b8662b$export$afa0f8e5c42b3f10), B.out ?? (0, $16b5b2e1f0b8662b$export$afa0f8e5c42b3f10), Math.min(1, s)),
            open: s < 0.5 ? A.open : B.open
        };
    }
    const ra = $bdd18b1d4b50ea61$var$reachOf(a, side, p, skA), rb = $bdd18b1d4b50ea61$var$reachOf(b, side, p, skB);
    const turn = Math.acos(Math.max(-1, Math.min(1, (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)((0, $0a4786a5aadc3b7f$export$a3295358bff77e)(ra.reach), (0, $0a4786a5aadc3b7f$export$a3295358bff77e)(rb.reach)))));
    const along = s > 1 && turn > 1e-4 ? 1 + Math.min(s - 1, $bdd18b1d4b50ea61$var$MAX_SWING_PAST / turn) : s;
    return {
        ...s < 0.5 ? A : B,
        reach: (0, $0a4786a5aadc3b7f$export$dcdf75081b88279d)($bdd18b1d4b50ea61$var$slerpDirection(ra.reach, rb.reach, along), $bdd18b1d4b50ea61$var$mix((0, $0a4786a5aadc3b7f$export$f24224f1c91d8156)(ra.reach), (0, $0a4786a5aadc3b7f$export$f24224f1c91d8156)(rb.reach), Math.min(1, along))),
        pole: (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$3a89f8d6f6bf6c9f)(ra.pole, rb.pole, Math.min(1, along))),
        grip: (0, $0a4786a5aadc3b7f$export$a3295358bff77e)((0, $0a4786a5aadc3b7f$export$3a89f8d6f6bf6c9f)(ra.grip, rb.grip, Math.min(1, along)))
    };
};
const $bdd18b1d4b50ea61$export$7445b8c8e5bfeada = (gait, phase, cyclesPerSecond, rest, tuning, p, facing)=>{
    const from = gait.sample(phase, p, facing);
    const dt = 0.004;
    const next = gait.sample((phase + dt * cyclesPerSecond) % 1, p, facing);
    const still = rest.sample(0, p, facing);
    if (!$bdd18b1d4b50ea61$var$allIk(from, still)) return undefined;
    const off = (s)=>$bdd18b1d4b50ea61$var$offFrom($bdd18b1d4b50ea61$var$leg(from, s), $bdd18b1d4b50ea61$var$leg(still, s));
    const planted = (0, $16b5b2e1f0b8662b$export$7bcc7ebb13416507).filter((s)=>$bdd18b1d4b50ea61$var$leg(from, s).planted);
    const landsIn = (s)=>{
        for(let k = 1; k <= 100; k++)if (gait.sample((phase + k / 100) % 1, p, facing).legs[s].planted) return k;
        return Infinity;
    };
    const landing = planted.length === 0;
    const pivot = landing ? (0, $16b5b2e1f0b8662b$export$7bcc7ebb13416507).slice().sort((a, b)=>landsIn(a) - landsIn(b))[0] : planted.slice().sort((a, b)=>off(a) - off(b))[0];
    const stepper = pivot === "L" ? "R" : "L";
    const landed = {
        ...$bdd18b1d4b50ea61$var$leg(from, pivot),
        ankle: [
            $bdd18b1d4b50ea61$var$leg(from, pivot).ankle[0],
            $bdd18b1d4b50ea61$var$leg(still, pivot).ankle[1],
            $bdd18b1d4b50ea61$var$leg(from, pivot).ankle[2]
        ],
        footPitch: 0
    };
    const pivotStart = landing ? landed : $bdd18b1d4b50ea61$var$leg(from, pivot);
    const slideFrom = landing ? tuning.landing + 0.1 : 0.15;
    const twoSteps = off(pivot) > tuning.slideMax;
    const duration = twoSteps ? tuning.twoSteps : tuning.oneStep;
    const frames = Math.max(2, Math.round(duration * 1000 / $bdd18b1d4b50ea61$export$e3e0fdec67911fb1));
    const firstEnd = twoSteps ? 0.5 : 0.7;
    const lift = (s, share)=>Math.min(tuning.lift, Math.max(0.5, off(s) * 0.12)) * share;
    const velocity = (a, b)=>(b - a) / dt;
    const swinging = (0, $16b5b2e1f0b8662b$export$7bcc7ebb13416507).every((s)=>!from.arms[s].reach && !still.arms[s].reach);
    const skFrom = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(from, p), skStill = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(still, p);
    const sample = (t)=>{
        // Frame 0 follows the stride frame on show; the last comes just before the standing frame.
        const u = (t * (frames - 1) + 1) / (frames + 1);
        const tau = u * duration;
        const e = (0, $0a4786a5aadc3b7f$export$b0f87bb1f6530fd8)(u);
        const share = 1 - $bdd18b1d4b50ea61$var$spring(1, 0, tau, tuning) * $bdd18b1d4b50ea61$var$fadeOut(u);
        const legs = {};
        legs[stepper] = $bdd18b1d4b50ea61$var$stepTo($bdd18b1d4b50ea61$var$leg(from, stepper), $bdd18b1d4b50ea61$var$leg(still, stepper), u / firstEnd, lift(stepper, 1));
        legs[pivot] = landing && u < tuning.landing ? $bdd18b1d4b50ea61$var$stepTo($bdd18b1d4b50ea61$var$leg(from, pivot), landed, u / tuning.landing, 0) : twoSteps ? $bdd18b1d4b50ea61$var$stepTo(pivotStart, $bdd18b1d4b50ea61$var$leg(still, pivot), (u - firstEnd) / (0.95 - firstEnd), lift(pivot, 0.7)) : {
            ...$bdd18b1d4b50ea61$var$stepTo(pivotStart, $bdd18b1d4b50ea61$var$leg(still, pivot), (u - slideFrom) / (0.85 - slideFrom), 0),
            planted: true
        };
        const arm = (s)=>{
            if (!swinging) return $bdd18b1d4b50ea61$var$blendArm(from, still, s, share, p, skFrom, skStill);
            const a = from.arms[s], b = still.arms[s], n = next.arms[s];
            return {
                pitch: $bdd18b1d4b50ea61$var$settleAngle(a.pitch, b.pitch, velocity(a.pitch, n.pitch) * tuning.armMomentum, tau, u, tuning),
                abduct: $bdd18b1d4b50ea61$var$mix(a.abduct, b.abduct, e),
                flex: $bdd18b1d4b50ea61$var$settleAngle(a.flex, b.flex, velocity(a.flex, n.flex) * tuning.armMomentum, tau, u, tuning),
                wrist: $bdd18b1d4b50ea61$var$mix(a.wrist ?? (0, $16b5b2e1f0b8662b$export$739083ff10a3e078), b.wrist ?? (0, $16b5b2e1f0b8662b$export$739083ff10a3e078), e),
                out: $bdd18b1d4b50ea61$var$mix(a.out ?? (0, $16b5b2e1f0b8662b$export$afa0f8e5c42b3f10), b.out ?? (0, $16b5b2e1f0b8662b$export$afa0f8e5c42b3f10), e),
                // The hand opens as it comes to rest, mid-settle, while it still moves.
                open: e < 0.5 ? a.open : b.open
            };
        };
        const lean = $bdd18b1d4b50ea61$var$settleAngle(from.lean, still.lean, velocity(from.lean, next.lean) + tuning.leanKick, tau, u, tuning);
        return $bdd18b1d4b50ea61$var$reachable({
            root: [
                $bdd18b1d4b50ea61$var$mix(from.root[0], still.root[0], e),
                $bdd18b1d4b50ea61$var$mix(from.root[1], still.root[1], e) - tuning.dip * Math.sin(Math.PI * u),
                $bdd18b1d4b50ea61$var$mix(from.root[2], still.root[2], e)
            ],
            rootRotation: still.rootRotation,
            lean: lean,
            twist: $bdd18b1d4b50ea61$var$settleAngle(from.twist, still.twist, velocity(from.twist, next.twist), tau, u, tuning),
            sideBend: $bdd18b1d4b50ea61$var$mix(from.sideBend, still.sideBend, e),
            // The eyes stay level as the chest rocks.
            headPitch: $bdd18b1d4b50ea61$var$mix(from.headPitch, still.headPitch, e) - 0.4 * (lean - $bdd18b1d4b50ea61$var$mix(from.lean, still.lean, e)),
            headYaw: $bdd18b1d4b50ea61$var$mix(from.headYaw, still.headYaw, e),
            arms: {
                L: arm("L"),
                R: arm("R")
            },
            legs: legs,
            draw: still.draw
        }, p);
    };
    return {
        name: $bdd18b1d4b50ea61$export$fc1a3fb716667d55,
        frames: frames,
        frameMs: $bdd18b1d4b50ea61$export$e3e0fdec67911fb1,
        loop: false,
        sample: sample
    };
};
const $bdd18b1d4b50ea61$export$c86439634b9d2068 = (end, rest, p, facing, tuning = $bdd18b1d4b50ea61$export$9c55e422856a5bc)=>{
    const from = end.sample(1, p, facing);
    const still = rest.sample(0, p, facing);
    if (!$bdd18b1d4b50ea61$var$allIk(from, still)) return undefined;
    const duration = tuning.oneStep;
    const frames = Math.max(2, Math.round(duration * 1000 / $bdd18b1d4b50ea61$export$e3e0fdec67911fb1));
    const skFrom = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(from, p), skStill = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(still, p);
    const yaw = $bdd18b1d4b50ea61$var$yawOf(from);
    const sample = (t)=>{
        const u = (t * (frames - 1) + 1) / (frames + 1);
        const tau = u * duration;
        const e = (0, $0a4786a5aadc3b7f$export$b0f87bb1f6530fd8)(u);
        const share = 1 - $bdd18b1d4b50ea61$var$spring(1, 0, tau, tuning) * $bdd18b1d4b50ea61$var$fadeOut(u);
        const legs = {};
        for (const s of (0, $16b5b2e1f0b8662b$export$7bcc7ebb13416507))legs[s] = $bdd18b1d4b50ea61$var$offFrom($bdd18b1d4b50ea61$var$leg(from, s), $bdd18b1d4b50ea61$var$leg(still, s)) > 0.5 ? $bdd18b1d4b50ea61$var$stepTo($bdd18b1d4b50ea61$var$leg(from, s), $bdd18b1d4b50ea61$var$leg(still, s), (u - 0.1) / 0.5, tuning.lift) : {
            ...$bdd18b1d4b50ea61$var$leg(still, s),
            planted: true
        };
        const sweep = (s)=>0.45 * Math.max(0, from.arms[s].pitch - Math.PI / 2) * Math.sin(Math.PI * Math.min(1, u * 1.8));
        const arm = (s)=>{
            const blended = $bdd18b1d4b50ea61$var$blendArm(from, still, s, share, p, skFrom, skStill);
            return blended.reach ? blended : {
                ...blended,
                abduct: $bdd18b1d4b50ea61$var$mix(from.arms[s].abduct, still.arms[s].abduct, e) + sweep(s)
            };
        };
        return $bdd18b1d4b50ea61$var$reachable({
            root: [
                $bdd18b1d4b50ea61$var$mix(from.root[0], still.root[0], e),
                $bdd18b1d4b50ea61$var$mix(from.root[1], still.root[1], e) - tuning.dip * Math.sin(Math.PI * u),
                $bdd18b1d4b50ea61$var$mix(from.root[2], still.root[2], e)
            ],
            rootRotation: yaw ? (0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)(yaw * (1 - e)) : still.rootRotation,
            lean: $bdd18b1d4b50ea61$var$mix(from.lean, still.lean, share),
            twist: $bdd18b1d4b50ea61$var$mix(from.twist, still.twist, share),
            sideBend: $bdd18b1d4b50ea61$var$mix(from.sideBend, still.sideBend, e),
            headPitch: $bdd18b1d4b50ea61$var$mix(from.headPitch, still.headPitch, e),
            headYaw: $bdd18b1d4b50ea61$var$mix(from.headYaw, still.headYaw, e),
            arms: {
                L: arm("L"),
                R: arm("R")
            },
            legs: legs,
            draw: still.draw
        }, p);
    };
    return {
        name: $bdd18b1d4b50ea61$export$fc1a3fb716667d55,
        frames: frames,
        frameMs: $bdd18b1d4b50ea61$export$e3e0fdec67911fb1,
        loop: false,
        sample: sample
    };
};
/** The stance's lead foot: the one the blow puts furthest ahead of where it stands at rest. */ const $bdd18b1d4b50ea61$var$leadFoot = (stance, still)=>{
    const ahead = (s)=>$bdd18b1d4b50ea61$var$leg(stance, s).ankle[2] - $bdd18b1d4b50ea61$var$leg(still, s).ankle[2];
    const lead = ahead("L") >= ahead("R") ? "L" : "R";
    return ahead(lead) > 1 ? lead : undefined;
};
const $bdd18b1d4b50ea61$export$c6f480c259bac807 = (attack, rest, fromRest)=>({
        ...attack,
        sample: (t, p, facing)=>{
            const a = attack.sample(t, p, facing);
            const still = rest.sample(0, p, facing);
            const stance = attack.sample(0, p, facing);
            if (!$bdd18b1d4b50ea61$var$allIk(a, still, stance)) return a;
            const lead = $bdd18b1d4b50ea61$var$leadFoot(stance, still);
            const into = (t + 0.1) / ($bdd18b1d4b50ea61$export$f590991ffe484603 + 0.1);
            const legs = {};
            for (const s of (0, $16b5b2e1f0b8662b$export$7bcc7ebb13416507))legs[s] = s !== lead ? {
                ...$bdd18b1d4b50ea61$var$leg(still, s),
                planted: true
            } : fromRest ? $bdd18b1d4b50ea61$var$stepTo($bdd18b1d4b50ea61$var$leg(still, s), $bdd18b1d4b50ea61$var$leg(a, s), into, $bdd18b1d4b50ea61$export$9c55e422856a5bc.lift) : $bdd18b1d4b50ea61$var$leg(a, s);
            const w = fromRest ? (0, $0a4786a5aadc3b7f$export$4053e36566dd3d9a)(into) : 1;
            if (w >= 1) return $bdd18b1d4b50ea61$var$reachable({
                ...a,
                legs: legs
            }, p);
            return $bdd18b1d4b50ea61$var$reachable({
                ...a,
                root: [
                    $bdd18b1d4b50ea61$var$mix(still.root[0], a.root[0], w),
                    $bdd18b1d4b50ea61$var$mix(still.root[1], a.root[1], w),
                    $bdd18b1d4b50ea61$var$mix(still.root[2], a.root[2], w)
                ],
                lean: $bdd18b1d4b50ea61$var$mix(still.lean, a.lean, w),
                twist: $bdd18b1d4b50ea61$var$mix(still.twist, a.twist, w),
                sideBend: $bdd18b1d4b50ea61$var$mix(still.sideBend, a.sideBend, w),
                headPitch: $bdd18b1d4b50ea61$var$mix(still.headPitch, a.headPitch, w),
                headYaw: $bdd18b1d4b50ea61$var$mix(still.headYaw, a.headYaw, w),
                arms: {
                    L: $bdd18b1d4b50ea61$var$blendArm(still, a, "L", w, p),
                    R: $bdd18b1d4b50ea61$var$blendArm(still, a, "R", w, p)
                },
                legs: legs
            }, p);
        }
    });


/**
 * Eyes, as pixel patterns stamped onto the face.
 *
 * An eye is a few pixels. Rendered from geometry it comes out a different few pixels every frame,
 * so the eyes are stamped on (raster.ts PixelStamp) at the point of the face where the skeleton puts
 * them, and the head's actual turn -- not the facing name -- picks the pattern: both eyes from the
 * front, the near one in profile, none from behind.
 *
 * Placement is calibrated to the LPC body (eye rows 29-31, columns 26-29 / 34-37 from the front);
 * the LOOK is a style. The styles, their colours and where they sit are content
 * (`content/game/sprites/ember/marks.json`): `lpc` is LPC's own eye, read off
 * body/male/human/light.png; `ember`, the default, is Ember's, so an Ember face is not mistaken for
 * an LPC one.
 *
 * Pattern characters name colours (marks.json eyeLetters, a style's own `colors`): n brow, # lash,
 * c cool glint, a ember glint, w white, i iris, p pupil, e the dark of an Ember eye; "." leaves the
 * skin alone.
 */ 




const $21b031d89cccca05$export$7f86446b4a44e3a1 = {};
let $21b031d89cccca05$export$d2091885a55adee9 = "ember";
/** Where eyes sit and when they show (marks.json eyePlacement). */ const $21b031d89cccca05$var$PLACEMENT = {
    frontTurn: 0.5,
    profileTurn: 0.6,
    faceDepth: 0.97,
    cheek: 0.8
};
/** Each style's letters with how to colour them: from the face's skin, or fixed. */ const $21b031d89cccca05$var$LETTERS = new Map();
const $21b031d89cccca05$var$colorOf = (ref)=>{
    if (/^#[0-9a-fA-F]{6}$/.test(ref)) {
        const c = parseInt(ref.slice(1), 16);
        return ()=>c;
    }
    const [table, name] = ref.split(".");
    if (table === "skin") return (skin)=>skin[name];
    const c = (0, $b28f7e6af286c932$export$4c4520429be8c63)[name];
    if (table !== "eye" || c === undefined) throw new Error(`Unknown eye colour ${ref}`);
    return ()=>c;
};
const $21b031d89cccca05$export$c170135e258ddd8c = (file)=>{
    for (const k of Object.keys($21b031d89cccca05$export$7f86446b4a44e3a1))delete $21b031d89cccca05$export$7f86446b4a44e3a1[k];
    $21b031d89cccca05$var$LETTERS.clear();
    for (const [name, style] of Object.entries(file?.eyeStyles ?? {})){
        $21b031d89cccca05$export$7f86446b4a44e3a1[name] = style;
        const letters = {
            ...file?.eyeLetters ?? {},
            ...style.colors ?? {}
        };
        $21b031d89cccca05$var$LETTERS.set(name, Object.entries(letters).filter(([letter])=>letter !== "about").map(([letter, ref])=>[
                letter,
                $21b031d89cccca05$var$colorOf(ref)
            ]));
    }
    $21b031d89cccca05$export$d2091885a55adee9 = file?.defaultEyes ?? "ember";
    Object.assign($21b031d89cccca05$var$PLACEMENT, file?.eyePlacement ?? {});
    (0, $121d74fbc26f823b$export$35d5ab3d09c2908f)("eyes", file && {
        eyeLetters: file.eyeLetters,
        eyePlacement: file.eyePlacement,
        defaultEyes: file.defaultEyes,
        eyeStyles: file.eyeStyles
    });
};
const $21b031d89cccca05$var$mirror = (rows)=>rows.map((row)=>row.split("").reverse().join(""));
const $21b031d89cccca05$export$5d2150392ebecbf4 = (sk, p, skin, facing, styleName = $21b031d89cccca05$export$d2091885a55adee9, o = (0, $bc9c62e5e9c273fc$export$5f22db6dc00b1799))=>{
    const style = $21b031d89cccca05$export$7f86446b4a44e3a1[styleName] ?? $21b031d89cccca05$export$7f86446b4a44e3a1[$21b031d89cccca05$export$d2091885a55adee9];
    if (!style) return [];
    const yaw = (0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)((0, $bc9c62e5e9c273fc$export$376317e739a8c334)[facing]);
    const { right: right, back: back } = (0, $bc9c62e5e9c273fc$export$bcbbffdf78e2f935)(o.pitch);
    const head = (0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(yaw, sk.headBasis);
    const forward = (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(head, [
        0,
        0,
        1
    ]);
    const toward = (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(forward, back);
    const sideways = (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)(forward, right);
    const palette = {};
    for (const [letter, color] of $21b031d89cccca05$var$LETTERS.get($21b031d89cccca05$export$7f86446b4a44e3a1[styleName] ? styleName : $21b031d89cccca05$export$d2091885a55adee9) ?? [])palette[letter] = color(skin);
    // A point on the head, in head-local coordinates, to frame pixels.
    const at = (local)=>(0, $bc9c62e5e9c273fc$export$98de20a72d8f134f)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(yaw, (0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(sk.head, (0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(sk.headBasis, local))), o);
    const stamp = (local, rows)=>{
        const q = at(local);
        return {
            x: Math.round(q.x - style.center.x),
            y: Math.round(q.y - style.center.y),
            rows: rows,
            palette: palette,
            group: "head"
        };
    };
    const [a, , c] = p.head;
    const front = c * $21b031d89cccca05$var$PLACEMENT.faceDepth;
    if (toward > $21b031d89cccca05$var$PLACEMENT.frontTurn) {
        const eyes = [
            -1,
            1
        ].map((s)=>{
            const local = [
                s * p.eyeSpacing,
                p.eyeHeight,
                front
            ];
            return {
                local: local,
                x: at(local).x
            };
        });
        eyes.sort((l, r)=>l.x - r.x);
        return [
            stamp(eyes[0].local, style.front[0]),
            stamp(eyes[1].local, style.front[1])
        ];
    }
    if (toward > 0 && Math.abs(sideways) > $21b031d89cccca05$var$PLACEMENT.profileTurn) {
        // The near eye is on whichever side of the head faces the camera.
        const near = (0, $0a4786a5aadc3b7f$export$94132a0e348806d4)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(head, [
            1,
            0,
            0
        ]), back) > 0 ? 1 : -1;
        // The side facings stand three-quarters on (raster.ts SIDE_TURN), so the near eye is on the
        // face, toward its near cheek; profileEyeInset sets it back from the face's front edge.
        const local = [
            near * a * $21b031d89cccca05$var$PLACEMENT.cheek,
            p.eyeHeight,
            front - p.profileEyeInset
        ];
        const side = stamp(local, sideways < 0 ? style.profile : $21b031d89cccca05$var$mirror(style.profile));
        // On the rows the eyes would be on from the front, in this same pose: that spot on a turned
        // face is nearer the camera, and the tilt would otherwise drop a side eye a row below the
        // front ones. LPC keeps them level across facings.
        const level = (0, $bc9c62e5e9c273fc$export$98de20a72d8f134f)((0, $0a4786a5aadc3b7f$export$e16d8520af44a096)(sk.head, [
            0,
            p.eyeHeight,
            front
        ]), o);
        return [
            {
                ...side,
                y: Math.round(level.y - style.center.y)
            }
        ];
    }
    return [];
};
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>catalog.source.emberMarks, $21b031d89cccca05$export$c170135e258ddd8c);


/**
 * Anatomy as LPC paints it: deliberate marks on simple shapes, not more volumes.
 *
 * Collarbones, a lit deltoid cap, abdominals, a fist's knuckles, a knee -- modelled as bumps these
 * melt into lumps at this size, and shading alone puts a highlight wherever the light happens to
 * fall rather than one per muscle. LPC paints each muscle its own small light and shade, which is
 * what makes every joint read. So these are painted on: pixel patterns read off the LPC male body
 * (tools ember-markgen), each pinned to a joint of the skeleton so it moves with the pose.
 *
 * A mark's `at` is where LPC paints it in the standing frame of its facing; its offset from the
 * joint is measured in Ember's standing pose (default proportions), so standing still the mark lands
 * on LPC's pixel and any other pose carries it along with the joint. It paints only bare skin of the
 * parts around that joint (a shirt or an arm in front hides it), and is left off when the limb has
 * swung far from where it hung, since a pattern does not rotate.
 *
 * Front and back marks are written for the screen-left limb and mirrored; right is left mirrored.
 * Pattern characters name the skin ramp's steps (marks.json markLetters: L light, B base, S shade,
 * D deep, n line); "." leaves the render alone. The marks themselves are content
 * (`content/game/sprites/ember/marks.json` markSets); a style names the set it paints.
 */ 




const $025663646c3dcfd6$export$f6e01cc85815d75f = {};
/** The skin ramp step each pattern letter paints (marks.json markLetters). */ const $025663646c3dcfd6$var$LETTERS = [];
const $025663646c3dcfd6$export$9182792cd10d0355 = (file)=>{
    for (const k of Object.keys($025663646c3dcfd6$export$f6e01cc85815d75f))delete $025663646c3dcfd6$export$f6e01cc85815d75f[k];
    Object.assign($025663646c3dcfd6$export$f6e01cc85815d75f, file?.markSets ?? {});
    $025663646c3dcfd6$var$LETTERS.length = 0;
    for (const [letter, step] of Object.entries(file?.markLetters ?? {}))if (letter !== "about") $025663646c3dcfd6$var$LETTERS.push([
        letter,
        step
    ]);
    (0, $121d74fbc26f823b$export$35d5ab3d09c2908f)("marks", file && {
        markLetters: file.markLetters,
        markSets: file.markSets
    });
};
const $025663646c3dcfd6$var$mirrorRows = (rows)=>rows.map((row)=>row.split("").reverse().join(""));
/** The same mark on the other half of the frame: LPC's facings mirror about the frame's middle. */ const $025663646c3dcfd6$var$mirrored = (m, side, frame)=>({
        ...m,
        side: side,
        at: [
            frame - m.at[0] - m.rows[0].length,
            m.at[1]
        ],
        rows: $025663646c3dcfd6$var$mirrorRows(m.rows)
    });
const $025663646c3dcfd6$var$marksFor = (set, facing)=>{
    const from = set.mirrorFacings[facing];
    if (from) return (set.facings[from] ?? []).map((m)=>$025663646c3dcfd6$var$mirrored(m, m.side, set.frame));
    // These screen-space patterns are measured for cardinal views only. Diagonals use volume shading.
    const own = set.facings[facing];
    if (!own) return [];
    return [
        ...own,
        ...own.filter((m)=>m.side && set.mirrorSides[m.side]).map((m)=>$025663646c3dcfd6$var$mirrored(m, set.mirrorSides[m.side], set.frame))
    ];
};
const $025663646c3dcfd6$var$BONE = {
    shoulder: [
        "shoulder",
        "elbow"
    ],
    elbow: [
        "shoulder",
        "elbow"
    ],
    hand: [
        "elbow",
        "hand"
    ],
    knee: [
        "hip",
        "knee"
    ],
    ankle: [
        "knee",
        "ankle"
    ]
};
const $025663646c3dcfd6$var$armOf = (side)=>side === "L" ? "armL" : "armR";
const $025663646c3dcfd6$var$legOf = (side)=>side === "L" ? "legL" : "legR";
const $025663646c3dcfd6$export$a14966d9255adb0b = (sk, p, skin, facing, o = (0, $bc9c62e5e9c273fc$export$5f22db6dc00b1799), setName = "lpc-male")=>{
    const set = $025663646c3dcfd6$export$f6e01cc85815d75f[setName];
    if (!set) return [];
    const SWUNG = set.swungLimit * Math.PI / 180;
    const TURNED = set.turnedLimit;
    const FRAME = set.frame;
    const yaw = (0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)((0, $bc9c62e5e9c273fc$export$376317e739a8c334)[facing]);
    const { back: back } = (0, $bc9c62e5e9c273fc$export$bcbbffdf78e2f935)(o.pitch);
    const at = (v)=>(0, $bc9c62e5e9c273fc$export$98de20a72d8f134f)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(yaw, v), o);
    const depth = (v)=>(0, $0a4786a5aadc3b7f$export$94132a0e348806d4)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(yaw, v), back);
    const toward = (s)=>(0, $0a4786a5aadc3b7f$export$94132a0e348806d4)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)((0, $0a4786a5aadc3b7f$export$6e3a27864ab166fe)(yaw, s.torsoBasis), [
            0,
            0,
            1
        ]), back);
    // Where the marks were measured: Ember standing, in this facing, at the default build.
    const standing = (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)((0, $16b5b2e1f0b8662b$export$a021dd78582c0634)((0, $16b5b2e1f0b8662b$export$e9495ff1e036db03), facing), (0, $16b5b2e1f0b8662b$export$e9495ff1e036db03));
    const torsoFits = Math.abs(toward(sk) - toward(standing)) < TURNED;
    // Which of the skeleton's limbs a side names, decided standing so it cannot swap mid-stride.
    const limb = (side, joint)=>{
        const [l, r] = [
            standing.L[joint],
            standing.R[joint]
        ];
        if (side === "near") return depth(l) > depth(r) ? "L" : "R";
        if (side === "far") return depth(l) > depth(r) ? "R" : "L";
        const leftmost = at(l).x < at(r).x ? "L" : "R";
        return side === "screenRight" ? leftmost === "L" ? "R" : "L" : leftmost;
    };
    const angle = (s, side, joint)=>{
        const [from, to] = $025663646c3dcfd6$var$BONE[joint];
        const a = at(s[side][from]), b = at(s[side][to]);
        return Math.atan2(b.y - a.y, b.x - a.x);
    };
    const palette = {};
    for (const [letter, step] of $025663646c3dcfd6$var$LETTERS)palette[letter] = skin[step];
    const stamps = [];
    for (const mark of $025663646c3dcfd6$var$marksFor(set, facing)){
        let now, then, group;
        if (mark.on === "head" || mark.on === "neck" || mark.on === "chest" || mark.on === "pelvis") {
            if (!torsoFits) continue;
            now = sk[mark.on];
            then = standing[mark.on];
            group = mark.on === "head" ? [
                "head"
            ] : mark.on === "neck" ? [
                "head",
                "torso",
                "shoulder"
            ] : [
                "torso",
                "bust",
                "shoulder"
            ];
        } else {
            const side = limb(mark.side, mark.on);
            let swing = Math.abs(angle(sk, side, mark.on) - angle(standing, side, mark.on));
            if (swing > Math.PI) swing = 2 * Math.PI - swing;
            if (swing > SWUNG) continue;
            now = sk[side][mark.on];
            then = standing[side][mark.on];
            group = mark.on === "shoulder" ? [
                "shoulder",
                "torso",
                $025663646c3dcfd6$var$armOf(side)
            ] : mark.on === "knee" || mark.on === "ankle" ? [
                $025663646c3dcfd6$var$legOf(side)
            ] : [
                $025663646c3dcfd6$var$armOf(side)
            ];
        }
        const q = at(now), q0 = at(then);
        // `at` is in LPC's 64px frame; a bigger frame (a held tool's) centres the same body in it.
        const grow = [
            (o.width - FRAME) / 2,
            (o.height - FRAME) / 2
        ];
        stamps.push({
            x: Math.round(q.x + mark.at[0] - q0.x + grow[0]),
            y: Math.round(q.y + mark.at[1] - q0.y + grow[1]),
            rows: mark.rows,
            palette: palette,
            group: group,
            material: skin
        });
    }
    return stamps;
};
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>catalog.source.emberMarks, $025663646c3dcfd6$export$9182792cd10d0355);







const $2018397478b2b37f$export$1b95202ede0d296c = (overrides)=>({
        ...(0, $16b5b2e1f0b8662b$export$e9495ff1e036db03),
        ...overrides || {}
    });
/** The skeleton a clip puts a body in at `t`, and the camera it is drawn with, for a facing. */ const $2018397478b2b37f$var$posed = (proportions, clip, t, facing, style)=>{
    let raster = style.raster;
    const pose = clip.sample(t, proportions, facing);
    // In a side facing the head turns back toward profile from the body's three-quarter stance
    // (see SIDE_TURN): toward the near side's opposite, whichever way the figure faces.
    if (facing === "left") pose.headYaw -= (0, $bc9c62e5e9c273fc$export$d5e55da86199c818);
    if (facing === "right") pose.headYaw += (0, $bc9c62e5e9c273fc$export$d5e55da86199c818);
    if (facing === "left" || facing === "right") {
        const toward = facing === "left" ? -1 : 1;
        raster = {
            ...raster,
            centerX: raster.centerX + toward * (0, $bc9c62e5e9c273fc$export$3012b1de2ca8cf4e).x,
            groundY: raster.groundY - (0, $bc9c62e5e9c273fc$export$3012b1de2ca8cf4e).y
        };
    }
    return {
        skeleton: (0, $16b5b2e1f0b8662b$export$8e00bc1a07512ac6)(pose, proportions),
        raster: raster
    };
};
const $2018397478b2b37f$export$37e1edfd62a35be2 = (proportions, clip, t, facing, style)=>{
    const { skeleton: skeleton, raster: raster } = $2018397478b2b37f$var$posed(proportions, clip, t, facing, style);
    const turn = (0, $0a4786a5aadc3b7f$export$d4dbf6597d59367)((0, $bc9c62e5e9c273fc$export$376317e739a8c334)[facing]);
    const at = (v)=>(0, $bc9c62e5e9c273fc$export$98de20a72d8f134f)((0, $0a4786a5aadc3b7f$export$5635d7ef4b8fee1c)(turn, v), raster);
    return {
        head: at(skeleton.head),
        hands: [
            at((0, $9311ef6950e6afe4$export$e8bff534353f9c48)(skeleton, proportions, "L")),
            at((0, $9311ef6950e6afe4$export$e8bff534353f9c48)(skeleton, proportions, "R"))
        ]
    };
};
const $2018397478b2b37f$export$e9ad4ea9b773aa4f = (look, proportions, clip, t, facing, style = (0, $df52b6239fb99090$export$f93cc37bce51e09b)[0, $df52b6239fb99090$export$38a28ac32dc22856])=>{
    const { skeleton: skeleton, raster: raster } = $2018397478b2b37f$var$posed(proportions, clip, t, facing, style);
    const skin = style.skins[look.skin] ?? style.skins.light;
    return (0, $bc9c62e5e9c273fc$export$d705dada763d21f4)((0, $bc9c62e5e9c273fc$export$d15de0cfe42daab7)((0, $9311ef6950e6afe4$export$d1d6e3b3f3e4b367)(skeleton, proportions, look, facing, style.skins), facing), raster, [
        // A skull's sockets are its own (body.ts bonesOf): no muscle marks, no eyes.
        ...style.marks && !look.bones ? (0, $025663646c3dcfd6$export$a14966d9255adb0b)(skeleton, proportions, skin, facing, raster, style.marks) : [],
        ...look.bones ? [] : (0, $21b031d89cccca05$export$5d2150392ebecbf4)(skeleton, proportions, skin, facing, look.eyes ?? style.eyes, raster)
    ]);
};
const $2018397478b2b37f$export$55d48bf248f3dccb = 8;
const $2018397478b2b37f$export$75dafd8545280d2d = [
    "walk",
    "run"
];
const $2018397478b2b37f$export$c681385ad5773906 = {
    walk: 100,
    run: 140
};
const $2018397478b2b37f$export$eab1478000e144c0 = 10;
const $2018397478b2b37f$export$b1f958bcbb171ce0 = (attack, gait, phase, facing, speed)=>{
    const at = (Math.round(phase * $2018397478b2b37f$export$55d48bf248f3dccb) % $2018397478b2b37f$export$55d48bf248f3dccb + $2018397478b2b37f$export$55d48bf248f3dccb) % $2018397478b2b37f$export$55d48bf248f3dccb;
    const pace = speed === undefined ? "" : `.${Math.max($2018397478b2b37f$export$eab1478000e144c0, Math.round(speed / $2018397478b2b37f$export$eab1478000e144c0) * $2018397478b2b37f$export$eab1478000e144c0)}`;
    return `${attack}.${gait}.${at}${pace}-${facing}`;
};
const $2018397478b2b37f$export$a2d9fcededd058c3 = (animation)=>{
    const [name, direction] = animation.split("-");
    const facing = direction ?? "front";
    if (!(0, $bc9c62e5e9c273fc$export$3088316d51d20bbf).includes(facing)) return undefined;
    const [action, gait, phase, pace] = name.split(".");
    if (action === (0, $bdd18b1d4b50ea61$export$fc1a3fb716667d55)) {
        if ($2018397478b2b37f$export$75dafd8545280d2d.includes(gait)) {
            const stride = Number(phase);
            return pace === undefined && Number.isInteger(stride) && stride >= 0 ? {
                action: action,
                facing: facing,
                after: gait,
                stride: stride
            } : undefined;
        }
        return (0, $bdd18b1d4b50ea61$export$57583a5b8573e6df).includes(gait) && phase === undefined ? {
            action: action,
            facing: facing,
            after: gait
        } : undefined;
    }
    // One of the game's actions, or a performance (animations.ts): a clip the body plays when asked.
    if (!Object.prototype.hasOwnProperty.call((0, $a1fb04dc4139ce6e$export$413377055ae1c862), action) && !(0, $e232198e56580323$export$da56a348482c51f)(action)) return undefined;
    if (gait === undefined) return {
        action: action,
        facing: facing
    };
    if (gait === (0, $bdd18b1d4b50ea61$export$4174912917740653)) return (0, $bdd18b1d4b50ea61$export$57583a5b8573e6df).includes(action) && phase === undefined ? {
        action: action,
        facing: facing,
        fromRest: true
    } : undefined;
    const index = Number(phase);
    if (!(action in (0, $a1fb04dc4139ce6e$export$dd2163ed96be013a)) || !$2018397478b2b37f$export$75dafd8545280d2d.includes(gait)) return undefined;
    if (!Number.isInteger(index) || index < 0 || index >= $2018397478b2b37f$export$55d48bf248f3dccb) return undefined;
    if (pace === undefined) return {
        action: action,
        facing: facing,
        gait: gait,
        phase: index / $2018397478b2b37f$export$55d48bf248f3dccb
    };
    const speed = Number(pace);
    if (!Number.isInteger(speed) || speed <= 0 || speed > 1000) return undefined;
    return {
        action: action,
        facing: facing,
        gait: gait,
        phase: index / $2018397478b2b37f$export$55d48bf248f3dccb,
        speed: speed
    };
};
const $2018397478b2b37f$export$fa328aa933695b7f = (entity)=>{
    const equipment = {};
    const items = entity.inventory?.items ?? [];
    const weapon = entity.weapon?.weaponType;
    if (weapon && (0, $9311ef6950e6afe4$export$56c9f9905232d5d6).includes(weapon)) {
        equipment.held = weapon;
        // The colour is the equipped item's: the active one of this type in the inventory.
        const color = items.find((i)=>i.active && i.itemTypeMeta?.type === weapon)?.itemTypeMeta?.color;
        if (color) equipment.heldColor = color;
    }
    const pants = items.find((i)=>i.active && i.itemTypeMeta?.class === "pants")?.itemTypeMeta;
    if (pants?.type && (0, $9311ef6950e6afe4$export$f8a4cd30a1d616ae).includes(pants.type)) {
        equipment.pants = pants.type;
        if (pants.color) equipment.pantsColor = pants.color;
    }
    const armor = items.find((i)=>i.active && i.itemTypeMeta?.class === "armor")?.itemTypeMeta;
    if (armor?.type && (0, $9311ef6950e6afe4$export$3b6e816b98cc7cab).includes(armor.type)) {
        equipment.armor = armor.type;
        if (armor.color) equipment.armorColor = armor.color;
    }
    const bauldron = items.find((i)=>i.active && i.itemTypeMeta?.class === "bauldron")?.itemTypeMeta;
    if (bauldron?.type && (0, $9311ef6950e6afe4$export$b1e35fca6919daa0).includes(bauldron.type)) {
        equipment.bauldron = bauldron.type;
        if (bauldron.color) equipment.bauldronColor = bauldron.color;
    }
    if (entity.appearance?.bodyColor) equipment.bodyColor = entity.appearance.bodyColor;
    // Hair the entity has chosen; none chosen leaves the humanoid's own.
    const hair = entity.appearance?.hair;
    if (hair) {
        equipment.hair = hair;
        if (entity.appearance?.hairColor) equipment.hairColor = entity.appearance.hairColor;
    }
    const shirt = items.find((i)=>i.active && i.itemTypeMeta?.class === "shirt")?.itemTypeMeta;
    if (shirt?.type && (0, $9311ef6950e6afe4$export$fa6e205ceaf9ec1b).includes(shirt.type)) {
        equipment.shirt = shirt.type;
        if (shirt.color) equipment.shirtColor = shirt.color;
    }
    const shoes = items.find((i)=>i.active && i.itemTypeMeta?.class === "shoes")?.itemTypeMeta;
    if (shoes?.type && (0, $9311ef6950e6afe4$export$97868a69ac87308f).includes(shoes.type)) {
        equipment.shoes = shoes.type;
        if (shoes.color) equipment.shoesColor = shoes.color;
    }
    const shield = items.find((i)=>i.active && i.itemTypeMeta?.class === "shield")?.itemTypeMeta;
    if (shield?.type && (0, $9311ef6950e6afe4$export$ec83d7edc9c6e083).includes(shield.type)) {
        equipment.shield = shield.type;
        if (shield.color) equipment.shieldColor = shield.color;
    }
    return equipment;
};
const $2018397478b2b37f$export$c5d6732ac6392eaf = (e)=>[
        e.held,
        e.heldColor,
        e.pants,
        e.pantsColor,
        e.armor,
        e.armorColor,
        e.shield,
        e.shieldColor,
        e.shoes,
        e.shoesColor,
        e.hair,
        e.hairColor,
        e.shirt,
        e.shirtColor,
        e.bodyColor,
        e.bauldron,
        e.bauldronColor,
        e.carry ? "carry" : "",
        // What the models draw is content: a changed model is a different look.
        (0, $121d74fbc26f823b$export$7087b1beab1089cd)()
    ].map((v)=>v ?? "").join(":");
/** What content's body-colour tables (humanoids.json bodyColors) name for `key`, if anything. */ const $2018397478b2b37f$var$named = (table, key)=>table && key !== undefined && Object.prototype.hasOwnProperty.call(table, key) ? table[key] : undefined;
/** The humanoid's look with its equipment on (minus what the humanoid keeps as its own: humanoids.ts keepsOwn). */ const $2018397478b2b37f$var$equippedLook = (look, equipment, slingShield = false, keepsOwn)=>{
    const e = keepsOwn?.length ? $2018397478b2b37f$var$ownLook(equipment, keepsOwn) : equipment;
    return {
        ...look,
        ...e.held ? {
            held: e.held,
            heldColor: e.heldColor
        } : {},
        ...e.pants ? {
            pants: (0, $9311ef6950e6afe4$export$3ceac30571744c24)(e.pants, e.pantsColor ?? "brown")
        } : {},
        ...e.armor ? {
            armor: (0, $9311ef6950e6afe4$export$1ea20f6d45609a7c)(e.armor, e.armorColor ?? "")
        } : {},
        ...e.bauldron ? {
            bauldron: (0, $9311ef6950e6afe4$export$764237bc0d65d1bc)(e.bauldron, e.bauldronColor ?? "brown")
        } : {},
        ...e.shoes ? {
            shoes: (0, $9311ef6950e6afe4$export$52578e0af89c75fb)(e.shoes, e.shoesColor ?? "brown")
        } : {},
        ...e.shirt ? {
            shirt: (0, $9311ef6950e6afe4$export$77ffb62114f6237d)(e.shirt, e.shirtColor ?? "white")
        } : {},
        ...e.hair ? {
            hair: {
                style: e.hair,
                color: e.hairColor ?? look.hair?.color ?? "brown"
            }
        } : {},
        // Bone takes the body colour, and so does a living man's skin (a zombie's dead flesh is its own).
        ...e.bodyColor && look.bones ? {
            boneColor: e.bodyColor
        } : {},
        ...e.bodyColor && !look.bones && $2018397478b2b37f$var$named((0, $3256700f2c0109f9$export$f8c8da5e39b421f3).skins, look.skin) && $2018397478b2b37f$var$named((0, $3256700f2c0109f9$export$f8c8da5e39b421f3).skins, e.bodyColor) ? {
            skin: $2018397478b2b37f$var$named((0, $3256700f2c0109f9$export$f8c8da5e39b421f3).skins, e.bodyColor)
        } : {},
        // A beast's fur is the body colour, in the game's colours for it (an unknown one stays the look's).
        ...e.bodyColor && look.beast && $2018397478b2b37f$var$named((0, $3256700f2c0109f9$export$f8c8da5e39b421f3).furs[look.beast], e.bodyColor) ? {
            skin: $2018397478b2b37f$var$named((0, $3256700f2c0109f9$export$f8c8da5e39b421f3).furs[look.beast], e.bodyColor)
        } : {},
        ...e.shield ? {
            shield: {
                type: e.shield,
                color: e.shieldColor ?? "",
                slung: slingShield || $2018397478b2b37f$var$shieldSlung(e)
            }
        } : {}
    };
};
/** The entity's equipment without the appearance a humanoid keeps as its own (its hair, its skin). */ const $2018397478b2b37f$var$ownLook = (e, keepsOwn)=>{
    const { hair: hair, hairColor: hairColor, bodyColor: bodyColor, ...rest } = e;
    return {
        ...rest,
        ...keepsOwn.includes("hair") ? {} : {
            hair: hair,
            hairColor: hairColor
        },
        ...keepsOwn.includes("skin") ? {} : {
            bodyColor: bodyColor
        }
    };
};
/** A two-handed weapon (a bow, a polearm) needs the left hand: its shield goes on the back. */ const $2018397478b2b37f$var$shieldSlung = (e)=>!!e.held && (0, $9311ef6950e6afe4$export$a9b51f1bd1fab061).includes(e.held);
/** The weapon whose clips a held item plays (its design's handling), its own name by default. */ const $2018397478b2b37f$var$clipsOf = (held)=>(0, $121d74fbc26f823b$export$d2c6fd47dbbb12e9)("held", held)?.handling?.clips ?? held;
const $2018397478b2b37f$export$c7901edca87d667a = 96;
const $2018397478b2b37f$export$31906ad8d2ca3777 = (held)=>(0, $121d74fbc26f823b$export$d2c6fd47dbbb12e9)("held", held)?.handling?.frame ?? $2018397478b2b37f$export$c7901edca87d667a;
const $2018397478b2b37f$export$3548a14918532984 = 80;
const $2018397478b2b37f$var$withFrame = (style, size)=>{
    const grow = (size - style.raster.width) / 2;
    return {
        ...style,
        raster: {
            ...style.raster,
            width: size,
            height: size,
            centerX: style.raster.centerX + grow,
            groundY: style.raster.groundY + grow
        }
    };
};
const $2018397478b2b37f$export$fe9b78c54a1acaf0 = (spriteName, animation, equipment = {})=>{
    const humanoid = (0, $3256700f2c0109f9$export$cd7bfe75b42812b5)[spriteName];
    if (!humanoid && (0, $2e9467226384ee42$export$8eb75a72f9f497f)(spriteName)) return (0, $2e9467226384ee42$export$cd3ee123dcc9a464)(spriteName, animation, equipment);
    const parsed = $2018397478b2b37f$export$a2d9fcededd058c3(animation);
    if (!humanoid || !parsed) return undefined;
    const baseStyle = (0, $df52b6239fb99090$export$f93cc37bce51e09b)[humanoid.style ?? (0, $df52b6239fb99090$export$38a28ac32dc22856)];
    // Held things and shields reach past the 64px body frame: a bigger one, centred on the same point.
    // A bigger body's frame grows its held things' frames by as much: its reach is longer too.
    const growth = (humanoid.frame ?? 64) - 64;
    const frame = Math.max(equipment.held ? $2018397478b2b37f$export$31906ad8d2ca3777(equipment.held) + growth : 64, equipment.shield ? $2018397478b2b37f$export$3548a14918532984 + growth : 64, humanoid.frame ?? 64);
    const style = frame > 64 ? $2018397478b2b37f$var$withFrame(baseStyle, frame) : baseStyle;
    // A weapon with an attack of its own (a dagger's slash, a bow's shot) is keyed `<action>:<held>`
    // or `<clip>:<held>`.
    const clips = equipment.held && $2018397478b2b37f$var$clipsOf(equipment.held);
    const own = (name)=>clips && (style.clips?.[`${name}:${clips}`] ?? (0, $a1fb04dc4139ce6e$export$130932a2d00959a0)[`${name}:${clips}`]);
    const clipOf = (name)=>own(name) || style.clips?.[name] || (0, $a1fb04dc4139ce6e$export$130932a2d00959a0)[name];
    const proportions = $2018397478b2b37f$export$1b95202ede0d296c(humanoid.proportions);
    const strideOf = (c)=>c.strideFor ? c.strideFor(proportions) : c.strideCycle;
    // A shield in hand takes the left arm: carried at the hip, raised in an attack.
    const shielded = !!equipment.shield && !$2018397478b2b37f$var$shieldSlung(equipment) && !equipment.carry;
    const attack = (0, $a1fb04dc4139ce6e$export$dd2163ed96be013a)[parsed.action] !== undefined;
    // A zombie shambles over every clip but its fall, reaching out when its hands are empty and
    // it is not striking with them.
    const shambles = humanoid.posture === "shamble";
    // A cast's hands are the spell's: neither a shield nor a zombie's reach takes them.
    const casting = parsed.action === "cast";
    // A climber's hands are the ladder's: a shield goes on the back.
    const climbing = parsed.action === "climb";
    // A falling body's hands are flung up empty, the weapon put away as on the ladder it is often
    // knocked off -- swung up overhead, a long one swept across the frame and out of it.
    const handsFree = climbing || parsed.action === "falling";
    // A body with a load in its arms holds it at rest and on the move; it strikes, casts or climbs
    // as ever (the load is not drawn then).
    // A stride settling to rest has the load in its arms throughout, as both ends of it do.
    const settlesStride = parsed.action === (0, $bdd18b1d4b50ea61$export$fc1a3fb716667d55) && $2018397478b2b37f$export$75dafd8545280d2d.includes(parsed.after ?? "");
    const loaded = !!equipment.carry && !parsed.gait && ((0, $a1fb04dc4139ce6e$export$78ecae501ab7f21c).includes((0, $a1fb04dc4139ce6e$export$413377055ae1c862)[parsed.action] ?? "") || settlesStride);
    const bearing = (c, raised)=>{
        if (c.name === "hurt" || handsFree) return c;
        const borne = shielded && !casting ? (0, $a1fb04dc4139ce6e$export$cd8e116089089e72)(c, raised) : c;
        return shambles ? (0, $a1fb04dc4139ce6e$export$a42c91d6bfd37b7c)(borne, !raised && !casting && !equipment.held && !shielded) : borne;
    };
    // Standing still, a weapon rests as its design holds it and the empty hands hang open (clips.ts
    // atRest): a hand with a weapon (the bow's is the left), a shield or a load in it stays closed.
    // A falling body's hands are empty and fly open, so it sets out from exactly its idle.
    const heldDesign = equipment.held ? (0, $121d74fbc26f823b$export$d2c6fd47dbbb12e9)("held", equipment.held) : undefined;
    const holding = new Set(loaded ? (0, $16b5b2e1f0b8662b$export$7bcc7ebb13416507) : []);
    if (heldDesign) holding.add($2018397478b2b37f$var$clipsOf(heldDesign.id) === "bow" ? "L" : "R");
    if (shielded) holding.add("L");
    const still = (c)=>c.name === "idle" ? (0, $a1fb04dc4139ce6e$export$76d5823997123dfb)(c, heldDesign?.handling?.rest, (0, $16b5b2e1f0b8662b$export$7bcc7ebb13416507).filter((s)=>!holding.has(s))) : c.name === "falling" ? (0, $a1fb04dc4139ce6e$export$76d5823997123dfb)(c, undefined, (0, $16b5b2e1f0b8662b$export$7bcc7ebb13416507)) : c;
    // A polearm is carried upright, wherever the arm swings it (clips.ts poleCarry).
    const carried = (c)=>equipment.held && (0, $9311ef6950e6afe4$export$cfaa8f2ed0c9ba36).includes(equipment.held) && [
            "idle",
            "walk",
            "run"
        ].includes(c.name) ? (0, $a1fb04dc4139ce6e$export$bb1c792c61cf6dee)(still(c)) : still(c);
    // A performance is the whole body's: no shield borne, no shamble, no load carried over it.
    const performance = (0, $e232198e56580323$export$da56a348482c51f)(parsed.action) ? (0, $e232198e56580323$export$7d5fe1d8fc443191)[parsed.action] : undefined;
    // A plain action's clip as this body plays it: borne, carried and loaded as it holds things.
    const clipFor = (action)=>{
        const c = bearing(carried(own(action) || clipOf((0, $a1fb04dc4139ce6e$export$413377055ae1c862)[action])), (0, $a1fb04dc4139ce6e$export$dd2163ed96be013a)[action] !== undefined);
        return loaded && (0, $a1fb04dc4139ce6e$export$78ecae501ab7f21c).includes((0, $a1fb04dc4139ce6e$export$413377055ae1c862)[action] ?? "") ? (0, $a1fb04dc4139ce6e$export$ebfd3f7c9b179305)(c) : c;
    };
    let clip;
    if (parsed.action === (0, $bdd18b1d4b50ea61$export$fc1a3fb716667d55)) {
        // Coming to rest (settle.ts): from a frame of a stride, or from a blow struck standing.
        const after = parsed.after;
        const rest = clipFor("idle");
        let settle;
        if (settlesStride) {
            const gait = clipFor(after);
            if (parsed.stride >= gait.frames) return undefined;
            const cyclesPerSecond = (0, $bdd18b1d4b50ea61$export$e2c6ffcb8d428e2)[after] / (strideOf(gait) * (0, $bc9c62e5e9c273fc$export$32e028fba1489aa1)[parsed.facing]);
            settle = (0, $bdd18b1d4b50ea61$export$7445b8c8e5bfeada)(gait, parsed.stride / gait.frames, cyclesPerSecond, rest, (0, $bdd18b1d4b50ea61$export$6dcca76cb5cf1068)[after], proportions, parsed.facing);
        } else settle = (0, $bdd18b1d4b50ea61$export$c86439634b9d2068)((0, $bdd18b1d4b50ea61$export$c6f480c259bac807)(clipFor(after), rest, false), rest, proportions, parsed.facing);
        if (!settle) return undefined;
        clip = settle;
    } else {
        clip = performance ?? bearing(carried(own(parsed.action) || clipOf((0, $a1fb04dc4139ce6e$export$413377055ae1c862)[parsed.action])), attack);
        if (loaded && !performance) clip = (0, $a1fb04dc4139ce6e$export$ebfd3f7c9b179305)(clip);
        // A blow struck standing still steps into its stance with the lead foot only, so one step
        // brings the body back out of it; struck from standing, it eases out of the standing pose.
        if (!parsed.gait && !performance && (0, $bdd18b1d4b50ea61$export$57583a5b8573e6df).includes(parsed.action)) clip = (0, $bdd18b1d4b50ea61$export$c6f480c259bac807)(clip, clipFor("idle"), !!parsed.fromRest);
    }
    let gaitPhaseAfter;
    if (parsed.gait) {
        // The legs advance as far through their stride as the attack's duration carries the body.
        const gait = bearing(carried(clipOf(parsed.gait)), false);
        const seconds = (0, $a1fb04dc4139ce6e$export$dd2163ed96be013a)[parsed.action] / 1000;
        const speed = parsed.speed ?? $2018397478b2b37f$export$c681385ad5773906[parsed.gait];
        const cycles = seconds * speed / (strideOf(gait) * (0, $bc9c62e5e9c273fc$export$32e028fba1489aa1)[parsed.facing]);
        clip = (0, $a1fb04dc4139ce6e$export$6f98ea285f26c534)(clip, gait, parsed.phase, cycles);
        gaitPhaseAfter = (parsed.phase + cycles) % 1;
    }
    const stride = parsed.gait ? undefined : strideOf(clip);
    // An attack keeps the duration of the LPC animation it replaces, whatever its frame count.
    const lpcDuration = (0, $a1fb04dc4139ce6e$export$dd2163ed96be013a)[parsed.action];
    return {
        name: animation,
        clip: clip.name,
        facing: parsed.facing,
        frameMs: lpcDuration ? lpcDuration / clip.frames : clip.frameMs,
        loop: clip.loop,
        // What the body travels across the screen per cycle with its planted feet keeping still.
        strideCycle: stride && stride * (0, $bc9c62e5e9c273fc$export$32e028fba1489aa1)[parsed.facing],
        frameCount: clip.frames,
        gaitPhaseAfter: gaitPhaseAfter,
        carrying: loaded || undefined,
        renderFrame: (i)=>$2018397478b2b37f$export$e9ad4ea9b773aa4f(// Full hands put the weapon away while they hold the load, or the ladder; so do empty ones in a fall.
            $2018397478b2b37f$var$equippedLook(humanoid.look, loaded || handsFree ? {
                ...equipment,
                held: undefined
            } : equipment, handsFree || !!equipment.carry, humanoid.keepsOwn), proportions, clip, (0, $a1fb04dc4139ce6e$export$8ec32ae08bf1bc32)(clip, i, clip.frames), parsed.facing, style),
        jointsAt: (i)=>$2018397478b2b37f$export$37e1edfd62a35be2(proportions, clip, (0, $a1fb04dc4139ce6e$export$8ec32ae08bf1bc32)(clip, i, clip.frames), parsed.facing, style)
    };
};
const $2018397478b2b37f$export$5f8b50f36a1dd2b4 = (spriteName, animation, equipment = {})=>{
    const plan = $2018397478b2b37f$export$fe9b78c54a1acaf0(spriteName, animation, equipment);
    if (!plan) return undefined;
    const { frameCount: frameCount, renderFrame: renderFrame, ...meta } = plan;
    return {
        ...meta,
        frames: Array.from({
            length: frameCount
        }, (_, i)=>renderFrame(i))
    };
};


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $P8XPi = parcelRequire("P8XPi");
var $6qzqq = parcelRequire("6qzqq");

const $151224aeaaf7ea66$var$INTERVAL = 20;
const $151224aeaaf7ea66$export$f4e49cf0e9b111a5 = (frame)=>(0, $klOfb.Texture).fromBuffer(new Uint8Array(frame.pixels.buffer, frame.pixels.byteOffset, frame.pixels.byteLength), frame.width, frame.height, {
        scaleMode: (0, $P8XPi.SCALE_MODES).NEAREST
    });
const $151224aeaaf7ea66$export$2a5b5330021702c = ({ width: width, height: height, pixels: pixels })=>{
    let left = width;
    let top = height;
    let right = -1;
    let bottom = -1;
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
        if (!pixels[(y * width + x) * 4 + 3]) continue;
        if (x < left) left = x;
        if (x > right) right = x;
        if (y < top) top = y;
        bottom = y;
    }
    return right < 0 ? {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    } : {
        x: left,
        y: top,
        width: right - left + 1,
        height: bottom - top + 1
    };
};
class $151224aeaaf7ea66$export$94035e151e5d7f15 {
    constructor(){
        this.baked = new Map();
        this.bakes = new Map();
        this.queue = [];
        this.budgetMs = 4;
        this.now = ()=>typeof performance !== "undefined" ? performance.now() : Date.now();
        // What the body holds and wears, and in what colours, is part of every frame, so of the key.
        this.keyOf = (spriteName, animation, equipment)=>`${spriteName}/${animation}/${(0, $2018397478b2b37f$export$c5d6732ac6392eaf)(equipment)}`;
        /** An animation already baked, now, or nothing (a screen rebuilt every keystroke can't wait a tick). */ this.peek = (spriteName, animation, equipment = {})=>this.baked.get(this.keyOf(spriteName, animation, equipment));
        this.request = (spriteName, animation, priority, callback, cancelled, equipment = {})=>{
            const key = this.keyOf(spriteName, animation, equipment);
            const done = this.baked.get(key);
            if (done) {
                // Still asynchronous: the sprite's adopt path expects to run outside activateAnimation.
                setTimeout(()=>!cancelled?.() && callback(done), 0);
                return;
            }
            const inFlight = this.bakes.get(key);
            if (inFlight) {
                inFlight.waiters.push({
                    callback: callback,
                    cancelled: cancelled
                });
                if (priority) this.promote(inFlight);
                return;
            }
            const plan = (0, $2018397478b2b37f$export$fe9b78c54a1acaf0)(spriteName, animation, equipment);
            if (!plan) {
                setTimeout(()=>!cancelled?.() && callback(null), 0);
                return;
            }
            const bake = {
                key: key,
                plan: plan,
                textures: [],
                drawn: [],
                waiters: [
                    {
                        callback: callback,
                        cancelled: cancelled
                    }
                ]
            };
            this.bakes.set(key, bake);
            if (priority) this.queue.unshift(bake);
            else this.queue.push(bake);
            if (!this.timer) this.timer = setInterval(this.process, $151224aeaaf7ea66$var$INTERVAL);
        };
        this.promote = (bake)=>{
            const at = this.queue.indexOf(bake);
            if (at > 0) {
                this.queue.splice(at, 1);
                this.queue.unshift(bake);
            }
        };
        this.process = ()=>{
            const start = this.now();
            while(this.queue.length){
                const bake = this.queue[0];
                // Nobody is waiting any more: leave it unbaked rather than spend the budget on it.
                if (bake.waiters.every((w)=>w.cancelled?.())) {
                    this.queue.shift();
                    this.bakes.delete(bake.key);
                    continue;
                }
                const frame = bake.plan.renderFrame(bake.textures.length);
                const texture = $151224aeaaf7ea66$export$f4e49cf0e9b111a5(frame);
                const drawn = $151224aeaaf7ea66$export$2a5b5330021702c(frame);
                // Measured here, from the pixels in hand, so nothing asks the GPU for them (texture_content_bounds).
                (0, $35a6592763403c18$export$742f20ba795461b9)(texture, drawn.width ? new (0, $6qzqq.Rectangle)(drawn.x, drawn.y, drawn.width, drawn.height) : null);
                bake.textures.push(texture);
                bake.drawn.push(drawn);
                if (bake.textures.length >= bake.plan.frameCount) {
                    this.queue.shift();
                    this.finish(bake);
                }
                if (this.now() - start >= this.budgetMs) return;
            }
            clearInterval(this.timer);
            this.timer = undefined;
        };
        this.finish = (bake)=>{
            const { frameMs: frameMs, loop: loop, strideCycle: strideCycle, gaitPhaseAfter: gaitPhaseAfter, carrying: carrying } = bake.plan;
            const joints = bake.textures.map((_, i)=>bake.plan.jointsAt(i));
            const baked = {
                textures: bake.textures,
                frameMs: frameMs,
                loop: loop,
                strideCycle: strideCycle,
                gaitPhaseAfter: gaitPhaseAfter,
                joints: joints,
                carrying: carrying,
                drawn: bake.drawn
            };
            this.baked.set(bake.key, baked);
            this.bakes.delete(bake.key);
            bake.waiters.forEach((w)=>!w.cancelled?.() && w.callback(baked));
        };
        /** Drain everything now (tests, and previews that want every frame at once). */ this.flush = ()=>{
            const budget = this.budgetMs;
            this.budgetMs = Infinity;
            this.process();
            this.budgetMs = budget;
        };
        this.clear = ()=>{
            this.baked.forEach((b)=>b.textures.forEach((t)=>t.destroy(true)));
            this.baked.clear();
            this.bakes.clear();
            this.queue = [];
            clearInterval(this.timer);
            this.timer = undefined;
        };
    }
}
const $151224aeaaf7ea66$export$39dc63e37dec0a0e = new $151224aeaaf7ea66$export$94035e151e5d7f15();









const $b063d2b45b823b26$export$765bd2598c6496f = 16;
const $b063d2b45b823b26$export$8e4b2935dacfb14d = 78;
const $b063d2b45b823b26$export$c73eb0616912120 = 66;
/** The LPC body frame every Ember frame centres its body in. */ const $b063d2b45b823b26$var$BODY_FRAME = 64;
const $b063d2b45b823b26$export$32cf8bf7604af9d0 = 300;
/** PIXI plays `animationSpeed` frames per 60Hz tick. */ const $b063d2b45b823b26$var$TICKS_PER_SECOND = 60;
const $b063d2b45b823b26$export$b055cf72b163b5b9 = (speed, strideCycle, frames)=>speed / strideCycle * (frames / $b063d2b45b823b26$var$TICKS_PER_SECOND);
class $b063d2b45b823b26$export$565c341f83d1c6bb extends (0, $d782e74b2eaa8700$export$db88fc637337eefb) {
    constructor(spriteName, meta, equipment = {}){
        // No sheets to load, and no LPC held-object art baked in: it is placed against LPC hands. A
        // held weapon is generated into the frames instead (game-common/ember_sprite, EMBER_HELD); a
        // carried item is the item's own art, held between the Ember body's hands (updateLoad).
        super({
            ...meta,
            descriptors: [],
            heldObject: undefined
        }), this.running = false, this.baked = new Map(), this.standingPostAnimation = this.postAnimation, /** Comes to rest through settles rather than cutting to idle: a player's humanoid body. */ this.settles = false, /**
     * The carried item, kept between the hands of the frame on show (its baked joints) -- so it rises
     * and falls with the arms on the move -- in front of the body, or behind it facing away (where
     * LPC puts its held objects too), tinted as the body is. Shown only while the arms are holding
     * it: an attack, a cast or a climb puts it out of sight.
     */ this.updateLoad = ()=>{
            if (!this.loadSpriteId || !this.initialized || !this.container) return;
            const job = this.animations[this.action];
            const animation = job?.animation;
            const holding = !!this.baked.get(this.action)?.carrying && !!animation?.visible;
            if (!this.load) {
                if (!holding) return;
                const texture = (0, $196acb402f85fad6$export$d51c6eb8facb1100)(this.loadSpriteId);
                if (!texture) return;
                this.load = new (0, $7Bs2Z.Sprite)(texture);
                // Resting on the forearms: centred over the hands, most of it above them.
                this.load.anchor.set(0.5, 0.75);
                this.load.scale.set($b063d2b45b823b26$export$765bd2598c6496f / Math.max(texture.orig.width, texture.orig.height));
            }
            const load = this.load;
            const hands = holding ? this.jointLocal((j)=>({
                    x: (j.hands[0].x + j.hands[1].x) / 2,
                    y: (j.hands[0].y + j.hands[1].y) / 2
                })) : undefined;
            load.visible = !!hands;
            if (!hands || !animation) return;
            load.position.set(hands.x, hands.y);
            load.tint = animation.tint;
            const behind = (0, $bc9c62e5e9c273fc$export$e32225fb3fb28f1e)((0, $2018397478b2b37f$export$a2d9fcededd058c3)(this.action)?.facing ?? this.facingDir);
            const container = this.container;
            const at = load.parent === container ? container.getChildIndex(load) : -1;
            const body = container.getChildIndex(animation);
            if (at < 0 || (behind ? at !== body - 1 : at !== body + 1)) {
                if (at >= 0) container.removeChild(load);
                const index = container.getChildIndex(animation);
                container.addChildAt(load, behind ? index : index + 1);
            }
        }, /** A settle that could not be drawn (no plan for it): stand, rather than wait on it. */ this.settleFailed = (action)=>{
            if ((0, $2018397478b2b37f$export$a2d9fcededd058c3)(action)?.action !== (0, $bdd18b1d4b50ea61$export$fc1a3fb716667d55)) return;
            const pending = this.pendingSettle?.name === action;
            if (pending) this.pendingSettle = undefined;
            if (pending || this.awaits(action)) this.activateAnimation(`idle-${this.facingDir}`);
        }, /** A blow struck standing, with this body: eased into from standing and settled out of. */ this.settlesAttack = (action)=>this.settles && (0, $bdd18b1d4b50ea61$export$57583a5b8573e6df).includes(action) && !this.equipment.carry, /** The blow this settle follows has played out and is waiting on it. */ this.awaits = (settle)=>{
            const parsed = (0, $2018397478b2b37f$export$a2d9fcededd058c3)(settle);
            const current = (0, $2018397478b2b37f$export$a2d9fcededd058c3)(this.action);
            if (!parsed?.after || !current || current.gait || current.action !== parsed.after || current.facing !== parsed.facing) return false;
            return !this.animations[this.action]?.animation?.playing;
        }, /** Where the current frame puts a joint, in this sprite's own space (its frames are offset when bigger). */ this.jointLocal = (pick)=>{
            const baked = this.baked.get(this.action);
            const animation = this.animations[this.action]?.animation;
            const joints = baked?.joints[animation?.currentFrame ?? 0];
            if (!baked || !joints || !this.initialized) return undefined;
            const point = pick(joints);
            // An Ember body is placed at the origin (lpc_composite), so only a bigger frame's growth moves it.
            const grow = (baked.textures[0].width - $b063d2b45b823b26$var$BODY_FRAME) / 2;
            return {
                x: point.x - grow,
                y: point.y - grow
            };
        }, /**
     * The skull a halo or a skeleton's effects hang from: the Ember body's own head, frame by frame,
     * where the LPC sprite reads a track measured off LPC's skeleton sheet.
     */ this.headAttachmentWorld = (race)=>{
            if (race !== "skeleton") return undefined;
            const head = this.jointLocal((j)=>j.head);
            return head && this.toGlobal(head);
        }, /** A skeleton's grip for what its attack holds or casts: between its raised hands in a cast, else its right fist. */ this.heldAttackGripWorld = (race)=>{
            if (race !== "skeleton") return undefined;
            const casting = this.action.startsWith("cast-");
            const grip = this.jointLocal((j)=>casting ? {
                    x: (j.hands[0].x + j.hands[1].x) / 2,
                    y: (j.hands[0].y + j.hands[1].y) / 2
                } : j.hands[1]);
            if (!grip) return undefined;
            const hands = casting ? [
                0,
                1
            ].map((i)=>this.toGlobal(this.jointLocal((j)=>j.hands[i]))) : undefined;
            const world = this.toGlobal(grip);
            return {
                x: world.x,
                y: world.y,
                scale: Math.hypot(this.worldTransform.a, this.worldTransform.b),
                hands: hands
            };
        }, this.resumeStride = ()=>{
            const pending = this.pendingSettle;
            this.pendingSettle = undefined;
            if (pending && this.action === pending.stride) this.animations[this.action]?.animation?.play();
        }, /** Standing (or as good as): a blow from here is struck from standing. */ this.standing = ()=>{
            if (this.action.startsWith("idle-") || this.pendingSettle?.stride === this.action) return true;
            const parsed = (0, $2018397478b2b37f$export$a2d9fcededd058c3)(this.action);
            if (parsed?.action !== (0, $bdd18b1d4b50ea61$export$fc1a3fb716667d55)) return false;
            // Barely out of a blow, the stance is still there to strike again from.
            const settle = this.animations[this.action]?.animation;
            return !(0, $bdd18b1d4b50ea61$export$57583a5b8573e6df).includes(parsed.after) || !settle || settle.currentFrame * 2 >= settle.totalFrames;
        }, /**
     * After a strike on the move, straight back into the stride; after a blow struck standing, its
     * settle (for a body that settles); after a settle, idle. Anything else goes on as LPC's does.
     */ this.postAnimation = (animation)=>{
            const parsed = (0, $2018397478b2b37f$export$a2d9fcededd058c3)(animation);
            if (parsed?.gait) return `${parsed.gait}-${parsed.facing}`;
            if (parsed?.action === (0, $bdd18b1d4b50ea61$export$fc1a3fb716667d55)) return `idle-${parsed.facing}`;
            if (parsed && this.settlesAttack(parsed.action)) return `${0, $bdd18b1d4b50ea61$export$fc1a3fb716667d55}.${parsed.action}-${parsed.facing}`;
            return this.standingPostAnimation(animation);
        };
        this.spriteName = spriteName;
        this.equipment = equipment;
        this.loadSpriteId = equipment.carry ? meta.heldObject?.spriteId : undefined;
        if (this.loadSpriteId) (0, $3YyWq.Ticker).shared.add(this.updateLoad);
    }
    remove() {
        (0, $3YyWq.Ticker).shared.remove(this.updateLoad);
        super.remove();
    }
    destroy() {
        (0, $3YyWq.Ticker).shared.remove(this.updateLoad);
        super.destroy();
    }
    requestAnimation(action, callback) {
        (0, $151224aeaaf7ea66$export$39dc63e37dec0a0e).request(this.spriteName, action, this.priority, (baked)=>{
            if (!baked) {
                callback(null);
                this.settleFailed(action);
                return;
            }
            this.baked.set(action, baked);
            const animation = new (0, $d3fD1.AnimatedSprite)(baked.textures);
            animation.visible = false;
            animation.animationSpeed = 1000 / (baked.frameMs * $b063d2b45b823b26$var$TICKS_PER_SECOND);
            // A held tool's frames are bigger than the 64px body frame and centre the same
            // body: shifted back by the margin, as LPC's oversize sheets are, the body stays put.
            const result = new (0, $39fb998eb7d66fde$export$7229ffc582571c48)({
                animation: animation
            });
            result.offsetX = -(baked.textures[0].width - $b063d2b45b823b26$var$BODY_FRAME) / 2;
            result.offsetY = -(baked.textures[0].height - $b063d2b45b823b26$var$BODY_FRAME) / 2;
            animation.position.set(result.offsetX, result.offsetY);
            callback(result);
        }, ()=>this.spriteReleased, this.equipment);
        // A blow struck standing settles afterwards: have the settle baked by the time the blow ends.
        const parsed = (0, $2018397478b2b37f$export$a2d9fcededd058c3)(action);
        if (parsed && !parsed.gait && this.settlesAttack(parsed.action)) (0, $151224aeaaf7ea66$export$39dc63e37dec0a0e).request(this.spriteName, `${(0, $bdd18b1d4b50ea61$export$fc1a3fb716667d55)}.${parsed.action}-${parsed.facing}`, false, ()=>{}, ()=>this.spriteReleased, this.equipment);
    }
    /** Bow grip in body space; late remote shots use the release pose rather than an idle hand. */ arrowGripLocal(angle) {
        if (this.equipment.held !== "bow") return undefined;
        const facing = this.calcDir(angle);
        if ((0, $2018397478b2b37f$export$a2d9fcededd058c3)(this.action)?.action === "shoot" && this.facingDir === facing) {
            const grip = this.jointLocal((j)=>j.hands[0]);
            if (grip) return grip;
        }
        const plan = (0, $2018397478b2b37f$export$fe9b78c54a1acaf0)(this.spriteName, `shoot-${facing}`, this.equipment);
        if (!plan) return undefined;
        const grip = plan.jointsAt(Math.floor(plan.frameCount / 2)).hands[0];
        // The plan centres the 64px body in its larger weapon frame, just like the baked art.
        const bodyGrowth = ((0, $3256700f2c0109f9$export$cd7bfe75b42812b5)[this.spriteName].frame ?? $b063d2b45b823b26$var$BODY_FRAME) - $b063d2b45b823b26$var$BODY_FRAME;
        const grow = ((0, $2018397478b2b37f$export$31906ad8d2ca3777)("bow") + bodyGrowth - $b063d2b45b823b26$var$BODY_FRAME) / 2;
        return {
            x: grip.x - grow,
            y: grip.y - grow
        };
    }
    calcDir(angle) {
        return (0, $bc9c62e5e9c273fc$export$63b89cef1abbc46e)(angle);
    }
    doMovement(entity) {
        this.runKey = entity.entityType === "player" ? entity.boosted === true : undefined;
        this.settles = entity.entityType === "player" && !!(0, $3256700f2c0109f9$export$cd7bfe75b42812b5)[this.spriteName];
        // Moving again before the settle it was waiting on has baked: pick the stride back up.
        const at = entity.location;
        if (this.pendingSettle && at && this.lastX !== undefined && (at.x !== this.lastX || at.y !== this.lastY)) this.resumeStride();
        super.doMovement(entity);
    }
    /**
     * Stopped: settle from the stride's frame (the next even one -- settles are drawn from every
     * other frame). Until that settle has baked the stride holds its frame, and gives up and stands
     * after SETTLE_WAIT_MS. A settle under way is left to finish: it hands over to idle itself.
     */ restAnimation() {
        const idle = super.restAnimation();
        const current = (0, $2018397478b2b37f$export$a2d9fcededd058c3)(this.action);
        if (current?.action === (0, $bdd18b1d4b50ea61$export$fc1a3fb716667d55)) return this.action;
        if (!this.settles || !current || current.gait || !(0, $2018397478b2b37f$export$75dafd8545280d2d).includes(current.action)) return idle;
        const pending = this.pendingSettle;
        if (pending?.stride === this.action) {
            if (Date.now() - pending.since <= $b063d2b45b823b26$export$32cf8bf7604af9d0) return pending.name;
            this.pendingSettle = undefined;
            return idle;
        }
        const stride = this.animations[this.action]?.animation;
        if (!stride) return idle;
        const frame = 2 * Math.ceil(stride.currentFrame / 2) % stride.totalFrames;
        const name = `${(0, $bdd18b1d4b50ea61$export$fc1a3fb716667d55)}.${current.action}.${frame}-${current.facing}`;
        if (this.animations[name]) return name;
        stride.stop();
        this.pendingSettle = {
            name: name,
            stride: this.action,
            since: Date.now()
        };
        return name;
    }
    /** Turning while coming to rest: stand facing the new way (the settle is drawn facing the old one). */ turnedAnimation(facing) {
        if ((0, $2018397478b2b37f$export$a2d9fcededd058c3)(this.action)?.action === (0, $bdd18b1d4b50ea61$export$fc1a3fb716667d55)) return `idle-${facing}`;
        return super.turnedAnimation(facing);
    }
    /**
     * A settle starts when it lands only if it is still wanted: the stride it was asked for is still
     * holding its frame, or the blow it follows has played out. Moved, turned or struck again in the
     * meantime, it is kept for next time instead.
     */ adoptsOnLoad(action) {
        if ((0, $2018397478b2b37f$export$a2d9fcededd058c3)(action)?.action !== (0, $bdd18b1d4b50ea61$export$fc1a3fb716667d55)) return true;
        const pending = this.pendingSettle;
        if (pending?.name === action && this.action === pending.stride) {
            this.pendingSettle = undefined;
            return true;
        }
        return this.awaits(action);
    }
    /** A generated humanoid lies down as LPC does, and falls with its arms flung up (clips.ts `falling`). */ drawsHeldPose(pose) {
        return pose === "downed" || !!(0, $3256700f2c0109f9$export$cd7bfe75b42812b5)[this.spriteName];
    }
    /**
     * Drive the full climb cycle by distance along the ladder. Holding a rung
     * freezes the pose; descending or reversing retraces the same frames.
     */ climbPose(entity) {
        const rise = (0, $5af76956b9282cac$export$aa044ab2f0c2781d)(entity);
        if (rise === undefined) return undefined;
        const frames = (0, $a1fb04dc4139ce6e$export$130932a2d00959a0).climb.frames;
        const cycle = (rise / (0, $a1fb04dc4139ce6e$export$6858458e4384d51e) % 1 + 1) % 1;
        return {
            action: "climb-back",
            progress: cycle,
            frame: Math.floor(cycle * frames) % frames
        };
    }
    locomotionAnimation() {
        const speed = this.walkPace.speed;
        if (this.runKey !== undefined) this.running = this.runKey;
        else if (this.running && speed > 0 && speed < $b063d2b45b823b26$export$c73eb0616912120) this.running = false;
        else if (!this.running && speed > $b063d2b45b823b26$export$8e4b2935dacfb14d) this.running = true;
        return `${this.running ? "run" : "walk"}-${this.facingDir}`;
    }
    attackAnimation() {
        const [gait] = this.action.split("-");
        const stride = this.animations[this.action]?.animation;
        this.resumeGait = undefined;
        if (this.settlesAttack(this.attackAction) && this.standing()) {
            this.pendingSettle = undefined;
            return `${this.attackAction}.${0, $bdd18b1d4b50ea61$export$4174912917740653}-${this.facingDir}`;
        }
        if (!stride || !(0, $2018397478b2b37f$export$75dafd8545280d2d).includes(gait) || !(this.attackAction in (0, $a1fb04dc4139ce6e$export$dd2163ed96be013a))) return super.attackAnimation();
        // Walking or running: strike over the legs from the point of the stride they are at, the
        // legs keeping the pace the body is actually crossing the ground at.
        const phase = stride.currentFrame / stride.totalFrames;
        const speed = this.walkPace.speed > 0 ? this.walkPace.speed : undefined;
        const strike = (0, $2018397478b2b37f$export$b1f958bcbb171ce0)(this.attackAction, gait, phase, this.facingDir, speed);
        this.resumeGait = {
            action: `${gait}-${this.facingDir}`,
            after: strike
        };
        return strike;
    }
    animationStartFrame(action, animation) {
        // Picking the stride back up after a strike on the move: on from where the strike left the legs.
        const resume = this.resumeGait;
        if (resume && animation && action === resume.action) {
            const after = this.baked.get(resume.after)?.gaitPhaseAfter;
            this.resumeGait = undefined;
            if (after !== undefined) return Math.round(after * animation.totalFrames) % animation.totalFrames;
        }
        return super.animationStartFrame(action, animation);
    }
    applyPace(action, animation) {
        super.applyPace(action, animation);
        const baked = this.baked.get(action);
        const speed = this.walkPace.speed;
        if (!animation || !baked?.strideCycle || speed <= 0) return;
        animation.animationSpeed = $b063d2b45b823b26$export$b055cf72b163b5b9(speed, baked.strideCycle, baked.textures.length);
    }
}






const $64e038f1765e0ab3$export$55369d1d7ed23ec = 16;
class $64e038f1765e0ab3$export$f3390963b1a1dc25 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(entityId, loadObserver, isClientPlayer, isRemotePlayer){
        super(), this.groundAnchor = {
            x: 32,
            y: 60
        }, this.bodyRace = "", this.spriteScale = 1, // False until this body has been through one doMovement. It separates "we watched them fall",
        // which plays the collapse, from "they were already down when we first drew them", which snaps
        // straight to the prone frame -- a body that replayed its fall every time it came back into
        // view would look like it kept falling over.
        this.poseSeen = false, this.getClickSurface = ()=>{
            return this.clickArea;
        }, this.rebuildLayers = (entity)=>{
            const dimensions = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.dimensions(entity);
            const race = entity.appearance?.race;
            this.bodyRace = race;
            const sex = entity.appearance?.sex;
            const hair = entity.appearance?.hair;
            const nose = entity.appearance?.nose;
            const eyes = entity.appearance?.eyes;
            const weaponAction = (0, $71594ae8b880a354$export$fed43fae8d163f04)(race, entity?.weapon?.weaponType);
            const descriptors = (0, $71594ae8b880a354$export$efde97289773c11d)({
                body: {
                    race: race,
                    sex: sex,
                    color: entity.appearance?.bodyColor
                },
                hair: hair ? {
                    component: hair,
                    color: entity.appearance?.hairColor
                } : undefined,
                nose: nose ? {
                    component: nose,
                    color: entity.appearance?.noseColor
                } : undefined,
                eyes: eyes ? {
                    component: eyes,
                    color: entity.appearance?.eyesColor
                } : undefined,
                ///////
                weapon: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$4c2157e8933c20e3)(entity.inventory, entity?.weapon?.weaponType)?.itemTypeMeta),
                pants: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "pants")),
                shirt: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "shirt")),
                armor: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "armor")),
                shoes: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "shoes")),
                shield: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "shield")),
                cape: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "cape")),
                bauldron: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "bauldron"))
            });
            const all = [];
            descriptors.body?.forEach((next)=>all.push(next));
            const isHumanoid = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isHumanoid(race);
            const undead = entity.faction === "undead" || [
                "skeleton",
                "zombie"
            ].includes((0, $bcc08db80bb560e5$export$1efc94ac0295d345)(race));
            const bodyShadow = (0, $71594ae8b880a354$export$cb53670f886c3e49)(race);
            if (isHumanoid) {
                descriptors.hair?.forEach((next)=>all.push(next));
                descriptors.nose?.forEach((next)=>all.push(next));
                descriptors.eyes?.forEach((next)=>all.push(next));
                descriptors.weapon?.forEach((next)=>all.push(next));
                descriptors.pants?.forEach((next)=>all.push(next));
                descriptors.shirt?.forEach((next)=>all.push(next));
                descriptors.armor?.forEach((next)=>all.push(next));
                descriptors.shoes?.forEach((next)=>all.push(next));
                descriptors.shield?.forEach((next)=>all.push(next));
                descriptors.cape?.forEach((next)=>all.push(next));
                descriptors.bauldron?.forEach((next)=>all.push(next));
            }
            const sortedDescriptors = all.sort((a, b)=>a.zIndex - b.zIndex);
            const heldObject = isHumanoid ? (0, $f684496fff50a7a1$export$2ed57f5a5ffde406)(entity) : undefined;
            const id = race + " " + entity?.safeName();
            const priority = (0, $1e46c45e333c583b$export$e1d138f8777c998e).value === entity.entityId;
            const oldSprite = this.sprite;
            let loadObserver;
            if (this.loadObserver) {
                loadObserver = this.loadObserver;
                oldSprite?.remove();
            } else if (oldSprite) loadObserver = new (0, $d782e74b2eaa8700$export$7e6fc99bfa4004f1)(()=>{
                new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(oldSprite, {
                    releaseCallback: ()=>{
                        oldSprite?.remove();
                    },
                    fadeAlphaDecrement: 0.05
                }).update();
            });
            loadObserver?.clear();
            const meta = {
                attackAction: weaponAction,
                angle: entity.movement.angle,
                descriptors: sortedDescriptors,
                hasHalo: this.halo,
                hasShadow: isHumanoid || bodyShadow !== undefined,
                feetY: bodyShadow?.feetY,
                bodyFrame: (0, $71594ae8b880a354$export$b2ae80db0884a5f7)[race] || {
                    w: 64,
                    h: 64
                },
                placement: (0, $71594ae8b880a354$export$7e0cb3ff08e322d2)(race),
                groundAnchor: (0, $71594ae8b880a354$export$a4bccc16e13fc57c)(race),
                // The ring says "a person is driving this". An INVADER is a person driving one of the
                // camp's own attackers, and the whole point of the body is that the defender cannot tell
                // -- so it is withheld. If the marked variant of the design wins instead, this is where a
                // hostile-coloured ring goes, and "the ring ignites on breaking out" is the concealment
                // variant's reveal (see docs/ember-the-fallen-design.md).
                hasPlayerRing: this.remotePlayer && !entity.invading,
                breathingSeed: isHumanoid && !undead ? entity.entityId : undefined,
                id: id,
                priority: priority,
                loadObserver: loadObserver,
                isSubmerged: this.submerged,
                heldObject: heldObject ? {
                    spriteId: heldObject,
                    sex: sex || "male"
                } : undefined,
                defaultAction: (0, $71594ae8b880a354$export$68fee8ec0f096607)(entity.appearance),
                // Carried across the rebuild: a fallen body whose inventory changes (looted, or handed
                // something) must not stand up, play the fall again and lie back down.
                heldPose: this.heldPose
            };
            // A humanoid Ember has a body for (or one it names) is drawn from generated frames; the
            // LPC paperdoll above is unused.
            const emberSprite = (0, $3256700f2c0109f9$export$ee2b787377c030da)(entity.appearance);
            const ember = !!emberSprite;
            this.sprite = ember ? new (0, $b063d2b45b823b26$export$565c341f83d1c6bb)(emberSprite, {
                ...meta,
                hasShadow: true,
                feetY: undefined,
                bodyFrame: {
                    w: 64,
                    h: 64
                },
                placement: {
                    x: 0,
                    y: 0
                },
                groundAnchor: undefined
            }, {
                ...(0, $2018397478b2b37f$export$fa328aa933695b7f)(entity),
                // An item readied in the hands (LPC's held object) is carried in both arms.
                ...heldObject ? {
                    carry: true
                } : {}
            }) // equipping or unequipping rebuilds the sprite with it
             : new (0, $d782e74b2eaa8700$export$db88fc637337eefb)(meta);
            // An Ember body stands taller than LPC's: its role glyph rests higher to clear the head.
            this.hud.setGlyphLift(ember ? $64e038f1765e0ab3$export$55369d1d7ed23ec : 0);
            this.sprite.initalize(id, entity.movement.angle);
            // The sprite above is brand new, so anything the composite is holding on this member's
            // behalf has to be put back onto it.
            this.applyStatusHalo();
            this.haloObject = this.sprite.halo;
            const raceDimensions = !ember && (0, $71594ae8b880a354$export$b2ae80db0884a5f7)[entity?.appearance?.race] || {
                w: 64,
                h: 64
            };
            this.groundAnchor = ember ? (0, $9667a1379a787b5e$export$20726201b68e0cab)(64, 64) : (0, $9667a1379a787b5e$export$20726201b68e0cab)(raceDimensions.w, raceDimensions.h, {
                groundAnchor: (0, $71594ae8b880a354$export$a4bccc16e13fc57c)(race),
                shadow: bodyShadow
            });
            this.updateScale(entity.spriteScale ?? this.spriteScale);
            this.addChild(this.sprite);
            if (this.clickArea.parent) this.clickArea.parent.removeChild(this.parentArea);
            this.clickArea.clear();
            this.clickArea.beginFill(0xff0000, 0.0001);
            this.clickArea.drawRect(0, 0, dimensions.w, dimensions.h);
            this.clickArea.x = -dimensions.w / 2;
            this.clickArea.y = -dimensions.h / 2 + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.15;
            this.clickArea.endFill();
            this.addChild(this.clickArea);
            if (this.haloObject) this.updateHaloColor(entity.hp, entity.maxHp);
        }, this.fragment = (entity)=>{
            this.sprite?.fragment(entity);
            this.drawableSurface.fragment(entity);
        }, this.onMouseOver = (show)=>{
            this.hud.onMouseOver(show);
        }, // Pose-accurate hover outline. The glow belongs to the sprite, which is the only thing that knows
        // which baked frame is on screen this instant and which carries the oversize offsets the outline
        // has to inherit -- and it is replaced wholesale on a paperdoll rebuild, so the highlight has to
        // live and die with it. A composite with no sprite yet (or none at all) reports false, and the
        // caller outlines whatever map tiles stand in for it.
        this.occlusionBody = ()=>{
            const frame = this.sprite?.highlightFrame();
            return frame ? {
                container: this.sprite,
                frame: frame
            } : undefined;
        }, this.setHighlighted = (on)=>{
            if (!this.sprite) return false;
            this.sprite.setHighlighted(on);
            return true;
        }, this.setWorldOverlayItem = (item)=>{
            this.worldOverlayItem = item;
            item.headAttachmentWorld = ()=>this.sprite?.headAttachmentWorld(this.bodyRace);
            item.heldAttackGripWorld = ()=>this.sprite?.heldAttackGripWorld(this.bodyRace);
            this.worldOverlayItem.addChild(this.hud);
        };
        this.entityId = entityId;
        this.remotePlayer = isRemotePlayer === true;
        this.clickArea = new (0, $a64b70167386625f$export$98e91636974d835d)();
        this.loadObserver = loadObserver;
        this.hud = new (0, $1d5c2742ca857d0e$export$5ef96c383b67a5e2)(0xffffff, {
            renderActions: {},
            alwaysShowLabel: false
        }, this.clickArea, isClientPlayer);
        this.drawableSurface = new (0, $a64b70167386625f$export$98e91636974d835d)();
        this.animatedFeedback = new (0, $5f817afe83d87a88$export$9ec831f4c1f089b1)();
        // The ColorMatrixFilter is only needed for the brief damage flash. A filtered display
        // object is rendered into its own framebuffer and cannot batch with its neighbours, so
        // leaving it attached costs an offscreen render pass per character every frame. Attach it
        // only while flashing (see doDamaged) and detach it afterwards.
        this.colorMatrix = new (0, $1avo5.filters).ColorMatrixFilter();
    }
    doMovement(entity) {
        if (entity?.weaponCharge && !this.weaponChargeIndicator) {
            this.weaponChargeIndicator = new (0, $d9c682be559f7d89$export$7610bd9a23b10f42)();
            // Its ground half goes UNDER the body, at index 0, so the character stands inside the
            // charge ring instead of wearing it. Rebuilding the sprite re-appends the sprite and
            // click area to the end of the child list, so index 0 keeps meaning "below everything".
            this.addChildAt(this.weaponChargeIndicator.ground, 0);
            this.addChild(this.weaponChargeIndicator);
        }
        this.weaponChargeIndicator?.draw(entity?.weaponCharge);
        this.updateHeldPose(entity);
        this.sprite?.doMovement(entity);
        if (this.sprite) {
            // The LIMP: a tilt that sways while an escorted survivor is actually walking. The other
            // half of the injury presentation, the resting pose, used to be a 0.72 vertical squash
            // of the standing sprite here; it is a real prone pose now (see updateHeldPose), so
            // there is nothing left to deform. Suppressed while the body is on the ground, where a
            // tilt would only rock a face-down sprite.
            //
            // entity.flags is wiped on every message the client receives (see
            // Client.updateEntityFromMessage), so this reads the wire field, not a flag.
            const limping = !this.heldPose && entity?.rescuePose === "following" && entity.movement.moving;
            this.sprite.rotation = limping ? -0.06 + 0.04 * Math.sin((0, $4171652afd996934$export$a86190deb5c4a8d0)() / 180) : 0;
        }
        this.drawableSurface.doMovement(entity);
    }
    /**
     * Lay this body down, or stand it back up; or, while it is in the air, fling its arms up.
     *
     * TWO ROADS TO THE SAME POSE, and the renderer deliberately cannot tell them apart. A fallen
     * PLAYER is `downed`, the server's verdict on a deadline it owns. An injured ember SURVIVOR is
     * `rescuePose`, a phase of the rescue that ends when somebody finishes holding to help her up.
     * Both mean "this body is on the ground", which is the only question this method asks -- so the
     * get-up animation, the guards that stop a prone body walking or turning, and the snap-vs-fall
     * decision are all written once and serve both.
     *
     * HUMANOIDS ONLY. The pose is the LPC `hurt` row's final frame, and that row exists only on the
     * humanoid sheets -- a rabbit or a slime has no frames for it at all, so asking would bake
     * nothing, fail, and leave the creature in whatever action it was already in while this class
     * believed it was posed. Rather than rely on that failing quietly, non-humanoids are never
     * asked, and go on behaving exactly as they did before this existed.
     *
     * IN THE AIR -- dropped through a floor, stepped off a roof, knocked off a ladder: the floor fall
     * the renderer is drawing (isAirborne) holds the body in `falling`, arms up, until it lands. Then
     * it lies down if the landing put it on the ground (a long drop, a knock-off: `landed` with a
     * recovery), and otherwise gets straight back up, the hands coming down. Only a body with frames
     * for it falls so (an Ember humanoid); an LPC one goes on as before.
     */ updateHeldPose(entity) {
        if (!entity) return;
        const onTheGround = !!entity.downed || entity.rescuePose === "downed" || entity.floorFall?.phase === "landed";
        const humanoid = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isHumanoid(entity.appearance?.race);
        const pose = !humanoid ? undefined : onTheGround ? "downed" : (0, $7f7f5b693e82869c$export$34b6d9b448395805)(entity) ? "falling" : undefined;
        if (pose !== this.heldPose) {
            this.heldPose = pose;
            // Play the fall only if we were watching before it happened; see poseSeen.
            this.sprite?.setHeldPose(pose, this.poseSeen);
        }
        this.poseSeen = true;
    }
    update(hp, hpMax) {
        this.hud.update(hp, hpMax);
        this.updateHaloColor(hp, hpMax);
    }
    updateName(name) {
        this.hud.updateName(name);
    }
    recolor(color) {
        this.hud.recolor(color);
    }
    updateHaloColor(hp, hpMax) {
        if (!this.haloObject) return;
        const hpPct = hp / hpMax;
        if (hpPct < 0.7) {
            if (hpPct < 0.4) this.haloObject.tint = 0xff0000;
            else this.haloObject.tint = 0xffa500;
        } else this.haloObject.tint = 0x00ff00;
    }
    updateBlinking(blinking) {
        if (!blinking) {
            this.visible = true;
            if (this.blinkingInterval) {
                clearInterval(this.blinkingInterval);
                this.blinkingInterval = null;
            }
        } else {
            if (this.blinkingInterval) return;
            this.blinkingInterval = setInterval(()=>{
                this.visible = !this.visible;
            }, 100);
        }
    }
    addTag() {
        this.hud.addTag();
    }
    removeTag() {
        this.hud.removeTag();
    }
    updateLevel(level) {
        this.hud.updateLevel(level);
    }
    doAttack(entity, callback) {
        this.sprite?.doAttack(entity, callback);
    }
    doDamaged(entity) {
        this.sprite?.doDamaged(entity);
        // Attach the filter only for the duration of the flash, then detach it so the character
        // batches normally again (see constructor).
        this.filters = [
            this.colorMatrix
        ];
        this.colorMatrix.blackAndWhite(true);
        this.colorMatrix.contrast(1, true);
        this.colorMatrix.saturate(1, true);
        // Guard against overlapping hits resetting the flash early.
        if (this.damageFlashTimeout !== undefined) clearTimeout(this.damageFlashTimeout);
        this.damageFlashTimeout = setTimeout(()=>{
            this.colorMatrix.reset();
            this.filters = null;
            this.damageFlashTimeout = undefined;
        }, 100);
    }
    // Called on entity removal (EntityRenderingManager.destroy). Cascades teardown into the inner
    // sprite -- which clears its cleanup timers and releases its generator clones -- and clears
    // this wrapper's own timers. Without this, entity removal (the common discard path, distinct
    // from a paperdoll rebuild) leaked both.
    cleanup() {
        if (this.rebuildTimeout !== undefined) {
            clearTimeout(this.rebuildTimeout);
            this.rebuildTimeout = undefined;
        }
        if (this.damageFlashTimeout !== undefined) {
            clearTimeout(this.damageFlashTimeout);
            this.damageFlashTimeout = undefined;
        }
        if (this.blinkingInterval) {
            clearInterval(this.blinkingInterval);
            this.blinkingInterval = null;
        }
        this.sprite?.cleanup();
        this.hud?.cleanup();
    }
    spoke(message, options) {
        this.hud.spoke(message, options);
    }
    releaseHeldSpeech() {
        this.hud.releaseHeldSpeech();
    }
    getDrawableSurface() {
        return this.drawableSurface.getDrawableSurface();
    }
    /**
     * Is this body drawable yet? No while its spritesheets are being fetched and baked, and no while
     * a build is merely scheduled -- both are states in which this container is on the stage with
     * nothing in it. Read by the room-reveal hold (see RoomReveal) to decide whether a freshly
     * loaded room is worth opening the screen on.
     *
     * A composite that has never been handed an appearance answers YES: there is no sprite coming,
     * so there is nothing to wait for. Entities beyond the server's detail range arrive exactly like
     * that -- a brief message with no appearance on it -- and a room full of distant wildlife must
     * not hold the curtain shut on a camp that is otherwise complete.
     */ isReadyToShow() {
        if (!this.sprite && this.rebuildTimeout === undefined) return true;
        return this.rebuildTimeout === undefined && !!this.sprite?.initialized;
    }
    updatePaperdoll(entity) {
        if (!entity) return;
        const { appearance: appearance } = entity;
        if (!appearance) return;
        if (this.rebuildTimeout !== undefined) clearTimeout(this.rebuildTimeout);
        // console.trace()
        // The FIRST build is barely debounced, every later one is. The wait exists to coalesce
        // churn -- an appearance change arrives as several messages (the body, then the inventory
        // that dresses it) and each rebuild throws away a composited sprite and bakes another, so
        // 250ms of patience is cheap when there is already a body on screen to look at meanwhile.
        //
        // Before the first build there is nothing on screen: the wait is pure latency, and it is
        // spent BEFORE the spritesheets are even asked for. Measured on a character-creation drop
        // into a camp, that debounce was 250ms of the ~510ms between the room landing and its lord
        // being drawable -- half the pop-in the room-reveal hold now has to wait out (see
        // RoomReveal). Keep a short window so an inventory arriving a tick behind the appearance
        // still builds once rather than twice.
        const delay = this.sprite ? 250 : 60;
        this.rebuildTimeout = setTimeout(()=>{
            this.rebuildLayers(entity);
            this.rebuildTimeout = undefined;
        }, delay);
    }
    // Possession happens to a sprite that already exists -- the player is standing there and then
    // they are wearing a skeleton -- so the ring has to be answerable after construction too, not
    // only when the layers are rebuilt from scratch.
    updatePlayerRing(entity) {
        this.sprite?.setPlayerRingVisible(!!this.remotePlayer && !entity?.invading);
    }
    updateHalo(entity, enabled) {
        this.halo = enabled;
        this.updatePaperdoll(entity);
        if (this.haloObject) this.updateHaloColor(entity.hp, entity.maxHp);
    }
    updateSpeed(factor) {
    //
    }
    detachWorldOverlayItem() {
        // The outgoing floor owns its overlay; keep the HUD alive for the new owner.
        this.addChild(this.hud);
        this.getClickSurface().removeAllListeners();
        this.getClickSurface().interactionsBound = false;
        this.setHighlighted(false);
        this.onMouseOver(false);
    }
    updatePointerIcon(show, angle) {
        this.hud.updatePointerIcon(show, angle);
    }
    itemPickedUp(entity, itemTypeMeta, quantity) {
        this.feedback(entity, itemTypeMeta.spriteId || `${itemTypeMeta.type}-${itemTypeMeta.color}.png`, quantity > 0 ? `+${quantity}` : "", {
            font: "EntityImportantFont",
            color: 0x00ff00
        });
    }
    // Floating feedback over this body: a pickup icon, a damage number, the "!!!" alert. A running
    // body's dust trail does NOT come through here -- it is ground art that has to z-sort against
    // other entities, which nothing parented into the overlay can do. EntityRenderingManager.feedback
    // routes `type: "foot"` to FootDust before it ever reaches a renderable.
    feedback(entity, image, label, params) {
        this.animatedFeedback.setup(0, this.worldOverlayItem.height / 2, image, label, this.worldOverlayItem, params, this.sprite);
    }
    updateSigil(sigil) {
        this.hud.updateSigil(sigil);
    }
    updateRole(role) {
        this.hud.updateRole(role);
    }
    // The in-world ground disc. Kept on the composite as well as pushed to the sprite because the
    // sprite is REPLACED on every paperdoll rebuild, and the rebuild is the common case for exactly
    // the members this marks: going hungry swaps the member's brain, which re-stamps its appearance.
    // A disc that lived only on the sprite would therefore go out at the moment the member started
    // walking off its post, which is the moment the player needs it. Reapplied in rebuildLayers,
    // alongside heldPose, which is carried across for the same reason.
    updateStatusHalo(tier) {
        this.statusHaloTier = tier;
        this.applyStatusHalo();
    }
    applyStatusHalo() {
        this.sprite?.setStatusHaloTier(this.statusHaloTier);
    }
    // A fixed lift from the canonical ground reference. Reading this.height would let
    // changing animation bounds or oversize weapons raise and lower the entire body.
    getYOffset() {
        // Obstacles are authored against the human sole line, 21.6px below location.y.
        // Native frame size must not change that ground reference (or a chicken stands
        // above the roots while its ground position already sorts in front of the tree).
        return 0, $9667a1379a787b5e$export$3ceafdb2446078a8;
    }
    /** Offset from the shooter's ground location to the bow, in room pixels. */ arrowLaunchOffset(angle) {
        if (!(this.sprite instanceof (0, $b063d2b45b823b26$export$565c341f83d1c6bb))) return undefined;
        const grip = this.sprite.arrowGripLocal(angle);
        if (!grip) return undefined;
        return {
            x: this.sprite.x + grip.x * this.spriteScale,
            y: this.getYOffset() + this.sprite.y + grip.y * this.spriteScale
        };
    }
    reflectionArt() {
        return this.sprite?.initialized ? this.sprite.reflectionArt() : undefined;
    }
    grassContact() {
        if (!this.sprite?.initialized || this.submerged || !this.parent) return undefined;
        // The ground stays fixed while the body leans or breathes above it.
        const point = this.parent.toLocal(this.toGlobal({
            x: 0,
            y: (0, $9667a1379a787b5e$export$5985b04c8e71b763) - (0, $9667a1379a787b5e$export$3ceafdb2446078a8)
        }));
        const angle = {
            front: Math.PI / 2,
            back: -Math.PI / 2,
            left: Math.PI,
            right: 0,
            frontleft: 3 * Math.PI / 4,
            frontright: Math.PI / 4,
            backleft: -3 * Math.PI / 4,
            backright: -Math.PI / 4
        }[this.sprite.facingDir];
        return {
            x: point.x,
            y: point.y,
            scale: this.spriteScale,
            angle: angle
        };
    }
    updateScale(scale = 1) {
        if (!Number.isFinite(scale) || scale <= 0) return;
        this.spriteScale = scale;
        if (!this.sprite) return;
        this.sprite.scale.set(scale);
        this.sprite.position.set(-this.groundAnchor.x * scale, (0, $9667a1379a787b5e$export$5985b04c8e71b763) - (0, $9667a1379a787b5e$export$3ceafdb2446078a8) - this.groundAnchor.y * scale);
    }
    updateSubmerged(submerged) {
        this.submerged = submerged;
    }
    updateAfk(afk) {
        if (this.sprite) this.sprite.alpha = afk ? 0.3 : 1.0;
    }
    updateActivation(entity, active) {
        if (!this.sprite) return;
        this.sprite.activateAnimation(active ? "activate" : "deactivate");
    }
}



class $e97a9ef66e2e5f53$export$8653a30c44b6e879 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(color = 0xff0000, size = 10, alpha = 1.0){
        super();
        super.beginFill(color, alpha);
        super.lineStyle(size, color, alpha);
        super.drawCircle(1, 1, 2);
        super.endFill();
    }
}



class $0ecb2be6c709254f$export$2d9ac7aa84f97a08 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(color = 0xff00ff, rotating){
        super();
        super.lineStyle(1, color);
        super.beginFill(color);
        super.drawRect(-10, 0, 25, 5);
        super.lineStyle(1, color);
        super.beginFill(color);
        super.drawRect(0, -10, 5, 25);
        super.endFill();
        let angle = 0;
        if (rotating) setInterval(()=>{
            if (angle > 360) angle = 0;
            this.angle = angle;
            angle++;
        }, 50);
    }
}


parcelRequire("1avo5");
var $hnGDn = parcelRequire("hnGDn");

class $a326659fb0a13e91$export$b0c249583f27a2b9 extends (0, $15caf4b106aaadb3$export$5a33d6de29791ec5) {
    constructor(spriteMeta){
        super(spriteMeta);
        this.labelText = new (0, $hnGDn.BitmapText)("", {
            fontName: "SignFont",
            align: "center"
        });
        this.labelText.visible = false;
        this.labelText.x = -this.container.width * 0.23;
        this.labelText.y = -this.container.height * 0.3;
        this.addChild(this.labelText);
    }
    updateName(name) {
        if (name) {
            this.labelText.text = name.replace(/ /g, "\n");
            this.labelText.visible = true;
        } else this.labelText.visible = false;
    }
}




parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $gwPoJ = parcelRequire("gwPoJ");
var $P8XPi = parcelRequire("P8XPi");

/**
 * The dust a running body kicks up (ENTITY_FEEDBACK `type: "foot"` -- a player holding the boost
 * key, or an NPC rushing a target).
 *
 * WHY THIS IS ITS OWN EFFECT. The trail used to be built by the generic AnimatedFeedback, which
 * parents everything it makes into the WORLD OVERLAY surface -- the layer that carries nameplates
 * and chat bubbles, added to the stage after the world and therefore drawn on top of every entity
 * in the room. That is right for a nameplate and wrong for dust: a runner heading SOUTH leaves its
 * trail to the north of itself, where the puffs have to be drawn BEHIND the body, and they were
 * drawn in front of it instead (and over every other character they passed). Nothing about the old
 * placement could be tuned into the right answer, because the overlay has no relationship to the
 * entity z-order at all. So the trail lives here, in the world surface, where each puff is an
 * ordinary z-sorted sibling of the bodies it has to interleave with.
 *
 * WHAT MAKES IT READ AS KICKED-UP DUST rather than as a sprite playing over the runner. Three
 * things, none of which the old version did:
 *
 *   FOOTFALLS, NOT A COLUMN. Puffs come off alternating feet, offset PERPENDICULAR to the direction
 *   of travel. One emission point dead-centre on the body draws a single column of stamps; two
 *   interleaved tracks read as something a pair of shoes did.
 *
 *   KICKED BACKWARDS, NOT RISING. Each puff is thrown along the ground opposite the run and
 *   decelerates into stillness (exponential drag), so it falls behind the runner and settles where
 *   it landed. Separately -- and this is the part that needs the 3/4 view taken seriously -- it has
 *   a HEIGHT that is tracked apart from its ground position: `lift` moves the drawn sprite up the
 *   screen while `groundY` stays put, so a rising puff does not slide backwards out of its own
 *   footprint, and it still sorts against bodies by the patch of ground it came off.
 *
 *   DIFFUSING, NOT STAMPED. It fades in over the first tenth of its life, grows to about 1.7x, and
 *   fades out on a curve. Size, lifetime, tint, spin and kick are all jittered per puff, so a run
 *   never shows the same puff twice.
 *
 * The art is baked here rather than shipped (the pattern wind_leaves and butterflies established):
 * white lumps generated once, tinted per puff off an earth palette, which is what lets one texture
 * serve the whole trail and batch into a single draw call. The shipped `dust` spritesheet it
 * replaces was an 8-frame burst of 1px GREY specks that popped symmetrically outward -- a pop, not
 * a kick, and grey flecks on grass at that.
 *
 * NOTHING HERE USES A TIMER. One update() off the render loop advances every puff of every trail
 * and decides when the next footfall lands. That matters twice over: a dozen rushing NPCs would
 * otherwise each hold a setTimeout chain plus one setInterval per live puff, and in a backgrounded
 * tab (rAF throttled to zero) the timers would keep emitting into a world nobody is drawing.
 */ // How far BELOW `entity.location.y` an LPC humanoid's soles are drawn: location.y lands around the
// hips, not on the floor. A puff is kicked up by a shoe, so it is laid down at the feet -- but
// sorted on the hip line, which is the line every entity in the surface sorts by. Positioning at the
// feet and sorting at the hip is the whole trick; sorting at the feet instead would draw the dust in
// front of its own runner from the waist down.
const $f63df80eccdeeea6$var$FOOT_DROP = 20;
// Dust comes off the back of the heel, so a puff sorts just behind whatever is standing on the same
// patch of ground. It only decides anything in the instant a puff is born, when it and the runner
// share a sort line; after that each one sorts on its own ground position.
const $f63df80eccdeeea6$var$BEHIND_THE_HEELS = 1;
// One footfall per this many ms, alternating feet. Roughly a stride at run speed.
const $f63df80eccdeeea6$var$FOOTFALL_MS = 105;
// A trail normally ends on the matching `action: "remove"` (BOOST_ACTION_OFF, or a rushing NPC
// arriving). Nothing guarantees that event lands -- it is a distance-filtered broadcast, and the
// runner can be culled or leave the room mid-stride -- so a trail also expires by itself.
const $f63df80eccdeeea6$var$TRAIL_MAX_MS = 1500;
// Emission is driven off the render loop, so a backgrounded tab (or a long frame) can hand us a gap
// of seconds. Past this many footfalls' worth we skip the backlog rather than burst-emitting it.
const $f63df80eccdeeea6$var$MAX_FOOTFALL_CATCHUP = 4;
// A frame longer than this is a stall, not motion; clamp it so nothing teleports on the way back.
const $f63df80eccdeeea6$var$MAX_FRAME_SECONDS = 0.05;
// Where a footfall lands relative to the body: half the gap between the two feet, across the
// direction of travel, and a little behind the body's centre where the pushing foot actually is.
const $f63df80eccdeeea6$var$FOOT_SPREAD = 4.5;
const $f63df80eccdeeea6$var$HEEL_SETBACK = 3;
// The kick, in world px/sec along the ground, opposite the run. GROUND_DRAG is an e-fold per second:
// at 5.5 a puff has spent most of its travel inside 200ms, so the trail's spacing comes from the
// runner moving on rather than from the dust flying.
const $f63df80eccdeeea6$var$KICK = 34;
const $f63df80eccdeeea6$var$KICK_MIN = 0.65;
const $f63df80eccdeeea6$var$KICK_MAX = 1.35;
const $f63df80eccdeeea6$var$GROUND_DRAG = 5.5;
// How far off straight-backwards a puff may be thrown, in radians either way.
const $f63df80eccdeeea6$var$KICK_SPREAD = 0.5;
// Height off the ground, which is tracked and drawn separately from the ground position (see above).
const $f63df80eccdeeea6$var$LIFT = 15;
const $f63df80eccdeeea6$var$LIFT_DRAG = 3.4;
// Per-puff jitter ranges.
const $f63df80eccdeeea6$var$SCALE_MIN = 0.42;
const $f63df80eccdeeea6$var$SCALE_MAX = 0.62;
const $f63df80eccdeeea6$var$GROWTH_MIN = 1.5;
const $f63df80eccdeeea6$var$GROWTH_MAX = 2.0;
const $f63df80eccdeeea6$var$ALPHA_MIN = 0.5;
const $f63df80eccdeeea6$var$ALPHA_MAX = 0.78;
const $f63df80eccdeeea6$var$SPIN = 0.6;
const $f63df80eccdeeea6$var$LIFE_MS = 520;
const $f63df80eccdeeea6$var$LIFE_JITTER = 0.3;
// Fraction of its life a puff holds full opacity for before it starts fading.
const $f63df80eccdeeea6$var$FADE_AFTER = 0.42;
// Fraction of its life it fades IN over, so it diffuses into being instead of popping.
const $f63df80eccdeeea6$var$FADE_IN = 0.1;
// Extra, smaller motes thrown with each footfall. One is enough to break the silhouette up; the
// difference between a single lump and a lump with a mote beside it is most of the irregularity.
const $f63df80eccdeeea6$var$SATELLITES = 1;
const $f63df80eccdeeea6$var$SATELLITE_SCALE = 0.55;
// Dry earth catching the light. Varied per puff rather than per trail, for grain.
const $f63df80eccdeeea6$var$TINTS = [
    0xd8caa8,
    0xc4b494,
    0xb3a384,
    0xe3d8bd
];
// Total live puffs across every trail. A wave of rushing NPCs is the case this exists for: they all
// kick dust at once, and the trail is ambience -- dropping the newest puff is invisible, a frame
// spent on four hundred sprites is not.
const $f63df80eccdeeea6$var$MAX_PUFFS = 220;
const $f63df80eccdeeea6$var$between = (min, max)=>min + Math.random() * (max - min);
class $f63df80eccdeeea6$export$ab8cf330af9aa032 {
    constructor(surface, makeTextures){
        this.textures = [];
        this.trails = new Map();
        this.puffs = [];
        // Begin (or restart) the trail under `entity`. `params.duration` sets the base puff lifetime;
        // the art is baked here, so the event's `image` is not looked up.
        this.start = (entity, params = {}, nowMs = performance.now(), surface = this.surface)=>{
            // A second start while one is already running -- an NPC that re-rushes without arriving --
            // replaces the emitter rather than stacking a second one onto the same entity.
            this.stop(entity.entityId);
            this.trails.set(entity.entityId, {
                surface: surface,
                entity: entity,
                roomId: entity.roomId,
                startedMs: nowMs,
                nextFootfallMs: nowMs,
                side: Math.random() < 0.5 ? 1 : -1,
                lifeMs: params?.duration || $f63df80eccdeeea6$var$LIFE_MS
            });
        };
        // Stop emitting under `entity`. Puffs already on the ground are left to settle and fade -- dust
        // does not vanish the moment a runner stops running.
        this.stop = (entityId)=>{
            this.trails.delete(entityId);
        };
        // Stop emitting AND take the trail off the surface now. For an entity being destroyed, or one
        // that changed rooms: its dust belongs to a patch of ground that is no longer on screen.
        this.remove = (entityId)=>{
            const trail = this.trails.get(entityId);
            this.stop(entityId);
            if (!trail) return;
            const emitter = trail.entity.entityId;
            this.puffs = this.puffs.filter((puff)=>{
                if (puff.emitterId !== emitter) return true;
                this.retire(puff);
                return false;
            });
        };
        // Exposed for tests: puffs currently on the surface.
        this.activeCount = ()=>this.puffs.length;
        /**
     * Lay down any footfalls that have come due and advance every live puff. Called once per drawn
     * frame (EntityRenderingManager.endFrame), which is also what pauses the whole effect in a
     * backgrounded tab rather than letting it emit into a world nobody is drawing.
     */ this.update = (nowMs = performance.now())=>{
            if (this.lastMs === undefined) {
                this.lastMs = nowMs;
                return;
            }
            const dt = Math.min((nowMs - this.lastMs) / 1000, $f63df80eccdeeea6$var$MAX_FRAME_SECONDS);
            this.lastMs = nowMs;
            this.emit(nowMs);
            this.advance(nowMs, dt);
        };
        this.emit = (nowMs)=>{
            this.trails.forEach((trail, entityId)=>{
                const entity = trail.entity;
                if (trail.surface.destroyed || entity.roomId !== trail.roomId) {
                    this.remove(entityId);
                    return;
                }
                if (nowMs - trail.startedMs > $f63df80eccdeeea6$var$TRAIL_MAX_MS) {
                    this.stop(entityId);
                    return;
                }
                // A stalled frame (or a tab coming back) can leave several footfalls due at once. Lay
                // down one and skip the backlog -- emitting it would dump a clump of dust on one spot.
                if (nowMs - trail.nextFootfallMs > $f63df80eccdeeea6$var$FOOTFALL_MS * $f63df80eccdeeea6$var$MAX_FOOTFALL_CATCHUP) trail.nextFootfallMs = nowMs;
                while(nowMs >= trail.nextFootfallMs){
                    this.footfall(trail, nowMs);
                    trail.nextFootfallMs += $f63df80eccdeeea6$var$FOOTFALL_MS;
                }
            });
        };
        // One foot hitting the ground: a lump of dust under the shoe, plus a smaller mote beside it.
        this.footfall = (trail, nowMs)=>{
            const entity = trail.entity;
            // The direction of travel. `movement.angle` points the way the body is going (+y is south),
            // and is maintained for remote entities too -- the interpolator stamps it off the position
            // buffer -- so a trail behind another player is thrown the right way as well.
            const angle = entity.movement?.angle ?? 0;
            const travelX = Math.cos(angle);
            const travelY = Math.sin(angle);
            // Across the run, for the gap between the two feet.
            const acrossX = -travelY;
            const acrossY = travelX;
            const side = trail.side;
            trail.side = -side;
            const footX = entity.location.x + acrossX * $f63df80eccdeeea6$var$FOOT_SPREAD * side - travelX * $f63df80eccdeeea6$var$HEEL_SETBACK;
            const footGroundY = entity.location.y + $f63df80eccdeeea6$var$FOOT_DROP + acrossY * $f63df80eccdeeea6$var$FOOT_SPREAD * side - travelY * $f63df80eccdeeea6$var$HEEL_SETBACK;
            // The emitter's own sort line, minus its ground position: carrying the race class rather
            // than the position is what lets each puff sort on the ground it actually settles on.
            const zBase = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.calculateZIndexBoost(entity) - entity.location.y - $f63df80eccdeeea6$var$FOOT_DROP;
            this.spawn(trail, nowMs, footX, footGroundY, travelX, travelY, zBase, 1);
            for(let i = 0; i < $f63df80eccdeeea6$var$SATELLITES; i++)this.spawn(trail, nowMs, footX, footGroundY, travelX, travelY, zBase, $f63df80eccdeeea6$var$SATELLITE_SCALE);
        };
        this.spawn = (trail, nowMs, x, groundY, travelX, travelY, zBase, sizeFactor)=>{
            if (this.puffs.length >= $f63df80eccdeeea6$var$MAX_PUFFS) return;
            const texture = this.texture();
            if (!texture) return;
            // Thrown backwards along the ground, fanned off straight-back so a trail is not a ruler line.
            const spread = $f63df80eccdeeea6$var$between(-$f63df80eccdeeea6$var$KICK_SPREAD, $f63df80eccdeeea6$var$KICK_SPREAD);
            const speed = $f63df80eccdeeea6$var$KICK * $f63df80eccdeeea6$var$between($f63df80eccdeeea6$var$KICK_MIN, $f63df80eccdeeea6$var$KICK_MAX);
            const kickX = -(travelX * Math.cos(spread) - travelY * Math.sin(spread)) * speed;
            const kickY = -(travelX * Math.sin(spread) + travelY * Math.cos(spread)) * speed;
            const sprite = new (0, $7Bs2Z.Sprite)(texture);
            // Most of the lump sits above the point it is pinned to, so it reads as sitting ON the
            // ground rather than straddling it, and it grows from there.
            sprite.anchor.set(0.5, 0.7);
            sprite.tint = $f63df80eccdeeea6$var$TINTS[Math.floor(Math.random() * $f63df80eccdeeea6$var$TINTS.length)];
            sprite.alpha = 0;
            sprite.rotation = Math.random() * Math.PI * 2;
            trail.surface.addChild(sprite);
            const puff = {
                sprite: sprite,
                emitterId: trail.entity.entityId,
                x: x,
                groundY: groundY,
                lift: 0,
                vx: kickX,
                vy: kickY,
                liftV: $f63df80eccdeeea6$var$LIFT * $f63df80eccdeeea6$var$between(0.7, 1.3),
                bornMs: nowMs,
                lifeMs: trail.lifeMs * $f63df80eccdeeea6$var$between(1 - $f63df80eccdeeea6$var$LIFE_JITTER, 1 + $f63df80eccdeeea6$var$LIFE_JITTER),
                zBase: zBase,
                scale: $f63df80eccdeeea6$var$between($f63df80eccdeeea6$var$SCALE_MIN, $f63df80eccdeeea6$var$SCALE_MAX) * sizeFactor,
                growth: $f63df80eccdeeea6$var$between($f63df80eccdeeea6$var$GROWTH_MIN, $f63df80eccdeeea6$var$GROWTH_MAX),
                alpha: $f63df80eccdeeea6$var$between($f63df80eccdeeea6$var$ALPHA_MIN, $f63df80eccdeeea6$var$ALPHA_MAX),
                spin: $f63df80eccdeeea6$var$between(-$f63df80eccdeeea6$var$SPIN, $f63df80eccdeeea6$var$SPIN)
            };
            this.puffs.push(puff);
            this.draw(puff, 0);
        };
        this.advance = (nowMs, dt)=>{
            // Exponential decay: the kick is spent in the first fraction of a second and the puff settles
            // where it landed, instead of coasting at a constant speed for its whole life.
            const groundDrag = Math.exp(-$f63df80eccdeeea6$var$GROUND_DRAG * dt);
            const liftDrag = Math.exp(-$f63df80eccdeeea6$var$LIFT_DRAG * dt);
            let write = 0;
            for(let i = 0; i < this.puffs.length; i++){
                const puff = this.puffs[i];
                const elapsed = (nowMs - puff.bornMs) / puff.lifeMs;
                if (puff.sprite.destroyed || elapsed >= 1) {
                    this.retire(puff);
                    continue;
                }
                puff.x += puff.vx * dt;
                puff.groundY += puff.vy * dt;
                puff.lift += puff.liftV * dt;
                puff.vx *= groundDrag;
                puff.vy *= groundDrag;
                puff.liftV *= liftDrag;
                puff.sprite.rotation += puff.spin * dt;
                this.draw(puff, elapsed);
                this.puffs[write++] = puff;
            }
            this.puffs.length = write;
        };
        this.draw = (puff, elapsed)=>{
            const sprite = puff.sprite;
            sprite.x = puff.x;
            sprite.y = puff.groundY - puff.lift;
            sprite.zIndex = puff.zBase + puff.groundY - $f63df80eccdeeea6$var$BEHIND_THE_HEELS;
            // Grows fastest early, the way a puff of anything diffuses.
            const eased = 1 - (1 - elapsed) * (1 - elapsed);
            sprite.scale.set(puff.scale * (1 + (puff.growth - 1) * eased));
            if (elapsed < $f63df80eccdeeea6$var$FADE_IN) sprite.alpha = puff.alpha * (elapsed / $f63df80eccdeeea6$var$FADE_IN);
            else if (elapsed < $f63df80eccdeeea6$var$FADE_AFTER) sprite.alpha = puff.alpha;
            else {
                const out = (elapsed - $f63df80eccdeeea6$var$FADE_AFTER) / (1 - $f63df80eccdeeea6$var$FADE_AFTER);
                sprite.alpha = puff.alpha * (1 - out * out);
            }
        };
        this.retire = (puff)=>{
            puff.sprite.parent?.removeChild(puff.sprite);
            if (!puff.sprite.destroyed) puff.sprite.destroy();
        };
        // Baked on the first puff rather than at construction: the renderer may not be able to generate
        // a texture yet (and in a test there is no GPU at all), and a trail that silently never appears
        // is worse than one drawn with a plain white blob.
        this.texture = ()=>{
            if (!this.textures.length) {
                try {
                    this.textures = this.makeTextures();
                } catch (e) {
                    this.textures = [];
                }
                if (!this.textures.length) this.textures = [
                    (0, $klOfb.Texture).WHITE
                ];
            }
            return this.textures[Math.floor(Math.random() * this.textures.length)];
        };
        this.surface = surface;
        this.makeTextures = makeTextures;
    }
    static{
        /**
     * The puff art: three white lumps, each built from overlapping soft ellipses, which every puff
     * then tints off the earth palette. White art is what makes one texture serve the whole palette
     * (tint multiplies), and three silhouettes is enough that the eye stops reading a repeated stamp
     * while all three still batch together.
     *
     * The softness is BAKED, three nested ellipses per blob rather than a blur filter: a filtered
     * display object renders into its own framebuffer and cannot batch with its neighbours, which
     * would be an offscreen pass per puff with a dozen of them on screen.
     *
     * Drawn oversized and scaled down per puff, at resolution 2 to match the world surface's 2x zoom,
     * so the edges stay smooth instead of showing the blocky diagonal of a 10px sprite. Each lump is
     * wider than it is tall: dust spreads along the ground, and the ground is seen at an angle.
     */ this.buildPuffTextures = (generate)=>{
            // [cx, cy, rx, ry] blobs per lump: a round one, a long low one, and a small wisp.
            const lumps = [
                [
                    [
                        0,
                        0,
                        7,
                        4.8
                    ],
                    [
                        -4.5,
                        1.4,
                        4.6,
                        3.4
                    ],
                    [
                        4,
                        -1,
                        5,
                        3.6
                    ]
                ],
                [
                    [
                        0,
                        0,
                        8,
                        4.4
                    ],
                    [
                        -5,
                        0.6,
                        4,
                        2.8
                    ],
                    [
                        4.6,
                        1,
                        3.4,
                        2.4
                    ]
                ],
                [
                    [
                        0,
                        0,
                        5.4,
                        4
                    ],
                    [
                        3,
                        -2,
                        3.6,
                        2.8
                    ]
                ]
            ];
            return lumps.map((blobs)=>{
                const g = new (0, $gwPoJ.Graphics)();
                blobs.forEach(([cx, cy, rx, ry])=>{
                    // Faint halo, body, dense core. Overlapping blobs compound where they meet, which is
                    // what gives a lump an uneven inside rather than a flat disc.
                    g.beginFill(0xffffff, 0.22);
                    g.drawEllipse(cx, cy, rx, ry);
                    g.endFill();
                    g.beginFill(0xffffff, 0.45);
                    g.drawEllipse(cx, cy, rx * 0.68, ry * 0.68);
                    g.endFill();
                    g.beginFill(0xffffff, 0.9);
                    g.drawEllipse(cx, cy, rx * 0.36, ry * 0.36);
                    g.endFill();
                });
                const texture = generate(g);
                g.destroy();
                return texture;
            });
        };
    }
    static{
        // The default texture factory, bound to a live pixi renderer. Split from buildPuffTextures so the
        // trail can be driven in a test without a GPU.
        this.textureFactory = (renderer)=>()=>$f63df80eccdeeea6$export$ab8cf330af9aa032.buildPuffTextures((g)=>renderer.generateTexture(g, {
                        resolution: 2,
                        scaleMode: (0, $P8XPi.SCALE_MODES).LINEAR
                    }));
    }
}



const $d4c6e028323d16a7$export$7f1b8be4b62f05f1 = 0.07;
const $d4c6e028323d16a7$export$e693e5f47e9e8878 = 0.06;
const $d4c6e028323d16a7$export$32e44352b9ab61f5 = 0.45;
const $d4c6e028323d16a7$export$7ab424ed67f2dfff = 0.1;
// Easing time constants, in seconds. Down slowly, so a 5-second server step becomes a drift; up fast,
// because the only way up is being fed, and the flare already covers that moment.
const $d4c6e028323d16a7$var$SHRINK_TAU = 1.6;
const $d4c6e028323d16a7$var$GROW_TAU = 0.25;
// A long gap (a backgrounded tab, a hitch) must not be integrated as one huge step.
const $d4c6e028323d16a7$var$MAX_DT = 0.25;
const $d4c6e028323d16a7$var$tuning = (key)=>{
    const value = typeof window === "undefined" ? undefined : window[key];
    return typeof value === "number" && Number.isFinite(value) ? Math.max(0, value) : 1;
};
class $d4c6e028323d16a7$export$8bdb2d278338129e {
    constructor(){
        this.states = new Map();
        /**
     * Write this frame's light for one fire. `target` is what the server says the light is;
     * `animate` is false off screen or by day, where the light simply follows the server.
     */ this.update = (lights, id, location, target, source, animate, nowMs)=>{
            let state = this.states.get(id);
            if (!state) {
                state = {
                    radius: target.radius,
                    intensity: target.intensity,
                    lastMs: nowMs
                };
                this.states.set(id, state);
            }
            const dt = Math.max(0, Math.min($d4c6e028323d16a7$var$MAX_DT, (nowMs - state.lastMs) / 1000));
            state.lastMs = nowMs;
            let radius = target.radius;
            let intensity = target.intensity;
            if (animate && source) {
                const k = 1 - Math.exp(-dt / (target.radius > state.radius ? $d4c6e028323d16a7$var$GROW_TAU : $d4c6e028323d16a7$var$SHRINK_TAU));
                state.radius += (target.radius - state.radius) * k;
                state.intensity += (target.intensity - state.intensity) * k;
                const breath = source.breath(nowMs) * $d4c6e028323d16a7$var$tuning("firelightBreath");
                const flare = source.flareLevel(nowMs) * $d4c6e028323d16a7$var$tuning("firelightFlare");
                radius = Math.max(0, state.radius * (1 + $d4c6e028323d16a7$export$7f1b8be4b62f05f1 * breath + $d4c6e028323d16a7$export$32e44352b9ab61f5 * flare));
                intensity = Math.max(0, Math.min(1, state.intensity * (1 + $d4c6e028323d16a7$export$e693e5f47e9e8878 * breath) + $d4c6e028323d16a7$export$7ab424ed67f2dfff * flare));
            } else {
                state.radius = target.radius;
                state.intensity = target.intensity;
            }
            const current = lights.get(id);
            if (current && current.radius === radius && current.intensity === intensity && current.location.x === location.x && current.location.y === location.y) return;
            lights.set(id, {
                entityId: id,
                location: {
                    x: location.x,
                    y: location.y
                },
                radius: radius,
                intensity: intensity
            });
        };
        this.remove = (id)=>{
            this.states.delete(id);
        };
    }
}



parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");

// Subtract the original alpha from its dilation: the centre stays transparent even
// when the outline is drawn above a building rather than underneath the body.
const $b885220dc92c19d4$var$fragment = `precision mediump float;
varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec4 inputSize;
uniform vec4 inputClamp;
void main(void) {
    float centre = texture2D(uSampler, vTextureCoord).a;
    float edge = 0.0;
    for (int i = 0; i < 8; i++) {
        float angle = float(i) * 0.78539816339;
        vec2 offset = vec2(cos(angle), sin(angle)) * inputSize.zw * 2.0;
        edge = max(edge, texture2D(uSampler, clamp(vTextureCoord + offset, inputClamp.xy, inputClamp.zw)).a);
    }
    float alpha = max(0.0, edge - centre);
    gl_FragColor = vec4(vec3(0.45, 0.90, 1.0) * alpha, alpha);
}`;
const $b885220dc92c19d4$export$bc32cd1613e8c4ca = 300;
const $b885220dc92c19d4$export$402ee61a7bf81935 = ()=>{
    const defaults = {
        recheckMs: $b885220dc92c19d4$export$bc32cd1613e8c4ca
    };
    if (typeof window === "undefined") return defaults;
    const w = window;
    if (w.occlusionOutline === undefined) w.occlusionOutline = defaults;
    return w.occlusionOutline && typeof w.occlusionOutline === "object" ? {
        ...defaults,
        ...w.occlusionOutline
    } : undefined;
};
class $b885220dc92c19d4$export$f32c9471336cdee1 {
    constructor(surface, recheckMs){
        this.surface = surface;
        this.recheckMs = recheckMs;
        this.hidden = false;
        this.checkedAt = -Infinity;
        this.root = new (0, $8t5Gy.Container)();
        this.pose = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).EMPTY);
        this.contentBounds = new (0, $6qzqq.Rectangle)();
        this.relative = new (0, $6qzqq.Matrix)();
        this.origin = new (0, $6qzqq.Point)();
        this.transformedOrigin = new (0, $6qzqq.Point)();
        this.filter = new (0, $klOfb.Filter)(`precision mediump float;
${(0, $klOfb.Filter).defaultVertexSrc}`, $b885220dc92c19d4$var$fragment);
        this.filter.padding = 3;
        this.pose.filters = [
            this.filter
        ];
        this.root.addChild(this.pose);
        this.root.zIndex = 999999;
        this.root.interactive = this.root.interactiveChildren = false;
        this.root.visible = false;
        surface.addChild(this.root);
    }
    update(body, playerZ, scene) {
        this.root.visible = false;
        if (!body || !body.container.worldVisible) {
            this.hide();
            return;
        }
        const { container: container, frame: frame } = body;
        container.toGlobal(this.origin, this.transformedOrigin);
        if (container.worldAlpha <= 0.15) {
            this.hide();
            return;
        }
        this.pose.texture = frame.texture;
        this.pose.position.set(frame.x, frame.y);
        this.pose.scale.set(frame.scaleX, frame.scaleY);
        this.pose.anchor.set(frame.anchorX ?? 0, frame.anchorY ?? 0);
        // Refresh the source transform, including stair travel, falls and camera zoom.
        this.surface.toGlobal(this.origin, this.transformedOrigin);
        const relative = this.relative.copyFrom(this.surface.worldTransform).invert().append(container.worldTransform);
        this.root.transform.setFromMatrix(relative);
        const now = Date.now();
        if (now - this.checkedAt >= (this.recheckMs ?? $b885220dc92c19d4$export$402ee61a7bf81935()?.recheckMs ?? $b885220dc92c19d4$export$bc32cd1613e8c4ca)) {
            this.checkedAt = now;
            const bounds = this.pose.getBounds();
            // Only read visible pixels after a cheap overlap succeeds. The existing
            // texture cache reads each shared pose once, then reuses its tight bounds;
            // a pose not read yet counts as clear until it is read, when the browser is idle.
            const content = scene.overlaps(bounds, playerZ) ? (0, $35a6592763403c18$export$92de05754e03fcc2)(this.pose, this.contentBounds) : undefined;
            // Outlined only once nothing of the body shows: half under a storey, the player can still see itself.
            this.hidden = content !== undefined && scene.covers(content ?? bounds, playerZ);
        }
        if (this.hidden) {
            this.root.alpha = container.worldAlpha / this.surface.worldAlpha;
            this.root.visible = true;
        } else this.pose.texture = (0, $klOfb.Texture).EMPTY;
    }
    hide() {
        this.root.visible = false;
        this.pose.texture = (0, $klOfb.Texture).EMPTY;
        // Ask afresh as soon as the outline may show again (off a ladder, back under a storey).
        this.hidden = false;
        this.checkedAt = -Infinity;
    }
    destroy() {
        this.root.destroy({
            children: true
        });
        this.filter.destroy();
    }
}


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");



// The command wheel: a forged ring of orders the player picks from by direction.
//
// What it is drawn as, and why. The wheel is a DECISION -- every time it is up, the player is being
// asked to choose -- so it has to read in one glance and feel good to answer. The previous wheel
// printed each order's name inside its wedge, which is the wrong shape for words: on the sides of the
// wheel a wedge is tall where a word is wide, so six orders meant two-line labels shrunk to fit and
// running into each other at the seams. It was also a see-through disc, so the world and the HUD
// text under it bled through the very labels being read.
//
//   the RING      carries a glyph per order (command_wheel_icons.ts). A glyph fits a wedge at any
//                 angle, so the ring can be smaller than the old disc and still roomy.
//   the PLAQUES   carry the names, one line each, on timber tags just past the rim where there is
//                 room for a whole word. Each plaque is a target too.
//   the HUB       is a bronze medallion with the subject's glyph -- the role being ordered, or the
//                 person/hand of an interaction page.
//
// It is built in the HUD's own materials -- the forged bezel and rivets of the wave dial (dial.ts),
// the cut timber and bronze of the build board (build_board.ts) -- so it belongs to the camp rather
// than floating over it. The face is OPAQUE: nothing behind it competes with the choice.
//
// The feel is in the motion, all of it driven off the frame delta handed to `animate` (the widget owns
// no timer): the ring pops open and the orders fan out round it one after another; the wedge under
// the pointer fills with firelight, its glyph lifts and gilds, and a brass needle on the hub swings
// to it; a pick flashes the wedge, throws a ripple off the rim and lifts the wheel away. No filters
// anywhere -- every glow is a stack of faint fills -- for the low-end hardware this game targets.
// Geometry, as fractions of the ring's outer radius, so a bigger wheel is the same wheel.
const $7676384fbaf9cdf2$var$BEZEL_RATIO = 0.095 // the forged band, painted inside the radius
;
const $7676384fbaf9cdf2$var$HUB_RATIO = 0.3 // the medallion in the middle
;
const $7676384fbaf9cdf2$var$ICON_RATIO = 0.31 // a slice glyph's drawn size
;
// How far past the rim a press still counts as the slice it points into. The wheel picks by
// DIRECTION, so overshooting the rim a little is aiming, not missing.
const $7676384fbaf9cdf2$var$RING_SLOP = 12;
const $7676384fbaf9cdf2$var$SINGLE_COMMAND_RADIUS = 22;
// The name plaques.
const $7676384fbaf9cdf2$var$PLAQUE_GAP = 5 // clear air between the rim and the nearest point of a plaque
;
const $7676384fbaf9cdf2$var$PLAQUE_PAD_X = 7;
const $7676384fbaf9cdf2$var$PLAQUE_H = 17;
const $7676384fbaf9cdf2$var$PLAQUE_NOTE_H = 10 // extra height when a plaque carries a note ("too far")
;
const $7676384fbaf9cdf2$var$PLAQUE_MIN_W = 34;
const $7676384fbaf9cdf2$var$PLAQUE_SEPARATION = 3 // closest two plaques may come to each other
;
const $7676384fbaf9cdf2$var$PLAQUE_CHAMFER = 4;
const $7676384fbaf9cdf2$var$PLAQUE_HIT_PAD = 3;
const $7676384fbaf9cdf2$var$LABEL_FONT_SIZE = 10;
const $7676384fbaf9cdf2$var$NOTE_FONT_SIZE = 8;
// The global wheel's title ("ALL FORAGERS"), which also switches the role it broadcasts to.
const $7676384fbaf9cdf2$var$BANNER_FONT_SIZE = 9;
const $7676384fbaf9cdf2$var$BANNER_H = 18;
const $7676384fbaf9cdf2$var$BANNER_PAD_X = 22 // room either side of the title for its switch chevrons
;
const $7676384fbaf9cdf2$var$BANNER_GAP = 6;
// Palette. The bezel, rim and rivets are build_board's; the light is the countdown dial's fire.
const $7676384fbaf9cdf2$var$FACE_COLOR = 0x16110c;
const $7676384fbaf9cdf2$var$FACE_WARM = 0x2b1e13 // a faint warmth pooled at the centre so the face is not a flat plate
;
const $7676384fbaf9cdf2$var$ICON_INK = 0xead7b2 // resting glyph: parchment
;
const $7676384fbaf9cdf2$var$LABEL_INK = 0xffedc7 // build_board INK
;
const $7676384fbaf9cdf2$var$GOLD = 0xffd166 // build_board GOLD -- what a chosen thing is lit with
;
const $7676384fbaf9cdf2$var$EMBER = 0xff9d2e // dial COUNTDOWN_FLARE -- the firelight pooled in a hovered wedge
;
const $7676384fbaf9cdf2$var$MUTED = 0xa3916f // an order that is offered but cannot be carried out from here
;
const $7676384fbaf9cdf2$var$NOTE_COLOR = 0xf09a6c;
const $7676384fbaf9cdf2$var$LABEL_RECEDED = 0xa89a80 // a name while another order is under the pointer
;
const $7676384fbaf9cdf2$var$PLAQUE_FACE = 0x1a140f;
const $7676384fbaf9cdf2$var$PLAQUE_FACE_LIT = 0x33240f;
const $7676384fbaf9cdf2$var$HUB_FACE = 0x110c08;
// Motion, in ms.
const $7676384fbaf9cdf2$var$OPEN_MS = 170;
const $7676384fbaf9cdf2$var$REVEAL_STAGGER_MS = 24 // each order fans out this long after the one before it
;
const $7676384fbaf9cdf2$var$REVEAL_ITEM_MS = 160;
const $7676384fbaf9cdf2$var$HOVER_MS = 90 // a wedge lighting up (or going dark)
;
const $7676384fbaf9cdf2$var$FLASH_MS = 420 // the confirmation flash on a pick
;
const $7676384fbaf9cdf2$var$CLOSE_MS = 140;
const $7676384fbaf9cdf2$var$COMMIT_HOLD_MS = 110 // a pick holds the lit wheel this long before it goes, so the flash registers
;
const $7676384fbaf9cdf2$var$NEEDLE_MS = 45 // time constant of the hub needle swinging round
;
const $7676384fbaf9cdf2$var$HUB_HOVER_MS = 110;
const $7676384fbaf9cdf2$export$f672e119ffb748dd = "interactions";
const $7676384fbaf9cdf2$export$1789b2f994d19a7a = "defender:hold";
const $7676384fbaf9cdf2$export$11a82d7ea0e09596 = "lord:hold";
const $7676384fbaf9cdf2$export$a4f042548a204485 = (command)=>command === $7676384fbaf9cdf2$export$1789b2f994d19a7a || command === $7676384fbaf9cdf2$export$11a82d7ea0e09596;
const $7676384fbaf9cdf2$export$88ecc0b698fd48f6 = (command)=>command.endsWith(":change_role");
// Per-role accent for the per-NPC (role-locked) wheel — matches ROLE_COLORS in ember_roster.ts,
// hand-synced to avoid an import cycle (command_wheel ← gui_manager → ember_roster). The global
// (broadcast) wheel keeps the neutral amber WHEEL_ACCENT instead.
const $7676384fbaf9cdf2$var$ROLE_ACCENT = {
    forager: 0x7be08a,
    defender: 0xff8a5c,
    lord: 0xf2a94e
};
const $7676384fbaf9cdf2$var$WHEEL_ACCENT = 0xf2a94e;
const $7676384fbaf9cdf2$export$dd85a0a51bd6aa0c = (index, count)=>(index + 0.5) * (Math.PI * 2 / count) - Math.PI / 2;
const $7676384fbaf9cdf2$export$c5eee76129d6b869 = (x, y, count)=>{
    if (count <= 0) return -1;
    const angle = Math.atan2(y, x) + Math.PI / 2;
    const normalized = angle < 0 ? angle + Math.PI * 2 : angle;
    return Math.min(count - 1, Math.floor(normalized / (Math.PI * 2 / count)));
};
// Nearest any point of a centred box comes to the origin.
const $7676384fbaf9cdf2$var$boxReach = (cx, cy, w, h)=>Math.hypot(Math.max(0, Math.abs(cx) - w / 2), Math.max(0, Math.abs(cy) - h / 2));
const $7676384fbaf9cdf2$var$boxesOverlap = (a, b, separation)=>Math.abs(a.x - b.x) < (a.w + b.w) / 2 + separation && Math.abs(a.y - b.y) < (a.h + b.h) / 2 + separation;
const $7676384fbaf9cdf2$export$6e0a26a9fc79b6b7 = (angle, w, h, clearance)=>{
    const ux = Math.cos(angle);
    const uy = Math.sin(angle);
    let lo = 0;
    let hi = clearance + w + h;
    for(let step = 0; step < 32; step++){
        const mid = (lo + hi) / 2;
        if ($7676384fbaf9cdf2$var$boxReach(mid * ux, mid * uy, w, h) >= clearance) hi = mid;
        else lo = mid;
    }
    return {
        x: hi * ux,
        y: hi * uy,
        t: hi
    };
};
const $7676384fbaf9cdf2$export$6fb9cefecc02c845 = (sizes, count, clearance)=>{
    const placed = sizes.map((size, i)=>{
        const angle = $7676384fbaf9cdf2$export$dd85a0a51bd6aa0c(i, count);
        return {
            ...size,
            ...$7676384fbaf9cdf2$export$6e0a26a9fc79b6b7(angle, size.w, size.h, clearance),
            angle: angle
        };
    });
    for(let pass = 0; pass < 200; pass++){
        let moved = false;
        for(let i = 0; i < placed.length; i++)for(let j = i + 1; j < placed.length; j++){
            if (!$7676384fbaf9cdf2$var$boxesOverlap(placed[i], placed[j], $7676384fbaf9cdf2$var$PLAQUE_SEPARATION)) continue;
            for (const p of [
                placed[i],
                placed[j]
            ]){
                p.t += 1;
                p.x = Math.cos(p.angle) * p.t;
                p.y = Math.sin(p.angle) * p.t;
            }
            moved = true;
        }
        if (!moved) break;
    }
    return placed.map(({ x: x, y: y, w: w, h: h })=>({
            x: Math.round(x),
            y: Math.round(y),
            w: w,
            h: h
        }));
};
const $7676384fbaf9cdf2$export$daa92b5a942060a2 = (displayName)=>{
    const match = /^(.*\S)\s*\(([^)]+)\)$/.exec(displayName);
    return match ? {
        label: match[1],
        note: match[2]
    } : {
        label: displayName
    };
};
// ---- small helpers ----------------------------------------------------------------------------
const $7676384fbaf9cdf2$var$clamp01 = (v)=>v < 0 ? 0 : v > 1 ? 1 : v;
const $7676384fbaf9cdf2$var$easeOutCubic = (t)=>1 - Math.pow(1 - t, 3);
const $7676384fbaf9cdf2$var$easeInQuad = (t)=>t * t;
const $7676384fbaf9cdf2$var$easeOutBack = (t)=>{
    const c1 = 1.7;
    const c3 = c1 + 1;
    return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
};
const $7676384fbaf9cdf2$var$lerpColor = (from, to, t)=>{
    const k = $7676384fbaf9cdf2$var$clamp01(t);
    const r = (from >> 16 & 0xff) + ((to >> 16 & 0xff) - (from >> 16 & 0xff)) * k;
    const g = (from >> 8 & 0xff) + ((to >> 8 & 0xff) - (from >> 8 & 0xff)) * k;
    const b = (from & 0xff) + ((to & 0xff) - (from & 0xff)) * k;
    return Math.round(r) << 16 | Math.round(g) << 8 | Math.round(b);
};
const $7676384fbaf9cdf2$var$approach = (value, target, step)=>value < target ? Math.min(target, value + step) : Math.max(target, value - step);
const $7676384fbaf9cdf2$var$wrapAngle = (a)=>Math.atan2(Math.sin(a), Math.cos(a));
// An annulus segment as one path, so a fill covers exactly one wedge of the ring.
const $7676384fbaf9cdf2$var$annularSector = (g, inner, outer, from, to)=>{
    g.moveTo(Math.cos(from) * inner, Math.sin(from) * inner);
    g.lineTo(Math.cos(from) * outer, Math.sin(from) * outer);
    g.arc(0, 0, outer, from, to);
    g.lineTo(Math.cos(to) * inner, Math.sin(to) * inner);
    g.arc(0, 0, inner, to, from, true);
    g.closePath();
};
const $7676384fbaf9cdf2$var$makeText = (text, fontSize, letterSpacing = 0)=>{
    const node = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(fontSize).bold().strokeThickness(0).align("center").render(text);
    if (letterSpacing) node.style.letterSpacing = letterSpacing;
    return node;
};
class $7676384fbaf9cdf2$export$a36bd337d7c5ab90 extends (0, $gwPoJ.Graphics) {
    get radius() {
        return this.compact ? $7676384fbaf9cdf2$var$SINGLE_COMMAND_RADIUS : this.normalRadius;
    }
    // THE command list for a page -- every layout, hit test and selection reads the wheel through
    // this, so a hidden command cannot be laid out, hovered, clicked or reported. `perEntityOnly`
    // commands are dropped unless the wheel is bound to a single NPC (roleLocked), which covers the
    // per-entity wheel, the roster wheel and the interactions page, and excludes only the global
    // (Control-key) broadcast wheel.
    commandsOf(npcType) {
        if (this.roleLocked) return this.commandOverride || npcType.commands;
        return npcType.commands.filter((command)=>!command.perEntityOnly);
    }
    constructor(props = {}){
        super(), this.compact = false, // Everything drawn lives in `content`, which the open/close motion scales. The wheel itself only
        // fades, so its position, hit area and pointer maths stay in unscaled coordinates.
        this.content = new (0, $8t5Gy.Container)(), this.frame = new (0, $gwPoJ.Graphics)() // shadow, bezel, face, spokes, rivets: redrawn per layout only
        , this.light = new (0, $gwPoJ.Graphics)() // firelight in the hovered wedge + the pick flash: per animated frame
        , this.iconLayer = new (0, $8t5Gy.Container)(), this.hub = new (0, $gwPoJ.Graphics)(), this.overlay = new (0, $gwPoJ.Graphics)() // needle, hub glow, pick ripple
        , this.plaqueLayer = new (0, $8t5Gy.Container)(), this.slices = [], this.currentNPCIndex = 0, // The ROLE page last shown, which the global wheel goes back to once an entity's interaction page
        // is dropped. (Clamping the index instead put the Control-key wheel on Defenders after every
        // chest or visitor, whatever page the player had been using.)
        this.rolePageIndex = 0, this.activeCommandIndex = -1, this.hoveredCommandIndex = -1, this.hubHovered = false, // While targeting a single NPC the role page is locked (center switcher disabled).
        this.roleLocked = false, // Open/close state. `opened` is the logical flag (flips the instant a close starts) so callers
        // see the wheel as "closed" the moment it begins dismissing, while `phase` keeps it drawing until
        // its exit has played.
        this.opened = false, this.phase = "closed", this.phaseMs = 0, this.commitClose = false, // A page change asked for while the wheel is on its way out waits until it has gone, so the exit
        // shows what the player was looking at rather than the global wheel it is being reset to.
        this.layoutPending = false, // The pick flash: which slice, and how far through.
        this.flashIndex = -1, this.flashMs = 0, this.needleAngle = -Math.PI / 2, this.needleAlpha = 0, this.hubGlow = 0, // "Change Role" is not an order to the NPC at all: it puts the role picker up over it and waits,
        // and it is `perEntityOnly` so the GLOBAL (Control-key) wheel never lists it. Re-crewing the whole
        // camp in one click is not a thing anybody means to do, and the question the picker asks ("which
        // job instead?") has no mass form -- it would stack one panel per member on the asking player's
        // screen. The server refuses an untargeted change_role as well (see handleCommand in
        // ember-forager.js / ember-defender.js); this is what keeps it off the wheel in the first place,
        // so the player is never offered an order that silently does nothing.
        //
        // There is deliberately NO "Rename" here. Naming a member is offered once, at the hire, as the
        // last beat of the role picker (ember-recruit.js chooseRole -> the name prompt), and that is the
        // whole of it: a standing order to re-open a text field is a settings screen, not a camp order,
        // and it crowded out the orders that actually move somebody. The scripts still answer a
        // "<role>:rename" command (and the name prompt, and RENAME_ENTITY, are untouched), so putting the
        // verb back is a line in the tables below.
        this.npcTypes = [
            {
                name: "forager",
                displayName: "Forager",
                commands: [
                    {
                        name: "forager:forage",
                        displayName: "Forage Wood"
                    },
                    {
                        name: "forager:feed_fire",
                        displayName: "Feed Fire"
                    },
                    {
                        name: "forager:head_back",
                        displayName: "Head Back"
                    },
                    {
                        name: "forager:repair",
                        displayName: "Repair Walls"
                    },
                    {
                        name: "forager:follow",
                        displayName: "Follow Me"
                    },
                    {
                        name: "forager:change_role",
                        displayName: "Change Role",
                        perEntityOnly: true
                    }
                ]
            },
            {
                name: "defender",
                displayName: "Defender",
                commands: [
                    {
                        name: "defender:defend",
                        displayName: "Defend Camp"
                    },
                    {
                        name: $7676384fbaf9cdf2$export$1789b2f994d19a7a,
                        displayName: "Hold Position"
                    },
                    {
                        name: "defender:follow",
                        displayName: "Follow Me"
                    },
                    {
                        name: "defender:change_role",
                        displayName: "Change Role",
                        perEntityOnly: true
                    },
                    {
                        name: "defender:watch",
                        displayName: "Watch",
                        perEntityOnly: true
                    }
                ]
            }
        ];
        this.normalRadius = props.radius || 64;
        this.onCommandSelect = props.onCommandSelect;
        this.onHoverChange = props.onHoverChange;
        this.content.addChild(this.frame, this.light, this.iconLayer, this.hub, this.overlay, this.plaqueLayer);
        this.addChild(this.content);
        this.interactive = true;
        this.hitArea = {
            contains: (x, y)=>this.coversPoint(x, y)
        };
        this.on("pointermove", this.onPointerMove.bind(this));
        this.on("pointerdown", this.onPointerDown.bind(this));
        this.on("pointerout", this.onPointerOut.bind(this));
        // Prevent context menu from appearing
        this.on("rightclick", (event)=>{
            event.stopPropagation();
        });
        this.on("contextmenu", (event)=>{
            event.preventDefault();
            event.stopPropagation();
        });
        this.layout();
    }
    // ---- geometry ----
    get bezelWidth() {
        return Math.max(4, this.radius * $7676384fbaf9cdf2$var$BEZEL_RATIO);
    }
    get faceRadius() {
        return this.radius - this.bezelWidth;
    }
    get hubRadius() {
        return this.radius * $7676384fbaf9cdf2$var$HUB_RATIO;
    }
    // Glyphs ride the middle of the band between the hub and the face's edge.
    get iconRadius() {
        if (this.compact) return 0;
        return (this.hubRadius + this.faceRadius) / 2 + 1;
    }
    get iconScale() {
        if (this.compact) return 22 / (0, $ec5c35dbffc1f325$export$2bd980d3c871717d);
        return this.radius * $7676384fbaf9cdf2$var$ICON_RATIO / (0, $ec5c35dbffc1f325$export$2bd980d3c871717d);
    }
    get switchable() {
        return !this.roleLocked && this.npcTypes.length > 1;
    }
    // The ring's outer radius, so callers can anchor chrome of their own (e.g. the tether line
    // gui_manager draws to the commanded NPC) on the rim rather than the center.
    getRadius() {
        return this.radius;
    }
    // How far the wheel paints from its centre in each direction -- ring, shadow, plaques and title
    // -- for laying it out against the screen edge. The plaques make it wider than it is tall, and
    // how much depends on the names on show, so this is read after a bind, never assumed.
    getExtent() {
        const extent = {
            left: this.radius,
            right: this.radius,
            top: this.radius,
            bottom: this.radius + 3
        };
        const boxes = this.slices.map((slice)=>slice.box);
        if (this.banner) boxes.push(this.banner.box);
        for (const box of boxes){
            extent.left = Math.max(extent.left, box.w / 2 - box.x);
            extent.right = Math.max(extent.right, box.x + box.w / 2);
            extent.top = Math.max(extent.top, box.h / 2 - box.y);
            extent.bottom = Math.max(extent.bottom, box.y + box.h / 2 + 2);
        }
        return extent;
    }
    // Identity color for the wheel's chrome: a per-NPC (role-locked) wheel takes its role's accent
    // so it reads as "this one unit"; the global broadcast wheel stays neutral amber. Public so the
    // tether line to the commanded NPC can wear the same accent as the wheel it leaves.
    getAccent() {
        if (this.roleLocked) {
            const role = this.npcTypes[this.currentNPCIndex].name;
            return $7676384fbaf9cdf2$var$ROLE_ACCENT[role] ?? $7676384fbaf9cdf2$var$WHEEL_ACCENT;
        }
        return $7676384fbaf9cdf2$var$WHEEL_ACCENT;
    }
    // The global wheel's hub glyph and title wear the ROLE's colour (it is the role being ordered);
    // the wheel's own accent stays amber, which is what tells it apart from a one-member wheel.
    glyphColor() {
        const page = this.npcTypes[this.currentNPCIndex];
        return $7676384fbaf9cdf2$var$ROLE_ACCENT[page.name] ?? this.getAccent();
    }
    // ---- building a page ----
    // Rebuild everything that depends on the page: the frame (spoke count), the hub, a glyph and a
    // plaque per order, and -- on the global wheel -- the title. Not called on hover: hovering only
    // repaints the light and moves what is already here.
    layout() {
        this.layoutPending = false;
        for (const slice of this.slices){
            slice.icon.destroy();
            slice.iconShadow.destroy();
            slice.plaque.destroy({
                children: true
            });
        }
        this.slices = [];
        if (this.banner) {
            this.banner.container.destroy({
                children: true
            });
            this.banner = undefined;
        }
        const page = this.npcTypes[this.currentNPCIndex];
        const commands = this.commandsOf(page);
        const count = commands.length;
        this.compact = count === 1;
        const views = commands.map((command, index)=>{
            const angle = $7676384fbaf9cdf2$export$dd85a0a51bd6aa0c(index, count);
            const { label: label, note: note } = $7676384fbaf9cdf2$export$daa92b5a942060a2(command.displayName);
            const iconKey = (0, $ec5c35dbffc1f325$export$5bb74e7e1a2132f0)(command.name, label);
            const icon = new (0, $gwPoJ.Graphics)();
            (0, $ec5c35dbffc1f325$export$8674a23a9be99236)(icon, iconKey);
            // Same geometry, painted black and dropped a pixel: the glyph reads as struck INTO the
            // face rather than printed on it, and it costs no second tessellation.
            const iconShadow = new (0, $gwPoJ.Graphics)(icon.geometry);
            iconShadow.tint = 0x000000;
            const cx = Math.cos(angle) * this.iconRadius;
            const cy = Math.sin(angle) * this.iconRadius;
            icon.position.set(cx, cy);
            iconShadow.position.set(cx, cy + 1.2);
            this.iconLayer.addChild(iconShadow, icon);
            const plaque = new (0, $8t5Gy.Container)();
            const plaqueBg = new (0, $gwPoJ.Graphics)();
            const labelText = $7676384fbaf9cdf2$var$makeText(label, $7676384fbaf9cdf2$var$LABEL_FONT_SIZE);
            plaque.addChild(plaqueBg, labelText);
            let noteText;
            if (note) {
                noteText = $7676384fbaf9cdf2$var$makeText(note, $7676384fbaf9cdf2$var$NOTE_FONT_SIZE);
                noteText.tint = $7676384fbaf9cdf2$var$NOTE_COLOR;
                plaque.addChild(noteText);
            }
            this.plaqueLayer.addChild(plaque);
            const w = Math.ceil(Math.max($7676384fbaf9cdf2$var$PLAQUE_MIN_W, labelText.width + $7676384fbaf9cdf2$var$PLAQUE_PAD_X * 2, (noteText?.width ?? 0) + $7676384fbaf9cdf2$var$PLAQUE_PAD_X * 2));
            const h = $7676384fbaf9cdf2$var$PLAQUE_H + (noteText ? $7676384fbaf9cdf2$var$PLAQUE_NOTE_H : 0);
            return {
                command: command,
                angle: angle,
                icon: icon,
                iconShadow: iconShadow,
                plaque: plaque,
                plaqueBg: plaqueBg,
                label: labelText,
                note: noteText,
                w: w,
                h: h,
                muted: !!note
            };
        });
        const boxes = this.compact ? views.map(({ w: w, h: h })=>({
                x: 0,
                y: this.radius + $7676384fbaf9cdf2$var$PLAQUE_GAP + h / 2,
                w: w,
                h: h
            })) : $7676384fbaf9cdf2$export$6fb9cefecc02c845(views.map(({ w: w, h: h })=>({
                w: w,
                h: h
            })), count, this.radius + $7676384fbaf9cdf2$var$PLAQUE_GAP);
        this.slices = views.map((view, index)=>{
            const box = boxes[index];
            const top = -box.h / 2;
            view.label.position.set(Math.round(-view.label.width / 2), Math.round(top + ($7676384fbaf9cdf2$var$PLAQUE_H - view.label.height) / 2));
            if (view.note) view.note.position.set(Math.round(-view.note.width / 2), Math.round(top + $7676384fbaf9cdf2$var$PLAQUE_H - 3));
            view.plaque.position.set(box.x, box.y);
            return {
                command: view.command,
                angle: view.angle,
                icon: view.icon,
                iconShadow: view.iconShadow,
                plaque: view.plaque,
                plaqueBg: view.plaqueBg,
                label: view.label,
                note: view.note,
                box: box,
                muted: view.muted,
                glow: 0
            };
        });
        if (this.switchable) this.buildBanner(page);
        this.drawFrame(count);
        this.drawHub(page);
        this.hub.visible = !this.compact;
        if (this.hubGlyph) this.hubGlyph.visible = !this.compact;
        this.paint();
    }
    // The global wheel names who it is ordering -- the whole role -- and doubles as the role switch:
    // its chevrons say "there is another page", and a press on either side turns to it.
    buildBanner(page) {
        const container = new (0, $8t5Gy.Container)();
        const bg = new (0, $gwPoJ.Graphics)();
        const title = $7676384fbaf9cdf2$var$makeText(`All ${page.displayName}s`.toUpperCase(), $7676384fbaf9cdf2$var$BANNER_FONT_SIZE, 1);
        title.tint = this.glyphColor();
        container.addChild(bg, title);
        // pixi's letterSpacing adds a trailing advance after the last glyph; take it back off so the
        // title sits on the wheel's axis.
        const inkWidth = title.width - 1;
        const w = Math.ceil(inkWidth + $7676384fbaf9cdf2$var$BANNER_PAD_X * 2);
        title.position.set(Math.round(-inkWidth / 2), Math.round(-title.height / 2));
        // Above the ring, and above any plaque it would otherwise land on.
        let y = -(this.radius + $7676384fbaf9cdf2$var$BANNER_GAP + $7676384fbaf9cdf2$var$BANNER_H / 2);
        for(let guard = 0; guard < 20; guard++){
            const box = {
                x: 0,
                y: y,
                w: w,
                h: $7676384fbaf9cdf2$var$BANNER_H
            };
            const blocker = this.slices.find((slice)=>$7676384fbaf9cdf2$var$boxesOverlap(box, slice.box, $7676384fbaf9cdf2$var$PLAQUE_SEPARATION));
            if (!blocker) break;
            y = blocker.box.y - blocker.box.h / 2 - $7676384fbaf9cdf2$var$PLAQUE_SEPARATION - $7676384fbaf9cdf2$var$BANNER_H / 2 - 1;
        }
        container.position.set(0, Math.round(y));
        this.plaqueLayer.addChild(container);
        this.banner = {
            container: container,
            bg: bg,
            title: title,
            box: {
                x: 0,
                y: Math.round(y),
                w: w,
                h: $7676384fbaf9cdf2$var$BANNER_H
            }
        };
    }
    // The static ring: dropped shadow, forged bezel lit from the upper left, an opaque face with a
    // little warmth at its heart, an engraved spoke between each pair of orders and a rivet where each
    // spoke meets the bezel.
    drawFrame(count) {
        const g = this.frame;
        const r = this.radius;
        const face = this.faceRadius;
        const band = r - this.bezelWidth / 2;
        g.clear();
        g.beginFill(0x000000, 0.36).drawCircle(0, 3, r + 0.5).endFill();
        g.beginFill((0, $658a44ce960354bb$export$611f5967b7e8b685), 1).drawCircle(0, 0, r).endFill();
        const sweep = (from, to, color, alpha)=>{
            g.lineStyle({
                width: this.bezelWidth * 0.6,
                color: color,
                alpha: alpha,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            g.moveTo(Math.cos(from) * band, Math.sin(from) * band);
            g.arc(0, 0, band, from, to);
        };
        sweep(Math.PI * 1.04, Math.PI * 1.88, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.45);
        sweep(Math.PI * 0.08, Math.PI * 0.86, 0x000000, 0.4);
        g.lineStyle({
            width: 1.2,
            color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
            alpha: 0.95
        }).drawCircle(0, 0, r);
        g.lineStyle(0);
        g.beginFill($7676384fbaf9cdf2$var$FACE_COLOR, 0.97).drawCircle(0, 0, face).endFill();
        // Many faint steps rather than a few strong ones: a few strong discs read as a target.
        for(let ring = 0; ring < 7; ring++)g.beginFill($7676384fbaf9cdf2$var$FACE_WARM, 0.09).drawCircle(0, 0, face * (0.92 - ring * 0.09)).endFill();
        g.lineStyle({
            width: 1,
            color: 0x000000,
            alpha: 0.6
        }).drawCircle(0, 0, face - 0.5);
        const spokeAngles = count > 1 ? Array.from({
            length: count
        }, (_, i)=>i * Math.PI * 2 / count - Math.PI / 2) : [];
        const inner = this.hubRadius + 1;
        for (const angle of spokeAngles){
            const ux = Math.cos(angle);
            const uy = Math.sin(angle);
            // A groove: a dark cut with a hairline of light along its lower edge.
            g.lineStyle({
                width: 2,
                color: 0x000000,
                alpha: 0.6,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            g.moveTo(ux * inner, uy * inner).lineTo(ux * (face - 1), uy * (face - 1));
            g.lineStyle({
                width: 1,
                color: (0, $658a44ce960354bb$export$6b1db5e247c0ce0),
                alpha: 0.12,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            g.moveTo(ux * inner - uy * 1.2, uy * inner + ux * 1.2).lineTo(ux * (face - 1) - uy * 1.2, uy * (face - 1) + ux * 1.2);
        }
        g.lineStyle(0);
        // Rivets where the spokes meet the bezel, or on the diagonals when there are no spokes.
        const rivets = spokeAngles.length ? spokeAngles : [
            0,
            1,
            2,
            3
        ].map((k)=>-Math.PI / 4 + k * Math.PI / 2);
        for (const angle of rivets){
            const x = Math.cos(angle) * band;
            const y = Math.sin(angle) * band;
            g.beginFill(0x000000, 0.5).drawCircle(x, y + 0.5, 2.2).endFill();
            g.beginFill((0, $658a44ce960354bb$export$dd27ce85ad53c944), 0.95).drawCircle(x, y, 1.75).endFill();
            g.beginFill((0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.7).drawCircle(x - 0.5, y - 0.6, 0.7).endFill();
        }
    }
    // The medallion: a raised bronze boss with a dark face, ringed in the subject's colour, carrying
    // its glyph.
    drawHub(page) {
        const g = this.hub;
        const r = this.hubRadius;
        const color = this.glyphColor();
        g.clear();
        g.beginFill(0x000000, 0.5).drawCircle(0, 1.6, r + 0.8).endFill();
        g.beginFill((0, $658a44ce960354bb$export$dd27ce85ad53c944), 1).drawCircle(0, 0, r).endFill();
        g.lineStyle({
            width: 1.6,
            color: (0, $658a44ce960354bb$export$6b1db5e247c0ce0),
            alpha: 0.6,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        g.moveTo(Math.cos(Math.PI * 1.05) * (r - 1.1), Math.sin(Math.PI * 1.05) * (r - 1.1));
        g.arc(0, 0, r - 1.1, Math.PI * 1.05, Math.PI * 1.85);
        g.lineStyle({
            width: 1,
            color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
            alpha: 0.9
        }).drawCircle(0, 0, r);
        g.lineStyle(0);
        g.beginFill($7676384fbaf9cdf2$var$HUB_FACE, 1).drawCircle(0, 0, r - 2.6).endFill();
        g.lineStyle({
            width: 1,
            color: color,
            alpha: 0.45
        }).drawCircle(0, 0, r - 4.4);
        g.lineStyle(0);
        if (this.hubGlyph) {
            this.hubGlyph.destroy();
            this.hubGlyph = undefined;
        }
        const iconKey = (0, $ec5c35dbffc1f325$export$37127edc63359470)(page.name, page.emoji);
        if (iconKey) {
            const glyph = new (0, $gwPoJ.Graphics)();
            (0, $ec5c35dbffc1f325$export$8674a23a9be99236)(glyph, iconKey);
            glyph.scale.set(r * 1.02 / (0, $ec5c35dbffc1f325$export$2bd980d3c871717d));
            glyph.tint = color;
            this.hubGlyph = glyph;
        } else {
            const glyph = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(Math.round(r)).align("center").render(page.emoji);
            glyph.position.set(-glyph.width / 2, -glyph.height / 2);
            this.hubGlyph = glyph;
        }
        this.content.addChildAt(this.hubGlyph, this.content.getChildIndex(this.hub) + 1);
    }
    // ---- painting (anything that moves) ----
    revealProgress(index) {
        if (this.revealMs === undefined) return 1;
        return $7676384fbaf9cdf2$var$clamp01((this.revealMs - index * $7676384fbaf9cdf2$var$REVEAL_STAGGER_MS) / $7676384fbaf9cdf2$var$REVEAL_ITEM_MS);
    }
    get revealTotalMs() {
        return Math.max(0, this.slices.length - 1) * $7676384fbaf9cdf2$var$REVEAL_STAGGER_MS + $7676384fbaf9cdf2$var$REVEAL_ITEM_MS;
    }
    sliceSpan(index) {
        const count = this.slices.length;
        if (count <= 1) return [
            -Math.PI / 2,
            Math.PI * 1.5
        ];
        const width = Math.PI * 2 / count;
        const from = index * width - Math.PI / 2;
        // Stop the light a hair short of the spokes, so the grooves stay cut.
        return [
            from + 0.025,
            from + width - 0.025
        ];
    }
    paint() {
        // The whole wheel: a pop on the way in, a sink (dismissed) or a lift (picked) on the way out.
        let alpha = 1;
        let scale = 1;
        if (this.phase === "opening") {
            const t = $7676384fbaf9cdf2$var$clamp01(this.phaseMs / $7676384fbaf9cdf2$var$OPEN_MS);
            alpha = $7676384fbaf9cdf2$var$easeOutCubic($7676384fbaf9cdf2$var$clamp01(t * 1.5));
            scale = 0.84 + 0.16 * $7676384fbaf9cdf2$var$easeOutBack(t);
        } else if (this.phase === "closing") {
            if (this.commitClose) {
                const t = $7676384fbaf9cdf2$var$clamp01((this.phaseMs - $7676384fbaf9cdf2$var$COMMIT_HOLD_MS) / $7676384fbaf9cdf2$var$CLOSE_MS);
                alpha = 1 - $7676384fbaf9cdf2$var$easeInQuad(t);
                scale = 1 + 0.05 * $7676384fbaf9cdf2$var$easeOutCubic(t);
            } else {
                const t = $7676384fbaf9cdf2$var$clamp01(this.phaseMs / $7676384fbaf9cdf2$var$CLOSE_MS);
                alpha = 1 - $7676384fbaf9cdf2$var$easeInQuad(t);
                scale = 1 - 0.07 * t;
            }
        }
        this.alpha = alpha;
        this.content.scale.set(scale);
        const flash = this.flashIndex >= 0 ? Math.pow(1 - $7676384fbaf9cdf2$var$clamp01(this.flashMs / $7676384fbaf9cdf2$var$FLASH_MS), 2) : 0;
        const focus = this.slices.reduce((most, slice)=>Math.max(most, slice.glow), 0);
        this.light.clear();
        this.slices.forEach((slice, index)=>{
            const f = index === this.flashIndex ? flash : 0;
            if (slice.glow > 0.003 || f > 0.003) this.drawSectorLight(index, $7676384fbaf9cdf2$var$easeOutCubic(slice.glow), f);
        });
        this.slices.forEach((slice, index)=>{
            const p = this.revealProgress(index);
            const f = index === this.flashIndex ? flash : 0;
            const lit = $7676384fbaf9cdf2$var$easeOutCubic(slice.glow);
            const pop = p >= 1 ? 1 : 0.5 + 0.5 * $7676384fbaf9cdf2$var$easeOutBack(p);
            const iconScale = this.iconScale * pop * (1 + 0.16 * lit + 0.2 * f);
            // Whatever is NOT under the pointer steps back a little, so the one that is stands out.
            const dim = 1 - 0.3 * focus * (1 - slice.glow);
            slice.icon.scale.set(iconScale);
            slice.iconShadow.scale.set(iconScale);
            slice.icon.alpha = $7676384fbaf9cdf2$var$clamp01(p * 1.4) * dim;
            slice.iconShadow.alpha = $7676384fbaf9cdf2$var$clamp01(p * 1.4) * dim * 0.75;
            slice.icon.tint = slice.muted ? $7676384fbaf9cdf2$var$lerpColor($7676384fbaf9cdf2$var$MUTED, $7676384fbaf9cdf2$var$ICON_INK, lit * 0.5) : $7676384fbaf9cdf2$var$lerpColor($7676384fbaf9cdf2$var$ICON_INK, $7676384fbaf9cdf2$var$GOLD, Math.max(lit, f));
            // Plaques slide out from the rim as they arrive, and lean out a touch when lit.
            const slide = 9 * (1 - $7676384fbaf9cdf2$var$easeOutCubic(p)) + 2 * lit;
            slice.plaque.position.set(slice.box.x + Math.cos(slice.angle) * slide, slice.box.y + Math.sin(slice.angle) * slide);
            // Plates stay solid -- a see-through plate over grass goes green -- and the other names recede
            // by their ink instead.
            slice.plaque.alpha = $7676384fbaf9cdf2$var$clamp01(p * 1.3);
            this.drawPlaque(slice, Math.max(lit, f), f);
            const resting = slice.muted ? $7676384fbaf9cdf2$var$MUTED : $7676384fbaf9cdf2$var$LABEL_INK;
            const receded = $7676384fbaf9cdf2$var$lerpColor(resting, $7676384fbaf9cdf2$var$LABEL_RECEDED, focus * (1 - slice.glow) * (slice.muted ? 0.4 : 1));
            slice.label.tint = $7676384fbaf9cdf2$var$lerpColor(receded, 0xffffff, lit);
        });
        const overlay = this.overlay;
        overlay.clear();
        if (!this.compact && this.needleAlpha > 0.01) this.drawNeedle(overlay, $7676384fbaf9cdf2$var$easeOutCubic(this.needleAlpha));
        if (this.hubGlow > 0.01) {
            const r = this.hubRadius;
            overlay.lineStyle({
                width: 4,
                color: $7676384fbaf9cdf2$var$GOLD,
                alpha: 0.18 * this.hubGlow
            }).drawCircle(0, 0, r + 1.5);
            overlay.lineStyle({
                width: 1.4,
                color: $7676384fbaf9cdf2$var$GOLD,
                alpha: 0.85 * this.hubGlow
            }).drawCircle(0, 0, r - 0.2);
            overlay.lineStyle(0);
        }
        if (flash > 0.003 && this.flashIndex >= 0 && this.flashIndex < this.slices.length) {
            const [from, to] = this.sliceSpan(this.flashIndex);
            const t = 1 - flash;
            const r = this.radius + 2 + 16 * $7676384fbaf9cdf2$var$easeOutCubic(t);
            overlay.lineStyle({
                width: 1 + 3 * flash,
                color: $7676384fbaf9cdf2$var$GOLD,
                alpha: 0.8 * flash,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            overlay.moveTo(Math.cos(from) * r, Math.sin(from) * r);
            overlay.arc(0, 0, r, from, to);
            overlay.lineStyle(0);
        }
        if (this.hubGlyph) this.hubGlyph.scale.set(this.hubGlyph instanceof (0, $gwPoJ.Graphics) ? this.hubRadius * 1.02 / (0, $ec5c35dbffc1f325$export$2bd980d3c871717d) * (1 + 0.08 * this.hubGlow) : 1);
        if (this.banner) this.drawBanner(this.banner, this.hubGlow);
    }
    // Firelight pooled in one wedge: a warm wash over all of it, brighter toward the rim, a glow under
    // its glyph, and the bezel above it catching the light.
    drawSectorLight(index, lit, flash) {
        const g = this.light;
        const [from, to] = this.sliceSpan(index);
        const inner = this.hubRadius + 2.5;
        const outer = this.faceRadius - 0.5;
        g.lineStyle(0);
        g.beginFill($7676384fbaf9cdf2$var$EMBER, 0.1 * lit + 0.28 * flash);
        $7676384fbaf9cdf2$var$annularSector(g, inner, outer, from, to);
        g.endFill();
        g.beginFill($7676384fbaf9cdf2$var$EMBER, 0.14 * lit + 0.18 * flash);
        $7676384fbaf9cdf2$var$annularSector(g, Math.max(inner, outer - 13), outer, from, to);
        g.endFill();
        g.beginFill($7676384fbaf9cdf2$var$GOLD, 0.12 * lit + 0.22 * flash);
        $7676384fbaf9cdf2$var$annularSector(g, outer - 5, outer, from, to);
        g.endFill();
        const mid = this.slices[index].angle;
        const cx = Math.cos(mid) * this.iconRadius;
        const cy = Math.sin(mid) * this.iconRadius;
        const size = this.radius * $7676384fbaf9cdf2$var$ICON_RATIO;
        for(let ring = 0; ring < 5; ring++)g.beginFill(ring < 3 ? $7676384fbaf9cdf2$var$EMBER : $7676384fbaf9cdf2$var$GOLD, 0.045 * lit).drawCircle(cx, cy, size * (0.85 - ring * 0.12)).endFill();
        const band = this.radius - this.bezelWidth / 2;
        g.lineStyle({
            width: this.bezelWidth + 3,
            color: $7676384fbaf9cdf2$var$GOLD,
            alpha: 0.16 * lit + 0.3 * flash,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        g.moveTo(Math.cos(from) * band, Math.sin(from) * band);
        g.arc(0, 0, band, from, to);
        g.lineStyle({
            width: 1.6,
            color: $7676384fbaf9cdf2$var$GOLD,
            alpha: Math.min(1, 0.85 * lit + 0.4 * flash),
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        g.moveTo(Math.cos(from) * (outer - 0.6), Math.sin(from) * (outer - 0.6));
        g.arc(0, 0, outer - 0.6, from, to);
        g.lineStyle(0);
    }
    // A brass pointer on the hub's rim, aimed at the order under the pointer.
    drawNeedle(g, alpha) {
        const a = this.needleAngle;
        const r0 = this.hubRadius + 1;
        const r1 = this.hubRadius + 7;
        const spread = 0.3;
        g.beginFill(0x000000, 0.45 * alpha).moveTo(Math.cos(a) * r1, Math.sin(a) * r1 + 1).lineTo(Math.cos(a - spread) * r0, Math.sin(a - spread) * r0 + 1).lineTo(Math.cos(a + spread) * r0, Math.sin(a + spread) * r0 + 1).closePath().endFill();
        g.beginFill($7676384fbaf9cdf2$var$GOLD, alpha).moveTo(Math.cos(a) * r1, Math.sin(a) * r1).lineTo(Math.cos(a - spread) * r0, Math.sin(a - spread) * r0).lineTo(Math.cos(a + spread) * r0, Math.sin(a + spread) * r0).closePath().endFill();
        // The hub's rim warms on the side the needle points to.
        g.lineStyle({
            width: 1.6,
            color: $7676384fbaf9cdf2$var$GOLD,
            alpha: 0.7 * alpha,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        g.moveTo(Math.cos(a - 0.55) * (this.hubRadius - 0.3), Math.sin(a - 0.55) * (this.hubRadius - 0.3));
        g.arc(0, 0, this.hubRadius - 0.3, a - 0.55, a + 0.55);
        g.lineStyle(0);
    }
    // A cut-timber tag: dropped shadow, dark face, bronze rim that turns gold when lit, one lit edge.
    drawPlaque(slice, lit, flash) {
        const g = slice.plaqueBg;
        const { w: w, h: h } = slice.box;
        const x = -w / 2;
        const y = -h / 2;
        g.clear();
        g.beginFill(0x000000, 0.38);
        (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x, y + 2, w, h, $7676384fbaf9cdf2$var$PLAQUE_CHAMFER);
        g.endFill();
        g.lineStyle({
            width: 1,
            color: $7676384fbaf9cdf2$var$lerpColor((0, $658a44ce960354bb$export$dd27ce85ad53c944), $7676384fbaf9cdf2$var$GOLD, lit),
            alpha: 0.9,
            join: (0, $gwPoJ.LINE_JOIN).MITER
        });
        g.beginFill($7676384fbaf9cdf2$var$lerpColor($7676384fbaf9cdf2$var$PLAQUE_FACE, $7676384fbaf9cdf2$var$PLAQUE_FACE_LIT, lit), 0.96);
        (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x, y, w, h, $7676384fbaf9cdf2$var$PLAQUE_CHAMFER);
        g.endFill();
        g.lineStyle(0);
        if (flash > 0.003) {
            g.beginFill($7676384fbaf9cdf2$var$GOLD, 0.28 * flash);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x, y, w, h, $7676384fbaf9cdf2$var$PLAQUE_CHAMFER);
            g.endFill();
        }
        g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.12 + 0.2 * lit).moveTo(x + $7676384fbaf9cdf2$var$PLAQUE_CHAMFER, y + 1.5).lineTo(x + w - $7676384fbaf9cdf2$var$PLAQUE_CHAMFER, y + 1.5);
        g.lineStyle(0);
    }
    // The global wheel's title plate, with a switch chevron at each end.
    drawBanner(banner, lit) {
        const g = banner.bg;
        const { w: w, h: h } = banner.box;
        const x = -w / 2;
        const y = -h / 2;
        g.clear();
        g.beginFill(0x000000, 0.38);
        (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x, y + 2, w, h, $7676384fbaf9cdf2$var$PLAQUE_CHAMFER + 1);
        g.endFill();
        g.lineStyle({
            width: 1,
            color: $7676384fbaf9cdf2$var$lerpColor((0, $658a44ce960354bb$export$dd27ce85ad53c944), $7676384fbaf9cdf2$var$GOLD, lit),
            alpha: 0.95,
            join: (0, $gwPoJ.LINE_JOIN).MITER
        });
        g.beginFill($7676384fbaf9cdf2$var$lerpColor($7676384fbaf9cdf2$var$PLAQUE_FACE, $7676384fbaf9cdf2$var$PLAQUE_FACE_LIT, lit * 0.6), 0.97);
        (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x, y, w, h, $7676384fbaf9cdf2$var$PLAQUE_CHAMFER + 1);
        g.endFill();
        g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.14 + 0.2 * lit).moveTo(x + $7676384fbaf9cdf2$var$PLAQUE_CHAMFER + 1, y + 1.5).lineTo(x + w - $7676384fbaf9cdf2$var$PLAQUE_CHAMFER - 1, y + 1.5);
        g.lineStyle(0);
        const chevron = $7676384fbaf9cdf2$var$lerpColor((0, $658a44ce960354bb$export$6b1db5e247c0ce0), $7676384fbaf9cdf2$var$GOLD, lit);
        const cx = w / 2 - 9;
        g.beginFill(chevron, 0.75 + 0.25 * lit);
        g.moveTo(-cx - 3, 0).lineTo(-cx + 2, -4).lineTo(-cx + 2, 4).closePath();
        g.moveTo(cx + 3, 0).lineTo(cx - 2, -4).lineTo(cx - 2, 4).closePath();
        g.endFill();
    }
    // ---- per-frame ----
    // Advance the wheel's motion by one frame. A resting wheel returns at once.
    animate(deltaMs) {
        if (!this.visible) return;
        // Not capped: after a hitch the motion catches up rather than playing on late.
        const dt = Math.max(0, deltaMs || 0);
        let dirty = false;
        if (this.phase === "opening") {
            this.phaseMs += dt;
            if (this.phaseMs >= $7676384fbaf9cdf2$var$OPEN_MS) this.phase = "open";
            dirty = true;
        } else if (this.phase === "closing") {
            this.phaseMs += dt;
            if (this.phaseMs >= $7676384fbaf9cdf2$var$CLOSE_MS + (this.commitClose ? $7676384fbaf9cdf2$var$COMMIT_HOLD_MS : 0)) {
                this.finishClose();
                return;
            }
            dirty = true;
        }
        if (this.revealMs !== undefined) {
            this.revealMs += dt;
            if (this.revealMs >= this.revealTotalMs) this.revealMs = undefined;
            dirty = true;
        }
        const step = dt / $7676384fbaf9cdf2$var$HOVER_MS;
        this.slices.forEach((slice, index)=>{
            const target = index === this.hoveredCommandIndex ? 1 : 0;
            if (slice.glow !== target) {
                slice.glow = $7676384fbaf9cdf2$var$approach(slice.glow, target, step);
                dirty = true;
            }
        });
        const hubTarget = this.hubHovered && this.switchable ? 1 : 0;
        if (this.hubGlow !== hubTarget) {
            this.hubGlow = $7676384fbaf9cdf2$var$approach(this.hubGlow, hubTarget, dt / $7676384fbaf9cdf2$var$HUB_HOVER_MS);
            dirty = true;
        }
        const hovered = this.slices[this.hoveredCommandIndex];
        const needleTarget = hovered ? 1 : 0;
        if (hovered) {
            const target = hovered.angle;
            if (this.needleAlpha < 0.02) this.needleAngle = target;
            else {
                const delta = $7676384fbaf9cdf2$var$wrapAngle(target - this.needleAngle);
                if (Math.abs(delta) > 0.001) {
                    this.needleAngle += delta * (1 - Math.exp(-dt / $7676384fbaf9cdf2$var$NEEDLE_MS));
                    dirty = true;
                }
            }
        }
        if (this.needleAlpha !== needleTarget) {
            this.needleAlpha = $7676384fbaf9cdf2$var$approach(this.needleAlpha, needleTarget, dt / $7676384fbaf9cdf2$var$HOVER_MS);
            dirty = true;
        }
        if (this.flashIndex >= 0) {
            this.flashMs += dt;
            if (this.flashMs >= $7676384fbaf9cdf2$var$FLASH_MS) this.flashIndex = -1;
            dirty = true;
        }
        if (dirty) this.paint();
    }
    // ---- input ----
    // What a point (in the wheel's own coordinates) lands on. Slices are picked by direction, out to a
    // little past the rim, and their plaques are targets in their own right.
    targetAt(x, y) {
        const distance = Math.hypot(x, y);
        if (this.compact) return distance <= this.radius + 3 || this.slices.some((slice)=>this.inBox(x, y, slice.box, $7676384fbaf9cdf2$var$PLAQUE_HIT_PAD)) ? {
            kind: "slice",
            index: 0
        } : null;
        if (distance <= this.hubRadius + 2) return {
            kind: "hub"
        };
        if (this.banner && this.inBox(x, y, this.banner.box, $7676384fbaf9cdf2$var$PLAQUE_HIT_PAD)) return {
            kind: "banner",
            step: x < 0 ? -1 : 1
        };
        const count = this.commandsOf(this.npcTypes[this.currentNPCIndex]).length;
        if (this.slices.length === count) {
            const onPlaque = this.slices.findIndex((slice)=>this.inBox(x, y, slice.box, $7676384fbaf9cdf2$var$PLAQUE_HIT_PAD));
            if (onPlaque >= 0) return {
                kind: "slice",
                index: onPlaque
            };
        }
        if (distance <= this.radius + $7676384fbaf9cdf2$var$RING_SLOP && count > 0) return {
            kind: "slice",
            index: $7676384fbaf9cdf2$export$c5eee76129d6b869(x, y, count)
        };
        return null;
    }
    inBox(x, y, box, pad) {
        return Math.abs(x - box.x) <= box.w / 2 + pad && Math.abs(y - box.y) <= box.h / 2 + pad;
    }
    // The hit area: the whole disc (a press in the hub of a locked wheel is still ON the wheel, not a
    // press on the world behind it) plus everything targetAt answers to.
    coversPoint(x, y) {
        return Math.hypot(x, y) <= this.radius || this.targetAt(x, y) !== null;
    }
    setHover(index, hub) {
        this.hubHovered = hub;
        this.cursor = index >= 0 || hub && this.switchable ? "pointer" : "default";
        if (index === this.hoveredCommandIndex) return;
        this.hoveredCommandIndex = index;
        if (index >= 0 && this.phase !== "closing") this.onHoverChange?.();
    }
    onPointerMove(event) {
        // Stop event propagation to prevent interfering with game mouse handling
        event.stopPropagation();
        const local = this.toLocal(event.data.global);
        this.hoverAt(local.x, local.y);
    }
    onPointerDown(event) {
        // Stop event propagation to prevent triggering game attacks
        event.stopPropagation();
        const local = this.toLocal(event.data.global);
        this.pressAt(local.x, local.y);
    }
    // A pointer resting at (x, y) in the wheel's own coordinates. Public, with pressAt, so a
    // demonstration can work the real wheel by hand (gui/forager_tutorial.ts) exactly as a mouse would.
    hoverAt(x, y) {
        const target = this.targetAt(x, y);
        this.setHover(target?.kind === "slice" ? target.index : -1, target?.kind === "hub" || target?.kind === "banner");
    }
    // A press at (x, y) in the wheel's own coordinates.
    pressAt(x, y) {
        const target = this.targetAt(x, y);
        if (!target) return;
        if (target.kind === "hub") {
            this.switchNPC(1);
            return;
        }
        if (target.kind === "banner") {
            this.switchNPC(target.step);
            return;
        }
        const currentNPC = this.npcTypes[this.currentNPCIndex];
        const command = this.commandsOf(currentNPC)[target.index];
        if (!command) return;
        this.activeCommandIndex = target.index;
        // Lit BEFORE the callback: a per-entity wheel is put away from inside it, and the exit has to
        // know it is carrying a pick (it holds the flash, then lifts away) rather than a dismissal.
        this.flashIndex = target.index;
        this.flashMs = 0;
        this.hoveredCommandIndex = target.index;
        this.paint();
        this.onCommandSelect?.(command.name, currentNPC.name);
    }
    onPointerOut() {
        this.setHover(-1, false);
    }
    // Turn the global wheel to the next (step 1) or previous (step -1) role.
    switchNPC(step = 1) {
        // When bound to a single NPC the page is locked to that NPC's role.
        if (!this.switchable) return;
        const count = this.npcTypes.length;
        this.currentNPCIndex = (this.currentNPCIndex + step + count) % count;
        this.rolePageIndex = this.currentNPCIndex;
        this.activeCommandIndex = -1;
        this.hoveredCommandIndex = -1;
        this.flashIndex = -1;
        this.layout();
        // The new page's orders fan out the way the first ones did.
        this.revealMs = 0;
        this.onHoverChange?.();
        this.paint();
    }
    // A page change. Deferred while the wheel is on its way out (see layoutPending).
    requestLayout() {
        if (this.phase === "closing") {
            this.layoutPending = true;
            return;
        }
        this.layout();
    }
    getCurrentNPC() {
        return this.npcTypes[this.currentNPCIndex].name;
    }
    getActiveCommand() {
        if (this.activeCommandIndex >= 0) return this.commandsOf(this.npcTypes[this.currentNPCIndex])[this.activeCommandIndex]?.name ?? null;
        return null;
    }
    // Forget the pick and the hover. The pick's FLASH is left to finish -- it is what the player
    // sees of their choice as the wheel goes.
    clearSelection() {
        this.activeCommandIndex = -1;
        this.hubHovered = false;
        // A wheel on its way out keeps the picked wedge lit until it has gone.
        if (this.phase !== "closing") this.hoveredCommandIndex = -1;
    }
    // Bind the wheel to a single NPC and lock it to that NPC's role page. Used when the wheel is
    // opened from an entity's command button (server tells us which role).
    bindToEntity(targetEntityId, role, commands) {
        if (role === "lord" && !this.npcTypes.some((npc)=>npc.name === "lord")) this.npcTypes.push({
            name: "lord",
            displayName: "Lord",
            commands: [
                {
                    name: "lord:follow",
                    displayName: "Follow Me"
                },
                {
                    name: $7676384fbaf9cdf2$export$11a82d7ea0e09596,
                    displayName: "Hold Position"
                },
                {
                    name: "lord:seek_fire",
                    displayName: "Seek fire"
                },
                {
                    name: "lord:watch",
                    displayName: "Watch"
                }
            ]
        });
        this.commandOverride = commands;
        this.targetEntityId = targetEntityId;
        this.roleLocked = true;
        const roleIndex = this.npcTypes.findIndex((npc)=>npc.name === role);
        this.currentNPCIndex = roleIndex >= 0 ? roleIndex : this.currentNPCIndex;
        if (role !== "lord") this.rolePageIndex = this.currentNPCIndex;
        this.resetPointerState();
        this.layout();
        this.replayRevealIfOpen();
    }
    // Bind the wheel to one entity's interactions: a synthetic single page whose "commands" are the
    // interaction types, locked (there is nothing to switch to). Reusing the role wheel's page shape
    // means the geometry, slice drawing, hover/selection states and motion all come for free; the
    // only thing gui_manager has to know is that a selection on the INTERACTION_PAGE page is an
    // interaction rather than a squad command.
    bindToInteractions(targetEntityId, commands, emoji = "\u270B", compact = false) {
        this.commandOverride = undefined;
        this.targetEntityId = targetEntityId;
        this.roleLocked = true;
        this.npcTypes = [
            ...this.npcTypes.filter((npc)=>npc.name !== $7676384fbaf9cdf2$export$f672e119ffb748dd),
            {
                name: $7676384fbaf9cdf2$export$f672e119ffb748dd,
                displayName: "Interactions",
                emoji: emoji,
                commands: compact ? commands.slice(0, 1) : commands
            }
        ];
        this.currentNPCIndex = this.npcTypes.length - 1;
        this.resetPointerState();
        this.layout();
        this.replayRevealIfOpen();
    }
    // A small medallion and one readable plaque. The entire disc, including its centre, picks
    // the sole command; the normal wheel keeps its role-switching hub and surrounding slices.
    bindToSingleInteraction(targetEntityId, command) {
        this.bindToInteractions(targetEntityId, [
            command
        ], "\u270B", true);
    }
    // Return to the global (broadcast) wheel: no bound entity, role switching re-enabled.
    clearTarget() {
        const wasLocked = this.roleLocked;
        this.commandOverride = undefined;
        this.targetEntityId = undefined;
        this.roleLocked = false;
        // Drop any synthetic interaction page so the global (Control-key) wheel can't cycle onto one
        // entity's verbs, and so the switch counts roles again.
        const hadInteractions = this.npcTypes.some((npc)=>npc.name === $7676384fbaf9cdf2$export$f672e119ffb748dd || npc.name === "lord");
        if (hadInteractions) {
            this.npcTypes = this.npcTypes.filter((npc)=>npc.name !== $7676384fbaf9cdf2$export$f672e119ffb748dd && npc.name !== "lord");
            this.currentNPCIndex = Math.min(this.rolePageIndex, this.npcTypes.length - 1);
        }
        if (wasLocked || hadInteractions) this.requestLayout();
    }
    // Re-bound while already up (another member tapped, or the player walked into reach of a verb):
    // the orders are new, so they arrive the way the first ones did.
    replayRevealIfOpen() {
        if (this.opened && this.phase !== "closing") {
            this.revealMs = 0;
            this.paint();
        }
    }
    resetPointerState() {
        this.activeCommandIndex = -1;
        this.hoveredCommandIndex = -1;
        this.hubHovered = false;
        this.flashIndex = -1;
        this.needleAlpha = 0;
        this.hubGlow = 0;
    }
    getTargetEntityId() {
        return this.targetEntityId;
    }
    // Where a pointer goes to pick `command` on the page showing -- its glyph, in the wheel's own
    // coordinates -- or undefined when the page does not offer it. For a demonstration working the
    // wheel (gui/forager_tutorial.ts), which aims by the real layout rather than a copy of it.
    aimAt(command) {
        const slice = this.slices.find((next)=>next.command.name === command);
        return slice && {
            x: Math.cos(slice.angle) * this.iconRadius,
            y: Math.sin(slice.angle) * this.iconRadius
        };
    }
    setVisible(visible) {
        if (visible) this.fadeIn();
        else this.fadeOut();
    }
    // Whether the wheel is logically open — true from the moment it starts opening until it starts
    // closing. Use this (not `.visible`) for input gating so releasing the wheel frees clicks
    // immediately rather than after the exit has played.
    isOpen() {
        return this.opened;
    }
    // Bring the wheel up: it pops open and its orders fan out. Interrupting a close picks up from the
    // current fade rather than snapping.
    fadeIn() {
        if (this.opened && this.phase !== "closing") return;
        this.opened = true;
        this.interactive = true;
        if (this.layoutPending) this.layout();
        const reopening = this.phase === "closing" && this.visible;
        this.phase = "opening";
        this.phaseMs = reopening ? $7676384fbaf9cdf2$var$OPEN_MS * $7676384fbaf9cdf2$var$clamp01(this.alpha) : 0;
        this.commitClose = false;
        this.flashIndex = -1;
        // The orders fan out on every open, a re-open mid-exit included: whatever is coming up may
        // be a different member's.
        this.revealMs = 0;
        if (!reopening) {
            this.needleAlpha = 0;
            this.slices.forEach((slice)=>slice.glow = 0);
        }
        this.visible = true;
        this.paint();
    }
    // Put the wheel away. A wheel carrying a fresh pick holds its flash a beat and lifts away; any
    // other close sinks back. Either way it stops taking presses at once.
    fadeOut() {
        this.opened = false;
        if (!this.visible || this.phase === "closing") return;
        this.interactive = false;
        this.commitClose = this.flashIndex >= 0;
        this.phase = "closing";
        this.phaseMs = 0;
        this.setHover(this.commitClose ? this.flashIndex : -1, false);
    }
    finishClose() {
        this.phase = "closed";
        this.visible = false;
        this.alpha = 1;
        this.interactive = true;
        this.flashIndex = -1;
        this.revealMs = undefined;
        this.resetPointerState();
        this.slices.forEach((slice)=>slice.glow = 0);
        if (this.layoutPending) this.layout();
        else this.paint();
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
// The flora tiles the world is decorated with, and the one arithmetic fact needed to recognise them
// again on the client.
//
// These indices MATCH the game's own procedural biome generators (packages/tools/src/mapgen/biomes),
// which is what makes ember decoration read like the rest of the world. Most live in the
// "lpc-flowers-plants-fungi-wood" tileset; the small terrain flowers live in "lpc-terrain".
//
// Layer conventions follow the game too: flat vegetation the player walks in front of (bushes, flower
// patches, small flowers) goes on map2, tall grass that y-sorts like a plant -- you can stand behind
// it -- goes on the entity-tile surface (map3, same layer as trees), and fine forest litter goes on
// map4. All are purely cosmetic and non-blocking.
const $757b61c60f0c23c3$export$fae1c8fa1221db37 = "lpc-flowers-plants-fungi-wood";
const $757b61c60f0c23c3$export$417c9cba6e63b540 = "lpc-terrain";
const $757b61c60f0c23c3$export$10eda66a00e50d39 = 227 // dense tall-grass fill -- addLongGrass' 95% pick
;
const $757b61c60f0c23c3$export$3e2090e8a40a2fc7 = [
    160,
    161,
    162,
    177,
    178
] // sparser tufts -- addLongGrass' 5% variety
;
const $757b61c60f0c23c3$export$fef0c43d58791281 = 179 // the `grassSprout` entity tile -- a planted seed's first shoot
;
const $757b61c60f0c23c3$export$1ce2c088de1b2a1c = [
    376,
    412,
    412,
    408
] // leafy/round shrubs, per Plains biome (412 weighted)
;
const $757b61c60f0c23c3$export$c13ebf3c1e690fc9 = [
    29,
    45
] // yellow / white flower patches, per Plains biome
;
const $757b61c60f0c23c3$export$e8b67ad437d4386e = [
    355,
    356,
    357
] // small red wildflowers (lpc-terrain), per Plains
;
const $757b61c60f0c23c3$export$dc6dd3abed284b2f = [
    35,
    59,
    43
];
const $757b61c60f0c23c3$export$c5676199efd017fe = [
    452,
    436,
    421
] // forest-floor twigs, per Forest biome
;
const $757b61c60f0c23c3$export$e9f428948ba22692 = [
    353,
    354,
    355
] // forest-floor mushrooms (the mushroom items' tiles)
;
const $757b61c60f0c23c3$export$d3d0e78acd285e01 = 95;
const $757b61c60f0c23c3$export$45f49b790a1a8487 = [
    ...$757b61c60f0c23c3$export$1ce2c088de1b2a1c,
    ...$757b61c60f0c23c3$export$3e2090e8a40a2fc7
];
const $757b61c60f0c23c3$export$a58c1b30fee75ddd = [
    $757b61c60f0c23c3$export$10eda66a00e50d39,
    ...$757b61c60f0c23c3$export$45f49b790a1a8487
];
const $757b61c60f0c23c3$export$b5fe4f8e2269498c = (tilesetId, tilePos)=>`${tilesetId}-${tilePos + 1}`;
const $757b61c60f0c23c3$export$480d4dd19409d344 = (tilesetId, tilePositions)=>tilePositions.map((tilePos)=>$757b61c60f0c23c3$export$b5fe4f8e2269498c(tilesetId, tilePos));
const $757b61c60f0c23c3$export$b084f1e02cb68e73 = 4.5;
const $757b61c60f0c23c3$export$ceb64c57b30dcebb = 1.6;
const $757b61c60f0c23c3$export$33e4a0514d95213f = [
    {
        tilesetId: $757b61c60f0c23c3$export$fae1c8fa1221db37,
        tilePositions: [
            $757b61c60f0c23c3$export$10eda66a00e50d39
        ],
        lean: $757b61c60f0c23c3$export$b084f1e02cb68e73
    },
    {
        tilesetId: $757b61c60f0c23c3$export$fae1c8fa1221db37,
        tilePositions: $757b61c60f0c23c3$export$3e2090e8a40a2fc7,
        lean: 2.8
    },
    {
        tilesetId: $757b61c60f0c23c3$export$fae1c8fa1221db37,
        tilePositions: [
            $757b61c60f0c23c3$export$fef0c43d58791281
        ],
        lean: $757b61c60f0c23c3$export$ceb64c57b30dcebb
    }
];
const $757b61c60f0c23c3$export$166f49b89327c25e = $757b61c60f0c23c3$export$33e4a0514d95213f.reduce((acc, { tilesetId: tilesetId, tilePositions: tilePositions, lean: lean })=>{
    $757b61c60f0c23c3$export$480d4dd19409d344(tilesetId, tilePositions).forEach((id)=>{
        acc[id] = lean;
    });
    return acc;
}, {});



// Shared by generation and client foot effects without importing the map builder into the browser.
const $4bd29aa0ad024b1a$export$2ccb78d34d8ca692 = 64;
const $4bd29aa0ad024b1a$export$798a18eef96f6654 = 4;
const $4bd29aa0ad024b1a$export$22eaffaa6720af8d = 353;
const $4bd29aa0ad024b1a$export$70f2d5257cd47caa = 80;
const $4bd29aa0ad024b1a$export$a8fc6a6a0971c16b = 96;
const $4bd29aa0ad024b1a$export$1b236937a10ba549 = 256;
const $4bd29aa0ad024b1a$export$e75ba0b9760753fb = 116000;
const $4bd29aa0ad024b1a$export$2103197717f60650 = 4096;
const $4bd29aa0ad024b1a$export$beabf976286e7f48 = {
    dense: 0,
    medium: 1,
    quiet: 2,
    border: 3
};
const $4bd29aa0ad024b1a$export$74b058a172548435 = (x, y, corners)=>(corners[0] + corners[1] * 4 + corners[2] * 16 + corners[3] * 64) * 16 + y % $4bd29aa0ad024b1a$export$798a18eef96f6654 * $4bd29aa0ad024b1a$export$798a18eef96f6654 + x % $4bd29aa0ad024b1a$export$798a18eef96f6654;
const $4bd29aa0ad024b1a$export$6b5b23411b38d591 = (x, y, quietCorners = 0)=>{
    const phase = y % $4bd29aa0ad024b1a$export$798a18eef96f6654 * $4bd29aa0ad024b1a$export$798a18eef96f6654 + x % $4bd29aa0ad024b1a$export$798a18eef96f6654;
    const start = quietCorners === 0 ? $4bd29aa0ad024b1a$export$2ccb78d34d8ca692 : quietCorners === 15 ? $4bd29aa0ad024b1a$export$70f2d5257cd47caa : $4bd29aa0ad024b1a$export$a8fc6a6a0971c16b + (quietCorners - 1) * 16;
    return start + phase;
};



// The forest-dirt tileset's layout, shared by generation (forest_dirt_ground.ts) and the client's ground
// effects without importing the map builder into the browser. Mirrors packages/tools/src/dirt/gen.py;
// forest_dirt_ground.test.ts pins it against the packed atlas.
const $4c9bb75d811418df$export$f455fb0aef93a5d4 = "forest-dirt";
const $4c9bb75d811418df$export$d8f0229fa99a3089 = 16 // 4x4 cells of a 128px texture
;
const $4c9bb75d811418df$export$796746bd321adcc = 4 // 2x2 cells of a 64px texture
;
const $4c9bb75d811418df$export$c5dacc6f7c4ec5ad = 81 * $4c9bb75d811418df$export$d8f0229fa99a3089 // 1296
;
const $4c9bb75d811418df$export$3489cd132588f268 = $4c9bb75d811418df$export$c5dacc6f7c4ec5ad + 625 * $4c9bb75d811418df$export$796746bd321adcc // 3796
;
const $4c9bb75d811418df$export$cc360bb468edf165 = 100;
const $4c9bb75d811418df$export$d0eaa4a7b189d4a0 = {
    edge: 0,
    pebbly: 1,
    core: 2
};
const $4c9bb75d811418df$export$16d8c406f9975ec3 = (x, y, corners)=>(corners[0] + corners[1] * 3 + corners[2] * 9 + corners[3] * 27) * $4c9bb75d811418df$export$d8f0229fa99a3089 + y % 4 * 4 + x % 4;
const $4c9bb75d811418df$export$ef34ef684937d604 = (x, y, corners)=>$4c9bb75d811418df$export$c5dacc6f7c4ec5ad + (corners[0] + corners[1] * 5 + corners[2] * 25 + corners[3] * 125) * $4c9bb75d811418df$export$796746bd321adcc + y % 2 * 2 + x % 2;
const $4c9bb75d811418df$var$smooth = (t)=>t * t * (3 - 2 * t);
const $4c9bb75d811418df$export$5b896e96e6a90565 = (position, lx, ly)=>{
    if (position >= $4c9bb75d811418df$export$c5dacc6f7c4ec5ad) return $4c9bb75d811418df$export$d0eaa4a7b189d4a0.edge;
    const code = Math.floor(position / $4c9bb75d811418df$export$d8f0229fa99a3089);
    const corners = [
        code % 3,
        Math.floor(code / 3) % 3,
        Math.floor(code / 9) % 3,
        Math.floor(code / 27)
    ];
    const u = $4c9bb75d811418df$var$smooth((lx + 0.5) / 32), v = $4c9bb75d811418df$var$smooth((ly + 0.5) / 32);
    const weights = [
        (1 - u) * (1 - v),
        u * (1 - v),
        (1 - u) * v,
        u * v
    ];
    const score = [
        0,
        0,
        0
    ];
    corners.forEach((zone, i)=>score[zone] += weights[i]);
    return score.indexOf(Math.max(...score));
};



const $53604101ee77d932$export$bc4af322a9d2495a = (provider, x, y, layer)=>{
    const delta = provider.getMapDeltaAt(x, y, layer);
    return delta ? delta.removed ? 0 : Number(delta.tileId) : Number(provider.resolveTileMapFromLayerId(layer)?.[x]?.[y] || 0);
};
const $53604101ee77d932$var$masks = new Map();
let $53604101ee77d932$var$maskGeneration = -1;
const $53604101ee77d932$export$3933f388997d959a = (position)=>{
    const generation = (0, $1f08f7b8f85adf9e$export$dd4554ad7431ed50)();
    if (generation !== $53604101ee77d932$var$maskGeneration) {
        $53604101ee77d932$var$masks.clear();
        $53604101ee77d932$var$maskGeneration = generation;
    }
    const cached = $53604101ee77d932$var$masks.get(position);
    if (cached) return cached;
    const texture = (0, $1f08f7b8f85adf9e$export$42d948b5d3f64a60)((0, $4c9bb75d811418df$export$f455fb0aef93a5d4))?.textures?.[`${0, $4c9bb75d811418df$export$f455fb0aef93a5d4}-${position + 1}`];
    const source = texture?.baseTexture?.resource?.source;
    if (!texture || !source) return undefined;
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const context = canvas.getContext("2d");
    if (!context) return undefined;
    const frame = texture.frame;
    context.drawImage(source, frame.x, frame.y, frame.width, frame.height, 0, 0, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    const rgba = context.getImageData(0, 0, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)).data;
    const soil = new Uint8Array((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    for(let i = 0; i < soil.length; i++)soil[i] = rgba[i * 4 + 3] > 128 ? 1 : 0;
    $53604101ee77d932$var$masks.set(position, soil);
    return soil;
};
const $53604101ee77d932$export$b2983f57d957d182 = (provider, gid)=>{
    const sheet = provider.resolveTileSet(String(gid));
    const position = gid - (sheet?.firstGid ?? 0);
    return sheet?.tilesetId === (0, $4c9bb75d811418df$export$f455fb0aef93a5d4) && position >= (0, $4c9bb75d811418df$export$c5dacc6f7c4ec5ad) ? position : undefined;
};
const $53604101ee77d932$var$pixelIn = (p)=>(Math.floor(p) % (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) % (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
const $53604101ee77d932$export$c3f44e35c652ea6f = (position, px, py)=>{
    const soil = $53604101ee77d932$export$3933f388997d959a(position);
    return soil && soil[$53604101ee77d932$var$pixelIn(py) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + $53604101ee77d932$var$pixelIn(px)] === 1;
};
const $53604101ee77d932$export$3d7a3cc7a3c1b108 = (provider, px, py)=>{
    if (!provider) return undefined;
    const x = Math.floor(px / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), y = Math.floor(py / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    const overlay = $53604101ee77d932$export$bc4af322a9d2495a(provider, x, y, "map2");
    if (overlay) {
        const edge = $53604101ee77d932$export$b2983f57d957d182(provider, overlay);
        return edge !== undefined && $53604101ee77d932$export$c3f44e35c652ea6f(edge, px, py) ? (0, $4c9bb75d811418df$export$d0eaa4a7b189d4a0).edge : undefined;
    }
    const gid = $53604101ee77d932$export$bc4af322a9d2495a(provider, x, y, "map1");
    if (!gid) return undefined;
    const sheet = provider.resolveTileSet(String(gid));
    if (!sheet) return undefined;
    const position = gid - sheet.firstGid;
    if (sheet.tilesetId === (0, $4c9bb75d811418df$export$f455fb0aef93a5d4) && position >= 0 && position < (0, $4c9bb75d811418df$export$c5dacc6f7c4ec5ad)) return (0, $4c9bb75d811418df$export$5b896e96e6a90565)(position, $53604101ee77d932$var$pixelIn(px), $53604101ee77d932$var$pixelIn(py));
    if (sheet.tilesetId === "lpc-terrain" && position === (0, $4c9bb75d811418df$export$cc360bb468edf165)) return (0, $4c9bb75d811418df$export$d0eaa4a7b189d4a0).pebbly;
    return undefined;
};



/**
 * Whether a world point is water, for things that are not the water layer -- the grass round a body's
 * feet, its footsteps. The water layer (water_layer.ts) publishes its BAKED shore per room once it has one,
 * so they follow the drawn edge; before that they fall back to the room's water cells.
 */ const $3895eb5d0ddb7972$var$presence = new Map();
const $3895eb5d0ddb7972$export$258bb248e3fac37b = (roomId, at)=>{
    if (at) $3895eb5d0ddb7972$var$presence.set(roomId, at);
    else $3895eb5d0ddb7972$var$presence.delete(roomId);
};
const $3895eb5d0ddb7972$export$36672f1fcfb01da4 = (source, px, py)=>{
    if (!source) return false;
    const baked = source.roomId ? $3895eb5d0ddb7972$var$presence.get(source.roomId) : undefined;
    if (baked) return baked(px, py);
    const v = source.getWaterLayer?.()?.[Math.floor(px / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))]?.[Math.floor(py / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))];
    return !!v && v !== "0";
};


const $7ea6fc60f5974fdd$export$920f903c798ad6e9 = (provider, px, py)=>{
    if (!provider) return false;
    // The grass under a pond is still grass on map1; the water over it is not.
    if ((0, $3895eb5d0ddb7972$export$36672f1fcfb01da4)(provider, px, py)) return false;
    const x = Math.floor(px / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), y = Math.floor(py / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    const tile = (layer)=>(0, $53604101ee77d932$export$bc4af322a9d2495a)(provider, x, y, layer);
    const overlay = tile("map2");
    if (overlay) {
        const sheet = provider.resolveTileSet(String(overlay));
        const flower = sheet?.tilesetId === (0, $757b61c60f0c23c3$export$fae1c8fa1221db37) && [
            ...(0, $757b61c60f0c23c3$export$c13ebf3c1e690fc9),
            ...(0, $757b61c60f0c23c3$export$dc6dd3abed284b2f)
        ].includes(overlay - sheet.firstGid);
        // A forest-dirt edge is transparent on its grass side: the grass under it is what shows there.
        const dirtEdge = (0, $53604101ee77d932$export$b2983f57d957d182)(provider, overlay);
        if (!flower && (dirtEdge === undefined || (0, $53604101ee77d932$export$c3f44e35c652ea6f)(dirtEdge, px, py) !== false)) return false;
    }
    const gid = tile("map1");
    if (!gid) return false;
    const sheet = provider.resolveTileSet(String(gid));
    if (!sheet) return false;
    const position = gid - sheet.firstGid;
    return sheet.tilesetId === "forest-grass" && position >= 0 && position < (0, $4bd29aa0ad024b1a$export$2103197717f60650) || sheet.tilesetId === "lpc-terrain" && position === (0, $4bd29aa0ad024b1a$export$22eaffaa6720af8d) || sheet.tilesetId === "authored-terrain" && position >= (0, $4bd29aa0ad024b1a$export$2ccb78d34d8ca692) && position < (0, $4bd29aa0ad024b1a$export$2ccb78d34d8ca692) + (0, $4bd29aa0ad024b1a$export$1b236937a10ba549);
};
const $7ea6fc60f5974fdd$var$RECOVERY_MS = 280;
const $7ea6fc60f5974fdd$var$MAX_PATCHES = 96;
const $7ea6fc60f5974fdd$export$e4c6bb257db2e291 = (angle, scale)=>{
    const dx = Math.cos(angle), dy = Math.sin(angle);
    const sideView = Math.abs(dx) > Math.abs(dy);
    const acrossX = -dy * 3.5 + (sideView ? dx : 0);
    const acrossY = sideView ? dx * 1.75 : 0;
    return [
        -1,
        1
    ].map((side)=>({
            x: acrossX * side * scale,
            y: acrossY * side * scale,
            size: sideView && acrossY * side < 0 ? 0.75 : 1
        }));
};
class $7ea6fc60f5974fdd$export$472ad0d38cb45514 {
    constructor(surface, onGrass){
        this.surface = surface;
        this.onGrass = onGrass;
        this.feet = new Map();
        this.seen = new Set();
        this.patches = [];
    }
    beginFrame(roomId) {
        if (this.roomId !== roomId) {
            this.clear();
            this.roomId = roomId;
        }
        this.seen.clear();
    }
    contact(id, contact, now = performance.now()) {
        const { x: x, y: y, scale: scale, zIndex: zIndex, alpha: alpha, moving: moving } = contact;
        const angle = Number.isFinite(contact.angle) ? contact.angle : Math.PI / 2;
        const lean = -Math.cos(Number.isFinite(contact.travelAngle) ? contact.travelAngle : angle);
        const soles = $7ea6fc60f5974fdd$export$e4c6bb257db2e291(angle, scale);
        const left = this.onGrass(x + soles[0].x, y + soles[0].y);
        const right = this.onGrass(x + soles[1].x, y + soles[1].y);
        if (!left && !right) {
            this.remove(id);
            return;
        }
        this.seen.add(id);
        let feet = this.feet.get(id);
        if (!feet) {
            feet = {
                art: this.art(),
                x: x,
                y: y,
                distance: 0,
                side: -1,
                stepMs: now - 150
            };
            this.feet.set(id, feet);
        }
        const distance = Math.hypot(x - feet.x, y - feet.y);
        // Teleports and re-entry do not stamp a backlog of footsteps.
        if (moving && distance < 32) feet.distance += distance;
        else feet.distance = 0;
        if (feet.distance >= 9 * scale && now - feet.stepMs >= 90) {
            const side = feet.side;
            if ((side < 0 ? left : right) && this.patches.length < $7ea6fc60f5974fdd$var$MAX_PATCHES) {
                const art = this.art();
                art.zIndex = zIndex - 0.01;
                art.alpha = alpha * 0.7;
                const sole = soles[side < 0 ? 0 : 1];
                this.patches.push({
                    art: art,
                    x: x + sole.x,
                    y: y + sole.y,
                    scale: scale * sole.size,
                    lean: lean,
                    born: now,
                    alpha: alpha
                });
            }
            feet.side = -side;
            feet.distance = 0;
            feet.stepMs = now;
        }
        feet.x = x;
        feet.y = y;
        feet.art.clear();
        feet.art.position.set(Math.round(x), Math.round(y));
        feet.art.zIndex = zIndex + 0.01;
        feet.art.alpha = alpha * 0.85;
        const bend = moving ? Math.max(0, 1 - (now - feet.stepMs) / $7ea6fc60f5974fdd$var$RECOVERY_MS) : 0;
        if (left) this.blades(feet.art, soles[0].x, soles[0].y, scale * soles[0].size, feet.side === 1 ? bend : 0, lean);
        if (right) this.blades(feet.art, soles[1].x, soles[1].y, scale * soles[1].size, feet.side === -1 ? bend : 0, lean);
    }
    endFrame(now = performance.now()) {
        for (const id of this.feet.keys())if (!this.seen.has(id)) this.remove(id);
        this.patches = this.patches.filter((patch)=>{
            const age = (now - patch.born) / $7ea6fc60f5974fdd$var$RECOVERY_MS;
            if (age >= 1 || !this.onGrass(patch.x, patch.y)) {
                patch.art.destroy();
                return false;
            }
            patch.art.clear();
            patch.art.position.set(Math.round(patch.x), Math.round(patch.y));
            this.blades(patch.art, 0, 0, patch.scale, 1 - age, patch.lean);
            patch.art.alpha = patch.alpha * 0.65 * (1 - age);
            return true;
        });
    }
    remove(id) {
        this.feet.get(id)?.art.destroy();
        this.feet.delete(id);
    }
    clear() {
        for (const id of this.feet.keys())this.remove(id);
        this.patches.forEach((patch)=>patch.art.destroy());
        this.patches = [];
    }
    art() {
        const art = new (0, $gwPoJ.Graphics)();
        this.surface.addChild(art);
        return art;
    }
    blades(art, x, y, scale, bend, side) {
        const colors = [
            0x438c39,
            0x81b64e,
            0x559847
        ];
        // Roots sit slightly in front of the sole, on the ground. Only blade tips cover the shoe.
        const ground = Math.round(y + 2 * scale);
        art.beginFill(0x327d3b, 0.65);
        art.drawRect(Math.round(x - 3 * scale), ground - 1, Math.max(1, 7 * scale), 1);
        art.endFill();
        for(let i = 0; i < 3; i++){
            const root = Math.round(x + (i - 1) * 2 * scale);
            const height = Math.max(1, Math.round((i === 1 ? 3 : 2) * scale * (1 - bend * 0.65)));
            const lean = Math.round(bend * side * 2 * scale);
            art.beginFill(colors[i]);
            art.drawRect(root, ground - 1, Math.max(1, scale), 1);
            art.drawRect(root + lean, ground - height, Math.max(1, scale), height);
            art.endFill();
        }
    }
}






// How long after a campfire_fed / campfire_lit a fire that appears still flares (see flareFires).
const $3de7f2d858d8583e$var$FIRE_FLARE_PENDING_MS = 2000;
// How long an entity stays "pointed at" after the pointer leaves it. There are no interaction icons
// to travel onto any more, but the grace period still absorbs the pointer flicking across a gap in
// an entity's hit area, and it keeps the hide self-healing if a pointer-out event is ever dropped.
const $3de7f2d858d8583e$var$INTERACTION_HOVER_GRACE_MS = 150;
// Touch has no hover, so the interactable nearest the player is focused instead: it takes the same
// outline the pointer would give it, which is the only cue a tap has anything to activate. Recomputed
// on this interval rather than per frame -- it walks the room's interactable entities.
const $3de7f2d858d8583e$var$FOCUS_SCAN_INTERVAL_MS = 200;
// How close the player has to be for an entity to become the focused one. Generous compared with the
// server's own reach checks (1.5-2 tiles), so the outline appears slightly before the interaction
// would actually succeed rather than after.
const $3de7f2d858d8583e$var$FOCUS_RANGE = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 2.5;
const $3de7f2d858d8583e$export$7250836c183fa0a2 = [
    "move",
    "idle",
    "attack"
];
const $3de7f2d858d8583e$var$HUD_ENTITY_FIELDS = [
    "name",
    "hp",
    "hunger",
    "maxHunger",
    "maxHp",
    "mana",
    "downed",
    "upgradePoints"
];
class $3de7f2d858d8583e$export$b797a3cc601f36f1 {
    constructor(surface, minimapSurface, worldOverlaySurface, logic, clientRenderer, app){
        this.visuals = new (0, $e016b4679cd99b2f$export$c04a1bedc59d4447)();
        this.entityIdToRenderable = {};
        this.localEntityMetaCache = {};
        // Last interaction list the server told us about, keyed by entityId and cached
        // independently of the renderable. The list can arrive (proactive broadcast or the
        // response to a hover re-request) before the client has built the entity's renderable,
        // so it is stashed here and applied whenever the renderable turns up. This cache is also
        // what decides, locally and with no round trip, what a tap on the entity does: see
        // resolveInteractions in game-common and PlayerController's press arbitration.
        this.collidingInteractionEntities = new Set();
        this.defaultInteractionWheels = new Map();
        this.defaultInteractionLabels = new Map();
        this.entityIdToInteractions = {};
        this.lastFocusScanTs = 0;
        this.lights = new (0, $cb689cfa16c444ba$export$ccc1bed6c7489102)();
        this.sceneLights = new (0, $cb689cfa16c444ba$export$ccc1bed6c7489102)();
        // A renderable is only ever hidden by render(), and the render loop only calls render() for
        // the entities in that frame's culled set. An entity that leaves the set between two frames --
        // it wandered out of the viewport, or the follow-cam PiP stopped feeding its neighborhood --
        // was therefore never told to hide, and its sprite stayed drawn at the position it was last
        // rendered at while the real entity moved on: the "ghost" NPC. These two sets let
        // beginFrame/endFrame hide anything that was on screen last frame and went unrendered this one.
        this.shownEntityIds = new Set();
        this.renderedThisFrame = new Set();
        // Keep completion until entity removal: stale snapshots and art rebuilds must not replay an arrival.
        this.completedPreSpawnEffects = new Set();
        this.preSpawnEffects = new Map();
        this.levelTransferArt = new Map();
        this.reusedLevelArt = new WeakSet();
        this.transferringLevel = false;
        this.beginLevelTransfer = (enabled, elevationChange = 0)=>{
            this.clearLevelTransferArt();
            this.transferringLevel = enabled;
            this.playerLightHandoff = undefined;
            const id = this.logic.playerEntity?.entityId;
            const light = id && this.lights.get(id);
            if (enabled && light) {
                // The destination's local coordinates shift along with the camera.
                // Preserve the carried light's screen position while arrival data is in flight.
                this.lights.set(id, {
                    ...light,
                    location: {
                        x: light.location.x,
                        y: light.location.y + elevationChange
                    }
                });
                this.playerLightHandoff = {};
            }
        };
        this.endLevelTransfer = ()=>{
            this.transferringLevel = false;
            // Active-room entities follow the map packet. Give those messages time to adopt
            // the already drawn bodies; discard anything no longer in either snapshot.
            this.levelTransferExpiry = setTimeout(()=>this.clearLevelTransferArt(), 1000);
        };
        this.clearLevelTransferArt = ()=>{
            if (this.levelTransferExpiry !== undefined) clearTimeout(this.levelTransferExpiry);
            this.levelTransferExpiry = undefined;
            this.levelTransferArt.forEach((sprite)=>{
                sprite.cleanup();
                sprite.destroy({
                    children: true
                });
            });
            this.levelTransferArt.clear();
        };
        /** Filters whose shaders are worth compiling at startup (see warmFilterShaders). */ this.warmableFilters = ()=>[
                this.playerOcclusionOutline.filter
            ];
        this.retainLevelEntity = (entity, sprite)=>{
            if (entity.stairTravel?.projection || !this.transferringLevel || !(sprite instanceof (0, $64e038f1765e0ab3$export$f3390963b1a1dc25))) return false;
            sprite.detachWorldOverlayItem();
            sprite.parent?.removeChild(sprite);
            this.levelTransferArt.set(entity.entityId, sprite);
            return true;
        };
        this.takeLevelEntity = (entity)=>{
            if (entity.stairTravel?.projection) return undefined;
            const sprite = this.levelTransferArt.get(entity.entityId);
            if (!sprite) return undefined;
            this.levelTransferArt.delete(entity.entityId);
            this.reusedLevelArt.add(sprite);
            sprite.alpha = 1;
            sprite.interactiveChildren = true;
            return sprite;
        };
        // The fires on this floor, whose light is animated per frame rather than set per server message
        // (see LivingFirelight), and until when a fire that turns up should flare as it appears: the
        // campfire_lit sound can land before a relit fire's entity does.
        this.fires = new Set();
        this.firelight = new (0, $d4c6e028323d16a7$export$8bdb2d278338129e)();
        this.fireFlareUntil = 0;
        this.init = ()=>{
        // noop, todo?
        };
        this.cacheEntity = (entity)=>{
            const item = {
                name: entity.name,
                hp: entity.hp,
                hunger: entity.hunger,
                maxHunger: entity.maxHunger,
                maxHp: entity.maxHp,
                mana: entity.mana,
                visible: entity.visible,
                downed: entity.downed,
                upgradePoints: entity.upgradePoints,
                x: entity.location.x,
                y: entity.location.y,
                clickable: entity.clickable,
                apperanceKey: this.computeAppearanceKey(entity)
            };
            this.localEntityMetaCache[entity.entityId] = item;
            return item;
        };
        this.computeAppearanceKey = (0, $6025e3108d833e99$export$e4a173e8d3dd312c);
        this.isPaperdollDifferent = (cachedEntity, entity)=>{
            return cachedEntity.apperanceKey !== this.computeAppearanceKey(entity);
        };
        this.renderEntity = (entity, meta)=>{
            const retained = this.takeLevelEntity(entity);
            if (retained) return retained;
            let renderable;
            switch(entity.npcType){
                case "flag":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        color: entity.color,
                        name: "flag",
                        scale: 0.6,
                        animated: true
                    });
                    break;
                case "spawner":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        color: 0xffffff,
                        name: "spawner",
                        scale: 2.0,
                        animated: true
                    });
                    break;
                case "bomb":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        color: 0xffffff,
                        name: "bomb.png",
                        scale: 1.0,
                        animated: false,
                        rotating: true,
                        ...meta || {}
                    });
                    break;
                case "emp":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        color: 0xffffff,
                        name: "emp.png",
                        scale: 1.0,
                        animated: false,
                        rotating: true
                    });
                    break;
                case "sign":
                    renderable = new (0, $a326659fb0a13e91$export$b0c249583f27a2b9)({
                        color: entity.color,
                        name: "sign.png",
                        scale: 0.55,
                        animated: false
                    });
                    break;
                case "goal":
                    renderable = new (0, $0a6164d33da4c314$export$462e530a9b3886e4)(entity.color);
                    break;
                case "light":
                    renderable = new (0, $6d7a9fd00230699d$export$eb38fb18cfba1d64)();
                    break;
                case "door":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "arch.png",
                        scale: 2.0,
                        animated: false
                    });
                    // renderable = new BasicSprite(entity.color, "arch", 2)
                    renderable.zIndex = 1000000;
                    break;
                case "lock":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "lock.png",
                        scale: 0.5,
                        animated: false
                    });
                    break;
                case "fire":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        color: 0xff0000,
                        name: "fire",
                        scale: 1.0,
                        animated: true
                    });
                    break;
                case "health":
                    renderable = new (0, $0ecb2be6c709254f$export$2d9ac7aa84f97a08)(0x00ff00, true);
                    break;
                case "mana":
                    renderable = new (0, $0ecb2be6c709254f$export$2d9ac7aa84f97a08)(0x399cbd, true);
                    break;
                case "outpost":
                    renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: entity.spriteId,
                        scale: 1.0,
                        color: 0xffffff,
                        rotating: entity.expirationTs !== undefined
                    });
                    break;
                default:
                    renderable = new (0, $64e038f1765e0ab3$export$f3390963b1a1dc25)(entity.entityId);
            }
            return renderable;
        };
        this.createCollectableArtwork = (entity)=>{
            const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                name: entity.spriteId,
                scale: 1,
                color: 0xffffff,
                animated: false,
                supportLabel: true,
                rotating: !entity.landedArrow && entity.expirationTs !== undefined
            });
            if (entity.landedArrow) sprite.anchorAtGroundPoint();
            sprite.container.rotation = entity.movement.angle;
            if (entity.quantity) sprite.updateName(`${entity.quantity}`);
            return sprite;
        };
        /** A single artwork factory; view capabilities control hit surfaces and the local-player body. */ this.createArtwork = (entity, features, provider = this.logic.tilemapMetaProvider)=>{
            const retained = this.takeLevelEntity(entity);
            if (retained) return retained;
            let sprite;
            if (entity.areaProjectile) sprite = new (0, $b7bc9eb1ec41b826$export$f02207558548248d)(entity);
            else if (entity.entityType === "player") {
                const local = entity.entityId === this.logic.playerEntity?.entityId;
                const remote = entity.entityId !== this.logic.playerEntity?.entityId;
                sprite = new (0, $64e038f1765e0ab3$export$f3390963b1a1dc25)(entity.entityId, undefined, local, remote);
            } else if (entity.entityType === "bullet") sprite = entity.spriteId === "none" ? new (0, $6d7a9fd00230699d$export$eb38fb18cfba1d64)() : this.createBulletArtwork();
            else if (entity.npcType === "collectable") sprite = this.createCollectableArtwork(entity);
            else if (entity.npcType === "marker") {
                if (!entity.spriteId) sprite = new (0, $6d7a9fd00230699d$export$eb38fb18cfba1d64)();
                else {
                    sprite = entity.spriteId === "fire" ? new (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)() : new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: entity.spriteId,
                        scale: 1,
                        color: 0xffffff,
                        tileMapMetaProvider: provider
                    }, features.interactions, true);
                    if (sprite instanceof (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)) sprite.setSputtering(!!entity.rainDamaged);
                }
            } else if (entity.entityType === "bomb") sprite = new (0, $a372f7647b536fce$export$3a0f78411bc2215d)(entity);
            else sprite = this.renderEntity(entity);
            if (entity.npcType === "marker" || entity.entityType === "bullet") sprite.rotation = entity.movement.angle;
            if (entity.spriteScale !== undefined) sprite.updateScale(entity.spriteScale);
            sprite.updateRenderedLocationFrom(entity);
            sprite.zIndex = (0, $aa4dbab34fec03c9$export$e44b69026e85417f)(entity, sprite.defaultZIndex, provider);
            (0, $aa4dbab34fec03c9$export$1b5e6173667b4c9b)(entity, sprite, provider);
            return sprite;
        };
        /** Other floors use the same artwork with local interaction features disabled. */ this.renderSceneEntity = (entity, provider)=>this.createArtwork(entity, (0, $1704411fa88dc9bf$export$784ce4bd6fedbedf), provider);
        this.attachClickHandler = (entity, entityRenderable)=>{
            const renderable = entityRenderable.getClickSurface();
            renderable.interactive = this.shouldTakePointer(entity);
            // Re-apply whatever the server has already told us about this entity. The list can arrive
            // before the renderable exists (a proactive broadcast, or the reply to a hover request that
            // won the race), so applying it here -- at create and on every clickable change -- arms the
            // entity regardless of message ordering. Without this the entity silently stays inert until
            // some later hover happens to win the round trip, which was the intermittent "interactions
            // don't work on that one NPC".
            this.applyInteractionAffordance(entity.entityId);
            // update() re-invokes this whenever entity.clickable changes. Bind the pointer listeners
            // (and the hover-state closure below) only once per renderable -- otherwise stacked
            // listeners fight each other over the same hover state.
            if (renderable.interactionsBound) return;
            renderable.interactionsBound = true;
            // Hover state for one entity. The icons this used to arm are gone: hovering now shows the
            // entity's own name/HP and, when it has something to activate, the warm outline. The grace
            // timer on the way out is kept because it makes the hide self-healing -- a dropped
            // pointer-out still resolves to "not hovered" instead of latching the outline on forever.
            let overSelf = false;
            let hideTimer;
            const clearHideTimer = ()=>{
                if (hideTimer) {
                    clearTimeout(hideTimer);
                    hideTimer = undefined;
                }
            };
            const reconcile = ()=>{
                clearHideTimer();
                if (overSelf) {
                    entityRenderable.onMouseOver(true);
                    this.setHighlightedEntity(entity.entityId);
                } else hideTimer = setTimeout(()=>{
                    hideTimer = undefined;
                    entityRenderable.onMouseOver(false);
                    this.clearHighlightIf(entity.entityId);
                }, $3de7f2d858d8583e$var$INTERACTION_HOVER_GRACE_MS);
            };
            const pointAt = ()=>{
                overSelf = true;
                this.logic.requestEntityInteractions(entity.entityId);
                this.logic.playerController.setHoveredEntity(entity.entityId);
                reconcile();
            };
            renderable.on((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? "tap" : "mouseover", ()=>{
                pointAt();
                if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) {
                    // Touch has no mouseout; release the entity after a delay instead.
                    clearHideTimer();
                    hideTimer = setTimeout(()=>{
                        hideTimer = undefined;
                        overSelf = false;
                        this.logic.playerController.unHoveredEntity(entity.entityId);
                        reconcile();
                    }, 1500);
                }
            });
            renderable.on("mouseout", ()=>{
                overSelf = false;
                this.logic.playerController.unHoveredEntity(entity.entityId);
                reconcile();
            });
            // Secondary mouse clicks (including trackpad two-finger taps) open menus.
            // Touch waits for a long press; desktop primary presses belong to world attack.
            let touchOrigin;
            renderable.on("pointerdown", (event)=>{
                touchOrigin = event.data?.pointerType === "touch" ? {
                    x: event.data.global.x,
                    y: event.data.global.y
                } : undefined;
                this.logic.playerController.setHoveredEntity(entity.entityId);
                this.logic.playerController.beginEntityPress(entity.entityId, event.data?.pointerType || "mouse", event.data?.button || 0);
            });
            renderable.on("rightclick", (event)=>{
                event.data?.originalEvent?.preventDefault?.();
            });
            renderable.on("pointermove", (event)=>{
                if (touchOrigin && Math.hypot(event.data.global.x - touchOrigin.x, event.data.global.y - touchOrigin.y) > 12) {
                    touchOrigin = undefined;
                    this.logic.playerController.cancelEntityPress(entity.entityId);
                }
            });
            renderable.on("pointerup", ()=>{
                touchOrigin = undefined;
                this.logic.playerController.endEntityPress(entity.entityId);
            });
            renderable.on("pointercancel", ()=>{
                touchOrigin = undefined;
                this.logic.playerController.cancelEntityPress(entity.entityId);
            });
            renderable.on("pointerupoutside", ()=>{
                touchOrigin = undefined;
                this.logic.playerController.cancelEntityPress(entity.entityId);
            });
            // Entities the server has its own plans for on a plain click (collectables it picks up, the
            // outpost avatars) keep working, but only when they offer no interactions of their own --
            // otherwise a single tap would both activate an interaction and fire ENTITY_CLICKED, and the
            // two handlers would race. An entity with interactions reaches the server through
            // ACTIVATE_ENTITY_INTERACTION instead.
            const callback = ()=>{
                if (this.getEntityInteractions(entity.entityId).length > 0) return;
                this.logic.entityClicked(entity);
            };
            renderable.on("click", callback);
            renderable.on("tap", callback);
        };
        // The interactions this viewer has been offered for an entity, most-primary first. Empty for an
        // entity that offers none, which is what makes a tap on it fall through to the world action.
        //
        // You are never a target of your own interactions: hovering yourself must not light you up, and a
        // press on yourself belongs to the world action (attack/build), not to an interaction. Filtered
        // here rather than upstream because the server really does offer the player entity interactions
        // of its own -- atoms/inventory.ts puts "inventory" on it -- and this is the single funnel the
        // cursor, the outline and the press arbitration all read.
        this.getEntityInteractions = (entityId)=>{
            if (entityId === this.logic.playerEntity?.entityId) return [];
            return this.entityIdToInteractions[entityId] || [];
        };
        this.updateEntityInteractions = (entityId, interactions, colliding)=>{
            // Cached even when the renderable isn't ready yet, so attachClickHandler can re-apply it on
            // (re)creation -- see entityIdToInteractions. Normalized on the way in so a bare
            // InteractionType[] (older payload shape, or a test fixture) still works.
            this.entityIdToInteractions[entityId] = (0, $0fb3f7f2a67be6e3$export$279c35a8a516c7b3)(interactions);
            this.applyInteractionAffordance(entityId);
            if (colliding === true) this.collidingInteractionEntities.add(entityId);
            if (colliding === false) this.collidingInteractionEntities.delete(entityId);
            this.updateDefaultInteractionWheel(entityId);
        };
        this.updateDefaultInteractionWheel = (entityId)=>{
            // Building owns the world pointer, including cells beside colliding interactables. A
            // nearby medallion would otherwise take its mouse hover and stop the build cursor.
            const interaction = !this.logic.playerController?.isBuilding?.() && this.collidingInteractionEntities.has(entityId) ? (0, $0fb3f7f2a67be6e3$export$112177784473fc2f)(this.getEntityInteractions(entityId)).find((next)=>next.isDefault && !(0, $0fb3f7f2a67be6e3$export$781c5ce8077cf3d7)(next)) : undefined;
            const overlay = this.worldOverlaySurface.getEntityRenderable(entityId);
            let wheel = this.defaultInteractionWheels.get(entityId);
            if (!interaction || !overlay) {
                if (wheel) {
                    wheel.emit("pointerout");
                    wheel.destroy({
                        children: true
                    });
                    this.defaultInteractionWheels.delete(entityId);
                    this.defaultInteractionLabels.delete(entityId);
                }
                return;
            }
            if (!wheel) {
                wheel = new (0, $7676384fbaf9cdf2$export$a36bd337d7c5ab90)({
                    onHoverChange: ()=>this.logic.audio.uiHover(),
                    onCommandSelect: (command)=>{
                        const current = this.getEntityInteractions(entityId).find((next)=>next.type === command && next.isDefault && !(0, $0fb3f7f2a67be6e3$export$781c5ce8077cf3d7)(next));
                        if (this.collidingInteractionEntities.has(entityId) && current) {
                            this.logic.audio.uiSelect();
                            if (this.logic.getEmberRole(entityId) === "lord" && current.type === "command") {
                                this.logic.playerController.suppressAttack();
                                this.logic.clientRenderer.gui().showInteractionWheel(entityId, (0, $0fb3f7f2a67be6e3$export$65634e3ec6b442de)(this.getEntityInteractions(entityId)));
                            } else this.logic.interactionCallback(entityId, current.type);
                        }
                    }
                });
                let holdingMouse = false;
                wheel.on("pointerover", ()=>{
                    holdingMouse = true;
                    this.logic.playerController.enabledMouseAction(false);
                });
                wheel.on("pointerout", ()=>{
                    if (holdingMouse) this.logic.playerController.enabledMouseAction(true);
                    holdingMouse = false;
                });
                this.defaultInteractionWheels.set(entityId, wheel);
            }
            if (wheel.parent !== overlay) overlay.addChild(wheel);
            // The Lord's nearby medallion opens his primary menu; Orders remains a choice inside it.
            const displayName = this.logic.getEmberRole(entityId) === "lord" && interaction.type === "command" ? "Interact" : (0, $0fb3f7f2a67be6e3$export$84e151b22524d21c)(interaction);
            const label = `${interaction.type}:${displayName}`;
            if (this.defaultInteractionLabels.get(entityId) !== label) {
                wheel.bindToSingleInteraction(entityId, {
                    name: interaction.type,
                    displayName: displayName
                });
                wheel.fadeIn();
                this.defaultInteractionLabels.set(entityId, label);
            }
            wheel.position.set((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 4, -wheel.getExtent().bottom - 12);
        };
        // A pointer cursor is the whole desktop "you can do something here" cue now that the icons are
        // gone; the outline is the other half and comes on hover. Both are driven from the cache, so an
        // entity that gains or loses an interaction mid-session picks it up immediately -- including
        // losing the outline it is currently wearing.
        this.applyInteractionAffordance = (entityId)=>{
            const renderable = this.entityIdToRenderable[entityId];
            if (!renderable) return;
            const hasInteractions = this.getEntityInteractions(entityId).length > 0;
            const clickSurface = renderable.getClickSurface();
            if (clickSurface) {
                clickSurface.cursor = hasInteractions ? "pointer" : null;
                const entity = this.logic.getEntity(entityId);
                if (entity) clickSurface.interactive = this.shouldTakePointer(entity);
            }
            if (!hasInteractions && this.highlightedEntityId === entityId) this.clearHighlightIf(entityId);
        };
        // Whether this entity should take pointer events at all.
        //
        // Pixi hands a pointer to the TOPMOST interactive object, so an entity with nothing to offer
        // doesn't merely waste a hit test -- it HIDES whatever is under it. The ember campfire sat under
        // two such things at once: its flame is a separate decorative marker drawn over the logs, and an
        // invisible ember manager entity (the wave/spawner/tutorial controllers are all `blank-32x32.png`
        // markers parked on the camp) sits on the same tile. Between them they swallowed every hover
        // aimed at the fire, leaving only the sliver of the logs' hit box poking out past them -- which
        // is why the campfire read as having a hover target a few pixels tall.
        //
        // So a MARKER has to earn the pointer: by offering an interaction, or by having visible art that
        // a click means something on. Everything else keeps it unconditionally -- players and NPCs show a
        // name plate and HP bar on hover even when they offer nothing to activate.
        this.shouldTakePointer = (entity)=>{
            if (this.getEntityInteractions(entity.entityId).length > 0) return true;
            if (entity.npcType !== "marker") return true;
            // A blank stand-in sprite is either tile-drawn art (a chest -- which has interactions, so it
            // never reaches here) or an invisible controller. Neither is something to point at.
            const isBlank = !entity.spriteId || entity.spriteId.startsWith("blank");
            return !!entity.clickable && !isBlank;
        };
        // Only the pointed-at (or, on touch, focused) entity is outlined, and only when it has something
        // to activate -- an outline on an entity a tap would just swing at would be a lie.
        this.setHighlightedEntity = (entityId)=>{
            if (this.getEntityInteractions(entityId).length === 0) {
                this.clearHighlightIf(this.highlightedEntityId);
                return;
            }
            if (this.highlightedEntityId === entityId) return;
            this.clearHighlightIf(this.highlightedEntityId);
            this.highlightedEntityId = entityId;
            // A renderable that reports false has no art of its own to trace -- it is an invisible marker
            // standing on tile-drawn art (the V2 chest). Outline those map tiles instead, so a chest gets
            // the same glow as a person rather than a box drawn round its footprint.
            if (this.applyHighlight(entityId) === false) this.tileHighlight().set(true);
        };
        this.clearHighlightIf = (entityId)=>{
            if (!entityId || this.highlightedEntityId !== entityId) return;
            this.highlightedEntityId = undefined;
            // Not simply "off": the roster may still want this one outlined.
            this.applyHighlight(entityId);
            this.entityTileHighlight?.set(false);
        };
        // The ember roster's selected member wears the same outline as a pointed-at entity, so the card
        // and the character on screen are visibly the same person. Undefined takes it off. The glow only
        // shows while the member is actually drawn: culling strips it (see hideRenderable) and coming
        // back into view puts it back (see renderEntity), which is what makes it viewport-bound.
        this.setRosterHighlight = (entityId)=>{
            if (this.rosterHighlightId === entityId) return;
            const previous = this.rosterHighlightId;
            this.rosterHighlightId = entityId;
            this.applyHighlight(previous);
            this.applyHighlight(entityId);
            // The deselected member may be dropping back to a red problem disc rather than to nothing,
            // which is why this recomputes the tier for both rather than just clearing the old one.
            this.applyStatusHalo(previous);
            this.applyStatusHalo(entityId);
        };
        // Does this entity have ANY reason left to be outlined? Two channels feed the one glow, and the
        // renderable only holds a single on/off, so the union has to be worked out here.
        this.highlightWanted = (entityId)=>this.highlightedEntityId === entityId || this.rosterHighlightId === entityId;
        // Push that union onto one entity's renderable. Returns what the renderable reported (false =
        // no art of its own to trace), or undefined when there is nothing to push it onto. Cheap to call
        // repeatedly: EntityHighlight.set is a no-op when nothing has changed.
        this.applyHighlight = (entityId)=>{
            if (!entityId) return undefined;
            return this.entityIdToRenderable[entityId]?.setHighlighted(this.highlightWanted(entityId));
        };
        // WHICH GROUND DISC THIS BODY WEARS, if any. Two channels feed the one disc and the renderable
        // holds a single tier, so -- exactly like `highlightWanted` above -- the union is worked out
        // here rather than on the sprite.
        //
        // SELECTION WINS over a problem. The red disc is ambient: it has been there a while and will
        // still be there in a minute. The green one answers a question the player asked half a second
        // ago by tapping a card ("which of these people is that?"), and if a hungry member's card were
        // the one tapped, leaving them red would withhold the one answer they are waiting for. The card
        // they are looking at still carries the status pill saying what is wrong, so nothing is lost by
        // the red disc standing down while they look.
        this.statusHaloTierFor = (entityId)=>this.rosterHighlightId === entityId ? "selected" : (0, $83feb2ed45960f8f$export$fbb2216c6674afa7)(this.logic.getEmberStatus(entityId));
        // Push that union onto one entity's disc, and remember what was pushed so the per-frame entity
        // pass does not have to ask again. Safe to call for an entity with no renderable yet: the cache
        // is keyed independently, so the tier is simply recomputed when one turns up.
        this.applyStatusHalo = (entityId)=>{
            if (!entityId) return;
            const cached = this.localEntityMetaCache[entityId];
            const tier = this.statusHaloTierFor(entityId);
            if (cached && cached.statusHaloTier === tier) return;
            if (cached) cached.statusHaloTier = tier;
            this.entityIdToRenderable[entityId]?.updateStatusHalo(tier);
        };
        // The outline used for entities drawn as map tiles. One instance, reused: it reads the highlighted
        // entity's tiles each frame, so switching from one chest to another needs no teardown. It is
        // parented into the map's own tile surface, which is why the tile sprites' coordinates can be
        // copied straight across with no conversion.
        this.tileHighlight = ()=>{
            if (!this.entityTileHighlight) this.entityTileHighlight = new (0, $95f2390044c89843$export$b6cf31fac6564392)({
                artContainer: this.logic.clientRenderer.map().getTileSurface(),
                frame: this.highlightedEntityTileFrames,
                // Under its own tiles in the z-sorted tile surface.
                zIndex: ()=>this.highlightedEntityTileZIndex
            });
            return this.entityTileHighlight;
        };
        this.highlightedEntityTileZIndex = 0;
        // The map tiles standing in for the highlighted entity, as outline frames. Looked up per frame
        // rather than cached: a map rerender destroys and rebuilds these sprites, and a stale reference
        // would be a destroyed texture.
        this.highlightedEntityTileFrames = ()=>{
            const entityId = this.highlightedEntityId;
            if (!entityId) return [];
            const entity = this.logic.getEntity(entityId);
            if (!entity) return [];
            // Floor, not round: this is "which cell contains the entity". NB the fineToRoughCoordinates
            // exported further down this very file ROUNDS, which lands a marker sitting at its tile's
            // centre (a chest is at x*32 + 16) on the NEXT cell over -- where there are no tiles to trace.
            const tiles = this.logic.clientRenderer.map().getSpritedTilesAt(Math.floor(entity.location.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.floor(entity.location.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)));
            if (tiles.length === 0) return [];
            this.highlightedEntityTileZIndex = Math.min(...tiles.map((tile)=>tile.zIndex)) - 1;
            return tiles.map((tile)=>({
                    texture: tile.texture,
                    x: tile.x,
                    y: tile.y,
                    scaleX: tile.scale.x,
                    scaleY: tile.scale.y
                }));
        };
        // Touch substitute for hover: outline the interactable nearest the player, so a tap always has a
        // visible target. The mobile scan is throttled; collision wheels update on every platform.
        this.updateInteractionFocus = (deltaMs = 0)=>{
            this.collidingInteractionEntities.forEach(this.updateDefaultInteractionWheel);
            this.defaultInteractionWheels.forEach((wheel)=>wheel.animate(deltaMs));
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) return;
            const now = Date.now();
            if (now - this.lastFocusScanTs < $3de7f2d858d8583e$var$FOCUS_SCAN_INTERVAL_MS) return;
            this.lastFocusScanTs = now;
            const player = this.logic.playerEntity;
            if (!player) return;
            let nearestId;
            let nearestDistance = $3de7f2d858d8583e$var$FOCUS_RANGE;
            Object.keys(this.entityIdToInteractions).forEach((entityId)=>{
                if (this.entityIdToInteractions[entityId].length === 0) return;
                const entity = this.logic.getEntity(entityId);
                if (!entity || entity.entityId === player.entityId) return;
                const dx = entity.location.x - player.location.x;
                const dy = entity.location.y - player.location.y;
                const distance = Math.sqrt(dx * dx + dy * dy);
                if (distance <= nearestDistance) {
                    nearestDistance = distance;
                    nearestId = entity.entityId;
                }
            });
            if (!nearestId) {
                this.clearHighlightIf(this.highlightedEntityId);
                return;
            }
            this.setHighlightedEntity(nearestId);
        };
        // Newly created renderables start visible, so a creation that lands outside the culled set
        // has to be hidden here -- and one that lands inside has to join the shown set, or the
        // end-of-frame sweep would not know to hide it later.
        this.trackCreated = (entity, renderable, worldOverlayItem)=>{
            if (entity.interestState !== "active" || this.logic.isTooDistantFromPlayer(entity)) {
                renderable.visible = false;
                if (worldOverlayItem) worldOverlayItem.visible = false;
                return;
            }
            this.shownEntityIds.add(entity.entityId);
        };
        this.create = (entity)=>{
            this.cacheEntity(entity);
            const local = this.logic.playerEntity.entityId === entity.entityId;
            const sprite = this.createArtwork(entity, (0, $1704411fa88dc9bf$export$e5daf445bbba1e2f));
            this.entityIdToRenderable[entity.entityId] = sprite;
            this.surface.addChild(sprite);
            if (!entity.areaProjectile) this.attachClickHandler(entity, sprite);
            if (sprite instanceof (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)) {
                this.fires.add(entity.entityId);
                if (performance.now() < this.fireFlareUntil) sprite.flare();
            }
            if (sprite instanceof (0, $8b020fb41ab0fc7e$export$f90411c24f6aebf8)) {
                // Only an arrow seen leaving the bow: one first seen mid-flight has no release to light.
                const launch = sprite.launchPoint(entity);
                if (launch) this.transientLights.flash("arrow", launch.x, launch.y, {
                    angle: sprite.rotation
                });
            }
            const body = !entity.areaProjectile && ![
                "bullet",
                "bomb"
            ].includes(entity.entityType) && entity.npcType !== "collectable" && !(entity.npcType === "marker" && !entity.spriteId);
            const minimappable = entity.isPlayer() || [
                "flag",
                "goal",
                "door"
            ].includes(entity.npcType);
            if (minimappable && body) this.minimapSurface.offer(entity.entityId, local);
            if (entity.npcType === "collectable") this.worldOverlaySurface.offerDroppedItemGlint(entity.entityId, sprite);
            const overlay = body ? this.worldOverlaySurface.offer(entity) : undefined;
            if (overlay) sprite.setWorldOverlayItem(overlay);
            const reused = this.reusedLevelArt.delete(sprite);
            if (body && entity.npcType !== "marker" && !reused && !(entity.entityType === "player" && (entity.floorFall?.fromAbove || entity.stairTravel))) sprite.fadeIn();
            this.trackCreated(entity, sprite, overlay);
            return sprite;
        };
        this.get = (entity)=>{
            return this.clientRenderer.map?.().getSceneRenderable?.(entity.entityId) ?? this.entityIdToRenderable[entity.entityId];
        };
        this.createBulletArtwork = ()=>new (0, $8b020fb41ab0fc7e$export$f90411c24f6aebf8)(0xffffff, 1, (entity)=>{
                const owner = entity.ownerEntityId;
                if (!owner) return undefined;
                const source = this.clientRenderer.map?.().getSceneRenderable?.(owner) ?? this.entityIdToRenderable[owner];
                return source instanceof (0, $64e038f1765e0ab3$export$f3390963b1a1dc25) ? source.arrowLaunchOffset(entity.movement.angle) : undefined;
            });
        this.isClientPlayer = (entity)=>entity?.entityId === this.clientRenderer.logic().playerEntity.entityId;
        this.fadePlayer = (direction, ms)=>{
            const from = this.playerFadeAlpha() ?? 1;
            this.playerFade = {
                from: from,
                to: direction === "in" ? 1 : 0,
                startTs: Date.now(),
                ms: Math.max(1, ms)
            };
        };
        /** Where the fade has got to, or undefined when there is none and the body is simply drawn. */ this.playerFadeAlpha = ()=>{
            const fade = this.playerFade;
            if (!fade) return undefined;
            const t = Math.min(1, (Date.now() - fade.startTs) / fade.ms);
            const alpha = fade.from + (fade.to - fade.from) * t;
            if (t >= 1 && fade.to === 1) // Done, and done at full opacity: drop the override so `entity.visible` owns the body
            // again. A finished fade-OUT is kept, because holding the body at 0 is its whole job.
            this.playerFade = undefined;
            return alpha;
        };
        this.updateEntityId = (originalEntityId, updatedEntityId)=>{
            this.entityIdToRenderable[updatedEntityId] = this.entityIdToRenderable[originalEntityId];
            delete this.entityIdToRenderable[originalEntityId];
            this.localEntityMetaCache[updatedEntityId] = this.localEntityMetaCache[originalEntityId];
            delete this.localEntityMetaCache[originalEntityId];
            this.entityIdToInteractions[updatedEntityId] = this.entityIdToInteractions[originalEntityId];
            delete this.entityIdToInteractions[originalEntityId];
            const colliding = this.collidingInteractionEntities.delete(originalEntityId);
            this.updateDefaultInteractionWheel(originalEntityId);
            if (colliding) this.collidingInteractionEntities.add(updatedEntityId);
            this.worldOverlaySurface.updateEntityId(originalEntityId, updatedEntityId);
        };
        /** Who stood in the water last frame (see endFrame): their `wading` is cleared when they step out. */ this.wadingIds = new Set();
        this.isSubmerged = (entity)=>{
            return this.logic.tilemapMetaProvider?.isDeepAt(Math.floor(entity.location.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.floor(entity.location.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)));
        };
        this.update = (entity)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            const minimapRenderable = this.minimapSurface.get(entity.entityId);
            let cachedEntity = this.localEntityMetaCache[entity.entityId];
            if (!cachedEntity) {
                this.cacheEntity(entity);
                cachedEntity = this.localEntityMetaCache[entity.entityId];
            }
            // Game HUD and input bookkeeping stay local; artwork is updated by the shared presenter.
            const hudChanged = $3de7f2d858d8583e$var$HUD_ENTITY_FIELDS.some((key)=>cachedEntity[key] !== entity[key]);
            if (hudChanged && this.isClientPlayer(entity)) this.clientRenderer.gui().update(entity);
            if (cachedEntity.clickable !== entity.clickable) this.attachClickHandler(entity, renderable);
            if (cachedEntity.visible !== entity.visible) {
                if (minimapRenderable) minimapRenderable.visible = entity.visible;
                if (this.isClientPlayer(entity)) renderable.alpha = entity.visible ? 1 : 0;
            }
            this.visuals.update(renderable, entity, (0, $1704411fa88dc9bf$export$e5daf445bbba1e2f), {
                role: this.logic.getEmberRole(entity.entityId),
                playerId: this.logic.playerEntity.entityId,
                level: this.clientRenderer.map().getVisibility()?.enableCommandWheel ? 0 : entity.level || 1
            });
            Object.assign(cachedEntity, {
                name: entity.name,
                hp: entity.hp,
                hunger: entity.hunger,
                maxHunger: entity.maxHunger,
                maxHp: entity.maxHp,
                mana: entity.mana,
                downed: entity.downed,
                upgradePoints: entity.upgradePoints,
                clickable: entity.clickable,
                visible: entity.visible
            });
            // And the in-world ground halo that marks a member the player has to do something about.
            // Diffed off the same roster mirror as the role above, and for the same reason: neither is a
            // field on the synced entity. See MemberStatusHalo for what it is and what it deliberately
            // is not.
            this.applyStatusHalo(entity.entityId);
            // Fallen bodies sit on the floor, below standing entities regardless of their feet's y.
            // Recompute each update so getting back up restores normal depth sorting immediately.
            renderable.zIndex = (0, $aa4dbab34fec03c9$export$e44b69026e85417f)(entity, renderable.defaultZIndex, this.logic.tilemapMetaProvider);
            const locationChanged = !(cachedEntity.x === entity.location.x && cachedEntity.y === entity.location.y);
            const entityLight = this.lights.get(entity.entityId);
            const lightChanged = !this.lights.contains(entity.entityId) || entityLight?.intensity !== entity.lightIntensity() || entityLight?.radius !== entity.lightRadius();
            if (locationChanged) entity.submerged = this.isSubmerged(entity);
            // A fire's light is written every frame by animateFirelight instead.
            if (!this.isClientPlayer(entity) && !(renderable instanceof (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)) && (entity.lightMeta && (locationChanged || lightChanged) || entity.npcType === "light" && lightChanged)) {
                this.lights.set(entity.entityId, {
                    entityId: entity.entityId,
                    location: entity.location,
                    intensity: entity.lightIntensity(),
                    radius: entity.lightRadius()
                });
                cachedEntity.x = entity.location.x;
                cachedEntity.y = entity.location.y;
            }
            if (this.isClientPlayer(entity)) {
                cachedEntity.x = entity.location.x;
                cachedEntity.y = entity.location.y;
            }
            // The countdown dial over a held-interaction target (see HoldTimer). NOT diffed against the
            // cache like everything above it: the remaining time is a different number on every
            // message, which is the point -- it is what keeps the ring anchored to the server's hold.
            this.worldOverlaySurface.updateHoldTimer(entity);
            // ...and the prompt that precedes it on an injured rescue survivor (see RescueHint). Same
            // channel, same reason: the server decides when it is up, and it says so on every message.
            this.worldOverlaySurface.updateRescueHint(entity);
        };
        /** Recreate visible art at the next render boundary, preserving gameplay and interaction data.
     * Retired texture generations stay alive while transient effects can still reference them. */ this.refreshContent = ()=>{
            const interactions = {
                ...this.entityIdToInteractions
            };
            const colliding = new Set(this.collidingInteractionEntities);
            const roster = this.rosterHighlightId;
            const highlighted = this.highlightedEntityId;
            for (const id of Object.keys(this.entityIdToRenderable)){
                const entity = this.logic.getEntity(id);
                if (!entity) {
                    this.destroy({
                        entityId: id
                    });
                    continue;
                }
                const arrivalStarted = this.preSpawnEffects.has(id) || this.completedPreSpawnEffects.has(id);
                this.destroy(entity);
                if (arrivalStarted) this.completedPreSpawnEffects.add(id);
                this.entityIdToInteractions[id] = interactions[id] || [];
                if (colliding.has(id)) this.collidingInteractionEntities.add(id);
                this.create(entity);
                // create() caches the entity as it is NOW, so update() would see nothing to apply and
                // the fresh renderable would never be dressed, named or given its hp bar (a spawn gets
                // these because its appearance lands in a later message). An empty cache makes every
                // field new again.
                this.localEntityMetaCache[id] = {};
                this.update(entity);
            }
            this.rosterHighlightId = roster;
            this.highlightedEntityId = highlighted;
            for (const id of Object.keys(this.entityIdToRenderable))this.entityIdToRenderable[id].setHighlighted?.(this.highlightWanted(id));
        };
        this.destroy = (entity)=>{
            if (entity.entityId === this.logic.playerEntity?.entityId) this.playerOcclusionOutline.hide();
            delete this.localEntityMetaCache[entity.entityId];
            delete this.entityIdToInteractions[entity.entityId];
            this.collidingInteractionEntities.delete(entity.entityId);
            this.updateDefaultInteractionWheel(entity.entityId);
            this.shownEntityIds.delete(entity.entityId);
            this.renderedThisFrame.delete(entity.entityId);
            this.minimapSurface.remove(entity.entityId);
            // Release hover state so a removed entity can't leave the hover reference (used for click
            // auto-travel and press arbitration) pointing at a stale id, or world mouse actions stuck
            // disabled because it vanished mid-press.
            this.logic.playerController.clearHoverForEntity(entity.entityId);
            this.clearHighlightIf(entity.entityId);
            // A member who is gone is nobody's selection any more; leaving the id here would put the
            // glow on whatever entity is recycled into it.
            if (this.rosterHighlightId === entity.entityId) this.rosterHighlightId = undefined;
            const renderable = this.entityIdToRenderable[entity.entityId];
            if (renderable) {
                const retained = this.retainLevelEntity(entity, renderable);
                // Clean up callbacks before destroying
                if (!retained && renderable.cleanup) renderable.cleanup();
                if (!retained) renderable.remove();
                delete this.entityIdToRenderable[entity.entityId];
                if (renderable.sideCar) renderable.sideCar.remove();
            }
            this.worldOverlaySurface.remove(entity);
            this.lights.remove(entity.entityId);
            this.fires.delete(entity.entityId);
            this.firelight.remove(entity.entityId);
            this.preSpawnEffects.get(entity.entityId)?.destroy();
            this.preSpawnEffects.delete(entity.entityId);
            this.completedPreSpawnEffects.delete(entity.entityId);
            this.footDust.remove(entity.entityId);
            this.grassFeet.remove(entity.entityId);
        };
        /**
     * How many of the bodies on screen cannot draw themselves yet -- an LPC composite whose sheets
     * are still being fetched or baked is on the stage with nothing in it (see
     * LpcComposite.isReadyToShow).
     *
     * This is what a freshly loaded room is held black for: the count is read every frame while the
     * curtain is down and the screen opens when it reaches zero (see RoomReveal). "On screen" is the
     * shown set the culling pass maintains, so a camp is never held shut waiting for wildlife at the
     * other end of the map -- plus this client's own body, which render() deliberately leaves out of
     * that set and which is the one sprite the player is certain to be looking at.
     */ this.isPlayerReadyToShow = ()=>{
            const player = this.entityIdToRenderable[this.logic.playerEntity?.entityId];
            return !!player && (player.isReadyToShow?.() ?? true);
        };
        this.pendingSpriteCount = ()=>{
            let pending = 0;
            this.shownEntityIds.forEach((entityId)=>{
                const renderable = this.entityIdToRenderable[entityId];
                if (renderable?.isReadyToShow && !renderable.isReadyToShow()) pending++;
            });
            const playerEntityId = this.logic.playerEntity?.entityId;
            const player = playerEntityId ? this.entityIdToRenderable[playerEntityId] : undefined;
            if (player?.isReadyToShow && !player.isReadyToShow()) pending++;
            return pending;
        };
        // Called by the render loop around its entity pass; see shownEntityIds above.
        this.beginFrame = ()=>{
            this.renderedThisFrame.clear();
        };
        // Budget deferral skips expensive animation work, but must still place the sprite at the
        // current interpolated position and restore visibility after re-entry. No server-only flags
        // are needed to distinguish static from moving NPCs.
        this.markDeferred = (entityId)=>{
            const entity = this.logic.getEntity(entityId);
            if (!entity || entity.interestState !== "active" || this.logic.isTooDistantFromPlayer(entity)) {
                this.hideRenderable(entityId);
                return;
            }
            this.renderedThisFrame.add(entityId);
            const renderable = this.entityIdToRenderable[entityId];
            if (renderable) {
                renderable.visible = entity.visible;
                if (entity.floorFall || entity.stairTravel) (0, $a3da31b418d2b1ed$export$4725754a4127b437)(entity, renderable, this.logic.roomId, this.logic.canRenderFloorFallArrival?.() ?? true, Date.now(), this.logic.tilemapMetaProvider);
                else {
                    renderable.updateRenderedLocationFrom(entity);
                    renderable.zIndex = (0, $aa4dbab34fec03c9$export$e44b69026e85417f)(entity, renderable.defaultZIndex, this.logic.tilemapMetaProvider);
                    (0, $5af76956b9282cac$export$73f8e5a2be3bf548)(entity, renderable, Date.now(), this.logic.roomId);
                }
                this.updateRenderedPlayerLight(entity, renderable);
                this.updatePreSpawnEffect(entity, renderable);
                if (entity.visible) this.shownEntityIds.add(entityId);
                else this.shownEntityIds.delete(entityId);
            }
            this.worldOverlaySurface.updateEntity(entity);
        };
        this.endFrame = ()=>{
            // Lay down any footfalls that have come due and settle the dust already on the ground. It
            // runs before the early return below: a frame that rendered no entities still has to
            // advance a trail somebody left behind.
            this.footDust.update();
            // Both before the mask is baked this frame (the renderer bakes it straight after endFrame), so
            // a flash's light and a fire's breath are in it on the frame they happen.
            const darkness = this.clientRenderer.map?.().getVisibility?.()?.darkness ?? 1;
            const now = performance.now();
            this.animateFirelight(darkness < 1, now);
            this.transientLights.update(darkness, this.logic.tilemapMetaProvider?.roomId, now);
            // The water: who wades (legs cut, rings, splashing steps) and who stands over it (reflected).
            const waterContacts = [];
            for (const id of this.renderedThisFrame){
                const renderable = this.entityIdToRenderable[id];
                if (!renderable?.visible) continue;
                const feet = renderable.grassContact?.();
                const entity = feet && this.logic.getEntity(id);
                if (!entity || !entity.visible || entity.downed || !!entity.floorFall || (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isFlat(entity)) continue;
                waterContacts.push({
                    id: id,
                    x: feet.x,
                    y: feet.y,
                    art: renderable.reflectionArt?.(),
                    body: renderable
                });
            }
            const wading = this.clientRenderer.map?.().updateWater?.(waterContacts, this.logic.scene?.daylight) ?? new Set();
            // Only who waded last frame or wades now can have changed.
            for (const id of new Set([
                ...this.wadingIds,
                ...wading
            ])){
                const entity = this.logic.getEntity(id);
                if (entity) entity.wading = wading.has(id);
            }
            this.wadingIds = wading;
            this.grassFeet.beginFrame(this.logic.tilemapMetaProvider?.roomId);
            if (window.grassFeet !== false) for (const id of this.renderedThisFrame){
                const renderable = this.entityIdToRenderable[id];
                if (!renderable?.visible) continue;
                const feet = renderable.grassContact?.();
                if (!feet) continue;
                const entity = this.logic.getEntity(id);
                if (!entity || !entity.visible || entity.submerged || entity.downed || !!entity.floorFall || entity.rescuePose === "downed" || (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isFlat(entity)) continue;
                this.grassFeet.contact(id, {
                    ...feet,
                    zIndex: renderable.zIndex,
                    alpha: renderable.alpha,
                    moving: !!entity.movement?.moving,
                    angle: feet.angle ?? entity.movement?.angle,
                    travelAngle: entity.movement?.angle
                });
            }
            this.grassFeet.endFrame();
            (0, $ab66af423f686729$export$33fd9cf5c2957616)(this.preSpawnEffects, this.completedPreSpawnEffects, (id)=>this.entityIdToRenderable[id]?.visible && this.renderedThisFrame.has(id));
            if (this.shownEntityIds.size < 1) return;
            // hideRenderable only ever deletes the entry being visited, which is safe to do while
            // iterating a Set.
            for (const entityId of this.shownEntityIds){
                if (this.renderedThisFrame.has(entityId)) continue;
                this.hideRenderable(entityId);
            }
        };
        this.updatePlayerOcclusionOutline = ()=>{
            const player = this.logic.playerEntity;
            const renderable = player && this.get(player);
            // Ladder endpoints stay clear too, even while the player stands still on the hatch.
            const onLadder = player && this.logic.tilemapMetaProvider?.isStairAt(Math.floor(player.location.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.floor(player.location.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)));
            if (!(0, $b885220dc92c19d4$export$402ee61a7bf81935)() || !player?.visible || !renderable?.visible || player.stairTravel || onLadder || !this.clientRenderer.map().hasForegroundSceneFloor(renderable.zIndex)) {
                this.playerOcclusionOutline.hide();
                return;
            }
            this.playerOcclusionOutline.update(player?.visible && renderable?.visible ? renderable.occlusionBody?.() : undefined, renderable?.zIndex ?? 0, this.sceneOcclusion);
        };
        this.sceneOcclusion = {
            overlaps: (bounds, z)=>this.clientRenderer.map().isPlayerBehindScene(bounds, z),
            covers: (bounds, z)=>this.clientRenderer.map().isPlayerHiddenByScene(bounds, z)
        };
        // Hide an entity's sprite and overlay, and release any hover it was holding. Culling to
        // invisible never fires a pointer-out, so a stranded hover (name plate, outline) has to be
        // dropped by hand or it reappears without a hover when the entity comes back.
        this.hideRenderable = (entityId)=>{
            this.shownEntityIds.delete(entityId);
            const renderable = this.entityIdToRenderable[entityId];
            if (renderable) {
                if (renderable.visible) {
                    renderable.onMouseOver?.(false);
                    renderable.setHighlighted?.(false);
                    this.clearHighlightIf(entityId);
                    this.logic.playerController?.clearHoverForEntity(entityId);
                }
                renderable.visible = false;
            }
            const worldOverlayItem = this.worldOverlaySurface.getEntityRenderable(entityId);
            if (worldOverlayItem) worldOverlayItem.visible = false;
        };
        this.render = (entity, playerEntityId)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            this.renderedThisFrame.add(entity.entityId);
            this.visuals.updateRole(renderable, this.logic.getEmberRole?.(entity.entityId) ?? null);
            if (!this.logic.clientRenderer.map().getVisibility()?.suppressMinimap) this.minimapSurface.updateEntity(entity.entityId, entity.roomId, entity.location);
            // Check if entity is too far from player
            const isTooFar = entity.interestState !== "active" || this.logic.isTooDistantFromPlayer(entity);
            if (!isTooFar) {
                // Entity is close enough - make it visible and update
                if (entity.entityId !== playerEntityId) {
                    renderable.visible = entity.visible;
                    if (entity.visible) {
                        this.shownEntityIds.add(entity.entityId);
                        // Roster statuses arrive separately from entity updates. A recruit parked at
                        // the fire may receive no entity changes until it is fed, so read the latest
                        // status while drawing it too. The tier cache avoids redundant sprite writes.
                        this.applyStatusHalo(entity.entityId);
                        // Re-assert the selected member's outline every frame they are drawn. A hover
                        // glow re-arms itself on the next pointer move; a roster selection has nothing
                        // to re-arm it, and two things throw it away behind its back -- culling takes it
                        // off by hand (see hideRenderable), and a paperdoll rebuild replaces the sprite
                        // that owns it (see LpcComposite.setHighlighted). Costs a map lookup: the
                        // highlight itself ignores a set() that changes nothing.
                        if (entity.entityId === this.rosterHighlightId) this.applyHighlight(entity.entityId);
                    } else this.shownEntityIds.delete(entity.entityId);
                }
                // The dissolve, re-asserted every frame it is running: the alpha written when
                // `entity.visible` changes is a one-shot, and a fade spans a room load and two
                // renderables. Skipped entirely while the player is HIDDEN, which owns alpha 0 for its
                // own reasons (see the entity.visible branch in update()).
                if (entity.entityId === playerEntityId && entity.visible) {
                    const faded = this.playerFadeAlpha();
                    if (faded !== undefined) renderable.alpha = faded;
                }
                (0, $a3da31b418d2b1ed$export$4725754a4127b437)(entity, renderable, this.logic.roomId, this.logic.canRenderFloorFallArrival?.() ?? true, Date.now(), this.logic.tilemapMetaProvider);
                this.updateRenderedPlayerLight(entity, renderable);
                this.updatePreSpawnEffect(entity, renderable);
                this.worldOverlaySurface.updateEntity(entity);
            } else // Entity is too far - hide it
            if (entity.entityId !== playerEntityId) this.hideRenderable(entity.entityId);
            else {
                // Also hide the world overlay
                const worldOverlayItem = this.worldOverlaySurface.getEntityRenderable(entity.entityId);
                if (worldOverlayItem) worldOverlayItem.visible = false;
            }
            return true;
        };
        this.detonate = (entity)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.detonate();
        };
        this.emp = (entity, range)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            const surface = renderable.parent ?? this.surface;
            const halo = new (0, $gwPoJ.Graphics)();
            surface.addChild(halo);
            halo.beginFill(0xff000080, 0.25);
            halo.drawCircle(1, 5, 5);
            halo.endFill();
            halo.x = renderable.x;
            halo.y = renderable.y;
            let scale = 1.0;
            let roomId = entity.roomId;
            const expandInterval = setInterval(()=>{
                if (halo.destroyed || this.get(entity) !== renderable) {
                    clearInterval(expandInterval);
                    halo.parent?.removeChild(halo);
                    return;
                }
                scale += 0.5;
                halo.scale.set(scale);
                halo.x = renderable.x - halo.width * 0.1;
                halo.y = renderable.y - halo.height / 2;
                if (halo.height > range) {
                    clearInterval(expandInterval);
                    let alpha = 1.0;
                    let startTs = Date.now();
                    const contractInterval = setInterval(()=>{
                        const changedRooms = roomId !== entity.roomId || halo.destroyed || this.get(entity) !== renderable;
                        if (Date.now() - startTs > 3000 || changedRooms) {
                            clearInterval(contractInterval);
                            if (changedRooms) halo.parent?.removeChild(halo);
                            else {
                                const fadeInterval = setInterval(()=>{
                                    if (halo.destroyed) {
                                        clearInterval(fadeInterval);
                                        return;
                                    }
                                    alpha -= 0.01;
                                    halo.alpha = alpha;
                                    if (alpha <= 0.0) {
                                        clearInterval(fadeInterval);
                                        halo.parent?.removeChild(halo);
                                    }
                                }, 5);
                            }
                        }
                    }, 250);
                }
            }, 4);
        };
        // Green "sparkle halo": an expanding green glow ring plus a handful of twinkling star
        // sparkles ringing the entity, all fading over ~700ms. Server-triggered (see
        // Protocol.type_entitySparkle) as feedback when a campfire is refreshed with wood.
        this.sparkle = (entity)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            const surface = renderable.parent ?? this.surface;
            const roomId = entity.roomId;
            const color = 0x33ff66;
            const cx = renderable.x;
            // Nudge up toward the middle of the sprite.
            const cy = renderable.y - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
            // --- Expanding green glow ring ---
            const ring = new (0, $gwPoJ.Graphics)();
            surface.addChild(ring);
            ring.lineStyle(3, color, 0.9);
            ring.beginFill(color, 0.15);
            ring.drawCircle(0, 0, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.6);
            ring.endFill();
            ring.x = cx;
            ring.y = cy;
            const ringStart = Date.now();
            const ringDuration = 700;
            const ringInterval = setInterval(()=>{
                const t = (Date.now() - ringStart) / ringDuration;
                if (t >= 1 || roomId !== entity.roomId || this.get(entity) !== renderable) {
                    clearInterval(ringInterval);
                    ring.parent?.removeChild(ring);
                    return;
                }
                ring.x = renderable.x;
                ring.y = renderable.y - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
                ring.scale.set(0.6 + t * 1.6);
                ring.alpha = 1 - t;
            }, 16);
            // --- Twinkling star sparkles ringing the entity ---
            const sparkleCount = 7;
            for(let i = 0; i < sparkleCount; i++){
                const angle = Math.PI * 2 * i / sparkleCount + Math.random() * 0.4;
                const radius = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (0.5 + Math.random() * 0.35);
                const star = this.drawSparkleStar(color, 3 + Math.random() * 2);
                surface.addChild(star);
                let offsetX = Math.cos(angle) * radius;
                let offsetY = Math.sin(angle) * radius;
                star.x = cx + offsetX;
                star.y = cy + offsetY;
                const driftX = Math.cos(angle) * 0.3;
                const driftY = Math.sin(angle) * 0.3 - 0.4 // slight upward bias
                ;
                const start = Date.now();
                const life = 500 + Math.random() * 300;
                const twinklePhase = Math.random() * Math.PI * 2;
                const interval = setInterval(()=>{
                    const elapsed = Date.now() - start;
                    if (elapsed > life || roomId !== entity.roomId || this.get(entity) !== renderable) {
                        clearInterval(interval);
                        star.parent?.removeChild(star);
                        return;
                    }
                    offsetX += driftX;
                    offsetY += driftY;
                    star.x = renderable.x + offsetX;
                    star.y = renderable.y - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 + offsetY;
                    const fade = 1 - elapsed / life;
                    star.alpha = fade * (0.5 + 0.5 * Math.abs(Math.sin(elapsed / 60 + twinklePhase)));
                    star.rotation += 0.08;
                }, 16);
            }
        };
        // A small 4-point sparkle drawn from two overlapping diamonds (drawPolygon is core in
        // pixi v6; drawStar is not).
        this.drawSparkleStar = (color, size)=>{
            const g = new (0, $gwPoJ.Graphics)();
            g.beginFill(color, 1);
            // Vertical spike
            g.drawPolygon([
                0,
                -size * 2,
                size * 0.5,
                0,
                0,
                size * 2,
                -size * 0.5,
                0
            ]);
            // Horizontal spike
            g.drawPolygon([
                -size * 2,
                0,
                0,
                size * 0.5,
                size * 2,
                0,
                0,
                -size * 0.5
            ]);
            g.endFill();
            return g;
        };
        this.attack = (entity, callback)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.doAttack(entity, callback);
        };
        this.updateActivation = (entity, active)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.updateActivation(entity, active);
        };
        this.animateStrikeOn = (target)=>{
            const struckEffect = new (0, $e97a9ef66e2e5f53$export$8653a30c44b6e879)(0xff0000, 10);
            const renderable = this.get(target);
            if (!renderable) return;
            // struckEffect.x = renderable.x
            // struckEffect.y = renderable.y
            // struckEffect.zIndex = renderable.zIndex + 1
            // this.surface.addChild(struckEffect)
            // struckEffect.alpha = 0.5
            // let startTS = Date.now()
            // let totalDuration = 150
            // let scale = 0
            // let incr = 0
            // const itr = setInterval(() => {
            //     const duration = Date.now() - startTS
            //     incr = duration > totalDuration / 2 ? -1 : 1
            //     scale += incr
            //     struckEffect.scale.set(scale, scale)
            //     if (duration > totalDuration) {
            //         clearInterval(itr)
            //         this.surface?.removeChild(struckEffect)
            //     }
            // }, 17)
            renderable.doDamaged(target);
        };
        this.spoke = (entity, message, options)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            // Render instantly (no typewriter) when this entity is the follow-cam PiP focus — the
            // typewriter's progressive reveal flickers when rendered into the PiP texture. On the main
            // view (not the PiP focus) keep the typewriter.
            const instant = entity.entityId === this.logic.focusEntityId;
            renderable.spoke(message, {
                instant: instant,
                hold: options?.hold,
                autoAdvance: options?.autoAdvance,
                onDismissed: options?.onDismissed
            });
        };
        // Called off a conversation the player has opted out of (the ember tutorial's Skip): every
        // held bubble on screen comes down, with whatever was queued behind it. Room-wide rather than
        // per-speaker, because what is being ended is the SCENE, not one entity's line.
        this.releaseHeldSpeech = ()=>{
            Object.values(this.entityIdToRenderable).forEach((renderable)=>renderable?.releaseHeldSpeech());
        };
        this.death = (entity)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.fragment(entity);
            const flash = (0, $4fe000d23bc94d81$export$6ddfb1d6399ca295)(entity, this.logic.getEmberRole?.(entity.entityId) != null);
            if (flash) {
                // The renderable sits at the location plus its artwork lift; the light goes on the body's
                // middle, a little above the hip line the location marks.
                const x = renderable.x;
                const y = renderable.y - (renderable.getYOffset?.() ?? 0) - 10 * flash.scale;
                this.flashIn(renderable.parent, flash.kind, x, y, {
                    scale: flash.scale
                });
            }
        };
        /**
     * The campfire was fed or lit (the client hears campfire_fed / campfire_lit, which say nothing of
     * WHICH fire -- a camp has one). Flare every fire on this floor, and any that appears in the next
     * moment: a relit fire is a new entity, and its message can trail the sound.
     */ this.flareFires = (nowMs = performance.now())=>{
            this.fireFlareUntil = nowMs + $3de7f2d858d8583e$var$FIRE_FLARE_PENDING_MS;
            for (const id of this.fires){
                const sprite = this.entityIdToRenderable[id];
                if (sprite instanceof (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)) sprite.flare(nowMs);
            }
        };
        this.getLights = ()=>{
            const companions = this.clientRenderer.map?.().getSceneLights?.() ?? [];
            if (!companions.length && !this.sceneLights.size()) return this.lights;
            const present = new Set();
            const offer = (light)=>{
                present.add(light.entityId);
                const old = this.sceneLights.get(light.entityId);
                if (!old || old.location.x !== light.location.x || old.location.y !== light.location.y || old.radius !== light.radius || old.intensity !== light.intensity) this.sceneLights.set(light.entityId, {
                    ...light,
                    location: {
                        ...light.location
                    }
                });
            };
            companions.forEach(offer);
            this.lights.iterate(offer);
            this.sceneLights.keys().forEach((id)=>{
                if (!present.has(id)) this.sceneLights.remove(id);
            });
            return this.sceneLights;
        };
        this.clearBiomeColorMap = ()=>{
            this.minimapSurface.clearBiomeColorMap();
        };
        this.updateLocationIcons = (icon)=>{
            this.minimapSurface.updateLocationIcon(icon);
        };
        this.updatePlayerLocations = (playerLocations)=>{
            const clientPlayerEntityId = this.clientRenderer.logic().playerEntity.entityId;
            if (!clientPlayerEntityId) return;
            if (!playerLocations) return;
            this.minimapSurface.entities().forEach((entityId)=>{
                // remove any players not present in the latest
                // player location manifest sent from the server
                const entity = this.logic.entityManager.get(entityId);
                if (!playerLocations[entityId] || entity?.roomId !== this.clientRenderer.logic().playerEntity.roomId) this.minimapSurface.remove(entityId);
            });
            Object.keys(playerLocations).forEach((entityId)=>{
                const location = playerLocations[entityId];
                if (location?.quadrantId && location.quadrantId !== this.clientRenderer.logic().quadrantId) return;
                this.minimapSurface.offer(entityId);
                this.minimapSurface.updateEntity(entityId, location.roomId, {
                    x: location.x,
                    y: location.y
                }, true);
            });
        };
        this.pulseLocation = (locationId, expires)=>{
            this.minimapSurface.pulseLocation(locationId, expires);
        };
        this.updateEntityPointerIcon = (entity, show, angle)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.updatePointerIcon(show, angle);
        };
        this.itemPickedUp = (entity, itemTypeMeta, quantity)=>{
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.itemPickedUp(entity, itemTypeMeta, quantity);
        };
        this.feedback = (entity, image, label, params)=>{
            // A running body's dust trail is not overlay feedback like a nameplate or a floating "+1":
            // it is art laid on the ground that has to sort against the bodies around it, so it is drawn
            // in the world surface this manager owns instead of inside the entity's renderable. See
            // FootDust for why the renderable cannot get the z-order right.
            if (params?.type === "foot") {
                if (params.action === "remove") this.footDust.stop(entity.entityId);
                else this.footDust.start(entity, params, undefined, this.get(entity)?.parent ?? this.surface);
                return;
            }
            const renderable = this.get(entity);
            if (!renderable) return;
            renderable.feedback(entity, image, label, params);
        };
        this.fragment = (spriteId, location)=>{
            const renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                name: spriteId,
                scale: 1.0,
                color: 0xffffff
            });
            const fragmentContainer = new (0, $gwPoJ.Graphics)();
            fragmentContainer.x = location.x;
            fragmentContainer.y = location.y - renderable.height * 0.25;
            fragmentContainer.addChild(renderable);
            this.surface.addChild(fragmentContainer);
            renderable.fragment(null, ()=>{
                renderable.visible = false;
            });
            setTimeout(()=>{
                this.surface.removeChild(fragmentContainer);
            }, 1500);
        };
        this.surface = surface;
        this.playerOcclusionOutline = new (0, $b885220dc92c19d4$export$f32c9471336cdee1)(surface);
        this.minimapSurface = minimapSurface;
        this.worldOverlaySurface = worldOverlaySurface;
        this.logic = logic;
        this.clientRenderer = clientRenderer;
        this.footDust = new (0, $f63df80eccdeeea6$export$ab8cf330af9aa032)(surface, (0, $f63df80eccdeeea6$export$ab8cf330af9aa032).textureFactory(app.renderer));
        this.grassFeet = new (0, $7ea6fc60f5974fdd$export$472ad0d38cb45514)(surface, (x, y)=>(0, $7ea6fc60f5974fdd$export$920f903c798ad6e9)(this.logic.tilemapMetaProvider, x, y));
        // Arrow releases, deaths and the dead rising: a glow in the world plus a light in the night
        // mask, which is why it is handed this manager's own LightsContainer.
        this.transientLights = new (0, $4fe000d23bc94d81$export$2626a6f34c87e254)(this.lights);
        surface.addChild(this.transientLights.container);
        if (typeof window !== "undefined") window.flashTest = (kind = "kill", opts = {})=>{
            const at = this.logic.playerEntity?.location;
            if (at) this.transientLights.flash(kind, at.x + 40, at.y - 10, opts);
        };
    }
    updateRenderedPlayerLight(entity, sprite) {
        if (entity.entityId !== this.logic.playerEntity?.entityId) return;
        // A map packet can precede its player packet. Old stair state must never
        // move the light back to the departing floor's unanimated origin.
        if (this.logic.roomId && (entity.roomId !== this.logic.roomId || entity.stairTravel && entity.stairTravel.roomId !== this.logic.roomId)) return;
        // Stair and fall playback move the body independently of its simulation
        // coordinates. Carry its light with that body, including the floor handoff.
        // Remove the normal artwork lift to preserve the light's usual ground anchor.
        const location = {
            x: sprite.x,
            y: sprite.y - (sprite.getYOffset?.() ?? 0)
        };
        // Down an organic cave the player carries a torch: a wide pool that fades to its edge.
        const torch = this.logic.tilemapMetaProvider?.getOrganicRockLayer?.() ? (0, $882231da9d46a555$export$3be67ca5d794e522)() : undefined;
        const intensity = torch?.intensity ?? entity.lightIntensity();
        const radius = torch?.radius ?? entity.lightRadius();
        const falloff = torch?.falloff;
        const previous = this.lights.get(entity.entityId);
        const handoff = this.playerLightHandoff;
        if (handoff && previous) {
            const now = Date.now();
            if (!handoff.offset) {
                handoff.offset = {
                    x: previous.location.x - location.x,
                    y: previous.location.y - location.y
                };
                handoff.startTs = now;
            }
            const progress = Math.min(1, (now - handoff.startTs) / 200);
            const remaining = 1 - progress * progress * (3 - 2 * progress);
            location.x += handoff.offset.x * remaining;
            location.y += handoff.offset.y * remaining;
            if (progress === 1) this.playerLightHandoff = undefined;
        }
        if (!previous || previous.location.x !== location.x || previous.location.y !== location.y || previous.intensity !== intensity || previous.radius !== radius || previous.falloff !== falloff) this.lights.set(entity.entityId, {
            entityId: entity.entityId,
            location: location,
            intensity: intensity,
            radius: radius,
            falloff: falloff
        });
    }
    updatePreSpawnEffect(entity, renderable) {
        (0, $ab66af423f686729$export$5aae9beeefa90c8c)(entity, renderable, renderable.parent ?? this.surface, this.preSpawnEffects, this.completedPreSpawnEffects, ()=>{
            this.logic.audio.groundRupture(entity.location);
            // Grave light out of the opening, building while the body climbs and peaking as it
            // clears the ground. Anchored where GroundRupture draws its hole.
            const remaining = entity.preSpawnEffectView?.remainingMs ?? 0;
            this.flashIn(renderable.parent, "graveRise", entity.location.x, entity.location.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763), {
                attackMs: Math.max(150, Math.min(900, remaining * 0.6)),
                scale: Math.max(0.5, Math.min(1.6, entity.spriteScale || 1))
            });
        });
    }
    // Each fire's light, breathing and flaring while it is on screen in the dark; see LivingFirelight.
    animateFirelight(dark, nowMs) {
        for (const id of this.fires){
            const sprite = this.entityIdToRenderable[id];
            const entity = this.logic.getEntity(id);
            if (!(sprite instanceof (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)) || !entity) continue;
            const drawn = this.renderedThisFrame.has(id) && sprite.visible;
            if (drawn) sprite.tick(nowMs);
            if (!entity.lightMeta && entity.npcType !== "light") continue;
            this.firelight.update(this.lights, id, entity.location, {
                radius: entity.lightRadius(),
                intensity: entity.lightIntensity()
            }, sprite, dark && drawn, nowMs);
        }
    }
    /** A flash at a point in `parent`'s space, which for an entity on a storey is not the world surface's. */ flashIn(parent, kind, x, y, opts) {
        const at = parent && parent !== this.surface && !parent.destroyed ? this.surface.toLocal({
            x: x,
            y: y
        }, parent) : {
            x: x,
            y: y
        };
        this.transientLights.flash(kind, at.x, at.y, opts);
    }
}
const $3de7f2d858d8583e$export$504709cb2a8295d2 = (fineCoordinate)=>{
    return {
        x: Math.round(fineCoordinate.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)),
        y: Math.round(fineCoordinate.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))
    };
};


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $6qzqq = parcelRequire("6qzqq");
var $P8XPi = parcelRequire("P8XPi");



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

const $2f9f1514035da1ec$export$d8df7395f14ba24a = 0xffd166;
const $2f9f1514035da1ec$export$81e981a732c8ab4a = 0xffb84a;
const $2f9f1514035da1ec$export$a946f851ecf2e2e0 = 0xff8a1f;
const $2f9f1514035da1ec$export$6237dac50234d3bb = 0xfff6d8;
const $2f9f1514035da1ec$export$c780db370c4a4d96 = 0x2a1a0c;
const $2f9f1514035da1ec$export$bc2a8782c99449da = (g, cx, cy, r)=>{
    g.moveTo(cx, cy - r).lineTo(cx + r, cy).lineTo(cx, cy + r).lineTo(cx - r, cy).closePath();
};
const $2f9f1514035da1ec$export$32465a74bc98bd3 = (g, cx, cy, r)=>{
    const k = r * 0.3;
    g.moveTo(cx, cy - r).lineTo(cx + k, cy - k).lineTo(cx + r, cy).lineTo(cx + k, cy + k).lineTo(cx, cy + r).lineTo(cx - k, cy + k).lineTo(cx - r, cy).lineTo(cx - k, cy - k).closePath();
};
const $2f9f1514035da1ec$export$35dc45686fc2dbd7 = (g, cx, cy, r, progress, color, width)=>{
    const p = (0, $a8782f4c6450260e$export$5c5ee632c52bc4a2)(progress);
    if (p <= 0) return;
    const a = {
        x: cx - r * 0.55,
        y: cy + r * 0.02
    };
    const b = {
        x: cx - r * 0.12,
        y: cy + r * 0.45
    };
    const c = {
        x: cx + r * 0.62,
        y: cy - r * 0.45
    };
    const first = Math.hypot(b.x - a.x, b.y - a.y);
    const second = Math.hypot(c.x - b.x, c.y - b.y);
    const along = p * (first + second);
    g.lineStyle({
        width: width,
        color: color,
        alpha: 1,
        cap: (0, $gwPoJ.LINE_CAP).ROUND,
        join: (0, $gwPoJ.LINE_JOIN).ROUND
    });
    g.moveTo(a.x, a.y);
    if (along <= first) {
        const k = along / first;
        g.lineTo(a.x + (b.x - a.x) * k, a.y + (b.y - a.y) * k);
    } else {
        const k = (along - first) / second;
        g.lineTo(b.x, b.y).lineTo(b.x + (c.x - b.x) * k, b.y + (c.y - b.y) * k);
    }
    g.lineStyle(0);
};
const $2f9f1514035da1ec$export$7957c9215476f232 = (g, cx, cy, r, checkProgress = 1)=>{
    g.lineStyle({
        width: 1,
        color: 0x5a3c12,
        alpha: 0.9,
        join: (0, $gwPoJ.LINE_JOIN).MITER
    });
    g.beginFill($2f9f1514035da1ec$export$81e981a732c8ab4a, 1);
    $2f9f1514035da1ec$export$bc2a8782c99449da(g, cx, cy, r);
    g.endFill();
    g.lineStyle(0);
    // The upper facets catch the light.
    g.beginFill($2f9f1514035da1ec$export$d8df7395f14ba24a, 1);
    g.moveTo(cx, cy - r + 1).lineTo(cx + r - 1, cy).lineTo(cx, cy + 0.5).lineTo(cx - r + 1, cy).closePath();
    g.endFill();
    g.beginFill($2f9f1514035da1ec$export$6237dac50234d3bb, 0.75);
    g.moveTo(cx, cy - r + 1.5).lineTo(cx - r * 0.5, cy - r * 0.5 + 0.5).lineTo(cx, cy - 0.5).closePath();
    g.endFill();
    $2f9f1514035da1ec$export$35dc45686fc2dbd7(g, cx, cy, r * 0.82, checkProgress, $2f9f1514035da1ec$export$c780db370c4a4d96, Math.max(1.4, r * 0.3));
};
const $2f9f1514035da1ec$export$11572259c1b566fa = (g, cx, cy, r, color, alpha, bands = 4)=>{
    if (!(alpha > 0) || !(r > 0)) return;
    for(let i = 0; i < bands; i++){
        const k = 1 - i / bands;
        g.beginFill(color, alpha / bands).drawCircle(cx, cy, r * k).endFill();
    }
};
const $2f9f1514035da1ec$export$e1c6fe5ee848dc6d = (g, cx, cy, t, count, from, to, color, seed = 0, width = 1.5)=>{
    if (!(t > 0) || t >= 1) return;
    const travel = (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(t);
    const alpha = 1 - t * t;
    for(let i = 0; i < count; i++){
        const angle = i / count * Math.PI * 2 + seed + (i % 2 ? 0.18 : -0.1);
        const reach = i % 3 === 0 ? 1 : i % 3 === 1 ? 0.78 : 0.9;
        const r1 = from + (to - from) * travel * reach;
        const tail = Math.max(2, (to - from) * 0.28 * (1 - t));
        const r0 = Math.max(from, r1 - tail);
        g.lineStyle({
            width: width,
            color: color,
            alpha: alpha,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        g.moveTo(cx + Math.cos(angle) * r0, cy + Math.sin(angle) * r0).lineTo(cx + Math.cos(angle) * r1, cy + Math.sin(angle) * r1);
    }
    g.lineStyle(0);
};
const $2f9f1514035da1ec$export$f2d9b1fa89f3b31e = (g, x, y, w, h, t, band, alpha, color = $2f9f1514035da1ec$export$6237dac50234d3bb)=>{
    if (t < 0 || t > 1 || !(alpha > 0)) return;
    const slant = h * 0.6;
    const start = x - band - slant + (w + band + slant) * t;
    // Nested passes, widest faintest, so the band has a soft falloff rather than a hard-edged slab.
    for (const [width, a] of [
        [
            band,
            alpha * 0.22
        ],
        [
            band * 0.72,
            alpha * 0.26
        ],
        [
            band * 0.46,
            alpha * 0.3
        ],
        [
            band * 0.22,
            alpha * 0.35
        ]
    ]){
        const left = start + (band - width) / 2;
        const poly = $2f9f1514035da1ec$export$26ed0069b1bebc36([
            {
                x: left + slant,
                y: y
            },
            {
                x: left + slant + width,
                y: y
            },
            {
                x: left + width,
                y: y + h
            },
            {
                x: left,
                y: y + h
            }
        ], x, x + w);
        if (poly.length < 3) continue;
        g.beginFill(color, a);
        g.drawPolygon(poly.flatMap((p)=>[
                p.x,
                p.y
            ]));
        g.endFill();
    }
};
const $2f9f1514035da1ec$export$26ed0069b1bebc36 = (points, minX, maxX)=>{
    const clip = (input, inside, edgeX)=>{
        const out = [];
        for(let i = 0; i < input.length; i++){
            const cur = input[i];
            const prev = input[(i + input.length - 1) % input.length];
            const cross = ()=>{
                const k = (edgeX - prev.x) / (cur.x - prev.x);
                return {
                    x: edgeX,
                    y: prev.y + (cur.y - prev.y) * k
                };
            };
            if (inside(cur)) {
                if (!inside(prev)) out.push(cross());
                out.push(cur);
            } else if (inside(prev)) out.push(cross());
        }
        return out;
    };
    return clip(clip(points, (p)=>p.x >= minX, minX), (p)=>p.x <= maxX, maxX);
};





const $355f6bd9e8d13e25$var$WIDTH = 228;
const $355f6bd9e8d13e25$var$HEADER_HEIGHT = 46;
const $355f6bd9e8d13e25$var$CONTENT_X = 14;
const $355f6bd9e8d13e25$var$SOCKET_X = 22;
const $355f6bd9e8d13e25$var$SOCKET_R = 5.5;
const $355f6bd9e8d13e25$var$LABEL_X = 36;
const $355f6bd9e8d13e25$var$ROW_MIN_H = 20;
const $355f6bd9e8d13e25$var$PIP_R = 3.4;
const $355f6bd9e8d13e25$var$PIP_STEP = 10;
const $355f6bd9e8d13e25$var$TOGGLE_W = 20;
const $355f6bd9e8d13e25$var$BUTTON_H = 30;
const $355f6bd9e8d13e25$var$DONE_TEXT = 0xc9a86a;
const $355f6bd9e8d13e25$var$TODO_TEXT = 0x93826b;
const $355f6bd9e8d13e25$var$CURRENT_TEXT = (0, $658a44ce960354bb$export$8eb3a98fbc1bd246);
const $355f6bd9e8d13e25$var$CURRENT_WARM = 0xffd99a;
const $355f6bd9e8d13e25$var$SOCKET_EMPTY = 0x0d0a07;
const $355f6bd9e8d13e25$var$SOCKET_RIM_TODO = 0x4a3f30;
const $355f6bd9e8d13e25$var$UNLIT_FILL = 0x2a201a;
const $355f6bd9e8d13e25$var$UNLIT_RIM = 0x6b4f38;
// Transition lengths.
const $355f6bd9e8d13e25$var$ROW_HANDOFF_MS = 520;
const $355f6bd9e8d13e25$var$FOLD_MS = 300;
const $355f6bd9e8d13e25$var$ROW_IN_MS = 260;
const $355f6bd9e8d13e25$var$ROW_IN_STAGGER = 45;
const $355f6bd9e8d13e25$var$ROW_OUT_MS = 170;
const $355f6bd9e8d13e25$var$ROW_OUT_STAGGER = 28;
const $355f6bd9e8d13e25$var$HEADER_GOLD_MS = 650;
const $355f6bd9e8d13e25$var$CONTENT_FADE_MS = 260;
// The folded bar a finished chapter shrinks to: just its button and the toggle to open it again.
const $355f6bd9e8d13e25$var$COMPACT_PAD = 8;
const $355f6bd9e8d13e25$var$HOVER_MS = 160;
// A panel appearing unfolds from a sliver of board rather than popping in whole.
const $355f6bd9e8d13e25$var$UNFOLD_FROM = 18;
// Celebrations that never arrive -- a hidden tab, a lost frame loop -- must not leave a task
// unchecked or the next chapter unreachable.
const $355f6bd9e8d13e25$var$PENDING_REVEAL_LIMIT_MS = 9000;
const $355f6bd9e8d13e25$var$DOCK_LIMIT_MS = 12000;
// The server's "chapter complete" and the list's last tick are separate messages and can land in
// either order; a completion only earns the fanfare when the two arrive this close together.
const $355f6bd9e8d13e25$var$COMPLETION_WINDOW_MS = 20000;
// A "continue" arriving before the list is finished waits this long for the last tick to land, so
// the button does not appear first and then vanish under the fanfare.
const $355f6bd9e8d13e25$var$CONTINUE_HOLD_MS = 3000;
// After Continue the server takes its prompt down and sends the next-chapter one a moment
// later. The spent button stays until it arrives rather than the panel collapsing and regrowing.
const $355f6bd9e8d13e25$var$RETIRE_MS = 1600;
const $355f6bd9e8d13e25$var$rowTint = (state)=>state === "done" ? $355f6bd9e8d13e25$var$DONE_TEXT : state === "current" ? $355f6bd9e8d13e25$var$CURRENT_TEXT : $355f6bd9e8d13e25$var$TODO_TEXT;
/**
 * Every task on the list done, and none still to be dealt onto it: a chapter that hands its tasks out
 * one at a time can have every listed task done while it waits to give the next (`more`).
 */ const $355f6bd9e8d13e25$var$allDone = (data)=>data.tasks.every((task)=>task.complete) && !data.more;
class $355f6bd9e8d13e25$export$ec54e50cc454228d extends (0, $8t5Gy.Container) {
    constructor(hover, anchor = ()=>undefined, events = {}){
        super(), this.hover = hover, this.anchor = anchor, this.events = events, this.minimized = true, this.hovered = false, this.panelHeight = $355f6bd9e8d13e25$var$HEADER_HEIGHT, this.toggleGlyph = new (0, $gwPoJ.Graphics)(), this.toggleTurn = new (0, $a8782f4c6450260e$export$f709befbd1bbaa29)(1, 240), this.board = new (0, $gwPoJ.Graphics)(), this.under = new (0, $gwPoJ.Graphics)(), this.content = new (0, $8t5Gy.Container)(), this.contentMask = new (0, $gwPoJ.Graphics)(), this.pips = new (0, $gwPoJ.Graphics)(), this.over = new (0, $gwPoJ.Graphics)(), this.rows = [], this.looks = new Map(), this.headerBottom = $355f6bd9e8d13e25$var$HEADER_HEIGHT, this.clock = 0, this.boardHeight = new (0, $a8782f4c6450260e$export$f709befbd1bbaa29)(0, $355f6bd9e8d13e25$var$FOLD_MS), this.paintedHeight = -1, this.headerGold = new (0, $a8782f4c6450260e$export$f709befbd1bbaa29)(0, $355f6bd9e8d13e25$var$HEADER_GOLD_MS), this.pending = new Map(), this.stamps = new Map(), this.ctaShownAt = 0, this.ctaSpent = false, this.ctaSpentAt = 0, this.ctaCover = new (0, $gwPoJ.Graphics)(), this.ctaSlide = new (0, $a8782f4c6450260e$export$f709befbd1bbaa29)(0, $355f6bd9e8d13e25$var$FOLD_MS), this.ctaHover = new (0, $a8782f4c6450260e$export$f709befbd1bbaa29)(0, $355f6bd9e8d13e25$var$HOVER_MS), this.setEvents = (events)=>{
            this.events = events;
        }, this.update = (data)=>{
            const previous = this.data;
            const live = !!previous && !!data && previous.chapter === data.chapter;
            if (!data || previous?.chapter !== data.chapter) {
                // A new chapter (or none): nothing in flight belongs to it, and the list unfolds afresh.
                this.pending.clear();
                this.stamps.clear();
                this.looks.clear();
                this.liveCompleteAt = undefined;
                this.awaitingDockSince = undefined;
                this.completeAt = undefined;
                this.collapsingAt = undefined;
                if (data && previous) this.continueAt = undefined;
                if (data) {
                    this.rowsInAt = this.clock;
                    this.boardHeight.snap(this.visible ? this.boardHeight.value(this.clock) : $355f6bd9e8d13e25$var$UNFOLD_FROM);
                    this.headerGold.snap($355f6bd9e8d13e25$var$allDone(data) ? 1 : 0);
                }
            }
            this.data = data || undefined;
            if (data && live) {
                const was = new Map(previous.tasks.map((task)=>[
                        task.id,
                        task.complete
                    ]));
                const finished = data.tasks.filter((task)=>task.complete && was.get(task.id) === false);
                finished.forEach((task)=>{
                    if (this.events.onTaskCompleted) {
                        this.pending.set(task.id, this.clock);
                        this.events.onTaskCompleted(task, data.chapter);
                    } else this.stamps.set(task.id, this.clock);
                });
                if (finished.length && $355f6bd9e8d13e25$var$allDone(data)) {
                    this.liveCompleteAt = this.clock;
                    this.maybeCelebrateChapter();
                }
            }
            this.refreshVisibility();
            this.layout();
            this.place();
        }, this./** A dropped celebration must still check the box; reveal is idempotent. */ reveal = (taskId)=>{
            if (!this.pending.delete(taskId)) return;
            this.stamps.set(taskId, this.clock);
            this.layout();
        }, this./** The fanfare has flown into the panel: light it, and put the choice of what next on it. */ dock = ()=>{
            if (this.awaitingDockSince === undefined) return;
            this.awaitingDockSince = undefined;
            this.dockFlashAt = this.clock;
            this.ctaShownAt = this.clock;
            this.layout();
        }, this./**
     * The server's chapter prompts, routed here rather than to the bottom-of-screen board.
     * `null` retracts a "continue" (the server's way of taking its completion prompt down) but leaves
     * a "next" standing, which is how the old chip behaved.
     */ setCallToAction = (cta)=>{
            if (!cta) {
                if (this.cta?.kind !== "continue") return;
                if (this.ctaSpent) {
                    this.ctaRetiringAt = this.clock;
                    return;
                }
                this.cta = undefined;
                this.continueAt = undefined;
                this.refreshVisibility();
                this.layout();
                return;
            }
            if (this.cta && JSON.stringify(this.cta) === JSON.stringify(cta) && !this.ctaSpent) return;
            this.cta = cta;
            this.ctaSpent = false;
            this.ctaRetiringAt = undefined;
            this.ctaShownAt = this.clock;
            this.ctaHeldUntil = undefined;
            this.ctaPressedAt = undefined;
            this.ctaTop = undefined;
            if (cta.kind === "continue") {
                this.continueAt = this.clock;
                const finished = !!this.data && $355f6bd9e8d13e25$var$allDone(this.data);
                if (!finished && this.data) this.ctaHeldUntil = this.clock + $355f6bd9e8d13e25$var$CONTINUE_HOLD_MS;
                this.maybeCelebrateChapter();
            }
            if (!this.visible) this.boardHeight.snap($355f6bd9e8d13e25$var$UNFOLD_FROM);
            this.refreshVisibility();
            this.layout();
            this.place();
        }, this./** The next-chapter announcement is up: the button that opened it goes with it. */ clearNextChapter = ()=>{
            if (this.cta?.kind !== "next") return;
            this.cta = undefined;
            this.refreshVisibility();
            this.layout();
        }, this.hasCallToAction = ()=>!!this.cta, this.hasTasks = ()=>!!this.data, this./** Where a task's diamond lands, in global space: its socket, or its pip while folded. */ socketGlobal = (taskId)=>{
            if (!this.visible || !this.data) return undefined;
            const row = this.rows.find((entry)=>entry.task.id === taskId);
            if (row && !this.minimized) return this.toGlobal(new (0, $6qzqq.Point)($355f6bd9e8d13e25$var$SOCKET_X, row.top + row.height / 2));
            const index = this.data.tasks.findIndex((task)=>task.id === taskId);
            if (index < 0) return this.toGlobal(new (0, $6qzqq.Point)($355f6bd9e8d13e25$var$WIDTH / 2, this.headerBottom / 2));
            return this.toGlobal(this.pipCenter(index));
        }, this./** Where the fanfare docks: the button it leaves behind, or the panel's middle. */ panelGlobal = ()=>{
            if (!this.visible) return undefined;
            const box = this.liveCtaBox();
            return this.toGlobal(new (0, $6qzqq.Point)($355f6bd9e8d13e25$var$WIDTH / 2, box ? box.y + box.h / 2 : this.panelHeight / 2));
        }, this.maybeCelebrateChapter = ()=>{
            if (!this.data || this.liveCompleteAt === undefined || this.continueAt === undefined) return;
            if (this.fanfaredChapter === this.data.chapter) return;
            if (Math.abs(this.liveCompleteAt - this.continueAt) > $355f6bd9e8d13e25$var$COMPLETION_WINDOW_MS) return;
            this.fanfaredChapter = this.data.chapter;
            this.ctaHeldUntil = undefined;
            if (!this.events.onChapterCompleted) return;
            this.awaitingDockSince = this.clock;
            this.events.onChapterCompleted(this.data.chapter, this.data.title);
        }, this.refreshVisibility = ()=>{
            this.visible = !!this.data || !!this.cta;
            if (!this.visible) {
                this.endDrag();
                if (this.hovered) {
                    this.hovered = false;
                    this.hover(false);
                }
            }
        }, this.ctaVisible = ()=>!!this.cta && this.awaitingDockSince === undefined && !(this.ctaHeldUntil !== undefined && this.clock < this.ctaHeldUntil), this.complete = ()=>!!this.data && $355f6bd9e8d13e25$var$allDone(this.data) && this.pending.size === 0, this.shown = (task)=>task.complete && !this.pending.has(task.id), this.pipCenter = (index)=>{
            const count = this.data?.tasks.length || 0;
            const right = $355f6bd9e8d13e25$var$WIDTH - $355f6bd9e8d13e25$var$CONTENT_X - $355f6bd9e8d13e25$var$TOGGLE_W - 8;
            return new (0, $6qzqq.Point)(right - (count - 1 - index) * $355f6bd9e8d13e25$var$PIP_STEP, 15);
        }, this.text = (value, color, size, bold = false, wrap, spacing = 0, parent = this.content)=>{
            const renderer = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(size).bold(bold).color(color).strokeThickness(0);
            if (wrap) renderer.wordWrap(wrap);
            const text = renderer.render(value);
            if (spacing) text.style.letterSpacing = spacing;
            parent.addChild(text);
            return text;
        }, this.toggle = ()=>{
            if (this.collapsingAt !== undefined) return;
            if (this.minimized) {
                this.minimized = false;
                this.rowsInAt = this.clock;
                this.layout();
                this.place();
            } else if (this.rows.length || this.foldsToCompact()) // Fade out first; the fold itself happens when they have gone (settleClocks).
            this.collapsingAt = this.clock;
            else {
                this.minimized = true;
                this.layout();
            }
            this.toggleTurn.set(this.minimized || this.collapsingAt !== undefined ? 1 : 0, this.clock);
        }, this.foldsToCompact = ()=>!!this.cta && this.ctaVisible(), this.addToggle = (x, y)=>{
            // A drawn chevron that turns, rather than a "−" that swaps for a "+".
            this.toggleButton = new (0, $ead1577967896e68$export$d714cb42a300e44f)({
                label: "",
                size: "small",
                width: $355f6bd9e8d13e25$var$TOGGLE_W,
                height: $355f6bd9e8d13e25$var$TOGGLE_W,
                theme: "ember",
                appearance: "subtle",
                onClick: this.toggle
            });
            this.toggleButton.position.set(x, y);
            this.content.addChild(this.toggleButton);
            this.toggleGlyph.position.set(x + $355f6bd9e8d13e25$var$TOGGLE_W / 2, y + $355f6bd9e8d13e25$var$TOGGLE_W / 2);
            this.content.addChild(this.toggleGlyph);
        }, this.addHandle = (w, h)=>{
            const handle = this.headerHandle = new (0, $gwPoJ.Graphics)().beginFill(0xffffff, 0.001).drawRect(0, 0, w, h).endFill();
            handle.interactive = true;
            handle.cursor = this.drag ? "grabbing" : "grab";
            handle.on("pointerdown", this.startDrag).on("pointermove", this.moveDrag).on("pointerup", this.endDrag).on("pointerupoutside", this.endDrag).on("pointercancel", this.endDrag);
            this.content.addChild(handle);
        }, this.layout = ()=>{
            // The persistent pieces are lifted out before the rebuild destroys everything else.
            for (const keep of [
                this.ctaCover,
                this.toggleGlyph
            ])keep.parent?.removeChild(keep);
            this.content.removeChildren().forEach((child)=>child.destroy({
                    children: true
                }));
            this.rows = [];
            this.ctaButton = undefined;
            this.ctaLayer = undefined;
            this.ctaBox = undefined;
            this.chipBox = undefined;
            this.toggleButton = undefined;
            this.headerHandle = undefined;
            this.overline = this.title = this.chip = undefined;
            const previousCtaTop = this.ctaTop;
            this.ctaTop = undefined;
            if (!this.visible) {
                this.board.clear();
                this.under.clear();
                this.over.clear();
                this.pips.clear();
                this.contentMask.clear();
                this.paintedHeight = -1;
                return;
            }
            const data = this.data;
            const complete = this.complete();
            if (complete && data && this.completeAt === undefined) {
                this.completeAt = this.clock;
                this.headerGold.set(1, this.clock);
            }
            const mode = this.minimized && this.foldsToCompact() ? "compact" : this.minimized ? "folded" : "full";
            // Into or out of the bar the whole face changes, so it fades in afresh rather than sliding.
            const recomposed = this.mode !== undefined && mode !== this.mode && (mode === "compact" || this.mode === "compact");
            if (recomposed) this.contentInAt = this.clock;
            this.mode = mode;
            let y = 0;
            if (mode === "compact") y = this.layoutCompact();
            else if (data) {
                this.overline = this.text(`CHAPTER ${data.chapter}`, 0xffffff, 8, true, undefined, 1.6);
                this.overline.position.set($355f6bd9e8d13e25$var$CONTENT_X + 12, 10);
                this.title = this.text(data.title, 0xffffff, 13, true, $355f6bd9e8d13e25$var$WIDTH - $355f6bd9e8d13e25$var$CONTENT_X * 2);
                this.title.position.set($355f6bd9e8d13e25$var$CONTENT_X, 23);
                this.headerBottom = Math.max($355f6bd9e8d13e25$var$HEADER_HEIGHT, Math.ceil(this.title.y + this.title.height + 8));
                if (complete) {
                    // letterSpacing adds a trailing advance after the last glyph; take it back off.
                    this.chip = this.text("COMPLETE", (0, $2f9f1514035da1ec$export$c780db370c4a4d96), 7, true, undefined, 1.2);
                    const w = Math.ceil(this.chip.width - 1.2) + 12;
                    this.chipBox = {
                        x: $355f6bd9e8d13e25$var$WIDTH - $355f6bd9e8d13e25$var$CONTENT_X - $355f6bd9e8d13e25$var$TOGGLE_W - 6 - w,
                        w: w
                    };
                    this.chip.anchor.set(0.5, 0.5);
                    this.chip.position.set(this.chipBox.x + w / 2, 14.5);
                }
                this.addHandle($355f6bd9e8d13e25$var$WIDTH - $355f6bd9e8d13e25$var$TOGGLE_W - 14, this.headerBottom);
                this.addToggle($355f6bd9e8d13e25$var$WIDTH - $355f6bd9e8d13e25$var$CONTENT_X - $355f6bd9e8d13e25$var$TOGGLE_W + 4, 6);
                y = this.headerBottom;
                // The folded checklist keeps the first unfinished objective in list order.
                // Live celebrations may hold a completed row unchecked in the full list, but
                // the folded preview moves on as soon as the server marks it complete.
                const current = data.tasks.find((task)=>this.minimized ? !task.complete : !this.shown(task));
                const tasks = this.minimized ? current ? [
                    current
                ] : [] : data.tasks;
                if (tasks.length) {
                    y += 5;
                    tasks.forEach((task, index)=>{
                        const state = this.shown(task) ? "done" : task === current ? "current" : "todo";
                        const look = this.lookFor(task.id, state);
                        look.glow.set(state === "current" ? 1 : 0, this.clock);
                        look.tint.set($355f6bd9e8d13e25$var$rowTint(state), this.clock);
                        const label = this.text(task.label, 0xffffff, 11, false, $355f6bd9e8d13e25$var$WIDTH - $355f6bd9e8d13e25$var$LABEL_X - $355f6bd9e8d13e25$var$CONTENT_X);
                        const height = Math.max($355f6bd9e8d13e25$var$ROW_MIN_H, Math.ceil(label.height + 7));
                        label.position.set($355f6bd9e8d13e25$var$LABEL_X, y + (height - label.height) / 2);
                        const socket = new (0, $gwPoJ.Graphics)();
                        socket.position.set($355f6bd9e8d13e25$var$SOCKET_X, y + height / 2);
                        this.content.addChild(socket);
                        const row = {
                            task: task,
                            index: index,
                            socket: socket,
                            label: label,
                            top: y,
                            height: height,
                            state: state
                        };
                        this.rows.push(row);
                        this.paintSocket(row, 1);
                        y += height;
                    });
                    y += 5;
                }
            } else this.headerBottom = 0;
            if (mode !== "compact" && this.cta && this.ctaVisible()) y = this.layoutCallToAction(y, recomposed ? undefined : previousCtaTop);
            this.panelHeight = mode === "compact" ? y : Math.max(y, data ? this.headerBottom : 0);
            this.boardHeight.set(this.panelHeight, this.clock);
            this.paintedHeight = -1;
            this.animate(0);
        }, this.lookFor = (id, state)=>{
            let look = this.looks.get(id);
            if (!look) {
                // A row seen for the first time starts in its state; only CHANGES are eased.
                look = {
                    glow: new (0, $a8782f4c6450260e$export$f709befbd1bbaa29)(state === "current" ? 1 : 0, $355f6bd9e8d13e25$var$ROW_HANDOFF_MS),
                    tint: new (0, $a8782f4c6450260e$export$f709befbd1bbaa29)($355f6bd9e8d13e25$var$rowTint(state), $355f6bd9e8d13e25$var$ROW_HANDOFF_MS, (0, $a8782f4c6450260e$export$671c724dbdd0c3a9))
                };
                this.looks.set(id, look);
            }
            return look;
        }, this.layoutCallToAction = (top, previousTop)=>{
            const cta = this.cta;
            this.ctaTop = top;
            // The section keeps its place on screen while the rows above it fold, then glides to its new one.
            if (previousTop !== undefined && previousTop !== top) {
                this.ctaSlide.snap(previousTop - top + this.ctaSlide.value(this.clock));
                this.ctaSlide.set(0, this.clock);
            }
            const layer = this.ctaLayer = new (0, $8t5Gy.Container)();
            this.content.addChild(layer);
            let y = this.data ? 9 : 12;
            if (cta.kind === "continue") {
                if (cta.body) {
                    const body = this.text(cta.body, 0xd8c7ab, 10, false, $355f6bd9e8d13e25$var$WIDTH - $355f6bd9e8d13e25$var$CONTENT_X * 2 - 2, 0, layer);
                    body.position.set($355f6bd9e8d13e25$var$CONTENT_X + 1, y);
                    y += Math.ceil(body.height) + 9;
                }
            } else {
                const overline = this.text(`UP NEXT \xb7 CHAPTER ${cta.chapter}`, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 8, true, undefined, 1.4, layer);
                overline.position.set($355f6bd9e8d13e25$var$CONTENT_X + 1, y);
                y += 13;
                const title = this.text(cta.title, (0, $658a44ce960354bb$export$8eb3a98fbc1bd246), 12, true, $355f6bd9e8d13e25$var$WIDTH - $355f6bd9e8d13e25$var$CONTENT_X * 2, 0, layer);
                title.position.set($355f6bd9e8d13e25$var$CONTENT_X + 1, y);
                y += Math.ceil(title.height) + 9;
            }
            this.addCtaButton(layer, $355f6bd9e8d13e25$var$CONTENT_X, y, $355f6bd9e8d13e25$var$WIDTH - $355f6bd9e8d13e25$var$CONTENT_X * 2);
            return top + y + $355f6bd9e8d13e25$var$BUTTON_H + 12;
        }, this.layoutCompact = ()=>{
            this.ctaTop = 0;
            this.headerBottom = 0;
            const layer = this.ctaLayer = new (0, $8t5Gy.Container)();
            this.content.addChild(layer);
            let y = $355f6bd9e8d13e25$var$COMPACT_PAD;
            if (this.cta.kind === "next") {
                const overline = this.text(`UP NEXT \xb7 CHAPTER ${this.cta.chapter}`, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 8, true, undefined, 1.4, layer);
                overline.position.set($355f6bd9e8d13e25$var$CONTENT_X + 1, y);
                y += 13;
                const title = this.text(this.cta.title, (0, $658a44ce960354bb$export$8eb3a98fbc1bd246), 12, true, $355f6bd9e8d13e25$var$WIDTH - $355f6bd9e8d13e25$var$CONTENT_X * 2, 0, layer);
                title.position.set($355f6bd9e8d13e25$var$CONTENT_X + 1, y);
                y += Math.ceil(title.height) + 9;
            }
            const height = y + $355f6bd9e8d13e25$var$BUTTON_H + $355f6bd9e8d13e25$var$COMPACT_PAD;
            this.addHandle($355f6bd9e8d13e25$var$WIDTH, height);
            this.content.addChild(layer);
            const toggleX = $355f6bd9e8d13e25$var$WIDTH - 10 - $355f6bd9e8d13e25$var$TOGGLE_W;
            this.addCtaButton(layer, 10, y, toggleX - 6 - 10);
            this.addToggle(toggleX, y + ($355f6bd9e8d13e25$var$BUTTON_H - $355f6bd9e8d13e25$var$TOGGLE_W) / 2);
            return height;
        }, this.addCtaButton = (layer, x, y, w)=>{
            const cta = this.cta;
            const label = cta.kind === "continue" ? `${cta.label || "Continue"}  \u{203A}` : "Next Chapter  \u203A";
            const button = this.ctaButton = new (0, $ead1577967896e68$export$d714cb42a300e44f)({
                label: label,
                width: w,
                height: $355f6bd9e8d13e25$var$BUTTON_H,
                size: "small",
                theme: "ember",
                shape: "chamfer",
                variant: "primary",
                accent: (0, $2f9f1514035da1ec$export$d8df7395f14ba24a),
                textColor: (0, $658a44ce960354bb$export$8eb3a98fbc1bd246),
                bold: true,
                fontSize: 12,
                enabled: !this.ctaSpent,
                onClick: this.pressCallToAction
            });
            button.pivot.set(w / 2, $355f6bd9e8d13e25$var$BUTTON_H / 2);
            button.position.set(x + w / 2, y + $355f6bd9e8d13e25$var$BUTTON_H / 2);
            for (const event of [
                "pointerover",
                "mouseover"
            ])button.on(event, ()=>this.ctaHover.set(1, this.clock));
            for (const event of [
                "pointerout",
                "mouseout",
                "pointerupoutside",
                "pointercancel"
            ])button.on(event, ()=>this.ctaHover.set(0, this.clock));
            layer.addChild(button);
            // Over the button: the unlit plate the light crosses.
            layer.addChild(this.ctaCover);
            this.ctaBox = {
                x: x,
                y: y,
                w: w,
                h: $355f6bd9e8d13e25$var$BUTTON_H
            };
        }, this.liveCtaBox = ()=>{
            if (!this.ctaBox || this.ctaTop === undefined) return undefined;
            return {
                ...this.ctaBox,
                y: this.ctaBox.y + this.ctaTop + this.ctaSlide.value(this.clock)
            };
        }, this.pressCallToAction = ()=>{
            const cta = this.cta;
            if (!cta || this.ctaSpent || (0, $a8782f4c6450260e$export$7ae8158c70919485)(this.clock - this.ctaShownAt).ignite < 1) return;
            this.ctaPressedAt = this.clock;
            if (cta.kind === "continue") {
                this.ctaSpent = true;
                this.ctaSpentAt = this.clock;
                this.ctaHover.set(0, this.clock);
                this.ctaButton?.setEnabled(false);
                if (!this.minimized) this.toggle();
                this.events.onContinue?.();
            } else this.events.onNextChapter?.(cta.chapter);
        }, this.paintBoard = (h)=>{
            const g = this.board.clear();
            const w = $355f6bd9e8d13e25$var$WIDTH;
            const complete = this.complete();
            g.beginFill(0x000000, 0.3);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 0, 3, w, h, 7);
            g.endFill();
            g.lineStyle({
                width: 1.5,
                color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
                alpha: 0.95,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            g.beginFill((0, $658a44ce960354bb$export$611f5967b7e8b685), 0.95);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 0, 0, w, h, 7);
            g.endFill();
            const gold = this.headerGold.value(this.clock);
            g.lineStyle({
                width: 1,
                color: (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $658a44ce960354bb$export$dd27ce85ad53c944), (0, $2f9f1514035da1ec$export$81e981a732c8ab4a), complete ? gold : 0),
                alpha: 0.8 + 0.15 * gold,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            g.beginFill((0, $658a44ce960354bb$export$e969f1546e2d24ca), 0.9);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 4, 4, w - 8, Math.max(8, h - 8), 5);
            g.endFill();
            g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.16).moveTo(11, 5.5).lineTo(w - 11, 5.5);
            g.lineStyle(0);
            if (this.data && this.mode !== "compact") {
                // The header's gold spark, as on the tutorial board and the clues.
                g.beginFill((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 1);
                (0, $2f9f1514035da1ec$export$32465a74bc98bd3)(g, $355f6bd9e8d13e25$var$CONTENT_X + 4, 14, 4);
                g.endFill();
                if (this.rows.length && h > this.headerBottom + 2) (0, $658a44ce960354bb$export$5ed3e56f5245819d)(g, 10, w - 10, this.headerBottom);
                const ctaTop = this.ctaTop !== undefined ? this.ctaTop + this.ctaSlide.value(this.clock) : undefined;
                if (ctaTop !== undefined && h > ctaTop + 2) (0, $658a44ce960354bb$export$5ed3e56f5245819d)(g, 10, w - 10, ctaTop + (this.rows.length ? 0 : 1));
            }
            if (h > 30 && this.mode !== "compact") {
                (0, $658a44ce960354bb$export$514310343d21eee2)(g, 10, h - 10);
                (0, $658a44ce960354bb$export$514310343d21eee2)(g, w - 10, h - 10);
            }
        }, this.paintSocket = (row, checkDraw)=>{
            const g = row.socket.clear();
            if (row.state === "done") {
                (0, $2f9f1514035da1ec$export$7957c9215476f232)(g, 0, 0, $355f6bd9e8d13e25$var$SOCKET_R, checkDraw);
                return;
            }
            const glow = this.looks.get(row.task.id)?.glow.value(this.clock) ?? 0;
            g.lineStyle({
                width: 1,
                color: (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)($355f6bd9e8d13e25$var$SOCKET_RIM_TODO, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), glow),
                alpha: 1,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            g.beginFill($355f6bd9e8d13e25$var$SOCKET_EMPTY, 1);
            (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(g, 0, 0, $355f6bd9e8d13e25$var$SOCKET_R);
            g.endFill();
            g.lineStyle(0);
        }, this./** Frame-driven; deltaTime in ms. Repaints the live layers and settles anything in flight. */ animate = (deltaTime)=>{
            this.clock += Math.max(0, Math.min(100, deltaTime || 0));
            if (!this.visible) return;
            this.settleClocks();
            if (!this.visible) return;
            const height = this.boardHeight.value(this.clock);
            if (Math.abs(height - this.paintedHeight) > 0.01 || !this.ctaSlide.settled(this.clock) || !this.headerGold.settled(this.clock)) {
                this.paintedHeight = height;
                this.paintBoard(height);
            }
            // Clip the content to the board only while the board is moving; a stencil otherwise is waste.
            const folding = !this.boardHeight.settled(this.clock);
            this.contentMask.clear();
            if (folding) this.contentMask.beginFill(0xffffff, 1).drawRect(0, 0, $355f6bd9e8d13e25$var$WIDTH, height).endFill();
            this.content.mask = folding ? this.contentMask : null;
            if (this.ctaLayer && this.ctaTop !== undefined) this.ctaLayer.y = this.ctaTop + this.ctaSlide.value(this.clock);
            // Folding to the bar fades everything out, then the bar's face fades in as the board shrinks.
            let contentAlpha = this.contentInAt === undefined ? 1 : (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(this.clock - this.contentInAt, 0, $355f6bd9e8d13e25$var$CONTENT_FADE_MS));
            if (this.collapsingAt !== undefined && this.foldsToCompact()) contentAlpha = Math.min(contentAlpha, 1 - (0, $a8782f4c6450260e$export$5da70c9577229d30)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(this.clock - this.collapsingAt, 0, this.collapseMs())));
            this.content.alpha = contentAlpha;
            this.pips.alpha = contentAlpha;
            if (this.contentInAt !== undefined && this.clock - this.contentInAt > $355f6bd9e8d13e25$var$CONTENT_FADE_MS) this.contentInAt = undefined;
            const under = this.under.clear();
            const over = this.over.clear();
            this.paintHeader(over);
            this.paintToggle();
            const pulse = (0, $a8782f4c6450260e$export$f98af890f38e203b)(this.clock);
            this.rows.forEach((row)=>this.paintRow(row, pulse, under, over));
            this.stamps.forEach((startedAt, id)=>{
                const pose = (0, $a8782f4c6450260e$export$b67b2e3d2289fb95)(this.clock - startedAt);
                if (pose.panelFlash > 0) this.paintRimGlow(over, pose.panelFlash * 0.7, height);
                if (pose.done) {
                    this.stamps.delete(id);
                    const row = this.rows.find((entry)=>entry.task.id === id);
                    if (row) {
                        row.socket.scale.set(1);
                        this.paintSocket(row, 1);
                    }
                }
            });
            if (this.dockFlashAt !== undefined) {
                const t = (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(this.clock - this.dockFlashAt, 0, 900);
                this.paintRimGlow(over, 1 - (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(t), height);
                (0, $2f9f1514035da1ec$export$11572259c1b566fa)(under, $355f6bd9e8d13e25$var$WIDTH / 2, height / 2, $355f6bd9e8d13e25$var$WIDTH * 0.7, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.35 * (1 - t), 5);
                if (t >= 1) this.dockFlashAt = undefined;
            }
            this.paintCallToAction(under, over);
        }, this.paintHeader = (over)=>{
            const gold = this.headerGold.value(this.clock);
            if (this.overline) this.overline.tint = (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $658a44ce960354bb$export$6b1db5e247c0ce0), (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), gold);
            if (this.title) this.title.tint = (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $658a44ce960354bb$export$8eb3a98fbc1bd246), (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), gold);
            const g = this.pips.clear();
            if (!this.data || this.mode === "compact") return;
            // The pips give way to the COMPLETE chip, which lights up in their place.
            const sinceComplete = this.completeAt === undefined ? -1 : this.clock - this.completeAt;
            const pipsAlpha = sinceComplete < 0 ? 1 : 1 - (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(sinceComplete, 0, 260));
            if (pipsAlpha > 0) this.data.tasks.forEach((task, index)=>{
                const { x: x, y: y } = this.pipCenter(index);
                const stampedAt = this.stamps.get(task.id);
                if (this.shown(task)) {
                    const pop = stampedAt === undefined ? 1 : (0, $a8782f4c6450260e$export$3a89f8d6f6bf6c9f)(2.2, 1, (0, $a8782f4c6450260e$export$3daa4a78f444687d)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(this.clock - stampedAt, 0, 380), 2.4));
                    if (stampedAt !== undefined) (0, $2f9f1514035da1ec$export$11572259c1b566fa)(over, x, y, 9 * pop, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.6 * (2.2 - pop), 3);
                    g.lineStyle(0).beginFill((0, $2f9f1514035da1ec$export$81e981a732c8ab4a), pipsAlpha);
                    (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(g, x, y, $355f6bd9e8d13e25$var$PIP_R * pop);
                    g.endFill();
                    g.beginFill((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), pipsAlpha);
                    (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(g, x, y - 0.6 * pop, $355f6bd9e8d13e25$var$PIP_R * 0.55 * pop);
                    g.endFill();
                } else {
                    g.lineStyle(1, $355f6bd9e8d13e25$var$SOCKET_RIM_TODO, pipsAlpha).beginFill($355f6bd9e8d13e25$var$SOCKET_EMPTY, pipsAlpha);
                    (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(g, x, y, $355f6bd9e8d13e25$var$PIP_R);
                    g.endFill();
                    g.lineStyle(0);
                }
            });
            if (this.chip && this.chipBox) {
                const t = sinceComplete < 0 ? 1 : (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(sinceComplete, 180, 560);
                const scale = sinceComplete < 0 ? 1 : (0, $a8782f4c6450260e$export$3a89f8d6f6bf6c9f)(1.8, 1, (0, $a8782f4c6450260e$export$3daa4a78f444687d)(t, 2.4));
                const alpha = sinceComplete < 0 ? 1 : (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(sinceComplete, 180, 300));
                const { x: x, w: w } = this.chipBox;
                const cx = x + w / 2, cy = 14.5;
                g.lineStyle({
                    width: 1,
                    color: 0x6b4a14,
                    alpha: alpha,
                    join: (0, $gwPoJ.LINE_JOIN).MITER
                });
                g.beginFill((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), alpha);
                (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, cx - w / 2 * scale, cy - 6.5 * scale, w * scale, 13 * scale, 3 * scale);
                g.endFill();
                g.lineStyle(0);
                this.chip.scale.set(scale);
                this.chip.alpha = alpha;
                if (sinceComplete >= 0 && sinceComplete < 1400) {
                    (0, $2f9f1514035da1ec$export$11572259c1b566fa)(over, cx, cy, w * 0.8, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.5 * (1 - (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(sinceComplete, 180, 1100)), 4);
                    (0, $2f9f1514035da1ec$export$e1c6fe5ee848dc6d)(over, cx, cy, (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(sinceComplete, 200, 760), 10, w / 2, w / 2 + 22, (0, $2f9f1514035da1ec$export$81e981a732c8ab4a), 0.4);
                    (0, $2f9f1514035da1ec$export$f2d9b1fa89f3b31e)(over, x, cy - 6.5, w, 13, (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(sinceComplete, 560, 1100), 16, 0.6);
                }
            }
        }, this.paintToggle = ()=>{
            const g = this.toggleGlyph.clear();
            if (!this.toggleButton) return;
            // Pointing down while open; turns to point right as the list folds away.
            g.rotation = -Math.PI / 2 * this.toggleTurn.value(this.clock);
            g.lineStyle({
                width: 1.6,
                color: (0, $658a44ce960354bb$export$6b1db5e247c0ce0),
                alpha: 0.9,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            g.moveTo(-3.5, -1.5).lineTo(0, 2).lineTo(3.5, -1.5);
            g.lineStyle(0);
        }, this.paintRow = (row, pulse, under, over)=>{
            const look = this.looks.get(row.task.id);
            const n = this.rows.length;
            // Cascading in on expand (and on first sight); fading out, last row first, on collapse.
            let alpha = this.rowsInAt === undefined ? 1 : (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(this.clock - this.rowsInAt, row.index * $355f6bd9e8d13e25$var$ROW_IN_STAGGER, row.index * $355f6bd9e8d13e25$var$ROW_IN_STAGGER + $355f6bd9e8d13e25$var$ROW_IN_MS));
            if (this.collapsingAt !== undefined) {
                const from = (n - 1 - row.index) * $355f6bd9e8d13e25$var$ROW_OUT_STAGGER;
                alpha = Math.min(alpha, 1 - (0, $a8782f4c6450260e$export$5da70c9577229d30)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(this.clock - this.collapsingAt, from, from + $355f6bd9e8d13e25$var$ROW_OUT_MS)));
            }
            const slide = -8 * (1 - alpha);
            row.label.alpha = alpha;
            row.socket.alpha = alpha;
            row.label.x = $355f6bd9e8d13e25$var$LABEL_X + slide;
            row.socket.x = $355f6bd9e8d13e25$var$SOCKET_X + slide;
            const cx = $355f6bd9e8d13e25$var$SOCKET_X + slide, cy = row.top + row.height / 2;
            const glow = (look?.glow.value(this.clock) ?? 0) * alpha;
            let tint = look?.tint.value(this.clock) ?? $355f6bd9e8d13e25$var$rowTint(row.state);
            // The objective to do next glows softly: a warm band across its row, an ember breathing in its
            // socket, and its label warming and cooling with the breath. Eased in and out, so finishing a
            // task hands the glow down the list instead of switching it.
            if (glow > 0.01) {
                // Strongest at the socket, fading out across the row in fine steps (coarse ones show).
                const steps = 16, stepW = ($355f6bd9e8d13e25$var$WIDTH - 12) / steps;
                for(let i = 0; i < steps; i++){
                    const k = 1 - i / steps;
                    under.beginFill((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), (0.04 + 0.02 * pulse) * k * k * glow).drawRect(6 + i * stepW, row.top + 1, stepW + 0.5, row.height - 2).endFill();
                }
                (0, $2f9f1514035da1ec$export$11572259c1b566fa)(over, cx, cy, 8 + pulse * 2.5, (0, $2f9f1514035da1ec$export$a946f851ecf2e2e0), (0.2 + 0.18 * pulse) * glow);
                over.beginFill((0, $2f9f1514035da1ec$export$81e981a732c8ab4a), (0.45 + 0.4 * pulse) * glow).drawCircle(cx, cy, 1.5 + pulse * 0.5).endFill();
                if (row.state === "current") tint = (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)(tint, $355f6bd9e8d13e25$var$CURRENT_WARM, 0.35 * pulse * glow);
            }
            if (row.state !== "done" && look && !look.glow.settled(this.clock)) this.paintSocket(row, 1);
            const stampedAt = this.stamps.get(row.task.id);
            if (stampedAt !== undefined) {
                const pose = (0, $a8782f4c6450260e$export$b67b2e3d2289fb95)(this.clock - stampedAt);
                row.socket.scale.set(pose.socketScale);
                this.paintSocket(row, pose.checkDraw);
                tint = (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)($355f6bd9e8d13e25$var$DONE_TEXT, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), pose.labelGold);
                (0, $2f9f1514035da1ec$export$11572259c1b566fa)(under, cx, cy, 18 * (1 - pose.ringT * 0.5), (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.9 * (1 - pose.ringT));
                if (pose.ringT < 1) {
                    over.lineStyle({
                        width: 2 * (1 - pose.ringT) + 0.5,
                        color: (0, $2f9f1514035da1ec$export$d8df7395f14ba24a),
                        alpha: 1 - pose.ringT,
                        join: (0, $gwPoJ.LINE_JOIN).MITER
                    });
                    (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(over, cx, cy, (0, $a8782f4c6450260e$export$3a89f8d6f6bf6c9f)($355f6bd9e8d13e25$var$SOCKET_R, 24, (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(pose.ringT)));
                    over.lineStyle(0);
                }
                (0, $2f9f1514035da1ec$export$e1c6fe5ee848dc6d)(over, cx, cy, pose.sparkT, 10, 7, 26, (0, $2f9f1514035da1ec$export$81e981a732c8ab4a), row.index);
                if (pose.sweepT > 0 && pose.sweepT < 1) (0, $2f9f1514035da1ec$export$f2d9b1fa89f3b31e)(over, 6, row.top, $355f6bd9e8d13e25$var$WIDTH - 12, row.height, pose.sweepT, 46, 0.32, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a));
            }
            row.label.tint = tint;
        }, this.settleClocks = ()=>{
            let changed = false;
            this.pending.forEach((since, id)=>{
                if (this.clock - since > $355f6bd9e8d13e25$var$PENDING_REVEAL_LIMIT_MS) {
                    this.pending.delete(id);
                    this.stamps.set(id, this.clock);
                    changed = true;
                }
            });
            if (this.awaitingDockSince !== undefined && this.clock - this.awaitingDockSince > $355f6bd9e8d13e25$var$DOCK_LIMIT_MS) {
                this.awaitingDockSince = undefined;
                this.ctaShownAt = this.clock;
                changed = true;
            }
            if (this.ctaHeldUntil !== undefined && this.clock >= this.ctaHeldUntil) {
                this.ctaHeldUntil = undefined;
                this.ctaShownAt = this.clock;
                changed = true;
            }
            if (this.ctaRetiringAt !== undefined && this.clock - this.ctaRetiringAt > $355f6bd9e8d13e25$var$RETIRE_MS) {
                this.ctaRetiringAt = undefined;
                this.cta = undefined;
                this.ctaSpent = false;
                this.refreshVisibility();
                changed = true;
            }
            if (this.collapsingAt !== undefined && this.clock - this.collapsingAt >= this.collapseMs()) {
                this.collapsingAt = undefined;
                this.rowsInAt = undefined;
                this.minimized = true;
                changed = true;
            }
            if (this.rowsInAt !== undefined && this.clock - this.rowsInAt > $355f6bd9e8d13e25$var$ROW_IN_MS + $355f6bd9e8d13e25$var$ROW_IN_STAGGER * this.rows.length) this.rowsInAt = undefined;
            if (changed) {
                this.layout();
                this.place();
            }
        }, this.collapseMs = ()=>$355f6bd9e8d13e25$var$ROW_OUT_MS + $355f6bd9e8d13e25$var$ROW_OUT_STAGGER * Math.max(0, this.rows.length - 1), this.paintRimGlow = (g, strength, height)=>{
            if (!(strength > 0)) return;
            for(let i = 0; i < 3; i++){
                g.lineStyle({
                    width: 2 + i * 3,
                    color: (0, $2f9f1514035da1ec$export$d8df7395f14ba24a),
                    alpha: strength * (0.5 - i * 0.14),
                    join: (0, $gwPoJ.LINE_JOIN).MITER
                });
                (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 1, 1, $355f6bd9e8d13e25$var$WIDTH - 2, height - 2, 7);
            }
            g.lineStyle(0);
        }, this.paintCallToAction = (under, over)=>{
            const cover = this.ctaCover.clear();
            const box = this.liveCtaBox(), button = this.ctaButton;
            if (!box || !button || !this.ctaBox) return;
            const pose = (0, $a8782f4c6450260e$export$7ae8158c70919485)(this.clock - this.ctaShownAt);
            const hover = this.ctaHover.value(this.clock);
            const spent = this.ctaSpent ? (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(this.clock - this.ctaSpentAt, 0, 380)) : 0;
            if (this.ctaLayer) {
                this.ctaLayer.alpha = pose.plateAlpha;
                this.ctaLayer.y += pose.rise;
            }
            const local = this.ctaBox;
            button.scale.set(1 + 0.03 * hover * (1 - spent));
            button.alpha = 1 - 0.45 * spent;
            // The unlit plate, drawn over the lit button and drawn back from the left as the light comes.
            if (pose.ignite < 1) {
                const front = local.w * pose.ignite;
                cover.lineStyle({
                    width: 1,
                    color: $355f6bd9e8d13e25$var$UNLIT_RIM,
                    alpha: 1,
                    join: (0, $gwPoJ.LINE_JOIN).MITER
                });
                cover.beginFill($355f6bd9e8d13e25$var$UNLIT_FILL, 1);
                const left = local.x + front;
                const c = Math.min(5, local.h / 4);
                if (front <= c) (0, $658a44ce960354bb$export$99dca9ebbafa6899)(cover, local.x, local.y, local.w, local.h, c);
                else cover.moveTo(left, local.y).lineTo(local.x + local.w - c, local.y).lineTo(local.x + local.w, local.y + c).lineTo(local.x + local.w, local.y + local.h - c).lineTo(local.x + local.w - c, local.y + local.h).lineTo(left, local.y + local.h).closePath();
                cover.endFill();
                cover.lineStyle(0);
            }
            const by = box.y + pose.rise;
            if (pose.edge > 0) {
                const x = box.x + box.w * pose.ignite;
                for(let i = 0; i < 3; i++)over.beginFill(i === 0 ? (0, $2f9f1514035da1ec$export$6237dac50234d3bb) : (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), pose.edge * (0.55 - i * 0.17)).drawRect(x - 1 - i * 2, by - i * 1.5, 2 + i * 4, box.h + i * 3).endFill();
                (0, $2f9f1514035da1ec$export$11572259c1b566fa)(over, x, by + box.h / 2, 16, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.35 * pose.edge, 3);
            }
            const glow = (0.6 * pose.glow + 0.3 * hover) * (1 - spent);
            const cx = box.x + box.w / 2, cy = by + box.h / 2;
            if (glow > 0.01) {
                for(let i = 0; i < 4; i++){
                    const grow = 2 + i * 3;
                    under.lineStyle({
                        width: 3 + i * 2,
                        color: i < 2 ? (0, $2f9f1514035da1ec$export$d8df7395f14ba24a) : (0, $2f9f1514035da1ec$export$a946f851ecf2e2e0),
                        alpha: glow * (0.34 - i * 0.07),
                        join: (0, $gwPoJ.LINE_JOIN).MITER
                    });
                    (0, $658a44ce960354bb$export$99dca9ebbafa6899)(under, cx - box.w / 2 - grow, cy - box.h / 2 - grow, box.w + grow * 2, box.h + grow * 2, 6);
                }
                under.lineStyle(0);
            }
            if (pose.shineT >= 0 && !this.ctaSpent) (0, $2f9f1514035da1ec$export$f2d9b1fa89f3b31e)(over, box.x + 2, by + 2, box.w - 4, box.h - 4, pose.shineT, 30, 0.22);
            if (hover > 0.01 && !this.ctaSpent) {
                over.beginFill((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.06 * hover);
                (0, $658a44ce960354bb$export$99dca9ebbafa6899)(over, box.x + 1, by + 1, box.w - 2, box.h - 2, 4);
                over.endFill();
            }
            // The press answers: a flash through the plate and a ring of sparks off it.
            if (this.ctaPressedAt !== undefined) {
                const t = (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(this.clock - this.ctaPressedAt, 0, 520);
                if (t < 1) {
                    over.beginFill((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.35 * (1 - (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(t)));
                    (0, $658a44ce960354bb$export$99dca9ebbafa6899)(over, box.x, by, box.w, box.h, 5);
                    over.endFill();
                    (0, $2f9f1514035da1ec$export$e1c6fe5ee848dc6d)(over, cx, cy, t, 12, box.h / 2, box.h / 2 + 22, (0, $2f9f1514035da1ec$export$81e981a732c8ab4a), 0.1, 1.5);
                } else this.ctaPressedAt = undefined;
            }
        }, this.startDrag = (event)=>{
            if (this.drag || !this.parent || (event.data.button ?? 0) !== 0) return;
            event.stopPropagation();
            const at = this.parent.toLocal(event.data.global);
            let interaction;
            try {
                interaction = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer.plugins.interaction;
            } catch  {
            /* Standalone previews use header events. */ }
            this.drag = {
                id: event.data.pointerId,
                offset: new (0, $6qzqq.Point)(at.x - this.x, at.y - this.y),
                interaction: interaction
            };
            this.manualPosition = this.position.clone();
            this.headerHandle.cursor = "grabbing";
            this.hovered = true;
            this.hover(true);
            interaction?.on("pointermove", this.moveDrag);
            interaction?.on("pointerup", this.endDrag);
            interaction?.on("pointerupoutside", this.endDrag);
            interaction?.on("pointercancel", this.endDrag);
        }, this.moveDrag = (event)=>{
            if (!this.drag || !this.parent || event.data.pointerId !== this.drag.id) return;
            event.stopPropagation();
            const at = this.parent.toLocal(event.data.global);
            this.manualPosition.set(at.x - this.drag.offset.x, at.y - this.drag.offset.y);
            this.place();
        }, this.endDrag = (event)=>{
            if (!this.drag || event && event.data.pointerId !== this.drag.id) return;
            const interaction = this.drag.interaction;
            interaction?.off("pointermove", this.moveDrag);
            interaction?.off("pointerup", this.endDrag);
            interaction?.off("pointerupoutside", this.endDrag);
            interaction?.off("pointercancel", this.endDrag);
            this.drag = undefined;
            if (this.headerHandle && !this.headerHandle.destroyed) this.headerHandle.cursor = "grab";
            this.hovered = !!event?.data?.global && this.getBounds().contains(event.data.global.x, event.data.global.y);
            this.hover(this.hovered);
        }, this.place = ()=>{
            if (!this.visible) return;
            const safe = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().safeViewport;
            const desired = this.manualPosition || this.anchor() || {
                x: safe.left + 12,
                y: safe.top + 64
            };
            const fit = Math.max(0.2, Math.min(1, (safe.width - 24) / $355f6bd9e8d13e25$var$WIDTH, (safe.height - 24) / this.panelHeight));
            this.scale.set(fit);
            const x = Math.max(safe.left, Math.min(desired.x, Math.max(safe.left, safe.right - $355f6bd9e8d13e25$var$WIDTH * fit)));
            const y = Math.max(safe.top, Math.min(desired.y, Math.max(safe.top, safe.bottom - this.panelHeight * fit)));
            this.position.set(x, y);
            this.manualPosition?.set(x, y);
        }, this.destroy = ()=>{
            this.endDrag();
            if (this.hovered) this.hover(false);
            for (const keep of [
                this.ctaCover,
                this.toggleGlyph
            ])keep.parent?.removeChild(keep);
            this.ctaCover.destroy();
            this.toggleGlyph.destroy();
            super.destroy({
                children: true
            });
        };
        this.visible = false;
        this.interactive = true;
        this.under.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.over.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.addChild(this.board, this.under, this.pips, this.content, this.contentMask, this.over);
        this.on("mouseover", ()=>{
            this.hovered = true;
            this.hover(true);
        });
        this.on("mouseout", ()=>{
            if (!this.drag) {
                this.hovered = false;
                this.hover(false);
            }
        });
        this.on("pointerdown", (event)=>event.stopPropagation());
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $6qzqq = parcelRequire("6qzqq");
var $P8XPi = parcelRequire("P8XPi");





const $06087902db7be4a6$var$TOAST_H = 48;
const $06087902db7be4a6$var$TOAST_SOCKET_X = 26;
const $06087902db7be4a6$var$TOAST_TEXT_X = 46;
const $06087902db7be4a6$var$TOAST_SOCKET_R = 9;
const $06087902db7be4a6$var$TRAIL = 12;
const $06087902db7be4a6$var$MOTE_EVERY_MS = 40;
const $06087902db7be4a6$var$MOTE_MAX = 40;
const $06087902db7be4a6$var$RAYS = 16;
// Candidate centres as fractions of the viewport, in order of preference: below the characters
// first, then above them, then off to either side.
const $06087902db7be4a6$var$TOAST_SLOTS = [
    [
        0.5,
        0.72
    ],
    [
        0.5,
        0.21
    ],
    [
        0.28,
        0.72
    ],
    [
        0.72,
        0.72
    ],
    [
        0.28,
        0.21
    ],
    [
        0.72,
        0.21
    ]
];
const $06087902db7be4a6$var$BANNER_SLOTS = [
    [
        0.5,
        0.68
    ],
    [
        0.5,
        0.29
    ]
];
const $06087902db7be4a6$var$SLOT_MARGIN = 14;
const $06087902db7be4a6$var$GLIDE_MS = 320;
const $06087902db7be4a6$var$overlapArea = (a, b)=>Math.max(0, Math.min(a.x + a.w, b.x + b.w) - Math.max(a.x, b.x)) * Math.max(0, Math.min(a.y + a.h, b.y + b.h) - Math.max(a.y, b.y));
const $06087902db7be4a6$export$19ab083117e3b429 = (slots, w, h, obstacles)=>{
    let best = 0, bestArea = Infinity;
    slots.forEach((slot, index)=>{
        const box = {
            x: slot.x - w / 2,
            y: slot.y - h / 2,
            w: w,
            h: h
        };
        const area = obstacles.reduce((sum, obstacle)=>sum + $06087902db7be4a6$var$overlapArea(box, obstacle), 0);
        if (area < bestArea) {
            best = index;
            bestArea = area;
        }
    });
    return {
        index: best,
        area: bestArea
    };
};
class $06087902db7be4a6$export$8092756ceb312dc6 extends (0, $8t5Gy.Container) {
    constructor(onCue = ()=>undefined, viewport = ()=>(0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().safeViewport, avoid = ()=>[]){
        super(), this.onCue = onCue, this.viewport = viewport, this.avoid = avoid, this.queue = [], this.glow = new (0, $gwPoJ.Graphics)(), this.backing = new (0, $gwPoJ.Graphics)(), this.stage_ = new (0, $8t5Gy.Container)(), this.plate = new (0, $gwPoJ.Graphics)(), this.fx = new (0, $gwPoJ.Graphics)(), this.cometBody = new (0, $gwPoJ.Graphics)(), this.texts = [], this.motes = [], this.moteClock = 0, this.toastW = 220, this.titleBox = {
            x: 0,
            y: 0,
            w: 0,
            h: 0
        }, this.stampW = 0, this.atX = new (0, $a8782f4c6450260e$export$f709befbd1bbaa29)(0, $06087902db7be4a6$var$GLIDE_MS), this.atY = new (0, $a8782f4c6450260e$export$f709befbd1bbaa29)(0, $06087902db7be4a6$var$GLIDE_MS), this.slot = 0, this./** A task finished: toast it, then fly its diamond to `target` and call `onArrive` there. */ taskComplete = (label, target, onArrive)=>{
            this.enqueue({
                kind: "task",
                title: label,
                target: target,
                onArrive: onArrive,
                ms: 0,
                hold: (0, $a8782f4c6450260e$export$6b88bd29e71fedd0),
                arrived: false,
                trail: []
            });
        }, this./** The chapter finished: the fanfare, docking into `target`. */ chapterComplete = (chapter, title, target, onArrive)=>{
            this.enqueue({
                kind: "chapter",
                chapter: chapter,
                title: title,
                target: target,
                onArrive: onArrive,
                ms: 0,
                hold: 0,
                arrived: false,
                trail: []
            });
        }, this.isBusy = ()=>!!this.beat || this.queue.length > 0, this./** Room change: land everything at once, so no row is left unchecked and no button unreachable. */ flush = ()=>{
            const beats = [
                ...this.beat ? [
                    this.beat
                ] : [],
                ...this.queue
            ];
            this.queue = [];
            this.endBeat();
            beats.forEach((beat)=>{
                if (!beat.arrived) beat.onArrive();
            });
        }, this.enqueue = (beat)=>{
            this.queue.push(beat);
            if (!this.beat) this.startNext();
        }, this.startNext = ()=>{
            this.endBeat();
            const beat = this.queue.shift();
            if (!beat) return;
            this.beat = beat;
            this.visible = true;
            if (beat.kind === "task") {
                this.buildToast(beat);
                this.onCue("task");
            } else {
                this.buildBanner(beat);
                this.onCue("chapter");
            }
            this.settle(beat);
        }, this.endBeat = ()=>{
            this.beat = undefined;
            this.texts.forEach((text)=>{
                if (!text.destroyed) text.destroy();
            });
            this.texts = [];
            this.stampText = undefined;
            this.motes = [];
            this.plate.clear();
            this.glow.clear();
            this.fx.clear();
            this.cometBody.clear();
            this.backing.clear();
            this.stage_.scale.set(1);
            this.stage_.alpha = 1;
            this.visible = false;
        }, this.text = (value, color, size, bold, spacing = 0, stroke = 0)=>{
            const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(size).bold(bold).color(color).strokeThickness(stroke).render(value);
            if (spacing) text.style.letterSpacing = spacing;
            this.texts.push(text);
            this.stage_.addChild(text);
            return text;
        }, this.footprint = (beat)=>beat.kind === "task" ? {
                w: this.toastW + $06087902db7be4a6$var$SLOT_MARGIN * 2,
                h: $06087902db7be4a6$var$TOAST_H + $06087902db7be4a6$var$SLOT_MARGIN * 2
            } : {
                w: Math.min(this.viewport().width, this.titleBox.w + 80),
                h: 120
            }, this.slotCentres = (beat)=>{
            const view = this.viewport();
            return (beat.kind === "task" ? $06087902db7be4a6$var$TOAST_SLOTS : $06087902db7be4a6$var$BANNER_SLOTS).map(([fx, fy])=>({
                    x: view.left + view.width * fx,
                    y: view.top + view.height * fy
                }));
        }, this.obstacles = ()=>this.avoid().map((rect)=>{
                const a = this.toLocal(new (0, $6qzqq.Point)(rect.x, rect.y));
                const b = this.toLocal(new (0, $6qzqq.Point)(rect.x + rect.w, rect.y + rect.h));
                return {
                    x: Math.min(a.x, b.x),
                    y: Math.min(a.y, b.y),
                    w: Math.abs(b.x - a.x),
                    h: Math.abs(b.y - a.y)
                };
            }), this.center = (beat, settling)=>{
            const centres = this.slotCentres(beat);
            const { w: w, h: h } = this.footprint(beat);
            if (settling) {
                const obstacles = this.obstacles();
                const here = centres[this.slot] || centres[0];
                const hereArea = $06087902db7be4a6$export$19ab083117e3b429([
                    here
                ], w, h, obstacles).area;
                if (hereArea > 0) {
                    const best = $06087902db7be4a6$export$19ab083117e3b429(centres, w, h, obstacles);
                    if (best.area < hereArea && best.index !== this.slot) {
                        this.slot = best.index;
                        this.atX.set(centres[best.index].x, beat.ms);
                        this.atY.set(centres[best.index].y, beat.ms);
                    }
                }
            }
            return {
                x: this.atX.value(beat.ms),
                y: this.atY.value(beat.ms)
            };
        }, this.settle = (beat)=>{
            const centres = this.slotCentres(beat);
            const { w: w, h: h } = this.footprint(beat);
            this.slot = $06087902db7be4a6$export$19ab083117e3b429(centres, w, h, this.obstacles()).index;
            this.atX.snap(centres[this.slot].x);
            this.atY.snap(centres[this.slot].y);
        }, this.buildToast = (beat)=>{
            const overline = this.text("TASK COMPLETE", (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 8, true, 1.8);
            const label = this.text(beat.title, (0, $658a44ce960354bb$export$8eb3a98fbc1bd246), 13, true);
            this.toastW = Math.max(210, Math.ceil(Math.max(label.width, overline.width) + $06087902db7be4a6$var$TOAST_TEXT_X + 22));
            overline.position.set($06087902db7be4a6$var$TOAST_TEXT_X, 10);
            label.position.set($06087902db7be4a6$var$TOAST_TEXT_X, 22);
            const g = this.plate.clear();
            const w = this.toastW, h = $06087902db7be4a6$var$TOAST_H;
            g.beginFill(0x000000, 0.35);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 0, 4, w, h, 7);
            g.endFill();
            g.lineStyle({
                width: 1.5,
                color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
                alpha: 0.95,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            g.beginFill((0, $658a44ce960354bb$export$611f5967b7e8b685), 0.97);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 0, 0, w, h, 7);
            g.endFill();
            g.lineStyle({
                width: 1,
                color: (0, $2f9f1514035da1ec$export$81e981a732c8ab4a),
                alpha: 0.9,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            g.beginFill((0, $658a44ce960354bb$export$e969f1546e2d24ca), 0.96);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 4, 4, w - 8, h - 8, 5);
            g.endFill();
            g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.22).moveTo(11, 5.5).lineTo(w - 11, 5.5);
            g.lineStyle(0);
            (0, $2f9f1514035da1ec$export$7957c9215476f232)(g, $06087902db7be4a6$var$TOAST_SOCKET_X, h / 2, $06087902db7be4a6$var$TOAST_SOCKET_R);
            this.stage_.pivot.set(w / 2, h / 2);
        }, this.animateToast = (beat)=>{
            const pose = (0, $a8782f4c6450260e$export$f1e303297d2a4077)(beat.ms, beat.hold);
            const { x: x, y: toastY } = this.center(beat, beat.ms < (0, $a8782f4c6450260e$export$2e4600308c0388c8)(beat.hold).leaveAt);
            this.stage_.position.set(x, toastY + pose.lift);
            this.stage_.scale.set(pose.scale);
            this.stage_.alpha = Math.max(0, pose.alpha);
            // Where the toast's socket is on screen, for the comet to set off from.
            const socket = {
                x: x + ($06087902db7be4a6$var$TOAST_SOCKET_X - this.toastW / 2) * pose.scale,
                y: toastY + pose.lift
            };
            const fx = this.fx.clear();
            const glow = this.glow.clear();
            if (pose.alpha > 0) {
                (0, $2f9f1514035da1ec$export$11572259c1b566fa)(glow, x, toastY + pose.lift, this.toastW * 0.62 * pose.scale, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.22 * pose.alpha * (1 - pose.burstT * 0.5), 5);
                (0, $2f9f1514035da1ec$export$11572259c1b566fa)(glow, socket.x, socket.y, 22, (0, $2f9f1514035da1ec$export$81e981a732c8ab4a), 0.6 * pose.alpha, 4);
            }
            (0, $2f9f1514035da1ec$export$e1c6fe5ee848dc6d)(fx, socket.x, socket.y, pose.burstT, 14, 12, 46, (0, $2f9f1514035da1ec$export$81e981a732c8ab4a), 0.3, 2);
            if (pose.burstT > 0 && pose.burstT < 1) {
                const t = (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(pose.burstT);
                fx.lineStyle({
                    width: 2.5 * (1 - pose.burstT) + 0.5,
                    color: (0, $2f9f1514035da1ec$export$d8df7395f14ba24a),
                    alpha: 1 - pose.burstT,
                    join: (0, $gwPoJ.LINE_JOIN).MITER
                });
                fx.drawEllipse(x, toastY + pose.lift, this.toastW / 2 + 6 + 40 * t, $06087902db7be4a6$var$TOAST_H / 2 + 6 + 22 * t);
                fx.lineStyle(0);
            }
            if (pose.shineT > 0 && pose.shineT < 1 && pose.alpha > 0.5) {
                const left = x - this.toastW / 2 * pose.scale, top = toastY + pose.lift - $06087902db7be4a6$var$TOAST_H / 2 * pose.scale;
                (0, $2f9f1514035da1ec$export$f2d9b1fa89f3b31e)(fx, left + 5, top + 5, (this.toastW - 10) * pose.scale, ($06087902db7be4a6$var$TOAST_H - 10) * pose.scale, pose.shineT, 40, 0.3);
            }
            this.flyComet(beat, pose.cometT, socket, $06087902db7be4a6$var$TOAST_SOCKET_R, 6);
            if (pose.arrived && !beat.arrived) this.arrive(beat);
            if (beat.ms >= (0, $a8782f4c6450260e$export$2e4600308c0388c8)(beat.hold).endAt) this.startNext();
        }, this.buildBanner = (beat)=>{
            const overline = this.text(`CHAPTER ${beat.chapter}`, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 12, true, 5, 3);
            const title = this.text(beat.title, (0, $658a44ce960354bb$export$8eb3a98fbc1bd246), 30, true, 0.5, 4);
            const stamp = this.stampText = this.text("COMPLETE", (0, $2f9f1514035da1ec$export$c780db370c4a4d96), 13, true, 4);
            overline.anchor.set(0.5, 0.5);
            title.anchor.set(0.5, 0.5);
            stamp.anchor.set(0.5, 0.5);
            overline.position.set(0, -36);
            title.position.set(0, 0);
            stamp.position.set(0, 40);
            this.titleBox = {
                x: -title.width / 2,
                y: -title.height / 2,
                w: title.width,
                h: title.height
            };
            this.stampW = stamp.width + 26;
            this.stage_.pivot.set(0, 0);
        }, this.animateBanner = (beat)=>{
            const pose = (0, $a8782f4c6450260e$export$5f0e9cd2ff3dbcb8)(beat.ms);
            const { x: x, y: y } = this.center(beat, beat.ms < (0, $a8782f4c6450260e$export$591a652e66acb793)().dockAt - 300);
            const view = this.viewport();
            // Docking: the banner draws in on itself while its heart flies off as the comet.
            this.stage_.position.set(x, y);
            this.stage_.scale.set(pose.bannerScale);
            this.stage_.alpha = pose.bannerAlpha;
            // The shadow ribbon the type stands on, so it reads over grass, snow or night alike.
            const backing = this.backing.clear();
            const ribbon = Math.min(view.width, 620);
            const bandAlpha = 0.55 * Math.min(pose.titleAlpha, pose.bannerAlpha);
            for(let i = 0; i < 10; i++){
                const k = i / 10;
                backing.beginFill(0x0b0705, bandAlpha / 10).drawRect(x - ribbon / 2 * (1 - k * 0.6), y - 62 + k * 6, ribbon * (1 - k * 0.6), 124 - k * 12).endFill();
            }
            const glow = this.glow.clear();
            const fx = this.fx.clear();
            // The flash and the shockwave.
            if (pose.flash > 0) (0, $2f9f1514035da1ec$export$11572259c1b566fa)(glow, x, y, 260, (0, $2f9f1514035da1ec$export$6237dac50234d3bb), 0.55 * pose.flash, 6);
            if (pose.ringT > 0 && pose.ringT < 1) {
                const t = (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(pose.ringT);
                for (const [lag, width] of [
                    [
                        0,
                        4
                    ],
                    [
                        0.12,
                        2
                    ]
                ]){
                    const k = Math.max(0, t - lag);
                    fx.lineStyle({
                        width: width * (1 - pose.ringT) + 0.5,
                        color: (0, $2f9f1514035da1ec$export$d8df7395f14ba24a),
                        alpha: (1 - pose.ringT) * 0.9
                    });
                    fx.drawEllipse(x, y, 60 + 300 * k, (60 + 300 * k) * 0.42);
                }
                fx.lineStyle(0);
            }
            // Rays opening behind the title, turning slowly while it holds.
            if (pose.raysAlpha > 0) {
                const turn = beat.ms / 9000 * Math.PI * 2;
                // Short enough to stay under the speakers standing above the banner.
                const reach = 205 * pose.raysOpen;
                for(let i = 0; i < $06087902db7be4a6$var$RAYS; i++){
                    const a = turn + i / $06087902db7be4a6$var$RAYS * Math.PI * 2;
                    const half = i % 2 ? 0.05 : 0.09;
                    const len = reach * (i % 2 ? 0.75 : 1);
                    glow.beginFill(i % 3 ? (0, $2f9f1514035da1ec$export$d8df7395f14ba24a) : (0, $2f9f1514035da1ec$export$a946f851ecf2e2e0), 0.13 * pose.raysAlpha);
                    glow.moveTo(x, y).lineTo(x + Math.cos(a - half) * len, y + Math.sin(a - half) * len * 0.62).lineTo(x + Math.cos(a + half) * len, y + Math.sin(a + half) * len * 0.62).closePath();
                    glow.endFill();
                }
                (0, $2f9f1514035da1ec$export$11572259c1b566fa)(glow, x, y, 170 * pose.raysOpen, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.45 * pose.raysAlpha, 6);
            }
            // The type.
            const [overline, title] = this.texts;
            if (overline) overline.alpha = pose.overlineAlpha;
            if (title) {
                title.alpha = pose.titleAlpha;
                title.scale.set(pose.titleScale);
            }
            // The rule under the title and the plate the stamp is on are drawn into the moving stage.
            const plate = this.plate.clear();
            if (pose.rule > 0) {
                const half = (this.titleBox.w / 2 + 30) * pose.rule;
                plate.lineStyle(2, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.9).moveTo(-half, 20).lineTo(half, 20);
                plate.lineStyle(0);
                plate.beginFill((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 1);
                (0, $2f9f1514035da1ec$export$32465a74bc98bd3)(plate, -half, 20, 4);
                (0, $2f9f1514035da1ec$export$32465a74bc98bd3)(plate, half, 20, 4);
                plate.endFill();
            }
            if (this.stampText) {
                this.stampText.alpha = pose.stampAlpha;
                this.stampText.scale.set(pose.stampScale);
                this.stampText.rotation = -0.05;
                if (pose.stampScale > 0) {
                    const w = this.stampW * pose.stampScale, h = 22 * pose.stampScale;
                    plate.lineStyle({
                        width: 1.5,
                        color: 0x6b4a14,
                        alpha: pose.stampAlpha,
                        join: (0, $gwPoJ.LINE_JOIN).MITER
                    });
                    plate.beginFill((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), pose.stampAlpha);
                    const c = Math.cos(-0.05), s = Math.sin(-0.05);
                    const corners = [
                        [
                            -w / 2 + 6,
                            -h / 2
                        ],
                        [
                            w / 2 - 6,
                            -h / 2
                        ],
                        [
                            w / 2,
                            0
                        ],
                        [
                            w / 2 - 6,
                            h / 2
                        ],
                        [
                            -w / 2 + 6,
                            h / 2
                        ],
                        [
                            -w / 2,
                            0
                        ]
                    ];
                    plate.drawPolygon(corners.flatMap(([px, py])=>[
                            px * c - py * s,
                            40 + px * s + py * c
                        ]));
                    plate.endFill();
                    plate.lineStyle(0);
                }
            }
            (0, $2f9f1514035da1ec$export$e1c6fe5ee848dc6d)(fx, x, y + 40, pose.stampBurstT, 18, 30, 110, (0, $2f9f1514035da1ec$export$81e981a732c8ab4a), 0.2, 2.2);
            (0, $2f9f1514035da1ec$export$e1c6fe5ee848dc6d)(fx, x, y, (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(beat.ms, 0, 700), 24, 40, 200, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0, 2.5);
            if (pose.shineT > 0 && pose.shineT < 1 && pose.bannerAlpha > 0.5) (0, $2f9f1514035da1ec$export$f2d9b1fa89f3b31e)(fx, x + this.titleBox.x * pose.titleScale, y + this.titleBox.y * pose.titleScale, this.titleBox.w * pose.titleScale, this.titleBox.h * pose.titleScale, pose.shineT, 60, 0.42);
            this.animateMotes(fx, x, y, pose.embers);
            this.flyComet(beat, pose.cometT, {
                x: x,
                y: y
            }, 12, 8);
            if (pose.arrived && !beat.arrived) this.arrive(beat);
            if (beat.ms >= (0, $a8782f4c6450260e$export$591a652e66acb793)().endAt) this.startNext();
        }, this.animateMotes = (g, cx, cy, emitting)=>{
            if (emitting) while(this.moteClock >= $06087902db7be4a6$var$MOTE_EVERY_MS && this.motes.length < $06087902db7be4a6$var$MOTE_MAX){
                this.moteClock -= $06087902db7be4a6$var$MOTE_EVERY_MS;
                this.motes.push({
                    x: cx + (Math.random() - 0.5) * 420,
                    y: cy + 40 + Math.random() * 30,
                    vx: (Math.random() - 0.5) * 0.02,
                    vy: -(0.04 + Math.random() * 0.06),
                    age: 0,
                    life: 1100 + Math.random() * 900,
                    r: 0.8 + Math.random() * 1.6
                });
            }
            this.motes = this.motes.filter((mote)=>mote.age < mote.life);
            this.motes.forEach((mote)=>{
                const k = mote.age / mote.life;
                const alpha = Math.sin(Math.PI * k);
                g.beginFill(k < 0.5 ? (0, $2f9f1514035da1ec$export$d8df7395f14ba24a) : (0, $2f9f1514035da1ec$export$a946f851ecf2e2e0), 0.85 * alpha).drawCircle(mote.x, mote.y, mote.r).endFill();
                g.beginFill((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.18 * alpha).drawCircle(mote.x, mote.y, mote.r * 3).endFill();
            });
        }, this.targetLocal = (beat)=>{
            const global = beat.target();
            return global ? this.toLocal(global) : undefined;
        }, this.flyComet = (beat, t, from, r0, r1)=>{
            const body = this.cometBody.clear();
            if (t < 0 || beat.arrived) return;
            if (!beat.from) beat.from = {
                ...from
            };
            const target = this.targetLocal(beat);
            if (!target) return;
            // Bow up and over: a thrown thing, not a slide.
            const via = {
                x: (beat.from.x + target.x) / 2,
                y: Math.min(beat.from.y, target.y) - 60
            };
            const head = (0, $a8782f4c6450260e$export$75c48cadd9435142)(beat.from, via, target, t);
            beat.trail.unshift(head);
            if (beat.trail.length > $06087902db7be4a6$var$TRAIL) beat.trail.length = $06087902db7be4a6$var$TRAIL;
            const fx = this.fx;
            beat.trail.forEach((p, i)=>{
                const k = 1 - i / $06087902db7be4a6$var$TRAIL;
                fx.beginFill(i < 3 ? (0, $2f9f1514035da1ec$export$6237dac50234d3bb) : (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.5 * k).drawCircle(p.x, p.y, Math.max(1, (0, $a8782f4c6450260e$export$3a89f8d6f6bf6c9f)(r1, r0, 1 - t) * 0.8 * k)).endFill();
                fx.beginFill((0, $2f9f1514035da1ec$export$a946f851ecf2e2e0), 0.12 * k).drawCircle(p.x, p.y, (0, $a8782f4c6450260e$export$3a89f8d6f6bf6c9f)(r1, r0, 1 - t) * 2.2 * k).endFill();
            });
            (0, $2f9f1514035da1ec$export$11572259c1b566fa)(fx, head.x, head.y, 22, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.7, 4);
            (0, $2f9f1514035da1ec$export$7957c9215476f232)(body, head.x, head.y, (0, $a8782f4c6450260e$export$3a89f8d6f6bf6c9f)(r0, r1, t));
        }, this.arrive = (beat)=>{
            beat.arrived = true;
            this.cometBody.clear();
            beat.onArrive();
            this.onCue("stamp");
        }, this./** Frame-driven; deltaTime in ms. */ animate = (deltaTime)=>{
            const beat = this.beat;
            if (!beat) return;
            const dt = Math.max(0, Math.min(100, deltaTime || 0));
            beat.ms += dt;
            this.moteClock += dt;
            this.motes.forEach((mote)=>{
                mote.age += dt;
                mote.x += mote.vx * dt;
                mote.y += mote.vy * dt;
            });
            // A toast with others queued behind it says its piece faster.
            if (beat.kind === "task") beat.hold = this.queue.length ? Math.min(beat.hold, (0, $a8782f4c6450260e$export$3285fc20e13e2402)) : beat.hold;
            if (beat.kind === "task") this.animateToast(beat);
            else this.animateBanner(beat);
        }, this.destroy = ()=>{
            this.endBeat();
            super.destroy({
                children: true
            });
        };
        this.interactive = false;
        this.interactiveChildren = false;
        this.glow.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.fx.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.stage_.addChild(this.plate);
        this.addChild(this.backing, this.glow, this.stage_, this.fx, this.cometBody);
        this.visible = false;
    }
}



parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $P8XPi = parcelRequire("P8XPi");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $6qzqq = parcelRequire("6qzqq");






const $902b76aaa1df7480$var$CREST_R = 24;
const $902b76aaa1df7480$var$CREST_Y = $902b76aaa1df7480$var$CREST_R + 8;
const $902b76aaa1df7480$var$CREST_INSET = 6;
const $902b76aaa1df7480$var$RULE_GAP = 10;
const $902b76aaa1df7480$var$OVERLINE_GAP = 16;
const $902b76aaa1df7480$var$TITLE_GAP = 8;
const $902b76aaa1df7480$var$BODY_GAP = 14;
const $902b76aaa1df7480$var$ACTIONS_GAP = 34;
const $902b76aaa1df7480$var$BUTTON_H = 36;
const $902b76aaa1df7480$var$BEGIN_W = 176;
const $902b76aaa1df7480$var$LATER_W = 150;
const $902b76aaa1df7480$var$STACK_GAP = 10;
// The unlit plate the light crosses as Begin lights up (the checklist's call to action's colours).
const $902b76aaa1df7480$var$UNLIT_FILL = 0x2a201a;
const $902b76aaa1df7480$var$UNLIT_RIM = 0x6b4f38;
const $902b76aaa1df7480$var$COVER = 0x0d0a08;
const $902b76aaa1df7480$var$TITLE_CREAM = 0xfff3e0;
const $902b76aaa1df7480$var$FLASH = 0xffe2a8;
const $902b76aaa1df7480$var$EMBER_MAX = 46;
const $902b76aaa1df7480$var$EMBER_EVERY_MS = 95;
// One frame never advances the card more than this, so a loading hitch under the cover cannot
// swallow the reveal.
const $902b76aaa1df7480$var$MAX_STEP_MS = 50;
const $902b76aaa1df7480$var$NUMBER_WORDS = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve"
];
const $902b76aaa1df7480$export$c0c6b1ae5e23071c = (chapter)=>`CHAPTER ${($902b76aaa1df7480$var$NUMBER_WORDS[chapter] || String(chapter)).toUpperCase()}`;
let $902b76aaa1df7480$var$softGlow;
/**
 * A white radial falloff baked once, tinted per use. Null where there is no 2D canvas (the jest
 * mock): the glows are then simply not drawn rather than drawn as solid squares.
 */ const $902b76aaa1df7480$var$softGlowTexture = ()=>{
    if ($902b76aaa1df7480$var$softGlow !== undefined) return $902b76aaa1df7480$var$softGlow;
    try {
        const canvas = document.createElement("canvas");
        canvas.width = canvas.height = 128;
        const ctx = canvas.getContext("2d");
        if (!ctx || typeof ctx.createRadialGradient !== "function") return $902b76aaa1df7480$var$softGlow = null;
        const gradient = ctx.createRadialGradient(64, 64, 0, 64, 64, 64);
        // Roughly gaussian, so neither the middle nor the rim reads as an edge.
        for (const [stop, alpha] of [
            [
                0,
                1
            ],
            [
                0.2,
                0.72
            ],
            [
                0.4,
                0.38
            ],
            [
                0.6,
                0.15
            ],
            [
                0.8,
                0.04
            ],
            [
                1,
                0
            ]
        ])gradient.addColorStop(stop, `rgba(255,255,255,${alpha})`);
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 128, 128);
        $902b76aaa1df7480$var$softGlow = (0, $klOfb.Texture).from(canvas);
    } catch (e) {
        $902b76aaa1df7480$var$softGlow = null;
    }
    return $902b76aaa1df7480$var$softGlow;
};
class $902b76aaa1df7480$var$Glow extends (0, $7Bs2Z.Sprite) {
    constructor(color){
        const texture = $902b76aaa1df7480$var$softGlowTexture();
        super(texture || (0, $klOfb.Texture).EMPTY), /** Centre (x, y), radii (rx, ry) to where the falloff reaches nothing. */ this.place = (x, y, rx, ry, alpha)=>{
            this.position.set(x, y);
            this.width = rx * 2;
            this.height = ry * 2;
            this.alpha = Math.max(0, Math.min(1, alpha));
            this.visible = this.alpha > 0.003;
        };
        this.anchor.set(0.5);
        this.tint = color;
        this.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.renderable = !!texture;
    }
}
class $902b76aaa1df7480$export$1ecb9b86807e092e extends (0, $8t5Gy.Container) {
    constructor(onBegin, canBegin = ()=>true, onLater, onCue = ()=>undefined){
        super(), this.onBegin = onBegin, this.canBegin = canBegin, this.onLater = onLater, this.onCue = onCue, this.backdrop = new (0, $gwPoJ.Graphics)(), this.hearthLayer = new (0, $8t5Gy.Container)(), this.hearthWide = new $902b76aaa1df7480$var$Glow((0, $2f9f1514035da1ec$export$a946f851ecf2e2e0)), this.hearthCore = new $902b76aaa1df7480$var$Glow((0, $2f9f1514035da1ec$export$81e981a732c8ab4a)), this.hearthHigh = new $902b76aaa1df7480$var$Glow((0, $2f9f1514035da1ec$export$d8df7395f14ba24a)), this.emberHalos = new (0, $8t5Gy.Container)(), this.halos = [], this.embers = new (0, $gwPoJ.Graphics)(), this.content = new (0, $8t5Gy.Container)(), this.glows = new (0, $8t5Gy.Container)(), this.titleGlow = new $902b76aaa1df7480$var$Glow((0, $2f9f1514035da1ec$export$d8df7395f14ba24a)), this.crestGlow = new $902b76aaa1df7480$var$Glow((0, $2f9f1514035da1ec$export$d8df7395f14ba24a)), this.crestCore = new $902b76aaa1df7480$var$Glow((0, $2f9f1514035da1ec$export$81e981a732c8ab4a)), this.flash = new $902b76aaa1df7480$var$Glow($902b76aaa1df7480$var$FLASH), this.nibs = [
            new $902b76aaa1df7480$var$Glow((0, $2f9f1514035da1ec$export$d8df7395f14ba24a)),
            new $902b76aaa1df7480$var$Glow((0, $2f9f1514035da1ec$export$d8df7395f14ba24a))
        ], this.under = new (0, $gwPoJ.Graphics)(), this.ornament = new (0, $gwPoJ.Graphics)(), this.words = new (0, $8t5Gy.Container)(), this.actions = new (0, $8t5Gy.Container)(), this.ctaCover = new (0, $gwPoJ.Graphics)(), this.fx = new (0, $gwPoJ.Graphics)(), this.ms = 0, this.hover = new (0, $a8782f4c6450260e$export$f709befbd1bbaa29)(0, 160), this.motes = [], this.moteClock = 0, this.bounds = new (0, $6qzqq.Rectangle)(0, 0, 800, 600), this.layoutHeight = 0, this.ruleHalf = 200, this.fit = 1, this.cueRevealed = false, this.open = (prompt)=>{
            // Login and camp entry can both announce the same chapter. Preserve its current state.
            if (this.visible && this.chapter === prompt.announcementChapter) return;
            this.clearContent();
            this.chapter = prompt.announcementChapter;
            this.exit = undefined;
            this.ms = 0;
            this.moteClock = 0;
            this.motes = [];
            this.cueRevealed = false;
            this.hover.snap(0);
            // The cover is opaque on the very first frame, before room loading can reveal the world.
            this.alpha = 1;
            this.visible = true;
            const chapter = this.chapter || 1;
            this.digit = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(22).bold(true).color(0xffffff).strokeThickness(0).render(String(chapter));
            this.digit.anchor.set(0.5, 0.5);
            this.overline = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(13).bold(true).color((0, $658a44ce960354bb$export$6b1db5e247c0ce0)).strokeThickness(0).render($902b76aaa1df7480$export$c0c6b1ae5e23071c(chapter));
            this.overline.style.letterSpacing = 5;
            // White, so the heat can tint it: ember gold on arrival, cooling to the panel cream.
            this.title = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("display").color(0xffffff).strokeThickness(0).wordWrap(560).render(prompt.title);
            this.description = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("body").color(0xc9bba7).strokeThickness(0).wordWrap(560).render(prompt.body);
            for (const text of [
                this.overline,
                this.title,
                this.description
            ]){
                text.anchor.set(0.5, 0);
                text.style.align = "center";
            }
            this.words.addChild(this.digit, this.overline, this.title, this.description);
            this.button = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
                label: "Begin",
                theme: "ember",
                shape: "chamfer",
                preset: "primary",
                accent: (0, $2f9f1514035da1ec$export$d8df7395f14ba24a),
                textColor: (0, $658a44ce960354bb$export$8eb3a98fbc1bd246),
                bold: true,
                width: $902b76aaa1df7480$var$BEGIN_W,
                height: $902b76aaa1df7480$var$BUTTON_H,
                size: "medium",
                onClick: this.begin
            });
            for (const event of [
                "pointerover",
                "mouseover"
            ])this.button.on(event, ()=>this.hover.set(1, this.ms));
            for (const event of [
                "pointerout",
                "mouseout",
                "pointerupoutside",
                "pointercancel"
            ])this.button.on(event, ()=>this.hover.set(0, this.ms));
            this.actions.addChild(this.button);
            if (chapter >= 2) {
                this.laterButton = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
                    label: "Later",
                    theme: "ember",
                    shape: "chamfer",
                    variant: "secondary",
                    textColor: (0, $97475243e21a0995$export$4569a0b09aa32d6c),
                    width: $902b76aaa1df7480$var$LATER_W,
                    height: $902b76aaa1df7480$var$BUTTON_H,
                    size: "medium",
                    onClick: this.maybeLater
                });
                this.actions.addChild(this.laterButton);
            }
            this.actions.addChild(this.ctaCover);
            this.actions.interactiveChildren = false;
            this.laidOut = undefined;
            this.resize(this.bounds.width, this.bounds.height, this.bounds.x, this.bounds.y);
            this.pose();
        }, this.clearContent = ()=>{
            for (const child of [
                this.digit,
                this.overline,
                this.title,
                this.description,
                this.button,
                this.laterButton
            ])if (child && !child.destroyed) child.destroy({
                children: true
            });
            this.digit = this.overline = this.title = this.description = undefined;
            this.button = this.laterButton = undefined;
            this.ctaCover.clear();
        }, this./** Called every frame with the screen in local coordinates; lays out only when something changed. */ resize = (width, height, x = 0, y = 0)=>{
            this.bounds = new (0, $6qzqq.Rectangle)(x, y, width, height);
            this.hitArea = this.bounds;
            const key = `${x}|${y}|${width}|${height}|${this.chapter}`;
            if (this.laidOut === key) return;
            this.laidOut = key;
            this.backdrop.clear().beginFill($902b76aaa1df7480$var$COVER, 1).drawRect(x, y, width, height).endFill();
            // The hearth: a warm glow from a fire just below the frame, so the card reads as a story
            // told at the fire rather than a loading screen.
            const cx = x + width / 2;
            this.hearthWide.place(cx, y + height * 1.12, width * 0.78, height * 0.9, 0.62);
            this.hearthCore.place(cx, y + height * 1.04, width * 0.36, height * 0.42, 0.42);
            this.hearthHigh.place(cx, y + height * 0.4, width * 0.42, height * 0.36, 0.08);
            this.layoutContent(width, height, x, y);
        }, this.layoutContent = (width, height, x, y)=>{
            const { overline: overline, title: title, description: description, button: button } = this;
            if (!overline || !title || !description || !button || !this.digit) return;
            const wrap = Math.min(560, Math.max(160, width - 48));
            title.style.wordWrapWidth = wrap;
            description.style.wordWrapWidth = wrap;
            const overlineY = $902b76aaa1df7480$var$CREST_Y + $902b76aaa1df7480$var$CREST_R + $902b76aaa1df7480$var$OVERLINE_GAP;
            const titleY = overlineY + overline.height + $902b76aaa1df7480$var$TITLE_GAP;
            const bodyY = titleY + Math.max(title.height, 48) + $902b76aaa1df7480$var$BODY_GAP;
            const actionsY = bodyY + Math.max(description.height, 22) + $902b76aaa1df7480$var$ACTIONS_GAP;
            overline.position.set(0, overlineY);
            title.position.set(0, titleY);
            description.position.set(0, bodyY);
            this.digit.position.set(0, $902b76aaa1df7480$var$CREST_Y);
            const stacked = width < 400;
            this.actions.position.set(0, actionsY);
            if (this.laterButton && !stacked) {
                button.position.set(6, 0);
                this.laterButton.position.set(-6 - $902b76aaa1df7480$var$LATER_W, 0);
            } else {
                button.position.set(-$902b76aaa1df7480$var$BEGIN_W / 2, 0);
                this.laterButton?.position.set(-$902b76aaa1df7480$var$LATER_W / 2, $902b76aaa1df7480$var$BUTTON_H + $902b76aaa1df7480$var$STACK_GAP);
            }
            this.layoutHeight = actionsY + $902b76aaa1df7480$var$BUTTON_H + (this.laterButton && stacked ? $902b76aaa1df7480$var$BUTTON_H + $902b76aaa1df7480$var$STACK_GAP : 0);
            this.ruleHalf = Math.max($902b76aaa1df7480$var$CREST_R + $902b76aaa1df7480$var$RULE_GAP + 40, Math.min(230, width / 2 - 36));
            this.fit = Math.min(1, Math.max(0.2, (height - 48) / Math.max(1, this.layoutHeight)));
            // Pivot on the middle so the push-in on Begin grows from the centre of the words.
            this.content.pivot.set(0, this.layoutHeight / 2);
            this.content.x = x + width / 2;
            // A touch above centre: the optical middle of a title card.
            const half = this.layoutHeight * this.fit / 2;
            this.content.y = Math.min(y + Math.max(24 + half, height * 0.47), y + height - 24 - half);
            this.content.scale.set(this.fit);
        }, this.isOpen = ()=>this.visible, this./** True once the card has finished arriving and its actions take input. */ isReady = ()=>this.visible && !this.exit && this.ms >= (0, $a8782f4c6450260e$export$e030a49c2fd33dd2), this./** Begin is deliberately unavailable until the card has finished arriving. */ begin = ()=>{
            if (!this.isReady() || !this.canBegin()) return;
            this.exit = {
                kind: "begin",
                ms: 0
            };
            this.actions.interactiveChildren = false;
            this.onCue("launch");
        }, this.maybeLater = ()=>{
            if (!this.isReady() || (this.chapter || 1) < 2 || !this.canBegin()) return;
            this.exit = {
                kind: "later",
                ms: 0
            };
            this.actions.interactiveChildren = false;
        }, this.close = ()=>{
            this.chapter = undefined;
            this.visible = false;
            this.exit = undefined;
            this.motes = [];
            this.embers.clear();
            this.halos.forEach((halo)=>{
                halo.visible = false;
            });
        }, this.animate = (dtMs)=>{
            if (!this.visible) return;
            const dt = Math.max(0, Math.min($902b76aaa1df7480$var$MAX_STEP_MS, dtMs || 0));
            this.ms += dt;
            if (this.exit) this.exit.ms += dt;
            if (!this.cueRevealed && this.ms >= (0, $a8782f4c6450260e$export$17fa3046cb6a40e)) {
                this.cueRevealed = true;
                this.onCue("reveal");
            }
            this.stepEmbers(dt);
            this.pose();
            const exit = this.exit;
            if (exit && (exit.kind === "begin" ? (0, $a8782f4c6450260e$export$e30b297803fc4af7)(exit.ms) : (0, $a8782f4c6450260e$export$16764a2d3c490b4a)(exit.ms)).done) {
                const chapter = this.chapter;
                this.close();
                if (chapter !== undefined) {
                    if (exit.kind === "later") this.onLater?.(chapter);
                    else this.onBegin(chapter);
                }
            }
        }, this.pose = ()=>{
            const pose = (0, $a8782f4c6450260e$export$979371c67e3966f9)(this.ms);
            const launch = this.exit?.kind === "begin" ? (0, $a8782f4c6450260e$export$e30b297803fc4af7)(this.exit.ms) : undefined;
            const later = this.exit?.kind === "later" ? (0, $a8782f4c6450260e$export$16764a2d3c490b4a)(this.exit.ms) : undefined;
            const flare = launch?.flare || 0;
            this.alpha = launch ? launch.coverAlpha : later ? later.coverAlpha : 1;
            this.content.alpha = launch ? launch.contentAlpha : later ? later.contentAlpha : 1;
            this.content.scale.set(this.fit * (1 + 0.08 * (launch?.push || 0)));
            this.hearthLayer.alpha = pose.hearth * (0.8 + 0.2 * flare);
            if (!this.actions.interactiveChildren && pose.ready && !this.exit) this.actions.interactiveChildren = true;
            const fx = this.fx.clear();
            this.under.clear();
            this.poseCrest(pose, flare);
            this.poseRule(pose);
            const lit = pose.lit * pose.crestAlpha;
            this.flash.place(0, $902b76aaa1df7480$var$CREST_Y, 130, 130, 0.55 * pose.flash);
            this.crestGlow.place(0, $902b76aaa1df7480$var$CREST_Y, 90 + 50 * flare, 90 + 50 * flare, 0.42 * lit + 0.4 * flare);
            this.crestCore.place(0, $902b76aaa1df7480$var$CREST_Y, 42, 42, 0.5 * lit + 0.3 * flare);
            this.ring(fx, pose.ringT);
            if (launch) this.ring(fx, launch.ringT);
            (0, $2f9f1514035da1ec$export$e1c6fe5ee848dc6d)(fx, 0, $902b76aaa1df7480$var$CREST_Y, pose.burstT, 16, $902b76aaa1df7480$var$CREST_R + 2, $902b76aaa1df7480$var$CREST_R + 66, (0, $2f9f1514035da1ec$export$81e981a732c8ab4a), 0.2, 1.8);
            if (launch) (0, $2f9f1514035da1ec$export$e1c6fe5ee848dc6d)(fx, 0, $902b76aaa1df7480$var$CREST_Y, launch.burstT, 14, $902b76aaa1df7480$var$CREST_R + 4, $902b76aaa1df7480$var$CREST_R + 84, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.45, 1.6);
            if (this.overline) {
                this.overline.alpha = pose.overlineAlpha;
                this.overline.pivot.y = -pose.overlineRise;
            }
            if (this.title) {
                const heat = Math.max(pose.heat, 0.65 * flare);
                this.title.alpha = pose.titleAlpha;
                this.title.pivot.y = -pose.titleRise / pose.titleScale;
                this.title.scale.set(pose.titleScale);
                this.title.tint = (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)($902b76aaa1df7480$var$TITLE_CREAM, (0, $2f9f1514035da1ec$export$81e981a732c8ab4a), heat);
                const w = this.title.width, h = this.title.height;
                const top = this.title.y + pose.titleRise;
                this.titleGlow.place(0, top + h / 2, w * 0.7 + 40, h * 0.9 + 30, pose.titleAlpha * (0.14 + 0.26 * heat));
                if (pose.titleShineT >= 0) (0, $2f9f1514035da1ec$export$f2d9b1fa89f3b31e)(fx, -w / 2, top, w, h, pose.titleShineT, 70, 0.32);
            }
            if (this.description) {
                this.description.alpha = pose.bodyAlpha * (launch ? launch.bodyAlpha : 1);
                this.description.pivot.y = -pose.bodyRise;
            }
            this.poseActions(pose, launch, this.under, fx);
        }, this.poseCrest = (pose, flare)=>{
            const g = this.ornament.clear();
            const alpha = pose.crestAlpha;
            if (!(alpha > 0)) {
                if (this.digit) this.digit.alpha = 0;
                return;
            }
            const s = pose.crestScale;
            const r = $902b76aaa1df7480$var$CREST_R * s, cy = $902b76aaa1df7480$var$CREST_Y, lit = pose.lit;
            g.beginFill(0x000000, 0.45 * alpha);
            (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(g, 0, cy + 3, r);
            g.endFill();
            g.lineStyle({
                width: 1.5,
                color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
                alpha: alpha,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            g.beginFill((0, $a8782f4c6450260e$export$671c724dbdd0c3a9)($902b76aaa1df7480$var$UNLIT_RIM, (0, $2f9f1514035da1ec$export$81e981a732c8ab4a), lit), alpha);
            (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(g, 0, cy, r);
            g.endFill();
            g.lineStyle(0);
            // The upper facets of the frame catch the light once it is lit.
            if (lit > 0) {
                g.beginFill((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), alpha * lit);
                g.moveTo(0, cy - r + 1).lineTo(r - 1, cy).lineTo(0, cy + 0.5).lineTo(-r + 1, cy).closePath();
                g.endFill();
                g.beginFill((0, $2f9f1514035da1ec$export$6237dac50234d3bb), 0.7 * alpha * lit);
                g.moveTo(0, cy - r + 1.5).lineTo(-r * 0.5, cy - r * 0.5 + 0.5).lineTo(0, cy - r * 0.62).closePath();
                g.endFill();
            }
            const inner = r - $902b76aaa1df7480$var$CREST_INSET * s;
            g.lineStyle({
                width: 1,
                color: (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $658a44ce960354bb$export$dd27ce85ad53c944), (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), lit),
                alpha: alpha,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            g.beginFill((0, $658a44ce960354bb$export$e969f1546e2d24ca), alpha);
            (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(g, 0, cy, inner);
            g.endFill();
            g.lineStyle(0);
            if (this.digit) {
                this.digit.alpha = alpha * (0.35 + 0.65 * lit);
                this.digit.scale.set(s);
                this.digit.tint = (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $a8782f4c6450260e$export$671c724dbdd0c3a9)($902b76aaa1df7480$var$UNLIT_RIM, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), lit), (0, $2f9f1514035da1ec$export$6237dac50234d3bb), 0.6 * Math.max(pose.flash, flare));
            }
        }, this.poseRule = (pose)=>{
            this.nibs.forEach((nib)=>{
                nib.visible = false;
            });
            if (!(pose.rule > 0)) return;
            const g = this.ornament;
            const from = $902b76aaa1df7480$var$CREST_R + $902b76aaa1df7480$var$RULE_GAP, full = this.ruleHalf - from;
            const reach = full * pose.rule;
            const SEGMENTS = 14;
            [
                -1,
                1
            ].forEach((side, index)=>{
                for(let i = 0; i < SEGMENTS; i++){
                    const a = i / SEGMENTS * full, b = (i + 1) / SEGMENTS * full;
                    if (a >= reach) break;
                    const k = i / SEGMENTS;
                    g.lineStyle(1.5, (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), (0, $658a44ce960354bb$export$dd27ce85ad53c944), k), 0.9 - 0.75 * k);
                    g.moveTo(side * (from + a), $902b76aaa1df7480$var$CREST_Y).lineTo(side * (from + Math.min(b, reach)), $902b76aaa1df7480$var$CREST_Y);
                }
                g.lineStyle(0);
                const tip = side * (from + reach);
                g.beginFill((0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $2f9f1514035da1ec$export$81e981a732c8ab4a), (0, $658a44ce960354bb$export$6b1db5e247c0ce0), pose.rule), 0.95);
                (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(g, tip, $902b76aaa1df7480$var$CREST_Y, 3.2);
                g.endFill();
                // The nib glows while it is still moving.
                this.nibs[index].place(tip, $902b76aaa1df7480$var$CREST_Y, 16, 16, 0.9 * (1 - pose.rule));
            });
        }, this.ring = (fx, t)=>{
            if (!(t > 0) || t >= 1) return;
            const k = (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(t);
            fx.lineStyle({
                width: 2.5 * (1 - t) + 0.5,
                color: (0, $2f9f1514035da1ec$export$d8df7395f14ba24a),
                alpha: 0.9 * (1 - t),
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(fx, 0, $902b76aaa1df7480$var$CREST_Y, $902b76aaa1df7480$var$CREST_R + 4 + 60 * k);
            fx.lineStyle(0);
        }, this.poseActions = (pose, launch, under, over)=>{
            const button = this.button;
            const cover = this.ctaCover.clear();
            if (!button) return;
            const cta = pose.actions;
            this.actions.alpha = cta.plateAlpha * (launch ? launch.actionsAlpha : 1);
            this.actions.pivot.y = -cta.rise;
            const bx = button.x, by = this.actions.y + button.y + cta.rise, w = $902b76aaa1df7480$var$BEGIN_W, h = $902b76aaa1df7480$var$BUTTON_H;
            // The unlit plate over Begin, drawn back from the left as the light comes.
            if (cta.ignite < 1) {
                const front = w * cta.ignite;
                const c = Math.min(5, h / 4);
                cover.lineStyle({
                    width: 1,
                    color: $902b76aaa1df7480$var$UNLIT_RIM,
                    alpha: 1,
                    join: (0, $gwPoJ.LINE_JOIN).MITER
                });
                cover.beginFill($902b76aaa1df7480$var$UNLIT_FILL, 1);
                if (front <= c) (0, $658a44ce960354bb$export$99dca9ebbafa6899)(cover, bx, button.y, w, h, c);
                else {
                    const left = bx + front, top = button.y;
                    cover.moveTo(left, top).lineTo(bx + w - c, top).lineTo(bx + w, top + c).lineTo(bx + w, top + h - c).lineTo(bx + w - c, top + h).lineTo(left, top + h).closePath();
                }
                cover.endFill();
                cover.lineStyle(0);
            }
            const actionsAlpha = this.actions.alpha;
            if (!(actionsAlpha > 0)) return;
            if (cta.edge > 0) {
                const x = bx + w * cta.ignite;
                for(let i = 0; i < 3; i++)over.beginFill(i === 0 ? (0, $2f9f1514035da1ec$export$6237dac50234d3bb) : (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), actionsAlpha * cta.edge * (0.55 - i * 0.17)).drawRect(x - 1 - i * 2, by - i * 1.5, 2 + i * 4, h + i * 3).endFill();
                (0, $2f9f1514035da1ec$export$11572259c1b566fa)(over, x, by + h / 2, 16, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.35 * cta.edge * actionsAlpha, 3);
            }
            const hover = this.hover.value(this.ms);
            const warm = (0.6 * cta.glow + 0.3 * hover + 0.8 * (launch?.flare || 0)) * actionsAlpha;
            if (warm > 0.01) {
                for(let i = 0; i < 4; i++){
                    const grow = 2 + i * 3;
                    under.lineStyle({
                        width: 3 + i * 2,
                        color: i < 2 ? (0, $2f9f1514035da1ec$export$d8df7395f14ba24a) : (0, $2f9f1514035da1ec$export$a946f851ecf2e2e0),
                        alpha: warm * (0.34 - i * 0.07),
                        join: (0, $gwPoJ.LINE_JOIN).MITER
                    });
                    (0, $658a44ce960354bb$export$99dca9ebbafa6899)(under, bx - grow, by - grow, w + grow * 2, h + grow * 2, 6);
                }
                under.lineStyle(0);
            }
            if (cta.shineT >= 0 && !launch) (0, $2f9f1514035da1ec$export$f2d9b1fa89f3b31e)(over, bx + 2, by + 2, w - 4, h - 4, cta.shineT, 30, 0.22 * actionsAlpha);
            if (launch) {
                over.beginFill((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.4 * launch.flare * actionsAlpha);
                (0, $658a44ce960354bb$export$99dca9ebbafa6899)(over, bx, by, w, h, 5);
                over.endFill();
            }
        }, this.stepEmbers = (dt)=>{
            const { x: x, y: y, width: width, height: height } = this.bounds;
            const launch = this.exit?.kind === "begin" ? (0, $a8782f4c6450260e$export$e30b297803fc4af7)(this.exit.ms) : undefined;
            const gust = launch?.gust || 0;
            // A thicker puff while the fire catches, and a gust when Begin is pressed.
            const every = $902b76aaa1df7480$var$EMBER_EVERY_MS / (this.ms < 700 ? 2 : 1) / (1 + 2.5 * gust);
            this.moteClock += dt;
            while(this.moteClock >= every){
                this.moteClock -= every;
                if (this.motes.length >= $902b76aaa1df7480$var$EMBER_MAX + 30 * gust) continue;
                // Clustered toward the middle, where the fire below the frame would be.
                const spread = (Math.random() + Math.random() + Math.random()) / 3 - 0.5;
                this.motes.push({
                    x: x + width * (0.5 + spread * 1.5),
                    y: y + height + 4,
                    vy: -(0.03 + Math.random() * 0.05),
                    sway: 4 + Math.random() * 12,
                    swayMs: 1400 + Math.random() * 1600,
                    phase: Math.random() * Math.PI * 2,
                    age: 0,
                    life: 2600 + Math.random() * 3400,
                    r: 0.7 + Math.random() * 1.4
                });
            }
            const speed = (0, $a8782f4c6450260e$export$3a89f8d6f6bf6c9f)(1, 5, gust);
            this.motes = this.motes.filter((mote)=>mote.age < mote.life);
            this.motes.forEach((mote)=>{
                mote.age += dt;
                mote.y += mote.vy * dt * speed;
            });
            const g = this.embers.clear();
            const hearth = (0, $a8782f4c6450260e$export$979371c67e3966f9)(this.ms).hearth;
            this.motes.forEach((mote, index)=>{
                // Each ember carries a soft halo sprite: a drawn circle reads as a bubble at full size.
                const halo = this.halos[index] || this.emberHalos.addChild(this.halos[index] = new $902b76aaa1df7480$var$Glow((0, $2f9f1514035da1ec$export$a946f851ecf2e2e0)));
                const k = mote.age / mote.life;
                const fade = Math.min(1, k / 0.15) * Math.min(1, (1 - k) / 0.45);
                const alpha = fade * hearth;
                const mx = mote.x + Math.sin(mote.phase + mote.age / mote.swayMs * Math.PI * 2) * mote.sway;
                halo.place(mx, mote.y, mote.r * 5, mote.r * 5, 0.32 * alpha);
                if (!(alpha > 0.01)) return;
                const color = k < 0.25 ? (0, $2f9f1514035da1ec$export$d8df7395f14ba24a) : k < 0.6 ? (0, $2f9f1514035da1ec$export$81e981a732c8ab4a) : (0, $2f9f1514035da1ec$export$a946f851ecf2e2e0);
                g.beginFill(color, 0.9 * alpha).drawCircle(mx, mote.y, mote.r).endFill();
            });
            for(let i = this.motes.length; i < this.halos.length; i++)this.halos[i].visible = false;
        }, this.destroy = ()=>{
            this.clearContent();
            super.destroy({
                children: true
            });
        };
        this.embers.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.under.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.fx.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.hearthLayer.addChild(this.hearthWide, this.hearthCore, this.hearthHigh);
        this.glows.addChild(this.titleGlow, this.crestGlow, this.crestCore, this.flash, ...this.nibs);
        this.content.addChild(this.glows, this.under, this.ornament, this.words, this.actions, this.fx);
        this.addChild(this.backdrop, this.hearthLayer, this.emberHalos, this.embers, this.content);
        this.interactive = true;
        // A click on the card while it is still arriving skips straight to the finished card. The
        // buttons take no input until then, so the same press cannot also answer them.
        this.on("pointerdown", (event)=>{
            event?.stopPropagation();
            if (this.visible && !this.exit && this.ms < (0, $a8782f4c6450260e$export$e030a49c2fd33dd2)) this.ms = (0, $a8782f4c6450260e$export$e030a49c2fd33dd2);
        });
        this.on("pointermove", (event)=>event.stopPropagation());
        this.on("rightclick", (event)=>event.stopPropagation());
        this.visible = false;
    }
}



const $7773f27b7db9938b$export$58e9fbe7b899d84c = 2500;
const $7773f27b7db9938b$export$adc438c857a77a9 = 5000;
const $7773f27b7db9938b$export$d5d52df440328934 = 400;
const $7773f27b7db9938b$var$PIECES = [
    "chips",
    "minimap",
    "roster",
    "checklist",
    "fireGauge",
    "vitals",
    "readyBar"
];
// The camp's, not the player's: these go while a line is read.
const $7773f27b7db9938b$var$STEPS_BACK = [
    "chips",
    "minimap",
    "roster",
    "fireGauge"
];
class $7773f27b7db9938b$export$8ae085b39c2128cd {
    constructor(){
        this.clock = 0;
        this.heldUntil = -Infinity;
        this.hidden = new Set();
        this.shown = new Map();
        this.focus = new Map();
        /** Hold back exactly these pieces from now on; the rest come (back) in. */ this.setHidden = (pieces)=>{
            this.hidden = new Set(pieces);
            $7773f27b7db9938b$var$PIECES.forEach((piece)=>{
                if (this.hidden.has(piece)) this.shown.get(piece).snap(0);
                else this.shown.get(piece).set(1, this.clock);
            });
        };
        this.update = (deltaMs, moment)=>{
            this.clock += Math.max(0, deltaMs);
            if (moment.held) this.heldUntil = Math.max(this.heldUntil, this.clock + $7773f27b7db9938b$export$58e9fbe7b899d84c);
            if (moment.announcing) this.heldUntil = Math.max(this.heldUntil, this.clock + $7773f27b7db9938b$export$adc438c857a77a9);
            const focused = this.focused();
            $7773f27b7db9938b$var$STEPS_BACK.forEach((piece)=>{
                const exempt = piece === "chips" && moment.clue;
                this.focus.get(piece).set(focused && !exempt ? 0 : 1, this.clock);
            });
        };
        /** What to write to the piece's alpha this frame. */ this.alpha = (piece)=>this.shown.get(piece).value(this.clock) * this.focus.get(piece).value(this.clock);
        /** Whether the piece is held back altogether (and out of its layout). */ this.hides = (piece)=>this.hidden.has(piece);
        /** Anything the player cannot see should not catch a click: pixi hit-tests a transparent object. */ this.takesInput = (piece)=>!this.hides(piece) && this.alpha(piece) > 0.05;
        /** How far the piece has arrived, from 0 to 1, leaving out focus: for layout that makes room for it. */ this.arrival = (piece)=>this.shown.get(piece).value(this.clock);
        this.focused = ()=>this.clock < this.heldUntil;
        $7773f27b7db9938b$var$PIECES.forEach((piece)=>{
            this.shown.set(piece, new (0, $a8782f4c6450260e$export$f709befbd1bbaa29)(1, $7773f27b7db9938b$export$d5d52df440328934));
            this.focus.set(piece, new (0, $a8782f4c6450260e$export$f709befbd1bbaa29)(1, $7773f27b7db9938b$export$d5d52df440328934));
        });
    }
}




const $4c8e1a710c1d007e$export$5b11a9d6569cde02 = {
    id: "ember-core",
    weaponType: "staff",
    chargeMs: 800,
    cooldownMs: 2000,
    movementMultiplier: 0.5,
    maxRange: 192,
    projectileSpeed: 320,
    fuseMs: 350,
    blast: {
        radius: 64,
        centerDamage: 12,
        edgeDamage: 4,
        targets: "non-friendly",
        selfDamageMultiplier: 0,
        blockedByWalls: true
    },
    ammunition: {
        items: [
            "ember-charge"
        ],
        quantity: 1
    }
};
const $4c8e1a710c1d007e$export$615dd66e9cbe88a1 = (definition)=>{
    if (!definition || typeof definition.id !== "string" || !definition.id.length || definition.id.length > 80 || typeof definition.weaponType !== "string") throw new Error("Invalid charged weapon identity");
    const bounded = (value, min, max)=>Number.isFinite(value) && value >= min && value <= max;
    if (!bounded(definition.chargeMs, 1, 30000) || !bounded(definition.cooldownMs, 0, 60000) || !bounded(definition.movementMultiplier, 0, 1) || !bounded(definition.maxRange, 1, 1024) || !bounded(definition.projectileSpeed, 1, 2048) || !bounded(definition.fuseMs, 0, 30000) || !bounded(definition.blast?.radius, 1, 512) || !bounded(definition.blast.centerDamage, 0, 10000) || !bounded(definition.blast.edgeDamage, 0, definition.blast.centerDamage) || !bounded(definition.blast.selfDamageMultiplier, 0, 1) || ![
        "hostile",
        "non-friendly",
        "all"
    ].includes(definition.blast.targets) || typeof definition.blast.blockedByWalls !== "boolean" || !Number.isInteger(definition.ammunition?.quantity) || !bounded(definition.ammunition.quantity, 1, 1000) || !Array.isArray(definition.ammunition.items) || !definition.ammunition.items.length || definition.ammunition.items.some((item)=>typeof item !== "string" || !item.length)) throw new Error("Invalid charged weapon parameters");
    if (definition.trajectory !== undefined && ![
        "straight",
        "lob"
    ].includes(definition.trajectory) || definition.appearance !== undefined && ![
        "energy",
        "bomb"
    ].includes(definition.appearance) || definition.structureDamage && (!Array.isArray(definition.structureDamage.types) || !definition.structureDamage.types.length || definition.structureDamage.types.some((t)=>typeof t !== "string" || !t.length) || !bounded(definition.structureDamage.centerDamage, 0, 10000) || !bounded(definition.structureDamage.edgeDamage, 0, definition.structureDamage.centerDamage))) throw new Error("Invalid area projectile parameters");
    return {
        ...definition,
        structureDamage: definition.structureDamage && {
            ...definition.structureDamage,
            types: [
                ...new Set(definition.structureDamage.types)
            ]
        },
        blast: {
            ...definition.blast
        },
        ammunition: {
            ...definition.ammunition,
            items: [
                ...new Set(definition.ammunition.items)
            ]
        }
    };
};
const $4c8e1a710c1d007e$export$f1bdad56e01f9510 = (inventory, cost, spend = true)=>{
    let remaining = cost.quantity;
    const deductions = [];
    for (const item of inventory?.items || []){
        if (!cost.items.includes(item.itemTypeMeta?.type)) continue;
        const amount = Math.min(Math.max(0, item.quantity || 0), remaining);
        if (amount > 0) deductions.push({
            item: item,
            amount: amount
        });
        remaining -= amount;
        if (!remaining) break;
    }
    if (remaining > 0) return false;
    if (spend) deductions.forEach(({ item: item, amount: amount })=>item.quantity -= amount);
    return true;
};
const $4c8e1a710c1d007e$export$2d49af4a1bd0e8a2 = (from, to, blocked)=>{
    const steps = Math.max(1, Math.ceil(Math.hypot(to.x - from.x, to.y - from.y) / 4));
    let last = {
        ...from
    };
    for(let i = 1; i <= steps; i++){
        const point = {
            x: from.x + (to.x - from.x) * i / steps,
            y: from.y + (to.y - from.y) * i / steps
        };
        if (blocked(point)) break;
        last = point;
    }
    return last;
};


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");

parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");


const $7f40928dcf527a2e$export$1a42273b4d6cf0d2 = 0x3d2e20 // build_board TIMBER
;
const $7f40928dcf527a2e$export$4e1a7e6c39034ffc = 0xd9b483 // build_board RIM_LIGHT — the lit upper-left of the band
;
const $7f40928dcf527a2e$export$a428162af1a5cf6e = 0x8e7b58 // build_board RIM
;
const $7f40928dcf527a2e$export$ea7cf79ddee910a5 = 0x15120d // build_board FACE
;
const $7f40928dcf527a2e$export$c2cf5999dc344b67 = 0.9;
const $7f40928dcf527a2e$export$4ea277c199a9094a = 0x000000;
const $7f40928dcf527a2e$export$899e05616b38a3b5 = 0.45;
const $7f40928dcf527a2e$export$a45bce2c10c351d8 = 5;
const $7f40928dcf527a2e$export$8b93a1472cb1b33 = ({ radius: radius, strokeWidth: strokeWidth })=>radius - strokeWidth / 2;
const $7f40928dcf527a2e$export$52c805a13553b1ac = ({ radius: radius, strokeWidth: strokeWidth })=>radius + strokeWidth / 2;
const $7f40928dcf527a2e$export$cc4a36cb2ed92a0e = (metrics)=>$7f40928dcf527a2e$export$52c805a13553b1ac(metrics) + $7f40928dcf527a2e$export$a45bce2c10c351d8;
const $7f40928dcf527a2e$export$e701ba9b0e6c1246 = (metrics)=>$7f40928dcf527a2e$export$cc4a36cb2ed92a0e(metrics) * 2;
const $7f40928dcf527a2e$export$a990dcceb7594917 = (g, props)=>{
    const arcRadius = $7f40928dcf527a2e$export$8b93a1472cb1b33(props);
    const faceRadius = $7f40928dcf527a2e$export$52c805a13553b1ac(props);
    const outer = $7f40928dcf527a2e$export$cc4a36cb2ed92a0e(props);
    const band = (faceRadius + outer) / 2;
    g.clear();
    // Sits ON the camp rather than in it.
    g.beginFill(0x000000, 0.34);
    g.drawCircle(0, 3, outer);
    g.endFill();
    g.beginFill($7f40928dcf527a2e$export$1a42273b4d6cf0d2, 1);
    g.drawCircle(0, 0, outer);
    g.endFill();
    // The band is lit from the upper left and shadowed opposite, which is what makes it read as
    // forged metal rather than a printed ring. Two arcs on the band's own centreline.
    const sweep = (from, to, color, alpha)=>{
        g.lineStyle({
            width: $7f40928dcf527a2e$export$a45bce2c10c351d8 * 0.62,
            color: color,
            alpha: alpha,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        g.moveTo(Math.cos(from) * band, Math.sin(from) * band);
        g.arc(0, 0, band, from, to);
    };
    sweep(Math.PI * 1.04, Math.PI * 1.88, $7f40928dcf527a2e$export$4e1a7e6c39034ffc, 0.5);
    sweep(Math.PI * 0.08, Math.PI * 0.86, 0x000000, 0.42);
    g.lineStyle(0);
    g.beginFill(props.faceColor ?? $7f40928dcf527a2e$export$ea7cf79ddee910a5, props.faceAlpha ?? $7f40928dcf527a2e$export$c2cf5999dc344b67);
    g.drawCircle(0, 0, faceRadius);
    g.endFill();
    g.lineStyle({
        width: props.strokeWidth,
        color: $7f40928dcf527a2e$export$4ea277c199a9094a,
        alpha: $7f40928dcf527a2e$export$899e05616b38a3b5,
        cap: (0, $gwPoJ.LINE_CAP).ROUND
    });
    g.drawCircle(0, 0, arcRadius);
    // Four quarter notches cut through the band — a pressure gauge's marks, not a clock's hours.
    // Twelve evenly spaced ticks is the single strongest "wall clock" tell there is.
    for(let quarter = 0; quarter < 4; quarter++){
        const angle = -Math.PI / 2 + quarter / 4 * Math.PI * 2;
        g.lineStyle({
            width: 2.4,
            color: 0x000000,
            alpha: 0.55,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        g.moveTo(Math.cos(angle) * (faceRadius - 1), Math.sin(angle) * (faceRadius - 1));
        g.lineTo(Math.cos(angle) * (outer - 0.5), Math.sin(angle) * (outer - 0.5));
    }
    // Rivets on the diagonals, where they cannot sit on a notch.
    g.lineStyle(0);
    for(let corner = 0; corner < 4; corner++){
        const angle = -Math.PI / 4 + corner / 4 * Math.PI * 2;
        const x = Math.cos(angle) * band;
        const y = Math.sin(angle) * band;
        g.beginFill(0x000000, 0.5);
        g.drawCircle(x, y + 0.5, 2.1);
        g.endFill();
        g.beginFill($7f40928dcf527a2e$export$a428162af1a5cf6e, 0.95);
        g.drawCircle(x, y, 1.7);
        g.endFill();
        g.beginFill($7f40928dcf527a2e$export$4e1a7e6c39034ffc, 0.7);
        g.drawCircle(x - 0.5, y - 0.6, 0.7);
        g.endFill();
    }
    // A hairline inside the face edge, so the face reads as recessed into the band.
    g.lineStyle({
        width: 1,
        color: 0x000000,
        alpha: 0.55
    });
    g.drawCircle(0, 0, faceRadius - 0.5);
};
const $7f40928dcf527a2e$export$e33ec2b352c86d34 = (g, metrics, color, heat)=>{
    if (!(heat > 0)) return;
    const faceRadius = $7f40928dcf527a2e$export$52c805a13553b1ac(metrics);
    // Four stacked discs, each smaller and stronger than the last, so the centre is the brightest
    // part. The alphas are deliberately heavy: the first pass at this was so faint that the dial at
    // three seconds was DIMMER than the dial at twenty-four, which is the escalation backwards.
    for(let ring = 0; ring < 4; ring++){
        const spread = 1 - ring * 0.23;
        g.beginFill(color, 0.1 * heat * (1 + ring * 0.5));
        g.drawCircle(0, 0, (faceRadius - 1) * spread);
        g.endFill();
    }
};
const $7f40928dcf527a2e$export$fabd2fd7d3821067 = (g, props)=>{
    g.clear();
    if (!(props.progress > 0)) return;
    const arcRadius = $7f40928dcf527a2e$export$8b93a1472cb1b33(props);
    const startAngle = -Math.PI / 2;
    const endAngle = startAngle + Math.min(1, props.progress) * Math.PI * 2;
    const startX = Math.cos(startAngle) * arcRadius;
    const startY = Math.sin(startAngle) * arcRadius;
    if (props.haloWidth && props.haloAlpha) {
        g.lineStyle({
            width: props.strokeWidth + props.haloWidth,
            color: props.color,
            alpha: props.haloAlpha,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        g.moveTo(startX, startY);
        g.arc(0, 0, arcRadius, startAngle, endAngle);
    }
    g.lineStyle({
        width: props.strokeWidth,
        color: props.arcColor ?? props.color,
        alpha: 1,
        cap: (0, $gwPoJ.LINE_CAP).ROUND
    });
    g.moveTo(startX, startY);
    g.arc(0, 0, arcRadius, startAngle, endAngle);
    // The draining end is an EMBER, not a white pin: a soft halo around an opaque hot heart. Same
    // recipe as the camp's fire — the glow has to sit under something solid or it reads as dust.
    if (props.bead !== false) {
        const x = Math.cos(endAngle) * arcRadius;
        const y = Math.sin(endAngle) * arcRadius;
        g.lineStyle(0);
        g.beginFill(props.color, 0.45);
        g.drawCircle(x, y, props.strokeWidth * 0.72);
        g.endFill();
        g.beginFill(0xfff2d0, 0.95);
        g.drawCircle(x, y, props.strokeWidth * 0.3);
        g.endFill();
    }
};
const $7f40928dcf527a2e$export$5931e35698b46017 = (from, to, factor)=>{
    const f = Math.max(0, Math.min(1, factor));
    const r = Math.round((from >> 16 & 0xff) + ((to >> 16 & 0xff) - (from >> 16 & 0xff)) * f);
    const g = Math.round((from >> 8 & 0xff) + ((to >> 8 & 0xff) - (from >> 8 & 0xff)) * f);
    const b = Math.round((from & 0xff) + ((to & 0xff) - (from & 0xff)) * f);
    return r << 16 | g << 8 | b;
};
const $7f40928dcf527a2e$export$1157fb72e7fbceb5 = (t)=>1 - Math.pow(1 - Math.max(0, Math.min(1, t)), 3);
const $7f40928dcf527a2e$export$c4200270c532ad03 = 0xffedc7 // build_board INK
;
const $7f40928dcf527a2e$export$7da3a3ba51387f3 = 0xa08c6c // build_board MUTED
;
const $7f40928dcf527a2e$export$8191f8c01763dd3c = 3 // between the word and its number
;
const $7f40928dcf527a2e$export$daeb2bb8a74480ef = 1.2;
const $7f40928dcf527a2e$export$94a4c9f12c96c83e = -22;
const $7f40928dcf527a2e$export$b4e42a1196873f1f = 0;
const $7f40928dcf527a2e$export$82a9eb428c63b9df = 23;
const $7f40928dcf527a2e$export$4e9219c5ee032693 = (metrics)=>$7f40928dcf527a2e$export$cc4a36cb2ed92a0e(metrics);
const $7f40928dcf527a2e$export$626d17f8fc89e437 = (wordWidth, digitsWidth)=>{
    const total = wordWidth + $7f40928dcf527a2e$export$8191f8c01763dd3c + digitsWidth;
    const word = -total / 2;
    return {
        word: word,
        digits: word + wordWidth + $7f40928dcf527a2e$export$8191f8c01763dd3c
    };
};
class $7f40928dcf527a2e$export$9e7f97e6c8f262fa extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.wave = -1;
        this.word = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($7f40928dcf527a2e$export$7da3a3ba51387f3).fontSize((0, $ef882f0a643d87d9$export$a57e4d4d74a95378).overline.fontSize).bold().render("WAVE");
        this.word.anchor.set(0, 0.5);
        // Letterspaced so four small capitals still read as a word rather than a smudge.
        this.word.style.letterSpacing = $7f40928dcf527a2e$export$daeb2bb8a74480ef;
        this.digits = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($7f40928dcf527a2e$export$c4200270c532ad03).fontSize(12).bold().render("1");
        this.digits.anchor.set(0, 0.5);
        this.addChild(this.word, this.digits);
        this.y = $7f40928dcf527a2e$export$94a4c9f12c96c83e;
        this.setWave(1);
    }
    setWave(wave, word = "WAVE") {
        this.visible = wave > 0;
        if (!this.visible || wave === this.wave && word === this.word.text) return;
        this.wave = wave;
        this.word.text = word;
        this.digits.text = String(wave);
        const at = $7f40928dcf527a2e$export$626d17f8fc89e437(this.word.width - $7f40928dcf527a2e$export$daeb2bb8a74480ef, this.digits.width);
        this.word.x = at.word;
        this.digits.x = at.digits;
    }
    /** Test seam: what the line currently reads, as one string. */ readsAs() {
        return `${this.word.text} ${this.digits.text}`;
    }
}


const $ec347662891822a3$export$8c3b9879a2e96719 = 0xff8a1f;
const $ec347662891822a3$export$4bd05e62286397cf = 3000;
// Peaks land roughly every two thirds of a second. Tied to FLARE_MS: stretching the flare without
// adding pulses would leave it swelling and sagging too slowly to read as a signal.
const $ec347662891822a3$var$FLARE_PULSES = 4.5;
// The fraction of the flare spent fading out. Before it, the pulses run at full strength; a flare
// that started decaying immediately would be three seconds long but only read as one, because a
// squared decay has already thrown most of the brightness away by the halfway mark.
const $ec347662891822a3$var$FADE_FROM = 0.45;
const $ec347662891822a3$export$fa77bbeff60091a9 = 0.2;
const $ec347662891822a3$export$ef6d3c936174c648 = 7;
const $ec347662891822a3$var$GLOW_LAYERS = 3;
const $ec347662891822a3$var$GLOW_ALPHA = 0.42;
const $ec347662891822a3$export$d6a23bbd0b8909ed = 13;
const $ec347662891822a3$export$eeb9303578cc67f2 = 2;
// How much of the flare's strength is left with `remaining` (1..0) of it to go. Full until the fade
// begins, then squared down to exactly zero, which is what guarantees the thing ends.
const $ec347662891822a3$var$envelopeAt = (remaining)=>remaining >= $ec347662891822a3$var$FADE_FROM ? 1 : remaining / $ec347662891822a3$var$FADE_FROM * (remaining / $ec347662891822a3$var$FADE_FROM);
const $ec347662891822a3$export$89ff20d7b20a9b0b = (remainingMs)=>{
    if (!(remainingMs > 0)) return 0;
    const remaining = Math.min(1, remainingMs / $ec347662891822a3$export$4bd05e62286397cf);
    // Pulses run on the ELAPSED fraction so the train starts hot at its first peak rather than at
    // zero.
    const elapsed = 1 - remaining;
    const pulse = Math.abs(Math.cos(elapsed * Math.PI * $ec347662891822a3$var$FLARE_PULSES));
    return pulse * $ec347662891822a3$var$envelopeAt(remaining);
};
const $ec347662891822a3$export$6475a58bf88bdc85 = (remainingMs, pop = $ec347662891822a3$export$fa77bbeff60091a9)=>1 + $ec347662891822a3$export$89ff20d7b20a9b0b(remainingMs) * pop;
const $ec347662891822a3$export$1844242e9d95ec9 = (remainingMs)=>{
    if (!(remainingMs > 0)) return [];
    const remaining = Math.min(1, remainingMs / $ec347662891822a3$export$4bd05e62286397cf);
    const elapsed = 1 - remaining;
    const envelope = $ec347662891822a3$var$envelopeAt(remaining);
    const rings = [];
    for(let i = 0; i < $ec347662891822a3$export$eeb9303578cc67f2; i++){
        const progress = (elapsed * $ec347662891822a3$var$FLARE_PULSES + i / $ec347662891822a3$export$eeb9303578cc67f2) % 1;
        rings.push({
            progress: progress,
            alpha: (1 - progress) * envelope
        });
    }
    // A ring too faint to see is a stroke the GPU draws for nothing.
    return rings.filter((ring)=>ring.alpha > 0.02);
};
const $ec347662891822a3$export$33ee99e9ec522cbf = (from, to, amount)=>{
    const a = Math.max(0, Math.min(1, amount));
    const mix = (shift)=>{
        const f = from >> shift & 0xff;
        const t = to >> shift & 0xff;
        return Math.round(f + (t - f) * a) & 0xff;
    };
    return mix(16) << 16 | mix(8) << 8 | mix(0);
};
const $ec347662891822a3$export$68fa09a501e35b68 = (glow, { remainingMs: remainingMs, width: width, height: height, corner: corner, spread: spread = $ec347662891822a3$export$ef6d3c936174c648, ringSpread: ringSpread = $ec347662891822a3$export$d6a23bbd0b8909ed })=>{
    glow.clear();
    if (remainingMs <= 0) return;
    const hot = $ec347662891822a3$export$89ff20d7b20a9b0b(remainingMs);
    // At the trough between two pulses there is no light to draw, only rings still travelling.
    for(let i = 1; hot > 0.01 && i <= $ec347662891822a3$var$GLOW_LAYERS; i++){
        const out = spread * i / $ec347662891822a3$var$GLOW_LAYERS * hot;
        // Inner layers are the brightest, so the light looks like it is coming off the plate.
        glow.lineStyle(2.5, $ec347662891822a3$export$8c3b9879a2e96719, hot * $ec347662891822a3$var$GLOW_ALPHA * (1 - (i - 1) / $ec347662891822a3$var$GLOW_LAYERS));
        glow.drawRoundedRect(-out, -out, width + out * 2, height + out * 2, corner + out);
    }
    for (const ring of $ec347662891822a3$export$1844242e9d95ec9(remainingMs)){
        const out = ringSpread * ring.progress;
        glow.lineStyle(0.5 + 2 * (1 - ring.progress), $ec347662891822a3$export$8c3b9879a2e96719, ring.alpha * 0.75);
        glow.drawRoundedRect(-out, -out, width + out * 2, height + out * 2, corner + out);
    }
};



// The readout the player carries down into the cave: how the lord FEELS back at the camp, never the
// danger of the cave the player is standing in. It is the only thread back to the surface.
//
// Built as a SENSE rather than as an instrument, which is a deliberate break from the HUD's other
// round widgets. The countdown dial and the wave badge measure things -- seconds, enemies -- and
// wear the hardware to prove it: a groove, a rim, a bright cursor, a numeral in the middle. This one
// is a feeling arriving from somewhere the player cannot see, so it has no number to read, no trace
// to follow and no ticks to count against. What it has is:
//
//   1. A HEART that beats, at his rate: ~43bpm settled against ~144bpm desperate. Nothing else on
//      the HUD moves at a tempo, which is what makes it legible out of the corner of an eye -- and
//      what makes it unmistakable when it STOPS.
//   2. A pulse of light off each beat, and a ring of colour that fills as he worsens: how far gone
//      he is, as an amount of light rather than as a position on a scale.
//   3. The CAUSE -- the server's own sentence, and the only text on the widget. There is no band
//      word: naming the four moods turned a feeling back into a category being reported, and "The
//      cold is getting in." already carries both the trouble and the tone of it. The band survives
//      as the COLOUR of everything, which is how a mood is worn rather than announced.
//
// Everything is plain fills and strokes. No filters: a soft edge here is a fatter, fainter copy of
// the same path, because the hardware this game targets cannot spare a filter pass on the HUD.
const $61be61f02d36c718$var$PLATE = {
    width: 278,
    height: 58,
    corner: 7
};
const $61be61f02d36c718$var$PLATE_COLOR = (0, $97475243e21a0995$export$ae463dc3cc7e810b // the HUD chip plate (ember_players_chip, ember_minimap_chip)
);
const $61be61f02d36c718$var$PLATE_ALPHA = 0.82;
const $61be61f02d36c718$var$SOCKET = {
    radius: 18,
    strokeWidth: 4,
    x: 31,
    y: 29
};
const $61be61f02d36c718$var$COLUMN_X = 58 // left edge of the text column, clear of the socket
;
const $61be61f02d36c718$var$CAUSE_COLOR = 0xc9d2d9;
const $61be61f02d36c718$var$TITLE_COLOR = 0x8b98a5;
const $61be61f02d36c718$var$FALLEN_COLOR = 0x7d8c9b // cold slate: the one colour on the widget that is not a mood
;
// Brightened a touch from the server's own bands so they survive being used as a TINT, which can
// only ever darken white text.
const $61be61f02d36c718$var$BANDS = {
    settled: 0x8fd6ad,
    uneasy: 0xe8c874,
    afraid: 0xf09a55,
    desperate: 0xf2676a
};
// The small-caps line above the sentence. It never names a mood -- it names what is being felt, and
// the one thing a mood cannot say for itself: that there is nothing left to feel.
const $61be61f02d36c718$var$TITLE = "THE LORD'S HEART";
const $61be61f02d36c718$var$TITLE_FALLEN = "THE LORD HAS FALLEN";
const $61be61f02d36c718$var$BAND_ORDER = [
    "settled",
    "uneasy",
    "afraid",
    "desperate"
];
const $61be61f02d36c718$var$clamp01 = (value)=>Math.max(0, Math.min(1, value));
const $61be61f02d36c718$export$cfba4f9507fbec93 = (causeBottom)=>Math.max($61be61f02d36c718$var$PLATE.height, Math.round(causeBottom + 10));
// ===== the beat =======================================================================
// One contraction, measured in SECONDS SINCE THE BEAT BEGAN rather than as a fraction of the gap to
// the next one. A heart's squeeze takes about as long whatever the rate -- what shortens when it
// races is the pause after it, and keeping that true is what stops a desperate lord's heart reading
// as a fast flutter instead of as hard, close thumps.
const $61be61f02d36c718$var$bump = (t, from, to, height)=>t <= from || t >= to ? 0 : Math.sin(Math.PI * (t - from) / (to - from)) * height;
const $61be61f02d36c718$export$6a18b51456a17ff = (t)=>$61be61f02d36c718$var$bump(t, 0.07, 0.2, 1) + $61be61f02d36c718$var$bump(t, 0.21, 0.32, 0.4);
const $61be61f02d36c718$export$65b2abc9c303f413 = (value)=>0.72 + 1.68 * $61be61f02d36c718$var$clamp01(value / 100);
/** How long the ring of light thrown off by a beat lives, in seconds. */ const $61be61f02d36c718$var$HALO_SECONDS = 0.55;
class $61be61f02d36c718$export$7da7148278a58213 extends (0, $8t5Gy.Container) {
    constructor(){
        super(), // Everything visible hangs off `body`, so a desperate lord's tremble can shift it without
        // touching the widget's own x/y -- which the GUI sets afresh every frame.
        this.body = new (0, $8t5Gy.Container)(), this.plateGlow = new (0, $gwPoJ.Graphics)(), this.plate = new (0, $gwPoJ.Graphics)(), this.socketGlow = new (0, $gwPoJ.Graphics)(), this.socket = new (0, $gwPoJ.Graphics)(), this.gauge = new (0, $gwPoJ.Graphics)(), this.heart = new (0, $gwPoJ.Graphics)(), this.key = "", this.plateHeight = $61be61f02d36c718$var$PLATE.height, this.band = "settled", this.fallen = false, this.target = 0, this.shown = -1 // < 0 = no reading yet, so the first one lands without a sweep
        , this.drawnValue = -1, this.drawnStyle = "", // The widget's own clock, in seconds. Only advanced while the meter is up, so a trip back to the
        // surface doesn't leave a gap in the beat.
        this.clock = 0, this.nextBeat = 0, this.sinceBeat = 99 // seconds since the last beat: what the squeeze and the halo are read from
        , /**
     * Advance the beat and repaint what moves. Driven by the GUI's frame timer, and only while the
     * meter is up, so a settled camp costs one small heart and two circles a frame.
     */ this.animate = (deltaMs)=>{
            if (!this.visible) return;
            const dt = Math.max(0, Math.min(0.25, (deltaMs || 0) / 1000)) // a resumed tab must not fire a burst of beats
            ;
            this.clock += dt;
            this.sinceBeat += dt;
            this.settleValue(dt);
            if (this.fallen) {
                // No more beats. The heart does not freeze mid-squeeze: it lets go and is still, which
                // is the whole reading -- a widget that has been pulsing for minutes simply stops.
                this.nextBeat = this.clock;
                this.sinceBeat = 99;
            } else {
                if (this.nextBeat < this.clock - 1) this.nextBeat = this.clock // first frame, or a long absence
                ;
                while(this.nextBeat <= this.clock){
                    this.sinceBeat = this.clock - this.nextBeat;
                    this.nextBeat += 1 / $61be61f02d36c718$export$65b2abc9c303f413(this.shown);
                }
            }
            this.drawBeat(this.fallen ? 0 : $61be61f02d36c718$export$6a18b51456a17ff(this.sinceBeat));
            this.tremble();
        }, this.moodColor = ()=>this.fallen ? $61be61f02d36c718$var$FALLEN_COLOR : $61be61f02d36c718$var$BANDS[this.band], /** How wound up he is, 0..1 -- the dial of everything that moves. */ this.intensity = ()=>this.fallen ? 1 : $61be61f02d36c718$var$clamp01(Math.max(0, this.shown) / 100), // The displayed value sweeps to the server's rather than snapping to it, so a once-a-second
        // sample reads as light growing rather than as a step. Floored at a minimum step so it actually
        // LANDS: an approach that is purely proportional to the remaining distance never does.
        this.settleValue = (dt)=>{
            const distance = this.target - this.shown;
            if (distance === 0) return;
            const step = Math.max(0.9, Math.abs(distance) * Math.min(1, dt * 7));
            this.shown = Math.abs(distance) <= step ? this.target : this.shown + Math.sign(distance) * step;
            this.drawGauge();
        }, this.drawPlate = ()=>{
            const height = $61be61f02d36c718$export$cfba4f9507fbec93(this.cause.y + this.cause.height);
            if (height === this.plateHeight && this.plate.geometry.graphicsData.length) return;
            this.plateHeight = height;
            this.plate.clear();
            this.plate.beginFill($61be61f02d36c718$var$PLATE_COLOR, $61be61f02d36c718$var$PLATE_ALPHA);
            this.plate.lineStyle(1, 0xffffff, 0.18);
            this.plate.drawRoundedRect(0, 0, $61be61f02d36c718$var$PLATE.width, height, $61be61f02d36c718$var$PLATE.corner);
            this.plate.endFill();
        }, // The ring of colour around the heart. Redrawn only when the value has actually moved a visible
        // amount, not on every frame the heart beats on.
        this.drawGauge = ()=>{
            const value = Math.round(Math.max(0, this.shown));
            if (value === this.drawnValue) return;
            this.drawnValue = value;
            (0, $7f40928dcf527a2e$export$fabd2fd7d3821067)(this.gauge, {
                radius: $61be61f02d36c718$var$SOCKET.radius,
                strokeWidth: $61be61f02d36c718$var$SOCKET.strokeWidth,
                progress: value / 100,
                color: this.moodColor(),
                haloWidth: 6,
                haloAlpha: 0.2,
                // No bead: a bright cursor at the end of the arc is a reading being TAKEN, and turns the
                // ring back into the instrument this widget is trying not to be.
                bead: false
            });
            this.gauge.position.set($61be61f02d36c718$var$SOCKET.x, $61be61f02d36c718$var$SOCKET.y);
        }, // The pool the heart sits in, and the heart itself. Both depend only on the mood, so they are
        // redrawn when it changes and merely SCALED by the beat -- the per-frame cost of a beating heart
        // is one scale.set, not a rebuilt path.
        this.drawStyle = ()=>{
            const style = `${this.band}/${this.fallen}`;
            if (style === this.drawnStyle) return;
            this.drawnStyle = style;
            // Concentric discs rather than a face with a rim: the heart needs somewhere dark to sit, but
            // a hard bezel around it is the first thing that would make this read as a gauge.
            this.socket.clear();
            for (const ring of [
                {
                    radius: 20,
                    alpha: 0.1
                },
                {
                    radius: 16.5,
                    alpha: 0.14
                },
                {
                    radius: 13.5,
                    alpha: 0.2
                }
            ]){
                this.socket.beginFill(0x000000, ring.alpha);
                this.socket.drawCircle(0, 0, ring.radius);
                this.socket.endFill();
            }
            // The unlit remainder of the ring, faint enough to be a suggestion of how much is left
            // rather than a scale with an end marked on it -- but not so faint that a settled lord's
            // short arc floats at the top of the socket with no circle to belong to.
            this.socket.lineStyle({
                width: $61be61f02d36c718$var$SOCKET.strokeWidth,
                color: this.moodColor(),
                alpha: 0.16
            });
            this.socket.drawCircle(0, 0, $61be61f02d36c718$var$SOCKET.radius - $61be61f02d36c718$var$SOCKET.strokeWidth / 2);
            this.socket.position.set($61be61f02d36c718$var$SOCKET.x, $61be61f02d36c718$var$SOCKET.y);
            const color = this.moodColor();
            this.heart.clear();
            // A fatter, fainter copy of the heart behind it: the only "glow" available without a filter.
            this.heart.beginFill(color, this.fallen ? 0.1 : 0.26);
            this.drawHeartPath(8.1);
            this.heart.endFill();
            this.heart.beginFill(this.fallen ? color : (0, $ec347662891822a3$export$33ee99e9ec522cbf)(color, 0xffffff, 0.25), this.fallen ? 0.5 : 1);
            this.drawHeartPath(6.9);
            this.heart.endFill();
            if (this.fallen) {
                // Broken, not merely grey and still: the crack is what says it at a glance, in the
                // half-second before anybody reads the word beside it.
                this.heart.lineStyle({
                    width: 1.8,
                    color: (0, $97475243e21a0995$export$ae463dc3cc7e810b),
                    alpha: 0.95
                });
                this.heart.moveTo(0.5, -8);
                this.heart.lineTo(-2.9, -2.2);
                this.heart.lineTo(2, 0.7);
                this.heart.lineTo(-1.3, 6.9);
                this.heart.lineStyle(0);
            }
        }, this.drawHeartPath = (size)=>{
            // The classic two-lobe heart, as one closed path so the fill has no seam down the middle.
            this.heart.moveTo(0, size * 0.95);
            this.heart.bezierCurveTo(-size * 1.5, -size * 0.25, -size * 0.55, -size * 1.3, 0, -size * 0.38);
            this.heart.bezierCurveTo(size * 0.55, -size * 1.3, size * 1.5, -size * 0.25, 0, size * 0.95);
            this.heart.closePath();
        }, // What a beat does: squeeze the heart, throw a ring of light off it, and lift the plate's own
        // glow. Together they make the whole widget breathe rather than just the icon -- and they are
        // the only motion left on it, so they carry the pulse on their own.
        this.drawBeat = (squeeze)=>{
            const intensity = this.intensity();
            this.heart.scale.set(1 + squeeze * (0.12 + 0.15 * intensity));
            const color = this.moodColor();
            const faceRadius = (0, $7f40928dcf527a2e$export$52c805a13553b1ac)($61be61f02d36c718$var$SOCKET);
            this.socketGlow.clear();
            if (!this.fallen) {
                // A standing pool of light under the heart, which the beat brightens...
                this.socketGlow.beginFill(color, (0.05 + 0.09 * intensity) * (0.35 + squeeze * 0.65));
                this.socketGlow.drawCircle(0, 0, faceRadius + 3 + squeeze * 3);
                this.socketGlow.endFill();
                // ...and a ring thrown off it, starting OUTSIDE the gauge and fading before it has
                // travelled far. A ring that expands across the gauge gets read as the gauge (cf. the
                // countdown dial's ripple), so this one is never on it.
                const age = this.sinceBeat / $61be61f02d36c718$var$HALO_SECONDS;
                if (age < 1) {
                    const fade = Math.pow(1 - age, 1.5);
                    this.socketGlow.lineStyle({
                        width: 2,
                        color: color,
                        alpha: (0.1 + 0.14 * intensity) * fade
                    });
                    this.socketGlow.drawCircle(0, 0, faceRadius + 2 + age * 5);
                    this.socketGlow.lineStyle(0);
                }
            }
            this.socketGlow.position.set($61be61f02d36c718$var$SOCKET.x, $61be61f02d36c718$var$SOCKET.y);
            // A mood-coloured bloom around the plate, so a desperate camp lights its own corner of the
            // screen. Two nested rounded rects, the outer one fainter: a cheap, filterless falloff.
            const lit = this.fallen ? 0.05 : (0.05 + 0.13 * intensity * intensity) * (0.6 + squeeze * 0.4);
            this.plateGlow.clear();
            for (const ring of [
                {
                    spread: 3,
                    alpha: lit
                },
                {
                    spread: 7,
                    alpha: lit * 0.45
                }
            ]){
                this.plateGlow.beginFill(color, ring.alpha);
                this.plateGlow.drawRoundedRect(-ring.spread, -ring.spread, $61be61f02d36c718$var$PLATE.width + ring.spread * 2, this.plateHeight + ring.spread * 2, $61be61f02d36c718$var$PLATE.corner + ring.spread);
                this.plateGlow.endFill();
            }
        }, // A fear that has nowhere left to go shows in the hand. Two sines at unrelated rates, so it
        // reads as a tremble rather than as a wobble, and stays reproducible for a test.
        this.tremble = ()=>{
            const over = Math.max(0, this.intensity() - 0.72) / 0.28 * (this.fallen ? 0 : 1);
            if (over <= 0) {
                this.body.position.set(0, 0);
                return;
            }
            this.body.position.set(Math.sin(this.clock * 83.1) * 0.9 * over, Math.sin(this.clock * 61.7 + 1.2) * 0.7 * over);
        }, // Browser-console triggers, in the same shape as window.playersChip / window.rosterWidget:
        //
        //     anxiety(82)                      // a desperate lord, with the matching band and cause
        //     anxiety(40, "uneasy", "...")     // any band and sentence
        //     anxiety(null)                    // put it away
        //     anxietyFallen()                  // the heart stops
        //
        // Nothing a developer alone at a keyboard can do will frighten the lord on cue -- it takes a
        // wave landing on a camp the player cannot see -- so there would otherwise be no way to look at
        // the thing this widget exists to show. The next server sample corrects whatever is faked here.
        this.exposeDevTriggers = ()=>{
            if (typeof window === "undefined") return;
            const anyWindow = window;
            anyWindow.anxietyMeter = this;
            anyWindow.anxiety = (value, band, cause)=>{
                if (value === null || value === undefined) {
                    this.update(null);
                    return "[anxiety] away";
                }
                const level = Math.max(0, Math.min(100, value));
                const resolved = band ?? $61be61f02d36c718$var$BAND_ORDER[Math.min(3, Math.floor(level / 25))];
                this.update({
                    roomId: "dev",
                    value: level,
                    band: resolved,
                    cause: cause ?? "The fighting is close."
                });
                return `[anxiety] ${level} ${resolved} @ ${($61be61f02d36c718$export$65b2abc9c303f413(level) * 60).toFixed(0)}bpm`;
            };
            anyWindow.anxietyFallen = ()=>{
                this.update({
                    roomId: "dev",
                    value: 100,
                    band: "desperate",
                    fallen: true,
                    cause: "The bond falls silent."
                });
                return "[anxiety] fallen";
            };
        };
        this.addChild(this.body);
        this.body.addChild(this.plateGlow, this.plate, this.socketGlow, this.socket, this.gauge, this.heart);
        this.title = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(9).bold().render($61be61f02d36c718$var$TITLE);
        this.title.style.letterSpacing = 1.3 // small caps read as a label, not as a sentence
        ;
        // pixi measures the tracked string WITHOUT the trailing gap, so the canvas comes out one
        // letterSpacing short and the last glyph is cut in half -- "THE LORD'S HEAR", with a ghost
        // of the T. `padding` widens the canvas and is compensated for in the texture's trim, so
        // nothing moves.
        this.title.style.padding = 2;
        this.title.tint = $61be61f02d36c718$var$TITLE_COLOR;
        this.cause = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(11.5).wordWrap($61be61f02d36c718$var$PLATE.width - $61be61f02d36c718$var$COLUMN_X - 12).render("");
        this.body.addChild(this.title, this.cause);
        this.title.position.set($61be61f02d36c718$var$COLUMN_X, 13);
        this.cause.position.set($61be61f02d36c718$var$COLUMN_X, 27);
        this.heart.position.set($61be61f02d36c718$var$SOCKET.x, $61be61f02d36c718$var$SOCKET.y);
        this.drawPlate();
        this.visible = false;
        this.exposeDevTriggers();
    }
    /** A new reading, or null to put the meter away. */ update(feeling) {
        this.visible = !!feeling;
        if (!feeling) {
            this.key = "";
            // Climbing back out of the cave ends this reading. Keeping the needle would mean the
            // next descent opened on the LAST trip's lord, sweeping down from a fear he is no
            // longer in.
            this.shown = -1;
            this.sinceBeat = 99;
            return;
        }
        const key = JSON.stringify(feeling);
        if (key === this.key) return;
        this.key = key;
        this.band = feeling.fallen ? "desperate" : feeling.band;
        this.fallen = !!feeling.fallen;
        this.target = Math.max(0, Math.min(100, feeling.value));
        if (this.shown < 0) this.shown = this.target;
        const color = this.moodColor();
        this.title.text = this.fallen ? $61be61f02d36c718$var$TITLE_FALLEN : $61be61f02d36c718$var$TITLE;
        this.title.tint = this.fallen ? $61be61f02d36c718$var$FALLEN_COLOR : $61be61f02d36c718$var$TITLE_COLOR;
        this.cause.text = feeling.cause || "";
        // Tinted toward the mood, so the sentence is worn in his colour -- it is the only text left,
        // and the only place a reader can be told the difference between cold and a wound. Only
        // partway there: it still has to be read word by word.
        this.cause.tint = (0, $ec347662891822a3$export$33ee99e9ec522cbf)($61be61f02d36c718$var$CAUSE_COLOR, color, 0.4);
        this.drawPlate();
        this.drawStyle();
        // A reading can arrive with the same VALUE and a new mood -- a lord who falls at 100 is the
        // ordinary case -- so the ring is always repainted, never skipped as unchanged.
        this.drawnValue = -1;
        this.drawGauge();
    }
}


parcelRequire("1avo5");
var $9Pi8W = parcelRequire("9Pi8W");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");



// The phone's build controls: the same plan board as the desktop shape palette (see
// build_board.ts), laid out for thumbs instead of a cursor.
//
// A tool is a plot carrying the footprint it lays down and the word for it -- on a phone the word
// does the work and the drawing says which of the three it is at a glance, where on the desktop the
// drawing is the whole control. Undo sits on the same row as a plate, not a plot, because it is not
// something you can be standing in.
const $61c7210a4ddc624c$var$PANEL_W = 296;
const $61c7210a4ddc624c$var$PANEL_H = 70;
const $61c7210a4ddc624c$var$CELL_W = 66;
const $61c7210a4ddc624c$var$CELL_H = 50;
const $61c7210a4ddc624c$var$CELL_Y = 10;
const $61c7210a4ddc624c$var$UNDO_X = 220;
const $61c7210a4ddc624c$var$ENTER_W = 90;
const $61c7210a4ddc624c$var$ENTER_H = 42;
// What each tool draws on its plot.
const $61c7210a4ddc624c$var$TOOL_FOOTPRINT = {
    single: "single",
    line: "line",
    room: "rectangle"
};
/** A tool on the dock: a plot of squared paper with its footprint on it and its name beneath. */ class $61c7210a4ddc624c$var$ToolCell extends (0, $gwPoJ.Graphics) {
    constructor(label, kind, onTap){
        super(), this.label = label, this.kind = kind, this.selected = false, this.enabled = true, this.// The mobile toolbar is read back by label in gui_manager's frame tests, and a control that
        // cannot say what it is would be invisible to them.
        getLabel = ()=>this.label, this.setSelected = (selected)=>{
            if (selected === this.selected) return;
            this.selected = selected;
            this.draw();
        }, this.setEnabled = (enabled)=>{
            if (enabled === this.enabled) return;
            this.enabled = enabled;
            this.interactive = enabled;
            this.cursor = enabled ? "pointer" : "default";
            this.draw();
        }, this.draw = ()=>{
            const on = this.selected;
            const ink = on ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : (0, $658a44ce960354bb$export$8b477761269297db);
            const cy = 18;
            this.clear();
            (0, $658a44ce960354bb$export$d9a20d35155171c3)(this, $61c7210a4ddc624c$var$CELL_W, $61c7210a4ddc624c$var$CELL_H, on, false);
            (0, $658a44ce960354bb$export$ae6afae266d469)(this, {
                x: 4,
                y: 4,
                w: $61c7210a4ddc624c$var$CELL_W - 8,
                h: 26
            }, $61c7210a4ddc624c$var$CELL_W / 2, cy, on);
            (0, $658a44ce960354bb$export$26109819dc8e506a)(this, ink);
            (0, $658a44ce960354bb$export$b6fa4f57132973f4)(this, this.kind, $61c7210a4ddc624c$var$CELL_W / 2, cy);
            this.caption.style.fill = on ? (0, $658a44ce960354bb$export$8eb3a98fbc1bd246) : (0, $658a44ce960354bb$export$8b477761269297db);
            this.caption.position.set(($61c7210a4ddc624c$var$CELL_W - this.caption.width) / 2, 33);
            this.alpha = this.enabled ? 1 : 0.42;
        };
        this.caption = new (0, $9Pi8W.Text)(label, {
            fontFamily: (0, $ef882f0a643d87d9$export$2653e0d5dd45b294),
            fontSize: (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).compactBody.fontSize,
            fill: (0, $658a44ce960354bb$export$8b477761269297db)
        });
        this.addChild(this.caption);
        this.interactive = true;
        this.cursor = "pointer";
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $61c7210a4ddc624c$var$CELL_W, $61c7210a4ddc624c$var$CELL_H);
        this.on("pointertap", (event)=>{
            event?.stopPropagation();
            if (this.enabled) onTap();
        });
        this.draw();
    }
}
/**
 * A verb rather than a place to stand. Undo and the way into build mode both use it.
 *
 * `primary` is the one that stands on the grass by itself, so it is cut from timber like a board of
 * its own and carries the gold -- it is the only control on the screen that has to be FOUND. Undo
 * is already on a board, so it is just a plate let into it; a second timber frame there reads as a
 * board on a board.
 */ class $61c7210a4ddc624c$var$BoardButton extends (0, $gwPoJ.Graphics) {
    constructor(label, w, h, primary, onTap){
        super(), this.label = label, this.w = w, this.h = h, this.primary = primary, this.enabled = true, this.getLabel = ()=>this.label, this.setEnabled = (enabled)=>{
            if (enabled === this.enabled) return;
            this.enabled = enabled;
            this.interactive = enabled;
            this.cursor = enabled ? "pointer" : "default";
            this.draw();
        }, this.draw = ()=>{
            this.clear();
            if (this.primary) {
                this.lineStyle({
                    width: 3,
                    color: (0, $658a44ce960354bb$export$319b6132a2fafb7c),
                    alpha: 0.14,
                    join: (0, $gwPoJ.LINE_JOIN).MITER
                });
                (0, $658a44ce960354bb$export$99dca9ebbafa6899)(this, 1, 1, this.w - 2, this.h - 2, 5);
                this.lineStyle({
                    width: 1.5,
                    color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
                    alpha: 0.95,
                    join: (0, $gwPoJ.LINE_JOIN).MITER
                });
                this.beginFill((0, $658a44ce960354bb$export$611f5967b7e8b685), 0.98);
                (0, $658a44ce960354bb$export$99dca9ebbafa6899)(this, 0.75, 0.75, this.w - 1.5, this.h - 1.5, 5);
                this.endFill();
            }
            const inset = this.primary ? 3.5 : 0.5;
            this.lineStyle({
                width: 1,
                color: this.primary ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : (0, $658a44ce960354bb$export$dd27ce85ad53c944),
                alpha: this.primary ? 1 : 0.7,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            this.beginFill((0, $658a44ce960354bb$export$e969f1546e2d24ca), this.primary ? 0.9 : 0.75);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(this, inset, inset, this.w - inset * 2, this.h - inset * 2, 4);
            this.endFill();
            this.caption.style.fill = this.primary ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : (0, $658a44ce960354bb$export$c48687f662ce7e97);
            this.caption.position.set((this.w - this.caption.width) / 2, (this.h - this.caption.height) / 2);
            this.alpha = this.enabled ? 1 : 0.42;
        };
        this.caption = new (0, $9Pi8W.Text)(label.toUpperCase(), {
            fontFamily: (0, $ef882f0a643d87d9$export$2653e0d5dd45b294),
            fontSize: (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).compactBody.fontSize,
            fill: (0, $658a44ce960354bb$export$8eb3a98fbc1bd246),
            letterSpacing: 1
        });
        this.addChild(this.caption);
        this.interactive = true;
        this.cursor = "pointer";
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, w, h);
        this.on("pointertap", (event)=>{
            event?.stopPropagation();
            if (this.enabled) onTap();
        });
        this.draw();
    }
}
class $61c7210a4ddc624c$export$a2f2fafd4be10a1b extends (0, $8t5Gy.Container) {
    constructor(actions){
        super(), this.panel = new (0, $8t5Gy.Container)(), this.tools = new Map(), this.signature = "", this.update = (state, readiedBar)=>{
            this.visible = state.available || state.active;
            this.panel.visible = state.active;
            this.enter.visible = !state.active;
            // The tray shares our parent; compensate for our vertical scale to keep an 8-unit gap.
            const aboveTray = (readiedBar.y - 8) * (0, $10da07838e6d507c$export$c6ec669adaa5980d);
            this.panel.position.set(readiedBar.x, aboveTray - $61c7210a4ddc624c$var$PANEL_H);
            this.enter.position.set(readiedBar.x, aboveTray - $61c7210a4ddc624c$var$ENTER_H);
            const signature = `${state.tool}:${state.canUndo}`;
            if (signature !== this.signature) {
                this.signature = signature;
                this.tools.forEach((cell, tool)=>cell.setSelected(tool === state.tool));
                this.undo.setEnabled(state.canUndo);
            }
        };
        this.scale.y = 1 / (0, $10da07838e6d507c$export$c6ec669adaa5980d);
        this.zIndex = 60003;
        this.enter = new $61c7210a4ddc624c$var$BoardButton("Build", $61c7210a4ddc624c$var$ENTER_W, $61c7210a4ddc624c$var$ENTER_H, true, ()=>actions.toggle(true));
        this.addChild(this.enter, this.panel);
        const background = new (0, $gwPoJ.Graphics)();
        (0, $658a44ce960354bb$export$37d7f1037ab575d0)(background, $61c7210a4ddc624c$var$PANEL_W, $61c7210a4ddc624c$var$PANEL_H);
        this.panel.interactive = true;
        this.panel.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $61c7210a4ddc624c$var$PANEL_W, $61c7210a4ddc624c$var$PANEL_H);
        this.panel.addChild(background);
        [
            "single",
            "line",
            "room"
        ].forEach((tool, index)=>{
            const cell = new $61c7210a4ddc624c$var$ToolCell(tool[0].toUpperCase() + tool.slice(1), $61c7210a4ddc624c$var$TOOL_FOOTPRINT[tool], ()=>actions.select(tool));
            cell.position.set(10 + index * 70, $61c7210a4ddc624c$var$CELL_Y);
            this.tools.set(tool, cell);
            this.panel.addChild(cell);
        });
        this.undo = new $61c7210a4ddc624c$var$BoardButton("Undo", $61c7210a4ddc624c$var$CELL_W, $61c7210a4ddc624c$var$CELL_H, false, actions.undo);
        this.undo.position.set($61c7210a4ddc624c$var$UNDO_X, $61c7210a4ddc624c$var$CELL_Y);
        this.panel.addChild(this.undo);
    }
}



parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");



// The dial over a batch of walls that have been placed but not yet printed.
//
// It is TWO things at once, and the drawing has to say both: a clock running down the few seconds
// before the batch commits, and the button that calls the batch off. So the ring drains (the window
// is closing, not the wall rising) and the middle of the dial is the cancel target — showing the
// seconds left at rest, and swapping to a cross the moment the pointer is on it, which is the only
// moment "click to cancel" is the useful thing to say.
//
// These dials are children of the world surface. Their tile coordinates never depend on the player,
// the mouse or the camera; they travel through the same transforms as the walls they belong to.
// Base radius. The world surface is at surfaceZoom, which `root.scale` undoes, so everything here is
// in SCREEN pixels against a 64px-on-screen tile — the old 13px dial with a 6.5px readout under it
// was about a tenth of a tile tall and could not be read at all while building.
const $e66d7f5cf01e9ed1$var$RADIUS = 17;
const $e66d7f5cf01e9ed1$var$RING_RADIUS = $e66d7f5cf01e9ed1$var$RADIUS - 3.5;
const $e66d7f5cf01e9ed1$var$RING_WIDTH = 2.5;
const $e66d7f5cf01e9ed1$var$FACE_COLOR = 0x20262d;
const $e66d7f5cf01e9ed1$var$FACE_HOVER_COLOR = 0x45211d;
const $e66d7f5cf01e9ed1$var$BORDER_COLOR = 0x8e7b58;
const $e66d7f5cf01e9ed1$var$BORDER_HOVER_COLOR = 0xff8f74;
const $e66d7f5cf01e9ed1$var$GROOVE_COLOR = 0x454b54;
const $e66d7f5cf01e9ed1$var$RING_COLOR = 0xffd166;
const $e66d7f5cf01e9ed1$var$RING_LATE_COLOR = 0xff9d5c;
const $e66d7f5cf01e9ed1$var$RING_HOVER_COLOR = 0xff7a5c;
const $e66d7f5cf01e9ed1$var$INK_COLOR = 0xffedc7;
const $e66d7f5cf01e9ed1$var$INK_HOVER_COLOR = 0xffd9cf;
// Pop-in, and how much bigger the dial gets under the pointer.
const $e66d7f5cf01e9ed1$var$APPEAR_MS = 170;
const $e66d7f5cf01e9ed1$var$HOVER_SCALE = 1.14;
class $e66d7f5cf01e9ed1$export$a3b4303fb9c66aa0 extends (0, $8t5Gy.Container) {
    constructor(worldSurface){
        super(), this.worldSurface = worldSurface, this.rows = new Map(), this.hovered = new Set(), this.isPointerOver = ()=>this.visible && this.hovered.size > 0, this.setGroups = (groups, now = Date.now())=>{
            const ids = new Set(groups.map((group)=>group.id));
            this.rows.forEach((row, id)=>{
                if (ids.has(id)) return;
                this.removeChild(row.root);
                row.root.destroy({
                    children: true
                });
                this.rows.delete(id);
                this.hovered.delete(id);
            });
            groups.forEach((group)=>{
                let row = this.rows.get(group.id);
                if (!row) {
                    const root = new (0, $8t5Gy.Container)();
                    root.interactive = true;
                    root.cursor = "pointer";
                    root.hitArea = new (0, $6qzqq.Circle)(0, 0, $e66d7f5cf01e9ed1$var$RADIUS + 3);
                    root.on("pointerover", ()=>this.hovered.add(group.id));
                    root.on("pointerout", ()=>this.hovered.delete(group.id));
                    root.on("pointerdown", (event)=>{
                        // Secondary drags trim ghosts, even when they cross this world's dial.
                        if (event.data?.button === 2) return;
                        event.stopPropagation();
                        this.rows.get(group.id)?.group.onCancel();
                    });
                    const wheel = new (0, $gwPoJ.Graphics)();
                    root.addChild(wheel);
                    // The seconds live in the MIDDLE of the dial now, where the cancel cross used to be:
                    // one glance tells you how long you have, and the cross takes over on hover.
                    // 12px: the clear disc inside the groove is only ~24px across, and the numeral has
                    // to sit wholly inside it without crowding the ring.
                    const time = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(12).color($e66d7f5cf01e9ed1$var$INK_COLOR).bold().align("center").strokeThickness(2).render("");
                    time.anchor.set(0.5);
                    root.addChild(time);
                    // How many cells are about to print. Only ever drawn for a real batch — a single
                    // wall does not need telling that it is one wall.
                    // This one sits OUTSIDE the dial, over whatever the world has there, so it keeps a
                    // full outline — 10px carries one without the stroke closing up the glyphs.
                    const count = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(10).color($e66d7f5cf01e9ed1$var$INK_COLOR).bold().align("center").strokeThickness(2).render("");
                    count.anchor.set(0.5);
                    count.y = $e66d7f5cf01e9ed1$var$RADIUS + 6;
                    root.addChild(count);
                    row = {
                        root: root,
                        wheel: wheel,
                        time: time,
                        count: count,
                        group: group,
                        appearedAt: now,
                        drawn: ""
                    };
                    this.rows.set(group.id, row);
                    this.addChild(root);
                }
                row.group = group;
                // Set once from the group's final tile, in world pixels.
                row.root.position.set((group.anchor.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (group.anchor.y + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (group.yOffset || 0));
            });
            this.visible = groups.length > 0;
            this.update(now);
        }, this.update = (now = Date.now())=>{
            if (!this.visible) return;
            const surface = this.worldSurface();
            if (this.parent !== surface) surface.addChild(this);
            this.rows.forEach((row)=>this.updateRow(row, now));
        }, this.updateRow = (row, now)=>{
            const { group: group } = row;
            const remaining = Math.max(0, group.duration - (now - group.startedAt));
            const fraction = group.duration > 0 ? Math.min(1, remaining / group.duration) : 0;
            const hover = this.hovered.has(group.id);
            const appear = Math.min(1, (now - row.appearedAt) / $e66d7f5cf01e9ed1$var$APPEAR_MS);
            // Quantize what the paint actually depends on. A dial whose arc has not moved a visible
            // step, and which nothing is hovering, must not repaint: a wall batch can be several of
            // these and the frame budget here is shared with the whole map.
            // 120 steps around a ~85px circumference is sub-pixel, and halves the repaints at 60fps.
            const key = `${Math.round(fraction * 120)}:${hover ? 1 : 0}:${Math.round(appear * 20)}:${group.count}`;
            if (key === row.drawn) return;
            row.drawn = key;
            // Correct the stage's vertical stretch while preserving the tile anchor, and pop in (then
            // swell under the pointer) by scaling the whole dial about that same anchor.
            const grow = (0.72 + 0.28 * (0, $7f40928dcf527a2e$export$1157fb72e7fbceb5)(appear)) * (hover ? $e66d7f5cf01e9ed1$var$HOVER_SCALE : 1);
            row.root.scale.set(0.5 * grow, 0.5 / (0, $10da07838e6d507c$export$c6ec669adaa5980d) * grow);
            row.root.alpha = appear;
            const seconds = String(Math.max(1, Math.ceil(remaining / 1000)));
            if (row.time.text !== seconds) row.time.text = seconds;
            row.time.visible = !hover;
            row.time.tint = hover ? $e66d7f5cf01e9ed1$var$INK_HOVER_COLOR : $e66d7f5cf01e9ed1$var$INK_COLOR;
            const batch = group.count > 1 ? `x${group.count}` : "";
            if (row.count.text !== batch) row.count.text = batch;
            row.count.visible = batch.length > 0;
            this.drawWheel(row.wheel, fraction, hover);
        }, this.drawWheel = (wheel, fraction, hover)=>{
            wheel.clear();
            // Dropped silhouette: the dial sits over wall ghosts and grass, and needs to read as an
            // object on top of them rather than a decal painted into them.
            wheel.beginFill(0x000000, 0.26).drawCircle(0, 2, $e66d7f5cf01e9ed1$var$RADIUS).endFill();
            wheel.lineStyle(1, hover ? $e66d7f5cf01e9ed1$var$BORDER_HOVER_COLOR : $e66d7f5cf01e9ed1$var$BORDER_COLOR, hover ? 1 : 0.9);
            wheel.beginFill(hover ? $e66d7f5cf01e9ed1$var$FACE_HOVER_COLOR : $e66d7f5cf01e9ed1$var$FACE_COLOR, 0.97).drawCircle(0, 0, $e66d7f5cf01e9ed1$var$RADIUS - 1).endFill();
            // The empty groove the arc drains along.
            wheel.lineStyle($e66d7f5cf01e9ed1$var$RING_WIDTH, $e66d7f5cf01e9ed1$var$GROOVE_COLOR, 0.9).drawCircle(0, 0, $e66d7f5cf01e9ed1$var$RING_RADIUS);
            if (fraction > 0) {
                // Warms from gold toward orange as the window closes, and goes danger-red under the
                // pointer, where the dial is a cancel button rather than a clock.
                const color = hover ? $e66d7f5cf01e9ed1$var$RING_HOVER_COLOR : (0, $7f40928dcf527a2e$export$5931e35698b46017)($e66d7f5cf01e9ed1$var$RING_LATE_COLOR, $e66d7f5cf01e9ed1$var$RING_COLOR, fraction);
                const angle = -Math.PI / 2 + fraction * Math.PI * 2;
                // Fat faint copy first: a glow without a filter, which this hardware target cannot spare.
                wheel.lineStyle($e66d7f5cf01e9ed1$var$RING_WIDTH + 2.5, color, 0.26).moveTo(0, -$e66d7f5cf01e9ed1$var$RING_RADIUS).arc(0, 0, $e66d7f5cf01e9ed1$var$RING_RADIUS, -Math.PI / 2, angle);
                wheel.lineStyle($e66d7f5cf01e9ed1$var$RING_WIDTH, color).moveTo(0, -$e66d7f5cf01e9ed1$var$RING_RADIUS).arc(0, 0, $e66d7f5cf01e9ed1$var$RING_RADIUS, -Math.PI / 2, angle);
                // The moving endpoint makes the shrinking countdown arc easy to read.
                wheel.lineStyle(0).beginFill($e66d7f5cf01e9ed1$var$INK_COLOR).drawCircle(Math.cos(angle) * $e66d7f5cf01e9ed1$var$RING_RADIUS, Math.sin(angle) * $e66d7f5cf01e9ed1$var$RING_RADIUS, 2).endFill();
            }
            // A clock's twelve-o'clock notch reinforces that the shrinking ring is a timer.
            wheel.lineStyle(1, $e66d7f5cf01e9ed1$var$INK_COLOR, 0.8).moveTo(0, -$e66d7f5cf01e9ed1$var$RADIUS + 1).lineTo(0, -$e66d7f5cf01e9ed1$var$RING_RADIUS - $e66d7f5cf01e9ed1$var$RING_WIDTH / 2);
            // The cross is the hover state: at rest the middle of the dial is the countdown, and the
            // affordance appears exactly when it can be acted on.
            if (hover) {
                const arm = 4.5;
                wheel.lineStyle(2, $e66d7f5cf01e9ed1$var$INK_HOVER_COLOR).moveTo(-arm, -arm).lineTo(arm, arm).moveTo(arm, -arm).lineTo(-arm, arm);
            }
        };
        this.zIndex = 100001 // Above pending wall ghosts.
        ;
        this.visible = false;
    }
}



parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");



class $7c95d0228c4864ae$export$1ae9dd6d410d7f23 extends (0, $8t5Gy.Container) {
    constructor(onInvite){
        super(), this.onInvite = onInvite, this.panel = new (0, $8t5Gy.Container)(), this.scrim = new (0, $gwPoJ.Graphics)(), this.options = new Map(), this.mode = "pvp";
        this.addChild(this.scrim, this.panel);
        this.interactive = true;
        for (const event of [
            "pointermove",
            "pointerup",
            "rightclick"
        ])this.on(event, (e)=>e.stopPropagation());
        this.on("contextmenu", (e)=>{
            e.preventDefault();
            e.stopPropagation();
        });
        this.scrim.interactive = true;
        this.scrim.on("pointerdown", (e)=>{
            e.stopPropagation();
            this.close();
        });
        const plate = new (0, $gwPoJ.Graphics)();
        plate.beginFill(0x1b1512, 0.98).lineStyle(2, 0xf2a94e, 0.9).drawRoundedRect(0, 0, 310, 230, 10).endFill();
        this.panel.addChild(plate);
        this.panel.interactive = true;
        this.panel.hitArea = new (0, $6qzqq.Rectangle)(0, 0, 310, 230);
        this.panel.on("pointerdown", (e)=>e.stopPropagation());
        this.title = this.label("", 14, 14, "label");
        this.label("Choose this player's play mode", 14, 42, "compactBody");
        [
            "pvp",
            "cooperation"
        ].forEach((mode, i)=>{
            const card = new (0, $gwPoJ.Graphics)();
            card.position.set(14 + i * 146, 68);
            card.interactive = true;
            card.cursor = "pointer";
            card.hitArea = new (0, $6qzqq.Rectangle)(0, 0, 136, 100);
            const title = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("label").color(0xfff3e0).bold().render(mode === "pvp" ? "PVP" : "Cooperation");
            title.position.set(10, 12);
            const desc = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("compactLabel").color(0xfff3e0).render(mode === "pvp" ? "No restrictions\nPlayer hits allowed" : "Work together\nNo player hits");
            desc.position.set(10, 40);
            card.addChild(title, desc);
            card.on("pointerdown", (e)=>{
                e.stopPropagation();
                this.selectMode(mode);
            });
            this.options.set(mode, card);
            this.panel.addChild(card);
        });
        this.button("Cancel", 14, ()=>this.close(), "standard");
        this.button("Invite", 160, ()=>this.confirm(), "confirm");
        this.visible = false;
    }
    label(text, x, y, role) {
        const label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role(role).bold(false).color(0xfff3e0).render(text);
        label.position.set(x, y);
        this.panel.addChild(label);
        return label;
    }
    button(label, x, onClick, preset) {
        const button = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
            label: label,
            onClick: onClick,
            width: 136,
            height: (0, $97475243e21a0995$export$73e83bf2b7e02467).medium.height,
            size: "medium",
            theme: "ember",
            preset: preset
        });
        button.position.set(x, 184);
        this.panel.addChild(button);
    }
    resize(width, height, left = 0, top = 0) {
        this.scrim.clear().beginFill(0x000000, 0.4).drawRect(left, top, width, height).endFill();
        this.scrim.hitArea = new (0, $6qzqq.Rectangle)(left, top, width, height);
        const scale = Math.max(0, Math.min(1, (width - 16) / 310, (height - 16) / 230));
        this.panel.scale.set(scale);
        this.panel.position.set(left + (width - 310 * scale) / 2, top + (height - 230 * scale) / 2);
    }
    open(id, name) {
        this.target = id;
        this.title.text = `Invite ${(name || id).slice(0, 23)}`;
        this.selectMode("pvp");
        this.visible = true;
    }
    selectMode(mode) {
        this.mode = mode;
        this.options.forEach((card, option)=>{
            const selected = option === mode;
            card.clear().beginFill(selected ? 0x33402e : 0x2a201a).lineStyle(selected ? 2 : 1, selected ? 0x7be08a : 0x6b4f38).drawRoundedRect(0, 0, 136, 100, 8).endFill();
        });
    }
    confirm() {
        if (!this.target) return;
        const id = this.target;
        const mode = this.mode;
        this.close();
        this.onInvite(id, mode);
    }
    close() {
        this.target = undefined;
        this.visible = false;
    }
    isOpen() {
        return !!this.target;
    }
    getTargetEntityId() {
        return this.target;
    }
}








var $8JEKL = parcelRequire("8JEKL");
parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $hnGDn = parcelRequire("hnGDn");
var $6qzqq = parcelRequire("6qzqq");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $kXE1p = parcelRequire("kXE1p");
parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $9Pi8W = parcelRequire("9Pi8W");
var $8t5Gy = parcelRequire("8t5Gy");




const $c557fc6e01c5a536$export$c212ee05c579f421 = 168;
const $c557fc6e01c5a536$export$59d4a21219d9e8bc = 100;
const $c557fc6e01c5a536$export$f84fc1b798c3f62d = $c557fc6e01c5a536$export$59d4a21219d9e8bc / (0, $10da07838e6d507c$export$c6ec669adaa5980d);
const $c557fc6e01c5a536$var$CELL_W = 46;
const $c557fc6e01c5a536$var$CELL_H = 32;
const $c557fc6e01c5a536$var$CELL_GAP = 5;
const $c557fc6e01c5a536$var$CELL_Y = 26;
const $c557fc6e01c5a536$var$CELL_X = ($c557fc6e01c5a536$export$c212ee05c579f421 - ($c557fc6e01c5a536$var$CELL_W * 3 + $c557fc6e01c5a536$var$CELL_GAP * 2)) / 2;
// Clear of the corner rivets, which is what sets the board's text margin.
const $c557fc6e01c5a536$var$TEXT_X = 15;
const $c557fc6e01c5a536$export$f542b2644ae8f7c4 = (shape)=>({
        x: $c557fc6e01c5a536$var$CELL_X + (0, $85e59abaaefadc89$export$508fe9565d0ddf0f).indexOf(shape) * ($c557fc6e01c5a536$var$CELL_W + $c557fc6e01c5a536$var$CELL_GAP) + $c557fc6e01c5a536$var$CELL_W / 2,
        y: ($c557fc6e01c5a536$var$CELL_Y + $c557fc6e01c5a536$var$CELL_H / 2) / (0, $10da07838e6d507c$export$c6ec669adaa5980d)
    });
// One plot: a square of dug ground under squared paper, with the footprint drawn on it.
//
// This owns its own plate rather than sitting on a UiButton, because the shared control is exactly
// the rounded slate rectangle this widget is getting away from, and the only thing left to borrow
// from it would be input -- which is three listeners.
class $c557fc6e01c5a536$var$ShapeCell extends (0, $gwPoJ.Graphics) {
    constructor(shape, onSelect){
        super(), this.shape = shape, this.hovered = false, this.selected = false, this.filled = false, this.enabled = true, this.setEnabled = (enabled)=>{
            this.enabled = enabled;
            this.interactive = enabled;
            this.cursor = enabled ? "pointer" : "default";
            if (!enabled) this.hovered = false;
            this.draw();
        }, this.setSelected = (selected)=>{
            this.selected = selected;
            this.draw();
        }, this.// Whether this shape prints solid. It is the material that decides (a wall is an outline,
        // everything else fills), not the shape -- so every cell wears the same answer, and a line is
        // neither either way.
        setFilled = (filled)=>{
            this.filled = filled && this.shape !== "line";
            this.draw();
        }, this.draw = ()=>{
            const on = this.selected;
            const ink = on ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : this.hovered ? (0, $658a44ce960354bb$export$8eb3a98fbc1bd246) : (0, $658a44ce960354bb$export$8b477761269297db);
            const cx = $c557fc6e01c5a536$var$CELL_W / 2;
            const cy = $c557fc6e01c5a536$var$CELL_H / 2;
            this.clear();
            (0, $658a44ce960354bb$export$d9a20d35155171c3)(this, $c557fc6e01c5a536$var$CELL_W, $c557fc6e01c5a536$var$CELL_H, on, this.hovered);
            // The wash goes under the grid, not over it, so a filled footprint still reads as squares
            // being claimed rather than as a flat blob.
            if (this.filled) {
                this.lineStyle(0);
                this.beginFill(ink, 0.22);
                (0, $658a44ce960354bb$export$b6fa4f57132973f4)(this, this.shape, cx, cy);
                this.endFill();
            }
            (0, $658a44ce960354bb$export$ae6afae266d469)(this, {
                x: 4,
                y: 4,
                w: $c557fc6e01c5a536$var$CELL_W - 8,
                h: $c557fc6e01c5a536$var$CELL_H - 8
            }, cx, cy, on);
            (0, $658a44ce960354bb$export$26109819dc8e506a)(this, ink);
            (0, $658a44ce960354bb$export$b6fa4f57132973f4)(this, this.shape, cx, cy);
            this.alpha = this.enabled ? 1 : 0.42;
        };
        this.interactive = true;
        this.cursor = "pointer";
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $c557fc6e01c5a536$var$CELL_W, $c557fc6e01c5a536$var$CELL_H);
        this.on("pointerover", ()=>{
            if (this.enabled) {
                this.hovered = true;
                this.draw();
            }
        });
        this.on("pointerout", ()=>{
            this.hovered = false;
            this.draw();
        });
        // Press rather than release: the pointer is already down for the drag that follows.
        this.on("pointerdown", (event)=>{
            event?.stopPropagation();
            if (this.enabled) onSelect();
        });
        this.draw();
    }
}
class $c557fc6e01c5a536$export$9e2c2e69a6bd8f7 extends (0, $8t5Gy.Container) {
    constructor(onSelect){
        super(), this.background = new (0, $gwPoJ.Graphics)(), this.chip = new (0, $gwPoJ.Graphics)(), this.buttons = new Map(), this.caption = new (0, $9Pi8W.Text)("", {
            fontFamily: (0, $ef882f0a643d87d9$export$2653e0d5dd45b294),
            fontSize: (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).compactLabel.fontSize,
            fill: (0, $658a44ce960354bb$export$8eb3a98fbc1bd246),
            letterSpacing: 1.2
        }), this.mode = new (0, $9Pi8W.Text)("", {
            fontFamily: (0, $ef882f0a643d87d9$export$2653e0d5dd45b294),
            fontSize: (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).overline.fontSize,
            fill: (0, $658a44ce960354bb$export$c48687f662ce7e97),
            letterSpacing: 1
        }), this.hint = new (0, $9Pi8W.Text)("Scroll or click \xb7 drag to draw", {
            fontFamily: (0, $ef882f0a643d87d9$export$2653e0d5dd45b294),
            fontSize: (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).compactCaption.fontSize,
            fill: (0, $658a44ce960354bb$export$c48687f662ce7e97)
        }), this.correctionHint = new (0, $9Pi8W.Text)("Right-drag erase \xb7 Z undo", {
            fontFamily: (0, $ef882f0a643d87d9$export$2653e0d5dd45b294),
            fontSize: (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).compactCaption.fontSize,
            fill: (0, $658a44ce960354bb$export$c48687f662ce7e97)
        }), this.signature = "", this.locked = false, // The mode plate riveted to the board's top right: what the chosen shape will print as. While a
        // stroke is being dragged it fills gold and says so, which is also the signal that the cells
        // below have gone cold.
        this.drawChip = (label, lit)=>{
            this.mode.text = label;
            const width = Math.max(28, Math.round(this.mode.width) + 12);
            const x = $c557fc6e01c5a536$export$c212ee05c579f421 - $c557fc6e01c5a536$var$TEXT_X - width;
            this.chip.clear();
            this.chip.lineStyle({
                width: 1,
                color: lit ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : (0, $658a44ce960354bb$export$dd27ce85ad53c944),
                alpha: lit ? 1 : 0.55,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            this.chip.beginFill(lit ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : 0x000000, lit ? 0.9 : 0.3);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(this.chip, x, 9, width, 14, 3);
            this.chip.endFill();
            this.mode.style.fill = lit ? 0x2a1a0c : (0, $658a44ce960354bb$export$c48687f662ce7e97);
            this.mode.position.set(x + (width - this.mode.width) / 2, 12);
        }, this.setState = (visible, shape, locked, hollow)=>{
            this.visible = visible;
            this.locked = locked;
            const signature = `${shape}:${locked}:${hollow}`;
            if (signature === this.signature) return;
            this.signature = signature;
            this.caption.text = shape.toUpperCase();
            this.drawChip(locked ? "DRAWING" : shape === "line" ? "STROKE" : hollow ? "OUTLINE" : "FILLED", locked);
            this.hint.text = locked ? "Release to start printing" : shape === "line" ? "Drag freely \xb7 Alt to snap" : shape === "rectangle" && !hollow ? "Drag area \xb7 Alt to align edges" : "Scroll or click \xb7 drag to draw";
            this.buttons.forEach((cell, candidate)=>{
                cell.setEnabled(!locked);
                cell.setSelected(candidate === shape);
                cell.setFilled(!hollow);
            });
        };
        this.visible = false;
        this.zIndex = 60002;
        this.scale.y = 1 / (0, $10da07838e6d507c$export$c6ec669adaa5980d);
        this.interactive = true;
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $c557fc6e01c5a536$export$c212ee05c579f421, $c557fc6e01c5a536$export$59d4a21219d9e8bc);
        (0, $658a44ce960354bb$export$37d7f1037ab575d0)(this.background, $c557fc6e01c5a536$export$c212ee05c579f421, $c557fc6e01c5a536$export$59d4a21219d9e8bc);
        (0, $658a44ce960354bb$export$5ed3e56f5245819d)(this.background, $c557fc6e01c5a536$var$TEXT_X - 4, $c557fc6e01c5a536$export$c212ee05c579f421 - $c557fc6e01c5a536$var$TEXT_X + 4, 62.5);
        this.addChild(this.background);
        this.caption.position.set($c557fc6e01c5a536$var$TEXT_X, 10);
        this.hint.position.set($c557fc6e01c5a536$var$TEXT_X, 66);
        this.correctionHint.position.set($c557fc6e01c5a536$var$TEXT_X, 81);
        this.addChild(this.chip, this.caption, this.mode, this.hint, this.correctionHint);
        (0, $85e59abaaefadc89$export$508fe9565d0ddf0f).forEach((shape, index)=>{
            const cell = new $c557fc6e01c5a536$var$ShapeCell(shape, ()=>{
                if (!this.locked) onSelect(shape);
            });
            cell.position.set($c557fc6e01c5a536$var$CELL_X + index * ($c557fc6e01c5a536$var$CELL_W + $c557fc6e01c5a536$var$CELL_GAP), $c557fc6e01c5a536$var$CELL_Y);
            this.buttons.set(shape, cell);
            this.addChild(cell);
        });
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");





class $ae9502ee83364da4$var$Pulsar {
    constructor(id, circle, mask){
        this.pulse = (duration)=>{
            if (this.pulsing) {
                clearInterval(this.circleGlow);
                clearInterval(this.volume);
            }
            this.pulsing = true;
            let { circle: circle, mask: mask } = this;
            circle.alpha = 1.0;
            circle.lineStyle(1, 0xffffff);
            circle.beginFill(0xffffff);
            circle.drawCircle(0, 0, 14);
            circle.endFill();
            mask.clear();
            mask.beginFill(0xff3300);
            mask.drawRect(-15, -15, 30, 30);
            mask.endFill();
            let dir = 1;
            this.circleGlow = setInterval(()=>{
                if (dir === -1) circle.alpha -= 0.01;
                else circle.alpha += 0.01;
                if (circle.alpha < 0.2) dir = 1;
                if (circle.alpha > 0.8) dir = -1;
            }, 10);
            let h = 0;
            this.volume = setInterval(()=>{
                if (h >= 30) {
                    clearInterval(this.volume);
                    clearInterval(this.circleGlow);
                    this.pulsing = false;
                    return;
                }
                h += 1;
                mask.clear();
                mask.beginFill(0xff3300);
                mask.drawRect(-15, h - 15, 30, 30);
                mask.endFill();
            }, duration / 30);
        };
        this.remove = ()=>{
            this.circle.parent.removeChild(this.circle);
            this.mask.parent.removeChild(this.mask);
        };
        this.entityId = id;
        this.circle = circle;
        this.mask = mask;
    }
}
class $ae9502ee83364da4$export$f69bebae58da6a32 extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.slotCoordinates = new Map(), this.slotPulsar = new (0, $cb689cfa16c444ba$export$cbcb4f84fc8dd985)(), this.renderSlot = (abilityType, label, item, quantity, cap, callback, showRing)=>{
            const slot = new (0, $gwPoJ.Graphics)();
            const mask = new (0, $gwPoJ.Graphics)();
            mask.name = "mask";
            mask.beginFill(0xff3300);
            mask.drawRect(-15, -15, 30, 30);
            mask.endFill();
            const circle = new (0, $gwPoJ.Graphics)();
            circle.name = "circle";
            circle.alpha = 0.0;
            circle.lineStyle(1, 0xffffff);
            circle.beginFill(0xffffff);
            circle.drawCircle(0, 0, 14);
            circle.endFill();
            circle.mask = mask;
            slot.addChild(mask, circle);
            if (showRing) {
                const circle2 = new (0, $gwPoJ.Graphics)();
                circle2.lineStyle(1, 0xffffff);
                circle2.drawCircle(0, 0, 14);
                slot.addChild(circle2);
            }
            item.y = -2;
            item.x = -2;
            slot.addChild(item);
            const labelObject = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().render(`${label}: ${quantity}${cap ? `/${cap}` : ""}`);
            labelObject.x = -20;
            labelObject.y = -30;
            slot.addChild(labelObject);
            const pulsar = new $ae9502ee83364da4$var$Pulsar(abilityType, circle, mask);
            this.slotPulsar.set(abilityType, pulsar);
            slot.interactive = true;
            slot.on("pointerdown", callback);
            return slot;
        }, this.update = (inventory, slotCallback)=>{
            // clear all
            this.slotCoordinates.clear();
            this.slotPulsar.iterate((next)=>next.remove());
            this.slotPulsar.clear();
            [
                ...this.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.removeChildren();
            let slotPos = 0;
            Object.values(inventory?.abilities || {}).sort((a, b)=>(0, $cb689cfa16c444ba$export$1cd76c5103dfeb09)[a.abilityType].equipOrder - (0, $cb689cfa16c444ba$export$1cd76c5103dfeb09)[b.abilityType].equipOrder).map((item)=>{
                const { abilityType: abilityType, quantity: quantity } = item;
                if (quantity < 1) return;
                const meta = (0, $cb689cfa16c444ba$export$1cd76c5103dfeb09)[abilityType];
                const shortcutKey = meta.shortcutKey;
                let renderable;
                let showRing = true;
                switch(abilityType){
                    case "heal":
                        renderable = new (0, $0ecb2be6c709254f$export$2d9ac7aa84f97a08)(0x00ff00);
                        renderable.scale.set(0.7);
                        break;
                    case "mana":
                        renderable = new (0, $0ecb2be6c709254f$export$2d9ac7aa84f97a08)(0x399cbd);
                        renderable.scale.set(0.7);
                        break;
                    case "bomb":
                        renderable = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                            color: 0xffffff,
                            name: "bomb.png",
                            scale: 1.45,
                            animated: false
                        });
                        showRing = false;
                        break;
                    case "speed":
                        break;
                }
                const slot = this.renderSlot(abilityType, shortcutKey, renderable, quantity, meta.maxCarried || 0, ()=>slotCallback(shortcutKey), showRing);
                slot.x = slotPos * 50;
                this.addChild(slot);
                this.slotCoordinates.set(abilityType, {
                    x: slot.x,
                    y: slot.y
                });
                slotPos++;
            });
        };
        this.guiManager = guiManager;
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

class $ac2a97d45725bff5$export$f79759b47a91f0e7 {
    constructor(guiManager, props){
        this.isOpen = ()=>this.show;
        this.update = ()=>{
            this.rebuildSurface();
        };
        // Repaint the content. Split out from update() so a subclass can decide for itself WHEN to
        // repaint (the character builder is driven by player-stat updates it mostly wants to ignore)
        // and still get the same teardown.
        //
        // Frees the previous content's per-instance Text textures before rebuilding -- otherwise every
        // open of this modal (inventory, character sheet, etc.) strands all its grid item labels /
        // quantity / stat Text textures. Shared item-sprite textures are left intact.
        this.rebuildSurface = ()=>{
            [
                ...this.surface.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.surface.removeChildren();
            this.surface.addChild(this.createContent());
            // Content can change the panel's measured size and close anchor. Reposition the frame
            // after painting, including the initial open and transitions between item screens.
            this.modal?.update();
        };
        this.width = ()=>this.modal?.width;
        this.height = ()=>this.modal?.height;
        this.close = ()=>{
            if (!this.show) return;
            this.show = false;
            this.modal?.close();
        };
        this.toggle = (onClose)=>{
            if (this.show) {
                this.close();
                return;
            }
            this.show = true;
            this.modal = this.guiManager.createModal({
                ...this.dragOptions,
                padding: this.padding,
                content: this.surface,
                fullScreen: true,
                backgroundAlpha: this.backgroundAlpha !== undefined ? this.backgroundAlpha : !this.opaque ? 0.91 : 1.0,
                plain: true,
                unescapeable: this.unescapable,
                closeAnchor: this.closeAnchor,
                closeButtonScale: this.closeButtonScale,
                closeTheme: this.closeTheme,
                hideCloseButton: this.hideCloseButton,
                onResize: ()=>this.update(),
                onClosed: ()=>{
                    this.show = false;
                },
                closeCallback: (clicked)=>{
                    if (this.onClose) this.onClose(clicked);
                    else if (onClose) onClose(clicked);
                }
            });
            this.update();
        };
        this.guiManager = guiManager;
        this.show = false;
        this.surface = new (0, $gwPoJ.Graphics)();
        this.padding = props?.padding ?? 10;
        this.opaque = props?.opaque || false;
        this.unescapable = props?.unescapable || false;
        this.backgroundAlpha = props?.backgroundAlpha;
        this.closeAnchor = props?.closeAnchor;
        this.closeButtonScale = props?.closeButtonScale;
        this.closeTheme = props?.closeTheme;
        this.hideCloseButton = props?.hideCloseButton;
        this.dragOptions = {
            dragHandle: props?.dragHandle,
            dragBounds: props?.dragBounds,
            onDrag: props?.onDrag
        };
    }
}


class $a67de6ec9600469c$export$c8424c4d8ba2150 extends (0, $ac2a97d45725bff5$export$f79759b47a91f0e7) {
    constructor(guiManager){
        super(guiManager), this.createContent = ()=>{
            const main = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            main.append("~~~~~~~~~~~~~~~~~~~").append("About Project Samsara").append("v2.0.0").append("~~~~~~~~~~~~~~~~~~~").append("Project Samsara is an experimental multiplayer combat game, in the vein").append("of its forebearers of the 90's, similar to Diablo I. This is about").append("that old feeling of blasting away the hordes, with or without your friends.").append("").append("...and also of blasting away your friends.").append("").append("The initial focus of this project is getting the gameplay mechanics right,").append("which is advancing your character's stats and equipment by completing the").append("game's challenges.").append("").append("Players will make decisions on what weapons, abilities, and equipment to").append("lean on in real-time during combat.").append("").append("There is a storyline in the works, which can be enjoyed as part of the").append("optional exploration aspect of this world that is yet to be developed.").append("").append("Stick with me as I evolve this game. Drop me a line at").appendLink("project-samsara@olioapps.com", "mailto:project-samsara@olioapps.com").append(", join the ", true).appendLink("project subreddit", "https://www.reddit.com/r/projectsamsara/", true).append(" or ", true).appendLink("discord channel", "https://discord.gg/Mbt6UfqW6e").append(" for latest developments!", true);
            return main;
        };
    }
}




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $8t5Gy = parcelRequire("8t5Gy");





parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");

parcelRequire("1avo5");
var $P8XPi = parcelRequire("P8XPi");
var $gwPoJ = parcelRequire("gwPoJ");
const $d4e9bfba8663fd0e$var$MAX_PARTICLES = 30;
const $d4e9bfba8663fd0e$var$SPAWN_RATE = 48 // particles/sec at full intensity
;
const $d4e9bfba8663fd0e$export$c8b3142d2b0d3df4 = (lifeFrac)=>lifeFrac > 0.8 ? 0xfff6d0 : lifeFrac > 0.55 ? 0xffd23c : lifeFrac > 0.3 ? 0xff8a1e : 0xe33a12;
class $d4e9bfba8663fd0e$export$180e4127bb338fb5 extends (0, $gwPoJ.Graphics) {
    // `glow` draws the layered warm halo behind the particles (the roster card wants it; the tutorial
    // dioramas' stand-in for FireSprite turns it off).
    constructor(width, height, { glow: glow = true } = {}){
        super(), this.particles = [], this.spawnAccumulator = 0, this._t = 0, this.spawn = ()=>{
            const cx = this.w / 2;
            this.particles.push({
                x: cx + (Math.random() - 0.5) * this.w * 0.85,
                y: this.h - Math.random() * 6,
                vx: (Math.random() - 0.5) * 0.01,
                vy: -(0.02 + Math.random() * 0.035),
                life: 0,
                maxLife: 650 + Math.random() * 800,
                size: 3.5 + Math.random() * 3.5
            });
        }, this.update = (dtMs, intensity)=>{
            const dt = Math.min(dtMs, 50) // clamp big frame gaps so particles don't jump
            ;
            const i = Math.max(0, Math.min(1, intensity));
            const target = Math.round($d4e9bfba8663fd0e$var$MAX_PARTICLES * i);
            // advance + cull
            this.particles = this.particles.filter((p)=>{
                p.life += dt;
                p.x += p.vx * dt;
                p.y += p.vy * dt;
                return p.life < p.maxLife && p.y > -3;
            });
            // spawn toward the target at a rate proportional to intensity
            this.spawnAccumulator += dt / 1000 * $d4e9bfba8663fd0e$var$SPAWN_RATE * i;
            while(this.spawnAccumulator >= 1){
                this.spawnAccumulator -= 1;
                if (this.particles.length < target) this.spawn();
            }
            // redraw
            this.clear();
            if (i <= 0) return;
            // Warm glow rising from the bottom-centre — this is the "backdrop" that dims with weak fire.
            // A gentle flicker keeps it alive even when few particles are around.
            if (this.showGlow) {
                const flicker = 0.85 + 0.15 * Math.sin(this._t + Math.random());
                this._t += 0.15;
                const gx = this.w / 2;
                const gy = this.h * 0.72;
                const glowR = this.w * 0.85;
                // Layered warm glow, brightest at the core (additive, so these stack toward white).
                this.beginFill(0xff4a12, 0.3 * i * flicker);
                this.drawEllipse(gx, gy, glowR, glowR * 0.95);
                this.endFill();
                this.beginFill(0xff8a24, 0.32 * i * flicker);
                this.drawEllipse(gx, gy + 3, glowR * 0.62, glowR * 0.74);
                this.endFill();
                this.beginFill(0xffcf5a, 0.34 * i * flicker);
                this.drawEllipse(gx, gy + 6, glowR * 0.34, glowR * 0.5);
                this.endFill();
            }
            // particles
            for (const p of this.particles){
                const lifeFrac = 1 - p.life / p.maxLife // 1 young -> 0 old
                ;
                const alpha = lifeFrac * 0.9 * i;
                const r = p.size * (0.5 + 0.5 * lifeFrac);
                this.beginFill($d4e9bfba8663fd0e$export$c8b3142d2b0d3df4(lifeFrac), alpha);
                this.drawCircle(p.x, p.y, r);
                this.endFill();
            }
        };
        this.w = width;
        this.h = height;
        this.showGlow = glow;
        // Additive blending: warm colours glow against the dark card and overlapping particles /
        // glow accumulate toward white — the classic bright-fire look.
        this.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $P8XPi = parcelRequire("P8XPi");
var $8t5Gy = parcelRequire("8t5Gy");
const $92b2c55b1ed94f26$export$d5e3057492233c50 = 0xff3d08;
const $92b2c55b1ed94f26$export$eb82270a4aa97b72 = 0xff8a24;
const $92b2c55b1ed94f26$export$319b6132a2fafb7c = 0xffd166;
const $92b2c55b1ed94f26$export$1cabeb8d5c2c6b4d = 0xffedc7;
// A spark cools as it rises: near-white-gold when it leaves the fire, deep orange by the time it goes.
const $92b2c55b1ed94f26$var$SPARK_HOT = 0xffe7a3;
const $92b2c55b1ed94f26$var$SPARK_WARM = 0xffb347;
const $92b2c55b1ed94f26$var$SPARK_COOL = 0xff6a24;
const $92b2c55b1ed94f26$var$bake = (w, h, paint)=>{
    try {
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const g = canvas.getContext("2d");
        if (!g || typeof g.createRadialGradient !== "function") return (0, $klOfb.Texture).WHITE;
        paint(g, w, h);
        return (0, $klOfb.Texture).from(canvas);
    } catch (e) {
        // No canvas (a test environment, or a browser that refuses one): a flat texture costs the
        // softness, not the screen.
        return (0, $klOfb.Texture).WHITE;
    }
};
const $92b2c55b1ed94f26$var$radial = (stops)=>(g, w, h)=>{
        const gradient = g.createRadialGradient(w / 2, h / 2, 0, w / 2, h / 2, w / 2);
        stops.forEach(([offset, alpha])=>gradient.addColorStop(offset, `rgba(255,255,255,${alpha})`));
        g.fillStyle = gradient;
        g.fillRect(0, 0, w, h);
    };
const $92b2c55b1ed94f26$var$cache = {};
const $92b2c55b1ed94f26$var$once = (key, make)=>$92b2c55b1ed94f26$var$cache[key] = $92b2c55b1ed94f26$var$cache[key] || make();
const $92b2c55b1ed94f26$export$c19a1bc36129b4be = ()=>$92b2c55b1ed94f26$var$once("glow", ()=>$92b2c55b1ed94f26$var$bake(128, 128, $92b2c55b1ed94f26$var$radial([
            [
                0,
                1
            ],
            [
                0.3,
                0.5
            ],
            [
                0.65,
                0.14
            ],
            [
                1,
                0
            ]
        ])));
const $92b2c55b1ed94f26$export$39bbb304d3263439 = ()=>$92b2c55b1ed94f26$var$once("spark", ()=>$92b2c55b1ed94f26$var$bake(32, 32, $92b2c55b1ed94f26$var$radial([
            [
                0,
                1
            ],
            [
                0.18,
                1
            ],
            [
                0.3,
                0.55
            ],
            [
                0.55,
                0.12
            ],
            [
                1,
                0
            ]
        ])));
const $92b2c55b1ed94f26$export$bc3e2f9b8d094108 = ()=>$92b2c55b1ed94f26$var$once("vignette", ()=>$92b2c55b1ed94f26$var$bake(256, 256, (g, w, h)=>{
            const gradient = g.createRadialGradient(w / 2, h * 0.55, w * 0.22, w / 2, h * 0.55, w * 0.75);
            gradient.addColorStop(0, "rgba(0,0,0,0)");
            gradient.addColorStop(1, "rgba(3,2,1,0.9)");
            g.fillStyle = gradient;
            g.fillRect(0, 0, w, h);
        }));
const $92b2c55b1ed94f26$export$db409cdf2315a975 = ()=>$92b2c55b1ed94f26$var$once("nightfall", ()=>$92b2c55b1ed94f26$var$bake(4, 256, (g, w, h)=>{
            const gradient = g.createLinearGradient(0, 0, 0, h);
            gradient.addColorStop(0, "rgba(9,6,5,0.86)");
            gradient.addColorStop(0.42, "rgba(14,9,6,0.42)");
            gradient.addColorStop(0.72, "rgba(14,9,6,0.38)");
            gradient.addColorStop(1, "rgba(6,4,3,0.7)");
            g.fillStyle = gradient;
            g.fillRect(0, 0, w, h);
        }));
const $92b2c55b1ed94f26$export$fc6a66bad1f036bc = (color, width, height, alpha, { additive: additive = true } = {})=>{
    const sprite = new (0, $7Bs2Z.Sprite)($92b2c55b1ed94f26$export$c19a1bc36129b4be());
    sprite.anchor.set(0.5);
    sprite.tint = color;
    sprite.width = width;
    sprite.height = height;
    sprite.alpha = alpha;
    if (additive) sprite.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
    return sprite;
};
const $92b2c55b1ed94f26$export$61e1f52f544ad1da = (ms, seed = 0)=>0.55 * Math.sin(ms / 170 + seed) * Math.sin(ms / 410 + seed * 1.7) + 0.3 * Math.sin(ms / 93 + seed * 2.3) + 0.15 * Math.sin(ms / 1300 + seed);
const $92b2c55b1ed94f26$export$f5be6f9336c4d7e0 = (age)=>{
    if (age <= 0 || age >= 1) return 0;
    const catchUp = Math.min(1, age / 0.12);
    const fade = age < 0.6 ? 1 : 1 - (age - 0.6) / 0.4;
    return catchUp * fade;
};
const $92b2c55b1ed94f26$var$lerpChannel = (from, to, shift, t)=>Math.round((from >> shift & 0xff) + ((to >> shift & 0xff) - (from >> shift & 0xff)) * t);
const $92b2c55b1ed94f26$var$lerpColor = (from, to, t)=>$92b2c55b1ed94f26$var$lerpChannel(from, to, 16, t) << 16 | $92b2c55b1ed94f26$var$lerpChannel(from, to, 8, t) << 8 | $92b2c55b1ed94f26$var$lerpChannel(from, to, 0, t);
const $92b2c55b1ed94f26$export$d604275f87a72912 = (age)=>age < 0.5 ? $92b2c55b1ed94f26$var$lerpColor($92b2c55b1ed94f26$var$SPARK_HOT, $92b2c55b1ed94f26$var$SPARK_WARM, age * 2) : $92b2c55b1ed94f26$var$lerpColor($92b2c55b1ed94f26$var$SPARK_WARM, $92b2c55b1ed94f26$var$SPARK_COOL, (age - 0.5) * 2);
class $92b2c55b1ed94f26$export$8a5dcbf95285d0bf extends (0, $8t5Gy.Container) {
    constructor(options){
        super(), this.embers = [], this.surgeLeft = 0, this.surgeMs = 1, this.resize = (width, height)=>{
            this.opts.width = width;
            this.opts.height = height;
        }, /** A gust: for `ms`, the field climbs faster and burns brighter, easing back to calm. */ this.surge = (ms = 1200)=>{
            this.surgeLeft = ms;
            this.surgeMs = ms;
        }, this.update = (dtMs)=>{
            const dt = Math.min(dtMs, 100) / 1000;
            const gust = this.surgeLeft > 0 ? this.surgeLeft / this.surgeMs : 0;
            this.surgeLeft = Math.max(0, this.surgeLeft - dtMs);
            const boost = 1 + 1.6 * gust;
            this.embers.forEach((ember)=>{
                ember.life += dt * boost;
                ember.y -= ember.rise * dt * boost;
                if (ember.life >= ember.maxLife || ember.y < -12) this.spawn(ember);
            });
            this.paint(gust);
        }, this.spawn = (ember)=>{
            const { width: width, height: height, spawnBand: spawnBand, minSize: minSize, maxSize: maxSize, minRise: minRise, maxRise: maxRise, sway: sway, minLife: minLife, maxLife: maxLife, random: random } = this.opts;
            ember.x = random() * width;
            ember.y = height - random() * height * spawnBand;
            ember.rise = minRise + random() * (maxRise - minRise);
            ember.swayAmp = sway * (0.4 + random() * 0.6);
            ember.swayHz = 0.25 + random() * 0.5;
            ember.phase = random() * Math.PI * 2;
            ember.life = 0;
            ember.maxLife = minLife + random() * (maxLife - minLife);
            ember.size = minSize + random() * (maxSize - minSize);
        }, this.paint = (gust = 0)=>{
            this.embers.forEach((ember)=>{
                const age = ember.life / ember.maxLife;
                const twinkle = 0.78 + 0.22 * Math.sin(ember.life * 9 + ember.phase);
                const { sprite: sprite } = ember;
                sprite.x = ember.x + ember.swayAmp * Math.sin(ember.life * ember.swayHz * Math.PI * 2 + ember.phase);
                sprite.y = ember.y;
                const size = ember.size * (1 - 0.45 * age);
                sprite.width = size;
                sprite.height = size;
                sprite.tint = $92b2c55b1ed94f26$export$d604275f87a72912(age);
                sprite.alpha = Math.min(1, $92b2c55b1ed94f26$export$f5be6f9336c4d7e0(age) * twinkle * this.opts.alpha * (1 + 0.5 * gust));
            });
        };
        this.opts = {
            spawnBand: 0.35,
            minSize: 3,
            maxSize: 8,
            minRise: 14,
            maxRise: 34,
            sway: 14,
            minLife: 3,
            maxLife: 7,
            alpha: 1,
            random: Math.random,
            ...options
        };
        for(let i = 0; i < this.opts.count; i++){
            const sprite = new (0, $7Bs2Z.Sprite)($92b2c55b1ed94f26$export$39bbb304d3263439());
            sprite.anchor.set(0.5);
            sprite.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
            this.addChild(sprite);
            const ember = {
                sprite: sprite
            };
            this.spawn(ember);
            // Start the field already alight: every ember part way through a life, so the first frame
            // is not a line of sparks all leaving the floor at once.
            ember.life = this.opts.random() * ember.maxLife;
            ember.y -= ember.rise * ember.life;
            this.embers.push(ember);
        }
        this.paint();
    }
    get count() {
        return this.embers.length;
    }
}
class $92b2c55b1ed94f26$export$c0068614e4872c8e extends (0, $8t5Gy.Container) {
    constructor(count = 12, { spread: spread = 70, lift: lift = 110, random: random = Math.random } = {}){
        super(), this.sparks = [], this.update = (dtMs)=>{
            const dt = Math.min(dtMs, 100) / 1000;
            this.sparks.forEach((spark)=>{
                spark.life += dt;
                spark.vy += 160 * dt;
                const { sprite: sprite } = spark;
                sprite.x += spark.vx * dt;
                sprite.y += spark.vy * dt;
                const age = Math.min(1, spark.life / spark.maxLife);
                const size = spark.size * (1 - 0.5 * age);
                sprite.width = size;
                sprite.height = size;
                sprite.tint = $92b2c55b1ed94f26$export$d604275f87a72912(age);
                sprite.alpha = age >= 1 ? 0 : 1 - age * age;
            });
        };
        for(let i = 0; i < count; i++){
            const sprite = new (0, $7Bs2Z.Sprite)($92b2c55b1ed94f26$export$39bbb304d3263439());
            sprite.anchor.set(0.5);
            sprite.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
            this.addChild(sprite);
            const angle = -Math.PI / 2 + (random() - 0.5) * Math.PI * 1.3;
            const speed = 0.45 + random() * 0.55;
            this.sparks.push({
                sprite: sprite,
                vx: Math.cos(angle) * spread * speed * 1.4,
                vy: Math.sin(angle) * lift * speed - 20,
                life: 0,
                maxLife: 0.45 + random() * 0.4,
                size: 6 + random() * 7
            });
        }
        this.update(0);
    }
    get done() {
        return this.sparks.every((spark)=>spark.life >= spark.maxLife);
    }
}
class $92b2c55b1ed94f26$export$c9c6e685d99d3d5b {
    constructor(){
        this.live = [];
        this.throw = (parent, x, y, count = 12, spread, lift)=>{
            const burst = new $92b2c55b1ed94f26$export$c0068614e4872c8e(count, {
                spread: spread,
                lift: lift
            });
            burst.position.set(x, y);
            parent.addChild(burst);
            this.live.push(burst);
        };
        this.update = (dtMs)=>{
            this.live.forEach((burst)=>burst.update(dtMs));
            this.live = this.live.filter((burst)=>{
                if (burst.done) {
                    burst.parent?.removeChild(burst);
                    return false;
                }
                return true;
            });
        };
        this.clear = ()=>{
            this.live.forEach((burst)=>burst.parent?.removeChild(burst));
            this.live = [];
        };
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

/**
 * The wordmark's timeline, as pure maths.
 *
 * Everything here is a function of elapsed milliseconds, so the renderer can be a single
 * requestAnimationFrame loop that asks "what should letter i look like at t?" and writes the
 * answer. Two things fall out of that:
 *
 *  - A frame that never arrives costs nothing. A hidden tab gets no animation frames at all, and
 *    the old wordmark -- a Fader per letter on `setInterval(..., 2)`, which Chrome clamps to ~1s in
 *    the background -- would sit half-drawn for minutes before finishing. Time-driven state just
 *    jumps to where it should be on the first frame after the tab comes back.
 *  - The choreography is testable without a renderer, which is the only way to assert the shape of
 *    an animation (does it overshoot? is the stagger right? does it land?) at all.
 */ /** Gap between one letter starting its entrance and the next. */ const $b67ebd3775cb0f71$export$5a345ca57ca838cd = 115;
const $b67ebd3775cb0f71$export$8b9e5c5d42c3f8db = 460;
const $b67ebd3775cb0f71$export$4f9066f935d3d8b2 = 28;
const $b67ebd3775cb0f71$export$2d357ab4bb4914c8 = 0.88;
const $b67ebd3775cb0f71$export$1f25fc24307f93ac = 2.2;
const $b67ebd3775cb0f71$export$61d039e8338b360e = 260;
const $b67ebd3775cb0f71$export$51699b5802e21c52 = 520;
const $b67ebd3775cb0f71$export$40da588c31712df0 = 300;
const $b67ebd3775cb0f71$export$5dedcc161001eebd = 0.14;
const $b67ebd3775cb0f71$export$d71fc30b0fb49107 = 0.62;
const $b67ebd3775cb0f71$export$e39d66636c1cc1b8 = 0.07;
const $b67ebd3775cb0f71$export$78832952c59ee86 = 3200;
const $b67ebd3775cb0f71$export$921356573f9c65e9 = 170;
const $b67ebd3775cb0f71$export$42fd3fb39fa9e691 = 700;
const $b67ebd3775cb0f71$export$1755e49798589433 = 0.22;
const $b67ebd3775cb0f71$export$5c5ee632c52bc4a2 = (t)=>t < 0 ? 0 : t > 1 ? 1 : t;
const $b67ebd3775cb0f71$export$1157fb72e7fbceb5 = (t)=>1 - Math.pow(1 - $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(t), 3);
const $b67ebd3775cb0f71$export$b410709e4ad080bf = (t)=>$b67ebd3775cb0f71$export$5c5ee632c52bc4a2(t) >= 1 ? 1 : 1 - Math.pow(2, -10 * $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(t));
const $b67ebd3775cb0f71$export$3daa4a78f444687d = (t, overshoot = $b67ebd3775cb0f71$export$1f25fc24307f93ac)=>{
    const u = $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(t) - 1;
    return 1 + (overshoot + 1) * u * u * u + overshoot * u * u;
};
const $b67ebd3775cb0f71$export$4053e36566dd3d9a = (t)=>{
    const c = $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(t);
    return c * c * (3 - 2 * c);
};
const $b67ebd3775cb0f71$export$671c724dbdd0c3a9 = (from, to, t)=>{
    const k = $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(t);
    const fr = from >> 16 & 0xff;
    const fg = from >> 8 & 0xff;
    const fb = from & 0xff;
    const tr = to >> 16 & 0xff;
    const tg = to >> 8 & 0xff;
    const tb = to & 0xff;
    const r = Math.round(fr + (tr - fr) * k);
    const g = Math.round(fg + (tg - fg) * k);
    const b = Math.round(fb + (tb - fb) * k);
    return r << 16 | g << 8 | b;
};
const $b67ebd3775cb0f71$export$38205451e09fd057 = (cold, hot, settled, t)=>{
    const k = $b67ebd3775cb0f71$export$4053e36566dd3d9a(t);
    return k < 0.5 ? $b67ebd3775cb0f71$export$671c724dbdd0c3a9(cold, hot, k * 2) : $b67ebd3775cb0f71$export$671c724dbdd0c3a9(hot, settled, (k - 0.5) * 2);
};
const $b67ebd3775cb0f71$export$50c9d04991b8f25 = (index, elapsedMs)=>$b67ebd3775cb0f71$export$5c5ee632c52bc4a2((elapsedMs - index * $b67ebd3775cb0f71$export$5a345ca57ca838cd) / $b67ebd3775cb0f71$export$8b9e5c5d42c3f8db);
const $b67ebd3775cb0f71$export$41b48cf6ccdd6df9 = (index, elapsedMs, pulseElapsed)=>{
    const t = $b67ebd3775cb0f71$export$50c9d04991b8f25(index, elapsedMs);
    const eased = $b67ebd3775cb0f71$export$3daa4a78f444687d(t);
    // Peaks mid-entrance and is gone by the time the letter lands, leaving only the resting halo:
    // this is the "ignition" that travels across the word on the stagger.
    const flare = Math.pow(Math.sin(Math.PI * t), 1.5);
    const breath = 0.5 + 0.5 * Math.sin(2 * Math.PI * (elapsedMs - index * $b67ebd3775cb0f71$export$921356573f9c65e9) / $b67ebd3775cb0f71$export$78832952c59ee86);
    const pulse = pulseElapsed === undefined ? 0 : $b67ebd3775cb0f71$export$1755e49798589433 * Math.sin(Math.PI * $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(pulseElapsed / $b67ebd3775cb0f71$export$42fd3fb39fa9e691));
    return {
        y: $b67ebd3775cb0f71$export$4f9066f935d3d8b2 * (1 - eased),
        alpha: $b67ebd3775cb0f71$export$1157fb72e7fbceb5(t * 1.8),
        scale: $b67ebd3775cb0f71$export$2d357ab4bb4914c8 + (1 - $b67ebd3775cb0f71$export$2d357ab4bb4914c8) * eased,
        tintProgress: t,
        glowAlpha: t * ($b67ebd3775cb0f71$export$5dedcc161001eebd + $b67ebd3775cb0f71$export$e39d66636c1cc1b8 * breath + pulse) + ($b67ebd3775cb0f71$export$d71fc30b0fb49107 - $b67ebd3775cb0f71$export$5dedcc161001eebd) * flare
    };
};
const $b67ebd3775cb0f71$export$bcda309bcb37ce01 = (letterCount)=>(letterCount - 1) * $b67ebd3775cb0f71$export$5a345ca57ca838cd + $b67ebd3775cb0f71$export$40da588c31712df0;
const $b67ebd3775cb0f71$export$d50f73c555340634 = (elapsedMs, letterCount)=>$b67ebd3775cb0f71$export$5c5ee632c52bc4a2((elapsedMs - ((letterCount - 1) * $b67ebd3775cb0f71$export$5a345ca57ca838cd + $b67ebd3775cb0f71$export$61d039e8338b360e)) / $b67ebd3775cb0f71$export$51699b5802e21c52);
const $b67ebd3775cb0f71$export$dc0efc1f2335b611 = (letterCount)=>(letterCount - 1) * $b67ebd3775cb0f71$export$5a345ca57ca838cd + Math.max($b67ebd3775cb0f71$export$8b9e5c5d42c3f8db, $b67ebd3775cb0f71$export$61d039e8338b360e + $b67ebd3775cb0f71$export$51699b5802e21c52);
const $b67ebd3775cb0f71$export$72c543f3583477c9 = 300;
const $b67ebd3775cb0f71$export$1473eb097d4a7daa = 40;
const $b67ebd3775cb0f71$export$c22aae6103d2c509 = 1150;
const $b67ebd3775cb0f71$export$d0d389799615fe3 = 160;
const $b67ebd3775cb0f71$export$51c378971f8b4414 = 0.05;
const $b67ebd3775cb0f71$export$53a475970bc51c1e = 0.48;
const $b67ebd3775cb0f71$export$335cb5cd63576219 = 0.025;
const $b67ebd3775cb0f71$export$b8ab26910598ea42 = 280;
const $b67ebd3775cb0f71$export$da9a52190ee7fa47 = 190;
const $b67ebd3775cb0f71$export$24656b269d8df7d6 = (t)=>{
    const c = $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(t);
    return c < 0.5 ? 4 * c * c * c : 1 - Math.pow(-2 * c + 2, 3) / 2;
};
const $b67ebd3775cb0f71$export$846c9e38ae2ca3a8 = (index)=>$b67ebd3775cb0f71$export$72c543f3583477c9 + index * $b67ebd3775cb0f71$export$1473eb097d4a7daa + $b67ebd3775cb0f71$export$c22aae6103d2c509;
const $b67ebd3775cb0f71$export$fcba187da56a95ab = (index, elapsedMs)=>$b67ebd3775cb0f71$export$5c5ee632c52bc4a2((elapsedMs - $b67ebd3775cb0f71$export$72c543f3583477c9 - index * $b67ebd3775cb0f71$export$1473eb097d4a7daa) / $b67ebd3775cb0f71$export$c22aae6103d2c509);
const $b67ebd3775cb0f71$export$52abb4dad060b151 = (index, elapsedMs, pulseElapsed)=>{
    const m = $b67ebd3775cb0f71$export$fcba187da56a95ab(index, elapsedMs);
    const landed = elapsedMs - $b67ebd3775cb0f71$export$846c9e38ae2ca3a8(index);
    const bump = landed > 0 ? 1 + $b67ebd3775cb0f71$export$335cb5cd63576219 * Math.sin(Math.PI * $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(landed / $b67ebd3775cb0f71$export$b8ab26910598ea42)) : 1;
    const flare = Math.pow(Math.sin(Math.PI * m), 1.5);
    const breath = 0.5 + 0.5 * Math.sin(2 * Math.PI * (elapsedMs - index * $b67ebd3775cb0f71$export$921356573f9c65e9) / $b67ebd3775cb0f71$export$78832952c59ee86);
    const pulse = pulseElapsed === undefined ? 0 : $b67ebd3775cb0f71$export$1755e49798589433 * Math.sin(Math.PI * $b67ebd3775cb0f71$export$5c5ee632c52bc4a2(pulseElapsed / $b67ebd3775cb0f71$export$42fd3fb39fa9e691));
    const rest = $b67ebd3775cb0f71$export$5dedcc161001eebd + $b67ebd3775cb0f71$export$e39d66636c1cc1b8 * breath + pulse;
    const settled = $b67ebd3775cb0f71$export$4053e36566dd3d9a(m);
    return {
        travel: $b67ebd3775cb0f71$export$24656b269d8df7d6(m),
        bump: bump,
        tintProgress: m,
        glowAlpha: $b67ebd3775cb0f71$export$51c378971f8b4414 + (rest - $b67ebd3775cb0f71$export$51c378971f8b4414) * settled + $b67ebd3775cb0f71$export$53a475970bc51c1e * flare,
        shadow: settled
    };
};
const $b67ebd3775cb0f71$export$7f4663febf6cd075 = (letterCount)=>$b67ebd3775cb0f71$export$846c9e38ae2ca3a8(letterCount - 1) + $b67ebd3775cb0f71$export$d0d389799615fe3;
const $b67ebd3775cb0f71$export$6a93703217500dd9 = (elapsedMs, letterCount)=>$b67ebd3775cb0f71$export$5c5ee632c52bc4a2((elapsedMs - ($b67ebd3775cb0f71$export$846c9e38ae2ca3a8(letterCount - 1) - $b67ebd3775cb0f71$export$da9a52190ee7fa47)) / $b67ebd3775cb0f71$export$51699b5802e21c52);


const $2b3f66371c8d7b60$var$REVEAL_MS = 380;
const $2b3f66371c8d7b60$var$REVEAL_RISE = 10;
const $2b3f66371c8d7b60$export$fe411fe8f7d18b19 = (elapsed, delay, ms)=>Math.max(0, Math.min(1, (elapsed - delay) / Math.max(1, ms)));
class $2b3f66371c8d7b60$export$fe2b06ef7574cc0e extends (0, $gwPoJ.Graphics) {
    // Frame hook, only called while this page is the one on screen.
    animate(_dtMs) {
    //
    }
    tearDown() {
    //
    }
    /**
     * Ask for a piece to arrive with the page: after `delay` ms it rises into place and fades up. Only
     * takes effect when the host starts an entrance (opening the screen, or turning to this page); on
     * an in-place repaint the piece is simply drawn where it belongs.
     */ reveal(target, delay = 0, options = {}) {
        this.reveals.push({
            target: target,
            delay: delay,
            rise: options.rise ?? $2b3f66371c8d7b60$var$REVEAL_RISE,
            ms: options.ms ?? $2b3f66371c8d7b60$var$REVEAL_MS,
            scaleFrom: options.scaleFrom ?? 1,
            onFrame: options.onFrame,
            onLand: options.onLand,
            baseY: target.y,
            baseScaleX: target.scale.x,
            baseScaleY: target.scale.y,
            landed: false
        });
    }
    /** The page has just come on screen: play every reveal from the top. */ startEntrance() {
        this.revealClock = 0;
        this.applyReveals();
    }
    /** Land every piece now (an in-place repaint, or the player skipping ahead). */ finishEntrance() {
        if (this.revealClock === undefined) return;
        this.revealClock = Number.POSITIVE_INFINITY;
        this.applyReveals();
        this.revealClock = undefined;
    }
    get entering() {
        return this.revealClock !== undefined;
    }
    /** Advance the entrance; called by the host every frame, before `animate`. */ tickEntrance(dtMs) {
        if (this.revealClock === undefined) return;
        this.revealClock += dtMs;
        this.applyReveals();
        if (this.reveals.every((reveal)=>reveal.landed)) this.revealClock = undefined;
    }
    applyReveals() {
        const elapsed = this.revealClock ?? Number.POSITIVE_INFINITY;
        this.reveals.forEach((reveal)=>{
            const raw = $2b3f66371c8d7b60$export$fe411fe8f7d18b19(elapsed, reveal.delay, reveal.ms);
            const t = reveal.scaleFrom !== 1 ? (0, $b67ebd3775cb0f71$export$3daa4a78f444687d)(raw, 1.4) : (0, $b67ebd3775cb0f71$export$1157fb72e7fbceb5)(raw);
            const { target: target } = reveal;
            target.alpha = Math.min(1, (0, $b67ebd3775cb0f71$export$1157fb72e7fbceb5)(raw * 1.4));
            target.y = reveal.baseY + reveal.rise * (1 - t);
            if (reveal.scaleFrom !== 1) {
                const scale = reveal.scaleFrom + (1 - reveal.scaleFrom) * t;
                target.scale.set(reveal.baseScaleX * scale, reveal.baseScaleY * scale);
            }
            reveal.onFrame?.(t);
            if (raw >= 1 && !reveal.landed) {
                reveal.landed = true;
                reveal.onLand?.();
            }
        });
    }
    // Free the per-instance Text textures of the last draw before rebuilding (they are not GC'd).
    wipe() {
        this.reveals = [];
        this.revealClock = undefined;
        [
            ...this.children
        ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
        this.removeChildren();
    }
    constructor(...args){
        super(...args), // The entrance choreography: every piece the page asked to have revealed, and how far into the
        // reveal we are. `undefined` means no entrance is running -- the page was repainted in place
        // (a palette click) and everything simply sits where it was drawn.
        this.reveals = [];
    }
}


// Grid maths for the palette picker. Pure (no pixi), so the awkward cases -- a palette of two, a
// palette of seventy-six, a box too short for a single row -- are unit-tested rather than eyeballed.
const $e9b2f8e011d0ad84$export$2ad821b5ee3abcf6 = (spec)=>{
    const gapX = spec.gapX ?? 6;
    const gapY = spec.gapY ?? 6;
    const count = Math.max(0, spec.count);
    // Widest grid whose cells still clear minCellWidth.
    let cols = Math.max(1, Math.floor((spec.width + gapX) / (spec.minCellWidth + gapX)));
    // A short palette shouldn't be spread over more columns than it has entries.
    cols = Math.max(1, Math.min(cols, count || 1));
    let cellWidth = (spec.width - (cols - 1) * gapX) / cols;
    if (spec.maxCellWidth !== undefined) cellWidth = Math.min(cellWidth, spec.maxCellWidth);
    const rows = Math.max(1, Math.floor((spec.height + gapY) / (spec.cellHeight + gapY)));
    const perPage = cols * rows;
    const pages = Math.max(1, Math.ceil(count / perPage));
    const usedRows = Math.max(1, Math.min(rows, Math.ceil(count / cols)));
    return {
        cols: cols,
        rows: rows,
        usedRows: usedRows,
        cellWidth: cellWidth,
        perPage: perPage,
        pages: pages,
        height: usedRows * spec.cellHeight + (usedRows - 1) * gapY
    };
};
const $e9b2f8e011d0ad84$export$2660a47c412cb681 = (items, layout, page)=>{
    const safePage = Math.max(0, Math.min(page, layout.pages - 1));
    const start = safePage * layout.perPage;
    return items.slice(start, start + layout.perPage);
};
const $e9b2f8e011d0ad84$export$da4afb51d4f9da58 = (index, layout, cellHeight, gapX = 6, gapY = 6)=>({
        x: index % layout.cols * (layout.cellWidth + gapX),
        y: Math.floor(index / layout.cols) * (cellHeight + gapY)
    });


const $ee6ea042cf422424$export$dd27ce85ad53c944 = 0xf2a94e;
const $ee6ea042cf422424$export$640631a81002c59c = 0x6b4f38;
const $ee6ea042cf422424$export$4389bfa33b3049ea = 0x120d0a;
const $ee6ea042cf422424$export$35cf6b4f538836cd = 0x1b1512;
const $ee6ea042cf422424$export$50b2007dd9e18f6b = 0.92;
const $ee6ea042cf422424$export$47e6a71c2ae4bc1f = 0x2a201a;
const $ee6ea042cf422424$export$fc0b8fefbf3a9f6a = 0x3a2c21;
const $ee6ea042cf422424$export$4623f99f39ff0c85 = 0x54402e;
const $ee6ea042cf422424$export$d597759d33be802e = 0xfff3e0;
const $ee6ea042cf422424$export$2032e0ed6548abf9 = 0xb49b83;
const $ee6ea042cf422424$export$6b1a2b07ad04beea = 0xffd27a;
const $ee6ea042cf422424$export$64abe9059de17029 = 0x4a3113;
let $ee6ea042cf422424$export$35aa3e8070dd3c30 = 780;
const $ee6ea042cf422424$export$8a4e6245b38ca3f5 = 420;
const $ee6ea042cf422424$export$341c383d1f147954 = 34;
const $ee6ea042cf422424$export$7900c34204647a1b = 42;
const $ee6ea042cf422424$export$2c2fdba2e52ddfba = $ee6ea042cf422424$export$341c383d1f147954 + 10;
const $ee6ea042cf422424$export$343fef082e4bb475 = $ee6ea042cf422424$export$8a4e6245b38ca3f5 - $ee6ea042cf422424$export$7900c34204647a1b - $ee6ea042cf422424$export$2c2fdba2e52ddfba;
const $ee6ea042cf422424$export$7e244b51fe9b8780 = 8;
const $ee6ea042cf422424$export$d35e9f16aaee0022 = 176;
const $ee6ea042cf422424$export$de7d1b6c57f828f4 = 232;
let $ee6ea042cf422424$export$c212ee05c579f421 = $ee6ea042cf422424$export$35aa3e8070dd3c30 - $ee6ea042cf422424$export$d35e9f16aaee0022 - $ee6ea042cf422424$export$de7d1b6c57f828f4 - 2 * $ee6ea042cf422424$export$7e244b51fe9b8780;
const $ee6ea042cf422424$export$dcc2b41e4d83d427 = 0;
const $ee6ea042cf422424$export$f3a8244e0a259e49 = $ee6ea042cf422424$export$d35e9f16aaee0022 + $ee6ea042cf422424$export$7e244b51fe9b8780;
const $ee6ea042cf422424$export$1a7bb33882f2a323 = $ee6ea042cf422424$export$f3a8244e0a259e49 + $ee6ea042cf422424$export$de7d1b6c57f828f4 + $ee6ea042cf422424$export$7e244b51fe9b8780;
const $ee6ea042cf422424$export$7e50c07e514fc0dd = (width)=>{
    $ee6ea042cf422424$export$35aa3e8070dd3c30 = width;
    $ee6ea042cf422424$export$c212ee05c579f421 = $ee6ea042cf422424$export$35aa3e8070dd3c30 - $ee6ea042cf422424$export$d35e9f16aaee0022 - $ee6ea042cf422424$export$de7d1b6c57f828f4 - 2 * $ee6ea042cf422424$export$7e244b51fe9b8780;
};
const $ee6ea042cf422424$export$348bab8f5b4627be = {
    white: 0xf9d5ba,
    light: 0xfdd5b7,
    tan: 0xfdd082,
    olive: 0xd98e60,
    dark: 0xba8454,
    brown: 0xa86431,
    black: 0x61382d
};
const $ee6ea042cf422424$export$c597f79f1052724f = {
    white: 0xd8dcdc,
    blonde: 0xfccf56,
    gold: 0xe8c31a,
    green: 0x2f8f2f,
    blue: 0x2f7fcb,
    red: 0xe21414,
    orange: 0xe55600,
    purple: 0xa966dd,
    brown: 0x6d2f0d,
    lightbrown: 0xae682a,
    gray: 0xaaaaaa,
    black: 0x31313e
};
const $ee6ea042cf422424$export$7a6359c34632213c = {
    black: 0x4a5057,
    blue: 0x61a0ef,
    brown: 0x996b4a,
    gray: 0xa2a0a4,
    green: 0x64a42c,
    maroon: 0xae424a,
    orange: 0xef7e19,
    purple: 0x813089,
    red: 0xcd2429,
    tan: 0xb78c41,
    teal: 0x00cfdf,
    white: 0xe5e6c7,
    yellow: 0xf3c03f,
    gold: 0xe0b23c,
    metal: 0xc9ccd6,
    silver: 0xd9dde3,
    olive: 0x6b6b32,
    lightbrown: 0x9b6b3a,
    lightgreen: 0x8ed07a,
    light: 0xe8e0d0,
    dark: 0x3b3b44,
    pink: 0xe89bbd,
    blonde: 0xe7c98a,
    na: 0x808080
};
const $ee6ea042cf422424$var$FAMILY_MAP = {
    skin: $ee6ea042cf422424$export$348bab8f5b4627be,
    hair: $ee6ea042cf422424$export$c597f79f1052724f,
    cloth: $ee6ea042cf422424$export$7a6359c34632213c
};
const $ee6ea042cf422424$export$ff0eb67b170646b7 = (family, color)=>$ee6ea042cf422424$var$FAMILY_MAP[family][color] ?? $ee6ea042cf422424$export$7a6359c34632213c[color] ?? 0x808080;
// Hand-written names for the values whose raw ids are either unreadable or far too long for a chip.
const $ee6ea042cf422424$var$NICE_NAMES = {
    none: "None",
    "pants-armor": "Armored",
    "shoes-armor": "Armored",
    skirts: "Skirt",
    scoop_shirt: "Scoop Neck",
    blouse_longsleeve: "Long Blouse",
    longsleeve_laced: "Laced",
    sleeveless_laced: "Laced Vest",
    sleeveless_striped: "Striped",
    bob_side_part: "Side Bob",
    curly_long: "Long Curls",
    curly_short: "Short Curls",
    curtains_long: "Long Curtains",
    dreadlocks_long: "Long Dreads",
    dreadlocks_short: "Dreads",
    flat_top_fade: "Flat Fade",
    flat_top_straight: "Flat Top",
    high_and_tight: "High & Tight",
    high_ponytail: "High Tail",
    long_center_part: "Center Part",
    long_messy: "Messy Long",
    long_messy2: "Messy Long 2",
    spiked_beehive: "Beehive",
    spiked_liberty: "Liberty",
    spiked_liberty2: "Liberty 2",
    spiked_porcupine: "Porcupine",
    twists_straight: "Twists",
    twists_fade: "Twist Fade",
    lightbrown: "Light Brown",
    lightgreen: "Light Green",
    half_up: "Half Up",
    bangs_bun: "Bangs Bun"
};
const $ee6ea042cf422424$export$9e764535c6c076b3 = (value)=>{
    if (!value) return "None";
    const nice = $ee6ea042cf422424$var$NICE_NAMES[value];
    if (nice) return nice;
    return value.split(/[-_]/).map((word)=>word.replace(/(\d+)$/, " $1")).map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};






const $e8dc6d9c289fb887$export$c53d0f541b41b88e = "none";
const $e8dc6d9c289fb887$export$5b887099a2508732 = [
    "sex",
    "skin",
    "hair",
    "shirt",
    "pants",
    "shoes"
];
const $e8dc6d9c289fb887$var$TRAIT_META = {
    sex: {
        label: "Build",
        icon: "figure"
    },
    skin: {
        label: "Skin",
        icon: "hand"
    },
    hair: {
        label: "Hair",
        icon: "hair"
    },
    shirt: {
        label: "Shirt",
        icon: "tunic"
    },
    pants: {
        label: "Legs",
        icon: "trousers"
    },
    shoes: {
        label: "Feet",
        icon: "boot"
    }
};
const $e8dc6d9c289fb887$var$GARMENT_CLASS = {
    shirt: "shirt",
    pants: "pants",
    shoes: "shoes"
};
// Colours a given garment type can be painted.
const $e8dc6d9c289fb887$var$garmentColors = (itemClass, type)=>{
    if (!type || type === $e8dc6d9c289fb887$export$c53d0f541b41b88e) return [];
    if (itemClass === "shirt") {
        const colors = (0, $bf6244e5cc9aa116$export$b4dd93b72d5ba14d)[type] || [];
        // The forge's generated human bodies can dye a plain longsleeve grey even though the
        // legacy male LPC sheet has no grey variant.
        return type === "longsleeve" ? Array.from(new Set([
            ...colors,
            "gray"
        ])) : colors;
    }
    if (itemClass === "pants") return (0, $bf6244e5cc9aa116$export$7ef85edc405cda8b)[type] || [];
    if (itemClass === "shoes") return (0, $bf6244e5cc9aa116$export$d9113a8608ba3a3c)[type] || [];
    return [];
};
// Types a garment can be, for this character's sex. Shirts and shoes may be left off; trousers of
// some kind are not optional.
const $e8dc6d9c289fb887$var$garmentTypes = (itemClass, sex)=>{
    if (itemClass === "shirt") return [
        ...(0, $bf6244e5cc9aa116$export$6e1561754c81021d)[sex],
        $e8dc6d9c289fb887$export$c53d0f541b41b88e
    ];
    if (itemClass === "pants") return [
        ...(0, $bf6244e5cc9aa116$export$a82a1c1a9f3bc6b3)[sex]
    ];
    if (itemClass === "shoes") return [
        ...(0, $bf6244e5cc9aa116$export$14c4cc2ba117f70c)[sex],
        $e8dc6d9c289fb887$export$c53d0f541b41b88e
    ];
    return [];
};
const $e8dc6d9c289fb887$var$styleSection = (title, values, selected)=>({
        kind: "style",
        title: title,
        options: values.map((value)=>({
                value: value,
                label: (0, $ee6ea042cf422424$export$9e764535c6c076b3)(value)
            })),
        selected: selected || $e8dc6d9c289fb887$export$c53d0f541b41b88e
    });
const $e8dc6d9c289fb887$var$colorSection = (title, family, values, selected)=>({
        kind: "color",
        title: title,
        options: values.map((value)=>({
                value: value,
                label: (0, $ee6ea042cf422424$export$9e764535c6c076b3)(value),
                swatch: (0, $ee6ea042cf422424$export$ff0eb67b170646b7)(family, value)
            })),
        selected: selected || ""
    });
const $e8dc6d9c289fb887$export$4cb82e77282accdd = (entity, id)=>{
    const { label: label, icon: icon } = $e8dc6d9c289fb887$var$TRAIT_META[id];
    const appearance = entity.appearance;
    const sex = appearance.sex;
    const race = appearance.race;
    const view = (summary, sections, swatch)=>({
            id: id,
            label: label,
            icon: icon,
            summary: summary,
            swatch: swatch,
            sections: sections
        });
    if (id === "sex") return view((0, $ee6ea042cf422424$export$9e764535c6c076b3)(sex), [
        $e8dc6d9c289fb887$var$styleSection("Build", [
            ...(0, $bf6244e5cc9aa116$export$32cdec3d782e201f)
        ], sex)
    ]);
    if (id === "skin") {
        const colors = (0, $bf6244e5cc9aa116$export$af1b56af8a451d06)[race] || [];
        return view((0, $ee6ea042cf422424$export$9e764535c6c076b3)(appearance.bodyColor), [
            $e8dc6d9c289fb887$var$colorSection("Skin tone", "skin", colors, appearance.bodyColor)
        ], (0, $ee6ea042cf422424$export$ff0eb67b170646b7)("skin", appearance.bodyColor));
    }
    if (id === "hair") {
        const styles = [
            $e8dc6d9c289fb887$export$c53d0f541b41b88e,
            ...(0, $bf6244e5cc9aa116$export$46ee3469290462e6)[sex]
        ];
        const sections = [
            $e8dc6d9c289fb887$var$styleSection("Style", styles, appearance.hair || $e8dc6d9c289fb887$export$c53d0f541b41b88e)
        ];
        if (appearance.hair) sections.push($e8dc6d9c289fb887$var$colorSection("Colour", "hair", (0, $bf6244e5cc9aa116$export$c2ef2c5bddebe408)[appearance.hair], appearance.hairColor));
        return view((0, $ee6ea042cf422424$export$9e764535c6c076b3)(appearance.hair || $e8dc6d9c289fb887$export$c53d0f541b41b88e), sections, appearance.hair ? (0, $ee6ea042cf422424$export$ff0eb67b170646b7)("hair", appearance.hairColor) : undefined);
    }
    // shirt / pants / shoes
    const itemClass = $e8dc6d9c289fb887$var$GARMENT_CLASS[id];
    const worn = (0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, itemClass);
    const type = worn?.type;
    const sections = [
        $e8dc6d9c289fb887$var$styleSection("Cut", $e8dc6d9c289fb887$var$garmentTypes(itemClass, sex), type || $e8dc6d9c289fb887$export$c53d0f541b41b88e)
    ];
    const colors = $e8dc6d9c289fb887$var$garmentColors(itemClass, type);
    if (colors.length > 0) sections.push($e8dc6d9c289fb887$var$colorSection("Colour", "cloth", colors, worn?.color));
    return view((0, $ee6ea042cf422424$export$9e764535c6c076b3)(type || $e8dc6d9c289fb887$export$c53d0f541b41b88e), sections, worn?.color ? (0, $ee6ea042cf422424$export$ff0eb67b170646b7)("cloth", worn.color) : undefined);
};
const $e8dc6d9c289fb887$export$d0a4aaa8f938be7a = (entity)=>$e8dc6d9c289fb887$export$5b887099a2508732.map((id)=>$e8dc6d9c289fb887$export$4cb82e77282accdd(entity, id));
// Swap what the character wears in one slot. Removing first keeps a single active item per class,
// and both helpers refresh the inventory-appearance hash the server reads.
const $e8dc6d9c289fb887$var$equip = (entity, itemClass, type, preferredColor)=>{
    const existing = (0, $f684496fff50a7a1$export$ff6824850c0111da)(entity.inventory, itemClass);
    if (existing) (0, $f684496fff50a7a1$export$6d9780a2b50e0c6e)(entity, existing.id);
    if (!type || type === $e8dc6d9c289fb887$export$c53d0f541b41b88e) return;
    const colors = $e8dc6d9c289fb887$var$garmentColors(itemClass, type);
    const color = preferredColor && colors.includes(preferredColor) ? preferredColor : colors[0];
    const itemTypeMeta = {
        type: type,
        class: itemClass,
        color: color
    };
    (0, $f684496fff50a7a1$export$73ce97a5e6b0458a)(entity, {
        id: (0, $a80d0b17b615d6f7$export$5e699d18035b41af)(),
        itemType: "none",
        itemTypeMeta: itemTypeMeta,
        quantity: 1,
        active: true
    });
};
const $e8dc6d9c289fb887$export$f90ea17b26c746f3 = (entity)=>{
    const appearance = entity.appearance;
    const sex = appearance.sex;
    if (appearance.hair && !(0, $bf6244e5cc9aa116$export$46ee3469290462e6)[sex].includes(appearance.hair)) appearance.hair = (0, $bf6244e5cc9aa116$export$46ee3469290462e6)[sex][0];
    [
        "shirt",
        "pants",
        "shoes"
    ].forEach((itemClass)=>{
        const worn = (0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, itemClass);
        const allowed = $e8dc6d9c289fb887$var$garmentTypes(itemClass, sex);
        if (!worn) {
            // Trousers are the one slot nobody goes without.
            if (itemClass === "pants") $e8dc6d9c289fb887$var$equip(entity, itemClass, allowed[0]);
            return;
        }
        if (!allowed.includes(worn.type)) $e8dc6d9c289fb887$var$equip(entity, itemClass, allowed[0], worn.color);
    });
};
const $e8dc6d9c289fb887$export$5ca4f74dfb7adac4 = (entity, id, kind, value)=>{
    const appearance = entity.appearance;
    if (id === "sex") {
        appearance.sex = value;
        $e8dc6d9c289fb887$export$f90ea17b26c746f3(entity);
        return;
    }
    if (id === "skin") {
        appearance.bodyColor = value;
        // The nose is a separate sheet tinted to match the body; left alone it floats as a different
        // colour patch on the face.
        appearance.noseColor = value;
        return;
    }
    if (id === "hair") {
        if (kind === "color") {
            appearance.hairColor = value;
            return;
        }
        if (value === $e8dc6d9c289fb887$export$c53d0f541b41b88e) {
            appearance.hair = undefined;
            return;
        }
        appearance.hair = value;
        const colors = (0, $bf6244e5cc9aa116$export$c2ef2c5bddebe408)[appearance.hair];
        if (!colors?.includes(appearance.hairColor)) appearance.hairColor = colors?.[0];
        return;
    }
    const itemClass = $e8dc6d9c289fb887$var$GARMENT_CLASS[id];
    const worn = (0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, itemClass);
    if (kind === "color") {
        $e8dc6d9c289fb887$var$equip(entity, itemClass, worn?.type, value);
        return;
    }
    $e8dc6d9c289fb887$var$equip(entity, itemClass, value, worn?.color);
};


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");


// Turning the character on the forge's stage. The figure stands on a turntable: drag anywhere on the
// stage and it turns with the pointer (the near side follows it, as a model on a stand would), or
// step it one view at a time with the buttons either side of its feet. A ring on the floor marks
// which way it faces, with a notch for every view its body draws -- eight for an Ember body, four
// for an LPC paperdoll.
const $6a245c5bef01ef6b$var$TAU = Math.PI * 2;
const $6a245c5bef01ef6b$export$8b51e904ef651c58 = 240;
/** How quickly the ring's marker catches up with the figure. */ const $6a245c5bef01ef6b$var$GLIDE_MS = 60;
/** How quickly the ring brightens under the pointer, and fades again. */ const $6a245c5bef01ef6b$var$EMPHASIS_MS = 140;
const $6a245c5bef01ef6b$export$c0a4330cd9ea2e5b = (angle)=>(angle % $6a245c5bef01ef6b$var$TAU + $6a245c5bef01ef6b$var$TAU) % $6a245c5bef01ef6b$var$TAU;
const $6a245c5bef01ef6b$var$shortestTurn = (from, to)=>{
    const delta = $6a245c5bef01ef6b$export$c0a4330cd9ea2e5b(to - from);
    return delta > Math.PI ? delta - $6a245c5bef01ef6b$var$TAU : delta;
};
const $6a245c5bef01ef6b$var$unitVector = (x, y)=>{
    const length = Math.hypot(x, y) || 1;
    return {
        x: x / length,
        y: y / length
    };
};
const $6a245c5bef01ef6b$export$377257a583f4b706 = (calcDir)=>{
    if (!calcDir) return 4;
    const facings = new Set();
    for(let k = 0; k < 8; k++)facings.add(calcDir(k * $6a245c5bef01ef6b$var$TAU / 8));
    return facings.size >= 8 ? 8 : 4;
};
const $6a245c5bef01ef6b$export$511cb9625de9f255 = (angle, views)=>{
    const unit = $6a245c5bef01ef6b$var$TAU / views;
    return $6a245c5bef01ef6b$export$c0a4330cd9ea2e5b(Math.round(angle / unit) * unit);
};
const $6a245c5bef01ef6b$export$fadc24ced26f5ace = (angle, views, direction)=>$6a245c5bef01ef6b$export$511cb9625de9f255($6a245c5bef01ef6b$export$511cb9625de9f255(angle, views) - direction * $6a245c5bef01ef6b$var$TAU / views, views);
const $6a245c5bef01ef6b$export$9b4d7f9e60d638d1 = (startAngle, dx)=>$6a245c5bef01ef6b$export$c0a4330cd9ea2e5b(startAngle - dx * $6a245c5bef01ef6b$var$TAU / $6a245c5bef01ef6b$export$8b51e904ef651c58);
class $6a245c5bef01ef6b$export$190425a47868a42 {
    constructor(layout, angle, onTurn){
        this.layout = layout;
        this.onTurn = onTurn;
        this./** How many views the body on the stand draws. */ views = 4;
        this./** The player has turned the figure, so the hint inviting them to has done its job. */ turned = false;
        this.ring = new (0, $gwPoJ.Graphics)();
        this.emphasis = 0;
        this.hovered = false;
        this.drawnKey = "";
        this./** One view round; see turnedBy. */ turn = (direction)=>{
            this.drag = undefined;
            this.face($6a245c5bef01ef6b$export$fadc24ced26f5ace(this.angle, this.views, direction));
        };
        this./** Let go: the figure settles on the view it is showing. */ endDrag = ()=>{
            if (!this.drag) return;
            this.drag = undefined;
            this.face($6a245c5bef01ef6b$export$511cb9625de9f255(this.angle, this.views));
        };
        this./** The catcher is about to be thrown away, and pixi never tells a removed object the pointer left. */ detach = ()=>{
            this.endDrag();
            this.hovered = false;
        };
        this.angle = $6a245c5bef01ef6b$export$c0a4330cd9ea2e5b(angle);
        this.shown = this.angle;
        this.draw();
    }
    get dragging() {
        return !!this.drag;
    }
    /**
     * The stage's drag catcher for this repaint: transparent, over the figure and under the buttons.
     * The drag itself lives here rather than on the catcher, which is thrown away by every repaint.
     */ surface(area) {
        const surface = new (0, $8t5Gy.Container)();
        surface.hitArea = area;
        surface.interactive = true;
        surface.cursor = this.drag ? "grabbing" : "grab";
        surface.on("pointerover", ()=>this.hovered = true);
        surface.on("pointerout", ()=>this.hovered = false);
        surface.on("pointerdown", (event)=>{
            event?.stopPropagation?.();
            const { data: data } = event;
            if (data.pointerType !== "touch" && (data.button ?? 0) > 0) return;
            this.drag = {
                pointerId: data.pointerId,
                startX: data.getLocalPosition(surface).x,
                startAngle: this.angle
            };
            surface.cursor = "grabbing";
        });
        // pixi hands pointermove to every interactive object, hit or not, so the drag keeps its moves
        // when the pointer strays off the stage.
        surface.on("pointermove", (event)=>{
            const drag = this.drag;
            if (!drag || event.data.pointerId !== drag.pointerId) return;
            this.face($6a245c5bef01ef6b$export$9b4d7f9e60d638d1(drag.startAngle, event.data.getLocalPosition(surface).x - drag.startX));
        });
        const release = (event)=>{
            if (!this.drag || event?.data?.pointerId !== this.drag.pointerId) return;
            this.endDrag();
            surface.cursor = "grab";
        };
        for (const name of [
            "pointerup",
            "pointerupoutside",
            "pointercancel"
        ])surface.on(name, release);
        return surface;
    }
    update(dtMs) {
        const gap = $6a245c5bef01ef6b$var$shortestTurn(this.shown, this.angle);
        this.shown = Math.abs(gap) < 0.002 ? this.angle : $6a245c5bef01ef6b$export$c0a4330cd9ea2e5b(this.shown + gap * (1 - Math.exp(-dtMs / $6a245c5bef01ef6b$var$GLIDE_MS)));
        const target = this.drag ? 1 : this.hovered ? 0.55 : 0;
        const step = dtMs / $6a245c5bef01ef6b$var$EMPHASIS_MS;
        this.emphasis = this.emphasis < target ? Math.min(target, this.emphasis + step) : Math.max(target, this.emphasis - step);
        this.draw();
    }
    face(angle) {
        if ($6a245c5bef01ef6b$export$511cb9625de9f255(angle, this.views) !== $6a245c5bef01ef6b$export$511cb9625de9f255(this.angle, this.views)) this.turned = true;
        this.angle = angle;
        this.onTurn(angle);
    }
    draw() {
        const key = `${this.shown.toFixed(3)}|${this.emphasis.toFixed(2)}|${this.views}`;
        if (key === this.drawnKey) return;
        this.drawnKey = key;
        const { x: x, y: y, rx: rx, ry: ry } = this.layout;
        const e = this.emphasis;
        const g = this.ring;
        g.clear();
        const point = (a, reach = 1)=>({
                x: x + rx * reach * Math.cos(a),
                y: y + ry * reach * Math.sin(a)
            });
        // One path per stroke: overlapping segments at a lower alpha would leave bright seams.
        const arc = (from, to)=>{
            const steps = Math.max(4, Math.ceil(Math.abs(to - from) / 0.1));
            for(let i = 0; i <= steps; i++){
                const p = point(from + (to - from) * i / steps);
                if (i === 0) g.moveTo(p.x, p.y);
                else g.lineTo(p.x, p.y);
            }
        };
        // The rim of the stand. Its near half is the brighter, so it reads as lying on the floor; the
        // far half runs behind the figure's legs.
        g.lineStyle(1, (0, $ee6ea042cf422424$export$dd27ce85ad53c944), 0.22 + 0.3 * e);
        arc(0, Math.PI);
        g.lineStyle(1, (0, $ee6ea042cf422424$export$dd27ce85ad53c944), 0.1 + 0.18 * e);
        arc(Math.PI, $6a245c5bef01ef6b$var$TAU);
        g.lineStyle(0);
        // A notch for every view the body has, so it is plain there is more to see than this one.
        for(let i = 0; i < this.views; i++){
            const a = i * $6a245c5bef01ef6b$var$TAU / this.views;
            const p = point(a);
            g.beginFill((0, $ee6ea042cf422424$export$dd27ce85ad53c944), (Math.sin(a) < -0.01 ? 0.3 : 0.55) + 0.35 * e);
            g.drawCircle(p.x, p.y, 1.7);
            g.endFill();
        }
        // The way the figure faces: a lit stretch of rim with a point off its middle. The point is a
        // fixed size off the rim's edge, so it neither shrinks to nothing at the front nor reaches
        // into the buttons at the sides.
        const a = this.shown;
        const half = 0.3;
        g.lineStyle(6, (0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 0.1 + 0.12 * e);
        arc(a - half, a + half);
        g.lineStyle(2, (0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 0.9);
        arc(a - half, a + half);
        g.lineStyle(0);
        const p = point(a);
        const n = $6a245c5bef01ef6b$var$unitVector(Math.cos(a) / rx, Math.sin(a) / ry);
        const t = $6a245c5bef01ef6b$var$unitVector(-Math.sin(a) * rx, Math.cos(a) * ry);
        g.beginFill((0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 0.95);
        g.drawPolygon([
            p.x + n.x * 7,
            p.y + n.y * 7,
            p.x + n.x + t.x * 3.2,
            p.y + n.y + t.y * 3.2,
            p.x + n.x - t.x * 3.2,
            p.y + n.y - t.y * 3.2
        ]);
        g.endFill();
    }
}
/**
 * The glyph on a turn button: a turntable's rim seen from in front, flattened into an ellipse, swept
 * almost all the way round in the direction the button turns it. The sweep ends at the near side, so
 * its head points the way the button is named for. Centred on (0, 0).
 */ const $6a245c5bef01ef6b$var$turnGlyph = (direction)=>{
    const g = new (0, $gwPoJ.Graphics)();
    const rx = 7.5;
    const ry = 3.8;
    // a = 90 degrees is the near side. Turning right carries the near side rightward, which is the
    // way of decreasing a: round the back from the front-right, ending just past the front.
    const at = (a)=>({
            x: direction * rx * Math.cos(a),
            y: ry * Math.sin(a)
        });
    const from = 395 * Math.PI / 180;
    const to = 72 * Math.PI / 180;
    const steps = 28;
    g.lineStyle(1.7, (0, $ee6ea042cf422424$export$d597759d33be802e), 0.92);
    for(let i = 0; i <= steps; i++){
        const p = at(from + (to - from) * i / steps);
        if (i === 0) g.moveTo(p.x, p.y);
        else g.lineTo(p.x, p.y);
    }
    g.lineStyle(0);
    // The head points along the way the sweep is travelling at its end.
    const end = at(to);
    const before = at(to + 0.05);
    const t = $6a245c5bef01ef6b$var$unitVector(end.x - before.x, end.y - before.y);
    g.beginFill((0, $ee6ea042cf422424$export$d597759d33be802e), 0.95);
    g.drawPolygon([
        end.x + t.x * 3.4,
        end.y + t.y * 3.4,
        end.x - t.x * 1.2 - t.y * 2.9,
        end.y - t.y * 1.2 + t.x * 2.9,
        end.x - t.x * 1.2 + t.y * 2.9,
        end.y - t.y * 1.2 - t.x * 2.9
    ]);
    g.endFill();
    return g;
};
const $6a245c5bef01ef6b$export$36f0674b7d8f8503 = (direction, cx, cy, onTurn)=>{
    const button = (0, $83d1a97b87afddc2$export$48c67489f19ab119)({
        icon: "",
        theme: "ember",
        size: "small",
        shape: "circle",
        appearance: "outline",
        onClick: ()=>onTurn(direction)
    });
    button.name = direction > 0 ? "turn-right" : "turn-left";
    const glyph = $6a245c5bef01ef6b$var$turnGlyph(direction);
    button.addChild(glyph);
    // The button sizes itself when it is added (larger on a touch screen), so it is centred then.
    button.on("added", ()=>{
        const { width: width, height: height } = button.getBoxSize();
        button.position.set(Math.round(cx - width / 2), Math.round(cy - height / 2));
        glyph.position.set(width / 2, height / 2);
    });
    return button;
};


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");



const $b0310457bd8276cc$var$raf = (fn)=>typeof requestAnimationFrame === "function" ? requestAnimationFrame(fn) : undefined;
const $b0310457bd8276cc$export$dc0b63720788090c = (ms, apply, { delay: delay = 0, ease: ease = (0, $b67ebd3775cb0f71$export$1157fb72e7fbceb5), onDone: onDone } = {})=>{
    const startedAt = Date.now() + delay;
    let cancelled = false;
    let finished = false;
    const finish = ()=>{
        if (finished) return;
        finished = true;
        apply(1, 1);
        onDone?.();
    };
    const frame = ()=>{
        if (cancelled || finished) return;
        const raw = ms <= 0 ? 1 : (Date.now() - startedAt) / ms;
        if (raw >= 1) {
            finish();
            return;
        }
        apply(ease(Math.max(0, raw)), Math.max(0, raw));
        $b0310457bd8276cc$var$raf(frame);
    };
    apply(0, 0);
    if ($b0310457bd8276cc$var$raf(frame) === undefined) finish();
    return {
        cancel: ()=>{
            cancelled = true;
        }
    };
};








const $e0fb6921b9eca6b1$export$6f093cfa640b7166 = (value, { role: role = "compactLabel", color: color = (0, $ee6ea042cf422424$export$d597759d33be802e), bold: bold = false, wrap: wrap, display: display = false, weight: weight, size: size } = {})=>{
    // No black outline. Every label on this screen sits on a flat panel or chip, so the stroke buys
    // nothing -- and on the light fills (a primary pill, a selected chip, a numbered badge) it wraps
    // the dark ink in a halo of its own colour, which smears small bold type into a blur.
    const renderer = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(color).role(role).bold(bold).strokeThickness(0);
    if (display) renderer.fontFamily((0, $ef882f0a643d87d9$export$51d6375781d583cb));
    if (size !== undefined) renderer.fontSize(size);
    if (wrap !== undefined) // Set at build time: poking style.wordWrap afterwards re-rasterizes the Text.
    renderer.wordWrap(wrap);
    const label = renderer.render(value);
    if (weight) // Before anything reads .width: a weight change re-rasterizes, and weights differ in advance.
    label.style.fontWeight = weight;
    return label;
};
const $e0fb6921b9eca6b1$export$ae58fbe30126ec19 = (value, options = {})=>$e0fb6921b9eca6b1$export$6f093cfa640b7166((0, $ef882f0a643d87d9$export$dfb0a212724b9d91)(value.toUpperCase()), {
        display: true,
        weight: "500",
        ...options
    });
const $e0fb6921b9eca6b1$export$6bfce7f06513f30a = (g, cx, y, halfWidth, color = (0, $ee6ea042cf422424$export$dd27ce85ad53c944), alpha = 1)=>{
    const lens = (half)=>{
        g.moveTo(cx - halfWidth, y);
        g.quadraticCurveTo(cx, y - half * 2, cx + halfWidth, y);
        g.quadraticCurveTo(cx, y + half * 2, cx - halfWidth, y);
        g.closePath();
    };
    g.beginFill(color, 0.14 * alpha);
    lens(3);
    g.endFill();
    g.beginFill((0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 0.85 * alpha);
    lens(0.9);
    g.endFill();
};
/**
 * Hover that EASES rather than snaps: a 0..1 amount that glides toward the pointer's state and
 * repaints as it goes, so sweeping across a palette reads as the chips answering rather than
 * flickering between two pictures.
 */ const $e0fb6921b9eca6b1$var$HOVER_MS = 120;
class $e0fb6921b9eca6b1$var$HoverEase {
    constructor(repaint){
        this.repaint = repaint;
        this.value = 0;
        this.set = (hovered)=>{
            this.motion?.cancel();
            const from = this.value;
            const to = hovered ? 1 : 0;
            this.motion = (0, $b0310457bd8276cc$export$dc0b63720788090c)($e0fb6921b9eca6b1$var$HOVER_MS * Math.abs(to - from), (t)=>{
                this.value = from + (to - from) * t;
                this.repaint();
            });
        };
        this.stop = ()=>this.motion?.cancel();
    }
}
const $e0fb6921b9eca6b1$export$b94583dc679500d = (label, maxWidth, minScale = 0.78)=>{
    if (label.width <= maxWidth || label.width === 0) return;
    const scale = Math.max(minScale, maxWidth / label.width);
    label.scale.set(scale);
    if (label.width <= maxWidth) return;
    const source = label.text;
    for(let cut = source.length - 1; cut > 1; cut--){
        label.text = `${source.slice(0, cut).trimEnd()}\u{2026}`;
        if (label.width <= maxWidth) return;
    }
};
const $e0fb6921b9eca6b1$export$7fbfc7da7d3c2e5e = (label, boxX, boxWidth, y)=>{
    label.x = Math.round(boxX + (boxWidth - label.width) / 2);
    label.y = Math.round(y);
};
const $e0fb6921b9eca6b1$export$3cd4174479c25cc8 = (g, x, y, w, h, { radius: radius = 10, rim: rim = (0, $ee6ea042cf422424$export$640631a81002c59c), rimAlpha: rimAlpha = 0.75, glow: glow = true, fill: fill = (0, $ee6ea042cf422424$export$35cf6b4f538836cd), fillAlpha: fillAlpha = (0, $ee6ea042cf422424$export$50b2007dd9e18f6b) } = {})=>{
    if (glow) {
        g.beginFill((0, $ee6ea042cf422424$export$dd27ce85ad53c944), 0.05);
        g.drawRoundedRect(x - 4, y - 4, w + 8, h + 8, radius + 4);
        g.endFill();
    }
    g.lineStyle(1.5, rim, rimAlpha);
    g.beginFill(fill, fillAlpha);
    g.drawRoundedRect(x, y, w, h, radius);
    g.endFill();
    g.lineStyle(0);
    // Light catching the top lip, inset past the corners: glass with an edge, not a flat cut-out.
    g.beginFill((0, $ee6ea042cf422424$export$d597759d33be802e), 0.07);
    g.drawRect(x + radius, y + 1.5, w - radius * 2, 1);
    g.endFill();
};
const $e0fb6921b9eca6b1$export$300ac6f106ef584d = (title, width)=>{
    const container = new (0, $8t5Gy.Container)();
    const label = $e0fb6921b9eca6b1$export$6f093cfa640b7166(title.toUpperCase(), {
        role: "compactCaption",
        color: (0, $ee6ea042cf422424$export$6b1a2b07ad04beea),
        bold: true
    });
    label.alpha = 0.9;
    container.addChild(label);
    const rule = new (0, $gwPoJ.Graphics)();
    rule.beginFill((0, $ee6ea042cf422424$export$640631a81002c59c), 0.5);
    rule.drawRect(label.width + 8, Math.round(label.height / 2), Math.max(0, width - label.width - 8), 1);
    rule.endFill();
    container.addChild(rule);
    return container;
};
class $e0fb6921b9eca6b1$export$f1b71a6df9b30e88 extends (0, $8t5Gy.Container) {
    constructor(label, props){
        super(), this.hover = new $e0fb6921b9eca6b1$var$HoverEase(()=>this.draw());
        this.props = props;
        this.bg = new (0, $gwPoJ.Graphics)();
        this.addChild(this.bg);
        const caption = $e0fb6921b9eca6b1$export$6f093cfa640b7166(label, {
            role: "compactCaption",
            color: props.selected ? 0x2a1c0c : (0, $ee6ea042cf422424$export$d597759d33be802e)
        });
        $e0fb6921b9eca6b1$export$b94583dc679500d(caption, props.width - 12);
        $e0fb6921b9eca6b1$export$7fbfc7da7d3c2e5e(caption, 0, props.width, (props.height - caption.height) / 2);
        this.addChild(caption);
        this.interactive = true;
        this.cursor = "pointer";
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, props.width, props.height);
        this.on("pointerover", ()=>this.hover.set(true));
        this.on("pointerout", ()=>this.hover.set(false));
        this.on("removed", this.hover.stop);
        this.on("pointerdown", (event)=>{
            event?.stopPropagation?.();
            props.onClick();
        });
        this.draw();
    }
    draw() {
        const { width: width, height: height, selected: selected } = this.props;
        const h = this.hover.value;
        const g = this.bg;
        g.clear();
        if (selected) {
            g.beginFill((0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 0.18);
            g.drawRoundedRect(-3, -3, width + 6, height + 6, 9);
            g.endFill();
            g.lineStyle(1.5, (0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 1);
            g.beginFill((0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 0.92);
        } else {
            if (h > 0) {
                g.beginFill((0, $ee6ea042cf422424$export$dd27ce85ad53c944), 0.12 * h);
                g.drawRoundedRect(-3, -3, width + 6, height + 6, 9);
                g.endFill();
            }
            g.lineStyle(1, (0, $b67ebd3775cb0f71$export$671c724dbdd0c3a9)((0, $ee6ea042cf422424$export$4623f99f39ff0c85), (0, $ee6ea042cf422424$export$dd27ce85ad53c944), h), 0.6 + 0.3 * h);
            g.beginFill((0, $b67ebd3775cb0f71$export$671c724dbdd0c3a9)((0, $ee6ea042cf422424$export$47e6a71c2ae4bc1f), (0, $ee6ea042cf422424$export$fc0b8fefbf3a9f6a), h), 0.95);
        }
        g.drawRoundedRect(0, 0, width, height, 6);
        g.endFill();
        g.lineStyle(0);
    }
}
class $e0fb6921b9eca6b1$export$43e54f70144d08dc extends (0, $8t5Gy.Container) {
    constructor(color, props){
        super(), this.hover = new $e0fb6921b9eca6b1$var$HoverEase(()=>this.draw());
        this.props = {
            ...props,
            color: color
        };
        this.bg = new (0, $gwPoJ.Graphics)();
        this.addChild(this.bg);
        this.interactive = true;
        this.cursor = "pointer";
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, props.width, props.height);
        this.on("pointerover", ()=>this.hover.set(true));
        this.on("pointerout", ()=>this.hover.set(false));
        this.on("removed", this.hover.stop);
        this.on("pointerdown", (event)=>{
            event?.stopPropagation?.();
            props.onClick();
        });
        this.draw();
    }
    draw() {
        const { width: width, height: height, selected: selected, color: color } = this.props;
        const h = this.hover.value;
        const g = this.bg;
        g.clear();
        if (selected || h > 0) {
            g.beginFill(selected ? (0, $ee6ea042cf422424$export$6b1a2b07ad04beea) : (0, $ee6ea042cf422424$export$dd27ce85ad53c944), selected ? 0.3 : 0.16 * h);
            g.drawRoundedRect(-4, -4, width + 8, height + 8, 9);
            g.endFill();
        }
        g.lineStyle(selected ? 2 : 1, selected ? (0, $ee6ea042cf422424$export$6b1a2b07ad04beea) : (0, $b67ebd3775cb0f71$export$671c724dbdd0c3a9)(0x000000, (0, $ee6ea042cf422424$export$dd27ce85ad53c944), h), selected ? 1 : 0.55 + 0.35 * h);
        g.beginFill(color, 1);
        g.drawRoundedRect(0, 0, width, height, 5);
        g.endFill();
        // Inner highlight: a hairline of light along the top edge so flat colours read as objects.
        g.lineStyle(1, 0xffffff, 0.18);
        g.moveTo(3, 2);
        g.lineTo(width - 3, 2);
        g.lineStyle(0);
    }
}
class $e0fb6921b9eca6b1$export$35081c78d70f9c8b extends (0, $8t5Gy.Container) {
    constructor(props){
        super();
        const { width: width, height: height, selected: selected } = props;
        this.bg = new (0, $gwPoJ.Graphics)();
        this.addChild(this.bg);
        this.glyph = (0, $ec5c35dbffc1f325$export$46ad086a5552f2fb)(props.icon, 16, (0, $ee6ea042cf422424$export$2032e0ed6548abf9));
        this.glyph.x = 17;
        this.glyph.y = height / 2;
        this.addChild(this.glyph);
        const name = $e0fb6921b9eca6b1$export$6f093cfa640b7166(props.label, {
            role: "compactLabel",
            color: selected ? 0xfff6e5 : (0, $ee6ea042cf422424$export$d597759d33be802e),
            bold: selected
        });
        name.x = 32;
        name.y = Math.round((height - name.height) / 2) - 5;
        this.addChild(name);
        const summary = $e0fb6921b9eca6b1$export$6f093cfa640b7166(props.summary, {
            role: "compactCaption",
            color: selected ? (0, $ee6ea042cf422424$export$6b1a2b07ad04beea) : (0, $ee6ea042cf422424$export$2032e0ed6548abf9)
        });
        const summaryRight = props.swatch !== undefined ? width - 24 : width - 10;
        $e0fb6921b9eca6b1$export$b94583dc679500d(summary, summaryRight - 32);
        summary.x = 32;
        summary.y = name.y + 13;
        this.addChild(summary);
        if (props.swatch !== undefined) {
            const dot = new (0, $gwPoJ.Graphics)();
            dot.lineStyle(1, 0x000000, 0.4);
            dot.beginFill(props.swatch, 1);
            dot.drawCircle(width - 15, height / 2, 6);
            dot.endFill();
            this.addChild(dot);
        }
        this.interactive = true;
        this.cursor = "pointer";
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, width, height);
        this.hover = new $e0fb6921b9eca6b1$var$HoverEase(()=>this.draw(props));
        this.on("pointerover", ()=>this.hover.set(true));
        this.on("pointerout", ()=>this.hover.set(false));
        this.on("removed", this.hover.stop);
        this.on("pointerdown", (event)=>{
            event?.stopPropagation?.();
            props.onClick();
        });
        this.draw(props);
    }
    draw(props) {
        const { width: width, height: height, selected: selected } = props;
        const h = this.hover.value;
        // The glyph is ink like the summary at rest, brightens with the name on hover, and takes the
        // accent with the summary once its row is open.
        this.glyph.tint = selected ? (0, $ee6ea042cf422424$export$6b1a2b07ad04beea) : (0, $b67ebd3775cb0f71$export$671c724dbdd0c3a9)((0, $ee6ea042cf422424$export$2032e0ed6548abf9), (0, $ee6ea042cf422424$export$d597759d33be802e), h);
        const g = this.bg;
        g.clear();
        if (selected) {
            g.beginFill((0, $ee6ea042cf422424$export$64abe9059de17029), 0.95);
            g.drawRoundedRect(0, 0, width, height, 7);
            g.endFill();
            // Amber spine on the selected row, pointing at the palette it opened.
            g.beginFill((0, $ee6ea042cf422424$export$dd27ce85ad53c944), 1);
            g.drawRoundedRect(0, 4, 3, height - 8, 1.5);
            g.endFill();
        } else if (h > 0) {
            g.beginFill((0, $ee6ea042cf422424$export$fc0b8fefbf3a9f6a), 0.8 * h);
            g.drawRoundedRect(0, 0, width, height, 7);
            g.endFill();
            // The spine starts to show on hover, so the row hints at what clicking it will do.
            g.beginFill((0, $ee6ea042cf422424$export$dd27ce85ad53c944), 0.45 * h);
            g.drawRoundedRect(0, 4 + (height - 8) * (1 - h) * 0.5, 3, (height - 8) * h, 1.5);
            g.endFill();
        }
    }
}
class $e0fb6921b9eca6b1$export$c5e39530e713771e extends (0, $ead1577967896e68$export$d714cb42a300e44f) {
    constructor(props){
        super({
            label: props.label,
            onClick: props.onClick,
            theme: "ember",
            size: "small",
            variant: props.primary ? "primary" : "secondary",
            appearance: props.primary ? "filled" : "outline",
            tone: props.primary ? "accent" : "neutral",
            shape: "pill",
            bold: !!props.primary,
            height: props.height ?? (0, $97475243e21a0995$export$73e83bf2b7e02467).small.height,
            hitPadding: {
                x: 4,
                y: 10
            }
        });
        this.boxWidth = this.getBoxSize().width;
        this.resize(this.boxWidth, props.height ?? (0, $97475243e21a0995$export$73e83bf2b7e02467).small.height);
    }
}
class $e0fb6921b9eca6b1$export$8b1e7a6f6a26652e extends (0, $8t5Gy.Container) {
    constructor(onRotate){
        super();
        const left = new $e0fb6921b9eca6b1$export$c5e39530e713771e({
            label: "\u2039 Rotate",
            onClick: ()=>onRotate(-1)
        });
        const right = new $e0fb6921b9eca6b1$export$c5e39530e713771e({
            label: "Rotate \u203A",
            onClick: ()=>onRotate(1)
        });
        right.x = left.boxWidth + 12;
        this.addChild(left, right);
        this.boxWidth = right.x + right.boxWidth;
    }
}
class $e0fb6921b9eca6b1$export$57625d62e5386b09 extends (0, $8t5Gy.Container) {
    constructor(props){
        super();
        const { page: page, pages: pages, onPage: onPage } = props;
        const arrow = (glyph, enabled, target)=>(0, $83d1a97b87afddc2$export$48c67489f19ab119)({
                icon: glyph,
                theme: "ember",
                width: (0, $97475243e21a0995$export$73e83bf2b7e02467).extraSmall.height,
                height: (0, $97475243e21a0995$export$73e83bf2b7e02467).extraSmall.height,
                size: "extraSmall",
                enabled: enabled,
                onClick: ()=>onPage(target)
            });
        const left = arrow("\u2039", page > 0, page - 1);
        this.addChild(left);
        const counter = $e0fb6921b9eca6b1$export$6f093cfa640b7166(`${page + 1} / ${pages}`, {
            role: "compactCaption",
            color: (0, $ee6ea042cf422424$export$2032e0ed6548abf9)
        });
        counter.x = 24;
        counter.y = Math.round(((0, $97475243e21a0995$export$73e83bf2b7e02467).extraSmall.height - counter.height) / 2);
        this.addChild(counter);
        const right = arrow("\u203A", page < pages - 1, page + 1);
        right.x = 28 + counter.width;
        this.addChild(right);
        this.boxWidth = right.x + 18;
    }
}


// The character forge: the trait list on the left, the character on a lit stage in the middle, and
// the palette for whichever trait is open on the right.
//
// The character starts facing southeast and stands on a turntable (see turntable.ts): drag the stage,
// or use the buttons at their feet, to look at the whole outfit. Every trait opens as a PALETTE:
// all of its choices laid out at once as chips and colour swatches, one click each, instead of a
// pair of arrows to cycle through.
const $c025c38ccd2d28a7$var$PANEL_PAD = 8;
const $c025c38ccd2d28a7$var$ROW_H = 36;
const $c025c38ccd2d28a7$var$ROW_GAP = 3;
const $c025c38ccd2d28a7$var$PALETTE_PAD = 14;
const $c025c38ccd2d28a7$var$paletteInnerWidth = ()=>(0, $ee6ea042cf422424$export$c212ee05c579f421) - $c025c38ccd2d28a7$var$PALETTE_PAD * 2;
const $c025c38ccd2d28a7$var$PALETTE_TITLE_H = 38;
const $c025c38ccd2d28a7$var$STYLE_CELL_H = 24;
const $c025c38ccd2d28a7$var$STYLE_MIN_W = 76;
const $c025c38ccd2d28a7$var$COLOR_CELL = 24;
const $c025c38ccd2d28a7$var$GRID_GAP = 6;
const $c025c38ccd2d28a7$var$SECTION_HEAD_H = 14;
const $c025c38ccd2d28a7$var$SECTION_GAP = 10;
const $c025c38ccd2d28a7$var$PAGER_H = 22;
// The stage. The composite is drawn from the centre of its 64x64 frame, and a standing LPC figure's
// feet sit about 28px below that centre.
const $c025c38ccd2d28a7$var$COMPOSITE_SCALE = 3.4;
const $c025c38ccd2d28a7$var$FEET_OFFSET = 28 * $c025c38ccd2d28a7$var$COMPOSITE_SCALE;
const $c025c38ccd2d28a7$var$FEET_Y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + 252;
const $c025c38ccd2d28a7$var$STAGE_CENTER_X = (0, $ee6ea042cf422424$export$f3a8244e0a259e49) + (0, $ee6ea042cf422424$export$de7d1b6c57f828f4) / 2;
const $c025c38ccd2d28a7$var$FLAME_H = 132;
/** The character's little hop when a change lands, and how long the stage light flares with it. */ const $c025c38ccd2d28a7$var$POP_MS = 280;
const $c025c38ccd2d28a7$var$FLARE_MS = 520;
/** How long the chip you just picked rings for. */ const $c025c38ccd2d28a7$var$PULSE_MS = 620;
/** The figure narrows for a moment as it swings to a new view, which reads as turning, not swapping. */ const $c025c38ccd2d28a7$var$TURN_MS = 130;
/** How long the "drag to turn" hint takes to go once it has been taken up. */ const $c025c38ccd2d28a7$var$HINT_FADE_MS = 500;
// The turntable's ring sits just outside the floor shadow; its buttons stand either side of it.
const $c025c38ccd2d28a7$var$RING_RX = 70;
const $c025c38ccd2d28a7$var$RING_RY = 18;
const $c025c38ccd2d28a7$var$TURN_BUTTON_INSET = 21;
/** The three columns arrive one after another: what you can change, who you are, what you can pick. */ const $c025c38ccd2d28a7$var$COLUMN_STAGGER = 90;
class $c025c38ccd2d28a7$export$fd5a80e92d0a5c1d extends (0, $2b3f66371c8d7b60$export$fe2b06ef7574cc0e) {
    constructor(player){
        super(), this.pageId = "build", this.title = "Forge your character", this.hint = "Pick a trait, then pick from its palette", this.openTrait = "sex", // Palettes bigger than one page remember where each trait was left.
        this.pageIndex = {}, this.fx = new (0, $8t5Gy.Container)(), this.sparks = new (0, $92b2c55b1ed94f26$export$c9c6e685d99d3d5b)(), this.ms = 0, this.popMs = $c025c38ccd2d28a7$var$POP_MS, this.flareMs = $c025c38ccd2d28a7$var$FLARE_MS, this.turnMs = $c025c38ccd2d28a7$var$TURN_MS, this.hintAlpha = 1, // Deep enough that editing the draft can't reach back into the live player's inventory (a
        // shallow copy shares the items array, so a new shirt would land on the player mid-creation).
        this.cloneForBuilder = (player)=>{
            const entity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
            entity.movement.angle = (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)(45);
            entity.weapon = {
                weaponType: "none"
            };
            entity.appearance = {
                ...player.appearance || (0, $1a2d6d21d6b0fac8$export$b7be1ee14f302b62)(undefined, "human", "male")
            };
            entity.inventory = {
                items: (player.inventory?.items || []).map((item)=>({
                        ...item,
                        itemTypeMeta: item.itemTypeMeta ? {
                            ...item.itemTypeMeta
                        } : undefined
                    })),
                abilities: {
                    ...player.inventory?.abilities || {}
                },
                lastUpdateTs: 0
            };
            const appearance = entity.appearance;
            appearance.race = "human";
            appearance.sex = "male";
            appearance.bodyColor = "light";
            appearance.hair = "high_and_tight";
            appearance.hairColor = (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$c2ef2c5bddebe408).high_and_tight);
            // Eyes aren't a choice any more, but an appearance that arrived without an eye layer still
            // gets the default one.
            appearance.eyes = appearance.eyes || "normal";
            appearance.eyesColor = appearance.eyesColor || "brown";
            appearance.noseColor = appearance.bodyColor;
            (0, $e8dc6d9c289fb887$export$5ca4f74dfb7adac4)(entity, "shirt", "style", "longsleeve");
            (0, $e8dc6d9c289fb887$export$5ca4f74dfb7adac4)(entity, "shirt", "color", "gray");
            (0, $e8dc6d9c289fb887$export$5ca4f74dfb7adac4)(entity, "pants", "style", "pantaloons");
            (0, $e8dc6d9c289fb887$export$5ca4f74dfb7adac4)(entity, "pants", "color", (0, $a80d0b17b615d6f7$export$e37b4dbfadf1f2de)((0, $bf6244e5cc9aa116$export$7ef85edc405cda8b).pantaloons));
            (0, $e8dc6d9c289fb887$export$5ca4f74dfb7adac4)(entity, "shoes", "style", "none");
            (0, $e8dc6d9c289fb887$export$f90ea17b26c746f3)(entity);
            return entity;
        }, this.rollOutfit = (entity)=>(0, $f684496fff50a7a1$export$eb64c22ff8ddddd4)(entity.appearance.sex, {
                pants: true,
                shirt: entity.appearance.sex === "male" ? (0, $cb689cfa16c444ba$export$30be1f861efc6479)(60) : true,
                shoe: true,
                weapon: true
            }), this.getAppearance = ()=>this.entity.appearance, this.getInventory = ()=>this.entity.inventory, this.lookSignature = ()=>JSON.stringify([
                this.entity.appearance,
                this.entity.inventory.items
            ]);
        this.entity = this.cloneForBuilder(player);
        // Particles only: its own glow is three stacked ellipses sized for the roster card, which banded
        // into visible rings across this stage. The stage's soft lights do that job here.
        this.flame = new (0, $d4e9bfba8663fd0e$export$180e4127bb338fb5)((0, $ee6ea042cf422424$export$de7d1b6c57f828f4) - 24, $c025c38ccd2d28a7$var$FLAME_H, {
            glow: false
        });
        this.turntable = new (0, $6a245c5bef01ef6b$export$190425a47868a42)({
            x: $c025c38ccd2d28a7$var$STAGE_CENTER_X,
            y: $c025c38ccd2d28a7$var$FEET_Y + 2,
            rx: $c025c38ccd2d28a7$var$RING_RX,
            ry: $c025c38ccd2d28a7$var$RING_RY
        }, this.entity.movement.angle, (angle)=>{
            this.entity.movement.angle = angle;
            this.composite?.doMovement(this.entity);
        });
    }
    animate(dtMs) {
        this.ms += dtMs;
        // A low, steady hearth glow at the character's feet -- alive, but never competing with the
        // character for attention.
        this.flame.update(dtMs, 0.45);
        this.sparks.update(dtMs);
        // A new look has just landed on the stage: give it a beat.
        const sprite = this.composite?.sprite;
        if (sprite && sprite !== this.shownSprite) {
            if (this.shownSprite) {
                this.popMs = 0;
                this.flareMs = 0;
                // Thrown up from the floor around the figure and drawn BEHIND it: embers kicked up
                // by the change, framing the new silhouette. (From the chest, white-hot sparks over
                // a pale shirt simply vanished.)
                this.sparks.throw(this.fx, $c025c38ccd2d28a7$var$STAGE_CENTER_X, $c025c38ccd2d28a7$var$FEET_Y - 6, 18, 150, 170);
            }
            this.shownSprite = sprite;
            this.shownFacing = sprite.facingDir;
            this.turntable.views = (0, $6a245c5bef01ef6b$export$377257a583f4b706)(sprite.calcDir?.bind(sprite));
        } else if (sprite && sprite.facingDir !== this.shownFacing) {
            this.shownFacing = sprite.facingDir;
            this.turnMs = 0;
        }
        this.popMs = Math.min($c025c38ccd2d28a7$var$POP_MS, this.popMs + dtMs);
        this.flareMs = Math.min($c025c38ccd2d28a7$var$FLARE_MS, this.flareMs + dtMs);
        this.turnMs = Math.min($c025c38ccd2d28a7$var$TURN_MS, this.turnMs + dtMs);
        if (this.composite) {
            const hop = Math.sin(Math.PI * (this.popMs / $c025c38ccd2d28a7$var$POP_MS));
            const pinch = Math.sin(Math.PI * (this.turnMs / $c025c38ccd2d28a7$var$TURN_MS));
            this.composite.scale.set($c025c38ccd2d28a7$var$COMPOSITE_SCALE * (1 + 0.05 * hop) * (1 - 0.05 * pinch), $c025c38ccd2d28a7$var$COMPOSITE_SCALE * (1 + 0.05 * hop));
            this.composite.y = $c025c38ccd2d28a7$var$FEET_Y - $c025c38ccd2d28a7$var$FEET_OFFSET * (1 + 0.05 * hop);
        }
        this.turntable.update(dtMs);
        if (this.turntable.turned && this.hintAlpha > 0) {
            this.hintAlpha = Math.max(0, this.hintAlpha - dtMs / $c025c38ccd2d28a7$var$HINT_FADE_MS);
            if (this.turnHint) this.turnHint.alpha = 0.7 * this.hintAlpha;
        }
        const flare = 1 - this.flareMs / $c025c38ccd2d28a7$var$FLARE_MS;
        if (this.lights) {
            this.lights.pool.alpha = 0.34 * (1 + 0.14 * (0, $92b2c55b1ed94f26$export$61e1f52f544ad1da)(this.ms, 1.3) + 0.9 * flare);
            this.lights.back.alpha = 0.2 * (1 + 0.08 * (0, $92b2c55b1ed94f26$export$61e1f52f544ad1da)(this.ms, 3.7) + 0.6 * flare);
            this.lights.spot.alpha = 0.09 * (1 + 0.5 * flare);
        }
        const pulse = this.pulse;
        if (pulse) {
            pulse.ms += dtMs;
            const k = Math.min(1, pulse.ms / $c025c38ccd2d28a7$var$PULSE_MS);
            const grow = 2 + 7 * (1 - Math.pow(1 - k, 3));
            pulse.g.clear();
            if (k < 1) {
                pulse.g.lineStyle(1.5, (0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 0.8 * (1 - k));
                pulse.g.drawRoundedRect(pulse.x - grow, pulse.y - grow, pulse.w + grow * 2, pulse.h + grow * 2, 6 + grow);
                pulse.g.lineStyle(0);
            } else this.pulse = undefined;
        }
    }
    tearDown() {
        this.openTrait = "sex";
        this.sparks.clear();
    }
    // Detach the pieces that outlive a repaint before the rest of the page is disposed.
    wipe() {
        if (this.composite?.parent) this.composite.parent.removeChild(this.composite);
        if (this.flame?.parent) this.flame.parent.removeChild(this.flame);
        if (this.fx.parent) this.fx.parent.removeChild(this.fx);
        if (this.turntable.ring.parent) this.turntable.ring.parent.removeChild(this.turntable.ring);
        this.turntable.detach();
        this.turnHint = undefined;
        this.pulse = undefined;
        super.wipe();
    }
    build() {
        this.wipe();
        this.reveal(this.drawTraitList(), 0);
        this.reveal(this.drawStage(), $c025c38ccd2d28a7$var$COLUMN_STAGGER);
        this.reveal(this.drawPalette(), $c025c38ccd2d28a7$var$COLUMN_STAGGER * 2);
        this.drawNav();
    }
    drawTraitList() {
        const column = new (0, $8t5Gy.Container)();
        this.addChild(column);
        const panel = new (0, $gwPoJ.Graphics)();
        (0, $e0fb6921b9eca6b1$export$3cd4174479c25cc8)(panel, (0, $ee6ea042cf422424$export$dcc2b41e4d83d427), (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba), (0, $ee6ea042cf422424$export$d35e9f16aaee0022), (0, $ee6ea042cf422424$export$343fef082e4bb475));
        column.addChild(panel);
        const views = (0, $e8dc6d9c289fb887$export$d0a4aaa8f938be7a)(this.entity);
        const listH = views.length * $c025c38ccd2d28a7$var$ROW_H + (views.length - 1) * $c025c38ccd2d28a7$var$ROW_GAP;
        let y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + Math.max($c025c38ccd2d28a7$var$PANEL_PAD, ((0, $ee6ea042cf422424$export$343fef082e4bb475) - listH) / 2);
        views.forEach((view)=>{
            const row = new (0, $e0fb6921b9eca6b1$export$35081c78d70f9c8b)({
                icon: view.icon,
                label: view.label,
                summary: view.summary,
                swatch: view.swatch,
                width: (0, $ee6ea042cf422424$export$d35e9f16aaee0022) - $c025c38ccd2d28a7$var$PANEL_PAD * 2,
                height: $c025c38ccd2d28a7$var$ROW_H,
                selected: view.id === this.openTrait,
                onClick: ()=>{
                    this.openTrait = view.id;
                    this.host.refresh();
                }
            });
            row.x = (0, $ee6ea042cf422424$export$dcc2b41e4d83d427) + $c025c38ccd2d28a7$var$PANEL_PAD;
            row.y = y;
            column.addChild(row);
            y += $c025c38ccd2d28a7$var$ROW_H + $c025c38ccd2d28a7$var$ROW_GAP;
        });
        return column;
    }
    drawStage() {
        const column = new (0, $8t5Gy.Container)();
        this.addChild(column);
        const panel = new (0, $gwPoJ.Graphics)();
        (0, $e0fb6921b9eca6b1$export$3cd4174479c25cc8)(panel, (0, $ee6ea042cf422424$export$f3a8244e0a259e49), (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba), (0, $ee6ea042cf422424$export$de7d1b6c57f828f4), (0, $ee6ea042cf422424$export$343fef082e4bb475));
        column.addChild(panel);
        // The light the character stands in: a warm wash behind them, a pool of firelight at their
        // feet, and a faint cool-white fall from above that picks out the figure. Soft sprites, so
        // there are no rings -- the stacked ellipses this replaced banded visibly.
        const stage = new (0, $8t5Gy.Container)();
        // Clip the light to the panel: the pool is wider than the stage and would spill over the
        // columns either side of it.
        const clip = new (0, $gwPoJ.Graphics)();
        clip.beginFill(0xffffff, 1);
        clip.drawRoundedRect((0, $ee6ea042cf422424$export$f3a8244e0a259e49) + 1, (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + 1, (0, $ee6ea042cf422424$export$de7d1b6c57f828f4) - 2, (0, $ee6ea042cf422424$export$343fef082e4bb475) - 2, 9);
        clip.endFill();
        stage.mask = clip;
        column.addChild(clip);
        const back = (0, $92b2c55b1ed94f26$export$fc6a66bad1f036bc)((0, $92b2c55b1ed94f26$export$d5e3057492233c50), 280, 330, 0.2);
        back.position.set($c025c38ccd2d28a7$var$STAGE_CENTER_X, $c025c38ccd2d28a7$var$FEET_Y - 60);
        const pool = (0, $92b2c55b1ed94f26$export$fc6a66bad1f036bc)((0, $92b2c55b1ed94f26$export$eb82270a4aa97b72), 250, 120, 0.34);
        pool.position.set($c025c38ccd2d28a7$var$STAGE_CENTER_X, $c025c38ccd2d28a7$var$FEET_Y + 4);
        const spot = (0, $92b2c55b1ed94f26$export$fc6a66bad1f036bc)((0, $92b2c55b1ed94f26$export$1cabeb8d5c2c6b4d), 150, 380, 0.09);
        spot.position.set($c025c38ccd2d28a7$var$STAGE_CENTER_X, (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + 120);
        stage.addChild(back, pool, spot);
        column.addChild(stage);
        this.lights = {
            back: back,
            pool: pool,
            spot: spot
        };
        this.flame.x = (0, $ee6ea042cf422424$export$f3a8244e0a259e49) + 12;
        this.flame.y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + (0, $ee6ea042cf422424$export$343fef082e4bb475) - $c025c38ccd2d28a7$var$FLAME_H - 6;
        column.addChild(this.flame);
        // Ground shadow, so the figure stands on something.
        const floor = new (0, $gwPoJ.Graphics)();
        floor.beginFill(0x000000, 0.45);
        floor.drawEllipse($c025c38ccd2d28a7$var$STAGE_CENTER_X, $c025c38ccd2d28a7$var$FEET_Y + 2, 46, 11);
        floor.endFill();
        floor.beginFill(0x000000, 0.3);
        floor.drawEllipse($c025c38ccd2d28a7$var$STAGE_CENTER_X, $c025c38ccd2d28a7$var$FEET_Y + 2, 62, 15);
        floor.endFill();
        column.addChild(floor);
        column.addChild(this.turntable.ring);
        // Between the floor and the figure: where the sparks of a change fly.
        column.addChild(this.fx);
        if (!this.composite) {
            this.composite = new (0, $64e038f1765e0ab3$export$f3390963b1a1dc25)("");
            this.composite.scale.set($c025c38ccd2d28a7$var$COMPOSITE_SCALE);
        }
        const look = this.lookSignature();
        if (look !== this.bakedLook) {
            this.bakedLook = look;
            this.composite.updatePaperdoll(this.entity);
        }
        this.composite.doMovement(this.entity);
        this.composite.x = $c025c38ccd2d28a7$var$STAGE_CENTER_X;
        this.composite.y = $c025c38ccd2d28a7$var$FEET_Y - $c025c38ccd2d28a7$var$FEET_OFFSET;
        column.addChild(this.composite);
        // The whole stage is the handle to turn the figure by; the buttons sit on top of it.
        column.addChild(this.turntable.surface(new (0, $6qzqq.Rectangle)((0, $ee6ea042cf422424$export$f3a8244e0a259e49), (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba), (0, $ee6ea042cf422424$export$de7d1b6c57f828f4), (0, $ee6ea042cf422424$export$343fef082e4bb475))));
        column.addChild((0, $6a245c5bef01ef6b$export$36f0674b7d8f8503)(-1, (0, $ee6ea042cf422424$export$f3a8244e0a259e49) + $c025c38ccd2d28a7$var$TURN_BUTTON_INSET, $c025c38ccd2d28a7$var$FEET_Y + 2, this.turntable.turn));
        column.addChild((0, $6a245c5bef01ef6b$export$36f0674b7d8f8503)(1, (0, $ee6ea042cf422424$export$f3a8244e0a259e49) + (0, $ee6ea042cf422424$export$de7d1b6c57f828f4) - $c025c38ccd2d28a7$var$TURN_BUTTON_INSET, $c025c38ccd2d28a7$var$FEET_Y + 2, this.turntable.turn));
        // An invitation that bows out once it has been taken up.
        if (this.hintAlpha > 0) {
            const hint = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)("Drag to turn", {
                role: "compactCaption",
                color: (0, $ee6ea042cf422424$export$2032e0ed6548abf9)
            });
            hint.x = Math.round($c025c38ccd2d28a7$var$STAGE_CENTER_X - hint.width / 2);
            hint.y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + 12;
            hint.alpha = 0.7 * this.hintAlpha;
            column.addChild(hint);
            this.turnHint = hint;
        }
        const caption = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)("Bound for the West", {
            role: "compactCaption",
            color: (0, $ee6ea042cf422424$export$2032e0ed6548abf9),
            display: true,
            size: 11
        });
        caption.x = Math.round($c025c38ccd2d28a7$var$STAGE_CENTER_X - caption.width / 2);
        caption.y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + (0, $ee6ea042cf422424$export$343fef082e4bb475) - 21;
        caption.alpha = 0.8;
        column.addChild(caption);
        return column;
    }
    drawPalette() {
        const column = new (0, $8t5Gy.Container)();
        this.addChild(column);
        const panel = new (0, $gwPoJ.Graphics)();
        (0, $e0fb6921b9eca6b1$export$3cd4174479c25cc8)(panel, (0, $ee6ea042cf422424$export$1a7bb33882f2a323), (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba), (0, $ee6ea042cf422424$export$c212ee05c579f421), (0, $ee6ea042cf422424$export$343fef082e4bb475));
        column.addChild(panel);
        const view = (0, $e8dc6d9c289fb887$export$4cb82e77282accdd)(this.entity, this.openTrait);
        const x = (0, $ee6ea042cf422424$export$1a7bb33882f2a323) + $c025c38ccd2d28a7$var$PALETTE_PAD;
        const heading = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)(view.label, {
            role: "label",
            color: (0, $ee6ea042cf422424$export$6b1a2b07ad04beea),
            display: true,
            weight: "500",
            size: 17
        });
        heading.x = x;
        heading.y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + 9;
        column.addChild(heading);
        const hint = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)(`Now: ${view.summary}`, {
            role: "compactCaption",
            color: (0, $ee6ea042cf422424$export$2032e0ed6548abf9)
        });
        (0, $e0fb6921b9eca6b1$export$b94583dc679500d)(hint, $c025c38ccd2d28a7$var$paletteInnerWidth() - heading.width - 14);
        hint.x = (0, $ee6ea042cf422424$export$1a7bb33882f2a323) + (0, $ee6ea042cf422424$export$c212ee05c579f421) - $c025c38ccd2d28a7$var$PALETTE_PAD - hint.width;
        hint.y = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + 15;
        column.addChild(hint);
        const top = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + $c025c38ccd2d28a7$var$PALETTE_TITLE_H;
        const bottom = (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + (0, $ee6ea042cf422424$export$343fef082e4bb475) - $c025c38ccd2d28a7$var$PALETTE_PAD;
        const colorSection = view.sections.find((section)=>section.kind === "color");
        const styleSection = view.sections.find((section)=>section.kind === "style");
        // The colour row is short and fixed; the style grid takes whatever is left.
        let colorBlockH = 0;
        let colorLayout;
        if (colorSection) {
            colorLayout = (0, $e9b2f8e011d0ad84$export$2ad821b5ee3abcf6)({
                count: colorSection.options.length,
                width: $c025c38ccd2d28a7$var$paletteInnerWidth(),
                height: $c025c38ccd2d28a7$var$COLOR_CELL * 2 + $c025c38ccd2d28a7$var$GRID_GAP,
                cellHeight: $c025c38ccd2d28a7$var$COLOR_CELL,
                minCellWidth: $c025c38ccd2d28a7$var$COLOR_CELL,
                maxCellWidth: $c025c38ccd2d28a7$var$COLOR_CELL + 6,
                gapX: $c025c38ccd2d28a7$var$GRID_GAP,
                gapY: $c025c38ccd2d28a7$var$GRID_GAP
            });
            colorBlockH = $c025c38ccd2d28a7$var$SECTION_HEAD_H + colorLayout.height + $c025c38ccd2d28a7$var$SECTION_GAP;
        }
        let y = top;
        if (styleSection) {
            const available = bottom - top - colorBlockH - $c025c38ccd2d28a7$var$SECTION_HEAD_H - $c025c38ccd2d28a7$var$PAGER_H;
            const layout = (0, $e9b2f8e011d0ad84$export$2ad821b5ee3abcf6)({
                count: styleSection.options.length,
                width: $c025c38ccd2d28a7$var$paletteInnerWidth(),
                height: available,
                cellHeight: $c025c38ccd2d28a7$var$STYLE_CELL_H,
                minCellWidth: $c025c38ccd2d28a7$var$STYLE_MIN_W,
                gapX: $c025c38ccd2d28a7$var$GRID_GAP,
                gapY: $c025c38ccd2d28a7$var$GRID_GAP
            });
            y = this.drawSection(column, styleSection, x, y, layout);
        }
        if (colorSection && colorLayout) {
            // With a style grid above it the colour row sits on the floor of the panel; on its own
            // (skin) it belongs at the top, not stranded at the bottom of an empty panel.
            const colorY = styleSection ? Math.max(y, bottom - colorBlockH + $c025c38ccd2d28a7$var$SECTION_GAP) : top;
            this.drawSection(column, colorSection, x, colorY, colorLayout);
        }
        return column;
    }
    // Draws one section (heading, grid of choices, pager when it doesn't fit on a page) and returns
    // the y just below it.
    drawSection(column, section, x, y, layout) {
        const heading = (0, $e0fb6921b9eca6b1$export$300ac6f106ef584d)(section.title, $c025c38ccd2d28a7$var$paletteInnerWidth());
        heading.x = x;
        heading.y = y;
        column.addChild(heading);
        const gridY = y + $c025c38ccd2d28a7$var$SECTION_HEAD_H;
        const page = Math.min(this.pageIndex[this.openTrait] || 0, layout.pages - 1);
        const shown = (0, $e9b2f8e011d0ad84$export$2660a47c412cb681)(section.options, layout, page);
        const cellH = section.kind === "color" ? $c025c38ccd2d28a7$var$COLOR_CELL : $c025c38ccd2d28a7$var$STYLE_CELL_H;
        shown.forEach((option, index)=>{
            const at = (0, $e9b2f8e011d0ad84$export$da4afb51d4f9da58)(index, layout, cellH, $c025c38ccd2d28a7$var$GRID_GAP, $c025c38ccd2d28a7$var$GRID_GAP);
            const onClick = ()=>this.choose(section, option.value);
            const chip = section.kind === "color" ? new (0, $e0fb6921b9eca6b1$export$43e54f70144d08dc)(option.swatch, {
                width: layout.cellWidth,
                height: cellH,
                selected: option.value === section.selected,
                onClick: onClick
            }) : new (0, $e0fb6921b9eca6b1$export$f1b71a6df9b30e88)(option.label, {
                width: layout.cellWidth,
                height: cellH,
                selected: option.value === section.selected,
                onClick: onClick
            });
            chip.x = x + at.x;
            chip.y = gridY + at.y;
            column.addChild(chip);
            // The chip that was just picked rings once, so the eye finds what changed.
            const choice = this.lastChoice;
            if (choice && choice.trait === this.openTrait && choice.kind === section.kind && choice.value === option.value && Date.now() - choice.at < 400) {
                const ring = new (0, $gwPoJ.Graphics)();
                column.addChild(ring);
                this.pulse = {
                    g: ring,
                    x: chip.x,
                    y: chip.y,
                    w: layout.cellWidth,
                    h: cellH,
                    ms: 0
                };
            }
        });
        let bottom = gridY + layout.height + $c025c38ccd2d28a7$var$SECTION_GAP;
        if (layout.pages > 1) {
            const pager = new (0, $e0fb6921b9eca6b1$export$57625d62e5386b09)({
                page: page,
                pages: layout.pages,
                onPage: (next)=>{
                    this.pageIndex[this.openTrait] = next;
                    this.host.refresh();
                }
            });
            pager.x = x + $c025c38ccd2d28a7$var$paletteInnerWidth() - pager.boxWidth;
            pager.y = gridY + layout.height + 4;
            column.addChild(pager);
            bottom += $c025c38ccd2d28a7$var$PAGER_H;
        }
        return bottom;
    }
    choose(section, value) {
        this.lastChoice = {
            trait: this.openTrait,
            kind: section.kind,
            value: value,
            at: Date.now()
        };
        (0, $e8dc6d9c289fb887$export$5ca4f74dfb7adac4)(this.entity, this.openTrait, section.kind, value);
        // A different hairstyle (or cut of shirt) can offer a different set of colours, so the open
        // palette is rebuilt rather than patched.
        this.host.refresh();
    }
    drawNav() {
        this.host.setNavButtons([
            {
                title: "\uD83C\uDFB2 Random look",
                callback: ()=>{
                    const appearance = (0, $1a2d6d21d6b0fac8$export$b7be1ee14f302b62)(this.entity, "human", this.entity.appearance.sex);
                    appearance.inventoryAppearanceHash = this.entity.appearance.inventoryAppearanceHash;
                    this.entity.appearance = appearance;
                    this.entity.appearance.eyes = this.entity.appearance.eyes || "normal";
                    this.entity.appearance.noseColor = this.entity.appearance.bodyColor;
                    (0, $e8dc6d9c289fb887$export$f90ea17b26c746f3)(this.entity);
                    this.host.refresh();
                }
            },
            {
                title: "\uD83D\uDC55 Random outfit",
                callback: ()=>{
                    this.entity.inventory.items = this.rollOutfit(this.entity);
                    (0, $e8dc6d9c289fb887$export$f90ea17b26c746f3)(this.entity);
                    this.host.refresh();
                }
            },
            {
                title: "Journey onward \u25B8",
                primary: true,
                callback: ()=>{
                    this.host.submitCharacter(this.entity.appearance, this.entity.inventory);
                    this.host.close();
                }
            }
        ]);
    }
}


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");
var $9Pi8W = parcelRequire("9Pi8W");






// The page before the forge: the exile that puts you on the road.
const $3388c3749452b953$var$TYPE_MS_PER_CHAR = 22;
// A block of prose that types itself out. Pre-wrapped with TextMetrics so revealing a character at a
// time can't reflow the paragraph underneath itself (the usual word-wrap typewriter jitter). Lines are
// centred on their FINISHED width, so a line grows outward from where it will end up rather than
// sliding left as it fills.
class $3388c3749452b953$var$Typewriter extends (0, $8t5Gy.Container) {
    constructor(body, width, { size: size = 17, color: color = (0, $ee6ea042cf422424$export$d597759d33be802e), lineHeight: lineHeight = 27, startMs: startMs = 0 } = {}){
        super(), this.lines = [], this.caret = new (0, $gwPoJ.Graphics)(), this.total = 0, this.revealed = -1, this.finished = false, /** Type the rest at once -- the player clicked to hurry it along. */ this.finish = ()=>{
            this.elapsed = Math.max(this.elapsed, this.total * $3388c3749452b953$var$TYPE_MS_PER_CHAR);
            this.animate(0);
        };
        this.lineH = lineHeight;
        this.elapsed = startMs;
        const style = new (0, $9Pi8W.TextStyle)({
            fontFamily: (0, $ef882f0a643d87d9$export$51d6375781d583cb),
            fontSize: size,
            fontWeight: "400",
            wordWrap: true,
            wordWrapWidth: width,
            // Match what text() below actually renders, so the lines it measures are the lines drawn.
            strokeThickness: 0
        });
        const measured = (0, $9Pi8W.TextMetrics).measureText(body, style);
        measured.lines.forEach((line, i)=>{
            const label = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)("", {
                display: true,
                weight: "400",
                size: size,
                color: color
            });
            const full = line.trimEnd();
            const lineWidth = (0, $9Pi8W.TextMetrics).measureText(full, style).width;
            label.y = i * lineHeight;
            this.addChild(label);
            this.lines.push({
                label: label,
                full: full,
                x: Math.round((width - lineWidth) / 2)
            });
            this.total += full.length;
        });
        this.caret.beginFill((0, $92b2c55b1ed94f26$export$319b6132a2fafb7c), 0.9);
        this.caret.drawRect(0, 0, 2, size + 3);
        this.caret.endFill();
        this.addChild(this.caret);
        this.animate(0);
    }
    /** The block's height when fully typed -- known up front, so the panel can be sized to it. */ get blockHeight() {
        return this.lines.length * this.lineH;
    }
    get done() {
        return this.finished;
    }
    get elapsedMs() {
        return this.elapsed;
    }
    animate(dtMs) {
        this.elapsed += dtMs;
        const target = Math.min(this.total, Math.floor(this.elapsed / $3388c3749452b953$var$TYPE_MS_PER_CHAR));
        if (target !== this.revealed) {
            this.revealed = target;
            let remaining = target;
            this.lines.forEach((line)=>{
                const take = Math.max(0, Math.min(line.full.length, remaining));
                if (line.label.text.length !== take) line.label.text = line.full.slice(0, take);
                line.label.x = line.x;
                remaining -= line.full.length;
            });
            this.finished = target >= this.total;
        }
        // The caret rides the end of the line being typed, then blinks twice and goes.
        const typing = !this.finished;
        const afterMs = this.elapsed - this.total * $3388c3749452b953$var$TYPE_MS_PER_CHAR;
        this.caret.visible = typing || afterMs < 1100 && Math.floor(afterMs / 275) % 2 === 1;
        const current = this.lines.find((line)=>line.label.text.length < line.full.length) || this.lines[this.lines.length - 1];
        if (current) {
            this.caret.x = current.x + current.label.width + 2;
            this.caret.y = current.label.y + 3;
        }
    }
}
// The seal has to read as wax pressed onto the decree, not as something to press. The first one was a
// toothed disc with a domed highlight and a floating drop shadow, alone and centred under the text,
// with a ring of light pulsing off it: every cue of a button. So the wax is an uneven dab lying flat
// on the page, the die is sunk INTO it, and it sits askew at the end of a sign-off line over two
// ribbon tails, where a seal goes on a document.
const $3388c3749452b953$var$WAX = 0x8a1a12;
const $3388c3749452b953$var$WAX_DEEP = 0x4e0b07;
const $3388c3749452b953$var$WAX_LIT = 0xc7473a;
const $3388c3749452b953$var$WAX_FACE = 0x7a160f;
const $3388c3749452b953$var$WAX_RELIEF = 0x93201a;
const $3388c3749452b953$var$RIBBON = 0x9b6a2c;
const $3388c3749452b953$var$RIBBON_DEEP = 0x5e3d18;
const $3388c3749452b953$var$RIBBON_LIT = 0xd9a456;
const $3388c3749452b953$var$SEAL_SEED = 2.2;
/**
 * The outline of a dab of wax about (0, 0): round-ish but swelling unevenly, with two lobes where it
 * squeezed out from under the die. `seed` turns the unevenness.
 */ const $3388c3749452b953$var$waxOutline = (r, seed)=>{
    const lobe = (angle, at, width, height)=>{
        const d = Math.atan2(Math.sin(angle - at), Math.cos(angle - at));
        return height * Math.exp(-(d * d) / (width * width));
    };
    const points = [];
    for(let i = 0; i < 96; i++){
        const a = i / 96 * Math.PI * 2;
        const swell = 0.06 * Math.sin(a * 2 + seed * 1.7) + 0.05 * Math.sin(a * 3 + seed * 2.9) + 0.035 * Math.sin(a * 5 + seed * 4.3) + 0.02 * Math.sin(a * 9 + seed * 0.7) + lobe(a, 0.6 + seed, 0.28, 0.13) + lobe(a, 3.6 + seed, 0.22, 0.09);
        points.push(Math.cos(a) * r * (1 + swell), Math.sin(a) * r * (1 + swell));
    }
    return points;
};
const $3388c3749452b953$var$starPoints = (radius, inner, dx, dy)=>{
    const points = [];
    for(let i = 0; i < 16; i++){
        const angle = i / 16 * Math.PI * 2 - Math.PI / 2;
        const rr = i % 2 === 0 ? radius : inner;
        points.push(Math.cos(angle) * rr + dx, Math.sin(angle) * rr + dy);
    }
    return points;
};
/** The wax's shadow on the page, in black, about (0, 0): its own Graphics so it can trail the seal down. */ const $3388c3749452b953$var$drawSealShadow = (g, r)=>{
    g.beginFill(0x000000, 1);
    g.drawPolygon($3388c3749452b953$var$waxOutline(r * 1.15, $3388c3749452b953$var$SEAL_SEED));
    g.endFill();
};
/**
 * An imperial seal pressed into red wax, about (0, 0). Lit from the upper left: the bead squeezed up
 * round the die stands proud (lit lip on that side), the die's circle is sunk in (its far wall dark,
 * its near wall lit), and a beaded border and an eight-pointed star stand up in relief inside it.
 */ const $3388c3749452b953$var$drawSeal = (g, r)=>{
    const outline = $3388c3749452b953$var$waxOutline(r * 1.12, $3388c3749452b953$var$SEAL_SEED);
    g.beginFill($3388c3749452b953$var$WAX, 1);
    g.drawPolygon(outline);
    g.endFill();
    g.beginFill($3388c3749452b953$var$WAX_LIT, 0.35);
    g.drawPolygon(outline.map((v)=>v * 0.93 - 0.6));
    g.endFill();
    g.beginFill($3388c3749452b953$var$WAX, 1);
    g.drawPolygon(outline.map((v)=>v * 0.93 + 0.5));
    g.endFill();
    const die = r * 0.74;
    g.beginFill($3388c3749452b953$var$WAX_DEEP, 0.9);
    g.drawCircle(-0.9, -0.9, die);
    g.endFill();
    g.beginFill($3388c3749452b953$var$WAX_LIT, 0.55);
    g.drawCircle(0.9, 0.9, die);
    g.endFill();
    g.beginFill($3388c3749452b953$var$WAX_FACE, 1);
    g.drawCircle(0, 0, die - 1.3);
    g.endFill();
    for(let i = 0; i < 24; i++){
        const angle = i / 24 * Math.PI * 2;
        const x = Math.cos(angle) * (die - 3.4);
        const y = Math.sin(angle) * (die - 3.4);
        g.beginFill($3388c3749452b953$var$WAX_LIT, 0.45);
        g.drawCircle(x - 0.35, y - 0.35, 0.85);
        g.endFill();
        g.beginFill($3388c3749452b953$var$WAX_DEEP, 0.6);
        g.drawCircle(x + 0.35, y + 0.35, 0.85);
        g.endFill();
    }
    g.beginFill($3388c3749452b953$var$WAX_DEEP, 0.85);
    g.drawPolygon($3388c3749452b953$var$starPoints(r * 0.44, r * 0.19, 0.8, 0.8));
    g.endFill();
    g.beginFill($3388c3749452b953$var$WAX_LIT, 0.7);
    g.drawPolygon($3388c3749452b953$var$starPoints(r * 0.44, r * 0.19, -0.6, -0.6));
    g.endFill();
    g.beginFill($3388c3749452b953$var$WAX_RELIEF, 1);
    g.drawPolygon($3388c3749452b953$var$starPoints(r * 0.42, r * 0.18, 0, 0));
    g.endFill();
    g.beginFill($3388c3749452b953$var$WAX_LIT, 0.6);
    g.drawCircle(-0.4, -0.4, r * 0.09);
    g.endFill();
    g.beginFill($3388c3749452b953$var$WAX_RELIEF, 1);
    g.drawCircle(0, 0, r * 0.075);
    g.endFill();
};
/** Two swallowtail ribbon ends hanging from (0, 0), fanned apart, for the wax to be pressed over. */ const $3388c3749452b953$var$drawRibbons = (g, length, width, spread)=>{
    const tail = (angle, len)=>{
        const dx = Math.sin(angle);
        const dy = Math.cos(angle);
        const nx = dy;
        const ny = -dx;
        const half = width / 2;
        const endX = dx * len;
        const endY = dy * len;
        const notchX = endX - dx * width * 0.7;
        const notchY = endY - dy * width * 0.7;
        const strip = [
            [
                nx * half,
                ny * half
            ],
            [
                endX + nx * half,
                endY + ny * half
            ],
            [
                notchX,
                notchY
            ],
            [
                endX - nx * half,
                endY - ny * half
            ],
            [
                -nx * half,
                -ny * half
            ]
        ].flat();
        g.beginFill(0x000000, 0.35);
        g.drawPolygon(strip.map((v, i)=>v + (i % 2 === 0 ? 0.8 : 1.6)));
        g.endFill();
        g.beginFill($3388c3749452b953$var$RIBBON, 1);
        g.drawPolygon(strip);
        g.endFill();
        // A fold of shade down one side, a lit edge down the other.
        g.beginFill($3388c3749452b953$var$RIBBON_DEEP, 0.55);
        g.drawPolygon([
            0,
            0,
            notchX,
            notchY,
            endX - nx * half,
            endY - ny * half,
            -nx * half,
            -ny * half
        ]);
        g.endFill();
        g.lineStyle(1, $3388c3749452b953$var$RIBBON_LIT, 0.6);
        g.moveTo(nx * (half - 0.5), ny * (half - 0.5));
        g.lineTo(endX + nx * (half - 0.5), endY + ny * (half - 0.5));
        g.lineStyle(0);
    };
    tail(spread, length);
    tail(-spread * 0.8, length * 0.88);
};
const $3388c3749452b953$var$SEAL_R = 22;
const $3388c3749452b953$var$SEAL_MS = 300;
// The seal rests turned a little, as a hand leaves it -- square to the page is how a button sits.
const $3388c3749452b953$var$SEAL_TILT = 0.24;
// After the last word: the sign-off line draws out toward the seal's place, the ribbons are laid,
// and then the stamp comes down.
const $3388c3749452b953$var$SIGN_LINE_W = 200;
const $3388c3749452b953$var$SEAL_DELAY = 420;
const $3388c3749452b953$var$ramp = (ms, from, over)=>Math.min(1, Math.max(0, (ms - from) / over));
class $3388c3749452b953$export$1f1210b18f6f2bd1 extends (0, $2b3f66371c8d7b60$export$fe2b06ef7574cc0e) {
    animate(dtMs) {
        this.sparks.update(dtMs);
        const typewriter = this.typewriter;
        if (!typewriter) return;
        // The decree waits for the page to arrive before it starts writing.
        if (!this.entering) {
            typewriter.animate(dtMs);
            this.typedMs = typewriter.elapsedMs;
        }
        if (typewriter.done && this.sealMs < 0) this.sealMs = 0;
        // A click only hurries the words along, so only the unfinished decree shows a hand: a pointer
        // still up over the finished seal would say the seal is the thing to press.
        this.cursor = typewriter.done ? "default" : "pointer";
        if (this.sealMs >= 0 && this.seal) {
            this.sealMs += dtMs;
            this.paintSignOff(this.sealMs);
            this.paintSeal(this.sealMs - $3388c3749452b953$var$SEAL_DELAY);
        }
    }
    tearDown() {
        this.sparks.clear();
    }
    build() {
        this.wipe();
        this.sparks.clear();
        this.typewriter = undefined;
        const panelW = 560 + ((0, $ee6ea042cf422424$export$35aa3e8070dd3c30) - 780) * 0.5;
        const panelX = Math.round(((0, $ee6ea042cf422424$export$35aa3e8070dd3c30) - panelW) / 2);
        const pad = 34;
        const innerW = panelW - pad * 2;
        const panel = new (0, $8t5Gy.Container)();
        this.panel = panel;
        this.addChild(panel);
        const kicker = (0, $e0fb6921b9eca6b1$export$ae58fbe30126ec19)("By order of the Emperor", {
            role: "compactCaption",
            color: (0, $ee6ea042cf422424$export$6b1a2b07ad04beea),
            size: 11
        });
        const body = new $3388c3749452b953$var$Typewriter("You have been exiled to the barbarous lands of the West, for the Emperor will suffer no rivals in the East.", innerW, {
            startMs: this.typedMs
        });
        // Laid out top-down from the panel's top edge, then the panel is sized to what it holds.
        const kickerTop = pad - 6;
        const bodyTop = kickerTop + kicker.height + 24;
        const sealCenter = bodyTop + body.blockHeight + 12 + $3388c3749452b953$var$SEAL_R;
        const panelH = sealCenter + $3388c3749452b953$var$SEAL_R + pad - 10;
        const panelY = Math.round((0, $ee6ea042cf422424$export$2c2fdba2e52ddfba) + ((0, $ee6ea042cf422424$export$343fef082e4bb475) - panelH) / 2);
        const glass = new (0, $gwPoJ.Graphics)();
        (0, $e0fb6921b9eca6b1$export$3cd4174479c25cc8)(glass, panelX, panelY, panelW, panelH, {
            radius: 12
        });
        panel.addChild(glass);
        kicker.x = Math.round(panelX + (panelW - kicker.width) / 2);
        kicker.y = panelY + kickerTop;
        panel.addChild(kicker);
        const rule = new (0, $gwPoJ.Graphics)();
        (0, $e0fb6921b9eca6b1$export$6bfce7f06513f30a)(rule, panelX + panelW / 2, kicker.y + kicker.height + 9, 70);
        panel.addChild(rule);
        body.x = panelX + pad;
        body.y = panelY + bodyTop;
        panel.addChild(body);
        this.typewriter = body;
        // Signed off at the bottom right: a line with the Emperor's mark over it, and the seal pressed at
        // its end over two ribbon tails. The seal and its shadow are drawn about their own centres so
        // the stamp scales down onto its middle.
        const sealX = panelX + panelW - pad - 24;
        const sealY = panelY + sealCenter;
        const lineRight = sealX - 40;
        const line = new (0, $gwPoJ.Graphics)();
        line.beginFill((0, $ee6ea042cf422424$export$640631a81002c59c), 0.7);
        line.drawRect(0, 0, $3388c3749452b953$var$SIGN_LINE_W, 1);
        line.endFill();
        line.position.set(lineRight - $3388c3749452b953$var$SIGN_LINE_W, sealY + 6);
        panel.addChild(line);
        const caption = (0, $e0fb6921b9eca6b1$export$ae58fbe30126ec19)("Sealed by his imperial hand", {
            role: "compactCaption",
            color: (0, $ee6ea042cf422424$export$2032e0ed6548abf9),
            size: 10
        });
        caption.x = Math.round(lineRight - caption.width);
        caption.y = Math.round(sealY + 2 - caption.height);
        panel.addChild(caption);
        const ribbons = new (0, $gwPoJ.Graphics)();
        $3388c3749452b953$var$drawRibbons(ribbons, 40, 11, 0.45);
        ribbons.position.set(sealX, sealY + 2);
        panel.addChild(ribbons);
        this.signOff = {
            line: line,
            caption: caption,
            ribbons: ribbons
        };
        const shadow = new (0, $gwPoJ.Graphics)();
        $3388c3749452b953$var$drawSealShadow(shadow, $3388c3749452b953$var$SEAL_R);
        panel.addChild(shadow);
        this.sealShadow = shadow;
        const seal = new (0, $gwPoJ.Graphics)();
        $3388c3749452b953$var$drawSeal(seal, $3388c3749452b953$var$SEAL_R);
        seal.position.set(sealX, sealY);
        panel.addChild(seal);
        this.seal = seal;
        this.paintSignOff(this.sealMs);
        this.paintSeal(this.sealMs < 0 ? -1 : this.sealMs - $3388c3749452b953$var$SEAL_DELAY);
        this.reveal(glass, 0, {
            rise: 14,
            ms: 480
        });
        this.reveal(kicker, 160);
        this.reveal(rule, 220, {
            rise: 0
        });
        // Clicking the decree hurries it: finish the words, and let the seal come straight down.
        this.interactive = true;
        this.hitArea = new (0, $6qzqq.Rectangle)(0, (0, $ee6ea042cf422424$export$2c2fdba2e52ddfba), (0, $ee6ea042cf422424$export$35aa3e8070dd3c30), (0, $ee6ea042cf422424$export$343fef082e4bb475));
        this.cursor = body.done ? "default" : "pointer";
        this.removeAllListeners("pointerdown");
        this.on("pointerdown", ()=>{
            this.finishEntrance();
            if (!this.typewriter?.done) {
                this.typewriter?.finish();
                this.typedMs = this.typewriter?.elapsedMs ?? this.typedMs;
            }
        });
        this.host.setNavButtons([
            {
                title: "Forge your character \u25B8",
                primary: true,
                callback: ()=>this.host.switchPage("build")
            }
        ]);
    }
    /**
     * The sign-off at `ms` after the last word: hidden before; the line drawn out left to right toward
     * the seal's place, then its caption. The ribbon tails spring out from under the wax as it lands --
     * laid out ahead of it, their tucked-in ends showed as a bare chevron.
     */ paintSignOff(ms) {
        const signOff = this.signOff;
        if (!signOff) return;
        const { line: line, caption: caption, ribbons: ribbons } = signOff;
        line.visible = caption.visible = ribbons.visible = ms >= 0;
        line.scale.x = (0, $b67ebd3775cb0f71$export$1157fb72e7fbceb5)(ms / 320);
        caption.alpha = $3388c3749452b953$var$ramp(ms, 100, 280);
        const landing = $3388c3749452b953$var$SEAL_DELAY + $3388c3749452b953$var$SEAL_MS - 40;
        ribbons.alpha = $3388c3749452b953$var$ramp(ms, landing, 60);
        ribbons.scale.y = 0.5 + 0.5 * (0, $b67ebd3775cb0f71$export$1157fb72e7fbceb5)($3388c3749452b953$var$ramp(ms, landing, 240));
    }
    /**
     * The seal at `ms` into its fall: hidden before; coming down from above the page, large and turned,
     * onto a shadow that tightens under it as it nears; then the wax squeezes out under the die and it
     * lies still. The landing is a thump and a few sparks -- no ring of light, which reads as "press me".
     */ paintSeal(ms) {
        const seal = this.seal;
        const shadow = this.sealShadow;
        if (!seal || !shadow) return;
        seal.visible = shadow.visible = ms >= 0;
        if (ms < 0) return;
        const t = Math.min(1, ms / $3388c3749452b953$var$SEAL_MS);
        // Gathering speed as it drops, rather than floating in.
        const drop = t * t;
        if (t >= 1 && this.sealedAt === undefined) {
            this.sealedAt = ms;
            this.sparks.throw(this.panel || this, seal.x, seal.y, 14, 90);
        }
        const since = this.sealedAt === undefined ? -1 : ms - this.sealedAt;
        const squeeze = since >= 0 && since < 180 ? 0.07 * Math.sin(Math.PI * since / 180) : 0;
        seal.scale.set(1.7 - 0.7 * drop + squeeze);
        seal.alpha = Math.min(1, t * 2.5);
        seal.rotation = $3388c3749452b953$var$SEAL_TILT - 0.2 * (1 - drop);
        // High up, the shadow is faint, loose, and well down and to the right of it; on landing it
        // closes up into the thin dark rim of wax a few millimetres thick.
        const height = 1 - drop;
        shadow.position.set(seal.x + 0.6 + 7 * height, seal.y + 1.4 + 11 * height);
        shadow.scale.set(1 + 0.25 * height + squeeze);
        shadow.rotation = seal.rotation;
        shadow.alpha = (0.45 - 0.33 * height) * seal.alpha;
        // The thump: the panel gives a little under the stamp.
        if (this.panel) this.panel.y = since >= 0 && since < 220 ? 2.5 * (1 - since / 220) * Math.cos(since / 22) : 0;
    }
    constructor(...args){
        super(...args), this.pageId = "intro", this.title = "The long exile", this.sparks = new (0, $92b2c55b1ed94f26$export$c9c6e685d99d3d5b)(), // Kept across repaints: a resize or a late font rebuilds the page, and the decree should carry on
        // from where it was rather than start typing over, or stamp itself a second time.
        this.typedMs = 0, this.sealMs = -1;
    }
}







parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

const $f84ce7d40829905e$export$d366e2aaf798d630 = (0, $ef882f0a643d87d9$export$51d6375781d583cb);
const $f84ce7d40829905e$export$bdcdd190e0e471c4 = 800;
const $f84ce7d40829905e$export$843193d9c9a3c91b = 460;
const $f84ce7d40829905e$export$56d196d2844d1ca1 = {
    panelFill: 0x120d0a,
    panelRim: 0x8a6a48,
    fieldFill: 0x090605,
    fieldRim: 0x8a6a48,
    text: 0xfbefdc,
    muted: 0xb9a68c,
    accent: 0xf2a94e,
    accentHi: 0xffd166,
    accentDim: 0xc98a3a,
    onAccent: 0x2b1a0b,
    danger: 0xff9f86,
    shadow: 0x000000,
    scrim: 0x0b0806,
    highlight: 0xffedc7
};
const $f84ce7d40829905e$export$3f0e99ae6e0ec541 = {
    cardWidth: 460,
    cardPadding: 26,
    cardRadius: 10,
    fieldHeight: 44,
    fieldRadius: 8,
    buttonHeight: 44,
    buttonRadius: 8,
    gutter: 16
};
const $f84ce7d40829905e$export$35aa3e8070dd3c30 = $f84ce7d40829905e$export$3f0e99ae6e0ec541.cardWidth - $f84ce7d40829905e$export$3f0e99ae6e0ec541.cardPadding * 2;
const $f84ce7d40829905e$export$3d8dfa7926012c64 = (g, w, h, radius = $f84ce7d40829905e$export$3f0e99ae6e0ec541.cardRadius)=>{
    g.clear();
    g.beginFill($f84ce7d40829905e$export$56d196d2844d1ca1.shadow, 0.34);
    g.drawRoundedRect(3, 7, w, h, radius);
    g.endFill();
    g.lineStyle({
        width: 1,
        color: $f84ce7d40829905e$export$56d196d2844d1ca1.panelRim,
        alpha: 0.6
    });
    g.beginFill($f84ce7d40829905e$export$56d196d2844d1ca1.panelFill, 0.88);
    g.drawRoundedRect(0, 0, w, h, radius);
    g.endFill();
    g.lineStyle(0);
    // Light catching the top edge: one hairline, inset past the corners, so the slab reads as glass
    // with a lip rather than a flat cut-out.
    g.beginFill($f84ce7d40829905e$export$56d196d2844d1ca1.highlight, 0.12);
    g.drawRect(radius, 1, w - radius * 2, 1);
    g.endFill();
};
const $f84ce7d40829905e$export$7ac3698ce9457404 = (g, w, h, radius = 8)=>{
    g.clear();
    g.lineStyle({
        width: 1,
        color: $f84ce7d40829905e$export$56d196d2844d1ca1.panelRim,
        alpha: 0.35
    });
    g.beginFill($f84ce7d40829905e$export$56d196d2844d1ca1.panelFill, 0.8);
    g.drawRoundedRect(0, 0, w, h, radius);
    g.endFill();
    g.lineStyle(0);
};
const $f84ce7d40829905e$export$a00f6eb43ef2da81 = (g, w, h, tone)=>{
    g.clear();
    const rim = tone === "error" ? {
        color: $f84ce7d40829905e$export$56d196d2844d1ca1.danger,
        alpha: 0.9,
        width: 2
    } : tone === "focused" ? {
        color: $f84ce7d40829905e$export$56d196d2844d1ca1.accent,
        alpha: 0.85,
        width: 2
    } : {
        color: $f84ce7d40829905e$export$56d196d2844d1ca1.fieldRim,
        alpha: 0.4,
        width: 1
    };
    g.lineStyle({
        width: rim.width,
        color: rim.color,
        alpha: rim.alpha
    });
    g.beginFill($f84ce7d40829905e$export$56d196d2844d1ca1.fieldFill, 0.72);
    g.drawRoundedRect(0, 0, w, h, $f84ce7d40829905e$export$3f0e99ae6e0ec541.fieldRadius);
    g.endFill();
    g.lineStyle(0);
};
const $f84ce7d40829905e$export$970ba5b8c200b2f1 = (tone)=>(w, h, state)=>{
        const g = new (0, $gwPoJ.Graphics)();
        const override = tone();
        $f84ce7d40829905e$export$a00f6eb43ef2da81(g, w, h, override === "error" ? "error" : state === "FOCUSED" ? "focused" : "default");
        return g;
    };
const $f84ce7d40829905e$export$e2b5c7690a313f00 = ()=>{
    const fonts = typeof document !== "undefined" ? document.fonts : undefined;
    if (!fonts || typeof fonts.load !== "function") return Promise.resolve();
    return Promise.all([
        fonts.load('300 88px "Jost"'),
        fonts.load('400 16px "Jost"'),
        fonts.load('500 16px "Jost"')
    ]).then(()=>undefined).catch(()=>undefined);
};


// The character-creation screen.
//
// Two pages share one frame -- a header, the page's body, and a footer of actions the page decides
// on: the exile that opens the game, and the character forge itself, whose last button sends the
// player off into the game. The forge is the substance of it; see character_creation/build_page.ts.
//
// The screen is only repainted when something actually changes (a page switch, a palette click, the
// player data finally arriving), rather than on every player-stat update the HUD receives -- the
// pages hold live state (which trait is open, how far the intro has typed) that a blind rebuild
// would throw away.
/** The road the player is on, as the header's trail shows it. */ const $5be630d7f2f3b131$var$TRAIL = [
    {
        id: "intro",
        label: "Exile"
    },
    {
        id: "build",
        label: "Forge"
    }
];
/**
 * The hall the screen is set in: dark, lit from the floor by a fire the player cannot see, with embers
 * drifting up through it. Built ONCE and carried from repaint to repaint -- the pages are rebuilt on
 * every palette click, and embers that restarted from the floor each time would stutter.
 */ class $5be630d7f2f3b131$var$BuilderAtmosphere extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.floor = new (0, $gwPoJ.Graphics)(), this.fire = (0, $92b2c55b1ed94f26$export$fc6a66bad1f036bc)((0, $92b2c55b1ed94f26$export$d5e3057492233c50), 1, 1, 0.5), this.fireCore = (0, $92b2c55b1ed94f26$export$fc6a66bad1f036bc)((0, $92b2c55b1ed94f26$export$eb82270a4aa97b72), 1, 1, 0.28), this.vignette = new (0, $7Bs2Z.Sprite)((0, $92b2c55b1ed94f26$export$bc3e2f9b8d094108)()), this.ms = 0, this.w = 0, this.h = 0, /** Cover the whole screen, out past the dialog's padding. */ this.layout = (width, height)=>{
            if (width === this.w && height === this.h) return;
            this.w = width;
            this.h = height;
            this.floor.clear();
            this.floor.beginFill((0, $ee6ea042cf422424$export$4389bfa33b3049ea), 1);
            this.floor.drawRect(-12, -12, width, height);
            this.floor.endFill();
            this.vignette.position.set(-12, -12);
            this.vignette.width = width;
            this.vignette.height = height;
            this.embers.position.set(-12, -12);
            this.embers.resize(width, height);
            this.animate(0);
        }, this.animate = (dtMs)=>{
            this.ms += dtMs;
            const { w: w, h: h, ms: ms } = this;
            this.embers.update(dtMs);
            // Firelight welling up from below the floor of the screen, breathing.
            this.fire.position.set(w / 2 - 12, h - 12);
            this.fire.width = w * 1.25;
            this.fire.height = h * 0.9 * (1 + 0.04 * (0, $92b2c55b1ed94f26$export$61e1f52f544ad1da)(ms, 4));
            this.fire.alpha = 0.5 * (1 + 0.1 * (0, $92b2c55b1ed94f26$export$61e1f52f544ad1da)(ms));
            this.fireCore.position.set(w / 2 - 12, h);
            this.fireCore.width = w * 0.6;
            this.fireCore.height = h * 0.32;
            this.fireCore.alpha = 0.28 * (1 + 0.18 * (0, $92b2c55b1ed94f26$export$61e1f52f544ad1da)(ms, 2.1));
        };
        this.addChild(this.floor);
        this.addChild(this.fire);
        this.addChild(this.fireCore);
        this.addChild(this.vignette);
        this.embers = new (0, $92b2c55b1ed94f26$export$8a5dcbf95285d0bf)({
            width: (0, $ee6ea042cf422424$export$35aa3e8070dd3c30),
            height: (0, $ee6ea042cf422424$export$8a4e6245b38ca3f5),
            count: 22,
            spawnBand: 0.25,
            minSize: 3,
            maxSize: 7,
            minRise: 10,
            maxRise: 26,
            sway: 16,
            minLife: 5,
            maxLife: 10,
            alpha: 0.8
        });
        this.addChild(this.embers);
    }
}
class $5be630d7f2f3b131$export$49421d8fc42e7f44 extends (0, $ac2a97d45725bff5$export$f79759b47a91f0e7) {
    constructor(guiManager, logic){
        super(guiManager, {
            opaque: true,
            unescapable: true
        }), this.pages = new Map(), this.currentPageId = "intro", this.navButtons = [], this.initialized = false, this.dirty = true, this.wasOpen = false, this.viewportHeight = 0, // A repaint only plays the entrance when the body is genuinely new -- opening the screen, or
        // moving to another page. An in-place repaint (a palette click, a pager step) redraws the same
        // page, and bringing that in from nothing is read as the whole screen blinking.
        this.fadeNextPaint = true, this.atmosphere = new $5be630d7f2f3b131$var$BuilderAtmosphere(), this.fontRequested = false, // The HUD calls this whenever the player entity changes. Rebuild only when the screen has
        // something new to show -- but keep retrying initialization, because the first call usually
        // arrives before the player's appearance and starting kit have.
        this.update = ()=>{
            // Opening (toggle -> update) always paints, even if nothing changed since it last closed.
            const open = this.isOpen();
            if (open && !this.wasOpen) {
                this.dirty = true;
                this.fadeNextPaint = true;
            }
            this.wasOpen = open;
            if (!this.initialized && !this.initialize()) return;
            if (!this.dirty) return;
            this.dirty = false;
            this.rebuildSurface();
        }, // Frame hook (driven by GuiManager.updateTimer) for the page's own animation: the hall's firelight
        // and embers, the entrance, the forge's stage, the intro's typewriter.
        this.animate = (dtMs)=>{
            if (!this.isOpen()) return;
            if ((0, $ee6ea042cf422424$export$35aa3e8070dd3c30) !== (0, $167efe97b4119a5d$export$b0f20d83cec42115)().width - 20 || this.viewportHeight !== (0, $167efe97b4119a5d$export$b0f20d83cec42115)().height) {
                this.dirty = true;
                this.update();
            }
            this.atmosphere.animate(dtMs);
            const page = this.pages.get(this.currentPageId);
            page?.tickEntrance(dtMs);
            page?.animate(dtMs);
        }, this.initialize = ()=>{
            const player = this.guiManager.getPlayer();
            if (!player?.appearance || player.inventory?.items?.length < 1) return false;
            // The headings and prose are set in Jost. It is normally resolved already -- the login screen
            // waits on it -- but a player who never saw that screen (the local name gate, an embed that
            // boots straight in) would get Verdana rasters, so ask, and repaint once it is here.
            if (!this.fontRequested) {
                this.fontRequested = true;
                (0, $f84ce7d40829905e$export$e2b5c7690a313f00)().then(()=>this.isOpen() && this.refresh());
            }
            const register = (page)=>{
                page.host = this;
                this.pages.set(page.pageId, page);
            };
            register(new (0, $3388c3749452b953$export$1f1210b18f6f2bd1)());
            register(new (0, $c025c38ccd2d28a7$export$fd5a80e92d0a5c1d)(player));
            this.initialized = true;
            return true;
        }, // --- BuilderHost -------------------------------------------------------------------------
        // Repaint, but not from inside the click that asked for it: a palette click would otherwise tear
        // down the very chip pixi is still dispatching the event on. Coalesces a burst into one repaint.
        this.refresh = ()=>{
            this.dirty = true;
            if (this.refreshTimer !== undefined) return;
            this.refreshTimer = setTimeout(()=>{
                this.refreshTimer = undefined;
                if (this.isOpen()) this.update();
            }, 0);
        }, this.setNavButtons = (buttons)=>{
            this.navButtons = buttons;
        }, this.submitCharacter = (appearance, inventory)=>{
            this.logic.playerController.client.saveAppearance(appearance, inventory);
        }, this.switchPage = (pageId)=>{
            if (pageId === this.currentPageId) return;
            this.pages.get(this.currentPageId)?.tearDown();
            this.currentPageId = pageId;
            this.fadeNextPaint = true;
            this.refresh();
        }, // --- rendering ---------------------------------------------------------------------------
        this.createContent = ()=>{
            const main = new (0, $gwPoJ.Graphics)();
            const viewport = (0, $167efe97b4119a5d$export$b0f20d83cec42115)();
            this.viewportHeight = viewport.height;
            (0, $ee6ea042cf422424$export$7e50c07e514fc0dd)(viewport.width - 20);
            this.atmosphere.layout((0, $ee6ea042cf422424$export$35aa3e8070dd3c30) + 24, Math.max((0, $ee6ea042cf422424$export$8a4e6245b38ca3f5) + 44, viewport.height + 24));
            main.addChild(this.atmosphere);
            if (!this.initialized && !this.initialize()) // Player data hasn't landed yet; the next update() tries again.
            return main;
            const page = this.pages.get(this.currentPageId);
            page.build();
            main.addChild(page);
            const heading = this.drawHeader(main, page);
            const footer = this.drawFooter(main);
            // On a page switch the page brings itself in, piece by piece (see BuilderPage.reveal), with
            // the header's title and the footer riding along. A repaint of the page you are already on
            // has to land instantly -- the whole rebuild happens inside one task, so swapping the
            // children is invisible unless something animates them.
            page.alpha = 1;
            if (this.fadeNextPaint) {
                this.fadeNextPaint = false;
                page.reveal(heading, 0, {
                    rise: 6
                });
                page.reveal(footer, 220, {
                    rise: 8
                });
                page.startEntrance();
            } else page.finishEntrance();
            return main;
        }, this.drawHeader = (g, page)=>{
            const heading = (0, $e0fb6921b9eca6b1$export$ae58fbe30126ec19)(page.title, {
                role: "compactTitle",
                color: (0, $ee6ea042cf422424$export$6b1a2b07ad04beea),
                size: 17
            });
            heading.x = 2;
            heading.y = 3;
            g.addChild(heading);
            if (page.hint) {
                const hint = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)(page.hint, {
                    role: "compactCaption",
                    color: (0, $ee6ea042cf422424$export$2032e0ed6548abf9)
                });
                hint.x = (0, $ee6ea042cf422424$export$35aa3e8070dd3c30) - hint.width - 2;
                hint.y = 10;
                hint.alpha = 0.75;
                g.addChild(hint);
            }
            this.drawTrail(g, page.pageId);
            // A bronze base with the gold lens swelling out of its middle -- the same mark the login
            // wordmark draws under itself, so the two screens read as one sequence.
            const rule = new (0, $gwPoJ.Graphics)();
            rule.beginFill((0, $ee6ea042cf422424$export$640631a81002c59c), 0.45);
            rule.drawRect(0, (0, $ee6ea042cf422424$export$341c383d1f147954) - 5, (0, $ee6ea042cf422424$export$35aa3e8070dd3c30), 1);
            rule.endFill();
            (0, $e0fb6921b9eca6b1$export$6bfce7f06513f30a)(rule, (0, $ee6ea042cf422424$export$35aa3e8070dd3c30) / 2, (0, $ee6ea042cf422424$export$341c383d1f147954) - 4.5, (0, $ee6ea042cf422424$export$35aa3e8070dd3c30) * 0.36);
            g.addChild(rule);
            return heading;
        }, /**
     * Exile -> Forge, centred in the header: where the player is, what is behind them and what is
     * ahead. Small and still -- a sense of a road, not a progress bar to race.
     */ this.drawTrail = (g, current)=>{
            const at = $5be630d7f2f3b131$var$TRAIL.findIndex((step)=>step.id === current);
            if (at < 0) return;
            const trail = new (0, $8t5Gy.Container)();
            const line = new (0, $gwPoJ.Graphics)();
            trail.addChild(line);
            const cy = 13;
            const gap = 26;
            let x = 0;
            // Where each stop's dot sits and where its label ends, to run the road between them.
            const stops = [];
            $5be630d7f2f3b131$var$TRAIL.forEach((step, i)=>{
                const isCurrent = i === at;
                const done = i < at;
                const dot = new (0, $gwPoJ.Graphics)();
                if (isCurrent) {
                    dot.beginFill((0, $ee6ea042cf422424$export$dd27ce85ad53c944), 0.18);
                    dot.drawCircle(0, 0, 9);
                    dot.endFill();
                    dot.lineStyle(1.5, (0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 1);
                    dot.beginFill((0, $ee6ea042cf422424$export$4389bfa33b3049ea), 1);
                    dot.drawCircle(0, 0, 5);
                    dot.endFill();
                    dot.lineStyle(0);
                    dot.beginFill((0, $ee6ea042cf422424$export$6b1a2b07ad04beea), 1);
                    dot.drawCircle(0, 0, 2.5);
                    dot.endFill();
                } else if (done) {
                    dot.beginFill((0, $ee6ea042cf422424$export$dd27ce85ad53c944), 0.9);
                    dot.drawCircle(0, 0, 3.5);
                    dot.endFill();
                } else {
                    dot.lineStyle(1, (0, $ee6ea042cf422424$export$640631a81002c59c), 0.9);
                    dot.beginFill((0, $ee6ea042cf422424$export$4389bfa33b3049ea), 1);
                    dot.drawCircle(0, 0, 3.5);
                    dot.endFill();
                    dot.lineStyle(0);
                }
                dot.x = x;
                dot.y = cy;
                trail.addChild(dot);
                const label = (0, $e0fb6921b9eca6b1$export$6f093cfa640b7166)(step.label, {
                    role: "compactCaption",
                    color: isCurrent ? (0, $ee6ea042cf422424$export$6b1a2b07ad04beea) : done ? (0, $ee6ea042cf422424$export$d597759d33be802e) : (0, $ee6ea042cf422424$export$2032e0ed6548abf9),
                    display: true,
                    weight: isCurrent ? "500" : "400",
                    size: 11
                });
                label.alpha = isCurrent ? 1 : done ? 0.75 : 0.55;
                label.x = x + 9;
                label.y = Math.round(cy - label.height / 2);
                trail.addChild(label);
                stops.push({
                    x: x,
                    labelRight: label.x + label.width
                });
                x = label.x + label.width + gap;
            });
            // The road between the stops: walked in gold, ahead in bronze.
            for(let i = 0; i < stops.length - 1; i++){
                const left = stops[i].labelRight + 6;
                const right = stops[i + 1].x - 8;
                line.beginFill(i < at ? (0, $ee6ea042cf422424$export$dd27ce85ad53c944) : (0, $ee6ea042cf422424$export$640631a81002c59c), i < at ? 0.7 : 0.5);
                line.drawRect(left, cy - 0.5, Math.max(0, right - left), 1);
                line.endFill();
            }
            trail.x = Math.round((0, $ee6ea042cf422424$export$35aa3e8070dd3c30) / 2 - trail.width / 2);
            g.addChild(trail);
        }, this.drawFooter = (g)=>{
            const y = (0, $ee6ea042cf422424$export$8a4e6245b38ca3f5) - (0, $ee6ea042cf422424$export$7900c34204647a1b);
            const footer = new (0, $8t5Gy.Container)();
            const rule = new (0, $gwPoJ.Graphics)();
            rule.beginFill((0, $ee6ea042cf422424$export$640631a81002c59c), 0.45);
            rule.drawRect(0, y, (0, $ee6ea042cf422424$export$35aa3e8070dd3c30), 1);
            rule.endFill();
            g.addChild(rule);
            const buttonY = y + 10;
            let x = 2;
            const primary = this.navButtons.filter((meta)=>meta.primary);
            const secondary = this.navButtons.filter((meta)=>!meta.primary);
            secondary.forEach((meta)=>{
                const button = new (0, $e0fb6921b9eca6b1$export$c5e39530e713771e)({
                    label: meta.title,
                    onClick: meta.callback
                });
                button.x = x;
                button.y = buttonY;
                footer.addChild(button);
                x += button.boxWidth + 8;
            });
            let right = (0, $ee6ea042cf422424$export$35aa3e8070dd3c30) - 2;
            primary.slice().reverse().forEach((meta)=>{
                const button = new (0, $e0fb6921b9eca6b1$export$c5e39530e713771e)({
                    label: meta.title,
                    primary: true,
                    onClick: meta.callback
                });
                button.x = right - button.boxWidth;
                button.y = buttonY;
                footer.addChild(button);
                right -= button.boxWidth + 8;
            });
            g.addChild(footer);
            return footer;
        };
        this.logic = logic;
    }
}






parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");














parcelRequire("1avo5");
var $kXE1p = parcelRequire("kXE1p");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $d3fD1 = parcelRequire("d3fD1");
var $gwPoJ = parcelRequire("gwPoJ");


const $4d7afde9fb919e81$var$dirs = [
    "left",
    "right",
    "front",
    "back"
];
const $4d7afde9fb919e81$var$SheetLoadingState = {};
const $4d7afde9fb919e81$export$c93e91c91768c5a2 = [
    "walk-left",
    "walk-right",
    "walk-back",
    "walk-front",
    "idle-left",
    "idle-right",
    "idle-back",
    "idle-front",
    "cast-left",
    "cast-right",
    "cast-back",
    "cast-front",
    "thrust-left",
    "thrust-right",
    "thrust-back",
    "thrust-front",
    "slash-left",
    "slash-right",
    "slash-back",
    "slash-front",
    "shoot-left",
    "shoot-right",
    "shoot-back",
    "shoot-front",
    "hurt-front",
    "activate",
    "deactivate",
    "inactive",
    "active"
];
const $4d7afde9fb919e81$var$defaultRenderMeta = {
    "walk-left": {
        scale: 1,
        speed: 0.25
    },
    activate: {
        scale: 1,
        speed: 0.25
    },
    deactivate: {
        scale: 1,
        speed: 0.25
    },
    "walk-right": {
        scale: 1,
        speed: 0.25
    },
    "walk-back": {
        scale: 1,
        speed: 0.25
    },
    "walk-front": {
        scale: 1,
        speed: 0.25
    },
    inactive: {
        scale: 1
    },
    active: {
        scale: 1
    },
    "idle-left": {
        scale: 1
    },
    "idle-right": {
        scale: 1
    },
    "idle-back": {
        scale: 1
    },
    "idle-front": {
        scale: 1
    },
    "cast-left": {
        scale: 1,
        speed: 0.2
    },
    "cast-right": {
        scale: 1,
        speed: 0.2
    },
    "cast-back": {
        scale: 1,
        speed: 0.2
    },
    "cast-front": {
        scale: 1,
        speed: 0.2
    },
    "thrust-left": {
        scale: 1,
        speed: 0.55
    },
    "thrust-right": {
        scale: 1,
        speed: 0.55
    },
    "thrust-back": {
        scale: 1,
        speed: 0.55
    },
    "thrust-front": {
        scale: 1,
        speed: 0.55
    },
    "slash-left": {
        scale: 1,
        speed: 0.25
    },
    "slash-right": {
        scale: 1,
        speed: 0.25
    },
    "slash-back": {
        scale: 1,
        speed: 0.25
    },
    "slash-front": {
        scale: 1,
        speed: 0.25
    },
    "shoot-left": {
        scale: 1,
        speed: 0.85
    },
    "shoot-right": {
        scale: 1,
        speed: 0.85
    },
    "shoot-back": {
        scale: 1,
        speed: 0.85
    },
    "shoot-front": {
        scale: 1,
        speed: 0.85
    },
    "hurt-front": {
        scale: 1
    }
};
const $4d7afde9fb919e81$var$animationToAction = {
    "walk-left": "walk",
    "walk-right": "walk",
    "walk-back": "walk",
    "walk-front": "walk",
    "idle-left": "idle",
    "idle-right": "idle",
    "idle-back": "idle",
    "idle-front": "idle",
    "cast-left": "cast",
    "cast-right": "cast",
    "cast-back": "cast",
    "cast-front": "cast",
    "thrust-left": "thrust",
    "thrust-right": "thrust",
    "thrust-back": "thrust",
    "thrust-front": "thrust",
    "slash-left": "slash",
    "slash-right": "slash",
    "slash-back": "slash",
    "slash-front": "slash",
    "shoot-left": "thrust",
    "shoot-right": "thrust",
    "shoot-back": "thrust",
    "shoot-front": "thrust",
    "hurt-front": "hurt",
    activate: "activate",
    deactivate: "deactivate",
    inactive: "inactive",
    active: "active"
};
const $4d7afde9fb919e81$var$isAttackAnimation = (animationName)=>[
        "shoot",
        "thrust",
        "slash"
    ].includes($4d7afde9fb919e81$var$animationToAction[animationName]);
const $4d7afde9fb919e81$var$isWalkAnimation = (animationName)=>[
        "walk"
    ].includes($4d7afde9fb919e81$var$animationToAction[animationName]);
const $4d7afde9fb919e81$var$extractDirection = (animation)=>animation.split("-")[1];
class $4d7afde9fb919e81$export$1a1b4f8679485f1c extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor({ sheetId: sheetId, renderMeta: renderMeta = $4d7afde9fb919e81$var$defaultRenderMeta, attackAction: attackAction, angle: angle, hasHalo: hasHalo, defaultAction: defaultAction = "idle-front", staticPose: staticPose = false }){
        super(), this.walkPace = new (0, $5db32d8baa90944d$export$da5eb4266422a064)(), this.spriteAngle = 0, this.action = "idle-front", this.prevAction = "idle-front", this.animations = {}, this.facingDir = "front", this.attackAction = "idle", // Static pose only: the sheet has been read, whether or not it had a frame for the pose.
        this.poseResolved = false, this.disposed = false, this.initalize = ()=>{
            if ((0, $1f08f7b8f85adf9e$export$250bc44beae81773).active?.resources.has(this.sheetId)) {
                this.setup();
                return;
            }
            const loadingState = $4d7afde9fb919e81$var$SheetLoadingState[this.sheetId];
            if (loadingState === "loaded") {
                this.setup();
                return;
            }
            if (loadingState === "loading") {
                this.loadingInterval = setInterval(()=>{
                    const loadingState = $4d7afde9fb919e81$var$SheetLoadingState[this.sheetId];
                    if (loadingState === "loaded") {
                        this.setup();
                        clearInterval(this.loadingInterval);
                        return;
                    }
                }, 1000);
                return;
            }
            // its not loaded at all -- start loading it!
            $4d7afde9fb919e81$var$SheetLoadingState[this.sheetId] = "loading";
            (0, $kXE1p.Loader).shared.add(this.sheetId, (0, $e5c675b7b9585b42$export$bab18279d67f8654)(`assets/${this.sheetId}`), ()=>{
                $4d7afde9fb919e81$var$SheetLoadingState[this.sheetId] = "loaded";
                this.setup();
            });
        }, this.setup = ()=>{
            // A loader can complete after the portrait or paperdoll has been removed.
            if (this.disposed || this.destroyed) return;
            this.spritesheetResource = (0, $1f08f7b8f85adf9e$export$42d948b5d3f64a60)(this.sheetId);
            const sheet = this.spritesheetResource?.spritesheet;
            if (!sheet) return;
            if (this.staticPose) {
                // A sheet with no frame for this pose draws nothing in it, but is still settled. Every
                // oversize weapon layer (saber, longsword, waraxe...) holds only slash rows, and waiting
                // on it left each armed recruit's roster card uncached for good.
                this.poseResolved = true;
                const texture = sheet.animations[this.defaultAnimationType]?.[0];
                if (texture) {
                    const { scale: scale = 1, color: color = 0xffffff } = this.renderMeta[this.defaultAnimationType] || {};
                    this.sprite = new (0, $7Bs2Z.Sprite)(texture);
                    this.sprite.scale.set(scale);
                    this.sprite.tint = color;
                    this.container.addChild(this.sprite);
                }
                return;
            }
            this.disallowMoveAttackAnimation = false;
            $4d7afde9fb919e81$export$c93e91c91768c5a2.forEach((animationName)=>{
                const source = this.renderMeta[animationName];
                if (!source) return;
                const { scale: scale, speed: speed = 0.267, color: color = 0xffffff } = source;
                const resource = sheet.animations[animationName];
                if (!resource) return;
                const animation = new (0, $d3fD1.AnimatedSprite)(resource);
                animation.scale.set(scale);
                animation.animationSpeed = speed;
                animation.visible = false;
                animation.tint = color;
                this.container.addChild(animation);
                this.animations[animationName] = animation;
                if ($4d7afde9fb919e81$var$isAttackAnimation(animationName)) {
                    animation.loop = false;
                    animation.onComplete = ()=>{
                        this.activateAnimation(`idle-${$4d7afde9fb919e81$var$extractDirection(this.action)}`);
                    };
                }
            });
            this.action = "idle-front";
            this.activateAnimation(this.action, true);
        }, this.recolor = (color)=>{
            if (this.currentColor === color) return;
            this.currentColor = color;
            if (this.animation) this.animation.tint = color;
            if (this.sprite) this.sprite.tint = color;
        }, this.activateAnimation = (updatedAction, force)=>{
            if (this.disposed || this.staticPose) return;
            if (!this.spritesheetResource) return;
            if (updatedAction === this.action && !force) // noop
            return;
            const source = this.animations[`${this.action}`];
            const toUpdate = this.animations[`${updatedAction}`];
            if (!toUpdate) return;
            this.walkPace.apply(updatedAction, toUpdate);
            if (source) {
                // stop and hide the current animation
                source.visible = false;
                source.stop();
            }
            // start and show the next animation
            this.action = updatedAction;
            toUpdate.visible = true;
            toUpdate.gotoAndPlay(0);
        }, this.fragment = (entity)=>{
            let actionToUse = this.action;
            if (!this.renderMeta[this.action]) actionToUse = `idle-${this.facingDir}`;
            if (!this.renderMeta[actionToUse]) return;
            const { scale: scale } = this.renderMeta[actionToUse];
            const surface = new (0, $gwPoJ.Graphics)();
            surface.x = this.parent.x;
            surface.y = this.parent.y;
            surface.scale.set(scale);
            surface.rotation = this.container.rotation;
            this.parent.parent.addChild(surface);
            const sprite = this.animations[`${actionToUse}`];
            if (!sprite) return;
            const f = sprite.textures[sprite.currentFrame];
            const { width: width, height: height } = f._frame;
            surface.x -= width / 2;
            surface.y -= height / 2;
            (0, $4264eae3240561ee$export$cc249234599c5a64)(surface, f, {
                cacheKey: entity.appearance?.race
            });
        };
        this.renderMeta = {
            ...$4d7afde9fb919e81$var$defaultRenderMeta,
            ...renderMeta
        };
        this.attackAction = attackAction;
        this.spriteAngle = angle;
        this.facingDir = this.calcDir(angle);
        this.container = new (0, $gwPoJ.Graphics)();
        this.addChild(this.container);
        if (hasHalo) {
            const halo = new (0, $gwPoJ.Graphics)();
            halo.alpha = 0.5;
            halo.beginFill(0xffffff);
            halo.drawCircle(0, -10, 12);
            halo.endFill();
            this.halo = halo;
            this.container.addChild(halo);
        }
        this.sheetId = sheetId;
        this.defaultAnimationType = defaultAction;
        this.staticPose = staticPose;
        this.initalize();
    }
    isReadyToShow() {
        return !this.disposed && (this.poseResolved || Object.keys(this.animations).length > 0);
    }
    calcDir(angle) {
        return (0, $a80d0b17b615d6f7$export$5ebc7cf9991d3d13)(angle);
    }
    calcSpriteAngle() {
        if (this.facingDir === "front") return 90;
        if (this.facingDir === "back") return 270;
        if (this.facingDir === "left") return 181;
        return 0;
    }
    doMovement(entity) {
        this.walkPace.update(entity);
        this.walkPace.apply(this.action, this.animations[this.action]);
        const { movement: movement } = entity;
        if (!movement) return;
        if (this.spriteAngle !== movement.angle) {
            const facingDir = this.calcDir(movement.angle);
            if (facingDir !== this.facingDir) {
                const parts = this.action.split("-");
                const updated = `${parts[0]}-${facingDir}`;
                this.activateAnimation(updated);
            }
            this.facingDir = facingDir;
        }
        this.spriteAngle = movement.angle;
        const { x: x, y: y } = entity.location;
        if (x !== this.lastX || y !== this.lastY) {
            this.lastX = x;
            this.lastY = y;
            if (this.idleTimeout !== undefined) {
                clearTimeout(this.idleTimeout);
                this.idleTimeout = undefined;
            }
            if (!$4d7afde9fb919e81$var$isAttackAnimation(this.action)) this.activateAnimation(`walk-${this.facingDir}`);
        } else if (this.idleTimeout === undefined) this.idleTimeout = setTimeout(()=>{
            if ($4d7afde9fb919e81$var$isAttackAnimation(this.action)) return;
            this.activateAnimation(`idle-${this.facingDir}`);
        }, 50);
    }
    cleanup() {
        if (this.disposed) return;
        this.disposed = true;
        clearInterval(this.loadingInterval);
        clearTimeout(this.idleTimeout);
        Object.values(this.animations).forEach((animation)=>animation.stop());
    }
    remove() {
        super.remove();
        this.destroy({
            children: true
        });
    }
    destroy(options) {
        this.cleanup();
        // The sheet textures are shared with other paperdolls.
        super.destroy(options);
    }
    doAttack(entity) {
        if ($4d7afde9fb919e81$var$isAttackAnimation(this.action)) // noop - already attacking
        return;
        if (this.disallowMoveAttackAnimation && $4d7afde9fb919e81$var$isWalkAnimation(this.action)) return;
        this.prevAction = this.action;
        this.activateAnimation(`${this.attackAction}-${this.facingDir}`);
    }
}


class $8d5e1ee7d468f782$export$6927fb12d9ccc2a extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(entityId, staticPose = false){
        super(), this.staticPose = staticPose, this.parts = [], this.getClickSurface = ()=>{
            return this.clickArea;
        }, this.rebuildLayers = (entity)=>{
            // A cached portrait owns a flattened image of the old layers and mask.
            this.cacheAsBitmap = false;
            const dimensions = (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.dimensions(entity);
            this.parts.forEach((part)=>{
                part.remove();
            });
            this.parts = [];
            const race = entity.appearance?.race;
            const sex = entity.appearance?.sex;
            const hair = entity.appearance?.hair;
            const nose = entity.appearance?.nose;
            const eyes = entity.appearance?.eyes;
            const weapon = (0, $f684496fff50a7a1$export$4c2157e8933c20e3)(entity.inventory, entity?.weapon?.weaponType)?.itemTypeMeta;
            const weaponAction = (0, $71594ae8b880a354$export$fed43fae8d163f04)(race, entity?.weapon?.weaponType);
            const armor = (0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "armor");
            const descriptors = (0, $71594ae8b880a354$export$efde97289773c11d)({
                body: {
                    race: race,
                    sex: sex,
                    color: entity.appearance.bodyColor
                },
                hair: hair ? {
                    component: hair,
                    color: entity.appearance.hairColor
                } : undefined,
                nose: nose ? {
                    component: nose,
                    color: entity.appearance.noseColor
                } : undefined,
                eyes: eyes ? {
                    component: eyes,
                    color: entity.appearance.eyesColor
                } : undefined,
                ///////
                weapon: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)(weapon),
                pants: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "pants")),
                shirt: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "shirt")),
                armor: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)(armor),
                shoes: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "shoes")),
                shield: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "shield")),
                cape: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "cape")),
                bauldron: (0, $1a2d6d21d6b0fac8$export$fd1c748ba2d511f1)((0, $f684496fff50a7a1$export$58361cde22f3aa43)(entity.inventory, "bauldron"))
            });
            const all = [];
            descriptors.body?.forEach((next)=>all.push(next));
            if ((0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.isHumanoid(race)) {
                descriptors.hair?.forEach((next)=>all.push(next));
                descriptors.nose?.forEach((next)=>all.push(next));
                descriptors.eyes?.forEach((next)=>all.push(next));
                descriptors.weapon?.forEach((next)=>all.push(next));
                descriptors.pants?.forEach((next)=>all.push(next));
                descriptors.shirt?.forEach((next)=>all.push(next));
                descriptors.armor?.forEach((next)=>all.push(next));
                descriptors.shoes?.forEach((next)=>all.push(next));
                descriptors.shield?.forEach((next)=>all.push(next));
                descriptors.cape?.forEach((next)=>all.push(next));
                descriptors.bauldron?.forEach((next)=>all.push(next));
            }
            all.sort((a, b)=>a.zIndex - b.zIndex).map((sheet)=>this.buildPart(weaponAction, entity.movement.angle, sheet)).forEach((sprite)=>{
                if (sprite.halo) this.haloObject = sprite.halo;
                this.addChild(sprite);
                this.parts.push(sprite);
            });
            if (this.clickArea.parent) this.clickArea.parent.removeChild(this.parentArea);
            this.clickArea.clear();
            this.clickArea.beginFill(0xff0000, 0.001);
            this.clickArea.drawRect(0, 0, dimensions.w, dimensions.h);
            this.clickArea.x = -dimensions.w / 2;
            this.clickArea.y = -dimensions.h / 2 + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.15;
            this.clickArea.endFill();
            this.addChild(this.clickArea);
        }, this.buildPart = (attackAction, angle, dollComponent)=>{
            if (!dollComponent) return;
            return new (0, $4d7afde9fb919e81$export$1a1b4f8679485f1c)({
                sheetId: `lpc/spritesheets/${dollComponent.entityId}.json`,
                attackAction: attackAction,
                angle: angle,
                hasHalo: this.halo && dollComponent.entityId.startsWith("body"),
                staticPose: this.staticPose
            });
        }, this.fragment = (entity)=>{
            this.parts.forEach((part)=>part.fragment(entity));
            this.drawableSurface.fragment(entity);
        }, this.onMouseOver = (show)=>{
            this.hud.onMouseOver(show);
        }, this.setWorldOverlayItem = (item)=>{
            this.worldOverlayItem = item;
            this.worldOverlayItem.addChild(this.hud);
        };
        this.entityId = entityId;
        this.clickArea = new (0, $a64b70167386625f$export$98e91636974d835d)();
        this.hud = new (0, $1d5c2742ca857d0e$export$5ef96c383b67a5e2)(0xffffff, {
            renderActions: {},
            alwaysShowLabel: false
        }, this.clickArea);
        this.drawableSurface = new (0, $a64b70167386625f$export$98e91636974d835d)();
    }
    isReadyToShow() {
        return this.parts.length > 0 && this.parts.every((part)=>part.isReadyToShow());
    }
    doMovement(entity) {
        this.parts.forEach((part)=>part.doMovement(entity));
        this.drawableSurface.doMovement(entity);
    }
    updateHaloColor(hp, hpMax) {
        const hpPct = hp / hpMax;
        if (hpPct < 0.7) {
            if (hpPct < 0.4) this.haloObject.tint = 0xff0000;
            else this.haloObject.tint = 0xffa500;
        } else this.haloObject.tint = 0x00ff00;
    }
    update(hp, hpMax) {
        this.hud.update(hp, hpMax);
        if (this.haloObject) this.updateHaloColor(hp, hpMax);
    }
    updateName(name) {
        this.hud.updateName(name);
    }
    recolor(color) {
        this.hud.recolor(color);
    }
    updateBlinking(blinking) {
        if (!blinking) {
            this.visible = true;
            if (this.blinkingInterval) {
                clearInterval(this.blinkingInterval);
                this.blinkingInterval = null;
                this.alpha = 1.0;
            }
        } else {
            if (this.blinkingInterval) return;
            let dir = -1;
            this.blinkingInterval = setInterval(()=>{
                this.alpha -= 0.1 * dir;
                if (this.alpha < 0.4 || this.alpha > 1.0) dir = -1 * dir;
            }, 25);
        }
    }
    addTag() {
        this.hud.addTag();
    }
    removeTag() {
        this.hud.removeTag();
    }
    updateLevel(level) {
        this.hud.updateLevel(level);
    }
    doAttack(entity) {
        this.parts.forEach((part)=>part.doAttack(entity));
    }
    doDamaged(entity) {
        this.parts.forEach((part)=>part.doDamaged(entity));
    }
    spoke(message, options) {
        this.hud.spoke(message, options);
    }
    releaseHeldSpeech() {
        this.hud.releaseHeldSpeech();
    }
    cleanup() {
        this.hud?.cleanup();
        this.parts.forEach((part)=>part.cleanup());
        clearInterval(this.blinkingInterval);
    }
    remove() {
        super.remove();
        this.destroy({
            children: true
        });
    }
    destroy(options) {
        this.cleanup();
        super.destroy(options);
    }
    getDrawableSurface() {
        return this.drawableSurface.getDrawableSurface();
    }
    updatePaperdoll(entity) {
        if (!entity) return;
        const { appearance: appearance } = entity;
        if (!appearance) return;
        this.rebuildLayers(entity);
    }
    updateHalo(entity, enabled) {
        this.halo = enabled;
        this.updatePaperdoll(entity);
        if (this.haloObject) this.updateHaloColor(entity.hp, entity.maxHp);
    }
    updateSpeed(factor) {
    //
    }
    updatePointerIcon(show, angle) {
        this.hud.updatePointerIcon(show, angle);
    }
    updateSigil(sigil) {
        this.hud.updateSigil(sigil);
    }
    updateRole(role) {
        this.hud.updateRole(role);
    }
}


const $a020ac28c1deebe7$export$8f1c0875ad4d8df = {
    x: 0,
    y: -10
};
const $a020ac28c1deebe7$export$67f117aa62ca3a78 = 1.9;
const $a020ac28c1deebe7$export$2b357f7e327c36fc = {
    x: -32,
    y: -32,
    width: 64,
    height: 64
};
const $a020ac28c1deebe7$export$d582f8b8f7e9c109 = 30;
/**
 * A baked body's first frame cut down to the figure on it, so a portrait measures as the figure and
 * not the empty frame round it (80-128px, by what it holds). One per baked body, shared as its
 * frames are; it goes when the baker lets the body go.
 */ const $a020ac28c1deebe7$var$figureCrops = new WeakMap();
const $a020ac28c1deebe7$var$figureTexture = (baked)=>{
    let crop = $a020ac28c1deebe7$var$figureCrops.get(baked);
    if (!crop) {
        const { x: x, y: y, width: width, height: height } = baked.drawn[0];
        crop = new (0, $klOfb.Texture)(baked.textures[0].baseTexture, new (0, $6qzqq.Rectangle)(x, y, width, height));
        $a020ac28c1deebe7$var$figureCrops.set(baked, crop);
    }
    return crop;
};
class $a020ac28c1deebe7$export$193f644bd4a561df extends (0, $8t5Gy.Container) {
    constructor(entityId, framing = "head", facing = "front"){
        super(), this.entityId = entityId, this.framing = framing, this.facing = facing, this.released = false, this.show = (baked)=>{
            if (!baked || this.released) return;
            this.sprite?.destroy();
            this.sprite = undefined;
            if (this.framing === "figure") {
                if (!baked.drawn[0].width) return;
                this.sprite = this.standInBox(new (0, $7Bs2Z.Sprite)($a020ac28c1deebe7$var$figureTexture(baked)), baked.drawn[0]);
            } else {
                const head = baked.joints[0].head;
                this.sprite = new (0, $7Bs2Z.Sprite)(baked.textures[0]);
                this.sprite.scale.set($a020ac28c1deebe7$export$67f117aa62ca3a78);
                this.sprite.position.set($a020ac28c1deebe7$export$8f1c0875ad4d8df.x - head.x * $a020ac28c1deebe7$export$67f117aa62ca3a78, $a020ac28c1deebe7$export$8f1c0875ad4d8df.y - head.y * $a020ac28c1deebe7$export$67f117aa62ca3a78);
            }
            this.addChild(this.sprite);
        }, this.standInBox = (figure, drawn)=>{
            const box = $a020ac28c1deebe7$export$2b357f7e327c36fc;
            const scale = Math.min(1, ($a020ac28c1deebe7$export$d582f8b8f7e9c109 - box.y) / drawn.height, box.width / drawn.width);
            figure.scale.set(scale);
            figure.position.set(Math.round(box.x + (box.width - drawn.width * scale) / 2), Math.round($a020ac28c1deebe7$export$d582f8b8f7e9c109 - drawn.height * scale));
            return figure;
        };
        if (framing === "figure") {
            // The frame bakes a few ticks later, but the screen measures its portrait now (to fit it
            // in a socket, or to lay out what follows): the box is there from the start, as LPC's is.
            const box = new (0, $gwPoJ.Graphics)();
            box.beginFill(0x000000, 0.001);
            box.drawRect($a020ac28c1deebe7$export$2b357f7e327c36fc.x, $a020ac28c1deebe7$export$2b357f7e327c36fc.y, $a020ac28c1deebe7$export$2b357f7e327c36fc.width, $a020ac28c1deebe7$export$2b357f7e327c36fc.height);
            box.endFill();
            this.addChild(box);
        }
    }
    updatePaperdoll(entity) {
        const name = (0, $3256700f2c0109f9$export$ee2b787377c030da)(entity?.appearance);
        if (!name) return;
        const equipment = (0, $2018397478b2b37f$export$fa328aa933695b7f)(entity);
        // Screens rebuild their portrait on every message and keystroke: a body baked already is
        // drawn at once, or it would blink out for a frame each time.
        const action = `idle-${this.facing}`;
        const baked = (0, $151224aeaaf7ea66$export$39dc63e37dec0a0e).peek(name, action, equipment);
        if (baked) {
            this.show(baked);
            return;
        }
        (0, $151224aeaaf7ea66$export$39dc63e37dec0a0e).request(name, action, true, this.show, ()=>this.released, equipment);
    }
    isReadyToShow() {
        return !!this.sprite && !this.released;
    }
    remove() {
        this.parent?.removeChild(this);
        this.destroy({
            children: true
        });
    }
    destroy(options) {
        // The frames are the baker's, shared with every sprite of this body: never the textures.
        this.released = true;
        super.destroy(typeof options === "object" ? {
            ...options,
            texture: false,
            baseTexture: false
        } : options);
    }
}
const $a020ac28c1deebe7$export$c4e1af01547f5776 = (entity, entityId, staticPose = false, framing = "head", facing = "front")=>{
    const portrait = (0, $3256700f2c0109f9$export$ee2b787377c030da)(entity?.appearance) ? new $a020ac28c1deebe7$export$193f644bd4a561df(entityId, framing, facing) : new (0, $8d5e1ee7d468f782$export$6927fb12d9ccc2a)(entityId, staticPose);
    portrait.updatePaperdoll(entity);
    return portrait;
};






class $16b4bf3d247fe459$export$6bed762da66f1ed6 extends (0, $ac2a97d45725bff5$export$f79759b47a91f0e7) {
    constructor(guiManager, logic){
        super(guiManager), this.race = "human", this.bodyColor = "white", this.sex = "male", this.previewAngle = Math.PI / 2, this.save = ()=>{
            const appearance = {
                race: this.race,
                bodyColor: this.bodyColor,
                sex: this.sex,
                hair: this.hair,
                hairColor: this.hairColor,
                nose: this.nose,
                noseColor: this.noseColor,
                eyes: this.eyes,
                eyesColor: this.eyesColor,
                inventoryAppearanceHash: this.entity.appearance.inventoryAppearanceHash
            };
            this.logic.saveAppearance(appearance);
            this.modal.close();
        }, this.createContent = ()=>{
            if (!this.entity) this.entity = this.guiManager.getPlayer();
            const main = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)({
                defaultTextFont: "ChatFont"
            });
            const spacer = ()=>{
                const spacer = new (0, $gwPoJ.Graphics)();
                spacer.x = 0;
                spacer.y = 0;
                spacer.drawRect(0, 0, 0, 10);
                return spacer;
            };
            const refresh = ()=>{
                if (this.nose && !(0, $bf6244e5cc9aa116$export$523e552deae170d8)[this.race] || (0, $bf6244e5cc9aa116$export$523e552deae170d8)[this.race]?.indexOf(this.nose) < 0) this.nose = (0, $bf6244e5cc9aa116$export$523e552deae170d8)[this.race] ? (0, $bf6244e5cc9aa116$export$523e552deae170d8)[this.race][0] : undefined;
                if (this.eyes && !(0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[this.race] || (0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[this.race]?.indexOf(this.eyes) < 0) this.eyes = (0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[this.race] ? (0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[this.race][0] : undefined;
                if (this.sex && !(0, $bf6244e5cc9aa116$export$1625117e6bf800e7)[this.race] || (0, $bf6244e5cc9aa116$export$1625117e6bf800e7)[this.race]?.indexOf(this.sex) < 0) this.sex = (0, $bf6244e5cc9aa116$export$1625117e6bf800e7)[this.race][0];
                this.entity.appearance.race = this.race;
                this.entity.appearance.bodyColor = this.bodyColor;
                this.entity.appearance.sex = this.sex;
                this.entity.appearance.hair = this.hair;
                this.entity.appearance.hairColor = this.hairColor;
                this.entity.appearance.nose = this.nose;
                this.entity.appearance.noseColor = this.noseColor;
                this.entity.appearance.eyes = this.eyes;
                this.entity.appearance.eyesColor = this.eyesColor;
                this.update();
            };
            const printControl = (title, range, t, setter, suppressNone)=>{
                const previous = (range, t, setter)=>{
                    let idx = range.indexOf(t) - 1;
                    if (idx < 0) idx = range.length - 1;
                    setter(range[idx]);
                    refresh();
                };
                const next = (range, t, setter)=>{
                    let idx = range.indexOf(t) + 1;
                    if (idx > range.length - 1) idx = 0;
                    setter(range[idx]);
                    refresh();
                };
                main.append(`${title}: ` + (t || " - none - "));
                main.append("Previous", false, undefined, undefined, undefined, "button", ()=>{
                    previous(range, t, setter);
                });
                main.append(" ", true);
                main.append("Next", true, undefined, undefined, undefined, "button", ()=>{
                    next(range, t, setter);
                });
                if (!suppressNone) {
                    main.append(" ", true);
                    main.append("None", true, undefined, undefined, undefined, "button", ()=>{
                        setter(undefined);
                        refresh();
                    });
                }
                main.append(spacer());
            };
            main.append("Randomize", true, undefined, undefined, undefined, "button", ()=>{
                const { race: race, bodyColor: bodyColor, sex: sex, hair: hair, hairColor: hairColor, nose: nose, noseColor: noseColor, eyes: eyes, eyesColor: eyesColor } = (0, $1a2d6d21d6b0fac8$export$b7be1ee14f302b62)();
                this.race = race;
                this.bodyColor = bodyColor;
                this.sex = sex;
                this.hair = hair;
                this.hairColor = hairColor;
                this.nose = nose;
                this.noseColor = noseColor;
                this.eyes = eyes;
                this.eyesColor = eyesColor;
                refresh();
            });
            main.append(" ", true);
            main.append("Save", true, undefined, undefined, undefined, "button", ()=>{
                this.save();
            });
            main.append(spacer());
            main.append(spacer());
            // race
            printControl("Race", (0, $bf6244e5cc9aa116$export$46125ee88f7f0638), this.race, (t)=>this.race = t, true);
            // bodyColor
            printControl("Body Color", (0, $bf6244e5cc9aa116$export$af1b56af8a451d06)[this.race], this.bodyColor, (t)=>this.bodyColor = t, true);
            // sex
            printControl("Sex", (0, $bf6244e5cc9aa116$export$1625117e6bf800e7)[this.race], this.sex, (t)=>this.sex = t, true);
            // hair
            printControl("Hair", (0, $bf6244e5cc9aa116$export$abac18ec637a6d99), this.hair, (t)=>this.hair = t);
            if (this.hair) // hair color
            printControl("Hair Color", (0, $bf6244e5cc9aa116$export$c2ef2c5bddebe408)[this.hair], this.hairColor, (t)=>this.hairColor = t);
            if ((0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[this.race]?.length > 0) {
                // Eyes
                printControl("Eyes", (0, $bf6244e5cc9aa116$export$4f6565fe06691e22)[this.race], this.eyes, (t)=>this.eyes = t);
                if (this.eyes) printControl("Eyes Color", (0, $bf6244e5cc9aa116$export$ffaabf2abfa69206)[this.eyes], this.eyesColor, (t)=>this.eyesColor = t);
            }
            if ((0, $bf6244e5cc9aa116$export$523e552deae170d8)[this.race]?.length > 0) {
                // Nose
                printControl("Nose", (0, $bf6244e5cc9aa116$export$523e552deae170d8)[this.race], this.nose, (t)=>this.nose = t);
                if (this.nose) printControl("Nose Color", (0, $bf6244e5cc9aa116$export$f5fdec393d34621)[this.nose], this.noseColor, (t)=>this.noseColor = t);
            }
            // The body the world will draw: an Ember one where the look has one, else LPC's paperdoll.
            const preview = Object.assign(new (0, $cb689cfa16c444ba$export$bc644a473284d944)(), this.entity, {
                movement: {
                    ...this.entity.movement,
                    angle: this.previewAngle,
                    moving: false
                }
            });
            const portrait = (0, $a020ac28c1deebe7$export$c4e1af01547f5776)(preview, "", false, "figure", (0, $a80d0b17b615d6f7$export$5ebc7cf9991d3d13)(this.previewAngle));
            portrait.scale.set(4);
            portrait.x = this.width() - 150;
            portrait.y = 250;
            if (portrait instanceof (0, $8d5e1ee7d468f782$export$6927fb12d9ccc2a)) portrait.doMovement(preview);
            main.addChild(portrait);
            const rotation = new (0, $e0fb6921b9eca6b1$export$8b1e7a6f6a26652e)((step)=>{
                this.previewAngle = (this.previewAngle + step * Math.PI / 2 + Math.PI * 2) % (Math.PI * 2);
                // Finish dispatching the button event before replacing its content.
                setTimeout(()=>this.isOpen() && this.update(), 0);
            });
            rotation.x = portrait.x - rotation.boxWidth / 2;
            rotation.y = portrait.y + 140;
            main.addChild(rotation);
            return main;
        };
        this.logic = logic;
    }
}


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");


const $bde0eb94ead9038f$export$72ee0c7a4855a274 = 320;
const $bde0eb94ead9038f$export$440d7b56d7e79537 = 8;
const $bde0eb94ead9038f$export$4f4624f448d7f7d8 = 9;
const $bde0eb94ead9038f$export$4dcefa986f9ebefe = 6;
const $bde0eb94ead9038f$export$35cf6b4f538836cd = 0x1b1512;
const $bde0eb94ead9038f$export$a3946689840d08dd = 0.84;
const $bde0eb94ead9038f$export$5eb57294d7a01ff = 0.93;
const $bde0eb94ead9038f$export$a9fed83f1c193f7e = 0x000000;
const $bde0eb94ead9038f$export$7fb3621e17d8a3da = 0.3;
const $bde0eb94ead9038f$export$ba288e268a12646c = 2;
const $bde0eb94ead9038f$export$13a6d78198248670 = 0x6b4f38;
const $bde0eb94ead9038f$export$542c8a566b36979 = 0xf2a94e;
const $bde0eb94ead9038f$export$516f68680b50dca1 = 0xfff3e0;
const $bde0eb94ead9038f$export$4a863a35dfd357dc = 0xf2a94e;
const $bde0eb94ead9038f$export$1f7cbc51fe7009c3 = 0xf2c879;
const $bde0eb94ead9038f$export$dc58655d5df465a7 = 0xf2c879;
const $bde0eb94ead9038f$export$ddc55e6671963e97 = 0xe8745a;
const $bde0eb94ead9038f$export$4e71f896fa269c0a = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).compactCaption.fontSize;
const $bde0eb94ead9038f$export$d02b3fe546d6073a = 3;
const $bde0eb94ead9038f$export$ec0e4eff17ebd09e = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).caption.fontSize;
const $bde0eb94ead9038f$export$c1e8972bf2d4e8dc = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).compactCaption.fontSize;
const $bde0eb94ead9038f$export$251eac38a164bee4 = 22;
const $bde0eb94ead9038f$export$ae76bdcbbb40538 = 6;
const $bde0eb94ead9038f$export$b305389aaeaa7609 = 0.5;
const $bde0eb94ead9038f$export$baa08eb4811faa03 = 0xffd27f;
// Everyone else. Warm-leaning so they sit with the panel, but far enough apart in hue that two
// speakers in the same conversation never read as the same person.
const $bde0eb94ead9038f$var$SPEAKER_COLORS = [
    0x8fc9f0,
    0x9fe08f,
    0xf0a6c8,
    0xc4b3f0,
    0x7fe0d4,
    0xf0b27a,
    0xd6d66b,
    0xe39393
];
const $bde0eb94ead9038f$export$180c07c2129a34ac = (name, isSelf)=>{
    if (isSelf) return $bde0eb94ead9038f$export$baa08eb4811faa03;
    let hash = 5381;
    for(let i = 0; i < name.length; i++)hash = (hash << 5) + hash + name.charCodeAt(i) >>> 0;
    return $bde0eb94ead9038f$var$SPEAKER_COLORS[hash % $bde0eb94ead9038f$var$SPEAKER_COLORS.length];
};


// How much of a row's width the speaker's name may take before it is given its own line. Past
// this, the hanging indent leaves the message in a gutter too narrow to read.
const $030df650e8220c82$var$MAX_NAME_SHARE = 0.45;
// Air between the name and the message that follows it on the same line.
const $030df650e8220c82$var$NAME_GAP = 5;
// Used only where a Text measures as zero (a headless/mocked canvas), so the panel can never
// collapse into a sliver with every line drawn on top of the last.
const $030df650e8220c82$var$FALLBACK_LINE_H = (0, $bde0eb94ead9038f$export$4e71f896fa269c0a) + 3;
class $030df650e8220c82$export$23974c6ecceedade extends (0, $8t5Gy.Container) {
    constructor(pos){
        super(), // Which edge `pos` is. "bottom" is the ambient home above the chat input; "top" is docked under
        // the composer, where the log has to grow DOWNWARD or its oldest lines would climb over the
        // panel the player is typing into.
        this.anchor = "bottom", // The height the panel was last drawn at, so a re-anchor can reposition without rebuilding
        // every row.
        this.lastHeight = 0, // The row built for each entry currently on screen, so an arriving line costs one row rather
        // than a whole log's worth of text rasterization.
        this.rowCache = new Map(), this.hide = ()=>{
            this.visible = false;
        }, this.show = ()=>{
            this.visible = true;
        }, // Entries oldest-first; the newest is drawn at the bottom, nearest the input.
        this.updateEntries = (entries)=>{
            const shown = entries.filter((entry)=>!!entry.text);
            if (shown.length === 0) {
                this.clearRows();
                this.shadow.clear();
                this.panel.clear();
                return;
            }
            // The log is append-only: every call but the first adds ONE line and drops at most one off
            // the top. Rebuilding all of it would re-rasterize a dozen Texts in the frame a message
            // lands in, which on an integrated GPU is a visible hitch for nothing (see the budget
            // hardware target), so rows are kept and looked up by the entry they were built from.
            const kept = new Map();
            let y = 0;
            shown.forEach((entry, index)=>{
                const row = this.rowCache.get(entry) || this.buildRow(entry);
                kept.set(entry, row);
                row.y = y;
                // Recency as opacity: full strength for the newest line, fading back through the ones
                // the player has probably already read.
                row.alpha = shown.length === 1 ? 1 : (0, $bde0eb94ead9038f$export$b305389aaeaa7609) + (1 - (0, $bde0eb94ead9038f$export$b305389aaeaa7609)) * index / (shown.length - 1);
                if (row.parent !== this.rows) this.rows.addChild(row);
                y += Math.max(row.height || $030df650e8220c82$var$FALLBACK_LINE_H, $030df650e8220c82$var$FALLBACK_LINE_H) + (0, $bde0eb94ead9038f$export$d02b3fe546d6073a);
            });
            this.rowCache.forEach((row, entry)=>{
                if (!kept.has(entry)) {
                    this.rows.removeChild(row);
                    row.destroy({
                        children: true
                    });
                }
            });
            this.rowCache = kept;
            const height = Math.round(y - (0, $bde0eb94ead9038f$export$d02b3fe546d6073a) + (0, $bde0eb94ead9038f$export$4dcefa986f9ebefe) * 2);
            this.draw(height);
            this.lastHeight = height;
            this.reposition();
        }, // Hang the panel off `pos` as `anchor` says. Called on every update, and again whenever the log
        // changes home, which is what keeps a docked log from growing up over the composer as lines
        // arrive.
        this.setAnchor = (anchor, pos)=>{
            this.anchor = anchor;
            this.pos = pos;
            this.reposition();
        }, this.reposition = ()=>{
            this.y = this.anchor === "top" ? this.pos : this.pos - this.lastHeight;
        }, // One line: the speaker's name, then the message in a column beside it, wrapped to whatever
        // width that leaves.
        this.buildRow = (entry)=>{
            const inner = (0, $bde0eb94ead9038f$export$72ee0c7a4855a274) - (0, $bde0eb94ead9038f$export$4f4624f448d7f7d8) * 2;
            const row = new (0, $8t5Gy.Container)();
            let bodyX = 0;
            let bodyY = 0;
            if (entry.speaker) {
                const name = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize((0, $bde0eb94ead9038f$export$4e71f896fa269c0a)).color((0, $bde0eb94ead9038f$export$180c07c2129a34ac)(entry.speaker, entry.self)).bold().strokeThickness(0).render(entry.speaker);
                row.addChild(name);
                const nameWidth = name.width || entry.speaker.length * ((0, $bde0eb94ead9038f$export$4e71f896fa269c0a) * 0.6);
                if (nameWidth + $030df650e8220c82$var$NAME_GAP <= inner * $030df650e8220c82$var$MAX_NAME_SHARE) bodyX = nameWidth + $030df650e8220c82$var$NAME_GAP;
                else // A long name takes the line to itself and the message wraps full width under it,
                // rather than being squeezed into what is left.
                bodyY = (name.height || $030df650e8220c82$var$FALLBACK_LINE_H) + 1;
            }
            const body = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize((0, $bde0eb94ead9038f$export$4e71f896fa269c0a)).color((0, $bde0eb94ead9038f$export$516f68680b50dca1)).strokeThickness(0).wordWrap(Math.max(40, inner - bodyX)).render(entry.text);
            body.x = bodyX;
            body.y = bodyY;
            row.addChild(body);
            return row;
        }, this.draw = (height)=>{
            this.shadow.clear();
            this.shadow.beginFill((0, $bde0eb94ead9038f$export$a9fed83f1c193f7e), (0, $bde0eb94ead9038f$export$7fb3621e17d8a3da));
            this.shadow.drawRoundedRect((0, $bde0eb94ead9038f$export$ba288e268a12646c), (0, $bde0eb94ead9038f$export$ba288e268a12646c), (0, $bde0eb94ead9038f$export$72ee0c7a4855a274), height, (0, $bde0eb94ead9038f$export$440d7b56d7e79537));
            this.shadow.endFill();
            this.panel.clear();
            this.panel.lineStyle({
                width: 1,
                color: (0, $bde0eb94ead9038f$export$13a6d78198248670),
                alpha: 0.45,
                join: (0, $gwPoJ.LINE_JOIN).ROUND
            });
            this.panel.beginFill((0, $bde0eb94ead9038f$export$35cf6b4f538836cd), (0, $bde0eb94ead9038f$export$a3946689840d08dd));
            this.panel.drawRoundedRect(0, 0, (0, $bde0eb94ead9038f$export$72ee0c7a4855a274), height, (0, $bde0eb94ead9038f$export$440d7b56d7e79537));
            this.panel.endFill();
        }, this.clearRows = ()=>{
            this.rows.removeChildren().forEach((child)=>child.destroy({
                    children: true
                }));
            this.rowCache = new Map();
        };
        this.pos = pos;
        this.shadow = new (0, $gwPoJ.Graphics)();
        this.panel = new (0, $gwPoJ.Graphics)();
        this.rows = new (0, $8t5Gy.Container)();
        this.rows.x = (0, $bde0eb94ead9038f$export$4f4624f448d7f7d8);
        this.rows.y = (0, $bde0eb94ead9038f$export$4dcefa986f9ebefe);
        this.addChild(this.shadow);
        this.addChild(this.panel);
        this.addChild(this.rows);
    }
}
// "Bryn: the fire is low" -> { speaker: "Bryn", text: "the fire is low" }, so a caller that still
// hands over one formatted line gets a coloured name like everyone else. A colon far into the line
// is punctuation in somebody's sentence, not a speaker, so only a short leading one counts.
const $030df650e8220c82$var$MAX_PARSED_NAME = 24;
const $030df650e8220c82$export$1efc33041612526 = (line)=>{
    const at = line.indexOf(": ");
    if (at <= 0 || at > $030df650e8220c82$var$MAX_PARSED_NAME) return {
        text: line
    };
    return {
        speaker: line.slice(0, at),
        text: line.slice(at + 2)
    };
};


// The chat line as DATA: the text, where the caret is in it, and what each edit does to both.
//
// It lives apart from the widget that draws it (gui/typing.ts) and from the manager that feeds it
// keystrokes (gui_manager) because this is the part with all the edge cases -- a caret in the
// middle of the line, word-wise deletion, pasted text that has to fit under the length cap, a
// history walk that must not eat the half-written line it was started from -- and all of them can
// then be tested without a renderer (gui/__tests__/chat_input_model.test.ts).
//
// Every function here is PURE: it returns a new state and never touches the one it was given.
const $2bc3e70fbff7f064$export$4779cfd32b998f47 = 150;
const $2bc3e70fbff7f064$export$d42b23612a605795 = {
    value: "",
    caret: 0
};
const $2bc3e70fbff7f064$var$clampCaret = (value, caret)=>Math.max(0, Math.min(value.length, caret));
const $2bc3e70fbff7f064$export$1a6beb1cd8a8be2e = (value, caret)=>({
        value: value,
        caret: $2bc3e70fbff7f064$var$clampCaret(value, caret === undefined ? value.length : caret)
    });
// Pasted text arrives from the OS and can be anything: several lines, tabs, a stray control
// character from a terminal copy. Chat is one line, so newlines and tabs become single spaces
// rather than being dropped (dropping them glues the last word of one line to the first of the
// next) and other control characters go.
const $2bc3e70fbff7f064$var$CONTROL_CHARS = new RegExp("[\\u0000-\\u001f\\u007f]", "g");
const $2bc3e70fbff7f064$var$LINE_BREAKS = new RegExp("[\\r\\n\\t\\v\\f]+", "g");
const $2bc3e70fbff7f064$export$bdade7163ff3b5d5 = (text)=>text.replace($2bc3e70fbff7f064$var$LINE_BREAKS, " ").replace($2bc3e70fbff7f064$var$CONTROL_CHARS, "");
const $2bc3e70fbff7f064$export$78ba03e296d6b5ac = (state, text, maxLength = $2bc3e70fbff7f064$export$4779cfd32b998f47)=>{
    const clean = $2bc3e70fbff7f064$export$bdade7163ff3b5d5(text);
    if (!clean) return state;
    // Truncate the INSERTION rather than the result, so pasting a wall of text into the middle of
    // a line keeps what is already there instead of cutting the tail off it.
    const room = Math.max(0, maxLength - state.value.length);
    const fitted = clean.slice(0, room);
    if (!fitted) return state;
    return {
        value: state.value.slice(0, state.caret) + fitted + state.value.slice(state.caret),
        caret: state.caret + fitted.length
    };
};
// Start of the word before `index`: skip any run of spaces, then the run of non-spaces. Matches
// what Alt/Ctrl+Backspace does in a terminal and in a browser text field.
const $2bc3e70fbff7f064$var$wordStart = (value, index)=>{
    let i = index;
    while(i > 0 && value[i - 1] === " ")i--;
    while(i > 0 && value[i - 1] !== " ")i--;
    return i;
};
const $2bc3e70fbff7f064$var$wordEnd = (value, index)=>{
    let i = index;
    while(i < value.length && value[i] === " ")i++;
    while(i < value.length && value[i] !== " ")i++;
    return i;
};
const $2bc3e70fbff7f064$export$f2323afd0aa0bdea = (state, scope = "char")=>{
    if (state.caret === 0) return state;
    const from = scope === "line" ? 0 : scope === "word" ? $2bc3e70fbff7f064$var$wordStart(state.value, state.caret) : state.caret - 1;
    return {
        value: state.value.slice(0, from) + state.value.slice(state.caret),
        caret: from
    };
};
// Forward word-delete also swallows the gap it leaves behind -- deleting "the" out of "feed the
// fire" has to give back "feed fire", not "feed  fire".
const $2bc3e70fbff7f064$var$wordEndWithGap = (value, index)=>{
    let i = $2bc3e70fbff7f064$var$wordEnd(value, index);
    while(i < value.length && value[i] === " ")i++;
    return i;
};
const $2bc3e70fbff7f064$export$948b9f836237b4b4 = (state, scope = "char")=>{
    if (state.caret >= state.value.length) return state;
    const to = scope === "line" ? state.value.length : scope === "word" ? $2bc3e70fbff7f064$var$wordEndWithGap(state.value, state.caret) : state.caret + 1;
    return {
        value: state.value.slice(0, state.caret) + state.value.slice(to),
        caret: state.caret
    };
};
const $2bc3e70fbff7f064$export$f98ff0c9f6637db1 = (state, target, byWord = false)=>{
    switch(target){
        case "home":
            return {
                ...state,
                caret: 0
            };
        case "end":
            return {
                ...state,
                caret: state.value.length
            };
        case "left":
            return {
                ...state,
                caret: byWord ? $2bc3e70fbff7f064$var$wordStart(state.value, state.caret) : Math.max(0, state.caret - 1)
            };
        case "right":
            return {
                ...state,
                caret: byWord ? $2bc3e70fbff7f064$var$wordEnd(state.value, state.caret) : Math.min(state.value.length, state.caret + 1)
            };
    }
};
const $2bc3e70fbff7f064$export$2cd8bbcbf799240 = {
    entries: [],
    index: -1,
    draft: ""
};
const $2bc3e70fbff7f064$export$7f903ac43047fe20 = (walk, current)=>{
    if (walk.entries.length === 0) return {
        walk: walk,
        input: current
    };
    if (walk.index === -1) {
        const index = walk.entries.length - 1;
        return {
            walk: {
                ...walk,
                index: index,
                draft: current.value
            },
            input: $2bc3e70fbff7f064$export$1a6beb1cd8a8be2e(walk.entries[index])
        };
    }
    const index = Math.max(0, walk.index - 1);
    return {
        walk: {
            ...walk,
            index: index
        },
        input: $2bc3e70fbff7f064$export$1a6beb1cd8a8be2e(walk.entries[index])
    };
};
const $2bc3e70fbff7f064$export$2957600c134d4b7e = (walk, current)=>{
    if (walk.index === -1) return {
        walk: walk,
        input: current
    };
    if (walk.index >= walk.entries.length - 1) // Off the recent end: back to whatever was being written when the walk started.
    return {
        walk: {
            ...walk,
            index: -1,
            draft: ""
        },
        input: $2bc3e70fbff7f064$export$1a6beb1cd8a8be2e(walk.draft)
    };
    const index = walk.index + 1;
    return {
        walk: {
            ...walk,
            index: index
        },
        input: $2bc3e70fbff7f064$export$1a6beb1cd8a8be2e(walk.entries[index])
    };
};
const $2bc3e70fbff7f064$export$2051cccf06572bb3 = 50;
const $2bc3e70fbff7f064$export$8981372ce0f88573 = (walk, message)=>{
    if (!message) return {
        ...walk,
        index: -1,
        draft: ""
    };
    const last = walk.entries[walk.entries.length - 1];
    const entries = last === message ? walk.entries : [
        ...walk.entries,
        message
    ].slice(-$2bc3e70fbff7f064$export$2051cccf06572bb3);
    return {
        entries: entries,
        index: -1,
        draft: ""
    };
};



// The state machine behind the `important` strip: which notice is showing, and for how long.
//
// Kept free of PIXI (like roster_speech_lane.ts, whose rules these are modelled on) so the timing
// can be unit-tested without a renderer; important_message.ts owns the drawing and just asks this
// what to show.
//
// WHY THERE IS A QUEUE AT ALL. The strip is one slot, and before this it was last-write-wins:
// `ImportantMessage.update` tore down the in-flight fade and drew the new line over it. Several
// ember beats land on the same wave boundary by construction, so specific sentences were being
// destroyed on a fixed timer:
//
//   * the bonecaller reveal asks for 6000ms and `VICTORY` lands 2500ms later (VICTORY_DELAY_MS),
//   * the rescue's "You hear a cry for help!" asks for 3000ms, same 2500ms wipe,
//   * and `WAVE n` is posted by AssaultDirector.onWaveLanded one statement BEFORE the encounter
//     callbacks it then invokes, so the wave-8 banner and "Eight armored skeletons are rising"
//     collide every time.
//
// The encounter's line is always the one the player has not seen before, and it was always the one
// at risk. So nothing is replaced any more: a notice waits its turn, and every notice gets at least
// its tier's floor on screen.
//
// WHY THERE ARE TIERS. Twelve ember call sites all passed `"important"`, which made a deadline and
// a receipt the same object in the same slot -- so "Provisions have been left by the fire." could
// delay "Stop the caller before the next assault." An alert outranks a notice in the queue and gets
// a longer floor and warmer colour; see TIER_FLOOR_MS and important_message.ts.
const $02082475a2de3c51$export$acaf6dea90bd8a67 = {
    alert: 2200,
    notice: 1300
};
const $02082475a2de3c51$export$913c89712479719f = 6500;
const $02082475a2de3c51$export$354f03de0bec5c37 = 3;
const $02082475a2de3c51$export$e7230c56a661fdfb = 1500;
const $02082475a2de3c51$export$c9acf6a45900baef = 220;
const $02082475a2de3c51$var$RANK = {
    alert: 1,
    notice: 0
};
/** Reading time when the sender named no duration: the strip's own long-standing rule. */ const $02082475a2de3c51$var$wordClock = (text)=>Math.max(1500, text.split(" ").length * 300);
const $02082475a2de3c51$export$505ac917808ea098 = (notice)=>Math.min($02082475a2de3c51$export$913c89712479719f, Math.max($02082475a2de3c51$export$acaf6dea90bd8a67[notice.tier], notice.durationMs || $02082475a2de3c51$var$wordClock(notice.text)));
class $02082475a2de3c51$export$fa8855d9633ae2f7 {
    constructor(){
        this.queue = [];
        this.showing = null;
        this.elapsedMs = 0;
        // Time left in the gap between two notices; see HANDOVER_MS.
        this.gapMs = 0;
        // Raised whenever `showing` becomes a different notice (or nothing), so the renderer can be
        // driven off a change rather than re-drawing the same line every frame.
        this.dirty = false;
        /** What the strip should be showing, or null for an empty lane. */ this.current = ()=>this.showing;
        this.queueLength = ()=>this.queue.length;
        /** True once per change of `current()`; reading it clears it. */ this.takeChange = ()=>{
            const changed = this.dirty;
            this.dirty = false;
            return changed;
        };
        /**
     * Offer a notice.
     *
     * A repeat of the line already showing REFRESHES it instead of queueing behind itself: the same
     * text arriving twice is a duplicate (a resumed wave re-announcing itself), not two things to
     * read. A repeat of something already waiting is dropped for the same reason.
     */ this.push = (notice)=>{
            if (!notice.text) return;
            if (this.showing?.text === notice.text && this.showing.tier === notice.tier) {
                this.elapsedMs = 0;
                return;
            }
            if (this.queue.some((q)=>q.text === notice.text && q.tier === notice.tier)) return;
            this.queue.push(notice);
            this.trim();
            // Nothing is showing and nothing is handing over, so take the slot on this call rather than
            // on the next frame: a lone notice should not wait for a tick to appear.
            if (!this.showing && this.gapMs <= 0) this.promote();
        };
        this.update = (dtMs)=>{
            if (dtMs >= $02082475a2de3c51$export$e7230c56a661fdfb) {
                this.clear();
                return;
            }
            if (this.showing) {
                this.elapsedMs += dtMs;
                const floor = $02082475a2de3c51$export$acaf6dea90bd8a67[this.showing.tier];
                // Its own time is up; or it has been readable for long enough and somebody waiting
                // MATCHES OR BEATS its rank.
                //
                // That rank test is the whole point, and a bare "somebody is waiting" quietly undid the
                // fix: it yields at the floor to anything at all, so `VICTORY` arriving 2500ms into the
                // bonecaller reveal took the slot at the alert's 2200ms floor, and the reveal lost three
                // and a half of its six seconds to the one message it was being protected from. A notice
                // now waits out an alert in full. Equal rank still yields, which is what drains a burst
                // of wave banners rather than queueing them up behind each other's full holds.
                const waiting = this.bestWaiting();
                const yields = waiting !== undefined && $02082475a2de3c51$var$RANK[waiting] >= $02082475a2de3c51$var$RANK[this.showing.tier];
                if (this.elapsedMs >= $02082475a2de3c51$export$505ac917808ea098(this.showing) || this.elapsedMs >= floor && yields) {
                    this.showing = null;
                    this.elapsedMs = 0;
                    this.dirty = true;
                    this.gapMs = this.queue.length > 0 ? $02082475a2de3c51$export$c9acf6a45900baef : 0;
                }
                return;
            }
            if (this.gapMs > 0) {
                this.gapMs = Math.max(0, this.gapMs - dtMs);
                if (this.gapMs > 0) return;
            }
            this.promote();
        };
        /** Drop everything, showing and waiting. Used on a room change and on a stale frame. */ this.clear = ()=>{
            this.queue = [];
            if (this.showing) this.dirty = true;
            this.showing = null;
            this.elapsedMs = 0;
            this.gapMs = 0;
        };
        /** Highest rank first, oldest first within a rank -- so an alert jumps a queue of notices. */ this.promote = ()=>{
            const pick = this.nextIndex();
            if (pick < 0) return;
            this.showing = this.queue.splice(pick, 1)[0];
            this.elapsedMs = 0;
            this.dirty = true;
        };
        /** The tier of whatever would take the slot next, or undefined with nothing waiting. */ this.bestWaiting = ()=>{
            const pick = this.nextIndex();
            return pick < 0 ? undefined : this.queue[pick].tier;
        };
        this.nextIndex = ()=>{
            if (this.queue.length < 1) return -1;
            let pick = 0;
            for(let i = 1; i < this.queue.length; i++)if ($02082475a2de3c51$var$RANK[this.queue[i].tier] > $02082475a2de3c51$var$RANK[this.queue[pick].tier]) pick = i;
            return pick;
        };
        this.trim = ()=>{
            while(this.queue.length > $02082475a2de3c51$export$354f03de0bec5c37){
                const oldestNotice = this.queue.findIndex((q)=>q.tier === "notice");
                // All alerts: drop the oldest of those rather than growing without bound.
                this.queue.splice(oldestNotice < 0 ? 0 : oldestNotice, 1);
            }
        };
    }
}


/**
 * The ritual always rises on wave 8 (BonecallerLifecycle.waveLanded), which is why the deadline can
 * be stated rather than counted. The minimap label says the same thing in the same words.
 */ const $7774c82afd18c45a$var$RITUAL_WAVE = 8;
const $7774c82afd18c45a$export$a2e29269a0cfdd47 = (state)=>{
    if (!state) return [];
    const obligations = [];
    const rescue = state.rescue;
    if (rescue) {
        // Only the three live states exist on the wire: the marker itself is dropped once she is
        // admitted (the swap to ember-recruit.js replaces flags wholesale, so `isSurvivor` goes with
        // it) or once she is dead. So there is no terminal state to filter out here.
        const danger = rescue.state === "In danger";
        obligations.push({
            key: "rescue",
            icon: "\uD83C\uDD98",
            label: "Survivor at the wreck",
            detail: rescue.state === "Following" ? "escorting her to the fire" : danger ? "under attack \u2014 drive them off" : "waiting for a hand up",
            tone: danger ? "alert" : "steady",
            signature: `rescue:${rescue.state}`
        });
    }
    const ritual = state.bonecaller;
    if (ritual && ritual.state === "active") obligations.push({
        key: "bonecaller",
        icon: "\uD83E\uDE78",
        label: "Bonecaller",
        detail: `stage ${ritual.stage} of 3 \xb7 rises on wave ${$7774c82afd18c45a$var$RITUAL_WAVE}`,
        // `warned` is set when the wave-8 countdown starts, which is the last moment the player
        // can still leave and stop it. That is the one point where this stops being a standing
        // fact and becomes something to act on now.
        tone: ritual.warned ? "alert" : "steady",
        signature: `ritual:${ritual.stage}:${ritual.warned}`
    });
    if (state.mine && !state.mine.explored) obligations.push({
        key: "mine",
        icon: "\u26CF",
        label: "Explore mine",
        detail: "a recruit found a cave \xb7 marked on your map",
        tone: "steady",
        signature: "mine:unexplored"
    });
    return obligations;
};
class $7774c82afd18c45a$export$c0db793bbc4500e2 {
    constructor(){
        this.dismissed = new Map();
        this.dismiss = (obligation)=>this.dismissed.set(obligation.key, obligation.signature);
        this.visible = (obligations)=>obligations.filter((o)=>this.dismissed.get(o.key) !== o.signature);
        /** A new run, or a new room: nothing carried over has anything to say about this camp. */ this.reset = ()=>this.dismissed.clear();
    }
}


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");



/**
 * The camp's standing tasks: one row per live obligation, top-left, for as long as it is true.
 *
 * The counterpart to the `important` strip rather than a replacement for it. The strip says what
 * CHANGED and then leaves; this says what is still TRUE, so a player who was placing walls when the
 * ritual was revealed can still find out that it is running, and a player who was told once a minute
 * ago does not have to have remembered.
 *
 * TWO WAYS OUT, which is the whole reason this can be allowed to persist at all. A permanent HUD
 * panel that the player cannot get rid of is just more of the clutter it was built to cut:
 *
 *   * Each row's x DISMISSES that row until what it says changes (see Obligation.signature). It is
 *     "I have read this", not "never again" -- the ritual lighting its third stone, or the survivor
 *     coming under attack, brings the row straight back. So a dismissal can never hide news.
 *   * The header COLLAPSES the stack to a single pill carrying the count, and that choice is
 *     remembered across sessions like the minimap's. It never collapses to nothing: a player who has
 *     hidden two tasks can still see that there are two, and in what tone.
 *
 * Drawn only on a change (`paintKey`), so a settled camp pays nothing per frame. There is no
 * animation here on purpose -- a standing fact that pulses is an alarm, and the alert tone plus the
 * strip's own alert tier are already doing that job.
 */ const $0b9b8914648f9fea$var$THEME = (0, $97475243e21a0995$export$b1586623fe466c29).ember;
/**
 * OPAQUE, not a translucent HUD plate.
 *
 * Everything else that floats over the world here is see-through, and this is the one thing that
 * must not be: it sits in the top band that the `important` strip crosses, so a translucent panel
 * put the camp's standing tasks and a transient notice about something else in the same pixels and
 * neither could be read. It is also the one panel that is up for minutes at a time rather than
 * seconds, which is exactly the case where legibility beats seeing the grass behind it.
 */ const $0b9b8914648f9fea$var$PANEL_FILL = 0x12100d;
const $0b9b8914648f9fea$var$PANEL_ALPHA = 1;
const $0b9b8914648f9fea$var$PANEL_ALPHA_HOVER = 1;
/** Hover lifts the FILL rather than the alpha, which has nowhere left to go. */ const $0b9b8914648f9fea$var$PANEL_FILL_HOVER = 0x1f1a14;
const $0b9b8914648f9fea$var$CORNER = 6;
const $0b9b8914648f9fea$var$PAD_X = 8;
const $0b9b8914648f9fea$var$PAD_Y = 6;
const $0b9b8914648f9fea$var$ROW_GAP = 4;
/** The coloured spine down the left of a row: the only thing that carries tone at a glance. */ const $0b9b8914648f9fea$var$SPINE_W = 2.5;
const $0b9b8914648f9fea$var$SPINE_GAP = 6;
/** Width of the whole panel. Fixed, so a detail changing length cannot make the stack twitch. */ const $0b9b8914648f9fea$var$WIDTH = 206;
const $0b9b8914648f9fea$var$TOUCH_WIDTH = 240;
class $0b9b8914648f9fea$export$3f0a40c1e1665750 extends (0, $8t5Gy.Container) {
    constructor(onDismiss, onToggleCollapsed){
        super(), this.onDismiss = onDismiss, this.onToggleCollapsed = onToggleCollapsed, this.header = new (0, $8t5Gy.Container)(), this.headerPlate = new (0, $gwPoJ.Graphics)(), this.rowsLayer = new (0, $8t5Gy.Container)(), this.rows = [], this.obligations = [], this.collapsed = false, this.yielded = false, this.yieldOverride = false, this.headerHovered = false, this.paintKey = "", this./** Idempotent: the owner re-asserts the remembered choice from its layout pass. */ setCollapsed = (collapsed)=>{
            if (this.collapsed === collapsed) return;
            this.collapsed = collapsed;
            this.repaint();
        }, this.isCollapsed = ()=>this.collapsed, this./**
     * Fold the rows away while the strip is speaking, and let them back once it has finished.
     *
     * The strip's band crosses the row the open rows hang into, so the two TAKE TURNS rather than
     * sharing the pixels: the notice says what changed, then the standing list unfolds behind it.
     * Drawing one over the other was legible, but it said two things at once, in one band, about
     * different events -- which is the noise this whole feature exists to cut.
     *
     * It folds to the PILL rather than disappearing: the header sits above the band, so the count
     * and the tone stay on screen and nothing is actually withheld while the strip has the floor.
     * A fold also reads as the panel making room, where a vanish reads as the task being over.
     */ setYielded = (yielded)=>{
            // The strip has gone quiet, so an override has nothing left to override.
            if (!yielded) this.yieldOverride = false;
            const next = yielded && !this.yieldOverride;
            if (this.yielded === next) return;
            this.yielded = next;
            this.repaint();
        }, this.isYielded = ()=>this.yielded, this.folded = ()=>this.collapsed || this.yielded, this./** Whether the camp owes the player anything the player has not waved away. */ hasTasks = ()=>this.obligations.length > 0, this./**
     * Just the header bar's height.
     *
     * The owner centres the header on the HP bar's line (see placeEmberObligations) -- the rows hang
     * BELOW it like any dropdown, so it is the header, not the whole stack, that has to line up.
     */ getHeaderHeight = ()=>this.headerHeight(), this.update = (obligations)=>{
            this.obligations = obligations;
            this.visible = obligations.length > 0;
            if (!this.visible) {
                // Keep the rows around: the next camp event is likely the same two keys back again.
                this.paintKey = "";
                return;
            }
            this.repaint();
        }, this.width_ = ()=>(0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().touch ? $0b9b8914648f9fea$var$TOUCH_WIDTH : $0b9b8914648f9fea$var$WIDTH, this.getWidth = ()=>this.width_(), this.getHeight = ()=>{
            const header = this.headerHeight();
            if (this.folded() || this.obligations.length < 1) return header;
            return this.rows.reduce((total, row)=>total + this.rowHeight(row) + $0b9b8914648f9fea$var$ROW_GAP, header + $0b9b8914648f9fea$var$ROW_GAP) - $0b9b8914648f9fea$var$ROW_GAP;
        }, this.headerHeight = ()=>Math.round(this.headerText.height) + $0b9b8914648f9fea$var$PAD_Y * 2, this.rowHeight = (row)=>Math.round(row.label.height + row.detail.height) + $0b9b8914648f9fea$var$PAD_Y * 2 + 1, this.repaint = ()=>{
            const key = [
                this.collapsed ? "c" : "o",
                this.yielded ? "y" : "-",
                this.headerHovered ? "h" : "-",
                (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().touch ? "t" : "d",
                ...this.obligations.map((o)=>`${o.key}|${o.tone}|${o.label}|${o.detail}`),
                ...this.rows.map((r)=>r.hovered ? "1" : "0")
            ].join("~");
            if (key === this.paintKey) return;
            this.paintKey = key;
            this.syncRows();
            this.draw();
        }, this.syncRows = ()=>{
            const keep = new Set(this.obligations.map((o)=>o.key));
            for (const row of this.rows.filter((r)=>!keep.has(r.obligation.key))){
                this.rowsLayer.removeChild(row.container);
                row.container.destroy({
                    children: true
                });
            }
            this.rows = this.rows.filter((r)=>keep.has(r.obligation.key));
            for (const obligation of this.obligations){
                const existing = this.rows.find((r)=>r.obligation.key === obligation.key);
                if (existing) {
                    existing.obligation = obligation;
                    continue;
                }
                this.rows.push(this.buildRow(obligation));
            }
            // Feed order, so the stack does not reshuffle as tones change.
            this.rows.sort((a, b)=>this.obligations.findIndex((o)=>o.key === a.obligation.key) - this.obligations.findIndex((o)=>o.key === b.obligation.key));
            this.rowsLayer.removeChildren();
            this.rows.forEach((row)=>this.rowsLayer.addChild(row.container));
        }, this.buildRow = (obligation)=>{
            const container = new (0, $8t5Gy.Container)();
            const plate = new (0, $gwPoJ.Graphics)();
            const label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("compactBody").color($0b9b8914648f9fea$var$THEME.text).render("");
            const detail = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("compactCaption").color($0b9b8914648f9fea$var$THEME.text).render("");
            const close = this.buildClose();
            container.addChild(plate, label, detail, close);
            const row = {
                obligation: obligation,
                container: container,
                plate: plate,
                label: label,
                detail: detail,
                close: close,
                hovered: false
            };
            container.interactive = true;
            container.on("mouseover", ()=>{
                row.hovered = true;
                this.repaint();
            });
            container.on("mouseout", ()=>{
                row.hovered = false;
                this.repaint();
            });
            close.on("click", ()=>this.onDismiss(row.obligation));
            close.on("tap", ()=>this.onDismiss(row.obligation));
            return row;
        }, this.buildClose = ()=>{
            const close = new (0, $8t5Gy.Container)();
            const mark = new (0, $gwPoJ.Graphics)();
            const r = 6;
            mark.lineStyle(1, $0b9b8914648f9fea$var$THEME.border, 0.9).drawCircle(r, r, r);
            mark.lineStyle(1.4, $0b9b8914648f9fea$var$THEME.text, 0.75).moveTo(r - 2.6, r - 2.6).lineTo(r + 2.6, r + 2.6).moveTo(r + 2.6, r - 2.6).lineTo(r - 2.6, r + 2.6);
            close.addChild(mark);
            close.interactive = true;
            close.cursor = "pointer";
            close.hitArea = new (0, $0d2b5753435eae0a$export$ca88597b86c9a1dc)(()=>(0, $0d2b5753435eae0a$export$f71286780f6a70a)(close, r * 2, r * 2, 8));
            return close;
        }, this.draw = ()=>{
            const w = this.width_();
            const headerH = this.headerHeight();
            const alertCount = this.obligations.filter((o)=>o.tone === "alert").length;
            const hot = alertCount > 0;
            this.headerText.text = this.folded() ? `\u{25B8}  ${this.obligations.length} ${this.obligations.length === 1 ? "TASK" : "TASKS"}` : "\u25BE  CAMP TASKS";
            this.headerText.tint = hot ? $0b9b8914648f9fea$var$THEME.accent : $0b9b8914648f9fea$var$THEME.text;
            this.headerText.alpha = this.headerHovered ? 1 : 0.85;
            // Folded, the header hugs its own text: a pill, not a full-width bar with nothing under it.
            const headerW = this.folded() ? Math.round(this.headerText.width) + $0b9b8914648f9fea$var$PAD_X * 2 : w;
            this.headerPlate.clear();
            this.headerPlate.beginFill(this.headerHovered ? $0b9b8914648f9fea$var$PANEL_FILL_HOVER : $0b9b8914648f9fea$var$PANEL_FILL, this.headerHovered ? $0b9b8914648f9fea$var$PANEL_ALPHA_HOVER : $0b9b8914648f9fea$var$PANEL_ALPHA).lineStyle(1, hot ? $0b9b8914648f9fea$var$THEME.accent : $0b9b8914648f9fea$var$THEME.border, this.headerHovered ? 0.9 : 0.55).drawRoundedRect(0, 0, headerW, headerH, $0b9b8914648f9fea$var$CORNER).endFill();
            this.headerText.x = $0b9b8914648f9fea$var$PAD_X;
            this.headerText.y = $0b9b8914648f9fea$var$PAD_Y;
            this.header.hitArea = new (0, $0d2b5753435eae0a$export$ca88597b86c9a1dc)(()=>(0, $0d2b5753435eae0a$export$f71286780f6a70a)(this.header, headerW, headerH, 6));
            this.rowsLayer.visible = !this.folded();
            if (this.folded()) return;
            let y = headerH + $0b9b8914648f9fea$var$ROW_GAP;
            for (const row of this.rows){
                const { obligation: obligation } = row;
                row.label.text = `${obligation.icon}  ${obligation.label}`;
                row.detail.text = obligation.detail;
                const tone = obligation.tone === "alert" ? $0b9b8914648f9fea$var$THEME.accent : $0b9b8914648f9fea$var$THEME.border;
                row.detail.tint = obligation.tone === "alert" ? $0b9b8914648f9fea$var$THEME.accent : $0b9b8914648f9fea$var$THEME.text;
                row.detail.alpha = obligation.tone === "alert" ? 0.95 : 0.6;
                const h = this.rowHeight(row);
                row.plate.clear();
                row.plate.beginFill(row.hovered ? $0b9b8914648f9fea$var$PANEL_FILL_HOVER : $0b9b8914648f9fea$var$PANEL_FILL, row.hovered ? $0b9b8914648f9fea$var$PANEL_ALPHA_HOVER : $0b9b8914648f9fea$var$PANEL_ALPHA).lineStyle(1, tone, row.hovered ? 0.8 : 0.45).drawRoundedRect(0, 0, w, h, $0b9b8914648f9fea$var$CORNER).endFill();
                // The spine, inside the rim: tone without tinting the text the player has to read.
                row.plate.lineStyle(0).beginFill(tone, obligation.tone === "alert" ? 0.95 : 0.5).drawRoundedRect(2, 4, $0b9b8914648f9fea$var$SPINE_W, h - 8, $0b9b8914648f9fea$var$SPINE_W / 2).endFill();
                const textX = 2 + $0b9b8914648f9fea$var$SPINE_W + $0b9b8914648f9fea$var$SPINE_GAP;
                row.label.x = textX;
                row.label.y = $0b9b8914648f9fea$var$PAD_Y;
                row.detail.x = textX;
                row.detail.y = $0b9b8914648f9fea$var$PAD_Y + Math.round(row.label.height) + 1;
                row.close.x = w - $0b9b8914648f9fea$var$PAD_X - 12;
                row.close.y = Math.round((h - 12) / 2);
                row.container.hitArea = new (0, $0d2b5753435eae0a$export$ca88597b86c9a1dc)(()=>(0, $0d2b5753435eae0a$export$f71286780f6a70a)(row.container, w, h, 0));
                row.container.y = y;
                y += h + $0b9b8914648f9fea$var$ROW_GAP;
            }
        };
        this.headerText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("overline").color($0b9b8914648f9fea$var$THEME.text).render("");
        this.header.addChild(this.headerPlate, this.headerText);
        this.header.interactive = true;
        this.header.cursor = "pointer";
        this.header.on("mouseover", ()=>{
            this.headerHovered = true;
            this.repaint();
        });
        this.header.on("mouseout", ()=>{
            this.headerHovered = false;
            this.repaint();
        });
        // A press OPENS it whatever is holding it shut, and closes it when it is open. Folding has
        // two causes (the player's own choice and making way for a notice) and the player should
        // never have to press twice to undo both, nor press once and see nothing change.
        const toggle = ()=>{
            if (this.folded()) {
                if (this.yielded) {
                    this.yieldOverride = true;
                    this.yielded = false;
                }
                if (this.collapsed) {
                    this.collapsed = false;
                    this.onToggleCollapsed(false);
                }
            } else {
                this.collapsed = true;
                this.onToggleCollapsed(true);
            }
            this.repaint();
        };
        this.header.on("click", toggle);
        this.header.on("tap", toggle);
        this.addChild(this.rowsLayer, this.header);
        this.visible = false;
    }
}


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");




const $b63697c140e90637$export$1193eaef86e14179 = (0, $97475243e21a0995$export$ae463dc3cc7e810b);
const $b63697c140e90637$export$4d5d11e976d0c432 = 0.59;
const $b63697c140e90637$export$a51459aea0dfefc8 = 0.82;
const $b63697c140e90637$export$3abdbd57ee78af1d = 0.36;
const $b63697c140e90637$export$93ef67ef32ca60d0 = 0.75;
const $b63697c140e90637$export$fbad5307eca418e5 = (0, $97475243e21a0995$export$4569a0b09aa32d6c);
const $b63697c140e90637$export$555570afd9db0e6 = (0, $97475243e21a0995$export$92999bc7164f195e);
// Toggles dim the glyph while off and use the game's amber selection rim while active.
const $b63697c140e90637$var$GLYPH_ALPHA_ON = 1;
const $b63697c140e90637$var$GLYPH_ALPHA_OFF = 0.4;
class $b63697c140e90637$export$81c7dcc65e224ff6 extends (0, $8t5Gy.Container) {
    constructor({ glyph: glyph, label: label, onClick: onClick, toggle: toggle = false }){
        super(), // Everything visible hangs off `body` rather than off the chip itself, so a flare's pop can
        // scale it about its own middle while the chip's x/y -- what layoutChipRow sets, and what the
        // panels beneath stack against -- stay exactly where they were put. (Same arrangement as
        // ember_players_chip.ts, which flared first.)
        this.metrics = (0, $0d2b5753435eae0a$export$80d247c8fac4e59d)(), this.metricSource = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)(), this.body = new (0, $8t5Gy.Container)(), this.glow = new (0, $gwPoJ.Graphics)(), this.plate = new (0, $gwPoJ.Graphics)(), this.hovered = false, // Whether what this chip toggles is currently showing. Chips that toggle nothing stay true and
        // draw as they always have.
        this.active = true, // Time left in the "look at me" flare, or 0 at rest -- which is the usual case: a chip only
        // flares when something it carries happened unasked (a line of chat arriving). At rest the glow
        // draws nothing and the pop is exactly 1, so a settled chip costs what it always did.
        this.flareMs = 0, // Both sit on a shared centre line, so the glyph and the text don't stagger.
        this.layout = ()=>{
            this.glyph.x = this.metrics.padX;
            this.label.x = this.metrics.padX + this.glyph.width + this.metrics.gap;
            const h = this.getHeight() - this.metrics.padY * 2;
            this.glyph.y = this.metrics.padY + (h - this.glyph.height) / 2;
            this.label.y = this.metrics.padY + (h - this.label.height) / 2;
            // Pivot and position on the same point: the body then occupies its old box at rest and
            // swells symmetrically out of the middle when a flare's pop scales it.
            const centre = {
                x: this.getWidth() / 2,
                y: this.getHeight() / 2
            };
            this.body.pivot.set(centre.x, centre.y);
            this.body.position.set(centre.x, centre.y);
            this.hitArea = new (0, $0d2b5753435eae0a$export$ca88597b86c9a1dc)(()=>{
                const rect = (0, $0d2b5753435eae0a$export$f71286780f6a70a)(this, this.getWidth(), this.getHeight(), this.metrics.hitPad);
                // Preserve the small desktop allowance too.
                if (!(0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().touch) rect.pad(this.metrics.hitPad);
                return rect;
            });
        }, // Start a flare, unless one is already running: that is what rate-limits the thing. A busy
        // conversation would otherwise restart the flare on every line and leave the corner blinking
        // for as long as people are talking.
        this.flash = ()=>{
            if (this.flareMs > 0) return;
            this.flareMs = (0, $ec347662891822a3$export$4bd05e62286397cf);
            this.draw();
        }, this.isFlashing = ()=>this.flareMs > 0, // Say which way the thing this chip toggles is currently set. Idempotent, because the owner
        // re-asserts it from its layout pass rather than only on a change.
        this.setActive = (active)=>{
            if (this.active === active) return;
            this.active = active;
            this.draw();
        }, this.isActive = ()=>this.active, // Drain the flare. Only repaints while one is running, so a chip that has settled costs nothing
        // per frame.
        this.animate = (dtMs)=>{
            if (this.flareMs <= 0) return;
            this.flareMs = Math.max(0, this.flareMs - dtMs);
            this.draw();
        }, this.draw = ()=>{
            const hot = (0, $ec347662891822a3$export$89ff20d7b20a9b0b)(this.flareMs);
            const w = this.getWidth();
            const h = this.getHeight();
            const selected = this.toggle && this.active;
            const theme = (0, $97475243e21a0995$export$b1586623fe466c29).ember;
            // The row sits 6px off the top of the screen, so the halo is kept short: anything taller is
            // spent off-canvas.
            (0, $ec347662891822a3$export$68fa09a501e35b68)(this.glow, {
                remainingMs: this.flareMs,
                width: w,
                height: h,
                corner: this.metrics.corner
            });
            this.plate.clear();
            this.plate.beginFill((0, $ec347662891822a3$export$33ee99e9ec522cbf)(selected ? theme.pressedFill : $b63697c140e90637$export$1193eaef86e14179, (0, $ec347662891822a3$export$8c3b9879a2e96719), hot * 0.85), (this.hovered || selected ? $b63697c140e90637$export$a51459aea0dfefc8 : $b63697c140e90637$export$4d5d11e976d0c432) + hot * (1 - $b63697c140e90637$export$4d5d11e976d0c432));
            // The rim stays near white at the peak rather than going orange with the fill: a bright
            // edge around a hot plate is what makes the thing look lit instead of merely recoloured.
            this.plate.lineStyle((selected ? 1.5 : 1) + hot * 1.5, (0, $ec347662891822a3$export$33ee99e9ec522cbf)(selected ? theme.accent : (0, $97475243e21a0995$export$cac838e5dd111a30), (0, $ec347662891822a3$export$8c3b9879a2e96719), hot * 0.4), Math.min(1, (this.hovered || selected ? $b63697c140e90637$export$93ef67ef32ca60d0 : $b63697c140e90637$export$3abdbd57ee78af1d) + hot));
            this.plate.drawRoundedRect(0, 0, w, h, this.metrics.corner);
            this.plate.endFill();
            this.label.tint = (0, $ec347662891822a3$export$33ee99e9ec522cbf)(selected ? theme.accent : this.hovered ? $b63697c140e90637$export$555570afd9db0e6 : $b63697c140e90637$export$fbad5307eca418e5, 0xffffff, hot);
            // Hovering an "off" toggle brings its glyph most of the way back up, so the chip previews what
            // the click is about to turn on.
            this.glyph.alpha = this.active || this.hovered ? $b63697c140e90637$var$GLYPH_ALPHA_ON : $b63697c140e90637$var$GLYPH_ALPHA_OFF;
            this.body.scale.set((0, $ec347662891822a3$export$6475a58bf88bdc85)(this.flareMs));
        }, // Measured off the content rather than getBounds(), so the plate can be drawn to the size the
        // caller is about to position against without a chicken-and-egg on bounds -- and so the row's
        // layout is the chip's RESTING size, unmoved by a flare in progress.
        this.refreshMetrics = ()=>{
            if (this.metricSource === (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)()) return;
            this.metricSource = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)();
            this.metrics = (0, $0d2b5753435eae0a$export$80d247c8fac4e59d)();
            this.glyph.style.fontSize = this.metrics.glyphSize;
            this.label.style.fontSize = this.metrics.labelSize;
            this.layout();
            this.draw();
        }, this.getWidth = ()=>{
            this.refreshMetrics();
            return Math.max(this.metrics.minWidth, this.metrics.padX * 2 + this.glyph.width + this.metrics.gap + this.label.width);
        }, this.getHeight = ()=>{
            this.refreshMetrics();
            return Math.max(this.metrics.minHeight, this.metrics.padY * 2 + Math.max(this.glyph.height, this.label.height));
        };
        this.toggle = toggle;
        this.active = !toggle;
        // No tint on the emoji -- it carries its own colours.
        this.glyph = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(this.metrics.glyphSize).render(glyph);
        this.label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(this.metrics.labelSize).render(label);
        this.body.addChild(this.glow, this.plate, this.glyph, this.label);
        this.addChild(this.body);
        this.layout();
        this.draw();
        this.interactive = true;
        this.cursor = "pointer";
        this.on("mouseover", ()=>{
            this.hovered = true;
            this.draw();
        });
        this.on("mouseout", ()=>{
            this.hovered = false;
            this.draw();
        });
        this.on("click", onClick);
        this.on("tap", onClick);
        // Every chip in this row is put on screen by whatever owns it, once it has something to
        // say. None of them should appear merely by being constructed.
        this.visible = false;
    }
}


class $ab150d38ea68b1cd$export$30768dbf6666e389 extends (0, $b63697c140e90637$export$81c7dcc65e224ff6) {
    constructor(onClick){
        super({
            glyph: "\uD83D\uDCAC",
            label: "SAY",
            onClick: onClick
        });
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");

var $8JEKL = parcelRequire("8JEKL");




const $b846cff9e823ca67$export$91e844e248b510e7 = 560;
const $b846cff9e823ca67$export$1eb5fccb533f1606 = 52;
// The virtual screen everything is laid out in (index.ts VIRTUAL_W). Centred on it rather than on
// the HUD's own right edge, so the panel sits under the middle of the screen the player is holding.
const $b846cff9e823ca67$var$SCREEN_W = 800;
const $b846cff9e823ca67$export$f445d03e81bcf8ba = ($b846cff9e823ca67$var$SCREEN_W - $b846cff9e823ca67$export$91e844e248b510e7) / 2;
const $b846cff9e823ca67$export$eb9927aac887875f = 34;
const $b846cff9e823ca67$export$5b84a9dbdfc7701e = $b846cff9e823ca67$export$eb9927aac887875f + $b846cff9e823ca67$export$1eb5fccb533f1606;
const $b846cff9e823ca67$var$PAD = 11;
const $b846cff9e823ca67$var$GAP = 8;
const $b846cff9e823ca67$var$FIELD_H = (0, $97475243e21a0995$export$73e83bf2b7e02467).medium.height;
const $b846cff9e823ca67$var$SEND_W = 74;
const $b846cff9e823ca67$var$SEND_H = $b846cff9e823ca67$var$FIELD_H;
const $b846cff9e823ca67$var$BUTTON_CORNER = 6;
const $b846cff9e823ca67$var$BUTTON_IDLE_RIM = 0x6b4f38;
const $b846cff9e823ca67$var$CLOSE_W = 28;
const $b846cff9e823ca67$var$FIELD_W = $b846cff9e823ca67$export$91e844e248b510e7 - $b846cff9e823ca67$var$PAD * 2 - $b846cff9e823ca67$var$SEND_W - $b846cff9e823ca67$var$CLOSE_W - $b846cff9e823ca67$var$GAP * 2;
const $b846cff9e823ca67$var$FIELD_X = $b846cff9e823ca67$export$f445d03e81bcf8ba + $b846cff9e823ca67$var$PAD;
const $b846cff9e823ca67$var$FIELD_Y = $b846cff9e823ca67$export$eb9927aac887875f + $b846cff9e823ca67$var$PAD;
const $b846cff9e823ca67$var$SEND_X = $b846cff9e823ca67$var$FIELD_X + $b846cff9e823ca67$var$FIELD_W + $b846cff9e823ca67$var$GAP;
const $b846cff9e823ca67$var$CLOSE_X = $b846cff9e823ca67$var$SEND_X + $b846cff9e823ca67$var$SEND_W + $b846cff9e823ca67$var$GAP;
// How far the dim reaches. Generous on every side: the stage is 800 x ~462 and is stretched
// vertically (see the canvas-resolution notes in index.ts), and a scrim that stops short of an edge
// leaves a live strip of world the player can swing at while they are typing.
const $b846cff9e823ca67$var$SCRIM = new (0, $6qzqq.Rectangle)(-60, -60, $b846cff9e823ca67$var$SCREEN_W + 120, 620);
const $b846cff9e823ca67$var$SCRIM_ALPHA = 0.28;
class $b846cff9e823ca67$export$813afa0a1cccf433 extends (0, $8t5Gy.Container) {
    constructor({ onSend: onSend, onDismiss: onDismiss }){
        super(), this.opened = false;
        this.onSend = onSend;
        this.onDismiss = onDismiss;
        // The scrim is the gate as well as the dim: every pointer event over it stops here, so a tap
        // meant for the panel never also reaches the joystick or an entity underneath. Deliberately
        // NOT routed through GuiManager.mouseOverControl -- that latch is a single global boolean,
        // and pixi never delivers the matching pointerout to a widget hidden under a resting
        // pointer, which is how the world's mouse gets stuck off for a whole room. The world action
        // is gated on isChatComposerVisible() instead.
        this.scrim = new (0, $gwPoJ.Graphics)();
        this.scrim.beginFill(0x05070a, $b846cff9e823ca67$var$SCRIM_ALPHA);
        this.scrim.drawRect($b846cff9e823ca67$var$SCRIM.x, $b846cff9e823ca67$var$SCRIM.y, $b846cff9e823ca67$var$SCRIM.width, $b846cff9e823ca67$var$SCRIM.height);
        this.scrim.endFill();
        this.scrim.interactive = true;
        this.scrim.hitArea = $b846cff9e823ca67$var$SCRIM;
        this.scrim.on("pointerdown", (event)=>{
            event.stopPropagation();
            this.onDismiss();
        });
        this.scrim.on("pointermove", (event)=>event.stopPropagation());
        this.addChild(this.scrim);
        this.shadow = new (0, $gwPoJ.Graphics)();
        this.panel = new (0, $gwPoJ.Graphics)();
        this.addChild(this.shadow, this.panel);
        this.drawPanel();
        // A tap anywhere on the panel itself is swallowed without dismissing: the gaps between the
        // field and the buttons are not a "cancel" target.
        const panelGate = new (0, $8t5Gy.Container)();
        panelGate.interactive = true;
        panelGate.hitArea = new (0, $6qzqq.Rectangle)($b846cff9e823ca67$export$f445d03e81bcf8ba, $b846cff9e823ca67$export$eb9927aac887875f, $b846cff9e823ca67$export$91e844e248b510e7, $b846cff9e823ca67$export$1eb5fccb533f1606);
        panelGate.on("pointerdown", (event)=>event.stopPropagation());
        panelGate.on("pointermove", (event)=>event.stopPropagation());
        this.addChild(panelGate);
        this.input = this.makeField();
        this.addChild(this.input);
        // Activate on press: dismissing the soft keyboard can move the release target.
        this.sendButton = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
            label: "Send",
            theme: "ember",
            preset: "primary",
            width: $b846cff9e823ca67$var$SEND_W,
            height: $b846cff9e823ca67$var$SEND_H,
            size: "medium",
            bold: true,
            activation: "press",
            onClick: ()=>this.submit()
        });
        this.closeButton = (0, $83d1a97b87afddc2$export$48c67489f19ab119)({
            icon: "\u2715",
            theme: "ember",
            width: $b846cff9e823ca67$var$CLOSE_W,
            height: $b846cff9e823ca67$var$SEND_H,
            size: "medium",
            activation: "press",
            onClick: ()=>this.onDismiss()
        });
        this.sendButton.position.set($b846cff9e823ca67$var$SEND_X, $b846cff9e823ca67$var$FIELD_Y);
        this.closeButton.position.set($b846cff9e823ca67$var$CLOSE_X, $b846cff9e823ca67$var$FIELD_Y);
        this.addChild(this.sendButton, this.closeButton);
        this.visible = false;
    }
    drawPanel() {
        this.shadow.clear();
        this.shadow.beginFill((0, $bde0eb94ead9038f$export$a9fed83f1c193f7e), (0, $bde0eb94ead9038f$export$7fb3621e17d8a3da));
        this.shadow.drawRoundedRect($b846cff9e823ca67$export$f445d03e81bcf8ba + (0, $bde0eb94ead9038f$export$ba288e268a12646c), $b846cff9e823ca67$export$eb9927aac887875f + (0, $bde0eb94ead9038f$export$ba288e268a12646c), $b846cff9e823ca67$export$91e844e248b510e7, $b846cff9e823ca67$export$1eb5fccb533f1606, (0, $bde0eb94ead9038f$export$440d7b56d7e79537));
        this.shadow.endFill();
        this.panel.clear();
        this.panel.lineStyle(1.5, (0, $bde0eb94ead9038f$export$542c8a566b36979), 0.9);
        this.panel.beginFill((0, $bde0eb94ead9038f$export$35cf6b4f538836cd), (0, $bde0eb94ead9038f$export$5eb57294d7a01ff));
        this.panel.drawRoundedRect($b846cff9e823ca67$export$f445d03e81bcf8ba, $b846cff9e823ca67$export$eb9927aac887875f, $b846cff9e823ca67$export$91e844e248b510e7, $b846cff9e823ca67$export$1eb5fccb533f1606, (0, $bde0eb94ead9038f$export$440d7b56d7e79537));
        this.panel.endFill();
    }
    // The field itself. Same two departures from the library's defaults that name_prompt.ts and
    // login_field.ts document at length: the real <input> stays on screen (substituteText off) and
    // the box is ours.
    makeField() {
        const input = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
            input: {
                fontFamily: "Arial, sans-serif",
                // 16px is the floor Safari zooms a focused field up to. index.html's viewport meta
                // pins the scale so it would not zoom anyway, but a field that is already big
                // enough cannot be caught out by a page that loses that pin.
                fontSize: "16px",
                lineHeight: `${$b846cff9e823ca67$var$FIELD_H}px`,
                height: `${$b846cff9e823ca67$var$FIELD_H}px`,
                width: `${$b846cff9e823ca67$var$FIELD_W}px`,
                boxSizing: "border-box",
                padding: "0 10px",
                color: "#fff3e0",
                caretColor: "#f2a94e",
                multiline: false
            },
            box: (w, h, state)=>{
                const g = new (0, $gwPoJ.Graphics)();
                g.lineStyle(1.5, state === "FOCUSED" ? (0, $bde0eb94ead9038f$export$542c8a566b36979) : $b846cff9e823ca67$var$BUTTON_IDLE_RIM, state === "FOCUSED" ? 1 : 0.7);
                g.beginFill(0x120e0b, 0.95);
                g.drawRoundedRect(0, 0, w, h, $b846cff9e823ca67$var$BUTTON_CORNER);
                g.endFill();
                return g;
            }
        });
        // The library builds its pixi Text stand-in before we can opt out, and _destroySurrogate()
        // leaves _surrogate_mask behind -- an opaque black Graphics that would paint a slab over the
        // field. (Same pair of fixes as login_field.ts and name_prompt.ts.)
        input.substituteText = false;
        const orphanedMask = input._surrogate_mask;
        if (orphanedMask) {
            input.removeChild(orphanedMask);
            orphanedMask.destroy();
            input._surrogate_mask = null;
        }
        input.x = $b846cff9e823ca67$var$FIELD_X;
        input.y = $b846cff9e823ca67$var$FIELD_Y;
        // The server drops anything longer, and the inline field caps the same line at the same
        // length, so a phone is not the one place a message can be typed and then truncated.
        input.maxLength = (0, $2bc3e70fbff7f064$export$4779cfd32b998f47);
        input.placeholder = "Say something\u2026";
        const dom = input._dom_input;
        // ::placeholder and ::selection colours for it live in index.html.
        dom.className = "samsara-input";
        dom.setAttribute("aria-label", "Chat message");
        // Chat is prose, so unlike a name field this one keeps the phone's help: sentence case and
        // autocorrect on.
        dom.setAttribute("autocapitalize", "sentences");
        dom.setAttribute("autocomplete", "off");
        // The one key a phone keyboard shows for "done". Without this it offers a newline the field
        // cannot hold, on a line nothing would send.
        dom.setAttribute("enterkeyhint", "send");
        input.on("keyup", (keycode)=>{
            if (keycode === 13) this.submit();
            if (keycode === 27) this.onDismiss();
        });
        return input;
    }
    submit() {
        const value = (this.input.text || "").trim();
        if (!value) {
            // An empty line is not a message. Treated as backing out, which is what a player who
            // taps Send on an empty field means.
            this.onDismiss();
            return;
        }
        this.onSend(value);
    }
    /**
     * Show or hide the DOM <input> itself.
     *
     * pixi-text-input syncs the real <input>'s css display from inside render(), i.e. only while it
     * is being drawn -- so the frame this container's `visible` goes false is the library's last
     * chance to hide the field. Miss it and the half-typed line stays painted over the game for
     * good. Showing is handed back to the library (it places the node and reveals it in the same
     * pass; a node it has not placed yet still sits at the page's top-left), which only needs a
     * reason to re-sync -- our hide was invisible to it. Cf. login_field.ts, which carries the same
     * pair.
     */ setDomVisible(visible) {
        if (visible) {
            this.input._previous.world_visible = false;
            return;
        }
        this.input.blur();
        this.input._setDOMInputVisible(false);
    }
    isOpen() {
        return this.opened;
    }
    text() {
        return (this.input.text || "").trim();
    }
    open() {
        this.opened = true;
        this.sendButton.resetInteraction();
        this.closeButton.resetInteraction();
        // Every open starts on a blank line: a draft left over from a conversation two camps ago is
        // not something a player wants to find in the field.
        this.input.text = "";
        this.visible = true;
        this.setDomVisible(true);
        // Deferred a tick on purpose: a focus() issued while the browser is still dispatching the
        // pointerdown that opened this is handed straight back to the canvas, which on a phone means
        // the keyboard never comes up at all. (The trap login_field.ts hit.)
        setTimeout(()=>{
            if (this.opened) this.input.focus();
        }, 0);
    }
    close() {
        this.opened = false;
        this.input.text = "";
        // Before `visible` goes false, for the reason setDomVisible explains.
        this.setDomVisible(false);
        this.visible = false;
    }
    /**
     * Detach the DOM node. pixi-text-input appends it to document.body on 'added' and removes it on
     * 'removed', so it outlives the canvas unless the field leaves the stage.
     */ dispose() {
        const dom = this.input._dom_input;
        try {
            this.input.parent?.removeChild(this.input);
        } catch (e) {
        /* ignore -- the node is detached below either way */ }
        if (dom && dom.parentNode) dom.parentNode.removeChild(dom);
        this.input._dom_added = false;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $9Pi8W = parcelRequire("9Pi8W");

parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");


const $e59d4eca9b366180$export$dc3c988e71114e28 = (0, $0d2b5753435eae0a$export$eb43af23fb6f2b4a)();
const $e59d4eca9b366180$var$RIM = 0x8d97ad;
const $e59d4eca9b366180$var$RIM_HOVER = 0xd9a441 // gold, matching the inventory/crafting panel accent
;
const $e59d4eca9b366180$var$FILL = 0x1b2030;
const $e59d4eca9b366180$var$FILL_HOVER = 0x2f3648;
const $e59d4eca9b366180$var$GLYPH = 0xe6e9f0;
const $e59d4eca9b366180$var$GLYPH_HOVER = 0xffe6b0;
const $e59d4eca9b366180$var$DISC = {
    slate: {
        fill: $e59d4eca9b366180$var$FILL,
        fillHover: $e59d4eca9b366180$var$FILL_HOVER,
        glyph: $e59d4eca9b366180$var$GLYPH,
        glyphHover: $e59d4eca9b366180$var$GLYPH_HOVER,
        rim: $e59d4eca9b366180$var$RIM
    },
    ember: {
        fill: (0, $97475243e21a0995$export$ae463dc3cc7e810b),
        fillHover: 0x2f2318,
        glyph: (0, $97475243e21a0995$export$4569a0b09aa32d6c),
        glyphHover: (0, $97475243e21a0995$export$92999bc7164f195e),
        rim: (0, $97475243e21a0995$export$cac838e5dd111a30)
    }
};
const $e59d4eca9b366180$export$cf4441b2ae4eae3b = (g, radius, hover, theme = "slate")=>{
    g.clear();
    // Fake drop shadow -- an offset dark disc behind, rather than a filter (see the budget hardware
    // target: filters cost a render pass per instance).
    g.lineStyle(0);
    g.beginFill(0x000000, 0.35);
    g.drawCircle(0, 1.5, radius);
    g.endFill();
    const tones = $e59d4eca9b366180$var$DISC[theme];
    g.lineStyle({
        width: 2,
        color: hover ? $e59d4eca9b366180$var$RIM_HOVER : tones.rim,
        alpha: 1
    });
    g.beginFill(hover ? tones.fillHover : tones.fill, 0.98);
    g.drawCircle(0, 0, radius);
    g.endFill();
    g.lineStyle(0);
};
const $e59d4eca9b366180$export$3da1e32664c3cd3 = (hover, theme = "slate")=>hover ? $e59d4eca9b366180$var$DISC[theme].glyphHover : $e59d4eca9b366180$var$DISC[theme].glyph;
class $e59d4eca9b366180$export$de65de8213222d10 extends (0, $gwPoJ.Graphics) {
    constructor({ radius: radius, onClick: onClick, hitPadding: hitPadding, theme: theme = "slate" } = {}){
        super(), this.hovered = false, this.draw = (hover)=>{
            this.hovered = hover;
            const r = this.radius;
            $e59d4eca9b366180$export$cf4441b2ae4eae3b(this, r, hover, this.theme);
            const arm = r * 0.4;
            this.lineStyle({
                width: Math.max(2, r * 0.19),
                color: $e59d4eca9b366180$export$3da1e32664c3cd3(hover, this.theme),
                alpha: 1,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            this.moveTo(-arm, -arm);
            this.lineTo(arm, arm);
            this.moveTo(arm, -arm);
            this.lineTo(-arm, arm);
            this.lineStyle(0);
        }, this.getRadius = ()=>this.radius, this.getHitSize = ()=>{
            if (this.hitArea instanceof (0, $0d2b5753435eae0a$export$ca88597b86c9a1dc)) {
                this.hitArea.refresh();
                return {
                    width: this.hitArea.width,
                    height: this.hitArea.height
                };
            }
            return {
                width: (this.radius + 3) * 2,
                height: (this.radius + 3) * 2
            };
        }, this.updateHitArea = ()=>{
            this.hitArea = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().touch ? new (0, $0d2b5753435eae0a$export$ca88597b86c9a1dc)(()=>{
                const rect = (0, $0d2b5753435eae0a$export$f71286780f6a70a)(this, this.radius * 2, this.radius * 2, this.hitPadding);
                rect.x -= this.radius;
                rect.y -= this.radius;
                return rect;
            }) : new (0, $6qzqq.Circle)(0, 0, this.radius + 3);
        }, this.refreshMetrics = ()=>{
            this.radius = this.fixedRadius ?? (0, $0d2b5753435eae0a$export$eb43af23fb6f2b4a)();
            this.updateHitArea();
            this.draw(this.hovered);
        };
        this.theme = theme;
        this.fixedRadius = radius;
        this.radius = radius ?? (0, $0d2b5753435eae0a$export$eb43af23fb6f2b4a)();
        this.hitPadding = hitPadding ?? (radius === undefined ? Infinity : 3);
        this.draw(false);
        this.interactive = true;
        this.cursor = "pointer";
        // An explicit circular hit area, a couple of px proud of the rim: the disc is small and this
        // is the one control every dialog is closed by, so it should be forgiving to hit (and to tap).
        this.updateHitArea();
        this.on("mouseover", ()=>this.draw(true));
        this.on("mouseout", ()=>this.draw(false));
        if (onClick) {
            this.on("click", onClick);
            this.on("tap", onClick);
        }
    }
}


class $4187b20a7424922e$export$cafd35a8da32c4c1 extends (0, $8t5Gy.Container) {
    constructor(onPress, onShown){
        super(), this.onShown = onShown, this.leader = new (0, $gwPoJ.Graphics)(), this.panel = new (0, $8t5Gy.Container)(), this.background = new (0, $gwPoJ.Graphics)(), this.label = new (0, $9Pi8W.Text)("", {
            fontFamily: (0, $ef882f0a643d87d9$export$2653e0d5dd45b294),
            fontSize: (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).caption.fontSize,
            fill: 0xffffff,
            lineHeight: 18
        }), this.dismissed = false, this.elapsed = 0, this.dismiss = ()=>{
            this.dismissed = true;
            this.reset();
        }, this.reset = ()=>{
            this.visible = false;
            this.targetId = undefined;
            this.elapsed = 0;
        // Dismissal survives room changes; only changing player resets the lesson.
        }, this.resetSession = ()=>{
            this.reset();
            this.dismissed = false;
        }, this.follow = (targetId, point, screen, touch, deltaMs)=>{
            this.visible = false;
            if (!targetId) this.targetId = undefined;
            if (this.dismissed || !targetId || !point) return;
            const firstAppearance = !this.targetId;
            if (firstAppearance) this.elapsed = 0;
            this.targetId = targetId;
            this.elapsed += deltaMs;
            if (this.elapsed >= 24000) {
                this.dismiss();
                return;
            }
            this.visible = true;
            this.label.text = touch ? "Touch and hold a recruit\nto feed them or give orders." : "Right-click a recruit for actions.\nTouchpad: tap with two fingers.";
            const closeSpace = 2 * (0, $e59d4eca9b366180$export$dc3c988e71114e28) + 16;
            this.label.style.wordWrap = true;
            this.label.style.wordWrapWidth = Math.max(80, screen.w - closeSpace - 36);
            const width = Math.min(this.label.width + 20 + closeSpace, screen.w - 16);
            const height = Math.max(this.label.height + 16, 2 * (0, $e59d4eca9b366180$export$dc3c988e71114e28) + 12);
            this.closeButton.position.set(width - (0, $e59d4eca9b366180$export$dc3c988e71114e28) - 6, (0, $e59d4eca9b366180$export$dc3c988e71114e28) + 6);
            this.background.clear().lineStyle(1, 0xff0000).beginFill(0x171313, 0.96).drawRoundedRect(0, 0, width, height, 5).endFill();
            const bounds = this.panel.getLocalBounds();
            this.panel.position.set(Math.max(8 - bounds.x, Math.min(screen.w - bounds.x - bounds.width - 8, point.x - width / 2)), Math.max(8 - bounds.y, Math.min(screen.h - bounds.y - bounds.height - 8, point.y - height - 48)));
            this.leader.clear().lineStyle(2, 0xff0000, 0.85).moveTo(this.panel.x + width / 2, this.panel.y + height).lineTo(point.x, point.y - 12).drawCircle(point.x, point.y - 12, 5);
            if (firstAppearance) this.onShown?.(targetId);
        };
        this.addChild(this.leader, this.panel);
        this.closeButton = new (0, $e59d4eca9b366180$export$de65de8213222d10)({
            onClick: this.dismiss
        });
        this.panel.addChild(this.background, this.label, this.closeButton);
        this.panel.interactive = true;
        this.panel.on("pointerdown", (event)=>{
            event.stopPropagation();
            onPress?.();
        });
        this.label.position.set(10, 8);
        this.visible = false;
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

class $c95294a9bc078027$export$ee1739c2abaa1d8d extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.setup = (inventoryCallback, questsCallback, feedbackCallback, mapCallback, chatCallback)=>{
            this.interactive = true;
            this.on("mouseover", ()=>{
                this.guiManager.mouseOverControl(true);
            });
            this.on("mouseout", ()=>{
                this.guiManager.mouseOverControl(false);
            });
            const items = [
                {
                    sprite: new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "inventory.png",
                        scale: 0.8
                    }),
                    callback: inventoryCallback
                },
                {
                    sprite: new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "globe.png",
                        scale: 0.8
                    }),
                    callback: mapCallback
                },
                // Chat. The keyboard's Enter opens the same thing, and on a phone there is no Enter --
                // outside a camp this button is the only way to say anything at all (in a camp the bar
                // is suppressed and the SAY chip stands in for it; see GuiManager.layoutChipRow).
                {
                    sprite: new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "action-chat.png",
                        scale: 0.8
                    }),
                    callback: chatCallback
                },
                {
                    sprite: new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "book.png",
                        scale: 1.4
                    }),
                    callback: questsCallback
                },
                {
                    sprite: new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "question.png",
                        scale: 0.6
                    }),
                    callback: ()=>this.guiManager.help(null)
                },
                {
                    sprite: new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "discord.png",
                        scale: 0.7
                    }),
                    callback: ()=>window.open("https://discord.gg/Mbt6UfqW6e")
                },
                {
                    sprite: new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: "feedback.png",
                        scale: 0.8
                    }),
                    callback: feedbackCallback,
                    padding: 5
                }
            ];
            let prevObj;
            items.forEach((item)=>{
                const obj = item.sprite;
                obj.x = (prevObj ? prevObj.x : 0) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.75 + (item.padding || 0);
                obj.y = item.sprite.height / 2;
                obj.interactive = true;
                obj.on("click", item.callback);
                obj.on("tap", item.callback);
                prevObj = obj;
                this.addChild(obj);
            });
        };
        this.guiManager = guiManager;
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");


// The location chooser: while it is up the pointer stops meaning "attack" and starts meaning
// "here". Put up by the defender's "Hold Position" order, which wants a spot on the ground at FINE
// (pixel) precision -- the build preview's tile grid is too coarse to post a guard with.
//
// Drawn rather than sprited so the whole
// reticle can carry a state color -- amber for ground the NPC can stand on, red for ground it
// can't -- without a second texture, and so it costs one Graphics on a weak GPU.
//
// GEOMETRY. This is a direct child of the stage, which carries `scale.y = SCALER` (1.3): the same
// vertical stretch every GUI widget here lives with. A circle drawn in that frame reads as an egg,
// so the container undoes the stretch (scale.y = 1/SCALER) and positions itself in stage-local
// space (global.y / SCALER). The ground ellipse underneath is squashed DELIBERATELY on top of that,
// so it lies on the ground plane the way an entity's foot shadow does.
const $76a97c569b52295c$var$RETICLE_COLOR = 0xf2a94e // warm amber -- the command wheel's rim, so the ember UI reads as one set
;
const $76a97c569b52295c$var$BLOCKED_COLOR = 0xe8705c // muted red: this ground can't be stood on
;
const $76a97c569b52295c$var$CAPTION_COLOR = 0xfff3e0;
const $76a97c569b52295c$var$RING_RADIUS = 11;
const $76a97c569b52295c$var$TICK_GAP = 4 // clear space between the ring and the cross ticks
;
const $76a97c569b52295c$var$TICK_LENGTH = 6;
const $76a97c569b52295c$var$GROUND_RADIUS_X = 17;
const $76a97c569b52295c$var$GROUND_RADIUS_Y = 6;
const $76a97c569b52295c$var$CAPTION_OFFSET_Y = 20;
class $76a97c569b52295c$export$2e19b9798c747684 extends (0, $8t5Gy.Container) {
    constructor(){
        super(), // Two captions, one line: what the pick is FOR, and — over ground nothing can stand on — why
        // clicking here will not take. The refusal replaces the prompt rather than sitting beside it,
        // so the line never has to compete with itself for the player's eye.
        this.prompt = "", this.refusal = "", this.blocked = false, // Idempotent: the first show() binds, every later one is a no-op.
        this.bindMouse = (mouse)=>{
            if (this.boundMouse || !mouse) return;
            this.boundMouse = mouse;
            mouse.addListener(this.followPointer);
        }, this.followPointer = (state)=>{
            if (!this.visible) return;
            this.x = state.position.x;
            this.y = state.position.y / (0, $10da07838e6d507c$export$c6ec669adaa5980d);
        }, this.show = (caption, blockedCaption)=>{
            this.prompt = caption;
            this.refusal = blockedCaption;
            this.blocked = false;
            this.layoutCaption();
            this.visible = true;
            // Jump straight to wherever the pointer already is instead of waiting for the next move --
            // otherwise the reticle appears at the last spot it was used, which is somewhere else.
            if (this.boundMouse) {
                const position = this.boundMouse.state().position;
                this.x = position.x;
                this.y = position.y / (0, $10da07838e6d507c$export$c6ec669adaa5980d);
            }
        }, this.hide = ()=>{
            this.visible = false;
        }, this.isVisible = ()=>this.visible, this.isBlocked = ()=>this.blocked, // The line currently under the reticle -- the prompt, or the refusal that has replaced it.
        this.captionText = ()=>this.caption.text, this.setBlocked = (blocked)=>{
            if (this.blocked === blocked) return;
            this.blocked = blocked;
            this.redraw();
        }, // The line under the reticle: the prompt, or the refusal in its place while the ground is
        // blocked. Re-centred every time because the two read at different widths.
        this.layoutCaption = ()=>{
            this.caption.text = this.blocked ? this.refusal : this.prompt;
            this.caption.x = -this.caption.width / 2;
            this.caption.y = $76a97c569b52295c$var$CAPTION_OFFSET_Y;
            this.caption.tint = this.blocked ? $76a97c569b52295c$var$BLOCKED_COLOR : $76a97c569b52295c$var$CAPTION_COLOR;
        }, this.redraw = ()=>{
            const color = this.blocked ? $76a97c569b52295c$var$BLOCKED_COLOR : $76a97c569b52295c$var$RETICLE_COLOR;
            const graphics = this.reticle;
            graphics.clear();
            // The patch of ground being chosen, lying flat.
            graphics.lineStyle(1, color, this.blocked ? 0.9 : 0.5);
            graphics.drawEllipse(0, 0, $76a97c569b52295c$var$GROUND_RADIUS_X, $76a97c569b52295c$var$GROUND_RADIUS_Y);
            // The reticle proper: a ring with four ticks aimed at its center.
            graphics.lineStyle(1.5, color, 1);
            graphics.drawCircle(0, 0, $76a97c569b52295c$var$RING_RADIUS);
            const directions = [
                [
                    1,
                    0
                ],
                [
                    -1,
                    0
                ],
                [
                    0,
                    1
                ],
                [
                    0,
                    -1
                ]
            ];
            directions.forEach(([dx, dy])=>{
                graphics.moveTo(dx * ($76a97c569b52295c$var$RING_RADIUS + $76a97c569b52295c$var$TICK_GAP), dy * ($76a97c569b52295c$var$RING_RADIUS + $76a97c569b52295c$var$TICK_GAP));
                graphics.lineTo(dx * ($76a97c569b52295c$var$RING_RADIUS + $76a97c569b52295c$var$TICK_GAP + $76a97c569b52295c$var$TICK_LENGTH), dy * ($76a97c569b52295c$var$RING_RADIUS + $76a97c569b52295c$var$TICK_GAP + $76a97c569b52295c$var$TICK_LENGTH));
            });
            graphics.beginFill(color, 1);
            graphics.drawCircle(0, 0, 1.5);
            graphics.endFill();
            this.layoutCaption();
        };
        // Undo the stage's vertical stretch so the reticle is round (see GEOMETRY above).
        this.scale.set(1, 1 / (0, $10da07838e6d507c$export$c6ec669adaa5980d));
        this.zIndex = 59000 // over the world and the HUD, under the command wheel (60000)
        ;
        this.visible = false;
        this.reticle = new (0, $gwPoJ.Graphics)();
        this.addChild(this.reticle);
        this.caption = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("compactLabel").bold().align("center").color($76a97c569b52295c$var$CAPTION_COLOR).render();
        this.addChild(this.caption);
        this.redraw();
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");


const $9ab086d4e07affe3$var$INK = 0x201b19;
const $9ab086d4e07affe3$var$IVORY = 0xfff1d5;
const $9ab086d4e07affe3$var$BRASS = 0xd9a65d;
class $9ab086d4e07affe3$export$c419b241c6d870af extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(mouse){
        super(), this.mouse = mouse, this.sight = new (0, $gwPoJ.Graphics)(), this.echo = new (0, $gwPoJ.Graphics)(), this.idleMs = 0, this.focus = 0, this.kick = 0, this.reducedMotion = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches, this.followPointer = (state)=>{
            if (this.x !== state.position.x || this.y !== state.position.y / (0, $10da07838e6d507c$export$c6ec669adaa5980d)) this.idleMs = 0;
            this.position.set(state.position.x, state.position.y / (0, $10da07838e6d507c$export$c6ec669adaa5980d));
        }, this.shot = ()=>{
            if (!this.visible || !this.renderable) return;
            this.idleMs = 0;
            this.kick = this.reducedMotion ? 0 : 1;
        }, this.animate = (deltaMs, held, suppressed)=>{
            this.renderable = !suppressed;
            if (!this.visible || suppressed) {
                const changed = this.kick !== 0 || this.focus !== 0;
                this.kick = 0;
                this.focus = 0;
                if (changed) this.draw();
                return;
            }
            const dt = Math.max(0, Math.min(deltaMs, 64));
            this.idleMs += dt;
            const nextFocus = held ? 1 : 0;
            const previousFocus = this.focus;
            const previousKick = this.kick;
            this.focus = this.reducedMotion ? nextFocus : this.focus + (nextFocus - this.focus) * (1 - Math.exp(-dt / 85));
            if (Math.abs(this.focus - nextFocus) < 0.001) this.focus = nextFocus;
            this.kick = Math.max(0, this.kick - dt / 240);
            // Keep the aim point legible while still; no looping pulse or rotation.
            const targetAlpha = held || this.idleMs < 900 ? 1 : 0.88;
            this.alpha += (targetAlpha - this.alpha) * (1 - Math.exp(-dt / 160));
            if (previousFocus !== this.focus || previousKick !== this.kick) this.draw();
        }, this.draw = ()=>{
            const sight = this.sight;
            sight.clear();
            const radius = 16 - this.focus * 2 + this.kick * 3;
            // Four separated, inward-facing corners leave the target unobscured. The dark
            // under-stroke keeps the fine warm lines readable over snow, grass and fire.
            for (const [width, color, alpha] of [
                [
                    5.5,
                    $9ab086d4e07affe3$var$INK,
                    0.95
                ],
                [
                    2.5,
                    $9ab086d4e07affe3$var$IVORY,
                    1
                ]
            ]){
                sight.lineStyle(width, color, alpha);
                for (const [x, y] of [
                    [
                        -1,
                        -1
                    ],
                    [
                        1,
                        -1
                    ],
                    [
                        1,
                        1
                    ],
                    [
                        -1,
                        1
                    ]
                ]){
                    sight.moveTo(x * (radius - 6), y * radius);
                    sight.lineTo(x * radius, y * radius);
                    sight.lineTo(x * radius, y * (radius - 6));
                }
            }
            sight.lineStyle(3.5, $9ab086d4e07affe3$var$INK, 0.95);
            sight.moveTo(0, -radius - 4).lineTo(0, -radius - 1);
            sight.moveTo(0, radius + 1).lineTo(0, radius + 4);
            sight.lineStyle(1.5, $9ab086d4e07affe3$var$BRASS, 1);
            sight.moveTo(0, -radius - 4).lineTo(0, -radius - 1);
            sight.moveTo(0, radius + 1).lineTo(0, radius + 4);
            sight.lineStyle(0);
            sight.beginFill($9ab086d4e07affe3$var$INK, 0.95).drawPolygon([
                0,
                -3.5,
                3.5,
                0,
                0,
                3.5,
                -3.5,
                0
            ]).endFill();
            sight.beginFill($9ab086d4e07affe3$var$IVORY).drawPolygon([
                0,
                -2,
                2,
                0,
                0,
                2,
                -2,
                0
            ]).endFill();
            // A single short-lived release echo, only after a projectile was created.
            this.echo.clear();
            if (this.kick > 0) {
                this.echo.lineStyle(1, $9ab086d4e07affe3$var$IVORY, this.kick * 0.55);
                const r = 20 + (1 - this.kick) * 8;
                for(let i = 0; i < 4; i++){
                    const angle = i * Math.PI / 2;
                    this.echo.moveTo(Math.cos(angle + 0.4) * r, Math.sin(angle + 0.4) * r);
                    this.echo.arc(0, 0, r, angle + 0.4, angle + 1.17);
                }
            }
        };
        this.scale.set(1, 1 / (0, $10da07838e6d507c$export$c6ec669adaa5980d));
        this.zIndex = 59000;
        this.interactive = false;
        this.interactiveChildren = false;
        this.visible = false;
        this.addChild(this.echo, this.sight);
        mouse?.addListener(this.followPointer);
        if (mouse) this.followPointer(mouse.state());
        this.draw();
    }
    destroy(options) {
        this.mouse?.removeListener(this.followPointer);
        super.destroy(options);
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $9Pi8W = parcelRequire("9Pi8W");




const $d1fcf23b0cb7db30$var$NUMBER_WORDS = [
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine"
];
const $d1fcf23b0cb7db30$var$median = (values)=>{
    if (values.length === 0) return undefined;
    const sorted = [
        ...values
    ].sort((a, b)=>a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 === 1 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
};
// The typical weapon's value for one stat. Read at call time: the table is rebound when content is
// republished (see bindContent in common/models.ts).
const $d1fcf23b0cb7db30$var$typical = (stat)=>$d1fcf23b0cb7db30$var$median(Object.values((0, $cb689cfa16c444ba$export$6e47733a887561b3) || {}).map((meta)=>meta?.[stat]).filter((value)=>typeof value === "number" && value > 0));
const $d1fcf23b0cb7db30$var$positive = (value)=>typeof value === "number" && value > 0;
const $d1fcf23b0cb7db30$export$a90c1cbaa639bde5 = (weaponType)=>{
    const words = weaponType.split(/[-_]/).join(" ");
    return words.charAt(0).toUpperCase() + words.slice(1);
};
const $d1fcf23b0cb7db30$export$dffd4f7455e1fe4f = (weaponType)=>{
    const meta = (0, $cb689cfa16c444ba$export$6e47733a887561b3)?.[weaponType];
    if (!meta) return undefined;
    const hits = meta.maxEntitiesHit || 1;
    if (hits > 1) return `cleaves ${$d1fcf23b0cb7db30$var$NUMBER_WORDS[hits] || hits}`;
    const reach = $d1fcf23b0cb7db30$var$typical("maxDistance");
    if ($d1fcf23b0cb7db30$var$positive(meta.maxDistance) && reach !== undefined && meta.maxDistance > reach) return "long reach";
    const damage = $d1fcf23b0cb7db30$var$typical("baseDamage");
    if ($d1fcf23b0cb7db30$var$positive(meta.baseDamage) && damage !== undefined && meta.baseDamage >= 2 * damage) return "heavy blows";
    if ($d1fcf23b0cb7db30$var$positive(meta.pushStrength)) return "knocks back";
    const swing = $d1fcf23b0cb7db30$var$typical("firingLatchMs");
    if ($d1fcf23b0cb7db30$var$positive(meta.firingLatchMs) && swing !== undefined && meta.firingLatchMs < swing) return "quick strikes";
    if ($d1fcf23b0cb7db30$var$positive(meta.maxDistance) && reach !== undefined && meta.maxDistance < reach) return "short reach";
    return undefined;
};
const $d1fcf23b0cb7db30$export$71510782555d9b4a = (weaponType)=>({
        name: $d1fcf23b0cb7db30$export$a90c1cbaa639bde5(weaponType),
        note: $d1fcf23b0cb7db30$export$dffd4f7455e1fe4f(weaponType)
    });


// Fade timing — mirrors CommandWheel (~100ms each way).
const $1a2af550e0229b29$var$FADE_INTERVAL_MS = 5;
const $1a2af550e0229b29$var$FADE_STEP = 0.05;
// Ember-lit palette + geometry.
const $1a2af550e0229b29$var$RIM = 0xf2a94e // warm amber rim / glow
;
const $1a2af550e0229b29$var$PANEL_FILL = 0x1b1512;
const $1a2af550e0229b29$var$PANEL_ALPHA = 0.92;
const $1a2af550e0229b29$var$CARD_IDLE_FILL = 0x2a201a;
const $1a2af550e0229b29$var$CARD_HOVER_FILL = 0x33271e;
const $1a2af550e0229b29$var$CARD_IDLE_RIM = 0x6b4f38;
const $1a2af550e0229b29$var$TEXT_COLOR = 0xfff3e0;
// What the panel calls itself. A hire is an assignment; a change is a reassignment, and saying so is
// the only cue that the single card on offer is a SWITCH rather than the job they already do.
const $1a2af550e0229b29$var$HIRE_TITLE = "Assign role";
const $1a2af550e0229b29$var$CHANGE_TITLE = "New Role";
const $1a2af550e0229b29$var$PAD = 12;
const $1a2af550e0229b29$var$TITLE_H = 20;
const $1a2af550e0229b29$var$CARD_W = 96;
// A card with no kit strip (the play-mode cards keep this, the height every card used to be).
const $1a2af550e0229b29$var$CARD_H = 104;
// The kit strip under a role card's description: a hairline, the tool's name, and a few words on
// it. The cards in a row always share one height, so a row with any kit on show is this much taller.
const $1a2af550e0229b29$var$KIT_H = 34;
const $1a2af550e0229b29$var$KIT_RULE_Y = $1a2af550e0229b29$var$CARD_H + 1;
const $1a2af550e0229b29$var$KIT_NAME_Y = $1a2af550e0229b29$var$CARD_H + 4;
const $1a2af550e0229b29$var$KIT_NOTE_Y = $1a2af550e0229b29$var$CARD_H + 19;
// What the forager works with, whatever it carries -- see ember-forager.js, which readies an axe.
const $1a2af550e0229b29$var$FORAGER_TOOL = "axe";
// The room a line of card text keeps from either edge of the card. A line that would come closer (a
// long weapon name) is scaled down to fit rather than spilling across the rim.
const $1a2af550e0229b29$var$CARD_TEXT_INSET = 6;
const $1a2af550e0229b29$var$CARD_GAP = 12;
const $1a2af550e0229b29$var$TAIL_H = 12;
const $1a2af550e0229b29$var$TAIL_HALF_W = 9;
const $1a2af550e0229b29$var$PANEL_CORNER = 10;
const $1a2af550e0229b29$var$CARD_CORNER = 8;
// Overall footprint scale. The stage applies a 1.3× vertical scale, so keep the widget compact
// enough that it still floats clear of the recruit near the top of the screen.
const $1a2af550e0229b29$var$WIDGET_SCALE = 0.82;
// Width is a function of how many cards are on offer (one, at a role change); height, of whether any
// of them carries a kit strip.
const $1a2af550e0229b29$var$panelWidthFor = (cardCount)=>cardCount * $1a2af550e0229b29$var$CARD_W + (cardCount - 1) * $1a2af550e0229b29$var$CARD_GAP + 2 * $1a2af550e0229b29$var$PAD;
const $1a2af550e0229b29$var$panelHeightFor = (cardH)=>$1a2af550e0229b29$var$TITLE_H + cardH + 2 * $1a2af550e0229b29$var$PAD;
// Origin (0,0) is the tail tip (points down at the member); the panel body floats above it.
const $1a2af550e0229b29$var$panelTopFor = (cardH)=>-($1a2af550e0229b29$var$TAIL_H + $1a2af550e0229b29$var$panelHeightFor(cardH));
const $1a2af550e0229b29$var$ROLE_CARDS = [
    {
        role: "forager",
        icon: "axe",
        title: "Forager",
        desc: [
            "Gathers wood",
            "to feed the fire"
        ],
        color: 0x7be08a,
        kit: ()=>({
                name: (0, $d1fcf23b0cb7db30$export$a90c1cbaa639bde5)($1a2af550e0229b29$var$FORAGER_TOOL),
                note: "fells trees"
            })
    },
    {
        role: "defender",
        icon: "shield",
        title: "Defender",
        desc: [
            "Guards the camp",
            "and the Lord"
        ],
        color: 0xff8a5c,
        kit: (weapon)=>weapon ? (0, $d1fcf23b0cb7db30$export$71510782555d9b4a)(weapon) : undefined
    }
];
// Set a line of card text and centre it on the card, scaled down if it would otherwise come closer to
// either edge than CARD_TEXT_INSET.
const $1a2af550e0229b29$var$setCardLine = (line, value)=>{
    line.text = value;
    line.scale.set(1);
    const room = $1a2af550e0229b29$var$CARD_W - 2 * $1a2af550e0229b29$var$CARD_TEXT_INSET;
    if (line.width > room) line.scale.set(room / line.width);
    line.x = $1a2af550e0229b29$var$CARD_W / 2 - line.width / 2;
};
class $1a2af550e0229b29$export$fcd75734e151a80 extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), this.playModePicker = false, this.stairPicker = false, this.cards = [], // Current panel width: narrower when only one card is on offer. Everything that depends on the
        // body's horizontal extent (glow, rim, hit area, card positions) reads this.
        this.panelW = $1a2af550e0229b29$var$panelWidthFor($1a2af550e0229b29$var$ROLE_CARDS.length), // Current card height: taller when a card on offer has a kit strip. The panel's height, and so
        // where its top sits above the tail, follow it.
        this.cardH = $1a2af550e0229b29$var$CARD_H, // Whether the downward pointer is drawn. The tail is a claim -- "this panel is about whoever is
        // standing under its tip" -- so it comes off when there is no longer anybody there (see
        // setTailVisible).
        this.tailVisible = true, // Logical open flag — flips the instant a fade starts so input gating frees immediately (mirrors
        // CommandWheel.isOpen semantics). Only one fader runs at a time.
        this.opened = false, this.fadeInFader = null, this.fadeOutFader = null;
        this.onSelect = props.onSelect;
        this.scale.set($1a2af550e0229b29$var$WIDGET_SCALE);
        // Swallow pointer events over the panel so clicks on the widget never fall through to a world
        // attack (the cards handle their own clicks; this covers the gaps/title too).
        this.interactive = true;
        this.hitArea = new (0, $6qzqq.Rectangle)(this.panelLeft(), this.panelTop(), this.panelW, this.panelH() + $1a2af550e0229b29$var$TAIL_H);
        this.on("pointerdown", (event)=>event.stopPropagation());
        this.on("pointermove", (event)=>event.stopPropagation());
        this.on("rightclick", (event)=>event.stopPropagation());
        this.on("contextmenu", (event)=>{
            event.preventDefault();
            event.stopPropagation();
        });
        this.bg = new (0, $gwPoJ.Graphics)();
        this.addChild(this.bg);
        this.addTitle();
        // Both cards are built once and shown or hidden by layout(); a role change hides one rather
        // than rebuilding the panel, so the hover redraw and the click handlers are wired exactly once.
        this.cards = $1a2af550e0229b29$var$ROLE_CARDS.map((meta)=>this.makeCard(meta));
        this.layout();
        this.visible = false;
    }
    // Dark "glass" panel with a warm rim, a faint outer glow (a fatter low-alpha copy — cheaper than a
    // blur filter, which matters on low-end GPUs), and a downward pointer whose tip sits at the origin.
    // The tail is drawn as a filled triangle overlapping the body's bottom edge with only its two
    // diagonals stroked, so there's no seam where it meets the body. Nothing below the body is drawn
    // at all once the tail is off, so the panel ends at its own bottom edge.
    drawBackground() {
        const g = this.bg;
        const left = this.panelLeft();
        const top = this.panelTop();
        const height = this.panelH();
        g.clear();
        // Soft outer glow.
        g.beginFill($1a2af550e0229b29$var$RIM, 0.06);
        g.drawRoundedRect(left - 5, top - 5, this.panelW + 10, height + 10, $1a2af550e0229b29$var$PANEL_CORNER + 5);
        g.endFill();
        // Body.
        g.lineStyle(2, $1a2af550e0229b29$var$RIM, 0.9);
        g.beginFill($1a2af550e0229b29$var$PANEL_FILL, $1a2af550e0229b29$var$PANEL_ALPHA);
        g.drawRoundedRect(left, top, this.panelW, height, $1a2af550e0229b29$var$PANEL_CORNER);
        g.endFill();
        if (!this.tailVisible) return;
        // Tail fill (base tucked 1px up into the body so the join is hidden).
        const baseY = -$1a2af550e0229b29$var$TAIL_H - 1;
        g.lineStyle(0);
        g.beginFill($1a2af550e0229b29$var$PANEL_FILL, $1a2af550e0229b29$var$PANEL_ALPHA);
        g.moveTo(-$1a2af550e0229b29$var$TAIL_HALF_W, baseY);
        g.lineTo(0, 0);
        g.lineTo($1a2af550e0229b29$var$TAIL_HALF_W, baseY);
        g.closePath();
        g.endFill();
        // Tail rim: stroke only the two visible diagonals (not the hidden base).
        g.lineStyle(2, $1a2af550e0229b29$var$RIM, 0.9);
        g.moveTo(-$1a2af550e0229b29$var$TAIL_HALF_W, baseY);
        g.lineTo(0, 0);
        g.lineTo($1a2af550e0229b29$var$TAIL_HALF_W, baseY);
    }
    addTitle() {
        this.title = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($1a2af550e0229b29$var$TEXT_COLOR).role("caption").bold().align("center").render($1a2af550e0229b29$var$HIRE_TITLE);
        this.title.y = this.panelTop() + $1a2af550e0229b29$var$PAD - 2;
        this.title.alpha = 0.95;
        this.addChild(this.title);
    }
    makeCard(meta) {
        const container = new (0, $8t5Gy.Container)();
        container.y = this.cardY();
        container.interactive = true;
        container.cursor = "pointer";
        container.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $1a2af550e0229b29$var$CARD_W, $1a2af550e0229b29$var$CARD_H);
        const bg = new (0, $gwPoJ.Graphics)();
        container.addChild(bg);
        const glyph = meta.icon ? (0, $ec5c35dbffc1f325$export$46ad086a5552f2fb)(meta.icon, 34, meta.color) : new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(34).align("center").render(meta.emoji);
        if (glyph instanceof (0, $9Pi8W.Text)) glyph.anchor.set(0.5);
        glyph.position.set($1a2af550e0229b29$var$CARD_W / 2, 29);
        container.addChild(glyph);
        // Title in the role accent color.
        const title = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(meta.color).role("label").bold().align("center").render(meta.title);
        title.x = $1a2af550e0229b29$var$CARD_W / 2 - title.width / 2;
        title.y = 56;
        container.addChild(title);
        // Two-line description.
        meta.desc.forEach((line, i)=>{
            const t = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($1a2af550e0229b29$var$TEXT_COLOR).role("compactCaption").align("center").render(line);
            t.x = $1a2af550e0229b29$var$CARD_W / 2 - t.width / 2;
            t.y = 78 + i * 12;
            t.alpha = 0.82;
            container.addChild(t);
        });
        // The kit strip, filled in (or hidden) by layout() for whoever the picker is bound to: a
        // hairline in the role colour, the tool's name, and what it is good at in the role colour.
        const kitRule = new (0, $gwPoJ.Graphics)();
        kitRule.lineStyle(1, meta.color, 0.4);
        kitRule.moveTo($1a2af550e0229b29$var$CARD_W * 0.25, $1a2af550e0229b29$var$KIT_RULE_Y);
        kitRule.lineTo($1a2af550e0229b29$var$CARD_W * 0.75, $1a2af550e0229b29$var$KIT_RULE_Y);
        container.addChild(kitRule);
        const kitName = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($1a2af550e0229b29$var$TEXT_COLOR).role("compactLabel").bold().align("center").render("");
        kitName.y = $1a2af550e0229b29$var$KIT_NAME_Y;
        container.addChild(kitName);
        const kitNote = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(meta.color).role("compactCaption").align("center").render("");
        kitNote.y = $1a2af550e0229b29$var$KIT_NOTE_Y;
        container.addChild(kitNote);
        const handle = {
            container: container,
            bg: bg,
            meta: meta,
            hovered: false,
            kitRule: kitRule,
            kitName: kitName,
            kitNote: kitNote
        };
        this.drawCard(handle);
        container.on("pointerover", ()=>{
            handle.hovered = true;
            this.drawCard(handle);
        });
        container.on("pointerout", ()=>{
            handle.hovered = false;
            this.drawCard(handle);
        });
        container.on("pointerdown", (event)=>{
            event.stopPropagation();
            this.onSelect?.(meta.role, this.currentRole);
        });
        this.addChild(container);
        return handle;
    }
    // Draw (or redraw on hover) a card: idle = warm charcoal fill + muted rim; hovered = a soft glow
    // in the role color, a brighter fill, and a full role-color rim.
    drawCard(handle) {
        const g = handle.bg;
        const color = handle.meta.color;
        g.clear();
        if (handle.hovered || this.playModePicker && handle.meta.role === this.currentRole) {
            g.beginFill(color, 0.16);
            g.drawRoundedRect(-3, -3, $1a2af550e0229b29$var$CARD_W + 6, this.cardH + 6, $1a2af550e0229b29$var$CARD_CORNER + 3);
            g.endFill();
            g.lineStyle(2, color, 1);
            g.beginFill($1a2af550e0229b29$var$CARD_HOVER_FILL, 0.97);
        } else {
            g.lineStyle(1.5, $1a2af550e0229b29$var$CARD_IDLE_RIM, 0.7);
            g.beginFill($1a2af550e0229b29$var$CARD_IDLE_FILL, 0.9);
        }
        g.drawRoundedRect(0, 0, $1a2af550e0229b29$var$CARD_W, this.cardH, $1a2af550e0229b29$var$CARD_CORNER);
        g.endFill();
    }
    // Show a card's kit strip for `kit`, or hide it.
    showKit(handle, kit) {
        handle.kitRule.visible = !!kit;
        handle.kitName.visible = !!kit;
        handle.kitNote.visible = !!kit?.note;
        if (!kit) return;
        $1a2af550e0229b29$var$setCardLine(handle.kitName, kit.name);
        $1a2af550e0229b29$var$setCardLine(handle.kitNote, kit.note || "");
    }
    clearHover() {
        this.cards.forEach((card)=>{
            if (card.hovered) {
                card.hovered = false;
                this.drawCard(card);
            }
        });
    }
    // Bind the picker to a single member so GuiManager can keep it positioned over that NPC and scope
    // the chosen role back to it.
    //
    // `currentRole` is the job that member is doing NOW, passed only by a "Change Role" order: its
    // card is dropped from the offer (there is nothing to pick in "keep doing what you are doing")
    // and the panel re-titles and narrows around what is left. Omit it for a hire, where both jobs
    // are on offer.
    bindPlayMode(targetEntityId, currentMode) {
        this.availableRoles = undefined;
        this.stairPicker = false;
        this.playModePicker = true;
        this.replaceCards([
            {
                role: "pvp",
                emoji: "\u2694\uFE0F",
                title: "PVP",
                desc: [
                    "No restrictions",
                    "Player hits allowed"
                ],
                color: 0xff8a5c
            },
            {
                role: "cooperation",
                emoji: "\uD83E\uDD1D",
                title: "Cooperation",
                desc: [
                    "Work together",
                    "No player hits"
                ],
                color: 0x7be08a
            }
        ]);
        this.targetEntityId = targetEntityId;
        this.currentRole = currentMode;
        this.layout();
    }
    replaceCards(cards) {
        this.cards.forEach((card)=>{
            this.removeChild(card.container);
            card.container.destroy({
                children: true
            });
        });
        this.cards = cards.map((meta)=>this.makeCard(meta));
    }
    bindStairs(targetEntityId) {
        this.availableRoles = undefined;
        this.stairPicker = true;
        this.playModePicker = false;
        this.currentRole = undefined;
        this.weapon = undefined;
        this.targetEntityId = targetEntityId;
        this.replaceCards([
            {
                role: "up",
                icon: "stairs-up",
                title: "Up",
                desc: [
                    "Build stairs",
                    "to the floor above"
                ],
                color: 0x7be08a
            },
            {
                role: "down",
                icon: "stairs",
                title: "Down",
                desc: [
                    "Build stairs",
                    "to the floor below"
                ],
                color: 0xff8a5c
            }
        ]);
        this.layout();
    }
    //
    // `weapon` is the weapon type that member holds, as the server reported it; the Defender card names
    // it and says what it is good at. Without it the Defender card simply has no kit strip.
    bindToEntity(targetEntityId, currentRole, weapon, availableRoles) {
        if (this.playModePicker || this.stairPicker) {
            this.stairPicker = false;
            this.playModePicker = false;
            this.replaceCards($1a2af550e0229b29$var$ROLE_CARDS);
        }
        this.targetEntityId = targetEntityId;
        this.currentRole = currentRole;
        this.availableRoles = availableRoles;
        this.weapon = weapon;
        this.clearHover();
        this.layout();
    }
    clearTarget() {
        this.availableRoles = undefined;
        this.targetEntityId = undefined;
        this.currentRole = undefined;
        this.weapon = undefined;
    }
    // The left edge of the body, which is centred on the tail tip at the origin.
    panelLeft() {
        return -this.panelW / 2;
    }
    panelH() {
        return $1a2af550e0229b29$var$panelHeightFor(this.cardH);
    }
    // The top edge of the body, which hangs above the tail.
    panelTop() {
        return $1a2af550e0229b29$var$panelTopFor(this.cardH);
    }
    cardY() {
        return this.panelTop() + $1a2af550e0229b29$var$PAD + $1a2af550e0229b29$var$TITLE_H;
    }
    // Size the panel to the cards on offer and lay them out centred under the title. Called on every
    // bind, because which cards are on offer is a property of what the picker was opened FOR.
    layout() {
        const offered = this.cards.map((card)=>card.meta).filter((meta)=>(this.playModePicker || meta.role !== this.currentRole) && (!this.availableRoles || this.availableRoles.includes(meta.role)));
        this.panelW = $1a2af550e0229b29$var$panelWidthFor(offered.length);
        const kits = new Map(offered.map((meta)=>[
                meta,
                meta.kit?.(this.weapon)
            ]));
        this.cardH = offered.some((meta)=>kits.get(meta)) ? $1a2af550e0229b29$var$CARD_H + $1a2af550e0229b29$var$KIT_H : $1a2af550e0229b29$var$CARD_H;
        const firstX = this.panelLeft() + $1a2af550e0229b29$var$PAD;
        let slot = 0;
        this.cards.forEach((card)=>{
            const shown = offered.indexOf(card.meta) >= 0;
            card.container.y = this.cardY();
            card.container.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $1a2af550e0229b29$var$CARD_W, this.cardH);
            this.showKit(card, shown ? kits.get(card.meta) : undefined);
            this.drawCard(card);
            card.container.visible = shown;
            // A hidden card keeps its hit area, so park it out of the way as well as out of sight --
            // an invisible Container still answers pointer events in pixi.
            card.container.interactive = shown;
            if (shown) {
                card.container.x = firstX + slot * ($1a2af550e0229b29$var$CARD_W + $1a2af550e0229b29$var$CARD_GAP);
                slot += 1;
            }
        });
        this.title.text = this.stairPicker ? "Build stairs" : this.playModePicker ? "Play Mode" : this.currentRole ? $1a2af550e0229b29$var$CHANGE_TITLE : $1a2af550e0229b29$var$HIRE_TITLE;
        this.title.x = -this.title.width / 2;
        this.title.y = this.panelTop() + $1a2af550e0229b29$var$PAD - 2;
        this.hitArea = new (0, $6qzqq.Rectangle)(this.panelLeft(), this.panelTop(), this.panelW, this.panelH() + (this.tailVisible ? $1a2af550e0229b29$var$TAIL_H : 0));
        this.drawBackground();
    }
    // Show or hide the downward pointer. A recruit can walk off while the picker is up, and a tail
    // left behind would aim at bare ground -- or worse, at whoever wandered into that spot. Without
    // it the panel is just a panel, which is the honest thing to show. The hit area follows so the
    // widget stops swallowing clicks on a strip of world it no longer covers.
    setTailVisible(visible) {
        if (this.tailVisible === visible) return;
        this.tailVisible = visible;
        this.hitArea = new (0, $6qzqq.Rectangle)(this.panelLeft(), this.panelTop(), this.panelW, this.panelH() + (visible ? $1a2af550e0229b29$var$TAIL_H : 0));
        this.drawBackground();
    }
    getTargetEntityId() {
        return this.targetEntityId;
    }
    // The panel body's footprint, in the PARENT's units (the widget scales itself down). What a
    // caller needs to park the panel somewhere in the HUD rather than over an entity.
    getPanelWidth() {
        return this.panelW * $1a2af550e0229b29$var$WIDGET_SCALE;
    }
    getPanelHeight() {
        return this.panelH() * $1a2af550e0229b29$var$WIDGET_SCALE;
    }
    // How far the widget's origin (the tail TIP) sits below the body's bottom edge. The panel hangs
    // above its own origin, so anything placing the body has to add this back.
    getTailDrop() {
        return $1a2af550e0229b29$var$TAIL_H * $1a2af550e0229b29$var$WIDGET_SCALE;
    }
    // Park the panel's BODY with its top-left corner at (x, y) in the parent's frame -- how the picker
    // is placed when it belongs to a roster card rather than to an entity on screen.
    placeBodyTopLeftAt(x, y) {
        this.position.set(x + this.getPanelWidth() / 2, y + this.getPanelHeight() + this.getTailDrop());
    }
    // Which roles the panel is currently offering, in the order the cards are laid out. One at a role
    // change (the job the member already does is not on offer), both at a hire.
    getOfferedRoles() {
        return this.cards.filter((card)=>card.container.visible).map((card)=>card.meta.role);
    }
    // The card on offer for `role`, in its own frame (0,0 is its top-left corner), and its current
    // height. For checking what a card says and that it all fits; undefined when it is not on offer.
    getCard(role) {
        const card = this.cards.find((candidate)=>candidate.meta.role === role && candidate.container.visible);
        return card ? {
            container: card.container,
            width: $1a2af550e0229b29$var$CARD_W,
            height: this.cardH
        } : undefined;
    }
    isOpen() {
        return this.opened;
    }
    // Reveal by fading in, interrupting an in-progress dismiss (mirrors CommandWheel.fadeIn).
    fadeIn() {
        this.opened = true;
        if (this.fadeOutFader) {
            this.fadeOutFader.stop(true);
            this.fadeOutFader = null;
        }
        if (this.fadeInFader) return;
        if (!this.visible) this.alpha = 0;
        this.visible = true;
        if (this.alpha >= 1) {
            this.alpha = 1;
            return;
        }
        this.fadeInFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "in",
            minAlpha: 1.0,
            fadeInterval: $1a2af550e0229b29$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $1a2af550e0229b29$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeInFader = null;
                this.alpha = 1;
            }
        });
        this.fadeInFader.update();
    }
    // Dismiss by fading out, hiding once transparent (mirrors CommandWheel.fadeOut).
    fadeOut() {
        this.opened = false;
        this.clearHover();
        if (this.fadeInFader) {
            this.fadeInFader.stop(true);
            this.fadeInFader = null;
        }
        if (this.fadeOutFader || !this.visible) return;
        this.fadeOutFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "out",
            minAlpha: 0.0,
            fadeInterval: $1a2af550e0229b29$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $1a2af550e0229b29$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeOutFader = null;
                this.visible = false;
                this.alpha = 1.0;
            }
        });
        this.fadeOutFader.update();
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");

var $8JEKL = parcelRequire("8JEKL");
// What an entity's displayed NAME is allowed to be.
//
// Entity names used to be fixed strings baked into a spawn template ("The Defender"), so nothing
// ever had to validate one. They are now also PLAYER INPUT: a camp member can be named by whoever
// recruited it (see the ember role picker's name prompt), and in a shared camp that name is
// shown to every other player in the roster, so it goes through here on the way in.
//
// Lives in common so the one cap and the one cleaner are shared: the client limits what can be
// typed, the server refuses to store anything else, and neither can drift from the other.
// Longest name we keep. Matched to the ember roster card's own display cap (NAME_MAX_CHARS in
// ember_roster_card.ts), which is where names are read most: a longer one would arrive and then be
// shown ellipsized, which looks like the field lost the end of what was typed.
const $f515f7e7306690f2$export$3f7a98c621297efa = 11;
/**
 * Whether a code point may appear in a name: everything except the C0/C1 control codes and the
 * zero-width / directional-formatting marks. That second group is the one worth being explicit
 * about -- those spell nothing, they let a name hide characters inside itself or reorder the row it
 * is drawn in, which is a cheap way to misrepresent one player's crew to another.
 *
 * Written as comparisons rather than a regex character class on purpose: a class of escapes for
 * these is unreadable, and one mistyped digit silently widens it over real letters.
 */ const $f515f7e7306690f2$var$isNameCharacter = (codePoint)=>{
    if (codePoint <= 0x1f) return false // C0 controls (tab and newline included -- whitespace is collapsed below)
    ;
    if (codePoint >= 0x7f && codePoint <= 0x9f) return false // delete + C1 controls
    ;
    if (codePoint >= 0x200b && codePoint <= 0x200f) return false // zero-width space/joiners, LTR/RTL marks
    ;
    if (codePoint === 0x2028 || codePoint === 0x2029) return false // line + paragraph separators
    ;
    if (codePoint >= 0x202a && codePoint <= 0x202e) return false // bidi embeddings and overrides
    ;
    if (codePoint >= 0x2066 && codePoint <= 0x2069) return false // bidi isolates
    ;
    if (codePoint === 0xfeff) return false // byte-order mark / zero-width no-break space
    ;
    return true;
};
const $f515f7e7306690f2$export$994e283d47c52c2e = (raw)=>{
    if (typeof raw !== "string") return "";
    // Array.from splits by code POINT, so an astral character (an emoji) is weighed, kept or cut as
    // one thing rather than as two halves of a surrogate pair.
    const printable = Array.from(raw).filter((character)=>$f515f7e7306690f2$var$isNameCharacter(character.codePointAt(0) || 0)).join("");
    return printable.replace(/\s+/g, " ").trim().slice(0, $f515f7e7306690f2$export$3f7a98c621297efa).trim();
};




// The name prompt: a small field that floats over a camp member so the player can name it.
//
// Put up by the server (Protocol.type_openNamePrompt) at the two moments naming belongs to -- the
// end of a hire, as the last beat of the role picker, and the "Rename" order from a member's
// command wheel. It always opens on a name the member ALREADY has (one rolled from the camp's
// register, server-side), so the player is editing rather than filling in a blank, and dismissing
// it keeps that name. Nothing waits on the answer.
//
// Styled and driven exactly like role_picker.ts beside it -- same ember-lit palette, same
// bind/fade API so GuiManager can treat them the same way. Unlike the picker it does NOT follow its
// entity: it is pinned where it opened, because a field that slides around under a cursor (and a
// soft keyboard) is hard to type into. Same reasoning as the command wheel staying put.
//
// The text field is pixi-text-input, i.e. a real DOM <input> positioned over the canvas, which is
// what makes it work with a phone's keyboard. The two departures from the library's defaults are
// the same ones intro/login_field.ts documents at length (substituteText off, our own box), and
// are repeated rather than shared because that class is wired into the intro's own theme.
// Fade timing -- mirrors RolePicker / CommandWheel (~100ms each way).
const $c40c25df820e3512$var$FADE_INTERVAL_MS = 5;
const $c40c25df820e3512$var$FADE_STEP = 0.05;
// Ember-lit palette. Kept in sync by hand with role_picker.ts (the two open over the same NPC, one
// after the other, so they have to read as one panel).
const $c40c25df820e3512$var$RIM = 0xf2a94e;
const $c40c25df820e3512$var$PANEL_FILL = 0x1b1512;
const $c40c25df820e3512$var$PANEL_ALPHA = 0.92;
const $c40c25df820e3512$var$TEXT_COLOR = 0xfff3e0;
const $c40c25df820e3512$var$BUTTON_IDLE_FILL = 0x2a201a;
const $c40c25df820e3512$var$BUTTON_HOVER_FILL = 0x33271e;
const $c40c25df820e3512$var$BUTTON_IDLE_RIM = 0x6b4f38;
const $c40c25df820e3512$var$PAD = 12;
const $c40c25df820e3512$var$TITLE_H = 18;
const $c40c25df820e3512$var$FIELD_H = 26;
const $c40c25df820e3512$var$GAP = 8;
const $c40c25df820e3512$var$BUTTON_W = 88;
const $c40c25df820e3512$var$BUTTON_H = 24;
const $c40c25df820e3512$var$TAIL_H = 12;
const $c40c25df820e3512$var$TAIL_HALF_W = 9;
const $c40c25df820e3512$var$PANEL_CORNER = 10;
const $c40c25df820e3512$var$BUTTON_CORNER = 6;
const $c40c25df820e3512$var$PANEL_W = 184;
const $c40c25df820e3512$var$PANEL_H = $c40c25df820e3512$var$PAD + $c40c25df820e3512$var$TITLE_H + $c40c25df820e3512$var$GAP + $c40c25df820e3512$var$FIELD_H + $c40c25df820e3512$var$GAP + $c40c25df820e3512$var$BUTTON_H + $c40c25df820e3512$var$PAD;
// Origin (0,0) is the tail tip (points down at the entity); the panel body floats above it.
const $c40c25df820e3512$var$PANEL_LEFT = -$c40c25df820e3512$var$PANEL_W / 2;
const $c40c25df820e3512$var$PANEL_TOP = -($c40c25df820e3512$var$TAIL_H + $c40c25df820e3512$var$PANEL_H);
const $c40c25df820e3512$var$FIELD_W = $c40c25df820e3512$var$PANEL_W - 2 * $c40c25df820e3512$var$PAD;
const $c40c25df820e3512$var$FIELD_X = $c40c25df820e3512$var$PANEL_LEFT + $c40c25df820e3512$var$PAD;
const $c40c25df820e3512$var$FIELD_Y = $c40c25df820e3512$var$PANEL_TOP + $c40c25df820e3512$var$PAD + $c40c25df820e3512$var$TITLE_H + $c40c25df820e3512$var$GAP;
const $c40c25df820e3512$var$BUTTON_X = -$c40c25df820e3512$var$BUTTON_W / 2;
const $c40c25df820e3512$var$BUTTON_Y = $c40c25df820e3512$var$FIELD_Y + $c40c25df820e3512$var$FIELD_H + $c40c25df820e3512$var$GAP;
class $c40c25df820e3512$export$8a1c693d5de025d7 extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), this.buttonHovered = false, // Whether the downward pointer is drawn. The prompt stays where it opened while its subject is
        // free to walk off, so the tail is the first thing to stop being true (see setTailVisible).
        this.tailVisible = true, // Logical open flag -- flips the instant a fade starts so input gating frees immediately
        // (mirrors RolePicker.isOpen semantics). Only one fader runs at a time.
        this.opened = false, this.fadeInFader = null, this.fadeOutFader = null;
        this.onSubmit = props.onSubmit;
        this.onCancel = props.onCancel;
        // Swallow pointer events over the panel so a click on it never falls through to a world
        // attack (the field and button handle their own; this covers the gaps and the title).
        this.interactive = true;
        this.hitArea = new (0, $6qzqq.Rectangle)($c40c25df820e3512$var$PANEL_LEFT, $c40c25df820e3512$var$PANEL_TOP, $c40c25df820e3512$var$PANEL_W, $c40c25df820e3512$var$PANEL_H + $c40c25df820e3512$var$TAIL_H);
        this.on("pointerdown", (event)=>event.stopPropagation());
        this.on("pointermove", (event)=>event.stopPropagation());
        this.on("rightclick", (event)=>event.stopPropagation());
        this.on("contextmenu", (event)=>{
            event.preventDefault();
            event.stopPropagation();
        });
        this.bg = new (0, $gwPoJ.Graphics)();
        this.addChild(this.bg);
        this.drawBackground();
        this.titleText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($c40c25df820e3512$var$TEXT_COLOR).role("caption").bold().align("center").render("Name them");
        this.titleText.x = -this.titleText.width / 2;
        this.titleText.y = $c40c25df820e3512$var$PANEL_TOP + $c40c25df820e3512$var$PAD - 2;
        this.titleText.alpha = 0.95;
        this.addChild(this.titleText);
        this.input = this.makeField();
        this.addChild(this.input);
        const { container: container, bg: bg } = this.makeButton();
        this.button = container;
        this.buttonBg = bg;
        this.drawButton();
        this.addChild(this.button);
        this.visible = false;
    }
    // Dark "glass" panel with a warm rim, a faint outer glow (a fatter low-alpha copy rather than a
    // blur filter, which matters on low-end GPUs) and a downward pointer whose tip sits at the
    // origin. Drawn exactly as role_picker.ts draws its own, tail and all.
    drawBackground() {
        const g = this.bg;
        g.clear();
        g.beginFill($c40c25df820e3512$var$RIM, 0.06);
        g.drawRoundedRect($c40c25df820e3512$var$PANEL_LEFT - 5, $c40c25df820e3512$var$PANEL_TOP - 5, $c40c25df820e3512$var$PANEL_W + 10, $c40c25df820e3512$var$PANEL_H + 10, $c40c25df820e3512$var$PANEL_CORNER + 5);
        g.endFill();
        g.lineStyle(2, $c40c25df820e3512$var$RIM, 0.9);
        g.beginFill($c40c25df820e3512$var$PANEL_FILL, $c40c25df820e3512$var$PANEL_ALPHA);
        g.drawRoundedRect($c40c25df820e3512$var$PANEL_LEFT, $c40c25df820e3512$var$PANEL_TOP, $c40c25df820e3512$var$PANEL_W, $c40c25df820e3512$var$PANEL_H, $c40c25df820e3512$var$PANEL_CORNER);
        g.endFill();
        if (!this.tailVisible) return;
        // Tail fill (base tucked 1px up into the body so the join is hidden), then only its two
        // visible diagonals stroked.
        const baseY = -$c40c25df820e3512$var$TAIL_H - 1;
        g.lineStyle(0);
        g.beginFill($c40c25df820e3512$var$PANEL_FILL, $c40c25df820e3512$var$PANEL_ALPHA);
        g.moveTo(-$c40c25df820e3512$var$TAIL_HALF_W, baseY);
        g.lineTo(0, 0);
        g.lineTo($c40c25df820e3512$var$TAIL_HALF_W, baseY);
        g.closePath();
        g.endFill();
        g.lineStyle(2, $c40c25df820e3512$var$RIM, 0.9);
        g.moveTo(-$c40c25df820e3512$var$TAIL_HALF_W, baseY);
        g.lineTo(0, 0);
        g.lineTo($c40c25df820e3512$var$TAIL_HALF_W, baseY);
    }
    makeField() {
        const input = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
            input: {
                fontFamily: "Arial, sans-serif",
                fontSize: "15px",
                lineHeight: `${$c40c25df820e3512$var$FIELD_H}px`,
                height: `${$c40c25df820e3512$var$FIELD_H}px`,
                width: `${$c40c25df820e3512$var$FIELD_W}px`,
                boxSizing: "border-box",
                padding: "0 8px",
                textAlign: "center",
                color: "#fff3e0",
                caretColor: "#f2a94e",
                multiline: false
            },
            box: (w, h, state)=>{
                const g = new (0, $gwPoJ.Graphics)();
                g.lineStyle(1.5, state === "FOCUSED" ? $c40c25df820e3512$var$RIM : $c40c25df820e3512$var$BUTTON_IDLE_RIM, state === "FOCUSED" ? 1 : 0.7);
                g.beginFill(0x120e0b, 0.95);
                g.drawRoundedRect(0, 0, w, h, $c40c25df820e3512$var$BUTTON_CORNER);
                g.endFill();
                return g;
            }
        });
        // Keep the real <input> on screen instead of the library's pixi Text stand-in: that copy is
        // a canvas raster scaled by the stage transform, and it hides the field from the browser
        // while unfocused. The constructor always builds the stand-in before we can opt out, and
        // _destroySurrogate() leaves _surrogate_mask behind -- an opaque black Graphics that would
        // paint a slab over our frame. Take it out. (Same two fixes as intro/login_field.ts.)
        input.substituteText = false;
        const orphanedMask = input._surrogate_mask;
        if (orphanedMask) {
            input.removeChild(orphanedMask);
            orphanedMask.destroy();
            input._surrogate_mask = null;
        }
        input.x = $c40c25df820e3512$var$FIELD_X;
        input.y = $c40c25df820e3512$var$FIELD_Y;
        // The server refuses anything longer anyway (sanitizeEntityName); capping the field means a
        // player never types a name and then watches its tail disappear.
        input.maxLength = (0, $f515f7e7306690f2$export$3f7a98c621297efa);
        const dom = input._dom_input;
        dom.setAttribute("aria-label", "Name");
        dom.setAttribute("autocapitalize", "words");
        dom.setAttribute("autocorrect", "off");
        dom.setAttribute("spellcheck", "false");
        // Enter accepts, Escape backs out. Both on key-UP because that is the event the library
        // forwards -- and Escape in particular only arrives here while the field has focus, which is
        // why GuiManager also lets Escape through its typing suppression.
        input.on("keyup", (keycode)=>{
            if (keycode === 13) this.submit();
            if (keycode === 27) this.onCancel?.();
        });
        return input;
    }
    makeButton() {
        const container = new (0, $8t5Gy.Container)();
        container.x = $c40c25df820e3512$var$BUTTON_X;
        container.y = $c40c25df820e3512$var$BUTTON_Y;
        container.interactive = true;
        container.cursor = "pointer";
        container.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $c40c25df820e3512$var$BUTTON_W, $c40c25df820e3512$var$BUTTON_H);
        const bg = new (0, $gwPoJ.Graphics)();
        container.addChild(bg);
        const label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($c40c25df820e3512$var$TEXT_COLOR).role("compactBody").bold().align("center").render("Done");
        label.x = $c40c25df820e3512$var$BUTTON_W / 2 - label.width / 2;
        label.y = $c40c25df820e3512$var$BUTTON_H / 2 - label.height / 2;
        container.addChild(label);
        container.on("pointerover", ()=>{
            this.buttonHovered = true;
            this.drawButton();
        });
        container.on("pointerout", ()=>{
            this.buttonHovered = false;
            this.drawButton();
        });
        container.on("pointerdown", (event)=>{
            event.stopPropagation();
            this.submit();
        });
        return {
            container: container,
            bg: bg
        };
    }
    drawButton() {
        const g = this.buttonBg;
        if (!g) return;
        g.clear();
        if (this.buttonHovered) {
            g.beginFill($c40c25df820e3512$var$RIM, 0.14);
            g.drawRoundedRect(-3, -3, $c40c25df820e3512$var$BUTTON_W + 6, $c40c25df820e3512$var$BUTTON_H + 6, $c40c25df820e3512$var$BUTTON_CORNER + 3);
            g.endFill();
            g.lineStyle(2, $c40c25df820e3512$var$RIM, 1);
            g.beginFill($c40c25df820e3512$var$BUTTON_HOVER_FILL, 0.97);
        } else {
            g.lineStyle(1.5, $c40c25df820e3512$var$BUTTON_IDLE_RIM, 0.7);
            g.beginFill($c40c25df820e3512$var$BUTTON_IDLE_FILL, 0.9);
        }
        g.drawRoundedRect(0, 0, $c40c25df820e3512$var$BUTTON_W, $c40c25df820e3512$var$BUTTON_H, $c40c25df820e3512$var$BUTTON_CORNER);
        g.endFill();
    }
    /**
     * Show or hide the DOM <input> itself.
     *
     * pixi-text-input syncs the real <input>'s position AND its css display from render(), i.e.
     * only while the panel is actually being drawn. So the moment this container's `visible` goes
     * false, pixi stops drawing it and the library never gets another chance to hide the field --
     * leaving the typed name on the page for good: crisp, fixed in screen space, floating over
     * whatever the player does next. (It bites anything that is hidden before it is torn down --
     * the intro's login card hides itself the moment you press Play and only disposes once the
     * server answers, so intro/login_field.ts carries the same pair of methods.)
     *
     * So the prompt drives it itself, around every open and close.
     */ setFieldVisible(visible) {
        this.input._setDOMInputVisible(visible);
    }
    // An empty field means "leave the name alone" rather than "clear the name", so it cancels.
    submit() {
        const value = (this.input.text || "").trim();
        if (!value) {
            this.onCancel?.();
            return;
        }
        this.onSubmit?.(value);
    }
    // Bind the prompt to one entity and start the field on the name it already has. The focus is
    // deferred a tick on purpose: a focus() issued while the browser is still dispatching the
    // pointerdown that led here is handed straight back to the canvas, leaving the player typing at
    // the game instead of the field (the trap intro/login_field.ts hit).
    bindToEntity(targetEntityId, name) {
        this.targetEntityId = targetEntityId;
        this.input.text = name || "";
        this.buttonHovered = false;
        this.drawButton();
        setTimeout(()=>{
            if (this.opened) // select(), not focus(): the field opens on a name already, and the player's first
            // keystroke should replace it rather than land in the middle of it.
            this.input.select();
        }, 0);
    }
    clearTarget() {
        this.targetEntityId = undefined;
        this.input.blur();
    }
    // Show or hide the downward pointer. This prompt is pinned where it opened on purpose, so the
    // member being named routinely walks out from under it -- and a tail hanging over the spot they
    // left points at bare ground, or at whoever stepped into it. Dropping it leaves a plain panel,
    // which is the honest thing to show. The hit area follows so the widget stops swallowing clicks
    // on a strip of world it no longer covers.
    setTailVisible(visible) {
        if (this.tailVisible === visible) return;
        this.tailVisible = visible;
        this.hitArea = new (0, $6qzqq.Rectangle)($c40c25df820e3512$var$PANEL_LEFT, $c40c25df820e3512$var$PANEL_TOP, $c40c25df820e3512$var$PANEL_W, $c40c25df820e3512$var$PANEL_H + (visible ? $c40c25df820e3512$var$TAIL_H : 0));
        this.drawBackground();
    }
    getTargetEntityId() {
        return this.targetEntityId;
    }
    isOpen() {
        return this.opened;
    }
    // Reveal by fading in, interrupting an in-progress dismiss (mirrors RolePicker.fadeIn).
    fadeIn() {
        this.opened = true;
        // Shown on the NEXT frame, not this one: the library places the DOM input from its own
        // render(), so a field made visible before that first render is briefly drawn wherever the
        // page would have put it -- a flash of the name in the top-left corner. Still done by hand
        // rather than left to the library, because a reopen that interrupts a dismissal can leave
        // the panel's transform unchanged, and the library only re-syncs when something about it
        // has changed -- which would leave the field hidden for good.
        requestAnimationFrame(()=>{
            if (this.opened) this.setFieldVisible(true);
        });
        if (this.fadeOutFader) {
            this.fadeOutFader.stop(true);
            this.fadeOutFader = null;
        }
        if (this.fadeInFader) return;
        if (!this.visible) this.alpha = 0;
        this.visible = true;
        if (this.alpha >= 1) {
            this.alpha = 1;
            return;
        }
        this.fadeInFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "in",
            minAlpha: 1.0,
            fadeInterval: $c40c25df820e3512$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $c40c25df820e3512$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeInFader = null;
                this.alpha = 1;
            }
        });
        this.fadeInFader.update();
    }
    // Dismiss by fading out, hiding once transparent (mirrors RolePicker.fadeOut). The DOM input
    // follows worldVisible/worldAlpha, so it goes with it.
    fadeOut() {
        this.opened = false;
        this.buttonHovered = false;
        this.drawButton();
        this.input.blur();
        // Before the early returns below, and before the fade rather than at the end of it: every
        // path out of here has to take the field with it (see setFieldVisible).
        this.setFieldVisible(false);
        if (this.fadeInFader) {
            this.fadeInFader.stop(true);
            this.fadeInFader = null;
        }
        if (this.fadeOutFader || !this.visible) return;
        this.fadeOutFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "out",
            minAlpha: 0.0,
            fadeInterval: $c40c25df820e3512$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $c40c25df820e3512$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeOutFader = null;
                this.visible = false;
                this.alpha = 1.0;
                this.setFieldVisible(false);
            }
        });
        this.fadeOutFader.update();
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");
var $8t5Gy = parcelRequire("8t5Gy");










// Presentation helpers for the ember end-of-run scorecard (see run_summary.ts). Split out so they
// can be unit-tested without pulling in the panel's pixi/paperdoll dependencies.
//
// Non-negotiable: run_summary.ts itself CANNOT be instantiated under jest -- importing it pulls in
// the pixi sprite graph, which dies on a circular import (`SignSprite extends undefined`). So every
// RULE the panel enforces lives here and the widget only sizes and places what these functions say.
// How a creature kind from the server is presented. Keys are what ember-controller.js reports: a
// wave enemy's orchestrator role, a wilderness enemy's race, or "rabbit". Anything unknown still
// renders (title-cased, with the generic skull) so a new creature type needs no client change.
const $0f597a38e51c14fa$var$CREATURE_META = {
    skirmisher: {
        label: "Skirmishers",
        emoji: "\uD83D\uDC80"
    },
    raider: {
        label: "Raiders",
        emoji: "\uD83D\uDDE1\uFE0F"
    },
    archer: {
        label: "Archers",
        emoji: "\uD83C\uDFF9"
    },
    bruiser: {
        label: "Bruisers",
        emoji: "\uD83E\uDDDF"
    },
    eliteRaider: {
        label: "Elite raiders",
        emoji: "\uD83D\uDC79"
    },
    slime: {
        label: "Slimes",
        emoji: "\uD83D\uDFE2"
    },
    snake: {
        label: "Snakes",
        emoji: "\uD83D\uDC0D"
    },
    redspider: {
        label: "Spiders",
        emoji: "\uD83D\uDD77\uFE0F"
    },
    rabbit: {
        label: "Rabbits",
        emoji: "\uD83D\uDC07"
    }
};
const $0f597a38e51c14fa$export$fe9c44471babb83 = (key)=>$0f597a38e51c14fa$var$CREATURE_META[key] || {
        label: key.charAt(0).toUpperCase() + key.slice(1),
        emoji: "\uD83D\uDC80"
    };
const $0f597a38e51c14fa$export$bc733b0c5cbb3e8a = (ms)=>{
    const total = Math.max(0, Math.round(ms / 1000));
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor(total % 3600 / 60);
    const seconds = total % 60;
    const pad = (n)=>n < 10 ? `0${n}` : `${n}`;
    return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${minutes}:${pad(seconds)}`;
};
const $0f597a38e51c14fa$export$ff38440d3f9f6c69 = (summary)=>{
    // A summary from a camp that doesn't report lives at all (an older server) reads as "no lives
    // to show" rather than as "out of lives": the panel then hides the embers and leaves both ways
    // on available, which is how it behaved before lives existed.
    const total = Math.max(0, Math.floor(summary?.livesTotal || 0));
    const spent = Math.max(0, Math.min(total, Math.floor(summary?.livesSpent || 0)));
    const remaining = total - spent;
    return {
        total: total,
        spent: spent,
        remaining: remaining,
        canTryAgain: total === 0 || remaining > 0,
        caption: total === 0 ? "" : remaining > 0 ? `${spent} OF ${total} SPENT` : "ALL SPENT"
    };
};
const $0f597a38e51c14fa$var$RESTART_BUTTON = {
    action: "restart",
    label: "RESTART",
    sublabel: "A FRESH START"
};
// What the picker is for, in the two words the player has to recognise later.
const $0f597a38e51c14fa$var$INVADE_LABEL = "RESURRECT AS UNDEAD!";
const $0f597a38e51c14fa$export$539f268c17834231 = "RISE IN A STRANGER'S CAMP";
const $0f597a38e51c14fa$export$abb63c118f1212b9 = (remaining)=>remaining === 1 ? "ENDS YOUR RUN \u2014 1 LIFE LEFT" : `ENDS YOUR RUN \u{2014} ${remaining} LIVES LEFT`;
const $0f597a38e51c14fa$export$457f4e9d8b9cc341 = (summary, candidates)=>{
    const lives = $0f597a38e51c14fa$export$ff38440d3f9f6c69(summary);
    const buttons = lives.canTryAgain ? [
        {
            action: "tryAgain",
            label: "TRY AGAIN",
            sublabel: "HOLD THIS CAMP",
            primary: true,
            enabled: true,
            minor: false
        },
        {
            ...$0f597a38e51c14fa$var$RESTART_BUTTON,
            primary: false,
            enabled: true,
            minor: false
        }
    ] : [
        {
            ...$0f597a38e51c14fa$var$RESTART_BUTTON,
            primary: true,
            enabled: true,
            minor: false
        }
    ];
    // Only ever drawn when there is somewhere to GO. See the note above the three states.
    if (candidates && candidates.length > 0) buttons.push({
        action: "invade",
        label: $0f597a38e51c14fa$var$INVADE_LABEL,
        // Rise and lose nothing (the run was over anyway), or rise and spend what is left of
        // this camp -- which the button says out loud, because every exit builds a fresh one.
        sublabel: lives.canTryAgain ? $0f597a38e51c14fa$export$abb63c118f1212b9(Math.max(1, lives.remaining)) : $0f597a38e51c14fa$export$539f268c17834231,
        primary: false,
        enabled: true,
        minor: true
    });
    return buttons;
};
const $0f597a38e51c14fa$export$379f48b98209a8ad = 520;
const $0f597a38e51c14fa$export$fa4a844e549b373e = 1900;
const $0f597a38e51c14fa$export$6b83639ebebd9af = (elapsedMs)=>{
    const t = Math.min(1, Math.max(0, elapsedMs / $0f597a38e51c14fa$export$379f48b98209a8ad));
    // Eased out, so it slams in and drains away rather than fading evenly.
    return (1 - t) * (1 - t);
};
const $0f597a38e51c14fa$export$78e7f021a5df08b1 = 260 // the number slams in, throwing a shockwave
;
const $0f597a38e51c14fa$export$b16ae063a0ac6cd3 = 3000 // ...and is held, breathing, while embers rise past it
;
const $0f597a38e51c14fa$export$276df5295c341d02 = 480 // ...then lifts away as the panel rises into its place
;
const $0f597a38e51c14fa$export$f35fd8a59a3bec81 = $0f597a38e51c14fa$export$b16ae063a0ac6cd3 + $0f597a38e51c14fa$export$276df5295c341d02;
// How far into the handoff the panel starts coming up. Well before the headline is gone: the
// overlap is what makes it read as one movement instead of two.
const $0f597a38e51c14fa$var$PANEL_ENTRY_AT = 0.25;
// The slam: the headline arrives oversized and snaps down past its resting size before settling.
const $0f597a38e51c14fa$var$SLAM_FROM = 2.05;
// The hold's breath, and how fast it breathes.
const $0f597a38e51c14fa$var$BREATH = 0.014;
// One unhurried cycle across the hold, so a three-second pause reads as something alive rather
// than as a frozen frame.
const $0f597a38e51c14fa$var$BREATH_HZ = 2 * Math.PI / 3000;
// What the headline does on its way out.
const $0f597a38e51c14fa$var$EXIT_SHRINK = 0.22;
const $0f597a38e51c14fa$var$EXIT_LIFT = 34;
// The panel's rise, in stage units.
const $0f597a38e51c14fa$var$PANEL_RISE = 22;
const $0f597a38e51c14fa$var$clamp01 = (t)=>t < 0 ? 0 : t > 1 ? 1 : t;
const $0f597a38e51c14fa$var$easeOutCubic = (t)=>1 - Math.pow(1 - $0f597a38e51c14fa$var$clamp01(t), 3);
const $0f597a38e51c14fa$var$easeInOutCubic = (t)=>{
    const x = $0f597a38e51c14fa$var$clamp01(t);
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
};
// Overshoots its target and comes back, which is what makes the slam land rather than glide.
const $0f597a38e51c14fa$var$easeOutBack = (t)=>{
    const x = $0f597a38e51c14fa$var$clamp01(t);
    const c1 = 1.9;
    const c3 = c1 + 1;
    return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
};
// A band of a timeline, as 0..1. Used for the staggered fades (kicker, then epithet).
const $0f597a38e51c14fa$var$band = (elapsedMs, fromMs, toMs)=>$0f597a38e51c14fa$var$clamp01((elapsedMs - fromMs) / (toMs - fromMs));
const $0f597a38e51c14fa$export$1d9e6deb9235c1ae = (elapsedMs)=>{
    const elapsed = Math.max(0, elapsedMs);
    if (elapsed >= $0f597a38e51c14fa$export$f35fd8a59a3bec81) return {
        done: true,
        alpha: 0,
        scale: 1 - $0f597a38e51c14fa$var$EXIT_SHRINK,
        lift: $0f597a38e51c14fa$var$EXIT_LIFT,
        kickerAlpha: 0,
        epithetAlpha: 0,
        ringT: -1,
        emitting: false,
        panelAlpha: 1,
        panelRise: 0
    };
    const strike = $0f597a38e51c14fa$var$clamp01(elapsed / $0f597a38e51c14fa$export$78e7f021a5df08b1);
    const handoff = $0f597a38e51c14fa$var$band(elapsed, $0f597a38e51c14fa$export$b16ae063a0ac6cd3, $0f597a38e51c14fa$export$f35fd8a59a3bec81);
    // The number is gone before the handoff ends, so the panel's last stretch of arriving is
    // uncluttered.
    const leaving = $0f597a38e51c14fa$var$easeOutCubic(handoff / 0.8);
    const entering = $0f597a38e51c14fa$var$easeOutCubic($0f597a38e51c14fa$var$band(elapsed, $0f597a38e51c14fa$export$b16ae063a0ac6cd3 + $0f597a38e51c14fa$export$276df5295c341d02 * $0f597a38e51c14fa$var$PANEL_ENTRY_AT, $0f597a38e51c14fa$export$f35fd8a59a3bec81));
    const settled = $0f597a38e51c14fa$var$SLAM_FROM + (1 - $0f597a38e51c14fa$var$SLAM_FROM) * $0f597a38e51c14fa$var$easeOutBack(strike);
    const breath = handoff > 0 ? 0 : $0f597a38e51c14fa$var$BREATH * Math.sin(elapsed * $0f597a38e51c14fa$var$BREATH_HZ);
    return {
        done: false,
        alpha: $0f597a38e51c14fa$var$easeOutCubic(elapsed / ($0f597a38e51c14fa$export$78e7f021a5df08b1 * 0.5)) * (1 - leaving),
        scale: settled + breath - $0f597a38e51c14fa$var$EXIT_SHRINK * $0f597a38e51c14fa$var$easeInOutCubic(handoff),
        lift: $0f597a38e51c14fa$var$EXIT_LIFT * $0f597a38e51c14fa$var$easeInOutCubic(handoff),
        kickerAlpha: $0f597a38e51c14fa$var$band(elapsed, 120, 320) * (1 - leaving),
        epithetAlpha: $0f597a38e51c14fa$var$band(elapsed, 360, 600) * (1 - leaving),
        ringT: strike < 1 ? strike : -1,
        emitting: elapsed > $0f597a38e51c14fa$export$78e7f021a5df08b1 * 0.4 && handoff < 0.35,
        panelAlpha: entering,
        panelRise: $0f597a38e51c14fa$var$PANEL_RISE * (1 - entering)
    };
};
// Rungs of the ladder, richest-first: the first one the wave clears is the one it gets. The camp's
// wave table runs to 20 (see ember-wave-tempo docs), so the top rung is the whole night survived.
const $0f597a38e51c14fa$var$WAVE_EPITHETS = [
    {
        from: 20,
        epithet: "THE NIGHT BROKE FIRST"
    },
    {
        from: 15,
        epithet: "DEEP IN THE DARK"
    },
    {
        from: 10,
        epithet: "A LONG VIGIL"
    },
    {
        from: 6,
        epithet: "HARD-WON GROUND"
    },
    {
        from: 3,
        epithet: "THE CAMP HELD"
    },
    {
        from: 1,
        epithet: "THE FIRST OF THEM"
    }
];
const $0f597a38e51c14fa$export$c3cad9a9dc8138b = (wave)=>($0f597a38e51c14fa$var$WAVE_EPITHETS.find((rung)=>wave >= rung.from) || $0f597a38e51c14fa$var$WAVE_EPITHETS[$0f597a38e51c14fa$var$WAVE_EPITHETS.length - 1]).epithet;
const $0f597a38e51c14fa$export$ab07704fa45aa778 = (summary)=>{
    const wave = Math.max(0, Math.floor(summary?.wavesReached || 0));
    // Dying before the first wave lands has no number to report -- "WAVE 0" is not a thing that
    // happened. So this one case turns the big line from a verdict into a shove: the player who
    // sees it got the least out of the camp and is the likeliest to walk away from the game, and
    // three seconds of the screen telling them they achieved nothing is not what should be in
    // front of them while they decide. It names the fact small and puts the way forward big.
    if (wave <= 0) return {
        kicker: "NO WAVE CAME",
        headline: "BEGIN AGAIN",
        epithet: "YOU GOT THIS"
    };
    return {
        kicker: "YOU SURVIVED TO",
        headline: `WAVE ${wave}`,
        epithet: $0f597a38e51c14fa$export$c3cad9a9dc8138b(wave)
    };
};


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");




// The opening beat of the end-of-run scorecard: how far the camp got, in the biggest type the
// screen has, before the panel itself is allowed to say anything. See run_summary_format for the
// timing (it is one pure function of the clock) and run_summary.ts for who drives it.
//
// The number is the whole point, so everything here is arranged to make it land: it arrives
// oversized and snaps down past its resting size, a shockwave goes out from it, a bloom of warm
// light sits behind it, embers climb past it while it is held, and the two smaller lines fade in
// after it rather than with it. Then it lifts away and the panel comes up through the space it
// leaves.
//
// Drawn in the same language as the panel below it (warm amber, dark glass, no blur filters --
// fake glows out of layered fills, which is what the rest of the ember UI does for the sake of
// weak GPUs).
// Geometry, as the centre line of each element relative to the block's own centre. The stage
// stretches everything vertically by SCALER, so anything that should LOOK round (the shockwave,
// the bloom, the diamond) is drawn squashed.
const $ea1172331fcf5328$var$HEADLINE_SIZE = 58;
const $ea1172331fcf5328$var$KICKER_CY = -58;
const $ea1172331fcf5328$var$HEADLINE_CY = 0;
const $ea1172331fcf5328$var$RULE_Y = 48;
const $ea1172331fcf5328$var$EPITHET_CY = 62;
const $ea1172331fcf5328$var$GOLD = 0xffd23f // the run's number, in the same gold the panel gives "WAVES HELD"
;
const $ea1172331fcf5328$var$GOLD_HOT = 0xffb04a;
const $ea1172331fcf5328$var$RIM = 0xf2a94e;
const $ea1172331fcf5328$var$EMBER_CORE = 0xffd98a;
const $ea1172331fcf5328$var$SHADOW = 0x140a04;
// The bloom behind the number: concentric filled ellipses, low alpha, biggest first. Banded fills
// rather than a blur filter, for the same reason the panel's ash shadow is banded.
const $ea1172331fcf5328$var$BLOOM_BANDS = 7;
const $ea1172331fcf5328$var$BLOOM_RX = 260;
const $ea1172331fcf5328$var$BLOOM_RY = 104 / (0, $10da07838e6d507c$export$c6ec669adaa5980d);
// The shockwave: two strokes going out from the strike, fading as they widen.
const $ea1172331fcf5328$var$RING_RX_FROM = 70;
const $ea1172331fcf5328$var$RING_RX_TO = 330;
const $ea1172331fcf5328$var$RING_ASPECT = 0.38;
// Embers climbing past the held number. Emitted on a clock while the frame says to, capped so a
// long hold can't grow the list without bound.
const $ea1172331fcf5328$var$MOTE_EVERY_MS = 46;
const $ea1172331fcf5328$var$MOTE_MAX = 44;
const $ea1172331fcf5328$var$MOTE_SPREAD_X = 210;
class $ea1172331fcf5328$export$8fae586d267b054 extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.moteList = [], this.moteClock = 0;
        this.ring = new (0, $gwPoJ.Graphics)();
        this.addChild(this.ring);
        this.block = new (0, $8t5Gy.Container)();
        this.addChild(this.block);
        // Above the type, so an ember can pass in front of the number as well as behind the bloom.
        this.motes = new (0, $gwPoJ.Graphics)();
        this.addChild(this.motes);
        this.visible = false;
    }
    // Rebuild around a run. Safe to call again -- the previous build is torn down first.
    setSummary(summary) {
        this.teardown();
        const { kicker: kicker, headline: headline, epithet: epithet } = (0, $0f597a38e51c14fa$export$ab07704fa45aa778)(summary);
        const block = this.block;
        const bloom = new (0, $gwPoJ.Graphics)();
        for(let i = $ea1172331fcf5328$var$BLOOM_BANDS; i >= 1; i--){
            const t = i / $ea1172331fcf5328$var$BLOOM_BANDS;
            // The outer bands are nearly nothing; the light gathers towards the letters.
            bloom.beginFill($ea1172331fcf5328$var$GOLD_HOT, 0.055 * (1 - t) + 0.012);
            bloom.drawEllipse(0, $ea1172331fcf5328$var$HEADLINE_CY, $ea1172331fcf5328$var$BLOOM_RX * t, $ea1172331fcf5328$var$BLOOM_RY * t);
            bloom.endFill();
        }
        block.addChild(bloom);
        this.kicker = this.addLine(block, kicker, {
            role: "caption",
            color: $ea1172331fcf5328$var$RIM,
            cy: $ea1172331fcf5328$var$KICKER_CY
        });
        // The number, in three passes: a dark copy for weight, a hotter oversized copy for the
        // glow around the letters, and the letters themselves on top.
        this.addHeadline(block, headline, $ea1172331fcf5328$var$SHADOW, 1, 3, 0.55);
        this.addHeadline(block, headline, $ea1172331fcf5328$var$GOLD_HOT, 1.06, 0, 0.38);
        this.addHeadline(block, headline, $ea1172331fcf5328$var$GOLD, 1, 0, 1);
        // A hairline rule with a diamond in it, separating the number from its verdict.
        const rule = new (0, $gwPoJ.Graphics)();
        const gap = 12;
        const reach = 92;
        rule.lineStyle(1, $ea1172331fcf5328$var$RIM, 0.45);
        rule.moveTo(-gap - reach, $ea1172331fcf5328$var$RULE_Y);
        rule.lineTo(-gap, $ea1172331fcf5328$var$RULE_Y);
        rule.moveTo(gap, $ea1172331fcf5328$var$RULE_Y);
        rule.lineTo(gap + reach, $ea1172331fcf5328$var$RULE_Y);
        rule.lineStyle(0);
        rule.beginFill($ea1172331fcf5328$var$RIM, 0.7);
        rule.drawPolygon([
            0,
            $ea1172331fcf5328$var$RULE_Y - 4 / (0, $10da07838e6d507c$export$c6ec669adaa5980d),
            4,
            $ea1172331fcf5328$var$RULE_Y,
            0,
            $ea1172331fcf5328$var$RULE_Y + 4 / (0, $10da07838e6d507c$export$c6ec669adaa5980d),
            -4,
            $ea1172331fcf5328$var$RULE_Y
        ]);
        rule.endFill();
        block.addChild(rule);
        this.epithet = this.addLine(block, epithet, {
            role: "compactLabel",
            color: $ea1172331fcf5328$var$RIM,
            cy: $ea1172331fcf5328$var$EPITHET_CY
        });
        this.moteList = [];
        this.moteClock = 0;
        this.ring.clear();
        this.motes.clear();
        this.block.alpha = 0;
        this.visible = true;
    }
    // TextRenderer has no letter-spacing, so these lines get theirs the only way a plain Text can:
    // spaces between the characters. Worth it -- they read as an inscription rather than a
    // caption, which is the difference between this beat and a tooltip.
    spaceOut(text) {
        return text.split("").join(" ");
    }
    // Anchored rather than offset by half its width: the whole block is scaled through the slam,
    // and an anchored Text stays put under a scale while an offset one drifts.
    addLine(parent, text, opts) {
        const t = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role(opts.role).bold(false).color(opts.color).bold().align("center").render(this.spaceOut(text));
        t.anchor.set(0.5, 0.5);
        t.y = opts.cy;
        t.alpha = 0;
        parent.addChild(t);
        return t;
    }
    // One pass of the number. `scale` is baked into this Text rather than taken from the block, so
    // the glow copy stays a fixed amount bigger than the letters through the whole slam.
    addHeadline(parent, text, color, scale, dy, alpha) {
        const t = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize($ea1172331fcf5328$var$HEADLINE_SIZE).color(color).bold().align("center").render(text);
        t.anchor.set(0.5, 0.5);
        t.scale.set(scale);
        t.y = $ea1172331fcf5328$var$HEADLINE_CY + dy;
        t.alpha = alpha;
        parent.addChild(t);
    }
    // ===== per-frame ===================================================================
    // Draw one already-computed moment of the beat (see waveRevealFrame). `dtMs` is only needed by
    // the part that carries its own state: the embers.
    applyFrame(frame, dtMs = 0) {
        if (frame.done) {
            this.visible = false;
            return;
        }
        this.visible = true;
        this.block.alpha = frame.alpha;
        this.block.scale.set(frame.scale);
        this.block.y = -frame.lift;
        // The small lines fade in UNDER the block's own alpha, so neither can outrun the number.
        if (this.kicker) this.kicker.alpha = frame.kickerAlpha;
        if (this.epithet) this.epithet.alpha = frame.epithetAlpha;
        this.drawRing(frame.ringT);
        this.advanceMotes(dtMs, frame.emitting, frame.alpha);
    }
    drawRing(t) {
        const g = this.ring;
        g.clear();
        if (t < 0) return;
        const eased = 1 - Math.pow(1 - t, 3);
        const left = Math.pow(1 - t, 2);
        for(let i = 0; i < 2; i++){
            const rx = $ea1172331fcf5328$var$RING_RX_FROM + ($ea1172331fcf5328$var$RING_RX_TO - $ea1172331fcf5328$var$RING_RX_FROM) * eased - i * 26;
            if (rx <= 0) continue;
            g.lineStyle(3 * left + 0.6, i === 0 ? $ea1172331fcf5328$var$GOLD : $ea1172331fcf5328$var$GOLD_HOT, (0.55 - i * 0.2) * left);
            g.drawEllipse(0, $ea1172331fcf5328$var$HEADLINE_CY, rx, rx * $ea1172331fcf5328$var$RING_ASPECT / (0, $10da07838e6d507c$export$c6ec669adaa5980d));
        }
    }
    // Embers thrown up past the held number. One Graphics, cleared and refilled each frame -- a
    // few dozen filled circles, which costs nothing next to the paperdoll the panel is building.
    advanceMotes(dtMs, emitting, alpha) {
        if (emitting) {
            this.moteClock += dtMs;
            while(this.moteClock >= $ea1172331fcf5328$var$MOTE_EVERY_MS && this.moteList.length < $ea1172331fcf5328$var$MOTE_MAX){
                this.moteClock -= $ea1172331fcf5328$var$MOTE_EVERY_MS;
                this.moteList.push({
                    x: (Math.random() - 0.5) * $ea1172331fcf5328$var$MOTE_SPREAD_X * 2,
                    y: 46 + Math.random() * 26,
                    vx: (Math.random() - 0.5) * 0.02,
                    vy: -(0.045 + Math.random() * 0.055),
                    age: 0,
                    life: 700 + Math.random() * 700,
                    r: 0.9 + Math.random() * 1.5
                });
            }
        } else this.moteClock = 0;
        this.moteList = this.moteList.filter((mote)=>{
            mote.age += dtMs;
            mote.x += mote.vx * dtMs;
            mote.y += mote.vy * dtMs;
            return mote.age < mote.life;
        });
        const g = this.motes;
        g.clear();
        g.lineStyle(0);
        this.moteList.forEach((mote)=>{
            const left = 1 - mote.age / mote.life;
            // In fast, out slow: an ember is brightest just after it leaves the fire.
            const heat = Math.min(1, left * 3) * left * alpha;
            if (heat <= 0.02) return;
            g.beginFill($ea1172331fcf5328$var$GOLD_HOT, 0.16 * heat);
            g.drawCircle(mote.x, mote.y, mote.r * 2.4);
            g.endFill();
            g.beginFill($ea1172331fcf5328$var$EMBER_CORE, 0.9 * heat);
            g.drawCircle(mote.x, mote.y, mote.r);
            g.endFill();
        });
    }
    // ===== teardown ====================================================================
    // Free the number's textures (a 58pt Text is not a small canvas to hold onto until the next
    // death) and reset every piece of running state.
    teardown() {
        (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(this.block);
        this.block.removeChildren().forEach((child)=>{
            if (!child.destroyed) child.destroy();
        });
        this.kicker = undefined;
        this.epithet = undefined;
        this.ring.clear();
        this.motes.clear();
        this.moteList = [];
        this.moteClock = 0;
        this.block.alpha = 0;
        this.block.scale.set(1);
        this.block.y = 0;
        this.visible = false;
    }
}


// The ember end-of-run scorecard: a centered panel that comes up when the player falls defending
// the camp, showing how the run went and offering the way back in. Driven entirely by one payload
// from the ember controller script (Protocol.type_showRunSummary -> EmberRunSummary).
//
// It offers up to two ways on, and the difference between them is the panel's whole job to make
// plain:
//   TRY AGAIN  -- get up in this same camp, everything still standing. This is what a life BUYS,
//                 so it is offered only while the camp still has one for the player.
//   RESTART    -- abandon it for a fresh camp, which is always available.
// The lives themselves are drawn as embers under the portrait: one per life the camp granted, lit
// while unspent and burnt out once spent. When the last one goes dark "try again" goes with it --
// not greyed out but GONE, leaving one button, centered: that camp is finished with the player and
// starting again elsewhere is the only thing left to decide.
//
// Drawn here in full, in the same ember-lit language as the command wheel / role picker (warm amber
// rim, dark glass, role-coloured accents) so the whole ember UI reads as one set. Fake glows rather
// than blur filters, for the same reason they use them: filters are expensive on weak GPUs.
// The stage stretches everything vertically by SCALER (1.3), so a box that should LOOK square is
// drawn wider than tall. All the geometry below is in stage units with that already accounted for.
const $8bf61ed7fd954e0e$var$SCREEN_W = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7;
const $8bf61ed7fd954e0e$var$CENTER_X = $8bf61ed7fd954e0e$var$SCREEN_W / 2;
// The same "visually centered" line the hero banner uses (the HUD's usable band is shorter than
// the nominal screen height).
const $8bf61ed7fd954e0e$var$CENTER_Y = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h / 2 + 52;
const $8bf61ed7fd954e0e$var$PANEL_W = 440;
const $8bf61ed7fd954e0e$var$PANEL_H = 310;
const $8bf61ed7fd954e0e$var$PANEL_LEFT = $8bf61ed7fd954e0e$var$CENTER_X - $8bf61ed7fd954e0e$var$PANEL_W / 2;
const $8bf61ed7fd954e0e$var$PANEL_TOP = $8bf61ed7fd954e0e$var$CENTER_Y - $8bf61ed7fd954e0e$var$PANEL_H / 2;
// Palette, shared with role_picker.ts / the ember roster.
const $8bf61ed7fd954e0e$var$RIM = 0xf2a94e;
const $8bf61ed7fd954e0e$var$PANEL_FILL = 0x1b1512;
const $8bf61ed7fd954e0e$var$PANEL_ALPHA = 0.96;
const $8bf61ed7fd954e0e$var$CARD_FILL = 0x241b16;
const $8bf61ed7fd954e0e$var$CARD_RIM = 0x6b4f38;
const $8bf61ed7fd954e0e$var$TEXT_COLOR = 0xfff3e0;
const $8bf61ed7fd954e0e$var$SCRIM_COLOR = 0x06060a;
// The gone-out portrait card: a cold frame, a near-black ground, and a blue-grey shadow over the
// player. Deliberately cool, where every other colour on this panel is warm.
const $8bf61ed7fd954e0e$var$ASH_RIM = 0x3c4048;
const $8bf61ed7fd954e0e$var$ASH_FILL = 0x05070c;
const $8bf61ed7fd954e0e$var$ASH_SHADOW = 0x04060f;
const $8bf61ed7fd954e0e$var$ASH_TEXT = 0x9aa2ae;
// The shadow is not flat: it thickens down the card, so the face is still legible and the body
// below it is swallowed. Top and bottom opacity of that fall, and how many bands it is drawn in
// (no gradient fills and no filters in this panel -- banded rects are what the rest of the ember
// UI uses, and they cost nothing on a weak GPU).
const $8bf61ed7fd954e0e$var$ASH_SHADOW_TOP = 0.14;
const $8bf61ed7fd954e0e$var$ASH_SHADOW_BOTTOM = 0.95;
const $8bf61ed7fd954e0e$var$ASH_SHADOW_BANDS = 28;
const $8bf61ed7fd954e0e$var$GOLD = 0xffd23f // waves — the run's real score
;
const $8bf61ed7fd954e0e$var$AMBER = 0xf2a94e // time survived
;
const $8bf61ed7fd954e0e$var$EMBER = 0xff8a5c // creatures vanquished
;
const $8bf61ed7fd954e0e$var$GREEN = 0x7be08a // forager/camp work
;
// Fade timing — mirrors the command wheel / role picker (~100ms each way).
const $8bf61ed7fd954e0e$var$FADE_INTERVAL_MS = 5;
const $8bf61ed7fd954e0e$var$FADE_STEP = 0.05;
// Panel-local geometry (origin = panel top-left).
const $8bf61ed7fd954e0e$var$PAD = 16;
const $8bf61ed7fd954e0e$var$PORTRAIT_W = 104;
const $8bf61ed7fd954e0e$var$PORTRAIT_H = 128;
const $8bf61ed7fd954e0e$var$PORTRAIT_TOP = 56;
// Zoom of the paperdoll inside the card, matched to the roster's framing (1.5 in a 70px card).
const $8bf61ed7fd954e0e$var$PORTRAIT_SCALE = 2.2;
const $8bf61ed7fd954e0e$var$STATS_LEFT = $8bf61ed7fd954e0e$var$PAD + $8bf61ed7fd954e0e$var$PORTRAIT_W + 14;
const $8bf61ed7fd954e0e$var$STATS_W = $8bf61ed7fd954e0e$var$PANEL_W - $8bf61ed7fd954e0e$var$PAD - $8bf61ed7fd954e0e$var$STATS_LEFT;
const $8bf61ed7fd954e0e$var$HERO_TOP = $8bf61ed7fd954e0e$var$PORTRAIT_TOP;
const $8bf61ed7fd954e0e$var$HERO_H = 60;
const $8bf61ed7fd954e0e$var$TILE_TOP = 134;
const $8bf61ed7fd954e0e$var$TILE_H = 44;
const $8bf61ed7fd954e0e$var$CHIP_LABEL_Y = 186;
const $8bf61ed7fd954e0e$var$CHIP_TOP = 197;
const $8bf61ed7fd954e0e$var$CHIP_H = 16;
const $8bf61ed7fd954e0e$var$CHIP_GAP = 5;
// The lives block sits in the left column, in the space under the portrait card.
const $8bf61ed7fd954e0e$var$LIVES_LABEL_Y = 188;
// The embers hang well clear of the label: a flame's tip reaches PIP_R * 1.35 above its centre,
// so a tight row here reads as the word sitting on top of the fire.
const $8bf61ed7fd954e0e$var$LIVES_ROW_Y = 210;
const $8bf61ed7fd954e0e$var$LIVES_CAPTION_Y = 234;
const $8bf61ed7fd954e0e$var$PIP_R = 9;
const $8bf61ed7fd954e0e$var$PIP_GAP = 8;
// The ember palette, warmer and redder than the panel's gold so a life reads as a coal rather
// than a coin: a red-orange body, a lighter rim, and a hot centre.
const $8bf61ed7fd954e0e$var$EMBER_BODY = 0xef5524;
const $8bf61ed7fd954e0e$var$EMBER_RIM = 0xffab66;
const $8bf61ed7fd954e0e$var$EMBER_CORE = 0xffd98a;
// How long the just-spent life takes to go out when the panel opens. It burns, gutters, and
// collapses into ash rather than simply appearing spent -- the player has to SEE it cost them.
const $8bf61ed7fd954e0e$var$LIVES_BURN_MS = 1150;
// The stretch of that, as a fraction, the ember spends still burning (and flickering) before it
// starts to go out.
const $8bf61ed7fd954e0e$var$LIVES_BURN_HOLD = 0.35;
// The most of the opening flourish any single frame is allowed to consume. See advanceReveal.
const $8bf61ed7fd954e0e$var$REVEAL_MAX_STEP_MS = 90;
// Two buttons, side by side, filling the panel's inner width. Deliberately large: this panel is a
// dead stop in the run and these are the only two things on it the player can do.
const $8bf61ed7fd954e0e$var$BUTTON_H = (0, $97475243e21a0995$export$73e83bf2b7e02467).large.height;
const $8bf61ed7fd954e0e$var$BUTTON_GAP = 12;
const $8bf61ed7fd954e0e$var$BUTTON_W = ($8bf61ed7fd954e0e$var$PANEL_W - $8bf61ed7fd954e0e$var$PAD * 2 - $8bf61ed7fd954e0e$var$BUTTON_GAP) / 2;
// A lone button doesn't inherit half the panel's width -- it would read as one of a pair with the
// other one missing. Wider, and centered.
const $8bf61ed7fd954e0e$var$SOLO_BUTTON_W = 240;
const $8bf61ed7fd954e0e$var$BUTTON_TOP = 252;
// The MINOR row: the third way on ("Resurrect as Undead!"), which sits BELOW the panel's own bottom
// edge rather than inside it.
//
// Outside, because the panel has no vertical budget left -- the kill chips already stop 6px short
// of BUTTON_TOP -- and because being off the card is the clearest possible statement of rank. The
// design names the scorecard's hierarchy as the dial that stops the camp game becoming
// instrumental: this is third, smaller, cooler, and detached, and none of that is decoration.
//
// The stage is 800x600 with scale.y = SCALER, so the usable vertical band is 600/1.3 ~= 461 units
// and the panel ends at PANEL_TOP + PANEL_H = 387. This row runs to ~431, which keeps ~30 units of
// clearance -- the docked-panel height budget, which is a real limit and not a style note.
const $8bf61ed7fd954e0e$var$MINOR_BUTTON_W = 262;
const $8bf61ed7fd954e0e$var$MINOR_BUTTON_H = (0, $97475243e21a0995$export$73e83bf2b7e02467).medium.height;
const $8bf61ed7fd954e0e$var$MINOR_BUTTON_TOP = $8bf61ed7fd954e0e$var$PANEL_H + 14;
class $8bf61ed7fd954e0e$export$786eace44478b97d extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), // Anything currently wearing a mask. Masks have to be detached before the subtree is destroyed
        // (a display object left pointing at a destroyed mask crashes the next render), which is the
        // same dance the roster cards do.
        this.masked = [], this.buttons = [], this.livesBurnMs = 0, // Sparks thrown off as the ember collapses: { x, y, vy, age, life }.
        this.sparks = [], this.revealMs = 0, this.revealing = false, this.opened = false, this.fadeInFader = null, this.fadeOutFader = null;
        this.onTryAgain = props.onTryAgain;
        this.onRestart = props.onRestart;
        this.onInvade = props.onInvade;
        // The scrim both dims the world and swallows every click, so a stray press while the panel
        // is up can't fire the player's bow into the camp behind it.
        this.scrim = new (0, $gwPoJ.Graphics)();
        this.scrim.beginFill($8bf61ed7fd954e0e$var$SCRIM_COLOR, 0.8);
        this.scrim.drawRect(-400, -400, $8bf61ed7fd954e0e$var$SCREEN_W + 800, 1400);
        this.scrim.endFill();
        this.scrim.interactive = true;
        this.scrim.hitArea = new (0, $6qzqq.Rectangle)(-400, -400, $8bf61ed7fd954e0e$var$SCREEN_W + 800, 1400);
        this.scrim.on("pointerdown", (event)=>event.stopPropagation());
        this.scrim.on("pointermove", (event)=>event.stopPropagation());
        this.scrim.on("rightclick", (event)=>event.stopPropagation());
        this.scrim.on("contextmenu", (event)=>{
            event.preventDefault();
            event.stopPropagation();
        });
        this.addChild(this.scrim);
        this.panel = new (0, $8t5Gy.Container)();
        this.panel.x = $8bf61ed7fd954e0e$var$PANEL_LEFT;
        this.panel.y = $8bf61ed7fd954e0e$var$PANEL_TOP;
        this.addChild(this.panel);
        this.content = new (0, $8t5Gy.Container)();
        this.panel.addChild(this.content);
        // Over the panel, and centered on the screen rather than on the panel: the number is
        // bigger than the thing it introduces.
        this.reveal = new (0, $ea1172331fcf5328$export$8fae586d267b054)();
        this.reveal.x = $8bf61ed7fd954e0e$var$CENTER_X;
        this.reveal.y = $8bf61ed7fd954e0e$var$CENTER_Y;
        this.addChild(this.reveal);
        this.visible = false;
    }
    // ===== drawing =====================================================================
    // Dark "glass" body with a warm rim and a faint outer glow (a fatter low-alpha copy — cheaper
    // than a blur filter, which matters on low-end GPUs), plus a warm bar across the very top so
    // the header reads as its own band.
    drawPanelChrome() {
        const g = new (0, $gwPoJ.Graphics)();
        g.beginFill($8bf61ed7fd954e0e$var$RIM, 0.05);
        g.drawRoundedRect(-6, -6, $8bf61ed7fd954e0e$var$PANEL_W + 12, $8bf61ed7fd954e0e$var$PANEL_H + 12, 16);
        g.endFill();
        g.lineStyle(2, $8bf61ed7fd954e0e$var$RIM, 0.9);
        g.beginFill($8bf61ed7fd954e0e$var$PANEL_FILL, $8bf61ed7fd954e0e$var$PANEL_ALPHA);
        g.drawRoundedRect(0, 0, $8bf61ed7fd954e0e$var$PANEL_W, $8bf61ed7fd954e0e$var$PANEL_H, 11);
        g.endFill();
        // Header underline, fading out at both ends.
        g.lineStyle(0);
        g.beginFill($8bf61ed7fd954e0e$var$RIM, 0.35);
        g.drawRect($8bf61ed7fd954e0e$var$PAD * 2, 47, $8bf61ed7fd954e0e$var$PANEL_W - $8bf61ed7fd954e0e$var$PAD * 4, 1);
        g.endFill();
        return g;
    }
    addText(parent, text, opts) {
        const builder = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role(opts.role).bold(false).color(opts.color === undefined ? $8bf61ed7fd954e0e$var$TEXT_COLOR : opts.color);
        if (opts.bold) builder.bold();
        const t = builder.align("center").render(text);
        t.x = opts.center ? Math.round(opts.x - t.width / 2) : opts.x;
        t.y = opts.y;
        if (opts.alpha !== undefined) t.alpha = opts.alpha;
        parent.addChild(t);
        return t;
    }
    // Shrink a value until it fits its cell — a 12-minute run ("12:45") is a lot wider than "3".
    addFittedValue(parent, text, color, cx, y, maxW) {
        let size = 27;
        let t = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(size).color(color).bold().align("center").render(text);
        while(t.width > maxW && size > 13){
            (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(t);
            size -= 2;
            t = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(size).color(color).bold().align("center").render(text);
        }
        t.x = Math.round(cx - t.width / 2);
        t.y = y;
        parent.addChild(t);
        return t;
    }
    // The player's own paperdoll, framed and lit from below by the same campfire particles the
    // roster gives the Lord — the camp's fire is what the run was about.
    //
    // `extinguished` is the last-life version of the same card: with the lives spent, the fire
    // behind the portrait is OUT. No particles, a colder frame, and the player sunk into shadow —
    // the card stops being a portrait lit by a camp and becomes what is left of one. It is the
    // same reading as the burnt embers and the missing "try again" button, said a third way.
    buildPortrait(parent, player, extinguished) {
        const card = new (0, $8t5Gy.Container)();
        card.x = $8bf61ed7fd954e0e$var$PAD;
        card.y = $8bf61ed7fd954e0e$var$PORTRAIT_TOP;
        parent.addChild(card);
        const chrome = new (0, $gwPoJ.Graphics)();
        chrome.lineStyle(1.5, extinguished ? $8bf61ed7fd954e0e$var$ASH_RIM : $8bf61ed7fd954e0e$var$CARD_RIM, extinguished ? 0.5 : 0.8);
        chrome.beginFill(extinguished ? $8bf61ed7fd954e0e$var$ASH_FILL : 0x0a0d08, 0.95);
        chrome.drawRoundedRect(0, 0, $8bf61ed7fd954e0e$var$PORTRAIT_W, $8bf61ed7fd954e0e$var$PORTRAIT_H, 8);
        chrome.endFill();
        card.addChild(chrome);
        // A pixi mask belongs to exactly one display object, so the flame and the paperdoll each
        // get their own copy of the same inset rounded rect (as the roster cards do).
        const makeClip = ()=>{
            const clip = new (0, $gwPoJ.Graphics)();
            clip.beginFill(0xffffff);
            clip.drawRoundedRect(3, 3, $8bf61ed7fd954e0e$var$PORTRAIT_W - 6, $8bf61ed7fd954e0e$var$PORTRAIT_H - 6, 6);
            clip.endFill();
            return clip;
        };
        // The fire behind the portrait, unless it has gone out with the last life — in which case
        // there is no backdrop at all, and animate() has nothing left to advance.
        if (!extinguished) {
            const flameClip = makeClip();
            card.addChild(flameClip);
            const flame = new (0, $d4e9bfba8663fd0e$export$180e4127bb338fb5)($8bf61ed7fd954e0e$var$PORTRAIT_W, $8bf61ed7fd954e0e$var$PORTRAIT_H);
            flame.mask = flameClip;
            card.addChild(flame);
            this.flame = flame;
            this.masked.push(flame);
        }
        if (player && player.appearance) {
            // Paperdoll off a synthetic entity carrying just appearance/inventory/weapon, the same
            // way the inventory screen and the roster build theirs — nothing here should touch the
            // live player entity.
            const doll = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
            doll.weapon = {
                weaponType: (0, $f684496fff50a7a1$export$58361cde22f3aa43)(player.inventory, "weapon")?.type
            };
            doll.appearance = player.appearance;
            doll.inventory = player.inventory;
            try {
                // The player's Ember body where they have one (ember_portrait), framed on the
                // same head as the LPC paperdoll.
                const portrait = (0, $a020ac28c1deebe7$export$c4e1af01547f5776)(doll, player.entityId);
                // Framing matched to the roster cards (same zoom + head-and-shoulders crop, scaled
                // up for this bigger card), so the player reads as one of the camp.
                portrait.scale.set($8bf61ed7fd954e0e$var$PORTRAIT_SCALE);
                portrait.x = $8bf61ed7fd954e0e$var$PORTRAIT_W / 2;
                portrait.y = Math.round($8bf61ed7fd954e0e$var$PORTRAIT_H * 0.57);
                // Sunk into the dark rather than deleted: the shape of the player is still there
                // to be made out, which is what makes it read as a body and not an empty frame.
                // The falling shadow below does most of that work, so this only takes the edge off.
                portrait.alpha = extinguished ? 0.72 : 1;
                const portraitClip = makeClip();
                card.addChild(portraitClip);
                portrait.mask = portraitClip;
                card.addChild(portrait);
                this.masked.push(portrait);
            } catch (e) {
                // A malformed paperdoll must not cost the player their only way back into a run.
                console.warn("[RunSummary] portrait build failed", e);
            }
        }
        // A cold shadow over the card once the fire behind it is out — drawn above the paperdoll so
        // it falls ON the player, and under the name plate so the name stays readable.
        //
        // It DEEPENS down the card rather than lying flat: the head keeps just enough light to be
        // recognisable and everything below it goes into the dark, which is what makes the card
        // read as a body sinking rather than a picture someone turned the brightness down on.
        if (extinguished) {
            const shadow = new (0, $gwPoJ.Graphics)();
            const top = 3;
            const height = $8bf61ed7fd954e0e$var$PORTRAIT_H - 6;
            for(let band = 0; band < $8bf61ed7fd954e0e$var$ASH_SHADOW_BANDS; band++){
                // Eased, so the fall is gentle across the face and steep past the shoulders.
                const t = band / ($8bf61ed7fd954e0e$var$ASH_SHADOW_BANDS - 1);
                const alpha = $8bf61ed7fd954e0e$var$ASH_SHADOW_TOP + ($8bf61ed7fd954e0e$var$ASH_SHADOW_BOTTOM - $8bf61ed7fd954e0e$var$ASH_SHADOW_TOP) * Math.pow(t, 1.6);
                shadow.beginFill($8bf61ed7fd954e0e$var$ASH_SHADOW, alpha);
                // Half a pixel of overlap: abutting bands leave hairline seams once the panel is
                // scaled onto the stage.
                shadow.drawRect(top, top + height * band / $8bf61ed7fd954e0e$var$ASH_SHADOW_BANDS, $8bf61ed7fd954e0e$var$PORTRAIT_W - 6, height / $8bf61ed7fd954e0e$var$ASH_SHADOW_BANDS + 0.6);
                shadow.endFill();
            }
            // Banded rects have square corners; the card does not. Clip them to the same inset
            // rounded rect the flame and the paperdoll use.
            const shadowClip = makeClip();
            card.addChild(shadowClip);
            shadow.mask = shadowClip;
            card.addChild(shadow);
            this.masked.push(shadow);
        }
        // Scrim + name plate across the bottom of the card.
        const plate = new (0, $gwPoJ.Graphics)();
        plate.beginFill(0x000000, 0.55);
        plate.drawRoundedRect(3, $8bf61ed7fd954e0e$var$PORTRAIT_H - 25, $8bf61ed7fd954e0e$var$PORTRAIT_W - 6, 22, 6);
        plate.endFill();
        card.addChild(plate);
        const name = player?.name ? player.name : "Camper";
        this.addText(card, name.length > 14 ? `${name.slice(0, 13)}\u{2026}` : name, {
            role: "compactLabel",
            bold: true,
            color: extinguished ? $8bf61ed7fd954e0e$var$ASH_TEXT : $8bf61ed7fd954e0e$var$TEXT_COLOR,
            x: $8bf61ed7fd954e0e$var$PORTRAIT_W / 2,
            y: $8bf61ed7fd954e0e$var$PORTRAIT_H - 21,
            center: true
        });
    }
    // The three headline numbers. These are the run's score, so they get the panel's biggest type.
    buildHeroStats(parent, summary) {
        const cells = [
            {
                value: (0, $0f597a38e51c14fa$export$bc733b0c5cbb3e8a)(summary.survivedMs),
                label: "SURVIVED",
                color: $8bf61ed7fd954e0e$var$AMBER
            },
            {
                value: `${summary.wavesCleared}`,
                label: "WAVES HELD",
                color: $8bf61ed7fd954e0e$var$GOLD
            },
            {
                value: `${summary.killsTotal}`,
                label: "VANQUISHED",
                color: $8bf61ed7fd954e0e$var$EMBER
            }
        ];
        const gap = 8;
        const cellW = ($8bf61ed7fd954e0e$var$STATS_W - gap * (cells.length - 1)) / cells.length;
        cells.forEach((cell, i)=>{
            const x = $8bf61ed7fd954e0e$var$STATS_LEFT + i * (cellW + gap);
            const bg = new (0, $gwPoJ.Graphics)();
            bg.lineStyle(1, cell.color, 0.28);
            bg.beginFill($8bf61ed7fd954e0e$var$CARD_FILL, 0.85);
            bg.drawRoundedRect(x, $8bf61ed7fd954e0e$var$HERO_TOP, cellW, $8bf61ed7fd954e0e$var$HERO_H, 8);
            bg.endFill();
            parent.addChild(bg);
            this.addFittedValue(parent, cell.value, cell.color, x + cellW / 2, $8bf61ed7fd954e0e$var$HERO_TOP + 9, cellW - 10);
            this.addText(parent, cell.label, {
                role: "overline",
                alpha: 0.7,
                x: x + cellW / 2,
                y: $8bf61ed7fd954e0e$var$HERO_TOP + $8bf61ed7fd954e0e$var$HERO_H - 15,
                center: true
            });
        });
        // The one number that is purely the player's own doing, rather than the camp's.
        if (summary.killsByPlayer > 0) this.addText(parent, `${summary.killsByPlayer} struck down by your own hand`, {
            role: "compactCaption",
            alpha: 0.6,
            x: $8bf61ed7fd954e0e$var$STATS_LEFT + $8bf61ed7fd954e0e$var$STATS_W / 2,
            y: $8bf61ed7fd954e0e$var$HERO_TOP + $8bf61ed7fd954e0e$var$HERO_H + 6,
            center: true
        });
    }
    // What the player built and kept alive, as opposed to what they killed.
    buildCampTiles(parent, summary) {
        const tiles = [
            {
                icon: "axe",
                value: summary.treesFelled,
                label: "TREES FELLED",
                color: $8bf61ed7fd954e0e$var$GREEN
            },
            {
                emoji: "\uD83E\uDD1D",
                value: summary.recruitsHired,
                label: "RECRUITED",
                color: $8bf61ed7fd954e0e$var$GOLD
            },
            {
                emoji: "\uD83D\uDD25",
                value: summary.fireRekindled,
                label: "FIRE FED",
                color: $8bf61ed7fd954e0e$var$AMBER
            }
        ];
        const gap = 8;
        const tileW = ($8bf61ed7fd954e0e$var$STATS_W - gap * (tiles.length - 1)) / tiles.length;
        tiles.forEach((tile, i)=>{
            const x = $8bf61ed7fd954e0e$var$STATS_LEFT + i * (tileW + gap);
            const bg = new (0, $gwPoJ.Graphics)();
            bg.lineStyle(1, $8bf61ed7fd954e0e$var$CARD_RIM, 0.5);
            bg.beginFill($8bf61ed7fd954e0e$var$CARD_FILL, 0.6);
            bg.drawRoundedRect(x, $8bf61ed7fd954e0e$var$TILE_TOP, tileW, $8bf61ed7fd954e0e$var$TILE_H, 7);
            bg.endFill();
            parent.addChild(bg);
            const emoji = tile.icon ? (0, $ec5c35dbffc1f325$export$46ad086a5552f2fb)(tile.icon, 12, tile.color) : new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("caption").align("center").render(tile.emoji);
            const count = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("label").color(tile.color).bold().align("center").render(`${tile.value}`);
            const groupW = emoji.width + 4 + count.width;
            emoji.x = Math.round(x + tileW / 2 - groupW / 2);
            emoji.y = $8bf61ed7fd954e0e$var$TILE_TOP + 7;
            const glyphLeft = emoji.x;
            if (emoji instanceof (0, $gwPoJ.Graphics)) {
                emoji.x += emoji.width / 2;
                emoji.y += 6;
            }
            count.x = Math.round(glyphLeft + emoji.width + 4);
            count.y = $8bf61ed7fd954e0e$var$TILE_TOP + 6;
            parent.addChild(emoji, count);
            this.addText(parent, tile.label, {
                role: "overline",
                alpha: 0.65,
                x: x + tileW / 2,
                y: $8bf61ed7fd954e0e$var$TILE_TOP + $8bf61ed7fd954e0e$var$TILE_H - 13,
                center: true
            });
        });
    }
    // The kill breakdown, as compact emoji chips that flow onto as many rows as they need. Ordered
    // biggest-first by the server, so the run's defining enemy leads.
    buildKillChips(parent, summary) {
        this.addText(parent, summary.kills.length > 0 ? "THE FALLEN" : "NOTHING FELL TO THE CAMP", {
            role: "overline",
            alpha: 0.5,
            x: $8bf61ed7fd954e0e$var$STATS_LEFT,
            y: $8bf61ed7fd954e0e$var$CHIP_LABEL_Y
        });
        let x = $8bf61ed7fd954e0e$var$STATS_LEFT;
        let y = $8bf61ed7fd954e0e$var$CHIP_TOP;
        summary.kills.forEach((kill)=>{
            const meta = (0, $0f597a38e51c14fa$export$fe9c44471babb83)(kill.key);
            const emoji = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("compactCaption").align("center").render(meta.emoji);
            const label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("compactCaption").color($8bf61ed7fd954e0e$var$TEXT_COLOR).align("center").render(`${meta.label} ${kill.count}`);
            const chipW = 8 + emoji.width + 4 + label.width + 8;
            // Wrap to the next row; drop anything that would spill past the two rows the panel has
            // room for (a long tail of one-off kinds isn't worth pushing the button off the panel).
            if (x + chipW > $8bf61ed7fd954e0e$var$STATS_LEFT + $8bf61ed7fd954e0e$var$STATS_W) {
                x = $8bf61ed7fd954e0e$var$STATS_LEFT;
                y += $8bf61ed7fd954e0e$var$CHIP_H + $8bf61ed7fd954e0e$var$CHIP_GAP;
            }
            if (y + $8bf61ed7fd954e0e$var$CHIP_H > $8bf61ed7fd954e0e$var$BUTTON_TOP - 6) {
                (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(emoji);
                (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(label);
                return;
            }
            const bg = new (0, $gwPoJ.Graphics)();
            bg.lineStyle(1, $8bf61ed7fd954e0e$var$CARD_RIM, 0.55);
            bg.beginFill($8bf61ed7fd954e0e$var$CARD_FILL, 0.75);
            bg.drawRoundedRect(x, y, chipW, $8bf61ed7fd954e0e$var$CHIP_H, $8bf61ed7fd954e0e$var$CHIP_H / 2);
            bg.endFill();
            parent.addChild(bg);
            emoji.x = Math.round(x + 8);
            emoji.y = Math.round(y + 2);
            label.x = Math.round(emoji.x + emoji.width + 4);
            label.y = Math.round(y + 3);
            label.alpha = 0.9;
            parent.addChild(emoji, label);
            x += chipW + $8bf61ed7fd954e0e$var$CHIP_GAP;
        });
    }
    // The lives this camp granted, as embers under the portrait: lit for a life still in hand,
    // burnt out for one already spent. The count is also spelled out underneath, because the
    // difference between two lit embers and three is not something to make anyone squint at.
    buildLives(parent, summary) {
        const { total: total, spent: spent, remaining: remaining, caption: caption } = (0, $0f597a38e51c14fa$export$ff38440d3f9f6c69)(summary);
        if (total <= 0) return;
        const columnCx = $8bf61ed7fd954e0e$var$PAD + $8bf61ed7fd954e0e$var$PORTRAIT_W / 2;
        this.addText(parent, "LIVES", {
            role: "overline",
            alpha: 0.5,
            x: columnCx,
            y: $8bf61ed7fd954e0e$var$LIVES_LABEL_Y,
            center: true
        });
        const step = $8bf61ed7fd954e0e$var$PIP_R * 2 + $8bf61ed7fd954e0e$var$PIP_GAP;
        const rowW = total * $8bf61ed7fd954e0e$var$PIP_R * 2 + (total - 1) * $8bf61ed7fd954e0e$var$PIP_GAP;
        this.embers = new (0, $gwPoJ.Graphics)();
        parent.addChild(this.embers);
        this.livesLayout = {
            firstCx: columnCx - rowW / 2 + $8bf61ed7fd954e0e$var$PIP_R,
            step: step,
            cy: $8bf61ed7fd954e0e$var$LIVES_ROW_Y + $8bf61ed7fd954e0e$var$PIP_R,
            total: total,
            spent: spent
        };
        // The row empties from the RIGHT: the lives still in hand stay banked on the left, and the
        // one this death just took is the leftmost of the dark ones -- which is the one that burns
        // out in front of the player (see drawLivesRow / animate).
        this.livesBurnMs = 0;
        this.sparks = [];
        this.drawLivesRow();
        this.addText(parent, caption, {
            role: "overline",
            color: remaining > 0 ? $8bf61ed7fd954e0e$var$TEXT_COLOR : $8bf61ed7fd954e0e$var$EMBER,
            alpha: remaining > 0 ? 0.6 : 0.9,
            x: columnCx,
            y: $8bf61ed7fd954e0e$var$LIVES_CAPTION_Y,
            center: true
        });
    }
    // Redraw the whole row for the current moment of the burn-out. Cheap enough to do every frame
    // (a handful of filled paths), and it keeps all the state in one place: which lives are lit,
    // which are ash, and how far through going out the one in between is.
    drawLivesRow() {
        const g = this.embers;
        const layout = this.livesLayout;
        if (!g || !layout) return;
        const { firstCx: firstCx, step: step, cy: cy, total: total, spent: spent } = layout;
        const remaining = total - spent;
        // How much fire is left in the life this death took. It holds — guttering, which is what
        // the flicker is — and only then goes out, so the loss reads as an event rather than as a
        // value that was always that way. The one that burns is the leftmost of the spent ones:
        // the boundary between what is still in hand and what is gone.
        const t = Math.max(0, Math.min(1, this.livesBurnMs / $8bf61ed7fd954e0e$var$LIVES_BURN_MS));
        const heat = t < $8bf61ed7fd954e0e$var$LIVES_BURN_HOLD ? 1 - 0.14 * Math.abs(Math.sin(t * 26)) : 1 - (t - $8bf61ed7fd954e0e$var$LIVES_BURN_HOLD) / (1 - $8bf61ed7fd954e0e$var$LIVES_BURN_HOLD);
        g.clear();
        for(let i = 0; i < total; i++){
            const cx = firstCx + i * step;
            if (i < remaining) this.drawEmber(g, cx, cy, 1);
            else if (i === remaining && spent > 0) this.drawEmber(g, cx, cy, heat);
            else this.drawEmber(g, cx, cy, 0);
        }
        this.sparks.forEach((spark)=>{
            const left = 1 - spark.age / spark.life;
            if (left <= 0) return;
            g.lineStyle(0);
            g.beginFill($8bf61ed7fd954e0e$var$EMBER_CORE, 0.85 * left);
            g.drawCircle(spark.x, spark.y, 1.4 * left + 0.5);
            g.endFill();
        });
    }
    // One ember: a teardrop flame, drawn at `heat` — 1 burning, 0 cold ash. The socket (the dark
    // outline) is always there, so the row keeps its shape as it empties; what changes is the fire
    // inside it, which shrinks into the socket and drains from red-orange to nothing.
    drawEmber(g, cx, cy, heat) {
        const flame = (r, oy = 0)=>{
            const y = cy + oy;
            g.moveTo(cx, y - r * 1.35);
            g.bezierCurveTo(cx + r * 1.0, y - r * 0.3, cx + r * 0.9, y + r * 0.85, cx, y + r);
            g.bezierCurveTo(cx - r * 0.9, y + r * 0.85, cx - r * 1.0, y - r * 0.3, cx, y - r * 1.35);
        };
        // The cold socket, under everything.
        g.lineStyle(1.5, $8bf61ed7fd954e0e$var$CARD_RIM, 0.75);
        g.beginFill(0x120d0a, 0.9);
        flame($8bf61ed7fd954e0e$var$PIP_R);
        g.endFill();
        if (heat <= 0.01) return;
        // A flame low on heat sits down into its socket rather than hovering, and its glow goes
        // first -- the light leaves the ember before the ember does.
        const scale = 0.35 + 0.65 * heat;
        const drop = $8bf61ed7fd954e0e$var$PIP_R * 0.5 * (1 - heat);
        g.lineStyle(0);
        g.beginFill($8bf61ed7fd954e0e$var$EMBER_BODY, 0.18 * heat);
        flame($8bf61ed7fd954e0e$var$PIP_R * 1.45 * scale, drop);
        g.endFill();
        g.lineStyle(1.5, $8bf61ed7fd954e0e$var$EMBER_RIM, 0.95 * Math.min(1, heat * 1.4));
        g.beginFill($8bf61ed7fd954e0e$var$EMBER_BODY, 0.95);
        flame($8bf61ed7fd954e0e$var$PIP_R * scale, drop);
        g.endFill();
        g.lineStyle(0);
        g.beginFill($8bf61ed7fd954e0e$var$EMBER_CORE, 0.9 * heat);
        flame($8bf61ed7fd954e0e$var$PIP_R * 0.42 * scale, drop);
        g.endFill();
    }
    // Draw the ways on that runSummaryButtons decided there are (see run_summary_format: WHICH
    // buttons exist is the rule, and lives in the testable half). All this end does is size and
    // place them: the ordinary pair splits the panel's inner width, a lone one is wider and
    // centered rather than sitting in half a row with a gap beside it, and the minor one gets a row
    // of its own under the panel.
    buildButtons(parent) {
        const summary = this.summary;
        if (!summary) return;
        const buttons = (0, $0f597a38e51c14fa$export$457f4e9d8b9cc341)(summary, this.invasionCandidates);
        const major = buttons.filter((button)=>!button.minor);
        const solo = major.length === 1;
        buttons.forEach((button)=>{
            const i = major.indexOf(button);
            this.addButton(parent, {
                x: button.minor ? $8bf61ed7fd954e0e$var$PANEL_W / 2 - $8bf61ed7fd954e0e$var$MINOR_BUTTON_W / 2 : solo ? $8bf61ed7fd954e0e$var$PANEL_W / 2 - $8bf61ed7fd954e0e$var$SOLO_BUTTON_W / 2 : $8bf61ed7fd954e0e$var$PAD + i * ($8bf61ed7fd954e0e$var$BUTTON_W + $8bf61ed7fd954e0e$var$BUTTON_GAP),
                y: button.minor ? $8bf61ed7fd954e0e$var$MINOR_BUTTON_TOP : $8bf61ed7fd954e0e$var$BUTTON_TOP,
                width: button.minor ? $8bf61ed7fd954e0e$var$MINOR_BUTTON_W : solo ? $8bf61ed7fd954e0e$var$SOLO_BUTTON_W : $8bf61ed7fd954e0e$var$BUTTON_W,
                height: button.minor ? $8bf61ed7fd954e0e$var$MINOR_BUTTON_H : $8bf61ed7fd954e0e$var$BUTTON_H,
                label: button.label,
                sublabel: button.sublabel,
                primary: button.primary,
                minor: button.minor,
                enabled: button.enabled,
                onPress: ()=>button.action === "tryAgain" ? this.onTryAgain?.() : button.action === "restart" ? this.onRestart?.() : this.onInvade?.()
            });
        });
    }
    // Re-run the button rule and redraw the row if its answer has changed. Cheap and idempotent, so
    // it can be called from the feed, and it is: the invasion offer arrives every couple of seconds
    // while the panel is up, which is what makes the third button light up by itself when a camp
    // opens. Guarded on a signature so a tick that changes nothing does not rebuild the row (and
    // lose the hover) under a pointer already resting on it.
    syncButtons() {
        const summary = this.summary;
        const layer = this.buttonLayer;
        if (!summary || !layer) return;
        const key = (0, $0f597a38e51c14fa$export$457f4e9d8b9cc341)(summary, this.invasionCandidates).map((button)=>`${button.action}/${button.enabled}/${button.sublabel}`).join("|");
        if (key === this.buttonsKey) return;
        this.buttonsKey = key;
        // The handles point into the subtree being thrown away, so they go with it.
        this.buttons = [];
        (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(layer);
        layer.removeChildren().forEach((child)=>child.destroy({
                children: true
            }));
        this.buildButtons(layer);
    }
    addButton(parent, opts) {
        const width = opts.width === undefined ? $8bf61ed7fd954e0e$var$BUTTON_W : opts.width;
        const height = opts.height === undefined ? $8bf61ed7fd954e0e$var$BUTTON_H : opts.height;
        const minor = !!opts.minor;
        const enabled = opts.enabled !== false;
        const container = new (0, $8t5Gy.Container)();
        container.x = opts.x;
        container.y = opts.y;
        parent.addChild(container);
        const bg = new (0, $gwPoJ.Graphics)();
        container.addChild(bg);
        const button = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
            label: opts.label,
            subtitle: opts.sublabel,
            theme: "ember",
            preset: opts.primary || minor ? "primary" : "standard",
            appearance: opts.primary || minor ? "filled" : "outline",
            width: width,
            height: height,
            size: minor ? "medium" : "large",
            bold: true,
            enabled: enabled,
            tone: opts.primary || minor ? "accent" : "neutral",
            accent: minor ? $8bf61ed7fd954e0e$var$EMBER_BODY : undefined,
            onClick: opts.onPress
        });
        container.addChild(button);
        const handle = {
            bg: bg,
            button: button,
            width: width,
            height: height,
            minor: minor,
            flareMs: 0,
            pulseMs: 0,
            hovered: false
        };
        this.buttons.push(handle);
        if (enabled) {
            button.on("pointerover", ()=>{
                handle.hovered = true;
                this.drawButton(handle);
            });
            button.on("pointerout", ()=>{
                handle.hovered = false;
                this.drawButton(handle);
            });
        }
        this.drawButton(handle);
    }
    drawButton(handle) {
        const g = handle.bg;
        if (!g) return;
        g.clear();
        // The invasion action arrives while the scorecard is open. Animate its surrounding glow
        // here; the shared button owns the plate, caption, disabled state and activation.
        if (handle.minor) {
            const flare = (0, $0f597a38e51c14fa$export$6b83639ebebd9af)(handle.flareMs ?? (0, $0f597a38e51c14fa$export$379f48b98209a8ad));
            const breath = 0.5 + 0.5 * Math.sin((handle.pulseMs ?? 0) / (0, $0f597a38e51c14fa$export$fa4a844e549b373e) * Math.PI * 2);
            // Hover tops the breath out rather than adding a separate state: the button is already
            // pulsing, so a hovered one simply stops dimming.
            const heat = handle.hovered ? 1 : 0.55 + 0.45 * breath;
            // The fake glow: three rings, widest first, the outermost one riding the flare out.
            const spread = 4 + 7 * heat + 16 * flare;
            for(let ring = 3; ring >= 1; ring--){
                const t = ring / 3;
                const pad = spread * t;
                g.beginFill(ring === 3 ? $8bf61ed7fd954e0e$var$EMBER_BODY : $8bf61ed7fd954e0e$var$EMBER_RIM, (0.1 + 0.22 * heat) * (1 - t * 0.55));
                g.drawRoundedRect(-pad, -pad, handle.width + pad * 2, handle.height + pad * 2, 9 + pad * 0.5);
                g.endFill();
            }
            return;
        }
        g.beginFill($8bf61ed7fd954e0e$var$RIM, handle.hovered ? 0.3 : 0.16);
        g.drawRoundedRect(-4, -4, handle.width + 8, handle.height + 8, 12);
        g.endFill();
    }
    // ===== public API ==================================================================
    isOpen() {
        return this.opened;
    }
    // The newest invasion offer off the feed (Protocol.type_updateInvasionOffer). Held whether or
    // not the panel is up, because the panel may go up a frame later and the third button has to be
    // on it immediately; `null` forgets the offer entirely, which takes the button away again.
    //
    // Note that an EMPTY array is not the same as null here. It is a real answer -- "no camp is
    // open to the dead" -- and it keeps an inert button on the panel saying so. See
    // runSummaryButtons.
    setInvasionOffer(candidates) {
        this.invasionCandidates = candidates || undefined;
        this.syncButtons();
    }
    // What the panel's buttons currently say, for a caller outside the display tree. The RULE is in
    // run_summary_format (and tested there); this is only the drawn answer.
    buttonSignature() {
        return this.buttonsKey;
    }
    // Rebuild the whole panel around a new scorecard. `player` is the local player entity, used for
    // the portrait and name; the panel still renders (without a portrait) if it's unavailable.
    // NOT named `render` -- that's pixi's own DisplayObject.render(renderer).
    setSummary(summary, player) {
        this.teardownContent();
        this.summary = summary;
        const content = new (0, $8t5Gy.Container)();
        this.content = content;
        this.panel.addChild(content);
        content.addChild(this.drawPanelChrome());
        this.addText(content, "YOU HAVE FALLEN", {
            role: "compactTitle",
            color: $8bf61ed7fd954e0e$var$RIM,
            bold: true,
            x: $8bf61ed7fd954e0e$var$PANEL_W / 2,
            y: 12,
            center: true
        });
        this.addText(content, summary.wavesReached > 0 ? `You held the ember through wave ${summary.wavesReached}.` : "The ember went dark before the first wave.", {
            role: "compactCaption",
            alpha: 0.6,
            x: $8bf61ed7fd954e0e$var$PANEL_W / 2,
            y: 33,
            center: true
        });
        // With the lives spent the camp is finished with this player, and the portrait card says
        // so: its fire is out (see buildPortrait).
        this.buildPortrait(content, player, !(0, $0f597a38e51c14fa$export$ff38440d3f9f6c69)(summary).canTryAgain);
        this.buildHeroStats(content, summary);
        this.buildCampTiles(content, summary);
        this.buildKillChips(content, summary);
        this.buildLives(content, summary);
        // The ways on go in a layer of their own, because they are the one part of this panel that
        // is rebuilt while it is up (see syncButtons).
        this.buttonLayer = new (0, $8t5Gy.Container)();
        content.addChild(this.buttonLayer);
        this.buttonsKey = undefined;
        this.syncButtons();
        // ...and put the flourish in front of all of it. The panel is not merely transparent
        // while the number is up, it is HIDDEN: an invisible button is still a pressable one, and
        // a player mashing attack as they die must not be able to restart a run they haven't been
        // shown yet.
        this.startReveal(summary);
    }
    // ===== the opening flourish ========================================================
    // Arm the wave reveal and put the panel in its pre-entrance state. Everything after this is
    // driven from animate(), off waveRevealFrame's clock.
    startReveal(summary) {
        this.revealMs = 0;
        this.revealing = true;
        this.reveal.setSummary(summary);
        this.panel.visible = false;
        this.panel.alpha = 0;
        this.panel.y = $8bf61ed7fd954e0e$var$PANEL_TOP;
    }
    // Advance it a frame, hand the panel its share of the movement, and take the whole thing down
    // once the beat is over. From here on the panel is simply the panel.
    advanceReveal(dtMs) {
        // Clamped, because this beat is measured in tenths of a second and one stalled frame (a
        // tab coming back, a texture upload) can be longer than the whole of it -- which would
        // land the player on the panel having never seen the number.
        const step = Math.max(0, Math.min(dtMs, $8bf61ed7fd954e0e$var$REVEAL_MAX_STEP_MS));
        this.revealMs += step;
        const frame = (0, $0f597a38e51c14fa$export$1d9e6deb9235c1ae)(this.revealMs);
        this.reveal.applyFrame(frame, step);
        this.panel.visible = frame.panelAlpha > 0;
        this.panel.alpha = frame.panelAlpha;
        this.panel.y = $8bf61ed7fd954e0e$var$PANEL_TOP + frame.panelRise;
        if (frame.done) this.endReveal();
    }
    // Leave the panel exactly as it would have been had there been no flourish at all. Called both
    // when the beat finishes and when the panel is torn down mid-beat.
    endReveal() {
        this.revealing = false;
        this.revealMs = 0;
        this.reveal.teardown();
        this.panel.visible = true;
        this.panel.alpha = 1;
        this.panel.y = $8bf61ed7fd954e0e$var$PANEL_TOP;
    }
    teardownContent() {
        if (this.revealing) this.endReveal();
        this.masked.forEach((node)=>{
            node.mask = null;
        });
        this.masked = [];
        this.flame = undefined;
        if (this.content) {
            this.panel.removeChild(this.content);
            (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(this.content);
            this.content.destroy({
                children: true
            });
        }
        this.buttons = [];
        this.buttonLayer = undefined;
        this.buttonsKey = undefined;
        this.summary = undefined;
        // NOT the invasion candidates: the feed is about the SERVER's state, not this panel's, and
        // a panel that forgot the newest list on teardown would come back up with no third button
        // until the next tick -- up to two seconds of the offer being missing at the exact moment
        // it is meant to be read.
        this.embers = undefined;
        this.livesLayout = undefined;
        this.sparks = [];
    }
    // Called each frame by GuiManager: the opening flourish, the portrait's campfire particles, and
    // the life this death took guttering out. Note the flame is optional (no portrait without a
    // player entity) while the lives are not, so neither may gate the other.
    animate(dtMs) {
        if (!this.visible) return;
        if (this.revealing) this.advanceReveal(dtMs);
        this.flame?.update(dtMs, 0.85);
        this.advanceLivesBurn(dtMs);
        this.advanceInvadeHeat(dtMs);
    }
    // The invade button breathes, and flares once when it appears. Redrawn every frame it is on
    // screen, which is one Graphics with a handful of rounded rects -- the panel is already
    // redrawing the lives embers at this rate.
    advanceInvadeHeat(dtMs) {
        this.buttons.forEach((handle)=>{
            if (!handle.minor) return;
            handle.pulseMs = ((handle.pulseMs ?? 0) + dtMs) % (0, $0f597a38e51c14fa$export$fa4a844e549b373e);
            if ((handle.flareMs ?? (0, $0f597a38e51c14fa$export$379f48b98209a8ad)) < (0, $0f597a38e51c14fa$export$379f48b98209a8ad)) handle.flareMs = Math.min((0, $0f597a38e51c14fa$export$379f48b98209a8ad), (handle.flareMs ?? 0) + dtMs);
            this.drawButton(handle);
        });
    }
    // The just-spent ember: it holds, flickering, long enough to be noticed, then collapses into
    // its socket and throws off a few sparks on the way out. Runs once per opening of the panel.
    advanceLivesBurn(dtMs) {
        const layout = this.livesLayout;
        if (!layout || layout.spent <= 0 || !this.embers) return;
        // Not while the wave reveal is still up. The whole point of this animation is that the
        // player SEES the life go out, and the panel it is drawn on is hidden until the flourish
        // hands over -- left running, the ember would be ash by the time anyone looked at it.
        if (this.revealing && this.panel.alpha <= 0) return;
        const finished = this.livesBurnMs >= $8bf61ed7fd954e0e$var$LIVES_BURN_MS;
        if (finished && this.sparks.length === 0) return;
        const before = this.livesBurnMs;
        this.livesBurnMs = Math.min($8bf61ed7fd954e0e$var$LIVES_BURN_MS, this.livesBurnMs + dtMs);
        // Sparks are thrown at the moment it starts to go out, not while it is still burning.
        const startMs = $8bf61ed7fd954e0e$var$LIVES_BURN_MS * $8bf61ed7fd954e0e$var$LIVES_BURN_HOLD;
        if (before < startMs && this.livesBurnMs >= startMs) {
            const cx = layout.firstCx + (layout.total - layout.spent) * layout.step;
            for(let i = 0; i < 6; i++)this.sparks.push({
                x: cx + (Math.random() - 0.5) * $8bf61ed7fd954e0e$var$PIP_R * 1.2,
                y: layout.cy - $8bf61ed7fd954e0e$var$PIP_R * 0.4,
                vx: (Math.random() - 0.5) * 0.012,
                vy: -(0.02 + Math.random() * 0.02),
                age: 0,
                life: 420 + Math.random() * 320
            });
        }
        this.sparks = this.sparks.filter((spark)=>{
            spark.age += dtMs;
            spark.x += spark.vx * dtMs;
            spark.y += spark.vy * dtMs;
            return spark.age < spark.life;
        });
        this.drawLivesRow();
    }
    fadeIn() {
        this.opened = true;
        if (this.fadeOutFader) {
            this.fadeOutFader.stop(true);
            this.fadeOutFader = null;
        }
        if (this.fadeInFader) return;
        if (!this.visible) this.alpha = 0;
        this.visible = true;
        if (this.alpha >= 1) {
            this.alpha = 1;
            return;
        }
        this.fadeInFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "in",
            minAlpha: 1.0,
            fadeInterval: $8bf61ed7fd954e0e$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $8bf61ed7fd954e0e$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeInFader = null;
                this.alpha = 1;
            }
        });
        this.fadeInFader.update();
    }
    fadeOut() {
        this.opened = false;
        // Drop every hover highlight: the pointer is nowhere near these buttons the next time the
        // panel opens, and a button that came up already lit would read as pre-selected.
        this.buttons.forEach((button)=>{
            button.hovered = false;
            button.button.resetInteraction();
        });
        if (this.fadeInFader) {
            this.fadeInFader.stop(true);
            this.fadeInFader = null;
        }
        if (this.fadeOutFader || !this.visible) return;
        this.fadeOutFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
            direction: "out",
            minAlpha: 0.0,
            fadeInterval: $8bf61ed7fd954e0e$var$FADE_INTERVAL_MS,
            fadeAlphaDecrement: $8bf61ed7fd954e0e$var$FADE_STEP,
            releaseCallback: ()=>{
                this.fadeOutFader = null;
                this.visible = false;
                this.alpha = 1.0;
                // The run is over and the panel is gone — free the paperdoll/text textures rather
                // than hold a whole scorecard's worth until the next death.
                this.teardownContent();
            }
        });
        this.fadeOutFader.update();
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $6qzqq = parcelRequire("6qzqq");


const $daf4f1c650b6c0f9$export$e483a3dc05447c30 = "A stranger";
const $daf4f1c650b6c0f9$export$6881c612b1e8acd5 = 14;
const $daf4f1c650b6c0f9$export$b2a71ccdb46cebdd = (candidate)=>{
    const name = candidate?.name?.trim();
    if (!name) return $daf4f1c650b6c0f9$export$e483a3dc05447c30;
    return name.length > $daf4f1c650b6c0f9$export$6881c612b1e8acd5 ? name.slice(0, $daf4f1c650b6c0f9$export$6881c612b1e8acd5 - 1) + "\u2026" : name;
};
const $daf4f1c650b6c0f9$export$72b7e65d3fa926ba = (candidate)=>{
    const wave = Math.max(0, Math.floor(candidate?.wave || 0));
    return wave > 0 ? `WAVE ${wave}` : "NO WAVE YET";
};
const $daf4f1c650b6c0f9$export$5064431e273f99c6 = (candidate, ageMs = 0)=>{
    const seconds = candidate?.secondsToWave;
    if (typeof seconds !== "number" || !Number.isFinite(seconds)) return undefined;
    return Math.max(0, Math.ceil(Math.max(0, seconds) - Math.max(0, ageMs) / 1000));
};
const $daf4f1c650b6c0f9$export$55099e7ccfabe53e = (candidate, ageMs = 0)=>{
    if (candidate?.waveActive) return "fighting now";
    const left = $daf4f1c650b6c0f9$export$5064431e273f99c6(candidate, ageMs);
    if (left === undefined) return "quiet for now";
    return left > 0 ? `in ${left}s` : "landing now";
};
// ===== geometry =======================================================================
// The stage stretches everything vertically by 1.3, so these are stage units with that already
// accounted for -- the same frame run_summary.ts works in, because this opens on top of it.
const $daf4f1c650b6c0f9$var$SCREEN_W = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7;
const $daf4f1c650b6c0f9$var$CENTER_X = $daf4f1c650b6c0f9$var$SCREEN_W / 2;
const $daf4f1c650b6c0f9$var$CENTER_Y = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h / 2 + 52;
const $daf4f1c650b6c0f9$export$4f5c9faaebb411d3 = 3;
const $daf4f1c650b6c0f9$var$PAD = 16;
const $daf4f1c650b6c0f9$var$TITLE_H = 42;
const $daf4f1c650b6c0f9$export$bed693db0561df20 = 118;
const $daf4f1c650b6c0f9$var$CARD_H = 104;
const $daf4f1c650b6c0f9$export$c73e9b0a14b3993b = 10;
const $daf4f1c650b6c0f9$var$FOOTER_H = 28;
const $daf4f1c650b6c0f9$var$FOOTER_GAP = 12;
const $daf4f1c650b6c0f9$var$PANEL_W = $daf4f1c650b6c0f9$var$PAD * 2 + $daf4f1c650b6c0f9$export$4f5c9faaebb411d3 * $daf4f1c650b6c0f9$export$bed693db0561df20 + ($daf4f1c650b6c0f9$export$4f5c9faaebb411d3 - 1) * $daf4f1c650b6c0f9$export$c73e9b0a14b3993b;
const $daf4f1c650b6c0f9$var$PANEL_H = $daf4f1c650b6c0f9$var$TITLE_H + $daf4f1c650b6c0f9$var$CARD_H + $daf4f1c650b6c0f9$var$FOOTER_GAP + $daf4f1c650b6c0f9$var$FOOTER_H + $daf4f1c650b6c0f9$var$PAD;
const $daf4f1c650b6c0f9$var$PANEL_LEFT = $daf4f1c650b6c0f9$var$CENTER_X - $daf4f1c650b6c0f9$var$PANEL_W / 2;
const $daf4f1c650b6c0f9$var$PANEL_TOP = $daf4f1c650b6c0f9$var$CENTER_Y - $daf4f1c650b6c0f9$var$PANEL_H / 2;
const $daf4f1c650b6c0f9$var$CARD_TOP = $daf4f1c650b6c0f9$var$PANEL_TOP + $daf4f1c650b6c0f9$var$TITLE_H;
const $daf4f1c650b6c0f9$var$FOOTER_TOP = $daf4f1c650b6c0f9$var$CARD_TOP + $daf4f1c650b6c0f9$var$CARD_H + $daf4f1c650b6c0f9$var$FOOTER_GAP;
const $daf4f1c650b6c0f9$var$FOOTER_W = 150;
// Palette, shared with run_summary.ts / role_picker.ts.
const $daf4f1c650b6c0f9$var$RIM = 0xf2a94e;
const $daf4f1c650b6c0f9$var$PANEL_FILL = 0x1b1512;
const $daf4f1c650b6c0f9$var$PANEL_ALPHA = 0.97;
const $daf4f1c650b6c0f9$var$CARD_FILL = 0x241b16;
const $daf4f1c650b6c0f9$var$CARD_HOVER_FILL = 0x33271e;
const $daf4f1c650b6c0f9$var$CARD_RIM = 0x6b4f38;
const $daf4f1c650b6c0f9$var$TEXT_COLOR = 0xfff3e0;
const $daf4f1c650b6c0f9$var$SCRIM_COLOR = 0x06060a;
const $daf4f1c650b6c0f9$var$MUTED = 0x8d97ad;
// The undead's own colour, used only for the thing the player is about to become: a cold rim on a
// live card and on "Let go". Everything else on the panel is warm, so one cool accent is enough to
// say this way out is not the camp's.
const $daf4f1c650b6c0f9$var$UNDEAD = 0x9fd2ff;
// A camp already fighting is the louder choice, not the disqualified one.
const $daf4f1c650b6c0f9$var$FIGHTING = 0xff8a5c;
// Fade timing -- mirrors the role picker / scorecard (~100ms each way), done by hand here because
// this widget is shown and hidden by the GUI manager rather than by a Fader of its own.
const $daf4f1c650b6c0f9$var$FADE_STEP = 0.14;
class $daf4f1c650b6c0f9$export$9306c99f3e124fbc extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), this.plate = new (0, $gwPoJ.Graphics)(), this.slots = [], this.cardRow = new (0, $8t5Gy.Container)(), this.footer = new (0, $gwPoJ.Graphics)(), // The newest list the feed gave us, and how long ago it arrived. The age is what drains the
        // countdowns; see candidateTimingLabel.
        this.candidates = [], this.ageMs = 0, // The timing strings last drawn, so the per-frame drain only touches a Text when its second
        // actually ticks over.
        this.drawnTiming = [], this.layoutPending = false, this.opened = false, // ===== public API =================================================================
        this.isOpen = ()=>this.opened, // Open on what the client already holds. Deliberately takes the list rather than fetching one:
        // the press must not wait for a server round trip (see the note at the top of this file).
        //
        // The slots are wiped FIRST. Clearing them on close instead would be wrong in the other
        // direction: a slot left holding a camp that has since dropped out would come back up as a gap
        // in a row, sized for a camp the player never saw.
        this.open = (candidates)=>{
            this.slots.forEach((slot)=>{
                slot.entityId = undefined;
                slot.vacated = false;
                slot.hovered = false;
            });
            // Nothing is hovered on a picker that is not up yet, so there is nothing to defer to -- and
            // the last visit's positions must not be inherited.
            this.laidOut = undefined;
            this.layoutPending = false;
            this.setCandidates(candidates);
            this.layoutCards(true);
            if (!this.visible) this.alpha = 0;
            this.opened = true;
            this.visible = true;
        }, // Dismiss. The content is deliberately left standing so the fade-out shows what the player was
        // looking at rather than collapsing to the empty state on its way off the screen.
        this.close = ()=>{
            this.opened = false;
            this.slots.forEach((slot)=>{
                if (slot.hovered) {
                    slot.hovered = false;
                    this.drawSlot(slot);
                }
            });
        }, // A fresh list off the feed. No-op on the display tree while closed, but the candidates are
        // still remembered: the scorecard's button reads them, and the picker may be opened from them
        // on the very next press.
        this.setCandidates = (candidates)=>{
            this.candidates = candidates || [];
            this.ageMs = 0;
            this.seatCandidates();
            this.fill();
        }, // Which camps the picker currently has to offer -- what a card press can mean, for a caller
        // outside the display tree (and for a test).
        this.liveEntityIds = ()=>this.slots.filter((slot)=>!!slot.entityId && !slot.vacated).map((slot)=>slot.entityId), // Whether the panel is showing the "no camp is open" state rather than any cards.
        this.isEmptyState = ()=>this.liveEntityIds().length < 1, // What one slot currently says, top line to bottom. The readable summary of a slot for a caller
        // outside the display tree.
        this.slotText = (index)=>{
            const slot = this.slots[index];
            return slot ? [
                slot.name.text,
                slot.wave.text,
                slot.timing.text
            ] : [];
        }, // Pick a camp. This IS the card's handler, and it is public because the cards are buried in the
        // display tree -- anything holding a defending player's id holds the control.
        this.pick = (entityId)=>{
            // The `opened` guard is for the fade-out: the panel is still drawn (and still catching
            // presses) for ~100ms after it has been dismissed, and a camp invaded on the way out would
            // be a camp nobody chose.
            if (!this.opened) return;
            const slot = this.slots.find((s)=>s.entityId === entityId && !s.vacated);
            if (!slot) return;
            this.onJoin?.(entityId);
        }, // Drain the countdowns, and the fade. Called every frame by the GUI manager; cheap while shut.
        this.animate = (dtMs)=>{
            if (!this.visible) return;
            const target = this.opened ? 1 : 0;
            if (this.alpha !== target) {
                this.alpha = target > this.alpha ? Math.min(1, this.alpha + $daf4f1c650b6c0f9$var$FADE_STEP) : Math.max(0, this.alpha - $daf4f1c650b6c0f9$var$FADE_STEP);
                if (this.alpha <= 0) {
                    this.visible = false;
                    return;
                }
            }
            if (!this.opened) return;
            this.ageMs += dtMs;
            this.refreshTiming();
        }, // ===== internals ==================================================================
        // Seat the newest list in the fixed slots: a camp keeps the slot it already had, a camp that has
        // dropped out leaves its slot standing (dead), and only a slot that never held anything takes a
        // newcomer. That is the whole anti-slide rule -- see the file header.
        this.seatCandidates = ()=>{
            const byId = new Map();
            this.candidates.slice(0, $daf4f1c650b6c0f9$export$4f5c9faaebb411d3).forEach((candidate)=>{
                if (candidate?.entityId) byId.set(candidate.entityId, candidate);
            });
            this.slots.forEach((slot)=>{
                if (!slot.entityId) return;
                if (byId.has(slot.entityId)) {
                    byId.delete(slot.entityId);
                    slot.vacated = false;
                    return;
                }
                // Gone. Keep the slot, mark it, and never hand it to anybody else.
                slot.vacated = true;
            });
            Array.from(byId.keys()).forEach((entityId)=>{
                const free = this.slots.find((slot)=>!slot.entityId);
                if (!free) return;
                free.entityId = entityId;
                free.vacated = false;
            });
        }, this.candidateFor = (entityId)=>entityId ? this.candidates.find((candidate)=>candidate?.entityId === entityId) : undefined, // Write every slot's labels and redraw it. Called on each feed tick (and on open), not per
        // frame -- the per-frame path is refreshTiming, which touches one line.
        this.fill = ()=>{
            const empty = this.isEmptyState();
            this.cardRow.visible = !empty;
            this.emptyLine.visible = empty;
            this.emptySub.visible = empty;
            this.title.text = empty ? "THE DEAD WAIT" : "THE DEAD WALK";
            this.subtitle.text = empty ? "Nothing is open to you yet." : "Choose a fire to rise at. You will wake as one of its attackers.";
            this.footerLabel.text = empty ? "BACK" : "NOT YET";
            this.center(this.title);
            this.center(this.subtitle);
            this.center(this.emptyLine);
            this.center(this.emptySub);
            this.footerLabel.x = Math.round($daf4f1c650b6c0f9$var$CENTER_X - this.footerLabel.width / 2);
            this.slots.forEach((slot, index)=>{
                const candidate = this.candidateFor(slot.entityId);
                const live = !!candidate && !slot.vacated;
                slot.container.interactive = live;
                slot.container.cursor = live ? "pointer" : "default";
                if (live) {
                    slot.name.text = $daf4f1c650b6c0f9$export$b2a71ccdb46cebdd(candidate);
                    slot.wave.text = $daf4f1c650b6c0f9$export$72b7e65d3fa926ba(candidate);
                    slot.timing.text = $daf4f1c650b6c0f9$export$55099e7ccfabe53e(candidate, this.ageMs);
                    slot.timing.tint = candidate.waveActive ? $daf4f1c650b6c0f9$var$FIGHTING : $daf4f1c650b6c0f9$var$UNDEAD;
                } else {
                    slot.name.text = "";
                    slot.wave.text = "";
                    slot.timing.text = "";
                }
                this.drawnTiming[index] = slot.timing.text;
                this.centerIn(slot.name, $daf4f1c650b6c0f9$export$bed693db0561df20);
                this.centerIn(slot.wave, $daf4f1c650b6c0f9$export$bed693db0561df20);
                this.centerIn(slot.timing, $daf4f1c650b6c0f9$export$bed693db0561df20);
                this.drawSlot(slot);
            });
            this.layoutCards();
        }, /** The slots currently showing a camp, in slot order. */ this.liveSlots = ()=>this.slots.filter((slot)=>!!this.candidateFor(slot.entityId) && !slot.vacated), /**
     * Place the live cards CENTRED, and draw nothing where a camp has dropped out.
     *
     * The slots themselves stay fixed and ordered -- a camp keeps the slot it was first given, and a
     * slot it has vacated is never handed to anybody else -- so what moves here is only where a card
     * is DRAWN, never which camp a given card means. That is what keeps "the press means the camp
     * the player was looking at" true while still closing the gaps up.
     *
     * Deferred while the pointer is over the row, because the press resolves on pointerDOWN: the
     * hazard is not a card moving mid-click, it is a card moving while the player is reaching for
     * it, which would land their press on a stranger they never chose. The pending layout is taken
     * the moment they move off.
     */ this.layoutCards = (force = false)=>{
            const live = this.liveSlots();
            const signature = live.map((slot)=>slot.entityId).join("|");
            if (signature === this.laidOut) {
                this.layoutPending = false;
                return;
            }
            if (!force && this.slots.some((slot)=>slot.hovered)) {
                this.layoutPending = true;
                return;
            }
            const width = live.length * $daf4f1c650b6c0f9$export$bed693db0561df20 + Math.max(0, live.length - 1) * $daf4f1c650b6c0f9$export$c73e9b0a14b3993b;
            let x = Math.round($daf4f1c650b6c0f9$var$CENTER_X - width / 2);
            this.slots.forEach((slot)=>{
                slot.container.visible = false;
            });
            live.forEach((slot)=>{
                slot.container.visible = true;
                slot.container.x = x;
                x += $daf4f1c650b6c0f9$export$bed693db0561df20 + $daf4f1c650b6c0f9$export$c73e9b0a14b3993b;
            });
            this.laidOut = signature;
            this.layoutPending = false;
        }, /** Where the live cards sit, for a caller outside the display tree. */ this.cardPositions = ()=>this.liveSlots().map((slot)=>slot.container.x), /** Hovering a card, and the one thing it owes the layout on the way out. */ this.hover = (handle, hovered)=>{
            handle.hovered = hovered;
            this.drawSlot(handle);
            // Whatever the feed said while they were reading it.
            if (!hovered && this.layoutPending && !this.slots.some((slot)=>slot.hovered)) this.layoutCards();
        }, /** Drive the hover from a test: pixi's own pointer events are not available under jsdom. */ this.setHovered = (index, hovered)=>{
            const slot = this.slots[index];
            if (slot) this.hover(slot, hovered);
        }, // The per-frame half of the drain: only the timing line can change between feed ticks, and only
        // when its whole second ticks over, so this is a string compare per card and nothing else.
        this.refreshTiming = ()=>{
            this.slots.forEach((slot, index)=>{
                const candidate = this.candidateFor(slot.entityId);
                if (!candidate || slot.vacated) return;
                const next = $daf4f1c650b6c0f9$export$55099e7ccfabe53e(candidate, this.ageMs);
                if (next === this.drawnTiming[index]) return;
                this.drawnTiming[index] = next;
                slot.timing.text = next;
                this.centerIn(slot.timing, $daf4f1c650b6c0f9$export$bed693db0561df20);
            });
        }, this.buildSlot = (index)=>{
            const container = new (0, $8t5Gy.Container)();
            container.x = $daf4f1c650b6c0f9$var$PANEL_LEFT + $daf4f1c650b6c0f9$var$PAD + index * ($daf4f1c650b6c0f9$export$bed693db0561df20 + $daf4f1c650b6c0f9$export$c73e9b0a14b3993b);
            container.y = $daf4f1c650b6c0f9$var$CARD_TOP;
            container.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $daf4f1c650b6c0f9$export$bed693db0561df20, $daf4f1c650b6c0f9$var$CARD_H);
            const bg = new (0, $gwPoJ.Graphics)();
            container.addChild(bg);
            // A skull rather than a portrait: the client has no appearance for a player in another
            // room, and a card promising a face it cannot draw is worse than one that doesn't.
            const sigil = this.text("\uD83D\uDC80", {
                role: "title"
            });
            sigil.y = 12;
            this.centerIn(sigil, $daf4f1c650b6c0f9$export$bed693db0561df20);
            container.addChild(sigil);
            const name = this.text("", {
                role: "compactBody",
                color: $daf4f1c650b6c0f9$var$TEXT_COLOR,
                bold: true
            });
            name.y = 46;
            const wave = this.text("", {
                role: "compactCaption",
                color: $daf4f1c650b6c0f9$var$RIM
            });
            wave.y = 66;
            const timing = this.text("", {
                role: "compactCaption",
                color: $daf4f1c650b6c0f9$var$UNDEAD
            });
            timing.y = 80;
            container.addChild(name, wave, timing);
            const handle = {
                container: container,
                bg: bg,
                name: name,
                wave: wave,
                timing: timing,
                vacated: false,
                hovered: false
            };
            container.on("pointerover", ()=>this.hover(handle, true));
            container.on("pointerout", ()=>this.hover(handle, false));
            container.on("pointerdown", (event)=>{
                event.stopPropagation();
                // Read the id off the slot at press time: the feed may have changed what this card is
                // showing since it was drawn, and the press has to mean whatever it says NOW.
                if (handle.entityId && !handle.vacated) this.pick(handle.entityId);
            });
            this.cardRow.addChild(container);
            return handle;
        }, this.drawSlot = (slot)=>{
            const candidate = this.candidateFor(slot.entityId);
            const live = !!candidate && !slot.vacated;
            const accent = candidate?.waveActive ? $daf4f1c650b6c0f9$var$FIGHTING : $daf4f1c650b6c0f9$var$UNDEAD;
            const g = slot.bg;
            g.clear();
            if (!live) {
                // An empty or spent slot is a frame, not a button: no glow, no fill to speak of.
                g.lineStyle(1, $daf4f1c650b6c0f9$var$CARD_RIM, slot.vacated ? 0.5 : 0.25);
                g.beginFill($daf4f1c650b6c0f9$var$CARD_FILL, slot.vacated ? 0.5 : 0.25);
                g.drawRoundedRect(0, 0, $daf4f1c650b6c0f9$export$bed693db0561df20, $daf4f1c650b6c0f9$var$CARD_H, 8);
                g.endFill();
                slot.name.alpha = 0.5;
                slot.wave.alpha = 0.45;
                slot.timing.alpha = 0.45;
                return;
            }
            slot.name.alpha = 1;
            slot.wave.alpha = 0.85;
            slot.timing.alpha = 0.95;
            if (slot.hovered) {
                // Fake glow: a fatter low-alpha copy behind the card. Cheaper than a blur filter, which
                // is the rule across this UI because filters cost real money on a weak GPU.
                g.beginFill(accent, 0.18);
                g.drawRoundedRect(-3, -3, $daf4f1c650b6c0f9$export$bed693db0561df20 + 6, $daf4f1c650b6c0f9$var$CARD_H + 6, 11);
                g.endFill();
                g.lineStyle(2, accent, 1);
                g.beginFill($daf4f1c650b6c0f9$var$CARD_HOVER_FILL, 0.97);
            } else {
                g.lineStyle(1.5, $daf4f1c650b6c0f9$var$CARD_RIM, 0.75);
                g.beginFill($daf4f1c650b6c0f9$var$CARD_FILL, 0.9);
            }
            g.drawRoundedRect(0, 0, $daf4f1c650b6c0f9$export$bed693db0561df20, $daf4f1c650b6c0f9$var$CARD_H, 8);
            g.endFill();
        }, this.drawPlate = ()=>{
            const g = this.plate;
            g.clear();
            g.beginFill($daf4f1c650b6c0f9$var$RIM, 0.06);
            g.drawRoundedRect($daf4f1c650b6c0f9$var$PANEL_LEFT - 6, $daf4f1c650b6c0f9$var$PANEL_TOP - 6, $daf4f1c650b6c0f9$var$PANEL_W + 12, $daf4f1c650b6c0f9$var$PANEL_H + 12, 16);
            g.endFill();
            g.lineStyle(2, $daf4f1c650b6c0f9$var$RIM, 0.9);
            g.beginFill($daf4f1c650b6c0f9$var$PANEL_FILL, $daf4f1c650b6c0f9$var$PANEL_ALPHA);
            g.drawRoundedRect($daf4f1c650b6c0f9$var$PANEL_LEFT, $daf4f1c650b6c0f9$var$PANEL_TOP, $daf4f1c650b6c0f9$var$PANEL_W, $daf4f1c650b6c0f9$var$PANEL_H, 12);
            g.endFill();
        }, this.drawFooter = (hovered)=>{
            const g = this.footer;
            g.clear();
            g.lineStyle(1.5, hovered ? $daf4f1c650b6c0f9$var$RIM : $daf4f1c650b6c0f9$var$CARD_RIM, hovered ? 1 : 0.7);
            g.beginFill($daf4f1c650b6c0f9$var$CARD_FILL, hovered ? 0.95 : 0.8);
            g.drawRoundedRect(0, 0, $daf4f1c650b6c0f9$var$FOOTER_W, $daf4f1c650b6c0f9$var$FOOTER_H, 7);
            g.endFill();
        }, this.text = (value, opts)=>{
            let renderer = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role(opts.role).bold(false).align("center");
            if (opts.color !== undefined) renderer = renderer.color(opts.color);
            if (opts.bold) renderer = renderer.bold();
            const text = renderer.render(value);
            if (opts.alpha !== undefined) text.alpha = opts.alpha;
            if (opts.center) this.center(text);
            return text;
        }, // Centre on the panel's own axis. Both of these are no-ops under a mocked canvas (every Text
        // measures as zero wide there), which is why no test asserts on a position.
        this.center = (text)=>{
            text.x = Math.round($daf4f1c650b6c0f9$var$CENTER_X - text.width / 2);
        }, this.centerIn = (text, width)=>{
            text.x = Math.round(width / 2 - text.width / 2);
        };
        this.onJoin = props.onJoin;
        this.onCancel = props.onCancel;
        // The scrim swallows every press that isn't on a card, and a press on it is an answer:
        // clicking off this panel means "not now". It has to swallow them even when it isn't
        // answering, or a stray click fires the player's bow into the camp behind the scorecard.
        this.scrim = new (0, $gwPoJ.Graphics)();
        this.scrim.beginFill($daf4f1c650b6c0f9$var$SCRIM_COLOR, 0.55);
        this.scrim.drawRect(-400, -400, $daf4f1c650b6c0f9$var$SCREEN_W + 800, 1400);
        this.scrim.endFill();
        this.scrim.interactive = true;
        this.scrim.hitArea = new (0, $6qzqq.Rectangle)(-400, -400, $daf4f1c650b6c0f9$var$SCREEN_W + 800, 1400);
        this.scrim.on("pointerdown", (event)=>{
            event.stopPropagation();
            this.onCancel?.();
        });
        this.scrim.on("pointermove", (event)=>event.stopPropagation());
        this.scrim.on("rightclick", (event)=>event.stopPropagation());
        this.addChild(this.scrim);
        this.panel = new (0, $8t5Gy.Container)();
        // Presses inside the panel never reach the scrim, so the panel's own gaps are not a way to
        // dismiss it by accident.
        this.panel.interactive = true;
        this.panel.hitArea = new (0, $6qzqq.Rectangle)($daf4f1c650b6c0f9$var$PANEL_LEFT, $daf4f1c650b6c0f9$var$PANEL_TOP, $daf4f1c650b6c0f9$var$PANEL_W, $daf4f1c650b6c0f9$var$PANEL_H);
        this.panel.on("pointerdown", (event)=>event.stopPropagation());
        this.panel.on("pointermove", (event)=>event.stopPropagation());
        this.addChild(this.panel);
        this.panel.addChild(this.plate);
        this.drawPlate();
        this.title = this.text("THE DEAD WALK", {
            role: "compactTitle",
            color: $daf4f1c650b6c0f9$var$RIM,
            bold: true,
            center: true
        });
        this.title.y = $daf4f1c650b6c0f9$var$PANEL_TOP + 10;
        this.subtitle = this.text("Choose a fire to rise at. You will wake as one of its attackers.", {
            role: "compactCaption",
            alpha: 0.6,
            center: true
        });
        this.subtitle.y = $daf4f1c650b6c0f9$var$PANEL_TOP + 29;
        this.panel.addChild(this.title, this.subtitle);
        this.cardRow.y = 0;
        this.panel.addChild(this.cardRow);
        for(let i = 0; i < $daf4f1c650b6c0f9$export$4f5c9faaebb411d3; i++)this.slots.push(this.buildSlot(i));
        // Centred on the card row's own band, so the two states occupy the same space and the panel
        // does not appear to resize when the last camp drops out.
        this.emptyLine = this.text("No camp is open to the dead right now.", {
            role: "compactLabel",
            color: $daf4f1c650b6c0f9$var$MUTED,
            center: true
        });
        this.emptyLine.y = $daf4f1c650b6c0f9$var$CARD_TOP + $daf4f1c650b6c0f9$var$CARD_H / 2 - 16;
        this.emptySub = this.text("The living are keeping their fires closed. Try again in a moment.", {
            role: "compactCaption",
            alpha: 0.5,
            center: true
        });
        this.emptySub.y = $daf4f1c650b6c0f9$var$CARD_TOP + $daf4f1c650b6c0f9$var$CARD_H / 2 + 2;
        this.panel.addChild(this.emptyLine, this.emptySub);
        this.footerLabel = this.text("NOT YET", {
            role: "compactLabel",
            color: $daf4f1c650b6c0f9$var$TEXT_COLOR,
            bold: true,
            center: true
        });
        this.footer.x = $daf4f1c650b6c0f9$var$CENTER_X - $daf4f1c650b6c0f9$var$FOOTER_W / 2;
        this.footer.y = $daf4f1c650b6c0f9$var$FOOTER_TOP;
        this.footerLabel.y = $daf4f1c650b6c0f9$var$FOOTER_TOP + 8;
        this.footer.interactive = true;
        this.footer.cursor = "pointer";
        this.footer.hitArea = new (0, $6qzqq.Rectangle)(-4, -4, $daf4f1c650b6c0f9$var$FOOTER_W + 8, $daf4f1c650b6c0f9$var$FOOTER_H + 8);
        this.footer.on("pointerdown", (event)=>{
            event.stopPropagation();
            this.onCancel?.();
        });
        this.footer.on("pointerover", ()=>this.drawFooter(true));
        this.footer.on("pointerout", ()=>this.drawFooter(false));
        this.panel.addChild(this.footer, this.footerLabel);
        this.drawFooter(false);
        this.fill();
        this.visible = false;
    }
}
// ===== "Let go" =======================================================================
// LEAVING: the one exit the invader presses themself. The other four fire on their own (you die,
// you kill the Lord, the wave is cleared, the defender leaves), and all five land in the same
// place: a fresh camp of the player's own.
//
// It exists ONLY while Message.invading is true, which is why this is a button and not a menu item:
// a player wearing somebody else's attacker, in a room that is not theirs, needs exactly one
// visible way home and needs to find it without opening anything.
//
// Cool-rimmed where the camp HUD is warm, because it belongs to the invasion rather than to the
// camp being invaded.
const $daf4f1c650b6c0f9$var$LETGO_W = 104;
const $daf4f1c650b6c0f9$var$LETGO_H = 26;
class $daf4f1c650b6c0f9$export$59009c2c2d99348c extends (0, $8t5Gy.Container) {
    constructor({ onPress: onPress }){
        super(), this.bg = new (0, $gwPoJ.Graphics)(), this.hovered = false, this.getWidth = ()=>$daf4f1c650b6c0f9$var$LETGO_W, this.getHeight = ()=>$daf4f1c650b6c0f9$var$LETGO_H, // Follows the server's verdict on every message (Message.invading), exactly as the downed flag
        // does -- never a local guess, so the button cannot outlive the body it lets go of.
        this.setInvading = (invading)=>{
            if (this.visible === invading) return;
            this.visible = invading;
            this.hovered = false;
            this.draw();
        }, this.draw = ()=>{
            const g = this.bg;
            g.clear();
            g.beginFill($daf4f1c650b6c0f9$var$UNDEAD, this.hovered ? 0.2 : 0.1);
            g.drawRoundedRect(-3, -3, $daf4f1c650b6c0f9$var$LETGO_W + 6, $daf4f1c650b6c0f9$var$LETGO_H + 6, 9);
            g.endFill();
            g.lineStyle(1.5, $daf4f1c650b6c0f9$var$UNDEAD, this.hovered ? 1 : 0.75);
            g.beginFill(0x0a1118, this.hovered ? 0.96 : 0.86);
            g.drawRoundedRect(0, 0, $daf4f1c650b6c0f9$var$LETGO_W, $daf4f1c650b6c0f9$var$LETGO_H, 6);
            g.endFill();
            this.label.alpha = this.hovered ? 1 : 0.9;
        };
        this.label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("compactLabel").color($daf4f1c650b6c0f9$var$TEXT_COLOR).bold().align("center").render("LET GO");
        this.label.x = Math.round($daf4f1c650b6c0f9$var$LETGO_W / 2 - this.label.width / 2);
        this.label.y = 6;
        this.addChild(this.bg, this.label);
        this.interactive = true;
        this.cursor = "pointer";
        // Proud of the fill on every side: it is 26px tall and it is the way out.
        this.hitArea = new (0, $6qzqq.Rectangle)(-4, -4, $daf4f1c650b6c0f9$var$LETGO_W + 8, $daf4f1c650b6c0f9$var$LETGO_H + 8);
        this.on("pointerdown", (event)=>{
            event.stopPropagation();
            onPress();
        });
        this.on("pointerover", ()=>{
            this.hovered = true;
            this.draw();
        });
        this.on("pointerout", ()=>{
            this.hovered = false;
            this.draw();
        });
        this.draw();
        this.visible = false;
    }
}



parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");



const $fd1228436d3e60cd$export$abbfafa8f348c16c = (kind)=>kind === "possessed" ? {
        title: "YOU HAVE POSSESSED AN INVADER",
        line: "You wear one of the wave's attackers. The camp does not know you.",
        button: "DISMISS"
    } : {
        title: "RETURNED TO THE LAND OF THE LIVING",
        line: "The borrowed body is finished with. You are yourself again.",
        button: "DISMISS"
    };
const $fd1228436d3e60cd$export$42463ac0de0f0a2 = (was, now)=>was === now ? undefined : now ? "possessed" : "returned";
// ===== geometry =======================================================================
// Stage units, with the 1.3 vertical stretch already accounted for -- the frame run_summary.ts and
// invasion_picker.ts work in, because this opens over the same screen.
const $fd1228436d3e60cd$var$SCREEN_W = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7;
const $fd1228436d3e60cd$var$CENTER_X = $fd1228436d3e60cd$var$SCREEN_W / 2;
const $fd1228436d3e60cd$var$CENTER_Y = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h / 2 + 52;
const $fd1228436d3e60cd$var$PANEL_W = 420;
const $fd1228436d3e60cd$var$PANEL_H = 150;
const $fd1228436d3e60cd$var$PANEL_LEFT = $fd1228436d3e60cd$var$CENTER_X - $fd1228436d3e60cd$var$PANEL_W / 2;
const $fd1228436d3e60cd$var$PANEL_TOP = $fd1228436d3e60cd$var$CENTER_Y - $fd1228436d3e60cd$var$PANEL_H / 2;
const $fd1228436d3e60cd$var$BUTTON_W = 150;
const $fd1228436d3e60cd$var$BUTTON_H = (0, $97475243e21a0995$export$73e83bf2b7e02467).medium.height;
const $fd1228436d3e60cd$var$BUTTON_TOP = $fd1228436d3e60cd$var$PANEL_TOP + $fd1228436d3e60cd$var$PANEL_H - $fd1228436d3e60cd$var$BUTTON_H - 18;
// Palette, shared with run_summary.ts / invasion_picker.ts.
const $fd1228436d3e60cd$var$PANEL_FILL = 0x1b1512;
const $fd1228436d3e60cd$var$PANEL_ALPHA = 0.97;
const $fd1228436d3e60cd$var$RIM = 0xf2a94e;
const $fd1228436d3e60cd$var$TEXT_COLOR = 0xfff3e0;
const $fd1228436d3e60cd$var$MUTED = 0xbfae99;
const $fd1228436d3e60cd$var$SCRIM_COLOR = 0x06060a;
// The undead's own cold colour, for the half of this that is about wearing somebody else.
const $fd1228436d3e60cd$var$UNDEAD = 0x9fd2ff;
const $fd1228436d3e60cd$var$FADE_STEP = 0.14;
class $fd1228436d3e60cd$export$3cab3b6954a18297 extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), this.opened = false, this.kind = "possessed", this.isOpen = ()=>this.opened, /** Which message is up, for a caller outside the display tree (and for a test). */ this.shownKind = ()=>this.opened ? this.kind : undefined, this.open = (kind)=>{
            this.kind = kind;
            this.build();
            if (!this.visible) this.alpha = 0;
            this.opened = true;
            this.visible = true;
        }, this.close = ()=>{
            this.opened = false;
        }, this.animate = (_dtMs)=>{
            if (!this.visible) return;
            const target = this.opened ? 1 : 0;
            if (this.alpha === target) return;
            this.alpha = target > this.alpha ? Math.min(1, this.alpha + $fd1228436d3e60cd$var$FADE_STEP) : Math.max(0, this.alpha - $fd1228436d3e60cd$var$FADE_STEP);
            if (this.alpha <= 0) this.visible = false;
        }, // ===== internals ==================================================================
        this.build = ()=>{
            if (this.content) {
                this.panel.removeChild(this.content);
                this.content.destroy({
                    children: true
                });
                this.content = undefined;
            }
            const copy = $fd1228436d3e60cd$export$abbfafa8f348c16c(this.kind);
            // Warm for coming home, cold for putting somebody else's face on -- the one accent the
            // scorecard and the picker already use to mean "this is the undead's half".
            const accent = this.kind === "possessed" ? $fd1228436d3e60cd$var$UNDEAD : $fd1228436d3e60cd$var$RIM;
            const content = new (0, $8t5Gy.Container)();
            this.content = content;
            this.panel.addChild(content);
            const chrome = new (0, $gwPoJ.Graphics)();
            chrome.beginFill(accent, 0.1);
            chrome.drawRoundedRect($fd1228436d3e60cd$var$PANEL_LEFT - 6, $fd1228436d3e60cd$var$PANEL_TOP - 6, $fd1228436d3e60cd$var$PANEL_W + 12, $fd1228436d3e60cd$var$PANEL_H + 12, 16);
            chrome.endFill();
            chrome.lineStyle(1.5, accent, 0.85);
            chrome.beginFill($fd1228436d3e60cd$var$PANEL_FILL, $fd1228436d3e60cd$var$PANEL_ALPHA);
            chrome.drawRoundedRect($fd1228436d3e60cd$var$PANEL_LEFT, $fd1228436d3e60cd$var$PANEL_TOP, $fd1228436d3e60cd$var$PANEL_W, $fd1228436d3e60cd$var$PANEL_H, 12);
            chrome.endFill();
            content.addChild(chrome);
            const title = this.text(copy.title, {
                role: "compactTitle",
                color: accent,
                bold: true
            });
            title.x = Math.round($fd1228436d3e60cd$var$CENTER_X - title.width / 2);
            title.y = $fd1228436d3e60cd$var$PANEL_TOP + 22;
            content.addChild(title);
            const line = this.text(copy.line, {
                role: "compactLabel",
                color: $fd1228436d3e60cd$var$MUTED
            });
            line.x = Math.round($fd1228436d3e60cd$var$CENTER_X - line.width / 2);
            line.y = $fd1228436d3e60cd$var$PANEL_TOP + 58;
            content.addChild(line);
            const button = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
                label: copy.button,
                theme: "ember",
                preset: "primary",
                appearance: "outline",
                width: $fd1228436d3e60cd$var$BUTTON_W,
                height: $fd1228436d3e60cd$var$BUTTON_H,
                size: "medium",
                bold: true,
                accent: this.kind === "possessed" ? $fd1228436d3e60cd$var$UNDEAD : $fd1228436d3e60cd$var$RIM,
                onClick: this.dismiss
            });
            button.position.set($fd1228436d3e60cd$var$CENTER_X - $fd1228436d3e60cd$var$BUTTON_W / 2, $fd1228436d3e60cd$var$BUTTON_TOP);
            content.addChild(button);
        }, /** Guarded on `opened`, so the fade-out cannot answer a second time on the way off the screen. */ this.dismiss = ()=>{
            if (!this.opened) return;
            this.close();
            this.onDismiss?.();
        }, this.text = (value, opts)=>{
            let renderer = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role(opts.role).bold(false).align("center");
            if (opts.color !== undefined) renderer = renderer.color(opts.color);
            if (opts.bold) renderer = renderer.bold();
            return renderer.render(value);
        };
        this.onDismiss = props.onDismiss;
        // The scrim swallows every press that is not the button, and unlike the picker's it is NOT
        // an answer: this panel is telling the player something, and a stray click while they are
        // reading it should not fire their bow into the camp behind -- nor dismiss a message they
        // have not read.
        this.scrim = new (0, $gwPoJ.Graphics)();
        this.scrim.beginFill($fd1228436d3e60cd$var$SCRIM_COLOR, 0.55);
        this.scrim.drawRect(-400, -400, $fd1228436d3e60cd$var$SCREEN_W + 800, 1400);
        this.scrim.endFill();
        this.scrim.interactive = true;
        this.scrim.hitArea = new (0, $6qzqq.Rectangle)(-400, -400, $fd1228436d3e60cd$var$SCREEN_W + 800, 1400);
        this.scrim.on("pointerdown", (event)=>event.stopPropagation());
        this.scrim.on("pointermove", (event)=>event.stopPropagation());
        this.scrim.on("rightclick", (event)=>event.stopPropagation());
        this.addChild(this.scrim);
        this.panel = new (0, $8t5Gy.Container)();
        this.panel.interactive = true;
        this.panel.hitArea = new (0, $6qzqq.Rectangle)($fd1228436d3e60cd$var$PANEL_LEFT, $fd1228436d3e60cd$var$PANEL_TOP, $fd1228436d3e60cd$var$PANEL_W, $fd1228436d3e60cd$var$PANEL_H);
        this.panel.on("pointerdown", (event)=>event.stopPropagation());
        this.panel.on("pointermove", (event)=>event.stopPropagation());
        this.addChild(this.panel);
        this.visible = false;
        this.alpha = 0;
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");




const $6d8fdbf74f9b9254$var$PANEL_W = 300;
const $6d8fdbf74f9b9254$var$PAD_X = 20;
const $6d8fdbf74f9b9254$var$PAD_TOP = 16;
const $6d8fdbf74f9b9254$var$PAD_BOTTOM = 15;
const $6d8fdbf74f9b9254$var$TEXT_X = $6d8fdbf74f9b9254$var$PAD_X;
const $6d8fdbf74f9b9254$var$TEXT_W = $6d8fdbf74f9b9254$var$PANEL_W - $6d8fdbf74f9b9254$var$PAD_X * 2;
// The overline: the server's title, set in letterspaced capitals beside the clues' gold spark.
const $6d8fdbf74f9b9254$var$SPARK_R = 3.5;
const $6d8fdbf74f9b9254$var$SPARK_GAP = 6;
const $6d8fdbf74f9b9254$var$OVERLINE_SPACING = 1.6;
const $6d8fdbf74f9b9254$var$OVERLINE_COLOR = (0, $658a44ce960354bb$export$6b1db5e247c0ce0);
const $6d8fdbf74f9b9254$var$OVERLINE_BODY_GAP = 5;
const $6d8fdbf74f9b9254$var$BODY_COLOR = (0, $97475243e21a0995$export$92999bc7164f195e);
// The buttons, right-aligned on their own row: the quiet way out first, the answer last.
const $6d8fdbf74f9b9254$var$BUTTON_H = (0, $97475243e21a0995$export$73e83bf2b7e02467).small.height;
const $6d8fdbf74f9b9254$var$ACCEPT_W = 92;
const $6d8fdbf74f9b9254$var$SKIP_W = 64;
const $6d8fdbf74f9b9254$var$BUTTON_GAP = 8;
// Clear air between the last line of copy and the button row.
const $6d8fdbf74f9b9254$var$BODY_BUTTONS_GAP = 14;
const $6d8fdbf74f9b9254$var$ACCEPT_X = $6d8fdbf74f9b9254$var$PANEL_W - $6d8fdbf74f9b9254$var$PAD_X - $6d8fdbf74f9b9254$var$ACCEPT_W;
const $6d8fdbf74f9b9254$var$SKIP_X = $6d8fdbf74f9b9254$var$ACCEPT_X - $6d8fdbf74f9b9254$var$BUTTON_GAP - $6d8fdbf74f9b9254$var$SKIP_W;
// The countdown along the bottom of "Show me", as on the chat bubble's Next button.
const $6d8fdbf74f9b9254$var$PROGRESS_H = 2;
const $6d8fdbf74f9b9254$var$PROGRESS_ROW = 4 // the bar plus its clearance from the button's bottom border
;
const $6d8fdbf74f9b9254$var$PROGRESS_INSET = 5 // keeps the bar clear of the chamfer (UiButton cuts min(5, h / 4))
;
const $6d8fdbf74f9b9254$var$PROGRESS_ALPHA = 0.75;
// Fallback line heights, used only where a Text measures as zero (a headless/mocked canvas): the
// panel must never collapse onto its own buttons just because nothing could be measured.
const $6d8fdbf74f9b9254$var$TITLE_LINE_H = 12;
const $6d8fdbf74f9b9254$var$BODY_LINE_H = 17;
// Arrival and departure. It rises the last few pixels into place as it fades in, and drops a little
// as it goes -- a board being set down and taken away, not a dialog popping.
const $6d8fdbf74f9b9254$var$ENTER_MS = 200;
const $6d8fdbf74f9b9254$var$LEAVE_MS = 140;
const $6d8fdbf74f9b9254$var$ENTER_RISE = 8;
const $6d8fdbf74f9b9254$var$LEAVE_DROP = 4;
const $6d8fdbf74f9b9254$var$easeOutCubic = (t)=>1 - Math.pow(1 - t, 3);
const $6d8fdbf74f9b9254$var$clamp01 = (t)=>Math.max(0, Math.min(1, t));
const $6d8fdbf74f9b9254$var$spark = (g, cx, cy, r)=>{
    const k = r * 0.3;
    g.moveTo(cx, cy - r).lineTo(cx + k, cy - k).lineTo(cx + r, cy).lineTo(cx + k, cy + k).lineTo(cx, cy + r).lineTo(cx - k, cy + k).lineTo(cx - r, cy).lineTo(cx - k, cy - k).closePath();
};
class $6d8fdbf74f9b9254$export$7d04c213ce109943 extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), // Height the current copy needs (see setPrompt). Everything that touches the bottom edge --
        // the board, the button row -- reads it rather than a constant.
        this.panelH = $6d8fdbf74f9b9254$var$PAD_TOP + $6d8fdbf74f9b9254$var$TITLE_LINE_H + $6d8fdbf74f9b9254$var$OVERLINE_BODY_GAP + $6d8fdbf74f9b9254$var$BODY_LINE_H + $6d8fdbf74f9b9254$var$BODY_BUTTONS_GAP + $6d8fdbf74f9b9254$var$BUTTON_H + $6d8fdbf74f9b9254$var$PAD_BOTTOM, // Countdown state. `remainingMs` only ticks while the bar is open; at 0 it resolves to accept.
        this.totalMs = 0, this.remainingMs = 0, this.progressWidth = -1, this.acceptChoice = "accept", this.acceptWidth = $6d8fdbf74f9b9254$var$ACCEPT_W, this.opened = false, this.motion = "hidden", this.motionMs = 0;
        this.onChoose = props.onChoose;
        // Swallow pointer events over the bar so a click on it never falls through to a world
        // attack (the buttons handle their own clicks; this covers the text/gaps).
        this.interactive = true;
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $6d8fdbf74f9b9254$var$PANEL_W, this.panelH);
        this.on("pointerdown", (event)=>event.stopPropagation());
        this.on("pointermove", (event)=>event.stopPropagation());
        this.on("rightclick", (event)=>event.stopPropagation());
        this.on("contextmenu", (event)=>{
            event.preventDefault();
            event.stopPropagation();
        });
        this.bg = new (0, $gwPoJ.Graphics)();
        this.addChild(this.bg);
        this.textLayer = new (0, $8t5Gy.Container)();
        this.addChild(this.textLayer);
        this.buttonLayer = new (0, $8t5Gy.Container)();
        this.addChild(this.buttonLayer);
        // Over the buttons, so the bar sits on the face of "Show me".
        this.progress = new (0, $gwPoJ.Graphics)();
        this.addChild(this.progress);
        this.drawBackground();
        this.visible = false;
    }
    // On-stage footprint, so GuiManager can place the bar without reaching into pixi's measured
    // bounds (which include the dropped shadow).
    static stageWidth() {
        return $6d8fdbf74f9b9254$var$PANEL_W;
    }
    // Instance-side, not static: the bar's height depends on the copy the server sent, so whoever
    // anchors it to the bottom of the screen has to re-read this after setPrompt.
    stageHeight() {
        return this.panelH;
    }
    drawBackground() {
        const g = this.bg;
        g.clear();
        (0, $658a44ce960354bb$export$37d7f1037ab575d0)(g, $6d8fdbf74f9b9254$var$PANEL_W, this.panelH);
    }
    // The countdown: a gold line along the bottom of "Show me" that runs out as the bar waits. Only
    // repainted when its width moves by a whole pixel.
    drawProgress() {
        const g = this.progress;
        const accept = this.accept;
        const full = this.acceptWidth - $6d8fdbf74f9b9254$var$PROGRESS_INSET * 2;
        const pct = this.totalMs > 0 ? $6d8fdbf74f9b9254$var$clamp01(this.remainingMs / this.totalMs) : 0;
        const width = accept ? Math.round(full * pct) : 0;
        if (width === this.progressWidth) return;
        this.progressWidth = width;
        g.clear();
        if (!accept || width <= 0) return;
        g.beginFill((0, $658a44ce960354bb$export$319b6132a2fafb7c), $6d8fdbf74f9b9254$var$PROGRESS_ALPHA);
        g.drawRect(accept.x + $6d8fdbf74f9b9254$var$PROGRESS_INSET, accept.y + $6d8fdbf74f9b9254$var$BUTTON_H - $6d8fdbf74f9b9254$var$PROGRESS_ROW, width, $6d8fdbf74f9b9254$var$PROGRESS_H);
        g.endFill();
    }
    makeButton(label, x, y, width, choice) {
        const primary = choice !== "skip";
        const button = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
            label: label,
            width: width,
            height: $6d8fdbf74f9b9254$var$BUTTON_H,
            size: "small",
            theme: "ember",
            shape: "chamfer",
            variant: primary ? "primary" : "secondary",
            accent: primary ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : undefined,
            textColor: primary ? (0, $97475243e21a0995$export$92999bc7164f195e) : (0, $97475243e21a0995$export$4569a0b09aa32d6c),
            bold: primary,
            onClick: ()=>this.choose(choice, "click")
        });
        button.position.set(x, y);
        this.buttonLayer.addChild(button);
        return button;
    }
    clearHover() {
        this.accept?.resetInteraction();
        this.skip?.resetInteraction();
    }
    // Answer once and only once: the first choice closes the bar, so a click landing in the same
    // frame the countdown expires can't send two answers.
    choose(choice, reason) {
        if (!this.opened) return;
        this.opened = false;
        this.onChoose?.(choice, reason);
    }
    // Rebuild the bar around a server-authored prompt (copy and countdown both come from the
    // server, so the wording can be retuned without a client release).
    setPrompt(prompt) {
        this.textLayer.removeChildren().forEach((child)=>child.destroy({
                children: true,
                texture: true,
                baseTexture: true
            }));
        this.buttonLayer.removeChildren().forEach((button)=>button.destroy({
                children: true
            }));
        this.accept = undefined;
        this.skip = undefined;
        // The spark, on the overline's centre.
        const sparkG = new (0, $gwPoJ.Graphics)();
        this.textLayer.addChild(sparkG);
        // Both lines wrap inside the bar rather than running off it (or under the buttons): the
        // wrap width is set at BUILD time so the measured height below is true on the first frame.
        const overlineX = $6d8fdbf74f9b9254$var$TEXT_X + $6d8fdbf74f9b9254$var$SPARK_R * 2 + $6d8fdbf74f9b9254$var$SPARK_GAP;
        const title = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($6d8fdbf74f9b9254$var$OVERLINE_COLOR).role("compactCaption").bold().strokeThickness(0).wordWrap($6d8fdbf74f9b9254$var$TEXT_W - (overlineX - $6d8fdbf74f9b9254$var$TEXT_X)).render((prompt.title || "").toUpperCase());
        title.style.letterSpacing = $6d8fdbf74f9b9254$var$OVERLINE_SPACING;
        title.x = overlineX;
        title.y = $6d8fdbf74f9b9254$var$PAD_TOP;
        this.textLayer.addChild(title);
        const titleH = Math.max(title.height, $6d8fdbf74f9b9254$var$TITLE_LINE_H);
        sparkG.beginFill((0, $658a44ce960354bb$export$319b6132a2fafb7c), 1);
        $6d8fdbf74f9b9254$var$spark(sparkG, $6d8fdbf74f9b9254$var$TEXT_X + $6d8fdbf74f9b9254$var$SPARK_R, $6d8fdbf74f9b9254$var$PAD_TOP + Math.min(titleH, $6d8fdbf74f9b9254$var$TITLE_LINE_H) / 2, $6d8fdbf74f9b9254$var$SPARK_R);
        sparkG.endFill();
        const body = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($6d8fdbf74f9b9254$var$BODY_COLOR).role("label").strokeThickness(0).wordWrap($6d8fdbf74f9b9254$var$TEXT_W).render(prompt.body || "");
        body.x = $6d8fdbf74f9b9254$var$TEXT_X;
        body.y = title.y + titleH + $6d8fdbf74f9b9254$var$OVERLINE_BODY_GAP;
        this.textLayer.addChild(body);
        // Grow the panel around the copy, then hang the button row off the BOTTOM of it. However
        // long the server's wording turns out to be, the buttons end up below it, never over it.
        const textBottom = body.y + Math.max(body.height, $6d8fdbf74f9b9254$var$BODY_LINE_H);
        this.panelH = Math.ceil(textBottom + $6d8fdbf74f9b9254$var$BODY_BUTTONS_GAP + $6d8fdbf74f9b9254$var$BUTTON_H + $6d8fdbf74f9b9254$var$PAD_BOTTOM);
        const buttonsY = this.buttonsTop();
        // Built answer-first, whatever order they sit in on screen: the button layer's first child
        // is the answer, as it always has been.
        this.acceptChoice = prompt.acceptCommand || "accept";
        this.acceptWidth = prompt.acceptCommand === "continue_story" ? 144 : $6d8fdbf74f9b9254$var$ACCEPT_W;
        this.accept = this.makeButton(prompt.acceptLabel || "Show me", $6d8fdbf74f9b9254$var$PANEL_W - $6d8fdbf74f9b9254$var$PAD_X - this.acceptWidth, buttonsY, this.acceptWidth, this.acceptChoice);
        if (!prompt.hideSkip) this.skip = this.makeButton(prompt.skipLabel || "Skip", $6d8fdbf74f9b9254$var$SKIP_X, buttonsY, $6d8fdbf74f9b9254$var$SKIP_W, "skip");
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, $6d8fdbf74f9b9254$var$PANEL_W, this.panelH);
        this.drawBackground();
        this.totalMs = prompt.acceptCommand === "continue_story" ? 0 : Math.max(0, prompt.timeoutMs || 0);
        this.remainingMs = this.totalMs;
        this.progressWidth = -1;
        this.drawProgress();
    }
    // Where the button row currently sits, in the bar's own coordinates. Exposed so a test can assert
    // the thing that broke here: that the copy never reaches it.
    buttonsTop() {
        return this.panelH - $6d8fdbf74f9b9254$var$PAD_BOTTOM - $6d8fdbf74f9b9254$var$BUTTON_H;
    }
    // The bottom of the last line of copy, in the same coordinates.
    textBottom() {
        let bottom = 0;
        this.textLayer.children.forEach((child)=>{
            if (child instanceof (0, $gwPoJ.Graphics)) return;
            bottom = Math.max(bottom, child.y + Math.max(child.height, $6d8fdbf74f9b9254$var$BODY_LINE_H));
        });
        return bottom;
    }
    // The inner face's edges, for a test to hold the copy and the buttons inside the frame.
    innerRect() {
        return new (0, $6qzqq.Rectangle)((0, $658a44ce960354bb$export$176f92955cca26b1), (0, $658a44ce960354bb$export$176f92955cca26b1), $6d8fdbf74f9b9254$var$PANEL_W - (0, $658a44ce960354bb$export$176f92955cca26b1) * 2, this.panelH - (0, $658a44ce960354bb$export$176f92955cca26b1) * 2);
    }
    // Called every frame by GuiManager; deltaTime is in milliseconds (same contract as
    // CountdownTimer.update). Moves the bar in and out, and drains the countdown while it is open.
    // A prompt with timeoutMs 0 never expires on its own. Returns at once while the bar is away.
    update(deltaTime) {
        if (this.motion === "hidden") return;
        const dt = Math.max(0, deltaTime || 0);
        this.animate(dt);
        if (!this.opened || this.totalMs <= 0) return;
        this.remainingMs = Math.max(0, this.remainingMs - dt);
        this.drawProgress();
        if (this.remainingMs <= 0) this.choose("accept", "timeout");
    }
    animate(dt) {
        if (this.motion === "entering") {
            this.motionMs += dt;
            const t = $6d8fdbf74f9b9254$var$easeOutCubic($6d8fdbf74f9b9254$var$clamp01(this.motionMs / $6d8fdbf74f9b9254$var$ENTER_MS));
            this.alpha = t;
            // Written so it lands on +0: pixi's ObservablePoint ignores 0 over -0.
            this.pivot.y = $6d8fdbf74f9b9254$var$ENTER_RISE * (t - 1);
            if (this.motionMs >= $6d8fdbf74f9b9254$var$ENTER_MS) {
                this.motion = "shown";
                this.alpha = 1;
            }
        } else if (this.motion === "leaving") {
            this.motionMs += dt;
            const t = $6d8fdbf74f9b9254$var$clamp01(this.motionMs / $6d8fdbf74f9b9254$var$LEAVE_MS);
            this.alpha = 1 - t;
            this.pivot.y = 0 - $6d8fdbf74f9b9254$var$LEAVE_DROP * $6d8fdbf74f9b9254$var$easeOutCubic(t);
            if (this.motionMs >= $6d8fdbf74f9b9254$var$LEAVE_MS) {
                this.motion = "hidden";
                this.visible = false;
                this.alpha = 1;
                this.pivot.y = 0;
            }
        }
    }
    remaining() {
        return this.remainingMs;
    }
    isOpen() {
        return this.opened;
    }
    // Reveal, picking up from wherever an interrupted dismiss had got to.
    fadeIn() {
        this.opened = true;
        if (this.motion === "entering" || this.motion === "shown") return;
        const from = this.motion === "leaving" ? this.alpha : 0;
        this.visible = true;
        this.alpha = from;
        this.motion = "entering";
        // Start the arrival at the point on its curve the bar is already showing.
        this.motionMs = $6d8fdbf74f9b9254$var$ENTER_MS * (1 - Math.cbrt(1 - from));
        this.animate(0);
    }
    // Dismiss: fade out and hide once transparent.
    fadeOut() {
        this.opened = false;
        this.clearHover();
        if (this.motion === "hidden" || this.motion === "leaving") return;
        // Leave from the alpha the bar has reached, so cutting short an arrival does not flash.
        this.motionMs = $6d8fdbf74f9b9254$var$LEAVE_MS * (1 - this.alpha);
        this.motion = "leaving";
        this.animate(0);
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");



// The HUD dial that counts DOWN to something the player has to be ready for — in an ember camp, the
// next assault landing on the fire.
//
// It shares its chrome and its screen slot with the WAVE BADGE (wave_indicator.ts): this dial drains
// to zero and vanishes, and the badge grows into the same spot already full, so the HUD reads as one
// object changing state rather than two widgets taking turns. The shared parts live in dial.ts; what
// is this widget's own is the PALETTE (banked coals, flaring, white-hot) and the SECOND —
// every whole second the numeral punches in and a ring ripples off the dial, which is what makes a
// countdown feel like it is running rather than merely being displayed.
//
// The numeral carries its UNIT, and that is the whole of the bottom line. Without the unit the dial's
// biggest element was a bare number over the word "INCOMING", which reads as a headcount — eleven
// enemies on the way rather than eleven seconds — and a wave-defense HUD can afford that confusion
// least of all on the one object the player watches. With it, "WAVE 20" over "3s" says everything
// the caption used to, in two lines instead of three: "INCOMING" measured 68px wide against a ring
// whose inside is 85px across, so it cut through the gauge at every size that was worth reading.
//
// Everything animates off the frame delta handed to `update`, so the widget never owns a timer. The
// caller only has to stop calling it when it is no longer `visible`.
// Entrance and exit, in ms. The exit is quicker: by then the thing it was counting to has arrived
// and is what the player should be looking at.
const $d85ea5e2371a760e$var$APPEAR_MS = 190;
const $d85ea5e2371a760e$var$VANISH_MS = 240;
// How long a fresh numeral takes to settle back from its punch-in, and how much bigger it starts.
const $d85ea5e2371a760e$var$TICK_MS = 260;
const $d85ea5e2371a760e$var$TICK_SWELL = 0.3;
// The ring that ripples off the dial on each whole second, and how far past the dial's edge it gets.
// It starts OUTSIDE the rim and leaves immediately: a ring sitting ON the dial reads as the gauge,
// which at one second left said "full" at the exact moment the gauge said "empty".
const $d85ea5e2371a760e$var$RIPPLE_MS = 420;
const $d85ea5e2371a760e$var$RIPPLE_REACH = 15;
// Inside this many seconds the dial is urgent: the glow breathes, the face heats from within and
// the ripples read as an alarm rather than a tick.
const $d85ea5e2371a760e$var$URGENT_SECONDS = 5;
const $d85ea5e2371a760e$export$976b5f32ad8c61c7 = 0xc2703a;
const $d85ea5e2371a760e$export$5ead290fc957823a = 0xff9d2e;
const $d85ea5e2371a760e$export$b7a0ce2acae6c9d9 = 0xffe9a8;
// What the face itself heats to under the numerals, as the ring goes white.
const $d85ea5e2371a760e$var$FORGE_COLOR = 0xd6391f;
// The unit's colour: the same warm cream the badge captions itself in.
const $d85ea5e2371a760e$var$CAPTION_COLOR = 0xffc89a;
// The unit riding on the numeral's right. Big enough to read at a glance, small and quiet enough
// that it can never be mistaken for a second digit.
const $d85ea5e2371a760e$var$UNIT_TEXT = "s";
const $d85ea5e2371a760e$var$UNIT_SIZE = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).compactBody.fontSize;
const $d85ea5e2371a760e$var$UNIT_ALPHA = 0.82;
const $d85ea5e2371a760e$var$UNIT_GAP = 2;
const $d85ea5e2371a760e$export$7a9488d1a06c32ad = (progress)=>{
    if (progress > 0.5) return (0, $7f40928dcf527a2e$export$5931e35698b46017)($d85ea5e2371a760e$export$5ead290fc957823a, $d85ea5e2371a760e$export$976b5f32ad8c61c7, (progress - 0.5) / 0.5);
    return (0, $7f40928dcf527a2e$export$5931e35698b46017)($d85ea5e2371a760e$export$b7a0ce2acae6c9d9, $d85ea5e2371a760e$export$5ead290fc957823a, Math.max(0, progress) / 0.5);
};
class $d85ea5e2371a760e$export$5a0af15366b01c51 extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), this.currentTime = 0, this.totalTime = 0, this.isRunning = false, // What the numeral currently reads, so a second that hasn't flipped costs no re-rasterization.
        this.lastDisplayTime = -1, // The wave this is counting down to, when the camp told us. Zero means a bare timer: no wave
        // label, and no "INCOMING" either, because then there is no assault for it to be about.
        this.wave = 0, this.expedition = false, // Whether the dial wants to be on screen, and how far the entrance/exit has got (0..1).
        this.wanted = false, this.appear = 0, // Age of the current numeral, in ms. Drives its punch-in and the ripple behind it.
        this.tickAge = $d85ea5e2371a760e$var$TICK_MS, // Free-running clock for the urgent breathing, so it doesn't stall when the arc does.
        this.pulseTs = 0;
        this.metrics = {
            radius: props.radius || 50,
            strokeWidth: props.strokeWidth || 8
        };
        // Kept for callers that still pass one, but the ember dials share a face now: an override
        // would be the one thing that breaks the hand-over to the wave badge.
        this.backgroundColor = props.backgroundColor;
        this.textColor = props.textColor || 0xffffff;
        this.onComplete = props.onComplete;
        this.face = new (0, $gwPoJ.Graphics)();
        this.fx = new (0, $gwPoJ.Graphics)();
        this.gauge = new (0, $gwPoJ.Graphics)();
        this.valueGroup = new (0, $8t5Gy.Container)();
        this.textDisplay = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(this.textColor).role("heading").bold().align("center").render("0");
        this.textDisplay.anchor.set(0.5);
        this.unitText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($d85ea5e2371a760e$var$CAPTION_COLOR).fontSize($d85ea5e2371a760e$var$UNIT_SIZE).bold().align("center").render($d85ea5e2371a760e$var$UNIT_TEXT);
        // Anchored on its LEFT edge and vertically centred, so it hangs off the numeral's right no
        // matter how many digits the numeral has.
        this.unitText.anchor.set(0, 0.5);
        this.unitText.alpha = $d85ea5e2371a760e$var$UNIT_ALPHA;
        this.valueGroup.addChild(this.textDisplay, this.unitText);
        this.label = new (0, $7f40928dcf527a2e$export$9e7f97e6c8f262fa)();
        // The ripple goes BEHIND the gauge so an alarm ring never washes out the arc it came from.
        this.addChild(this.face, this.fx, this.gauge, this.label, this.valueGroup);
        this.drawFace();
        this.layoutText();
        this.visible = false;
        this.alpha = 0;
    }
    // ---------------------------------------------------------------- geometry
    /** Outer painted size of the dial itself — what a caller should position against. */ get dialSize() {
        return (0, $7f40928dcf527a2e$export$e701ba9b0e6c1246)(this.metrics);
    }
    /** How far below the dial's CENTRE the widget paints. */ get bottomExtent() {
        return (0, $7f40928dcf527a2e$export$4e9219c5ee032693)(this.metrics);
    }
    // ---------------------------------------------------------------- control
    /**
     * Start counting down.
     *
     * `wave` is the assault this is counting to, when the camp knows it: it heads the dial with the
     * same line the wave badge will be wearing a moment later, in the same place, so the hand-over
     * leaves it untouched. Omit it for a bare timer.
     */ start(totalSeconds, wave = 0, expedition = false) {
        this.expedition = expedition;
        this.totalTime = totalSeconds;
        this.currentTime = totalSeconds;
        this.isRunning = true;
        this.wave = wave > 0 ? Math.floor(wave) : 0;
        this.lastDisplayTime = -1;
        // The entrance carries the first numeral in; punching it as well reads as a stutter.
        this.tickAge = $d85ea5e2371a760e$var$TICK_MS;
        this.wanted = true;
        this.appear = 0;
        this.visible = true;
        this.alpha = 0;
        this.redraw();
    }
    reset() {
        this.currentTime = this.totalTime;
        this.isRunning = false;
        this.lastDisplayTime = -1;
        this.tickAge = $d85ea5e2371a760e$var$TICK_MS;
        this.wanted = true;
        this.appear = 1;
        this.alpha = 1;
        this.visible = true;
        this.scale.set(1);
        this.redraw();
    }
    /** Halt without finishing. The dial fades out; a caller that hides it outright also may. */ stop() {
        this.isRunning = false;
        this.wanted = false;
    }
    getCurrentTime() {
        return this.currentTime;
    }
    getTotalTime() {
        return this.totalTime;
    }
    isActive() {
        return this.isRunning;
    }
    /** Test/inspection seam: how far the entrance (or exit) has got, 0..1. */ appearance() {
        return this.appear;
    }
    // ---------------------------------------------------------------- frame
    /**
     * Advance one frame. `deltaTime` is in milliseconds.
     *
     * Always does its animation work, even once the count has reached zero: the exit is part of the
     * countdown, and a widget that stopped moving the instant it hit zero would be yanked away at
     * the one moment the player is watching it.
     */ update(deltaTime) {
        if (this.isRunning) {
            this.currentTime -= deltaTime / 1000;
            if (this.currentTime <= 0) {
                this.currentTime = 0;
                this.isRunning = false;
                this.onComplete?.();
                // Zero is reached, so the dial has said everything it has to say.
                this.wanted = false;
            }
        }
        const target = this.wanted ? 1 : 0;
        if (this.appear !== target) {
            const step = deltaTime / (this.wanted ? $d85ea5e2371a760e$var$APPEAR_MS : $d85ea5e2371a760e$var$VANISH_MS);
            this.appear = target > this.appear ? Math.min(1, this.appear + step) : Math.max(0, this.appear - step);
        }
        this.tickAge += deltaTime;
        this.pulseTs += deltaTime;
        if (!this.wanted && this.appear <= 0) {
            this.visible = false;
            this.alpha = 0;
            return;
        }
        this.redraw();
    }
    // ---------------------------------------------------------------- drawing
    redraw() {
        const eased = (0, $7f40928dcf527a2e$export$1157fb72e7fbceb5)(this.appear);
        this.alpha = eased;
        // Grows into place and shrinks away rather than popping — the wave badge that replaces it
        // arrives the same way, from the same spot.
        this.scale.set(0.84 + 0.16 * eased);
        const displayTime = Math.ceil(this.currentTime);
        if (displayTime !== this.lastDisplayTime) {
            this.lastDisplayTime = displayTime;
            this.textDisplay.text = String(Math.max(0, displayTime));
            this.tickAge = 0;
            // 9 -> 10 is a wider numeral, so the unit beside it has to move with it.
            this.layoutValue();
        }
        const progress = this.totalTime > 0 ? Math.max(0, Math.min(1, this.currentTime / this.totalTime)) : 0;
        const color = $d85ea5e2371a760e$export$7a9488d1a06c32ad(progress);
        const urgency = this.urgency();
        // A fresh numeral punches in and settles back. `tickAge` is wall-clock, not the fraction of
        // the remaining second, so the swell lasts the same 260ms whatever the frame rate — and it
        // happens when the number CHANGES, which is the thing the player is reacting to.
        const tick = 1 - (0, $7f40928dcf527a2e$export$1157fb72e7fbceb5)(Math.min(1, this.tickAge / $d85ea5e2371a760e$var$TICK_MS));
        // The whole value — numeral and unit — swells about the numeral's own centre, which is the
        // group's origin. Scaling the numeral alone would have it grow INTO the unit and back out.
        this.valueGroup.scale.set(1 + $d85ea5e2371a760e$var$TICK_SWELL * tick);
        // Warm the numeral toward the ring colour as time drains: crisp white while there is plenty,
        // reddening for urgency near zero. A tint is a cheap multiply over white text, so it never
        // re-rasterizes the glyphs — but it can only ever DARKEN, so the mix is capped well short of
        // the ring's own colour. Taking it the whole way left the last few seconds, the ones that
        // actually have to be read, as dim red numerals on a dark red face.
        this.textDisplay.tint = (0, $7f40928dcf527a2e$export$5931e35698b46017)(0xffffff, color, Math.min(0.5, Math.pow(1 - progress, 1.6)));
        this.drawRipple(color, urgency);
        this.drawHeat(urgency);
        this.drawGauge(progress, color, urgency);
        this.layoutLabel();
    }
    urgency() {
        if (!(this.totalTime > 0) || this.currentTime <= 0) return 0;
        const window = Math.min($d85ea5e2371a760e$var$URGENT_SECONDS, this.totalTime);
        return Math.max(0, Math.min(1, (window - this.currentTime) / window));
    }
    drawFace() {
        (0, $7f40928dcf527a2e$export$a990dcceb7594917)(this.face, {
            ...this.metrics,
            faceColor: this.backgroundColor
        });
    }
    // One expanding ring per second. Cheap (a single stroked circle) and it is what carries the
    // tick: the dial visibly emits something every time the number changes.
    drawRipple(color, urgency) {
        this.fx.clear();
        const age = this.tickAge / $d85ea5e2371a760e$var$RIPPLE_MS;
        if (age >= 1 || this.currentTime <= 0) return;
        const grow = (0, $7f40928dcf527a2e$export$1157fb72e7fbceb5)(age);
        const radius = (0, $7f40928dcf527a2e$export$52c805a13553b1ac)(this.metrics) + 1 + $d85ea5e2371a760e$var$RIPPLE_REACH * grow;
        this.fx.lineStyle({
            width: 2 + urgency,
            color: color,
            alpha: (0.26 + 0.2 * urgency) * Math.pow(1 - grow, 1.5)
        });
        this.fx.drawCircle(0, 0, radius);
    }
    // The face heats from within over the final seconds, breathing with the glow — a forge coming
    // up, not a warning lamp switching on. Drawn over the face rather than into it so the face
    // itself stays a one-off draw.
    drawHeat(urgency) {
        if (urgency <= 0) return;
        const breath = 0.5 + 0.5 * Math.sin(this.pulseTs / 170);
        (0, $7f40928dcf527a2e$export$e33ec2b352c86d34)(this.fx, this.metrics, $d85ea5e2371a760e$var$FORGE_COLOR, urgency * (0.78 + 0.22 * breath));
    }
    drawGauge(progress, color, urgency) {
        if (this.currentTime <= 0) {
            this.gauge.clear();
            return;
        }
        const breath = urgency > 0 ? 0.5 + 0.5 * Math.sin(this.pulseTs / 170) : 0;
        (0, $7f40928dcf527a2e$export$fabd2fd7d3821067)(this.gauge, {
            ...this.metrics,
            progress: progress,
            color: color,
            haloWidth: 5 + 10 * urgency * (0.55 + 0.45 * breath),
            haloAlpha: 0.22 + 0.4 * urgency * (0.6 + 0.4 * breath)
        });
    }
    // Which wave, then the number — on the lines dial.ts fixes, because the wave badge stacks itself
    // on the same ones (it adds a third, "LEFT", which is short enough to fit where "INCOMING" was
    // not). DialLabel parks itself on the top line, so only the value is set here.
    layoutText() {
        this.valueGroup.y = (0, $7f40928dcf527a2e$export$b4e42a1196873f1f);
        this.layoutValue();
        this.layoutLabel();
    }
    // Park the unit off the numeral's right and shift the pair left by half of what it added, so
    // what the eye centres on is the whole value rather than the digits alone. Measured unscaled:
    // the swell lives on the group, so the numeral's own scale is always 1.
    layoutValue() {
        const advance = this.unitText.width + $d85ea5e2371a760e$var$UNIT_GAP;
        this.unitText.x = this.textDisplay.width / 2 + $d85ea5e2371a760e$var$UNIT_GAP;
        this.valueGroup.x = -advance / 2;
    }
    layoutLabel() {
        // A bare timer (`/timer`) has no wave to name: it is just a clock, so it shows its number.
        this.label.setWave(this.wave, this.expedition ? "NEXT" : "WAVE");
    }
}
const $d85ea5e2371a760e$export$33ad350a1dd66426 = (metrics)=>(0, $7f40928dcf527a2e$export$8b93a1472cb1b33)(metrics);


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");



// The HUD badge shown while an ember camp is under assault: which wave is being fought and how many
// of its enemies are still to be put down.
//
// It deliberately takes the pre-wave COUNTDOWN DIAL's slot and its shape — same radius, same stroke,
// same dark face and groove. The countdown drains to zero, disappears, and this dial takes its place
// already full, so the HUD reads as one object handing over: "time until the wave" becomes "what's
// left of the wave". The palettes are what separate them, and they run opposite ways: the countdown
// HEATS as safety runs out, this one COOLS from hostile red to ember gold as the threat does.
//
// The gauge is `remaining / total`, where remaining counts enemies not yet released by the spawners
// as well as the ones on the field — so it only ever falls (see ember-wave-manager.js, which owns
// those numbers). A head count would climb while the player fought, which reads backwards.
// Gauge ramp: a full ring is hostile blood-red, a nearly-cleared one is the camp's own ember gold
// (build_board GOLD). It runs the opposite way to the countdown's, which heats UP as time runs out:
// this one cools as the threat does.
const $3220884133cc6599$var$THREAT_COLOR = 0xd63a2a;
const $3220884133cc6599$var$CLEARING_COLOR = 0xffd166;
const $3220884133cc6599$var$COUNT_COLOR = 0xffffff;
const $3220884133cc6599$var$CAPTION_COLOR = 0xffc89a;
const $3220884133cc6599$var$COUNT_SIZE = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).heading.fontSize;
const $3220884133cc6599$var$CAPTION_SIZE = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).compactCaption.fontSize;
const $3220884133cc6599$var$CAPTION_SPACING = 1.6;
const $3220884133cc6599$var$APPEAR_MS = 220;
const $3220884133cc6599$var$FLASH_MS = 320;
// Below this many enemies the ring breathes — the last of a wave is the part worth watching.
const $3220884133cc6599$var$FINAL_STRETCH = 3;
const $3220884133cc6599$export$c556ea7803c4be93 = (remaining, total)=>{
    if (!(total > 0)) return remaining > 0 ? 1 : 0;
    return Math.max(0, Math.min(1, remaining / total));
};
const $3220884133cc6599$export$5ba3d6ef6c5cead = (progress)=>(0, $7f40928dcf527a2e$export$5931e35698b46017)($3220884133cc6599$var$CLEARING_COLOR, $3220884133cc6599$var$THREAT_COLOR, progress);
const $3220884133cc6599$var$easeOut = (t)=>1 - Math.pow(1 - t, 3);
class $3220884133cc6599$export$20faccd1109d9248 extends (0, $8t5Gy.Container) {
    constructor(props = {}){
        super(), // What's being displayed. Null until the first wave status arrives.
        this.status = null, // Whether the badge wants to be on screen; `appear` is how far the entrance/exit has got (0..1).
        this.wanted = false, this.appear = 0, // Kill feedback: driven to 1 when `remaining` drops, decays back to 0.
        this.flash = 0, // Free-running clock for the final-stretch breathing.
        this.pulseTs = 0, this.needsDraw = true;
        this.metrics = {
            radius: props.radius || 50,
            strokeWidth: props.strokeWidth || 7.5
        };
        this.face = new (0, $gwPoJ.Graphics)();
        this.gauge = new (0, $gwPoJ.Graphics)();
        this.countText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($3220884133cc6599$var$COUNT_COLOR).fontSize($3220884133cc6599$var$COUNT_SIZE).bold().align("center").render("0");
        this.countText.anchor.set(0.5);
        this.captionText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color($3220884133cc6599$var$CAPTION_COLOR).fontSize($3220884133cc6599$var$CAPTION_SIZE).bold().align("center").render("LEFT");
        this.captionText.anchor.set(0.5);
        this.captionText.style.letterSpacing = $3220884133cc6599$var$CAPTION_SPACING;
        this.captionText.alpha = 0.75;
        this.label = new (0, $7f40928dcf527a2e$export$9e7f97e6c8f262fa)();
        this.addChild(this.face);
        this.addChild(this.gauge);
        this.addChild(this.label);
        this.addChild(this.countText);
        this.addChild(this.captionText);
        this.drawFace();
        this.layoutText();
        this.visible = false;
        this.alpha = 0;
    }
    // Outer painted size of the dial — what a caller positions against.
    get dialSize() {
        return (0, $7f40928dcf527a2e$export$e701ba9b0e6c1246)(this.metrics);
    }
    // How far below the dial's CENTRE the badge actually paints. Lets a caller keep the whole thing
    // on screen without reaching into the layout.
    get bottomExtent() {
        return (0, $7f40928dcf527a2e$export$4e9219c5ee032693)(this.metrics);
    }
    // New wave state from the server, or null / wave 0 to take the badge down.
    update(status) {
        const live = status && status.wave > 0 ? status : null;
        if (!live) {
            if (this.wanted) this.wanted = false;
            return;
        }
        const previous = this.status;
        // A drop in the count is a kill (or several): flash the number so the player sees it land.
        // A new wave is not a drop, however much the number falls between waves.
        if (previous && previous.wave === live.wave && live.remaining < previous.remaining) this.flash = 1;
        this.status = live;
        this.wanted = true;
        this.needsDraw = true;
    }
    // Per-frame tick. Only redraws when something is actually moving, so a long wave doesn't repaint
    // a static dial 60 times a second.
    animate(deltaMs) {
        const target = this.wanted ? 1 : 0;
        if (this.appear !== target) {
            const step = deltaMs / $3220884133cc6599$var$APPEAR_MS;
            this.appear = target > this.appear ? Math.min(1, this.appear + step) : Math.max(0, this.appear - step);
            this.needsDraw = true;
        }
        if (this.flash > 0) {
            this.flash = Math.max(0, this.flash - deltaMs / $3220884133cc6599$var$FLASH_MS);
            this.needsDraw = true;
        }
        if (this.isBreathing()) {
            this.pulseTs += deltaMs;
            this.needsDraw = true;
        }
        if (!this.needsDraw) return;
        this.needsDraw = false;
        this.redraw();
    }
    // Whether the badge is on screen at all (mid-fade counts).
    isShowing() {
        return this.visible;
    }
    // Test/inspection seam: how strong the kill flash is right now (1 the frame a kill lands, 0 once
    // it has decayed).
    flashStrength() {
        return this.flash;
    }
    isBreathing() {
        return this.wanted && !!this.status && this.status.remaining > 0 && this.status.remaining <= $3220884133cc6599$var$FINAL_STRETCH;
    }
    redraw() {
        this.visible = this.appear > 0;
        if (!this.visible || !this.status) {
            this.alpha = 0;
            return;
        }
        const eased = $3220884133cc6599$var$easeOut(this.appear);
        this.alpha = eased;
        // Grows into place rather than popping — the countdown dial it replaces has just vanished
        // from the same spot.
        this.scale.set(0.82 + 0.18 * eased);
        const { remaining: remaining, total: total, wave: wave } = this.status;
        if (this.countText.text !== String(remaining)) this.countText.text = String(remaining);
        this.label.setWave(wave);
        // The number swells on a kill and settles back.
        this.countText.scale.set(1 + 0.28 * this.flash);
        this.drawGauge($3220884133cc6599$export$c556ea7803c4be93(remaining, total));
    }
    drawFace() {
        // The countdown dial's face, down to the pixel (see dial.ts). There is no "but" any more:
        // the clock hour marks that used to separate them are gone from both.
        (0, $7f40928dcf527a2e$export$a990dcceb7594917)(this.face, {
            ...this.metrics
        });
    }
    // Which wave, the number, what the number means — on the lines dial.ts fixes, which is what
    // keeps the top line from so much as twitching when the countdown dial hands this one its slot.
    layoutText() {
        this.countText.y = (0, $7f40928dcf527a2e$export$b4e42a1196873f1f);
        this.captionText.y = (0, $7f40928dcf527a2e$export$82a9eb428c63b9df);
    }
    drawGauge(progress) {
        if (progress <= 0) {
            this.gauge.clear();
            return;
        }
        const color = $3220884133cc6599$export$5ba3d6ef6c5cead(progress);
        // The last of a wave breathes; a kill washes the arc toward white for a moment.
        const breath = this.isBreathing() ? 0.5 + 0.5 * Math.sin(this.pulseTs / 190) : 0;
        (0, $7f40928dcf527a2e$export$fabd2fd7d3821067)(this.gauge, {
            ...this.metrics,
            progress: progress,
            color: color,
            arcColor: this.flash > 0 ? (0, $7f40928dcf527a2e$export$5931e35698b46017)(color, 0xffffff, this.flash * 0.55) : color,
            haloWidth: 5 + 4 * breath,
            haloAlpha: 0.18 + 0.22 * breath + 0.3 * this.flash
        });
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

class $617042715e0a010b$export$5696eab43b4d4c5a extends (0, $gwPoJ.Graphics) {
    constructor(gui){
        super(), this.setup = (angle)=>{
            //
            // this.surface.removeChildren()
            // let angle = 0
            // setInterval(() => {
            //     angle++
            //     if (angle > 360) {
            //         angle = 0
            //     }
            this.surface.angle = angle;
            // sun.angle -= angle
            const x = Math.sin(Math.PI * 180 / 360);
            const y = Math.cos(Math.PI * 180 / 360);
            this.surface.x = x;
            this.surface.y = y;
            this.sun.angle = -this.surface.angle;
            this.moon.angle = -this.surface.angle;
        // }, 25)
        };
        this.gui = gui;
        this.surface = new (0, $gwPoJ.Graphics)();
        this.addChild(this.surface);
        this.scale.set(0.44);
        const mask = new (0, $gwPoJ.Graphics)();
        mask.beginFill(0x000000, 1.0);
        mask.drawRect(-40, -40, 80, 39);
        mask.endFill();
        this.addChild(mask);
        this.surface.mask = mask;
        const sun = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
            color: 0xffffff,
            scale: 1.0,
            name: "sun-icon.png"
        });
        const moon = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
            color: 0xffffff,
            scale: 1.0,
            name: "moon-icon.png"
        });
        this.surface.addChild(sun);
        sun.x = -25;
        moon.x = 25;
        this.surface.addChild(moon);
        this.beginFill(0x00ff00, 1);
        this.drawRect(-40, -1, 80, 2);
        this.endFill();
        this.sun = sun;
        this.moon = moon;
    }
}


parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $gwPoJ = parcelRequire("gwPoJ");



parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
const $7dcf9acc2579c643$export$4a423b5b028a4cfb = (width, height, centerAlpha)=>{
    try {
        const canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round(width));
        canvas.height = Math.max(1, Math.round(height));
        const ctx = canvas.getContext("2d");
        if (!ctx) return (0, $klOfb.Texture).WHITE;
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
        gradient.addColorStop(0.0, "rgba(0,0,0,0)");
        gradient.addColorStop(0.18, `rgba(0,0,0,${centerAlpha})`);
        gradient.addColorStop(0.82, `rgba(0,0,0,${centerAlpha})`);
        gradient.addColorStop(1.0, "rgba(0,0,0,0)");
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        return (0, $klOfb.Texture).from(canvas);
    } catch (e) {
        return (0, $klOfb.Texture).WHITE;
    }
};


// The "hero" banner: a big center-screen announcement. Same calm ambient look as the
// "important" strip — a full-width translucent band whose left/right edges fade to nothing,
// gently faded in and out — but with the giant text and centered placement that make it a
// "hero" moment rather than a routine notice.
const $4a3ce4bbe28116a7$var$VERTICAL_PADDING = 30 // space above/below the text inside the strip
;
const $4a3ce4bbe28116a7$var$STRIP_ALPHA = 0.4 // center opacity of the strip; kept airy so the giant text carries it
;
const $4a3ce4bbe28116a7$var$VERTICAL_OFFSET = 55 // nudge down to sit visually centered given the surrounding UI
;
class $4a3ce4bbe28116a7$export$75ee3f18f40024cd extends (0, $gwPoJ.Graphics) {
    constructor(){
        super(), this.background = null, this.fadeInFader = null, this.fadeOutFader = null, this.displayCallback = null, // The strip spans the full (fixed) viewport width, so the gradient texture is built once.
        this.gradientTexture = null, this.show = (message)=>{
            const { text: text, displayCallback: displayCallback, duration: duration = 1500 } = message;
            this.displayCallback = displayCallback || null;
            // Clear any existing animation
            if (this.fadeInFader) {
                this.fadeInFader.stop(true);
                this.fadeInFader = null;
            }
            if (this.fadeOutFader) {
                this.fadeOutFader.stop(true);
                this.fadeOutFader = null;
            }
            // Clear previous content
            this.removeChildren();
            // Use the actual game screen dimensions (the visible viewport is wider than the 640 play area).
            const gameScreenWidth = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7;
            const gameScreenHeight = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h;
            // The giant hero text (retained size)
            this.heroText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().variant("GiganticFont").color(0xffffff).align("center").render(text);
            this.heroText.anchor.set(0, 0);
            this.heroText.x = gameScreenWidth / 2 - this.heroText.width / 2;
            this.heroText.y = gameScreenHeight / 2 - this.heroText.height / 2 + $4a3ce4bbe28116a7$var$VERTICAL_OFFSET;
            // Full-width gradient strip, vertically centered on the hero text.
            const stripHeight = this.heroText.height + $4a3ce4bbe28116a7$var$VERTICAL_PADDING * 2;
            const stripTop = this.heroText.y - $4a3ce4bbe28116a7$var$VERTICAL_PADDING;
            if (!this.gradientTexture) this.gradientTexture = (0, $7dcf9acc2579c643$export$4a423b5b028a4cfb)(gameScreenWidth, stripHeight, $4a3ce4bbe28116a7$var$STRIP_ALPHA);
            const background = new (0, $7Bs2Z.Sprite)(this.gradientTexture);
            background.x = 0;
            background.y = stripTop;
            background.width = gameScreenWidth;
            background.height = stripHeight;
            if (this.gradientTexture === (0, $klOfb.Texture).WHITE) {
                // Fallback (no 2D canvas): tint + alpha the flat texture so it still reads as a dark strip.
                background.tint = 0x000000;
                background.alpha = $4a3ce4bbe28116a7$var$STRIP_ALPHA;
            }
            this.background = background;
            // Background first so the text sits on top of it.
            this.addChild(background);
            this.addChild(this.heroText);
            this.visible = true;
            this.alpha = 0.0 // start transparent, fade in
            ;
            // Fade in -> hold -> fade out. No pop, no shrink.
            const displayDuration = duration || 2000;
            const fadeInDuration = 250 // 250ms fade in time
            ;
            const fadeOutDuration = 500 // 500ms fade out time
            ;
            const displayTime = displayDuration - fadeInDuration - fadeOutDuration;
            this.fadeInFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                direction: "in",
                minAlpha: 1.0,
                fadeInterval: 5,
                fadeAlphaDecrement: 0.02,
                releaseCallback: ()=>{
                    this.fadeInFader = null;
                    // Start the display timer after fade in completes
                    setTimeout(()=>{
                        this.startFadeOut();
                    }, Math.max(0, displayTime));
                }
            });
            this.fadeInFader.update();
        }, this.startFadeOut = ()=>{
            this.fadeOutFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                direction: "out",
                minAlpha: 0.0,
                fadeInterval: 20,
                fadeAlphaDecrement: 0.05,
                releaseCallback: ()=>{
                    this.fadeOutFader = null;
                    this.visible = false;
                    this.alpha = 1.0 // Reset opacity for next display
                    ;
                    this.removeChildren();
                    if (this.displayCallback) {
                        this.displayCallback();
                        this.displayCallback = null;
                    }
                }
            });
            this.fadeOutFader.update();
        }, this.destroy = ()=>{
            if (this.fadeInFader) {
                this.fadeInFader.stop(true);
                this.fadeInFader = null;
            }
            if (this.fadeOutFader) {
                this.fadeOutFader.stop(true);
                this.fadeOutFader = null;
            }
            this.removeChildren();
            this.visible = false;
            this.alpha = 1.0 // Reset opacity for next display
            ;
        };
        this.visible = false;
    }
}



const $9600e6b065d22e57$export$e47778fec1008d44 = 45000;
const $9600e6b065d22e57$export$e19271ea5abac88c = 22;
const $9600e6b065d22e57$export$e50a54bda5f8e083 = 5;
const $9600e6b065d22e57$export$62bf8a437abb6139 = 6;
const $9600e6b065d22e57$export$f0cf1164e72697ca = 8;
// The point stops this far short of the control, so it never stabs into the brackets.
const $9600e6b065d22e57$var$NOTCH_CLEARANCE = 6;
// Shorter than this and a notch is a nick in the rim, not a point: leave it off.
const $9600e6b065d22e57$var$NOTCH_MIN_LEN = 3;
// How far the tip may lean off square when the note had to be pushed along to stay on screen. Past
// about 45 degrees it stops reading as a point and starts reading as a tear in the board.
const $9600e6b065d22e57$var$NOTCH_MAX_LEAN = 8;
const $9600e6b065d22e57$export$cf3a52d3dbeb0881 = 4;
const $9600e6b065d22e57$export$14401afa5819d457 = 8;
const $9600e6b065d22e57$export$cbebaa48d952aec0 = {
    // The one clue that is not about the fire. The dial it points at is the whole reason the line
    // lands: a countdown is a DEADLINE, and a deadline is what makes speed something the player
    // wants, in a camp where nothing yet makes it something they need. Hence the second line -- it
    // names what the dial is for, rather than claiming the two skirmishers can outrun anybody.
    "ember-run": [
        "Hold SHIFT to run.",
        "Be back at the fire before this runs out."
    ],
    "ember-ready": [
        "Your axe is ready here.",
        "Anything on this bar can be held."
    ],
    "ember-wood": [
        "Ready this wood.",
        "Strike the campfire with it to light it."
    ],
    "ember-wood-items": [
        "Open your pack to ready your wood."
    ],
    "ember-wood-pack": [
        "Choose the wood for its actions."
    ],
    "ember-wood-use": [
        "Select Ready, then close your pack."
    ],
    "ember-items": [
        "Open your pack.",
        "The wood you cut is in there."
    ],
    "ember-planks-items": [
        "Open your pack and craft planks for the roof."
    ],
    "ember-crafting": [
        "Switch to crafting."
    ],
    "ember-planks-recipe": [
        "Craft planks from your wood.",
        "These are the materials for your shelter."
    ],
    "ember-wall-recipe": [
        "Craft wood walls from your planks."
    ],
    "ember-wall-pack": [
        "Choose a wall in your pack."
    ],
    "ember-wall-use": [
        "Select Ready, then close your pack.",
        "Place walls on three sides of the fire. Leave a way in."
    ],
    "ember-roof-recipe": [
        "Craft wood roof sections.",
        "Check the recipe for the materials you need."
    ],
    "ember-roof-pack": [
        "Choose a roof section in your pack."
    ],
    "ember-roof-use": [
        "Select Ready, then close your pack.",
        "Highlight at least a 2\xd72 square over the fire and wait for it to build."
    ],
    "ember-recipe": [
        "Craft a campfire out of the wood."
    ],
    "ember-pack": [
        "Here it is, in your pack."
    ],
    "ember-use": [
        "Select Ready."
    ],
    "ember-close": [
        "Close your pack.",
        "Then aim at the ground and click to place the fire."
    ]
};
const $9600e6b065d22e57$export$e9a54e30240a1d3d = [
    // "ember-ready" is deliberately NOT in this chain. It names the ready bar when the axe is handed
    // over, which is a beat of its own with nothing before or after it -- putting it in the order
    // would have the pack's clue retire it, which is not what taking the axe means. It ends on its own
    // timeout, or with the rest when the lesson is marked seen.
    //
    // Nor is "ember-run", for a stronger reason: it is raised a wave into the run, long after this
    // chain is done, and the only thing that retires it is the player actually running (see
    // Player's Shift handler, which calls satisfyClue).
    "ember-items",
    "ember-crafting",
    "ember-recipe",
    "ember-pack",
    "ember-use",
    "ember-close"
];
const $9600e6b065d22e57$export$478dbbcac4bfb39 = (tutorialType)=>tutorialType === "ember-planks-recipe" || tutorialType === "ember-wall-recipe" || tutorialType === "ember-roof-recipe" ? "ember-crafting" : tutorialType === "ember-wall-pack" ? "ember-wall-recipe" : tutorialType === "ember-wall-use" ? "ember-wall-pack" : tutorialType === "ember-roof-pack" ? "ember-roof-recipe" : tutorialType === "ember-roof-use" ? "ember-roof-pack" : tutorialType === "ember-wood-pack" ? "ember-wood-items" : tutorialType === "ember-wood-use" ? "ember-wood-pack" : tutorialType === "ember-wood" ? "ember-wood-use" : $9600e6b065d22e57$export$e9a54e30240a1d3d[$9600e6b065d22e57$export$e9a54e30240a1d3d.indexOf(tutorialType) - 1];
const $9600e6b065d22e57$export$9069b388aec1210a = (tutorialType, suppressed)=>{
    if (!tutorialType) return "clear";
    if ((0, $cb689cfa16c444ba$export$a35d0571df2da201)(tutorialType)) return "clue";
    return suppressed ? "suppressed" : "popup";
};
const $9600e6b065d22e57$export$e8a38504aad4fd94 = ({ anchorX: anchorX, anchorY: anchorY, anchorW: anchorW = 0, anchorH: anchorH, boxW: boxW, boxH: boxH, boxMinX: boxMinX = $9600e6b065d22e57$export$14401afa5819d457, boxMaxX: boxMaxX, placement: placement = "left" })=>{
    if (placement === "right") {
        // Out to the right of the control and level with it. `leader` is the horizontal run back to
        // it. Clamped on the FAR edge rather than the near one: the dial sits in a corner so there is
        // always room beside it, but a long line on a narrow screen can still overhang, and a box
        // pushed back left would land on the dial.
        const wanted = anchorX + anchorW + $9600e6b065d22e57$export$e19271ea5abac88c;
        const boxX = boxMaxX === undefined ? wanted : Math.min(wanted, Math.max(anchorX + anchorW, boxMaxX - boxW));
        const boxY = Math.max($9600e6b065d22e57$export$cf3a52d3dbeb0881, anchorY + anchorH / 2 - boxH / 2);
        return {
            boxX: boxX,
            boxY: boxY,
            leader: Math.max(0, boxX - (anchorX + anchorW))
        };
    }
    if (placement === "below") {
        const boxX = Math.max(boxMinX, anchorX + anchorW / 2 - boxW / 2);
        const boxY = Math.max($9600e6b065d22e57$export$cf3a52d3dbeb0881, anchorY + anchorH + $9600e6b065d22e57$export$e19271ea5abac88c);
        return {
            boxX: boxX,
            boxY: boxY,
            leader: Math.max(0, boxY - (anchorY + anchorH))
        };
    }
    if (placement === "above") {
        // Centred over the control and sitting on top of it. `leader` is the vertical drop back down
        // to it, and is 0 when the clamp left no clear gap to draw one in.
        const boxX = Math.max(boxMinX, anchorX + anchorW / 2 - boxW / 2);
        const boxY = Math.max($9600e6b065d22e57$export$cf3a52d3dbeb0881, anchorY - $9600e6b065d22e57$export$e19271ea5abac88c - boxH);
        return {
            boxX: boxX,
            boxY: boxY,
            leader: Math.max(0, anchorY - (boxY + boxH))
        };
    }
    const boxX = Math.max(boxMinX, anchorX - $9600e6b065d22e57$export$e19271ea5abac88c - boxW);
    const boxY = Math.max($9600e6b065d22e57$export$cf3a52d3dbeb0881, anchorY + anchorH / 2 - boxH / 2);
    return {
        boxX: boxX,
        boxY: boxY,
        leader: Math.max(0, anchorX - (boxX + boxW))
    };
};
const $9600e6b065d22e57$export$abccabccc7ee5588 = (edgeLength, along)=>{
    const min = $9600e6b065d22e57$export$e50a54bda5f8e083 + $9600e6b065d22e57$export$62bf8a437abb6139 + 1;
    const max = edgeLength - $9600e6b065d22e57$export$e50a54bda5f8e083 - $9600e6b065d22e57$export$62bf8a437abb6139 - 1;
    if (max < min) return edgeLength / 2;
    return Math.max(min, Math.min(max, along));
};
const $9600e6b065d22e57$export$eb9ecf2fc66f62b3 = ({ placement: placement, boxX: boxX, boxY: boxY, boxW: boxW, boxH: boxH, anchorX: anchorX, anchorY: anchorY, anchorW: anchorW, anchorH: anchorH })=>{
    // The control's centre, in the note's own coordinates.
    const cx = anchorX + anchorW / 2 - boxX;
    const cy = anchorY + anchorH / 2 - boxY;
    const reach = (gap)=>Math.min($9600e6b065d22e57$export$f0cf1164e72697ca, gap - $9600e6b065d22e57$var$NOTCH_CLEARANCE);
    const aim = (edgeLength, along)=>{
        const base = $9600e6b065d22e57$export$abccabccc7ee5588(edgeLength, along);
        return Math.max(base - $9600e6b065d22e57$var$NOTCH_MAX_LEAN, Math.min(base + $9600e6b065d22e57$var$NOTCH_MAX_LEAN, along));
    };
    const notch = (len, edge, tipX, tipY)=>len < $9600e6b065d22e57$var$NOTCH_MIN_LEN ? null : {
            edge: edge,
            tipX: tipX,
            tipY: tipY
        };
    if (placement === "above") {
        const len = reach(anchorY - (boxY + boxH));
        return notch(len, "bottom", aim(boxW, cx), boxH + len);
    }
    if (placement === "below") {
        const len = reach(boxY - (anchorY + anchorH));
        return notch(len, "top", aim(boxW, cx), -len);
    }
    if (placement === "right") {
        const len = reach(boxX - (anchorX + anchorW));
        return notch(len, "left", -len, aim(boxH, cy));
    }
    const len = reach(anchorX - (boxX + boxW));
    return notch(len, "right", boxW + len, aim(boxH, cy));
};
class $9600e6b065d22e57$export$5e29510581c9aca2 {
    constructor(props){
        // Armed, with each clue's expiry timer.
        this.armed = new Map();
        // Where each clue's control was last drawn.
        this.anchors = new Map();
        // What is currently on screen, and how to retract it.
        this.drawn = new Map();
        // The server says this clue's beat is live. Draws it now if its control is already on screen;
        // otherwise remembers it, so it appears the moment the control does.
        this.arm = (tutorialType, timeoutMs)=>{
            if (this.armed.has(tutorialType)) return;
            const hold = timeoutMs && timeoutMs > 0 ? timeoutMs : this.props.defaultTimeoutMs || $9600e6b065d22e57$export$e47778fec1008d44;
            this.armed.set(tutorialType, setTimeout(()=>this.disarm(tutorialType), hold));
            this.refresh(tutorialType);
        };
        // Whatever drew one of the clued controls says where it landed. Called again on every rebuild of
        // the panel it lives in, which is why this redraws rather than skipping: an inventory update
        // throws the whole content tree away, clue and all.
        this.registerAnchor = (tutorialType, anchor)=>{
            this.anchors.set(tutorialType, anchor);
            this.refresh(tutorialType);
        };
        // The control has gone (its panel closed, or this rebuild no longer draws it). The clue stays
        // ARMED -- reopening the panel puts it back -- but nothing is left pointing at nothing.
        this.clearAnchor = (tutorialType)=>{
            this.anchors.delete(tutorialType);
            this.retract(tutorialType);
        };
        // Every clue down and disarmed. Sent by the server the moment the tutorial counts as seen, and
        // done locally on a room change.
        this.clearAll = (preserveAnchors = false)=>{
            Array.from(this.armed.keys()).forEach((type)=>this.disarm(type));
            Array.from(this.drawn.keys()).forEach((type)=>this.retract(type));
            if (!preserveAnchors) this.anchors.clear();
        };
        // Taken down for good rather than merely undrawn: an expired clue, or one the player dismissed,
        // must not reappear on the next rebuild of the panel it pointed at.
        this.disarm = (tutorialType)=>{
            const timer = this.armed.get(tutorialType);
            if (timer !== undefined) clearTimeout(timer);
            this.armed.delete(tutorialType);
            this.retract(tutorialType, true);
        };
        this.isArmed = (tutorialType)=>this.armed.has(tutorialType);
        this.isShowing = (tutorialType)=>this.drawn.has(tutorialType);
        this.anyShowing = ()=>this.drawn.size > 0;
        this.retract = (tutorialType, fade = false)=>{
            const stop = this.drawn.get(tutorialType);
            this.drawn.delete(tutorialType);
            if (stop) stop(fade ? {
                fade: fade
            } : undefined);
        };
        this.refresh = (tutorialType)=>{
            if (!this.armed.has(tutorialType)) return;
            const anchor = this.anchors.get(tutorialType) || (this.props.builtInAnchor ? this.props.builtInAnchor(tutorialType) : undefined);
            if (anchor === undefined || anchor === null) return;
            // Replace whatever was drawn for this clue before (a rebuilt panel) rather than stacking.
            this.retract(tutorialType);
            const stop = this.props.draw(tutorialType, anchor);
            if (stop) this.drawn.set(tutorialType, stop);
        };
        this.props = props;
    }
}
const $9600e6b065d22e57$export$b131041a3ede9882 = [
    {
        itemType: "planks",
        recipe: "ember-planks-recipe"
    },
    {
        itemType: "wall-wood",
        recipe: "ember-wall-recipe",
        pack: "ember-wall-pack",
        use: "ember-wall-use"
    },
    {
        itemType: "roof-wood",
        recipe: "ember-roof-recipe",
        pack: "ember-roof-pack",
        use: "ember-roof-use"
    }
];





parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");
var $8t5Gy = parcelRequire("8t5Gy");






const $d634a66159f23623$export$db3e35bb56748094 = (sprite, x, y, size)=>{
    const b = sprite.getLocalBounds();
    // getLocalBounds() is measured in the sprite's OWN coordinate space, before its transform, so a
    // caller that normalised the art by setting `sprite.scale` (rather than by passing a scale into
    // the SpriteMeta, which scales an inner child instead) would otherwise be centred by the
    // unscaled box and land off by a factor. Every caller that scales via the meta has scale 1 here,
    // so this is a no-op for them.
    const sx = sprite.scale?.x ?? 1;
    const sy = sprite.scale?.y ?? 1;
    if (b.width > 0 && b.height > 0) {
        sprite.x = x + size / 2 - (b.x + b.width / 2) * sx;
        sprite.y = y + size / 2 - (b.y + b.height / 2) * sy;
    } else {
        sprite.x = x + size / 2;
        sprite.y = y + size / 2;
    }
};


// Geometry for the crafting panel. Like the chest/trade screen, the crafting screen shows the
// player's backpack underneath its own UI -- the materials every recipe draws from. Both halves live
// in ONE docked panel that has to stay inside the 442px-tall screen, so neither half can claim a
// fixed size: the backpack picks the largest slot size whose rows still fit in what is left, and the
// recipe list takes the rest as a window it SCROLLS inside.
//
// Pure math, no pixi -- see __tests__/crafting_layout.test.ts.
// Slot sizes the backpack grid will try, largest first. Each one implies its own column count,
// fitted to the panel's inner width (32 -> 8 cols, 28 -> 9, 24 -> 10 at a 4px gap in 284px).
const $a5a3df2f3994c840$export$a880d2a4436d893d = [
    32,
    28,
    24
];
const $a5a3df2f3994c840$export$b00cc381b2941ede = 4;
// Chests/players always show at least two rows on the trade screen; match that so a light backpack
// still reads as a grid rather than a lone strip of icons.
const $a5a3df2f3994c840$var$MIN_ROWS = 2;
// Rows the recipe list is asked to give up room for. A fuller backpack than this shrinks its own
// slots rather than squeezing the recipes further.
const $a5a3df2f3994c840$var$MAX_RESERVED_ROWS = 3;
const $a5a3df2f3994c840$export$b6095232b96cb2d5 = 4;
const $a5a3df2f3994c840$export$936291e846da1cf6 = 52;
const $a5a3df2f3994c840$export$f2d3f3e7b3a52713 = 36;
// Height of the "No recipes available yet." placeholder that stands in for the rows.
const $a5a3df2f3994c840$var$RECIPE_EMPTY_H = 24;
// Gap between the recipe list and the backpack's section label, and from that label to its slots.
// Both are kept tight on purpose: a handful of pixels here is the difference between the pack fitting
// a third row of slots and having to report the tail of itself as "+N more".
const $a5a3df2f3994c840$var$SECTION_GAP = 6;
const $a5a3df2f3994c840$var$LABEL_H = 18;
const $a5a3df2f3994c840$var$rowsHeight = (slot, rows)=>rows * (slot + $a5a3df2f3994c840$export$b00cc381b2941ede) - $a5a3df2f3994c840$export$b00cc381b2941ede;
// What one slot size can make of `maxH`: every row it needs when they fit (padded out to MIN_ROWS if
// there is room to spare), otherwise every row it can draw.
const $a5a3df2f3994c840$var$gridFor = (slot, itemCount, innerW, maxH)=>{
    const cols = Math.max(1, Math.floor((innerW + $a5a3df2f3994c840$export$b00cc381b2941ede) / (slot + $a5a3df2f3994c840$export$b00cc381b2941ede)));
    const needed = Math.max(1, Math.ceil(itemCount / cols));
    const affordable = Math.floor((maxH + $a5a3df2f3994c840$export$b00cc381b2941ede) / (slot + $a5a3df2f3994c840$export$b00cc381b2941ede));
    const rows = needed <= affordable ? Math.min(affordable, Math.max(needed, $a5a3df2f3994c840$var$MIN_ROWS)) : Math.max(1, affordable);
    return {
        slot: slot,
        cols: cols,
        rows: rows,
        gap: $a5a3df2f3994c840$export$b00cc381b2941ede,
        height: $a5a3df2f3994c840$var$rowsHeight(slot, rows),
        hidden: Math.max(0, itemCount - rows * cols)
    };
};
const $a5a3df2f3994c840$export$1db2d49d36d40ac5 = (itemCount, innerW, maxH)=>{
    const candidates = $a5a3df2f3994c840$export$a880d2a4436d893d.map((slot)=>$a5a3df2f3994c840$var$gridFor(slot, itemCount, innerW, maxH));
    const complete = candidates.find((c)=>c.height <= maxH && c.hidden === 0);
    if (complete) return complete;
    const fitting = candidates.filter((c)=>c.height <= maxH);
    // Ties keep the earlier (roomier) candidate.
    return (fitting.length > 0 ? fitting : candidates).reduce((best, c)=>c.hidden < best.hidden ? c : best);
};
const $a5a3df2f3994c840$export$cad70a0e6e8fa48e = ({ topY: topY, bottomY: bottomY, innerW: innerW, recipeCount: recipeCount, itemCount: itemCount, backpackTopY: backpackTopY })=>{
    const available = Math.max(0, bottomY - topY);
    // Reserve what the backpack wants at the roomiest slot size given unlimited height, capped so a
    // full pack can't starve the recipe list -- past the cap the grid compensates with smaller slots.
    const preferred = $a5a3df2f3994c840$var$gridFor($a5a3df2f3994c840$export$a880d2a4436d893d[0], itemCount, innerW, Number.MAX_SAFE_INTEGER);
    const cappedRows = Math.min(preferred.rows, $a5a3df2f3994c840$var$MAX_RESERVED_ROWS);
    const reserved = backpackTopY === undefined ? $a5a3df2f3994c840$var$SECTION_GAP + $a5a3df2f3994c840$var$LABEL_H + $a5a3df2f3994c840$var$rowsHeight(preferred.slot, cappedRows) : 0;
    const viewH = Math.max(0, available - reserved);
    const cardH = recipeCount > 0 ? Math.max($a5a3df2f3994c840$export$f2d3f3e7b3a52713, Math.min($a5a3df2f3994c840$export$936291e846da1cf6, Math.floor((viewH + $a5a3df2f3994c840$export$b6095232b96cb2d5) / recipeCount) - $a5a3df2f3994c840$export$b6095232b96cb2d5)) : 0;
    const contentH = recipeCount > 0 ? recipeCount * (cardH + $a5a3df2f3994c840$export$b6095232b96cb2d5) - $a5a3df2f3994c840$export$b6095232b96cb2d5 : $a5a3df2f3994c840$var$RECIPE_EMPTY_H;
    const windowH = Math.min(contentH, viewH);
    const maxScroll = Math.max(0, contentH - windowH);
    const recipesBottom = topY + windowH;
    const labelY = backpackTopY ?? recipesBottom + $a5a3df2f3994c840$var$SECTION_GAP;
    const gridY = labelY + $a5a3df2f3994c840$var$LABEL_H;
    const grid = $a5a3df2f3994c840$export$1db2d49d36d40ac5(itemCount, innerW, bottomY - gridY);
    return {
        cardH: cardH,
        viewH: windowH,
        contentH: contentH,
        maxScroll: maxScroll,
        recipesBottom: recipesBottom,
        labelY: labelY,
        gridY: gridY,
        grid: grid,
        bottom: Math.max(recipesBottom, gridY + grid.height)
    };
};
const $a5a3df2f3994c840$export$74e32579ce8387f2 = (scrollY, maxScroll)=>Math.max(0, Math.min(scrollY, Math.max(0, maxScroll)));
const $a5a3df2f3994c840$export$f56c163cec589c17 = (index, cardH, scrollY, viewH, listX, listY)=>{
    const top = index * (cardH + $a5a3df2f3994c840$export$b6095232b96cb2d5);
    return {
        x: listX,
        y: listY + top - scrollY,
        // Partly visible counts: a row half off the bottom edge is still a row the player can see and
        // reach.
        visible: top + cardH > scrollY && top < scrollY + viewH
    };
};




const $d3bd591c0da8302e$export$50223ad7f5125750 = "all";
let $d3bd591c0da8302e$export$bec7d8138cfd7e50 = [
    $d3bd591c0da8302e$export$50223ad7f5125750,
    ...(0, $29a7cd3edffb5113$export$4079d59f0101220)
];
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>[
        $d3bd591c0da8302e$export$50223ad7f5125750,
        ...catalog.source.presentation.crafting.groups
    ], (next)=>{
    $d3bd591c0da8302e$export$bec7d8138cfd7e50 = next;
});
const $d3bd591c0da8302e$export$a0b2823229be2588 = (group)=>group === $d3bd591c0da8302e$export$50223ad7f5125750 ? "All" : (0, $29a7cd3edffb5113$export$b516a3f6baae9008)[group];
const $d3bd591c0da8302e$var$normalise = (value)=>(value || "").toLowerCase().replace(/[-_]/g, " ").trim();
const $d3bd591c0da8302e$export$720c7cf5a5c0e696 = (recipe, query)=>{
    const needle = $d3bd591c0da8302e$var$normalise(query);
    if (!needle) return true;
    if ($d3bd591c0da8302e$var$normalise(recipe.label || recipe.name).includes(needle)) return true;
    return (recipe.cost || []).some((ingredient)=>$d3bd591c0da8302e$var$normalise(ingredient.itemType).includes(needle));
};
const $d3bd591c0da8302e$export$c4f8bfd602c345ad = (recipe, group)=>group === $d3bd591c0da8302e$export$50223ad7f5125750 || recipe.group === group;
const $d3bd591c0da8302e$export$e1dba822652599da = (recipes, group, query, craftableOnly = false)=>(recipes || []).filter((recipe)=>$d3bd591c0da8302e$export$c4f8bfd602c345ad(recipe, group) && $d3bd591c0da8302e$export$720c7cf5a5c0e696(recipe, query) && (!craftableOnly || !!recipe.enabled));
const $d3bd591c0da8302e$export$9fcff8a5073a2444 = (group, query, craftableOnly = false)=>{
    // "Can make now" is reported first when it is on, because it is the filter most likely to be the
    // whole reason the list is empty -- early on, almost nothing can be made yet, and a player who
    // left the toggle on would otherwise read an empty Camp list as "there is nothing to build".
    const scope = group === $d3bd591c0da8302e$export$50223ad7f5125750 ? "recipe" : `${$d3bd591c0da8302e$export$a0b2823229be2588(group)} recipe`;
    if (craftableOnly && query) return `No ${scope} matching "${query}" can be made yet.`;
    if (craftableOnly) return `No ${scope} can be made yet.`;
    if (query) return `No ${scope} matches "${query}".`;
    return group === $d3bd591c0da8302e$export$50223ad7f5125750 ? "No recipes available yet." : `No ${$d3bd591c0da8302e$export$a0b2823229be2588(group)} recipes yet.`;
};
const $d3bd591c0da8302e$export$91be09654db10545 = 1500;
const $d3bd591c0da8302e$export$617576e570fdd953 = (elapsed, duration = $d3bd591c0da8302e$export$91be09654db10545)=>{
    if (!(elapsed >= 0) || elapsed >= duration) return 0;
    const t = elapsed / duration;
    const RISE = 0.08;
    const FADE_FROM = 0.55;
    if (t < RISE) return t / RISE;
    if (t < FADE_FROM) return 1;
    return (1 - t) / (1 - FADE_FROM);
};
const $d3bd591c0da8302e$export$b09bffac643084d2 = {
    group: $d3bd591c0da8302e$export$50223ad7f5125750,
    query: "",
    craftableOnly: false,
    dropdownOpen: false,
    searchFocused: false
};
const $d3bd591c0da8302e$export$97aa46c267294ba4 = (craftableOnly = false)=>({
        ...$d3bd591c0da8302e$export$b09bffac643084d2,
        craftableOnly: craftableOnly
    });


// The ingredient line under a recipe's name on the crafting panel: which materials it costs, how many
// of each the player holds, and -- the part that was broken -- WHICH ONE is stopping them.
//
// The card used to pick that line by reading the server's hover prose back and taking the first entry
// it found:
//
//     recipe.disabledReason?.find(r => r.startsWith("-"))?.replace(/^-\s*/, "need ")
//
// The prose lists ingredients in recipe order, so for a rabbit snare (3 sticks and a rope) a player
// carrying ten sticks and no rope was shown "need 3 stick (have 10)" -- a line that is both satisfied
// and nonsense as a reason, with the actual blocker never drawn at all. The fix is not a better
// regex: the panel is now handed the price as data (`IngredientCost[]`, straight off the same pass
// that greyed the Craft button) and decides for itself.
//
// Pure of pixi on purpose, like crafting_layout.ts beside it -- see __tests__/crafting_ingredients.test.ts.
// Mirrors game-common's IngredientCost. Restated rather than imported so this module stays free of
// the item/mechanics import cycle; the shapes are checked against each other in the test.
const $e5ed6231df7ea832$export$c37d3257af004b97 = "  \xb7  ";
const $e5ed6231df7ea832$export$1473bf525092daf3 = (cost)=>cost.held < cost.required;
const $e5ed6231df7ea832$export$e8c6daca657590ea = (cost)=>`${Math.min(cost.held, cost.required)}/${cost.required} ${cost.itemType}`;
const $e5ed6231df7ea832$export$770de5cd5a50d909 = (cost)=>[
        ...cost.filter($e5ed6231df7ea832$export$1473bf525092daf3),
        ...cost.filter((next)=>!$e5ed6231df7ea832$export$1473bf525092daf3(next))
    ];
const $e5ed6231df7ea832$export$616974f9a0f955c4 = (cost, maxChars)=>{
    const ordered = $e5ed6231df7ea832$export$770de5cd5a50d909(cost || []);
    if (ordered.length < 1) return [];
    const taken = [];
    let width = 0;
    ordered.forEach((next)=>{
        const remaining = ordered.length - taken.length - 1;
        // What a `+N` tail would cost if this chip is the last one drawn.
        const tail = remaining > 0 ? $e5ed6231df7ea832$export$c37d3257af004b97.length + `+${remaining}`.length : 0;
        const added = (taken.length > 0 ? $e5ed6231df7ea832$export$c37d3257af004b97.length : 0) + $e5ed6231df7ea832$export$e8c6daca657590ea(next).length;
        if (taken.length > 0 && width + added + tail > maxChars) return;
        taken.push(next);
        width += added;
    });
    const chips = taken.map((next, i)=>({
            text: $e5ed6231df7ea832$export$e8c6daca657590ea(next),
            missing: $e5ed6231df7ea832$export$1473bf525092daf3(next),
            lead: i > 0 ? $e5ed6231df7ea832$export$c37d3257af004b97 : "",
            // Only a SHORT ingredient is a question worth answering. One already covered is not.
            actionable: $e5ed6231df7ea832$export$1473bf525092daf3(next) && !!next.craftable,
            source: $e5ed6231df7ea832$export$1473bf525092daf3(next) && !next.craftable ? next.source : undefined
        }));
    const hidden = ordered.length - taken.length;
    if (hidden > 0) chips.push({
        text: `+${hidden}`,
        missing: false,
        lead: $e5ed6231df7ea832$export$c37d3257af004b97,
        actionable: false,
        hidden: hidden
    });
    return chips;
};
const $e5ed6231df7ea832$export$2c2ee042b1dccca8 = (lines)=>{
    const short = (lines || []).find((line)=>line.startsWith("!"));
    if (short) return short.replace(/^!\s*/, "need ");
    // No `!` anywhere: either every ingredient is covered (so the row is dead for some other reason,
    // like a full pack) or this is a one-line message such as "Inventory full, cannot craft".
    return (lines || []).find((line)=>!line.startsWith("-") && !line.endsWith(":"));
};


// What the `+2` at the end of a recipe's ingredient line opens: the WHOLE price, one ingredient per
// row, in a small popover hung off the chip that was tapped.
//
// The ingredient line is one row tall inside a docked panel, so a three-ingredient recipe routinely
// has room for one chip and a `+2` (see ingredientChipsFor). Short ingredients are drawn first, which
// means the `+N` usually hides only things the player already has -- but on a recipe short of three
// materials with room for one chip, it hides shortfalls too. Either way a tail that cannot be
// expanded is a line admitting it is hiding something and then refusing to say what.
//
// Pure of pixi, like crafting_ingredients.ts it reads and crafting_layout.ts beside it. The drawing
// lives in modern_inventory_dialog.ts; what is checked here is the rows and the arithmetic that keeps
// the box on the panel -- see __tests__/recipe_popover.test.ts.

const $199629acfe156ebe$export$e82d0fa23248ae49 = 8;
const $199629acfe156ebe$export$43fd459361d4ceb2 = 6;
const $199629acfe156ebe$export$9d8dddb24d0dd6f2 = 4;
const $199629acfe156ebe$export$49825faa641b5954 = 4;
const $199629acfe156ebe$export$b57d4d5e072318c5 = 3;
const $199629acfe156ebe$export$f9ab69e04f728393 = " \u2014 ";
const $199629acfe156ebe$export$4a64f2f0a079efbd = (cost)=>(0, $e5ed6231df7ea832$export$770de5cd5a50d909)(cost || []).map((next)=>({
            text: (0, $e5ed6231df7ea832$export$e8c6daca657590ea)(next),
            missing: (0, $e5ed6231df7ea832$export$1473bf525092daf3)(next),
            // Only a SHORT ingredient is a question worth answering, exactly as on the line.
            jumpable: (0, $e5ed6231df7ea832$export$1473bf525092daf3)(next) && !!next.craftable,
            note: (0, $e5ed6231df7ea832$export$1473bf525092daf3)(next) && !next.craftable ? next.source : undefined
        }));
const $199629acfe156ebe$export$a678144c2ca99670 = ({ titleW: titleW, titleH: titleH, rowW: rowW, rowH: rowH, rows: rows })=>({
        w: Math.ceil(Math.max(titleW, rowW)) + $199629acfe156ebe$export$e82d0fa23248ae49 * 2,
        h: Math.ceil(titleH + $199629acfe156ebe$export$b57d4d5e072318c5 + rowH * Math.max(0, rows)) + $199629acfe156ebe$export$43fd459361d4ceb2 * 2
    });
const $199629acfe156ebe$export$af0317d4de5b92ee = ({ anchorX: anchorX, anchorY: anchorY, anchorH: anchorH, popW: popW, popH: popH, panelW: panelW, panelH: panelH })=>{
    const maxX = Math.max($199629acfe156ebe$export$49825faa641b5954, panelW - popW - $199629acfe156ebe$export$49825faa641b5954);
    const x = Math.round(Math.max($199629acfe156ebe$export$49825faa641b5954, Math.min(maxX, anchorX)));
    const below = anchorY + anchorH + $199629acfe156ebe$export$9d8dddb24d0dd6f2;
    const above = anchorY - popH - $199629acfe156ebe$export$9d8dddb24d0dd6f2;
    const fitsBelow = below + popH <= panelH - $199629acfe156ebe$export$49825faa641b5954;
    const fitsAbove = above >= $199629acfe156ebe$export$49825faa641b5954;
    // Neither side fits: take the preferred one and let the clamp pin it, rather than picking the
    // side that overflows LESS and landing the box somewhere the player did not tap.
    const chosen = fitsBelow || !fitsAbove ? below : above;
    const maxY = Math.max($199629acfe156ebe$export$49825faa641b5954, panelH - popH - $199629acfe156ebe$export$49825faa641b5954);
    return {
        x: x,
        y: Math.round(Math.max($199629acfe156ebe$export$49825faa641b5954, Math.min(maxY, chosen)))
    };
};




// A real DOM <input>, parked over the canvas where a pixi box is drawn.
//
// The crafting panel's search box used to read document keydowns and draw its own text, which is
// everything a phone cannot give: a soft keyboard with autocorrect does not produce the keystrokes it
// read, and nothing raises that keyboard in the first place. gui/chat_composer.ts says the same thing
// at greater length -- a real <input> is the only thing that opens a phone's keyboard at all.
//
// It is NOT a pixi-text-input like the composer's. That library parents its DOM node to a display
// object and appends/removes it on 'added'/'removed', and this panel rebuilds its whole tree on every
// server message, scroll and keystroke -- so the node would be torn out and re-appended mid-word, and
// the field would lose focus after a single letter. A node the panel does not own survives all of it;
// each rebuild just tells it where the box ended up.
//
// The box the panel draws is now only a FRAME. The input is visible and carries its own text, so a
// tap lands on the element itself -- a genuine user gesture, which is what a phone wants before it
// will raise a keyboard, rather than a focus() call issued from a pixi handler.
const $d8f28c464fcc8750$export$95a22a72d3b9c87e = (global, screen, canvas)=>{
    const scaleX = screen.width > 0 ? canvas.width / screen.width : 0;
    const scaleY = screen.height > 0 ? canvas.height / screen.height : 0;
    return {
        left: canvas.left + global.x * scaleX,
        top: canvas.top + global.y * scaleY,
        width: global.width * scaleX,
        height: global.height * scaleY
    };
};
const $d8f28c464fcc8750$var$SEARCH_FIELD_CLASS = "samsara-search-field";
let $d8f28c464fcc8750$var$placeholderStyled = false;
// A placeholder's colour can only be set from a stylesheet (::placeholder has no inline form), so the
// rule is added to the page once, the first time a field is built.
const $d8f28c464fcc8750$var$ensurePlaceholderStyle = ()=>{
    if ($d8f28c464fcc8750$var$placeholderStyled || typeof document === "undefined") return;
    $d8f28c464fcc8750$var$placeholderStyled = true;
    const style = document.createElement("style");
    style.textContent = `.${$d8f28c464fcc8750$var$SEARCH_FIELD_CLASS}::placeholder { color: #8f7d62; opacity: 1; }`;
    document.head.appendChild(style);
};
class $d8f28c464fcc8750$export$b94867ecbd698f21 {
    constructor(props){
        this.props = props;
    }
    /** Build the node on first use. Idempotent. */ ensure() {
        if (this.node) return this.node;
        if (typeof document === "undefined") return undefined;
        const node = document.createElement("input");
        node.type = "text";
        node.value = "";
        node.setAttribute("aria-label", this.props.ariaLabel);
        node.placeholder = this.props.placeholder;
        // A search box is not prose: the phone's sentence case and autocorrect would fight a player
        // typing "shard-metal". `enterkeyhint` turns the keyboard's return key into "search", which
        // is the one key that means "I am done here" on a device with no Escape.
        node.setAttribute("autocapitalize", "off");
        node.setAttribute("autocomplete", "off");
        node.setAttribute("autocorrect", "off");
        node.setAttribute("spellcheck", "false");
        node.setAttribute("enterkeyhint", "search");
        Object.assign(node.style, {
            position: "fixed",
            margin: "0",
            padding: "0 8px",
            border: "none",
            outline: "none",
            background: "transparent",
            // The camp's ink and gold, to match the timber panel the field is set into.
            color: "#ffedc7",
            caretColor: "#ffd166",
            // 16px is the floor Safari zooms a focused field up to. The viewport meta pins the scale
            // so it should not zoom anyway, but a field already big enough cannot be caught out by a
            // page that loses that pin.
            fontSize: "16px",
            fontFamily: "Arial, sans-serif",
            boxSizing: "border-box",
            // Over the canvas, under anything the browser puts on top of the page.
            zIndex: "40",
            display: "none"
        });
        node.className = $d8f28c464fcc8750$var$SEARCH_FIELD_CLASS;
        $d8f28c464fcc8750$var$ensurePlaceholderStyle();
        node.addEventListener("input", ()=>this.props.onInput(node.value));
        node.addEventListener("keydown", (event)=>{
            // Both "I am done here" keys actually BLUR the node rather than just telling the panel
            // they were pressed. Updating panel state alone left the <input> holding focus: the
            // caret stayed in it, and -- because of the stopPropagation below -- no number of further
            // Escapes could reach the modal to close the screen. The native blur event is what drives
            // the callback, so there is one path out whether the player used a key or tapped away.
            if (event.key === "Enter" || event.key === "Escape") {
                event.preventDefault();
                node.blur();
                return;
            }
            // Movement keys must not reach the game while the player is typing into this. Only while
            // the field still has the keyboard -- the two keys above get out of the way first, so
            // Escape closes the panel on the press after the one that left the field.
            event.stopPropagation();
        });
        node.addEventListener("focus", ()=>this.props.onFocus());
        node.addEventListener("blur", ()=>this.props.onBlur());
        document.body.appendChild(node);
        this.node = node;
        return node;
    }
    /** Put the field over this page rectangle and show it. */ show(rect, value) {
        const node = this.ensure();
        if (!node) return;
        if (node.value !== value) node.value = value;
        Object.assign(node.style, {
            display: "block",
            left: `${Math.round(rect.left)}px`,
            top: `${Math.round(rect.top)}px`,
            width: `${Math.round(rect.width)}px`,
            height: `${Math.round(rect.height)}px`,
            // The drawn frame is the box; the text should sit on its centre line whatever the
            // letterbox has done to the panel's scale.
            lineHeight: `${Math.round(rect.height)}px`,
            // Room for whatever the frame draws at its left end (the panel's magnifier), measured in
            // box heights so it follows the letterbox's scale like the box does.
            paddingLeft: `${Math.round(8 + rect.height * (this.props.leadingInset ?? 0))}px`
        });
    }
    hide() {
        if (this.node) this.node.style.display = "none";
    }
    /** Darken the field with whatever is dimming the panel under it (1 = as drawn). */ setBrightness(brightness) {
        if (this.node) this.node.style.filter = brightness < 1 ? `brightness(${brightness.toFixed(3)})` : "";
    }
    focus() {
        this.node?.focus();
    }
    /** Give the keyboard back to the page, without taking the field off it. */ blurNode() {
        this.node?.blur();
    }
    isFocused() {
        return !!this.node && typeof document !== "undefined" && document.activeElement === this.node;
    }
    value() {
        return this.node?.value ?? "";
    }
    /**
     * Take the node off the page.
     *
     * The panel is rebuilt and thrown away constantly; this node is not part of that tree, which is
     * the point of it -- and also why nothing else will ever clean it up. A field left behind is the
     * ghost input that has bitten the login card before.
     */ dispose() {
        this.node?.remove();
        this.node = undefined;
    }
}






parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");


class $c14ea609224dd88d$export$982d39230018c180 extends (0, $aeae8505a2eb5f5c$export$f169141001428c70) {
    constructor(entityProps, entity, props){
        super(props), this.createContent = ()=>{
            const content = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            // The body the entity has in the world: an Ember one where it has one, else its LPC paperdoll.
            const portrait = (0, $a020ac28c1deebe7$export$c4e1af01547f5776)(this.entity, this.entity.entityId, false, "figure");
            portrait.scale.set(this.entityProps.scale || 3);
            const holder = new (0, $gwPoJ.Graphics)();
            holder.addChild(portrait);
            content.append2(holder, {
                topMargin: 32,
                leftMargin: 32
            });
            return content;
        };
        this.entityProps = entityProps;
        this.entity = entity;
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");








class $3abf84d544684951$export$63ffc65ecf9f990b extends (0, $gwPoJ.Graphics) {
    constructor(){
        super(), this.update = (item, onSelectCallback)=>{
            if (!item) return;
            [
                ...this.surface.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.surface.removeChildren();
            this.clear();
            const main = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            this.surface.addChild(main);
            this.surface.addChild(this.hoverText);
            const title = new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(item.title, {
                color: 0x00ff00
            });
            main.append2(title);
            if (item.hoverText?.length > 0) {
                this.hoverText.visible = true;
                this.hoverText.visible = true;
                this.hoverText.update(item.hoverText);
                this.hoverText.y = -this.hoverText.height;
            } else this.hoverText.visible = false;
            let width = 0;
            item.options.forEach((itemOption, i)=>{
                const option = new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(itemOption.title, {
                    type: "button|dynamic",
                    onClick: ()=>{
                        onSelectCallback({
                            ...itemOption
                        });
                    }
                });
                main.append2(option, {
                    topMargin: i === 0 ? 5 : undefined
                });
                if (option.width > width) width = option.width;
            });
            this.beginFill(0xff0000, 0.1);
            this.drawRect(0, 0, width, main.height);
            this.endFill();
            this.zIndex = 100000;
        };
        this.surface = new (0, $gwPoJ.Graphics)();
        this.addChild(this.surface);
        this.hoverText = new (0, $95fcf006ca17068b$export$9035ac6ca3ebe147)();
        this.interactive = true;
        this.on("mouseover", ()=>{
            if (this.fader) {
                this.fader.stop();
                this.visible = true;
                this.alpha = 1.0;
            }
        });
        this.on("mouseout", ()=>{
            this.fader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                fadeInterval: 1,
                fadeAlphaDecrement: 0.03,
                releaseCallback: ()=>{
                    this.alpha = 1.0;
                    this.visible = false;
                }
            });
            this.fader.update();
        });
    }
}
class $3abf84d544684951$export$ef2184bd89960b14 extends (0, $aeae8505a2eb5f5c$export$f169141001428c70) {
    constructor(gridMeta, props){
        super(props), this.itemMap = new Map(), this.createContent = (itemDetail)=>{
            const pane = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            const itemList = this.buildItems(this.meta.itemMeta, itemDetail, this.meta.rows, this.meta.columns, this.meta.optionSelectionHandler);
            pane.append(itemList);
            this.surface = pane;
            return pane;
        }, this.buildItems = (items, detail, rows, columns, optionSelectionHandler)=>{
            const itemList = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            const surfaceWidth = 48;
            const print = (item, row, column)=>{
                const itemSurface = new (0, $gwPoJ.Graphics)();
                itemSurface.width = surfaceWidth;
                itemSurface.height = surfaceWidth;
                itemSurface.zIndex = 1;
                if (item) this.itemMap.set(item.id, itemSurface);
                if (item && item.active) {
                    itemSurface.beginFill(item.activeColor !== undefined ? item.activeColor : 0x00ff00, 0.5);
                    itemSurface.drawCircle(surfaceWidth / 2, surfaceWidth / 2, surfaceWidth / 2 - 1);
                    itemSurface.endFill();
                } else {
                    itemSurface.beginFill(0xffffff, 0.3);
                    itemSurface.drawCircle(surfaceWidth / 2, surfaceWidth / 2, surfaceWidth / 2 - 1);
                    itemSurface.endFill();
                    itemSurface.beginFill(0x000000, 1);
                    itemSurface.drawCircle(surfaceWidth / 2, surfaceWidth / 2, surfaceWidth / 2 - 2);
                    itemSurface.endFill();
                }
                if (item) {
                    itemSurface.interactive = true;
                    itemSurface.on((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? "tap" : "mouseover", ()=>{
                        detail.visible = true;
                        detail.x = itemSurface.x + this.surface.x + (this.foofoo?.x || 0);
                        detail.y = itemSurface.y + this.surface.y + (this.foofoo?.y || 0);
                        detail.update(item, optionSelectionHandler);
                    });
                    const itemSprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: item.spriteId,
                        scale: 0.8,
                        color: 0xffffff,
                        animated: false,
                        rotating: false
                    });
                    itemSprite.x = surfaceWidth / 2;
                    itemSprite.y = surfaceWidth / 2;
                    itemSurface.addChild(itemSprite);
                    if (item.quantity > 1) {
                        const quantityLabel = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render(`${item.quantity}`);
                        quantityLabel.x = itemSprite.x - quantityLabel.width / 2;
                        quantityLabel.y = itemSprite.y + 10;
                        itemSurface.addChild(quantityLabel);
                    }
                }
                itemSurface.x = column * surfaceWidth;
                itemSurface.y = row * surfaceWidth;
                itemList.addChild(itemSurface);
            };
            let itemPos = 0;
            for(let row = 0; row < rows; row++)for(let column = 0; column < columns; column++){
                print(items[row * columns + column], row, column);
                itemPos++;
            }
            return itemList;
        };
        this.meta = gridMeta;
    }
}




class $95fcf006ca17068b$export$9035ac6ca3ebe147 extends (0, $gwPoJ.Graphics) {
    constructor(){
        super(), this.update = (texts)=>{
            if (texts.length < 1) return;
            this.surface.removeChildren();
            this.clear();
            const main = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            this.surface.addChild(main);
            texts.forEach((text, i)=>{
                main.append2(new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(text), {
                    topMargin: i === 0 ? 5 : 0,
                    leftMargin: 5,
                    bottomMargin: 2
                });
            });
            this.beginFill(0x808080);
            this.drawRoundedRect(0, 0, main.width + 10, main.height + 10, 5);
            this.endFill();
        };
        this.surface = new (0, $gwPoJ.Graphics)();
        this.addChild(this.surface);
        this.interactive = true;
        this.on("mouseover", ()=>{
            if (this.fader) {
                this.fader.stop();
                this.visible = true;
                this.alpha = 1.0;
            }
        });
        this.on("mouseout", ()=>{
            this.fader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                fadeInterval: 1,
                fadeAlphaDecrement: 0.03,
                releaseCallback: ()=>{
                    this.alpha = 1.0;
                    this.visible = false;
                }
            });
            this.fader.update();
        });
    }
}
class $95fcf006ca17068b$export$97a92ac594e41d5f extends (0, $ac2a97d45725bff5$export$f79759b47a91f0e7) {
    constructor(guiManager, logic, message, onClose, modalProps){
        super(guiManager, modalProps), this.grids = [], this.throbbers = [], this.updateContent = (message)=>{
            this.grids = [];
            this.message = message;
            // this.logic.enablePlayerMouseAction(false)
            this.update();
        }, this.createContent = ()=>{
            const { message: message } = this;
            return $95fcf006ca17068b$export$97a92ac594e41d5f.createContent(this.logic, message, this.width(), this.grids);
        }, this.pulseGridItem = (itemId)=>{
            const slots = this.grids.map((grid)=>grid.itemMap.get(itemId)).filter((items)=>!!items).flat();
            slots.forEach((slot)=>{
                const newIndicator = new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)("New!", {
                    font: "RedChatFont"
                });
                newIndicator.x = slot.width / 2 - newIndicator.width / 2;
                newIndicator.y = 2;
                slot.addChild(newIndicator);
                const throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(slot, {
                    expires: 10000,
                    blinkInterval: 50,
                    releaseCallback: ()=>{
                        slot.removeChild(newIndicator);
                    }
                });
                throbber.update();
            });
        };
        this.logic = logic;
        this.message = message;
        if (onClose) this.onClose = ()=>{
            if (onClose) onClose();
        };
    }
    static{
        this.createContent = (logic, message, width, grids, props)=>{
            const progressive = message.progressive;
            const content = new (0, $gwPoJ.Graphics)();
            const { dynamicText: dynamicText = [], columnCount: columnCount = 1 } = message;
            const columns = new Map();
            const columnWidth = width / columnCount;
            const detailContainer = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            const itemDetail = new (0, $3abf84d544684951$export$63ffc65ecf9f990b)();
            const hoverText = new $95fcf006ca17068b$export$9035ac6ca3ebe147();
            detailContainer.addChild(itemDetail);
            detailContainer.addChild(hoverText);
            for(let i = 1; i <= columnCount; i++){
                const columnSurface = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)({
                    linkCallback: logic.log,
                    progressive: progressive,
                    hoverText: hoverText,
                    ...props || {}
                });
                columnSurface.x = (i - 1) * columnWidth;
                content.addChild(columnSurface);
                columns.set(i, columnSurface);
            }
            const processText = (text, targetContainer)=>{
                if (text.type === "entity") {
                    const { entityId: entityId, scale: scale, appearance: appearance, inventory: inventory } = text.context;
                    const entity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
                    entity.weapon = {
                        weaponType: (0, $f684496fff50a7a1$export$58361cde22f3aa43)(inventory, "weapon")?.type
                    };
                    entity.appearance = appearance;
                    entity.inventory = inventory;
                    const entityDisplayer = new (0, $c14ea609224dd88d$export$982d39230018c180)({
                        entityId: entityId,
                        scale: scale
                    }, entity);
                    const c = entityDisplayer.createContent();
                    targetContainer.append2(c, {
                        sameLine: text.sameLine,
                        leftSpacer: text.leftSpacer !== undefined ? text.leftSpacer : 0,
                        leftMargin: text.leftMargin !== undefined ? text.leftMargin : 15,
                        topMargin: text.topMargin,
                        exactLocation: text.exactLocation,
                        hoverText: text.hoverText
                    });
                }
                if (text.type === "grid") {
                    const { gridMeta: meta, rows: rows, columns: columns } = text.context;
                    const grid = new (0, $3abf84d544684951$export$ef2184bd89960b14)({
                        itemMeta: meta,
                        optionSelectionHandler: (option)=>{
                            logic.playerController.client.emitPlayerEvent({
                                ...option.onClickContext
                            });
                        },
                        rows: rows,
                        columns: columns
                    });
                    grid.foofoo = targetContainer;
                    grids.push(grid);
                    targetContainer.append2(grid.createContent(itemDetail), {
                        sameLine: text.sameLine,
                        leftSpacer: text.leftSpacer !== undefined ? text.leftSpacer : 0,
                        leftMargin: text.leftMargin !== undefined ? text.leftMargin : 0,
                        topMargin: text.topMargin,
                        exactLocation: text.exactLocation,
                        hoverText: text.hoverText
                    });
                } else if (text.type === "horizontalLine") targetContainer.append2(new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)("", {
                    type: "horizontalLine"
                }), {
                    topMargin: text.topMargin,
                    bottomMargin: text.bottomMargin,
                    leftMargin: text.leftMargin,
                    hoverText: text.hoverText
                });
                else if (text.type === "container") {
                    const containerSurface = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)({
                        linkCallback: logic.log,
                        progressive: progressive,
                        hoverText: hoverText
                    });
                    text.children.forEach((child)=>{
                        processText(child, containerSurface);
                    });
                    targetContainer.append2(containerSurface, {
                        sameLine: text.sameLine,
                        sameX: text.sameX,
                        leftSpacer: text.leftSpacer !== undefined ? text.leftSpacer : 0,
                        leftMargin: text.leftMargin !== undefined ? text.leftMargin : 15,
                        topMargin: text.topMargin,
                        exactLocation: text.exactLocation,
                        hoverText: text.hoverText
                    });
                } else {
                    const texts = (0, $a80d0b17b615d6f7$export$edde49207b897324)(text.text, 95);
                    texts.forEach((nextText)=>{
                        targetContainer.append2(nextText, {
                            sameLine: text.sameLine,
                            sameX: text.sameX,
                            leftSpacer: text.leftSpacer !== undefined ? text.leftSpacer : 0,
                            leftMargin: text.leftMargin !== undefined ? text.leftMargin : 15,
                            pause: text.pause,
                            type: text.type,
                            textDecorations: text.textDecorations,
                            onClick: text.clickEventEmitter ? ()=>{
                                logic.playerController.client.emitPlayerEvent(text.clickEventEmitter);
                            } : undefined,
                            mouseControlCallback: (on)=>{
                                const wasEnabled = logic.playerController.isMouseActionEnabled();
                                const enableRequested = !on;
                                if (enableRequested) // turn on player mouse control
                                {
                                    if (wasEnabled) // mouse control was allowed, so turn it on
                                    logic.playerController.enabledMouseAction(true);
                                // it wasn't allowed prior, so don't turn it on
                                } else // turn off player mouse control
                                logic.playerController.enabledMouseAction(enableRequested);
                            },
                            spriteId: text.spriteId,
                            scale: text.scale,
                            context: text.context,
                            exactLocation: text.exactLocation,
                            hoverText: text.hoverText,
                            font: text.font,
                            color: text.color
                        });
                    });
                }
            };
            dynamicText.map((next)=>typeof next === "string" ? {
                    text: next
                } : next).forEach((text)=>{
                const { column: column = 1 } = text;
                const textBlock = columns.get(column);
                processText(text, textBlock);
            });
            content.addChild(detailContainer);
            if (progressive) for(let i = 1; i <= columnCount; i++)columns.get(i).playback();
            return content;
        };
    }
}




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");

const $90f59133f949281e$export$79f534cd3b893038 = 0.995;
const $90f59133f949281e$export$430109590db6beb9 = 0.25;
/**
 * The ramp, as stops rather than one green-to-red mix.
 *
 * A single lerp end to end puts a muddy olive at the halfway mark -- which reads as neither healthy
 * nor hurt, and halfway is exactly where a player starts thinking about a replacement -- and it
 * also drags "new" territory a long way towards yellow, so a 90% axe looked tired. The stops are
 * placed so the colour and the WORD the server's tiers would give it (75/50/25) agree at a glance:
 * green above three quarters, amber through the middle, red by the time it is fragile.
 */ const $90f59133f949281e$var$RAMP = [
    [
        0,
        0xcf3b32
    ],
    // Red by the time the gauge is in the warning tier, rather than somewhere on the way there:
    // drawn with the red stop only at zero, a weapon two swings from breaking was still ORANGE,
    // which is the colour of "getting on a bit" and not of "this is about to leave your hand".
    [
        0.22,
        0xe2543f
    ],
    [
        0.45,
        0xf0a63c
    ],
    // A bright yellow between amber and green. Without it the mix sags through an unsaturated
    // khaki right where most of a player's gear lives, and a half-worn axe looked dirty rather
    // than half worn.
    [
        0.68,
        0xdcc94e
    ],
    [
        0.85,
        0x8ecf5c
    ],
    [
        1,
        0x5fd16e
    ]
];
const $90f59133f949281e$var$clamp01 = (value)=>value < 0 ? 0 : value > 1 ? 1 : value;
const $90f59133f949281e$export$1ab1c54f03f55cee = (pct)=>{
    const p = $90f59133f949281e$var$clamp01(pct);
    for(let i = 1; i < $90f59133f949281e$var$RAMP.length; i++){
        const [at, color] = $90f59133f949281e$var$RAMP[i];
        if (p <= at) {
            const [from, fromColor] = $90f59133f949281e$var$RAMP[i - 1];
            return (0, $7f40928dcf527a2e$export$5931e35698b46017)(fromColor, color, (p - from) / (at - from));
        }
    }
    return $90f59133f949281e$var$RAMP[$90f59133f949281e$var$RAMP.length - 1][1];
};
const $90f59133f949281e$export$ae886648d8c4599b = (pct)=>pct !== undefined && Number.isFinite(pct) && pct < $90f59133f949281e$export$79f534cd3b893038;
// The empty part of the gauge. Near-black, because at slot scale it is read against the well it
// sits in -- the tray's warm black and the panel's slate both -- and it has to be the hole in both.
const $90f59133f949281e$var$TRACK = 0x0b0a09;
const $90f59133f949281e$var$TRACK_ALPHA = 0.78;
// The item menu needs a lighter one. Its card is already near-black (COLOR.cardFill 0x11141c), so
// the slot track vanished into it and the gauge lost its far end: what was LEFT could be seen and
// what was GONE could not, which is half a gauge.
const $90f59133f949281e$var$CARD_TRACK = 0x272e3d;
// Resting alpha of the fragile bloom, and the band it breathes across in the tray.
const $90f59133f949281e$var$BLOOM_REST = 0.38;
const $90f59133f949281e$var$BLOOM_LOW = 0.2;
const $90f59133f949281e$var$BLOOM_HIGH = 0.62;
const $90f59133f949281e$var$BLOOM_PERIOD = 1400;
/** Fraction of the track a gauge's fill covers, floored so the last sliver is still a visible dot. */ const $90f59133f949281e$var$fillWidth = (p, w, h)=>Math.max(h, w * p);
/**
 * The soft red halo under a fragile gauge, or undefined above the warning tier.
 *
 * It hugs the FILL, not the track. Drawn the track's full length -- the first thing tried -- it was
 * a long dull slab the colour of dried blood lying under the gauge, which read as a nearly-full bar
 * in a worrying colour: the exact opposite of what it is there to say. Around the stub that is left
 * it is a coal instead, and the darkness to its right is the part that is gone.
 */ const $90f59133f949281e$var$makeBloom = (pct, x, y, w, h)=>{
    const p = $90f59133f949281e$var$clamp01(pct);
    if (p > $90f59133f949281e$export$430109590db6beb9) return undefined;
    const bloom = new (0, $gwPoJ.Graphics)();
    bloom.beginFill((0, $7f40928dcf527a2e$export$5931e35698b46017)($90f59133f949281e$export$1ab1c54f03f55cee(p), 0xffffff, 0.15), 1);
    bloom.drawRoundedRect(x - 2.5, y - 2.5, $90f59133f949281e$var$fillWidth(p, w, h) + 5, h + 5, h / 2 + 2.5);
    bloom.endFill();
    bloom.alpha = $90f59133f949281e$var$BLOOM_REST;
    return bloom;
};
/**
 * The capsule gauge itself, in whatever box the caller gives it. Used at slot scale (a 3-4px bar in
 * the well's bottom gutter) and at card scale (a 6px bar across the item menu). The bloom, where
 * there is one, is a separate node the caller stacks UNDER this -- pixi draws a Graphics' own
 * geometry before its children, so a halo added to this one would sit on top of the gauge it is
 * meant to be glowing behind.
 */ const $90f59133f949281e$var$drawCapsule = (g, pct, x, y, w, h, { sheen: sheen = true, ticks: ticks = false, track: track = $90f59133f949281e$var$TRACK, trackAlpha: trackAlpha = $90f59133f949281e$var$TRACK_ALPHA } = {})=>{
    const p = $90f59133f949281e$var$clamp01(pct);
    const r = h / 2;
    const color = $90f59133f949281e$export$1ab1c54f03f55cee(p);
    const fillW = $90f59133f949281e$var$fillWidth(p, w, h);
    g.beginFill(track, trackAlpha);
    g.drawRoundedRect(x, y, w, h, r);
    g.endFill();
    g.beginFill(color, 1);
    g.drawRoundedRect(x, y, fillW, h, r);
    g.endFill();
    // Sheen along the top half, which is what makes the fill read as a lit tube instead of a flat
    // swatch of colour. Skipped on the 3px bars, where "half" is a third of the bar and the lighter
    // band just desaturates it.
    if (sheen && h >= 4) {
        const sheenH = h / 2 - 0.75;
        g.beginFill((0, $7f40928dcf527a2e$export$5931e35698b46017)(color, 0xffffff, 0.45), 0.2);
        g.drawRoundedRect(x + 1, y + 0.75, Math.max(1, fillW - 2), sheenH, sheenH / 2);
        g.endFill();
    }
    // Engraved tier marks at the thresholds the server's own words turn on (75/50/25), so the
    // "Sturdy" printed beside the gauge and the length of the gauge agree with each other. Card
    // scale only -- at 22px wide they are three scratches.
    if (ticks) {
        g.beginFill(0x000000, 0.28);
        [
            0.25,
            0.5,
            0.75
        ].forEach((at)=>g.drawRect(x + w * at - 0.5, y + 1, 1, h - 2));
        g.endFill();
    }
};
class $90f59133f949281e$export$aac214f772e3eeb7 extends (0, $8t5Gy.Container) {
    constructor(pct, size, rightInset){
        super(), this.phase = 0, /**
     * Breathe the fragile bloom. One alpha write per frame -- no geometry, no filters, nothing
     * rebuilt -- and a no-op on every bar that is not fragile, which is almost all of them.
     *
     * Driven off the frame delta rather than a wall clock, so a tab drawing no frames is not
     * quietly running a timer (see the hearts in gui/icon_meter.ts for the same argument).
     */ this.animate = (deltaMs)=>{
            if (!this.bloom) return;
            this.phase = (this.phase + deltaMs) % $90f59133f949281e$var$BLOOM_PERIOD;
            const wave = 0.5 - 0.5 * Math.cos(this.phase / $90f59133f949281e$var$BLOOM_PERIOD * Math.PI * 2);
            this.bloom.alpha = $90f59133f949281e$var$BLOOM_LOW + ($90f59133f949281e$var$BLOOM_HIGH - $90f59133f949281e$var$BLOOM_LOW) * wave;
        };
        const h = size >= 36 ? 4 : 3;
        const side = Math.max(4, Math.round(size * 0.12));
        const w = Math.max(8, size - side * 2 - rightInset);
        // 4px off the floor of the well: the slot's own face is inset 2 and its rim is 1, so this
        // clears both and still reads as sitting INSIDE the frame rather than on its edge.
        const y = size - 4 - h;
        this.bloom = $90f59133f949281e$var$makeBloom(pct, side, y, w, h);
        if (this.bloom) this.addChild(this.bloom);
        const body = new (0, $gwPoJ.Graphics)();
        $90f59133f949281e$var$drawCapsule(body, pct, side, y, w, h);
        this.addChild(body);
    }
    static{
        /** Undefined when the item cannot wear, or has not. Callers add the node if they get one. */ this.forSlot = (pct, size, rightInset = 0)=>$90f59133f949281e$export$ae886648d8c4599b(pct) ? new $90f59133f949281e$export$aac214f772e3eeb7(pct, size, rightInset) : undefined;
    }
    /** True while this gauge has something to animate, so an owner can skip the frame clock. */ get breathing() {
        return !!this.bloom;
    }
}
const $90f59133f949281e$export$2563b908070a066f = 6;
const $90f59133f949281e$export$b3ec34e617a827fb = (g, pct, x, y, w)=>{
    $90f59133f949281e$var$drawCapsule(g, pct, x, y, w, $90f59133f949281e$export$2563b908070a066f, {
        ticks: true,
        track: $90f59133f949281e$var$CARD_TRACK,
        trackAlpha: 1
    });
};






const $70944e0e10e6c43a$export$2910b725986ae787 = 264;
const $70944e0e10e6c43a$export$ac1e2850638b95a7 = 14;
const $70944e0e10e6c43a$export$a9ede386157d607a = $70944e0e10e6c43a$export$2910b725986ae787 - $70944e0e10e6c43a$export$ac1e2850638b95a7 * 2;
const $70944e0e10e6c43a$export$9af9114e89ff83a2 = 11;
const $70944e0e10e6c43a$export$553d45c3442434df = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).caption.fontSize;
const $70944e0e10e6c43a$export$da8ec1e8cb867d79 = 32;
const $70944e0e10e6c43a$export$3e922b6dc32741b1 = 86;
const $70944e0e10e6c43a$export$7d52ac13ac82d711 = 30;
const $70944e0e10e6c43a$export$6a9dffc2d456b0a3 = 8;
const $70944e0e10e6c43a$export$b3279a5753537da9 = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).title.fontSize;
const $70944e0e10e6c43a$export$cf30ece78a3cde75 = 76;
const $70944e0e10e6c43a$export$dcfd15f865104c82 = (0, $97475243e21a0995$export$73e83bf2b7e02467).small.height;
const $70944e0e10e6c43a$export$22d76395a6fcd5f6 = 10;
const $70944e0e10e6c43a$export$df9c782f47875f3d = $70944e0e10e6c43a$export$ac1e2850638b95a7 + $70944e0e10e6c43a$export$dcfd15f865104c82 + $70944e0e10e6c43a$export$22d76395a6fcd5f6;
const $70944e0e10e6c43a$export$35b0ea25dd9324cb = $70944e0e10e6c43a$export$2910b725986ae787 - $70944e0e10e6c43a$export$df9c782f47875f3d * 2;
const $70944e0e10e6c43a$export$4f0a5731cdda4a44 = 6;
const $70944e0e10e6c43a$export$7b47d622867725d1 = $70944e0e10e6c43a$export$cf30ece78a3cde75 + $70944e0e10e6c43a$export$dcfd15f865104c82 / 2;
const $70944e0e10e6c43a$export$fa15a17427b0bc4d = 8;
const $70944e0e10e6c43a$export$a9b2c383cf2ab052 = 108;
const $70944e0e10e6c43a$export$be057f60597d5793 = 64;
const $70944e0e10e6c43a$export$5102f6b83c315c0c = (0, $97475243e21a0995$export$73e83bf2b7e02467).small.height;
const $70944e0e10e6c43a$export$4a74fa73d9fcb37a = 8;
const $70944e0e10e6c43a$export$53b190a46f0ad1d8 = ($70944e0e10e6c43a$export$2910b725986ae787 - ($70944e0e10e6c43a$export$be057f60597d5793 * 3 + $70944e0e10e6c43a$export$4a74fa73d9fcb37a * 2)) / 2;
const $70944e0e10e6c43a$export$fe23d09197d672af = 140;
const $70944e0e10e6c43a$export$69d919be6a7605d6 = (0, $97475243e21a0995$export$73e83bf2b7e02467).medium.height;
const $70944e0e10e6c43a$export$edd5e498781c14ea = 100;
const $70944e0e10e6c43a$export$1104136229124ac4 = 12;
const $70944e0e10e6c43a$export$fb049acdf78c8ac0 = $70944e0e10e6c43a$export$ac1e2850638b95a7 + $70944e0e10e6c43a$export$edd5e498781c14ea + $70944e0e10e6c43a$export$1104136229124ac4;
const $70944e0e10e6c43a$export$7f34fdcc42257ed6 = $70944e0e10e6c43a$export$a9ede386157d607a - $70944e0e10e6c43a$export$edd5e498781c14ea - $70944e0e10e6c43a$export$1104136229124ac4;
const $70944e0e10e6c43a$export$8dc567715ae55238 = $70944e0e10e6c43a$export$fe23d09197d672af + $70944e0e10e6c43a$export$69d919be6a7605d6 + $70944e0e10e6c43a$export$ac1e2850638b95a7;
const $70944e0e10e6c43a$export$82285e32b1314e7f = (panelW, panelH)=>({
        x: Math.max(0, Math.round((panelW - $70944e0e10e6c43a$export$2910b725986ae787) / 2)),
        y: Math.max(8, Math.round((panelH - $70944e0e10e6c43a$export$8dc567715ae55238) / 2))
    });
const $70944e0e10e6c43a$export$bbeb423b0346ff89 = (value, max)=>{
    if (!Number.isFinite(value)) return 1;
    return Math.max(1, Math.min(Math.floor(value), Math.max(1, Math.floor(max))));
};
const $70944e0e10e6c43a$export$83caf5bd22dcb16c = (quantity, max, trackW = $70944e0e10e6c43a$export$35b0ea25dd9324cb)=>{
    if (max <= 1) return 0;
    return ($70944e0e10e6c43a$export$bbeb423b0346ff89(quantity, max) - 1) / (max - 1) * trackW;
};
const $70944e0e10e6c43a$export$1e01af2fcd867956 = (offset, max, trackW = $70944e0e10e6c43a$export$35b0ea25dd9324cb)=>{
    if (max <= 1 || trackW <= 0) return 1;
    const ratio = Math.max(0, Math.min(1, offset / trackW));
    return $70944e0e10e6c43a$export$bbeb423b0346ff89(1 + Math.round(ratio * (max - 1)), max);
};
const $70944e0e10e6c43a$export$5bd044db5e0bc461 = (buffer, digit, max)=>{
    if (!/^[0-9]$/.test(digit)) return buffer;
    const next = `${buffer}${digit}`.replace(/^0+(?=\d)/, "");
    return Number(next) > max ? String($70944e0e10e6c43a$export$bbeb423b0346ff89(max, max)) : next;
};
const $70944e0e10e6c43a$export$6fbb95dd774f97a5 = (buffer)=>buffer.slice(0, -1);
const $70944e0e10e6c43a$export$f94dcf61679e1cfc = (buffer, max)=>{
    if (!/^[0-9]+$/.test(buffer)) return undefined;
    const value = Number(buffer);
    return value < 1 ? undefined : $70944e0e10e6c43a$export$bbeb423b0346ff89(value, max);
};
const $70944e0e10e6c43a$export$2c2c55fe8865ab2 = (max)=>Math.max(1, Math.floor(max / 2));



// Where the inventory's hover pill goes.
//
// Hovering a slot names the item; clicking it opens the menu. The pill exists so that looking through
// a pack answers "what is that?" without a context menu springing open under the pointer on its way
// across the grid.
//
// Pixi-free, like crafting_layout.ts beside it: the drawing is three lines of Graphics and the part
// worth guarding is the arithmetic, which has to keep a pill on an edge slot inside the panel.
// Clear air between the pill and the slot it names.
const $ad04bdb603662f3e$export$760b8ddd45219997 = 5;
const $ad04bdb603662f3e$export$ada46e7358e1cb98 = 4;
const $ad04bdb603662f3e$export$824d04aee2bc3075 = ({ slotX: slotX, slotY: slotY, slotSize: slotSize, pillW: pillW, pillH: pillH, panelW: panelW })=>{
    // Centred over the slot...
    const centred = slotX + slotSize / 2 - pillW / 2;
    // ...then pulled back inside the panel. A pill on the first or last column would otherwise hang
    // off the side of it, and a long item name makes that the common case rather than the rare one.
    const maxX = Math.max($ad04bdb603662f3e$export$ada46e7358e1cb98, panelW - pillW - $ad04bdb603662f3e$export$ada46e7358e1cb98);
    const x = Math.round(Math.max($ad04bdb603662f3e$export$ada46e7358e1cb98, Math.min(maxX, centred)));
    // Above the slot, unless that is off the top of the panel -- the top row is where this bites.
    const y = Math.round(Math.max($ad04bdb603662f3e$export$ada46e7358e1cb98, slotY - pillH - $ad04bdb603662f3e$export$760b8ddd45219997));
    return {
        x: x,
        y: y
    };
};



parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
class $d37c2dc6a7897ec7$export$35c1754b36550cfd {
    constructor(interaction, layer, makeGhost, select, hideDetails, isWorldDrop = ()=>false){
        this.interaction = interaction;
        this.layer = layer;
        this.makeGhost = makeGhost;
        this.select = select;
        this.hideDetails = hideDetails;
        this.isWorldDrop = isWorldDrop;
        this.slots = [];
        this.sections = [];
        this.registerSection = (node, bounds, section, highlight)=>{
            this.sections.push({
                node: node,
                bounds: bounds,
                section: section,
                highlight: highlight,
                highlighted: false
            });
        };
        this.registerTarget = (node, item, section, size, highlight)=>{
            const target = {
                node: node,
                item: item,
                section: section,
                size: size,
                highlight: highlight
            };
            this.slots.push(target);
            return target;
        };
        this.register = (node, item, section, size, highlight)=>{
            const source = this.registerTarget(node, item, section, size, highlight);
            // Empty wells must also consume presses so the panel's background does not drag.
            node.interactive = true;
            if (!node.hitArea) node.hitArea = new (0, $6qzqq.Rectangle)(0, 0, size, size);
            if (!item) return;
            node.cursor = "grab";
            node.on("pointerdown", (event)=>{
                if (this.held || event.data.pointerType !== "touch" && event.data.button > 0) return;
                this.suppressed = undefined;
                this.held = {
                    source: source,
                    pointerId: event.data.pointerId,
                    start: event.data.global.clone(),
                    moved: false
                };
                this.interaction.on("pointermove", this.move);
                this.interaction.on("pointerup", this.release);
                this.interaction.on("pointerupoutside", this.cancelPointer);
                this.interaction.on("pointercancel", this.cancelPointer);
                window.addEventListener("blur", this.cancel);
                event.stopPropagation();
            });
        };
        this.suppressClick = (node)=>this.suppressed === node;
        this.optionFor = (section, slot)=>{
            const source = this.held?.source;
            if (!source || source === slot) return undefined;
            if (slot?.item?.id && source.item?.itemSlotDropOptions?.[slot.item.id]) return source.item.itemSlotDropOptions[slot.item.id];
            if (source.section === section) return undefined;
            return source.item?.itemDropOptions?.[section];
        };
        this.slotAt = (event)=>this.slots.find((slot)=>{
                const at = slot.node.toLocal(event.data.global);
                return slot.node.hitArea?.contains(at.x, at.y);
            });
        this.targetAt = (event)=>{
            const target = this.sections.find((section)=>{
                const at = section.node.toLocal(event.data.global);
                return section.bounds.contains(at.x, at.y);
            });
            return target?.section ?? this.slotAt(event)?.section ?? (this.isWorldDrop(event.data.global) ? "world" : undefined);
        };
        this.move = (event)=>{
            const held = this.held;
            if (!held || held.pointerId !== event.data.pointerId) return;
            if (!held.moved) {
                if (Math.hypot(event.data.global.x - held.start.x, event.data.global.y - held.start.y) < 6) return;
                held.moved = true;
                this.suppressed = held.source.node;
                this.hideDetails();
                held.source.node.alpha = 0.4;
                held.source.node.cursor = "grabbing";
                this.ghost = this.makeGhost(held.source.item, held.source.size);
                this.ghost.alpha = 1;
                this.ghost.interactive = false;
                this.ghost.interactiveChildren = false;
                this.layer.addChild(this.ghost);
            }
            const target = this.targetAt(event);
            const hoveredSlot = this.slotAt(event);
            this.slots.forEach((slot)=>slot.highlight(!!this.optionFor(slot.section, slot) && slot === hoveredSlot));
            this.sections.forEach((section)=>{
                // Area feedback stays steady across wells and gaps, even when only occupied
                // slots can accept the item (same-area replacements or a full ready bar).
                const acceptsDrop = !!this.optionFor(section.section) || this.slots.some((slot)=>slot.section === section.section && !!this.optionFor(section.section, slot));
                this.highlightSection(section, section.section === target && acceptsDrop);
            });
            const at = this.layer.toLocal(event.data.global);
            this.ghost.position.set(at.x - held.source.size / 2, at.y - held.source.size / 2);
        };
        this.release = (event)=>{
            if (!this.held || this.held.pointerId !== event.data.pointerId) return;
            const target = this.targetAt(event);
            const item = this.held.source.item;
            const option = this.held.moved && target ? this.optionFor(target, this.slotAt(event)) : undefined;
            this.cancel();
            if (option) this.select(item, option);
        };
        this.highlightSection = (section, on)=>{
            if (section.highlighted === on) return;
            section.highlighted = on;
            section.highlight(on);
        };
        this.cancelPointer = (event)=>{
            if (this.held?.pointerId === event.data.pointerId) this.cancel();
        };
        this.cancel = ()=>{
            if (this.held) {
                this.held.source.node.alpha = 1;
                this.held.source.node.cursor = "grab";
            }
            this.held = undefined;
            this.slots.forEach((slot)=>slot.highlight(false));
            this.sections.forEach((section)=>this.highlightSection(section, false));
            this.ghost?.parent?.removeChild(this.ghost);
            this.ghost?.destroy({
                children: true
            });
            this.ghost = undefined;
            this.interaction.off("pointermove", this.move);
            this.interaction.off("pointerup", this.release);
            this.interaction.off("pointerupoutside", this.cancelPointer);
            this.interaction.off("pointercancel", this.cancelPointer);
            window.removeEventListener("blur", this.cancel);
        };
    }
    get dragging() {
        return !!this.held?.moved;
    }
}


// -----------------------------------------------------------------------------
// Palette -- the camp's own materials.
//
// These screens used to be a cool slate "dark theme" (navy plate, blue-grey rims, a blue readied
// ring, a green HP bar), which was fine on its own and wrong next to everything around it: the HUD,
// the wave dial, the build board and the command wheel are all cut timber, forged bronze and
// firelight, so opening your pack swapped one game's furniture for another's. The panel is now a
// timber board (build_board.ts), item slots are sockets carved into it, and every accent is a warm
// one: gold for "this is the one", bronze for equipped, ember for readied.
// -----------------------------------------------------------------------------
const $98fc6d407c9f2a1f$var$COLOR = {
    panelFill: 0x16110c,
    panelFillTop: 0x241a11,
    panelBorder: 0x4a3c2c,
    gold: 0xf0b453,
    equipped: 0xd9b483,
    readied: 0xf28c4e,
    hp: 0xc9523b,
    slotFill: 0x271d14,
    slotEmpty: 0x120d09,
    slotInset: 0x0a0705,
    slotBorder: 0x3a2f23,
    slotHover: 0xffd166,
    text: 0xffedc7,
    textMuted: 0xae9a7a,
    title: 0xf3d9a4,
    label: 0xd9b483,
    shortfall: 0xec7a5c,
    cardFill: 0x18120d,
    cardBorder: 0x8e7b58
};
// ---- the board's surfaces ----------------------------------------------------
//
// Three shapes do almost all the drawing below, so the panel cannot drift into using three slightly
// different versions of each.
// Clipped corners rather than rounded ones, as on the build board: a radius is a desktop dialog, a
// chamfer is a sawn plank.
const $98fc6d407c9f2a1f$var$PANEL_CHAMFER = 9;
const $98fc6d407c9f2a1f$var$SOCKET_CHAMFER = 3;
const $98fc6d407c9f2a1f$var$PLATE_CHAMFER = 4;
/**
 * A socket carved into the board: the dark cut, a face set slightly into it, and a hairline of light
 * along the cut's lower lip -- light from above catches the far edge of a hole, which is what makes it
 * read as recessed rather than painted on.
 */ const $98fc6d407c9f2a1f$var$drawSocket = (g, x, y, w, h, face = $98fc6d407c9f2a1f$var$COLOR.slotFill, c = $98fc6d407c9f2a1f$var$SOCKET_CHAMFER)=>{
    g.lineStyle(0);
    g.beginFill($98fc6d407c9f2a1f$var$COLOR.slotInset, 1);
    (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x, y, w, h, c);
    g.endFill();
    g.beginFill(face, 1);
    (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x + 1.5, y + 2, w - 3, h - 3.5, Math.max(1, c - 1));
    g.endFill();
    g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.1);
    g.moveTo(x + c, y + h - 0.5).lineTo(x + w - c, y + h - 0.5);
    g.lineStyle(0);
};
/** A plate laid ON the board -- a card, a menu, a label: dropped shadow, dark face, bronze rim, lit top. */ const $98fc6d407c9f2a1f$var$drawPlate = (g, x, y, w, h, { face: face = $98fc6d407c9f2a1f$var$COLOR.cardFill, faceAlpha: faceAlpha = 0.97, rim: rim = $98fc6d407c9f2a1f$var$COLOR.cardBorder, rimAlpha: rimAlpha = 0.85, c: c = $98fc6d407c9f2a1f$var$PLATE_CHAMFER, shadow: shadow = true } = {})=>{
    g.lineStyle(0);
    if (shadow) {
        g.beginFill(0x000000, 0.38);
        (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x, y + 2, w, h, c);
        g.endFill();
    }
    g.lineStyle({
        width: 1,
        color: rim,
        alpha: rimAlpha,
        join: (0, $gwPoJ.LINE_JOIN).MITER
    });
    g.beginFill(face, faceAlpha);
    (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x, y, w, h, c);
    g.endFill();
    g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.12);
    g.moveTo(x + c, y + 1.5).lineTo(x + w - c, y + 1.5);
    g.lineStyle(0);
};
/** A glyph from the command wheel's set (command_wheel_icons.ts), at `size`, centred on (x, y). */ const $98fc6d407c9f2a1f$var$glyph = (icon, x, y, size, color)=>{
    const g = new (0, $gwPoJ.Graphics)();
    (0, $ec5c35dbffc1f325$export$8674a23a9be99236)(g, icon);
    g.scale.set(size / (0, $ec5c35dbffc1f325$export$2bd980d3c871717d));
    g.position.set(x, y);
    g.tint = color;
    return g;
};
// Item art comes at the size it was drawn: a spear is 51px long, a dagger 11, a shard 12. At the one
// shared scale every slot used to draw them at, a dagger in a 32px slot was a six-pixel speck and
// the pack read as rows of empty sockets. The item atlas crops each icon to its art, so the frame's
// own bounds are the art's -- fit the longest side to most of the slot, without blowing small pixel
// art up past the point it turns to mush.
const $98fc6d407c9f2a1f$var$ICON_FILL = 0.8;
const $98fc6d407c9f2a1f$var$ICON_MAX_SCALE = 1.5;
const $98fc6d407c9f2a1f$var$fitItemIcon = (sprite, x, y, size)=>{
    const bounds = sprite.getLocalBounds();
    const longest = Math.max(bounds.width, bounds.height);
    if (longest > 0 && isFinite(longest)) {
        // How many local units one texture pixel already takes; the cap is on the art's final scale.
        const base = Math.abs(sprite.sprite?.scale?.x ?? 1) || 1;
        sprite.scale.set(Math.min(size * $98fc6d407c9f2a1f$var$ICON_FILL / longest, $98fc6d407c9f2a1f$var$ICON_MAX_SCALE / base));
    }
    (0, $d634a66159f23623$export$db3e35bb56748094)(sprite, x, y, size);
};
// Letterspaced caps for titles and section labels: the dial's and the wheel's banner voice.
const $98fc6d407c9f2a1f$var$caps = (value, role, color, spacing)=>{
    const t = $98fc6d407c9f2a1f$var$text(value.toUpperCase(), role, color, true);
    t.style.letterSpacing = spacing;
    return t;
};
// Fallback content dimensions for messages outside the docked inventory renderer.
const $98fc6d407c9f2a1f$var$PANEL_W = 780;
const $98fc6d407c9f2a1f$var$PANEL_H = 442;
// Right-docked panel used for the inventory/crafting/trade screens: a tall, narrow panel pinned to
// the right so the player and the world stay visible on the left. DOCK_X is the on-screen left
// offset applied to the whole content container. The width is fitted to the 8-column grid
// (8*32 + 7*4 = 284) plus even 16px margins, and DOCK_X leaves room for trade's close button, which
// hangs off the panel's top-right corner.
const $98fc6d407c9f2a1f$var$DOCK_SLOT = 32 // compact slot size for the narrow docked grids
;
// The header row's buttons: their top and height, and the right margin they end at. Inventory and
// crafting seat their close disc at the end of this row (see headerCloseRoom).
const $98fc6d407c9f2a1f$var$HEADER_BUTTON_Y = 11;
const $98fc6d407c9f2a1f$var$HEADER_BUTTON_H = 24;
const $98fc6d407c9f2a1f$var$HEADER_RIGHT_MARGIN = 16;
const $98fc6d407c9f2a1f$var$DOCK_MARGIN = 16;
const $98fc6d407c9f2a1f$var$DOCK_W = $98fc6d407c9f2a1f$var$DOCK_MARGIN * 2 + 8 * $98fc6d407c9f2a1f$var$DOCK_SLOT + 28 // 316
;
const $98fc6d407c9f2a1f$var$MOBILE_PANEL_W = $98fc6d407c9f2a1f$var$DOCK_W * 2;
const $98fc6d407c9f2a1f$var$DOCK_H = 430;
const $98fc6d407c9f2a1f$var$DOCK_X = 452;
const $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? 1.331 : 1;
// Grow toward the world while keeping the panel's right edge in the same place.
const $98fc6d407c9f2a1f$var$SCALED_DOCK_X = $98fc6d407c9f2a1f$var$DOCK_X + $98fc6d407c9f2a1f$var$DOCK_W * (1 - $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE);
// The panel background is drawn inset by this much inside the content box, so this is where its
// visible corners are (see drawPanelBg).
const $98fc6d407c9f2a1f$var$PANEL_INSET = 4;
// Slack assemble() leaves under the content when it sizes the panel to fit. A screen that lays itself
// out against a height budget (crafting) has to subtract it to land inside DOCK_H.
const $98fc6d407c9f2a1f$var$PANEL_BOTTOM_PAD = 14;
const $98fc6d407c9f2a1f$var$SLOT = 44;
const $98fc6d407c9f2a1f$var$GAP = 6;
// The clues on a recipe row's Craft button. Their note goes ABOVE the row: beside the button it lay
// across the row's own name, hiding what the button makes.
const $98fc6d407c9f2a1f$var$RECIPE_CLUES = [
    "ember-recipe",
    "ember-planks-recipe",
    "ember-wall-recipe",
    "ember-roof-recipe"
];
// Every clue this panel owns, so a rebuild or a close can retract the lot in one go.
const $98fc6d407c9f2a1f$var$PANEL_CLUES = [
    "ember-planks-recipe",
    "ember-wall-recipe",
    "ember-wall-pack",
    "ember-wall-use",
    "ember-roof-recipe",
    "ember-roof-pack",
    "ember-roof-use",
    "ember-crafting",
    "ember-recipe",
    "ember-pack",
    "ember-use",
    "ember-close",
    "ember-wood-pack",
    "ember-wood-use"
];
// The recipe and the item the clues name. `title` is capitalize(itemTypeMeta.type) server-side and
// a recipe's `name` is the raw item type, so both compare case-insensitively against this.
const $98fc6d407c9f2a1f$var$CLUED_ITEM = "campfire";
// The inventory title bar's action that opens the crafting screen.
const $98fc6d407c9f2a1f$var$CRAFT_ACTION = /craft/i;
// The hover-menu option that puts a carried campfire on the ground (inventory.ts pushes "Use" for
// anything `useable`, which is how a campfire is placed -- it is not buildable).
const $98fc6d407c9f2a1f$var$READY_OPTION = /^ready$/i;
// The hover name pill. Small, quiet, and gone the moment the pointer leaves: its whole job is to
// answer "what is that?" without opening anything.
const $98fc6d407c9f2a1f$var$PILL_PAD_X = 7;
const $98fc6d407c9f2a1f$var$PILL_PAD_Y = 3;
const $98fc6d407c9f2a1f$var$PILL_FILL = 0x1b1512;
const $98fc6d407c9f2a1f$var$PILL_BORDER = 0x8e7b58;
const $98fc6d407c9f2a1f$var$PILL_TEXT = 0xffedc7;
const $98fc6d407c9f2a1f$var$text = (value, role, color, bold = false)=>{
    const renderer = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role(role).bold(bold).color(color);
    return renderer.render(value);
};
const $98fc6d407c9f2a1f$var$prettify = (value)=>(value || "").replace(/[-_]/g, " ").replace(/\b\w/g, (c)=>c.toUpperCase());
// Average width of one character of a recipe's ingredient line, used to work out how many chips fit
// between the icon well and the Craft button.
//
// MEASURED once off a real Text rather than guessed at, because the ingredient line is the narrowest
// thing on the panel and a per-character estimate that is wrong by 10% is the difference between a
// three-ingredient recipe showing its blocker and showing "+2". Cached module-wide: the probe costs a
// text bake, and every card asks the same question.
//
// WRAPPED, and with a fallback width, because this is a cosmetic measurement on the path that draws
// the whole panel. The first cut disposed the probe twice -- disposeTextTextures already destroys a
// Text with its textures, and the `probe.destroy()` after it threw on the destroyed object. That
// throw was inside the first recipe card, so it took `createCraftingContent` with it and the crafting
// screen simply never appeared: pressing `c` did nothing at all. Nothing about fitting a line of text
// is worth a dead screen.
// The scrollbar beside a recipe list that does not fit, and how far a press may wander before it is
// a scroll rather than a tap on the card underneath.
//
// 10px, not the 4 this started at: at four it read as a decoration and could not be gripped, which is
// the one job a scrollbar has beyond saying there is more. The thumb never shrinks below a thumb's
// worth of height either, however long the list gets.
const $98fc6d407c9f2a1f$var$SCROLLBAR_W = 10;
// How far the search field's text starts in from the box's left edge, in box heights: clear of the
// magnifier drawn there.
const $98fc6d407c9f2a1f$var$SEARCH_GLYPH_INSET = 0.75;
// The panel's entrance: a slide in off its dock on opening, and a shorter, shallower one on turning
// from one of its screens to another (pack -> crafting). Short enough never to stand between a
// player and their pack.
const $98fc6d407c9f2a1f$var$ENTRANCE_MS = 170;
const $98fc6d407c9f2a1f$var$ENTRANCE_SLIDE = 16;
const $98fc6d407c9f2a1f$var$TURN_MS = 130;
const $98fc6d407c9f2a1f$var$TURN_FROM_ALPHA = 0.35;
const $98fc6d407c9f2a1f$var$TURN_SLIDE = 6;
const $98fc6d407c9f2a1f$var$SCROLLBAR_MIN_THUMB = 24;
const $98fc6d407c9f2a1f$var$DRAG_SLOP = 4;
const $98fc6d407c9f2a1f$var$INGREDIENT_CHAR_PROBE = "0/0 shard-metal";
const $98fc6d407c9f2a1f$var$INGREDIENT_CHAR_FALLBACK = 5;
let $98fc6d407c9f2a1f$var$ingredientCharW = 0;
const $98fc6d407c9f2a1f$export$ad760941f0ea5621 = ()=>{
    $98fc6d407c9f2a1f$var$ingredientCharW = 0;
};
const $98fc6d407c9f2a1f$export$a6613d83a13315d7 = ()=>{
    if ($98fc6d407c9f2a1f$var$ingredientCharW > 0) return $98fc6d407c9f2a1f$var$ingredientCharW;
    $98fc6d407c9f2a1f$var$ingredientCharW = $98fc6d407c9f2a1f$var$INGREDIENT_CHAR_FALLBACK;
    try {
        const probe = $98fc6d407c9f2a1f$var$text($98fc6d407c9f2a1f$var$INGREDIENT_CHAR_PROBE, "compactCaption", $98fc6d407c9f2a1f$var$COLOR.textMuted);
        const measured = probe.width / $98fc6d407c9f2a1f$var$INGREDIENT_CHAR_PROBE.length;
        // Destroys the Text and its own canvas-backed texture. Do NOT destroy() it again after this.
        (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(probe);
        if (measured > 0) $98fc6d407c9f2a1f$var$ingredientCharW = measured;
    } catch (e) {
    // Keep the fallback and draw the line slightly conservatively.
    }
    return $98fc6d407c9f2a1f$var$ingredientCharW;
};
const $98fc6d407c9f2a1f$var$asMeta = (node)=>typeof node === "string" ? {
        text: node
    } : node;
const $98fc6d407c9f2a1f$export$bba5840b442d1a1 = (nodes)=>{
    let found = false;
    (nodes || []).forEach((node)=>{
        if (node?.context?.craftingReveal) {
            delete node.context.craftingReveal;
            found = true;
        }
        if ($98fc6d407c9f2a1f$export$bba5840b442d1a1(node?.children)) found = true;
    });
    return found;
};
const $98fc6d407c9f2a1f$export$bc3be2b9790d3f4d = (message)=>(message.dynamicText || []).some((n)=>$98fc6d407c9f2a1f$var$asMeta(n)?.text === "Craftable items");
// Does any node in this subtree carry exactly this text? Used to pick the recipe browser out of the
// payload, by the "Craft" button or the "None" placeholder it is sure to contain.
const $98fc6d407c9f2a1f$var$hasDescendantText = (node, value)=>{
    if (!node) return false;
    if (node.text === value) return true;
    return (node.children || []).some((c)=>$98fc6d407c9f2a1f$var$hasDescendantText(c, value));
};
const $98fc6d407c9f2a1f$export$1a9ed648cfadc85e = (message)=>(message.dynamicText || []).some((n)=>{
        const m = $98fc6d407c9f2a1f$var$asMeta(n);
        return m?.type === "sprite" && m?.spriteId === "action-trade.png";
    });
// -----------------------------------------------------------------------------
// The floating item detail / action card. Shown on hover (or tap on mobile); stays
// open while the pointer is over the originating slot OR the card itself, so its
// action buttons are reachable. Mirrors the classic ItemDetail's Fader behavior.
// -----------------------------------------------------------------------------
class $98fc6d407c9f2a1f$var$ModernDetailCard extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.keepOpen = ()=>{
            // Cancelling a fade must not run its hidden callback, which retracts the Ready clue.
            this.fader?.stop(true);
            this.visible = true;
            this.alpha = 1.0;
        }, // With a hitArea on this container, Pixi tracks the child buttons separately and can report
        // that the card itself was exited as the pointer enters a button. Keep the menu alive for those
        // internal transitions; a button's own mouseout performs the same boundary check on the way out.
        this.hideIfPointerOutside = (event)=>this.scheduleHide(event), this.keepButtonHover = (button)=>{
            button.on("mouseover", this.keepOpen);
            button.on("mouseout", this.hideIfPointerOutside);
        }, this.hideImmediately = ()=>{
            this.fader?.stop(true);
            this.visible = false;
            this.onHidden?.();
        }, this.scheduleHide = (event)=>{
            // Slot mouseout fires as the pointer travels from the item to this floating menu. Test the
            // destination from that event before starting the grace timer; the menu's hit area excludes
            // interactive child buttons in Pixi's hover tracking, so its own mouseover is not sufficient.
            if (event?.data?.global) {
                const point = this.toLocal(event.data.global);
                if (this.hitArea?.contains(point.x, point.y)) {
                    this.keepOpen();
                    return;
                }
            }
            // Stop any in-flight fade first so overlapping faders can't stack and yank the card
            // invisible mid-interaction (that race made action buttons occasionally un-clickable).
            if (this.fader) this.fader.stop(true);
            // Gentle ~250ms grace so the pointer has time to travel from the slot onto the card.
            this.fader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                fadeInterval: 16,
                fadeAlphaDecrement: 0.06,
                releaseCallback: ()=>{
                    this.alpha = 1.0;
                    this.visible = false;
                    if (this.onHidden) this.onHidden();
                }
            });
            this.fader.update();
        }, this.show = (item, onSelect, anchorX, anchorY, anchorSize = $98fc6d407c9f2a1f$var$SLOT, panelW = $98fc6d407c9f2a1f$var$PANEL_W, panelH = $98fc6d407c9f2a1f$var$PANEL_H)=>{
            if (this.fader) this.fader.stop(true);
            [
                ...this.surface.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.surface.removeChildren();
            this.surface.clear();
            const padX = 12;
            const padY = 10;
            const lineGap = 4;
            let y = padY;
            let contentW = 150;
            const accent = item.active ? item.activeColor ?? $98fc6d407c9f2a1f$var$COLOR.equipped : $98fc6d407c9f2a1f$var$COLOR.gold;
            const title = $98fc6d407c9f2a1f$var$text(item.title || "Item", "label", $98fc6d407c9f2a1f$var$COLOR.title, true);
            title.x = padX;
            title.y = y;
            this.surface.addChild(title);
            contentW = Math.max(contentW, title.width);
            y += title.height + lineGap + 2;
            // CONDITION, if this thing wears. A labelled gauge rather than the muted "38% durable
            // (worn)" sentence this used to be the last line of: the number and the word are both worth
            // having, but what a player actually wants off this card is how much is LEFT, and a length
            // answers that before the text has been read. The slot's own gauge is the same object at
            // 4px (gui/durability.ts), so the card is a bigger look at a thing already seen, not a
            // second notation for it.
            let gauge;
            if (item.condition !== undefined) {
                const pct = item.condition;
                const label = $98fc6d407c9f2a1f$var$text("CONDITION", "overline", $98fc6d407c9f2a1f$var$COLOR.textMuted);
                label.x = padX;
                label.y = y + 1;
                this.surface.addChild(label);
                // Rounded UP off zero: an axe reported as "0%" is one a player will believe is broken
                // already, and it still has a swing in it.
                const figure = $98fc6d407c9f2a1f$var$text(`${Math.max(1, Math.round(pct * 100))}% \xb7 ${$98fc6d407c9f2a1f$var$prettify((0, $d3527b517d667178$export$4cfe0674a42ef84e).item.durability.conditionForPct(pct))}`, "compactCaption", (0, $90f59133f949281e$export$1ab1c54f03f55cee)(pct), true);
                figure.y = y;
                this.surface.addChild(figure);
                // The row has to fit both ends with a gap between them, whatever the title measured.
                contentW = Math.max(contentW, label.width + 14 + figure.width);
                y += Math.max(label.height, figure.height) + 3;
                // Placed once the card's final width is known, below -- a gauge is the one thing here
                // that must span the whole inner width, and a right-aligned figure needs the same
                // answer.
                gauge = {
                    y: y,
                    figure: figure
                };
                y += (0, $90f59133f949281e$export$2563b908070a066f) + lineGap + 3;
            }
            (item.hoverText || []).forEach((line)=>{
                const t = $98fc6d407c9f2a1f$var$text(line, "compactLabel", $98fc6d407c9f2a1f$var$COLOR.textMuted);
                t.x = padX;
                t.y = y;
                this.surface.addChild(t);
                contentW = Math.max(contentW, t.width);
                y += t.height + lineGap;
            });
            const options = item.options || [];
            if (options.length > 0) y += 4;
            const btnH = 26;
            const btnGap = 5;
            const optionButtons = [];
            options.forEach((option)=>{
                const btnW = ()=>contentW // resolved after final width known; recomputed below
                ;
                const button = $98fc6d407c9f2a1f$var$makeButton(option.title, btnW(), btnH, ()=>{
                    onSelect({
                        ...option
                    });
                    this.hideNow();
                });
                this.keepButtonHover(button);
                button.x = padX;
                button.y = y;
                this.surface.addChild(button);
                optionButtons.push({
                    option: option,
                    button: button
                });
                y += btnH + btnGap;
            });
            const cardW = contentW + padX * 2;
            const cardH = y + padY - (options.length > 0 ? btnGap : 0);
            // Re-stretch buttons to the full card inner width now that it's known.
            this.surface.children.forEach((child)=>{
                if (child instanceof (0, $ead1577967896e68$export$d714cb42a300e44f)) child.resize(cardW - padX * 2, btnH);
            });
            // Backdrop: a plate laid over the pack, with the item's accent run along its top edge.
            $98fc6d407c9f2a1f$var$drawPlate(this.surface, 0, 0, cardW, cardH, {
                c: 5
            });
            this.surface.lineStyle(2, accent, 0.9);
            this.surface.moveTo(5, 1).lineTo(cardW - 5, 1);
            this.surface.lineStyle(0);
            // The condition gauge, which could not be drawn until the card's width was known -- and has
            // to be issued AFTER the backdrop, because it shares the backdrop's Graphics and that is a
            // single draw list rather than a stack of layers. (The text and buttons are children, so
            // they are above all of it whatever order it was issued in.)
            if (gauge) {
                gauge.figure.x = cardW - padX - gauge.figure.width;
                (0, $90f59133f949281e$export$b3ec34e617a827fb)(this.surface, item.condition, padX, gauge.y, cardW - padX * 2);
            }
            // Keep the drawn backdrop behind the text/buttons.
            this.surface.setChildIndex(this.surface.children[0], 0);
            // A full-card hit area means hovering anywhere on the card (not just a button) keeps it
            // alive — moving the pointer from the slot onto the card immediately cancels the fade.
            this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, cardW, cardH);
            // Anchor as a dropdown directly beneath the slot, overlapping it by 2px so there is NO dead
            // gap for the pointer to cross on its way to the menu (crossing empty space is what let the
            // menu fade out before you could click it). Flip above / clamp to stay on-panel.
            let x = anchorX;
            if (x + cardW > panelW - 8) x = panelW - 8 - cardW;
            if (x < 8) x = 8;
            let cy = anchorY + anchorSize - 2;
            if (cy + cardH > panelH - 6) cy = anchorY - cardH + 2 // not enough room below — flip above the slot
            ;
            // Final guarantee: keep the WHOLE menu inside the panel so nothing is ever clipped — even a
            // tall menu near an edge. This pins the bottom edge in-bounds (it may overlap the icon), so
            // every option stays visible and clickable rather than running off the panel.
            cy = Math.max(8, Math.min(cy, panelH - 6 - cardH));
            this.x = x;
            this.y = cy;
            this.visible = true;
            this.alpha = 1.0;
            // Report the buttons last, once the card's own position is settled: a clue has to be told
            // where a button is in the PARENT's space, and until now neither the card's x/y nor the
            // buttons' final width were known.
            if (this.optionAnchors && optionButtons.length > 0) this.optionAnchors(item, optionButtons.map(({ option: option, button: button })=>({
                    option: option,
                    rect: new (0, $6qzqq.Rectangle)(this.x + button.x, this.y + button.y, cardW - padX * 2, btnH)
                })));
        }, this.hideNow = ()=>{
            this.visible = false;
            this.alpha = 1.0;
            if (this.onHidden) this.onHidden();
        };
        this.surface = new (0, $gwPoJ.Graphics)();
        this.addChild(this.surface);
        this.visible = false;
        this.interactive = true;
        this.on("mouseover", this.keepOpen);
        this.on("mouseout", this.hideIfPointerOutside);
    }
}
// Compatibility adapter for existing measured inventory layouts. State and interaction belong
// to UiButton; new controls can use its standard size tiers directly.
//
// Every button in these screens is the camp's cut-timber plate. `primary` is the one action a row or
// panel is FOR -- Craft, the transfer's confirm -- and wears a gold rim and bold caption so the eye
// lands on it first; everything else is a quiet bronze-rimmed plank.
const $98fc6d407c9f2a1f$var$makeButton = (label, width, height, onClick, style)=>(0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
        label: label,
        width: width,
        height: height,
        onClick: onClick,
        size: height <= (0, $97475243e21a0995$export$73e83bf2b7e02467).extraSmall.height ? "extraSmall" : height <= (0, $97475243e21a0995$export$73e83bf2b7e02467).small.height ? "small" : "medium",
        theme: "ember",
        shape: "chamfer",
        fill: style?.accent,
        variant: style?.primary ? "primary" : "secondary",
        accent: style?.primary ? $98fc6d407c9f2a1f$var$COLOR.slotHover : undefined,
        textColor: style?.primary ? $98fc6d407c9f2a1f$var$COLOR.text : $98fc6d407c9f2a1f$var$COLOR.textMuted,
        bold: style?.primary
    });
class $98fc6d407c9f2a1f$var$QuantityPicker extends (0, $8t5Gy.Container) {
    constructor(props){
        super(), // Digits typed since the picker opened. Empty means "not typing", and the readout shows `value`.
        // Kept as a string, not a number, because a half-typed "1" on the way to "12" must read as "1"
        // without the slider snapping to 1 and back.
        this.buffer = "", this.dragging = false, this.released = false, this.panel = new (0, $8t5Gy.Container)(), this.slider = new (0, $gwPoJ.Graphics)(), this.readout = new (0, $gwPoJ.Graphics)(), this.trackHit = new (0, $gwPoJ.Graphics)(), // Sits over the whole panel for the duration of a drag so every move lands on ONE object, rather
        // than being swallowed by whatever the pointer happens to be over. Draws nothing.
        this.capture = new (0, $gwPoJ.Graphics)(), // A dim wash over the panel: says "answer this first", and blocks the item slots underneath so a
        // stray hover can't reopen the menu the picker was launched from.
        this.buildScrim = ()=>{
            const { panelW: panelW, panelH: panelH } = this.props;
            const scrim = new (0, $gwPoJ.Graphics)();
            scrim.beginFill($98fc6d407c9f2a1f$var$COLOR.slotInset, 0.66);
            scrim.drawRect(0, 0, panelW, panelH);
            scrim.endFill();
            scrim.interactive = true;
            this.addChild(scrim);
        }, this.buildPanel = ()=>{
            const { itemTitle: itemTitle, prompt: prompt, panelW: panelW, panelH: panelH } = this.props;
            const origin = (0, $70944e0e10e6c43a$export$82285e32b1314e7f)(panelW, panelH);
            this.panel.x = origin.x;
            this.panel.y = origin.y;
            const chrome = new (0, $gwPoJ.Graphics)();
            $98fc6d407c9f2a1f$var$drawPlate(chrome, 0, 0, (0, $70944e0e10e6c43a$export$2910b725986ae787), (0, $70944e0e10e6c43a$export$8dc567715ae55238), {
                face: $98fc6d407c9f2a1f$var$COLOR.panelFill,
                faceAlpha: 0.99,
                rim: $98fc6d407c9f2a1f$var$COLOR.gold,
                rimAlpha: 0.9,
                c: 7
            });
            this.panel.addChild(chrome);
            const title = $98fc6d407c9f2a1f$var$text(`${prompt.verb} ${itemTitle}`, "caption", $98fc6d407c9f2a1f$var$COLOR.title, true);
            title.x = (0, $70944e0e10e6c43a$export$ac1e2850638b95a7);
            title.y = (0, $70944e0e10e6c43a$export$9af9114e89ff83a2);
            this.panel.addChild(title);
            if ((this.props.per ?? 1) > 1) {
                // Right-aligned against the margin in sync(), since its width changes with the amount.
                this.yieldText = $98fc6d407c9f2a1f$var$text("", "compactCaption", $98fc6d407c9f2a1f$var$COLOR.textMuted);
                this.yieldText.y = (0, $70944e0e10e6c43a$export$9af9114e89ff83a2) + (title.height - this.yieldText.height) / 2;
                this.panel.addChild(this.yieldText);
            }
            // Readout row: the boxed amount, with "/ max" alongside. Centered as one group, so the box
            // stays put no matter how many digits the number grows to.
            const ofMax = $98fc6d407c9f2a1f$var$text(`/ ${this.max}`, "compactBody", $98fc6d407c9f2a1f$var$COLOR.textMuted);
            const groupW = (0, $70944e0e10e6c43a$export$3e922b6dc32741b1) + (0, $70944e0e10e6c43a$export$6a9dffc2d456b0a3) + ofMax.width;
            const boxX = Math.round(((0, $70944e0e10e6c43a$export$2910b725986ae787) - groupW) / 2);
            this.readout.x = boxX;
            this.readout.y = (0, $70944e0e10e6c43a$export$da8ec1e8cb867d79);
            this.readout.interactive = true;
            this.readout.cursor = "text";
            this.readout.hitArea = new (0, $6qzqq.Rectangle)(0, 0, (0, $70944e0e10e6c43a$export$3e922b6dc32741b1), (0, $70944e0e10e6c43a$export$7d52ac13ac82d711));
            // Clicking the box means "let me retype this": empty the buffer and wait for digits.
            this.readout.on("pointerdown", ()=>{
                this.buffer = "";
                this.sync();
            });
            this.panel.addChild(this.readout);
            this.amountText = $98fc6d407c9f2a1f$var$text("", "title", $98fc6d407c9f2a1f$var$COLOR.text, true);
            this.panel.addChild(this.amountText);
            ofMax.x = boxX + (0, $70944e0e10e6c43a$export$3e922b6dc32741b1) + (0, $70944e0e10e6c43a$export$6a9dffc2d456b0a3);
            ofMax.y = (0, $70944e0e10e6c43a$export$da8ec1e8cb867d79) + ((0, $70944e0e10e6c43a$export$7d52ac13ac82d711) - ofMax.height) / 2 + 1;
            this.panel.addChild(ofMax);
            // Steppers pinned to the margins, slider between them.
            const minus = $98fc6d407c9f2a1f$var$makeButton("-", (0, $70944e0e10e6c43a$export$dcfd15f865104c82), (0, $70944e0e10e6c43a$export$dcfd15f865104c82), ()=>this.step(-1));
            minus.x = (0, $70944e0e10e6c43a$export$ac1e2850638b95a7);
            minus.y = (0, $70944e0e10e6c43a$export$cf30ece78a3cde75);
            this.panel.addChild(minus);
            const plus = $98fc6d407c9f2a1f$var$makeButton("+", (0, $70944e0e10e6c43a$export$dcfd15f865104c82), (0, $70944e0e10e6c43a$export$dcfd15f865104c82), ()=>this.step(1));
            plus.x = (0, $70944e0e10e6c43a$export$2910b725986ae787) - (0, $70944e0e10e6c43a$export$ac1e2850638b95a7) - (0, $70944e0e10e6c43a$export$dcfd15f865104c82);
            plus.y = (0, $70944e0e10e6c43a$export$cf30ece78a3cde75);
            this.panel.addChild(plus);
            this.panel.addChild(this.slider);
            this.trackHit.interactive = true;
            this.trackHit.cursor = "pointer";
            // Taller than the track and wider by a handle radius at each end, so the ends are reachable
            // and the grab doesn't demand pixel accuracy.
            this.trackHit.hitArea = new (0, $6qzqq.Rectangle)((0, $70944e0e10e6c43a$export$df9c782f47875f3d) - (0, $70944e0e10e6c43a$export$fa15a17427b0bc4d), (0, $70944e0e10e6c43a$export$7b47d622867725d1) - 12, (0, $70944e0e10e6c43a$export$35b0ea25dd9324cb) + (0, $70944e0e10e6c43a$export$fa15a17427b0bc4d) * 2, 24);
            this.trackHit.on("pointerdown", this.beginDrag);
            this.trackHit.on("pointerup", this.endDrag);
            this.trackHit.on("pointerupoutside", this.endDrag);
            this.panel.addChild(this.trackHit);
            const chips = [
                {
                    label: "1",
                    amount: ()=>1
                },
                {
                    label: "Half",
                    amount: ()=>(0, $70944e0e10e6c43a$export$2c2c55fe8865ab2)(this.max)
                },
                {
                    label: "All",
                    amount: ()=>this.max
                }
            ];
            chips.forEach((chip, i)=>{
                const button = $98fc6d407c9f2a1f$var$makeButton(chip.label, (0, $70944e0e10e6c43a$export$be057f60597d5793), (0, $70944e0e10e6c43a$export$5102f6b83c315c0c), ()=>this.set(chip.amount()), {});
                button.x = (0, $70944e0e10e6c43a$export$53b190a46f0ad1d8) + i * ((0, $70944e0e10e6c43a$export$be057f60597d5793) + (0, $70944e0e10e6c43a$export$4a74fa73d9fcb37a));
                button.y = (0, $70944e0e10e6c43a$export$a9b2c383cf2ab052);
                this.panel.addChild(button);
            });
            const cancel = $98fc6d407c9f2a1f$var$makeButton("Cancel", (0, $70944e0e10e6c43a$export$edd5e498781c14ea), (0, $70944e0e10e6c43a$export$69d919be6a7605d6), ()=>this.dismissWith(this.props.onCancel));
            cancel.x = (0, $70944e0e10e6c43a$export$ac1e2850638b95a7);
            cancel.y = (0, $70944e0e10e6c43a$export$fe23d09197d672af);
            this.panel.addChild(cancel);
            this.confirmButton = $98fc6d407c9f2a1f$var$makeButton("", (0, $70944e0e10e6c43a$export$7f34fdcc42257ed6), (0, $70944e0e10e6c43a$export$69d919be6a7605d6), this.confirm, {
                primary: true
            });
            this.confirmButton.x = (0, $70944e0e10e6c43a$export$fb049acdf78c8ac0);
            this.confirmButton.y = (0, $70944e0e10e6c43a$export$fe23d09197d672af);
            this.panel.addChild(this.confirmButton);
        }, // ---- state ----------------------------------------------------------
        // The amount as it stands: the typed digits while typing, otherwise the slider's value. Undefined
        // only when the buffer has been emptied out -- a half-typed number with nothing to transfer yet.
        this.committed = ()=>this.buffer === "" ? this.value : (0, $70944e0e10e6c43a$export$f94dcf61679e1cfc)(this.buffer, this.max), this.set = (amount)=>{
            this.value = (0, $70944e0e10e6c43a$export$bbeb423b0346ff89)(amount, this.max);
            this.buffer = "";
            this.sync();
        }, this.step = (delta)=>this.set((this.committed() ?? this.value) + delta), // Redraws only what changes with the amount (readout, handle, confirm label). The chrome, labels
        // and buttons are built once -- a full rebuild on every drag frame would churn a Text texture per
        // pixel of travel.
        this.sync = ()=>{
            const amount = this.committed();
            const typing = this.buffer !== "";
            this.amountText.text = typing ? this.buffer : `${this.value}`;
            this.amountText.x = this.readout.x + ((0, $70944e0e10e6c43a$export$3e922b6dc32741b1) - this.amountText.width) / 2;
            this.amountText.y = (0, $70944e0e10e6c43a$export$da8ec1e8cb867d79) + ((0, $70944e0e10e6c43a$export$7d52ac13ac82d711) - this.amountText.height) / 2;
            this.readout.clear();
            $98fc6d407c9f2a1f$var$drawSocket(this.readout, 0, 0, (0, $70944e0e10e6c43a$export$3e922b6dc32741b1), (0, $70944e0e10e6c43a$export$7d52ac13ac82d711), $98fc6d407c9f2a1f$var$COLOR.slotEmpty, 4);
            if (typing) {
                this.readout.lineStyle({
                    width: 1.5,
                    color: $98fc6d407c9f2a1f$var$COLOR.slotHover,
                    alpha: 1,
                    join: (0, $gwPoJ.LINE_JOIN).MITER
                });
                (0, $658a44ce960354bb$export$99dca9ebbafa6899)(this.readout, 0.75, 0.75, (0, $70944e0e10e6c43a$export$3e922b6dc32741b1) - 1.5, (0, $70944e0e10e6c43a$export$7d52ac13ac82d711) - 1.5, 4);
                this.readout.lineStyle(0);
            }
            if (typing || amount === undefined) {
                // A plain caret rather than a blinking one: a blink needs a timer per open picker, and the
                // gold box edge already says the field has the keyboard.
                this.readout.beginFill($98fc6d407c9f2a1f$var$COLOR.gold, 0.9);
                this.readout.drawRect(this.amountText.x - this.readout.x + this.amountText.width + 2, 6, 2, (0, $70944e0e10e6c43a$export$7d52ac13ac82d711) - 12);
                this.readout.endFill();
            }
            this.drawSlider();
            if (this.yieldText) {
                this.yieldText.text = amount === undefined ? "" : `makes ${amount * (this.props.per ?? 1)}`;
                this.yieldText.x = (0, $70944e0e10e6c43a$export$2910b725986ae787) - (0, $70944e0e10e6c43a$export$ac1e2850638b95a7) - this.yieldText.width;
            }
            const { verb: verb } = this.props.prompt;
            this.confirmButton.setLabel(amount === undefined ? verb : `${verb} ${amount}`);
            this.confirmButton.setEnabled(amount !== undefined);
        }, this.drawSlider = ()=>{
            const g = this.slider;
            const shown = this.committed() ?? this.value;
            const filled = (0, $70944e0e10e6c43a$export$83caf5bd22dcb16c)(shown, this.max);
            const top = (0, $70944e0e10e6c43a$export$7b47d622867725d1) - (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44) / 2;
            g.clear();
            g.beginFill($98fc6d407c9f2a1f$var$COLOR.slotInset, 1);
            g.drawRoundedRect((0, $70944e0e10e6c43a$export$df9c782f47875f3d), top, (0, $70944e0e10e6c43a$export$35b0ea25dd9324cb), (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44), (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44) / 2);
            g.endFill();
            g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.12).moveTo((0, $70944e0e10e6c43a$export$df9c782f47875f3d) + (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44) / 2, top + (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44) + 0.5).lineTo((0, $70944e0e10e6c43a$export$df9c782f47875f3d) + (0, $70944e0e10e6c43a$export$35b0ea25dd9324cb) - (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44) / 2, top + (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44) + 0.5);
            g.lineStyle(0);
            g.beginFill($98fc6d407c9f2a1f$var$COLOR.gold, 0.9);
            g.drawRoundedRect((0, $70944e0e10e6c43a$export$df9c782f47875f3d), top, Math.max((0, $70944e0e10e6c43a$export$4f0a5731cdda4a44), filled), (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44), (0, $70944e0e10e6c43a$export$4f0a5731cdda4a44) / 2);
            g.endFill();
            // A bronze boss with a gold heart while it is held -- the wheel's hub in miniature.
            g.beginFill(0x000000, 0.4).drawCircle((0, $70944e0e10e6c43a$export$df9c782f47875f3d) + filled, (0, $70944e0e10e6c43a$export$7b47d622867725d1) + 1.5, (0, $70944e0e10e6c43a$export$fa15a17427b0bc4d)).endFill();
            g.lineStyle(1.5, (0, $658a44ce960354bb$export$dd27ce85ad53c944), 1);
            g.beginFill(this.dragging ? $98fc6d407c9f2a1f$var$COLOR.slotHover : $98fc6d407c9f2a1f$var$COLOR.text, 1);
            g.drawCircle((0, $70944e0e10e6c43a$export$df9c782f47875f3d) + filled, (0, $70944e0e10e6c43a$export$7b47d622867725d1), (0, $70944e0e10e6c43a$export$fa15a17427b0bc4d));
            g.endFill();
            g.lineStyle(0);
        }, // ---- slider drag ----------------------------------------------------
        this.beginDrag = (event)=>{
            this.dragging = true;
            this.capture.visible = true;
            this.onDragMove(event);
        }, this.onDragMove = (event)=>{
            if (!this.dragging) return;
            const local = event.data.getLocalPosition(this.panel);
            this.set((0, $70944e0e10e6c43a$export$1e01af2fcd867956)(local.x - (0, $70944e0e10e6c43a$export$df9c782f47875f3d), this.max));
        }, this.endDrag = ()=>{
            if (!this.dragging) return;
            this.dragging = false;
            this.capture.visible = false;
            this.drawSlider();
        }, // ---- keyboard -------------------------------------------------------
        // The picker owns the keyboard while it is up: digits would otherwise hit the hotbar, the arrows
        // would walk the player out from under the screen, and Escape would tear the whole screen down
        // rather than backing out of the picker.
        this.attachKeys = ()=>{
            this.props.logic.playerController.enabledKeyboardAction(false);
            this.props.modal?.suspendEscape(true);
            this.props.logic.clientRenderer.keyboard().addListener(this.onKey);
        }, this.detachKeys = ()=>{
            this.props.logic.clientRenderer.keyboard().removeListener(this.onKey);
            this.props.modal?.suspendEscape(false);
            this.props.logic.playerController.enabledKeyboardAction(true);
        }, this.onKey = (key, down)=>{
            if (!down || this.released) return;
            if (/^[0-9]$/.test(key)) {
                this.buffer = (0, $70944e0e10e6c43a$export$5bd044db5e0bc461)(this.buffer, key, this.max);
                const typed = (0, $70944e0e10e6c43a$export$f94dcf61679e1cfc)(this.buffer, this.max);
                if (typed !== undefined) this.value = typed;
                this.sync();
                return;
            }
            if (key === "Backspace" || key === "Delete") {
                this.buffer = (0, $70944e0e10e6c43a$export$6fbb95dd774f97a5)(this.buffer === "" ? `${this.value}` : this.buffer);
                const typed = (0, $70944e0e10e6c43a$export$f94dcf61679e1cfc)(this.buffer, this.max);
                if (typed !== undefined) this.value = typed;
                this.sync();
                return;
            }
            if (key === "Enter") {
                this.confirm();
                return;
            }
            if (key === "Escape" || key === "Esc") {
                this.dismissWith(this.props.onCancel);
                return;
            }
            if (key === "ArrowLeft" || key === "ArrowDown") {
                this.step(key === "ArrowDown" ? -10 : -1);
                return;
            }
            if (key === "ArrowRight" || key === "ArrowUp") this.step(key === "ArrowUp" ? 10 : 1);
        }, // ---- teardown -------------------------------------------------------
        this.confirm = ()=>{
            const amount = this.committed();
            if (amount === undefined) return;
            this.dismissWith(()=>this.props.onConfirm(amount));
        }, this.dismissWith = (then)=>{
            this.dismiss();
            then();
        }, // Idempotent, and safe to call from anywhere the screen can be torn down under us (a re-render
        // after a transfer, the close button, the room changing) -- whatever happens, the keyboard has to
        // go back to the player.
        this.dismiss = ()=>{
            if (this.released) return;
            this.released = true;
            this.endDrag();
            this.detachKeys();
            this.parent?.removeChild(this);
        };
        this.props = props;
        this.max = Math.max(2, Math.floor(props.prompt.max));
        // Half the stack by default: the middle is the one starting point that is a short drag from
        // every answer, and the whole stack is one click away on the All chip.
        this.value = props.initial === undefined ? (0, $70944e0e10e6c43a$export$2c2c55fe8865ab2)(this.max) : (0, $70944e0e10e6c43a$export$bbeb423b0346ff89)(props.initial, this.max);
        this.buildScrim();
        this.buildPanel();
        this.addChild(this.panel);
        this.addChild(this.capture);
        this.capture.interactive = true;
        this.capture.visible = false;
        this.capture.hitArea = new (0, $6qzqq.Rectangle)(0, 0, props.panelW, props.panelH);
        this.capture.on("pointermove", this.onDragMove);
        this.capture.on("pointerup", this.endDrag);
        this.capture.on("pointerupoutside", this.endDrag);
        this.attachKeys();
        this.sync();
    }
}
class $98fc6d407c9f2a1f$export$a2cb772ea0bad012 extends (0, $95fcf006ca17068b$export$97a92ac594e41d5f) {
    constructor(guiManager, logic, message, onClose){
        // Mobile item screens are centered; desktop screens dock to the right. The close button
        // follows the panel's top-right corner within the transparent fullscreen dialog. Every item
        // screen has one: the Items chip toggles the pack too, but it is not always on screen (a
        // chapter can hold the chip row back, and it goes while a held line is read), and a panel
        // with no visible way out is a trap.
        super(guiManager, logic, message, onClose, {
            backgroundAlpha: 0,
            // Inventory and crafting seat the disc at the end of their header row. Hung off the corner, as
            // trade's still is, it sat on the chip row the docked panel hangs under (the MAP or Items
            // chip), which is why those two once hid it altogether.
            closeAnchor: ()=>this.isInventoryOrCrafting() ? {
                    x: this.dockOrigin().x + (this.panelW - $98fc6d407c9f2a1f$var$HEADER_RIGHT_MARGIN - (0, $0d2b5753435eae0a$export$eb43af23fb6f2b4a)()) * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE,
                    y: this.dockOrigin().y + ($98fc6d407c9f2a1f$var$HEADER_BUTTON_Y + $98fc6d407c9f2a1f$var$HEADER_BUTTON_H / 2) * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE
                } : {
                    x: this.dockOrigin().x + (this.panelW - $98fc6d407c9f2a1f$var$PANEL_INSET) * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE,
                    y: this.dockOrigin().y + $98fc6d407c9f2a1f$var$PANEL_INSET * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE
                },
            closeButtonScale: $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE,
            // The disc that hangs off this panel's corner is in the panel's timber, not the slate
            // every other dialog's still wears.
            closeTheme: "ember",
            dragHandle: ()=>({
                    ...this.dockOrigin(),
                    width: this.panelW * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE,
                    height: this.panelH * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE
                }),
            dragBounds: ()=>{
                const viewport = (0, $167efe97b4119a5d$export$b0f20d83cec42115)();
                const origin = this.dockOrigin();
                const left = viewport.left - origin.x - 10 + 6;
                const top = viewport.top - origin.y + 6;
                return {
                    left: left,
                    right: Math.max(left, viewport.right - origin.x - this.panelW * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE - 10 - 24),
                    top: top,
                    bottom: Math.max(top, viewport.bottom - origin.y - this.panelH * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE - 10 - 6)
                };
            },
            onDrag: ()=>this.positionSearchField()
        }), this.modernItemMap = new Map(), // A local redraw asked for while the picker was up, run once it closes (see refreshCrafting).
        this.refreshDeferred = false, this.horizontalPanel = false, this.panelClueAnchors = new Map(), this.panelAssembled = false, // How far down the current group's recipe list we are, and which group that is.
        //
        // Kept on the DIALOG rather than in the drawn tree, because the panel is rebuilt from scratch on
        // every server message -- and the server sends one after every craft. An offset stored anywhere
        // in the content would reset to the top each time a player made something, which is precisely
        // when they are most likely to be half way down a list.
        this.craftingScrollY = 0, this.craftingScrollGroup = "", // Set while a press over the recipe list has turned into a scroll, so the Craft button underneath
        // it does not also fire. Pixi delivers the button's click after the drag ends, so this is checked
        // rather than the event being cancelled.
        this.recipeDragMoved = false, this.recipeMaxScroll = 0, this.scrollTravel = 0, // How the recipe list is narrowed: one category, plus free text over it. Both live on the DIALOG
        // for the same reason the scroll offset does -- the panel is rebuilt on every server message, and
        // the server sends one after every craft, so anything held in the drawn tree would reset itself
        // mid-search.
        this.craftingGroup = (0, $d3bd591c0da8302e$export$50223ad7f5125750), this.craftingQuery = "", this.craftingDropdownOpen = false, // Loaded once per dialog from the server; local redraws keep the current choice.
        this.craftingCraftableOnly = false, this.craftingFilterLoaded = false, // The search box takes the keyboard off the player while it is focused, so it must always be
        // possible to hand it back -- including on a teardown the box never saw coming.
        this.craftingSearchFocused = false, this.glowStart = 0, this.panelOrigin = {
            x: 0,
            y: 0
        }, // Redraw the panel in place, for a change the client made on its own (a scroll) rather than one
        // the server told it about. rebuildSurface is FullScreenModal's own "repaint when you decide to"
        // hook, and does the Text teardown that a naive removeChildren would leak.
        //
        // Held while the quantity picker is up: a rebuild throws away the tree the picker floats in, and
        // a redraw the client asked for itself (a reveal glow finishing, the search box letting go) is
        // not worth losing a half-chosen amount over. It runs when the picker closes.
        this.refreshCrafting = ()=>{
            if (this.quantityPicker) {
                this.refreshDeferred = true;
                return;
            }
            this.rebuildSurface();
        }, this.dockOrigin = ()=>{
            const viewport = (0, $167efe97b4119a5d$export$b0f20d83cec42115)();
            if (this.horizontalPanel) {
                // The fullscreen dialog adds 10px of content padding in both axes.
                const centeredY = (viewport.height - this.panelH * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE) / 2 - 10;
                const belowChipsY = this.guiManager.emberInventoryChip?.visible ? this.guiManager.itemPanelDefaultAnchor(this.panelW * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE).y - viewport.top - 10 - $98fc6d407c9f2a1f$var$PANEL_INSET * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE : centeredY;
                return {
                    x: (viewport.width - this.panelW * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE) / 2 - 10,
                    y: Math.max(centeredY, belowChipsY)
                };
            }
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() && this.isInventoryOrCrafting()) {
                const at = this.guiManager.itemPanelDefaultAnchor((this.panelW - $98fc6d407c9f2a1f$var$PANEL_INSET * 2) * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE);
                return {
                    x: at.x - viewport.left - 10 - $98fc6d407c9f2a1f$var$PANEL_INSET * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE,
                    y: at.y - viewport.top - 10 - $98fc6d407c9f2a1f$var$PANEL_INSET * $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE
                };
            }
            return {
                x: this.dockX - viewport.left,
                y: -viewport.top
            };
        }, this.createContent = ()=>{
            this.itemDrag?.cancel();
            this.itemDrag = undefined;
            // Crafting reuses this modal, so reset the dimensions before choosing each screen's layout.
            this.horizontalPanel = false;
            this.panelW = $98fc6d407c9f2a1f$var$DOCK_W;
            this.panelH = $98fc6d407c9f2a1f$var$DOCK_H / $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE;
            this.dockX = $98fc6d407c9f2a1f$var$SCALED_DOCK_X;
            this.modernItemMap = new Map();
            // Every rebuild (including the one that follows a transfer) throws the old tree away, the
            // picker with it. Retire it properly first so it gives the keyboard back.
            this.dismissQuantityPicker();
            this.pickerLayer = undefined;
            // Same for the tutorial clues: the tree they were drawn into is about to be discarded, so drop
            // every anchor and let this pass re-report whichever controls it actually draws.
            this.retractClues();
            this.clueLayer = undefined;
            this.panelClueAnchors.clear();
            this.panelAssembled = false;
            // The revealed recipe is remembered BY NAME across a rebuild (see recipePopover), but the
            // request to draw it is per pass: a row scrolled out of the window reports no anchor, so the
            // popover simply does not appear until the row is back.
            this.pendingPopover = undefined;
            this.popoverLayer = undefined;
            // Nothing to reveal on a screen that has no recipes on it.
            if (!$98fc6d407c9f2a1f$export$bc3be2b9790d3f4d(this.message)) this.recipePopover = undefined;
            // The field is parented to the PAGE, so switching this panel to a screen that has no search
            // box would otherwise leave it sitting over the backpack grid.
            //
            // Only on the way to ANOTHER screen, though. `display: none` on a focused input blurs it, and
            // this runs on every rebuild -- including the one caused by the keystroke that was just typed
            // into it. Hiding unconditionally cost the field its focus after a single letter.
            if (!$98fc6d407c9f2a1f$export$bc3be2b9790d3f4d(this.message)) this.searchField?.hide();
            // Crafting and trading share the mobile inventory's centered, horizontal presentation.
            if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() && ($98fc6d407c9f2a1f$export$1a9ed648cfadc85e(this.message) || $98fc6d407c9f2a1f$export$bc3be2b9790d3f4d(this.message))) {
                this.horizontalPanel = true;
                this.panelW = $98fc6d407c9f2a1f$var$MOBILE_PANEL_W + ($98fc6d407c9f2a1f$export$1a9ed648cfadc85e(this.message) ? 32 : 0);
            }
            if ($98fc6d407c9f2a1f$export$1a9ed648cfadc85e(this.message)) return this.createTradeContent();
            // The crafting screen reuses this same modal (it opens from the inventory's Craft button),
            // so route it to the modern crafting layout rather than the generic fallback.
            if ($98fc6d407c9f2a1f$export$bc3be2b9790d3f4d(this.message)) return this.createCraftingContent();
            const parsed = this.parse(this.message);
            // Only the player's own inventory renders in the modern layout. Anything else that reuses
            // this modal (or a mis-fired open-intent flag) falls back to the classic generic renderer so
            // it looks and behaves exactly as before. DynamicDialog.createContent is an instance arrow
            // field on the base, so `super.createContent` doesn't resolve — call the static form directly.
            if (!this.isSelfInventory(parsed)) return (0, $95fcf006ca17068b$export$97a92ac594e41d5f).createContent(this.logic, this.message, this.width() || $98fc6d407c9f2a1f$var$PANEL_W, this.grids);
            this.horizontalPanel = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)();
            if (this.horizontalPanel) this.panelW = $98fc6d407c9f2a1f$var$MOBILE_PANEL_W;
            return this.assemble((body, detailCard)=>{
                this.drawTitleBar(body, parsed);
                this.drawPortraitAndStats(body, parsed);
                this.drawEquipped(body, parsed, detailCard);
                this.drawReadied(body, parsed, detailCard);
                this.drawBackpack(body, parsed, detailCard);
            });
        }, // Builds a docked panel that sizes its height to the content. The body is drawn first, then the
        // rounded panel background is sized to fit behind it — so no screen has awkward empty space
        // below its content. The whole thing is offset to the right dock position.
        //
        // `fixedHeight` opts out of the measurement, and is a THUNK because the caller only learns the
        // answer while drawing (the tabs decide where the list starts). The crafting screen needs it: its
        // recipe list is a
        // SCROLLING window, and a masked child still reports its full height to getLocalBounds, so a long
        // group would stretch the panel off the bottom of the screen even though the mask hid the
        // overflow. craftingLayout already knows exactly how tall the panel should be, so it says.
        this.assemble = (drawBody, fixedHeight, drawOverlay)=>{
            const wrapper = new (0, $gwPoJ.Graphics)();
            const bg = new (0, $gwPoJ.Graphics)();
            const body = new (0, $gwPoJ.Graphics)();
            wrapper.addChild(bg);
            wrapper.addChild(body);
            // Created before the body is drawn (drawBody reports its clued controls as it goes) but
            // parented after it, so it draws over the panel and is never part of the body's measurement.
            // It shares the body's coordinate space: both sit at the wrapper's origin.
            const clueLayer = new (0, $8t5Gy.Container)();
            this.clueLayer = clueLayer;
            const detailCard = this.clueOnDetailCard(new $98fc6d407c9f2a1f$var$ModernDetailCard());
            this.itemDrag = new (0, $d37c2dc6a7897ec7$export$35c1754b36550cfd)((0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer.plugins.interaction, body, (item, size)=>{
                const ghost = new (0, $8t5Gy.Container)();
                const frame = new (0, $gwPoJ.Graphics)();
                // A larger, opaque tile keeps even tiny item art visible over the world and slots.
                frame.beginFill(0x000000, 0.55);
                (0, $658a44ce960354bb$export$99dca9ebbafa6899)(frame, -2, 0, size + 8, size + 8, 5);
                frame.endFill();
                frame.lineStyle({
                    width: 2,
                    color: $98fc6d407c9f2a1f$var$COLOR.slotHover,
                    alpha: 1,
                    join: (0, $gwPoJ.LINE_JOIN).MITER
                });
                frame.beginFill($98fc6d407c9f2a1f$var$COLOR.slotFill, 1);
                (0, $658a44ce960354bb$export$99dca9ebbafa6899)(frame, -4, -4, size + 8, size + 8, 5);
                frame.endFill();
                frame.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.25);
                frame.moveTo(1, -1.5).lineTo(size - 1, -1.5);
                ghost.addChild(frame);
                const icon = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: item.spriteId,
                    scale: 0.78 * size / $98fc6d407c9f2a1f$var$SLOT,
                    color: 0xffffff,
                    animated: false,
                    rotating: false
                });
                ghost.addChild(icon);
                $98fc6d407c9f2a1f$var$fitItemIcon(icon, 0, 0, size);
                // The tile carries its gauge while it is in the air. Dropping a worn weapon into a
                // chest is a decision made ABOUT its wear, and the pack it came from is covered by
                // the thing being dragged over it.
                const wear = (0, $90f59133f949281e$export$aac214f772e3eeb7).forSlot(item.condition, size);
                if (wear) ghost.addChild(wear);
                return ghost;
            }, this.selectItemOption, ()=>{
                detailCard.hideImmediately();
                this.hideNamePill();
            }, (point)=>{
                const at = body.toLocal(point);
                return (0, $065c5647ab3ff4dc$export$56359d4511c7424)().screen.contains(point.x, point.y) && !new (0, $6qzqq.Rectangle)(0, 0, this.panelW, this.panelH).contains(at.x, at.y);
            });
            drawBody(body, detailCard);
            // Register before world fallback: releasing over the HUD must ready the item, not drop it.
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) this.guiManager.equipped?.registerInventoryDropTarget(this.itemDrag);
            // Shared item menus always render above the slots on every screen.
            body.addChild(detailCard);
            drawOverlay?.(body);
            // Measure the visible content (the hidden detail card is excluded) and size the panel to it,
            // unless the caller already knows the answer.
            const b = body.getLocalBounds();
            const h = fixedHeight?.() ?? (b.height > 0 ? b.y + b.height + $98fc6d407c9f2a1f$var$PANEL_BOTTOM_PAD : this.panelH);
            this.panelH = h;
            this.drawPanelBg(bg, h);
            // Mounted last, and after the measurement, so an open picker floats over everything without
            // stretching the panel it is floating over.
            this.pickerLayer = new (0, $8t5Gy.Container)();
            body.addChild(this.pickerLayer);
            // The hover pill, over the panel like the clues but under them: a clue is a standing
            // instruction, a pill is a passing label, and the instruction wins if they ever overlap.
            this.pillLayer = new (0, $8t5Gy.Container)();
            wrapper.addChild(this.pillLayer);
            // The revealed recipe, over the pill: a popover was asked for, a pill is only hovered. Drawn
            // here rather than where it was asked for, because it is clamped against a panel height that
            // the line above has only just worked out.
            this.popoverLayer = new (0, $8t5Gy.Container)();
            wrapper.addChild(this.popoverLayer);
            this.drawPendingPopover();
            wrapper.addChild(clueLayer);
            // Position after measuring so mobile inventory centers using its actual height.
            const origin = this.dockOrigin();
            wrapper.position.set(origin.x, origin.y);
            wrapper.scale.set($98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE);
            this.panelWrapper = wrapper;
            this.panelOrigin = {
                x: origin.x,
                y: origin.y
            };
            // Opening the panel slides it in off its dock; turning to another of its screens is a softer
            // version of the same. The many rebuilds in between (every server message, keystroke and
            // scroll) are neither, and must not move anything.
            const kind = $98fc6d407c9f2a1f$export$1a9ed648cfadc85e(this.message) ? "trade" : $98fc6d407c9f2a1f$export$bc3be2b9790d3f4d(this.message) ? "crafting" : "inventory";
            if (this.screenKind === undefined) this.beginEntrance($98fc6d407c9f2a1f$var$ENTRANCE_MS, 0, $98fc6d407c9f2a1f$var$ENTRANCE_SLIDE);
            else if (kind !== this.screenKind) this.beginEntrance($98fc6d407c9f2a1f$var$TURN_MS, $98fc6d407c9f2a1f$var$TURN_FROM_ALPHA, $98fc6d407c9f2a1f$var$TURN_SLIDE);
            this.screenKind = kind;
            this.applyEntrance();
            this.panelAssembled = true;
            this.panelClueAnchors.forEach((anchor, type)=>this.registerPanelClue(type, anchor));
            return wrapper;
        }, // ---- the entrance ------------------------------------------------------
        //
        // Driven off the renderer's ticker by elapsed frame time, and applied to whichever wrapper is
        // current, because a rebuild can replace the wrapper mid-slide (the server answers an open with a
        // second message often enough). With no ticker -- tests, a renderer not up yet -- the panel simply
        // appears, which is what it always did.
        this.beginEntrance = (ms, fromAlpha, slide)=>{
            const ticker = this.ticker();
            if (!ticker) return;
            this.entrance = {
                elapsed: 0,
                ms: ms,
                fromAlpha: fromAlpha,
                slide: slide
            };
            if (!this.entranceTick) {
                this.entranceTick = ()=>{
                    if (!this.entrance) return;
                    this.entrance.elapsed += ticker.deltaMS;
                    this.applyEntrance();
                    if (!this.entrance) {
                        this.stopEntrance();
                        // The DOM search field was placed over the box while it was still sliding.
                        this.positionSearchField();
                    }
                };
                ticker.add(this.entranceTick);
            }
        }, this.applyEntrance = ()=>{
            const wrapper = this.panelWrapper;
            if (!wrapper || wrapper.destroyed) return;
            const motion = this.entrance;
            const t = motion ? Math.min(1, motion.elapsed / motion.ms) : 1;
            const eased = 1 - Math.pow(1 - t, 3);
            const offset = motion ? motion.slide * (1 - eased) : 0;
            wrapper.alpha = motion ? motion.fromAlpha + (1 - motion.fromAlpha) * eased : 1;
            // Off its own dock: a right-docked panel comes in from the right, a centred one from below.
            wrapper.position.set(this.panelOrigin.x + (this.horizontalPanel ? 0 : offset), this.panelOrigin.y + (this.horizontalPanel ? offset : 0));
            if (t >= 1) this.entrance = undefined;
        }, this.stopEntrance = ()=>{
            if (this.entranceTick) this.ticker()?.remove(this.entranceTick);
            this.entranceTick = undefined;
            this.entrance = undefined;
        }, // ---- the hover name pill -----------------------------------------------
        /**
     * A small rounded label with the item's name, centred over the slot the pointer is on.
     *
     * Deliberately not a DyanmicTextContainer: this is redrawn on every slot the pointer crosses, and
     * a pill wants to be cheap to make and throw away.
     */ this.showNamePill = (title, slotX, slotY, size)=>{
            const layer = this.pillLayer;
            if (!layer || !title) return;
            layer.removeChildren();
            const label = $98fc6d407c9f2a1f$var$text(title, "compactCaption", $98fc6d407c9f2a1f$var$PILL_TEXT);
            const w = Math.ceil(label.width) + $98fc6d407c9f2a1f$var$PILL_PAD_X * 2;
            const h = Math.ceil(label.height) + $98fc6d407c9f2a1f$var$PILL_PAD_Y * 2;
            const pill = new (0, $gwPoJ.Graphics)();
            $98fc6d407c9f2a1f$var$drawPlate(pill, 0, 0, w, h, {
                face: $98fc6d407c9f2a1f$var$PILL_FILL,
                rim: $98fc6d407c9f2a1f$var$PILL_BORDER,
                rimAlpha: 0.9,
                c: 3
            });
            label.x = $98fc6d407c9f2a1f$var$PILL_PAD_X;
            label.y = $98fc6d407c9f2a1f$var$PILL_PAD_Y;
            pill.addChild(label);
            const { x: x, y: y } = (0, $ad04bdb603662f3e$export$824d04aee2bc3075)({
                slotX: slotX,
                slotY: slotY,
                slotSize: size,
                pillW: w,
                pillH: h,
                panelW: this.panelW
            });
            pill.x = x;
            pill.y = y;
            layer.addChild(pill);
        }, this.hideNamePill = ()=>{
            this.pillLayer?.removeChildren();
        }, // ---- the revealed recipe ------------------------------------------------
        /**
     * Draw the full price of whichever recipe's `+N` was tapped: a title, then every ingredient one
     * to a row, shortfalls in red, each short material carrying the same affordance it has on the
     * line -- a jump to its own recipe, or the line saying where the stuff comes from.
     *
     * Behind the box sits a transparent catcher over the whole panel, so the next tap anywhere else
     * puts the popover away. Deliberately NOT a scrim like the quantity picker's: that one is a
     * question the player has to answer, this is a reveal they are free to walk away from, and dimming
     * the recipe list they are reading would be backwards.
     */ this.drawPendingPopover = ()=>{
            const want = this.pendingPopover;
            const layer = this.popoverLayer;
            this.pendingPopover = undefined;
            if (!want || !layer) return;
            const rows = (0, $199629acfe156ebe$export$4a64f2f0a079efbd)(want.cost);
            if (rows.length < 1) return;
            const dismiss = new (0, $gwPoJ.Graphics)();
            dismiss.beginFill(0x000000, 0.001);
            dismiss.drawRect(0, 0, this.panelW, this.panelH);
            dismiss.endFill();
            dismiss.interactive = true;
            const close = ()=>{
                if (this.recipeDragMoved) return;
                this.recipePopover = undefined;
                this.refreshCrafting();
            };
            dismiss.on("click", close);
            dismiss.on("tap", close);
            layer.addChild(dismiss);
            const box = new (0, $gwPoJ.Graphics)();
            const title = $98fc6d407c9f2a1f$var$text(want.title, "compactCaption", $98fc6d407c9f2a1f$var$COLOR.text, true);
            // Built before the box so the box can be drawn to the size they came out, and positioned
            // after, once the box's own origin is known.
            const lines = rows.map((row)=>{
                const label = $98fc6d407c9f2a1f$var$text(row.note ? `${row.text}${0, $199629acfe156ebe$export$f9ab69e04f728393}${row.note}` : row.text, "compactCaption", row.missing ? $98fc6d407c9f2a1f$var$COLOR.shortfall : $98fc6d407c9f2a1f$var$COLOR.textMuted);
                return {
                    row: row,
                    label: label
                };
            });
            const rowH = Math.max(...lines.map((line)=>Math.ceil(line.label.height) + 2));
            const { w: w, h: h } = (0, $199629acfe156ebe$export$a678144c2ca99670)({
                titleW: title.width,
                titleH: title.height,
                rowW: Math.max(...lines.map((line)=>line.label.width)),
                rowH: rowH,
                rows: lines.length
            });
            $98fc6d407c9f2a1f$var$drawPlate(box, 0, 0, w, h, {
                face: $98fc6d407c9f2a1f$var$PILL_FILL,
                faceAlpha: 0.98,
                rim: $98fc6d407c9f2a1f$var$PILL_BORDER,
                rimAlpha: 0.9,
                c: 5
            });
            title.x = (0, $199629acfe156ebe$export$e82d0fa23248ae49);
            title.y = (0, $199629acfe156ebe$export$43fd459361d4ceb2);
            box.addChild(title);
            let rowY = (0, $199629acfe156ebe$export$43fd459361d4ceb2) + title.height + (0, $199629acfe156ebe$export$b57d4d5e072318c5);
            lines.forEach(({ row: row, label: label }, i)=>{
                label.x = (0, $199629acfe156ebe$export$e82d0fa23248ae49);
                label.y = rowY;
                box.addChild(label);
                // The same material, the same affordance it has inline. A row here is often the ONLY
                // place a shortfall appears: short ingredients are drawn first on the line, but a recipe
                // short of three materials with room for one chip hides two of them behind the tail.
                const ingredient = (0, $e5ed6231df7ea832$export$770de5cd5a50d909)(want.cost)[i];
                if (row.jumpable && ingredient?.jumpEvent) {
                    label.interactive = true;
                    label.cursor = "pointer";
                    const rule = new (0, $gwPoJ.Graphics)();
                    rule.beginFill($98fc6d407c9f2a1f$var$COLOR.shortfall, 0.6);
                    rule.drawRect(label.x, label.y + label.height - 1, label.width, 1);
                    rule.endFill();
                    box.addChild(rule);
                    const jump = ()=>{
                        if (this.recipeDragMoved) return;
                        // The popover goes away with the row it was opened from: the jump replaces the
                        // whole recipe list, so leaving it up would float it over a screen it is not
                        // about.
                        this.recipePopover = undefined;
                        this.emit(ingredient.jumpEvent);
                    };
                    label.on("click", jump);
                    label.on("tap", jump);
                }
                rowY += rowH;
            });
            const at = (0, $199629acfe156ebe$export$af0317d4de5b92ee)({
                anchorX: want.x,
                anchorY: want.y,
                anchorH: want.h,
                popW: w,
                popH: h,
                panelW: this.panelW,
                panelH: this.panelH
            });
            box.x = at.x;
            box.y = at.y;
            layer.addChild(box);
        }, // ---- ember tutorial clues ----------------------------------------------
        // "I drew this clued control, here." The tutorial layer decides whether anything comes of it.
        this.clueAt = (tutorialType, x, y, w, h, reveal)=>{
            if (!this.clueLayer) return;
            const anchor = {
                x: x,
                y: y,
                w: w,
                h: h,
                reveal: reveal
            };
            this.panelClueAnchors.set(tutorialType, anchor);
            if (this.panelAssembled) this.registerPanelClue(tutorialType, anchor);
            const clues = this.guiManager.tutorialClues();
            // Drawing this control retires the one before it (see clueSatisfiedByDrawing). Order within a
            // rebuild does not matter: disarming wins, because registerAnchor on a disarmed clue is a no-op.
            const previous = (0, $9600e6b065d22e57$export$478dbbcac4bfb39)(tutorialType);
            if (previous) clues.satisfyClue(previous);
        }, this.registerPanelClue = (type, anchor)=>{
            const viewport = (0, $167efe97b4119a5d$export$b0f20d83cec42115)();
            const safe = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().safeViewport;
            const origin = this.dockOrigin();
            const x = viewport.left + 10 + origin.x;
            const y = viewport.top + 10 + origin.y;
            this.guiManager.tutorialClues().registerClueAnchor(type, {
                host: this.clueLayer,
                ...anchor,
                boxMinX: (safe.left - x + 8) / $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE,
                boxMaxX: (safe.right - x - 8) / $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE,
                boxMinY: (safe.top - y + 8) / $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE,
                boxMaxY: (safe.bottom - y - 8) / $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE,
                placement: (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? type === "ember-crafting" || type === "ember-close" ? "below" : "above" : $98fc6d407c9f2a1f$var$RECIPE_CLUES.includes(type) ? "above" : "left",
                round: type === "ember-close",
                // The board dims and the control lights up: a note in the panel's own timber, laid over
                // the panel, otherwise reads as part of it.
                spotlight: {
                    x: $98fc6d407c9f2a1f$var$PANEL_INSET,
                    y: $98fc6d407c9f2a1f$var$PANEL_INSET,
                    w: this.panelW - $98fc6d407c9f2a1f$var$PANEL_INSET * 2,
                    h: this.panelH - $98fc6d407c9f2a1f$var$PANEL_INSET * 2,
                    chamfer: $98fc6d407c9f2a1f$var$PANEL_CHAMFER,
                    // The close disc (the modal's) and the search box (a DOM field) sit over the panel, out
                    // of the scrim's reach: darkened with it, unless the disc is what is being taught.
                    onDim: (brightness)=>{
                        const close = type === "ember-close" ? undefined : this.modal?.closeControl?.();
                        if (close && !close.destroyed) {
                            const v = Math.round(255 * brightness);
                            close.tint = v << 16 | v << 8 | v;
                        }
                        this.searchField?.setBrightness(brightness);
                    }
                }
            });
        }, this.retractClues = ()=>{
            const clues = this.guiManager.tutorialClues();
            $98fc6d407c9f2a1f$var$PANEL_CLUES.forEach((tutorialType)=>clues.clearClueAnchor(tutorialType));
        }, // The fifth clue lives on the hover menu, which only exists once the player has picked the item --
        // so the card reports its buttons as it lays them out, and this picks the campfire's "Ready" out of
        // them. Picking any other item (or the menu closing) takes the pointer off.
        this.clueOnDetailCard = (card)=>{
            const clues = this.guiManager.tutorialClues();
            card.optionAnchors = (item, anchors)=>{
                const title = (item.title || "").toLowerCase();
                for (const [itemTitle, type] of [
                    [
                        $98fc6d407c9f2a1f$var$CLUED_ITEM,
                        "ember-use"
                    ],
                    [
                        "wood",
                        "ember-wood-use"
                    ],
                    [
                        "wall-wood",
                        "ember-wall-use"
                    ],
                    [
                        "roof-wood",
                        "ember-roof-use"
                    ]
                ]){
                    const ready = title === itemTitle ? anchors.find((a)=>$98fc6d407c9f2a1f$var$READY_OPTION.test(a.option.title || "")) : undefined;
                    if (ready) this.clueAt(type, ready.rect.x, ready.rect.y, ready.rect.width, ready.rect.height);
                    else clues.clearClueAnchor(type);
                }
            };
            card.onHidden = ()=>{
                clues.clearClueAnchor("ember-use");
                clues.clearClueAnchor("ember-wood-use");
                clues.clearClueAnchor("ember-wall-use");
                clues.clearClueAnchor("ember-roof-use");
            };
            return card;
        }, // ---- quantity picker ----------------------------------------------------
        // A Take/Give on a stack asks how many first. Everything else fires on the click, as before.
        this.openQuantityPicker = (item, option)=>{
            const prompt = option.quantityPrompt;
            if (!prompt) return false;
            return this.showQuantityPicker(item.title, prompt, (amount)=>this.emitWithQuantity(option.onClickContext, amount));
        }, // Craft on a recipe the pack covers more than once asks how many crafts to run. Counted in crafts
        // rather than items, because a craft is what the server makes whole; the picker says what the
        // count comes to when one craft makes several. Starts at one: what a craft uses up -- wood is
        // also the fire's fuel -- is the player's to give away, not the picker's.
        this.craftRecipe = (recipe, title)=>{
            // A drag across the list that let go over this button is a scroll, not a press.
            if (this.recipeDragMoved || !recipe.event) return;
            const max = Math.floor(recipe.maxCrafts ?? 1);
            const asked = max > 1 && this.showQuantityPicker(title, {
                max: max,
                verb: "Craft"
            }, (amount)=>this.emitWithQuantity(recipe.event, amount), {
                initial: 1,
                per: recipe.yield
            });
            if (!asked) this.emit(recipe.event);
        }, // The amount rides beside the event's sealed transaction -- it was chosen after the event was
        // minted, so it cannot be inside it. The server clamps it.
        this.emitWithQuantity = (event, amount)=>{
            this.logic.playerController.client.emitPlayerEvent({
                ...event,
                context: {
                    ...event?.context,
                    transferQuantity: amount
                }
            });
        }, this.showQuantityPicker = (itemTitle, prompt, onConfirm, extra)=>{
            if (!this.pickerLayer) return false;
            this.dismissQuantityPicker();
            const picker = new $98fc6d407c9f2a1f$var$QuantityPicker({
                logic: this.logic,
                modal: this.modal,
                itemTitle: itemTitle,
                prompt: prompt,
                panelW: this.panelW,
                panelH: this.panelH,
                ...extra,
                onConfirm: (amount)=>{
                    this.pickerClosed();
                    onConfirm(amount);
                },
                onCancel: this.pickerClosed
            });
            this.quantityPicker = picker;
            this.pickerLayer.addChild(picker);
            // A tutorial clue bracketing the button that opened this would sit on top of the picker,
            // pointing at a control the scrim has just put out of reach.
            if (this.clueLayer) this.clueLayer.visible = false;
            return true;
        }, // The picker answered itself (confirm or cancel), as opposed to being torn down by a rebuild.
        this.pickerClosed = ()=>{
            this.quantityPicker = undefined;
            if (this.clueLayer) this.clueLayer.visible = true;
            if (this.refreshDeferred) {
                this.refreshDeferred = false;
                this.refreshCrafting();
            }
        }, // Menus and drops share quantity handling and event submission across all item screens.
        this.selectItemOption = (item, option)=>{
            if (this.openQuantityPicker(item, option)) return;
            this.logic.playerController.client.emitPlayerEvent({
                ...option.onClickContext
            });
        }, this.dismissQuantityPicker = ()=>{
            const picker = this.quantityPicker;
            this.quantityPicker = undefined;
            // Only ever called on the way into a rebuild or a close, either of which covers a redraw
            // that was waiting on the picker.
            this.refreshDeferred = false;
            picker?.dismiss();
        }, this.pulseGridItem = (itemId)=>{
            // In modern mode there's one slot per item; in classic-fallback mode (crafting etc.) the
            // generic grids own the slots. Pulse whichever we find. `super.pulseGridItem` can't be used
            // because the base defines it as an instance arrow field, not a prototype method.
            const slots = [];
            const modern = this.modernItemMap.get(itemId);
            if (modern) slots.push(modern);
            else this.grids.forEach((grid)=>{
                const s = grid.itemMap.get(itemId);
                if (s) slots.push(s);
            });
            slots.forEach((slot)=>{
                const indicator = $98fc6d407c9f2a1f$var$text("New!", "compactLabel", $98fc6d407c9f2a1f$var$COLOR.gold, true);
                indicator.x = (slot.width - indicator.width) / 2;
                indicator.y = 2;
                slot.addChild(indicator);
                const throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(slot, {
                    expires: 10000,
                    blinkInterval: 50,
                    releaseCallback: ()=>slot.removeChild(indicator)
                });
                throbber.update();
            });
        }, // ---- payload parsing ----------------------------------------------------
        this.parse = (message)=>{
            const result = {
                backpack: [],
                readied: [],
                equipped: [],
                statLines: [],
                actions: [],
                gridCount: 0,
                hasBackpackGrid: false
            };
            const grids = [];
            const walk = (node)=>{
                const meta = typeof node === "string" ? {
                    text: node
                } : node;
                if (!meta) return;
                if (meta.type === "grid") {
                    const items = meta.context?.gridMeta || [];
                    grids.push({
                        items: items,
                        rows: meta.context?.rows ?? 0,
                        columns: meta.context?.columns ?? 0
                    });
                } else if (meta.type === "entity") {
                    if (!result.entity) result.entity = {
                        entityId: meta.context?.entityId,
                        appearance: meta.context?.appearance,
                        inventory: meta.context?.inventory
                    };
                } else if (meta.type === "button|dynamic" && meta.clickEventEmitter) result.actions.push({
                    text: meta.text,
                    event: meta.clickEventEmitter
                });
                else if (meta.font === "ImportantFont" && meta.text) {
                    if (!result.name) result.name = meta.text;
                } else if (meta.text && /^(HP:|Speed:|Defense:|Mana)/.test(meta.text)) result.statLines.push(meta.text);
                if (meta.children) meta.children.forEach(walk);
            };
            (message.dynamicText || []).forEach(walk);
            result.gridCount = grids.length;
            // Classify grids by the server's dimensions (6x5 backpack, 6x1 readied, 2x6 equipped);
            // any unclassified grid folds into the backpack. We deliberately IGNORE these dims for
            // layout — they only tell us which bucket each pre-filtered item list belongs to.
            grids.forEach((grid)=>{
                if (grid.columns === 6 && grid.rows === 1) result.readied.push(...grid.items);
                else if (grid.columns === 2 && grid.rows === 6) result.equipped.push(...grid.items);
                else {
                    if (grid.columns === 6 && grid.rows === 5) result.hasBackpackGrid = true;
                    result.backpack.push(...grid.items);
                }
            });
            return result;
        }, // The modern layout is only meaningful for the player's own inventory panel. That panel is the
        // only reuse of this modal that carries BOTH the 6x5 backpack grid AND the character portrait
        // (showEntity). Crafting/trade sub-dialogs reuse the modal via updateContent but omit the
        // portrait, so they fall through to the generic renderer and look exactly as they always did.
        this.isSelfInventory = (parsed)=>!!parsed.entity && parsed.hasBackpackGrid, this.isInventoryOrCrafting = ()=>!$98fc6d407c9f2a1f$export$1a9ed648cfadc85e(this.message) && ($98fc6d407c9f2a1f$export$bc3be2b9790d3f4d(this.message) || this.isSelfInventory(this.parse(this.message))), // ---- panel chrome -------------------------------------------------------
        // The board: a dropped silhouette, a cut-timber frame with a bronze inner rim, the dark face, a
        // warmer band behind the title, one lit edge along the top and a rivet in each corner. Drawn the
        // way build_board.ts draws the build controls, because these panels and those controls are the
        // same camp's furniture.
        this.drawPanelBg = (g, h)=>{
            const x = $98fc6d407c9f2a1f$var$PANEL_INSET;
            const y = $98fc6d407c9f2a1f$var$PANEL_INSET;
            const w = this.panelW - $98fc6d407c9f2a1f$var$PANEL_INSET * 2;
            const ph = h - $98fc6d407c9f2a1f$var$PANEL_INSET * 2;
            const frame = 4;
            g.lineStyle(0);
            g.beginFill(0x000000, 0.36);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x, y + 4, w, ph, $98fc6d407c9f2a1f$var$PANEL_CHAMFER);
            g.endFill();
            g.lineStyle({
                width: 1.5,
                color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
                alpha: 1,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            g.beginFill((0, $658a44ce960354bb$export$611f5967b7e8b685), 1);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x, y, w, ph, $98fc6d407c9f2a1f$var$PANEL_CHAMFER);
            g.endFill();
            g.lineStyle({
                width: 1,
                color: (0, $658a44ce960354bb$export$dd27ce85ad53c944),
                alpha: 0.85,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            g.beginFill($98fc6d407c9f2a1f$var$COLOR.panelFill, 0.985);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x + frame, y + frame, w - frame * 2, ph - frame * 2, $98fc6d407c9f2a1f$var$PANEL_CHAMFER - 2);
            g.endFill();
            // The title band: the same cut at the top, square at the bottom where the groove runs. The trade
            // screen has no title -- it opens on the two parties -- so it has no band either.
            if (!$98fc6d407c9f2a1f$export$1a9ed648cfadc85e(this.message)) {
                const bx = x + frame + 1;
                const by = y + frame + 1;
                const bw = w - frame * 2 - 2;
                const bc = $98fc6d407c9f2a1f$var$PANEL_CHAMFER - 3;
                g.lineStyle(0);
                g.beginFill($98fc6d407c9f2a1f$var$COLOR.panelFillTop, 0.85);
                g.moveTo(bx + bc, by).lineTo(bx + bw - bc, by).lineTo(bx + bw, by + bc).lineTo(bx + bw, 40).lineTo(bx, 40).lineTo(bx, by + bc).closePath();
                g.endFill();
            }
            g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.2);
            g.moveTo(x + frame + $98fc6d407c9f2a1f$var$PANEL_CHAMFER, y + frame + 1.5).lineTo(x + w - frame - $98fc6d407c9f2a1f$var$PANEL_CHAMFER, y + frame + 1.5);
            g.lineStyle(0);
            // Rivets sit on the frame's corners, where the timber is.
            const r = frame / 2 + 0.5;
            for (const [rx, ry] of [
                [
                    x + $98fc6d407c9f2a1f$var$PANEL_CHAMFER + 2,
                    y + r
                ],
                [
                    x + w - $98fc6d407c9f2a1f$var$PANEL_CHAMFER - 2,
                    y + r
                ],
                [
                    x + $98fc6d407c9f2a1f$var$PANEL_CHAMFER + 2,
                    y + ph - r
                ],
                [
                    x + w - $98fc6d407c9f2a1f$var$PANEL_CHAMFER - 2,
                    y + ph - r
                ]
            ])(0, $658a44ce960354bb$export$514310343d21eee2)(g, rx, ry);
        }, // A screen's name: its glyph, then the name in letterspaced caps, then the groove that closes the
        // title band. The glyph is the one the command wheel uses for the same thing, so the pack looks
        // like the pack wherever it is drawn.
        this.drawPanelTitle = (content, label, icon)=>{
            const title = $98fc6d407c9f2a1f$var$caps(label, "compactTitle", $98fc6d407c9f2a1f$var$COLOR.title, 1.5);
            title.x = 36;
            title.y = 14;
            content.addChild(title);
            content.addChild($98fc6d407c9f2a1f$var$glyph(icon, 25, title.y + title.height / 2, 15, $98fc6d407c9f2a1f$var$COLOR.gold));
            (0, $658a44ce960354bb$export$5ed3e56f5245819d)(content, 14, this.panelW - 14, 40);
            content.lineStyle(0);
        }, /** The header row's room for the close disc at its end: the disc and a button gap. */ this.headerCloseRoom = ()=>(0, $0d2b5753435eae0a$export$eb43af23fb6f2b4a)() * 2 + 6, this.drawTitleBar = (content, parsed)=>{
            this.drawPanelTitle(content, "Inventory", "sack");
            // Header actions (e.g. Craft) — out to the right margin, left of the close disc.
            let bx = this.panelW - $98fc6d407c9f2a1f$var$HEADER_RIGHT_MARGIN - this.headerCloseRoom();
            parsed.actions.forEach((action)=>{
                const btnW = 64;
                const button = $98fc6d407c9f2a1f$var$makeButton(action.text, btnW, $98fc6d407c9f2a1f$var$HEADER_BUTTON_H, ()=>{
                    this.logic.playerController.client.emitPlayerEvent(action.event);
                });
                bx -= btnW;
                button.x = bx;
                button.y = $98fc6d407c9f2a1f$var$HEADER_BUTTON_Y;
                content.addChild(button);
                // The way through to the recipe list, and the second clue in the ember tutorial's chain.
                if ($98fc6d407c9f2a1f$var$CRAFT_ACTION.test(action.text || "")) this.clueAt("ember-crafting", button.x, button.y, btnW, 24);
                bx -= 6;
            });
            // The last clue in the chain: once the campfire is readied, the way out of the pack is the way
            // to put it down. The disc is the modal's (see closeAnchor), drawn at the end of this row, so
            // this reports where it is rather than drawing it. Reported only while the campfire is readied,
            // which is what makes reporting it proof that Ready was pressed.
            if (parsed.readied.some((item)=>(item.title || "").toLowerCase() === $98fc6d407c9f2a1f$var$CLUED_ITEM)) {
                const r = (0, $0d2b5753435eae0a$export$eb43af23fb6f2b4a)();
                this.clueAt("ember-close", this.panelW - $98fc6d407c9f2a1f$var$HEADER_RIGHT_MARGIN - r * 2, $98fc6d407c9f2a1f$var$HEADER_BUTTON_Y + $98fc6d407c9f2a1f$var$HEADER_BUTTON_H / 2 - r, r * 2, r * 2);
            }
        }, // ---- portrait + stats (compact header row) -----------------------------
        this.drawPortraitAndStats = (content, parsed)=>{
            const frameX = 16;
            const frameY = 46;
            const frameW = 74;
            const frameH = 80;
            // Portrait frame: a deep socket, warmed from below as if the character stood at the fire.
            $98fc6d407c9f2a1f$var$drawSocket(content, frameX, frameY, frameW, frameH, 0x17110c, 6);
            for(let ring = 0; ring < 5; ring++){
                content.beginFill(0x5a3018, 0.07);
                content.drawEllipse(frameX + frameW / 2, frameY + frameH - 8, frameW * (0.5 - ring * 0.08), 22 - ring * 3.5);
                content.endFill();
            }
            content.lineStyle({
                width: 1,
                color: (0, $658a44ce960354bb$export$dd27ce85ad53c944),
                alpha: 0.55,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(content, frameX - 0.5, frameY - 0.5, frameW + 1, frameH + 1, 6);
            content.lineStyle(0);
            if (parsed.entity?.appearance || parsed.entity?.inventory) {
                const entity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
                entity.weapon = {
                    weaponType: (0, $f684496fff50a7a1$export$58361cde22f3aa43)(parsed.entity.inventory, "weapon")?.type
                };
                entity.appearance = parsed.entity.appearance;
                entity.inventory = parsed.entity.inventory;
                const displayer = new (0, $c14ea609224dd88d$export$982d39230018c180)({
                    entityId: parsed.entity.entityId,
                    scale: 1.6
                }, entity);
                const portrait = displayer.createContent();
                content.addChild(portrait);
                const bounds = portrait.getLocalBounds();
                if (bounds.width > 0 && bounds.height > 0) {
                    const fit = Math.min((frameW - 12) / bounds.width, (frameH - 12) / bounds.height, 1);
                    portrait.scale.set(fit);
                    portrait.x = frameX + (frameW - bounds.width * fit) / 2 - bounds.x * fit;
                    portrait.y = frameY + (frameH - bounds.height * fit) / 2 - bounds.y * fit;
                }
            }
            // Stats to the right of the portrait, tight line spacing to fit the header height.
            const statsX = frameX + frameW + 12;
            let sy = frameY + 2;
            if (parsed.name) {
                const name = $98fc6d407c9f2a1f$var$text(parsed.name, "label", $98fc6d407c9f2a1f$var$COLOR.title, true);
                name.x = statsX;
                name.y = sy;
                content.addChild(name);
                sy += 19;
            }
            parsed.statLines.forEach((line)=>{
                const hp = line.match(/^HP:\s*([\d.]+)\s*\/\s*([\d.]+)/);
                if (hp) {
                    this.drawStatBar(content, statsX, sy, $98fc6d407c9f2a1f$var$DOCK_W - statsX - 16, "HP", parseFloat(hp[1]), parseFloat(hp[2]), $98fc6d407c9f2a1f$var$COLOR.hp);
                    sy += 17;
                } else {
                    const t = $98fc6d407c9f2a1f$var$text(line, "compactLabel", $98fc6d407c9f2a1f$var$COLOR.textMuted);
                    t.x = statsX;
                    t.y = sy;
                    content.addChild(t);
                    sy += 14;
                }
            });
        }, this.drawStatBar = (content, x, y, w, label, value, max, color)=>{
            // A gauge cut into the board, filled like the dial's arc: the colour, then a brighter upper half
            // so it reads as a lit bar rather than a flat swatch.
            const barH = 14;
            $98fc6d407c9f2a1f$var$drawSocket(content, x, y, w, barH, $98fc6d407c9f2a1f$var$COLOR.slotEmpty, 3);
            const ratio = max > 0 ? Math.max(0, Math.min(1, value / max)) : 0;
            if (ratio > 0) {
                const fw = Math.max(4, (w - 4) * ratio);
                content.beginFill(color, 0.95);
                (0, $658a44ce960354bb$export$99dca9ebbafa6899)(content, x + 2, y + 2.5, fw, barH - 5, 2);
                content.endFill();
                content.beginFill(0xffffff, 0.16);
                content.drawRect(x + 3, y + 3, Math.max(0, fw - 2), (barH - 5) / 2 - 0.5);
                content.endFill();
            }
            const t = $98fc6d407c9f2a1f$var$text(`${label}  ${Math.ceil(value)} / ${Math.ceil(max)}`, "compactCaption", $98fc6d407c9f2a1f$var$COLOR.text, true);
            t.x = x + 6;
            t.y = y + (barH - t.height) / 2;
            content.addChild(t);
        }, // ---- right region sections ---------------------------------------------
        // `note` is a muted right-aligned aside on the label row (e.g. the crafting pack's "+3 more"); the
        // rule stops short of it.
        this.sectionLabel = (content, label, x, y, note, right = this.panelW - 16)=>{
            const t = $98fc6d407c9f2a1f$var$caps(label, "compactBody", $98fc6d407c9f2a1f$var$COLOR.label, 1.2);
            t.x = x;
            t.y = y;
            content.addChild(t);
            let ruleRight = right;
            if (note) {
                const n = $98fc6d407c9f2a1f$var$text(note, "compactLabel", $98fc6d407c9f2a1f$var$COLOR.textMuted);
                n.x = right - n.width;
                n.y = y + 1;
                content.addChild(n);
                ruleRight = n.x - 8;
            }
            // An engraved groove out to the right of the label.
            (0, $658a44ce960354bb$export$5ed3e56f5245819d)(content, x + t.width + 8, ruleRight, Math.round(y + t.height / 2));
            content.lineStyle(0);
        }, // Inventory sections and trade sides use the same drop region and highlight.
        this.itemSectionTarget = (content, section, bounds)=>{
            const highlight = new (0, $gwPoJ.Graphics)();
            highlight.interactive = false;
            highlight.visible = false;
            highlight.lineStyle({
                width: 2,
                color: $98fc6d407c9f2a1f$var$COLOR.gold,
                alpha: 1,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            highlight.beginFill($98fc6d407c9f2a1f$var$COLOR.gold, 0.08);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(highlight, bounds.x, bounds.y, bounds.width, bounds.height, 5);
            highlight.endFill();
            content.addChild(highlight);
            this.itemDrag?.registerSection(content, bounds, section, (on)=>{
                highlight.visible = on;
            });
        }, this.drawEquipped = (content, parsed, card)=>{
            const originX = 16;
            const labelY = 132;
            this.sectionLabel(content, "Equipped", originX, labelY, undefined, $98fc6d407c9f2a1f$var$DOCK_W - 16);
            const slotsY = labelY + 18;
            const count = Math.max(4, parsed.equipped.length);
            for(let i = 0; i < count; i++){
                const item = parsed.equipped[i];
                const slot = this.makeSlot(item, originX + i * ($98fc6d407c9f2a1f$var$DOCK_SLOT + 5), slotsY, card, $98fc6d407c9f2a1f$var$COLOR.equipped, $98fc6d407c9f2a1f$var$DOCK_SLOT, false, "equipped");
                content.addChild(slot);
            }
            this.itemSectionTarget(content, "equipped", new (0, $6qzqq.Rectangle)(8, labelY - 4, $98fc6d407c9f2a1f$var$DOCK_W - 16, 56));
        }, this.drawReadied = (content, parsed, card)=>{
            const originX = 16;
            const labelY = 188;
            this.sectionLabel(content, "Readied", originX, labelY, undefined, $98fc6d407c9f2a1f$var$DOCK_W - 16);
            const slotsY = labelY + 18;
            for(let i = 0; i < (0, $cb689cfa16c444ba$export$ae5c2924da49a08c); i++){
                const item = parsed.readied[i];
                const slot = this.makeSlot(item, originX + i * ($98fc6d407c9f2a1f$var$DOCK_SLOT + 5), slotsY, card, $98fc6d407c9f2a1f$var$COLOR.readied, $98fc6d407c9f2a1f$var$DOCK_SLOT, false, "readied");
                content.addChild(slot);
            }
            this.itemSectionTarget(content, "readied", new (0, $6qzqq.Rectangle)(8, labelY - 4, $98fc6d407c9f2a1f$var$DOCK_W - 16, 56));
        }, this.drawBackpack = (content, parsed, card)=>{
            const originX = this.horizontalPanel ? $98fc6d407c9f2a1f$var$DOCK_W + 16 : 16;
            const labelY = this.horizontalPanel ? 46 : 244;
            this.sectionLabel(content, "Backpack", originX, labelY);
            const slotsY = labelY + 18;
            const cols = 8;
            const gap = 4;
            const rows = Math.max(4, Math.ceil(parsed.backpack.length / cols));
            for(let r = 0; r < rows; r++)for(let c = 0; c < cols; c++){
                const idx = r * cols + c;
                const item = parsed.backpack[idx];
                const slot = this.makeSlot(item, originX + c * ($98fc6d407c9f2a1f$var$DOCK_SLOT + gap), slotsY + r * ($98fc6d407c9f2a1f$var$DOCK_SLOT + gap), card, $98fc6d407c9f2a1f$var$COLOR.gold, $98fc6d407c9f2a1f$var$DOCK_SLOT, true, "backpack");
                content.addChild(slot);
            }
            this.itemSectionTarget(content, "backpack", new (0, $6qzqq.Rectangle)(originX - 8, labelY - 4, $98fc6d407c9f2a1f$var$DOCK_W - 16, 22 + rows * ($98fc6d407c9f2a1f$var$DOCK_SLOT + gap)));
        }, // ---- individual slot ----------------------------------------------------
        this.makeSlot = (item, x, y, card, accent, size = $98fc6d407c9f2a1f$var$SLOT, // Only the PLAYER'S OWN pack grid is clued. The same slot builder draws the equipped/readied
        // rows and both halves of a trade, and a campfire sitting in a chest is not the one the
        // tutorial is talking about.
        clued = false, section = "backpack")=>{
            const slot = new (0, $gwPoJ.Graphics)();
            slot.x = x;
            slot.y = y;
            // A socket carved into the board. An empty one is barely there, so the pack reads by what is
            // IN it; an item in use carries its section's ring (bronze worn, ember readied); the one under
            // the pointer is ringed in gold with a faint glow, the same gold the command wheel lights a
            // choice with.
            const drawFrame = (hovered)=>{
                slot.clear();
                $98fc6d407c9f2a1f$var$drawSocket(slot, 0, 0, size, size, item ? $98fc6d407c9f2a1f$var$COLOR.slotFill : $98fc6d407c9f2a1f$var$COLOR.slotEmpty);
                const active = !!item?.active;
                if (hovered) {
                    slot.lineStyle({
                        width: 4,
                        color: $98fc6d407c9f2a1f$var$COLOR.slotHover,
                        alpha: 0.16,
                        join: (0, $gwPoJ.LINE_JOIN).MITER
                    });
                    (0, $658a44ce960354bb$export$99dca9ebbafa6899)(slot, -0.5, -0.5, size + 1, size + 1, $98fc6d407c9f2a1f$var$SOCKET_CHAMFER + 1);
                }
                if (hovered || active) {
                    slot.lineStyle({
                        width: 1.5,
                        color: hovered ? $98fc6d407c9f2a1f$var$COLOR.slotHover : accent,
                        alpha: 1,
                        join: (0, $gwPoJ.LINE_JOIN).MITER
                    });
                    (0, $658a44ce960354bb$export$99dca9ebbafa6899)(slot, 0.75, 0.75, size - 1.5, size - 1.5, $98fc6d407c9f2a1f$var$SOCKET_CHAMFER);
                } else if (item) {
                    slot.lineStyle({
                        width: 1,
                        color: $98fc6d407c9f2a1f$var$COLOR.slotBorder,
                        alpha: 0.9,
                        join: (0, $gwPoJ.LINE_JOIN).MITER
                    });
                    (0, $658a44ce960354bb$export$99dca9ebbafa6899)(slot, 0.5, 0.5, size - 1, size - 1, $98fc6d407c9f2a1f$var$SOCKET_CHAMFER);
                }
                slot.lineStyle(0);
            };
            drawFrame(false);
            this.itemDrag?.register(slot, item, section, size, drawFrame);
            if (!item) return slot;
            this.modernItemMap.set(item.id, slot);
            // The fourth clue: the campfire they just made, in the pack it landed in.
            if (clued && (item.title || "").toLowerCase() === $98fc6d407c9f2a1f$var$CLUED_ITEM) this.clueAt("ember-pack", x, y, size, size);
            for (const entry of (0, $9600e6b065d22e57$export$b131041a3ede9882))if ("pack" in entry && clued && (item.title || "").toLowerCase() === entry.itemType) this.clueAt(entry.pack, x, y, size, size);
            if (clued && (item.title || "").toLowerCase() === "wood") this.clueAt("ember-wood-pack", x, y, size, size);
            const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                name: item.spriteId,
                scale: 0.78 * size / $98fc6d407c9f2a1f$var$SLOT,
                color: 0xffffff,
                animated: false,
                rotating: false
            });
            slot.addChild(sprite);
            $98fc6d407c9f2a1f$var$fitItemIcon(sprite, 0, 0, size);
            let qtyWidth = 0;
            if (item.quantity > 1) {
                const qty = $98fc6d407c9f2a1f$var$text(`${item.quantity}`, "compactCaption", $98fc6d407c9f2a1f$var$COLOR.text, true);
                qty.x = size - qty.width - 3;
                qty.y = size - qty.height - 2;
                qtyWidth = qty.width + 5;
                slot.addChild(qty);
            }
            // The wear gauge, in the same place and at the same size as the readied tray's (gui/
            // durability.ts) -- the two are the same slot seen in two windows, and wear is the kind of
            // thing a player checks in one and acts on in the other.
            //
            // A child, not slot geometry: `drawFrame` reissues that geometry on every hover, and the
            // item art reaches to within 4px of the well's floor, which is where the gauge lives.
            const wear = (0, $90f59133f949281e$export$aac214f772e3eeb7).forSlot(item.condition, size, qtyWidth);
            if (wear) slot.addChild(wear);
            slot.interactive = true;
            slot.cursor = "grab";
            const onSelect = (option)=>this.selectItemOption(item, option);
            const reveal = ()=>{
                if (this.itemDrag?.suppressClick(slot)) return;
                drawFrame(true);
                this.hideNamePill();
                card.show(item, onSelect, slot.x, slot.y, size, this.panelW, this.panelH);
            };
            // HOVER NAMES IT, CLICK OPENS IT. The card used to spring open under the pointer on its way
            // across the grid, which made simply looking at your pack feel like being interrupted. A pill
            // with the item's name answers "what is that?" without answering a question nobody asked, and
            // the menu is now something you go and get.
            slot.on((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? "tap" : "click", reveal);
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) slot.on("mouseover", ()=>{
                if (this.itemDrag?.dragging) return;
                drawFrame(true);
                this.showNamePill(item.title, slot.x, slot.y, size);
            });
            slot.on("mouseout", (event)=>{
                drawFrame(false);
                this.hideNamePill();
                // The card still closes on its own terms: it has its own hover grace period, so travelling
                // from the slot to the menu that just opened does not shut it (see ModernDetailCard).
                card.scheduleHide(event);
            });
            return slot;
        }, // =========================================================================
        // CRAFTING — a paginated recipe browser + the player's materials. Reuses this
        // same modal (opened from the inventory's Craft button).
        // =========================================================================
        this.emit = (event)=>{
            if (event) this.logic.playerController.client.emitPlayerEvent(event);
        }, /**
     * Take the reveal marker out of the stored message, so a LOCAL rebuild cannot see it twice.
     *
     * The panel re-reads `this.message` every time it redraws itself, and it redraws itself for
     * things the server knows nothing about. A one-shot therefore has to be consumed here as well as
     * on the server; the next real message brings its own marker if there is one.
     */ this.consumeCraftingReveal = ()=>{
            // `asMeta` hands back the very node for an object (it only wraps bare strings), so this edits
            // the stored message rather than a copy of it -- which is the point.
            $98fc6d407c9f2a1f$export$bba5840b442d1a1((this.message?.dynamicText || []).map($98fc6d407c9f2a1f$var$asMeta).filter(Boolean));
        }, this.parseCrafting = (message)=>{
            const inv = this.parse(message);
            const result = {
                materials: [
                    ...inv.readied,
                    ...inv.backpack
                ],
                recipes: [],
                headerActions: [],
                empty: false
            };
            const top = (message.dynamicText || []).map($98fc6d407c9f2a1f$var$asMeta).filter(Boolean);
            // The craftable browser is the top-level container holding recipe rows (a "Craft" button
            // descendant) or the "None" placeholder when nothing is craftable.
            const craftable = top.find((n)=>n.type === "container" && ($98fc6d407c9f2a1f$var$hasDescendantText(n, "Craft") || $98fc6d407c9f2a1f$var$hasDescendantText(n, "None")));
            // Header actions (e.g. "Inventory") — button|dynamic buttons OUTSIDE the browser, so we don't
            // scoop up each recipe's Craft button.
            top.forEach((n)=>{
                if (n === craftable) return;
                const collect = (node)=>{
                    if (node.type === "button|dynamic" && node.clickEventEmitter && node.text !== "Craft") result.headerActions.push({
                        text: node.text,
                        event: node.clickEventEmitter
                    });
                    (node.children || []).forEach(collect);
                };
                collect(n);
            });
            if (!craftable) {
                result.empty = true;
                return result;
            }
            result.filter = craftable.context?.craftingFilter;
            const children = craftable.children || [];
            // Recipe rows are a flat sequence of [Craft button, icon sprite, name text, spacer]. There are
            // no category chips or paginator to pick out any more: the server sends one list and the panel
            // narrows it itself.
            let cur = null;
            children.forEach((child)=>{
                if (child.type === "button|dynamic" && child.text === "Craft") {
                    cur = {
                        name: "",
                        ingredients: [],
                        enabled: !!child.clickEventEmitter && !(child.textDecorations || []).includes("disabled"),
                        event: child.clickEventEmitter,
                        disabledReason: child.hoverText
                    };
                    result.recipes.push(cur);
                } else if (cur && child.type === "sprite") cur.spriteId = child.spriteId;
                else if (child.context?.craftingReveal) result.reveal = child.context.craftingReveal;
                else if (cur && child.text && child.text.trim() !== "" && child.text !== "Craft") {
                    if (!cur.name) {
                        cur.name = child.text;
                        // hoverText[0] repeats the item name; the rest are the recipe's ingredients.
                        cur.ingredients = (child.hoverText || []).slice(1);
                        const recipe = child.context?.craftingRecipe;
                        cur.cost = recipe?.cost;
                        cur.yield = recipe?.yield;
                        cur.label = recipe?.name;
                        cur.full = recipe?.full;
                        cur.maxCrafts = recipe?.maxCrafts;
                    }
                }
            });
            result.empty = result.recipes.length === 0;
            return result;
        }, this.createCraftingContent = ()=>{
            // Cleared before the rebuild so a handler can never be left pointing at a discarded tree.
            this.recipeStrip = undefined;
            this.scrollThumb = undefined;
            this.recipeMaxScroll = 0;
            // ...including the glow, whose row may not be drawn at all in the rebuild that follows (it can
            // be scrolled out of the window). The ticker tolerates having nothing to fade.
            this.glowNode = undefined;
            let panelHeight;
            let filterTop = 48;
            const content = this.assemble((body, detailCard)=>{
                const parsed = this.parseCrafting(this.message);
                if (!this.craftingFilterLoaded) {
                    this.craftingCraftableOnly = parsed.filter?.canMakeNow ?? false;
                    this.craftingFilterLoaded = true;
                }
                this.drawCraftingTitleBar(body, parsed);
                // Recipe reveals may reset category and search, but must respect the player's saved
                // "Can make now" preference. Consume the marker once so local redraws do not reset
                // subsequent changes to the filters.
                if (parsed.reveal) {
                    const cleared = (0, $d3bd591c0da8302e$export$97aa46c267294ba4)(this.craftingCraftableOnly);
                    this.craftingGroup = cleared.group;
                    this.craftingQuery = cleared.query;
                    this.craftingCraftableOnly = cleared.craftableOnly;
                    this.craftingDropdownOpen = cleared.dropdownOpen;
                    // ...and the search box gives the keyboard back. Clearing the query while leaving it
                    // focused left a box that drew itself as live, still held the keyboard, and had lost
                    // its text: clicking into it did nothing (already focused) and typing began from
                    // empty. No redraw asked for here -- this IS the redraw.
                    this.applySearchFocus(cleared.searchFocused);
                    this.consumeCraftingReveal();
                    this.glowItem = parsed.reveal;
                    this.glowStart = Date.now();
                    this.startGlow();
                }
                // Draw the controls after applying the reveal so they match the list on its first frame.
                // Mobile keeps filters and recipes on the left and materials on the right.
                let y = 48;
                filterTop = y;
                y = this.drawFilterBar(body, 16, y, $98fc6d407c9f2a1f$var$DOCK_W - 16);
                // The server sends every recipe; the narrowing happens here, in the same frame as the
                // keystroke that asked for it.
                const shown = (0, $d3bd591c0da8302e$export$e1dba822652599da)(parsed.recipes, this.craftingGroup, this.craftingQuery, this.craftingCraftableOnly);
                // Both halves are sized together: the pack reserves its rows and the recipe list takes
                // what is left as a window it scrolls inside.
                const layout = (0, $a5a3df2f3994c840$export$cad70a0e6e8fa48e)({
                    topY: y,
                    bottomY: (this.horizontalPanel ? 280 : $98fc6d407c9f2a1f$var$DOCK_H / $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE) - $98fc6d407c9f2a1f$var$PANEL_BOTTOM_PAD,
                    innerW: $98fc6d407c9f2a1f$var$DOCK_W - 32,
                    backpackTopY: this.horizontalPanel ? 48 : undefined,
                    recipeCount: shown.length,
                    itemCount: parsed.materials.length
                });
                // A different list wants a fresh scroll -- arriving part way down one you have just
                // narrowed reads as a broken panel. Between identical filters the offset survives the
                // rebuild that follows every craft, so making something does not throw the player back to
                // the top of the list.
                const filterKey = `${this.craftingGroup}|${this.craftingQuery}|${this.craftingCraftableOnly}`;
                if (filterKey !== this.craftingScrollGroup) {
                    this.craftingScrollGroup = filterKey;
                    this.craftingScrollY = 0;
                }
                // Scroll to the revealed recipe if it passes "Can make now"; hidden recipes must not
                // change the player's preference.
                if (parsed.reveal) {
                    const index = shown.findIndex((recipe)=>recipe.name === parsed.reveal);
                    if (index >= 0) {
                        this.craftingScrollY = index * (layout.cardH + (0, $a5a3df2f3994c840$export$b6095232b96cb2d5));
                        this.craftingScrollGroup = `${this.craftingGroup}|${this.craftingQuery}|${this.craftingCraftableOnly}`;
                    }
                }
                this.craftingScrollY = (0, $a5a3df2f3994c840$export$74e32579ce8387f2)(this.craftingScrollY, layout.maxScroll);
                this.drawRecipes(body, shown, parsed, 16, y, $98fc6d407c9f2a1f$var$DOCK_W - 16, layout);
                this.drawCraftingBackpack(body, parsed, detailCard, layout);
                // The panel's height is KNOWN rather than measured: the recipe list is a masked window and
                // a masked child still reports its full height to getLocalBounds.
                panelHeight = layout.bottom + $98fc6d407c9f2a1f$var$PANEL_BOTTOM_PAD;
            }, ()=>panelHeight, (body)=>this.drawFilterOptions(body, 16, filterTop + 26));
            this.attachWheel();
            this.attachResize();
            return content;
        }, /**
     * Re-place the field when the window changes shape.
     *
     * The panel is laid out in a virtual 800x600 screen that is letterboxed into whatever the window
     * is, so a resize moves and rescales the box without redrawing anything. A DOM node pinned to
     * page coordinates does not follow on its own.
     */ this.attachResize = ()=>{
            if (this.resizeListener || typeof window === "undefined") return;
            this.resizeListener = ()=>this.positionSearchField();
            window.addEventListener("resize", this.resizeListener);
        }, this.detachResize = ()=>{
            if (this.resizeListener && typeof window !== "undefined") window.removeEventListener("resize", this.resizeListener);
            this.resizeListener = undefined;
        }, // The player's own pack, pinned below the recipe list. Hovering a slot surfaces the same item
        // menu the inventory screen gives it, so materials can be readied or dropped without leaving.
        this.drawCraftingBackpack = (content, parsed, card, layout)=>{
            const originX = this.horizontalPanel ? $98fc6d407c9f2a1f$var$DOCK_W + 16 : 16;
            const { slot: slot, cols: cols, rows: rows, gap: gap, hidden: hidden } = layout.grid;
            this.sectionLabel(content, "Backpack", originX, layout.labelY, hidden > 0 ? `+${hidden} more` : undefined);
            for(let r = 0; r < rows; r++)for(let c = 0; c < cols; c++){
                const item = parsed.materials[r * cols + c];
                content.addChild(this.makeSlot(item, originX + c * (slot + gap), layout.gridY + r * (slot + gap), card, $98fc6d407c9f2a1f$var$COLOR.gold, slot, true));
            }
        }, this.drawCraftingTitleBar = (content, parsed)=>{
            this.drawPanelTitle(content, "Crafting", "hammer");
            // Header action (e.g. "Inventory") — out to the right margin, left of the close disc.
            let bx = this.panelW - $98fc6d407c9f2a1f$var$HEADER_RIGHT_MARGIN - this.headerCloseRoom();
            parsed.headerActions.forEach((action)=>{
                const btnW = 82;
                const button = $98fc6d407c9f2a1f$var$makeButton(action.text, btnW, $98fc6d407c9f2a1f$var$HEADER_BUTTON_H, ()=>this.emit(action.event));
                bx -= btnW;
                button.x = bx;
                button.y = $98fc6d407c9f2a1f$var$HEADER_BUTTON_Y;
                content.addChild(button);
                bx -= 6;
            });
        }, /**
     * The filter bar: a category dropdown and a search box, on one row above the list.
     *
     * This replaced a row of category tab chips. Tabs could only ever show ONE group, and with every
     * recipe now listed the view a player wants most often is all of them -- "All" is not a tab you
     * can add, it is the absence of one. Four chips plus their counts also did not fit across a 316px
     * panel, so they wrapped to a second row and took that space out of the list itself.
     */ this.drawFilterBar = (content, x, y, right)=>{
            const h = 26;
            const dropW = 96;
            // --- the category dropdown
            const current = (0, $d3bd591c0da8302e$export$a0b2823229be2588)(this.craftingGroup);
            const drop = $98fc6d407c9f2a1f$var$makeButton(`${current}  \u{25BE}`, dropW, h, ()=>{
                this.craftingDropdownOpen = !this.craftingDropdownOpen;
                this.refreshCrafting();
            });
            drop.x = x;
            drop.y = y;
            content.addChild(drop);
            // --- the search box
            const boxX = x + dropW + 6;
            const boxW = right - boxX;
            // A groove cut into the board, with a magnifier at its left end so an empty box still says
            // what it is for (the DOM field over it leaves room -- see SEARCH_GLYPH_INSET).
            const box = new (0, $gwPoJ.Graphics)();
            $98fc6d407c9f2a1f$var$drawSocket(box, 0, 0, boxW, h, $98fc6d407c9f2a1f$var$COLOR.slotEmpty, 4);
            if (this.craftingSearchFocused) {
                box.lineStyle({
                    width: 1.5,
                    color: $98fc6d407c9f2a1f$var$COLOR.slotHover,
                    alpha: 1,
                    join: (0, $gwPoJ.LINE_JOIN).MITER
                });
                (0, $658a44ce960354bb$export$99dca9ebbafa6899)(box, 0.75, 0.75, boxW - 1.5, h - 1.5, 4);
                box.lineStyle(0);
            }
            box.addChild($98fc6d407c9f2a1f$var$glyph("lens", h / 2 + 1, h / 2, 12, this.craftingSearchFocused ? $98fc6d407c9f2a1f$var$COLOR.gold : $98fc6d407c9f2a1f$var$COLOR.textMuted));
            box.x = boxX;
            box.y = y;
            // Reserve this area for the DOM input, including the brief gap before it is positioned.
            box.interactive = true;
            box.cursor = "text";
            content.addChild(box);
            // The box is only a FRAME. A real DOM <input> sits over it carrying the text and the caret --
            // the one thing that raises a phone's keyboard, and the reason this box is not drawn text fed
            // from document keydowns the way it started out. See search_field.ts.
            this.placeSearchField(box, boxW, h);
            // A way out that does not need the keyboard, for a thumb.
            const typed = this.craftingQuery;
            if (typed) {
                const clear = $98fc6d407c9f2a1f$var$text("\u2715", "compactBody", $98fc6d407c9f2a1f$var$COLOR.textMuted);
                clear.x = boxW - 18;
                clear.y = (h - clear.height) / 2;
                clear.interactive = true;
                clear.cursor = "pointer";
                const wipe = ()=>{
                    this.craftingQuery = "";
                    this.craftingScrollY = 0;
                    this.searchField?.show(this.searchRect ?? {
                        left: 0,
                        top: 0,
                        width: 0,
                        height: 0
                    }, "");
                    this.refreshCrafting();
                };
                clear.on("click", wipe);
                clear.on("tap", wipe);
                box.addChild(clear);
            }
            // --- "can make now", on its own row so the search box keeps the width it needs to be typed
            // into. Three controls across a 316px panel leaves the box too narrow to read what you typed.
            const toggleY = y + h + 6;
            const on = this.craftingCraftableOnly;
            // A small socket that takes a gold check, beside its words: the board's own checkbox.
            const toggleLabel = $98fc6d407c9f2a1f$var$text("Can make now", "compactBody", on ? $98fc6d407c9f2a1f$var$COLOR.text : $98fc6d407c9f2a1f$var$COLOR.textMuted, on);
            const tick = 12;
            const toggleW = tick + 8 + toggleLabel.width + 8;
            const toggle = new (0, $gwPoJ.Graphics)();
            toggle.beginFill(0xffffff, 0.001);
            toggle.drawRect(0, 0, toggleW, 22);
            toggle.endFill();
            $98fc6d407c9f2a1f$var$drawSocket(toggle, 0, 5, tick, tick, on ? $98fc6d407c9f2a1f$var$COLOR.slotFill : $98fc6d407c9f2a1f$var$COLOR.slotEmpty, 2);
            toggle.lineStyle({
                width: 1,
                color: on ? $98fc6d407c9f2a1f$var$COLOR.slotHover : (0, $658a44ce960354bb$export$dd27ce85ad53c944),
                alpha: on ? 1 : 0.7,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(toggle, 0.5, 5.5, tick - 1, tick - 1, 2);
            toggle.lineStyle(0);
            if (on) {
                toggle.lineStyle({
                    width: 2,
                    color: $98fc6d407c9f2a1f$var$COLOR.slotHover,
                    alpha: 1,
                    cap: (0, $gwPoJ.LINE_CAP).ROUND,
                    join: (0, $gwPoJ.LINE_JOIN).ROUND
                });
                toggle.moveTo(3, 11).lineTo(5.5, 13.8).lineTo(9.5, 8);
                toggle.lineStyle(0);
            }
            toggle.x = x;
            toggle.y = toggleY;
            toggle.interactive = true;
            toggle.cursor = "pointer";
            const flip = ()=>{
                this.craftingCraftableOnly = !this.craftingCraftableOnly;
                const filter = this.parseCrafting(this.message).filter;
                this.emit(this.craftingCraftableOnly ? filter?.enable : filter?.disable);
                this.craftingScrollY = 0;
                this.refreshCrafting();
            };
            toggle.on("click", flip);
            toggle.on("tap", flip);
            toggleLabel.x = tick + 8;
            toggleLabel.y = (22 - toggleLabel.height) / 2;
            toggle.addChild(toggleLabel);
            content.addChild(toggle);
            return toggleY + 22 + 8;
        }, /**
     * The dropdown's options, drawn OVER the list.
     *
     * Added to the panel last and positioned absolutely rather than taking part in the column's
     * layout, so opening it does not shove the recipes down and then pull them back up again.
     */ this.drawFilterOptions = (content, x, y)=>{
            if (!this.craftingDropdownOpen) return;
            const w = 96;
            const rowH = 24;
            const menu = new (0, $gwPoJ.Graphics)();
            $98fc6d407c9f2a1f$var$drawPlate(menu, 0, 0, w, (0, $d3bd591c0da8302e$export$bec7d8138cfd7e50).length * rowH + 8, {
                face: $98fc6d407c9f2a1f$var$COLOR.panelFill,
                faceAlpha: 0.99,
                rim: $98fc6d407c9f2a1f$var$COLOR.gold,
                rimAlpha: 0.9
            });
            menu.x = x;
            menu.y = y;
            menu.interactive = true;
            content.addChild(menu);
            (0, $d3bd591c0da8302e$export$bec7d8138cfd7e50).forEach((group, i)=>{
                const selected = group === this.craftingGroup;
                // The chosen group is lit, not inverted: warm face and a gold tick, ink unchanged.
                const row = new (0, $gwPoJ.Graphics)();
                row.beginFill(selected ? $98fc6d407c9f2a1f$var$COLOR.panelFillTop : 0xffffff, selected ? 1 : 0.001);
                (0, $658a44ce960354bb$export$99dca9ebbafa6899)(row, 0, 0, w - 8, rowH - 2, 3);
                row.endFill();
                if (selected) {
                    row.beginFill($98fc6d407c9f2a1f$var$COLOR.slotHover, 1);
                    row.drawRect(0, 4, 2, rowH - 10);
                    row.endFill();
                }
                row.x = 4;
                row.y = 4 + i * rowH;
                row.interactive = true;
                row.cursor = "pointer";
                const pick = ()=>{
                    this.craftingGroup = group;
                    this.craftingDropdownOpen = false;
                    // A new filter is a new list; arriving part way down one reads as a broken panel.
                    this.craftingScrollY = 0;
                    this.refreshCrafting();
                };
                row.on("click", pick);
                row.on("tap", pick);
                const label = $98fc6d407c9f2a1f$var$text((0, $d3bd591c0da8302e$export$a0b2823229be2588)(group), "compactBody", selected ? $98fc6d407c9f2a1f$var$COLOR.text : $98fc6d407c9f2a1f$var$COLOR.textMuted, selected);
                label.x = 8;
                label.y = (rowH - 2 - label.height) / 2;
                row.addChild(label);
                menu.addChild(row);
            });
        }, /**
     * Put the real <input> over the frame the panel just drew, and keep it there.
     *
     * Called on every rebuild, because the box moves: the panel is redrawn for every server message,
     * every scroll and every keystroke. The NODE is not rebuilt with it -- it is parented to the page,
     * not to the panel -- which is the whole reason this is a bare DOM element rather than a
     * pixi-text-input like the chat composer's. That library parents its node to a display object and
     * re-appends it whenever that object is re-added, so a field inside this panel would lose focus
     * after a single letter.
     */ this.placeSearchField = (box, boxW, boxH)=>{
            this.searchField = this.searchField ?? this.makeSearchField();
            this.searchBox = {
                box: box,
                w: boxW,
                h: boxH
            };
            // DEFERRED, and this is the whole subtlety. `assemble` builds the panel and hands it back for
            // the caller to add to the surface, so while this runs the box has no path to the stage at
            // all -- getGlobalPosition() reports a position inside a detached subtree, missing the dock
            // offset that puts the panel on the right-hand side of the screen. The field ended up some
            // 470px left of the box it is supposed to be sitting in, which is invisible against a dark
            // game and reads exactly like a field that cannot be clicked.
            //
            // One timeout per rebuild, which is cheap: a bounds read and a few style writes.
            setTimeout(this.positionSearchField, 0);
        }, this.positionSearchField = ()=>{
            const held = this.searchBox;
            const field = this.searchField;
            const view = this.canvas();
            if (!held || !field || !view || held.box.destroyed) return;
            // Include the panel and stage scales when placing the DOM input over its canvas frame.
            const global = held.box.toGlobal({
                x: 0,
                y: 0
            });
            const end = held.box.toGlobal({
                x: held.w,
                y: held.h
            });
            const rect = (0, $d8f28c464fcc8750$export$95a22a72d3b9c87e)({
                x: global.x,
                y: global.y,
                width: end.x - global.x,
                height: end.y - global.y
            }, this.rendererScreen(), view.getBoundingClientRect());
            this.searchRect = rect;
            field.show(rect, this.craftingQuery);
        }, this.makeSearchField = ()=>new (0, $d8f28c464fcc8750$export$b94867ecbd698f21)({
                placeholder: "Search\u2026",
                leadingInset: $98fc6d407c9f2a1f$var$SEARCH_GLYPH_INSET,
                ariaLabel: "Search recipes",
                onFocus: ()=>{
                    // The game must stop reading the keyboard the moment the field takes it, not on the
                    // first letter -- otherwise typing "w" walks the player north as well.
                    if (this.applySearchFocus(true)) this.refreshCrafting();
                },
                onInput: (value)=>{
                    this.craftingQuery = value;
                    // A narrowed list is a different list; keeping the old offset can leave it blank.
                    this.craftingScrollY = 0;
                    this.craftingSearchFocused = true;
                    this.refreshCrafting();
                },
                onBlur: ()=>{
                    if (!this.craftingSearchFocused) return;
                    this.craftingSearchFocused = false;
                    this.logic.playerController.enabledKeyboardAction(true);
                    this.modal?.suspendEscape(false);
                    this.refreshCrafting();
                }
            }), /**
     * Move the keyboard between the player and the search box, WITHOUT redrawing.
     *
     * Split out because the two callers that matter are already mid-redraw: a reveal clears the
     * filters while the panel is being built, and the close handler runs while it is being torn down.
     * Asking either of them for a rebuild is at best wasted and at worst re-entrant.
     *
     * Returns whether anything changed, so the caller that CAN redraw only does so when it needs to.
     */ this.applySearchFocus = (focused)=>{
            if (focused === this.craftingSearchFocused) return false;
            this.craftingSearchFocused = focused;
            if (focused) {
                this.logic.playerController.enabledKeyboardAction(false);
                this.modal?.suspendEscape(true);
            } else {
                this.modal?.suspendEscape(false);
                this.logic.playerController.enabledKeyboardAction(true);
                this.searchField?.blurNode();
            }
            return true;
        }, this.rendererScreen = ()=>{
            try {
                const screen = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer.screen;
                return {
                    width: screen.width,
                    height: screen.height
                };
            } catch (e) {
                return {
                    width: 0,
                    height: 0
                };
            }
        }, /**
     * The recipe list: one card per recipe, in a window it scrolls inside.
     *
     * Every card is drawn, not just the visible ones. Virtualising looked tempting -- `assemble`
     * sizes the panel from what was drawn, and a masked child still reports its full height to
     * getLocalBounds -- but the fix for that is to TELL assemble the height (craftingLayout already
     * knows it), and drawing the lot means a gesture can move the list by shifting one container
     * instead of rebuilding the panel. That matters: rebuilding mid-drag destroys the very display
     * object handling the drag, which is why the first attempt scrolled nowhere.
     */ this.drawRecipes = (content, recipes, parsed, x, y, right, layout)=>{
            if (recipes.length < 1) {
                // Names the filter that emptied the list rather than saying a bare "no recipes", because
                // the fixes are different and the player cannot see which one is in their way.
                const reason = parsed.empty ? "No recipes available yet." : (0, $d3bd591c0da8302e$export$9fcff8a5073a2444)(this.craftingGroup, this.craftingQuery, this.craftingCraftableOnly);
                const msg = $98fc6d407c9f2a1f$var$text(reason, "compactBody", $98fc6d407c9f2a1f$var$COLOR.textMuted);
                msg.x = x;
                msg.y = y + 6;
                content.addChild(msg);
                return;
            }
            const { cardH: cardH, viewH: viewH, maxScroll: maxScroll } = layout;
            const scrollable = maxScroll > 0;
            // The bar takes a sliver off the cards' width, but only when there is something to scroll.
            const cardW = right - x - (scrollable ? $98fc6d407c9f2a1f$var$SCROLLBAR_W + 6 : 0);
            const window1 = new (0, $8t5Gy.Container)();
            window1.x = x;
            window1.y = y;
            content.addChild(window1);
            // The part that actually moves. Everything else about the list stays put.
            const strip = new (0, $8t5Gy.Container)();
            window1.addChild(strip);
            this.recipeStrip = strip;
            this.recipeMaxScroll = maxScroll;
            recipes.forEach((recipe, i)=>{
                // The card is drawn in STRIP coordinates, but the tutorial clue that may point at it is
                // registered in the panel's -- see recipeRowPlacement.
                const placement = (0, $a5a3df2f3994c840$export$f56c163cec589c17)(i, cardH, this.craftingScrollY, viewH, x, y);
                this.drawRecipeCard(strip, recipe, 0, i * (cardH + (0, $a5a3df2f3994c840$export$b6095232b96cb2d5)), cardW, cardH, placement.visible ? placement : undefined);
            });
            strip.y = -this.craftingScrollY;
            if (!scrollable) {
                this.recipeStrip = undefined;
                return;
            }
            const mask = new (0, $gwPoJ.Graphics)();
            mask.beginFill(0xffffff, 1);
            mask.drawRect(0, 0, right - x, viewH);
            mask.endFill();
            window1.addChild(mask);
            window1.mask = mask;
            // Drag anywhere in the list, including across a card. Bound to the WINDOW rather than a
            // surface laid over the cards, so a press still reaches the Craft button underneath it; pixi
            // bubbles the pointer events up to here either way.
            window1.interactive = true;
            window1.hitArea = new (0, $6qzqq.Rectangle)(0, 0, right - x, viewH);
            this.bindRecipeDrag(window1);
            this.drawScrollbar(content, right - $98fc6d407c9f2a1f$var$SCROLLBAR_W, y, viewH, layout);
        }, /** Move the list to a new offset without rebuilding the panel. */ this.scrollRecipesTo = (next)=>{
            const clamped = (0, $a5a3df2f3994c840$export$74e32579ce8387f2)(next, this.recipeMaxScroll);
            if (clamped === this.craftingScrollY) return;
            this.craftingScrollY = clamped;
            if (this.recipeStrip) this.recipeStrip.y = -clamped;
            this.positionScrollThumb();
        }, /**
     * The bar beside a scrolling list -- the part that says there is more, and the part you grab.
     *
     * A page turn at least announced itself ("Page 1 of 2"); a scroll that looks like a short list is
     * worse than either. Wide enough to actually hit with a pointer: the first cut was 4px, which read
     * as a decoration and could not be gripped. The track is clickable too, so a tap below the thumb
     * jumps a window down rather than requiring a drag.
     */ this.drawScrollbar = (content, x, y, viewH, layout)=>{
            const track = new (0, $gwPoJ.Graphics)();
            $98fc6d407c9f2a1f$var$drawSocket(track, 0, 0, $98fc6d407c9f2a1f$var$SCROLLBAR_W, viewH, $98fc6d407c9f2a1f$var$COLOR.slotEmpty, 3);
            track.x = x;
            track.y = y;
            track.interactive = true;
            track.cursor = "pointer";
            content.addChild(track);
            const thumbH = Math.max($98fc6d407c9f2a1f$var$SCROLLBAR_MIN_THUMB, viewH * viewH / layout.contentH);
            // A bronze bar riding in the groove, lit along its top.
            const thumb = new (0, $gwPoJ.Graphics)();
            thumb.lineStyle({
                width: 1,
                color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
                alpha: 1,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            thumb.beginFill((0, $658a44ce960354bb$export$dd27ce85ad53c944), 1);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(thumb, 1, 1, $98fc6d407c9f2a1f$var$SCROLLBAR_W - 2, thumbH - 2, 2);
            thumb.endFill();
            thumb.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.7).moveTo(3, 2.5).lineTo($98fc6d407c9f2a1f$var$SCROLLBAR_W - 3, 2.5);
            thumb.lineStyle(0);
            thumb.interactive = true;
            thumb.cursor = "pointer";
            track.addChild(thumb);
            this.scrollThumb = thumb;
            this.scrollTravel = Math.max(0, viewH - thumbH);
            this.positionScrollThumb();
            // Drag the thumb: travel maps to scroll offset, not 1:1 with the pointer.
            let grabbed = null;
            let grabbedScroll = 0;
            thumb.on("pointerdown", (event)=>{
                grabbed = event.data.global.y;
                grabbedScroll = this.craftingScrollY;
                event.stopPropagation();
            });
            const moveThumb = (event)=>{
                if (grabbed === null || this.scrollTravel <= 0) return;
                const travelled = event.data.global.y - grabbed;
                this.scrollRecipesTo(grabbedScroll + travelled / this.scrollTravel * this.recipeMaxScroll);
            };
            const releaseThumb = ()=>{
                grabbed = null;
            };
            thumb.on("pointermove", moveThumb);
            thumb.on("pointerup", releaseThumb);
            thumb.on("pointerupoutside", releaseThumb);
            // The pointer leaves a 10px-wide thumb almost immediately during a drag, so the move has to be
            // followed on the track behind it as well.
            track.on("pointermove", moveThumb);
            track.on("pointerup", releaseThumb);
            track.on("pointerupoutside", releaseThumb);
            // A tap on the track above or below the thumb pages towards it.
            track.on("pointertap", (event)=>{
                const local = event.data.getLocalPosition(track);
                if (local.y >= thumb.y && local.y <= thumb.y + thumbH) return;
                this.scrollRecipesTo(this.craftingScrollY + (local.y < thumb.y ? -viewH : viewH));
            });
        }, this.positionScrollThumb = ()=>{
            if (!this.scrollThumb) return;
            const progress = this.recipeMaxScroll > 0 ? this.craftingScrollY / this.recipeMaxScroll : 0;
            this.scrollThumb.y = progress * this.scrollTravel;
        }, /**
     * Press and drag the list itself.
     *
     * The drag threshold matters: a card's Craft button is inside the area being dragged, and pixi
     * delivers that button's own click after the gesture ends. The flag is checked by the button
     * rather than the event being cancelled, because by then it is too late to cancel.
     */ this.bindRecipeDrag = (window1)=>{
            let from = null;
            let fromScroll = 0;
            let blurred = false;
            window1.on("pointerdown", (event)=>{
                // Reaching for the list means you have finished typing. Without this the box keeps the
                // keyboard -- and therefore the player's movement keys -- until the player happens to
                // press Escape or close the panel, which is a worse trap than the one it replaces.
                //
                // The REDRAW that shows the box unfocused waits for the gesture to end. Rebuilding here
                // would destroy this very `window` in the middle of dispatching its own pointerdown, and
                // the pointermove/pointerup that complete the drag would land on a discarded object --
                // the exact failure that made the first version of this scroll scroll nowhere.
                blurred = this.applySearchFocus(false);
                from = event.data.global.y;
                fromScroll = this.craftingScrollY;
                this.recipeDragMoved = false;
            });
            window1.on("pointermove", (event)=>{
                if (from === null) return;
                const travelled = from - event.data.global.y;
                if (Math.abs(travelled) > $98fc6d407c9f2a1f$var$DRAG_SLOP) this.recipeDragMoved = true;
                this.scrollRecipesTo(fromScroll + travelled);
            });
            const up = ()=>{
                from = null;
                // Cleared a frame later: the Craft button's own click lands after pointerup, and it is
                // that click the flag exists to swallow.
                setTimeout(()=>{
                    this.recipeDragMoved = false;
                    // ...and the deferred redraw for a search box this gesture un-focused goes here too,
                    // once nothing is left dispatching against the tree it replaces.
                    if (blurred) {
                        blurred = false;
                        this.refreshCrafting();
                    }
                }, 0);
            };
            window1.on("pointerup", up);
            window1.on("pointerupoutside", up);
        }, /**
     * Fade the reveal glow out, on the ticker.
     *
     * Per frame it touches one `alpha`, not the panel: rebuilding the whole screen ninety times to
     * fade one rectangle would be absurd, and would also fight the player -- a rebuild mid-drag
     * destroys the display object handling the drag, which is a trap this panel has already been
     * caught by once.
     *
     * Idempotent, and it stops itself. The one rebuild it does ask for is the last one, to drop the
     * glow node cleanly rather than leaving an invisible Graphics on every card the player visits.
     */ this.startGlow = ()=>{
            if (this.glowTick) return;
            const ticker = this.ticker();
            if (!ticker) // No ticker to ride: show the glow at full and let the next rebuild clear it. Better a
            // glow that overstays than a panel that throws trying to animate one.
            return;
            this.glowTick = ()=>{
                const elapsed = Date.now() - this.glowStart;
                const alpha = (0, $d3bd591c0da8302e$export$617576e570fdd953)(elapsed);
                if (this.glowNode) this.glowNode.alpha = alpha;
                if (elapsed >= (0, $d3bd591c0da8302e$export$91be09654db10545)) {
                    this.stopGlow();
                    this.refreshCrafting();
                }
            };
            ticker.add(this.glowTick);
        }, this.stopGlow = ()=>{
            if (this.glowTick) this.ticker()?.remove(this.glowTick);
            this.glowTick = undefined;
            this.glowNode = undefined;
            this.glowItem = undefined;
        }, this.ticker = ()=>{
            try {
                return (0, $065c5647ab3ff4dc$export$56359d4511c7424)().ticker;
            } catch (e) {
                return undefined;
            }
        }, /**
     * The mouse wheel -- and a two-finger trackpad drag, which is the same event.
     *
     * pixi 6's InteractionManager handles pointer, mouse and touch events but NOT `wheel`: an
     * `on("wheel")` on a display object is simply never called. It has to come off the DOM canvas.
     *
     * NOT filtered by pointer position. The first cut tested the pointer against the recipe window's
     * `getBounds()`, which silently rejected every wheel: those bounds are in STAGE space, while a
     * client coordinate converts to the canvas BUFFER, and the two differ by the stage transform and
     * the letterbox. Rather than redo that conversion, note that nothing else in the client listens
     * for a wheel at all -- so while this panel is up with a list that can scroll, the wheel is
     * unambiguously the list's.
     *
     * Installed once per dialog and removed on close, so a stale listener cannot outlive the panel and
     * scroll a list that is no longer on screen.
     */ this.attachWheel = ()=>{
            const view = this.canvas();
            if (!view || this.wheelListener) return;
            this.wheelListener = (event)=>{
                if (this.recipeMaxScroll <= 0 || !this.recipeStrip) return;
                event.preventDefault();
                // The list is behind the quantity picker's scrim, and "answer this first" covers the
                // wheel too.
                if (this.quantityPicker) return;
                this.scrollRecipesTo(this.craftingScrollY + event.deltaY);
            };
            view.addEventListener("wheel", this.wheelListener, {
                passive: false
            });
        }, this.detachWheel = ()=>{
            const view = this.canvas();
            if (view && this.wheelListener) view.removeEventListener("wheel", this.wheelListener);
            this.wheelListener = undefined;
        }, // The pixi canvas, via the two-function module that exists so callers needing only the
        // Application do not drag the whole renderer's import graph along. Never throws out here: a
        // missing canvas costs the wheel, not the panel.
        this.canvas = ()=>{
            try {
                return (0, $065c5647ab3ff4dc$export$56359d4511c7424)().view;
            } catch (e) {
                return undefined;
            }
        }, this.drawRecipeCard = (content, recipe, x, y, w, h, // Where this row lands on the PANEL, for the tutorial clue. Absent when the row is scrolled
        // out of the window, which is also "do not point at this".
        placement)=>{
            const enabled = recipe.enabled;
            const card = new (0, $gwPoJ.Graphics)();
            card.x = x;
            card.y = y;
            // The reveal's glow, drawn BEHIND the card so it reads as light coming off it rather than a
            // border drawn on it. Three fattening, fading strokes rather than a filter -- filters are a
            // per-object render pass and this has to be cheap on a low-end machine (see the budget
            // hardware note); concentric strokes cost three draw calls and look much the same.
            if (this.glowItem && recipe.name === this.glowItem) {
                const glow = new (0, $gwPoJ.Graphics)();
                for(let ring = 3; ring >= 1; ring--){
                    glow.lineStyle({
                        width: ring * 2,
                        color: $98fc6d407c9f2a1f$var$COLOR.slotHover,
                        alpha: 0.16 * (4 - ring),
                        join: (0, $gwPoJ.LINE_JOIN).MITER
                    });
                    (0, $658a44ce960354bb$export$99dca9ebbafa6899)(glow, x - ring, y - ring, w + ring * 2, h + ring * 2, $98fc6d407c9f2a1f$var$PLATE_CHAMFER + ring);
                }
                glow.lineStyle(0);
                glow.alpha = (0, $d3bd591c0da8302e$export$617576e570fdd953)(Date.now() - this.glowStart);
                content.addChild(glow);
                // Kept so the ticker can fade it without rebuilding the panel around it.
                this.glowNode = glow;
            }
            // A plate on the board. One that can be made now stands proud and warm; one that cannot is
            // laid flat and darker, so the makeable rows read first without hiding the rest.
            $98fc6d407c9f2a1f$var$drawPlate(card, 0, 0, w, h, enabled ? {
                face: 0x221911,
                rim: (0, $658a44ce960354bb$export$dd27ce85ad53c944),
                rimAlpha: 0.6
            } : {
                face: 0x15100c,
                faceAlpha: 0.9,
                rim: $98fc6d407c9f2a1f$var$COLOR.slotBorder,
                rimAlpha: 0.9,
                shadow: false
            });
            content.addChild(card);
            // Square icon well filling the card height. The padding tracks the card height so a card
            // compressed to make room for the backpack still holds both text lines (name + ingredients).
            const pad = Math.max(4, Math.round((h - 34) / 2));
            const iconSize = h - pad * 2;
            $98fc6d407c9f2a1f$var$drawSocket(card, pad, pad, iconSize, iconSize, enabled ? $98fc6d407c9f2a1f$var$COLOR.slotFill : $98fc6d407c9f2a1f$var$COLOR.slotEmpty);
            if (recipe.spriteId) {
                const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: recipe.spriteId,
                    scale: iconSize / 52 * 0.95,
                    color: enabled ? 0xffffff : 0xa3927a,
                    animated: false,
                    rotating: false
                });
                card.addChild(sprite);
                $98fc6d407c9f2a1f$var$fitItemIcon(sprite, pad, pad, iconSize);
            }
            const btnW = 64;
            const btnH = 24;
            const btnX = w - btnW - pad;
            const btnY = (h - btnH) / 2;
            const textX = pad + iconSize + 10;
            // "Stick ×5" — what one craft actually makes. A stick recipe yields five and an arrow recipe
            // ten, which the row never said, so a player short of sticks had no way to know how little
            // wood would cover it. `label` is the server's name for the row, which says the colour when
            // two recipes share a type (there are two daggers).
            const base = $98fc6d407c9f2a1f$var$prettify(recipe.label || recipe.name);
            const yielded = (recipe.yield ?? 1) > 1 ? `${base} \xd7${recipe.yield}` : base;
            const name = $98fc6d407c9f2a1f$var$text(yielded, "caption", enabled ? $98fc6d407c9f2a1f$var$COLOR.text : $98fc6d407c9f2a1f$var$COLOR.textMuted, true);
            name.x = textX;
            name.y = pad;
            card.addChild(name);
            // Second line: the whole price, every ingredient the player is SHORT of first and in red.
            //
            // Short-first is what fixes the reported bug. The line only has room for a chip or two, and
            // picking what to show by recipe order meant a rabbit snare (3 sticks, 1 rope) told a player
            // holding ten sticks and no rope "need 3 stick (have 10)" — the one ingredient they had, and
            // no mention of the one they didn't.
            //
            // Each chip is its own Text so a short one can be a CONTROL: tapping it opens that material's
            // recipe, or says where the stuff comes from when nothing makes it. That is the step that
            // turns a greyed row from a dead end into a plan.
            const lineY = name.y + name.height + 1;
            if (recipe.full) {
                // Stated INSTEAD of the price, because the price is not the problem: every chip would read
                // satisfied. A player holding eighteen straw was told a rope needs "3/3 straw" and left to
                // work out that the real answer was a full backpack.
                const msg = $98fc6d407c9f2a1f$var$text("Backpack full", "compactCaption", $98fc6d407c9f2a1f$var$COLOR.shortfall);
                msg.x = textX;
                msg.y = lineY;
                card.addChild(msg);
            } else if (recipe.cost && recipe.cost.length > 0) {
                // Chars the ingredient line has room for: the gap between the icon well and the Craft
                // button, over a measured character width.
                const maxChars = Math.max(1, Math.floor((btnX - 6 - textX) / $98fc6d407c9f2a1f$export$a6613d83a13315d7()));
                let cx = textX;
                (0, $e5ed6231df7ea832$export$616974f9a0f955c4)(recipe.cost, maxChars).forEach((chip, i)=>{
                    if (chip.lead) {
                        const sep = $98fc6d407c9f2a1f$var$text(chip.lead, "compactCaption", $98fc6d407c9f2a1f$var$COLOR.textMuted);
                        sep.x = cx;
                        sep.y = lineY;
                        card.addChild(sep);
                        cx += sep.width;
                    }
                    const t = $98fc6d407c9f2a1f$var$text(chip.text, "compactCaption", chip.missing ? $98fc6d407c9f2a1f$var$COLOR.shortfall : $98fc6d407c9f2a1f$var$COLOR.textMuted);
                    t.x = cx;
                    t.y = lineY;
                    card.addChild(t);
                    const ingredient = (0, $e5ed6231df7ea832$export$770de5cd5a50d909)(recipe.cost)[i];
                    if (chip.hidden) {
                        // The `+N` tail: not an ingredient but a control that reveals the whole price.
                        // Underlined like the jumpable chips, in its own muted colour, so the line says
                        // "there is more here" rather than merely trailing off.
                        t.interactive = true;
                        t.cursor = "pointer";
                        const rule = new (0, $gwPoJ.Graphics)();
                        rule.beginFill($98fc6d407c9f2a1f$var$COLOR.textMuted, 0.5);
                        rule.drawRect(t.x, lineY + t.height - 1, t.width, 1);
                        rule.endFill();
                        card.addChild(rule);
                        t.on("mouseover", ()=>t.tint = $98fc6d407c9f2a1f$var$COLOR.text);
                        t.on("mouseout", ()=>t.tint = 0xffffff);
                        const reveal = ()=>{
                            if (this.recipeDragMoved) return;
                            // A second tap on the same tail puts it away: the control that opened the
                            // popover is the nearest thing to hand for closing it.
                            this.recipePopover = this.recipePopover === recipe.name ? undefined : recipe.name;
                            this.refreshCrafting();
                        };
                        t.on("click", reveal);
                        t.on("tap", reveal);
                        // Reported in PANEL coordinates, and only while the row is actually on screen --
                        // `assemble` draws it once the panel's height is known. Anchored on the tail so
                        // the box hangs off the thing that was tapped.
                        if (placement && this.recipePopover === recipe.name) this.pendingPopover = {
                            title: yielded,
                            cost: recipe.cost,
                            x: placement.x + t.x,
                            y: placement.y + lineY,
                            h: t.height
                        };
                    } else if (chip.actionable && ingredient?.jumpEvent) {
                        t.interactive = true;
                        t.cursor = "pointer";
                        // Underlined, so it reads as somewhere to go rather than just more red text.
                        const rule = new (0, $gwPoJ.Graphics)();
                        rule.beginFill($98fc6d407c9f2a1f$var$COLOR.shortfall, 0.6);
                        rule.drawRect(t.x, lineY + t.height - 1, t.width, 1);
                        rule.endFill();
                        card.addChild(rule);
                        const jump = ()=>{
                            if (this.recipeDragMoved) return;
                            this.emit(ingredient.jumpEvent);
                        };
                        t.on("click", jump);
                        t.on("tap", jump);
                    } else if (chip.source) {
                        // Nothing makes this, so there is nowhere to jump to — say where to look instead.
                        t.interactive = true;
                        t.cursor = "help";
                        const tell = ()=>{
                            if (!this.recipeDragMoved) // Reuses the slot hover pill: same "what is this" affordance the backpack
                            // already has, pointed at a word in the ingredient line instead of a slot.
                            this.showNamePill(`${$98fc6d407c9f2a1f$var$prettify(ingredient.itemType)} \u{2014} ${chip.source}`, x + t.x, y + lineY, 16);
                        };
                        t.on("click", tell);
                        t.on("tap", tell);
                        t.on("mouseover", tell);
                        t.on("mouseout", this.hideNamePill);
                    }
                    cx += t.width;
                });
            } else {
                // No structured cost on this payload: fall back to the server's prose, which at least
                // marks the ingredient it is short of.
                const reason = !enabled ? (0, $e5ed6231df7ea832$export$2c2ee042b1dccca8)(recipe.disabledReason) : undefined;
                const line = reason || recipe.ingredients.join(",  ");
                if (line) {
                    const t = $98fc6d407c9f2a1f$var$text(line, "compactCaption", reason ? $98fc6d407c9f2a1f$var$COLOR.shortfall : $98fc6d407c9f2a1f$var$COLOR.textMuted);
                    t.x = textX;
                    // Hung off the name's own height rather than a fixed offset — a compressed card has no
                    // spare pixels to lose to a guessed line height.
                    t.y = lineY;
                    card.addChild(t);
                }
            }
            // The campfire row is the third clue in the ember tutorial's chain. Reported whether or not the
            // button is live: a greyed row with "need 2 wood" on it is still the row they are looking for.
            // In PANEL coordinates, not the scrolling strip's, and only when the row is on screen.
            // The spotlight leaves the whole row lit, not just its button: what is being made is on it.
            const row = placement && {
                x: placement.x,
                y: placement.y,
                w: w,
                h: h
            };
            if (placement && (recipe.name || "").toLowerCase() === $98fc6d407c9f2a1f$var$CLUED_ITEM) this.clueAt("ember-recipe", placement.x + btnX, placement.y + btnY, btnW, btnH, row);
            for (const entry of (0, $9600e6b065d22e57$export$b131041a3ede9882))if (placement && (recipe.name || "").toLowerCase() === entry.itemType) this.clueAt(entry.recipe, placement.x + btnX, placement.y + btnY, btnW, btnH, row);
            // Craft button (enabled) or a grayed placeholder (disabled).
            if (enabled) {
                const craftBtn = $98fc6d407c9f2a1f$var$makeButton("Craft", btnW, btnH, ()=>this.craftRecipe(recipe, base), {
                    primary: true
                });
                craftBtn.x = btnX;
                craftBtn.y = btnY;
                card.addChild(craftBtn);
            } else {
                // Not a button you can press, so not drawn as one: the same outline, sunk flat into the plate.
                const disabled = new (0, $gwPoJ.Graphics)();
                $98fc6d407c9f2a1f$var$drawSocket(disabled, 0, 0, btnW, btnH, $98fc6d407c9f2a1f$var$COLOR.slotEmpty, 4);
                const dl = $98fc6d407c9f2a1f$var$text("Craft", "compactLabel", 0x6f604c);
                dl.x = (btnW - dl.width) / 2;
                dl.y = (btnH - dl.height) / 2;
                disabled.addChild(dl);
                disabled.x = btnX;
                disabled.y = btnY;
                card.addChild(disabled);
            }
        }, // =========================================================================
        // TRANSFER — two side-by-side inventories (chest / trade). Each item carries
        // its own Take / Give options; hovering a slot surfaces them.
        // =========================================================================
        this.parseTrade = (message)=>{
            const left = {
                items: [],
                statLines: []
            };
            const right = {
                items: [],
                statLines: []
            };
            const headerActions = [];
            const collect = (node, side)=>{
                if (node.type === "grid") side.items.push(...node.context?.gridMeta || []);
                else if (node.type === "entity") {
                    if (!side.entity) side.entity = {
                        entityId: node.context?.entityId,
                        appearance: node.context?.appearance,
                        inventory: node.context?.inventory
                    };
                } else if (node.type === "sprite" && node.spriteId && node.spriteId !== "action-trade.png") {
                    if (!side.spriteId) side.spriteId = node.spriteId;
                } else if (node.type === "button|dynamic" && node.clickEventEmitter) headerActions.push({
                    text: node.text,
                    event: node.clickEventEmitter
                });
                else if (node.font === "ImportantFont" && node.text) {
                    if (!side.name) side.name = node.text;
                } else if (node.text && /^(HP:|Speed:|Defense:|Mana)/.test(node.text)) side.statLines.push(node.text);
                (node.children || []).forEach((c)=>collect(c, side));
            };
            (message.dynamicText || []).map($98fc6d407c9f2a1f$var$asMeta).filter(Boolean).forEach((node)=>{
                if (node.type === "sprite" && node.spriteId === "action-trade.png") return;
                // The server positions the target (chest) on the left and the origin (player) on the
                // right; bucket every node by its x anchor.
                const x = node.exactLocation?.x ?? 0;
                collect(node, x < 350 ? left : right);
            });
            return {
                left: left,
                right: right,
                headerActions: headerActions
            };
        }, this.createTradeContent = ()=>this.assemble((body, card)=>{
                const parsed = this.parseTrade(this.message);
                // Header action (e.g. "Inventory" when trading with a humanoid) top-right at the margin.
                let bx = this.panelW - 16;
                parsed.headerActions.forEach((action)=>{
                    const btnW = 82;
                    const button = $98fc6d407c9f2a1f$var$makeButton(action.text, btnW, 24, ()=>this.emit(action.event));
                    bx -= btnW;
                    button.x = bx;
                    button.y = 11;
                    body.addChild(button);
                    bx -= 6;
                });
                if (this.horizontalPanel) {
                    const y = 48;
                    const leftBottom = this.drawTradeSection(body, parsed.left, y, card, $98fc6d407c9f2a1f$var$COLOR.gold, "trade-target");
                    const rightBottom = this.drawTradeSection(body, parsed.right, y, card, $98fc6d407c9f2a1f$var$COLOR.readied, "trade-player", $98fc6d407c9f2a1f$var$DOCK_W + 32);
                    this.drawTradeArrow(body, this.panelW / 2, (y + Math.max(leftBottom, rightBottom)) / 2);
                } else {
                    let y = this.drawTradeSection(body, parsed.left, 14, card, $98fc6d407c9f2a1f$var$COLOR.gold, "trade-target");
                    this.drawTradeArrow(body, this.panelW / 2, y + 24);
                    y += 48;
                    this.drawTradeSection(body, parsed.right, y, card, $98fc6d407c9f2a1f$var$COLOR.readied, "trade-player");
                }
            }), // One stacked inventory: [thumbnail][name (+ compact stats)] header, then a grid of its items.
        this.drawTradeSection = (content, side, y, card, accent, target, originX = 0)=>{
            const margin = originX + 16;
            const thumb = 40;
            this.drawTradeThumb(content, side, margin, y, thumb);
            const nameX = margin + thumb + 10;
            const name = $98fc6d407c9f2a1f$var$text(side.name || "", "label", $98fc6d407c9f2a1f$var$COLOR.title, true);
            name.x = nameX;
            name.y = y + 2;
            content.addChild(name);
            // Compact HP line for humanoid sides (chests have no stats).
            const statLine = side.statLines.find((l)=>l.startsWith("HP:"))?.replace("HP: ", "HP ").replace(/\s*\/\s*/, "/");
            if (statLine) {
                const s = $98fc6d407c9f2a1f$var$text(statLine, "compactLabel", $98fc6d407c9f2a1f$var$COLOR.textMuted);
                s.x = nameX;
                s.y = y + 22;
                content.addChild(s);
            }
            // Item grid.
            const gridY = y + thumb + 8;
            const cols = 8;
            const gap = 4;
            const rows = Math.max(2, Math.ceil(side.items.length / cols));
            for(let r = 0; r < rows; r++)for(let c = 0; c < cols; c++){
                const item = side.items[r * cols + c];
                const slot = this.makeSlot(item, margin + c * ($98fc6d407c9f2a1f$var$DOCK_SLOT + gap), gridY + r * ($98fc6d407c9f2a1f$var$DOCK_SLOT + gap), card, accent, $98fc6d407c9f2a1f$var$DOCK_SLOT, false, target);
                content.addChild(slot);
            }
            const bottom = gridY + rows * ($98fc6d407c9f2a1f$var$DOCK_SLOT + gap);
            this.itemSectionTarget(content, target, new (0, $6qzqq.Rectangle)(originX + 8, y - 4, $98fc6d407c9f2a1f$var$DOCK_W - 16, bottom - y + 4));
            return bottom;
        }, // Small framed thumbnail: the player's portrait, or a chest's item sprite.
        this.drawTradeThumb = (content, side, x, y, size)=>{
            $98fc6d407c9f2a1f$var$drawSocket(content, x, y, size, size, 0x17110c, 5);
            content.lineStyle({
                width: 1,
                color: (0, $658a44ce960354bb$export$dd27ce85ad53c944),
                alpha: 0.55,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(content, x - 0.5, y - 0.5, size + 1, size + 1, 5);
            content.lineStyle(0);
            if (side.entity?.appearance || side.entity?.inventory) {
                const entity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
                entity.weapon = {
                    weaponType: (0, $f684496fff50a7a1$export$58361cde22f3aa43)(side.entity.inventory, "weapon")?.type
                };
                entity.appearance = side.entity.appearance;
                entity.inventory = side.entity.inventory;
                const displayer = new (0, $c14ea609224dd88d$export$982d39230018c180)({
                    entityId: side.entity.entityId,
                    scale: 1.4
                }, entity);
                const portrait = displayer.createContent();
                content.addChild(portrait);
                const b = portrait.getLocalBounds();
                if (b.width > 0 && b.height > 0) {
                    const fit = Math.min((size - 6) / b.width, (size - 6) / b.height, 1);
                    portrait.scale.set(fit);
                    portrait.x = x + (size - b.width * fit) / 2 - b.x * fit;
                    portrait.y = y + (size - b.height * fit) / 2 - b.y * fit;
                }
            } else if (side.spriteId) {
                const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: side.spriteId,
                    scale: 0.9,
                    color: 0xffffff,
                    animated: false,
                    rotating: false
                });
                content.addChild(sprite);
                (0, $d634a66159f23623$export$db3e35bb56748094)(sprite, x, y, size);
            }
        }, // The exchange between the two parties: a bronze medallion on a groove running across the panel,
        // carrying the wheel's swap glyph turned to point along the axis joining them.
        this.drawTradeArrow = (content, cx, cy)=>{
            const r = 12;
            if (!this.horizontalPanel) {
                (0, $658a44ce960354bb$export$5ed3e56f5245819d)(content, 16, cx - r - 6, cy);
                (0, $658a44ce960354bb$export$5ed3e56f5245819d)(content, cx + r + 6, this.panelW - 16, cy);
            }
            content.lineStyle(0);
            content.beginFill(0x000000, 0.45).drawCircle(cx, cy + 1.5, r + 0.5).endFill();
            content.beginFill((0, $658a44ce960354bb$export$dd27ce85ad53c944), 1).drawCircle(cx, cy, r).endFill();
            content.lineStyle(1, (0, $658a44ce960354bb$export$c2ea448b59bcc1de), 0.9).drawCircle(cx, cy, r);
            content.lineStyle(0);
            content.beginFill(0x110c08, 1).drawCircle(cx, cy, r - 2.4).endFill();
            const swap = $98fc6d407c9f2a1f$var$glyph("swap", cx, cy, 15, $98fc6d407c9f2a1f$var$COLOR.gold);
            if (!this.horizontalPanel) swap.rotation = Math.PI / 2;
            content.addChild(swap);
        };
        this.panelW = $98fc6d407c9f2a1f$var$DOCK_W;
        this.panelH = $98fc6d407c9f2a1f$var$DOCK_H / $98fc6d407c9f2a1f$var$MOBILE_PANEL_SCALE;
        this.dockX = $98fc6d407c9f2a1f$var$SCALED_DOCK_X;
        // Closing the screen out from under an open picker (close button, Escape, a room change) has
        // to hand the keyboard back. DynamicDialog has already installed onClose by the time this
        // runs, so wrap whatever it set.
        const inherited = this.onClose;
        this.onClose = (clicked)=>{
            this.itemDrag?.cancel();
            this.dismissQuantityPicker();
            // The wheel listener lives on the DOM canvas, which outlives this panel by a long way --
            // left behind it would scroll a recipe list that is no longer on screen.
            this.detachWheel();
            // ...and the search box may be holding the keyboard. Closing the panel out from under it
            // has to give the player their movement keys back -- without asking a panel that is going
            // away to draw itself again.
            this.applySearchFocus(false);
            // A glow still fading when the panel closes would keep a ticker listener alive against a
            // tree that no longer exists.
            this.stopGlow();
            this.stopEntrance();
            // The search field is parented to the page, so nothing else will ever take it off. A node
            // left behind is the ghost input that has bitten the login card before.
            this.searchField?.dispose();
            this.searchField = undefined;
            this.searchBox = undefined;
            this.detachResize();
            // The clued controls go off screen with the panel. The clues stay ARMED (reopening the pack
            // puts them back) but nothing is left pointing at a control that isn't there.
            this.retractClues();
            if (inherited) inherited(clicked);
        };
    }
}






parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");






const $9fb9be6d4b9a07da$export$4dc770bbadfb72db = 40;
const $9fb9be6d4b9a07da$export$d7c2de209fe3ac51 = 5;
const $9fb9be6d4b9a07da$export$1d2a07e77e913156 = $9fb9be6d4b9a07da$export$4dc770bbadfb72db + $9fb9be6d4b9a07da$export$d7c2de209fe3ac51;
const $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff = 4;
const $9fb9be6d4b9a07da$export$97f31c0e24982bcb = $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff * 2 + $9fb9be6d4b9a07da$export$4dc770bbadfb72db;
const $9fb9be6d4b9a07da$var$TRAY_CORNER = 8;
const $9fb9be6d4b9a07da$var$WELL_CORNER = 5;
// Art is scaled DOWN into this box and never up: 32px tile art then still draws at 1:1, which keeps
// pixel art crisp, and only the oversized stragglers are touched.
const $9fb9be6d4b9a07da$var$ICON_BOX = 32;
// The ammo icon is budgeted by WIDTH, not by its longest side. An arrow is naturally 27x5 -- a long
// thin thing -- so scaling it by the longest side to fit a square box took it to 16x3, a hairline
// that read as a scratch on the plate. Against a width budget it keeps its native 1:1 size.
const $9fb9be6d4b9a07da$var$AMMO_ICON_W = 28;
// ---- palette (gui/chat_theme.ts) -------------------------------------------------------------
const $9fb9be6d4b9a07da$var$TRAY_FILL = 0x1b1512;
// Sheer on purpose. The wells carry the contrast; the plate only has to bind them into one object,
// and at the old panel alpha it stamped a black bar across the bottom of the world.
const $9fb9be6d4b9a07da$var$TRAY_ALPHA = 0.4;
const $9fb9be6d4b9a07da$var$SHADOW_ALPHA = 0.16;
const $9fb9be6d4b9a07da$var$RIM = 0x6b4f38;
const $9fb9be6d4b9a07da$var$RIM_ALPHA = 0.7;
const $9fb9be6d4b9a07da$var$WELL_FILL = 0x140f0c;
const $9fb9be6d4b9a07da$var$WELL_ALPHA = 0.9;
const $9fb9be6d4b9a07da$var$WELL_FILL_ARMED = 0x352619;
const $9fb9be6d4b9a07da$var$ARMED = 0xf2a94e;
const $9fb9be6d4b9a07da$var$SELECTION_SLIDE_MS = 180;
const $9fb9be6d4b9a07da$var$BADGE_FILL = 0x0a0706;
const $9fb9be6d4b9a07da$var$TEXT_COLOR = 0xfff3e0;
const $9fb9be6d4b9a07da$var$KEY_COLOR = 0xa89480;
const $9fb9be6d4b9a07da$export$e1093899c97bdd06 = (n)=>{
    if (n < 10000) return `${n}`;
    const thousands = Math.round(n / 1000);
    return thousands < 1000 ? `${thousands}k` : "999k+";
};
class $9fb9be6d4b9a07da$export$ae188dfa452708ef extends (0, $gwPoJ.Graphics) {
    constructor(guiManager, dragOptions){
        super(), this.dragOptions = dragOptions, this.dropSlots = [], this.// Inventory drags use the same server-issued Ready/Replace actions as the panel's ready row.
        registerInventoryDropTarget = (drag)=>{
            const width = $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff * 2 + Math.max(1, this.dropSlots.length) * $9fb9be6d4b9a07da$export$1d2a07e77e913156 - $9fb9be6d4b9a07da$export$d7c2de209fe3ac51;
            const feedback = new (0, $gwPoJ.Graphics)();
            feedback.interactive = false;
            feedback.lineStyle(2, $9fb9be6d4b9a07da$var$ARMED, 1);
            feedback.beginFill($9fb9be6d4b9a07da$var$WELL_FILL_ARMED, 0.5);
            feedback.drawRoundedRect(0, 0, width, $9fb9be6d4b9a07da$export$97f31c0e24982bcb, $9fb9be6d4b9a07da$var$WELL_CORNER);
            feedback.endFill();
            drag.registerSection(this, new (0, $6qzqq.Rectangle)(0, 0, width, $9fb9be6d4b9a07da$export$97f31c0e24982bcb), "readied", (on)=>{
                if (on && this.worldVisible) this.addChild(feedback);
                else feedback.parent?.removeChild(feedback);
            });
            this.dropSlots.forEach(({ node: node, item: item })=>{
                drag.registerTarget(node, item, "readied", $9fb9be6d4b9a07da$export$4dc770bbadfb72db, ()=>{});
            });
        }, this.wearBars = [], this.selectionFromX = 0, this.selectionTargetX = 0, this.selectionElapsed = $9fb9be6d4b9a07da$var$SELECTION_SLIDE_MS, this.getWoodSlotBounds = ()=>this.woodSlotBounds, this.// One slot. Its origin is the well's TOP-LEFT, so the widget's bounds are the tray's bounds and
        // the thing can be anchored by arithmetic instead of by measurement.
        renderSlot = (label, spriteMeta, selected, callback, amt, condition)=>{
            const slot = new (0, $gwPoJ.Graphics)();
            slot.beginFill(selected ? $9fb9be6d4b9a07da$var$WELL_FILL_ARMED : $9fb9be6d4b9a07da$var$WELL_FILL, $9fb9be6d4b9a07da$var$WELL_ALPHA);
            slot.lineStyle({
                width: 1,
                color: $9fb9be6d4b9a07da$var$RIM,
                alpha: 0.85,
                join: (0, $gwPoJ.LINE_JOIN).ROUND
            });
            slot.drawRoundedRect(0.5, 0.5, $9fb9be6d4b9a07da$export$4dc770bbadfb72db - 1, $9fb9be6d4b9a07da$export$4dc770bbadfb72db - 1, $9fb9be6d4b9a07da$var$WELL_CORNER);
            slot.endFill();
            slot.lineStyle(0);
            // The item is NOT tinted by its armed state. That was the single worst thing about the old
            // tray: `color: item.active ? 0x00ff00` repainted the equipped item as a flat green blob, so
            // the one slot you most need to identify was the one you could not read. Armed is the rim's
            // job.
            const item = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)(spriteMeta);
            const art = item.getLocalBounds();
            const longest = Math.max(art.width, art.height);
            if (longest > $9fb9be6d4b9a07da$var$ICON_BOX) item.scale.set($9fb9be6d4b9a07da$var$ICON_BOX / longest);
            (0, $d634a66159f23623$export$db3e35bb56748094)(item, 0, 0, $9fb9be6d4b9a07da$export$4dc770bbadfb72db);
            slot.addChild(item);
            // Shortcut digit, in the well's corner rather than floating above it. It is a hint, not a
            // headline, so it is dim until the slot is armed.
            const labelObject = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").color(selected ? $9fb9be6d4b9a07da$var$ARMED : $9fb9be6d4b9a07da$var$KEY_COLOR).render(label);
            labelObject.x = 3;
            labelObject.y = 1;
            slot.addChild(labelObject);
            let badgeInset = 0;
            if (amt !== undefined) {
                const amtLabel = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").color($9fb9be6d4b9a07da$var$TEXT_COLOR).strokeThickness(0).render($9fb9be6d4b9a07da$export$e1093899c97bdd06(amt));
                const badgeW = amtLabel.width + 5;
                const badgeH = amtLabel.height + 1;
                const badgeX = $9fb9be6d4b9a07da$export$4dc770bbadfb72db - badgeW - 2;
                const badgeY = $9fb9be6d4b9a07da$export$4dc770bbadfb72db - badgeH - 2;
                // The plate goes on its OWN Graphics, added after the item, rather than into the slot's
                // geometry: a Container draws its own geometry first and its children over it, so a badge
                // drawn into the slot would sit UNDER the art it is supposed to be legible against -- and
                // the number, being a child, would have floated over bare item art.
                const badge = new (0, $gwPoJ.Graphics)();
                badge.beginFill($9fb9be6d4b9a07da$var$BADGE_FILL, 0.92);
                badge.drawRoundedRect(badgeX, badgeY, badgeW, badgeH, 3);
                badge.endFill();
                amtLabel.x = badgeX + 2.5;
                amtLabel.y = badgeY + 0.5;
                badge.addChild(amtLabel);
                slot.addChild(badge);
                // Measured, not guessed: how far in from the right the wear gauge has to stop so the
                // two never overlap, whatever the count is.
                badgeInset = $9fb9be6d4b9a07da$export$4dc770bbadfb72db - badgeX + 2;
            }
            // The wear gauge, if this thing wears and has started to. Added LAST, for the badge's reason
            // and then some: it sits in the bottom 8px of the well, which is exactly where a 32px icon
            // in a 40px box reaches, so drawn into the slot's own geometry it would be under the art.
            const wear = (0, $90f59133f949281e$export$aac214f772e3eeb7).forSlot(condition, $9fb9be6d4b9a07da$export$4dc770bbadfb72db, badgeInset);
            if (wear) {
                slot.addChild(wear);
                this.wearBars.push(wear);
            }
            // One uniform press target per slot, rather than each item's own sprite bounds.
            //
            // Hanging the handler off the sprite made a slot exactly as easy to hit as its art is big: a
            // shield filled the slot and a dagger was a few pixels of blade on the diagonal, so the same
            // gesture picked one reliably and missed the other. Which item is in a slot should not change
            // how hard it is to select.
            //
            // It is exactly one pitch wide and the full height of the tray -- the largest target that
            // cannot overlap its neighbour and steal its taps -- so the gaps between wells are live too,
            // and a thumb landing between two slots still gets the nearer one.
            slot.interactive = true;
            slot.cursor = "pointer";
            slot.hitArea = new (0, $6qzqq.Rectangle)(-$9fb9be6d4b9a07da$export$d7c2de209fe3ac51 / 2, -$9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff, $9fb9be6d4b9a07da$export$1d2a07e77e913156, $9fb9be6d4b9a07da$export$97f31c0e24982bcb);
            slot.on("pointertap", (event)=>{
                if (event?.data?.pointerType !== "touch" && event?.data?.button > 0) return;
                if (!this.itemDrag?.suppressClick(slot)) callback();
            });
            return slot;
        }, this.renderAmmo = (ammo, x)=>{
            const node = new (0, $gwPoJ.Graphics)();
            node.x = x;
            node.lineStyle({
                width: 1,
                color: $9fb9be6d4b9a07da$var$RIM,
                alpha: $9fb9be6d4b9a07da$var$RIM_ALPHA
            });
            node.moveTo(0.5, $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff + 6);
            node.lineTo(0.5, $9fb9be6d4b9a07da$export$97f31c0e24982bcb - $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff - 6);
            node.lineStyle(0);
            const icon = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                animated: false,
                color: 0xffffff,
                name: ammo.icon,
                scale: 1
            });
            const art = icon.getLocalBounds();
            if (art.width > $9fb9be6d4b9a07da$var$AMMO_ICON_W) icon.scale.set($9fb9be6d4b9a07da$var$AMMO_ICON_W / art.width);
            // Centred in a square the width of the budget, so the icon sits on the tray's middle line
            // whatever shape the ammo happens to be.
            (0, $d634a66159f23623$export$db3e35bb56748094)(icon, 6, ($9fb9be6d4b9a07da$export$97f31c0e24982bcb - $9fb9be6d4b9a07da$var$AMMO_ICON_W) / 2, $9fb9be6d4b9a07da$var$AMMO_ICON_W);
            node.addChild(icon);
            const count = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("compactCaption").bold().color($9fb9be6d4b9a07da$var$TEXT_COLOR).render($9fb9be6d4b9a07da$export$e1093899c97bdd06(ammo.quantity));
            count.x = 6 + $9fb9be6d4b9a07da$var$AMMO_ICON_W + 4;
            count.y = ($9fb9be6d4b9a07da$export$97f31c0e24982bcb - count.height) / 2;
            node.addChild(count);
            return {
                node: node,
                width: count.x + count.width
            };
        }, this.drawTray = (width)=>{
            this.clear();
            if (width <= 0) return;
            // Fake drop shadow: an offset copy behind the plate, no filters. Kept faint because the
            // plate above it is sheer and would otherwise read as mottled rather than shadowed.
            this.beginFill(0x000000, $9fb9be6d4b9a07da$var$SHADOW_ALPHA);
            this.drawRoundedRect(0, 2, width, $9fb9be6d4b9a07da$export$97f31c0e24982bcb, $9fb9be6d4b9a07da$var$TRAY_CORNER);
            this.endFill();
            this.beginFill($9fb9be6d4b9a07da$var$TRAY_FILL, $9fb9be6d4b9a07da$var$TRAY_ALPHA);
            this.lineStyle({
                width: 1,
                color: $9fb9be6d4b9a07da$var$RIM,
                alpha: $9fb9be6d4b9a07da$var$RIM_ALPHA,
                join: (0, $gwPoJ.LINE_JOIN).ROUND
            });
            this.drawRoundedRect(0.5, 0.5, width - 1, $9fb9be6d4b9a07da$export$97f31c0e24982bcb - 1, $9fb9be6d4b9a07da$var$TRAY_CORNER);
            this.endFill();
            this.lineStyle(0);
        }, this.moveSelectionRing = (x)=>{
            if (x === undefined) {
                if (this.selectionRing) this.selectionRing.visible = false;
                this.selectionElapsed = $9fb9be6d4b9a07da$var$SELECTION_SLIDE_MS;
                return;
            }
            if (!this.selectionRing) {
                const ring = this.selectionRing = new (0, $gwPoJ.Graphics)();
                ring.interactive = false;
                ring.lineStyle({
                    width: 1.5,
                    color: $9fb9be6d4b9a07da$var$ARMED,
                    alpha: 1,
                    join: (0, $gwPoJ.LINE_JOIN).ROUND
                });
                ring.drawRoundedRect(0.5, 0.5, $9fb9be6d4b9a07da$export$4dc770bbadfb72db - 1, $9fb9be6d4b9a07da$export$4dc770bbadfb72db - 1, $9fb9be6d4b9a07da$var$WELL_CORNER);
                // Inset glow without a filter or an extra render target.
                ring.lineStyle({
                    width: 3,
                    color: $9fb9be6d4b9a07da$var$ARMED,
                    alpha: 0.18,
                    join: (0, $gwPoJ.LINE_JOIN).ROUND
                });
                ring.drawRoundedRect(2.5, 2.5, $9fb9be6d4b9a07da$export$4dc770bbadfb72db - 5, $9fb9be6d4b9a07da$export$4dc770bbadfb72db - 5, Math.max(1, $9fb9be6d4b9a07da$var$WELL_CORNER - 2));
                ring.visible = false;
            }
            const ring = this.selectionRing;
            if (!ring.visible) {
                ring.position.set(x, $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff);
                this.selectionTargetX = x;
                this.selectionElapsed = $9fb9be6d4b9a07da$var$SELECTION_SLIDE_MS;
            } else if (x !== this.selectionTargetX) {
                this.selectionFromX = ring.x;
                this.selectionTargetX = x;
                this.selectionElapsed = 0;
            }
            ring.visible = true;
            this.addChild(ring);
        }, this.update = (inventory, slotCallback, ammo)=>{
            this.itemDrag?.cancel();
            this.itemDrag = undefined;
            [
                ...this.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.removeChildren();
            this.woodSlotBounds = undefined;
            this.dropSlots = [];
            this.wearBars = [];
            if (this.dragOptions) {
                const { interaction: interaction, layer: layer, isWorldDrop: isWorldDrop, drop: drop } = this.dragOptions;
                this.itemDrag = new (0, $d37c2dc6a7897ec7$export$35c1754b36550cfd)(interaction, layer, (item)=>this.renderSlot("", {
                        animated: false,
                        color: 0xffffff,
                        name: item.spriteId,
                        scale: 1
                    }, false, ()=>{}, item.quantity > 1 ? item.quantity : undefined, item.condition), (item)=>drop(item.id), ()=>{}, isWorldDrop);
            }
            const baseMeta = {
                animated: false,
                color: 0xffffff,
                name: "",
                scale: 1.0
            };
            const slotCallbacks = {};
            const readied = (inventory.items || []).filter((item)=>item.readied && ((0, $cb689cfa16c444ba$export$6e47733a887561b3)[item.itemType]?.slotVisible || (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.properties.primaryUseable(item.itemTypeMeta)));
            const selectedIndex = readied.findIndex((item)=>item.active);
            readied.forEach((item, i)=>{
                const name = item.itemTypeMeta.spriteId || `${item.itemTypeMeta.type}-${item.itemTypeMeta.color}.png`;
                const shortcutKey = `${i + 1}`;
                const callback = ()=>slotCallback(item.id);
                // Computed here rather than sent: the whole inventory already rides to the client, hp and
                // all, so the tray needs nothing new from the server to know the axe in slot 1 is spent.
                const condition = (0, $d3527b517d667178$export$4cfe0674a42ef84e).item.durability.computeItemConditionPct(item);
                const slot = this.renderSlot(shortcutKey, {
                    ...baseMeta,
                    name: name
                }, item.active, callback, // A bare "1" on every single weapon is noise; a count is only news when there is
                // more than one of the thing.
                item.quantity > 1 ? item.quantity : undefined, condition);
                slotCallbacks[i + 1] = callback;
                slot.x = $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff + i * $9fb9be6d4b9a07da$export$1d2a07e77e913156;
                slot.y = $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff;
                if (item.itemTypeMeta.type === "wood" && item.quantity >= 1 && !this.woodSlotBounds) this.woodSlotBounds = new (0, $6qzqq.Rectangle)(slot.x, slot.y, $9fb9be6d4b9a07da$export$4dc770bbadfb72db, $9fb9be6d4b9a07da$export$4dc770bbadfb72db);
                this.addChild(slot);
                const detail = {
                    id: item.id,
                    title: item.flags?.chargedWeaponId ? item.description || item.flags.chargedWeaponId : item.itemTypeMeta.type,
                    spriteId: name,
                    quantity: item.quantity,
                    options: [],
                    condition: condition,
                    itemDropOptions: {
                        world: {
                            title: "Drop",
                            onClickContext: {}
                        }
                    }
                };
                this.dropSlots.push({
                    node: slot,
                    item: detail
                });
                this.itemDrag?.register(slot, detail, "readied", $9fb9be6d4b9a07da$export$4dc770bbadfb72db, ()=>{});
            });
            // No readied items, no tray. An empty plate on the grass is just a smudge.
            if (readied.length === 0) {
                this.moveSelectionRing();
                this.drawTray(0);
                return slotCallbacks;
            }
            let width = $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff + (readied.length - 1) * $9fb9be6d4b9a07da$export$1d2a07e77e913156 + $9fb9be6d4b9a07da$export$4dc770bbadfb72db + $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff;
            if (ammo) {
                const { node: node, width: ammoWidth } = this.renderAmmo(ammo, width - $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff + 1);
                this.addChild(node);
                width = node.x + ammoWidth + $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff + 2;
            }
            this.drawTray(width);
            this.moveSelectionRing(selectedIndex < 0 ? undefined : $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff + selectedIndex * $9fb9be6d4b9a07da$export$1d2a07e77e913156);
            return slotCallbacks;
        }, this./**
     * Slide the selection ring and breathe gauges of weapons about to break.
     *
     * The tray is rebuilt only when the inventory changes, so this is its only frame clock -- and it
     * only animates while the ring is moving or a weapon is in the warning tier, so
     * gui_manager can call it unconditionally. A fragile weapon is the one wear state that has to
     * reach a player who is looking at the fight rather than at the tray.
     */ animate = (deltaMs)=>{
            if (this.selectionRing?.visible && this.selectionElapsed < $9fb9be6d4b9a07da$var$SELECTION_SLIDE_MS) {
                this.selectionElapsed = Math.min($9fb9be6d4b9a07da$var$SELECTION_SLIDE_MS, this.selectionElapsed + Math.max(0, deltaMs));
                const progress = this.selectionElapsed / $9fb9be6d4b9a07da$var$SELECTION_SLIDE_MS;
                const eased = 1 - Math.pow(1 - progress, 3);
                this.selectionRing.x = this.selectionFromX + (this.selectionTargetX - this.selectionFromX) * eased;
            }
            this.wearBars.forEach((bar)=>bar.animate(deltaMs));
        };
        this.guiManager = guiManager;
        this.on("removed", ()=>this.itemDrag?.cancel());
    }
    destroy(options) {
        this.itemDrag?.cancel();
        this.selectionRing?.destroy();
        super.destroy(options);
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");


class $91106b3dea6906a4$export$6386e5268de7fe1f extends (0, $gwPoJ.Graphics) {
    constructor(gui){
        super(), this.remove = ()=>{
            if (this.surface) {
                this.fader?.stop();
                this.removeChild(this.surface);
            }
        }, this.setup = (screenMessage)=>{
            if (screenMessage.action === "close") {
                if (this.surface) {
                    this.fader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.surface, {
                        fadeInterval: 5,
                        releaseCallback: ()=>{
                            this.removeChild(this.surface);
                        }
                    });
                    this.fader.update();
                }
                return;
            }
            if (this.surface) {
                this.fader?.stop();
                this.removeChild(this.surface);
            }
            this.surface = (0, $95fcf006ca17068b$export$97a92ac594e41d5f).createContent(this.gui.logic, screenMessage, this.width, [], {
                backdrop: true
            });
            this.surface.x = -150;
            this.addChild(this.surface);
            const interval = setInterval(()=>{
                this.surface.x += 5;
                if (this.surface.x >= 0) {
                    this.surface.x = 0;
                    clearInterval(interval);
                }
            }, 10);
        };
        this.gui = gui;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");


// The frame-rate readout, toggled with `f`.
//
// It deliberately shows more than a frame rate, because a frame rate on its own is the one number
// that hides the problem we actually care about (see the budget-hardware target): a client that
// averages 58fps while dropping one 90ms frame every second reads as "fine" and feels awful. So the
// panel carries three things that disagree with each other usefully:
//
//   * the rate, averaged over the last second -- throughput, the number everyone asks for;
//   * avg / worst frame time in that same second -- the worst is the hitch, and it is the reading
//     that moves when something expensive (a bake, a full map rerender) lands in one frame;
//   * a bar per frame over that second, so a single spike is visibly a SPIKE and not a dip in an
//     average. Each bar is coloured against the 60fps budget, and the budget itself is drawn as a
//     hairline, so "over budget" is a thing you see rather than a number you compare.
//
// It measures the real loop: it is a stage child fed from the renderer's own frame delta, not a
// separate rAF. That also means it costs something, so it is careful to cost very little -- the
// numbers are re-rasterized a few times a second rather than every frame (see TEXT_REFRESH_MS), and
// nothing is drawn at all while it is hidden, which is almost always.
const $e9383df2bf94b4f7$var$PANEL_COLOR = 0x05070a;
const $e9383df2bf94b4f7$var$PANEL_ALPHA = 0.72;
const $e9383df2bf94b4f7$var$BORDER_COLOR = 0xffffff;
const $e9383df2bf94b4f7$var$BORDER_ALPHA = 0.14;
const $e9383df2bf94b4f7$var$CORNER = 5;
const $e9383df2bf94b4f7$export$c893b6a4fba5f6bb = 1000 / 60;
const $e9383df2bf94b4f7$var$GOOD_COLOR = 0x7be08a;
const $e9383df2bf94b4f7$var$WARN_COLOR = 0xd9a441;
const $e9383df2bf94b4f7$var$BAD_COLOR = 0xe8745a;
const $e9383df2bf94b4f7$var$GUIDE_COLOR = 0xffffff;
const $e9383df2bf94b4f7$var$GUIDE_ALPHA = 0.38;
const $e9383df2bf94b4f7$var$RATE_COLOR = 0xffffff;
const $e9383df2bf94b4f7$var$UNIT_COLOR = 0x8f9bb0;
const $e9383df2bf94b4f7$var$DETAIL_COLOR = 0xcfd8dc;
// How wide a window the numbers describe. One second is long enough that the rate is steady to read
// and short enough that a hitch shows up and then clears, rather than haunting the panel.
const $e9383df2bf94b4f7$var$WINDOW_MS = 1000;
// A hard cap on the ring, so a machine running at 240Hz (or a pathological burst of zero-length
// frames) can't grow it without bound.
const $e9383df2bf94b4f7$var$MAX_SAMPLES = 240;
// A "frame" longer than this is not a frame. It is the gap either side of something that stopped
// the loop entirely -- a backgrounded tab whose rAF was throttled to nothing, a page that has just
// finished loading, a laptop coming out of sleep. Letting one in parks a five-figure worst-frame on
// the panel for a full second every time the player tabs back, which buries the hitches that are
// real and fixable. Everything below it is kept, so a genuinely horrible 800ms frame still shows.
const $e9383df2bf94b4f7$var$STALL_CEILING_MS = 2000;
// Frames are measured every frame; the TEXT is only re-rasterized this often. Re-styling a pixi Text
// rebuilds its texture, and doing that 60 times a second in the thing that reports frame cost would
// be measuring its own shadow. The bars still move every frame -- they are one Graphics redraw.
const $e9383df2bf94b4f7$var$TEXT_REFRESH_MS = 200;
const $e9383df2bf94b4f7$var$PAD_X = 7;
const $e9383df2bf94b4f7$var$PAD_Y = 5;
const $e9383df2bf94b4f7$var$GRAPH_H = 16;
const $e9383df2bf94b4f7$var$GRAPH_GAP = 5;
const $e9383df2bf94b4f7$var$BAR_W = 2;
const $e9383df2bf94b4f7$var$BAR_GAP = 1;
const $e9383df2bf94b4f7$var$BAR_COUNT = 44;
const $e9383df2bf94b4f7$var$GRAPH_W = $e9383df2bf94b4f7$var$BAR_COUNT * ($e9383df2bf94b4f7$var$BAR_W + $e9383df2bf94b4f7$var$BAR_GAP) - $e9383df2bf94b4f7$var$BAR_GAP;
// The tallest frame time the graph can draw. It is three budgets rather than something generous,
// because the graph's job is to separate frames in the 16-50ms range -- the ones that are the
// difference between smooth and not. A taller ceiling would flatten all of those into the floor to
// make room for the rare frame nobody needs measured precisely: anything above this draws full
// height, which is what it means anyway, and its colour has already said so.
const $e9383df2bf94b4f7$var$GRAPH_CEILING_MS = $e9383df2bf94b4f7$export$c893b6a4fba5f6bb * 3;
// How wide the panel should end up on the actual display, in CSS pixels.
//
// The HUD is laid out in a virtual 800-unit screen that is stretched to fit whatever is in front of
// the player, and on a phone that stretch runs the WRONG WAY: a portrait handset maps those 800
// units onto ~390 real pixels, so a panel that reads comfortably on a desktop lands at about 70px
// across with 4px digits -- present, correct, and completely unreadable. Every other touch control
// answers this by growing (chipMetrics, the control bar's 1.5x), so this one does too. Desktop is
// already past this width and is left exactly as it was.
const $e9383df2bf94b4f7$var$MIN_PANEL_CSS_W = 170;
const $e9383df2bf94b4f7$var$MAX_PANEL_SCALE = 3;
const $e9383df2bf94b4f7$export$f6c1ae7982f80375 = (durationsMs)=>{
    let total = 0;
    let count = 0;
    let worst = 0;
    for (const ms of durationsMs){
        if (!isFinite(ms) || ms <= 0) continue;
        total += ms;
        count++;
        if (ms > worst) worst = ms;
    }
    if (!count) return {
        fps: 0,
        avgMs: 0,
        worstMs: 0
    };
    return {
        fps: count * 1000 / total,
        avgMs: total / count,
        worstMs: worst
    };
};
const $e9383df2bf94b4f7$export$13ac0d3bed904283 = (ms)=>{
    if (!isFinite(ms) || ms < 0) return "--";
    if (ms >= 999.5) return "999+";
    return ms >= 100 ? ms.toFixed(0) : ms.toFixed(1);
};
const $e9383df2bf94b4f7$export$cd74b911503b5b10 = (panelWidth, cssPerUnit)=>{
    if (!(panelWidth > 0) || !(cssPerUnit > 0)) return 1;
    return Math.min($e9383df2bf94b4f7$var$MAX_PANEL_SCALE, Math.max(1, $e9383df2bf94b4f7$var$MIN_PANEL_CSS_W / (panelWidth * cssPerUnit)));
};
const $e9383df2bf94b4f7$export$9725e7b96cb83cbb = (ms)=>{
    if (ms <= $e9383df2bf94b4f7$export$c893b6a4fba5f6bb * 1.05) return $e9383df2bf94b4f7$var$GOOD_COLOR;
    return ms <= $e9383df2bf94b4f7$export$c893b6a4fba5f6bb * 2 ? $e9383df2bf94b4f7$var$WARN_COLOR : $e9383df2bf94b4f7$var$BAD_COLOR;
};
class $e9383df2bf94b4f7$export$b944265fdd8e54c4 extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.plate = new (0, $gwPoJ.Graphics)(), this.graph = new (0, $gwPoJ.Graphics)(), // Frame durations over roughly the last second, oldest first.
        this.samples = [], this.sinceTextMs = $e9383df2bf94b4f7$var$TEXT_REFRESH_MS, // The display scale the panel was last sized for, so a resize is noticed without asking every
        // frame what it would be.
        this.scaledFor = 0, this.layout = ()=>{
            this.rate.x = $e9383df2bf94b4f7$var$PAD_X;
            this.rate.y = $e9383df2bf94b4f7$var$PAD_Y;
            this.unit.x = $e9383df2bf94b4f7$var$PAD_X + this.rate.width + 3;
            // Sit the unit on the number's baseline rather than its top, so "FPS" reads as a suffix.
            this.unit.y = $e9383df2bf94b4f7$var$PAD_Y + this.rate.height - this.unit.height - 1;
            this.detail.y = this.unit.y;
            this.graph.x = $e9383df2bf94b4f7$var$PAD_X;
            this.graph.y = this.panelH - $e9383df2bf94b4f7$var$PAD_Y - $e9383df2bf94b4f7$var$GRAPH_H;
        }, this.drawPlate = ()=>{
            this.plate.clear().beginFill($e9383df2bf94b4f7$var$PANEL_COLOR, $e9383df2bf94b4f7$var$PANEL_ALPHA).lineStyle({
                width: 1,
                color: $e9383df2bf94b4f7$var$BORDER_COLOR,
                alpha: $e9383df2bf94b4f7$var$BORDER_ALPHA,
                alignment: 0
            }).drawRoundedRect(0, 0, this.panelW, this.panelH, $e9383df2bf94b4f7$var$CORNER).endFill();
        }, /** The plate's drawn size, for whoever is placing it. Not `width`/`height`, which pixi derives
     * from bounds and which collapse to nothing while the panel is hidden. */ this.panelSize = ()=>({
                width: this.panelW,
                height: this.panelH
            }), /**
     * Magnify the panel on a display that would otherwise draw it too small to read -- which in
     * practice means a phone. Cheap to call: it compares one number and returns.
     */ this.fitToDisplay = ()=>{
            const cssPerUnit = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().scaleX;
            if (cssPerUnit === this.scaledFor) return;
            this.scaledFor = cssPerUnit;
            this.scale.set($e9383df2bf94b4f7$export$cd74b911503b5b10(this.panelW, cssPerUnit));
        }, /** The frame durations currently being reported on, oldest first. For tests. */ this.frameWindow = ()=>[
                ...this.samples
            ], /** Is the readout up? */ this.isOpen = ()=>this.visible, /**
     * Show or hide the readout. Hiding drops the window, so the panel doesn't come back up
     * reporting the frame times of whenever it was last looked at -- including the enormous one
     * that is the gap between then and now.
     */ this.setOpen = (open)=>{
            if (open === this.visible) return;
            this.visible = open;
            if (!open) this.samples = [];
            this.sinceTextMs = $e9383df2bf94b4f7$var$TEXT_REFRESH_MS;
        }, this.toggle = ()=>{
            this.setOpen(!this.visible);
            return this.visible;
        }, /**
     * One frame's delta, in ms, from the render loop. A no-op while hidden -- including the
     * sampling, so the panel measures the frames it is actually drawn into.
     */ this.sample = (deltaMs)=>{
            if (!this.visible) return;
            // A phone can be turned over while the panel is up, and the virtual screen is reshaped when
            // it is (see canvas_layout).
            this.fitToDisplay();
            if (isFinite(deltaMs) && deltaMs > 0 && deltaMs < $e9383df2bf94b4f7$var$STALL_CEILING_MS) this.samples.push(deltaMs);
            // Trim to the window from the front: drop the oldest until what's left spans WINDOW_MS.
            let total = 0;
            for (const ms of this.samples)total += ms;
            while(this.samples.length > 1 && (total - this.samples[0] >= $e9383df2bf94b4f7$var$WINDOW_MS || this.samples.length > $e9383df2bf94b4f7$var$MAX_SAMPLES))total -= this.samples.shift();
            this.drawGraph();
            this.sinceTextMs += deltaMs;
            if (this.sinceTextMs >= $e9383df2bf94b4f7$var$TEXT_REFRESH_MS) {
                this.sinceTextMs = 0;
                this.drawNumbers();
            }
        }, this.drawNumbers = ()=>{
            const { fps: fps, avgMs: avgMs, worstMs: worstMs } = $e9383df2bf94b4f7$export$f6c1ae7982f80375(this.samples);
            if (!fps) return;
            this.rate.text = String(Math.round(fps));
            this.rate.tint = $e9383df2bf94b4f7$export$9725e7b96cb83cbb(avgMs);
            this.detail.text = `${$e9383df2bf94b4f7$export$13ac0d3bed904283(avgMs)} / ${$e9383df2bf94b4f7$export$13ac0d3bed904283(worstMs)} ms`;
            // The number's width moves as it crosses 9/99, and the detail is right-aligned against the
            // panel edge, so both followers are re-placed whenever the text changes.
            this.unit.x = $e9383df2bf94b4f7$var$PAD_X + this.rate.width + 3;
            this.detail.x = this.panelW - $e9383df2bf94b4f7$var$PAD_X - this.detail.width;
        }, // The last BAR_COUNT frames, newest at the right, each scaled against GRAPH_CEILING_MS. One
        // Graphics redraw a frame: ~40 rects, which is cheap enough to not show up in its own graph.
        this.drawGraph = ()=>{
            const g = this.graph.clear();
            const shown = this.samples.slice(-$e9383df2bf94b4f7$var$BAR_COUNT);
            const left = $e9383df2bf94b4f7$var$GRAPH_W - shown.length * ($e9383df2bf94b4f7$var$BAR_W + $e9383df2bf94b4f7$var$BAR_GAP) + $e9383df2bf94b4f7$var$BAR_GAP;
            g.beginFill($e9383df2bf94b4f7$var$BORDER_COLOR, 0.05).drawRect(0, 0, $e9383df2bf94b4f7$var$GRAPH_W, $e9383df2bf94b4f7$var$GRAPH_H).endFill();
            shown.forEach((ms, i)=>{
                const h = Math.max(1, Math.min(1, ms / $e9383df2bf94b4f7$var$GRAPH_CEILING_MS) * $e9383df2bf94b4f7$var$GRAPH_H);
                g.beginFill($e9383df2bf94b4f7$export$9725e7b96cb83cbb(ms), 0.95).drawRect(left + i * ($e9383df2bf94b4f7$var$BAR_W + $e9383df2bf94b4f7$var$BAR_GAP), $e9383df2bf94b4f7$var$GRAPH_H - h, $e9383df2bf94b4f7$var$BAR_W, h).endFill();
            });
            // The budget, last and across the whole width, so it reads OVER the bars rather than being
            // hidden by the very bars it exists to be compared against. A frame that made 60fps stops
            // just under it; one that didn't pokes through it.
            //
            // Drawn one pixel clear of the height a 16.7ms frame actually reaches. Sitting it exactly
            // there is the truthful placement and an invisible one: the line and the tops of every
            // green bar are then the same row of pixels, and the guide disappears into the thing it is
            // supposed to be a guide for.
            const budgetY = Math.round($e9383df2bf94b4f7$var$GRAPH_H - $e9383df2bf94b4f7$export$c893b6a4fba5f6bb / $e9383df2bf94b4f7$var$GRAPH_CEILING_MS * $e9383df2bf94b4f7$var$GRAPH_H) - 2;
            g.beginFill($e9383df2bf94b4f7$var$GUIDE_COLOR, $e9383df2bf94b4f7$var$GUIDE_ALPHA).drawRect(0, Math.max(0, budgetY), $e9383df2bf94b4f7$var$GRAPH_W, 1).endFill();
        };
        this.rate = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("compactTitle").color($e9383df2bf94b4f7$var$RATE_COLOR).strokeThickness(0).render("--");
        this.unit = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("overline").color($e9383df2bf94b4f7$var$UNIT_COLOR).strokeThickness(0).render("FPS");
        this.detail = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("overline").color($e9383df2bf94b4f7$var$DETAIL_COLOR).strokeThickness(0).render("");
        this.panelW = $e9383df2bf94b4f7$var$PAD_X * 2 + $e9383df2bf94b4f7$var$GRAPH_W;
        this.panelH = $e9383df2bf94b4f7$var$PAD_Y * 2 + this.rate.height + $e9383df2bf94b4f7$var$GRAPH_GAP + $e9383df2bf94b4f7$var$GRAPH_H;
        this.addChild(this.plate, this.rate, this.unit, this.detail, this.graph);
        this.layout();
        this.drawPlate();
        this.fitToDisplay();
        // Starts away: this is a tool, not a HUD element, and the player who never presses `f`
        // should never pay for it.
        this.visible = false;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

var $8JEKL = parcelRequire("8JEKL");

const $95442441126989b8$var$MODAL_WIDTH = 400;
const $95442441126989b8$var$MODAL_HEIGHT = 340;
class $95442441126989b8$export$175e500a48a60fd2 {
    constructor(guiManager, props){
        this.fields = [];
        this.feedbackText = "";
        this.emailText = "";
        this.setup = ()=>{
            this.surface.clear();
            this.modal = this.guiManager.createModal({
                padding: 0,
                width: $95442441126989b8$var$MODAL_WIDTH,
                height: $95442441126989b8$var$MODAL_HEIGHT,
                content: this.surface,
                center: true,
                closeCallback: ()=>{
                    this.fields.forEach((field)=>field.destroy());
                    this.fields = [];
                }
            });
            this.renderForm();
        };
        this.renderForm = ()=>{
            const fieldWidth = $95442441126989b8$var$MODAL_WIDTH - 40;
            const title = new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)("Feedback - what do you think of this game?");
            title.x = 20, title.y = 10, this.surface.addChild(title);
            const feedback = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
                input: {
                    fontFamily: "Arial",
                    fontSize: "10pt",
                    lineHeight: "13px",
                    padding: "10px 12px",
                    color: "#26272E",
                    multiline: true,
                    width: `${fieldWidth}px`,
                    height: `${fieldWidth / 2}px`
                },
                box: {
                    default: {
                        fill: 0xe1e3ee,
                        rounded: 10,
                        stroke: {
                            color: 0xcbcee0,
                            width: 2
                        }
                    },
                    focused: {
                        fill: 0xe1e3ee,
                        rounded: 10,
                        stroke: {
                            color: 0xabafc6,
                            width: 2
                        }
                    },
                    disabled: {
                        fill: 0xdbdbdb,
                        rounded: 10
                    }
                }
            });
            feedback.on("focus", (e)=>{
                this.guiManager.logic.playerController.enabledKeyboardAction(false);
            });
            feedback.on("blur", (e)=>{
                this.guiManager.logic.playerController.enabledKeyboardAction(true);
            });
            feedback.x = 20;
            feedback.y = 40;
            feedback.placeHolder = "What do you think of this game?";
            feedback.placeholderColor = 0x000000;
            feedback.on("input", (text)=>{
                this.feedbackText = text;
            });
            this.fields.push(feedback);
            this.surface.addChild(feedback);
            feedback.focus();
            const emailField = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
                input: {
                    fontFamily: "Arial",
                    fontSize: "10pt",
                    lineHeight: "13px",
                    padding: "10px 12px",
                    color: "#26272E",
                    multiline: false,
                    width: `${fieldWidth}px`
                },
                box: {
                    default: {
                        fill: 0xe1e3ee,
                        rounded: 10,
                        stroke: {
                            color: 0xcbcee0,
                            width: 2
                        }
                    },
                    focused: {
                        fill: 0xe1e3ee,
                        rounded: 10,
                        stroke: {
                            color: 0xabafc6,
                            width: 2
                        }
                    },
                    disabled: {
                        fill: 0xdbdbdb,
                        rounded: 10
                    }
                }
            });
            emailField.x = 20;
            emailField.y = feedback.y + feedback.height + 20;
            emailField.placeholderColor = 0x000000;
            emailField.placeholder = "Your email address (optional)";
            emailField.on("input", (text)=>{
                this.emailText = text;
            });
            emailField.on("focus", (e)=>{
                this.guiManager.logic.playerController.enabledKeyboardAction(false);
            });
            emailField.on("blur", (e)=>{
                this.guiManager.logic.playerController.enabledKeyboardAction(true);
            });
            this.surface.addChild(emailField);
            const submitButton = new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)("Submit", {
                type: "button|dynamic",
                onClick: ()=>{
                    this.props?.onSubmit({
                        feedback: this.feedbackText,
                        email: this.emailText
                    });
                    this.modal.close();
                }
            });
            submitButton.x = 20, submitButton.y = $95442441126989b8$var$MODAL_HEIGHT - submitButton.height - 10;
            this.fields.push(emailField);
            this.surface.addChild(submitButton);
        };
        this.guiManager = guiManager;
        this.props = props;
        this.surface = new (0, $gwPoJ.Graphics)();
    }
}






// The game's control reference, as data. Shared by the /help modal and the controls page of the
// character-creation screen so the two can never drift apart.
//
// Written for the camp a new player is dropped into (an ember room): alongside the world controls
// every room has, the entries cover the camp-only ones -- firewood, orders, the HUD chips --
// because that is where someone reading this is actually standing.
//
// KEEP EACH BODY TO ONE LINE. The /help modal renders these unwrapped at size 14 into an 800-wide
// screen (about 70 characters) and stacks them down a 460px column, so a body that wraps pushes the
// last entries off the bottom. The controls page wraps the same text into its own columns.
const $9232cedf236eccda$export$37a7ec870b628d38 = [
    {
        title: "Movement",
        body: "WASD or the arrow keys. Hold SHIFT to run."
    },
    {
        title: "Interact",
        body: "Click or tap a thing to act on it. Several choices open a wheel."
    },
    {
        title: "Attack",
        body: "Press SPACE, or click. Hold a click on someone to swing instead."
    },
    {
        title: "Firewood",
        body: "An axe fells trees. Carry the wood to the fire and feed it in."
    },
    {
        title: "Inventory",
        body: "Press 'e' or the ITEMS chip. Keys 1-6 ready a slot, 'q' drops one."
    },
    {
        title: "Crafting",
        body: "Press 'c' to open the crafting screen."
    },
    {
        title: "Camp orders",
        body: "Click one of your camp for their orders. Hold CTRL to order them all."
    },
    {
        title: "Camp HUD",
        body: "The map, your roster, the wave countdown. Click a chip to reopen one."
    },
    {
        title: "Chat & help",
        body: "ENTER to chat. '/help' for this list, '/register' to save progress."
    }
];


class $7ce197e6bf5d40c1$export$1be7516c0280bee8 extends (0, $ac2a97d45725bff5$export$f79759b47a91f0e7) {
    constructor(guiManager){
        super(guiManager), this.createContent = ()=>{
            const textBlock = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            textBlock.append2("").append2("");
            $7ce197e6bf5d40c1$export$1be7516c0280bee8.attachHelp(textBlock);
            const media = this.guiManager.socialMedia();
            textBlock.append2(media, {
                exactLocation: {
                    x: 0,
                    y: (0, $7dd73ecdd94bfe01$export$84e1549b474f1b93) - media.height - 10
                }
            });
            return textBlock;
        };
    }
    static{
        this.attachHelp = (textBlock)=>{
            (0, $9232cedf236eccda$export$37a7ec870b628d38).forEach((entry, i)=>{
                const block = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
                block.append2(new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(0xffa500).bold().render(entry.title)).append2(new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().render(entry.body));
                textBlock.append2(block, i > 0 ? {
                    topMargin: 8
                } : undefined);
            });
        };
    }
}


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $P8XPi = parcelRequire("P8XPi");
var $gwPoJ = parcelRequire("gwPoJ");

// The player's health, as a row of hearts docked to the readied-item tray (gui_manager's
// positionVitals).
//
// What it replaced, and why: the old meter rebuilt all five sprites from scratch on every change,
// drew each heart as one of three frames, and said "you are nearly dead" by running a Throbber over
// the WHOLE row -- a 25ms setInterval strobing `alpha` between 0.4 and 1.5. That is a bad bargain
// twice over. A strobe makes the thing you most need to read disappear half the time, and a
// wall-clock interval keeps firing in a backgrounded tab, where no frame will ever draw it.
//
// Three ideas replace it:
//
//  - **The art is the game's, the LIGHT is drawn.** The heart stays the 15x13 pixel sprite, because
//    a vector heart is a different medium sitting on a pixel world. Everything that glows -- the
//    beat halo, the hit bloom, the burst -- is Graphics and additive blending, which read as light
//    rather than as art from somewhere else. No filters: this game's hardware target cannot spare a
//    filter pass, so a soft edge is a fatter, fainter copy of the same shape.
//
//  - **Hearts DRAIN rather than snap.** A heart is the `empty` frame (the vessel) with the `full`
//    frame masked over it, revealed from the bottom. The fill is a continuous 0..1 that eases to
//    its new value, so taking half a heart is something you watch happen. The mask is dropped
//    whenever a heart is wholly full or wholly empty, so in practice at most ONE is ever stencilled.
//
//  - **Low health BEATS, it does not blink.** The remaining hearts pulse on a lub-dub rhythm that
//    quickens as health falls, over a red halo. The row never drops below full opacity, so the
//    count stays readable at the exact moment it matters most.
//
// Nothing here owns a timer: `animate` is handed the frame delta, and does no work at all on a
// resting meter.
// Heart art is 15x13 (humanoid.json). The pitch gives FOUR pixels between hearts, which is the same
// as the plate's padding -- at a one-pixel gap the row read as cramped in the middle and loose at
// the ends, which is what an uneven rhythm looks like even when everything is perfectly centred.
const $9b7bf4301258d7f9$var$HEART_W = 15;
const $9b7bf4301258d7f9$var$HEART_H = 13;
const $9b7bf4301258d7f9$var$PITCH = $9b7bf4301258d7f9$var$HEART_W + 4;
// Padding around the row's ART (not around the slot grid, which is wider than the art it holds --
// measuring from the grid is what made the end margins disagree with the gaps). It is also what
// keeps getLocalBounds CONSTANT: the plate is static and must stay the widest thing here, or a
// beating heart would resize the meter and positionVitals would shuffle the meters beside it.
const $9b7bf4301258d7f9$var$PLATE_PAD = 4;
const $9b7bf4301258d7f9$var$PLATE_RADIUS = 5;
// The plate's dropped silhouette. One pixel: at more than that the shadow reads as PLATE, the
// bottom edge looks thicker than the top, and the hearts look like they are sitting high.
const $9b7bf4301258d7f9$var$PLATE_SHADOW_DROP = 1;
// OPTICAL centring, which is not the same as geometric centring. A heart is TOP-HEAVY: wide lobes
// above, tapering to a single pixel below -- 123 opaque pixels in the 15x13 frame with their
// centroid on row 5.3, so the ink's mass sits ~1.2px above the centre of its bounding box. Centre
// the box exactly, as this did at first, and the row reads as riding high with too much air under
// it. The geometry was perfect and it still looked wrong.
//
// Half the centroid offset, not all of it: at the full 1.2 the hearts read LOW, because that
// tapering tip still counts as the bottom edge to the eye even though it weighs almost nothing.
//
// And it is the PLATE that moves, not the art. Nudging a 15x13 pixel sprite by a fraction of a
// pixel is how pixel art goes soft; a vector rounded-rect can sit anywhere it likes.
const $9b7bf4301258d7f9$var$PLATE_OPTICAL_LIFT = 0.6;
// The readied-item tray's own palette (gui/equipped.ts): the hearts sit directly on top of it and
// the two have to read as one cluster rather than two overlays.
const $9b7bf4301258d7f9$var$PLATE_FILL = 0x1b1512;
const $9b7bf4301258d7f9$var$PLATE_ALPHA = 0.55;
const $9b7bf4301258d7f9$var$PLATE_RIM = 0x6b4f38;
const $9b7bf4301258d7f9$var$DANGER_COLOR = 0xff3b30;
const $9b7bf4301258d7f9$var$HEAL_COLOR = 0xffd166;
// How long a whole heart takes to drain. Long enough to see, short enough that a burst of damage
// does not leave the meter lying about how much health is left.
const $9b7bf4301258d7f9$var$DRAIN_MS = 260;
// The flash thrown off a heart that just changed, and the whole row's recoil.
const $9b7bf4301258d7f9$var$BURST_MS = 320;
const $9b7bf4301258d7f9$var$HIT_MS = 300;
const $9b7bf4301258d7f9$var$HIT_SHAKE = 2.5;
const $9b7bf4301258d7f9$export$f749d5530c9b9fa5 = 2;
const $9b7bf4301258d7f9$var$BEAT_SLOW_MS = 880;
const $9b7bf4301258d7f9$var$BEAT_FAST_MS = 440;
const $9b7bf4301258d7f9$var$BEAT_SCALE = 0.16;
// Non-finite in, zero out. A NaN here does not throw -- it rides all the way into a mask rectangle
// with NaN coordinates, which pixi draws as NO geometry, and an empty stencil clips NOTHING: the
// hearts come out FULL. A meter that reads full because its input was broken is the worst possible
// failure for this particular widget.
const $9b7bf4301258d7f9$var$clamp01 = (value)=>Number.isFinite(value) ? Math.max(0, Math.min(1, value)) : 0;
const $9b7bf4301258d7f9$export$c83a6c73dceed244 = (hearts, index)=>$9b7bf4301258d7f9$var$clamp01(hearts - index);
const $9b7bf4301258d7f9$export$dd404402fdf5289d = (hearts)=>{
    const danger = $9b7bf4301258d7f9$var$clamp01(hearts / $9b7bf4301258d7f9$export$f749d5530c9b9fa5);
    return $9b7bf4301258d7f9$var$BEAT_FAST_MS + ($9b7bf4301258d7f9$var$BEAT_SLOW_MS - $9b7bf4301258d7f9$var$BEAT_FAST_MS) * danger;
};
const $9b7bf4301258d7f9$export$bc5d822131ac8085 = (phase)=>{
    const at = phase - Math.floor(phase);
    const thump = (centre, width)=>{
        const distance = Math.abs(at - centre);
        if (distance >= width) return 0;
        const t = 1 - distance / width;
        return t * t;
    };
    return Math.max(thump(0.06, 0.08), thump(0.24, 0.07) * 0.6);
};
class $9b7bf4301258d7f9$export$7332475dd933238a extends (0, $gwPoJ.Graphics) {
    constructor(iconBase, max){
        super(), this.slots = [], this.hearts = 0, this.beatMs = 0, this.hitMs = 0, this.needsDraw = true, /**
     * New health, on the caller's 0..`max` scale (two per heart).
     *
     * Only records what changed and what should flash for it; nothing moves until `animate` runs,
     * so a value arriving twice in a frame cannot double up an effect.
     */ this.update = (amt)=>{
            if (this.max < 1) return;
            if (amt === this.current) return;
            this.build();
            const before = this.hearts;
            const after = Number.isFinite(amt) ? Math.max(0, amt / 2) : 0;
            this.current = amt;
            this.hearts = after;
            if (after < before) this.hitMs = $9b7bf4301258d7f9$var$HIT_MS;
            this.slots.forEach((slot, index)=>{
                const was = $9b7bf4301258d7f9$export$c83a6c73dceed244(before, index);
                const now = $9b7bf4301258d7f9$export$c83a6c73dceed244(after, index);
                slot.target = now;
                if (now === was) return;
                // A heart that changed throws a flash of its own colour: white-hot for damage, gold for
                // a heal. Damage also snaps the fill AHEAD of the drain by nothing -- the drain is what
                // sells it -- so the burst is the only instant part.
                slot.burstMs = $9b7bf4301258d7f9$var$BURST_MS;
                slot.burstColor = now < was ? 0xffffff : $9b7bf4301258d7f9$var$HEAL_COLOR;
            });
            this.needsDraw = true;
        }, /**
     * Advance one frame. `deltaMs` is the render loop's own delta.
     *
     * Returns without touching the display list when nothing is moving, which is the common case:
     * a healthy player's meter costs one comparison a frame.
     */ this.animate = (deltaMs)=>{
            if (!this.slots.length) return;
            let moving = false;
            const step = deltaMs / $9b7bf4301258d7f9$var$DRAIN_MS;
            for (const slot of this.slots){
                if (slot.shown !== slot.target) {
                    // Linear and clamped, never an exponential approach: a filter that only ever halves
                    // the remainder never actually lands, and a heart that is forever 2% full is a lie
                    // about how much health is left.
                    slot.shown = slot.shown > slot.target ? Math.max(slot.target, slot.shown - step) : Math.min(slot.target, slot.shown + step);
                    moving = true;
                }
                if (slot.burstMs > 0) {
                    slot.burstMs = Math.max(0, slot.burstMs - deltaMs);
                    moving = true;
                }
            }
            if (this.hitMs > 0) {
                this.hitMs = Math.max(0, this.hitMs - deltaMs);
                moving = true;
            }
            const beating = this.hearts > 0 && this.hearts <= $9b7bf4301258d7f9$export$f749d5530c9b9fa5;
            if (beating) {
                this.beatMs += deltaMs;
                moving = true;
            } else if (this.beatMs !== 0) {
                this.beatMs = 0;
                moving = true;
            }
            if (!moving && !this.needsDraw) return;
            this.needsDraw = false;
            this.redraw(beating);
        }, /**
     * Widen the plate to cover the whole vitals row, or pass undefined to go back to hugging the
     * hearts. Only the WIDTH moves, never the plate's own left or top, so a caller can place this
     * widget by `plateRect()` first and size the plate afterwards without the two chasing each other.
     */ this.setPlateWidth = (width)=>{
            if (this.plateSpan === width) return;
            this.plateSpan = width;
            this.needsDraw = true;
            this.redraw(false);
        }, /** The plate's rectangle in this widget's own space — what a caller lines up against. */ this.plateRect = ()=>{
            const art = this.artExtent();
            return {
                x: art.left - $9b7bf4301258d7f9$var$PLATE_PAD,
                y: -(art.height / 2 + $9b7bf4301258d7f9$var$PLATE_PAD) - $9b7bf4301258d7f9$var$PLATE_OPTICAL_LIFT,
                width: this.plateSpan ?? art.right - art.left + $9b7bf4301258d7f9$var$PLATE_PAD * 2,
                height: art.height + $9b7bf4301258d7f9$var$PLATE_PAD * 2
            };
        }, /**
     * The hearts' own resting rectangle, art only. Deliberately NOT getLocalBounds: a beating or
     * bursting heart is scaled up to 1.9, so anything laying a row out against measured bounds would
     * be shoved sideways by a hit.
     */ this.artRect = ()=>{
            const art = this.artExtent();
            return {
                x: art.left,
                y: -art.height / 2,
                width: art.right - art.left,
                height: art.height
            };
        }, /** Test seam: the fill each slot is currently SHOWING, which lags the value while it drains. */ this.shownFill = ()=>this.slots.map((slot)=>slot.shown), // ---------------------------------------------------------------- building
        // Built once, when the first real `max` arrives. The old meter made five fresh BasicSprites on
        // every hit -- each of which carries a click area and a Text -- and threw the previous five away.
        this.build = ()=>{
            const wanted = Math.floor(this.max / 2);
            if (this.slots.length === wanted) return;
            this.slots.forEach((slot)=>this.removeChild(slot.root));
            this.slots = [];
            for(let index = 0; index < wanted; index++){
                const root = new (0, $8t5Gy.Container)();
                const vessel = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: `${this.iconBase}-empty.png`,
                    scale: 1.0
                });
                const fill = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: `${this.iconBase}-full.png`,
                    scale: 1.0
                });
                const burst = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: `${this.iconBase}-full.png`,
                    scale: 1.0
                });
                // Centre each piece of art on the slot's origin, measured rather than assumed: the atlas
                // frames carry a TexturePacker pivot and the three need not share it. Written out
                // rather than with `||` defaults -- an already-centred sprite measures -0, which is
                // FALSY, so `a || b` silently takes the other branch on exactly the common case.
                const bounds = vessel.getLocalBounds();
                const width = bounds.width > 0 ? bounds.width : $9b7bf4301258d7f9$var$HEART_W;
                const height = bounds.height > 0 ? bounds.height : $9b7bf4301258d7f9$var$HEART_H;
                for (const art of [
                    vessel,
                    fill,
                    burst
                ]){
                    const own = art.getLocalBounds();
                    if (own.width > 0) {
                        art.x = -(own.x + own.width / 2);
                        art.y = -(own.y + own.height / 2);
                    }
                }
                if (burst.sprite) // Additive, so the flash reads as the heart lighting UP. A tint can only ever
                // darken, so there is no way to flash a sprite white by tinting it.
                burst.sprite.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
                burst.visible = false;
                const fillMask = new (0, $gwPoJ.Graphics)();
                root.addChild(vessel, fill, burst, fillMask);
                root.x = index * $9b7bf4301258d7f9$var$PITCH + $9b7bf4301258d7f9$var$PITCH / 2;
                this.addChild(root);
                this.slots.push({
                    root: root,
                    vessel: vessel,
                    fill: fill,
                    fillMask: fillMask,
                    burst: burst,
                    width: width,
                    height: height,
                    shown: $9b7bf4301258d7f9$export$c83a6c73dceed244(this.hearts, index),
                    target: $9b7bf4301258d7f9$export$c83a6c73dceed244(this.hearts, index),
                    burstMs: 0,
                    burstColor: 0xffffff
                });
            }
        }, // ---------------------------------------------------------------- drawing
        // The rectangle the ART actually occupies, which is what the plate is drawn around. The slot
        // grid is wider than its art (a slot is PITCH, the heart is HEART_W), so padding the grid puts
        // half a gap of extra air at each end and the row stops looking evenly spaced.
        this.artExtent = ()=>{
            const width = this.slots[0]?.width ?? $9b7bf4301258d7f9$var$HEART_W;
            const height = this.slots[0]?.height ?? $9b7bf4301258d7f9$var$HEART_H;
            return {
                left: $9b7bf4301258d7f9$var$PITCH / 2 - width / 2,
                right: (this.slots.length - 1) * $9b7bf4301258d7f9$var$PITCH + $9b7bf4301258d7f9$var$PITCH / 2 + width / 2,
                height: height
            };
        }, this.redraw = (beating)=>{
            const pulse = beating ? $9b7bf4301258d7f9$export$bc5d822131ac8085(this.beatMs / $9b7bf4301258d7f9$export$dd404402fdf5289d(this.hearts)) : 0;
            const hit = this.hitMs / $9b7bf4301258d7f9$var$HIT_MS;
            // The recoil rides on PIVOT, not position: pivot is part of this object's own transform, so
            // getLocalBounds -- and therefore where positionVitals puts the meters beside this one --
            // never sees the shake.
            this.pivot.x = hit > 0 ? Math.sin((1 - hit) * Math.PI * 5) * $9b7bf4301258d7f9$var$HIT_SHAKE * hit : 0;
            this.clear();
            this.drawPlate();
            this.drawBloom(hit);
            this.slots.forEach((slot)=>{
                const beats = beating && slot.shown > 0;
                slot.root.scale.set(1 + (beats ? $9b7bf4301258d7f9$var$BEAT_SCALE * pulse : 0));
                if (beats && pulse > 0) this.drawHalo(slot, pulse);
                this.layoutFill(slot);
                this.layoutBurst(slot);
            });
        }, this.drawPlate = ()=>{
            if (!this.slots.length) return;
            const { x: x, y: y, width: width, height: height } = this.plateRect();
            this.beginFill(0x000000, 0.3);
            this.drawRoundedRect(x, y + $9b7bf4301258d7f9$var$PLATE_SHADOW_DROP, width, height, $9b7bf4301258d7f9$var$PLATE_RADIUS);
            this.endFill();
            this.lineStyle({
                width: 1,
                color: $9b7bf4301258d7f9$var$PLATE_RIM,
                alpha: 0.35
            });
            this.beginFill($9b7bf4301258d7f9$var$PLATE_FILL, $9b7bf4301258d7f9$var$PLATE_ALPHA);
            this.drawRoundedRect(x, y, width, height, $9b7bf4301258d7f9$var$PLATE_RADIUS);
            this.endFill();
            this.lineStyle(0);
        }, // A red wash over the plate as a hit lands. Kept INSIDE the plate's own rectangle so it cannot
        // widen the meter's bounds.
        this.drawBloom = (hit)=>{
            if (hit <= 0 || !this.slots.length) return;
            // Scoped to the HEARTS' own span, not the whole plate: once the plate runs under the mana
            // and hunger bars too, washing all of it red would say the bars had been hit as well.
            const art = this.artExtent();
            const height = art.height + $9b7bf4301258d7f9$var$PLATE_PAD * 2;
            this.beginFill($9b7bf4301258d7f9$var$DANGER_COLOR, 0.42 * hit);
            this.drawRoundedRect(art.left - $9b7bf4301258d7f9$var$PLATE_PAD, -height / 2 - $9b7bf4301258d7f9$var$PLATE_OPTICAL_LIFT, art.right - art.left + $9b7bf4301258d7f9$var$PLATE_PAD * 2, height, $9b7bf4301258d7f9$var$PLATE_RADIUS);
            this.endFill();
        }, // The glow under a beating heart: three stacked discs, brightest in the middle. The cheap way to
        // a radial falloff when a blur filter is off the table.
        this.drawHalo = (slot, pulse)=>{
            const radius = Math.max(slot.width, slot.height) * 0.62;
            for(let ring = 0; ring < 3; ring++){
                this.beginFill($9b7bf4301258d7f9$var$DANGER_COLOR, 0.1 * pulse * (1 + ring * 0.5));
                this.drawCircle(slot.root.x, 0, radius * (1 - ring * 0.22));
                this.endFill();
            }
        }, // Reveal the full-heart art from the bottom up. The mask is dropped at both extremes, so a
        // healthy row carries no stencil work at all and a draining one carries exactly one.
        this.layoutFill = (slot)=>{
            if (!(slot.shown > 0)) {
                slot.fill.visible = false;
                slot.fill.mask = null;
                slot.fillMask.clear();
                return;
            }
            slot.fill.visible = true;
            if (slot.shown >= 1) {
                slot.fill.mask = null;
                slot.fillMask.clear();
                return;
            }
            const top = slot.height / 2 - slot.height * slot.shown;
            slot.fillMask.clear();
            slot.fillMask.beginFill(0xffffff, 1);
            slot.fillMask.drawRect(-slot.width, top, slot.width * 2, slot.height);
            slot.fillMask.endFill();
            slot.fill.mask = slot.fillMask;
        }, this.layoutBurst = (slot)=>{
            if (slot.burstMs <= 0) {
                slot.burst.visible = false;
                return;
            }
            const age = 1 - slot.burstMs / $9b7bf4301258d7f9$var$BURST_MS;
            slot.burst.visible = true;
            slot.burst.alpha = (1 - age) * 0.9;
            slot.burst.scale.set(1 + age * 0.9);
            slot.burst.recolor(slot.burstColor);
        };
        this.iconBase = iconBase;
        this.max = max;
    }
}


parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $gwPoJ = parcelRequire("gwPoJ");





// An "important" notice, rendered as a calm ambient strip: a thin translucent band near
// the top of the screen whose left/right edges fade to nothing. It fades in, holds long
// enough to read, then fades out. Deliberately NOT a hard black slab that pops in and
// shrinks away — that read as an alarm (and the shrink looked buggy). The point is to be
// noticed without blocking the game behind it.
//
// ONE SLOT, BUT NO LONGER LAST-WRITE-WINS. This draws whatever ImportantLane hands it; the lane
// owns the queue, the ordering and the timing (see important_lane.ts for why). The hold timer below
// stays as a BACKSTOP rather than as the rule: the lane cuts a line short through `dismiss()`, and
// if the lane were ever left unticked -- a render loop that stops, a HUD that never animates -- the
// strip still takes itself down on its own clock instead of sticking forever.
//
// TIERS. `alert` is the amber, slightly more opaque form, used for the handful of beats that are
// asking the player to go and do something (the dead are waking, the ritual is complete, a survivor
// was lost). `notice` is the original white, used for everything that merely reports (WAVE n,
// VICTORY, provisions left by the fire). The tier rides in `ScreenMessage.context.tier`, which is a
// field that already existed -- the countdown passes its wave the same way -- so nothing in the
// protocol or the models had to change for this.
const $a7b6262714ec8487$var$STRIP_TOP_Y = 40 // distance from the top of the screen to the top of the strip
;
const $a7b6262714ec8487$var$VERTICAL_PADDING = 12 // space above/below the text inside the strip
;
const $a7b6262714ec8487$var$HORIZONTAL_PADDING = 24 // keep wrapped text clear of the viewport edges
;
const $a7b6262714ec8487$var$STRIP_ALPHA = 0.5 // center opacity of the strip; low so the game stays visible behind it
;
// An alert sits a little heavier on the world behind it, which is most of what separates the two at
// a glance when the text is short enough to read in one hit.
const $a7b6262714ec8487$var$ALERT_STRIP_ALPHA = 0.62;
const $a7b6262714ec8487$var$TIER_STYLE = {
    notice: {
        color: 0xffffff,
        alpha: $a7b6262714ec8487$var$STRIP_ALPHA
    },
    alert: {
        color: (0, $97475243e21a0995$export$b1586623fe466c29).ember.accent,
        alpha: $a7b6262714ec8487$var$ALERT_STRIP_ALPHA
    }
};
class $a7b6262714ec8487$export$b3ee1e8559ec7f0c extends (0, $gwPoJ.Graphics) {
    constructor(color = 0xffffff, screenMessage){
        super(), this.bannerText = null, this.background = null, this.fadeInFader = null, this.fadeOutFader = null, this.holdTimer = null, this.displayCallback = null, // The strip spans the full visible width, which never changes (ScreenDimensions is
        // fixed and the stage is scaled to fit), so each tier's gradient texture is built once and
        // reused. Keyed by the tier's centre alpha, which is the only thing that differs between them.
        this.gradientTextures = new Map(), // Same full width hero_message uses (the visible viewport is wider than the 640 play area).
        this.stripWidth = ()=>(0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7, this.update = (message)=>{
            const { text: text, duration: duration, displayCallback: displayCallback } = message;
            const tier = message.context?.tier === "alert" ? "alert" : "notice";
            const style = $a7b6262714ec8487$var$TIER_STYLE[tier];
            this.displayCallback = displayCallback || null;
            // Interrupt any in-flight fade/hold so a newer message shows cleanly.
            this.stopAnimations();
            this.removeChildren();
            const width = this.stripWidth();
            const bannerText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().variant("ImportantFont").color(style.color).align("center").wordWrap(width - $a7b6262714ec8487$var$HORIZONTAL_PADDING * 2).render(text);
            this.bannerText = bannerText;
            const stripHeight = bannerText.height + $a7b6262714ec8487$var$VERTICAL_PADDING * 2;
            // Background gradient strip (built once per tier, reused thereafter).
            let gradientTexture = this.gradientTextures.get(style.alpha);
            if (!gradientTexture) {
                gradientTexture = (0, $7dcf9acc2579c643$export$4a423b5b028a4cfb)(width, stripHeight, style.alpha);
                this.gradientTextures.set(style.alpha, gradientTexture);
            }
            const background = new (0, $7Bs2Z.Sprite)(gradientTexture);
            background.x = 0;
            background.y = $a7b6262714ec8487$var$STRIP_TOP_Y;
            background.width = width;
            background.height = stripHeight;
            if (gradientTexture === (0, $klOfb.Texture).WHITE) {
                // Fallback path (no 2D canvas): tint + alpha the flat texture so it still reads as a dark strip.
                background.tint = 0x000000;
                background.alpha = style.alpha;
            }
            this.background = background;
            this.addChild(background);
            // Text centered horizontally across the full width, vertically within the strip.
            bannerText.x = width / 2 - bannerText.width / 2;
            bannerText.y = $a7b6262714ec8487$var$STRIP_TOP_Y + (stripHeight - bannerText.height) / 2;
            this.addChild(bannerText);
            // Hold time scales gently with message length (min 1.5s) so there's time to read it. The
            // lane normally passes the hold it resolved, so this is the fallback for a direct caller.
            const wordCount = text.split(" ").length;
            const holdMs = duration || Math.max(1500, wordCount * 300);
            // Fade in -> hold -> fade out. No pop-in, no shrink-to-zero.
            this.visible = true;
            this.alpha = 0.0;
            this.fadeInFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                direction: "in",
                minAlpha: 1.0,
                fadeInterval: 5,
                fadeAlphaDecrement: 0.025,
                releaseCallback: ()=>{
                    this.fadeInFader = null;
                    this.holdTimer = setTimeout(()=>{
                        this.holdTimer = null;
                        this.startFadeOut();
                    }, holdMs);
                }
            });
            this.fadeInFader.update();
        }, /**
     * Take the current line down now, mid-hold.
     *
     * This is how the lane shortens a line that something more urgent is waiting behind: the strip
     * still fades rather than cutting, so the slot hands over the way it always did. A no-op while
     * nothing is showing, and while a fade-out is already running -- otherwise a second call would
     * restart the fade from whatever alpha the first had reached.
     */ this.dismiss = ()=>{
            if (!this.visible || this.fadeOutFader) return;
            if (this.fadeInFader) {
                this.fadeInFader.stop(true);
                this.fadeInFader = null;
                this.alpha = 1.0;
            }
            if (this.holdTimer) {
                clearTimeout(this.holdTimer);
                this.holdTimer = null;
            }
            this.startFadeOut();
        }, this.startFadeOut = ()=>{
            this.fadeOutFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this, {
                direction: "out",
                minAlpha: 0.0,
                fadeInterval: 10,
                fadeAlphaDecrement: 0.025,
                releaseCallback: ()=>{
                    this.fadeOutFader = null;
                    this.visible = false;
                    this.alpha = 1.0;
                    this.removeChildren();
                    if (this.displayCallback) {
                        this.displayCallback();
                        this.displayCallback = null;
                    }
                }
            });
            this.fadeOutFader.update();
        }, this.stopAnimations = ()=>{
            if (this.fadeInFader) {
                this.fadeInFader.stop(true);
                this.fadeInFader = null;
            }
            if (this.fadeOutFader) {
                this.fadeOutFader.stop(true);
                this.fadeOutFader = null;
            }
            if (this.holdTimer) {
                clearTimeout(this.holdTimer);
                this.holdTimer = null;
            }
        }, // Mirrors HeroMessage.destroy: tear down timers/faders so nothing fires against a dead Graphics.
        this.destroy = ()=>{
            this.stopAnimations();
            this.removeChildren();
            this.visible = false;
            this.alpha = 1.0;
        };
        this.color = color;
        this.screenMessage = screenMessage;
        this.visible = false;
        this.zIndex = 55000 // above the rest of the HUD; below the hero banner / countdown (60000)
        ;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $hnGDn = parcelRequire("hnGDn");
class $f98cea862b8a2ca9$export$c75dedfb09f9174d extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.show = [], this.createToggles = (height, i)=>{
            if (this.toggle[i]) return;
            const toggle = new (0, $gwPoJ.Graphics)();
            this.toggle[i] = toggle;
            toggle.lineStyle(1, 0xff0000);
            // Because the array is initialized as [], we need to specifically check for undefined, not just a falsey value.
            if (this.show[i] === undefined) this.show[i] = false;
            if (!this.show[i]) {
                toggle.beginFill(0x101010);
                toggle.drawRect(0, 0, 8, 8);
                toggle.endFill();
            } else {
                toggle.beginFill(0xcc0000);
                toggle.drawRect(0, 0, 8, 8);
                toggle.endFill();
            }
            toggle.x = -15;
            toggle.y = 7 + height;
            toggle.interactive = true;
            toggle.on("mouseover", ()=>{
                this.guiManager.mouseOverControl(true);
            });
            toggle.on("mouseout", ()=>{
                this.guiManager.mouseOverControl(false);
            });
            toggle.on("mouseup", ()=>{
                this.show[i] = !this.show[i];
                this.update(this.leaderboards);
            });
            this.addChild(toggle);
        }, this.renderBoard = (boardIndex, leaderboard, pos, show)=>{
            const graphics = new (0, $gwPoJ.Graphics)();
            const name = leaderboard.name.replace("_", " ").toLowerCase().split(" ").map((n)=>{
                return n.split("").map((l, i)=>i === 0 ? l.toUpperCase() : l).join("");
            }).join(" ");
            const leaderName = leaderboard.items[0].name;
            const headerContainer = new (0, $gwPoJ.Graphics)();
            const headerText = new (0, $hnGDn.BitmapText)(`Top ${name}`, {
                fontName: "LeaderboardFont"
            });
            headerContainer.addChild(headerText);
            headerContainer.interactive = true;
            headerContainer.on("mouseover", ()=>{
                this.guiManager.mouseOverControl(true);
            });
            headerContainer.on("mouseout", ()=>{
                this.guiManager.mouseOverControl(false);
            });
            headerContainer.on("mouseup", ()=>{
                this.show[boardIndex] = !this.show[boardIndex];
                this.update(this.leaderboards);
            });
            if (!show) {
                const name = new (0, $hnGDn.BitmapText)(leaderName, {
                    fontName: "LeaderboardLeaderFont"
                });
                name.x = 175 - name.width;
                headerContainer.addChild(name);
            }
            graphics.addChild(headerContainer);
            graphics.lineStyle(1, 0x00a000);
            graphics.drawRect(0, headerText.height, 175, 1);
            let height = headerContainer.height;
            if (show) leaderboard.items.forEach((item, i)=>{
                const font = {
                    fontName: i == 0 ? "LeaderboardLeaderFont" : "LeaderboardFont"
                };
                const name = new (0, $hnGDn.BitmapText)(item.name, font);
                name.y = headerContainer.height + i * name.height + 3;
                graphics.addChild(name);
                const count = new (0, $hnGDn.BitmapText)("" + item.count, font);
                count.y = headerContainer.height + i * count.height + 3;
                count.x = graphics.width - count.width;
                graphics.addChild(count);
                height += name.height;
            });
            graphics.y = pos;
            this.addChild(graphics);
            return height + (show ? 15 : 5);
        }, this.update = (leaderboards)=>{
            this.leaderboards = leaderboards;
            this.toggle = this.leaderboards ? new Array(leaderboards.length).fill(null) : [];
            // clear all
            this.removeChildren();
            if (!leaderboards) return;
            let prevHeight = 0;
            leaderboards.sort().forEach((next, i)=>{
                this.createToggles(prevHeight, i);
                prevHeight += this.renderBoard(i, next, prevHeight, this.show[i]);
            });
        };
        this.guiManager = guiManager;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
class $fad6195fae17b303$export$62e3ae2a4090b879 extends (0, $gwPoJ.Graphics) {
    constructor(color = 0x00ff00, max, lowColor){
        super(), this.update = (amt)=>{
            const color = this.lowColor ? amt < this.max / 2 ? 0xff0000 : this.color : this.color;
            this.clear();
            for(let i = 0; i < amt; i++){
                super.lineStyle(0, color);
                super.beginFill(color);
                super.drawRoundedRect(i * 3, 2, 3, 2 + this.barHeight, 0);
                super.endFill();
            }
            super.lineStyle(1, color, 0.4);
            super.beginFill(color, 0.35);
            super.drawRoundedRect(-2, 0, this.max * 3 + 4, this.barHeight + 6, 2);
        };
        this.color = color;
        this.lowColor = lowColor;
        this.max = max;
        this.barHeight = 6;
    }
} // 0 - 3
 // 6 - 9
 // 12 - 15
 // 24 - 27
 // 30 - 33



class $6cfcddb9955aa6fe$export$10811ae595fe85fd extends (0, $gwPoJ.Graphics) {
    constructor(color = 0x00ff00, max, spriteId, lowColor){
        super(), this.update = (amt)=>{
            this.meter.update(amt);
        };
        this.max = max;
        this.meter = new (0, $fad6195fae17b303$export$62e3ae2a4090b879)(color, max, lowColor);
        const icon = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
            name: spriteId || "stamina.png",
            scale: 0.9
        });
        icon.y = icon.height / 2 + 1;
        this.addChild(icon);
        this.meter.x = 13;
        this.addChild(this.meter);
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");



const $1401bf9c6a4e7405$var$WIDTH = 90;
const $1401bf9c6a4e7405$var$TRACK_Y = 11;
const $1401bf9c6a4e7405$var$TRACK_HEIGHT = 5;
class $1401bf9c6a4e7405$export$160dd9b73ca3e58e extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.max = 1, this.track = new (0, $gwPoJ.Graphics)(), this.fill = new (0, $gwPoJ.Graphics)(), this.target = 1, this.shown = 1, this.initialized = false, this.update = (ratio)=>{
            this.target = Number.isFinite(ratio) ? Math.max(0, Math.min(1, ratio)) : 0;
            if (!this.initialized) {
                this.shown = this.target;
                this.initialized = true;
                this.draw();
            }
        }, this.animate = (deltaMs)=>{
            if (!this.visible || this.shown === this.target) return;
            // A brief settle makes individual attack costs readable without a distracting flash.
            const delta = this.target - this.shown;
            this.shown += delta * (1 - Math.exp(-Math.max(0, Math.min(deltaMs, 100)) / 90));
            if (Math.abs(this.target - this.shown) < 0.001) this.shown = this.target;
            this.draw();
        }, this.draw = ()=>{
            // Follow the animated fill, so hue and length settle together during drain and recovery.
            const color = this.shown <= 0.5 ? (0, $ec347662891822a3$export$33ee99e9ec522cbf)(0xe36b60, 0xd8b46b, this.shown * 2) : (0, $ec347662891822a3$export$33ee99e9ec522cbf)(0xd8b46b, 0x91c78a, (this.shown - 0.5) * 2);
            this.label.tint = (0, $ec347662891822a3$export$33ee99e9ec522cbf)(0xe99688, (0, $97475243e21a0995$export$4569a0b09aa32d6c), Math.min(1, this.shown / 0.25));
            this.fill.clear();
            const width = ($1401bf9c6a4e7405$var$WIDTH - 2) * this.shown;
            if (width <= 0) return;
            this.fill.beginFill(color, 0.95).drawRoundedRect(1, $1401bf9c6a4e7405$var$TRACK_Y + 1, width, $1401bf9c6a4e7405$var$TRACK_HEIGHT - 2, Math.min(1.5, width / 2)).endFill();
            // Fine, pale upper edge: a lit metal inlay rather than a flat neon rectangle.
            this.fill.beginFill((0, $ec347662891822a3$export$33ee99e9ec522cbf)(color, 0xfff3e0, 0.55), 0.45).drawRect(1, $1401bf9c6a4e7405$var$TRACK_Y + 1, width, 1).endFill();
        };
        this.label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(8).bold().color(0xffffff).strokeThickness(0).render("STAMINA");
        this.label.style.letterSpacing = 1;
        this.label.style.padding = 2;
        this.addChild(this.track, this.fill, this.label);
        // This fixed track also keeps the row's geometry steady at empty and full.
        this.track.lineStyle(1, (0, $97475243e21a0995$export$cac838e5dd111a30), 0.65).beginFill(0x100c09, 0.95).drawRoundedRect(0, $1401bf9c6a4e7405$var$TRACK_Y, $1401bf9c6a4e7405$var$WIDTH, $1401bf9c6a4e7405$var$TRACK_HEIGHT, 2).endFill();
        this.draw();
    }
}




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");



class $09653c960702fb63$export$3ddf2d174ce01153 {
    constructor(parent, { padding: padding = 0, x: x = 0, y: y = 0, content: content = new (0, $gwPoJ.Graphics)(), borderColor: borderColor = 0xffffff, backgroundColor: backgroundColor = 0x000000, backgroundAlpha: backgroundAlpha = 0.91, width: width, height: height, closeCallback: closeCallback, onCloseClick: onCloseClick, onMouseOver: onMouseOver, onMouseOut: onMouseOut, plain: plain, unescapeable: unescapeable, closeAnchor: closeAnchor, closeButtonScale: closeButtonScale = 1, closeTheme: closeTheme, hideCloseButton: hideCloseButton, dragHandle: dragHandle, dragBounds: dragBounds, onDrag: onDrag }){
        this.closed = false;
        this.update = ()=>{
            if (this.closed) return;
            if (this.dialog) {
                this.layout();
                return;
            }
            const dialog = new (0, $gwPoJ.Graphics)();
            this.dialog = dialog;
            this.dialog.zIndex = 3;
            this.parent.addChild(dialog);
            this.content.x = this.padding;
            this.content.y = this.padding;
            this.attachDragHandle(dialog);
            dialog.addChild(this.content);
            if (!this.unescapeable) {
                const close = new (0, $e59d4eca9b366180$export$de65de8213222d10)({
                    onClick: this.onCloseClick,
                    theme: this.closeTheme
                });
                close.scale.set(this.closeButtonScale);
                this.closeButton = close;
                dialog.addChild(close);
            }
            this.layout();
            dialog.interactive = !!this.onMouseOut || !!this.onMouseOver;
            if (this.onMouseOver) dialog.on("mouseover", ()=>this.onMouseOver());
            if (this.onMouseOut) dialog.on("mouseout", ()=>this.onMouseOut());
        };
        // Resize the existing frame without rebuilding content or registering input listeners again.
        /** The close disc, when this dialog has one: drawn over its content, not part of it. */ this.closeControl = ()=>this.closeButton;
        this.layout = (options)=>{
            if (this.closed || !this.dialog) return;
            if (options) Object.assign(this, options);
            const bounds = this.content.getLocalBounds();
            const width = (this.width ?? Math.max(0, bounds.x + bounds.width)) + this.padding * 2;
            const height = (this.height ?? Math.max(0, bounds.y + bounds.height)) + this.padding * 2;
            const dialog = this.dialog;
            dialog.position.set(this.x, this.y);
            dialog.clear();
            if (!this.plain) dialog.lineStyle(1, this.borderColor, 0.5);
            dialog.beginFill(this.backgroundColor, this.backgroundAlpha);
            if (this.plain) dialog.drawRect(0, 0, width, height);
            else dialog.drawRoundedRect(0, 0, width, height, 8);
            dialog.endFill();
            if (this.closeButton) {
                this.closeButton.visible = !(typeof this.hideCloseButton === "function" ? this.hideCloseButton() : this.hideCloseButton);
                this.closeButton.refreshMetrics();
                const anchor = typeof this.closeAnchor === "function" ? this.closeAnchor() : this.closeAnchor;
                const radius = this.closeButton.getRadius() * this.closeButtonScale;
                this.closeButton.position.set(anchor ? anchor.x + this.padding : width - radius - 6, anchor ? anchor.y + this.padding : radius + 6);
                // A target expanded for touch must stay reachable inside the visible, safe frame.
                const metrics = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)();
                if (metrics.touch) {
                    const target = this.closeButton.getHitSize();
                    const halfW = target.width * this.closeButtonScale / 2;
                    const halfH = target.height * this.closeButtonScale / 2;
                    const safe = metrics.safeViewport;
                    const clamp = (value, min, max)=>max < min ? (min + max) / 2 : Math.max(min, Math.min(max, value));
                    this.closeButton.x = clamp(this.closeButton.x, Math.max(0, safe.left - this.x) + halfW, Math.min(width, safe.right - this.x) - halfW);
                    this.closeButton.y = clamp(this.closeButton.y, Math.max(0, safe.top - this.y) + halfH, Math.min(height, safe.bottom - this.y) - halfH);
                }
            }
        };
        this.attachDragHandle = (dialog)=>{
            const { dragHandle: dragHandle, dragBounds: dragBounds, onDrag: onDrag } = this.dragOptions;
            if (!dragHandle) return;
            const handle = new (0, $gwPoJ.Graphics)();
            handle.hitArea = {
                contains: (x, y)=>{
                    const rect = typeof dragHandle === "function" ? dragHandle() : dragHandle;
                    const left = rect.x + this.padding;
                    const top = rect.y + this.padding;
                    return x >= left && y >= top && x < left + rect.width && y < top + rect.height;
                }
            };
            handle.interactive = true;
            handle.cursor = "grab";
            dialog.addChild(handle);
            let grab;
            handle.on("pointerdown", (event)=>{
                // Pixi normalizes an active TouchEvent to button=1. Only filter secondary mouse/pen buttons.
                if (grab || event.data.pointerType !== "touch" && event.data.button > 0) return;
                const pointer = event.data.getLocalPosition(this.parent);
                grab = {
                    x: dialog.x - pointer.x,
                    y: dialog.y - pointer.y,
                    pointerId: event.data.pointerId
                };
                handle.cursor = "grabbing";
                event.stopPropagation();
            });
            handle.on("pointermove", (event)=>{
                if (!grab || event.data.pointerId !== grab.pointerId) return;
                const pointer = event.data.getLocalPosition(this.parent);
                const bounds = dragBounds?.();
                const x = pointer.x + grab.x;
                const y = pointer.y + grab.y;
                dialog.x = bounds ? Math.max(bounds.left, Math.min(x, bounds.right)) : x;
                dialog.y = bounds ? Math.max(bounds.top, Math.min(y, bounds.bottom)) : y;
                onDrag?.();
                event.stopPropagation();
            });
            const release = (event)=>{
                if (grab && event.data.pointerId === grab.pointerId) {
                    grab = undefined;
                    handle.cursor = "grab";
                }
            };
            handle.on("pointerup", release);
            handle.on("pointerupoutside", release);
            handle.on("pointercancel", release);
        };
        this.close = ()=>{
            if (this.closed) return;
            // Mark closed before removing children or calling user code, either of which can reenter.
            this.closed = true;
            if (!this.dialog) return;
            // Free the dialog content's per-instance Text textures on close -- every modal/dialog
            // (inventory, character sheet, etc.) builds Text via TextRenderer, and detaching without
            // this strands each one's canvas-backed texture (not reclaimed by GC). Shared item-sprite
            // textures are left intact by disposeTextTextures.
            (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(this.dialog);
            this.dialog.parent?.removeChild(this.dialog);
            // The content root belongs to the caller (fullscreen screens reuse it on their next open).
            this.dialog.removeChild(this.content);
            this.dialog.destroy({
                children: true
            });
            this.closeCallback?.();
        };
        this.parent = parent;
        this.padding = padding;
        this.content = content;
        this.x = x;
        this.y = y;
        this.backgroundAlpha = backgroundAlpha;
        this.backgroundColor = backgroundColor;
        this.width = width;
        this.height = height;
        this.closeCallback = closeCallback;
        this.onCloseClick = onCloseClick;
        this.borderColor = borderColor;
        this.onMouseOver = onMouseOver;
        this.onMouseOut = onMouseOut;
        this.plain = plain;
        this.unescapeable = unescapeable;
        this.closeAnchor = closeAnchor;
        this.closeButtonScale = closeButtonScale;
        this.closeTheme = closeTheme;
        this.hideCloseButton = hideCloseButton;
        this.dragOptions = {
            dragHandle: dragHandle,
            dragBounds: dragBounds,
            onDrag: onDrag
        };
    }
}


class $33e5ff783af47130$export$2b77a92f1a5ad772 {
    static{
        // Every modal up right now, whichever screen raised it (an item screen, the world map, help...).
        this.open = new Set();
    }
    static{
        /** True while any modal is up. One whose stage has since been torn down no longer counts. */ this.isAnyOpen = ()=>Array.from($33e5ff783af47130$export$2b77a92f1a5ad772.open).some((modal)=>!modal.parent.destroyed);
    }
    constructor(logic, parent, props){
        this.closedClicked = false;
        this.closed = false;
        this.escapeSuspended = false;
        this.resolveLayout = ()=>{
            const viewport = (0, $167efe97b4119a5d$export$b0f20d83cec42115)();
            const padding = this.props.padding ?? 0;
            const bounds = this.props.content.getLocalBounds();
            this.width = this.props.fullScreen ? Math.max(0, viewport.width - padding * 2) : this.props.width ?? Math.max(0, bounds.x + bounds.width);
            this.height = this.props.fullScreen ? Math.max(0, viewport.height - padding * 2) : this.props.height ?? Math.max(0, bounds.y + bounds.height);
            return {
                width: this.width,
                height: this.height,
                x: this.props.fullScreen ? viewport.left : this.props.center ? viewport.left + (viewport.width - this.width - padding * 2) / 2 : this.props.x ?? 0,
                y: this.props.fullScreen ? viewport.top : this.props.center ? viewport.top + (viewport.height - this.height - padding * 2) / 2 : this.props.y ?? 0
            };
        };
        this.resize = ()=>{
            if (this.closed || !this.dialog) return;
            this.dialog.layout(this.resolveLayout());
            this.props.onResize?.();
        };
        // Key DOWN only. The key-up matters because a sub-panel that borrows Escape (see suspendEscape)
        // hands it back the moment it closes on the key-down -- and the key-up that follows would
        // otherwise land here and take the whole screen down behind it.
        this.closeListener = (key, down)=>{
            if (!this.closed && this.dialog && key === "Escape" && down && !this.escapeSuspended) {
                this.closedClicked = true;
                this.dialog.close();
            }
        };
        // A sub-panel opened INSIDE this modal (the trade screen's quantity picker) borrows Escape while
        // it is up, so backing out of the picker doesn't also tear down the screen behind it.
        this.suspendEscape = (suspended)=>{
            this.escapeSuspended = suspended;
        };
        this.release = ()=>{
            if (this.closed) return;
            this.closed = true;
            $33e5ff783af47130$export$2b77a92f1a5ad772.open.delete(this);
            window.removeEventListener("samsara:canvas-resize", this.resize);
            // this.logic.playerController.enabledKeyboardAction(true)
            this.logic.playerController.enabledMouseAction(true);
            this.logic.clientRenderer.keyboard().removeListener(this.closeListener);
            this.props.onClosed?.();
            if (this.props.closeCallback && !this.suppressOnCloseCallback) this.props.closeCallback(this.closedClicked);
        };
        this.update = ()=>{
            if (this.closed) return;
            if (this.dialog) {
                this.dialog.layout(this.resolveLayout());
                return;
            }
            const createDialog = ()=>{
                const mouseOver = ()=>{
                    if (this.props.onMouseOver) this.props.onMouseOver();
                    this.logic.enablePlayerMouseAction(false);
                };
                const mouseOut = ()=>{
                    if (this.props.onMouseOut) this.props.onMouseOut();
                    this.logic.enablePlayerMouseAction(true);
                };
                const dialog = new (0, $09653c960702fb63$export$3ddf2d174ce01153)(this.parent, {
                    ...this.props,
                    ...this.resolveLayout(),
                    onMouseOver: mouseOver,
                    onMouseOut: mouseOut,
                    closeCallback: this.release,
                    onCloseClick: ()=>{
                        this.closedClicked = true;
                        dialog.close();
                    }
                });
                dialog.update();
                return dialog;
            };
            const dialog = createDialog();
            this.dialog = dialog;
            $33e5ff783af47130$export$2b77a92f1a5ad772.open.add(this);
            if (this.props.fullScreen || this.props.center) window.addEventListener("samsara:canvas-resize", this.resize);
            // setup
            // this.logic.playerController.enabledKeyboardAction(false)
            this.logic.playerController.enabledMouseAction(false);
            if (!this.props.unescapeable) this.logic.clientRenderer.keyboard().addListener(this.closeListener);
        };
        this.close = ()=>{
            if (!this.dialog) {
                this.closed = true;
                return;
            }
            this.dialog.close();
        };
        this.closeControl = ()=>this.dialog?.closeControl();
        this.logic = logic;
        this.parent = parent;
        this.props = props;
        this.resolveLayout();
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");



class $11fe0387f9c174f1$export$85cd1614e509c3d9 extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.setup = (resourcesMeta = [])=>{
            [
                ...this.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.removeChildren();
            let prev;
            resourcesMeta.forEach((meta, idx)=>{
                const icon = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: meta.icon,
                    scale: 1.0,
                    color: 0xffffff
                });
                icon.x = prev ? prev + 40 : 0;
                icon.y = icon.height < (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 ? icon.height + 5 : icon.height / 2 + 2;
                this.addChild(icon);
                const quantityText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().render();
                quantityText.x = Math.max((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2, icon.x + icon.width - 8);
                quantityText.y = 1;
                quantityText.text = `${meta.quantity}`;
                this.addChild(quantityText);
                prev = icon.x + quantityText.width;
            });
        };
        this.guiManager = guiManager;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");



class $bbfac5179e5fdb9e$export$d5f40203d1afc530 extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.renderSlot = (label, spriteMeta, selected, callback)=>{
            const slot = new (0, $gwPoJ.Graphics)();
            const item = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)(spriteMeta);
            item.interactive = true;
            item.on("pointerdown", callback);
            slot.addChild(item);
            const labelObject = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render(label);
            labelObject.x = -20;
            labelObject.y = -30;
            if (selected) labelObject.tint = 0x00ff00;
            slot.addChild(labelObject);
            return slot;
        }, this.update = (squadState)=>{
            [
                ...this.children
            ].forEach((0, $7fc026ed2e091ee4$export$7e4c1296b4859de0));
            this.removeChildren();
            if (squadState.count < 1) return;
            const baseMeta = {
                animated: false,
                color: 0xffffff,
                name: "",
                scale: 1.0
            };
            let i = -1;
            const width = 40;
            {
                i++;
                const scale = 1;
                const name = `squad-tome.png`;
                const shortcutKey = `J`;
                const callback = ()=>{
                // alert(squadState.stance)
                };
                const slot = this.renderSlot(shortcutKey, {
                    ...baseMeta,
                    color: baseMeta.color,
                    name: name,
                    scale: scale
                }, false, callback);
                slot.x = i * width;
                this.addChild(slot);
            }
            {
                i++;
                const scale = 1;
                const name = `formation-${squadState?.formation || "random"}.png`;
                const shortcutKey = `K`;
                const callback = ()=>{
                // alert(squadState.stance)
                };
                const slot = this.renderSlot(shortcutKey, {
                    ...baseMeta,
                    color: baseMeta.color,
                    name: name,
                    scale: scale
                }, false, callback);
                slot.x = i * width;
                this.addChild(slot);
            }
            {
                i++;
                const scale = 1;
                const name = `stance-${squadState?.stance || "defense"}.png`;
                const shortcutKey = `L`;
                const callback = ()=>{
                // alert(squadState.stance)
                };
                const slot = this.renderSlot(shortcutKey, {
                    ...baseMeta,
                    color: baseMeta.color,
                    name: name,
                    scale: scale
                }, false, callback);
                slot.x = i * width;
                this.addChild(slot);
            }
        };
        this.guiManager = guiManager;
    }
}


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");
var $9Pi8W = parcelRequire("9Pi8W");









parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");




// The speech bubble that floats above the ember roster strip when a camp member says something the
// player can't see them say (they're outside the viewport). Its tail points down at the speaker's
// roster card, so the line is tied to a face and a name rather than floating free.
//
// ONE bubble exists and is re-aimed as the lane's occupant changes — see EmberRosterWidget, which
// owns the queue. Keeping it single is the whole clutter strategy: a bubble is far wider than the
// ~56px card it belongs to, so two of them side by side would overlap and neither would be readable.
//
// It fades in and out rather than popping, and a HANDOVER between two speakers fades the old line
// out before the new one fades in — the tail moves to a different card, so cross-dissolving in place
// would read as the bubble teleporting. The fade is driven by the roster's existing per-frame tick
// rather than the Fader utility, which spawns a setInterval per fade; this runs on every frame the
// roster already animates, and timer churn is worth avoiding on the low-end hardware this targets.
// THE LOOK (restyled 2026-10-10): the in-world chat bubble's own cut-timber panel
// (sprites/avatar_hud.ts spokeImpl) -- HUD_PANEL plate, chamfered corners, an inked bronze rim, a
// dropped shadow and a lit top edge, body and tail ONE path -- so a line reads as the same object
// whether it is said beside you or relayed from off screen. It used to be a rounded rect ringed and
// haloed in the speaker's ROLE colour, with the tail drawn as a second shape, centred text with a
// black outline, and the name centred over it like a title card. The role colour now lives in one
// place: the speaker's NAME, set as a small capitals tag above the line. The card the tail lands on
// already pulses in that colour while its member speaks (EmberRosterWidget.drawSpeakingRing), so
// the tie between bubble and card does not need the rim as well.
const $23d13a6e2a72aec5$var$PANEL_FILL = (0, $97475243e21a0995$export$ae463dc3cc7e810b);
const $23d13a6e2a72aec5$var$PANEL_ALPHA = 0.97;
const $23d13a6e2a72aec5$var$TEXT_COLOR = (0, $97475243e21a0995$export$92999bc7164f195e);
const $23d13a6e2a72aec5$var$PAD_X = 10;
const $23d13a6e2a72aec5$var$PAD_Y = 7;
const $23d13a6e2a72aec5$var$CHAMFER = 6;
const $23d13a6e2a72aec5$var$TAIL_H = 8;
const $23d13a6e2a72aec5$var$TAIL_HALF_W = 6;
const $23d13a6e2a72aec5$var$LINE_GAP = 2;
// The rim, as on the world bubble: a wide dark stroke with a thin bronze one down its middle.
// (In roster units, which the strip draws at 0.8 -- so these land at the world bubble's 3.5 / 1.25.)
const $23d13a6e2a72aec5$var$EDGE_WIDTH = 4.4;
const $23d13a6e2a72aec5$var$EDGE_ALPHA = 0.95;
const $23d13a6e2a72aec5$var$RIM_WIDTH = 1.5;
const $23d13a6e2a72aec5$var$MITER_LIMIT = 3 // bevels the tail's tip rather than spiking it
;
const $23d13a6e2a72aec5$var$SHADOW_Y = 3;
const $23d13a6e2a72aec5$var$SHADOW_ALPHA = 0.38;
const $23d13a6e2a72aec5$var$TOP_LIGHT_ALPHA = 0.2;
const $23d13a6e2a72aec5$var$NAME_SPACING = 1.2;
// EVERY size here is in the roster widget's local units, which the strip then draws at
// WIDGET_SCALE (0.8) — so a font set to 15 lands at ~12px on screen. 12px is deliberate: it is what
// the in-world chat bubble uses (the shared "speech" role), so a line reads the same whether
// you happen to be standing next to the speaker or reading it off the HUD.
const $23d13a6e2a72aec5$var$ROSTER_SCALE = 0.8;
const $23d13a6e2a72aec5$var$SCREEN_MSG_PX = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).speech.fontSize;
const $23d13a6e2a72aec5$var$SCREEN_NAME_PX = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).compactCaption.fontSize;
const $23d13a6e2a72aec5$var$MSG_SIZE = Math.round($23d13a6e2a72aec5$var$SCREEN_MSG_PX / $23d13a6e2a72aec5$var$ROSTER_SCALE);
const $23d13a6e2a72aec5$var$NAME_SIZE = Math.round($23d13a6e2a72aec5$var$SCREEN_NAME_PX / $23d13a6e2a72aec5$var$ROSTER_SCALE);
// Wide enough for a sentence over two lines at that size, narrow enough to sit over the strip.
const $23d13a6e2a72aec5$var$MAX_W = 250;
// Hard cap so a long line can't grow the bubble without bound. The longest thing anyone currently
// says (the Lord's camp-news lines) is ~60 characters.
const $23d13a6e2a72aec5$var$MAX_CHARS = 72;
// The name line doesn't wrap, so an over-long name would render wider than the body it sits in and
// spill out both sides of the bubble. Cap it.
const $23d13a6e2a72aec5$var$MAX_NAME_CHARS = 18;
// Rough line box for a font size — Verdana's ascent+descent plus the 1px stroke TextRenderer adds.
const $23d13a6e2a72aec5$var$lineHeight = (fontSize)=>Math.ceil(fontSize * 1.35);
const $23d13a6e2a72aec5$export$256f864ac4a53998 = $23d13a6e2a72aec5$var$PAD_Y * 2 + $23d13a6e2a72aec5$var$lineHeight($23d13a6e2a72aec5$var$NAME_SIZE) + $23d13a6e2a72aec5$var$LINE_GAP + 3 * $23d13a6e2a72aec5$var$lineHeight($23d13a6e2a72aec5$var$MSG_SIZE) + $23d13a6e2a72aec5$var$TAIL_H;
// Half the dark edge stroke paints outside the body's rect. The clamp has to allow for it or the
// rim is what runs off-screen.
const $23d13a6e2a72aec5$var$GLOW_PAD = Math.ceil($23d13a6e2a72aec5$var$EDGE_WIDTH / 2) + 1;
const $23d13a6e2a72aec5$export$6ba66118f048f541 = (contentW, contentH, tailX, tailY, clampRight)=>{
    const width = Math.min($23d13a6e2a72aec5$var$MAX_W, contentW + $23d13a6e2a72aec5$var$PAD_X * 2);
    const height = contentH + $23d13a6e2a72aec5$var$PAD_Y * 2;
    const rightLimit = clampRight - $23d13a6e2a72aec5$var$GLOW_PAD;
    let left = tailX - width / 2;
    if (left + width > rightLimit) left = rightLimit - width;
    return {
        left: left,
        top: tailY - $23d13a6e2a72aec5$var$TAIL_H - height,
        width: width,
        height: height
    };
};
const $23d13a6e2a72aec5$var$FADE_IN_MS = 160;
const $23d13a6e2a72aec5$var$FADE_OUT_MS = 220;
class $23d13a6e2a72aec5$export$1173af088df4f527 extends (0, $8t5Gy.Container) {
    constructor(){
        super(), // The utterance currently drawn (null while nothing is), and where the fade is up to.
        this.shownKey = null, this.fade = 0, // Drive one frame of the bubble toward `target` (null = nothing to say). Handles the fade and
        // the swap, so the caller can simply hand over whatever the lane picked each frame.
        this.update = (dtMs, target)=>{
            const wantsSwap = target !== null && this.shownKey !== null && target.key !== this.shownKey;
            // Fade OUT when there's nothing to show, or when a different speaker is taking the lane —
            // the new line only appears once the old one has cleared.
            if (target === null || wantsSwap) {
                this.fade = Math.max(0, this.fade - dtMs / $23d13a6e2a72aec5$var$FADE_OUT_MS);
                if (this.fade <= 0) {
                    this.shownKey = null;
                    this.visible = false;
                }
                this.alpha = this.fade;
                return;
            }
            if (this.shownKey !== target.key) {
                this.draw(target);
                this.shownKey = target.key;
                this.visible = true;
            }
            this.fade = Math.min(1, this.fade + dtMs / $23d13a6e2a72aec5$var$FADE_IN_MS);
            this.alpha = this.fade;
        }, // Lay the bubble out around its tail. `tailX`/`tailY` are the tail TIP in the parent's
        // coordinate space (the top-centre of the speaking card); the body is drawn above it, and
        // `clampRight` keeps it from spilling past the right edge of the roster strip.
        this.draw = (target)=>{
            const { name: name, text: text, tailX: tailX, tailY: tailY, clampRight: clampRight, color: color } = target;
            const trimmed = text.length > $23d13a6e2a72aec5$var$MAX_CHARS ? text.slice(0, $23d13a6e2a72aec5$var$MAX_CHARS - 1) + "\u2026" : text;
            if (this.messageText.text !== trimmed) this.messageText.text = trimmed;
            const shortName = (name.length > $23d13a6e2a72aec5$var$MAX_NAME_CHARS ? name.slice(0, $23d13a6e2a72aec5$var$MAX_NAME_CHARS - 1) + "\u2026" : name).toUpperCase();
            if (this.nameText.text !== shortName) this.nameText.text = shortName;
            this.nameText.tint = color;
            // letterSpacing adds a trailing advance after the last capital; it is not ink.
            const nameW = Math.max(0, this.nameText.width - $23d13a6e2a72aec5$var$NAME_SPACING);
            const contentW = Math.max(nameW, this.messageText.width);
            const contentH = this.nameText.height + $23d13a6e2a72aec5$var$LINE_GAP + this.messageText.height;
            const box = $23d13a6e2a72aec5$export$6ba66118f048f541(contentW, contentH, tailX, tailY, clampRight);
            const { left: bodyLeft, top: bodyTop, width: bodyW, height: bodyH } = box;
            this.drawBubble(bodyLeft, bodyTop, bodyW, bodyH, tailX, tailY);
            const textX = Math.round(bodyLeft + $23d13a6e2a72aec5$var$PAD_X);
            this.nameText.position.set(textX, Math.round(bodyTop + $23d13a6e2a72aec5$var$PAD_Y));
            this.messageText.position.set(textX, Math.round(bodyTop + $23d13a6e2a72aec5$var$PAD_Y + this.nameText.height + $23d13a6e2a72aec5$var$LINE_GAP));
        }, // Body + tail as ONE path, filled and stroked once, so the rim runs unbroken round the tail
        // (drawing the tail as a second shape left a seam and a fill mismatch on the world bubble).
        this.drawBubble = (left, top, w, h, tailX, tailY)=>{
            const g = this.bg;
            const c = $23d13a6e2a72aec5$var$CHAMFER;
            const right = left + w;
            const bottom = top + h;
            // The tail's base slides along the bottom edge to sit under the speaker's card, clear of the
            // chamfers; its tip stays on the card, leaning when the body had to slide left to fit.
            const baseX = Math.max(left + c + $23d13a6e2a72aec5$var$TAIL_HALF_W + 1, Math.min(right - c - $23d13a6e2a72aec5$var$TAIL_HALF_W - 1, tailX));
            const trace = (oy)=>{
                g.moveTo(left + c, top + oy);
                g.lineTo(right - c, top + oy);
                g.lineTo(right, top + c + oy);
                g.lineTo(right, bottom - c + oy);
                g.lineTo(right - c, bottom + oy);
                g.lineTo(baseX + $23d13a6e2a72aec5$var$TAIL_HALF_W, bottom + oy);
                g.lineTo(tailX, tailY + oy);
                g.lineTo(baseX - $23d13a6e2a72aec5$var$TAIL_HALF_W, bottom + oy);
                g.lineTo(left + c, bottom + oy);
                g.lineTo(left, bottom - c + oy);
                g.lineTo(left, top + c + oy);
                g.closePath();
            };
            g.clear();
            // Dropped silhouette, straight down: a diagonal offset ghosts a second tail beside the real one.
            g.lineStyle(0);
            g.beginFill(0x000000, $23d13a6e2a72aec5$var$SHADOW_ALPHA);
            trace($23d13a6e2a72aec5$var$SHADOW_Y);
            g.endFill();
            g.lineStyle({
                width: $23d13a6e2a72aec5$var$EDGE_WIDTH,
                color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
                alpha: $23d13a6e2a72aec5$var$EDGE_ALPHA,
                join: (0, $gwPoJ.LINE_JOIN).MITER,
                miterLimit: $23d13a6e2a72aec5$var$MITER_LIMIT
            });
            g.beginFill($23d13a6e2a72aec5$var$PANEL_FILL, $23d13a6e2a72aec5$var$PANEL_ALPHA);
            trace(0);
            g.endFill();
            g.lineStyle({
                width: $23d13a6e2a72aec5$var$RIM_WIDTH,
                color: (0, $97475243e21a0995$export$cac838e5dd111a30),
                alpha: 1,
                join: (0, $gwPoJ.LINE_JOIN).MITER,
                miterLimit: $23d13a6e2a72aec5$var$MITER_LIMIT
            });
            trace(0);
            // One lit edge along the top, so the panel has a direction the light falls from.
            g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), $23d13a6e2a72aec5$var$TOP_LIGHT_ALPHA);
            g.moveTo(left + c + 1, top + 2.5).lineTo(right - c - 1, top + 2.5);
            g.lineStyle(0);
        };
        this.bg = new (0, $gwPoJ.Graphics)();
        // The speaker's name: a small letterspaced capitals tag, the one thing in the role's colour.
        this.nameText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("compactCaption").fontSize($23d13a6e2a72aec5$var$NAME_SIZE).bold().strokeThickness(0).render("");
        this.nameText.style.letterSpacing = $23d13a6e2a72aec5$var$NAME_SPACING;
        // Left-aligned, like the world bubble's lines: a two-line wrap reads better from one edge
        // than centred on a ragged middle. No outline -- it sits on a solid plate.
        this.messageText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("speech").fontSize($23d13a6e2a72aec5$var$MSG_SIZE).strokeThickness(0).wordWrap($23d13a6e2a72aec5$var$MAX_W - $23d13a6e2a72aec5$var$PAD_X * 2).render("");
        this.messageText.tint = $23d13a6e2a72aec5$var$TEXT_COLOR;
        this.addChild(this.bg, this.nameText, this.messageText);
        this.visible = false;
    }
}


// The state machine behind the ember roster's offscreen speech lane. Kept free of PIXI (like
// faction_tracker_geometry.ts) so the rules can be unit-tested without a renderer; ember_roster.ts
// owns the drawing and just asks this what to show.
//
// THE CLUTTER RULE. A camp member who speaks while the player can't see them gets their line shown
// over their roster card. A readable bubble is several times wider than the ~56px card it belongs
// to, so two of them side by side would overlap into mush — the lane therefore holds exactly ONE at
// a time and everyone else queues:
//
//   - a line holds the lane for MIN_MS before it can be pushed out, so it can actually be read,
//   - and gives it up at MAX_MS even if nobody is waiting, so the HUD returns to quiet,
//   - every collected line keeps its turn, including older lines during a burst,
//   - and every speaker's card flashes the moment they speak, so a queued line is acknowledged
//     immediately even though its bubble has to wait its turn.
const $9e747834c562d64b$export$5c1878fd8e0add16 = 2200;
const $9e747834c562d64b$export$c0be6884d7e4f609 = 5200;
const $9e747834c562d64b$export$42fd3fb39fa9e691 = 700;
class $9e747834c562d64b$export$902003cea2799f4d {
    constructor(){
        this.queue = [];
        this.current = null;
        this.elapsedMs = 0;
        // The last line already reacted to per member, so one utterance raises one bubble rather than
        // one per frame it remains inside its ~3s window.
        this.handled = new Map();
        // entityId -> remaining flash time.
        this.pulses = new Map();
        // Advance one frame. `getSpeech` must answer null for anyone the player can currently SEE —
        // their bubble is already drawn over their head in the world, and repeating it here is noise.
        this.update = (dtMs, members, getSpeech)=>{
            this.collect(members, getSpeech);
            this.advance(dtMs, getSpeech);
            this.advancePulses(dtMs);
        };
        // The line to show, or null for an empty lane.
        this.currentLine = ()=>this.current;
        // 0..1 flash strength for a member's card this frame.
        this.pulseAlpha = (entityId)=>(this.pulses.get(entityId) || 0) / $9e747834c562d64b$export$42fd3fb39fa9e691;
        this.queueLength = ()=>this.queue.length;
        // A member who left the roster keeps neither the lane nor a place in the queue.
        this.forget = (entityId)=>{
            this.queue = this.queue.filter((q)=>q.entityId !== entityId);
            this.handled.delete(entityId);
            this.pulses.delete(entityId);
            if (this.current?.entityId === entityId) this.clear();
        };
        this.collect = (members, getSpeech)=>{
            members.forEach((member)=>{
                const line = getSpeech(member.entityId);
                if (!line) {
                    // Window lapsed, or they walked into view: re-arm so saying the same thing again
                    // later counts as a fresh utterance.
                    this.handled.delete(member.entityId);
                    return;
                }
                if (this.handled.get(member.entityId) === line) return;
                this.handled.set(member.entityId, line);
                this.pulses.set(member.entityId, $9e747834c562d64b$export$42fd3fb39fa9e691);
                this.queue.push({
                    entityId: member.entityId,
                    name: member.name,
                    text: line
                });
            });
        };
        this.advance = (dtMs, getSpeech)=>{
            if (this.current) {
                this.elapsedMs += dtMs;
                const readable = this.elapsedMs >= $9e747834c562d64b$export$5c1878fd8e0add16;
                // Let it go early once the player has caught up with the speaker — they can see the real
                // bubble now — but never before it has been up long enough to read.
                const caughtUp = getSpeech(this.current.entityId) === null;
                if (readable && (caughtUp || this.queue.length > 0) || this.elapsedMs >= $9e747834c562d64b$export$c0be6884d7e4f609) this.clear();
            }
            if (!this.current && this.queue.length > 0) {
                this.current = this.queue.shift();
                this.elapsedMs = 0;
            }
        };
        this.advancePulses = (dtMs)=>{
            for (const [entityId, remaining] of Array.from(this.pulses.entries())){
                const next = remaining - dtMs;
                if (next <= 0) this.pulses.delete(entityId);
                else this.pulses.set(entityId, next);
            }
        };
        this.clear = ()=>{
            this.current = null;
            this.elapsedMs = 0;
        };
    }
}



const $8d6533e00bd59062$export$cdc10a00a6ecc04e = 70;
const $8d6533e00bd59062$export$4cacdb4184ffb7a8 = 96;
const $8d6533e00bd59062$export$2295e056c5b8b159 = 6;
const $8d6533e00bd59062$export$f8b8d0e2524d7c47 = 5;
const $8d6533e00bd59062$export$4e669d5539617474 = 6;
const $8d6533e00bd59062$export$937b0d3608fcf11e = 1.5;
const $8d6533e00bd59062$export$77f435e13f71eb7f = $8d6533e00bd59062$export$cdc10a00a6ecc04e / 2;
const $8d6533e00bd59062$export$572eba96a021644d = 50;
const $8d6533e00bd59062$export$e1a1d856f86d5382 = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).label.fontSize;
const $8d6533e00bd59062$export$c51218e3426de1b7 = 4;
const $8d6533e00bd59062$export$b643d415cf93452e = 3;
const $8d6533e00bd59062$export$9abd345d8933c5ce = 38;
const $8d6533e00bd59062$export$50e8cfc43db69af3 = $8d6533e00bd59062$export$4cacdb4184ffb7a8 - 32;
const $8d6533e00bd59062$export$dc9a8445d2f3c372 = 9;
const $8d6533e00bd59062$export$1c21151185bd8e77 = $8d6533e00bd59062$export$4cacdb4184ffb7a8 - 18;
const $8d6533e00bd59062$export$d80daa1884709eb5 = 5;
const $8d6533e00bd59062$export$8c0eb8c159a41292 = $8d6533e00bd59062$export$1c21151185bd8e77 + $8d6533e00bd59062$export$d80daa1884709eb5 + 2;
const $8d6533e00bd59062$export$30e8349973c4d242 = 4;
const $8d6533e00bd59062$export$6881c612b1e8acd5 = 11;
const $8d6533e00bd59062$export$68dee29db058ecad = 11;
const $8d6533e00bd59062$export$e74fbfde0a93daa9 = 0.3;
const $8d6533e00bd59062$export$d87ce5ad91d00207 = 900;
const $8d6533e00bd59062$export$a3fc1e002308197a = (ratio)=>ratio > 0.6 ? 0xf0b429 : ratio > $8d6533e00bd59062$export$e74fbfde0a93daa9 ? 0xe07b39 : 0xd94f3d;
const $8d6533e00bd59062$export$ff66bb5d2113fcb7 = (ratio)=>ratio > 0.5 ? 0x6fe06f : ratio > 0.25 ? 0xffd23f : 0xff5c5c;
const $8d6533e00bd59062$export$3b4d14647a9972a3 = 2.5;
const $8d6533e00bd59062$export$1520631a15db096 = 2;
const $8d6533e00bd59062$export$c964a3078907ce20 = 0.25;
const $8d6533e00bd59062$export$7a164107508d4f84 = (ratio)=>ratio > $8d6533e00bd59062$export$c964a3078907ce20 ? 0xffb648 : 0xff7a45;
const $8d6533e00bd59062$export$c082e8bc79733f73 = 0xc21a1a;
const $8d6533e00bd59062$export$7b5bc50f06bd4503 = 0xff4d4d;
const $8d6533e00bd59062$export$2231d9ccf0d5169e = 0xffd9d9;
const $8d6533e00bd59062$export$77f3d2d2b010c804 = 0xff5959;
const $8d6533e00bd59062$export$e82906a3183f43fc = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).title.fontSize;
const $8d6533e00bd59062$export$db313b0d55ae90f4 = 44;



parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");



const $df39eaafb36c45c0$export$9c9863fd2b4a26c6 = 24;
const $df39eaafb36c45c0$export$f8db1cc21f63f690 = 3;
const $df39eaafb36c45c0$export$314245d45833463c = (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - $df39eaafb36c45c0$export$f8db1cc21f63f690 * 2;
// Clear air inside the chip, and how far a label may be squeezed to stay inside it. Two labels
// ("Defending", and "Needs job" in the alarm's bold) are a hair wider than the chip at the fire
// warning's size; shrinking those two by a few percent is invisible, where clipping them is not, and
// it beats inventing a shorter word for one of the states purely because of the font.
const $df39eaafb36c45c0$var$PILL_PAD_X = 4;
const $df39eaafb36c45c0$var$MIN_TEXT_SCALE = 0.8;
// The alarm/warning colours are the fire warning's own, so "red chip in the roster lane" keeps
// meaning exactly one thing. The working colours are the ROLE colours the cards and minimap dots
// already use, which is what lets the row be scanned by colour before it is read.
const $df39eaafb36c45c0$var$ALARM = 0xff5959;
const $df39eaafb36c45c0$var$WARN = 0xffbd45;
const $df39eaafb36c45c0$var$FORAGER = 0x7be08a;
const $df39eaafb36c45c0$var$DEFENDER = 0xff8a5c;
const $df39eaafb36c45c0$var$FOLLOWING = 0x2bc4a8;
// Ember gold: a visitor is not one of the camp yet, and their chips say so in the colour of the fire
// that drew them in (matching their card's patience ring).
const $df39eaafb36c45c0$var$VISITOR = 0xffb648;
const $df39eaafb36c45c0$var$PILL_TEXT = 0xfff3e0;
const $df39eaafb36c45c0$var$PLATE_FILL = 0x10140f;
const $df39eaafb36c45c0$var$PLATE_ALPHA = 0.9;
const $df39eaafb36c45c0$export$916504b9880d3fa9 = {
    // It has stopped, and will not start again until this player answers. The question mark is the
    // whole point: it is addressed to the reader.
    awaitingOrders: {
        label: "Orders?",
        tone: "alarm",
        color: $df39eaafb36c45c0$var$ALARM
    },
    // Deliberately phrased like "No fire!", the alarm beside it: both are "the camp is out of
    // something and that is about to cost you somebody".
    needsFood: {
        label: "No food!",
        tone: "alarm",
        color: $df39eaafb36c45c0$var$ALARM
    },
    hungry: {
        label: "Hungry",
        tone: "warn",
        color: $df39eaafb36c45c0$var$WARN
    },
    idle: {
        label: "Idle",
        tone: "warn",
        color: $df39eaafb36c45c0$var$WARN
    },
    fighting: {
        label: "Fighting",
        tone: "busy",
        color: $df39eaafb36c45c0$var$DEFENDER
    },
    holding: {
        label: "Holding",
        tone: "busy",
        color: $df39eaafb36c45c0$var$DEFENDER
    },
    defending: {
        label: "Defending",
        tone: "busy",
        color: $df39eaafb36c45c0$var$DEFENDER
    },
    following: {
        label: "Following",
        tone: "busy",
        color: $df39eaafb36c45c0$var$FOLLOWING
    },
    foraging: {
        label: "Foraging",
        tone: "busy",
        color: $df39eaafb36c45c0$var$FORAGER
    },
    repairing: {
        label: "Repairing",
        tone: "busy",
        color: $df39eaafb36c45c0$var$FORAGER
    },
    feedingFire: {
        label: "Fire duty",
        tone: "busy",
        color: $df39eaafb36c45c0$var$FORAGER
    },
    hauling: {
        label: "Hauling",
        tone: "busy",
        color: $df39eaafb36c45c0$var$FORAGER
    },
    wantsFood: {
        label: "Hungry",
        tone: "warn",
        color: $df39eaafb36c45c0$var$VISITOR
    },
    // The one state the camp cannot resolve on its own: they have been paid and are standing at the
    // fire with nothing to do until a role is picked for them.
    needsJob: {
        label: "Needs job",
        tone: "alarm",
        color: $df39eaafb36c45c0$var$VISITOR
    }
};
const $df39eaafb36c45c0$export$e9dce1cbee204240 = (status)=>status ? $df39eaafb36c45c0$export$916504b9880d3fa9[status] : undefined;
const $df39eaafb36c45c0$export$3d3231c99f8a15bb = (plate, color, tone)=>{
    plate.clear();
    if (tone === "alarm") plate.beginFill(color, 1);
    else {
        plate.beginFill($df39eaafb36c45c0$var$PLATE_FILL, $df39eaafb36c45c0$var$PLATE_ALPHA);
        plate.lineStyle(1, color, 0.55);
    }
    plate.drawRoundedRect(0, 0, $df39eaafb36c45c0$export$314245d45833463c, $df39eaafb36c45c0$export$9c9863fd2b4a26c6, $df39eaafb36c45c0$export$9c9863fd2b4a26c6 / 2);
    plate.endFill();
};
const $df39eaafb36c45c0$export$8e160a798f1ef897 = (text)=>{
    const room = $df39eaafb36c45c0$export$314245d45833463c - $df39eaafb36c45c0$var$PILL_PAD_X * 2;
    text.scale.set(1);
    if (text.width > room) text.scale.set(Math.max($df39eaafb36c45c0$var$MIN_TEXT_SCALE, room / text.width));
    text.position.set(Math.round(($df39eaafb36c45c0$export$314245d45833463c - text.width) / 2), Math.round(($df39eaafb36c45c0$export$9c9863fd2b4a26c6 - text.height) / 2));
};
class $df39eaafb36c45c0$export$e0c9e7096bf0a040 extends (0, $8t5Gy.Container) {
    constructor(...args){
        super(...args), this.pills = new Map(), // Lay the row out from the cards it belongs to. Called from the roster's own layout(), so the
        // chips move with the strip -- including the sideways shove a visitor's gap gives the household.
        //
        // Everything is diffed rather than rebuilt: a Text is a rasterised texture, the roster ticks twice
        // a second, and a member at its post holds the same status for minutes at a time.
        this.sync = (entries)=>{
            const seen = new Set();
            entries.forEach((entry)=>{
                const style = $df39eaafb36c45c0$export$e9dce1cbee204240(entry.status);
                if (!style) {
                    // Nothing to say about this member. Any chip it had goes, rather than being left
                    // showing the last thing that was true about it.
                    this.forget(entry.entityId);
                    return;
                }
                seen.add(entry.entityId);
                let pill = this.pills.get(entry.entityId);
                if (!pill) {
                    const root = new (0, $8t5Gy.Container)();
                    const plate = new (0, $gwPoJ.Graphics)();
                    // Weight is set per tone in `paint` (bold is the alarm's, not everybody's).
                    const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("caption").strokeThickness(0).render("");
                    root.addChild(plate, text);
                    this.addChild(root);
                    pill = {
                        root: root,
                        plate: plate,
                        text: text,
                        status: entry.status,
                        tone: style.tone
                    };
                    this.pills.set(entry.entityId, pill);
                    this.paint(pill, entry.status, style);
                } else if (pill.status !== entry.status) this.paint(pill, entry.status, style);
                pill.root.x = entry.x + $df39eaafb36c45c0$export$f8db1cc21f63f690;
            });
            Array.from(this.pills.keys()).forEach((entityId)=>{
                if (!seen.has(entityId)) this.forget(entityId);
            });
        }, // The breath the alarm chips take, driven by the roster's own pulse clock so every alarm in the
        // HUD -- these, the fire warning, a starving member's hunger bar -- rises and falls together.
        // Opacity only: a chip that moved or scaled would drag the eye off the card it belongs to.
        this.pulse = (alpha)=>{
            this.pills.forEach((pill)=>{
                pill.root.alpha = pill.tone === "alarm" ? alpha : 1;
            });
        }, this.forget = (entityId)=>{
            const pill = this.pills.get(entityId);
            if (!pill) return;
            this.pills.delete(entityId);
            this.removeChild(pill.root);
            // Textures first, then the rest: a Text owns a canvas-backed texture pixi only reclaims on an
            // explicit destroy, and destroying it detaches it, so it is gone from the root by the time
            // the root goes (no double destroy).
            (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(pill.root);
            pill.root.destroy({
                children: true
            });
        }, this.forgetAll = ()=>{
            Array.from(this.pills.keys()).forEach(this.forget);
        }, // --- for tests and the browser console
        this.labelFor = (entityId)=>this.pills.get(entityId)?.text.text, this.count = ()=>this.pills.size, this.paint = (pill, status, style)=>{
            pill.plate.cacheAsBitmap = false;
            pill.status = status;
            pill.tone = style.tone;
            $df39eaafb36c45c0$export$3d3231c99f8a15bb(pill.plate, style.color, style.tone);
            pill.text.text = style.label;
            // Pale ink on the filled alarm, the chip's own colour on every dark one -- the same two
            // treatments the HUD's filled and outlined buttons use.
            pill.text.tint = style.tone === "alarm" ? $df39eaafb36c45c0$var$PILL_TEXT : style.color;
            // BOLD IS THE ALARM'S, like the fill. A whole row set in bold is a row of headlines, and the
            // eye then has to read every one of them to find the one that matters; the working chips are
            // set light so they can be skipped.
            pill.text.style.fontWeight = style.tone === "alarm" ? "bolder" : "normal";
            $df39eaafb36c45c0$export$8e160a798f1ef897(pill.text);
            pill.root.alpha = 1;
            // The shape is static until status changes; the alarm only pulses the root's alpha.
            pill.plate.cacheAsBitmap = true;
        };
    }
}


// The impact an ember roster card takes when its member is hurt. Kept free of PIXI (like
// roster_speech_lane.ts) so the timings and curves can be unit-tested without a renderer;
// ember_roster.ts owns the drawing and just asks this what a card should look like this frame.
//
// WHY A CARD HAS TO SHOUT. The roster is the only sight the player has of a camp member who is
// fighting somewhere off-screen, and an HP bar 52px wide losing a few pixels is not something
// anyone notices mid-fight. So a hit is drawn as an EVENT rather than a new value: the card jolts,
// washes red, and the health it just lost is left hanging as a pale "ghost" segment that drains
// away a beat later -- the fighting-game trick, which is what makes the size of the hit legible at
// a glance. A rising damage number over the portrait says exactly how much.
//
// Everything is scaled by SEVERITY (the share of the member's maximum health the blow took), so a
// scratch reads as a scratch and a mauling reads as a mauling. The roster only speaks every 500ms
// (ROSTER_INTERVAL_MS), so what arrives is really "the damage taken since the last tick" -- one
// jolt per tick is the most any card can show, and that is the right density for the HUD anyway.
const $510d6be55289832c$export$be5fdb9a8fa8ab45 = 360;
const $510d6be55289832c$export$6c1279663b1160c7 = 500;
const $510d6be55289832c$export$2b1e059ccff43a50 = 620;
const $510d6be55289832c$export$25d491887f28ed2b = 190;
const $510d6be55289832c$export$37009f542e15b99d = 200;
const $510d6be55289832c$export$985f4ffd0a61844d = 420;
const $510d6be55289832c$export$7c035f1efc26822 = 1100;
const $510d6be55289832c$export$16bddead18efce30 = $510d6be55289832c$export$7c035f1efc26822;
const $510d6be55289832c$export$c4792b23dd798686 = 0.25;
const $510d6be55289832c$export$cd5aa8e599364038 = 2;
const $510d6be55289832c$export$435698e2819999e8 = 6.5;
const $510d6be55289832c$export$386e78b4dec646f6 = 21;
const $510d6be55289832c$export$e02c62cd85f02998 = 0.04;
const $510d6be55289832c$export$ad35d3e46d06a1bb = 0.11;
const $510d6be55289832c$export$bbbcf641baad31af = 0.55;
const $510d6be55289832c$export$3459ca9a00502428 = 0.9;
const $510d6be55289832c$export$270b70581362efed = 24;
const $510d6be55289832c$export$9a468fc1f4d8a2e3 = 0.45;
const $510d6be55289832c$var$clamp01 = (v)=>v < 0 ? 0 : v > 1 ? 1 : v;
const $510d6be55289832c$export$57800b7ee2fc44c1 = (elapsedMs, severity)=>{
    if (elapsedMs >= $510d6be55289832c$export$be5fdb9a8fa8ab45) return {
        x: 0,
        y: 0
    };
    const decay = 1 - elapsedMs / $510d6be55289832c$export$be5fdb9a8fa8ab45;
    const amp = ($510d6be55289832c$export$cd5aa8e599364038 + ($510d6be55289832c$export$435698e2819999e8 - $510d6be55289832c$export$cd5aa8e599364038) * $510d6be55289832c$var$clamp01(severity)) * decay * decay;
    const w = 2 * Math.PI * $510d6be55289832c$export$386e78b4dec646f6 / 1000;
    return {
        x: amp * Math.sin(elapsedMs * w),
        y: amp * 0.4 * Math.sin(elapsedMs * w * 1.7 + 1.1)
    };
};
const $510d6be55289832c$export$5ecbb996e3d16f6f = (elapsedMs, severity)=>{
    if (elapsedMs >= $510d6be55289832c$export$25d491887f28ed2b) return 1;
    const amount = $510d6be55289832c$export$e02c62cd85f02998 + ($510d6be55289832c$export$ad35d3e46d06a1bb - $510d6be55289832c$export$e02c62cd85f02998) * $510d6be55289832c$var$clamp01(severity);
    return 1 + amount * Math.sin(Math.PI * (elapsedMs / $510d6be55289832c$export$25d491887f28ed2b));
};
const $510d6be55289832c$export$d4dc426e7bd6642e = (elapsedMs)=>{
    if (elapsedMs >= $510d6be55289832c$export$6c1279663b1160c7) return 0;
    const p = 1 - elapsedMs / $510d6be55289832c$export$6c1279663b1160c7;
    return $510d6be55289832c$export$bbbcf641baad31af * p * p;
};
const $510d6be55289832c$export$4f7bbc3eca0964c0 = (elapsedMs)=>elapsedMs >= $510d6be55289832c$export$2b1e059ccff43a50 ? 0 : $510d6be55289832c$export$3459ca9a00502428 * (1 - elapsedMs / $510d6be55289832c$export$2b1e059ccff43a50);
const $510d6be55289832c$export$c6b2f0bee2bd53d2 = (elapsedMs, fromRatio, toRatio)=>{
    if (elapsedMs <= $510d6be55289832c$export$37009f542e15b99d) return fromRatio;
    const p = $510d6be55289832c$var$clamp01((elapsedMs - $510d6be55289832c$export$37009f542e15b99d) / $510d6be55289832c$export$985f4ffd0a61844d);
    return fromRatio + (toRatio - fromRatio) * p * p;
};
const $510d6be55289832c$export$6b868817a54a4b96 = (elapsedMs)=>{
    if (elapsedMs >= $510d6be55289832c$export$7c035f1efc26822) return {
        alpha: 0,
        rise: $510d6be55289832c$export$270b70581362efed
    };
    const p = elapsedMs / $510d6be55289832c$export$7c035f1efc26822;
    const alpha = p < $510d6be55289832c$export$9a468fc1f4d8a2e3 ? 1 : 1 - (p - $510d6be55289832c$export$9a468fc1f4d8a2e3) / (1 - $510d6be55289832c$export$9a468fc1f4d8a2e3);
    return {
        alpha: alpha,
        rise: $510d6be55289832c$export$270b70581362efed * (1 - (1 - p) * (1 - p))
    };
};
class $510d6be55289832c$export$c2606b7ba4b337e3 {
    constructor(){
        this.pulses = new Map();
        this.nextSeq = 1;
        // A member's health went DOWN. Healing and first sightings never reach here -- the caller only
        // knows there was a hit because it remembers what the last roster tick said.
        this.hit = (entityId, previousHp, hp, hpMax)=>{
            const lost = previousHp - hp;
            if (!(hpMax > 0) || !(lost > 0)) return;
            const existing = this.pulses.get(entityId);
            const beforeRatio = $510d6be55289832c$var$clamp01(previousHp / hpMax);
            this.pulses.set(entityId, {
                elapsedMs: 0,
                amount: Math.max(1, Math.round(lost)),
                severity: $510d6be55289832c$var$clamp01(lost / hpMax / $510d6be55289832c$export$c4792b23dd798686),
                // Struck again mid-effect: start the ghost from wherever it currently stands rather than
                // from the health before THIS hit, or the pale segment would jump back down and the two
                // blows would read as one small one.
                fromRatio: existing ? Math.max(beforeRatio, $510d6be55289832c$export$c6b2f0bee2bd53d2(existing.elapsedMs, existing.fromRatio, existing.toRatio)) : beforeRatio,
                toRatio: $510d6be55289832c$var$clamp01(hp / hpMax),
                seq: this.nextSeq++
            });
        };
        this.update = (dtMs)=>{
            for (const [entityId, pulse] of Array.from(this.pulses.entries())){
                pulse.elapsedMs += dtMs;
                if (pulse.elapsedMs >= $510d6be55289832c$export$16bddead18efce30) this.pulses.delete(entityId);
            }
        };
        // What this member's card should look like, or null when it is at rest (the common case -- the
        // widget then puts the card back to its resting position and stops redrawing it).
        this.frame = (entityId)=>{
            const pulse = this.pulses.get(entityId);
            if (!pulse) return null;
            const { elapsedMs: elapsedMs, severity: severity } = pulse;
            const shake = $510d6be55289832c$export$57800b7ee2fc44c1(elapsedMs, severity);
            const number = $510d6be55289832c$export$6b868817a54a4b96(elapsedMs);
            return {
                shakeX: shake.x,
                shakeY: shake.y,
                scale: $510d6be55289832c$export$5ecbb996e3d16f6f(elapsedMs, severity),
                flashAlpha: $510d6be55289832c$export$d4dc426e7bd6642e(elapsedMs),
                ringAlpha: $510d6be55289832c$export$4f7bbc3eca0964c0(elapsedMs),
                ghostRatio: $510d6be55289832c$export$c6b2f0bee2bd53d2(elapsedMs, pulse.fromRatio, pulse.toRatio),
                numberAlpha: number.alpha,
                numberRise: number.rise,
                amount: pulse.amount,
                seq: pulse.seq
            };
        };
        // A member who left the roster takes their effect with them.
        this.forget = (entityId)=>{
            this.pulses.delete(entityId);
        };
        this.activeCount = ()=>this.pulses.size;
    }
}


// How an ember roster card leaves the strip when its member dies. PIXI-free (like
// roster_damage.ts and roster_speech_lane.ts beside it), so the timings and the shard motion can be
// unit-tested without a renderer; ember_roster.ts owns the objects and draws what this decides.
//
// WHY A DEATH GETS A SECOND AND A HALF. Until now a member who died simply stopped being in the
// roster broadcast, and their card vanished between two ticks -- the strip just had one card fewer,
// with nothing to say that somebody had been lost. The camp is small enough that losing a defender
// matters, so the card is given an exit:
//
//   - the colour drains out of it until it is completely grey (the member is gone),
//   - then the card itself breaks apart and the pieces fall away,
//   - and only once the last piece has gone does the strip close the gap.
//
// The card holds its COLUMN for the whole of it. Letting the survivors slide over immediately would
// put a live card on top of the one that is breaking up, and would also mean the strip shrank before
// the player had seen which card it was.
const $bb9e23e7af52cc31$export$db237cf1ba467f33 = 500;
const $bb9e23e7af52cc31$export$8c5c1ebc079711ff = 1000;
const $bb9e23e7af52cc31$export$f3b14c224c07c95b = $bb9e23e7af52cc31$export$db237cf1ba467f33 + $bb9e23e7af52cc31$export$8c5c1ebc079711ff;
const $bb9e23e7af52cc31$export$6029fd88d9db5b6 = 14;
const $bb9e23e7af52cc31$export$9c83558f29ac851e = 900;
const $bb9e23e7af52cc31$export$c059030fbdddd4b3 = 70;
const $bb9e23e7af52cc31$export$172c7549624448fe = 150;
const $bb9e23e7af52cc31$export$d19c6a2eaa617cfa = 420;
const $bb9e23e7af52cc31$export$4b1fde3a9508334 = 90;
const $bb9e23e7af52cc31$export$70ee08772c334b5 = 0.35;
const $bb9e23e7af52cc31$var$clamp01 = (v)=>v < 0 ? 0 : v > 1 ? 1 : v;
const $bb9e23e7af52cc31$export$54311821b45b94a4 = (elapsedMs)=>{
    const p = $bb9e23e7af52cc31$var$clamp01(elapsedMs / $bb9e23e7af52cc31$export$db237cf1ba467f33);
    return 1 - (1 - p) * (1 - p);
};
const $bb9e23e7af52cc31$export$1d5894916c503cf9 = (elapsedMs)=>elapsedMs >= $bb9e23e7af52cc31$export$db237cf1ba467f33;
const $bb9e23e7af52cc31$export$b019cd4aafde2132 = (elapsedMs)=>elapsedMs >= $bb9e23e7af52cc31$export$f3b14c224c07c95b;
const $bb9e23e7af52cc31$export$3157021a2e406e10 = (size, resolution)=>{
    const scale = resolution > 0 ? resolution : 1;
    return Math.ceil(size * scale) / scale;
};
const $bb9e23e7af52cc31$export$62785211b15662cd = (width, height, rand = Math.random, size = $bb9e23e7af52cc31$export$6029fd88d9db5b6)=>{
    const cols = Math.max(1, Math.ceil(width / size));
    const rows = Math.max(1, Math.ceil(height / size));
    const seeds = [];
    for(let row = 0; row < rows; row++)for(let col = 0; col < cols; col++){
        const x = col * size;
        const y = row * size;
        // Where this piece sits relative to the card's centre, -1..1 on each axis. It decides
        // which way the piece is thrown, so the card comes apart from the middle.
        const nx = cols > 1 ? (col - (cols - 1) / 2) / ((cols - 1) / 2) : 0;
        const ny = rows > 1 ? (row - (rows - 1) / 2) / ((rows - 1) / 2) : 0;
        const spread = Math.min(1, Math.sqrt(nx * nx + ny * ny));
        seeds.push({
            col: col,
            row: row,
            x: x,
            y: y,
            // Clipped at the right/bottom edge so the shards tile the card exactly.
            w: Math.min(size, width - x),
            h: Math.min(size, height - y),
            vx: nx * $bb9e23e7af52cc31$export$c059030fbdddd4b3 * (0.6 + rand() * 0.8),
            // Up first (negative y), hardest at the top of the card, then gravity takes over.
            vy: -$bb9e23e7af52cc31$export$172c7549624448fe * (0.45 + rand() * 0.7) + ny * 30,
            spin: (rand() - 0.5) * 2 * $bb9e23e7af52cc31$export$d19c6a2eaa617cfa,
            delayMs: spread * $bb9e23e7af52cc31$export$4b1fde3a9508334
        });
    }
    return seeds;
};
const $bb9e23e7af52cc31$export$e174c14a9cb043b8 = (shatterMs, seed)=>{
    if (shatterMs < seed.delayMs) return null;
    const flightMs = $bb9e23e7af52cc31$export$8c5c1ebc079711ff - seed.delayMs;
    const p = $bb9e23e7af52cc31$var$clamp01((shatterMs - seed.delayMs) / flightMs);
    const t = (shatterMs - seed.delayMs) / 1000;
    return {
        dx: seed.vx * t,
        dy: seed.vy * t + 0.5 * $bb9e23e7af52cc31$export$9c83558f29ac851e * t * t,
        angle: seed.spin * t,
        alpha: p < $bb9e23e7af52cc31$export$70ee08772c334b5 ? 1 : 1 - (p - $bb9e23e7af52cc31$export$70ee08772c334b5) / (1 - $bb9e23e7af52cc31$export$70ee08772c334b5)
    };
};


const $44af089a9f2b65fe$var$ROLE_COLORS = {
    lord: 0xffd23f,
    // The same cool green a partner's dot gets on the minimap, so the card and the dot are
    // recognisably the same person without having to read either.
    player: 0x2bc4a8,
    defender: 0xff8a5c,
    forager: 0x7be08a,
    // Ember gold: the colour of the fire that drew them in, and deliberately not in the camp's own
    // palette -- a visitor is warm, welcome and not yet one of these people.
    visitor: 0xffb648
};
// Must agree with ROLE_ORDER in the server's ember_roster campaign, which is what actually sorts
// the strip; this one re-sorts locally after a card is added or removed.
const $44af089a9f2b65fe$var$ROLE_ORDER = {
    visitor: -1,
    lord: 0,
    player: 1,
    defender: 2,
    forager: 3
};
// Uniform scale for the whole widget (portraits, text, emoji, spacing) — cheaper and more reliable
// than re-tuning every geometry constant below.
const $44af089a9f2b65fe$var$WIDGET_SCALE = 0.8;
// Kept back from the edge of a texture a shard is cut out of. A frame that measures EXACTLY to the
// edge is a floating-point coin toss against pixi's "does this fit" test, and losing it throws; a
// hundredth of a pixel is not a thing anybody can see. See shatterCard.
const $44af089a9f2b65fe$var$FRAME_EPSILON = 0.01;
// ===== the visitor's detached slot =====
//
// A visitor is drawn on its OWN little plate, set apart from the household's, with two dots
// crawling across the gap between them. The gap is the whole statement: this person is at the fire
// and is not one of the camp, and the only thing standing between those two facts is the player.
//
// It opens on the LEFT because the strip is anchored by its right edge (positionEmberRoster), so
// everything to the right of the gap -- the lord and the crew the player has learned the position
// of -- stays exactly where it was while a stranger comes and goes.
const $44af089a9f2b65fe$var$VISITOR_GAP = 26;
// The two dots in the gap. They travel toward the HOUSEHOLD, which is what makes them read as
// "wants in" rather than "leaving"; running them the other way is this widget's departure.
const $44af089a9f2b65fe$var$DOT_COUNT = 2;
const $44af089a9f2b65fe$var$DOT_R = 2.1;
const $44af089a9f2b65fe$var$DOT_TRAVEL_MS = 1500;
// How much of the cycle separates one dot from the next.
const $44af089a9f2b65fe$var$DOT_STAGGER = 0.42;
// Once the bargain is struck the dots quicken -- the thing they are counting down to is close.
const $44af089a9f2b65fe$var$DOT_FED_SPEEDUP = 2.1;
const $44af089a9f2b65fe$export$5aa03a0c21de6504 = 480;
const $44af089a9f2b65fe$export$8c09971e64afcd26 = 620;
const $44af089a9f2b65fe$var$LEAVE_DRIFT = 26;
// Child z-order within a card (container.sortableChildren) so the fire backdrop sits behind the
// portrait but above the frame, regardless of add/rebuild order.
const $44af089a9f2b65fe$var$Z_CHROME = 0;
const $44af089a9f2b65fe$var$Z_FLAME = 1;
const $44af089a9f2b65fe$var$Z_PORTRAIT = 2;
const $44af089a9f2b65fe$var$Z_SCRIM = 3;
// The damage wash goes over the portrait but UNDER the name and stat bars, so a card can shout that
// it was hit without hiding the numbers the player is being told to look at.
const $44af089a9f2b65fe$var$Z_WASH = 4;
const $44af089a9f2b65fe$var$Z_BADGE = 5;
const $44af089a9f2b65fe$var$Z_NAME = 6;
const $44af089a9f2b65fe$var$Z_HP = 7;
const $44af089a9f2b65fe$var$Z_HUNGER = 8;
const $44af089a9f2b65fe$var$Z_SELECTION = 9;
const $44af089a9f2b65fe$var$Z_SPEAKING = 10;
const $44af089a9f2b65fe$var$Z_PATIENCE = 11;
// Over the card's own chrome: the flare bleeds OUTSIDE the frame (that is what makes it a glow
// rather than a border), so nothing on the card should be drawn on top of it.
const $44af089a9f2b65fe$var$Z_FLARE = 14;
const $44af089a9f2b65fe$var$Z_DAMAGE_RING = 12;
const $44af089a9f2b65fe$var$Z_DAMAGE_NUMBER = 13;
// The grey a dead member's card goes under sits over everything else on it.
const $44af089a9f2b65fe$var$Z_DEATH_PALL = 15;
// Ash: mid-grey, and just short of opaque (see drawPall).
const $44af089a9f2b65fe$var$PALL_COLOR = 0x5a5f5a;
const $44af089a9f2b65fe$var$PALL_MAX_ALPHA = 0.88;
// Offscreen speech lane: a camp member speaking while OUT of the player's view gets their line
// shown over their roster card. The rules (one bubble at a time, dwell, queue cap, card flash) are
// in roster_speech_lane.ts; this file only draws what that decides. The lane's height comes from
// the bubble itself so the two can't drift apart — it is reserved whether or not anyone is talking,
// so the follow-cam PiP sitting above the strip never jumps.
const $44af089a9f2b65fe$var$FIRE_WARNING_H = 30;
const $44af089a9f2b65fe$var$FIRE_WARNING_PULSE_MS = 600;
const $44af089a9f2b65fe$var$SPEECH_LANE_H = (0, $23d13a6e2a72aec5$export$256f864ac4a53998) + $44af089a9f2b65fe$var$FIRE_WARNING_H;
// Cache the portrait AND its mask in card-local space. Caching the paperdoll itself while
// its mask is a sibling in the card mixes coordinate systems during Pixi's offscreen bake:
// cards farther along the strip can be clipped completely out of their own cached texture.
class $44af089a9f2b65fe$var$RosterPortrait extends (0, $8t5Gy.Container) {
    constructor(paperdoll, mask){
        super(), this.paperdoll = paperdoll;
        this.addChild(mask, paperdoll);
        paperdoll.mask = mask;
    }
    isReadyToShow() {
        return this.paperdoll.isReadyToShow?.() ?? false;
    }
    remove() {
        this.parent?.removeChild(this);
        this.destroy({
            children: true
        });
    }
}
class $44af089a9f2b65fe$export$7b64a8ee2d511abd extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.slots = new Map(), // Offscreen speech: the rules live in the lane, the bubble draws what it decides.
        this.fireWarning = new (0, $gwPoJ.Graphics)(), this.fireWarningPulseMs = 0, // One pill per member, in the same lane as the fire warning above (see roster_status.ts).
        this.statusRow = new (0, $df39eaafb36c45c0$export$e0c9e7096bf0a040)(), this.speechLane = new (0, $9e747834c562d64b$export$902003cea2799f4d)(), // Hits taken by camp members, read off the health each roster tick reports. The curves and
        // timings live in roster_damage.ts; this widget only draws the frame it is handed.
        this.damageFx = new (0, $510d6be55289832c$export$c2606b7ba4b337e3)(), // Cards whose member has died: greying, then breaking apart, and holding their column in the
        // strip until the last shard has gone (see roster_death.ts). Keyed by the entity that left, so a
        // member who somehow comes back gets a fresh card rather than the one that is falling apart.
        this.dying = new Map(), // The living cards in display order, remembered so the strip can be laid out again the moment a
        // death finishes rather than waiting for the next roster tick to close the gap.
        this.order = [], // Visitors who gave up and walked out, drifting off the left of the strip. Separate from
        // `dying` because they take no column with them and never break apart.
        this.leaving = new Map(), // Free-running clock for the starving-member pulse, shared by every card so they breathe together
        // rather than each on its own phase.
        this.pulseMs = 0, // How many columns at the left of the strip are visitors. 0 means no gap and no dots, which is
        // every camp with nobody at the fire -- i.e. the strip as it has always looked.
        this.visitorColumns = 0, // Whether the strip is split at all. Held open a little past the last visitor: while one is
        // walking out there is nobody on the left any more, but the space they left -- and the dots
        // running back across it -- is the departure.
        this.gapOpen = false, this.dotMs = 0, // Where column `n` sits, in the widget's own space. Identical to the old `n * SLOT_W` until a
        // visitor turns up, at which point everything from the first household column rightwards is
        // pushed clear by the gap -- and because the widget is right-anchored, "pushed clear" means the
        // VISITOR hangs off the left while the household stays put.
        this.columnX = (column)=>column * (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) + (this.gapOpen && column >= this.visitorColumns ? $44af089a9f2b65fe$var$VISITOR_GAP : 0), // How many cards are mid-hire, crossing from the visitor slot into the household.
        this.joining = ()=>{
            let count = 0;
            this.slots.forEach((slot)=>{
                if (slot.joinMs !== undefined) count++;
            });
            return count;
        }, // Browser-console triggers, in the same shape as window.playerRing / window.spriteShadow:
        //
        //     rosterHit()        // every card takes a middling hit
        //     rosterHit(0.4)     // ...takes 40% of its health off
        //     rosterKill()       // the last card on the strip dies and breaks apart
        //     rosterWidget       // the strip itself: cardCount(), isDying(id), deathPhase(id)
        //
        // Neither reaction can be looked at on demand -- one needs something off-screen to land a blow,
        // the other needs somebody to die -- so there would otherwise be no way to tune the shake, the
        // colours or the shatter. The health rosterHit pretends was lost is corrected by the next roster
        // tick half a second later; the card rosterKill takes is rebuilt by it.
        this.exposeDevTriggers = ()=>{
            if (typeof window === "undefined") return;
            window.rosterWidget = this;
            window.rosterKill = (name)=>{
                const entry = Array.from(this.slots.entries()).reverse().find(([, slot])=>!name || (slot.name || "").toLowerCase().includes(name.toLowerCase()));
                if (!entry) return `[rosterKill] no card matching ${name ?? "(any)"}`;
                this.beginDeath(entry[0], entry[1]);
                this.layout();
                this.guiManager.positionEmberRoster();
                return entry[0];
            };
            window.rosterHit = (fraction = 0.18)=>{
                this.slots.forEach((slot, entityId)=>{
                    const hpMax = slot.hpMax ?? 20;
                    const hp = slot.hp ?? hpMax;
                    const hit = Math.max(0, hp - hpMax * fraction);
                    this.damageFx.hit(entityId, hp, hit, hpMax);
                    slot.hp = hit;
                    this.drawHpBar(slot.hpBar, hit, hpMax, slot.ghostRatio);
                });
                return `[rosterHit] ${this.slots.size} card(s)`;
            };
        }, this.appearanceKeyFor = (entry)=>entry.appearance ? JSON.stringify(entry.appearance) : "", this.truncate = (name)=>{
            if (!name) return "";
            return name.length > (0, $8d6533e00bd59062$export$6881c612b1e8acd5) ? name.slice(0, (0, $8d6533e00bd59062$export$6881c612b1e8acd5) - 1) + "\u2026" : name;
        }, // Build the zoomed front-facing portrait from a synthetic entity, mirroring the inventory-view
        // portrait (dynamic_dialog.ts / EntityDisplayer), with the clip in the same local container.
        this.buildPortrait = (entry)=>{
            const entity = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
            entity.weapon = {
                weaponType: (0, $f684496fff50a7a1$export$58361cde22f3aa43)(entry.inventory, "weapon")?.type
            };
            entity.appearance = entry.appearance;
            entity.inventory = entry.inventory;
            // Cards only need a still face. Avoid a full animation set and shared-ticker callback
            // for every clothing layer of every recruit (including cards outside the screen). An
            // Ember body gives its own (ember_portrait), framed on the same head as an LPC one.
            let portrait;
            try {
                portrait = (0, $a020ac28c1deebe7$export$c4e1af01547f5776)(entity, entry.entityId, true);
            } catch (e) {
                // Malformed appearance data must not take down the whole roster — leave it blank.
                console.warn(`[EmberRoster] portrait build failed for ${entry.entityId}`, e);
                portrait = new (0, $8d5e1ee7d468f782$export$6927fb12d9ccc2a)(entry.entityId, true);
            }
            portrait.scale.set((0, $8d6533e00bd59062$export$937b0d3608fcf11e));
            portrait.x = (0, $8d6533e00bd59062$export$77f435e13f71eb7f);
            portrait.y = (0, $8d6533e00bd59062$export$572eba96a021644d);
            return new $44af089a9f2b65fe$var$RosterPortrait(portrait, this.makeMask());
        }, this.makeMask = ()=>{
            const g = new (0, $gwPoJ.Graphics)();
            g.beginFill(0xffffff);
            g.drawRoundedRect((0, $8d6533e00bd59062$export$f8b8d0e2524d7c47), (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47), (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) * 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) * 2, (0, $8d6533e00bd59062$export$4e669d5539617474));
            g.endFill();
            return g;
        }, // Only a vector glyph is cached. Text is never baked into a cacheAsBitmap image on this strip:
        // a bake sometimes came out without its Text (a hired recruit's name and status label went
        // blank until re-baked), and a live Text is one batched quad anyway.
        this.makeBadge = (role)=>{
            const t = (0, $7674b5c0a355be98$export$68f029f6c68daa48)(role, (0, $8d6533e00bd59062$export$e1a1d856f86d5382));
            t.x = (0, $8d6533e00bd59062$export$c51218e3426de1b7) + (0, $8d6533e00bd59062$export$e1a1d856f86d5382) / 2;
            t.y = (0, $8d6533e00bd59062$export$b643d415cf93452e) + (0, $8d6533e00bd59062$export$e1a1d856f86d5382) / 2;
            if (t instanceof (0, $gwPoJ.Graphics)) t.cacheAsBitmap = true;
            return t;
        }, this.makeNameText = (name)=>{
            const t = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("entityLabel").render(this.truncate(name));
            t.tint = 0xffffff;
            t.x = Math.round((0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) / 2 - t.width / 2);
            t.y = (0, $8d6533e00bd59062$export$50e8cfc43db69af3);
            return t;
        }, // `ghostRatio` is the fighting-game "health you just lost": a pale segment left standing where
        // the bar was before the hit, drawn UNDER the live fill so only the difference shows, and drained
        // away by the damage effect a beat later. Undefined (the resting case) draws the bar as before.
        this.drawHpBar = (bar, hp, hpMax, ghostRatio)=>{
            bar.cacheAsBitmap = false;
            bar.clear();
            const w = (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - (0, $8d6533e00bd59062$export$dc9a8445d2f3c372) * 2;
            bar.beginFill(0x000000, 0.6);
            bar.drawRoundedRect(0, 0, w, (0, $8d6533e00bd59062$export$d80daa1884709eb5), 2);
            bar.endFill();
            if (ghostRatio !== undefined && ghostRatio > 0) {
                bar.beginFill((0, $8d6533e00bd59062$export$2231d9ccf0d5169e), 0.9);
                bar.drawRoundedRect(0, 0, Math.max(1, w * Math.min(1, ghostRatio)), (0, $8d6533e00bd59062$export$d80daa1884709eb5), 2);
                bar.endFill();
            }
            if (hp !== undefined && hpMax && hpMax > 0) {
                const ratio = Math.max(0, Math.min(1, hp / hpMax));
                const color = (0, $8d6533e00bd59062$export$ff66bb5d2113fcb7)(ratio);
                if (ratio > 0) {
                    bar.beginFill(color, 0.95);
                    bar.drawRoundedRect(0, 0, Math.max(1, w * ratio), (0, $8d6533e00bd59062$export$d80daa1884709eb5), 2);
                    bar.endFill();
                }
            }
            bar.x = (0, $8d6533e00bd59062$export$dc9a8445d2f3c372);
            bar.y = (0, $8d6533e00bd59062$export$1c21151185bd8e77);
            // Pixi tessellates two tiny rounded rectangles into >100 vertices, forcing a
            // standalone mesh pass per member. Only the draining damage segment needs live geometry.
            bar.cacheAsBitmap = ghostRatio === undefined;
        }, // The hunger bar: the recruit's whole food arc as one falling bar, drawn a shade thinner than the
        // HP bar above it and in warm food colours (amber -> orange -> ember red) so the two rows can't be
        // read as the same stat. The server sends no hunger for the lord, whose row stays empty.
        this.drawHungerBar = (bar, hunger)=>{
            bar.cacheAsBitmap = false;
            bar.clear();
            bar.visible = hunger !== undefined;
            if (hunger === undefined) return;
            const w = (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - (0, $8d6533e00bd59062$export$dc9a8445d2f3c372) * 2;
            bar.beginFill(0x000000, 0.6);
            bar.drawRoundedRect(0, 0, w, (0, $8d6533e00bd59062$export$30e8349973c4d242), 2);
            bar.endFill();
            const ratio = Math.max(0, Math.min(1, hunger));
            const color = (0, $8d6533e00bd59062$export$a3fc1e002308197a)(ratio);
            if (ratio > 0) {
                bar.beginFill(color, 0.95);
                bar.drawRoundedRect(0, 0, Math.max(1, w * ratio), (0, $8d6533e00bd59062$export$30e8349973c4d242), 2);
                bar.endFill();
            }
            bar.x = (0, $8d6533e00bd59062$export$dc9a8445d2f3c372);
            bar.y = (0, $8d6533e00bd59062$export$8c0eb8c159a41292);
            bar.cacheAsBitmap = true;
        }, // A VISITOR's patience, as a rim that unwinds. Drawn as an arc rather than a bar because a bar
        // on this card would be read as the hunger bar one row above it, and this is not hunger -- it
        // is the stranger's willingness to keep standing there. Starts at twelve o'clock and drains
        // clockwise, so the gap in the rim opens at the top where the eye already is.
        //
        // Nothing is drawn at all for a member of the camp: `patience` is undefined for everyone but a
        // visitor, which is also what keeps this off the lord's card.
        this.drawPatienceRing = (ring, patience)=>{
            ring.cacheAsBitmap = false;
            ring.clear();
            ring.visible = patience !== undefined;
            if (patience === undefined) return;
            const ratio = Math.max(0, Math.min(1, patience));
            const x = (0, $8d6533e00bd59062$export$3b4d14647a9972a3);
            const y = (0, $8d6533e00bd59062$export$3b4d14647a9972a3);
            const w = (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - (0, $8d6533e00bd59062$export$3b4d14647a9972a3) * 2;
            const h = (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - (0, $8d6533e00bd59062$export$3b4d14647a9972a3) * 2;
            const radius = (0, $8d6533e00bd59062$export$4e669d5539617474) + 1;
            // The groove the ring drains out of, so the missing part still reads as "there was more
            // here" rather than as nothing.
            ring.lineStyle((0, $8d6533e00bd59062$export$1520631a15db096), 0x000000, 0.42);
            ring.drawRoundedRect(x, y, w, h, radius);
            if (ratio <= 0) return;
            // A rounded rect has no arc API, so the live part is walked as a polyline around the frame
            // from the top centre, clockwise, and cut off at `ratio` of the way round. The corners are
            // squared off in the path -- at a 2px stroke on a 6px radius that is a difference nobody
            // can see, and it keeps this to one cheap pass per redraw on hardware that counts them.
            const right = x + w;
            const bottom = y + h;
            const midX = x + w / 2;
            const legs = [
                [
                    midX,
                    y,
                    right,
                    y
                ],
                [
                    right,
                    y,
                    right,
                    bottom
                ],
                [
                    right,
                    bottom,
                    x,
                    bottom
                ],
                [
                    x,
                    bottom,
                    x,
                    y
                ],
                [
                    x,
                    y,
                    midX,
                    y
                ]
            ];
            const lengths = legs.map(([x1, y1, x2, y2])=>Math.abs(x2 - x1) + Math.abs(y2 - y1));
            const perimeter = lengths.reduce((a, b)=>a + b, 0);
            let remaining = perimeter * ratio;
            ring.lineStyle((0, $8d6533e00bd59062$export$1520631a15db096), (0, $8d6533e00bd59062$export$7a164107508d4f84)(ratio), 0.95);
            ring.moveTo(midX, y);
            for(let i = 0; i < legs.length && remaining > 0; i++){
                const [x1, y1, x2, y2] = legs[i];
                const length = lengths[i];
                if (length <= 0) continue;
                const t = Math.min(1, remaining / length);
                ring.lineTo(x1 + (x2 - x1) * t, y1 + (y2 - y1) * t);
                remaining -= length;
            }
            ring.cacheAsBitmap = true;
        }, // The card frame (dark, so the inset portrait reads as a bordered background) plus a bottom
        // scrim and a small chip behind the badge, all in one Graphics behind the portrait/overlays.
        this.drawChrome = (chrome)=>{
            chrome.clear();
            // Frame / margin.
            chrome.beginFill(0x0a0d08, 0.9);
            chrome.lineStyle(1, 0xffffff, 0.1);
            chrome.drawRoundedRect(1, 1, (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - 2, (0, $8d6533e00bd59062$export$4e669d5539617474) + 1);
            chrome.endFill();
        }, this.drawScrim = (scrim)=>{
            scrim.clear();
            scrim.beginFill(0x000000, 0.5);
            scrim.drawRoundedRect((0, $8d6533e00bd59062$export$f8b8d0e2524d7c47), (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) - (0, $8d6533e00bd59062$export$9abd345d8933c5ce), (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) * 2, (0, $8d6533e00bd59062$export$9abd345d8933c5ce), (0, $8d6533e00bd59062$export$4e669d5539617474));
            scrim.endFill();
            // Chip behind the role icon badge (top-left) for contrast over any portrait.
            scrim.beginFill(0x000000, 0.45);
            scrim.drawRoundedRect((0, $8d6533e00bd59062$export$c51218e3426de1b7) - 2, (0, $8d6533e00bd59062$export$b643d415cf93452e) - 1, (0, $8d6533e00bd59062$export$e1a1d856f86d5382) + 5, (0, $8d6533e00bd59062$export$e1a1d856f86d5382) + 3, 3);
            scrim.endFill();
        }, // The flash a card gives when its member speaks from offscreen — the immediate acknowledgement
        // that lets extra speakers wait in the queue without their line feeling dropped.
        this.drawSpeakingRing = (ring, role)=>{
            ring.cacheAsBitmap = false;
            ring.clear();
            ring.lineStyle(2, $44af089a9f2b65fe$var$ROLE_COLORS[role], 1);
            ring.drawRoundedRect(1, 1, (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - 2, (0, $8d6533e00bd59062$export$4e669d5539617474) + 1);
            ring.cacheAsBitmap = true;
        }, // The two halves of a hit's flash, drawn once per card and then only faded: a wash filling the
        // portrait area and a ring around the frame (which outlives the wash, so the card stays marked
        // as the one that was hit).
        this.drawWash = (wash)=>{
            wash.clear();
            wash.beginFill((0, $8d6533e00bd59062$export$c082e8bc79733f73), 1);
            wash.drawRoundedRect((0, $8d6533e00bd59062$export$f8b8d0e2524d7c47), (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47), (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) * 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) * 2, (0, $8d6533e00bd59062$export$4e669d5539617474));
            wash.endFill();
            wash.cacheAsBitmap = true;
        }, this.drawDamageRing = (ring)=>{
            ring.clear();
            ring.lineStyle(2, (0, $8d6533e00bd59062$export$7b5bc50f06bd4503), 1);
            ring.drawRoundedRect(1, 1, (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - 2, (0, $8d6533e00bd59062$export$4e669d5539617474) + 1);
            ring.cacheAsBitmap = true;
        }, // The grey a dead member's card goes under. Left just short of opaque, so the shape of the card
        // -- the portrait, the name -- is still faintly there under the ash rather than replaced by a
        // plain grey oblong.
        this.drawPall = (pall)=>{
            pall.clear();
            pall.beginFill($44af089a9f2b65fe$var$PALL_COLOR, 1);
            pall.drawRoundedRect(1, 1, (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - 2, (0, $8d6533e00bd59062$export$4e669d5539617474) + 1);
            pall.endFill();
        }, this.drawSelection = (selection, role)=>{
            selection.cacheAsBitmap = false;
            selection.clear();
            selection.lineStyle(2, $44af089a9f2b65fe$var$ROLE_COLORS[role], 0.95);
            selection.drawRoundedRect(1, 1, (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - 2, (0, $8d6533e00bd59062$export$4e669d5539617474) + 1);
            selection.cacheAsBitmap = true;
        }, // The flame's clip: the portrait's inset area as a PLAIN rect, which pixi clips with a scissor box.
        // The rounded portrait mask would be a stencil mask redrawn every frame (a full stencil clear plus
        // two mask draws), measured at a few fps of a 120Hz frame for this one card; the flame may now
        // glow into the inset's corners.
        this.makeFlameClip = ()=>{
            const g = new (0, $gwPoJ.Graphics)();
            g.beginFill(0xffffff);
            g.drawRect((0, $8d6533e00bd59062$export$f8b8d0e2524d7c47), (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47), (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) * 2, (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) - (0, $8d6533e00bd59062$export$f8b8d0e2524d7c47) * 2);
            g.endFill();
            return g;
        }, // Add (lord) or remove (non-lord) the animated fire-particle backdrop for a slot, matching its
        // role. The flame sits behind the portrait, clipped to the portrait's inset rect.
        this.ensureFlame = (slot)=>{
            const isLord = slot.role === "lord";
            if (isLord && !slot.flame) {
                const mask = this.makeFlameClip();
                const flame = new (0, $d4e9bfba8663fd0e$export$180e4127bb338fb5)((0, $8d6533e00bd59062$export$cdc10a00a6ecc04e), (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8));
                flame.mask = mask;
                flame.zIndex = $44af089a9f2b65fe$var$Z_FLAME;
                slot.art.cacheAsBitmap = false;
                slot.art.addChild(mask, flame);
                slot.flame = flame;
                slot.flameMask = mask;
            } else if (!isLord && slot.flame) {
                slot.flame.mask = null;
                slot.art.cacheAsBitmap = false;
                slot.art.removeChild(slot.flame, slot.flameMask);
                slot.flame.destroy();
                slot.flameMask?.destroy();
                slot.flame = undefined;
                slot.flameMask = undefined;
            }
        }, // Advance the fire-particle backdrops, the starving pulse, the damage effects and the offscreen
        // speech lane (called each frame by GuiManager).
        this.animate = (dtMs)=>{
            this.pulseMs = (this.pulseMs + dtMs) % (0, $8d6533e00bd59062$export$d87ce5ad91d00207);
            // 1 -> 0.55 -> 1 over the period. Done with alpha rather than a redraw so a pulsing card
            // costs nothing beyond the value itself.
            const pulse = 0.55 + 0.45 * (0.5 + 0.5 * Math.cos(this.pulseMs / (0, $8d6533e00bd59062$export$d87ce5ad91d00207) * Math.PI * 2));
            // A stronger, faster breath than the hunger bars. Only opacity changes:
            // the pill stays anchored and never shakes or scales.
            this.fireWarningPulseMs = (this.fireWarningPulseMs + dtMs) % $44af089a9f2b65fe$var$FIRE_WARNING_PULSE_MS;
            const alarm = 0.45 + 0.55 * (0.5 + 0.5 * Math.cos(this.fireWarningPulseMs / $44af089a9f2b65fe$var$FIRE_WARNING_PULSE_MS * Math.PI * 2));
            this.fireWarning.alpha = alarm;
            // The chips that need answering breathe on the same clock as the fire alarm beside them, so
            // the lane has one heartbeat rather than several out of step.
            this.statusRow.pulse(alarm);
            this.damageFx.update(dtMs);
            this.slots.forEach((slot, entityId)=>{
                // Cache static art, including the frame's vector geometry and the portrait mask.
                // Live masks/graphics flush the batch for every card every frame. Wait for every
                // sheet; the lord's fire remains live behind its cached face.
                if (slot.portrait.isReadyToShow()) {
                    if (slot.role === "lord") slot.portrait.cacheAsBitmap = true;
                    else if (!slot.art.cacheAsBitmap) slot.art.cacheAsBitmap = true;
                }
                slot.flame?.update(dtMs, Number.isFinite(slot.fireStrength) ? slot.fireStrength : 0);
                slot.hungerBar.alpha = slot.hunger !== undefined && slot.hunger <= (0, $8d6533e00bd59062$export$e74fbfde0a93daa9) ? pulse : 1;
                // The same breath the starving bar takes, for the same reason: at this point the clock
                // is the only thing the card is still telling you.
                slot.patienceRing.alpha = slot.patience !== undefined && slot.patience <= (0, $8d6533e00bd59062$export$c964a3078907ce20) ? pulse : 1;
                this.applyDamage(slot, this.damageFx.frame(entityId));
                this.updateFlare(slot, dtMs);
            });
            // After applyDamage, which parks a card at its resting x -- a card crossing the gap is not
            // at rest, and the join is what owns its position until it lands.
            this.updateJoins(dtMs);
            this.updateDots(dtMs);
            this.updateSpeech(dtMs);
            this.updateDeaths(dtMs);
            this.updateLeaving(dtMs);
        }, // Burn down a card's arrival flare. Torn down once it is over rather than left drawing nothing,
        // because every card on this strip is paid for per frame on hardware that counts them.
        this.updateFlare = (slot, dtMs)=>{
            if (slot.flareMs === undefined || !slot.flare) return;
            slot.flareMs -= dtMs;
            if (slot.flareMs <= 0) {
                slot.container.removeChild(slot.flare);
                slot.flare.destroy();
                slot.flare = undefined;
                slot.flareMs = undefined;
                return;
            }
            (0, $ec347662891822a3$export$68fa09a501e35b68)(slot.flare, {
                remainingMs: slot.flareMs,
                width: (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e),
                height: (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8),
                corner: (0, $8d6533e00bd59062$export$4e669d5539617474) + 1
            });
        }, // A point already on screen, expressed in this widget's own space. Both animations below start
        // from where the card VISUALLY was, and the strip moves underneath them while they run -- it is
        // right-anchored, so admitting or releasing a card shifts every local coordinate in it. Going
        // through the screen keeps the start of a slide pinned to what the player actually saw.
        this.localFromScreen = (screenX)=>(screenX - this.x) / (this.scale.x || 1), this.screenFromLocal = (localX)=>this.x + localX * this.scale.x, // Ease in and out, so a card leaves and arrives gently and spends its speed in the middle.
        this.ease = (t)=>t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2, // THE JOIN. A visitor that has been given a job keeps its card -- it is the same person, and
        // the same entity id -- so what the strip shows is that card crossing the gap and taking its
        // place at the end of the household. Nothing else on the strip moves while it happens.
        this.updateJoins = (dtMs)=>{
            let landed = false;
            this.slots.forEach((slot)=>{
                if (slot.joinMs === undefined || slot.joinFromX === undefined) return;
                slot.joinMs += dtMs;
                const t = Math.min(1, slot.joinMs / $44af089a9f2b65fe$export$5aa03a0c21de6504);
                const from = this.localFromScreen(slot.joinFromX);
                slot.container.x = from + (slot.baseX - from) * this.ease(t);
                if (t >= 1) {
                    slot.joinMs = undefined;
                    slot.joinFromX = undefined;
                    slot.container.x = slot.baseX;
                    landed = true;
                }
            });
            if (landed) {
                this.layout();
                this.guiManager.positionEmberRoster();
            }
        }, // THE DEPARTURE. Not a death: they gave up on this camp and walked back out, so the card drifts
        // further left -- the way they came -- and fades. The gap is held open until the last of them
        // has gone (see layout), which is what lets the dots run backwards over the space they left.
        this.updateLeaving = (dtMs)=>{
            let finished = false;
            this.leaving.forEach((card, entityId)=>{
                card.elapsedMs += dtMs;
                const t = Math.min(1, card.elapsedMs / $44af089a9f2b65fe$export$8c09971e64afcd26);
                const from = this.localFromScreen(card.fromX);
                card.slot.container.x = from - $44af089a9f2b65fe$var$LEAVE_DRIFT * this.ease(t);
                card.slot.container.alpha = 1 - t;
                if (t >= 1) {
                    this.disposeSlot(card.slot);
                    this.leaving.delete(entityId);
                    finished = true;
                }
            });
            if (finished) {
                this.layout();
                this.guiManager.positionEmberRoster();
            }
        }, // The two dots crawling across the gap: the strip's way of saying that the person on the far
        // side of it is trying to get to this side. They travel TOWARD the household while somebody is
        // asking, and back the other way while one walks out, which is the whole difference between the
        // two events read at a glance.
        this.updateDots = (dtMs)=>{
            if (!this.gapOpen) {
                this.joinDots.visible = false;
                return;
            }
            const leaving = this.visitorColumns === 0;
            // Fed visitors quicken: the bargain is struck and only the job is still to be settled.
            let anyFed = false;
            this.slots.forEach((slot)=>{
                if (slot.role === "visitor" && slot.fed) anyFed = true;
            });
            const speed = anyFed ? $44af089a9f2b65fe$var$DOT_FED_SPEEDUP : 1;
            this.dotMs = (this.dotMs + dtMs * speed) % $44af089a9f2b65fe$var$DOT_TRAVEL_MS;
            const x0 = this.visitorColumns * (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e);
            const span = $44af089a9f2b65fe$var$VISITOR_GAP;
            const y = (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) / 2;
            const color = leaving ? 0x8a8378 : anyFed ? 0xffd98a : 0xffb648;
            this.joinDots.visible = true;
            this.joinDots.clear();
            for(let i = 0; i < $44af089a9f2b65fe$var$DOT_COUNT; i++){
                let p = (this.dotMs / $44af089a9f2b65fe$var$DOT_TRAVEL_MS + i * $44af089a9f2b65fe$var$DOT_STAGGER) % 1;
                if (leaving) p = 1 - p;
                // Faded at both ends so a dot arrives and departs rather than popping into the gap.
                const alpha = Math.sin(Math.PI * ((this.dotMs / $44af089a9f2b65fe$var$DOT_TRAVEL_MS + i * $44af089a9f2b65fe$var$DOT_STAGGER) % 1));
                this.joinDots.beginFill(color, 0.25 + 0.65 * alpha);
                this.joinDots.drawCircle(x0 + span * p, y, $44af089a9f2b65fe$var$DOT_R);
                this.joinDots.endFill();
            }
        }, // Put one card into the state a hit's frame asks for -- or back to rest when there is no hit.
        // The resting path touches nothing it doesn't have to, so an undamaged strip (the normal case)
        // costs a handful of assignments per card per frame and no redraw at all.
        this.applyDamage = (slot, frame)=>{
            if (!frame) {
                if (slot.damageSeq === 0) return;
                slot.damageSeq = 0;
                slot.container.x = slot.baseX;
                slot.container.y = 0;
                slot.container.scale.set(1);
                slot.wash.visible = false;
                slot.damageRing.visible = false;
                if (slot.damageNumber) slot.damageNumber.visible = false;
                if (slot.ghostRatio !== undefined) {
                    slot.ghostRatio = undefined;
                    this.drawHpBar(slot.hpBar, slot.hp, slot.hpMax);
                }
                return;
            }
            // Scale about the card's centre without a pivot (which `selectedCardAnchor` and the layout
            // below both read `container.x` raw for), by taking back half of what the growth adds.
            const grow = frame.scale - 1;
            slot.container.scale.set(frame.scale);
            slot.container.x = slot.baseX + frame.shakeX - grow * (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) / 2;
            slot.container.y = frame.shakeY - grow * (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) / 2;
            slot.wash.alpha = frame.flashAlpha;
            slot.wash.visible = frame.flashAlpha > 0.01;
            slot.damageRing.alpha = frame.ringAlpha;
            slot.damageRing.visible = frame.ringAlpha > 0.01;
            // The ghost holds still for the first fifth of the effect; only repaint the bar once it has
            // actually moved.
            if (slot.ghostRatio === undefined || Math.abs(slot.ghostRatio - frame.ghostRatio) > 0.004) {
                slot.ghostRatio = frame.ghostRatio;
                this.drawHpBar(slot.hpBar, slot.hp, slot.hpMax, frame.ghostRatio);
            }
            const damageNumber = this.ensureDamageNumber(slot);
            if (slot.damageSeq !== frame.seq) {
                slot.damageSeq = frame.seq;
                damageNumber.text = `-${frame.amount}`;
                damageNumber.x = Math.round((0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) / 2 - damageNumber.width / 2);
            }
            damageNumber.y = (0, $8d6533e00bd59062$export$db313b0d55ae90f4) - frame.numberRise;
            damageNumber.alpha = frame.numberAlpha;
            damageNumber.visible = frame.numberAlpha > 0.01;
        }, // The floating "-N" is built on the card's FIRST hit and then reused (its text is re-rasterized
        // per hit, which is once every 500ms at worst) -- a fresh Text per hit would churn a canvas-backed
        // texture through the GPU for every blow landed in the camp.
        this.ensureDamageNumber = (slot)=>{
            if (!slot.damageNumber) {
                const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("title").bold().strokeThickness(3).color((0, $8d6533e00bd59062$export$77f3d2d2b010c804)).render("");
                text.style.stroke = 0x000000;
                text.zIndex = $44af089a9f2b65fe$var$Z_DAMAGE_NUMBER;
                slot.container.addChild(text);
                slot.damageNumber = text;
            }
            return slot.damageNumber;
        }, // Hand the lane this frame's members and whatever they've said out of the player's sight, then
        // draw whichever single line it picked, plus the card flashes it wants.
        this.updateSpeech = (dtMs)=>{
            const members = Array.from(this.slots.entries()).map(([entityId, slot])=>({
                    entityId: entityId,
                    name: slot.name || ""
                }));
            this.speechLane.update(dtMs, members, this.guiManager.getOffscreenSpeech);
            // Hand the bubble this frame's target; it owns the fade and the swap between speakers.
            const line = this.speechLane.currentLine();
            const slot = line ? this.slots.get(line.entityId) : undefined;
            const target = line && slot ? {
                key: `${line.entityId}:${line.text}`,
                name: line.name,
                text: line.text,
                tailX: slot.baseX + (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) / 2,
                tailY: -(0, $8d6533e00bd59062$export$2295e056c5b8b159) - $44af089a9f2b65fe$var$FIRE_WARNING_H,
                clampRight: this.columnX(this.slots.size) + (0, $8d6533e00bd59062$export$2295e056c5b8b159),
                color: $44af089a9f2b65fe$var$ROLE_COLORS[slot.role]
            } : null;
            this.speechBubble.update(dtMs, target);
            this.slots.forEach((s, entityId)=>{
                const alpha = this.speechLane.pulseAlpha(entityId);
                if (alpha > 0 && s.speakingRole !== s.role) {
                    this.drawSpeakingRing(s.speaking, s.role);
                    s.speakingRole = s.role;
                }
                s.speaking.alpha = alpha;
                s.speaking.visible = alpha > 0;
            });
        }, // A visitor has given up on this camp. Hand their card to the drift-out instead of the death
        // sequence: they are alive, they are simply walking back the way they came, and the strip says
        // so by letting the card go the same way -- left, and gone -- while the gap it leaves behind
        // stays open just long enough for the dots to run back across it.
        this.beginDeparture = (entityId, slot)=>{
            this.slots.delete(entityId);
            this.speechLane.forget(entityId);
            this.damageFx.forget(entityId);
            this.order = this.order.filter((id)=>id !== entityId);
            // Nothing on a card on its way out is still worth clicking or flashing at the player.
            slot.container.interactive = false;
            slot.container.cursor = "default";
            slot.selection.visible = false;
            slot.speaking.visible = false;
            slot.wash.visible = false;
            slot.damageRing.visible = false;
            slot.container.scale.set(1);
            if (this.selectedEntityId === entityId) {
                this.selectedEntityId = undefined;
                // Whatever their card had put up in the slot above the strip belongs to somebody who is
                // no longer here.
                this.guiManager.closeRosterSelection();
            }
            this.leaving.set(entityId, {
                slot: slot,
                elapsedMs: 0,
                fromX: this.screenFromLocal(slot.container.x)
            });
        }, // A member has left the roster, which in an ember camp means they died. Hand their card over to
        // the death sequence instead of tearing it down: it holds its column, greys over, and breaks
        // apart (roster_death.ts owns the timings).
        this.beginDeath = (entityId, slot)=>{
            this.slots.delete(entityId);
            this.speechLane.forget(entityId);
            this.damageFx.forget(entityId);
            this.order = this.order.filter((id)=>id !== entityId);
            // A dead member is not somebody you can still click through to, and the card's live
            // decoration (the selection ring, a speech flash, a half-finished damage flash) has no
            // business outliving them.
            slot.container.interactive = false;
            slot.container.cursor = "default";
            slot.selection.visible = false;
            slot.speaking.visible = false;
            slot.wash.visible = false;
            slot.damageRing.visible = false;
            if (slot.damageNumber) slot.damageNumber.visible = false;
            slot.container.scale.set(1);
            if (this.selectedEntityId === entityId) this.selectedEntityId = undefined;
            const pall = new (0, $gwPoJ.Graphics)();
            this.drawPall(pall);
            pall.alpha = 0;
            pall.zIndex = $44af089a9f2b65fe$var$Z_DEATH_PALL;
            slot.container.addChild(pall);
            this.dying.set(entityId, {
                slot: slot,
                column: slot.column,
                elapsedMs: 0,
                pall: pall,
                shattered: false
            });
        }, // Advance every dying card: drain its colour, break it apart at the halfway mark, fly the shards,
        // and take the whole thing off the strip when it is done.
        this.updateDeaths = (dtMs)=>{
            let finished = false;
            this.dying.forEach((card, entityId)=>{
                card.elapsedMs += dtMs;
                if (!card.shattered) // Over the WHOLE card, bars and name included -- the member is gone, so nothing on
                // the card is still telling the player anything.
                card.pall.alpha = $44af089a9f2b65fe$var$PALL_MAX_ALPHA * (0, $bb9e23e7af52cc31$export$54311821b45b94a4)(card.elapsedMs);
                if (!card.shattered && (0, $bb9e23e7af52cc31$export$1d5894916c503cf9)(card.elapsedMs)) this.shatterCard(card);
                if (card.shattered && card.seeds && card.pieces) {
                    const shatterMs = card.elapsedMs - (0, $bb9e23e7af52cc31$export$db237cf1ba467f33);
                    card.seeds.forEach((seed, i)=>{
                        const piece = card.pieces[i];
                        const motion = (0, $bb9e23e7af52cc31$export$e174c14a9cb043b8)(shatterMs, seed);
                        if (!motion) return;
                        piece.x = seed.x + seed.w / 2 + motion.dx;
                        piece.y = seed.y + seed.h / 2 + motion.dy;
                        piece.angle = motion.angle;
                        piece.alpha = motion.alpha;
                    });
                }
                if ((0, $bb9e23e7af52cc31$export$b019cd4aafde2132)(card.elapsedMs)) {
                    this.endDeath(entityId, card);
                    finished = true;
                }
            });
            if (finished) {
                // The gap closes the moment the last shard has gone, rather than on whichever roster tick
                // happens to come next.
                this.layout();
                this.guiManager.positionEmberRoster();
            }
        }, // Break the (by now grey) card into shards: snapshot it to a texture, slice that into a grid of
        // little sprites, and hide the card itself. Without a renderer -- a test, or a context that is
        // gone -- there is nothing to photograph and nothing being watched either, so the card just goes
        // and the death runs out its clock with the column still held.
        this.shatterCard = (card)=>{
            card.shattered = true;
            const texture = this.captureCard(card.slot);
            if (!texture) {
                card.slot.container.visible = false;
                return;
            }
            // Clamped to what the photograph ACTUALLY measures, which can be a fraction less than the
            // card it photographed -- see captureCard. `new Texture` throws on a frame that does not fit
            // inside its base, and this runs from the render loop, where a throw used to stop the ticker
            // and freeze the whole client (see the frame guard in index.ts). captureCard now rounds the
            // capture up so this never binds; it stays because the cost of being wrong here is the game.
            const maxW = texture.baseTexture.width;
            const maxH = texture.baseTexture.height;
            const seeds = (0, $bb9e23e7af52cc31$export$62785211b15662cd)((0, $8d6533e00bd59062$export$cdc10a00a6ecc04e), (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8)).map((seed)=>({
                    ...seed,
                    w: Math.min(seed.w, maxW - seed.x - $44af089a9f2b65fe$var$FRAME_EPSILON),
                    h: Math.min(seed.h, maxH - seed.y - $44af089a9f2b65fe$var$FRAME_EPSILON)
                }))// A shard that fell entirely outside the photograph has nothing to show.
            .filter((seed)=>seed.w > 0 && seed.h > 0);
            const shards = new (0, $8t5Gy.Container)();
            shards.position.set(card.column * (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e), 0);
            const pieces = seeds.map((seed)=>{
                const piece = new (0, $7Bs2Z.Sprite)(new (0, $klOfb.Texture)(texture.baseTexture, new (0, $6qzqq.Rectangle)(seed.x, seed.y, seed.w, seed.h)));
                // Spun about their own middles, so a shard tumbles rather than swinging around a corner.
                piece.anchor.set(0.5);
                piece.x = seed.x + seed.w / 2;
                piece.y = seed.y + seed.h / 2;
                shards.addChild(piece);
                return piece;
            });
            this.addChild(shards);
            card.texture = texture;
            card.shards = shards;
            card.pieces = pieces;
            card.seeds = seeds;
            card.slot.container.visible = false;
        }, // Snapshot one card into a texture of its own. The card is drawn at its own origin (its position
        // in the strip is put back straight afterwards) so the shards can be placed by the grid alone.
        this.captureCard = (slot)=>{
            const renderer = (0, $baf9ca3dd57f31c4$export$e33484ee45c8bb13)._app?.renderer;
            if (!renderer) return null;
            try {
                const resolution = renderer.resolution || 1;
                // Asked for in whole DEVICE pixels, so the photograph can never come back smaller than
                // the card the shards are cut from -- see captureExtent for why that happens and what it
                // used to cost.
                const texture = (0, $klOfb.RenderTexture).create({
                    width: (0, $bb9e23e7af52cc31$export$3157021a2e406e10)((0, $8d6533e00bd59062$export$cdc10a00a6ecc04e), resolution),
                    height: (0, $bb9e23e7af52cc31$export$3157021a2e406e10)((0, $8d6533e00bd59062$export$4cacdb4184ffb7a8), resolution),
                    resolution: resolution
                });
                const savedX = slot.container.x;
                const savedY = slot.container.y;
                slot.container.position.set(0, 0);
                renderer.render(slot.container, {
                    renderTexture: texture,
                    clear: true
                });
                slot.container.position.set(savedX, savedY);
                return texture;
            } catch (e) {
                // A card that can't be photographed must not take the roster down with it.
                console.warn("[EmberRoster] card snapshot failed", e);
                return null;
            }
        }, this.endDeath = (entityId, card)=>{
            this.dying.delete(entityId);
            card.pall.destroy();
            if (card.shards) {
                this.removeChild(card.shards);
                card.shards.destroy({
                    children: true
                });
            }
            // The shards' sub-textures share this base texture, so it goes last, once they are gone.
            card.texture?.destroy(true);
            this.disposeSlot(card.slot);
        }, this.disposeSlot = (slot)=>{
            slot.art.cacheAsBitmap = false;
            slot.flare?.destroy();
            slot.speaking.destroy();
            slot.wash.destroy();
            slot.damageRing.destroy();
            (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(slot.container);
            slot.portrait.remove();
            if (slot.flame) {
                slot.flame.mask = null;
                slot.flame.destroy();
                slot.flameMask?.destroy();
            }
            this.removeChild(slot.container);
            slot.container.destroy({
                children: true
            });
        }, // The plate (or plates) behind the cards. A camp with nobody at the fire draws exactly the one
        // rounded rect it always has; a visitor gets a SECOND, separate plate of its own, because the
        // gap has to be a gap between two things rather than a notch cut out of one.
        this.drawPanel = (count)=>{
            this.clear();
            if (count < 1) return;
            const h = (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) + (0, $8d6533e00bd59062$export$2295e056c5b8b159) * 2;
            const plate = (x, cards)=>{
                this.beginFill(0x10140f, 0.72);
                this.lineStyle(1, 0xffffff, 0.12);
                this.drawRoundedRect(x - (0, $8d6533e00bd59062$export$2295e056c5b8b159), -(0, $8d6533e00bd59062$export$2295e056c5b8b159), cards * (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) + (0, $8d6533e00bd59062$export$2295e056c5b8b159) * 2, h, 8);
                this.endFill();
            };
            const visitors = Math.min(this.visitorColumns, count);
            if (visitors > 0) plate(0, visitors);
            const household = count - visitors;
            if (household > 0) plate(this.columnX(visitors), household);
        }, this.update = (roster)=>{
            // At most ONE hit sound per tick, however many members were hurt in it. The roster speaks
            // twice a second, so a wave mauling the whole camp would otherwise stack three or four
            // sounds into the same frame and arrive as a blur rather than as blows.
            let heardAHit = false;
            // Stable order (lord, defenders, foragers) so cards don't shuffle between ticks.
            const ordered = [
                ...roster
            ].sort((a, b)=>{
                const o = $44af089a9f2b65fe$var$ROLE_ORDER[a.role] - $44af089a9f2b65fe$var$ROLE_ORDER[b.role];
                return o !== 0 ? o : a.entityId.localeCompare(b.entityId);
            });
            const incoming = new Set(ordered.map((e)=>e.entityId));
            for (const [entityId, slot] of Array.from(this.slots.entries()))if (!incoming.has(entityId)) {
                // Off the roster means dead (or gone): the card doesn't just disappear, it dies.
                //
                // Except for a VISITOR, who leaves the feed for a second reason -- they ran out of
                // patience and walked back into the dark. They are still alive, and shattering
                // their card would say they were not. The entity itself is asked which it was
                // (hasMemberFallen): a disappointed recruit is still standing in the world at this
                // moment, walking home, while one that was cut down at the fire is not.
                if (slot.role === "visitor" && !this.guiManager.hasMemberFallen(entityId)) this.beginDeparture(entityId, slot);
                else this.beginDeath(entityId, slot);
            }
            ordered.forEach((entry)=>{
                const appearanceKey = this.appearanceKeyFor(entry);
                let slot = this.slots.get(entry.entityId);
                if (!slot) {
                    const container = new (0, $8t5Gy.Container)();
                    container.interactive = true;
                    container.cursor = "pointer";
                    container.hitArea = new (0, $6qzqq.Rectangle)(0, 0, (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e), (0, $8d6533e00bd59062$export$4cacdb4184ffb7a8));
                    container.sortableChildren = true;
                    // Two layers keep the damage wash BETWEEN the face and the labels. Only `art` is
                    // cached as one image; labels hold Text, which stays live (see makeBadge).
                    const art = new (0, $8t5Gy.Container)();
                    art.sortableChildren = true;
                    art.zIndex = $44af089a9f2b65fe$var$Z_CHROME;
                    const labels = new (0, $8t5Gy.Container)();
                    labels.sortableChildren = true;
                    labels.zIndex = $44af089a9f2b65fe$var$Z_BADGE;
                    const chrome = new (0, $gwPoJ.Graphics)();
                    this.drawChrome(chrome);
                    chrome.zIndex = $44af089a9f2b65fe$var$Z_CHROME;
                    const portrait = this.buildPortrait(entry);
                    portrait.zIndex = $44af089a9f2b65fe$var$Z_PORTRAIT;
                    const scrim = new (0, $gwPoJ.Graphics)();
                    this.drawScrim(scrim);
                    scrim.zIndex = $44af089a9f2b65fe$var$Z_SCRIM;
                    const badge = this.makeBadge(entry.role);
                    badge.zIndex = $44af089a9f2b65fe$var$Z_BADGE;
                    const nameText = this.makeNameText(entry.name);
                    nameText.zIndex = $44af089a9f2b65fe$var$Z_NAME;
                    const locationBadge = new (0, $9Pi8W.Text)("", {
                        fontSize: 10,
                        fontWeight: "bold",
                        fill: 0xb3e5ff,
                        stroke: 0x10140f,
                        strokeThickness: 3
                    });
                    locationBadge.zIndex = $44af089a9f2b65fe$var$Z_BADGE + 1;
                    locationBadge.y = 4;
                    const hpBar = new (0, $gwPoJ.Graphics)();
                    this.drawHpBar(hpBar, entry.hp, entry.hpMax);
                    hpBar.zIndex = $44af089a9f2b65fe$var$Z_HP;
                    const hungerBar = new (0, $gwPoJ.Graphics)();
                    this.drawHungerBar(hungerBar, entry.hunger);
                    hungerBar.zIndex = $44af089a9f2b65fe$var$Z_HUNGER;
                    const patienceRing = new (0, $gwPoJ.Graphics)();
                    this.drawPatienceRing(patienceRing, entry.patience);
                    patienceRing.zIndex = $44af089a9f2b65fe$var$Z_PATIENCE;
                    // Only a visitor arrives unasked; everyone else on this strip got here because the
                    // player hired them, and flaring at a defender walking back into view would train
                    // the eye to ignore the one signal that matters.
                    const arriving = entry.role === "visitor";
                    const flare = arriving ? new (0, $gwPoJ.Graphics)() : undefined;
                    if (flare) {
                        flare.zIndex = $44af089a9f2b65fe$var$Z_FLARE;
                        container.addChild(flare);
                    }
                    const selection = new (0, $gwPoJ.Graphics)();
                    selection.visible = false;
                    selection.zIndex = $44af089a9f2b65fe$var$Z_SELECTION;
                    const speaking = new (0, $gwPoJ.Graphics)();
                    speaking.visible = false;
                    speaking.zIndex = $44af089a9f2b65fe$var$Z_SPEAKING;
                    const wash = new (0, $gwPoJ.Graphics)();
                    this.drawWash(wash);
                    wash.visible = false;
                    wash.zIndex = $44af089a9f2b65fe$var$Z_WASH;
                    const damageRing = new (0, $gwPoJ.Graphics)();
                    this.drawDamageRing(damageRing);
                    damageRing.visible = false;
                    damageRing.zIndex = $44af089a9f2b65fe$var$Z_DAMAGE_RING;
                    art.addChild(chrome, portrait, scrim);
                    labels.addChild(badge, nameText, locationBadge);
                    container.addChild(art, labels, hpBar, hungerBar, patienceRing, selection, speaking, wash, damageRing);
                    container.on("pointerdown", ()=>this.onSlotClick(entry.entityId));
                    slot = {
                        container: container,
                        art: art,
                        labels: labels,
                        portrait: portrait,
                        badge: badge,
                        nameText: nameText,
                        locationBadge: locationBadge,
                        hpBar: hpBar,
                        hungerBar: hungerBar,
                        hunger: entry.hunger,
                        patienceRing: patienceRing,
                        patience: entry.patience,
                        fed: entry.fed,
                        flare: flare,
                        flareMs: arriving ? (0, $ec347662891822a3$export$4bd05e62286397cf) : undefined,
                        selection: selection,
                        appearanceKey: appearanceKey,
                        canKick: entry.canKick,
                        role: entry.role,
                        name: entry.name,
                        status: entry.status,
                        hp: entry.hp,
                        hpMax: entry.hpMax,
                        baseX: 0,
                        column: 0,
                        fireStrength: entry.fireStrength ?? NaN,
                        speaking: speaking,
                        wash: wash,
                        damageRing: damageRing,
                        damageSeq: 0
                    };
                    this.ensureFlame(slot);
                    this.slots.set(entry.entityId, slot);
                    this.addChild(container);
                    if (arriving) this.guiManager.playVisitorArrival();
                } else {
                    slot.canKick = entry.canKick;
                    // Rebuild only what actually changed (portrait rebuild + Text textures are costly).
                    if (slot.appearanceKey !== appearanceKey) {
                        slot.art.cacheAsBitmap = false;
                        slot.portrait.remove();
                        const portrait = this.buildPortrait(entry);
                        portrait.zIndex = $44af089a9f2b65fe$var$Z_PORTRAIT;
                        slot.art.addChild(portrait);
                        slot.portrait = portrait;
                        slot.appearanceKey = appearanceKey;
                    }
                    if (slot.role !== entry.role) {
                        // THE HIRE. A stranger has been given a job: same card, same person, different
                        // side of the gap. Remembered in SCREEN coordinates because the strip is about
                        // to be laid out again underneath it (see localFromScreen).
                        if (slot.role === "visitor") {
                            slot.joinFromX = this.screenFromLocal(slot.container.x);
                            slot.joinMs = 0;
                        }
                        (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(slot.badge);
                        slot.labels.removeChild(slot.badge);
                        if (!slot.badge.destroyed) slot.badge.destroy();
                        slot.badge = this.makeBadge(entry.role);
                        slot.badge.zIndex = $44af089a9f2b65fe$var$Z_BADGE;
                        slot.labels.addChild(slot.badge);
                        slot.role = entry.role;
                    }
                    if (slot.name !== entry.name) {
                        (0, $7fc026ed2e091ee4$export$7e4c1296b4859de0)(slot.nameText);
                        slot.labels.removeChild(slot.nameText);
                        slot.nameText = this.makeNameText(entry.name);
                        slot.nameText.zIndex = $44af089a9f2b65fe$var$Z_NAME;
                        slot.labels.addChild(slot.nameText);
                        slot.name = entry.name;
                    }
                    if (slot.hp !== entry.hp || slot.hpMax !== entry.hpMax) {
                        // A member whose health went DOWN since the last tick was hurt -- the roster
                        // carries no hit event of its own, and this is the one place both numbers are
                        // known. Healing and a first sighting fall through to a plain redraw.
                        if (slot.hp !== undefined && entry.hp !== undefined && entry.hpMax) {
                            this.damageFx.hit(entry.entityId, slot.hp, entry.hp, entry.hpMax);
                            if (entry.hp < slot.hp && !heardAHit) {
                                // Somebody in the camp is being hurt out of sight. The card says so; the
                                // sound is what gets the player to look at it. GuiManager keeps quiet for
                                // a member close enough that the world already played their hit.
                                this.guiManager.playOffscreenHit(entry.entityId);
                                heardAHit = true;
                            }
                        }
                        slot.hp = entry.hp;
                        slot.hpMax = entry.hpMax;
                        this.drawHpBar(slot.hpBar, entry.hp, entry.hpMax, slot.ghostRatio);
                    }
                    if (slot.hunger !== entry.hunger) {
                        this.drawHungerBar(slot.hungerBar, entry.hunger);
                        slot.hunger = entry.hunger;
                    }
                    if (slot.patience !== entry.patience) {
                        this.drawPatienceRing(slot.patienceRing, entry.patience);
                        slot.patience = entry.patience;
                    }
                    slot.fed = entry.fed;
                    slot.status = entry.status;
                    slot.fireStrength = entry.fireStrength ?? NaN;
                    this.ensureFlame(slot);
                }
                const locationText = entry.crossRoom ? `L${entry.floor ?? 0}` : "";
                const locationVisible = entry.crossRoom === true;
                if (slot.locationBadge.text !== locationText || slot.locationBadge.visible !== locationVisible) {
                    slot.locationBadge.text = locationText;
                    slot.locationBadge.visible = locationVisible;
                    slot.locationBadge.x = (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) - slot.locationBadge.width - 5;
                }
            });
            this.order = ordered.map((entry)=>entry.entityId);
            this.layout();
            this.applySelection();
        }, // Place every card in the strip and redraw the panel behind them. Cards whose member has died
        // keep the column they had, and the living lay out around those gaps -- so a card breaking apart
        // is never slid under by a survivor, and the strip only closes up once it has gone.
        //
        // Called on each roster tick AND the moment a death finishes, because the gap has to close then
        // rather than whenever the next tick happens to arrive.
        this.layout = ()=>{
            const total = this.order.length + this.dying.size;
            // How much of the left of the strip belongs to visitors. Counted off the LIVING order only:
            // it is sorted (visitors first, by ROLE_ORDER), so this is simply its leading run -- and a
            // card that is breaking apart has no say in where the gap goes.
            let visitors = 0;
            while(visitors < this.order.length && this.slots.get(this.order[visitors])?.role === "visitor")visitors++;
            this.visitorColumns = visitors;
            // Held open for a join in flight as well. The card crossing the gap has already been
            // re-sorted into the household, so without this the strip would close up around it the
            // instant it was hired and the slide would happen in mid-air, over the top of the camp.
            // Kept open, the space it is leaving empties behind it and the strip's width never moves.
            this.gapOpen = visitors > 0 || this.leaving.size > 0 || this.joining() > 0;
            // Dying cards claim their column first, lowest first. An index that no longer exists (the
            // last card of the strip died) falls to the nearest one that does.
            const taken = new Set();
            Array.from(this.dying.values()).sort((a, b)=>a.column - b.column).forEach((card)=>{
                let column = Math.min(Math.max(0, card.column), Math.max(0, total - 1));
                while(taken.has(column))column = column + 1 >= total ? 0 : column + 1;
                taken.add(column);
                card.column = column;
                card.slot.column = column;
                this.place(card.slot, column);
                card.shards?.position.set(this.columnX(column), 0);
            });
            let column = 0;
            this.order.forEach((entityId)=>{
                const slot = this.slots.get(entityId);
                if (!slot) return;
                while(taken.has(column))column++;
                slot.column = column;
                this.place(slot, column);
                this.applyDamage(slot, this.damageFx.frame(entityId));
                column++;
            });
            this.drawPanel(total);
            this.updateFireWarning();
            this.updateStatusRow();
        }, // Hand the pill row this frame's cards. Driven off `order` and the RESTING x, so a chip sits over
        // the column its member belongs to rather than following a damage shake -- and so a card that is
        // breaking apart (which keeps its column but has no orders left) carries no chip at all.
        this.updateStatusRow = ()=>{
            // The fire warning's own baseline, so the lord's alarm and everybody else's chip sit on one
            // line, inset from the card by the same air every chip keeps (see the fire warning below).
            this.statusRow.y = -(0, $8d6533e00bd59062$export$2295e056c5b8b159) - $44af089a9f2b65fe$var$FIRE_WARNING_H;
            this.statusRow.sync(this.order.map((entityId)=>{
                const slot = this.slots.get(entityId);
                return {
                    entityId: entityId,
                    // The lord's pill is the fire warning; nobody gets two.
                    status: slot && slot.role !== "lord" ? slot.status : undefined,
                    x: slot?.baseX ?? 0
                };
            }));
        }, // Use the same 0.3 boundary as the server's cold-health drain. Missing data is
        // not evidence of an extinguished fire (older/initial roster packets may omit it).
        this.updateFireWarning = ()=>{
            const lord = Array.from(this.slots.values()).find((slot)=>slot.role === "lord");
            const state = !lord || !Number.isFinite(lord.fireStrength) || lord.fireStrength >= 0.3 ? undefined : lord.fireStrength <= 0 ? "No fire" : "Fire low";
            this.fireWarning.visible = state !== undefined;
            if (!state || !lord) {
                this.fireWarningState = undefined;
                return;
            }
            if (state !== this.fireWarningState) {
                this.fireWarningState = state;
                this.fireWarningPulseMs = 0;
                this.fireWarning.alpha = 1;
                const color = state === "No fire" ? 0xff5959 : 0xffbd45;
                this.fireWarningTitle.text = state === "No fire" ? "No fire!" : state;
                this.fireWarningTitle.tint = 0xfff3e0;
                // The same plate every status chip in the row beside it is drawn on, laid out by the same
                // rule: this pill was the first one, and the row generalised it, so the shape now lives in
                // one place (roster_status.ts) and the lord's alarm cannot drift away from the rest of
                // the lane -- including the air that keeps one chip off the next.
                (0, $df39eaafb36c45c0$export$3d3231c99f8a15bb)(this.fireWarning, color, "alarm");
                (0, $df39eaafb36c45c0$export$8e160a798f1ef897)(this.fireWarningTitle);
            }
            this.fireWarning.position.set(lord.baseX + (0, $df39eaafb36c45c0$export$f8db1cc21f63f690), -(0, $8d6533e00bd59062$export$2295e056c5b8b159) - $44af089a9f2b65fe$var$FIRE_WARNING_H);
        }, // The card's resting place. Its ACTUAL position is set by applyDamage, which is what holds the
        // shake -- a roster tick landing mid-jolt would otherwise snap the card back.
        this.place = (slot, column)=>{
            slot.baseX = this.columnX(column);
            // A card mid-JOIN is being driven across the gap by updateJoins; writing its resting x here
            // would snap it to the far side the instant the roster next ticked, which is most of the
            // way through a 480ms slide. `baseX` is still updated, because that is where it is sliding
            // TO -- and what the connector line and the speech tail should already be aiming at.
            if (slot.joinMs === undefined) slot.container.x = slot.baseX;
            slot.container.y = 0;
        }, // Take the whole strip down at once, with no death animation: this is a ROOM CHANGE, not a camp
        // losing its people, and a card cannot break apart over a room the player has already left.
        // (Not `clear`, which is Graphics' own.)
        this.clearRoster = ()=>{
            this.dying.forEach((card, entityId)=>this.endDeath(entityId, card));
            this.slots.forEach((slot, entityId)=>{
                this.disposeSlot(slot);
                this.speechLane.forget(entityId);
                this.damageFx.forget(entityId);
            });
            this.slots.clear();
            this.updateFireWarning();
            this.statusRow.forgetAll();
            this.order = [];
            this.selectMember(undefined);
            this.drawPanel(0);
        }, // Camp member cards, including the Lord, open their command wheel above the strip.
        this.onSlotClick = (entityId)=>{
            const slot = this.slots.get(entityId);
            if (!slot) return;
            // Whatever the last tap put up comes down first -- both live in the slot above the strip, and
            // only one card is ever the active one. It also makes tapping the ACTIVE card a toggle.
            const wasSelected = this.selectedEntityId === entityId;
            this.guiManager.closeRosterSelection();
            if (wasSelected) return;
            // Set AFTER the close above: closeRosterSelection clears the selection on its way out.
            this.selectMember(entityId);
            // An inviter can watch or kick their guest. Other player cards open
            // the follow camera; roster permissions come from the server for this viewer.
            // A VISITOR takes no orders -- they are not crew, and the command wheel has nothing to say
            // to them. What a tap on their card gives you instead is exactly what a tap on the person
            // would: their own verbs ("Give Food", and "Talk" once they are fed), parked in the slot
            // above the strip because the whole reason you are reading their card is that you cannot
            // see them. `openRosterInteractionWheel` carries a "Watch" slice for the follow cam, which
            // is how the one gesture still reaches both.
            if (slot.role === "visitor") {
                this.guiManager.openRosterInteractionWheel(entityId, slot.name);
                return;
            }
            if (slot.role === "player" && slot.canKick) this.guiManager.openRosterPlayerWheel(entityId, slot.name);
            else if (slot.role === "player") this.guiManager.openFollowCam(entityId, slot.name);
            else this.guiManager.openRosterCommandWheel(entityId, slot.role);
        }, // The one place the active card changes. Besides lighting the card itself, the selected member is
        // outlined OUT IN THE WORLD with the same glow a pointed-at entity gets, so it is obvious which
        // character on screen the card belongs to. Everything that selects or deselects goes through here
        // so the world glow can never outlive the card highlight.
        this.selectMember = (entityId)=>{
            if (this.selectedEntityId === entityId) return;
            this.selectedEntityId = entityId;
            this.applySelection();
            this.guiManager.highlightEmberMember(entityId);
        }, // Called by GuiManager when whatever the card opened closes again (the follow-cam, or that
        // member's command wheel), so the highlighted card returns to normal.
        this.clearSelection = ()=>{
            this.selectMember(undefined);
        }, // Called by GuiManager when something it opened HANDS OVER to something else about the same
        // member -- a roster command wheel giving way to the role picker it asked for -- so the card stays
        // lit through the swap rather than going dark for the round trip and coming back.
        this.holdSelection = (entityId)=>{
            this.selectMember(entityId);
        }, this.isSelected = (entityId)=>this.selectedEntityId === entityId, // --- What the strip currently holds. Live cards plus the ones still breaking apart, because to
        // everything outside this widget (its width, the gap it is holding) those count as cards too.
        this.cardCount = ()=>this.slots.size + this.dying.size, this.isDying = (entityId)=>this.dying.has(entityId), // Which column a card occupies, living or dying; -1 if it isn't on the strip at all.
        this.columnOf = (entityId)=>this.slots.get(entityId)?.column ?? this.dying.get(entityId)?.column ?? -1, // A visitor drifting back out into the dark -- alive, unlike a dying card.
        this.isLeaving = (entityId)=>this.leaving.has(entityId), // Where a card rests in the strip's own space. The gap a visitor opens lives in HERE rather
        // than in the column numbers, so this is the only honest way to ask whether the strip is split.
        this.cardX = (entityId)=>this.slots.get(entityId)?.baseX ?? -1, // "greying" | "shattering" for a card on its way out, null for anything else.
        this.deathPhase = (entityId)=>{
            const card = this.dying.get(entityId);
            return card ? card.shattered ? "shattering" : "greying" : null;
        }, // Rendered panel extents (in the parent's coordinate space, i.e. including WIDGET_SCALE), so
        // GuiManager can right-/bottom-align the strip as the card count changes. Measured from this
        // widget's origin (x/y) to the panel's right / bottom edge.
        this.rightExtent = ()=>{
            // Cards still breaking apart hold their column, so they are still part of the strip's width.
            // A card drifting OUT is not: it is already past the left edge of the plate and taking no
            // room, and counting it would drag the whole strip sideways as it went.
            const count = this.slots.size + this.dying.size;
            return count < 1 ? 0 : (this.columnX(count) + (0, $8d6533e00bd59062$export$2295e056c5b8b159)) * $44af089a9f2b65fe$var$WIDGET_SCALE;
        }, this.bottomExtent = ()=>((0, $8d6533e00bd59062$export$4cacdb4184ffb7a8) + (0, $8d6533e00bd59062$export$2295e056c5b8b159)) * $44af089a9f2b65fe$var$WIDGET_SCALE, // Distance from this widget's origin (y) up to the panel's top edge, INCLUDING the reserved
        // speech lane above it. Reserved whether or not a bubble is showing, so whatever sits above the
        // roster (the follow-cam PiP) doesn't jump every time someone speaks.
        this.topExtent = ()=>((0, $8d6533e00bd59062$export$2295e056c5b8b159) + $44af089a9f2b65fe$var$SPEECH_LANE_H) * $44af089a9f2b65fe$var$WIDGET_SCALE, // Top-centre of one member's card, in this widget's PARENT coordinate space (i.e. including this
        // widget's position and scale), plus the card's role colour. Null when that member has no card.
        // Used to draw a connector line from whatever the card opened back down to the card.
        //
        // `edge` picks which top the point sits on. The follow-cam's line is drawn OVER the strip and
        // stops at the card itself; a roster command wheel's line is drawn UNDER it (so a speech bubble
        // reads over the line) and has to stop at the panel's outer edge, or its end is buried.
        this.cardAnchor = (entityId, edge = "card")=>{
            if (!entityId) return null;
            const slot = this.slots.get(entityId);
            if (!slot) return null;
            // The card's RESTING centre: reading container.x would make the connector line wobble along
            // with a damage shake.
            const localCenterX = slot.baseX + (0, $8d6533e00bd59062$export$cdc10a00a6ecc04e) / 2;
            return {
                x: this.x + localCenterX * this.scale.x,
                y: this.y - (edge === "panel" ? (0, $8d6533e00bd59062$export$2295e056c5b8b159) * this.scale.y : 0),
                color: $44af089a9f2b65fe$var$ROLE_COLORS[slot.role]
            };
        }, // The selected card's anchor, for the follow-cam PiP's connector line.
        this.selectedCardAnchor = ()=>this.cardAnchor(this.selectedEntityId), this.applySelection = ()=>{
            this.slots.forEach((slot, entityId)=>{
                const selected = this.selectedEntityId === entityId;
                // Called on every roster tick; a redraw would also re-bake the ring's cached texture.
                if (selected && slot.selectionRole !== slot.role) {
                    this.drawSelection(slot.selection, slot.role);
                    slot.selectionRole = slot.role;
                }
                slot.selection.visible = selected;
            });
        };
        this.guiManager = guiManager;
        this.scale.set($44af089a9f2b65fe$var$WIDGET_SCALE);
        this.joinDots = new (0, $gwPoJ.Graphics)();
        this.joinDots.visible = false;
        this.addChild(this.joinDots);
        // Added before the bubble and the fire warning, which both sit in or above the same lane and
        // should draw over a chip rather than under one.
        this.addChild(this.statusRow);
        this.speechBubble = new (0, $23d13a6e2a72aec5$export$1173af088df4f527)();
        this.addChild(this.speechBubble);
        this.fireWarningTitle = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("caption").bold().render("");
        this.fireWarning.addChild(this.fireWarningTitle);
        this.fireWarning.visible = false;
        this.addChild(this.fireWarning);
        this.exposeDevTriggers();
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $8t5Gy = parcelRequire("8t5Gy");

parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");

class $f42064c8e11476cf$export$965a4009231121c2 extends (0, $gwPoJ.Graphics) {
    constructor({ radius: radius, onClick: onClick }){
        super(), // A diagonal with an arrowhead at each end, running bottom-left to top-right. Drawn from the
        // radius so it holds at both the desktop and the touch size.
        this.draw = (hover)=>{
            const r = this.radius;
            (0, $e59d4eca9b366180$export$cf4441b2ae4eae3b)(this, r, hover, "ember");
            const arm = r * 0.44;
            // Arrowhead legs, a shade shorter than they are from the tip -- any longer and at an 8px
            // radius the two heads touch in the middle and the glyph reads as a blob.
            const head = r * 0.3;
            this.lineStyle({
                width: Math.max(1.5, r * 0.17),
                color: (0, $e59d4eca9b366180$export$3da1e32664c3cd3)(hover, "ember"),
                alpha: 1,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            this.moveTo(-arm, arm);
            this.lineTo(arm, -arm);
            // Top-right head.
            this.moveTo(arm, -arm);
            this.lineTo(arm - head, -arm);
            this.moveTo(arm, -arm);
            this.lineTo(arm, -arm + head);
            // Bottom-left head.
            this.moveTo(-arm, arm);
            this.lineTo(-arm + head, arm);
            this.moveTo(-arm, arm);
            this.lineTo(-arm, arm - head);
            this.lineStyle(0);
        };
        this.radius = radius;
        this.draw(false);
        this.interactive = true;
        this.cursor = "pointer";
        // Keep the panel control's forgiving circular target.
        this.hitArea = new (0, $6qzqq.Circle)(0, 0, radius + 3);
        this.on("mouseover", ()=>this.draw(true));
        this.on("mouseout", ()=>this.draw(false));
        if (onClick) {
            this.on("click", onClick);
            this.on("tap", onClick);
        }
    }
}



// Picture-in-picture "follow cam" opened from the ember roster. Shows the world rendered live,
// centred on a chosen entity, so the player can watch a defender/forager/lord wherever it is in
// the room. The actual world render into `texture` is driven each frame by PixiJsClientRenderer
// (renderWorldToTexture); this widget owns the texture, frame and size controls.
//
// TUNABLES (verify live): VIEW_W/H is the window size; ZOOM is the world scale shown inside it
// (1.0 shows ~VIEW_W px of world; raise to zoom in). Keep ZOOM's visible span within the client's
// FOCUS_RENDER_RADIUS or entities will pop at the edges.
const $a800cd15c7729c86$var$VIEW_W = 260;
const $a800cd15c7729c86$var$VIEW_H = 200;
const $a800cd15c7729c86$var$ZOOM = 1.0;
// The overlay renders into the PiP at scale zoom/surfaceZoom (0.5), which pixel-drops bitmap text.
// Render the texture at a higher resolution (2 x devicePixelRatio) so the downscaled text stays legible.
const $a800cd15c7729c86$var$PIP_RESOLUTION = 2 * (typeof window !== "undefined" && window.devicePixelRatio ? window.devicePixelRatio : 1);
const $a800cd15c7729c86$var$FRAME = 4;
// No title/name header — the PiP is just the framed world view.
const $a800cd15c7729c86$var$TITLE_H = 0;
const $a800cd15c7729c86$var$CONTROL_RADIUS = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? 15 : 8;
class $a800cd15c7729c86$export$6b342f104f181be3 extends (0, $8t5Gy.Container) {
    constructor(_guiManager, drag){
        super(), this.drag = drag, this.panelWidth = 160, this.isOpen_ = false, this.grabbed = false, this.grabDx = 0, this.grabDy = 0, this.resizing = false, this.resizeStartX = 0, this.resizeStartWidth = 0, this.focusEntityId = null, this.onGrab = (event)=>{
            if (event.target !== this || !this.parent) return;
            const pointer = event.data.getLocalPosition(this.parent);
            this.grabDx = this.x - pointer.x;
            this.grabDy = this.y - pointer.y;
            this.grabbed = true;
            this.cursor = "grabbing";
            this.drag?.onGrab();
        }, this.onDragMove = (event)=>{
            if (this.resizing && this.parent) {
                const pointer = event.data.getLocalPosition(this.parent);
                const width = Math.max(160, Math.min(536, this.resizeStartWidth + pointer.x - this.resizeStartX));
                this.setWidth(width);
                this.drag?.onGrab();
                this.drag?.onResize?.();
                return;
            }
            if (!this.grabbed || !this.parent) return;
            const pointer = event.data.getLocalPosition(this.parent);
            this.drag?.onDragTo(pointer.x + this.grabDx, pointer.y + this.grabDy);
        }, this.onRelease = ()=>{
            if (!this.grabbed && !this.resizing) return;
            this.grabbed = false;
            this.resizing = false;
            this.cursor = "grab";
            this.drag?.onRelease();
        }, this.drawFrame = ()=>{
            this.frame.clear();
            this.frame.beginFill((0, $97475243e21a0995$export$ae463dc3cc7e810b), 0.59);
            this.frame.lineStyle(2, 0xffffff, 0.36);
            this.frame.drawRoundedRect(0, 0, this.getWidth(), this.getHeight(), 6);
            this.frame.endFill();
            this.sizeButton.position.set(this.getWidth() - $a800cd15c7729c86$var$CONTROL_RADIUS - 3, $a800cd15c7729c86$var$CONTROL_RADIUS + 3);
            const grip = this.resizeHandle;
            grip.clear();
            grip.lineStyle(2, 0xffffff, 0.36);
            grip.moveTo(-12, 0);
            grip.lineTo(0, -12);
            grip.beginFill(0xffffff, 0.001);
            grip.drawRect(-16, -16, 20, 20);
            grip.endFill();
            grip.position.set(this.getWidth() - $a800cd15c7729c86$var$FRAME, this.getHeight() - $a800cd15c7729c86$var$FRAME);
        }, this.setWidth = (width)=>{
            this.panelWidth = width;
            this.view.width = this.getWidth() - $a800cd15c7729c86$var$FRAME * 2;
            this.view.height = this.getHeight() - $a800cd15c7729c86$var$FRAME * 2;
            this.drawFrame();
        }, this.cycleSize = ()=>{
            const sizes = [
                160,
                268,
                536
            ];
            this.setWidth(sizes.find((width)=>width > this.panelWidth + 1) ?? sizes[0]);
            this.drag?.onGrab();
            this.drag?.onResize?.();
            this.drag?.onRelease();
        }, this.open = (entityId, _name)=>{
            this.focusEntityId = entityId;
            this.isOpen_ = true;
            this.visible = true;
        }, this.close = ()=>{
            this.onRelease();
            this.isOpen_ = false;
            this.visible = false;
            this.focusEntityId = null;
        }, this.isOpen = ()=>this.isOpen_, this.getTexture = ()=>this.texture, this.getZoom = ()=>$a800cd15c7729c86$var$ZOOM, this.// Outer frame dimensions (for positioning the modal relative to other HUD elements).
        getWidth = ()=>this.panelWidth, this.getHeight = ()=>($a800cd15c7729c86$var$VIEW_H + $a800cd15c7729c86$var$FRAME * 2 + $a800cd15c7729c86$var$TITLE_H) * this.panelWidth / ($a800cd15c7729c86$var$VIEW_W + $a800cd15c7729c86$var$FRAME * 2);
        this.texture = (0, $klOfb.RenderTexture).create({
            width: $a800cd15c7729c86$var$VIEW_W,
            height: $a800cd15c7729c86$var$VIEW_H,
            resolution: $a800cd15c7729c86$var$PIP_RESOLUTION
        });
        this.frame = new (0, $gwPoJ.Graphics)();
        this.addChild(this.frame);
        this.view = new (0, $7Bs2Z.Sprite)(this.texture);
        this.view.x = $a800cd15c7729c86$var$FRAME;
        this.view.y = $a800cd15c7729c86$var$FRAME + $a800cd15c7729c86$var$TITLE_H;
        this.addChild(this.view);
        this.sizeButton = new (0, $f42064c8e11476cf$export$965a4009231121c2)({
            radius: $a800cd15c7729c86$var$CONTROL_RADIUS,
            onClick: this.cycleSize
        });
        this.addChild(this.sizeButton);
        const resizeHandle = new (0, $gwPoJ.Graphics)();
        this.resizeHandle = resizeHandle;
        resizeHandle.interactive = true;
        resizeHandle.cursor = "nwse-resize";
        resizeHandle.on("pointerdown", (event)=>{
            if (!this.parent) return;
            this.resizing = true;
            this.resizeStartX = event.data.getLocalPosition(this.parent).x;
            this.resizeStartWidth = this.getWidth();
            this.drag?.onGrab();
        });
        this.addChild(resizeHandle);
        this.setWidth(this.panelWidth);
        this.interactive = true;
        this.cursor = "grab";
        this.on("pointerdown", this.onGrab);
        this.on("pointermove", this.onDragMove);
        this.on("pointerup", this.onRelease);
        this.on("pointerupoutside", this.onRelease);
        this.visible = false;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $9Pi8W = parcelRequire("9Pi8W");





// Frame thickness, matching the follow-cam PiP that shares this HUD slot.
const $27706b8361e494c8$var$FRAME = 4;
const $27706b8361e494c8$var$CORNER = 6;
const $27706b8361e494c8$export$bd0af544843e4d09 = {
    radar: 112,
    normal: 176,
    large: 240
};
const $27706b8361e494c8$export$b9c010a4183e9f26 = [
    "radar",
    "normal",
    "large"
];
const $27706b8361e494c8$export$b224d4b6baa336d9 = "radar";
const $27706b8361e494c8$export$ae98601b622c352d = (size)=>$27706b8361e494c8$export$b9c010a4183e9f26[(Math.max(0, $27706b8361e494c8$export$b9c010a4183e9f26.indexOf(size)) + 1) % $27706b8361e494c8$export$b9c010a4183e9f26.length];
const $27706b8361e494c8$export$c8b624e948a22741 = (value)=>$27706b8361e494c8$export$b9c010a4183e9f26.includes(value) ? value : null;
// The size control sits inside the map's top-right corner. The MAP chip owns visibility.
const $27706b8361e494c8$var$CONTROL_RADIUS = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? 15 : 8;
// Dot sizes and colours. White = camp member, red = wave attacker, bright green = you (the same
// green the world minimap has always used for the player). Trees are a DIM green wash painted under
// all of them: terrain, not a dot, and far enough from the player's bright green to never be mistaken
// for it.
const $27706b8361e494c8$var$DOT_R = 2.2;
const $27706b8361e494c8$var$PLAYER_DOT_R = 2.8;
const $27706b8361e494c8$var$MEMBER_COLOR = 0xffffff;
const $27706b8361e494c8$var$ATTACKER_COLOR = 0xff3b30;
const $27706b8361e494c8$var$PLAYER_COLOR = 0x39ff6a;
const $27706b8361e494c8$var$TREE_COLOR = 0x2f6b3d;
// Another person in the camp: a player, so player-sized and player-green, but a cooler, dimmer
// green than your own bright one. Near enough to read as "one of us" at a glance, far enough apart
// that you never mistake theirs for the dot you are steering.
const $27706b8361e494c8$var$PARTNER_COLOR = 0x2bc4a8;
// A stranger at the fire asking to be taken on. Ember gold -- the colour of the thing that drew
// them -- and the ONLY dot on this map that pulses. Nothing else here moves except by travelling,
// so the pulse alone says "this one is new, and it is waiting on you" with no legend to read. It
// also keeps a visitor clear of the red it would otherwise be mistaken for at this dot size: the
// other thing that turns up at your camp uninvited is a wave.
const $27706b8361e494c8$var$VISITOR_COLOR = 0xffb648;
const $27706b8361e494c8$var$VISITOR_PULSE_MS = 1100;
// The same stranger, earlier: still crossing the dark towards the fire. The same gold, because it is
// the same creature and nothing has changed about what it wants -- and NOT pulsing, because it is
// not asking yet. So the arrival reads as one continuous thing: a gold dot appears at the edge of
// the map, walks in, and starts to beat when it reaches the fire and puts its hand up.
const $27706b8361e494c8$var$APPROACHING_ALPHA = 0.82;
// How far the pulse swells the dot. Deliberately modest: the dots already GLIDE a full second
// between snapshots, and a big throb on top of a glide reads as jitter rather than as a beacon.
const $27706b8361e494c8$var$VISITOR_PULSE_GROW = 0.55;
// How much of the world the map lets through. The BACKDROP, its border and the tree wash are all
// semi-transparent so the map sits lightly over the game rather than punching a panel out of it; the
// dots stay fully opaque, because they are the thing the map is for.
const $27706b8361e494c8$var$PANEL_COLOR = (0, $97475243e21a0995$export$ae463dc3cc7e810b);
const $27706b8361e494c8$var$PANEL_ALPHA = 0.59;
const $27706b8361e494c8$var$BORDER_ALPHA = 0.36;
const $27706b8361e494c8$var$TREE_ALPHA = 0.61;
const $27706b8361e494c8$var$GROUND_COLOR = 0xc3b38b;
const $27706b8361e494c8$var$GROUND_ALPHA = 0.24;
const $27706b8361e494c8$var$ROCK_COLOR = 0x9297a3;
const $27706b8361e494c8$var$ORE_COLOR = 0xb6a482;
// The pond: the water's own mid blue (water_layer.ts), so the map reads it as the same water.
const $27706b8361e494c8$var$WATER_COLOR = 0x1d78a2;
const $27706b8361e494c8$var$WATER_ALPHA = 0.85;
const $27706b8361e494c8$export$30a87bc142bf2fb5 = (map, tilesWide, tilesHigh)=>{
    const cells = {
        trees: [],
        rocks: [],
        ore: [],
        structures: [],
        water: []
    };
    const water = map.getWaterLayer?.();
    for(let x = 0; x < tilesWide; x++)for(let y = 0; y < tilesHigh; y++){
        const tile = map.getEntityTileAt(x, y)?.entityTile;
        const cell = {
            x: x,
            y: y
        };
        const wet = water?.[x]?.[y];
        // Before collision: deep water can block (a showcase's moat), and it is water, not rock.
        if (wet && wet !== "0") cells.water.push(cell);
        else if ((0, $ff74dc2a666565c1$export$81d865d97cd78a4a)(tile)) cells.trees.push(cell);
        else if (tile && /ore|rock|stone/i.test(tile) && !/wall|floor/i.test(tile)) cells.ore.push(cell);
        else if (tile && /wall|hearth|campfire|chest/i.test(tile)) cells.structures.push(cell);
        else if (map.isCollisionAt?.(x, y)) cells.rocks.push(cell);
    }
    return cells;
};
const $27706b8361e494c8$export$4023aa562dd89cda = (exploration, tilesWide, tilesHigh)=>{
    if (exploration.cellTiles !== 2 || exploration.columns !== Math.ceil(tilesWide / 2) || exploration.rows !== Math.ceil(tilesHigh / 2) || !Number.isInteger(exploration.revision) || exploration.revision < 0) return null;
    try {
        const decoded = atob(exploration.bits);
        if (decoded.length !== Math.ceil(exploration.columns * exploration.rows / 8)) return null;
        return Uint8Array.from(decoded, (char)=>char.charCodeAt(0));
    } catch  {
        return null;
    }
};
const $27706b8361e494c8$export$a6ce970ca4241c6a = 1000;
const $27706b8361e494c8$export$f2723e5f32c829e9 = (track)=>{
    const p = $27706b8361e494c8$export$a6ce970ca4241c6a > 0 ? Math.max(0, Math.min(1, track.t / $27706b8361e494c8$export$a6ce970ca4241c6a)) : 1;
    return {
        x: track.fromX + (track.toX - track.fromX) * p,
        y: track.fromY + (track.toY - track.fromY) * p
    };
};
const $27706b8361e494c8$export$d8cdfd7fe35d629c = (map, tilesWide, tilesHigh)=>{
    const cells = [];
    if (!map || !(tilesWide > 0) || !(tilesHigh > 0)) return cells;
    for(let x = 0; x < tilesWide; x++){
        for(let y = 0; y < tilesHigh; y++)if ((0, $ff74dc2a666565c1$export$81d865d97cd78a4a)(map.getEntityTileAt(x, y)?.entityTile)) cells.push({
            x: x,
            y: y
        });
    }
    return cells;
};
const $27706b8361e494c8$export$7d8c499170a003eb = (dot, room, mapW, mapH)=>{
    const fx = room.width > 0 ? dot.x / room.width : 0;
    const fy = room.height > 0 ? dot.y / room.height : 0;
    return {
        x: Math.max(0, Math.min(1, fx)) * mapW,
        y: Math.max(0, Math.min(1, fy)) * mapH
    };
};
const $27706b8361e494c8$export$750bcf04cfea520e = (room, max)=>{
    if (!(room.width > 0) || !(room.height > 0)) return {
        w: max,
        h: max
    };
    const longest = Math.max(room.width, room.height);
    return {
        w: Math.round(room.width / longest * max),
        h: Math.round(room.height / longest * max)
    };
};
const $27706b8361e494c8$export$a05724648878e2dc = (a, b)=>a.x < b.x + b.width && b.x < a.x + a.width && a.y < b.y + b.height && b.y < a.y + a.height;
const $27706b8361e494c8$export$39715f4eaf395d01 = (at, panel, bounds)=>({
        x: (0, $10da07838e6d507c$export$7d15b64cf5a3a4c4)(at.x, bounds.left, Math.max(bounds.left, bounds.right - panel.width)),
        y: (0, $10da07838e6d507c$export$7d15b64cf5a3a4c4)(at.y, bounds.top, Math.max(bounds.top, bounds.bottom - panel.height))
    });
class $27706b8361e494c8$export$72d7fbba603469ff extends (0, $8t5Gy.Container) {
    render(renderer) {
        if (this.terrainDirty || this.cachedAtResolution !== renderer.resolution) {
            this.terrainDirty = false;
            this.cachedAtResolution = renderer.resolution;
            // Off and on again redraws the bitmap. In a cave the sight mask over the whole map keeps all of it live.
            this.terrainHolder.cacheAsBitmap = false;
            this.terrainHolder.cacheAsBitmap = !!this.terrainLayer.mask && !this.caveContents.mask;
        }
        super.render(renderer);
    }
    // The owner moves the panel and remembers size changes.
    constructor(drag, onSizeChange){
        super(), this.frame = new (0, $gwPoJ.Graphics)(), this.caveContents = new (0, $8t5Gy.Container)(), this.sightMask = new (0, $gwPoJ.Graphics)(), this.sightPolygon = null, this.rememberedSightPolygon = null, this.rememberedSightKey = "", this.caveDiscovery = new Map(), this.terrainLayer = new (0, $8t5Gy.Container)(), // The terrain with its fog-of-war mask, cached as one bitmap while that mask is in use: a mask of many rounded cells
        // is a stencil pass, and drawn live it cleared the whole screen's stencil and redrew the mask every frame (~1.4ms of
        // a castle frame) for terrain that changes only as the map is explored. Redrawn when it changes (terrainDirty).
        this.terrainHolder = new (0, $8t5Gy.Container)(), this.terrainDirty = true, this.cachedAtResolution = 0, this.ground = new (0, $gwPoJ.Graphics)(), this.terrainMask = new (0, $gwPoJ.Graphics)(), this.trees = new (0, $gwPoJ.Graphics)(), this.rocks = new (0, $gwPoJ.Graphics)(), this.terrainCells = {
            trees: [],
            rocks: [],
            ore: [],
            structures: [],
            water: []
        }, this.discovery = null, this.discoveryBits = null, // A bounded, disposable mirror of server snapshots, including packets that arrive just before
        // roomUpdated. Clearing the active room must not lose the only bitmap in an unchanged feed.
        this.discoveryCache = new Map(), this.discoveryKey = "", this.expectedRoomId = null, this.dots = new (0, $gwPoJ.Graphics)(), // Outside the cave sight mask so the dev command can locate still-hidden rooms.
        this.voidRooms = new (0, $gwPoJ.Graphics)(), this.bonecallerLabel = new (0, $9Pi8W.Text)("", {
            fontSize: 10,
            fill: 0xe9b4ff,
            stroke: 0x000000,
            strokeThickness: 3
        }), this.mineLabel = new (0, $9Pi8W.Text)("Mine", {
            fontSize: 10,
            fill: 0xf0cc83,
            stroke: 0x000000,
            strokeThickness: 3
        }), this.rescueLabel = new (0, $9Pi8W.Text)("", {
            fontSize: 10,
            fill: 0xffdd88,
            stroke: 0x000000,
            strokeThickness: 3
        }), this.rescueTracks = new Map(), this.playerDot = new (0, $gwPoJ.Graphics)(), this.state = null, this.size = $27706b8361e494c8$export$b224d4b6baa336d9, this.mapW = $27706b8361e494c8$export$bd0af544843e4d09[$27706b8361e494c8$export$b224d4b6baa336d9], this.mapH = $27706b8361e494c8$export$bd0af544843e4d09[$27706b8361e494c8$export$b224d4b6baa336d9], // The last tree scan, kept so the layer can be repainted if the map's extent changes under it.
        this.treeCells = [], this.treeTilesWide = 0, this.treeTilesHigh = 0, // Where each dot is travelling, keyed by its entity id -- the whole reason the dots carry one.
        // Kept per kind because a camper never becomes an attacker, and it saves storing the colour.
        this.memberTracks = new Map(), this.attackerTracks = new Map(), // The other PEOPLE in the camp. Glided like the rest -- they come off the same once-a-second
        // feed -- and kept apart from `members` so they can be drawn last, bigger and in their own
        // green. The viewer is never in here; the server leaves them out, and their own dot is
        // `playerDot`, repositioned every frame off the entity the client already tracks.
        this.partnerTracks = new Map(), // Strangers at the fire. Tracked exactly like everyone else (so their dot glides rather than
        // teleports between snapshots); what is different is only how it is drawn.
        this.visitorTracks = new Map(), // Strangers still on their way to it. A separate map rather than a flag on the visitor track,
        // so each kind is plotted by one `plot` call with its own treatment. The same id moves from one
        // map to the other when the recruit reaches the fire; its glide restarts there, which costs
        // nothing visible because by then it has stopped walking.
        this.approachingTracks = new Map(), // Free-running phase for the visitor pulse, so two of them beat together rather than each on
        // its own clock.
        this.visitorPulseMs = 0, // What the frame was last drawn for -- the room's extent AND the chosen size, since either one
        // changes the surface. Keyed so a steady stream of broadcasts doesn't redraw it.
        this.drawnExtent = "", this.drawnDiscoveryKey = "", // Whether the pointer currently has hold of the panel, and where it took hold: the panel's origin
        // MINUS the pointer, in PARENT coordinates. Fixed at pointerdown rather than recomputed per frame,
        // or a drag that ran into a screen edge and came back would leave the panel creeping out from
        // under the cursor.
        this.grabbed = false, this.grabDx = 0, this.grabDy = 0, // Make the whole panel a grab handle. Deliberately NO hitArea of its own: the frame graphic
        // already IS the panel's shape, and pixi skips a container's children entirely once the pointer
        // falls outside an explicit hitArea -- which would strand the size control in its hover state
        // whenever the pointer left the map in one jump.
        //
        // pointermove/pointerup are bound here rather than on some capture layer because pixi dispatches
        // both to every interactive object regardless of what was hit (moveWhenInside is off), so a drag
        // keeps its stream of moves even while the pointer is way off the panel -- which it will be the
        // moment the panel is dragged up against a screen edge.
        this.attachDrag = (drag)=>{
            this.drag = drag;
            this.interactive = true;
            this.cursor = "grab";
            this.on("pointerdown", this.onGrab);
            this.on("pointermove", this.onDragMove);
            this.on("pointerup", this.onRelease);
            this.on("pointerupoutside", this.onRelease);
        }, // A press on the panel takes hold of it -- unless it landed on the size control, the
        // only things up here that are not a grab handle. (pixi bubbles a child's pointerdown to its
        // parent, and `target` is the deepest INTERACTIVE object that was actually hit, so that is what
        // tells them apart.)
        this.onGrab = (event)=>{
            if (event.target !== this || !this.parent) return;
            const pointer = event.data.getLocalPosition(this.parent);
            this.grabDx = this.x - pointer.x;
            this.grabDy = this.y - pointer.y;
            this.grabbed = true;
            this.cursor = "grabbing";
            this.drag?.onGrab();
        }, this.onDragMove = (event)=>{
            if (!this.grabbed || !this.parent) return;
            const pointer = event.data.getLocalPosition(this.parent);
            this.drag?.onDragTo(pointer.x + this.grabDx, pointer.y + this.grabDy);
        }, this.onRelease = ()=>{
            if (!this.grabbed) return;
            this.grabbed = false;
            this.cursor = "grab";
            this.drag?.onRelease();
        }, // Keep the size control inside the map, clear of the screen edge.
        this.positionControls = ()=>{
            this.sizeButton.x = this.getWidth() - $27706b8361e494c8$var$CONTROL_RADIUS - 3;
            this.sizeButton.y = $27706b8361e494c8$var$CONTROL_RADIUS + 3;
        }, this.drawFrame = ()=>{
            this.frame.clear();
            this.frame.beginFill($27706b8361e494c8$var$PANEL_COLOR, $27706b8361e494c8$var$PANEL_ALPHA);
            this.frame.lineStyle(2, (0, $97475243e21a0995$export$cac838e5dd111a30), $27706b8361e494c8$var$BORDER_ALPHA);
            this.frame.drawRoundedRect(0, 0, this.mapW + $27706b8361e494c8$var$FRAME * 2, this.mapH + $27706b8361e494c8$var$FRAME * 2, $27706b8361e494c8$var$CORNER);
            this.frame.endFill();
            this.positionControls();
        }, this.drawPlayerDot = ()=>{
            this.playerDot.clear();
            this.playerDot.beginFill($27706b8361e494c8$var$PLAYER_COLOR, 1);
            this.playerDot.drawCircle(0, 0, $27706b8361e494c8$var$PLAYER_DOT_R);
            this.playerDot.endFill();
            this.playerDot.visible = false;
        }, // One cell-sized square per tree tile. Rects rather than circles because a forest is hundreds of
        // cells and a square is 2 triangles to a circle's dozens — and at ~3.5px a tile, a square IS the
        // honest shape for "this cell has canopy in it".
        this.drawTrees = ()=>{
            this.terrainDirty = true;
            this.trees.clear();
            if (this.treeCells.length < 1 || !(this.treeTilesWide > 0) || !(this.treeTilesHigh > 0)) return;
            const cellW = this.mapW / this.treeTilesWide;
            const cellH = this.mapH / this.treeTilesHigh;
            // Overdrawn by a hair so neighbouring cells of one canopy read as a clump, not a grid.
            const w = cellW + 0.5;
            const h = cellH + 0.5;
            this.trees.beginFill($27706b8361e494c8$var$TREE_COLOR, $27706b8361e494c8$var$TREE_ALPHA);
            for (const cell of this.treeCells)this.trees.drawRect($27706b8361e494c8$var$FRAME + cell.x * cellW, $27706b8361e494c8$var$FRAME + cell.y * cellH, w, h);
            this.trees.endFill();
        }, // Rasterize the world's existing polygon into a bounded, run-scoped discovery bitmap.
        // Four-pixel cells preserve wall edges without building occluders or casting more rays.
        this.updateSight = (roomId, polygon)=>{
            if (this.sightRoomId === roomId && this.sightPolygon === polygon) return;
            this.sightRoomId = roomId;
            this.sightPolygon = polygon;
            if (this.rememberSight()) this.drawSight();
        }, this.rememberSight = ()=>{
            if (this.state?.terrain !== "cave" || this.state.roomId !== this.sightRoomId || !this.discoveryKey || !this.sightPolygon?.length) return false;
            if (this.rememberedSightKey === this.discoveryKey && this.rememberedSightPolygon === this.sightPolygon) return false;
            this.rememberedSightKey = this.discoveryKey;
            this.rememberedSightPolygon = this.sightPolygon;
            const columns = Math.ceil(this.state.width / 4), rows = Math.ceil(this.state.height / 4);
            let seen = this.caveDiscovery.get(this.discoveryKey);
            if (!seen) {
                seen = {
                    columns: columns,
                    rows: rows,
                    bits: new Uint8Array(columns * rows)
                };
                this.caveDiscovery.set(this.discoveryKey, seen);
                if (this.caveDiscovery.size > 4) this.caveDiscovery.delete(this.caveDiscovery.keys().next().value);
            }
            let changed = false;
            const polygon = this.sightPolygon;
            const minY = Math.max(0, Math.floor(Math.min(...polygon.map((point)=>point.y)) / 4));
            const maxY = Math.min(rows - 1, Math.floor(Math.max(...polygon.map((point)=>point.y)) / 4));
            for(let y = minY; y <= maxY; y++){
                const py = y * 4 + 2, crossings = [];
                for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
                    const a = polygon[j], b = polygon[i];
                    if (a.y > py !== b.y > py) crossings.push(a.x + (py - a.y) * (b.x - a.x) / (b.y - a.y));
                }
                crossings.sort((a, b)=>a - b);
                for(let i = 0; i + 1 < crossings.length; i += 2){
                    const start = Math.max(0, Math.ceil((crossings[i] - 2) / 4));
                    const end = Math.min(columns, Math.ceil((crossings[i + 1] - 2) / 4));
                    for(let x = start; x < end; x++){
                        const index = y * columns + x;
                        if (!seen.bits[index]) {
                            seen.bits[index] = 1;
                            changed = true;
                        }
                    }
                }
            }
            return changed;
        }, this.drawSight = ()=>{
            this.sightMask.clear();
            this.caveContents.mask = this.state?.terrain === "cave" ? this.sightMask : null;
            const seen = this.caveDiscovery.get(this.discoveryKey);
            if (this.state?.terrain !== "cave" || !seen) return;
            const cellW = 4 * this.mapW / this.state.width, cellH = 4 * this.mapH / this.state.height;
            this.sightMask.beginFill(0xffffff);
            for(let y = 0; y < seen.rows; y++){
                let start = -1;
                for(let x = 0; x <= seen.columns; x++){
                    const known = x < seen.columns && seen.bits[y * seen.columns + x];
                    if (known && start < 0) start = x;
                    if (!known && start >= 0) {
                        this.sightMask.drawRect($27706b8361e494c8$var$FRAME + start * cellW, $27706b8361e494c8$var$FRAME + y * cellH, Math.min(this.mapW, x * cellW) - start * cellW, Math.min(cellH, this.mapH - y * cellH));
                        start = -1;
                    }
                }
            }
            this.sightMask.endFill();
        }, this.drawDiscovery = ()=>{
            this.terrainDirty = true;
            this.ground.clear();
            this.terrainMask.clear();
            // Legacy snapshots have no identity and keep their existing full forest treatment.
            this.terrainLayer.mask = this.state?.generationId && this.state.terrain !== "cave" ? this.terrainMask : null;
            // Pixi makes a detached mask renderable again. In caves this graphic is unused,
            // so leave it empty rather than painting the server's white discovery bitmap.
            if (this.state?.terrain === "cave") {
                this.ground.beginFill($27706b8361e494c8$var$GROUND_COLOR, $27706b8361e494c8$var$GROUND_ALPHA).drawRect($27706b8361e494c8$var$FRAME, $27706b8361e494c8$var$FRAME, this.mapW, this.mapH).endFill();
                return;
            }
            if (!this.discovery || !this.discoveryBits) return;
            const { columns: columns, rows: rows, cellTiles: cellTiles } = this.discovery;
            const cellW = this.mapW * cellTiles / this.tilesWide();
            const cellH = this.mapH * cellTiles / this.tilesHigh();
            this.terrainMask.beginFill(0xffffff);
            // Merge each row into runs. Circular reveal stamps make a walked frontier; tiny rounded
            // corners soften its coarse cells without filters, textures or per-frame terrain rebuilds.
            for(let y = 0; y < rows; y++){
                let start = -1;
                for(let x = 0; x <= columns; x++){
                    const index = y * columns + x;
                    const known = x < columns && !!(this.discoveryBits[index >> 3] & 1 << (index & 7));
                    if (known && start < 0) start = x;
                    if (!known && start >= 0) {
                        const left = start * cellW, top = y * cellH;
                        const width = Math.min(this.mapW, x * cellW) - left;
                        const height = Math.min(cellH, this.mapH - top);
                        this.terrainMask.drawRoundedRect($27706b8361e494c8$var$FRAME + left, $27706b8361e494c8$var$FRAME + top, width, height, 0.6);
                        start = -1;
                    }
                }
            }
            this.terrainMask.endFill();
            this.ground.beginFill($27706b8361e494c8$var$GROUND_COLOR, $27706b8361e494c8$var$GROUND_ALPHA).drawRect($27706b8361e494c8$var$FRAME, $27706b8361e494c8$var$FRAME, this.mapW, this.mapH).endFill();
        }, this.drawRockAndStructures = ()=>{
            this.terrainDirty = true;
            this.rocks.clear();
            if (!(this.treeTilesWide > 0) || !(this.treeTilesHigh > 0)) return;
            const cellW = this.mapW / this.treeTilesWide, cellH = this.mapH / this.treeTilesHigh;
            const paint = (cells, color, alpha)=>{
                this.rocks.beginFill(color, alpha);
                cells.forEach((cell)=>this.rocks.drawRect($27706b8361e494c8$var$FRAME + cell.x * cellW, $27706b8361e494c8$var$FRAME + cell.y * cellH, cellW + 0.25, cellH + 0.25));
                this.rocks.endFill();
            };
            if (this.state?.terrain === "cave") {
                paint(this.terrainCells.rocks, $27706b8361e494c8$var$ROCK_COLOR, 0.75);
                paint(this.terrainCells.ore, $27706b8361e494c8$var$ORE_COLOR, 0.8);
            }
            paint(this.terrainCells.water ?? [], $27706b8361e494c8$var$WATER_COLOR, $27706b8361e494c8$var$WATER_ALPHA);
            paint(this.terrainCells.structures, 0xc5bba1, 0.8);
        }, this.plot = (tracks, color, radius = $27706b8361e494c8$var$DOT_R, alpha = 1)=>{
            if (tracks.size < 1) return;
            this.dots.beginFill(color, alpha);
            tracks.forEach((track)=>{
                const p = $27706b8361e494c8$export$7d8c499170a003eb($27706b8361e494c8$export$f2723e5f32c829e9(track), this.state, this.mapW, this.mapH);
                this.dots.drawCircle($27706b8361e494c8$var$FRAME + p.x, $27706b8361e494c8$var$FRAME + p.y, radius);
            });
            this.dots.endFill();
        }, this.drawDots = ()=>{
            this.dots.clear();
            this.rescueLabel.visible = !!this.state?.rescue;
            this.bonecallerLabel.visible = !!this.state?.bonecaller;
            this.mineLabel.visible = !!this.state?.mine;
            if (!this.state) return;
            // Attackers last so an attacker standing on a defender still reads as the threat -- but
            // partners after even them: a person is never the thing you want hidden under a dot, and an
            // attacker ON a partner is read off the red crowding them rather than off the green going
            // missing.
            this.plot(this.memberTracks, $27706b8361e494c8$var$MEMBER_COLOR);
            this.plot(this.attackerTracks, $27706b8361e494c8$var$ATTACKER_COLOR);
            // Under the people: somebody walking in is news, but it is not yet a question, and it
            // crosses open ground where there is nothing to be hidden under anyway.
            this.plot(this.approachingTracks, $27706b8361e494c8$var$VISITOR_COLOR, $27706b8361e494c8$var$DOT_R, $27706b8361e494c8$var$APPROACHING_ALPHA);
            this.plot(this.partnerTracks, $27706b8361e494c8$var$PARTNER_COLOR, $27706b8361e494c8$var$PLAYER_DOT_R);
            // Over everything, including a partner: a visitor is the one dot on this map that is a
            // question being asked of the player, and a question must never be the thing hidden under
            // somebody walking past it.
            if (this.visitorTracks.size > 0) {
                // 0 -> 1 -> 0 over the period, as one shared phase so two visitors beat together.
                const beat = 0.5 - 0.5 * Math.cos(this.visitorPulseMs / $27706b8361e494c8$var$VISITOR_PULSE_MS * Math.PI * 2);
                this.plot(this.visitorTracks, $27706b8361e494c8$var$VISITOR_COLOR, $27706b8361e494c8$var$DOT_R * (1 + $27706b8361e494c8$var$VISITOR_PULSE_GROW * beat), 0.72 + 0.28 * beat);
            }
            const rescue = this.state.rescue;
            if (rescue) {
                this.plot(this.rescueTracks, rescue.state === "In danger" ? $27706b8361e494c8$var$ATTACKER_COLOR : $27706b8361e494c8$var$VISITOR_COLOR, $27706b8361e494c8$var$DOT_R + 2);
                const p = $27706b8361e494c8$export$7d8c499170a003eb(rescue, this.state, this.mapW, this.mapH);
                this.rescueLabel.text = rescue.state === "Waiting" ? "survivor" : rescue.state;
                this.rescueLabel.x = Math.max($27706b8361e494c8$var$FRAME, Math.min($27706b8361e494c8$var$FRAME + p.x + 5, this.mapW - this.rescueLabel.width));
                this.rescueLabel.y = $27706b8361e494c8$var$FRAME + p.y - 14;
            }
            const mine = this.state.mine;
            if (mine) {
                const p = $27706b8361e494c8$export$7d8c499170a003eb(mine, this.state, this.mapW, this.mapH);
                const x = $27706b8361e494c8$var$FRAME + p.x, y = $27706b8361e494c8$var$FRAME + p.y;
                this.dots.lineStyle(1.5, 0xf0cc83).moveTo(x - 4, y + 3).lineTo(x - 4, y).lineTo(x, y - 4).lineTo(x + 4, y).lineTo(x + 4, y + 3);
                this.dots.lineStyle(0);
                this.mineLabel.x = Math.max($27706b8361e494c8$var$FRAME, Math.min(x + 6, this.mapW - this.mineLabel.width));
                this.mineLabel.y = Math.max($27706b8361e494c8$var$FRAME, y - 15);
            }
            const ritual = this.state.bonecaller;
            if (ritual) {
                const p = $27706b8361e494c8$export$7d8c499170a003eb(ritual, this.state, this.mapW, this.mapH);
                const x = $27706b8361e494c8$var$FRAME + p.x, y = $27706b8361e494c8$var$FRAME + p.y;
                const active = ritual.state === "active";
                const beat = 0.5 - 0.5 * Math.cos(this.visitorPulseMs / $27706b8361e494c8$var$VISITOR_PULSE_MS * Math.PI * 2);
                const radius = active ? 4 + beat * 1.5 : 3;
                this.dots.lineStyle(1.5, active ? 0xd981ff : 0x9b8aa4, active ? 0.7 + 0.3 * beat : 0.7).moveTo(x, y - radius).lineTo(x + radius, y).lineTo(x, y + radius).lineTo(x - radius, y).lineTo(x, y - radius);
                this.dots.lineStyle(0);
                if (active) for(let stone = 0; stone < 3; stone++)this.dots.beginFill(stone < ritual.stage ? 0xd981ff : 0x62596a).drawCircle(x + (stone - 1) * 4, y + 9, 1.5).endFill();
                this.bonecallerLabel.text = active ? "ritual: wave 8" : ritual.state === "interrupted" ? "ritual stopped" : "dead risen";
                this.bonecallerLabel.x = Math.max($27706b8361e494c8$var$FRAME, Math.min(x + 6, this.mapW - this.bonecallerLabel.width));
                this.bonecallerLabel.y = Math.max($27706b8361e494c8$var$FRAME, y - 15);
            }
        }, this.drawVoidRooms = ()=>{
            this.voidRooms.clear();
            if (this.state?.terrain !== "cave" || !(this.state.width > 0) || !(this.state.height > 0)) return;
            const scaleX = this.mapW / this.state.width, scaleY = this.mapH / this.state.height;
            this.voidRooms.lineStyle(1, 0xff3333, 1).beginFill(0xff3333, 0.5);
            for (const room of this.state.voidRooms || [])this.voidRooms.drawRect($27706b8361e494c8$var$FRAME + room.x * scaleX, $27706b8361e494c8$var$FRAME + room.y * scaleY, room.width * scaleX, room.height * scaleY);
            this.voidRooms.endFill();
        }, // Fold one snapshot's dots into their tracks: a dot seen before is re-aimed FROM wherever it has
        // glided to so far (never from its last reported position, which would snap it back), a dot seen
        // for the first time simply appears where it is, and a dot that has gone is dropped.
        this.syncTracks = (tracks, dots)=>{
            const present = new Set();
            for (const dot of dots || []){
                if (!dot || dot.id === undefined) continue;
                present.add(dot.id);
                const track = tracks.get(dot.id);
                if (!track) {
                    tracks.set(dot.id, {
                        fromX: dot.x,
                        fromY: dot.y,
                        toX: dot.x,
                        toY: dot.y,
                        t: $27706b8361e494c8$export$a6ce970ca4241c6a
                    });
                    continue;
                }
                if (track.toX === dot.x && track.toY === dot.y) continue;
                const at = $27706b8361e494c8$export$f2723e5f32c829e9(track);
                track.fromX = at.x;
                track.fromY = at.y;
                track.toX = dot.x;
                track.toY = dot.y;
                track.t = 0;
            }
            for (const id of Array.from(tracks.keys()))if (!present.has(id)) tracks.delete(id);
        }, // Advance every glide by a frame, and repaint the dots only if any of them actually moved. A camp
        // standing still costs nothing.
        this.animate = (dtMs)=>{
            if (!this.state) return;
            let moved = false;
            const advance = (tracks)=>tracks.forEach((track)=>{
                    if (track.t < $27706b8361e494c8$export$a6ce970ca4241c6a) {
                        track.t = Math.min($27706b8361e494c8$export$a6ce970ca4241c6a, track.t + dtMs);
                        moved = true;
                    }
                });
            advance(this.memberTracks);
            advance(this.attackerTracks);
            advance(this.partnerTracks);
            advance(this.visitorTracks);
            advance(this.approachingTracks);
            advance(this.rescueTracks);
            // A visitor's dot breathes whether or not anybody moved, so its presence is what makes this
            // map repaint every frame. That is the only case: with nobody at the fire -- which is the
            // camp almost all of the time -- a still camp still costs nothing.
            if (this.visitorTracks.size > 0 || this.state.bonecaller?.state === "active") {
                this.visitorPulseMs = (this.visitorPulseMs + dtMs) % $27706b8361e494c8$var$VISITOR_PULSE_MS;
                moved = true;
            }
            if (moved) this.drawDots();
        }, // What the drawn surface depends on: the room's shape and the chosen size. Compared against
        // `drawnExtent` so a snapshot a second does no geometry work, while a resize or a new room does.
        this.surfaceKey = ()=>this.state ? `${this.state.width}x${this.state.height}@${this.size}` : `@${this.size}`, // Re-measure the surface and repaint everything laid out in its pixels. Called on a new room
        // shape and on a resize -- the two things that move every pixel on this panel.
        this.applySurface = ()=>{
            const surface = $27706b8361e494c8$export$750bcf04cfea520e(this.state ?? {
                width: 0,
                height: 0
            }, $27706b8361e494c8$export$bd0af544843e4d09[this.size]);
            this.mapW = surface.w;
            this.mapH = surface.h;
            this.drawnExtent = this.surfaceKey();
            this.drawnDiscoveryKey = this.discoveryKey;
            this.drawFrame();
            // Both of these are laid out in the surface's px, so they have to follow it. (The player's own
            // dot needs no repaint -- it is a fixed circle that trackPlayer re-positions every frame.)
            this.drawDiscovery();
            this.drawSight();
            this.drawTrees();
            this.drawRockAndStructures();
            this.drawDots();
            this.drawVoidRooms();
        }, // Step to the next size and tell the owner, which is what remembers the choice and re-clamps the
        // panel -- it has just changed size, so the spot it was parked in may no longer hold it.
        this.cycleSize = ()=>{
            this.setSize($27706b8361e494c8$export$ae98601b622c352d(this.size));
            this.onSizeChange?.(this.size);
        }, // Put the map at a given size. GuiManager calls this once at startup with the remembered choice,
        // and the corner control calls it through cycleSize.
        this.setSize = (size)=>{
            if (size === this.size) return;
            this.size = size;
            this.applySurface();
        }, // Take the latest snapshot (null clears the map, e.g. on leaving the room).
        this.update = (state)=>{
            const key = state?.generationId ? `${state.roomId}:${state.runId}:${state.generationId}` : "";
            if (state?.roomId && this.expectedRoomId && state.roomId !== this.expectedRoomId) {
                // A new-room feed may precede the room packet. Keep its discovery, but never draw it
                // using the old room's terrain. The next feed can restore it even without a bitmap.
                if (key && state.exploration && $27706b8361e494c8$export$4023aa562dd89cda(state.exploration, Math.round(state.width / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.round(state.height / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)))) {
                    this.discoveryCache.delete(key);
                    this.discoveryCache.set(key, state.exploration);
                    if (this.discoveryCache.size > 4) this.discoveryCache.delete(this.discoveryCache.keys().next().value);
                }
                return;
            }
            if (key !== this.discoveryKey) {
                this.discoveryKey = key;
                this.discovery = key ? this.discoveryCache.get(key) || null : null;
                this.discoveryBits = null;
                this.treeCells = [];
                this.terrainCells = {
                    trees: [],
                    rocks: [],
                    ore: [],
                    structures: [],
                    water: []
                };
                this.memberTracks.clear();
                this.attackerTracks.clear();
                this.partnerTracks.clear();
                this.visitorTracks.clear();
                this.approachingTracks.clear();
                this.rescueTracks.clear();
                this.playerDot.visible = false;
            }
            const previousDiscovery = this.discovery;
            this.state = state;
            this.drawVoidRooms();
            this.rememberSight();
            this.drawSight();
            if (!state) {
                this.dots.clear();
                this.trees.clear();
                this.rocks.clear();
                this.ground.clear();
                this.terrainMask.clear();
                this.terrainDirty = true;
                this.discovery = null;
                this.discoveryBits = null;
                this.terrainCells = {
                    trees: [],
                    rocks: [],
                    ore: [],
                    structures: [],
                    water: []
                };
                this.treeCells = [];
                this.treeTilesWide = 0;
                this.treeTilesHigh = 0;
                this.memberTracks.clear();
                this.attackerTracks.clear();
                this.partnerTracks.clear();
                this.visitorTracks.clear();
                this.approachingTracks.clear();
                this.rescueTracks.clear();
                this.rescueLabel.visible = false;
                this.bonecallerLabel.visible = false;
                this.mineLabel.visible = false;
                this.playerDot.visible = false;
                return;
            }
            if (state.exploration && (!this.discovery || state.exploration.revision >= this.discovery.revision)) {
                const bits = $27706b8361e494c8$export$4023aa562dd89cda(state.exploration, this.tilesWide(), this.tilesHigh());
                if (bits) {
                    this.discovery = state.exploration;
                    this.discoveryBits = bits;
                    if (key) {
                        this.discoveryCache.delete(key);
                        this.discoveryCache.set(key, state.exploration);
                        if (this.discoveryCache.size > 4) this.discoveryCache.delete(this.discoveryCache.keys().next().value);
                    }
                }
            }
            if (this.discovery && !this.discoveryBits) this.discoveryBits = $27706b8361e494c8$export$4023aa562dd89cda(this.discovery, this.tilesWide(), this.tilesHigh());
            if (key !== "" && (!previousDiscovery || this.discovery !== previousDiscovery)) this.drawDiscovery();
            if (this.surfaceKey() !== this.drawnExtent || key !== this.drawnDiscoveryKey) this.applySurface();
            this.syncTracks(this.memberTracks, state.members);
            this.syncTracks(this.attackerTracks, state.attackers);
            // Absent on an older server's snapshot; syncTracks reads a missing list as an empty one,
            // which correctly empties the partner tracks rather than freezing the last dots in place.
            this.syncTracks(this.partnerTracks, state.players);
            // Missing from an older server's snapshot; an absent list is an empty one, which correctly
            // empties the tracks rather than leaving a gold dot pulsing over nobody.
            this.syncTracks(this.visitorTracks, state.visitors);
            this.syncTracks(this.approachingTracks, state.approaching);
            this.syncTracks(this.rescueTracks, state.rescue ? [
                state.rescue
            ] : []);
            this.drawDots();
        }, this.selectRoom = (roomId)=>{
            this.expectedRoomId = roomId;
            this.update(null);
        }, // Replace the forest. `cells` are TILE coordinates in a room `tilesWide` x `tilesHigh` tiles; the
        // caller (GuiManager) scans them off the client's own tile map and only when it has changed.
        this.updateTrees = (cells, tilesWide, tilesHigh)=>{
            this.treeCells = cells || [];
            this.treeTilesWide = tilesWide;
            this.treeTilesHigh = tilesHigh;
            this.drawTrees();
        }, this.updateTerrain = (cells, tilesWide, tilesHigh)=>{
            this.terrainCells = cells;
            this.updateTrees(cells.trees, tilesWide, tilesHigh);
            this.drawRockAndStructures();
        }, // Move the player's own dot. Called every frame with the client's live player location, which is
        // predicted locally and so smoother than anything the broadcast could carry.
        this.trackPlayer = (location)=>{
            if (!this.state || !location) {
                this.playerDot.visible = false;
                return;
            }
            const p = $27706b8361e494c8$export$7d8c499170a003eb(location, this.state, this.mapW, this.mapH);
            this.playerDot.position.set($27706b8361e494c8$var$FRAME + p.x, $27706b8361e494c8$var$FRAME + p.y);
            this.playerDot.visible = true;
        }, // Whether there is a room to draw at all -- GuiManager keeps the widget off screen until the
        // first broadcast arrives, and takes it down again on leaving the room.
        this.hasData = ()=>!!this.state, // The room's extent in TILES, for the caller's tree scan. Zero until the first broadcast.
        this.tilesWide = ()=>this.state ? Math.round(this.state.width / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) : 0, this.tilesHigh = ()=>this.state ? Math.round(this.state.height / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) : 0, // Outer frame dimensions, for positioning against the rest of the HUD.
        this.getWidth = ()=>this.mapW + $27706b8361e494c8$var$FRAME * 2, this.getHeight = ()=>this.mapH + $27706b8361e494c8$var$FRAME * 2, this.getDefaultHeight = ()=>$27706b8361e494c8$export$750bcf04cfea520e(this.state ?? {
                width: 0,
                height: 0
            }, $27706b8361e494c8$export$bd0af544843e4d09[$27706b8361e494c8$export$b224d4b6baa336d9]).h + $27706b8361e494c8$var$FRAME * 2, // Test seam: the corner control that steps the map through its sizes.
        this.sizeControl = ()=>this.sizeButton, // The size the map is currently at.
        this.currentSize = ()=>this.size, // Test seam: whether the pointer currently has hold of the panel.
        this.isGrabbed = ()=>this.grabbed, // Test seams: what the map is currently showing.
        this.memberCount = ()=>this.memberTracks.size, this.attackerCount = ()=>this.attackerTracks.size, this.visitorCount = ()=>this.visitorTracks.size, this.approachingCount = ()=>this.approachingTracks.size, // Where a dot is being drawn right now, in ROOM (fine) coordinates -- i.e. part-way through its
        // glide, not where the last snapshot put it.
        this.dotPosition = (id)=>{
            const track = this.memberTracks.get(id) || this.attackerTracks.get(id) || this.partnerTracks.get(id) || this.visitorTracks.get(id) || this.approachingTracks.get(id);
            return track ? $27706b8361e494c8$export$f2723e5f32c829e9(track) : null;
        }, this.treeCount = ()=>this.treeCells.length, this.isTerrainRevealed = (x, y)=>{
            if (this.state?.terrain === "cave") {
                const seen = this.caveDiscovery.get(this.discoveryKey);
                if (!seen || x < 0 || y < 0 || x >= this.tilesWide() || y >= this.tilesHigh()) return false;
                return !!seen.bits[Math.floor((y + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 4) * seen.columns + Math.floor((x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 4)];
            }
            if (!this.state?.generationId) return true;
            if (!this.discovery || !this.discoveryBits || x < 0 || y < 0 || x >= this.tilesWide() || y >= this.tilesHigh()) return false;
            const index = Math.floor(y / this.discovery.cellTiles) * this.discovery.columns + Math.floor(x / this.discovery.cellTiles);
            return !!(this.discoveryBits[index >> 3] & 1 << (index & 7));
        }, this.isTrackingPlayer = ()=>this.playerDot.visible, this.playerDotPosition = ()=>({
                x: this.playerDot.x,
                y: this.playerDot.y
            });
        this.onSizeChange = onSizeChange;
        this.terrainLayer.addChild(this.ground, this.trees, this.rocks);
        this.terrainHolder.addChild(this.terrainLayer, this.terrainMask);
        this.caveContents.addChild(this.terrainHolder, this.dots, this.playerDot, this.rescueLabel, this.bonecallerLabel, this.mineLabel);
        this.addChild(this.frame, this.caveContents, this.sightMask, this.voidRooms);
        this.sizeButton = new (0, $f42064c8e11476cf$export$965a4009231121c2)({
            radius: $27706b8361e494c8$var$CONTROL_RADIUS,
            onClick: this.cycleSize
        });
        this.addChild(this.sizeButton);
        this.drawPlayerDot();
        this.drawFrame();
        this.attachDrag(drag);
        this.visible = false;
    }
}



class $4a2d6e0f8539e4d1$export$3adb491320ceffcc extends (0, $b63697c140e90637$export$81c7dcc65e224ff6) {
    constructor(onClick){
        super({
            glyph: "\uD83C\uDF92",
            label: "ITEMS",
            onClick: onClick,
            toggle: true
        });
    }
}



class $d36eec2a890b47fd$export$155d6b3ee6ea424d extends (0, $b63697c140e90637$export$81c7dcc65e224ff6) {
    constructor(onClick){
        super({
            glyph: "\uD83D\uDDFA",
            label: "MAP",
            onClick: onClick,
            toggle: true
        });
    }
}



var $1avo5 = parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $9Pi8W = parcelRequire("9Pi8W");




const $76215559f193965e$export$76042a63517f7a34 = 0.3;
const $76215559f193965e$export$fbeac00649894f55 = 0.7;
const $76215559f193965e$var$PLATE_H = 22;
const $76215559f193965e$var$PLATE_RADIUS = 5;
const $76215559f193965e$var$PLATE_PAD_X = 7;
const $76215559f193965e$var$SHADOW_DROP = 1;
const $76215559f193965e$var$GROOVE_H = 7;
const $76215559f193965e$var$GROOVE_RADIUS = 3.5;
// Room kept at the right for the band word. Measured, not guessed: "LOW" and "OUT" are 22 and 20
// wide at this size, and the space is RESERVED even while empty so the bar is the same length in
// every state -- a gauge whose bar grows as the fire improves would be reading two things at once.
const $76215559f193965e$var$LABEL_RESERVE = 28;
// Light enough to read off the timber plate. The bar carries the dying colour; the word only has to
// be legible, and a word tinted the same near-black as an empty fire cannot be read at all.
const $76215559f193965e$var$LABEL_COLOR = 0xff9d8a;
// Ember gold while it is healing, amber while it is merely holding, and a dying red below the drain
// line. Green-free, like the countdown dial's: this is a fire, and a fire has no green in it.
const $76215559f193965e$var$STRONG_COLOR = (0, $658a44ce960354bb$export$319b6132a2fafb7c);
const $76215559f193965e$var$STEADY_COLOR = 0xff9d2e;
const $76215559f193965e$var$LOW_COLOR = 0xe8542d;
const $76215559f193965e$var$OUT_COLOR = 0x8c2f1d;
// How long the bar takes to reach a new reading -- a DURATION, not a rate. A rate (full sweep in
// 420ms) made every small change finish in under a tenth of a second, so the one thing the fire
// actually does -- tick quietly down -- snapped instead of moving. Each reading now takes the same
// beat to arrive however far it has to go, which is what makes a log landing something you SEE.
const $76215559f193965e$var$FILL_MS = 520;
// The flame's own clock. It burns whatever the fire is doing: a gauge whose only moving part moves
// solely when you are already in trouble is a gauge nobody looks at the rest of the time.
//
// SLOW, and much slower than the first attempt. At 190ms and 437ms (5Hz against 2Hz) the glyph
// vibrated -- it read as a fault in the UI rather than as a flame. A real flame DRIFTS, with the
// occasional lick: the periods below are near two seconds, far apart and in no simple ratio, so the
// two never line up and the loop never becomes visible. Amplitudes are under a pixel on purpose;
// this is a 10px glyph and anything you can measure by eye on it is a twitch.
const $76215559f193965e$var$FLICKER_DRIFT_MS = 2100;
const $76215559f193965e$var$FLICKER_LICK_MS = 1300;
// The breath below the drain line. Slow -- this is a worry, not an alarm; the roster has the alarm.
const $76215559f193965e$var$BREATH_MS = 1400;
// An empty hearth gets an occasional short rattle, with enough quiet between shakes to read clearly.
const $76215559f193965e$var$OUT_SHAKE_PERIOD_MS = 2400;
const $76215559f193965e$var$OUT_SHAKE_DURATION_MS = 320;
const $76215559f193965e$var$OUT_SHAKE_AMPLITUDE = 4;
const $76215559f193965e$var$OUT_TRAIL_INTERVAL_MS = 40;
const $76215559f193965e$var$OUT_TRAIL_LIFETIME_MS = 260;
const $76215559f193965e$var$WHITE_TRAIL_FILTER = new (0, $1avo5.filters).ColorMatrixFilter();
$76215559f193965e$var$WHITE_TRAIL_FILTER.matrix = [
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0
];
const $76215559f193965e$export$e771200109d9772 = (strength)=>{
    if (!(strength > 0)) return "out";
    if (strength < $76215559f193965e$export$76042a63517f7a34) return "low";
    return strength < $76215559f193965e$export$fbeac00649894f55 ? "steady" : "strong";
};
const $76215559f193965e$export$b128223173870ea3 = (band)=>band === "out" ? "OUT" : band === "low" ? "LOW" : "";
const $76215559f193965e$export$f087c488d44b08c3 = (strength)=>{
    if (!(strength > 0)) return $76215559f193965e$var$OUT_COLOR;
    if (strength < $76215559f193965e$export$76042a63517f7a34) return (0, $7f40928dcf527a2e$export$5931e35698b46017)($76215559f193965e$var$OUT_COLOR, $76215559f193965e$var$LOW_COLOR, strength / $76215559f193965e$export$76042a63517f7a34);
    if (strength < $76215559f193965e$export$fbeac00649894f55) return (0, $7f40928dcf527a2e$export$5931e35698b46017)($76215559f193965e$var$LOW_COLOR, $76215559f193965e$var$STEADY_COLOR, (strength - $76215559f193965e$export$76042a63517f7a34) / ($76215559f193965e$export$fbeac00649894f55 - $76215559f193965e$export$76042a63517f7a34));
    return (0, $7f40928dcf527a2e$export$5931e35698b46017)($76215559f193965e$var$STEADY_COLOR, $76215559f193965e$var$STRONG_COLOR, (strength - $76215559f193965e$export$fbeac00649894f55) / (1 - $76215559f193965e$export$fbeac00649894f55));
};
class $76215559f193965e$export$1ef3fa7c24f5e1bd extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.trailLayer = new (0, $8t5Gy.Container)(), this.contents = new (0, $8t5Gy.Container)(), this.plate = new (0, $gwPoJ.Graphics)(), this.bar = new (0, $gwPoJ.Graphics)(), this.flame = new (0, $gwPoJ.Graphics)(), this.width_ = 118, // The bar's travel: where it set off from, where it is going, and how far through it is.
        this.shown = 0, this.from = 0, this.target = 0, this.travelMs = $76215559f193965e$var$FILL_MS, this.strength = 0, this.breathMs = 0, this.flickerMs = 0, this.outShakeMs = 0, this.outTrailMs = 0, this.trails = [], this.needsDraw = true, /** Match the dial above, so the top-left column reads as one stack rather than two widgets. */ this.setWidth = (width)=>{
            if (this.width_ === width) return;
            this.width_ = width;
            this.needsDraw = true;
        }, /**
     * The camp's fire, 0..1, or undefined when there is no camp to report one (every room that is
     * not an ember camp, and any roster packet that predates the field).
     */ this.update = (strength)=>{
            const known = Number.isFinite(strength);
            if (!known) {
                if (this.visible) this.visible = false;
                this.outShakeMs = 0;
                this.outTrailMs = 0;
                this.contents.x = 0;
                this.clearTrails();
                return;
            }
            const next = Math.max(0, Math.min(1, strength));
            const wasOut = $76215559f193965e$export$e771200109d9772(this.strength) === "out";
            const willBeOut = $76215559f193965e$export$e771200109d9772(next) === "out";
            if (willBeOut && !wasOut) {
                this.outShakeMs = 0;
                this.outTrailMs = 0;
            } else if (!willBeOut) {
                this.outShakeMs = 0;
                this.outTrailMs = 0;
                this.contents.x = 0;
            }
            this.visible = true;
            if (next === this.strength) return;
            this.strength = next;
            // Set off from wherever the bar actually IS, not from the last reading: a second change
            // arriving mid-travel would otherwise jump back to the start of the first one.
            this.from = this.shown;
            this.target = next;
            this.travelMs = 0;
            this.needsDraw = true;
        }, /** Advance one frame. Does nothing on a gauge that is settled and out of the worry band. */ this.animate = (deltaMs)=>{
            if (!this.visible) return;
            // The flame burns every frame, at every strength. It repaints ONLY itself (see drawFlame),
            // so the plate and the bar underneath are still only redrawn when they actually change.
            this.flickerMs += deltaMs;
            this.drawFlame();
            this.animateOutShake(deltaMs);
            this.updateTrails(deltaMs);
            let moving = false;
            if (this.travelMs < $76215559f193965e$var$FILL_MS) {
                this.travelMs = Math.min($76215559f193965e$var$FILL_MS, this.travelMs + deltaMs);
                // Eased over a fixed duration, and LANDED exactly at the end rather than approached --
                // a bar forever 2% short is the same lie the hearts would have told (gui/icon_meter.ts).
                const t = this.travelMs / $76215559f193965e$var$FILL_MS;
                this.shown = this.travelMs >= $76215559f193965e$var$FILL_MS ? this.target : this.from + (this.target - this.from) * (1 - Math.pow(1 - t, 3));
                moving = true;
            }
            if (this.strength < $76215559f193965e$export$76042a63517f7a34) {
                this.breathMs = (this.breathMs + deltaMs) % $76215559f193965e$var$BREATH_MS;
                moving = true;
            } else if (this.breathMs !== 0) {
                this.breathMs = 0;
                moving = true;
            }
            if (!moving && !this.needsDraw) return;
            this.needsDraw = false;
            this.redraw();
        }, /** Test seam: the fill the bar is SHOWING, which lags the reading while it travels. */ this.shownFill = ()=>this.shown, this.animateOutShake = (deltaMs)=>{
            if ($76215559f193965e$export$e771200109d9772(this.strength) !== "out") {
                this.outShakeMs = 0;
                this.outTrailMs = 0;
                this.contents.x = 0;
                return;
            }
            this.outShakeMs = (this.outShakeMs + deltaMs) % $76215559f193965e$var$OUT_SHAKE_PERIOD_MS;
            // Offset the phase so the first shake follows a quiet interval after entering "out".
            const shakePhase = (this.outShakeMs + $76215559f193965e$var$OUT_SHAKE_DURATION_MS) % $76215559f193965e$var$OUT_SHAKE_PERIOD_MS;
            if (shakePhase >= $76215559f193965e$var$OUT_SHAKE_DURATION_MS) {
                this.outTrailMs = 0;
                this.contents.x = 0;
                return;
            }
            const progress = shakePhase / $76215559f193965e$var$OUT_SHAKE_DURATION_MS;
            const cycle = progress * Math.PI * 6;
            this.contents.x = Math.sin(cycle) * $76215559f193965e$var$OUT_SHAKE_AMPLITUDE * (1 - progress);
            this.outTrailMs += deltaMs;
            if (this.outTrailMs >= $76215559f193965e$var$OUT_TRAIL_INTERVAL_MS) {
                this.outTrailMs %= $76215559f193965e$var$OUT_TRAIL_INTERVAL_MS;
                this.addTrail(Math.sign(Math.cos(cycle)));
            }
        }, this.addTrail = (direction)=>{
            const trail = new (0, $8t5Gy.Container)();
            // Place the afterimage behind the current motion so it reads as a streak, not a duplicate.
            trail.x = this.contents.x - direction * 5;
            trail.alpha = 0.48;
            trail.filters = [
                $76215559f193965e$var$WHITE_TRAIL_FILTER
            ];
            trail.addChild(this.plate.clone(), this.bar.clone(), this.flame.clone());
            const text = new (0, $9Pi8W.Text)(this.bandText.text, this.bandText.style);
            text.anchor.copyFrom(this.bandText.anchor);
            text.position.copyFrom(this.bandText.position);
            text.tint = this.bandText.tint;
            text.visible = this.bandText.visible;
            trail.addChild(text);
            this.trailLayer.addChild(trail);
            this.trails.push({
                container: trail,
                ageMs: 0
            });
        }, this.updateTrails = (deltaMs)=>{
            for(let i = this.trails.length - 1; i >= 0; i--){
                const trail = this.trails[i];
                trail.ageMs += deltaMs;
                if (trail.ageMs >= $76215559f193965e$var$OUT_TRAIL_LIFETIME_MS) {
                    this.trailLayer.removeChild(trail.container);
                    trail.container.destroy({
                        children: true
                    });
                    this.trails.splice(i, 1);
                    continue;
                }
                trail.container.alpha = 0.48 * (1 - trail.ageMs / $76215559f193965e$var$OUT_TRAIL_LIFETIME_MS);
            }
        }, this.clearTrails = ()=>{
            for (const trail of this.trails){
                this.trailLayer.removeChild(trail.container);
                trail.container.destroy({
                    children: true
                });
            }
            this.trails = [];
        }, this.redraw = ()=>{
            const band = $76215559f193965e$export$e771200109d9772(this.strength);
            const color = $76215559f193965e$export$f087c488d44b08c3(this.strength);
            // Below the drain line the whole plate breathes. Above it, nothing moves.
            const breath = band === "low" || band === "out" ? 0.5 + 0.5 * Math.sin(this.breathMs / $76215559f193965e$var$BREATH_MS * Math.PI * 2) : 0;
            this.drawPlate();
            this.drawBar(color, breath);
            const label = $76215559f193965e$export$b128223173870ea3(band);
            this.bandText.visible = label.length > 0;
            if (this.bandText.text !== label) this.bandText.text = label;
            this.bandText.tint = $76215559f193965e$var$LABEL_COLOR;
            this.bandText.position.set(this.width_ - $76215559f193965e$var$PLATE_PAD_X, 0);
        }, this.drawPlate = ()=>{
            const top = -$76215559f193965e$var$PLATE_H / 2;
            this.plate.clear();
            this.plate.beginFill(0x000000, 0.34);
            this.plate.drawRoundedRect(0, top + $76215559f193965e$var$SHADOW_DROP, this.width_, $76215559f193965e$var$PLATE_H, $76215559f193965e$var$PLATE_RADIUS);
            this.plate.endFill();
            this.plate.lineStyle({
                width: 1,
                color: (0, $658a44ce960354bb$export$dd27ce85ad53c944),
                alpha: 0.45
            });
            this.plate.beginFill((0, $658a44ce960354bb$export$611f5967b7e8b685), 0.96);
            this.plate.drawRoundedRect(0, top, this.width_, $76215559f193965e$var$PLATE_H, $76215559f193965e$var$PLATE_RADIUS);
            this.plate.endFill();
            this.plate.lineStyle(0);
        }, /**
     * The flame on the left, which DANCES -- every frame, at every strength.
     *
     * It is the plate's one moving part and the only thing on it that says "fire" without spending
     * any of a 118px row on the word. A still flame reads as an icon; a moving one reads as the
     * thing itself, and it is what makes the gauge worth glancing at while the fire is fine.
     *
     * Two frequencies that do not divide into each other drive three separate things -- height, the
     * lean of the tip, and the hot heart -- so no two of them peak together and the loop never
     * becomes visible. The amplitude rides on STRENGTH: a strong fire leaps, a dying one gutters,
     * which is a second reading of the gauge for anyone not looking directly at the bar.
     *
     * Repaints only its own Graphics, so running every frame leaves the plate and bar alone.
     */ this.drawFlame = ()=>{
            const drift = Math.sin(this.flickerMs / $76215559f193965e$var$FLICKER_DRIFT_MS * Math.PI * 2);
            const lick = Math.sin(this.flickerMs / $76215559f193965e$var$FLICKER_LICK_MS * Math.PI * 2);
            const life = 0.4 + 0.6 * this.shown;
            const x = $76215559f193965e$var$PLATE_PAD_X + 3;
            const h = 10.5 + (drift * 0.5 + lick * 0.35) * life;
            // The tip leans; the base does not. A flame pinned at both ends is a leaf.
            const lean = (drift * 0.75 + lick * 0.3) * life;
            const waist = 3 + drift * 0.2 * life;
            const color = $76215559f193965e$export$f087c488d44b08c3(this.strength);
            this.flame.clear();
            this.flame.beginFill(color, 0.92);
            this.flame.moveTo(x + lean, -h / 2);
            this.flame.quadraticCurveTo(x + 4.5, -h / 6, x + waist, h / 4);
            this.flame.quadraticCurveTo(x + 1.5, h / 2, x, h / 2);
            this.flame.quadraticCurveTo(x - 1.5, h / 2, x - waist, h / 4);
            this.flame.quadraticCurveTo(x - 4.5, -h / 6, x + lean, -h / 2);
            this.flame.endFill();
            // The hot heart, so the glyph does not read as a flat leaf. Opaque and small, under a
            // translucent body -- the fire's own rule (see additive-blending notes on the camp fire).
            this.flame.beginFill(0xfff2d0, 0.8);
            this.flame.drawEllipse(x, h / 5, 1.2 + lick * 0.1 * life, 1.9 + drift * 0.2 * life);
            this.flame.endFill();
        }, this.drawBar = (color, breath)=>{
            const left = $76215559f193965e$var$PLATE_PAD_X + 11;
            // Leave the band word its room on the right, whether or not there is a word today.
            const right = this.width_ - $76215559f193965e$var$PLATE_PAD_X - $76215559f193965e$var$LABEL_RESERVE;
            const span = Math.max(8, right - left);
            const top = -$76215559f193965e$var$GROOVE_H / 2;
            this.bar.clear();
            this.bar.beginFill(0x000000, 0.55);
            this.bar.drawRoundedRect(left, top, span, $76215559f193965e$var$GROOVE_H, $76215559f193965e$var$GROOVE_RADIUS);
            this.bar.endFill();
            if (this.shown > 0) {
                const fill = Math.max($76215559f193965e$var$GROOVE_H, span * this.shown);
                this.bar.beginFill(color, 0.35 + 0.25 * breath);
                this.bar.drawRoundedRect(left - 1, top - 1, fill + 2, $76215559f193965e$var$GROOVE_H + 2, $76215559f193965e$var$GROOVE_RADIUS + 1);
                this.bar.endFill();
                this.bar.beginFill(color, 1);
                this.bar.drawRoundedRect(left, top, fill, $76215559f193965e$var$GROOVE_H, $76215559f193965e$var$GROOVE_RADIUS);
                this.bar.endFill();
            }
            // The two lines the server actually cares about, cut through the groove. Faint: they are a
            // reference the eye finds when it looks for them, not furniture competing with the fill.
            for (const at of [
                $76215559f193965e$export$76042a63517f7a34,
                $76215559f193965e$export$fbeac00649894f55
            ]){
                const x = Math.round(left + span * at) + 0.5;
                this.bar.lineStyle({
                    width: 1,
                    color: (0, $658a44ce960354bb$export$6b1db5e247c0ce0),
                    alpha: 0.5,
                    cap: (0, $gwPoJ.LINE_CAP).SQUARE
                });
                this.bar.moveTo(x, top - 1.5);
                this.bar.lineTo(x, top + $76215559f193965e$var$GROOVE_H + 1.5);
            }
            this.bar.lineStyle(0);
        };
        this.bandText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color((0, $658a44ce960354bb$export$c48687f662ce7e97)).fontSize((0, $ef882f0a643d87d9$export$a57e4d4d74a95378).overline.fontSize).bold().align("right").render("");
        this.bandText.anchor.set(1, 0.5);
        this.contents.addChild(this.plate, this.bar, this.flame, this.bandText);
        this.addChild(this.trailLayer, this.contents);
        this.visible = false;
    }
    get height_() {
        return $76215559f193965e$var$PLATE_H;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

const $4911350b96cb29c4$export$39bef255baa7394a = 520;
// Where in its life the flash peaks. Fast in, slow out -- a symmetrical envelope reads as a fade
// rather than as an impact.
const $4911350b96cb29c4$var$PEAK_AT = 0.16;
// The falloff is built from stacked layers, each a full-screen fill with an ELLIPTICAL hole in it.
// A point near the rim falls outside every hole and so takes every layer; a point near the middle
// falls inside them all and takes none. The gradient is therefore the ACCUMULATION of equal alphas
// rather than a ramp of different ones -- which is what stops it reading as a set of steps.
//
// The first attempt stacked rectangular frames at a falloff curve: six hard-edged boxes, plainly
// visible as boxes. Light does not arrive in rectangles.
const $4911350b96cb29c4$var$BANDS = 9;
// Where the innermost hole sits, and where the outermost reaches, as a fraction of the half-width
// and half-height. The first is the clear zone the fight stays readable in; the second runs past
// the corners so the rim gets every layer.
//
// 0.55 is deliberately generous -- it leaves the whole of a camp's lit clearing untouched and puts
// the wash in the outer half only. At 0.34 the light reached well inside the clearing and the grass
// went brown at the peak, which is the failure this effect exists to avoid: the frame a wave lands
// is the frame the player most needs to read the ground they are standing on.
const $4911350b96cb29c4$var$CLEAR_ZONE = 0.55;
const $4911350b96cb29c4$var$OUTER_REACH = 1.05;
const $4911350b96cb29c4$var$FLASH_COLOR = 0xff5a2a;
// The hot line right at the rim, which lands and goes almost at once: it is what makes the hit read
// as a strike rather than as a glow coming up.
const $4911350b96cb29c4$var$RIM_COLOR = 0xffd9a0;
const $4911350b96cb29c4$export$3d803e2e5f0483ee = (age)=>{
    if (!(age > 0) || age >= 1) return 0;
    if (age < $4911350b96cb29c4$var$PEAK_AT) return age / $4911350b96cb29c4$var$PEAK_AT;
    const t = (age - $4911350b96cb29c4$var$PEAK_AT) / (1 - $4911350b96cb29c4$var$PEAK_AT);
    return (1 - t) * (1 - t);
};
const $4911350b96cb29c4$export$c5e58d23d8aec1af = (wave)=>Math.max(0, Math.min(1, 0.55 + Math.max(0, wave - 1) * 0.035));
class $4911350b96cb29c4$export$76d08da91ef0fbea extends (0, $gwPoJ.Graphics) {
    constructor(){
        super(), this.ageMs = $4911350b96cb29c4$export$39bef255baa7394a, this.strength = 0, /** A wave has landed. Restarts the hit if one is somehow still running. */ this.strike = (wave)=>{
            this.strength = $4911350b96cb29c4$export$c5e58d23d8aec1af(wave);
            this.ageMs = 0;
            this.visible = true;
        }, /** Test seam: how far through the hit we are, 0..1 (1 once it is over). */ this.progress = ()=>Math.min(1, this.ageMs / $4911350b96cb29c4$export$39bef255baa7394a), this.animate = (deltaMs)=>{
            if (!this.visible) return;
            this.ageMs += deltaMs;
            if (this.ageMs >= $4911350b96cb29c4$export$39bef255baa7394a) {
                this.visible = false;
                this.clear();
                return;
            }
            this.redraw($4911350b96cb29c4$export$3d803e2e5f0483ee(this.ageMs / $4911350b96cb29c4$export$39bef255baa7394a) * this.strength);
        }, this.redraw = (power)=>{
            this.clear();
            if (!(power > 0)) return;
            const view = (0, $167efe97b4119a5d$export$b0f20d83cec42115)();
            const cx = view.left + view.width / 2;
            const cy = view.top + view.height / 2;
            const alpha = 0.46 * power / $4911350b96cb29c4$var$BANDS;
            for(let band = 0; band < $4911350b96cb29c4$var$BANDS; band++){
                const at = band / ($4911350b96cb29c4$var$BANDS - 1);
                const spread = $4911350b96cb29c4$var$CLEAR_ZONE + ($4911350b96cb29c4$var$OUTER_REACH - $4911350b96cb29c4$var$CLEAR_ZONE) * at;
                this.beginFill($4911350b96cb29c4$var$FLASH_COLOR, alpha);
                this.drawRect(view.left, view.top, view.width, view.height);
                this.beginHole();
                this.drawEllipse(cx, cy, view.width / 2 * spread, view.height / 2 * spread);
                this.endHole();
                this.endFill();
            }
            // The rim line, on only for the first fifth of the hit.
            const rim = Math.max(0, power * 1.6 - 0.6);
            if (rim > 0) {
                this.lineStyle({
                    width: 3,
                    color: $4911350b96cb29c4$var$RIM_COLOR,
                    alpha: Math.min(0.75, rim)
                });
                this.drawRect(view.left + 1.5, view.top + 1.5, view.width - 3, view.height - 3);
                this.lineStyle(0);
            }
        };
        this.visible = false;
    }
}


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");




// The "you are not alone" chip: a small pill in the top-right corner, beside the map toggle, carrying
// the number of OTHER players logged into the server. It is present only while there is somebody else
// to count -- a solo camp has no use for it, and the corner is better empty than occupied by a zero.
//
// Deliberately built off the map chip's own plate (dark translucent, thin light rim, glyph + label) so
// the pair reads as one row of controls rather than two unrelated badges.
//
// Because every change to it happens unasked -- somebody else logged in, nothing the player did -- it
// announces itself with the HUD's shared flare (see ./flare) whenever the count ARRIVES OR GROWS: the
// plate goes hot, it pops against its own middle, and a glow with rings expands out of it, for three
// seconds. A count that drops is not news and passes in silence.
const $847e936c2402c20f$var$GLYPH = "\uD83D\uDC65";
const $847e936c2402c20f$var$PANEL_COLOR = (0, $97475243e21a0995$export$ae463dc3cc7e810b);
const $847e936c2402c20f$var$PANEL_ALPHA = 0.59;
const $847e936c2402c20f$var$PANEL_ALPHA_HOVER = 0.82;
const $847e936c2402c20f$var$BORDER_ALPHA = 0.36;
const $847e936c2402c20f$var$BORDER_ALPHA_HOVER = 0.75;
const $847e936c2402c20f$var$LABEL_COLOR = (0, $97475243e21a0995$export$4569a0b09aa32d6c);
const $847e936c2402c20f$var$LABEL_COLOR_HOVER = 0xffffff;
class $847e936c2402c20f$export$79ada16547910660 extends (0, $8t5Gy.Container) {
    constructor(onClick){
        super(), // Everything visible hangs off `body` rather than off the chip itself, so the flare's pop can
        // scale it about its own middle while the chip's x/y -- what layoutChipRow sets, and what the
        // players panel stacks beneath -- stay exactly where they were put.
        this.metrics = (0, $0d2b5753435eae0a$export$80d247c8fac4e59d)(), this.metricSource = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)(), this.body = new (0, $8t5Gy.Container)(), this.glow = new (0, $gwPoJ.Graphics)(), this.plate = new (0, $gwPoJ.Graphics)(), this.count = 0, this.hovered = false, this.flareMs = 0, // Browser-console triggers, in the same shape as window.rosterWidget / window.playerRing:
        //
        //     playersFlare()     // flare on the count that is up (or on a 1, if the chip is away)
        //     playersFlare(4)    // ...as if a fourth player had just joined
        //     playersChip        // the chip itself: isFlashing(), getWidth()
        //
        // Nothing a developer alone at a keyboard can do makes this chip move -- it takes a second player
        // logging into the server -- so there would otherwise be no way to look at the one thing it exists
        // to do, let alone tune it. The count it pretends to carry is corrected by the next players
        // broadcast a couple of seconds later.
        this.exposeDevTriggers = ()=>{
            if (typeof window === "undefined") return;
            window.playersChip = this;
            window.playersFlare = (count)=>{
                this.update(Math.max(1, Math.floor(count ?? this.count ?? 1)));
                this.flash();
                this.draw();
                return `[playersFlare] ${this.count} online, ${0, $ec347662891822a3$export$4bd05e62286397cf}ms`;
            };
        }, // How many others there are. Any count that GROWS flares: the chip appearing out of nothing, a
        // second player joining the three already online, or walking into a camp while somebody else is
        // logged in. All of them are somebody arriving, which is the thing worth looking up for. A count
        // that falls just redraws -- a player leaving is not an event the player can act on, and flaring
        // on every change would make the corner a blinking light.
        this.update = (count)=>{
            const next = Math.max(0, Math.floor(count || 0));
            const arrival = next > this.count;
            this.count = next;
            this.label.text = String(next);
            this.layout();
            this.visible = next > 0;
            if (arrival) this.flash();
            this.draw();
        }, this.flash = ()=>{
            this.flareMs = (0, $ec347662891822a3$export$4bd05e62286397cf);
        }, this.isFlashing = ()=>this.flareMs > 0, // Drain the flare. Only repaints while one is running, so a chip that has settled costs nothing
        // per frame.
        this.animate = (dtMs)=>{
            if (this.flareMs <= 0) return;
            this.flareMs = Math.max(0, this.flareMs - dtMs);
            this.draw();
        }, // Both sit on a shared centre line, so the glyph and the count don't stagger. Re-run whenever the
        // count's width changes (1 digit to 2), which also moves the hit area.
        this.layout = ()=>{
            this.glyph.x = this.metrics.padX;
            this.label.x = this.metrics.padX + this.glyph.width + this.metrics.gap;
            const h = this.getHeight() - this.metrics.padY * 2;
            this.glyph.y = this.metrics.padY + (h - this.glyph.height) / 2;
            this.label.y = this.metrics.padY + (h - this.label.height) / 2;
            // Pivot and position on the same point: the body then occupies its old box at rest and swells
            // symmetrically out of the middle when the pop scales it.
            const centre = {
                x: this.getWidth() / 2,
                y: this.getHeight() / 2
            };
            this.body.pivot.set(centre.x, centre.y);
            this.body.position.set(centre.x, centre.y);
            // An explicit hit area a couple of px proud of the plate: the chip is small, and it is the one
            // way into the player list. Measured off the resting size, so a pop doesn't move the target
            // under a thumb that is already reaching for it.
            this.hitArea = new (0, $0d2b5753435eae0a$export$ca88597b86c9a1dc)(()=>{
                const rect = (0, $0d2b5753435eae0a$export$f71286780f6a70a)(this, this.getWidth(), this.getHeight(), this.metrics.hitPad);
                if (!(0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().touch) rect.pad(this.metrics.hitPad);
                return rect;
            });
        }, this.draw = ()=>{
            const hot = (0, $ec347662891822a3$export$89ff20d7b20a9b0b)(this.flareMs);
            const w = this.getWidth();
            const h = this.getHeight();
            // The row sits 6px off the top of the screen, so the halo is kept short: anything taller is
            // spent off-canvas.
            (0, $ec347662891822a3$export$68fa09a501e35b68)(this.glow, {
                remainingMs: this.flareMs,
                width: w,
                height: h,
                corner: this.metrics.corner
            });
            this.plate.clear();
            this.plate.beginFill((0, $ec347662891822a3$export$33ee99e9ec522cbf)($847e936c2402c20f$var$PANEL_COLOR, (0, $ec347662891822a3$export$8c3b9879a2e96719), hot * 0.85), (this.hovered ? $847e936c2402c20f$var$PANEL_ALPHA_HOVER : $847e936c2402c20f$var$PANEL_ALPHA) + hot * (1 - $847e936c2402c20f$var$PANEL_ALPHA));
            // The rim stays near white at the peak rather than going orange with the fill: a bright edge
            // around a hot plate is what makes the thing look lit instead of merely recoloured.
            this.plate.lineStyle(1 + hot * 1.5, (0, $ec347662891822a3$export$33ee99e9ec522cbf)(0xffffff, (0, $ec347662891822a3$export$8c3b9879a2e96719), hot * 0.4), Math.min(1, (this.hovered ? $847e936c2402c20f$var$BORDER_ALPHA_HOVER : $847e936c2402c20f$var$BORDER_ALPHA) + hot));
            this.plate.drawRoundedRect(0, 0, w, h, this.metrics.corner);
            this.plate.endFill();
            this.label.tint = (0, $ec347662891822a3$export$33ee99e9ec522cbf)(this.hovered ? $847e936c2402c20f$var$LABEL_COLOR_HOVER : $847e936c2402c20f$var$LABEL_COLOR, 0xffffff, hot);
            this.body.scale.set((0, $ec347662891822a3$export$6475a58bf88bdc85)(this.flareMs));
        }, // Measured off the content rather than getBounds(), so the plate can be drawn to the size the
        // caller is about to position against without a chicken-and-egg on bounds -- and so the row's
        // layout is the chip's RESTING size, unmoved by a flare in progress.
        this.refreshMetrics = ()=>{
            if (this.metricSource === (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)()) return;
            this.metricSource = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)();
            this.metrics = (0, $0d2b5753435eae0a$export$80d247c8fac4e59d)();
            this.glyph.style.fontSize = this.metrics.glyphSize;
            this.label.style.fontSize = this.metrics.labelSize;
            this.layout();
            this.draw();
        }, this.getWidth = ()=>{
            this.refreshMetrics();
            return Math.max(this.metrics.minWidth, this.metrics.padX * 2 + this.glyph.width + this.metrics.gap + this.label.width);
        }, this.getHeight = ()=>{
            this.refreshMetrics();
            return Math.max(this.metrics.minHeight, this.metrics.padY * 2 + Math.max(this.glyph.height, this.label.height));
        };
        // No tint on the emoji -- it carries its own colours.
        this.glyph = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(this.metrics.glyphSize).render($847e936c2402c20f$var$GLYPH);
        this.label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(this.metrics.labelSize).render("0");
        this.body.addChild(this.glow, this.plate, this.glyph, this.label);
        this.addChild(this.body);
        this.layout();
        this.draw();
        this.interactive = true;
        this.cursor = "pointer";
        this.on("mouseover", ()=>{
            this.hovered = true;
            this.draw();
        });
        this.on("mouseout", ()=>{
            this.hovered = false;
            this.draw();
        });
        this.on("click", onClick);
        this.on("tap", onClick);
        this.visible = false;
        this.exposeDevTriggers();
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");





// Panel geometry. Sized to the right-hand HUD gutter: wide enough for a name, a wave badge and a
// button side by side, and no wider, because everything else on that edge (the map, the roster strip)
// has to keep its own room.
const $031092a28fb787ca$var$WIDTH = 186;
const $031092a28fb787ca$var$PAD = 8;
const $031092a28fb787ca$var$CORNER = 6;
const $031092a28fb787ca$var$HEADER_H = 18;
const $031092a28fb787ca$var$ROW_H = 32;
const $031092a28fb787ca$var$ROW_GAP = 2;
const $031092a28fb787ca$export$29aaa579571d742c = 5;
const $031092a28fb787ca$var$FOOTER_H = 12;
const $031092a28fb787ca$export$6881c612b1e8acd5 = 13;
const $031092a28fb787ca$var$PANEL_COLOR = (0, $97475243e21a0995$export$ae463dc3cc7e810b);
const $031092a28fb787ca$var$PANEL_ALPHA = 0.82;
const $031092a28fb787ca$var$BORDER_ALPHA = 0.36;
const $031092a28fb787ca$var$HEADER_COLOR = 0x8d97ad;
const $031092a28fb787ca$var$NAME_COLOR = 0xe6e9f0;
const $031092a28fb787ca$var$NAME_COLOR_HERE = 0x9fe6a8 // already in your camp -- the same green the map draws a friend in
;
const $031092a28fb787ca$var$WAVE_COLOR = 0xffab66;
const $031092a28fb787ca$var$WAVE_IDLE_COLOR = 0x6b7382;
// The invite button.
const $031092a28fb787ca$var$BUTTON_W = 46;
const $031092a28fb787ca$var$BUTTON_H = (0, $97475243e21a0995$export$73e83bf2b7e02467).extraSmall.height;
const $031092a28fb787ca$var$BUTTON_TEXT = 0xffe6b0;
const $031092a28fb787ca$export$e22393ef4e0495dc = 2500;
const $031092a28fb787ca$export$988945b3d699075c = (name)=>{
    if (!name) return "???";
    return name.length > $031092a28fb787ca$export$6881c612b1e8acd5 ? name.slice(0, $031092a28fb787ca$export$6881c612b1e8acd5 - 1) + "\u2026" : name;
};
const $031092a28fb787ca$export$447f0dcdd48b7fcc = (wave)=>{
    if (wave === undefined || wave === null) return "\u2014";
    return wave > 0 ? `W${wave}` : "\u2022";
};
class $031092a28fb787ca$export$349ef492ca0f8a2a extends (0, $8t5Gy.Container) {
    constructor({ onInvite: onInvite }){
        super(), this.plate = new (0, $gwPoJ.Graphics)(), this.rowsLayer = new (0, $8t5Gy.Container)(), this.rows = new Map(), this.players = [], this.allPlayers = [], this.rowLimit = $031092a28fb787ca$export$29aaa579571d742c, this.overflow = 0, // "Asked" is remembered per player rather than per row, so a list that rebuilds underneath the
        // player (somebody's wave ticked over) doesn't swallow the acknowledgement they just earned.
        this.sentAt = new Map(), // The players to list, newest state wins. Rows are reconciled by entity id rather than rebuilt,
        // so a list that refreshes while the pointer is over a button doesn't pull it out from under them.
        this.update = (players)=>{
            this.allPlayers = players || [];
            const listed = this.allPlayers.slice(0, this.rowLimit);
            this.players = listed;
            this.overflow = Math.max(0, (players || []).length - listed.length);
            const seen = new Set();
            listed.forEach((player, index)=>{
                seen.add(player.entityId);
                const row = this.rows.get(player.entityId) || this.buildRow(player);
                this.rows.set(player.entityId, row);
                this.fillRow(row, player);
                row.container.y = index * ($031092a28fb787ca$var$ROW_H + $031092a28fb787ca$var$ROW_GAP);
            });
            Array.from(this.rows.keys()).forEach((entityId)=>{
                if (!seen.has(entityId)) {
                    const row = this.rows.get(entityId);
                    this.rowsLayer.removeChild(row.container);
                    row.container.destroy({
                        children: true
                    });
                    this.rows.delete(entityId);
                    // Somebody who has logged out has no press left to acknowledge.
                    this.sentAt.delete(entityId);
                }
            });
            this.header.text = `ONLINE  ${(players || []).length}`;
            this.footer.text = this.overflow > 0 ? `+${this.overflow} more` : "";
            this.footer.visible = this.overflow > 0;
            this.footer.y = $031092a28fb787ca$var$PAD + $031092a28fb787ca$var$HEADER_H + listed.length * ($031092a28fb787ca$var$ROW_H + $031092a28fb787ca$var$ROW_GAP) + 1;
            this.draw();
        }, // Let the "Sent" acknowledgements lapse. Cheap when there are none, which is almost always.
        this.animate = (dtMs)=>{
            if (this.sentAt.size < 1) return;
            let changed = false;
            this.sentAt.forEach((remaining, entityId)=>{
                const left = remaining - dtMs;
                if (left > 0) {
                    this.sentAt.set(entityId, left);
                    return;
                }
                this.sentAt.delete(entityId);
                changed = true;
            });
            if (changed) this.players.forEach((player)=>{
                const row = this.rows.get(player.entityId);
                if (row) this.fillRow(row, player);
            });
        }, // Keep text around 16 CSS pixels on phones, including canvases scaled down to fit the display.
        // Layout calls this again on resize, and limits rows instead of shrinking the text to fit.
        this.fitToViewport = (top)=>{
            const metrics = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)();
            const mobile = metrics.touch || (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)();
            const scale = mobile ? Math.min(2 / Math.min(metrics.scaleX, metrics.scaleY), Math.max(1, (metrics.safeViewport.width - 24) / $031092a28fb787ca$var$WIDTH)) : 1;
            this.scale.set(scale);
            const availableHeight = Math.max(0, metrics.safeViewport.bottom - top - 12);
            const rowLimit = mobile ? Math.max(1, Math.min($031092a28fb787ca$export$29aaa579571d742c, Math.floor((availableHeight / scale - $031092a28fb787ca$var$PAD * 2 - $031092a28fb787ca$var$HEADER_H - $031092a28fb787ca$var$FOOTER_H) / ($031092a28fb787ca$var$ROW_H + $031092a28fb787ca$var$ROW_GAP)))) : $031092a28fb787ca$export$29aaa579571d742c;
            if (rowLimit !== this.rowLimit) {
                this.rowLimit = rowLimit;
                this.update(this.allPlayers);
            }
        }, this.getWidth = ()=>$031092a28fb787ca$var$WIDTH * this.scale.x, this.getHeight = ()=>this.localHeight() * this.scale.y, this.localHeight = ()=>$031092a28fb787ca$var$PAD * 2 + $031092a28fb787ca$var$HEADER_H + Math.max(1, this.players.length) * ($031092a28fb787ca$var$ROW_H + $031092a28fb787ca$var$ROW_GAP) + (this.overflow > 0 ? $031092a28fb787ca$var$FOOTER_H : 0), // Press one row's invite. This IS the button's handler, and it is public because the button itself
        // is buried in the display tree -- a caller (or a test) that has the player's id has the control.
        this.inviteFor = (entityId)=>{
            const row = this.rows.get(entityId);
            if (!row) return;
            // A player already in the camp has nothing to be invited to, and a press already acknowledged
            // is not sent twice -- both would just be a wasted round trip.
            if (row.here || this.sentAt.has(entityId)) return;
            this.onInvite(entityId);
        }, this.markInvited = (entityId)=>{
            const row = this.rows.get(entityId);
            if (!row) return;
            this.sentAt.set(entityId, $031092a28fb787ca$export$e22393ef4e0495dc);
            const current = this.players.find((player)=>player.entityId === entityId);
            if (current) this.fillRow(row, current);
        }, // What a listed player's button currently says ("Invite" / "Sent" / "Here"), or undefined when they
        // have no row. The one readable summary of a row's state, for a caller outside the display tree.
        this.buttonLabelFor = (entityId)=>this.rows.get(entityId)?.button.getLabel(), // How many players did NOT get a row (the footer's number).
        this.modeLabelFor = (entityId)=>this.rows.get(entityId)?.mode.text, this.overflowCount = ()=>this.overflow, this.buildRow = (player)=>{
            const container = new (0, $8t5Gy.Container)();
            const backdrop = new (0, $gwPoJ.Graphics)();
            const name = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("");
            const mode = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("");
            mode.position.set($031092a28fb787ca$var$PAD, 19);
            mode.tint = $031092a28fb787ca$var$NAME_COLOR_HERE;
            const wave = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("");
            const button = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
                label: "Invite",
                theme: "ember",
                width: $031092a28fb787ca$var$BUTTON_W,
                height: $031092a28fb787ca$var$BUTTON_H,
                size: "extraSmall",
                textColor: $031092a28fb787ca$var$BUTTON_TEXT,
                hitPadding: 3,
                onClick: ()=>this.inviteFor(player.entityId)
            });
            name.x = $031092a28fb787ca$var$PAD;
            name.y = 5;
            wave.y = name.y;
            button.position.set($031092a28fb787ca$var$WIDTH - $031092a28fb787ca$var$PAD - $031092a28fb787ca$var$BUTTON_W, Math.round(($031092a28fb787ca$var$ROW_H - $031092a28fb787ca$var$BUTTON_H) / 2));
            container.addChild(backdrop, name, mode, wave, button);
            this.rowsLayer.addChild(container);
            const row = {
                entityId: player.entityId,
                container: container,
                name: name,
                mode: mode,
                wave: wave,
                button: button,
                here: false
            };
            // Row backdrop: a faint plate, so a long list still reads as rows rather than as a wall of
            // text. Drawn once -- it never changes size.
            backdrop.beginFill(0xffffff, 0.04);
            backdrop.drawRoundedRect($031092a28fb787ca$var$PAD - 4, 0, $031092a28fb787ca$var$WIDTH - ($031092a28fb787ca$var$PAD - 4) * 2, $031092a28fb787ca$var$ROW_H, 3);
            backdrop.endFill();
            return row;
        }, this.fillRow = (row, player)=>{
            row.here = !!player.here;
            row.mode.text = player.here ? player.playMode === "cooperation" ? "Cooperation" : "PVP" : "";
            row.name.text = $031092a28fb787ca$export$988945b3d699075c(player.name);
            row.name.tint = player.here ? $031092a28fb787ca$var$NAME_COLOR_HERE : $031092a28fb787ca$var$NAME_COLOR;
            row.wave.text = $031092a28fb787ca$export$447f0dcdd48b7fcc(player.wave);
            row.wave.tint = player.wave ? $031092a28fb787ca$var$WAVE_COLOR : $031092a28fb787ca$var$WAVE_IDLE_COLOR;
            // Right-aligned against the button, so the badge column lines up however wide a name is.
            row.wave.x = $031092a28fb787ca$var$WIDTH - $031092a28fb787ca$var$PAD - $031092a28fb787ca$var$BUTTON_W - 6 - row.wave.width;
            row.button.setLabel(row.here ? "Here" : this.sentAt.has(player.entityId) ? "Asked" : "Invite");
            row.button.setEnabled(!row.here && !this.sentAt.has(row.entityId));
        }, this.draw = ()=>{
            this.plate.clear();
            this.plate.beginFill($031092a28fb787ca$var$PANEL_COLOR, $031092a28fb787ca$var$PANEL_ALPHA);
            this.plate.lineStyle(1, 0xffffff, $031092a28fb787ca$var$BORDER_ALPHA);
            this.plate.drawRoundedRect(0, 0, $031092a28fb787ca$var$WIDTH, this.localHeight(), $031092a28fb787ca$var$CORNER);
            this.plate.endFill();
        };
        this.onInvite = onInvite;
        this.header = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("ONLINE");
        this.header.tint = $031092a28fb787ca$var$HEADER_COLOR;
        this.header.x = $031092a28fb787ca$var$PAD;
        this.header.y = $031092a28fb787ca$var$PAD - 2;
        this.footer = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("");
        this.footer.tint = $031092a28fb787ca$var$HEADER_COLOR;
        this.footer.x = $031092a28fb787ca$var$PAD;
        this.footer.visible = false;
        this.rowsLayer.x = 0;
        this.rowsLayer.y = $031092a28fb787ca$var$PAD + $031092a28fb787ca$var$HEADER_H;
        this.addChildAt(this.plate, 0);
        this.addChild(this.header, this.rowsLayer, this.footer);
        this.draw();
        this.visible = false;
        this.fitToViewport((0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().safeViewport.top);
    }
}


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");





// The prompt an invited player answers: who is asking, and Join / Decline. It docks in the right-hand
// gutter directly under the players chip, above the player list, so the whole "who else is playing"
// business reads as one column.
//
// It is NOT a modal. An invitation is somebody else's idea, arriving while the player is in the middle
// of something -- very likely a wave -- so it must be ignorable. Ignoring it IS an answer: the bar at
// the foot of the panel drains, and at zero the prompt takes itself down without moving anybody. The
// server expires the invitation on the same clock, so the two agree without a second message.
//
// Amber rim, from the same ember-lit family as the role picker and the tutorial bar, because unlike
// everything else in this column it wants an answer.
//
// And because it is the most ignorable thing on screen that most deserves not to be -- it arrives
// unasked, in the corner, while the middle of the screen is a wave -- it ARRIVES with the HUD's
// shared flare (see ./flare), the same three seconds of hot pulsing, glow and rings the players chip
// uses. Only the plate behind the prompt breathes with it: the buttons stay exactly where they are,
// because one of them moves the player to another room and must not slide under a thumb already on
// its way down.
const $102f4cd7b044a43e$var$WIDTH = 186;
const $102f4cd7b044a43e$var$PAD = 8;
const $102f4cd7b044a43e$var$CORNER = 6;
const $102f4cd7b044a43e$var$LINE_GAP = 4;
const $102f4cd7b044a43e$var$BUTTON_H = (0, $97475243e21a0995$export$73e83bf2b7e02467).extraSmall.height;
const $102f4cd7b044a43e$var$BUTTON_GAP = 6;
const $102f4cd7b044a43e$var$METER_H = 3;
const $102f4cd7b044a43e$var$METER_GAP = 7;
const $102f4cd7b044a43e$var$PANEL_COLOR = (0, $97475243e21a0995$export$ae463dc3cc7e810b);
const $102f4cd7b044a43e$var$PANEL_ALPHA = 0.9;
const $102f4cd7b044a43e$var$RIM = 0xf2a94e;
const $102f4cd7b044a43e$var$RIM_ALPHA = 0.7;
const $102f4cd7b044a43e$var$TITLE_COLOR = 0xfff3e0;
const $102f4cd7b044a43e$var$BODY_COLOR = 0x8d97ad;
const $102f4cd7b044a43e$var$ACCEPT_TEXT = 0xdcffe2;
const $102f4cd7b044a43e$var$DECLINE_TEXT = 0xd4d8e0;
const $102f4cd7b044a43e$var$METER_TRACK = 0x2a2119;
// How far the plate swells at the peak of a pulse. Far gentler than the players chip's: this is a
// 186px panel docked against the right edge with a list under it, and it has no room to throw about.
const $102f4cd7b044a43e$var$FLARE_POP = 0.045;
// The halo is kept tight for the same reason -- the gutter it sits in is only so wide.
const $102f4cd7b044a43e$var$FLARE_GLOW_SPREAD = 6;
const $102f4cd7b044a43e$var$FLARE_RING_SPREAD = 11;
// Fallback line height for a Text that measures as zero, which is every Text under a mocked canvas.
// Without it the panel collapses onto its own buttons in any headless render.
const $102f4cd7b044a43e$var$LINE_H = 10;
const $102f4cd7b044a43e$export$c0f8283346f0f07a = (remainingMs, totalMs)=>{
    if (!(totalMs > 0)) return 0;
    return Math.max(0, Math.min(1, remainingMs / totalMs));
};
class $102f4cd7b044a43e$export$2910d5f40b7274eb extends (0, $8t5Gy.Container) {
    constructor({ onAnswer: onAnswer }){
        super(), // The plate and its halo ride on their own container so the flare's pop can scale them about the
        // panel's middle while the text and the two buttons stay put. Nothing interactive moves.
        this.shell = new (0, $8t5Gy.Container)(), this.glow = new (0, $gwPoJ.Graphics)(), this.plate = new (0, $gwPoJ.Graphics)(), this.meter = new (0, $gwPoJ.Graphics)(), this.invite = null, this.remainingMs = 0, this.totalMs = 0, this.flareMs = 0, // Browser-console triggers, in the same shape as window.playersFlare (see EmberPlayersChip): an
        // invitation needs a second logged-in player to send one, so there is otherwise no way to look at
        // the arrival this widget is built around.
        //
        //     invitePrompt            // the widget itself: isOpen(), remaining(), answer(true)
        //     inviteFlare("Ash")      // an invitation from Ash, flare and all
        this.exposeDevTriggers = ()=>{
            if (typeof window === "undefined") return;
            window.invitePrompt = this;
            window.inviteFlare = (fromName = "Ash")=>{
                this.update({
                    fromEntityId: "dev",
                    fromName: fromName,
                    expiresInMs: 20000
                });
                return `[inviteFlare] from ${fromName}, ${0, $ec347662891822a3$export$4bd05e62286397cf}ms`;
            };
        }, // Put the prompt up, or take it down with null. A fresh invitation always restarts the clock --
        // a second host asking replaces the first, exactly as the server's own one-per-guest rule does.
        this.update = (invite)=>{
            this.accept.resetInteraction();
            this.decline.resetInteraction();
            this.invite = invite || null;
            if (!this.invite) {
                this.visible = false;
                this.remainingMs = 0;
                this.totalMs = 0;
                return;
            }
            this.totalMs = this.invite.expiresInMs > 0 ? this.invite.expiresInMs : 0;
            this.remainingMs = this.totalMs;
            this.title.text = `${(0, $031092a28fb787ca$export$988945b3d699075c)(this.invite.fromName)}`;
            this.body.text = this.invite.playMode === "cooperation" ? "Cooperation: no player hits" : "PVP: unrestricted play";
            this.visible = true;
            // Every invitation that goes up is a new one -- update(null) takes the old one down, and a
            // second host asking replaces the first -- so every one of them announces itself.
            this.flareMs = (0, $ec347662891822a3$export$4bd05e62286397cf);
            this.draw();
        }, // Answer it. Public because the buttons are buried in the display tree, and because a caller with
        // a keyboard shortcut or a test has as much right to answer as the pointer does.
        this.answer = (accepted)=>{
            if (!this.invite) return;
            this.invite = null;
            this.visible = false;
            this.onAnswer(accepted);
        }, // Drain the clock. Doing nothing is an answer -- at zero the prompt takes itself down, and tells
        // the server nothing: the server is expiring the same invitation on the same clock.
        this.animate = (dtMs)=>{
            if (!this.invite) return;
            // The flare is drained BEFORE the deadline is consulted, because an invitation that arrived
            // without one (expiresInMs 0) never expires -- and must not therefore sit in the gutter with
            // a plate frozen mid-flare forever.
            const flaring = this.flareMs > 0;
            if (flaring) {
                this.flareMs = Math.max(0, this.flareMs - dtMs);
                this.draw();
            }
            if (this.totalMs <= 0) return;
            this.remainingMs = Math.max(0, this.remainingMs - dtMs);
            if (this.remainingMs <= 0) {
                this.invite = null;
                this.visible = false;
                this.flareMs = 0;
                return;
            }
            // The flare is three seconds out of an invitation's twenty, so most frames only redraw the
            // meter -- and a frame that redrew the whole prompt has already drawn it.
            if (!flaring) this.drawMeter();
        }, this.isFlaring = ()=>this.flareMs > 0, this.isOpen = ()=>!!this.invite, this.remaining = ()=>this.remainingMs, // The name the prompt is showing, for a caller outside the display tree.
        this.inviterLabel = ()=>this.title.text, this.getWidth = ()=>$102f4cd7b044a43e$var$WIDTH, this.getHeight = ()=>this.accept.y + $102f4cd7b044a43e$var$BUTTON_H + $102f4cd7b044a43e$var$METER_GAP + $102f4cd7b044a43e$var$METER_H + $102f4cd7b044a43e$var$PAD - 2, this.draw = ()=>{
            const hot = (0, $ec347662891822a3$export$89ff20d7b20a9b0b)(this.flareMs);
            (0, $ec347662891822a3$export$68fa09a501e35b68)(this.glow, {
                remainingMs: this.flareMs,
                width: $102f4cd7b044a43e$var$WIDTH,
                height: this.getHeight(),
                corner: $102f4cd7b044a43e$var$CORNER,
                spread: $102f4cd7b044a43e$var$FLARE_GLOW_SPREAD,
                ringSpread: $102f4cd7b044a43e$var$FLARE_RING_SPREAD
            });
            this.plate.clear();
            // The plate only warms -- it stays dark enough to read the two button labels against at the
            // hottest point of the flare. The RIM is what carries the heat.
            this.plate.beginFill((0, $ec347662891822a3$export$33ee99e9ec522cbf)($102f4cd7b044a43e$var$PANEL_COLOR, (0, $ec347662891822a3$export$8c3b9879a2e96719), hot * 0.4), $102f4cd7b044a43e$var$PANEL_ALPHA);
            this.plate.lineStyle(1 + hot * 1.5, (0, $ec347662891822a3$export$33ee99e9ec522cbf)($102f4cd7b044a43e$var$RIM, 0xffffff, hot * 0.55), Math.min(1, $102f4cd7b044a43e$var$RIM_ALPHA + hot * 0.3));
            this.plate.drawRoundedRect(0, 0, $102f4cd7b044a43e$var$WIDTH, this.getHeight(), $102f4cd7b044a43e$var$CORNER);
            this.plate.endFill();
            this.shell.scale.set((0, $ec347662891822a3$export$6475a58bf88bdc85)(this.flareMs, $102f4cd7b044a43e$var$FLARE_POP));
            this.drawMeter();
        }, this.drawMeter = ()=>{
            const w = $102f4cd7b044a43e$var$WIDTH - $102f4cd7b044a43e$var$PAD * 2;
            const y = this.accept.y + $102f4cd7b044a43e$var$BUTTON_H + $102f4cd7b044a43e$var$METER_GAP;
            this.meter.clear();
            this.meter.beginFill($102f4cd7b044a43e$var$METER_TRACK, 0.9);
            this.meter.drawRoundedRect($102f4cd7b044a43e$var$PAD, y, w, $102f4cd7b044a43e$var$METER_H, 1.5);
            this.meter.endFill();
            const left = $102f4cd7b044a43e$export$c0f8283346f0f07a(this.remainingMs, this.totalMs);
            if (left > 0) {
                this.meter.beginFill($102f4cd7b044a43e$var$RIM, 0.95);
                this.meter.drawRoundedRect($102f4cd7b044a43e$var$PAD, y, Math.max(1, w * left), $102f4cd7b044a43e$var$METER_H, 1.5);
                this.meter.endFill();
            }
        };
        this.onAnswer = onAnswer;
        this.title = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("");
        this.title.tint = $102f4cd7b044a43e$var$TITLE_COLOR;
        this.title.x = $102f4cd7b044a43e$var$PAD;
        this.title.y = $102f4cd7b044a43e$var$PAD - 2;
        this.body = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render("wants you at their camp");
        this.body.tint = $102f4cd7b044a43e$var$BODY_COLOR;
        this.body.x = $102f4cd7b044a43e$var$PAD;
        this.body.y = this.title.y + $102f4cd7b044a43e$var$LINE_H + $102f4cd7b044a43e$var$LINE_GAP;
        const buttonW = Math.round(($102f4cd7b044a43e$var$WIDTH - $102f4cd7b044a43e$var$PAD * 2 - $102f4cd7b044a43e$var$BUTTON_GAP) / 2);
        const buttonY = this.body.y + $102f4cd7b044a43e$var$LINE_H + $102f4cd7b044a43e$var$LINE_GAP + 2;
        this.accept = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
            label: "Join",
            theme: "ember",
            preset: "confirm",
            width: buttonW,
            height: $102f4cd7b044a43e$var$BUTTON_H,
            size: "extraSmall",
            textColor: $102f4cd7b044a43e$var$ACCEPT_TEXT,
            hitPadding: 3,
            onClick: ()=>this.answer(true)
        });
        this.decline = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
            label: "Decline",
            theme: "ember",
            width: buttonW,
            height: $102f4cd7b044a43e$var$BUTTON_H,
            size: "extraSmall",
            textColor: $102f4cd7b044a43e$var$DECLINE_TEXT,
            hitPadding: 3,
            onClick: ()=>this.answer(false)
        });
        this.accept.position.set($102f4cd7b044a43e$var$PAD, buttonY);
        this.decline.position.set($102f4cd7b044a43e$var$PAD + buttonW + $102f4cd7b044a43e$var$BUTTON_GAP, buttonY);
        this.shell.addChild(this.glow, this.plate);
        this.addChild(this.shell, this.title, this.body, this.accept, this.decline, this.meter);
        // Pivot and position on the same point, so the shell covers its own box at rest and swells
        // symmetrically out of the middle under the pop.
        this.shell.pivot.set($102f4cd7b044a43e$var$WIDTH / 2, this.getHeight() / 2);
        this.shell.position.set($102f4cd7b044a43e$var$WIDTH / 2, this.getHeight() / 2);
        this.draw();
        this.visible = false;
        this.exposeDevTriggers();
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");




class $0159750bbc757373$export$cd136f60375f2af0 extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.setup = (text, sprite, hoverText)=>{
            this.removeChildren();
            const container = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            let s;
            if (sprite) {
                const s = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: sprite,
                    color: 0xffffff,
                    scale: 1.0
                });
                container.append2(s, {
                    topMargin: s.height / 2
                });
            }
            if (text) container.append2(new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(text), {
                sameLine: true,
                topMargin: -10,
                leftMargin: s ? -10 : undefined
            });
            this.addChild(container);
            if (hoverText) {
                this.addChild(this.hoverText);
                container.interactive = true;
                container.on("mouseover", ()=>{
                    this.hoverText.x = container.x - 15;
                    this.hoverText.y = container.y + 20;
                    this.hoverText.visible = true;
                    this.hoverText.update(hoverText);
                });
            }
        };
        this.guiManager = guiManager;
        this.hoverText = new (0, $95fcf006ca17068b$export$9035ac6ca3ebe147)();
    }
}












class $3055b73bb9878bd5$export$4df964ecab0cb7d6 {
    constructor(tiledMapBuilder, featureType){
        this.boundsToClear = [];
        this.clear = true;
        this.seekSpawnBounds = (roomBounds, dimensions, targetBiomes)=>{
            const start = (0, $4171652afd996934$export$a86190deb5c4a8d0)();
            while((0, $4171652afd996934$export$a86190deb5c4a8d0)() - start < 1500){
                const target = this.tiledMapBuilder.randomOneOf(targetBiomes);
                const targetBounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(target.x, target.y, target.x + target.width, target.y + target.height);
                const candidateCoordinates = this.tiledMapBuilder.randomCoordinateWithinBounds(targetBounds);
                const boundsToCheck = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(candidateCoordinates.x, candidateCoordinates.y, candidateCoordinates.x + dimensions.w * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), candidateCoordinates.y + dimensions.h * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                if (roomBounds.encloses(boundsToCheck)) return boundsToCheck;
            }
            return null;
        };
        this.build = (roomId, dimensions, featuresDescriptor, roomCoordinates)=>{
            this.featureSpec = {
                dimensions: dimensions,
                mapEntries: [],
                fragments: []
            };
        };
        this.print = (spawnLocation, roomMeta)=>{
            console.log(this.featureType, "at", this.roomId, spawnLocation);
            const mapSpriteCaps = [];
            const featureSprites = [];
            const featurePoints = [];
            const postFeatureMapEntries = [];
            const { mapX: mapX, mapY: mapY } = this.tiledMapBuilder.maps[this.roomId];
            const toClear = [];
            const layers = [
                "map2",
                "map3",
                "map4",
                "map5",
                "map6",
                "sprite",
                "sprite2"
            ];
            if (this.clear) {
                this.boundsToClear.forEach((bounds)=>{
                    for(let x = bounds.x1; x < bounds.x2; x++)for(let y = bounds.y1; y < bounds.y2; y++){
                        const gX = mapX * this.tiledMapBuilder.mapSize + spawnLocation.x + x;
                        const gY = mapY * this.tiledMapBuilder.mapSize + spawnLocation.y + y;
                        layers.forEach((layerId)=>{
                            toClear.push({
                                mapId: this.roomId,
                                layerId: layerId,
                                tileSpec: {
                                    tilesetId: "lpc-terrain",
                                    tilePos: 722
                                },
                                x: gX,
                                y: gY
                            });
                        });
                    }
                });
                this.tiledMapBuilder.applyEntries(toClear);
            }
            ////
            ////
            ////
            const entries = this.featureSpec.mapEntries.map((entry)=>{
                const { x: cX, y: cY } = entry;
                const x = spawnLocation.x + this.featureSpec.dimensions.w / 2;
                const y = spawnLocation.y + this.featureSpec.dimensions.h / 2;
                const gX = mapX * this.tiledMapBuilder.mapSize + x + cX;
                const gY = mapY * this.tiledMapBuilder.mapSize + y + cY;
                if (this.originBiomeName && !this.tiledMapBuilder.scanPoint(this.originBiomeName, gX, gY)) return;
                return {
                    ...entry,
                    x: gX,
                    y: gY
                };
            }).filter((n)=>!!n);
            this.featureSpec?.postFeatureEntries?.map((entry)=>{
                const { x: cX, y: cY } = entry;
                const x = spawnLocation.x + this.featureSpec.dimensions.w / 2;
                const y = spawnLocation.y + this.featureSpec.dimensions.h / 2;
                const gX = mapX * this.tiledMapBuilder.mapSize + x + cX;
                const gY = mapY * this.tiledMapBuilder.mapSize + y + cY;
                if (this.originBiomeName && !this.tiledMapBuilder.scanPoint(this.originBiomeName, gX, gY)) return;
                return {
                    ...entry,
                    x: gX,
                    y: gY
                };
            }).filter((n)=>!!n).forEach((n)=>postFeatureMapEntries.push(n));
            this.tiledMapBuilder.applyEntries(entries, roomMeta);
            entries.filter((entry)=>!!entry.mapSpriteCap).forEach((entry)=>{
                mapSpriteCaps.push({
                    x: entry.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2,
                    y: entry.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2,
                    context: entry.mapSpriteCap
                });
            });
            ////
            ////
            ////
            const previousFeatureBounds = [];
            const delayed = [];
            this.featureSpec.fragments.forEach((featureFragment)=>{
                const featureLocation = {
                    x: spawnLocation.x + featureFragment.location.x,
                    y: spawnLocation.y + featureFragment.location.y
                };
                previousFeatureBounds.push(new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(featureLocation.x, featureLocation.y, featureLocation.x + featureFragment.dimensions.w, featureLocation.y + featureFragment.dimensions.h));
                delayed.push(()=>{
                    this.tiledMapBuilder.printFeature(featureFragment, featureLocation, mapX, mapY, this.roomId, featureSprites, featurePoints, postFeatureMapEntries, mapSpriteCaps);
                });
            });
            delayed.forEach((d)=>d());
            const finalFeatureRegionBounds = new (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4)(-1, -1, -1, -1);
            finalFeatureRegionBounds.widen(previousFeatureBounds);
            const bounds = (0, $cb689cfa16c444ba$export$c4e9d269599ab4b4).from(Math.max(0, finalFeatureRegionBounds.x1 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.max(0, finalFeatureRegionBounds.y1 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.min(this.tiledMapBuilder.mapSize * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), finalFeatureRegionBounds.width * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.min(this.tiledMapBuilder.mapSize * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), finalFeatureRegionBounds.height * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)));
            const featureRegion = this.tiledMapBuilder.toFeatureRegion(bounds.x1, bounds.y1, bounds.width, bounds.height, this.featureType, this.featureContext);
            this.finalFeatureRegionBounds = finalFeatureRegionBounds;
            const debug = (this.featureSpec.debug || []).map((next)=>{
                return this.tiledMapBuilder.toDebugObject(next.text, next.x, next.y);
            });
            return {
                type: this.featureType,
                roomId: this.roomId,
                spawnLocation: spawnLocation,
                region: featureRegion,
                bounds: bounds,
                featureSpriteMeta: featureSprites.map((next)=>this.tiledMapBuilder.toFeatureSpriteRegion(next)),
                subFeaturesMeta: featureSprites.map((next)=>next.subFeatures).flat(),
                subFeaturesRegions: mapSpriteCaps.map((n)=>{
                    return this.tiledMapBuilder.toMapSpriteCap(n.x, n.y, n.context);
                }),
                featurePoints: featurePoints,
                postFeatureMapEntries: postFeatureMapEntries,
                debug: debug
            };
        };
        this.tiledMapBuilder = tiledMapBuilder;
        this.featureType = featureType;
        this.featureId = (0, $a80d0b17b615d6f7$export$5e699d18035b41af)();
    }
}





/**
 * The wall grid a storey's walls take their shapes from: its own walls, and beside each wall standing on a wall of
 * its own material on the storey below, that storey's walls of the material too. An unfinished storey then draws
 * the shapes of the walls it stands on (a corner over a corner, not a lone panel); a finished one is unchanged.
 * Only the storey's own walls draw anything.
 */ /** The kind a wall cell joins only (a railing joins only railings), from its material: see `wallAutotile`. */ const $d9b505386b42bf36$var$joinsOnly = (cell)=>(0, $d06e01c1880d4b6a$export$a476270257d86655)($d9b505386b42bf36$export$374d003f514472fe.wallDefinitions.get(cell.itemType));
const $d9b505386b42bf36$export$fd0298a827e6eac5 = (house, below)=>{
    if (!below) return house;
    const grid = house.map((row)=>[
            ...row
        ]);
    let borrowed = false;
    for(let y = 0; y < house.length; y++)for(let x = 0; x < house[y].length; x++){
        const itemType = house[y][x]?.itemType;
        if (!itemType || below[y]?.[x]?.itemType !== itemType) continue;
        for(let ny = Math.max(0, y - 1); ny <= Math.min(house.length - 1, y + 1); ny++)for(let nx = Math.max(0, x - 1); nx <= Math.min(house[ny].length - 1, x + 1); nx++){
            const cell = below[ny]?.[nx];
            if (cell?.itemType === itemType && !grid[ny][nx]) {
                grid[ny][nx] = cell;
                borrowed = true;
            }
        }
    }
    if (!borrowed) return house;
    const { indices: indices } = (0, $5cfd87a852590fa6$export$d004d5a0cbfa247b)(grid, $d9b505386b42bf36$var$joinsOnly);
    // A lower room with a different footprint can fill this room's doorway or interior in the
    // borrowed grid. Never let those borrowed cells erase real walls by making their art uncomputable.
    if (house.some((row, y)=>row.some((cell, x)=>cell && !(0, $5cfd87a852590fa6$export$a936a6c53c1608e9)(indices[y][x])))) return house;
    return grid;
};
const $d9b505386b42bf36$export$33638ba377d70cb2 = (definition)=>(x, y, houseAuto, { entry: entry, addFor: addFor, exists: exists }, options)=>{
        (0, $d06e01c1880d4b6a$export$9c6b1f61882a2146)(definition, houseAuto, x, y, {
            entry: entry,
            addFor: addFor,
            exists: exists
        }, {
            storey: options?.storey,
            ornament: options?.ornament
        });
    };
class $d9b505386b42bf36$export$374d003f514472fe extends (0, $3055b73bb9878bd5$export$4df964ecab0cb7d6) {
    static{
        /** Roof items resolve their pieces from live content, with the original wood as a fallback. */ this.roofDefinitions = new Map();
    }
    static{
        /** Floor materials by the item that builds them (bitmask definitions naming an `itemType`). */ this.floorDefinitions = new Map();
    }
    static{
        /**
     * Which wall material (a kind "wall" id in content/game/maps/autotiles.json) each item type builds:
     * every wall definition's `itemType`, so a material saved from Sprite Lab is buildable as content.
     */ this.wallMaterials = new Map();
    }
    static{
        this.wallDefinitions = new Map();
    }
    static{
        this.autotilers = new Map();
    }
    constructor(baseMapBuilder, config){
        super(baseMapBuilder, "house"), this.boundsToClear = [], this.clear = true, this.build = (roomId)=>{
            this.roomId = roomId;
            let entries = [];
            const debug = [];
            const { blockingTileSpec: blockingTileSpec, roof: roof, house: house, entity: entity, floor: floor, floor2: floor2, decor: decor } = this.config;
            const width = house[0].length;
            const height = house.length;
            const cache = new Map();
            // What goes under a house cell: its wall material's `cell` decorations, or, for a cell no wall
            // definition covers, the caller's blockingTileSpec on both layers. One TileSpec per kind of
            // cell per build, as the shared blockingTileSpec was, so no entry aliases the loaded data.
            const cellDecorations = new Map();
            const decorationsFor = (itemType)=>{
                let decorations = cellDecorations.get(itemType);
                if (!decorations) {
                    const cell = $d9b505386b42bf36$export$374d003f514472fe.wallDefinitions.get(itemType)?.cell;
                    const spec = (ref)=>ref ? {
                            tilePos: ref.tilePos,
                            tilesetId: ref.tilesetId
                        } : undefined;
                    decorations = cell ? {
                        blocking: spec(cell.blocking),
                        occlusion: spec(cell.occlusion)
                    } : {
                        blocking: blockingTileSpec,
                        occlusion: blockingTileSpec
                    };
                    cellDecorations.set(itemType, decorations);
                }
                return decorations;
            };
            const entry = (x, y, tilePos, layerId = "sprite", tilesetId = "fence_medieval", spriteCap, context)=>{
                const e = cache.get(`${x}-${y}-${layerId}`);
                if (e) {
                    replace(x, y, tilePos, layerId);
                    return find(x, y, layerId);
                }
                let mapSpriteCap;
                try {
                    mapSpriteCap = spriteCap !== undefined ? spriteCap : !layerId.includes("sky") && !layerId.includes("map") && !house[y + 1]?.[x] && !!house[y + 2]?.[x] ? {} : undefined;
                } catch (e) {
                    console.log("!");
                }
                const item = {
                    mapId: roomId,
                    tileSpec: {
                        tilePos: tilePos,
                        tilesetId: tilesetId
                    },
                    layerId: layerId,
                    x: x,
                    y: y,
                    mapSpriteCap: mapSpriteCap,
                    context: context
                };
                cache.set(`${x}-${y}-${layerId}`, item);
                return item;
            };
            const replace = (x, y, tilePos, layerId = "sprite")=>{
                const e = cache.get(`${x}-${y}-${layerId}`);
                if (e) e.tileSpec.tilePos = tilePos;
            };
            const find = (x, y, layerId = "sprite")=>{
                const e = cache.get(`${x}-${y}-${layerId}`);
                return e;
            };
            const tileAt = (x, y, layerId = "sprite")=>{
                return find(x, y, layerId)?.tileSpec?.tilePos;
            };
            const exists = (x, y, layerId = "sprite")=>{
                return !!find(x, y, layerId);
            };
            const addFor = (x, y, mapEntry)=>{
                if (!mapEntry) return;
                mapEntry.context = {
                    ...mapEntry.context || {},
                    parent: {
                        x: x,
                        y: y
                    }
                };
                const key = `${x}-${y}-${mapEntry.layerId}`;
                let sub = this.results.coordinateCache.get(key);
                if (!sub) {
                    sub = [];
                    this.results.coordinateCache.set(key, sub);
                }
                sub.push(mapEntry);
                entries.push(mapEntry);
                this.results.explicitlyRemoved = this.results.explicitlyRemoved.filter((n)=>!(n.x === mapEntry.x && n.y === mapEntry.y && n.layerId === mapEntry.layerId));
            };
            const add = (mapEntry)=>{
                const { x: x, y: y } = mapEntry;
                addFor(x, y, mapEntry);
            };
            const remove = (x, y, layerId)=>{
                const key = `${x}-${y}-${layerId}`;
                let sub = this.results.coordinateCache.get(key);
                if (sub) {
                    sub = sub.filter((n)=>!(n.layerId === layerId && n.x === x && n.y === y));
                    if (sub.length > 0) this.results.coordinateCache.set(key, sub);
                    else this.results.coordinateCache.delete(key);
                }
                entries = entries.filter((n)=>!(n.layerId === layerId && n.x === x && n.y === y));
                this.results.explicitlyRemoved.push({
                    x: x,
                    y: y,
                    layerId: layerId,
                    mapId: this.roomId,
                    tileSpec: null
                });
            };
            const handleFragmentPointer = (x, y, fragmentPointer, entityId, context)=>{
                const fragmentMeta = this.tiledMapBuilder.featureCatalogs.featureByTag(fragmentPointer.catalog, fragmentPointer.tag);
                const caps = fragmentMeta.mapSpriteCaps.map((n)=>({
                        x: (0, $a80d0b17b615d6f7$export$b240a5f8651dffb4)(n.location.x),
                        y: (0, $a80d0b17b615d6f7$export$b240a5f8651dffb4)(n.location.y),
                        context: n.context
                    })).reduce((acc, next)=>({
                        ...acc,
                        [next.x + "-" + next.y]: next
                    }), {});
                const anchor = fragmentMeta.points.find((n)=>n.context?.anchor);
                const anchorPos = anchor ? (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(anchor.location) : undefined;
                const clearPointsForLayers = fragmentMeta.context?.clearPointsForLayers || [];
                for(let fy = 0; fy < fragmentMeta.dimensions.h; fy++)for(let fx = 0; fx < fragmentMeta.dimensions.w; fx++){
                    Object.keys(fragmentMeta.fragmentMaps).forEach((layerId)=>{
                        const spec = fragmentMeta.fragmentMaps[layerId]?.[fx]?.[fy];
                        if (spec) {
                            const curX = anchorPos ? fx - anchorPos.x : fx;
                            const curY = anchorPos ? fy - anchorPos.y : fy;
                            const isAnchorPos = fx === anchorPos?.x && fy === anchorPos?.y;
                            const entryObject = entry(curX + x, curY + y, spec.tilePos, layerId, spec.tilesetId, caps[`${fx}-${fy}`]?.context, {
                                ...fragmentMeta.context,
                                ...context || {},
                                primary: isAnchorPos
                            });
                            if (entityId) {
                                if (!entryObject.context) entryObject.context = {};
                                entryObject.context.entityId = entityId;
                            }
                            addFor(x, y, entryObject);
                        }
                    });
                    clearPointsForLayers.forEach((layerId)=>{
                        const curX = anchorPos ? fx - anchorPos.x : fx;
                        const curY = anchorPos ? fy - anchorPos.y : fy;
                        remove(curX + x, curY + y, layerId);
                    });
                }
                if (anchor?.context) {
                    const context = JSON.parse(anchor.context);
                    if (context?.blocking === "remove") remove(x, y, "blocking");
                    if (context?.occlusion === "remove") remove(x, y, "occlusion");
                }
            };
            const walls = (0, $5cfd87a852590fa6$export$d004d5a0cbfa247b)($d9b505386b42bf36$export$fd0298a827e6eac5(house, this.config.below), $d9b505386b42bf36$var$joinsOnly);
            const houseAuto = walls.indices;
            const roofAuto = (0, $5cfd87a852590fa6$export$19a7a8d2d9b0fbb7)(roof);
            const isRoof = (x, y)=>!!roof[y]?.[x];
            // A floor joins any floor beside it, except across a wall's foot where the two belong to different slabs
            // (`context.slab`): a tower standing up through a rampart's walkway has its own slab, so the walkway's paving
            // stops short of the tower's walls -- a cut the tower pokes through -- and meets it only in its doorways.
            // The cut turns a corner only where both cells beside the corner are the floor's own slab: in front of a
            // doorway one of them is the other slab's, and the threshold runs the doorway's full width.
            const slab = (x, y)=>floor[y]?.[x]?.context?.slab;
            const floorAuto = (0, $5cfd87a852590fa6$export$19a7a8d2d9b0fbb7)(floor, (x, y, nx, ny)=>slab(x, y) === slab(nx, ny) || !house[y]?.[x] && !house[ny]?.[nx] || nx !== x && ny !== y && (slab(nx, y) === slab(nx, ny) || slab(x, ny) === slab(nx, ny)));
            for(let y = 0; y < house.length; y++)for(let x = 0; x < house[y].length; x++){
                // print blocking tiles and occlusion tiles
                const tile = house[y][x];
                if (tile) {
                    const { blocking: blocking, occlusion: occlusion } = decorationsFor(tile.itemType);
                    if (blocking) entries.push({
                        mapId: roomId,
                        tileSpec: blocking,
                        layerId: "blocking",
                        x: x,
                        y: y
                    });
                    if (occlusion) add(entry(x, y, occlusion.tilePos, "occlusion", occlusion.tilesetId));
                }
                if (houseAuto[y][x]) debug.push({
                    text: `${houseAuto[y][x]}`,
                    x: x * 32,
                    y: y * 32
                });
                roofAuto[y][x];
                if (floorAuto[y][x]) debug.push({
                    text: `${floorAuto[y][x]}`,
                    x: x * 32,
                    y: y * 32
                });
                //
                // roof
                //
                if (roof[y][x] && (0, $48a990ae9133d7d6$export$1a9f2fca497fed07)(roofAuto[y][x])) add(entry(x, y, blockingTileSpec.tilePos, "skyTrigger"));
                if (roofAuto[y][x]) {
                    // A pitched material reads the whole roof (any material's cells shape it); a cell may
                    // carry an ornament (a chimney) on its piece, placed or scattered.
                    const material = $d9b505386b42bf36$export$374d003f514472fe.roofDefinitions.get(roof[y][x]?.itemType);
                    const tile = (0, $48a990ae9133d7d6$export$ae9b38edca1c9221)(material, roofAuto[y][x], isRoof, x, y, {
                        ornament: roof[y][x]?.context?.ornament,
                        storey: this.config.storey ?? 0,
                        worldOrigin: this.config.worldOrigin
                    });
                    add(entry(x, y, tile.tilePos, "sky", tile.tilesetId));
                }
                //
                // floor
                //
                if (floor[y][x]?.fragmentPointer) handleFragmentPointer(x, y, floor[y][x]?.fragmentPointer);
                else if (floorAuto[y][x] && $d9b505386b42bf36$export$374d003f514472fe.floorDefinitions.has(floor[y][x]?.itemType)) {
                    // Materials join each other like one floor: the autotile reads any floor neighbour.
                    const material = $d9b505386b42bf36$export$374d003f514472fe.floorDefinitions.get(floor[y][x].itemType);
                    const tile = (0, $4d955fa5af64f75a$export$a901f188b8d1362b)(material, floorAuto[y][x], x + (this.config.worldOrigin?.x ?? 0), y + (this.config.worldOrigin?.y ?? 0), this.config.storey ?? 0, floor[y][x]?.context?.ornament);
                    add(entry(x, y, tile, "map2", material.tilesetId));
                } else {
                    if (floorAuto[y][x] == 47) add(entry(x, y, 38, "map2", "floors"));
                    if (floorAuto[y][x] == 34) add(entry(x, y, 0, "map2", "floors"));
                    if (floorAuto[y][x] == 42) add(entry(x, y, 1, "map2", "floors"));
                    if (floorAuto[y][x] == 26) add(entry(x, y, 2, "map2", "floors"));
                    if (floorAuto[y][x] == 36) add(entry(x, y, 32, "map2", "floors"));
                    if (floorAuto[y][x] == 46) add(entry(x, y, 33, "map2", "floors"));
                    if (floorAuto[y][x] == 28) add(entry(x, y, 34, "map2", "floors"));
                    if (floorAuto[y][x] == 7) add(entry(x, y, 64, "map2", "floors"));
                    if (floorAuto[y][x] == 12) add(entry(x, y, 65, "map2", "floors"));
                    if (floorAuto[y][x] == 4) add(entry(x, y, 66, "map2", "floors"));
                    if (floorAuto[y][x] == 18) add(entry(x, y, 5, "map2", "floors"));
                    if (floorAuto[y][x] == 8) add(entry(x, y, 6, "map2", "floors"));
                    if (floorAuto[y][x] == 15) add(entry(x, y, 7, "map2", "floors"));
                    if (floorAuto[y][x] == 14) add(entry(x, y, 37, "map2", "floors"));
                    if (floorAuto[y][x] == 6) add(entry(x, y, 69, "map2", "floors"));
                    if (floorAuto[y][x] == 3) add(entry(x, y, 70, "map2", "floors"));
                    if (floorAuto[y][x] == 13) add(entry(x, y, 71, "map2", "floors"));
                    if (floorAuto[y][x] == 1) add(entry(x, y, 39, "map2", "floors"));
                    if (floorAuto[y][x] == 5) add(entry(x, y, 67, "map2", "floors"));
                    if (floorAuto[y][x] == 2) add(entry(x, y, 68, "map2", "floors"));
                    if (floorAuto[y][x] == 43) add(entry(x, y, 9, "map2", "floors"));
                    if (floorAuto[y][x] == 31) add(entry(x, y, 42, "map2", "floors"));
                    if (floorAuto[y][x] == 25) add(entry(x, y, 73, "map2", "floors"));
                    if (floorAuto[y][x] == 40) add(entry(x, y, 40, "map2", "floors"));
                    if (floorAuto[y][x] === 29) add(entry(x, y, 3, "map2", "floors"));
                    if (floorAuto[y][x] === 37) add(entry(x, y, 4, "map2", "floors"));
                    if (floorAuto[y][x] === 20) add(entry(x, y, 32, "map2", "floors"));
                    if (floorAuto[y][x] === 35) add(entry(x, y, 32, "map2", "floors"));
                    if (floorAuto[y][x] === 17) add(entry(x, y, 34, "map2", "floors"));
                    if (floorAuto[y][x] === 27) add(entry(x, y, 34, "map2", "floors"));
                    if (floorAuto[y][x] === 29) add(entry(x, y, 1, "map2", "floors"));
                    if (floorAuto[y][x] === 37) add(entry(x, y, 1, "map2", "floors"));
                    if (floorAuto[y][x] === 10) add(entry(x, y, 65, "map2", "floors"));
                    if (floorAuto[y][x] === 11) add(entry(x, y, 65, "map2", "floors"));
                    if (floorAuto[y][x] === 33) add(entry(x, y, 3, "map2", "floors"));
                    if (floorAuto[y][x] === 44) add(entry(x, y, 35, "map2", "floors"));
                    if (floorAuto[y][x] === 45) add(entry(x, y, 36, "map2", "floors"));
                    if (floorAuto[y][x] === 41) add(entry(x, y, 4, "map2", "floors"));
                    if (floorAuto[y][x] === 21) add(entry(x, y, 1, "map2", "floors"));
                    if (floorAuto[y][x] === 9) add(entry(x, y, 65, "map2", "floors"));
                    if (floorAuto[y][x] === 16) add(entry(x, y, 34, "map2", "floors"));
                    if (floorAuto[y][x] === 19) add(entry(x, y, 32, "map2", "floors"));
                    // default
                    if (floorAuto[y][x] && !exists(x, y, "map2")) add(entry(x, y, 33, "map2", "floors"));
                }
                if (floor2[y][x]?.fragmentPointer) handleFragmentPointer(x, y, floor2[y][x]?.fragmentPointer);
                if (decor[y][x]?.fragmentPointer) handleFragmentPointer(x, y, decor[y][x]?.fragmentPointer);
            }
            for(let y = 0; y < house.length; y++)for(let x = 0; x < house[y].length; x++){
                //
                // walls: each material's rules from content/game/maps/autotiles.json, row-major
                //
                // A wall cell's ornament: one placed on it (a window), or a scattered one (moss).
                const ornament = house[y][x] ? (0, $d06e01c1880d4b6a$export$9eba03b0b3dd1baf)($d9b505386b42bf36$export$374d003f514472fe.wallDefinitions.get(house[y][x].itemType), house[y][x].context?.ornament, x + (this.config.worldOrigin?.x ?? 0), y + (this.config.worldOrigin?.y ?? 0), this.config.storey ?? 0) : undefined;
                $d9b505386b42bf36$export$374d003f514472fe.autotilers.get(house[y][x]?.itemType)?.(x, y, walls.gridAt(x, y), {
                    add: add,
                    addFor: addFor,
                    exists: exists,
                    entry: entry
                }, {
                    storey: this.config.storey,
                    ornament: ornament
                });
                //
                // entities
                //
                if (entity[y][x]?.fragmentPointer) handleFragmentPointer(x, y, entity[y][x]?.fragmentPointer, entity[y][x]?.entityId, entity[y][x]?.context);
            }
            this.featureSpec = {
                dimensions: {
                    w: width,
                    h: height
                },
                mapEntries: entries,
                fragments: [],
                debug: debug
            };
        };
        this.config = config;
        this.results = {
            coordinateCache: new Map(),
            explicitlyRemoved: []
        };
    }
    static{
        this.createConfig = (blockingTileSpec, map)=>{
            if (!map?.layers) throw new Error("A generated house needs the Tiled house template from content (maps/sources/housetemplate.tmj)");
            const houseData = map.layers.find((l)=>l.properties.find((p)=>p.name === "blocking" && p.value === true)).data;
            const roofData = map.layers.find((l)=>l.properties.find((p)=>p.name === "sky" && p.value === true)).data;
            const height = map.height;
            const width = map.width;
            const house = (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(width, height);
            const roof = (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(width, height);
            const entity = (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(width, height);
            const floor = (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(width, height);
            const floor2 = (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(width, height);
            const decor = (0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(width, height);
            houseData.forEach((next, index)=>{
                const x = index % height;
                const y = Math.floor(index / width);
                if (next) house[y][x] = {
                    itemType: "wall2-wood"
                };
            });
            roofData.forEach((next, index)=>{
                const x = index % width;
                const y = Math.floor(index / height);
                if (next) roof[y][x] = {
                    itemType: "roof-wood"
                };
            });
            return {
                blockingTileSpec: blockingTileSpec,
                house: house,
                roof: roof,
                entity: entity,
                floor: floor,
                floor2: floor2,
                decor: decor
            };
        };
    }
}
// Which item builds which wall material, and how: rebuilt from the content on every activation, so
// a wall material deployed live from Sprite Lab is buildable without a restart.
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>{
    const walls = (0, $4d955fa5af64f75a$export$62c64c0877f888c5)(catalog.source.autotiles).walls;
    const materials = (0, $4d955fa5af64f75a$export$f9fae3e65c576dac)(walls);
    const definitions = new Map();
    const autotilers = new Map();
    materials.forEach((id, itemType)=>{
        const definition = walls.find((d)=>d.id === id);
        definitions.set(itemType, definition);
        autotilers.set(itemType, $d9b505386b42bf36$export$33638ba377d70cb2(definition));
    });
    const roofs = new Map((0, $4d955fa5af64f75a$export$62c64c0877f888c5)(catalog.source.autotiles).roofs.map((d)=>[
            d.itemType,
            d
        ]));
    const terrain = (0, $4d955fa5af64f75a$export$62c64c0877f888c5)(catalog.source.autotiles).terrain;
    const floor = terrain.find((d)=>d.id === "floor-wood");
    const floors = new Map(terrain.filter((d)=>d.kind === "bitmask" && d.itemType).map((d)=>[
            d.itemType,
            d
        ]));
    if (floor && !floors.has("floor-wood")) floors.set("floor-wood", floor);
    return {
        materials: materials,
        definitions: definitions,
        autotilers: autotilers,
        roofs: roofs,
        floor: floor,
        floors: floors
    };
}, (next)=>{
    $d9b505386b42bf36$export$374d003f514472fe.floorDefinition = next.floor;
    $d9b505386b42bf36$export$374d003f514472fe.floorDefinitions = next.floors;
    $d9b505386b42bf36$export$374d003f514472fe.roofDefinitions = next.roofs;
    $d9b505386b42bf36$export$374d003f514472fe.wallMaterials = next.materials;
    $d9b505386b42bf36$export$374d003f514472fe.wallDefinitions = next.definitions;
    $d9b505386b42bf36$export$374d003f514472fe.autotilers = next.autotilers;
});



parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $P8XPi = parcelRequire("P8XPi");









parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $P8XPi = parcelRequire("P8XPi");
var $6qzqq = parcelRequire("6qzqq");







// The window every animated helper is played in: a timber board with a gold spark and an overline,
// a step track that lights each step as the demonstration reaches it and stamps it once it is done,
// a diorama of the camp set into the board, a pointer that works the real controls inside it, a
// caption under it, and Replay once a play-through has finished. The building helper
// (building_tutorial.ts) was the first; the forager's wheel (forager_tutorial.ts) is the second.
//
// A subclass owns what is INSIDE the diorama -- it adds its scene to `content` and poses it in
// poseScene -- and hands this class the timeline's few facts: the steps, the caption at any instant
// and where the pointer is. Everything else is here, so every helper arrives, drags, replays and
// leaves alike.
//
// A helper played a step at a time is worked from the caption row, beside the words it is pacing:
// a small Back plate and a Next plate that lights up once its step has played and is waiting on the
// player, which hands its place to Replay at the end. The steps on the track can be picked too.
// Display caps are tracked with trackLetters: pixi's letterSpacing measures but does not draw here.
const $d88289c4fa93045f$var$OVERLINE_Y = 15;
const $d88289c4fa93045f$var$TITLE_Y = 27;
// The step track, between the title and the scene.
const $d88289c4fa93045f$var$TRACK_Y = 72;
const $d88289c4fa93045f$var$NODE_R = 6.5;
const $d88289c4fa93045f$var$NODE_LABEL_GAP = 6;
const $d88289c4fa93045f$var$LINK_GAP = 8;
const $d88289c4fa93045f$var$STEP_LIGHT_MS = 260;
// The close X: bare, like the clue notes' (clue_callout.ts), so the loudest thing on the board is
// never the way out of it.
const $d88289c4fa93045f$var$CLOSE_ARM = 3.75;
const $d88289c4fa93045f$var$CLOSE_HIT = 12;
// The caption row's controls: the action plate (Next, then Replay), and the square Back plate left
// of it. The caption wraps short of whatever the row holds.
const $d88289c4fa93045f$var$ACTION_W = 78;
const $d88289c4fa93045f$var$ACTION_H = 24;
const $d88289c4fa93045f$var$ACTION_GAP = 6;
const $d88289c4fa93045f$var$CAPTION_GAP = 10;
const $d88289c4fa93045f$var$ACTION_IN_MS = 220;
// Next lights over this long once its step has played; then it stays still, never breathing.
const $d88289c4fa93045f$var$NEXT_LIGHT_MS = 320;
// Arrival and departure: set down onto the screen, lifted away -- never a dialog popping.
const $d88289c4fa93045f$var$ENTER_MS = 320, $d88289c4fa93045f$var$ENTER_RISE = 12;
const $d88289c4fa93045f$var$LEAVE_MS = 170, $d88289c4fa93045f$var$LEAVE_DROP = 6;
const $d88289c4fa93045f$var$CAPTION_IN_MS = 240;
const $d88289c4fa93045f$var$DONE_TINT = 0xffe2a0;
const $d88289c4fa93045f$var$RIPPLE_MS = 460;
const $d88289c4fa93045f$export$3eaec8cae9ace885 = (ms)=>({
        alpha: ms < 0 ? 0 : (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(ms, 0, 120)),
        scale: ms < 0 ? 0 : (0, $a8782f4c6450260e$export$3a89f8d6f6bf6c9f)(1.9, 1, (0, $a8782f4c6450260e$export$3daa4a78f444687d)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(ms, 0, 320), 2.2)),
        checkDraw: (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(ms, 90, 380)),
        burstT: (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(ms, 0, 620),
        shineT: ms < 0 ? -1 : (0, $a8782f4c6450260e$export$24656b269d8df7d6)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(ms, 340, 1000))
    });
const $d88289c4fa93045f$var$cursorArrow = [
    0,
    0,
    0,
    13.5,
    3.3,
    10.4,
    5.7,
    15.6,
    7.9,
    14.6,
    5.6,
    9.6,
    9.9,
    9.6
];
const $d88289c4fa93045f$export$44282c4fb29fbea2 = (g, x, y, w, h)=>{
    // The vignette: stacked frames with ever-smaller holes, equal alpha each, so the falloff is
    // their accumulation -- darkest at the casing, gone a few cells in.
    for(let i = 1; i <= 8; i++){
        const d = i * 2.5;
        g.beginFill(0x000000, 0.045);
        g.drawRect(x, y, w, h);
        g.beginHole();
        g.drawRect(x + d, y + d, w - d * 2, h - d * 2);
        g.endHole();
        g.endFill();
    }
    // Inner shadow under the top lip.
    for(let i = 0; i < 4; i++)g.lineStyle(1, 0x000000, 0.34 - i * 0.075).moveTo(x, y + 0.5 + i).lineTo(x + w, y + 0.5 + i);
    // The casing: a band with chamfered inner corners, covering the scene's own square corners.
    g.lineStyle(0);
    g.beginFill((0, $658a44ce960354bb$export$c2ea448b59bcc1de), 1);
    g.drawRect(x - 3, y - 3, w + 6, h + 6);
    g.beginHole();
    (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x, y, w, h, 5);
    g.endHole();
    g.endFill();
    g.lineStyle({
        width: 1,
        color: (0, $658a44ce960354bb$export$dd27ce85ad53c944),
        alpha: 0.75,
        join: (0, $gwPoJ.LINE_JOIN).MITER
    });
    (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, x - 0.5, y - 0.5, w + 1, h + 1, 5.5);
    g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.22).moveTo(x + 6, y + h + 1.5).lineTo(x + w - 6, y + h + 1.5);
};
const $d88289c4fa93045f$export$3c35d57a4fa64702 = (g, t, times, cursorAt)=>{
    times.forEach((at)=>{
        const k = (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, at, at + $d88289c4fa93045f$var$RIPPLE_MS);
        if (t < at || k >= 1) return;
        const p = cursorAt(at);
        g.lineStyle(2, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.9 * Math.pow(1 - k, 1.5));
        g.drawCircle(p.x, p.y, (0, $a8782f4c6450260e$export$3a89f8d6f6bf6c9f)(3, 16, (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(k)));
        g.lineStyle(0);
        (0, $2f9f1514035da1ec$export$11572259c1b566fa)(g, p.x, p.y, 9, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.45 * (1 - k), 3);
    });
};
class $d88289c4fa93045f$export$fa9539309080be6 {
    constructor(label){
        this.plaque = new (0, $8t5Gy.Container)();
        // The plaque's burst, squashed flat so it fans out along the free row instead of up into the
        // step track.
        this.burst = new (0, $gwPoJ.Graphics)();
        this.plate = new (0, $gwPoJ.Graphics)();
        this.shine = new (0, $gwPoJ.Graphics)();
        this.size = {
            w: 0,
            h: 24
        };
        this.place = (x, y)=>{
            this.plaque.position.set(x, y);
            this.burst.position.set(x, y);
        };
        /** Pose it `ms` after it starts (negative: not yet). */ this.draw = (ms)=>{
            this.plaque.visible = ms >= 0;
            this.burst.clear();
            if (ms < 0) return;
            const pose = $d88289c4fa93045f$export$3eaec8cae9ace885(ms);
            this.plaque.alpha = pose.alpha;
            this.plaque.scale.set(pose.scale);
            const { w: w, h: h } = this.size;
            const plate = this.plate.clear();
            // Dropped straight down, then the cut-timber plate with a gold rim over a dark casing.
            plate.beginFill(0x000000, 0.4);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(plate, -w / 2, -h / 2 + 3, w, h, 5);
            plate.endFill();
            plate.lineStyle({
                width: 3.5,
                color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
                alpha: 1,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            plate.beginFill(0x1b1512, 0.97);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(plate, -w / 2, -h / 2, w, h, 5);
            plate.endFill();
            plate.lineStyle({
                width: 1.25,
                color: (0, $2f9f1514035da1ec$export$d8df7395f14ba24a),
                alpha: 1,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(plate, -w / 2, -h / 2, w, h, 5);
            plate.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.25).moveTo(-w / 2 + 6, -h / 2 + 2).lineTo(w / 2 - 6, -h / 2 + 2);
            plate.lineStyle(0);
            (0, $2f9f1514035da1ec$export$7957c9215476f232)(plate, -w / 2 + 17, 0, 7, pose.checkDraw);
            (0, $2f9f1514035da1ec$export$f2d9b1fa89f3b31e)(this.shine.clear(), -w / 2, -h / 2, w, h, pose.shineT, 22, 0.75);
            (0, $2f9f1514035da1ec$export$e1c6fe5ee848dc6d)(this.burst, 0, 0, pose.burstT, 14, w * 0.42, w * 0.78, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.2, 1.6);
        };
        const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(11).bold().strokeThickness(0).render((0, $ef882f0a643d87d9$export$dfb0a212724b9d91)(label));
        text.anchor.set(0, 0.5);
        let width = 0;
        try {
            text.updateText(true);
            width = text.width;
        } catch  {}
        width = Math.max(width, 80);
        const w = Math.round(width + 46);
        this.size.w = w;
        text.position.set(-w / 2 + 31, 0.5);
        text.tint = (0, $2f9f1514035da1ec$export$d8df7395f14ba24a);
        this.shine.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.plaque.addChild(this.plate, text, this.shine);
        this.plaque.visible = false;
        this.burst.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.burst.scale.set(1, 0.4);
    }
}
class $d88289c4fa93045f$export$88dde37a6e446e2d extends (0, $8t5Gy.Container) {
    constructor(icon, w, onTap, label){
        super(), this.icon = icon, this.w = w, this.lit = 0, this.plate = new (0, $gwPoJ.Graphics)(), this.glyph = new (0, $gwPoJ.Graphics)(), this.hovered = false, this.pressed = false, this.drawn = "", this.draw = ()=>{
            const k = this.hovered ? 1 : Math.max(0, Math.min(1, this.lit));
            const key = `${Math.round(k * 32)}:${this.hovered}:${this.pressed}`;
            if (key === this.drawn) return;
            this.drawn = key;
            const { w: w } = this, h = $d88289c4fa93045f$var$ACTION_H, dy = this.pressed ? 1 : 0;
            const g = this.plate.clear();
            // Dropped straight down; pressing closes the gap.
            g.beginFill(0x000000, 0.4);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 0, 3, w, h, 4);
            g.endFill();
            g.lineStyle({
                width: 3,
                color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
                alpha: 1,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            g.beginFill((0, $a8782f4c6450260e$export$671c724dbdd0c3a9)(0x1b1512, 0x33240f, k), 0.97);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 0, dy, w, h, 4);
            g.endFill();
            g.lineStyle({
                width: 1.25,
                color: this.hovered ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $658a44ce960354bb$export$dd27ce85ad53c944), (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), k),
                alpha: 1,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 0, dy, w, h, 4);
            g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.12 + 0.18 * k).moveTo(5, dy + 2).lineTo(w - 5, dy + 2);
            g.lineStyle(0);
            if (this.text) {
                this.text.y = h / 2 + dy;
                this.text.tint = (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $658a44ce960354bb$export$6b1db5e247c0ce0), (0, $658a44ce960354bb$export$8eb3a98fbc1bd246), k);
            }
            this.glyph.y = h / 2 + dy;
            this.drawGlyph((0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $658a44ce960354bb$export$6b1db5e247c0ce0), (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), k));
        }, this.drawGlyph = (color)=>{
            const g = this.glyph.clear();
            g.lineStyle({
                width: 1.75,
                color: color,
                alpha: 1,
                cap: (0, $gwPoJ.LINE_CAP).ROUND,
                join: (0, $gwPoJ.LINE_JOIN).ROUND
            });
            if (this.icon === "next") {
                g.moveTo(-2, -4).lineTo(2, 0).lineTo(-2, 4);
                return;
            }
            if (this.icon === "back") {
                g.moveTo(2, -4).lineTo(-2, 0).lineTo(2, 4);
                return;
            }
            // Replay: most of a turn clockwise, its head at the top right pointing back into the gap.
            const r = 4.25, from = Math.PI * 0.12, to = Math.PI * 1.72;
            g.moveTo(Math.cos(from) * r, Math.sin(from) * r);
            for(let i = 1; i <= 14; i++){
                const a = (0, $a8782f4c6450260e$export$3a89f8d6f6bf6c9f)(from, to, i / 14);
                g.lineTo(Math.cos(a) * r, Math.sin(a) * r);
            }
            g.lineStyle(0);
            const tip = {
                x: Math.cos(to) * r,
                y: Math.sin(to) * r
            };
            const along = {
                x: -Math.sin(to),
                y: Math.cos(to)
            };
            g.beginFill(color, 1).drawPolygon([
                tip.x + along.x * 3,
                tip.y + along.y * 3,
                tip.x - along.y * 2.6 - along.x * 0.8,
                tip.y + along.x * 2.6 - along.y * 0.8,
                tip.x + along.y * 2.6 - along.x * 0.8,
                tip.y - along.x * 2.6 - along.y * 0.8
            ]).endFill();
        };
        this.addChild(this.plate);
        // The glyph leads Replay, follows Next, and is all a Back plate holds; the pair is centred.
        const glyphW = 8, gap = 5;
        let textW = 0;
        if (label) {
            this.text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(10).bold().strokeThickness(0).render((0, $ef882f0a643d87d9$export$dfb0a212724b9d91)(label));
            this.text.anchor.set(0, 0.5);
            try {
                this.text.updateText(true);
                textW = this.text.width;
            } catch  {}
            textW = textW || label.length * 7.5;
            this.addChild(this.text);
        }
        const left = (w - (label ? textW + gap + glyphW : glyphW)) / 2;
        this.glyph.x = left + (icon === "next" ? textW + gap : 0) + glyphW / 2;
        if (this.text) this.text.x = icon === "next" ? left : left + glyphW + gap;
        this.addChild(this.glyph);
        this.interactive = true;
        this.cursor = "pointer";
        this.hitArea = new (0, $6qzqq.Rectangle)(-3, -5, w + 6, $d88289c4fa93045f$var$ACTION_H + 10);
        this.on("pointerover", ()=>{
            this.hovered = true;
            this.draw();
        });
        this.on("pointerout", ()=>{
            this.hovered = this.pressed = false;
            this.draw();
        });
        this.on("pointerdown", ()=>{
            this.pressed = true;
            this.draw();
        });
        this.on("pointerup", ()=>{
            this.pressed = false;
            this.draw();
        });
        this.on("pointerupoutside", ()=>{
            this.pressed = false;
            this.draw();
        });
        this.on("pointertap", (event)=>{
            event.stopPropagation();
            onTap();
        });
        this.draw();
    }
}
class $d88289c4fa93045f$export$1a9cc944b63e989c extends (0, $8t5Gy.Container) {
    constructor(layout, hover, dismiss){
        super(), this.layout = layout, this.hover = hover, this.dismiss = dismiss, this.content = new (0, $8t5Gy.Container)(), this.elapsed = 0, this.clock = 0, this.touch = false, this.trackGlow = new (0, $gwPoJ.Graphics)(), this.track = new (0, $gwPoJ.Graphics)(), this.trackLabels = [], this.trackX = [], this.pointer = new (0, $gwPoJ.Graphics)(), this.closeX = new (0, $gwPoJ.Graphics)(), this.manualStep = 0, this.nextShownAt = 0, this.backShownAt = 0, this.replayShownAt = 0, this.hoveredStep = -1, this.stepTargets = [], this.captionShownAt = 0, this.closeHovered = false, this.hovered = false, this.titleHandle = new (0, $gwPoJ.Graphics)(), this.drawHeader = ()=>{
            const { padX: padX } = this.layout;
            const sparkG = new (0, $gwPoJ.Graphics)();
            sparkG.beginFill((0, $658a44ce960354bb$export$319b6132a2fafb7c), 1);
            (0, $2f9f1514035da1ec$export$32465a74bc98bd3)(sparkG, padX + 3.5, $d88289c4fa93045f$var$OVERLINE_Y + 5.5, 3.5);
            sparkG.endFill();
            this.addChild(sparkG);
            const overline = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role("compactCaption").bold().strokeThickness(0).color((0, $658a44ce960354bb$export$6b1db5e247c0ce0)).render((0, $ef882f0a643d87d9$export$dfb0a212724b9d91)(this.layout.overline));
            overline.position.set(padX + 13, $d88289c4fa93045f$var$OVERLINE_Y);
            this.addChild(overline);
            const title = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(18).bold().strokeThickness(0).color((0, $658a44ce960354bb$export$8eb3a98fbc1bd246)).render(this.layout.title);
            title.position.set(padX, $d88289c4fa93045f$var$TITLE_Y);
            this.addChild(title);
        }, this.buildTrackLabels = ()=>{
            const { labels: labels } = this.layout.steps;
            const widths = labels.map((label)=>{
                const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(9).bold().strokeThickness(0).render((0, $ef882f0a643d87d9$export$dfb0a212724b9d91)(label));
                text.anchor.set(0, 0.5);
                text.y = $d88289c4fa93045f$var$TRACK_Y;
                this.trackLabels.push(text);
                this.addChild(text);
                // A headless canvas measures nothing; never let the track collapse onto itself.
                let width = 0;
                try {
                    text.updateText(true);
                    width = text.width;
                } catch  {}
                return Math.max(width, label.length * 6.5);
            });
            // Diamond, its label, then a link reaching to the next diamond; the links share what is left.
            const fixed = widths.reduce((sum, w)=>sum + $d88289c4fa93045f$var$NODE_R * 2 + $d88289c4fa93045f$var$NODE_LABEL_GAP + w, 0);
            const links = Math.max(1, labels.length - 1);
            const link = Math.max(12, (this.layout.contentWidth - fixed - $d88289c4fa93045f$var$LINK_GAP * links * 2) / links);
            let x = this.layout.padX;
            widths.forEach((w, i)=>{
                const node = x + $d88289c4fa93045f$var$NODE_R;
                const label = x + $d88289c4fa93045f$var$NODE_R * 2 + $d88289c4fa93045f$var$NODE_LABEL_GAP;
                this.trackLabels[i].x = label;
                x = label + w + $d88289c4fa93045f$var$LINK_GAP;
                this.trackX.push({
                    node: node,
                    label: label,
                    end: x
                });
                x += link + $d88289c4fa93045f$var$LINK_GAP;
            });
        }, this.buildStepTargets = ()=>{
            this.trackX.forEach(({ node: node, end: end }, i)=>{
                const target = new (0, $gwPoJ.Graphics)();
                const left = node - $d88289c4fa93045f$var$NODE_R - 4;
                target.beginFill(0xffffff, 0.001).drawRect(left, $d88289c4fa93045f$var$TRACK_Y - 11, end - $d88289c4fa93045f$var$LINK_GAP + 4 - left, 22).endFill();
                target.interactive = true;
                target.cursor = "pointer";
                target.on("pointerover", ()=>{
                    this.hoveredStep = i;
                });
                target.on("pointerout", ()=>{
                    if (this.hoveredStep === i) this.hoveredStep = -1;
                });
                target.on("pointertap", (event)=>{
                    event.stopPropagation();
                    this.goToStep(i);
                });
                this.stepTargets.push(target);
                this.addChild(target);
            });
        }, this.drawClose = ()=>{
            const g = this.closeX.clear();
            g.lineStyle({
                width: 1.8,
                color: this.closeHovered ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : (0, $658a44ce960354bb$export$c48687f662ce7e97),
                alpha: this.closeHovered ? 1 : 0.85,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            g.moveTo(-$d88289c4fa93045f$var$CLOSE_ARM, -$d88289c4fa93045f$var$CLOSE_ARM).lineTo($d88289c4fa93045f$var$CLOSE_ARM, $d88289c4fa93045f$var$CLOSE_ARM);
            g.moveTo($d88289c4fa93045f$var$CLOSE_ARM, -$d88289c4fa93045f$var$CLOSE_ARM).lineTo(-$d88289c4fa93045f$var$CLOSE_ARM, $d88289c4fa93045f$var$CLOSE_ARM);
            g.lineStyle(0);
        }, this.replay = ()=>{
            this.manualStep = 0;
            this.elapsed = 0;
            this.heldAt = undefined;
            this.rewind();
            this.animate(0);
        }, this.goToStep = (step)=>{
            const starts = this.layout.manualStepStarts;
            if (!starts || step < 0 || step >= starts.length) return;
            this.manualStep = step;
            this.elapsed = starts[step];
            this.heldAt = undefined;
            this.rewind();
            this.animate(0);
        }, this./** Fade away and dismiss, as the close X does. */ leave = ()=>{
            if (this.leavingAt === undefined) this.leavingAt = this.clock;
        }, this.startDrag = (event)=>{
            if (this.drag || !this.parent || (event.data.button ?? 0) !== 0) return;
            event.stopPropagation();
            const at = this.parent.toLocal(event.data.global);
            let interaction;
            try {
                interaction = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer.plugins.interaction;
            } catch  {}
            this.drag = {
                id: event.data.pointerId,
                offset: new (0, $6qzqq.Point)(at.x - this.x, at.y - this.y),
                interaction: interaction
            };
            this.manualPosition = this.position.clone();
            this.titleHandle.cursor = "grabbing";
            this.hovered = true;
            this.hover(true);
            interaction?.on("pointermove", this.moveDrag);
            interaction?.on("pointerup", this.endDrag);
            interaction?.on("pointerupoutside", this.endDrag);
            interaction?.on("pointercancel", this.endDrag);
        }, this.moveDrag = (event)=>{
            if (!this.drag || !this.parent || event.data.pointerId !== this.drag.id) return;
            event.stopPropagation();
            const at = this.parent.toLocal(event.data.global);
            this.manualPosition.set(at.x - this.drag.offset.x, at.y - this.drag.offset.y);
            this.placeWindow();
        }, this.endDrag = (event)=>{
            if (!this.drag || event && event.data.pointerId !== this.drag.id) return;
            const interaction = this.drag.interaction;
            interaction?.off("pointermove", this.moveDrag);
            interaction?.off("pointerup", this.endDrag);
            interaction?.off("pointerupoutside", this.endDrag);
            interaction?.off("pointercancel", this.endDrag);
            this.drag = undefined;
            this.titleHandle.cursor = "grab";
            this.hovered = !!event?.data?.global && this.getBounds().contains(event.data.global.x, event.data.global.y);
            this.hover(this.hovered);
        }, this.placeWindow = ()=>{
            const { width: width, height: height } = this.layout;
            const safe = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().safeViewport;
            const scale = Math.min(1, Math.max(0.5, (safe.width - 24) / width), Math.max(0.5, (safe.height - 100) / height));
            this.scale.set(scale);
            const desired = this.manualPosition || new (0, $6qzqq.Point)(safe.right - width * scale - 12, safe.top + Math.max(60, (safe.height - height * scale) / 2));
            const x = Math.max(safe.left, Math.min(desired.x, Math.max(safe.left, safe.right - width * scale)));
            const y = Math.max(safe.top, Math.min(desired.y, Math.max(safe.top, safe.bottom - height * scale)));
            this.position.set(x, y);
            this.manualPosition?.set(x, y);
        }, this.// ---- The frame ----------------------------------------------------------------------------
        animate = (deltaMs)=>{
            if (this.destroyed) return;
            const step = Math.max(0, deltaMs || 0);
            this.clock += step;
            // Arrival and departure ride on the PIVOT, so the position dragging reads stays clean.
            if (this.leavingAt !== undefined) {
                const k = (0, $a8782f4c6450260e$export$5da70c9577229d30)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(this.clock - this.leavingAt, 0, $d88289c4fa93045f$var$LEAVE_MS));
                this.alpha = 1 - k;
                this.pivot.y = -$d88289c4fa93045f$var$LEAVE_DROP * k;
                if (k >= 1) {
                    this.dismiss();
                    return;
                }
            } else {
                const k = (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(this.clock, 0, $d88289c4fa93045f$var$ENTER_MS);
                this.alpha = (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(Math.min(1, k * 1.6));
                this.pivot.y = -$d88289c4fa93045f$var$ENTER_RISE * (1 - (0, $a8782f4c6450260e$export$3daa4a78f444687d)(k, 1.4));
            }
            const starts = this.layout.manualStepStarts;
            const stop = starts?.[this.manualStep + 1];
            this.elapsed = Math.min(stop === undefined ? this.layout.durationMs : stop - 1, this.elapsed + step);
            const t = this.elapsed;
            this.poseScene(t, deltaMs);
            this.drawTrack(t);
            this.drawPointer(this.cursorAt(t));
            this.updateCaption(this.captionAt(t));
            this.poseActions(t, stop);
            this.placeWindow();
        }, this.poseActions = (t, stop)=>{
            const { replayAt: replayAt } = this.layout;
            const appear = (shownAt)=>(0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(this.clock - shownAt, 0, $d88289c4fa93045f$var$ACTION_IN_MS));
            const showReplay = t >= replayAt || !!this.nextButton && stop === undefined;
            if (showReplay && !this.replayButton.visible) this.replayShownAt = this.clock;
            this.replayButton.visible = showReplay;
            this.replayButton.alpha = appear(this.replayShownAt);
            this.replayButton.lit = (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, replayAt, replayAt + $d88289c4fa93045f$var$NEXT_LIGHT_MS));
            this.replayButton.draw();
            if (this.backButton) {
                const show = this.manualStep > 0;
                if (show && !this.backButton.visible) this.backShownAt = this.clock;
                this.backButton.visible = show;
                this.backButton.alpha = appear(this.backShownAt);
            }
            if (this.nextButton) {
                const show = stop !== undefined;
                if (show && !this.nextButton.visible) this.nextShownAt = this.clock;
                this.nextButton.visible = show;
                this.nextButton.alpha = appear(this.nextShownAt);
                const held = show && t >= stop - 1;
                if (held && this.heldAt === undefined) this.heldAt = this.clock;
                if (!held) this.heldAt = undefined;
                this.nextButton.lit = held ? (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(this.clock - this.heldAt, 0, $d88289c4fa93045f$var$NEXT_LIGHT_MS)) : 0;
                this.nextButton.draw();
            }
        }, this.drawTrack = (t)=>{
            const { labels: labels, litAt: litAt, doneAt: doneAt, linkFill: linkFill } = this.layout.steps;
            const g = this.track.clear();
            const glow = this.trackGlow.clear();
            // The links first, so the diamonds sit over their ends.
            linkFill.forEach(([from, to], i)=>{
                const x0 = this.trackX[i].end, x1 = this.trackX[i + 1].node - $d88289c4fa93045f$var$NODE_R - $d88289c4fa93045f$var$LINK_GAP;
                if (x1 <= x0) return;
                g.lineStyle(2, 0x000000, 0.55).moveTo(x0, $d88289c4fa93045f$var$TRACK_Y).lineTo(x1, $d88289c4fa93045f$var$TRACK_Y);
                g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.14).moveTo(x0, $d88289c4fa93045f$var$TRACK_Y + 1.5).lineTo(x1, $d88289c4fa93045f$var$TRACK_Y + 1.5);
                const fill = (0, $a8782f4c6450260e$export$24656b269d8df7d6)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, from, to));
                if (fill > 0) {
                    const head = (0, $a8782f4c6450260e$export$3a89f8d6f6bf6c9f)(x0, x1, fill);
                    g.lineStyle({
                        width: 2,
                        color: (0, $2f9f1514035da1ec$export$d8df7395f14ba24a),
                        alpha: 1,
                        cap: (0, $gwPoJ.LINE_CAP).ROUND
                    }).moveTo(x0, $d88289c4fa93045f$var$TRACK_Y).lineTo(head, $d88289c4fa93045f$var$TRACK_Y);
                    // The bead of light leading the fill, gone once it arrives.
                    if (fill < 1) (0, $2f9f1514035da1ec$export$11572259c1b566fa)(glow, head, $d88289c4fa93045f$var$TRACK_Y, 7, (0, $2f9f1514035da1ec$export$81e981a732c8ab4a), 0.8, 3);
                }
            });
            g.lineStyle(0);
            labels.forEach((_, i)=>{
                const cx = this.trackX[i].node, cy = $d88289c4fa93045f$var$TRACK_Y;
                const label = this.trackLabels[i];
                const doneMs = t - doneAt[i];
                const hovered = this.hoveredStep === i;
                // A step that can be picked answers the pointer with a bronze ring round its diamond.
                if (hovered) {
                    g.lineStyle({
                        width: 1,
                        color: (0, $658a44ce960354bb$export$6b1db5e247c0ce0),
                        alpha: 0.6,
                        join: (0, $gwPoJ.LINE_JOIN).MITER
                    });
                    (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(g, cx, cy, $d88289c4fa93045f$var$NODE_R + 3.5);
                    g.lineStyle(0);
                }
                if (doneMs >= 0) {
                    const stamp = (0, $a8782f4c6450260e$export$b67b2e3d2289fb95)(doneMs);
                    if (stamp.ringT < 1) {
                        g.lineStyle(1.25, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.8 * (1 - stamp.ringT));
                        (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(g, cx, cy, $d88289c4fa93045f$var$NODE_R + 1 + 11 * (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)(stamp.ringT));
                        g.lineStyle(0);
                    }
                    (0, $2f9f1514035da1ec$export$11572259c1b566fa)(glow, cx, cy, $d88289c4fa93045f$var$NODE_R * 2.4, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.5 * (1 - (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(doneMs, 0, 600))), 3);
                    (0, $2f9f1514035da1ec$export$e1c6fe5ee848dc6d)(glow, cx, cy, stamp.sparkT, 8, $d88289c4fa93045f$var$NODE_R + 2, $d88289c4fa93045f$var$NODE_R + 13, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), i);
                    (0, $2f9f1514035da1ec$export$7957c9215476f232)(g, cx, cy, $d88289c4fa93045f$var$NODE_R * stamp.socketScale, stamp.checkDraw);
                    label.tint = (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $658a44ce960354bb$export$6b1db5e247c0ce0), (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), stamp.labelGold);
                    return;
                }
                const lit = t >= litAt[i] ? (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, litAt[i], litAt[i] + $d88289c4fa93045f$var$STEP_LIGHT_MS)) : 0;
                if (lit > 0) {
                    // The step being shown breathes, gently, so the eye finds it.
                    const breathe = 0.5 - 0.5 * Math.cos((t - litAt[i]) / 1400 * Math.PI * 2);
                    (0, $2f9f1514035da1ec$export$11572259c1b566fa)(glow, cx, cy, $d88289c4fa93045f$var$NODE_R * 2.6, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), (0.22 + 0.12 * breathe) * lit, 3);
                }
                g.lineStyle({
                    width: 1.25,
                    color: (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $658a44ce960354bb$export$f0510412e0d12cd1), (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), lit),
                    alpha: 1,
                    join: (0, $gwPoJ.LINE_JOIN).MITER
                });
                g.beginFill((0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $658a44ce960354bb$export$f73e3f59ba72192a), 0x3a2810, lit), 0.95);
                (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(g, cx, cy, $d88289c4fa93045f$var$NODE_R);
                g.endFill();
                g.lineStyle(0);
                if (lit > 0) {
                    g.beginFill((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 1);
                    (0, $2f9f1514035da1ec$export$bc2a8782c99449da)(g, cx, cy, $d88289c4fa93045f$var$NODE_R * 0.42 * (0, $a8782f4c6450260e$export$3daa4a78f444687d)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, litAt[i], litAt[i] + $d88289c4fa93045f$var$STEP_LIGHT_MS), 2.4));
                    g.endFill();
                }
                label.tint = (0, $a8782f4c6450260e$export$671c724dbdd0c3a9)((0, $658a44ce960354bb$export$c48687f662ce7e97), (0, $658a44ce960354bb$export$8eb3a98fbc1bd246), hovered ? Math.max(lit, 0.75) : lit);
            });
        }, this.drawPointer = (pose)=>{
            const g = this.pointer.clear();
            if (!(pose.alpha > 0)) return;
            if (this.touch) {
                const r = pose.pressed ? 7.5 : 9;
                g.beginFill(0x000000, 0.3 * pose.alpha).drawCircle(pose.x + 1.5, pose.y + 2, r).endFill();
                g.lineStyle({
                    width: 1.4,
                    color: 0x1a120c,
                    alpha: pose.alpha
                });
                g.beginFill(pose.pressed ? 0xfff0c8 : 0xffffff, 0.85 * pose.alpha).drawCircle(pose.x, pose.y, r).endFill();
                g.lineStyle(0);
                return;
            }
            const s = pose.pressed ? 0.86 : 1;
            const at = (dx, dy)=>$d88289c4fa93045f$var$cursorArrow.map((v, i)=>i % 2 ? pose.y + dy + v * s : pose.x + dx + v * s);
            g.beginFill(0x000000, 0.35 * pose.alpha).drawPolygon(at(1.5, 2)).endFill();
            g.lineStyle({
                width: 1.4,
                color: 0x1a120c,
                alpha: pose.alpha,
                join: (0, $gwPoJ.LINE_JOIN).ROUND
            });
            g.beginFill(pose.pressed ? 0xfff0c8 : 0xffffff, pose.alpha).drawPolygon(at(0, 0)).endFill();
            g.lineStyle(0);
        }, this.updateCaption = ({ text: text, done: done })=>{
            if (this.caption.text !== text) {
                this.caption.text = text;
                this.captionShownAt = this.clock;
                // Leave room for whatever shares the row: always the step plates, or Replay once it is there.
                const controls = this.backButton ? $d88289c4fa93045f$var$ACTION_W + $d88289c4fa93045f$var$ACTION_GAP + $d88289c4fa93045f$var$ACTION_H : done ? $d88289c4fa93045f$var$ACTION_W : 0;
                this.caption.style.wordWrapWidth = this.layout.contentWidth - (controls && controls + $d88289c4fa93045f$var$CAPTION_GAP);
            }
            const k = (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(this.clock - this.captionShownAt, 0, $d88289c4fa93045f$var$CAPTION_IN_MS));
            this.caption.alpha = k;
            this.caption.y = this.layout.captionY + 5 * (1 - k);
            this.caption.tint = done ? $d88289c4fa93045f$var$DONE_TINT : (0, $658a44ce960354bb$export$8eb3a98fbc1bd246);
        }, this.destroy = ()=>{
            this.endDrag();
            if (this.hovered) this.hover(false);
            this.teardown();
            super.destroy({
                children: true
            });
        };
        const { width: width, height: height, padX: padX, captionY: captionY, captionH: captionH, contentWidth: contentWidth } = layout;
        const board = new (0, $gwPoJ.Graphics)();
        (0, $658a44ce960354bb$export$37d7f1037ab575d0)(board, width, height);
        this.addChild(board);
        this.drawHeader();
        this.trackGlow.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.addChild(this.trackGlow);
        this.addChild(this.track);
        this.buildTrackLabels();
        this.addChild(this.content);
        this.addChild(this.pointer);
        this.caption = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(13).color((0, $658a44ce960354bb$export$8eb3a98fbc1bd246)).strokeThickness(0).render("");
        this.caption.style.wordWrap = true;
        this.caption.style.wordWrapWidth = contentWidth;
        this.caption.position.set(padX, captionY);
        this.addChild(this.caption);
        // Next and Replay share the end of the caption row; Back sits just inside them.
        const actionX = width - padX - $d88289c4fa93045f$var$ACTION_W, actionY = captionY + (captionH - $d88289c4fa93045f$var$ACTION_H) / 2 - 2;
        this.replayButton = new $d88289c4fa93045f$export$88dde37a6e446e2d("replay", $d88289c4fa93045f$var$ACTION_W, this.replay, "REPLAY");
        this.replayButton.position.set(actionX, actionY);
        this.replayButton.visible = false;
        this.addChild(this.replayButton);
        if (layout.manualStepStarts) {
            this.backButton = new $d88289c4fa93045f$export$88dde37a6e446e2d("back", $d88289c4fa93045f$var$ACTION_H, ()=>this.goToStep(this.manualStep - 1));
            this.nextButton = new $d88289c4fa93045f$export$88dde37a6e446e2d("next", $d88289c4fa93045f$var$ACTION_W, ()=>this.goToStep(this.manualStep + 1), "NEXT");
            this.backButton.position.set(actionX - $d88289c4fa93045f$var$ACTION_GAP - $d88289c4fa93045f$var$ACTION_H, actionY);
            this.nextButton.position.set(actionX, actionY);
            this.addChild(this.backButton, this.nextButton);
            this.buildStepTargets();
        }
        this.titleHandle.beginFill(0xffffff, 0.001).drawRect(8, 6, width - 48, $d88289c4fa93045f$var$TRACK_Y - 16).endFill();
        this.titleHandle.interactive = true;
        this.titleHandle.cursor = "grab";
        this.titleHandle.on("pointerdown", this.startDrag);
        this.titleHandle.on("pointermove", this.moveDrag);
        this.titleHandle.on("pointerup", this.endDrag);
        this.titleHandle.on("pointerupoutside", this.endDrag);
        this.titleHandle.on("pointercancel", this.endDrag);
        this.addChild(this.titleHandle);
        this.closeX.position.set(width - 22, 22);
        this.closeX.interactive = true;
        this.closeX.cursor = "pointer";
        this.closeX.hitArea = new (0, $6qzqq.Circle)(0, 0, $d88289c4fa93045f$var$CLOSE_HIT);
        this.closeX.on("pointerover", ()=>{
            this.closeHovered = true;
            this.drawClose();
        });
        this.closeX.on("pointerout", ()=>{
            this.closeHovered = false;
            this.drawClose();
        });
        this.closeX.on("pointertap", (event)=>{
            event.stopPropagation();
            this.leave();
        });
        this.drawClose();
        this.addChild(this.closeX);
        this.interactive = true;
        this.on("mouseover", ()=>{
            this.hovered = true;
            this.hover(true);
        });
        this.on("mouseout", ()=>{
            if (!this.drag) {
                this.hovered = false;
                this.hover(false);
            }
        });
        this.on("pointerdown", (event)=>event.stopPropagation());
    // The subclass calls animate(0) once its scene exists.
    }
    /** Last things to let go of, before the children are destroyed. */ teardown() {}
}


// The building helper: a little diorama of the camp in which a pointer readies roof tiles, clicks each
// roof cell over the fire, and waits for them to build. It is a lesson the player watches rather
// than a form they read, so it is drawn in the camp HUD's own materials (build_board's timber and
// bronze, the clues' gold spark, the chapter checklist's diamonds and stamp) rather than as a panel of
// numbered sentences.
//
// Everything inside the frame is the REAL thing: the ready bar is the HUD's EquippedWidget; the walls
// and the roof are laid out by the camp's own HouseBuilder, so every wall cap, post and roof edge is
// the autotile a player's build gets, and the roof is raised off its cells by houseRoofOffset() as the
// map draws every roof; the hearth is the campfire's tiles and flame; and the cursor, the clicks,
// counting halo and the build are drawn by the game's own build cursor, BuildPlacementFeedback and
// BuildingPrintCountdown -- so what the demo shows is exactly what the player will see when they try
// it. Only the chrome around it (step track, pointer, the closing flourish) belongs to the demo; the
// window itself is tutorial_demo.ts.
// The board, and the diorama inside it. CELL must equal TileSize: the placement feedback draws in
// world tiles, and the scene is laid out on the same grid at 1:1.
const $52327f3b2610ea75$var$CELL = 32;
const $52327f3b2610ea75$var$COLS = 10, $52327f3b2610ea75$var$ROWS = 8;
const $52327f3b2610ea75$var$SCENE_W = $52327f3b2610ea75$var$COLS * $52327f3b2610ea75$var$CELL, $52327f3b2610ea75$var$SCENE_H = $52327f3b2610ea75$var$ROWS * $52327f3b2610ea75$var$CELL;
const $52327f3b2610ea75$var$WIDTH = $52327f3b2610ea75$var$SCENE_W + 44;
const $52327f3b2610ea75$var$SCENE_X = ($52327f3b2610ea75$var$WIDTH - $52327f3b2610ea75$var$SCENE_W) / 2;
const $52327f3b2610ea75$var$SCENE_Y = 92;
const $52327f3b2610ea75$var$CAPTION_Y = $52327f3b2610ea75$var$SCENE_Y + $52327f3b2610ea75$var$SCENE_H + 13;
const $52327f3b2610ea75$var$CAPTION_H = 36;
const $52327f3b2610ea75$var$HEIGHT = $52327f3b2610ea75$var$CAPTION_Y + $52327f3b2610ea75$var$CAPTION_H + 10;
// The starter shelter (EmberRoomService.ruinedWallCells): a 5×5 wooden perimeter round the hearth with
// a one-tile doorway east of centre on its south side. The roof begins on the north and west
// wall edges and grows inward until it covers the fire. Clear of the ready bar to its west; the rows
// above it hold the north wall's caps, the print dial and the stamp, all of which stand higher than
// the cells they belong to.
const $52327f3b2610ea75$var$HEARTH = {
    x: 6,
    y: 5
};
const $52327f3b2610ea75$var$SHELTER_RADIUS = 2;
const $52327f3b2610ea75$var$SHELTER_SIDE = $52327f3b2610ea75$var$SHELTER_RADIUS * 2 + 1;
const $52327f3b2610ea75$var$DOOR = {
    x: $52327f3b2610ea75$var$HEARTH.x + 1,
    y: $52327f3b2610ea75$var$HEARTH.y + $52327f3b2610ea75$var$SHELTER_RADIUS
};
const $52327f3b2610ea75$var$ROOF_SIDE = 3, $52327f3b2610ea75$var$ROOF_TILES = $52327f3b2610ea75$var$ROOF_SIDE * $52327f3b2610ea75$var$ROOF_SIDE;
const $52327f3b2610ea75$var$ROOF_LEFT = $52327f3b2610ea75$var$HEARTH.x - $52327f3b2610ea75$var$SHELTER_RADIUS, $52327f3b2610ea75$var$ROOF_TOP = $52327f3b2610ea75$var$HEARTH.y - $52327f3b2610ea75$var$SHELTER_RADIUS;
const $52327f3b2610ea75$var$ROOF_W = $52327f3b2610ea75$var$ROOF_SIDE * $52327f3b2610ea75$var$CELL, $52327f3b2610ea75$var$ROOF_H = $52327f3b2610ea75$var$ROOF_SIDE * $52327f3b2610ea75$var$CELL;
// The campfire's three composite tiles (lpc-terrain:760 is the one a placed campfire names), and the
// camp's flame standing in its logs -- as the forager's helper draws it.
const $52327f3b2610ea75$var$FIRE_X = ($52327f3b2610ea75$var$HEARTH.x + 0.5) * $52327f3b2610ea75$var$CELL;
const $52327f3b2610ea75$var$FIRE_BASE_Y = $52327f3b2610ea75$var$HEARTH.y * $52327f3b2610ea75$var$CELL + 20;
const $52327f3b2610ea75$var$FLAME_W = 34, $52327f3b2610ea75$var$FLAME_H = 44;
// Firelight is ADDED over grass, so it is starved of green: a gold glow there turns lime.
const $52327f3b2610ea75$var$FIRELIGHT = 0xff3d08;
// Player.buildGhostAlpha: a pending ghost at BUILD_GHOST_ALPHA that firms toward 0.7 as it counts down.
const $52327f3b2610ea75$var$GHOST_ALPHA = 0.4, $52327f3b2610ea75$var$GHOST_FIRM_ALPHA = 0.7;
// World stacking, as the map uses it: a cell's own sprites by their row, then the build overlays.
const $52327f3b2610ea75$var$rowZ = (y)=>100 + y * $52327f3b2610ea75$var$CELL + $52327f3b2610ea75$var$CELL / 3;
const $52327f3b2610ea75$var$GHOST_Z = 100000, $52327f3b2610ea75$var$CURSOR_Z = 100000.1, $52327f3b2610ea75$var$GUIDE_Z = 100001;
const $52327f3b2610ea75$var$cellKey = ({ x: x, y: y })=>`${x},${y}`;
const $52327f3b2610ea75$export$86de43c8770e5a7a = (side = $52327f3b2610ea75$var$ROOF_SIDE, left = $52327f3b2610ea75$var$ROOF_LEFT, top = $52327f3b2610ea75$var$ROOF_TOP)=>{
    const cells = [];
    for(let y = 0; y < side; y++)for(let x = 0; x < side; x++)cells.push({
        x: left + x,
        y: top + y
    });
    return cells;
};
const $52327f3b2610ea75$var$shelterWalls = ()=>$52327f3b2610ea75$export$86de43c8770e5a7a($52327f3b2610ea75$var$SHELTER_SIDE, $52327f3b2610ea75$var$HEARTH.x - $52327f3b2610ea75$var$SHELTER_RADIUS, $52327f3b2610ea75$var$HEARTH.y - $52327f3b2610ea75$var$SHELTER_RADIUS).filter(({ x: x, y: y })=>(x === $52327f3b2610ea75$var$HEARTH.x - $52327f3b2610ea75$var$SHELTER_RADIUS || x === $52327f3b2610ea75$var$HEARTH.x + $52327f3b2610ea75$var$SHELTER_RADIUS || y === $52327f3b2610ea75$var$HEARTH.y - $52327f3b2610ea75$var$SHELTER_RADIUS || y === $52327f3b2610ea75$var$HEARTH.y + $52327f3b2610ea75$var$SHELTER_RADIUS) && !(x === $52327f3b2610ea75$var$DOOR.x && y === $52327f3b2610ea75$var$DOOR.y));
/** The map entries the camp's builder lays for these walls and this roof (house_roof.ts does the same). */ const $52327f3b2610ea75$var$shelterEntries = (walls, roof)=>{
    // The builder reads its grids [y][x]; a square grid keeps blankMap's [x][y] from mattering.
    const grid = ()=>(0, $a80d0b17b615d6f7$export$4fece460db87ee7b)($52327f3b2610ea75$var$COLS, $52327f3b2610ea75$var$COLS);
    const house = grid(), roofGrid = grid();
    walls.forEach(({ x: x, y: y })=>{
        house[y][x] = {
            itemType: "wall-wood"
        };
    });
    roof.forEach(({ x: x, y: y })=>{
        roofGrid[y][x] = {
            itemType: "roof-wood"
        };
    });
    const builder = new (0, $d9b505386b42bf36$export$374d003f514472fe)({}, {
        blockingTileSpec: {
            tilePos: 121,
            tilesetId: "lpc-terrain"
        },
        house: house,
        roof: roofGrid,
        entity: grid(),
        floor: grid(),
        floor2: grid(),
        decor: grid()
    });
    builder.build("building-tutorial");
    return builder.featureSpec.mapEntries;
};
// A map entry's tilePos is 0-based within its tileset; the atlas names that cell frame tilePos + 1
// (TileMapMetaProvider.resolveTilesetTileId).
const $52327f3b2610ea75$var$atlasFrame = (entry)=>entry.tileSpec.tilePos + 1;
const $52327f3b2610ea75$export$2c027e71e4516370 = 11500;
const $52327f3b2610ea75$var$SELECT_AT = 900 // the pointer clicks the roof tiles on the ready bar
;
const $52327f3b2610ea75$var$PLACE_ATS = Array.from({
    length: $52327f3b2610ea75$var$ROOF_TILES
}, (_, i)=>1800 + i * 700);
const $52327f3b2610ea75$var$LAST_CLICK_AT = $52327f3b2610ea75$var$PLACE_ATS[$52327f3b2610ea75$var$PLACE_ATS.length - 1];
const $52327f3b2610ea75$var$PRINT_MS = 2700;
const $52327f3b2610ea75$var$BUILT_AT = $52327f3b2610ea75$var$LAST_CLICK_AT + $52327f3b2610ea75$var$PRINT_MS;
const $52327f3b2610ea75$var$STAMP_AT = $52327f3b2610ea75$var$BUILT_AT + 250;
const $52327f3b2610ea75$var$DONE_AT = $52327f3b2610ea75$var$BUILT_AT + 450;
const $52327f3b2610ea75$var$REPLAY_AT = 11000;
const $52327f3b2610ea75$var$RIPPLES = [
    $52327f3b2610ea75$var$SELECT_AT,
    ...$52327f3b2610ea75$var$PLACE_ATS
];
const $52327f3b2610ea75$var$CAPTIONS = [
    "Pick the roof tiles from your ready bar.",
    "Start at the wall edges and build inward to cover the fire.",
    "Wait for the roof tiles to finish building."
];
const $52327f3b2610ea75$var$DONE_CAPTION = "Your roof is up! The fire is covered.";
const $52327f3b2610ea75$var$DEMOLITION_HOLD_AT = 1200;
const $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT = $52327f3b2610ea75$var$DEMOLITION_HOLD_AT + 500;
const $52327f3b2610ea75$var$DEMOLITION_DEMO_MS = 3200;
const $52327f3b2610ea75$export$18748ad53601f9fd = (t)=>({
        pressed: t >= $52327f3b2610ea75$var$DEMOLITION_HOLD_AT && t < $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT,
        progress: (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $52327f3b2610ea75$var$DEMOLITION_HOLD_AT, $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT),
        removed: t >= $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT
    });
const $52327f3b2610ea75$export$27dd16fa374494ec = (elapsedMs)=>{
    const t = Math.min($52327f3b2610ea75$export$2c027e71e4516370, Math.max(0, elapsedMs));
    const tiles = $52327f3b2610ea75$var$PLACE_ATS.filter((at)=>t >= at).length;
    const builtTiles = $52327f3b2610ea75$var$PLACE_ATS.filter((at)=>t >= at + $52327f3b2610ea75$var$PRINT_MS).length;
    return {
        step: t < $52327f3b2610ea75$var$PLACE_ATS[0] ? 0 : t < $52327f3b2610ea75$var$LAST_CLICK_AT ? 1 : 2,
        selected: t < $52327f3b2610ea75$var$SELECT_AT ? 0 : 1,
        tiles: tiles,
        builtTiles: builtTiles,
        built: builtTiles === $52327f3b2610ea75$var$ROOF_TILES,
        done: t >= $52327f3b2610ea75$var$DONE_AT
    };
};
// A hand moves in arcs, not along a ruler.
const $52327f3b2610ea75$var$glide = (from, to, k)=>(0, $a8782f4c6450260e$export$75c48cadd9435142)(from, {
        x: (from.x + to.x) / 2,
        y: Math.min(from.y, to.y) - 18
    }, to, (0, $a8782f4c6450260e$export$24656b269d8df7d6)(k));
const $52327f3b2610ea75$export$a010dc3e42a47fb6 = (elapsedMs, at)=>{
    const t = Math.min($52327f3b2610ea75$export$2c027e71e4516370, Math.max(0, elapsedMs));
    let p = t < $52327f3b2610ea75$var$SELECT_AT ? $52327f3b2610ea75$var$glide(at.rest, at.slot, (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, 120, $52327f3b2610ea75$var$SELECT_AT - 100)) : t < $52327f3b2610ea75$var$PLACE_ATS[0] ? $52327f3b2610ea75$var$glide(at.slot, at.targets[0], (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $52327f3b2610ea75$var$SELECT_AT + 180, $52327f3b2610ea75$var$PLACE_ATS[0] - 80)) : at.targets[at.targets.length - 1];
    for(let i = 1; i < $52327f3b2610ea75$var$PLACE_ATS.length; i++)if (t >= $52327f3b2610ea75$var$PLACE_ATS[i - 1] && t < $52327f3b2610ea75$var$PLACE_ATS[i]) {
        p = $52327f3b2610ea75$var$glide(at.targets[i - 1], at.targets[i], (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $52327f3b2610ea75$var$PLACE_ATS[i - 1] + 180, $52327f3b2610ea75$var$PLACE_ATS[i] - 80));
        break;
    }
    if (t >= $52327f3b2610ea75$var$PLACE_ATS[$52327f3b2610ea75$var$PLACE_ATS.length - 1] + 180) {
        const k = (0, $a8782f4c6450260e$export$24656b269d8df7d6)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $52327f3b2610ea75$var$PLACE_ATS[$52327f3b2610ea75$var$PLACE_ATS.length - 1] + 180, $52327f3b2610ea75$var$PLACE_ATS[$52327f3b2610ea75$var$PLACE_ATS.length - 1] + 650));
        const last = at.targets[at.targets.length - 1];
        p = {
            x: last.x + 26 * k,
            y: last.y + 6 * k
        };
    }
    return {
        ...p,
        pressed: t >= $52327f3b2610ea75$var$SELECT_AT && t < $52327f3b2610ea75$var$SELECT_AT + 150 || $52327f3b2610ea75$var$PLACE_ATS.some((at)=>t >= at && t < at + 150),
        alpha: Math.min((0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, 0, 250)), 1 - (0, $a8782f4c6450260e$export$5da70c9577229d30)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $52327f3b2610ea75$var$PLACE_ATS[$52327f3b2610ea75$var$PLACE_ATS.length - 1] + 250, $52327f3b2610ea75$var$PLACE_ATS[$52327f3b2610ea75$var$PLACE_ATS.length - 1] + 750)))
    };
};
class $52327f3b2610ea75$export$2096d43a63683d03 extends (0, $d88289c4fa93045f$export$1a9cc944b63e989c) {
    constructor(hover, dismiss, mode = "build"){
        super({
            width: $52327f3b2610ea75$var$WIDTH,
            height: $52327f3b2610ea75$var$HEIGHT,
            padX: $52327f3b2610ea75$var$SCENE_X,
            contentWidth: $52327f3b2610ea75$var$SCENE_W,
            captionY: $52327f3b2610ea75$var$CAPTION_Y,
            captionH: $52327f3b2610ea75$var$CAPTION_H,
            overline: "BUILDING",
            title: mode === "demolish" ? "Tear down the old roof" : "Cover the fire",
            steps: mode === "demolish" ? {
                labels: [
                    "POINT",
                    "HOLD",
                    "REMOVE"
                ],
                litAt: [
                    0,
                    $52327f3b2610ea75$var$DEMOLITION_HOLD_AT,
                    $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT
                ],
                doneAt: [
                    1000,
                    $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT,
                    2600
                ],
                linkFill: [
                    [
                        1000,
                        $52327f3b2610ea75$var$DEMOLITION_HOLD_AT
                    ],
                    [
                        $52327f3b2610ea75$var$DEMOLITION_HOLD_AT,
                        $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT
                    ]
                ]
            } : {
                labels: [
                    "PICK",
                    "CLICK",
                    "BUILD"
                ],
                litAt: [
                    0,
                    $52327f3b2610ea75$var$PLACE_ATS[0],
                    $52327f3b2610ea75$var$LAST_CLICK_AT
                ],
                doneAt: [
                    $52327f3b2610ea75$var$SELECT_AT,
                    $52327f3b2610ea75$var$LAST_CLICK_AT,
                    $52327f3b2610ea75$var$BUILT_AT
                ],
                linkFill: [
                    [
                        $52327f3b2610ea75$var$SELECT_AT + 120,
                        $52327f3b2610ea75$var$PLACE_ATS[0]
                    ],
                    [
                        $52327f3b2610ea75$var$PLACE_ATS[0] + 100,
                        $52327f3b2610ea75$var$LAST_CLICK_AT
                    ]
                ]
            },
            durationMs: mode === "demolish" ? $52327f3b2610ea75$var$DEMOLITION_DEMO_MS : $52327f3b2610ea75$export$2c027e71e4516370,
            replayAt: mode === "demolish" ? 2800 : $52327f3b2610ea75$var$REPLAY_AT,
            manualStepStarts: mode === "demolish" ? [
                0,
                $52327f3b2610ea75$var$DEMOLITION_HOLD_AT,
                $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT
            ] : [
                0,
                $52327f3b2610ea75$var$PLACE_ATS[0],
                $52327f3b2610ea75$var$LAST_CLICK_AT
            ]
        }, hover, dismiss), this.mode = mode, this.scene = new (0, $8t5Gy.Container)(), this.frame = new (0, $gwPoJ.Graphics)(), this.fx = new (0, $gwPoJ.Graphics)(), this.hearthGlow = new (0, $gwPoJ.Graphics)(), this.target = new (0, $f982fe860ce57e21$export$7e8a46a1c03ab825)(()=>this.clock), this.inventory = {
            items: [
                "axe",
                "roof-wood"
            ].map((type, i)=>({
                    ...(0, $f684496fff50a7a1$export$9bccf79e85d1f187)((0, $f684496fff50a7a1$export$9efb6bfe58196888)(type), {
                        id: `tutorial-${type}`,
                        quantity: 1
                    }),
                    readied: true,
                    active: i === 0
                })),
            abilities: {},
            lastUpdateTs: 0
        }, this.art = [], this.roof = [], this.lift = (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)(), this.played = {
            tiles: 0,
            builtTiles: 0
        }, this.selected = -1, this.addTile = (sheet, tile, x, y, zIndex)=>{
            const sprite = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).EMPTY);
            sprite.position.set(x * $52327f3b2610ea75$var$CELL, y * $52327f3b2610ea75$var$CELL);
            sprite.width = $52327f3b2610ea75$var$CELL;
            sprite.height = $52327f3b2610ea75$var$CELL;
            sprite.zIndex = zIndex;
            this.scene.addChild(sprite);
            this.art.push({
                sprite: sprite,
                sheet: sheet,
                tile: tile
            });
        }, this.buildRoof = ()=>{
            const states = Array.from({
                length: $52327f3b2610ea75$var$ROOF_TILES
            }, (_, i)=>new Map($52327f3b2610ea75$var$shelterEntries([], $52327f3b2610ea75$export$86de43c8770e5a7a().slice(0, i + 1)).filter((entry)=>entry.layerId === "sky").map((entry)=>[
                        $52327f3b2610ea75$var$cellKey(entry),
                        entry
                    ])));
            $52327f3b2610ea75$export$86de43c8770e5a7a().forEach((cell)=>{
                const frames = states.map((state)=>state.get($52327f3b2610ea75$var$cellKey(cell))).map((entry)=>entry && $52327f3b2610ea75$var$atlasFrame(entry));
                const sprite = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).EMPTY);
                sprite.position.set(cell.x * $52327f3b2610ea75$var$CELL, cell.y * $52327f3b2610ea75$var$CELL + this.lift);
                sprite.width = $52327f3b2610ea75$var$CELL;
                sprite.height = $52327f3b2610ea75$var$CELL;
                sprite.zIndex = $52327f3b2610ea75$var$GHOST_Z;
                sprite.visible = false;
                this.scene.addChild(sprite);
                const entry = states[$52327f3b2610ea75$var$ROOF_TILES - 1].get($52327f3b2610ea75$var$cellKey(cell));
                this.roof.push({
                    sprite: sprite,
                    cell: cell,
                    sheet: entry?.tileSpec.tilesetId ?? "fence_medieval",
                    frames: frames
                });
            });
        }, this.buildFlame = ()=>{
            try {
                const fire = new (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)();
                // FireSprite seats its coals 3px left of its origin, as it would above a placed campfire;
                // land them on the logs' crossing (the pit art's row 16).
                fire.position.set($52327f3b2610ea75$var$FIRE_X + 3, $52327f3b2610ea75$var$FIRE_BASE_Y - 4);
                return fire;
            } catch  {
                // If the real flame can't be built, the roster card's live one stands in.
                const flame = new (0, $d4e9bfba8663fd0e$export$180e4127bb338fb5)($52327f3b2610ea75$var$FLAME_W, $52327f3b2610ea75$var$FLAME_H, {
                    glow: false
                });
                flame.position.set($52327f3b2610ea75$var$FIRE_X - $52327f3b2610ea75$var$FLAME_W / 2, $52327f3b2610ea75$var$FIRE_BASE_Y - $52327f3b2610ea75$var$FLAME_H);
                return flame;
            }
        }, this.dress = (sprite, sheet, tile)=>{
            const texture = (0, $1f08f7b8f85adf9e$export$42d948b5d3f64a60)(sheet)?.textures?.[`${sheet}-${tile}`] || (0, $klOfb.Texture).EMPTY;
            if (sprite.texture !== texture) {
                sprite.texture = texture;
                sprite.width = $52327f3b2610ea75$var$CELL;
                sprite.height = $52327f3b2610ea75$var$CELL;
            }
        }, this.poseDemolition = (t, deltaMs)=>{
            const pose = $52327f3b2610ea75$export$18748ad53601f9fd(t);
            this.art.forEach(({ sprite: sprite, sheet: sheet, tile: tile })=>this.dress(sprite, sheet, tile));
            this.roof.forEach(({ sprite: sprite, sheet: sheet, frames: frames }, i)=>{
                const frame = frames[$52327f3b2610ea75$var$ROOF_TILES - 1];
                sprite.visible = frame !== undefined && !(i === 0 && pose.removed);
                if (frame !== undefined) this.dress(sprite, sheet, frame);
                sprite.alpha = 1;
            });
            this.readyBar.visible = false;
            this.target.visible = this.liftGuide.visible = false;
            this.countdown.setGroups([], t);
            this.poseHearth(deltaMs);
            const x = $52327f3b2610ea75$var$SCENE_X + ($52327f3b2610ea75$var$ROOF_LEFT + 0.5) * $52327f3b2610ea75$var$CELL;
            const y = $52327f3b2610ea75$var$SCENE_Y + ($52327f3b2610ea75$var$ROOF_TOP + 0.5) * $52327f3b2610ea75$var$CELL + this.lift;
            const g = this.fx.clear();
            if (pose.pressed) {
                g.lineStyle(3, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.9);
                g.arc(x, y, 14, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * pose.progress);
            }
            if (pose.removed) (0, $2f9f1514035da1ec$export$e1c6fe5ee848dc6d)(g, x, y, (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT, $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT + 650), 12, 8, 35, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.7, 1.75);
            this.stamp.draw(t - $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT - 150);
        }, this.poseHearth = (deltaMs)=>{
            if (this.flame instanceof (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)) this.flame.setIntensity(0.6);
            else this.flame.update(deltaMs || 0, 0.6);
            const flicker = 0.5 + 0.5 * Math.sin(this.clock / 170) * Math.sin(this.clock / 310);
            (0, $2f9f1514035da1ec$export$11572259c1b566fa)(this.hearthGlow.clear(), $52327f3b2610ea75$var$FIRE_X, $52327f3b2610ea75$var$FIRE_BASE_Y - 4, 44, $52327f3b2610ea75$var$FIRELIGHT, 0.16 + 0.05 * flicker, 5);
        }, this.poseCursor = (t)=>{
            const pointer = this.cursorAt(t);
            const x = Math.floor((pointer.x - $52327f3b2610ea75$var$SCENE_X) / $52327f3b2610ea75$var$CELL), y = Math.floor((pointer.y - $52327f3b2610ea75$var$SCENE_Y) / $52327f3b2610ea75$var$CELL);
            const bar = this.readyBar;
            const overBar = pointer.x < bar.x + bar.width + 4 && pointer.y > bar.y - 4;
            const show = $52327f3b2610ea75$export$27dd16fa374494ec(t).selected === 1 && pointer.alpha > 0 && !overBar && x >= 0 && y >= 0 && x < $52327f3b2610ea75$var$COLS && y < $52327f3b2610ea75$var$ROWS;
            this.target.visible = show;
            this.liftGuide.visible = show && !pointer.pressed && t < $52327f3b2610ea75$var$BUILT_AT;
            if (show) {
                this.target.moveTo(x * $52327f3b2610ea75$var$CELL, y * $52327f3b2610ea75$var$CELL + this.lift);
                this.target.alpha = pointer.alpha;
                this.liftGuide.position.set((x + 0.5) * $52327f3b2610ea75$var$CELL, (y + 0.5) * $52327f3b2610ea75$var$CELL);
            }
            this.target.animate();
            this.liftGuide.pivot.set(-this.target.body.x, -this.target.body.y);
            this.liftGuide.alpha = this.target.body.alpha;
        }, this.playFeedback = (pose)=>{
            const cells = $52327f3b2610ea75$export$86de43c8770e5a7a();
            if (pose.tiles > this.played.tiles) {
                for(let i = this.played.tiles; i < pose.tiles; i++){
                    const cell = cells[i];
                    this.target.press();
                    this.feedback.add($52327f3b2610ea75$var$cellKey(cell), cell, this.lift);
                    this.feedback.setState($52327f3b2610ea75$var$cellKey(cell), "valid");
                    this.feedback.setCounting($52327f3b2610ea75$var$cellKey(cell), $52327f3b2610ea75$var$PLACE_ATS[i], i + 1);
                }
                this.played.tiles = pose.tiles;
            }
            if (pose.builtTiles > this.played.builtTiles) {
                for(let i = this.played.builtTiles; i < pose.builtTiles; i++){
                    const cell = cells[i];
                    this.feedback.remove($52327f3b2610ea75$var$cellKey(cell));
                    this.feedback.spark(cell, "built", this.lift);
                }
                this.played.builtTiles = pose.builtTiles;
                if (pose.built) this.feedback.settle(this.roof.map((tile)=>tile.sprite));
            }
            this.feedback.update();
        }, this.drawFx = (t)=>{
            const g = this.fx.clear();
            (0, $d88289c4fa93045f$export$3c35d57a4fa64702)(g, t, $52327f3b2610ea75$var$RIPPLES, (at)=>$52327f3b2610ea75$export$a010dc3e42a47fb6(at, this.cursorStops()));
            if (t < $52327f3b2610ea75$var$BUILT_AT) return;
            const ms = t - $52327f3b2610ea75$var$BUILT_AT;
            const x = $52327f3b2610ea75$var$SCENE_X + $52327f3b2610ea75$var$ROOF_LEFT * $52327f3b2610ea75$var$CELL, y = $52327f3b2610ea75$var$SCENE_Y + $52327f3b2610ea75$var$ROOF_TOP * $52327f3b2610ea75$var$CELL + this.lift;
            const cx = x + $52327f3b2610ea75$var$ROOF_W / 2, cy = y + $52327f3b2610ea75$var$ROOF_H / 2;
            // One warm bloom as the roof commits, then a band of light across the finished roof -- inside
            // its ragged plank ends, which have grass between them that ADD would turn lime.
            const bloom = 1 - (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(ms, 0, 700));
            if (bloom > 0) (0, $2f9f1514035da1ec$export$11572259c1b566fa)(g, cx, cy, $52327f3b2610ea75$var$ROOF_W * 0.6, (0, $2f9f1514035da1ec$export$81e981a732c8ab4a), 0.6 * bloom, 5);
            (0, $2f9f1514035da1ec$export$f2d9b1fa89f3b31e)(g, x + 4, y + 2, $52327f3b2610ea75$var$ROOF_W - 8, $52327f3b2610ea75$var$ROOF_H - 6, (0, $a8782f4c6450260e$export$24656b269d8df7d6)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(ms, 60, 760)), 26, 0.5);
            (0, $2f9f1514035da1ec$export$e1c6fe5ee848dc6d)(g, cx, cy, (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(ms, 0, 650), 14, $52327f3b2610ea75$var$ROOF_W * 0.3, $52327f3b2610ea75$var$ROOF_W * 0.75, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.4, 1.75);
        }, this.cursorStops = ()=>{
            const bar = this.readyBar;
            return {
                rest: {
                    x: $52327f3b2610ea75$var$SCENE_X + 9.3 * $52327f3b2610ea75$var$CELL,
                    y: $52327f3b2610ea75$var$SCENE_Y + 4.6 * $52327f3b2610ea75$var$CELL
                },
                slot: {
                    x: bar.x + (0, $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff) + (0, $9fb9be6d4b9a07da$export$1d2a07e77e913156) + (0, $9fb9be6d4b9a07da$export$4dc770bbadfb72db) * 0.55,
                    y: bar.y + (0, $9fb9be6d4b9a07da$export$ed8bdbd0a6d05eff) + (0, $9fb9be6d4b9a07da$export$4dc770bbadfb72db) * 0.5
                },
                targets: $52327f3b2610ea75$export$86de43c8770e5a7a().map(({ x: x, y: y })=>({
                        x: $52327f3b2610ea75$var$SCENE_X + (x + 0.5) * $52327f3b2610ea75$var$CELL,
                        y: $52327f3b2610ea75$var$SCENE_Y + (y + 0.5) * $52327f3b2610ea75$var$CELL
                    }))
            };
        };
        this.stamp = new (0, $d88289c4fa93045f$export$fa9539309080be6)(mode === "demolish" ? "TILE REMOVED" : "ROOF RAISED");
        // The diorama. Sortable, so everything keeps its world stacking: grass, then the walls and the
        // fire by row, then the roof, the cursor, the placement feedback and the print dial over all.
        this.scene.position.set($52327f3b2610ea75$var$SCENE_X, $52327f3b2610ea75$var$SCENE_Y);
        this.scene.sortableChildren = true;
        this.content.addChild(this.scene);
        for(let y = 0; y < $52327f3b2610ea75$var$ROWS; y++)for(let x = 0; x < $52327f3b2610ea75$var$COLS; x++)this.addTile("forest-grass", (0, $4bd29aa0ad024b1a$export$6b5b23411b38d591)(x, y), x, y, 0);
        this.hearthGlow.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.hearthGlow.zIndex = 1;
        this.scene.addChild(this.hearthGlow);
        [
            759,
            760,
            761
        ].forEach((tile, i)=>this.addTile("lpc-terrain", tile, $52327f3b2610ea75$var$HEARTH.x - 1 + i, $52327f3b2610ea75$var$HEARTH.y, $52327f3b2610ea75$var$rowZ($52327f3b2610ea75$var$HEARTH.y)));
        this.flame = this.buildFlame();
        this.flame.zIndex = $52327f3b2610ea75$var$rowZ($52327f3b2610ea75$var$HEARTH.y) + 1;
        this.scene.addChild(this.flame);
        $52327f3b2610ea75$var$shelterEntries($52327f3b2610ea75$var$shelterWalls(), []).filter((entry)=>entry.layerId === "sprite").forEach((entry)=>this.addTile(entry.tileSpec.tilesetId, $52327f3b2610ea75$var$atlasFrame(entry), entry.x, entry.y, $52327f3b2610ea75$var$rowZ(entry.y)));
        this.buildRoof();
        this.target.zIndex = $52327f3b2610ea75$var$CURSOR_Z;
        this.liftGuide = (0, $f982fe860ce57e21$export$ee41eff74b98381e)(new (0, $gwPoJ.Graphics)(), this.lift);
        this.liftGuide.zIndex = $52327f3b2610ea75$var$GUIDE_Z;
        this.target.visible = this.liftGuide.visible = false;
        this.scene.addChild(this.target, this.liftGuide);
        this.feedback = new (0, $f982fe860ce57e21$export$dd4b4b25282569d2)(()=>this.scene, ()=>this.clock);
        this.countdown = new (0, $e66d7f5cf01e9ed1$export$a3b4303fb9c66aa0)(()=>this.scene);
        // At 2x the dial is drawn the size it is on screen in the camp, so its seconds can be read.
        // Place it over the first tile as Player does for a single-tile build.
        this.countdown.scale.set(2, 2 * (0, $10da07838e6d507c$export$c6ec669adaa5980d));
        const dialX = ($52327f3b2610ea75$var$ROOF_LEFT + 0.5) * $52327f3b2610ea75$var$CELL, dialY = ($52327f3b2610ea75$var$ROOF_TOP + 0.5) * $52327f3b2610ea75$var$CELL + this.lift;
        this.countdown.position.set(dialX - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), dialY - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (0, $10da07838e6d507c$export$c6ec669adaa5980d));
        this.scene.addChild(this.countdown);
        (0, $d88289c4fa93045f$export$44282c4fb29fbea2)(this.frame, $52327f3b2610ea75$var$SCENE_X, $52327f3b2610ea75$var$SCENE_Y, $52327f3b2610ea75$var$SCENE_W, $52327f3b2610ea75$var$SCENE_H);
        this.content.addChild(this.frame);
        // The ready bar where the HUD keeps it: docked in the bottom-left corner of the view.
        this.readyBar = new (0, $9fb9be6d4b9a07da$export$ae188dfa452708ef)({});
        this.readyBar.position.set($52327f3b2610ea75$var$SCENE_X + 6, $52327f3b2610ea75$var$SCENE_Y + $52327f3b2610ea75$var$SCENE_H - (0, $9fb9be6d4b9a07da$export$97f31c0e24982bcb) - 6);
        this.content.addChild(this.readyBar);
        this.fx.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.content.addChild(this.fx);
        // Centred over the roof, in the free rows above it.
        this.stamp.place($52327f3b2610ea75$var$SCENE_X + $52327f3b2610ea75$var$FIRE_X, $52327f3b2610ea75$var$SCENE_Y + ($52327f3b2610ea75$var$ROOF_TOP * $52327f3b2610ea75$var$CELL + this.lift) / 2);
        this.content.addChild(this.stamp.burst, this.stamp.plaque);
        this.animate(0);
    }
    rewind() {
        this.feedback.clear();
        this.played = {
            tiles: 0,
            builtTiles: 0
        };
    }
    poseScene(t, deltaMs) {
        if (this.mode === "demolish") {
            this.poseDemolition(t, deltaMs);
            return;
        }
        const pose = $52327f3b2610ea75$export$27dd16fa374494ec(t);
        if (this.selected !== pose.selected) {
            this.selected = pose.selected;
            this.inventory.items.forEach((item, i)=>item.active = i === pose.selected);
            this.readyBar.update(this.inventory, ()=>{});
        }
        this.readyBar.animate(deltaMs);
        this.art.forEach(({ sprite: sprite, sheet: sheet, tile: tile })=>this.dress(sprite, sheet, tile));
        // Each click adds one ghost tile; its countdown firms that tile into place on its own.
        this.roof.forEach(({ sprite: sprite, sheet: sheet, frames: frames }, i)=>{
            const frame = frames[pose.tiles - 1];
            sprite.visible = i < pose.tiles && frame !== undefined;
            if (frame !== undefined) this.dress(sprite, sheet, frame);
            const firm = (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $52327f3b2610ea75$var$PLACE_ATS[i], $52327f3b2610ea75$var$PLACE_ATS[i] + $52327f3b2610ea75$var$PRINT_MS);
            sprite.alpha = pose.builtTiles > i ? 1 : (0, $a8782f4c6450260e$export$3a89f8d6f6bf6c9f)($52327f3b2610ea75$var$GHOST_ALPHA, $52327f3b2610ea75$var$GHOST_FIRM_ALPHA, firm * firm * (3 - 2 * firm));
        });
        this.poseHearth(deltaMs);
        this.poseCursor(t);
        this.playFeedback(pose);
        this.countdown.setGroups($52327f3b2610ea75$export$86de43c8770e5a7a().map((cell, i)=>({
                id: i + 1,
                anchor: {
                    x: (cell.x - $52327f3b2610ea75$var$ROOF_LEFT) / 2,
                    y: (cell.y - $52327f3b2610ea75$var$ROOF_TOP) / (2 * (0, $10da07838e6d507c$export$c6ec669adaa5980d))
                },
                startedAt: $52327f3b2610ea75$var$PLACE_ATS[i],
                duration: $52327f3b2610ea75$var$PRINT_MS,
                count: 1,
                onCancel: ()=>{}
            })).filter((_, i)=>pose.tiles > i && pose.builtTiles <= i), t);
        this.drawFx(t);
        this.stamp.draw(t - $52327f3b2610ea75$var$STAMP_AT);
    }
    cursorAt(t) {
        if (this.mode === "demolish") {
            const target = {
                x: $52327f3b2610ea75$var$SCENE_X + ($52327f3b2610ea75$var$ROOF_LEFT + 0.5) * $52327f3b2610ea75$var$CELL,
                y: $52327f3b2610ea75$var$SCENE_Y + ($52327f3b2610ea75$var$ROOF_TOP + 0.5) * $52327f3b2610ea75$var$CELL + this.lift
            };
            return {
                ...$52327f3b2610ea75$var$glide({
                    x: target.x + 80,
                    y: target.y + 60
                }, target, (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, 150, 1000)),
                pressed: $52327f3b2610ea75$export$18748ad53601f9fd(t).pressed,
                alpha: 1 - (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT + 200, $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT + 700))
            };
        }
        return $52327f3b2610ea75$export$a010dc3e42a47fb6(t, this.cursorStops());
    }
    captionAt(t) {
        if (this.mode === "demolish") return {
            text: t < $52327f3b2610ea75$var$DEMOLITION_HOLD_AT ? "Point at a roof tile you want to destroy." : t < $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT ? "Press and hold for half a second to destroy the tile." : "The tile is removed. Repeat to tear down the old roof.",
            done: t >= $52327f3b2610ea75$var$DEMOLITION_REMOVED_AT
        };
        const pose = $52327f3b2610ea75$export$27dd16fa374494ec(t);
        return {
            text: pose.done ? $52327f3b2610ea75$var$DONE_CAPTION : $52327f3b2610ea75$var$CAPTIONS[pose.step],
            done: pose.done
        };
    }
    // First: the feedback destroys its own graphics, which the children sweep would otherwise
    // destroy a second time.
    teardown() {
        this.feedback.destroy();
        // The real flame plays on the shared ticker; its baked frames are shared and stay.
        if (this.flame instanceof (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)) this.flame.cleanup();
    }
}





parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");








const $3de9dff7c679ccea$export$9b9dbbbbcf1fc0eb = 7600;
const $3de9dff7c679ccea$var$RUN_AT = 1800, $3de9dff7c679ccea$var$REST_AT = 4600;
const $3de9dff7c679ccea$var$X = 22, $3de9dff7c679ccea$var$Y = 92, $3de9dff7c679ccea$var$W = 320, $3de9dff7c679ccea$var$H = 192;
const $3de9dff7c679ccea$export$f788e64535bf5af6 = (elapsedMs)=>{
    const t = Math.max(0, Math.min($3de9dff7c679ccea$export$9b9dbbbbcf1fc0eb, elapsedMs));
    const sprinting = t >= $3de9dff7c679ccea$var$RUN_AT && t < $3de9dff7c679ccea$var$REST_AT - 200;
    const walking = t < $3de9dff7c679ccea$var$RUN_AT - 200;
    return {
        step: t < $3de9dff7c679ccea$var$RUN_AT ? 0 : t < $3de9dff7c679ccea$var$REST_AT ? 1 : 2,
        moving: walking || sprinting,
        sprinting: sprinting,
        x: 42 + 48 * (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, 200, 1600) + 134 * (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $3de9dff7c679ccea$var$RUN_AT, $3de9dff7c679ccea$var$REST_AT - 200),
        stamina: t < $3de9dff7c679ccea$var$RUN_AT ? 1 : t < $3de9dff7c679ccea$var$REST_AT ? 1 - 0.85 * (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $3de9dff7c679ccea$var$RUN_AT, $3de9dff7c679ccea$var$REST_AT - 200) : 0.15 + 0.85 * (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $3de9dff7c679ccea$var$REST_AT + 200, $3de9dff7c679ccea$export$9b9dbbbbcf1fc0eb - 300),
        done: t >= $3de9dff7c679ccea$export$9b9dbbbbcf1fc0eb - 200
    };
};
class $3de9dff7c679ccea$export$80c7bb7133a52b84 extends (0, $d88289c4fa93045f$export$1a9cc944b63e989c) {
    constructor(hover, dismiss, touch = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)(), player){
        super({
            width: 364,
            height: 378,
            padX: $3de9dff7c679ccea$var$X,
            contentWidth: $3de9dff7c679ccea$var$W,
            captionY: 300,
            captionH: 64,
            overline: "MOVEMENT",
            title: "Make haste",
            steps: {
                labels: [
                    "MOVE",
                    "SPRINT",
                    "RECOVER"
                ],
                litAt: [
                    0,
                    $3de9dff7c679ccea$var$RUN_AT,
                    $3de9dff7c679ccea$var$REST_AT
                ],
                doneAt: [
                    1500,
                    4350,
                    7300
                ],
                linkFill: [
                    [
                        1500,
                        $3de9dff7c679ccea$var$RUN_AT
                    ],
                    [
                        4350,
                        $3de9dff7c679ccea$var$REST_AT
                    ]
                ]
            },
            durationMs: $3de9dff7c679ccea$export$9b9dbbbbcf1fc0eb,
            replayAt: $3de9dff7c679ccea$export$9b9dbbbbcf1fc0eb - 100,
            manualStepStarts: [
                0,
                $3de9dff7c679ccea$var$RUN_AT,
                $3de9dff7c679ccea$var$REST_AT
            ]
        }, hover, dismiss), this.scene = new (0, $8t5Gy.Container)(), this.art = [], this.runner = new (0, $64e038f1765e0ab3$export$f3390963b1a1dc25)("sprint-tutorial"), this.body = new (0, $cb689cfa16c444ba$export$bc644a473284d944)(), this.controls = new (0, $gwPoJ.Graphics)(), this.stamina = new (0, $1401bf9c6a4e7405$export$160dd9b73ca3e58e)(), this.dust = new (0, $gwPoJ.Graphics)();
        this.touch = touch;
        this.scene.position.set($3de9dff7c679ccea$var$X, $3de9dff7c679ccea$var$Y);
        this.content.addChild(this.scene);
        for(let y = 0; y < 6; y++)for(let x = 0; x < 10; x++){
            const tile = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).EMPTY);
            tile.position.set(x * 32, y * 32);
            this.art.push(tile);
            this.scene.addChild(tile);
        }
        this.scene.addChild(this.dust, this.runner);
        this.body.entityType = "player";
        this.body.appearance = player?.appearance || (0, $1a2d6d21d6b0fac8$export$b7be1ee14f302b62)(undefined, "human", "male");
        if (player?.inventory) this.body.inventory = player.inventory;
        this.body.weapon = {
            weaponType: "none"
        };
        this.body.movement.angle = Math.PI * 2;
        this.runner.updatePaperdoll(this.body);
        this.stamina.position.set($3de9dff7c679ccea$var$W - 104, 12);
        this.scene.addChild(this.stamina, this.controls);
        const label = (text, x)=>{
            const node = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(11).bold().strokeThickness(0).render(text);
            node.position.set(x, 163);
            node.anchor.set(0.5);
            this.scene.addChild(node);
            return node;
        };
        this.shift = label(touch ? "MOVE STICK" : "SHIFT", 65);
        this.direction = label(touch ? "TO THE RIM" : "+   D  \u2192", 174);
        const frame = new (0, $gwPoJ.Graphics)();
        (0, $d88289c4fa93045f$export$44282c4fb29fbea2)(frame, $3de9dff7c679ccea$var$X, $3de9dff7c679ccea$var$Y, $3de9dff7c679ccea$var$W, $3de9dff7c679ccea$var$H);
        this.content.addChild(frame);
        this.animate(0);
    }
    cursorAt(_t) {
        return {
            x: 0,
            y: 0,
            pressed: false,
            alpha: 0
        };
    }
    captionAt(t) {
        const pose = $3de9dff7c679ccea$export$f788e64535bf5af6(t);
        const captions = this.touch ? [
            "Push the movement stick to walk.",
            "Push it to the rim to run faster.",
            "Ease off to recover stamina. Watch the bar beside your hearts."
        ] : [
            "Hold WASD or an arrow key to walk.",
            "Hold SHIFT + a direction to run faster.",
            "Release SHIFT to recover stamina. Watch the bar beside your hearts."
        ];
        return {
            text: captions[pose.step],
            done: pose.done
        };
    }
    rewind() {}
    poseScene(t, deltaMs) {
        const pose = $3de9dff7c679ccea$export$f788e64535bf5af6(t);
        this.art.forEach((tile, i)=>{
            const frame = (0, $4bd29aa0ad024b1a$export$6b5b23411b38d591)(i % 10, Math.floor(i / 10));
            const texture = (0, $1f08f7b8f85adf9e$export$42d948b5d3f64a60)("forest-grass")?.textures?.[`forest-grass-${frame}`] || (0, $klOfb.Texture).EMPTY;
            if (tile.texture !== texture) {
                tile.texture = texture;
                tile.width = tile.height = 32;
            }
        });
        this.runner.position.set(pose.x, 91);
        // The real sprite driver observes position changes, not just the moving flag.
        this.body.location = {
            x: pose.x,
            y: 91
        };
        this.body.speed = pose.sprinting ? 160 : 100;
        this.body.movement.moving = pose.moving;
        this.body.boosted = pose.sprinting;
        this.body.speed2 = {
            x: pose.moving ? 1 : 0,
            y: 0
        };
        this.runner.doMovement(this.body);
        this.stamina.update(pose.stamina);
        this.stamina.animate(deltaMs);
        const g = this.controls.clear();
        [
            {
                x: 20,
                w: 90,
                active: pose.sprinting
            },
            {
                x: 122,
                w: 104,
                active: pose.moving
            }
        ].forEach((key)=>{
            g.lineStyle(1, key.active ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : (0, $658a44ce960354bb$export$dd27ce85ad53c944), 0.95).beginFill(key.active ? 0x594326 : 0x1b1512, 0.95).drawRoundedRect(key.x, 149, key.w, 28, 4).endFill();
            g.lineStyle(1, (0, $658a44ce960354bb$export$8eb3a98fbc1bd246), key.active ? 0.25 : 0.08).moveTo(key.x + 5, 151).lineTo(key.x + key.w - 5, 151);
        });
        this.shift.tint = pose.sprinting ? (0, $658a44ce960354bb$export$8eb3a98fbc1bd246) : (0, $658a44ce960354bb$export$c48687f662ce7e97);
        this.direction.tint = pose.moving ? (0, $658a44ce960354bb$export$8eb3a98fbc1bd246) : (0, $658a44ce960354bb$export$c48687f662ce7e97);
        this.dust.clear();
        if (pose.sprinting) for(let i = 0; i < 5; i++){
            const phase = (t / 500 + i / 5) % 1;
            this.dust.beginFill(0xcbb49a, (1 - phase) * 0.35).drawCircle(pose.x - 8 - phase * 22, 120 - phase * 6, 1 + phase * 2).endFill();
        }
    }
}








parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $P8XPi = parcelRequire("P8XPi");









// The forager's wheel, shown once the chapter-three forager has walked in to the fire: a pointer
// right-clicks him (on a touch screen, holds on him), his wheel opens, Orders turns it to the jobs
// he can be given, and Feed Fire sends him to the hearth. Chapter three teaches this first work order; the demo shows how to open the wheel.
//
// As with the building helper (building_tutorial.ts), what is inside the frame is the REAL thing:
// the man is an LPC body in the recruit's own look, lit by the game's hover outline; the wheel is
// the HUD's CommandWheel, bound exactly as GuiManager binds it (his verbs ranked by the same rule,
// then the forager's own orders page) and worked by hand through its hoverAt/pressAt, so its light,
// needle and pick flash are the ones the player will see. The campfire is the camp's own tiles.
const $a9a9835bf946efb8$var$CELL = 32;
const $a9a9835bf946efb8$var$COLS = 10, $a9a9835bf946efb8$var$ROWS = 6;
const $a9a9835bf946efb8$var$SCENE_W = $a9a9835bf946efb8$var$COLS * $a9a9835bf946efb8$var$CELL, $a9a9835bf946efb8$var$SCENE_H = $a9a9835bf946efb8$var$ROWS * $a9a9835bf946efb8$var$CELL;
const $a9a9835bf946efb8$var$WIDTH = $a9a9835bf946efb8$var$SCENE_W + 44;
const $a9a9835bf946efb8$var$SCENE_X = ($a9a9835bf946efb8$var$WIDTH - $a9a9835bf946efb8$var$SCENE_W) / 2;
const $a9a9835bf946efb8$var$SCENE_Y = 92;
const $a9a9835bf946efb8$var$CAPTION_Y = $a9a9835bf946efb8$var$SCENE_Y + $a9a9835bf946efb8$var$SCENE_H + 13;
const $a9a9835bf946efb8$var$CAPTION_H = 36;
const $a9a9835bf946efb8$var$HEIGHT = $a9a9835bf946efb8$var$CAPTION_Y + $a9a9835bf946efb8$var$CAPTION_H + 10;
// The hearth: the campfire's three composite tiles (lpc-terrain:760 is the one a placed campfire
// names; its neighbours either side complete the art), logs centred on the middle one, and the
// camp's own flame standing in them.
const $a9a9835bf946efb8$var$FIRE_COL = 1, $a9a9835bf946efb8$var$FIRE_ROW = 3;
const $a9a9835bf946efb8$var$FIRE_X = ($a9a9835bf946efb8$var$FIRE_COL + 1.5) * $a9a9835bf946efb8$var$CELL;
const $a9a9835bf946efb8$var$FIRE_BASE_Y = $a9a9835bf946efb8$var$FIRE_ROW * $a9a9835bf946efb8$var$CELL + 20;
// Without a renderer to bake the real flame (a test), the roster card's live one stands in.
const $a9a9835bf946efb8$var$FLAME_W = 34, $a9a9835bf946efb8$var$FLAME_H = 44;
// The forager: standing a few paces off the fire, facing out. A body is drawn about its HIP; the
// soles are FEET_BELOW_HIP under it (see build_page's FEET_OFFSET).
const $a9a9835bf946efb8$var$FEET_BELOW_HIP = 28;
const $a9a9835bf946efb8$var$FORAGER_X = 5.5 * $a9a9835bf946efb8$var$CELL;
const $a9a9835bf946efb8$var$FORAGER_HIP_Y = 4 * $a9a9835bf946efb8$var$CELL + 4 - $a9a9835bf946efb8$var$FEET_BELOW_HIP;
// The wheel opens over him as it does in the camp, a little smaller so his six orders fit the frame.
const $a9a9835bf946efb8$var$WHEEL_RADIUS = 64 // the HUD's COMMAND_WHEEL_RADIUS
;
// Firelight is ADDED over grass, so it is starved of green: a gold glow there turns lime.
const $a9a9835bf946efb8$var$FIRELIGHT = 0xff3d08 // FORGE.blaze, the camp's additive-only fire colour
;
const $a9a9835bf946efb8$var$WHEEL_SCALE = 0.86;
// The verbs a hired forager offers (lib/member_verbs.js), and the order this demo gives.
const $a9a9835bf946efb8$var$MEMBER_VERBS = (0, $0fb3f7f2a67be6e3$export$112177784473fc2f)([
    {
        type: "command"
    },
    {
        type: "food"
    },
    {
        type: "inventory"
    }
]);
const $a9a9835bf946efb8$var$ORDERS = "command";
const $a9a9835bf946efb8$var$FEED_FIRE = "forager:feed_fire";
const $a9a9835bf946efb8$var$DEMO_ENTITY = "forager-tutorial";
const $a9a9835bf946efb8$export$39132258acc840de = 6800;
const $a9a9835bf946efb8$var$ARRIVE_AT = 950 // the pointer is on him, and he lights up
;
const $a9a9835bf946efb8$var$MENU_AT = 1450 // his wheel opens
;
const $a9a9835bf946efb8$var$RIGHT_CLICK_AT = $a9a9835bf946efb8$var$MENU_AT - 70;
const $a9a9835bf946efb8$var$HOLD_FROM = $a9a9835bf946efb8$var$ARRIVE_AT // on a touch screen the press is held until the wheel answers
;
const $a9a9835bf946efb8$var$PICK_ORDERS_AT = 2500;
const $a9a9835bf946efb8$var$ORDERS_MENU_AT = 2950;
const $a9a9835bf946efb8$var$PICK_FEED_AT = 4200;
const $a9a9835bf946efb8$var$TURN_AT = 4550 // he faces the fire...
;
const $a9a9835bf946efb8$var$TOSS_FROM = 4650, $a9a9835bf946efb8$var$TOSS_TO = 5050 // ...and throws a log on it
;
const $a9a9835bf946efb8$var$STAMP_AT = 5350;
const $a9a9835bf946efb8$var$DONE_AT = 5550;
const $a9a9835bf946efb8$var$REPLAY_AT = 6200;
const $a9a9835bf946efb8$var$PRESS_MS = 120;
const $a9a9835bf946efb8$var$caption = (touch)=>[
        touch ? "Touch and hold the forager to open his wheel." : "Right-click the forager (or tap with two fingers) to open his wheel.",
        "Pick Orders to see the jobs he can do.",
        "Choose a job. Feed Fire keeps the hearth burning."
    ];
const $a9a9835bf946efb8$var$doneCaption = (touch)=>touch ? "Hold on your forager and choose Feed Fire." : "Right-click your forager and choose Feed Fire.";
const $a9a9835bf946efb8$export$bde6a74a8ca6eae2 = (elapsedMs)=>{
    const t = Math.min($a9a9835bf946efb8$export$39132258acc840de, Math.max(0, elapsedMs));
    return {
        step: t < $a9a9835bf946efb8$var$MENU_AT ? 0 : t < $a9a9835bf946efb8$var$PICK_ORDERS_AT ? 1 : 2,
        // The hover outline, from the pointer landing on him until the wheel covers him.
        highlighted: t >= $a9a9835bf946efb8$var$ARRIVE_AT && t < $a9a9835bf946efb8$var$MENU_AT + 150,
        turned: t >= $a9a9835bf946efb8$var$TURN_AT,
        toss: (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $a9a9835bf946efb8$var$TOSS_FROM, $a9a9835bf946efb8$var$TOSS_TO),
        flare: t >= $a9a9835bf946efb8$var$TOSS_TO ? 1 - (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $a9a9835bf946efb8$var$TOSS_TO, $a9a9835bf946efb8$var$TOSS_TO + 1400)) : 0,
        done: t >= $a9a9835bf946efb8$var$DONE_AT
    };
};
// A hand moves in arcs, not along a ruler.
const $a9a9835bf946efb8$var$glide = (from, to, k)=>(0, $a8782f4c6450260e$export$75c48cadd9435142)(from, {
        x: (from.x + to.x) / 2,
        y: Math.min(from.y, to.y) - 18
    }, to, (0, $a8782f4c6450260e$export$24656b269d8df7d6)(k));
const $a9a9835bf946efb8$export$c26f6186d424d9b7 = (elapsedMs, at, touch = false)=>{
    const t = Math.min($a9a9835bf946efb8$export$39132258acc840de, Math.max(0, elapsedMs));
    let p;
    if (t < $a9a9835bf946efb8$var$MENU_AT + 300) p = $a9a9835bf946efb8$var$glide(at.rest, at.body, (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, 150, $a9a9835bf946efb8$var$ARRIVE_AT - 50));
    else if (t < $a9a9835bf946efb8$var$ORDERS_MENU_AT) p = $a9a9835bf946efb8$var$glide(at.body, at.orders, (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $a9a9835bf946efb8$var$MENU_AT + 300, $a9a9835bf946efb8$var$PICK_ORDERS_AT - 250));
    else if (t < $a9a9835bf946efb8$var$PICK_FEED_AT + 120) p = $a9a9835bf946efb8$var$glide(at.orders, at.feed, (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $a9a9835bf946efb8$var$ORDERS_MENU_AT + 300, $a9a9835bf946efb8$var$PICK_FEED_AT - 300));
    else {
        const k = (0, $a8782f4c6450260e$export$24656b269d8df7d6)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $a9a9835bf946efb8$var$PICK_FEED_AT + 120, $a9a9835bf946efb8$var$PICK_FEED_AT + 600));
        p = {
            x: at.feed.x + 18 * k,
            y: at.feed.y + 26 * k
        };
    }
    const pressedFrom = touch ? $a9a9835bf946efb8$var$HOLD_FROM : $a9a9835bf946efb8$var$RIGHT_CLICK_AT;
    const pressed = t >= pressedFrom && t < $a9a9835bf946efb8$var$MENU_AT + (touch ? 80 : $a9a9835bf946efb8$var$PRESS_MS - 70) || [
        $a9a9835bf946efb8$var$PICK_ORDERS_AT,
        $a9a9835bf946efb8$var$PICK_FEED_AT
    ].some((at)=>t >= at && t < at + $a9a9835bf946efb8$var$PRESS_MS);
    return {
        ...p,
        pressed: pressed,
        alpha: Math.min((0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, 0, 250)), 1 - (0, $a8782f4c6450260e$export$5da70c9577229d30)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $a9a9835bf946efb8$var$PICK_FEED_AT + 250, $a9a9835bf946efb8$var$PICK_FEED_AT + 750)))
    };
};
/** The recruit's own look (ember-recruit.js entitySetup), carrying an axe. */ const $a9a9835bf946efb8$var$recruitBody = ()=>{
    const body = new (0, $cb689cfa16c444ba$export$bc644a473284d944)();
    body.movement.angle = (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)(90);
    body.weapon = {
        weaponType: "none"
    };
    body.appearance = {
        ...(0, $1a2d6d21d6b0fac8$export$b7be1ee14f302b62)(undefined, "human", "male"),
        hair: "plain",
        hairColor: "black"
    };
    const skirts = (0, $f684496fff50a7a1$export$9efb6bfe58196888)("skirts", "brown") || (0, $f684496fff50a7a1$export$9efb6bfe58196888)("skirts");
    body.inventory = {
        items: [
            {
                ...(0, $f684496fff50a7a1$export$9bccf79e85d1f187)((0, $f684496fff50a7a1$export$9efb6bfe58196888)("axe"), {
                    id: "forager-tutorial-axe",
                    quantity: 1
                }),
                active: true,
                readied: true
            },
            {
                ...(0, $f684496fff50a7a1$export$9bccf79e85d1f187)(skirts, {
                    id: "forager-tutorial-skirts",
                    quantity: 1
                }),
                active: true
            }
        ],
        abilities: {},
        lastUpdateTs: 0
    };
    return body;
};
class $a9a9835bf946efb8$export$97d258abb54b739c extends (0, $d88289c4fa93045f$export$1a9cc944b63e989c) {
    constructor(hover, dismiss, touch = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()){
        super({
            width: $a9a9835bf946efb8$var$WIDTH,
            height: $a9a9835bf946efb8$var$HEIGHT,
            padX: $a9a9835bf946efb8$var$SCENE_X,
            contentWidth: $a9a9835bf946efb8$var$SCENE_W,
            captionY: $a9a9835bf946efb8$var$CAPTION_Y,
            captionH: $a9a9835bf946efb8$var$CAPTION_H,
            overline: "FORAGER",
            title: "Give him orders",
            steps: {
                labels: [
                    touch ? "HOLD" : "RIGHT-CLICK",
                    "ORDERS",
                    "CHOOSE"
                ],
                litAt: [
                    0,
                    $a9a9835bf946efb8$var$MENU_AT + 420,
                    $a9a9835bf946efb8$var$PICK_ORDERS_AT + 420
                ],
                doneAt: [
                    $a9a9835bf946efb8$var$MENU_AT,
                    $a9a9835bf946efb8$var$PICK_ORDERS_AT,
                    $a9a9835bf946efb8$var$PICK_FEED_AT
                ],
                linkFill: [
                    [
                        $a9a9835bf946efb8$var$MENU_AT + 60,
                        $a9a9835bf946efb8$var$MENU_AT + 420
                    ],
                    [
                        $a9a9835bf946efb8$var$PICK_ORDERS_AT + 60,
                        $a9a9835bf946efb8$var$PICK_ORDERS_AT + 420
                    ]
                ]
            },
            durationMs: $a9a9835bf946efb8$export$39132258acc840de,
            replayAt: $a9a9835bf946efb8$var$REPLAY_AT
        }, hover, dismiss), this.scene = new (0, $8t5Gy.Container)(), this.frame = new (0, $gwPoJ.Graphics)(), this.hearthGlow = new (0, $gwPoJ.Graphics)(), this.forager = new (0, $64e038f1765e0ab3$export$f3390963b1a1dc25)(""), this.body = $a9a9835bf946efb8$var$recruitBody(), this.wheelLayer = new (0, $8t5Gy.Container)(), // Normal-blend marks over the wheel: the mouse with its lit button (or the hold ring), the log.
        this.hand = new (0, $gwPoJ.Graphics)(), this.fx = new (0, $gwPoJ.Graphics)(), this.stamp = new (0, $d88289c4fa93045f$export$fa9539309080be6)("ORDER GIVEN"), this.art = [], // Which wheel events the play-through has already played, so each happens once.
        this.played = {
            menu: false,
            pickOrders: false,
            ordersMenu: false,
            pickFeed: false
        }, // What the wheel reported picked this play-through. It goes nowhere else.
        this.picked = [], this.turned = false, this.addTile = (sheet, tile, x, y)=>{
            const sprite = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).EMPTY);
            sprite.position.set(x * $a9a9835bf946efb8$var$CELL, y * $a9a9835bf946efb8$var$CELL);
            sprite.width = $a9a9835bf946efb8$var$CELL;
            sprite.height = $a9a9835bf946efb8$var$CELL;
            this.scene.addChild(sprite);
            this.art.push({
                sprite: sprite,
                sheet: sheet,
                tile: tile
            });
        }, this.buildFlame = ()=>{
            try {
                const fire = new (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)();
                // FireSprite seats its coals 3px left of its origin, as it would above a placed campfire;
                // land them on the logs' crossing (the pit art's row 16).
                fire.position.set($a9a9835bf946efb8$var$FIRE_X + 3, $a9a9835bf946efb8$var$FIRE_BASE_Y - 4);
                return fire;
            } catch  {
                const flame = new (0, $d4e9bfba8663fd0e$export$180e4127bb338fb5)($a9a9835bf946efb8$var$FLAME_W, $a9a9835bf946efb8$var$FLAME_H, {
                    glow: false
                });
                flame.position.set($a9a9835bf946efb8$var$FIRE_X - $a9a9835bf946efb8$var$FLAME_W / 2, $a9a9835bf946efb8$var$FIRE_BASE_Y - $a9a9835bf946efb8$var$FLAME_H);
                return flame;
            }
        }, this.buildWheel = ()=>{
            const wheel = new (0, $7676384fbaf9cdf2$export$a36bd337d7c5ab90)({
                radius: $a9a9835bf946efb8$var$WHEEL_RADIUS,
                onCommandSelect: (command)=>this.picked.push(command)
            });
            wheel.visible = false;
            this.wheelLayer.addChild(wheel);
            return wheel;
        }, // GuiManager.showInteractionWheel's binding, for a hired forager.
        this.bindVerbs = ()=>this.wheel.bindToInteractions($a9a9835bf946efb8$var$DEMO_ENTITY, $a9a9835bf946efb8$var$MEMBER_VERBS.map((verb)=>({
                    name: verb.type,
                    displayName: (0, $0fb3f7f2a67be6e3$export$84e151b22524d21c)(verb)
                }))), // ...and the forager's orders page, which the server opens when Orders is picked.
        this.bindOrders = ()=>this.wheel.bindToEntity($a9a9835bf946efb8$var$DEMO_ENTITY, "forager"), /** Aim by the real wheel's layout: lay each page out once, read where its slice is, put it away. */ this.cursorStops = ()=>{
            const toBoard = (aim)=>({
                    x: this.wheelLayer.x + (aim?.x ?? 0) * $a9a9835bf946efb8$var$WHEEL_SCALE,
                    y: this.wheelLayer.y + (aim?.y ?? 0) * $a9a9835bf946efb8$var$WHEEL_SCALE
                });
            this.bindVerbs();
            const orders = toBoard(this.wheel.aimAt($a9a9835bf946efb8$var$ORDERS));
            this.bindOrders();
            const feed = toBoard(this.wheel.aimAt($a9a9835bf946efb8$var$FEED_FIRE));
            return {
                rest: {
                    x: $a9a9835bf946efb8$var$SCENE_X + 8.4 * $a9a9835bf946efb8$var$CELL,
                    y: $a9a9835bf946efb8$var$SCENE_Y + 1.4 * $a9a9835bf946efb8$var$CELL
                },
                // His chest, a little above the hip the wheel opens on.
                body: {
                    x: this.wheelLayer.x + 2,
                    y: this.wheelLayer.y - 6
                },
                orders: orders,
                feed: feed
            };
        }, /** Open, aim and pick on the real wheel, each once, as a player's hand would. */ this.playWheel = (t)=>{
            const local = (ms)=>{
                const p = this.cursorAt(ms);
                return {
                    x: (p.x - this.wheelLayer.x) / $a9a9835bf946efb8$var$WHEEL_SCALE,
                    y: (p.y - this.wheelLayer.y) / $a9a9835bf946efb8$var$WHEEL_SCALE
                };
            };
            // A pick lands where the pointer was at the moment of the pick, whatever frame it is seen in.
            const pick = (at)=>{
                const p = local(at);
                this.wheel.hoverAt(p.x, p.y);
                this.wheel.pressAt(p.x, p.y);
                // GuiManager.hideCommandWheel: the pick flashes, holds a beat and lifts away.
                this.wheel.fadeOut();
                this.wheel.clearSelection();
            };
            if (t >= $a9a9835bf946efb8$var$MENU_AT && !this.played.menu) {
                this.played.menu = true;
                this.bindVerbs();
                this.wheel.fadeIn();
            }
            if (t >= $a9a9835bf946efb8$var$PICK_ORDERS_AT && !this.played.pickOrders) {
                this.played.pickOrders = true;
                pick($a9a9835bf946efb8$var$PICK_ORDERS_AT);
            }
            if (t >= $a9a9835bf946efb8$var$ORDERS_MENU_AT && !this.played.ordersMenu) {
                this.played.ordersMenu = true;
                this.bindOrders();
                this.wheel.fadeIn();
            }
            if (t >= $a9a9835bf946efb8$var$PICK_FEED_AT && !this.played.pickFeed) {
                this.played.pickFeed = true;
                pick($a9a9835bf946efb8$var$PICK_FEED_AT);
            }
            if (this.wheel.isOpen()) {
                const p = local(t);
                this.wheel.hoverAt(p.x, p.y);
            }
        }, /**
     * Beside the pointer, which button it is: a small mouse with its RIGHT button lit as it clicks.
     * On a touch screen, a ring that fills round the fingertip while the press is held. Then the log
     * he throws on the fire.
     */ this.drawHand = (t, pose)=>{
            const g = this.hand.clear();
            const cursor = this.cursorAt(t);
            const shown = Math.min((0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $a9a9835bf946efb8$var$ARRIVE_AT - 250, $a9a9835bf946efb8$var$ARRIVE_AT)), 1 - (0, $a8782f4c6450260e$export$5da70c9577229d30)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $a9a9835bf946efb8$var$MENU_AT + 250, $a9a9835bf946efb8$var$MENU_AT + 550)));
            if (shown > 0 && this.touch) {
                const fill = (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $a9a9835bf946efb8$var$HOLD_FROM, $a9a9835bf946efb8$var$MENU_AT);
                if (fill > 0 && fill < 1) {
                    g.lineStyle({
                        width: 3,
                        color: 0x000000,
                        alpha: 0.4 * shown
                    }).drawCircle(cursor.x, cursor.y, 14);
                    g.lineStyle({
                        width: 2.5,
                        color: (0, $2f9f1514035da1ec$export$d8df7395f14ba24a),
                        alpha: shown,
                        cap: (0, $gwPoJ.LINE_CAP).ROUND
                    });
                    g.moveTo(cursor.x, cursor.y - 14).arc(cursor.x, cursor.y, 14, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * fill);
                    g.lineStyle(0);
                }
            } else if (shown > 0) {
                const lit = t >= $a9a9835bf946efb8$var$RIGHT_CLICK_AT && t < $a9a9835bf946efb8$var$MENU_AT + 260 ? 1 - (0, $a8782f4c6450260e$export$5da70c9577229d30)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(t, $a9a9835bf946efb8$var$MENU_AT + 60, $a9a9835bf946efb8$var$MENU_AT + 260)) : 0;
                this.drawMouse(g, cursor.x + 15, cursor.y + 13, lit, shown);
            }
            if (pose.toss > 0 && pose.toss < 1) {
                // From his hands to the fire, end over end.
                const from = {
                    x: $a9a9835bf946efb8$var$FORAGER_X - 8,
                    y: $a9a9835bf946efb8$var$FORAGER_HIP_Y - 2
                }, to = {
                    x: $a9a9835bf946efb8$var$FIRE_X,
                    y: $a9a9835bf946efb8$var$FIRE_BASE_Y - 6
                };
                const p = (0, $a8782f4c6450260e$export$75c48cadd9435142)(from, {
                    x: (from.x + to.x) / 2,
                    y: Math.min(from.y, to.y) - 34
                }, to, pose.toss);
                const a = -pose.toss * Math.PI * 2.2;
                const ux = Math.cos(a) * 7, uy = Math.sin(a) * 7;
                const x = $a9a9835bf946efb8$var$SCENE_X + p.x, y = $a9a9835bf946efb8$var$SCENE_Y + p.y;
                g.lineStyle({
                    width: 6,
                    color: 0x2a170b,
                    alpha: 1,
                    cap: (0, $gwPoJ.LINE_CAP).ROUND
                }).moveTo(x - ux, y - uy).lineTo(x + ux, y + uy);
                g.lineStyle({
                    width: 4,
                    color: 0x8a5a32,
                    alpha: 1,
                    cap: (0, $gwPoJ.LINE_CAP).ROUND
                }).moveTo(x - ux, y - uy).lineTo(x + ux, y + uy);
                g.lineStyle(0);
                g.beginFill(0xd9b07a, 1).drawCircle(x + ux, y + uy, 1.6).endFill();
            }
        }, this.drawMouse = (g, x, y, lit, alpha)=>{
            const w = 11, h = 15, r = 5;
            g.beginFill(0x000000, 0.35 * alpha).drawRoundedRect(x + 1, y + 1.5, w, h, r).endFill();
            g.lineStyle({
                width: 1.2,
                color: 0x1a120c,
                alpha: alpha,
                join: (0, $gwPoJ.LINE_JOIN).ROUND
            });
            g.beginFill(0xf4ead8, alpha).drawRoundedRect(x, y, w, h, r).endFill();
            // The right button, lit gold while it is pressed.
            if (lit > 0) {
                g.lineStyle(0);
                g.beginFill((0, $2f9f1514035da1ec$export$d8df7395f14ba24a), alpha * lit);
                g.moveTo(x + w / 2 + 0.6, y + 0.8).lineTo(x + w - r, y + 0.8).arc(x + w - r, y + r, r - 0.8, -Math.PI / 2, 0).lineTo(x + w - 0.8, y + 6).lineTo(x + w / 2 + 0.6, y + 6).closePath();
                g.endFill();
            }
            g.lineStyle({
                width: 1,
                color: 0x1a120c,
                alpha: alpha
            });
            g.moveTo(x + w / 2, y + 0.5).lineTo(x + w / 2, y + 6);
            g.moveTo(x + 0.5, y + 6).lineTo(x + w - 0.5, y + 6);
            g.lineStyle(0);
        }, /** Ripples where the pointer pressed, and the hearth taking the log. */ this.drawFx = (t, pose)=>{
            const g = this.fx.clear();
            (0, $d88289c4fa93045f$export$3c35d57a4fa64702)(g, t, [
                this.touch ? $a9a9835bf946efb8$var$MENU_AT : $a9a9835bf946efb8$var$RIGHT_CLICK_AT,
                $a9a9835bf946efb8$var$PICK_ORDERS_AT,
                $a9a9835bf946efb8$var$PICK_FEED_AT
            ], (at)=>$a9a9835bf946efb8$export$c26f6186d424d9b7(at, this.stops, this.touch));
            if (t < $a9a9835bf946efb8$var$TOSS_TO) return;
            const ms = t - $a9a9835bf946efb8$var$TOSS_TO;
            const x = $a9a9835bf946efb8$var$SCENE_X + $a9a9835bf946efb8$var$FIRE_X, y = $a9a9835bf946efb8$var$SCENE_Y + $a9a9835bf946efb8$var$FIRE_BASE_Y - 10;
            const bloom = 1 - (0, $a8782f4c6450260e$export$1157fb72e7fbceb5)((0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(ms, 0, 700));
            if (bloom > 0) (0, $2f9f1514035da1ec$export$11572259c1b566fa)(g, x, y, 34, $a9a9835bf946efb8$var$FIRELIGHT, 0.45 * bloom, 5);
            (0, $2f9f1514035da1ec$export$e1c6fe5ee848dc6d)(g, x, y, (0, $a8782f4c6450260e$export$afc1bfabebaf28a2)(ms, 0, 650), 12, 8, 34, (0, $2f9f1514035da1ec$export$d8df7395f14ba24a), 0.7, 1.5);
            // The light reaches him as well: he is the one who fed it.
            if (pose.flare > 0) (0, $2f9f1514035da1ec$export$11572259c1b566fa)(g, $a9a9835bf946efb8$var$SCENE_X + $a9a9835bf946efb8$var$FORAGER_X, $a9a9835bf946efb8$var$SCENE_Y + $a9a9835bf946efb8$var$FORAGER_HIP_Y, 22, $a9a9835bf946efb8$var$FIRELIGHT, 0.1 * pose.flare, 4);
        };
        this.touch = touch;
        this.scene.position.set($a9a9835bf946efb8$var$SCENE_X, $a9a9835bf946efb8$var$SCENE_Y);
        this.content.addChild(this.scene);
        for(let y = 0; y < $a9a9835bf946efb8$var$ROWS; y++)for(let x = 0; x < $a9a9835bf946efb8$var$COLS; x++)this.addTile("forest-grass", (0, $4bd29aa0ad024b1a$export$6b5b23411b38d591)(x, y), x, y);
        this.hearthGlow.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.scene.addChild(this.hearthGlow);
        [
            759,
            760,
            761
        ].forEach((tile, i)=>this.addTile("lpc-terrain", tile, $a9a9835bf946efb8$var$FIRE_COL + i, $a9a9835bf946efb8$var$FIRE_ROW));
        this.flame = this.buildFlame();
        this.scene.addChild(this.flame);
        this.forager.position.set($a9a9835bf946efb8$var$FORAGER_X, $a9a9835bf946efb8$var$FORAGER_HIP_Y);
        this.scene.addChild(this.forager);
        this.forager.updatePaperdoll(this.body);
        this.forager.doMovement(this.body);
        (0, $d88289c4fa93045f$export$44282c4fb29fbea2)(this.frame, $a9a9835bf946efb8$var$SCENE_X, $a9a9835bf946efb8$var$SCENE_Y, $a9a9835bf946efb8$var$SCENE_W, $a9a9835bf946efb8$var$SCENE_H);
        this.content.addChild(this.frame);
        // The wheel opens on him, and only the demonstration works it: no pointer reaches it.
        this.wheelLayer.position.set($a9a9835bf946efb8$var$SCENE_X + $a9a9835bf946efb8$var$FORAGER_X, $a9a9835bf946efb8$var$SCENE_Y + $a9a9835bf946efb8$var$FORAGER_HIP_Y);
        this.wheelLayer.scale.set($a9a9835bf946efb8$var$WHEEL_SCALE);
        this.wheelLayer.interactiveChildren = false;
        this.content.addChild(this.wheelLayer);
        this.wheel = this.buildWheel();
        this.stops = this.cursorStops();
        this.fx.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.content.addChild(this.fx, this.hand);
        // In the clear row above the fire and the man, where the wheel was.
        this.stamp.place($a9a9835bf946efb8$var$SCENE_X + ($a9a9835bf946efb8$var$FIRE_X + $a9a9835bf946efb8$var$FORAGER_X) / 2, $a9a9835bf946efb8$var$SCENE_Y + $a9a9835bf946efb8$var$CELL * 0.7);
        this.content.addChild(this.stamp.burst, this.stamp.plaque);
        this.animate(0);
    }
    rewind() {
        this.wheel.destroy({
            children: true
        });
        this.wheel = this.buildWheel();
        this.played = {
            menu: false,
            pickOrders: false,
            ordersMenu: false,
            pickFeed: false
        };
        this.picked = [];
    }
    cursorAt(t) {
        return $a9a9835bf946efb8$export$c26f6186d424d9b7(t, this.stops, this.touch);
    }
    captionAt(t) {
        const pose = $a9a9835bf946efb8$export$bde6a74a8ca6eae2(t);
        return {
            text: pose.done ? $a9a9835bf946efb8$var$doneCaption(this.touch) : $a9a9835bf946efb8$var$caption(this.touch)[pose.step],
            done: pose.done
        };
    }
    poseScene(t, deltaMs) {
        const pose = $a9a9835bf946efb8$export$bde6a74a8ca6eae2(t);
        this.art.forEach(({ sprite: sprite, sheet: sheet, tile: tile })=>{
            const texture = (0, $1f08f7b8f85adf9e$export$42d948b5d3f64a60)(sheet)?.textures?.[`${sheet}-${tile}`] || (0, $klOfb.Texture).EMPTY;
            if (sprite.texture !== texture) {
                sprite.texture = texture;
                sprite.width = $a9a9835bf946efb8$var$CELL;
                sprite.height = $a9a9835bf946efb8$var$CELL;
            }
        });
        // A burning fire, and one that roars up when he feeds it.
        const strength = 0.6 + 0.4 * pose.flare;
        if (this.flame instanceof (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)) this.flame.setIntensity(strength);
        else this.flame.update(deltaMs || 0, strength);
        this.hearthGlow.clear();
        const flicker = 0.5 + 0.5 * Math.sin(this.clock / 170) * Math.sin(this.clock / 310);
        (0, $2f9f1514035da1ec$export$11572259c1b566fa)(this.hearthGlow, $a9a9835bf946efb8$var$FIRE_X, $a9a9835bf946efb8$var$FIRE_BASE_Y - 4, 40 + 10 * pose.flare, $a9a9835bf946efb8$var$FIRELIGHT, 0.14 + 0.04 * flicker + 0.22 * pose.flare, 5);
        // The hover outline belongs to the body's sprite, which loads after us and is rebuilt on a
        // new look: ask again until it takes.
        if (this.highlighted !== pose.highlighted) this.highlighted = this.forager.setHighlighted(pose.highlighted) ? pose.highlighted : undefined;
        if (this.turned !== pose.turned) {
            this.turned = pose.turned;
            this.body.movement.angle = (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)(pose.turned ? 180 : 90);
            this.forager.doMovement(this.body);
        }
        this.playWheel(t);
        this.wheel.animate(deltaMs);
        this.drawHand(t, pose);
        this.drawFx(t, pose);
        this.stamp.draw(t - $a9a9835bf946efb8$var$STAMP_AT);
    }
    teardown() {
        if (this.highlighted) this.forager.setHighlighted(false);
        this.forager.cleanup();
        // The real flame plays on the shared ticker; its baked frames are shared and stay.
        if (this.flame instanceof (0, $2ea1527dda10caae$export$5d3e6a2d155f61d0)) this.flame.cleanup();
    }
}



parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $P8XPi = parcelRequire("P8XPi");





// THE LOOK OF A TUTORIAL CLUE: a small cut-timber note with a notch that points at a control, and a
// pair of gold brackets that close round the control itself.
//
// It replaces a 0xff0000 box and leader -- a debugger's annotation over a timber-and-bronze HUD --
// on a rounded panel with a dusty-red rim, a blurred DropShadowFilter, a slate close disc on a row of
// its own, and a 250ms setInterval strobe. A clue interrupts play by design; this is what makes the
// interruption cost as little as it can: it is as small as its words, it is the same object as the
// chat bubbles the Lord is teaching in (avatar_hud.ts spokeImpl, the same plate, chamfer and inked
// rim), and the only thing that moves is a slow breath on the brackets.
//
// No filters and no timers (see the budget hardware target): the glow is a fat low-alpha stroke, the
// shadow a dropped silhouette, and every bit of motion is a pure pose function of elapsed time that
// gui/tutorial.ts feeds from GuiManager.updateTimer.
// ---- the note ----------------------------------------------------------------------------------
const $f9d75e6d13623a22$var$PAD_X = 11;
const $f9d75e6d13623a22$var$PAD_Y = 8;
const $f9d75e6d13623a22$var$CHAMFER = (0, $9600e6b065d22e57$export$e50a54bda5f8e083);
const $f9d75e6d13623a22$var$SHADOW_Y = 3;
const $f9d75e6d13623a22$var$SHADOW_ALPHA = 0.38;
const $f9d75e6d13623a22$var$FILL_ALPHA = 0.97;
// An inked rim, as on the chat bubble: a wide dark stroke, then a thin bronze one down its middle.
const $f9d75e6d13623a22$var$EDGE_WIDTH = 3.5;
const $f9d75e6d13623a22$var$EDGE_ALPHA = 0.95;
const $f9d75e6d13623a22$var$RIM_WIDTH = 1.25;
const $f9d75e6d13623a22$var$MITER_LIMIT = 3 // bevels the notch's tip rather than spiking it
;
const $f9d75e6d13623a22$var$TOP_LIGHT_ALPHA = 0.2;
// The first line is the instruction and is read; the rest explain it and are glanced at.
const $f9d75e6d13623a22$var$LEAD_ROLE = "label";
const $f9d75e6d13623a22$var$NOTE_ROLE = "compactBody";
const $f9d75e6d13623a22$var$LEAD_NOTE_GAP = 3;
const $f9d75e6d13623a22$var$NOTE_GAP = 1;
// What a line measures when nothing could be (jsdom's mocked canvas), so the note never collapses.
const $f9d75e6d13623a22$var$LEAD_LINE_H = 17;
const $f9d75e6d13623a22$var$NOTE_LINE_H = 15;
// The spark before the first line: a four-point star in the brackets' gold, so the note and the
// brackets read as one object without the note needing a gold rim of its own.
const $f9d75e6d13623a22$var$SPARK_R = 4;
const $f9d75e6d13623a22$var$SPARK_GAP = 7;
// The dismiss X: a bare stroked glyph tucked in the top-right corner, level with the first line. It
// used to be the dialog close disc on a row of its own under the words, which made every note a
// whole button-row taller than its text and put the loudest shape on the panel on the one thing a
// player should do least.
const $f9d75e6d13623a22$var$DISMISS_ARM = 3.25;
const $f9d75e6d13623a22$var$DISMISS_STROKE = 1.6;
const $f9d75e6d13623a22$var$DISMISS_GAP = 10 // between the end of the longest line and the X
;
const $f9d75e6d13623a22$var$DISMISS_HIT = 11 // half-size of its desktop hit box: generous, it is a small glyph
;
const $f9d75e6d13623a22$var$spark = (g, cx, cy, r)=>{
    const k = r * 0.3;
    g.moveTo(cx, cy - r).lineTo(cx + k, cy - k).lineTo(cx + r, cy).lineTo(cx + k, cy + k).lineTo(cx, cy + r).lineTo(cx - k, cy + k).lineTo(cx - r, cy).lineTo(cx - k, cy - k).closePath();
};
class $f9d75e6d13623a22$export$e075b0a1fbcd98a extends (0, $8t5Gy.Container) {
    constructor({ lines: lines, onDismiss: onDismiss }){
        super(), this.noteW = 0, this.noteH = 0, this.notch = null, this.dismissHovered = false, /** The note's own box, notch excluded, in its local coordinates. */ this.noteRect = ()=>new (0, $6qzqq.Rectangle)(0, 0, this.noteW, this.noteH), this.getNotch = ()=>this.notch, /** Point the note at something; null takes the notch off. */ this.setNotch = (notch)=>{
            this.notch = notch;
            this.drawBackdrop();
        }, this.drawDismiss = (hover)=>{
            this.dismissHovered = hover;
            const g = this.dismiss;
            g.clear();
            g.lineStyle({
                width: $f9d75e6d13623a22$var$DISMISS_STROKE,
                color: hover ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : (0, $97475243e21a0995$export$4569a0b09aa32d6c),
                alpha: hover ? 1 : 0.7,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            g.moveTo(-$f9d75e6d13623a22$var$DISMISS_ARM, -$f9d75e6d13623a22$var$DISMISS_ARM).lineTo($f9d75e6d13623a22$var$DISMISS_ARM, $f9d75e6d13623a22$var$DISMISS_ARM);
            g.moveTo($f9d75e6d13623a22$var$DISMISS_ARM, -$f9d75e6d13623a22$var$DISMISS_ARM).lineTo(-$f9d75e6d13623a22$var$DISMISS_ARM, $f9d75e6d13623a22$var$DISMISS_ARM);
            g.lineStyle(0);
        }, this.isDismissHovered = ()=>this.dismissHovered, // The outline -- chamfered box plus the notch -- is ONE path, filled and stroked once, so the
        // rim runs unbroken round the point (the chat bubble's lesson: a separately drawn tail seams).
        this.tracePath = (g, oy)=>{
            const w = this.noteW;
            const h = this.noteH;
            const c = $f9d75e6d13623a22$var$CHAMFER;
            const n = this.notch;
            const notchOn = (edge)=>n && n.edge === edge;
            const base = (len, along)=>(0, $9600e6b065d22e57$export$abccabccc7ee5588)(len, along);
            g.moveTo(c, oy);
            if (notchOn("top")) {
                const b = base(w, n.tipX);
                g.lineTo(b - (0, $9600e6b065d22e57$export$62bf8a437abb6139), oy).lineTo(n.tipX, n.tipY + oy).lineTo(b + (0, $9600e6b065d22e57$export$62bf8a437abb6139), oy);
            }
            g.lineTo(w - c, oy).lineTo(w, oy + c);
            if (notchOn("right")) {
                const b = base(h, n.tipY);
                g.lineTo(w, oy + b - (0, $9600e6b065d22e57$export$62bf8a437abb6139)).lineTo(n.tipX, n.tipY + oy).lineTo(w, oy + b + (0, $9600e6b065d22e57$export$62bf8a437abb6139));
            }
            g.lineTo(w, oy + h - c).lineTo(w - c, oy + h);
            if (notchOn("bottom")) {
                const b = base(w, n.tipX);
                g.lineTo(b + (0, $9600e6b065d22e57$export$62bf8a437abb6139), oy + h).lineTo(n.tipX, n.tipY + oy).lineTo(b - (0, $9600e6b065d22e57$export$62bf8a437abb6139), oy + h);
            }
            g.lineTo(c, oy + h).lineTo(0, oy + h - c);
            if (notchOn("left")) {
                const b = base(h, n.tipY);
                g.lineTo(0, oy + b + (0, $9600e6b065d22e57$export$62bf8a437abb6139)).lineTo(n.tipX, n.tipY + oy).lineTo(0, oy + b - (0, $9600e6b065d22e57$export$62bf8a437abb6139));
            }
            g.lineTo(0, oy + c);
            g.closePath();
        }, this.drawBackdrop = ()=>{
            const g = this.backdrop;
            g.clear();
            // Dropped silhouette, straight down: a diagonal offset ghosts a second notch beside the real one.
            g.lineStyle(0);
            g.beginFill(0x000000, $f9d75e6d13623a22$var$SHADOW_ALPHA);
            this.tracePath(g, $f9d75e6d13623a22$var$SHADOW_Y);
            g.endFill();
            g.lineStyle({
                width: $f9d75e6d13623a22$var$EDGE_WIDTH,
                color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
                alpha: $f9d75e6d13623a22$var$EDGE_ALPHA,
                join: (0, $gwPoJ.LINE_JOIN).MITER,
                miterLimit: $f9d75e6d13623a22$var$MITER_LIMIT
            });
            g.beginFill((0, $97475243e21a0995$export$ae463dc3cc7e810b), $f9d75e6d13623a22$var$FILL_ALPHA);
            this.tracePath(g, 0);
            g.endFill();
            g.lineStyle({
                width: $f9d75e6d13623a22$var$RIM_WIDTH,
                color: (0, $97475243e21a0995$export$cac838e5dd111a30),
                alpha: 1,
                join: (0, $gwPoJ.LINE_JOIN).MITER,
                miterLimit: $f9d75e6d13623a22$var$MITER_LIMIT
            });
            this.tracePath(g, 0);
            // One lit edge along the top, so the note has a direction the light falls from (build_board).
            g.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), $f9d75e6d13623a22$var$TOP_LIGHT_ALPHA);
            g.moveTo($f9d75e6d13623a22$var$CHAMFER + 1, 2.5).lineTo(this.noteW - $f9d75e6d13623a22$var$CHAMFER - 1, 2.5);
            g.lineStyle(0);
        };
        this.backdrop = new (0, $gwPoJ.Graphics)();
        this.addChild(this.backdrop);
        this.sparkNode = new (0, $gwPoJ.Graphics)();
        this.addChild(this.sparkNode);
        const textX = $f9d75e6d13623a22$var$PAD_X + $f9d75e6d13623a22$var$SPARK_R * 2 + $f9d75e6d13623a22$var$SPARK_GAP - 2;
        let y = $f9d75e6d13623a22$var$PAD_Y;
        let widest = 0;
        let leadH = $f9d75e6d13623a22$var$LEAD_LINE_H;
        lines.forEach((line, index)=>{
            const lead = index === 0;
            const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().role(lead ? $f9d75e6d13623a22$var$LEAD_ROLE : $f9d75e6d13623a22$var$NOTE_ROLE).bold(lead).color(lead ? (0, $97475243e21a0995$export$92999bc7164f195e) : (0, $97475243e21a0995$export$4569a0b09aa32d6c)).strokeThickness(0).render(line);
            if (index > 0) y += index === 1 ? $f9d75e6d13623a22$var$LEAD_NOTE_GAP : $f9d75e6d13623a22$var$NOTE_GAP;
            text.x = textX;
            text.y = y;
            const h = Math.max(text.height, lead ? $f9d75e6d13623a22$var$LEAD_LINE_H : $f9d75e6d13623a22$var$NOTE_LINE_H);
            if (lead) leadH = h;
            y += h;
            widest = Math.max(widest, text.width);
            this.addChild(text);
        });
        this.noteW = Math.round(textX + widest + $f9d75e6d13623a22$var$DISMISS_GAP + $f9d75e6d13623a22$var$DISMISS_ARM * 2 + $f9d75e6d13623a22$var$PAD_X - 1);
        this.noteH = Math.round(y + $f9d75e6d13623a22$var$PAD_Y);
        // The spark sits on the first line's centre, the X level with it at the far edge.
        const leadMid = $f9d75e6d13623a22$var$PAD_Y + leadH / 2;
        this.sparkNode.beginFill((0, $658a44ce960354bb$export$319b6132a2fafb7c), 1);
        $f9d75e6d13623a22$var$spark(this.sparkNode, $f9d75e6d13623a22$var$PAD_X + $f9d75e6d13623a22$var$SPARK_R, leadMid, $f9d75e6d13623a22$var$SPARK_R);
        this.sparkNode.endFill();
        this.dismiss = new (0, $gwPoJ.Graphics)();
        this.dismiss.x = this.noteW - $f9d75e6d13623a22$var$PAD_X + 1 - $f9d75e6d13623a22$var$DISMISS_ARM;
        this.dismiss.y = leadMid;
        this.dismiss.interactive = true;
        this.dismiss.cursor = "pointer";
        this.dismiss.hitArea = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().touch ? new (0, $0d2b5753435eae0a$export$ca88597b86c9a1dc)(()=>{
            const rect = (0, $0d2b5753435eae0a$export$f71286780f6a70a)(this.dismiss, $f9d75e6d13623a22$var$DISMISS_HIT * 2, $f9d75e6d13623a22$var$DISMISS_HIT * 2);
            rect.x -= $f9d75e6d13623a22$var$DISMISS_HIT;
            rect.y -= $f9d75e6d13623a22$var$DISMISS_HIT;
            return rect;
        }) : new (0, $6qzqq.Circle)(0, 0, $f9d75e6d13623a22$var$DISMISS_HIT);
        this.dismiss.on("mouseover", ()=>this.drawDismiss(true));
        this.dismiss.on("mouseout", ()=>this.drawDismiss(false));
        if (onDismiss) {
            this.dismiss.on("click", onDismiss);
            this.dismiss.on("tap", onDismiss);
        }
        this.drawDismiss(false);
        this.addChild(this.dismiss);
        // The note is the hover target, not its shadow or its notch.
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, this.noteW, this.noteH);
        this.drawBackdrop();
    }
}
// ---- the brackets ------------------------------------------------------------------------------
// Clear air between the control and the brackets at rest, and how far they breathe out from there.
const $f9d75e6d13623a22$var$RING_PAD = 4;
const $f9d75e6d13623a22$var$RING_BREATH = 2.5;
const $f9d75e6d13623a22$var$RING_BREATH_MS = 1700;
// The brackets arrive from further out and close onto the control: the eye follows them in.
const $f9d75e6d13623a22$var$RING_ARRIVE_FROM = 14;
const $f9d75e6d13623a22$var$RING_ARRIVE_MS = 340;
const $f9d75e6d13623a22$var$RING_LEAVE_TO = 6;
const $f9d75e6d13623a22$var$RING_STROKE = 2;
const $f9d75e6d13623a22$var$RING_INK = 4 // the dark stroke under the gold, so it holds over a light control or grass
;
const $f9d75e6d13623a22$var$RING_GLOW = 6;
const $f9d75e6d13623a22$var$BRACKET_CUT = 3 // each corner is chamfered, like everything else on the board
;
const $f9d75e6d13623a22$export$15db115911357705 = 170;
const $f9d75e6d13623a22$var$easeOutCubic = (t)=>1 - Math.pow(1 - t, 3);
const $f9d75e6d13623a22$var$clamp01 = (t)=>Math.max(0, Math.min(1, t));
const $f9d75e6d13623a22$export$2c0afedfc7b66598 = (shownMs, leftMs)=>{
    const breath = 0.5 - 0.5 * Math.cos(2 * Math.PI * Math.max(0, shownMs) / $f9d75e6d13623a22$var$RING_BREATH_MS);
    const resting = $f9d75e6d13623a22$var$RING_PAD + $f9d75e6d13623a22$var$RING_BREATH * breath;
    const arrive = $f9d75e6d13623a22$var$easeOutCubic($f9d75e6d13623a22$var$clamp01(shownMs / $f9d75e6d13623a22$var$RING_ARRIVE_MS));
    let pad = resting + $f9d75e6d13623a22$var$RING_ARRIVE_FROM * (1 - arrive);
    let alpha = $f9d75e6d13623a22$var$clamp01(shownMs / ($f9d75e6d13623a22$var$RING_ARRIVE_MS * 0.5));
    const glow = 0.55 + 0.45 * breath;
    if (leftMs !== undefined) {
        const t = $f9d75e6d13623a22$var$clamp01(leftMs / $f9d75e6d13623a22$export$15db115911357705);
        pad += $f9d75e6d13623a22$var$RING_LEAVE_TO * $f9d75e6d13623a22$var$easeOutCubic(t);
        alpha *= 1 - t;
    }
    return {
        pad: pad,
        alpha: alpha,
        glow: glow
    };
};
const $f9d75e6d13623a22$export$3ccde2ac49bf4924 = (shownMs, leftMs)=>{
    const t = $f9d75e6d13623a22$var$easeOutCubic($f9d75e6d13623a22$var$clamp01(shownMs / 220));
    let alpha = t;
    let slide = 7 * (1 - t);
    if (leftMs !== undefined) {
        const out = $f9d75e6d13623a22$var$clamp01(leftMs / $f9d75e6d13623a22$export$15db115911357705);
        alpha *= 1 - out;
        slide += 3 * out;
    }
    return {
        alpha: alpha,
        slide: slide
    };
};
class $f9d75e6d13623a22$export$97b6fabf308fe0b4 extends (0, $gwPoJ.Graphics) {
    constructor(target){
        super(), this.poseAt = (shownMs, leftMs)=>this.pose($f9d75e6d13623a22$export$2c0afedfc7b66598(shownMs, leftMs)), this.pose = ({ pad: pad, alpha: alpha, glow: glow })=>{
            this.clear();
            this.alpha = alpha;
            const strokes = [
                [
                    $f9d75e6d13623a22$var$RING_GLOW,
                    (0, $658a44ce960354bb$export$319b6132a2fafb7c),
                    0.16 * glow
                ],
                [
                    $f9d75e6d13623a22$var$RING_INK,
                    (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
                    0.7
                ],
                [
                    $f9d75e6d13623a22$var$RING_STROKE,
                    (0, $658a44ce960354bb$export$319b6132a2fafb7c),
                    1
                ]
            ];
            for (const [width, color, a] of strokes){
                this.lineStyle({
                    width: width,
                    color: color,
                    alpha: a,
                    cap: (0, $gwPoJ.LINE_CAP).SQUARE,
                    join: (0, $gwPoJ.LINE_JOIN).MITER
                });
                if (this.target.round) this.traceArcs(pad);
                else this.traceBrackets(pad);
            }
            this.lineStyle(0);
        }, // Four corners of a chamfered frame `pad` outside the control.
        this.traceBrackets = (pad)=>{
            const { w: w, h: h } = this.target;
            const x0 = -pad;
            const y0 = -pad;
            const x1 = w + pad;
            const y1 = h + pad;
            const arm = Math.max(6, Math.min(12, Math.min(w, h) * 0.35)) + pad * 0.5;
            const k = $f9d75e6d13623a22$var$BRACKET_CUT;
            this.moveTo(x0, y0 + arm).lineTo(x0, y0 + k).lineTo(x0 + k, y0).lineTo(x0 + arm, y0);
            this.moveTo(x1 - arm, y0).lineTo(x1 - k, y0).lineTo(x1, y0 + k).lineTo(x1, y0 + arm);
            this.moveTo(x1, y1 - arm).lineTo(x1, y1 - k).lineTo(x1 - k, y1).lineTo(x1 - arm, y1);
            this.moveTo(x0 + arm, y1).lineTo(x0 + k, y1).lineTo(x0, y1 - k).lineTo(x0, y1 - arm);
        }, // A round control (the wave dial) gets four arcs on the diagonals instead -- between the dial's
        // own quarter notches, so the two sets of marks interleave rather than sit on top of each other.
        this.traceArcs = (pad)=>{
            const { w: w, h: h } = this.target;
            const cx = w / 2;
            const cy = h / 2;
            const r = Math.max(w, h) / 2 + pad;
            const half = 22 * Math.PI / 180;
            for(let q = 0; q < 4; q++){
                const mid = Math.PI / 4 + q * Math.PI / 2;
                this.moveTo(cx + Math.cos(mid - half) * r, cy + Math.sin(mid - half) * r);
                this.arc(cx, cy, r, mid - half, mid + half);
            }
        };
        this.target = target;
        this.pose($f9d75e6d13623a22$export$2c0afedfc7b66598(0));
    }
}
const $f9d75e6d13623a22$var$SCRIM_COLOR = 0x060403;
const $f9d75e6d13623a22$var$SCRIM_ALPHA = 0.7;
const $f9d75e6d13623a22$export$e0aca6709b3bc00b = 6;
const $f9d75e6d13623a22$var$HOLE_CHAMFER = 5;
const $f9d75e6d13623a22$export$88db77f12aab4efe = 260;
const $f9d75e6d13623a22$export$4ff52a466644cd67 = $f9d75e6d13623a22$export$15db115911357705;
const $f9d75e6d13623a22$export$7cab943deb1e7343 = (area, targets, pad = $f9d75e6d13623a22$export$e0aca6709b3bc00b)=>{
    const inset = $f9d75e6d13623a22$var$HOLE_CHAMFER;
    const clipped = [];
    for (const t of targets){
        const x0 = Math.max(area.x + inset, t.x - pad);
        const y0 = Math.max(area.y + inset, t.y - pad);
        const x1 = Math.min(area.x + area.w - inset, t.x + t.w + pad);
        const y1 = Math.min(area.y + area.h - inset, t.y + t.h + pad);
        if (x1 > x0 && y1 > y0) clipped.push({
            x: x0,
            y: y0,
            w: x1 - x0,
            h: y1 - y0
        });
    }
    const overlaps = (a, b)=>a.x <= b.x + b.w && b.x <= a.x + a.w && a.y <= b.y + b.h && b.y <= a.y + a.h;
    let merged = clipped;
    for(let changed = true; changed;){
        changed = false;
        const next = [];
        for (const rect of merged){
            const hit = next.findIndex((other)=>overlaps(rect, other));
            if (hit < 0) {
                next.push(rect);
                continue;
            }
            const o = next[hit];
            const x = Math.min(o.x, rect.x);
            const y = Math.min(o.y, rect.y);
            next[hit] = {
                x: x,
                y: y,
                w: Math.max(o.x + o.w, rect.x + rect.w) - x,
                h: Math.max(o.y + o.h, rect.y + rect.h) - y
            };
            changed = true;
        }
        merged = next;
    }
    return merged;
};
class $f9d75e6d13623a22$export$cfe00a7eb4ed7ee8 extends (0, $gwPoJ.Graphics) {
    constructor(...args){
        super(...args), this.brightness = 1, /** How dark the board is, 0..1: the scrim's alpha, and what the area's owner is told. */ this.setLevel = (level)=>{
            this.alpha = level;
            this.tellOwner(1 - $f9d75e6d13623a22$var$SCRIM_ALPHA * level);
        }, /** Let the owner put back whatever it dimmed. */ this.undim = ()=>this.tellOwner(1), this.tellOwner = (brightness)=>{
            if (brightness === this.brightness) return;
            this.brightness = brightness;
            this.area?.onDim?.(brightness);
        }, this.draw = (area, holes)=>{
            this.area = area;
            this.clear();
            this.lineStyle(0);
            this.beginFill($f9d75e6d13623a22$var$SCRIM_COLOR, $f9d75e6d13623a22$var$SCRIM_ALPHA);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(this, area.x, area.y, area.w, area.h, area.chamfer || 0);
            for (const hole of holes){
                this.beginHole();
                (0, $658a44ce960354bb$export$99dca9ebbafa6899)(this, hole.x, hole.y, hole.w, hole.h, $f9d75e6d13623a22$var$HOLE_CHAMFER);
                this.endHole();
            }
            this.endFill();
        };
    }
}
// The lit frame: hugs the control, arrives from further out like the brackets do, and breathes far
// less than they do -- a full frame swelling and shrinking round a button reads as a wobble.
const $f9d75e6d13623a22$var$LIGHT_PAD = 2.5;
const $f9d75e6d13623a22$var$LIGHT_BREATH = 1;
const $f9d75e6d13623a22$var$LIGHT_ARRIVE_FROM = 12;
const $f9d75e6d13623a22$var$LIGHT_CUT = 4;
const $f9d75e6d13623a22$var$LIGHT_WARM = 0xffb347;
// Light spilling off the control onto the dimmed board round it: widest and faintest first. ADDED,
// like the light it is, so it warms what it falls on instead of laying a film over it.
const $f9d75e6d13623a22$var$LIGHT_SPILL = [
    [
        18,
        0.07
    ],
    [
        11,
        0.1
    ],
    [
        6,
        0.16
    ]
];
// The control's face, lit: added over it, so its own label brightens with it rather than being
// washed out -- a grey "Craft" comes up cream on warm timber.
const $f9d75e6d13623a22$var$LIGHT_FACE_ALPHA = 0.3;
const $f9d75e6d13623a22$export$fddaaf0c1962131c = (shownMs, leftMs)=>{
    const breath = 0.5 - 0.5 * Math.cos(2 * Math.PI * Math.max(0, shownMs) / $f9d75e6d13623a22$var$RING_BREATH_MS);
    const arrive = $f9d75e6d13623a22$var$easeOutCubic($f9d75e6d13623a22$var$clamp01(shownMs / $f9d75e6d13623a22$var$RING_ARRIVE_MS));
    let pad = $f9d75e6d13623a22$var$LIGHT_PAD + $f9d75e6d13623a22$var$LIGHT_BREATH * breath + $f9d75e6d13623a22$var$LIGHT_ARRIVE_FROM * (1 - arrive);
    let alpha = $f9d75e6d13623a22$var$clamp01(shownMs / ($f9d75e6d13623a22$var$RING_ARRIVE_MS * 0.5));
    const glow = 0.6 + 0.4 * breath;
    if (leftMs !== undefined) {
        const t = $f9d75e6d13623a22$var$clamp01(leftMs / $f9d75e6d13623a22$export$15db115911357705);
        pad += $f9d75e6d13623a22$var$RING_LEAVE_TO * $f9d75e6d13623a22$var$easeOutCubic(t);
        alpha *= 1 - t;
    }
    return {
        pad: pad,
        alpha: alpha,
        glow: glow
    };
};
class $f9d75e6d13623a22$export$26863edc8177020b extends (0, $gwPoJ.Graphics) {
    constructor(target){
        super(), this.poseAt = (shownMs, leftMs)=>this.pose($f9d75e6d13623a22$export$fddaaf0c1962131c(shownMs, leftMs)), this.pose = ({ pad: pad, alpha: alpha, glow: glow })=>{
            const { w: w, h: h } = this.target;
            // A round control (the close disc) gets rings, not a box round its bounds.
            const round = this.target.round;
            const outline = (g, out)=>{
                if (round) g.drawCircle(w / 2, h / 2, Math.max(w, h) / 2 + out);
                else (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, -out, -out, w + out * 2, h + out * 2, out > 0 ? $f9d75e6d13623a22$var$LIGHT_CUT : $f9d75e6d13623a22$var$LIGHT_CUT - 1);
            };
            this.alpha = alpha;
            const light = this.light;
            light.clear();
            light.lineStyle(0);
            light.beginFill($f9d75e6d13623a22$var$LIGHT_WARM, $f9d75e6d13623a22$var$LIGHT_FACE_ALPHA * glow);
            outline(light, 0);
            light.endFill();
            for (const [width, a] of $f9d75e6d13623a22$var$LIGHT_SPILL){
                light.lineStyle({
                    width: width,
                    color: $f9d75e6d13623a22$var$LIGHT_WARM,
                    alpha: a * glow,
                    join: (0, $gwPoJ.LINE_JOIN).MITER
                });
                outline(light, pad);
            }
            light.lineStyle(0);
            this.clear();
            this.lineStyle({
                width: $f9d75e6d13623a22$var$RING_INK,
                color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
                alpha: 0.7,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            outline(this, pad);
            this.lineStyle({
                width: $f9d75e6d13623a22$var$RING_STROKE,
                color: (0, $658a44ce960354bb$export$319b6132a2fafb7c),
                alpha: 1,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            outline(this, pad);
            this.lineStyle(0);
        };
        this.target = target;
        this.light = new (0, $gwPoJ.Graphics)();
        this.light.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.addChild(this.light);
        this.pose($f9d75e6d13623a22$export$fddaaf0c1962131c(0));
    }
}



// How long an overworld popup stays up. Tuned for a notice nobody is waiting on: it says its piece
// and gets out of the way. (A clue's much longer lifetime lives in ember_clues.ts, with the rest of
// the clue bookkeeping.)
const $dbd41000427e8969$var$POPUP_TIMEOUT_MS = 7000;
// A frame hitch (a room load, a GC pause) must not swallow a clue's entrance: the clock a clue is
// posed from never jumps by more than this in one frame.
const $dbd41000427e8969$var$MAX_FRAME_MS = 50;
// How far past the viewport's edges the dimming behind a helper window reaches, so no sliver of
// the screen is left lit by rounding or a letterbox nudge.
const $dbd41000427e8969$var$DEMO_SCRIM_BLEED = 64;
// The control bar's inventory button, as the existing controlbar popup boxes it: the first entry in
// ControlBar.setup() (inventory.png), measured from the bar's own x in the gui surface.
const $dbd41000427e8969$var$CONTROLBAR_ITEMS_OFFSET_X = 15;
const $dbd41000427e8969$var$CONTROLBAR_ITEMS_W = 32;
const $dbd41000427e8969$var$CONTROLBAR_ITEMS_H = 30;
// The unit step away from the control, per side: a note slides its last few pixels TOWARD what it
// is pointing at.
const $dbd41000427e8969$var$SLIDE_FROM = {
    left: [
        -1,
        0
    ],
    right: [
        1,
        0
    ],
    above: [
        0,
        -1
    ],
    below: [
        0,
        1
    ]
};
class $dbd41000427e8969$export$825b76de5f2b0345 {
    constructor(gui, surface, equippedWidget, controlBar, minimapSurface, emberInventoryChip, demoSurface){
        this.activeTutorials = new Set();
        // Per-room suppression latch (set from GuiManager.roomUpdated via WorldState.visibility). When
        // true, setup() is a no-op so no tutorial popups appear — ember rooms suppress them. It does NOT
        // hold back the ember clues: see setup().
        this.suppressed = false;
        // The ember clues' bookkeeping (armed vs anchored, expiry, teardown) lives next door in
        // ember_clues.ts, free of pixi; all this file provides is the drawing.
        this.clues = new (0, $9600e6b065d22e57$export$5e29510581c9aca2)({
            draw: (tutorialType, anchor)=>this.drawClue(tutorialType, anchor),
            builtInAnchor: (tutorialType)=>this.builtInClueAnchor(tutorialType) || undefined
        });
        this.buildingDemoPendingUntilInventoryClose = false;
        this.buildingDemoShownLocally = false;
        this.demos = ()=>[
                this.buildingDemo,
                this.demolitionDemo,
                this.foragerDemo,
                this.sprintDemo
            ].filter((demo)=>demo && !demo.destroyed);
        /** The helper window's global bounds while one is up, for toasts to keep clear of. */ this.demoBounds = ()=>{
            const demo = this.demos().find((next)=>next.visible);
            return demo?.getBounds();
        };
        this.isForagerDemoShowing = ()=>!!this.foragerDemo && !this.foragerDemo.destroyed;
        // The player has given a forager an order: the forager helper has made its point, so it goes.
        this.foragerOrdered = ()=>this.foragerDemo?.leave();
        this.clock = 0;
        this.live = new Set();
        // When each clue was last taken down to be REDRAWN, and when it had first arrived. The inventory
        // panel rebuilds -- clue and all -- on every server message while it is open, and a clue redrawn
        // within the same frame carries on where it was instead of arriving all over again.
        this.lastShown = new Map();
        // How dimmed the spotlit panel is, 0..1. ONE level rather than one per clue, because the panel
        // rebuilds -- host and all -- on every server message and on every step of the lesson: a clue
        // handing over to the next one keeps the panel dark instead of flashing it light for a frame.
        this.spotlightLevel = 0;
        // The dimming drawn into each host. One per host however many of its controls are lit.
        this.scrims = new Map();
        // Advance every clue on screen. Costs one addition when there are none, which is nearly always.
        // The clock runs regardless: it is also what tells a redraw within the frame (carry on) from a
        // control that went away and came back (arrive again).
        this.animate = (deltaMs)=>{
            if (this.sprintDemo && !this.sprintDemo.destroyed) this.sprintDemo.animate(deltaMs);
            if (this.buildingDemo && !this.buildingDemo.destroyed) this.buildingDemo.animate(deltaMs);
            if (this.demolitionDemo && !this.demolitionDemo.destroyed) this.demolitionDemo.animate(deltaMs);
            if (this.foragerDemo && !this.foragerDemo.destroyed) this.foragerDemo.animate(deltaMs);
            if (this.demoScrim || this.demos().length > 0) this.poseDemoScrim();
            const step = Math.min($dbd41000427e8969$var$MAX_FRAME_MS, Math.max(0, deltaMs || 0));
            this.clock += step;
            if (this.live.size > 0) this.live.forEach(this.pose);
            if (this.scrims.size > 0 || this.spotlightLevel > 0) this.poseSpotlight(step);
        };
        // While a helper window is up, everything else on screen -- the camp and the whole HUD -- sits
        // under the same dimming the pack's board takes behind a taught control. It comes and goes with
        // the window itself (its arrival and departure fade), so there is no level of its own to keep.
        this.poseDemoScrim = ()=>{
            const level = this.demos().reduce((most, demo)=>Math.max(most, demo.visible ? demo.alpha : 0), 0);
            if (!(level > 0)) {
                if (this.demoScrim && !this.demoScrim.destroyed) {
                    this.demoScrim.parent?.removeChild(this.demoScrim);
                    this.demoScrim.destroy();
                }
                this.demoScrim = undefined;
                return;
            }
            if (!this.demoScrim || this.demoScrim.destroyed) this.demoScrim = new (0, $f9d75e6d13623a22$export$cfe00a7eb4ed7ee8)();
            const scrim = this.demoScrim;
            // The whole stage viewport, past its edges, wherever the layer happens to sit.
            const { left: left, top: top, width: width, height: height } = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().viewport;
            const from = this.demoSurface.toLocal(new (0, $6qzqq.Point)(left - $dbd41000427e8969$var$DEMO_SCRIM_BLEED, top - $dbd41000427e8969$var$DEMO_SCRIM_BLEED), this.gui.stage);
            const to = this.demoSurface.toLocal(new (0, $6qzqq.Point)(left + width + $dbd41000427e8969$var$DEMO_SCRIM_BLEED, top + height + $dbd41000427e8969$var$DEMO_SCRIM_BLEED), this.gui.stage);
            const area = {
                x: from.x,
                y: from.y,
                w: to.x - from.x,
                h: to.y - from.y
            };
            const drawn = scrim.area;
            if (!drawn || drawn.x !== area.x || drawn.y !== area.y || drawn.w !== area.w || drawn.h !== area.h) scrim.draw(area, []);
            scrim.alpha = level;
            // Under the windows.
            if (scrim.parent !== this.demoSurface) this.demoSurface.addChildAt(scrim, 0);
            else if (this.demoSurface.getChildIndex(scrim) !== 0) this.demoSurface.setChildIndex(scrim, 0);
        };
        // The panel dims while a control in it is being taught, and lifts when the last such clue goes.
        // A scrim whose host has nothing lit any more (its menu closed under it) fades with the level
        // and goes once it is clear; one whose host was thrown away by a rebuild goes at once.
        this.poseSpotlight = (step)=>{
            const lit = Array.from(this.live).some((clue)=>clue.spotlight && clue.leftAt === undefined);
            this.spotlightLevel = lit ? Math.min(1, this.spotlightLevel + step / (0, $f9d75e6d13623a22$export$88db77f12aab4efe)) : Math.max(0, this.spotlightLevel - step / (0, $f9d75e6d13623a22$export$4ff52a466644cd67));
            const alpha = this.scrimAlpha();
            this.scrims.forEach((scrim, host)=>{
                if (scrim.destroyed || host.destroyed) {
                    scrim.undim();
                    this.scrims.delete(host);
                    return;
                }
                if (this.spotlightLevel === 0 && !this.hasSpotlitClue(host)) {
                    this.dropScrim(host);
                    return;
                }
                scrim.setLevel(alpha);
            });
        };
        this.scrimAlpha = ()=>{
            const t = this.spotlightLevel;
            return t * t * (3 - 2 * t);
        };
        this.hasSpotlitClue = (host)=>Array.from(this.live).some((clue)=>clue.spotlight?.host === host);
        this.dropScrim = (host)=>{
            const scrim = this.scrims.get(host);
            this.scrims.delete(host);
            scrim?.undim();
            if (scrim && !scrim.destroyed) {
                scrim.parent?.removeChild(scrim);
                scrim.destroy();
            }
        };
        // Redraw a host's dimming for the clues lit in it now: one cut per control. With none left, the
        // scrim stays (whole, no cuts) to fade out with the level, unless another host has taken the
        // spotlight over -- a rebuilt panel -- in which case the old one is not on screen to fade.
        this.syncScrim = (host)=>{
            const clues = Array.from(this.live).filter((clue)=>clue.spotlight?.host === host);
            if (clues.length === 0) {
                const handedOver = Array.from(this.live).some((clue)=>clue.spotlight && clue.spotlight.host !== host);
                if (handedOver || host.destroyed) this.dropScrim(host);
                else {
                    const scrim = this.scrims.get(host);
                    if (scrim?.area && !scrim.destroyed) scrim.draw(scrim.area, []);
                }
                return;
            }
            // A newer host means the panel was rebuilt: the old scrim went with the old tree.
            Array.from(this.scrims.keys()).filter((other)=>other !== host).forEach(this.dropScrim);
            const area = clues[clues.length - 1].spotlight.area;
            let scrim = this.scrims.get(host);
            if (!scrim || scrim.destroyed) {
                scrim = new (0, $f9d75e6d13623a22$export$cfe00a7eb4ed7ee8)();
                this.scrims.set(host, scrim);
            }
            scrim.draw(area, (0, $f9d75e6d13623a22$export$7cab943deb1e7343)(area, clues.map((clue)=>clue.spotlight.target)));
            scrim.setLevel(this.scrimAlpha());
            // Under everything the clues draw: the lit frames and the notes stand on it.
            if (scrim.parent !== host) host.addChildAt(scrim, 0);
            else host.setChildIndex(scrim, 0);
        };
        this.pose = (clue)=>{
            if (clue.note.destroyed) {
                // Its host was torn down under it without a stop (nothing should, but a clue is never
                // worth an exception in the frame loop).
                this.live.delete(clue);
                return;
            }
            const shown = this.clock - clue.shownAt;
            const left = clue.leftAt === undefined ? undefined : this.clock - clue.leftAt;
            clue.ring?.poseAt(shown, left);
            const note = (0, $f9d75e6d13623a22$export$3ccde2ac49bf4924)(shown, left);
            clue.note.alpha = note.alpha;
            clue.note.x = clue.restX + clue.slideX * note.slide;
            clue.note.y = clue.restY + clue.slideY * note.slide;
            if (left !== undefined && left >= (0, $f9d75e6d13623a22$export$15db115911357705)) clue.remove();
        };
        // Builds the note (and, given a control's size, the brackets that go round it) every tutorial
        // and clue is made of, and how to take them down. Placing them is the caller's business.
        // `timeoutMs` of 0 means it does not take itself down: the ember clues have their own lifetime
        // (see ember_clues.ts).
        this.setupTutorial = (tutorialType, text, ringTarget, timeoutMs = $dbd41000427e8969$var$POPUP_TIMEOUT_MS)=>{
            if (this.activeTutorials.has(tutorialType)) return undefined;
            this.activeTutorials.add(tutorialType);
            // While the pointer is on the note the world does not get the mouse, so a click meant for
            // the note (or for its dismiss X) is not also a swing at whatever is behind it. Tracked here
            // rather than left to pixi so the teardown can hand the mouse back (see stop), and so a note
            // never clears a latch it did not set.
            let hovered = false;
            const setHovered = (over)=>{
                if (hovered === over) return;
                hovered = over;
                this.gui.mouseOverControl(over);
            };
            // Dismissing a CLUE has to disarm it as well as take it down, or the next rebuild of the panel
            // it points at would put it straight back up over a player who has said they are done with it.
            const note = new (0, $f9d75e6d13623a22$export$e075b0a1fbcd98a)({
                lines: text,
                onDismiss: ()=>{
                    stop({
                        fade: true
                    });
                    if ((0, $cb689cfa16c444ba$export$a35d0571df2da201)(tutorialType)) this.clues.disarm(tutorialType);
                }
            });
            note.interactive = true;
            note.on("mouseover", ()=>setHovered(true));
            note.on("mouseout", ()=>setHovered(false));
            const ring = !ringTarget ? undefined : ringTarget.lit ? new (0, $f9d75e6d13623a22$export$26863edc8177020b)(ringTarget) : new (0, $f9d75e6d13623a22$export$97b6fabf308fe0b4)(ringTarget);
            const previous = this.lastShown.get(tutorialType);
            // Removal can be asked for twice -- the frame clock finishing a fade, then the fallback timer
            // behind it -- and a second destroy() on a Graphics throws.
            let removed = false;
            const clue = {
                note: note,
                ring: ring,
                shownAt: previous && previous.at === this.clock ? previous.shownAt : this.clock,
                restX: 0,
                restY: 0,
                slideX: 0,
                slideY: 0,
                remove: ()=>{
                    if (removed) return;
                    removed = true;
                    this.live.delete(clue);
                    if (clue.spotlight) this.syncScrim(clue.spotlight.host);
                    ring?.parent?.removeChild(ring);
                    ring?.destroy();
                    note.parent?.removeChild(note);
                    // Its Text textures are per-instance and not reclaimed by GC.
                    if (!note.destroyed) note.destroy({
                        children: true,
                        texture: true,
                        baseTexture: true
                    });
                }
            };
            this.live.add(clue);
            // Idempotent: a clue can be taken down by its own dismiss X, by its expiry timer, by the panel
            // it points at being rebuilt, and by the tutorial being marked seen -- and more than one of
            // those can land on the same clue.
            let stopped = false;
            const stop = (opts)=>{
                if (stopped) return;
                stopped = true;
                // Give the world its mouse back FIRST. The note takes it away while the pointer is on it,
                // and the commonest way for one to go is the player clicking its own dismiss X -- with the
                // pointer right there on it. Removing a display object does not make pixi deliver the
                // mouseout it owed, so the latch would stay set and the player would be left unable to
                // walk or swing until the next room load. The expiry timer and a panel rebuild can land
                // under a resting pointer the same way.
                setHovered(false);
                this.activeTutorials.delete(tutorialType);
                note.interactive = false;
                note.interactiveChildren = false;
                // Going for good, and still on screen: let the frame clock fade it. Otherwise -- a redraw,
                // or the control it named has just gone with its panel -- at once, so nothing is left
                // pointing at where a control used to be.
                if (opts?.fade && note.parent && note.worldVisible) {
                    clue.leftAt = this.clock;
                    // The frame clock stops in a hidden tab; the clue must still go.
                    setTimeout(clue.remove, (0, $f9d75e6d13623a22$export$15db115911357705) + 500);
                    return;
                }
                this.lastShown.set(tutorialType, {
                    shownAt: clue.shownAt,
                    at: this.clock
                });
                clue.remove();
            };
            if (timeoutMs > 0) setTimeout(()=>stop({
                    fade: true
                }), timeoutMs);
            return {
                note: note,
                ring: ring,
                clue: clue,
                stop: stop
            };
        };
        // Puts a note beside a control and brackets round it -- every clue, and every overworld popup that
        // has a control to point at -- and hands back how to take them down.
        this.pointAt = (tutorialType, text, anchor, timeoutMs)=>{
            const lit = !!anchor.spotlight;
            const built = this.setupTutorial(tutorialType, text, {
                w: anchor.w,
                h: anchor.h,
                round: anchor.round,
                lit: lit
            }, timeoutMs);
            if (!built) return undefined;
            const { note: note, ring: ring, clue: clue, stop: stop } = built;
            if (anchor.spotlight) {
                const target = anchor.reveal || {
                    x: anchor.x,
                    y: anchor.y,
                    w: anchor.w,
                    h: anchor.h
                };
                clue.spotlight = {
                    host: anchor.host,
                    area: anchor.spotlight,
                    target: target
                };
            }
            // Brackets under the note: where the two meet, the words win.
            if (ring) {
                ring.x = anchor.x;
                ring.y = anchor.y;
                anchor.host.addChild(ring);
            }
            anchor.host.addChild(note);
            const placement = anchor.placement || "left";
            const box = note.noteRect();
            const { boxX: boxX, boxY: boxY } = (0, $9600e6b065d22e57$export$e8a38504aad4fd94)({
                anchorX: anchor.x,
                anchorY: anchor.y,
                anchorW: anchor.w,
                anchorH: anchor.h,
                boxW: box.width,
                boxH: box.height,
                boxMinX: anchor.boxMinX,
                boxMaxX: anchor.boxMaxX,
                placement: placement
            });
            // ...then held inside the host's visible screen, which a scaled or docked host reports.
            const clamp = (value, min, max, size)=>{
                const lower = min === undefined ? -Infinity : min;
                const upper = max === undefined ? Infinity : max - size;
                return Math.max(lower, Math.min(value, Math.max(lower, upper)));
            };
            const x = Math.round(clamp(boxX, anchor.boxMinX, anchor.boxMaxX, box.width));
            const y = Math.round(clamp(boxY, anchor.boxMinY, anchor.boxMaxY, box.height));
            note.setNotch((0, $9600e6b065d22e57$export$eb9ecf2fc66f62b3)({
                placement: placement,
                boxX: x,
                boxY: y,
                boxW: box.width,
                boxH: box.height,
                anchorX: anchor.x,
                anchorY: anchor.y,
                anchorW: anchor.w,
                anchorH: anchor.h
            }));
            clue.restX = x;
            clue.restY = y;
            [clue.slideX, clue.slideY] = $dbd41000427e8969$var$SLIDE_FROM[placement];
            this.pose(clue);
            if (clue.spotlight) this.syncScrim(anchor.host);
            return stop;
        };
        // The overworld popups: one notice each, raised by the intro campaign's own triggers.
        this.setupHotbarTutorial = ()=>{
            const anchor = this.builtInClueAnchor("ember-ready");
            if (!anchor) return;
            this.pointAt("hotbar", [
                "This is your hotbar.",
                "Activate readied equipment, supplies, and follower commands",
                "by pressing their associated numbers and letters (1, 2, J, K ...)."
            ], anchor, $dbd41000427e8969$var$POPUP_TIMEOUT_MS);
        };
        this.setupMapTutorial = ()=>{
            const map = this.minimapSurface;
            if (!map) return;
            this.pointAt("map", [
                "This is your map.",
                "Points of interest appear as icons, and new ones pulse to get your attention."
            ], {
                host: this.surface,
                ...this.viewportLimits(this.surface),
                x: map.x,
                y: map.y,
                w: map.width,
                h: map.height
            }, $dbd41000427e8969$var$POPUP_TIMEOUT_MS);
        };
        this.setupControlbarTutorial = ()=>{
            const anchor = this.builtInClueAnchor("ember-items");
            if (!anchor) return;
            this.pointAt("controlbar", [
                "Access your inventory and craft items using these controls."
            ], anchor, $dbd41000427e8969$var$POPUP_TIMEOUT_MS);
        };
        this.setupCompanionTutorial = ()=>{
            const playerEntity = this.gui.logic.playerEntity;
            if (!playerEntity) {
                this.activeTutorials.delete("companion");
                return;
            }
            const companion = this.gui.logic.entityManager.find((e)=>e.leaderEntityId === playerEntity.entityId);
            if (!companion) {
                this.activeTutorials.delete("companion");
                return;
            }
            const entityRenderable = this.gui.logic.clientRenderer.map().overlay().getEntityRenderable(companion.entityId);
            if (!entityRenderable) {
                this.activeTutorials.delete("companion");
                return;
            }
            const tutorial = this.setupTutorial("companion", [
                "This is your companion and protected.",
                "Mouse over him, and click the icons that appear to interact."
            ]);
            if (!tutorial) return;
            // Hung off the companion's own renderable so it walks with him: the note to his left, its
            // notch pointing across at him. No brackets -- a body is not a control.
            const { note: note, clue: clue } = tutorial;
            entityRenderable.addChild(note);
            const box = note.noteRect();
            clue.restX = -box.width - (0, $9600e6b065d22e57$export$f0cf1164e72697ca) - 2;
            clue.restY = -25;
            [clue.slideX, clue.slideY] = $dbd41000427e8969$var$SLIDE_FROM.left;
            note.setNotch({
                edge: "right",
                tipX: box.width + (0, $9600e6b065d22e57$export$f0cf1164e72697ca),
                tipY: box.height / 2
            });
            this.pose(clue);
        };
        // =========================================================================================
        // THE EMBER CLUES
        //
        // Five pointer-and-text boxes that name the controls the camp's first fire is built with. They are
        // armed by the SERVER (assets/scripts/v2/ember-tutorial.js), one beat at a time, because only the
        // director knows which beat is live -- the client cannot tell "waiting for a campfire to be
        // crafted" from "the player is browsing recipes for fun".
        //
        // The rules (armed vs anchored, lifetime, teardown) are in ember_clues.ts. This half draws them.
        // =========================================================================================
        // Whatever draws one of the clued controls says where it landed. Called again on every rebuild of
        // the panel it lives in.
        this.registerClueAnchor = (tutorialType, anchor)=>this.clues.registerAnchor(tutorialType, anchor);
        // The control has gone (its panel closed, or this rebuild no longer draws it).
        this.clearClueAnchor = (tutorialType)=>this.clues.clearAnchor(tutorialType);
        // The player DID the thing this clue was pointing at, so it has served its purpose and goes for
        // good. Disarm rather than merely retract: a satisfied clue must not come back when the panel it
        // pointed at is next rebuilt, or reopening the pack would re-light a label for a step already done.
        this.satisfyClue = (tutorialType)=>this.clues.disarm(tutorialType);
        // Opening either item screen satisfies the hints pointing at the Items pill, regardless of
        // which controls or recipes the panel happens to draw.
        this.itemScreenOpened = ()=>{
            for (const type of [
                "ember-items",
                "ember-planks-items",
                "ember-wood-items"
            ])this.satisfyClue(type);
        };
        // Every clue down and disarmed: the tutorial is over, or the camp is.
        this.clearBuildingDemo = ()=>{
            this.buildingDemoPendingUntilInventoryClose = false;
            if (this.buildingDemo && !this.buildingDemo.destroyed) this.buildingDemo.destroy();
            this.buildingDemo = undefined;
            this.poseDemoScrim();
        };
        this.itemScreenClosed = ()=>{
            if (!this.buildingDemoPendingUntilInventoryClose) return;
            this.buildingDemoPendingUntilInventoryClose = false;
            if (this.buildingDemoShownLocally || this.gui.logic?.playerEntity?.flags?.emberBuildingTutorialShown) return;
            if (!this.buildingDemo || this.buildingDemo.destroyed) {
                this.buildingDemo = new (0, $52327f3b2610ea75$export$2096d43a63683d03)((over)=>this.gui.mouseOverControl(over), this.clearBuildingDemo);
                this.demoSurface.addChild(this.buildingDemo);
                this.buildingDemoShownLocally = true;
                this.gui.logic.playerController.client.emitPlayerEvent({
                    playerEventType: "EMBER_BUILDING_TUTORIAL_SHOWN"
                });
            }
        };
        this.clearForagerDemo = ()=>{
            if (this.foragerDemo && !this.foragerDemo.destroyed) this.foragerDemo.destroy();
            this.foragerDemo = undefined;
            this.poseDemoScrim();
        };
        this.clearDemolitionDemo = ()=>{
            if (this.demolitionDemo && !this.demolitionDemo.destroyed) this.demolitionDemo.destroy();
            this.demolitionDemo = undefined;
            this.poseDemoScrim();
        };
        this.clearSprintDemo = ()=>{
            if (this.sprintDemo && !this.sprintDemo.destroyed) this.sprintDemo.destroy();
            this.sprintDemo = undefined;
            this.poseDemoScrim();
        };
        this.clearEmberClues = ()=>{
            this.clues.clearAll();
            this.clearBuildingDemo();
            this.clearDemolitionDemo();
            this.clearForagerDemo();
            this.clearSprintDemo();
        };
        this.isClueArmed = (tutorialType)=>this.clues.isArmed(tutorialType);
        this.isClueShowing = (tutorialType)=>this.clues.isShowing(tutorialType);
        this.isAnyClueShowing = ()=>this.clues.anyShowing();
        // Draw one clue at its anchor, and hand back how to take it down.
        this.drawClue = (tutorialType, anchor)=>this.pointAt(tutorialType, (0, $9600e6b065d22e57$export$cbebaa48d952aec0)[tutorialType], anchor, 0);
        // The one clue whose control is part of the permanent HUD rather than a panel, so it needs no
        // registration: in a CAMP the pack is opened from the ITEMS chip in the top-right row, because
        // ember rooms suppress the control bar (GuiManager.roomUpdated). The bar's own inventory.png --
        // the first entry in ControlBar.setup() -- is the fallback for a room that leaves the bar up.
        this.builtInClueAnchor = (tutorialType)=>{
            // The pre-wave COUNTDOWN DIAL, which is the deadline the run hint is about: it is up for the
            // ten seconds before a wave spawns, with nothing else happening on screen, and it goes away
            // by itself when the wave lands.
            //
            // DESKTOP ONLY. On a phone the run is the move stick pushed out to the rim
            // (client_util's sprintScaledIntent) -- there is no persistent control to ring, and a thumb
            // that commits a direction fully discovers it without being told.
            if (tutorialType === "ember-run") {
                if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) return null;
                const dial = this.countdownDial;
                if (!dial || !dial.visible || !(dial.dialSize > 0)) return null;
                const size = dial.dialSize;
                // The first anchor that points at a widget living on the STAGE rather than in the HUD
                // container the clues are drawn into, so its position has to come back across that
                // offset (GuiManager.init sets container.x; the chip layer copies it for the same
                // reason). The dial also positions itself by its CENTRE, not its corner.
                return {
                    host: this.surface,
                    ...this.viewportLimits(this.surface),
                    x: dial.x - size / 2 - (this.surface.x || 0),
                    y: dial.y - size / 2 - (this.surface.y || 0),
                    w: size,
                    h: size,
                    placement: "right",
                    round: true
                };
            }
            // The ready bar, which is the equipped widget: permanent HUD, so nothing has to report it.
            if (tutorialType === "ember-ready" || tutorialType === "ember-wood") {
                if (!this.equippedWidget || !this.equippedWidget.visible) return null;
                const bounds = tutorialType === "ember-wood" ? this.equippedWidget.getWoodSlotBounds?.() : this.equippedWidget.getLocalBounds();
                if (!bounds) return null;
                const host = this.equippedWidget.parent || this.surface;
                return {
                    host: host,
                    ...this.viewportLimits(host),
                    x: this.equippedWidget.x + bounds.x * this.equippedWidget.scale.x,
                    y: this.equippedWidget.y + bounds.y * this.equippedWidget.scale.y,
                    w: bounds.width * this.equippedWidget.scale.x,
                    h: bounds.height * this.equippedWidget.scale.y,
                    placement: "above"
                };
            }
            if (tutorialType !== "ember-items" && tutorialType !== "ember-planks-items" && tutorialType !== "ember-wood-items") return null;
            const chip = this.emberInventoryChip;
            if (chip && chip.visible && (!chip.parent || chip.parent.worldVisible)) {
                const host = chip.parent || this.surface;
                return {
                    host: host,
                    ...this.viewportLimits(host),
                    x: chip.x,
                    y: chip.y,
                    w: chip.getWidth(),
                    h: chip.getHeight()
                };
            }
            if (!this.controlBar || !this.controlBar.visible) return null;
            return {
                host: this.surface,
                x: this.controlBar.x + $dbd41000427e8969$var$CONTROLBAR_ITEMS_OFFSET_X,
                y: this.controlBar.y,
                w: $dbd41000427e8969$var$CONTROLBAR_ITEMS_W,
                h: $dbd41000427e8969$var$CONTROLBAR_ITEMS_H
            };
        };
        this.viewportLimits = (host)=>{
            if (!this.gui.stage) return {};
            const safe = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().safeViewport;
            const topLeft = host.toLocal(new (0, $6qzqq.Point)(safe.left, safe.top), this.gui.stage);
            const bottomRight = host.toLocal(new (0, $6qzqq.Point)(safe.right, safe.bottom), this.gui.stage);
            return {
                boxMinX: topLeft.x + 8,
                boxMaxX: bottomRight.x - 8,
                boxMinY: topLeft.y + 8,
                boxMaxY: bottomRight.y - 8
            };
        };
        this.hudAnchors = new Map();
        this.refreshHudAnchors = ()=>{
            for (const type of [
                "ember-run",
                "ember-ready",
                "ember-wood",
                "ember-items",
                "ember-planks-items",
                "ember-wood-items"
            ]){
                const anchor = this.builtInClueAnchor(type);
                const previous = this.hudAnchors.get(type);
                if (!anchor) {
                    this.clues.clearAnchor(type);
                    this.hudAnchors.delete(type);
                } else if (!previous || Object.keys(anchor).some((key)=>anchor[key] !== previous[key])) {
                    this.hudAnchors.set(type, anchor);
                    this.clues.registerAnchor(type, anchor);
                }
            }
        };
        // The one way in from the wire (GuiManager.showTutorial). What each kind of message means -- and
        // which of them `suppressed` is allowed to swallow -- is decided in one place, routeTutorial.
        this.setup = (tutorialType, timeoutMs)=>{
            this.refreshHudAnchors();
            if (tutorialType === "ember-sprint-demo") {
                // Chapter timing belongs to the server; private player flags are not on the wire.
                if (!this.sprintDemo) {
                    this.sprintDemo = new (0, $3de9dff7c679ccea$export$80c7bb7133a52b84)((over)=>this.gui.mouseOverControl(over), this.clearSprintDemo, undefined, this.gui.logic?.playerEntity);
                    this.demoSurface.addChild(this.sprintDemo);
                }
                return;
            }
            if (tutorialType === "ember-demolition-demo") {
                // Chapter timing belongs to the server; private player flags are not on the wire.
                if (!this.demolitionDemo) {
                    this.demolitionDemo = new (0, $52327f3b2610ea75$export$2096d43a63683d03)((over)=>this.gui.mouseOverControl(over), this.clearDemolitionDemo, "demolish");
                    this.demoSurface.addChild(this.demolitionDemo);
                }
                return;
            }
            if (tutorialType === "ember-roof-demo") {
                if (this.buildingDemoShownLocally || this.gui.logic?.playerEntity?.flags?.emberBuildingTutorialShown) return;
                this.buildingDemoPendingUntilInventoryClose = true;
                return;
            }
            if (tutorialType === "ember-building-demo") {
                if (!this.buildingDemo) {
                    this.buildingDemo = new (0, $52327f3b2610ea75$export$2096d43a63683d03)((over)=>this.gui.mouseOverControl(over), this.clearBuildingDemo);
                    this.demoSurface.addChild(this.buildingDemo);
                }
                return;
            }
            if (tutorialType === "ember-forager-demo") {
                if (!this.foragerDemo) {
                    this.foragerDemo = new (0, $a9a9835bf946efb8$export$97d258abb54b739c)((over)=>this.gui.mouseOverControl(over), this.clearForagerDemo);
                    this.demoSurface.addChild(this.foragerDemo);
                }
                return;
            }
            const route = (0, $9600e6b065d22e57$export$9069b388aec1210a)(tutorialType, this.suppressed);
            if (route === "clear") {
                // Step changes leave the inventory open; its controls still have valid anchors.
                // Room changes use clearEmberClues() to discard those anchors as well.
                this.clues.clearAll(true);
                this.clearBuildingDemo();
                this.clearDemolitionDemo();
                this.clearForagerDemo();
                this.clearSprintDemo();
                return;
            }
            if (route === "suppressed") return;
            if (route === "clue") {
                this.clues.arm(tutorialType, timeoutMs);
                return;
            }
            const all = false;
            if (all || tutorialType === "controlbar") this.setupControlbarTutorial();
            if (all || tutorialType === "hotbar") this.setupHotbarTutorial();
            if (all || tutorialType === "map") this.setupMapTutorial();
            if (all || tutorialType === "companion") setTimeout(()=>{
                this.setupCompanionTutorial();
            }, 4000);
        };
        this.gui = gui;
        this.surface = surface;
        this.equippedWidget = equippedWidget;
        this.controlBar = controlBar;
        this.minimapSurface = minimapSurface;
        this.emberInventoryChip = emberInventoryChip;
        this.demoSurface = demoSurface || surface;
    }
    // The wave countdown dial, read off the GuiManager rather than taken in the constructor: it is
    // permanent HUD furniture like the ready bar, and a GuiManager stub in a test simply leaves it
    // undefined, which builtInClueAnchor already treats as "nothing to anchor to".
    get countdownDial() {
        return this.gui.countdownTimer;
    }
}


parcelRequire("1avo5");
var $9Pi8W = parcelRequire("9Pi8W");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");



const $1d7285dcca0039d8$var$BLINK_MS = 530;
// Start warning about the length cap once the line is this close to it. Earlier than that it is
// noise; later and the player hits the cap mid-word with no warning at all.
const $1d7285dcca0039d8$var$COUNTER_FROM = (0, $2bc3e70fbff7f064$export$4779cfd32b998f47) - 30;
const $1d7285dcca0039d8$var$CARET_W = 1.5;
const $1d7285dcca0039d8$var$CHEVRON_GAP = 5;
// Air kept to the right of the text so a caret at the end of a full line is never flush against
// the rim.
const $1d7285dcca0039d8$var$TAIL_PAD = 3;
class $1d7285dcca0039d8$export$3997e86453ee41f3 extends (0, $8t5Gy.Container) {
    constructor(){
        super(), this.textX = 0, this.viewportWidth = 0, this.update = (state)=>{
            this.visible = true;
            this.startBlink();
            const isCommand = state.value.startsWith("/");
            this.textNode.text = state.value;
            this.textNode.tint = isCommand ? (0, $bde0eb94ead9038f$export$1f7cbc51fe7009c3) : (0, $bde0eb94ead9038f$export$516f68680b50dca1);
            const remaining = (0, $2bc3e70fbff7f064$export$4779cfd32b998f47) - state.value.length;
            const showCounter = state.value.length >= $1d7285dcca0039d8$var$COUNTER_FROM;
            this.counter.visible = showCounter;
            if (showCounter) {
                this.counter.text = `${remaining}`;
                this.counter.tint = remaining <= 10 ? (0, $bde0eb94ead9038f$export$ddc55e6671963e97) : (0, $bde0eb94ead9038f$export$dc58655d5df465a7);
            }
            this.layoutRows();
            const caretX = this.measure(state.value.slice(0, state.caret));
            this.caret.x = caretX;
            // Keep the caret inside the field: scroll only as far as it has to, and never past the
            // start, so a short line always sits against the chevron.
            const maxScroll = Math.max(0, this.measure(state.value) - this.viewportWidth + $1d7285dcca0039d8$var$TAIL_PAD);
            let scroll = -this.textNode.x;
            if (caretX - scroll > this.viewportWidth - $1d7285dcca0039d8$var$TAIL_PAD) scroll = caretX - this.viewportWidth + $1d7285dcca0039d8$var$TAIL_PAD;
            if (caretX - scroll < 0) scroll = caretX;
            scroll = Math.max(0, Math.min(scroll, maxScroll));
            this.textNode.x = -scroll;
            this.caret.x -= scroll;
        }, this.removeText = ()=>{
            this.visible = false;
            this.textNode.text = "";
            this.textNode.x = 0;
            this.stopBlink();
        }, // Width of a prefix of the line, in the field's own font. TextMetrics caches per string+style,
        // so re-measuring on every keystroke is cheap.
        this.measure = (text)=>text ? (0, $9Pi8W.TextMetrics).measureText(text, this.textNode.style).width : 0, this.layoutRows = ()=>{
            const lineH = this.textNode.height || (0, $bde0eb94ead9038f$export$ec0e4eff17ebd09e) + 4;
            const baseline = Math.round(((0, $bde0eb94ead9038f$export$251eac38a164bee4) - lineH) / 2);
            this.chevron.y = Math.round(((0, $bde0eb94ead9038f$export$251eac38a164bee4) - (this.chevron.height || lineH)) / 2);
            this.viewport.y = baseline;
            // The countdown to the length cap is pinned to the right edge, and takes its width out of
            // the field the text may scroll in.
            const tail = this.counter.visible ? this.counter : undefined;
            const tailWidth = tail ? (tail.width || 0) + $1d7285dcca0039d8$var$CHEVRON_GAP : 0;
            if (tail) {
                tail.x = (0, $bde0eb94ead9038f$export$72ee0c7a4855a274) - (0, $bde0eb94ead9038f$export$4f4624f448d7f7d8) - (tail.width || 0);
                tail.y = Math.round(((0, $bde0eb94ead9038f$export$251eac38a164bee4) - (tail.height || (0, $bde0eb94ead9038f$export$c1e8972bf2d4e8dc))) / 2) + 1;
            }
            this.viewportWidth = Math.max(40, (0, $bde0eb94ead9038f$export$72ee0c7a4855a274) - this.textX - (0, $bde0eb94ead9038f$export$4f4624f448d7f7d8) - tailWidth);
            this.textMask.clear();
            this.textMask.beginFill(0xffffff);
            this.textMask.drawRect(this.textX, 0, this.viewportWidth, (0, $bde0eb94ead9038f$export$251eac38a164bee4));
            this.textMask.endFill();
            this.caret.clear();
            this.caret.beginFill((0, $bde0eb94ead9038f$export$4a863a35dfd357dc), 0.95);
            this.caret.drawRect(0, 1, $1d7285dcca0039d8$var$CARET_W, Math.max(10, lineH - 2));
            this.caret.endFill();
        }, this.drawPanel = ()=>{
            this.shadow.clear();
            this.shadow.beginFill((0, $bde0eb94ead9038f$export$a9fed83f1c193f7e), (0, $bde0eb94ead9038f$export$7fb3621e17d8a3da));
            this.shadow.drawRoundedRect((0, $bde0eb94ead9038f$export$ba288e268a12646c), (0, $bde0eb94ead9038f$export$ba288e268a12646c), (0, $bde0eb94ead9038f$export$72ee0c7a4855a274), (0, $bde0eb94ead9038f$export$251eac38a164bee4), (0, $bde0eb94ead9038f$export$440d7b56d7e79537));
            this.shadow.endFill();
            this.panel.clear();
            this.panel.lineStyle({
                width: 1,
                color: (0, $bde0eb94ead9038f$export$542c8a566b36979),
                alpha: 0.55,
                join: (0, $gwPoJ.LINE_JOIN).ROUND
            });
            this.panel.beginFill((0, $bde0eb94ead9038f$export$35cf6b4f538836cd), (0, $bde0eb94ead9038f$export$5eb57294d7a01ff));
            this.panel.drawRoundedRect(0, 0, (0, $bde0eb94ead9038f$export$72ee0c7a4855a274), (0, $bde0eb94ead9038f$export$251eac38a164bee4), (0, $bde0eb94ead9038f$export$440d7b56d7e79537));
            this.panel.endFill();
        }, // The caret is solid while the player is typing and only resumes blinking once they stop --
        // a caret that blinks THROUGH the keystroke reads as dropped input.
        this.startBlink = ()=>{
            this.caret.visible = true;
            if (this.blinkInterval) clearInterval(this.blinkInterval);
            this.blinkInterval = setInterval(()=>{
                this.caret.visible = !this.caret.visible;
            }, $1d7285dcca0039d8$var$BLINK_MS);
        }, this.stopBlink = ()=>{
            clearInterval(this.blinkInterval);
            this.blinkInterval = undefined;
            this.caret.visible = false;
        };
        this.shadow = new (0, $gwPoJ.Graphics)();
        this.panel = new (0, $gwPoJ.Graphics)();
        this.addChild(this.shadow);
        this.addChild(this.panel);
        this.chevron = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize((0, $bde0eb94ead9038f$export$ec0e4eff17ebd09e)).color((0, $bde0eb94ead9038f$export$542c8a566b36979)).bold().strokeThickness(0).render(">");
        this.chevron.x = (0, $bde0eb94ead9038f$export$4f4624f448d7f7d8);
        this.addChild(this.chevron);
        this.textX = (0, $bde0eb94ead9038f$export$4f4624f448d7f7d8) + (this.chevron.width || (0, $bde0eb94ead9038f$export$ec0e4eff17ebd09e) * 0.6) + $1d7285dcca0039d8$var$CHEVRON_GAP;
        // Everything that scrolls lives in the viewport; the mask is what makes a long line stop
        // at the rim instead of running on across the world behind the panel.
        this.viewport = new (0, $8t5Gy.Container)();
        this.viewport.x = this.textX;
        this.textMask = new (0, $gwPoJ.Graphics)();
        this.viewport.mask = this.textMask;
        this.addChild(this.textMask);
        this.addChild(this.viewport);
        this.textNode = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize((0, $bde0eb94ead9038f$export$ec0e4eff17ebd09e)).color((0, $bde0eb94ead9038f$export$516f68680b50dca1)).strokeThickness(0).render("");
        this.caret = new (0, $gwPoJ.Graphics)();
        this.viewport.addChild(this.textNode);
        this.viewport.addChild(this.caret);
        this.counter = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize((0, $bde0eb94ead9038f$export$c1e8972bf2d4e8dc)).color((0, $bde0eb94ead9038f$export$dc58655d5df465a7)).strokeThickness(0).render("");
        this.counter.visible = false;
        this.addChild(this.counter);
        this.drawPanel();
        this.layoutRows();
        this.visible = false;
    }
}



parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $3YyWq = parcelRequire("3YyWq");
var $f569351cceda89c3$exports = {};
"use strict";
var $f569351cceda89c3$var$__extends = $f569351cceda89c3$exports && $f569351cceda89c3$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f569351cceda89c3$var$__createBinding = $f569351cceda89c3$exports && $f569351cceda89c3$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f569351cceda89c3$var$__setModuleDefault = $f569351cceda89c3$exports && $f569351cceda89c3$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f569351cceda89c3$var$__importStar = $f569351cceda89c3$exports && $f569351cceda89c3$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f569351cceda89c3$var$__createBinding(result, mod, k);
    }
    $f569351cceda89c3$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($f569351cceda89c3$exports, "__esModule", {
    value: true
});
$f569351cceda89c3$exports.Joystick = $f569351cceda89c3$exports.Direction = void 0;

var $f569351cceda89c3$var$PIXI = $f569351cceda89c3$var$__importStar((parcelRequire("1avo5")));
var $f569351cceda89c3$var$Direction;
(function(Direction) {
    Direction["LEFT"] = "left";
    Direction["TOP"] = "top";
    Direction["BOTTOM"] = "bottom";
    Direction["RIGHT"] = "right";
    Direction["TOP_LEFT"] = "top_left";
    Direction["TOP_RIGHT"] = "top_right";
    Direction["BOTTOM_LEFT"] = "bottom_left";
    Direction["BOTTOM_RIGHT"] = "bottom_right";
})($f569351cceda89c3$var$Direction = $f569351cceda89c3$exports.Direction || ($f569351cceda89c3$exports.Direction = {}));
var $f569351cceda89c3$var$Joystick = /** @class */ function(_super) {
    $f569351cceda89c3$var$__extends(Joystick, _super);
    function Joystick(opts) {
        var _this = _super.call(this) || this;
        _this.outerRadius = 0;
        _this.innerRadius = 0;
        _this.innerAlphaStandby = 0.5;
        _this.settings = Object.assign({
            outerScale: {
                x: 1,
                y: 1
            },
            innerScale: {
                x: 1,
                y: 1
            }
        }, opts);
        if (!_this.settings.outer) {
            var outer = new $f569351cceda89c3$var$PIXI.Graphics();
            outer.beginFill(0x000000);
            outer.drawCircle(0, 0, 60);
            outer.alpha = 0.5;
            _this.settings.outer = outer;
        }
        if (!_this.settings.inner) {
            var inner = new $f569351cceda89c3$var$PIXI.Graphics();
            inner.beginFill(0x000000);
            inner.drawCircle(0, 0, 35);
            inner.alpha = _this.innerAlphaStandby;
            _this.settings.inner = inner;
        }
        _this.initialize();
        return _this;
    }
    Joystick.prototype.initialize = function() {
        this.outer = this.settings.outer;
        this.inner = this.settings.inner;
        this.outer.scale.set(this.settings.outerScale.x, this.settings.outerScale.y);
        this.inner.scale.set(this.settings.innerScale.x, this.settings.innerScale.y);
        if ('anchor' in this.outer) this.outer.anchor.set(0.5);
        if ('anchor' in this.inner) this.inner.anchor.set(0.5);
        this.addChild(this.outer);
        this.addChild(this.inner);
        // this.outerRadius = this.containerJoystick.width / 2;
        this.outerRadius = this.width / 2.5;
        this.innerRadius = this.inner.width / 2;
        this.bindEvents();
    };
    Joystick.prototype.bindEvents = function() {
        var that = this;
        this.interactive = true;
        var dragging = false;
        var eventData;
        var power;
        var startPosition;
        function onDragStart(event) {
            var _a, _b;
            eventData = event.data;
            startPosition = eventData.getLocalPosition(that);
            dragging = true;
            that.inner.alpha = 1;
            (_b = (_a = that.settings).onStart) === null || _b === void 0 || _b.call(_a);
        }
        function onDragEnd(event) {
            var _a, _b;
            if (dragging == false) return;
            that.inner.position.set(0, 0);
            dragging = false;
            that.inner.alpha = that.innerAlphaStandby;
            (_b = (_a = that.settings).onEnd) === null || _b === void 0 || _b.call(_a);
        }
        function onDragMove(event) {
            var _a, _b, _c, _d, _e, _f;
            if (dragging == false) return;
            var newPosition = eventData.getLocalPosition(that);
            var sideX = newPosition.x - startPosition.x;
            var sideY = newPosition.y - startPosition.y;
            var centerPoint = new $f569351cceda89c3$var$PIXI.Point(0, 0);
            var angle = 0;
            if (sideX == 0 && sideY == 0) return;
            var calRadius = 0;
            if (sideX * sideX + sideY * sideY >= that.outerRadius * that.outerRadius) calRadius = that.outerRadius;
            else calRadius = that.outerRadius - that.innerRadius;
            /**
             * x:   -1 <-> 1
             * y:   -1 <-> 1
             *          Y
             *          ^
             *          |
             *     180  |  90
             *    ------------> X
             *     270  |  360
             *          |
             *          |
             */ var direction = $f569351cceda89c3$var$Direction.LEFT;
            if (sideX == 0) {
                if (sideY > 0) {
                    centerPoint.set(0, sideY > that.outerRadius ? that.outerRadius : sideY);
                    angle = 270;
                    direction = $f569351cceda89c3$var$Direction.BOTTOM;
                } else {
                    centerPoint.set(0, -(Math.abs(sideY) > that.outerRadius ? that.outerRadius : Math.abs(sideY)));
                    angle = 90;
                    direction = $f569351cceda89c3$var$Direction.TOP;
                }
                that.inner.position.set(centerPoint.x, centerPoint.y);
                power = that.getPower(centerPoint);
                (_b = (_a = that.settings).onChange) === null || _b === void 0 || _b.call(_a, {
                    angle: angle,
                    direction: direction,
                    power: power
                });
                return;
            }
            if (sideY == 0) {
                if (sideX > 0) {
                    centerPoint.set(Math.abs(sideX) > that.outerRadius ? that.outerRadius : Math.abs(sideX), 0);
                    angle = 0;
                    direction = $f569351cceda89c3$var$Direction.LEFT;
                } else {
                    centerPoint.set(-(Math.abs(sideX) > that.outerRadius ? that.outerRadius : Math.abs(sideX)), 0);
                    angle = 180;
                    direction = $f569351cceda89c3$var$Direction.RIGHT;
                }
                that.inner.position.set(centerPoint.x, centerPoint.y);
                power = that.getPower(centerPoint);
                (_d = (_c = that.settings).onChange) === null || _d === void 0 || _d.call(_c, {
                    angle: angle,
                    direction: direction,
                    power: power
                });
                return;
            }
            var tanVal = Math.abs(sideY / sideX);
            var radian = Math.atan(tanVal);
            angle = radian * 180 / Math.PI;
            var centerX = 0;
            var centerY = 0;
            if (sideX * sideX + sideY * sideY >= that.outerRadius * that.outerRadius) {
                centerX = that.outerRadius * Math.cos(radian);
                centerY = that.outerRadius * Math.sin(radian);
            } else {
                centerX = Math.abs(sideX) > that.outerRadius ? that.outerRadius : Math.abs(sideX);
                centerY = Math.abs(sideY) > that.outerRadius ? that.outerRadius : Math.abs(sideY);
            }
            if (sideY < 0) centerY = -Math.abs(centerY);
            if (sideX < 0) centerX = -Math.abs(centerX);
            if (sideX > 0 && sideY < 0) ;
            else if (sideX < 0 && sideY < 0) // 90 ~ 180
            angle = 180 - angle;
            else if (sideX < 0 && sideY > 0) // 180 ~ 270
            angle = angle + 180;
            else if (sideX > 0 && sideY > 0) // 270 ~ 369
            angle = 360 - angle;
            centerPoint.set(centerX, centerY);
            power = that.getPower(centerPoint);
            direction = that.getDirection(centerPoint);
            that.inner.position.set(centerPoint.x, centerPoint.y);
            (_f = (_e = that.settings).onChange) === null || _f === void 0 || _f.call(_e, {
                angle: angle,
                direction: direction,
                power: power
            });
        }
        this.on('pointerdown', onDragStart).on('pointerup', onDragEnd).on('pointerupoutside', onDragEnd).on('pointermove', onDragMove);
    };
    Joystick.prototype.getPower = function(centerPoint) {
        var a = centerPoint.x - 0;
        var b = centerPoint.y - 0;
        return Math.min(1, Math.sqrt(a * a + b * b) / this.outerRadius);
    };
    Joystick.prototype.getDirection = function(center) {
        var rad = Math.atan2(center.y, center.x); // [-PI, PI]
        if (rad >= -Math.PI / 8 && rad < 0 || rad >= 0 && rad < Math.PI / 8) return $f569351cceda89c3$var$Direction.RIGHT;
        else if (rad >= Math.PI / 8 && rad < 3 * Math.PI / 8) return $f569351cceda89c3$var$Direction.BOTTOM_RIGHT;
        else if (rad >= 3 * Math.PI / 8 && rad < 5 * Math.PI / 8) return $f569351cceda89c3$var$Direction.BOTTOM;
        else if (rad >= 5 * Math.PI / 8 && rad < 7 * Math.PI / 8) return $f569351cceda89c3$var$Direction.BOTTOM_LEFT;
        else if (rad >= 7 * Math.PI / 8 && rad < Math.PI || rad >= -Math.PI && rad < -7 * Math.PI / 8) return $f569351cceda89c3$var$Direction.LEFT;
        else if (rad >= -7 * Math.PI / 8 && rad < -5 * Math.PI / 8) return $f569351cceda89c3$var$Direction.TOP_LEFT;
        else if (rad >= -5 * Math.PI / 8 && rad < -3 * Math.PI / 8) return $f569351cceda89c3$var$Direction.TOP;
        else return $f569351cceda89c3$var$Direction.TOP_RIGHT;
    };
    return Joystick;
}($f569351cceda89c3$var$PIXI.Container);
$f569351cceda89c3$exports.Joystick = $f569351cceda89c3$var$Joystick;


// How long a released stick takes to fade off the screen: long enough to read as the control
// letting go rather than a dropped frame, short enough that the next touch is not aiming at a
// ghost of the last one.
const $d433a8402e64fdc4$var$FADE_MS = 140;
// The eight compass sectors a stick reports, in order, from screen-right and going clockwise -- the
// direction of increasing atan2 once y points down the screen.
//
// Worked out here rather than taken from the library, whose own answer is wrong twice. Its sector
// table has a gap at exactly half a turn, so a dead-horizontal push to the LEFT matches no branch
// and falls out of the chain as top_right; and the axis-aligned shortcut that used to catch that
// case first reported `left` for a push to the right and `right` for a push to the left. A thumb
// almost never lands dead on an axis, which is how both survived.
const $d433a8402e64fdc4$var$SECTORS = [
    (0, $f569351cceda89c3$exports.Direction).RIGHT,
    (0, $f569351cceda89c3$exports.Direction).BOTTOM_RIGHT,
    (0, $f569351cceda89c3$exports.Direction).BOTTOM,
    (0, $f569351cceda89c3$exports.Direction).BOTTOM_LEFT,
    (0, $f569351cceda89c3$exports.Direction).LEFT,
    (0, $f569351cceda89c3$exports.Direction).TOP_LEFT,
    (0, $f569351cceda89c3$exports.Direction).TOP,
    (0, $f569351cceda89c3$exports.Direction).TOP_RIGHT
];
// A gesture that never pushed the stick this far out of its centre never steered anything, so it
// is a tap: the attack stick fires on one -- which is what pixi's own `tap` did for the pinned
// stick -- and the move stick does nothing with it. Expressed as a fraction of the travel, and the
// same fraction the handlers read as "no input" (GuiManager's JoystickDeadZone), so a tap is
// exactly a press that came back up without ever asking for anything.
const $d433a8402e64fdc4$var$TAP_POWER = 0.3;
class $d433a8402e64fdc4$export$c28ac4966a0b048a extends (0, $f569351cceda89c3$exports.Joystick) {
    constructor(opts){
        super(opts), // pixi's id for the finger holding this stick, or null when nothing holds it. A touch's id and
        // a mouse's pointer id are different numbers for the same gesture, but every id here comes out
        // of the one normalized stream FloatingSticks listens to, so they always compare.
        this.holder = null, // The furthest the finger has been from where it went down, in this stick's own pixels. What
        // separates a tap from a steer.
        this.reach = 0, this.fadeLeft = 0, this.isHeld = ()=>this.holder !== null, this.heldBy = (pointerId)=>this.holder === pointerId, /**
     * Put the stick under a finger and take hold of it. `at` is in the parent's coordinates, and
     * becomes the stick's centre: deflection is measured from where the finger landed, so the knob
     * starts dead centre however far from a corner the player touched.
     */ this.grab = (pointerId, at)=>{
            this.stopFade();
            this.holder = pointerId;
            this.reach = 0;
            this.position.set(at.x, at.y);
            this.inner.position.set(0, 0);
            this.inner.alpha = 1;
            this.alpha = 1;
            this.visible = true;
            this.settings.onStart?.();
        }, /** Steer: `at` is where the finger is now, in the parent's coordinates. */ this.steer = (at)=>{
            if (this.holder === null) return;
            const dx = at.x - this.position.x;
            const dy = at.y - this.position.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            this.reach = Math.max(this.reach, distance);
            // The knob tracks the finger out to the rim and stops there, keeping the direction. The
            // library clamped each axis separately, which bent a diagonal into the corner of a square
            // once either axis ran out; clamping the vector's length holds the angle the thumb chose.
            const pulled = Math.min(distance, this.outerRadius);
            const knob = distance > 0 ? new (0, $6qzqq.Point)(dx / distance * pulled, dy / distance * pulled) : new (0, $6qzqq.Point)(0, 0);
            this.inner.position.set(knob.x, knob.y);
            if (distance === 0) return;
            const bearing = Math.atan2(dy, dx);
            this.settings.onChange?.({
                // Degrees counter-clockwise from screen-right, the convention the library's own diagram
                // documents. Nothing in the HUD reads it -- direction and power are the whole signal --
                // but it is part of the event the handlers are typed against.
                angle: (-bearing * 180 / Math.PI + 360) % 360,
                direction: $d433a8402e64fdc4$var$SECTORS[(Math.round(bearing / (Math.PI / 4)) + 8) % 8],
                // Exactly how far out of its travel the thumb is: a ratio of the two lengths rather
                // than a re-measurement of the clamped knob, so a thumb at or past the rim reads as a
                // clean 1 and the sprint and fire thresholds have something exact to compare against.
                power: pulled / this.outerRadius
            });
        }, /**
     * Let go, and start fading out. Answers whether the gesture was a tap -- a press that went
     * down and came up without ever steering.
     */ this.release = ()=>{
            if (this.holder === null) return {
                tapped: false
            };
            this.holder = null;
            this.inner.position.set(0, 0);
            this.inner.alpha = this.innerAlphaStandby;
            this.settings.onEnd?.();
            this.fadeLeft = $d433a8402e64fdc4$var$FADE_MS;
            (0, $3YyWq.Ticker).shared.remove(this.fade);
            (0, $3YyWq.Ticker).shared.add(this.fade);
            return {
                tapped: this.reach <= this.outerRadius * $d433a8402e64fdc4$var$TAP_POWER
            };
        }, this.fade = ()=>{
            this.fadeLeft -= (0, $3YyWq.Ticker).shared.deltaMS || 0;
            if (this.fadeLeft <= 0) {
                this.stopFade();
                return;
            }
            this.alpha = this.fadeLeft / $d433a8402e64fdc4$var$FADE_MS;
        }, this.stopFade = ()=>{
            this.fadeLeft = 0;
            this.alpha = 0;
            this.visible = false;
            (0, $3YyWq.Ticker).shared.remove(this.fade);
        };
        this.visible = false;
        this.alpha = 0;
        // A stick is PAINTED, never pressed. Staying out of the display tree's hit testing is what
        // lets it be drawn over the world without shadowing the entity underneath it, and what
        // keeps the hit test answering "free space" for ground a stick happens to cover.
        this.interactive = false;
        this.interactiveChildren = false;
    }
    // Deliberately empty: see the class comment.
    bindEvents() {}
}
class $d433a8402e64fdc4$export$941e6c675ffa98cd {
    constructor(props){
        this.worldPointer = null;
        this.bind = ()=>{
            const interaction = this.interaction();
            if (!interaction) return false;
            interaction.on("pointerdown", this.onDown);
            interaction.on("pointermove", this.onSteer);
            // A finger released over the canvas, released off it, and taken away by the system (a
            // notification, an incoming call) all have to let the stick go. Missing any one of them
            // leaves the intent latched and the player walking with nothing on the screen.
            interaction.on("pointerup", this.onUp);
            interaction.on("pointerupoutside", this.onUp);
            interaction.on("pointercancel", this.onCancel);
            window.addEventListener("blur", this.onBlur);
            return true;
        };
        this.onDown = (event)=>{
            const { move: move, aim: aim, layer: layer, midline: midline } = this.props;
            const at = layer.toLocal(event.data.global);
            if (this.props.buildMode?.() && !this.props.movementZone?.(at)) {
                if (this.worldPointer === null && this.props.onWorldDown?.(event)) this.worldPointer = event.data.identifier;
                return;
            }
            if (!this.isFreeSpace(event)) return;
            const stick = this.props.buildMode?.() || at.x < midline() ? move : aim;
            if (stick.isHeld()) return;
            stick.grab(event.data.identifier, at);
        };
        this.onSteer = (event)=>{
            if (this.worldPointer === event.data.identifier) {
                this.props.onWorldMove?.(event);
                return;
            }
            const stick = this.holdingStick(event.data.identifier);
            stick?.steer(this.props.layer.toLocal(event.data.global));
        };
        this.onUp = (event)=>{
            if (this.worldPointer === event.data.identifier) {
                this.worldPointer = null;
                this.props.onWorldUp?.();
                return;
            }
            const stick = this.holdingStick(event.data.identifier);
            if (!stick) return;
            const { tapped: tapped } = stick.release();
            if (tapped && stick === this.props.aim) this.props.onAimTap();
        };
        this.onCancel = (event)=>{
            if (this.worldPointer === event.data.identifier) {
                this.worldPointer = null;
                this.props.onWorldUp?.(true);
            }
            this.holdingStick(event.data.identifier)?.release();
        };
        this.releaseAll = ()=>this.onBlur();
        this.onBlur = ()=>{
            if (this.worldPointer !== null) this.props.onWorldUp?.(true);
            this.worldPointer = null;
            this.props.move.release();
            this.props.aim.release();
        };
        this.holdingStick = (pointerId)=>{
            const { move: move, aim: aim } = this.props;
            return move.heldBy(pointerId) ? move : aim.heldBy(pointerId) ? aim : undefined;
        };
        /**
     * Did this touch land on something that wants it?
     *
     * `undefined` from the hit test means the question cannot be answered here (no interaction
     * plugin, i.e. headless tests), which is read as "do not summon" rather than as "landed on
     * nothing" -- the same way Mouse.pressTarget's callers read it.
     */ this.isFreeSpace = (event)=>{
            const hit = this.hitTest(event.data.global);
            return hit === null || hit === this.props.app.stage;
        };
        this.hitTest = (at)=>{
            const interaction = this.interaction();
            if (!interaction?.hitTest) return undefined;
            return interaction.hitTest(at) || null;
        };
        this.interaction = ()=>this.props.app.renderer?.plugins?.interaction;
        this.props = props;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");

parcelRequire("1avo5");
var $9Pi8W = parcelRequire("9Pi8W");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $P8XPi = parcelRequire("P8XPi");


/**
 * One dial for how fast the loading hand-off and the shipwreck play: the wordmark's flight, night
 * falling, the ship being drawn and running aground, and every idle loop after it.
 *
 * The choreography (logo_choreography FLIGHT_*, shipwreck_geometry SCENE) is written in its own
 * milliseconds; real time is that divided by the pace. 0.5 means everything takes twice as long as
 * written -- the speed the user picked from the prototype. The HTML side of the hand-off (the wheel
 * and caption fading, in index.html) is timed to match by hand; change both together.
 */ const $2d30638548db1697$export$5ce67906266fbd66 = 0.5;
const $2d30638548db1697$export$c7f9011f90f33196 = (realMs)=>realMs * $2d30638548db1697$export$5ce67906266fbd66;
const $2d30638548db1697$export$fd9beec5ba709d96 = (choreo)=>choreo / $2d30638548db1697$export$5ce67906266fbd66;



const $768df19440da6131$var$LOGO_SIZE = 88;
/** Wide tracking -- roughly 0.16em, applied between letters (never after the last one). */ const $768df19440da6131$var$TRACKING = 14;
/** Offset dark copy behind each glyph. The canopy underneath is busy and nearly the same value as
 *  the accent, so without this the wordmark has no edge to sit on. Matches drawPanel's shadow. */ const $768df19440da6131$var$SHADOW_OFFSET_X = 2;
const $768df19440da6131$var$SHADOW_OFFSET_Y = 5;
const $768df19440da6131$var$SHADOW_ALPHA = 0.4;
/** The halo is a scaled copy of the glyph behind it -- never a filter, see intro_theme. */ const $768df19440da6131$var$GLOW_SPREAD = 1.07;
/** The hairline under the wordmark: half-heights at its thickest point, in logical pixels. */ const $768df19440da6131$var$RULE_WIDTH_RATIO = 0.56;
const $768df19440da6131$var$RULE_CORE_HALF = 1.0;
const $768df19440da6131$var$RULE_GLOW_HALF = 3.0;
const $768df19440da6131$var$RULE_GAP = 16;
/** The loading screen's wordmark colour (index.html `.loading-brand`): where a flight starts. */ const $768df19440da6131$var$LOADING_CREAM = 0xffedc7;
class $768df19440da6131$export$a1a937f96881772 extends (0, $gwPoJ.Graphics) {
    constructor(){
        super(), this.logoText = "samsara", this.letters = [], this.letterWidths = [], this.restX = [], this.totalWidth = 0, this.lineHeight = 0, this.startedAt = 0, this.disposed = false, /**
     * Build every letter up front and cache the run's width.
     *
     * The width has to be exact from frame 1: `intro.ts` centres the wordmark with it once, and
     * the old version both hardcoded `calcWidth() => 630` against a run that rendered ~427 wide
     * AND appended letters one per timer tick, so the container grew while it was spelling itself
     * out and anything positioned from it drifted.
     */ this.build = ()=>{
            this.letters = this.logoText.split("").map(this.buildLetter);
            this.letterWidths = this.letters.map((letter)=>letter.width);
            this.lineHeight = this.letters.length > 0 ? this.letters[0].glyph.height : 0;
            this.totalWidth = this.letterWidths.reduce((sum, w)=>sum + w, 0) + $768df19440da6131$var$TRACKING * Math.max(0, this.letterWidths.length - 1);
        }, this.renderLetter = (letter)=>{
            const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontFamily((0, $f84ce7d40829905e$export$d366e2aaf798d630)).fontSize($768df19440da6131$var$LOGO_SIZE).color(0xffffff)// The default 1px black outline is for labels out in the world. Here it only muddies
            // the thin Jost 300 stems; the shadow copy below does the separation properly.
            .strokeThickness(0).render(letter);
            // Set before anything reads .width: a style change re-rasterizes, and Jost 300 and 400 have
            // different advances, so measuring at the default weight would mis-size the run.
            text.style.fontWeight = "300";
            return text;
        }, /**
     * One letter = three draws of the SAME raster. Reading `.width` forces the Text to rasterize
     * (the getter calls updateText), after which its texture can back plain Sprites for the shadow
     * and the halo -- 7 canvas textures for the wordmark instead of 21, and the two copies can
     * never drift out of register with the glyph.
     */ this.buildLetter = (letter)=>{
            const glyph = this.renderLetter(letter);
            glyph.anchor.set(0.5);
            // Reading .width is also what forces the raster -- the getter calls updateText -- and
            // everything below depends on the texture being final.
            const width = glyph.width;
            // pixi draws a line's baseline at padding + half the stroke + the font's ascent from the top
            // of the raster; anchored at 0.5, the top is half the height above the centre.
            const style = glyph.style;
            const metrics = (0, $9Pi8W.TextMetrics).measureText(letter, style);
            const baseline = -glyph.height / 2 + (style.padding || 0) + (style.strokeThickness || 0) / 2 + metrics.fontProperties.ascent;
            const shadow = new (0, $7Bs2Z.Sprite)(glyph.texture);
            shadow.anchor.set(0.5);
            shadow.tint = (0, $f84ce7d40829905e$export$56d196d2844d1ca1).shadow;
            shadow.alpha = $768df19440da6131$var$SHADOW_ALPHA;
            shadow.x = $768df19440da6131$var$SHADOW_OFFSET_X;
            shadow.y = $768df19440da6131$var$SHADOW_OFFSET_Y;
            const glow = new (0, $7Bs2Z.Sprite)(glyph.texture);
            glow.anchor.set(0.5);
            glow.tint = (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent;
            glow.scale.set($768df19440da6131$var$GLOW_SPREAD);
            glow.alpha = 0;
            const container = new (0, $8t5Gy.Container)();
            // Anchored glyphs mean the container's origin is the letter's centre, so the pop scales
            // about the letter rather than dragging it right and down.
            container.addChild(shadow, glow, glyph);
            return {
                container: container,
                glyph: glyph,
                glow: glow,
                shadow: shadow,
                width: width,
                baseline: baseline
            };
        }, this.calcWidth = ()=>this.totalWidth, /** Where the hairline under the letters sits, in the wordmark's own coordinates. */ this.ruleY = ()=>this.lineHeight + $768df19440da6131$var$RULE_GAP, /**
     * A one-off flare over the resting halo. `intro.ts` fires it as the block starts sliding up, so
     * the glow and the motion read as one event rather than two things that happen to overlap.
     */ this.pulse = ()=>{
            this.pulsedAt = Date.now();
        }, /**
     * Lay the wordmark out and start it. `callback` fires once the letters have landed -- that is
     * the screen's cue to bring in the login card (and, without a flight, to slide the block up).
     *
     * With `flight`, the letters start where the loading screen drew its own small wordmark and fly
     * up into place, so the two screens share one "samsara" instead of crossfading between two.
     */ this.update = (callback, flight)=>{
            const root = new (0, $8t5Gy.Container)();
            let x = 0;
            this.letters.forEach((letter, i)=>{
                this.restX[i] = x + this.letterWidths[i] / 2;
                letter.container.x = this.restX[i];
                letter.container.y = this.lineHeight / 2;
                root.addChild(letter.container);
                x += this.letterWidths[i] + $768df19440da6131$var$TRACKING;
            });
            this.rule = new (0, $gwPoJ.Graphics)();
            root.addChild(this.rule);
            if (flight && flight.from.length === this.letters.length) {
                this.flight = {
                    from: flight.from.map((start, i)=>{
                        const scale = start.size / $768df19440da6131$var$LOGO_SIZE;
                        return {
                            x: start.x,
                            y: start.baseline - this.letters[i].baseline * scale,
                            scale: scale
                        };
                    }),
                    onLiftOff: flight.onLiftOff,
                    liftedOff: false
                };
                // The letters start at well under half size: let the GPU sample the big raster down
                // properly instead of skipping texels (WebGL2; WebGL1 ignores this for these sizes).
                this.letters.forEach((letter)=>letter.glyph.texture.baseTexture.mipmap = (0, $P8XPi.MIPMAP_MODES).ON);
            }
            this.startedAt = Date.now();
            this.applyFrame(0);
            // The letters are driven by animation frames, but the CUE is a timer. A hidden tab gets no
            // frames, and a player who opens the game in a background tab still has to find a login
            // card waiting when they come back -- so the cue never depends on anything having rendered.
            const settleMs = this.flight ? (0, $2d30638548db1697$export$fd9beec5ba709d96)((0, $b67ebd3775cb0f71$export$7f4663febf6cd075)(this.letters.length)) : (0, $b67ebd3775cb0f71$export$bcda309bcb37ce01)(this.letters.length);
            this.settleHandle = setTimeout(()=>{
                this.liftOff();
                callback();
            }, settleMs);
            this.frameHandle = requestAnimationFrame(this.tick);
            return root;
        }, this.tick = ()=>{
            if (this.disposed) return;
            this.applyFrame(Date.now() - this.startedAt);
            this.frameHandle = requestAnimationFrame(this.tick);
        }, this.applyFrame = (elapsed)=>{
            if (this.flight) {
                this.applyFlight((0, $2d30638548db1697$export$c7f9011f90f33196)(elapsed));
                return;
            }
            const pulseElapsed = this.pulsedAt === undefined ? undefined : Date.now() - this.pulsedAt;
            this.letters.forEach((letter, i)=>{
                const state = (0, $b67ebd3775cb0f71$export$41b48cf6ccdd6df9)(i, elapsed, pulseElapsed);
                letter.container.y = this.lineHeight / 2 + state.y;
                letter.container.alpha = state.alpha;
                letter.container.scale.set(state.scale);
                letter.glyph.tint = (0, $b67ebd3775cb0f71$export$38205451e09fd057)((0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent, (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accentHi, (0, $f84ce7d40829905e$export$56d196d2844d1ca1).text, state.tintProgress);
                letter.glow.alpha = state.glowAlpha;
            });
            this.drawRule((0, $b67ebd3775cb0f71$export$d50f73c555340634)(elapsed, this.letters.length));
        }, /** One frame of the hand-off flight; `t` is in choreography ms (see intro_pace). */ this.applyFlight = (t)=>{
            const flight = this.flight;
            if (t >= (0, $b67ebd3775cb0f71$export$72c543f3583477c9)) this.liftOff();
            const pulseElapsed = this.pulsedAt === undefined ? undefined : (0, $2d30638548db1697$export$c7f9011f90f33196)(Date.now() - this.pulsedAt);
            const restY = this.lineHeight / 2;
            this.letters.forEach((letter, i)=>{
                const state = (0, $b67ebd3775cb0f71$export$52abb4dad060b151)(i, t, pulseElapsed);
                const from = flight.from[i];
                letter.container.x = from.x + (this.restX[i] - from.x) * state.travel;
                letter.container.y = from.y + (restY - from.y) * state.travel;
                letter.container.scale.set((from.scale + (1 - from.scale) * state.travel) * state.bump);
                letter.container.alpha = 1;
                letter.glyph.tint = (0, $b67ebd3775cb0f71$export$38205451e09fd057)($768df19440da6131$var$LOADING_CREAM, (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accentHi, (0, $f84ce7d40829905e$export$56d196d2844d1ca1).text, state.tintProgress);
                letter.glow.alpha = state.glowAlpha;
                letter.shadow.alpha = $768df19440da6131$var$SHADOW_ALPHA * state.shadow;
            });
            this.drawRule((0, $b67ebd3775cb0f71$export$6a93703217500dd9)(t, this.letters.length));
        }, this.liftOff = ()=>{
            const flight = this.flight;
            if (!flight || flight.liftedOff) return;
            flight.liftedOff = true;
            flight.onLiftOff?.();
        }, /**
     * The hairline wipes out from the centre.
     *
     * It is one lens-shaped path, not a bar and not a row of segments. A bar has two hard stops
     * and reads as a divider; segments with falling alpha leave a bright seam everywhere two of
     * them overlap. A lens tapers to nothing at both ends in a single fill, which is also the
     * cheaper draw -- and the same "shape as one continuous path" rule the chat bubbles follow.
     */ this.drawRule = (progress)=>{
            if (!this.rule) return;
            this.rule.clear();
            if (progress <= 0) return;
            const halfWidth = (0, $b67ebd3775cb0f71$export$b410709e4ad080bf)(progress) * this.totalWidth * $768df19440da6131$var$RULE_WIDTH_RATIO / 2;
            const alpha = (0, $b67ebd3775cb0f71$export$1157fb72e7fbceb5)(progress);
            const cx = this.totalWidth / 2;
            const y = this.lineHeight + $768df19440da6131$var$RULE_GAP;
            // A quadratic's peak sits halfway to its control point, so the control goes at twice the
            // half-height we actually want.
            const lens = (half)=>{
                this.rule.moveTo(cx - halfWidth, y);
                this.rule.quadraticCurveTo(cx, y - half * 2, cx + halfWidth, y);
                this.rule.quadraticCurveTo(cx, y + half * 2, cx - halfWidth, y);
                this.rule.closePath();
            };
            // Fatter, dimmer copy for the glow, then the hairline itself. Never a filter -- intro_theme.
            this.rule.beginFill((0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent, 0.14 * alpha);
            lens($768df19440da6131$var$RULE_GLOW_HALF);
            this.rule.endFill();
            this.rule.beginFill((0, $f84ce7d40829905e$export$56d196d2844d1ca1).accentHi, 0.9 * alpha);
            lens($768df19440da6131$var$RULE_CORE_HALF);
            this.rule.endFill();
        }, /**
     * Stop the loop and free the rasters. A pixi Text's canvas texture is not reclaimed by GC, and
     * the login screen is torn down on every sign-in, so this has to be called -- see
     * `Intro.guestLandingRemover`.
     */ this.dispose = ()=>{
            this.disposed = true;
            if (this.frameHandle !== undefined) {
                cancelAnimationFrame(this.frameHandle);
                this.frameHandle = undefined;
            }
            if (this.settleHandle !== undefined) {
                clearTimeout(this.settleHandle);
                this.settleHandle = undefined;
            }
            this.letters.forEach((letter)=>{
                // The sprites borrow the glyph's texture, so only the glyph may destroy it.
                letter.shadow.destroy({
                    texture: false,
                    baseTexture: false
                });
                letter.glow.destroy({
                    texture: false,
                    baseTexture: false
                });
                letter.glyph.destroy({
                    texture: true,
                    baseTexture: true
                });
                letter.container.destroy({
                    children: true
                });
            });
            this.letters = [];
            this.rule?.destroy();
            this.rule = undefined;
        };
        this.build();
    }
}






parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $P8XPi = parcelRequire("P8XPi");
var $6qzqq = parcelRequire("6qzqq");




/** How long hover takes to light a button up, and to let it go. */ const $314a16dbbd0a4e9b$var$HOVER_MS = 140;
/** The sheen's crossing, and how wide its band of light is. */ const $314a16dbbd0a4e9b$var$SHEEN_MS = 820;
const $314a16dbbd0a4e9b$var$SHEEN_W = 46;
class $314a16dbbd0a4e9b$export$b78a3abd8101bea6 extends (0, $gwPoJ.Graphics) {
    constructor({ label: label, width: width, variant: variant, onClick: onClick, height: height }){
        super(), this.hover = 0, this.hovered = false, this.pressed = false, this.enabled = true, this.sheen = new (0, $gwPoJ.Graphics)(), this.sheenMask = new (0, $gwPoJ.Graphics)(), this.setEnabled = (enabled)=>{
            this.enabled = enabled;
            this.interactive = enabled;
            this.cursor = enabled ? "pointer" : "default";
            this.paint();
        }, this.setLabel = (text)=>{
            this.label.text = text;
            this.paint();
        }, /**
     * One band of light across the face, once. Used when the card arrives, to say where the way in
     * is -- and never on a loop: a call to action that keeps flashing at a player who is still
     * deciding on a name is nagging, not inviting.
     */ this.shine = (delay = 0)=>{
            this.sheenTween?.cancel();
            this.sheenTween = (0, $b0310457bd8276cc$export$dc0b63720788090c)($314a16dbbd0a4e9b$var$SHEEN_MS, (t)=>{
                const g = this.sheen;
                g.clear();
                g.visible = t > 0 && t < 1;
                if (!g.visible) return;
                // A slanted band, travelling from fully off the left edge to fully off the right.
                const x = -$314a16dbbd0a4e9b$var$SHEEN_W * 2 + (this.w + $314a16dbbd0a4e9b$var$SHEEN_W * 3) * t;
                const slant = this.h * 0.6;
                const strength = Math.sin(Math.PI * t);
                g.beginFill(0xffffff, 0.16 * strength);
                g.moveTo(x, this.h);
                g.lineTo(x + slant, 0);
                g.lineTo(x + slant + $314a16dbbd0a4e9b$var$SHEEN_W, 0);
                g.lineTo(x + $314a16dbbd0a4e9b$var$SHEEN_W, this.h);
                g.closePath();
                g.endFill();
                g.beginFill(0xffffff, 0.22 * strength);
                g.moveTo(x + $314a16dbbd0a4e9b$var$SHEEN_W * 0.35, this.h);
                g.lineTo(x + slant + $314a16dbbd0a4e9b$var$SHEEN_W * 0.35, 0);
                g.lineTo(x + slant + $314a16dbbd0a4e9b$var$SHEEN_W * 0.6, 0);
                g.lineTo(x + $314a16dbbd0a4e9b$var$SHEEN_W * 0.6, this.h);
                g.closePath();
                g.endFill();
            }, {
                delay: delay,
                ease: (t)=>t
            });
        }, this.dispose = ()=>{
            this.hoverTween?.cancel();
            this.sheenTween?.cancel();
        }, this.easeHover = ()=>{
            this.hoverTween?.cancel();
            const from = this.hover;
            const to = this.hovered ? 1 : 0;
            this.hoverTween = (0, $b0310457bd8276cc$export$dc0b63720788090c)($314a16dbbd0a4e9b$var$HOVER_MS * Math.abs(to - from), (t)=>{
                this.hover = from + (to - from) * t;
                this.paint();
            });
        }, this.paint = ()=>{
            this.clear();
            const dim = !this.enabled;
            const fillAlpha = dim ? 0.4 : 1;
            const h = dim ? 0 : this.hover;
            const r = (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).buttonRadius;
            if (this.variant === "primary") {
                // The halo: two widening, fading copies of the shape, painted first so the fill sits on
                // them -- a glow without a filter.
                if (h > 0) {
                    this.beginFill((0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent, 0.1 * h);
                    this.drawRoundedRect(-7, -6, this.w + 14, this.h + 12, r + 7);
                    this.endFill();
                    this.beginFill((0, $f84ce7d40829905e$export$56d196d2844d1ca1).accentHi, 0.14 * h);
                    this.drawRoundedRect(-3, -2, this.w + 6, this.h + 4, r + 3);
                    this.endFill();
                }
                const fill = this.pressed ? (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accentDim : (0, $b67ebd3775cb0f71$export$671c724dbdd0c3a9)((0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent, (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accentHi, h * 0.75);
                this.beginFill(fill, fillAlpha);
                this.drawRoundedRect(0, 0, this.w, this.h, r);
                this.endFill();
                if (!this.pressed) {
                    // Light along the top edge and a darker lip along the bottom: enough bevel to read
                    // as a thing to press, not a coloured rectangle -- and no hard-edged gloss band.
                    this.beginFill(0xffffff, 0.32 * fillAlpha);
                    this.drawRect(r, 1, this.w - r * 2, 1);
                    this.endFill();
                    this.beginFill(0xffffff, 0.05 * fillAlpha);
                    this.drawRoundedRect(1, 1, this.w - 2, this.h * 0.5, r - 1);
                    this.endFill();
                    this.beginFill(0x000000, 0.16 * fillAlpha);
                    this.drawRect(r, this.h - 2, this.w - r * 2, 2);
                    this.endFill();
                }
            } else {
                this.lineStyle({
                    width: 1,
                    color: (0, $b67ebd3775cb0f71$export$671c724dbdd0c3a9)((0, $f84ce7d40829905e$export$56d196d2844d1ca1).panelRim, (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent, h),
                    alpha: dim ? 0.3 : 0.55 + 0.35 * h
                });
                this.beginFill((0, $f84ce7d40829905e$export$56d196d2844d1ca1).highlight, this.pressed ? 0.1 : 0.035 + 0.05 * h);
                this.drawRoundedRect(0, 0, this.w, this.h, r);
                this.endFill();
                this.lineStyle(0);
            }
            this.label.alpha = dim ? 0.55 : 1;
            this.label.x = Math.round((this.w - this.label.width) / 2);
            this.label.y = Math.round((this.h - this.label.height) / 2) + (this.pressed ? 1 : 0);
        };
        this.variant = variant;
        this.w = width;
        this.h = height ?? (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).buttonHeight;
        this.label = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontFamily((0, $f84ce7d40829905e$export$d366e2aaf798d630)).role("body").bold(false).color(variant === "primary" ? (0, $f84ce7d40829905e$export$56d196d2844d1ca1).onAccent : (0, $f84ce7d40829905e$export$56d196d2844d1ca1).text).align("center").render(label);
        if (variant === "primary") this.label.style.fontWeight = "600";
        else this.label.style.fontWeight = "500";
        this.addChild(this.label);
        // The sheen is clipped to the button's own shape and added onto it, so it brightens the fill
        // as it crosses rather than laying a grey bar over it.
        this.sheenMask.beginFill(0xffffff, 1);
        this.sheenMask.drawRoundedRect(0, 0, this.w, this.h, (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).buttonRadius);
        this.sheenMask.endFill();
        this.sheen.mask = this.sheenMask;
        this.sheen.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.sheen.visible = false;
        this.addChild(this.sheenMask);
        this.addChild(this.sheen);
        this.interactive = true;
        this.cursor = "pointer";
        // The halo is painted past the edges; the target stays the button.
        this.hitArea = new (0, $6qzqq.Rectangle)(0, 0, this.w, this.h);
        this.interactiveChildren = false;
        this.on("pointerover", ()=>{
            this.hovered = true;
            this.easeHover();
        });
        this.on("pointerout", ()=>{
            this.hovered = false;
            this.pressed = false;
            this.easeHover();
        });
        this.on("pointerdown", ()=>{
            this.pressed = true;
            this.paint();
        });
        this.on("pointerup", ()=>{
            this.pressed = false;
            this.paint();
        });
        const fire = ()=>{
            if (this.enabled) onClick();
        };
        this.on("click", fire);
        this.on("tap", fire);
        this.paint();
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");

var $8JEKL = parcelRequire("8JEKL");


const $774b7b76c6b71a95$export$2566754fe8f3b125 = 24 + (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).fieldHeight;
class $774b7b76c6b71a95$export$58231d3fc204542d extends (0, $8t5Gy.Container) {
    constructor({ label: label, width: width = (0, $f84ce7d40829905e$export$35aa3e8070dd3c30), placeholder: placeholder, autocomplete: autocomplete, password: password, onInput: onInput, onEnter: onEnter, onEscape: onEscape }){
        super(), this.tone = "default", /**
     * Deferred by a tick on purpose: a focus() issued while the browser is still dispatching the
     * pointerdown/click that triggered it gets handed straight back to the canvas, so switching to
     * the sign-in fields by clicking "Log in" would leave you typing at the game instead.
     */ this.focus = ()=>{
            setTimeout(()=>this.input.focus(), 0);
        }, this.setTone = (tone)=>{
            if (this.tone === tone) return;
            this.tone = tone;
            // Force the library to re-run our box generator: it caches one box per state and only
            // rebuilds when the input's measured size changes, which a tone change does not.
            this.input._buildBoxCache();
            this.input._setState(this.input.state);
        }, /**
     * Follow the field on and off screen.
     *
     * Hiding has to be done here and now. pixi-text-input syncs the real `<input>`'s css `display`
     * from inside `render()`, so the frame an ancestor's `visible` goes false is the last chance the
     * library gets -- pixi stops drawing the subtree, and the input (placeholder and all) stays
     * painted over whatever comes next. Cf. `gui/name_prompt.ts`, which hit this first.
     *
     * Showing is handed back to the library on purpose: it places the node and sets `display` in
     * the same pass, whereas an input it has not placed yet still sits at the page's top-left, so
     * revealing one by hand flashes the field in the corner. All it needs is a reason to re-sync --
     * it skips the work when nothing it watches has changed, and our hide was invisible to it.
     */ this.setDomVisible = (visible)=>{
            if (visible) {
                this.input._previous.world_visible = false;
                return;
            }
            // Nothing should be typing into a field that is off screen, and on a phone a focused input
            // keeps the soft keyboard up over the game.
            this.input.blur();
            this.input._setDOMInputVisible(false);
        }, /**
     * Detach the DOM input. pixi-text-input appends it to document.body on 'added' and removes it on
     * 'removed', so the node outlives the canvas unless the field is taken off the stage.
     */ this.dispose = ()=>{
            const dom = this.input._dom_input;
            try {
                // The library's 'removed' handler unconditionally does document.body.removeChild, which
                // throws for a field that was disposed before it ever rendered a frame.
                this.input.parent?.removeChild(this.input);
            } catch (e) {
            /* ignore -- the node is detached below either way */ }
            if (dom && dom.parentNode) dom.parentNode.removeChild(dom);
            this.input._dom_added = false;
        };
        this.labelText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontFamily((0, $f84ce7d40829905e$export$d366e2aaf798d630)).role("caption").bold(false).color((0, $f84ce7d40829905e$export$56d196d2844d1ca1).muted).render(label.toUpperCase());
        this.labelText.style.fontWeight = "500";
        this.labelText.style.letterSpacing = 1.1;
        this.addChild(this.labelText);
        this.input = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
            input: {
                fontFamily: (0, $f84ce7d40829905e$export$d366e2aaf798d630),
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: `${(0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).fieldHeight}px`,
                height: `${(0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).fieldHeight}px`,
                width: `${width}px`,
                boxSizing: "border-box",
                padding: "0 14px",
                color: "#fbefdc",
                caretColor: "#ffd166",
                multiline: false
            },
            box: (w, h, state)=>{
                const g = new (0, $gwPoJ.Graphics)();
                (0, $f84ce7d40829905e$export$a00f6eb43ef2da81)(g, w, h, this.tone === "error" ? "error" : state === "FOCUSED" ? "focused" : "default");
                return g;
            }
        });
        // Keep the real <input> on screen instead of the library's pixi Text stand-in -- see the
        // class comment.
        //
        // The constructor always builds the stand-in before we can opt out, and the library's
        // _destroySurrogate() drops the Text and its hitbox but NOT _surrogate_mask -- a Graphics
        // filled with beginFill(0), i.e. opaque black, covering the field inset by its padding.
        // Left behind it paints a black slab over our frame. Take it out here.
        this.input.substituteText = false;
        const orphanedMask = this.input._surrogate_mask;
        if (orphanedMask) {
            this.input.removeChild(orphanedMask);
            orphanedMask.destroy();
            this.input._surrogate_mask = null;
        }
        this.input.y = 24;
        this.addChild(this.input);
        const dom = this.input._dom_input;
        dom.className = "samsara-input";
        dom.setAttribute("autocomplete", autocomplete);
        dom.setAttribute("name", autocomplete === "current-password" ? "password" : "username");
        dom.setAttribute("aria-label", label);
        if (password) dom.type = "password";
        else {
            dom.setAttribute("autocapitalize", "off");
            dom.setAttribute("autocorrect", "off");
            dom.setAttribute("spellcheck", "false");
            this.input.maxLength = 24;
        }
        if (placeholder) this.input.placeholder = placeholder;
        if (onInput) this.input.on("input", onInput);
        this.input.on("keyup", (keycode)=>{
            if (keycode === 13 && onEnter) onEnter();
            if (keycode === 27 && onEscape) onEscape();
        });
        // Typing in a field that is showing an error clears the error rim -- the message itself is
        // cleared by the card, which owns it.
        this.input.on("input", ()=>{
            if (this.tone === "error") this.setTone("default");
        });
    }
    get value() {
        return (this.input.text || "").trim();
    }
    set value(next) {
        this.input.text = next;
    }
}




/** The card's arrival: how far it rises, how long it takes, and the beat between its rows. */ const $19eb09ada16d9b5b$var$ENTER_RISE = 16;
const $19eb09ada16d9b5b$var$ENTER_MS = 560;
const $19eb09ada16d9b5b$var$ROW_DELAY = 140;
const $19eb09ada16d9b5b$var$ROW_STAGGER = 55;
const $19eb09ada16d9b5b$var$ROW_MS = 420;
const $19eb09ada16d9b5b$var$ROW_RISE = 8;
/** When the real `<input>`s join the arrival: once the name row is most of the way in. */ const $19eb09ada16d9b5b$var$FIELDS_AT = 320;
class $19eb09ada16d9b5b$export$25233b7fe55e5696 extends (0, $8t5Gy.Container) {
    constructor(props){
        super(), this.panel = new (0, $gwPoJ.Graphics)(), this.content = new (0, $8t5Gy.Container)(), this.mode = "guest", this.submitted = false, /** Whether the card is on screen -- the fields' DOM nodes have to be told (see setDomVisible). */ this.domVisible = false, /** Bumped by every setDomVisible, so a delayed reveal can tell it has been overtaken. */ this.domToken = 0, this.buttons = [], this.motion = [], this.focus = ()=>{
            this.nameField?.focus();
        }, /**
     * Follow the card on and off screen.
     *
     * Hiding the card by flipping `visible` on it or any ancestor is not enough on its own: the
     * fields are real DOM `<input>`s and the library only moves them from inside a render pass, so
     * the one it never gets to run leaves them on the page -- the "Pick a name, or play as a guest"
     * placeholder sitting over the next screen until the card is finally disposed. Every show and
     * hide of the card has to come through here.
     */ this.setDomVisible = (visible)=>{
            this.domToken++;
            this.domVisible = visible;
            this.nameField?.setDomVisible(visible);
            this.passwordField?.setDomVisible(visible);
        }, /**
     * Bring the card on: the slab rises into place and its rows follow it up one after another, then
     * a single sheen crosses the Play button. Played once, when the wordmark hands over to the form --
     * every later re-layout (switching modes, an error row) only crossfades the contents.
     *
     * The fields are real DOM `<input>`s, which cannot fade with the canvas: shown at once, the
     * placeholder would hang in mid-air before the card under it had arrived. So they are held back
     * until the name row is most of the way in, and focused once they are actually on the page --
     * a focus() on an input that is still `display: none` does nothing at all.
     */ this.playEntrance = ()=>{
            this.stopMotion();
            if (this.domVisible) {
                this.setDomVisible(false);
                const token = this.domToken;
                setTimeout(()=>{
                    if (token !== this.domToken) return;
                    this.setDomVisible(true);
                    // The library shows the input from its next render; focus after that frame.
                    if (typeof requestAnimationFrame === "function") requestAnimationFrame(()=>token + 1 === this.domToken && this.focus());
                    else this.focus();
                }, $19eb09ada16d9b5b$var$FIELDS_AT);
            }
            this.motion.push((0, $b0310457bd8276cc$export$dc0b63720788090c)($19eb09ada16d9b5b$var$ENTER_MS, (t)=>{
                this.alpha = Math.min(1, t * 1.6);
                this.pivot.y = -$19eb09ada16d9b5b$var$ENTER_RISE * (1 - t);
                this.scale.set(0.985 + 0.015 * t);
            }));
            this.content.children.forEach((row, i)=>{
                this.motion.push((0, $b0310457bd8276cc$export$dc0b63720788090c)($19eb09ada16d9b5b$var$ROW_MS, (t)=>{
                    row.alpha = t;
                    row.pivot.y = -$19eb09ada16d9b5b$var$ROW_RISE * (1 - t);
                }, {
                    delay: $19eb09ada16d9b5b$var$ROW_DELAY + i * $19eb09ada16d9b5b$var$ROW_STAGGER,
                    ease: (t)=>(0, $b67ebd3775cb0f71$export$3daa4a78f444687d)(t, 1.2)
                }));
            });
            this.primary?.shine($19eb09ada16d9b5b$var$ROW_DELAY + this.content.children.length * $19eb09ada16d9b5b$var$ROW_STAGGER + 260);
        }, this.setMode = (mode)=>{
            if (this.mode === mode) return;
            this.mode = mode;
            this.layout();
            this.crossfade();
            this.props.onModeChange?.(mode);
            if (mode === "account" && this.nameField?.value) this.passwordField?.focus();
            else this.focus();
        }, /**
     * Show a failure against the credentials that are still in the fields. The username is kept --
     * losing it on every wrong password is most of what made the old failure path miserable.
     */ this.showError = (message)=>{
            this.submitted = false;
            this.mode = "account";
            this.layout({
                error: message
            });
            this.passwordField?.setTone("error");
            this.passwordField?.focus();
        }, this.dispose = ()=>{
            this.stopMotion();
            this.buttons.forEach((button)=>button.dispose());
            this.buttons = [];
            this.nameField?.dispose();
            this.passwordField?.dispose();
            this.nameField = undefined;
            this.passwordField = undefined;
            this.content.removeChildren();
            this.removeChildren();
            this.parent?.removeChild(this);
        }, this.setWidth = (width)=>{
            if ((this.props.width ?? (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).cardWidth) === width) return;
            const focused = document.activeElement;
            const passwordFocused = focused === this.passwordField?.input._dom_input;
            const nameFocused = focused === this.nameField?.input._dom_input;
            this.props.width = width;
            this.layout({
                error: this.errorText?.text
            });
            if (passwordFocused) this.passwordField?.focus();
            else if (nameFocused) this.nameField?.focus();
        }, this.layout = (opts = {})=>{
            const keepName = this.nameField?.value;
            const keepPassword = this.passwordField?.value;
            this.nameField?.dispose();
            this.passwordField?.dispose();
            this.nameField = undefined;
            this.passwordField = undefined;
            this.buttons.forEach((button)=>button.dispose());
            this.buttons = [];
            this.primary = undefined;
            this.content.removeChildren();
            this.errorText = undefined;
            const cardWidth = this.props.width ?? (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).cardWidth;
            const contentWidth = cardWidth - (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).cardPadding * 2;
            const pad = (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).cardPadding;
            let y = pad;
            const place = (child, top)=>{
                child.x = pad;
                child.y = top;
                this.content.addChild(child);
            };
            if (this.mode === "account") {
                const heading = this.text("Welcome back", "title", (0, $f84ce7d40829905e$export$56d196d2844d1ca1).text, "500");
                place(heading, y);
                y += 34;
            }
            this.nameField = new (0, $774b7b76c6b71a95$export$58231d3fc204542d)({
                width: contentWidth,
                label: "Player name",
                placeholder: this.mode === "guest" ? "Pick a name, or play as a guest" : undefined,
                autocomplete: "username",
                onEnter: ()=>this.mode === "guest" ? this.play() : this.passwordField?.focus(),
                onEscape: ()=>this.mode === "account" && this.setMode("guest")
            });
            if (keepName) this.nameField.value = keepName;
            place(this.nameField, y);
            y += 24 + (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).fieldHeight;
            if (this.mode === "account") {
                y += 16;
                this.passwordField = new (0, $774b7b76c6b71a95$export$58231d3fc204542d)({
                    width: contentWidth,
                    label: "Password",
                    autocomplete: "current-password",
                    password: true,
                    onInput: this.dimError,
                    onEnter: this.submit,
                    onEscape: ()=>this.setMode("guest")
                });
                if (keepPassword) this.passwordField.value = keepPassword;
                place(this.passwordField, y);
                y += 24 + (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).fieldHeight;
            }
            if (opts.error) {
                y += 10;
                this.errorText = this.text(opts.error, "label", (0, $f84ce7d40829905e$export$56d196d2844d1ca1).danger, "normal", contentWidth);
                place(this.errorText, y);
                y += this.errorText.height;
            }
            y += (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).gutter;
            if (this.mode === "guest") {
                const half = (contentWidth - (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).gutter) / 2;
                const play = new (0, $314a16dbbd0a4e9b$export$b78a3abd8101bea6)({
                    label: "Play",
                    width: half,
                    variant: "primary",
                    onClick: this.play
                });
                place(play, y);
                this.primary = play;
                const guest = new (0, $314a16dbbd0a4e9b$export$b78a3abd8101bea6)({
                    label: "Play as guest",
                    width: half,
                    variant: "ghost",
                    onClick: ()=>this.props.onPlay(this.props.guestName)
                });
                guest.x = pad + half + (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).gutter;
                guest.y = y;
                this.content.addChild(guest);
                this.buttons.push(play, guest);
                y += (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).buttonHeight + 24;
                const rule = new (0, $gwPoJ.Graphics)();
                rule.beginFill((0, $f84ce7d40829905e$export$56d196d2844d1ca1).panelRim, 0.28);
                rule.drawRect(0, 0, contentWidth, 1);
                rule.endFill();
                place(rule, y);
                y += 15;
                const footer = new (0, $8t5Gy.Container)();
                const prompt = this.text("Already have an account?", "label", (0, $f84ce7d40829905e$export$56d196d2844d1ca1).muted);
                const link = this.text("Log in", "label", (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent, "500");
                link.x = prompt.width + 6;
                link.interactive = true;
                link.cursor = "pointer";
                const toAccount = ()=>this.setMode("account");
                link.on("click", toAccount);
                link.on("tap", toAccount);
                link.on("pointerover", ()=>link.tint = (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accentHi);
                link.on("pointerout", ()=>link.tint = (0, $f84ce7d40829905e$export$56d196d2844d1ca1).accent);
                footer.addChild(prompt);
                footer.addChild(link);
                footer.x = pad + Math.round((contentWidth - (prompt.width + 6 + link.width)) / 2);
                footer.y = y;
                this.content.addChild(footer);
                y += footer.height;
            } else {
                const login = new (0, $314a16dbbd0a4e9b$export$b78a3abd8101bea6)({
                    label: "Log in",
                    width: contentWidth - 86,
                    variant: "primary",
                    onClick: this.submit
                });
                place(login, y);
                this.primary = login;
                this.buttons.push(login);
                const back = this.text("Back", "label", (0, $f84ce7d40829905e$export$56d196d2844d1ca1).muted);
                back.interactive = true;
                back.cursor = "pointer";
                const toGuest = ()=>this.setMode("guest");
                back.on("click", toGuest);
                back.on("tap", toGuest);
                back.on("pointerover", ()=>back.tint = (0, $f84ce7d40829905e$export$56d196d2844d1ca1).text);
                back.on("pointerout", ()=>back.tint = (0, $f84ce7d40829905e$export$56d196d2844d1ca1).muted);
                back.x = pad + contentWidth - 86 + Math.round((86 - back.width) / 2);
                back.y = y + Math.round(((0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).buttonHeight - back.height) / 2);
                this.content.addChild(back);
                y += (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).buttonHeight;
            }
            // A re-layout builds brand new fields. Keeping them hidden is ours to do -- showing them
            // is not: an input the library has not placed yet still sits at the page's top-left, so
            // revealing it by hand flashes the field in the corner. A visible card gets its fields from
            // the library's next render, which places and shows them in the same pass.
            if (!this.domVisible) this.setDomVisible(false);
            const height = y + pad;
            (0, $f84ce7d40829905e$export$3d8dfa7926012c64)(this.panel, cardWidth, height);
            this.y = Math.round(this.props.centerY - height / 2);
        }, /** A re-layout swaps the card's contents in place; ease the new ones in rather than cutting. */ this.crossfade = ()=>{
            this.stopMotion();
            this.alpha = 1;
            this.pivot.y = 0;
            this.scale.set(1);
            this.motion.push((0, $b0310457bd8276cc$export$dc0b63720788090c)(220, (t)=>{
                this.content.alpha = t;
                this.content.pivot.y = -4 * (1 - t);
            }));
        }, this.stopMotion = ()=>{
            this.motion.forEach((motion)=>motion.cancel());
            this.motion = [];
        }, /**
     * Fade the message once the player starts fixing the input, without re-laying out the card --
     * dropping the row would resize the panel and steal focus mid-keystroke.
     */ this.dimError = ()=>{
            if (this.errorText) this.errorText.visible = false;
        }, this.text = (value, role, color, weight = "normal", wrap)=>{
            const builder = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontFamily((0, $f84ce7d40829905e$export$d366e2aaf798d630)).role(role).bold(false).color(color);
            const text = (wrap ? builder.wordWrap(wrap) : builder).render(value);
            text.style.fontWeight = weight;
            return text;
        }, this.play = ()=>{
            if (this.submitted) return;
            const name = this.nameField?.value || this.props.guestName;
            this.submitted = true;
            this.props.onPlay(name);
        }, this.submit = ()=>{
            if (this.submitted) return;
            const username = this.nameField?.value;
            const password = this.passwordField?.value;
            if (!username) {
                this.layout({
                    error: "Enter your player name."
                });
                this.nameField?.setTone("error");
                this.nameField?.focus();
                return;
            }
            if (!password) {
                this.layout({
                    error: "Enter your password."
                });
                this.passwordField?.setTone("error");
                this.passwordField?.focus();
                return;
            }
            this.submitted = true;
            this.props.onLogin(username, password);
        };
        this.props = props;
        this.addChild(this.panel);
        this.addChild(this.content);
        this.layout();
    }
    get currentMode() {
        return this.mode;
    }
}




parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $P8XPi = parcelRequire("P8XPi");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $8t5Gy = parcelRequire("8t5Gy");




parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");

const $b8d1d91ff2e7f409$export$347d421daadd77cf = [
    [
        0,
        "#2b1e13"
    ],
    [
        0.38,
        "#14110e"
    ],
    [
        0.78,
        "#07090d"
    ]
];
const $b8d1d91ff2e7f409$var$loadingElement = ()=>typeof document === "undefined" ? null : document.getElementById("loading");
const $b8d1d91ff2e7f409$var$brandElement = ()=>$b8d1d91ff2e7f409$var$loadingElement()?.querySelector(".loading-brand") ?? null;
/** Is the loading screen up, with its wordmark showing, ready to hand over? */ const $b8d1d91ff2e7f409$var$loadingIsUp = ()=>{
    const loading = $b8d1d91ff2e7f409$var$loadingElement();
    return !!loading && !loading.hidden && !loading.classList.contains("is-complete");
};
/** Maps a CSS pixel on the page into `stage`'s coordinates (stage.y is stretched by SCALER). */ const $b8d1d91ff2e7f409$var$pageToStage = (stage)=>{
    const app = (0, $065c5647ab3ff4dc$export$90e89a86e46f5ae3)();
    const view = app?.renderer?.view;
    if (!app || !view) return undefined;
    const rect = view.getBoundingClientRect();
    if (!rect.width || !rect.height) return undefined;
    const screen = app.renderer.screen;
    return (x, y)=>stage.toLocal(new (0, $6qzqq.Point)((x - rect.left) * screen.width / rect.width, (y - rect.top) * screen.height / rect.height));
};
const $b8d1d91ff2e7f409$export$390ded33ed101d15 = (stage)=>{
    if (!$b8d1d91ff2e7f409$var$loadingIsUp()) return undefined;
    const brand = $b8d1d91ff2e7f409$var$brandElement();
    const text = brand?.firstChild;
    if (!brand || !text || text.nodeType !== Node.TEXT_NODE || !text.textContent) return undefined;
    const toStage = $b8d1d91ff2e7f409$var$pageToStage(stage);
    if (!toStage) return undefined;
    try {
        const style = getComputedStyle(brand);
        const fontSize = parseFloat(style.fontSize);
        const ctx = document.createElement("canvas").getContext("2d");
        if (!ctx || !fontSize) return undefined;
        ctx.font = `${style.fontWeight} ${fontSize}px ${style.fontFamily}`;
        // A Range per character gives the left edge of each advance box. The box may or may not
        // include the letter-spacing after it, so the centre comes from the advance alone.
        const range = document.createRange();
        const content = text.textContent;
        const centres = [];
        for(let i = 0; i < content.length; i++){
            range.setStart(text, i);
            range.setEnd(text, i + 1);
            const rect = range.getBoundingClientRect();
            if (!rect.width) return undefined;
            centres.push(rect.left + ctx.measureText(content[i]).width / 2);
        }
        // The baseline, exactly: an empty inline-block sits with its bottom edge on it. Added and
        // removed in the same task, so the page never paints it.
        const probe = document.createElement("span");
        probe.style.cssText = "display:inline-block;width:0;height:0;vertical-align:baseline";
        brand.appendChild(probe);
        const baseline = probe.getBoundingClientRect().bottom;
        brand.removeChild(probe);
        if (!baseline) return undefined;
        const unit = toStage(1, 0).x - toStage(0, 0).x;
        return centres.map((cx)=>{
            const p = toStage(cx, baseline);
            return {
                x: p.x,
                baseline: p.y,
                size: fontSize * unit
            };
        });
    } catch (e) {
        // getBoundingClientRect on a Range is not implemented everywhere (jsdom). No hand-off then:
        // the login screen falls back to its own entrance.
        return undefined;
    }
};
const $b8d1d91ff2e7f409$export$bb7bda02140dee45 = (stage)=>{
    const loading = $b8d1d91ff2e7f409$var$loadingElement();
    const toStage = $b8d1d91ff2e7f409$var$pageToStage(stage);
    if (!loading || !toStage) return undefined;
    const r = loading.getBoundingClientRect();
    if (!r.width || !r.height) return undefined;
    // farthest-corner keeps closest-side's aspect ratio (w/2 : h/2) and passes through the corner,
    // which makes the radii w/sqrt(2) and h/sqrt(2).
    const cx = r.left + r.width / 2;
    const cy = r.top + r.height / 2;
    const centre = toStage(cx, cy);
    return {
        cx: centre.x,
        cy: centre.y,
        rx: toStage(cx + r.width / Math.SQRT2, cy).x - centre.x,
        ry: toStage(cx, cy + r.height / Math.SQRT2).y - centre.y
    };
};
const $b8d1d91ff2e7f409$export$90ac2b177e966984 = ()=>{
    const handOff = typeof window !== "undefined" ? window.handOffLoading : undefined;
    return typeof handOff === "function" ? !!handOff() : false;
};
const $b8d1d91ff2e7f409$export$d9eb662df70a11ab = ()=>{
    const brand = $b8d1d91ff2e7f409$var$brandElement();
    if (brand) brand.style.visibility = "hidden";
};
const $b8d1d91ff2e7f409$export$4dabcd056c1d895c = ()=>{
    const stop = typeof window !== "undefined" ? window.stopLoading : undefined;
    if (typeof stop === "function") stop();
};
const $b8d1d91ff2e7f409$export$ff7706047246b98b = ()=>typeof window !== "undefined" && !!window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;


/**
 * The login screen's line-art shipwreck, as pure data and pure maths.
 *
 * Everything here is a function of choreography time (see `intro_pace.ts`), with no canvas and no
 * pixi, so the shape of the scene can be asserted in a unit test: the ship arrives where it should,
 * the bow rides up when it strikes, the sail tears and stays torn.
 *
 * Coordinates are the GUI's logical screen (800 x 460, see intro_theme). The scene is AUTHORED with
 * the ship on the left, sailing right; `SHIP_ON_RIGHT` mirrors the whole drawing about the screen's
 * centre line at paint time, so the geometry never has to be written twice.
 */ const $457b7d299870118f$export$43d3c9dbcf230964 = true;
const $457b7d299870118f$export$875e106f2e8aca73 = 400;
const $457b7d299870118f$export$74231045b68dcd81 = (x)=>$457b7d299870118f$export$43d3c9dbcf230964 ? 2 * $457b7d299870118f$export$875e106f2e8aca73 - x : x;
const $457b7d299870118f$export$c579116fa63b8535 = {
    backdrop: [
        250,
        1350
    ],
    horizon: [
        700,
        1900
    ],
    water: [
        900,
        2700
    ],
    stars: 1300,
    moon: [
        1250,
        2250
    ],
    cloud: [
        1750,
        2950
    ],
    land: [
        1600,
        3300
    ],
    rocks: [
        2100,
        3000
    ],
    shipInk: [
        2000,
        3600
    ],
    sail: [
        2600,
        5400
    ],
    lantern: 3600,
    impact: 5400
};
const $457b7d299870118f$export$f64453ff4afd9ce8 = 3700;
const $457b7d299870118f$export$896f328fde139f45 = $457b7d299870118f$export$c579116fa63b8535.impact + 1400;
const $457b7d299870118f$export$5c5ee632c52bc4a2 = (v)=>v < 0 ? 0 : v > 1 ? 1 : v;
const $457b7d299870118f$export$3a89f8d6f6bf6c9f = (a, b, t)=>a + (b - a) * t;
const $457b7d299870118f$export$9662278bae91bccc = (t, a, b)=>$457b7d299870118f$export$5c5ee632c52bc4a2((t - a) / (b - a));
const $457b7d299870118f$export$3ab94c50cd824f15 = (v)=>{
    const t = $457b7d299870118f$export$5c5ee632c52bc4a2(v);
    return t * t * (3 - 2 * t);
};
const $457b7d299870118f$export$1157fb72e7fbceb5 = (v)=>1 - Math.pow(1 - $457b7d299870118f$export$5c5ee632c52bc4a2(v), 3);
const $457b7d299870118f$export$24656b269d8df7d6 = (v)=>{
    const t = $457b7d299870118f$export$5c5ee632c52bc4a2(v);
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
};
const $457b7d299870118f$export$dbce5739ea4fa8d3 = (v)=>-(Math.cos(Math.PI * $457b7d299870118f$export$5c5ee632c52bc4a2(v)) - 1) / 2;
const $457b7d299870118f$export$cd94982b18c6332c = (seed)=>()=>{
        seed |= 0;
        seed = seed + 0x6d2b79f5 | 0;
        let r = Math.imul(seed ^ seed >>> 15, 1 | seed);
        r = r + Math.imul(r ^ r >>> 7, 61 | r) ^ r;
        return ((r ^ r >>> 14) >>> 0) / 4294967296;
    };
const $457b7d299870118f$export$40fa977508bcf282 = (d, n = 10)=>{
    const tokens = d.match(/[MLQCZ]|-?\d*\.?\d+/g) || [];
    const pts = [];
    let i = 0;
    let cmd = "";
    let cx = 0;
    let cy = 0;
    let closed = false;
    const num = ()=>parseFloat(tokens[i++]);
    while(i < tokens.length){
        if (/[MLQCZ]/.test(tokens[i])) cmd = tokens[i++];
        if (cmd === "M" || cmd === "L") {
            cx = num();
            cy = num();
            pts.push([
                cx,
                cy
            ]);
        } else if (cmd === "Q") {
            const x1 = num(), y1 = num(), x = num(), y = num();
            for(let s = 1; s <= n; s++){
                const u = s / n, v = 1 - u;
                pts.push([
                    v * v * cx + 2 * v * u * x1 + u * u * x,
                    v * v * cy + 2 * v * u * y1 + u * u * y
                ]);
            }
            cx = x;
            cy = y;
        } else if (cmd === "C") {
            const x1 = num(), y1 = num(), x2 = num(), y2 = num(), x = num(), y = num();
            for(let s = 1; s <= n; s++){
                const u = s / n, v = 1 - u;
                pts.push([
                    v * v * v * cx + 3 * v * v * u * x1 + 3 * v * u * u * x2 + u * u * u * x,
                    v * v * v * cy + 3 * v * v * u * y1 + 3 * v * u * u * y2 + u * u * u * y
                ]);
            }
            cx = x;
            cy = y;
        } else if (cmd === "Z") closed = true;
        else break;
    }
    return {
        pts: pts,
        closed: closed
    };
};
const $457b7d299870118f$export$ac13333ee7ee8a51 = {
    x: 36,
    y: 350,
    s: 0.5
};
const $457b7d299870118f$export$25173d0d38b8d129 = {
    x: 96,
    y: 390,
    s: 0.88
};
/** The hull pivots about its stern foot as the bow rides up the rock. */ const $457b7d299870118f$var$PIVOT = [
    -50,
    14
];
const $457b7d299870118f$export$11038cc09fdccb91 = [
    $457b7d299870118f$export$25173d0d38b8d129.x + 72 * $457b7d299870118f$export$25173d0d38b8d129.s,
    $457b7d299870118f$export$25173d0d38b8d129.y
];
const $457b7d299870118f$export$852e4b6956254f0c = (t)=>{
    const u = $457b7d299870118f$export$9662278bae91bccc(t, $457b7d299870118f$export$c579116fa63b8535.sail[0], $457b7d299870118f$export$c579116fa63b8535.sail[1]);
    // Slightly accelerating: perspective makes a ship coming at you seem to gather speed.
    const p = Math.pow(u, 1.35);
    const s = $457b7d299870118f$export$3a89f8d6f6bf6c9f($457b7d299870118f$export$ac13333ee7ee8a51.s, $457b7d299870118f$export$25173d0d38b8d129.s, p);
    let x = $457b7d299870118f$export$3a89f8d6f6bf6c9f($457b7d299870118f$export$ac13333ee7ee8a51.x, $457b7d299870118f$export$25173d0d38b8d129.x, p);
    let y = $457b7d299870118f$export$3a89f8d6f6bf6c9f($457b7d299870118f$export$ac13333ee7ee8a51.y, $457b7d299870118f$export$25173d0d38b8d129.y, p);
    const wl = y;
    const dt = t - $457b7d299870118f$export$c579116fa63b8535.impact;
    const afloat = dt < 0 ? 1 : 1 - $457b7d299870118f$export$3ab94c50cd824f15(dt / 300);
    let rot = 0.016 * Math.sin(t / 820) * afloat;
    y += 1.1 * s * Math.sin(t / 610) * afloat;
    let bend = 0.012 * Math.sin(t / 820 + 0.6) * afloat;
    let yard = 0;
    let tear = 0;
    let swing = 0.08 * Math.sin(t / 820 + 0.5) * afloat;
    if (dt >= 0) {
        // Bow up: a negative angle lifts the +x end. A quick rise with one small overshoot.
        rot += -0.1 * (1 - Math.exp(-dt / 120) * Math.cos(dt / 95)) + 0.006 * Math.sin(dt / 1500) * $457b7d299870118f$export$3ab94c50cd824f15((dt - 600) / 900);
        x += s * 4 * (1 - Math.exp(-dt / 70));
        y -= s * 3 * (1 - Math.exp(-dt / 100));
        // The masts keep going when the hull stops: tops lurch forward, then ring down.
        bend += 0.075 * Math.exp(-dt / 420) * Math.sin(dt / 85) + 0.008 * Math.sin(dt / 1700) * $457b7d299870118f$export$3ab94c50cd824f15((dt - 800) / 1000);
        yard = 0.28 * (1 - Math.exp(-dt / 200) * Math.cos(dt / 120)) + 0.03 * Math.sin(dt / 900) * $457b7d299870118f$export$3ab94c50cd824f15((dt - 700) / 800);
        tear = $457b7d299870118f$export$3ab94c50cd824f15((dt - 60) / 450);
        swing += 0.55 * Math.exp(-dt / 1600) * Math.sin(dt / 230) + 0.05 * Math.sin(t / 1300);
    }
    const ink = $457b7d299870118f$export$9662278bae91bccc(t, $457b7d299870118f$export$c579116fa63b8535.shipInk[0], $457b7d299870118f$export$c579116fa63b8535.shipInk[1]);
    const near = $457b7d299870118f$export$3ab94c50cd824f15((s - $457b7d299870118f$export$ac13333ee7ee8a51.s) / ($457b7d299870118f$export$25173d0d38b8d129.s - $457b7d299870118f$export$ac13333ee7ee8a51.s));
    const alpha = (0.6 + 0.4 * near) * (0.35 + 0.65 * $457b7d299870118f$export$3ab94c50cd824f15(ink * 1.4));
    return {
        x: x,
        y: y,
        s: s,
        wl: wl,
        cos: Math.cos(rot),
        sin: Math.sin(rot),
        bend: bend,
        yard: yard,
        tear: tear,
        swing: swing,
        ink: ink,
        alpha: alpha
    };
};
const $457b7d299870118f$export$f6767242255957ef = (st, x, y, rig)=>{
    if (rig) {
        const h = -31 - y;
        if (h > 0) x += st.bend * h * h / 170;
    }
    const dx = x - $457b7d299870118f$var$PIVOT[0];
    const dy = y - $457b7d299870118f$var$PIVOT[1];
    const xr = $457b7d299870118f$var$PIVOT[0] + dx * st.cos - dy * st.sin;
    const yr = $457b7d299870118f$var$PIVOT[1] + dx * st.sin + dy * st.cos;
    return [
        st.x + xr * st.s,
        st.y + yr * st.s
    ];
};
const $457b7d299870118f$export$6783634de7af2576 = (st, t)=>{
    const tp = st.tear;
    const loose = [
        80 + 5 * Math.sin(t / 170) + 2.5 * Math.sin(t / 63),
        -74 + 6 * Math.sin(t / 210 + 1) + 2 * Math.sin(t / 71)
    ];
    const br = [
        $457b7d299870118f$export$3a89f8d6f6bf6c9f(95, loose[0], tp),
        $457b7d299870118f$export$3a89f8d6f6bf6c9f(-58, loose[1], tp)
    ];
    const pts = [
        [
            26,
            -105
        ],
        [
            94,
            -105
        ]
    ];
    const c1 = [
        100 - 8 * tp,
        -90
    ];
    const c2 = [
        100 - 14 * tp,
        -72 + 4 * tp
    ];
    for(let s = 1; s <= 10; s++){
        const u = s / 10, v = 1 - u;
        pts.push([
            v * v * v * 94 + 3 * v * v * u * c1[0] + 3 * v * u * u * c2[0] + u * u * u * br[0],
            v * v * v * -105 + 3 * v * v * u * c1[1] + 3 * v * u * u * c2[1] + u * u * u * br[1]
        ]);
    }
    // The foot, ragged once it has torn.
    const ctl = [
        60,
        -52 + 6 * tp
    ];
    for(let s = 1; s <= 9; s++){
        const u = s / 10, v = 1 - u;
        const x = v * v * br[0] + 2 * v * u * ctl[0] + u * u * 26;
        let y = v * v * br[1] + 2 * v * u * ctl[1] + u * u * -58;
        y += (s % 2 ? 1 : -1) * 3.2 * tp * (1 - u * 0.6);
        pts.push([
            x,
            y
        ]);
    }
    pts.push([
        26,
        -58
    ]);
    for(let s = 1; s <= 8; s++){
        const u = s / 8, v = 1 - u;
        pts.push([
            v * v * v * 26 + 3 * v * v * u * 21 + 3 * v * u * u * 21 + u * u * u * 26,
            v * v * v * -58 + 3 * v * v * u * -72 + 3 * v * u * u * -90 + u * u * u * -105
        ]);
    }
    return pts;
};
const $457b7d299870118f$export$c60e1ae01ff4068c = (_st, t)=>{
    const up = [];
    const lo = [];
    const n = 9;
    const len = 30;
    for(let i = 0; i <= n; i++){
        const u = i / n;
        const x = -6 + u * len;
        const wave = Math.sin(t / 120 - u * 5) * 2.2 * u + u * 3;
        const hw = 2.4 * (1 - u) + 0.2;
        up.push([
            x,
            -198 + wave - hw
        ]);
        lo.push([
            x,
            -198 + wave + hw
        ]);
    }
    return up.concat(lo.reverse());
};
/** The fore topsail yard swings loose at the strike, and the head of the sail swings with it. */ const $457b7d299870118f$var$yardSwing = (weight)=>(x, y, st)=>{
        const w = weight(y);
        if (!w || !st.yard) return [
            x,
            y
        ];
        const a = st.yard * w;
        const cs = Math.cos(a), sn = Math.sin(a);
        const dx = x - 60, dy = y + 150;
        return [
            60 + dx * cs - dy * sn,
            -150 + dx * sn + dy * cs
        ];
    };
const $457b7d299870118f$var$topsailWeight = (y)=>$457b7d299870118f$export$5c5ee632c52bc4a2((-111 - y) / 38);
const $457b7d299870118f$var$buildShip = ()=>{
    const parts = [];
    const add = (d, o)=>parts.push({
            shape: $457b7d299870118f$export$40fa977508bcf282(d),
            ...o
        });
    const rigLine = {
        w: 0.7,
        a: 0.5,
        rig: true
    };
    add("M 78 -50 L 130 -78", {
        ink: [
            0.22,
            0.36
        ],
        w: 1.2
    }) // bowsprit
    ;
    // Standing rigging, behind everything else.
    add("M 60 -168 L 128 -77", {
        ...rigLine,
        ink: [
            0.6,
            0.84
        ],
        a: 0.55
    });
    add("M -6 -194 L 56 -54", {
        ...rigLine,
        ink: [
            0.62,
            0.86
        ]
    });
    add("M -6 -196 L 60 -168", {
        ...rigLine,
        ink: [
            0.64,
            0.86
        ]
    });
    add("M -62 -140 L -6 -112", {
        ...rigLine,
        ink: [
            0.66,
            0.88
        ]
    });
    add("M -6 -190 L -40 -58", {
        ...rigLine,
        ink: [
            0.66,
            0.9
        ],
        a: 0.42
    });
    const fan = (top, feet, a, b)=>feet.forEach((f)=>add(`M ${top[0]} ${top[1]} L ${f[0]} ${f[1]}`, {
                ...rigLine,
                ink: [
                    a,
                    b
                ],
                w: 0.6,
                a: 0.45
            }));
    fan([
        -6,
        -150
    ], [
        [
            -26,
            -33
        ],
        [
            -19,
            -32
        ],
        [
            -12,
            -31
        ],
        [
            1,
            -31
        ],
        [
            8,
            -31
        ],
        [
            15,
            -32
        ]
    ], 0.6, 0.82);
    fan([
        60,
        -131
    ], [
        [
            47,
            -51
        ],
        [
            53,
            -51
        ],
        [
            67,
            -51
        ],
        [
            73,
            -51
        ]
    ], 0.62, 0.84);
    fan([
        -62,
        -124
    ], [
        [
            -73,
            -61
        ],
        [
            -68,
            -61
        ],
        [
            -56,
            -60
        ],
        [
            -51,
            -60
        ]
    ], 0.64, 0.86);
    const ratlines = (top, foot, l1, l2, r1, r2, ys)=>ys.forEach((y)=>{
            const u = (y - top[1]) / (foot - top[1]);
            const xs = [
                l1,
                l2,
                r1,
                r2
            ].map((x)=>top[0] + (x - top[0]) * u);
            const o = {
                ...rigLine,
                ink: [
                    0.78,
                    0.96
                ],
                w: 0.5,
                a: 0.35
            };
            if (xs[1] - xs[0] > 2) add(`M ${xs[0]} ${y} L ${xs[1]} ${y}`, o);
            if (xs[3] - xs[2] > 2) add(`M ${xs[2]} ${y} L ${xs[3]} ${y}`, o);
        });
    ratlines([
        -6,
        -150
    ], -32, -26, -12, 1, 15, [
        -46,
        -60,
        -74,
        -88,
        -102,
        -116
    ]);
    ratlines([
        60,
        -131
    ], -51, 47, 53, 67, 73, [
        -62,
        -76,
        -90
    ]);
    // Masts.
    add("M -62 -61 L -62 -142", {
        ink: [
            0.2,
            0.4
        ],
        w: 1.3,
        rig: true
    });
    add("M -6 -31 L -6 -198", {
        ink: [
            0.18,
            0.42
        ],
        w: 1.4,
        rig: true
    });
    add("M 60 -51 L 60 -170", {
        ink: [
            0.2,
            0.42
        ],
        w: 1.3,
        rig: true
    });
    // The hull and its planking.
    add("M -84 -62 L -44 -60 L -44 -36 Q 0 -28 48 -34 L 48 -50 L 88 -52 C 92 -24 84 0 64 14 C 40 24 -30 26 -60 18 L -72 8 Z", {
        ink: [
            0,
            0.32
        ],
        w: 1.45,
        fill: true,
        tone: 0.025
    });
    add("M -44 -33 Q 0 -25 48 -31", {
        ink: [
            0.28,
            0.46
        ],
        w: 0.9,
        a: 0.85
    });
    add("M -83.5 -54 L -44 -53", {
        ink: [
            0.3,
            0.46
        ],
        w: 0.9,
        a: 0.85
    });
    add("M 48 -45 L 89 -46", {
        ink: [
            0.3,
            0.46
        ],
        w: 0.9,
        a: 0.85
    });
    add("M -78 -26 Q 0 -6 88 -24", {
        ink: [
            0.3,
            0.5
        ],
        w: 1
    });
    add("M -75 -8 Q 0 10 83 -7", {
        ink: [
            0.34,
            0.54
        ],
        w: 0.9,
        a: 0.8
    });
    // Balusters along the castle rails.
    const aftTop = (x)=>-62 + (x + 84) / 20;
    const aftBalusters = [
        -78,
        -71,
        -64,
        -57,
        -50
    ];
    aftBalusters.forEach((x)=>add(`M ${x} ${aftTop(x) + 0.6} L ${x} -54`, {
            ink: [
                0.46,
                0.62
            ],
            w: 0.65,
            a: 0.7
        }));
    const foreTop = (x)=>-50 - (x - 48) / 20;
    const foreBalusters = [
        55,
        62,
        69,
        76,
        83
    ];
    foreBalusters.forEach((x)=>add(`M ${x} ${foreTop(x) + 0.6} L ${x} -45.5`, {
            ink: [
                0.46,
                0.62
            ],
            w: 0.65,
            a: 0.7
        }));
    // Gun ports along the waist, and a few in the castles.
    const port = (x, y, s = 5.5)=>add(`M ${x} ${y} L ${x + s} ${y} L ${x + s} ${y + s} L ${x} ${y + s} Z`, {
            ink: [
                0.44,
                0.64
            ],
            w: 0.8,
            a: 0.8
        });
    const waistPorts = [
        -32,
        -17,
        -2,
        13,
        28
    ];
    waistPorts.forEach((x)=>port(x, -27.5));
    port(-68, -48, 5);
    port(-57, -48, 5);
    port(60, -43, 5);
    port(71, -43, 5);
    port(-80, -50, 4);
    // Mizzen lateen, behind the main.
    add("M -30 -78 L -96 -160 C -92 -120 -86 -90 -82 -66 Q -56 -66 -30 -78 Z", {
        ink: [
            0.46,
            0.74
        ],
        w: 1,
        fill: true,
        tone: 0.05,
        rig: true
    });
    add("M -26 -73 L -100 -165", {
        ink: [
            0.42,
            0.58
        ],
        w: 1.1,
        rig: true
    });
    // Main course and topsail.
    add("M -52 -121 L 40 -121 C 48 -103 48 -84 42 -68 Q -6 -60 -54 -68 C -60 -84 -60 -103 -52 -121 Z", {
        ink: [
            0.48,
            0.78
        ],
        w: 1.1,
        fill: true,
        tone: 0.06,
        rig: true
    });
    add("M -26 -120 C -32 -100 -32 -82 -28 -64", {
        ink: [
            0.62,
            0.84
        ],
        w: 0.7,
        a: 0.55,
        rig: true
    });
    add("M 14 -120 C 18 -100 18 -82 16 -64", {
        ink: [
            0.64,
            0.86
        ],
        w: 0.7,
        a: 0.55,
        rig: true
    });
    add("M -33 -173 L 21 -173 C 27 -160 27 -140 23 -128 Q -6 -123 -35 -128 C -39 -140 -39 -160 -33 -173 Z", {
        ink: [
            0.5,
            0.78
        ],
        w: 1.05,
        fill: true,
        tone: 0.06,
        rig: true
    });
    add("M -14 -172 C -17 -158 -17 -142 -15 -126", {
        ink: [
            0.66,
            0.86
        ],
        w: 0.65,
        a: 0.5,
        rig: true
    });
    add("M 4 -172 C 6 -158 6 -142 5 -126", {
        ink: [
            0.66,
            0.86
        ],
        w: 0.65,
        a: 0.5,
        rig: true
    });
    // Fore course: torn at the strike.
    parts.push({
        dyn: $457b7d299870118f$export$6783634de7af2576,
        closed: true,
        ink: [
            0.5,
            0.78
        ],
        w: 1.1,
        fill: true,
        tone: 0.06,
        rig: true
    });
    add("M 46 -104 C 41 -88 41 -72 44 -57", {
        ink: [
            0.64,
            0.86
        ],
        w: 0.7,
        a: 0.55,
        rig: true
    });
    add("M 74 -104 C 78 -88 78 -72 76 -57", {
        ink: [
            0.66,
            0.88
        ],
        w: 0.7,
        a: 0.55,
        rig: true,
        alphaFn: (st)=>1 - st.tear
    });
    // Fore topsail: its yard swings askew at the strike.
    const topsail = $457b7d299870118f$var$yardSwing($457b7d299870118f$var$topsailWeight);
    add("M 38 -149 L 82 -149 C 87 -138 87 -122 84 -111 Q 60 -107 36 -111 C 33 -122 33 -138 38 -149 Z", {
        ink: [
            0.52,
            0.8
        ],
        w: 1.05,
        fill: true,
        tone: 0.06,
        rig: true,
        pre: topsail
    });
    add("M 52 -148 C 50 -136 50 -124 51 -110", {
        ink: [
            0.68,
            0.88
        ],
        w: 0.65,
        a: 0.5,
        rig: true,
        pre: topsail
    });
    add("M 68 -148 C 70 -136 70 -124 69 -110", {
        ink: [
            0.68,
            0.88
        ],
        w: 0.65,
        a: 0.5,
        rig: true,
        pre: topsail
    });
    // Yards and tops.
    add("M -56 -122 L 44 -122", {
        ink: [
            0.4,
            0.56
        ],
        w: 1.3,
        rig: true
    });
    add("M -36 -174 L 24 -174", {
        ink: [
            0.42,
            0.58
        ],
        w: 1.2,
        rig: true
    });
    add("M 22 -106 L 98 -106", {
        ink: [
            0.42,
            0.58
        ],
        w: 1.3,
        rig: true
    });
    add("M 36 -150 L 84 -150", {
        ink: [
            0.44,
            0.6
        ],
        w: 1.2,
        rig: true,
        pre: $457b7d299870118f$var$yardSwing(()=>1)
    });
    add("M -15 -152 L 3 -152 L 1 -146 L -13 -146 Z", {
        ink: [
            0.55,
            0.66
        ],
        w: 1,
        fill: true,
        rig: true
    });
    add("M 52 -132 L 68 -132 L 66 -127 L 54 -127 Z", {
        ink: [
            0.56,
            0.67
        ],
        w: 1,
        fill: true,
        rig: true
    });
    parts.push({
        dyn: $457b7d299870118f$export$c60e1ae01ff4068c,
        closed: true,
        ink: [
            0.85,
            1
        ],
        w: 0.8,
        fill: true,
        tone: 0.12,
        rig: true
    });
    return parts;
};
const $457b7d299870118f$export$3f9b18cab577933c = $457b7d299870118f$var$buildShip();
const $457b7d299870118f$export$3dc6026ff9ad2bcf = (st, t)=>{
    const hook = [
        -93,
        -64
    ];
    const cs = Math.cos(st.swing), sn = Math.sin(st.swing);
    const hang = (x, y)=>[
            hook[0] + x * cs - y * sn,
            hook[1] + x * sn + y * cs
        ];
    const at = (p)=>$457b7d299870118f$export$f6767242255957ef(st, p[0], p[1]);
    const lit = $457b7d299870118f$export$9662278bae91bccc(t, $457b7d299870118f$export$c579116fa63b8535.lantern, $457b7d299870118f$export$c579116fa63b8535.lantern + 350);
    return {
        bracket: [
            at([
                -83,
                -58
            ]),
            at([
                -90,
                -63.5
            ]),
            at(hook)
        ],
        body: [
            [
                -2.6,
                2.2
            ],
            [
                2.6,
                2.2
            ],
            [
                2.1,
                9
            ],
            [
                -2.1,
                9
            ]
        ].map((p)=>at(hang(p[0], p[1]))),
        cap: [
            [
                -3.2,
                2.2
            ],
            [
                0,
                -0.2
            ],
            [
                3.2,
                2.2
            ]
        ].map((p)=>at(hang(p[0], p[1]))),
        glow: at(hang(0, 5.6)),
        drawn: st.ink >= 1 ? 1 : $457b7d299870118f$export$5c5ee632c52bc4a2((st.ink - 0.9) / 0.1),
        lit: lit,
        flare: lit > 0 && lit < 1 ? Math.sin(Math.PI * lit) : 0,
        flicker: 0.82 + 0.1 * Math.sin(t / 83) + 0.06 * Math.sin(t / 37 + 1.3) + 0.04 * Math.sin(t / 151)
    };
};
const $457b7d299870118f$export$332ee97f731c11be = 312;
const $457b7d299870118f$export$53f107bf4efd5fa6 = {
    x: 128,
    y: 74,
    r: 20
};
const $457b7d299870118f$export$cc2253c86677d4f6 = (right)=>{
    const pts = $457b7d299870118f$export$40fa977508bcf282("M 620 351 C 652 347 680 333 700 314 C 720 294 756 272 812 262", 14).pts;
    const far = right + 12;
    if (far > 812) pts.push([
        far,
        262 - (far - 812) * 0.06
    ]);
    return pts;
};
const $457b7d299870118f$export$412162e701df86f3 = (x)=>352 + (x - 614) * 0.03;
const $457b7d299870118f$export$1df9a14ff8767bf = (profile, x)=>{
    for(let i = 1; i < profile.length; i++){
        const a = profile[i - 1], b = profile[i];
        if (x <= b[0]) return $457b7d299870118f$export$3a89f8d6f6bf6c9f(a[1], b[1], (x - a[0]) / (b[0] - a[0] || 1));
    }
    return profile[profile.length - 1][1];
};
const $457b7d299870118f$var$pinePoints = (x, b, h)=>{
    const tiers = 4;
    const w = h * 0.34;
    const right = [];
    for(let j = 1; j <= tiers; j++){
        const y = b - h + h * 0.8 * j / tiers;
        const ww = w * (0.35 + 0.65 * j / tiers);
        right.push([
            x + ww,
            y
        ]);
        if (j < tiers) right.push([
            x + ww * 0.4,
            y - h * 0.05
        ]);
    }
    right.push([
        x + 1.3,
        b - h * 0.2
    ]);
    right.push([
        x + 1.3,
        b
    ]);
    const left = right.map((p)=>[
            2 * x - p[0],
            p[1]
        ]).reverse();
    return [
        [
            x,
            b - h
        ],
        ...right,
        ...left
    ];
};
const $457b7d299870118f$export$7af8585ff28ebcdc = (right)=>{
    const profile = $457b7d299870118f$export$cc2253c86677d4f6(right);
    const far = profile[profile.length - 1][0];
    const poly = profile.concat([
        [
            far,
            $457b7d299870118f$export$412162e701df86f3(far) + 6
        ],
        [
            620,
            $457b7d299870118f$export$412162e701df86f3(620) + 1
        ]
    ]);
    const shore = $457b7d299870118f$export$40fa977508bcf282(`M 614 352 Q 700 355 ${far} ${$457b7d299870118f$export$412162e701df86f3(far)}`).pts;
    const wetSand = $457b7d299870118f$export$40fa977508bcf282(`M 646 356 Q 720 359 ${far} ${$457b7d299870118f$export$412162e701df86f3(far) + 3}`).pts;
    const random = $457b7d299870118f$export$cd94982b18c6332c(3);
    const hatches = [];
    for(let x = 688; x < far - 2; x += 5.2){
        const top = $457b7d299870118f$export$1df9a14ff8767bf(profile, x) + 2.5;
        const end = Math.min(top + 7 + random() * 12 * $457b7d299870118f$export$5c5ee632c52bc4a2((x - 680) / 40), $457b7d299870118f$export$412162e701df86f3(x) - 6);
        if (end - top >= 3) hatches.push({
            pts: [
                [
                    x,
                    top
                ],
                [
                    x - (end - top) * 0.3,
                    end
                ]
            ],
            d: random()
        });
    }
    const sizes = [
        [
            724,
            30
        ],
        [
            741,
            42
        ],
        [
            757,
            34
        ],
        [
            775,
            48
        ],
        [
            794,
            38
        ]
    ];
    const more = $457b7d299870118f$export$cd94982b18c6332c(9);
    for(let x = 812; x < far - 6; x += 15 + more() * 6)sizes.push([
        x,
        30 + more() * 18
    ]);
    const pines = sizes.map(([x, h], i)=>({
            pts: $457b7d299870118f$var$pinePoints(x, $457b7d299870118f$export$1df9a14ff8767bf(profile, x) + 1, h),
            i: i
        }));
    return {
        profile: profile,
        poly: poly,
        shore: shore,
        wetSand: wetSand,
        hatches: hatches,
        pines: pines
    };
};
const $457b7d299870118f$export$e11553435f0d764e = $457b7d299870118f$export$40fa977508bcf282("M 128 399 L 133 391 L 139 387 L 144 381 L 150 377 L 156 378 L 161 373 L 167 375 L 172 381 L 176 388 L 181 399").pts;
const $457b7d299870118f$export$3e26e6a832bd70d0 = $457b7d299870118f$export$40fa977508bcf282("M 104 399 L 108 394 L 114 392 L 119 393 L 124 397 L 127 399").pts;
const $457b7d299870118f$export$73de39a15d96efa1 = $457b7d299870118f$export$40fa977508bcf282("M 640 366 L 645 360 L 652 358 L 657 362 L 661 366").pts;
const $457b7d299870118f$export$7e67cf26a1bbe8e2 = $457b7d299870118f$export$40fa977508bcf282("M 670 371 L 675 366 L 681 365 L 686 371").pts;
const $457b7d299870118f$export$aacbd23eb8a8c758 = [
    "M 146 385 L 149 392",
    "M 153 382 L 156 390",
    "M 160 379 L 163 387",
    "M 166 380 L 169 388",
    "M 139 392 L 141 397",
    "M 112 395 L 114 398"
].map((d)=>$457b7d299870118f$export$40fa977508bcf282(d).pts);
const $457b7d299870118f$export$ac1bd2e1ce16d251 = $457b7d299870118f$export$40fa977508bcf282("M 649 361 L 651 365").pts;
const $457b7d299870118f$export$333251a5a08cdd5d = (cx, cy, r, a0 = 0, a1 = Math.PI * 2, n = 64)=>{
    const out = [];
    for(let i = 0; i <= n; i++){
        const a = a0 + (a1 - a0) * i / n;
        out.push([
            cx + Math.cos(a) * r,
            cy + Math.sin(a) * r
        ]);
    }
    return out;
};
const $457b7d299870118f$export$81fac420e05bb76b = $457b7d299870118f$export$333251a5a08cdd5d($457b7d299870118f$export$53f107bf4efd5fa6.x, $457b7d299870118f$export$53f107bf4efd5fa6.y, $457b7d299870118f$export$53f107bf4efd5fa6.r, -Math.PI / 2, Math.PI * 1.5);
const $457b7d299870118f$export$dfddbf17b4e37835 = Array.from({
    length: 25
}, (_, i)=>{
    const a = -Math.PI / 2 + Math.PI * i / 24;
    return [
        $457b7d299870118f$export$53f107bf4efd5fa6.x - $457b7d299870118f$export$53f107bf4efd5fa6.r * 0.38 * Math.cos(a),
        $457b7d299870118f$export$53f107bf4efd5fa6.y + $457b7d299870118f$export$53f107bf4efd5fa6.r * Math.sin(a)
    ];
});
const $457b7d299870118f$export$3b3f30bf2cdae990 = [
    -12,
    -7,
    -2,
    3,
    8,
    13
].map((dy)=>{
    const half = Math.sqrt($457b7d299870118f$export$53f107bf4efd5fa6.r * $457b7d299870118f$export$53f107bf4efd5fa6.r - dy * dy);
    return [
        [
            $457b7d299870118f$export$53f107bf4efd5fa6.x - half + 2,
            $457b7d299870118f$export$53f107bf4efd5fa6.y + dy
        ],
        [
            $457b7d299870118f$export$53f107bf4efd5fa6.x - half * 0.38 - 1.5,
            $457b7d299870118f$export$53f107bf4efd5fa6.y + dy
        ]
    ];
});
const $457b7d299870118f$export$3ee4ec77a6272710 = (cx, cy)=>{
    const top = $457b7d299870118f$export$40fa977508bcf282(`M ${cx - 68} ${cy} Q ${cx - 8} ${cy - 9} ${cx + 68} ${cy}`, 16).pts;
    const bottom = $457b7d299870118f$export$40fa977508bcf282(`M ${cx + 68} ${cy} Q ${cx + 10} ${cy + 5} ${cx - 68} ${cy}`, 16).pts;
    return {
        lens: top.concat(bottom.slice(1)),
        under: $457b7d299870118f$export$40fa977508bcf282(`M ${cx - 38} ${cy + 7} Q ${cx + 4} ${cy + 10} ${cx + 46} ${cy + 6.5}`, 12).pts
    };
};
const $457b7d299870118f$export$428c0af80a7329cd = {
    x: 96,
    y: 124,
    drift: 10,
    period: 8000
};
const $457b7d299870118f$export$7a7f0e08ac520364 = (b)=>{
    const random = $457b7d299870118f$export$cd94982b18c6332c(11);
    const out = [];
    const want = Math.round(22 * ((b.right - b.left) / 800));
    for(let tries = 0; out.length < want && tries < 2000; tries++){
        const x = b.left + random() * (b.right - b.left);
        const y = Math.max(b.top, 0) + 8 + random() * (280 - Math.max(b.top, 0));
        if (x > 180 && x < 620 && y < 162) continue;
        if (x > 158 && x < 642 && y >= 150) continue;
        if (Math.hypot(x - $457b7d299870118f$export$53f107bf4efd5fa6.x, y - $457b7d299870118f$export$53f107bf4efd5fa6.y) < 46) continue;
        if (x > 600 && y > 228) continue;
        if (x < 175 && y > 190) continue;
        out.push({
            x: x,
            y: y,
            r: 0.5 + random() * 0.7,
            ph: random() * 6.28,
            per: 1400 + random() * 2600,
            cross: random() < 0.18
        });
    }
    return out;
};
const $457b7d299870118f$export$3af4fa7869d1e582 = (b)=>{
    const random = $457b7d299870118f$export$cd94982b18c6332c(5);
    const out = [];
    const span = b.right - b.left + 20;
    for(let k = 0;; k++){
        const y = 316 + 3.1 * k + 0.2 * k * k;
        if (y > b.bottom - 2) break;
        const n = Math.round((6 + Math.floor(k * 0.6)) * (span / 820));
        for(let j = 0; j < n; j++){
            const x = b.left - 10 + random() * span;
            const len = 4 + k * 1.4 + random() * (6 + k * 0.6);
            // Never behind the land.
            if (x + len > 612 && y < $457b7d299870118f$export$412162e701df86f3(x + len) + 8) continue;
            out.push({
                x: x,
                y: y,
                len: len,
                a: Math.min(0.5, 0.14 + k * 0.018),
                ph: random() * 6.28,
                per: 2200 + random() * 3000,
                amp: 2 + random() * 5,
                d: random()
            });
        }
    }
    return out;
};
const $457b7d299870118f$export$1dd3c775c04eaed0 = (b)=>{
    const out = [];
    let y = $457b7d299870118f$export$332ee97f731c11be + 5;
    let row = 0;
    while(y < Math.min(452, b.bottom - 4)){
        out.push({
            y: y,
            hw: 3 + (y - $457b7d299870118f$export$332ee97f731c11be) * 0.1,
            row: row
        });
        y += 4 + (y - $457b7d299870118f$export$332ee97f731c11be) * 0.045;
        row++;
    }
    return out;
};
const $457b7d299870118f$export$19ea71ec66de9781 = (t)=>{
    const dt = t - $457b7d299870118f$export$c579116fa63b8535.impact;
    if (dt < 0 || dt > 1700) return [];
    const random = $457b7d299870118f$export$cd94982b18c6332c(7);
    const out = [];
    for(let i = 0; i < 26; i++){
        const ang = (-90 + (random() - 0.5) * 130) * Math.PI / 180;
        const sp = 50 + random() * 150;
        const life = 650 + random() * 650;
        const delay = random() * 90;
        const width = 0.7 + random() * 0.6;
        const tt = (dt - delay) / 1000;
        if (tt < 0 || tt * 1000 > life) continue;
        const vx = Math.cos(ang) * sp + 25;
        const vy = Math.sin(ang) * sp;
        const g = 420;
        const x = $457b7d299870118f$export$11038cc09fdccb91[0] + vx * tt;
        const y = $457b7d299870118f$export$11038cc09fdccb91[1] - 2 + vy * tt + 0.5 * g * tt * tt;
        if (y > $457b7d299870118f$export$11038cc09fdccb91[1] + 6) continue;
        const cvy = vy + g * tt;
        const m = Math.hypot(vx, cvy) || 1;
        const l = 2 + m * 0.022;
        out.push({
            from: [
                x - vx / m * l,
                y - cvy / m * l
            ],
            to: [
                x,
                y
            ],
            alpha: 0.85 * (1 - tt * 1000 / life),
            width: width
        });
    }
    return out;
};
const $457b7d299870118f$export$57800b7ee2fc44c1 = (t)=>{
    const dt = t - $457b7d299870118f$export$c579116fa63b8535.impact;
    if (dt <= 0 || dt >= 600) return [
        0,
        0
    ];
    const e = Math.exp(-dt / 130);
    return [
        2.2 * e * Math.sin(dt / 24),
        1.5 * e * Math.sin(dt / 29 + 1)
    ];
};


const $cc9dbc1d3afefc0c$export$8eb3a98fbc1bd246 = "rgb(233, 222, 198)";
/** The night sky over 0..460, top to bottom. Every knock-out fill uses the same gradient. */ const $cc9dbc1d3afefc0c$var$SKY_STOPS = [
    [
        0,
        "#07090d"
    ],
    [
        0.55,
        "#0c1017"
    ],
    [
        0.678,
        "#131822"
    ],
    [
        0.7,
        "#0d1118"
    ],
    [
        1,
        "#06080b"
    ]
];
const $cc9dbc1d3afefc0c$export$db7c42592d3dd571 = (ctx)=>{
    const gradient = ctx.createLinearGradient(0, 0, 0, 460);
    $cc9dbc1d3afefc0c$var$SKY_STOPS.forEach(([offset, color])=>gradient.addColorStop(offset, color));
    return gradient;
};
/** Draw a polyline up to `frac` of its length. Returns true when it reached the end. */ const $cc9dbc1d3afefc0c$var$trace = (ctx, pts, frac, closed)=>{
    const n = pts.length;
    const segments = closed ? n : n - 1;
    const lengths = [];
    let total = 0;
    for(let j = 0; j < segments; j++){
        const a = pts[j], b = pts[(j + 1) % n];
        const l = Math.hypot(b[0] - a[0], b[1] - a[1]);
        lengths.push(l);
        total += l;
    }
    let remain = total * frac;
    ctx.moveTo(pts[0][0], pts[0][1]);
    for(let j = 0; j < segments; j++){
        const a = pts[j], b = pts[(j + 1) % n];
        if (lengths[j] <= remain) {
            ctx.lineTo(b[0], b[1]);
            remain -= lengths[j];
        } else {
            const u = lengths[j] ? remain / lengths[j] : 0;
            ctx.lineTo(a[0] + (b[0] - a[0]) * u, a[1] + (b[1] - a[1]) * u);
            return false;
        }
    }
    return true;
};
const $cc9dbc1d3afefc0c$var$fillPoly = (ctx, pts, style, alpha)=>{
    if (alpha <= 0 || pts.length < 3) return;
    ctx.globalAlpha = alpha;
    ctx.fillStyle = style;
    ctx.beginPath();
    ctx.moveTo(pts[0][0], pts[0][1]);
    for(let i = 1; i < pts.length; i++)ctx.lineTo(pts[i][0], pts[i][1]);
    ctx.closePath();
    ctx.fill();
};
/**
 * One stroke of line art, drawn `frac` of the way along. A filled shape is first knocked out with
 * the sky's own gradient, which is what keeps overlapping line work legible: the ship hides the
 * horizon behind it instead of being tangled up with it.
 */ const $cc9dbc1d3afefc0c$var$ink = (pen, pts, drawn, o = {})=>{
    if (drawn <= 0 || pts.length < 2) return;
    // Progress built from float timings lands a hair under 1 ((1 - 0.9) / 0.1 is 0.9999...), and a
    // closed shape only closes on a complete trace.
    const frac = drawn > 0.9995 ? 1 : drawn;
    const { ctx: ctx } = pen;
    if (o.fill) {
        const fa = (0, $457b7d299870118f$export$3ab94c50cd824f15)((frac - 0.45) / 0.55);
        $cc9dbc1d3afefc0c$var$fillPoly(ctx, pts, pen.sky, fa);
        if (o.tone) $cc9dbc1d3afefc0c$var$fillPoly(ctx, pts, $cc9dbc1d3afefc0c$export$8eb3a98fbc1bd246, fa * o.tone * (o.a ?? 1));
    }
    ctx.globalAlpha = o.a ?? 1;
    ctx.lineWidth = o.w ?? 1.1;
    ctx.strokeStyle = $cc9dbc1d3afefc0c$export$8eb3a98fbc1bd246;
    ctx.beginPath();
    const done = $cc9dbc1d3afefc0c$var$trace(ctx, pts, frac, !!o.closed);
    if (done && o.closed) ctx.closePath();
    ctx.stroke();
};
const $cc9dbc1d3afefc0c$var$begin = (ctx)=>{
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = "source-over";
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
};
const $cc9dbc1d3afefc0c$export$48fcb55568ba2187 = (pen, t, land, b)=>{
    const { ctx: ctx } = pen;
    $cc9dbc1d3afefc0c$var$begin(ctx);
    ctx.fillStyle = pen.sky;
    ctx.fillRect(b.left - 20, b.top - 20, b.right - b.left + 40, b.bottom - b.top + 40);
    const horizon = (0, $457b7d299870118f$export$24656b269d8df7d6)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).horizon[0], (0, $457b7d299870118f$export$c579116fa63b8535).horizon[1]));
    $cc9dbc1d3afefc0c$var$ink(pen, [
        [
            b.left - 10,
            (0, $457b7d299870118f$export$332ee97f731c11be)
        ],
        [
            b.right + 10,
            (0, $457b7d299870118f$export$332ee97f731c11be)
        ]
    ], horizon, {
        a: 0.42,
        w: 1
    });
    const moon = (0, $457b7d299870118f$export$dbce5739ea4fa8d3)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).moon[0], (0, $457b7d299870118f$export$c579116fa63b8535).moon[1]));
    if (moon > 0) {
        $cc9dbc1d3afefc0c$var$fillPoly(ctx, (0, $457b7d299870118f$export$81fac420e05bb76b), $cc9dbc1d3afefc0c$export$8eb3a98fbc1bd246, 0.07 * (0, $457b7d299870118f$export$3ab94c50cd824f15)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).moon[0] + 400, (0, $457b7d299870118f$export$c579116fa63b8535).moon[1] + 500)));
        $cc9dbc1d3afefc0c$var$ink(pen, (0, $457b7d299870118f$export$81fac420e05bb76b), moon, {
            a: 0.85,
            w: 1.15
        });
        $cc9dbc1d3afefc0c$var$ink(pen, (0, $457b7d299870118f$export$dfddbf17b4e37835), (0, $457b7d299870118f$export$dbce5739ea4fa8d3)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).moon[0] + 500, (0, $457b7d299870118f$export$c579116fa63b8535).moon[1] + 300)), {
            a: 0.45,
            w: 0.8
        });
        (0, $457b7d299870118f$export$3b3f30bf2cdae990).forEach((h, i)=>$cc9dbc1d3afefc0c$var$ink(pen, h, (0, $457b7d299870118f$export$dbce5739ea4fa8d3)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).moon[1] - 200 + i * 60, (0, $457b7d299870118f$export$c579116fa63b8535).moon[1] + 100 + i * 60)), {
                a: 0.32,
                w: 0.7
            }));
    }
    const shore = (0, $457b7d299870118f$export$dbce5739ea4fa8d3)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).land[0], (0, $457b7d299870118f$export$c579116fa63b8535).land[0] + 1100));
    if (shore > 0) {
        $cc9dbc1d3afefc0c$var$fillPoly(ctx, land.poly, pen.sky, (0, $457b7d299870118f$export$3ab94c50cd824f15)((shore - 0.3) / 0.7));
        $cc9dbc1d3afefc0c$var$ink(pen, land.profile, shore, {
            a: 0.85,
            w: 1.2
        });
        $cc9dbc1d3afefc0c$var$ink(pen, land.shore, (0, $457b7d299870118f$export$dbce5739ea4fa8d3)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).land[0] + 300, (0, $457b7d299870118f$export$c579116fa63b8535).land[0] + 1300)), {
            a: 0.6,
            w: 0.9
        });
        $cc9dbc1d3afefc0c$var$ink(pen, land.wetSand, (0, $457b7d299870118f$export$dbce5739ea4fa8d3)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).land[0] + 500, (0, $457b7d299870118f$export$c579116fa63b8535).land[0] + 1500)), {
            a: 0.3,
            w: 0.8
        });
        const hatchAt = (0, $457b7d299870118f$export$c579116fa63b8535).land[0] + 700;
        land.hatches.forEach((h)=>$cc9dbc1d3afefc0c$var$ink(pen, h.pts, (0, $457b7d299870118f$export$dbce5739ea4fa8d3)((0, $457b7d299870118f$export$9662278bae91bccc)(t, hatchAt + h.d * 700, hatchAt + h.d * 700 + 300)), {
                a: 0.38,
                w: 0.7
            }));
        land.pines.forEach((p)=>{
            const delay = Math.min(p.i, 6) * 140;
            const f = (0, $457b7d299870118f$export$dbce5739ea4fa8d3)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).land[0] + 900 + delay, (0, $457b7d299870118f$export$c579116fa63b8535).land[0] + 1500 + delay));
            $cc9dbc1d3afefc0c$var$ink(pen, p.pts, f, {
                closed: true,
                fill: true,
                a: 0.8,
                w: 1
            });
        });
    }
    const rocks = (0, $457b7d299870118f$export$dbce5739ea4fa8d3)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).rocks[0], (0, $457b7d299870118f$export$c579116fa63b8535).rocks[1]));
    if (rocks > 0) {
        for (const rock of [
            (0, $457b7d299870118f$export$73de39a15d96efa1),
            (0, $457b7d299870118f$export$7e67cf26a1bbe8e2)
        ]){
            $cc9dbc1d3afefc0c$var$fillPoly(ctx, rock, pen.sky, (0, $457b7d299870118f$export$3ab94c50cd824f15)((rocks - 0.3) / 0.7));
            $cc9dbc1d3afefc0c$var$ink(pen, rock, rocks, {
                a: 0.85,
                w: 1.15
            });
        }
        $cc9dbc1d3afefc0c$var$ink(pen, (0, $457b7d299870118f$export$ac1bd2e1ce16d251), (0, $457b7d299870118f$export$dbce5739ea4fa8d3)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).rocks[0] + 400, (0, $457b7d299870118f$export$c579116fa63b8535).rocks[1])), {
            a: 0.45,
            w: 0.7
        });
    }
};
const $cc9dbc1d3afefc0c$export$be213a4ba0ef04ea = (pen, t)=>{
    $cc9dbc1d3afefc0c$var$begin(pen.ctx);
    const f = (0, $457b7d299870118f$export$dbce5739ea4fa8d3)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).cloud[0], (0, $457b7d299870118f$export$c579116fa63b8535).cloud[1]));
    if (f <= 0) return;
    const { lens: lens, under: under } = (0, $457b7d299870118f$export$3ee4ec77a6272710)((0, $457b7d299870118f$export$428c0af80a7329cd).x, (0, $457b7d299870118f$export$428c0af80a7329cd).y);
    $cc9dbc1d3afefc0c$var$ink(pen, lens, f, {
        closed: true,
        fill: true,
        a: 0.32,
        w: 0.9
    });
    $cc9dbc1d3afefc0c$var$ink(pen, under, f, {
        a: 0.2,
        w: 0.8
    });
};
// ---- the live layer: the ship, the rocks it strikes, the water it disturbs ---------------------
const $cc9dbc1d3afefc0c$var$paintShipItself = (pen, t, st)=>{
    const { ctx: ctx } = pen;
    const widthScale = 0.75 + 0.25 * (st.s / (0, $457b7d299870118f$export$25173d0d38b8d129).s);
    // Nothing of the ship shows below the water.
    ctx.save();
    ctx.beginPath();
    ctx.rect(-400, -400, 1600, st.wl + 400.5);
    ctx.clip();
    for (const part of (0, $457b7d299870118f$export$3f9b18cab577933c)){
        const f = (0, $457b7d299870118f$export$5c5ee632c52bc4a2)((st.ink - part.ink[0]) / (part.ink[1] - part.ink[0]));
        if (f <= 0) continue;
        const source = part.dyn ? part.dyn(st, t) : part.shape.pts;
        const closed = part.dyn ? !!part.closed : part.shape.closed;
        const pts = source.map((p)=>{
            const q = part.pre ? part.pre(p[0], p[1], st) : p;
            return (0, $457b7d299870118f$export$f6767242255957ef)(st, q[0], q[1], part.rig);
        });
        const a = (part.a ?? 1) * st.alpha * (part.alphaFn ? part.alphaFn(st) : 1);
        $cc9dbc1d3afefc0c$var$ink(pen, pts, (0, $457b7d299870118f$export$dbce5739ea4fa8d3)(f), {
            closed: closed,
            fill: part.fill,
            tone: part.tone,
            a: a,
            w: (part.w ?? 1.1) * widthScale
        });
    }
    ctx.restore();
    const drawn = (0, $457b7d299870118f$export$3ab94c50cd824f15)((st.ink - 0.3) / 0.3);
    const bow = (0, $457b7d299870118f$export$f6767242255957ef)(st, 75, 0);
    const stern = (0, $457b7d299870118f$export$f6767242255957ef)(st, -73, 0);
    if (drawn > 0) {
        // A ruffle of foam where the hull meets the water.
        const foam = [];
        for(let i = 0; i <= 24; i++){
            const x = (0, $457b7d299870118f$export$3a89f8d6f6bf6c9f)(stern[0], bow[0], i / 24);
            foam.push([
                x,
                st.wl + 0.6 + 0.7 * Math.sin(x * 0.45 + t / 260)
            ]);
        }
        $cc9dbc1d3afefc0c$var$ink(pen, foam, 1, {
            a: 0.55 * drawn * st.alpha,
            w: 0.9
        });
    }
    // Under way: a bow wave and a wake, gone the moment she strikes.
    const way = (0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).sail[0], (0, $457b7d299870118f$export$c579116fa63b8535).sail[0] + 700) * (1 - (0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).impact, (0, $457b7d299870118f$export$c579116fa63b8535).impact + 450)) * drawn;
    if (way > 0) {
        const j = Math.sin(t / 90) * 0.6;
        $cc9dbc1d3afefc0c$var$ink(pen, [
            [
                bow[0] + 1,
                st.wl
            ],
            [
                bow[0] - 5 * st.s,
                st.wl + 3 + j
            ],
            [
                bow[0] - 16 * st.s,
                st.wl + 4.5
            ]
        ], 1, {
            a: 0.6 * way,
            w: 0.9
        });
        $cc9dbc1d3afefc0c$var$ink(pen, [
            [
                bow[0] + 2,
                st.wl + 1
            ],
            [
                bow[0] - 3 * st.s,
                st.wl + 7 * st.s
            ]
        ], 1, {
            a: 0.4 * way,
            w: 0.8
        });
        ctx.setLineDash([
            3,
            5
        ]);
        ctx.lineDashOffset = -t / 25;
        $cc9dbc1d3afefc0c$var$ink(pen, [
            [
                stern[0] - 2,
                st.wl + 1
            ],
            [
                stern[0] - 46 * st.s,
                st.wl - 1.5
            ]
        ], 1, {
            a: 0.45 * way,
            w: 0.8
        });
        $cc9dbc1d3afefc0c$var$ink(pen, [
            [
                stern[0] - 2,
                st.wl + 2.5
            ],
            [
                stern[0] - 38 * st.s,
                st.wl + 4 * st.s
            ]
        ], 1, {
            a: 0.35 * way,
            w: 0.8
        });
        ctx.setLineDash([]);
    }
};
/** Rings spreading from the bow at the strike. Drawn before the ship, so the hull hides their far side. */ const $cc9dbc1d3afefc0c$var$paintImpactRings = (ctx, t)=>{
    const dt = t - (0, $457b7d299870118f$export$c579116fa63b8535).impact;
    if (dt < 0) return;
    ctx.strokeStyle = $cc9dbc1d3afefc0c$export$8eb3a98fbc1bd246;
    ctx.lineWidth = 0.9;
    for(let j = 0; j < 3; j++){
        const d = dt - j * 160;
        if (d < 0 || d > 1500) continue;
        const e = (0, $457b7d299870118f$export$1157fb72e7fbceb5)(d / 1500);
        const rx = 6 + 52 * e;
        ctx.globalAlpha = 0.55 * (1 - e);
        ctx.beginPath();
        ctx.ellipse((0, $457b7d299870118f$export$11038cc09fdccb91)[0], (0, $457b7d299870118f$export$11038cc09fdccb91)[1] + 2, rx, rx * 0.17, 0, 0, Math.PI * 2);
        ctx.stroke();
    }
};
/** Once she is fast, the swell keeps rolling in toward the rocks. */ const $cc9dbc1d3afefc0c$var$paintSwell = (pen, t)=>{
    const dt = t - (0, $457b7d299870118f$export$c579116fa63b8535).impact - 900;
    if (dt < 0) return;
    const fade = (0, $457b7d299870118f$export$3ab94c50cd824f15)(dt / 800);
    for(let j = 0; j < 3; j++){
        const u = (dt + j * 1200) % 3600 / 3600;
        const x0 = -10 + 120 * u;
        const y = 405 + j * 9 - 4 * u;
        $cc9dbc1d3afefc0c$var$ink(pen, (0, $457b7d299870118f$export$40fa977508bcf282)(`M ${x0} ${y} Q ${x0 + 13} ${y - 2} ${x0 + 26} ${y}`, 8).pts, 1, {
            a: Math.sin(Math.PI * u) * 0.42 * fade,
            w: 0.85
        });
    }
};
const $cc9dbc1d3afefc0c$var$paintRocks = (pen, t)=>{
    const f = (0, $457b7d299870118f$export$dbce5739ea4fa8d3)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).rocks[0], (0, $457b7d299870118f$export$c579116fa63b8535).rocks[1]));
    if (f <= 0) return;
    for (const rock of [
        (0, $457b7d299870118f$export$e11553435f0d764e),
        (0, $457b7d299870118f$export$3e26e6a832bd70d0)
    ]){
        $cc9dbc1d3afefc0c$var$fillPoly(pen.ctx, rock, pen.sky, (0, $457b7d299870118f$export$3ab94c50cd824f15)((f - 0.3) / 0.7));
        $cc9dbc1d3afefc0c$var$ink(pen, rock, f, {
            a: 0.85,
            w: 1.15
        });
    }
    (0, $457b7d299870118f$export$aacbd23eb8a8c758).forEach((h, i)=>$cc9dbc1d3afefc0c$var$ink(pen, h, (0, $457b7d299870118f$export$dbce5739ea4fa8d3)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).rocks[0] + 400 + i * 80, (0, $457b7d299870118f$export$c579116fa63b8535).rocks[1] + i * 80)), {
            a: 0.45,
            w: 0.7
        }));
    const foam = (0, $457b7d299870118f$export$3ab94c50cd824f15)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).rocks[1], (0, $457b7d299870118f$export$c579116fa63b8535).rocks[1] + 600));
    if (foam > 0) {
        const l = 7 + 3 * Math.sin(t / 900);
        $cc9dbc1d3afefc0c$var$ink(pen, [
            [
                127 - l,
                401
            ],
            [
                126,
                401
            ]
        ], 1, {
            a: 0.35 * foam,
            w: 0.8
        });
        $cc9dbc1d3afefc0c$var$ink(pen, [
            [
                100 - l * 0.6,
                401.5
            ],
            [
                103,
                401.5
            ]
        ], 1, {
            a: 0.25 * foam,
            w: 0.8
        });
    }
};
const $cc9dbc1d3afefc0c$var$paintSpray = (ctx, t)=>{
    ctx.strokeStyle = $cc9dbc1d3afefc0c$export$8eb3a98fbc1bd246;
    for (const drop of (0, $457b7d299870118f$export$19ea71ec66de9781)(t)){
        ctx.globalAlpha = drop.alpha;
        ctx.lineWidth = drop.width;
        ctx.beginPath();
        ctx.moveTo(drop.from[0], drop.from[1]);
        ctx.lineTo(drop.to[0], drop.to[1]);
        ctx.stroke();
    }
};
/** The lantern's frame and its lit pane. The light it throws is an additive sprite in the scene. */ const $cc9dbc1d3afefc0c$var$paintLantern = (pen, t, st)=>{
    const lantern = (0, $457b7d299870118f$export$3dc6026ff9ad2bcf)(st, t);
    if (lantern.drawn <= 0) return;
    $cc9dbc1d3afefc0c$var$ink(pen, lantern.bracket, lantern.drawn, {
        a: 0.9 * st.alpha,
        w: 1
    });
    if (lantern.lit > 0) $cc9dbc1d3afefc0c$var$fillPoly(pen.ctx, lantern.body, "#ffc56b", lantern.lit * (0.75 + 0.25 * lantern.flicker));
    $cc9dbc1d3afefc0c$var$ink(pen, lantern.body, lantern.drawn, {
        closed: true,
        a: 0.95 * st.alpha,
        w: 0.9
    });
    $cc9dbc1d3afefc0c$var$ink(pen, lantern.cap, lantern.drawn, {
        a: 0.95 * st.alpha,
        w: 0.9
    });
};
const $cc9dbc1d3afefc0c$export$9683c77eea312b46 = (pen, t)=>{
    const { ctx: ctx } = pen;
    $cc9dbc1d3afefc0c$var$begin(ctx);
    const st = (0, $457b7d299870118f$export$852e4b6956254f0c)(t);
    $cc9dbc1d3afefc0c$var$paintImpactRings(ctx, t);
    $cc9dbc1d3afefc0c$var$paintSwell(pen, t);
    if (st.ink > 0) $cc9dbc1d3afefc0c$var$paintShipItself(pen, t, st);
    $cc9dbc1d3afefc0c$var$paintRocks(pen, t);
    $cc9dbc1d3afefc0c$var$paintSpray(ctx, t);
    $cc9dbc1d3afefc0c$var$paintLantern(pen, t, st);
    ctx.globalAlpha = 1;
    return st;
};



/**
 * The login screen's backdrop: a ship drawn in line art, sailing in out of the night and running
 * aground beside the card. Replaces the forest picture, the nightfall wash, the fog and the embers.
 *
 * Built from three kinds of piece, each for its cost:
 *  - Line art is painted with Canvas2D (antialiased; the game's renderer is not) into canvases that
 *    pixi shows as textures. The sky, horizon, moon and far shore are one layer, repainted only while
 *    they are being drawn in and then never again. The ship -- with the rocks, the spray and the swell
 *    around it -- is a small layer repainted every frame.
 *  - The water's glints and the stars are plain sprites off one tiny texture: hundreds of them cost
 *    nothing, and they never need a repaint.
 *  - Light -- the moon's halo, the mist on the horizon, the lantern and its reflection -- is additive
 *    sprites, never a filter (see intro_theme on why the login screen uses no filters).
 *
 * The whole thing is a function of time since the loading screen handed over (see intro_pace.ts),
 * driven by its own animation frame loop, so a background tab lands on the right frame.
 */ const $731b1cfd7600e971$var$INK_TINT = 0xe9dec6;
const $731b1cfd7600e971$var$LANTERN_TINT = 0xffb860;
const $731b1cfd7600e971$var$REFLECTION_TINT = 0xffbe6e;
const $731b1cfd7600e971$var$MOON_TINT = 0xbecde6;
const $731b1cfd7600e971$var$MIST_TINT = 0x96aac8;
/** Everything the ship touches, in authored coordinates: the far pose, the masts, the swell, the spray. */ const $731b1cfd7600e971$var$SHIP_REGION = {
    x: -70,
    y: 170,
    w: 330,
    h: 258
};
const $731b1cfd7600e971$var$CLOUD_REGION = {
    x: (0, $457b7d299870118f$export$428c0af80a7329cd).x - 82,
    y: (0, $457b7d299870118f$export$428c0af80a7329cd).y - 16,
    w: 164,
    h: 32
};
/** Line art is drawn at the screen's density, capped so the uploads stay small on a big display. */ const $731b1cfd7600e971$var$STATIC_MAX_DENSITY = 2;
const $731b1cfd7600e971$var$LIVE_MAX_DENSITY = 2.5;
/** Below this the warm loading backdrop has faded and is freed. */ const $731b1cfd7600e971$var$BACKDROP_DENSITY = 0.5;
const $731b1cfd7600e971$var$clamp = (v, lo, hi)=>Math.max(lo, Math.min(hi, v));
/** A Canvas2D surface shown as a pixi sprite. `place` sizes it; `pen` paints into it; `commit` uploads. */ class $731b1cfd7600e971$var$CanvasLayer {
    constructor(){
        this.region = {
            x: 0,
            y: 0,
            w: 1,
            h: 1
        };
        this.density = 1;
        /** `region` is in authored coordinates; the sprite goes wherever the mirror puts it. */ this.place = (region, density)=>{
            this.region = region;
            this.density = density;
            const w = Math.max(1, Math.ceil(region.w * density));
            const h = Math.max(1, Math.ceil(region.h * density));
            if (this.canvas.width !== w || this.canvas.height !== h) {
                this.canvas.width = w;
                this.canvas.height = h;
            }
            this.sprite.position.set(this.outX(), region.y);
            this.sprite.scale.set(1 / density);
        };
        /** A pen in authored coordinates. Cleared first unless the painter covers every pixel itself. */ this.pen = (clear)=>{
            const ctx = this.ctx;
            if (!ctx) return undefined;
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            if (clear) ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            const d = this.density;
            ctx.setTransform(d, 0, 0, d, -this.outX() * d, -this.region.y * d);
            if (0, $457b7d299870118f$export$43d3c9dbcf230964) {
                ctx.translate(2 * (0, $457b7d299870118f$export$875e106f2e8aca73), 0);
                ctx.scale(-1, 1);
            }
            this.sky = this.sky || (0, $cc9dbc1d3afefc0c$export$db7c42592d3dd571)(ctx);
            return {
                ctx: ctx,
                sky: this.sky
            };
        };
        /**
     * Upload what was painted. Through the resource, not `baseTexture.update()`: that only marks the
     * texture dirty and never re-reads the canvas size, so a canvas resized after `Texture.from`
     * stays a 1x1 texture -- the line art silently vanishes while every sprite still draws.
     */ this.commit = ()=>this.texture.update();
        this.dispose = ()=>{
            this.sprite.destroy();
            this.texture.destroy(true);
        };
        this.outX = ()=>(0, $457b7d299870118f$export$43d3c9dbcf230964) ? 2 * (0, $457b7d299870118f$export$875e106f2e8aca73) - (this.region.x + this.region.w) : this.region.x;
        this.canvas = document.createElement("canvas");
        this.canvas.width = 1;
        this.canvas.height = 1;
        this.ctx = this.canvas.getContext("2d");
        this.texture = (0, $klOfb.Texture).from(this.canvas);
        this.texture.baseTexture.mipmap = (0, $P8XPi.MIPMAP_MODES).OFF;
        this.sprite = new (0, $7Bs2Z.Sprite)(this.texture);
    }
}
/**
 * One short white stroke with round ends, for every glint on the water. 32x8 with the stroke from
 * 3 to 29 and 2px thick: `dashSprite` sizes it by visible length and thickness.
 */ let $731b1cfd7600e971$var$dash;
const $731b1cfd7600e971$var$dashTexture = ()=>{
    if ($731b1cfd7600e971$var$dash) return $731b1cfd7600e971$var$dash;
    try {
        const canvas = document.createElement("canvas");
        canvas.width = 32;
        canvas.height = 8;
        const g = canvas.getContext("2d");
        if (!g) return (0, $klOfb.Texture).WHITE;
        g.strokeStyle = "#ffffff";
        g.lineWidth = 2;
        g.lineCap = "round";
        g.beginPath();
        g.moveTo(4, 4);
        g.lineTo(28, 4);
        g.stroke();
        $731b1cfd7600e971$var$dash = (0, $klOfb.Texture).from(canvas);
    } catch (e) {
        $731b1cfd7600e971$var$dash = (0, $klOfb.Texture).WHITE;
    }
    return $731b1cfd7600e971$var$dash;
};
const $731b1cfd7600e971$var$dashSprite = (tint, additive = false)=>{
    const sprite = new (0, $7Bs2Z.Sprite)($731b1cfd7600e971$var$dashTexture());
    sprite.anchor.set(0.5);
    sprite.tint = tint;
    if (additive) sprite.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
    return sprite;
};
/** Lay a dash sprite out by its visible length and stroke width, centred on (x, y), in authored x. */ const $731b1cfd7600e971$var$setDash = (sprite, x, y, length, thickness)=>{
    sprite.position.set((0, $457b7d299870118f$export$74231045b68dcd81)(x), y);
    sprite.width = Math.max(0.5, length) * 32 / 26;
    sprite.height = thickness * 4;
};
class $731b1cfd7600e971$export$d56a52d38c087484 extends (0, $8t5Gy.Container) {
    constructor({ backdrop: backdrop, atRest: atRest = false } = {}){
        super(), /** Everything but the loading backdrop: this is what shakes when the ship strikes. */ this.world = new (0, $8t5Gy.Container)(), this.staticLayer = new $731b1cfd7600e971$var$CanvasLayer(), this.cloudLayer = new $731b1cfd7600e971$var$CanvasLayer(), this.shipLayer = new $731b1cfd7600e971$var$CanvasLayer(), this.starLayer = new (0, $8t5Gy.Container)(), this.waterLayer = new (0, $8t5Gy.Container)(), this.reflections = [], this.bounds = {
            left: 0,
            right: 800,
            top: 0,
            bottom: 460
        }, this.land = (0, $457b7d299870118f$export$7af8585ff28ebcdc)(800), this.stars = [], this.water = [], this.glitter = [], this.staticDirty = true, this.cloudDirty = true, this.frameCount = 0, this.disposed = false, /** Fit the scene to the visible stage: wider and taller than 800 x 460 on an expanded phone. */ this.resize = ()=>{
            if (this.disposed) return;
            const v = (0, $167efe97b4119a5d$export$b0f20d83cec42115)();
            this.bounds = {
                left: v.left,
                right: v.right,
                top: v.top,
                bottom: v.bottom
            };
            this.land = (0, $457b7d299870118f$export$7af8585ff28ebcdc)(v.right);
            const resolution = (0, $065c5647ab3ff4dc$export$90e89a86e46f5ae3)()?.renderer?.resolution ?? 1;
            this.staticLayer.place({
                x: v.left,
                y: v.top,
                w: v.width,
                h: v.height
            }, $731b1cfd7600e971$var$clamp(resolution, 1, $731b1cfd7600e971$var$STATIC_MAX_DENSITY));
            this.cloudLayer.place($731b1cfd7600e971$var$CLOUD_REGION, $731b1cfd7600e971$var$clamp(resolution, 1, $731b1cfd7600e971$var$LIVE_MAX_DENSITY));
            this.shipLayer.place($731b1cfd7600e971$var$SHIP_REGION, $731b1cfd7600e971$var$clamp(resolution, 1, $731b1cfd7600e971$var$LIVE_MAX_DENSITY));
            this.buildStars();
            this.buildWater();
            this.halo.position.set((0, $457b7d299870118f$export$74231045b68dcd81)((0, $457b7d299870118f$export$53f107bf4efd5fa6).x), (0, $457b7d299870118f$export$53f107bf4efd5fa6).y);
            this.halo.width = this.halo.height = (0, $457b7d299870118f$export$53f107bf4efd5fa6).r * 11;
            this.mist.position.set((0, $457b7d299870118f$export$875e106f2e8aca73), (0, $457b7d299870118f$export$332ee97f731c11be) + 2);
            this.mist.width = v.width * 1.3;
            this.mist.height = 70;
            this.bakeBackdrop();
            this.staticDirty = true;
            this.cloudDirty = true;
            this.paint(this.now());
        }, this.dispose = ()=>{
            this.disposed = true;
            if (this.frame !== undefined && typeof cancelAnimationFrame === "function") cancelAnimationFrame(this.frame);
            this.frame = undefined;
            this.dropBackdrop();
            this.staticLayer.dispose();
            this.cloudLayer.dispose();
            this.shipLayer.dispose();
            // The glow and dash textures are shared and cached; only the sprites go.
            this.removeChildren();
            this.world.destroy({
                children: true
            });
        }, this.now = ()=>(0, $2d30638548db1697$export$c7f9011f90f33196)(Date.now() - this.startedAt), this.tick = ()=>{
            if (this.disposed) return;
            this.paint(this.now());
            if (typeof requestAnimationFrame === "function") this.frame = requestAnimationFrame(this.tick);
        }, this.buildStars = ()=>{
            this.stars.forEach((s)=>[
                    s.dot,
                    ...s.arms
                ].forEach((sprite)=>sprite.destroy()));
            this.starLayer.removeChildren();
            this.stars = (0, $457b7d299870118f$export$7a7f0e08ac520364)(this.bounds).map((star)=>{
                const dot = new (0, $7Bs2Z.Sprite)((0, $92b2c55b1ed94f26$export$39bbb304d3263439)());
                dot.anchor.set(0.5);
                dot.tint = $731b1cfd7600e971$var$INK_TINT;
                dot.position.set((0, $457b7d299870118f$export$74231045b68dcd81)(star.x), star.y);
                dot.width = dot.height = star.r * 7;
                const arms = star.cross ? [
                    $731b1cfd7600e971$var$dashSprite($731b1cfd7600e971$var$INK_TINT),
                    $731b1cfd7600e971$var$dashSprite($731b1cfd7600e971$var$INK_TINT)
                ] : [];
                arms.forEach((arm, i)=>{
                    $731b1cfd7600e971$var$setDash(arm, star.x, star.y, 5.2, 0.5);
                    arm.rotation = i * (Math.PI / 2);
                });
                this.starLayer.addChild(dot, ...arms);
                return {
                    star: star,
                    dot: dot,
                    arms: arms
                };
            });
        }, this.buildWater = ()=>{
            this.waterLayer.children.slice().forEach((child)=>child.destroy());
            this.waterLayer.removeChildren();
            this.water = (0, $457b7d299870118f$export$3af4fa7869d1e582)(this.bounds).map((d)=>{
                const sprite = $731b1cfd7600e971$var$dashSprite($731b1cfd7600e971$var$INK_TINT);
                this.waterLayer.addChild(sprite);
                return {
                    dash: d,
                    sprite: sprite
                };
            });
            this.glitter = (0, $457b7d299870118f$export$1dd3c775c04eaed0)(this.bounds).map((row)=>{
                const sprites = [
                    $731b1cfd7600e971$var$dashSprite($731b1cfd7600e971$var$INK_TINT),
                    $731b1cfd7600e971$var$dashSprite($731b1cfd7600e971$var$INK_TINT)
                ];
                this.waterLayer.addChild(...sprites);
                return {
                    row: row,
                    sprites: sprites
                };
            });
        }, /**
     * The loading screen's own backdrop, repainted in pixi under the HTML one so the HTML layer can
     * drop away without the screen changing. It then fades to show the night behind it.
     */ this.bakeBackdrop = ()=>{
            const e = this.backdrop;
            if (!e || this.now() >= (0, $457b7d299870118f$export$c579116fa63b8535).backdrop[1]) {
                this.dropBackdrop();
                return;
            }
            const b = this.bounds;
            try {
                const canvas = document.createElement("canvas");
                canvas.width = Math.max(1, Math.ceil((b.right - b.left) * $731b1cfd7600e971$var$BACKDROP_DENSITY));
                canvas.height = Math.max(1, Math.ceil((b.bottom - b.top) * $731b1cfd7600e971$var$BACKDROP_DENSITY));
                const g = canvas.getContext("2d");
                if (!g) return;
                g.fillStyle = (0, $b8d1d91ff2e7f409$export$347d421daadd77cf)[(0, $b8d1d91ff2e7f409$export$347d421daadd77cf).length - 1][1];
                g.fillRect(0, 0, canvas.width, canvas.height);
                g.setTransform($731b1cfd7600e971$var$BACKDROP_DENSITY, 0, 0, $731b1cfd7600e971$var$BACKDROP_DENSITY, -b.left * $731b1cfd7600e971$var$BACKDROP_DENSITY, -b.top * $731b1cfd7600e971$var$BACKDROP_DENSITY);
                g.translate(e.cx, e.cy);
                g.scale(1, e.ry / e.rx);
                const gradient = g.createRadialGradient(0, 0, 0, 0, 0, e.rx);
                (0, $b8d1d91ff2e7f409$export$347d421daadd77cf).forEach(([offset, color])=>gradient.addColorStop(offset, color));
                g.fillStyle = gradient;
                g.fillRect(-e.rx, -e.rx, e.rx * 2, e.rx * 2);
                this.dropBackdrop();
                const sprite = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).from(canvas));
                sprite.position.set(b.left, b.top);
                sprite.scale.set(1 / $731b1cfd7600e971$var$BACKDROP_DENSITY);
                this.backdropSprite = sprite;
                this.addChild(sprite);
            } catch (err) {
            // No canvas: no backdrop. The HTML one fades over the scene instead.
            }
        }, this.dropBackdrop = ()=>{
            const sprite = this.backdropSprite;
            if (!sprite) return;
            this.backdropSprite = undefined;
            sprite.parent?.removeChild(sprite);
            sprite.destroy({
                texture: true,
                baseTexture: true
            });
        }, this.paint = (t)=>{
            if (this.backdropSprite) {
                const alpha = 1 - (0, $457b7d299870118f$export$24656b269d8df7d6)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).backdrop[0], (0, $457b7d299870118f$export$c579116fa63b8535).backdrop[1]));
                if (alpha <= 0) this.dropBackdrop();
                else this.backdropSprite.alpha = alpha;
            }
            this.paintStatic(t);
            this.paintCloud(t);
            this.paintLights(t);
            this.paintWater(t);
            this.paintShip(t);
            const [sx, sy] = (0, $457b7d299870118f$export$57800b7ee2fc44c1)(t);
            this.world.position.set((0, $457b7d299870118f$export$43d3c9dbcf230964) ? -sx : sx, sy);
            this.frameCount++;
        }, /** Repainted at half the frame rate while it is being drawn in, then never again. */ this.paintStatic = (t)=>{
            const drawing = t < (0, $457b7d299870118f$export$f64453ff4afd9ce8) + 100;
            if (!this.staticDirty && (!drawing || this.frameCount % 2 === 1)) return;
            const pen = this.staticLayer.pen(false);
            if (pen) {
                (0, $cc9dbc1d3afefc0c$export$48fcb55568ba2187)(pen, t, this.land, this.bounds);
                this.staticLayer.commit();
            }
            this.staticDirty = false;
        }, this.paintCloud = (t)=>{
            const offset = (0, $457b7d299870118f$export$428c0af80a7329cd).drift * Math.sin(t / (0, $457b7d299870118f$export$428c0af80a7329cd).period);
            const base = (0, $457b7d299870118f$export$43d3c9dbcf230964) ? 2 * (0, $457b7d299870118f$export$875e106f2e8aca73) - ($731b1cfd7600e971$var$CLOUD_REGION.x + $731b1cfd7600e971$var$CLOUD_REGION.w) : $731b1cfd7600e971$var$CLOUD_REGION.x;
            this.cloudLayer.sprite.x = base + ((0, $457b7d299870118f$export$43d3c9dbcf230964) ? -offset : offset);
            if (!this.cloudDirty && t > (0, $457b7d299870118f$export$c579116fa63b8535).cloud[1] + 100) return;
            const pen = this.cloudLayer.pen(true);
            if (pen) {
                (0, $cc9dbc1d3afefc0c$export$be213a4ba0ef04ea)(pen, t);
                this.cloudLayer.commit();
            }
            this.cloudDirty = false;
        }, this.paintLights = (t)=>{
            this.halo.alpha = 0.25 * (0, $457b7d299870118f$export$3ab94c50cd824f15)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).moon[0] + 400, (0, $457b7d299870118f$export$c579116fa63b8535).moon[1] + 500));
            this.mist.alpha = 0.12 * (0, $457b7d299870118f$export$3ab94c50cd824f15)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).horizon[0], (0, $457b7d299870118f$export$c579116fa63b8535).horizon[1] + 800)) * (0.85 + 0.15 * Math.sin(t / 4100));
            this.stars.forEach(({ star: star, dot: dot, arms: arms }, i)=>{
                const appear = (0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).stars + i * 70, (0, $457b7d299870118f$export$c579116fa63b8535).stars + i * 70 + 500);
                const alpha = appear * (0.28 + 0.42 * (0.5 + 0.5 * Math.sin(t / star.per + star.ph)));
                dot.alpha = alpha;
                arms.forEach((arm)=>arm.alpha = alpha * 0.7);
            });
        }, this.paintWater = (t)=>{
            const span = (0, $457b7d299870118f$export$c579116fa63b8535).water[1] - (0, $457b7d299870118f$export$c579116fa63b8535).water[0] - 400;
            for (const { dash: d, sprite: sprite } of this.water){
                const appear = (0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).water[0] + d.d * span, (0, $457b7d299870118f$export$c579116fa63b8535).water[0] + d.d * span + 400);
                sprite.visible = appear > 0;
                if (!sprite.visible) continue;
                const x = d.x + d.amp * Math.sin(t / d.per + d.ph);
                const len = d.len * (0.85 + 0.15 * Math.sin(t / (d.per * 0.7) + d.ph * 2));
                $731b1cfd7600e971$var$setDash(sprite, x + len / 2, d.y, len, 0.9);
                sprite.alpha = d.a * appear;
            }
            // The moon's path on the water: two glints a row, shimmering.
            const appear = (0, $457b7d299870118f$export$3ab94c50cd824f15)((0, $457b7d299870118f$export$9662278bae91bccc)(t, (0, $457b7d299870118f$export$c579116fa63b8535).moon[1] - 300, (0, $457b7d299870118f$export$c579116fa63b8535).moon[1] + 700));
            for (const { row: row, sprites: sprites } of this.glitter){
                const cx = (0, $457b7d299870118f$export$53f107bf4efd5fa6).x + Math.sin(t / 700 + row.row * 0.9) * 2;
                const alpha = appear * 0.55 * (1 - (row.y - (0, $457b7d299870118f$export$332ee97f731c11be)) / 190);
                sprites.forEach((sprite, j)=>{
                    sprite.visible = alpha > 0;
                    if (!sprite.visible) return;
                    const off = (j ? 0.35 : -0.55) * row.hw + Math.sin(t / 380 + row.row * 1.7 + j * 2) * row.hw * 0.25;
                    const len = row.hw * (0.35 + 0.45 * Math.abs(Math.sin(t / 300 + row.row * 2.3 + j)));
                    $731b1cfd7600e971$var$setDash(sprite, cx + off + len / 2, row.y, len, 1);
                    sprite.alpha = alpha * (j ? 0.8 : 1);
                });
            }
        }, this.paintShip = (t)=>{
            const showing = t >= Math.min((0, $457b7d299870118f$export$c579116fa63b8535).shipInk[0], (0, $457b7d299870118f$export$c579116fa63b8535).rocks[0]);
            this.shipLayer.sprite.visible = showing;
            this.lanternGlow.visible = false;
            this.reflections.forEach((r)=>r.visible = false);
            if (!showing) return;
            const pen = this.shipLayer.pen(true);
            if (!pen) return;
            const st = (0, $cc9dbc1d3afefc0c$export$9683c77eea312b46)(pen, t);
            this.shipLayer.commit();
            const lantern = (0, $457b7d299870118f$export$3dc6026ff9ad2bcf)(st, t);
            if (lantern.lit <= 0) return;
            const fl = lantern.flicker;
            this.lanternGlow.visible = true;
            this.lanternGlow.position.set((0, $457b7d299870118f$export$74231045b68dcd81)(lantern.glow[0]), lantern.glow[1]);
            this.lanternGlow.width = this.lanternGlow.height = 60 * st.s * (1 + 0.7 * lantern.flare);
            this.lanternGlow.alpha = (0.5 * fl + 0.4 * lantern.flare) * lantern.lit;
            const near = st.s / 0.88;
            this.reflections.forEach((sprite, i)=>{
                const y = st.wl + 3 + i * 3.6 * near;
                const hw = (3.4 - i * 0.5) * (0.75 + 0.35 * Math.sin(t / 140 + i * 1.9)) * near;
                const x = lantern.glow[0] + Math.sin(t / 230 + i * 1.3) * 1.4;
                sprite.visible = true;
                $731b1cfd7600e971$var$setDash(sprite, x, y, hw * 2, 1.1);
                sprite.alpha = 0.42 * (1 - i / 5.5) * fl * lantern.lit;
            });
        };
        this.backdrop = backdrop;
        this.startedAt = Date.now() - (atRest ? (0, $2d30638548db1697$export$fd9beec5ba709d96)((0, $457b7d299870118f$export$896f328fde139f45)) : 0);
        this.halo = new (0, $7Bs2Z.Sprite)((0, $92b2c55b1ed94f26$export$c19a1bc36129b4be)());
        this.halo.anchor.set(0.5);
        this.halo.tint = $731b1cfd7600e971$var$MOON_TINT;
        this.halo.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.mist = new (0, $7Bs2Z.Sprite)((0, $92b2c55b1ed94f26$export$c19a1bc36129b4be)());
        this.mist.anchor.set(0.5);
        this.mist.tint = $731b1cfd7600e971$var$MIST_TINT;
        this.mist.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        this.lanternGlow = new (0, $7Bs2Z.Sprite)((0, $92b2c55b1ed94f26$export$c19a1bc36129b4be)());
        this.lanternGlow.anchor.set(0.5);
        this.lanternGlow.tint = $731b1cfd7600e971$var$LANTERN_TINT;
        this.lanternGlow.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
        for(let i = 0; i < 5; i++)this.reflections.push($731b1cfd7600e971$var$dashSprite($731b1cfd7600e971$var$REFLECTION_TINT, true));
        this.world.addChild(this.staticLayer.sprite, this.halo, this.mist, this.starLayer, this.cloudLayer.sprite, this.waterLayer, this.shipLayer.sprite, this.lanternGlow, ...this.reflections);
        this.addChild(this.world);
        this.resize();
        this.tick();
    }
}




/**
 * Without a hand-off (the loading screen was already gone), the wordmark rises in lower down and then
 * slides up: where it starts, and how long the slide takes. A hand-off flies it straight to its place.
 */ const $93842021a2e36862$var$LOGO_DROP = 120;
const $93842021a2e36862$var$LOGO_SLIDE_MS = 630;
/**
 * The card's middle. The wordmark (and the tagline under it) settle above ~150 and the
 * socials/fullscreen chips sit at CHROME_Y, so this centres the card in what is left and lets it grow
 * either way.
 */ const $93842021a2e36862$var$CARD_CENTER_Y = 281;
const $93842021a2e36862$var$CHROME_Y = (0, $f84ce7d40829905e$export$843193d9c9a3c91b) - 40;
/** The height of the chips on the chrome row, which the install hint is centred against. */ const $93842021a2e36862$var$CHIP_H = 34;
/**
 * What an iPhone gets instead of the expand chip. Worth the words: nothing else on the page can
 * put the game edge to edge there, and the player has no reason to guess that the browser's own
 * Share menu is where the fullscreen button went.
 */ const $93842021a2e36862$var$INSTALL_HINT = "Tap Share, then Add to Home Screen, for fullscreen";
/**
 * One line under the wordmark: what the game is about, in the fewest words. It names the loop the
 * player is about to live in -- the fire in the dark -- rather than describing the product.
 */ const $93842021a2e36862$var$TAGLINE = "KEEP THE FIRE ALIVE";
const $93842021a2e36862$var$TAGLINE_GAP = 11;
/** After the slide-up, the tagline waits for the hairline. After a flight the hairline is already out. */ const $93842021a2e36862$var$TAGLINE_DELAY = 380;
class $93842021a2e36862$export$b3c44ac484b3c461 extends (0, $gwPoJ.Graphics) {
    constructor(guiManager){
        super(), this.formRemover = ()=>{
            this.exitMotion?.cancel();
            this.card?.dispose();
            this.card = undefined;
            this.container?.removeChildren();
            this.container?.parent?.removeChild(this.container);
            this.container = undefined;
        }, this.guestLandingRemover = ()=>{
            window.removeEventListener("samsara:canvas-resize", this.resize);
            this.formRemover();
            // Frees the wordmark's canvas rasters and stops its animation frame loop; neither is
            // reclaimed by removeChildren().
            this.logo?.dispose();
            this.logo = undefined;
            // Same for the shipwreck's loop and its canvas textures.
            this.scene?.dispose();
            this.scene = undefined;
            this.taglineMotion?.cancel();
            this.tagline?.destroy({
                texture: true,
                baseTexture: true
            });
            this.tagline = undefined;
            this.landingContainer?.removeChildren();
            this.landingContainer?.parent?.removeChild(this.landingContainer);
            this.socials?.removeChildren();
            this.socials?.parent?.removeChild(this.socials);
        }, /**
     * Show or hide the login form.
     *
     * Not just `container.visible`: the card's fields are real DOM `<input>`s that only follow
     * pixi's visibility from inside a render pass, so hiding the container alone leaves them --
     * and the "Pick a name, or play as a guest" placeholder -- on the page, over whatever screen
     * comes next, until the card is finally disposed. See LoginField.setDomVisible.
     */ this.setFormVisible = (visible)=>{
            if (visible) {
                // Undo a send-off that was in flight: a rejected sign-in brings the card straight back.
                this.exitMotion?.cancel();
                this.exitMotion = undefined;
                if (this.container) {
                    this.container.alpha = 1;
                    this.container.pivot.y = 0;
                }
            }
            if (this.container) this.container.visible = visible;
            this.card?.setDomVisible(visible);
        }, /**
     * The card goes: the form sinks and fades. The DOM fields leave at once -- a real `<input>` cannot
     * fade with the canvas, and one lingering over the next screen is the ghost-placeholder bug.
     */ this.sendOff = ()=>{
            this.card?.setDomVisible(false);
            const container = this.container;
            if (!container) return;
            this.exitMotion?.cancel();
            this.exitMotion = (0, $b0310457bd8276cc$export$dc0b63720788090c)(240, (t)=>{
                container.alpha = 1 - t;
                container.pivot.y = -10 * t;
            }, {
                onDone: ()=>container.visible = false
            });
        }, this.loginSuccess = ()=>{
            this.loggingIn = false;
            this.guestLandingRemover();
        }, /**
     * A rejected sign-in. Returns true when the card took the message inline -- the caller then
     * skips the global screen banner, which used to land across the wordmark.
     */ this.loginFailed = ()=>{
            this.loggingIn = false;
            if (this.card) {
                this.setFormVisible(true);
                this.card.showError("That name and password don't match.");
                return true;
            }
            this.setFormVisible(true);
            return false;
        }, this.init = (doneCallback)=>{
            if (this.loggingIn) return;
            // Jost has to be resolvable before the first Text is built; a pixi Text keeps whatever face
            // it rasterized with. ensureIntroFont never rejects, so a slow CDN-less start still gets a
            // login screen, just in Verdana.
            (0, $f84ce7d40829905e$export$e2b5c7690a313f00)().then(()=>this.build(doneCallback));
        }, /**
     * The hand-off from the HTML loading screen, when it is still up: the loading screen's small
     * "samsara" flies up into the big wordmark while night falls and the shipwreck is drawn in. The
     * HTML backdrop drops away over an identical one painted in pixi, so nothing jumps; its wordmark
     * goes on the frame the pixi letters first move (see loading_handoff.ts).
     *
     * Without a loading screen to take over from -- or for a player who asked for reduced motion --
     * the wordmark makes its own entrance and the scene starts already drawn.
     */ this.build = (doneCallback)=>{
            const landingContainer = new (0, $gwPoJ.Graphics)();
            this.landingContainer = landingContainer;
            // On the stage before anything is measured: the hand-off maps the page into its coordinates.
            this.guiManager.stage.addChild(landingContainer);
            const reduceMotion = (0, $b8d1d91ff2e7f409$export$ff7706047246b98b)();
            const letters = reduceMotion ? undefined : (0, $b8d1d91ff2e7f409$export$390ded33ed101d15)(this.guiManager.stage);
            const handOff = !!letters;
            const scene = new (0, $731b1cfd7600e971$export$d56a52d38c087484)({
                backdrop: handOff ? (0, $b8d1d91ff2e7f409$export$bb7bda02140dee45)(this.guiManager.stage) : undefined,
                atRest: reduceMotion
            });
            this.scene = scene;
            landingContainer.addChild(scene);
            const logo = new (0, $768df19440da6131$export$a1a937f96881772)();
            this.logo = logo;
            const logoX = Math.round(((0, $f84ce7d40829905e$export$bdcdd190e0e471c4) - logo.calcWidth()) / 2);
            const logoY = handOff ? 0 : $93842021a2e36862$var$LOGO_DROP;
            const flight = letters ? {
                from: letters.map((l)=>({
                        x: l.x - logoX,
                        baseline: l.baseline - logoY,
                        size: l.size
                    })),
                onLiftOff: (0, $b8d1d91ff2e7f409$export$d9eb662df70a11ab)
            } : undefined;
            const intro = logo.update(()=>{
                logo.pulse();
                if (!handOff) this.slideLogo(intro);
                this.revealTagline(handOff ? 0 : $93842021a2e36862$var$TAGLINE_DELAY);
                this.container = this.buildLoginContainer(doneCallback);
                this.setFormVisible(false);
                this.guiManager.stage.addChild(this.container);
                this.socials = this.buildSocials(this.guiManager.stage);
                this.resize();
                this.setFormVisible(true);
                this.card?.playEntrance();
            }, flight);
            intro.x = logoX;
            intro.y = logoY;
            this.tagline = this.buildTagline(logo);
            intro.addChild(this.tagline);
            landingContainer.addChild(intro);
            this.resize();
            window.addEventListener("samsara:canvas-resize", this.resize);
            // A frame later, once pixi has drawn the letters (and the backdrop) under the HTML ones.
            requestAnimationFrame(()=>{
                if (!handOff || !(0, $b8d1d91ff2e7f409$export$90ac2b177e966984)()) (0, $b8d1d91ff2e7f409$export$4dabcd056c1d895c)();
            });
        }, /** Resize in place so the logo animation and entered credentials survive orientation changes. */ this.resize = ()=>{
            const viewport = (0, $167efe97b4119a5d$export$b0f20d83cec42115)();
            this.scene?.resize();
            if (this.card) // Keep the desktop card proportions; only the backdrop and edge chrome expand.
            this.card.x = Math.round(((0, $f84ce7d40829905e$export$bdcdd190e0e471c4) - (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).cardWidth) / 2);
            const socials = this.socials?.getChildByName("socials");
            if (socials) {
                socials.x = viewport.left + 12;
                socials.y = $93842021a2e36862$var$CHROME_Y + viewport.insetY;
            }
            const chrome = this.socials?.getChildByName("rightChrome");
            if (chrome) {
                chrome.x = viewport.right - 12 - chrome.width;
                chrome.y = $93842021a2e36862$var$CHROME_Y + viewport.insetY + ($93842021a2e36862$var$CHIP_H - chrome.height) / 2;
            }
        }, /**
     * Ease the wordmark up to its resting place (the old version stepped 1px on a 1ms timer).
     *
     * Expo rather than cubic: it covers most of the distance early and then creeps the last few
     * pixels, which reads as the block settling into place instead of coasting to a stop. No
     * overshoot here -- the wordmark rests at y=0, the top of the screen, so there is nothing above
     * it to spring into. The spring lives in the individual letters, where there is room for it.
     *
     * LOGO_SLIDE_MS is the one dial for how gradual this feels; it is the whole travel time.
     */ this.slideLogo = (intro)=>{
            const started = Date.now();
            const tick = ()=>{
                const t = Math.min(1, (Date.now() - started) / $93842021a2e36862$var$LOGO_SLIDE_MS);
                const eased = t >= 1 ? 1 : 1 - Math.pow(2, -10 * t);
                intro.y = Math.round($93842021a2e36862$var$LOGO_DROP * (1 - eased));
                if (t < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
        }, /**
     * The tagline hangs under the wordmark's hairline, inside the wordmark's own container so it rides
     * the slide up with it. Built hidden; `revealTagline` brings it in once the hairline has drawn.
     */ this.buildTagline = (logo)=>{
            const tagline = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontFamily((0, $f84ce7d40829905e$export$d366e2aaf798d630)).fontSize(11).strokeThickness(0).color((0, $f84ce7d40829905e$export$56d196d2844d1ca1).muted).render((0, $ef882f0a643d87d9$export$dfb0a212724b9d91)($93842021a2e36862$var$TAGLINE));
            tagline.style.fontWeight = "500";
            tagline.x = Math.round((logo.calcWidth() - tagline.width) / 2);
            tagline.y = Math.round(logo.ruleY() + $93842021a2e36862$var$TAGLINE_GAP);
            tagline.alpha = 0;
            return tagline;
        }, this.revealTagline = (delay)=>{
            const tagline = this.tagline;
            if (!tagline) return;
            this.taglineMotion?.cancel();
            this.taglineMotion = (0, $b0310457bd8276cc$export$dc0b63720788090c)(900, (t)=>{
                tagline.alpha = 0.9 * t;
                tagline.pivot.y = -5 * (1 - t);
            }, {
                delay: delay
            });
        }, /** The sign-in card is taller and grows over the tagline; let it step aside while it does. */ this.onCardMode = (mode)=>{
            const tagline = this.tagline;
            if (!tagline) return;
            this.taglineMotion?.cancel();
            const from = tagline.alpha;
            const to = mode === "account" ? 0 : 0.9;
            this.taglineMotion = (0, $b0310457bd8276cc$export$dc0b63720788090c)(220, (t)=>tagline.alpha = from + (to - from) * t);
        }, this.buildLoginContainer = (doneCallback)=>{
            const container = new (0, $8t5Gy.Container)();
            const guestName = "Guest " + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(1, 10000);
            const card = new (0, $19eb09ada16d9b5b$export$25233b7fe55e5696)({
                guestName: guestName,
                centerY: $93842021a2e36862$var$CARD_CENTER_Y,
                onModeChange: this.onCardMode,
                onPlay: (playerName)=>{
                    // A phone can only expand from inside a gesture, and this is the first one that
                    // means "I am playing" -- the taps before it may be aimed at the name field, and
                    // resizing the page out from under an opening soft keyboard is its own mess.
                    (0, $0f29b5a53cc88186$export$1bfbbc26cf37a585)();
                    this.sendOff();
                    setTimeout(()=>doneCallback(playerName), 250);
                },
                onLogin: (username, password)=>{
                    (0, $0f29b5a53cc88186$export$1bfbbc26cf37a585)();
                    this.loggingIn = true;
                    this.sendOff();
                    doneCallback(username, password);
                }
            });
            // y is the card's own business -- it re-centres itself on CARD_CENTER_Y after each layout.
            card.x = Math.round(((0, $f84ce7d40829905e$export$bdcdd190e0e471c4) - (0, $f84ce7d40829905e$export$3f0e99ae6e0ec541).cardWidth) / 2);
            container.addChild(card);
            this.card = card;
            return container;
        }, this.buildSocials = (parent)=>{
            const allContainer = new (0, $gwPoJ.Graphics)();
            if (parent) parent.addChild(allContainer);
            const socialContainer = new (0, $gwPoJ.Graphics)();
            socialContainer.name = "socials";
            socialContainer.x = 12;
            socialContainer.y = $93842021a2e36862$var$CHROME_Y;
            const socialMedia = this.guiManager.socialMedia();
            // socialMedia() positions its own row for the in-game HUD; the intro parks it in a chip.
            socialMedia.y = 0;
            socialMedia.x = 0;
            (0, $f84ce7d40829905e$export$7ac3698ce9457404)(socialContainer, socialMedia.width + 20, 34);
            socialMedia.x = 10;
            socialMedia.y = Math.round((34 - socialMedia.height) / 2);
            socialContainer.addChild(socialMedia);
            allContainer.addChild(socialContainer);
            // The chrome arrives after the card, quietly: it is furniture, not part of the welcome.
            allContainer.alpha = 0;
            (0, $b0310457bd8276cc$export$dc0b63720788090c)(600, (t)=>allContainer.alpha = t, {
                delay: 700
            });
            // No chip where the platform has no fullscreen to give: iPhone, and an embed framed
            // without allowfullscreen. Better an absent control than one that visibly does nothing --
            // but a phone in that position still has Add to Home Screen, so say so rather than leave
            // the corner empty.
            if (!(0, $0f29b5a53cc88186$export$efad50a2596de3ba)()) {
                if ((0, $0f29b5a53cc88186$export$d0667092c1237a4c)()) allContainer.addChild(this.buildInstallHint());
                return allContainer;
            }
            const fullscreenChip = new (0, $gwPoJ.Graphics)();
            fullscreenChip.name = "rightChrome";
            (0, $f84ce7d40829905e$export$7ac3698ce9457404)(fullscreenChip, $93842021a2e36862$var$CHIP_H, $93842021a2e36862$var$CHIP_H);
            fullscreenChip.x = (0, $f84ce7d40829905e$export$bdcdd190e0e471c4) - $93842021a2e36862$var$CHIP_H - 12;
            fullscreenChip.y = $93842021a2e36862$var$CHROME_Y;
            const expandFullScreen = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                name: "fullscreen.png",
                scale: 0.55
            });
            expandFullScreen.x = 17;
            expandFullScreen.y = 17;
            fullscreenChip.addChild(expandFullScreen);
            fullscreenChip.interactive = true;
            fullscreenChip.cursor = "pointer";
            fullscreenChip.on("click", (0, $0f29b5a53cc88186$export$1aba1ee5e6dc1474));
            fullscreenChip.on("tap", (0, $0f29b5a53cc88186$export$1aba1ee5e6dc1474));
            allContainer.addChild(fullscreenChip);
            return allContainer;
        }, /**
     * Plain muted type rather than a chip: a chip reads as a button, and there is nothing here to
     * press -- the control it names belongs to the browser, not to us.
     */ this.buildInstallHint = ()=>{
            const hint = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontFamily((0, $f84ce7d40829905e$export$d366e2aaf798d630)).role("caption").bold(false).color((0, $f84ce7d40829905e$export$56d196d2844d1ca1).muted).render($93842021a2e36862$var$INSTALL_HINT);
            hint.x = Math.round((0, $f84ce7d40829905e$export$bdcdd190e0e471c4) - 12 - hint.width);
            hint.name = "rightChrome";
            hint.y = Math.round($93842021a2e36862$var$CHROME_Y + ($93842021a2e36862$var$CHIP_H - hint.height) / 2);
            return hint;
        };
        this.guiManager = guiManager;
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");


const $6cde84e126c0fae2$var$PROMPT_FIELD_CLASS = "samsara-prompt-field";
let $6cde84e126c0fae2$var$styled = false;
const $6cde84e126c0fae2$var$ensureStyle = ()=>{
    if ($6cde84e126c0fae2$var$styled || typeof document === "undefined") return;
    $6cde84e126c0fae2$var$styled = true;
    const style = document.createElement("style");
    style.textContent = `.${$6cde84e126c0fae2$var$PROMPT_FIELD_CLASS}::placeholder { color: #8f7d62; opacity: 1; }
.${$6cde84e126c0fae2$var$PROMPT_FIELD_CLASS}::-webkit-scrollbar { width: 6px; }
.${$6cde84e126c0fae2$var$PROMPT_FIELD_CLASS}::-webkit-scrollbar-thumb { background: #5a4630; border-radius: 3px; }`;
    document.head.appendChild(style);
};
// Everything a press or a key can raise. All of them stop at the field: the world reads presses off
// the document, and the game's hotkeys read keys there too.
const $6cde84e126c0fae2$var$SWALLOWED = [
    "pointerdown",
    "pointerup",
    "mousedown",
    "mouseup",
    "touchstart",
    "touchend",
    "click",
    "dblclick",
    "contextmenu",
    "wheel",
    "keyup",
    "keypress",
    "paste"
];
class $6cde84e126c0fae2$export$3a76e1252d0bbb0b {
    constructor(props){
        this.props = props;
        this.shownAt = "";
        this.isShown = ()=>this.node?.style.display === "block";
        this.isFocused = ()=>!!this.node && typeof document !== "undefined" && document.activeElement === this.node;
        this.value = ()=>this.node?.value ?? "";
    }
    ensure() {
        if (this.node) return this.node;
        if (typeof document === "undefined") return undefined;
        const node = document.createElement("textarea");
        node.className = $6cde84e126c0fae2$var$PROMPT_FIELD_CLASS;
        node.setAttribute("aria-label", this.props.ariaLabel);
        node.placeholder = this.props.placeholder;
        node.maxLength = this.props.maxLength;
        node.rows = 2;
        node.setAttribute("enterkeyhint", "send");
        node.setAttribute("autocapitalize", "sentences");
        Object.assign(node.style, {
            position: "fixed",
            margin: "0",
            border: "none",
            outline: "none",
            resize: "none",
            background: "transparent",
            color: "#ffedc7",
            caretColor: "#ffd166",
            fontFamily: "Verdana, Geneva, sans-serif",
            lineHeight: "1.3",
            boxSizing: "border-box",
            overflowY: "auto",
            zIndex: "40",
            display: "none"
        });
        $6cde84e126c0fae2$var$ensureStyle();
        node.addEventListener("input", ()=>this.props.onInput(node.value));
        node.addEventListener("keydown", (event)=>{
            event.stopPropagation();
            if (event.key === "Escape") {
                event.preventDefault();
                node.blur();
                return;
            }
            // isComposing: an IME's own Enter confirms a character, it does not send the message.
            if (event.key === "Enter" && !event.shiftKey && !event.isComposing) {
                event.preventDefault();
                this.props.onSubmit();
            }
        });
        for (const name of $6cde84e126c0fae2$var$SWALLOWED)node.addEventListener(name, (event)=>{
            event.stopPropagation();
            if (name === "pointerdown" || name === "mousedown" || name === "touchstart") this.props.onClaimInput?.();
        });
        node.addEventListener("focus", ()=>{
            this.props.suppressGameKeys(true);
            this.props.onClaimInput?.();
            this.props.onFocusChange?.(true);
        });
        node.addEventListener("blur", (event)=>{
            // Focus moving straight into another text field (the chat composer) keeps the keyboard
            // away from the game: that field has already claimed it, and releasing here would undo it.
            const next = event.relatedTarget;
            if (!next || !/^(INPUT|TEXTAREA)$/.test(next.tagName)) this.props.suppressGameKeys(false);
            this.props.onFocusChange?.(false);
        });
        document.body.appendChild(node);
        this.node = node;
        return node;
    }
    /** Put the field over this page rectangle and show it. Style writes only when it moved. */ show(rect, touch = false) {
        const node = this.ensure();
        if (!node) return;
        const key = `${Math.round(rect.left)},${Math.round(rect.top)},${Math.round(rect.width)},${Math.round(rect.height)},${touch}`;
        if (key === this.shownAt && node.style.display === "block") return;
        this.shownAt = key;
        // 16px is the floor iOS zooms a focused field up to; a desktop box too short for two lines of
        // that steps down rather than showing one and a half.
        const fontSize = touch ? 16 : Math.max(11, Math.min(16, Math.floor(rect.height / 2.9)));
        const pad = Math.max(3, Math.round(fontSize * 0.4));
        Object.assign(node.style, {
            display: "block",
            left: `${Math.round(rect.left)}px`,
            top: `${Math.round(rect.top)}px`,
            width: `${Math.round(rect.width)}px`,
            height: `${Math.round(rect.height)}px`,
            fontSize: `${fontSize}px`,
            padding: `${pad}px ${pad + 2}px`
        });
    }
    hide() {
        if (!this.node) return;
        if (this.isFocused()) this.node.blur();
        this.node.style.display = "none";
        this.shownAt = "";
    }
    setValue(value) {
        const node = this.ensure();
        if (node && node.value !== value) {
            node.value = value;
            this.props.onInput(value);
        }
    }
    focus() {
        this.node?.focus();
    }
    blur() {
        if (this.isFocused()) this.node?.blur();
    }
    /** Off the page for good. Nothing else will remove it: it is not in the pixi tree. */ dispose() {
        this.hide();
        this.node?.remove();
        this.node = undefined;
    }
}






const $021a35bc759e48d3$export$f8f8f291b0ba75f3 = 2;
const $021a35bc759e48d3$export$1433d2e405c81609 = 8;
const $021a35bc759e48d3$export$3a89f0ed1a7c44ae = (state)=>state.generationSlots ?? $021a35bc759e48d3$export$f8f8f291b0ba75f3;
const $021a35bc759e48d3$export$38b8831342db17ec = (state)=>state.queueLimit ?? $021a35bc759e48d3$export$1433d2e405c81609;
const $021a35bc759e48d3$export$867b0b35f5a34859 = (ms)=>{
    const total = Math.max(0, Math.floor((Number.isFinite(ms) ? ms : 0) / 1000));
    const seconds = total % 60;
    const minutes = Math.floor(total / 60) % 60;
    const hours = Math.floor(total / 3600);
    const ss = String(seconds).padStart(2, "0");
    return hours > 0 ? `${hours}:${String(minutes).padStart(2, "0")}:${ss}` : `${minutes}:${ss}`;
};
const $021a35bc759e48d3$var$KIND_LABEL = {
    creature: "creature",
    equipment: "equipment"
};
const $021a35bc759e48d3$var$clip = (value, max)=>{
    const flat = value.replace(/\s+/g, " ").trim();
    return flat.length > max ? flat.slice(0, max - 1).trimEnd() + "\u2026" : flat;
};
const $021a35bc759e48d3$export$9a7464b4753a4616 = (job, max = 40)=>{
    if (job.draftId) return $021a35bc759e48d3$var$clip(job.draftId, max);
    if (job.prompt) return $021a35bc759e48d3$var$clip(job.prompt, max);
    return job.mine ? `Your ${$021a35bc759e48d3$var$KIND_LABEL[job.kind]}` : `Another lab's ${$021a35bc759e48d3$var$KIND_LABEL[job.kind]}`;
};
const $021a35bc759e48d3$export$4d8fdc598a722976 = (job)=>job.mine ? "you" : job.player || "";
const $021a35bc759e48d3$export$bc97a6c9ad9ba5da = (job, sinceMs = 0)=>{
    const clock = $021a35bc759e48d3$export$867b0b35f5a34859(job.phaseMs + sinceMs);
    if (job.phase === "generating") return `Drawing ${clock}`;
    if (job.phase === "queued") return job.queuePosition ? `Queued #${job.queuePosition}` : "Queued";
    if (job.phase === "publishing") return `Publishing ${clock}`;
    if (job.phase === "done") return "Live";
    return "Failed";
};
const $021a35bc759e48d3$export$5b66932f01c1f909 = (job)=>job.phase === "generating" || job.phase === "queued" || job.phase === "publishing";
const $021a35bc759e48d3$export$54d4565df8e13037 = (state, prompt, pending = false)=>{
    if (!state) return "Not in a SpriteLab room";
    if (!state.available) return "Publishing is unavailable on this server";
    if (pending) return "Sending\u2026";
    if (state.ownPhase) return "Your make is still in progress";
    if (state.generating >= $021a35bc759e48d3$export$3a89f0ed1a7c44ae(state)) return "Both generation slots are busy";
    if (state.generating + state.queued + state.publishing >= $021a35bc759e48d3$export$38b8831342db17ec(state)) return "The publication queue is full";
    if (!prompt.trim()) return "Describe what to make";
    return null;
};
const $021a35bc759e48d3$export$86ced59c2582b3de = (state, sinceMs = 0)=>{
    const own = state.jobs?.find((job)=>job.mine && $021a35bc759e48d3$export$5b66932f01c1f909(job));
    if (own) return $021a35bc759e48d3$export$bc97a6c9ad9ba5da(own, sinceMs);
    // Short enough for the folded header: drawing is what holds the slots; the rest is just waiting its turn.
    const waiting = state.queued + state.publishing;
    if (state.generating) return waiting ? `${state.generating} drawing \xb7 ${waiting} more` : `${state.generating} drawing`;
    if (state.publishing) return state.queued ? `Publishing \xb7 ${state.queued} queued` : "Publishing";
    if (state.queued) return `${state.queued} queued`;
    const recent = state.jobs?.find((job)=>job.mine && !$021a35bc759e48d3$export$5b66932f01c1f909(job));
    if (recent) return recent.phase === "done" ? "Your make is live" : "Your make failed";
    return "Idle";
};
const $021a35bc759e48d3$export$fba9605fc9710e5b = (state)=>!!state && state.generating + state.queued + state.publishing > 0;
const $021a35bc759e48d3$export$a5908e4e63b0bea7 = (id)=>id.replace(/^lab-/, "");
const $021a35bc759e48d3$export$7804ac8eb5cfa918 = (total, perPage)=>Math.max(1, Math.ceil(total / Math.max(1, perPage)));
const $021a35bc759e48d3$export$37065cd88a320a11 = (page, total, perPage)=>Math.max(0, Math.min(page, $021a35bc759e48d3$export$7804ac8eb5cfa918(total, perPage) - 1));


const $c6aea3ca9a48e675$export$7bd4e97e64a27f7e = 244;
const $c6aea3ca9a48e675$var$BAND = 3 // the timber band around the face
;
const $c6aea3ca9a48e675$var$CHAMFER = 7;
const $c6aea3ca9a48e675$var$PAD = 11 // face content inset from the panel edge
;
const $c6aea3ca9a48e675$var$INNER_W = $c6aea3ca9a48e675$export$7bd4e97e64a27f7e - $c6aea3ca9a48e675$var$PAD * 2;
const $c6aea3ca9a48e675$var$HEADER_H = 24;
const $c6aea3ca9a48e675$var$KIND_H = 18;
const $c6aea3ca9a48e675$var$PROMPT_H = 42;
const $c6aea3ca9a48e675$var$ACTION_H = 20;
const $c6aea3ca9a48e675$var$GENERATE_W = 82;
const $c6aea3ca9a48e675$var$SECTION_H = 12;
const $c6aea3ca9a48e675$var$ROW_H = 18;
const $c6aea3ca9a48e675$var$MAX_QUEUE_ROWS = 5;
const $c6aea3ca9a48e675$var$CREATION_ROWS = 3;
const $c6aea3ca9a48e675$var$CREATION_ROW_H = 20;
const $c6aea3ca9a48e675$var$SPAWN_W = 44;
const $c6aea3ca9a48e675$var$LEAVE_W = 64;
const $c6aea3ca9a48e675$var$FOOTER_H = 16;
const $c6aea3ca9a48e675$var$GAP = 6;
// ---- colours: build_board's, plus the two outcomes ---------------------------------------------
const $c6aea3ca9a48e675$var$HEADER_FACE = 0x241a11;
const $c6aea3ca9a48e675$var$TITLE = 0xf3d9a4;
const $c6aea3ca9a48e675$var$LABEL = 0xd9b483;
const $c6aea3ca9a48e675$var$INK_DIM = 0xcbb49a;
const $c6aea3ca9a48e675$var$PUBLISH = 0xf28c4e;
const $c6aea3ca9a48e675$var$LIVE = 0x9bd47e;
const $c6aea3ca9a48e675$var$FAILED = 0xe8745a;
const $c6aea3ca9a48e675$var$MINE_FACE = 0x2a1f12;
const $c6aea3ca9a48e675$var$PROMPT_MAX = 4000;
const $c6aea3ca9a48e675$var$KIND_ICON = {
    creature: "paw",
    equipment: "shield"
};
const $c6aea3ca9a48e675$var$ENTRY_ICON = {
    creature: "paw",
    item: "sack",
    entity: "tent"
};
const $c6aea3ca9a48e675$var$label = (value, size, color, bold = false)=>new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(size).bold(bold).color(color).strokeThickness(0).render(value);
const $c6aea3ca9a48e675$var$caps = (value, size, color, spacing = 1.4)=>{
    const t = $c6aea3ca9a48e675$var$label(value.toUpperCase(), size, color, true);
    t.style.letterSpacing = spacing;
    return t;
};
const $c6aea3ca9a48e675$var$drawPaw = (g)=>{
    g.lineStyle(0).beginFill(0xffffff, 1);
    g.drawEllipse(0, 4.5, 6.2, 5);
    for (const [x, y] of [
        [
            -7.4,
            -2.6
        ],
        [
            -2.8,
            -7.6
        ],
        [
            2.8,
            -7.6
        ],
        [
            7.4,
            -2.6
        ]
    ])g.drawCircle(x, y, 2.9);
    g.endFill();
};
const $c6aea3ca9a48e675$var$glyph = (icon, size, color)=>{
    const g = new (0, $gwPoJ.Graphics)();
    if (icon === "paw") $c6aea3ca9a48e675$var$drawPaw(g);
    else (0, $ec5c35dbffc1f325$export$8674a23a9be99236)(g, icon);
    g.scale.set(size / (0, $ec5c35dbffc1f325$export$2bd980d3c871717d));
    g.tint = color;
    return g;
};
// pixi adds the letter spacing after the last glyph too; centring by width alone sits a word right.
const $c6aea3ca9a48e675$var$inkWidth = (t)=>Math.max(0, t.width - (Number(t.style.letterSpacing) || 0));
/** Set `value`, cut with an ellipsis to fit `max` measured pixels. Cosmetic: never allowed to throw. */ const $c6aea3ca9a48e675$var$fitText = (t, value, max)=>{
    t.text = value;
    try {
        if (!(max > 0) || t.width <= max) return;
        let lo = 0;
        let hi = value.length;
        while(lo < hi){
            const mid = lo + hi + 1 >> 1;
            t.text = value.slice(0, mid).trimEnd() + "\u2026";
            if (t.width <= max) lo = mid;
            else hi = mid - 1;
        }
        t.text = value.slice(0, lo).trimEnd() + "\u2026";
    } catch  {
        t.text = value;
    }
};
/** A small carved-plate control drawn by hand: a toggle segment, a tab, a pager arrow. */ class $c6aea3ca9a48e675$var$Plate extends (0, $8t5Gy.Container) {
    constructor(w, h, onPress, c = 3){
        super(), this.w = w, this.h = h, this.onPress = onPress, this.c = c, this.face = new (0, $gwPoJ.Graphics)(), this.hovered = false, this.enabled = true, this.selected = false, this.press = ()=>{
            if (this.enabled) this.onPress();
        };
        this.addChild(this.face);
        this.interactive = true;
        this.cursor = "pointer";
        this.hitArea = {
            contains: (x, y)=>x >= -2 && y >= -2 && x <= this.w + 2 && y <= this.h + 2
        };
        this.on("pointerover", ()=>{
            this.hovered = true;
            this.draw();
        });
        this.on("pointerout", ()=>{
            this.hovered = false;
            this.draw();
        });
        this.on("pointerdown", (event)=>event.stopPropagation());
        this.on("pointertap", (event)=>{
            event.stopPropagation();
            if (this.enabled) this.onPress();
        });
        this.draw();
    }
    setSelected(selected) {
        if (selected === this.selected) return;
        this.selected = selected;
        this.draw();
    }
    setEnabled(enabled) {
        if (enabled === this.enabled) return;
        this.enabled = enabled;
        this.cursor = enabled ? "pointer" : "default";
        this.alpha = enabled ? 1 : 0.4;
        this.draw();
    }
    draw() {
        const g = this.face;
        const lit = this.selected;
        g.clear();
        if (lit) {
            g.lineStyle({
                width: 3,
                color: (0, $658a44ce960354bb$export$319b6132a2fafb7c),
                alpha: 0.12,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 0, 0, this.w, this.h, this.c);
        }
        g.lineStyle({
            width: 1,
            color: lit ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : this.hovered && this.enabled ? (0, $658a44ce960354bb$export$dd27ce85ad53c944) : (0, $658a44ce960354bb$export$f0510412e0d12cd1),
            alpha: lit ? 0.95 : 0.85,
            join: (0, $gwPoJ.LINE_JOIN).MITER
        });
        g.beginFill(lit ? (0, $658a44ce960354bb$export$82dbffd75f7d6df3) : this.hovered && this.enabled ? 0x1c160f : (0, $658a44ce960354bb$export$f73e3f59ba72192a), lit ? 0.98 : 0.9);
        (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 0.5, 0.5, this.w - 1, this.h - 1, this.c);
        g.endFill();
        g.lineStyle(0);
    }
}
class $c6aea3ca9a48e675$export$8912876716d2e56c extends (0, $8t5Gy.Container) {
    constructor(handlers){
        super(), this.handlers = handlers, this.plate = new (0, $gwPoJ.Graphics)(), this.header = new (0, $gwPoJ.Graphics)(), this.headerSpinner = new (0, $gwPoJ.Graphics)(), this.foldGlyph = new (0, $gwPoJ.Graphics)(), this.body = new (0, $8t5Gy.Container)(), this.promptSocket = new (0, $gwPoJ.Graphics)(), this.queueRule = new (0, $gwPoJ.Graphics)(), this.slotPips = new (0, $gwPoJ.Graphics)(), this.queueLayer = new (0, $8t5Gy.Container)(), this.queueRows = [], this.creationsChevron = new (0, $gwPoJ.Graphics)(), this.creationsLayer = new (0, $8t5Gy.Container)(), this.creationRows = [], this.state = null, this.stateAgeMs = 0, this.kind = "creature", this.prompt = "", this.pendingMake = false, this.pendingMs = 0, this.minimized = false, this.creationsOpen = false, this.page = 0, this.queueKey = "", this.creationsKey = "", this.messageMs = 0, this.panelHeight = 0, this.clockTick = 0, this.spin = 0, this.fieldCheckMs = 0, this.fieldFocused = false, this.grabbed = false, this.grabDx = 0, this.grabDy = 0, this.grabX = 0, this.grabY = 0, this.dragged = false, this.// ---- public surface -------------------------------------------------------------------------
        update = (state, message)=>{
            const roomChanged = this.state?.roomId !== state?.roomId;
            this.state = state;
            this.stateAgeMs = 0;
            this.visible = !!state;
            if (!state) {
                this.pendingMake = false;
                this.field.hide();
                this.setMessage("");
                return;
            }
            if (roomChanged) this.setMessage("");
            if (message) this.setMessage(message);
            if (this.pendingMake && (state.ownPhase || message)) {
                this.pendingMake = false;
                // Taken: the job exists now, so the description has done its work. Refused: keep it for a retry.
                if (state.ownPhase) this.setPrompt("");
            }
            this.refreshHeader();
            this.refreshQueue();
            this.refreshCreations();
            this.refreshAction();
            this.layout();
        }, this.animate = (dtMs)=>{
            if (!this.visible || !this.state) return;
            const dt = Math.max(0, Math.min(250, Number.isFinite(dtMs) ? dtMs : 0));
            this.stateAgeMs += dt;
            this.spin = (this.spin + dt * 0.0062) % (Math.PI * 2);
            this.headerSpinner.rotation = this.spin;
            for (const row of this.queueRows){
                if (row.job.phase === "generating") row.icon.rotation = this.spin;
                else if (row.job.phase === "publishing") row.icon.rotation = this.spin * 1.6;
                else if (row.job.phase === "queued") row.icon.alpha = 0.55 + 0.45 * (0.5 + 0.5 * Math.sin(this.spin * 2));
            }
            // The clocks move once a second; re-rasterising text every frame would be waste.
            this.clockTick += dt;
            if (this.clockTick >= 500) {
                this.clockTick = 0;
                this.refreshClocks();
            }
            if (this.messageMs > 0) {
                this.messageMs -= dt;
                this.message.alpha = Math.max(0, Math.min(1, this.messageMs / 1500));
                if (this.messageMs <= 0) this.setMessage("");
            }
            if (this.pendingMake) {
                this.pendingMs -= dt;
                if (this.pendingMs <= 0) {
                    this.pendingMake = false;
                    this.refreshAction();
                }
            }
            this.fieldCheckMs -= dt;
            if (this.fieldCheckMs <= 0) {
                this.fieldCheckMs = 200;
                this.placeField();
            }
        }, this.isMinimized = ()=>this.minimized, this.isCreationsOpen = ()=>this.creationsOpen, this.getWidth = ()=>$c6aea3ca9a48e675$export$7bd4e97e64a27f7e * this.scale.x, this.getHeight = ()=>this.panelHeight * this.scale.y, this.setMinimized = (minimized)=>{
            if (minimized === this.minimized) return;
            this.minimized = minimized;
            if (minimized) this.field.blur();
            this.refreshHeader();
            this.layout();
        }, this.toggleMinimized = ()=>{
            this.setMinimized(!this.minimized);
            this.handlers.onLayoutChange();
        }, this.setCreationsOpen = (open)=>{
            if (open === this.creationsOpen) return;
            this.creationsOpen = open;
            this.refreshCreations();
            this.layout();
            this.handlers.onLayoutChange();
        }, this.selectKind = (kind)=>{
            this.kind = kind;
            this.kindPlates.creature.setSelected(kind === "creature");
            this.kindPlates.equipment.setSelected(kind === "equipment");
        }, this.getKind = ()=>this.kind, this./** Type into the description, as the DOM field would. */ setPrompt = (value)=>{
            this.field.setValue(value);
            this.prompt = value;
            this.refreshAction();
        }, this.generate = ()=>{
            const prompt = this.prompt.trim();
            if ((0, $021a35bc759e48d3$export$54d4565df8e13037)(this.state, prompt, this.pendingMake)) return;
            this.pendingMake = true;
            this.pendingMs = 10000;
            this.handlers.onClaimInput();
            this.handlers.onRequest({
                action: "make",
                kind: this.kind,
                prompt: prompt
            });
            this.refreshAction();
        }, this.spawn = (entry)=>{
            this.handlers.onClaimInput();
            this.handlers.onRequest({
                action: "spawn",
                kind: entry.kind,
                id: entry.id
            });
        }, this.leave = ()=>{
            this.handlers.onClaimInput();
            this.field.blur();
            this.handlers.onRequest({
                action: "leave"
            });
        }, this.isGenerateEnabled = ()=>!(0, $021a35bc759e48d3$export$54d4565df8e13037)(this.state, this.prompt, this.pendingMake), this.getHint = ()=>this.hint.text, this.getActivity = ()=>this.activity.text, this.getMessage = ()=>this.message.text, this./** Each queue row as "title · owner — status", for a caller outside the display tree. */ getQueueLines = ()=>this.queueRows.map((row)=>{
                const owner = (0, $021a35bc759e48d3$export$4d8fdc598a722976)(row.job);
                return `${(0, $021a35bc759e48d3$export$9a7464b4753a4616)(row.job)}${owner ? ` \xb7 ${owner}` : ""} \u{2014} ${row.statusText}`;
            }), this.getVisibleCreations = ()=>this.creationsOpen ? this.pageEntries() : [], this./** Keep the panel legible on a phone without letting it swallow the screen. */ fitToViewport = ()=>{
            const metrics = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)();
            const scale = metrics.touch ? Math.max(1, Math.min(1.6, 1.6 / Math.min(metrics.scaleX, metrics.scaleY), (metrics.safeViewport.width - 16) / $c6aea3ca9a48e675$export$7bd4e97e64a27f7e)) : 1;
            if (scale !== this.scale.x) {
                this.scale.set(scale);
                this.handlers.onLayoutChange();
            }
        }, this.dispose = ()=>{
            this.field.dispose();
        }, this.onGrab = (event)=>{
            if (!this.parent) return;
            this.handlers.onClaimInput();
            const pointer = event.data.getLocalPosition(this.parent);
            this.grabDx = this.x - pointer.x;
            this.grabDy = this.y - pointer.y;
            this.grabX = pointer.x;
            this.grabY = pointer.y;
            this.grabbed = true;
            this.dragged = false;
            this.header.cursor = "grabbing";
            this.handlers.onGrab();
        }, this.onDragMove = (event)=>{
            if (!this.grabbed || !this.parent) return;
            const pointer = event.data.getLocalPosition(this.parent);
            // A press that wanders a pixel or two is still a tap.
            if (!this.dragged && Math.hypot(pointer.x - this.grabX, pointer.y - this.grabY) < 4) return;
            this.dragged = true;
            this.handlers.onDragTo(pointer.x + this.grabDx, pointer.y + this.grabDy);
            this.fieldCheckMs = 0;
        }, this.onRelease = ()=>{
            if (!this.grabbed) return;
            this.grabbed = false;
            this.header.cursor = "grab";
            // Tapping a folded header opens it: on a phone the header is a far bigger target than the button.
            if (!this.dragged && this.minimized) this.toggleMinimized();
            this.handlers.onRelease();
        };
        this.plate.interactive = true;
        this.plate.on("pointerdown", ()=>this.handlers.onClaimInput());
        this.addChild(this.plate, this.header);
        this.spark = $c6aea3ca9a48e675$var$glyph("spark", 13, (0, $658a44ce960354bb$export$319b6132a2fafb7c));
        this.title = $c6aea3ca9a48e675$var$caps("Sprite Lab", 10, $c6aea3ca9a48e675$var$TITLE, 1.6);
        this.activity = $c6aea3ca9a48e675$var$label("", 9, $c6aea3ca9a48e675$var$INK_DIM);
        this.foldButton = new $c6aea3ca9a48e675$var$Plate(18, 16, ()=>this.toggleMinimized());
        this.foldButton.addChild(this.foldGlyph);
        this.addChild(this.spark, this.title, this.headerSpinner, this.activity, this.foldButton);
        this.header.interactive = true;
        this.header.cursor = "grab";
        this.header.on("pointerdown", this.onGrab);
        this.interactive = true;
        this.on("pointermove", this.onDragMove);
        this.on("pointerup", this.onRelease);
        this.on("pointerupoutside", this.onRelease);
        const kindW = ($c6aea3ca9a48e675$var$INNER_W - 4) / 2;
        this.kindPlates = {
            creature: this.kindPlate("creature", "Creature", kindW),
            equipment: this.kindPlate("equipment", "Equipment", kindW)
        };
        this.kindPlates.equipment.x = kindW + 4;
        const kinds = new (0, $8t5Gy.Container)();
        kinds.addChild(this.kindPlates.creature, this.kindPlates.equipment);
        kinds.name = "kinds";
        this.hint = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(8).color((0, $658a44ce960354bb$export$c48687f662ce7e97)).strokeThickness(0).wordWrap($c6aea3ca9a48e675$var$INNER_W - $c6aea3ca9a48e675$var$GENERATE_W - 8).render("");
        this.generateButton = new (0, $ead1577967896e68$export$d714cb42a300e44f)({
            label: "Generate",
            onClick: ()=>this.generate(),
            theme: "ember",
            shape: "chamfer",
            tone: "accent",
            accent: (0, $658a44ce960354bb$export$319b6132a2fafb7c),
            size: "small",
            width: $c6aea3ca9a48e675$var$GENERATE_W,
            height: $c6aea3ca9a48e675$var$ACTION_H,
            fontSize: 10,
            bold: true,
            hitPadding: 2
        });
        this.queueTitle = $c6aea3ca9a48e675$var$caps("Queue", 8, $c6aea3ca9a48e675$var$LABEL);
        this.slotsLabel = $c6aea3ca9a48e675$var$label("slots", 8, (0, $658a44ce960354bb$export$c48687f662ce7e97));
        this.queueEmpty = $c6aea3ca9a48e675$var$label("Nothing cooking. Describe something above.", 8, (0, $658a44ce960354bb$export$c48687f662ce7e97));
        this.queueOverflow = $c6aea3ca9a48e675$var$label("", 8, (0, $658a44ce960354bb$export$c48687f662ce7e97));
        this.creationsHeader = new $c6aea3ca9a48e675$var$Plate($c6aea3ca9a48e675$var$INNER_W, 16, ()=>this.setCreationsOpen(!this.creationsOpen));
        this.creationsTitle = $c6aea3ca9a48e675$var$caps("Creations", 8, $c6aea3ca9a48e675$var$LABEL);
        this.creationsCount = $c6aea3ca9a48e675$var$label("", 8, (0, $658a44ce960354bb$export$c48687f662ce7e97));
        this.creationsHeader.addChild(this.creationsChevron, this.creationsTitle, this.creationsCount);
        this.pagePrev = new $c6aea3ca9a48e675$var$Plate(14, 12, ()=>this.turnPage(-1), 2);
        this.pageNext = new $c6aea3ca9a48e675$var$Plate(14, 12, ()=>this.turnPage(1), 2);
        this.pagePrev.addChild(this.arrow(-1));
        this.pageNext.addChild(this.arrow(1));
        this.pageLabel = $c6aea3ca9a48e675$var$label("", 8, $c6aea3ca9a48e675$var$INK_DIM);
        this.creationsEmpty = $c6aea3ca9a48e675$var$label("Nothing made yet. Published creations appear here.", 8, (0, $658a44ce960354bb$export$c48687f662ce7e97));
        this.message = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().fontSize(8).color($c6aea3ca9a48e675$var$INK_DIM).strokeThickness(0).wordWrap($c6aea3ca9a48e675$var$INNER_W - $c6aea3ca9a48e675$var$LEAVE_W - 8).render("");
        this.leaveButton = new (0, $ead1577967896e68$export$d714cb42a300e44f)({
            label: "Leave lab",
            onClick: ()=>this.leave(),
            theme: "ember",
            shape: "chamfer",
            appearance: "outline",
            size: "extraSmall",
            width: $c6aea3ca9a48e675$var$LEAVE_W,
            height: $c6aea3ca9a48e675$var$FOOTER_H,
            fontSize: 8,
            textColor: $c6aea3ca9a48e675$var$INK_DIM,
            hitPadding: 2
        });
        this.body.addChild(kinds, this.promptSocket, this.hint, this.generateButton, this.queueRule, this.queueTitle, this.slotsLabel, this.slotPips, this.queueLayer, this.queueEmpty, this.queueOverflow, this.creationsHeader, this.pagePrev, this.pageLabel, this.pageNext, this.creationsLayer, this.creationsEmpty, this.message, this.leaveButton);
        this.addChild(this.body);
        this.field = new (0, $6cde84e126c0fae2$export$3a76e1252d0bbb0b)({
            placeholder: "A tiny blue dragon with golden horns\u2026",
            ariaLabel: "Describe what SpriteLab should make",
            maxLength: $c6aea3ca9a48e675$var$PROMPT_MAX,
            onInput: (value)=>{
                this.prompt = value;
                this.refreshAction();
            },
            onSubmit: ()=>this.generate(),
            onClaimInput: ()=>this.handlers.onClaimInput(),
            suppressGameKeys: (suppressed)=>this.handlers.suppressGameKeys(suppressed)
        });
        this.visible = false;
        this.selectKind("creature");
        this.layout();
    }
    // ---- content --------------------------------------------------------------------------------
    kindPlate(kind, name, w) {
        const plate = new $c6aea3ca9a48e675$var$Plate(w, $c6aea3ca9a48e675$var$KIND_H, ()=>this.selectKind(kind));
        const icon = $c6aea3ca9a48e675$var$glyph($c6aea3ca9a48e675$var$KIND_ICON[kind], 10, (0, $658a44ce960354bb$export$8eb3a98fbc1bd246));
        const text = $c6aea3ca9a48e675$var$caps(name, 8, (0, $658a44ce960354bb$export$8eb3a98fbc1bd246), 1.2);
        const total = 15 + $c6aea3ca9a48e675$var$inkWidth(text);
        icon.position.set((w - total) / 2 + 5, $c6aea3ca9a48e675$var$KIND_H / 2);
        text.position.set((w - total) / 2 + 15, Math.round(($c6aea3ca9a48e675$var$KIND_H - text.height) / 2));
        plate.addChild(icon, text);
        return plate;
    }
    arrow(direction) {
        const g = new (0, $gwPoJ.Graphics)();
        g.lineStyle({
            width: 1.5,
            color: (0, $658a44ce960354bb$export$8eb3a98fbc1bd246),
            alpha: 0.9,
            cap: (0, $gwPoJ.LINE_CAP).ROUND,
            join: (0, $gwPoJ.LINE_JOIN).ROUND
        });
        g.moveTo(7 - direction * 1.5, 3).lineTo(7 + direction * 1.5, 6).lineTo(7 - direction * 1.5, 9);
        return g;
    }
    setMessage(text) {
        this.message.text = text;
        this.message.alpha = 1;
        // Long enough to read a failure twice; the queue row carries the lasting state.
        this.messageMs = text ? 20000 : 0;
        if (!text) this.layout();
    }
    refreshHeader() {
        const state = this.state;
        const busy = (0, $021a35bc759e48d3$export$fba9605fc9710e5b)(state);
        this.headerSpinner.visible = busy;
        // Expanded, the queue below says it all; the spinner alone marks that something is cooking.
        const text = state && this.minimized ? (0, $021a35bc759e48d3$export$86ced59c2582b3de)(state, this.stateAgeMs) : "";
        if (this.activity.text !== text) this.activity.text = text;
        this.drawFoldGlyph();
    }
    refreshClocks() {
        for (const row of this.queueRows){
            const status = (0, $021a35bc759e48d3$export$bc97a6c9ad9ba5da)(row.job, this.stateAgeMs);
            if (status !== row.statusText) {
                row.statusText = status;
                row.status.text = status;
                row.status.x = $c6aea3ca9a48e675$var$INNER_W - 4 - row.status.width;
            }
        }
        if (this.minimized) {
            const before = this.activity.text;
            this.refreshHeader();
            if (before !== this.activity.text) this.layoutHeader();
        }
    }
    refreshAction() {
        const blocker = (0, $021a35bc759e48d3$export$54d4565df8e13037)(this.state, this.prompt, this.pendingMake);
        this.generateButton.setEnabled(!blocker);
        const hint = blocker && blocker !== "Describe what to make" ? blocker : (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().touch ? "Tap Generate when ready" : "Press Enter to generate";
        if (this.hint.text !== hint) this.hint.text = hint;
        this.hint.tint = blocker && blocker !== "Describe what to make" ? 0xe9b26a : (0, $658a44ce960354bb$export$c48687f662ce7e97);
    }
    refreshQueue() {
        const jobs = this.state?.jobs ?? [];
        const key = JSON.stringify(jobs.map((job)=>[
                job.id,
                job.phase,
                job.draftId,
                job.queuePosition,
                job.mine,
                job.player
            ]));
        if (key === this.queueKey) {
            // Same rows; only the clocks moved. Re-seat them on the server's measurement.
            this.queueRows.forEach((row)=>{
                row.job = jobs.find((job)=>job.id === row.job.id) || row.job;
            });
            this.refreshClocks();
            return;
        }
        this.queueKey = key;
        for (const row of this.queueRows)row.container.destroy({
            children: true,
            texture: true,
            baseTexture: true
        });
        this.queueRows = [];
        const shown = jobs.slice(0, $c6aea3ca9a48e675$var$MAX_QUEUE_ROWS);
        shown.forEach((job, index)=>{
            const row = this.buildQueueRow(job);
            row.container.y = index * $c6aea3ca9a48e675$var$ROW_H;
            this.queueLayer.addChild(row.container);
            this.queueRows.push(row);
        });
        this.queueEmpty.visible = shown.length === 0;
        const overflow = jobs.length - shown.length;
        this.queueOverflow.text = overflow > 0 ? `+${overflow} more` : "";
        this.queueOverflow.visible = overflow > 0;
        this.drawSlotPips();
    }
    buildQueueRow(job) {
        const container = new (0, $8t5Gy.Container)();
        const back = new (0, $gwPoJ.Graphics)();
        if (job.mine) {
            back.lineStyle({
                width: 1,
                color: (0, $658a44ce960354bb$export$319b6132a2fafb7c),
                alpha: 0.28,
                join: (0, $gwPoJ.LINE_JOIN).MITER
            });
            back.beginFill($c6aea3ca9a48e675$var$MINE_FACE, 0.9);
            (0, $658a44ce960354bb$export$99dca9ebbafa6899)(back, -3, 1, $c6aea3ca9a48e675$var$INNER_W + 6, $c6aea3ca9a48e675$var$ROW_H - 2, 3);
            back.endFill();
        }
        const icon = this.jobIcon(job);
        icon.position.set(5, $c6aea3ca9a48e675$var$ROW_H / 2);
        const status = $c6aea3ca9a48e675$var$label((0, $021a35bc759e48d3$export$bc97a6c9ad9ba5da)(job, this.stateAgeMs), 8, job.phase === "failed" ? $c6aea3ca9a48e675$var$FAILED : job.phase === "done" ? $c6aea3ca9a48e675$var$LIVE : job.phase === "publishing" ? $c6aea3ca9a48e675$var$PUBLISH : job.mine ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : $c6aea3ca9a48e675$var$INK_DIM, job.mine);
        status.x = $c6aea3ca9a48e675$var$INNER_W - 4 - status.width;
        status.y = Math.round(($c6aea3ca9a48e675$var$ROW_H - status.height) / 2);
        const owner = (0, $021a35bc759e48d3$export$4d8fdc598a722976)(job);
        const ownerText = $c6aea3ca9a48e675$var$label(owner ? `\xb7 ${owner}` : "", 8, (0, $658a44ce960354bb$export$c48687f662ce7e97));
        const title = $c6aea3ca9a48e675$var$label("", 9, job.mine ? (0, $658a44ce960354bb$export$8eb3a98fbc1bd246) : $c6aea3ca9a48e675$var$INK_DIM, job.mine);
        const titleMax = $c6aea3ca9a48e675$var$INNER_W - 18 - status.width - 10 - (owner ? Math.min(60, ownerText.width) + 4 : 0);
        $c6aea3ca9a48e675$var$fitText(title, (0, $021a35bc759e48d3$export$9a7464b4753a4616)(job), titleMax);
        title.position.set(14, Math.round(($c6aea3ca9a48e675$var$ROW_H - title.height) / 2));
        $c6aea3ca9a48e675$var$fitText(ownerText, owner ? `\xb7 ${owner}` : "", 60);
        ownerText.position.set(title.x + title.width + 4, Math.round(($c6aea3ca9a48e675$var$ROW_H - ownerText.height) / 2) + 0.5);
        ownerText.visible = !!owner;
        container.addChild(back, icon, title, ownerText, status);
        return {
            job: job,
            container: container,
            icon: icon,
            status: status,
            statusText: status.text
        };
    }
    /** A spinner while the Lab is drawing or the server publishing, a breathing ring in the queue, then the outcome. */ jobIcon(job) {
        const g = new (0, $gwPoJ.Graphics)();
        const r = 4.6;
        if (job.phase === "done") {
            g.lineStyle({
                width: 1.8,
                color: $c6aea3ca9a48e675$var$LIVE,
                alpha: 1,
                cap: (0, $gwPoJ.LINE_CAP).ROUND,
                join: (0, $gwPoJ.LINE_JOIN).ROUND
            });
            g.moveTo(-3.4, 0.2).lineTo(-1, 2.8).lineTo(3.6, -2.6);
            return g;
        }
        if (job.phase === "failed") {
            g.lineStyle({
                width: 1.8,
                color: $c6aea3ca9a48e675$var$FAILED,
                alpha: 1,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            g.moveTo(-2.8, -2.8).lineTo(2.8, 2.8).moveTo(2.8, -2.8).lineTo(-2.8, 2.8);
            return g;
        }
        if (job.phase === "queued") {
            g.lineStyle({
                width: 1.2,
                color: (0, $658a44ce960354bb$export$6b1db5e247c0ce0),
                alpha: 0.75
            });
            g.drawCircle(0, 0, r - 0.6);
            g.lineStyle(0).beginFill((0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.9).drawCircle(0, 0, 1.4).endFill();
            return g;
        }
        this.drawSpinner(g, r, job.phase === "publishing" ? $c6aea3ca9a48e675$var$PUBLISH : (0, $658a44ce960354bb$export$319b6132a2fafb7c));
        return g;
    }
    drawSpinner(g, r, color) {
        g.clear();
        g.lineStyle({
            width: 1.6,
            color: color,
            alpha: 0.18
        });
        g.drawCircle(0, 0, r);
        g.lineStyle({
            width: 1.8,
            color: color,
            alpha: 1,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        g.moveTo(r, 0);
        g.arc(0, 0, r, 0, Math.PI * 1.35);
    }
    drawSlotPips() {
        const g = this.slotPips;
        g.clear();
        const state = this.state;
        if (!state) return;
        const slots = (0, $021a35bc759e48d3$export$3a89f0ed1a7c44ae)(state);
        for(let i = 0; i < slots; i++){
            const used = i < state.generating;
            const x = -i * 9;
            g.lineStyle({
                width: 1,
                color: used ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : (0, $658a44ce960354bb$export$f0510412e0d12cd1),
                alpha: 1
            });
            g.beginFill(used ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : (0, $658a44ce960354bb$export$f73e3f59ba72192a), used ? 0.95 : 1);
            g.drawCircle(x, 0, 3);
            g.endFill();
        }
        g.lineStyle(0);
    }
    entries() {
        return this.state?.entries ?? [];
    }
    pageEntries() {
        const entries = this.entries();
        this.page = (0, $021a35bc759e48d3$export$37065cd88a320a11)(this.page, entries.length, $c6aea3ca9a48e675$var$CREATION_ROWS);
        return entries.slice(this.page * $c6aea3ca9a48e675$var$CREATION_ROWS, this.page * $c6aea3ca9a48e675$var$CREATION_ROWS + $c6aea3ca9a48e675$var$CREATION_ROWS);
    }
    turnPage(step) {
        const total = this.entries().length;
        const next = (0, $021a35bc759e48d3$export$37065cd88a320a11)(this.page + step, total, $c6aea3ca9a48e675$var$CREATION_ROWS);
        if (next === this.page) return;
        this.page = next;
        this.creationsKey = "";
        this.refreshCreations();
    }
    refreshCreations() {
        const entries = this.entries();
        this.creationsCount.text = String(entries.length);
        const pages = (0, $021a35bc759e48d3$export$7804ac8eb5cfa918)(entries.length, $c6aea3ca9a48e675$var$CREATION_ROWS);
        const visible = this.creationsOpen ? this.pageEntries() : [];
        const key = JSON.stringify([
            this.creationsOpen,
            this.page,
            visible
        ]);
        this.pageLabel.text = `${this.page + 1} / ${pages}`;
        this.pagePrev.setEnabled(this.page > 0);
        this.pageNext.setEnabled(this.page < pages - 1);
        this.drawChevron();
        if (key === this.creationsKey) return;
        this.creationsKey = key;
        for (const row of this.creationRows){
            row.button.releaseMouseControl();
            row.container.destroy({
                children: true,
                texture: true,
                baseTexture: true
            });
        }
        this.creationRows = [];
        visible.forEach((entry, index)=>{
            const container = new (0, $8t5Gy.Container)();
            const icon = $c6aea3ca9a48e675$var$glyph($c6aea3ca9a48e675$var$ENTRY_ICON[entry.kind], 10, $c6aea3ca9a48e675$var$LABEL);
            icon.position.set(5, $c6aea3ca9a48e675$var$CREATION_ROW_H / 2);
            const kindText = $c6aea3ca9a48e675$var$label(entry.kind === "entity" ? "prop" : entry.kind, 8, (0, $658a44ce960354bb$export$c48687f662ce7e97));
            const name = $c6aea3ca9a48e675$var$label("", 9, (0, $658a44ce960354bb$export$8eb3a98fbc1bd246));
            $c6aea3ca9a48e675$var$fitText(name, (0, $021a35bc759e48d3$export$a5908e4e63b0bea7)(entry.id), $c6aea3ca9a48e675$var$INNER_W - 16 - $c6aea3ca9a48e675$var$SPAWN_W - 8 - kindText.width - 6);
            name.position.set(14, Math.round(($c6aea3ca9a48e675$var$CREATION_ROW_H - name.height) / 2));
            kindText.position.set(name.x + name.width + 5, Math.round(($c6aea3ca9a48e675$var$CREATION_ROW_H - kindText.height) / 2) + 0.5);
            const button = new (0, $ead1577967896e68$export$d714cb42a300e44f)({
                label: "Spawn",
                onClick: ()=>this.spawn(entry),
                theme: "ember",
                shape: "chamfer",
                size: "extraSmall",
                width: $c6aea3ca9a48e675$var$SPAWN_W,
                height: 15,
                fontSize: 8,
                textColor: (0, $658a44ce960354bb$export$8eb3a98fbc1bd246),
                hitPadding: 2
            });
            button.position.set($c6aea3ca9a48e675$var$INNER_W - $c6aea3ca9a48e675$var$SPAWN_W, Math.round(($c6aea3ca9a48e675$var$CREATION_ROW_H - 15) / 2));
            const rule = new (0, $gwPoJ.Graphics)();
            if (index > 0) (0, $658a44ce960354bb$export$5ed3e56f5245819d)(rule, 0, $c6aea3ca9a48e675$var$INNER_W, 0);
            container.addChild(rule, icon, name, kindText, button);
            container.y = index * $c6aea3ca9a48e675$var$CREATION_ROW_H;
            this.creationsLayer.addChild(container);
            this.creationRows.push({
                container: container,
                button: button
            });
        });
    }
    drawChevron() {
        const g = this.creationsChevron;
        g.clear();
        g.lineStyle({
            width: 1.4,
            color: $c6aea3ca9a48e675$var$LABEL,
            alpha: 1,
            cap: (0, $gwPoJ.LINE_CAP).ROUND,
            join: (0, $gwPoJ.LINE_JOIN).ROUND
        });
        if (this.creationsOpen) g.moveTo(-3, -1.5).lineTo(0, 1.5).lineTo(3, -1.5);
        else g.moveTo(-1.5, -3).lineTo(1.5, 0).lineTo(-1.5, 3);
        g.position.set(9, 8);
    }
    drawFoldGlyph() {
        const g = this.foldGlyph;
        g.clear();
        g.lineStyle({
            width: 1.6,
            color: (0, $658a44ce960354bb$export$8eb3a98fbc1bd246),
            alpha: 0.95,
            cap: (0, $gwPoJ.LINE_CAP).ROUND
        });
        g.moveTo(5, 8).lineTo(13, 8);
        if (this.minimized) g.moveTo(9, 4).lineTo(9, 12);
    }
    // ---- layout ---------------------------------------------------------------------------------
    layoutHeader() {
        const cy = $c6aea3ca9a48e675$var$BAND + $c6aea3ca9a48e675$var$HEADER_H / 2;
        this.spark.position.set($c6aea3ca9a48e675$var$PAD + 5, cy);
        this.title.position.set($c6aea3ca9a48e675$var$PAD + 15, Math.round(cy - this.title.height / 2));
        this.foldButton.position.set($c6aea3ca9a48e675$export$7bd4e97e64a27f7e - $c6aea3ca9a48e675$var$PAD - 16, Math.round(cy - 8));
        const right = this.foldButton.x - 6;
        const titleEnd = this.title.x + $c6aea3ca9a48e675$var$inkWidth(this.title) + 6;
        $c6aea3ca9a48e675$var$fitText(this.activity, this.activity.text, Math.max(0, right - titleEnd - 12));
        this.activity.position.set(right - this.activity.width, Math.round(cy - this.activity.height / 2));
        this.headerSpinner.clear();
        this.drawSpinner(this.headerSpinner, 4.2, (0, $658a44ce960354bb$export$319b6132a2fafb7c));
        this.headerSpinner.position.set(this.activity.x - (this.activity.text ? 9 : 4), cy);
    }
    layout() {
        this.layoutHeader();
        this.body.visible = !this.minimized;
        let y = $c6aea3ca9a48e675$var$BAND + $c6aea3ca9a48e675$var$HEADER_H + 7;
        if (!this.minimized) {
            const kinds = this.body.getChildByName("kinds");
            kinds.position.set($c6aea3ca9a48e675$var$PAD, y);
            y += $c6aea3ca9a48e675$var$KIND_H + 5;
            this.promptSocket.position.set($c6aea3ca9a48e675$var$PAD, y);
            this.drawPromptSocket();
            y += $c6aea3ca9a48e675$var$PROMPT_H + 5;
            this.generateButton.position.set($c6aea3ca9a48e675$var$PAD + $c6aea3ca9a48e675$var$INNER_W - $c6aea3ca9a48e675$var$GENERATE_W, y);
            this.hint.position.set($c6aea3ca9a48e675$var$PAD, y + Math.max(0, Math.round(($c6aea3ca9a48e675$var$ACTION_H - this.hint.height) / 2)));
            y += $c6aea3ca9a48e675$var$ACTION_H + $c6aea3ca9a48e675$var$GAP + 2;
            // Queue: a section label with the generation slots on the right, then one row per job.
            this.queueTitle.position.set($c6aea3ca9a48e675$var$PAD, y);
            this.queueRule.clear();
            const pipsW = this.state ? (0, $021a35bc759e48d3$export$3a89f0ed1a7c44ae)(this.state) * 9 : 18;
            this.slotsLabel.position.set($c6aea3ca9a48e675$var$PAD + $c6aea3ca9a48e675$var$INNER_W - pipsW - 3 - this.slotsLabel.width, y + Math.round(($c6aea3ca9a48e675$var$SECTION_H - this.slotsLabel.height) / 2) - 1);
            (0, $658a44ce960354bb$export$5ed3e56f5245819d)(this.queueRule, $c6aea3ca9a48e675$var$PAD + $c6aea3ca9a48e675$var$inkWidth(this.queueTitle) + 6, this.slotsLabel.x - 6, y + $c6aea3ca9a48e675$var$SECTION_H / 2 - 1);
            this.slotPips.position.set($c6aea3ca9a48e675$var$PAD + $c6aea3ca9a48e675$var$INNER_W - 3, y + $c6aea3ca9a48e675$var$SECTION_H / 2 - 1);
            y += $c6aea3ca9a48e675$var$SECTION_H + 2;
            this.queueLayer.position.set($c6aea3ca9a48e675$var$PAD, y);
            const rows = Math.max(1, this.queueRows.length);
            this.queueEmpty.position.set($c6aea3ca9a48e675$var$PAD + 2, y + Math.round(($c6aea3ca9a48e675$var$ROW_H - this.queueEmpty.height) / 2));
            y += rows * $c6aea3ca9a48e675$var$ROW_H;
            if (this.queueOverflow.visible) {
                this.queueOverflow.position.set($c6aea3ca9a48e675$var$PAD + 14, y);
                y += 11;
            }
            y += $c6aea3ca9a48e675$var$GAP;
            // Creations: a fold-out list with its own pager.
            this.creationsHeader.position.set($c6aea3ca9a48e675$var$PAD, y);
            this.creationsTitle.position.set(18, Math.round((16 - this.creationsTitle.height) / 2));
            this.creationsCount.position.set(this.creationsTitle.x + $c6aea3ca9a48e675$var$inkWidth(this.creationsTitle) + 6, Math.round((16 - this.creationsCount.height) / 2));
            const showPager = this.creationsOpen && this.entries().length > $c6aea3ca9a48e675$var$CREATION_ROWS;
            for (const part of [
                this.pagePrev,
                this.pageLabel,
                this.pageNext
            ])part.visible = showPager;
            this.pageNext.position.set($c6aea3ca9a48e675$var$PAD + $c6aea3ca9a48e675$var$INNER_W - 18, y + 2);
            this.pageLabel.position.set(this.pageNext.x - 4 - this.pageLabel.width, y + Math.round((16 - this.pageLabel.height) / 2));
            this.pagePrev.position.set(this.pageLabel.x - 4 - 14, y + 2);
            y += 16;
            this.creationsLayer.visible = this.creationsOpen;
            this.creationsEmpty.visible = this.creationsOpen && this.entries().length === 0;
            if (this.creationsOpen) {
                y += 3;
                this.creationsLayer.position.set($c6aea3ca9a48e675$var$PAD, y);
                this.creationsEmpty.position.set($c6aea3ca9a48e675$var$PAD + 2, y + 4);
                y += Math.max(1, this.creationRows.length) * $c6aea3ca9a48e675$var$CREATION_ROW_H;
            }
            y += $c6aea3ca9a48e675$var$GAP;
            // Footer: the latest word from the server, and the way out.
            const messageH = this.message.text ? this.message.height : 0;
            const footerH = Math.max($c6aea3ca9a48e675$var$FOOTER_H, messageH);
            this.message.position.set($c6aea3ca9a48e675$var$PAD, y + Math.round((footerH - messageH) / 2));
            this.leaveButton.position.set($c6aea3ca9a48e675$var$PAD + $c6aea3ca9a48e675$var$INNER_W - $c6aea3ca9a48e675$var$LEAVE_W, y + Math.round((footerH - $c6aea3ca9a48e675$var$FOOTER_H) / 2));
            y += footerH + $c6aea3ca9a48e675$var$PAD - 2;
        } else y = $c6aea3ca9a48e675$var$BAND + $c6aea3ca9a48e675$var$HEADER_H + $c6aea3ca9a48e675$var$BAND;
        const height = Math.round(y);
        if (height !== this.panelHeight) {
            this.panelHeight = height;
            this.drawFrame();
            this.handlers.onLayoutChange();
        } else this.drawFrame();
        this.fieldCheckMs = 0;
    }
    drawFrame() {
        const g = this.plate;
        const w = $c6aea3ca9a48e675$export$7bd4e97e64a27f7e;
        const h = this.panelHeight;
        g.clear();
        // Dropped silhouette: the panel sits on the world rather than being painted into it.
        g.beginFill(0x000000, 0.34);
        (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 0, 3, w, h, $c6aea3ca9a48e675$var$CHAMFER);
        g.endFill();
        g.lineStyle({
            width: 1.5,
            color: (0, $658a44ce960354bb$export$c2ea448b59bcc1de),
            alpha: 0.95,
            join: (0, $gwPoJ.LINE_JOIN).MITER
        });
        g.beginFill((0, $658a44ce960354bb$export$611f5967b7e8b685), 0.98);
        (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 0, 0, w, h, $c6aea3ca9a48e675$var$CHAMFER);
        g.endFill();
        g.lineStyle({
            width: 1,
            color: (0, $658a44ce960354bb$export$dd27ce85ad53c944),
            alpha: 0.85,
            join: (0, $gwPoJ.LINE_JOIN).MITER
        });
        g.beginFill((0, $658a44ce960354bb$export$e969f1546e2d24ca), 0.97);
        (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, $c6aea3ca9a48e675$var$BAND, $c6aea3ca9a48e675$var$BAND, w - $c6aea3ca9a48e675$var$BAND * 2, h - $c6aea3ca9a48e675$var$BAND * 2, $c6aea3ca9a48e675$var$CHAMFER - 2);
        g.endFill();
        g.lineStyle(0);
        // The header band: a little lighter (the fire catches it), cut off from the face by a groove.
        const hb = this.header;
        hb.clear();
        hb.beginFill($c6aea3ca9a48e675$var$HEADER_FACE, this.minimized ? 0.0 : 0.85);
        hb.drawRect($c6aea3ca9a48e675$var$BAND + 1, $c6aea3ca9a48e675$var$BAND + 1, w - $c6aea3ca9a48e675$var$BAND * 2 - 2, $c6aea3ca9a48e675$var$HEADER_H - 1);
        hb.endFill();
        hb.hitArea = {
            contains: (x, y)=>x >= 0 && x <= w && y >= 0 && y <= $c6aea3ca9a48e675$var$BAND + $c6aea3ca9a48e675$var$HEADER_H
        };
        if (!this.minimized) (0, $658a44ce960354bb$export$5ed3e56f5245819d)(hb, $c6aea3ca9a48e675$var$BAND + 2, w - $c6aea3ca9a48e675$var$BAND - 2, $c6aea3ca9a48e675$var$BAND + $c6aea3ca9a48e675$var$HEADER_H);
        hb.lineStyle(1, (0, $658a44ce960354bb$export$6b1db5e247c0ce0), 0.16).moveTo($c6aea3ca9a48e675$var$BAND + $c6aea3ca9a48e675$var$CHAMFER, $c6aea3ca9a48e675$var$BAND + 1.5).lineTo(w - $c6aea3ca9a48e675$var$BAND - $c6aea3ca9a48e675$var$CHAMFER, $c6aea3ca9a48e675$var$BAND + 1.5);
        hb.lineStyle(0);
    }
    drawPromptSocket() {
        const g = this.promptSocket;
        g.clear();
        const focused = this.fieldFocused;
        g.lineStyle(0);
        g.beginFill(0x0a0705, 1);
        (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 0, 0, $c6aea3ca9a48e675$var$INNER_W, $c6aea3ca9a48e675$var$PROMPT_H, 3);
        g.endFill();
        g.beginFill(0x120d09, 1);
        (0, $658a44ce960354bb$export$99dca9ebbafa6899)(g, 1.5, 2, $c6aea3ca9a48e675$var$INNER_W - 3, $c6aea3ca9a48e675$var$PROMPT_H - 3.5, 2);
        g.endFill();
        g.lineStyle(1, focused ? (0, $658a44ce960354bb$export$319b6132a2fafb7c) : (0, $658a44ce960354bb$export$6b1db5e247c0ce0), focused ? 0.6 : 0.12);
        g.moveTo(3, $c6aea3ca9a48e675$var$PROMPT_H - 0.5).lineTo($c6aea3ca9a48e675$var$INNER_W - 3, $c6aea3ca9a48e675$var$PROMPT_H - 0.5);
        g.lineStyle(0);
    }
    /** Park the DOM field over the socket, or take it off the page when the socket is not showing. */ placeField() {
        const showing = this.visible && !this.minimized && !!this.state && this.worldVisible;
        if (!showing) {
            if (this.field.isShown()) this.field.hide();
            return;
        }
        const canvas = this.handlers.canvasRect();
        const screen = this.handlers.rendererScreen();
        if (!canvas || !(screen.width > 0)) return;
        const start = this.promptSocket.toGlobal({
            x: 2,
            y: 2
        });
        const end = this.promptSocket.toGlobal({
            x: $c6aea3ca9a48e675$var$INNER_W - 2,
            y: $c6aea3ca9a48e675$var$PROMPT_H - 2
        });
        this.field.show((0, $d8f28c464fcc8750$export$95a22a72d3b9c87e)({
            x: start.x,
            y: start.y,
            width: end.x - start.x,
            height: end.y - start.y
        }, screen, canvas), (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().touch);
        // The socket's lower lip lights gold while the field has the keyboard.
        const focused = this.field.isFocused();
        if (focused !== this.fieldFocused) {
            this.fieldFocused = focused;
            this.drawPromptSocket();
        }
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");




class $7679dbbb27672f9f$export$3ee0d0a1366434ff {
    constructor(subject, props){
        this.faderStep = 0.01;
        this.direction = "out";
        this.isActive = ()=>this.active;
        this.update = ()=>{
            this.active = true;
            if (this.interval) return;
            this.interval = setInterval(()=>{
                if (this.direction === "out") {
                    this.alpha -= this.faderStep;
                    this.effectCallback(this.alpha);
                    if (this.alpha <= this.minAlpha) {
                        this.releaseCallback && this.releaseCallback();
                        clearInterval(this.interval);
                        this.interval = undefined;
                        return;
                    }
                } else if (this.direction === "in") {
                    this.alpha += this.faderStep;
                    this.effectCallback(this.alpha);
                    if (this.alpha >= this.minAlpha) {
                        this.releaseCallback && this.releaseCallback();
                        clearInterval(this.interval);
                        this.interval = undefined;
                        return;
                    }
                } else {
                    // not supported, clear it right away
                    clearInterval(this.interval);
                    this.interval = undefined;
                }
            }, this.fadeInterval);
        };
        this.stop = (suppressCallback)=>{
            if (this.interval) {
                clearInterval(this.interval);
                this.interval = undefined;
            }
            if (!suppressCallback && this.releaseCallback) this.releaseCallback();
            this.active = false;
        };
        this.releaseCallback = props?.releaseCallback;
        this.effectCallback = props?.effectCallback;
        this.minAlpha = props?.minAlpha !== undefined ? props.minAlpha : this.direction === "out" ? 0.0 : 1.0;
        this.fadeInterval = props?.fadeInterval || 2;
        this.faderStep = props?.fadeAlphaDecrement || 0.01;
        this.direction = props?.direction || "out";
        if (this.direction === "out") this.alpha = props.maxAlpha || 1.0;
        else this.alpha = 0.0;
    }
}


class $a231d713277e9a39$export$9a82c68eff2bb78f extends (0, $ac2a97d45725bff5$export$f79759b47a91f0e7) {
    constructor(guiManager, map, onClickCallback){
        super(guiManager), this.throbbers = [], this.createContent = ()=>{
            const main = new (0, $gwPoJ.Graphics)();
            const width = this.width();
            const height = this.height();
            const sizeX = width / this.map.dimensions.w;
            const sizeY = height / this.map.dimensions.h;
            main.beginFill(0x808080);
            main.drawRect(0, 0, width, height);
            main.endFill();
            this.map.map.points.forEach((point)=>{
                const pointObj = new (0, $gwPoJ.Graphics)();
                pointObj.interactive = true;
                main.addChild(pointObj);
                const { x: x, y: y } = point.biomeCoordinate;
                pointObj.x = x * sizeX;
                pointObj.y = y * sizeY;
                pointObj.beginFill(point.color);
                pointObj.drawRect(0, 0, sizeX, sizeY);
                pointObj.endFill();
                pointObj.on("click", ()=>this.onClickCallback({
                        x: x,
                        y: y
                    }));
                pointObj.on("tap", ()=>this.onClickCallback({
                        x: x,
                        y: y
                    }));
            });
            if (this.map.playerLocations) this.map.playerLocations.forEach((location)=>{
                const playerLocation = new (0, $gwPoJ.Graphics)();
                playerLocation.beginFill(location.isViewer ? 0xff0000 : 0xffffff);
                playerLocation.drawCircle(0, 0, sizeX / 2);
                playerLocation.endFill();
                playerLocation.x = location.location.x * sizeX;
                playerLocation.y = location.location.y * sizeY;
                main.addChild(playerLocation);
                playerLocation.interactive = true;
                if (location.isViewer) {
                    let dir = false;
                    playerLocation.scale.set(1.2);
                    const throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(playerLocation, {
                        blinkInterval: 25,
                        cycleCallback: ()=>{
                            if (dir) playerLocation.tint = 0xff0000;
                            else playerLocation.tint = 0x000000;
                            dir = !dir;
                        }
                    });
                    this.throbbers.push(throbber);
                    throbber.update();
                    const playerLocationHuge = new (0, $gwPoJ.Graphics)();
                    playerLocationHuge.beginFill(location.isViewer ? 0xff0000 : 0xffffff);
                    playerLocationHuge.drawCircle(0, 0, sizeX / 2);
                    playerLocationHuge.endFill();
                    playerLocationHuge.x = location.location.x * sizeX;
                    playerLocationHuge.y = location.location.y * sizeY;
                    playerLocationHuge.scale.set(2);
                    main.addChild(playerLocationHuge);
                    const fader = new (0, $7679dbbb27672f9f$export$3ee0d0a1366434ff)(playerLocationHuge, {
                        direction: "out",
                        maxAlpha: 4.0,
                        fadeAlphaDecrement: 0.03,
                        fadeInterval: 0.5,
                        effectCallback: (alpha)=>{
                            playerLocationHuge.scale.set(alpha);
                        }
                    });
                    fader.update();
                }
                const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().render(location.label);
                playerLocation.on("mouseover", ()=>{
                    text.x = playerLocation.x - text.width / 2;
                    text.y = playerLocation.y - text.height * 1.2;
                    text.zIndex = 1000;
                    main.addChild(text);
                });
                playerLocation.on("mouseout", ()=>{
                    text.parent.removeChild(text);
                });
            });
            if (this.map.locationIcons) this.map.locationIcons.forEach((icon)=>{
                const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: icon.icon,
                    color: 0xffffff,
                    scale: 0.25
                });
                sprite.x = icon.x * sizeX;
                sprite.y = icon.y * sizeY;
                sprite.interactive = true;
                main.addChild(sprite);
            });
            if (this.map.questMarkers) this.map.questMarkers.forEach((icon)=>{
                const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                    name: icon.icon,
                    color: 0xffffff,
                    scale: 0.25
                });
                sprite.x = icon.x * sizeX;
                sprite.y = icon.y * sizeY;
                sprite.interactive = true;
                if (icon.context?.active) {
                    sprite.recolor(0xff0000);
                    sprite.scale.set(1.5);
                    let dir = false;
                    const throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(sprite, {
                        blinkInterval: 25,
                        cycleCallback: ()=>{
                            if (dir) sprite.recolor(0xff0000);
                            else sprite.recolor(0x000000);
                            dir = !dir;
                        }
                    });
                    this.throbbers.push(throbber);
                    throbber.update();
                    const spriteHuge = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: icon.icon,
                        color: 0xffffff,
                        scale: 2.0
                    });
                    spriteHuge.x = icon.x * sizeX;
                    spriteHuge.y = icon.y * sizeY;
                    main.addChild(spriteHuge);
                    const fader = new (0, $7679dbbb27672f9f$export$3ee0d0a1366434ff)(spriteHuge, {
                        direction: "out",
                        maxAlpha: 1.0,
                        fadeInterval: 0.2,
                        effectCallback: (alpha)=>{
                            spriteHuge.scale.set(alpha);
                        }
                    });
                    fader.update();
                }
                const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().render(icon.context?.label || "");
                sprite.on("mouseover", ()=>{
                    text.x = sprite.x - text.width / 2;
                    text.y = sprite.y - text.height * 1.2;
                    text.zIndex = 1000;
                    main.addChild(text);
                });
                sprite.on("mouseout", ()=>{
                    text.parent.removeChild(text);
                });
                sprite.on("click", ()=>this.onClickCallback({
                        x: icon.x,
                        y: icon.y
                    }));
                sprite.on("tap", ()=>this.onClickCallback({
                        x: icon.x,
                        y: icon.y
                    }));
                main.addChild(sprite);
            });
            if (this.map.geographicFeatureLocations) this.map.geographicFeatureLocations.forEach((location)=>{
                const chatHistoryText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").render(location.name);
                chatHistoryText.x = location.x * sizeX;
                chatHistoryText.y = location.y * sizeY;
                main.addChild(chatHistoryText);
            });
            return main;
        };
        this.map = map;
        this.onClose = ()=>{
            this.throbbers?.forEach((throbber)=>throbber.stop);
            this.throbbers = [];
        };
        this.onClickCallback = onClickCallback;
    }
}


const $7dd73ecdd94bfe01$export$84e1549b474f1b93 = 460;
const $7dd73ecdd94bfe01$export$15ae5481f3ca1c06 = 6;
// Where the `f` frame-rate readout parks: top band, clear of the health meters on the left and the
// day/night dial on the right.
const $7dd73ecdd94bfe01$var$FPS_METER_X = 130;
const $7dd73ecdd94bfe01$var$FPS_METER_Y = 4;
const $7dd73ecdd94bfe01$var$FPS_METER_KEY = "_fpsMeter_";
// The top-right chip row: the map toggle, the inventory toggle, the players count and the chat
// button, and the gap between them. Ember rooms suppress the control bar that normally lives up
// there, so the corner is theirs.
const $7dd73ecdd94bfe01$var$CHIP_ROW_Y = 6;
// Air between the camp-tasks stack and whatever is above it in the top-left column.
const $7dd73ecdd94bfe01$var$OBLIGATIONS_GAP = 10;
/**
 * How long the camp-tasks stack stays folded after the `important` strip falls quiet.
 *
 * Long enough to cover the strip's own ~400ms fade-out, so the rows do not unfold through a notice
 * that is still on screen, plus the lane's 220ms handover -- which is what stops a burst of wave
 * banners flickering the stack open and shut between each one.
 */ const $7dd73ecdd94bfe01$var$OBLIGATIONS_YIELD_MS = 600;
const $7dd73ecdd94bfe01$var$chipGap = ()=>(0, $0d2b5753435eae0a$export$80d247c8fac4e59d)().rowGap;
// The player's own VITALS, docked to the top edge of the readied-item tray: hearts, then whichever
// of the mana and hunger bars the room has not suppressed, laid out left to right on ONE line.
//
// They used to head the top-left column, which put the three things a player reads mid-fight -- own
// health, own items, crew health -- in three different corners. Here the first two are one cluster
// under the hand that is already on the number keys.
//
// A row, not a stack: stacked, the three meters are ~60px tall and that whole band comes out of
// chat's column. The band is RESERVED whether or not a bar is currently in it, for the same reason
// the chip row reserves each chip's slot -- chat must not slide about as a meter appears.
//
// 32 comes from the art, MEASURED in the browser rather than guessed: the hearts draw 100x22.5
// (five 15x13 hearts on their own plate, see icon_meter.ts) and the bars' icons are 16x16 and 19x12
// (humanoid.json), so the tallest thing on the row is 22.5; plus VITALS_GAP that is 27.5, and the
// rest is air under chat's input field. Widthwise the three come to ~266 against a 318-wide tray,
// so a full row never reaches the abilities widget parked off the tray's right edge.
const $7dd73ecdd94bfe01$var$VITALS_BAND = 32;
// Air between the tray's top edge and the row, and between the meters along it.
const $7dd73ecdd94bfe01$var$VITALS_GAP = 5;
const $7dd73ecdd94bfe01$var$VITALS_ROW_GAP = 8;
// Air kept inside the row's plate at its right-hand end. Matches the padding the hearts' plate
// already keeps around the art at the other end (icon_meter.ts PLATE_PAD).
const $7dd73ecdd94bfe01$var$VITALS_PLATE_PAD = 4;
// The top of the countdown dial, which now heads the top-left column on its own. Clear of the
// name/level label that shares the top band with it (nameText, at x 90).
// Where the HUD's top band starts. Only a construction-time default now: hudTopEdge is what both
// of the band's clusters actually read, so the one that is placed per frame cannot drift from the
// one that is not. (It WAS 24 against the chip row's 6, which put the whole left column 18px below
// the chips -- at a glance, like the left half of the HUD had slipped down.)
const $7dd73ecdd94bfe01$var$DIAL_TOP = $7dd73ecdd94bfe01$var$CHIP_ROW_Y;
// The fire gauge's gap from whatever is above it in the left column, and how fast it slides when
// that changes (px/ms: a dial's height in about a fifth of a second).
const $7dd73ecdd94bfe01$var$FIRE_GAUGE_GAP = 9;
const $7dd73ecdd94bfe01$var$FIRE_GAUGE_SLIDE = 0.62;
// Chat's ambient home, bottom-left: the input field's top edge, with the log hanging off it. The
// field's bottom has to clear the vitals row docked on the readied-item tray.
const $7dd73ecdd94bfe01$var$CHAT_LEFT = 15;
const $7dd73ecdd94bfe01$var$CHAT_INPUT_TOP = $7dd73ecdd94bfe01$export$84e1549b474f1b93 - 74 - $7dd73ecdd94bfe01$var$VITALS_BAND;
const $7dd73ecdd94bfe01$var$CHAT_LOG_BOTTOM = $7dd73ecdd94bfe01$var$CHAT_INPUT_TOP - 6;
// Where the log goes while the composer is open: directly under that panel, centred on it, growing
// downward. The bottom-left corner is no use there -- it is what a soft keyboard covers, and on a
// phone it is also under the move stick.
const $7dd73ecdd94bfe01$var$COMPOSER_LOG_X = (0, $b846cff9e823ca67$export$f445d03e81bcf8ba) + ((0, $b846cff9e823ca67$export$91e844e248b510e7) - (0, $bde0eb94ead9038f$export$72ee0c7a4855a274)) / 2;
const $7dd73ecdd94bfe01$var$COMPOSER_LOG_TOP = (0, $b846cff9e823ca67$export$5b84a9dbdfc7701e) + 8;
// How much bigger the readied-item slots are under a thumb, and how far the row is lifted off the
// bottom edge to make room for the growth. See where the widget is built.
const $7dd73ecdd94bfe01$var$EQUIPPED_TOUCH_SCALE = 1.5;
// The tether from a per-entity command wheel to the NPC it commands. Semi-transparent so it reads as
// a link rather than another piece of HUD, and started off the rim so it doesn't cut across the disc.
const $7dd73ecdd94bfe01$var$WHEEL_TETHER_ALPHA = 0.45;
const $7dd73ecdd94bfe01$var$WHEEL_TETHER_WIDTH = 2;
const $7dd73ecdd94bfe01$var$WHEEL_TETHER_RIM_GAP = 4 // how far outside the wheel's rim the line begins
;
const $7dd73ecdd94bfe01$var$WHEEL_TETHER_MIN_LENGTH = 6 // shorter than this and the line is just a nub: don't draw it
;
const $7dd73ecdd94bfe01$var$WHEEL_TETHER_DOT_RADIUS = 3 // marker pinning the far end to the NPC's center
;
// The command wheel's ring. Its name plaques sit outside this, so the wheel is laid out against the
// screen by CommandWheel.getExtent, never by the radius.
const $7dd73ecdd94bfe01$var$COMMAND_WHEEL_RADIUS = 64;
// The one slice on an interaction wheel that is not one of the entity's verbs. A card's tap belongs
// to what you can DO with the person; this is how the same tap still reaches the follow cam, which
// is otherwise only on the lord's and a partner's cards. Prefixed so it can never collide with an
// InteractionType coming off the wire.
const $7dd73ecdd94bfe01$var$WATCH_SLICE = "__watch";
// How far the subject of a pinned panel may drift from that panel's tail tip before the tail stops
// telling the truth -- half a tile, i.e. they are still standing on the spot the panel opened over.
// In stage pixels, which the world overlay puts at surfaceZoom to the world unit (computeLocation).
const $7dd73ecdd94bfe01$var$PANEL_TAIL_SLACK = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 * (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
// The joysticks report one of eight compass sectors, and the game moves in those same eight
// directions (see Directions in game-common/models), so each sector maps to the per-axis -1/0/1
// vector the equivalent WASD combination would produce.
const $7dd73ecdd94bfe01$var$JoystickVectors = {
    left: {
        x: -1,
        y: 0
    },
    right: {
        x: 1,
        y: 0
    },
    top: {
        x: 0,
        y: -1
    },
    bottom: {
        x: 0,
        y: 1
    },
    top_left: {
        x: -1,
        y: -1
    },
    top_right: {
        x: 1,
        y: -1
    },
    bottom_left: {
        x: -1,
        y: 1
    },
    bottom_right: {
        x: 1,
        y: 1
    }
};
// Fraction of the stick's travel that reads as "no input". The move stick used to demand 0.9,
// which left only the outermost tenth of the travel usable and let ordinary thumb jitter fall
// out of it mid-drag.
const $7dd73ecdd94bfe01$var$JoystickDeadZone = 0.3;
class $7dd73ecdd94bfe01$export$530fe131767a4087 {
    acceptsSceneRoom(roomId) {
        return !roomId || roomId === this.currentRoomId || !!this.logic.scene?.contains(roomId);
    }
    constructor(stage, minimapSurface, logic){
        this.chatHistoryFader = null;
        this.chatLog = [];
        this.chatInput = (0, $2bc3e70fbff7f064$export$d42b23612a605795);
        this.chatWalk = (0, $2bc3e70fbff7f064$export$2cd8bbcbf799240);
        // Whether the input currently owns the keyboard. The log does not fade itself out while it
        // is open: a line arriving mid-sentence must not take the conversation away from the player
        // who is in the middle of answering it.
        this.chatOpen = false;
        this.CHAT_HISTORY_KEY = "_chatHistory_";
        this.screenMessages = [];
        this.currentScreenMessage = null;
        this.currentMessageTimeout = null;
        this.recruitMenuHint = new (0, $4187b20a7424922e$export$cafd35a8da32c4c1)(()=>this.logic.playerController?.suppressAttack(), (entityId)=>this.recordRecruitMenuLearned(entityId, "RECRUIT_MENU_HINT_SHOWN"));
        this.campfireMenuLearnedLocally = false;
        this.recruitHintRoster = [];
        this.recruitMenuLearnedLocally = false;
        this.followCamPlacement = null;
        // Fade state for the follow-cam: `followCamShown` is the current target (null forces the first
        // evaluation after open to run a fade); `followCamFader` is the active alpha tween.
        this.followCamShown = false;
        this.followCamFader = null;
        // The last list the server sent, kept so opening the panel draws the current one rather than
        // waiting for the next broadcast.
        this.emberPlayers = [];
        // Whether the player has folded the map away. Remembered across rooms and sessions: an ember run
        // drops you into a FRESH room on every death and retry, so a preference that reset each time
        // would be no preference at all.
        this.emberMinimapCollapsed = false;
        this.EMBER_MINIMAP_COLLAPSED_KEY = "_emberMinimapCollapsed_";
        this.EMBER_OBLIGATIONS_COLLAPSED_KEY = "_emberObligationsCollapsed_";
        // The queue in front of the one-slot `important` strip. See gui/important_lane.ts: several ember
        // beats land on the same wave boundary by construction, and before this the later one erased the
        // earlier one mid-hold.
        this.importantLane = new (0, $02082475a2de3c51$export$fa8855d9633ae2f7)();
        this.emberObligationDismissals = new (0, $7774c82afd18c45a$export$c0db793bbc4500e2)();
        this.emberObligationFeed = [];
        /** Time left before the task stack may unfold again; see OBLIGATIONS_YIELD_MS. */ this.obligationsYieldMs = 0;
        // Where the player has DRAGGED the map to, in this HUD container's own coordinates, or null while
        // it is still parked in its default slot above the roster. Remembered for the same reason the
        // collapsed flag is: a run hands out a fresh room on every death and retry.
        this.emberMinimapPlacement = null;
        this.EMBER_MINIMAP_PLACEMENT_KEY = "_emberMinimapPlacement_";
        // Which of the three sizes the map is at. Remembered like the other two map preferences: a player
        // who decided the map is a radar should not have to decide it again next session.
        this.emberMinimapSize = (0, $27706b8361e494c8$export$b224d4b6baa336d9);
        this.EMBER_MINIMAP_SIZE_KEY = "_emberMinimapSize_";
        this.spriteLabPlacement = null;
        this.SPRITELAB_PANEL_KEY = "_spriteLabPanel_";
        // Cache key for the minimap's TREE layer, which the client scans off its own tile map rather than
        // being sent: room + the map's collision version (bumped on every tile write, so a felled tree or
        // a placed wall invalidates it) + the room's extent. Null means "not scanned yet".
        this.emberTreeScanKey = null;
        // ...plus a floor on how often that O(tiles) scan may re-run, so a burst of tile edits (placing a
        // wall writes several cells) can't rescan on every broadcast. Low-end CPUs are the target here.
        this.emberTreeScanAt = 0;
        // Whether the column had a dial at its head last frame, and whether the gauge is still sliding
        // to the place that answer gave it. Null until the first frame places it, which has nothing to
        // slide from. See placeEmberFireGauge.
        this.fireGaugeHeaded = null;
        this.fireGaugeSliding = false;
        this.tileWheelInteractionsKey = "";
        this.commandWheelHome = {
            x: 0,
            y: 0
        };
        // Whether the player was in reach of it the last time the slices were written.
        this.rosterInteractionInReach = false;
        // Last invading verdict seen, so the scorecard is dismissed -- and each end of a visit
        // announced -- on the TRANSITION rather than on every message that arrives during one.
        this.invading = false;
        // How much of the HUD is on screen (gui/hud_presence.ts): the pieces held back, set by signals --
        // the server's "hud" screen messages, decided by the story chapter -- and the step back while a
        // held line is read. Read last in every frame, over everyone's own layout; the GUI decides none
        // of it itself.
        this.hudPresence = new (0, $7773f27b7db9938b$export$8ae085b39c2128cd)();
        this.currentPlayerUpgradePoints = 0;
        this.currentPlayerName = "";
        this.currentPlayerHp = 0;
        this.currentPlayerHpMax = 0;
        // Tracked alongside hp because a player can be stood back up without their hp changing, and the
        // hearts have to refill on that alone.
        this.currentPlayerDowned = false;
        this.currentPlayerHunger = 0;
        this.currentPlayerHungerMax = 0;
        this.currentPlayerMana = -1;
        this.currentPlayerManaMax = -1;
        // A camp's checklist and HUD list that arrived before the client had entered that camp, by target
        // (see addScreenMessage).
        this.earlySceneMessages = new Map();
        this.leftJoystickAngleAllowed = true;
        this.inventoryUpdateTs = new Map();
        this.userSuppressMinimap = false;
        // Per-room flag: when true, the day/night indicator stays hidden even as day-pct updates arrive.
        this.suppressDayCycle = false;
        // Per-room flag: when true, the "Level up stats!" button is not built in helpMessaging().
        this.suppressLevelUp = false;
        // The buttons the LAST helpMessaging() build put on screen. Held only so the next build can give
        // the world's mouse back on their behalf before they are removed -- see helpMessaging().
        this.helpMessagingButtons = [];
        // Per-room flags: when true, the mana meter / food (hunger) meter stay hidden even as
        // update() receives new player mana/hunger values.
        this.suppressMana = false;
        this.suppressFood = false;
        // Per-room flags: when true, the shard/resource counter (resourceBar) / the player name+level
        // label stay hidden even as updateInventory()/update() would otherwise show them.
        this.suppressShards = false;
        this.suppressPlayerName = false;
        // Per-room flag: when true, a guest's standing "/register to save progress" nudge is left out of
        // the help-messaging stack. Ember rooms set it -- see Visibility.suppressGuestPrompt.
        this.suppressGuestPrompt = false;
        this.hudInset = 0;
        this.hudInsetY = 0;
        this.controlKeyPressed = false;
        this.init = ()=>{
            // meters
            const container = new (0, $gwPoJ.Graphics)();
            this.container = container;
            container.sortableChildren = true;
            container.x = 10;
            container.zIndex = 2;
            this.stage.addChild(container);
            // These toggles remain reachable above item dialogs, including when their X is hidden.
            // Match the HUD transform so the chip row and tutorial anchors keep their coordinates.
            const chipLayer = new (0, $8t5Gy.Container)();
            this.chipLayer = chipLayer;
            chipLayer.position.copyFrom(container.position);
            chipLayer.zIndex = 4;
            chipLayer.visible = false;
            this.stage.addChild(chipLayer);
            const bannerText = new (0, $hnGDn.BitmapText)("", {
                fontName: "BannerFont"
            });
            bannerText.y = 50;
            this.bannerText = bannerText;
            container.addChild(bannerText);
            container.addChild(this.minimapSurface);
            const screenWidth = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7;
            // message — the ambient "important" strip self-positions across the full viewport,
            // so it lives on the stage (not the +10 offset HUD container) at its own zIndex.
            const importantMessage = new (0, $a7b6262714ec8487$export$b3ee1e8559ec7f0c)(0xffffff, {
                text: ""
            });
            this.importantMessage = importantMessage;
            this.stage.addChild(importantMessage);
            // The standing counterpart to the strip above it: what is still true, rather than what just
            // changed. Hidden until the camp owes the player something; placed by placeEmberObligations.
            //
            // On the STAGE rather than the HUD container, because it continues the top-left column the
            // countdown dial and the let-go button are already in (both of which live here), and
            // measuring itself against those two is only honest in their own coordinate space.
            const emberObligations = new (0, $0b9b8914648f9fea$export$3f0a40c1e1665750)((obligation)=>this.dismissEmberObligation(obligation), (collapsed)=>this.saveEmberObligationsCollapsed(collapsed));
            emberObligations.setCollapsed(this.loadEmberObligationsCollapsed());
            // Above the `important` strip (55000), which is a full-width band crossing the row the open
            // rows hang into. The band is translucent and transient; what is STANDING has to stay
            // readable through it, so the dropdown wins that overlap rather than being greyed out by a
            // notice about something else. Still below the hero banner and the countdown dial's own
            // slot (60000), which nothing should ever cover.
            emberObligations.zIndex = 56000;
            this.emberObligations = emberObligations;
            // Keep camp tasks off the stage for now; the chapter checklist provides progress guidance.
            // The three vitals. Where they GO is positionVitals' job alone -- they are docked to the
            // readied-item tray, which is not built yet at this point in the constructor -- so nothing
            // here places them. The old code seeded an x off `this.stage.width / 2`, measured on an
            // all-but-empty stage, and then relied on the edge-inset shifts to drag it somewhere usable.
            const hp = new (0, $9b7bf4301258d7f9$export$7332475dd933238a)("heart", 0);
            this.hp = hp;
            container.addChild(hp);
            const mana = new (0, $1401bf9c6a4e7405$export$160dd9b73ca3e58e)();
            mana.visible = false;
            this.mana = mana;
            container.addChild(mana);
            const hunger = new (0, $6cfcddb9955aa6fe$export$10811ae595fe85fd)(0xc4a484, 19, "drumstick-brown.png");
            hunger.visible = false;
            this.hunger = hunger;
            container.addChild(hunger);
            // Chat, bottom-left: the input field, with the log hanging off its top edge. Both are the
            // same width and share a left edge, so they read as one component (gui/chat_theme.ts).
            const chatLeft = $7dd73ecdd94bfe01$var$CHAT_LEFT;
            const chatInputTop = $7dd73ecdd94bfe01$var$CHAT_INPUT_TOP;
            this.typing = new (0, $1d7285dcca0039d8$export$3997e86453ee41f3)();
            this.typing.x = chatLeft;
            this.typing.y = chatInputTop;
            this.typing.visible = false;
            this.typing.zIndex = 3;
            this.stage.addChild(this.typing);
            // The log sizes itself and hangs UP from this line, so a long conversation grows into the
            // empty grass above instead of pushing the field down over the hotbar.
            const chatHistory = new (0, $030df650e8220c82$export$23974c6ecceedade)($7dd73ecdd94bfe01$var$CHAT_LOG_BOTTOM);
            chatHistory.zIndex = 3;
            chatHistory.x = chatLeft;
            chatHistory.y = $7dd73ecdd94bfe01$var$CHAT_LOG_BOTTOM;
            this.chatHistory = chatHistory;
            this.stage.addChild(chatHistory);
            // The composer: the field a phone can actually type into. Above the command wheel / name
            // prompt tier (it dims the screen and takes the keyboard), below the end-of-run panels,
            // which are never up at the same time as a chat field.
            this.chatComposer = new (0, $b846cff9e823ca67$export$813afa0a1cccf433)({
                onSend: (message)=>{
                    this.dismissChatComposer();
                    this.logic.playerController?.client?.sendChatMessage(message);
                },
                onDismiss: ()=>this.dismissChatComposer()
            });
            this.chatComposer.zIndex = 60500;
            this.stage.addChild(this.chatComposer);
            this.exposeChatDevTriggers();
            // leaderboard
            this.leaderboard = new (0, $f98cea862b8a2ca9$export$c75dedfb09f9174d)(this);
            this.leaderboard.x = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w - 25;
            this.leaderboard.y = 0;
            this.stage.addChild(this.leaderboard);
            // equipped
            this.equipped = new (0, $9fb9be6d4b9a07da$export$ae188dfa452708ef)(this, {
                interaction: (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer.plugins.interaction,
                layer: this.stage,
                isWorldDrop: (point)=>(0, $065c5647ab3ff4dc$export$56359d4511c7424)().screen.contains(point.x, point.y) && (0, $f246f635ee3b2e66$export$7caecd373b84cec3).isWorldPoint(point),
                drop: (itemId)=>{
                    this.logic.playerController.suppressAttack();
                    this.logic.playerController.client.inventoryAction(this.logic.playerEntity.entityId, itemId, "drop");
                }
            });
            // The readied slots are the only way to swap weapon under a thumb, and at 1x they are a
            // ~32px icon on a 640x360 stage letterboxed down to a phone -- roughly 20 CSS px, and a
            // miss as often as a hit. Scaling the widget takes the slot art, the spacing and the tap
            // targets with it, the same way the control bar is scaled up on touch just below.
            // Anchored bottom-left off BOTTOM, so growing it reaches UP, into empty grass.
            if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) this.equipped.scale.set($7dd73ecdd94bfe01$var$EQUIPPED_TOUCH_SCALE);
            // Inset from the LEFT edge of the screen by exactly what the ember roster is inset from the
            // right (see positionEmberRoster). Both are children of `container`, which is itself offset,
            // so the margin is measured in screen space and the parent's offset taken back out -- the old
            // `container.x + 10` was a container-local number that put the tray at 30 on screen while the
            // roster sat at 6 on the other side.
            this.equipped.x = $7dd73ecdd94bfe01$export$15ae5481f3ca1c06 - container.x;
            // Anchored off the tray's KNOWN height rather than its measured one. The widget is empty
            // until the first inventory arrives, so measuring it here reads 0; the old line compensated
            // with a constant and then needed a second constant to undo what the touch scale did to the
            // guess. TRAY_HEIGHT is fixed by construction (gui/equipped.ts), so the tray can simply sit
            // on the bottom line, at either scale.
            this.equipped.y = $7dd73ecdd94bfe01$export$84e1549b474f1b93 - (0, $9fb9be6d4b9a07da$export$97f31c0e24982bcb) * ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() ? $7dd73ecdd94bfe01$var$EQUIPPED_TOUCH_SCALE : 1);
            container.addChild(this.equipped);
            // The vitals dock to the tray's top edge, so they can only be placed once it exists.
            this.positionVitals();
            // squad
            this.squad = new (0, $bbfac5179e5fdb9e$export$d5f40203d1afc530)(this);
            this.squad.x = 390;
            this.squad.y = $7dd73ecdd94bfe01$export$84e1549b474f1b93 - this.squad.height - 20;
            container.addChild(this.squad);
            // The connector from a roster-opened command wheel down to the card that opened it. Added
            // BEFORE the roster so the strip -- and the speech bubbles it floats above itself -- draw
            // over the line rather than the line over them.
            this.rosterWheelConnector = new (0, $gwPoJ.Graphics)();
            this.rosterWheelConnector.visible = false;
            container.addChild(this.rosterWheelConnector);
            // The same line for the ROLE PICKER a roster wheel can raise. Its own Graphics rather than a
            // share of the one above: updateCommandWheelTether wipes that one on every frame the wheel is
            // closed, which is every frame the picker is up.
            this.rolePickerConnector = new (0, $gwPoJ.Graphics)();
            this.rolePickerConnector.visible = false;
            container.addChild(this.rolePickerConnector);
            // ember roster (clickable NPC portraits; only populated in ember rooms). Anchored
            // bottom-right; repositioned as the card count changes (see positionEmberRoster).
            this.emberAnxietyMeter = new (0, $61be61f02d36c718$export$7da7148278a58213)();
            container.addChild(this.emberAnxietyMeter);
            this.emberRoster = new (0, $44af089a9f2b65fe$export$7b64a8ee2d511abd)(this);
            container.addChild(this.emberRoster);
            this.stage.addChild(this.recruitMenuHint);
            this.positionEmberRoster();
            // follow-cam PiP modal (opened by clicking a roster portrait). Positioned above the roster
            // on open (see positionFollowCam).
            this.followCam = new (0, $a800cd15c7729c86$export$6b342f104f181be3)(this, {
                onGrab: this.holdOffMinimapDragAttack,
                onDragTo: this.dragFollowCamTo,
                onRelease: this.holdOffMinimapDragAttack,
                onResize: ()=>this.dragFollowCamTo(this.followCam.x, this.followCam.y)
            });
            this.followCam.zIndex = 2;
            container.addChild(this.followCam);
            // ember minimap — under the MAP toggle by default, and anywhere on screen once the
            // player has dragged it there (see dragEmberMinimapTo). Stays hidden until the first per-room
            // broadcast arrives, and steps aside only for a panel it actually overlaps (see
            // positionEmberMinimap). Three sizes, cycled from its own corner control.
            //
            // Every one of the three preferences — folded away, parked where, and how big — is loaded
            // BEFORE the widget goes on screen, so the map never flashes up at the default and then
            // jumps to what the player chose last session.
            this.emberMinimapCollapsed = this.loadEmberMinimapCollapsed();
            this.emberMinimapPlacement = this.loadEmberMinimapPlacement();
            this.emberMinimapSize = this.loadEmberMinimapSize();
            this.emberMinimap = new (0, $27706b8361e494c8$export$72d7fbba603469ff)({
                onGrab: this.holdOffMinimapDragAttack,
                onDragTo: this.dragEmberMinimapTo,
                onRelease: this.dropEmberMinimap
            }, this.onEmberMinimapResized);
            this.emberMinimap.setSize(this.emberMinimapSize);
            container.addChild(this.emberMinimap);
            // SpriteLab rooms only; stays hidden until the server's first status reply.
            this.spriteLabPanel = this.createSpriteLabPanel();
            container.addChild(this.spriteLabPanel);
            // The map's toggle. Unlike the panels it sits beside in the chip row, it is on screen whether
            // the map is folded or not: it is the one place that says the map HAS an open state, which a
            // control that only existed while the map was hidden could never say.
            this.emberMinimapChip = new (0, $d36eec2a890b47fd$export$155d6b3ee6ea424d)(this.toggleEmberMinimap);
            chipLayer.addChild(this.emberMinimapChip);
            // Same inventory the control bar's button opens; this chip is simply where it lives when
            // the room has hidden that bar.
            this.emberInventoryChip = new (0, $4a2d6e0f8539e4d1$export$3adb491320ceffcc)(this.toggleInventory);
            chipLayer.addChild(this.emberInventoryChip);
            // The chat button, FOR TOUCH ONLY (chatChipWanted). Same argument as the items chip beside
            // it: a camp suppresses the control bar, and chat has only ever been opened with a key --
            // which a phone does not have. A keyboard does, so there the chip was a button repeating a
            // key the player already had, in the one corner of the screen the camp HUD is short of.
            this.chatChip = new (0, $ab150d38ea68b1cd$export$30768dbf6666e389)(()=>this.logic.playerController?.requestChat());
            chipLayer.addChild(this.chatChip);
            // "Who else is playing" -- the count chip sits immediately to the LEFT of the map toggle in
            // the top-right corner, and opens the list of online players down the right-hand edge below
            // it. Both stay hidden until the server says there is somebody else to show.
            this.emberPlayersPanel = new (0, $031092a28fb787ca$export$349ef492ca0f8a2a)({
                onInvite: (entityId)=>{
                    const player = this.emberPlayers.find((entry)=>entry.entityId === entityId);
                    if (!player || player.here) return;
                    this.hideCommandWheel();
                    this.hideRolePicker();
                    this.positionEmberInviteModal();
                    this.emberInviteModal.open(entityId, player.name);
                }
            });
            this.emberInviteModal = new (0, $7c95d0228c4864ae$export$1ae9dd6d410d7f23)((entityId, playMode)=>{
                const player = this.emberPlayers.find((entry)=>entry.entityId === entityId);
                if (!player || player.here) return;
                this.inviteEmberPlayer(entityId, playMode);
                this.emberPlayersPanel.markInvited(entityId);
            });
            this.emberInviteModal.zIndex = 65000;
            this.stage.addChild(this.emberInviteModal);
            container.addChild(this.emberPlayersPanel);
            this.emberPlayersChip = new (0, $847e936c2402c20f$export$79ada16547910660)(()=>this.setEmberPlayersOpen(!this.emberPlayersPanel.visible));
            chipLayer.addChild(this.emberPlayersChip);
            // The invitation prompt. Unlike the chip and the list this is NOT ember-only: an invitation
            // finds the player wherever they are, which is the point of being invited somewhere.
            this.emberInvitePrompt = new (0, $102f4cd7b044a43e$export$2910d5f40b7274eb)({
                onAnswer: this.answerEmberInvite
            });
            container.addChild(this.emberInvitePrompt);
            // abilities
            this.abilities = new (0, $ae9502ee83364da4$export$f69bebae58da6a32)(this);
            this.abilities.x = 390;
            this.abilities.y = this.equipped.y;
            container.addChild(this.abilities);
            // player
            this.nameText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().color(0x00ff00).render();
            this.nameText.y = 1;
            this.nameText.x = 90;
            container.addChild(this.nameText);
            // resource bar
            this.resourceBar = new (0, $11fe0387f9c174f1$export$85cd1614e509c3d9)(this);
            this.resourceBar.visible = true;
            this.resourceBar.setup();
            this.resourceBar.x = this.nameText.x + 5;
            this.resourceBar.y = this.nameText.y;
            container.addChild(this.resourceBar);
            const blackout = new (0, $gwPoJ.Graphics)();
            blackout.x = 0;
            blackout.y = 0;
            blackout.lineStyle(2, 0x000000);
            blackout.beginFill(0x000000);
            blackout.drawRect(0, 0, 1000, 1000);
            blackout.visible = true;
            blackout.alpha = 1.0;
            blackout.endFill();
            this.blackout = blackout;
            this.stage.addChild(blackout);
            const redout = new (0, $gwPoJ.Graphics)();
            redout.x = 0;
            redout.y = 0;
            redout.lineStyle(2, 0xff0000);
            redout.beginFill(0xff0000);
            redout.drawRect(0, 0, 1000, 1000);
            redout.visible = false;
            redout.alpha = 0.3;
            redout.endFill();
            this.redout = redout;
            this.stage.addChild(redout);
            this.minimapSurface.x = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + 40;
            this.minimapSurface.y = $7dd73ecdd94bfe01$export$84e1549b474f1b93 - 105;
            this.characterCustomizer = new (0, $16b4bf3d247fe459$export$6bed762da66f1ed6)(this, this.logic);
            this.characterBuilder = new (0, $5be630d7f2f3b131$export$49421d8fc42e7f44)(this, this.logic);
            const controlBar = new (0, $c95294a9bc078027$export$ee1739c2abaa1d8d)(this);
            if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) controlBar.scale.set(1.5);
            else controlBar.scale.set(0.7);
            controlBar.setup(()=>{
                this.logic.invokeInventory(null);
            }, ()=>{
                this.logic.invokeQuests();
            }, ()=>{
                this.invokeFeedback();
            }, ()=>{
                this.logic.playerController.client.requestWorldMap();
            }, ()=>{
                this.logic.playerController?.requestChat();
            });
            controlBar.x = screenWidth - controlBar.width - 18;
            controlBar.y = 4;
            controlBar.visible = false;
            this.controlBar = controlBar;
            this.container.addChild(controlBar);
            const stickyBanner = new (0, $0159750bbc757373$export$cd136f60375f2af0)(this);
            stickyBanner.setup();
            stickyBanner.y = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.07;
            stickyBanner.x = controlBar.x - stickyBanner.width - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.15;
            this.stickyBanner = stickyBanner;
            this.container.addChild(stickyBanner);
            // The animated helper windows (tutorial_demo.ts) and the dimming the rest of the screen takes
            // behind them. Over every HUD panel (the checklist, the wave dial, the obligations), so all of
            // it sits under the dim; under the command wheel and pickers a lesson sends the player to, the
            // chat composer, and every celebration and modal screen. In stage coordinates, which is what a
            // window places itself in.
            const tutorialDemoLayer = new (0, $8t5Gy.Container)();
            tutorialDemoLayer.zIndex = 59000;
            this.stage.addChild(tutorialDemoLayer);
            // The chip goes in because it is what the ember tutorial's first clue points at: a camp
            // suppresses the control bar, so the chip IS the Items button in there (see roomUpdated).
            this.tutorial = new (0, $dbd41000427e8969$export$825b76de5f2b0345)(this, this.container, this.equipped, this.controlBar, this.minimapSurface, this.emberInventoryChip, tutorialDemoLayer);
            this.dayCycle = new (0, $617042715e0a010b$export$5696eab43b4d4c5a)(this);
            this.dayCycle.visible = false;
            this.dayCycle.x = stickyBanner.x - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 5.25;
            this.dayCycle.y = stickyBanner.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.46;
            this.container.addChild(this.dayCycle);
            this.dayCycle.setup(90);
            // The `f` frame-rate readout. On the STAGE rather than in the HUD container, at a zIndex
            // above everything including the room-load curtain and the day/night mask: a perf tool that
            // goes dark exactly when the client is working hardest would be useless. Parked in the top
            // band between the health meters (and, in a camp, the wave dial under them) and the
            // day/night dial, which is the one strip of HUD no screen puts anything in.
            this.fpsMeter = new (0, $e9383df2bf94b4f7$export$b944265fdd8e54c4)();
            this.fpsMeter.x = $7dd73ecdd94bfe01$var$FPS_METER_X;
            this.fpsMeter.y = $7dd73ecdd94bfe01$var$FPS_METER_Y;
            this.fpsMeter.zIndex = 1000000;
            this.stage.addChild(this.fpsMeter);
            try {
                if (typeof localStorage !== "undefined" && localStorage.getItem($7dd73ecdd94bfe01$var$FPS_METER_KEY) === "true") this.fpsMeter.setOpen(true);
            } catch (error) {
                console.warn("Failed to read the fps readout's state from localStorage:", error);
            }
            this.featureWidget = new (0, $91106b3dea6906a4$export$6386e5268de7fe1f)(this);
            this.featureWidget.x = 0;
            this.featureWidget.y = 55;
            this.container.addChild(this.featureWidget);
            // The pre-wave countdown dial.
            this.countdownTimer = new (0, $d85ea5e2371a760e$export$5a0af15366b01c51)({
                radius: 50,
                strokeWidth: 7.5,
                textColor: 0xffffff
            });
            // Position timer on the top-left, directly under the HP bar and left-aligned to it.
            // The HP bar lives on `container` (offset by container.x), while the timer lives on the
            // stage, so add container.x to convert into stage space. The dial is center-anchored, so add
            // half its DIAL size to left- and top-align it against the HP bar: `width`/`height` would be
            // the measured bounds, which move with the dial's glow, its chip and its entrance scale, and
            // would therefore pin the HUD's geometry to whichever frame they happened to be read on.
            // Anchored on the same margin as the tray below it, rather than on whatever the hearts
            // happened to measure: they have gone to the bottom-left cluster (see positionVitals), and
            // this dial now heads the column by itself.
            this.countdownTimer.x = $7dd73ecdd94bfe01$export$15ae5481f3ca1c06 + this.countdownTimer.dialSize / 2;
            this.countdownTimer.y = $7dd73ecdd94bfe01$var$DIAL_TOP + this.countdownTimer.dialSize / 2;
            this.countdownTimer.visible = false;
            this.countdownTimer.zIndex = 50000 // Lower than chat bubbles (100000)
            ;
            this.stage.addChild(this.countdownTimer);
            // The ember gauge rides this column rather than sitting at a fixed height in it -- see
            // placeEmberFireGauge, which is the only thing that positions it. Matched to the dial's
            // width so the two read as one stack. It shares the under-dial slot with the invader's LET
            // GO button, which is safe because the two can never want it at once: a player wearing
            // someone else's body has no camp fire of their own to tend (see setInvading).
            this.emberFireGauge = new (0, $76215559f193965e$export$1ef3fa7c24f5e1bd)();
            this.emberFireGauge.setWidth(this.countdownTimer.dialSize);
            this.emberFireGauge.zIndex = 50000;
            this.stage.addChild(this.emberFireGauge);
            // Above the HUD, because it is a camera effect rather than a panel -- but below every modal
            // (invite 65000, run summary 70000): a wave landing behind an end-of-run panel must not wash
            // over the panel.
            this.waveLandingFlash = new (0, $4911350b96cb29c4$export$76d08da91ef0fbea)();
            this.waveLandingFlash.zIndex = 62000;
            this.stage.addChild(this.waveLandingFlash);
            window.waveLanding = (wave = 12)=>this.playWaveLanding(wave, true);
            // Ember wave badge. Sits exactly where the countdown dial does and is the same size: the
            // dial counts DOWN to the wave, then vanishes and this takes the slot for as long as the
            // wave lasts. The two are never up together (see addScreenMessage).
            this.waveIndicator = new (0, $3220884133cc6599$export$20faccd1109d9248)({
                radius: 50,
                strokeWidth: 7.5
            });
            this.waveIndicator.x = this.countdownTimer.x;
            this.waveIndicator.y = this.countdownTimer.y;
            this.waveIndicator.zIndex = 50000;
            this.stage.addChild(this.waveIndicator);
            // "Let go" -- the invader's way out, and the only exit of the five they press themself. It
            // continues the top-left column (HP bar, then the countdown dial / wave badge) rather than
            // taking a corner of its own: an invader is reading that dial, so the way out sits where
            // they are already looking. Placed once, like the dial above it.
            this.letGoButton = new (0, $daf4f1c650b6c0f9$export$59009c2c2d99348c)({
                onPress: ()=>{
                    this.logic.playerController?.client?.sendEmberInvasionCommand("release");
                    this.logic.playerController?.client?.logActivity("invasion: let go");
                }
            });
            // Clear of whichever dial is up. Both of them now name their wave INSIDE the ring (see
            // dial.ts), so this sits right under the dial rather than under a pill hanging off it.
            this.letGoButton.x = Math.round(this.countdownTimer.x - this.letGoButton.getWidth() / 2);
            this.letGoButton.y = Math.round(this.countdownTimer.y + Math.max(this.countdownTimer.bottomExtent, this.waveIndicator.bottomExtent) + 10);
            this.letGoButton.zIndex = 50001;
            this.stage.addChild(this.letGoButton);
            // command wheel - positioned in center of screen
            this.commandWheel = new (0, $7676384fbaf9cdf2$export$a36bd337d7c5ab90)({
                radius: $7dd73ecdd94bfe01$var$COMMAND_WHEEL_RADIUS,
                // A soft tick as the pointer crosses onto another order, so aiming has a feel to it.
                onHoverChange: ()=>this.logic.audio.uiHover(),
                onCommandSelect: (command, npcType)=>{
                    // Confirmation click, before the branch below: both the interaction page and the
                    // squad command channel are the same gesture from the player's side.
                    this.logic.audio.uiSelect();
                    // targetEntityId is set only when the wheel was opened from a specific NPC's
                    // command button; otherwise the command broadcasts to the whole role.
                    const targetEntityId = this.commandWheel.getTargetEntityId();
                    if (this.tileWheelTarget) {
                        const { yOffset: yOffset, ...target } = this.tileWheelTarget;
                        this.logic.playerController.suppressAttack();
                        this.logic.playerController.client.emitPlayerEvent({
                            playerEventType: "ACTIVATE_TILE_INTERACTION",
                            context: {
                                ...target,
                                interaction: command
                            }
                        });
                        this.hideCommandWheel();
                        return;
                    }
                    // The interaction page's "commands" are interaction types on one entity, so they go
                    // out on the interaction channel rather than the squad command channel.
                    if (npcType === (0, $7676384fbaf9cdf2$export$f672e119ffb748dd)) {
                        if (command === "ember:play_mode" && targetEntityId) {
                            const mode = this.recruitHintRoster.find((entry)=>entry.entityId === targetEntityId)?.playMode || "pvp";
                            this.hideRolePicker();
                            this.hideCommandWheel();
                            this.rolePickerRosterId = targetEntityId;
                            this.showRolePicker(targetEntityId, undefined, {
                                playMode: mode
                            });
                            return;
                        }
                        if (command === "ember:kick" && targetEntityId) {
                            this.logic.playerController.client.kickEmberPlayer(targetEntityId);
                            this.hideCommandWheel();
                            return;
                        }
                        // "Watch" is the HUD's own slice, not the entity's: it swaps this wheel for the
                        // follow-cam PiP in the same slot. It only ever appears on a wheel opened from a
                        // roster card, which is the one place the follow cam is otherwise unreachable.
                        if (command === $7dd73ecdd94bfe01$var$WATCH_SLICE) {
                            const watching = targetEntityId;
                            const watchingName = this.rosterInteractionName;
                            this.hideCommandWheel();
                            if (watching) this.openFollowCam(watching, watchingName);
                            return;
                        }
                        // Out of reach: say so and leave the wheel up, rather than sending an order
                        // that the server would refuse and the player would read as a dead button. The
                        // wheel staying open matters -- "Watch" is right there, and watching them is
                        // the useful thing to do from where they are standing.
                        if (targetEntityId && (0, $0fb3f7f2a67be6e3$export$3799b383fc0956ea)(command) && !this.withinInteractionReach(targetEntityId)) {
                            this.addScreenMessage({
                                target: "important",
                                text: "Too far away. Go to them."
                            });
                            return;
                        }
                        this.hideCommandWheel();
                        if (targetEntityId) {
                            this.logic.interactionCallback(targetEntityId, command);
                            this.logic.playerController.client.logActivity(`interaction wheel: ${command} on ${targetEntityId}`);
                        }
                        return;
                    }
                    if (this.watchMemberCommand(command, targetEntityId)) return;
                    // "Hold Position" (a defender's or the Lord's) asks for a PLACE as well as an order.
                    // Hand the pointer to the location picker and let the click that follows carry the
                    // spot; until then nothing goes to the server. On touch there is no hovering pointer
                    // to aim with, so the order keeps its older meaning there: hold where they stand.
                    if ((0, $7676384fbaf9cdf2$export$a4f042548a204485)(command) && !(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) {
                        this.hideCommandWheel();
                        this.logic.playerController.beginLocationPick({
                            caption: "Click the spot to hold",
                            blockedCaption: "Nothing can stand here",
                            onPick: (point)=>{
                                this.logic.playerController.client.sendCommandWheelSelection(command, npcType, targetEntityId, point);
                                this.logic.playerController.client.logActivity(`command wheel: ${command} for ${npcType} at ` + `${Math.round(point.x)},${Math.round(point.y)}`);
                            }
                        });
                        return;
                    }
                    // "Change Role" doesn't order anything -- it asks the server for the role picker. Where
                    // that picker should OPEN is known only here, at the wheel that asked: from a roster
                    // card it belongs in the HUD slot that wheel is leaving, not over a member who may be
                    // off in the forest. Recorded before hideCommandWheel below lets go of the card.
                    if ((0, $7676384fbaf9cdf2$export$88ecc0b698fd48f6)(command) && targetEntityId && this.commandWheelRosterId === targetEntityId) this.rolePickerRosterId = targetEntityId;
                    else if ((0, $7676384fbaf9cdf2$export$88ecc0b698fd48f6)(command)) this.rolePickerRosterId = undefined;
                    // Work given to a forager is what the chapter-three helper teaches; once it has been
                    // given, the helper has done its job.
                    if (npcType === "forager" && !(0, $7676384fbaf9cdf2$export$88ecc0b698fd48f6)(command)) this.tutorial?.foragerOrdered();
                    this.logic.playerController.client.sendCommandWheelSelection(command, npcType, targetEntityId);
                    this.logic.playerController.client.logActivity(`command wheel: ${command} for ${npcType}`);
                    // The per-entity wheel is not tied to the Control key, so dismiss it on selection.
                    if (targetEntityId) this.hideCommandWheel();
                }
            });
            this.commandWheel.x = screenWidth / 2;
            this.commandWheel.y = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h / 2;
            // Screen-center "home" the global (Control-key) wheel returns to after a per-entity wheel
            // has moved it over an NPC.
            this.commandWheelHome = {
                x: this.commandWheel.x,
                y: this.commandWheel.y
            };
            this.commandWheel.visible = false;
            this.commandWheel.zIndex = 60000 // Higher than countdown timer
            ;
            // The tether lives in the same (stage) frame as the wheel so both ends can be expressed in
            // stage-local coordinates, and sits just under it so the line tucks behind the disc.
            this.commandWheelTether = new (0, $gwPoJ.Graphics)();
            this.commandWheelTether.visible = false;
            this.commandWheelTether.zIndex = this.commandWheel.zIndex - 1;
            this.stage.addChild(this.commandWheelTether);
            this.stage.addChild(this.commandWheel);
            // recruit role picker — opened by the server over a specific camp member (like the per-entity
            // command wheel). Selecting a card sends the chosen role back on the SQUAD_COMMAND channel,
            // scoped to that member, which its script turns into a swap to the role.
            //
            // Two commands, because the two moments are answered by different scripts: `recruit:<role>` is
            // the HIRE, answered by ember-recruit.js (which also charges the food), and `role:<role>` is a
            // CHANGE on an already-hired member, answered by its own role script (lib/role_change.js).
            // Keeping them apart is what stops a stray hire landing on a member, or a change on a recruit.
            this.rolePicker = new (0, $1a2af550e0229b29$export$fcd75734e151a80)({
                onSelect: (role, currentRole)=>{
                    if ((role === "up" || role === "down") && this.stairPickerMessage) {
                        const choice = this.stairPickerMessage.stairChoices[role];
                        this.stairPickerMessage = undefined;
                        this.logic.playerController.client.emitPlayerEvent(choice);
                        this.hideRolePicker();
                        return;
                    }
                    const targetEntityId = this.rolePicker.getTargetEntityId();
                    if (role === "pvp" || role === "cooperation") {
                        this.logic.playerController.client.setEmberPlayMode(targetEntityId, role);
                        this.hideRolePicker();
                        return;
                    }
                    const command = currentRole ? `role:${role}` : `recruit:${role}`;
                    this.logic.playerController.client.sendCommandWheelSelection(command, "recruit", targetEntityId);
                    this.logic.playerController.client.logActivity(`role picker: ${command} for ${targetEntityId}`);
                    this.hideRolePicker();
                }
            });
            this.rolePicker.visible = false;
            this.rolePicker.zIndex = 60000 // Same tier as the command wheel
            ;
            this.stage.addChild(this.rolePicker);
            // name prompt -- opened by the server over a camp member (at the end of a hire, or on the
            // "Rename" order) so the player can name it. The field starts on the name the member
            // already has, so backing out is a complete answer and simply keeps it.
            this.namePrompt = new (0, $c40c25df820e3512$export$8a1c693d5de025d7)({
                onSubmit: (name)=>{
                    const targetEntityId = this.namePrompt.getTargetEntityId();
                    if (targetEntityId) {
                        this.logic.playerController.client.sendEntityName(targetEntityId, name);
                        this.logic.playerController.client.logActivity(`named ${targetEntityId} "${name}"`);
                    }
                    this.hideNamePrompt();
                },
                onCancel: ()=>this.hideNamePrompt()
            });
            this.namePrompt.visible = false;
            this.namePrompt.zIndex = 60001 // Just over the role picker, which it opens on top of
            ;
            this.stage.addChild(this.namePrompt);
            // The location chooser — the reticle a "Hold Position" order puts under the pointer while
            // the player picks the spot. It only draws; the pick itself (and the click that ends it)
            // belongs to PlayerController, which owns world presses.
            this.buildingPrintCountdown = new (0, $e66d7f5cf01e9ed1$export$a3b4303fb9c66aa0)(()=>this.logic.clientRenderer.map().getTileSurface());
            this.locationPicker = new (0, $76a97c569b52295c$export$2e19b9798c747684)();
            this.stage.addChild(this.locationPicker);
            // ember end-of-run scorecard — put up by the server when the player dies in an ember camp
            // (Protocol.type_showRunSummary). Its two buttons go back to the ember controller, which
            // either stands the player up in the camp they fell in or resets that camp; the
            // panel dismisses itself as it sends. Whether a restart is on the table at all is the
            // camp's call (it rides in on the summary's lives) — the controller enforces it either way.
            this.runSummary = new (0, $8bf61ed7fd954e0e$export$786eace44478b97d)({
                onTryAgain: ()=>{
                    this.logic.playerController.client.sendEmberRunCommand("tryAgain");
                    this.logic.playerController.client.logActivity("run summary: try again");
                    this.hideRunSummary();
                },
                onRestart: ()=>{
                    this.logic.playerController.client.sendEmberRunCommand("restart");
                    this.logic.playerController.client.logActivity("run summary: restart");
                    this.hideRunSummary();
                },
                // The third way on. The press opens the picker from the list the client ALREADY holds
                // -- the offer is an interval feed, not a reply -- and the `seek` that goes with it is
                // only a nudge for a fresher list. Nothing waits on the server.
                onInvade: ()=>{
                    this.logic.playerController.client.sendEmberInvasionCommand("seek");
                    this.logic.playerController.client.logActivity("run summary: resurrect as undead");
                    this.showInvasionPicker();
                }
            });
            this.runSummary.visible = false;
            // Above the command wheel / role picker: this one is a full-screen modal over a finished run.
            this.runSummary.zIndex = 70000;
            this.stage.addChild(this.runSummary);
            // The camp chooser, opened from the scorecard and drawn over it. Picking a card is the last
            // press of the whole handshake: the server moves the player, and every exit from there is a
            // fresh camp of their own (see docs/ember-the-fallen-design.md, "Leave").
            this.invasionPicker = new (0, $daf4f1c650b6c0f9$export$9306c99f3e124fbc)({
                onJoin: (entityId)=>{
                    this.logic.playerController.client.sendEmberInvasionCommand("join", entityId);
                    this.logic.playerController.client.logActivity(`invasion: join ${entityId}`);
                    this.hideInvasionPicker();
                },
                onCancel: ()=>{
                    this.cancelInvasionPicker();
                }
            });
            this.invasionPicker.visible = false;
            // Over the scorecard, which stays up behind it.
            this.invasionPicker.zIndex = 70001;
            this.stage.addChild(this.invasionPicker);
            // The two doorways of a possession. Above BOTH of those, because it is the one thing on the
            // screen the player has not seen yet -- and because the far end of a visit arrives together
            // with a whole new room, whose load must not draw over it.
            this.possessionSplash = new (0, $fd1228436d3e60cd$export$3cab3b6954a18297)({
                onDismiss: ()=>{
                    this.logic.playerController?.client?.logActivity("possession splash dismissed");
                }
            });
            this.possessionSplash.visible = false;
            this.possessionSplash.zIndex = 70002;
            this.stage.addChild(this.possessionSplash);
            // The chapter's quest log, under the fire gauge, and the celebrations that land in it: a task
            // done is toasted mid-screen and its diamond flown into the row; a chapter done is a fanfare
            // that docks into the panel, where Continue / Next Chapter then wait.
            this.chapterChecklist = new (0, $355f6bd9e8d13e25$export$ec54e50cc454228d)((over)=>this.mouseOverControl(over), ()=>{
                const gauge = this.emberFireGauge;
                if (!gauge) return undefined;
                // In the gauge's own slot while the gauge is held back, and eased down under it as it
                // arrives, so the list is never left hanging under an empty space.
                const top = gauge.y - gauge.height_ / 2;
                return {
                    x: gauge.x,
                    y: top + this.hudPresence.arrival("fireGauge") * (gauge.height_ + 6)
                };
            }, {
                onTaskCompleted: (task)=>this.chapterCelebration.taskComplete(task.label, ()=>this.chapterChecklist.socketGlobal(task.id), ()=>this.chapterChecklist.reveal(task.id)),
                onChapterCompleted: (chapter, title)=>this.chapterCelebration.chapterComplete(chapter, title, ()=>this.chapterChecklist.panelGlobal(), ()=>this.chapterChecklist.dock()),
                onContinue: ()=>{
                    this.logic.playerController.client.sendEmberTutorialCommand("continue_story", "click");
                    this.logic.playerController.client.logActivity("chapter checklist: continue_story (click)");
                },
                onNextChapter: (chapter)=>{
                    if (this.currentModal || this.chapterAnnouncement.isOpen()) return;
                    this.logic.playerController.client.sendEmberTutorialCommand("preview_chapter", "click", chapter);
                }
            });
            this.chapterChecklist.zIndex = 55000;
            this.stage.addChild(this.chapterChecklist);
            // Above the HUD and the tutorial board, below every modal and the chapter title card.
            // It keeps clear of anyone's speech bubble (the Lord nearly always has something to say at
            // these moments) and of the building and forager helper windows.
            this.chapterCelebration = new (0, $06087902db7be4a6$export$8092756ceb312dc6)((cue)=>{
                if (cue === "task") this.logic.audio.chapterTaskComplete();
                else if (cue === "stamp") this.logic.audio.chapterTaskStamp();
                else this.logic.audio.chapterComplete();
            }, undefined, ()=>{
                const rects = (0, $a77286236663d69d$export$54b23a9eafdee768).screenRects();
                const helper = this.tutorial?.demoBounds();
                if (helper) rects.push({
                    x: helper.x,
                    y: helper.y,
                    w: helper.width,
                    h: helper.height
                });
                return rects;
            });
            this.chapterCelebration.zIndex = 62000;
            this.stage.addChild(this.chapterCelebration);
            this.chapterAnnouncement = new (0, $902b76aaa1df7480$export$1ecb9b86807e092e)((chapter)=>{
                this.logic.playerController.client.sendEmberTutorialCommand("begin_chapter", "click", chapter);
                this.logic.playerController.enabledKeyboardAction(true);
                this.logic.playerController.enabledMouseAction(true);
                this.logic.playerController.suppressAttack?.(300);
            }, ()=>!!this.logic.playerController && !!this.logic.playerEntity?.entityId, (chapter)=>{
                this.logic.playerController.client.sendEmberTutorialCommand("maybe_later", "click", chapter);
                this.logic.playerController.enabledKeyboardAction(true);
                this.logic.playerController.enabledMouseAction(true);
                this.logic.playerController.suppressAttack?.(300);
            }, (cue)=>{
                if (cue === "reveal") this.logic.audio.chapterAnnounce();
                else this.logic.audio.chapterBegin();
            });
            this.chapterAnnouncement.zIndex = 80000;
            this.stage.addChild(this.chapterAnnouncement);
            // first-run ember tutorial invitation — put up by ember-tutorial.js on a player's very
            // first camp (Protocol.type_showTutorialPrompt). Either button answers on the generic
            // player-event channel, and so does letting the countdown run out (which means "go ahead").
            // Low on the screen and clear of the roster strip (bottom-right) and the wave dial
            // (top-left), so the Lord stays visible while he talks.
            this.tutorialPrompt = new (0, $6d8fdbf74f9b9254$export$7d04c213ce109943)({
                onChoose: (choice, reason)=>{
                    this.logic.playerController.client.sendEmberTutorialCommand(choice, reason);
                    this.logic.playerController.client.logActivity(`tutorial prompt: ${choice} (${reason})`);
                    this.hideTutorialPrompt();
                    if (choice === "skip") // Anything still waiting on a "Next" belongs to a scene that is over, and a
                    // held bubble SWALLOWS what comes after it: lines spoken while one is up queue
                    // behind it and inherit its hold (AvatarHud.spoke), which is exactly what the
                    // Lord's sign-off must not do to the player who just declined the lesson.
                    this.logic.clientRenderer.entity().releaseHeldSpeech();
                }
            });
            this.tutorialPrompt.x = screenWidth / 2 - (0, $6d8fdbf74f9b9254$export$7d04c213ce109943).stageWidth() / 2;
            this.anchorTutorialPrompt();
            this.tutorialPrompt.visible = false;
            // Same tier as the command wheel / role picker: above the HUD, below the run scorecard.
            this.tutorialPrompt.zIndex = 60000;
            this.stage.addChild(this.tutorialPrompt);
            // hero message - positioned in center of screen
            this.heroMessage = new (0, $4a3ce4bbe28116a7$export$75ee3f18f40024cd)();
            this.heroMessage.zIndex = 60000 // Higher than countdown timer
            ;
            this.stage.addChild(this.heroMessage);
            this.intro = new (0, $93842021a2e36862$export$b3c44ac484b3c461)(this);
            this.layoutHudEdges();
            // A press anywhere that isn't the wheel puts the wheel away (see onOutsidePress). Bound once,
            // for the life of the HUD, and inert while no wheel is up.
            if (typeof document !== "undefined") document.addEventListener("pointerdown", this.onOutsidePress, true);
        };
        // Dismiss-on-outside-press. A wheel is modal in intent but not in fact -- it floats over the
        // world and the world goes on taking clicks underneath it -- so a press that lands anywhere else
        // has to read as "put it away". Presses arrive on the DOCUMENT (see Mouse.pressIsOnGui), which is
        // why this asks pixi what was under the pointer rather than hanging a handler off the stage: a
        // press on empty canvas hits nothing and would never reach one.
        //
        // Capture phase, so it runs before the widget the press landed on: a press on another roster card
        // closes this wheel and then that card opens its own.
        //
        // Three things own their own presses and are left alone: the wheel itself (a slice is a choice,
        // not a dismissal), the role picker (a sibling of the wheel, not a rival), and the roster strip,
        // whose cards re-target the wheel or toggle it off themselves.
        this.onOutsidePress = (event)=>{
            if (!this.commandWheel?.isOpen()) return;
            const target = (0, $f246f635ee3b2e66$export$7caecd373b84cec3).pressTarget(event);
            // Can't tell (no interaction plugin) is not the same as "landed on nothing": leave it up.
            if (target === undefined) return;
            for(let node = target; node; node = node.parent){
                if (node === this.commandWheel || node === this.rolePicker || node === this.namePrompt || node === this.emberRoster) return;
            }
            this.hideCommandWheel();
        };
        this.updateDayPct = (pct)=>{
            if (pct !== undefined && !this.suppressDayCycle) {
                this.dayCycle.visible = true;
                this.dayCycle.setup(pct * 360);
            }
        };
        this.getIntro = ()=>this.intro;
        this.log = (msg)=>this.logic.playerController.client.logActivity(msg);
        // The wire's one way into the tutorial layer: an overworld popup, an ember clue to arm, or -- on a
        // null type -- the server taking the ember clues back down (see Tutorial.setup).
        this.showTutorial = (tutorialType, timeoutMs)=>{
            this.tutorial.setup(tutorialType, timeoutMs);
        };
        // What the inventory/crafting panel calls to say where one of the clued controls landed, and to
        // take the pointer off one it is no longer drawing.
        this.tutorialClues = ()=>this.tutorial;
        this.invokeFeedback = ()=>{
            this.logic.playerController.client.logActivity("Opened feedback widget");
            const feedback = new (0, $95442441126989b8$export$175e500a48a60fd2)(this, {
                onSubmit: (feedback)=>{
                    if ((feedback.feedback || "").trim().length > 0) {
                        this.addScreenMessage({
                            target: "important",
                            text: "Thanks. Your feedback will improve the game!"
                        });
                        this.logic.playerController.client.submitFeedback(feedback);
                    }
                }
            });
            feedback.setup();
        };
        this.helpMessaging = ()=>{
            // Hand the world's mouse back before anything is torn down. Both buttons below take it away
            // while the pointer is on them, and this rebuild is how they go: the message button calls
            // haltMessageIndicator from its own click handler, its throbber does the same 30s later with
            // nobody touching anything, and the level-up button goes when the points are spent. pixi
            // delivers no mouseout to a removed display object -- and none at all to one whose PARENT is
            // removed, which is how the message button goes -- so the latch would stay set and every
            // world click (walk, swing, fire) would be dead until the next room load.
            this.helpMessagingButtons.forEach((button)=>button.releaseMouseControl());
            this.helpMessagingButtons = [];
            // cleanout old message
            const existingMessage = this.container.getChildByName("_help_messaging_");
            if (existingMessage) existingMessage.parent.removeChild(existingMessage);
            // The "Level up stats!" prompt is positioned independently (beside the hp/mana bars), not
            // in the help-messaging stack — clean up its previous instance here too.
            const existingLevelUp = this.container.getChildByName("_level_up_stats_");
            if (existingLevelUp) existingLevelUp.parent.removeChild(existingLevelUp);
            const helpMessaging = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)();
            helpMessaging.name = "_help_messaging_";
            this.container.addChild(helpMessaging);
            const messages = [];
            const items = [];
            if (this.logic.playerController.isGuest() && !this.suppressGuestPrompt) messages.push("/register to save progress");
            let previous = null;
            messages.forEach((message)=>{
                const messageText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().align("right").render(message);
                helpMessaging.addChild(messageText);
                if (previous) messageText.y = previous.y - messageText.height;
                items.push(messageText);
                previous = messageText;
            });
            if (this.incomingMessageMeta.unread) {
                const haltIndicator = (showDialog = true)=>{
                    if (showDialog) this.doDynamicDialog(this.incomingMessageMeta.text);
                    this.haltMessageIndicator();
                };
                const button = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
                    label: "Incoming message",
                    preset: "compact",
                    variant: "danger",
                    tone: "accent",
                    height: (0, $97475243e21a0995$export$73e83bf2b7e02467).small.height,
                    onClick: ()=>{
                        this.log("open incoming message");
                        haltIndicator(true);
                    },
                    mouseControlCallback: (on)=>{
                        this.logic.playerController.enabledMouseAction(!on);
                    }
                });
                button.y = (previous?.y ?? 0) - button.height;
                new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(button, {
                    expires: 30000,
                    blinkInterval: 20,
                    releaseCallback: ()=>haltIndicator(false)
                }).update();
                previous = button;
                helpMessaging.addChild(button);
                items.push(button);
                this.helpMessagingButtons.push(button);
            }
            if (this.upgradeIndicator && !this.suppressLevelUp) {
                const button = (0, $83d1a97b87afddc2$export$9b6d6ca62970729f)({
                    label: "Level up stats!",
                    preset: "compact",
                    variant: "primary",
                    width: 120,
                    height: (0, $97475243e21a0995$export$73e83bf2b7e02467).small.height,
                    onClick: ()=>{
                        this.log("open stats upgrade ui");
                        this.logic.playerController.client.invokeStatUpgradeUI();
                    },
                    mouseControlCallback: (on)=>{
                        this.logic.playerController.enabledMouseAction(!on);
                    }
                });
                new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(button, {
                    expires: 5000,
                    blinkInterval: 20
                }).update();
                // Beside the countdown dial, which is what heads the top-left column now that the
                // hearts have gone down to the tray. On the dial's mid-line rather than its top, so it
                // and the camp-tasks stack (which hangs from the dial's TOP, in the same gutter) have
                // to overlap before they collide. Both are transient; neither is common.
                button.name = "_level_up_stats_";
                // GUARDED, and deliberately: this is cosmetic placement sitting on the path that builds
                // a live HUD button, and nothing about where a button lands is worth throwing out of
                // (the crafting screen once vanished entirely over a measuring helper that threw). The
                // dial is built in the constructor so the fallback is only ever reached under a stub.
                const dial = this.countdownTimer;
                button.x = (dial ? dial.x + dial.dialSize / 2 + 12 : $7dd73ecdd94bfe01$export$15ae5481f3ca1c06) - this.container.x;
                button.y = (dial ? dial.y : this.hudTopEdge()) - this.container.y;
                this.container.addChild(button);
                this.helpMessagingButtons.push(button);
            }
            helpMessaging.x = this.minimapSurface.x - helpMessaging.width - 10;
            helpMessaging.y = $7dd73ecdd94bfe01$export$84e1549b474f1b93 - 30 + (0, $167efe97b4119a5d$export$b0f20d83cec42115)().insetY;
            items.forEach((item)=>{
                item.x = helpMessaging.width - item.width;
            });
        };
        this.update = (player)=>{
            // A FALLEN player reads EMPTY whatever their hp says. The server restores hp as part of
            // standing a downed player back up (standUpDownedPlayer), and that lands while the client
            // is still holding its own death state -- so the hearts refilled underneath a black screen,
            // which is where "you died and your health went up" came from. Zero is the honest reading
            // of being dead, and it moves the refill to the moment the player is actually back up
            // (ClientGameLogic.respawned clears `downed` and fades in together).
            //
            // `hasFallen`, not `isDowned`: the deadline behind isDowned is server-side state, so on the
            // client it answers NO on the very machine drawing the death screen. The client's truth is
            // the `downed` mirror that updateFromPlayerMessage sets from every world-state message.
            const downed = player.hasFallen();
            if (this.currentPlayerHp !== player.hp || this.currentPlayerHpMax !== player.maxHp || this.currentPlayerDowned !== downed) {
                this.hp.max = 10;
                // maxHp can be zero on a half-built or possessed entity, and 0/0 is NaN -- which the
                // meter would carry all the way into a mask rectangle.
                const ratio = player.maxHp > 0 ? player.hp / player.maxHp : 0;
                this.hp.update(downed ? 0 : ratio * this.hp.max);
                this.currentPlayerHp = player.hp;
                this.currentPlayerHpMax = player.maxHp;
                this.currentPlayerDowned = downed;
            }
            if (this.currentPlayerHunger !== player.hunger || this.currentPlayerHungerMax !== player.maxHunger) {
                this.hunger.visible = !this.suppressFood;
                this.hunger.update(player.hunger / player.maxHunger * this.hunger.max);
                this.currentPlayerHunger = player.hunger;
                this.currentPlayerHungerMax = player.maxHunger;
            }
            if (this.currentPlayerMana !== player.mana || this.currentPlayerManaMax !== player.maxMana) {
                this.mana.visible = !this.suppressMana;
                this.mana.update(player.maxMana > 0 ? player.mana / player.maxMana : 0);
                this.currentPlayerMana = player.mana;
                this.currentPlayerManaMax = player.maxMana;
            }
            if (this.currentPlayerName !== player.name || this.currentScore !== player.score) {
                let name = player.safeName();
                this.nameText.text = `${name}, Lvl ${Math.floor(player.level)}`;
                // this.nameText.text = `${name} - Lvl ${player.level} | `
                // this.nameText.text += `${Math.floor(player.score)}/${Math.floor(player.score + player.scoreTilNextLevel)} next level`
                this.currentPlayerName = player.name;
                this.currentScore = player.score;
            }
            if (this.currentPlayerUpgradePoints !== player.upgradePoints) {
                this.currentPlayerUpgradePoints = player.upgradePoints;
                this.upgradeIndicator = this.currentPlayerUpgradePoints > 0;
                this.helpMessaging();
            }
            if (player && player.entityId === this.logic.playerEntity.entityId && !this.joystickSetup) {
                this.setupJoystick(this.container);
                this.joystickSetup = true;
            }
            if (player && player.entityId === this.logic.playerEntity.entityId) {
                if (this.characterBuilder.isOpen()) this.characterBuilder.update();
            }
            this.positionVitals();
        };
        this.updateRecruitMenuHint = (_deltaTime)=>{
            if (this.recruitLessonPlayerId !== this.logic.playerEntity?.entityId) {
                this.recruitLessonPlayerId = this.logic.playerEntity?.entityId;
                this.recruitMenuLearnedLocally = false;
                this.campfireMenuLearnedLocally = false;
            }
            // Chapter checklists now guide recruitment; keep the old anchored gesture hint hidden.
            this.recruitMenuHint.reset();
        };
        this.recordCampfireMenuLearned = (entityId)=>{
            if (this.logic.getEntity(entityId)?.contextMenuSubject !== "campfire" || this.campfireMenuLearnedLocally || this.logic.playerEntity?.campfireMenuLearned) return;
            this.campfireMenuLearnedLocally = true;
            this.logic.playerController.client.emitPlayerEvent({
                playerEventType: "ENTITY_CONTEXT_MENU_OPENED",
                context: {
                    entityId: entityId
                }
            });
        };
        this.learnedEntityMenu = (entityId)=>{
            if (this.logic.getEntity(entityId)?.contextMenuSubject === "campfire") {
                this.recordCampfireMenuLearned(entityId);
                return;
            }
            this.recruitMenuHint.dismiss();
            this.recordRecruitMenuLearned(entityId, "ENTITY_CONTEXT_MENU_OPENED");
        };
        this.recordRecruitMenuLearned = (entityId, playerEventType)=>{
            const entity = this.logic.getEntity(entityId);
            if (entity?.contextMenuSubject !== "recruit") return;
            if (this.recruitMenuLearnedLocally || this.logic.playerEntity?.recruitMenuLearned) return;
            this.recruitMenuLearnedLocally = true;
            this.logic.playerController.client.emitPlayerEvent({
                playerEventType: playerEventType,
                context: {
                    entityId: entityId
                }
            });
        };
        this.updateEmberAnxiety = (feeling, roomId)=>{
            if (!this.acceptsSceneRoom(roomId)) return;
            this.emberAnxietyMeter?.update(feeling);
        };
        this.updateTimer = (deltaTime)=>{
            if (this.emberAnxietyMeter?.visible) {
                const viewport = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().safeViewport;
                const scale = Math.min((0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().touch ? 1.4 : 1, viewport.width / 298);
                this.emberAnxietyMeter.scale.set(scale);
                this.emberAnxietyMeter.position.set(viewport.left + 12, viewport.top + 65);
                // The meter beats, so it needs the frame clock. Only while it is up: away from the
                // cave it is hidden and costs nothing.
                this.emberAnxietyMeter.animate(deltaTime);
            }
            // The command wheel's open/close, hover light and pick flash. Returns at once while it rests.
            this.commandWheel?.animate(deltaTime);
            if (this.mousePointer?.visible) {
                const controller = this.logic.playerController;
                const point = this.logic.clientRenderer?.mouse().state().position;
                this.mousePointer.animate(deltaTime, !!controller?.isAttacking(), (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() || !controller?.isMouseActionEnabled() || !this.logic.playerEntity || this.logic.playerEntity.isDead() || this.logic.playerEntity.hasFallen() || this.isCommandWheelVisible() || this.isItemScreenOpen() || !!this.isChatComposerVisible() || !!this.isNamePromptVisible() || !!this.isRolePickerVisible() || !!(point && !(0, $f246f635ee3b2e66$export$7caecd373b84cec3).isWorldPoint(new (0, $6qzqq.Point)(point.x, point.y))));
            } else this.mousePointer?.animate(deltaTime, false, true);
            this.updateGameplayControls();
            this.layoutHudEdges();
            this.updateMobileBuildToolbar();
            this.positionVitals();
            // The hearts drain, beat and flash off the frame clock rather than a wall-clock interval,
            // so they need the delta. A resting meter returns from this immediately.
            this.hp?.animate(deltaTime);
            this.mana?.animate(deltaTime);
            // Slide the readied selection ring and breathe the wear gauges of fragile weapons.
            this.equipped?.animate(deltaTime);
            this.placeColumnHead();
            this.placeEmberFireGauge(deltaTime);
            this.emberFireGauge?.animate(deltaTime);
            this.waveLandingFlash?.animate(deltaTime);
            this.tutorial?.refreshHudAnchors();
            // The clues' brackets breathe and their notes slide in and fade out off the frame clock.
            // Returns at once with no clue up, which is all but the first minutes of a first camp.
            this.tutorial?.animate(deltaTime);
            // The frame-rate readout, fed the render loop's own delta. A no-op while it is away.
            this.fpsMeter?.sample(deltaTime);
            // The render loop calls this even when no player/entity state has changed.
            this.buildingPrintCountdown?.update();
            this.logic.playerController?.animatePendingBuilds?.();
            if (this.countdownTimer && this.countdownTimer.visible) this.countdownTimer.update(deltaTime);
            this.updateRecruitMenuHint(deltaTime);
            // Cheap when nothing is moving: the badge only repaints on a change or a live animation.
            this.waveIndicator?.animate(deltaTime);
            // Advance the `important` strip's queue. A no-op with an empty lane, which is the usual case.
            this.pumpImportantLane(deltaTime);
            // Then place the task stack, which yields to whatever the line above just decided to show.
            this.placeEmberObligations(deltaTime);
            this.chapterChecklist?.animate(deltaTime);
            this.chapterChecklist?.place();
            this.chapterCelebration?.animate(deltaTime);
            // Track the follow-cam subject each frame: hide the PiP while it's on-screen, show it when off.
            this.updateFollowCamVisibility();
            // Advance the lord's campfire-strength fire-particle backdrop.
            this.emberRoster.animate(deltaTime);
            // The character-creation screen animates its own stage (hearth glow, intro typewriter).
            this.characterBuilder.animate(deltaTime);
            // Glide the minimap's dots between snapshots (the feed only speaks once a second), and slide
            // the player's own dot, whose location is predicted locally and so needs no interpolation.
            if (this.emberMinimap?.visible) {
                this.emberMinimap.animate(deltaTime);
                this.emberMinimap.trackPlayer(this.logic.playerEntity?.location);
            }
            // Drain the players chip's arrival flash, and the transient "Sent" on an invite button. Both
            // are no-ops when nothing is running.
            this.emberPlayersChip?.animate(deltaTime);
            this.chatChip?.animate(deltaTime);
            if (this.emberPlayersPanel?.visible) this.emberPlayersPanel.animate(deltaTime);
            // Spinners, the queue's clocks, and keeping the description box parked over its socket.
            if (this.spriteLabPanel?.visible) {
                this.spriteLabPanel.fitToViewport();
                this.spriteLabPanel.animate(deltaTime);
            }
            // Drain the invitation's clock. At zero the prompt takes itself down -- doing nothing is an
            // answer -- which frees the slot the list sits below.
            if (this.emberInvitePrompt?.isOpen()) {
                this.emberInvitePrompt.animate(deltaTime);
                if (!this.emberInvitePrompt.isOpen()) {
                    this.emberInviteFrom = undefined;
                    this.positionEmberPlayers();
                }
            }
            // ...and the one behind the run scorecard's portrait, while that's up.
            if (this.emberInviteModal?.isOpen()) this.positionEmberInviteModal();
            this.runSummary?.animate(deltaTime);
            // Drain the invasion picker's countdowns (the feed is two seconds coarse, so the seconds
            // are counted down locally between ticks) and its fade. No-op while shut.
            this.invasionPicker?.animate(deltaTime);
            this.possessionSplash?.animate(deltaTime);
            if (this.chapterAnnouncement?.isOpen()) {
                const screen = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer.screen;
                const topLeft = this.chapterAnnouncement.toLocal(new (0, $6qzqq.Point)(screen.x, screen.y));
                const bottomRight = this.chapterAnnouncement.toLocal(new (0, $6qzqq.Point)(screen.x + screen.width, screen.y + screen.height));
                this.chapterAnnouncement.resize(bottomRight.x - topLeft.x, bottomRight.y - topLeft.y, topLeft.x, topLeft.y);
                this.chapterAnnouncement.animate(deltaTime);
            }
            // Move the tutorial invitation in and out and drain its countdown; at zero it answers
            // "accept" for the player. Fed every frame (not only while open) so its exit can finish;
            // a no-op while it is away.
            this.tutorialPrompt?.update(deltaTime);
            this.applyHudPresence(deltaTime);
        };
        /**
     * The last word on how much of the HUD is showing (see gui/hud_presence.ts). Fed only the GUI's
     * own state -- a held bubble in view, a title card, a clue -- never a camp's; what a
     * chapter holds back arrives as a signal. Written as ALPHA, which none of these widgets set on
     * themselves, so every widget keeps deciding its own visibility and layout and this only ever
     * fades what they decided to show. An unseen piece also stops taking input: pixi hit-tests a
     * transparent object as readily as an opaque one.
     */ this.applyHudPresence = (deltaTime)=>{
            // Optional: a headless GUI test runs frames with no renderer, and nothing is on screen there.
            const screen = (0, $065c5647ab3ff4dc$export$90e89a86e46f5ae3)()?.renderer?.screen;
            this.hudPresence.update(deltaTime, {
                held: !!screen && (0, $5dbaf3682d88a932$export$46264c47e2aa11a2).anyInView(screen),
                announcing: !!this.chapterAnnouncement?.isOpen(),
                clue: !!this.tutorial?.isAnyClueShowing()
            });
            const pieces = [
                [
                    "chips",
                    this.chipLayer
                ],
                // The MAP chip goes with the map it toggles.
                [
                    "minimap",
                    this.emberMinimapChip
                ],
                [
                    "minimap",
                    this.emberMinimap
                ],
                [
                    "roster",
                    this.emberRoster
                ],
                [
                    "checklist",
                    this.chapterChecklist
                ],
                [
                    "fireGauge",
                    this.emberFireGauge
                ],
                [
                    "vitals",
                    this.hp
                ],
                [
                    "vitals",
                    this.mana
                ],
                [
                    "readyBar",
                    this.equipped
                ]
            ];
            for (const [piece, view] of pieces){
                if (!view) continue;
                view.alpha = this.hudPresence.alpha(piece);
                view.interactiveChildren = this.hudPresence.takesInput(piece);
            }
        };
        // A line a roster member has just spoken, but ONLY while the player can't see them say it —
        // once they're in the viewport their bubble is already drawn over their head in the world, and
        // repeating it on the HUD would be noise. Null otherwise. Drives the roster's speech lane.
        // A hit the player had no way of hearing: the roster saw a camp member lose health while they
        // were too far off for the world to have played anything for them.
        //
        // The predicate is deliberately the SAME one doStruck uses to decide whether to play the hit
        // sound at all (isTooDistantFromPlayer -- which also keeps the follow-cam's focus neighbourhood
        // audible), rather than a plain viewport test. Anything looser would double up the sound on a
        // member the player can already hear being hit, which is the whole reason this is conditional.
        this.playOffscreenHit = (entityId)=>{
            const entity = this.logic.getEntity(entityId);
            if (entity && !this.logic.isTooDistantFromPlayer(entity)) return;
            this.logic.audio.hit(entity);
        };
        // A stranger has reached the camp's fire. Unlike playOffscreenHit this plays wherever the
        // player is standing, including right next to them: the sound is not a substitute for seeing
        // it happen, it is the camp's doorbell, and a player watching the fire still wants to be told
        // that the thing they are watching is now asking them a question.
        this.playVisitorArrival = ()=>{
            this.logic.audio.visitorArrives();
        };
        // Did the member behind this card FALL, or did they just stop being on the roster?
        //
        // The roster broadcast is a list, and a removal from it carries no reason -- but the two
        // reasons want opposite animations: a camp member leaves it by dying (the card greys and
        // shatters) and a VISITOR leaves it by giving up on the camp and walking back the way they came
        // (the card drifts out, alive). The entity itself is the witness, and it is still in the world
        // in the second case: a disappointed recruit walks all the way back to the map edge before it
        // self-destructs, so at the moment its card goes it is very much still standing.
        //
        // Not decided from the card's last known HP, which is a reading up to a roster tick old -- a
        // visitor cut down between two ticks would be remembered at full health and drift politely off
        // the strip instead of falling.
        this.hasMemberFallen = (entityId)=>{
            const entity = this.logic.getEntity(entityId);
            if (!entity || this.logic.isDestroyed(entityId)) return true;
            return entity.isDead() || entity.hp !== undefined && entity.hp <= 0;
        };
        this.getOffscreenSpeech = (entityId)=>{
            const entity = this.logic.getEntity(entityId);
            if (!entity || !entity.location || this.logic.isDestroyed(entityId)) return null;
            if (this.logic.isWithinPlayerViewport(entity.location)) return null;
            return this.logic.getRecentSpeech(entityId);
        };
        this.updateSquadState = (squadState)=>{
            this.squad.update(squadState);
        };
        // The ember camp's wave badge, driven by the wave manager script's "waveStatus" screen messages
        // (see ember-wave-manager.js). The structured counts ride in the message's context; the text
        // carries the wave number as well, so a message that somehow arrives without a context can still
        // say whether a wave is on. Wave 0 — or an unreadable payload — takes the badge down.
        this.updateWaveIndicator = (message)=>{
            const context = message.context || {};
            const wave = Number(context.wave !== undefined ? context.wave : parseInt(message.text || "0"));
            if (isNaN(wave) || wave <= 0) {
                this.waveIndicator.update(null);
                return;
            }
            // A wave has landed, so the pre-wave dial has had its turn.
            if (this.countdownTimer.visible) {
                this.countdownTimer.stop();
                this.countdownTimer.visible = false;
            }
            // Consumed whether or not it matches: a countdown that was overtaken by some other wave is
            // not something to hold open and fire on later.
            const awaited = this.waveAwaited;
            this.waveAwaited = undefined;
            this.playWaveLanding(wave, awaited !== undefined && wave === awaited);
            this.waveIndicator.update({
                wave: wave,
                remaining: Number(context.remaining) || 0,
                total: Number(context.total) || 0,
                alive: Number(context.alive) || 0
            });
        };
        /**
     * The landing itself: one hit of light thrown in from the edges of the screen.
     *
     * NO SCREEN SHAKE, deliberately. The first version shook the ground as well and it read as the
     * player taking damage -- correctly, because that is exactly what a shaking screen already means
     * here: `screenShake` fires when the player is hit (client_game_logic, beside pulseDamage) and
     * `screenShakeImpulse` is an Ember Core blast going off nearby. A wave spawning at the edge of
     * the camp is neither, and nothing has touched the player at all. Borrowing the damage verb for
     * it makes both of them mean less. The light carries the beat on its own, and being
     * edge-weighted it is also spatially honest about where the thing arrived.
     *
     * waveStatus arrives constantly while a wave is being fought (it carries the kill count), so
     * this never fires on the message alone. A player arriving mid-assault did not witness that
     * wave land, and striking for it would mean every walk into a camp started with a bang.
     */ this.playWaveLanding = (wave, watched)=>{
            const seen = this.wavePlayed;
            this.wavePlayed = wave;
            if (wave <= 0) return;
            // Either this client was counting down to exactly this wave, or the number has gone up from
            // one it has already seen. The first clause is what makes a camp's FIRST wave land: there is
            // no earlier wave to have gone up from, and keying on that alone silently swallowed wave 1
            // of every single run -- which is, of course, the one most likely to be watched.
            if (!watched && (seen === undefined || wave <= seen)) return;
            // The wave number goes with it: the flash scales itself, so wave 1 is a knock and the late
            // table is a slam without anything out here having to know how.
            this.waveLandingFlash.strike(wave);
        };
        this.updateEmberRoster = (roster)=>{
            this.recruitHintRoster = roster;
            this.emberRoster.update(roster);
            this.positionEmberRoster();
            // Only the lord's entry carries the camp's fire. No lord, no camp, no gauge -- which is also
            // what takes it down on the way out of an ember room.
            const lord = roster.find((entry)=>entry.role === "lord");
            this.emberFireGauge.update(this.invading ? undefined : lord?.fireStrength);
        };
        // Bottom-right of the HUD (the ember room suppresses the minimap that normally sits there).
        // Recomputed each update because the strip's width depends on how many cards are showing --
        // including by the widget itself, when a card finishes breaking apart between roster ticks.
        this.positionEmberRoster = ()=>{
            const rightEdge = this.rosterRightEdge();
            // Roughly aligned with the inventory-slots (equipped) widget's bottom (constant BOTTOM - 20),
            // then nudged down 15 so the whole roster/follow-cam system sits a little lower.
            const bottomEdge = $7dd73ecdd94bfe01$export$84e1549b474f1b93 + (0, $167efe97b4119a5d$export$b0f20d83cec42115)().insetY;
            this.emberRoster.x = rightEdge - this.emberRoster.rightExtent();
            this.emberRoster.y = bottomEdge - this.emberRoster.bottomExtent();
            // Keep whatever holds the slot above the roster aligned with it as cards come and go.
            this.positionFollowCam();
            this.positionRosterCommandWheel();
            this.positionRolePickerInRosterSlot();
            this.positionEmberMinimap();
        };
        // The single HUD slot directly above the ember roster strip: right-aligned with the strip, its
        // bottom edge a little clear of it. The follow-cam PiP, the minimap and a roster-opened command
        // wheel all live here (only one at a time), so they can't drift apart.
        this.rosterSlotAnchor = (width, height)=>{
            const rightEdge = this.rosterRightEdge();
            const rosterTop = this.emberRoster.y - this.emberRoster.topExtent();
            return {
                x: rightEdge - width,
                y: rosterTop - 16 - height
            };
        };
        // Place the follow-cam below the default minimap, unless the player has dragged it elsewhere.
        this.positionFollowCam = ()=>{
            // positionEmberRoster runs during init before followCam exists — guard against that.
            if (!this.followCam?.isOpen()) return;
            const anchor = this.clampToScreen(this.followCamPlacement ?? {
                x: this.hudRightEdge() - this.followCam.getWidth(),
                y: this.chipRowBottom() + this.emberMinimap.getDefaultHeight() + $7dd73ecdd94bfe01$var$chipGap()
            }, this.followCam.getWidth(), this.followCam.getHeight());
            this.followCam.x = anchor.x;
            this.followCam.y = anchor.y;
            this.updateFollowCamVisibility();
        };
        this.dragFollowCamTo = (x, y)=>{
            this.holdOffMinimapDragAttack();
            this.followCamPlacement = this.clampToScreen({
                x: x,
                y: y
            }, this.followCam.getWidth(), this.followCam.getHeight());
            this.followCam.x = this.followCamPlacement.x;
            this.followCam.y = this.followCamPlacement.y;
        };
        // Where the minimap lives until the player drags it somewhere else: directly under the MAP toggle
        // that turns it on and off, hard against the same right edge, so the control and the thing it
        // controls are one object in the corner.
        //
        // It used to default to the slot above the roster strip -- a 176px map wants somewhere roomy -- but
        // a radar wants to be next to its switch, and that slot is the follow-cam PiP's anyway. The chip's
        // row is measured rather than assumed because the chips carry text, whose metrics are the font's
        // business.
        this.updateGameplayControls = ()=>{
            if (!this.chipLayer) return;
            this.chipLayer.visible = !!this.logic.playerEntity?.visible && !!this.logic.roomId && this.currenRoomName !== (0, $cb689cfa16c444ba$export$1bb94dd20d93df2d) && !this.characterBuilder?.isOpen() && !this.characterCustomizer?.isOpen() && !this.blackout?.visible;
        };
        this.minimapDefaultAnchor = (width)=>({
                x: this.hudRightEdge() - width,
                y: this.chipRowBottom()
            });
        // Item dialogs live on the stage, while the minimap uses HUD-local coordinates.
        this.itemPanelDefaultAnchor = (width)=>{
            const at = this.minimapDefaultAnchor(width);
            return {
                x: at.x + this.container.x,
                y: at.y + this.container.y
            };
        };
        // The y directly below the top-right chip row. Reserved whether or not any chip is currently IN
        // it, for the same reason layoutChipRow reserves each chip's slot: nothing stacked underneath
        // should slide about as chips come and go.
        /**
     * The top edge of the HUD's top band, shared by both clusters hanging from it: the countdown
     * dial's column on the left, and the chip row on the right. They read as one band across the top
     * of the screen, so they are anchored to one line rather than to two constants that agreed by
     * accident -- which they did not.
     *
     * `safeViewport.top` already carries the viewport's own top (-insetY, see stageViewport) as well
     * as a device's notch, so anything placed from this follows both without a seat in
     * layoutHudEdges' shift lists.
     */ this.hudTopEdge = ()=>$7dd73ecdd94bfe01$var$CHIP_ROW_Y + (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().safeViewport.top;
        this.chipRowBottom = ()=>this.hudTopEdge() + this.emberMinimapChip.getHeight() + $7dd73ecdd94bfe01$var$chipGap();
        /**
     * Lay the player's vitals along the top edge of the readied-item tray (see VITALS_BAND).
     *
     * Derived from the tray every frame rather than nudged about by the edge-inset shifts, so there
     * is exactly one place that decides where these three sit — which is why hp/mana/hunger are in
     * neither of layoutHudEdges' lists.
     *
     * A hidden meter is still placed but takes no room, so suppressing hunger in an ember camp does
     * not leave a gap in the middle of the row.
     */ this.positionVitals = ()=>{
            if (!this.hp || !this.equipped) return;
            // Each of these draws its art at some offset inside its own bounds -- the hearts sit on a
            // plate that overhangs them, the bars hang off an icon -- so each is placed by a VISIBLE
            // edge rather than by its origin.
            const edge = (meter)=>{
                const bounds = meter.getLocalBounds();
                return {
                    left: bounds.x * meter.scale.x,
                    middle: (bounds.y + bounds.height / 2) * meter.scale.y,
                    width: bounds.width * meter.scale.x,
                    drawn: bounds.height > 0
                };
            };
            // The hearts set the row, and they are placed by their PLATE: that plate and the tray's
            // directly below it are two panels of one cluster, and a step between their left edges is
            // the difference between reading as one object and as two that happen to be near each other.
            //
            // Measured off plateRect rather than getLocalBounds, because a beating or bursting heart is
            // scaled up to 1.9 -- laying the row out against live bounds would shove it sideways on
            // every hit.
            const plate = this.hp.plateRect();
            const art = this.hp.artRect();
            if (!(plate.height > 0)) return;
            this.hp.x = this.equipped.x - plate.x;
            this.hp.y = this.equipped.y - $7dd73ecdd94bfe01$var$VITALS_GAP - (plate.y + plate.height);
            // Everything after it is CENTRED on the hearts' own middle, not levelled with the plate's
            // bottom edge -- that edge is four pixels below the lowest heart, and a bar sitting on it
            // reads low against the art beside it. The hearts' art is centred on their origin, so their
            // middle IS hp.y.
            let x = this.hp.x + art.x + art.width + $7dd73ecdd94bfe01$var$VITALS_ROW_GAP;
            const place = (meter)=>{
                if (!meter) return;
                const at = edge(meter);
                if (!at.drawn) return;
                meter.x = x - at.left;
                meter.y = this.hp.y - at.middle;
                if (meter.visible) x += at.width + $7dd73ecdd94bfe01$var$VITALS_ROW_GAP;
            };
            place(this.mana);
            place(this.hunger);
            // ONE plate under the whole row. Sized last, because only its WIDTH changes -- the hearts
            // have already been placed by a left and top that this cannot move. Without it the hearts
            // sit on a panel while the bars float on the grass beside them, which is the normal
            // overworld case (an ember camp suppresses both bars, so it never showed up there).
            const rowRight = x - $7dd73ecdd94bfe01$var$VITALS_ROW_GAP;
            this.hp.setPlateWidth(Math.max(plate.width, rowRight - (this.hp.x + plate.x) + $7dd73ecdd94bfe01$var$VITALS_PLATE_PAD));
        };
        // The command wheel and role picker temporarily hide an overlapping map. The follow-cam
        // can overlap it freely and renders above it instead.
        this.claimedSlotRect = ()=>{
            const rect = (width, height)=>{
                const at = this.clampToScreen(this.rosterSlotAnchor(width, height), width, height);
                return {
                    x: at.x,
                    y: at.y,
                    width: width,
                    height: height
                };
            };
            if (this.commandWheelRosterId && this.commandWheel) {
                const extent = this.commandWheel.getExtent();
                return rect(extent.left + extent.right, extent.top + extent.bottom);
            }
            if (this.rolePickerRosterId && this.rolePicker) return rect(this.rolePicker.getPanelWidth(), this.rolePicker.getPanelHeight());
            return null;
        };
        // The minimap's home is under its own MAP toggle (see minimapDefaultAnchor), and anywhere the
        // player has dragged it to after that.
        //
        // Wherever it is, it steps aside for whatever has claimed the slot above the roster strip — the
        // roster command wheel or role picker — but ONLY if the two would actually
        // OVERLAP. That last part matters more than it sounds: the map used to vanish for any of those
        // panels wherever it had been dragged to, so a player who had parked it in the opposite corner
        // watched it disappear every time they tapped a roster card, for no reason they could see — which
        // is how you come away from a playthrough not realising the map can simply be left open. A panel
        // the map is nowhere near is not a reason to take the map away.
        //
        // Collapsed, the map gives up its space entirely and its chip carries the "off" state instead. The
        // chip stays on screen either way, including while another panel overlaps the map, so the
        // player can always change whether the map is enabled.
        this.positionEmberMinimap = ()=>{
            if (!this.emberMinimap) return;
            const hasMap = this.emberMinimap.hasData();
            const width = this.emberMinimap.getWidth();
            const height = this.emberMinimap.getHeight();
            // Re-clamped rather than taken as read: the map is a plan of the room and carries its aspect
            // ratio, and it has three sizes — so the panel a placement was chosen for may not be the size
            // of this one.
            const at = this.emberMinimapPlacement ? this.clampToScreen(this.emberMinimapPlacement, width, height) : this.minimapDefaultAnchor(width);
            const claimed = this.claimedSlotRect();
            const clear = !claimed || !(0, $27706b8361e494c8$export$a05724648878e2dc)({
                x: at.x,
                y: at.y,
                width: width,
                height: height
            }, claimed);
            // A held-back map (gui/hud_presence.ts) is as though there were none.
            const show = hasMap && clear && !this.emberMinimapCollapsed && !this.hudPresence.hides("minimap");
            this.emberMinimap.visible = show;
            if (show) {
                this.emberMinimap.x = at.x;
                this.emberMinimap.y = at.y;
            }
            this.emberMinimapChip.visible = hasMap && !this.hudPresence.hides("minimap");
            this.emberMinimapChip.setActive(!this.emberMinimapCollapsed);
            // Top-right corner of the screen. Ember rooms suppress the control bar that normally lives
            // there, so the corner is the camp HUD's. Laid out unconditionally: the map toggle holds its
            // slot even while it is hidden, so the chips beside it do not move when the map is unfolded.
            this.layoutChipRow();
            // The map now sits at the head of the right-edge column, so whatever stacks under it has to be
            // told when the map appears, folds away, or changes size. One-way: positionEmberPlayers reads
            // the map's placement and never sets it.
            if (this.emberPlayersChip) this.positionEmberPlayers();
        };
        // The x every right-justified HUD panel measures back from, in this container's coordinates.
        this.rosterRightEdge = ()=>(0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7 + (0, $167efe97b4119a5d$export$b0f20d83cec42115)().inset - this.container.x - $7dd73ecdd94bfe01$export$15ae5481f3ca1c06;
        this.hudRightEdge = ()=>{
            const metrics = (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)();
            const safeRight = metrics.viewport.left + metrics.viewport.width - metrics.safeViewport.right;
            if (metrics.touch || (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) return this.rosterRightEdge();
            return (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7 + (0, $167efe97b4119a5d$export$b0f20d83cec42115)().inset - this.container.x - 6 - safeRight;
        };
        // Whether the SAY chip belongs on this machine at all.
        //
        // It is a stand-in for a key: `requestChat` is what Enter does, and the chip exists because a
        // phone has no Enter (see the constructor, and player.ts's requestChat). On a keyboard the
        // player already has that key in every room, so the chip only spent a slot in the camp's
        // corner to say a second time what Enter says -- and the corner is the one part of the HUD
        // that is actually crowded. DEVICE, not room: the room decides whether the control bar is
        // suppressed, this decides whether the stand-in is wanted when it is.
        this.chatChipWanted = ()=>(0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().phone;
        // The top-right chip row, laid out right to left: map, items, say, players.
        //
        // Every chip keeps its slot whether or not it is currently on screen. They appear and vanish
        // independently -- the map toggle exists while the room has map data, the players count
        // only while somebody else is logged in -- and a row that closed up around a missing one would
        // shuffle the others sideways under the player's thumb each time that happened. Reserving the
        // slots costs a few empty pixels and buys a row that never moves.
        //
        // Called again whenever a chip's width can change; the players chip carries a count, so it
        // does.
        this.layoutChipRow = ()=>{
            let right = this.hudRightEdge();
            const place = (chip)=>{
                if (!chip) return;
                chip.x = right - chip.getWidth();
                chip.y = this.hudTopEdge();
                right -= chip.getWidth() + $7dd73ecdd94bfe01$var$chipGap();
            };
            // A held-back MAP chip gives up its slot, like the SAY chip below: it is not coming back soon,
            // and holding the corner for it would leave the Items chip beside a hole.
            place(this.hudPresence.hides("minimap") ? undefined : this.emberMinimapChip);
            place(this.emberInventoryChip);
            // Inboard of the players chip on purpose: that one carries a count, so its width moves when
            // a tenth player logs in -- and everything LEFT of it moves with it. Reserving slots keeps
            // the row still as chips come and go, but it cannot keep a chip still beside one that
            // grows, so the growing one goes on the end.
            // ...and the SAY chip is left OUT of the row entirely on a keyboard, rather than hidden in
            // it. The reservation above buys a row that holds still as chips come and go; a chip that
            // never comes at all is not that case, and holding its slot would leave a permanent hole.
            place(this.chatChipWanted() ? this.chatChip : undefined);
            place(this.emberPlayersChip);
        };
        // Who else is logged in, as the server last told us. An empty list takes the chip down and, with
        // it, the panel -- there is nothing left to invite.
        this.updateEmberPlayers = (players)=>{
            if (!this.emberPlayersChip) // A room update can land before the HUD has finished standing itself up.
            return;
            this.emberPlayers = players || [];
            // The chip owns its own visibility (and the orange flash it makes on arrival) -- it is the
            // count that decides, and only the chip knows whether this count is the first one.
            this.emberPlayersChip.update(this.emberPlayers.length);
            if (this.emberPlayers.length < 1) this.emberPlayersPanel.visible = false;
            if (this.emberPlayersPanel.visible) this.emberPlayersPanel.update(this.emberPlayers);
            this.positionEmberPlayers();
        };
        // Open or close the player list. Filled on open rather than kept up to date while hidden: the feed
        // only speaks when the list CHANGES, so a panel that waited for the next broadcast could sit empty
        // indefinitely.
        this.setEmberPlayersOpen = (open)=>{
            const show = open && this.emberPlayers.length > 0;
            if (show) this.emberPlayersPanel.update(this.emberPlayers);
            this.emberPlayersPanel.visible = show;
            this.positionEmberPlayers();
        };
        // Ask the server to pull another player into this camp. It is a request in both directions: the
        // server decides whether it is allowed and where they land, and the INVITED player decides
        // whether to come at all (see the EMBER_PLAYERS campaign and updateEmberInvite).
        this.positionEmberInviteModal = ()=>{
            const screen = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer.screen;
            // Renderer coordinates include the stage's scale and translation. Convert both viewport
            // corners into the modal's space before drawing the scrim or positioning the dialog.
            const topLeft = this.emberInviteModal.toLocal(new (0, $6qzqq.Point)(screen.x, screen.y));
            const bottomRight = this.emberInviteModal.toLocal(new (0, $6qzqq.Point)(screen.x + screen.width, screen.y + screen.height));
            this.emberInviteModal.resize(bottomRight.x - topLeft.x, bottomRight.y - topLeft.y, topLeft.x, topLeft.y);
        };
        this.inviteEmberPlayer = (entityId, playMode = "pvp")=>{
            this.logic.playerController?.client?.inviteEmberPlayer(entityId, playMode);
        };
        // An invitation into somebody's camp, or null to take the prompt down. Deliberately NOT gated on
        // being in an ember room: the player being invited is, by definition, somewhere else.
        this.updateEmberInvite = (invite)=>{
            if (!this.emberInvitePrompt) return;
            this.emberInviteFrom = invite?.fromEntityId;
            this.emberInvitePrompt.update(invite);
            this.positionEmberPlayers();
        };
        // The player's answer. Only an accepted one moves them, and the server does the moving -- this
        // says nothing about where they will land.
        this.answerEmberInvite = (accepted)=>{
            const from = this.emberInviteFrom;
            this.emberInviteFrom = undefined;
            if (from) this.logic.playerController?.client?.answerEmberInvite(from, accepted);
            this.positionEmberPlayers();
        };
        // The players chip takes the leftmost place in the top-right row (see layoutChipRow), and the
        // list of players hangs under it against the same right edge.
        this.positionEmberPlayers = ()=>{
            if (!this.emberPlayersChip) return;
            const rightEdge = this.hudRightEdge();
            // The chip's own place in the top-right row. Re-run here because this chip's width moves
            // with the count it carries, which nothing else is watching.
            this.layoutChipRow();
            // One column down the right edge: the chip's row, then the MAP if it is still parked under its
            // toggle, then the invitation prompt, then the list. The chip's row is reserved whether or not
            // the chip is IN it, for the same reason the map toggle's slot is -- so nothing below it slides
            // about as players come and go.
            let below = this.chipRowBottom();
            if (this.minimapHoldsTheCorner()) below += this.emberMinimap.getHeight() + $7dd73ecdd94bfe01$var$chipGap();
            if (this.emberInvitePrompt?.isOpen()) {
                this.emberInvitePrompt.x = rightEdge - this.emberInvitePrompt.getWidth();
                this.emberInvitePrompt.y = below;
                below += this.emberInvitePrompt.getHeight() + $7dd73ecdd94bfe01$var$chipGap();
            }
            this.emberPlayersPanel.fitToViewport(below);
            this.emberPlayersPanel.x = rightEdge - this.emberPlayersPanel.getWidth();
            this.emberPlayersPanel.y = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() || (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().touch ? Math.min(below, (0, $0d2b5753435eae0a$export$f8d7a330bfe28b29)().safeViewport.bottom - this.emberPlayersPanel.getHeight() - 12) : below;
        };
        // Whether the map is currently sitting in its default spot under the MAP toggle -- in which case
        // everything else that stacks down that right edge has to start below it rather than under the
        // chip row. Derived rather than remembered, so it cannot be read before positionEmberMinimap has
        // run: the two only share the chip row's height and the map's own size.
        this.minimapHoldsTheCorner = ()=>!!this.emberMinimap?.visible && !this.emberMinimapPlacement;
        // What the top-right MAP chip does: flip the map between shown and folded away. One control for
        // both directions, because that is what makes it read as a toggle with a state rather than a
        // button that opens something.
        this.toggleEmberMinimap = ()=>this.setEmberMinimapCollapsed(!this.emberMinimapCollapsed);
        // Fold the map away (or bring it back), remembering the choice.
        this.setEmberMinimapCollapsed = (collapsed)=>{
            if (this.emberMinimapCollapsed === collapsed) return;
            this.emberMinimapCollapsed = collapsed;
            this.saveEmberMinimapCollapsed(collapsed);
            this.positionEmberMinimap();
        };
        // The collapsed preference is a per-viewer convenience, so it lives in localStorage — which can
        // throw or come back empty (private windows, blocked site data), hence the guards.
        this.loadEmberMinimapCollapsed = ()=>{
            try {
                if (typeof localStorage !== "undefined") return localStorage.getItem(this.EMBER_MINIMAP_COLLAPSED_KEY) === "true";
            } catch (error) {
                console.warn("Failed to load minimap collapsed state from localStorage:", error);
            }
            return false;
        };
        this.saveEmberMinimapCollapsed = (collapsed)=>{
            try {
                if (typeof localStorage !== "undefined") localStorage.setItem(this.EMBER_MINIMAP_COLLAPSED_KEY, String(collapsed));
            } catch (error) {
                console.warn("Failed to save minimap collapsed state to localStorage:", error);
            }
        };
        /**
     * Hand the lane's current choice to the strip, and advance its clock.
     *
     * Called from the frame loop with a real delta, and again with 0 the moment a message is pushed
     * so a strip that was empty lights up on the spot instead of on the next frame.
     *
     * `takeChange` is what keeps this cheap: with a settled lane -- which is nearly always -- this is
     * one addition and one boolean read per frame, and the widget is not touched at all.
     */ this.pumpImportantLane = (deltaTime)=>{
            if (deltaTime > 0) this.importantLane.update(deltaTime);
            if (!this.importantLane.takeChange()) return;
            const notice = this.importantLane.current();
            if (!notice) {
                // Nothing waiting, or a handover gap: fade the strip down rather than cutting it.
                this.importantMessage.dismiss();
                return;
            }
            // The original message, with the lane's resolved hold and tier written over it: every other
            // field it was sent with (a displayCallback, most of all) survives the wait in the queue.
            this.importantMessage.update({
                ...notice.source || {},
                text: notice.text,
                duration: (0, $02082475a2de3c51$export$505ac917808ea098)(notice),
                context: {
                    ...notice.source?.context || {},
                    tier: notice.tier
                }
            });
        };
        /**
     * Rebuild the camp's standing-task list from the minimap feed.
     *
     * The feed is the source for this because it already carries the state and already arrives once a
     * second (EmberMinimap.MINIMAP_INTERVAL_MS) -- see gui/ember_obligations.ts. A null feed is a room
     * change, which is also the moment any dismissal stops meaning anything: the next camp's ritual is
     * not the one this player waved away.
     */ this.refreshEmberObligations = (minimap)=>{
            if (!this.emberObligations) return;
            if (!minimap) {
                this.emberObligationDismissals.reset();
                this.emberObligationFeed = [];
                this.emberObligations.update([]);
                return;
            }
            this.emberObligationFeed = (0, $7774c82afd18c45a$export$a2e29269a0cfdd47)(minimap);
            this.emberObligations.update(this.emberObligationDismissals.visible(this.emberObligationFeed));
        };
        this.dismissEmberObligation = (obligation)=>{
            this.emberObligationDismissals.dismiss(obligation);
            this.emberObligations.update(this.emberObligationDismissals.visible(this.emberObligationFeed));
        };
        /**
     * In the top row, beside the hearts: a dropdown whose header shares the HP bar's line and whose
     * rows hang below it.
     *
     * The top-left of the HUD is a COLUMN, not a corner -- hearts, then the countdown dial or the
     * wave badge in its place, then the invader's let-go button -- and the first version of this sat
     * on top of the dial, which only shows once a wave is actually counting down. So the stack moves
     * out of that column entirely and starts to the right of it, on the line the player's own
     * hearts are on. What they are, what the clock says, and what they still owe end up readable in
     * one sweep across the top of the screen.
     *
     * CLEARING THE DIAL, NOT THE HEARTS, is what sets the left edge: the dial is wider than the five
     * hearts and is left-aligned with them, so a stack that merely cleared the hearts would be back
     * under the dial the moment a wave was called. Its slot is reserved whether or not it is
     * currently drawn -- `dialSize` is a constant of the widget, not a measurement of what it is
     * painting -- so calling a wave never moves this panel, which is the one moment the player can
     * least afford to go looking for it again. (Same rule, and the same reason, as layoutChipRow
     * reserving a slot per chip.)
     *
     * Placed per frame like the anxiety meter rather than once on a layout pass, so it follows a
     * viewport inset change without needing a seat in layoutHudEdges.
     */ this.placeEmberObligations = (deltaTime)=>{
            if (!this.emberObligations || !this.countdownTimer || !this.hp) return;
            // Re-asserted rather than latched: the same gate as the chip row (no HUD over character
            // creation, a blackout, or a dead player), and it has to be able to let the panel back.
            const gated = !!this.chipLayer && !this.chipLayer.visible;
            this.emberObligations.visible = this.emberObligations.hasTasks() && !gated;
            if (!this.emberObligations.visible) return;
            // Take turns with the strip rather than sharing the band: a notice speaks, and the stack
            // unfolds once it has gone. See EmberObligationsPanel.setYielded and OBLIGATIONS_YIELD_MS.
            this.obligationsYieldMs = this.importantLane.current() ? $7dd73ecdd94bfe01$var$OBLIGATIONS_YIELD_MS : Math.max(0, this.obligationsYieldMs - deltaTime);
            this.emberObligations.setYielded(this.obligationsYieldMs > 0);
            // Beside the dial, which heads this column on its own now that the hearts have gone to the
            // tray. Both live on the stage, so no container offset comes into it. Hung from the dial's
            // TOP edge because the rows drop below the header.
            const dial = this.countdownTimer.dialSize;
            this.emberObligations.position.set(Math.round(this.countdownTimer.x + dial / 2 + $7dd73ecdd94bfe01$var$OBLIGATIONS_GAP), Math.round(this.countdownTimer.y - dial / 2));
        };
        /**
     * The head of the top-left column: the countdown dial, the wave badge that stands in its exact
     * slot, and the invader's LET GO button under them.
     *
     * Placed per frame from hudTopEdge rather than once from a constant, so the dial's bezel lands on
     * the same line as the chip plates across the band -- including on a notched phone, where the
     * chips step down for the notch and a dial placed once did not.
     *
     * These three are therefore OUT of layoutHudEdges' vertical shift list: hudTopEdge already
     * carries the inset, so being shifted as well would double it. Their x is still shifted there,
     * which is why only the y is set here.
     */ this.placeColumnHead = ()=>{
            const dial = this.countdownTimer;
            if (!dial) return;
            dial.y = this.hudTopEdge() + dial.dialSize / 2;
            if (this.waveIndicator) {
                // The badge takes the dial's slot exactly -- same size, never both up (addScreenMessage).
                this.waveIndicator.y = dial.y;
                if (this.letGoButton) this.letGoButton.y = Math.round(dial.y + Math.max(dial.bottomExtent, this.waveIndicator.bottomExtent) + 10);
            }
        };
        /**
     * The fire gauge's place in the top-left column.
     *
     * It used to be parked at a fixed height there: the slot the old "WAVE n" pill hung in, directly
     * under the dial. That is right whenever a dial IS up, which is most of a camp being fought -- a
     * countdown, then the wave badge, then the next countdown. But both of those are TRANSIENT and
     * the fire is not; it burns for the whole run. So in a camp's opening calm, and again once its
     * waves are done, the gauge was left floating a dial's height down the left edge with nothing
     * above it to belong to, which reads as a widget that has come loose rather than as a readout.
     *
     * It rides the column instead: under whichever dial is up, and at the column's HEAD when neither
     * is. The dial keeps the corner whenever it has something to say, because it is not a camp's
     * widget at all -- addScreenMessage counts down with it in any room -- and a camp-only readout
     * should not push a general one off its anchor.
     *
     * Placed per frame and derived from the dial, exactly like placeEmberObligations beside it: one
     * writer for this position, and it follows a viewport inset without a seat in layoutHudEdges.
     */ this.placeEmberFireGauge = (deltaTime)=>{
            if (!this.emberFireGauge || !this.countdownTimer) return;
            const dial = this.countdownTimer;
            // Both live on the stage, so no container offset comes into it. The gauge is left-anchored
            // and vertically CENTRED (see its setWidth/height_), hence the half-height on the y.
            const head = dial.y - dial.dialSize / 2;
            const headed = dial.visible || !!this.waveIndicator?.visible;
            const target = Math.round(headed ? head + dial.dialSize + $7dd73ecdd94bfe01$var$FIRE_GAUGE_GAP + this.emberFireGauge.height_ / 2 : head + this.emberFireGauge.height_ / 2);
            this.emberFireGauge.x = Math.round(dial.x - dial.dialSize / 2);
            // A dial arriving or leaving is the one move worth sliding: it happens about twice a run,
            // it is a dial's height, and a teleport that far reads as a glitch. Every OTHER move of this
            // widget is the viewport's -- an inset change, a resize -- and those have to land at once,
            // or the gauge would ease across the screen behind a window the player is still dragging.
            const was = this.fireGaugeHeaded ?? headed;
            this.fireGaugeHeaded = headed;
            if (!this.emberFireGauge.visible) // A room change takes the reading away mid-slide. Dropping the slide here means the next
            // camp's gauge is simply already in place rather than easing in from the last one's.
            this.fireGaugeSliding = false;
            else if (was !== headed) this.fireGaugeSliding = true;
            if (!this.fireGaugeSliding) {
                this.emberFireGauge.y = target;
                return;
            }
            // Linear and CLAMPED to what is left, so it lands exactly rather than approaching forever
            // -- the same bargain the bar's own travel makes (gui/ember_fire_gauge.ts).
            const travel = $7dd73ecdd94bfe01$var$FIRE_GAUGE_SLIDE * deltaTime;
            const gap = target - this.emberFireGauge.y;
            this.emberFireGauge.y += Math.max(-travel, Math.min(travel, gap));
            if (this.emberFireGauge.y === target) this.fireGaugeSliding = false;
        };
        this.loadEmberObligationsCollapsed = ()=>{
            try {
                if (typeof localStorage !== "undefined") return localStorage.getItem(this.EMBER_OBLIGATIONS_COLLAPSED_KEY) === "true";
            } catch (error) {
                console.warn("Failed to load camp tasks collapsed state from localStorage:", error);
            }
            return false;
        };
        this.saveEmberObligationsCollapsed = (collapsed)=>{
            try {
                if (typeof localStorage !== "undefined") localStorage.setItem(this.EMBER_OBLIGATIONS_COLLAPSED_KEY, String(collapsed));
            } catch (error) {
                console.warn("Failed to save camp tasks collapsed state to localStorage:", error);
            }
        };
        // The widget owns the size cycle and tells us where it landed. Two jobs here: remember it, and
        // re-place a panel that has just changed size under a placement chosen for the old one.
        this.onEmberMinimapResized = (size)=>{
            this.emberMinimapSize = size;
            this.saveEmberMinimapSize(size);
            this.positionEmberMinimap();
        };
        // Like the other two map preferences, a per-viewer convenience in localStorage — which can throw
        // or come back empty (private windows, blocked site data), and whose contents are whatever was
        // last written there, hence the guards and asMinimapSize.
        this.loadEmberMinimapSize = ()=>{
            try {
                if (typeof localStorage !== "undefined") return (0, $27706b8361e494c8$export$c8b624e948a22741)(localStorage.getItem(this.EMBER_MINIMAP_SIZE_KEY)) ?? (0, $27706b8361e494c8$export$b224d4b6baa336d9);
            } catch (error) {
                console.warn("Failed to load minimap size from localStorage:", error);
            }
            return 0, $27706b8361e494c8$export$b224d4b6baa336d9;
        };
        this.saveEmberMinimapSize = (size)=>{
            try {
                if (typeof localStorage !== "undefined") localStorage.setItem(this.EMBER_MINIMAP_SIZE_KEY, size);
            } catch (error) {
                console.warn("Failed to save minimap size to localStorage:", error);
            }
        };
        this.holdOffMinimapDragAttack = ()=>this.logic.playerController?.suppressAttack($7dd73ecdd94bfe01$export$530fe131767a4087.MINIMAP_DRAG_ATTACK_HOLDOFF_MS);
        this.dragEmberMinimapTo = (x, y)=>{
            this.holdOffMinimapDragAttack();
            const at = this.clampToScreen({
                x: x,
                y: y
            }, this.emberMinimap.getWidth(), this.emberMinimap.getHeight());
            this.emberMinimapPlacement = at;
            this.emberMinimap.x = at.x;
            this.emberMinimap.y = at.y;
        };
        // Saved on release rather than per frame: a drag is hundreds of positions and only the last one is
        // the answer.
        this.dropEmberMinimap = ()=>{
            this.holdOffMinimapDragAttack();
            this.saveEmberMinimapPlacement();
        };
        // ---- SpriteLab -------------------------------------------------------------------------------
        // The SpriteLab room's state from the server (null outside one, which takes the panel down), and
        // the message its last request produced, if any.
        this.updateSpriteLab = (state, message)=>{
            const panel = this.spriteLabPanel;
            if (!panel) return;
            const appearing = !!state && !panel.visible;
            panel.update(state, message);
            if (appearing) this.placeSpriteLabPanel();
        };
        this.createSpriteLabPanel = ()=>{
            const saved = this.loadSpriteLabPanel();
            this.spriteLabPlacement = saved.at;
            // The panel lays itself out (and reports it) while it is being built; nothing to place yet.
            let panel;
            panel = new (0, $c6aea3ca9a48e675$export$8912876716d2e56c)({
                onRequest: (request)=>this.logic.playerController?.client?.sendSpriteLabRequest(request),
                onGrab: this.holdOffMinimapDragAttack,
                onDragTo: (x, y)=>{
                    this.holdOffMinimapDragAttack();
                    if (!panel) return;
                    const at = this.clampToScreen({
                        x: x,
                        y: y
                    }, panel.getWidth(), panel.getHeight());
                    this.spriteLabPlacement = at;
                    panel.position.set(at.x, at.y);
                },
                onRelease: ()=>{
                    this.holdOffMinimapDragAttack();
                    this.saveSpriteLabPanel();
                },
                // Folding, unfolding and new queue rows change the height: keep it on screen without
                // forgetting where the player put it.
                onLayoutChange: ()=>{
                    if (!panel || this.spriteLabPanel !== panel) return;
                    this.placeSpriteLabPanel();
                    this.saveSpriteLabPanel();
                },
                onClaimInput: ()=>this.logic.playerController?.cancelAttackForUi(),
                suppressGameKeys: (suppressed)=>(0, $ea3f90e500565ae9$export$16e4d70cc375e707).suppressTyping(suppressed),
                canvasRect: ()=>{
                    try {
                        return (0, $065c5647ab3ff4dc$export$56359d4511c7424)().view.getBoundingClientRect();
                    } catch (e) {
                        return null;
                    }
                },
                rendererScreen: ()=>{
                    try {
                        const screen = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer.screen;
                        return {
                            width: screen.width,
                            height: screen.height
                        };
                    } catch (e) {
                        return {
                            width: 0,
                            height: 0
                        };
                    }
                }
            });
            // Over the HUD's readouts, under every modal and the command wheel.
            panel.zIndex = 55000;
            panel.setMinimized(saved.minimized);
            panel.setCreationsOpen(saved.creationsOpen);
            return panel;
        };
        // Top-left by default, under the name line: the room is empty grass, so nothing else wants it.
        this.placeSpriteLabPanel = ()=>{
            const panel = this.spriteLabPanel;
            if (!panel) return;
            const bounds = this.hudBounds();
            const at = this.spriteLabPlacement ?? {
                x: bounds.left + 14,
                y: bounds.top + 34
            };
            const clamped = this.clampToScreen(at, panel.getWidth(), panel.getHeight());
            panel.position.set(clamped.x, clamped.y);
        };
        this.loadSpriteLabPanel = ()=>{
            try {
                if (typeof localStorage !== "undefined") {
                    const stored = JSON.parse(localStorage.getItem(this.SPRITELAB_PANEL_KEY) || "null");
                    return {
                        at: isFinite(stored?.x) && isFinite(stored?.y) ? {
                            x: stored.x,
                            y: stored.y
                        } : null,
                        minimized: stored?.minimized === true,
                        creationsOpen: stored?.creationsOpen === true
                    };
                }
            } catch (error) {
                console.warn("Failed to load the SpriteLab panel's placement from localStorage:", error);
            }
            return {
                at: null,
                minimized: false,
                creationsOpen: false
            };
        };
        this.saveSpriteLabPanel = ()=>{
            const panel = this.spriteLabPanel;
            if (!panel) return;
            try {
                if (typeof localStorage !== "undefined") localStorage.setItem(this.SPRITELAB_PANEL_KEY, JSON.stringify({
                    ...this.spriteLabPlacement || {},
                    minimized: panel.isMinimized(),
                    creationsOpen: panel.isCreationsOpen()
                }));
            } catch (error) {
                console.warn("Failed to save the SpriteLab panel's placement to localStorage:", error);
            }
        };
        // The screen, in the HUD container's own coordinates: the container is nudged in from the left
        // edge, so screen left sits at -container.x; the right edge is the same expression the rest of the
        // HUD right-justifies against, and BOTTOM is the HUD's own floor.
        this.hudBounds = ()=>{
            const { inset: inset, insetY: insetY } = (0, $167efe97b4119a5d$export$b0f20d83cec42115)();
            const screenWidth = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4.7 + inset;
            return {
                left: -inset - this.container.x,
                top: -insetY,
                right: screenWidth - this.container.x,
                bottom: $7dd73ecdd94bfe01$export$84e1549b474f1b93 + insetY
            };
        };
        // Expand the space between the two edge columns, keeping each widget's desktop-sized margin
        // and scale. Apply only the change in inset so live widget positions survive repeated frames.
        this.layoutHudEdges = ()=>{
            const viewport = (0, $167efe97b4119a5d$export$b0f20d83cec42115)();
            const { inset: inset, insetY: insetY } = viewport;
            const delta = inset - this.hudInset;
            const deltaY = insetY - this.hudInsetY;
            if (!delta && !deltaY) return;
            this.hudInset = inset;
            this.hudInsetY = insetY;
            const shift = (widgets, offset, axis = "x")=>{
                widgets.forEach((widget)=>{
                    if (widget) widget[axis] += offset;
                });
            };
            shift([
                this.nameText,
                this.resourceBar,
                this.equipped,
                this.abilities,
                this.squad,
                this.featureWidget,
                this.bannerText,
                this.typing,
                this.countdownTimer,
                this.waveIndicator,
                this.letGoButton,
                this.fpsMeter,
                this.container.getChildByName("_level_up_stats_")
            ], -delta);
            if (!this.chatComposer?.isOpen()) shift([
                this.chatHistory
            ], -delta);
            shift([
                this.controlBar,
                this.stickyBanner,
                this.dayCycle,
                this.minimapSurface,
                this.leaderboard,
                this.container.getChildByName("_help_messaging_")
            ], delta);
            shift([
                this.nameText,
                this.resourceBar,
                this.featureWidget,
                this.bannerText,
                this.controlBar,
                this.stickyBanner,
                this.dayCycle,
                this.leaderboard,
                this.fpsMeter,
                this.container.getChildByName("_level_up_stats_")
            ], -deltaY, "y");
            shift([
                this.equipped,
                this.abilities,
                this.squad,
                this.typing,
                this.minimapSurface,
                this.container.getChildByName("_help_messaging_")
            ], deltaY, "y");
            if (!this.chatComposer?.isOpen()) this.chatHistory.setAnchor("bottom", $7dd73ecdd94bfe01$var$CHAT_LOG_BOTTOM + insetY);
            for (const [overlay, color] of [
                [
                    this.blackout,
                    0x000000
                ],
                [
                    this.redout,
                    0xff0000
                ]
            ]){
                if (!overlay) continue;
                overlay.clear().beginFill(color);
                overlay.drawRect(viewport.left, viewport.top, viewport.width, viewport.height);
                overlay.endFill();
            }
            this.positionEmberRoster();
            this.positionEmberPlayers();
        };
        this.clampToScreen = (at, width, height)=>(0, $27706b8361e494c8$export$39715f4eaf395d01)(at, {
                width: width,
                height: height
            }, this.hudBounds());
        // The dragged position is a per-viewer convenience, so it lives in localStorage — which can throw
        // or come back empty (private windows, blocked site data), and whose contents are whatever was
        // last written there, hence the guards and the shape check.
        this.loadEmberMinimapPlacement = ()=>{
            try {
                if (typeof localStorage !== "undefined") {
                    const stored = localStorage.getItem(this.EMBER_MINIMAP_PLACEMENT_KEY);
                    const at = stored ? JSON.parse(stored) : null;
                    if (isFinite(at?.x) && isFinite(at?.y)) return {
                        x: at.x,
                        y: at.y
                    };
                }
            } catch (error) {
                console.warn("Failed to load minimap placement from localStorage:", error);
            }
            return null;
        };
        this.saveEmberMinimapPlacement = ()=>{
            if (!this.emberMinimapPlacement) return;
            try {
                if (typeof localStorage !== "undefined") localStorage.setItem(this.EMBER_MINIMAP_PLACEMENT_KEY, JSON.stringify(this.emberMinimapPlacement));
            } catch (error) {
                console.warn("Failed to save minimap placement to localStorage:", error);
            }
        };
        // The ember room's per-room minimap snapshot (camp members + wave attackers). null takes the map
        // down.
        this.updateEmberMinimap = (minimap)=>{
            if (minimap?.roomId && !this.acceptsSceneRoom(minimap.roomId)) {
                this.emberMinimap.update(minimap);
                return;
            }
            const rescueId = minimap?.rescue?.id;
            const rescueStarted = !!rescueId && rescueId !== this.emberMinimapRescueId;
            this.emberMinimapRescueId = rescueId;
            const ritualId = minimap?.bonecaller?.id;
            const ritualStarted = minimap?.bonecaller?.state === "active" && ritualId !== this.emberMinimapBonecallerId;
            this.emberMinimapBonecallerId = ritualId;
            this.emberMinimap.update(minimap);
            this.refreshEmberMinimapTrees(minimap);
            this.refreshEmberObligations(minimap);
            if (rescueStarted || ritualStarted) this.setEmberMinimapCollapsed(false);
            this.positionEmberMinimap();
        };
        this.refreshEmberMinimapTrees = (minimap)=>{
            if (!minimap) {
                this.emberTreeScanKey = null;
                return;
            }
            const provider = this.logic.tilemapMetaProvider;
            if (!provider) return;
            const key = `${this.currentRoomId}:${minimap.generationId || ""}:${provider.getCollisionVersion()}:${minimap.width}x${minimap.height}`;
            if (key === this.emberTreeScanKey) return;
            const now = Date.now();
            // A brand-new room (nothing scanned yet) is drawn immediately; only RE-scans wait their turn.
            const sameGeneration = this.emberTreeScanKey?.startsWith(`${this.currentRoomId}:${minimap.generationId || ""}:`);
            if (sameGeneration && now - this.emberTreeScanAt < $7dd73ecdd94bfe01$export$530fe131767a4087.EMBER_TREE_RESCAN_MS) return;
            this.emberTreeScanKey = key;
            this.emberTreeScanAt = now;
            const tilesWide = this.emberMinimap.tilesWide();
            const tilesHigh = this.emberMinimap.tilesHigh();
            this.emberMinimap.updateTerrain((0, $27706b8361e494c8$export$30a87bc142bf2fb5)(provider, tilesWide, tilesHigh), tilesWide, tilesHigh);
        };
        // Open the follow-cam PiP on an entity: show the modal, keep the entity's neighborhood live on
        // the client, and ask the server to sync it in full detail every tick.
        this.openFollowCam = (entityId, name)=>{
            // Dismiss roster menus when opening the follow-cam.
            if (this.commandWheelRosterId) this.hideCommandWheel();
            if (this.rolePickerRosterId) this.hideRolePicker();
            this.emberRoster.holdSelection(entityId);
            this.followCam.open(entityId, name);
            // Start transparent and let updateFollowCamVisibility fade it in (null forces a fade).
            this.followCam.alpha = 0;
            this.followCamShown = null;
            this.positionFollowCam();
            // Refresh the map alongside the PiP.
            this.positionEmberMinimap();
            this.logic.setFocusEntityId(entityId);
            this.logic.playerController.client.setFocusEntity(entityId);
        };
        // Close the follow-cam if it's open (Escape / deactivation); no-op otherwise.
        this.dismissFollowCam = ()=>{
            if (this.followCam?.isOpen()) this.closeFollowCam();
        };
        this.closeFollowCam = ()=>{
            this.followCamFader?.stop(true);
            this.followCamShown = false;
            this.followCam.close();
            this.emberRoster.clearSelection();
            // Refresh the map after closing the PiP.
            this.positionEmberMinimap();
            this.logic.setFocusEntityId(null);
            this.logic.playerController.client.setFocusEntity(null);
        };
        this.updateBannerText = (text)=>{
            this.bannerText.text = text;
        };
        this.updateLocation = (label)=>{
        //
        };
        this.startChat = ()=>{
            // The two fields are the same conversation; only one of them can hold the keyboard.
            this.dismissChatComposer();
            this.chatOpen = true;
            this.chatInput = (0, $2bc3e70fbff7f064$export$d42b23612a605795);
            this.chatWalk = {
                ...this.chatWalk,
                index: -1,
                draft: ""
            };
            this.renderChatInput();
            clearTimeout(this.chatHistoryTextTimer);
            if (this.chatHistoryFader) this.chatHistoryFader.stop(true);
            this.chatHistory.alpha = 1.0;
            this.chatHistory.show();
        };
        // --- the composer: chat on a device with no keyboard ------------------------------------
        // Put the composer up (gui/chat_composer.ts). The inline field and the composer are never both
        // open: they are the same conversation, and they would both be holding the keyboard.
        this.openChatComposer = ()=>{
            if (!this.chatComposer || this.chatComposer.isOpen()) return;
            this.dismissChatInput();
            this.chatOpen = true;
            // The log moves with the field it belongs to: docked under the composer at the top of the
            // screen, where no soft keyboard can cover it, and pinned there -- a log that faded out
            // from under a half-typed reply would take the conversation away mid-sentence.
            clearTimeout(this.chatHistoryTextTimer);
            this.chatHistoryFader?.stop(true);
            this.chatHistory.alpha = 1.0;
            this.chatHistory.x = $7dd73ecdd94bfe01$var$COMPOSER_LOG_X;
            this.chatHistory.setAnchor("top", $7dd73ecdd94bfe01$var$COMPOSER_LOG_TOP);
            this.chatHistory.show();
            // The field owns the keyboard from here (see Keyboard.suppressTyping), which also releases
            // whatever was held when it opened -- the movement loop reads that map every frame, so
            // clearing it is what stops the player walking while they type.
            (0, $ea3f90e500565ae9$export$16e4d70cc375e707).suppressTyping(true);
            this.chatComposer.open();
        };
        this.dismissChatComposer = ()=>{
            if (!this.chatComposer?.isOpen()) return;
            // The press that is closing this panel is still travelling. pixi delivers `pointerdown` to
            // the scrim BEFORE the document-level `mousedown` the world action arrives on, so by the
            // time that one is handled the composer is already shut and isChatComposerVisible() no
            // longer gates it -- measured live: a tap on the dimmed world closed the composer and fired
            // a shot. Holding attacks off for a beat is what an interaction icon does with the same
            // problem (see Player.suppressAttack).
            this.logic.playerController?.suppressAttack();
            this.chatComposer.close();
            (0, $ea3f90e500565ae9$export$16e4d70cc375e707).suppressTyping(false);
            this.chatOpen = false;
            // Back to the ambient log, bottom-left, which fades itself out again.
            this.chatHistory.x = $7dd73ecdd94bfe01$var$CHAT_LEFT - (0, $167efe97b4119a5d$export$b0f20d83cec42115)().inset;
            this.chatHistory.setAnchor("bottom", $7dd73ecdd94bfe01$var$CHAT_LOG_BOTTOM + (0, $167efe97b4119a5d$export$b0f20d83cec42115)().insetY);
            this.scheduleChatHistoryFade(5000);
        };
        this.isChatComposerVisible = ()=>!!this.chatComposer?.isOpen();
        // Browser-console triggers, in the same shape as window.playersFlare / window.rosterWidget:
        //
        //     openChat()     // put the composer up at a desktop, where Enter opens the inline field
        //     chatFlare()    // flare the SAY chip as if a line had landed while it was closed
        //     chatComposer   // the panel itself: isOpen(), text()
        //
        // The composer is the TOUCH path, so nothing a developer at a keyboard can do opens it -- there
        // would otherwise be no way to look at it without a phone in hand.
        this.exposeChatDevTriggers = ()=>{
            if (typeof window === "undefined") return;
            window.chatComposer = this.chatComposer;
            window.openChat = ()=>{
                this.openChatComposer();
                return "[openChat] composer up";
            };
            window.chatFlare = ()=>{
                this.chatChip?.flash();
                const why = this.chatChipWanted() ? "not in a camp" : "a keyboard has Enter";
                return `[chatFlare] chip ${this.chatChip?.visible ? "up" : `hidden (${why})`}`;
            };
        };
        // Redraws the input from the current state. Everything that edits the line ends here.
        this.renderChatInput = ()=>{
            this.typing.update(this.chatInput);
        };
        // Takes the input off the screen, and the log with it, dropping the half-written line. Every
        // client-side slash command below starts this way before doing its own thing.
        this.dismissChatInput = ()=>{
            this.chatOpen = false;
            this.chatInput = (0, $2bc3e70fbff7f064$export$d42b23612a605795);
            this.typing.removeText();
            if (this.chatHistoryFader) this.chatHistoryFader.stop(true);
            this.chatHistory.alpha = 1.0;
            this.chatHistory.hide();
        };
        this.appendChatHistory = (message, speaker)=>{
            if (!message) return;
            this.chatHistory.show();
            // Callers hand over the speaker and the line apart; a single formatted "Name: line" is
            // still understood, because that is what this took for its whole life before.
            const named = speaker === undefined ? (0, $030df650e8220c82$export$1efc33041612526)(message) : {
                speaker: speaker,
                text: message
            };
            this.chatLog.push({
                ...named,
                self: !!named.speaker && named.speaker === this.logic?.playerEntity?.name
            });
            this.chatLog = this.chatLog.slice(-(0, $bde0eb94ead9038f$export$ae76bdcbbb40538));
            this.chatHistory.updateEntries(this.chatLog);
            if (this.chatHistoryFader) this.chatHistoryFader.stop(true);
            clearTimeout(this.chatHistoryTextTimer);
            this.chatHistory.alpha = 1.0;
            // A line that lands while the player is typing does NOT start the clock: fading the log
            // out from under someone who is in the middle of answering it is how a reply gets sent to
            // a conversation the sender can no longer see. stopChat starts it again on the way out.
            if (this.chatOpen) return;
            // Nobody is reading, so this line is about to fade. On touch the chip's flare is the only
            // notice the player gets that it was ever there: there is no keyboard to open chat with,
            // and the log itself is deliberately not made tappable (it is drawn over the move stick, and
            // an interactive panel there would swallow the thumb that steers). The chip rate-limits
            // itself to one flare at a time, so a busy conversation does not leave the corner blinking.
            if ((0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) this.chatChip?.flash();
            this.scheduleChatHistoryFade(5000);
        };
        this.scheduleChatHistoryFade = (delay)=>{
            clearTimeout(this.chatHistoryTextTimer);
            this.chatHistoryTextTimer = setTimeout(()=>{
                this.chatHistoryFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.chatHistory, {
                    direction: "out",
                    minAlpha: 0.0,
                    fadeInterval: 16,
                    fadeAlphaDecrement: 0.02,
                    releaseCallback: ()=>{
                        this.chatHistory.hide();
                        this.chatHistory.alpha = 1.0 // Reset alpha for next time
                        ;
                    }
                });
                this.chatHistoryFader.update();
            }, delay);
        };
        // One keystroke of chat input. `mods` is the modifier state at the moment the key went down,
        // which is what tells a plain Backspace from a word-wise one -- and what keeps the letter of
        // an OS shortcut (cmd+R) out of the line.
        this.captureKeystroke = (c, mods)=>{
            const scope = mods?.meta ? "line" : mods?.alt || mods?.ctrl ? "word" : "char";
            if (c === "Escape") {
                // player.ts closes the input right after this; dropping the line here is what makes
                // Escape a cancel rather than a send.
                this.chatInput = (0, $2bc3e70fbff7f064$export$d42b23612a605795);
                this.chatWalk = {
                    ...this.chatWalk,
                    index: -1,
                    draft: ""
                };
                return;
            }
            if (c === "Backspace") this.chatInput = (0, $2bc3e70fbff7f064$export$f2323afd0aa0bdea)(this.chatInput, scope);
            else if (c === "Delete") this.chatInput = (0, $2bc3e70fbff7f064$export$948b9f836237b4b4)(this.chatInput, scope);
            else if (c === "ArrowLeft" || c === "ArrowRight") {
                const back = c === "ArrowLeft";
                // cmd+arrow is "to the end of the line" on a Mac, not "a word at a time".
                this.chatInput = mods?.meta ? (0, $2bc3e70fbff7f064$export$f98ff0c9f6637db1)(this.chatInput, back ? "home" : "end") : (0, $2bc3e70fbff7f064$export$f98ff0c9f6637db1)(this.chatInput, back ? "left" : "right", scope === "word");
            } else if (c === "Home" || c === "End") this.chatInput = (0, $2bc3e70fbff7f064$export$f98ff0c9f6637db1)(this.chatInput, c === "Home" ? "home" : "end");
            else if (c === "ArrowUp" || c === "ArrowDown") {
                const walked = c === "ArrowUp" ? (0, $2bc3e70fbff7f064$export$7f903ac43047fe20)(this.chatWalk, this.chatInput) : (0, $2bc3e70fbff7f064$export$2957600c134d4b7e)(this.chatWalk, this.chatInput);
                this.chatWalk = walked.walk;
                this.chatInput = walked.input;
            } else if (mods?.ctrl) // The line-editing keys a terminal (and a browser text field) answers to.
            switch(c.toLowerCase()){
                case "u":
                    this.chatInput = (0, $2bc3e70fbff7f064$export$f2323afd0aa0bdea)(this.chatInput, "line");
                    break;
                case "k":
                    this.chatInput = (0, $2bc3e70fbff7f064$export$948b9f836237b4b4)(this.chatInput, "line");
                    break;
                case "w":
                    this.chatInput = (0, $2bc3e70fbff7f064$export$f2323afd0aa0bdea)(this.chatInput, "word");
                    break;
                case "a":
                    this.chatInput = (0, $2bc3e70fbff7f064$export$f98ff0c9f6637db1)(this.chatInput, "home");
                    break;
                case "e":
                    this.chatInput = (0, $2bc3e70fbff7f064$export$f98ff0c9f6637db1)(this.chatInput, "end");
                    break;
                default:
                    return;
            }
            else if (mods?.meta) // cmd+R, cmd+L, cmd+1 ... the player is talking to the browser, not to the camp.
            return;
            else if (c.length === 1) this.chatInput = (0, $2bc3e70fbff7f064$export$78ba03e296d6b5ac)(this.chatInput, c);
            else return;
            this.renderChatInput();
        };
        // Pasted text (see Keyboard.addPasteListener): dropped in at the caret, flattened to one line
        // and trimmed to whatever is left under the length cap.
        this.insertChatText = (text)=>{
            this.chatInput = (0, $2bc3e70fbff7f064$export$78ba03e296d6b5ac)(this.chatInput, text);
            this.renderChatInput();
        };
        this.stopChat = ()=>{
            this.chatOpen = false;
            // Stop any active fader and timeout
            if (this.chatHistoryFader) this.chatHistoryFader.stop(true);
            clearTimeout(this.chatHistoryTextTimer);
            const messageToSend = this.chatInput.value.trim();
            if (messageToSend === "/register") {
                this.dismissChatInput();
                if (this.logic.playerController.isGuest()) this.collectPlayerAccount(this.logic.playerEntity.name, (username, password, email)=>{
                    if (username && password) this.logic.playerController.client.register(username, password, email);
                });
                else this.addScreenMessage({
                    target: "important",
                    text: "You're already registered"
                });
                return "";
            }
            if (messageToSend === "/message") {
                this.dismissChatInput();
                if (this.incomingMessageMeta.text) {
                    this.doDynamicDialog(this.incomingMessageMeta.text);
                    this.haltMessageIndicator();
                }
                return "";
            }
            if (messageToSend === "/help") {
                this.logic.playerController.client.logActivity("invoke help");
                this.dismissChatInput();
                this.help(()=>{});
                return "";
            }
            if (messageToSend === "/upgrade") {
                this.logic.playerController.client.invokeStatUpgradeUI();
                this.dismissChatInput();
                return "";
            }
            // The frame-rate readout's second door, and the only one a phone has: `f` needs a keyboard,
            // and both thumbs on a touch screen already belong to the movement and attack sticks. Typed
            // rather than given a HUD control because it is a tool -- a fifth chip in the top-right row
            // would cost a permanent slot at the width where slots are scarcest, to carry something
            // almost nobody presses.
            //
            // Deliberately not dev-gated. A player who can say "22 fps, worst frame 140ms" has given a
            // far better bug report than one who can only say it feels bad, and the panel shows nothing
            // that isn't theirs already.
            if (messageToSend === "/fps roster") {
                // Local rendering A/B check: keep the same NPCs, simulation and frame meter,
                // but omit the roster's draw pass. No server command or gameplay state change.
                this.emberRoster.renderable = !this.emberRoster.renderable;
                this.dismissChatInput();
                return "";
            }
            if (messageToSend === "/fps") {
                this.logic.playerController.client.logActivity("invoke fps");
                this.dismissChatInput();
                this.toggleFpsMeter();
                return "";
            }
            if (messageToSend === "/about") {
                this.logic.playerController.client.logActivity("invoke about");
                this.dismissChatInput();
                this.about();
                return "";
            }
            if (messageToSend.startsWith("/timer")) {
                this.logic.playerController.client.logActivity("invoke timer");
                this.dismissChatInput();
                // Parse timer duration from command (e.g., "/timer 30" for 30 seconds)
                const parts = messageToSend.split(" ");
                const duration = parts.length > 1 ? parseInt(parts[1]) : 10 // default 10 seconds
                ;
                if (isNaN(duration) || duration <= 0) this.addScreenMessage({
                    target: "important",
                    text: "Invalid timer duration. Use: /timer [seconds]"
                });
                else {
                    this.countdownTimer.visible = true;
                    this.countdownTimer.start(duration);
                }
                return "";
            }
            if (messageToSend === "/timerstop") {
                this.logic.playerController.client.logActivity("stop timer");
                this.dismissChatInput();
                if (this.countdownTimer.visible) {
                    this.countdownTimer.stop();
                    this.countdownTimer.visible = false;
                    this.addScreenMessage({
                        target: "important",
                        text: "Timer stopped"
                    });
                } else this.addScreenMessage({
                    target: "important",
                    text: "No timer is currently running"
                });
                return "";
            }
            if (messageToSend === "/timerreset") {
                this.logic.playerController.client.logActivity("reset timer");
                this.dismissChatInput();
                this.countdownTimer.reset();
                this.countdownTimer.visible = false;
                this.addScreenMessage({
                    target: "important",
                    text: "Timer reset"
                });
                return "";
            }
            if (messageToSend === "/wheel") {
                this.logic.playerController.client.logActivity("invoke command wheel");
                this.dismissChatInput();
                this.commandWheel.fadeIn();
                this.addScreenMessage({
                    text: "Command wheel opened. Click commands to select, use button to switch NPCs."
                });
                return "";
            }
            if (messageToSend === "/wheelclose") {
                this.logic.playerController.client.logActivity("close command wheel");
                this.dismissChatInput();
                this.commandWheel.fadeOut();
                this.addScreenMessage({
                    text: "Command wheel closed"
                });
                return "";
            }
            if (messageToSend.startsWith("/hero")) {
                this.logic.playerController.client.logActivity("test hero message");
                this.dismissChatInput();
                // Parse text and duration from command
                // Format: /hero [duration] [text] or /hero [text]
                const parts = messageToSend.split(" ");
                let text = "HERO MESSAGE!" // default text
                ;
                let duration = 2000 // default 2 seconds
                ;
                if (parts.length > 1) {
                    // Check if second part is a number (duration)
                    const secondPart = parseInt(parts[1]);
                    if (!isNaN(secondPart)) {
                        // Format: /hero [duration] [text]
                        duration = secondPart;
                        text = parts.slice(2).join(" ") || "HERO MESSAGE!";
                    } else // Format: /hero [text]
                    text = parts.slice(1).join(" ");
                }
                this.addScreenMessage({
                    target: "hero",
                    text: text,
                    duration: duration
                });
                return "";
            }
            // The log outlives the input it was opened with, so the player can read the answer to
            // what they just sent.
            if (this.chatHistoryFader) this.chatHistoryFader.stop(true);
            this.scheduleChatHistoryFade(10000);
            // Remember what was sent for the up-arrow walk (consecutive duplicates collapse), and
            // reset the walk so the next Up starts from this line rather than mid-history.
            this.chatWalk = (0, $2bc3e70fbff7f064$export$8981372ce0f88573)(this.chatWalk, messageToSend);
            if (messageToSend) this.saveChatHistory();
            this.chatInput = (0, $2bc3e70fbff7f064$export$d42b23612a605795);
            this.typing.removeText();
            return messageToSend;
        };
        this.saveChatHistory = ()=>{
            try {
                if (typeof localStorage !== "undefined") localStorage.setItem(this.CHAT_HISTORY_KEY, JSON.stringify(this.chatWalk.entries));
            } catch (error) {
                console.warn("Failed to save chat history to localStorage:", error);
            }
        };
        this.loadChatHistory = ()=>{
            try {
                if (typeof localStorage !== "undefined") {
                    const saved = localStorage.getItem(this.CHAT_HISTORY_KEY);
                    if (saved) {
                        const parsed = JSON.parse(saved);
                        if (Array.isArray(parsed)) this.chatWalk = {
                            entries: parsed.filter((entry)=>typeof entry === "string"),
                            index: -1,
                            draft: ""
                        };
                    }
                }
            } catch (error) {
                console.warn("Failed to load chat history from localStorage:", error);
                this.chatWalk = (0, $2bc3e70fbff7f064$export$2cd8bbcbf799240);
            }
        };
        this.clearChatHistory = ()=>{
            this.chatWalk = (0, $2bc3e70fbff7f064$export$2cd8bbcbf799240);
            try {
                if (typeof localStorage !== "undefined") localStorage.removeItem(this.CHAT_HISTORY_KEY);
            } catch (error) {
                console.warn("Failed to clear chat history from localStorage:", error);
            }
        };
        this.addScreenMessage = (message)=>{
            const { target: target, text: text, roomId: roomId, action: action, actionToken: actionToken, context: context, suppressOnCloseEmitEvent: suppressOnCloseEmitEvent } = message;
            if (suppressOnCloseEmitEvent && this.currentModal) this.currentModal.modal.suppressOnCloseCallback = suppressOnCloseEmitEvent;
            if ((target === "chapterChecklist" || target === "hud") && roomId && !this.acceptsSceneRoom(roomId)) {
                // The server sends a camp's checklist and HUD list on the tick the player arrives there,
                // which can beat the client's own scene change by a few milliseconds, and it never sends
                // an unchanged one twice. Dropped, a fresh camp had no checklist at all. Kept instead, for
                // roomUpdated to hand over once the scene is entered.
                this.earlySceneMessages.set(target, message);
                return;
            }
            if (!this.acceptsSceneRoom(roomId)) return;
            if (target === "hud") {
                this.hudPresence.setHidden(message.hudHidden || []);
                this.layoutChipRow();
                return;
            }
            if (target === "chapterChecklist") {
                this.chapterChecklist.update(message.chapterChecklist || null);
                this.chapterChecklist.place();
                return;
            }
            if (target === "stairPicker") {
                this.hideRolePicker();
                if (action !== "close" && message.stairChoices) {
                    this.closeModal();
                    this.stairPickerMessage = message;
                    this.rolePicker.bindStairs(message.entityId);
                    this.positionRolePickerOverEntity(message.entityId);
                    this.rolePicker.fadeIn();
                    this.preventContextMenu();
                }
                return;
            }
            if (action === "close" && target !== "featureWidget") {
                this.closeModal();
                return;
            }
            if (action === "openDynamicDialog") this.dynamicDialogToken = actionToken;
            if (!target) {
                this.screenMessages.push(message);
                // Always consume messages immediately to allow interruption
                this.consumeMessages();
            } else {
                if (target === "leaderboard") this.updateBannerText(text);
                if (target === "important") {
                    // Into the queue, not onto the strip. The lane decides what shows and for how long,
                    // and `updateTimer` below is what hands its choice to the widget.
                    this.importantLane.push({
                        text: message.text || "",
                        tier: message.context?.tier === "alert" ? "alert" : "notice",
                        durationMs: message.duration,
                        source: message
                    });
                    this.pumpImportantLane(0);
                }
                if (target === "waveStatus") this.updateWaveIndicator(message);
                if (target === "countdown") {
                    const duration = parseInt(text);
                    if (!isNaN(duration) && duration > 0) {
                        // The dial and the wave badge share one slot: starting a countdown means the
                        // previous wave is over, so the badge comes down.
                        this.waveIndicator.update(null);
                        this.countdownTimer.visible = true;
                        // The wave is optional: the camp sends it, `/timer` doesn't, and without it the
                        // dial simply goes uncaptioned.
                        this.countdownTimer.start(duration, Number(message.context?.wave) || 0, message.context?.expedition === true);
                        // Remember what this dial is counting to, so the landing knows the player sat
                        // through it. Read off the message rather than off the dial's own visibility:
                        // the dial takes ITSELF off screen at zero, and the server's "it landed" arrives
                        // a round trip later, so by then `visible` is a race.
                        this.waveAwaited = Number(message.context?.wave) || undefined;
                    } else if (!isNaN(duration)) {
                        // A non-positive value is an explicit "hide the countdown" signal (e.g. the ember
                        // waves were stopped on a delegated respawn). Clear the ring immediately instead of
                        // letting its client-side timer run down.
                        this.countdownTimer.stop();
                        this.countdownTimer.visible = false;
                    } else this.addScreenMessage({
                        target: "important",
                        text: "Invalid countdown duration. Must be a positive number."
                    });
                }
                if (target === "hero") this.heroMessage.show(message);
                if (target === "dialog") {
                    if (message.forceTarget) this.doDynamicDialog(message);
                    else this.availableMessage(message);
                }
                if (target === "stickyBanner") {
                    this.stickyBanner.setup(message.text, message.context?.icon, message.context?.hoverText);
                    this.stickyBanner.x = this.controlBar.x - this.stickyBanner.width - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                    this.dayCycle.x = this.stickyBanner.x - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 1.25;
                }
                if (target === "featureWidget") this.featureWidget.setup(message);
            }
        };
        this.updateLeaderboard = (leaderboards)=>{
            this.leaderboard.update(leaderboards);
        };
        this.updateInventory = (owner, inventory)=>{
            if (this.inventoryUpdateTs.get(owner.entityId) === inventory.lastUpdateTs) return false;
            this.inventoryUpdateTs.set(owner.entityId, inventory.lastUpdateTs);
            const player = this.getPlayer();
            if (player.entityId === owner.entityId) {
                if (this.dynamicDialogToken) this.logic.emitConversationResponse(this.dynamicDialogToken);
                // Worked out BEFORE the tray is drawn, because the tray now carries the count: the
                // arrows used to be read off the ResourceBar beside the player's NAME, in the opposite
                // corner from the bow they belong to.
                const ammoBearingWeapon = (0, $f684496fff50a7a1$export$429c16c642745fa3)(inventory, "weapon").sort((b, a)=>a.active ? 2 : 1 - (b.active ? 2 : 1)).find((o)=>{
                    return !!(0, $bf6244e5cc9aa116$export$3f4c28cf92a4cf37)[o.itemType];
                });
                let ammo;
                if (ammoBearingWeapon) {
                    const ammoType = (0, $f684496fff50a7a1$export$9efb6bfe58196888)((0, $bf6244e5cc9aa116$export$3f4c28cf92a4cf37)[ammoBearingWeapon.itemTypeMeta.type]);
                    if (ammoType) {
                        // Only while the bow is actually IN HAND. A bow sitting in the pack makes the
                        // arrow count noise -- it is not what the next click is going to spend.
                        if (ammoBearingWeapon.active) {
                            const ammoItem = (0, $f684496fff50a7a1$export$4c2157e8933c20e3)(inventory, ammoType.type);
                            ammo = {
                                icon: `${ammoType.type}-${ammoType.color}.png`,
                                quantity: ammoItem?.quantity || 0
                            };
                        }
                        this.logic.playerController.updateLongRangedEquippedState(ammoBearingWeapon.active);
                    } else this.logic.playerController.updateLongRangedEquippedState(false);
                } else this.logic.playerController.updateLongRangedEquippedState(false);
                const chargedItem = inventory.items.find((item)=>item.active && item.quantity > 0 && item.flags?.chargedWeaponId);
                const charged = player.chargedWeaponDefinition || (chargedItem?.flags.chargedWeaponId === (0, $4c8e1a710c1d007e$export$5b11a9d6569cde02).id ? (0, $4c8e1a710c1d007e$export$5b11a9d6569cde02) : undefined);
                if (chargedItem && charged) {
                    const material = (0, $f684496fff50a7a1$export$9efb6bfe58196888)(charged.ammunition.items[0]);
                    const quantity = inventory.items.reduce((sum, item)=>charged.ammunition.items.includes(item.itemTypeMeta?.type) ? sum + Math.max(0, item.quantity || 0) : sum, 0);
                    ammo = {
                        icon: material.spriteId || `${material.type}-${material.color}.png`,
                        quantity: Math.floor(quantity / charged.ammunition.quantity)
                    };
                    this.logic.playerController.updateLongRangedEquippedState(true);
                }
                this.slotCallbacks = this.equipped.update(inventory, (itemId)=>{
                    this.logic.playerController.selectSlot(itemId);
                }, ammo);
                this.abilities.update(inventory, (shortcut)=>{
                    this.logic.playerController.activeAbility(shortcut);
                });
                this.abilities.x = this.equipped.x + this.equipped.width;
                const shards = (0, $f684496fff50a7a1$export$4c2157e8933c20e3)(inventory, "shard-metal");
                this.resourceBar.setup([
                    {
                        icon: `shard-metal-gray.png`,
                        quantity: shards?.quantity || 0
                    }
                ]);
                this.resourceBar.x = this.nameText.x + this.nameText.width + 20;
                // Honor per-room suppression (e.g. ember rooms) — the ammo branch above may have
                // forced it visible; keep it hidden while suppressed.
                this.resourceBar.visible = !this.suppressShards;
            }
            // this.inventoryGui.update()
            return true;
        };
        this.activateInventorySlot = (slot)=>{
            const callback = this.slotCallbacks[slot];
            if (callback) callback();
        };
        this.mouseOverControl = (disable)=>{
            this.logic.enablePlayerMouseAction(!disable);
        };
        this.consumeMessages = ()=>{
            // Clear any existing timeout to allow interruption
            if (this.currentMessageTimeout) {
                clearTimeout(this.currentMessageTimeout);
                this.currentMessageTimeout = null;
            }
            // If there's a current message, interrupt it and process the next one
            if (this.currentScreenMessage) {
                if (this.currentScreenMessage.displayCallback) this.currentScreenMessage.displayCallback();
                this.currentScreenMessage = null;
            }
            this.currentScreenMessage = this.screenMessages.shift();
            if (!this.currentScreenMessage) return;
            const { text: text, roomId: roomId, displayCallback: displayCallback } = this.currentScreenMessage;
            let delayMs = 0;
            if (this.acceptsSceneRoom(roomId)) {
                this.bannerText.text = text;
                const wordCount = text.split(" ").length;
                delayMs = Math.max(1000, wordCount * 60 / 200 * 1000);
            }
            this.currentMessageTimeout = setTimeout(()=>{
                if (displayCallback) displayCallback();
                this.bannerText.text = "";
                this.currentScreenMessage = null;
                this.currentMessageTimeout = null;
                this.consumeMessages();
            }, delayMs);
        };
        /**
     * Close the curtain. `durationMs` is how long it takes; the default is the 1s this always was.
     *
     * A transition (Protocol.TransitFade) sets it, because a scene change wants the curtain to close
     * at a pace that matches what is happening behind it -- a descent has already spent its fade
     * dissolving the player, and the curtain following over the empty ground is the shorter half.
     */ this.fadeOut = (immediate, durationMs = 1000)=>{
            this.blackout.alpha = 0.0;
            this.blackout.visible = true;
            this.bannerText.text = "";
            // Clear any pending message timeout
            if (this.currentMessageTimeout) {
                clearTimeout(this.currentMessageTimeout);
                this.currentMessageTimeout = null;
            }
            this.currentScreenMessage = null;
            if (immediate) this.blackout.alpha = 1.0;
            else {
                const step = Math.max(16, durationMs / 10);
                const loop = setInterval(()=>{
                    const newAlpha = Math.min(1.0, this.blackout.alpha + 0.1);
                    this.blackout.alpha = newAlpha;
                    if (newAlpha === 1.0) clearInterval(loop);
                }, step);
            }
        };
        /**
     * Close the curtain and leave it closed, with none of fadeOut's housekeeping (it also clears the
     * banner and the message queue, which a room load has no business doing).
     *
     * Used to hold a freshly loaded room out of sight while it finishes arriving: fadeIn starts from
     * full black anyway, so this only brings that black forward to the moment the room lands rather
     * than the moment the screen opens on it. See RoomReveal.
     */ this.holdBlackout = ()=>{
            this.blackout.alpha = 1.0;
            this.blackout.visible = true;
        };
        this.isBlackoutVisible = ()=>!!this.blackout.visible && this.blackout.alpha > 0;
        this.fadeIn = (immediate = false)=>{
            if (immediate) {
                this.blackout.alpha = 0;
                this.blackout.visible = false;
                return;
            }
            this.blackout.alpha = 1.0;
            this.blackout.visible = true;
            const loop = setInterval(()=>{
                const newAlpha = Math.max(0.0, this.blackout.alpha - 0.1);
                this.blackout.alpha = newAlpha;
                if (newAlpha === 0.0) {
                    clearInterval(loop);
                    this.blackout.alpha = 0.0;
                    this.blackout.visible = false;
                }
            }, 100);
        };
        this.roomUpdated = (roomId, roomName, suppressMinimap, suppressDayCycle, suppressControlBar, suppressLevelUp, suppressMana, suppressFood, suppressShards, suppressPlayerName, suppressTutorial, suppressGuestPrompt, suppressTeamCommands)=>{
            const sceneId = this.logic.scene?.id ?? roomId;
            const sceneGeneration = this.logic.scene?.generation;
            const sceneChanged = sceneId !== (this.currentSceneId ?? this.currentRoomId) || this.currentSceneGeneration !== undefined && this.currentSceneGeneration !== sceneGeneration;
            // Camp HUD state belongs to the scene. Taking stairs keeps its countdown and wave state;
            // entering another scene clears it, even if the previous active room was an upper floor.
            if (sceneChanged && this.countdownTimer) {
                // Land anything still in flight before the list it was flying to goes.
                this.chapterCelebration?.flush();
                this.chapterChecklist?.update(null);
                // What one camp held back is its own; the next says for itself.
                this.hudPresence.setHidden([]);
                this.countdownTimer.reset();
                this.countdownTimer.visible = false;
                // Same for the wave badge: it's per-room wave UI, and the room it belonged to is gone.
                this.waveIndicator?.update(null);
                // ...and the fire gauge, for the same reason. It would otherwise keep showing the
                // strength of a camp the player has walked out of until the next roster packet, and in
                // a room that sends no roster at all (a cave) it would simply never come down.
                this.emberFireGauge?.update(undefined);
                // Forget which wave was last played, and what was being counted down to: the next
                // camp's wave 1 is a landing this player has not watched yet.
                this.wavePlayed = undefined;
                this.waveAwaited = undefined;
            }
            // Clues, invitations and chat stay with the camp through floor transfers.
            if (sceneChanged) {
                this.emberAnxietyMeter?.update(null);
                this.emberInviteModal?.close();
                this.recruitHintRoster = [];
                this.recruitMenuHint.reset();
                this.tutorial.clearEmberClues();
                // Nothing typed at one camp should still be on screen over the next one -- and a DOM
                // field left up keeps a phone's keyboard over the room that is loading behind it.
                this.dismissChatComposer();
            }
            const minimapRoomChanged = sceneChanged;
            this.currentRoomId = roomId;
            this.currentSceneId = sceneId;
            this.currentSceneGeneration = sceneGeneration;
            // After the scene change above has cleared the last camp's state, never before it.
            this.earlySceneMessages.forEach((message, target)=>{
                if (!this.acceptsSceneRoom(message.roomId)) return;
                this.earlySceneMessages.delete(target);
                this.addScreenMessage(message);
            });
            this.currenRoomName = roomName;
            this.screenMessages = this.screenMessages.filter((n)=>this.acceptsSceneRoom(n.roomId));
            this.controlBar.visible = !suppressControlBar;
            // The pack has to stay reachable. Suppressing the control bar takes the inventory button
            // with it, and in a camp there is no keyboard to fall back on, so the chip in the top-right
            // row stands in for exactly as long as the bar is gone.
            this.emberInventoryChip.visible = !!suppressControlBar;
            // Chat's button follows the pack's: whenever the bar that carries it is gone, the chip in
            // the top-right row stands in for it -- but only on a machine that needs standing in for.
            this.chatChip.visible = !!suppressControlBar && this.chatChipWanted();
            this.layoutChipRow();
            // Latch per-room mana / food (hunger) meter suppression so it survives later update() calls,
            // which otherwise force the meters visible on any mana/hunger change. Hide immediately on
            // entry (and the meters are restored on exit when the flags come back false).
            this.suppressMana = !!suppressMana;
            this.suppressFood = !!suppressFood;
            this.mana.visible = !this.suppressMana;
            if (this.suppressFood) this.hunger.visible = false;
            // Latch per-room shard/resource counter + player-name suppression. updateInventory() only
            // fires when the inventory changes, so apply the resourceBar state here on entry too; the
            // name label is applied directly here (update() never toggles its visibility).
            this.suppressShards = !!suppressShards;
            this.suppressPlayerName = !!suppressPlayerName;
            this.resourceBar.visible = !this.suppressShards;
            this.nameText.visible = !this.suppressPlayerName;
            // Latch per-room day/night suppression so it survives later updateDayPct() calls, which
            // otherwise force the widget visible on every day-pct tick. Hide immediately on entry too.
            this.suppressDayCycle = !!suppressDayCycle;
            if (this.suppressDayCycle) this.dayCycle.visible = false;
            // Latch per-room "Level up stats!" suppression and rebuild the help-messaging stack so a
            // button from the previous room is removed on entry (and restored on exit).
            this.suppressLevelUp = !!suppressLevelUp;
            // Latch per-room tutorial suppression so showTutorial() is a no-op while in the room (and
            // popups return once the flag comes back false on exit). Ember rooms set this.
            this.tutorial.suppressed = !!suppressTutorial;
            // Same for a guest's "/register to save progress" line, which helpMessaging() rebuilds from
            // scratch just below -- so setting it here is what takes the line off on entry and puts it
            // back on exit.
            this.squad.visible = !suppressTeamCommands;
            this.suppressGuestPrompt = !!suppressGuestPrompt;
            this.helpMessaging();
            this.minimapSurface.roomUpdated(this.userSuppressMinimap || suppressMinimap);
            this.featureWidget.remove();
            // Clear scene feeds on leaving the camp, retaining them during floor transfers.
            // clear(), not update([]): the cards are not dying, the player is leaving the room, and a
            // card cannot break apart over a room that is already gone.
            if (sceneChanged) this.emberRoster.clearRoster();
            this.positionEmberRoster();
            // Queued notices are about the room being left. Drop them rather than announcing the old
            // camp's wave over the new one.
            if (sceneChanged) {
                this.importantLane.clear();
                this.importantMessage.dismiss();
            }
            // Metadata refreshes for the same room must not erase an unchanged discovery feed.
            if (minimapRoomChanged) {
                this.emberMinimap.selectRoom(sceneId);
                this.updateEmberMinimap(null);
            }
            // The player list and follow-cam share the same scene lifetime as the roster.
            if (sceneChanged) this.updateEmberPlayers([]);
            // Leaving the scene also clears the server focus subscription.
            if (sceneChanged && this.followCam?.isOpen()) this.closeFollowCam();
        };
        this.hideRoomName = (hidden)=>{
            this.roomNameHidden = hidden;
        };
        this.animateAbility = (abilityType, duration)=>{
            const pulsar = this.abilities.slotPulsar.get(abilityType);
            if (!pulsar) return;
            pulsar.pulse(duration || 750);
        };
        this.animateLocalEntityCollection = (entity, target, position)=>{
            // for now -- all local entity animations relate to ability slot
            const abilityType = target.split(":")[1];
            const location = this.abilities.slotCoordinates.get(abilityType);
            if (!location) return;
            const destX = this.abilities.x + location.x + 3;
            const destY = this.abilities.y + location.y - 10;
            const entityRenderingManager = this.logic.clientRenderer.entity();
            const clientRenderable = entityRenderingManager.renderEntity(entity);
            this.stage.addChild(clientRenderable);
            clientRenderable.x = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w * 0.58;
            clientRenderable.y = 285;
            const increment = 6;
            const animationInterval = setInterval(()=>{
                const currentDistance = (0, $cb689cfa16c444ba$export$79376507b09a66f)(clientRenderable.x, clientRenderable.y, destX, destY);
                if (currentDistance < increment) {
                    clearInterval(animationInterval);
                    // clientRenderable.remove()
                    const fadeInterval = setInterval(()=>{
                        if (clientRenderable.alpha <= 0.0) {
                            clearInterval(fadeInterval);
                            clientRenderable.remove();
                            return;
                        }
                        clientRenderable.alpha -= 0.01;
                    }, 1);
                    return;
                }
                if (clientRenderable.alpha > 0.6) clientRenderable.alpha -= 0.01;
                clientRenderable.x += clientRenderable.x > destX ? -increment : increment;
                clientRenderable.y += clientRenderable.y > destY ? -increment : increment;
            }, 1);
        };
        this.updateMobileBuildToolbar = ()=>{
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) return;
            const player = this.logic.playerController;
            if (!player?.mobileBuildingState || !this.equipped) return;
            if (!this.mobileBuildToolbar) {
                this.mobileBuildToolbar = new (0, $61c7210a4ddc624c$export$a2f2fafd4be10a1b)({
                    toggle: (on)=>{
                        this.touchSticks?.releaseAll();
                        this.logic.playerController.setMobileBuildMode(on);
                    },
                    select: (tool)=>this.logic.playerController.selectMobileBuildTool(tool),
                    undo: ()=>this.logic.playerController.undoMobileBuild()
                });
                this.container.addChild(this.mobileBuildToolbar);
            }
            this.mobileBuildToolbar.update(player.mobileBuildingState(), this.equipped.position);
            if (this.isItemScreenOpen() || this.isCommandWheelVisible() || this.isChatComposerVisible() || this.isNamePromptVisible() || this.characterBuilder?.isOpen() || this.characterCustomizer?.isOpen() || this.blackout?.visible || this.currenRoomName === (0, $cb689cfa16c444ba$export$1bb94dd20d93df2d)) this.mobileBuildToolbar.visible = false;
        };
        this.mobileBuildCoordinate = (at)=>{
            const world = this.mobileBuildWorldPoint(at);
            return world ? this.logic.playerController.buildingTargetAt(world) : null;
        };
        this.mobileBuildWorldPoint = (at)=>{
            const overlay = this.logic.clientRenderer.map().overlay();
            if (!overlay) return null;
            const local = overlay.toLocal(at);
            return overlay.worldLocation(local.x, local.y);
        };
        /**
     * The two touch sticks.
     *
     * Neither is pinned any more: a stick is summoned under the thumb that asks for it and fades
     * when that thumb lifts, so a phone screen costs nothing to a control nobody is holding. The
     * left half of the screen summons this move stick, the right half the attack stick; FloatingSticks
     * owns the gesture, the halves and the "is this touch free?" question.
     */ this.setupJoystick = (container)=>{
            if (!(0, $10da07838e6d507c$export$d0a8044dce8ff2fc)()) return;
            const moveStick = new (0, $d433a8402e64fdc4$export$c28ac4966a0b048a)({
                outer: (0, $7Bs2Z.Sprite).from("outer"),
                inner: (0, $7Bs2Z.Sprite).from("inner"),
                outerScale: {
                    x: 0.5,
                    y: 0.5
                },
                innerScale: {
                    x: 0.8,
                    y: 0.8
                },
                // Held intent, not a direct write. Player's 60Hz velocity loop rebuilds
                // speed2 from held input every tick, so anything written onto entity.speed2
                // here is erased before the next frame -- and since onChange only fires as the
                // thumb travels, a thumb held at full deflection never writes again. That pair
                // is what made the stick stutter and refuse to move continuously.
                onChange: (data)=>{
                    const entity = this.logic.playerEntity;
                    const { power: power } = data;
                    if (power < $7dd73ecdd94bfe01$var$JoystickDeadZone) {
                        this.logic.playerController.setJoystickIntent(null);
                        return;
                    }
                    const vector = $7dd73ecdd94bfe01$var$JoystickVectors[data.direction];
                    if (!vector) return;
                    // Stick pushed right out to the rim means sprint. See sprintScaledIntent
                    // for why scaling the vector is the whole mechanic, and why it must not
                    // scale the shared JoystickVectors entry in place.
                    const intent = (0, $10da07838e6d507c$export$37f678e26ae1e8b8)(vector, power);
                    this.logic.playerController.setJoystickIntent(intent);
                    // Facing follows the move stick unless the aim stick has taken it over.
                    // Sprinting scales the vector but not its direction, so the same intent
                    // serves for both.
                    if (this.leftJoystickAngleAllowed) entity.movement.angle = (0, $a80d0b17b615d6f7$export$b363da9ded343252)({
                        x: entity.location.x + intent.x,
                        y: entity.location.y + intent.y
                    }, {
                        x: entity.location.x,
                        y: entity.location.y
                    });
                },
                onStart: ()=>{
                    this.logic.playerController.enabledMouseAction(false);
                },
                onEnd: ()=>{
                    this.logic.playerController.setJoystickIntent(null);
                    this.logic.playerController.enabledMouseAction(true);
                }
            });
            container.addChild(moveStick);
            const knob = (0, $7Bs2Z.Sprite).from("inner");
            knob.tint = 0xff0000;
            let angleBeforeAim;
            const aimStick = new (0, $d433a8402e64fdc4$export$c28ac4966a0b048a)({
                outer: (0, $7Bs2Z.Sprite).from("outer"),
                inner: knob,
                outerScale: {
                    x: 0.5,
                    y: 0.5
                },
                innerScale: {
                    x: 0.8,
                    y: 0.8
                },
                onChange: (data)=>{
                    const entity = this.logic.playerEntity;
                    const { power: power } = data;
                    if (power < $7dd73ecdd94bfe01$var$JoystickDeadZone) return;
                    const aim = $7dd73ecdd94bfe01$var$JoystickVectors[data.direction];
                    if (!aim) return;
                    entity.movement.angle = (0, $a80d0b17b615d6f7$export$b363da9ded343252)({
                        x: entity.location.x + aim.x,
                        y: entity.location.y + aim.y
                    }, {
                        x: entity.location.x,
                        y: entity.location.y
                    });
                },
                onStart: ()=>{
                    this.logic.playerController.enabledMouseAction(false);
                    this.leftJoystickAngleAllowed = false;
                    angleBeforeAim = this.getPlayer().movement.angle;
                    this.logic.playerController.setAttackHeld(true);
                },
                onEnd: ()=>{
                    this.logic.playerController.enabledMouseAction(true);
                    this.logic.playerController.setAttackHeld(false);
                    this.leftJoystickAngleAllowed = true;
                    this.getPlayer().movement.angle = angleBeforeAim;
                }
            });
            container.addChild(aimStick);
            this.touchSticks = new (0, $d433a8402e64fdc4$export$941e6c675ffa98cd)({
                app: (0, $065c5647ab3ff4dc$export$56359d4511c7424)(),
                layer: container,
                move: moveStick,
                aim: aimStick,
                // Read per touch rather than cached: the HUD's width comes off the stage, which the
                // letterbox can still be resizing when the first player entity arrives and this runs.
                midline: ()=>{
                    const { left: left, right: right } = this.hudBounds();
                    return (left + right) / 2;
                },
                // The attack already started on press, so release never adds another swing.
                onAimTap: ()=>{},
                buildMode: ()=>this.logic.playerController.mobileBuildingState().active,
                movementZone: (at)=>{
                    const { left: left, bottom: bottom } = this.hudBounds();
                    return at.x >= left && at.x < left + 140 && at.y > bottom - 150 / (0, $10da07838e6d507c$export$c6ec669adaa5980d);
                },
                onWorldDown: (event)=>{
                    if (!(0, $f246f635ee3b2e66$export$7caecd373b84cec3).isWorldPoint(event.data.global)) return false;
                    const point = this.mobileBuildCoordinate(event.data.global);
                    return !!point && this.logic.playerController.beginMobileBuildTouch(point, this.mobileBuildWorldPoint(event.data.global) ?? undefined);
                },
                onWorldMove: (event)=>{
                    const point = this.mobileBuildCoordinate(event.data.global);
                    if (point) this.logic.playerController.moveMobileBuildTouch(point, this.mobileBuildWorldPoint(event.data.global) ?? undefined);
                },
                onWorldUp: (cancelled)=>{
                    if (!cancelled) this.logic.playerController.endTilePress();
                    this.logic.playerController.endMobileBuildTouch();
                }
            });
            this.touchSticks.bind();
        };
        this.socialMedia = (parent)=>{
            const container = new (0, $gwPoJ.Graphics)();
            container.y = 480;
            if (parent) parent.addChild(container);
            const socialMedia = new (0, $gwPoJ.Graphics)();
            const reddit = new (0, $7Bs2Z.Sprite)((0, $kXE1p.Loader).shared.resources["reddit"].texture);
            reddit.scale.set(0.05);
            reddit.interactive = true;
            reddit.on("click", ()=>{
                window.open("https://www.reddit.com/r/projectsamsara/");
                this.logic.playerController.client.logActivity(`>> ${this.logic.playerEntity?.name || "guest"} visited discord <<`);
            });
            reddit.on("tap", ()=>{
                window.open("https://www.reddit.com/r/projectsamsara/");
                this.logic.playerController.client.logActivity(`>> ${this.logic.playerEntity?.name || "guest"} visited subreddit <<`);
            });
            const discord = new (0, $7Bs2Z.Sprite)((0, $kXE1p.Loader).shared.resources["discord"].texture);
            discord.scale.set(0.13);
            discord.x = reddit.x + reddit.width + 12;
            discord.y = -1;
            discord.interactive = true;
            discord.on("click", ()=>window.open("https://discord.gg/Mbt6UfqW6e"));
            discord.on("tap", ()=>window.open("https://discord.gg/Mbt6UfqW6e"));
            socialMedia.addChild(reddit);
            socialMedia.addChild(discord);
            container.addChild(socialMedia);
            return container;
        };
        this.collectPlayerAccount = (name, doneCallback)=>{
            const release = ()=>{
                this.logic.playerController.enabledKeyboardAction(true);
                this.logic.playerController.enabledMouseAction(true);
            };
            const askForName = ()=>{
                const dialog = new (0, $gwPoJ.Graphics)();
                this.stage.addChild(dialog);
                const padding = 20;
                const container = new (0, $gwPoJ.Graphics)();
                container.x = padding;
                container.y = padding;
                dialog.addChild(container);
                const bannerText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().variant("BannerFont").render();
                bannerText.y = 10;
                bannerText.text = "Register new player:";
                container.addChild(bannerText);
                const placeHolder = name;
                const nameField = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
                    input: {
                        fontSize: "20pt",
                        padding: "10px",
                        width: "530px",
                        color: "#26272E"
                    },
                    box: {
                        default: {
                            fill: 0xe8e9f3,
                            rounded: 16,
                            stroke: {
                                color: 0xcbcee0,
                                width: 4
                            }
                        },
                        focused: {
                            fill: 0xe1e3ee,
                            rounded: 16,
                            stroke: {
                                color: 0xabafc6,
                                width: 4
                            }
                        },
                        disabled: {
                            fill: 0xdbdbdb,
                            rounded: 16
                        }
                    }
                });
                nameField.text = placeHolder;
                nameField.y = 50;
                nameField.placeholder = placeHolder;
                nameField.placeholderColor = 0x000000;
                container.addChild(nameField);
                nameField.focus();
                let currentName = placeHolder;
                let currentPassword = "";
                let currentEmail = "";
                const submit = ()=>{
                    if (!currentName) {
                        this.addScreenMessage({
                            target: "important",
                            text: "Player name is required"
                        });
                        return false;
                    }
                    if (!currentPassword) {
                        this.addScreenMessage({
                            target: "important",
                            text: "Password is required"
                        });
                        return false;
                    }
                    release();
                    doneCallback(currentName, currentPassword, currentEmail);
                    return true;
                };
                nameField.on("input", (text)=>{
                    currentName = text;
                });
                nameField.on("keyup", (keycode)=>{
                    if (keycode === 27) {
                        release();
                        container.removeChildren();
                        dialog.parent.removeChild(dialog);
                        return;
                    }
                    if (keycode === 13) passwordField.focus();
                });
                const passwordField = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
                    input: {
                        fontSize: "20pt",
                        padding: "10px",
                        width: "530px",
                        color: "#26272E"
                    },
                    box: {
                        default: {
                            fill: 0xe8e9f3,
                            rounded: 16,
                            stroke: {
                                color: 0xcbcee0,
                                width: 4
                            }
                        },
                        focused: {
                            fill: 0xe1e3ee,
                            rounded: 16,
                            stroke: {
                                color: 0xabafc6,
                                width: 4
                            }
                        },
                        disabled: {
                            fill: 0xdbdbdb,
                            rounded: 16
                        }
                    }
                });
                passwordField._dom_input.type = "password";
                passwordField.y = 115;
                passwordField.placeholder = "Password";
                passwordField.placeholderColor = 0x000000;
                passwordField.on("input", (text)=>{
                    currentPassword = text;
                });
                passwordField.on("keyup", (keycode)=>{
                    if (keycode === 27) {
                        release();
                        container.removeChildren();
                        dialog.parent.removeChild(dialog);
                        return;
                    }
                    if (keycode === 13) {
                        if (submit()) {
                            container.removeChildren();
                            dialog.parent.removeChild(dialog);
                        }
                    }
                });
                container.addChild(passwordField);
                const emailField = new (0, (/*@__PURE__*/$parcel$interopDefault($8JEKL)))({
                    input: {
                        fontSize: "20pt",
                        padding: "10px",
                        width: "530px",
                        color: "#26272E"
                    },
                    box: {
                        default: {
                            fill: 0xe8e9f3,
                            rounded: 16,
                            stroke: {
                                color: 0xcbcee0,
                                width: 4
                            }
                        },
                        focused: {
                            fill: 0xe1e3ee,
                            rounded: 16,
                            stroke: {
                                color: 0xabafc6,
                                width: 4
                            }
                        },
                        disabled: {
                            fill: 0xdbdbdb,
                            rounded: 16
                        }
                    }
                });
                emailField.y = 180;
                emailField.placeholder = "Email (optional)";
                emailField.placeholderColor = 0x000000;
                emailField.on("input", (text)=>{
                    currentEmail = text;
                });
                container.addChild(emailField);
                const buttonContainer = new (0, $gwPoJ.Graphics)();
                buttonContainer.y = 245;
                container.addChild(buttonContainer);
                {
                    const button = new (0, $gwPoJ.Graphics)();
                    button.addChild(new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().variant("ImportantFont").render("Cancel"));
                    button.x = 125;
                    button.interactive = true;
                    button.on("click", ()=>{
                        release();
                        doneCallback();
                        container.removeChildren();
                        dialog.parent.removeChild(dialog);
                    });
                    buttonContainer.addChild(button);
                }
                {
                    const button = new (0, $gwPoJ.Graphics)();
                    const text = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().variant("ImportantFont").render("Register");
                    text.tint = 0x00ff00;
                    button.addChild(text);
                    button.interactive = true;
                    button.on("click", ()=>{
                        if (submit()) {
                            container.removeChildren();
                            dialog.parent.removeChild(dialog);
                            doneCallback();
                        }
                    });
                    buttonContainer.addChild(button);
                }
                dialog.x = 15;
                dialog.y = 50;
                dialog.lineStyle(1, 0xffffff, 0.5);
                dialog.beginFill(0x000000, 0.9);
                dialog.drawRoundedRect(0, 0, dialog.width + padding * 2, dialog.height + padding * 2.5, 8);
                dialog.endFill();
            };
            this.logic.playerController.enabledKeyboardAction(false);
            this.logic.playerController.enabledMouseAction(false);
            askForName();
        };
        this.help = (doneCallback)=>{
            const help = new (0, $7ce197e6bf5d40c1$export$1be7516c0280bee8)(this);
            help.toggle();
        };
        this.screenDimensions = ()=>{
            return {
                w: this.stage.width,
                h: this.stage.height
            };
        };
        this.createModal = (props)=>{
            const modal = new (0, $33e5ff783af47130$export$2b77a92f1a5ad772)(this.logic, this.stage, props);
            modal.update();
            return modal;
        };
        this.about = ()=>{
            const about = new (0, $a67de6ec9600469c$export$c8424c4d8ba2150)(this);
            about.toggle();
        };
        this.doDynamicDialog = (message)=>{
            if (this.currentModal) {
                this.currentModal.updateContent(message);
                if (this.currentModal instanceof (0, $98fc6d407c9f2a1f$export$a2cb772ea0bad012) && this.currentModal.isInventoryOrCrafting()) this.tutorial.itemScreenOpened();
                this.updateItemsChip();
                return;
            }
            if (!message) return;
            // Always render via ModernInventoryDialog. It extends DynamicDialog and self-selects its
            // layout from the payload: the player's own inventory, crafting, and trade/chest screens get
            // the modern client-native panels, while any other server-driven dialog (quests, traders,
            // NPC management) falls through to the generic DynamicDialog renderer and looks exactly as
            // before. It's a drop-in for currentModal and every downstream call (updateContent/close/
            // pulseGridItem).
            let itemScreen = false;
            const onClose = ()=>{
                if (itemScreen) this.tutorial.itemScreenClosed();
                if (message.onCloseEmitEvent) this.logic.playerController.client.emitPlayerEvent(message.onCloseEmitEvent);
                this.logic.playerController.client.onDialogClose();
                this.currentModal = undefined;
                this.dynamicDialogToken = undefined;
                this.updateItemsChip();
            };
            const dialog = new (0, $98fc6d407c9f2a1f$export$a2cb772ea0bad012)(this, this.logic, message, onClose);
            itemScreen = dialog.isInventoryOrCrafting();
            if (itemScreen) this.tutorial.itemScreenOpened();
            dialog.toggle((clicked)=>{
                if (clicked) // this.dynamicDialogToken = null
                this.closeModal();
            });
            this.currentModal = dialog;
            this.updateItemsChip();
        };
        this.availableMessage = (message)=>{
            this.incomingMessageMeta.unread = true;
            this.incomingMessageMeta.expires = Date.now() + 60000;
            this.incomingMessageMeta.text = {
                ...message
            };
            this.helpMessaging();
        };
        this.haltMessageIndicator = ()=>{
            clearInterval(this.incomingMessageMeta.flasherInterval);
            this.incomingMessageMeta.unread = false;
            this.incomingMessageMeta.expires = null;
            this.incomingMessageMeta.text = null;
            this.helpMessaging();
        };
        this.showUpgradeIndicator = ()=>{};
        this.closeModal = ()=>{
            if (this.currentModal) this.currentModal.close();
            this.dynamicDialogToken = null;
            this.currentModal = null;
            this.updateItemsChip();
        };
        this.updateItemsChip = ()=>{
            const modal = this.currentModal;
            this.emberInventoryChip?.setActive(modal instanceof (0, $98fc6d407c9f2a1f$export$a2cb772ea0bad012) && modal.isInventoryOrCrafting());
            const hideBottomWidgets = (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)() && modal instanceof (0, $98fc6d407c9f2a1f$export$a2cb772ea0bad012) && (modal.isInventoryOrCrafting() || (0, $98fc6d407c9f2a1f$export$1a9ed648cfadc85e)(modal.message));
            if (this.equipped) this.equipped.visible = !hideBottomWidgets;
            if (this.emberRoster) this.emberRoster.visible = !hideBottomWidgets;
        };
        this.toggleInventory = ()=>{
            if (!this.currentModal) this.logic.invokeInventory(null);
            else this.closeModal();
        };
        // `c` toggles the crafting screen the way `i` toggles the inventory. Asking the server to open
        // crafting while a screen is already up would only re-dress the modal that's there, so a second
        // press has to close it locally instead.
        this.toggleCrafting = ()=>{
            if (!this.dynamicDialogToken) this.logic.invokeCrafting();
            else this.closeModal();
        };
        // `f`. A developer tool, so the choice is remembered per browser -- somebody profiling a hitch
        // reloads the client over and over and should not have to re-arm the readout each time. The
        // store can be absent or throw (private windows, blocked site data), which only means the
        // readout starts away.
        this.toggleFpsMeter = ()=>{
            const open = this.fpsMeter.toggle();
            try {
                if (typeof localStorage !== "undefined") localStorage.setItem($7dd73ecdd94bfe01$var$FPS_METER_KEY, open ? "true" : "false");
            } catch (error) {
                console.warn("Failed to save the fps readout's state to localStorage:", error);
            }
            return open;
        };
        this.toggleCharacterCustomizer = ()=>{
            this.characterCustomizer.toggle();
            this.updateGameplayControls();
        };
        this.buildCharacter = (entityId)=>{
            const player = this.getPlayer();
            if (player?.entityId !== entityId) // for now -- you can only build your own character
            return;
            if (!this.characterBuilder.isOpen()) {
                if (this.chipLayer) this.chipLayer.visible = false;
                this.characterBuilder.toggle(()=>{
                    this.logic.playerController.client.finalizeCharacter();
                    // Close the curtain on the CLICK, not on the teleport that answers it.
                    //
                    // A character drawn in LIMBO is whisked out of it into a fresh camp, and that
                    // teleport brings the usual room-transition blackout with it
                    // (ServerGameLogic.teleportEntity -> sendFadeInOut("out")). But it cannot arrive for
                    // half a second: the finalize has to cross the socket, the server has to dispatch
                    // BUILD_CHARACTER{finalized}, and EmberRoomService has to build a whole camp room.
                    // This modal is opaque and comes down in the frame of this very callback, so without
                    // this that half second is spent looking at limbo -- a tile-less room the visibility
                    // parser gives darkness 1.0, i.e. the new character alone in the void.
                    //
                    // Only from limbo, because only from limbo is a room change coming. Finalizing in
                    // the overworld (EMBER_ENABLED off, where the INTRO campaign opens this screen) goes
                    // nowhere, and a curtain nothing lifts would be a worse bug than the one above.
                    //
                    // "out" is an immediate black (fadeOut(true)), so the modal's disappearance reveals
                    // the curtain rather than the void, and the camp's own map build fades back in
                    // (ClientGameLogic.updateFromWorldState). The "inOut" form is the watchdog: if no
                    // camp ever arrives -- a failed build falls through to rescueFromLimbo, which can
                    // itself come up empty -- the screen lifts anyway instead of stranding the player
                    // behind a black rectangle.
                    if (this.currenRoomName === (0, $cb689cfa16c444ba$export$1bb94dd20d93df2d)) this.logic.fadeInOut("inOut", 10000);
                });
            }
        };
        this.getPlayer = ()=>this.logic.playerEntity;
        this.pulseInventoryItem = (itemId)=>{
            if (!this.currentModal) return;
            this.currentModal.pulseGridItem(itemId);
        };
        this.mapPointHoverListener = (onMouseOver, label)=>{
            // this.container.beginFill(0xFF0000)
            // this.container.drawCircle(705, 454, 20)
            // this.container.endFill()
            const position = this.logic.clientRenderer.mouse().state().position;
            if (onMouseOver) {
                const container = new (0, $aeae8505a2eb5f5c$export$f169141001428c70)({
                    backdrop: true
                });
                container.append2(new (0, $9fd6885af96d4f37$export$98d0db62fdbc7614)(label, {
                    font: "ChatFont"
                }));
                this.mouseHoverElement = container;
                this.container.addChild(this.mouseHoverElement);
                this.mouseHoverElement.x = 5 + this.minimapSurface.x + this.minimapSurface.width / 2 - this.mouseHoverElement.width / 2;
                this.mouseHoverElement.y = this.minimapSurface.y - this.mouseHoverElement.height + 2;
            } else if (this.mouseHoverElement) this.container.removeChild(this.mouseHoverElement);
        };
        this.createCursorSprite = ()=>{
            if (!this.mousePointer) {
                this.mousePointer = new (0, $9ab086d4e07affe3$export$c419b241c6d870af)(this.logic.clientRenderer?.mouse());
                this.stage.addChild(this.mousePointer);
            }
            return this.mousePointer;
        };
        this.targetingShot = ()=>this.mousePointer?.shot();
        // ---- location picker -------------------------------------------------------------------------
        // The reticle under the pointer while the player chooses a spot on the ground (the defender's
        // "Hold Position" order). GuiManager owns only the drawing and the screen->world conversion;
        // arming the pick, ending it, and what the chosen spot MEANS belong to PlayerController, which
        // owns world presses.
        this.showLocationPicker = (caption, blockedCaption)=>{
            this.locationPicker.bindMouse(this.logic.clientRenderer?.mouse());
            this.locationPicker.show(caption, blockedCaption);
        };
        this.hideLocationPicker = ()=>{
            this.locationPicker.hide();
        };
        this.setBuildingPrintGroups = (groups)=>this.buildingPrintCountdown?.setGroups(groups);
        this.isBuildingPrintControlHovered = ()=>this.buildingPrintCountdown?.isPointerOver() || false;
        this.setBuildingShapePalette = (state)=>{
            if (!this.buildingShapePalette && state.visible) {
                this.buildingShapePalette = new (0, $c557fc6e01c5a536$export$9e2c2e69a6bd8f7)((shape)=>{
                    this.logic.playerController.suppressAttack();
                    this.logic.playerController.selectBuildingShape(shape);
                });
                this.stage.addChild(this.buildingShapePalette);
            }
            const palette = this.buildingShapePalette;
            if (!palette) return;
            if (state.visible && !palette.visible) {
                // The selected tool opens under the pointer. Freeze the board during selection.
                const pointer = this.stage.toLocal(new (0, $6qzqq.Point)(state.position.x, state.position.y));
                const anchor = (0, $c557fc6e01c5a536$export$f542b2644ae8f7c4)(state.shape);
                const edge = this.stage.toLocal(new (0, $6qzqq.Point)(window.innerWidth, window.innerHeight));
                // The board carries a dropped shadow below it, so keep a little more than its own box
                // clear of the viewport edge.
                palette.position.set(Math.max(8, Math.min(pointer.x - anchor.x, edge.x - (0, $c557fc6e01c5a536$export$c212ee05c579f421) - 8)), Math.max(8, Math.min(pointer.y - anchor.y, edge.y - (0, $c557fc6e01c5a536$export$f84fc1b798c3f62d) - 8)));
            }
            palette.setState(state.visible, state.shape, state.locked, state.hollow);
        };
        this.isLocationPickerVisible = ()=>this.locationPicker.isVisible();
        this.setLocationPickerBlocked = (blocked)=>{
            this.locationPicker.setBlocked(blocked);
        };
        // The fine world coordinate under the pointer, read straight off pixi's own transforms: the
        // world-overlay converts its local point through the ground surface's own transform,
        // including the separate scale and pivot used when a house is projected.
        //
        // Read the transform directly; a cached combat target may have been cleared by keyboard facing.
        this.worldPointAtPointer = ()=>{
            const overlay = this.logic.clientRenderer?.map()?.overlay();
            const mouse = this.logic.clientRenderer?.mouse();
            if (!overlay || !mouse) return null;
            const local = overlay.toLocal(mouse.state().position);
            return overlay.worldLocation(local.x, local.y);
        };
        this.pulseDamage = ()=>{
            this.redout.alpha = 0.3;
            this.redout.visible = true;
            new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.redout, {
                fadeInterval: 25,
                releaseCallback: ()=>{
                    this.redout.visible = false;
                }
            }).update();
        };
        this.showWorldMap = (map)=>{
            const worldMap = new (0, $a231d713277e9a39$export$9a82c68eff2bb78f)(this, map, (coordinate)=>{
                if (this.logic.runLevel === "dev") {
                    this.logic.playerController.client.worldMapClicked(coordinate);
                    worldMap.close();
                }
            });
            worldMap.toggle();
        };
        this.isControlKeyPressed = ()=>{
            return this.logic.clientRenderer.keyboard().state().get("Control") || this.logic.clientRenderer.keyboard().state().get("ControlLeft") || this.logic.clientRenderer.keyboard().state().get("ControlRight");
        };
        // True when one of the player's item screens (inventory, crafting, or trading) is the open
        // modal. Under the modern renderer all three are a single ModernInventoryDialog; under the
        // classic renderer crafting/trading are still recognizable from the opening message.
        // Public so the world-click handler can suppress attacks while a screen is up.
        this.isItemScreenOpen = ()=>{
            if (this.chapterAnnouncement?.isOpen()) return true;
            const modal = this.currentModal;
            if (!modal) return false;
            if (modal instanceof (0, $98fc6d407c9f2a1f$export$a2cb772ea0bad012)) return true;
            return (0, $98fc6d407c9f2a1f$export$bc3be2b9790d3f4d)(modal.message) || (0, $98fc6d407c9f2a1f$export$1a9ed648cfadc85e)(modal.message);
        };
        // Called both by the global Control-key path (no args → broadcast wheel) and by the server's
        // OPEN_COMMAND_WHEEL reply (opts → wheel bound to one NPC, locked to its role).
        this.showCommandWheel = (opts)=>{
            // The command wheel is only available in rooms that opt in (ember rooms), signalled by the
            // per-room enableCommandWheel flag that rides to the client in WorldState.visibility.
            if (!this.logic.clientRenderer.map().getVisibility()?.enableCommandWheel) return;
            // Don't let the player summon the wheel on top of an inventory/crafting/trading screen.
            // The server-driven per-NPC wheel (opts present) is intentional and stays allowed.
            if (!opts && this.isItemScreenOpen()) return;
            // A wheel going up replaces whatever the pointer was being used for: an armed location pick
            // has no press left to answer it, and its reticle would sit under the wheel unexplained.
            this.logic.playerController?.cancelLocationPick();
            this.clearCommandWheelTether();
            // Whatever this wheel is about, it is no longer the roster card's.
            this.releaseRosterWheel();
            if (opts) {
                this.tileWheelTarget = undefined;
                this.commandWheel.bindToEntity(opts.targetEntityId, opts.role, opts.commands);
                // A per-entity wheel opens directly over its NPC instead of screen-center, and stays
                // there: updateCommandWheelTether draws the line to the NPC as it walks off.
                this.positionCommandWheelOverEntity(opts.targetEntityId);
            } else {
                this.tileWheelTarget = undefined;
                this.commandWheel.clearTarget();
                this.commandWheel.clearSelection() // Clear any previous selection
                ;
                // The global (Control-key) wheel returns to its screen-center home in case a prior
                // per-entity wheel moved it.
                this.commandWheel.position.copyFrom(this.commandWheelHome);
            }
            this.commandWheel.fadeIn();
            // Prevent context menu when command wheel is visible
            this.preventContextMenu();
            if (opts) this.learnedEntityMenu(opts.targetEntityId);
        };
        this.openRosterCommandWheel = (entityId, role)=>{
            if (!this.logic.clientRenderer.map().getVisibility()?.enableCommandWheel) return;
            if (this.isItemScreenOpen()) return;
            this.logic.playerController?.cancelLocationPick();
            this.clearCommandWheelTether();
            this.commandWheelRosterId = entityId;
            this.tileWheelTarget = undefined;
            this.commandWheel.bindToEntity(entityId, role);
            this.positionRosterCommandWheel();
            this.commandWheel.fadeIn();
            // The wheel has taken the slot the minimap was holding.
            this.positionEmberMinimap();
            this.preventContextMenu();
            this.learnedEntityMenu(entityId);
        };
        // Park a roster-opened wheel in the slot above the strip, clamped so no part of the disc -- glow
        // included -- can leave the screen, however few cards the strip is down to.
        this.positionRosterCommandWheel = ()=>{
            // positionEmberRoster runs during init before the wheel exists -- guard against that.
            if (!this.commandWheelRosterId || !this.commandWheel) return;
            // The wheel is wider than it is tall (its name plaques reach out to either side), and how much
            // depends on the names on show -- so the slot is sized from its extent, not its radius.
            const extent = this.commandWheel.getExtent();
            const width = extent.left + extent.right;
            const height = extent.top + extent.bottom;
            const slot = this.rosterSlotAnchor(width, height);
            const at = this.clampToScreen(slot, width, height);
            // rosterSlotAnchor and clampToScreen work in the HUD container's frame; the wheel is a direct
            // child of the stage, and is centre-anchored rather than top-left.
            this.commandWheel.position.set(this.container.x + at.x + extent.left, this.container.y + at.y + extent.top);
            this.updateRosterWheelConnector();
        };
        // The line from a roster-opened wheel down to the card that opened it, in the wheel's accent (the
        // member's role colour). Drawn UNDER the strip -- see where rosterWheelConnector is built -- so an
        // offscreen-speech bubble, and every other piece of HUD, reads over the top of it.
        this.updateRosterWheelConnector = ()=>{
            const g = this.rosterWheelConnector;
            g.clear();
            const anchor = this.commandWheelRosterId ? this.emberRoster.cardAnchor(this.commandWheelRosterId, "panel") : null;
            if (!anchor || !this.commandWheel.isOpen()) {
                g.visible = false;
                return;
            }
            // Both ends in the HUD container's frame (the wheel lives on the stage, one level up). The
            // card end stops a dot's width clear of the panel: the line runs UNDER the strip, so a dot
            // sitting on the panel's edge would be half buried by it.
            const toX = anchor.x;
            const toY = anchor.y - $7dd73ecdd94bfe01$var$WHEEL_TETHER_DOT_RADIUS;
            const fromCenterX = this.commandWheel.x - this.container.x;
            const fromCenterY = this.commandWheel.y - this.container.y;
            const dx = toX - fromCenterX;
            const dy = toY - fromCenterY;
            const distance = Math.hypot(dx, dy);
            const rim = this.commandWheel.getRadius() + $7dd73ecdd94bfe01$var$WHEEL_TETHER_RIM_GAP;
            if (distance < rim + $7dd73ecdd94bfe01$var$WHEEL_TETHER_MIN_LENGTH) {
                g.visible = false;
                return;
            }
            g.visible = true;
            g.alpha = this.commandWheel.alpha * $7dd73ecdd94bfe01$var$WHEEL_TETHER_ALPHA;
            g.lineStyle({
                width: $7dd73ecdd94bfe01$var$WHEEL_TETHER_WIDTH,
                color: anchor.color,
                alpha: 1,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            g.moveTo(fromCenterX + dx / distance * rim, fromCenterY + dy / distance * rim);
            g.lineTo(toX, toY);
            g.beginFill(anchor.color, 1);
            g.drawCircle(toX, toY, $7dd73ecdd94bfe01$var$WHEEL_TETHER_DOT_RADIUS);
            g.endFill();
        };
        this.clearRosterWheelConnector = ()=>{
            this.rosterWheelConnector.clear();
            this.rosterWheelConnector.visible = false;
        };
        // Outline the roster's selected member out in the world (undefined takes it off). Routed through
        // the HUD rather than called from the roster widget directly, which knows only about this class.
        this.highlightEmberMember = (entityId)=>{
            this.logic.clientRenderer.entity().setRosterHighlight(entityId);
        };
        // Put away whatever the roster's active card opened -- the follow-cam PiP or that member's
        // command wheel -- and clear the card's highlight. Called by the roster before it acts on a tap,
        // so only one card is ever live and tapping the active card is a toggle.
        this.closeRosterSelection = ()=>{
            this.dismissFollowCam();
            if (this.commandWheelRosterId) this.hideCommandWheel();
            if (this.rolePickerRosterId) this.hideRolePicker();
        };
        // Open a VISITOR'S OWN VERBS from their roster card: the same wheel a tap on the person would
        // give you ("Give Food", and "Talk" once they are fed), parked in the HUD slot above the strip
        // with a connector down to the card -- because the entire reason the player is reading a card
        // is that they cannot see who it belongs to.
        //
        // It borrows the roster command wheel's plumbing wholesale (`commandWheelRosterId` is what pins
        // it to the slot, draws the connector, and keeps it alive while its NPC is off screen); what
        // `rosterInteractionId` adds is that a selection goes out on the INTERACTION channel instead of
        // the squad one, and that the slices know how far away the player is standing.
        this.openRosterPlayerWheel = (entityId, name)=>{
            if (this.isItemScreenOpen()) return;
            this.logic.playerController?.cancelLocationPick();
            this.clearCommandWheelTether();
            this.commandWheelRosterId = entityId;
            this.rosterInteractionName = name;
            this.tileWheelTarget = undefined;
            this.commandWheel.bindToInteractions(entityId, [
                {
                    name: $7dd73ecdd94bfe01$var$WATCH_SLICE,
                    displayName: "Watch"
                },
                {
                    name: "ember:kick",
                    displayName: "Kick"
                },
                {
                    name: "ember:play_mode",
                    displayName: "Play Mode"
                }
            ], "\uD83D\uDC64");
            this.positionRosterCommandWheel();
            this.commandWheel.fadeIn();
            this.positionEmberMinimap();
            this.preventContextMenu();
        };
        this.openRosterInteractionWheel = (entityId, name)=>{
            if (this.isItemScreenOpen()) return;
            this.logic.playerController?.cancelLocationPick();
            this.clearCommandWheelTether();
            this.commandWheelRosterId = entityId;
            this.rosterInteractionId = entityId;
            this.rosterInteractionName = name;
            this.bindRosterInteractions(entityId);
            this.positionRosterCommandWheel();
            this.commandWheel.fadeIn();
            // The wheel has taken the slot the minimap was holding.
            this.positionEmberMinimap();
            this.preventContextMenu();
        };
        // Is the player close enough to hand something over? See INTERACTION_REACH: this is the "can
        // you see them" rule a world tap always enforced by accident, written down so a card can
        // enforce it too.
        this.withinInteractionReach = (entityId)=>{
            const me = this.logic.playerEntity;
            const them = this.logic.getEntity(entityId);
            if (!me?.location || !them?.location || me.roomId !== them.roomId) return false;
            const dx = me.location.x - them.location.x;
            const dy = me.location.y - them.location.y;
            const reach = (0, $0fb3f7f2a67be6e3$export$d915060d878a7a90) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            return dx * dx + dy * dy <= reach * reach;
        };
        // Write the slices for a roster-opened interaction wheel. A verb that needs the player to be
        // there says so in its own label rather than being hidden: a card that silently dropped "Give
        // Food" would teach the player that a visitor wants nothing, which is the opposite of the
        // lesson. WATCH is appended by the HUD, not the entity -- it is how one tap still reaches the
        // follow cam now that the card's tap belongs to the verbs.
        this.bindRosterInteractions = (entityId)=>{
            // A HELD verb is not among them: a slice cannot be held down, so picking one would do
            // nothing (see wheelInteractions). A card whose entity offers only held verbs still opens,
            // carrying the HUD's own "Watch" -- which is then honestly all a card can do for them.
            const descriptors = (0, $0fb3f7f2a67be6e3$export$65634e3ec6b442de)(this.logic.clientRenderer.entity().getEntityInteractions(entityId) || []);
            const inReach = this.withinInteractionReach(entityId);
            this.rosterInteractionInReach = inReach;
            const commands = descriptors.map((descriptor)=>({
                    name: descriptor.type,
                    displayName: (0, $0fb3f7f2a67be6e3$export$3799b383fc0956ea)(descriptor.type) && !inReach ? `${(0, $0fb3f7f2a67be6e3$export$84e151b22524d21c)(descriptor)} (too far)` : (0, $0fb3f7f2a67be6e3$export$84e151b22524d21c)(descriptor)
                }));
            commands.push({
                name: $7dd73ecdd94bfe01$var$WATCH_SLICE,
                displayName: "Watch"
            });
            this.tileWheelTarget = undefined;
            this.commandWheel.bindToInteractions(entityId, commands);
        };
        // Called every frame while a roster interaction wheel is up: the player can walk into (or out
        // of) reach with it open, and a label that went stale would be a lie about the only thing the
        // wheel is being asked.
        this.refreshRosterInteractionReach = ()=>{
            if (!this.rosterInteractionId) return;
            if (this.withinInteractionReach(this.rosterInteractionId) === this.rosterInteractionInReach) return;
            this.bindRosterInteractions(this.rosterInteractionId);
            // The relabelled plaques ("Give Food (too far)" -> "Give Food") change the wheel's footprint.
            this.positionRosterCommandWheel();
            this.positionEmberMinimap();
        };
        // Map tiles use the shared wheel and advertise their verbs through delta metadata.
        this.showTileInteractionWheel = (target)=>{
            if (!target.interactions.length || this.isItemScreenOpen()) return;
            this.logic.playerController.cancelLocationPick();
            this.releaseRosterWheel();
            this.clearCommandWheelTether();
            this.tileWheelTarget = {
                coordinate: {
                    ...target.coordinate
                },
                layerId: target.layerId,
                roomId: target.roomId ?? this.logic.playerEntity.roomId,
                yOffset: target.yOffset
            };
            const interactions = this.liveTileWheelInteractions() ?? target.interactions;
            this.tileWheelInteractionsKey = JSON.stringify(interactions);
            this.commandWheel.bindToInteractions("", interactions);
            this.positionTileInteractionWheel();
            this.commandWheel.fadeIn();
            this.preventContextMenu();
        };
        this.liveTileWheelInteractions = ()=>{
            const target = this.tileWheelTarget;
            if (!target) return;
            const provider = target.roomId === this.logic.playerEntity?.roomId ? this.logic.tilemapMetaProvider : this.logic.clientRenderer.map().drawnFloorProvider?.(target.roomId);
            return (0, $5a580aacfacf7705$export$a7fa163723092bfa)(provider?.getMapDeltaAt(target.coordinate.x, target.coordinate.y, target.layerId));
        };
        // Tile wheels belong to a world position. Reproject their center each frame as the camera
        // moves; screen clamping would detach the wheel from the tile that supplies its command.
        this.positionTileInteractionWheel = ()=>{
            if (!this.tileWheelTarget) return;
            const overlay = this.logic.clientRenderer.map().overlay();
            const { coordinate: coordinate, yOffset: yOffset = 0 } = this.tileWheelTarget;
            const center = overlay.computeLocation((coordinate.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (coordinate.y + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + yOffset);
            this.commandWheel.position.copyFrom(this.stage.toLocal(center, overlay));
        };
        // Open the wheel over an entity to choose between the interactions it offers. Unlike
        // showCommandWheel this is NOT gated on the ember-room enableCommandWheel flag: chests, campfires
        // and denizens exist everywhere, and their interactions are how a player opens them now that the
        // hover icons are gone. Positioning, dismissal (Escape, Control, selection) and the fade are
        // shared with the command wheel.
        this.showInteractionWheel = (entityId, interactions)=>{
            if (!interactions?.length) return;
            // Don't put a wheel up underneath an inventory/crafting/trading screen.
            if (this.isItemScreenOpen()) return;
            this.logic.playerController?.cancelLocationPick();
            this.releaseRosterWheel();
            this.tileWheelTarget = undefined;
            this.commandWheel.bindToInteractions(entityId, interactions.map((next)=>({
                    name: next.type,
                    displayName: (0, $0fb3f7f2a67be6e3$export$84e151b22524d21c)(next)
                })));
            this.clearCommandWheelTether();
            if (!this.positionCommandWheelOverEntity(entityId)) this.commandWheel.position.copyFrom(this.commandWheelHome);
            this.commandWheel.fadeIn();
            this.preventContextMenu();
            this.learnedEntityMenu(entityId);
        };
        // The given entity's center in stage-local coordinates (the frame the command wheel / role
        // picker live in, as direct children of the stage). Null when the entity isn't available yet.
        this.entityStageLocal = (entityId)=>{
            const entity = this.logic.getEntity(entityId);
            if (!entity) return null;
            const overlay = this.logic.clientRenderer.map().overlay();
            // computeLocation gives the entity's center in the overlay surface's local frame; convert
            // that into stage-local coordinates.
            const center = overlay.computeLocation(entity.location.x, entity.location.y);
            return this.stage.toLocal(center, overlay);
        };
        // Move the wheel so its center sits over the given entity -- or as near it as keeps the whole
        // wheel on screen. Returns false when the entity (or its overlay frame) isn't available yet.
        // Called once, at open: the wheel then stays put (a wheel that chased a walking NPC was
        // impossible to aim at), and the tether line carries the link.
        this.positionCommandWheelOverEntity = (entityId)=>{
            const local = this.entityStageLocal(entityId);
            if (!local) return false;
            this.commandWheel.position.set(local.x, local.y);
            this.clampCommandWheelToScreen();
            return true;
        };
        // Keep the whole wheel -- name plaques and title included -- on screen. It opens centred on what it
        // is about, but a member standing near the edge would otherwise hang half its orders off it. The
        // tether still runs to the member wherever the wheel ends up.
        this.clampCommandWheelToScreen = ()=>{
            const extent = this.commandWheel.getExtent();
            const at = this.clampToScreen({
                x: this.commandWheel.x - this.container.x - extent.left,
                y: this.commandWheel.y - this.container.y - extent.top
            }, extent.left + extent.right, extent.top + extent.bottom);
            this.commandWheel.position.set(this.container.x + at.x + extent.left, this.container.y + at.y + extent.top);
        };
        // Per-frame upkeep for a per-entity wheel: drop it once its target is gone or has left the
        // viewport (there is nothing left on screen to command), and otherwise redraw the tether from
        // the pinned wheel to the NPC. No-op for the global broadcast wheel (no bound target) and while
        // the wheel is closed. Called every frame by the renderer.
        this.updateCommandWheelTether = ()=>{
            if (this.commandWheel.isOpen() && this.tileWheelTarget) {
                const interactions = this.liveTileWheelInteractions();
                if (interactions && JSON.stringify(interactions) !== this.tileWheelInteractionsKey) {
                    this.tileWheelInteractionsKey = JSON.stringify(interactions);
                    this.commandWheel.bindToInteractions("", interactions);
                }
                this.positionTileInteractionWheel();
            }
            const entityId = this.commandWheel.isOpen() ? this.commandWheel.getTargetEntityId() : undefined;
            if (!entityId) {
                this.clearCommandWheelTether();
                this.clearRosterWheelConnector();
                return;
            }
            // A ROSTER-opened wheel is pinned to the HUD, not to the world: it is tied to a card rather
            // than to the NPC, and it must survive its member being off screen -- reaching somebody you
            // cannot see is what the roster is for. Other floors may have no local entity (or a stale
            // destroyed marker after a room transfer), so the camp roster determines whether it is gone.
            if (this.commandWheelRosterId) {
                if (!this.recruitHintRoster.some((entry)=>entry.entityId === entityId)) {
                    this.hideCommandWheel();
                    return;
                }
                this.refreshRosterInteractionReach();
                this.clearCommandWheelTether();
                this.updateRosterWheelConnector();
                return;
            }
            const entity = this.logic.getEntity(entityId);
            const gone = !entity || this.logic.isDestroyed(entityId);
            if (gone || !this.logic.isWithinPlayerViewport(entity.location)) {
                this.hideCommandWheel();
                return;
            }
            this.drawCommandWheelTether(entityId);
        };
        // A translucent line from the pinned wheel's rim to the commanded NPC's center, with a dot on
        // the NPC end. Drawn in the wheel's accent and multiplied by the wheel's own alpha so it fades
        // in and out with it. Suppressed while the NPC is still under the disc, where a stub of line
        // would only show as a nub poking out of the hub.
        this.drawCommandWheelTether = (entityId)=>{
            const g = this.commandWheelTether;
            g.clear();
            const local = this.entityStageLocal(entityId);
            if (!local) {
                g.visible = false;
                return;
            }
            const dx = local.x - this.commandWheel.x;
            const dy = local.y - this.commandWheel.y;
            const distance = Math.hypot(dx, dy);
            const rim = this.commandWheel.getRadius() + $7dd73ecdd94bfe01$var$WHEEL_TETHER_RIM_GAP;
            if (distance < rim + $7dd73ecdd94bfe01$var$WHEEL_TETHER_MIN_LENGTH) {
                g.visible = false;
                return;
            }
            const accent = this.commandWheel.getAccent();
            g.visible = true;
            g.alpha = this.commandWheel.alpha * $7dd73ecdd94bfe01$var$WHEEL_TETHER_ALPHA;
            g.lineStyle({
                width: $7dd73ecdd94bfe01$var$WHEEL_TETHER_WIDTH,
                color: accent,
                alpha: 1,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            g.moveTo(this.commandWheel.x + dx / distance * rim, this.commandWheel.y + dy / distance * rim);
            g.lineTo(local.x, local.y);
            g.beginFill(accent, 1);
            g.drawCircle(local.x, local.y, $7dd73ecdd94bfe01$var$WHEEL_TETHER_DOT_RADIUS);
            g.endFill();
        };
        this.clearCommandWheelTether = ()=>{
            this.commandWheelTether.clear();
            this.commandWheelTether.visible = false;
        };
        // Let go of a roster-opened wheel: drop its connector, un-highlight the card that opened it, and
        // hand the slot above the strip back to the minimap. Called wherever the wheel stops being that
        // card's -- it closing, or another kind of wheel taking it over.
        this.releaseRosterWheel = ()=>{
            if (!this.commandWheelRosterId) return;
            this.commandWheelRosterId = undefined;
            this.rosterInteractionId = undefined;
            this.rosterInteractionName = undefined;
            this.clearRosterWheelConnector();
            this.emberRoster.clearSelection();
            this.positionEmberMinimap();
        };
        this.hideCommandWheel = ()=>{
            const tileWheel = !!this.tileWheelTarget;
            this.tileWheelTarget = undefined;
            this.releaseRosterWheel();
            this.commandWheel.fadeOut();
            this.commandWheel.clearTarget();
            this.commandWheel.clearSelection() // Clear any previous selection
            ;
            this.clearCommandWheelTether();
            // Restore normal context menu behavior
            this.restoreContextMenu();
            // A right-click on a tile may have left build mode to open this wheel; the player picks it back up.
            if (tileWheel) this.logic.playerController?.tileWheelClosed();
        };
        this.isCommandWheelVisible = ()=>{
            return this.commandWheel.isOpen();
        };
        // Server-driven: open the recruit role picker over a specific camp member so the player can assign
        // it a role. Gated to ember rooms via the same per-room visibility flag as the command wheel.
        //
        // `currentRole` arrives only with a "Change Role" order on an already-hired member, and narrows the
        // picker to the job that member is NOT doing. `weapon` is the weapon type it would fight with,
        // which the Defender card names; `playMode` turns the same widget into the guest play-mode picker.
        this.showRolePicker = (entityId, currentRole, options = {})=>{
            const { playMode: playMode, weapon: weapon, availableRoles: availableRoles } = options;
            if (!this.logic.clientRenderer.map().getVisibility()?.enableCommandWheel) return;
            // A picker asked for from a roster card is not about a spot on screen; it inherits the HUD slot
            // (and the lit card, and the connector) from the wheel that asked for it. Anything else -- a
            // hire at the fire, a per-entity wheel -- opens over the member, where the player is looking.
            if (this.rolePickerRosterId && this.rolePickerRosterId !== entityId) this.rolePickerRosterId = undefined;
            const fromRoster = this.rolePickerRosterId === entityId;
            if (playMode) this.rolePicker.bindPlayMode(entityId, playMode);
            else this.rolePicker.bindToEntity(entityId, currentRole, weapon, availableRoles);
            if (fromRoster) {
                this.rolePicker.setTailVisible(false);
                this.positionRolePickerInRosterSlot();
                this.emberRoster.holdSelection(entityId);
                // The picker has taken the slot the minimap was holding.
                this.positionEmberMinimap();
            } else this.positionRolePickerOverEntity(entityId);
            this.rolePicker.fadeIn();
            this.preventContextMenu();
        };
        // Park a roster-raised picker in the slot above the strip, clamped so none of it can leave the
        // screen -- the same slot, and the same clamp, the wheel that raised it was using.
        this.positionRolePickerInRosterSlot = ()=>{
            if (!this.rolePickerRosterId || !this.rolePicker) return;
            const width = this.rolePicker.getPanelWidth();
            const height = this.rolePicker.getPanelHeight();
            const at = this.clampToScreen(this.rosterSlotAnchor(width, height), width, height);
            // rosterSlotAnchor and clampToScreen work in the HUD container's frame; the picker is a direct
            // child of the stage.
            this.rolePicker.placeBodyTopLeftAt(this.container.x + at.x, this.container.y + at.y);
            this.updateRolePickerConnector();
        };
        // The line from a roster-raised picker down to the card that raised it, in that member's role
        // colour -- the same connector the roster command wheel draws, and drawn with the same Graphics,
        // because the wheel is always closed by the time the picker is up.
        this.updateRolePickerConnector = ()=>{
            const g = this.rolePickerConnector;
            g.clear();
            const anchor = this.rolePickerRosterId ? this.emberRoster.cardAnchor(this.rolePickerRosterId, "panel") : null;
            if (!anchor || !this.rolePicker.isOpen()) {
                g.visible = false;
                return;
            }
            // Both ends in the HUD container's frame. The picker's own origin is its tail TIP, which sits
            // below the body -- the line starts from the body's bottom edge, where the tail would have been.
            const toX = anchor.x;
            const toY = anchor.y - $7dd73ecdd94bfe01$var$WHEEL_TETHER_DOT_RADIUS;
            const fromX = this.rolePicker.x - this.container.x;
            const fromY = this.rolePicker.y - this.container.y - this.rolePicker.getTailDrop();
            if (toY - fromY < $7dd73ecdd94bfe01$var$WHEEL_TETHER_MIN_LENGTH) {
                g.visible = false;
                return;
            }
            g.visible = true;
            g.alpha = this.rolePicker.alpha * $7dd73ecdd94bfe01$var$WHEEL_TETHER_ALPHA;
            g.lineStyle({
                width: $7dd73ecdd94bfe01$var$WHEEL_TETHER_WIDTH,
                color: anchor.color,
                alpha: 1,
                cap: (0, $gwPoJ.LINE_CAP).ROUND
            });
            g.moveTo(fromX, fromY + $7dd73ecdd94bfe01$var$WHEEL_TETHER_RIM_GAP);
            g.lineTo(toX, toY);
            g.beginFill(anchor.color, 1);
            g.drawCircle(toX, toY, $7dd73ecdd94bfe01$var$WHEEL_TETHER_DOT_RADIUS);
            g.endFill();
        };
        // Position the picker so its tail tip sits at the recruit's center (the panel floats above).
        // The picker is glued to its recruit, so the tail is true for exactly as long as there is
        // somebody to glue it to: once the recruit is gone from this client the panel is left standing
        // where it was, and the pointer comes off rather than aim at empty ground.
        this.positionRolePickerOverEntity = (entityId)=>{
            const local = this.logic.isDestroyed(entityId) ? null : this.entityStageLocal(entityId);
            if (!local) {
                this.rolePicker.setTailVisible(false);
                return false;
            }
            this.rolePicker.position.set(local.x, local.y);
            this.rolePicker.setTailVisible(true);
            return true;
        };
        // Keep the picker glued over its member as the entity (or camera) moves. No-op while closed.
        // Called every frame by the renderer.
        this.updateRolePickerPosition = ()=>{
            if (!this.rolePicker.isOpen()) return;
            const entityId = this.rolePicker.getTargetEntityId();
            if (!entityId) return;
            // A roster-raised picker is pinned to the HUD, not to the world: it is tied to a CARD, and must
            // survive its member being off screen -- reaching somebody you cannot see is what the roster is
            // for. Only the member actually going takes it down.
            if (this.rolePickerRosterId === entityId) {
                if (this.logic.isDestroyed(entityId) || !this.logic.getEntity(entityId)) {
                    this.hideRolePicker();
                    return;
                }
                this.positionRolePickerInRosterSlot();
                return;
            }
            this.positionRolePickerOverEntity(entityId);
        };
        this.hideRolePicker = ()=>{
            const stairMessage = this.stairPickerMessage;
            this.stairPickerMessage = undefined;
            if (stairMessage?.onCloseEmitEvent) this.logic.playerController.client.emitPlayerEvent(stairMessage.onCloseEmitEvent);
            this.emberInviteModal?.close();
            const wasRoster = this.rolePickerRosterId;
            this.rolePickerRosterId = undefined;
            this.rolePicker.fadeOut();
            this.rolePicker.clearTarget();
            if (wasRoster) {
                // Hand the card, the connector and the slot back the way a roster wheel does when it closes.
                this.rolePickerConnector.clear();
                this.rolePickerConnector.visible = false;
                this.emberRoster.clearSelection();
                this.positionEmberMinimap();
            }
            this.restoreContextMenu();
        };
        // Server-driven: put the name field up over one camp member, started on `name`. Gated to ember
        // rooms by the same per-room visibility flag as the command wheel and the role picker.
        this.showNamePrompt = (entityId, name)=>{
            if (!this.logic.clientRenderer.map().getVisibility()?.enableCommandWheel) return;
            this.namePrompt.bindToEntity(entityId, name);
            if (!this.positionNamePromptOverEntity(entityId)) {
                // The entity isn't on this client yet (a hire names the recruit in the same breath as
                // swapping its script). Nothing to pin to, so there is nothing sensible to show.
                this.namePrompt.clearTarget();
                return;
            }
            this.namePrompt.fadeIn();
            // The field now owns the keyboard: see Keyboard.suppressTyping. Released in hideNamePrompt,
            // and Escape still gets through, which is what guarantees there is always a way out.
            (0, $ea3f90e500565ae9$export$16e4d70cc375e707).suppressTyping(true);
            this.preventContextMenu();
        };
        // Position the prompt so its tail tip sits at the member's center (the panel floats above).
        // Called once, at open: unlike the role picker the prompt does NOT follow its entity, because a
        // field that slides out from under the cursor while being typed into is far worse than one
        // left standing where the player opened it. The tail is what pays for that -- see
        // updateNamePrompt.
        this.positionNamePromptOverEntity = (entityId)=>{
            const local = this.entityStageLocal(entityId);
            if (!local) return false;
            this.namePrompt.position.set(local.x, local.y);
            this.namePrompt.setTailVisible(true);
            return true;
        };
        // Per-frame upkeep: drop the prompt once the entity being named is gone -- there is nobody left
        // to name. Deliberately NOT closed when that entity merely walks off screen: a member can wander
        // out of view while their name is half typed, and losing the field then would lose the name.
        //
        // What does go is the tail. The panel is pinned where it opened, so the member (or the camera)
        // only has to move for the pointer to be aiming at bare ground, which reads as the prompt being
        // about whatever is standing there now. Checked every frame, and it comes back if they walk
        // back under it.
        this.updateNamePrompt = ()=>{
            if (!this.namePrompt.isOpen()) return;
            const entityId = this.namePrompt.getTargetEntityId();
            if (!entityId) return;
            if (!this.logic.getEntity(entityId) || this.logic.isDestroyed(entityId)) {
                this.hideNamePrompt();
                return;
            }
            const local = this.entityStageLocal(entityId);
            const onTip = !!local && Math.hypot(local.x - this.namePrompt.x, local.y - this.namePrompt.y) <= $7dd73ecdd94bfe01$var$PANEL_TAIL_SLACK;
            this.namePrompt.setTailVisible(onTip);
        };
        this.hideNamePrompt = ()=>{
            const targetEntityId = this.namePrompt.getTargetEntityId();
            const wasOpen = this.namePrompt.isOpen();
            this.namePrompt.fadeOut();
            this.namePrompt.clearTarget();
            (0, $ea3f90e500565ae9$export$16e4d70cc375e707).suppressTyping(false);
            this.restoreContextMenu();
            if (wasOpen && targetEntityId) this.logic.playerController.client.emitPlayerEvent({
                playerEventType: "NAME_PROMPT_DISMISSED",
                context: {
                    targetEntityId: targetEntityId
                }
            });
        };
        this.isNamePromptVisible = ()=>{
            return this.namePrompt.isOpen();
        };
        // The run is over: rebuild the scorecard around this payload and fade it in over the camp.
        this.showRunSummary = (summary)=>{
            if (!summary) return;
            // Nothing else should be competing for the screen once the run has ended.
            this.hideCommandWheel();
            this.hideRolePicker();
            this.hideNamePrompt();
            this.hideInvasionPicker();
            this.dismissFollowCam();
            // Prefer the synced entity (it carries the current appearance/inventory the paperdoll needs)
            // and fall back to the local player stub.
            const player = this.logic.getEntity(this.logic.playerEntity?.entityId) || this.logic.playerEntity;
            this.runSummary.setSummary(summary, player);
            this.runSummary.fadeIn();
        };
        this.hideRunSummary = ()=>{
            this.runSummary.fadeOut();
            // The picker is opened FROM the scorecard and is meaningless without it: the panel going
            // away means the player took one of its other ways on, and a chooser left floating over a
            // room they have already left would still send a `join`.
            this.hideInvasionPicker();
        };
        this.isRunSummaryVisible = ()=>{
            return this.runSummary?.isOpen() === true;
        };
        // Server-driven: the newest invasion offer (Protocol.type_updateInvasionOffer). An interval
        // feed, ~2s, NOT a reply to a press -- which is the point: the scorecard's third button lights
        // up by itself when a camp becomes available, and an open picker gains and loses cards while
        // it is being read.
        //
        // `null` forgets the offer and takes the picker down. An EMPTY list does neither: it is a real
        // answer ("no camp is open to the dead") and the normal steady state on a quiet server, so the
        // button stays, inert and saying so, and an open picker shows its empty state rather than
        // vanishing under the player.
        this.updateInvasionOffer = (candidates)=>{
            if (!candidates) {
                this.invasionCandidates = undefined;
                this.runSummary?.setInvasionOffer(undefined);
                this.hideInvasionPicker();
                return;
            }
            this.invasionCandidates = candidates;
            this.runSummary?.setInvasionOffer(candidates);
            if (this.invasionPicker?.isOpen()) this.invasionPicker.setCandidates(candidates);
        };
        // Open the chooser on what the client already holds. No round trip: see the scorecard's
        // onInvade. Refuses to open on nothing, because the inert button should not have been pressable
        // in the first place (runSummaryButtons) and a picker opening onto its own empty state would
        // read as a broken press rather than as an honest answer.
        this.showInvasionPicker = ()=>{
            if (!this.invasionCandidates || this.invasionCandidates.length < 1) return;
            this.invasionPicker.open(this.invasionCandidates);
        };
        this.hideInvasionPicker = ()=>{
            if (this.invasionPicker?.isOpen()) this.invasionPicker.close();
        };
        this.isInvasionPickerVisible = ()=>{
            return this.invasionPicker?.isOpen() === true;
        };
        // Backing out of the picker, from any of its three ways out: the footer button, a press on its
        // own scrim, and Escape (the house convention for every other modal -- see Player's Escape
        // chain). All three go through here rather than each pairing the message with the close
        // themselves, which is how the keyboard path and the pointer path drift apart.
        this.cancelInvasionPicker = ()=>{
            if (!this.isInvasionPickerVisible()) return;
            this.logic.playerController?.client?.sendEmberInvasionCommand("cancel");
            this.hideInvasionPicker();
        };
        // Whether this player is currently wearing one of another camp's attackers (Message.invading).
        // Taken from the server's verdict on every message, like the downed flag, so the way out cannot
        // outlive the body -- or go missing while it lives.
        //
        // It is also what takes the SCORECARD down, and the timing is the point. The other two ways off
        // that panel dismiss it as they send, because they cannot fail; a `join` can -- the camp may
        // have closed, or filled, between the feed and the press -- and a panel dismissed optimistically
        // on a refused join would leave a still-fallen player with no way out at all until the camp's
        // own 3-minute net fired. So the panel waits for the server to say the visit really started.
        this.setInvading = (invading)=>{
            this.letGoButton?.setInvading(invading);
            // The gauge and that button share one slot. Taken down here rather than on the next roster
            // tick so the swap happens on the same frame the button appears.
            if (invading) {
                this.emberFireGauge?.update(undefined);
                // Forget which wave was last played, and what was being counted down to: the next
                // camp's wave 1 is a landing this player has not watched yet.
                this.wavePlayed = undefined;
                this.waveAwaited = undefined;
            }
            if (invading && !this.invading && this.isRunSummaryVisible()) this.hideRunSummary();
            // Each end of a visit, announced once. Both ends are this ONE verdict's transitions, which
            // is why neither needs a message of its own: the server already tells the client whether it
            // is wearing somebody else's body, every message, for its own entity.
            //
            // A visit that ends by dying also builds the player a fresh camp, so the "returned" splash
            // goes up alongside a room load -- hence its zIndex above everything, and hence nothing in
            // the room-change path takes it down. It waits to be read.
            const splash = (0, $fd1228436d3e60cd$export$42463ac0de0f0a2)(this.invading, invading);
            if (splash) this.showPossessionSplash(splash);
            this.invading = invading;
        };
        this.showPossessionSplash = (kind)=>{
            this.possessionSplash?.open(kind);
        };
        this.hidePossessionSplash = ()=>{
            if (this.possessionSplash?.isOpen()) this.possessionSplash.close();
        };
        this.isPossessionSplashVisible = ()=>this.possessionSplash?.isOpen() === true;
        this.isRolePickerVisible = ()=>{
            return this.rolePicker.isOpen() || this.emberInviteModal?.isOpen() === true;
        };
        // Server-driven: put up the first-run tutorial invitation (or take it down again when the
        // server passes null -- e.g. the player answered on another client, or the camp moved on).
        // Gated to ember rooms by the same per-room visibility flag as the command wheel and the role
        // picker, so a stray payload can never park a bar over a normal room.
        this.showTutorialPrompt = (prompt)=>{
            // The chapter's own choices live at the foot of its checklist, not on a board of their own.
            if (prompt?.nextChapterChip !== undefined) {
                this.hideTutorialPrompt();
                this.chapterChecklist.setCallToAction({
                    kind: "next",
                    chapter: prompt.nextChapterChip,
                    title: prompt.body
                });
                return;
            }
            if (prompt?.acceptCommand === "continue_story" && this.chapterChecklist.hasTasks()) {
                this.hideTutorialPrompt();
                this.chapterChecklist.setCallToAction({
                    kind: "continue",
                    body: prompt.body,
                    label: prompt.acceptLabel
                });
                return;
            }
            if (prompt?.announcementChapter !== undefined) {
                this.chapterChecklist.clearNextChapter();
                this.hideTutorialPrompt();
                this.logic.clientRenderer.entity().releaseHeldSpeech();
                this.chapterAnnouncement.open(prompt);
                const screen = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer.screen;
                const topLeft = this.chapterAnnouncement.toLocal(new (0, $6qzqq.Point)(screen.x, screen.y));
                const bottomRight = this.chapterAnnouncement.toLocal(new (0, $6qzqq.Point)(screen.x + screen.width, screen.y + screen.height));
                this.chapterAnnouncement.resize(bottomRight.x - topLeft.x, bottomRight.y - topLeft.y, topLeft.x, topLeft.y);
                this.logic.playerController?.enabledKeyboardAction(false);
                this.logic.playerController?.enabledMouseAction(false);
                return;
            }
            if (!prompt) {
                this.chapterChecklist.setCallToAction(null);
                this.hideTutorialPrompt();
                return;
            }
            if (!this.logic.clientRenderer.map().getVisibility()?.enableCommandWheel) return;
            this.tutorialPrompt.setPrompt(prompt);
            // The bar sizes itself to the server's wording, so re-anchor it to the bottom of the
            // screen AFTER it has been rebuilt -- otherwise a taller prompt hangs off the edge.
            this.anchorTutorialPrompt();
            this.tutorialPrompt.fadeIn();
        };
        // Keep the invitation a fixed distance off the bottom edge, whatever height its copy needs.
        this.anchorTutorialPrompt = ()=>{
            this.tutorialPrompt.y = (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h - this.tutorialPrompt.stageHeight() - 18;
        };
        this.hideTutorialPrompt = ()=>{
            this.tutorialPrompt.fadeOut();
        };
        this.isChapterAnnouncementVisible = ()=>this.chapterAnnouncement?.isOpen() === true;
        // Any screen, wheel, picker, prompt or splash that Escape would close. Read before the Escape
        // handlers run: while one is up, that press is its, and the world (build mode) keeps it.
        this.isModalOpen = ()=>(0, $33e5ff783af47130$export$2b77a92f1a5ad772).isAnyOpen() || this.isItemScreenOpen() || this.isCommandWheelVisible() || this.isRolePickerVisible() || this.isPossessionSplashVisible() || this.isInvasionPickerVisible() || this.isNamePromptVisible() || this.isChatComposerVisible() || this.isRunSummaryVisible() || this.characterBuilder?.isOpen() === true || this.characterCustomizer?.isOpen() === true;
        this.isTutorialPromptVisible = ()=>{
            return this.tutorialPrompt.isOpen();
        };
        this.preventContextMenu = ()=>{
            // Add document-level context menu prevention
            document.addEventListener("contextmenu", this.onContextMenu, true);
        };
        this.restoreContextMenu = ()=>{
            // Remove document-level context menu prevention
            document.removeEventListener("contextmenu", this.onContextMenu, true);
        };
        this.onContextMenu = (event)=>{
            // Only prevent context menu if command wheel is open
            if (this.commandWheel.isOpen()) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
        this.stage = stage;
        this.minimapSurface = minimapSurface;
        this.logic = logic;
        this.incomingMessageMeta = {
            unread: false,
            flasherInterval: null,
            expires: null,
            text: null
        };
        this.currentModal = null;
        this.upgradeIndicator = false;
        this.minimapSurface.register(this.mapPointHoverListener);
        // Load chat history from localStorage
        this.loadChatHistory();
    }
    static{
        // ---- dragging the minimap ------------------------------------------------
        //
        // The whole panel is a grab handle (see EmberMinimapWidget.attachDrag), because the part of the
        // camp the map covers is sometimes the part the player needs to watch. GuiManager does the moving
        // rather than the widget: it is what re-anchors the panel above the roster strip, and so the only
        // place that can both honour a dragged position and keep it on screen.
        // A press on the panel must never also swing the player's axe. The attack click arrives via a
        // document-level mousedown that cannot see which pixi widget it landed on, so it is held off the
        // same way an interaction-icon click is (see Player.suppressAttack) — renewed on grab, on every
        // drag frame and once more on release, so a drag of any length is covered end to end. A drag that
        // pauses needs no cover: a still pointer raises no mouse events, so nothing can fire.
        this.MINIMAP_DRAG_ATTACK_HOLDOFF_MS = 500;
    }
    static{
        // Terrain under the dots. The client already holds the tile map, so trees, cave rock and
        // structures are scanned here. The server supplies discovery bits and moving contacts.
        // Keyed on the map's collision version so a felled tree drops off the map, and floored on
        // EMBER_TREE_RESCAN_MS so a run of tile edits can't turn a 5Hz broadcast into a 5Hz full-room scan.
        this.EMBER_TREE_RESCAN_MS = 1000;
    }
    // The PiP only earns its screen space while the watched character is OFF-screen. Hide the PiP
    // once the subject enters the player's viewport; show it again when it
    // leaves. Called every frame (updateTimer) so it tracks the subject's movement.
    updateFollowCamVisibility() {
        if (!this.followCam?.isOpen()) {
            this.followCamShown = false;
            return;
        }
        const focusId = this.followCam.focusEntityId;
        if (!focusId || !this.emberRoster.isSelected(focusId)) {
            this.closeFollowCam();
            return;
        }
        const entity = this.logic.getFollowCamEntity(focusId);
        // Floor transfers can evict the local entity before its observation frame arrives.
        // The active roster card owns Watch throughout that gap, just as it owns its command wheel.
        const rosterMember = this.recruitHintRoster.some((entry)=>entry.entityId === focusId);
        if (this.logic.isFocusPending() && (!entity || entity.isDead() || this.logic.isDestroyed(entity.entityId))) return;
        if (rosterMember && (!entity || !this.logic.observation?.room && this.logic.isDestroyed(entity.entityId))) return;
        if (!entity || entity.isDead() || !this.logic.observation?.room && this.logic.isDestroyed(entity.entityId)) {
            this.closeFollowCam();
            return;
        }
        const onScreen = entity.roomId === this.logic.playerEntity?.roomId && this.logic.isWithinPlayerViewport(entity.location);
        const shouldShow = !onScreen;
        // Only start a fade on an actual transition (this runs every frame).
        if (shouldShow !== this.followCamShown) {
            this.followCamShown = shouldShow;
            this.followCamFader?.stop(true);
            if (shouldShow) {
                this.followCam.visible = true;
                // minAlpha (the fade target) passed explicitly: Fader computes its default before
                // applying `direction`, so an "in" fade would otherwise target 0 and never appear.
                this.followCamFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.followCam, {
                    direction: "in",
                    minAlpha: 1.0
                });
            } else this.followCamFader = new (0, $4d15b2b8e5519ed1$export$f290ab8c9aedfe3c)(this.followCam, {
                direction: "out",
                minAlpha: 0,
                releaseCallback: ()=>{
                    this.followCam.visible = false;
                }
            });
            this.followCamFader.update();
        }
    }
    // Open one camp member's command wheel from their ROSTER CARD.
    //
    // Unlike the per-NPC wheel above, this one is not put over its entity: a member you reach through
    // the roster is usually the one you can't see, so it takes the HUD slot directly above the strip
    // (the same slot the follow-cam PiP and the minimap share) and a connector line carries which
    // card it belongs to. For the same reason it does NOT close when its NPC leaves the viewport.
    watchMemberCommand(command, targetEntityId) {
        if (![
            "defender:watch",
            "lord:watch"
        ].includes(command) || !targetEntityId) return false;
        const name = this.recruitHintRoster.find((entry)=>entry.entityId === targetEntityId)?.name;
        this.hideCommandWheel();
        this.openFollowCam(targetEntityId, name);
        this.emberRoster.holdSelection(targetEntityId);
        return true;
    }
}


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");



// Pure geometry for the faction-tracking edge arrows. Kept free of PIXI so it can be
// unit-tested. All inputs are in ONE consistent coordinate space (the overlay container's
// local space); the caller obtains points/rect via PIXI transforms (toLocal) so no screen
// dimensions are assumed here.
function $346557f46cacf0ca$export$ed6daf3dad1b8753(a, b) {
    return {
        left: Math.min(a.x, b.x),
        right: Math.max(a.x, b.x),
        top: Math.min(a.y, b.y),
        bottom: Math.max(a.y, b.y)
    };
}
function $346557f46cacf0ca$export$cdb01b513ccf6a5c(p, rect, pad = 0) {
    return p.x < rect.left + pad || p.x > rect.right - pad || p.y < rect.top + pad || p.y > rect.bottom - pad;
}
function $346557f46cacf0ca$export$d96d408106aa045f(x, y, w, h, rect, pad = 2) {
    const halfW = w / 2 + pad;
    const halfH = h / 2 + pad;
    const minX = rect.left + halfW;
    const maxX = rect.right - halfW;
    const minY = rect.top + halfH;
    const maxY = rect.bottom - halfH;
    return {
        x: minX > maxX ? (rect.left + rect.right) / 2 : Math.max(minX, Math.min(maxX, x)),
        y: minY > maxY ? (rect.top + rect.bottom) / 2 : Math.max(minY, Math.min(maxY, y))
    };
}
function $346557f46cacf0ca$export$c0fb7ff48a5b5eeb(placement, w, h, rect, arrowClear, gap) {
    return $346557f46cacf0ca$var$offsetInwardBox(placement, placement.x, placement.y, arrowClear + gap, w, h, rect);
}
function $346557f46cacf0ca$export$91ef56399d0e33f3(placement, anchor, anchorW, anchorH, w, h, rect, gap) {
    const anchorHalf = placement.onVerticalEdge ? anchorW / 2 : anchorH / 2;
    return $346557f46cacf0ca$var$offsetInwardBox(placement, anchor.x, anchor.y, anchorHalf + gap, w, h, rect);
}
// Shared core: offset a box inward (perpendicular to the placement's screen edge), aligned
// with the anchor point on the along-edge axis, so the box's near edge sits `clearance` past
// the anchor. Then clamp it on screen (which only pushes further inward -> no re-overlap).
function $346557f46cacf0ca$var$offsetInwardBox(placement, ax, ay, clearance, w, h, rect) {
    let x = ax;
    let y = ay;
    if (placement.onVerticalEdge) // sign(cos) matches sign(anchor.x - center.x): +1 on the right edge, -1 on the left.
    // Subtracting pushes the box inward by half its width plus the clearance.
    x = ax - Math.sign(Math.cos(placement.angle)) * (clearance + w / 2);
    else y = ay - Math.sign(Math.sin(placement.angle)) * (clearance + h / 2);
    return $346557f46cacf0ca$export$d96d408106aa045f(x, y, w, h, rect);
}
function $346557f46cacf0ca$export$d6462cc94e2727e7(target, rect, margin) {
    const cx = (rect.left + rect.right) / 2;
    const cy = (rect.top + rect.bottom) / 2;
    const dx = target.x - cx;
    const dy = target.y - cy;
    if (dx === 0 && dy === 0) return {
        x: cx,
        y: cy,
        angle: 0,
        onVerticalEdge: true
    };
    const halfW = Math.max(1, (rect.right - rect.left) / 2 - margin);
    const halfH = Math.max(1, (rect.bottom - rect.top) / 2 - margin);
    // Whichever normalized reach is smaller binds first: the x-scale binding means the ray
    // exits through a left/right (vertical) edge; the y-scale, a top/bottom (horizontal) one.
    const sx = halfW / Math.abs(dx || 1e-9);
    const sy = halfH / Math.abs(dy || 1e-9);
    const scale = Math.min(sx, sy);
    return {
        x: cx + dx * scale,
        y: cy + dy * scale,
        angle: Math.atan2(dy, dx),
        onVerticalEdge: sx <= sy
    };
}


class $265fbb56155cf111$export$92880c192d1b7482 {
    constructor(logic, surface, app){
        this.markers = new Map();
        this.EDGE_MARGIN = 18;
        // How far the arrow triangle can reach toward the glyph (its farthest vertex is the 9px
        // tip; near a corner the rotated arrow reaches obliquely toward the glyph, so use the tip
        // radius rather than the 6px back edge). GLYPH_GAP is the extra clear space kept between
        // the arrow and the glyph; together they set the constant near-edge clearance used by
        // placeInwardBox so the glyph never overlaps the arrow at any edge angle.
        this.ARROW_REACH = 9;
        this.GLYPH_GAP = 1;
        this.OFFSCREEN_PAD = 8;
        this.ARROW_COLOR = 0x66ff66;
        // The highlighted roster member's arrow: hot orange, breathing, with an expanding ping behind
        // it, so "where is the one I just clicked?" is answerable at a glance across a busy screen.
        this.HIGHLIGHT_COLOR = 0xff8a1f;
        this.PULSE_MS = 900 // one breathe/ping cycle
        ;
        this.PULSE_GROW = 0.5 // the arrow swells to 1.5x at the top of the breath
        ;
        this.NAME_COLOR = 0x66ff66 // name line — matches the arrow/glyph
        ;
        this.GLYPH_SIZE = (0, $ef882f0a643d87d9$export$a57e4d4d74a95378).body.fontSize // role icon size
        ;
        this.HOVER_PAD = 5 // extra hit-area padding so the small glyph is easy to hover
        ;
        this.PANEL_GAP = 5 // gap between the glyph and the name/message panel
        ;
        // Rescanning every entity in the room each frame (entityManager.collect is O(n) and
        // allocates) is wasteful; the tracked-member SET changes slowly. Rebuild it a few times
        // a second and reuse the cached Entity references — their `location` is mutated in place
        // by the netcode, so arrow positions still update every frame.
        this.members = [];
        this.lastScanMs = 0;
        this.lastScannedFaction = null;
        this.SCAN_INTERVAL_MS = 250;
        // Reused scratch points to avoid per-frame allocation.
        this.tmpA = new (0, $6qzqq.Point)();
        this.tmpB = new (0, $6qzqq.Point)();
        this.logic = logic;
        this.surface = surface;
        this.app = app;
        this.container = new (0, $8t5Gy.Container)();
        this.container.zIndex = 50000 // above other HUD; stage.sortableChildren is on
        ;
        // Markers sort among themselves so the highlighted arrow draws over its neighbours when
        // two members are bunched at the same screen edge.
        this.container.sortableChildren = true;
    }
    // Triangle pointing toward +x; the marker's rotation orients it outward. Redrawn (rather than
    // tinted) when the highlight turns on/off, so the fill is the literal colour either way.
    drawArrow(g, color) {
        g.clear();
        g.beginFill(color);
        g.moveTo(9, 0);
        g.lineTo(-6, -6);
        g.lineTo(-6, 6);
        g.closePath();
        g.endFill();
    }
    // Fake glow behind the highlighted arrow: the same triangle stacked at growing scales with
    // falling alpha, largest first. A real blur filter would cost a GPU bake per frame per arrow,
    // which this has to run without.
    buildGlow() {
        const g = new (0, $gwPoJ.Graphics)();
        for (const [scale, alpha] of [
            [
                2.6,
                0.14
            ],
            [
                1.9,
                0.28
            ],
            [
                1.35,
                0.5
            ]
        ]){
            g.beginFill(this.HIGHLIGHT_COLOR, alpha);
            g.moveTo(9 * scale, 0);
            g.lineTo(-6 * scale, -6 * scale);
            g.lineTo(-6 * scale, 6 * scale);
            g.closePath();
            g.endFill();
        }
        g.visible = false;
        return g;
    }
    buildArrow() {
        const g = new (0, $gwPoJ.Graphics)();
        this.drawArrow(g, this.ARROW_COLOR);
        // Padded hit area around the small triangle (local bounds ~x[-6,9] y[-6,6]) so the
        // arrow itself is an easy hover target, not just the glyph. Rotates with the arrow.
        g.hitArea = new (0, $6qzqq.Rectangle)(-6 - this.HOVER_PAD, -6 - this.HOVER_PAD, 15 + this.HOVER_PAD * 2, 12 + this.HOVER_PAD * 2);
        return g;
    }
    // Make an object a hover target that drives the marker's tooltip (arrow + glyph both use this).
    wireHover(obj, marker) {
        obj.interactive = true;
        obj.cursor = "help";
        obj.on("pointerover", ()=>marker.hoverCount += 1);
        obj.on("pointerout", ()=>marker.hoverCount = Math.max(0, marker.hoverCount - 1));
    }
    applyGlyph(m) {
        m.glyph.removeChildren().forEach((child)=>child.destroy({
                children: true,
                texture: true,
                baseTexture: true
            }));
        m.glyph.addChild((0, $7674b5c0a355be98$export$68f029f6c68daa48)(m.role, this.GLYPH_SIZE, m.highlighted ? this.HIGHLIGHT_COLOR : m.role ? undefined : this.ARROW_COLOR));
        // Padded hit area (measured after the text is set) so the small glyph is easy to hover.
        const hw = m.glyph.width / 2 + this.HOVER_PAD;
        const hh = m.glyph.height / 2 + this.HOVER_PAD;
        m.glyph.hitArea = new (0, $6qzqq.Rectangle)(-hw, -hh, hw * 2, hh * 2);
    }
    ensureMarker(entityId, role) {
        let m = this.markers.get(entityId);
        if (!m) {
            const container = new (0, $8t5Gy.Container)();
            const glow = this.buildGlow();
            const arrow = this.buildArrow();
            const glyph = new (0, $8t5Gy.Container)();
            container.addChild(glow) // behind the arrow
            ;
            container.addChild(arrow);
            container.addChild(glyph);
            this.container.addChild(container);
            m = {
                container: container,
                glow: glow,
                arrow: arrow,
                glyph: glyph,
                role: role,
                hoverCount: 0,
                highlighted: false
            };
            this.wireHover(arrow, m) // hovering the arrow OR the glyph shows the name tooltip
            ;
            this.wireHover(glyph, m);
            this.applyGlyph(m);
            this.markers.set(entityId, m);
        } else if (m.role !== role) {
            m.role = role;
            this.applyGlyph(m);
        }
        return m;
    }
    // Turn the "this is the roster card you have open" treatment on/off for a marker. Only the
    // state CHANGE redraws; the per-frame motion is in animateHighlight.
    setHighlight(m, on) {
        if (m.highlighted === on) return;
        m.highlighted = on;
        this.drawArrow(m.arrow, on ? this.HIGHLIGHT_COLOR : this.ARROW_COLOR);
        this.applyGlyph(m);
        m.glow.visible = on;
        m.container.zIndex = on ? 1 : 0;
        if (!on) m.arrow.scale.set(1);
    }
    // The pulse itself: the arrow breathes (smooth cosine) while a ping expands and fades out of
    // it (sawtooth), both off one shared clock so every highlighted arrow beats in time.
    animateHighlight(m, nowMs, placement) {
        const t = nowMs % this.PULSE_MS / this.PULSE_MS;
        const breathe = 0.5 - 0.5 * Math.cos(t * Math.PI * 2);
        m.arrow.scale.set(1 + this.PULSE_GROW * breathe);
        m.glow.position.set(placement.x, placement.y);
        m.glow.rotation = placement.angle;
        m.glow.scale.set(0.85 + 0.9 * t);
        m.glow.alpha = 0.85 * Math.pow(1 - t, 1.5);
    }
    hideMarker(m) {
        m.container.visible = false;
        m.hoverCount = 0 // pointerout won't fire while hidden; clear so no stale tooltip on return
        ;
    }
    hideAll() {
        this.markers.forEach((m)=>this.hideMarker(m));
    }
    // Show the black high-contrast panel inward of the glyph: the name (name color), and — when
    // the member is speaking — the message (message color) stacked below it. `message` is null
    // for a plain hover (name only). Positioned just past the glyph (via placeInwardOfBox) so it
    // never covers the glyph or the arrowhead.
    // The hover label: just the member's name. What they SAY is no longer shown here — an offscreen
    // member's words go to the ember roster's speech lane instead (gui/roster_speech_lane.ts), where
    // they sit above that member's own portrait card. Showing the line in both places at once was
    // the same sentence twice on screen.
    showPanel(marker, name, glyphCenter, glyphW, glyphH, placement, rect) {
        if (!marker.panel) {
            const container = new (0, $8t5Gy.Container)();
            const bg = new (0, $gwPoJ.Graphics)();
            const nameText = new (0, $30b51e7e6bcae30f$export$75ebcd2c8ed5b901)().size("tiny").color(this.NAME_COLOR).render();
            nameText.anchor.set(0.5, 0) // top-centered
            ;
            container.addChild(bg);
            container.addChild(nameText);
            marker.container.addChild(container);
            marker.panel = {
                container: container,
                bg: bg,
                nameText: nameText
            };
        }
        const panel = marker.panel;
        if (panel.nameText.text !== name) panel.nameText.text = name;
        const padX = 6;
        const padY = 3;
        const w = panel.nameText.width + padX * 2;
        const h = panel.nameText.height + padY * 2;
        panel.nameText.position.set(0, -h / 2 + padY);
        panel.bg.clear();
        panel.bg.beginFill(0x000000, 0.85) // near-opaque black for high contrast over the world
        ;
        panel.bg.lineStyle(1, this.ARROW_COLOR, 0.9);
        panel.bg.drawRoundedRect(-w / 2, -h / 2, w, h, 4);
        panel.bg.endFill();
        // Sit the panel just past the glyph (inward), aligned with it, and keep it on screen.
        const pos = (0, $346557f46cacf0ca$export$91ef56399d0e33f3)(placement, glyphCenter, glyphW, glyphH, w, h, rect, this.PANEL_GAP);
        panel.container.position.set(pos.x, pos.y);
        panel.container.visible = true;
    }
    hidePanel(marker) {
        if (marker.panel) marker.panel.container.visible = false;
    }
    nameFor(entity) {
        const anyEntity = entity;
        if (typeof anyEntity.safeName === "function") return anyEntity.safeName() || "";
        return entity.name || "";
    }
    // The visible screen rectangle expressed in this overlay's local coordinate space,
    // derived from the renderer's actual screen corners via PIXI transforms.
    screenRectInLocal() {
        this.tmpA.set(this.app.screen.x, this.app.screen.y);
        this.tmpB.set(this.app.screen.x + this.app.screen.width, this.app.screen.y + this.app.screen.height);
        const tl = this.container.toLocal(this.tmpA);
        const br = this.container.toLocal(this.tmpB);
        return (0, $346557f46cacf0ca$export$ed6daf3dad1b8753)(tl, br);
    }
    update() {
        const logic = this.logic;
        if (!logic.trackingEnabled || !logic.trackedFaction) {
            this.hideAll();
            return;
        }
        const player = logic.playerEntity;
        if (!player || !player.location) {
            this.hideAll();
            return;
        }
        const rect = this.screenRectInLocal();
        // Throttled rescan of the tracked-faction member set (also rescans immediately if
        // the tracked faction changed). Positions come from the cached refs each frame.
        const nowMs = performance.now();
        if (nowMs - this.lastScanMs >= this.SCAN_INTERVAL_MS || this.lastScannedFaction !== logic.trackedFaction) {
            // (A visitor appearing is picked up by the interval, not by a change of faction -- at
            // the scan rate the arrow is at most one scan behind the card, which is well inside the
            // time it takes the player to look up at the strip.)
            this.lastScanMs = nowMs;
            this.lastScannedFaction = logic.trackedFaction;
            this.members = logic.entityManager.collect((e)=>e.entityId !== player.entityId && // A VISITOR is tracked without being one of us: a recruit standing at the camp's
                // fire is faction "none" on purpose (so nothing in the wilderness or the camp
                // treats it as a side), and an arrow to it is the one thing the player most
                // wants when they are off in the trees. The roster feed is the only witness to
                // who is visiting -- entity FLAGS never reach the client (see server.ts
                // fillMessageFromEntity) -- which is why this asks for the role rather than a
                // flag, and why it costs nothing: the roster was already feeding this lookup
                // for the arrow glyphs.
                (e.faction === logic.trackedFaction || logic.getEmberRole(e.entityId) === "visitor"));
        }
        // The highlighted roster card IS the follow-cam focus (EmberRosterWidget.onSlotClick ->
        // GuiManager.openFollowCam -> setFocusEntityId), so that one id is the whole signal.
        const highlightedId = logic.focusEntityId;
        const present = new Set();
        for (const entity of this.members){
            // Skip stale cached refs: entity hidden, removed from the manager, or already
            // scheduled for destruction (removed next cleanup). Not adding it to `present`
            // makes the cleanup pass below destroy its arrow this frame.
            if (!entity.location || entity.visible === false || !logic.hasEntity(entity.entityId) || logic.isDestroyed(entity.entityId)) continue;
            present.add(entity.entityId);
            // Entity world position -> this overlay's local space (exact, via the world
            // container's transform).
            this.tmpA.set(entity.location.x, entity.location.y);
            const p = this.container.toLocal(this.tmpA, this.surface);
            if (!(0, $346557f46cacf0ca$export$cdb01b513ccf6a5c)(p, rect, this.OFFSCREEN_PAD)) {
                const existing = this.markers.get(entity.entityId);
                if (existing) this.hideMarker(existing);
                continue;
            }
            const placement = (0, $346557f46cacf0ca$export$d6462cc94e2727e7)(p, rect, this.EDGE_MARGIN);
            const marker = this.ensureMarker(entity.entityId, this.logic.getEmberRole(entity.entityId));
            this.setHighlight(marker, !!highlightedId && entity.entityId === highlightedId);
            marker.container.visible = true;
            marker.arrow.position.set(placement.x, placement.y);
            marker.arrow.rotation = placement.angle;
            if (marker.highlighted) this.animateHighlight(marker, nowMs, placement);
            // The role glyph, offset perpendicular to the arrow's screen edge and aligned along
            // it, so it sits centered next to the arrow without overlapping the arrowhead.
            // Reserve clearance for the arrow at its LARGEST (peak of the breath) rather than
            // re-placing the glyph every frame, which would make it jitter in and out.
            const reach = marker.highlighted ? this.ARROW_REACH * (1 + this.PULSE_GROW) : this.ARROW_REACH;
            const gp = (0, $346557f46cacf0ca$export$c0fb7ff48a5b5eeb)(placement, marker.glyph.width, marker.glyph.height, rect, reach, this.GLYPH_GAP);
            marker.glyph.position.set(gp.x, gp.y);
            // The black panel (just past the glyph) names the member while the arrow or glyph is
            // hovered. The arrow's job is DIRECTION — where they are; what they're saying belongs to
            // the roster's speech lane, which has their portrait and name already.
            if (marker.hoverCount > 0) this.showPanel(marker, this.nameFor(entity), gp, marker.glyph.width, marker.glyph.height, placement, rect);
            else this.hidePanel(marker);
        }
        // Drop markers whose entity is gone (left room, died, out of sync range).
        for (const [id, m] of this.markers)if (!present.has(id)) {
            m.container.destroy({
                children: true
            });
            this.markers.delete(id);
        }
    }
}






parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $eUwg9 = parcelRequire("eUwg9");




// The upright ladder has 12px of top padding and a 4px-thick top beam.
// Fasten the underside lid to that beam, rather than into the empty padding above it.
const $91d06b361b7153d4$var$hingeRow = (underside)=>underside ? 16 : 12;
const $91d06b361b7153d4$export$ad49191e0a619067 = (openness)=>{
    const angle = Math.max(0, Math.min(1, openness)) * Math.PI * .57;
    return {
        frontY: 12 + 28 * Math.cos(angle) - 30 * Math.sin(angle),
        spread: Math.sin(angle) * .75,
        shade: 1 - Math.sin(angle) * .12
    };
};
class $91d06b361b7153d4$export$8fb929e46cc39fa7 extends (0, $8t5Gy.Container) {
    constructor(hatch, underside = false){
        super(), this.hatch = hatch, this.underside = underside, this.panel = new (0, $8t5Gy.Container)(), this.edge = new (0, $gwPoJ.Graphics)(), this.shadow = new (0, $gwPoJ.Graphics)(), this.cracks = new (0, $gwPoJ.Graphics)(), this./** Include the independently sorted panel when transferring this floor's owned artwork. */ depthArtwork = ()=>this.panel.destroyed ? undefined : this.panel;
        this.addChild(this.shadow);
        this.lid = new (0, $eUwg9.SimpleMesh)((0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)("hatch-wood-lid"), new Float32Array(8), new Float32Array([
            0,
            0,
            1,
            0,
            1,
            1,
            0,
            1
        ]), new Uint16Array([
            0,
            1,
            2,
            0,
            2,
            3
        ]));
        this.panel.addChild(this.lid, this.edge);
        this.addChild(this.panel);
        const hinges = new (0, $gwPoJ.Graphics)();
        const hingeY = $91d06b361b7153d4$var$hingeRow(underside) - 4;
        hinges.beginFill(0x211d1b).drawRect(19, hingeY, 4, 6).drawRect(41, hingeY, 4, 6).endFill();
        hinges.beginFill(0x858079).drawRect(20, hingeY + 1, 2, 2).drawRect(42, hingeY + 1, 2, 2).endFill();
        this.panel.addChild(hinges, this.cracks);
        this.pose();
    }
    pose(now = (0, $4171652afd996934$export$a86190deb5c4a8d0)()) {
        if (this.destroyed || this.panel.destroyed) return;
        const open = (0, $da5649d79a6bbe55$export$ba4449ea24c4ee75)(this.hatch, now);
        const pose = $91d06b361b7153d4$export$ad49191e0a619067(open);
        const angle = open * Math.PI * .57;
        const hingeY = $91d06b361b7153d4$var$hingeRow(this.underside);
        const frontY = this.underside ? hingeY + 10 * Math.cos(angle) - 20 * Math.sin(angle) : pose.frontY;
        this.sortPanel(frontY < hingeY, hingeY);
        const hitAge = this.hatch.lastHitAt === undefined ? Infinity : now - this.hatch.lastHitAt;
        const shake = hitAge >= 0 && hitAge < 320 ? Math.sin(hitAge * .09) * 1.5 * (1 - hitAge / 320) : 0;
        // Offset only the lid artwork; the opening and ladder remain fixed to their floor.
        this.panel.x += shake * this.panel.scale.x;
        if (open === this.lastOpenness) return;
        this.lastOpenness = open;
        const { spread: spread, shade: shade } = pose;
        const v = this.lid.vertices;
        v[0] = 16;
        v[1] = hingeY;
        v[2] = 48;
        v[3] = hingeY;
        v[4] = 48 + spread;
        v[5] = frontY;
        v[6] = 16 - spread;
        v[7] = frontY;
        this.lid.tint = Math.round(255 * shade) * 0x010101;
        this.shadow.clear().beginFill(0x0c0806, .30 * (1 - open)).drawRect(15, hingeY, 34, this.underside ? 11 : 29).endFill();
        this.edge.clear().lineStyle(2, 0x2d1d12, 1).moveTo(16 - spread, frontY).lineTo(48 + spread, frontY);
        const damage = 1 - (0, $da5649d79a6bbe55$export$c4ac2bf49c6c1267)(this.hatch) / (0, $da5649d79a6bbe55$export$b2d35e74b04a84a5);
        this.cracks.clear();
        const point = (x, t)=>[
                x,
                hingeY + (frontY - hingeY) * t
            ];
        const split = (x, start, end)=>{
            const a = point(x, start), b = point(x - 2, (start + end) / 2), c = point(x + 1, end);
            this.cracks.lineStyle(1, 0x25180f, .95).moveTo(a[0], a[1]).lineTo(b[0], b[1]).lineTo(c[0], c[1]);
        };
        if (damage > 0) split(28, .18, .55);
        if (damage >= .375) split(39, .42, .95);
        if (damage >= .625) split(22, .6, 1);
    }
    /** The raised door shares the bodies' depth surface; the shaft and shadow stay on the floor. */ sortPanel(raised, hingeY) {
        const opening = this.parent;
        if (raised && opening?.parent) {
            const surface = opening.parent;
            if (this.panel.parent !== surface) surface.addChild(this.panel);
            this.panel.position.copyFrom(opening.position);
            this.panel.scale.copyFrom(opening.scale);
            this.panel.skew.copyFrom(opening.skew);
            this.panel.rotation = opening.rotation;
            // The view from below is attached to a tall ladder: its drawn top is far
            // north of its ground anchor. Keep the lid in that ladder's depth band,
            // or opening it moves it behind the roof the ladder stands in front of.
            this.panel.zIndex = this.underside ? opening.zIndex + .1 : 100 + opening.y + hingeY * opening.scale.y - (0, $9667a1379a787b5e$export$5985b04c8e71b763);
            this.panel.visible = opening.visible && this.visible;
            this.panel.alpha = opening.alpha * this.alpha;
        } else {
            if (this.panel.parent !== this) this.addChild(this.panel);
            this.panel.position.set(0, 0);
            this.panel.scale.set(1, 1);
            this.panel.skew.set(0, 0);
            this.panel.rotation = 0;
            this.panel.visible = true;
            this.panel.alpha = 1;
        }
    }
    destroy(options) {
        if (this.destroyed) return;
        // The panel can be a sibling of its owning opening when it is raised.
        if (!this.panel.destroyed) {
            this.panel.parent?.removeChild(this.panel);
            this.panel.destroy({
                children: true
            });
        }
        super.destroy(options);
    }
}
const $91d06b361b7153d4$export$6075182e406ebc5b = (opening, hatch, underside = false)=>{
    const sprite = new $91d06b361b7153d4$export$8fb929e46cc39fa7(hatch, underside);
    opening.addChild(sprite);
    sprite.pose();
    return sprite;
};
class $91d06b361b7153d4$export$63dec0f88d1072cf extends (0, $8t5Gy.Container) {
    constructor(brokenAt, underside = false){
        super(), this.brokenAt = brokenAt, this.underside = underside, this.fragments = [], this.dust = new (0, $gwPoJ.Graphics)(), this.depthArtwork = ()=>undefined;
        const height = underside ? 10 : 28, width = 32 / 3;
        for(let row = 0; row < 2; row++)for(let col = 0; col < 3; col++){
            const h = height / 2, u = col / 3, v = row / 2;
            const mesh = new (0, $eUwg9.SimpleMesh)((0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)("hatch-wood-lid"), new Float32Array([
                -width / 2,
                -h / 2,
                width / 2,
                -h / 2,
                width / 2,
                h / 2,
                -width / 2,
                h / 2
            ]), new Float32Array([
                u,
                v,
                u + 1 / 3,
                v,
                u + 1 / 3,
                v + .5,
                u,
                v + .5
            ]), new Uint16Array([
                0,
                1,
                2,
                0,
                2,
                3
            ]));
            const sign = (col + row) % 2 ? 1 : -1;
            this.fragments.push({
                mesh: mesh,
                x: 16 + (col + .5) * width,
                y: $91d06b361b7153d4$var$hingeRow(underside) + (row + .5) * h,
                dx: (col - 1) * 15 + sign * (row ? 4 : 7),
                spin: sign * (row ? 1.4 : .8)
            });
            this.addChild(mesh);
        }
        this.addChild(this.dust);
    }
    pose(now = (0, $4171652afd996934$export$a86190deb5c4a8d0)()) {
        if (this.destroyed) return;
        const t = Math.max(0, (now - this.brokenAt) / (0, $da5649d79a6bbe55$export$8090247a39a06ef1));
        if (t >= 1) {
            this.destroy({
                children: true
            });
            return;
        }
        const fade = Math.min(1, (1 - t) / .4);
        for (const piece of this.fragments){
            piece.mesh.position.set(piece.x + piece.dx * t, piece.y - 22 * t + (this.underside ? 86 : 54) * t * t);
            piece.mesh.rotation = piece.spin * t;
            piece.mesh.scale.set(1 - t * .22);
            piece.mesh.alpha = fade;
        }
        this.dust.clear();
        for(let i = 0; i < 10; i++){
            const dx = (i % 5 - 2) * 9, lift = 10 + i % 3 * 5;
            this.dust.beginFill(i % 2 ? 0x9c764a : 0xd1aa70, (1 - t) * .65).drawRect(32 + dx * t, $91d06b361b7153d4$var$hingeRow(this.underside) + 8 - lift * t + 32 * t * t, 1 + i % 2, 2).endFill();
        }
    }
}
const $91d06b361b7153d4$export$75c879799cfe3970 = (opening, brokenAt, underside = false)=>{
    const sprite = new $91d06b361b7153d4$export$63dec0f88d1072cf(brokenAt, underside);
    opening.addChild(sprite);
    sprite.pose();
    return sprite;
};





/* eslint-disable */ /*!
 * @pixi/tilemap - v3.2.2
 * Compiled Fri, 22 Oct 2021 12:27:49 UTC
 *
 * @pixi/tilemap is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 * 
 * Copyright 2019-2020, Ivan Popelyshev, All Rights Reserved
 */ 
var $8t5Gy = parcelRequire("8t5Gy");

var $klOfb = parcelRequire("klOfb");

var $P8XPi = parcelRequire("P8XPi");

var $6qzqq = parcelRequire("6qzqq");

var $csytw = parcelRequire("csytw");
/**
 * The renderer plugin for canvas. It isn't registered by default.
 *
 * ```
 * import { CanvasTileRenderer } from '@pixi/tilemap';
 * import { CanvasRenderer } from '@pixi/canvas-core';
 *
 * // You must register this yourself (optional). @pixi/tilemap doesn't do it to
 * // prevent a hard dependency on @pixi/canvas-core.
 * CanvasRenderer.registerPlugin('tilemap', CanvasTileRenderer);
 * ```
 */ // TODO: Move to @pixi/tilemap-canvas
class $21ba273fabeffbe8$export$adc19050884d1e30 {
    /** The renderer */ /** The global tile animation state */ __init() {
        this.tileAnim = [
            0,
            0
        ];
    }
    /** @deprecated */ __init2() {
        this.dontUseTransform = false;
    }
    /** @param renderer */ constructor(renderer){
        $21ba273fabeffbe8$export$adc19050884d1e30.prototype.__init.call(this);
        $21ba273fabeffbe8$export$adc19050884d1e30.prototype.__init2.call(this);
        this.renderer = renderer;
        this.tileAnim = [
            0,
            0
        ];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static getInstance(renderer) {
        if (!renderer.plugins.tilemap) renderer.plugins.tilemap = new $21ba273fabeffbe8$export$adc19050884d1e30(renderer);
        return renderer.plugins.tilemap;
    }
}
/**
 * These are additional @pixi/tilemap options.
 *
 * This settings should not be changed after the renderer has initialized; otherwise, the behavior
 * is undefined.
 */ const $21ba273fabeffbe8$export$a5a6e0b888b2c992 = {
    /** The default number of textures per tilemap in a tilemap composite. */ TEXTURES_PER_TILEMAP: 16,
    /**
     * The width/height of each texture tile in a {@link TEXTILE_DIMEN}. This is 1024px by default.
     *
     * This should fit all tile base-textures; otherwise, {@link TextileResource} may fail to correctly
     * upload the textures togther in a tiled fashion.
     */ TEXTILE_DIMEN: 1024,
    /**
     * The number of texture tiles per {@link TextileResource}.
     *
     * Texture tiling is disabled by default, and so this is set to `1` by default. If it is set to a
     * higher value, textures will be uploaded together in a tiled fashion.
     *
     * Since {@link TextileResource} is a dual-column format, this should be even for packing
     * efficiency. The optimal value is usually 4.
     */ TEXTILE_UNITS: 1,
    /** The scaling mode of the combined texture tiling. */ TEXTILE_SCALE_MODE: (0, $P8XPi.SCALE_MODES).LINEAR,
    /** This will enable 32-bit index buffers. It's useful when you have more than 16K tiles. */ use32bitIndex: false,
    /** Flags whether textiles should be cleared when each tile is uploaded. */ DO_CLEAR: true,
    // Backward compatibility
    get maxTextures () {
        return this.MAX_TEXTURES;
    },
    set maxTextures (value){
        this.MAX_TEXTURES = value;
    },
    get boundSize () {
        return this.TEXTURE_TILE_DIMEN;
    },
    set boundSize (value){
        this.TILE_TEXTURE_DIMEN = value;
    },
    get boundCountPerBuffer () {
        return this.TEXTILE_UNITS;
    },
    set boundCountPerBuffer (value){
        this.TEXTILE_UNITS = value;
    }
};
// @deprecated
const $21ba273fabeffbe8$export$3c508fb3f8ac1ad4 = $21ba273fabeffbe8$export$a5a6e0b888b2c992;
function $21ba273fabeffbe8$var$_nullishCoalesce(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
var $21ba273fabeffbe8$var$POINT_STRUCT;
(function(POINT_STRUCT) {
    const U = 0;
    POINT_STRUCT[POINT_STRUCT["U"] = U] = "U";
    const V = U + 1;
    POINT_STRUCT[POINT_STRUCT["V"] = V] = "V";
    const X = V + 1;
    POINT_STRUCT[POINT_STRUCT["X"] = X] = "X";
    const Y = X + 1;
    POINT_STRUCT[POINT_STRUCT["Y"] = Y] = "Y";
    const TILE_WIDTH = Y + 1;
    POINT_STRUCT[POINT_STRUCT["TILE_WIDTH"] = TILE_WIDTH] = "TILE_WIDTH";
    const TILE_HEIGHT = TILE_WIDTH + 1;
    POINT_STRUCT[POINT_STRUCT["TILE_HEIGHT"] = TILE_HEIGHT] = "TILE_HEIGHT";
    const ROTATE = TILE_HEIGHT + 1;
    POINT_STRUCT[POINT_STRUCT["ROTATE"] = ROTATE] = "ROTATE";
    const ANIM_X = ROTATE + 1;
    POINT_STRUCT[POINT_STRUCT["ANIM_X"] = ANIM_X] = "ANIM_X";
    const ANIM_Y = ANIM_X + 1;
    POINT_STRUCT[POINT_STRUCT["ANIM_Y"] = ANIM_Y] = "ANIM_Y";
    const TEXTURE_INDEX = ANIM_Y + 1;
    POINT_STRUCT[POINT_STRUCT["TEXTURE_INDEX"] = TEXTURE_INDEX] = "TEXTURE_INDEX";
    const ANIM_COUNT_X = TEXTURE_INDEX + 1;
    POINT_STRUCT[POINT_STRUCT["ANIM_COUNT_X"] = ANIM_COUNT_X] = "ANIM_COUNT_X";
    const ANIM_COUNT_Y = ANIM_COUNT_X + 1;
    POINT_STRUCT[POINT_STRUCT["ANIM_COUNT_Y"] = ANIM_COUNT_Y] = "ANIM_COUNT_Y";
    const ANIM_DIVISOR = ANIM_COUNT_Y + 1;
    POINT_STRUCT[POINT_STRUCT["ANIM_DIVISOR"] = ANIM_DIVISOR] = "ANIM_DIVISOR";
    const ALPHA = ANIM_DIVISOR + 1;
    POINT_STRUCT[POINT_STRUCT["ALPHA"] = ALPHA] = "ALPHA";
})($21ba273fabeffbe8$var$POINT_STRUCT || ($21ba273fabeffbe8$var$POINT_STRUCT = {}));
const $21ba273fabeffbe8$export$1352a974e0a4bb22 = Object.keys($21ba273fabeffbe8$var$POINT_STRUCT).length / 2;
/**
 * A rectangular tilemap implementation that renders a predefined set of tile textures.
 *
 * The {@link Tilemap.tileset tileset} of a tilemap defines the list of base-textures that can be painted in the
 * tilemap. A texture is identified using its base-texture's index into the this list, i.e. changing the base-texture
 * at a given index in the tileset modifies the paint of all tiles pointing to that index.
 *
 * The size of the tileset is limited by the texture units supported by the client device. The minimum supported
 * value is 8, as defined by the WebGL 1 specification. `gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS`) can be used
 * to extract this limit. {@link CompositeTilemap} can be used to get around this limit by layering multiple tilemap
 * instances.
 *
 * @example
 * import { Tilemap } from '@pixi/tilemap';
 * import { Loader } from '@pixi/loaders';
 *
 * // Add the spritesheet into your loader!
 * Loader.shared.add('atlas', 'assets/atlas.json');
 *
 * // Make the tilemap once the tileset assets are available.
 * Loader.shared.load(function onTilesetLoaded()
 * {
 *      // The base-texture is shared between all the tile textures.
 *      const tilemap = new Tilemap([Texture.from('grass.png').baseTexture])
 *          .tile('grass.png', 0, 0)
 *          .tile('grass.png', 100, 100)
 *          .tile('brick_wall.png', 0, 100);
 * });
 */ class $21ba273fabeffbe8$export$f9d4276726476e59 extends (0, $8t5Gy.Container) {
    __init() {
        this.shadowColor = new Float32Array([
            0.0,
            0.0,
            0.0,
            0.5
        ]);
    }
    __init2() {
        this._globalMat = null;
    }
    /**
     * The tile animation frame.
     *
     * @see CompositeTilemap.tileAnim
     */ __init3() {
        this.tileAnim = null;
    }
    /**
     * This is the last uploaded size of the tilemap geometry.
     * @ignore
     */ __init4() {
        this.modificationMarker = 0;
    }
    /** @ignore */ __init5() {
        this.offsetX = 0;
    }
    /** @ignore */ __init6() {
        this.offsetY = 0;
    }
    /** @ignore */ __init7() {
        this.compositeParent = false;
    }
    /**
     * The list of base-textures being used in the tilemap.
     *
     * This should not be shuffled after tiles have been added into this tilemap. Usually, only tile textures
     * should be added after tiles have been added into the map.
     */ /**
     * The local bounds of the tilemap itself. This does not include DisplayObject children.
     */ __init8() {
        this.tilemapBounds = new (0, $8t5Gy.Bounds)();
    }
    /** Flags whether any animated tile was added. */ __init9() {
        this.hasAnimatedTile = false;
    }
    /** The interleaved geometry of the tilemap. */ __init10() {
        this.pointsBuf = [];
    }
    /**
     * @param tileset - The tileset to use for the tilemap. This can be reset later with {@link Tilemap.setTileset}. The
     *      base-textures in this array must not be duplicated.
     */ constructor(tileset){
        super();
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init2.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init3.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init4.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init5.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init6.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init7.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init8.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init9.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init10.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init11.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init12.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init13.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init14.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init15.call(this);
        $21ba273fabeffbe8$export$f9d4276726476e59.prototype.__init16.call(this);
        this.setTileset(tileset);
    }
    /**
     * @returns The tileset of this tilemap.
     */ getTileset() {
        return this.tileset;
    }
    /**
     * Define the tileset used by the tilemap.
     *
     * @param tileset - The list of textures to use in the tilemap. If a base-texture (not array) is passed, it will
     *  be wrapped into an array. This should not contain any duplicates.
     */ setTileset(tileset = []) {
        if (!Array.isArray(tileset)) tileset = [
            tileset
        ];
        for(let i = 0; i < tileset.length; i++)if (tileset[i].baseTexture) tileset[i] = tileset[i].baseTexture;
        this.tileset = tileset;
        return this;
    }
    /**  Clears all the tiles added into this tilemap. */ clear() {
        this.pointsBuf.length = 0;
        this.modificationMarker = 0;
        this.tilemapBounds.clear();
        this.hasAnimatedTile = false;
        return this;
    }
    /**
     * Adds a tile that paints the given texture at (x, y).
     *
     * @param tileTexture - The tiling texture to render.
     * @param x - The local x-coordinate of the tile's position.
     * @param y - The local y-coordinate of the tile's position.
     * @param options - Additional tile options.
     * @param [options.u=texture.frame.x] - The x-coordinate of the texture in its base-texture's space.
     * @param [options.v=texture.frame.y] - The y-coordinate of the texture in its base-texture's space.
     * @param [options.tileWidth=texture.orig.width] - The local width of the tile.
     * @param [options.tileHeight=texture.orig.height] - The local height of the tile.
     * @param [options.animX=0] - For animated tiles, this is the "offset" along the x-axis for adjacent
     *      animation frame textures in the base-texture.
     * @param [options.animY=0] - For animated tiles, this is the "offset" along the y-axis for adjacent
     *      animation frames textures in the base-texture.
     * @param [options.rotate=0]
     * @param [options.animCountX=1024] - For animated tiles, this is the number of animation frame textures
     *      per row.
     * @param [options.animCountY=1024] - For animated tiles, this is the number of animation frame textures
     *      per column.
     * @param [options.animDivisor=1] - For animated tiles, this is the animation duration of each frame
     * @param [options.alpha=1] - Tile alpha
     * @return This tilemap, good for chaining.
     */ tile(tileTexture, x, y, options = {}) {
        let baseTexture;
        let textureIndex = -1;
        if (typeof tileTexture === 'number') {
            textureIndex = tileTexture;
            baseTexture = this.tileset[textureIndex];
        } else {
            let texture;
            if (typeof tileTexture === 'string') texture = (0, $klOfb.Texture).from(tileTexture);
            else texture = tileTexture;
            const textureList = this.tileset;
            for(let i = 0; i < textureList.length; i++)if (textureList[i] === texture.castToBaseTexture()) {
                textureIndex = i;
                break;
            }
            if ('baseTexture' in texture) {
                options.u = $21ba273fabeffbe8$var$_nullishCoalesce(options.u, ()=>texture.frame.x);
                options.v = $21ba273fabeffbe8$var$_nullishCoalesce(options.v, ()=>texture.frame.y);
                options.tileWidth = $21ba273fabeffbe8$var$_nullishCoalesce(options.tileWidth, ()=>texture.orig.width);
                options.tileHeight = $21ba273fabeffbe8$var$_nullishCoalesce(options.tileHeight, ()=>texture.orig.height);
            }
            baseTexture = texture.castToBaseTexture();
        }
        if (!baseTexture || textureIndex < 0) {
            console.error('The tile texture was not found in the tilemap tileset.');
            return this;
        }
        const { u: u = 0, v: v = 0, tileWidth: tileWidth = baseTexture.realWidth, tileHeight: tileHeight = baseTexture.realHeight, animX: animX = 0, animY: animY = 0, rotate: rotate = 0, animCountX: animCountX = 1024, animCountY: animCountY = 1024, animDivisor: animDivisor = 1, alpha: alpha = 1 } = options;
        const pb = this.pointsBuf;
        this.hasAnimatedTile = this.hasAnimatedTile || animX > 0 || animY > 0;
        pb.push(u);
        pb.push(v);
        pb.push(x);
        pb.push(y);
        pb.push(tileWidth);
        pb.push(tileHeight);
        pb.push(rotate);
        pb.push(animX | 0);
        pb.push(animY | 0);
        pb.push(textureIndex);
        pb.push(animCountX);
        pb.push(animCountY);
        pb.push(animDivisor);
        pb.push(alpha);
        this.tilemapBounds.addFramePad(x, y, x + tileWidth, y + tileHeight, 0, 0);
        return this;
    }
    /** Changes the rotation of the last tile. */ tileRotate(rotate) {
        const pb = this.pointsBuf;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.TEXTURE_INDEX)] = rotate;
    }
    /** Changes the `animX`, `animCountX` of the last tile. */ tileAnimX(offset, count) {
        const pb = this.pointsBuf;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_X)] = offset;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_COUNT_X)] = count;
    // pb[pb.length - (POINT_STRUCT_SIZE - POINT_STRUCT.ANIM_DIVISOR)] = duration;
    }
    /** Changes the `animY`, `animCountY` of the last tile. */ tileAnimY(offset, count) {
        const pb = this.pointsBuf;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_Y)] = offset;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_COUNT_Y)] = count;
    }
    /** Changes the `animDivisor` value of the last tile. */ tileAnimDivisor(divisor) {
        const pb = this.pointsBuf;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_DIVISOR)] = divisor;
    }
    tileAlpha(alpha) {
        const pb = this.pointsBuf;
        pb[pb.length - ($21ba273fabeffbe8$export$1352a974e0a4bb22 - $21ba273fabeffbe8$var$POINT_STRUCT.ALPHA)] = alpha;
    }
    __init11() {
        this.renderCanvas = (renderer)=>{
            const plugin = $21ba273fabeffbe8$export$adc19050884d1e30.getInstance(renderer);
            if (plugin && !plugin.dontUseTransform) {
                const wt = this.worldTransform;
                renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution, wt.ty * renderer.resolution);
            }
            this.renderCanvasCore(renderer);
        };
    }
    renderCanvasCore(renderer) {
        if (this.tileset.length === 0) return;
        const points = this.pointsBuf;
        const tileAnim = this.tileAnim || renderer.plugins.tilemap && renderer.plugins.tilemap.tileAnim;
        renderer.context.fillStyle = '#000000';
        for(let i = 0, n = points.length; i < n; i += $21ba273fabeffbe8$export$1352a974e0a4bb22){
            let x1 = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.U];
            let y1 = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.V];
            const x2 = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.X];
            const y2 = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.Y];
            const w = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.TILE_WIDTH];
            const h = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.TILE_HEIGHT];
            x1 += points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_X] * tileAnim[0];
            y1 += points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_Y] * tileAnim[1];
            const textureIndex = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.TEXTURE_INDEX];
            const alpha = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ALPHA];
            // canvas does not work with rotate yet
            if (textureIndex >= 0 && this.tileset[textureIndex]) {
                renderer.context.globalAlpha = alpha;
                renderer.context.drawImage(this.tileset[textureIndex].getDrawableSource(), x1, y1, w, h, x2, y2, w, h);
            } else {
                renderer.context.globalAlpha = 0.5;
                renderer.context.fillRect(x2, y2, w, h);
            }
            renderer.context.globalAlpha = 1;
        }
    }
    __init12() {
        this.vbId = 0;
    }
    __init13() {
        this.vb = null;
    }
    __init14() {
        this.vbBuffer = null;
    }
    __init15() {
        this.vbArray = null;
    }
    __init16() {
        this.vbInts = null;
    }
    destroyVb() {
        if (this.vb) {
            this.vb.destroy();
            this.vb = null;
        }
    }
    render(renderer) {
        const plugin = renderer.plugins.tilemap;
        const shader = plugin.getShader();
        renderer.batch.setObjectRenderer(plugin);
        this._globalMat = shader.uniforms.projTransMatrix;
        renderer.globalUniforms.uniforms.projectionMatrix.copyTo(this._globalMat).append(this.worldTransform);
        shader.uniforms.shadowColor = this.shadowColor;
        shader.uniforms.animationFrame = this.tileAnim || plugin.tileAnim;
        this.renderWebGLCore(renderer, plugin);
    }
    renderWebGLCore(renderer, plugin) {
        const points = this.pointsBuf;
        if (points.length === 0) return;
        const rectsCount = points.length / $21ba273fabeffbe8$export$1352a974e0a4bb22;
        const shader = plugin.getShader();
        const textures = this.tileset;
        if (textures.length === 0) return;
        plugin.bindTileTextures(renderer, textures);
        renderer.shader.bind(shader, false);
        // lost context! recover!
        let vb = this.vb;
        if (!vb) {
            vb = plugin.createVb();
            this.vb = vb;
            this.vbId = vb.id;
            this.vbBuffer = null;
            this.modificationMarker = 0;
        }
        plugin.checkIndexBuffer(rectsCount, vb);
        const boundCountPerBuffer = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS;
        const vertexBuf = vb.getBuffer('aVertexPosition');
        // if layer was changed, re-upload vertices
        const vertices = rectsCount * vb.vertPerQuad;
        if (vertices === 0) return;
        if (this.modificationMarker !== vertices) {
            this.modificationMarker = vertices;
            const vs = vb.stride * vertices;
            if (!this.vbBuffer || this.vbBuffer.byteLength < vs) {
                // !@#$ happens, need resize
                let bk = vb.stride;
                while(bk < vs)bk *= 2;
                this.vbBuffer = new ArrayBuffer(bk);
                this.vbArray = new Float32Array(this.vbBuffer);
                this.vbInts = new Uint32Array(this.vbBuffer);
                vertexBuf.update(this.vbBuffer);
            }
            const arr = this.vbArray;
            // const ints = this.vbInts;
            // upload vertices!
            let sz = 0;
            // let tint = 0xffffffff;
            let textureId = 0;
            let shiftU = this.offsetX;
            let shiftV = this.offsetY;
            // let tint = 0xffffffff;
            // const tint = -1;
            for(let i = 0; i < points.length; i += $21ba273fabeffbe8$export$1352a974e0a4bb22){
                const eps = 0.5;
                if (this.compositeParent) {
                    const textureIndex = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.TEXTURE_INDEX];
                    if (boundCountPerBuffer > 1) {
                        // TODO: what if its more than 4?
                        textureId = textureIndex >> 2;
                        shiftU = this.offsetX * (textureIndex & 1);
                        shiftV = this.offsetY * (textureIndex >> 1 & 1);
                    } else {
                        textureId = textureIndex;
                        shiftU = 0;
                        shiftV = 0;
                    }
                }
                const x = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.X];
                const y = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.Y];
                const w = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.TILE_WIDTH];
                const h = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.TILE_HEIGHT];
                const u = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.U] + shiftU;
                const v = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.V] + shiftV;
                let rotate = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ROTATE];
                const animX = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_X];
                const animY = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_Y];
                const animWidth = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_COUNT_X] || 1024;
                const animHeight = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_COUNT_Y] || 1024;
                const animXEncoded = animX + animWidth * 2048;
                const animYEncoded = animY + animHeight * 2048;
                const animDivisor = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ANIM_DIVISOR];
                const alpha = points[i + $21ba273fabeffbe8$var$POINT_STRUCT.ALPHA];
                let u0;
                let v0;
                let u1;
                let v1;
                let u2;
                let v2;
                let u3;
                let v3;
                if (rotate === 0) {
                    u0 = u;
                    v0 = v;
                    u1 = u + w;
                    v1 = v;
                    u2 = u + w;
                    v2 = v + h;
                    u3 = u;
                    v3 = v + h;
                } else {
                    let w2 = w / 2;
                    let h2 = h / 2;
                    if (rotate % 4 !== 0) {
                        w2 = h / 2;
                        h2 = w / 2;
                    }
                    const cX = u + w2;
                    const cY = v + h2;
                    rotate = (0, $6qzqq.groupD8).add(rotate, (0, $6qzqq.groupD8).NW);
                    u0 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
                    v0 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
                    rotate = (0, $6qzqq.groupD8).add(rotate, 2); // rotate 90 degrees clockwise
                    u1 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
                    v1 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
                    rotate = (0, $6qzqq.groupD8).add(rotate, 2);
                    u2 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
                    v2 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
                    rotate = (0, $6qzqq.groupD8).add(rotate, 2);
                    u3 = cX + w2 * (0, $6qzqq.groupD8).uX(rotate);
                    v3 = cY + h2 * (0, $6qzqq.groupD8).uY(rotate);
                }
                arr[sz++] = x;
                arr[sz++] = y;
                arr[sz++] = u0;
                arr[sz++] = v0;
                arr[sz++] = u + eps;
                arr[sz++] = v + eps;
                arr[sz++] = u + w - eps;
                arr[sz++] = v + h - eps;
                arr[sz++] = animXEncoded;
                arr[sz++] = animYEncoded;
                arr[sz++] = textureId;
                arr[sz++] = animDivisor;
                arr[sz++] = alpha;
                arr[sz++] = x + w;
                arr[sz++] = y;
                arr[sz++] = u1;
                arr[sz++] = v1;
                arr[sz++] = u + eps;
                arr[sz++] = v + eps;
                arr[sz++] = u + w - eps;
                arr[sz++] = v + h - eps;
                arr[sz++] = animXEncoded;
                arr[sz++] = animYEncoded;
                arr[sz++] = textureId;
                arr[sz++] = animDivisor;
                arr[sz++] = alpha;
                arr[sz++] = x + w;
                arr[sz++] = y + h;
                arr[sz++] = u2;
                arr[sz++] = v2;
                arr[sz++] = u + eps;
                arr[sz++] = v + eps;
                arr[sz++] = u + w - eps;
                arr[sz++] = v + h - eps;
                arr[sz++] = animXEncoded;
                arr[sz++] = animYEncoded;
                arr[sz++] = textureId;
                arr[sz++] = animDivisor;
                arr[sz++] = alpha;
                arr[sz++] = x;
                arr[sz++] = y + h;
                arr[sz++] = u3;
                arr[sz++] = v3;
                arr[sz++] = u + eps;
                arr[sz++] = v + eps;
                arr[sz++] = u + w - eps;
                arr[sz++] = v + h - eps;
                arr[sz++] = animXEncoded;
                arr[sz++] = animYEncoded;
                arr[sz++] = textureId;
                arr[sz++] = animDivisor;
                arr[sz++] = alpha;
            }
            vertexBuf.update(arr);
        }
        renderer.geometry.bind(vb, shader);
        renderer.geometry.draw((0, $P8XPi.DRAW_MODES).TRIANGLES, rectsCount * 6, 0);
    }
    /**
     * @internal
     * @ignore
     */ isModified(anim) {
        if (this.modificationMarker !== this.pointsBuf.length || anim && this.hasAnimatedTile) return true;
        return false;
    }
    /**
     * This will pull forward the modification marker.
     *
     * @internal
     * @ignore
     */ clearModify() {
        this.modificationMarker = this.pointsBuf.length;
    }
    /** @override */ _calculateBounds() {
        const { minX: minX, minY: minY, maxX: maxX, maxY: maxY } = this.tilemapBounds;
        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    }
    /** @override */ getLocalBounds(rect) {
        // we can do a fast local bounds if the sprite has no children!
        if (this.children.length === 0) return this.tilemapBounds.getRectangle(rect);
        return super.getLocalBounds.call(this, rect);
    }
    /** @override */ destroy(options) {
        super.destroy(options);
        this.destroyVb();
    }
    /**
     * Deprecated signature for {@link Tilemap.tile tile}.
     *
     * @deprecated Since @pixi/tilemap 3.
     */ addFrame(texture, x, y, animX, animY) {
        this.tile(texture, x, y, {
            animX: animX,
            animY: animY
        });
        return true;
    }
    /**
     * Deprecated signature for {@link Tilemap.tile tile}.
     *
     * @deprecated Since @pixi/tilemap 3.
     */ // eslint-disable-next-line max-params
    addRect(textureIndex, u, v, x, y, tileWidth, tileHeight, animX = 0, animY = 0, rotate = 0, animCountX = 1024, animCountY = 1024, animDivisor = 1, alpha = 1) {
        return this.tile(textureIndex, x, y, {
            u: u,
            v: v,
            tileWidth: tileWidth,
            tileHeight: tileHeight,
            animX: animX,
            animY: animY,
            rotate: rotate,
            animCountX: animCountX,
            animCountY: animCountY,
            animDivisor: animDivisor,
            alpha: alpha
        });
    }
}
/**
 * A tilemap composite that lazily builds tilesets layered into multiple tilemaps.
 *
 * The composite tileset is the concatenatation of the individual tilesets used in the tilemaps. You can
 * preinitialized it by passing a list of tile textures to the constructor. Otherwise, the composite tilemap
 * is lazily built as you add more tiles with newer tile textures. A new tilemap is created once the last
 * tilemap has reached its limit (as set by {@link CompositeTilemap.texturesPerTilemap texturesPerTilemap}).
 *
 * @example
 * import { Application } from '@pixi/app';
 * import { CompositeTilemap } from '@pixi/tilemap';
 * import { Loader } from '@pixi/loaders';
 *
 * // Setup view & stage.
 * const app = new Application();
 *
 * document.body.appendChild(app.renderer.view);
 * app.stage.interactive = true;
 *
 * // Global reference to the tilemap.
 * let globalTilemap: CompositeTilemap;
 *
 * // Load the tileset spritesheet!
 * Loader.shared.load('atlas.json');
 *
 * // Initialize the tilemap scene when the assets load.
 * Loader.shared.load(function onTilesetLoaded()
 * {
 *      const tilemap = new CompositeTilemap();
 *
 *      // Setup the game level with grass and dungeons!
 *      for (let x = 0; x < 10; x++)
 *      {
 *          for (let y = 0; y < 10; y++)
 *          {
 *              tilemap.tile(
 *                  x % 2 === 0 && (x === y || x + y === 10) ? 'dungeon.png' : 'grass.png',
 *                  x * 100,
 *                  y * 100,
 *              );
 *          }
 *      }
 *
 *      globalTilemap = app.stage.addChild(tilemap);
 * });
 *
 * // Show a bomb at a random location whenever the user clicks!
 * app.stage.on('click', function onClick()
 * {
 *      if (!globalTilemap) return;
 *
 *      const x = Math.floor(Math.random() * 10);
 *      const y = Math.floor(Math.random() * 10);
 *
 *      globalTilemap.tile('bomb.png', x * 100, y * 100);
 * });
 */ class $21ba273fabeffbe8$export$8f858bd4088571f0 extends (0, $8t5Gy.Container) {
    /** The hard limit on the number of tile textures used in each tilemap. */ /**
     * The animation frame vector.
     *
     * Animated tiles have four parameters - `animX`, `animY`, `animCountX`, `animCountY`. The textures
     * of adjacent animation frames are at offset `animX` or `animY` of each other, with `animCountX` per
     * row and `animCountY` per column.
     *
     * The animation frame vector specifies which animation frame texture to use. If the x/y coordinate is
     * larger than the `animCountX` or `animCountY` for a specific tile, the modulus is taken.
     */ __init() {
        this.tileAnim = null;
    }
    /** The last modified tilemap. */ __init2() {
        this.lastModifiedTilemap = null;
    }
    __init3() {
        this.modificationMarker = 0;
    }
    __init4() {
        this.shadowColor = new Float32Array([
            0.0,
            0.0,
            0.0,
            0.5
        ]);
    }
    __init5() {
        this._globalMat = null;
    }
    /**
     * @param tileset - A list of tile base-textures that will be used to eagerly initialized the layered
     *  tilemaps. This is only an performance optimization, and using {@link CompositeTilemap.tile tile}
     *  will work equivalently.
     */ constructor(tileset){
        super();
        $21ba273fabeffbe8$export$8f858bd4088571f0.prototype.__init.call(this);
        $21ba273fabeffbe8$export$8f858bd4088571f0.prototype.__init2.call(this);
        $21ba273fabeffbe8$export$8f858bd4088571f0.prototype.__init3.call(this);
        $21ba273fabeffbe8$export$8f858bd4088571f0.prototype.__init4.call(this);
        $21ba273fabeffbe8$export$8f858bd4088571f0.prototype.__init5.call(this);
        $21ba273fabeffbe8$export$8f858bd4088571f0.prototype.__init6.call(this);
        this.tileset(tileset);
        this.texturesPerTilemap = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTURES_PER_TILEMAP;
    }
    /**
     * This will preinitialize the tilesets of the layered tilemaps.
     *
     * If used after a tilemap has been created (or a tile added), this will overwrite the tile textures of the
     * existing tilemaps. Passing the tileset to the constructor instead is the best practice.
     *
     * @param tileTextures - The list of tile textures that make up the tileset.
     */ tileset(tileTextures) {
        if (!tileTextures) tileTextures = [];
        const texPerChild = this.texturesPerTilemap;
        const len1 = this.children.length;
        const len2 = Math.ceil(tileTextures.length / texPerChild);
        for(let i = 0; i < Math.min(len1, len2); i++)this.children[i].setTileset(tileTextures.slice(i * texPerChild, (i + 1) * texPerChild));
        for(let i = len1; i < len2; i++){
            const tilemap = new $21ba273fabeffbe8$export$f9d4276726476e59(tileTextures.slice(i * texPerChild, (i + 1) * texPerChild));
            tilemap.compositeParent = true;
            tilemap.offsetX = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_DIMEN;
            tilemap.offsetY = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_DIMEN;
            // TODO: Don't use children
            this.addChild(tilemap);
        }
        return this;
    }
    /** Clears the tilemap composite. */ clear() {
        for(let i = 0; i < this.children.length; i++)this.children[i].clear();
        this.modificationMarker = 0;
        return this;
    }
    /** Changes the rotation of the last added tile. */ tileRotate(rotate) {
        if (this.lastModifiedTilemap) this.lastModifiedTilemap.tileRotate(rotate);
        return this;
    }
    /** Changes `animX`, `animCountX` of the last added tile. */ tileAnimX(offset, count) {
        if (this.lastModifiedTilemap) this.lastModifiedTilemap.tileAnimX(offset, count);
        return this;
    }
    /** Changes `animY`, `animCountY` of the last added tile. */ tileAnimY(offset, count) {
        if (this.lastModifiedTilemap) this.lastModifiedTilemap.tileAnimY(offset, count);
        return this;
    }
    /** Changes `tileAnimDivisor` value of the last added tile. */ tileAnimDivisor(divisor) {
        if (this.lastModifiedTilemap) this.lastModifiedTilemap.tileAnimDivisor(divisor);
        return this;
    }
    /**
     * Adds a tile that paints the given tile texture at (x, y).
     *
     * @param tileTexture - The tile texture. You can pass an index into the composite tilemap as well.
     * @param x - The local x-coordinate of the tile's location.
     * @param y - The local y-coordinate of the tile's location.
     * @param options - Additional options to pass to {@link Tilemap.tile}.
     * @param [options.u=texture.frame.x] - The x-coordinate of the texture in its base-texture's space.
     * @param [options.v=texture.frame.y] - The y-coordinate of the texture in its base-texture's space.
     * @param [options.tileWidth=texture.orig.width] - The local width of the tile.
     * @param [options.tileHeight=texture.orig.height] - The local height of the tile.
     * @param [options.animX=0] - For animated tiles, this is the "offset" along the x-axis for adjacent
     *      animation frame textures in the base-texture.
     * @param [options.animY=0] - For animated tiles, this is the "offset" along the y-axis for adjacent
     *      animation frames textures in the base-texture.
     * @param [options.rotate=0]
     * @param [options.animCountX=1024] - For animated tiles, this is the number of animation frame textures
     *      per row.
     * @param [options.animCountY=1024] - For animated tiles, this is the number of animation frame textures
     *      per column.
     * @param [options.animDivisor=1] - For animated tiles, this is the animation duration each frame
     * @param [options.alpha=1] - Tile alpha
     * @return This tilemap, good for chaining.
     */ tile(tileTexture, x, y, options = {}) {
        let tilemap = null;
        const children = this.children;
        this.lastModifiedTilemap = null;
        if (typeof tileTexture === 'number') {
            const childIndex = tileTexture / this.texturesPerTilemap >> 0;
            let tileIndex = 0;
            tilemap = children[childIndex];
            if (!tilemap) {
                tilemap = children[0];
                // Silently fail if the tilemap doesn't exist
                if (!tilemap) return this;
                tileIndex = 0;
            } else tileIndex = tileTexture % this.texturesPerTilemap;
            tilemap.tile(tileIndex, x, y, options);
        } else {
            if (typeof tileTexture === 'string') tileTexture = (0, $klOfb.Texture).from(tileTexture);
            // Probe all tilemaps to find which tileset contains the base-texture.
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                const tex = child.getTileset();
                for(let j = 0; j < tex.length; j++)if (tex[j] === tileTexture.baseTexture) {
                    tilemap = child;
                    break;
                }
                if (tilemap) break;
            }
            // If no tileset contains the base-texture, attempt to add it.
            if (!tilemap) {
                // Probe the tilemaps to find one below capacity. If so, add the texture into that tilemap.
                for(let i = children.length - 1; i >= 0; i--){
                    const child = children[i];
                    if (child.getTileset().length < this.texturesPerTilemap) {
                        tilemap = child;
                        child.getTileset().push(tileTexture.baseTexture);
                        break;
                    }
                }
                // Otherwise, create a new tilemap initialized with that tile texture.
                if (!tilemap) {
                    tilemap = new $21ba273fabeffbe8$export$f9d4276726476e59(tileTexture.baseTexture);
                    tilemap.compositeParent = true;
                    tilemap.offsetX = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_DIMEN;
                    tilemap.offsetY = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_DIMEN;
                    this.addChild(tilemap);
                }
            }
            tilemap.tile(tileTexture, x, y, options);
        }
        this.lastModifiedTilemap = tilemap;
        return this;
    }
    renderCanvas(renderer) {
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
        const tilemapPlugin = $21ba273fabeffbe8$export$adc19050884d1e30.getInstance(renderer);
        if (tilemapPlugin && !tilemapPlugin.dontUseTransform) {
            const wt = this.worldTransform;
            renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution, wt.ty * renderer.resolution);
        }
        const layers = this.children;
        for(let i = 0; i < layers.length; i++){
            const layer = layers[i];
            layer.tileAnim = this.tileAnim;
            layer.renderCanvasCore(renderer);
        }
    }
    render(renderer) {
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) return;
        const plugin = renderer.plugins.tilemap;
        const shader = plugin.getShader();
        renderer.batch.setObjectRenderer(plugin);
        // TODO: dont create new array, please
        this._globalMat = shader.uniforms.projTransMatrix;
        renderer.globalUniforms.uniforms.projectionMatrix.copyTo(this._globalMat).append(this.worldTransform);
        shader.uniforms.shadowColor = this.shadowColor;
        shader.uniforms.animationFrame = this.tileAnim || plugin.tileAnim;
        renderer.shader.bind(shader, false);
        const layers = this.children;
        for(let i = 0; i < layers.length; i++)layers[i].renderWebGLCore(renderer, plugin);
    }
    /**
     * @internal
     * @ignore
     */ isModified(anim) {
        const layers = this.children;
        if (this.modificationMarker !== layers.length) return true;
        for(let i = 0; i < layers.length; i++){
            if (layers[i].isModified(anim)) return true;
        }
        return false;
    }
    /**
     * @internal
     * @ignore
     */ clearModify() {
        const layers = this.children;
        this.modificationMarker = layers.length;
        for(let i = 0; i < layers.length; i++)layers[i].clearModify();
    }
    /**
     * @deprecated Since @pixi/tilemap 3.
     * @see CompositeTilemap.tile
     */ addFrame(texture, x, y, animX, animY, animWidth, animHeight, animDivisor, alpha) {
        return this.tile(texture, x, y, {
            animX: animX,
            animY: animY,
            animCountX: animWidth,
            animCountY: animHeight,
            animDivisor: animDivisor,
            alpha: alpha
        });
    }
    /**
     * @deprecated @pixi/tilemap 3
     * @see CompositeTilemap.tile
     */ // eslint-disable-next-line max-params
    addRect(textureIndex, u, v, x, y, tileWidth, tileHeight, animX, animY, rotate, animWidth, animHeight) {
        const childIndex = textureIndex / this.texturesPerTilemap >> 0;
        const textureId = textureIndex % this.texturesPerTilemap;
        if (this.children[childIndex] && this.children[childIndex].getTileset()) {
            this.lastModifiedTilemap = this.children[childIndex];
            this.lastModifiedTilemap.addRect(textureId, u, v, x, y, tileWidth, tileHeight, animX, animY, rotate, animWidth, animHeight);
        } else this.lastModifiedTilemap = null;
        return this;
    }
    /**
     * Alias for {@link CompositeTilemap.tileset tileset}.
     *
     * @deprecated Since @pixi/tilemap 3.
     */ __init6() {
        this.setBitmaps = this.tileset;
    }
    /**
     * @deprecated Since @pixi/tilemap 3.
     * @readonly
     * @see CompositeTilemap.texturesPerTilemap
     */ get texPerChild() {
        return this.texturesPerTilemap;
    }
}
// For some reason ESLint goes mad with indendation in this file ^&^
/* eslint-disable indent */ /**
 * This texture tiling resource can be used to upload multiple base-textures together.
 *
 * This resource combines multiple base-textures into a "textile". They're laid out in
 * a dual column format, placed in row-order order. The size of each tile is predefined,
 * and defaults to {@link settings.TEXTILE_DIMEN}. This means that each input base-texture
 * must is smaller than that along both its width and height.
 *
 * @see settings.TEXTILE_UNITS
 */ class $21ba273fabeffbe8$export$b40e6bac0476cdd9 extends (0, $klOfb.Resource) {
    /** The base-texture that contains all the texture tiles. */ __init() {
        this.baseTexture = null;
    }
    __init2() {
        this._clearBuffer = null;
    }
    /**
	 * @param options - This will default to the "settings" exported by @pixi/tilemap.
	 * @param options.TEXTILE_DIMEN - The dimensions of each tile.
	 * @param options.TEXTILE_UNITS - The number of texture tiles.
	 */ constructor(options = $21ba273fabeffbe8$export$a5a6e0b888b2c992){
        super(options.TEXTILE_DIMEN * 2, options.TEXTILE_DIMEN * Math.ceil(options.TEXTILE_UNITS / 2));
        $21ba273fabeffbe8$export$b40e6bac0476cdd9.prototype.__init.call(this);
        $21ba273fabeffbe8$export$b40e6bac0476cdd9.prototype.__init2.call(this);
        const tiles = this.tiles = new Array(options.TEXTILE_UNITS);
        this.doClear = !!options.DO_CLEAR;
        this.tileDimen = options.TEXTILE_DIMEN;
        for(let j = 0; j < options.TEXTILE_UNITS; j++)tiles[j] = {
            dirtyId: 0,
            x: options.TEXTILE_DIMEN * (j & 1),
            y: options.TEXTILE_DIMEN * (j >> 1),
            baseTexture: (0, $klOfb.Texture).WHITE.baseTexture
        };
    }
    /**
	 * Sets the texture to be uploaded for the given tile.
	 *
	 * @param index - The index of the tile being set.
	 * @param texture - The texture with the base-texture to upload.
	 */ tile(index, texture) {
        const tile = this.tiles[index];
        if (tile.baseTexture === texture) return;
        tile.baseTexture = texture;
        this.baseTexture.update();
        this.tiles[index].dirtyId = this.baseTexture.dirtyId;
    }
    /** @override */ bind(baseTexture) {
        if (this.baseTexture) throw new Error('Only one baseTexture is allowed for this resource!');
        this.baseTexture = baseTexture;
        super.bind(baseTexture);
    }
    /** @override */ upload(renderer, texture, glTexture) {
        const { gl: gl } = renderer;
        const { width: width, height: height } = this;
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.alphaMode === undefined || texture.alphaMode === (0, $P8XPi.ALPHA_MODES).UNPACK);
        if (glTexture.dirtyId < 0) {
            glTexture.width = width;
            glTexture.height = height;
            gl.texImage2D(texture.target, 0, texture.format, width, height, 0, texture.format, texture.type, null);
        }
        const doClear = this.doClear;
        const tiles = this.tiles;
        if (doClear && !this._clearBuffer) this._clearBuffer = new Uint8Array($21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_DIMEN * $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_DIMEN * 4);
        for(let i = 0; i < tiles.length; i++){
            const spr = tiles[i];
            const tex = spr.baseTexture;
            if (glTexture.dirtyId >= this.tiles[i].dirtyId) continue;
            const res = tex.resource;
            if (!tex.valid || !res || !res.source) continue;
            if (doClear && (tex.width < this.tileDimen || tex.height < this.tileDimen)) gl.texSubImage2D(texture.target, 0, spr.x, spr.y, this.tileDimen, this.tileDimen, texture.format, texture.type, this._clearBuffer);
            gl.texSubImage2D(texture.target, 0, spr.x, spr.y, texture.format, texture.type, res.source);
        }
        return true;
    }
}
/**
 * This will generate fragment shader code that samples the correct texture into the "color" variable.
 *
 * @internal
 * @ignore
 * @param maxTextures - The texture array length in the shader's uniforms.
 */ function $21ba273fabeffbe8$var$generateSampleSrc(maxTextures) {
    let src = '';
    src += '\n';
    src += '\n';
    src += 'if(vTextureId <= -1.0) {';
    src += '\n\tcolor = shadowColor;';
    src += '\n}';
    for(let i = 0; i < maxTextures; i++){
        src += '\nelse ';
        if (i < maxTextures - 1) src += `if(textureId == ${i}.0)`;
        src += '\n{';
        src += `\n\tcolor = texture2D(uSamplers[${i}], textureCoord * uSamplerSize[${i}]);`;
        src += '\n}';
    }
    src += '\n';
    src += '\n';
    return src;
}
/**
 * @internal
 * @ignore
 * @param shader
 * @param maxTextures
 */ function $21ba273fabeffbe8$export$436f73875e9a62fb(shader, maxTextures) {
    const sampleValues = [];
    for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
    shader.uniforms.uSamplers = sampleValues;
    const samplerSize = [];
    for(let i = 0; i < maxTextures; i++){
        // These are overwritten by TileRenderer when textures actually bound.
        samplerSize.push(1.0 / 2048);
        samplerSize.push(1.0 / 2048);
    }
    shader.uniforms.uSamplerSize = samplerSize;
}
/**
 * @internal
 * @ignore
 * @param maxTextures
 * @param fragmentSrc
 * @returns
 */ function $21ba273fabeffbe8$export$2c417c463460549d(maxTextures, fragmentSrc) {
    return fragmentSrc.replace(/%count%/gi, `${maxTextures}`).replace(/%forloop%/gi, $21ba273fabeffbe8$var$generateSampleSrc(maxTextures));
}
// eslint-disable-next-line @typescript-eslint/triple-slash-reference, spaced-comment
const $21ba273fabeffbe8$var$tilemapVertexTemplateSrc = `#version 100
precision highp float;
attribute vec2 aVertexPosition;
attribute vec2 aTextureCoord;
attribute vec4 aFrame;
attribute vec2 aAnim;
attribute float aAnimDivisor;
attribute float aTextureId;
attribute float aAlpha;

uniform mat3 projTransMatrix;
uniform vec2 animationFrame;

varying vec2 vTextureCoord;
varying float vTextureId;
varying vec4 vFrame;
varying float vAlpha;

void main(void)
{
   gl_Position = vec4((projTransMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
   vec2 animCount = floor((aAnim + 0.5) / 2048.0);
   vec2 animFrameOffset = aAnim - animCount * 2048.0;
   vec2 currentFrame = floor(animationFrame / aAnimDivisor);
   vec2 animOffset = animFrameOffset * floor(mod(currentFrame + 0.5, animCount));

   vTextureCoord = aTextureCoord + animOffset;
   vFrame = aFrame + vec4(animOffset, animOffset);
   vTextureId = aTextureId;
   vAlpha = aAlpha;
}
`;
const $21ba273fabeffbe8$var$tilemapFragmentTemplateSrc = `#version 100
#ifdef GL_FRAGMENT_PRECISION_HIGH
precision highp float;
#else
precision mediump float;
#endif
varying vec2 vTextureCoord;
varying vec4 vFrame;
varying float vTextureId;
varying float vAlpha;
uniform vec4 shadowColor;
uniform sampler2D uSamplers[%count%];
uniform vec2 uSamplerSize[%count%];

void main(void)
{
   vec2 textureCoord = clamp(vTextureCoord, vFrame.xy, vFrame.zw);
   float textureId = floor(vTextureId + 0.5);

   vec4 color;
   %forloop%
   gl_FragColor = color * vAlpha;
}
`;
// For some reason ESLint goes mad with indendation in this file ^&^
/* eslint-disable no-mixed-spaces-and-tabs, indent */ class $21ba273fabeffbe8$export$6cd4ea578148e7f0 extends (0, $klOfb.Shader) {
    __init() {
        this.maxTextures = 0;
    }
    constructor(maxTextures){
        super(new (0, $klOfb.Program)($21ba273fabeffbe8$var$tilemapVertexTemplateSrc, $21ba273fabeffbe8$export$2c417c463460549d(maxTextures, $21ba273fabeffbe8$var$tilemapFragmentTemplateSrc)), {
            animationFrame: new Float32Array(2),
            uSamplers: [],
            uSamplerSize: [],
            projTransMatrix: new (0, $6qzqq.Matrix)()
        });
        $21ba273fabeffbe8$export$6cd4ea578148e7f0.prototype.__init.call(this);
        this.maxTextures = maxTextures;
        $21ba273fabeffbe8$export$436f73875e9a62fb(this, this.maxTextures);
    }
}
class $21ba273fabeffbe8$export$102165b99c936142 extends (0, $klOfb.Geometry) {
    __init2() {
        this.vertSize = 13;
    }
    __init3() {
        this.vertPerQuad = 4;
    }
    __init4() {
        this.stride = this.vertSize * 4;
    }
    __init5() {
        this.lastTimeAccess = 0;
    }
    constructor(){
        super();
        $21ba273fabeffbe8$export$102165b99c936142.prototype.__init2.call(this);
        $21ba273fabeffbe8$export$102165b99c936142.prototype.__init3.call(this);
        $21ba273fabeffbe8$export$102165b99c936142.prototype.__init4.call(this);
        $21ba273fabeffbe8$export$102165b99c936142.prototype.__init5.call(this);
        const buf = this.buf = new (0, $klOfb.Buffer)(new Float32Array(2), true, false);
        this.addAttribute('aVertexPosition', buf, 0, false, 0, this.stride, 0).addAttribute('aTextureCoord', buf, 0, false, 0, this.stride, 8).addAttribute('aFrame', buf, 0, false, 0, this.stride, 16).addAttribute('aAnim', buf, 0, false, 0, this.stride, 32).addAttribute('aTextureId', buf, 0, false, 0, this.stride, 40).addAttribute('aAnimDivisor', buf, 0, false, 0, this.stride, 44).addAttribute('aAlpha', buf, 0, false, 0, this.stride, 48);
    }
}
// For some reason ESLint goes mad with indendation in this file ^&^
/* eslint-disable no-mixed-spaces-and-tabs, indent */ /**
 * Rendering helper pipeline for tilemaps. This plugin is registered automatically.
 */ class $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2 extends (0, $klOfb.ObjectRenderer) {
    /** The managing renderer */ /** The tile animation frame */ __init() {
        this.tileAnim = [
            0,
            0
        ];
    }
    __init2() {
        this.ibLen = 0;
    }
    /** The index buffer for the tilemaps to share. */ __init3() {
        this.indexBuffer = null;
    }
    /** The shader used to render tilemaps. */ /**
	 * {@link TextileResource} instances used to upload textures batched in tiled groups. This is
	 * used only if {@link settings.TEXTURES_PER_TILEMAP} is greater than 1.
	 */ __init4() {
        this.textiles = [];
    }
    /** @param renderer - The managing renderer */ constructor(renderer){
        super(renderer);
        $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2.prototype.__init.call(this);
        $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2.prototype.__init2.call(this);
        $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2.prototype.__init3.call(this);
        $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2.prototype.__init4.call(this);
        this.shader = new $21ba273fabeffbe8$export$6cd4ea578148e7f0($21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTURES_PER_TILEMAP);
        this.indexBuffer = new (0, $klOfb.Buffer)(undefined, true, true);
        this.checkIndexBuffer(2000);
        this.makeTextiles();
    }
    /**
	 * Binds the tile textures to the renderer, and updates the tilemap shader's `uSamplerSize` uniform.
	 *
	 * If {@link settings.TEXTILE_UNITS}
	 *
	 * @param renderer - The renderer to which the textures are to be bound.
	 * @param textures - The tile textures being bound.
	 */ bindTileTextures(renderer, textures) {
        const len = textures.length;
        const shader = this.shader;
        const maxTextures = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTURES_PER_TILEMAP;
        const samplerSize = shader.uniforms.uSamplerSize;
        if (len > $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS * maxTextures) // TODO: Show error message instead of silently failing!
        return;
        if ($21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS <= 1) // Bind each texture directly & update samplerSize.
        for(let i = 0; i < textures.length; i++){
            const texture = textures[i];
            if (!texture || !texture.valid) return;
            renderer.texture.bind(textures[i], i);
            samplerSize[i * 2] = 1.0 / textures[i].realWidth;
            samplerSize[i * 2 + 1] = 1.0 / textures[i].realHeight;
        }
        else {
            // Ensure we have enough textiles, in case settings.TEXTILE_UNITS was modified.
            this.makeTextiles();
            const usedTextiles = Math.ceil(len / $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS);
            // First ensure each textile has all tiles point to the right textures.
            for(let i = 0; i < len; i++){
                const texture = textures[i];
                if (texture && texture.valid) {
                    const resourceIndex = Math.floor(i / $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS);
                    const tileIndex = i % $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS;
                    this.textiles[resourceIndex].tile(tileIndex, texture);
                }
            }
            // Then bind the textiles + update samplerSize.
            for(let i = 0; i < usedTextiles; i++){
                renderer.texture.bind(this.textiles[i].baseTexture, i);
                samplerSize[i * 2] = 1.0 / this.textiles[i].width;
                samplerSize[i * 2 + 1] = 1.0 / this.textiles[i].baseTexture.height;
            }
        }
        shader.uniforms.uSamplerSize = samplerSize;
    }
    start() {
    // sorry, nothing
    }
    /**
	 * @internal
	 * @ignore
	 */ createVb() {
        const geom = new $21ba273fabeffbe8$export$102165b99c936142();
        geom.addIndex(this.indexBuffer);
        geom.lastTimeAccess = Date.now();
        return geom;
    }
    /** @return The {@link TilemapShader} shader that this rendering pipeline is using. */ getShader() {
        return this.shader;
    }
    destroy() {
        super.destroy();
        // this.rectShader.destroy();
        this.shader = null;
    }
    checkIndexBuffer(size, _vb = null) {
        const totalIndices = size * 6;
        if (totalIndices <= this.ibLen) return;
        this.ibLen = totalIndices;
        this.indexBuffer.update((0, $csytw.createIndicesForQuads)(size, $21ba273fabeffbe8$export$a5a6e0b888b2c992.use32bitIndex ? new Uint32Array(size * 6) : undefined));
    // 	TODO: create new index buffer instead?
    // if (vb) {
    // 	const curIndex = vb.getIndex();
    // 	if (curIndex !== this.indexBuffer && (curIndex.data as any).length < totalIndices) {
    // 		this.swapIndex(vb, this.indexBuffer);
    // 	}
    // }
    }
    /** Makes textile resources and initializes {@link TileRenderer.textiles}. */ makeTextiles() {
        if ($21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS <= 1) return;
        for(let i = 0; i < $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_UNITS; i++){
            if (this.textiles[i]) continue;
            const resource = new $21ba273fabeffbe8$export$b40e6bac0476cdd9();
            const baseTex = new (0, $klOfb.BaseTexture)(resource);
            baseTex.scaleMode = $21ba273fabeffbe8$export$a5a6e0b888b2c992.TEXTILE_SCALE_MODE;
            baseTex.wrapMode = (0, $P8XPi.WRAP_MODES).CLAMP;
            this.textiles[i] = resource;
        }
    }
}
// eslint-disable-next-line camelcase
const $21ba273fabeffbe8$export$6fd503dcb5b4d46c = {
    CanvasTileRenderer: $21ba273fabeffbe8$export$adc19050884d1e30,
    CompositeRectTileLayer: $21ba273fabeffbe8$export$8f858bd4088571f0,
    CompositeTilemap: $21ba273fabeffbe8$export$8f858bd4088571f0,
    Constant: $21ba273fabeffbe8$export$3c508fb3f8ac1ad4,
    TextileResource: $21ba273fabeffbe8$export$b40e6bac0476cdd9,
    MultiTextureResource: $21ba273fabeffbe8$export$b40e6bac0476cdd9,
    RectTileLayer: $21ba273fabeffbe8$export$f9d4276726476e59,
    Tilemap: $21ba273fabeffbe8$export$f9d4276726476e59,
    TilemapShader: $21ba273fabeffbe8$export$6cd4ea578148e7f0,
    TilemapGeometry: $21ba273fabeffbe8$export$102165b99c936142,
    RectTileShader: $21ba273fabeffbe8$export$6cd4ea578148e7f0,
    RectTileGeom: $21ba273fabeffbe8$export$102165b99c936142,
    TileRenderer: $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2
};
(0, $klOfb.Renderer).registerPlugin('tilemap', $21ba273fabeffbe8$export$ea7c3b5f0dbd1f2);


parcelRequire("1avo5");
var $P8XPi = parcelRequire("P8XPi");
class $6dd6e4a0e941ec0b$export$e9f462800192160c extends (0, $21ba273fabeffbe8$export$8f858bd4088571f0) {
    render(renderer) {
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable || this.isEmpty()) return;
        const filters = this.filters?.filter((filter)=>filter.enabled);
        if (!filters?.length) {
            this.renderTiles(renderer);
            return;
        }
        renderer.batch.flush();
        renderer.filter.push(this, filters);
        this.renderTiles(renderer);
        renderer.batch.flush();
        renderer.filter.pop();
    }
    /** No layer holds a tile (a layer keeps its tiles' vertices in `pointsBuf`, private in its typings). */ isEmpty() {
        return !this.children.some((layer)=>layer.pointsBuf?.length);
    }
    renderTiles(renderer) {
        // Flush what is already batched under its own blend modes before taking over the state.
        renderer.batch.setObjectRenderer(renderer.plugins.tilemap);
        renderer.state.setBlendMode((0, $P8XPi.BLEND_MODES).NORMAL);
        super.render(renderer);
    }
}




parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $gwPoJ = parcelRequire("gwPoJ");
var $8t5Gy = parcelRequire("8t5Gy");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $1avo5 = parcelRequire("1avo5");
var $P8XPi = parcelRequire("P8XPi");

var $5UG8I = parcelRequire("5UG8I");
parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
class $30804d8d8c7ac29a$export$d2b760035f8f14b9 {
    static{
        this.DEFAULT_OUTLINE_CONFIG = {
            thickness: 0.8,
            color: 0x1a1a1a,
            alpha: 0.7,
            enabled: true
        };
    }
    static{
        this.DEFAULT_SCUFF_CONFIG = {
            enabled: true,
            count: 3,
            color: 0xff00ff,
            alpha: 0.8,
            minSize: 0.05,
            maxSize: 0.15,
            roughness: 0.7
        };
    }
    static{
        this.DEFAULT_DENT_CONFIG = {
            enabled: true,
            count: 2,
            color: 0x1a1a1a,
            alpha: 0.4,
            minSize: 0.08,
            maxSize: 0.2,
            depth: 0.6
        };
    }
    static{
        // Make cache persistent across rooms
        this.GLOBAL_DAMAGED_SPRITES_CACHE = new Map();
    }
    static{
        this.maxGlobalCacheSize = 5000 // Global cache size limit
        ;
    }
    static{
        this.cacheHits = 0;
    }
    static{
        this.cacheMisses = 0;
    }
    constructor(roomId, randomNumberGenerator){
        this.outlineConfig = {
            ...$30804d8d8c7ac29a$export$d2b760035f8f14b9.DEFAULT_OUTLINE_CONFIG
        };
        this.scuffConfig = {
            ...$30804d8d8c7ac29a$export$d2b760035f8f14b9.DEFAULT_SCUFF_CONFIG
        };
        this.dentConfig = {
            ...$30804d8d8c7ac29a$export$d2b760035f8f14b9.DEFAULT_DENT_CONFIG
        };
        this.rngCache = new Map();
        // Track intact art separately so repairing can remove damage, including on pooled sprites.
        this.lastDamagedTextures = new WeakMap();
        this.sourceTextures = new WeakMap();
        // Cache original textures by x,y coordinates (room-specific).
        this.originalTexturesByLocation = new Map();
        /**
     * Update the random number generator and room context
     * Only clear room-specific caches, keep global damage cache
     */ this.updateRandomContext = (roomId, randomNumberGenerator)=>{
            this.roomId = roomId;
            this.randomNumberGenerator = randomNumberGenerator;
            this.rngCache.clear();
            this.originalTexturesByLocation.clear() // Clear room-specific texture cache
            ;
        // DON'T clear the global damaged sprites cache - keep it persistent!
        };
        /**
     * Cache original textures by x,y location for incremental damage
     */ this.cacheOriginalTexturesByLocation = (sprites, x, y)=>{
            const locationKey = `${this.roomId}-${x},${y}`;
            // Only cache if not already cached to avoid overwriting
            if (!this.originalTexturesByLocation.has(locationKey)) {
                const originalTextures = sprites.map((sprite)=>sprite.texture);
                this.originalTexturesByLocation.set(locationKey, originalTextures);
            }
        };
        /**
     * Configure hole outline appearance
     */ this.configureHoleOutlines = (config)=>{
            this.outlineConfig = {
                ...this.outlineConfig,
                ...config
            };
        };
        /**
     * Enable or disable hole outlines
     */ this.setHoleOutlinesEnabled = (enabled)=>{
            this.outlineConfig.enabled = enabled;
        };
        /**
     * Get current hole outline configuration
     */ this.getHoleOutlineConfig = ()=>{
            return {
                ...this.outlineConfig
            };
        };
        /**
     * Configure scuff mark appearance
     */ this.configureScuffMarks = (config)=>{
            this.scuffConfig = {
                ...this.scuffConfig,
                ...config
            };
        };
        /**
     * Enable or disable scuff marks
     */ this.setScuffMarksEnabled = (enabled)=>{
            this.scuffConfig.enabled = enabled;
        };
        /**
     * Get current scuff mark configuration
     */ this.getScuffMarkConfig = ()=>{
            return {
                ...this.scuffConfig
            };
        };
        /**
     * Configure dent appearance
     */ this.configureDents = (config)=>{
            this.dentConfig = {
                ...this.dentConfig,
                ...config
            };
        };
        /**
     * Enable or disable dents
     */ this.setDentsEnabled = (enabled)=>{
            this.dentConfig.enabled = enabled;
        };
        /**
     * Get current dent configuration
     */ this.getDentConfig = ()=>{
            return {
                ...this.dentConfig
            };
        };
        /**
     * Normalize damage percentage to nearest 5%
     */ this.normalizeDamagePct = (damagePct)=>{
            return Math.round(damagePct * 20) / 20 // Round to nearest 5%
            ;
        };
        /**
     * Create cache key that's room-agnostic for global cache
     */ this.createGlobalCacheKey = (surfaceObject, normalizedDamagePct)=>{
            // The cached value is the ENTIRE spriteSet, re-applied to sprites by positional index
            // on a hit. So the key must uniquely identify the full per-sprite composition, not just
            // one surface-level tile id. A vertical wall is two sprites (cap + base) that share a
            // single parent -- surfaceObject.tilesetTileId only records the BASE tile, so keying on
            // it alone made every wall with the same base tile collide regardless of its cap or
            // sprite ordering. On a hit, cap and base textures were then stamped by index onto a
            // differently-composed wall, making the base cell render as a cap. Build the key from
            // each sprite's own texture identity, in order, so a collision guarantees an identical
            // composition and the by-index texture copy is always correct.
            const spriteKey = (surfaceObject.spriteSet || []).map((sprite)=>{
                const texture = sprite?.texture;
                if (!texture) return "x";
                const id = texture.textureCacheIds && texture.textureCacheIds.length ? texture.textureCacheIds[0] : `${texture.baseTexture?.uid}`;
                const frame = texture.frame ? `${texture.frame.x},${texture.frame.y},${texture.frame.width},${texture.frame.height}` : "";
                return `${id}:${frame}`;
            }).join("|");
            // Room-agnostic key for global cache
            return `${spriteKey}-${normalizedDamagePct}`;
        };
        /**
     * Generate dynamic holes, scuff marks, and dents on sprites based on damage percentage
     * Now accepts SurfaceObject for better caching and tile identification
     *
     * @param surfaceObject - SurfaceObject containing sprites and tile information
     * @param options - Configuration options including damage percentage and effect configs
     *
     * Example usage:
     * ```typescript
     * const holeEffect = new HoleEffect(roomId, randomNumberGenerator);
     *
     * // Configure scuff marks
     * holeEffect.configureScuffMarks({
     *   enabled: true,
     *   count: 5,
     *   color: 0x333333,
     *   alpha: 0.7,
     *   minSize: 0.08,
     *   maxSize: 0.20,
     *   roughness: 0.8
     * });
     *
     * // Configure dents
     * holeEffect.configureDents({
     *   enabled: true,
     *   count: 3,
     *   color: 0x1a1a1a,
     *   alpha: 0.5,
     *   minSize: 0.10,
     *   maxSize: 0.25,
     *   depth: 0.7
     * });
     *
     * // Apply effects
     * holeEffect.generateDynamicHoles(surfaceObject, {
     *   damagePct: 0.5, // 50% damage
     *   x: 100,
     *   y: 100,
     *   scuffConfig: { count: 4, roughness: 0.9 },
     *   dentConfig: { count: 2, depth: 0.8 }
     * });
     * ```
     */ this.generateDynamicHoles = (surfaceObject, options)=>{
            const { damagePct: damagePct, x: x, y: y, outlineConfig: outlineConfig, scuffConfig: scuffConfig, dentConfig: dentConfig } = options;
            // This can run deferred (a shake's onComplete, or applyDamageVisualizationToExistingTiles after a
            // full rerender). In between, a concurrent full rerender / incremental repaint can have destroyed
            // this surface's sprites -- reading `.x` (generateAndCacheDamagedSprites) or `.texture`
            // (createSpriteCanvas) on a destroyed sprite (transform null) throws. Prune to live sprites in
            // place so the cache key and the per-index texture copy stay consistent, then bail if none remain.
            if (surfaceObject.spriteSet) surfaceObject.spriteSet = surfaceObject.spriteSet.filter((s)=>s && !s.destroyed && s.transform);
            // Sprites are already in correct Y-order from processSurfaceId insertion
            const sprites = surfaceObject.spriteSet;
            if (!sprites || sprites.length === 0) return;
            // Always rebuild holes from the intact artwork. Drawing over already damaged textures
            // can only add holes and cannot heal them as HP rises.
            sprites.forEach((sprite)=>{
                if (!this.sourceTextures.has(sprite) || sprite.texture !== this.lastDamagedTextures.get(sprite) && sprite.texture !== this.sourceTextures.get(sprite)) this.sourceTextures.set(sprite, sprite.texture);
                sprite.texture = this.sourceTextures.get(sprite);
            });
            if (damagePct <= 0) return;
            // Apply configs if provided
            if (outlineConfig) this.configureHoleOutlines(outlineConfig);
            if (scuffConfig) this.configureScuffMarks(scuffConfig);
            if (dentConfig) this.configureDents(dentConfig);
            // Normalize damage to nearest 5%
            const normalizedDamagePct = this.normalizeDamagePct(damagePct);
            // Check global cache first (room-agnostic)
            const globalCacheKey = this.createGlobalCacheKey(surfaceObject, normalizedDamagePct);
            const cachedDamagedSprites = $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.get(globalCacheKey);
            if (cachedDamagedSprites) {
                $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheHits++;
                // Use cached sprites - just copy the textures
                sprites.forEach((sprite, index)=>{
                    if (cachedDamagedSprites[index]) {
                        sprite.texture = cachedDamagedSprites[index].texture;
                        this.lastDamagedTextures.set(sprite, sprite.texture);
                    }
                });
                return;
            }
            $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheMisses++;
            // Generate new damaged sprites and cache them globally
            const damagedSprites = this.generateAndCacheDamagedSprites(surfaceObject, normalizedDamagePct, globalCacheKey);
            // Apply the damaged textures to the input sprites
            sprites.forEach((sprite, index)=>{
                if (damagedSprites[index]) {
                    sprite.texture = damagedSprites[index].texture;
                    this.lastDamagedTextures.set(sprite, sprite.texture);
                }
            });
        };
        /**
     * Generate and cache damaged sprites for global reuse
     */ this.generateAndCacheDamagedSprites = (surfaceObject, normalizedDamagePct, globalCacheKey)=>{
            const sprites = surfaceObject.spriteSet;
            // Create copies of the original sprites for caching
            const damagedSprites = sprites.map((sprite)=>{
                const copy = new (0, $7Bs2Z.Sprite)(sprite.texture);
                copy.x = sprite.x;
                copy.y = sprite.y;
                copy.zIndex = sprite.zIndex;
                return copy;
            });
            // Apply damage effects to the copies using the original incremental method
            this.applyDamageToSprites(damagedSprites, normalizedDamagePct, 0, 0);
            // Cache the damaged sprites globally
            $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.set(globalCacheKey, damagedSprites);
            // Manage cache size
            this.evictOldestGlobalCache();
            return damagedSprites;
        };
        /**
     * Apply damage effects to sprites (extracted from original generateDynamicHoles logic)
     */ this.applyDamageToSprites = (sprites, damagePct, x, y)=>{
            // Apply damage incrementally from 10% to current damage level
            const currentDamageStep = Math.floor(damagePct * 20) / 20 // Round to nearest 5%
            ;
            const maxDamageStep = currentDamageStep;
            // Build ONE canvas per sprite up front. Every hole/scuff/dent for that sprite is drawn
            // onto this single canvas and uploaded as a single texture at the end. This replaces the
            // previous approach that allocated a fresh canvas, ran a full-canvas getImageData()
            // readback (a synchronous GPU->CPU stall) and a Texture.from() upload for EVERY individual
            // mark -- the dominant cost of this path on low-end/integrated GPUs.
            const canvases = sprites.map((sprite)=>this.createSpriteCanvas(sprite));
            // Walk up by 10% damage increments up to current damage
            for(let stepDamage = 0.1; stepDamage <= maxDamageStep; stepDamage += 0.1){
                const stepDamagePct = Math.min(stepDamage, maxDamageStep);
                // Generate holes for this damage step
                const numHoles = Math.floor(stepDamagePct * 8) + 1 // 1-17 holes based on damage
                ;
                // Distribute holes evenly across all sprites in the set
                const holesPerSprite = Math.max(1, Math.floor(numHoles / sprites.length));
                const remainingHoles = numHoles - holesPerSprite * sprites.length;
                for(let spriteIndex = 0; spriteIndex < sprites.length; spriteIndex++){
                    const dc = canvases[spriteIndex];
                    if (!dc) continue;
                    const holesForThisSprite = holesPerSprite + (spriteIndex < remainingHoles ? 1 : 0);
                    // Create holes for this damage step
                    for(let i = 0; i < holesForThisSprite; i++)this.createHoleInSprite(dc, stepDamagePct, x, y, spriteIndex, i);
                    // Add scuff marks and dents for this damage step
                    this.addScuffMarksToSprite(dc, stepDamagePct, x, y, spriteIndex);
                    this.addDentsToSprite(dc, stepDamagePct, x, y, spriteIndex);
                }
            }
            // Upload each modified canvas as a single texture (one GPU upload per sprite).
            sprites.forEach((sprite, index)=>{
                const dc = canvases[index];
                if (dc) sprite.texture = (0, $klOfb.Texture).from(dc.canvas);
            });
        };
        /**
     * Build a scratch canvas seeded with the sprite's original texture. All damage marks for
     * the sprite are drawn onto this one canvas; marks that must stay within the sprite's opaque
     * silhouette use the "source-atop" composite op rather than a per-pixel getImageData mask.
     */ this.createSpriteCanvas = (sprite)=>{
            try {
                const texture = sprite.texture;
                const baseTexture = texture.baseTexture;
                const imageSource = baseTexture.resource?.source;
                if (!imageSource) {
                    console.warn("Cannot access image source for texture manipulation");
                    return null;
                }
                const canvas = document.createElement("canvas");
                canvas.width = texture.width;
                canvas.height = texture.height;
                const ctx = canvas.getContext("2d");
                // Draw the original texture to canvas using the frame coordinates
                const frame = texture.frame;
                ctx.drawImage(imageSource, frame.x, frame.y, frame.width, frame.height, 0, 0, frame.width, frame.height);
                return {
                    canvas: canvas,
                    ctx: ctx,
                    width: frame.width,
                    height: frame.height
                };
            } catch (error) {
                console.warn("Failed to create sprite canvas:", error);
                return null;
            }
        };
        /**
     * Convenience method that matches MapRenderingManager's interface
     * @param surfaceObject - SurfaceObject containing sprites and tile information
     * @param hpPct - Health percentage (0-1, where 1 is full health)
     * @param x - X coordinate for seeded randomness
     * @param y - Y coordinate for seeded randomness
     */ this.generateDynamicHolesFromHp = (surfaceObject, hpPct, x, y)=>{
            const damagePct = 1.0 - hpPct;
            this.generateDynamicHoles(surfaceObject, {
                damagePct: damagePct,
                x: x,
                y: y
            });
        };
        /**
     * Create a single hole in a sprite
     */ this.createHoleInSprite = (dc, damagePct, x, y, spriteIndex, holeIndex)=>{
            // Use texture frame dimensions (not full texture) for hole positioning
            const textureWidth = dc.width;
            const textureHeight = dc.height;
            const holeSize = Math.min(textureWidth, textureHeight) * (0.09 + damagePct * 0.12 // 9-21% of texture size (50% larger holes)
            );
            // Position hole randomly across the frame area, but keep it within bounds
            const maxRadius = Math.min(holeSize, textureWidth, textureHeight) / 2;
            // Use seeded randomness for consistent positioning
            const centerX = this.randomIntBetweenRng(Math.ceil(maxRadius), Math.floor(textureWidth - maxRadius), `hole-center-x-${spriteIndex}-${holeIndex}-${x}-${y}`);
            const centerY = this.randomIntBetweenRng(Math.ceil(maxRadius), Math.floor(textureHeight - maxRadius), `hole-center-y-${spriteIndex}-${holeIndex}-${x}-${y}`);
            const sides = 3 + this.randomIntBetweenRng(0, 5, `hole-sides-${spriteIndex}-${holeIndex}-${x}-${y}`) // 3-5 sides
            ;
            const radius = holeSize * (0.4 + this.randomIntBetweenRng(0, 60, `hole-radius-${spriteIndex}-${holeIndex}-${x}-${y}`) / 100 // 40-100% of hole size
            );
            // Generate polygon points for the hole using seeded randomness
            const points = [];
            for(let j = 0; j < sides; j++){
                // Use seeded randomness for angles and radii
                const baseAngle = j / sides * Math.PI * 2;
                const angleVariation = this.randomIntBetweenRng(-50, 50, `hole-angle-${spriteIndex}-${holeIndex}-${j}-${x}-${y}`) / 100 * Math.PI;
                const angle = baseAngle + angleVariation;
                const pointRadius = radius * (0.5 + this.randomIntBetweenRng(0, 50, `hole-point-radius-${spriteIndex}-${holeIndex}-${j}-${x}-${y}`) / 100 // 50-100% of radius
                );
                const pointX = Math.max(0, Math.min(textureWidth - 1, centerX + Math.cos(angle) * pointRadius));
                const pointY = Math.max(0, Math.min(textureHeight - 1, centerY + Math.sin(angle) * pointRadius));
                points.push(pointX, pointY);
            }
            // Cut the hole into the shared canvas (also draws the outline)
            this.cutHoleOnCtx(dc.ctx, points);
        };
        /**
     * Add scuff marks to a sprite
     */ this.addScuffMarksToSprite = (dc, damagePct, x, y, spriteIndex)=>{
            if (!this.scuffConfig.enabled) return;
            // Calculate number of scuffs based on damage
            const scuffCount = Math.floor(this.scuffConfig.count * (0.5 + damagePct * 0.5)) // 50-100% of base count
            ;
            for(let i = 0; i < scuffCount; i++)this.createScuffMarkInSprite(dc, damagePct, x, y, spriteIndex, i);
        };
        /**
     * Create a single scuff mark in a sprite
     */ this.createScuffMarkInSprite = (dc, damagePct, x, y, spriteIndex, scuffIndex)=>{
            const textureWidth = dc.width;
            const textureHeight = dc.height;
            // Calculate scuff size based on damage and config
            const baseSize = textureWidth * (this.scuffConfig.minSize + damagePct * (this.scuffConfig.maxSize - this.scuffConfig.minSize));
            const scuffSize = baseSize * (0.8 + this.randomIntBetweenRng(0, 40, `scuff-size-${spriteIndex}-${scuffIndex}-${x}-${y}`) / 100 // 80-120% of base size
            );
            // Position scuff randomly across the frame area
            const maxRadius = scuffSize / 2;
            const centerX = this.randomIntBetweenRng(Math.ceil(maxRadius), Math.floor(textureWidth - maxRadius), `scuff-center-x-${spriteIndex}-${scuffIndex}-${x}-${y}`);
            const centerY = this.randomIntBetweenRng(Math.ceil(maxRadius), Math.floor(textureHeight - maxRadius), `scuff-center-y-${spriteIndex}-${scuffIndex}-${x}-${y}`);
            // Generate scuff as radial crack pattern with more randomness
            const crackRadius = scuffSize * (0.3 + this.randomIntBetweenRng(0, 40, `crack-radius-${spriteIndex}-${scuffIndex}-${x}-${y}`) / 100 // 30-70% of scuff size
            );
            const crackCount = 3 + this.randomIntBetweenRng(0, 4, `crack-count-${spriteIndex}-${scuffIndex}-${x}-${y}`) // 3-7 cracks
            ;
            // Draw scuff mark onto the shared canvas
            this.drawScuffMarkOnCtx(dc.ctx, centerX, centerY, crackRadius, crackCount, spriteIndex, scuffIndex, x, y);
        };
        /**
     * Add dents to a sprite
     */ this.addDentsToSprite = (dc, damagePct, x, y, spriteIndex)=>{
            if (!this.dentConfig.enabled) return;
            // Calculate number of dents based on damage
            const dentCount = Math.floor(this.dentConfig.count * (0.3 + damagePct * 0.7)) // 30-100% of base count
            ;
            for(let i = 0; i < dentCount; i++)this.createDentInSprite(dc, damagePct, x, y, spriteIndex, i);
        };
        /**
     * Create a single dent in a sprite
     */ this.createDentInSprite = (dc, damagePct, x, y, spriteIndex, dentIndex)=>{
            const textureWidth = dc.width;
            const textureHeight = dc.height;
            // Calculate dent size based on damage and config
            const baseSize = textureWidth * (this.dentConfig.minSize + damagePct * (this.dentConfig.maxSize - this.dentConfig.minSize));
            const dentSize = baseSize * (0.7 + this.randomIntBetweenRng(0, 60, `dent-size-${spriteIndex}-${dentIndex}-${x}-${y}`) / 100 // 70-130% of base size
            );
            // Position dent randomly across the frame area
            const maxRadius = dentSize / 2;
            const centerX = this.randomIntBetweenRng(Math.ceil(maxRadius), Math.floor(textureWidth - maxRadius), `dent-center-x-${spriteIndex}-${dentIndex}-${x}-${y}`);
            const centerY = this.randomIntBetweenRng(Math.ceil(maxRadius), Math.floor(textureHeight - maxRadius), `dent-center-y-${spriteIndex}-${dentIndex}-${x}-${y}`);
            // Generate dent shape (oval with shadow effect)
            const points = this.generateDentShape(centerX, centerY, dentSize, spriteIndex, dentIndex, x, y, textureWidth, textureHeight);
            // Draw dent onto the shared canvas
            this.drawDentOnCtx(dc.ctx, points, centerX, centerY, dentSize);
        };
        /**
     * Generate dent shape points (oval)
     */ this.generateDentShape = (centerX, centerY, size, spriteIndex, dentIndex, x, y, textureWidth, textureHeight)=>{
            const points = [];
            const segments = 16;
            const radiusX = size * 0.4 // 40% of size for width
            ;
            const radiusY = size * 0.3 // 30% of size for height
            ;
            // Generate oval points
            for(let i = 0; i <= segments; i++){
                const angle = i / segments * Math.PI * 2;
                const pointX = centerX + Math.cos(angle) * radiusX;
                const pointY = centerY + Math.sin(angle) * radiusY;
                points.push(Math.max(0, Math.min(textureWidth - 1, pointX)), Math.max(0, Math.min(textureHeight - 1, pointY)));
            }
            return points;
        };
        /**
     * Cut a hole into the shared canvas and stroke its outline.
     *
     * The outline is drawn with the "source-atop" composite op so it only lands on pixels that
     * are still opaque -- this reproduces the old "mask the outline by the sprite's alpha" result
     * without the getImageData/putImageData readback + per-pixel JS loop it used to require.
     */ this.cutHoleOnCtx = (ctx, holePoints)=>{
            try {
                const buildPath = ()=>{
                    ctx.beginPath();
                    ctx.moveTo(holePoints[0], holePoints[1]);
                    for(let i = 2; i < holePoints.length; i += 2)ctx.lineTo(holePoints[i], holePoints[i + 1]);
                    ctx.closePath();
                };
                // Cut out the hole.
                ctx.save();
                ctx.globalCompositeOperation = "destination-out";
                buildPath();
                ctx.fill();
                ctx.restore();
                // Draw the outline, clipped to the remaining opaque silhouette.
                if (this.outlineConfig.enabled) {
                    ctx.save();
                    ctx.globalCompositeOperation = "source-atop";
                    ctx.strokeStyle = `rgba(${this.getColorComponents(this.outlineConfig.color)}, ${this.outlineConfig.alpha})`;
                    ctx.lineWidth = this.outlineConfig.thickness;
                    ctx.lineCap = "round";
                    ctx.lineJoin = "round";
                    buildPath();
                    ctx.stroke();
                    ctx.restore();
                }
            } catch (error) {
                console.warn("Failed to cut hole on canvas:", error);
            }
        };
        /**
     * Draw a scuff mark (radial cracks) directly onto the shared canvas.
     *
     * Uses "source-atop" so the cracks are clipped to the sprite's opaque silhouette -- the same
     * result the old per-pixel alpha mask produced, minus the getImageData readback + temp canvas.
     */ this.drawScuffMarkOnCtx = (ctx, centerX, centerY, crackRadius, crackCount, spriteIndex, scuffIndex, x, y)=>{
            try {
                ctx.save();
                ctx.globalCompositeOperation = "source-atop";
                ctx.strokeStyle = `rgba(${this.getColorComponents(this.scuffConfig.color)}, ${this.scuffConfig.alpha})`;
                ctx.lineWidth = 1.5;
                ctx.lineCap = "round";
                ctx.lineJoin = "round";
                // Draw radial cracks from center point
                for(let i = 0; i < crackCount; i++){
                    // Calculate angle for this crack with more randomness
                    const baseAngle = i / crackCount * Math.PI * 2;
                    // Add more randomness to the angle using seeded RNG instead of Date.now()
                    const angleVariation = this.randomIntBetweenRng(-60, 60, `crack-angle-${spriteIndex}-${scuffIndex}-${i}-${x}-${y}`) / 100 * Math.PI;
                    const angle = baseAngle + angleVariation;
                    // Calculate crack length (with more variation) using seeded RNG instead of Date.now()
                    const crackLength = crackRadius * (0.4 + this.randomIntBetweenRng(0, 120, `crack-length-${spriteIndex}-${scuffIndex}-${i}-${x}-${y}`) / 100 // 40-160% of radius
                    );
                    // Calculate end point
                    const endX = centerX + Math.cos(angle) * crackLength;
                    const endY = centerY + Math.sin(angle) * crackLength;
                    // Draw the crack line
                    ctx.beginPath();
                    ctx.moveTo(centerX, centerY);
                    ctx.lineTo(endX, endY);
                    ctx.stroke();
                }
                ctx.restore();
            } catch (error) {
                console.warn("Failed to draw scuff mark on canvas:", error);
            }
        };
        /**
     * Draw a dent (radial shadow gradient + subtle outline) directly onto the shared canvas.
     *
     * Uses "source-atop" so the dent is clipped to the sprite's opaque silhouette -- the same
     * result the old per-pixel alpha mask produced, minus the getImageData readback + temp canvas.
     */ this.drawDentOnCtx = (ctx, dentPoints, centerX, centerY, dentSize)=>{
            try {
                ctx.save();
                ctx.globalCompositeOperation = "source-atop";
                // Create shadow gradient for dent effect
                const gradient = ctx.createRadialGradient(centerX - dentSize * 0.1, centerY - dentSize * 0.1, 0, centerX, centerY, dentSize * 0.5);
                gradient.addColorStop(0, `rgba(${this.getColorComponents(this.dentConfig.color)}, ${this.dentConfig.alpha * this.dentConfig.depth})`);
                gradient.addColorStop(1, `rgba(${this.getColorComponents(this.dentConfig.color)}, 0)`);
                // Build the dent path once, reused for fill + stroke
                ctx.beginPath();
                ctx.moveTo(dentPoints[0], dentPoints[1]);
                for(let i = 2; i < dentPoints.length; i += 2)ctx.lineTo(dentPoints[i], dentPoints[i + 1]);
                ctx.closePath();
                // Draw the dent shadow
                ctx.fillStyle = gradient;
                ctx.fill();
                // Add a subtle outline
                ctx.strokeStyle = `rgba(${this.getColorComponents(this.dentConfig.color)}, ${this.dentConfig.alpha * 0.8})`;
                ctx.lineWidth = 1;
                ctx.lineCap = "round";
                ctx.lineJoin = "round";
                ctx.stroke();
                ctx.restore();
            } catch (error) {
                console.warn("Failed to draw dent on canvas:", error);
            }
        };
        /**
     * Convert color number to RGB components string
     */ this.getColorComponents = (color)=>{
            const r = color >> 16 & 0xff;
            const g = color >> 8 & 0xff;
            const b = color & 0xff;
            return `${r}, ${g}, ${b}`;
        };
        /**
     * Generate random integer between min and max using seeded randomness
     * This matches the exact same format as MapRenderingManager.randomIntBetweenRng
     */ this.randomIntBetweenRng = (min, max, seed)=>{
            let randomFloat;
            if (!seed) randomFloat = this.randomNumberGenerator ? this.randomNumberGenerator() : Math.random();
            else {
                const toUse = `${seed}-${min}-${max}-${this.roomId}`;
                randomFloat = this.rngCache.get(toUse);
                if (randomFloat === undefined) {
                    randomFloat = this.randomNumberGenerator ? this.randomNumberGenerator() : Math.random();
                    this.rngCache.set(toUse, randomFloat);
                }
            }
            return Math.floor(randomFloat * (max - min + 1) + min);
        };
        /**
     * Evict oldest entries from global cache when it gets too large
     */ this.evictOldestGlobalCache = ()=>{
            if ($30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.size > $30804d8d8c7ac29a$export$d2b760035f8f14b9.maxGlobalCacheSize) {
                // Remove oldest entries (Map maintains insertion order)
                const entriesToRemove = $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.size - $30804d8d8c7ac29a$export$d2b760035f8f14b9.maxGlobalCacheSize;
                const keysToRemove = Array.from($30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.keys()).slice(0, entriesToRemove);
                keysToRemove.forEach((key)=>{
                    const sprites = $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.get(key);
                    if (sprites) sprites.forEach((sprite)=>sprite.destroy());
                    $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.delete(key);
                });
            }
        };
        this.roomId = roomId;
        this.randomNumberGenerator = randomNumberGenerator;
    }
    /**
     * Flush the texture cache (useful when full map rerender starts)
     */ flushCache() {
        this.originalTexturesByLocation.clear();
    }
    static{
        /**
     * Get cache statistics
     */ this.getCacheStats = ()=>{
            const total = $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheHits + $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheMisses;
            return {
                hits: $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheHits,
                misses: $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheMisses,
                size: $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.size,
                hitRate: total > 0 ? $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheHits / total : 0
            };
        };
    }
    static{
        /**
     * Clear global cache (useful for memory management or testing)
     */ this.clearGlobalCache = ()=>{
            $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.forEach((sprites)=>{
                sprites.forEach((sprite)=>sprite.destroy());
            });
            $30804d8d8c7ac29a$export$d2b760035f8f14b9.GLOBAL_DAMAGED_SPRITES_CACHE.clear();
            $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheHits = 0;
            $30804d8d8c7ac29a$export$d2b760035f8f14b9.cacheMisses = 0;
        };
    }
    /**
     * Clean up resources (only clear room-specific caches)
     */ destroy() {
        this.rngCache.clear();
        this.originalTexturesByLocation.clear();
    // DON'T clear global cache - it's shared across instances
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

const $a5455a642b85f08d$export$a28c4ec3b4f79a47 = (provider, x, y)=>{
    const tile = provider.resolveTileMapFromLayerId("map2")?.[x]?.[y];
    return !!tile && tile !== "0" && !provider.isHiddenTile(tile) && !provider.isFloorOpeningAt(x, y) && !provider.isStairAt(x, y);
};
function $a5455a642b85f08d$export$64d9e22c5bb83118(provider) {
    if (!(provider.twoStoreyHouse?.floor > 0)) return [];
    const markers = provider.resolveTileMapFromLayerId("sprite2");
    const edges = [];
    const neighbors = [
        [
            "north",
            0,
            -1
        ],
        [
            "east",
            1,
            0
        ],
        [
            "south",
            0,
            1
        ],
        [
            "west",
            -1,
            0
        ]
    ];
    markers?.forEach((column, x)=>column?.forEach((marker, y)=>{
            if (!marker || marker === "0" || !provider.isFloorOpeningAt(x, y)) return;
            for (const [side, dx, dy] of neighbors)if ($a5455a642b85f08d$export$a28c4ec3b4f79a47(provider, x + dx, y + dy)) edges.push({
                x: x,
                y: y,
                side: side
            });
        }));
    return edges;
}
class $a5455a642b85f08d$export$973d0f1d5c4c8122 extends (0, $gwPoJ.Graphics) {
    constructor(){
        super(), this.floorAt = ()=>false;
        this.interactive = false;
        // Tilemaps draw at zero, stairs and bodies above this ground decoration.
        this.zIndex = 0.5;
    }
    sync(provider) {
        const version = provider && `${provider.getPresentationVersion()}:${provider.twoStoreyHouse?.floor}`;
        if (this.provider === provider && this.version === version) return;
        this.provider = provider;
        this.version = version;
        this.clear();
        const edges = provider ? $a5455a642b85f08d$export$64d9e22c5bb83118(provider) : [];
        this.visible = edges.length > 0;
        this.floorAt = (x, y)=>!!provider && $a5455a642b85f08d$export$a28c4ec3b4f79a47(provider, x, y);
        // Two bands of ambient shade, independent of directional building shadows.
        for (const edge of edges){
            this.band(edge, edge.side === "north" ? 7 : 4, 0x171410, 0.12);
            this.band(edge, edge.side === "north" ? 5 : 2, 0x171410, 0.18);
        }
        // Looking down exposes the face of the floor along the far (north) edge.
        for (const edge of edges)if (edge.side === "north") this.band(edge, 3, 0x4a4037, 0.95);
        for (const edge of edges)this.band(edge, 1, 0x171410, 0.88);
    }
    /** Shade the floor face next to the opening, never the empty opening or a transparent tile margin. */ band(edge, depth, color, alpha) {
        const dx = edge.side === "east" ? 1 : edge.side === "west" ? -1 : 0;
        const dy = edge.side === "south" ? 1 : edge.side === "north" ? -1 : 0;
        const rects = (0, $af4c175a7e8f40ad$export$7e53b5197744fc5d)(edge.x + dx, edge.y + dy, this.floorAt);
        const face = edge.side === "north" ? Math.max(...rects.map((rect)=>rect.y1)) : edge.side === "south" ? Math.min(...rects.map((rect)=>rect.y0)) : edge.side === "east" ? Math.min(...rects.map((rect)=>rect.x0)) : Math.max(...rects.map((rect)=>rect.x1));
        this.beginFill(color, alpha);
        for (const rect of rects){
            const width = rect.x1 - rect.x0, height = rect.y1 - rect.y0;
            if (edge.side === "north" && rect.y1 === face) {
                const inset = Math.min(depth, height);
                this.drawRect(rect.x0, rect.y1 - inset, width, inset);
            } else if (edge.side === "south" && rect.y0 === face) this.drawRect(rect.x0, rect.y0, width, Math.min(depth, height));
            else if (edge.side === "east" && rect.x0 === face) this.drawRect(rect.x0, rect.y0, Math.min(depth, width), height);
            else if (edge.side === "west" && rect.x1 === face) {
                const inset = Math.min(depth, width);
                this.drawRect(rect.x1 - inset, rect.y0, inset, height);
            }
        }
        this.endFill();
    }
}




parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");





parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");
var $P8XPi = parcelRequire("P8XPi");
var $8t5Gy = parcelRequire("8t5Gy");

parcelRequire("1avo5");
var $csytw = parcelRequire("csytw");
var $1avo5 = parcelRequire("1avo5");
var $P8XPi = parcelRequire("P8XPi");
var $3YyWq = parcelRequire("3YyWq");

const $cb0c2ff63ebff87f$export$15a69dcd528d8816 = 260;
/** A blend mode id of our own: each channel the larger of what is there and what lands (registered below). */ const $cb0c2ff63ebff87f$var$MAX_BLEND = 64;
let $cb0c2ff63ebff87f$var$maxBlendReady;
/**
 * The darker-of-two blend, registered once; undefined where WebGL offers no MAX. It must be known in two
 * places: the renderer's table of GL blend functions, and pixi's premultiplied-alpha table, which every
 * batched sprite's mode is looked up through first -- missing there, a sprite asked the renderer for an
 * undefined mode, the batch threw mid-flush, and every frame after it failed.
 */ const $cb0c2ff63ebff87f$var$maxBlend = ()=>{
    const renderer = (0, $065c5647ab3ff4dc$export$90e89a86e46f5ae3)()?.renderer;
    const gl = renderer?.gl;
    if ($cb0c2ff63ebff87f$var$maxBlendReady === undefined) {
        const max = !gl ? undefined : renderer.context?.webGLVersion === 2 ? gl.MAX : gl.getExtension("EXT_blend_minmax")?.MAX_EXT;
        $cb0c2ff63ebff87f$var$maxBlendReady = max !== undefined && !!renderer?.state?.blendModes && !!(0, $csytw).premultiplyBlendMode?.[0] && !!(0, $csytw).premultiplyBlendMode?.[1];
        if ($cb0c2ff63ebff87f$var$maxBlendReady) {
            renderer.state.blendModes[$cb0c2ff63ebff87f$var$MAX_BLEND] = [
                gl.ONE,
                gl.ONE,
                gl.ONE,
                gl.ONE,
                max,
                max
            ];
            (0, $csytw).premultiplyBlendMode[0][$cb0c2ff63ebff87f$var$MAX_BLEND] = $cb0c2ff63ebff87f$var$MAX_BLEND;
            (0, $csytw).premultiplyBlendMode[1][$cb0c2ff63ebff87f$var$MAX_BLEND] = $cb0c2ff63ebff87f$var$MAX_BLEND;
        }
    }
    // A lost and restored context rebuilds the renderer's table: never hand out a mode it no longer knows.
    return $cb0c2ff63ebff87f$var$maxBlendReady && renderer?.state?.blendModes?.[$cb0c2ff63ebff87f$var$MAX_BLEND] ? $cb0c2ff63ebff87f$var$MAX_BLEND : undefined;
};
class $cb0c2ff63ebff87f$export$316a7d97d9517d7b {
    constructor(layer){
        this.layer = layer;
        this.groups = [];
        this.pending = new Set();
        this.retiring = [];
        this.tick = ()=>{
            const fade = this.fade;
            if (!fade) return;
            const t = Math.min(1, (performance.now() - fade.start) / $cb0c2ff63ebff87f$export$15a69dcd528d8816);
            const eased = t * t * (3 - 2 * t);
            if (fade.phase === "in") {
                fade.arriving.forEach((graphics)=>{
                    if (!graphics.destroyed) graphics.alpha = eased;
                });
                if (t < 1) return;
                if (!fade.leaving.length) {
                    this.finishFade();
                    return;
                }
                fade.phase = "out";
                fade.start = performance.now();
                this.leaveOnTop();
                return;
            }
            fade.leaving.forEach((graphics)=>{
                if (!graphics.destroyed) graphics.alpha = 1 - eased;
            });
            if (t >= 1) this.finishFade();
        };
    }
    /**
     * Replace the groups with `next`: those in it already kept their place; `fresh` (also in it) are new,
     * added hidden and softened here. Groups no longer wanted go now if never shown, else at the swap.
     */ replace(next, fresh) {
        this.finishFade();
        const wanted = new Set(next.map((group)=>group.graphics));
        this.groups.forEach(({ graphics: graphics })=>{
            if (wanted.has(graphics)) return;
            if (this.pending.delete(graphics)) this.discard(graphics);
            else this.retiring.push(graphics);
        });
        this.groups = next;
        fresh.forEach((graphics)=>{
            graphics.visible = false;
            this.pending.add(graphics);
            this.layer.addChild(graphics);
        });
        fresh.forEach((graphics)=>graphics.soften(()=>{
                if (!this.pending.delete(graphics)) return;
                if (!this.pending.size) this.swap();
            }));
        if (!this.pending.size) this.swap();
    }
    /** Whether a fade is running (for tests). */ get fading() {
        return !!this.fade;
    }
    swap() {
        const arriving = this.groups.map((group)=>group.graphics).filter((graphics)=>!graphics.visible);
        const leaving = this.retiring;
        this.retiring = [];
        // Headless (no renderer, no frames to fade over): swap at once.
        if (!(0, $065c5647ab3ff4dc$export$90e89a86e46f5ae3)() || typeof requestAnimationFrame === "undefined" || !arriving.length && !leaving.length) {
            arriving.forEach((graphics)=>{
                graphics.visible = true;
            });
            leaving.forEach((graphics)=>this.discard(graphics));
            return;
        }
        this.buffer ??= Object.assign(new (0, $1avo5.filters).AlphaFilter(1), {
            blendMode: (0, $P8XPi.BLEND_MODES).MULTIPLY
        });
        this.layer.filters = [
            this.buffer
        ];
        const landing = $cb0c2ff63ebff87f$var$maxBlend() ?? (0, $P8XPi.BLEND_MODES).NORMAL;
        this.groups.forEach(({ graphics: graphics })=>graphics.setLanding(landing));
        leaving.forEach((graphics)=>graphics.setLanding(landing));
        arriving.forEach((graphics)=>{
            graphics.visible = true;
            graphics.alpha = 0;
        });
        // The old under the new while the new fades in.
        leaving.forEach((graphics)=>this.layer.addChildAt(graphics, 0));
        this.fade = {
            arriving: arriving,
            leaving: leaving,
            phase: arriving.length ? "in" : "out",
            start: performance.now()
        };
        if (this.fade.phase === "out") this.leaveOnTop();
        (0, $3YyWq.Ticker).shared.add(this.tick);
    }
    leaveOnTop() {
        this.fade.arriving.forEach((graphics)=>{
            graphics.alpha = 1;
        });
        // The old over the new while it fades out.
        this.fade.leaving.forEach((graphics)=>this.layer.addChild(graphics));
    }
    /** Ends a fade where it would end: the new at full, the old gone, the layer multiplied group by group again. */ finishFade() {
        const fade = this.fade;
        if (!fade) return;
        this.fade = undefined;
        (0, $3YyWq.Ticker).shared.remove(this.tick);
        fade.arriving.forEach((graphics)=>{
            if (!graphics.destroyed) graphics.alpha = 1;
        });
        fade.leaving.forEach((graphics)=>this.discard(graphics));
        this.layer.filters = null;
        this.groups.forEach(({ graphics: graphics })=>{
            if (!graphics.destroyed) graphics.setLanding();
        });
    }
    discard(graphics) {
        if (graphics.destroyed) return;
        graphics.parent?.removeChild(graphics);
        graphics.destroy();
    }
    clear() {
        this.finishFade();
        this.groups.forEach(({ graphics: graphics })=>this.discard(graphics));
        this.retiring.forEach((graphics)=>this.discard(graphics));
        this.groups = [];
        this.retiring = [];
        this.pending.clear();
        this.buffer?.destroy();
        this.buffer = undefined;
    }
}



const $126d618cffb761ba$var$BUDGET_GPU = /swiftshader|llvmpipe|software|microsoft basic|intel|mali|adreno|powervr|apple gpu|videocore|tegra/i;
const $126d618cffb761ba$export$28c5b8a09a290b66 = ({ gpu: gpu, memoryGb: memoryGb, cores: cores, maxTextureSize: maxTextureSize, mobile: mobile })=>{
    if (mobile) return "budget";
    if (gpu && $126d618cffb761ba$var$BUDGET_GPU.test(gpu)) return "budget";
    if (memoryGb !== undefined && memoryGb <= 4) return "budget";
    if (cores !== undefined && cores <= 4) return "budget";
    if (maxTextureSize !== undefined && maxTextureSize < 8192) return "budget";
    return "full";
};
const $126d618cffb761ba$var$readSignals = ()=>{
    if (typeof navigator === "undefined") return undefined;
    const gl = (0, $065c5647ab3ff4dc$export$90e89a86e46f5ae3)()?.renderer?.gl;
    if (!gl) return undefined;
    let gpu;
    try {
        const info = gl.getExtension("WEBGL_debug_renderer_info");
        gpu = String(gl.getParameter(info ? info.UNMASKED_RENDERER_WEBGL : gl.RENDERER) ?? "");
    } catch  {
        gpu = undefined;
    }
    const nav = navigator;
    return {
        gpu: gpu,
        memoryGb: typeof nav.deviceMemory === "number" ? nav.deviceMemory : undefined,
        cores: typeof nav.hardwareConcurrency === "number" ? nav.hardwareConcurrency : undefined,
        maxTextureSize: gl.getParameter(gl.MAX_TEXTURE_SIZE),
        mobile: /iphone|ipad|ipod|android/i.test(nav.userAgent ?? "") || nav.maxTouchPoints > 1 && /macintosh/i.test(nav.userAgent ?? "")
    };
};
let $126d618cffb761ba$var$detected;
const $126d618cffb761ba$export$28b76cdd32bcb4c6 = ()=>{
    const w = typeof window === "undefined" ? undefined : window;
    if (w?.graphicsTier === "budget" || w?.graphicsTier === "full") return w.graphicsTier;
    if (!$126d618cffb761ba$var$detected) {
        const signals = $126d618cffb761ba$var$readSignals();
        if (!signals) return "full";
        $126d618cffb761ba$var$detected = {
            tier: $126d618cffb761ba$export$28c5b8a09a290b66(signals),
            signals: signals
        };
        if (w) w.deviceTierSignals = {
            ...signals,
            tier: $126d618cffb761ba$var$detected.tier
        };
    }
    return $126d618cffb761ba$var$detected.tier;
};
const $126d618cffb761ba$export$bcea76f852eb0b92 = ()=>$126d618cffb761ba$export$28b76cdd32bcb4c6() === "budget" ? 0.5 : 1;





const $ff5e8e678ac263ca$export$f4641cf88636a32d = {
    enabled: true,
    alpha: 1,
    color: 0x727a91,
    indoors: false,
    softness: 1.25,
    /** Contact shade (castContactShadows): strength, what it multiplies by, its reach past a footprint, its blur. */ contact: 1,
    contactColor: 0x84848f,
    contactReach: 4,
    contactSoftness: 4,
    /** What a wall's south face, turned from the sun, multiplies its colours by at full strength. */ faces: 0xbdc4db,
    /** The walls' halo strength (silhouette_halo.ts HALO). */ halo: 0.7,
    /** Sprites standing in shade take it (sprite_shade.ts); false leaves them lit. */ sprites: true,
    /**
     * A room seen through an arch over its doorway (indoors, out of the sun's shade) is laid over with `archColor` at this
     * strength, by daylight like the shade. A plain blend: the arch's storey is blurred, and MULTIPLY in a blurred storey
     * darkens nothing below it.
     */ arch: 0.5,
    archColor: 0x10131f
};
const $ff5e8e678ac263ca$export$b2b1c48d57b3a943 = {
    front: 0.22,
    ridge: 18,
    eave: 0.74,
    eaveRows: 7,
    verge: 0.82,
    vergeWidth: 3,
    /** The drip shadow under an eave, onto whatever stands in the slot below it: `drip` at the eave, gone `dripDepth` px down; beside a verge, `side` gone in `sideWidth`. */ drip: 0.45,
    dripDepth: 16,
    side: 0.62,
    sideWidth: 8
};
const $ff5e8e678ac263ca$export$417fb4c1160a072e = (faces, strength)=>{
    const s = Math.max(0, Math.min(1, strength));
    const mix = (shift)=>Math.round(255 + ((faces >> shift & 0xff) - 255) * s);
    return mix(16) << 16 | mix(8) << 8 | mix(0);
};
const $ff5e8e678ac263ca$export$c83a039e3272b805 = ()=>{
    if (typeof window === "undefined") return $ff5e8e678ac263ca$export$f4641cf88636a32d;
    const w = window;
    if (w.buildingShadow === undefined) w.buildingShadow = $ff5e8e678ac263ca$export$f4641cf88636a32d;
    const live = w.buildingShadow;
    if (live === false) return {
        ...$ff5e8e678ac263ca$export$f4641cf88636a32d,
        enabled: false
    };
    return live && typeof live === "object" ? live : $ff5e8e678ac263ca$export$f4641cf88636a32d;
};
const $ff5e8e678ac263ca$export$7eacdda72209f408 = 1;
const $ff5e8e678ac263ca$export$c40fb1f8c9cffd84 = 0.4;
const $ff5e8e678ac263ca$export$d89c39803e62f19a = (brightness)=>brightness === undefined ? 1 : Math.min(1, Math.max(0, (brightness - $ff5e8e678ac263ca$export$c40fb1f8c9cffd84) / (1 - $ff5e8e678ac263ca$export$c40fb1f8c9cffd84)));
const $ff5e8e678ac263ca$export$955c453c49e43c9f = (brightness, sky)=>{
    const daylight = $ff5e8e678ac263ca$export$d89c39803e62f19a(brightness);
    const moon = (0, $a44874d288f3eb63$export$176295348256a78b)();
    if (daylight > 0 || !sky || !moon || brightness === undefined) return {
        ...(0, $a44874d288f3eb63$export$aa4bd1b541804cf)(),
        strength: daylight,
        moon: false
    };
    const rise = Math.min(1, Math.max(0, ($ff5e8e678ac263ca$export$c40fb1f8c9cffd84 - brightness) / Math.max(0.01, $ff5e8e678ac263ca$export$c40fb1f8c9cffd84 - moon.full)));
    return {
        x: moon.x,
        y: moon.y,
        strength: moon.strength * rise,
        moon: true
    };
};
const $ff5e8e678ac263ca$export$8c235c973bd2cc6a = (polygons, pad = 8, bucket = 64)=>{
    const parent = polygons.map((_, i)=>i);
    const find = (i)=>parent[i] === i ? i : parent[i] = find(parent[i]);
    const owner = new Map();
    polygons.forEach((polygon, i)=>{
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        for(let k = 0; k < polygon.length; k += 2){
            minX = Math.min(minX, polygon[k]);
            maxX = Math.max(maxX, polygon[k]);
            minY = Math.min(minY, polygon[k + 1]);
            maxY = Math.max(maxY, polygon[k + 1]);
        }
        for(let bx = Math.floor((minX - pad) / bucket); bx <= Math.floor((maxX + pad) / bucket); bx++)for(let by = Math.floor((minY - pad) / bucket); by <= Math.floor((maxY + pad) / bucket); by++){
            const key = `${bx},${by}`;
            const other = owner.get(key);
            if (other === undefined) owner.set(key, i);
            else parent[find(i)] = find(other);
        }
    });
    const groups = new Map();
    polygons.forEach((polygon, i)=>{
        const root = find(i);
        const group = groups.get(root);
        if (group) group.push(polygon);
        else groups.set(root, [
            polygon
        ]);
    });
    return [
        ...groups.values()
    ];
};
/** A plant's silhouette as a black picture, one texture per plant and strength, and a view of it per run of rows. */ const $ff5e8e678ac263ca$var$silhouettes = new WeakMap();
const $ff5e8e678ac263ca$var$stampTexture = ({ art: art, y: y, height: height, strength: strength = 1 })=>{
    let byStrength = $ff5e8e678ac263ca$var$silhouettes.get(art);
    if (!byStrength) $ff5e8e678ac263ca$var$silhouettes.set(art, byStrength = new Map());
    let made = byStrength.get(strength);
    if (!made) {
        // White where the art is drawn (premultiplied, scaled by its strength): the stamp is tinted the shadow's colour.
        const rgba = new Uint8Array(art.width * art.height * 4);
        for(let i = 0; i < art.alpha.length; i++)rgba.fill(Math.round(art.alpha[i] * strength), i * 4, i * 4 + 4);
        made = {
            texture: (0, $klOfb.Texture).fromBuffer(rgba, art.width, art.height),
            rows: new Map()
        };
        byStrength.set(strength, made);
    }
    const key = `${y}:${height}`;
    let rows = made.rows.get(key);
    if (!rows) made.rows.set(key, rows = new (0, $klOfb.Texture)(made.texture.baseTexture, new (0, $6qzqq.Rectangle)(0, y, art.width, height)));
    return rows;
};
class $ff5e8e678ac263ca$export$fd19f4d7b2d2ab91 extends (0, $8t5Gy.Container) {
    /**
     * `resolution`: the bakes' pixels per world pixel; by default the device's (device_tier.ts): full,
     * or half on a budget machine. A forest's shadow is one group as wide as the room, so at full
     * resolution one room's shade comes to tens of MB of textures (measured 34MB, 8MB at half).
     */ constructor(resolution){
        super(), this.resolution = resolution, this.baked = new (0, $cb0c2ff63ebff87f$export$316a7d97d9517d7b)(this), this./** How many groups the last draw baked afresh (the rest kept their bake). */ lastBaked = 0;
        this.zIndex = $ff5e8e678ac263ca$export$7eacdda72209f408;
        this.interactive = false;
        this.interactiveChildren = false;
    }
    /**
     * `stampArea(x0, y0, x1, y1)`: where stamps may land within a box (building_shadow_geometry.ts
     * sunReceivingRects), for a storey whose floor ends or is roofed over; undefined for anywhere.
     */ draw(polygons, softness, stamps = [], color = 0x000000, stampArea) {
        const previous = new Map(this.baked.groups.map((group)=>[
                group.key,
                group
            ]));
        const next = [];
        const fresh = [];
        // A stamp is grouped by the quadrilateral it lands on.
        const quads = new Map(stamps.map((stamp)=>[
                (0, $7fbbd538ea219bbf$export$2e3e7392189b3267)(stamp),
                stamp
            ]));
        const resolution = this.resolution ?? (0, $126d618cffb761ba$export$bcea76f852eb0b92)();
        $ff5e8e678ac263ca$export$8c235c973bd2cc6a([
            ...polygons,
            ...quads.keys()
        ]).forEach((members)=>{
            const group = members.filter((polygon)=>!quads.has(polygon));
            const groupStamps = members.filter((polygon)=>quads.has(polygon)).map((quad)=>quads.get(quad));
            let area;
            if (stampArea && groupStamps.length) {
                const xs = groupStamps.flatMap((stamp)=>(0, $7fbbd538ea219bbf$export$2e3e7392189b3267)(stamp).filter((_, i)=>i % 2 === 0));
                const ys = groupStamps.flatMap((stamp)=>(0, $7fbbd538ea219bbf$export$2e3e7392189b3267)(stamp).filter((_, i)=>i % 2 === 1));
                area = stampArea(Math.min(...xs), Math.min(...ys), Math.max(...xs), Math.max(...ys)).map(({ x0: x0, y0: y0, x1: x1, y1: y1 })=>({
                        x: x0,
                        y: y0,
                        width: x1 - x0,
                        height: y1 - y0
                    }));
            }
            const areaKey = area ? (0, $080b7304e1fb664d$export$d0bdf2835f4bf05)(area.map(({ x: x, y: y, width: width, height: height })=>[
                    x,
                    y,
                    width,
                    height
                ])) : "-";
            const key = `${softness}|${color}|${resolution}|${(0, $080b7304e1fb664d$export$d0bdf2835f4bf05)(group)}|${(0, $7fbbd538ea219bbf$export$4afa64c4106f0e32)(groupStamps)}|${areaKey}`;
            const kept = previous.get(key);
            if (kept) {
                previous.delete(key);
                next.push(kept);
                return;
            }
            const graphics = new (0, $ff77f0e96218c7e7$export$6bfce3b6985f9a3d)(softness, 2, (0, $P8XPi.BLEND_MODES).MULTIPLY, resolution);
            if (group.length) {
                graphics.beginFill(color, 1);
                group.forEach((polygon)=>graphics.drawPolygon(polygon));
                graphics.endFill();
            }
            groupStamps.forEach((stamp)=>graphics.stamp($ff5e8e678ac263ca$var$stampTexture(stamp), new (0, $6qzqq.Matrix)(...stamp.matrix), color));
            graphics.maskStamps(area);
            next.push({
                key: key,
                graphics: graphics
            });
            fresh.push(graphics);
        });
        this.lastBaked = fresh.length;
        this.baked.replace(next, fresh);
    }
    get groupCount() {
        return this.baked.groups.length;
    }
    destroy(options) {
        this.baked.clear();
        super.destroy(options);
    }
}




/**
 * Wall trims: what a wall material lays along its walls beyond its 32px pieces, drawn by the client
 * over each piece. A piece repeats every cell; trims do not.
 * - masonry: stones laid by world position along each storey's face, columns of their own widths split
 *   into stones of their own heights, so courses break and joints never fall on the tile grid;
 * - coping: the back edge of a top nothing stands on, laid as stones of uneven length and set;
 * - weeds: tufts rooted along such a top's back edge;
 * - streaks: water stains down a face under a top nothing stands on;
 * - foot: rubble, tufts and moss where a ground-storey face meets the ground (they spill past the cell);
 * - spurs: a battered spur of stone hugging each outer corner at the foot (past the cell too);
 * - arch: a gateway the storey above walls over becomes an arch cut up into that storey's face -- where that face
 *   is seen from outside (no floor of that storey in front of it), not inside a room over the doorway;
 * - creepers: ivy that grows from a root at the foot of a face and climbs only what it can hold -- a
 *   face, and the face of the storey above only where that storey's wall stands on this one; where it
 *   does not, the stem reaches this storey's coping, runs along it and stops;
 * - continuous: a smooth face (render) runs on through its storeys with no line at each storey's foot;
 * - damp: a darker band with a wavering tide mark at the foot of a ground-storey face;
 * - quoins: dressed stones up every outer end of a face (a corner, a jamb), long and short in turn;
 * - stringCourse: a band of dressed stone along the foot of every so many storeys, dividing a tall face into stages;
 * - framing: a timber frame over a face of infill -- posts by world position, the panels between them and the rails
 *   filled with studs, braces, saltires and arched heads, each panel's infill limewashed a little differently.
 *
 * Pure and deterministic: everything comes from the pieces' own pixels (which part each colour is:
 * WallTrims.parts), the storey stack, and hashes of world position. The same wall always gets the
 * same trims, building beside it never reshuffles them, and a plant's lower part never changes when
 * storeys are built over it.
 */ 
const $af123a5a2d29cf17$var$T = 32;
const $af123a5a2d29cf17$export$9c177af5c85b1deb = (below, here, x, y)=>{
    const open = (cx)=>!below.wall(cx, y) && !!here.wall(cx, y);
    let start = x;
    if (!open(x)) {
        if (open(x + 1)) start = x + 1;
        else if (open(x - 1)) start = x - 1;
        else return undefined;
    }
    let x0 = start, x1 = start;
    while(open(x0 - 1) && start - x0 < 6)x0--;
    while(open(x1 + 1) && x1 - start < 6)x1++;
    if (!below.wall(x0 - 1, y) || !below.wall(x1 + 1, y)) return undefined;
    for(let cx = x0; cx <= x1; cx++)if (here.floored?.(cx, y + 1)) return undefined;
    const definition = here.wall(start, y);
    const arch = definition.trims?.arch;
    if (!arch || x1 - x0 + 1 > arch.maxSpan) return undefined;
    return {
        x0: x0,
        x1: x1,
        definition: definition
    };
};
const $af123a5a2d29cf17$export$7f366f5e3b668630 = (...values)=>{
    let h = 0x811c9dc5;
    for (const v of values){
        h = Math.imul(h ^ (v | 0), 0x01000193);
        h ^= h >>> 15;
        h = Math.imul(h, 0x2c1b3c6d);
    }
    h ^= h >>> 13;
    h = Math.imul(h, 0x5bd1e995);
    h ^= h >>> 15;
    return (h >>> 0) / 4294967296;
};
/** A seeded generator for the walks a plant takes. */ const $af123a5a2d29cf17$var$seeded = (seed)=>{
    let a = Math.floor(seed * 4294967296) >>> 0;
    return ()=>{
        a = a + 0x6d2b79f5 >>> 0;
        let t = a;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
};
const $af123a5a2d29cf17$var$SALT = {
    column: 11,
    split: 12,
    tone: 13,
    speck: 14,
    coping: 21,
    set: 22,
    weed: 31,
    streak: 41,
    streakLength: 42,
    foot: 51,
    footKind: 52,
    footSize: 53,
    moss: 54,
    root: 61,
    rootX: 62,
    rootReach: 63,
    plant: 64,
    leaf: 65,
    fork: 66,
    damp: 71,
    quoin: 81,
    course: 91,
    bay: 101,
    fill: 102,
    side: 103,
    wash: 104,
    grain: 105,
    kink: 106,
    bloom: 111
};
const $af123a5a2d29cf17$var$rgb = (hex)=>[
        1,
        3,
        5
    ].map((i)=>parseInt(hex.slice(i, i + 2), 16));
const $af123a5a2d29cf17$var$key = (r, g, b)=>r << 16 | g << 8 | b;
const $af123a5a2d29cf17$var$keyOf = (hex)=>$af123a5a2d29cf17$var$key(...$af123a5a2d29cf17$var$rgb(hex));
const $af123a5a2d29cf17$var$copyImage = (image)=>({
        width: image.width,
        height: image.height,
        data: new Uint8Array(image.data)
    });
const $af123a5a2d29cf17$var$blank = (width, height)=>({
        width: width,
        height: height,
        data: new Uint8Array(width * height * 4)
    });
const $af123a5a2d29cf17$var$alphaAt = (image, x, y)=>x < 0 || y < 0 || x >= image.width || y >= image.height ? 0 : image.data[(y * image.width + x) * 4 + 3];
const $af123a5a2d29cf17$var$colourAt = (image, x, y)=>{
    const i = (y * image.width + x) * 4;
    return $af123a5a2d29cf17$var$key(image.data[i], image.data[i + 1], image.data[i + 2]);
};
const $af123a5a2d29cf17$var$rgbAt = (image, x, y)=>{
    const i = (y * image.width + x) * 4;
    return [
        image.data[i],
        image.data[i + 1],
        image.data[i + 2]
    ];
};
const $af123a5a2d29cf17$var$put = (image, x, y, c)=>{
    if (x < 0 || y < 0 || x >= image.width || y >= image.height) return;
    const i = (y * image.width + x) * 4;
    image.data[i] = c[0];
    image.data[i + 1] = c[1];
    image.data[i + 2] = c[2];
    image.data[i + 3] = 255;
};
const $af123a5a2d29cf17$var$clear = (image, x, y)=>{
    if (x < 0 || y < 0 || x >= image.width || y >= image.height) return;
    image.data.fill(0, (y * image.width + x) * 4, (y * image.width + x) * 4 + 4);
};
const $af123a5a2d29cf17$var$kits = new WeakMap();
const $af123a5a2d29cf17$var$kitOf = (definition)=>{
    const trims = definition?.trims;
    if (!trims) return undefined;
    let kit = $af123a5a2d29cf17$var$kits.get(trims);
    if (!kit) {
        const p = trims.palette;
        kit = {
            trims: trims,
            face: new Set(trims.parts.face.map($af123a5a2d29cf17$var$keyOf)),
            top: new Set(trims.parts.top.map($af123a5a2d29cf17$var$keyOf)),
            coping: new Set((trims.parts.coping || []).map($af123a5a2d29cf17$var$keyOf)),
            over: new Set((trims.framing?.over || []).map($af123a5a2d29cf17$var$keyOf)),
            frame: new Set(trims.framing ? (p.timber || []).map($af123a5a2d29cf17$var$keyOf) : []),
            c: {
                outline: $af123a5a2d29cf17$var$rgb(p.outline),
                joint: $af123a5a2d29cf17$var$rgb(p.joint),
                stem: $af123a5a2d29cf17$var$rgb(p.stem),
                stone: p.stone.map($af123a5a2d29cf17$var$rgb),
                top: p.top.map($af123a5a2d29cf17$var$rgb),
                dressed: p.dressed.map($af123a5a2d29cf17$var$rgb),
                moss: p.moss.map($af123a5a2d29cf17$var$rgb),
                grass: p.grass.map($af123a5a2d29cf17$var$rgb),
                leaves: p.leaves.map($af123a5a2d29cf17$var$rgb),
                timber: (p.timber || []).map($af123a5a2d29cf17$var$rgb),
                flowers: (p.flowers || []).map($af123a5a2d29cf17$var$rgb)
            }
        };
        $af123a5a2d29cf17$var$kits.set(trims, kit);
    }
    return kit;
};
const $af123a5a2d29cf17$var$partOf = (kit, image, x, y)=>{
    if ($af123a5a2d29cf17$var$alphaAt(image, x, y) < 128) return "void";
    if (!kit) return "other";
    const c = $af123a5a2d29cf17$var$colourAt(image, x, y);
    return kit.face.has(c) ? "face" : kit.top.has(c) ? "top" : kit.coping.has(c) ? "coping" : kit.frame.has(c) ? "frame" : "other";
};
class $af123a5a2d29cf17$export$84f6c3e7ed068c52 {
    constructor(stack){
        this.stack = stack;
        this.dressedPieces = new Map();
        this.pieces = new Map();
        this.lattices = new Map();
        this.owners = new Map();
        this.frames = new Map();
        this.storeyCells = new Map();
    }
    /** A storey's piece at a cell, asked of the stack once. */ pieceAt(k, x, y) {
        const id = `${k},${x},${y}`;
        let piece = this.pieces.get(id);
        if (piece === undefined) {
            piece = this.stack.storeys[k]?.piece(x, y) ?? null;
            this.pieces.set(id, piece);
        }
        return piece ?? undefined;
    }
    /**
     * One cell's art with its trims: over `image` (the art the caller draws there; by default the
     * stack's piece), and what spills past the cell. Undefined when no trim of its material applies.
     */ trim(k, x, y, image) {
        const piece = this.pieceAt(k, x, y);
        const kit = $af123a5a2d29cf17$var$kitOf(piece?.definition);
        if (!piece || !kit) return undefined;
        const out = this.dress(k, x, y, piece, kit, $af123a5a2d29cf17$var$copyImage(image ?? piece.image));
        (this.plantPaints().get(`${k},${x},${y}`) || []).forEach((p)=>$af123a5a2d29cf17$var$put(out, p.x, p.y, p.c));
        const overflow = [
            ...this.foot(k, x, y, piece, kit),
            ...this.spurs(k, x, y, piece, kit)
        ];
        return {
            image: out,
            overflow: overflow
        };
    }
    /** Whether a cell's art carries any trim (cheap: no painting). */ applies(k, x, y) {
        return !!$af123a5a2d29cf17$var$kitOf(this.pieceAt(k, x, y)?.definition);
    }
    // -----------------------------------------------------------------------------------------
    // Dressing one piece: masonry, streaks, the arch, coping, weeds, moss at the foot
    // -----------------------------------------------------------------------------------------
    dressed(k, x, y) {
        const id = `${k},${x},${y}`;
        if (this.dressedPieces.has(id)) return this.dressedPieces.get(id) ?? undefined;
        const piece = this.pieceAt(k, x, y);
        const kit = $af123a5a2d29cf17$var$kitOf(piece?.definition);
        const image = piece ? kit ? this.dress(k, x, y, piece, kit, $af123a5a2d29cf17$var$copyImage(piece.image)) : piece.image : undefined;
        this.dressedPieces.set(id, image ?? null);
        return image;
    }
    dress(k, x, y, piece, kit, image) {
        const face = y === piece.parent.y && x === piece.parent.x;
        const top = y === piece.parent.y - 1 || face && !this.hasFace(image, kit);
        // A parapet standing on it (merlons) leaves its top uncovered.
        const uncovered = !(0, $d06e01c1880d4b6a$export$a2f415c060ce2b32)(this.stack.storeys[k + 1]?.wall(piece.parent.x, piece.parent.y));
        if (kit.trims.continuous && (face ? this.stack.storeys[k - 1]?.wall(x, y)?.id === piece.definition.id : top && !uncovered)) this.continuous(kit, image);
        if (kit.trims.framing) this.framing(k, x, y, piece.definition, kit, image);
        if (face && kit.trims.masonry) this.masonry(k, x, y, kit, image);
        if (face && uncovered && kit.trims.streaks) this.streaks(k, x, kit, image);
        if (face && kit.trims.damp && k === 0) this.damp(x, y, kit, image);
        if (face && kit.trims.foot && k === 0 && this.stack.ground(x, y + 1) === "soil") this.moss(x, y, kit, image);
        if (face && kit.trims.stringCourse) this.stringCourse(k, x, y, piece, kit, image);
        if (kit.trims.quoins) this.quoins(k, x, y, kit, image);
        if (top && uncovered && kit.trims.coping) this.coping(k, x, y, kit, image);
        if (top && uncovered && kit.trims.weeds) this.weeds(k, x, y, kit, image);
        this.arch(k, x, y, piece, kit, image);
        return image;
    }
    hasFace(image, kit) {
        for(let y = 0; y < $af123a5a2d29cf17$var$T; y++)for(let x = 0; x < $af123a5a2d29cf17$var$T; x++)if ($af123a5a2d29cf17$var$partOf(kit, image, x, y) === "face") return true;
        return false;
    }
    /** The column starts of a lattice along one row of one storey, from world x 0, by a hash of each column. */ lattice(id, seed, widths, upTo) {
        let starts = this.lattices.get(id);
        if (!starts) {
            starts = [
                0
            ];
            this.lattices.set(id, starts);
        }
        while(starts[starts.length - 1] <= upTo){
            const i = starts.length - 1;
            const w = widths[Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630(...seed, i) * widths.length)];
            starts.push(starts[i] + w);
        }
        return starts;
    }
    masonry(k, x, y, kit, image) {
        const spec = k > 0 ? kit.trims.masonry.upper ?? kit.trims.masonry.ground : kit.trims.masonry.ground;
        const [r0, r1] = spec.rows;
        const X0 = x * $af123a5a2d29cf17$var$T;
        const starts = this.lattice(`m:${k}:${y}:${spec.widths.join(".")}`, [
            $af123a5a2d29cf17$var$SALT.column,
            k,
            y
        ], spec.widths, X0 + $af123a5a2d29cf17$var$T);
        const { stone: stone, joint: joint } = kit.c;
        const paint = (px, py, c)=>$af123a5a2d29cf17$var$partOf(kit, image, px, py) === "face" && $af123a5a2d29cf17$var$put(image, px, py, c);
        for(let i = 0; i + 1 < starts.length; i++){
            const c0 = starts[i], c1 = starts[i + 1] - 1 // c1: the column's joint
            ;
            if (c1 < X0 || c0 > X0 + $af123a5a2d29cf17$var$T - 1) continue;
            const split = spec.splits[Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.split, k, y, i) * spec.splits.length)];
            let yy = r0, s = 0;
            while(yy <= r1){
                const h = s < split.length - 1 ? split[s] : r1 - yy + 2;
                const sy0 = yy, sy1 = Math.min(r1, yy + h - 2);
                const tone = 1 + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.tone, k, y, i, s) * 3) // 1..3
                ;
                for(let X = Math.max(c0, X0); X <= Math.min(c1, X0 + $af123a5a2d29cf17$var$T - 1); X++){
                    const px = X - X0;
                    for(let py = sy0; py <= Math.min(r1, sy1 + 1); py++){
                        if (X === c1 || py === sy1 + 1) {
                            paint(px, py, joint);
                            continue;
                        }
                        const left = X === c0, right = X === c1 - 1, upper = py === sy0, lower = py === sy1;
                        if ((left || right) && (upper || lower)) paint(px, py, joint);
                        else if (upper) paint(px, py, right ? stone[3] : stone[4]);
                        else if (left) paint(px, py, lower ? stone[2] : stone[3]);
                        else if (lower || right) paint(px, py, stone[Math.max(0, tone - 1)]);
                        else {
                            const u = (py - sy0) / Math.max(1, sy1 - sy0) + (X - c0) / Math.max(1, c1 - 1 - c0) * 0.6;
                            let t = u < 0.3 ? tone + 1 : u > 1.25 ? tone - 1 : tone;
                            const speck = $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.speck, X, py, k, y);
                            if (speck < 0.04) t += speck < 0.02 ? 1 : -1;
                            paint(px, py, stone[Math.max(0, Math.min(4, t))]);
                        }
                    }
                }
                yy = sy1 + 2;
                s++;
            }
        }
    }
    streaks(k, x, kit, image) {
        const share = kit.trims.streaks.share;
        for(let px = 0; px < $af123a5a2d29cf17$var$T; px++){
            const X = x * $af123a5a2d29cf17$var$T + px;
            if ($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.streak, k, X) >= share) continue;
            const length = 3 + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.streakLength, k, X) * 8);
            // From the first face row down, darker where it starts.
            let first = -1;
            for(let py = 0; py < $af123a5a2d29cf17$var$T && first < 0; py++)if ($af123a5a2d29cf17$var$partOf(kit, image, px, py) === "face") first = py;
            if (first < 0) continue;
            for(let d = 0; d < length; d++){
                const py = first + d;
                if ($af123a5a2d29cf17$var$partOf(kit, image, px, py) !== "face") continue;
                $af123a5a2d29cf17$var$put(image, px, py, kit.c.stone[d < length / 2 ? 0 : 1]);
            }
        }
    }
    moss(x, y, kit, image) {
        const share = kit.trims.foot.moss;
        for(let spot = 0; spot < 3; spot++){
            if ($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.moss, x, y, spot) >= share) continue;
            const cx = Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.moss, x, y, spot, 1) * $af123a5a2d29cf17$var$T);
            const r = 3 + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.moss, x, y, spot, 2) * 4);
            for(let py = $af123a5a2d29cf17$var$T - 1 - 10; py < $af123a5a2d29cf17$var$T - 1; py++)for(let px = cx - r - 2; px <= cx + r + 2; px++){
                if ($af123a5a2d29cf17$var$partOf(kit, image, px, py) !== "face") continue;
                const d = ((px - cx) / (r + 2)) ** 2 + ((py - ($af123a5a2d29cf17$var$T - 2)) / 9) ** 2;
                if (d < 1 && $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.moss, x * $af123a5a2d29cf17$var$T + px, py, spot) < 0.75 - d * 0.55) $af123a5a2d29cf17$var$put(image, px, py, kit.c.moss[Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.moss, px, py, 7) * kit.c.moss.length)]);
            }
        }
    }
    /**
     * The line at the foot of a piece that runs on into more of this face (a face standing on this material, a top the
     * storey above covers with more of its face): each pixel of it painted as the face pixel above it.
     */ continuous(kit, image) {
        const outline = $af123a5a2d29cf17$var$key(...kit.c.outline);
        for(let px = 0; px < $af123a5a2d29cf17$var$T; px++){
            if ($af123a5a2d29cf17$var$alphaAt(image, px, $af123a5a2d29cf17$var$T - 1) < 128 || $af123a5a2d29cf17$var$colourAt(image, px, $af123a5a2d29cf17$var$T - 1) !== outline || $af123a5a2d29cf17$var$partOf(kit, image, px, $af123a5a2d29cf17$var$T - 2) !== "face") continue;
            $af123a5a2d29cf17$var$put(image, px, $af123a5a2d29cf17$var$T - 1, $af123a5a2d29cf17$var$rgbAt(image, px, $af123a5a2d29cf17$var$T - 2));
        }
    }
    /** Rising damp: from the ground up to a tide mark that wanders along the wall by world x, the face a shade darker. */ damp(x, y, kit, image) {
        const [least, most] = kit.trims.damp.height;
        const s = kit.c.stone;
        for(let px = 0; px < $af123a5a2d29cf17$var$T; px++){
            const X = x * $af123a5a2d29cf17$var$T + px;
            // A smooth wave through a hashed height every 8px, and now and then a pixel's jitter.
            const i = Math.floor(X / 8), f = (X - i * 8) / 8, u = f * f * (3 - 2 * f);
            const a = $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.damp, i, y), b = $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.damp, i + 1, y);
            const height = Math.round(least + (most - least) * (a + (b - a) * u)) + ($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.damp, X, y, 1) < 0.2 ? 1 : 0);
            const mark = $af123a5a2d29cf17$var$T - 1 - height;
            for(let py = Math.max(0, mark); py < $af123a5a2d29cf17$var$T; py++){
                if ($af123a5a2d29cf17$var$partOf(kit, image, px, py) !== "face") continue;
                $af123a5a2d29cf17$var$put(image, px, py, py === mark ? s[0] : $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.damp, X, py, 2) < 0.2 ? s[2] : s[1]);
            }
            // Salt blooms just over the mark.
            if (mark > 0 && $af123a5a2d29cf17$var$partOf(kit, image, px, mark - 1) === "face" && $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.damp, X, y, 3) < 0.16) $af123a5a2d29cf17$var$put(image, px, mark - 1, s[4]);
        }
    }
    /** Whether storey k at (x, y) carries a string course: every so many storeys, standing on this material. */ coursed(k, x, y, kit, id) {
        const every = kit.trims.stringCourse?.every;
        return !!every && k > 0 && k % every === 0 && this.stack.storeys[k]?.wall(x, y)?.id === id && this.stack.storeys[k - 1]?.wall(x, y)?.id === id;
    }
    /**
     * The string course over a face's foot (its last four rows: a lit arris, the band, its shaded underside, joints
     * by world x), and the line of shade it throws on the top row of the face below.
     */ stringCourse(k, x, y, piece, kit, image) {
        const d = kit.c.dressed, id = piece.definition.id;
        if (this.coursed(k, x, y, kit, id)) {
            const rows = [
                d[3],
                d[2],
                d[2],
                d[1]
            ];
            for(let px = 0; px < $af123a5a2d29cf17$var$T; px++){
                const X = x * $af123a5a2d29cf17$var$T + px, joint = $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.course, Math.floor(X / 3), y, k) < 0.06 && $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.course, X, y, k) < 0.5;
                rows.forEach((c, i)=>{
                    const py = $af123a5a2d29cf17$var$T - rows.length + i;
                    if ($af123a5a2d29cf17$var$partOf(kit, image, px, py) === "face") $af123a5a2d29cf17$var$put(image, px, py, joint && i > 0 ? d[0] : c);
                });
            }
        }
        if (this.coursed(k + 1, x, y, kit, id)) {
            for(let px = 0; px < $af123a5a2d29cf17$var$T; px++)if ($af123a5a2d29cf17$var$partOf(kit, image, px, 0) === "face") $af123a5a2d29cf17$var$put(image, px, 0, kit.c.stone[1]);
        }
    }
    /**
     * Quoins up every outer end of a face in this piece: where past the face there is the silhouette's outline and
     * then nothing (an outer corner, a jamb), not another wall (an inner corner, a tee). The courses run by the
     * stack's drawn rows, so they carry on from storey to storey; the stones stay inside this piece.
     */ quoins(k, x, y, kit, image) {
        const { long: long, short: short, course: course } = kit.trims.quoins;
        const d = kit.c.dressed;
        const clear = (px, py)=>{
            const cell = x + Math.floor(px / $af123a5a2d29cf17$var$T);
            const art = cell === x ? image : this.pieceAt(k, cell, y)?.image;
            return !art || $af123a5a2d29cf17$var$alphaAt(art, px - (cell - x) * $af123a5a2d29cf17$var$T, py) < 128;
        };
        const faceAt = (px, py)=>{
            if (px >= 0 && px < $af123a5a2d29cf17$var$T) return $af123a5a2d29cf17$var$partOf(kit, image, px, py) === "face";
            const cell = x + Math.floor(px / $af123a5a2d29cf17$var$T), piece = this.pieceAt(k, cell, y);
            return !!piece && $af123a5a2d29cf17$var$partOf($af123a5a2d29cf17$var$kitOf(piece.definition), piece.image, px - (cell - x) * $af123a5a2d29cf17$var$T, py) === "face";
        };
        // An end at px (the face's last pixel), facing `step`: past it, the outline and then nothing, or nothing at all.
        const outerEnd = (px, step, py)=>!faceAt(px + step, py) && (clear(px + step, py) || clear(px + 2 * step, py));
        for(let py = 0; py < $af123a5a2d29cf17$var$T; py++){
            const ends = [];
            for(let px = 0; px < $af123a5a2d29cf17$var$T; px++){
                if ($af123a5a2d29cf17$var$partOf(kit, image, px, py) !== "face") continue;
                if (outerEnd(px, -1, py)) ends.push([
                    px,
                    1
                ]);
                if (outerEnd(px, 1, py)) ends.push([
                    px,
                    -1
                ]);
            }
            if (!ends.length) continue;
            const Ys = y * $af123a5a2d29cf17$var$T + py - k * this.stack.rise;
            const c = Math.floor(Ys / course), r = Ys - c * course;
            const width = c % 2 === 0 ? long : short;
            // Each stone inward from its end: a lit top arris, the outer arris lit on a west end and shaded on an east
            // one, a shaded foot, its bed joint and its inner edge where the face meets it.
            ends.forEach(([from, step])=>{
                for(let i = 0; i < width; i++){
                    const px = from + i * step;
                    if (px < 0 || px >= $af123a5a2d29cf17$var$T) break;
                    if ($af123a5a2d29cf17$var$partOf(kit, image, px, py) !== "face") continue;
                    let colour;
                    if (r === course - 1 || i === width - 1) colour = d[0];
                    else if (r === 0) colour = d[3];
                    else if (i === 0) colour = step > 0 ? d[3] : d[1];
                    else if (r === course - 2) colour = d[1];
                    else colour = $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.quoin, x * $af123a5a2d29cf17$var$T + px, Ys) < 0.06 ? d[1] : d[2];
                    $af123a5a2d29cf17$var$put(image, px, py, colour);
                }
            });
        }
    }
    // -----------------------------------------------------------------------------------------
    // Timber framing
    // -----------------------------------------------------------------------------------------
    framing(k, x, y, definition, kit, image) {
        const ops = this.frameRow(k, y, definition, kit).get(x);
        if (!ops) return;
        // What each pixel is, as drawn before the frame; the timbers first, then the infill's shade and tone, each
        // once, on what the timbers left.
        const before = $af123a5a2d29cf17$var$copyImage(image);
        const timbered = new Uint8Array($af123a5a2d29cf17$var$T * $af123a5a2d29cf17$var$T), factor = new Float32Array($af123a5a2d29cf17$var$T * $af123a5a2d29cf17$var$T).fill(1), shaded = new Uint8Array($af123a5a2d29cf17$var$T * $af123a5a2d29cf17$var$T), toned = new Uint8Array($af123a5a2d29cf17$var$T * $af123a5a2d29cf17$var$T);
        ops.forEach((op)=>{
            const part = $af123a5a2d29cf17$var$partOf(kit, before, op.px, op.py), i = op.py * $af123a5a2d29cf17$var$T + op.px;
            if (op.kind === "post") {
                if (part === "void") return;
                $af123a5a2d29cf17$var$put(image, op.px, op.py, op.c);
                timbered[i] = 1;
            } else if (op.kind === "member") {
                if (part !== "face" && !kit.over.has($af123a5a2d29cf17$var$colourAt(before, op.px, op.py))) return;
                $af123a5a2d29cf17$var$put(image, op.px, op.py, op.c);
                timbered[i] = 1;
            } else if (part === "face") {
                const seen = op.kind === "shade" ? shaded : toned;
                if (seen[i]) return;
                seen[i] = 1;
                factor[i] *= op.f;
            }
        });
        for(let i = 0; i < $af123a5a2d29cf17$var$T * $af123a5a2d29cf17$var$T; i++){
            if (timbered[i] || factor[i] === 1) continue;
            const px = i % $af123a5a2d29cf17$var$T, py = Math.floor(i / $af123a5a2d29cf17$var$T);
            const [r, g, b] = $af123a5a2d29cf17$var$rgbAt(before, px, py), f = factor[i];
            $af123a5a2d29cf17$var$put(image, px, py, [
                Math.min(255, Math.round(r * f)),
                Math.min(255, Math.round(g * f)),
                Math.min(255, Math.round(b * f))
            ]);
        }
    }
    /**
     * The frame along one cell row of one storey, cell by cell: worked out once over the whole of each run of wall, so a
     * panel that spans cells is filled the same from both sides, from the stack's pieces (what is face where).
     */ frameRow(k, y, definition, kit) {
        const id = `${k},${y},${definition.id}`;
        const known = this.frames.get(id);
        if (known) return known;
        const out = new Map();
        this.frames.set(id, out);
        const storey = this.stack.storeys[k];
        if (!storey) return out;
        const framing = kit.trims.framing;
        const tm = kit.c.timber;
        if (tm.length < 5) return out;
        // The cells of this row with art: walls on it and the tops of the walls south of it.
        let cells = this.storeyCells.get(k);
        if (!cells) {
            cells = storey.cells();
            this.storeyCells.set(k, cells);
        }
        const xs = new Set();
        cells.forEach((c)=>(c.y === y || c.y === y + 1) && xs.add(c.x));
        const sorted = [
            ...xs
        ].sort((a, b)=>a - b);
        const groups = [];
        sorted.forEach((cx)=>{
            const last = groups[groups.length - 1];
            if (last && last[1] === cx - 1) last[1] = cx;
            else groups.push([
                cx,
                cx
            ]);
        });
        const emit = (X, py, op)=>{
            const cx = Math.floor(X / $af123a5a2d29cf17$var$T);
            const list = out.get(cx) ?? [];
            list.push({
                px: X - cx * $af123a5a2d29cf17$var$T,
                py: py,
                ...op
            });
            out.set(cx, list);
        };
        const W = framing.width;
        const panels = framing.panels;
        groups.forEach(([g0, g1])=>{
            const X0 = g0 * $af123a5a2d29cf17$var$T, X1 = g1 * $af123a5a2d29cf17$var$T + $af123a5a2d29cf17$var$T - 1, n = X1 - X0 + 1;
            // Which pixels of the run's rows are infill a member may be laid over: this material's face, or `over`.
            const infill = Array.from({
                length: $af123a5a2d29cf17$var$T
            }, ()=>new Uint8Array(n));
            for(let cx = g0; cx <= g1; cx++){
                const piece = this.pieceAt(k, cx, y);
                if (!piece || piece.definition.id !== definition.id) continue;
                for(let py = 0; py < $af123a5a2d29cf17$var$T; py++)for(let px = 0; px < $af123a5a2d29cf17$var$T; px++)if ($af123a5a2d29cf17$var$partOf(kit, piece.image, px, py) === "face" || $af123a5a2d29cf17$var$alphaAt(piece.image, px, py) >= 128 && kit.over.has($af123a5a2d29cf17$var$colourAt(piece.image, px, py))) infill[py][cx * $af123a5a2d29cf17$var$T + px - X0] = 1;
            }
            const open = (X, py)=>X >= X0 && X <= X1 && infill[py][X - X0] === 1;
            const panelOpen = (X)=>panels.every((p)=>{
                    for(let py = p.rows[0]; py <= p.rows[1]; py++)if (!open(X, py)) return false;
                    return true;
                });
            // Posts by the lattice, from world x 0 and the same on every storey: each stands only clear of other art.
            const starts = this.lattice(`f:${y}:${framing.bays.join(".")}`, [
                $af123a5a2d29cf17$var$SALT.bay,
                y
            ], framing.bays, X1 + $af123a5a2d29cf17$var$T);
            const posted = new Uint8Array(n);
            starts.forEach((s, i)=>{
                const c0 = s - Math.floor(W / 2), c1 = c0 + W - 1;
                if (c1 + 2 < X0 || c0 - 2 > X1) return;
                for(let X = c0 - 2; X <= c1 + 2; X++)if (!panelOpen(X)) return;
                for(let X = c0; X <= c1; X++)posted[X - X0] = 1;
                const colour = (X)=>X === c0 ? tm[3] : X === c1 ? tm[1] : tm[2];
                for(let py = framing.posts[0]; py <= framing.posts[1]; py++)for(let X = c0; X <= c1; X++)emit(X, py, {
                    kind: "post",
                    c: colour(X)
                });
                // Its pegs where the rails between the panels are tenoned into it, and its shadow on the infill.
                panels.slice(1).forEach((p, j)=>emit(c0 + 1, Math.floor((panels[j].rows[1] + p.rows[0]) / 2), {
                        kind: "post",
                        c: tm[0]
                    }));
                panels.forEach((p)=>{
                    for(let py = p.rows[0]; py <= p.rows[1]; py++)emit(c1 + 1, py, {
                        kind: "shade",
                        f: 0.86
                    });
                });
                // Now and then a check, a split along the grain.
                if ($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.grain, s, y) < 0.3) {
                    const gx = c0 + 1 + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.grain, s, y, 1) * (W - 2));
                    const g0 = framing.posts[0] + 1 + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.grain, s, y, 2) * 6), length = 3 + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.grain, s, y, 3) * 5);
                    for(let py = g0; py < Math.min(framing.posts[1], g0 + length); py++)emit(gx, py, {
                        kind: "post",
                        c: tm[1]
                    });
                }
            });
            // The panels between posts and rails: each a run of columns open from its head to its foot.
            panels.forEach((panel, pi)=>{
                const [a, b] = panel.rows;
                const h = b - a + 1;
                let X = X0, previous;
                while(X <= X1){
                    const columnOpen = (cX)=>{
                        if (cX > X1 || posted[cX - X0]) return false;
                        for(let py = a; py <= b; py++)if (!open(cX, py)) return false;
                        return true;
                    };
                    if (!columnOpen(X)) {
                        X++;
                        continue;
                    }
                    let x1 = X;
                    while(columnOpen(x1 + 1))x1++;
                    const x0 = X, w = x1 - x0 + 1;
                    X = x1 + 1;
                    // Its limewash, a shade of its own.
                    const tones = framing.tones ?? 0;
                    if (tones > 0) {
                        const t = Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.wash, k, y, pi, x0) * 3) - 1;
                        if (t) for(let py = a; py <= b; py++)for(let cX = x0; cX <= x1; cX++)emit(cX, py, {
                            kind: "tone",
                            f: 1 + t * tones
                        });
                    }
                    const fill = this.pickFill(panel.fills, w, h, previous, [
                        k,
                        y,
                        pi,
                        x0
                    ]);
                    previous = fill;
                    this.fillPanel(fill, x0, x1, a, b, [
                        k,
                        y,
                        pi,
                        x0
                    ], tm, emit);
                }
            });
        });
        return out;
    }
    /** A fill for a panel w x h: by weight among those it is wide enough for, not the same as the panel before it (bare infill aside). */ pickFill(fills, w, h, previous, seed) {
        const fits = (fill)=>{
            switch(fill){
                case "plain":
                    return true;
                case "stud":
                    return w >= 10;
                case "studs":
                    return w >= 14;
                case "brace":
                    return w >= h + 2;
                case "chevron":
                    return w >= 2 * h + 2;
                case "cross":
                    return w >= 8 && h >= 5 && w <= 2 * h + 6;
                case "arched":
                    return w >= 12 && h >= 6;
            }
        };
        const choices = Object.entries(fills).filter(([fill, weight])=>weight > 0 && fits(fill));
        const pick = (salt, list)=>{
            const total = list.reduce((sum, [, weight])=>sum + weight, 0);
            let r = $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.fill, salt, ...seed) * total;
            for (const [fill, weight] of list)if ((r -= weight) < 0) return fill;
            return list[list.length - 1]?.[0] ?? "plain";
        };
        const first = pick(0, choices);
        if (first === previous && first !== "plain") {
            const others = choices.filter(([fill])=>fill !== first);
            if (others.length) return pick(1, others);
        }
        return first;
    }
    /** Lays one fill over a panel (x0..x1 world px, rows a..b): members as ops, their shadows on the infill. */ fillPanel(fill, x0, x1, a, b, seed, tm, emit) {
        const w = x1 - x0 + 1, h = b - a + 1;
        const member = (X, py, c)=>X >= x0 && X <= x1 && py >= a && py <= b && emit(X, py, {
                kind: "member",
                c: c
            });
        const shade = (X, py)=>X >= x0 && X <= x1 && py >= a && py <= b && emit(X, py, {
                kind: "shade",
                f: 0.86
            });
        const stud = (cX, salt)=>{
            // Hewn, not sawn: now and then it steps a pixel part way up.
            const kink = $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.kink, ...seed, salt) < 0.35 ? a + 2 + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.kink, ...seed, salt, 1) * Math.max(1, h - 4)) : -1;
            const side = $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.kink, ...seed, salt, 2) < 0.5 ? -1 : 1;
            for(let py = a; py <= b; py++){
                const c = cX + (kink >= 0 && py < kink ? side : 0);
                member(c, py, tm[3]);
                member(c + 1, py, tm[2]);
                member(c + 2, py, tm[1]);
                shade(c + 3, py);
            }
        };
        // A straight brace with its foot at (fx, b) and its head at (hx, a): three px across, lit on its upper side.
        const brace = (fx, hx)=>{
            for(let py = a; py <= b; py++){
                const t = h > 1 ? (b - py) / (h - 1) : 0;
                const c = Math.round(fx + (hx - fx) * t);
                member(c, py, tm[3]);
                member(c + 1, py, tm[2]);
                member(c + 2, py, tm[1]);
                shade(c + 3, py);
            }
        };
        switch(fill){
            case "plain":
                return;
            case "stud":
                return stud(x0 + Math.floor((w - 3) / 2), 0);
            case "studs":
                {
                    const count = Math.max(1, Math.round(w / 8) - 1);
                    for(let i = 1; i <= count; i++)stud(x0 + Math.round(i * w / (count + 1)) - 1, i);
                    return;
                }
            case "brace":
                {
                    // Rising from one post at the panel's foot to its head, leaning out at 45 degrees.
                    const reach = Math.min(w - 3, h - 1);
                    return $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.side, ...seed) < 0.5 ? brace(x0, x0 + reach) : brace(x1 - 2, x1 - 2 - reach);
                }
            case "chevron":
                {
                    const mid = x0 + Math.floor(w / 2);
                    brace(x0, mid - 2);
                    brace(x1 - 2, mid - 1);
                    return;
                }
            case "cross":
                brace(x0, x1 - 2);
                brace(x1 - 2, x0);
                return;
            case "arched":
                {
                    // The panel's head an arch: timber spandrels from its posts, springing part way down, to a crown just
                    // under the head, the infill in the opening shaded along its edge.
                    const spring = Math.min(h - 3, Math.max(5, Math.round(h * 0.6))), crown = 2;
                    const rx = w / 2, ry = spring - crown, xc = x0 + w / 2, yc = a + spring;
                    for(let py = a; py < a + spring; py++)for(let X = x0; X <= x1; X++){
                        const dx = (X + 0.5 - xc) / rx, dy = (py + 0.5 - yc) / ry;
                        const e = dx * dx + dy * dy;
                        if (e >= 1) member(X, py, e < 1.3 ? tm[1] : tm[2]);
                        else if (e > 0.78) shade(X, py);
                    }
                    return;
                }
        }
    }
    /** The first opaque row of each pixel column with a top below it: the back edge of a top, where open sky is behind. */ backEdge(kit, image, px) {
        for(let py = 1; py < 20; py++){
            if ($af123a5a2d29cf17$var$alphaAt(image, px, py) < 128) continue;
            const below = $af123a5a2d29cf17$var$partOf(kit, image, px, py + 1);
            return below === "top" && $af123a5a2d29cf17$var$alphaAt(image, px, py - 1) < 128 ? py : -1;
        }
        return -1;
    }
    coping(k, x, y, kit, image) {
        const [shortest, longest] = kit.trims.coping.lengths;
        const widths = Array.from({
            length: longest - shortest + 1
        }, (_, i)=>shortest + i);
        const X0 = x * $af123a5a2d29cf17$var$T;
        const starts = this.lattice(`c:${k}:${y}:${shortest}-${longest}`, [
            $af123a5a2d29cf17$var$SALT.coping,
            k,
            y
        ], widths, X0 + $af123a5a2d29cf17$var$T);
        const t = kit.c.top;
        const edges = Array.from({
            length: $af123a5a2d29cf17$var$T
        }, (_, px)=>this.backEdge(kit, image, px));
        for(let i = 0; i + 1 < starts.length; i++){
            const s0 = starts[i], s1 = starts[i + 1] - 1;
            if (s1 < X0 || s0 > X0 + $af123a5a2d29cf17$var$T - 1) continue;
            const set = [
                -2,
                -1,
                -1,
                0,
                0,
                1
            ][Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.set, k, y, i) * 6)];
            for(let X = Math.max(s0, X0); X <= Math.min(s1, X0 + $af123a5a2d29cf17$var$T - 1); X++){
                const px = X - X0, edge = edges[px];
                if (edge < 0) continue;
                const shoulder = X === s0 || X === s1;
                const lift = set + (shoulder ? 1 : 0 // negative: the stone stands proud
                );
                if (X === s1 && X !== s0) {
                    // The joint to the next stone: a notch down the stone's back edge.
                    $af123a5a2d29cf17$var$clear(image, px, edge);
                    $af123a5a2d29cf17$var$put(image, px, edge + 1, t[0]);
                    continue;
                }
                if (lift < 0) {
                    $af123a5a2d29cf17$var$put(image, px, edge + lift, t[0]);
                    for(let py = edge + lift + 1; py <= edge; py++)$af123a5a2d29cf17$var$put(image, px, py, py === edge + lift + 1 ? t[4] : t[3]);
                } else if (lift > 0) {
                    for(let py = edge; py < edge + lift; py++)$af123a5a2d29cf17$var$clear(image, px, py);
                    $af123a5a2d29cf17$var$put(image, px, edge + lift, t[0]);
                }
            }
        }
    }
    weeds(k, x, y, kit, image) {
        if ($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.weed, k, x, y) >= kit.trims.weeds.share) return;
        const cx = 4 + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.weed, k, x, y, 1) * 24);
        const g = kit.c.grass;
        for(let b = 0; b < 5; b++){
            const bx = cx + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.weed, k, x, y, b, 2) * 7) - 3;
            const edge = this.backEdge(kit, image, bx);
            if (edge < 0) continue;
            const h = 2 + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.weed, k, x, y, b, 3) * 4);
            for(let d = 0; d <= h; d++)$af123a5a2d29cf17$var$put(image, bx, edge + 1 - d, g[Math.min(g.length - 1, Math.floor(d / h * g.length))]);
        }
    }
    // -----------------------------------------------------------------------------------------
    // The arch over a gateway
    // -----------------------------------------------------------------------------------------
    /** The gateway under storey k at cell row y that the cell x opens over or flanks (archGateway). */ gateway(k, x, y) {
        const below = this.stack.storeys[k - 1], here = this.stack.storeys[k];
        const gate = below && here ? $af123a5a2d29cf17$export$9c177af5c85b1deb(below, here, x, y) : undefined;
        const kit = $af123a5a2d29cf17$var$kitOf(gate?.definition);
        return gate && kit ? {
            x0: gate.x0,
            x1: gate.x1,
            kit: kit
        } : undefined;
    }
    arch(k, x, y, piece, kit, image) {
        if (k < 1 || piece.parent.y !== y || piece.parent.x !== x) return;
        const gate = this.gateway(k, x, y);
        if (!gate) return;
        const { rise: rise, ring: ring } = gate.kit.trims.arch;
        const left = gate.x0 * $af123a5a2d29cf17$var$T, right = (gate.x1 + 1) * $af123a5a2d29cf17$var$T;
        const half = (right - left) / 2, mid = left + half;
        const hr = half, vr = Math.min(half, rise);
        const d = gate.kit.c.dressed;
        for(let py = 0; py < $af123a5a2d29cf17$var$T; py++)for(let px = 0; px < $af123a5a2d29cf17$var$T; px++){
            const X = x * $af123a5a2d29cf17$var$T + px + 0.5;
            const dx = X - mid, dy = $af123a5a2d29cf17$var$T - 0.5 - py // above the springing, the face's bottom
            ;
            const inner = (dx / hr) ** 2 + (dy / vr) ** 2;
            const outer = (dx / (hr + ring)) ** 2 + (dy / (vr + ring)) ** 2;
            if (Math.abs(dx) < hr && inner < 1) // The opening: the passage running back through the wall shows through it, and whoever walks it.
            // Its shade is the sun's (the client draws none of this storey's floor under the arch, and shades
            // the passage as the ground under the storey above).
            $af123a5a2d29cf17$var$clear(image, px, py);
            else if (outer < 1 && dy >= 0) {
                const angle = Math.atan2(dy * (hr / vr), dx) * (180 / Math.PI);
                const joint = angle % 15 < 1.6 || angle % 15 > 13.4;
                const edge = inner < 1.12;
                const keystone = Math.abs(dx) < 3.2 && dy > vr - 1;
                $af123a5a2d29cf17$var$put(image, px, py, edge ? gate.kit.c.outline : keystone ? Math.abs(dx) > 2.2 ? d[0] : d[3] : joint ? d[0] : outer > 0.86 ? d[1] : dx < 0 ? d[3] : d[2]);
            }
        }
    }
    // -----------------------------------------------------------------------------------------
    // Past the cell: the foot, the spurs
    // -----------------------------------------------------------------------------------------
    foot(k, x, y, piece, kit) {
        const foot = kit.trims.foot;
        if (!foot || k !== 0 || piece.parent.y !== y || piece.parent.x !== x) return [];
        const ground = this.stack.ground(x, y + 1);
        if (ground === "floor" || ground === "water") return [];
        const image = this.pieceAt(0, x, y).image;
        // Only along the face's foot: where its bottom row has art.
        const footed = Array.from({
            length: $af123a5a2d29cf17$var$T
        }, (_, px)=>$af123a5a2d29cf17$var$alphaAt(image, px, $af123a5a2d29cf17$var$T - 1) >= 128);
        if (!footed.some(Boolean)) return [];
        const out = $af123a5a2d29cf17$var$blank($af123a5a2d29cf17$var$T + 8, 14) // x -4..35, y 24..37 of the cell
        ;
        const at = (px, py)=>[
                px + 4,
                py - 24
            ];
        const stones = kit.c.stone;
        for(let spot = 0; spot < 6; spot++){
            const sx = Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.foot, x, y, spot) * $af123a5a2d29cf17$var$T);
            if (!footed[sx]) continue;
            const kind = $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.footKind, x, y, spot);
            if (kind < foot.rubble) {
                const w = 2 + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.footSize, x, y, spot) * 3), h = 1 + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.footSize, x, y, spot, 1) * 2);
                const cy = $af123a5a2d29cf17$var$T + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.footSize, x, y, spot, 2) * 3);
                for(let dy = -h; dy <= h; dy++)for(let dx = -w; dx <= w; dx++){
                    const dd = (dx / (w + 0.5)) ** 2 + (dy / (h + 0.5)) ** 2;
                    if (dd > 1) continue;
                    const [ox, oy] = at(sx + dx, cy + dy);
                    const c = dd > 0.6 ? dy > 0 || dx > 0 ? kit.c.outline : kit.c.top[0] : dx + dy < -w * 0.5 ? stones[4] : dx + dy > w * 0.4 ? stones[1] : stones[2];
                    $af123a5a2d29cf17$var$put(out, ox, oy, c);
                }
            } else if (kind < foot.rubble + foot.tufts && ground === "soil") {
                const g = kit.c.grass;
                for(let b = 0; b < 4; b++){
                    const bx = sx + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.footSize, x, y, spot, b) * 7) - 3;
                    const h = 3 + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.footSize, x, y, spot, b, 1) * 5);
                    for(let d = 0; d < h; d++){
                        const [ox, oy] = at(bx + (d > h / 2 && b % 2 ? 1 : 0), $af123a5a2d29cf17$var$T + 2 - d);
                        $af123a5a2d29cf17$var$put(out, ox, oy, g[Math.min(g.length - 1, Math.floor(d / h * g.length))]);
                    }
                }
            }
        }
        return [
            {
                image: out,
                dx: -4,
                dy: 24
            }
        ];
    }
    spurs(k, x, y, piece, kit) {
        const spurs = kit.trims.spurs;
        if (!spurs || k !== 0 || piece.parent.y !== y || piece.parent.x !== x) return [];
        const storey = this.stack.storeys[0];
        const n = !!storey.wall(x, y - 1), s = !!storey.wall(x, y + 1), e = !!storey.wall(x + 1, y), w = !!storey.wall(x - 1, y);
        const side = n && !s && e && !w ? -1 : n && !s && w && !e ? 1 : 0;
        if (!side) return [];
        const ground = this.stack.ground(x, y + 1);
        if (ground === "floor" || ground === "water") return [];
        const image = piece.image;
        // Where the face's outer side stands: its outermost opaque column in its lower rows.
        let edge = side < 0 ? $af123a5a2d29cf17$var$T : -1;
        for(let py = 20; py < $af123a5a2d29cf17$var$T; py++)for(let px = 0; px < $af123a5a2d29cf17$var$T; px++)if ($af123a5a2d29cf17$var$alphaAt(image, px, py) >= 128) edge = side < 0 ? Math.min(edge, px) : Math.max(edge, px);
        if (edge < 0 || edge >= $af123a5a2d29cf17$var$T) return [];
        const { reach: reach, height: height } = spurs;
        // Outward is west for a south-west corner, east for a south-east one; the spur reaches out `reach` px
        // at its foot, 1 px at its head, and laps 6 px over the face.
        const origin = side < 0 ? edge - reach - 1 : edge - 7;
        const rows = height + 4, top = $af123a5a2d29cf17$var$T - height;
        const out = $af123a5a2d29cf17$var$blank(reach + 8, rows);
        const s0 = kit.c.stone, d = kit.c.dressed;
        for(let r = 0; r < rows; r++){
            const f = r / (rows - 1);
            const reachHere = Math.round(1 + (reach - 1) * f);
            for(let t = -6; t <= reachHere; t++){
                const px = edge + side * t;
                let c;
                if (r === rows - 1 || t === reachHere) c = kit.c.outline;
                else if (r === 0) c = d[3];
                else if (r % 9 === 8) c = kit.c.joint;
                else if (t > 0) c = f < 0.5 ? s0[3] : s0[2];
                else c = t === -6 ? s0[1] : (r + t) % 7 ? s0[2] : s0[3];
                $af123a5a2d29cf17$var$put(out, px - origin, r, c);
            }
        }
        const dx = origin;
        return [
            {
                image: out,
                dx: dx,
                dy: top
            }
        ];
    }
    // -----------------------------------------------------------------------------------------
    // Creepers
    // -----------------------------------------------------------------------------------------
    /**
     * Works out what the whole stack needs before any cell is trimmed -- where its creepers grow -- so a renderer can do
     * it in a frame of its own rather than in the frame that draws the storey. True when there was work to do.
     */ warm() {
        if (this.plants) return false;
        this.plantPaints();
        return true;
    }
    /** The part a pixel of the stack's drawn view is, and whose it is: the topmost storey with art there. */ owner(X, Ys) {
        // The creepers ask of the same pixels over and over (a step up, a band crossed): each is worked out once.
        const id = Math.abs(X) < 32768 && Math.abs(Ys) < 32768 ? (X + 32768) * 65536 + (Ys + 32768) : undefined;
        if (id !== undefined) {
            const known = this.owners.get(id);
            if (known !== undefined) return known ?? undefined;
        }
        const hit = this.findOwner(X, Ys);
        if (id !== undefined) this.owners.set(id, hit ?? null);
        return hit;
    }
    findOwner(X, Ys) {
        const { storeys: storeys, rise: rise } = this.stack;
        for(let k = storeys.length - 1; k >= 0; k--){
            const Y = Ys + k * rise;
            const x = Math.floor(X / $af123a5a2d29cf17$var$T), y = Math.floor(Y / $af123a5a2d29cf17$var$T);
            const image = this.dressed(k, x, y);
            if (!image) continue;
            const px = X - x * $af123a5a2d29cf17$var$T, py = Y - y * $af123a5a2d29cf17$var$T;
            if ($af123a5a2d29cf17$var$alphaAt(image, px, py) < 128) continue;
            const piece = this.pieceAt(k, x, y);
            return {
                k: k,
                x: x,
                y: y,
                px: px,
                py: py,
                part: $af123a5a2d29cf17$var$partOf($af123a5a2d29cf17$var$kitOf(piece?.definition), image, px, py)
            };
        }
        return undefined;
    }
    /** Where a pixel of the drawn view would be drawn when it lands on no art: the topmost storey with a piece at that cell. */ host(X, Ys) {
        const { storeys: storeys, rise: rise } = this.stack;
        for(let k = storeys.length - 1; k >= 0; k--){
            const Y = Ys + k * rise;
            const x = Math.floor(X / $af123a5a2d29cf17$var$T), y = Math.floor(Y / $af123a5a2d29cf17$var$T);
            if (this.dressed(k, x, y)) return {
                k: k,
                x: x,
                y: y,
                px: X - x * $af123a5a2d29cf17$var$T,
                py: Y - y * $af123a5a2d29cf17$var$T
            };
        }
        return undefined;
    }
    plantPaints() {
        if (this.plants) return this.plants;
        const paints = new Map();
        this.plants = paints;
        const ground = this.stack.storeys[0];
        if (!ground) return paints;
        const roots = this.roots();
        // A face, or a timber frame over one (a climbing rose takes to the posts and rails).
        const climb = (X, Ys)=>{
            const p = this.owner(X, Ys)?.part;
            return p === "face" || p === "frame";
        };
        const holds = (X, Ys)=>{
            const p = this.owner(X, Ys)?.part;
            return p === "top" || p === "coping";
        };
        // A band of coping or a top with more face just above it (a moulded offset, a string course, the seam
        // where a storey stands on the one below) is crossed, not hung from.
        const crosses = (X, Ys)=>{
            for(let d = 0; d <= 8; d++){
                const p = this.owner(X, Ys - d)?.part;
                if (!p || p === "void") return false;
                if (p === "face") return d > 0;
            }
            return false;
        };
        const draw = (X, Ys, c)=>{
            const at = this.owner(X, Ys) ?? this.host(X, Ys);
            if (!at) return;
            const id = `${at.k},${at.x},${at.y}`;
            const list = paints.get(id) ?? [];
            list.push({
                x: at.px,
                y: at.py,
                c: c
            });
            paints.set(id, list);
        };
        roots.forEach((root)=>{
            const { kit: kit, reach: reach, spread: spread } = root;
            // Each stem walks with its own seed (a branch's from its stem's and where it forks), and each leaf is
            // picked by its position: what grows above a point never changes what grew below it.
            const leaves = [];
            const stems = [];
            for(let s = 0; s < 3; s++){
                const seed = $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.plant, root.X, root.Ys, s);
                const random = $af123a5a2d29cf17$var$seeded(seed);
                stems.push({
                    X: root.X + Math.floor(random() * 7) - 3,
                    Ys: root.Ys,
                    lean: random() - 0.5,
                    left: Math.floor(reach * (0.7 + random() * 0.3)),
                    seed: seed
                });
            }
            // From the root the stems first cover whatever lies between the ground and the face (a battered
            // footing, a plinth): up to a dozen pixels over any art, then they must find a face to climb.
            let base = root.Ys;
            for(let d = 0; d < 12 && !climb(root.X, base) && this.owner(root.X, base - 1); d++){
                draw(root.X, base, kit.c.stem);
                if (d % 2 === 0) leaves.push({
                    X: root.X,
                    Ys: base,
                    k: 0
                });
                base--;
            }
            if (!climb(root.X, base)) return;
            stems.forEach((stem)=>stem.Ys = base);
            let guard = 0;
            while(stems.length && guard++ < 64){
                const stem = stems.pop();
                const random = $af123a5a2d29cf17$var$seeded($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.plant, Math.floor(stem.seed * 1e9), 1));
                let fx = stem.X, X = stem.X, Ys = stem.Ys, draped = 0, run = 0, left = stem.left, step = 0;
                while(left-- > 0){
                    step++;
                    const risen = root.Ys - Ys;
                    fx += stem.lean + (random() * 1.2 - 0.6);
                    const width = spread * (0.35 + 1.4 * risen / Math.max(1, reach));
                    fx = Math.max(root.X - width, Math.min(root.X + width, fx));
                    const nx = Math.round(fx), ny = Ys - 1;
                    if (climb(nx, ny) || crosses(nx, ny)) [X, Ys] = [
                        nx,
                        ny
                    ];
                    else if (holds(nx, ny) && draped < 6) {
                        [X, Ys] = [
                            nx,
                            ny
                        ];
                        draped++;
                    } else if (climb(nx - 2, ny) || climb(nx + 2, ny)) {
                        X = climb(nx - 2, ny) ? nx - 2 : nx + 2;
                        fx = X;
                        Ys = ny;
                    } else if (draped && run < 8) {
                        // Over the coping it runs along the top a little, then stops.
                        const side = stem.lean >= 0 ? 1 : -1;
                        if (holds(X + side, Ys) || climb(X + side, Ys)) {
                            X += side;
                            run++;
                        } else break;
                    } else break;
                    draw(X, Ys, kit.c.stem);
                    if ($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.leaf, X, Ys) < 0.55) leaves.push({
                        X: X,
                        Ys: Ys,
                        k: (root.Ys - Ys) / Math.max(1, reach)
                    });
                    const fork = $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.fork, Math.floor(stem.seed * 1e9), step);
                    if (left > 12 && fork < 0.035) {
                        const seed = $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.plant, Math.floor(stem.seed * 1e9), step, 2);
                        stems.push({
                            X: X,
                            Ys: Ys,
                            lean: stem.lean + (seed < 0.5 ? -1 : 1) * (0.3 + seed * 0.5),
                            left: Math.floor(left * (0.4 + fork * 10)),
                            seed: seed
                        });
                    }
                }
            }
            const L = kit.c.leaves;
            const shape = [
                [
                    0,
                    0,
                    2
                ],
                [
                    1,
                    0,
                    1
                ],
                [
                    0,
                    1,
                    1
                ],
                [
                    -1,
                    0,
                    2
                ],
                [
                    0,
                    -1,
                    3
                ],
                [
                    1,
                    -1,
                    4
                ],
                [
                    1,
                    1,
                    0
                ]
            ];
            leaves.forEach((leaf)=>{
                [
                    [
                        -2,
                        0
                    ],
                    [
                        2,
                        -1
                    ],
                    [
                        -1,
                        -2
                    ],
                    [
                        1,
                        1
                    ],
                    [
                        0,
                        -1
                    ],
                    [
                        -2,
                        1
                    ]
                ].forEach(([dx, dy], n)=>{
                    if ($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.leaf, leaf.X, leaf.Ys, n) > 0.9 - 0.45 * leaf.k) return;
                    shape.forEach(([ox, oy, c])=>{
                        const X = leaf.X + dx + ox, Ys = leaf.Ys + dy + oy;
                        const there = this.owner(X, Ys)?.part;
                        const low = root.Ys - Ys < 14 // by the root, leaves cover whatever the stem grew over
                        ;
                        if (there === "face" || there === "frame" || there === "top" || there === "coping" || low && there === "other" || climb(X, Ys + 1) || climb(X - 1, Ys) || climb(X + 1, Ys)) {
                            if (there !== "other" || low) draw(X, Ys, L[Math.min(L.length - 1, c)]);
                        }
                    });
                });
                // A climbing rose flowers among its leaves: a blossom lit at its upper left.
                const bloom = kit.trims.creepers?.bloom ?? 0;
                const F = kit.c.flowers;
                if (bloom > 0 && F.length >= 3 && $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.bloom, leaf.X, leaf.Ys) < bloom) {
                    const bx = leaf.X + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.bloom, leaf.X, leaf.Ys, 1) * 3) - 1, by = leaf.Ys - 1;
                    const there = this.owner(bx, by)?.part;
                    if (there === "face" || there === "frame" || there === "top" || there === "coping") [
                        [
                            0,
                            0,
                            2
                        ],
                        [
                            1,
                            0,
                            1
                        ],
                        [
                            0,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            0
                        ]
                    ].forEach(([dx, dy, c])=>draw(bx + dx, by + dy, F[c]));
                }
            });
        });
        return paints;
    }
    /** Where ivy roots: at most one per ground-storey face cell on soil, by a hash of the cell. */ roots() {
        const out = [];
        const ground = this.stack.storeys[0];
        ground.cells().forEach(({ x: x, y: y })=>{
            const kit = $af123a5a2d29cf17$var$kitOf(ground.wall(x, y));
            const creepers = kit?.trims.creepers;
            if (!kit || !creepers || this.stack.ground(x, y + 1) !== "soil") return;
            if ($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.root, x, y) >= creepers.share) return;
            const [least, most] = creepers.reach;
            out.push({
                X: x * $af123a5a2d29cf17$var$T + 6 + Math.floor($af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.rootX, x, y) * 20),
                Ys: y * $af123a5a2d29cf17$var$T + $af123a5a2d29cf17$var$T - 2,
                kit: kit,
                reach: Math.round((least + (most - least) * $af123a5a2d29cf17$export$7f366f5e3b668630($af123a5a2d29cf17$var$SALT.rootReach, x, y)) * this.stack.rise),
                spread: creepers.spread
            });
        });
        return out;
    }
}




parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");

const $3c8dd7879239ee0e$var$PAGE = 1024;
class $3c8dd7879239ee0e$export$a63a0a78b9585282 {
    constructor(size = $3c8dd7879239ee0e$var$PAGE){
        this.size = size;
        this.pages = [];
    }
    /** The image on a page; undefined when it is bigger than a page (or there is no 2D canvas), for the caller to keep its own. */ put(image) {
        const place = this.place(image.width, image.height);
        if (!place) return undefined;
        const data = place.page.context.createImageData(image.width, image.height);
        data.data.set(image.data);
        place.page.context.putImageData(data, place.x, place.y);
        return this.finish(place, image.data, image.width, image.height);
    }
    /** A canvas's picture on a page (its pixels read once, for its bounds). */ putCanvas(canvas) {
        const context = canvas.getContext("2d");
        if (!context || !canvas.width || !canvas.height) return undefined;
        const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
        const place = this.place(canvas.width, canvas.height);
        if (!place) return undefined;
        place.page.context.drawImage(canvas, place.x, place.y);
        return this.finish(place, pixels, canvas.width, canvas.height);
    }
    reset() {
        const old = this.pages;
        this.pages = [];
        // The sprites using them are gone with the full render; free the GPU copies a frame later.
        setTimeout(()=>old.forEach((p)=>p.base.destroy()), 0);
    }
    get pageCount() {
        return this.pages.length;
    }
    place(width, height) {
        if (!width || !height || width > this.size || height > this.size) return undefined;
        // A page someone destroyed (a texture freed with its base): its pieces are gone; start another.
        if (this.pages.length && this.pages[this.pages.length - 1].base.destroyed) this.pages.pop();
        let page = this.pages[this.pages.length - 1];
        const fits = (p)=>{
            if (p.x + width > this.size) {
                p.x = 0;
                p.y += p.shelf;
                p.shelf = 0;
            }
            return p.y + height <= this.size;
        };
        if (!page || !fits(page)) {
            const canvas = document.createElement("canvas");
            canvas.width = this.size;
            canvas.height = this.size;
            // In memory, not on the GPU: what reads a wall's image back (its damage, its edges) reads from this page.
            const context = canvas.getContext("2d", {
                willReadFrequently: true
            });
            if (!context) return undefined;
            page = {
                canvas: canvas,
                context: context,
                base: (0, $klOfb.BaseTexture).from(canvas),
                x: 0,
                y: 0,
                shelf: 0
            };
            this.pages.push(page);
        }
        const at = {
            page: page,
            x: page.x,
            y: page.y
        };
        page.x += width + 1;
        page.shelf = Math.max(page.shelf, height + 1);
        return at;
    }
    finish(place, pixels, width, height) {
        place.page.base.update();
        const texture = new (0, $klOfb.Texture)(place.page.base, new (0, $6qzqq.Rectangle)(place.x, place.y, width, height));
        (0, $35a6592763403c18$export$89d9314d15db4cff)(texture, pixels, width, height);
        return texture;
    }
}
const $3c8dd7879239ee0e$export$11cde7437b85d173 = new $3c8dd7879239ee0e$export$a63a0a78b9585282();




/**
 * The client side of wall trims (game-common room/wall_trims.ts): the storey stack a renderer draws, as the
 * painter reads it; one painter per stack and state of its walls, shared by every storey's renderer; and an
 * atlas the trimmed cells are baked into, so a castle's hundreds of distinct cells still draw in few batches.
 * Nothing here runs in the frame loop: a cell is baked when its storey renders.
 */ // ---------------------------------------------------------------------------------------------
// Pixels
// ---------------------------------------------------------------------------------------------
const $ba9ee37aae1b90d9$var$pixelCache = new WeakMap();
const $ba9ee37aae1b90d9$export$fc42ccd69c0ec10c = (texture)=>{
    if (!texture || !texture.baseTexture.valid) return undefined;
    const known = $ba9ee37aae1b90d9$var$pixelCache.get(texture);
    if (known !== undefined) return known ?? undefined;
    let image = null;
    try {
        const source = texture.baseTexture.resource?.source;
        if (source) {
            const canvas = document.createElement("canvas");
            canvas.width = texture.width;
            canvas.height = texture.height;
            const context = canvas.getContext("2d");
            if (context) {
                const frame = texture.frame, trim = texture.trim;
                context.drawImage(source, frame.x, frame.y, frame.width, frame.height, trim?.x || 0, trim?.y || 0, trim?.width || texture.width, trim?.height || texture.height);
                const data = context.getImageData(0, 0, texture.width, texture.height);
                image = {
                    width: data.width,
                    height: data.height,
                    data: new Uint8Array(data.data.buffer.slice(0))
                };
            }
        }
    } catch  {
        image = null;
    }
    $ba9ee37aae1b90d9$var$pixelCache.set(texture, image);
    return image ?? undefined;
};
class $ba9ee37aae1b90d9$export$e0acefc08bd634f2 extends (0, $3c8dd7879239ee0e$export$a63a0a78b9585282) {
}
// ---------------------------------------------------------------------------------------------
// The stack a renderer draws, as the painter reads it
// ---------------------------------------------------------------------------------------------
let $ba9ee37aae1b90d9$var$byItem;
const $ba9ee37aae1b90d9$var$definitionFor = (itemType)=>{
    if (!itemType) return undefined;
    if ($ba9ee37aae1b90d9$var$byItem?.source !== (0, $4d955fa5af64f75a$export$7f5e211f9738e851)) $ba9ee37aae1b90d9$var$byItem = {
        source: (0, $4d955fa5af64f75a$export$7f5e211f9738e851),
        map: new Map((0, $4d955fa5af64f75a$export$7f5e211f9738e851).filter((d)=>d.itemType).map((d)=>[
                d.itemType,
                d
            ]))
    };
    return $ba9ee37aae1b90d9$var$byItem.map.get(itemType);
};
const $ba9ee37aae1b90d9$export$9f9361b20898f65c = ()=>(0, $4d955fa5af64f75a$export$7f5e211f9738e851).some((d)=>!!d.trims);
const $ba9ee37aae1b90d9$export$3c9496a80943a375 = (provider)=>{
    const below = [];
    const seen = new Set([
        provider
    ]);
    for(let p = provider.getFloorSupportProvider(); p && !seen.has(p); p = p.getFloorSupportProvider()){
        seen.add(p);
        below.unshift(p);
    }
    const above = [];
    for(let p = provider.getUpperFloorProvider(); p && !seen.has(p); p = p.getUpperFloorProvider()){
        seen.add(p);
        above.push(p);
    }
    return {
        storeys: [
            ...below,
            provider,
            ...above
        ],
        index: below.length
    };
};
const $ba9ee37aae1b90d9$export$5cd8483e1f9c208c = (storeys)=>storeys.map((p)=>`${p.roomId}:${p.getPresentationVersion()}`).join("|") + `|${0, $2751e0027a1b432f$export$de62489b685ceb}`;
const $ba9ee37aae1b90d9$export$fd1b3f060dedf495 = (provider, x, y)=>{
    const tile = provider.resolveTileMapFromLayerId("map2")?.[x]?.[y];
    return !!tile && tile !== "0";
};
const $ba9ee37aae1b90d9$var$archStoreyOf = (provider)=>({
        wall: (x, y)=>$ba9ee37aae1b90d9$var$definitionFor(provider.wallItemAt(x, y)),
        floored: (x, y)=>$ba9ee37aae1b90d9$export$fd1b3f060dedf495(provider, x, y)
    });
const $ba9ee37aae1b90d9$export$b3a01c67d8d60400 = (below, upper, x, y)=>{
    if (!below || !upper || !upper.wallItemAt(x, y) || below.wallItemAt(x, y)) return false;
    const gate = (0, $af123a5a2d29cf17$export$9c177af5c85b1deb)($ba9ee37aae1b90d9$var$archStoreyOf(below), $ba9ee37aae1b90d9$var$archStoreyOf(upper), x, y);
    return !!gate && x >= gate.x0 && x <= gate.x1;
};
const $ba9ee37aae1b90d9$var$storeyOf = (provider, seamTile)=>({
        cells: ()=>provider.getMapDeltas().filter((d)=>d.layerId === "sprite" && !d.removed && !!provider.wallItemAt(d.x, d.y) && d.context?.parent?.x === d.x && d.context?.parent?.y === d.y).map((d)=>({
                    x: d.x,
                    y: d.y
                })),
        wall: (x, y)=>$ba9ee37aae1b90d9$var$definitionFor(provider.wallItemAt(x, y)),
        floored: (x, y)=>$ba9ee37aae1b90d9$export$fd1b3f060dedf495(provider, x, y),
        piece: (x, y)=>{
            const tile = provider.resolveTileMapFromLayerId("sprite")?.[x]?.[y];
            if (!tile || tile === "0" || provider.isHiddenTile(tile)) return undefined;
            const context = provider.getMapDeltaAt(x, y, "sprite")?.context;
            const parent = context?.parent;
            if (!parent) return undefined;
            const definition = $ba9ee37aae1b90d9$var$definitionFor(context?.itemType ?? provider.wallItemAt(parent.x, parent.y));
            if (!definition) return undefined;
            const drawn = seamTile(x, y, provider.resolveTilesetTileId(tile), context, provider);
            const image = $ba9ee37aae1b90d9$export$fc42ccd69c0ec10c((0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(drawn));
            return image ? {
                image: image,
                parent: {
                    x: parent.x,
                    y: parent.y
                },
                definition: definition
            } : undefined;
        }
    });
const $ba9ee37aae1b90d9$var$groundOf = (provider)=>(x, y)=>{
        const px = x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2, py = y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
        if ((0, $3895eb5d0ddb7972$export$36672f1fcfb01da4)(provider, px, py)) return "water";
        if ((0, $7ea6fc60f5974fdd$export$920f903c798ad6e9)(provider, px, py)) return "soil";
        const floor = provider.resolveTileMapFromLayerId("map2")?.[x]?.[y];
        return floor && floor !== "0" ? "floor" : "hard";
    };
const $ba9ee37aae1b90d9$var$painters = new WeakMap();
const $ba9ee37aae1b90d9$export$c9e7d128a54cb10b = (provider, seamTile)=>{
    const { storeys: storeys, index: index } = $ba9ee37aae1b90d9$export$3c9496a80943a375(provider);
    const bottom = storeys[0];
    const version = $ba9ee37aae1b90d9$export$5cd8483e1f9c208c(storeys);
    let held = $ba9ee37aae1b90d9$var$painters.get(bottom);
    if (!held || held.version !== version) {
        const stack = {
            storeys: storeys.map((p)=>$ba9ee37aae1b90d9$var$storeyOf(p, seamTile)),
            rise: (0, $2751e0027a1b432f$export$de62489b685ceb),
            ground: $ba9ee37aae1b90d9$var$groundOf(bottom)
        };
        held = {
            version: version,
            painter: new (0, $af123a5a2d29cf17$export$84f6c3e7ed068c52)(stack)
        };
        $ba9ee37aae1b90d9$var$painters.set(bottom, held);
    }
    return {
        painter: held.painter,
        storey: index
    };
};
const $ba9ee37aae1b90d9$export$e17f160e092cb33a = (atlas, provider, seamTile, x, y, texture)=>{
    const { painter: painter, storey: storey } = $ba9ee37aae1b90d9$export$c9e7d128a54cb10b(provider, seamTile);
    if (!painter.applies(storey, x, y)) return undefined;
    const base = $ba9ee37aae1b90d9$export$fc42ccd69c0ec10c(texture);
    if (!base || base.width !== (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) || base.height !== (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) return undefined;
    const trimmed = painter.trim(storey, x, y, base);
    if (!trimmed) return undefined;
    const baked = atlas.put(trimmed.image);
    if (!baked) return undefined;
    const overflow = trimmed.overflow.flatMap((o)=>{
        const t = atlas.put(o.image);
        return t ? [
            {
                texture: t,
                dx: o.dx,
                dy: o.dy
            }
        ] : [];
    });
    return {
        texture: baked,
        overflow: overflow
    };
};


const $4216ea292092863c$export$56b5b58aaec914ee = {
    enabled: true,
    thickness: 10,
    under: 0.7,
    underWithSun: 0.5,
    lip: 0.55,
    step: 0.35,
    stepCore: 0.6,
    stepWidth: 14
};
const $4216ea292092863c$export$b243cb41db6bd29c = ()=>{
    if (typeof window === "undefined") return $4216ea292092863c$export$56b5b58aaec914ee;
    const w = window;
    if (w.storeyEdges === undefined) w.storeyEdges = $4216ea292092863c$export$56b5b58aaec914ee;
    const live = w.storeyEdges;
    if (live === false) return {
        ...$4216ea292092863c$export$56b5b58aaec914ee,
        enabled: false
    };
    return live && typeof live === "object" ? {
        ...$4216ea292092863c$export$56b5b58aaec914ee,
        ...live
    } : $4216ea292092863c$export$56b5b58aaec914ee;
};
const $4216ea292092863c$var$cellsOf = (storey)=>{
    const house = storey.twoStoreyHouse;
    const walls = new Set((storey.getHousePresentation()?.wallCells ?? []).map((cell)=>`${cell.x},${cell.y}`));
    const sky = storey.resolveTileMapFromLayerId("sky");
    const floor = (x, y)=>(0, $a5455a642b85f08d$export$a28c4ec3b4f79a47)(storey, x, y);
    const wall = (x, y)=>walls.has(`${x},${y}`);
    return {
        storey: storey,
        roomId: storey.roomId,
        level: house?.floor ?? 0,
        elevation: house ? (0, $2751e0027a1b432f$export$815ba2e910747d11)(house) : 0,
        floor: floor,
        wall: wall,
        solid: (x, y)=>floor(x, y) || wall(x, y) || storey.isStairAt(x, y) || storey.isFloorOpeningAt(x, y),
        roof: (x, y)=>{
            const tile = sky?.[x]?.[y];
            return !!tile && tile !== "0";
        }
    };
};
/** A floor carries on past its edge onto (x, y): its own art, or the roof below standing at its height. */ const $4216ea292092863c$var$carriesOn = (upper, beneath, x, y)=>upper.solid(x, y) || !!beneath && beneath.level === upper.level - 1 && beneath.roof(x, y);
/** The band of a cell's floor art its south edge belongs to (the lowest of drawnFloorRects). */ const $4216ea292092863c$var$southBand = (rects)=>rects.reduce((low, rect)=>rect.y1 > low.y1 ? rect : low);
/** The upper floors above `below`, each with the storey straight under it and those in between. */ const $4216ea292092863c$var$storeysAbove = (base, uppers)=>{
    const stack = uppers.map($4216ea292092863c$var$cellsOf).filter((storey)=>storey.level > base.level).sort((a, b)=>a.level - b.level);
    return stack.flatMap((upper, index)=>{
        const between = stack.slice(0, index);
        const drop = upper.elevation - base.elevation;
        if (upper.level < 1 || drop <= 0) return [];
        return [
            {
                upper: upper,
                between: between,
                drop: drop,
                beneath: [
                    base,
                    ...between
                ].find((storey)=>storey.level === upper.level - 1)
            }
        ];
    });
};
/** Whatever hangs down from a higher floor at (x, y) comes down on `base`: nothing in between catches it. */ const $4216ea292092863c$var$landsOn = (base, between, x, y)=>!between.some((storey)=>storey.floor(x, y) || storey.wall(x, y) || storey.roof(x, y)) && !base.roof(x, y) && (base.level === 0 || base.floor(x, y));
function $4216ea292092863c$export$ff4c0ea3a04e4c86(below, uppers) {
    const base = $4216ea292092863c$var$cellsOf(below);
    const faces = [];
    for (const { upper: upper, beneath: beneath, between: between, drop: drop } of $4216ea292092863c$var$storeysAbove(base, uppers)){
        const floorAt = (x, y)=>upper.floor(x, y);
        upper.storey.resolveTileMapFromLayerId("map2")?.forEach((column, x)=>column?.forEach((_, y)=>{
                if (!upper.floor(x, y) || $4216ea292092863c$var$carriesOn(upper, beneath, x, y + 1)) return;
                // The storey straight under the edge stands a wall there: the wall's art is the face. So is an arch the
                // upper storey's wall cuts over a gateway there: no slab edge shows through it.
                if (beneath?.wall(x, y) || (0, $ba9ee37aae1b90d9$export$b3a01c67d8d60400)(beneath?.storey, upper.storey, x, y)) return;
                // A storey in between catches the face, and draws it itself.
                if (!$4216ea292092863c$var$landsOn(base, between, x, y)) return;
                const band = $4216ea292092863c$var$southBand((0, $af4c175a7e8f40ad$export$7e53b5197744fc5d)(x, y, floorAt));
                faces.push({
                    roomId: upper.roomId,
                    x: x,
                    y: y,
                    x0: band.x0,
                    x1: band.x1,
                    edge: band.y1,
                    drop: drop
                });
            }));
    }
    return $4216ea292092863c$var$mergeRuns(faces);
}
function $4216ea292092863c$export$ec27c7a57e317ba2(below, uppers) {
    const base = $4216ea292092863c$var$cellsOf(below);
    const shadows = [];
    for (const { upper: upper, beneath: beneath, between: between, drop: drop } of $4216ea292092863c$var$storeysAbove(base, uppers)){
        const floorAt = (x, y)=>upper.floor(x, y);
        const adjacent = upper.level === base.level + 1;
        upper.storey.resolveTileMapFromLayerId("map2")?.forEach((column, x)=>column?.forEach((_, y)=>{
                if (!upper.floor(x, y)) return;
                const steps = (dx, dy)=>!$4216ea292092863c$var$carriesOn(upper, beneath, x + dx, y + dy) && $4216ea292092863c$var$landsOn(base, between, x + dx, y + dy);
                const rects = (0, $af4c175a7e8f40ad$export$7e53b5197744fc5d)(x, y, floorAt);
                for (const [side, dx] of [
                    [
                        "east",
                        1
                    ],
                    [
                        "west",
                        -1
                    ]
                ]){
                    if (!steps(dx, 0)) continue;
                    for (const rect of rects)shadows.push({
                        roomId: upper.roomId,
                        side: side,
                        at: dx > 0 ? rect.x1 : rect.x0,
                        from: rect.y0,
                        to: rect.y1
                    });
                }
                if (adjacent && steps(0, -1)) {
                    const top = rects.reduce((high, rect)=>rect.y0 < high.y0 ? rect : high);
                    shadows.push({
                        roomId: upper.roomId,
                        side: "north",
                        at: top.y0 - drop,
                        from: top.x0,
                        to: top.x1
                    });
                }
            }));
    }
    const sorted = shadows.sort((a, b)=>a.roomId.localeCompare(b.roomId) || a.side.localeCompare(b.side) || a.at - b.at || a.from - b.from);
    const merged = [];
    for (const shadow of sorted){
        const last = merged[merged.length - 1];
        if (last && last.roomId === shadow.roomId && last.side === shadow.side && last.at === shadow.at && last.to === shadow.from) last.to = shadow.to;
        else merged.push({
            ...shadow
        });
    }
    return merged;
}
/** Tilemaps are walked column by column; join the pieces of one row that touch. */ const $4216ea292092863c$var$mergeRuns = (faces)=>{
    const sorted = [
        ...faces
    ].sort((a, b)=>a.roomId.localeCompare(b.roomId) || a.y - b.y || a.x0 - b.x0);
    const runs = [];
    for (const face of sorted){
        const last = runs[runs.length - 1];
        if (last && last.roomId === face.roomId && last.y === face.y && last.edge === face.edge && last.drop === face.drop && last.x1 === face.x0) last.x1 = face.x1;
        else runs.push({
            ...face
        });
    }
    return runs;
};
function $4216ea292092863c$export$3509f2c4ca17e83a(storey, below) {
    const cells = $4216ea292092863c$var$cellsOf(storey);
    if (cells.level < 1) return [];
    const beneath = below ? $4216ea292092863c$var$cellsOf(below) : undefined;
    const lips = [];
    const floorAt = (x, y)=>cells.floor(x, y);
    storey.resolveTileMapFromLayerId("map2")?.forEach((column, x)=>column?.forEach((_, y)=>{
            // A wall standing on the cell is its edge already.
            if (!cells.floor(x, y) || cells.wall(x, y)) return;
            const open = (dx, dy)=>!$4216ea292092863c$var$carriesOn(cells, beneath, x + dx, y + dy);
            const north = open(0, -1), south = open(0, 1), west = open(-1, 0), east = open(1, 0);
            if (!north && !south && !west && !east) return;
            const rects = (0, $af4c175a7e8f40ad$export$7e53b5197744fc5d)(x, y, floorAt);
            if (south) {
                const band = $4216ea292092863c$var$southBand(rects);
                lips.push({
                    side: "south",
                    x0: band.x0,
                    y0: band.y1 - 2,
                    x1: band.x1,
                    y1: band.y1
                });
            }
            if (north) {
                const band = rects.reduce((high, rect)=>rect.y0 < high.y0 ? rect : high);
                lips.push({
                    side: "north",
                    x0: band.x0,
                    y0: band.y0,
                    x1: band.x1,
                    y1: band.y0 + 2
                });
            }
            for (const rect of rects){
                if (west) lips.push({
                    side: "west",
                    x0: rect.x0,
                    y0: rect.y0,
                    x1: rect.x0 + 2,
                    y1: rect.y1
                });
                if (east) lips.push({
                    side: "east",
                    x0: rect.x1 - 1,
                    y0: rect.y0,
                    x1: rect.x1,
                    y1: rect.y1
                });
            }
        }));
    return lips;
}
const $4216ea292092863c$var$LIGHT = 0xf0c890;
const $4216ea292092863c$var$SHADE = 0x0d0a08;
const $4216ea292092863c$var$EDGE = 0x4a301c;
const $4216ea292092863c$var$EDGE_LIGHT = 0x7a5536;
const $4216ea292092863c$var$EDGE_DARK = 0x2a1a10;
const $4216ea292092863c$var$LIP_STYLE = {
    // North is the lit back rim over the step shadow behind it: light over dark reads as the step.
    south: [
        $4216ea292092863c$var$LIGHT,
        1
    ],
    north: [
        $4216ea292092863c$var$LIGHT,
        1
    ],
    east: [
        $4216ea292092863c$var$LIGHT,
        0.65
    ],
    west: [
        $4216ea292092863c$var$SHADE,
        0.8
    ]
};
const $4216ea292092863c$export$d9c81065c6b57373 = (face)=>100 + face.edge - (0, $9667a1379a787b5e$export$5985b04c8e71b763);
class $4216ea292092863c$export$fcedb987e0a02405 {
    constructor(){
        this.lips = new (0, $gwPoJ.Graphics)();
        this.runs = [];
        this.steps = [];
        /** Everything this layer put into the surface, for a map handing its surface over. */ this.displayObjects = ()=>[
                this.lips,
                ...this.runs.map((run)=>run.art),
                ...this.steps.map((steps)=>steps.art)
            ];
        this.getFaces = ()=>this.runs.map((run)=>run.face);
        this.lips.interactive = false;
        // Tilemaps draw at zero, opening rims at 0.5; bodies, walls and stairs from 100.
        this.lips.zIndex = 0.6;
    }
    /** Rebuild when this storey or one above changed, then fade each face with the floor it hangs from. */ /**
     * `mayRebuild`: asked before redrawing edges already drawn for this room (frame_work_budget.ts claimHeavyWork), so a
     * rebuild can wait a frame for its turn; the first drawing in a room never waits.
     */ sync(provider, surface, mayRebuild) {
        const edges = $4216ea292092863c$export$b243cb41db6bd29c();
        const sun = !!(0, $ff5e8e678ac263ca$export$c83a039e3272b805)().enabled;
        const config = sun ? {
            ...edges,
            under: edges.under * (edges.underWithSun ?? $4216ea292092863c$export$56b5b58aaec914ee.underWithSun)
        } : edges;
        const uppers = [];
        for(let upper = provider?.getUpperFloorProvider(); upper && upper !== provider && !uppers.includes(upper); upper = upper.getUpperFloorProvider())uppers.push(upper);
        const below = provider?.getFloorSupportProvider();
        const stamp = (p)=>p ? `${p.roomId}:${p.getPresentationVersion()}:${p.twoStoreyHouse?.floor}` : "";
        const version = provider && config.enabled ? [
            sun,
            config.thickness,
            config.under,
            config.lip,
            config.step,
            config.stepCore,
            config.stepWidth,
            (0, $2751e0027a1b432f$export$de62489b685ceb),
            stamp(provider),
            stamp(below),
            ...uppers.map(stamp)
        ].join("|") : undefined;
        const sameRoom = !!provider && provider.roomId === this.builtRoomId;
        if (version !== this.version && (!sameRoom || this.version === undefined || !mayRebuild || mayRebuild())) {
            this.version = version;
            this.builtRoomId = provider?.roomId;
            this.rebuild(version ? provider : undefined, below, uppers, config, sun);
        }
        for (const child of this.displayObjects())if (child.parent !== surface) surface.addChild(child);
        for (const run of this.runs){
            const alpha = (0, $21141db879ebc35b$export$b1e07aa98e0f145b)(run.face.roomId, run.face.x, run.face.y);
            run.art.alpha = alpha;
            run.art.visible = alpha > 0.01;
        }
        // A storey cut away over the player still stands there: its step shadows follow the storey, not the cut.
        for (const steps of this.steps){
            steps.art.alpha = (0, $21141db879ebc35b$export$b1e07aa98e0f145b)(steps.roomId, NaN, NaN);
            steps.art.visible = steps.art.alpha > 0.01;
        }
    }
    rebuild(provider, below, uppers, config, sun = false) {
        this.lips.clear();
        this.runs.forEach((run)=>run.art.destroy());
        this.runs = [];
        this.steps.forEach((steps)=>steps.art.destroy());
        this.steps = [];
        if (!provider?.twoStoreyHouse) return;
        for (const lip of $4216ea292092863c$export$3509f2c4ca17e83a(provider, below)){
            const [color, strength] = $4216ea292092863c$var$LIP_STYLE[lip.side];
            this.lips.beginFill(color, config.lip * strength).drawRect(lip.x0, lip.y0, lip.x1 - lip.x0, lip.y1 - lip.y0).endFill();
        }
        for (const face of $4216ea292092863c$export$ff4c0ea3a04e4c86(provider, uppers)){
            const art = new (0, $gwPoJ.Graphics)();
            art.interactive = false;
            art.zIndex = $4216ea292092863c$export$d9c81065c6b57373(face);
            $4216ea292092863c$var$drawFace(art, face, config);
            this.runs.push({
                face: face,
                art: art
            });
        }
        for (const shadow of $4216ea292092863c$export$ec27c7a57e317ba2(provider, uppers)){
            // The sun casts the east and west ones for real now (or, east, none at all).
            if (sun && shadow.side !== "north") continue;
            let steps = this.steps.find((drawn)=>drawn.roomId === shadow.roomId);
            if (!steps) {
                steps = {
                    roomId: shadow.roomId,
                    art: new (0, $gwPoJ.Graphics)()
                };
                steps.art.interactive = false;
                // On the floor, over the lips and opening rims; under every wall and body.
                steps.art.zIndex = 0.7;
                this.steps.push(steps);
            }
            $4216ea292092863c$var$drawStepShadow(steps.art, shadow, config);
        }
    }
    destroy() {
        this.lips.destroy();
        this.runs.forEach((run)=>run.art.destroy());
        this.runs = [];
        this.steps.forEach((steps)=>steps.art.destroy());
        this.steps = [];
        this.version = undefined;
    }
}
const $4216ea292092863c$var$drawFace = (g, face, config)=>{
    const top = face.edge - face.drop, width = face.x1 - face.x0;
    const thickness = Math.min(config.thickness, face.drop);
    // The floor below, seen beneath the overhang: darkest deep under the slab, easing toward the open edge.
    const steps = 8, from = top + thickness;
    for(let i = 0; i < steps; i++){
        const y0 = Math.round(from + (face.edge - from) * i / steps), y1 = Math.round(from + (face.edge - from) * (i + 1) / steps);
        if (y1 > y0) g.beginFill($4216ea292092863c$var$SHADE, config.under * (1 - i / steps)).drawRect(face.x0, y0, width, y1 - y0).endFill();
    }
    // Contact shadow where the overhang's shade meets the open floor.
    g.beginFill($4216ea292092863c$var$SHADE, 0.18).drawRect(face.x0, face.edge, width, 3).endFill();
    // The floor's own thickness, its top edge catching the light.
    g.beginFill($4216ea292092863c$var$EDGE, 1).drawRect(face.x0, top, width, thickness).endFill();
    if (thickness >= 3) {
        g.beginFill($4216ea292092863c$var$EDGE_LIGHT, 1).drawRect(face.x0, top + 1, width, 1).endFill();
        g.beginFill($4216ea292092863c$var$EDGE_DARK, 1).drawRect(face.x0, top + thickness - 1, width, 1).endFill();
    }
};
/** A crisp line at the foot of the step, then a shade easing away over the lower floor. */ const $4216ea292092863c$var$drawStepShadow = (g, shadow, config)=>{
    const length = shadow.to - shadow.from;
    for(let i = 0; i < config.stepWidth; i++){
        const alpha = i < 2 ? config.stepCore : config.step * Math.pow(1 - (i - 2) / Math.max(1, config.stepWidth - 2), 1.6);
        if (alpha <= 0) continue;
        g.beginFill($4216ea292092863c$var$SHADE, alpha);
        if (shadow.side === "north") g.drawRect(shadow.from, shadow.at - i - 1, length, 1);
        else g.drawRect(shadow.side === "east" ? shadow.at + i : shadow.at - i - 1, shadow.from, 1, length);
        g.endFill();
    }
};




// How much of the day it is, for the ambience effects that only belong at one end of it: windblown
// leaves by day (wind_leaves.ts), fog by night (night_fog.ts). One place, so the two cross-fade
// against the same numbers instead of drifting apart.
//
// WHY BRIGHTNESS AND NOT THE PHASE NAME. The engine has six phases, each with a brightness
// (game-common/mechanics/physics_mechanics.ts):
//
//     darkestNight 0.2   night 0.3   dawn 0.4   dusk 0.5   morning 0.7   day 1.0
//
// and the client walks `currentBrightness` between them a hundredth at a time rather than snapping
// (ClientGameLogic.updateDayPhase). Reading the interpolated value means an effect dies across the
// whole of dusk and gets up across the whole of the morning; reading the phase NAME would step it,
// and a wind that stops mid-gust on a phase boundary looks like a bug.
// At or below STILL there is no daylight left as far as these effects are concerned; at or above FULL
// it is broad day; between them it ramps. This puts dawn (0.4) and every darker phase at zero and
// morning (0.7) upward at one, leaving dusk (0.5) as the half-lit third.
//
// 0.42 sits deliberately BETWEEN two phase brightnesses. On a threshold a settled phase could land
// exactly on, an effect that starts and stops at the boundary would flicker on and off forever.
const $eca6088c9a6d9651$export$9916be3f5943c55c = 0.42;
const $eca6088c9a6d9651$export$82825f99e114a585 = 0.7;
const $eca6088c9a6d9651$export$45f6af437d59d9ba = (brightness)=>{
    if (brightness === undefined) return 1;
    const span = $eca6088c9a6d9651$export$82825f99e114a585 - $eca6088c9a6d9651$export$9916be3f5943c55c;
    return Math.min(1, Math.max(0, (brightness - $eca6088c9a6d9651$export$9916be3f5943c55c) / span));
};
const $eca6088c9a6d9651$export$92091d9bb73d8475 = (brightness)=>1 - $eca6088c9a6d9651$export$45f6af437d59d9ba(brightness);


const $3462bfbeaff010be$export$4bccb4f7607c3eec = 22;
const $3462bfbeaff010be$export$7bac97f9fd8f9135 = 0.6;
const $3462bfbeaff010be$export$4e07af95bd4178be = (tSeconds, gustiness)=>Math.max(0.15, 1 + gustiness * (0.62 * Math.sin(tSeconds * 0.41) + 0.38 * Math.sin(tSeconds * 1.13 + 1.7)));
const $3462bfbeaff010be$export$317929bda4a1dd52 = (config, tSeconds)=>{
    const w = window;
    const forced = typeof w.windLeaves === "boolean" ? w.windLeaves : undefined;
    const enabled = forced !== undefined ? forced : !!config?.enabled;
    if (!enabled) return null;
    const num = (override, value, fallback)=>typeof override === "number" ? override : typeof value === "number" ? value : fallback;
    const rad = num(w.windLeavesDirection, config?.directionDeg, $3462bfbeaff010be$export$4bccb4f7607c3eec) * Math.PI / 180;
    const gustiness = Math.min(1, Math.max(0, num(w.windLeavesGust, config?.gustiness, $3462bfbeaff010be$export$7bac97f9fd8f9135)));
    return {
        x: Math.cos(rad),
        y: Math.sin(rad),
        gust: $3462bfbeaff010be$export$4e07af95bd4178be(tSeconds, gustiness)
    };
};


class $ce5d8c9ba4707e67$export$759431532c42f1f4 {
    constructor(objects){
        this.objects = objects;
        this.bent = new Map();
        this.nearby = [];
        this.gatherAt = -Infinity;
        this.gatherX = Infinity;
        this.gatherY = Infinity;
        this.objectCount = -1;
        this.// Restore before hits, falls, redraws, or the next frame. Ownership and last-write checks keep
        // detached/recycled pool sprites out of this effect's hands.
        release = (key)=>{
            const tree = this.bent.get(key);
            if (!tree) return 0;
            if (this.objects.get(key) === tree.object) for (const p of tree.pieces){
                const s = p.sprite;
                if (!s.destroyed && s.parent && tree.object.spriteSet.includes(s) && s.x === p.written && s.skew.x === p.skew) {
                    s.x = p.x;
                    s.skew.x = 0;
                }
            }
            this.bent.delete(key);
            return tree.angle;
        };
        this.clear = ()=>{
            for (const key of this.bent.keys())this.release(key);
        };
        this.reset = ()=>{
            this.clear();
            this.nearby = [];
            this.gatherAt = -Infinity;
        };
        this.update = (config, center, storm = 0, brightness, busy = ()=>false, now = performance.now())=>{
            this.clear();
            if (!center || window.treeSway === false) return;
            const wind = (0, $3462bfbeaff010be$export$317929bda4a1dd52)(config ?? (storm > 0 ? {
                enabled: true
            } : null), now / 1000);
            if (!wind) return;
            const strength = 0.0025 * (0.3 + 0.7 * (0, $eca6088c9a6d9651$export$45f6af437d59d9ba)(brightness)) + 0.013 * storm;
            // Gather occasionally rather than scanning the room's entire tile registry every frame.
            // The extra tile of margin covers movement until the next gather. Replaced objects are
            // rejected below, so a removed tree can never keep bending a reused pool sprite.
            if (now - this.gatherAt >= 250 || this.objectCount !== this.objects.size || Math.abs(center.x - this.gatherX) > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) || Math.abs(center.y - this.gatherY) > (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) {
                this.nearby = [];
                for (const entry of this.objects){
                    const root = entry[1].treeWind;
                    if (root && Math.abs(root.x - center.x) <= 13 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) && Math.abs(root.y - center.y) <= 13 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) this.nearby.push(entry);
                }
                this.gatherAt = now;
                this.gatherX = center.x;
                this.gatherY = center.y;
                this.objectCount = this.objects.size;
            }
            for (const [key, object] of this.nearby){
                const root = object.treeWind;
                if (this.objects.get(key) !== object || busy(key)) continue;
                const phase = (root.x * wind.x + root.y * wind.y) / (6 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) + Math.sin(root.x * 12.9898 + root.y * 78.233) * 0.45;
                let angle = wind.x * wind.gust * strength * (0.65 + 0.35 * Math.sin(now / 1000 * 1.4 - phase));
                // A tall tree should still move just a few pixels at its crown.
                let top = Infinity;
                for (const s of object.spriteSet)if (!s.destroyed && s.parent) top = Math.min(top, s.y);
                if (top === Infinity) continue;
                const height = root.y - top;
                const limit = 4 / Math.max(1, height);
                angle = Math.max(-limit, Math.min(limit, angle));
                // Never write an invalid weather value into a persistent sprite transform. NaN
                // also fails the last-write equality check in release(), so it cannot be restored.
                if (!Number.isFinite(angle)) continue;
                const pieces = [];
                for (const sprite of object.spriteSet){
                    if (sprite.destroyed || !sprite.parent) continue;
                    const x = sprite.x;
                    const skew = -Math.asin(angle);
                    sprite.x = x + angle * (root.y - sprite.y);
                    sprite.skew.x = skew;
                    pieces.push({
                        sprite: sprite,
                        x: x,
                        written: sprite.x,
                        skew: skew
                    });
                }
                if (pieces.length) this.bent.set(key, {
                    object: object,
                    angle: angle,
                    pieces: pieces
                });
            }
        };
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
class $22c4fc79c5705c6e$export$9c5b1f65c085f81 {
    emit(surface, at, angle = 0, strength = 1) {
        if (this.impacts.length >= 24) this.impacts.shift()?.art.destroy();
        const art = new (0, $gwPoJ.Graphics)();
        art.position.set(at.x, at.y);
        art.zIndex = 100 + at.y;
        surface.addChild(art);
        this.impacts.push({
            art: art,
            start: performance.now(),
            strength: Math.max(.6, Math.min(2, strength)),
            angle: angle
        });
        this.update();
    }
    update() {
        const now = performance.now();
        this.impacts = this.impacts.filter((impact)=>{
            const { art: art, start: start, strength: strength, angle: angle } = impact;
            if (art.destroyed) return false;
            const t = Math.max(0, now - start) / 420;
            if (t >= 1) {
                art.destroy();
                return false;
            }
            art.clear();
            const spread = 1 - Math.pow(1 - t, 3);
            // A compressed ring and dust stay on the ground; the flecks have their own short arcs.
            art.lineStyle(1, 0xd6b682, .6 * Math.pow(1 - t, 2));
            art.drawEllipse(0, 0, (2 + 10 * spread) * strength, (1 + 3 * spread) * strength);
            art.lineStyle(0);
            art.beginFill(0xb6976d, .28 * Math.pow(1 - t, 2));
            art.drawEllipse(Math.cos(angle) * 3 * spread, -2 * spread, (2 + 7 * spread) * strength, (1 + 4 * spread) * strength);
            art.endFill();
            for(let i = 0; i < 6; i++){
                const direction = angle + i * Math.PI / 3;
                const radius = (6 + i % 3 * 3) * strength * spread;
                const lift = Math.sin(Math.PI * Math.min(1, t * 1.5)) * (3 + i % 2 * 3) * strength;
                art.beginFill(i % 2 ? 0x806345 : 0xc5a574, Math.pow(1 - t, 1.3));
                art.drawRect(Math.cos(direction) * radius, Math.sin(direction) * radius * .35 - lift, 1.5, 1.5);
                art.endFill();
            }
            return true;
        });
    }
    clear() {
        for (const impact of this.impacts)impact.art.destroy();
        this.impacts = [];
    }
    constructor(){
        this.impacts = [];
    }
}


/**
 * Reading a tree's art -- where its trunk is, where an axe lands on it, what its leaves and bark look
 * like -- and cutting the notch an axe leaves in it.
 *
 * Pure pixel work on an RGBA buffer, no pixi and no DOM, so it runs the same in a test as in the game
 * and the numbers below can be checked against the shipped art directly.
 *
 * WHY THE ART IS READ RATHER THAN DESCRIBED. Every tree species is drawn differently: the plants
 * tileset's pines and round oaks have a long straight trunk standing on a soft cast shadow, the
 * blossom tree a thin gnarled one, tree5 a stub buried in a root flare twice its width, tree6's trunk
 * sits a third of a tile right of the cell it is planted in. A per-species table of trunk positions
 * would be six hand-measured entries that silently go stale the first time the Lab redraws a tree.
 * Reading the silhouette gets all six right (see the numbers in tree_art.test.ts) and the next one too.
 *
 * The same read gives the effect its colours, which is the other half of why it is worth doing: the
 * leaves an axe shakes loose are the canopy's own greens -- or the blossom tree's pinks -- and the chips
 * are its own bark.
 */ // Alpha at or above which a pixel is the tree. The plants tileset bakes each tree's cast shadow into the
// same art at alpha 153; everything that is actually wood or leaf is 255.
const $cda41e870802b180$var$SOLID = 200;
// A row is canopy when its solid pixels reach this share of the widest row. 0.6 and not lower: tree5's
// root flare is just over half the width of its crown, and must not be read as the bottom of the canopy.
const $cda41e870802b180$var$CANOPY_SHARE = 0.6;
// Where on the trunk an axe lands: about this far above the roots, which is the height of a swing from
// a standing body (the hip line sits ~20px above the soles -- see entity-sort-line-is-the-hip).
const $cda41e870802b180$var$SWING_HEIGHT = 16;
// The trunk is searched for in the upper part of the gap between canopy and roots, which keeps a root
// flare -- wider than the trunk above it, and narrowing again to a point at the foot -- out of the
// running for "the narrowest part of the tree".
const $cda41e870802b180$var$TRUNK_BAND = 0.6;
const $cda41e870802b180$var$MAX_CANOPY_POINTS = 160;
// The tallest stump a felled tree leaves, in px above its roots. The axe bites at hip height, and a stump
// that tall reads as a post standing in the way; the tree is cut through lower, below the notch.
const $cda41e870802b180$var$STUMP_RISE = 9;
const $cda41e870802b180$export$b09c36a056f24d82 = [
    0x2f5a2a,
    0x3f7432,
    0x548c3a,
    0x6fa046,
    0x8bb85a
];
const $cda41e870802b180$export$1930a84180cc634d = [
    0x3f2a1c,
    0x5e3f28,
    0x7d5636
];
// What the inside of a tree looks like once an axe has opened it: always pale, whatever the bark.
const $cda41e870802b180$var$FRESH_WOOD = 0xe7cb98;
const $cda41e870802b180$var$FRESH_WOOD_DEEP = 0xc8a370;
const $cda41e870802b180$var$CUT_HEART = 0x785634;
const $cda41e870802b180$var$luminance = (rgb)=>0.299 * (rgb >> 16 & 255) + 0.587 * (rgb >> 8 & 255) + 0.114 * (rgb & 255);
// Colours at a spread of points along the dark-to-light order, de-duplicated. Percentiles rather than a
// histogram's peaks because a canopy is a gradient, and the leaves should span it.
const $cda41e870802b180$var$spread = (colors, at)=>{
    if (!colors.length) return [];
    const sorted = colors.slice().sort((a, b)=>$cda41e870802b180$var$luminance(a) - $cda41e870802b180$var$luminance(b));
    const out = [];
    for (const p of at){
        const c = sorted[Math.min(sorted.length - 1, Math.floor(p * sorted.length))];
        if (!out.includes(c)) out.push(c);
    }
    return out;
};
const $cda41e870802b180$var$rgbAt = (pixels, width, x, y)=>{
    const i = (y * width + x) * 4;
    return pixels[i] << 16 | pixels[i + 1] << 8 | pixels[i + 2];
};
// The solid run on row `y` containing column `cx`, or else the one whose middle is nearest it.
const $cda41e870802b180$var$runAt = (solid, width, y, cx)=>{
    let best;
    let bestDistance = Infinity;
    let x = 0;
    while(x < width){
        if (!solid[y * width + x]) {
            x++;
            continue;
        }
        const start = x;
        while(x < width && solid[y * width + x])x++;
        const end = x - 1;
        const distance = start <= cx && cx <= end ? -1 : Math.abs((start + end) / 2 - cx);
        if (distance < bestDistance) {
            bestDistance = distance;
            best = [
                start,
                end
            ];
        }
    }
    return best;
};
const $cda41e870802b180$export$e7b85b41095ef033 = (pixels, width, height)=>{
    if (!width || !height || pixels.length < width * height * 4) return undefined;
    const solid = new Uint8Array(width * height);
    const counts = new Array(height).fill(0);
    for(let y = 0; y < height; y++){
        for(let x = 0; x < width; x++)if (pixels[(y * width + x) * 4 + 3] >= $cda41e870802b180$var$SOLID) {
            solid[y * width + x] = 1;
            counts[y]++;
        }
    }
    let footY = -1;
    for(let y = height - 1; y >= 0; y--)if (counts[y] >= 2) {
        footY = y;
        break;
    }
    if (footY < 8) return undefined;
    // Where the trunk stands: the median column of the solid pixels just above the roots. Not the art's
    // middle, and not the planted cell's: tree6's trunk is twelve pixels right of both.
    const xs = [];
    for(let y = Math.max(0, footY - 20); y < footY; y++){
        for(let x = 0; x < width; x++)if (solid[y * width + x]) xs.push(x);
    }
    if (!xs.length) return undefined;
    xs.sort((a, b)=>a - b);
    const centerX = xs[Math.floor(xs.length / 2)];
    const widest = Math.max(...counts);
    let canopyBottomY = -1;
    for(let y = footY - 5; y >= 0; y--)if (counts[y] >= $cda41e870802b180$var$CANOPY_SHARE * widest) {
        canopyBottomY = y;
        break;
    }
    if (canopyBottomY < 0) return undefined;
    // The narrowest rows in the upper part of the trunk, and of those the one nearest swing height.
    const bandTop = canopyBottomY + 2;
    const bandBottom = Math.max(bandTop, Math.floor(canopyBottomY + $cda41e870802b180$var$TRUNK_BAND * (footY - canopyBottomY)));
    const runs = new Map();
    let narrowest = Infinity;
    for(let y = bandTop; y <= bandBottom && y < footY; y++){
        const run = $cda41e870802b180$var$runAt(solid, width, y, centerX);
        if (!run) continue;
        runs.set(y, run);
        narrowest = Math.min(narrowest, run[1] - run[0] + 1);
    }
    if (!runs.size) return undefined;
    let impactY = -1;
    runs.forEach((run, y)=>{
        if (run[1] - run[0] + 1 > narrowest + 3) return;
        if (impactY < 0 || Math.abs(y - (footY - $cda41e870802b180$var$SWING_HEIGHT)) < Math.abs(impactY - (footY - $cda41e870802b180$var$SWING_HEIGHT))) impactY = y;
    });
    const [trunkLeft, trunkRight] = runs.get(impactY);
    // A grid sample of the canopy, thinned evenly to the cap: leaves can come off anywhere on it.
    const grid = [];
    for(let y = 0; y <= canopyBottomY; y += 3){
        for(let x = 1; x < width; x += 3)if (solid[y * width + x]) grid.push(x, y);
    }
    const stride = Math.max(1, Math.ceil(grid.length / 2 / $cda41e870802b180$var$MAX_CANOPY_POINTS));
    const canopyPoints = [];
    const leafColors = [];
    for(let i = 0; i < grid.length; i += 2 * stride){
        canopyPoints.push(grid[i], grid[i + 1]);
        leafColors.push($cda41e870802b180$var$rgbAt(pixels, width, grid[i], grid[i + 1]));
    }
    const barkSample = [];
    for(let y = Math.max(0, impactY - 6); y <= Math.min(footY, impactY + 6); y++){
        for(let x = trunkLeft; x <= trunkRight; x++)if (solid[y * width + x]) barkSample.push($cda41e870802b180$var$rgbAt(pixels, width, x, y));
    }
    return {
        width: width,
        height: height,
        footY: footY,
        canopyBottomY: canopyBottomY,
        impactY: impactY,
        trunkLeft: trunkLeft,
        trunkRight: trunkRight,
        canopyPoints: canopyPoints,
        canopyColors: $cda41e870802b180$var$spread(leafColors, [
            0.2,
            0.4,
            0.6,
            0.8,
            0.92
        ]),
        barkColors: $cda41e870802b180$var$spread(barkSample, [
            0.15,
            0.5,
            0.85
        ])
    };
};
const $cda41e870802b180$export$7237cfdeb6b5edff = (width, height)=>{
    const footY = Math.max(0, Math.round(height - 12));
    const canopyBottomY = Math.round(height * 0.55);
    const cx = width / 2;
    const canopyPoints = [];
    const rx = width * 0.4;
    const ry = canopyBottomY * 0.48;
    const cy = canopyBottomY - ry;
    for(let y = 0; y <= canopyBottomY; y += 6){
        for(let x = 0; x < width; x += 6)if (((x - cx) / rx) ** 2 + ((y - cy) / ry) ** 2 <= 1) canopyPoints.push(x, y);
    }
    const impactY = Math.max(canopyBottomY + 2, footY - $cda41e870802b180$var$SWING_HEIGHT);
    return {
        width: width,
        height: height,
        footY: footY,
        canopyBottomY: canopyBottomY,
        impactY: impactY,
        trunkLeft: Math.round(cx - 6),
        trunkRight: Math.round(cx + 5),
        canopyPoints: canopyPoints,
        canopyColors: $cda41e870802b180$export$b09c36a056f24d82,
        barkColors: $cda41e870802b180$export$1930a84180cc634d
    };
};
const $cda41e870802b180$export$fa49dfa6649e4406 = (pixels, width, height, art, damage, side)=>{
    const out = new Uint8ClampedArray(pixels);
    const d = Math.max(0, Math.min(1, damage));
    if (d <= 0) return out;
    const trunkWidth = art.trunkRight - art.trunkLeft + 1;
    const centerX = (art.trunkLeft + art.trunkRight) / 2;
    const depth = Math.max(2, Math.round(trunkWidth * (0.2 + 0.45 * d)));
    const above = 1 + Math.round(3.5 * d);
    const below = 1 + Math.round(d);
    const heart = art.barkColors.length ? art.barkColors[0] : $cda41e870802b180$var$CUT_HEART;
    // Read solidity off the ORIGINAL art: the rows are cut one at a time, and a row must find its trunk
    // edge where the bark is, not where the row above was just cut back to.
    const solidAt = (x, y)=>pixels[(y * width + x) * 4 + 3] >= $cda41e870802b180$var$SOLID;
    const paint = (x, y, rgb, alpha = 255)=>{
        const i = (y * width + x) * 4;
        out[i] = rgb >> 16 & 255;
        out[i + 1] = rgb >> 8 & 255;
        out[i + 2] = rgb & 255;
        out[i + 3] = alpha;
    };
    for(let dy = -above; dy <= below; dy++){
        const y = art.impactY + dy;
        if (y < 0 || y >= height) continue;
        const taper = dy < 0 ? 1 + dy / (above + 0.5) : 1 - dy / (below + 0.5);
        const cut = Math.max(dy === 0 ? 1 : 0, Math.round(depth * taper));
        if (!cut) continue;
        // This row's own trunk edge on the struck side: the bark is not a straight column.
        let left = Math.round(centerX);
        let right = left;
        if (!solidAt(left, y)) continue;
        while(left > 0 && solidAt(left - 1, y))left--;
        while(right < width - 1 && solidAt(right + 1, y))right++;
        const edge = side > 0 ? right : left;
        const room = right - left + 1;
        const reach = Math.min(cut, room - 1);
        for(let k = 0; k < reach; k++){
            const x = edge - k * Math.sign(side || 1);
            if (dy < 0) paint(x, y, 0, 0);
            else paint(x, y, dy === below || k >= reach * 0.6 ? $cda41e870802b180$var$FRESH_WOOD_DEEP : $cda41e870802b180$var$FRESH_WOOD);
        }
        const deepest = edge - reach * Math.sign(side || 1);
        if (deepest >= 0 && deepest < width && solidAt(deepest, y)) paint(deepest, y, dy < 0 ? heart : $cda41e870802b180$var$CUT_HEART);
    }
    return out;
};
const $cda41e870802b180$export$843effe7554b5528 = (pixels, width, height, art, side)=>{
    const fall = side < 0 ? -1 : 1;
    const notched = $cda41e870802b180$export$fa49dfa6649e4406(pixels, width, height, art, 1, -fall);
    const cutY = Math.min(art.footY, Math.max(art.impactY + 1, art.footY - $cda41e870802b180$var$STUMP_RISE));
    const crown = new Uint8ClampedArray(width * height * 4);
    const stump = new Uint8ClampedArray(width * height * 4);
    let shadow;
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
        const i = (y * width + x) * 4;
        const a = notched[i + 3];
        if (!a) continue;
        // Translucent under the canopy is the baked cast shadow, wherever it reaches up to.
        let target = a < $cda41e870802b180$var$SOLID && y > art.canopyBottomY ? undefined : y < cutY ? crown : stump;
        if (!target) target = shadow = shadow || new Uint8ClampedArray(width * height * 4);
        target[i] = notched[i];
        target[i + 1] = notched[i + 1];
        target[i + 2] = notched[i + 2];
        target[i + 3] = a;
    }
    // The cut face, across the trunk as it stands at the cut line on the ORIGINAL art.
    const solid = new Uint8Array(width * height);
    for(let i = 0; i < width * height; i++)solid[i] = pixels[i * 4 + 3] >= $cda41e870802b180$var$SOLID ? 1 : 0;
    const [left, right] = $cda41e870802b180$var$runAt(solid, width, cutY, (art.trunkLeft + art.trunkRight) / 2) || [
        art.trunkLeft,
        art.trunkRight
    ];
    const rx = (right - left + 1) / 2;
    const ry = Math.max(1, Math.round(rx * 0.45));
    const cx = left + rx;
    const cy = cutY - ry;
    const rim = art.barkColors.length ? art.barkColors[0] : $cda41e870802b180$export$1930a84180cc634d[0];
    const bark = art.barkColors.length ? art.barkColors[Math.floor(art.barkColors.length / 2)] : $cda41e870802b180$export$1930a84180cc634d[1];
    const paint = (x, y, rgb)=>{
        if (x < 0 || x >= width || y < 0 || y >= height) return;
        const i = (y * width + x) * 4;
        stump[i] = rgb >> 16 & 255;
        stump[i + 1] = rgb >> 8 & 255;
        stump[i + 2] = rgb & 255;
        stump[i + 3] = 255;
    };
    const inside = (x, y)=>((x + 0.5 - cx) / rx) ** 2 + ((y + 0.5 - cy) / (ry + 0.5)) ** 2 <= 1;
    for(let y = cy - ry; y < cutY; y++)for(let x = left; x <= right; x++){
        if (!inside(x, y)) continue;
        const edge = !inside(x - 1, y) || !inside(x + 1, y) || !inside(x, y - 1) || !inside(x, y + 1);
        const r = Math.hypot((x + 0.5 - cx) / rx, (y + 0.5 - cy) / (ry + 0.5));
        if (edge) // The far rim is the bark's dark outline; the near rim, the bark face of the stump.
        paint(x, y, y < cy ? rim : bark);
        else paint(x, y, r < 0.3 ? $cda41e870802b180$var$CUT_HEART : r < 0.6 ? $cda41e870802b180$var$FRESH_WOOD_DEEP : $cda41e870802b180$var$FRESH_WOOD);
    }
    return {
        crown: crown,
        stump: stump,
        shadow: shadow,
        cutY: cutY,
        hingeX: fall > 0 ? right + 1 : left
    };
};
// A repeatable 0..1 value for an integer point.
const $cda41e870802b180$var$hash2 = (x, y)=>{
    let h = x * 374761393 + y * 668265263 | 0;
    h = Math.imul(h ^ h >>> 13, 1274126177);
    return ((h ^ h >>> 16) >>> 0) / 4294967296;
};
// Smooth noise at `cell` px: blotches of about a leaf cluster's size, so the crown comes apart in clumps.
const $cda41e870802b180$var$blotch = (x, y, cell)=>{
    const gx = x / cell;
    const gy = y / cell;
    const x0 = Math.floor(gx);
    const y0 = Math.floor(gy);
    const fx = gx - x0;
    const fy = gy - y0;
    const sx = fx * fx * (3 - 2 * fx);
    const sy = fy * fy * (3 - 2 * fy);
    const top = $cda41e870802b180$var$hash2(x0, y0) + ($cda41e870802b180$var$hash2(x0 + 1, y0) - $cda41e870802b180$var$hash2(x0, y0)) * sx;
    const bottom = $cda41e870802b180$var$hash2(x0, y0 + 1) + ($cda41e870802b180$var$hash2(x0 + 1, y0 + 1) - $cda41e870802b180$var$hash2(x0, y0 + 1)) * sx;
    return top + (bottom - top) * sy;
};
const $cda41e870802b180$export$b076bc0720750241 = (x, y, hingeX, cutY, reach)=>{
    const distance = Math.hypot(x - hingeX, y - cutY) / Math.max(1, reach);
    return 0.4 * $cda41e870802b180$var$blotch(x, y, 4) + 0.1 * $cda41e870802b180$var$hash2(x, y) + 0.5 * (1 - Math.min(1, distance));
};
const $cda41e870802b180$export$1d9b048f58b250d9 = (width, hingeX, cutY)=>Math.hypot(Math.max(hingeX, width - hingeX), cutY);
const $cda41e870802b180$export$d6e511f97dd6b58e = (width, height, hingeX, cutY)=>{
    const orders = new Float32Array(width * height);
    const reach = $cda41e870802b180$export$1d9b048f58b250d9(width, hingeX, cutY);
    for(let y = 0; y < Math.min(height, cutY); y++)for(let x = 0; x < width; x++)orders[y * width + x] = $cda41e870802b180$export$b076bc0720750241(x, y, hingeX, cutY, reach);
    return orders;
};
const $cda41e870802b180$export$f273f1b16f62b577 = (crown, orders, t)=>{
    const out = new Uint8ClampedArray(crown);
    for(let i = 0; i < orders.length; i++)if (out[i * 4 + 3] && orders[i] < t) out[i * 4 + 3] = 0;
    return out;
};


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");
// Same convention as FootDust: something lying on the ground at groundY sorts like a body whose soles
// are there, and a body's sort line is its hip, this far above its soles.
const $a0018fcc72efc0ff$var$FOOT_DROP = 20;
const $a0018fcc72efc0ff$var$CHIP_GRAVITY = 480;
const $a0018fcc72efc0ff$var$CHIP_REST_MS = [
    450,
    950
];
const $a0018fcc72efc0ff$var$LEAF_GRAVITY = 160;
const $a0018fcc72efc0ff$var$LEAF_DRAG = 2.4;
const $a0018fcc72efc0ff$var$LEAF_REST_MS = [
    600,
    1300
];
const $a0018fcc72efc0ff$var$FADE_MS = 380;
const $a0018fcc72efc0ff$export$1d11fb5839f528b2 = 140;
const $a0018fcc72efc0ff$export$cf95c51b03f10bae = (min, max)=>min + Math.random() * (max - min);
const $a0018fcc72efc0ff$export$357523c63a2253b9 = (list)=>list[Math.floor(Math.random() * list.length)];
class $a0018fcc72efc0ff$export$321f8791b80b52dd {
    constructor(surface, makeTextures){
        this.bits = [];
        this.pool = [];
        this.count = ()=>this.bits.length;
        /** A chip of wood or bark: arcs out, bounces once, lies in the dirt. Size in px. */ this.chip = (at, tint, nowMs, size = {
            w: $a0018fcc72efc0ff$export$cf95c51b03f10bae(1.5, 3),
            h: $a0018fcc72efc0ff$export$cf95c51b03f10bae(1, 1.8)
        })=>{
            const sprite = this.add((0, $klOfb.Texture).WHITE);
            if (!sprite) return false;
            sprite.anchor.set(0.5);
            sprite.scale.set(size.w / (0, $klOfb.Texture).WHITE.width, size.h / (0, $klOfb.Texture).WHITE.height);
            sprite.rotation = Math.random() * Math.PI;
            sprite.tint = tint;
            this.push({
                ...this.blank(0, sprite, nowMs, at),
                spin: (Math.random() < 0.5 ? -1 : 1) * $a0018fcc72efc0ff$export$cf95c51b03f10bae(8, 20),
                restMs: $a0018fcc72efc0ff$export$cf95c51b03f10bae($a0018fcc72efc0ff$var$CHIP_REST_MS[0], $a0018fcc72efc0ff$var$CHIP_REST_MS[1])
            });
            return true;
        };
        /** A leaf: flung, then the air takes over -- it sways, tumbles edge-on and settles flat. */ this.leaf = (at, tint, nowMs, scale = $a0018fcc72efc0ff$export$cf95c51b03f10bae(0.26, 0.4))=>{
            const leaves = this.leaves;
            if (!leaves.length) return false;
            const sprite = this.add($a0018fcc72efc0ff$export$357523c63a2253b9(leaves));
            if (!sprite) return false;
            sprite.anchor.set(0.5);
            sprite.scale.set(scale);
            sprite.rotation = Math.random() * Math.PI * 2;
            sprite.tint = tint;
            this.push({
                ...this.blank(1, sprite, nowMs, at),
                scale: scale,
                terminal: $a0018fcc72efc0ff$export$cf95c51b03f10bae(40, 62),
                swayAmp: $a0018fcc72efc0ff$export$cf95c51b03f10bae(10, 22),
                swayFreq: $a0018fcc72efc0ff$export$cf95c51b03f10bae(2.2, 4),
                swayPhase: Math.random() * Math.PI * 2,
                flutterFreq: $a0018fcc72efc0ff$export$cf95c51b03f10bae(5, 10),
                flutterPhase: Math.random() * Math.PI * 2,
                spin: (Math.random() < 0.5 ? -1 : 1) * $a0018fcc72efc0ff$export$cf95c51b03f10bae(1.5, 4.5),
                restMs: $a0018fcc72efc0ff$export$cf95c51b03f10bae($a0018fcc72efc0ff$var$LEAF_REST_MS[0], $a0018fcc72efc0ff$var$LEAF_REST_MS[1])
            });
            return true;
        };
        /** A puff of dust that swells and thins out over `lifeMs`, `growth` times its starting size. */ this.puff = (at, tint, nowMs, look)=>{
            const puffs = this.puffs;
            if (!puffs.length) return false;
            const sprite = this.add($a0018fcc72efc0ff$export$357523c63a2253b9(puffs));
            if (!sprite) return false;
            sprite.anchor.set(0.5, 0.7);
            sprite.tint = tint;
            sprite.rotation = Math.random() * Math.PI * 2;
            this.push({
                ...this.blank(2, sprite, nowMs, at),
                ...look,
                spin: $a0018fcc72efc0ff$export$cf95c51b03f10bae(-0.8, 0.8)
            });
            return true;
        };
        this.update = (nowMs, dt)=>{
            if (!this.bits.length) return;
            const leafDrag = Math.exp(-$a0018fcc72efc0ff$var$LEAF_DRAG * dt);
            let write = 0;
            for(let i = 0; i < this.bits.length; i++){
                const bit = this.bits[i];
                const sprite = bit.sprite;
                if (sprite.destroyed) continue;
                if (bit.kind === 2) {
                    const age = (nowMs - bit.bornMs) / bit.lifeMs;
                    if (age >= 1) {
                        this.retire(bit);
                        continue;
                    }
                    bit.x += bit.vx * dt;
                    bit.groundY += bit.vy * dt;
                    bit.z += bit.vz * dt;
                    bit.vx *= Math.exp(-5 * dt);
                    bit.vy *= Math.exp(-5 * dt);
                    bit.vz *= Math.exp(-3 * dt);
                    sprite.rotation += bit.spin * dt;
                    const eased = 1 - (1 - age) * (1 - age);
                    sprite.scale.set(bit.scale * (1 + (bit.growth - 1) * eased));
                    sprite.alpha = bit.alpha * (age < 0.15 ? age / 0.15 : 1 - ((age - 0.15) / 0.85) ** 2);
                } else if (!bit.landedMs) {
                    if (bit.kind === 0) {
                        bit.vz -= $a0018fcc72efc0ff$var$CHIP_GRAVITY * dt;
                        bit.x += bit.vx * dt;
                        bit.groundY += bit.vy * dt;
                        bit.z += bit.vz * dt;
                        sprite.rotation += bit.spin * dt;
                        if (bit.z <= 0) {
                            bit.z = 0;
                            if (bit.bounces < 1 && bit.vz < -40) {
                                // One hop, much smaller, and most of the slide is gone.
                                bit.vz = -bit.vz * 0.32;
                                bit.vx *= 0.45;
                                bit.vy *= 0.45;
                                bit.spin *= 0.5;
                                bit.bounces++;
                            } else bit.landedMs = nowMs;
                        }
                    } else {
                        bit.vz = Math.max(bit.vz - $a0018fcc72efc0ff$var$LEAF_GRAVITY * dt, -bit.terminal);
                        bit.vx *= leafDrag;
                        bit.vy *= leafDrag;
                        const t = (nowMs - bit.bornMs) / 1000;
                        bit.x += (bit.vx + bit.swayAmp * Math.sin(t * bit.swayFreq + bit.swayPhase)) * dt;
                        bit.groundY += bit.vy * dt;
                        bit.z += bit.vz * dt;
                        sprite.rotation += bit.spin * dt;
                        // Turning edge-on and back as it tumbles.
                        const flutter = Math.abs(Math.cos(t * bit.flutterFreq + bit.flutterPhase));
                        sprite.scale.set(bit.scale, bit.scale * (0.3 + 0.7 * flutter));
                        if (bit.z <= 0) {
                            bit.z = 0;
                            bit.landedMs = nowMs;
                            // Lying flat, seen at the camera's angle.
                            sprite.scale.set(bit.scale, bit.scale * 0.55);
                        }
                    }
                } else {
                    const lying = nowMs - bit.landedMs;
                    if (lying >= bit.restMs + $a0018fcc72efc0ff$var$FADE_MS) {
                        this.retire(bit);
                        continue;
                    }
                    sprite.alpha = lying > bit.restMs ? bit.alpha * (1 - (lying - bit.restMs) / $a0018fcc72efc0ff$var$FADE_MS) : bit.alpha;
                }
                this.draw(bit);
                this.bits[write++] = bit;
            }
            this.bits.length = write;
        };
        /** Sweep every bit away (a new room). */ this.clear = ()=>{
            this.bits.forEach(this.retire);
            this.bits = [];
        };
        this.draw = (bit)=>{
            const sprite = bit.sprite;
            sprite.x = bit.x;
            sprite.y = bit.groundY - bit.z;
            const z = Math.max(100 + bit.groundY - $a0018fcc72efc0ff$var$FOOT_DROP, bit.zFloor);
            // zIndex marks the whole world surface for a re-sort; only touch it when it moved.
            if (sprite.zIndex !== z) sprite.zIndex = z;
        };
        this.add = (texture)=>{
            if (this.bits.length >= $a0018fcc72efc0ff$export$1d11fb5839f528b2) return undefined;
            const sprite = this.pool.pop() || new (0, $7Bs2Z.Sprite)(texture);
            sprite.texture = texture;
            sprite.alpha = 1;
            sprite.scale.set(1);
            sprite.skew.set(0);
            sprite.rotation = 0;
            this.surface.addChild(sprite);
            return sprite;
        };
        this.push = (bit)=>{
            this.bits.push(bit);
            this.draw(bit);
        };
        this.blank = (kind, sprite, nowMs, at)=>({
                kind: kind,
                sprite: sprite,
                x: at.x,
                groundY: at.groundY,
                z: at.z,
                vx: at.vx,
                vy: at.vy ?? 0,
                vz: at.vz,
                zFloor: at.zFloor,
                spin: 0,
                scale: 1,
                alpha: 1,
                bornMs: nowMs,
                landedMs: 0,
                restMs: 0,
                bounces: 0,
                terminal: 0,
                swayAmp: 0,
                swayFreq: 0,
                swayPhase: 0,
                flutterFreq: 0,
                flutterPhase: 0,
                lifeMs: 0,
                growth: 1
            });
        // Built on the first particle, not at construction: the renderer may not be able to bake a texture
        // yet, and in a test there is no GPU at all.
        this.ensureTextures = ()=>{
            if (!this.textures) try {
                this.textures = this.makeTextures();
            } catch (e) {
                this.textures = {
                    leaves: [],
                    puffs: []
                };
            }
            return this.textures;
        };
        this.retire = (bit)=>{
            bit.sprite.parent?.removeChild(bit.sprite);
            if (!bit.sprite.destroyed) {
                if (this.pool.length < $a0018fcc72efc0ff$export$1d11fb5839f528b2) this.pool.push(bit.sprite);
                else bit.sprite.destroy();
            }
        };
        this.surface = surface;
        this.makeTextures = makeTextures;
    }
    setSurface(surface) {
        this.surface = surface;
    }
    /** The leaf and puff textures, built on first use: in a test there is no GPU to bake them. */ get leaves() {
        return this.ensureTextures().leaves;
    }
    get puffs() {
        return this.ensureTextures().puffs;
    }
}


// Integration step for the spring: semi-implicit Euler is comfortably stable at 4ms for a 3Hz spring,
// and a long frame is taken in several of these rather than one big step.
const $7fe91d19123d7ca1$var$STEP = 1 / 240;
// A frame longer than this is a stall, not motion.
const $7fe91d19123d7ca1$var$MAX_FRAME_SECONDS = 0.05;
// Hard limit on the lean, however many blows stack up: about four degrees.
const $7fe91d19123d7ca1$var$MAX_LEAN = 0.075;
// Below both of these the tree is upright and still, and is handed back to the map untouched.
const $7fe91d19123d7ca1$var$REST_ANGLE = 0.0004;
const $7fe91d19123d7ca1$var$REST_VELOCITY = 0.01;
const $7fe91d19123d7ca1$var$CHIP_SPEED_MIN = 35;
const $7fe91d19123d7ca1$var$CHIP_SPEED_MAX = 95;
const $7fe91d19123d7ca1$var$PUFF_LIFE_MS = 420;
const $7fe91d19123d7ca1$export$885666579e701cb5 = [
    0xe7cb98,
    0xd8b37c,
    0xc99c63
];
const $7fe91d19123d7ca1$export$7603bd6f61b623e3 = 0xd6c2a0;
const $7fe91d19123d7ca1$var$alive = (s)=>!!s && !s.destroyed && !!s.transform && !!s.parent;
const $7fe91d19123d7ca1$var$spriteHeight = (s)=>s.texture.height * Math.abs(s.scale.y);
// Peak lean reached by a spring at rest kicked with unit velocity: the impulse is sized from this, so
// `lean` means the peak whatever the frequency and damping are tuned to.
const $7fe91d19123d7ca1$var$peakPerUnitVelocity = (omega, zeta)=>{
    const damped = omega * Math.sqrt(Math.max(0.01, 1 - zeta * zeta));
    const tPeak = Math.atan2(damped, zeta * omega) / damped;
    return Math.exp(-zeta * omega * tPeak) * Math.sin(damped * tPeak) / damped;
};
class $7fe91d19123d7ca1$export$6089bc5cd44e4755 {
    setSurface(surface) {
        this.debris.setSurface(surface);
    }
    constructor(surface, makeTextures){
        this.tuning = {
            enabled: true,
            lean: 0.032,
            frequency: 3.1,
            damping: 0.2,
            leaves: 5,
            chips: 5
        };
        this.recoils = new Map();
        // Exposed for tests.
        this.isSwaying = (key)=>this.recoils.has(key);
        this.leanOf = (key)=>this.recoils.get(key)?.angle ?? 0;
        this.particleCount = ()=>this.debris.count();
        /**
     * Let go of a tree that is coming down: hand its sprites back upright and say how it was swinging,
     * so the fall can carry on from the lean the last blow put it in rather than snapping upright first.
     */ this.release = (key)=>{
            const recoil = this.recoils.get(key);
            if (!recoil) return undefined;
            this.straighten(recoil, (recoil.sprites() || []).filter($7fe91d19123d7ca1$var$alive));
            this.recoils.delete(key);
            return {
                angle: recoil.angle,
                velocity: recoil.velocity
            };
        };
        /** Hit a tree. Returns false when there was nothing on screen to hit. */ this.strike = (strike, nowMs = performance.now())=>{
            if (!this.tuning.enabled) return false;
            const set = (strike.sprites() || []).filter($7fe91d19123d7ca1$var$alive);
            if (!set.length) return false;
            let recoil = this.recoils.get(strike.key);
            if (!recoil) {
                recoil = {
                    footOffset: 0,
                    sprites: strike.sprites,
                    angle: strike.initialLean ?? 0,
                    velocity: 0,
                    bases: new Map()
                };
                this.recoils.set(strike.key, recoil);
            }
            recoil.sprites = strike.sprites;
            // Where the art is in the world, measured from where the map PUT the sprites, not where the
            // swing has them this frame.
            let left = Infinity;
            let top = Infinity;
            let right = -Infinity;
            let bottom = -Infinity;
            let treeZ = -Infinity;
            for (const s of set){
                const x = this.baseX(recoil, s);
                left = Math.min(left, x);
                top = Math.min(top, s.y);
                right = Math.max(right, x + s.texture.width * Math.abs(s.scale.x));
                bottom = Math.max(bottom, s.y + $7fe91d19123d7ca1$var$spriteHeight(s));
                treeZ = Math.max(treeZ, s.zIndex);
            }
            const width = right - left;
            const height = bottom - top;
            // The analysed art describes the whole composite; a set that is not that size is not that art.
            const art = strike.art && Math.abs(strike.art.width - width) <= 1 && Math.abs(strike.art.height - height) <= 1 ? strike.art : (0, $cda41e870802b180$export$7237cfdeb6b5edff)(width, height);
            recoil.footOffset = art === strike.art ? height - art.footY : 0;
            const trunkX = left + (art.trunkLeft + art.trunkRight + 1) / 2;
            const dx = strike.from ? trunkX - strike.from.x : 0;
            // Knocked AWAY from the blow. Struck from dead ahead (or by nothing in particular), either way.
            const away = Math.abs(dx) >= 4 ? Math.sign(dx) : Math.random() < 0.5 ? -1 : 1;
            const strength = Math.max(0.2, Math.min(2, strike.strength || 1));
            const omega = 2 * Math.PI * this.tuning.frequency;
            recoil.velocity += away * strength * this.tuning.lean / $7fe91d19123d7ca1$var$peakPerUnitVelocity(omega, this.tuning.damping);
            const scene = {
                left: left,
                top: top,
                pivot: bottom,
                footY: top + art.footY,
                trunkX: trunkX,
                halfTrunk: (art.trunkRight - art.trunkLeft + 1) / 2,
                impactHeight: Math.max(4, art.footY - art.impactY),
                zFloor: treeZ + 0.5,
                lean: recoil.angle
            };
            // Chips fly back toward the swing; from dead ahead they spray both ways.
            this.spawnChips(scene, art, Math.abs(dx) >= 6 ? -away : 0, strength, nowMs);
            this.spawnLeaves(scene, art, away, strength, nowMs);
            return true;
        };
        /** Advance every swing and every particle. Called once per drawn frame. */ this.update = (nowMs = performance.now())=>{
            if (!this.tuning.enabled) {
                this.clear();
                return;
            }
            if (this.lastMs === undefined) {
                this.lastMs = nowMs;
                return;
            }
            const dt = Math.min(Math.max(0, (nowMs - this.lastMs) / 1000), $7fe91d19123d7ca1$var$MAX_FRAME_SECONDS);
            this.lastMs = nowMs;
            if (this.recoils.size) this.advanceRecoils(dt);
            this.debris.update(nowMs, dt);
        };
        /** Stand every tree up and sweep the particles away (a new room). */ this.clear = ()=>{
            this.recoils.forEach((recoil)=>this.straighten(recoil, (recoil.sprites() || []).filter($7fe91d19123d7ca1$var$alive)));
            this.recoils.clear();
            this.debris.clear();
            this.lastMs = undefined;
        };
        this.releaseSprites = ()=>{
            this.recoils.forEach((recoil)=>{
                this.straighten(recoil, (recoil.sprites() || []).filter($7fe91d19123d7ca1$var$alive));
                recoil.bases.clear();
            });
        };
        // ---------------------------------------------------------------------------------------------
        // The swing
        // ---------------------------------------------------------------------------------------------
        this.advanceRecoils = (dt)=>{
            const omega = 2 * Math.PI * this.tuning.frequency;
            const zeta = this.tuning.damping;
            this.recoils.forEach((recoil, key)=>{
                for(let left = dt; left > 1e-6; left -= $7fe91d19123d7ca1$var$STEP){
                    const h = Math.min($7fe91d19123d7ca1$var$STEP, left);
                    recoil.velocity += (-omega * omega * recoil.angle - 2 * zeta * omega * recoil.velocity) * h;
                    recoil.angle += recoil.velocity * h;
                }
                recoil.angle = Math.max(-$7fe91d19123d7ca1$var$MAX_LEAN, Math.min($7fe91d19123d7ca1$var$MAX_LEAN, recoil.angle));
                const set = (recoil.sprites() || []).filter($7fe91d19123d7ca1$var$alive);
                if (!set.length) {
                    // Felled, or the room went away. Nothing of ours is left on screen to put back.
                    this.recoils.delete(key);
                    return;
                }
                if (Math.abs(recoil.angle) < $7fe91d19123d7ca1$var$REST_ANGLE && Math.abs(recoil.velocity) < $7fe91d19123d7ca1$var$REST_VELOCITY) {
                    this.straighten(recoil, set);
                    this.recoils.delete(key);
                    return;
                }
                const current = new Set(set);
                recoil.bases.forEach((_, sprite)=>{
                    if (!current.has(sprite)) recoil.bases.delete(sprite);
                });
                this.lean(recoil, set);
            });
        };
        // Shear every piece of the tree about the foot of the art. Each piece's top and bottom edge land
        // where the lean puts that height, so the pieces of a split tree meet exactly; for the usual single
        // sprite this is just a lean with the roots pinned. asin rather than the small-angle shortcut for
        // the same reason GrassSway gives: at the world's 2x zoom a fraction of a pixel shows as a seam.
        this.lean = (recoil, set)=>{
            let pivot = -Infinity;
            for (const s of set)pivot = Math.max(pivot, s.y + $7fe91d19123d7ca1$var$spriteHeight(s));
            pivot -= recoil.footOffset;
            for (const s of set){
                const h = $7fe91d19123d7ca1$var$spriteHeight(s);
                if (h <= 0) continue;
                let base = recoil.bases.get(s);
                if (!base || s.x !== base.written) {
                    base = {
                        x: s.x,
                        written: s.x
                    };
                    recoil.bases.set(s, base);
                }
                const top = recoil.angle * (pivot - s.y);
                const bottom = recoil.angle * (pivot - s.y - h);
                s.skew.x = Math.asin(Math.max(-1, Math.min(1, (bottom - top) / h)));
                s.x = base.x + top;
                base.written = s.x;
            }
        };
        // Hand the sprites back exactly as the map left them -- but only the ones still ours: a sprite whose
        // x is not what this effect last wrote has been re-placed by the map and is not touched.
        this.straighten = (recoil, set)=>{
            for (const s of set){
                const base = recoil.bases.get(s);
                if (base && s.x === base.written) {
                    s.x = base.x;
                    s.skew.x = 0;
                }
            }
        };
        this.baseX = (recoil, s)=>{
            const base = recoil.bases.get(s);
            return base && s.x === base.written ? base.x : s.x;
        };
        // ---------------------------------------------------------------------------------------------
        // What comes off the tree
        // ---------------------------------------------------------------------------------------------
        this.spawnChips = (scene, art, toward, strength, nowMs)=>{
            const count = Math.round(this.tuning.chips * Math.min(strength, 1.5) * (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0.8, 1.2));
            const bark = art.barkColors.length ? art.barkColors : $7fe91d19123d7ca1$export$885666579e701cb5;
            // Where the axe bit, on the face toward the swing, carried by the lean at that height.
            const lift = scene.lean * scene.impactHeight;
            for(let i = 0; i < count; i++){
                const side = toward || (Math.random() < 0.5 ? -1 : 1);
                const speed = (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)($7fe91d19123d7ca1$var$CHIP_SPEED_MIN, $7fe91d19123d7ca1$var$CHIP_SPEED_MAX) * (0.7 + 0.3 * Math.min(strength, 1.5));
                const tint = Math.random() < 0.6 ? (0, $a0018fcc72efc0ff$export$357523c63a2253b9)($7fe91d19123d7ca1$export$885666579e701cb5) : (0, $a0018fcc72efc0ff$export$357523c63a2253b9)(bark);
                if (!this.debris.chip({
                    x: scene.trunkX + side * Math.max(1, scene.halfTrunk - 1) + lift,
                    groundY: scene.footY + (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0, 3),
                    z: scene.impactHeight,
                    vx: side * speed,
                    // Struck from dead ahead, chips come out toward the viewer as much as sideways.
                    vy: toward ? (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-10, 26) : (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(10, 40),
                    vz: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(45, 110),
                    zFloor: scene.zFloor
                }, tint, nowMs)) return;
            }
            // A breath of bark dust off the cut, on the side the axe came from.
            if (count > 0) {
                const side = toward || (Math.random() < 0.5 ? -1 : 1);
                for(let i = 0; i < (strength >= 1 ? 2 : 1); i++){
                    if (!this.debris.puff({
                        x: scene.trunkX + side * scene.halfTrunk + lift,
                        groundY: scene.footY + 1,
                        z: scene.impactHeight - 2,
                        vx: side * (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(10, 26),
                        vz: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(6, 14),
                        zFloor: scene.zFloor
                    }, $7fe91d19123d7ca1$export$7603bd6f61b623e3, nowMs, {
                        scale: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0.26, 0.38),
                        alpha: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0.4, 0.6),
                        lifeMs: $7fe91d19123d7ca1$var$PUFF_LIFE_MS * (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0.8, 1.2),
                        growth: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(1.6, 2.1)
                    })) return;
                }
            }
        };
        this.spawnLeaves = (scene, art, away, strength, nowMs)=>{
            const points = art.canopyPoints;
            if (points.length < 2) return;
            const colors = art.canopyColors.length ? art.canopyColors : [
                0x548c3a
            ];
            const count = Math.max(0, Math.round(this.tuning.leaves * Math.min(strength, 1.5) * (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0.7, 1.3)));
            for(let i = 0; i < count; i++){
                const p = 2 * Math.floor(Math.random() * (points.length / 2));
                const worldY = scene.top + points[p + 1];
                // Shaken off where the canopy IS this frame, mid-lean.
                const worldX = scene.left + points[p] + scene.lean * (scene.pivot - worldY);
                // Leaves land around the foot of the tree, in front of it: the canopy overhangs the ground
                // there as much as anywhere, and a leaf landing behind the trunk would be hidden by it.
                const groundY = scene.footY + (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-2, 12);
                if (!this.debris.leaf({
                    x: worldX,
                    groundY: groundY,
                    z: Math.max(6, groundY - worldY),
                    // Flung the way the crown lurched, then the air takes over.
                    vx: away * (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(10, 32) * Math.min(strength, 1.5) + (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-6, 6),
                    vy: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-2, 6),
                    vz: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0, 18),
                    zFloor: scene.zFloor
                }, (0, $a0018fcc72efc0ff$export$357523c63a2253b9)(colors), nowMs)) return;
            }
        };
        this.debris = new (0, $a0018fcc72efc0ff$export$321f8791b80b52dd)(surface, makeTextures);
        if (typeof window !== "undefined") window.treeHit = this.tuning;
    }
}


parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $P8XPi = parcelRequire("P8XPi");
var $6qzqq = parcelRequire("6qzqq");


// How many steps a fallen crown breaks up in, the last being gone.
const $572948edb3de1154$var$BREAKUP_STAGES = 7;
class $572948edb3de1154$export$af2e50943638548c {
    constructor(){
        this.ids = new WeakMap();
        this.nextId = 0;
        this.textureId = (texture)=>{
            if (!this.ids.has(texture)) this.ids.set(texture, ++this.nextId);
            return this.ids.get(texture);
        };
        this.originals = new WeakMap();
        this.images = new WeakMap();
        this.image = (sprites)=>{
            const set = sprites.filter((s)=>s && !s.destroyed && s.transform);
            if (!set.length) return undefined;
            const pivot = Math.max(...set.map((s)=>s.y + s.texture.height));
            const xs = set.map((s)=>s.x + Math.sin(s.skew.x) * (pivot - s.y));
            const left = Math.min(...xs);
            const top = Math.min(...set.map((s)=>s.y));
            const pieces = set.map((s, i)=>({
                    source: this.originals.get(s.texture) || s.texture,
                    x: Math.round(xs[i] - left),
                    y: Math.round(s.y - top),
                    width: s.texture.width,
                    height: s.texture.height
                }));
            const key = pieces.map((p)=>`${this.textureId(p.source)}:${p.x}:${p.y}`).join("|");
            let layouts = this.images.get(pieces[0].source);
            if (!layouts) {
                layouts = new Map();
                this.images.set(pieces[0].source, layouts);
            }
            if (layouts.has(key)) return layouts.get(key) || undefined;
            try {
                const width = Math.max(...pieces.map((p)=>p.x + p.width));
                const height = Math.max(...pieces.map((p)=>p.y + p.height));
                const pixels = new Uint8ClampedArray(width * height * 4);
                for (const p of pieces){
                    const sample = new (0, $7Bs2Z.Sprite)(p.source);
                    let rgba;
                    try {
                        rgba = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer.extract.pixels(sample);
                    } finally{
                        sample.destroy();
                    }
                    if (rgba.length !== p.width * p.height * 4) throw new Error("Unexpected tree texture resolution");
                    for(let y = 0; y < p.height; y++)pixels.set(rgba.subarray(y * p.width * 4, (y + 1) * p.width * 4), ((p.y + y) * width + p.x) * 4);
                }
                const art = (0, $cda41e870802b180$export$e7b85b41095ef033)(pixels, width, height);
                if (!art) throw new Error("No readable tree silhouette");
                const image = {
                    pixels: pixels,
                    pieces: pieces,
                    art: art,
                    stages: new Map(),
                    felled: new Map()
                };
                layouts.set(key, image);
                return image;
            } catch (_) {
                // Headless renderers and unreadable textures still get recoil and particles; never holes.
                layouts.set(key, null);
                return undefined;
            }
        };
        this.art = (sprites)=>this.image(sprites)?.art;
        /** The tree cut through for a fall toward `side`, as textures the size of the whole art. */ this.felled = (sprites, side)=>{
            const image = this.image(sprites);
            if (!image) return undefined;
            const fall = side < 0 ? -1 : 1;
            let felled = image.felled.get(fall);
            if (!felled) {
                const { width: width, height: height } = image.art;
                const cut = (0, $cda41e870802b180$export$843effe7554b5528)(image.pixels, width, height, image.art, fall);
                const texture = (rgba)=>(0, $klOfb.Texture).fromBuffer(new Uint8Array(rgba), width, height, {
                        scaleMode: (0, $P8XPi.SCALE_MODES).NEAREST
                    });
                // The break-up is baked a stage at a time as the animation reaches it, and only the first
                // time a tree of this kind clears away: one frame never pays for all of it.
                let orders;
                const stages = [];
                felled = {
                    art: image.art,
                    cutY: cut.cutY,
                    hingeX: cut.hingeX,
                    crown: texture(cut.crown),
                    stump: texture(cut.stump),
                    shadow: cut.shadow && texture(cut.shadow),
                    breakup: {
                        stages: $572948edb3de1154$var$BREAKUP_STAGES - 1,
                        stage: (i)=>{
                            if (!stages[i]) {
                                orders = orders || (0, $cda41e870802b180$export$d6e511f97dd6b58e)(width, height, cut.hingeX, cut.cutY);
                                stages[i] = texture((0, $cda41e870802b180$export$f273f1b16f62b577)(cut.crown, orders, (i + 1) / $572948edb3de1154$var$BREAKUP_STAGES));
                            }
                            return stages[i];
                        }
                    }
                };
                image.felled.set(fall, felled);
            }
            return felled;
        };
        this.apply = (sprites, damage, side)=>{
            const image = this.image(sprites);
            if (!image) return;
            const stage = Math.max(0, Math.min(10, Math.round(damage * 10)));
            if (!stage) {
                sprites.forEach((s)=>{
                    s.texture = this.originals.get(s.texture) || s.texture;
                });
                return;
            }
            const key = `${stage}:${side < 0 ? -1 : 1}`;
            let textures = image.stages.get(key);
            if (!textures) {
                const { width: width, height: height } = image.art;
                const rgba = (0, $cda41e870802b180$export$fa49dfa6649e4406)(image.pixels, width, height, image.art, stage / 10, side);
                const atlas = (0, $klOfb.Texture).fromBuffer(new Uint8Array(rgba), width, height, {
                    scaleMode: (0, $P8XPi.SCALE_MODES).NEAREST
                });
                textures = image.pieces.map((p)=>new (0, $klOfb.Texture)(atlas.baseTexture, new (0, $6qzqq.Rectangle)(p.x, p.y, p.width, p.height)));
                textures.forEach((texture, i)=>this.originals.set(texture, image.pieces[i].source));
                image.stages.set(key, textures);
            }
            sprites.forEach((s, i)=>{
                if (textures[i]) s.texture = textures[i];
            });
        };
    }
}


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $7Bs2Z = parcelRequire("7Bs2Z");




// The same integration step and stall guard as TreeHit.
const $af00d3574f850c0a$var$STEP = 1 / 240;
const $af00d3574f850c0a$var$MAX_FRAME_SECONDS = 0.05;
const $af00d3574f850c0a$var$QUARTER = Math.PI / 2;
// When the hinge gives way: a few degrees over, when the creak is done and it is truly going.
const $af00d3574f850c0a$var$SNAP_ANGLE = 0.16;
// Slower than this at the ground and it is down to stay.
const $af00d3574f850c0a$var$SETTLE_SPEED = 0.9;
// The stump's sink at the end.
const $af00d3574f850c0a$var$STUMP_FADE_MS = 900;
// Above this many trees falling at once, the newest just goes: a crowd of woodcutters is not worth a
// frame spent on it.
const $af00d3574f850c0a$var$MAX_FALLS = 10;
const $af00d3574f850c0a$var$DUST = 0xcfbf9c;
const $af00d3574f850c0a$var$DIRT = 0x9a8463;
const $af00d3574f850c0a$var$smoothstep = (a, b, x)=>{
    const t = Math.max(0, Math.min(1, (x - a) / (b - a)));
    return t * t * (3 - 2 * t);
};
const $af00d3574f850c0a$export$cdbd06b8937c9881 = (trunkX, from, lean)=>{
    const dx = from ? trunkX - from.x : 0;
    if (Math.abs(dx) >= 4) return Math.sign(dx);
    if (lean && Math.abs(lean) > 1e-4) return Math.sign(lean);
    return Math.random() < 0.5 ? -1 : 1;
};
class $af00d3574f850c0a$export$c1847329e9550900 {
    constructor(surface, debris){
        this.tuning = {
            enabled: true,
            gravity: 12,
            startSpeed: 0.35,
            bounce: 0.24,
            restMs: 0,
            fadeMs: 650,
            stumpMs: 3200,
            trail: 7,
            leaves: 22,
            dust: 10,
            breakupLeaves: 0.6
        };
        this.falls = new Map();
        // Exposed for tests.
        this.isFalling = (key)=>this.falls.has(key);
        this.fallOf = (key)=>this.falls.get(key);
        /** Bring a tree down. Returns false when there was nothing on screen to fell. */ this.fell = (felling, nowMs = performance.now())=>{
            if (!this.tuning.enabled) return false;
            const set = felling.sprites.filter((s)=>s && !s.destroyed && !!s.transform);
            if (!set.length) return false;
            this.remove(felling.key);
            if (this.falls.size >= $af00d3574f850c0a$var$MAX_FALLS) return false;
            let left = Infinity;
            let top = Infinity;
            let right = -Infinity;
            let bottom = -Infinity;
            let treeZ = -Infinity;
            let alpha = 0;
            for (const s of set){
                left = Math.min(left, s.x);
                top = Math.min(top, s.y);
                right = Math.max(right, s.x + s.width);
                bottom = Math.max(bottom, s.y + s.height);
                treeZ = Math.max(treeZ, s.zIndex);
                alpha = Math.max(alpha, s.alpha);
            }
            const side = felling.side < 0 ? -1 : 1;
            const felled = felling.felled;
            // The cut art describes the whole composite; a set that is not that size is not that art.
            const fits = felled && Math.abs(felled.art.width - (right - left)) <= 1 && Math.abs(felled.art.height - (bottom - top)) <= 1;
            const crown = new (0, $8t5Gy.Container)();
            crown.zIndex = treeZ + 0.1;
            let art;
            let hingeArtX;
            let hingeArtY;
            let drop;
            let stump;
            let shadow;
            let piece;
            if (fits) {
                art = felled.art;
                hingeArtX = felled.hingeX;
                hingeArtY = felled.cutY;
                drop = Math.max(0, art.footY - felled.cutY);
                piece = new (0, $7Bs2Z.Sprite)(felled.crown);
                piece.position.set(-hingeArtX, -hingeArtY);
                crown.addChild(piece);
                stump = new (0, $7Bs2Z.Sprite)(felled.stump);
                stump.position.set(left, top);
                stump.zIndex = treeZ;
                if (felled.shadow) {
                    shadow = new (0, $7Bs2Z.Sprite)(felled.shadow);
                    shadow.position.set(left, top);
                    shadow.zIndex = treeZ - 0.1;
                }
            } else {
                art = (0, $cda41e870802b180$export$7237cfdeb6b5edff)(right - left, bottom - top);
                const halfTrunk = (art.trunkRight - art.trunkLeft + 1) / 2;
                hingeArtX = (art.trunkLeft + art.trunkRight + 1) / 2 + side * halfTrunk;
                hingeArtY = art.footY;
                drop = 0;
                for (const s of set){
                    const copy = new (0, $7Bs2Z.Sprite)(s.texture);
                    copy.position.set(s.x - left - hingeArtX, s.y - top - hingeArtY);
                    copy.scale.copyFrom(s.scale);
                    crown.addChild(copy);
                }
            }
            const fall = {
                key: felling.key,
                side: side,
                crown: crown,
                piece: piece,
                breakup: fits ? felled.breakup : undefined,
                stump: stump,
                shadow: shadow,
                shadowAlpha: alpha,
                art: art,
                left: left,
                top: top,
                hingeArtX: hingeArtX,
                hingeArtY: hingeArtY,
                hingeX: left + hingeArtX,
                hingeY: top + hingeArtY,
                drop: drop,
                // TreeHit's lean is the tangent of the angle; only a lean the way it is going counts.
                angle: Math.max(0.02, Math.min(0.08, Math.atan(side * (felling.lean || 0)))),
                velocity: this.tuning.startSpeed,
                snapped: false,
                impacts: 0,
                hitMs: 0,
                landedMs: 0,
                fadeStartMs: 0,
                stumpFadeMs: 0,
                // The occluder fade may have had it see-through; it comes back solid as it goes.
                alphaFrom: alpha || 1,
                bornMs: nowMs,
                zFloor: treeZ + 0.5,
                owed: 0
            };
            if (shadow) this.surface.addChild(shadow);
            if (stump) this.surface.addChild(stump);
            this.surface.addChild(crown);
            this.falls.set(fall.key, fall);
            this.draw(fall, nowMs);
            return true;
        };
        /** Advance every fall. Called once per drawn frame. */ this.update = (nowMs = performance.now())=>{
            if (!this.tuning.enabled) {
                this.clear();
                return;
            }
            if (this.lastMs === undefined) {
                this.lastMs = nowMs;
                if (!this.falls.size) return;
            }
            const dt = Math.min(Math.max(0, (nowMs - this.lastMs) / 1000), $af00d3574f850c0a$var$MAX_FRAME_SECONDS);
            this.lastMs = nowMs;
            this.falls.forEach((fall)=>{
                if (!fall.landedMs && !fall.crown.destroyed) this.topple(fall, dt, nowMs);
                if (fall.hitMs) this.clearAway(fall, dt, nowMs);
                if (fall.crown.destroyed && !fall.stump) this.falls.delete(fall.key);
                else this.draw(fall, nowMs);
            });
        };
        /** Take every falling tree away at once (a new room). */ this.clear = ()=>{
            Array.from(this.falls.keys()).forEach(this.remove);
            this.lastMs = undefined;
        };
        // ---------------------------------------------------------------------------------------------
        // Going over
        // ---------------------------------------------------------------------------------------------
        this.topple = (fall, dt, nowMs)=>{
            const before = fall.angle;
            for(let left = dt; left > 1e-6; left -= $af00d3574f850c0a$var$STEP){
                const h = Math.min($af00d3574f850c0a$var$STEP, left);
                fall.velocity += this.tuning.gravity * Math.sin(fall.angle) * h;
                fall.angle += fall.velocity * h;
                if (fall.angle >= $af00d3574f850c0a$var$QUARTER && fall.velocity > 0) {
                    fall.angle = $af00d3574f850c0a$var$QUARTER;
                    if (fall.velocity < $af00d3574f850c0a$var$SETTLE_SPEED || fall.impacts >= 2) {
                        fall.velocity = 0;
                        fall.landedMs = nowMs;
                        break;
                    }
                    this.crash(fall, fall.velocity, nowMs);
                    fall.velocity = -fall.velocity * this.tuning.bounce;
                }
            }
            if (!fall.snapped && fall.angle >= $af00d3574f850c0a$var$SNAP_ANGLE) {
                fall.snapped = true;
                this.snap(fall, nowMs);
            }
            // Leaves stream off the canopy in proportion to how far it moved this frame.
            fall.owed += this.tuning.trail * Math.abs(fall.angle - before);
            while(fall.owed >= 1){
                fall.owed -= 1;
                this.shedLeaf(fall, nowMs);
            }
        };
        // Timed from the first crash, not from coming to rest: the break-up may begin while it still bounces.
        this.clearAway = (fall, dt, nowMs)=>{
            const lying = nowMs - fall.hitMs;
            if (!fall.crown.destroyed) {
                if (lying >= this.tuning.restMs) {
                    const before = fall.fadeStartMs ? (nowMs - fall.fadeStartMs - dt * 1000) / this.tuning.fadeMs : 0;
                    if (!fall.fadeStartMs) {
                        fall.fadeStartMs = nowMs;
                        // Art that cannot break up fades instead, letting a few leaves go as it does.
                        if (!fall.breakup) for(let i = 0; i < Math.round(this.tuning.leaves * 0.35); i++)this.shedLeaf(fall, nowMs, true);
                    }
                    const t = (nowMs - fall.fadeStartMs) / this.tuning.fadeMs;
                    const piece = fall.piece;
                    const breakup = fall.breakup;
                    if (piece && breakup) {
                        const stage = Math.floor(t * (breakup.stages + 1));
                        if (stage >= 1 && stage <= breakup.stages) piece.texture = breakup.stage(stage - 1);
                        // Leaves go up off the crown where it is coming apart.
                        this.shedBreakup(fall, Math.max(0, before), Math.min(1, t), nowMs);
                    }
                    if (t >= 1) {
                        fall.crown.destroy({
                            children: true
                        });
                        fall.shadow?.destroy();
                        fall.shadow = undefined;
                    }
                }
            }
            if (fall.stump && lying >= this.tuning.stumpMs) {
                if (!fall.stumpFadeMs) fall.stumpFadeMs = nowMs;
                if (nowMs - fall.stumpFadeMs >= $af00d3574f850c0a$var$STUMP_FADE_MS) {
                    fall.stump.destroy();
                    fall.stump = undefined;
                }
            }
        };
        // Where the crown is this frame: the hinge, carried down to the ground as the butt comes off the
        // stump near the end, and the turn.
        this.pose = (fall)=>{
            const off = $af00d3574f850c0a$var$smoothstep(0.6, 1, fall.angle / $af00d3574f850c0a$var$QUARTER);
            return {
                x: fall.hingeX - fall.side * 2 * off,
                y: fall.hingeY + fall.drop * off,
                rotation: fall.side * fall.angle
            };
        };
        // A point of the art, where the falling crown has it in the world now.
        this.place = (fall, artX, artY)=>{
            const pose = this.pose(fall);
            const lx = artX - fall.hingeArtX;
            const ly = artY - fall.hingeArtY;
            const cos = Math.cos(pose.rotation);
            const sin = Math.sin(pose.rotation);
            return {
                x: pose.x + lx * cos - ly * sin,
                y: pose.y + lx * sin + ly * cos,
                lx: lx,
                ly: ly
            };
        };
        this.draw = (fall, nowMs)=>{
            const crown = fall.crown;
            if (!crown.destroyed) {
                const pose = this.pose(fall);
                crown.position.set(pose.x, pose.y);
                crown.rotation = pose.rotation;
                const solid = Math.min(1, (nowMs - fall.bornMs) / 250);
                let alpha = fall.alphaFrom + (1 - fall.alphaFrom) * solid;
                if (fall.fadeStartMs && !fall.breakup) alpha *= 1 - $af00d3574f850c0a$var$smoothstep(0, 1, (nowMs - fall.fadeStartMs) / this.tuning.fadeMs);
                crown.alpha = alpha;
            }
            if (fall.shadow) fall.shadow.alpha = fall.shadowAlpha * Math.max(0, Math.cos(fall.angle)) ** 2;
            if (fall.stump && fall.stumpFadeMs) {
                const t = Math.min(1, (nowMs - fall.stumpFadeMs) / $af00d3574f850c0a$var$STUMP_FADE_MS);
                fall.stump.alpha = 1 - t * t;
            }
        };
        // ---------------------------------------------------------------------------------------------
        // What comes off it
        // ---------------------------------------------------------------------------------------------
        this.ground = (fall)=>fall.top + fall.art.footY;
        this.bark = (fall)=>fall.art.barkColors.length ? fall.art.barkColors : (0, $7fe91d19123d7ca1$export$885666579e701cb5);
        // The canopy's greens, less its darkest: that one is the outline and the deep shade, and a leaf in
        // the air painted with it reads as a black speck.
        this.leafColors = (fall)=>{
            const colors = fall.art.canopyColors;
            return colors.length > 2 ? colors.slice(1) : colors.length ? colors : [
                0x548c3a
            ];
        };
        // How far the lying crown reaches across the ground toward the camera from the line it lies on: the
        // canopy on the far side of the hinge, turned down.
        this.nearReach = (fall)=>fall.side > 0 ? fall.art.width - fall.hingeArtX : fall.hingeArtX;
        // The hinge breaks: splinters out of the cut, both ways, and a breath of sawdust.
        this.snap = (fall, nowMs)=>{
            const ground = this.ground(fall);
            const height = Math.max(4, fall.drop);
            const trunkX = fall.left + (fall.art.trunkLeft + fall.art.trunkRight + 1) / 2;
            for(let i = 0; i < 7; i++){
                const way = i < 5 ? -fall.side : fall.side;
                if (!this.debris.chip({
                    x: trunkX + (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-2, 2),
                    groundY: ground + (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0, 3),
                    z: height,
                    vx: way * (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(25, 80),
                    vy: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-8, 24),
                    vz: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(50, 120),
                    zFloor: fall.zFloor
                }, Math.random() < 0.7 ? (0, $a0018fcc72efc0ff$export$357523c63a2253b9)((0, $7fe91d19123d7ca1$export$885666579e701cb5)) : (0, $a0018fcc72efc0ff$export$357523c63a2253b9)(this.bark(fall)), nowMs)) break;
            }
            (0, $2027e742bf23a011$export$d5812078266caf23).creaked({
                x: trunkX,
                y: ground
            });
        };
        this.shedLeaf = (fall, nowMs, lying = false)=>{
            const points = fall.art.canopyPoints;
            if (points.length < 2) return;
            const p = 2 * Math.floor(Math.random() * (points.length / 2));
            const at = this.place(fall, points[p], points[p + 1]);
            const ground = this.ground(fall);
            // The canopy's own motion, which flings what it lets go of.
            const spin = fall.side * fall.velocity;
            const vx = -(at.lx * Math.sin(fall.side * fall.angle) + at.ly * Math.cos(fall.side * fall.angle)) * spin;
            const vy = (at.lx * Math.cos(fall.side * fall.angle) - at.ly * Math.sin(fall.side * fall.angle)) * spin;
            const colors = this.leafColors(fall);
            // Lying down, the canopy IS on the ground: a leaf lets go from where it lies.
            const groundY = lying ? at.y + (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0, 4) : ground + (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-2, 12);
            this.debris.leaf({
                x: at.x,
                groundY: groundY,
                z: lying ? (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(2, 8) : Math.max(4, groundY - at.y),
                vx: 0.45 * vx + (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-8, 8),
                vy: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-4, 8),
                vz: lying ? (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(20, 50) : Math.max(-40, Math.min(40, -0.45 * vy)),
                zFloor: fall.zFloor
            }, (0, $a0018fcc72efc0ff$export$357523c63a2253b9)(colors), nowMs);
        };
        // Leaves lifting off the crown where its pixels went between break-up times `from` and `to`.
        this.shedBreakup = (fall, from, to, nowMs)=>{
            const points = fall.art.canopyPoints;
            if (to <= from || points.length < 2) return;
            const reach = (0, $cda41e870802b180$export$1d9b048f58b250d9)(fall.art.width, fall.hingeArtX, fall.hingeArtY);
            const colors = this.leafColors(fall);
            // A fixed share of the canopy's sample points is tried each frame; those that went in the window shed.
            for(let tries = 0; tries < 14; tries++){
                const p = 2 * Math.floor(Math.random() * (points.length / 2));
                const order = (0, $cda41e870802b180$export$b076bc0720750241)(points[p], points[p + 1], fall.hingeArtX, fall.hingeArtY, reach);
                if (order < from || order >= to || Math.random() > this.tuning.breakupLeaves) continue;
                const at = this.place(fall, points[p], points[p + 1]);
                this.debris.leaf({
                    x: at.x,
                    groundY: at.y + (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0, 4),
                    z: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(1, 6),
                    vx: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-14, 14),
                    vy: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-6, 10),
                    vz: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(25, 60),
                    zFloor: fall.zFloor
                }, (0, $a0018fcc72efc0ff$export$357523c63a2253b9)(colors), nowMs);
            }
        };
        // The crash. The first is the big one; the bounce comes down again with a fraction of it.
        this.crash = (fall, speed, nowMs)=>{
            fall.impacts++;
            const first = fall.impacts === 1;
            if (first) fall.hitMs = nowMs;
            const force = Math.min(1.4, speed / 5) * (first ? 1 : 0.3);
            const ground = this.ground(fall);
            const art = fall.art;
            // Along the fallen tree, butt to tip: the trunk, then the canopy.
            const butt = fall.hingeX - fall.side * 2;
            const length = fall.hingeArtY;
            const trunkLength = Math.max(0, fall.hingeArtY - art.canopyBottomY);
            const along = (d)=>butt + fall.side * d;
            // Dust rolls out from under it where it can be seen: along the near edge of the fallen crown, and
            // off the end of it.
            const near = this.nearReach(fall);
            const dust = Math.round(this.tuning.dust * force);
            for(let i = 0; i < dust; i++){
                const d = length * ((i + Math.random()) / Math.max(1, dust));
                const inCanopy = d > trunkLength;
                const tip = i === dust - 1;
                this.debris.puff({
                    x: along(tip ? length + 4 : d) + (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-3, 3),
                    groundY: ground + (inCanopy ? near * (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0.6, 0.95) : (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(1, 4)),
                    z: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0, 2),
                    // Pushed out from under it: toward the camera, and off the end.
                    vx: fall.side * (tip ? (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(20, 40) : (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-8, 16)),
                    vy: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(10, 30),
                    vz: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(6, 16),
                    zFloor: fall.zFloor
                }, Math.random() < 0.75 ? $af00d3574f850c0a$var$DUST : $af00d3574f850c0a$var$DIRT, nowMs, {
                    scale: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0.45, 0.7) * (first ? 1 : 0.6),
                    alpha: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0.3, 0.45),
                    lifeMs: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(700, 1100),
                    growth: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(1.9, 2.5)
                });
            }
            if (!first) return;
            const points = art.canopyPoints;
            const colors = this.leafColors(fall);
            const middle = along(length / 2);
            const leaves = Math.round(this.tuning.leaves * force);
            for(let i = 0; i < leaves && points.length >= 2; i++){
                const p = 2 * Math.floor(Math.random() * (points.length / 2));
                const at = this.place(fall, points[p], points[p + 1]);
                this.debris.leaf({
                    x: at.x,
                    groundY: at.y + (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(0, 6),
                    z: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(2, 10),
                    vx: Math.sign(at.x - middle) * (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(10, 45) + (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-10, 10),
                    vy: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-15, 20),
                    vz: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(45, 115) * force,
                    zFloor: fall.zFloor
                }, (0, $a0018fcc72efc0ff$export$357523c63a2253b9)(colors), nowMs);
            }
            // Twigs and bark knocked off along the trunk and out of the crown.
            for(let i = 0; i < 6; i++){
                const d = length * Math.random();
                if (!this.debris.chip({
                    x: along(d),
                    groundY: ground + (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-4, 6),
                    z: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(2, 6),
                    vx: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-40, 40),
                    vy: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(-15, 25),
                    vz: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(60, 130) * force,
                    zFloor: fall.zFloor
                }, (0, $a0018fcc72efc0ff$export$357523c63a2253b9)(this.bark(fall)), nowMs, {
                    w: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(2.5, 4.5),
                    h: (0, $a0018fcc72efc0ff$export$cf95c51b03f10bae)(1, 1.5)
                })) break;
            }
            (0, $2027e742bf23a011$export$d5812078266caf23).landed({
                x: middle,
                y: ground
            }, Math.min(1.5, art.height / 128 * force));
        };
        this.remove = (key)=>{
            const fall = this.falls.get(key);
            if (!fall) return;
            if (!fall.crown.destroyed) fall.crown.destroy({
                children: true
            });
            fall.stump?.destroy();
            fall.shadow?.destroy();
            this.falls.delete(key);
        };
        this.surface = surface;
        this.debris = debris;
        if (typeof window !== "undefined") window.treeFall = this.tuning;
    }
    setSurface(surface) {
        this.surface = surface;
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $P8XPi = parcelRequire("P8XPi");




class $02d47f540b0d58f8$export$ebaa494e10da0ea2 {
    static{
        // Above every tile and entity (world sprites sort at roughly 100 + row * TileSize), below the
        // sky surface at 1_000_000 so a roof still hides the leaves indoors.
        this.Z_INDEX = 900000;
    }
    static{
        // Hard ceiling on the sprite count whatever a room or the console asks for. The effect is
        // ambience; it does not get to cost a frame.
        this.MAX_LEAVES = 64;
    }
    static{
        // The box the simulation lives in, as a half-extent in world px around the player. The visible
        // world is ScalingParams.viewportX/Y tiles either side of the player, so this is that plus a
        // three-tile margin: leaves are born and die outside the screen, never in view.
        this.HALF_W = ((0, $10da07838e6d507c$export$aa707847c2571374).viewportX + 3) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        this.HALF_H = ((0, $10da07838e6d507c$export$aa707847c2571374).viewportY + 3) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // How deep the fade-in/out band at the edge of the box is, in world px. A leaf's opacity ramps
        // with its distance to the nearest edge, so nothing ever pops into or out of existence.
        this.FADE_BAND = 44;
    }
    static{
        // Defaults for everything a config may leave out.
        this.DEFAULT_DIRECTION_DEG = 22;
    }
    static{
        this.DEFAULT_COUNT = 10;
    }
    static{
        this.DEFAULT_SPEED = 46;
    }
    static{
        this.DEFAULT_GUSTINESS = 0.6;
    }
    static{
        this.DEFAULT_ALPHA = 0.85;
    }
    static{
        this.DEFAULT_SCALE_MIN = 0.3;
    }
    static{
        this.DEFAULT_SCALE_MAX = 0.62;
    }
    static{
        // Tint multiplies, so these are the colours the (white) leaf art becomes. A leaf samples this list
        // uniformly, so the MIX is simply how many entries each shade gets: five living greens to two
        // turned ones, i.e. mostly green with the odd dry leaf among them.
        this.DEFAULT_COLORS = [
            0x6f9b3a,
            0x568a2e,
            0x86ab48,
            0x4e7c2a,
            0x9cbb55,
            0xb9762b,
            0xd9a13a
        ];
    }
    static{
        // A jump bigger than this between frames is a teleport or a room change, not walking, so the
        // whole field is re-scattered rather than dragged across the map behind the player.
        this.TELEPORT_JUMP = $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_W;
    }
    constructor(makeTextures){
        this.makeTextures = makeTextures;
        this.leaves = [];
        this.activeCount = 0;
        this.textures = [];
        this.config = null;
        this.running = false;
        this.lastMs = 0;
        this.lastCenterX = 0;
        this.lastCenterY = 0;
        this.hasCenter = false;
        this./**
     * Advance the field one frame and draw it. `center` is the player's world position: the box
     * follows the player, so the simulation only ever runs over what could be on screen.
     *
     * `brightness` is the client's interpolated daylight (ClientGameLogic.currentBrightness), or
     * undefined for a room with no day cycle -- which counts as full daylight, not as darkness.
     *
     * Safe and cheap to call every frame whether or not the room has wind.
     */ update = (config, center, brightness)=>{
            const resolved = this.resolve(config, brightness);
            if (!resolved || !center) {
                this.stop();
                return;
            }
            const nowMs = performance.now();
            if (!this.running) {
                // Starting (or restarting after a still room): fill the box immediately so the wind is
                // already blowing on the first visible frame, rather than blowing in from one edge.
                this.running = true;
                this.container.visible = true;
                this.lastMs = nowMs;
                this.ensurePool(resolved.count);
                this.scatter(center.x, center.y, resolved);
                this.lastCenterX = center.x;
                this.lastCenterY = center.y;
                this.hasCenter = true;
                return;
            }
            this.ensurePool(resolved.count);
            // A teleport (or a new room) moves the box further in one frame than the box is wide. Dragging
            // the existing leaves along would show the previous room's field sliding into place, so
            // re-seed instead.
            if (this.hasCenter && (Math.abs(center.x - this.lastCenterX) > $02d47f540b0d58f8$export$ebaa494e10da0ea2.TELEPORT_JUMP || Math.abs(center.y - this.lastCenterY) > $02d47f540b0d58f8$export$ebaa494e10da0ea2.TELEPORT_JUMP)) {
                this.scatter(center.x, center.y, resolved);
                this.lastMs = nowMs;
                this.lastCenterX = center.x;
                this.lastCenterY = center.y;
                return;
            }
            this.lastCenterX = center.x;
            this.lastCenterY = center.y;
            this.hasCenter = true;
            // Time-based, so the wind blows at the same speed on a 30fps laptop and a 144Hz monitor. The
            // clamp is for the tab coming back from the background, where the gap can be minutes: without
            // it every leaf would teleport clean across the map in a single step.
            let dt = (nowMs - this.lastMs) / 1000;
            this.lastMs = nowMs;
            if (!(dt > 0)) return;
            dt = Math.min(dt, 0.05);
            this.step(dt, nowMs / 1000, center.x, center.y, resolved);
        };
        this.// Exposed for tests: how many leaves are currently simulated and drawn.
        getActiveCount = ()=>this.running ? this.activeCount : 0;
        this.stop = ()=>{
            if (!this.running) return;
            this.running = false;
            this.container.visible = false;
            // Next enable must not integrate the whole time the effect was off.
            this.lastMs = 0;
            this.hasCenter = false;
        };
        this.resolve = (config, brightness)=>{
            const w = window;
            const forced = typeof w.windLeaves === "boolean" ? w.windLeaves : undefined;
            const enabled = forced !== undefined ? forced : !!config?.enabled;
            if (!enabled) return null;
            const daylight = this.daylightFactor(config, brightness);
            if (daylight <= 0) // Night. Returning null takes the same path as a room with no wind: the container is
            // hidden and not one leaf is simulated until the light comes back.
            return null;
            const num = (override, value, fallback)=>typeof override === "number" ? override : typeof value === "number" ? value : fallback;
            const directionDeg = num(w.windLeavesDirection, config?.directionDeg, $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_DIRECTION_DEG);
            const rad = directionDeg * Math.PI / 180;
            const scaleMin = config?.scaleMin ?? $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_SCALE_MIN;
            const scaleMax = config?.scaleMax ?? $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_SCALE_MAX;
            return {
                // Unit heading, and the unit perpendicular the cross-wind wander rides on.
                windX: Math.cos(rad),
                windY: Math.sin(rad),
                crossX: -Math.sin(rad),
                crossY: Math.cos(rad),
                speed: Math.max(1, num(w.windLeavesSpeed, config?.speed, $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_SPEED)),
                gustiness: Math.min(1, Math.max(0, num(w.windLeavesGust, config?.gustiness, $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_GUSTINESS))),
                // Thinned by the time of day, but never rounded away to nothing while there is still
                // light: a last leaf or two in the failing light is the point of the fade.
                count: Math.max(daylight > 0 ? 1 : 0, Math.min($02d47f540b0d58f8$export$ebaa494e10da0ea2.MAX_LEAVES, Math.round(num(w.windLeavesCount, config?.count, $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_COUNT) * daylight))),
                alpha: Math.min(1, Math.max(0, num(w.windLeavesAlpha, config?.alpha, $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_ALPHA))),
                scaleMin: Math.max(0.05, Math.min(scaleMin, scaleMax)),
                scaleMax: Math.max(scaleMin, scaleMax),
                colors: config?.colors?.length ? config.colors : $02d47f540b0d58f8$export$ebaa494e10da0ea2.DEFAULT_COLORS,
                daylight: daylight
            };
        };
        this.daylightFactor = (config, brightness)=>{
            const w = window;
            const dayOnly = typeof w.windLeavesDayOnly === "boolean" ? w.windLeavesDayOnly : config?.dayOnly !== false;
            if (!dayOnly) return 1;
            return (0, $eca6088c9a6d9651$export$45f6af437d59d9ba)(brightness);
        };
        this.step = (dt, tSeconds, centerX, centerY, cfg)=>{
            // The shared gust envelope (wind.ts), the same one the bending grass reads -- the leaves and the
            // grass have to surge at the same moments or the two read as different weather.
            const gust = (0, $3462bfbeaff010be$export$4e07af95bd4178be)(tSeconds, cfg.gustiness);
            for(let i = 0; i < this.activeCount; i++){
                const leaf = this.leaves[i];
                const along = cfg.speed * gust * leaf.speedScale;
                const cross = Math.sin(tSeconds * leaf.swayFreq + leaf.swayPhase) * leaf.swayAmp;
                leaf.x += (cfg.windX * along + cfg.crossX * cross) * dt;
                leaf.y += (cfg.windY * along + cfg.crossY * cross) * dt;
                // Distance to the nearest edge of the box, which is both the recycle test and the fade.
                const edgeX = $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_W - Math.abs(leaf.x - centerX);
                const edgeY = $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_H - Math.abs(leaf.y - centerY);
                if (edgeX <= 0 || edgeY <= 0) {
                    this.reseed(leaf, centerX, centerY, cfg);
                    continue;
                }
                const sprite = leaf.sprite;
                sprite.x = leaf.x;
                sprite.y = leaf.y;
                // Tumble. Faster in a gust, because a leaf that spins at a constant rate while its drift
                // surges looks like it is on rails.
                sprite.rotation += leaf.spin * gust * dt;
                // Edge-on flip: squash the short axis only. abs() of a cosine gives the sharp turn at the
                // moment the leaf passes through edge-on, which a plain sine would smooth away.
                const flutter = Math.abs(Math.cos(tSeconds * leaf.flutterFreq + leaf.flutterPhase));
                sprite.scale.set(leaf.scale, leaf.scale * (0.3 + 0.7 * flutter));
                // cfg.daylight is applied HERE and not folded into baseAlpha at reseed: a leaf keeps its
                // baseAlpha for its whole crossing, so baking the light in would leave the field fading
                // one leaf at a time as each got recycled instead of dimming together.
                sprite.alpha = leaf.baseAlpha * cfg.daylight * Math.min(1, Math.min(edgeX, edgeY) / $02d47f540b0d58f8$export$ebaa494e10da0ea2.FADE_BAND);
            }
        };
        this.ensurePool = (count)=>{
            const target = Math.min(count, $02d47f540b0d58f8$export$ebaa494e10da0ea2.MAX_LEAVES);
            if (!this.textures.length && target > 0) {
                // A leaf is ambience. If the bake fails (no GPU -- a test, a lost context), draw plain
                // tinted quads rather than taking the frame down.
                try {
                    this.textures = this.makeTextures();
                } catch (e) {
                    this.textures = [];
                }
                if (!this.textures.length) this.textures = [
                    (0, $klOfb.Texture).WHITE
                ];
            }
            while(this.leaves.length < target){
                const sprite = new (0, $7Bs2Z.Sprite)(this.textures[this.leaves.length % this.textures.length] ?? (0, $klOfb.Texture).WHITE);
                sprite.anchor.set(0.5);
                this.container.addChild(sprite);
                this.leaves.push({
                    sprite: sprite,
                    x: 0,
                    y: 0,
                    speedScale: 1,
                    swayAmp: 0,
                    swayFreq: 1,
                    swayPhase: 0,
                    spin: 0,
                    flutterFreq: 1,
                    flutterPhase: 0,
                    scale: 0.5,
                    baseAlpha: 1
                });
            }
            if (target === this.activeCount) return;
            for(let i = 0; i < this.leaves.length; i++)this.leaves[i].sprite.visible = i < target;
            this.activeCount = target;
        };
        this.scatter = (centerX, centerY, cfg)=>{
            for(let i = 0; i < this.activeCount; i++){
                const leaf = this.leaves[i];
                this.randomizeLeaf(leaf, cfg);
                leaf.x = centerX + (Math.random() * 2 - 1) * $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_W;
                leaf.y = centerY + (Math.random() * 2 - 1) * $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_H;
                leaf.sprite.x = leaf.x;
                leaf.sprite.y = leaf.y;
                leaf.sprite.alpha = 0;
            }
        };
        this.reseed = (leaf, centerX, centerY, cfg)=>{
            this.randomizeLeaf(leaf, cfg);
            const absX = Math.abs(cfg.windX);
            const absY = Math.abs(cfg.windY);
            // Weighted pick with no zero-division: with a purely vertical wind absX is 0 and this never
            // takes the horizontal arm, which is what we want (its sign would be 0 and the leaf would be
            // born in the middle of the screen).
            if (Math.random() * (absX + absY) < absX) {
                leaf.x = centerX - Math.sign(cfg.windX) * $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_W;
                leaf.y = centerY + (Math.random() * 2 - 1) * $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_H;
            } else {
                leaf.x = centerX + (Math.random() * 2 - 1) * $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_W;
                leaf.y = centerY - Math.sign(cfg.windY) * $02d47f540b0d58f8$export$ebaa494e10da0ea2.HALF_H;
            }
            leaf.sprite.x = leaf.x;
            leaf.sprite.y = leaf.y;
            leaf.sprite.alpha = 0;
        };
        this.randomizeLeaf = (leaf, cfg)=>{
            const rand = (min, max)=>min + Math.random() * (max - min);
            leaf.speedScale = rand(0.62, 1.45);
            // Sway amplitude is a fraction of the drift speed: a slow leaf that wanders as hard as a fast
            // one looks like it is being steered rather than carried.
            leaf.swayAmp = cfg.speed * rand(0.18, 0.5);
            leaf.swayFreq = rand(0.5, 1.9);
            leaf.swayPhase = Math.random() * Math.PI * 2;
            leaf.spin = rand(0.6, 3.1) * (Math.random() < 0.5 ? -1 : 1);
            leaf.flutterFreq = rand(1.4, 4.2);
            leaf.flutterPhase = Math.random() * Math.PI * 2;
            leaf.scale = rand(cfg.scaleMin, cfg.scaleMax);
            // Smaller leaves read as further away, so they are also fainter. Cheap depth for free.
            const depth = (leaf.scale - cfg.scaleMin) / Math.max(0.0001, cfg.scaleMax - cfg.scaleMin);
            leaf.baseAlpha = cfg.alpha * (0.6 + 0.4 * depth);
            leaf.sprite.texture = this.textures[Math.floor(Math.random() * this.textures.length)] ?? (0, $klOfb.Texture).WHITE;
            leaf.sprite.tint = cfg.colors[Math.floor(Math.random() * cfg.colors.length)];
        };
        const container = new (0, $8t5Gy.Container)();
        container.zIndex = $02d47f540b0d58f8$export$ebaa494e10da0ea2.Z_INDEX;
        // Nothing in here is ever clicked, and it sits over the whole world -- keep it out of hit
        // testing entirely so it can't swallow a press meant for an entity underneath.
        container.interactiveChildren = false;
        container.visible = false;
        this.container = container;
    }
    static{
        /**
     * The leaf art, generated once at startup rather than shipped as an asset: three white blades with
     * a grey midrib, which every leaf then tints. White art is what makes a single texture serve a
     * whole seasonal palette (tint multiplies), and the grey rib survives tinting as a darker vein.
     *
     * Drawn oversized and scaled down per leaf, at resolution 2 to match the world surface's 2x zoom,
     * so the edges stay smooth instead of showing the blocky diagonal of a 6px sprite.
     */ this.buildLeafTextures = (generate)=>{
            // Long/narrow, short/round, and a thin sliver: enough variety that the eye stops reading a
            // repeated stamp, few enough that all three stay in one batch.
            const shapes = [
                [
                    17,
                    7
                ],
                [
                    13,
                    10
                ],
                [
                    15,
                    4
                ]
            ];
            return shapes.map(([length, width])=>{
                const g = new (0, $gwPoJ.Graphics)();
                g.beginFill(0xffffff);
                // A lens: two quadratic curves from tip to tip. The control points at ±width sit outside
                // the curve, so the widest point of the blade lands near width/2 -- deliberate, it gives
                // the leaf a pointed tip rather than an ellipse's blunt one.
                g.moveTo(-length / 2, 0);
                g.quadraticCurveTo(0, -width, length / 2, 0);
                g.quadraticCurveTo(0, width, -length / 2, 0);
                g.endFill();
                // Midrib, stopping short of both tips so it doesn't spill outside the blade.
                g.lineStyle(1, 0x9a9a9a, 0.85);
                g.moveTo(-length / 2 + 1.5, 0);
                g.lineTo(length / 2 - 1.5, 0);
                const texture = generate(g);
                g.destroy();
                return texture;
            });
        };
    }
    static{
        // The default texture factory, bound to a live pixi renderer. Split from buildLeafTextures so the
        // simulation can be tested without a GPU.
        this.textureFactory = (renderer)=>()=>$02d47f540b0d58f8$export$ebaa494e10da0ea2.buildLeafTextures((g)=>renderer.generateTexture(g, {
                        resolution: 2,
                        scaleMode: (0, $P8XPi.SCALE_MODES).LINEAR
                    }));
    }
}






parcelRequire("1avo5");
var $hnGDn = parcelRequire("hnGDn");
var $gwPoJ = parcelRequire("gwPoJ");

parcelRequire("1avo5");
var $3YyWq = parcelRequire("3YyWq");
var $gwPoJ = parcelRequire("gwPoJ");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");
var $7Bs2Z = parcelRequire("7Bs2Z");

var $5UG8I = parcelRequire("5UG8I");


// Helper function for random float values
const $680de7ed15411c91$var$randomFloatBetween = (min, max)=>{
    return Math.random() * (max - min) + min;
};
// All FragmentEffects share ONE Ticker.shared callback rather than each registering their own.
// Cutting several trees at once previously added one ticker callback per effect, each looping its
// own animator array; now a single callback fans out to every active effect once per frame.
const $680de7ed15411c91$var$activeEffects = new Set();
let $680de7ed15411c91$var$sharedTickerAdded = false;
// Hard cap on simultaneous effects. Destroying a whole cluster of trees/walls in one frame used to
// spawn an unbounded burst of sprites+textures and stutter budget machines; past this many active
// effects we simply skip the visual rather than let the allocation storm tank the frame rate.
const $680de7ed15411c91$var$MAX_ACTIVE_EFFECTS = 12;
const $680de7ed15411c91$var$sharedTick = ()=>{
    const now = Date.now();
    $680de7ed15411c91$var$activeEffects.forEach((effect)=>effect.step(now));
};
const $680de7ed15411c91$var$ensureSharedTicker = ()=>{
    if (!$680de7ed15411c91$var$sharedTickerAdded) {
        (0, $3YyWq.Ticker).shared.add($680de7ed15411c91$var$sharedTick);
        $680de7ed15411c91$var$sharedTickerAdded = true;
    }
};
class $680de7ed15411c91$export$e2a711ce70ac9a4 {
    constructor(parent){
        this.pooledItems = [];
        this.dustItems = [];
        // All particles for this effect are driven by ONE shared-ticker callback rather
        // than a setInterval per particle. Each tree cut previously started ~16-24
        // independent setInterval(16ms) timers (one per fragment + one per dust particle,
        // plus a nested fade timer per fragment). Those timers fire off the render frame
        // and pile up when several trees are cut in quick succession -- the stutter you see
        // when the splinter animation plays. Ticker.shared is rAF-driven, so every particle
        // now updates exactly once per rendered frame with a single timer for the whole effect.
        this.animators = [];
        this.started = false;
        this.released = false;
        this.parent = parent;
        this.surface = new (0, $gwPoJ.Graphics)();
        this.surface.scale.set(1.0);
        this.parent.addChild(this.surface);
    }
    createEffect(texture, x, y, options = {}) {
        // Drop the effect entirely if we're already saturated -- see MAX_ACTIVE_EFFECTS.
        if ($680de7ed15411c91$var$activeEffects.size >= $680de7ed15411c91$var$MAX_ACTIVE_EFFECTS) {
            this.cleanup();
            return;
        }
        const { fragmentCount: fragmentCount = 32, duration: duration = 1000, effectType: effectType = "crumble", gravity: gravity = 0.3, bounceFactor: bounceFactor = 0.6, dustParticles: dustParticles = 5, groundLevel: groundLevel = 0 } = options;
        this.surface.x = x;
        this.surface.y = y;
        const { x: origX, y: origY, width: width, height: height } = texture._frame;
        // Create fragments based on effect type
        for(let i = 0; i < fragmentCount; i++){
            const fragment = this.createFragment(texture, origX, origY, width, height, i, effectType);
            if (fragment) this.animators.push(this.makeFragmentAnimator(fragment, effectType, duration, gravity, bounceFactor, groundLevel));
        }
        // Add dust particles for crumble effect
        if (effectType === "crumble" && dustParticles > 0) this.createDustParticles(origX, origY, width, height, dustParticles);
        this.start();
    }
    createMultiTextureEffect(textures, options = {}) {
        // Drop the effect entirely if we're already saturated -- see MAX_ACTIVE_EFFECTS.
        if ($680de7ed15411c91$var$activeEffects.size >= $680de7ed15411c91$var$MAX_ACTIVE_EFFECTS) {
            this.cleanup();
            return;
        }
        const { fragmentCount: fragmentCount = 32, duration: duration = 1000, effectType: effectType = "crumble", gravity: gravity = 0.3, bounceFactor: bounceFactor = 0.6, dustParticles: dustParticles = 8, groundLevel: groundLevel = 0 } = options;
        // Calculate bounds for dust particles
        let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
        textures.forEach(({ x: x, y: y, texture: texture })=>{
            const { width: width, height: height } = texture._frame;
            if (x < minX) minX = x;
            if (x + width > maxX) maxX = x + width;
            if (y < minY) minY = y;
            if (y + height > maxY) maxY = y + height;
        });
        this.surface.x = minX;
        this.surface.y = minY;
        // Create fragments for each texture
        textures.forEach(({ texture: texture, x: x, y: y })=>{
            const { x: origX, y: origY, width: width, height: height } = texture._frame;
            const localX = x - minX;
            const localY = y - minY;
            // Create fragments for this texture
            for(let i = 0; i < Math.ceil(fragmentCount / textures.length); i++){
                const fragment = this.createFragment(texture, origX, origY, width, height, i, effectType);
                if (fragment) {
                    // Adjust fragment position relative to the combined surface
                    fragment.x += localX;
                    fragment.y += localY;
                    this.animators.push(this.makeFragmentAnimator(fragment, effectType, duration, gravity, bounceFactor, groundLevel - minY));
                }
            }
        });
        // Add dust particles for the entire area
        if (effectType === "crumble" && dustParticles > 0) this.createDustParticles(0, 0, maxX - minX, maxY - minY, dustParticles);
        this.start();
    }
    createFragment(texture, origX, origY, width, height, index, effectType) {
        // Fragment size based on effect type - larger chunks for crumble
        let fragWidth;
        let fragHeight;
        if (effectType === "crumble") {
            // Larger, more realistic chunks
            fragWidth = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(Math.max(2, Math.floor(width / 4)), Math.max(2, Math.floor(width / 2)));
            fragHeight = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(Math.max(2, Math.floor(height / 4)), Math.max(2, Math.floor(height / 2)));
        } else {
            // Original smaller fragments for explosion
            fragWidth = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(Math.max(1, Math.floor(width / 8)), Math.max(1, Math.floor(width / 3)));
            fragHeight = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(Math.max(1, Math.floor(height / 8)), Math.max(1, Math.floor(height / 3)));
        }
        const fragX = origX + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, Math.max(1, width - fragWidth));
        const fragY = origY + (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, Math.max(1, height - fragHeight));
        const frag = new (0, $klOfb.Texture)(texture.baseTexture, new (0, $6qzqq.Rectangle)(fragX, fragY, fragWidth, fragHeight), undefined, undefined, texture.rotate, texture.defaultAnchor);
        const fragSprite = new (0, $7Bs2Z.Sprite)(frag);
        fragSprite.x = fragX - origX;
        fragSprite.y = fragY - origY;
        this.surface.addChild(fragSprite);
        this.pooledItems.push(fragSprite);
        return fragSprite;
    }
    // Build a per-fragment animator. It replaces the old setInterval-based
    // animateFragment: the physics (crumble/explosion), settle detection and the
    // 500ms fade-out are the same, just driven by the shared ticker one frame at a time.
    makeFragmentAnimator(fragSprite, effectType, duration, gravity, bounceFactor, groundLevel) {
        const angle = (0, $a80d0b17b615d6f7$export$3cb92a2060a7aca2)((0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 360));
        let velocity;
        let velocityY = 0;
        let rotation = 0;
        const startTs = Date.now();
        let changedColor1 = false;
        let changedColor2 = false;
        // fade-out phase state
        let fading = false;
        let fadeOutStart = 0;
        const fadeOutDuration = 500;
        let fadeStartAlpha = 0;
        if (effectType === "crumble") {
            // Crumble physics - more realistic chunk behavior
            const chunkType = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, 3);
            let horizontalForce = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(2, 8);
            let verticalForce = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(-2, 2) // Some chunks start falling immediately
            ;
            switch(chunkType){
                case 0:
                    horizontalForce *= 0.7;
                    verticalForce -= 1;
                    break;
                case 1:
                    horizontalForce *= 1.2;
                    verticalForce += 2;
                    break;
                case 2:
                    horizontalForce *= 1.5;
                    verticalForce -= 0.5;
                    break;
            }
            velocity = {
                x: Math.cos(angle) * horizontalForce,
                y: Math.sin(angle) * horizontalForce * 0.3
            };
            velocityY = verticalForce;
        } else // Explosion physics (original)
        velocity = {
            x: Math.cos(angle) * 10,
            y: Math.sin(angle) * 10
        };
        return (now)=>{
            if (fading) {
                const fadeProgress = (now - fadeOutStart) / fadeOutDuration;
                fragSprite.alpha = Math.max(0, fadeStartAlpha - fadeProgress * fadeStartAlpha);
                return fadeProgress >= 1 || fragSprite.alpha <= 0;
            }
            if (effectType === "crumble") {
                // Apply gravity
                velocityY += gravity;
                fragSprite.y += velocityY;
                fragSprite.x += velocity.x * 0.3 // Slower horizontal movement
                ;
                // Bounce effect when hitting ground
                if (fragSprite.y >= groundLevel && velocityY > 0) {
                    velocityY *= -bounceFactor;
                    fragSprite.y = groundLevel;
                    // Add some horizontal friction
                    velocity.x *= 0.8;
                }
                // Rotation based on movement and gravity
                fragSprite.angle += (velocityY + Math.abs(velocity.x)) * 0.05;
                // Fade out more gradually
                fragSprite.alpha -= 0.008;
            } else {
                // Original explosion effect
                fragSprite.x += velocity.x;
                fragSprite.y += velocity.y;
                rotation += 1;
                if (rotation > 360) rotation = 0;
                fragSprite.angle = rotation;
                fragSprite.alpha -= 0.1;
                // Color changes for explosion effect
                if (fragSprite.alpha < 0.7 && !changedColor1) {
                    fragSprite.tint = 0xffc0c0;
                    changedColor1 = true;
                }
                if (fragSprite.alpha < 0.5 && !changedColor2) {
                    fragSprite.tint = 0xff0000;
                    changedColor2 = true;
                }
            }
            // Check if fragment should start fading out
            const isSettled = effectType === "crumble" && Math.abs(velocityY) < 0.1 && Math.abs(velocity.x) < 0.1 && fragSprite.alpha < 0.8;
            // If settled or duration exceeded, start fade out instead of immediate cleanup
            if (isSettled || now - startTs > duration) {
                fading = true;
                fadeOutStart = now;
                fadeStartAlpha = fragSprite.alpha // Start from current alpha
                ;
            }
            return false;
        };
    }
    createDustParticles(origX, origY, width, height, count) {
        for(let d = 0; d < count; d++){
            // Dust is a tinted sprite off the shared Texture.WHITE rather than its own Graphics
            // object. Graphics don't batch (each is its own draw call); WHITE-textured sprites all
            // batch together, so a burst of dust is a handful of draw calls instead of one per mote.
            const dust = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).WHITE);
            dust.tint = 0x8b7355 // Brown dust color
            ;
            const size = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(2, 4);
            dust.width = size;
            dust.height = size;
            dust.x = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, width);
            dust.y = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(0, height);
            dust.alpha = 0.6;
            const jitter = $680de7ed15411c91$var$randomFloatBetween(0.5, 1.5);
            dust.scale.set(dust.scale.x * jitter, dust.scale.y * jitter);
            this.surface.addChild(dust);
            this.dustItems.push(dust);
            const dustVelocity = {
                x: $680de7ed15411c91$var$randomFloatBetween(-1, 1),
                y: $680de7ed15411c91$var$randomFloatBetween(-2, -4)
            };
            this.animators.push(()=>{
                dust.x += dustVelocity.x;
                dust.y += dustVelocity.y;
                dust.alpha -= 0.02;
                dust.scale.set(dust.scale.x * 0.98) // Shrink slightly
                ;
                if (dust.alpha <= 0) {
                    if (dust.parent) dust.parent.removeChild(dust);
                    return true;
                }
                return false;
            });
        }
    }
    // Advance every particle in this effect by one frame. Called once per frame by the shared
    // ticker (sharedTick), not registered as its own Ticker callback.
    step(now) {
        if (this.released) return;
        for(let i = this.animators.length - 1; i >= 0; i--){
            let done = false;
            try {
                done = this.animators[i](now);
            } catch (e) {
                (0, $5UG8I.logger).error({
                    tags: [
                        "fragment",
                        "error"
                    ]
                }, e);
                done = true;
            }
            if (done) this.animators.splice(i, 1);
        }
        if (this.animators.length === 0) this.cleanup();
    }
    start() {
        if (this.started) return;
        this.started = true;
        if (this.animators.length === 0) {
            // Nothing to animate; tear down immediately.
            this.cleanup();
            return;
        }
        $680de7ed15411c91$var$activeEffects.add(this);
        $680de7ed15411c91$var$ensureSharedTicker();
    }
    cleanup() {
        if (this.released) return;
        this.released = true;
        $680de7ed15411c91$var$activeEffects.delete(this);
        this.animators = [];
        this.pooledItems.forEach((p)=>{
            try {
                if (p?.parent) {
                    p.parent.removeChild(p);
                    p.texture.destroy();
                }
            } catch (e) {
                (0, $5UG8I.logger).error({
                    tags: [
                        "fragment",
                        "error"
                    ]
                }, e);
            }
        });
        this.dustItems.forEach((dust)=>{
            try {
                if (dust?.parent) dust.parent.removeChild(dust);
                dust.destroy();
            } catch (e) {
                (0, $5UG8I.logger).error({
                    tags: [
                        "fragment",
                        "error"
                    ]
                }, e);
            }
        });
        this.pooledItems = [];
        this.dustItems = [];
        if (this.surface.parent) this.surface.parent.removeChild(this.surface);
    }
    destroy() {
        this.cleanup();
    }
}





parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
const $82c6cfe7f2e4c6f3$export$8f65e0ccf9f5fea5 = (surface, location)=>{
    const effect = new (0, $gwPoJ.Graphics)();
    effect.position.set(location.x, location.y);
    surface.addChild(effect);
    const started = Date.now();
    const duration = 450;
    const paint = (progress)=>{
        effect.clear();
        effect.alpha = 1 - progress;
        effect.lineStyle(1.5, 0xcaffd6, 1);
        for (const [x, y] of [
            [
                -9,
                0
            ],
            [
                7,
                -5
            ],
            [
                -2,
                -13
            ]
        ]){
            const risingY = y - progress * 13;
            effect.moveTo(x - 2, risingY);
            effect.lineTo(x + 2, risingY);
            effect.moveTo(x, risingY - 2);
            effect.lineTo(x, risingY + 2);
        }
    };
    paint(0);
    const timer = setInterval(()=>{
        const progress = (Date.now() - started) / duration;
        if (effect.destroyed || surface.destroyed || !effect.parent || progress >= 1) {
            clearInterval(timer);
            if (!effect.destroyed) {
                effect.parent?.removeChild(effect);
                effect.destroy();
            }
            return;
        }
        paint(Math.max(0, progress));
    }, 16);
    return effect;
};



class $cf8aec4e49454e2b$export$59b4c816941e3699 {
    constructor(config, surfaceObjectsByKey){
        this.arrowImpacts = new (0, $22c4fc79c5705c6e$export$9c5b1f65c085f81)();
        this.treeDamage = new (0, $572948edb3de1154$export$af2e50943638548c)();
        // Where each tree was last struck from, so its fall can go away from whoever felled it even when the
        // felling names no striker. Entries go when the tree falls or the room changes.
        this.lastStrikeFrom = new Map();
        this.predictedHits = new Map();
        // Last damage for live tiles in this room. Baked-in ore has no HP delta, so retain its
        // visual state across map redraws. Entries are removed on destruction/removal or room change.
        this.damagedTiles = new Map();
        // Shatter textures captured when a wall's cell was removed, keyed by surfaceId. Lets a "destroy"
        // tile-effect that arrives AFTER the removal-triggered rerender (which cleared the live surface)
        // still play the shatter. Bounded; entries are consumed on use.
        this.removedSurfaceSnapshots = new Map();
        /**
     * Configure the hole effect with proper colors
     */ this.configureHoleEffect = ()=>{
            this.config.holeEffect.configureScuffMarks({
                enabled: true,
                count: 3,
                color: 0x000000,
                alpha: 0.15,
                minSize: 0.05,
                maxSize: 0.15,
                roughness: 0.7
            });
            this.config.holeEffect.configureDents({
                enabled: true,
                count: 2,
                color: 0x1a1a1a,
                alpha: 0.4,
                minSize: 0.08,
                maxSize: 0.2,
                depth: 0.6
            });
        };
        // ============================================================================
        // Sprite Fragment Rendering Methods
        // ============================================================================
        /**
     * Render a sprite fragment with all its map entries
     */ this.renderSpriteFragment = (fragment)=>{
            const { location: location, height: height, mapEntries: mapEntries, fineLocationNudge: fineLocationNudge, debugTxt: debugTxt } = fragment;
            if (debugTxt) {
                const debugTxtLocation = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                    x: location.x,
                    y: location.y + 0
                });
                const debugTextObj = new (0, $hnGDn.BitmapText)(debugTxt, {
                    fontName: "SignFont",
                    align: "center"
                });
                debugTextObj.x = debugTxtLocation.x;
                debugTextObj.y = debugTxtLocation.y;
                this.config.surface.addChild(debugTextObj);
                return;
            }
            const key = `frag-${fragment.id}-${location.x}-${location.y}`;
            const set = [];
            this.surfaceObjectsByKey.set(key, {
                spriteSet: set
            });
            const bottom = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                x: location.x,
                y: location.y + 0
            });
            bottom.x += fineLocationNudge?.x || 0;
            bottom.y += fineLocationNudge?.y || 0;
            let maxX = undefined;
            let maxY = undefined;
            const debug = false;
            const renderZIdxOffset = mapEntries[0].renderZIdxOffset || 0;
            mapEntries.forEach((mapEntry)=>{
                const tile = `${mapEntry.tilePos}`;
                const compositeTileId = this.config.tilemapMetaProvider.getCompositeTileId(`${mapEntry.tilePos}`);
                if (compositeTileId) this.config.renderCompositeTile(this.config.tilemapMetaProvider, tile, compositeTileId, mapEntry.x, mapEntry.y, renderZIdxOffset + 200);
                else {
                    const tilesetTileId = this.config.tilemapMetaProvider.resolveTilesetTileId(tile);
                    const g = this.config.attachTexture((0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(`${tilesetTileId}`), mapEntry.roofLayer === "below" ? this.config.skySpriteSurfaceBelow : mapEntry.roofLayer === "above" ? this.config.skySpriteSurfaceAbove : undefined);
                    const fine = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                        x: mapEntry.x,
                        y: mapEntry.y
                    });
                    fine.x += fineLocationNudge?.x || 0;
                    fine.y += fineLocationNudge?.y || 0;
                    g.x = fine.x;
                    g.y = fine.y;
                    g.zIndex = 100 + bottom.y - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.5;
                    set.push(g);
                    if (debug) {
                        const f = new (0, $gwPoJ.Graphics)();
                        f.beginFill(0x00ff00);
                        f.drawCircle(0, 0, 5);
                        f.endFill();
                        f.x = fine.x;
                        f.y = fine.y;
                        f.zIndex = 100000;
                        this.config.surface.addChild(f);
                    }
                    if (maxY === undefined || fine.y > maxY) maxY = fine.y;
                    if (maxX == undefined) maxX = fine.x;
                }
            });
            if (maxX !== undefined && maxY !== undefined) {
                const z = maxY + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.35;
                set.forEach((sprite)=>{
                    sprite.zIndex = 100 + renderZIdxOffset + z;
                });
                if (debug) {
                    const f = new (0, $gwPoJ.Graphics)();
                    f.beginFill(0xff0000);
                    f.drawCircle(0, 0, 5);
                    f.endFill();
                    f.x = maxX;
                    f.y = z;
                    f.zIndex = 100000;
                    this.config.surface.addChild(f);
                }
            }
        };
        /**
     * Process surface ID for sprite grouping
     * Maintains consistent Y-coordinate ordering for proper visual layering
     */ this.processSurfaceId = (tilesetTileId, surfaceId, spriteToReturn, delta)=>{
            if (!surfaceId) return;
            let surfaceObject = this.surfaceObjectsByKey.get(surfaceId);
            if (!surfaceObject) {
                surfaceObject = {
                    spriteSet: [
                        spriteToReturn
                    ]
                };
                this.surfaceObjectsByKey.set(surfaceId, surfaceObject);
            } else {
                // Insert sprite in correct Y-order to maintain consistent ordering
                // This ensures the same ordering used in damage visualization
                const insertIndex = surfaceObject.spriteSet.findIndex((sprite)=>sprite.y > spriteToReturn.y);
                if (insertIndex === -1) surfaceObject.spriteSet.push(spriteToReturn);
                else surfaceObject.spriteSet.splice(insertIndex, 0, spriteToReturn);
            }
            if (delta) surfaceObject.delta = delta;
            if (tilesetTileId) surfaceObject.tilesetTileId = tilesetTileId;
        };
        /**
     * Inverse of processSurfaceId's insertion: drop the given sprites from a surface's spriteSet by
     * identity. Called when an incremental repaint destroys a cell's owned sprites -- without this the
     * shared spriteSet keeps references to destroyed sprites, and the next damage/shake/hole pass reads
     * `.x` / `.texture` on a destroyed sprite (transform is null) and throws. If the set empties out the
     * surface object is removed entirely so a stale, spriteless entry can't linger.
     */ this.detachSpritesFromSurface = (surfaceId, sprites)=>{
            if (!surfaceId || !sprites || sprites.length === 0) return;
            const surfaceObject = this.surfaceObjectsByKey.get(surfaceId);
            if (!surfaceObject || !surfaceObject.spriteSet) return;
            surfaceObject.spriteSet = surfaceObject.spriteSet.filter((s)=>!sprites.includes(s));
            if (surfaceObject.spriteSet.length === 0) this.surfaceObjectsByKey.delete(surfaceId);
        };
        /**
     * Capture a surface's current shatter textures + positions before its sprites are torn down by the
     * removal-triggered rerender. A wall's "destroy" tile-effect can arrive AFTER that rerender (the
     * removal delta beats the effect), by which point the live surface is gone; the snapshot lets the
     * shatter still play. Called per removed cell -- a multi-cell wall snapshots the same surfaceId
     * (idempotent, captures the full sprite set each time). Bounded so a missing destroy effect can't
     * grow it without limit.
     */ this.snapshotSurfaceForDestroy = (surfaceId)=>{
            if (!surfaceId) return;
            const surfaceObject = this.surfaceObjectsByKey.get(surfaceId);
            const set = (surfaceObject?.spriteSet || []).filter((s)=>s && !s.destroyed && !!s.transform);
            if (set.length === 0) return;
            let minY = Infinity;
            let maxY = -Infinity;
            set.forEach((g)=>{
                if (g.y < minY) minY = g.y;
                if (g.y + g.height > maxY) maxY = g.y + g.height;
            });
            const groundLevel = maxY - (maxY - minY) / 2;
            const textures = set.map((g)=>({
                    texture: g.texture,
                    x: g.x,
                    y: g.y
                }));
            this.removedSurfaceSnapshots.set(surfaceId, {
                textures: textures,
                groundLevel: groundLevel
            });
            if (this.removedSurfaceSnapshots.size > 32) {
                const oldest = this.removedSurfaceSnapshots.keys().next().value;
                this.removedSurfaceSnapshots.delete(oldest);
            }
        };
        // Play the shatter from a snapshot captured at removal time; consume it so it can't be reused.
        this.shatterFromSnapshot = (surfaceId)=>{
            const snap = this.removedSurfaceSnapshots.get(surfaceId);
            if (!snap) return;
            this.removedSurfaceSnapshots.delete(surfaceId);
            // A destroyed PIXI texture nulls its baseTexture/orig; skip those so the fragment effect never
            // reads a torn-down texture.
            const textures = snap.textures.filter((t)=>t.texture && t.texture.baseTexture && t.texture.orig);
            if (textures.length === 0) return;
            this.createFragmentEffect(textures, snap.groundLevel);
        };
        // ============================================================================
        // Tile Effect Methods
        // ============================================================================
        /**
     * Apply a tile effect (damage, destroy, remove)
     */ this.applyTileEffect = (effect)=>{
            if (effect.effectType === "arrow-impact") {
                if (effect.impactPosition) this.arrowImpacts.emit(this.config.surface, effect.impactPosition, effect.impactAngle, effect.strikeStrength);
                return;
            }
            if (effect.effectType === "repair") {
                const { x: x, y: y } = effect.mapRoughCoordinates;
                const location = this.config.worldOverlaySurface.computeLocation((x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                const key = effect.surfaceId || `${effect.tileId}-${x}-${y}`;
                const surfaceObject = this.surfaceObjectsByKey.get(key);
                if (effect.hp !== undefined && effect.hpMax !== undefined) {
                    this.damagedTiles.set(key, {
                        ...effect,
                        effectType: "damage"
                    });
                    if (surfaceObject) this.applyDamageVisualization(effect, surfaceObject, surfaceObject.spriteSet, x, y, false);
                }
                (0, $82c6cfe7f2e4c6f3$export$8f65e0ccf9f5fea5)(this.config.worldOverlaySurface, location).scale.set((0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom);
                return;
            }
            if (!effect.tileId && !effect.surfaceId) // we need either the tileId or surfaceId to do an effect
            return;
            if (effect.effectType === "remove" || effect.effectType === "destroy") {
                const { x: x, y: y } = effect.mapRoughCoordinates;
                this.damagedTiles.delete(effect.surfaceId || `${effect.tileId}-${x}-${y}`);
            }
            if (effect.effectType === "remove") this.applyRemoveEffect(effect);
            else if (effect.effectType === "destroy") {
                const { tileId: tileId, surfaceId: surfaceId, mapRoughCoordinates: mapRoughCoordinates } = effect;
                const { x: x, y: y } = mapRoughCoordinates;
                const key = surfaceId || `${tileId}-${x}-${y}`;
                const surfaceObject = this.surfaceObjectsByKey.get(key);
                if (surfaceObject) this.applyDestroyEffect(effect, surfaceObject);
                else // The live surface was already cleared by a removal-triggered rerender that beat this
                // destroy effect -- play the shatter from the snapshot captured at removal time.
                this.shatterFromSnapshot(key);
            } else if (effect.effectType === "damage") {
                const { tileId: tileId, surfaceId: surfaceId, mapRoughCoordinates: mapRoughCoordinates } = effect;
                const { x: x, y: y } = mapRoughCoordinates;
                const key = surfaceId || `${tileId}-${x}-${y}`;
                const surfaceObject = this.surfaceObjectsByKey.get(key);
                if (surfaceObject) this.applyDamageEffect(effect, surfaceObject);
            }
        };
        /**
     * Apply damage effect to a tile
     */ this.applyDamageEffect = (effect, surfaceObject)=>{
            if (effect.effectType !== "damage") return;
            const { tileId: tileId, surfaceId: surfaceId, mapRoughCoordinates: mapRoughCoordinates } = effect;
            const { x: x, y: y } = mapRoughCoordinates;
            const key = surfaceId || `${tileId}-${x}-${y}`;
            this.damagedTiles.set(key, effect);
            // Defensive: an incremental repaint can leave destroyed sprites in the shared spriteSet
            // (removeSpritedCell detaches them via detachSpritesFromSurface, but guard here too). A
            // destroyed sprite's transform is null, so reading `.x` in the shake or `.texture` in the hole
            // pass throws "Cannot read properties of null (reading 'position')". Drop them in place so both
            // the shake (set) and the hole pass (surfaceObject.spriteSet) only ever touch live sprites.
            if (surfaceObject?.spriteSet) surfaceObject.spriteSet = surfaceObject.spriteSet.filter((s)=>s && !s.destroyed && s.transform);
            const set = surfaceObject?.spriteSet;
            if (!set || set.length === 0) return;
            if (this.isTree(surfaceObject, effect)) {
                if (effect.strikeFrom) this.lastStrikeFrom.set(key, effect.strikeFrom);
                const pending = (this.predictedHits.get(key) || []).filter((hit)=>performance.now() - hit.at < 2000);
                const ownHit = pending.findIndex((hit)=>hit.strikerId === effect.strikerId);
                if (ownHit >= 0) pending.splice(ownHit, 1);
                else this.strikeTree(key, surfaceObject, effect);
                if (pending.length) this.predictedHits.set(key, pending);
                else this.predictedHits.delete(key);
                this.applyDamageVisualization(effect, surfaceObject, set, x, y, false);
                return;
            }
            // Prevent multiple shake animations on the same tiles
            if (surfaceObject.isShaking) return;
            surfaceObject.isShaking = true;
            this.performShakeAnimation(set, surfaceObject, ()=>{
                // A redraw can recycle these pooled sprites during the shake. Only touch the
                // still-current surface, and use the latest hit if another arrived mid-animation.
                const latest = this.damagedTiles.get(key);
                if (latest && this.surfaceObjectsByKey.get(key) === surfaceObject && set.some((s)=>s.parent)) this.applyDamageVisualization(latest, surfaceObject, set, x, y);
            }, ()=>this.damagedTiles.has(key) && this.surfaceObjectsByKey.get(key) === surfaceObject);
        };
        /**
     * Apply destroy effect to a tile
     */ this.applyDestroyEffect = (effect, surfaceObject)=>{
            const { tileId: tileId, surfaceId: surfaceId, mapRoughCoordinates: mapRoughCoordinates } = effect;
            const { x: x, y: y } = mapRoughCoordinates;
            // Defensive: drop any destroyed sprites left in the shared spriteSet by an incremental repaint
            // before we read their geometry (g.y + g.height below throws on a destroyed sprite). See the
            // matching note in applyDamageEffect.
            if (surfaceObject?.spriteSet) surfaceObject.spriteSet = surfaceObject.spriteSet.filter((s)=>s && !s.destroyed && s.transform);
            const set = surfaceObject?.spriteSet;
            if (set && set.length > 0 && this.isTree(surfaceObject, effect)) {
                this.fellTree(surfaceId || `${tileId}-${x}-${y}`, set, effect);
                set.forEach((g)=>g.parent?.removeChild(g));
                return;
            }
            if (set && set.length > 0) {
                // Calculate the ground level (bottom of the lowest sprite)
                let groundLevel = 0;
                let minX = Infinity;
                let maxX = -Infinity;
                let minY = Infinity;
                let maxY = -Infinity;
                set.forEach((g)=>{
                    const spriteBottomY = g.y + g.height;
                    if (spriteBottomY > groundLevel) groundLevel = spriteBottomY;
                    if (g.x < minX) minX = g.x;
                    if (g.x + g.width > maxX) maxX = g.x + g.width;
                    if (g.y < minY) minY = g.y;
                    if (g.y + g.height > maxY) maxY = g.y + g.height;
                });
                // Ground level should be one tile height above the bottom of the lowest sprite
                const totalHeight = maxY - minY;
                groundLevel = maxY - totalHeight / 2;
                // Prepare texture data for multi-texture effect
                const textures = Array.from(set).map((g)=>({
                        texture: g.texture,
                        x: g.x,
                        y: g.y
                    }));
                this.createFragmentEffect(textures, groundLevel);
                // Remove all sprites
                set.forEach((g)=>{
                    g.parent?.removeChild(g);
                });
                const compositeTileMeta = this.config.tilemapMetaProvider.resolveCompositeTileIdTileMeta(surfaceObject.compositeTileId, surfaceObject.tilesetId);
                const breakageMeta = compositeTileMeta?.tileMeta?.breakageMeta;
                if (breakageMeta) breakageMeta.descriptors.forEach((descriptor)=>{
                    const key = `${descriptor.compositeTileId}-${x}-${y}`;
                    this.surfaceObjectsByKey.delete(key);
                });
            }
        };
        /**
     * Apply remove effect to a tile
     */ this.applyRemoveEffect = (effect)=>{
            const { tileId: tileId, surfaceId: surfaceId, mapRoughCoordinates: mapRoughCoordinates } = effect;
            const { x: x, y: y } = mapRoughCoordinates;
            const key = surfaceId || `${tileId}-${x}-${y}`;
            const set = this.surfaceObjectsByKey.get(key)?.spriteSet;
            if (set) set.forEach((g)=>{
                g.parent?.removeChild(g);
            });
        };
        // ============================================================================
        // Fragment Effect Methods
        // ============================================================================
        /**
     * Create fragment effect for destroyed tiles
     */ this.createFragmentEffect = (textures, groundLevel)=>{
            const options = {
                effectType: "crumble",
                fragmentCount: 8,
                duration: 1000,
                animationSpeed: 16,
                gravity: 0.3,
                bounceFactor: 0.6,
                dustParticles: 8,
                groundLevel: groundLevel
            };
            const effect = new (0, $680de7ed15411c91$export$e2a711ce70ac9a4)(this.config.surface);
            effect.createMultiTextureEffect(textures, options);
        };
        /**
     * Create single texture fragment effect
     */ this.createSingleFragmentEffect = (texture, parentX, parentY)=>{
            const options = {
                effectType: "crumble",
                duration: 1000,
                animationSpeed: 16,
                gravity: 0.3,
                bounceFactor: 0.6,
                dustParticles: 5,
                groundLevel: 20
            };
            const effect = new (0, $680de7ed15411c91$export$e2a711ce70ac9a4)(this.config.surface);
            effect.createEffect(texture, parentX, parentY, options);
        };
        // ============================================================================
        // Damage Visualization Methods
        // ============================================================================
        /**
     * Apply damage visualization to existing tiles
     */ this.applyDamageVisualizationToExistingTiles = (surfaceObjectsByKey)=>{
            surfaceObjectsByKey.forEach((obj, key)=>{
                const effect = this.damagedTiles.get(key);
                if (obj.delta?.context?.hp && obj.delta?.context?.hpMax) {
                    const { hp: hp, hpMax: hpMax } = obj.delta.context;
                    this.applyDamageVisualization({
                        ...effect,
                        effectType: "damage",
                        hp: hp,
                        hpMax: hpMax,
                        mapRoughCoordinates: {
                            x: obj.delta.x,
                            y: obj.delta.y
                        }
                    }, obj, obj.spriteSet, obj.delta.x, obj.delta.y, false);
                } else if (effect) {
                    const { x: x, y: y } = effect.mapRoughCoordinates;
                    this.applyDamageVisualization(effect, obj, obj.spriteSet, x, y, false);
                }
            });
        };
        // ============================================================================
        // Configuration Methods
        // ============================================================================
        /**
     * Update the tilemap meta provider
     */ this.updateTilemapMetaProvider = (tilemapMetaProvider)=>{
            this.config.tilemapMetaProvider = tilemapMetaProvider;
        };
        /**
     * Get the hole effect instance for advanced configuration
     */ this.getHoleEffect = ()=>{
            return this.config.holeEffect;
        };
        /** The map's surfaces move when its floor changes roles; new effects follow them. */ this.setSurfaces = (surface, worldOverlaySurface)=>{
            this.config.surface = surface;
            this.config.worldOverlaySurface = worldOverlaySurface;
            this.treeHit.setSurface(surface);
            this.treeFall.setSurface(surface);
        };
        /**
     * Update sky surfaces (called after SkyManager is initialized)
     */ this.updateSkySurfaces = (skySpriteSurfaceAbove, skySpriteSurfaceBelow)=>{
            this.config.skySpriteSurfaceAbove = skySpriteSurfaceAbove;
            this.config.skySpriteSurfaceBelow = skySpriteSurfaceBelow;
        };
        /**
     * Create damage overlay sprite for damaged tiles
     */ this.createDamageOverlaySprite = (tilesetTileId, x, y, surface)=>{
            return this.config.attachTexture((0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(tilesetTileId), surface);
        };
        /**
     * Check if a tile should have a damage overlay based on its delta
     */ this.shouldCreateDamageOverlay = (delta)=>{
            return !!(delta && delta.context?.hp && delta.context.hp < delta.context.hpMax);
        };
        /**
     * Update hole effect context when room changes
     */ this.updateHoleEffectContext = (roomId, rng)=>{
            this.treeSway.reset();
            this.treeHit.clear();
            this.treeFall.clear();
            this.lastStrikeFrom.clear();
            this.predictedHits.clear();
            this.damagedTiles.clear();
            // Update hole effect with new room context
            this.config.holeEffect.updateRandomContext(roomId, rng);
        };
        /** Advance tree motion and expire unmatched local contacts. */ this.update = (wind = null, center, storm = 0, brightness)=>{
            this.arrowImpacts.update();
            this.treeSway.clear();
            this.treeHit.update();
            this.treeFall.update();
            this.treeSway.update(wind, center, storm, brightness, this.treeHit.isSwaying);
            this.predictedHits.forEach((hits, key)=>{
                const live = hits.filter((hit)=>performance.now() - hit.at < 2000);
                if (live.length) this.predictedHits.set(key, live);
                else this.predictedHits.delete(key);
            });
        };
        this.isTree = (obj, effect)=>{
            const tile = effect.entityTile || this.config.tilemapMetaProvider.resolveCompositeTileIdTileMeta(obj.compositeTileId, obj.tilesetId)?.tileMeta?.entityTileId;
            return (0, $ff74dc2a666565c1$export$1db3e4d273a27613)(tile);
        };
        // A tree comes down rather than shattering: see TreeFall. It carries on from the swing the last blow
        // left it in, and goes over away from whoever felled it.
        this.fellTree = (key, set, effect)=>{
            const windLean = this.treeSway.release(key);
            const swing = this.treeHit.release(key);
            const lean = swing?.angle ?? windLean;
            const from = effect.strikeFrom || this.lastStrikeFrom.get(key);
            this.lastStrikeFrom.delete(key);
            this.predictedHits.delete(key);
            const art = this.treeDamage.art(set);
            const left = Math.min(...set.map((s)=>s.x));
            const right = Math.max(...set.map((s)=>s.x + s.width));
            const trunkX = art ? left + (art.trunkLeft + art.trunkRight + 1) / 2 : (left + right) / 2;
            const side = (0, $af00d3574f850c0a$export$cdbd06b8937c9881)(trunkX, from, lean);
            this.treeFall.fell({
                key: key,
                sprites: set,
                felled: this.treeDamage.felled(set, side),
                side: side,
                lean: lean
            });
        };
        this.strikeTree = (key, obj, effect)=>{
            const initialLean = this.treeSway.release(key);
            return this.treeHit.strike({
                initialLean: initialLean,
                key: key,
                sprites: ()=>this.surfaceObjectsByKey.get(key)?.spriteSet,
                art: this.treeDamage.art(obj.spriteSet),
                from: effect.strikeFrom,
                strength: effect.strikeStrength ?? 1
            });
        };
        this.predictTreeStrike = (effect)=>{
            const { x: x, y: y } = effect.mapRoughCoordinates;
            const key = effect.surfaceId || `${effect.tileId}-${x}-${y}`;
            const obj = this.surfaceObjectsByKey.get(key);
            if (!obj || !this.isTree(obj, effect) || !this.strikeTree(key, obj, effect)) return;
            if (effect.strikeFrom) this.lastStrikeFrom.set(key, effect.strikeFrom);
            const pending = this.predictedHits.get(key) || [];
            pending.push({
                strikerId: effect.strikerId,
                at: performance.now()
            });
            this.predictedHits.set(key, pending.slice(-8));
        };
        /** Release map transforms before a redraw recycles the tile sprites. */ this.clearSurfaceObjects = ()=>{
            this.arrowImpacts.clear();
            this.treeSway.reset();
            this.treeHit.releaseSprites();
            this.surfaceObjectsByKey.clear();
        };
        // ============================================================================
        // Private Helper Methods (consolidated from TileDamageManager)
        // ============================================================================
        /**
     * Perform shake animation for damaged tiles
     */ this.performShakeAnimation = (set, surfaceObject, onComplete, isCurrent)=>{
            const startTs = Date.now();
            const duration = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(100, 200) // ms
            ;
            const frequency = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(20, 30) // Hz
            ;
            const initialAmplitude = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(3, 6) // pixels
            ;
            const original = set.map((g)=>({
                    x: g.x,
                    y: g.y
                }));
            // A sprite in `set` can be destroyed mid-shake by a concurrent incremental repaint (placing or
            // hitting an adjacent wall re-tiles this one -> removeSpritedCell destroys its owned sprites).
            // A destroyed sprite is still truthy but its transform is null, so `g.x = ...` throws
            // "Cannot read properties of null (reading 'position')". Skip any sprite that's gone.
            const alive = (g)=>!!g && !g.destroyed && !!g.transform;
            const interval = setInterval(()=>{
                if (!isCurrent()) {
                    clearInterval(interval);
                    surfaceObject.isShaking = false;
                    return;
                }
                const elapsed = Date.now() - startTs;
                const progress = elapsed / duration;
                if (progress >= 1.0) {
                    clearInterval(interval);
                    // Guaranteed restoration - ensure tiles return to exact original positions
                    set.forEach((g, i)=>{
                        if (!alive(g)) return;
                        g.x = original[i].x;
                    });
                    // Clear the shaking flag to allow future shake effects
                    surfaceObject.isShaking = false;
                    onComplete();
                    return;
                }
                // Damped sine wave: amplitude * decay * sin(2π * frequency * time)
                const decay = Math.pow(1 - progress, 2) // Exponential decay
                ;
                const amplitude = initialAmplitude * decay;
                const offset = amplitude * Math.sin(2 * Math.PI * frequency * (elapsed / 1000));
                set.forEach((g, i)=>{
                    if (!alive(g)) return;
                    g.x = original[i].x + offset;
                });
            }, 16) // ~60fps
            ;
        };
        /**
     * Apply damage visualization after shake completes
     * Sprites are already in correct Y-order from processSurfaceId
     */ this.applyDamageVisualization = (effect, surfaceObject, set, x, y, showFeedback = true)=>{
            // This runs from the shake's onComplete, so `set` (captured before the shake) can now hold
            // sprites destroyed mid-shake by a concurrent full rerender / repaint. Reading their geometry
            // (breakage addChild, the HP-indicator's set[0].width) throws. Prune the shared spriteSet and
            // work from the live sprites; bail if nothing survives (the tile is gone -- nothing to visualize).
            if (surfaceObject.spriteSet) surfaceObject.spriteSet = surfaceObject.spriteSet.filter((s)=>s && !s.destroyed && !!s.transform);
            // Sprites are already in correct Y-order from processSurfaceId insertion
            const sorted = (surfaceObject.spriteSet || []).filter((s)=>s && !s.destroyed && !!s.transform);
            if (sorted.length === 0) return;
            // The server only populates hpPct for tiles whose max hp > 10 (see entity_tile.ts);
            // low-hp tiles like wall-wood (hp 5) arrive with hpPct undefined, which would make
            // damagePct = 1 - undefined = NaN and draw no damage. Derive the fraction from the
            // hp/hpMax the effect always carries -- the same values the deferred (re-render) path
            // uses -- so immediate damage matches what a reload would show.
            const hpPct = effect.hpPct ?? (effect.hpMax ? effect.hp / effect.hpMax : undefined);
            const compositeTileMeta = this.config.tilemapMetaProvider.resolveCompositeTileIdTileMeta(surfaceObject.compositeTileId, surfaceObject.tilesetId);
            if (this.isTree(surfaceObject, effect)) {
                const art = this.treeDamage.art(sorted);
                const left = Math.min(...sorted.map((s)=>s.x));
                const trunkX = left + (art ? (art.trunkLeft + art.trunkRight + 1) / 2 : sorted[0].texture.width / 2);
                const side = effect.strikeFrom && effect.strikeFrom.x < trunkX ? -1 : 1;
                this.treeDamage.apply(sorted, 1 - (hpPct ?? 1), side);
                return;
            }
            const breakageMeta = compositeTileMeta?.tileMeta?.breakageMeta;
            if (breakageMeta) {
                const damagePct = 1.0 - hpPct;
                if (!surfaceObject.flags) surfaceObject.flags = new Set();
                const breakSets = [];
                breakageMeta?.descriptors.forEach((descriptor, i)=>{
                    const key = `${descriptor.compositeTileId}-${x}-${y}`;
                    const applies = (0, $a80d0b17b615d6f7$export$cf95c51b03f10bae)(damagePct, descriptor.thresholdLow, descriptor.thresholdHigh);
                    if (applies) {
                        if (!surfaceObject.flags.has(key)) {
                            if (this.config.handleRenderCompositeTile) {
                                let breakset = this.config.handleRenderCompositeTile(key, this.config.tilemapMetaProvider, descriptor.compositeTileId, descriptor.tilesetId);
                                surfaceObject.flags.add(key);
                                breakSets.push(breakset);
                            }
                        }
                    }
                });
                if (breakSets.length > 0) breakSets.forEach((breakSet)=>{
                    sorted.forEach((next, i)=>{
                        const renderable = breakSet[i];
                        // `next` can have been destroyed mid-shake by a concurrent repaint (same race as
                        // performShakeAnimation); addChild on a destroyed sprite throws. Skip if gone.
                        if (!renderable || !next || next.destroyed || !next.transform) return;
                        // Position child sprites relative to parent, not absolute
                        renderable.x = 0;
                        renderable.y = 0;
                        next.addChild(renderable);
                    });
                });
            } else // Generate holes for more realistic damage
            this.config.holeEffect.generateDynamicHolesFromHp(surfaceObject, hpPct, x, y);
            // Show HP percentage indicator
            if (showFeedback && effect.hpPct) {
                const indicator = new (0, $5f817afe83d87a88$export$9ec831f4c1f089b1)();
                const location = this.config.worldOverlaySurface.computeLocation(x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                indicator.setup(location.x + sorted[0].width / 2, location.y, undefined, `${Math.ceil(effect.hpPct * 100)}%`, this.config.worldOverlaySurface);
            }
        };
        /**
     * Get cache statistics from the hole effect
     */ this.getCacheStats = ()=>{
            return (0, $30804d8d8c7ac29a$export$d2b760035f8f14b9).getCacheStats();
        };
        /**
     * Clear the global damage cache
     */ this.clearGlobalCache = ()=>{
            (0, $30804d8d8c7ac29a$export$d2b760035f8f14b9).clearGlobalCache();
        };
        this.config = config;
        this.surfaceObjectsByKey = surfaceObjectsByKey;
        this.treeSway = new (0, $ce5d8c9ba4707e67$export$759431532c42f1f4)(surfaceObjectsByKey);
        this.treeHit = new (0, $7fe91d19123d7ca1$export$6089bc5cd44e4755)(config.surface, ()=>{
            const renderer = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer;
            return {
                leaves: (0, $02d47f540b0d58f8$export$ebaa494e10da0ea2).textureFactory(renderer)(),
                puffs: (0, $f63df80eccdeeea6$export$ab8cf330af9aa032).textureFactory(renderer)()
            };
        });
        this.treeFall = new (0, $af00d3574f850c0a$export$c1847329e9550900)(config.surface, this.treeHit.debris);
        // Configure hole effect with proper colors
        this.configureHoleEffect();
    }
}







class $4c699c02db426c96$export$7d222435fcebb768 {
    static{
        this.PAN_MS = 360;
    }
    static{
        this.FLOOR_PAN_MS = 600;
    }
    static{
        this.JUMP_DISTANCE = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        this.FALL_FOLLOW_MS = 80;
    }
    constructor(){
        this.hasRunOnce = false;
        this.noDelay = false;
        this.panStartedAt = 0;
        this.floorPan = false;
        this.levelChanged = false;
        this.followingFall = false;
        this.fallFollowUntil = 0;
        this.computedAt = 0;
        this.velocity = {
            x: 0,
            y: 0
        };
        this.update = (tilemapMetaProvider)=>{
            const previous = this.tilemapMetaProvider;
            const previousHouse = previous?.twoStoreyHouse;
            const nextHouse = tilemapMetaProvider.twoStoreyHouse;
            const preserve = previous?.roomId === tilemapMetaProvider.roomId || previousHouse && nextHouse && previousHouse.groundRoomId === nextHouse.groundRoomId;
            if (preserve && this.hasRunOnce && previousHouse && nextHouse && previousHouse.floor !== nextHouse.floor) {
                // The destination used to be a companion drawn at this vertical offset.
                // Preserve its screen placement before easing toward the new active floor.
                this.modifierY += (0, $2751e0027a1b432f$export$9f4b491aa2a94a16)(previousHouse, nextHouse);
                this.levelChanged = true;
            }
            this.tilemapMetaProvider = tilemapMetaProvider;
            this.ts = Date.now();
            if (!preserve) this.reset();
        };
        this.reset = ()=>{
            this.hasRunOnce = false;
            this.target = undefined;
            this.panOffset = undefined;
            this.floorPan = false;
            this.levelChanged = false;
            this.followingFall = false;
            this.fallFollowUntil = 0;
            this.computedAt = 0;
            this.velocity = {
                x: 0,
                y: 0
            };
            this.modifierX = undefined;
            this.modifierY = undefined;
            this.xStatus = undefined;
            this.yStatus = undefined;
        };
        this.ready = ()=>Date.now() - this.ts >= 150;
        this.getCameraCenter = ()=>this.hasRunOnce ? {
                x: 50 - this.modifierX,
                y: 50 - this.modifierY
            } : undefined;
        this.bounds = ()=>{
            const X_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportX;
            const Y_FACTOR = (0, $10da07838e6d507c$export$aa707847c2571374).viewportY - 1;
            return {
                minX: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * X_FACTOR,
                maxX: (this.tilemapMetaProvider.width() - X_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                minY: (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * Y_FACTOR,
                maxY: (this.tilemapMetaProvider.height() - Y_FACTOR) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            };
        };
        /** The nearest point the camera can centre on without showing past the map edge. */ this.clampFocus = (location)=>{
            const { minX: minX, maxX: maxX, minY: minY, maxY: maxY } = this.bounds();
            return {
                x: Math.min(Math.max(location.x, minX), maxX),
                y: Math.min(Math.max(location.y, minY), maxY)
            };
        };
        this.compute = (location, force, fallOffsetY)=>{
            if (!this.hasRunOnce && !force && !this.noDelay && !this.ready()) return;
            const { minX: minX, maxX: maxX, minY: minY, maxY: maxY } = this.bounds();
            const focus = this.clampFocus(location);
            const target = {
                x: -focus.x + 50,
                y: -focus.y + 50
            };
            const now = Date.now();
            const previousX = this.modifierX, previousY = this.modifierY;
            const followingFall = fallOffsetY !== undefined;
            const fallHandoff = followingFall !== this.followingFall && this.hasRunOnce;
            if (fallOffsetY !== undefined) {
                // Follow the same physical height as the body. Independent per-floor pans
                // would decelerate and restart while the fall itself is accelerating.
                target.y -= fallOffsetY;
                // On takeover, retain the displayed framing (including walking/aim lead).
                // Decay that framing difference while the target follows the body's height.
                if (fallHandoff) {
                    this.panOffset = {
                        x: this.modifierX - target.x,
                        y: this.modifierY - target.y
                    };
                    this.panStartedAt = now;
                    this.floorPan = false;
                }
                this.levelChanged = false;
            } else if (this.levelChanged || !this.followingFall && this.target && Math.hypot(target.x - this.target.x, target.y - this.target.y) >= $4c699c02db426c96$export$7d222435fcebb768.JUMP_DISTANCE) {
                // Retarget from the displayed position, including an unfinished pan.
                this.panOffset = {
                    x: this.modifierX - target.x,
                    y: this.modifierY - target.y
                };
                this.panStartedAt = now;
                this.floorPan = this.levelChanged;
                this.levelChanged = false;
            }
            this.followingFall = followingFall;
            const duration = this.floorPan ? $4c699c02db426c96$export$7d222435fcebb768.FLOOR_PAN_MS : $4c699c02db426c96$export$7d222435fcebb768.PAN_MS;
            const progress = Math.min(1, (now - this.panStartedAt) / duration);
            // Floor changes start and finish at rest, so the height adjustment doesn't
            // kick the camera at full speed as soon as the destination arrives.
            const remaining = !this.panOffset ? 0 : this.floorPan ? 1 - progress * progress * (3 - 2 * progress) : (1 - progress) ** 3;
            this.modifierX = target.x + (this.panOffset?.x ?? 0) * remaining;
            this.modifierY = target.y + (this.panOffset?.y ?? 0) * remaining;
            const elapsed = Math.max(0, now - this.computedAt);
            if (followingFall) this.fallFollowUntil = now + $4c699c02db426c96$export$7d222435fcebb768.PAN_MS;
            if (this.hasRunOnce && now < this.fallFollowUntil) {
                // Falling height accelerates and stops abruptly at the ground. Follow it
                // with a short ease, including the landing tail, rather than copying that
                // velocity change straight into the entire world. Use the displayed
                // modifiers, already rebased by update() when a storey changes.
                const settle = followingFall ? 1 : (this.fallFollowUntil - now) / $4c699c02db426c96$export$7d222435fcebb768.PAN_MS;
                // Critically damped motion preserves velocity at both handoffs. Reduce
                // the settling time gradually so resumed walking regains normal follow.
                const omega = 2 / ($4c699c02db426c96$export$7d222435fcebb768.FALL_FOLLOW_MS * settle);
                const decay = Math.exp(-omega * elapsed);
                const smooth = (previous, target, axis)=>{
                    const gap = previous - target;
                    const motion = this.velocity[axis] + omega * gap;
                    const position = target + (gap + motion * elapsed) * decay;
                    this.velocity[axis] = (this.velocity[axis] - omega * motion * elapsed) * decay;
                    return position;
                };
                this.modifierX = smooth(previousX, this.modifierX, "x");
                this.modifierY = smooth(previousY, this.modifierY, "y");
            } else if (this.hasRunOnce && elapsed > 0) {
                this.velocity.x = (this.modifierX - previousX) / elapsed;
                this.velocity.y = (this.modifierY - previousY) / elapsed;
            }
            this.computedAt = now;
            if (progress >= 1) this.panOffset = undefined;
            this.target = target;
            this.hasRunOnce = true;
            this.xStatus = location.x <= minX ? "left" : location.x >= maxX ? "right" : "center";
            this.yStatus = location.y <= minY ? "top" : location.y >= maxY ? "bottom" : "center";
        };
    }
}



const $45a2dd83f20431d2$var$DEFAULT_TUNING = {
    enabled: true,
    deadZone: 12,
    lead: 24,
    leadEase: 0.4,
    aimLead: 64,
    follow: 0.12
};
const $45a2dd83f20431d2$var$tuning = {
    ...$45a2dd83f20431d2$var$DEFAULT_TUNING
};
const $45a2dd83f20431d2$export$34c5422d37d2e3b5 = (next)=>{
    if (next === null) Object.assign($45a2dd83f20431d2$var$tuning, $45a2dd83f20431d2$var$DEFAULT_TUNING);
    else if (typeof next === "boolean") $45a2dd83f20431d2$var$tuning.enabled = next;
    else Object.assign($45a2dd83f20431d2$var$tuning, next);
    return {
        ...$45a2dd83f20431d2$var$tuning
    };
};
const $45a2dd83f20431d2$var$ease = (seconds, tau)=>tau <= 0 ? 1 : 1 - Math.exp(-seconds / tau);
const $45a2dd83f20431d2$var$clampLength = (v, max)=>{
    const length = Math.hypot(v.x, v.y);
    return length <= max ? v : {
        x: v.x * max / length,
        y: v.y * max / length
    };
};
/** Ease `v` toward `target` by `fraction` of the gap, but never more than `maxStep` px. */ const $45a2dd83f20431d2$var$approach = (v, target, fraction, maxStep)=>{
    const step = $45a2dd83f20431d2$var$clampLength({
        x: (target.x - v.x) * fraction,
        y: (target.y - v.y) * fraction
    }, maxStep);
    v.x += step.x;
    v.y += step.y;
};
class $45a2dd83f20431d2$export$a7a8279c80a7b6f {
    static{
        /** A step this long between two calls is a teleport, not a walk: the camera goes straight there. */ this.JUMP_DISTANCE = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        /** Intent above this is walking; below it (released keys coasting to a halt) the lead holds. */ this.WALKING = 0.5;
    }
    constructor(){
        this.moveLead = {
            x: 0,
            y: 0
        };
        this.aimLean = {
            x: 0,
            y: 0
        };
        this.walking = 0;
        this.ts = 0;
        this.focus = (location, now, input)=>{
            const jumped = this.last && Math.hypot(location.x - this.last.x, location.y - this.last.y) >= $45a2dd83f20431d2$export$a7a8279c80a7b6f.JUMP_DISTANCE;
            this.last = {
                x: location.x,
                y: location.y
            };
            if (!$45a2dd83f20431d2$var$tuning.enabled || input.snap || jumped || !this.camera) return this.place(location, now, input.clamp);
            const seconds = Math.max(0, now - this.ts) / 1000;
            this.ts = now;
            const intent = $45a2dd83f20431d2$var$clampLength(input.intent ?? {
                x: 0,
                y: 0
            }, 1);
            const pace = Math.hypot(intent.x, intent.y);
            const walking = pace > $45a2dd83f20431d2$export$a7a8279c80a7b6f.WALKING;
            const leadEase = $45a2dd83f20431d2$var$ease(seconds, $45a2dd83f20431d2$var$tuning.leadEase);
            const maxStep = input.speed ? input.speed * seconds : Infinity;
            if (walking) {
                const lead = $45a2dd83f20431d2$var$tuning.lead / pace;
                $45a2dd83f20431d2$var$approach(this.moveLead, {
                    x: intent.x * lead,
                    y: intent.y * lead
                }, leadEase, maxStep);
            }
            if (input.aimAngle !== undefined) {
                const aim = {
                    x: Math.cos(input.aimAngle) * $45a2dd83f20431d2$var$tuning.aimLead,
                    y: Math.sin(input.aimAngle) * $45a2dd83f20431d2$var$tuning.aimLead
                };
                $45a2dd83f20431d2$var$approach(this.aimLean, aim, leadEase, maxStep);
            } else if (walking) $45a2dd83f20431d2$var$approach(this.aimLean, {
                x: 0,
                y: 0
            }, leadEase, maxStep);
            this.walking += (pace - this.walking) * leadEase;
            const zone = $45a2dd83f20431d2$var$tuning.deadZone * (1 - this.walking);
            const anchor = this.anchor;
            anchor.x = Math.min(Math.max(anchor.x, location.x - zone), location.x + zone);
            anchor.y = Math.min(Math.max(anchor.y, location.y - zone), location.y + zone);
            const offset = $45a2dd83f20431d2$var$clampLength({
                x: this.moveLead.x + this.aimLean.x,
                y: this.moveLead.y + this.aimLean.y
            }, Math.max($45a2dd83f20431d2$var$tuning.lead, $45a2dd83f20431d2$var$tuning.aimLead));
            const trail = (input.speed ?? 0) * $45a2dd83f20431d2$var$tuning.follow;
            const target = input.clamp({
                x: anchor.x + offset.x + intent.x * trail,
                y: anchor.y + offset.y + intent.y * trail
            });
            const follow = $45a2dd83f20431d2$var$ease(seconds, $45a2dd83f20431d2$var$tuning.follow);
            this.camera.x += (target.x - this.camera.x) * follow;
            this.camera.y += (target.y - this.camera.y) * follow;
            return {
                ...this.camera
            };
        };
        this.reset = ()=>{
            this.camera = undefined;
            this.anchor = undefined;
            this.last = undefined;
        };
        this.place = (location, now, clamp)=>{
            this.camera = clamp(location);
            this.anchor = {
                x: location.x,
                y: location.y
            };
            this.moveLead = {
                x: 0,
                y: 0
            };
            this.aimLean = {
                x: 0,
                y: 0
            };
            this.walking = 0;
            this.ts = now;
            return {
                ...this.camera
            };
        };
    }
}
// Browser-console tuning, in the same shape as window.playerRing / window.spriteShadow:
//
//     cameraFollow = false                  // the old camera, locked on the player
//     cameraFollow = { lead: 64 }           // look further ahead
//     cameraFollow = { deadZone: 0 }        // no free box
//     cameraFollow = { follow: 0 }          // no easing
//     cameraFollow = null                   // back to the defaults
//     cameraFollow                          // read the active values back
//
// Guarded so it is a no-op in the Node test harness.
if (typeof window !== "undefined") Object.defineProperty(window, "cameraFollow", {
    get: ()=>({
            ...$45a2dd83f20431d2$var$tuning
        }),
    set: (next)=>{
        console.log("[cameraFollow]", $45a2dd83f20431d2$export$34c5422d37d2e3b5(next));
    },
    configurable: true
});



class $ecbfd660c7b27906$export$b63e72441cbf98ad {
    constructor(config){
        this.follow = new (0, $45a2dd83f20431d2$export$a7a8279c80a7b6f)();
        /**
     * Update the camera position based on player location
     */ this.updatePlayerLocation = (entity, force)=>{
            if (!entity) return;
            if (entity.location.x < 0 || entity.location.y < 0) return;
            // Compute camera translation modifiers
            const fallOffset = entity.floorFall ? (0, $7f7f5b693e82869c$export$b9937d18fdb36290)(entity, this.translationComputer.tilemapMetaProvider?.roomId) : undefined;
            const focus = this.translationComputer.tilemapMetaProvider ? this.follow.focus(entity.location, Date.now(), {
                intent: entity.speed2,
                speed: entity.speed,
                aimAngle: this.aimAngle?.(entity),
                clamp: this.translationComputer.clampFocus,
                // A fall keeps its own camera, timed to the body (see TranslationComputer.compute).
                snap: force || !this.translationComputer.hasRunOnce || fallOffset !== undefined || entity.entityId !== this.followedId
            }) : entity.location;
            this.followedId = entity.entityId;
            this.translationComputer.compute(focus, force, fallOffset);
            const { modifierX: modifierX, modifierY: modifierY } = this.translationComputer;
            // Apply screen shake and camera positioning
            const shakeState = this.screenShakeManager.getState();
            if (modifierX !== undefined) {
                const transformedX = (shakeState.shakeOffsetX + modifierX + (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w / 2) * (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom - 48 * (0, $10da07838e6d507c$export$aa707847c2571374).viewportX;
                this.surface.transform.position.x = transformedX;
                this.worldOverlaySurface.transform.position.x = transformedX;
            }
            if (modifierY !== undefined) {
                const transformedY = (shakeState.shakeOffsetY + modifierY + (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h / 2) * (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom - 48 * (0, $10da07838e6d507c$export$aa707847c2571374).viewportY;
                this.surface.transform.position.y = transformedY;
                this.worldOverlaySurface.transform.position.y = transformedY;
            }
        };
        /**
     * Trigger screen shake effect
     */ this.screenShake = (entity)=>{
            this.screenShakeManager.screenShake(entity, this.updatePlayerLocation);
        };
        /**
     * A decaying camera kick from a world event rather than from being hit. See
     * ScreenShakeManager.impulse for why this is a separate channel from screenShake.
     */ this.screenShakeImpulse = (entity, amplitude, durationMs)=>{
            this.screenShakeManager.impulse(entity, amplitude, durationMs, this.updatePlayerLocation);
        };
        /**
     * Update the translation computer with new tilemap data
     */ this.updateTranslationComputer = (tilemapMetaProvider)=>{
            this.translationComputer.update(tilemapMetaProvider);
        };
        /**
     * Reset camera state
     */ this.reset = ()=>{
            this.translationComputer.reset();
            this.follow.reset();
        };
        /**
     * Get the current translation computer for advanced operations
     */ this.getTranslationComputer = ()=>{
            return this.translationComputer;
        };
        /**
     * Get the current screen shake manager
     */ this.getScreenShakeManager = ()=>{
            return this.screenShakeManager;
        };
        this.surface = config.surface;
        this.worldOverlaySurface = config.worldOverlaySurface;
        this.screenShakeManager = config.screenShakeManager;
        this.aimAngle = config.aimAngle;
        this.translationComputer = new (0, $4c699c02db426c96$export$7d222435fcebb768)();
    }
}



parcelRequire("1avo5");





const $75a0a4fb75fb6456$export$b972511549e2f31a = true;
const $75a0a4fb75fb6456$export$f34b24a5dc375e3 = ()=>({
        enabled: $75a0a4fb75fb6456$export$b972511549e2f31a,
        alpha: 0.5,
        speed: 0.1,
        neighborRadius: 160,
        minNeighbors: 8,
        hysteresis: 3
    });
// Player body box in fine (pixel) coords, anchored at the feet sort-point (== entity.location). The
// box spans up from the feet to roughly the head so a canopy overlapping the torso/head counts as
// occluding, while a trunk sprite sitting at/below the feet line does not.
const $75a0a4fb75fb6456$var$PLAYER_HALF_WIDTH = 11;
const $75a0a4fb75fb6456$var$PLAYER_BODY_HEIGHT = 46;
const $75a0a4fb75fb6456$var$PLAYER_FEET_MARGIN = 2;
// Alpha within this of the target snaps exactly (and, when restoring, drops the sprite from tracking).
const $75a0a4fb75fb6456$var$SNAP = 0.02;
const $75a0a4fb75fb6456$export$a9aeffcbb50105b7 = (entityTileId)=>{
    if (!entityTileId) return undefined;
    if ((0, $ff74dc2a666565c1$export$1db3e4d273a27613)(entityTileId)) return "gated";
    if ((0, $ff74dc2a666565c1$export$81defb755c513edb)(entityTileId)) return "always";
    return undefined;
};
class $75a0a4fb75fb6456$export$ffb41811f55797a3 {
    // Whether the player is currently in a "dense" stand (the fade is active).
    get isDense() {
        return this.denseLatched;
    }
    // Fade the tile sprites the player (feet at fine coords feetX/feetY, draw-order key playerZIndex)
    // is behind, and ease everything else back to opaque. `candidates` is the tagged tile sprites
    // currently on screen (a reused array, so no allocation). One indexed pass computes both the local
    // density (neighbor count) and the set of tiles overlapping the player; the density gate then
    // decides which of those overlappers fade -- "always" candidates skip the gate. Allocation-free
    // and idempotent per frame.
    update(feetX, feetY, playerZIndex, candidates) {
        if (!this.config.enabled) {
            this.relaxAll();
            return;
        }
        const bx1 = feetX - $75a0a4fb75fb6456$var$PLAYER_HALF_WIDTH;
        const bx2 = feetX + $75a0a4fb75fb6456$var$PLAYER_HALF_WIDTH;
        const by1 = feetY - $75a0a4fb75fb6456$var$PLAYER_BODY_HEIGHT;
        const by2 = feetY - $75a0a4fb75fb6456$var$PLAYER_FEET_MARGIN;
        const radius = this.config.neighborRadius;
        const r2 = radius * radius;
        let neighbors = 0;
        const occluding = this.occluding;
        occluding.clear();
        for(let i = 0; i < candidates.length; i++){
            const g = candidates[i];
            if (!g || g.destroyed) continue;
            const w = g.width;
            const h = g.height;
            if (w <= 0 || h <= 0) continue;
            // Local density: does this tile's center sit within neighborRadius of the player? Skip the
            // squared-distance for tiles already too far in x to qualify (the common case off-cluster).
            const dx = g.x + w * 0.5 - feetX;
            if (dx <= radius && dx >= -radius) {
                const dy = g.y + h * 0.5 - feetY;
                if (dx * dx + dy * dy <= r2) neighbors++;
            }
            // Occlusion: draws in front AND its box (top-left anchored) overlaps the body box. Cheap
            // comparisons that short-circuit for far tiles, so this stays correct at any neighborRadius.
            if (g.zIndex > playerZIndex && g.x < bx2 && g.x + w > bx1 && g.y < by2 && g.y + h > by1) occluding.add(g);
        }
        this.lastNeighborCount = neighbors;
        // Neighbor-density gate with hysteresis: turn ON at minNeighbors, OFF only once density falls
        // to minNeighbors - hysteresis, so the player lingering on the boundary can't cause a blink.
        const onThreshold = this.config.minNeighbors;
        const offThreshold = Math.max(0, this.config.minNeighbors - this.config.hysteresis);
        this.denseLatched = this.denseLatched ? neighbors >= offThreshold : neighbors >= onThreshold;
        const dense = this.denseLatched;
        // An occluder fades if the gate is open OR it is one of the candidates that ignores the gate.
        const fades = (g)=>occluding.has(g) && (dense || g.occluderFade === "always");
        occluding.forEach((g)=>{
            if (fades(g)) this.tracked.add(g);
        });
        for (const g of this.tracked){
            if (g.destroyed) {
                this.tracked.delete(g);
                continue;
            }
            const target = fades(g) ? this.config.alpha : 1.0;
            const next = g.alpha + (target - g.alpha) * this.config.speed;
            if (Math.abs(next - target) <= $75a0a4fb75fb6456$var$SNAP) {
                g.alpha = target;
                if (target >= 1.0) this.tracked.delete(g);
            } else g.alpha = next;
        }
    }
    // Put every tracked sprite straight back to full opacity: the map stopped being the one the player
    // stands in, so nothing will ease them back.
    restoreAll() {
        this.occluding.clear();
        this.denseLatched = false;
        for (const g of this.tracked)if (!g.destroyed) g.alpha = 1.0;
        this.tracked.clear();
    }
    // Ease every tracked sprite back to full opacity (used when the feature is disabled or there is no
    // player). Idempotent; drops sprites once restored so no sprite references are retained while idle.
    relaxAll() {
        // Drop last frame's occluder refs -- the active path clears this each frame, but the disabled
        // path skips it, so clear here too and hold nothing while idle.
        this.occluding.clear();
        this.denseLatched = false;
        for (const g of this.tracked){
            if (g.destroyed) {
                this.tracked.delete(g);
                continue;
            }
            const next = g.alpha + (1.0 - g.alpha) * this.config.speed;
            if (1.0 - next <= $75a0a4fb75fb6456$var$SNAP) {
                g.alpha = 1.0;
                this.tracked.delete(g);
            } else g.alpha = next;
        }
    }
    constructor(){
        this.config = $75a0a4fb75fb6456$export$f34b24a5dc375e3();
        // Sprites currently pushed off full opacity; tracked until they lerp back to 1.0 so we know which
        // to restore once the player steps out from behind them.
        this.tracked = new Set();
        // The occluders found this frame. Reused (cleared) every frame rather than reallocated, so the
        // per-frame path allocates nothing -- avoids the steady GC pressure that causes hitches on
        // low-end machines (see the budget-hardware note).
        this.occluding = new Set();
        // Latched gate state (hysteresis) + last density, exposed for the debug/tuning readout.
        this.denseLatched = false;
        this.lastNeighborCount = 0;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $klOfb = parcelRequire("klOfb");
let $f995e013b6debd58$var$frames;
const $f995e013b6debd58$var$blend = (dark, bright, amount)=>[
        16,
        8,
        0
    ].reduce((color, shift)=>color | Math.round((dark >> shift & 255) * (1 - amount) + (bright >> shift & 255) * amount) << shift, 0);
const $f995e013b6debd58$export$f1decc78b3ea2087 = (renderer)=>{
    if ($f995e013b6debd58$var$frames) return $f995e013b6debd58$var$frames;
    $f995e013b6debd58$var$frames = [];
    const g = new (0, $gwPoJ.Graphics)(), x = 16, y = 30;
    for(let i = 0; i <= 10; i++){
        const energy = i / 10;
        g.clear();
        g.lineStyle(2, $f995e013b6debd58$var$blend(0x787180, 0x9ee86c, energy), 0.9);
        g.beginFill(0x383041, 1);
        g.drawPolygon([
            x - 9,
            y + 10,
            x - 10,
            y - 9,
            x - 3,
            y - 18,
            x + 7,
            y - 15,
            x + 10,
            y + 8,
            x,
            y + 14
        ]);
        g.endFill();
        g.lineStyle(1.5, 0x99889f, 0.5);
        g.moveTo(x - 3, y - 16);
        g.lineTo(x - 4, y + 9);
        g.lineStyle(2, $f995e013b6debd58$var$blend(0x62536e, 0xc4ff9f, energy), 0.9);
        g.moveTo(x, y + 4);
        g.lineTo(x, y - 10);
        g.moveTo(x - 5, y - 6);
        g.lineTo(x, y - 2);
        g.lineTo(x + 5, y - 6);
        const texture = (0, $klOfb.RenderTexture).create({
            width: 32,
            height: 48
        });
        renderer.render(g, {
            renderTexture: texture,
            clear: true
        });
        $f995e013b6debd58$var$frames.push(texture);
    }
    g.destroy();
    return $f995e013b6debd58$var$frames;
};
const $f995e013b6debd58$export$2f635036cd6a2bce = (ritual, index, now, elapsedMs)=>{
    if (!ritual || index >= ritual.stage) return 0;
    const fade = ritual.phase === "active" ? 1 : Math.max(0, 1 - ((ritual.transitionAgeMs ?? Infinity) + elapsedMs) / 1400);
    return fade * (0.8 + 0.2 * Math.sin(now / 200 + index));
};


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $gwPoJ = parcelRequire("gwPoJ");
var $klOfb = parcelRequire("klOfb");
const $1b34ef4012f1eb6c$export$7ca626a3dd9d2334 = {
    coal: {
        color: 0x242630,
        shadow: 0x121319,
        highlight: 0x55545c,
        flecks: [
            [
                8,
                12,
                4,
                3
            ],
            [
                20,
                19,
                4,
                3
            ],
            [
                13,
                27,
                3,
                3
            ],
            [
                7,
                39,
                4,
                3
            ],
            [
                21,
                47,
                3,
                3
            ]
        ]
    },
    iron: {
        color: 0x947969,
        shadow: 0x493b34,
        highlight: 0xc6aa91,
        flecks: [
            [
                9,
                12,
                4,
                2
            ],
            [
                20,
                19,
                3,
                2
            ],
            [
                12,
                27,
                4,
                2
            ],
            [
                8,
                40,
                3,
                2
            ],
            [
                21,
                47,
                4,
                2
            ]
        ]
    },
    copper: {
        color: 0xc47946,
        shadow: 0x603e2b,
        highlight: 0xe7aa67,
        flecks: [
            [
                9,
                12,
                3,
                3
            ],
            [
                20,
                20,
                3,
                3
            ],
            [
                12,
                27,
                3,
                3
            ],
            [
                8,
                40,
                3,
                3
            ],
            [
                21,
                47,
                3,
                3
            ]
        ]
    },
    silver: {
        color: 0xb6c8d0,
        shadow: 0x526577,
        highlight: 0xe8f3f5,
        flecks: [
            [
                10,
                11,
                2,
                4
            ],
            [
                21,
                19,
                2,
                4
            ],
            [
                13,
                26,
                2,
                4
            ],
            [
                9,
                39,
                2,
                4
            ],
            [
                22,
                46,
                2,
                4
            ]
        ]
    },
    gold: {
        color: 0xd5a332,
        shadow: 0x705019,
        highlight: 0xf6d46a,
        flecks: [
            [
                9,
                12,
                3,
                2
            ],
            [
                20,
                20,
                3,
                2
            ],
            [
                12,
                27,
                3,
                2
            ],
            [
                8,
                40,
                3,
                2
            ],
            [
                21,
                47,
                3,
                2
            ]
        ]
    }
};
const $1b34ef4012f1eb6c$export$56f5d6880632643 = (value)=>typeof value === "string" && Object.prototype.hasOwnProperty.call($1b34ef4012f1eb6c$export$7ca626a3dd9d2334, value);
const $1b34ef4012f1eb6c$var$textures = new WeakMap();
const $1b34ef4012f1eb6c$export$ad0c8bd3f530e1e4 = (base, material, renderer)=>{
    let variants = $1b34ef4012f1eb6c$var$textures.get(base);
    if (!variants) {
        variants = new Map();
        $1b34ef4012f1eb6c$var$textures.set(base, variants);
    }
    const cached = variants.get(material);
    if (cached?.orig && !cached.baseTexture?.destroyed) return cached;
    const surface = new (0, $8t5Gy.Container)();
    surface.addChild(new (0, $7Bs2Z.Sprite)(base));
    const flecks = new (0, $gwPoJ.Graphics)();
    const style = $1b34ef4012f1eb6c$export$7ca626a3dd9d2334[material];
    for (const [x, y, width, height] of style.flecks){
        flecks.beginFill(style.shadow).drawRect(x - 1, y - 1, width + 2, height + 2).endFill();
        flecks.beginFill(style.color).drawRect(x, y, width, height).endFill();
        flecks.beginFill(style.highlight).drawRect(x, y, Math.max(1, width - 1), 1).endFill();
    }
    surface.addChild(flecks);
    const texture = (0, $klOfb.RenderTexture).create({
        width: base.width,
        height: base.height,
        scaleMode: base.baseTexture.scaleMode
    });
    renderer.render(surface, {
        renderTexture: texture,
        clear: true
    });
    surface.destroy({
        children: true
    });
    variants.set(material, texture);
    return texture;
};






const $33b8b2956df9c5d3$export$f27ffc74f52b64b5 = [
    "grove-bush-a",
    "grove-bush-b",
    "grove-shrub-b",
    "grove-shrub-a",
    "grove-shrub-c",
    "grove-shrub-a",
    "grove-bush-c",
    "grove-bush-d"
];
const $33b8b2956df9c5d3$var$EMBER_BUSH_SET = new Set($33b8b2956df9c5d3$export$f27ffc74f52b64b5);
const $33b8b2956df9c5d3$export$fee21090cd1958a1 = (compositeId)=>$33b8b2956df9c5d3$var$EMBER_BUSH_SET.has(compositeId);
const $33b8b2956df9c5d3$var$property = (tile, name)=>tile?.properties?.find((p)=>p.name === name)?.value;
let $33b8b2956df9c5d3$var$parentsFor;
let $33b8b2956df9c5d3$var$parents;
const $33b8b2956df9c5d3$export$322eeafa544cf3aa = (id)=>{
    if ($33b8b2956df9c5d3$var$parentsFor !== (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets) {
        $33b8b2956df9c5d3$var$parents = new Map();
        for (const [tilesetId, sheet] of Object.entries((0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets))for (const tile of sheet.tiles || []){
            const composite = $33b8b2956df9c5d3$var$property(tile, "compositeTileIdParent");
            if (composite && !$33b8b2956df9c5d3$var$parents.has(composite)) $33b8b2956df9c5d3$var$parents.set(composite, {
                tilesetId: tilesetId,
                tilePos: tile.id
            });
        }
        $33b8b2956df9c5d3$var$parentsFor = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets;
    }
    return $33b8b2956df9c5d3$var$parents.get(id);
};
const $33b8b2956df9c5d3$export$8f515c9a2a28cf4a = ()=>$33b8b2956df9c5d3$export$f27ffc74f52b64b5.map((id)=>{
        const planted = $33b8b2956df9c5d3$export$322eeafa544cf3aa(id);
        // Loud rather than a bare camp: the art ships with the code that plants it.
        if (!planted) throw new Error(`Ember bush ${id} is not in the content catalog`);
        return planted;
    });
const $33b8b2956df9c5d3$export$3a1fd1403e0fe2ae = (tilesetId, tilePos)=>$33b8b2956df9c5d3$export$8f515c9a2a28cf4a().some((bush)=>bush.tilesetId === tilesetId && bush.tilePos === tilePos);
const $33b8b2956df9c5d3$export$99a5c4a7db1012ac = ()=>[
        ...new Set($33b8b2956df9c5d3$export$8f515c9a2a28cf4a().map((bush)=>(0, $757b61c60f0c23c3$export$b5fe4f8e2269498c)(bush.tilesetId, bush.tilePos)))
    ];




const $3e205d6c633194c2$export$6bbccace033387da = (compositeTileMeta, y)=>{
    const rects = compositeTileMeta?.tileMeta?.blockingRects;
    if (!rects?.length) return undefined;
    const top = Math.min(...rects.map((rect)=>rect.y));
    const bottom = Math.max(...rects.map((rect)=>rect.y + rect.height));
    return 100 + y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (top + bottom) / 2;
};
const $3e205d6c633194c2$export$8b3ab97ac444fb53 = (compositeTileMeta, bounds, x, y, extraZIndex)=>{
    const fine = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
        x: x,
        y: y - bounds.height + 1
    });
    return {
        x: fine.x - (bounds.width > 1 ? bounds.width * 0.25 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) : 0) + (compositeTileMeta?.tileMeta?.renderXOffset || 0),
        y: fine.y + (compositeTileMeta?.tileMeta?.renderYOffset || 0),
        zIndex: (extraZIndex || 0) + (compositeTileMeta?.tileMeta?.renderZIdxOffset || 0) + ($3e205d6c633194c2$export$6bbccace033387da(compositeTileMeta, y) ?? 100 + fine.y + (compositeTileMeta?.tileMeta?.renderYOffset || 0) + bounds.height * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.75)
    };
};


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");





const $94eed483b855593a$export$84bb4db9803ba90d = (tilesetId, columns, children)=>{
    const frames = (0, $1f08f7b8f85adf9e$export$42d948b5d3f64a60)(tilesetId)?.textures;
    if (!frames || !children.length) return undefined;
    const cells = children.map((child)=>({
            tile: child.tileNumber,
            x: (child.tileNumber - 1) % columns,
            y: Math.floor((child.tileNumber - 1) / columns)
        }));
    const left = Math.min(...cells.map((c)=>c.x)), top = Math.min(...cells.map((c)=>c.y));
    const canvas = document.createElement("canvas");
    canvas.width = (Math.max(...cells.map((c)=>c.x)) - left + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    canvas.height = (Math.max(...cells.map((c)=>c.y)) - top + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const context = canvas.getContext("2d");
    if (!context) return undefined;
    for (const cell of cells){
        const texture = frames[`${tilesetId}-${cell.tile}`];
        const source = texture?.baseTexture?.resource?.source;
        if (!source) return undefined;
        const frame = texture.frame;
        context.drawImage(source, frame.x, frame.y, frame.width, frame.height, (cell.x - left) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (cell.y - top) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    }
    return {
        data: context.getImageData(0, 0, canvas.width, canvas.height).data,
        width: canvas.width,
        height: canvas.height
    };
};


const $e9b6a02a637ade4e$export$88b9dbeabdb549d3 = (rgba, width, height)=>{
    const edges = [];
    for(let x = 0; x < width; x++)for(let y = height - 1; y >= Math.max(0, height - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)); y--)if (rgba[(y * width + x) * 4 + 3] > 128) {
        edges.push({
            x: x,
            y: y
        });
        break;
    }
    return edges;
};
const $e9b6a02a637ade4e$export$77a9be7b578c3d87 = (edges, maxClimb = 3)=>{
    if (!edges.length) return edges;
    const lowest = edges.reduce((best, edge, i)=>edge.y > edges[best].y ? i : best, 0);
    const joined = (from, to)=>Math.abs(to.x - from.x) === 1 && from.y - to.y <= maxClimb;
    let left = lowest, right = lowest;
    while(left > 0 && joined(edges[left], edges[left - 1]))left--;
    while(right < edges.length - 1 && joined(edges[right], edges[right + 1]))right++;
    return edges.slice(left, right + 1);
};
const $e9b6a02a637ade4e$export$c7f5b8d65f50cd68 = (rgba, width, edges)=>edges.map((edge)=>{
        const i = (Math.max(0, edge.y - 1) * width + edge.x) * 4;
        const bark = rgba[i + 3] > 250 && rgba[i] > rgba[i + 2] + 4 && rgba[i] >= rgba[i + 1];
        return bark ? {
            ...edge,
            bark: bark
        } : edge;
    });
const $e9b6a02a637ade4e$export$f822a6c070dba650 = (x, y, seed)=>{
    let h = Math.imul(x + seed, 374761393) ^ Math.imul(y, 668265263);
    h = Math.imul(h ^ h >>> 13, 1274126177);
    return ((h ^ h >>> 16) >>> 0) / 4294967295;
};
// One shared palette and density for all grass surfaces.
const $e9b6a02a637ade4e$var$PALETTE = [
    0x3e872a,
    0x4d932a,
    0x6a9e31
];
const $e9b6a02a637ade4e$export$2f9cfe66677688b0 = (edges)=>$e9b6a02a637ade4e$export$77a9be7b578c3d87(edges).flatMap((edge)=>{
        if (edge.x % 2 || $e9b6a02a637ade4e$export$f822a6c070dba650(edge.x, edge.y, 0) > 0.58) return [];
        const variation = $e9b6a02a637ade4e$export$f822a6c070dba650(edge.x, edge.y, 71);
        return [
            {
                x: edge.x,
                y: edge.y + 1,
                height: 2 + Math.floor(variation * 4),
                color: $e9b6a02a637ade4e$var$PALETTE[Math.floor(variation * 3)]
            }
        ];
    });
const $e9b6a02a637ade4e$export$5f3b0c0520ba57d0 = (edges)=>{
    const bottom = Math.max(...edges.map((edge)=>edge.y));
    const roots = edges.filter((edge)=>edge.y >= bottom - 2);
    return {
        x: (Math.min(...roots.map((edge)=>edge.x)) + Math.max(...roots.map((edge)=>edge.x))) / 2,
        y: bottom + 2
    };
};
const $e9b6a02a637ade4e$var$contours = new Map();
let $e9b6a02a637ade4e$var$contourGeneration = -1;
const $e9b6a02a637ade4e$export$5c30771e466c913e = (tilesetId, compositeId, columns, children)=>{
    const generation = (0, $1f08f7b8f85adf9e$export$dd4554ad7431ed50)();
    if (generation !== $e9b6a02a637ade4e$var$contourGeneration) {
        $e9b6a02a637ade4e$var$contours.clear();
        $e9b6a02a637ade4e$var$contourGeneration = generation;
    }
    const key = `${tilesetId}:${compositeId}`;
    if ($e9b6a02a637ade4e$var$contours.has(key)) return $e9b6a02a637ade4e$var$contours.get(key);
    const art = (0, $94eed483b855593a$export$84bb4db9803ba90d)(tilesetId, columns, children);
    if (!art) return undefined;
    const edges = $e9b6a02a637ade4e$export$c7f5b8d65f50cd68(art.data, art.width, $e9b6a02a637ade4e$export$88b9dbeabdb549d3(art.data, art.width, art.height));
    $e9b6a02a637ade4e$var$contours.set(key, edges);
    return edges;
};
const $e9b6a02a637ade4e$var$baked = new WeakMap();
const $e9b6a02a637ade4e$export$4f4a66328d0917d9 = (tree, edges, renderer)=>{
    const cached = $e9b6a02a637ade4e$var$baked.get(tree);
    if (cached?.renderer === renderer && !cached.texture.baseTexture.destroyed) return cached.texture;
    const surface = new (0, $8t5Gy.Container)();
    surface.addChild(new (0, $7Bs2Z.Sprite)(tree));
    const fringe = new (0, $gwPoJ.Graphics)();
    surface.addChild(fringe);
    for (const blade of $e9b6a02a637ade4e$export$2f9cfe66677688b0(edges)){
        fringe.beginFill(blade.color);
        fringe.drawRect(blade.x, blade.y - blade.height + 1, 1, blade.height);
        fringe.drawRect(blade.x + (blade.x % 4 ? -1 : 1), blade.y - blade.height, 1, 1);
        fringe.endFill();
    }
    // Into the shared atlas of baked trees, so a forest's trees batch together (a texture each broke it).
    const region = new (0, $6qzqq.Rectangle)(0, 0, tree.width, tree.height);
    const texture = (0, $78ff247413a98680$export$d356f62a11a0ce0d).put(renderer, surface, region) ?? renderer.generateTexture(surface, {
        region: region
    });
    surface.destroy({
        children: true
    });
    $e9b6a02a637ade4e$var$baked.set(tree, {
        renderer: renderer,
        texture: texture
    });
    return texture;
};




parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");


// The forest dirt's soil ramp, darkest first (packages/tools/src/dirt/gen.py SOIL; the LPC dirt pair is
// 3 and 4). The mound is drawn one step darker on the damp edge soil and one lighter on the trodden
// core, as the soil itself is, so it never shows as a band of another colour.
const $6f4e2796428d115f$var$SOIL = [
    0x73503a,
    0x7b563c,
    0x80593d,
    0x865e40,
    0x926c42,
    0x97714a,
    0x9b744c
];
const $6f4e2796428d115f$var$REACH = 4 // how far the mound slopes out past the trunk
;
const $6f4e2796428d115f$export$5d5be7b74f7c6cd8 = (edges)=>{
    if (!edges.length) return undefined;
    const bottom = Math.max(...edges.map((edge)=>edge.y));
    const bark = edges.filter((edge)=>edge.bark && edge.y >= bottom - 4).map((edge)=>edge.x).sort((a, b)=>a - b);
    let best;
    for(let i = 0, start = 0; i < bark.length; i++){
        if (i + 1 < bark.length && bark[i + 1] === bark[i] + 1) continue;
        if (!best || bark[i] - bark[start] > best.right - best.left) best = {
            left: bark[start],
            right: bark[i]
        };
        start = i + 1;
    }
    return best && best.right - best.left >= 4 ? {
        ...best,
        bottom: bottom
    } : undefined;
};
const $6f4e2796428d115f$export$b9f12138e1ef7452 = (edges, zone)=>{
    const trunk = $6f4e2796428d115f$export$5d5be7b74f7c6cd8(edges);
    if (!trunk) return [];
    const { left: left, right: right, bottom: bottom } = trunk;
    const heights = new Map();
    for(let x = left - $6f4e2796428d115f$var$REACH, lump = 0; x <= right + $6f4e2796428d115f$var$REACH; lump++){
        const width = 4 + Math.floor((0, $e9b6a02a637ade4e$export$f822a6c070dba650)(x, lump, 101) * 4);
        const peak = [
            2,
            3,
            3,
            4
        ][Math.floor((0, $e9b6a02a637ade4e$export$f822a6c070dba650)(x, lump, 103) * 4)];
        for(let i = 0; i < width; i++){
            const inside = Math.min(x + i - left, right - (x + i));
            const slope = Math.max(0, Math.min(1, (inside + $6f4e2796428d115f$var$REACH) / ($6f4e2796428d115f$var$REACH + 1.5)));
            const height = peak * Math.sin(Math.PI * (i + 0.5) / width) ** 0.4 * slope;
            heights.set(x + i, Math.max(heights.get(x + i) ?? 0, height));
        }
        x += width - 1 - Math.floor((0, $e9b6a02a637ade4e$export$f822a6c070dba650)(x, lump, 107) * 2);
    }
    const lowest = new Map(edges.map((edge)=>[
            edge.x,
            edge.y
        ]));
    const soil = (step)=>$6f4e2796428d115f$var$SOIL[Math.max(0, Math.min($6f4e2796428d115f$var$SOIL.length - 1, step + zone - 1))];
    const pixels = [];
    heights.forEach((raw, x)=>{
        const height = Math.round(raw);
        if (height <= 0) return;
        const foot = x >= left && x <= right ? lowest.get(x) ?? bottom : bottom;
        const top = foot + 2 - height;
        for(let y = top; y <= foot + 1; y++){
            let step;
            if (y === top) {
                const lit = Math.round(heights.get(x - 1) ?? 0) <= height;
                step = lit ? (0, $e9b6a02a637ade4e$export$f822a6c070dba650)(x, y, 3) < 0.25 ? 6 : 5 : 4;
            } else {
                const mottle = (0, $e9b6a02a637ade4e$export$f822a6c070dba650)(x, y, 9);
                step = mottle < 0.4 ? 3 : mottle < 0.9 ? 4 : 2;
            }
            pixels.push({
                x: x,
                y: y,
                color: soil(step)
            });
        }
    });
    return pixels;
};
const $6f4e2796428d115f$var$baked = new WeakMap();
const $6f4e2796428d115f$export$f46223c1ceeaa5d9 = (tree, edges, zone, renderer)=>{
    const cached = $6f4e2796428d115f$var$baked.get(tree)?.get(zone);
    if (cached?.renderer === renderer && !cached.texture.baseTexture.destroyed) return cached.texture;
    const mound = $6f4e2796428d115f$export$b9f12138e1ef7452(edges, zone);
    if (!mound.length) return tree;
    const surface = new (0, $8t5Gy.Container)();
    surface.addChild(new (0, $7Bs2Z.Sprite)(tree));
    const soil = new (0, $gwPoJ.Graphics)();
    surface.addChild(soil);
    for (const pixel of mound){
        soil.beginFill(pixel.color);
        soil.drawRect(pixel.x, pixel.y, 1, 1);
        soil.endFill();
    }
    // Into the shared atlas of baked trees, so a forest's trees batch together (a texture each broke it).
    const region = new (0, $6qzqq.Rectangle)(0, 0, tree.width, tree.height);
    const texture = (0, $78ff247413a98680$export$d356f62a11a0ce0d).put(renderer, surface, region) ?? renderer.generateTexture(surface, {
        region: region
    });
    surface.destroy({
        children: true
    });
    if (!$6f4e2796428d115f$var$baked.has(tree)) $6f4e2796428d115f$var$baked.set(tree, new Map());
    $6f4e2796428d115f$var$baked.get(tree).set(zone, {
        renderer: renderer,
        texture: texture
    });
    return texture;
};


class $9973b82363bdbab3$export$ca0a091ecfb17b44 {
    constructor(options){
        this.bonecallerStones = new Map();
        this.clearBonecallerStones = ()=>this.bonecallerStones.clear();
        this.updateBonecallerStones = (now = Date.now())=>{
            if (!this.bonecallerStones.size) return;
            const frames = (0, $f995e013b6debd58$export$f1decc78b3ea2087)((0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer);
            this.bonecallerStones.forEach((state, sprite)=>{
                if (!sprite.parent || sprite.destroyed || !frames.includes(sprite.texture)) {
                    this.bonecallerStones.delete(sprite);
                    return;
                }
                const ritual = this.logic.entityManager?.get(state.shrineId)?.bonecallerRitual;
                if (ritual !== state.ritual) {
                    state.ritual = ritual;
                    state.receivedAt = now;
                }
                const energy = (0, $f995e013b6debd58$export$2f635036cd6a2bce)(ritual, state.index, now, now - state.receivedAt);
                sprite.texture = frames[Math.round(energy * (frames.length - 1))];
            });
        };
        this.setSurface = (surface)=>{
            this.surface = surface;
        };
        /**
     * Offer a piece of vegetation to the wind, and remember what it was offered as on the sprite. A
     * floor drawn while it was not the active one had no wind; when it becomes active its blades are
     * offered again from these (see MapRenderingManager.registerGrassBlades).
     */ this.offerToWind = (sprite, x, y, textureId, heightAbove = 0, entityTileId)=>{
            sprite.grassBlade = [
                x,
                y,
                textureId,
                heightAbove,
                entityTileId
            ];
            this.getGrassSway()?.register(sprite, x, y, textureId, heightAbove, entityTileId);
        };
        // Plant art does not own pointer events. Desktop strikes can still resolve a blade to its
        // root by checking its geometry separately from Pixi's interactive hit test.
        this.updateCompositeTilePointer = (at)=>{
            let root;
            let topZ = -Infinity;
            for (const object of this.surfaceObjectsByKey.values()){
                if (!object.compositeRoot) continue;
                for (const sprite of object.spriteSet)if (sprite.parent && sprite.worldVisible && sprite.zIndex >= topZ && sprite.containsPoint(at)) {
                    root = object.compositeRoot;
                    topZ = sprite.zIndex;
                }
            }
            this.logic.playerController.updateCompositeTile(root?.x ?? -1, root?.y ?? -1);
        };
        this.renderCompositeTile = (tilemapMetaProvider, parentTileId, compositeTileId, x, y, zIndex = 0)=>{
            const key = `${parentTileId}-${x}-${y}`;
            const parentTileMeta = tilemapMetaProvider.resolveTileMeta(parentTileId);
            // An organic cave's rock is painted as one continuous mass by RockMassLayer, not a block per cell.
            if (parentTileMeta.entityTileId === "testore" && tilemapMetaProvider.getOrganicRockLayer?.()) return;
            if (parentTileMeta.entityTileId === "bonecaller-stone") {
                if (this.surfaceObjectsByKey.has(key)) return;
                const frames = (0, $f995e013b6debd58$export$f1decc78b3ea2087)((0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer);
                const sprite = this.attachTexture(frames[0], this.surface);
                sprite.position.set(x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 6);
                sprite.zIndex = 100 + y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 16;
                const context = tilemapMetaProvider.getMapDeltaAt(x, y, tilemapMetaProvider.resolveEntityTileLayerId())?.context;
                this.bonecallerStones.set(sprite, {
                    shrineId: context?.bonecallerShrineId,
                    index: context?.bonecallerStoneIndex ?? 0,
                    receivedAt: Date.now()
                });
                this.surfaceObjectsByKey.set(key, {
                    spriteSet: [
                        sprite
                    ],
                    compositeTileId: compositeTileId,
                    tilesetId: "bonecaller-stones",
                    compositeRoot: {
                        x: x,
                        y: y
                    }
                });
                return;
            }
            //
            // dense microtiles
            //
            if (parentTileMeta.tileTypes.includes("dense")) {
                this.renderDenseMicrotiles(key, parentTileId, parentTileMeta, x, y, zIndex);
                return;
            }
            //
            // compositeTile
            //
            const tileset = tilemapMetaProvider.resolveTileSet(parentTileId);
            const compositeSprites = this.handleRenderCompositeTile(key, tilemapMetaProvider, compositeTileId, tileset.tilesetId, x, y, this.surface, zIndex);
            const object = this.surfaceObjectsByKey.get(key);
            // Saved HP must reach the damage pass even on a fresh client with no hit history.
            // Trees use trunk notches rather than authored breakage overlays.
            if (object && (parentTileMeta.breakageMeta || (0, $ff74dc2a666565c1$export$1db3e4d273a27613)(parentTileMeta.entityTileId))) object.delta = tilemapMetaProvider.findMapDeltaAt(x, y);
        };
        this.handleRenderCompositeTile = (key, tilemapMetaProvider, compositeTileId, tilesetId, x = 0, y = 0, surface, extraZIndex)=>{
            let set = this.surfaceObjectsByKey.get(key)?.spriteSet;
            if (set) return set;
            set = [];
            const compositeTileMeta = tilemapMetaProvider.resolveCompositeTileIdTileMeta(compositeTileId, tilesetId);
            if (!compositeTileMeta) return set;
            const parentTileSet = tilemapMetaProvider.getTilesetById(tilesetId);
            const parentTileMeta = compositeTileMeta.tileMeta;
            //
            // compositeTile
            //
            const { width: width } = parentTileSet;
            // find the parent tile location
            let parentTileSetX;
            let parentTileSetY;
            const tileNumber = compositeTileMeta.tileNumber - 1;
            parentTileSetX = tileNumber % width;
            parentTileSetY = Math.floor(tileNumber / width);
            const isDenseVertical = parentTileMeta.tileTypes.includes("denseVertical");
            if (isDenseVertical) {
                this.renderDenseVerticalTiles(key, compositeTileMeta, parentTileSet, parentTileSetX, parentTileSetY, x, y, surface, extraZIndex, set);
                this.surfaceObjectsByKey.set(key, {
                    spriteSet: set,
                    compositeTileId: compositeTileId,
                    tilesetId: tilesetId,
                    compositeRoot: {
                        x: x,
                        y: y
                    }
                });
            } else {
                const fullTileId = `${parentTileSet.tilesetId}-${compositeTileId}`;
                let texture = this.tileTextureExtractor.extract(tilemapMetaProvider, parentTileSet.tilesetId, compositeTileId);
                const bounds = (0, $86e9e05f3ebc1d8f$export$171acc6ba80afe2).compositeTileSpriteBounds.get(fullTileId);
                const children = compositeTileMeta.children || [];
                let intersects = false;
                for(let i = 0; !this.depthSortedRoofs && i < children.length; i++){
                    const childTileMeta = children[i];
                    const tileNumber = childTileMeta.tileNumber - 1;
                    const tileSetX = tileNumber % width;
                    const tileSetY = Math.floor(tileNumber / width);
                    const childTileSetXOffset = tileSetX - parentTileSetX;
                    const childTileSetYOffset = tileSetY - parentTileSetY;
                    const xx = x + childTileSetXOffset;
                    const yy = y + childTileSetYOffset;
                    if (tilemapMetaProvider.isSkyTileAt(xx, yy)) {
                        intersects = true;
                        break;
                    }
                }
                if (!intersects) {
                    const material = parentTileMeta.entityTileId === "testore" ? tilemapMetaProvider.getMapDeltaAt?.(x, y, tilemapMetaProvider.resolveEntityTileLayerId())?.context?.oreMaterial : undefined;
                    if ((0, $1b34ef4012f1eb6c$export$56f5d6880632643)(material)) texture = (0, $1b34ef4012f1eb6c$export$ad0c8bd3f530e1e4)(texture, material, (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer);
                    // The grass that rings a tree's roots (and a wall's base) rings the camp's bushes too. On
                    // bare dirt a tree's foot is heaped with soil instead.
                    const tree = (0, $ff74dc2a666565c1$export$1db3e4d273a27613)(parentTileMeta.entityTileId);
                    if (tree || (0, $33b8b2956df9c5d3$export$fee21090cd1958a1)(compositeTileId)) {
                        const edges = (0, $e9b6a02a637ade4e$export$5c30771e466c913e)(tilesetId, compositeTileId, width, children);
                        if (edges?.length) {
                            const placement = (0, $3e205d6c633194c2$export$8b3ab97ac444fb53)(compositeTileMeta, bounds, x, y, extraZIndex);
                            const ground = (0, $e9b6a02a637ade4e$export$5f3b0c0520ba57d0)(edges);
                            const groundX = placement.x + ground.x, groundY = placement.y + ground.y;
                            if ((0, $7ea6fc60f5974fdd$export$920f903c798ad6e9)(tilemapMetaProvider, groundX, groundY)) texture = (0, $e9b6a02a637ade4e$export$4f4a66328d0917d9)(texture, edges, (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer);
                            else if (tree) {
                                const zone = (0, $53604101ee77d932$export$3d7a3cc7a3c1b108)(tilemapMetaProvider, groundX, groundY);
                                if (zone !== undefined) texture = (0, $6f4e2796428d115f$export$f46223c1ceeaa5d9)(texture, edges, zone, (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer);
                            }
                        }
                    }
                    this.renderNonIntersectingCompositeTile(compositeTileMeta, texture, bounds, x, y, surface, extraZIndex, set);
                } else this.renderSkyIntersectingCompositeTile(compositeTileMeta, parentTileSet, x, y, surface, extraZIndex, set, bounds, children, tilemapMetaProvider);
                this.surfaceObjectsByKey.set(key, {
                    spriteSet: set,
                    compositeTileId: compositeTileId,
                    tilesetId: tilesetId
                });
                // Short tufts use the ordinary composite path. Offer their complete sprite to wind
                // as well; GrassSway ignores every texture outside its explicit vegetation list.
                for (const sprite of set)this.offerToWind(sprite, x, y, `${tilesetId}-${tileNumber + 1}`, 0, parentTileMeta?.entityTileId);
            }
            // Keep the wind hinge at the actual roots, above any transparent padding or baked shadow.
            if ((0, $ff74dc2a666565c1$export$1db3e4d273a27613)(parentTileMeta?.entityTileId) && set.length) {
                const edges = (0, $e9b6a02a637ade4e$export$5c30771e466c913e)(tilesetId, compositeTileId, width, compositeTileMeta.children || []);
                const top = Math.min(...set.map((s)=>s.y));
                const bottom = Math.max(...set.map((s)=>s.y + s.texture.height * Math.abs(s.scale.y)));
                this.surfaceObjectsByKey.get(key).treeWind = {
                    x: x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: edges?.length ? top + (0, $e9b6a02a637ade4e$export$5f3b0c0520ba57d0)(edges).y : bottom
                };
            }
            // Tag the tiles the occluder-fade may fade, with the gate policy each kind wants (a structured
            // check on the tile's entityTileId -- no sprite/texture name parsing). Pool sprites are untagged
            // at checkout (SpriteManagementService.attachTexture), so this only needs to stamp the few that
            // fade. A tile's BREAKAGE overlay comes back through here under its own composite id
            // (stoneBreaklevel*, no fade policy) and is then re-parented onto the block it cracks, which is
            // what we want: a pixi child inherits its parent's alpha, and a child's x/y are parent-relative,
            // so the occlusion box math must only ever see the top-level sprite.
            const policy = (0, $75a0a4fb75fb6456$export$a9aeffcbb50105b7)(parentTileMeta?.entityTileId);
            if (policy) for (const g of set)g.occluderFade = policy;
            return set;
        };
        this.renderDenseMicrotiles = (key, parentTileId, parentTileMeta, x, y, zIndex)=>{
            const set = [];
            this.surfaceObjectsByKey.set(key, {
                spriteSet: set
            });
            const fullTileId = this.tilemapMetaProvider.resolveTilesetTileId(parentTileId);
            const cacheKey = `${(0, $1f08f7b8f85adf9e$export$dd4554ad7431ed50)()}:${fullTileId}`;
            let textTure = this.compositeTileSpriteTextures.get(cacheKey);
            if (!textTure) {
                if (parentTileMeta.spriteId) {
                    let resource = (0, $1f08f7b8f85adf9e$export$42d948b5d3f64a60)("humanoid");
                    if (resource) textTure = resource.texture;
                } else {
                    textTure = (0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(`${fullTileId}`);
                    this.compositeTileSpriteTextures.set(cacheKey, textTure);
                }
            }
            const parentFine = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                x: x,
                y: y
            });
            const noiseChance = 0.1;
            const print = (offsetX = 0, offsetY = 0)=>{
                const g = this.attachTexture(textTure);
                g.x = parentFine.x + offsetX;
                g.y = parentFine.y + offsetY;
                g.zIndex = zIndex;
                set.push(g);
            };
            print();
            this.pctChance(noiseChance, `pct-${key}-${parentFine.x}-${parentFine.y}-${zIndex}`) && print(-0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), -0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            this.pctChance(noiseChance, `pct-${key}-${parentFine.x}-${parentFine.y}-${zIndex}`) && print(0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), -0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            this.pctChance(noiseChance, `pct-${key}-${parentFine.x}-${parentFine.y}-${zIndex}`) && print(-0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            this.pctChance(noiseChance, `pct-${key}-${parentFine.x}-${parentFine.y}-${zIndex}`) && print(0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), 0.5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
        };
        /**
     * How far each copy of the dense-vertical tile `parentTileId` at (x, y) is drawn above its place: one
     * entry per copy, as renderDenseVerticalTiles draws them (its shadow is cast from the same numbers).
     */ this.denseCopyLifts = (parentTileId, tileMeta, x, y)=>this.copyLifts(`${parentTileId}-${x}-${y}`, tileMeta, x, y);
        this.copyLifts = (key, tileMeta, x, y)=>{
            // The old LPC long grass is flat stripes, stacked 1-3 deep to look thick. A tile can name its own
            // count instead: a drawn clump (the ember meadow's) stacked twice is the same picture twice,
            // a few pixels apart, which reads as an echo rather than as more grass.
            const count = tileMeta?.denseCopies ?? (this.pctChance(10, `dense-vertical-${key}-1`) ? this.pctChance(50, `dense-vertical-${key}-2`) ? 1 : 3 : 2);
            return Array.from({
                length: count
            }, (_, i)=>this.pertubation("_", x, y, i, `horizontalDensity`));
        };
        this.renderDenseVerticalTiles = (key, compositeTileMeta, parentTileSet, parentTileSetX, parentTileSetY, x, y, surface, extraZIndex, set)=>{
            const lifts = this.copyLifts(key, compositeTileMeta.tileMeta, x, y);
            const count = lifts.length;
            const gradient = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / count;
            for(let i = 0; i < count; i++){
                let verticalOffset = i * gradient;
                const yPertubation = lifts[i];
                const children = compositeTileMeta.children || [];
                const parentTileIdNumber = compositeTileMeta.tileNumber;
                // The id the composite's parent tile renders under. NOTE the convention change: a tile's
                // position as an AUTHOR writes it is one below the id the client resolves it to (see
                // flora.ts), but compositeTileMeta.tileNumber is already in the resolved convention. Both
                // numbers are small, plausible and name a real neighbouring tile, so getting this wrong
                // matches nothing and reports nothing -- which is exactly what it did first.
                const parentCompositeTextureId = `${parentTileSet.tilesetId}-${parentTileIdNumber}`;
                let height = 0;
                children.forEach((childTileMeta)=>{
                    const tileId = `${childTileMeta.tileNumber}`;
                    const tileNumber = childTileMeta.tileNumber - 1;
                    const tileSetX = tileNumber % parentTileSet.width;
                    const tileSetY = Math.floor(tileNumber / parentTileSet.width);
                    const fullTileId = `${parentTileSet.tilesetId}-${tileId}`;
                    const isParent = parentTileIdNumber === tileNumber;
                    const childTileSetXOffset = tileSetX - parentTileSetX;
                    const childTileSetYOffset = tileSetY - parentTileSetY;
                    if (!isParent) height = Math.max(height, Math.abs(childTileSetYOffset));
                    const cacheKey = `${(0, $1f08f7b8f85adf9e$export$dd4554ad7431ed50)()}:${fullTileId}`;
                    let textTure = this.compositeTileSpriteTextures.get(cacheKey);
                    if (!textTure) {
                        textTure = (0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(`${fullTileId}`);
                        this.compositeTileSpriteTextures.set(cacheKey, textTure);
                    }
                    const g = this.attachTexture(textTure, surface);
                    const fineItem = (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.checkout();
                    const roughItem = (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.checkout();
                    const rough = roughItem.data;
                    rough.x = x + childTileSetXOffset;
                    rough.y = y + childTileSetYOffset;
                    const fine = fineItem.data;
                    (0, $a80d0b17b615d6f7$export$131bd9752b097096)(rough, fine);
                    g.x = fine.x - this.pertubation(tileId, fine.x, fine.y, i, `verticalDensity`, 1);
                    g.y = fine.y - yPertubation;
                    g.zIndex = 100 + (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                        x: x,
                        y: y
                    }).y - verticalOffset - yPertubation + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 3 + extraZIndex || 0;
                    (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.release(roughItem);
                    (0, $044ce6b9ee544b01$export$ca8a4d4f8adbc954).instance.release(fineItem);
                    g.interactive = false;
                    // Offer this sub-tile to the wind. Long grass is a two-tile vertical composite -- a
                    // base and a top -- so the sub-tile's own height above the anchor row is exactly how
                    // much of the bend it should carry: the base barely moves and the top does the
                    // leaning, which is how a plant bends rather than how a decal slides.
                    //
                    // Keyed on the COMPOSITE's parent tile, not on the sub-tile, so one entry in the sway
                    // table covers every piece of the plant.
                    this.offerToWind(g, x, y, parentCompositeTextureId, -childTileSetYOffset, compositeTileMeta.tileMeta?.entityTileId);
                    set.push(g);
                });
                if (height > 0 || compositeTileMeta.tileMeta.renderZIdxOffset !== undefined) set.forEach((g)=>{
                    if (height > 1) {
                        g.y += (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                        g.zIndex += (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                    }
                    if (compositeTileMeta.tileMeta.renderZIdxOffset) g.zIndex += compositeTileMeta.tileMeta.renderZIdxOffset;
                });
            }
        };
        this.renderNonIntersectingCompositeTile = (compositeTileMeta, texture, bounds, x, y, surface, extraZIndex, set)=>{
            const surfaceToUse = surface || this.surface;
            const containingSprite = this.attachTexture(texture, surfaceToUse);
            const placement = (0, $3e205d6c633194c2$export$8b3ab97ac444fb53)(compositeTileMeta, bounds, x, y, extraZIndex);
            containingSprite.x = placement.x;
            containingSprite.y = placement.y;
            containingSprite.zIndex = placement.zIndex;
            set.push(containingSprite);
        };
        this.renderSkyIntersectingCompositeTile = (compositeTileMeta, parentTileSet, x, y, surface, extraZIndex, set, bounds, children, tilemapMetaProvider)=>{
            // find the parent tile location
            const tileNumber = compositeTileMeta.tileNumber - 1;
            const parentTileSetXLocal = tileNumber % parentTileSet.width;
            const parentTileSetYLocal = Math.floor(tileNumber / parentTileSet.width);
            const fineXX = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                x: x,
                y: y
            }).x;
            // Splitting the artwork around sky tiles must retain the whole composite's ground depth.
            const placement = (0, $3e205d6c633194c2$export$8b3ab97ac444fb53)(compositeTileMeta, bounds, x, y, extraZIndex);
            const left = Math.min(...children.map((child)=>(child.tileNumber - 1) % parentTileSet.width));
            const top = Math.min(...children.map((child)=>Math.floor((child.tileNumber - 1) / parentTileSet.width)));
            children.forEach((childTileMeta)=>{
                const tileId = `${childTileMeta.tileNumber}`;
                const tileNumber = childTileMeta.tileNumber - 1;
                const tileSetX = tileNumber % parentTileSet.width;
                const tileSetY = Math.floor(tileNumber / parentTileSet.width);
                const fullTileId = `${parentTileSet.tilesetId}-${tileId}`;
                const childTileSetXOffset = tileSetX - parentTileSetXLocal;
                const childTileSetYOffset = tileSetY - parentTileSetYLocal;
                const xx = x + childTileSetXOffset;
                const yy = y + childTileSetYOffset;
                const skyAt = tilemapMetaProvider.isSkyTileAt(xx, yy);
                const surfaceToUse = skyAt ? this.skySpriteSurfaceAbove : surface;
                const subtileSprite = this.attachTexture((0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(fullTileId), surfaceToUse);
                const fineX = placement.x + (tileSetX - left) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                const fineY = placement.y + (tileSetY - top) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
                subtileSprite.x = fineX;
                subtileSprite.y = fineY;
                subtileSprite.zIndex = placement.zIndex;
                set.push(subtileSprite);
            });
        };
        this.updateSkySurfaces = (skySpriteSurfaceAbove)=>{
            this.skySpriteSurfaceAbove = skySpriteSurfaceAbove;
        };
        this.surface = options.surface;
        this.skySpriteSurfaceAbove = options.skySpriteSurfaceAbove;
        this.tilemapMetaProvider = options.tilemapMetaProvider;
        this.compositeTileSpriteTextures = options.compositeTileSpriteTextures;
        this.surfaceObjectsByKey = options.surfaceObjectsByKey;
        this.attachTexture = options.attachTexture;
        this.pertubation = options.pertubation;
        this.pctChance = options.pctChance;
        this.logic = options.logic;
        this.tileTextureExtractor = options.tileTextureExtractor;
        this.getGrassSway = options.getGrassSway || (()=>undefined);
        this.depthSortedRoofs = options.depthSortedRoofs ?? false;
    }
    updateTilemapMetaProvider(tilemapMetaProvider) {
        this.tilemapMetaProvider = tilemapMetaProvider;
    }
}



class $21e34920946cefc2$export$5dbc5b3773f0a3b2 {
    /**
     * Get current shake state. Both channels are summed here so every caller sees the same camera
     * offset without having to know there are two of them.
     */ getState() {
        return {
            isShaking: this.state.isShaking || !!this.impulseInterval,
            shakeOffsetX: this.state.shakeOffsetX + this.impulseOffsetX,
            shakeOffsetY: this.state.shakeOffsetY + this.impulseOffsetY
        };
    }
    /**
     * Update shake offsets
     */ setShakeOffsets(x, y) {
        this.state.shakeOffsetX = x;
        this.state.shakeOffsetY = y;
    }
    /**
     * Reset shake state
     */ reset() {
        this.state.shakeOffsetX = 0;
        this.state.shakeOffsetY = 0;
        this.state.isShaking = false;
        this.stopImpulse();
    }
    /** Room teardown and session end both go through reset(); nothing may outlive them. */ stopImpulse() {
        if (this.impulseInterval) {
            clearInterval(this.impulseInterval);
            this.impulseInterval = undefined;
        }
        this.impulseOffsetX = 0;
        this.impulseOffsetY = 0;
        this.impulseAmplitude = 0;
    }
    /**
     * A decaying camera kick. `amplitude` is the opening displacement in world pixels; it falls off
     * quadratically over `durationMs`, which is what makes it read as an impact rather than a
     * vibration.
     *
     * Two frequencies, deliberately incommensurate (about 14Hz across and 11Hz down), so the camera
     * traces a path that never repeats inside one kick -- a single frequency on both axes draws a
     * diagonal line and looks like a glitch. A new kick REPLACES a weaker one still running instead
     * of queueing: two blasts in a second should be one bigger shake, not a four-second rattle.
     */ impulse(entity, amplitude, durationMs, onUpdate) {
        if (!this.screenshakeEnabled || amplitude <= 0 || durationMs <= 0) return;
        if (this.impulseInterval && amplitude <= this.impulseAmplitude) return;
        this.stopImpulse();
        this.impulseAmplitude = amplitude;
        const startedAt = Date.now();
        const phase = Math.random() * Math.PI * 2;
        this.impulseInterval = setInterval(()=>{
            const elapsed = Date.now() - startedAt;
            if (elapsed >= durationMs) {
                this.stopImpulse();
                onUpdate(entity);
                return;
            }
            const decay = (1 - elapsed / durationMs) ** 2;
            this.impulseOffsetX = Math.sin(elapsed * 0.088 + phase) * amplitude * decay;
            this.impulseOffsetY = Math.cos(elapsed * 0.071 + phase * 1.7) * amplitude * decay * 0.7;
            onUpdate(entity);
        }, 16);
    }
    /**
     * Trigger screen shake effect
     */ screenShake(entity, onUpdate) {
        if (!this.screenshakeEnabled) return;
        if (this.state.isShaking) return;
        this.state.isShaking = true;
        let startTs = Date.now();
        let shakeDirLeft = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)();
        let shakeDistance = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(5, 8);
        let currentShakeDistance = shakeDistance;
        let duration = (0, $cb689cfa16c444ba$export$7bddc4d01a7cbd18)(40, 60);
        let up = (0, $cb689cfa16c444ba$export$b3b584c8d6ffe165)();
        const interval = setInterval(()=>{
            let elapsed = Date.now() - startTs;
            if (elapsed > duration) {
                clearInterval(interval);
                this.state.shakeOffsetX = 0;
                this.state.shakeOffsetY = 0;
                this.state.isShaking = false;
                onUpdate(entity);
                return;
            }
            if (elapsed / duration % 0.25 === 0 || currentShakeDistance <= 0) {
                shakeDirLeft = !shakeDirLeft;
                shakeDistance = shakeDistance - 1;
                currentShakeDistance = shakeDistance;
            }
            currentShakeDistance -= 1;
            this.state.shakeOffsetX += shakeDirLeft ? 1 : -1;
            onUpdate(entity);
            this.state.shakeOffsetY += up ? -1 : 1;
            up = !up;
        }, 10);
    }
    constructor(){
        this.state = {
            isShaking: false,
            shakeOffsetX: 0,
            shakeOffsetY: 0
        };
        this.impulseOffsetX = 0;
        this.impulseOffsetY = 0;
        this.impulseAmplitude = 0;
        this.screenshakeEnabled = true;
    }
}


parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $1avo5 = parcelRequire("1avo5");



class $c83cd7e406c913d7$export$530258b752862cdf {
    constructor(config){
        this.skyHidingAllowed = true;
        this.currentUnderSky = undefined;
        this.visibilityFade = new (0, $f938f025cf72352a$export$6377df4ac9e9e40f)();
        // ============================================================================
        // Sky Visibility Control
        // ============================================================================
        /**
     * Set whether sky hiding is allowed
     */ this.setStaticHidingAllowed = (allowed)=>{
            this.skyHidingAllowed = allowed;
        };
        /**
     * Update sky visibility based on player location
     */ this.updatePlayerLocation = (entity, force)=>{
            if (!this.tilemapMetaProvider || !entity) return;
            // Sample coverage every frame: feet and live roof edits can cross a boundary
            // without changing the player's body cell. Reversals retain the current opacity.
            this.currentUnderSky = !(0, $9b85be211484fac5$export$4a8c8628e4e44ada)(entity.floorFall) && this.tilemapMetaProvider.isUnderRoofAt(entity.location);
            this.visibilityFade.update(!this.currentUnderSky || !this.skyHidingAllowed);
            this.skySurface.visible = this.visibilityFade.visible;
            this.skyAlphFilter.alpha = this.visibilityFade.alpha;
            // Keep the grouped alpha pass only while translucent; opaque/hidden ceilings
            // need no render-to-texture filter.
            this.skySurface.filters = this.visibilityFade.visible && this.visibilityFade.alpha < 1 ? [
                this.skyAlphFilter
            ] : null;
        };
        // ============================================================================
        // Sky Rendering
        // ============================================================================
        /**
     * Clear all sky surfaces
     */ this.clearSkySurfaces = ()=>{
            this.skyTilemapRenderer.clear();
            this.skySpriteSurfaceAbove.removeChildren();
            this.skySpriteSurfaceBelow.removeChildren();
        };
        /**
     * Get the sky tilemap renderer
     */ this.getSkyTilemapRenderer = ()=>{
            return this.skyTilemapRenderer;
        };
        /**
     * Get the sky sprite surface above
     */ this.getSkySpriteSurfaceAbove = ()=>{
            return this.skySpriteSurfaceAbove;
        };
        /**
     * Get the sky sprite surface below
     */ this.getSkySpriteSurfaceBelow = ()=>{
            return this.skySpriteSurfaceBelow;
        };
        // ============================================================================
        // Sky State
        // ============================================================================
        /**
     * Check if currently under sky
     */ this.isUnderSky = ()=>{
            return this.currentUnderSky;
        };
        /**
     * Check if sky hiding is allowed
     */ this.isSkyHidingAllowed = ()=>{
            return this.skyHidingAllowed;
        };
        this.getSkyAlpha = ()=>this.skyAlphFilter.alpha;
        // ============================================================================
        // Configuration
        // ============================================================================
        /**
     * Update the tilemap meta provider
     */ this.updateTilemapMetaProvider = (tilemapMetaProvider)=>{
            this.tilemapMetaProvider = tilemapMetaProvider;
        };
        /**
     * Reset sky state (called when changing rooms)
     */ /**
     * Hand this map's sky layers to another container. The one left behind belongs to someone else
     * now, so it goes back to plain and visible; this manager's own fade restarts.
     */ this.moveTo = (skySurface)=>{
            if (skySurface === this.skySurface) return;
            const previous = this.skySurface;
            skySurface.addChild(this.skySpriteSurfaceBelow, this.skyTilemapRenderer, this.skySpriteSurfaceAbove);
            previous.visible = true;
            previous.filters = null;
            this.skySurface = skySurface;
            this.resetSkyState();
        };
        this.resetSkyState = ()=>{
            this.skyHidingAllowed = true;
            this.currentUnderSky = undefined;
            this.visibilityFade.reset();
            this.skyAlphFilter.alpha = 1;
            this.skySurface.visible = true;
            this.skySurface.filters = null;
        };
        this.skySurface = config.skySurface;
        this.tilemapMetaProvider = config.tilemapMetaProvider;
        // Initialize sky components
        this.skyTilemapRenderer = new (0, $6dd6e4a0e941ec0b$export$e9f462800192160c)();
        this.skySpriteSurfaceAbove = new (0, $gwPoJ.Graphics)();
        this.skySpriteSurfaceBelow = new (0, $gwPoJ.Graphics)();
        this.skyAlphFilter = new (0, $1avo5.filters).AlphaFilter(1.0);
        // Setup sky surface. The AlphaFilter is attached ONLY while a fade is in progress (see
        // updatePlayerLocation) -- a permanently attached filter forces the whole sky surface to
        // render-to-texture every frame even at full alpha, a constant cost on integrated GPUs.
        this.skySurface.addChild(this.skySpriteSurfaceBelow);
        this.skySurface.addChild(this.skyTilemapRenderer);
        this.skySurface.addChild(this.skySpriteSurfaceAbove);
    }
}



parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");



parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
class $16c48257f96a9477$export$1bcf5cc4ba3a2b8f extends (0, $bc8613e262b54793$export$72650553bea9c295) {
    constructor(size = 1000){
        super(size), this.poolStats = {
            totalCreated: 0,
            totalReused: 0,
            totalCleared: 0,
            peakUsage: 0,
            currentUsage: 0
        }, // Properties from parent class
        this.items = [], this.ptr = -1, this.releasing = false, this.checkout = ()=>{
            // Call parent checkout method directly
            if (this.releasing) throw new Error("BAD!");
            this.ptr++;
            if (this.ptr > this.items.length - 1) // grow the array by creating new items
            for(let i = 0; i < 1000; i++)this.items.push(this.create());
            const item = this.items[this.ptr];
            item.free = false;
            // Update stats (ensure poolStats is initialized)
            if (this.poolStats) {
                this.poolStats.totalReused++;
                this.poolStats.currentUsage++;
                this.poolStats.peakUsage = Math.max(this.poolStats.peakUsage, this.poolStats.currentUsage);
            }
            return item;
        }, this.release = (item)=>{
            // Call parent release method directly
            if (item.free) // already free, noop
            return;
            item.free = true;
            this.clear(item);
            this.ptr--;
            if (this.ptr < 0) this.ptr = 0;
            // Update stats (ensure poolStats is initialized)
            if (this.poolStats) this.poolStats.currentUsage--;
        };
        this.defaultSprite = new (0, $7Bs2Z.Sprite)();
    }
    static getInstance() {
        if (!$16c48257f96a9477$export$1bcf5cc4ba3a2b8f.instance) $16c48257f96a9477$export$1bcf5cc4ba3a2b8f.instance = new $16c48257f96a9477$export$1bcf5cc4ba3a2b8f();
        return $16c48257f96a9477$export$1bcf5cc4ba3a2b8f.instance;
    }
    create() {
        // Initialize poolStats if not already initialized (happens during construction)
        if (!this.poolStats) this.poolStats = {
            totalCreated: 0,
            totalReused: 0,
            totalCleared: 0,
            peakUsage: 0,
            currentUsage: 0
        };
        this.poolStats.totalCreated++;
        this.poolStats.currentUsage++;
        this.poolStats.peakUsage = Math.max(this.poolStats.peakUsage, this.poolStats.currentUsage);
        return {
            free: true,
            data: new (0, $7Bs2Z.Sprite)()
        };
    }
    clear(item) {
        // Update stats (ensure poolStats is initialized)
        if (this.poolStats) this.poolStats.totalCleared++;
        // Reset all properties to default state
        item.data.texture = (0, $klOfb.Texture).EMPTY;
        item.data.x = this.defaultSprite.x;
        item.data.y = this.defaultSprite.y;
        item.data.tint = this.defaultSprite.tint;
        item.data.visible = this.defaultSprite.visible;
        item.data.alpha = this.defaultSprite.alpha;
        item.data.scale.set(this.defaultSprite.scale.x, this.defaultSprite.scale.y);
        item.data.rotation = this.defaultSprite.rotation;
        item.data.zIndex = this.defaultSprite.zIndex;
        item.data.removeAllListeners();
        item.data.interactive = false;
        item.data.buttonMode = false;
        // Clear any filters
        item.data.filters = null;
        // Reset anchor
        item.data.anchor.set(0, 0);
        // Remove from parent if attached
        if (item.data.parent) item.data.parent.removeChild(item.data);
    }
    getStats() {
        return {
            ...this.poolStats,
            reuseRate: this.poolStats.totalCreated > 0 ? (this.poolStats.totalReused / this.poolStats.totalCreated * 100).toFixed(2) + "%" : "0%",
            currentPoolSize: this.items.length,
            freeItems: this.items.filter((item)=>item.free).length,
            usedItems: this.items.filter((item)=>!item.free).length
        };
    }
    resetStats() {
        this.poolStats = {
            totalCreated: 0,
            totalReused: 0,
            totalCleared: 0,
            peakUsage: 0,
            currentUsage: 0
        };
    }
}


class $2937f12c3e372b97$export$c10d0c7e188aaa18 {
    constructor(config){
        /** Where unparented pool sprites go: the map's surface moves when a floor changes roles. */ this.setDefaultSurface = (surface)=>{
            this.defaultSurface = surface;
        };
        /**
     * Attach a texture to a sprite and add it to the specified surface
     */ this.attachTexture = (texture, surface)=>{
            const spritePoolItem = this.spritePool.checkout();
            const sprite = spritePoolItem.data;
            sprite.texture = texture;
            sprite.occluderFade = undefined;
            // Same reasoning for the wind's shear: GrassSway leans a blade by writing skew.x, and these
            // sprites are POOLED. A blade that is released mid-gust and handed out again as a wall or a
            // tree would arrive already bent, with nothing to straighten it.
            sprite.skew.x = 0;
            sprite.grassBlade = undefined;
            sprite.scale.set(1, 1);
            sprite.rotation = 0;
            const surfaceToUse = surface || this.defaultSurface;
            surfaceToUse.addChild(sprite);
            spritePoolItem.data = sprite;
            return sprite;
        };
        /**
     * Creates a sprite at the specified coordinates with consistent positioning and z-index calculation
     */ this.createSpriteAt = (tilesetTileId, x, y, zIndexOffset = 0, surface)=>{
            const texture = (0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(`${tilesetTileId}`);
            const sprite = this.attachTexture(texture, surface);
            const fine = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                x: x,
                y: y
            });
            sprite.x = fine.x;
            sprite.y = fine.y;
            sprite.zIndex = 100 + zIndexOffset + fine.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 3;
            return sprite;
        };
        /**
     * Release all sprites back to the pool
     */ this.releaseAllSprites = (onRelease)=>{
            return this.spritePool.releaseAll((spriteItemObject)=>{
                const sprite = spriteItemObject.data;
                if (!sprite.parent) {
                    spriteItemObject.data = new (0, $7Bs2Z.Sprite)();
                    return true // Indicates error
                    ;
                } else {
                    sprite.parent?.removeChild(sprite);
                    return false // No error
                    ;
                }
            });
        };
        /**
     * Get the current sprite pool for advanced operations
     */ this.getSpritePool = ()=>{
            return this.spritePool;
        };
        /**
     * Clean up resources
     */ this.destroy = ()=>{
            this.spritePool.releaseAll();
        };
        this.spritePool = new (0, $16c48257f96a9477$export$1bcf5cc4ba3a2b8f)(config.spritePoolSize);
        this.defaultSurface = config.defaultSurface;
    }
}







// The cell row a sprited tile should sort by: its structure's base/anchor row (context.parent.y),
// falling back to its own cell when it has no parent (single-tile autotiles).
//
// A wall is two tiles -- a CAP at (x, y-1) and a BASE at (x, y) -- both stamped with
// parent = base cell. Anchoring both to the base row keeps a wall grouped as a unit AND splits
// *stacked* walls in the same contiguous column: the wall to the north sorts by its (higher) base
// row and the wall to the south by its (lower) base row. Previously the whole contiguous run was
// grouped to the run's bottom cell, so a north wall inherited the south wall's row and drew over an
// entity standing between them (occluding the player's head). Multi-tile fragments stamp every tile
// with their anchor origin as parent, so they still group as one unit.
const $f78f32798274f66a$var$woodVariant = (id)=>{
    if (!id) return -1;
    const separator = id.lastIndexOf("-");
    return (0, $c3e6e81239a7bc85$export$59bd1dfb16da1c8a)(id.slice(0, separator), Number(id.slice(separator + 1)) - 1);
};
const $f78f32798274f66a$export$6a603ef1f674b5ef = (item)=>{
    // Older corners and static maps can have a cap anchored to its own row. Its
    // artwork and the blocking wooden base directly below establish the actual anchor.
    const parentY = item.context?.parent?.y;
    if ((parentY === undefined || parentY === item.y) && $f78f32798274f66a$var$woodVariant(item.tilesetTileId) === 13 && item.belowBlocking && $f78f32798274f66a$var$woodVariant(item.belowTilesetTileId) >= 0) return item.y + 1;
    return parentY ?? item.y;
};
const $f78f32798274f66a$export$360f852efd938c01 = (index, anchorY)=>100 + index + anchorY * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 3;




parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");

class $4c4cb0e826badbe1$export$9f1d2d356a00ec8 {
    static{
        this.DURATION_MS = 450;
    }
    start(key, now = Date.now()) {
        if (!this.cells.has(key)) this.cells.set(key, {
            started: now
        });
    }
    cancel(key) {
        const cell = this.cells.get(key);
        cell?.sprite?.destroy();
        this.cells.delete(key);
    }
    // A map rebuild can change the autotile texture, but must keep the fade's original clock.
    clearSprites() {
        this.cells.forEach((cell)=>{
            cell.sprite?.destroy();
            cell.sprite = undefined;
        });
    }
    render(key, texture, x, y, surface) {
        const cell = this.cells.get(key);
        if (!cell) return false;
        cell.sprite?.destroy();
        const sprite = new (0, $7Bs2Z.Sprite)((0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(texture));
        sprite.position.set(x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
        sprite.alpha = this.alpha(cell.started, Date.now());
        surface.addChild(sprite);
        cell.sprite = sprite;
        return true;
    }
    /** Returns true when completed tiles need to be baked into the ground tilemap. */ update(now = Date.now()) {
        let completed = false;
        this.cells.forEach((cell, key)=>{
            if (now - cell.started >= $4c4cb0e826badbe1$export$9f1d2d356a00ec8.DURATION_MS) {
                this.cancel(key);
                completed = true;
            } else if (cell.sprite) cell.sprite.alpha = this.alpha(cell.started, now);
        });
        return completed;
    }
    clear() {
        this.clearSprites();
        this.cells.clear();
    }
    alpha(started, now) {
        const t = Math.max(0, Math.min(1, (now - started) / $4c4cb0e826badbe1$export$9f1d2d356a00ec8.DURATION_MS));
        return t * t * (3 - 2 * t);
    }
    constructor(){
        this.cells = new Map();
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");






// Wall definitions distinguish bases on the anchor row from raised caps. Rebuild this
// small lookup when content changes, rather than examining rules for every wall.
let $832b6f4df8293e69$var$wallBases = new Set();
let $832b6f4df8293e69$var$southConnectedBases = new Set();
(0, $e5c675b7b9585b42$export$f9af3f5df3a57431)((catalog)=>catalog.source.autotiles, (file)=>{
    $832b6f4df8293e69$var$wallBases = new Set();
    $832b6f4df8293e69$var$southConnectedBases = new Set();
    const visit = (node, tileset, southConnected)=>{
        if (!node || typeof node !== "object") return;
        if (typeof node.tile === "number" && !(node.dy || 0)) {
            const id = `${tileset}-${node.tile + 1}`;
            $832b6f4df8293e69$var$wallBases.add(id);
            if (southConnected) $832b6f4df8293e69$var$southConnectedBases.add(id);
        }
        Object.values(node).forEach((value)=>visit(value, tileset, southConnected));
    };
    file.definitions.forEach((definition)=>{
        if (definition.kind !== "wall") return;
        Object.entries(definition.rules).forEach(([index, rule])=>{
            // Index 14 connects north and south: its bottom is a join to the next
            // wall segment, rather than an exposed foot meeting the grass.
            if (index !== "14") visit(rule, definition.tilesetId, !!((0, $a1574d49bcae8132$export$65ef21f6c2d0a519)(Number(index)) & (0, $a1574d49bcae8132$export$25ce5a424b770e84)));
        });
    });
});
const $832b6f4df8293e69$export$1c4fbf9ae2ff0216 = (id, x, y, parent)=>$832b6f4df8293e69$var$wallBases.has(id) && (!parent || parent.x === x && parent.y === y);
const $832b6f4df8293e69$var$baked = new WeakMap();
const $832b6f4df8293e69$export$4572ba08ef3a43f6 = (id, edges, height)=>$832b6f4df8293e69$var$southConnectedBases.has(id) ? edges.filter((edge)=>edge.y < height - 1) : edges;
const $832b6f4df8293e69$export$398b357e3ce7a4b0 = (wall, id, x, y, provider, parent)=>{
    if (!$832b6f4df8293e69$export$1c4fbf9ae2ff0216(id, x, y, parent) || !(0, $7ea6fc60f5974fdd$export$920f903c798ad6e9)(provider, x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 16, y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 16)) return wall;
    const cached = $832b6f4df8293e69$var$baked.get(wall);
    if (cached && !cached.baseTexture.destroyed) return cached;
    const source = wall.baseTexture.resource?.source;
    if (!source) return wall;
    const canvas = document.createElement("canvas");
    canvas.width = wall.width;
    canvas.height = wall.height;
    const context = canvas.getContext("2d");
    if (!context) return wall;
    const frame = wall.frame, trim = wall.trim;
    context.drawImage(source, frame.x, frame.y, frame.width, frame.height, trim?.x || 0, trim?.y || 0, trim?.width || wall.width, trim?.height || wall.height);
    const edges = (0, $e9b6a02a637ade4e$export$88b9dbeabdb549d3)(context.getImageData(0, 0, canvas.width, canvas.height).data, canvas.width, canvas.height);
    for (const blade of (0, $e9b6a02a637ade4e$export$2f9cfe66677688b0)($832b6f4df8293e69$export$4572ba08ef3a43f6(id, edges, canvas.height))){
        context.fillStyle = `#${blade.color.toString(16).padStart(6, "0")}`;
        context.fillRect(blade.x, blade.y - blade.height + 1, 1, blade.height);
        context.fillRect(blade.x + (blade.x % 4 ? -1 : 1), blade.y - blade.height, 1, 1);
    }
    // A canvas-backed texture keeps the existing damage/repair system's image access intact.
    // On a shared page (wallArtAtlas), so a wall of distinct cells batches together.
    const texture = (0, $3c8dd7879239ee0e$export$11cde7437b85d173).putCanvas(canvas) ?? (0, $klOfb.Texture).from(canvas);
    $832b6f4df8293e69$var$baked.set(wall, texture);
    return texture;
};


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");

const $3ff1d7a24724a48b$export$2c292daaf2fe9ac1 = [
    "north",
    "east",
    "south",
    "west"
];
const $3ff1d7a24724a48b$var$FACING = {
    north: "south",
    east: "west",
    south: "north",
    west: "east"
};
/** A pixel this dark is an outline already (timber's is 43,28,29; the fence sheets' are darker still). */ const $3ff1d7a24724a48b$var$OUTLINE_MAX = 72;
const $3ff1d7a24724a48b$var$DEFAULT_OUTLINE = [
    43,
    28,
    29
];
const $3ff1d7a24724a48b$export$9ccf98c0489a8ccc = (data, size)=>{
    let outline = $3ff1d7a24724a48b$var$DEFAULT_OUTLINE, darkest = Infinity;
    for(let i = 0; i < size * size * 4; i += 4){
        if (data[i + 3] < 128) continue;
        const sum = data[i] + data[i + 1] + data[i + 2];
        if (sum < darkest && Math.max(data[i], data[i + 1], data[i + 2]) <= $3ff1d7a24724a48b$var$OUTLINE_MAX) {
            darkest = sum;
            outline = [
                data[i],
                data[i + 1],
                data[i + 2]
            ];
        }
    }
    const at = (x, y)=>(y * size + x) * 4;
    const along = (side, k)=>side === "north" ? at(k, 0) : side === "south" ? at(k, size - 1) : side === "west" ? at(0, k) : at(size - 1, k);
    const opaque = {}, open = {};
    $3ff1d7a24724a48b$export$2c292daaf2fe9ac1.forEach((side)=>{
        opaque[side] = [];
        open[side] = [];
        for(let k = 0; k < size; k++){
            const i = along(side, k);
            const solid = data[i + 3] >= 128;
            opaque[side].push(solid);
            open[side].push(solid && Math.max(data[i], data[i + 1], data[i + 2]) > $3ff1d7a24724a48b$var$OUTLINE_MAX);
        }
    });
    return {
        size: size,
        opaque: opaque,
        open: open,
        outline: outline
    };
};
const $3ff1d7a24724a48b$export$a669cd95b844f67 = (own, neighbours)=>{
    const bare = {};
    $3ff1d7a24724a48b$export$2c292daaf2fe9ac1.forEach((side)=>{
        const facing = neighbours[side]?.opaque[$3ff1d7a24724a48b$var$FACING[side]];
        bare[side] = [];
        own.open[side].forEach((open, k)=>{
            if (open && !facing?.[k]) bare[side].push(k);
        });
    });
    return bare;
};
const $3ff1d7a24724a48b$export$c1cac76f2a250e8c = (bare)=>$3ff1d7a24724a48b$export$2c292daaf2fe9ac1.some((side)=>bare[side].length);
/** The pixels of a texture's frame, drawn onto a canvas of its size; undefined when it has no image to read. */ const $3ff1d7a24724a48b$var$drawFrame = (texture)=>{
    const source = texture.baseTexture.resource?.source;
    if (!source) return undefined;
    const canvas = document.createElement("canvas");
    canvas.width = texture.width;
    canvas.height = texture.height;
    const context = canvas.getContext("2d");
    if (!context) return undefined;
    const frame = texture.frame, trim = texture.trim;
    context.drawImage(source, frame.x, frame.y, frame.width, frame.height, trim?.x || 0, trim?.y || 0, trim?.width || texture.width, trim?.height || texture.height);
    return {
        canvas: canvas,
        context: context
    };
};
const $3ff1d7a24724a48b$var$profiles = new WeakMap();
const $3ff1d7a24724a48b$export$80513b7ac8accc2c = (texture)=>{
    if (!texture || texture.width !== texture.height || !texture.baseTexture.valid) return undefined;
    const known = $3ff1d7a24724a48b$var$profiles.get(texture);
    if (known !== undefined) return known ?? undefined;
    let profile = null;
    try {
        const drawn = $3ff1d7a24724a48b$var$drawFrame(texture);
        if (drawn) profile = $3ff1d7a24724a48b$export$9ccf98c0489a8ccc(drawn.context.getImageData(0, 0, texture.width, texture.height).data, texture.width);
    } catch  {
        profile = null;
    }
    $3ff1d7a24724a48b$var$profiles.set(texture, profile);
    return profile ?? undefined;
};
const $3ff1d7a24724a48b$var$baked = new WeakMap();
const $3ff1d7a24724a48b$export$2535f19fc440f33c = (texture, bare, outline)=>{
    if (!$3ff1d7a24724a48b$export$c1cac76f2a250e8c(bare)) return texture;
    const key = $3ff1d7a24724a48b$export$2c292daaf2fe9ac1.map((side)=>bare[side].join(".")).join("|");
    const forTexture = $3ff1d7a24724a48b$var$baked.get(texture) ?? new Map();
    $3ff1d7a24724a48b$var$baked.set(texture, forTexture);
    const cached = forTexture.get(key);
    if (cached && !cached.baseTexture.destroyed) return cached;
    const drawn = $3ff1d7a24724a48b$var$drawFrame(texture);
    if (!drawn) return texture;
    const { canvas: canvas, context: context } = drawn;
    const size = texture.width;
    context.fillStyle = `rgb(${outline[0]}, ${outline[1]}, ${outline[2]})`;
    bare.north.forEach((k)=>context.fillRect(k, 0, 1, 1));
    bare.south.forEach((k)=>context.fillRect(k, size - 1, 1, 1));
    bare.west.forEach((k)=>context.fillRect(0, k, 1, 1));
    bare.east.forEach((k)=>context.fillRect(size - 1, k, 1, 1));
    // A canvas-backed texture, like the grass fringe's: the damage system can still read its image.
    // On a shared page (wallArtAtlas), so a wall of distinct cells batches together.
    const result = (0, $3c8dd7879239ee0e$export$11cde7437b85d173).putCanvas(canvas) ?? (0, $klOfb.Texture).from(canvas);
    forTexture.set(key, result);
    return result;
};





var $1avo5 = parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");




const $399d057f25535ae6$var$INDEX_CELL_SIZE = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 4;
const $399d057f25535ae6$var$MAX_SPARES = 64;
const $399d057f25535ae6$var$ids = new WeakMap();
let $399d057f25535ae6$var$nextId = 0;
const $399d057f25535ae6$var$idOf = (target)=>{
    let id = $399d057f25535ae6$var$ids.get(target);
    if (id === undefined) $399d057f25535ae6$var$ids.set(target, id = ++$399d057f25535ae6$var$nextId);
    return id;
};
// Floor filters are retuned in place (blur grows with storey distance), so settings belong in the key.
const $399d057f25535ae6$var$filterKey = (filter)=>{
    if (filter instanceof (0, $1avo5.filters).BlurFilter) return `${$399d057f25535ae6$var$idOf(filter)}:${filter.blur}:${filter.quality}:${filter.resolution}`;
    if (filter instanceof (0, $1avo5.filters).ColorMatrixFilter) return `${$399d057f25535ae6$var$idOf(filter)}:${filter.alpha}:${filter.matrix.join(",")}`;
    return `${$399d057f25535ae6$var$idOf(filter)}`;
};
/** Merge only exact rectangular unions; holes and stepped edges remain clipped. */ const $399d057f25535ae6$var$mergeClipRectangles = (rectangles)=>{
    const merged = [];
    for (const rectangle of rectangles){
        let current = rectangle;
        for(let i = 0; i < merged.length;){
            const other = merged[i];
            const contains = (a, b)=>a.x <= b.x && a.y <= b.y && a.right >= b.right && a.bottom >= b.bottom;
            const vertical = current.x === other.x && current.width === other.width && current.y <= other.bottom && other.y <= current.bottom;
            const horizontal = current.y === other.y && current.height === other.height && current.x <= other.right && other.x <= current.right;
            if (vertical || horizontal || contains(current, other) || contains(other, current)) {
                const x = Math.min(current.x, other.x), y = Math.min(current.y, other.y);
                current = new (0, $6qzqq.Rectangle)(x, y, Math.max(current.right, other.right) - x, Math.max(current.bottom, other.bottom) - y);
                merged.splice(i, 1);
                i = 0;
            } else i++;
        }
        merged.push(current);
    }
    return merged;
};
/** Restore foreground composite artwork only where raised ceiling artwork would cover it.
 * Ground sprites keep their collision depth against walls and actors.
 *
 * Each restoration is a sprite cut to its clip rectangle and given the source's transform, so it
 * batches like ordinary art. Masks cost a batch break each, and pixi falls back to a full stencil
 * clear for any rectangle mask that is off screen; with a copy per storey and wall, those passes
 * grew with every floor climbed. Distant floors are blurred by a filter on their root, so their
 * restorations are cut from the source art baked through that blur once, not filtered per frame. */ /** The content-bounds cache key for art's height under ceilings. */ const $399d057f25535ae6$var$CEILING_HEIGHT = "ceiling-height";
class $399d057f25535ae6$export$19b0dab5ba3d8bed {
    constructor(surface){
        this.surface = surface;
        this.copies = [];
        this.spares = [];
        this.groundDepths = new Map();
        this.cells = new Map();
        this.candidates = [];
        this.query = 0;
        this.styleFrame = 0;
        this.projectionStyles = new Map();
        this.bakedArt = new Map();
        this.unread = new Set();
    }
    /** The restorations drawn now. They are only rebuilt on a full render, so they move with the map. */ getCopies() {
        return this.copies.map(({ copy: copy })=>copy);
    }
    /** A storey holding restorations, or the art they copy, was torn down, or art's height has been read: rebuild. */ isStale() {
        return this.copies.some(({ copy: copy, source: source })=>copy.destroyed || source.destroyed) || this.heightsRead();
    }
    /** Some art restored at its texture's full height has had its height read since: rebuild. */ heightsRead() {
        for (const texture of this.unread)if ((0, $35a6592763403c18$export$437cb752f6483367)(texture, $399d057f25535ae6$var$CEILING_HEIGHT) !== undefined) return true;
        return false;
    }
    setSurface(surface) {
        this.surface = surface;
    }
    /** Release active art before map sprites are recycled, retaining reusable GPU objects. */ reset() {
        for (const [source, depth] of this.groundDepths)if (!source.destroyed) source.zIndex = depth;
        this.groundDepths.clear();
        for (const restoration of this.copies){
            this.releaseCut(restoration);
            if (restoration.copy.destroyed) continue;
            restoration.copy.parent?.removeChild(restoration.copy);
            this.spares.push(restoration.copy);
        }
        this.copies.length = 0;
        this.unread.clear();
        for (const group of this.candidates)group.hits.length = 0;
        this.candidates.length = 0;
        this.cells.clear();
        this.projectionStyles.clear();
    }
    /** Final teardown; shared source textures and filters remain owned by their original art. */ clear() {
        this.reset();
        while(this.spares.length)this.spares.pop().destroy();
        for (const { texture: texture } of this.bakedArt.values())texture.destroy(true);
        this.bakedArt.clear();
    }
    index(roofs) {
        const groups = new Map();
        this.query = 0;
        for (const { owner: owner, bounds: bounds, level: level, layer: layer, upright: upright } of roofs){
            let group = groups.get(owner);
            if (!group) groups.set(owner, group = {
                owner: owner,
                hits: [],
                level: level,
                layer: layer,
                upright: upright
            });
            for (const rect of bounds){
                if (rect.width <= 0 || rect.height <= 0) continue;
                const entry = {
                    bounds: rect,
                    group: group,
                    query: 0
                };
                for(let x = Math.floor(rect.x / $399d057f25535ae6$var$INDEX_CELL_SIZE); x < Math.ceil(rect.right / $399d057f25535ae6$var$INDEX_CELL_SIZE); x++)for(let y = Math.floor(rect.y / $399d057f25535ae6$var$INDEX_CELL_SIZE); y < Math.ceil(rect.bottom / $399d057f25535ae6$var$INDEX_CELL_SIZE); y++){
                    const key = `${x},${y}`;
                    let bucket = this.cells.get(key);
                    if (!bucket) this.cells.set(key, bucket = []);
                    bucket.push(entry);
                }
            }
        }
    }
    nearby(left, top, right, bottom) {
        for (const group of this.candidates)group.hits.length = 0;
        this.candidates.length = 0;
        const query = ++this.query;
        for(let x = Math.floor(left / $399d057f25535ae6$var$INDEX_CELL_SIZE); x < Math.ceil(right / $399d057f25535ae6$var$INDEX_CELL_SIZE); x++)for(let y = Math.floor(top / $399d057f25535ae6$var$INDEX_CELL_SIZE); y < Math.ceil(bottom / $399d057f25535ae6$var$INDEX_CELL_SIZE); y++){
            const bucket = this.cells.get(`${x},${y}`);
            if (!bucket) continue;
            for (const entry of bucket){
                if (entry.query === query) continue;
                entry.query = query;
                const rect = entry.bounds;
                if (left >= rect.right || right <= rect.x || top >= rect.bottom || bottom <= rect.y) continue;
                if (!entry.group.hits.length) this.candidates.push(entry.group);
                entry.group.hits.push(entry);
            }
        }
        return this.candidates;
    }
    rebuild(composites, roofs) {
        this.reset();
        if (composites.length && roofs.length) this.index(roofs);
        for (const composite of composites){
            if (!this.cells.size) break;
            const { source: source, projection: projection, level: level } = composite instanceof (0, $7Bs2Z.Sprite) ? {
                source: composite,
                projection: undefined,
                level: undefined
            } : composite;
            if (!projection) {
                const groundX = source.x + source.width / 2;
                const groundY = source.zIndex - 100 - (0, $2751e0027a1b432f$export$42b4af315a0c8aa1);
                const bucket = this.cells.get(`${Math.floor(groundX / $399d057f25535ae6$var$INDEX_CELL_SIZE)},${Math.floor(groundY / $399d057f25535ae6$var$INDEX_CELL_SIZE)}`);
                if (bucket) for (const { bounds: rect, group: { owner: owner } } of bucket){
                    if (owner.zIndex < 100) continue; // Floor tilemaps are ground artwork, not ceilings.
                    if (groundX >= rect.x && groundX < rect.right && groundY >= rect.y && groundY < rect.bottom) {
                        if (!this.groundDepths.has(source)) this.groundDepths.set(source, source.zIndex);
                        source.zIndex = Math.min(source.zIndex, owner.zIndex - 0.1);
                    }
                }
            }
            const x = source.x + (projection?.x ?? 0), y = source.y + (projection?.y ?? 0);
            const bottom = y + source.height;
            const groups = this.nearby(x, y, x + source.width, bottom);
            if (!groups.length) continue; // No texture readback for art away from ceilings.
            const depth = projection?.zIndex ?? source.zIndex;
            if (!groups.some((group)=>depth < group.owner.zIndex)) continue;
            // Atlas padding does not make an object tall. Read without waiting on the GPU: a readback here
            // stalled the climb onto a storey for as long as the GPU took to drain (half a second, two on a
            // player's machine). Until it lands the art counts at its full height, padding and all.
            const content = (0, $35a6592763403c18$export$437cb752f6483367)(source.texture, $399d057f25535ae6$var$CEILING_HEIGHT);
            if (content === undefined) this.unread.add(source.texture);
            const height = content ? content.height * Math.abs(source.scale.y) : source.height;
            const artBottom = y + (content ? content.bottom * Math.abs(source.scale.y) : source.height);
            for (const { owner: owner, hits: hits, level: ownerLevel, layer: layer, upright: upright } of groups){
                if (depth >= owner.zIndex) continue;
                // A storey's own art already sorts with its walls; only a storey above it can cover it.
                if (level !== undefined && ownerLevel !== undefined && level >= ownerLevel) continue;
                // A lower storey's art can only rise in front of artwork above it by its own height: the drop
                // between the two storeys, so a tree four floors down never reaches. Every storey in between
                // counts, or a tree in front of a tall wall shows its top over the upper storeys while the
                // storey between them hides its middle.
                const lift = Math.max(Math.abs((0, $2751e0027a1b432f$export$42b4af315a0c8aa1)), (projection?.y ?? 0) - (layer?.y ?? 0));
                if (height <= lift) continue;
                const elevatedBottom = artBottom - lift;
                // Across storeys, "lower on screen" is not "in front": a storey further down is drawn further down,
                // so a tree up to a storey's drop BEHIND a wall passes that test. Against a wall it must stand
                // south of the wall's foot in the world. A flat roof or floor needs no such test: on any line of
                // sight the higher point is the nearer, and the lift above keeps only what rises over its height.
                const worldBottom = bottom - (projection?.y ?? 0);
                const standsBehind = (rect)=>!!upright && worldBottom <= rect.bottom - (layer?.y ?? 0);
                const clips = [];
                for (const { bounds: rect } of hits){
                    const top = Math.max(rect.y, y), end = Math.min(rect.bottom, elevatedBottom);
                    if (bottom <= rect.bottom || end <= top) continue;
                    if (standsBehind(rect)) continue;
                    clips.push(new (0, $6qzqq.Rectangle)(rect.x, top, rect.width, end - top));
                }
                for (const rect of $399d057f25535ae6$var$mergeClipRectangles(clips)){
                    const crop = this.textureArea(source, x, y, rect);
                    if (!crop) continue;
                    const copy = this.spares.pop() ?? new (0, $7Bs2Z.Sprite)();
                    copy.interactive = false;
                    copy.focusBlurExempt = true;
                    (layer ?? this.surface).addChild(copy);
                    this.copies.push({
                        source: source,
                        projection: projection,
                        roof: owner,
                        layer: layer,
                        copy: copy,
                        crop: crop,
                        cutX: 0,
                        cutY: 0
                    });
                }
            }
        }
        // Keep reuse bounded when moving from a dense scene into a sparse one.
        while(this.spares.length > $399d057f25535ae6$var$MAX_SPARES)this.spares.pop().destroy();
        this.sync();
    }
    /** A surface rectangle in the orig pixels of the source's texture, ignoring sway skew. */ textureArea(source, x, y, rect) {
        const { width: width, height: height } = source.texture.orig;
        const { x: scaleX, y: scaleY } = source.scale;
        if (!width || !height || !scaleX || !scaleY) return;
        const originX = source.anchor.x * width, originY = source.anchor.y * height;
        const left = (rect.x - x) / scaleX + originX, right = (rect.right - x) / scaleX + originX;
        const top = (rect.y - y) / scaleY + originY, bottom = (rect.bottom - y) / scaleY + originY;
        return new (0, $6qzqq.Rectangle)(Math.min(left, right), Math.min(top, bottom), Math.abs(right - left), Math.abs(bottom - top));
    }
    /** Point the copy at the crop of `from`, whose frame starts `pad` pixels before the source's. */ cut(restoration, from, pad) {
        this.releaseCut(restoration);
        restoration.from = from;
        const { crop: crop, copy: copy } = restoration;
        if (copy.destroyed) return;
        const { frame: frame } = from;
        const left = (from.trim?.x ?? 0) - pad, top = (from.trim?.y ?? 0) - pad;
        const x1 = Math.max(crop.x, left), y1 = Math.max(crop.y, top);
        const x2 = Math.min(crop.right, left + frame.width), y2 = Math.min(crop.bottom, top + frame.height);
        if (x2 <= x1 || y2 <= y1) return;
        copy.texture = restoration.cutTexture = new (0, $klOfb.Texture)(from.baseTexture, new (0, $6qzqq.Rectangle)(frame.x + x1 - left, frame.y + y1 - top, x2 - x1, y2 - y1));
        restoration.cutX = x1;
        restoration.cutY = y1;
    }
    releaseCut(restoration) {
        const { copy: copy, cutTexture: cutTexture } = restoration;
        if (!copy.destroyed) copy.texture = (0, $klOfb.Texture).EMPTY;
        restoration.from = undefined;
        restoration.cutTexture = undefined;
        cutTexture?.destroy();
    }
    /** The source art rendered through a floor's remaining filters, cached until a sync stops using it. */ filteredArt(texture, stack, stackKey, frame) {
        const key = `${$399d057f25535ae6$var$idOf(texture)}|${stackKey}`;
        let baked = this.bakedArt.get(key);
        if (!baked) {
            // Headless tests have no renderer; their copies stay unfiltered.
            const renderer = (0, $065c5647ab3ff4dc$export$90e89a86e46f5ae3)()?.renderer;
            if (!renderer || !texture.valid) return;
            const pad = Math.ceil(Math.max(0, ...stack.map((filter)=>filter.padding)));
            const { width: width, height: height } = texture.orig;
            const art = new (0, $7Bs2Z.Sprite)(texture);
            art.filters = stack;
            const region = new (0, $6qzqq.Rectangle)(-pad, -pad, width + pad * 2, height + pad * 2);
            const result = renderer.generateTexture(art, {
                region: region,
                resolution: texture.baseTexture.resolution
            });
            art.filters = null;
            art.destroy();
            this.bakedArt.set(key, baked = {
                texture: result,
                pad: pad,
                frame: frame
            });
        }
        baked.frame = frame;
        return baked;
    }
    sync() {
        const frame = ++this.styleFrame;
        for (const restoration of this.copies){
            const { source: source, projection: projection, roof: roof, layer: layer, copy: copy } = restoration;
            if (copy.destroyed) continue;
            if (source.destroyed) {
                copy.visible = false;
                continue;
            }
            const style = projection && this.projectionStyle(projection, frame);
            const filtered = style?.filters ? this.filteredArt(source.texture, style.filters, style.key, frame) : undefined;
            const from = filtered?.texture ?? source.texture;
            if (restoration.from !== from) this.cut(restoration, from, filtered?.pad ?? 0);
            const x = source.x + (projection?.x ?? 0) - (layer?.x ?? 0), y = source.y + (projection?.y ?? 0) - (layer?.y ?? 0);
            if (copy.x !== x || copy.y !== y) copy.position.set(x, y);
            if (copy.scale.x !== source.scale.x || copy.scale.y !== source.scale.y) copy.scale.copyFrom(source.scale);
            if (copy.skew.x !== source.skew.x || copy.skew.y !== source.skew.y) copy.skew.copyFrom(source.skew);
            if (copy.rotation !== source.rotation) copy.rotation = source.rotation;
            // With the same transform, this anchor lays the cut exactly over its place in the source.
            const { width: width, height: height } = copy.texture.frame;
            const anchorX = width ? (source.anchor.x * source.texture.orig.width - restoration.cutX) / width : 0;
            const anchorY = height ? (source.anchor.y * source.texture.orig.height - restoration.cutY) / height : 0;
            if (copy.anchor.x !== anchorX || copy.anchor.y !== anchorY) copy.anchor.set(anchorX, anchorY);
            // Inside another storey the copy also takes that storey's own shade: tint only what remains.
            const host = layer ? this.projectionStyle(layer, frame).shade : [
                1,
                1,
                1
            ];
            const [r, g, b] = (style ? style.shade : [
                1,
                1,
                1
            ]).map((shade, i)=>Math.min(1, shade / (host[i] || 1)));
            const tint = r === 1 && g === 1 && b === 1 ? source.tint : Math.round((source.tint >>> 16 & 255) * r) << 16 | Math.round((source.tint >>> 8 & 255) * g) << 8 | Math.round((source.tint & 255) * b);
            if (copy.tint !== tint) copy.tint = tint;
            const depth = roof.zIndex + 0.1;
            if (copy.zIndex !== depth) copy.zIndex = depth;
            const visible = copy.texture !== (0, $klOfb.Texture).EMPTY && source.visible && (projection?.visible ?? true) && roof.visible && (projection?.zIndex ?? source.zIndex) < roof.zIndex;
            if (copy.visible !== visible) copy.visible = visible;
            // Avoid doubling the composite's opacity while the roof fades away.
            const alpha = source.alpha * (projection?.alpha ?? 1), coverage = roof.alpha * (layer?.alpha ?? 1);
            const shown = alpha * coverage / Math.max(0.0001, 1 - alpha * (1 - coverage));
            // A copy inside a storey fades with it already.
            const opacity = layer ? Math.min(1, shown / Math.max(0.0001, layer.alpha)) : shown;
            if (copy.alpha !== opacity) copy.alpha = opacity;
        }
        // Retire art no restoration was cut from this frame, e.g. after a storey change retunes the blur.
        for (const [key, baked] of this.bakedArt){
            if (baked.frame === frame) continue;
            baked.texture.destroy(true);
            this.bakedArt.delete(key);
        }
    }
    /** Darkening each channel by a plain factor is a sprite tint, without baking the shade into the art. */ projectionStyle(projection, frame) {
        let style = this.projectionStyles.get(projection);
        if (style?.frame === frame) return style;
        if (!style) this.projectionStyles.set(projection, style = {
            frame: 0,
            shade: [
                1,
                1,
                1
            ],
            filters: null,
            key: ""
        });
        const shade = [
            1,
            1,
            1
        ];
        const remaining = [];
        for (const filter of projection.filters ?? []){
            if (filter instanceof (0, $1avo5.filters).ColorMatrixFilter && filter.alpha === 1) {
                const matrix = filter.matrix;
                const scale = matrix.every((value, index)=>index === 0 || index === 6 || index === 12 ? value >= 0 && value <= 1 : value === (index === 18 ? 1 : 0));
                if (scale) {
                    shade[0] *= matrix[0];
                    shade[1] *= matrix[6];
                    shade[2] *= matrix[12];
                    continue;
                }
            }
            remaining.push(filter);
        }
        if (remaining.length !== (style.filters?.length ?? 0) || remaining.some((filter, index)=>filter !== style.filters?.[index])) style.filters = remaining.length ? remaining : null;
        style.key = style.filters ? style.filters.map($399d057f25535ae6$var$filterKey).join("|") : "";
        style.shade = shade;
        style.frame = frame;
        return style;
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");

const $5e01909f2a2154f9$export$8fdb32df88561578 = (base, upper, width, height, dy)=>{
    for(let y = 0; y < height; y++){
        const sy = y - dy;
        if (sy < 0 || sy >= height) continue;
        for(let x = 0; x < width; x++){
            const dst = (y * width + x) * 4, src = (sy * width + x) * 4;
            if (!base[dst + 3] || !upper[src + 3]) continue;
            const alpha = upper[src + 3] / 255;
            for(let c = 0; c < 3; c++)base[dst + c] = Math.round(upper[src + c] * alpha + base[dst + c] * (1 - alpha));
        }
    }
};
const $5e01909f2a2154f9$var$pixels = (texture)=>{
    const source = texture.baseTexture.resource?.source;
    if (!source || !texture.baseTexture.valid) return undefined;
    const canvas = document.createElement("canvas");
    canvas.width = texture.width;
    canvas.height = texture.height;
    const context = canvas.getContext("2d");
    if (!context) return undefined;
    const f = texture.frame, trim = texture.trim;
    context.drawImage(source, f.x, f.y, f.width, f.height, trim?.x || 0, trim?.y || 0, f.width, f.height);
    return {
        canvas: canvas,
        context: context,
        image: context.getImageData(0, 0, canvas.width, canvas.height)
    };
};
const $5e01909f2a2154f9$var$cache = new WeakMap();
const $5e01909f2a2154f9$var$ids = new WeakMap();
let $5e01909f2a2154f9$var$nextId = 0;
const $5e01909f2a2154f9$var$id = (texture)=>{
    if (!$5e01909f2a2154f9$var$ids.has(texture)) $5e01909f2a2154f9$var$ids.set(texture, ++$5e01909f2a2154f9$var$nextId);
    return $5e01909f2a2154f9$var$ids.get(texture);
};
const $5e01909f2a2154f9$export$9f38552cc9744cc9 = (texture, patches)=>{
    if (!patches.length) return texture;
    const key = patches.map((p)=>`${$5e01909f2a2154f9$var$id(p.texture)}:${p.dy}`).join("|");
    const variants = $5e01909f2a2154f9$var$cache.get(texture) ?? new Map();
    $5e01909f2a2154f9$var$cache.set(texture, variants);
    const known = variants.get(key);
    if (known && !known.baseTexture.destroyed) return known;
    const base = $5e01909f2a2154f9$var$pixels(texture);
    if (!base) return texture;
    for (const patch of patches){
        const upper = $5e01909f2a2154f9$var$pixels(patch.texture);
        // Retry on the next repaint if an atlas is still loading.
        if (!upper || upper.canvas.width !== base.canvas.width || upper.canvas.height !== base.canvas.height) return texture;
        $5e01909f2a2154f9$export$8fdb32df88561578(base.image.data, upper.image.data, base.canvas.width, base.canvas.height, patch.dy);
    }
    base.context.putImageData(base.image, 0, 0);
    // On a shared page (wallArtAtlas), so a wall of distinct cells batches together.
    const result = (0, $3c8dd7879239ee0e$export$11cde7437b85d173).put({
        width: base.canvas.width,
        height: base.canvas.height,
        data: base.image.data
    }) ?? (0, $klOfb.Texture).from(base.canvas);
    variants.set(key, result);
    return result;
};




parcelRequire("1avo5");
var $P8XPi = parcelRequire("P8XPi");
var $6qzqq = parcelRequire("6qzqq");
var $8t5Gy = parcelRequire("8t5Gy");




const $72f83e51a7379926$export$ac7d244648d3c160 = {
    wall: {
        alpha: 0.7,
        softness: 4,
        spread: 3
    }
};
const $72f83e51a7379926$export$fa5f84e3c33377ce = 1.5;
const $72f83e51a7379926$var$keyOf = (pieces)=>{
    let a = 0x811c9dc5, b = 0x9e3779b9;
    const mix = (v)=>{
        a = Math.imul(a ^ v, 0x01000193);
        b = Math.imul(b ^ v + 0x632be5ab, 0x85ebca6b) ^ b >>> 13;
    };
    for (const { texture: texture, x: x, y: y, width: width, height: height } of pieces){
        mix(texture ? texture.baseTexture.uid ?? 1 : 0);
        mix(texture ? texture.frame.x * 4096 + texture.frame.y : 0);
        mix(Math.round(x));
        mix(Math.round(y));
        mix(Math.round(width));
        mix(Math.round(height));
    }
    return `${pieces.length}:${a >>> 0}:${b >>> 0}`;
};
class $72f83e51a7379926$export$8664e1cc27db0c04 extends (0, $8t5Gy.Container) {
    constructor(resolution){
        super(), this.resolution = resolution, this.baked = new (0, $cb0c2ff63ebff87f$export$316a7d97d9517d7b)(this);
        this.interactive = false;
        this.interactiveChildren = false;
    }
    /** Re-bakes only the groups (pieces near one another) whose pieces changed. */ draw(pieces, softness, spread = 0) {
        const previous = new Map(this.baked.groups.map((group)=>[
                group.key,
                group
            ]));
        const next = [];
        const fresh = [];
        const rects = new Map(pieces.map((piece)=>{
            const { x: x, y: y, width: w, height: h } = piece;
            return [
                [
                    x,
                    y,
                    x + w,
                    y,
                    x + w,
                    y + h,
                    x,
                    y + h
                ],
                piece
            ];
        }));
        const resolution = this.resolution ?? (0, $126d618cffb761ba$export$bcea76f852eb0b92)();
        (0, $ff5e8e678ac263ca$export$8c235c973bd2cc6a)([
            ...rects.keys()
        ], softness * 4 + spread * 2).forEach((members)=>{
            const group = members.map((rect)=>rects.get(rect));
            const key = `${softness}|${spread}|${resolution}|${$72f83e51a7379926$var$keyOf(group)}`;
            const kept = previous.get(key);
            if (kept) {
                previous.delete(key);
                next.push(kept);
                return;
            }
            const graphics = new (0, $ff77f0e96218c7e7$export$6bfce3b6985f9a3d)(softness, 2, (0, $P8XPi.BLEND_MODES).MULTIPLY, resolution);
            const plain = group.filter((piece)=>!piece.texture);
            if (plain.length) {
                graphics.beginFill(0x000000, 1);
                plain.forEach(({ x: x, y: y, width: width, height: height })=>graphics.drawRect(x - spread, y - spread, width + 2 * spread, height + 2 * spread));
                graphics.endFill();
            }
            const offsets = spread > 0 ? [
                [
                    0,
                    0
                ],
                [
                    spread,
                    0
                ],
                [
                    -spread,
                    0
                ],
                [
                    0,
                    spread
                ],
                [
                    0,
                    -spread
                ],
                [
                    spread * 0.7,
                    spread * 0.7
                ],
                [
                    -spread * 0.7,
                    spread * 0.7
                ],
                [
                    spread * 0.7,
                    -spread * 0.7
                ],
                [
                    -spread * 0.7,
                    -spread * 0.7
                ]
            ] : [
                [
                    0,
                    0
                ]
            ];
            group.forEach((piece)=>{
                if (!piece.texture) return;
                offsets.forEach(([dx, dy])=>graphics.stamp(piece.texture, new (0, $6qzqq.Matrix)(1, 0, 0, 1, piece.x + dx, piece.y + dy), 0x000000));
            });
            next.push({
                key: key,
                graphics: graphics
            });
            fresh.push(graphics);
        });
        this.baked.replace(next, fresh);
    }
    get groupCount() {
        return this.baked.groups.length;
    }
    destroy(options) {
        this.baked.clear();
        super.destroy(options);
    }
}





parcelRequire("1avo5");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $8t5Gy = parcelRequire("8t5Gy");



const $c176d075ea73ab2c$export$bdd1d77507f3331 = {
    enabled: true,
    faceHeight: 6
};
const $c176d075ea73ab2c$export$db4af2b448dd82b2 = ()=>{
    if (typeof window === "undefined") return $c176d075ea73ab2c$export$bdd1d77507f3331;
    const w = window;
    if (w.groundRise === undefined) w.groundRise = $c176d075ea73ab2c$export$bdd1d77507f3331;
    const live = w.groundRise;
    if (live === false) return {
        ...$c176d075ea73ab2c$export$bdd1d77507f3331,
        enabled: false
    };
    return live && typeof live === "object" ? live : $c176d075ea73ab2c$export$bdd1d77507f3331;
};
const $c176d075ea73ab2c$export$950875a04869e1d8 = 128;
const $c176d075ea73ab2c$export$7b46d8d6b5fc39be = 12;
/** Most frame time the bake may take before it waits for the next frame. */ const $c176d075ea73ab2c$var$BAKE_BUDGET_MS = 4;
const $c176d075ea73ab2c$var$hash = (x, y, seed)=>{
    let h = Math.imul(x, 374761393) ^ Math.imul(y, 668265263) ^ seed;
    h = Math.imul(h ^ h >>> 13, 1274126177);
    return ((h ^ h >>> 16) >>> 0) / 4294967295;
};
const $c176d075ea73ab2c$var$smooth = (v)=>v * v * (3 - 2 * v);
const $c176d075ea73ab2c$var$valueNoise = (x, y, seed)=>{
    const ix = Math.floor(x), iy = Math.floor(y);
    const sx = $c176d075ea73ab2c$var$smooth(x - ix), sy = $c176d075ea73ab2c$var$smooth(y - iy);
    const a = $c176d075ea73ab2c$var$hash(ix, iy, seed), b = $c176d075ea73ab2c$var$hash(ix + 1, iy, seed), c = $c176d075ea73ab2c$var$hash(ix, iy + 1, seed), d = $c176d075ea73ab2c$var$hash(ix + 1, iy + 1, seed);
    const top = a + (b - a) * sx;
    return top + (c + (d - c) * sx - top) * sy;
};
const $c176d075ea73ab2c$export$177cc49a05862605 = (cells, x0, y0, w, h)=>{
    const mask = new Uint8Array(w * h);
    const share = (vx, vy)=>(+cells(vx - 1, vy - 1) + +cells(vx, vy - 1) + +cells(vx - 1, vy) + +cells(vx, vy)) / 4;
    const corners = new Map();
    const corner = (vx, vy)=>{
        const key = vx * 65536 + vy;
        let v = corners.get(key);
        if (v === undefined) corners.set(key, v = share(vx, vy));
        return v;
    };
    for(let y = 0; y < h; y++){
        const py = y0 + y, cy = Math.floor(py / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), fy = $c176d075ea73ab2c$var$smooth(py / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - cy);
        for(let x = 0; x < w; x++){
            const px = x0 + x, cx = Math.floor(px / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), fx = $c176d075ea73ab2c$var$smooth(px / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - cx);
            const c00 = corner(cx, cy), c10 = corner(cx + 1, cy), c01 = corner(cx, cy + 1), c11 = corner(cx + 1, cy + 1);
            if (c00 === 0 && c10 === 0 && c01 === 0 && c11 === 0) continue;
            if (c00 === 1 && c10 === 1 && c01 === 1 && c11 === 1) {
                mask[y * w + x] = 1;
                continue;
            }
            const f = (c00 + (c10 - c00) * fx) * (1 - fy) + (c01 + (c11 - c01) * fx) * fy + 0.30 * ($c176d075ea73ab2c$var$valueNoise(px / 22, py / 22, 71) - 0.5) + 0.05 * ($c176d075ea73ab2c$var$valueNoise(px / 7, py / 7, 72) - 0.5);
            if (f > 0.5) mask[y * w + x] = 1;
        }
    }
    return mask;
};
const $c176d075ea73ab2c$var$SOIL = [
    92,
    64,
    38
];
const $c176d075ea73ab2c$var$DEEP = [
    26,
    64,
    31
];
const $c176d075ea73ab2c$export$ff5a7a92863b0ae7 = (ground, mask, w, h, x0, y0, margin, faceHeight = $c176d075ea73ab2c$export$bdd1d77507f3331.faceHeight)=>{
    const FH = Math.max(1, Math.round(faceHeight));
    const n = w * h;
    const out = new Float32Array(n * 3);
    for(let i = 0; i < n; i++){
        out[i * 3] = ground[i * 4];
        out[i * 3 + 1] = ground[i * 4 + 1];
        out[i * 3 + 2] = ground[i * 4 + 2];
    }
    const up = (x, y)=>x >= 0 && y >= 0 && x < w && y < h && mask[y * w + x] === 1;
    const lowAt = (x, y)=>x >= 0 && y >= 0 && x < w && y < h && mask[y * w + x] === 0;
    const g = (x, y, c)=>ground[(Math.min(h - 1, Math.max(0, y)) * w + x) * 4 + c];
    const scale = (i, m)=>{
        out[i * 3] *= m;
        out[i * 3 + 1] *= m;
        out[i * 3 + 2] *= m;
    };
    const colHash = (x, k, seed)=>$c176d075ea73ab2c$var$hash(x0 + x, k, seed);
    // s: rows down to the first lower pixel (1 = right above the drop); FH + 2 when there is none in reach.
    const s = new Uint8Array(n);
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
        if (!mask[y * w + x]) continue;
        let k = 1;
        while(k <= FH + 1 && y + k < h && mask[(y + k) * w + x])k++;
        s[y * w + x] = k <= FH + 1 && y + k < h ? k : FH + 2;
    }
    const isFace = (i)=>s[i] > 0 && s[i] <= FH;
    // The face, its strands, and the raised grass hanging over its top.
    const hangCap = Math.round(FH * 0.45);
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (!isFace(i)) continue;
        const depth = FH - s[i] + 1, t = depth / FH, lip = y - depth;
        const openSide = lowAt(x - 1, y) || lowAt(x + 1, y);
        const e = Math.min(1, Math.max(0, t - 0.55));
        const strand = depth <= Math.floor(colHash(x, 0, 41) * 7) && colHash(x, 1, 42) > 0.35;
        const hang = Math.min(Math.floor(colHash(x, 2, 43) * 3.2), hangCap);
        for(let c = 0; c < 3; c++){
            const top = g(x, lip, c);
            let v = openSide ? top * (0.84 - 0.10 * t) : (top * (0.66 - 0.22 * t) + $c176d075ea73ab2c$var$DEEP[c] * 0.15) * (1 - 0.35 * e) + $c176d075ea73ab2c$var$SOIL[c] * 0.35 * e;
            if (strand) v = top * 0.80;
            if (depth <= hang) v = top * (depth === hang ? 0.86 : 0.97);
            out[i * 3 + c] = v;
        }
    }
    // The lit lip above the face.
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (s[i] === FH + 1 && colHash(x, 3, 44) > 0.25) scale(i, 1.13);
    }
    // The ground below: a contact shadow, and its grass growing up in front of the face's foot.
    const contact = [
        0.78,
        0.86,
        0.93,
        0.97
    ];
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (mask[i]) continue;
        for(let k = 1; k <= contact.length; k++){
            if (y - k < 0) break;
            if (mask[(y - k) * w + x]) {
                scale(i, contact[k - 1]);
                break;
            }
        }
    }
    const bladeCap = Math.round(FH * 0.35);
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (!isFace(i)) continue;
        const len = colHash(x, 4, 45) > 0.5 ? Math.floor(colHash(x, 5, 46) * 3.4) : 0;
        if (s[i] <= len && s[i] <= bladeCap) for(let c = 0; c < 3; c++)out[i * 3 + c] = g(x, y + s[i] + 2, c) * 0.92;
    }
    // The far rim catches the sun; its blades poke up over the ground behind.
    for(let y = 1; y < h; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (mask[i] && !mask[i - w] && colHash(x, 9, 50) > 0.2) scale(i, 1.10);
    }
    const tip = new Uint8Array(n);
    for(let y = 0; y < h - 1; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (!mask[i] && mask[i + w] && colHash(x, 6, 47) > 0.45) {
            tip[i] = 1;
            for(let c = 0; c < 3; c++)out[i * 3 + c] = out[(i + w) * 3 + c] * 0.94;
        }
    }
    for(let y = 0; y < h - 2; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (!mask[i] && tip[i + w] && colHash(x, 7, 48) > 0.75) for(let c = 0; c < 3; c++)out[i * 3 + c] = out[(i + 2 * w) * 3 + c] * 0.90;
    }
    // Sides: blades spill over; the west side falls in shade, the east side catches the light.
    for (const dx of [
        -1,
        1
    ]){
        const edgeColour = new Float32Array(n * 3);
        const edge = new Uint8Array(n);
        for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
            const i = y * w + x;
            if (mask[i] && lowAt(x + dx, y)) {
                edge[i] = 1;
                edgeColour[i * 3] = out[i * 3];
                edgeColour[i * 3 + 1] = out[i * 3 + 1];
                edgeColour[i * 3 + 2] = out[i * 3 + 2];
            }
        }
        for(let y = 0; y < h; y++){
            const spill = Math.floor($c176d075ea73ab2c$var$hash((y0 + y) * 7 + (dx > 0 ? 1 : 0), 8, 49) * 2.6);
            for(let x = 0; x < w; x++){
                const i = y * w + x;
                if (!edge[i]) continue;
                for(let k = 1; k <= Math.min(2, spill); k++){
                    const tx = x + dx * k;
                    if (!lowAt(tx, y)) continue;
                    const j = y * w + tx;
                    for(let c = 0; c < 3; c++)out[j * 3 + c] = edgeColour[i * 3 + c] * (0.96 - 0.06 * k);
                }
                if (dx < 0) for (const [k, m] of [
                    [
                        1,
                        0.86
                    ],
                    [
                        2,
                        0.93
                    ]
                ]){
                    const tx = x - (spill + k);
                    if (lowAt(tx, y)) scale(y * w + tx, m);
                }
                else scale(i, 1.07);
            }
        }
    }
    const iw = w - 2 * margin, ih = h - 2 * margin;
    const rgba = new Uint8ClampedArray(Math.max(0, iw * ih * 4));
    for(let y = 0; y < ih; y++)for(let x = 0; x < iw; x++){
        const i = (y + margin) * w + x + margin, o = (y * iw + x) * 4;
        const r = Math.round(Math.min(255, Math.max(0, out[i * 3])));
        const gg = Math.round(Math.min(255, Math.max(0, out[i * 3 + 1])));
        const b = Math.round(Math.min(255, Math.max(0, out[i * 3 + 2])));
        if (r === ground[i * 4] && gg === ground[i * 4 + 1] && b === ground[i * 4 + 2]) continue;
        rgba[o] = r;
        rgba[o + 1] = gg;
        rgba[o + 2] = b;
        rgba[o + 3] = 255;
    }
    return rgba;
};
const $c176d075ea73ab2c$export$20e289ea0cb8d91f = (cells, width, height)=>{
    const out = [];
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
        const here = cells(x, y);
        let differs = false;
        for(let dy = -1; dy <= 1 && !differs; dy++)for(let dx = -1; dx <= 1 && !differs; dx++)if (cells(x + dx, y + dy) !== here) differs = true;
        if (differs) out.push({
            x: x,
            y: y
        });
    }
    return out;
};
const $c176d075ea73ab2c$var$cellsOf = (rise, width, height)=>(x, y)=>!!rise && x >= 0 && y >= 0 && x < width && y < height && rise[x]?.[y] === "1";
const $c176d075ea73ab2c$export$7634dfb099fa0e05 = (source, px, py, w, h)=>{
    if (typeof document === "undefined") return undefined;
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const context = canvas.getContext("2d");
    if (!context) return undefined;
    const ground = source.resolveTileMapFromLayerId("map1");
    for(let cy = Math.floor(py / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)); cy * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) < py + h; cy++)for(let cx = Math.floor(px / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)); cx * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) < px + w; cx++){
        const tile = ground?.[cx]?.[cy];
        if (!tile || tile === "0") continue;
        const texture = (0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(source.resolveTilesetTileId(tile));
        const image = texture?.baseTexture?.resource?.source;
        if (!image || !texture.baseTexture.valid) return undefined;
        const frame = texture.frame;
        context.drawImage(image, frame.x, frame.y, frame.width, frame.height, cx * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - px, cy * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - py, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    }
    try {
        return context.getImageData(0, 0, w, h).data;
    } catch  {
        return undefined // a tainted canvas: draw no step rather than fail the map
        ;
    }
};
class $c176d075ea73ab2c$export$67bdc57a63bd8057 extends (0, $8t5Gy.Container) {
    constructor(readGround = $c176d075ea73ab2c$export$7634dfb099fa0e05){
        super(), this.readGround = readGround, this.chunks = new Map(), this.slots = new (0, $3efef98b54376b50$export$cbb847030152319)($c176d075ea73ab2c$export$950875a04869e1d8), this.queue = [], this.configKey = "", this.sync = (source)=>{
            const config = $c176d075ea73ab2c$export$db4af2b448dd82b2();
            this.configKey = `${config.enabled}|${config.faceHeight}`;
            const rise = source?.getRiseLayer?.();
            if (!source || !rise || !config.enabled) {
                this.source = source;
                this.clearChunks();
                this.visible = false;
                return;
            }
            if (source.roomId !== this.source?.roomId) this.clearChunks();
            this.source = source;
            this.visible = true;
            const width = source.width(), height = source.height();
            const cells = $c176d075ea73ab2c$var$cellsOf(rise, width, height);
            const ground = source.resolveTileMapFromLayerId("map1");
            const per = $c176d075ea73ab2c$export$950875a04869e1d8 / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const wanted = new Map();
            for (const cell of $c176d075ea73ab2c$export$20e289ea0cb8d91f(cells, width, height)){
                const x = Math.floor(cell.x / per), y = Math.floor(cell.y / per);
                wanted.set(`${x},${y}`, {
                    x: x,
                    y: y
                });
            }
            this.chunks.forEach((chunk, key)=>{
                if (!wanted.has(key)) this.dropChunk(chunk);
            });
            const reach = Math.ceil($c176d075ea73ab2c$export$7b46d8d6b5fc39be / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            this.queue = [];
            wanted.forEach(({ x: x, y: y }, key)=>{
                // Everything a piece is baked from: the raised cells and the ground tiles in reach of it.
                const parts = [
                    this.configKey
                ];
                for(let cy = y * per - reach; cy < (y + 1) * per + reach; cy++)for(let cx = x * per - reach; cx < (x + 1) * per + reach; cx++)parts.push(`${+cells(cx, cy)}${ground?.[cx]?.[cy] ?? ""}`);
                const signature = parts.join(",");
                const chunk = this.chunks.get(key) ?? {
                    key: key,
                    x: x,
                    y: y,
                    baked: ""
                };
                this.chunks.set(key, chunk);
                if (chunk.baked !== signature) this.queue.push({
                    chunk: chunk,
                    signature: signature
                });
            });
        }, this./** Bake waiting pieces until the frame budget runs out. */ tick = (budgetMs = $c176d075ea73ab2c$var$BAKE_BUDGET_MS)=>{
            if (!this.source) return;
            const config = $c176d075ea73ab2c$export$db4af2b448dd82b2();
            if (`${config.enabled}|${config.faceHeight}` !== this.configKey) this.sync(this.source);
            if (!this.queue.length) return;
            const start = performance.now();
            const rise = this.source.getRiseLayer?.();
            const width = this.source.width(), height = this.source.height();
            const cells = $c176d075ea73ab2c$var$cellsOf(rise, width, height);
            while(this.queue.length && performance.now() - start < budgetMs){
                const { chunk: chunk, signature: signature } = this.queue[0];
                const px = chunk.x * $c176d075ea73ab2c$export$950875a04869e1d8, py = chunk.y * $c176d075ea73ab2c$export$950875a04869e1d8;
                // The piece and its margin, kept inside the map (there is no ground to read past its edge).
                const rx = Math.max(0, px - $c176d075ea73ab2c$export$7b46d8d6b5fc39be), ry = Math.max(0, py - $c176d075ea73ab2c$export$7b46d8d6b5fc39be);
                const rw = Math.min(width * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), px + $c176d075ea73ab2c$export$950875a04869e1d8 + $c176d075ea73ab2c$export$7b46d8d6b5fc39be) - rx;
                const rh = Math.min(height * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), py + $c176d075ea73ab2c$export$950875a04869e1d8 + $c176d075ea73ab2c$export$7b46d8d6b5fc39be) - ry;
                const groundPixels = this.readGround(this.source, rx, ry, rw, rh);
                if (!groundPixels) return; // an atlas still decoding: try again next frame, never mark it done
                this.queue.shift();
                // Pad to a full margin on every side so the painter's interior is exactly this piece.
                const left = px - rx, top = py - ry;
                const pw = rw + ($c176d075ea73ab2c$export$7b46d8d6b5fc39be - left) + Math.max(0, px + $c176d075ea73ab2c$export$950875a04869e1d8 + $c176d075ea73ab2c$export$7b46d8d6b5fc39be - (rx + rw));
                const ph = rh + ($c176d075ea73ab2c$export$7b46d8d6b5fc39be - top) + Math.max(0, py + $c176d075ea73ab2c$export$950875a04869e1d8 + $c176d075ea73ab2c$export$7b46d8d6b5fc39be - (ry + rh));
                const padded = new Uint8ClampedArray(pw * ph * 4);
                for(let y = 0; y < rh; y++)padded.set(groundPixels.subarray(y * rw * 4, (y + 1) * rw * 4), ((y + $c176d075ea73ab2c$export$7b46d8d6b5fc39be - top) * pw + $c176d075ea73ab2c$export$7b46d8d6b5fc39be - left) * 4);
                const ox = px - $c176d075ea73ab2c$export$7b46d8d6b5fc39be, oy = py - $c176d075ea73ab2c$export$7b46d8d6b5fc39be;
                const mask = $c176d075ea73ab2c$export$177cc49a05862605(cells, ox, oy, pw, ph);
                const rgba = $c176d075ea73ab2c$export$ff5a7a92863b0ae7(padded, mask, pw, ph, ox, oy, $c176d075ea73ab2c$export$7b46d8d6b5fc39be, config.faceHeight);
                this.placeChunk(chunk, rgba);
                chunk.baked = signature;
            }
        }, this.placeChunk = (chunk, rgba)=>{
            if (!rgba.some((v, i)=>i % 4 === 3 && v > 0)) {
                this.emptyChunk(chunk);
                return;
            }
            const slot = chunk.slot ?? this.slots.claim();
            if (!slot) return;
            chunk.slot = slot;
            this.slots.paint(slot, rgba);
            if (!chunk.sprite) {
                chunk.sprite = new (0, $7Bs2Z.Sprite)(slot.texture);
                chunk.sprite.position.set(chunk.x * $c176d075ea73ab2c$export$950875a04869e1d8, chunk.y * $c176d075ea73ab2c$export$950875a04869e1d8);
                this.addChild(chunk.sprite);
            }
        }, this.emptyChunk = (chunk)=>{
            chunk.sprite?.destroy();
            chunk.sprite = undefined;
            if (chunk.slot) this.slots.release(chunk.slot);
            chunk.slot = undefined;
        }, this.dropChunk = (chunk)=>{
            this.emptyChunk(chunk);
            this.chunks.delete(chunk.key);
        }, this.clearChunks = ()=>{
            this.chunks.forEach((chunk)=>chunk.sprite?.destroy());
            this.chunks.clear();
            this.slots.reset();
            this.queue = [];
        };
        this.interactiveChildren = false;
    }
    /** True while pieces are still waiting to bake. */ get baking() {
        return this.queue.length > 0;
    }
    destroy(options) {
        this.clearChunks();
        super.destroy(options);
    }
}



parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $P8XPi = parcelRequire("P8XPi");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $9Tsx3 = parcelRequire("9Tsx3");
var $8t5Gy = parcelRequire("8t5Gy");



const $e6afa59572fc359e$export$c45014df4141ef98 = {
    sigma: 13,
    cut: 0.42,
    wobble: 3.5
};
const $e6afa59572fc359e$export$35b828c091043fb4 = 7;
const $e6afa59572fc359e$var$hash = (x, y, seed)=>{
    let h = Math.imul(x | 0, 374761393) ^ Math.imul(y | 0, 668265263) ^ seed;
    h = Math.imul(h ^ h >>> 13, 1274126177);
    return ((h ^ h >>> 16) >>> 0) / 4294967295;
};
const $e6afa59572fc359e$var$smooth = (v)=>v * v * (3 - 2 * v);
const $e6afa59572fc359e$var$valueNoise = (x, y, seed)=>{
    const ix = Math.floor(x), iy = Math.floor(y);
    const sx = $e6afa59572fc359e$var$smooth(x - ix), sy = $e6afa59572fc359e$var$smooth(y - iy);
    const a = $e6afa59572fc359e$var$hash(ix, iy, seed), b = $e6afa59572fc359e$var$hash(ix + 1, iy, seed), c = $e6afa59572fc359e$var$hash(ix, iy + 1, seed), d = $e6afa59572fc359e$var$hash(ix + 1, iy + 1, seed);
    const top = a + (b - a) * sx;
    return top + (c + (d - c) * sx - top) * sy;
};
/** One box pass along x then y, edges held. Three of these are close to a gaussian. */ const $e6afa59572fc359e$var$boxBlur = (src, w, h, r)=>{
    const tmp = new Float32Array(w * h), out = new Float32Array(w * h), span = 2 * r + 1;
    for(let y = 0; y < h; y++){
        const row = y * w;
        let sum = 0;
        for(let k = -r; k <= r; k++)sum += src[row + Math.min(w - 1, Math.max(0, k))];
        for(let x = 0; x < w; x++){
            tmp[row + x] = sum / span;
            sum += src[row + Math.min(w - 1, x + r + 1)] - src[row + Math.max(0, x - r)];
        }
    }
    for(let x = 0; x < w; x++){
        let sum = 0;
        for(let k = -r; k <= r; k++)sum += tmp[Math.min(h - 1, Math.max(0, k)) * w + x];
        for(let y = 0; y < h; y++){
            out[y * w + x] = sum / span;
            sum += tmp[Math.min(h - 1, y + r + 1) * w + x] - tmp[Math.max(0, y - r) * w + x];
        }
    }
    return out;
};
/**
 * The cells that pass `test`, as 1 and 0 per world pixel of `region`, blurred to a gaussian of `sigma`. It
 * reads that far past the region, so two regions agree where they meet.
 */ const $e6afa59572fc359e$var$blurredCells = (cells, region, sigma, test)=>{
    // Three boxes of this radius are a gaussian of `sigma`.
    const r = Math.max(1, Math.round((Math.sqrt(4 * sigma * sigma + 1) - 1) / 2));
    const m = 3 * r + 1;
    const W = region.w + 2 * m, H = region.h + 2 * m;
    let field = new Float32Array(W * H), any = false;
    for(let y = 0; y < H; y++){
        const cy = Math.floor((region.y0 - m + y) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
        for(let x = 0; x < W; x++)if (test(cells(Math.floor((region.x0 - m + x) / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), cy))) {
            field[y * W + x] = 1;
            any = true;
        }
    }
    const out = new Float32Array(region.w * region.h);
    // Nothing passed: nothing to blur (water with no deeper core skips the whole pass).
    if (!any) return out;
    for(let pass = 0; pass < 3; pass++)field = $e6afa59572fc359e$var$boxBlur(field, W, H, r);
    for(let y = 0; y < region.h; y++)out.set(field.subarray((y + m) * W + m, (y + m) * W + m + region.w), y * region.w);
    return out;
};
const $e6afa59572fc359e$export$70184279f211ed0a = (cells, region, shore = $e6afa59572fc359e$export$c45014df4141ef98)=>{
    const field = $e6afa59572fc359e$var$blurredCells(cells, region, shore.sigma, (cell)=>cell > 0);
    const mask = new Uint8Array(region.w * region.h);
    const k = shore.wobble / 40;
    for(let y = 0; y < region.h; y++)for(let x = 0; x < region.w; x++){
        const v = field[y * region.w + x];
        if (v <= 0.02) continue;
        const px = region.x0 + x, py = region.y0 + y;
        const wob = k * (2 * ($e6afa59572fc359e$var$valueNoise(px / 26, py / 26, 71) - 0.5) + 0.6 * ($e6afa59572fc359e$var$valueNoise(px / 8, py / 8, 72) - 0.5));
        if (v - shore.cut + wob > 0) mask[y * region.w + x] = 1;
    }
    return mask;
};
const $e6afa59572fc359e$export$dae6f67aab381cee = (mask, w, h, target)=>{
    const INF = 1e12, n = Math.max(w, h);
    const grid = new Float64Array(w * h), out = new Float32Array(w * h);
    const f = new Float64Array(n), d = new Float64Array(n), v = new Int32Array(n), z = new Float64Array(n + 1);
    const pass = (len)=>{
        let k = 0;
        v[0] = 0;
        z[0] = -INF;
        z[1] = INF;
        for(let q = 1; q < len; q++){
            let s = (f[q] + q * q - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
            while(s <= z[k]){
                k--;
                s = (f[q] + q * q - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
            }
            k++;
            v[k] = q;
            z[k] = s;
            z[k + 1] = INF;
        }
        k = 0;
        for(let q = 0; q < len; q++){
            while(z[k + 1] < q)k++;
            d[q] = (q - v[k]) * (q - v[k]) + f[v[k]];
        }
    };
    for(let x = 0; x < w; x++){
        for(let y = 0; y < h; y++)f[y] = mask[y * w + x] === target ? 0 : INF;
        pass(h);
        for(let y = 0; y < h; y++)grid[y * w + x] = d[y];
    }
    for(let y = 0; y < h; y++){
        for(let x = 0; x < w; x++)f[x] = grid[y * w + x];
        pass(w);
        for(let x = 0; x < w; x++)out[y * w + x] = Math.sqrt(d[x]);
    }
    return out;
};
/** The sun's direction per px of bank height (sun.ts leans shadows to the lower left), a touch exaggerated. */ const $e6afa59572fc359e$var$SHADE = {
    x: 0.46,
    y: -0.26
};
/** The deeper water's edge: blurred like the shore, and eased from where its cells' blur reads this low to this high. */ const $e6afa59572fc359e$var$DEEPER_EDGE = {
    sigma: 13,
    from: 0.2,
    to: 0.7
};
const $e6afa59572fc359e$var$DEEPER_CELL = 3;
const $e6afa59572fc359e$export$21bd7a34e9ae9a60 = (cells, region, faceHeight = $e6afa59572fc359e$export$35b828c091043fb4)=>{
    const { w: w, h: h } = region;
    const mask = $e6afa59572fc359e$export$70184279f211ed0a(cells, region);
    const depth = $e6afa59572fc359e$export$dae6f67aab381cee(mask, w, h, 0);
    const deeper = $e6afa59572fc359e$var$blurredCells(cells, region, $e6afa59572fc359e$var$DEEPER_EDGE.sigma, (cell)=>cell >= $e6afa59572fc359e$var$DEEPER_CELL);
    const field = new Uint8Array(w * h * 4), flow = new Uint8Array(w * h * 4);
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        field[i * 4 + 3] = 255;
        flow[i * 4] = 128;
        flow[i * 4 + 1] = 128;
        flow[i * 4 + 3] = 255;
        if (!mask[i]) {
            depth[i] = 0;
            deeper[i] = 0;
            continue;
        }
        deeper[i] = $e6afa59572fc359e$var$smooth(Math.max(0, Math.min(1, (deeper[i] - $e6afa59572fc359e$var$DEEPER_EDGE.from) / ($e6afa59572fc359e$var$DEEPER_EDGE.to - $e6afa59572fc359e$var$DEEPER_EDGE.from))));
        flow[i * 4 + 2] = Math.round(deeper[i] * 255);
        field[i * 4] = Math.min(63, depth[i]) * 4;
        let shaded = false;
        for(let k = 0.5; k <= faceHeight && !shaded; k += 0.5){
            const qx = Math.round(x + $e6afa59572fc359e$var$SHADE.x * k), qy = Math.round(y + $e6afa59572fc359e$var$SHADE.y * k);
            if (qx >= 0 && qy >= 0 && qx < w && qy < h && !mask[qy * w + qx]) shaded = true;
        }
        field[i * 4 + 1] = shaded ? 255 : 0;
        const dn = depth[Math.min(h - 1, y + 2) * w + x] - depth[Math.max(0, y - 2) * w + x];
        const de = depth[y * w + Math.min(w - 1, x + 2)] - depth[y * w + Math.max(0, x - 2)];
        const g = Math.hypot(dn, de);
        field[i * 4 + 2] = Math.round(255 * (g > 0.01 ? 0.5 + 0.5 * dn / g : 0.5));
    }
    return {
        mask: mask,
        depth: depth,
        deeper: deeper,
        field: field,
        flow: flow
    };
};
const $e6afa59572fc359e$var$SOIL = [
    92,
    64,
    38
];
const $e6afa59572fc359e$var$DEEP = [
    26,
    64,
    31
];
const $e6afa59572fc359e$export$33e21c0888957a6f = (ground, mask, region, faceHeight = $e6afa59572fc359e$export$35b828c091043fb4)=>{
    const { w: w, h: h, x0: x0, y0: y0 } = region;
    const FH = Math.max(1, Math.round(faceHeight));
    const n = w * h, out = new Float32Array(n * 3), painted = new Uint8Array(n);
    for(let i = 0; i < n; i++){
        out[i * 3] = ground[i * 4];
        out[i * 3 + 1] = ground[i * 4 + 1];
        out[i * 3 + 2] = ground[i * 4 + 2];
    }
    const wet = (x, y)=>x >= 0 && y >= 0 && x < w && y < h && mask[y * w + x] === 1;
    const g = (x, y, c)=>ground[(Math.min(h - 1, Math.max(0, y)) * w + x) * 4 + c];
    const scale = (i, m)=>{
        out[i * 3] *= m;
        out[i * 3 + 1] *= m;
        out[i * 3 + 2] *= m;
        painted[i] = 1;
    };
    const colHash = (x, k, seed)=>$e6afa59572fc359e$var$hash(x0 + x, k, seed);
    // s: rows down to the first water pixel (1 = right above it); FH + 2 when there is none in reach.
    const s = new Uint8Array(n);
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
        if (mask[y * w + x]) continue;
        let k = 1;
        while(k <= FH + 1 && y + k < h && !mask[(y + k) * w + x])k++;
        s[y * w + x] = k <= FH + 1 && y + k < h ? k : FH + 2;
    }
    const isFace = (i)=>s[i] > 0 && s[i] <= FH;
    const hangCap = Math.round(FH * 0.45);
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (!isFace(i)) continue;
        const depth = FH - s[i] + 1, t = depth / FH, lip = y - depth;
        const openSide = wet(x - 1, y) || wet(x + 1, y);
        const e = Math.min(1, Math.max(0, t - 0.45));
        const strand = depth <= Math.floor(colHash(x, 0, 41) * 6) && colHash(x, 1, 42) > 0.4;
        const hang = Math.min(Math.floor(colHash(x, 2, 43) * 3.2), hangCap);
        for(let c = 0; c < 3; c++){
            const top = g(x, lip, c);
            let v = openSide ? top * (0.80 - 0.12 * t) : (top * (0.62 - 0.24 * t) + $e6afa59572fc359e$var$DEEP[c] * 0.15) * (1 - 0.4 * e) + $e6afa59572fc359e$var$SOIL[c] * 0.42 * e;
            if (strand) v = top * 0.78;
            if (depth <= hang) v = top * (depth === hang ? 0.86 : 0.97);
            if (s[i] === 1) v = $e6afa59572fc359e$var$SOIL[c] * 0.42 + $e6afa59572fc359e$var$DEEP[c] * 0.12;
            out[i * 3 + c] = v;
        }
        painted[i] = 1;
    }
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (!mask[i] && s[i] === FH + 1 && colHash(x, 3, 44) > 0.25) scale(i, 1.13);
    }
    for(let y = 1; y < h; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (!mask[i] && mask[i - w] && colHash(x, 9, 50) > 0.2) scale(i, 1.10);
    }
    const tip = new Uint8Array(n);
    for(let y = 0; y < h - 1; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (mask[i] && !mask[i + w] && colHash(x, 6, 47) > 0.45) {
            tip[i] = 1;
            painted[i] = 1;
            for(let c = 0; c < 3; c++)out[i * 3 + c] = out[(i + w) * 3 + c] * 0.94;
        }
    }
    for(let y = 0; y < h - 2; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (mask[i] && tip[i + w] && colHash(x, 7, 48) > 0.75) {
            painted[i] = 1;
            for(let c = 0; c < 3; c++)out[i * 3 + c] = out[(i + 2 * w) * 3 + c] * 0.90;
        }
    }
    for (const dx of [
        -1,
        1
    ]){
        const edgeColour = new Float32Array(n * 3), edge = new Uint8Array(n);
        for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
            const i = y * w + x;
            if (!mask[i] && wet(x + dx, y)) {
                edge[i] = 1;
                edgeColour.set(out.subarray(i * 3, i * 3 + 3), i * 3);
            }
        }
        for(let y = 0; y < h; y++){
            const spill = Math.floor($e6afa59572fc359e$var$hash((y0 + y) * 7 + (dx > 0 ? 1 : 0), 8, 49) * 2.6);
            for(let x = 0; x < w; x++){
                const i = y * w + x;
                if (!edge[i]) continue;
                for(let k = 1; k <= Math.min(2, spill); k++){
                    const tx = x + dx * k;
                    if (!wet(tx, y)) continue;
                    const j = y * w + tx;
                    for(let c = 0; c < 3; c++)out[j * 3 + c] = edgeColour[i * 3 + c] * (0.92 - 0.06 * k);
                    painted[j] = 1;
                }
                if (dx > 0) scale(i, 1.07);
            }
        }
    }
    const rgba = new Uint8ClampedArray(n * 4);
    for(let i = 0; i < n; i++){
        if (!painted[i]) continue;
        rgba[i * 4] = Math.min(255, Math.max(0, out[i * 3]));
        rgba[i * 4 + 1] = Math.min(255, Math.max(0, out[i * 3 + 1]));
        rgba[i * 4 + 2] = Math.min(255, Math.max(0, out[i * 3 + 2]));
        rgba[i * 4 + 3] = 255;
    }
    return rgba;
};
const $e6afa59572fc359e$export$9798d608fa5aa8c5 = (ground, bank, mask, region, faceHeight = $e6afa59572fc359e$export$35b828c091043fb4)=>{
    const { w: w, h: h } = region;
    const out = new Uint8ClampedArray(w * h * 4);
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++){
        const i = y * w + x;
        if (!mask[i]) continue;
        let k0 = 0;
        for(let k = 1; k <= faceHeight + 3; k++){
            if (y - k < 0) break;
            if (!mask[(y - k) * w + x]) {
                k0 = k;
                break;
            }
        }
        if (!k0) continue;
        const sy = y - 2 * k0 + 1;
        if (sy < 0) continue;
        const j = (sy * w + x) * 4;
        const src = bank[j + 3] ? bank : ground;
        out[i * 4] = src[j];
        out[i * 4 + 1] = src[j + 1];
        out[i * 4 + 2] = src[j + 2];
        out[i * 4 + 3] = k0 <= faceHeight ? 255 : 150;
    }
    return out;
};
const $e6afa59572fc359e$export$1e14ad071b3ff14b = (cells, width, height)=>{
    const seen = new Uint8Array(width * height);
    const out = [];
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
        if (seen[y * width + x] || !cells(x, y)) continue;
        const body = {
            x0: x,
            y0: y,
            x1: x,
            y1: y,
            cells: 0
        };
        const stack = [
            y * width + x
        ];
        seen[y * width + x] = 1;
        while(stack.length){
            const i = stack.pop(), cx = i % width, cy = Math.floor(i / width);
            body.cells++;
            body.x0 = Math.min(body.x0, cx);
            body.x1 = Math.max(body.x1, cx);
            body.y0 = Math.min(body.y0, cy);
            body.y1 = Math.max(body.y1, cy);
            for(let dy = -1; dy <= 1; dy++)for(let dx = -1; dx <= 1; dx++){
                const nx = cx + dx, ny = cy + dy;
                if (nx < 0 || ny < 0 || nx >= width || ny >= height) continue;
                const j = ny * width + nx;
                if (!seen[j] && cells(nx, ny)) {
                    seen[j] = 1;
                    stack.push(j);
                }
            }
        }
        out.push(body);
    }
    return out;
};



const $01866daf3eb22cee$export$3283543fbef50d2 = {
    enabled: true,
    reflection: 0.55,
    faceHeight: (0, $e6afa59572fc359e$export$35b828c091043fb4),
    waist: 22
};
const $01866daf3eb22cee$export$ca5952f179acb8de = ()=>{
    if (typeof window === "undefined") return $01866daf3eb22cee$export$3283543fbef50d2;
    const w = window;
    if (w.water === undefined) w.water = $01866daf3eb22cee$export$3283543fbef50d2;
    const live = w.water;
    if (live === false) return {
        ...$01866daf3eb22cee$export$3283543fbef50d2,
        enabled: false
    };
    return live && typeof live === "object" ? live : $01866daf3eb22cee$export$3283543fbef50d2;
};
/** Cells of land baked round each body: the shore's blur and the bank's face both reach into it. */ const $01866daf3eb22cee$var$BODY_MARGIN_CELLS = 2;
/** How far above the water a body still reflects in it (its feet on the bank). */ const $01866daf3eb22cee$var$REFLECT_REACH = 3 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
const $01866daf3eb22cee$var$MAX_WADERS = 8;
/** The legs' ring, and how far it widens round a waist, in px. */ const $01866daf3eb22cee$var$RING_RADIUS = 8;
const $01866daf3eb22cee$var$WAIST_RING_GROWTH = 3;
/** How deep a wader goes in out of the deeper water (to the knee), in px; WATER.waist is how deep in it. */ const $01866daf3eb22cee$var$KNEE_SUBMERSION = 12;
const $01866daf3eb22cee$var$VERT = `
attribute vec2 aVertexPosition;
attribute vec2 aUvs;
uniform mat3 translationMatrix;
uniform mat3 projectionMatrix;
varying vec2 vUvs;
void main() {
    vUvs = aUvs;
    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
}`;
const $01866daf3eb22cee$var$FRAG = `
#ifdef GL_FRAGMENT_PRECISION_HIGH
precision highp float;
#else
precision mediump float;
#endif
varying vec2 vUvs;
uniform sampler2D uField;
uniform sampler2D uFlow;
uniform sampler2D uRefl;
uniform vec2 uSize;
uniform vec2 uOrigin;
uniform float uTime;
uniform float uFlowPx;
uniform float uReflAmt;
uniform float uDay;
uniform vec3 uR0; uniform vec3 uR1; uniform vec3 uR2; uniform vec3 uR3; uniform vec3 uR4; uniform vec3 uDeeper;
uniform vec3 uMid; uniform vec3 uLight; uniform vec3 uFoam; uniform vec3 uSpark; uniform vec3 uReflTint;
uniform vec4 uWaders[${$01866daf3eb22cee$var$MAX_WADERS}];

float hash(vec2 p) { p = fract(p * vec2(123.34, 456.21)); p += dot(p, p + 45.32); return fract(p.x * p.y); }
float vnoise(vec2 p) {
    vec2 i = floor(p), f = fract(p); vec2 u = f * f * (3.0 - 2.0 * f);
    return mix(mix(hash(i), hash(i + vec2(1.0, 0.0)), u.x), mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), u.x), u.y);
}
// Horizontal sky-glint dashes (the LPC water's own mark), and a finer shimmer drifting on its own.
float streaks(vec2 q, float t) {
    float a = vnoise(vec2(q.x / 12.0, q.y / 1.8));
    float b = vnoise(vec2(q.x / 5.0 + 7.0, q.y / 1.4 + t * 0.35));
    return a * 0.68 + b * 0.32;
}
float ringDist(vec2 p, vec2 c, float r) {
    vec2 d = (p - c) / vec2(1.0, 0.42);
    float e = length(d);
    vec2 g = vec2(d.x, d.y / 0.42) / max(e, 0.001);
    return abs(e - r) / max(length(g), 0.001);
}
void main() {
    // Everything is evaluated at a WORLD pixel's centre; p is in world px, so neighbouring bodies agree.
    vec2 local = floor(vUvs * uSize);
    vec2 p = uOrigin + local + 0.5;
    vec2 uv = (local + 0.5) / uSize;
    vec4 F = texture2D(uField, uv);
    float inD = F.r * 255.0 / 4.0;
    if (inD < 0.5) { gl_FragColor = vec4(0.0); return; }
    float shade = F.g;
    vec4 FL = texture2D(uFlow, uv);
    vec2 flow = (FL.rg * 255.0 - 128.0) / 127.0;
    float speed = length(flow);
    float still = 1.0 - smoothstep(0.12, 0.4, speed);
    float t = uTime;

    float depth = clamp((inD - 1.0) / 20.0, 0.0, 1.0);
    float band = depth * 4.0 + (vnoise(p / 6.0 + vec2(t * 0.04, 0.0)) - 0.5) * 0.9;
    vec3 col = band < 0.55 ? uR0 : band < 1.5 ? uR1 : band < 2.5 ? uR2 : band < 3.4 ? uR3 : uR4;
    // The deeper water: a darker core whose edge drifts, dithered a pixel or two where the bottom drops away.
    float drop = FL.b + (vnoise(p / 7.0 + vec2(t * 0.03, 0.0)) - 0.5) * 0.3;
    if (drop > 0.55 || (drop > 0.45 && hash(local) > 0.5)) col = uDeeper;

    // Flow-map advection: two phases half a period apart, crossfaded with the variance kept.
    float period = 2.6;
    float ph0 = fract(t / period), ph1 = fract(t / period + 0.5);
    float w0 = 1.0 - abs(2.0 * ph0 - 1.0), w1 = 1.0 - w0;
    vec2 vel = flow * uFlowPx + vec2(1.2, 0.0) * still;
    vec2 q0 = p - vel * (ph0 * period), q1 = p - vel * (ph1 * period) + vec2(31.0, 17.0);
    float n = ((streaks(q0, t) - 0.5) * w0 + (streaks(q1, t) - 0.5) * w1) / sqrt(w0 * w0 + w1 * w1) + 0.5;
    float lift = speed * 0.05;
    if (shade < 0.5) {
        if (n > 0.86 - lift) col = uLight;
        else if (n > 0.76 - lift) col = uMid;
    } else if (n > 0.84 - lift) col = mix(col, uMid, 0.5);

    // The shore: widest at the foot of a north bank (its face is in view), all but gone under a south one.
    float facing = F.b;
    float reach = mix(0.25, 1.0, facing);
    float lap = 1.0 + 1.5 * (0.5 + 0.5 * sin(t * 1.7 + vnoise(p / 11.0) * 6.283));
    float drag = vnoise(vec2(q0.x / 5.0, q0.y / 5.0)) * w0 + vnoise(vec2(q1.x / 5.0, q1.y / 5.0)) * w1;
    float foamW = mix(0.8 + drag * 2.6, lap, still) * reach;
    float fleck = vnoise(p / 2.3 + vec2(t * 0.25, 0.0));
    if (inD < foamW) col = fleck > 0.62 && shade < 0.5 ? uFoam : uLight;
    else if (inD < foamW + 1.0 + facing) col = uMid;
    float r = fract(t / 3.4 + vnoise(p / 15.0) * 0.6);
    if (still > 0.5 && abs(inD - (2.5 + r * 6.0) * reach) < 0.55 && hash(local + floor(r * 9.0)) > 0.25 + r * 0.9) col = uMid;

    // Waders: a ring round the legs (its front shows where the clipped legs were), and rings spreading out.
    for (int i = 0; i < ${$01866daf3eb22cee$var$MAX_WADERS}; i++) {
        vec4 wd = uWaders[i];
        if (wd.w < 0.5) continue;
        float rd0 = ringDist(p, wd.xy, wd.z);
        if (rd0 < 0.75) col = p.y > wd.y ? uFoam : uLight;
        else if (rd0 < 1.6 && p.y > wd.y) col = uMid;
        for (int k = 0; k < 2; k++) {
            float rr = fract(t / 2.0 + float(k) * 0.5 + wd.w * 0.37);
            if (ringDist(p, wd.xy, wd.z + 3.0 + rr * 16.0) < 0.6 && hash(p + floor(t * 6.0)) > rr * 0.9) col = rr < 0.45 ? uLight : uMid;
        }
    }

    // Reflections: what stands over the water, wobbling a pixel row by row.
    float wob = floor(sin(p.y * 0.85 + t * 2.3) * 1.25 + 0.5);
    vec4 R = texture2D(uRefl, (local + 0.5 + vec2(wob, 0.0)) / uSize);
    if (R.a > 0.01) col = mix(col, (R.rgb / R.a) * uReflTint, uReflAmt * R.a);

    if (shade > 0.5) col *= 0.80;

    // Sun sparkles, by day: a pixel, at the peak a short dash.
    vec2 sc = floor(p / 5.0);
    float h = hash(sc * 1.7 + 3.1);
    if (uDay > 0.5 && h > 0.955 && shade < 0.5 && depth > 0.15) {
        vec2 sp = sc * 5.0 + floor(vec2(hash(sc + 1.3), hash(sc + 2.7)) * 5.0) + 0.5;
        float tw = sin(t * 2.6 + h * 90.0);
        vec2 dd = abs(p - sp);
        if (tw > 0.90 && dd.x + dd.y < 0.6) col = uSpark;
        if (tw > 0.97 && dd.y < 0.5 && dd.x < 1.6) col = uSpark;
    }
    gl_FragColor = vec4(col, 1.0);
}`;
/** LPC's own blues -- #156c99 base, #0098b2 / #00cfdf marks -- with a deeper end and a lighter shallow. */ const $01866daf3eb22cee$var$PALETTE = {
    ramp: [
        "#2a86a8",
        "#1d78a2",
        "#156c99",
        "#125f8c",
        "#0f527c"
    ],
    /** The waist-deep core: one step on down the ramp. */ deeper: "#0c4570",
    mid: "#0d93b0",
    light: "#4fd0dd",
    foam: "#c5eeea",
    spark: "#f4fffd",
    reflection: "#6f8fa0"
};
const $01866daf3eb22cee$var$rgb = (hex)=>new Float32Array([
        1,
        3,
        5
    ].map((i)=>parseInt(hex.slice(i, i + 2), 16) / 255));
const $01866daf3eb22cee$var$regionGeometry = (x, y, w, h, region)=>{
    const u0 = (x - region.x0) / region.w, v0 = (y - region.y0) / region.h;
    const u1 = (x + w - region.x0) / region.w, v1 = (y + h - region.y0) / region.h;
    return new (0, $klOfb.Geometry)().addAttribute("aVertexPosition", [
        x,
        y,
        x + w,
        y,
        x + w,
        y + h,
        x,
        y + h
    ], 2).addAttribute("aUvs", [
        u0,
        v0,
        u1,
        v0,
        u1,
        v1,
        u0,
        v1
    ], 2).addIndex([
        0,
        1,
        2,
        0,
        2,
        3
    ]);
};
const $01866daf3eb22cee$var$canvasTexture = (rgba, w, h)=>{
    if (typeof document === "undefined") return undefined;
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const context = canvas.getContext("2d");
    if (!context) return undefined;
    context.putImageData(new ImageData(rgba, w, h), 0, 0);
    return (0, $klOfb.Texture).from(canvas, {
        scaleMode: (0, $P8XPi.SCALE_MODES).NEAREST
    });
};
class $01866daf3eb22cee$export$6626238c475bccd6 extends (0, $8t5Gy.Container) {
    constructor(readGround = (0, $c176d075ea73ab2c$export$7634dfb099fa0e05)){
        super(), this.readGround = readGround, this.bodies = new Map(), this.queue = [], this.startMs = typeof performance === "undefined" ? 0 : performance.now(), this.clips = new Map(), this./** After every full map render: which bodies exist, and which changed. */ sync = (source)=>{
            const config = $01866daf3eb22cee$export$ca5952f179acb8de();
            const water = source?.getWaterLayer?.();
            if (!source || !water || !config.enabled) {
                this.source = source;
                this.clearBodies();
                this.visible = false;
                return;
            }
            if (source.roomId !== this.source?.roomId) this.clearBodies();
            this.source = source;
            this.visible = true;
            const width = source.width(), height = source.height();
            const cells = $01866daf3eb22cee$var$cellsOf(water, width, height);
            const ground = source.resolveTileMapFromLayerId("map1");
            const wanted = new Set();
            for (const found of (0, $e6afa59572fc359e$export$1e14ad071b3ff14b)(cells, width, height)){
                const cx0 = Math.max(0, found.x0 - $01866daf3eb22cee$var$BODY_MARGIN_CELLS), cy0 = Math.max(0, found.y0 - $01866daf3eb22cee$var$BODY_MARGIN_CELLS);
                const cx1 = Math.min(width - 1, found.x1 + $01866daf3eb22cee$var$BODY_MARGIN_CELLS), cy1 = Math.min(height - 1, found.y1 + $01866daf3eb22cee$var$BODY_MARGIN_CELLS);
                const key = `${cx0},${cy0},${cx1},${cy1}`;
                wanted.add(key);
                const parts = [
                    `${config.faceHeight}`
                ];
                for(let cy = cy0; cy <= cy1; cy++)for(let cx = cx0; cx <= cx1; cx++)parts.push(`${cells(cx, cy)}${ground?.[cx]?.[cy] ?? ""}`);
                const signature = parts.join(",");
                let body = this.bodies.get(key);
                if (!body) {
                    body = {
                        key: key,
                        signature: "",
                        queued: false,
                        textures: [],
                        reflected: 0,
                        region: {
                            x0: cx0 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                            y0: cy0 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                            w: (cx1 - cx0 + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                            h: (cy1 - cy0 + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                        }
                    };
                    this.bodies.set(key, body);
                }
                if (body.signature !== signature) {
                    body.signature = signature;
                    body.pending = undefined;
                    body.queued = true;
                }
            }
            this.bodies.forEach((body, key)=>{
                if (!wanted.has(key)) this.dropBody(body);
            });
            this.queue = Array.from(this.bodies.values()).filter((body)=>body.queued);
            this.publishPresence();
        }, this./**
     * Bake whatever is waiting -- ONE stage a frame (read the ground; the shore; the bank; the art), so a
     * budget machine never stalls on a whole pond at once -- and move the time on. An atlas still decoding
     * leaves the first stage for the next frame.
     */ tick = ()=>{
            if (!this.source) return;
            const body = this.queue[0];
            if (body) {
                const config = $01866daf3eb22cee$export$ca5952f179acb8de();
                const { region: region } = body;
                const cells = $01866daf3eb22cee$var$cellsOf(this.source.getWaterLayer?.(), this.source.width(), this.source.height());
                if (!body.pending) {
                    const ground = this.readGround(this.source, region.x0, region.y0, region.w, region.h);
                    if (ground) body.pending = {
                        ground: ground
                    };
                } else if (!body.pending.field) body.pending.field = (0, $e6afa59572fc359e$export$21bd7a34e9ae9a60)(cells, region, config.faceHeight);
                else if (!body.pending.bank) body.pending.bank = (0, $e6afa59572fc359e$export$33e21c0888957a6f)(body.pending.ground, body.pending.field.mask, region, config.faceHeight);
                else {
                    this.queue.shift();
                    body.queued = false;
                    this.bake(body, body.pending.ground, body.pending.field, body.pending.bank);
                    body.pending = undefined;
                    this.publishPresence();
                }
            }
            const now = (typeof performance === "undefined" ? 0 : performance.now()) - this.startMs;
            // Wrapped, so a long session never runs the shader's time past what a mediump float can hold.
            this.bodies.forEach((body)=>{
                if (body.uniforms) body.uniforms.uTime = now / 1000 % 600;
            });
        }, this./** px of water over the ground at a world point, or undefined on dry land (or before the bake). */ depthAt = (px, py)=>this.wadeAt(px, py)?.depth, this./**
     * How a body standing at a world point wades: `depth` px from the shore, `deeper` 0..1 into the
     * waist-deep core, and `sink`, how far up its body the waterline comes. Undefined on dry land.
     */ wadeAt = (px, py, waist = $01866daf3eb22cee$export$ca5952f179acb8de().waist)=>{
            for (const body of this.bodies.values()){
                const { x0: x0, y0: y0, w: w, h: h } = body.region;
                const x = Math.floor(px - x0), y = Math.floor(py - y0);
                if (!body.field || x < 0 || y < 0 || x >= w || y >= h) continue;
                const i = y * w + x;
                if (!body.field.mask[i]) return undefined;
                const depth = body.field.depth[i], deeper = body.field.deeper[i];
                const knee = Math.max(2, Math.min($01866daf3eb22cee$var$KNEE_SUBMERSION, depth * 0.55));
                return {
                    depth: depth,
                    deeper: deeper,
                    sink: Math.round(knee + (Math.max(knee, waist) - knee) * deeper)
                };
            }
            return undefined;
        }, this./**
     * Once a frame, after the bodies are laid out: who wades, and what reflects. `surface` is the world
     * surface the bodies stand in; `daylight` 0..1 turns the sun's sparkles off after dark.
     */ update = (contacts, surface, renderer, daylight = 1)=>{
            const wading = new Set();
            const config = $01866daf3eb22cee$export$ca5952f179acb8de();
            this.bodies.forEach((body)=>{
                if (!body.uniforms || !body.mesh) return;
                body.uniforms.uReflAmt = config.reflection;
                body.uniforms.uDay = daylight;
                const waders = [];
                const reflect = [];
                const { x0: x0, y0: y0, w: w, h: h } = body.region;
                for (const contact of contacts){
                    if (contact.x < x0 || contact.x >= x0 + w || contact.y < y0 - $01866daf3eb22cee$var$REFLECT_REACH || contact.y >= y0 + h) continue;
                    const wade = this.wadeAt(contact.x, contact.y, config.waist);
                    if (wade && waders.length < $01866daf3eb22cee$var$MAX_WADERS) {
                        const line = Math.round(contact.y) - wade.sink;
                        waders.push({
                            contact: contact,
                            line: line,
                            ring: $01866daf3eb22cee$var$RING_RADIUS + $01866daf3eb22cee$var$WAIST_RING_GROWTH * wade.deeper
                        });
                        wading.add(contact.id);
                        this.clipAt(contact, line);
                        if (contact.art) reflect.push({
                            art: contact.art,
                            mirror: line
                        });
                    } else if (!wade && contact.art && this.waterBelow(contact.x, contact.y)) reflect.push({
                        art: contact.art,
                        mirror: Math.round(contact.y) + config.faceHeight
                    });
                }
                const list = body.uniforms.uWaders;
                list.fill(0);
                waders.forEach(({ contact: contact, line: line, ring: ring }, i)=>list.set([
                        Math.round(contact.x),
                        line + 0.5,
                        ring,
                        1 + i
                    ], i * 4));
                if (renderer) this.renderReflections(body, reflect, waders, surface, renderer);
            });
            this.clips.forEach((_, id)=>{
                if (!wading.has(id)) this.releaseClip(id);
            });
            return wading;
        }, this.waterBelow = (x, y)=>{
            for(let k = 4; k <= 64; k += 6)if (this.depthAt(x, y + k) !== undefined) return true;
            return false;
        }, this.clipAt = (contact, line)=>{
            const body = contact.body;
            if (!body || body.destroyed) return;
            let entry = this.clips.get(contact.id);
            if (entry && (entry.body !== body || entry.clip.destroyed)) {
                this.releaseClip(contact.id);
                entry = undefined;
            }
            if (!entry) {
                // Something else is clipping this body already (a stair's opening): leave it be.
                if (body.mask) return;
                const clip = new (0, $gwPoJ.Graphics)();
                clip.name = "water-clip";
                body.addChild(clip);
                body.mask = clip;
                entry = {
                    body: body,
                    clip: clip,
                    line: NaN
                };
                this.clips.set(contact.id, entry);
            }
            const local = (line - body.y) / (body.scale.y || 1);
            if (entry.line === local) return;
            entry.clip.clear().beginFill(0xffffff).drawRect(-96, local - 256, 192, 256).endFill();
            entry.line = local;
        }, this.releaseClip = (id)=>{
            const entry = this.clips.get(id);
            if (!entry) return;
            if (!entry.body.destroyed && entry.body.mask === entry.clip) entry.body.mask = null;
            if (!entry.clip.destroyed) entry.clip.destroy();
            this.clips.delete(id);
        }, this.renderReflections = (body, reflect, waders, surface, renderer)=>{
            if (!body.reflection || !body.reflectionBase) return;
            if (!reflect.length && !body.reflected) return;
            const { x0: x0, y0: y0 } = body.region;
            renderer.render(body.reflectionBase, {
                renderTexture: body.reflection,
                clear: true
            });
            const inverse = surface.worldTransform.clone().invert();
            for (const { art: art, mirror: mirror } of reflect){
                if (!art.worldVisible || art.destroyed) continue;
                // world (the surface's space) -> flipped about the waterline -> the reflection texture's pixels
                const flip = new (0, $6qzqq.Matrix)(1, 0, 0, -1, -x0, 2 * mirror - y0);
                renderer.render(art, {
                    renderTexture: body.reflection,
                    clear: false,
                    skipUpdateTransform: true,
                    transform: flip.append(inverse)
                });
            }
            // A wader's legs, flipped, land ABOVE its waterline: rub them out -- the water reflects only what is above it.
            if (waders.length) {
                const eraser = this.eraser ??= Object.assign(new (0, $gwPoJ.Graphics)(), {
                    blendMode: (0, $P8XPi.BLEND_MODES).ERASE
                });
                eraser.clear().beginFill(0xffffff);
                waders.forEach(({ contact: contact, line: line })=>eraser.drawRect(Math.round(contact.x) - x0 - 24, line - y0 - 64, 48, 64));
                eraser.endFill();
                renderer.render(eraser, {
                    renderTexture: body.reflection,
                    clear: false
                });
            }
            // The bank goes over the bodies again: it stands between them and the water.
            if (reflect.length) renderer.render(body.reflectionBase, {
                renderTexture: body.reflection,
                clear: false
            });
            body.reflected = reflect.length;
        }, this.bake = (body, ground, field, bank)=>{
            this.releaseArt(body);
            const config = $01866daf3eb22cee$export$ca5952f179acb8de();
            const { region: region } = body;
            body.field = field;
            const reflection = (0, $e6afa59572fc359e$export$9798d608fa5aa8c5)(ground, bank, field.mask, region, config.faceHeight);
            const options = {
                width: region.w,
                height: region.h,
                scaleMode: (0, $P8XPi.SCALE_MODES).NEAREST
            };
            const fieldTexture = (0, $klOfb.Texture).fromBuffer(field.field, region.w, region.h, options);
            const flowTexture = (0, $klOfb.Texture).fromBuffer(field.flow, region.w, region.h, options);
            body.textures.push(fieldTexture, flowTexture);
            body.reflection = (0, $klOfb.RenderTexture).create({
                width: region.w,
                height: region.h,
                scaleMode: (0, $P8XPi.SCALE_MODES).NEAREST
            });
            const reflectionTexture = $01866daf3eb22cee$var$canvasTexture(reflection, region.w, region.h);
            if (reflectionTexture) body.textures.push(reflectionTexture);
            body.reflectionBase = new (0, $7Bs2Z.Sprite)(reflectionTexture ?? (0, $klOfb.Texture).EMPTY);
            body.uniforms = {
                uField: fieldTexture,
                uFlow: flowTexture,
                uRefl: body.reflection,
                uSize: new Float32Array([
                    region.w,
                    region.h
                ]),
                uOrigin: new Float32Array([
                    region.x0,
                    region.y0
                ]),
                uTime: 0,
                uFlowPx: 16,
                uReflAmt: config.reflection,
                uDay: 1,
                uR0: $01866daf3eb22cee$var$rgb($01866daf3eb22cee$var$PALETTE.ramp[0]),
                uR1: $01866daf3eb22cee$var$rgb($01866daf3eb22cee$var$PALETTE.ramp[1]),
                uR2: $01866daf3eb22cee$var$rgb($01866daf3eb22cee$var$PALETTE.ramp[2]),
                uR3: $01866daf3eb22cee$var$rgb($01866daf3eb22cee$var$PALETTE.ramp[3]),
                uR4: $01866daf3eb22cee$var$rgb($01866daf3eb22cee$var$PALETTE.ramp[4]),
                uDeeper: $01866daf3eb22cee$var$rgb($01866daf3eb22cee$var$PALETTE.deeper),
                uMid: $01866daf3eb22cee$var$rgb($01866daf3eb22cee$var$PALETTE.mid),
                uLight: $01866daf3eb22cee$var$rgb($01866daf3eb22cee$var$PALETTE.light),
                uFoam: $01866daf3eb22cee$var$rgb($01866daf3eb22cee$var$PALETTE.foam),
                uSpark: $01866daf3eb22cee$var$rgb($01866daf3eb22cee$var$PALETTE.spark),
                uReflTint: $01866daf3eb22cee$var$rgb($01866daf3eb22cee$var$PALETTE.reflection),
                uWaders: new Float32Array($01866daf3eb22cee$var$MAX_WADERS * 4)
            };
            body.mesh = new (0, $9Tsx3.Mesh)($01866daf3eb22cee$var$regionGeometry(region.x0, region.y0, region.w, region.h, region), (0, $klOfb.Shader).from($01866daf3eb22cee$var$VERT, $01866daf3eb22cee$var$FRAG, body.uniforms));
            body.mesh.name = "water";
            this.addChild(body.mesh);
            const bankTexture = $01866daf3eb22cee$var$canvasTexture(bank, region.w, region.h);
            if (bankTexture) {
                body.textures.push(bankTexture);
                body.bank = new (0, $7Bs2Z.Sprite)(bankTexture);
                body.bank.position.set(region.x0, region.y0);
                this.addChild(body.bank);
            }
            body.reflected = 1 // draw the bank's reflection on the first update
            ;
        }, this.isWater = (px, py)=>{
            for (const body of this.bodies.values()){
                const { x0: x0, y0: y0, w: w, h: h } = body.region;
                const x = Math.floor(px - x0), y = Math.floor(py - y0);
                if (x < 0 || y < 0 || x >= w || y >= h) continue;
                if (body.field) return body.field.mask[y * w + x] === 1;
                const water = this.source?.getWaterLayer?.();
                return !!this.source && $01866daf3eb22cee$var$cellsOf(water, this.source.width(), this.source.height())(Math.floor(px / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), Math.floor(py / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243))) > 0;
            }
            return false;
        }, this.publishPresence = ()=>{
            const roomId = this.source?.roomId;
            if (!roomId) return;
            (0, $3895eb5d0ddb7972$export$258bb248e3fac37b)(roomId, this.bodies.size ? this.isWater : undefined);
        }, this.releaseArt = (body)=>{
            body.mesh?.destroy();
            body.bank?.destroy();
            body.reflectionBase?.destroy();
            body.reflection?.destroy(true);
            body.textures.forEach((texture)=>texture.destroy(true));
            body.mesh = body.bank = body.reflectionBase = body.reflection = body.uniforms = undefined;
            body.textures = [];
            body.field = undefined;
        }, this.dropBody = (body)=>{
            this.releaseArt(body);
            body.queued = false;
            body.pending = undefined;
            this.bodies.delete(body.key);
            this.queue = this.queue.filter((waiting)=>waiting !== body);
        }, this.clearBodies = ()=>{
            this.bodies.forEach((body)=>this.releaseArt(body));
            this.bodies.clear();
            this.queue = [];
            if (this.source?.roomId) (0, $3895eb5d0ddb7972$export$258bb248e3fac37b)(this.source.roomId, undefined);
        };
        this.interactiveChildren = false;
    }
    /** True while bodies are still waiting to bake. */ get baking() {
        return this.queue.length > 0;
    }
    destroy(options) {
        Array.from(this.clips.keys()).forEach(this.releaseClip);
        this.eraser?.destroy();
        this.clearBodies();
        super.destroy(options);
    }
}
const $01866daf3eb22cee$var$cellsOf = (water, width, height)=>(x, y)=>{
        if (!water || x < 0 || y < 0 || x >= width || y >= height) return 0;
        const v = water[x]?.[y];
        return v && v !== "0" ? Number(v) || 1 : 0;
    };








parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $6qzqq = parcelRequire("6qzqq");
var $7Bs2Z = parcelRequire("7Bs2Z");

const $5b10e7700721e8ad$export$7b6e5bf2acd80cf9 = 2;
const $5b10e7700721e8ad$export$c3fa529f6dadb7d0 = (line, height)=>[
        line - $5b10e7700721e8ad$export$7b6e5bf2acd80cf9,
        line + $5b10e7700721e8ad$export$7b6e5bf2acd80cf9
    ].map((top)=>Math.max(0, Math.min(height - 1, Math.round(top))));
class $5b10e7700721e8ad$export$3c8fc0805a00d47e {
    /** `line`: the art's row (from its texture's top) where the shade ends; undefined when its art can't be cut. */ static create(art, line, owned) {
        const texture = art.texture;
        if (!texture?.valid || texture.trim || texture.rotate) return undefined;
        return new $5b10e7700721e8ad$export$3c8fc0805a00d47e(art, line, owned);
    }
    constructor(art, line, owned){
        this.art = art;
        this.line = line;
        this.owned = owned;
        this.source = art.texture;
        this.bands = $5b10e7700721e8ad$export$c3fa529f6dadb7d0(line, this.source.frame.height).map((top)=>{
            const texture = this.cut(top);
            return {
                sprite: $5b10e7700721e8ad$export$3c8fc0805a00d47e.band(texture),
                texture: texture,
                top: top
            };
        });
    }
    /** The art from row `top` down. */ cut(top) {
        const { frame: frame, baseTexture: baseTexture } = this.source;
        return new (0, $klOfb.Texture)(baseTexture, new (0, $6qzqq.Rectangle)(frame.x, frame.y + top, frame.width, frame.height - top));
    }
    static band(texture) {
        const sprite = new (0, $7Bs2Z.Sprite)(texture);
        sprite.visible = false;
        return sprite;
    }
    /** The bands as they stand: a map's surface hands them on with its art (MapRenderingManager.ownedArt). */ displayObjects() {
        return this.bands.map((band)=>band.sprite).filter((sprite)=>!sprite.destroyed);
    }
    /** Shown at `strength` (0: not at all, 1: the shade's full darkening), tinted `color`, where the art is now. */ sync(strength, color) {
        const art = this.art;
        const live = strength > 0 && !art.destroyed && !!art.parent && art.texture === this.source && this.owned();
        const n = this.bands.length;
        this.bands.forEach((band, i)=>{
            // A container destroyed with its children took the band along: every later frame
            // would throw adding it back, so lay a new one.
            if (band.sprite.destroyed) {
                if (!live) return;
                if (!band.texture.valid) band.texture = this.cut(band.top);
                band.sprite = $5b10e7700721e8ad$export$3c8fc0805a00d47e.band(band.texture);
            }
            const { sprite: sprite, top: top } = band;
            sprite.visible = live && art.visible && art.renderable;
            if (!sprite.visible) return;
            if (sprite.parent !== art.parent) art.parent.addChild(sprite);
            const z = art.zIndex + 0.01;
            // A zIndex write re-sorts the whole surface: only on a change.
            if (sprite.zIndex !== z) sprite.zIndex = z;
            const height = this.source.frame.height;
            sprite.anchor.set(art.anchor.x, (art.anchor.y * height - top) / (height - top));
            sprite.position.copyFrom(art.position);
            sprite.scale.copyFrom(art.scale);
            sprite.skew.copyFrom(art.skew);
            sprite.pivot.copyFrom(art.pivot);
            sprite.rotation = art.rotation;
            sprite.alpha = art.alpha;
            const tint = (0, $a1ff1a141ce12c85$export$4680da062056e5ae)(0xffffff, Math.min(1, strength) * (i + 1) / n, color);
            if (sprite.tint !== tint) sprite.tint = tint;
        });
    }
    /** Whether this is the shade of `art` as it is now, ending at `line`. */ isFor(art, line) {
        return this.art === art && this.line === line && art.texture === this.source;
    }
    destroy() {
        for (const { sprite: sprite, texture: texture } of this.bands){
            if (!sprite.destroyed) {
                sprite.parent?.removeChild(sprite);
                sprite.destroy();
            }
            texture.destroy(false);
        }
    }
}


/**
 * The sun's shadows of a storey's furniture -- what players build on the floor (`sprite2`: tables,
 * stools, chests, barrels, sacks, beds standing up, doors) -- for MapRenderingManager to draw and publish
 * with the rest (foliage_shadow.ts). Furniture is drawn a cell at a time, so each cell's own art casts:
 * stood up from the bottom row of its piece and sheared along the sun, a pixel moved as far as it stands
 * above that row, like an upright entity tile (foliage_shadow_geometry.ts uprightShadowParts).
 */ 



/** Pieces that lie in or on the floor, or are drawn by their own sprites: no upright shadow. */ const $0dd042549bc41733$var$FLAT = new Set([
    "stairs-up",
    "stairs-down",
    "floor-opening",
    "hatch-wood"
]);
const $0dd042549bc41733$export$10aded4afe862f4e = (provider)=>{
    const pieces = new Map();
    provider.resolveTileMapFromLayerId("sprite2")?.forEach((column, x)=>column?.forEach((tile, y)=>{
            if (!tile || tile === "0" || provider.isHiddenTile(tile)) return;
            if ($0dd042549bc41733$var$FLAT.has(provider.resolveTileMeta(tile)?.entityTileId)) return;
            if (!provider.shouldDrawTileAt(x, y, "sprite2", provider.resolveTileMapFromLayerId("sprite2"))) return;
            const parent = provider.getMapDeltaAt(x, y, "sprite2")?.context?.parent ?? {
                x: x,
                y: y
            };
            const key = `${parent.x},${parent.y}`;
            const piece = pieces.get(key) ?? {
                parent: {
                    x: parent.x,
                    y: parent.y
                },
                cells: [],
                left: x,
                top: y,
                right: x,
                bottom: y
            };
            piece.cells.push({
                x: x,
                y: y,
                tile: tile
            });
            piece.left = Math.min(piece.left, x);
            piece.right = Math.max(piece.right, x);
            piece.top = Math.min(piece.top, y);
            piece.bottom = Math.max(piece.bottom, y);
            pieces.set(key, piece);
        }));
    return [
        ...pieces.values()
    ];
};
// One silhouette per tile art and content generation (a Lab publish can repaint it).
const $0dd042549bc41733$var$silhouettes = new Map();
let $0dd042549bc41733$var$artGeneration = -1;
const $0dd042549bc41733$var$cellArt = (provider, tile)=>{
    const generation = (0, $1f08f7b8f85adf9e$export$dd4554ad7431ed50)();
    if (generation !== $0dd042549bc41733$var$artGeneration) {
        $0dd042549bc41733$var$silhouettes.clear();
        $0dd042549bc41733$var$artGeneration = generation;
    }
    const tileset = provider.resolveTileSet(tile);
    if (!tileset) return null;
    const id = `${tileset.tilesetId}:${Number(tile) - tileset.firstGid}`;
    if ($0dd042549bc41733$var$silhouettes.has(id)) return $0dd042549bc41733$var$silhouettes.get(id);
    const pixels = (0, $94eed483b855593a$export$84bb4db9803ba90d)(tileset.tilesetId, tileset.width, [
        {
            tileNumber: Number(tile) - tileset.firstGid + 1
        }
    ]);
    if (!pixels) return undefined;
    const art = (0, $7fbbd538ea219bbf$export$8bb3f4c5879e064)(id, pixels.data, pixels.width, pixels.height);
    $0dd042549bc41733$var$silhouettes.set(id, art.rows.length ? art : null);
    return $0dd042549bc41733$var$silhouettes.get(id);
};
const $0dd042549bc41733$export$ed46199a19bb75d = (provider, sun, indoors = ()=>false)=>{
    const stamps = [], feet = [];
    let pending = false;
    for (const piece of $0dd042549bc41733$export$10aded4afe862f4e(provider)){
        const arts = piece.cells.map((cell)=>({
                ...cell,
                art: $0dd042549bc41733$var$cellArt(provider, cell.tile)
            }));
        if (arts.some((cell)=>cell.art === undefined)) {
            pending = true;
            continue;
        }
        const drawn = arts.filter((cell)=>cell.art);
        if (!drawn.length) continue;
        // The piece stands where its art ends: the lowest drawn row of any of its cells (a cell's art can
        // stop short of the cell's bottom edge, and a shadow from that edge hung below the legs).
        const base = Math.max(...drawn.map(({ y: y, art: art })=>y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + art.rows[art.rows.length - 1].y + 1));
        const x0 = piece.left * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + 3, x1 = (piece.right + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 3, cy = base - 3;
        feet.push([
            x0,
            cy - 3,
            x1,
            cy - 3,
            x1,
            cy + 3,
            x0,
            cy + 3
        ]);
        if (indoors(piece.parent.x, piece.parent.y)) continue;
        for (const { x: x, y: y, art: art } of drawn){
            const top = art.rows[0].y, bottom = art.rows[art.rows.length - 1].y + 1;
            const lift = base - (y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + top);
            stamps.push({
                art: art,
                y: top,
                height: bottom - top,
                matrix: [
                    1,
                    0,
                    -sun.x,
                    -sun.y,
                    x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + sun.x * lift,
                    base + sun.y * lift
                ]
            });
        }
    }
    return {
        stamps: stamps,
        feet: feet,
        pending: pending
    };
};


/**
 * The sun's shadows of a storey's entity tiles (every composite: trees, bushes, boulders, barrels,
 * statues, tents...), for MapRenderingManager to draw and publish with its buildings' shadows: one union,
 * one strength, one softness, and the same shade on the bodies standing in it (building_shade.ts). The
 * shapes are foliage_shadow_geometry.ts's, chosen per tile by tileShadowModel: plants marked
 * `castsShadow` (the procedural grove) cast crown and trunk, other upright art its standing silhouette;
 * grass, flat art and art that bakes its own ground shadow (the older LPC trees and bushes) cast nothing.
 * Every caster also gives its foot, for contact shade.
 */ 



const $5e8d3400ffcaf54d$export$44b73c9c83559d98 = {
    enabled: true,
    depth: 0.5,
    silhouettes: true,
    grass: 0.5
};
const $5e8d3400ffcaf54d$export$af4bed2901273a93 = ()=>{
    if (typeof window === "undefined") return $5e8d3400ffcaf54d$export$44b73c9c83559d98;
    const w = window;
    if (w.foliageShadow === undefined) w.foliageShadow = $5e8d3400ffcaf54d$export$44b73c9c83559d98;
    const live = w.foliageShadow;
    if (live === false) return {
        ...$5e8d3400ffcaf54d$export$44b73c9c83559d98,
        enabled: false
    };
    return live && typeof live === "object" ? live : $5e8d3400ffcaf54d$export$44b73c9c83559d98;
};
// Read once per composite and content generation (a Lab publish can repaint the art).
const $5e8d3400ffcaf54d$var$silhouettes = new Map();
const $5e8d3400ffcaf54d$var$models = new Map();
const $5e8d3400ffcaf54d$var$shapes = new Map();
let $5e8d3400ffcaf54d$var$artGeneration = -1;
const $5e8d3400ffcaf54d$var$plantShape = (caster, options, grassStrength)=>{
    const generation = (0, $1f08f7b8f85adf9e$export$dd4554ad7431ed50)();
    if (generation !== $5e8d3400ffcaf54d$var$artGeneration) {
        $5e8d3400ffcaf54d$var$silhouettes.clear();
        $5e8d3400ffcaf54d$var$models.clear();
        $5e8d3400ffcaf54d$var$shapes.clear();
        $5e8d3400ffcaf54d$var$artGeneration = generation;
    }
    const plant = `${caster.tilesetId}:${caster.meta.tileMeta.compositeTileId}`;
    const key = `${plant}|${options.sun.x}:${options.sun.y}:${options.depth}:${options.silhouettes !== false}:${grassStrength}`;
    const known = $5e8d3400ffcaf54d$var$shapes.get(key);
    if (known) return known;
    let art = $5e8d3400ffcaf54d$var$silhouettes.get(plant);
    if (!art) {
        const pixels = (0, $94eed483b855593a$export$84bb4db9803ba90d)(caster.tilesetId, caster.columns, caster.meta.children || []);
        if (!pixels) return undefined;
        art = (0, $7fbbd538ea219bbf$export$8bb3f4c5879e064)(plant, pixels.data, pixels.width, pixels.height);
        $5e8d3400ffcaf54d$var$silhouettes.set(plant, art);
        $5e8d3400ffcaf54d$var$models.set(plant, (0, $7fbbd538ea219bbf$export$eae896c538d79207)(caster.meta.tileMeta, pixels.data, pixels.width, pixels.height));
    }
    const model = $5e8d3400ffcaf54d$var$models.get(plant);
    const shape = model === "foliage" ? (0, $7fbbd538ea219bbf$export$962eb871c0a044e7)(art, options) : model === "upright" ? (0, $7fbbd538ea219bbf$export$88cc5f0e18e22720)(art, options) : model === "grass" && grassStrength > 0 ? (0, $7fbbd538ea219bbf$export$88cc5f0e18e22720)(art, options, grassStrength) : {
        polygons: [],
        stamps: []
    };
    $5e8d3400ffcaf54d$var$shapes.set(key, shape);
    return shape;
};
const $5e8d3400ffcaf54d$export$3373223240634c37 = (tilesetId, compositeTileId)=>{
    const model = $5e8d3400ffcaf54d$var$models.get(`${tilesetId}:${compositeTileId}`);
    return model === undefined ? undefined : model === "foliage" || model === "upright";
};
const $5e8d3400ffcaf54d$export$ea55fd34f8e4f96e = (provider, options, denseLifts)=>{
    const polygons = [];
    const stamps = [];
    const grass = [];
    const feet = [];
    const grassStrength = options.grass ?? $5e8d3400ffcaf54d$export$44b73c9c83559d98.grass;
    let pending = false;
    // Tile ids repeat across a forest: resolve each once.
    const casters = new Map();
    const casterFor = (tile)=>{
        let caster = casters.get(tile);
        if (caster !== undefined) return caster;
        caster = null;
        const meta = provider.resolveTileMeta(tile);
        const tileset = meta?.compositeTileParent && meta.compositeTileId ? provider.resolveTileSet(tile) : undefined;
        const composite = tileset && provider.resolveCompositeTileIdTileMeta(meta.compositeTileId, tileset.tilesetId);
        if (composite) {
            const columns = tileset.width;
            const cells = (composite.children || []).map((child)=>child.tileNumber - 1);
            const xs = cells.map((cell)=>cell % columns), ys = cells.map((cell)=>Math.floor(cell / columns));
            const parentRow = Math.floor((composite.tileNumber - 1) / columns);
            caster = {
                meta: composite,
                tilesetId: tileset.tilesetId,
                columns: columns,
                width: Math.max(...xs) - Math.min(...xs) + 1,
                height: Math.max(...ys) - Math.min(...ys) + 1,
                dropRow: Math.max(...ys.map((row)=>Math.abs(row - parentRow))) > 1
            };
        }
        casters.set(tile, caster);
        return caster;
    };
    provider.visit(({ tilemap: tilemap, layerId: layerId, sky: sky })=>{
        if (!tilemap || sky) return;
        tilemap.forEach((column, x)=>column?.forEach((tile, y)=>{
                if (!tile || tile === "0") return;
                const caster = casterFor(tile);
                if (!caster || !provider.shouldDrawTileAt(x, y, layerId, tilemap)) return;
                const shape = $5e8d3400ffcaf54d$var$plantShape(caster, options, grassStrength);
                if (!shape) {
                    pending = true;
                    return;
                }
                if (!shape.polygons.length && !shape.stamps.length) return;
                const at = (0, $3e205d6c633194c2$export$8b3ab97ac444fb53)(caster.meta, caster, x, y);
                shape.polygons.forEach((polygon)=>polygons.push((0, $7fbbd538ea219bbf$export$bf389ed589e3a7f3)(polygon, at.x, at.y)));
                if (caster.meta.tileMeta.tileTypes?.includes("denseVertical")) {
                    // Long grass is drawn as copies, each lifted its own few pixels: a shadow per copy, from its foot.
                    const lifts = denseLifts?.(tile, caster.meta.tileMeta, x, y) ?? [
                        0
                    ];
                    const drop = caster.dropRow ? 32 : 0;
                    lifts.forEach((lift)=>shape.stamps.forEach((stamp)=>(stamp.strength !== undefined ? grass : stamps).push((0, $7fbbd538ea219bbf$export$61467af1a154b2d9)(stamp, at.x, at.y + drop - lift))));
                } else shape.stamps.forEach((stamp)=>(stamp.strength !== undefined ? grass : stamps).push((0, $7fbbd538ea219bbf$export$61467af1a154b2d9)(stamp, at.x, at.y)));
                if (shape.foot?.length) feet.push((0, $7fbbd538ea219bbf$export$bf389ed589e3a7f3)(shape.foot, at.x, at.y));
            }));
    });
    return {
        polygons: polygons,
        stamps: stamps,
        grass: grass,
        feet: feet,
        pending: pending
    };
};








// Visible bounds of the wooden roof autotiles in fence_medieval (32px atlas cells).
// Edge artwork has transparent margins; those pixels cannot support the next storey.
const $b115d5752cc44167$var$roofBounds = {
    448: [
        4,
        7,
        32,
        32
    ],
    449: [
        0,
        7,
        32,
        32
    ],
    450: [
        0,
        7,
        28,
        32
    ],
    451: [
        4,
        7,
        32,
        32
    ],
    452: [
        0,
        7,
        32,
        27
    ],
    453: [
        0,
        7,
        28,
        32
    ],
    454: [
        0,
        7,
        28,
        27
    ],
    455: [
        4,
        7,
        32,
        27
    ],
    464: [
        5,
        0,
        32,
        32
    ],
    465: [
        0,
        0,
        32,
        32
    ],
    466: [
        0,
        0,
        27,
        32
    ],
    467: [
        5,
        0,
        29,
        32
    ],
    468: [
        4,
        6,
        26,
        25
    ],
    469: [
        3,
        0,
        27,
        23
    ],
    480: [
        4,
        0,
        32,
        25
    ],
    481: [
        0,
        0,
        32,
        25
    ],
    482: [
        0,
        0,
        28,
        25
    ],
    483: [
        4,
        0,
        32,
        25
    ],
    484: [
        0,
        0,
        28,
        25
    ],
    485: [
        3,
        9,
        27,
        32
    ]
};
const $b115d5752cc44167$export$84a3581bcc892863 = 12;
const $b115d5752cc44167$export$34d697321b2dd5d4 = (tilesetId, position)=>(tilesetId === "fence_medieval" ? $b115d5752cc44167$var$roofBounds[position] : undefined) ?? [
        0,
        0,
        32,
        32
    ];
const $b115d5752cc44167$export$9af9cf624f627c69 = (tilesetId, position, exposed)=>{
    const bounds = $b115d5752cc44167$export$34d697321b2dd5d4(tilesetId, position);
    let [left, top, right, bottom] = bounds;
    // Inset only the visible outline. Interior joins remain continuous.
    if (left > 0 || exposed.left) left += $b115d5752cc44167$export$84a3581bcc892863;
    if (top > 0 || exposed.top) top += $b115d5752cc44167$export$84a3581bcc892863;
    if (right < 32 || exposed.right) right -= $b115d5752cc44167$export$84a3581bcc892863;
    if (bottom < 32 || exposed.bottom) bottom -= $b115d5752cc44167$export$84a3581bcc892863;
    const rects = [];
    if (left) rects.push({
        x: 0,
        y: 0,
        width: left,
        height: 32,
        groundSupport: true
    });
    if (right < 32) rects.push({
        x: right,
        y: 0,
        width: 32 - right,
        height: 32,
        groundSupport: true
    });
    if (top) rects.push({
        x: 0,
        y: 0,
        width: 32,
        height: top,
        groundSupport: true
    });
    if (bottom < 32) rects.push({
        x: 0,
        y: bottom,
        width: 32,
        height: 32 - bottom,
        groundSupport: true
    });
    return rects;
};




const $2911f2fc3a73440b$export$910413b1c7659f34 = (sprite, at, type, exit)=>{
    if (type !== "stairs-up" && type !== "stairs-down") return;
    const dx = exit ? exit.x - (at.x + .5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) : 0;
    const dy = exit ? exit.y - (at.y + .5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) : 0;
    const horizontal = Math.abs(dx) >= Math.abs(dy);
    const left = horizontal && dx < 0;
    const flip = !!exit && type === "stairs-up" !== left;
    const width = sprite.texture?.orig.width ?? (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const height = sprite.texture?.orig.height ?? (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const sx = flip ? -1 : 1;
    sprite.scale.set(sx, 1);
    sprite.rotation = 0;
    // Larger flights extend above the cell, with their base centered on its floor.
    sprite.x = at.x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + ((0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - width) / 2 + (flip ? width : 0);
    sprite.y = at.y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - height;
};




const $718a35436683a80f$export$33f4909808e4f90c = (cells, width, height, roomId)=>{
    const blank = ()=>(0, $a80d0b17b615d6f7$export$4fece460db87ee7b)(width, height);
    const roof = blank();
    cells.forEach(({ x: x, y: y })=>{
        roof[y][x] = {
            itemType: "roof-wood"
        };
    });
    const builder = new (0, $d9b505386b42bf36$export$374d003f514472fe)({}, {
        blockingTileSpec: {
            tilePos: 121,
            tilesetId: "lpc-terrain"
        },
        house: blank(),
        roof: roof,
        entity: blank(),
        floor: blank(),
        floor2: blank(),
        decor: blank()
    });
    builder.build(roomId);
    return builder.featureSpec.mapEntries.filter((entry)=>entry.layerId === "sky" || entry.layerId === "skyTrigger");
};








/** The widest doorway a lintel spans: the most cells the storey above may wall over (the server's GATEWAY_SPAN). */ const $409e08612bd4cd6f$var$LINTEL_SPAN = 3;
/**
 * Move many children into one container. Container.removeChild finds each child with indexOf and
 * splices it out, so moving a floor's few thousand sprites one at a time is quadratic: a hitch of
 * its own. Each old parent is filtered once instead.
 */ const $409e08612bd4cd6f$var$moveChildren = (children, to)=>{
    const byParent = new Map();
    for (const child of children){
        if (!child.parent || child.parent === to) continue;
        let moving = byParent.get(child.parent);
        if (!moving) byParent.set(child.parent, moving = new Set());
        moving.add(child);
    }
    byParent.forEach((moving, parent)=>{
        const kept = parent.children.filter((child)=>!moving.has(child));
        parent.children.length = 0;
        for (const child of kept)parent.children.push(child);
        moving.forEach((child)=>{
            child.parent = null;
            to.addChild(child);
        });
        parent._boundsID++;
        parent.onChildrenChange(0);
    });
};
/** A stack's wall-trim signature (MapRenderingManager.wallTrimSignature), by its bottom storey, shared by its storeys' maps. */ const $409e08612bd4cd6f$var$stackTrimSignatures = new WeakMap();
class $409e08612bd4cd6f$export$ac241b7c41940a17 {
    constructor(surface, skySurface, miniMapSurface, worldOverlaySurface, logic, features = (0, $1704411fa88dc9bf$export$e5daf445bbba1e2f)){
        this.features = features;
        this.ownedGhosts = new Set();
        this.landingDust = new (0, $dd2f604be1eac3c5$export$ef42757986f4090e)(()=>this.surface);
        this.landingOverlays = new Map();
        this.settledLandings = new WeakSet();
        this.lavaTileFade = new (0, $4c4cb0e826badbe1$export$9f1d2d356a00ec8)();
        this.lavaFadeSurfaces = new Map();
        this.needsRender = false;
        this.compositeTileSpriteTextures = new Map();
        this.spritedCellSprites = new Map();
        this.spritedLayerIds = new Set();
        this.occluderFade = new (0, $75a0a4fb75fb6456$export$ffb41811f55797a3)();
        this.spritedCellSurfaceId = new Map();
        this.dirtyCells = new Set();
        this.pendingRedraw = false;
        this.dirtyNeedsFull = false;
        this.surfaceObjectsByKey = new Map();
        this.spriteOcclusionBounds = new (0, $6qzqq.Rectangle)();
        this.spriteBoundsFilter = new (0, $1c935e758fdc5c1b$export$871d1b476f60b319)();
        this.renderedOcclusionTiles = new (0, $1c935e758fdc5c1b$export$c91a30cd3333b2fb)();
        this.floorOpeningEdges = new (0, $a5455a642b85f08d$export$973d0f1d5c4c8122)();
        this.storeyEdges = new (0, $4216ea292092863c$export$fcedb987e0a02405)();
        this.houseRoof = new (0, $6dd6e4a0e941ec0b$export$e9f462800192160c)();
        this.roofGroups = new Map();
        this.buildVeil = new Set();
        this.archedCells = new Set();
        this.groundLayerRenderers = new Map();
        this.skyTilemaps = [];
        this.roofGroupByCell = new Map();
        this.roofArtwork = new Map();
        this.compositeSprites = [];
        this.artworkVersion = 0;
        this.shadedSprites = [];
        this.shadeShown = new Map();
        this.shadedSpritesSeen = false;
        this.shadeEasing = false;
        this.climbing = [];
        this.climbShades = new Map();
        this.getCompositeSprites = ()=>this.compositeSprites;
        this.getArtworkVersion = ()=>this.artworkVersion;
        this.houseRoofDepth = new (0, $ff77f0e96218c7e7$export$6bfce3b6985f9a3d)(1.25, 2);
        this.houseRoofShade = new (0, $gwPoJ.Graphics)();
        this.wallHalo = new (0, $72f83e51a7379926$export$8664e1cc27db0c04)();
        this.houseRoofCells = new Set();
        this.setViewEntity = (entity)=>{
            this.viewEntity = entity;
        };
        this.houseRoofFade = new (0, $f938f025cf72352a$export$6377df4ac9e9e40f)();
        this.renderedStoreyRisePx = (0, $2751e0027a1b432f$export$de62489b685ceb);
        this.renderedRoofUpliftPx = (0, $2751e0027a1b432f$export$42b4af315a0c8aa1);
        this.renderedRoofCover = "";
        this.renderedWallSeams = "";
        this.wallTrimAtlas = new (0, $ba9ee37aae1b90d9$export$e0acefc08bd634f2)();
        this.renderedWallTrims = "";
        this.houseRoofFallback = new Map();
        this.buildingShadow = new (0, $ff5e8e678ac263ca$export$fd19f4d7b2d2ab91)();
        this.contactShadow = new (0, $ff5e8e678ac263ca$export$fd19f4d7b2d2ab91)();
        this.roofCastShadow = new (0, $ff5e8e678ac263ca$export$fd19f4d7b2d2ab91)();
        this.roofShadowPolygons = [];
        this.groundRise = new (0, $c176d075ea73ab2c$export$67bdc57a63bd8057)();
        this.rockMass = new (0, $882231da9d46a555$export$395ef1bf505a6c69)();
        this.water = new (0, $01866daf3eb22cee$export$6626238c475bccd6)();
        this.shadowSun = {
            ...(0, $a44874d288f3eb63$export$63a353feb061e28c)
        };
        this.shadowPolygons = [];
        this.shadowStamps = [];
        this.grassStamps = [];
        this.contactPolygons = [];
        this.archShade = new (0, $gwPoJ.Graphics)();
        this.rngCache = new Map();
        this.isRendering = false;
        this.pendingMapDeltas = [];
        this.pendingRerender = false;
        this.// ============================================================================
        // INITIALIZATION
        // ============================================================================
        init = ()=>{
            this.tilemapRendererList = [
                new (0, $6dd6e4a0e941ec0b$export$e9f462800192160c)(),
                new (0, $6dd6e4a0e941ec0b$export$e9f462800192160c)(),
                new (0, $6dd6e4a0e941ec0b$export$e9f462800192160c)(),
                new (0, $6dd6e4a0e941ec0b$export$e9f462800192160c)(),
                new (0, $6dd6e4a0e941ec0b$export$e9f462800192160c)(),
                new (0, $6dd6e4a0e941ec0b$export$e9f462800192160c)()
            ];
            this.tilemapRenderers = new (0, $a80d0b17b615d6f7$export$37a78dc06a7d1e2e)(this.tilemapRendererList);
            this.tilemapRendererList.forEach((renderer, i)=>{
                this.surface.addChild(renderer);
                // Same ground sort order, immediately above this layer and below the next one.
                const fades = new (0, $8t5Gy.Container)();
                this.surface.addChild(fades);
                this.lavaFadeSurfaces.set(renderer, fades);
            });
            // Update composite tile renderer with sky surfaces from SkyManager
            this.compositeTileRenderer.updateSkySurfaces(this.skyManager.getSkySpriteSurfaceAbove());
            // Update tile effect system with sky surfaces from SkyManager
            this.tileEffectSystem.updateSkySurfaces(this.skyManager.getSkySpriteSurfaceAbove(), this.skyManager.getSkySpriteSurfaceBelow());
            // Live tuning hook: window.occluderFade.enabled / .alpha / .speed / .minNeighbors etc.
            // (matches window.deathEffect).
            if (this.features.occluderFade && typeof window !== "undefined") window.occluderFade = this.occluderFade.config;
        };
        this.checkStructure = ()=>{
            // A floor built or removed upstairs covers or uncovers this storey's roof: repaint it then.
            const upperFloorVersion = this.tilemapMetaProvider?.getUpperFloorVersion();
            if (upperFloorVersion !== this.checkedUpperFloorVersion) {
                this.checkedUpperFloorVersion = upperFloorVersion;
                if (this.roofCover() !== this.renderedRoofCover) this.needsRender = true;
            }
            // A wall built or removed on this storey or the ones above and below changes where walls meet
            // (seams, lintels): repaint then.
            const provider = this.tilemapMetaProvider;
            const upperWallVersions = [];
            const seenUpper = new Set();
            for(let upper = provider?.getUpperFloorProvider(); upper && !seenUpper.has(upper); upper = upper.getUpperFloorProvider()){
                seenUpper.add(upper);
                upperWallVersions.push(`${upper.roomId}:${upper.getPresentationVersion()}`);
            }
            const wallSeamVersion = provider && `${provider.getPresentationVersion()}|${upperWallVersions.join(";")}|${this.wallJointCeiling()}|` + `${provider.getFloorSupportProvider()?.roomId}:${provider.getFloorSupportProvider()?.getPresentationVersion()}`;
            if (provider && wallSeamVersion !== this.checkedWallSeamVersion) {
                this.checkedWallSeamVersion = wallSeamVersion;
                if (this.wallSeamSignature() !== this.renderedWallSeams) this.needsRender = true;
            }
            // Trims read the whole stack (ivy climbs every storey, an arch cuts the storey over a gateway): repaint when
            // any storey's walls change.
            // A lone storey repaints the cells a change touches and their neighbours, which is all its trims need.
            const trimStack = provider && (0, $ba9ee37aae1b90d9$export$9f9361b20898f65c)() ? (0, $ba9ee37aae1b90d9$export$3c9496a80943a375)(provider).storeys : [];
            const trimVersion = trimStack.length > 1 ? trimStack.map((p)=>`${p.roomId}:${p.getPresentationVersion()}`).join("|") : "";
            if (trimVersion !== this.checkedWallTrimVersion) {
                this.checkedWallTrimVersion = trimVersion;
                if (this.wallTrimSignature() !== this.renderedWallTrims) this.needsRender = true;
            }
        };
        this.renderTileMap = ()=>{
            // Art drawn afresh this frame (a felled tree's full render, a repainted cell) starts untinted, and
            // the shadows above were worked out before the frame's deltas: settle both again at the end.
            const artworkBefore = this.artworkSignature();
            if (this.renderedStoreyRisePx !== (0, $2751e0027a1b432f$export$de62489b685ceb) || this.renderedRoofUpliftPx !== (0, $2751e0027a1b432f$export$42b4af315a0c8aa1)) {
                this.renderedStoreyRisePx = (0, $2751e0027a1b432f$export$de62489b685ceb);
                this.renderedRoofUpliftPx = (0, $2751e0027a1b432f$export$42b4af315a0c8aa1);
                this.rerender();
            }
            if (this.features.roofCutaway) this.skyManager.updatePlayerLocation(this.viewEntity ?? this.logic.playerEntity);
            this.checkStructure();
            // The storey the player is on draws first: a block laid there shows before the storeys round it catch up.
            // Asked before the scene's other storeys ask for theirs (they draw in sceneRenderer.render, below).
            const renderTurn = this.features.camera && this.needsRender && this.paintedRoomId === this.roomId && (0, $a17a83e5cb2d0838$export$666b3b940e8c9ba8)();
            const provider = this.tilemapMetaProvider;
            this.roofGroups.forEach(({ surface: surface })=>{
                surface.visible = this.skySurface.visible;
                surface.alpha = this.skyManager.getSkyAlpha();
            });
            // The storey the player stands on is drawn whole; the others publish their own fade as they draw.
            if (this.features.camera && provider) (0, $21141db879ebc35b$export$f9cdf82e798d4d86)(provider.roomId, 1);
            this.sceneRenderer.render(this.tilemapMetaProvider?.getHousePresentation(), this.viewEntity ?? this.logic.playerEntity, this.features.camera && !!this.logic.isRoomRevealHolding?.());
            const house = this.tilemapMetaProvider?.getHousePresentation();
            // A live roof can be added to an open top floor without a room reload.
            this.houseRoof.y = (0, $2751e0027a1b432f$export$bec9e2f2535fb41)(house) ? (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)(house, this.projectionFloor ?? house.floor) : 0;
            this.houseRoofDepth.y = this.houseRoofShade.y = this.houseRoof.y;
            this.houseRoof.zIndex = this.houseRoofZIndex(house);
            this.houseRoofDepth.zIndex = this.houseRoof.zIndex - 0.5;
            this.houseRoofShade.zIndex = this.houseRoof.zIndex + 0.01;
            this.roofCastShadow.zIndex = this.houseRoof.zIndex + 0.02;
            this.houseRoofFade.update((0, $2751e0027a1b432f$export$bec9e2f2535fb41)(house) && (!this.features.roofCutaway || (0, $9b85be211484fac5$export$4a8c8628e4e44ada)((this.viewEntity ?? this.logic.playerEntity)?.floorFall) || !!(this.viewEntity ?? this.logic.playerEntity)?.location && !(0, $2751e0027a1b432f$export$2c01c05cc2cc0271)(house, (this.viewEntity ?? this.logic.playerEntity).location)));
            this.houseRoof.alpha = this.houseRoofDepth.alpha = this.houseRoofShade.alpha = this.houseRoofFade.alpha;
            this.houseRoof.visible = this.houseRoofFade.visible;
            this.houseRoofDepth.visible = this.houseRoofShade.visible = this.houseRoof.visible;
            // Art restored at its full height until its height was read.
            if (!this.isRendering && this.roofCompositeOverlap.heightsRead()) this.rebuildRoofComposites();
            this.roofCompositeOverlap.sync();
            this.updateBuildingShadow();
            this.groundRise.tick();
            this.water.tick();
            if (this.lavaTileFade.update()) this.needsRender = true;
            // Apply queued map deltas every frame, independent of the visual re-render gate
            // below. Deltas carry collision/blocking changes -- e.g. a chopped-down tree
            // becoming walkable. Previously deltas were only applied inside a full re-render,
            // but a tree cut does not trigger one (it sends a map delta, not a redrawClient),
            // so the client's collision map (tileTypesMap "blocking") stayed stale until the
            // next unrelated re-render or a reload. The player then predicts a collision the
            // server no longer enforces; reconciliation repeatedly yanks the player through the
            // now-empty space -- the shudder when walking where a tree used to be. Applying
            // deltas here mutates the persistent data model, so a later full re-render still
            // reflects them.
            this.processPendingDeltas();
            // After the deltas, so a cell mined this frame is drawn open this frame.
            this.rockMass.tick(this.tilemapMetaProvider, (this.viewEntity ?? this.logic.playerEntity)?.location);
            this.floorOpeningEdges.sync(this.tilemapMetaProvider);
            this.storeyEdges.sync(this.tilemapMetaProvider, this.surface, (0, $a17a83e5cb2d0838$export$666b3b940e8c9ba8));
            this.syncDownstairsVisibility();
            this.updateHatches();
            for (const ladder of this.stackedLadders)if (ladder.destroyed || !ladder.parent) this.stackedLadders.delete(ladder);
            else ladder.pose();
            this.applyLadderVeils();
            // The deltas may have changed what only a full drawing shows (a wall joining a trimmed stack): then that
            // drawing repaints their cells too, and a cell-by-cell repaint first would be thrown away.
            if (this.pendingRedraw) this.checkStructure();
            if (this.pendingRedraw && this.needsRender && !this.isRendering) {
                this.pendingRedraw = false;
                this.dirtyCells.clear();
                this.dirtyNeedsFull = false;
            }
            // A redrawClient signal: repaint just the delta-changed cells (incremental) rather than the
            // whole map. Runs here, after processPendingDeltas has applied the accompanying deltas. May
            // escalate to a full rerender (needsRender) if a tilemap-layer cell changed.
            if (this.pendingRedraw && !this.isRendering) {
                this.pendingRedraw = false;
                this.repaintDirtyCells();
            }
            // A storey drawn again takes its turn with the other heavy work of the frame (frame_work_budget.ts), the trim
            // painter of a changed stack having had a turn of its own first; its first drawing in a room does not wait.
            if (!this.shouldRender() || this.paintedRoomId === this.roomId && (!(renderTurn || (0, $a17a83e5cb2d0838$export$666b3b940e8c9ba8)()) || this.warmTrims())) {
                this.updateLandings();
                this.syncSceneComposites();
                if (this.artworkSignature() !== artworkBefore) this.updateBuildingShadow();
                return;
            }
            this.isRendering = true;
            try {
                this.prepareRendering();
                this.renderAllLayers();
                this.groundRise.sync(this.tilemapMetaProvider);
                this.placeGroundRise();
                this.water.sync(this.tilemapMetaProvider);
                this.placeWater();
                this.finalizeRendering();
                // After the rebuild, which draws every wall at rest.
                this.updateLandings();
                this.syncSceneComposites();
            } finally{
                this.isRendering = false;
            }
            if (this.artworkSignature() !== artworkBefore) this.updateBuildingShadow();
            // Process queued re-render request
            if (this.pendingRerender) {
                this.pendingRerender = false;
                this.needsRender = true;
            }
        };
        this.warmTrims = ()=>{
            const provider = this.tilemapMetaProvider;
            if (!(0, $a17a83e5cb2d0838$export$63bf454cb404d2ce)() || !provider || !(0, $ba9ee37aae1b90d9$export$9f9361b20898f65c)() || (0, $ba9ee37aae1b90d9$export$3c9496a80943a375)(provider).storeys.length < 2) return false;
            return (0, $ba9ee37aae1b90d9$export$c9e7d128a54cb10b)(provider, this.wallSeamTileId).painter.warm();
        };
        this.artworkSignature = ()=>`${this.artworkVersion}|${this.surfaceObjectsByKey.size}`;
        this.renderAt = (x, y, tilemap, layerId, options)=>{
            if (layerId === "sprite2" && tilemap[x]?.[y] && tilemap[x][y] !== "0" && (0, $f63a252d2ded274b$export$6d09a325ee084aba)(this.tilemapMetaProvider, {
                x: x,
                y: y
            })) {
                this.renderSpritedCell(x, y, tilemap[x][y], layerId, this.spritedLayerIndex(layerId));
                return this.spritedCellSprites.get(`${x}-${y}-${layerId}`)?.slice(-1)[0];
            }
            let { tilemapRender: tilemapRender, wasReplaced: wasReplaced, surfaceId: surfaceId } = options || {};
            tilemapRender = tilemapRender || this.tilemapRenderers.next().value;
            const size = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const _x = tilemap[x];
            if (!_x) return;
            let spriteToReturn;
            const tile = _x[y];
            if (tile && this.tilemapMetaProvider.shouldDrawTileAt(x, y, layerId, tilemap)) {
                if (!this.tilemapMetaProvider.isHiddenTile(tile)) {
                    const compositeTileId = this.tilemapMetaProvider.getCompositeTileId(tile);
                    if (compositeTileId) this.renderCompositeTile(this.tilemapMetaProvider, tile, compositeTileId, x, y);
                    else {
                        const tilesetTileId = this.tilemapMetaProvider.resolveTilesetTileId(tile);
                        if (layerId === "sky" && tilemap === this.tilemapMetaProvider.resolveTileMapFromLayerId("sky") && this.houseRoofCells.has(`${x},${y}`)) // The house roof is painted independently of the sky pass, beneath
                        // the upper room. Ordinary sky visibility must not control it.
                        return;
                        if (layerId) {
                            const layerMapping = this.tilemapMetaProvider.resolveLayerMapping(layerId);
                            if (layerMapping.maptype === "sprited") spriteToReturn = this.spriteManagementService.createSpriteAt(tilesetTileId, x, y);
                            if (layerMapping.maptype === "tilemap") {
                                this.renderGroundTile(this.tilemapRenderers.values[layerMapping.idx], tilesetTileId, x, y, layerId);
                                if (wasReplaced) {
                                    // todo -- this is too blunt... maybe there is a way to avoid full
                                    // rerenders on pixijs tilemap renders
                                    this.rerender();
                                    return;
                                }
                            }
                            if (layerMapping.maptype === "sky") {
                                const roof = this.roofGroupAt(x, y);
                                const delta = this.tilemapMetaProvider.getMapDeltaAt(x, y, "sky");
                                if (delta?.collideable) {
                                    spriteToReturn = this.spriteManagementService.createSpriteAt(tilesetTileId, x, y, 0, roof.surface);
                                    spriteToReturn.y += (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)();
                                } else if (!this.buildVeil.has(`${x}-${y}-sky`) || tilemap !== this.tilemapMetaProvider.resolveTileMapFromLayerId("sky")) roof.tiles.tile(`${tilesetTileId}`, x * size, y * size + (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)());
                                const tileset = this.tilemapMetaProvider.resolveTileSet(tile);
                                const [left, top, right, bottom] = (0, $b115d5752cc44167$export$34d697321b2dd5d4)(tileset?.tilesetId, Number(tile) - tileset?.firstGid);
                                this.recordRoofArtwork(roof.surface, new (0, $6qzqq.Rectangle)(x * size + left, y * size + (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)() + top, right - left, bottom - top));
                                this.renderedOcclusionTiles.add(roof.surface, new (0, $6qzqq.Rectangle)(x * size, y * size + (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)(), size, size));
                            }
                        } else {
                            this.renderGroundTile(tilemapRender, tilesetTileId, x, y, options?.fadeLayerId);
                            // Create overlay sprite for damage effects on regular layers
                            const delta = this.tilemapMetaProvider.findMapDeltaAt(x, y);
                            if (this.tileEffectSystem.shouldCreateDamageOverlay(delta)) spriteToReturn = this.tileEffectSystem.createDamageOverlaySprite(tilesetTileId, x, y);
                        }
                    }
                }
            }
            if (spriteToReturn && layerId === "sprite2") this.orientStairSprite(spriteToReturn, x, y, tile);
            return spriteToReturn;
        };
        this.orientStairSprite = (sprite, x, y, tile)=>{
            if (sprite instanceof (0, $f63a252d2ded274b$export$3fce9c276dbc848)) {
                sprite.pose();
                return;
            }
            const type = this.tilemapMetaProvider.resolveTileMeta(tile).entityTileId;
            if (type !== "stairs-up" && type !== "stairs-down") return;
            sprite.heightBlurExempt = true;
            (0, $2911f2fc3a73440b$export$910413b1c7659f34)(sprite, {
                x: x,
                y: y
            }, type, (0, $d67ded9f7782cb88$export$821b6aaabbc063ff)(this.tilemapMetaProvider, {
                x: x,
                y: y
            }));
        };
        this.downstairsHasSurface = (x, y)=>{
            const provider = this.tilemapMetaProvider;
            if ((0, $f63a252d2ded274b$export$6d09a325ee084aba)(provider, {
                x: x,
                y: y
            })) return true;
            const surfaces = [
                [
                    provider,
                    "map2"
                ],
                [
                    provider,
                    "sky"
                ]
            ];
            const below = provider.getFloorSupportProvider();
            if (below) surfaces.push([
                below,
                "sky"
            ]);
            return surfaces.some(([map, layer])=>{
                const tiles = map.resolveTileMapFromLayerId(layer);
                for(let dx = -1; dx <= 1; dx++)for(let dy = -1; dy <= 1; dy++){
                    const cx = x + dx, cy = y + dy;
                    const tile = tiles?.[cx]?.[cy];
                    if (tile && tile !== "0" && !map.isHiddenTile(tile) && !map.getMapDeltaAt(cx, cy, layer)?.removed && (layer !== "map2" || !map.isFloorOpeningAt(cx, cy))) return true;
                }
                return false;
            });
        };
        this.hatchSprites = new Set();
        this.stackedLadders = new Set();
        this.ladderVeiled = new Set();
        this.applyLadderVeils = ()=>{
            const storey = this.storey();
            const veiled = new Set();
            for (const veil of (0, $2c4a8005c243ff16$export$9fbd56626b49c812).active()){
                if (storey < veil.from || storey > veil.to) continue;
                this.spritedCellSprites.get(`${veil.x}-${veil.y}-sprite2`)?.forEach((sprite)=>{
                    if (!sprite.destroyed) veiled.add(sprite);
                });
            }
            this.ladderVeiled.forEach((sprite)=>{
                if (!veiled.has(sprite) && !sprite.destroyed) sprite.alpha = 1;
            });
            veiled.forEach((sprite)=>{
                sprite.alpha = 0;
            });
            this.ladderVeiled = veiled;
        };
        this.updateHatches = ()=>{
            for (const hatch of this.hatchSprites)if (hatch.destroyed || !hatch.parent || hatch.parent.destroyed) {
                if (!hatch.destroyed) hatch.destroy({
                    children: true
                });
                this.hatchSprites.delete(hatch);
            } else hatch.pose();
        };
        this.syncDownstairsVisibility = ()=>{
            const provider = this.tilemapMetaProvider;
            if (!provider) return;
            const below = provider.getFloorSupportProvider();
            const version = `${provider.roomId}:${provider.getPresentationVersion()}:${below?.roomId}:${below?.getPresentationVersion()}:${this.artworkVersion}`;
            if (version === this.checkedDownstairsVisibility) return;
            this.checkedDownstairsVisibility = version;
            this.spritedCellSprites.forEach((sprites, key)=>{
                const [x, y, layer] = key.split("-");
                const tile = provider.resolveTileMapFromLayerId(layer)?.[Number(x)]?.[Number(y)];
                if (!tile || provider.resolveTileMeta(tile).entityTileId !== "stairs-down") return;
                const visible = !this.buildVeil.has(key) && this.downstairsHasSurface(Number(x), Number(y));
                sprites.forEach((sprite)=>{
                    sprite.visible = visible;
                });
            });
        };
        this.renderGroundTile = (renderer, texture, x, y, layerId)=>{
            if (!renderer || !this.drawGroundTile(renderer, texture, x, y, layerId)) return;
            if (layerId === "map2" && this.tilemapMetaProvider.twoStoreyHouse?.floor > 0) this.recordRoofArtwork(renderer, new (0, $6qzqq.Rectangle)(x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)));
            // Recorded whatever this map's role: the active map becomes a passive floor without a repaint
            // when the player changes level (handOver), and passive floors test occlusion against these.
            const art = (0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(texture);
            this.renderedOcclusionTiles.add(renderer, new (0, $6qzqq.Rectangle)(x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), art.width, art.height));
        };
        this.drawGroundTile = (renderer, texture, x, y, layerId)=>{
            const key = `${x}-${y}-${layerId}`;
            // A build preview is showing this tile reshaped; it stays recorded, just undrawn.
            if (layerId && this.buildVeil.has(key)) return true;
            // The floor a wall stands on where it arches over a gateway below: the passage shows through the arch instead.
            if (layerId === "map2" && this.archedCells.has(`${x},${y}`)) return true;
            const fadeSurface = this.lavaFadeSurfaces.get(renderer);
            if (fadeSurface && layerId && this.lavaTileFade.render(key, `${texture}`, x, y, fadeSurface)) return false;
            renderer.tile(`${texture}`, x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            return true;
        };
        this.addTileAt = (x, y, tile, layerId, owned = false)=>{
            const mapping = this.tilemapMetaProvider.resolveLayerMapping(layerId);
            const tilesetTileId = this.tilemapMetaProvider.resolveTilesetTileId(tile);
            // Pending build ghosts must survive map redraws without being reused by the frame pool.
            const sprite = owned ? new (0, $7Bs2Z.Sprite)((0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(tilesetTileId)) : this.spriteManagementService.createSpriteAt(tilesetTileId, x, y, mapping?.idx || 0);
            if (owned) {
                sprite.position.set(x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                sprite.zIndex = 100 + (mapping?.idx || 0) + y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 3;
                this.surface.addChild(sprite);
                this.ownedGhosts.add(sprite);
            }
            if (mapping?.maptype === "sky") sprite.y += (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)();
            if (layerId === "sprite2") this.orientStairSprite(sprite, x, y, tile);
            return {
                sprite: sprite
            };
        };
        this.updateCompositeTilePointer = (at)=>{
            // An organic cave's rock has no sprites to hit-test: point at the rock cell under the pointer.
            if (this.rockMass.active) {
                const cell = this.rockMass.breakableCellAt(this.surface.toLocal(at));
                this.logic.playerController.updateCompositeTile(cell?.x ?? -1, cell?.y ?? -1);
                return;
            }
            this.compositeTileRenderer.updateCompositeTilePointer(at);
        };
        this.renderCompositeTile = (tilemapMetaProvider, parentTileId, compositeTileId, x, y, zIndex = 0)=>{
            this.compositeTileRenderer.renderCompositeTile(tilemapMetaProvider, parentTileId, compositeTileId, x, y, zIndex);
        };
        this.// ============================================================================
        // PLAYER/CAMERA MANAGEMENT METHODS
        // ============================================================================
        updatePlayerLocation = (entity, force)=>{
            if (!entity) return;
            // Update sky visibility based on player position
            if (this.features.roofCutaway) this.skyManager.updatePlayerLocation(entity, force);
            if (!force && this.needsRender || !this.tilemapMetaProvider || entity.location.x < 0 || entity.location.y < 0) return;
            // Delegate camera positioning to camera management service
            if (this.features.camera) this.cameraManagementService.updatePlayerLocation(entity, force);
        };
        this.screenShakeImpulse = (entity, amplitude, durationMs)=>{
            if (this.features.camera) this.cameraManagementService.screenShakeImpulse(entity, amplitude, durationMs);
        };
        this.screenShake = (entity)=>{
            if (this.features.camera) this.cameraManagementService.screenShake(entity);
        };
        this.// ============================================================================
        // EFFECTS AND OVERLAYS METHODS
        // ============================================================================
        updateTileEffects = (wind = null, center, storm = 0, brightness)=>this.tileEffectSystem.update(wind, center, storm, brightness);
        this.predictTreeStrike = (location, entity)=>{
            const target = this.tilemapMetaProvider?.getEntityTileAt(location.x, location.y);
            if (target?.entityTile === "testore" && this.rockMass.active) return;
            if (!target || (0, $d3527b517d667178$export$4cfe0674a42ef84e).entityTile.hpDecrementOnHit(target.entityTile, entity.weapon?.weaponType || "none") < 1) return;
            this.tileEffectSystem.predictTreeStrike({
                effectType: "damage",
                mapRoughCoordinates: location,
                ...target,
                surfaceId: this.tilemapMetaProvider.findMapDeltaAt(location.x, location.y)?.context?.surfaceId,
                strikerId: entity.entityId,
                strikeFrom: entity.location,
                strikeStrength: !entity.weapon || entity.weapon.weaponType === "none" ? 0.35 : entity.weapon.weaponType === "warhammer" ? 1.5 : 1
            });
        };
        this.tileEffect = (effect)=>{
            // An organic cave's rock has no block sprite to crack or crumble: its own layer shows the hit.
            if (this.rockMass.tileEffect(effect)) return;
            this.tileEffectSystem.applyTileEffect(effect);
        };
        this.overlay = ()=>this.worldOverlaySurface;
        this.setStaticHidingAllowed = (allowed)=>this.skyManager.setStaticHidingAllowed(allowed);
        this.setProjectionFloor = (floor)=>{
            this.projectionFloor = floor;
        };
        this./**
     * The roof stands a storey higher than the storey it caps, so seen from above it should recede by one
     * storey less than the storey does (scene_room_renderer.ts storeyTone): `gain`, per channel, lifts it
     * back that far through the storey's own tone. Undefined: no lift.
     */ setRoofTone = (gain)=>{
            const key = gain ? gain.map((g)=>g.toFixed(3)).join(",") : undefined;
            if (key === this.roofToneKey) return;
            this.roofToneKey = key;
            if (!gain) {
                this.houseRoof.filters = null;
                return;
            }
            this.roofTone ||= new (0, $1avo5.filters).ColorMatrixFilter();
            const [r, g, b] = gain;
            this.roofTone.matrix = [
                r,
                0,
                0,
                0,
                0,
                0,
                g,
                0,
                0,
                0,
                0,
                0,
                b,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ];
            this.houseRoof.filters = [
                this.roofTone
            ];
        };
        this.updateHouseProjection = ()=>{
            // Choose the world origin when loading the active map. Adding the first stairs
            // introduces house metadata mid-room; changing the pivot then jumps the camera.
            // Passive floors inherit the active world's lift through their parent surface.
            const offset = this.projectionFloor === undefined && this.tilemapMetaProvider?.getHousePresentation() ? (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) : 0;
            this.surface.pivot.y = offset;
            this.worldOverlaySurface.pivot.y = offset;
        };
        this.// ============================================================================
        // MINIMAP METHODS
        // ============================================================================
        updateMinimap = (tilemapMetaProvider)=>{
            if (this.features.minimap) this.miniMapSurface.update(tilemapMetaProvider);
        };
        this.updateBiomeColorMap = (biomeCoordinate, color)=>{
            if (this.features.minimap) this.miniMapSurface.updateBiomeColorMap(biomeCoordinate, color);
        };
        this.removeLocationIcon = (iconId)=>{
            this.miniMapSurface.removeLocationIcon(iconId);
        };
        this.// ============================================================================
        // STATE MANAGEMENT METHODS
        // ============================================================================
        update = (tilemapMetaProvider, visibility, levelHandOff = false)=>{
            if (tilemapMetaProvider && levelHandOff && this.handOverTo(tilemapMetaProvider, visibility)) return true;
            if (tilemapMetaProvider) {
                const previousHouse = this.tilemapMetaProvider?.twoStoreyHouse;
                const nextHouse = tilemapMetaProvider.twoStoreyHouse;
                const linkedFloor = (0, $30c0c3cc99c65923$export$5f2cb0f098ee5881)(this.roomId, previousHouse, tilemapMetaProvider.roomId, nextHouse);
                const replacedMap = this.tilemapMetaProvider !== tilemapMetaProvider;
                this.tilemapMetaProvider = tilemapMetaProvider;
                this.updateHouseProjection();
                // Restart can replace the active map under the same room ID, without
                // sending companion frames when the new camp has no building.
                if (this.roomId !== tilemapMetaProvider.roomId || replacedMap) {
                    if (linkedFloor) this.sceneRenderer.activateRoom(tilemapMetaProvider.roomId);
                    else this.sceneRenderer.clear();
                    this.houseRoofFade.reset();
                }
                const house = tilemapMetaProvider.getHousePresentation();
                this.houseRoofCells = new Set((0, $2751e0027a1b432f$export$bec9e2f2535fb41)(house) ? (0, $2751e0027a1b432f$export$149797a16feb3a10)(house).map((0, $2751e0027a1b432f$export$d3423e7ce2638637)) : []);
                this.houseRoofFallback.clear();
                if ((0, $2751e0027a1b432f$export$bec9e2f2535fb41)(house)) (0, $718a35436683a80f$export$33f4909808e4f90c)((0, $2751e0027a1b432f$export$149797a16feb3a10)(house), tilemapMetaProvider.width(), tilemapMetaProvider.height(), tilemapMetaProvider.roomId).filter((entry)=>entry.layerId === "sky").forEach((entry)=>this.houseRoofFallback.set(`${entry.x},${entry.y}`, String((0, $2db7e29a401f47a7$export$89f24ee63398b793)[entry.tileSpec.tilesetId].firstgid + entry.tileSpec.tilePos)));
                this.houseRoof.y = (0, $2751e0027a1b432f$export$bec9e2f2535fb41)(house) ? (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)(house, this.projectionFloor ?? house.floor) : 0;
                this.houseRoof.zIndex = this.houseRoofZIndex(house);
                this.houseRoofDepth.y = this.houseRoofShade.y = this.houseRoof.y;
                this.houseRoofDepth.zIndex = this.houseRoof.zIndex - 0.5;
                this.houseRoofShade.zIndex = this.houseRoof.zIndex + 0.01;
                this.roofCastShadow.zIndex = this.houseRoof.zIndex + 0.02;
                // Update composite tile renderer with new tilemap meta provider
                this.compositeTileRenderer.updateTilemapMetaProvider(tilemapMetaProvider);
                // Update tile effect system with new tilemap meta provider
                this.tileEffectSystem.updateTilemapMetaProvider(tilemapMetaProvider);
                // Update sky manager with new tilemap meta provider
                this.skyManager.updateTilemapMetaProvider(tilemapMetaProvider);
                if (this.roomId !== tilemapMetaProvider.roomId) {
                    this.lavaTileFade.clear();
                    this.clearLandingArt();
                    this.roomId = tilemapMetaProvider.roomId;
                    // new room boundary has been crossed
                    this.tileEffectSystem.clearSurfaceObjects();
                    this.RANDOM_NUMBER_GENERATOR = $46cd47a21442bee6$exports(this.roomId);
                    this.rngCache.clear();
                    // Reset sky state
                    if (!linkedFloor) this.skyManager.resetSkyState();
                    // Update tile effect system with new room context
                    this.tileEffectSystem.updateHoleEffectContext(this.roomId, this.RANDOM_NUMBER_GENERATOR);
                }
                this.rerender();
                if (this.features.camera) this.cameraManagementService.updateTranslationComputer(tilemapMetaProvider);
            }
            this.visibility = visibility;
            if (this.visibility) this.visibility.lastUpdateTs = Date.now();
            return false;
        };
        this.keepsLevelsDrawn = ()=>!!this.onHandOff;
        this.drawnFloorProvider = (roomId)=>this.sceneRenderer.floorProvider(roomId);
        this.handOverTo = (provider, visibility)=>{
            const leaving = this.tilemapMetaProvider;
            if (!this.onHandOff || !leaving || this.isRendering || this.roomId === provider.roomId || !(0, $30c0c3cc99c65923$export$5f2cb0f098ee5881)(this.roomId, leaving.twoStoreyHouse, provider.roomId, provider.twoStoreyHouse)) return false;
            const next = this.sceneRenderer.floorMap(provider.roomId);
            if (!(next instanceof $409e08612bd4cd6f$export$ac241b7c41940a17) || !next.tilemapMetaProvider || next.isRendering) return false;
            const exchanged = this.sceneRenderer.exchange(provider.roomId, leaving, this, (root, sky)=>this.handOver(next, {
                    surface: root,
                    skySurface: sky,
                    worldOverlaySurface: new (0, $b11c64d757fefaba$export$198fa1625abb29ee)(this.logic, root)
                }, provider.twoStoreyHouse.floor));
            if (!exchanged) return false;
            next.adoptProvider(provider, visibility);
            next.onHandOff?.(next);
            return true;
        };
        this.handOver = (next, passive, activeFloor)=>{
            const mine = this.ownedArt(), theirs = next.ownedArt();
            const active = this.role();
            this.takeRole({
                ...next.role(),
                ...passive,
                features: (0, $1704411fa88dc9bf$export$784ce4bd6fedbedf),
                grassSway: undefined,
                projectionFloor: activeFloor,
                onHandOff: undefined
            }, mine);
            next.takeRole(active, theirs);
        };
        this.role = ()=>({
                surface: this.surface,
                skySurface: this.skySurface,
                worldOverlaySurface: this.worldOverlaySurface,
                miniMapSurface: this.miniMapSurface,
                sceneRenderer: this.sceneRenderer,
                cameraManagementService: this.cameraManagementService,
                screenShakeManager: this.screenShakeManager,
                grassSway: this.grassSway,
                features: this.features,
                projectionFloor: this.projectionFloor,
                onHandOff: this.onHandOff
            });
        this.takeRole = (role, art)=>{
            ({ surface: this.surface, skySurface: this.skySurface, worldOverlaySurface: this.worldOverlaySurface, miniMapSurface: this.miniMapSurface, sceneRenderer: this.sceneRenderer, cameraManagementService: this.cameraManagementService, screenShakeManager: this.screenShakeManager, grassSway: this.grassSway, features: this.features, projectionFloor: this.projectionFloor, onHandOff: this.onHandOff } = role);
            $409e08612bd4cd6f$var$moveChildren(art, this.surface);
            this.placeGroundRise();
            this.skyManager.moveTo(this.skySurface);
            this.spriteManagementService.setDefaultSurface(this.surface);
            this.compositeTileRenderer.setSurface(this.surface);
            this.tileEffectSystem.setSurfaces(this.surface, this.worldOverlaySurface);
            this.roofCompositeOverlap.setSurface(this.surface);
            this.sceneCompositeOverlap.setSurface(this.surface);
            this.sceneCompositeKey = undefined;
            this.houseRoofFade.reset();
            this.updateHouseProjection();
            if (this.features.grassSway) this.registerGrassBlades();
            if (this.features.occluderFade) {
                if (typeof window !== "undefined") window.occluderFade = this.occluderFade.config;
            } else {
                // Nothing eases a passive floor's faded canopies back, and it borrows the active room's light.
                this.occluderFade.restoreAll();
                this.visibility = undefined;
            }
        };
        this.ownedArt = ()=>{
            const art = new Set([
                this.houseRoofDepth,
                this.houseRoof,
                this.houseRoofShade,
                this.wallHalo,
                this.floorOpeningEdges,
                this.buildingShadow,
                this.contactShadow,
                this.roofCastShadow,
                this.archShade,
                this.groundRise,
                this.rockMass,
                this.water,
                ...this.tilemapRendererList,
                ...this.lavaFadeSurfaces.values(),
                ...this.storeyEdges.displayObjects(),
                ...this.roofCompositeOverlap.getCopies(),
                ...this.sceneCompositeOverlap.getCopies()
            ]);
            this.roofGroups.forEach(({ surface: surface })=>art.add(surface));
            this.spritedCellSprites.forEach((sprites)=>sprites.forEach((sprite)=>art.add(sprite)));
            // Shade bands lie beside their tree, not in it: left behind, they went down with the old storey's root.
            this.climbShades.forEach((shade)=>shade.displayObjects().forEach((sprite)=>art.add(sprite)));
            this.hatchSprites.forEach((hatch)=>{
                const panel = !hatch.destroyed && hatch.depthArtwork();
                if (panel) art.add(panel);
            });
            this.ownedGhosts.forEach((sprite)=>{
                if (sprite.destroyed || sprite.parent !== this.surface) this.ownedGhosts.delete(sprite);
                else art.add(sprite);
            });
            const pool = this.spriteManagementService.getSpritePool();
            for(let i = 0; i <= pool.ptr; i++){
                const item = pool.items[i];
                if (item && !item.free && item.data) art.add(item.data);
            }
            return [
                ...art
            ].filter((child)=>!child.destroyed && child.parent === this.surface);
        };
        this.registerGrassBlades = ()=>{
            const sway = this.grassSway;
            if (!this.features.grassSway || !sway) return;
            sway.detachAll();
            const pool = this.spriteManagementService.getSpritePool();
            for(let i = 0; i <= pool.ptr; i++){
                const item = pool.items[i];
                const blade = item && !item.free && !item.data?.destroyed ? item.data.grassBlade : undefined;
                if (blade) sway.register(item.data, blade[0], blade[1], blade[2], blade[3], blade[4]);
            }
        };
        this.adoptProvider = (provider, visibility)=>{
            const drawn = this.tilemapMetaProvider;
            provider.setUpperFloorProvider(drawn.getUpperFloorProvider());
            provider.setFloorSupportProvider(drawn.getFloorSupportProvider());
            this.tilemapMetaProvider = provider;
            this.compositeTileRenderer.updateTilemapMetaProvider(provider);
            this.tileEffectSystem.updateTilemapMetaProvider(provider);
            this.skyManager.updateTilemapMetaProvider(provider);
            if (this.features.minimap) this.miniMapSurface.update(provider);
            if (this.features.camera) this.cameraManagementService.updateTranslationComputer(provider);
            this.visibility = visibility;
            if (this.visibility) this.visibility.lastUpdateTs = Date.now();
        };
        this./**
     * Does the map still owe the screen a paint? True from the moment a room (or a redraw) is handed
     * over until the next frame has drawn it. The room-reveal hold asks, because the ground is the
     * one thing that is certainly not ready on the frame a room lands (see RoomReveal).
     */ hasPendingRender = ()=>{
            // The storeys round this one are drawn behind the curtain too (SceneFloorRenderer prepaint).
            return this.needsRender || this.pendingRerender || this.features.camera && this.sceneRenderer.hasUnpaintedFloors();
        };
        this./** False while this map has its room's tiles but has not drawn them (a hidden storey, before its first reveal). */ hasPainted = ()=>!this.tilemapMetaProvider || this.paintedRoomId === this.roomId;
        this.rerender = ()=>{
            if (this.isRendering) // Queue the re-render request for after current rendering completes
            this.pendingRerender = true;
            else this.needsRender = true;
        };
        this.reset = ()=>{
            this.cameraManagementService.reset();
        };
        this.destroy = ()=>{
            this.hatchSprites.forEach((hatch)=>{
                if (!hatch.destroyed) hatch.destroy({
                    children: true
                });
            });
            this.hatchSprites.clear();
            this.renderedOcclusionTiles.clear();
            this.sceneRenderer.clear();
            this.roofCompositeOverlap.clear();
            this.sceneCompositeOverlap.clear();
            this.clearRoofGroups();
            this.houseRoof.destroy({
                children: true
            });
            this.houseRoofDepth.destroy();
            this.houseRoofShade.destroy();
            this.wallHalo.destroy();
            this.floorOpeningEdges.destroy();
            this.storeyEdges.destroy();
            this.buildingShadow.destroy();
            this.contactShadow.destroy();
            this.roofCastShadow.destroy();
            this.archShade.destroy();
            this.climbShades.forEach((shade)=>shade.destroy());
            this.climbShades.clear();
            this.groundRise.destroy();
            this.rockMass.destroy();
            this.water.destroy({
                children: true
            });
            if (this.shadeRoomId !== undefined) (0, $a1ff1a141ce12c85$export$521911947bc5fb90)(this.shadeRoomId, this);
            this.lavaTileFade.clear();
            this.lavaFadeSurfaces.forEach((surface)=>surface.destroy({
                    children: true
                }));
            this.lavaFadeSurfaces.clear();
            this.clearLandingArt();
            // Clean up sprite management service
            this.spriteManagementService.destroy();
        };
        this.// ============================================================================
        // UTILITY/HELPER METHODS
        // ============================================================================
        randomIntBetweenRng = (min, max, seed)=>{
            let randomFloat;
            if (!seed) randomFloat = this.RANDOM_NUMBER_GENERATOR ? this.RANDOM_NUMBER_GENERATOR() : Math.random();
            else {
                const toUse = `${seed}-${min}-${max}-${this.roomId}`;
                randomFloat = this.rngCache.get(toUse);
                if (randomFloat === undefined) {
                    randomFloat = this.RANDOM_NUMBER_GENERATOR ? this.RANDOM_NUMBER_GENERATOR() : Math.random();
                    this.rngCache.set(toUse, randomFloat);
                }
            }
            return Math.floor(randomFloat * (max - min + 1) + min);
        };
        this.pctChance = (pct, seed)=>{
            // min and max included
            return this.randomIntBetweenRng(0, 100, seed) >= 100 - pct;
        };
        this.pertubation = (tileId, x, y, offset, type, range = 5)=>{
            const key = `${type}-${tileId}-${x}-${y}-${range}-${offset}`;
            return this.randomIntBetweenRng(-range, range, key);
        };
        this.shouldRender = ()=>{
            return this.needsRender && !!this.tilemapMetaProvider;
        };
        this.prepareRendering = ()=>{
            this.roofCompositeOverlap.reset();
            this.sceneCompositeOverlap.reset();
            this.sceneCompositeKey = undefined;
            this.roofArtwork.clear();
            this.renderedOcclusionTiles.clear();
            this.houseRoof.clear();
            this.houseRoofDepth.clear();
            this.houseRoofShade.clear();
            this.tileEffectSystem.clearSurfaceObjects();
            let errorCount = 0;
            const releasedCount = this.spriteManagementService.releaseAllSprites((spriteItemObject)=>{
                const sprite = spriteItemObject.data;
                if (!sprite.parent) {
                    spriteItemObject.data = new (0, $7Bs2Z.Sprite)();
                    errorCount++;
                    return true;
                } else {
                    sprite.parent?.removeChild(sprite);
                    return false;
                }
            });
            this.clearRoofGroups();
            // Sprited-layer cells use OWNED sprites (not the frame pool), so releaseAllSprites above does
            // not touch them -- destroy them here before the full rebuild. children:true tears down any
            // damage-overlay children; texture defaults false so the shared spritesheet textures survive.
            this.spritedCellSprites.forEach((sprites)=>sprites.forEach((s)=>{
                    s.parent?.removeChild(s);
                    s.destroy({
                        children: true
                    });
                }));
            this.spritedCellSprites.clear();
            this.wallTrimAtlas.reset();
            this.stackedLadders.clear();
            this.spritedLayerIds.clear();
            this.spritedCellSurfaceId.clear();
            // A full rebuild releases every pooled sprite, which is every blade the wind was bending -- and
            // a released sprite is not merely dead, it is about to be handed to some other tile. Per-CELL
            // removals need no such hook (GrassSway prunes destroyed sprites itself), but discovering a
            // whole room's worth one frame at a time would mean bending sprites that now belong elsewhere.
            this.grassSway?.clear();
            this.compositeTileRenderer.clearBonecallerStones();
            // A full render repaints every cell, so any pending incremental dirty cells are subsumed.
            this.dirtyCells.clear();
            this.dirtyNeedsFull = false;
            // Clear tilemap renderers
            this.lavaTileFade.clearSprites();
            this.tilemapRendererList.forEach((renderer)=>renderer.clear());
            this.skyManager.clearSkySurfaces();
            this.tilemapRenderers.reset();
            // Clear tile effect system surface objects
            this.tileEffectSystem.clearSurfaceObjects();
        // Composite-tile textures (TileTextureExtractor.textureCache / compositeTileSpriteBounds and
        // this.compositeTileSpriteTextures) are content-addressed by `${tilesetId}-${compositeTileId}`,
        // immutable, and safely shared across rooms, so they are an intentional PERSISTENT memo --
        // NOT cleared per rerender (regenerating each rerender was a hitch) and bounded by the number
        // of distinct composite-tile types in the loaded tilesets. These were previously ".clear()"ed
        // here, but those calls were silent no-ops -- the Maps were accessed with bracket syntax, so
        // .clear() never touched the entries; the access is now .get/.set. Do NOT clear+destroy them
        // on room change: live sprites can still reference a cached texture, and destroy() nulls
        // Texture.orig, crashing any later getBounds() ("Cannot read properties of null (reading
        // 'width')").
        };
        this.renderAllLayers = ()=>{
            this.groundLayerRenderers.clear();
            this.archedCells = new Set(this.wallSeamCells().arched);
            this.skyTilemaps = [];
            this.renderedWithBuildingShadow = !!(0, $ff5e8e678ac263ca$export$c83a039e3272b805)().enabled;
            this.renderHouseRoof();
            this.houseRoofDepth.soften();
            const { visit: visit } = this.tilemapMetaProvider;
            visit(({ tilemap: tilemap, sky: sky, sprited: sprited, mapSpriteCaps: mapSpriteCaps = [], spriteFragments: spriteFragments, index: index, layerId: layerId })=>{
                if (spriteFragments) spriteFragments.forEach((fragment)=>{
                    this.tileEffectSystem.renderSpriteFragment(fragment);
                });
                else if (sprited) this.renderSpritedLayer(tilemap, mapSpriteCaps, index, layerId);
                else if (tilemap) {
                    const tilemapRender = sky ? this.skyManager.getSkyTilemapRenderer() : this.tilemapRenderers.next().value;
                    if (sky) this.skyTilemaps.push(tilemap);
                    else if (layerId) this.groundLayerRenderers.set(layerId, tilemapRender);
                    for(let y = 0; y < this.tilemapMetaProvider.height(); y++)for(let x = 0; x < this.tilemapMetaProvider.width(); x++)this.renderAt(x, y, tilemap, sky ? "sky" : undefined, {
                        tilemapRender: tilemapRender,
                        fadeLayerId: layerId
                    });
                }
            });
            this.renderWallLintels();
            this.renderedWallSeams = this.wallSeamSignature();
            this.renderedWallTrims = this.wallTrimSignature();
        };
        this.renderHouseRoof = ()=>{
            const house = this.tilemapMetaProvider.getHousePresentation();
            if (!(0, $2751e0027a1b432f$export$bec9e2f2535fb41)(house)) return;
            const sky = this.tilemapMetaProvider.resolveTileMapFromLayerId("sky");
            const cells = new Map((0, $2751e0027a1b432f$export$149797a16feb3a10)(house).map((cell)=>[
                    (0, $2751e0027a1b432f$export$d3423e7ce2638637)(cell),
                    cell
                ]));
            // Live roof extensions also sit at this storey's ceiling height and support the level above.
            sky?.forEach((column, x)=>column.forEach((tile, y)=>{
                    if (tile && tile !== "0") cells.set(`${x},${y}`, {
                        x: x,
                        y: y
                    });
                }));
            this.houseRoofCells = new Set(cells.keys());
            this.renderedRoofCover = this.roofCover();
            const painted = new Map();
            for (const { x: x, y: y } of cells.values()){
                if (this.tilemapMetaProvider.getMapDeltaAt(x, y, "sky")?.removed) continue;
                // Under the storey above, the roof is its ceiling: that floor is drawn over it, and the
                // roof would only show as a sliver beneath the upper storey's front edge.
                if (this.tilemapMetaProvider.isRoofCoveredAt(x, y)) continue;
                const roofTile = sky?.[x]?.[y];
                // Older prototype camps had an empty sky layer or floor art in it. Reconstruct
                // their roof with the manual builder rather than painting floor tiles overhead.
                const tile = roofTile && roofTile !== "0" && this.tilemapMetaProvider.resolveTileSet(roofTile)?.tilesetId !== "floors" ? roofTile : this.houseRoofFallback.get(`${x},${y}`);
                if (!tile || tile === "0") continue;
                painted.set(`${x},${y}`, {
                    x: x,
                    y: y,
                    tile: tile
                });
            }
            for (const { x: x, y: y, tile: tile } of painted.values()){
                const texture = (0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(this.tilemapMetaProvider.resolveTilesetTileId(tile));
                this.houseRoof.tile(texture, x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                const tileset = this.tilemapMetaProvider.resolveTileSet(tile);
                const [left, top, right, bottom] = (0, $b115d5752cc44167$export$34d697321b2dd5d4)(tileset?.tilesetId, Number(tile) - tileset?.firstGid);
                const px = x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + left, py = y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + top;
                const width = right - left, height = bottom - top;
                this.recordRoofArtwork(this.houseRoof, new (0, $6qzqq.Rectangle)(px, py + this.houseRoof.y, width, height));
                this.renderedOcclusionTiles.add(this.houseRoof, new (0, $6qzqq.Rectangle)(px, py, width, height));
                // A drop shadow under the roof, only while the sun's building shadows are off: it leans
                // down and to the right, against the sun everything else casts with.
                if (!this.renderedWithBuildingShadow) this.houseRoofDepth.beginFill(0x151018, 0.17).drawRect(px + 4, py + 6, width, height).endFill();
                // The exposed south face gives the roof thickness; never draw seams
                // across connected interior tiles. Respect the wooden art's alpha bounds.
                if (bottom < (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) || !painted.has(`${x},${y + 1}`)) this.houseRoofDepth.beginFill(0x302019, 0.65).drawRect(px, py + height, width, 3).endFill();
            }
            this.shadeRoofSlopes(painted);
        };
        this.shadeRoofSlopes = (painted)=>{
            const provider = this.tilemapMetaProvider;
            const has = (x, y)=>painted.has(`${x},${y}`);
            const pitched = this.pitchedRoofTileIds();
            const art = (tile)=>{
                const tileset = provider.resolveTileSet(tile);
                const [left, top, right, bottom] = (0, $b115d5752cc44167$export$34d697321b2dd5d4)(tileset?.tilesetId, Number(tile) - tileset?.firstGid);
                return {
                    left: left,
                    top: top,
                    right: right,
                    bottom: bottom
                };
            };
            const gray = (v)=>{
                const c = Math.max(0, Math.min(255, Math.round(255 * v)));
                return c << 16 | c << 8 | c;
            };
            for (const { x: x, y: y, tile: tile } of painted.values()){
                let top = y, bottom = y;
                while(has(x, top - 1))top--;
                while(has(x, bottom + 1))bottom++;
                const { left: left, top: artTop, right: right, bottom: artBottom } = art(tile);
                const px = x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + left, width = right - left;
                const eave = bottom * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + art(painted.get(`${x},${bottom}`).tile).bottom;
                // The ridge as pitchedRoofPiece draws it: on the top row, or a row down when the whole ridge drops there.
                const slope = pitched.has(provider.resolveTilesetTileId(tile));
                const drops = slope && bottom - top >= 4 && (0, $48a990ae9133d7d6$export$bb60dad4b331947b)((cx, cy)=>has(cx, cy), x, top).startsWith("back.");
                const ridge = top * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (drops ? (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) : 0) + (0, $ff5e8e678ac263ca$export$b2b1c48d57b3a943).ridge;
                const west = !has(x - 1, y), east = !has(x + 1, y);
                for(let row = y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + artTop; row < y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + artBottom; row += 2){
                    const front = slope ? Math.max(0, Math.min(1, (row - ridge) / Math.max(1, eave - ridge))) : 0;
                    let v = 1 - (0, $ff5e8e678ac263ca$export$b2b1c48d57b3a943).front * Math.pow(front, 1.3);
                    if (row >= eave - (0, $ff5e8e678ac263ca$export$b2b1c48d57b3a943).eaveRows) v *= (0, $ff5e8e678ac263ca$export$b2b1c48d57b3a943).eave;
                    if (v >= 0.995 && !west && !east) continue;
                    const verge = (0, $ff5e8e678ac263ca$export$b2b1c48d57b3a943).vergeWidth;
                    this.houseRoofShade.beginFill(gray(v), 1).drawRect(px, row, width, 2).endFill();
                    if (west) this.houseRoofShade.beginFill(gray((0, $ff5e8e678ac263ca$export$b2b1c48d57b3a943).verge), 1).drawRect(px, row, verge, 2).endFill();
                    if (east) this.houseRoofShade.beginFill(gray((0, $ff5e8e678ac263ca$export$b2b1c48d57b3a943).verge), 1).drawRect(px + width - verge, row, verge, 2).endFill();
                }
                // The drip: shade dropped past the roof's edge into the slot below the eave, and beside the verges.
                const ease = (t)=>t * t * (3 - 2 * t);
                if (!has(x, y + 1)) for(let d = 0; d < (0, $ff5e8e678ac263ca$export$b2b1c48d57b3a943).dripDepth; d += 2){
                    const v = 1 - (1 - (0, $ff5e8e678ac263ca$export$b2b1c48d57b3a943).drip) * (1 - ease(d / (0, $ff5e8e678ac263ca$export$b2b1c48d57b3a943).dripDepth));
                    this.houseRoofShade.beginFill(gray(v), 1).drawRect(px, y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + artBottom + d, width, 2).endFill();
                }
                for (const [side, dir] of [
                    [
                        west,
                        -1
                    ],
                    [
                        east,
                        1
                    ]
                ]){
                    if (!side) continue;
                    for(let d = 0; d < (0, $ff5e8e678ac263ca$export$b2b1c48d57b3a943).sideWidth; d += 2){
                        const v = 1 - (1 - (0, $ff5e8e678ac263ca$export$b2b1c48d57b3a943).side) * (1 - ease(d / (0, $ff5e8e678ac263ca$export$b2b1c48d57b3a943).sideWidth));
                        const sx = dir < 0 ? px - d - 2 : px + width + d;
                        this.houseRoofShade.beginFill(gray(v), 1).drawRect(sx, y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + artTop, 2, artBottom - artTop).endFill();
                    }
                }
            }
        };
        this.placeGroundRise = ()=>{
            const map1 = this.groundLayerRenderers.get("map1");
            if (!map1 || map1.parent !== this.surface) {
                if (this.groundRise.parent !== this.surface) this.surface.addChild(this.groundRise);
                return;
            }
            const at = this.surface.getChildIndex(map1) + 1;
            if (this.groundRise.parent === this.surface && this.surface.getChildIndex(this.groundRise) === at) return;
            if (this.groundRise.parent) this.groundRise.parent.removeChild(this.groundRise);
            this.surface.addChildAt(this.groundRise, this.surface.getChildIndex(map1) + 1);
        };
        this.placeWater = ()=>{
            if (this.groundRise.parent !== this.surface) {
                if (this.water.parent !== this.surface) this.surface.addChild(this.water);
                return;
            }
            const at = this.surface.getChildIndex(this.groundRise) + 1;
            if (this.water.parent === this.surface && this.surface.getChildIndex(this.water) === at) return;
            if (this.water.parent) this.water.parent.removeChild(this.water);
            this.surface.addChildAt(this.water, this.surface.getChildIndex(this.groundRise) + 1);
        };
        this./**
     * Once a frame, with every body that stands somewhere: legs clipped and ringed where they wade, frames
     * reflected where they stand over the water. Returns who is wading.
     */ updateWater = (contacts, daylight)=>{
            let renderer;
            try {
                renderer = (0, $065c5647ab3ff4dc$export$56359d4511c7424)().renderer;
            } catch  {
                renderer = undefined // no Application (a headless test): no reflections, waders still cut
                ;
            }
            return this.water.update(contacts, this.surface, renderer, daylight ?? 1);
        };
        this./** px of water at a world point, undefined on dry land. */ waterDepthAt = (px, py)=>this.water.depthAt(px, py);
        this.updateBuildingShadow = ()=>{
            const config = (0, $ff5e8e678ac263ca$export$c83a039e3272b805)();
            // The old roof drop shadow stands in while these are off: a toggle repaints the roof.
            if (this.renderedWithBuildingShadow !== undefined && this.renderedWithBuildingShadow !== !!config.enabled) {
                this.renderedWithBuildingShadow = undefined;
                this.rerender();
            }
            const provider = this.tilemapMetaProvider;
            if (provider?.roomId !== this.shadeRoomId) {
                if (this.shadeRoomId !== undefined) (0, $a1ff1a141ce12c85$export$521911947bc5fb90)(this.shadeRoomId, this);
                this.shadeRoomId = provider?.roomId;
            }
            if (!config.enabled || !provider) {
                this.buildingShadow.visible = false;
                this.contactShadow.visible = false;
                this.roofCastShadow.visible = false;
                this.wallHalo.visible = false;
                this.archShade.visible = false;
                this.shadeSprites(0, (0, $ff5e8e678ac263ca$export$f4641cf88636a32d).faces, 0x000000);
                if (provider) (0, $a1ff1a141ce12c85$export$274c9a44d26e84dc)(provider.roomId, 0);
                return;
            }
            const storeys = [];
            for(let p = provider; p && !storeys.includes(p); p = p.getUpperFloorProvider())storeys.push(p);
            // The sun by day, the moon by night: the whole world re-casts the other way when they swap (unseen, both faded out).
            const light = (0, $ff5e8e678ac263ca$export$955c453c49e43c9f)(this.brightness(), this.underSky());
            const sun = {
                x: light.x,
                y: light.y
            };
            this.shadowSun = sun;
            const indoors = config.indoors !== false;
            const softness = config.softness ?? 1.25;
            const color = config.color ?? (0, $ff5e8e678ac263ca$export$f4641cf88636a32d).color;
            const contactAlpha = config.contact ?? (0, $ff5e8e678ac263ca$export$f4641cf88636a32d).contact;
            const contactColor = config.contactColor ?? (0, $ff5e8e678ac263ca$export$f4641cf88636a32d).contactColor;
            const contactReach = config.contactReach ?? (0, $ff5e8e678ac263ca$export$f4641cf88636a32d).contactReach;
            const contactSoftness = config.contactSoftness ?? (0, $ff5e8e678ac263ca$export$f4641cf88636a32d).contactSoftness;
            const foliage = (0, $5e8d3400ffcaf54d$export$af4bed2901273a93)();
            const foliageDepth = foliage.depth ?? 0.5;
            const silhouettes = foliage.silhouettes !== false;
            const grassStrength = foliage.grass ?? (0, $5e8d3400ffcaf54d$export$44b73c9c83559d98).grass;
            // The storey below's roofs are walked on wherever this storey has no floor: they take its shadows too.
            const below = provider.twoStoreyHouse?.floor > 0 ? provider.getFloorSupportProvider() : undefined;
            const version = [
                below,
                ...storeys
            ].map((p)=>p ? `${p.roomId}:${p.getPresentationVersion()}` : "").join("|") + `|${0, $2751e0027a1b432f$export$de62489b685ceb}:${0, $2751e0027a1b432f$export$42b4af315a0c8aa1}|${sun.x}:${sun.y}|${indoors}:${softness}:${color}|${contactReach}:${contactSoftness}:${contactColor}` + `|${(0, $126d618cffb761ba$export$bcea76f852eb0b92)()}|${this.houseRoofCells.size}` + `|${!!foliage.enabled}:${foliageDepth}:${silhouettes}:${grassStrength}`;
            // A plant whose art was still loading is looked for again, now and then.
            if (this.foliageRetryAt !== undefined && performance.now() >= this.foliageRetryAt) this.checkedShadowVersion = undefined;
            // Re-cast in turn with the frame's other heavy work (frame_work_budget.ts): a frame late, the shade of a wall just
            // laid is not missed; the first cast, or a retry for art that was loading, does not wait.
            if (version !== this.checkedShadowVersion && (this.checkedShadowVersion === undefined || (0, $a17a83e5cb2d0838$export$666b3b940e8c9ba8)())) {
                this.checkedShadowVersion = version;
                const stack = storeys.map(this.shadowStorey);
                if (below) stack[0] = {
                    ...stack[0],
                    roofsBelow: this.shadowStorey(below).roofs
                };
                const shadowOptions = {
                    sun: sun,
                    rise: (0, $2751e0027a1b432f$export$de62489b685ceb),
                    roofLift: (0, $2751e0027a1b432f$export$42b4af315a0c8aa1),
                    indoors: indoors
                };
                // The shade on the house roof below is this storey's (bodies walk on it), but that storey draws it (roofCastShadow).
                const belowHouse = below?.getHousePresentation();
                const roofApart = (0, $2751e0027a1b432f$export$bec9e2f2535fb41)(belowHouse) ? {
                    cells: new Set((0, $2751e0027a1b432f$export$149797a16feb3a10)(belowHouse).map((0, $2751e0027a1b432f$export$d3423e7ce2638637))),
                    out: []
                } : undefined;
                const castKey = `${(0, $080b7304e1fb664d$export$fa4605c55ca778c6)(stack)}|${stack[0].floor}|${sun.x}:${sun.y}|${(0, $2751e0027a1b432f$export$de62489b685ceb)}:${(0, $2751e0027a1b432f$export$42b4af315a0c8aa1)}|${indoors}|` + (roofApart ? [
                    ...roofApart.cells
                ].join(";") : "-");
                let cast = this.castBuildings;
                if (cast?.key !== castKey) {
                    const polygons = (0, $080b7304e1fb664d$export$a3c5f8cac73c364b)(stack, stack[0].floor, shadowOptions, roofApart);
                    cast = this.castBuildings = {
                        key: castKey,
                        polygons: polygons,
                        apart: roofApart?.out ?? [],
                        posts: (0, $080b7304e1fb664d$export$d619e0645ed0f317)(stack, stack[0].floor, shadowOptions),
                        shadedWalls: (0, $59778fc6a8174634$export$d27dc3c922b5e34d)(stack, stack[0].floor, shadowOptions, roofApart?.cells)
                    };
                } else if (roofApart) roofApart.out.push(...cast.apart);
                // Copied: the plants' and the roof-apart polygons are added to it below.
                const polygons = [
                    ...cast.polygons
                ];
                const drawnApart = new Set(roofApart?.out);
                polygons.push(...drawnApart);
                // The buildings' own come first: tall art takes only theirs (shadeSprites).
                const buildingPolygons = polygons.length;
                this.foliageRetryAt = undefined;
                let stamps = [];
                let grass = [];
                let feet = [];
                if (foliage.enabled) {
                    const plants = (0, $5e8d3400ffcaf54d$export$ea55fd34f8e4f96e)(provider, {
                        sun: sun,
                        depth: foliageDepth,
                        silhouettes: silhouettes,
                        grass: grassStrength
                    }, this.compositeTileRenderer.denseCopyLifts);
                    polygons.push(...plants.polygons);
                    stamps = plants.stamps;
                    grass = plants.grass;
                    feet = plants.feet;
                    if (plants.pending) this.foliageRetryAt = performance.now() + 500;
                }
                // Furniture casts with the plants: its shade is published, so a body by a table is in it.
                // Indoors (unless window.buildingShadow.indoors), under a roof or the floor above: no sun to cast with.
                const over = stack[1];
                const indoorCells = indoors ? undefined : new Set([
                    ...stack[0].roofs,
                    ...over?.slab ?? [],
                    ...over?.surface ?? []
                ]);
                this.wallCover = indoorCells;
                // A room seen through an arch cut over its doorway here: the storey below's floor just inside is indoors, out
                // of the sun's shade, and showed lit through the vault where a gate's passage shows shaded.
                this.archShade.clear();
                if (below && stack[0].undrawn) {
                    const lower = this.shadowStorey(below);
                    const inside = (0, $080b7304e1fb664d$export$8b64b2fbc59ce7d4)([
                        lower,
                        ...stack
                    ], lower.floor, shadowOptions);
                    stack[0].undrawn.forEach((cell)=>{
                        const [x, y] = cell.split(",").map(Number);
                        if (inside.has(`${x},${y - 1}`)) this.archShade.beginFill(config.archColor ?? (0, $ff5e8e678ac263ca$export$f4641cf88636a32d).archColor, 1).drawRect(x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)).endFill();
                    });
                }
                const furniture = (0, $0dd042549bc41733$export$ed46199a19bb75d)(provider, sun, indoorCells ? (x, y)=>indoorCells.has(`${x},${y}`) : undefined);
                stamps = stamps.concat(furniture.stamps);
                feet = feet.concat(furniture.feet);
                if (furniture.pending) this.foliageRetryAt = performance.now() + 500;
                const contact = (0, $080b7304e1fb664d$export$2a9d9a1fbfe119)(stack, stack[0].floor, shadowOptions, contactReach, feet);
                const contactGeometry = `${contactSoftness}|${contactColor}|${(0, $080b7304e1fb664d$export$d0bdf2835f4bf05)(contact)}`;
                if (contactGeometry !== this.renderedContactGeometry) {
                    this.renderedContactGeometry = contactGeometry;
                    this.contactPolygons = contact;
                    this.contactShadow.draw(contact, contactSoftness, [], contactColor);
                }
                (0, $a1ff1a141ce12c85$export$5ce2d550e02675c1)(provider.roomId, this, polygons, stamps, color, buildingPolygons);
                // Drawn with them, but nobody stands in it: upper posts' shadows on their own level.
                const drawn = polygons.filter((polygon)=>!drawnApart.has(polygon)).concat(cast.posts);
                // Most edits (a tree felled, grass cut) leave every shadow as it was: bake only on a change.
                // Long grass's shade is drawn too, after the rest (over a full shadow it changes nothing), but not published.
                const geometry = `${softness}|${color}|${(0, $080b7304e1fb664d$export$d0bdf2835f4bf05)(drawn)}|${(0, $7fbbd538ea219bbf$export$4afa64c4106f0e32)(stamps)}|${(0, $7fbbd538ea219bbf$export$4afa64c4106f0e32)(grass)}`;
                if (geometry !== this.renderedShadowGeometry) {
                    this.renderedShadowGeometry = geometry;
                    this.shadowPolygons = drawn;
                    this.shadowStamps = stamps;
                    this.grassStamps = grass;
                    // Stamped silhouettes cannot be cut like the polygons: they are masked to the floor when baked.
                    this.buildingShadow.draw(drawn, softness, [
                        ...stamps,
                        ...grass
                    ], color, (0, $080b7304e1fb664d$export$a2eb5f084d559d2)(stack, stack[0].floor, shadowOptions));
                }
                // This storey's house roof, under what the storeys above cast across the ground round it.
                const roofKey = [
                    ...this.houseRoofCells
                ].join(";");
                if (cast.roofKey !== roofKey) {
                    cast.roofKey = roofKey;
                    cast.roof = this.houseRoofCells.size ? (0, $080b7304e1fb664d$export$6578b6db898b0e14)(stack, stack[0].floor, this.houseRoofCells, shadowOptions) : [];
                }
                const roofShade = cast.roof ?? [];
                const roofGeometry = `${softness}|${color}|${(0, $080b7304e1fb664d$export$d0bdf2835f4bf05)(roofShade)}`;
                if (roofGeometry !== this.renderedRoofShadowGeometry) {
                    this.renderedRoofShadowGeometry = roofGeometry;
                    this.roofShadowPolygons = roofShade;
                    this.roofCastShadow.draw(roofShade, softness, [], color);
                }
            }
            this.buildingShadow.alpha = (config.alpha ?? (0, $ff5e8e678ac263ca$export$f4641cf88636a32d).alpha) * light.strength;
            this.buildingShadow.visible = this.buildingShadow.alpha > 0 && (this.shadowPolygons.length > 0 || this.shadowStamps.length > 0 || this.grassStamps.length > 0);
            // The shade's strength, shapes or not: bodies cast their own shadows by it (lpc_composite_sprite).
            (0, $a1ff1a141ce12c85$export$274c9a44d26e84dc)(provider.roomId, this.buildingShadow.alpha, sun);
            this.contactShadow.alpha = contactAlpha * light.strength;
            this.contactShadow.visible = this.contactShadow.alpha > 0 && this.contactPolygons.length > 0;
            this.archShade.alpha = (config.arch ?? (0, $ff5e8e678ac263ca$export$f4641cf88636a32d).arch) * light.strength;
            this.archShade.visible = this.archShade.alpha > 0 && this.archShade.geometry.graphicsData.length > 0;
            this.roofCastShadow.alpha = this.buildingShadow.alpha * this.houseRoof.alpha;
            this.roofCastShadow.visible = this.houseRoof.visible && this.roofCastShadow.alpha > 0 && this.roofShadowPolygons.length > 0;
            // By the shade's strength whether or not this storey has a shadow of its own: a wall's south face is out of the
            // sun on every storey, and a tower's closed middle storeys (no shadows) drawn with untinted faces between
            // tinted ones banded its face storey by storey. Only sprites standing in a shadow take more than the faces' tint.
            this.shadeSprites(this.buildingShadow.alpha, config.faces ?? (0, $ff5e8e678ac263ca$export$f4641cf88636a32d).faces, color, config.sprites !== false);
            // The walls' halo: rebuilt when the walls' art changes, re-baked only where it changed.
            const haloKey = `${this.artworkVersion}|${(0, $126d618cffb761ba$export$bcea76f852eb0b92)()}`;
            // A re-bake takes its turn with the frame's other heavy work (frame_work_budget.ts): after a storey is drawn again
            // its halo follows a frame or two later. The first bake in a room does not wait.
            if (haloKey !== this.renderedHaloKey && (this.renderedHaloKey === undefined || (0, $a17a83e5cb2d0838$export$666b3b940e8c9ba8)())) {
                this.renderedHaloKey = haloKey;
                const pieces = [];
                const raised = (provider.twoStoreyHouse?.floor ?? 0) > 0;
                for (const [cellKey, sprites] of this.spritedCellSprites)for (const sprite of sprites){
                    if (!sprite.wallArt || sprite.destroyed || !sprite.visible || !sprite.texture?.valid) continue;
                    // Above the ground a south face spills its halo only onto a floor of its own storey in front of it.
                    // With none there (a tower's outside face) the spill fell on the face of the storey below, a dark band
                    // at every storey of the tower by day.
                    if (raised && sprite.wallFace) {
                        const [x, y] = cellKey.split("-").map(Number);
                        if (!(0, $ba9ee37aae1b90d9$export$fd1b3f060dedf495)(provider, x, y + 1)) continue;
                    }
                    pieces.push({
                        texture: sprite.texture,
                        x: sprite.x,
                        y: sprite.y,
                        width: sprite.texture.width,
                        height: sprite.texture.height
                    });
                }
                this.wallHalo.draw(pieces, (0, $72f83e51a7379926$export$ac7d244648d3c160).wall.softness, (0, $72f83e51a7379926$export$ac7d244648d3c160).wall.spread);
            }
            this.wallHalo.alpha = (config.halo ?? (0, $72f83e51a7379926$export$ac7d244648d3c160).wall.alpha) * light.strength;
            this.wallHalo.visible = this.wallHalo.alpha > 0 && this.wallHalo.groupCount > 0;
        };
        this.shadeSprites = (strength, faces, color, sprites = true)=>{
            const provider = this.tilemapMetaProvider;
            const key = `${this.renderedShadowGeometry}|${this.artworkVersion}|${this.surfaceObjectsByKey.size}|${this.shadowSun.x}:${this.shadowSun.y}`;
            if (provider && key !== this.shadedSpritesKey) {
                this.shadedSpritesKey = key;
                this.shadedTints = undefined;
                const before = new Set(this.shadedSprites.map((entry)=>entry.sprite));
                const roomId = provider.roomId, sun = this.shadowSun;
                const entries = [];
                const share = (points)=>points.reduce((hits, p)=>hits + ((0, $a1ff1a141ce12c85$export$55e3e87f5132cc63)(roomId, p.x, p.y) ? 1 : 0), 0) / points.length;
                // Furniture casts now: it looks for its shade sunward of its piece's foot, past its own shadow.
                const pieces = new Map((0, $0dd042549bc41733$export$10aded4afe862f4e)(provider).map((piece)=>[
                        `${piece.parent.x},${piece.parent.y}`,
                        piece
                    ]));
                // How far into shade each sprite is drawn now, by where it stands: a full render makes every
                // sprite afresh, and a sprite under a felled tree should still ease out of its shade.
                const shown = this.shadeShown;
                this.shadeShown = new Map();
                const add = (spriteKey, sprite, face, target, line)=>{
                    const was = shown.get(spriteKey);
                    if (target <= 0 && !face && !(was > 0)) return;
                    entries.push({
                        key: spriteKey,
                        sprite: sprite,
                        face: face,
                        target: target,
                        shown: was ?? (this.shadedSpritesSeen ? 0 : target),
                        line: line
                    });
                };
                const owners = new Map();
                this.spritedCellSprites.forEach((cellSprites, cellKey)=>{
                    const [cx, cy, layerId] = cellKey.split("-");
                    const x = Number(cx), y = Number(cy);
                    const parent = provider.getMapDeltaAt(x, y, layerId)?.context?.parent ?? {
                        x: x,
                        y: y
                    };
                    cellSprites.forEach((sprite, index)=>{
                        // Art drawn on the floor, under the shade layer (a stair down), is shaded by the layer itself.
                        if (sprite.destroyed || !(sprite instanceof (0, $7Bs2Z.Sprite)) || sprite.zIndex < 50) return;
                        const wall = !!sprite.wallArt;
                        const piece = layerId === "sprite2" ? pieces.get(`${parent.x},${parent.y}`) : undefined;
                        // A wall piece takes the shade of buildings taller than its wall only (sprite_shade.ts shadedWallPieces).
                        // Not one under its own building's cover: the cover keeps its foot out of the sun's shade, so only a piece
                        // whose sample point fell just outside (an outer end beside a shaded corridor, the jamb of a shaded gate)
                        // went dark, a square on a lit face. Its face takes the faces' tint like every other.
                        const target = wall && this.wallCover?.has(`${parent.x},${parent.y}`) ? 0 : wall ? this.castBuildings?.shadedWalls.has(`${parent.x},${parent.y}`) ? 1 : 0 : share(piece ? (0, $59778fc6a8174634$export$aa26ac95af79b0da)(piece.left * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), piece.top * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), (piece.right - piece.left + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), Math.min((0, $59778fc6a8174634$export$827cbfd2c009f1c5), (piece.bottom - piece.top + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), sun, true) : (0, $59778fc6a8174634$export$bdcc8456024c0d74)(parent.x, parent.y));
                        add(`${cellKey}#${index}`, sprite, !!sprite.wallFace, target);
                    });
                });
                this.surfaceObjectsByKey.forEach((object, objectKey)=>{
                    if (!object.compositeTileId) return;
                    object.spriteSet.forEach((sprite, index)=>{
                        if (sprite.destroyed) return;
                        const width = Math.abs(sprite.width), height = Math.abs(sprite.height);
                        const casts = (0, $5e8d3400ffcaf54d$export$3373223240634c37)(object.tilesetId, object.compositeTileId) ?? true;
                        const left = sprite.x - sprite.anchor.x * width, top = sprite.y - sprite.anchor.y * height;
                        const points = (0, $59778fc6a8174634$export$aa26ac95af79b0da)(left, top, width, height, sun, casts);
                        if (points) {
                            add(`${objectKey}#${index}`, sprite, false, share(points));
                            return;
                        }
                        // Tall art (a tree) is shaded only as high as the buildings' shade climbs it.
                        const climb = (0, $59778fc6a8174634$export$9df2d71819810102)({
                            x: left + width / 2,
                            y: top + height - 4
                        }, height, sun, (px, py)=>(0, $a1ff1a141ce12c85$export$55e3e87f5132cc63)(roomId, px, py, true));
                        const spriteKey = `${objectKey}#${index}`;
                        owners.set(spriteKey, ()=>this.surfaceObjectsByKey.get(objectKey)?.spriteSet[index] === sprite);
                        add(spriteKey, sprite, false, climb > 0 ? 1 : 0, climb > 0 ? (height - 4 - climb) / (Math.abs(sprite.scale.y) || 1) : undefined);
                    });
                });
                // Each climbing shade kept while its art and line are, else made afresh.
                const climbShades = new Map();
                this.climbing = entries.filter((entry)=>entry.line !== undefined);
                for (const entry of this.climbing){
                    const kept = this.climbShades.get(entry.key);
                    if (kept?.isFor(entry.sprite, entry.line)) {
                        this.climbShades.delete(entry.key);
                        climbShades.set(entry.key, kept);
                        continue;
                    }
                    const made = (0, $5b10e7700721e8ad$export$3c8fc0805a00d47e).create(entry.sprite, entry.line, owners.get(entry.key) ?? (()=>false));
                    if (made) climbShades.set(entry.key, made);
                }
                this.climbShades.forEach((shade)=>shade.destroy());
                this.climbShades = climbShades;
                // Sprites first seen with the room take their shade at once; later changes ease.
                this.shadedSpritesSeen = true;
                entries.forEach(({ sprite: sprite })=>before.delete(sprite));
                before.forEach((sprite)=>{
                    if (!sprite.destroyed) sprite.tint = 0xffffff;
                });
                this.shadedSprites = entries;
                this.shadeEasing = entries.some((entry)=>entry.shown !== entry.target);
            }
            // Ease every sprite toward its shade over a shadow fade's length (baked_groups.ts).
            const now = performance.now(), dt = Math.min(100, now - (this.shadeEasedAt ?? now));
            this.shadeEasedAt = now;
            let eased = false;
            if (this.shadeEasing) {
                const step = dt / (2 * (0, $cb0c2ff63ebff87f$export$15a69dcd528d8816));
                let still = false;
                for (const entry of this.shadedSprites){
                    if (entry.shown === entry.target) continue;
                    entry.shown = entry.shown < entry.target ? Math.min(entry.target, entry.shown + step) : Math.max(entry.target, entry.shown - step);
                    eased = true;
                    still = still || entry.shown !== entry.target;
                }
                this.shadeEasing = still;
            }
            this.shadedSprites.forEach((entry)=>{
                if (entry.shown > 0) this.shadeShown.set(entry.key, entry.shown);
            });
            // Climbing shades follow their art (sway, fall, fade) every frame.
            for (const entry of this.climbing)this.climbShades.get(entry.key)?.sync(sprites ? strength * entry.shown : 0, color);
            const faceTint = (0, $ff5e8e678ac263ca$export$417fb4c1160a072e)(faces, strength);
            const tints = `${faceTint}|${sprites ? Math.round(strength * 100) : 0}|${color}`;
            if (tints === this.shadedTints && !eased) return;
            this.shadedTints = tints;
            for (const { sprite: sprite, face: face, shown: shown, line: line } of this.shadedSprites){
                if (sprite.destroyed) continue;
                // Tall art keeps its own light: its shade is drawn over it, as high as it climbs.
                const shadeT = sprites && shown > 0 && line === undefined ? (0, $a1ff1a141ce12c85$export$4680da062056e5ae)(0xffffff, strength * shown, color) : 0xffffff;
                sprite.tint = face ? (0, $59778fc6a8174634$export$b30b2f234be6041e)(faceTint, shadeT) : shadeT;
            }
        };
        this.shadowStorey = (p)=>{
            const floor = p.twoStoreyHouse?.floor ?? 0;
            const walls = new Set(), surface = new Set(), slab = new Set();
            const roofs = new Set(), pitched = new Set();
            p.getMapDeltas().forEach((delta)=>{
                if (delta.layerId !== "sprite") return;
                // A wall's own cell, or a piece of a run standing on its cell though the builder parents it to the wall
                // below (the side of a room above its corner): either way a wall stands there and casts.
                const piece = delta.blocking && !delta.removed && !delta.context?.previewTarget && (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[delta.context?.itemType]?.buildType === "wall";
                if (piece || p.wallItemAt(delta.x, delta.y)) walls.add(`${delta.x},${delta.y}`);
            });
            const below = p.getFloorSupportProvider();
            const undrawn = new Set();
            p.resolveTileMapFromLayerId("map2")?.forEach((column, x)=>column?.forEach((tile, y)=>{
                    if (!tile || tile === "0" || p.isFloorOpeningAt(x, y)) return;
                    surface.add(`${x},${y}`);
                    if (!p.isStairAt(x, y)) slab.add(`${x},${y}`);
                    // Under an arch over a gateway below the floor is not drawn (the passage shows through it): no shade lands
                    // there, though the vault still shades the passage and the floor round it is drawn as before.
                    if (walls.has(`${x},${y}`) && (0, $ba9ee37aae1b90d9$export$b3a01c67d8d60400)(below, p, x, y)) undrawn.add(`${x},${y}`);
                }));
            const pitchedTiles = this.pitchedRoofTileIds();
            p.resolveTileMapFromLayerId("sky")?.forEach((column, x)=>column?.forEach((tile, y)=>{
                    if (!tile || tile === "0" || p.isHiddenTile(tile) || p.getMapDeltaAt(x, y, "sky")?.removed) return;
                    roofs.add(`${x},${y}`);
                    if (pitchedTiles.has(p.resolveTilesetTileId(tile))) pitched.add(`${x},${y}`);
                }));
            // Materials that cast other than wall-stone: a castle wall's thick body, merlons' free blocks. Merlons (a
            // parapet) stand on the wall below with no floor; the top they leave open between them takes their shade.
            const profiles = new Map();
            const parapets = new Set();
            walls.forEach((cell)=>{
                const [x, y] = cell.split(",").map(Number);
                const definition = this.wallDefinitionFor(p.wallItemAt(x, y));
                if (definition?.shadow) profiles.set(cell, definition.shadow);
                if (definition?.parapet && !surface.has(cell) && below?.wallItemAt(x, y)) parapets.add(cell);
            });
            return {
                floor: floor,
                ground: floor === 0,
                walls: walls,
                surface: surface,
                slab: slab,
                roofs: roofs,
                pitched: pitched,
                ...profiles.size ? {
                    profiles: profiles
                } : {},
                ...parapets.size ? {
                    parapets: parapets
                } : {},
                ...undrawn.size ? {
                    undrawn: undrawn
                } : {}
            };
        };
        this.pitchedRoofTileIds = ()=>{
            if (this.pitchedRoofTiles?.source !== (0, $4d955fa5af64f75a$export$11b99b57097122cd)) {
                const tiles = new Set();
                (0, $4d955fa5af64f75a$export$11b99b57097122cd).forEach((definition)=>{
                    if (!definition.pitched) return;
                    const add = (tilePos)=>tiles.add(`${definition.tilesetId}-${tilePos + 1}`);
                    Object.values(definition.pitched).forEach(add);
                    Object.values(definition.ornaments ?? {}).forEach((ornament)=>Object.values(ornament.pieces ?? {}).forEach(add));
                });
                this.pitchedRoofTiles = {
                    source: (0, $4d955fa5af64f75a$export$11b99b57097122cd),
                    tiles: tiles
                };
            }
            return this.pitchedRoofTiles.tiles;
        };
        this.brightness = ()=>this.visibility?.darkness ?? this.logic?.clientRenderer?.map?.()?.getVisibility?.()?.darkness;
        this.underSky = ()=>{
            const logic = this.logic;
            const visibility = this.visibility ?? logic?.clientRenderer?.map?.()?.getVisibility?.();
            return logic?.scene?.daylight !== undefined && !visibility?.fullOcclusion;
        };
        this./** The shadow polygons on this storey, in its own pixels (for tests and for shading bodies). */ getBuildingShadowPolygons = ()=>this.shadowPolygons;
        this./** The plants' silhouettes stamped with those polygons, in the same pixels. */ getBuildingShadowStamps = ()=>this.shadowStamps;
        this.finalizeRendering = ()=>{
            this.compositeSprites = this.liveComposites();
            this.artworkVersion++;
            this.rebuildRoofComposites();
            if (this.features.minimap) this.miniMapSurface.update(this.tilemapMetaProvider);
            this.needsRender = false;
            this.tileEffectSystem.applyDamageVisualizationToExistingTiles(this.surfaceObjectsByKey);
            this.paintedRoomId = this.roomId;
        };
        this.liveComposites = ()=>[
                ...this.surfaceObjectsByKey.values()
            ].filter((object)=>!!object.compositeTileId).flatMap((object)=>object.spriteSet);
        this./** The roofs and walls this storey draws, which lower storeys' trees can stand in front of (its own pixels). */ getCeilingArtwork = ()=>{
            const artwork = [
                ...this.roofArtwork
            ].map(([owner, bounds])=>({
                    owner: owner,
                    bounds: bounds
                }));
            for (const sprites of this.spritedCellSprites.values())for (const sprite of sprites)artwork.push({
                owner: sprite,
                upright: true,
                bounds: [
                    new (0, $6qzqq.Rectangle)(sprite.x, sprite.y, sprite.width, sprite.height)
                ]
            });
            return artwork;
        };
        this.// Hand the map the wind that bends its grass. Set once by the renderer at construction; the map
        // passes it down to the composite tile renderer, which is what actually builds the grass, and
        // tells it when a full rebuild has taken every blade away.
        setGrassSway = (grassSway)=>{
            this.grassSway = grassSway;
        };
        this.renderSpritedCell = (x, y, tile, layerId, index)=>{
            const tilesetTileId = this.tilemapMetaProvider.resolveTilesetTileId(tile);
            if (tile === "0" || !tile || this.tilemapMetaProvider.isHiddenTile(tile) || tilesetTileId === "lpc-terrain-723") return;
            const delta = this.tilemapMetaProvider.getMapDeltaAt(x, y, layerId);
            const context = delta?.context;
            // What it looks like where storeys meet (a beam, a seamless face); it sorts and takes damage as the tile it is.
            const drawnTileId = layerId === "sprite" ? this.wallSeamTileId(x, y, tilesetTileId, context) : tilesetTileId;
            const belowTile = this.tilemapMetaProvider.resolveTileMapFromLayerId(layerId)?.[x]?.[y + 1];
            const depthItem = {
                x: x,
                y: y,
                context: context,
                tilesetTileId: tilesetTileId,
                belowTilesetTileId: belowTile && belowTile !== "0" ? this.tilemapMetaProvider.resolveTilesetTileId(belowTile) : undefined,
                belowBlocking: this.tilemapMetaProvider.isCollisionAt(x, y + 1)
            };
            const item = {
                x: x,
                y: y,
                tile: tile,
                context: context,
                delta: !!context?.hp ? delta : undefined
            };
            try {
                const fringed = (0, $832b6f4df8293e69$export$398b357e3ce7a4b0)((0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(drawnTileId), tilesetTileId, x, y, this.tilemapMetaProvider, context?.parent);
                const closed = layerId === "sprite" ? this.closeBareWallEdges(fringed, x, y, drawnTileId, context) : fringed;
                const texture = layerId === "sprite" && context?.parent && this.tilemapMetaProvider.wallItemAt(context.parent.x, context.parent.y) ? (0, $5e01909f2a2154f9$export$9f38552cc9744cc9)(closed, this.projectedWallJoints(x, y).map((p)=>({
                        texture: (0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(p.id),
                        dy: p.dy
                    }))) : closed;
                const adaptive = layerId === "sprite2" && (0, $f63a252d2ded274b$export$6d09a325ee084aba)(this.tilemapMetaProvider, {
                    x: x,
                    y: y
                });
                // A wall of a material with trims: its cell baked with them, and what they draw past the cell.
                const trimmed = layerId === "sprite" && context?.parent && (0, $ba9ee37aae1b90d9$export$9f9361b20898f65c)() ? (0, $ba9ee37aae1b90d9$export$e17f160e092cb33a)(this.wallTrimAtlas, this.tilemapMetaProvider, this.wallSeamTileId, x, y, texture) : undefined;
                const g = adaptive ? new (0, $f63a252d2ded274b$export$3fce9c276dbc848)(this.tilemapMetaProvider, {
                    x: x,
                    y: y
                }) : new (0, $7Bs2Z.Sprite)(trimmed?.texture ?? texture);
                if (g instanceof (0, $f63a252d2ded274b$export$3fce9c276dbc848)) this.stackedLadders.add(g);
                this.surface.addChild(g);
                const fine = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                    x: x,
                    y: y
                });
                g.x = fine.x;
                g.y = fine.y;
                g.visible = !this.buildVeil.has(`${x}-${y}-${layerId}`) && (this.tilemapMetaProvider.resolveTileMeta(tile).entityTileId !== "stairs-down" || this.downstairsHasSurface(x, y));
                // A descending stair is an opening in the floor; bodies always draw over it.
                g.zIndex = !adaptive && this.tilemapMetaProvider.resolveTileMeta(tile).entityTileId === "stairs-down" ? 0 : (0, $f78f32798274f66a$export$360f852efd938c01)(index, (0, $f78f32798274f66a$export$6a603ef1f674b5ef)(depthItem));
                if (layerId === "sprite2") {
                    this.orientStairSprite(g, x, y, tile);
                    const hatch = (0, $da5649d79a6bbe55$export$c8dc180c2e5db7f9)(this.tilemapMetaProvider, {
                        x: x,
                        y: y
                    });
                    const stairType = this.tilemapMetaProvider.resolveTileMeta(tile).entityTileId;
                    if (hatch && [
                        "stairs-up",
                        "stairs-down"
                    ].includes(stairType)) this.hatchSprites.add((0, $91d06b361b7153d4$export$6075182e406ebc5b)(g, hatch, stairType === "stairs-up"));
                    else if (!hatch && [
                        "stairs-up",
                        "stairs-down"
                    ].includes(stairType)) {
                        const brokenAt = context?.hatchBrokenAt;
                        const age = (0, $4171652afd996934$export$a86190deb5c4a8d0)() - brokenAt;
                        if (typeof brokenAt === "number" && age >= 0 && age < (0, $da5649d79a6bbe55$export$8090247a39a06ef1)) this.hatchSprites.add((0, $91d06b361b7153d4$export$75c879799cfe3970)(g, brokenAt, stairType === "stairs-up"));
                    }
                }
                const surfaceId = context?.surfaceId;
                const isParent = context?.parent && context.parent?.x === x && context.parent?.y === y;
                // A wall's south face turns from the sun (sun.ts: north-east); its top, drawn on the cell
                // north (a cap, parented to the cell below), and the long top of a north-south run catch it.
                // A covered seam (a storey stands on it) shows the face above running down.
                const wall = layerId === "sprite" && !!context?.parent && this.tilemapMetaProvider.wallItemAt(context.parent.x, context.parent.y);
                if (wall) g.wallArt = true;
                // A parapet's piece is its own top as well as its face, and carries the face's shade in its art.
                if (wall && (isParent || drawnTileId !== tilesetTileId) && !this.wallDefinitionFor(wall)?.parapet) g.wallFace = true;
                this.tileEffectSystem.processSurfaceId(isParent ? tilesetTileId : undefined, surfaceId, g, item.delta);
                const key = `${x}-${y}-${layerId}`;
                this.artworkVersion++;
                this.spritedLayerIds.add(layerId);
                const arr = this.spritedCellSprites.get(key);
                if (arr) arr.push(g);
                else this.spritedCellSprites.set(key, [
                    g
                ]);
                // Trim art past the cell (rubble at the foot, a corner's spur): sorted as the wall, removed with it.
                trimmed?.overflow.forEach((o)=>{
                    const spill = new (0, $7Bs2Z.Sprite)(o.texture);
                    spill.x = g.x + o.dx;
                    spill.y = g.y + o.dy;
                    spill.zIndex = g.zIndex;
                    spill.visible = g.visible;
                    this.surface.addChild(spill);
                    this.spritedCellSprites.get(key).push(spill);
                });
                // Remember which surface this cell registered under so removeSpritedCell can detach these
                // exact sprites from the shared spriteSet on an incremental repaint.
                if (surfaceId) this.spritedCellSurfaceId.set(key, surfaceId);
            } catch (e) {
                (0, $5UG8I.logger).error({
                    tags: [
                        "map",
                        "error"
                    ]
                }, e);
            }
        };
        this.closeBareWallEdges = (texture, x, y, drawnTileId, context)=>{
            const provider = this.tilemapMetaProvider;
            const parent = context?.parent;
            const wall = (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[context?.itemType]?.buildType === "wall" || parent && !!provider.wallItemAt(parent.x, parent.y);
            if (!wall) return texture;
            const own = (0, $3ff1d7a24724a48b$export$80513b7ac8accc2c)((0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(drawnTileId));
            if (!own) return texture;
            const tiles = provider.resolveTileMapFromLayerId("sprite");
            const meets = {
                ...own,
                opaque: {
                    north: [],
                    east: [],
                    south: [],
                    west: []
                }
            };
            [
                "north",
                "east",
                "south",
                "west"
            ].forEach((side)=>meets.opaque[side] = own.opaque[side].map(()=>true));
            const beside = (nx, ny)=>{
                const tile = tiles?.[nx]?.[ny];
                if (!tile || tile === "0" || provider.isHiddenTile(tile)) return undefined;
                const id = provider.resolveTilesetTileId(tile);
                return (0, $3ff1d7a24724a48b$export$80513b7ac8accc2c)((0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(this.wallSeamTileId(nx, ny, id, provider.getMapDeltaAt(nx, ny, "sprite")?.context))) ?? meets;
            };
            const bare = (0, $3ff1d7a24724a48b$export$a669cd95b844f67)(own, {
                north: beside(x, y - 1),
                east: beside(x + 1, y),
                south: beside(x, y + 1),
                west: beside(x - 1, y)
            });
            return (0, $3ff1d7a24724a48b$export$2535f19fc440f33c)(texture, bare, own.outline);
        };
        this.renderSpritedLayer = (tilemap, mapSpriteCaps, index, layerId)=>{
            // The previous per-run buffer/mapSpriteCap "splitter" machinery was vestigial: it only
            // re-assigned each sprite's z-index to the SAME per-cell value it already had (a sprited tile
            // z-sorts by its own structure base row, context.parent.y -- see sprited_tile_zindex.ts). So
            // this is now a straight per-cell render via renderSpritedCell.
            const width = this.tilemapMetaProvider.width();
            const height = this.tilemapMetaProvider.height();
            for(let x = 0; x < width; x++)for(let y = 0; y < height; y++)this.renderSpritedCell(x, y, tilemap[x][y], layerId, index);
        };
        this.wallDefinitionFor = (itemType)=>{
            if (this.wallDefinitions?.source !== (0, $4d955fa5af64f75a$export$7f5e211f9738e851)) this.wallDefinitions = {
                source: (0, $4d955fa5af64f75a$export$7f5e211f9738e851),
                byItem: new Map((0, $4d955fa5af64f75a$export$7f5e211f9738e851).filter((d)=>d.itemType).map((d)=>[
                        d.itemType,
                        d
                    ]))
            };
            return this.wallDefinitions.byItem.get(itemType);
        };
        this.wallSeamTileId = (x, y, tilesetTileId, context, provider = this.tilemapMetaProvider)=>{
            const parent = context?.parent;
            if (!parent || parent.x !== x || y !== parent.y - 1 && y !== parent.y) return tilesetTileId;
            // A top piece carries its wall cell but not always its material: the wall standing there says.
            const itemType = context?.itemType ?? provider.wallItemAt(parent.x, parent.y);
            const definition = this.wallDefinitionFor(itemType);
            if (!definition?.seams || !tilesetTileId.startsWith(`${definition.tilesetId}-`)) return tilesetTileId;
            const piece = (0, $d06e01c1880d4b6a$export$3ad3a12c780212fb)(definition, Number(tilesetTileId.slice(definition.tilesetId.length + 1)) - 1, y === parent.y ? "face" : "top", (0, $d06e01c1880d4b6a$export$a2f415c060ce2b32)(this.wallDefinitionFor(provider.getUpperFloorProvider()?.wallItemAt(parent.x, parent.y))), provider.getFloorSupportProvider()?.wallItemAt(parent.x, parent.y) === itemType, !!provider.wallItemAt(parent.x, parent.y + 1));
            return piece ? `${piece.tilesetId}-${piece.tilePos + 1}` : tilesetTileId;
        };
        this.projectedWallJoints = (x, y)=>{
            const patches = [];
            const seen = new Set([
                this.tilemapMetaProvider
            ]);
            let level = 0;
            const ceiling = this.wallJointCeiling();
            for(let upper = this.tilemapMetaProvider.getUpperFloorProvider(); upper && !seen.has(upper); upper = upper.getUpperFloorProvider()){
                seen.add(upper);
                level++;
                if ((upper.twoStoreyHouse?.floor ?? 0) > ceiling) continue;
                const offset = level * (0, $2751e0027a1b432f$export$de62489b685ceb);
                const start = Math.floor(y + offset / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                for(let row = start; row <= Math.ceil(y + offset / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)); row++){
                    const item = upper.wallItemAt(x, row), definition = this.wallDefinitionFor(item);
                    if (!definition?.seams?.joints) continue;
                    const delta = upper.getMapDeltaAt(x, row, "sprite");
                    const tile = upper.resolveTileMapFromLayerId("sprite")?.[x]?.[row];
                    if (!tile || !delta) continue;
                    const id = this.wallSeamTileId(x, row, upper.resolveTilesetTileId(tile), delta.context, upper);
                    if (!Object.values(definition.seams.joints).some((ref)=>id === `${ref.tilesetId}-${ref.tilePos + 1}`)) continue;
                    patches.push({
                        id: id,
                        dy: row * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - offset - y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                    });
                }
            }
            return patches;
        };
        this.wallJointCeiling = ()=>{
            const viewer = this.viewEntity ?? this.logic.playerEntity;
            if (!viewer?.location || (0, $9b85be211484fac5$export$4a8c8628e4e44ada)(viewer.floorFall)) return Infinity;
            const seen = new Set();
            for(let p = this.tilemapMetaProvider; p && !seen.has(p); p = p.getUpperFloorProvider()){
                seen.add(p);
                if (p.roomId !== viewer.location.roomId) continue;
                const house = p.getHousePresentation();
                return house && (0, $2751e0027a1b432f$export$2c01c05cc2cc0271)(house, viewer.location) ? house.floor : Infinity;
            }
            return Infinity;
        };
        this.wallSeamCells = ()=>{
            const provider = this.tilemapMetaProvider;
            const upper = provider?.getUpperFloorProvider(), lower = provider?.getFloorSupportProvider();
            const covered = [], continued = [], lintels = [];
            const arched = [];
            if (!provider || !upper && !lower) return {
                covered: covered,
                continued: continued,
                lintels: lintels,
                arched: arched
            };
            const wallCells = (p)=>p.getMapDeltas().filter((d)=>d.layerId === "sprite" && p.wallItemAt(d.x, d.y));
            if (upper) wallCells(upper).forEach(({ x: x, y: y })=>{
                const own = provider.wallItemAt(x, y);
                if (own) {
                    if ((0, $d06e01c1880d4b6a$export$a2f415c060ce2b32)(this.wallDefinitionFor(upper.wallItemAt(x, y)))) covered.push(`${x},${y}`);
                    return;
                }
                // The storey above cuts an arch over a gateway of its material's span: the arch is the lintel.
                if ((0, $ba9ee37aae1b90d9$export$b3a01c67d8d60400)(provider, upper, x, y)) return;
                // Else a lintel spans the doorway: a gap in a run of this storey's walls, as wide as the storey above may wall
                // over (the server's GATEWAY_SPAN), in the material of the wall at its west jamb.
                const gap = (cx)=>!provider.wallItemAt(cx, y) && !!upper.wallItemAt(cx, y);
                let x0 = x, x1 = x;
                while(x - x0 < $409e08612bd4cd6f$var$LINTEL_SPAN && gap(x0 - 1))x0--;
                while(x1 - x < $409e08612bd4cd6f$var$LINTEL_SPAN && gap(x1 + 1))x1++;
                if (x1 - x0 + 1 > $409e08612bd4cd6f$var$LINTEL_SPAN) return;
                const west = provider.wallItemAt(x0 - 1, y), east = provider.wallItemAt(x1 + 1, y);
                const material = west && east ? this.wallDefinitionFor(west) : undefined;
                if (material?.seams?.lintel) lintels.push({
                    x: x,
                    y: y,
                    itemType: west
                });
            });
            if (lower) wallCells(provider).forEach(({ x: x, y: y })=>{
                const own = provider.wallItemAt(x, y);
                const seams = this.wallDefinitionFor(own)?.seams;
                if ((seams?.style === "seamless" || seams?.joints) && lower.wallItemAt(x, y) === own) continued.push(`${x},${y}${seams.joints ? `:${provider.wallItemAt(x, y + 1) ? "internal" : "end"}` : ""}`);
                if ((0, $ba9ee37aae1b90d9$export$b3a01c67d8d60400)(lower, provider, x, y)) arched.push(`${x},${y}`);
            });
            return {
                covered: covered,
                continued: continued,
                lintels: lintels,
                arched: arched
            };
        };
        this.wallSeamSignature = ()=>{
            const { covered: covered, continued: continued, lintels: lintels, arched: arched } = this.wallSeamCells();
            const projected = this.tilemapMetaProvider.getMapDeltas().filter((d)=>d.layerId === "sprite" && !d.removed && d.context?.parent && this.tilemapMetaProvider.wallItemAt(d.context.parent.x, d.context.parent.y)).map((d)=>`${d.x},${d.y}:${this.projectedWallJoints(d.x, d.y).map((p)=>`${p.id}@${p.dy}`).join(",")}`).filter((k)=>!k.endsWith(":"));
            return [
                covered.sort().join(";"),
                continued.sort().join(";"),
                lintels.map((l)=>`${l.x},${l.y}`).sort().join(";"),
                projected.sort().join(";"),
                arched.sort().join(";")
            ].join("|");
        };
        this.wallTrimSignature = ()=>{
            const provider = this.tilemapMetaProvider;
            if (!provider || !(0, $ba9ee37aae1b90d9$export$9f9361b20898f65c)()) return "";
            const { storeys: storeys } = (0, $ba9ee37aae1b90d9$export$3c9496a80943a375)(provider);
            if (storeys.length < 2) return "";
            // Every storey of a stack asks for the same signature: the first to ask after a change works it out for them all.
            const version = `${storeys.map((p)=>`${p.roomId}:${p.getPresentationVersion()}`).join("|")}|${(0, $4d955fa5af64f75a$export$7f5e211f9738e851).length}`;
            const shared = $409e08612bd4cd6f$var$stackTrimSignatures.get(storeys[0]);
            if (shared?.version === version && shared.definitions === (0, $4d955fa5af64f75a$export$7f5e211f9738e851)) return shared.signature;
            let trimmed = false;
            const parts = storeys.map((p)=>p.getMapDeltas().filter((d)=>d.layerId === "sprite" && !d.removed && d.context?.parent).map((d)=>{
                    const item = p.wallItemAt(d.context.parent.x, d.context.parent.y);
                    if (!item) return "";
                    if (!trimmed && this.wallDefinitionFor(item)?.trims) trimmed = true;
                    return `${d.x},${d.y}:${d.tileId ?? ""}:${item}`;
                }).filter(Boolean).sort().join(";"));
            const signature = trimmed ? parts.join("|") : "";
            $409e08612bd4cd6f$var$stackTrimSignatures.set(storeys[0], {
                version: version,
                definitions: (0, $4d955fa5af64f75a$export$7f5e211f9738e851),
                signature: signature
            });
            return signature;
        };
        this.renderWallLintels = ()=>{
            const index = this.spritedLayerIndex("sprite");
            this.wallSeamCells().lintels.forEach(({ x: x, y: y, itemType: itemType })=>{
                const lintel = this.wallDefinitionFor(itemType)?.seams?.lintel;
                if (!lintel || y < 1) return;
                try {
                    const g = new (0, $7Bs2Z.Sprite)((0, $1f08f7b8f85adf9e$export$be4093a94fa236fa)(`${lintel.tilesetId}-${lintel.tilePos + 1}`));
                    const fine = (0, $a80d0b17b615d6f7$export$ec6726e81e6754f2)({
                        x: x,
                        y: y - 1
                    });
                    g.x = fine.x;
                    g.y = fine.y;
                    g.zIndex = (0, $f78f32798274f66a$export$360f852efd938c01)(index, y);
                    this.surface.addChild(g);
                    const key = `${x}-${y - 1}-sprite`;
                    this.spritedLayerIds.add("sprite");
                    const cell = this.spritedCellSprites.get(key);
                    if (cell) cell.push(g);
                    else this.spritedCellSprites.set(key, [
                        g
                    ]);
                    this.artworkVersion++;
                } catch (e) {
                    (0, $5UG8I.logger).error({
                        tags: [
                            "map",
                            "error"
                        ]
                    }, e);
                }
            });
        };
        this.// The sprited-layer sprites currently drawn at one map cell, across every sprited layer. This is
        // how a tile-drawn entity gets a hover outline: the V2 chest is an invisible marker standing on
        // these sprites, so they -- not the marker -- are the shape to trace. Returns live sprites in the
        // map surface's own coordinate space; callers must not retain them across a rerender.
        getSpritedTilesAt = (x, y)=>{
            const found = [];
            this.spritedLayerIds.forEach((layerId)=>{
                const sprites = this.spritedCellSprites.get(`${x}-${y}-${layerId}`);
                sprites?.forEach((sprite)=>{
                    if (!sprite.destroyed) found.push(sprite);
                });
            });
            return found;
        };
        this.// The container those sprites live in, so an outline traced from them can be parented alongside
        // and share their coordinate space without any conversion.
        getTileSurface = ()=>this.surface;
        this./**
     * The sprites drawing the sprited tile whose cell is (x, y): its own cell, and every nearby piece the builder
     * parented to it (a wall's top, drawn in the cell above). Another room's tile is looked up on the storey that
     * room is drawn as. Live sprites, so callers must not keep them across a rerender.
     */ getTileArt = (x, y, layerId, roomId)=>{
            if (roomId && roomId !== this.roomId) return this.sceneRenderer.tileArt(roomId, x, y, layerId);
            const found = [];
            for(let cy = y - 2; cy <= y + 1; cy++)for(let cx = x - 1; cx <= x + 1; cx++){
                if (cx !== x || cy !== y) {
                    const parent = this.tilemapMetaProvider?.getMapDeltaAt(cx, cy, layerId)?.context?.parent;
                    if (parent?.x !== x || parent?.y !== y) continue;
                }
                this.spritedCellSprites.get(`${cx}-${cy}-${layerId}`)?.forEach((sprite)=>{
                    if (!sprite.destroyed && sprite.visible) found.push(sprite);
                });
            }
            return found;
        };
        this./** Every sprited layer's art for the tile at (x, y): what a wall looks like on screen, its top included. */ getWallArt = (x, y)=>{
            const found = [];
            this.spritedLayerIds.forEach((layerId)=>found.push(...this.getTileArt(x, y, layerId)));
            return found;
        };
        this.// ---------------------------------------------------------------------------------------------
        // Build preview veil: an existing tile a build preview reshapes (a wall it joins, a roof edge
        // turning interior, a floor's trim) is hidden while the preview's ghost of its new shape stands in.
        // ---------------------------------------------------------------------------------------------
        /** Whether the tile drawn here can be hidden: a wall piece, a plain tile of a roof group, or a plain ground tile. */ canVeilBuildCell = (x, y, layerId)=>{
            const maptype = this.tilemapMetaProvider?.resolveLayerMapping(layerId)?.maptype;
            if (maptype === "sprited") return !!this.spritedCellSprites.get(`${x}-${y}-${layerId}`)?.some((sprite)=>!sprite.destroyed);
            if (maptype === "sky") return layerId === "sky" && this.roofGroupByCell.has(`${x},${y}`) && !!this.plainLaidTile(x, y, this.tilemapMetaProvider.resolveTileMapFromLayerId("sky"), "sky");
            if (maptype === "tilemap") return this.groundLayerRenderers.has(layerId) && !!this.plainLaidTile(x, y, this.tilemapMetaProvider.resolveTileMapFromLayerId(layerId));
            return false;
        };
        this./** Hide exactly these cells (`${x}-${y}-${layerId}`); every other one is drawn as the map has it. Takes effect at once. */ setBuildVeil = (keys)=>{
            const next = new Set(keys);
            const changed = [
                ...next
            ].filter((key)=>!this.buildVeil.has(key)).concat([
                ...this.buildVeil
            ].filter((key)=>!next.has(key)));
            if (!changed.length) return;
            this.buildVeil = next;
            const groups = new Set(), layers = new Set();
            changed.forEach((key)=>{
                const dash = key.lastIndexOf("-");
                const layerId = key.slice(dash + 1);
                const [x, y] = key.slice(0, dash).split("-").map(Number);
                const maptype = this.tilemapMetaProvider?.resolveLayerMapping(layerId)?.maptype;
                if (maptype === "sprited") {
                    const tile = this.tilemapMetaProvider.resolveTileMapFromLayerId(layerId)?.[x]?.[y];
                    const visible = !next.has(key) && (!tile || this.tilemapMetaProvider.resolveTileMeta(tile).entityTileId !== "stairs-down" || this.downstairsHasSurface(x, y));
                    this.spritedCellSprites.get(key)?.forEach((sprite)=>{
                        sprite.visible = visible;
                    });
                } else if (maptype === "sky" && this.roofGroupByCell.has(`${x},${y}`)) groups.add(this.roofGroupByCell.get(`${x},${y}`));
                else if (maptype === "tilemap") layers.add(layerId);
            });
            // A tilemap only appends or clears, so the layer or roof holding a changed cell is laid again.
            groups.forEach(this.relayRoofGroup);
            layers.forEach(this.relayGroundLayer);
        };
        this.plainLaidTile = (x, y, tilemap, sky)=>{
            const provider = this.tilemapMetaProvider;
            const tile = tilemap?.[x]?.[y];
            if (!tile || !provider.shouldDrawTileAt(x, y, sky, tilemap) || provider.isHiddenTile(tile) || provider.getCompositeTileId(tile)) return;
            if (sky && (tilemap === provider.resolveTileMapFromLayerId("sky") && this.houseRoofCells.has(`${x},${y}`) || provider.getMapDeltaAt(x, y, "sky")?.collideable)) return;
            return provider.resolveTilesetTileId(tile);
        };
        this.relayGroundLayer = (layerId)=>{
            const renderer = this.groundLayerRenderers.get(layerId);
            const tilemap = this.tilemapMetaProvider?.resolveTileMapFromLayerId(layerId);
            if (!renderer || !tilemap) return;
            renderer.clear();
            for(let y = 0; y < this.tilemapMetaProvider.height(); y++)for(let x = 0; x < this.tilemapMetaProvider.width(); x++){
                const texture = this.plainLaidTile(x, y, tilemap);
                if (texture) this.drawGroundTile(renderer, texture, x, y, layerId);
            }
        };
        this.relayRoofGroup = (groupKey)=>{
            const group = this.roofGroups.get(groupKey);
            if (!group) return;
            const cells = [
                ...this.roofGroupByCell
            ].filter(([, key])=>key === groupKey).map(([cell])=>cell.split(",").map(Number)).sort((a, b)=>a[1] - b[1] || a[0] - b[0]);
            const sky = this.tilemapMetaProvider.resolveTileMapFromLayerId("sky");
            group.tiles.clear();
            this.skyTilemaps.forEach((tilemap)=>cells.forEach(([x, y])=>{
                    if (tilemap === sky && this.buildVeil.has(`${x}-${y}-sky`)) return;
                    const texture = this.plainLaidTile(x, y, tilemap, "sky");
                    if (texture) group.tiles.tile(texture, x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)());
                }));
        };
        this.removeSpritedCell = (x, y, layerId)=>{
            const key = `${x}-${y}-${layerId}`;
            const sprites = this.spritedCellSprites.get(key);
            if (!sprites) return;
            // Detach these sprites from the shared surfaceObjectsByKey spriteSet BEFORE destroying them, so
            // the tile-effect system never keeps a destroyed sprite in a surface's set. A vertical wall's
            // cap+base cells share one surfaceId, so this removes only this cell's sprites and empties the
            // surface only once its last cell is removed.
            const surfaceId = this.spritedCellSurfaceId.get(key);
            if (surfaceId) {
                this.tileEffectSystem.detachSpritesFromSurface(surfaceId, sprites);
                this.spritedCellSurfaceId.delete(key);
            }
            sprites.forEach((s)=>{
                s.parent?.removeChild(s);
                if (!s.destroyed) s.destroy({
                    children: true
                });
            });
            this.spritedCellSprites.delete(key);
            this.artworkVersion++;
        };
        this.spritedLayerIndex = (layerId)=>(this.tilemapMetaProvider.resolveLayerMapping(layerId)?.idx ?? 0) + 1;
        this.// Fade the tile art the LOCAL player is standing behind (tree canopies, a cave's ore blocks) toward
        // translucent, and ease the rest back to opaque. Called once per frame after entities are laid out.
        // playerZIndex mirrors Mechanics.entity.body.calculateZIndexBoost for the humanoid player
        // (100 + feet-y, defaultZIndex 0) -- the same key tile sprites are z-sorted against.
        //
        // Candidates are ONLY the pooled tile sprites carrying a fade policy (occluderFade, stamped by
        // CompositeTileRenderer from the tile's structured entityTileId via occluderFadePolicy). Ground
        // tiles are baked into CompositeTilemaps and never occlude; walls (owned sprited-cell sprites) are
        // deliberately excluded, so only the tagged tiles fade.
        applyOccluderFade = (player)=>{
            this.compositeTileRenderer.updateBonecallerStones();
            // Disabled (via the OCCLUDER_FADE_ENABLED constant or a runtime window.occluderFade.enabled
            // toggle) or no player yet: ease any residual fade back and do NO per-frame work (no pool scan).
            // The ticker calls render() every frame, including before a room's map/entities exist.
            if (!this.features.occluderFade || !this.occluderFade.config.enabled || !player?.location) {
                this.occluderFade.relaxAll();
                this.occluderCandidateBuf.length = 0 // hold no sprite refs while idle
                ;
                this.roofCompositeOverlap.sync();
                return;
            }
            const feetX = player.location.x;
            const feetY = player.location.y + (0, $9667a1379a787b5e$export$5985b04c8e71b763);
            this.occluderFade.update(feetX, feetY, (0, $d3527b517d667178$export$4cfe0674a42ef84e).entity.body.calculateZIndexBoost(player), this.collectOccluderCandidates());
            this.roofCompositeOverlap.sync();
        };
        this.occluderCandidateBuf = [];
        this.collectOccluderCandidates = ()=>{
            const buf = this.occluderCandidateBuf;
            buf.length = 0;
            const pool = this.spriteManagementService.getSpritePool();
            const items = pool.items;
            const ptr = pool.ptr;
            for(let i = 0; i <= ptr; i++){
                const item = items[i];
                if (item && !item.free && item.data && item.data.occluderFade) buf.push(item.data);
            }
            return buf;
        };
        this.// Called on a redrawClient signal (building/chest/door placement). Deferred to renderTileMap so it
        // runs after processPendingDeltas has applied the accompanying deltas. An applied ADD delta sets
        // pendingRedraw itself (see applyMapDelta), for the tiles that arrive without a signal.
        onRedraw = ()=>{
            this.pendingRedraw = true;
        };
        this.repaintDirtyCells = ()=>{
            if (!this.tilemapMetaProvider || this.dirtyCells.size === 0) {
                this.dirtyCells.clear();
                this.dirtyNeedsFull = false;
                return;
            }
            // Fall back to a FULL rerender when: any dirty batch touched a removal/damaged tile (tile
            // effects -- see dirtyNeedsFull), OR any dirty cell is a non-sprited (tilemap/sky/occlusion)
            // layer that can't be updated in isolation (CompositeTilemap is append+clear only). Otherwise
            // every change is a pristine sprited placement and we repaint just those cells.
            let needFullRerender = this.dirtyNeedsFull;
            this.dirtyNeedsFull = false;
            this.dirtyCells.forEach((key)=>{
                const layerId = key.slice(key.lastIndexOf("-") + 1);
                if (this.tilemapMetaProvider.resolveLayerMapping(layerId)?.maptype !== "sprited") needFullRerender = true;
            });
            if (needFullRerender) {
                this.dirtyCells.clear();
                this.rerender();
                return;
            }
            this.dirtyCells.forEach((key)=>{
                const dash = key.lastIndexOf("-");
                const layerId = key.slice(dash + 1);
                const [x, y] = key.slice(0, dash).split("-").map(Number);
                this.removeSpritedCell(x, y, layerId);
                const tileMap = this.tilemapMetaProvider.resolveTileMapFromLayerId(layerId);
                const tile = tileMap?.[x]?.[y];
                if (tile) this.renderSpritedCell(x, y, tile, layerId, this.spritedLayerIndex(layerId));
            });
            this.dirtyCells.clear();
        };
        this.queueMapDelta = (delta)=>{
            this.pendingMapDeltas = this.pendingMapDeltas.concat(delta);
        };
        this./** Keep hidden companion collision/support current without painting its map. */ flushMapDeltas = ()=>{
            this.processPendingDeltas();
        };
        this.processPendingDeltas = ()=>{
            if (this.pendingMapDeltas.length > 0) {
                const deltas = [
                    ...this.pendingMapDeltas
                ];
                this.pendingMapDeltas = [];
                // Read before the batch applies: a piece is new if its cell held nothing of it before.
                const built = this.paintedRoomId === this.roomId ? this.newBuildPieces(deltas) : undefined;
                deltas.forEach((delta)=>{
                    this.applyMapDelta(delta);
                });
                if (built?.size) this.landBuiltPieces(built);
            }
        };
        this.applyMapDelta = (delta)=>{
            if (!delta || !this.tilemapMetaProvider) return;
            const { x: x, y: y, blocking: blocking, occlusion: occlusion, tileId: tileId, layerId: layerId, surfaceId: surfaceId, mapSpriteCap: mapSpriteCap, collideable: collideable, temporary: temporary, context: context } = delta;
            if (tileId) {
                // Remember this cell so a following redrawClient can repaint just it (see repaintDirtyCells).
                this.dirtyCells.add(`${x}-${y}-${layerId}`);
                // A wooden cap's recovered anchor depends on the blocking base below it.
                // Re-evaluate the cap when that base is placed or replaced incrementally.
                if (y > 0 && this.tilemapMetaProvider.resolveLayerMapping(layerId)?.maptype === "sprited") this.dirtyCells.add(`${x}-${y - 1}-${layerId}`);
                // A wall's bare edges are judged against the tiles beside it (see closeBareWallEdges).
                if (layerId === "sprite") {
                    this.dirtyCells.add(`${x - 1}-${y}-${layerId}`);
                    this.dirtyCells.add(`${x + 1}-${y}-${layerId}`);
                    this.dirtyCells.add(`${x}-${y + 1}-${layerId}`);
                }
                // A removal (destroy) or a damaged tile drives the tile-effect system -- keep it on the
                // full-rerender path so crumble/shake/holes are not raced by an incremental remove+recreate.
                if (delta.removed || context?.hp !== undefined && context?.hpMax !== undefined && context.hp < context.hpMax) this.dirtyNeedsFull = true;
                if (delta.removed) {
                    this.lavaTileFade.cancel(`${x}-${y}-${layerId}`);
                    // Taken down: built again, it lands again. A removal names no material; the tile it removes does.
                    const removing = this.tilemapMetaProvider.getMapDeltaAt(x, y, layerId);
                    const landingLayer = removing && this.landingLayerOf({
                        ...removing,
                        layerId: layerId
                    });
                    if (landingLayer) (0, $dd2f604be1eac3c5$export$6e2723a70a7a1aa7).forget(this.storey(), landingLayer, x, y);
                    // The removal delta and the wall's "destroy" tile-effect race; the removal (which drives
                    // the surface-clearing rerender below) can win, so the destroy effect then finds no
                    // surface to shatter. Snapshot this cell's shatter textures NOW -- the surface + its
                    // live sprites still exist at this point -- so a destroy effect arriving after the
                    // rerender can still play the shatter from the snapshot.
                    const removedSurfaceId = this.spritedCellSurfaceId.get(`${x}-${y}-${layerId}`);
                    if (removedSurfaceId) this.tileEffectSystem.snapshotSurfaceForDestroy(removedSurfaceId);
                    this.tilemapMetaProvider.removeTileAt(x, y, layerId);
                } else {
                    const layerMapping = this.tilemapMetaProvider.resolveLayerMapping(layerId);
                    const tileMap = this.tilemapMetaProvider.resolveTileMapFromLayerId(layerId) || this.tilemapMetaProvider.entityTileMap();
                    const isReplace = layerMapping?.maptype === "tilemap" && tileMap[x][y] !== "0";
                    if (layerMapping?.maptype === "tilemap") {
                        const key = `${x}-${y}-${layerId}`;
                        const isLava = this.tilemapMetaProvider.resolveTileMeta(tileId).tileTypes.includes("lava");
                        const wasLava = this.tilemapMetaProvider.resolveTileMeta(tileMap[x][y]).tileTypes.includes("lava");
                        if (isLava && !wasLava) this.lavaTileFade.start(key);
                        else if (!isLava) this.lavaTileFade.cancel(key);
                    }
                    // Incoming server state is authoritative, including increasing HP during repair.
                    // Art-only updates may omit health; keep the existing values in that case.
                    const existingDelta = this.tilemapMetaProvider.getMapDeltaAt(x, y, layerId);
                    const mergedContext = {
                        ...existingDelta?.context,
                        ...Object.fromEntries(Object.entries(context || {}).filter(([, value])=>value !== undefined))
                    };
                    this.tilemapMetaProvider.addTileAt(x, y, blocking, occlusion, tileId, layerId, mapSpriteCap, temporary, collideable, mergedContext);
                    // Ask for a repaint. A delta that ADDS a tile is the only notice the client gets for
                    // a tile that appears with no placement behind it: the sapling a planted seed becomes,
                    // the next stage a sapling grows into, a regrown tree. Those all come from
                    // ENTITY_TILE_ADDED, which broadcasts the delta and nothing else -- no redrawClient --
                    // so without this the cell lands in the data model only (collision/blocking correct,
                    // nothing drawn) and is first PAINTED by the next unrelated repaint or a reload.
                    //
                    // repaintDirtyCells decides how: per-cell on a sprited layer, a full rerender on a
                    // tilemap layer (CompositeTilemap is append+clear only, so a cell whose tile was
                    // replaced cannot be repainted in isolation) -- which is the entity-tile surface, and
                    // where trees/saplings are composite tiles baked by the full render path anyway.
                    //
                    // Removals and damage are deliberately NOT self-painting: the tile-effect system
                    // (crumble, shatter, damage holes) owns those cells and an incremental
                    // remove+recreate races it. See dirtyNeedsFull.
                    this.pendingRedraw = true;
                // if (mapSpriteCap) {
                //     this.tilemapMetaProvider.addMapSpriteCapAt(x, y, mapSpriteCap?.context)
                // }
                }
            } else this.tilemapMetaProvider.updateBlockingAt(x, y, blocking, false);
        };
        this.storey = ()=>this.tilemapMetaProvider?.twoStoreyHouse?.floor ?? 0;
        this.landingLayerOf = (delta)=>{
            const buildType = (0, $7a0964f649e0c77d$export$5f8f4df3a4ea6bd)[delta.context?.itemType]?.buildType;
            if (!buildType || !this.tilemapMetaProvider) return undefined;
            const maptype = this.tilemapMetaProvider.resolveLayerMapping(delta.layerId)?.maptype;
            if (buildType === "wall") return delta.layerId === "sprite" ? "wall" : undefined;
            if (buildType === "roof") return maptype === "sky" ? "roof" : undefined;
            return (buildType === "floor" || buildType === "floor2") && maptype === "tilemap" ? "floor" : undefined;
        };
        this.newBuildPieces = (deltas)=>{
            const provider = this.tilemapMetaProvider;
            const built = new Map();
            if (!provider) return built;
            deltas.forEach((delta)=>{
                if (!delta?.tileId || delta.removed) return;
                const layer = this.landingLayerOf(delta);
                if (!layer) return;
                const { x: x, y: y } = delta;
                if (layer === "wall") {
                    const parent = delta.context?.parent;
                    if (parent?.x !== x || parent?.y !== y) return;
                    const before = provider.getMapDeltaAt(x, y, "sprite");
                    if (before && !before.removed && before.context?.parent?.x === x && before.context?.parent?.y === y) return;
                } else {
                    const before = provider.resolveTileMapFromLayerId(delta.layerId)?.[x]?.[y];
                    if (before && before !== "0") return;
                }
                let group = built.get(layer);
                if (!group) built.set(layer, group = {
                    cells: [],
                    tiles: [],
                    itemType: delta.context.itemType
                });
                group.cells.push({
                    x: x,
                    y: y
                });
                group.tiles.push({
                    tileId: delta.tileId,
                    layerId: delta.layerId
                });
            });
            return built;
        };
        this.landBuiltPieces = (built)=>{
            const now = Date.now();
            built.forEach(({ cells: cells, tiles: tiles, itemType: itemType }, layer)=>{
                const started = (0, $dd2f604be1eac3c5$export$6e2723a70a7a1aa7).start(cells, {
                    storey: this.storey(),
                    layer: layer,
                    now: now,
                    origin: this.builderNear(cells),
                    itemType: itemType,
                    lift: layer === "roof" ? (0, $2751e0027a1b432f$export$5b9b003c5dc616cd)() : 0,
                    tiles: tiles
                });
                if (layer !== "wall") started.forEach(this.addLandingOverlay);
            });
        };
        this.builderNear = (cells)=>{
            const cx = cells.reduce((sum, c)=>sum + c.x + 0.5, 0) / cells.length;
            const cy = cells.reduce((sum, c)=>sum + c.y + 0.5, 0) / cells.length;
            let nearest, distance = Infinity;
            this.logic?.entityManager?.iterate("player", (entity)=>{
                if (!entity.location) return;
                const at = {
                    x: entity.location.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                    y: entity.location.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                };
                const d = Math.hypot(at.x - cx, at.y - cy);
                if (d < distance) {
                    nearest = at;
                    distance = d;
                }
            });
            return distance < 16 ? nearest : undefined;
        };
        this.addLandingOverlay = (landing)=>{
            if (!landing.tileId || !landing.layerId) return;
            if (landing.layer === "roof" && this.tilemapMetaProvider.isRoofCoveredAt(landing.x, landing.y)) return;
            const sprite = this.addTileAt(landing.x, landing.y, landing.tileId, landing.layerId, true)?.sprite;
            if (!sprite) return;
            // A roof is drawn over everything; a floor under every body.
            sprite.zIndex = landing.layer === "roof" ? 100000 : 0.5;
            this.landingOverlays.set(landing, {
                sprites: [
                    sprite
                ],
                pivot: {
                    x: sprite.x + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2,
                    y: sprite.y + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2
                }
            });
        };
        this.roofLandingAlpha = ()=>{
            const house = this.tilemapMetaProvider?.getHousePresentation();
            if ((0, $2751e0027a1b432f$export$bec9e2f2535fb41)(house)) return this.houseRoof.visible ? this.houseRoof.alpha : 0;
            return this.skySurface?.visible ? this.skyManager.getSkyAlpha() : 0;
        };
        this.landingWallSprites = (landing)=>{
            const sprites = [];
            for (const y of [
                landing.y,
                landing.y - 1
            ]){
                const parent = this.tilemapMetaProvider?.getMapDeltaAt(landing.x, y, "sprite")?.context?.parent;
                if (parent?.x !== landing.x || parent?.y !== landing.y) continue;
                this.spritedCellSprites.get(`${landing.x}-${y}-sprite`)?.forEach((sprite)=>{
                    if (!sprite.destroyed) sprites.push(sprite);
                });
            }
            return sprites;
        };
        this.updateLandings = ()=>{
            const now = Date.now();
            (0, $dd2f604be1eac3c5$export$6e2723a70a7a1aa7).prune(now);
            const storey = this.storey();
            const duration = (0, $dd2f604be1eac3c5$export$e150b53ef71313fe)();
            (0, $dd2f604be1eac3c5$export$6e2723a70a7a1aa7).forEach((landing)=>{
                const elapsed = now - landing.startAt;
                const done = elapsed >= duration;
                if (landing.ghosts?.size) this.poseLandingGhosts(landing, now, done, storey);
                if (landing.storey !== storey || this.settledLandings.has(landing)) return;
                if (landing.layer === "wall") {
                    const sprites = this.landingWallSprites(landing);
                    if (done) (0, $dd2f604be1eac3c5$export$b10d9a6189b2349b)(sprites);
                    else (0, $dd2f604be1eac3c5$export$270ebf66df17de70)(sprites, (0, $dd2f604be1eac3c5$export$b6581620621b73b7)(elapsed, "wall", 0.7), {
                        x: (landing.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                        y: (landing.y + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
                    });
                }
                const overlay = this.landingOverlays.get(landing);
                if (overlay) {
                    if (done) {
                        overlay.sprites.forEach((sprite)=>{
                            sprite.parent?.removeChild(sprite);
                            if (!sprite.destroyed) sprite.destroy();
                        });
                        this.landingOverlays.delete(landing);
                    } else {
                        (0, $dd2f604be1eac3c5$export$270ebf66df17de70)(overlay.sprites, (0, $dd2f604be1eac3c5$export$b6581620621b73b7)(elapsed, landing.layer), overlay.pivot, false);
                        const alpha = landing.layer === "roof" ? this.roofLandingAlpha() : 1;
                        overlay.sprites.forEach((sprite)=>{
                            sprite.alpha = alpha;
                        });
                    }
                }
                if (landing.dust && !landing.dusted && elapsed >= (0, $dd2f604be1eac3c5$export$b4e04ab9b076b17c)()) {
                    landing.dusted = true;
                    // A tab that stalled through the impact doesn't owe the dust any more.
                    if (elapsed < duration + 100) this.puffLandingDust(landing, now);
                }
                if (done) this.settledLandings.add(landing);
            });
            this.landingDust.update(now);
        };
        this.poseLandingGhosts = (landing, now, done, storey)=>{
            const ghosts = [
                ...landing.ghosts
            ].filter((sprite)=>!sprite.destroyed && sprite.parent === this.surface);
            if (!ghosts.length) return;
            if (landing.ghostsOwned) {
                const since = now - (landing.releasedAt ?? 0);
                const replaced = landing.layer === "wall" ? landing.storey === storey && this.landingWallSprites(landing).length > 0 || done && since > 300 : done && since > 100;
                if (replaced) {
                    (0, $dd2f604be1eac3c5$export$aa86d51cd3992879)(landing);
                    return;
                }
            }
            if (done) (0, $dd2f604be1eac3c5$export$b10d9a6189b2349b)(ghosts, false);
            else (0, $dd2f604be1eac3c5$export$270ebf66df17de70)(ghosts, (0, $dd2f604be1eac3c5$export$b6581620621b73b7)(now - landing.startAt, landing.layer), landing.ghostPivot, false);
        };
        this.puffLandingDust = (landing, now)=>{
            if (landing.layer === "roof" && this.roofLandingAlpha() === 0) return;
            const colors = (0, $dd2f604be1eac3c5$export$22de6e2b70e42ca9)(landing.itemType);
            const seed = landing.x * 73856093 ^ landing.y * 19349663 ^ landing.storey * 83492791;
            const strength = landing.dust === 2 ? 2 : 1;
            const middle = (landing.x + 0.5) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            if (landing.layer === "wall") // Off the wall's foot, just in front of it.
            this.landingDust.puff(middle, (landing.y + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 3, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 - 3, colors, strength, (0, $f78f32798274f66a$export$360f852efd938c01)(this.spritedLayerIndex("sprite"), landing.y) + 0.4, now, seed);
            else this.landingDust.puff(middle, (landing.y + 1) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - 2 + landing.lift, (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2 - 2, colors, strength, landing.layer === "roof" ? 100000.1 : 0.6, now, seed);
        };
        this.clearLandingArt = ()=>{
            this.landingOverlays.forEach(({ sprites: sprites })=>sprites.forEach((sprite)=>{
                    sprite.parent?.removeChild(sprite);
                    if (!sprite.destroyed) sprite.destroy();
                }));
            this.landingOverlays.clear();
            this.landingDust.clear();
        };
        this.// ============================================================================
        // GETTERS
        // ============================================================================
        getVisibilityMap = ()=>!this.visibility?.mask ? undefined : this.visibility.mask;
        this.crossFloorAim = (point)=>this.sceneRenderer.projectileAim(point, this.tilemapMetaProvider?.twoStoreyHouse) ?? this.sceneRenderer.surfaceAim(point, this.tilemapMetaProvider?.twoStoreyHouse);
        this.isRoofVisibleForPlacement = ()=>this.skySurface.visible && this.skyManager.getSkyAlpha() > .15;
        this.drawnStoreys = ()=>this.sceneRenderer.drawnStoreys(this.tilemapMetaProvider?.twoStoreyHouse);
        this.sceneTileEffect = (effect)=>this.sceneRenderer.tileEffect(effect);
        this.getSceneEntity = (id)=>this.sceneRenderer.getEntity(id);
        this.getSceneRenderable = (id)=>this.sceneRenderer.getRenderable(id);
        this.getSceneLights = ()=>{
            const scene = this.sceneRenderer.getLights();
            const rock = this.rockMass.lights();
            return rock.length ? [
                ...scene,
                ...rock
            ] : scene;
        };
        this.updateSceneRooms = (rooms)=>{
            this.sceneRenderer.update(rooms, this.tilemapMetaProvider?.getHousePresentation());
            if (this.tilemapMetaProvider) this.sceneRenderer.linkFloorSupport(this.tilemapMetaProvider);
        };
        this.getVisibility = ()=>this.visibility;
        this.getCameraCenter = ()=>this.cameraManagementService.getTranslationComputer().getCameraCenter();
        this.surface = surface;
        this.roofCompositeOverlap = new (0, $399d057f25535ae6$export$19b0dab5ba3d8bed)(surface);
        this.sceneCompositeOverlap = new (0, $399d057f25535ae6$export$19b0dab5ba3d8bed)(surface);
        this.surface.addChild(this.houseRoofDepth, this.houseRoof, this.houseRoofShade, this.floorOpeningEdges, this.buildingShadow, this.contactShadow, this.roofCastShadow, this.wallHalo, this.archShade, this.rockMass);
        this.houseRoofShade.blendMode = (0, $P8XPi.BLEND_MODES).MULTIPLY;
        this.wallHalo.zIndex = (0, $72f83e51a7379926$export$fa5f84e3c33377ce);
        // Over the floor and its shades, under every wall: the wall's art hides it all but in the arch's opening.
        this.archShade.zIndex = (0, $72f83e51a7379926$export$fa5f84e3c33377ce) + 0.1;
        this.archShade.interactive = false;
        this.houseRoofDepth.interactive = false;
        this.sceneRenderer = new (0, $55d4eaeb8e7150fb$export$393557a3eeefd18a)(surface, (root, sky)=>{
            const map = new $409e08612bd4cd6f$export$ac241b7c41940a17(root, sky, miniMapSurface, new (0, $b11c64d757fefaba$export$198fa1625abb29ee)(logic, root, (0, $1704411fa88dc9bf$export$784ce4bd6fedbedf)), logic, (0, $1704411fa88dc9bf$export$784ce4bd6fedbedf));
            // Companion rooms are seen from another floor. The active player's coordinates
            // must never open a cutaway in the downstairs roof when viewed from upstairs.
            map.init();
            return map;
        }, (entity, provider)=>logic.clientRenderer.entity().renderSceneEntity(entity, provider), (entity, sprite)=>logic.clientRenderer.entity().retainLevelEntity(entity, sprite), (id)=>logic.getEmberRole(id));
        this.skySurface = skySurface;
        this.miniMapSurface = miniMapSurface;
        this.worldOverlaySurface = worldOverlaySurface;
        this.screenShakeManager = new (0, $21e34920946cefc2$export$5dbc5b3773f0a3b2)();
        this.logic = logic;
        // Initialize camera management service
        this.cameraManagementService = new (0, $ecbfd660c7b27906$export$b63e72441cbf98ad)({
            surface: this.surface,
            worldOverlaySurface: this.worldOverlaySurface,
            screenShakeManager: this.screenShakeManager,
            aimAngle: (entity)=>entity === logic.playerEntity ? logic.playerController?.rangedAimAngle() : undefined
        });
        // Initialize sprite management service
        this.spriteManagementService = new (0, $2937f12c3e372b97$export$c10d0c7e188aaa18)({
            spritePoolSize: 2000,
            defaultSurface: this.surface
        });
        // Initialize sky manager
        const skyConfig = {
            skySurface: this.skySurface,
            tilemapMetaProvider: null
        };
        this.skyManager = new (0, $c83cd7e406c913d7$export$530258b752862cdf)(skyConfig);
        // Initialize composite tile renderer first
        this.compositeTileRenderer = new (0, $9973b82363bdbab3$export$ca0a091ecfb17b44)({
            surface: this.surface,
            skySpriteSurfaceAbove: null,
            tilemapMetaProvider: null,
            compositeTileSpriteTextures: this.compositeTileSpriteTextures,
            surfaceObjectsByKey: this.surfaceObjectsByKey,
            attachTexture: this.spriteManagementService.attachTexture,
            getGrassSway: ()=>this.features.grassSway ? this.grassSway : undefined,
            depthSortedRoofs: true,
            pertubation: this.pertubation,
            pctChance: this.pctChance,
            logic: this.logic,
            tileTextureExtractor: (0, $86e9e05f3ebc1d8f$export$171acc6ba80afe2).instance
        });
        // Initialize tile effect system
        const tileEffectConfig = {
            surface: this.surface,
            worldOverlaySurface: this.worldOverlaySurface,
            tilemapMetaProvider: null,
            holeEffect: new (0, $30804d8d8c7ac29a$export$d2b760035f8f14b9)("", ()=>Math.random()),
            skySpriteSurfaceAbove: null,
            skySpriteSurfaceBelow: null,
            attachTexture: this.spriteManagementService.attachTexture,
            renderCompositeTile: this.renderCompositeTile,
            handleRenderCompositeTile: this.compositeTileRenderer.handleRenderCompositeTile
        };
        this.tileEffectSystem = new (0, $cf8aec4e49454e2b$export$59b4c816941e3699)(tileEffectConfig, this.surfaceObjectsByKey);
    }
    get worldProjectionOffset() {
        return this.surface.pivot.y;
    }
    roofGroupAt(x, y) {
        const cell = `${x},${y}`;
        const groupKey = this.roofGroupByCell.get(cell);
        if (groupKey) return this.roofGroups.get(groupKey);
        const sky = this.tilemapMetaProvider.resolveTileMapFromLayerId("sky");
        const pending = [
            {
                x: x,
                y: y
            }
        ];
        this.roofGroupByCell.set(cell, cell);
        let bottom = y + 1;
        for(let i = 0; i < pending.length; i++){
            const at = pending[i];
            bottom = Math.max(bottom, at.y + 1);
            for (const next of [
                {
                    x: at.x - 1,
                    y: at.y
                },
                {
                    x: at.x + 1,
                    y: at.y
                },
                {
                    x: at.x,
                    y: at.y - 1
                },
                {
                    x: at.x,
                    y: at.y + 1
                }
            ]){
                const key = `${next.x},${next.y}`;
                const tile = sky?.[next.x]?.[next.y];
                if (!tile || tile === "0" || this.houseRoofCells.has(key) || this.roofGroupByCell.has(key) || this.tilemapMetaProvider.isHiddenTile(tile)) continue;
                this.roofGroupByCell.set(key, cell);
                pending.push(next);
            }
        }
        const surface = new (0, $8t5Gy.Container)();
        const tiles = new (0, $6dd6e4a0e941ec0b$export$e9f462800192160c)();
        surface.addChild(tiles);
        // A connected ceiling must cover every supporting wall as a unit.
        // Its height moves the artwork, while ground depth orders it against
        // trunks and bodies outside the southern edge.
        surface.zIndex = (0, $097c8f680b47a2c7$export$88ac54f1f217b5ed)(bottom - 1);
        surface.visible = this.skySurface.visible;
        surface.alpha = this.skyManager.getSkyAlpha();
        this.surface.addChild(surface);
        const group = {
            surface: surface,
            tiles: tiles
        };
        this.roofGroups.set(cell, group);
        return group;
    }
    clearRoofGroups() {
        this.roofGroups.forEach(({ surface: surface, tiles: tiles })=>{
            // Pooled tile-effect sprites are owned by SpriteManagementService.
            surface.removeChildren();
            tiles.destroy({
                children: true
            });
            surface.destroy();
        });
        this.roofGroups.clear();
        this.roofGroupByCell.clear();
    }
    /** This storey's roof cells the storey above covers, as a comparable key. */ roofCover() {
        const provider = this.tilemapMetaProvider;
        if (!provider) return "";
        return [
            ...this.houseRoofCells
        ].filter((cell)=>{
            const [x, y] = cell.split(",").map(Number);
            return provider.isRoofCoveredAt(x, y);
        }).join(";");
    }
    houseRoofZIndex(house) {
        if (!(0, $2751e0027a1b432f$export$bec9e2f2535fb41)(house)) return 0;
        // Use only the roof footprint, independently of floor extensions.
        // Elevation changes the art position; supporting walls share ground depth.
        const bottom = (0, $2751e0027a1b432f$export$149797a16feb3a10)(house).reduce((edge, cell)=>Math.max(edge, cell.y + 1), 0);
        return (0, $097c8f680b47a2c7$export$88ac54f1f217b5ed)(bottom - 1);
    }
    recordRoofArtwork(owner, bounds) {
        let cells = this.roofArtwork.get(owner);
        if (!cells) this.roofArtwork.set(owner, cells = []);
        cells.push(bounds);
    }
    rebuildRoofComposites() {
        this.roofCompositeOverlap.rebuild(this.liveComposites().filter((sprite)=>!sprite.destroyed), [
            ...this.roofArtwork
        ].map(([owner, bounds])=>({
                owner: owner,
                bounds: bounds
            })));
    }
    syncSceneComposites() {
        const scene = this.sceneRenderer.backgroundCompositeArtwork(this.tilemapMetaProvider?.getHousePresentation());
        const key = `${this.artworkVersion}:${scene.key}`;
        if (key !== this.sceneCompositeKey || this.sceneCompositeOverlap.isStale()) {
            const level = this.tilemapMetaProvider?.twoStoreyHouse?.floor;
            const artwork = [
                ...this.getCeilingArtwork().map((art)=>({
                        ...art,
                        level: level
                    })),
                ...scene.ceilings
            ];
            this.sceneCompositeOverlap.rebuild(scene.composites, artwork);
            this.sceneCompositeKey = key;
        }
        this.sceneCompositeOverlap.sync();
    }
    hasForegroundSceneFloor(playerZ) {
        return this.sceneRenderer.hasForegroundFloor(playerZ);
    }
    isPlayerBehindScene(bounds, playerZ) {
        return this.sceneRenderer.occludes(bounds, playerZ);
    }
    isPlayerHiddenByScene(bounds, playerZ) {
        return this.sceneRenderer.covers(bounds, playerZ);
    }
    /** Test individual drawn tiles, preserving openings and irregular storey footprints. */ overlapsRenderedMap(bounds) {
        return this.renderedOcclusionTiles.overlaps(bounds) || this.findRenderedSprite(bounds, ()=>true);
    }
    /** Pushes the drawn tiles over `bounds` onto `out` as screen-space [left, top, right, bottom] runs. */ collectRenderedTiles(bounds, out) {
        this.renderedOcclusionTiles.collect(bounds, out);
    }
    /** Pushes the wall and tile sprites' art over `bounds` onto `out`, like collectRenderedTiles. */ collectRenderedSprites(bounds, out) {
        this.findRenderedSprite(bounds, (art)=>{
            out.push(art.x, art.y, art.right, art.bottom);
            return false;
        });
    }
    /** Visits the screen bounds of each live wall or tile sprite's art over `bounds` until `visit` returns true. */ findRenderedSprite(bounds, visit) {
        const overlaps = (box)=>box.x < bounds.right && box.right > bounds.x && box.y < bounds.bottom && box.bottom > bounds.y;
        const near = this.spriteBoundsFilter.reset(bounds);
        const hits = (sprite)=>{
            if (sprite.destroyed || !sprite.visible || !near.mayOverlap(sprite) || !sprite.worldVisible) return false;
            const box = sprite.getBounds();
            if (!overlaps(box) || sprite.worldAlpha <= 0.15) return false;
            const content = (0, $35a6592763403c18$export$92de05754e03fcc2)(sprite, this.spriteOcclusionBounds);
            // Not read yet: clear until it is, rather than stalling this frame on the GPU.
            if (content === undefined) return false;
            const art = content ?? box;
            return overlaps(art) && visit(art);
        };
        for (const sprites of this.spritedCellSprites.values()){
            if (sprites.some(hits)) return true;
        }
        const pool = this.spriteManagementService.getSpritePool();
        for(let i = 0; i <= pool.ptr; i++){
            const item = pool.items[i];
            if (item && !item.free && item.data && hits(item.data)) return true;
        }
        return false;
    }
    get translationComputer() {
        return this.cameraManagementService.getTranslationComputer();
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");

var $5UG8I = parcelRequire("5UG8I");



class $1cf3778ec61af1ce$export$46cd43cb5d943bd1 extends (0, $a64b70167386625f$export$98e91636974d835d) {
    constructor(color = 0xff00ff){
        super();
        super.beginFill(color);
        super.drawRect(0, 0, 1, 1);
        super.endFill();
    }
    recolor(color) {
        super.beginFill(color);
        super.drawRect(0, 0, 1, 1);
        super.endFill();
    }
}


class $0de04cf39fd0c1a1$export$549555cdc2ac3f0f extends (0, $gwPoJ.Graphics) {
    constructor(logic){
        super(), this.entityIdToMinimapRenderable = new Map(), this.entityUpdatePauseTs = Date.now(), this.isVisible = false, this.localBiomeColorMapUpdate = new Map(), this.localLocationIconUpdate = new Map(), this.iconChildren = new Map(), this.setup = ()=>{}, this.get = (entityId)=>{
            return this.entityIdToMinimapRenderable.get(entityId);
        }, this.entities = ()=>Array.from(this.entityIdToMinimapRenderable.keys()), this.offer = (entity, isClientPlayer = false)=>{
            const existing = this.entityIdToMinimapRenderable.get(entity);
            if (existing) {
                // already exists
                const currentRoomId = this.logic.roomId;
                const entityObj = this.logic.entityManager.get(entity);
                if (entityObj?.roomId === currentRoomId) existing.visible = true;
                return existing;
            }
            const minimapRenderable = new (0, $1cf3778ec61af1ce$export$46cd43cb5d943bd1)();
            const recolor = (color)=>{
                if (isClientPlayer) // you appear green
                minimapRenderable.recolor(color || 0x00ff00);
                else // all others appear white
                minimapRenderable.recolor(color || 0xffb6c1);
            };
            recolor();
            this.addChild(minimapRenderable);
            this.entityIdToMinimapRenderable.set(entity, minimapRenderable);
            minimapRenderable.interactive = true;
            const player = this.logic.entityManager.get(entity);
            if (player && player.entityId === this.logic.playerEntity?.entityId) {
                minimapRenderable.on("mouseover", ()=>{
                    if (this.pointHoverListener) {
                        this.pointHoverListener(true, "You");
                        minimapRenderable.recolor(0xff0000);
                    }
                });
                minimapRenderable.on("mouseout", ()=>{
                    if (this.pointHoverListener) {
                        this.pointHoverListener(false);
                        recolor();
                    }
                });
            }
            return minimapRenderable;
        }, this.remove = (entity)=>{
            const renderable = this.entityIdToMinimapRenderable.get(entity);
            if (!renderable) {
                (0, $5UG8I.logger).debug({
                    tags: [
                        "minimap",
                        "renderable"
                    ]
                }, "No renderable", entity);
                return;
            }
            this.removeChild(renderable);
            this.entityIdToMinimapRenderable.delete(entity);
            (0, $5UG8I.logger).debug({
                tags: [
                    "minimap",
                    "renderable"
                ]
            }, "Removed renderable", entity);
        }, this.roomUpdated = (suppressMinimap)=>{
            // hide everything
            this.entityIdToMinimapRenderable.forEach((renderable)=>{
                renderable.visible = false;
            });
            this.visible = !suppressMinimap;
            this.isVisible = this.visible;
            this.entityUpdatePauseTs = Date.now() + 500;
        }, this.updateBiomeColorMap = (coordinate, color)=>{
            if (color === 0) return;
            const key = `${coordinate.x}-${coordinate.y}`;
            if (this.localBiomeColorMapUpdate.get(key) === color) return;
            this.localBiomeColorMapUpdate.set(key, color);
            this.beginFill(color, 0.4);
            this.drawRect(coordinate.x, coordinate.y, 1, 1);
            this.endFill();
        }, this.clearBiomeColorMap = ()=>{
            this.clear();
            this.localBiomeColorMapUpdate.clear();
        }, this.removeLocationIcon = (iconId)=>{
            const sprite = this.iconChildren.get(iconId);
            this.localLocationIconUpdate.delete(iconId);
            if (sprite) sprite.parent.removeChild(sprite);
            this.iconChildren.delete(iconId);
        }, this.updateLocationIcon = (icon)=>{
            const key = icon.id;
            if (this.localLocationIconUpdate.has(key)) return;
            const quadrantCoordinate = this.computeQuadrantOffsetCoordinate();
            if (!quadrantCoordinate) // minimapConfig isn't set yet -- a location-icon update arrived over the socket before
            // the map's update() ran (or this map has no minimap config). Skip: update() redraws all
            // icons once a config is present, and this icon isn't marked seen so it retries.
            return;
            const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                name: icon.icon,
                color: 0xffffff,
                scale: 0.05
            });
            sprite.x = icon.x - quadrantCoordinate.x + sprite.width / 2;
            sprite.y = icon.y - quadrantCoordinate.y + sprite.height / 2;
            this.addChild(sprite);
            this.iconChildren.set(key, sprite);
            sprite.interactive = true;
            const original = sprite.tint;
            sprite.on("mouseover", (event)=>{
                if (this.pointHoverListener) {
                    this.pointHoverListener(true, icon.name);
                    sprite.recolor(0xff0000);
                }
            });
            sprite.on("mouseout", ()=>{
                if (this.pointHoverListener) {
                    this.pointHoverListener(false);
                    sprite.recolor(original || 0xffffff);
                }
            });
            this.localLocationIconUpdate.set(key, sprite);
            this.pulseLocation(icon.id);
        }, this.flashMap = ()=>{
            if (this.mapIsFlashing) return;
            const overlay = new (0, $gwPoJ.Graphics)();
            overlay.zIndex = 0;
            overlay.x = this.x;
            overlay.y = this.y;
            this.parent.addChild(overlay);
            overlay.beginFill(0xffffff, 0.5);
            overlay.drawRect(0, 0, this.width, this.height);
            overlay.endFill();
            this.mapIsFlashing = true;
            const throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(overlay, {
                blinkInterval: 50,
                minAlpha: 0.1,
                expires: 750,
                releaseCallback: ()=>{
                    this.parent.removeChild(overlay);
                    this.mapIsFlashing = false;
                }
            });
            throbber.update();
        }, this.pulseLocation = (locationId, expires = 10000)=>{
            this.logic.audio.mapLocationFound();
            this.flashMap();
            const location = this.localLocationIconUpdate.get(locationId);
            if (location) {
                const originalColor = location.currentColor;
                location.recolor(0xff0000);
                const throbber = new (0, $b3798b784c33df3d$export$3b2ce821e7872e8e)(location, {
                    blinkInterval: 50,
                    minAlpha: 0.5,
                    expires: expires,
                    releaseCallback: ()=>{
                        location.recolor(originalColor);
                    }
                });
                throbber.update();
            }
        }, this.computeQuadrantOffsetCoordinate = ()=>{
            if (!this.minimapConfig) return null;
            const { worldMetaDimensions: worldMetaDimensions } = this.minimapConfig;
            const biomeQuadrantStrideX = worldMetaDimensions.roomWidth / worldMetaDimensions.sectorWidth;
            const biomeQuadrantStrideY = worldMetaDimensions.roomHeight / worldMetaDimensions.sectorHeight;
            const quadrantBiomesWidth = biomeQuadrantStrideX * worldMetaDimensions.quadrantWidth;
            const quadrantBiomesHeight = biomeQuadrantStrideY * worldMetaDimensions.quadrantHeight;
            const quadrantCoordinate = (0, $a80d0b17b615d6f7$export$be3fee91976fb47a)(this.logic.quadrantId);
            quadrantCoordinate.x = quadrantCoordinate.x * quadrantBiomesWidth;
            quadrantCoordinate.y = quadrantCoordinate.y * quadrantBiomesHeight;
            return quadrantCoordinate;
        }, this.update = (tilemapMetaProvider)=>{
            if (!tilemapMetaProvider) return;
            const wasEmpty = this.localLocationIconUpdate.size < 1;
            const previousLocationIds = [
                ...this.localLocationIconUpdate.keys()
            ];
            this.minimapConfig = tilemapMetaProvider.minimapConfig;
            this.localBiomeColorMapUpdate.clear();
            this.localLocationIconUpdate.clear();
            this.clear();
            this.iconChildren.forEach((child)=>{
                this.removeChild(child);
            });
            this.iconChildren.clear();
            const { biomeColorMap: biomeColorMap, locationIcons: locationIcons } = tilemapMetaProvider;
            if (biomeColorMap) {
                for(let x = 0; x < biomeColorMap.length; x++)for(let y = 0; y < biomeColorMap[0].length; y++){
                    const color = biomeColorMap[x][y];
                    // Skip empty cells: color 0 would otherwise fill a black 40%-alpha rect over
                    // every empty biome cell (a visible overlay) and emit an O(w*h) run of fill
                    // commands. Matches the incremental updateBiomeColorMap path, which also skips 0.
                    if (color !== 0) {
                        const key = `${x}-${y}`;
                        this.localBiomeColorMapUpdate.set(key, color);
                        this.beginFill(color, 0.4);
                        this.drawRect(x, y, 1, 1);
                        this.endFill();
                    }
                }
            }
            if (locationIcons) {
                const quadrantCoordinate = this.computeQuadrantOffsetCoordinate();
                locationIcons.forEach((icon)=>{
                    if (!quadrantCoordinate) // No minimap config -> no quadrant offset -> nothing to place (matches updateLocationIcon).
                    return;
                    if (icon.quadrantId && icon.quadrantId !== this.logic.quadrantId) return;
                    const sprite = new (0, $15caf4b106aaadb3$export$5a33d6de29791ec5)({
                        name: icon.icon,
                        color: 0xffffff,
                        scale: 0.05
                    });
                    sprite.x = icon.x - quadrantCoordinate.x + sprite.width / 2;
                    sprite.y = icon.y - quadrantCoordinate.y + sprite.height / 2;
                    this.addChild(sprite);
                    this.iconChildren.set(icon.id, sprite);
                    const key = icon.id;
                    const shouldPulse = !wasEmpty && !previousLocationIds.includes(key);
                    this.localLocationIconUpdate.set(key, sprite);
                    sprite.interactive = true;
                    let original;
                    sprite.on("mouseover", (event)=>{
                        if (this.pointHoverListener) {
                            original = sprite.getCurrentColor();
                            this.pointHoverListener(true, icon.name);
                            sprite.recolor(0xff0000);
                        }
                    });
                    sprite.on("mouseout", ()=>{
                        if (this.pointHoverListener) {
                            this.pointHoverListener(false);
                            sprite.recolor(original);
                        }
                    });
                    shouldPulse;
                });
            }
            this.width = 100;
            this.height = 100;
            this.visible = this.isVisible;
        }, this.updateEntity = (entity, roomId, location, force = false)=>{
            if (!force && Date.now() < this.entityUpdatePauseTs) return;
            const minimapRenderable = this.entityIdToMinimapRenderable.get(entity);
            if (!minimapRenderable) return;
            const [_, roomX, roomY] = roomId.split("-");
            const rough = (0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(location);
            const roughRoomX = rough.x;
            const roughRoomY = rough.y;
            if (!minimapRenderable.visible) minimapRenderable.visible = true;
            if (this.minimapConfig?.biomeBased) {
                const { worldMetaDimensions: worldMetaDimensions } = this.minimapConfig;
                const biomeX = roughRoomX / worldMetaDimensions.sectorWidth;
                const biomeY = roughRoomY / worldMetaDimensions.sectorHeight;
                const biomeQuadrantStrideX = worldMetaDimensions.roomWidth / worldMetaDimensions.sectorWidth;
                const biomeQuadrantStrideY = worldMetaDimensions.roomHeight / worldMetaDimensions.sectorHeight;
                const globalX = Number(roomX) * biomeQuadrantStrideX + biomeX;
                const globalY = Number(roomY) * biomeQuadrantStrideY + biomeY;
                const quadrantBiomesWidth = biomeQuadrantStrideX * worldMetaDimensions.quadrantWidth;
                const quadrantBiomesHeight = biomeQuadrantStrideY * worldMetaDimensions.quadrantHeight;
                minimapRenderable.x = Math.min(globalX % quadrantBiomesWidth, quadrantBiomesWidth - 1);
                minimapRenderable.y = Math.min(globalY % quadrantBiomesHeight, quadrantBiomesHeight - 1);
            } else {
                minimapRenderable.x = roughRoomX;
                minimapRenderable.y = roughRoomY;
            }
            this.width = 100;
            this.height = 100;
        }, this.register = (listener)=>this.pointHoverListener = listener;
        this.logic = logic;
        this.visible = false;
    }
}




parcelRequire("1avo5");
var $csytw = parcelRequire("csytw");
var $1avo5 = parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $8t5Gy = parcelRequire("8t5Gy");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $P8XPi = parcelRequire("P8XPi");
var $klOfb = parcelRequire("klOfb");
var $gwPoJ = parcelRequire("gwPoJ");

var $5UG8I = parcelRequire("5UG8I");





const $abad4886bf7dabfe$export$5dea1a95d8ddcc7 = {
    crisp: true,
    feather: 2,
    penumbra: 32
};
const $abad4886bf7dabfe$export$67e662ef16cfc032 = ()=>{
    if (typeof window === "undefined") return $abad4886bf7dabfe$export$5dea1a95d8ddcc7;
    const w = window;
    if (w.indoorSight === undefined) w.indoorSight = $abad4886bf7dabfe$export$5dea1a95d8ddcc7;
    const live = w.indoorSight;
    if (live === false) return {
        ...$abad4886bf7dabfe$export$5dea1a95d8ddcc7,
        crisp: false
    };
    return live && typeof live === "object" ? {
        ...$abad4886bf7dabfe$export$5dea1a95d8ddcc7,
        ...live
    } : $abad4886bf7dabfe$export$5dea1a95d8ddcc7;
};
// getSightPolygon casts a pair of rays a hair either side of every corner. Consecutive vertices
// this close in angle are such a pair...
const $abad4886bf7dabfe$var$CornerPair = 1e-3;
// ...and they are a shadow edge when the ray past the corner lands this much further out.
const $abad4886bf7dabfe$var$MinShadowDepth = 4;
// Never open a fan wider than this, however close the eye stands to the corner.
const $abad4886bf7dabfe$var$MaxPenumbraAngle = 0.6;
const $abad4886bf7dabfe$export$1e085ae6ee28cca0 = 12;
const $abad4886bf7dabfe$export$8234cead8c1c7816 = (polygon, radius, out = [])=>{
    out.length = 0;
    const count = polygon.length;
    if (!(radius > 0) || count < 3) return out;
    for(let i = 0; i < count; i++){
        const a = polygon[i];
        const b = polygon[(i + 1) % count];
        let turn = b.angle - a.angle;
        if (turn > Math.PI) turn -= 2 * Math.PI;
        else if (turn < -Math.PI) turn += 2 * Math.PI;
        if (Math.abs(turn) > $abad4886bf7dabfe$var$CornerPair) continue;
        const corner = a.param < b.param ? a : b;
        const beyond = corner === a ? b : a;
        const length = beyond.param - corner.param;
        if (length < $abad4886bf7dabfe$var$MinShadowDepth) continue;
        // Rays on the corner's side of the pair stop at its blocker, so that is the shaded side.
        const side = Math.sign(corner === a ? -turn : turn) || 1;
        const spread = Math.min($abad4886bf7dabfe$var$MaxPenumbraAngle, Math.atan2(radius, Math.max(1, corner.param)));
        for(let k = 0; k < $abad4886bf7dabfe$export$1e085ae6ee28cca0; k++){
            const from = beyond.angle + side * spread * k / $abad4886bf7dabfe$export$1e085ae6ee28cca0;
            const to = beyond.angle + side * spread * (k + 1) / $abad4886bf7dabfe$export$1e085ae6ee28cca0;
            const t = (k + 0.5) / $abad4886bf7dabfe$export$1e085ae6ee28cca0;
            out.push(corner.x, corner.y, corner.x + Math.cos(from) * length, corner.y + Math.sin(from) * length, corner.x + Math.cos(to) * length, corner.y + Math.sin(to) * length, 1 - t * t * (3 - 2 * t));
        }
    }
    return out;
};
const $abad4886bf7dabfe$export$209a517483303fad = (flat, x, y)=>{
    let inside = false;
    for(let i = 0, j = flat.length - 2; i < flat.length; j = i, i += 2){
        const xi = flat[i], yi = flat[i + 1], xj = flat[j], yj = flat[j + 1];
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) inside = !inside;
    }
    return inside;
};
const $abad4886bf7dabfe$var$TileSamples = [
    -10,
    0,
    10
];
const $abad4886bf7dabfe$export$afd6d6dc499b611a = (flat, x, y)=>{
    const cx = x * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
    const cy = y * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2;
    for (const dy of $abad4886bf7dabfe$var$TileSamples)for (const dx of $abad4886bf7dabfe$var$TileSamples){
        if ($abad4886bf7dabfe$export$209a517483303fad(flat, cx + dx, cy + dy)) return true;
    }
    return false;
};


// How far a polygon edge may sit inside the true circle it stands in for. A light's boundary used
// to be a fixed 64-gon whatever its size, which is 64 ray targets -- more than every occluder
// around it put together -- to hold a 0.4px error at a torch's radius. Deriving the count from the
// radius instead holds the error where it stops being visible and costs a fraction of the rays.
const $cb0ab22baf2add07$var$CircleFlatness = 0.75;
// Never fewer than this, so a tiny light still reads as round, nor more than the old fixed count.
const $cb0ab22baf2add07$var$MinCircleSides = 16;
const $cb0ab22baf2add07$var$MaxCircleSides = 64;
const $cb0ab22baf2add07$var$circleSides = (radius)=>{
    if (!(radius > $cb0ab22baf2add07$var$CircleFlatness)) return $cb0ab22baf2add07$var$MinCircleSides;
    const sides = Math.ceil(Math.PI / Math.acos(1 - $cb0ab22baf2add07$var$CircleFlatness / radius));
    return Math.min($cb0ab22baf2add07$var$MaxCircleSides, Math.max($cb0ab22baf2add07$var$MinCircleSides, sides));
};
/**
 * The light map laid over the world rather than masking it: a blend pixi does not define, the world's colour multiplied
 * by the map's (grey: white light, black veil), its alpha left alone. A sprite mask did the same sum the long way round --
 * the whole world drawn into a texture of its own, then drawn again through the mask, every frame whenever it was not
 * full day -- and the stage is cleared to black, so what the mask hid showed black just as the multiply leaves it.
 */ const $cb0ab22baf2add07$var$LIGHT_MAP_BLEND = 40;
const $cb0ab22baf2add07$var$ensureLightMapBlend = (renderer)=>{
    const state = renderer.state;
    const gl = renderer.gl;
    // No real renderer (tests): nothing to draw with.
    if (!state?.blendModes || !gl) return;
    // Rebuilt by pixi on a restored context: set again whenever it is missing.
    if (!state.blendModes[$cb0ab22baf2add07$var$LIGHT_MAP_BLEND]) state.blendModes[$cb0ab22baf2add07$var$LIGHT_MAP_BLEND] = [
        gl.ZERO,
        gl.SRC_COLOR,
        gl.ZERO,
        gl.ONE
    ];
    // The batcher looks a sprite's blend up by its texture's alpha mode first.
    for (const table of (0, $csytw).premultiplyBlendMode)table[$cb0ab22baf2add07$var$LIGHT_MAP_BLEND] = $cb0ab22baf2add07$var$LIGHT_MAP_BLEND;
};
// The outdoor light gradient's softening. See the constructor for why it is dialled down.
const $cb0ab22baf2add07$var$BlurRadius = 50;
const $cb0ab22baf2add07$var$BlurQuality = 2;
const $cb0ab22baf2add07$var$BlurResolution = 0.25;
const $cb0ab22baf2add07$var$softBlur = ()=>{
    const blur = new (0, $1avo5.filters).BlurFilter($cb0ab22baf2add07$var$BlurRadius, $cb0ab22baf2add07$var$BlurQuality, $cb0ab22baf2add07$var$BlurResolution);
    return blur;
};
// What ground out of sight keeps of its light: next to nothing. The blurred path's floor, which is
// the faintest fill it can draw (a fill at alpha 0 is not drawn at all).
const $cb0ab22baf2add07$var$HiddenBrightness = 0.01;
// The veil texture overhangs the mask by this much on every side, so its feather blurs in veil from
// beyond the screen's edge instead of fading out at it and ringing the screen with a lit border.
const $cb0ab22baf2add07$var$VeilOverhang = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
// How far around the eye to look for walls sight reaches, in tiles. The server prunes a building's
// occluders to seven tiles around the player, so nothing further out stops a ray anyway.
const $cb0ab22baf2add07$var$WallSearchTiles = 8;
// drawPolygon's other overload takes Point instances, and flattens them itself. Handing it the
// flat form skips that copy, and is what the sight polygon's vertices are closest to anyway.
const $cb0ab22baf2add07$var$flatten = (polygon)=>{
    const flat = new Array(polygon.length * 2);
    for(let i = 0; i < polygon.length; i++){
        flat[i * 2] = polygon[i].x;
        flat[i * 2 + 1] = polygon[i].y;
    }
    return flat;
};
/** Even-odd point-in-polygon. */ const $cb0ab22baf2add07$var$insidePolygon = (polygon, x, y)=>{
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const a = polygon[i], b = polygon[j];
        if (a.y > y !== b.y > y && x < (b.x - a.x) * (y - a.y) / (b.y - a.y) + a.x) inside = !inside;
    }
    return inside;
};
/**
 * A light polygon cut down to `radius`: every vertex lies on its own ray from the light, so pulling the far
 * ones in along that ray is the same shape the light would have had with the shorter reach.
 */ const $cb0ab22baf2add07$var$clampToRadius = (polygon, x, y, radius)=>polygon.map((p)=>{
        const d = Math.hypot(p.x - x, p.y - y);
        return d <= radius ? p : {
            x: x + (p.x - x) * radius / d,
            y: y + (p.y - y) * radius / d
        };
    });
class $cb0ab22baf2add07$export$fe76cdfccd658eb {
    constructor(app, surface, debug, logic){
        this.lastLocation = {
            x: -1,
            y: -1
        };
        this.cleared = true;
        this.lastCameraTransform = "";
        this.translationComputer = new (0, $4c699c02db426c96$export$7d222435fcebb768)();
        this.outgoingSight = null;
        this.occlusionFade = new (0, $f938f025cf72352a$export$6377df4ac9e9e40f)();
        this.latestOcclusionStrength = 0;
        // The mask is baked into ONE render texture, reused for the life of the room.
        //
        // There used to be a Map of up to ten textures keyed by this hash, with a fresh
        // renderer.generateTexture() -- a new GPU texture allocation -- on every miss and a FIFO
        // destroy behind it. It could not hit: the hash carries the player's position at full
        // precision and the stage offset, so every frame the player moves is a unique key, and when
        // the player stands still the hash-unchanged check below returns before the cache is ever
        // consulted. So it allocated and freed a texture per moving frame and served nothing, which
        // on a weak GPU is exactly the alloc/free churn that stalls the driver.
        this.needsTextureUpdate = false;
        this.cachedVisibilityHash = "";
        this.bakedWidth = 0;
        this.bakedHeight = 0;
        // Reused for the bake's world->texture translation, to match what generateTexture did.
        this.bakeTransform = new (0, $6qzqq.Matrix)();
        this.wallErase = new (0, $8t5Gy.Container)();
        this.wallProxies = [];
        this.veilSprite = new (0, $7Bs2Z.Sprite)();
        this.veilTransform = new (0, $6qzqq.Matrix)();
        this.veilActive = false;
        this.penumbra = [];
        this.lastSightKey = "";
        this.debugHashCalculation = false // Debug flag for hash calculation logging
        ;
        // Shared with the cave minimap; generated once by the world visibility pass.
        this.sightPolygon = null;
        this.renderVisibility = (visionOptions)=>{
            const shouldRender = this.prepare(visionOptions);
            if (!shouldRender) return false;
            // NEW: Only render if we need to update the texture
            if (this.needsTextureUpdate) {
                this.render();
                this.needsTextureUpdate = false;
            }
            return true;
        };
        this.prepare = ({ polyMap: polyMap, location: location, visibility: visibility, debug: debug, lights: lights, wallArt: wallArt })=>{
            if (!this.logic.tilemapMetaProvider) return false;
            // The logical body position can overlap each eave while the actual body
            // falls outside the facade. Do not restart indoor sight at every storey.
            const exteriorFall = !visibility?.fullOcclusion && (0, $9b85be211484fac5$export$4a8c8628e4e44ada)(this.logic.playerEntity?.floorFall);
            if (exteriorFall) polyMap = undefined;
            const darkness = visibility?.darkness;
            const hasDarkness = darkness < 1.0;
            const hasPolymap = polyMap?.length > 0;
            // Caves took this blur away because blurring the dense polygon mask produced a nearly
            // empty render texture on the live WebGL client. That was the NaN vertices a vertical
            // ray used to emit (see getIntersection): they made the Graphics bounds non-finite, so
            // Pixi computed an empty filter area. With finite bounds the blur is safe everywhere.
            this.visibilitySurface.filters = this.softLightFilters;
            if (this.roomId !== this.logic.tilemapMetaProvider?.roomId) {
                this.lastLocation = {
                    x: -1,
                    y: -1
                };
                this.translationComputer.update(this.logic.tilemapMetaProvider);
                this.roomId = this.logic.tilemapMetaProvider.roomId;
                this.outgoingSight = null;
                this.occlusionFade.reset();
                // NEW: Clear cache on room change
                this.invalidateMask();
            }
            // Keep the last indoor sight polygon in world coordinates while the areas it hid
            // brighten. Recasting from outside would jump the sightline across the doorway.
            // Room changes and exterior falls must never carry an old building's mask along.
            if (exteriorFall || visibility?.fullOcclusion) {
                this.outgoingSight = null;
                this.occlusionFade.reset();
            }
            this.occlusionFade.update(hasPolymap);
            const occlusionStrength = this.occlusionFade.alpha;
            if (!hasPolymap && occlusionStrength === 0) this.outgoingSight = null;
            const fadingOcclusion = !hasPolymap && occlusionStrength > 0;
            const occlusionChanged = this.latestOcclusionStrength !== occlusionStrength || hasPolymap !== (this.sightPolygon !== null);
            // A building's walls are veiled over the lights (see drawSightVeil). A cave keeps its
            // sightline inside the light layer, where its wall-face reveal and rock-shaped lights
            // were tuned against the wide blur.
            const sight = (0, $abad4886bf7dabfe$export$67e662ef16cfc032)();
            const veiled = sight.crisp && !visibility?.fullOcclusion && (hasPolymap || fadingOcclusion);
            const sightKey = `${sight.crisp}:${sight.feather}:${sight.penumbra}`;
            const sightChanged = sightKey !== this.lastSightKey;
            const backgroundAlpha = occlusionStrength === 1 ? $cb0ab22baf2add07$var$HiddenBrightness : darkness + ($cb0ab22baf2add07$var$HiddenBrightness - darkness) * occlusionStrength;
            // Account for the background composited over the sight polygon. Both sides of
            // the boundary blend to outdoor lighting without pulsing already visible ground.
            const sightAlpha = occlusionStrength === 0 ? 0 : darkness * 0.99 * occlusionStrength / (1 - backgroundAlpha);
            if (!hasPolymap && !fadingOcclusion && !hasDarkness && this.cleared === false) {
                this.translationComputer.reset();
                this.visibilitySurface.clear();
                this.cleared = true;
                this.surface.mask = undefined;
                this.sightPolygon = null;
                this.sightRoomId = this.logic.roomId;
                if (this.visibilitySprite) this.app.stage.removeChild(this.visibilitySprite);
                this.lastLocation = {
                    x: -1,
                    y: -1
                };
                // NEW: Clear cache when visibility is disabled
                this.invalidateMask();
                return false;
            }
            const cameraTransform = `${this.surface.position.x}:${this.surface.position.y}:${this.surface.pivot.x}:${this.surface.pivot.y}`;
            const cameraChanged = cameraTransform !== this.lastCameraTransform;
            const lightsChanged = this.lightLastChangedTs !== lights?.lastUpdatedTs;
            const playerLocationChanged = !(location.x === this.lastLocation.x && location.y === this.lastLocation.y);
            const darknessChanged = this.latestDarkness !== darkness;
            // The mask is baked in stage coordinates. Include the newly exposed areas on all edges
            // and rebake after resizing even when the player and lights have not moved.
            const left = 0 - this.app.stage.x;
            const top = 0 - this.app.stage.y / (0, $10da07838e6d507c$export$c6ec669adaa5980d);
            const viewportChanged = !this.visibilityBounds || this.visibilityBounds.x !== left || this.visibilityBounds.y !== top;
            if (viewportChanged) this.visibilityBounds = new (0, $6qzqq.Rectangle)(left, top, 27 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + this.app.stage.x * 2, 16 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + this.app.stage.y * 2 / (0, $10da07838e6d507c$export$c6ec669adaa5980d));
            if (this.visibilitySprite) this.visibilitySprite.position.set(left, top);
            // NEW: Calculate visibility hash to determine if update is needed
            const hashState = {
                polyMap: polyMap,
                location: location,
                visibility: visibility,
                lights: lights,
                playerLocationChanged: playerLocationChanged,
                lightsChanged: lightsChanged,
                darknessChanged: darknessChanged
            };
            if (this.debugHashCalculation) this.debugHashCalculationLog(hashState);
            const currentVisibilityHash = `${this.computeVisibilityHash(hashState)}-${occlusionStrength}-${sightKey}`;
            if (this.debugHashCalculation) (0, $5UG8I.logger).debug({
                tags: [
                    "shadow",
                    "cache",
                    "debug"
                ]
            }, `[Shadow Cache] Current hash: ${currentVisibilityHash}, Cached hash: ${this.cachedVisibilityHash}`);
            // Nothing that shapes the mask has changed, so the texture already on the sprite stands.
            if (currentVisibilityHash === this.cachedVisibilityHash) {
                this.needsTextureUpdate = false // Mark as cache hit
                ;
                if (this.debugHashCalculation) (0, $5UG8I.logger).debug({
                    tags: [
                        "shadow",
                        "cache",
                        "hit"
                    ]
                }, `[Shadow Cache] Same hash, no update needed: ${currentVisibilityHash}`);
                return true;
            }
            // Check if we should skip expensive operations based on old logic
            if (!hasPolymap && !fadingOcclusion) {
                // there isn't a poly map. In this case, then we don't care about player location changes,
                // only pure darkness changes
                if (!hasDarkness || this.translationComputer.ready() && !occlusionChanged && !cameraChanged && !viewportChanged && !darknessChanged && !playerLocationChanged && !lightsChanged) return false;
            } else if (hasPolymap) // there's a poly map. in this case we care about player changes
            {
                if (!occlusionChanged && !cameraChanged && !viewportChanged && !playerLocationChanged && !lightsChanged && !sightChanged) {
                    if (this.visibilityLastUpdateTs === visibility?.lastUpdateTs) return false;
                }
            }
            if (this.visibilityLastUpdateTs !== visibility?.lastUpdateTs) this.visibilityLastUpdateTs = visibility?.lastUpdateTs;
            this.lightLastChangedTs = lights.lastUpdatedTs;
            this.latestDarkness = darkness;
            this.latestOcclusionStrength = occlusionStrength;
            this.lastSightKey = sightKey;
            this.sightPolygon = null;
            this.sightRoomId = this.logic.roomId;
            this.cleared = false;
            this.veilActive = false;
            const g = this.visibilitySurface;
            g.clear();
            const playerLocation = {
                x: location.x,
                y: location.y
            };
            // Bake in the displayed world's transform, including a level pan, shake and pivot.
            // A second camera can disagree during transitions and expose a bright frame.
            g.position.set(this.surface.position.x, this.surface.position.y);
            g.pivot.copyFrom(this.surface.pivot);
            this.lastCameraTransform = cameraTransform;
            if (hasPolymap) {
                const vs = visibility?.range || 600;
                // Top
                polyMap[0] = {
                    a: {
                        x: playerLocation.x - vs,
                        y: playerLocation.y - vs
                    },
                    b: {
                        x: playerLocation.x + vs,
                        y: playerLocation.y - vs
                    }
                };
                // Bottom
                polyMap[1] = {
                    a: {
                        x: playerLocation.x - vs,
                        y: playerLocation.y + vs
                    },
                    b: {
                        x: playerLocation.x + vs,
                        y: playerLocation.y + vs
                    }
                };
                // Left
                polyMap[2] = {
                    a: {
                        x: playerLocation.x - vs,
                        y: playerLocation.y - vs
                    },
                    b: {
                        x: playerLocation.x - vs,
                        y: playerLocation.y + vs
                    }
                };
                // Right
                polyMap[3] = {
                    a: {
                        x: playerLocation.x + vs,
                        y: playerLocation.y - vs
                    },
                    b: {
                        x: playerLocation.x + vs,
                        y: playerLocation.y + vs
                    }
                };
                const prunedSegments = (0, $23e67fb1a742a4ea$export$691dec627034f05a)(polyMap, playerLocation.x, playerLocation.y, vs, 3);
                // A cave's occluders sit on the rock's true tile boundary, so the sightline stops
                // at the surface. Reveal the near half of whatever it stopped against, or the
                // player would stand in a black box with no visible walls.
                const reveal = visibility?.fullOcclusion ? (0, $23e67fb1a742a4ea$export$96afdb68a4534bc1) : 0;
                let polygons = [
                    (0, $23e67fb1a742a4ea$export$a30470b4ef717782)(prunedSegments, playerLocation.x, playerLocation.y, reveal)
                ];
                this.sightPolygon = polygons[0];
                this.outgoingSight = visibility?.fullOcclusion ? null : polygons[0];
                if (debug) {
                    // debug.transform.position.x = -playerLocation.x + 50 + ScreenDimensions.w / 2
                    // debug.transform.position.y = -playerLocation.y + 50 + ScreenDimensions.h / 2
                    debug.transform.position.x = (-playerLocation.x + 50 + (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).w / 2) * 2 - 32 * (0, $10da07838e6d507c$export$aa707847c2571374).viewportX;
                    debug.transform.position.y = (-playerLocation.y + 50 + (0, $cb689cfa16c444ba$export$c894fd4e81634c0f).h / 2) * 2 - 32 * (0, $10da07838e6d507c$export$aa707847c2571374).viewportY;
                    debug.clear();
                    const lineMap = prunedSegments.reduce((acc, x)=>{
                        acc.push(x.a);
                        acc.push(x.b);
                        return acc;
                    }, []);
                    debug.beginFill(0xff0000, 0.95);
                    for (let point of lineMap)debug.drawCircle(point.x, point.y, 3);
                    debug.endFill();
                    debug.beginFill(0x00ff00, debug ? 0.2 : 1);
                    for (let polygon of polygons)for (let point of polygon)debug.drawCircle(point.x, point.y, 3);
                    debug.endFill();
                    debug.beginFill(0xff0000, 0.2);
                    for (let polygon of polygons)debug.drawPolygon($cb0ab22baf2add07$var$flatten(polygon));
                    debug.endFill();
                }
                if (!veiled) {
                    g.beginFill(0xff0000, sightAlpha);
                    for (let polygon of polygons)g.drawPolygon($cb0ab22baf2add07$var$flatten(polygon));
                    g.endFill();
                }
            } else if (fadingOcclusion && !veiled) {
                g.beginFill(0xff0000, sightAlpha);
                g.drawPolygon($cb0ab22baf2add07$var$flatten(this.outgoingSight));
                g.endFill();
            }
            // Veiled, the light layer is the outdoor lighting everywhere and the veil does the hiding.
            const ambient = darkness ?? 1;
            if (veiled) {
                // A building's sight polygon is also kept as the outgoing one, so this is the live
                // sightline indoors and the one fading out on the way through the door.
                const sightline = this.outgoingSight;
                this.drawSightVeil(sightline, occlusionStrength * (1 - $cb0ab22baf2add07$var$HiddenBrightness), sight, location, wallArt);
            }
            if (veiled || darkness !== undefined) {
                g.beginFill(0xfffffff, veiled ? ambient : backgroundAlpha);
                // for now -- hardcode to large map size
                g.drawRect(0, 0, this.logic.tilemapMetaProvider.width() * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243), this.logic.tilemapMetaProvider.height() * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
                g.endFill();
            }
            if ((veiled || darkness !== undefined) && lights) lights.iterate((light)=>{
                const { location: { x: x, y: y }, intensity: intensity, radius: radius } = light;
                if (!this.lightCanReachView(playerLocation, x, y, radius)) return;
                // A sight-gated light (an organic cave's crystals) counts only while the player can see
                // where it comes from: lights are shaped against the rock, not against the player's view.
                if (light.sightGated && (!hasPolymap || !this.sightPolygon || !$cb0ab22baf2add07$var$insidePolygon(this.sightPolygon, x, y))) return;
                // `falloff` rings: the same shape drawn smaller and smaller, each over the last, so the
                // light is brightest at its heart. Each ring's alpha is picked so they stack to `intensity`.
                const rings = Math.max(1, Math.floor(light.falloff ?? 1));
                const alpha = rings > 1 ? 1 - Math.pow(1 - intensity, 1 / rings) : intensity;
                let polygon;
                if (hasPolymap && visibility?.fullOcclusion) {
                    // A light must stop at the same cave rock as the player's sight. Drawing an
                    // unrestricted circle here paints over the shadow polygon drawn above.
                    // Its reach is pulled in by the same reveal the polygon is pushed out by,
                    // so the light still reaches exactly `radius` across open ground.
                    const reach = Math.max(1, radius - (0, $23e67fb1a742a4ea$export$96afdb68a4534bc1));
                    // Include long walls crossing the light even if both endpoints lie outside it.
                    const blockers = polyMap.slice(4).filter(({ a: a, b: b })=>Math.min(a.x, b.x) <= x + radius && Math.max(a.x, b.x) >= x - radius && Math.min(a.y, b.y) <= y + radius && Math.max(a.y, b.y) >= y - radius);
                    polygon = (0, $23e67fb1a742a4ea$export$3a4b253c0ba86d15)(blockers, x, y, reach, (0, $23e67fb1a742a4ea$export$96afdb68a4534bc1), $cb0ab22baf2add07$var$circleSides(reach));
                }
                for(let ring = 0; ring < rings; ring++){
                    const scale = (rings - ring) / rings;
                    g.beginFill(0xffffff, alpha);
                    if (polygon) g.drawPolygon($cb0ab22baf2add07$var$flatten(ring === 0 ? polygon : $cb0ab22baf2add07$var$clampToRadius(polygon, x, y, radius * scale)));
                    else g.drawCircle(x, y, radius * scale);
                    g.endFill();
                }
            });
            this.lastLocation.x = location.x;
            this.lastLocation.y = location.y;
            // NEW: Mark that texture needs update and update cached hash
            this.needsTextureUpdate = true;
            this.cachedVisibilityHash = currentVisibilityHash;
            if (this.debugHashCalculation) (0, $5UG8I.logger).debug({
                tags: [
                    "shadow",
                    "cache",
                    "miss"
                ]
            }, `[Shadow Cache] Cache MISS for hash: ${currentVisibilityHash}`);
            return true;
        };
        /**
     * Whether a light could put any brightness inside the baked region, so the ones that cannot
     * are skipped before their sight polygon is cast. Nothing used to cull here at all: every
     * light in the room was shaped against its occluders and drawn, including campfires tens of
     * tiles away contributing not one pixel. That makes the per-frame cost scale with how many
     * lights the ROOM holds rather than how many are on screen.
     *
     * The bound is deliberately loose -- a full viewport of slack in each direction on top of the
     * half that is actually visible -- because the camera is free to sit up to half a viewport off
     * the player near a map edge (see the modifier clamping above), and a light that pops out at
     * the edge of the screen is far worse than one shaded for nothing.
     */ this.lightCanReachView = (center, x, y, radius)=>{
            const { viewportX: viewportX, viewportY: viewportY, viewportPaddingX: viewportPaddingX, viewportPaddingY: viewportPaddingY } = (0, $10da07838e6d507c$export$aa707847c2571374);
            return Math.abs(x - center.x) <= (viewportX * 2 + viewportPaddingX) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + radius && Math.abs(y - center.y) <= (viewportY * 2 + viewportPaddingY) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + radius;
        };
        /**
     * Veil everything the walls hide. Black drawn over the mask only scales down what is under it,
     * so a light brightens what the player can see and nothing behind the walls. Drawn into the
     * blurred layer, a light's circle used to paint over the hidden ground and show it through them.
     */ this.drawSightVeil = (sightline, alpha, sight, eye, wallArt)=>{
            const veil = this.sightVeil;
            const erase = this.sightErase;
            veil.clear();
            erase.clear();
            for (const proxy of this.wallProxies)proxy.visible = false;
            if (!(alpha > 0) || !sightline) return;
            for (const layer of [
                veil,
                erase,
                this.wallErase
            ]){
                layer.position.copyFrom(this.visibilitySurface.position);
                layer.pivot.copyFrom(this.visibilitySurface.pivot);
            }
            if (this.veilFeather) this.veilFeather.blur = sight.feather;
            this.veilSprite.filters = this.veilFeather && sight.feather > 0 ? [
                this.veilFeather
            ] : [];
            // The whole map and well past it, since the veil texture overhangs the screen.
            const width = this.logic.tilemapMetaProvider.width() * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const height = this.logic.tilemapMetaProvider.height() * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            veil.beginFill(0x000000, alpha);
            veil.drawRect(-width, -height, width * 3, height * 3);
            veil.endFill();
            const flat = $cb0ab22baf2add07$var$flatten(sightline);
            erase.beginFill(0xffffff, 1);
            erase.drawPolygon(flat);
            erase.endFill();
            const fan = (0, $abad4886bf7dabfe$export$8234cead8c1c7816)(sightline, sight.penumbra, this.penumbra);
            for(let i = 0; i < fan.length; i += 7){
                erase.beginFill(0xffffff, fan[i + 6]);
                erase.drawPolygon(fan[i], fan[i + 1], fan[i + 2], fan[i + 3], fan[i + 4], fan[i + 5]);
                erase.endFill();
            }
            if (wallArt) this.eraseSeenWalls(flat, eye, wallArt);
            this.veilActive = true;
        };
        // Lift the veil off the drawn art of every wall the sightline reaches into, top and all.
        this.eraseSeenWalls = (flat, eye, wallArt)=>{
            const provider = this.logic.tilemapMetaProvider;
            const eyeX = Math.floor(eye.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            const eyeY = Math.floor(eye.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            const seen = new Set();
            let used = 0;
            for(let y = eyeY - $cb0ab22baf2add07$var$WallSearchTiles; y <= eyeY + $cb0ab22baf2add07$var$WallSearchTiles; y++)for(let x = eyeX - $cb0ab22baf2add07$var$WallSearchTiles; x <= eyeX + $cb0ab22baf2add07$var$WallSearchTiles; x++){
                if (!provider.isOcclusionAt(x, y) || !(0, $abad4886bf7dabfe$export$afd6d6dc499b611a)(flat, x, y)) continue;
                for (const art of wallArt(x, y)){
                    // A texture freed under a live sprite would crash the proxy's texture setter.
                    if (seen.has(art) || !art.texture?.baseTexture) continue;
                    seen.add(art);
                    const proxy = this.wallProxies[used++] ?? this.addWallProxy();
                    proxy.texture = art.texture;
                    proxy.anchor.copyFrom(art.anchor);
                    proxy.position.copyFrom(art.position);
                    proxy.scale.copyFrom(art.scale);
                    proxy.pivot.copyFrom(art.pivot);
                    proxy.skew.copyFrom(art.skew);
                    proxy.rotation = art.rotation;
                    proxy.visible = true;
                }
            }
        };
        this.addWallProxy = ()=>{
            const proxy = new (0, $7Bs2Z.Sprite)();
            proxy.blendMode = (0, $P8XPi.BLEND_MODES).ERASE;
            this.wallErase.addChild(proxy);
            this.wallProxies.push(proxy);
            return proxy;
        };
        this.render = ()=>{
            const bounds = this.visibilityBounds;
            // Minimum texture size is 1x1; 0x0 throws.
            const width = Math.max(1, Math.ceil(bounds.width));
            const height = Math.max(1, Math.ceil(bounds.height));
            // Compare against the size WE asked for, not the texture's own: BaseTexture rounds what it
            // is given, so a fractional bounds.width would never equal texture.width and the texture
            // would be thrown away and rebuilt every single frame -- the very churn this replaced.
            if (!this.visibilityRenderTexture || this.bakedWidth !== width || this.bakedHeight !== height) {
                this.visibilityRenderTexture?.destroy(true);
                this.veilTexture?.destroy(true);
                this.veilTexture = undefined;
                // The mask is magnified about 3x onto the screen. Nearest-neighbour sampling, the
                // client's default for its pixel art, turned every soft edge into visible steps.
                this.visibilityRenderTexture = (0, $klOfb.RenderTexture).create({
                    width: width,
                    height: height,
                    scaleMode: (0, $P8XPi.SCALE_MODES).LINEAR
                });
                this.bakedWidth = width;
                this.bakedHeight = height;
            }
            this.visibilityTexture = this.visibilityRenderTexture;
            // Same framing generateTexture applied: translate the baked region's top-left to the
            // texture's origin, and let the surface update its own transform since it has no parent.
            this.bakeTransform.tx = -bounds.x;
            this.bakeTransform.ty = -bounds.y;
            this.app.renderer.render(this.visibilitySurface, {
                renderTexture: this.visibilityRenderTexture,
                // generateTexture could skip this, because its texture was always brand new. Reusing
                // one means last frame's mask is still in it.
                clear: true,
                transform: this.bakeTransform,
                skipUpdateTransform: false
            });
            if (this.veilActive) {
                if (!this.veilTexture) {
                    this.veilTexture = (0, $klOfb.RenderTexture).create({
                        width: width + $cb0ab22baf2add07$var$VeilOverhang * 2,
                        height: height + $cb0ab22baf2add07$var$VeilOverhang * 2
                    });
                    this.veilSprite.texture = this.veilTexture;
                }
                this.veilTransform.tx = $cb0ab22baf2add07$var$VeilOverhang - bounds.x;
                this.veilTransform.ty = $cb0ab22baf2add07$var$VeilOverhang - bounds.y;
                const veil = {
                    renderTexture: this.veilTexture,
                    transform: this.veilTransform,
                    skipUpdateTransform: false
                };
                this.app.renderer.render(this.sightVeil, {
                    ...veil,
                    clear: true
                });
                this.app.renderer.render(this.sightErase, {
                    ...veil,
                    clear: false
                });
                this.app.renderer.render(this.wallErase, {
                    ...veil,
                    clear: false
                });
                this.veilSprite.position.set(bounds.x - $cb0ab22baf2add07$var$VeilOverhang, bounds.y - $cb0ab22baf2add07$var$VeilOverhang);
                this.app.renderer.render(this.veilSprite, {
                    renderTexture: this.visibilityRenderTexture,
                    clear: false,
                    transform: this.bakeTransform,
                    skipUpdateTransform: false
                });
            }
            if (!this.visibilitySprite) this.visibilitySprite = new (0, $7Bs2Z.Sprite)(this.visibilityTexture);
            else if (this.visibilitySprite.texture !== this.visibilityTexture) this.visibilitySprite.texture = this.visibilityTexture;
            // Drawn straight after the world, multiplying it (LIGHT_MAP_BLEND), where a mask would have drawn the world twice.
            $cb0ab22baf2add07$var$ensureLightMapBlend(this.app.renderer);
            if (this.surface.mask === this.visibilitySprite) this.surface.mask = null;
            this.visibilitySprite.blendMode = $cb0ab22baf2add07$var$LIGHT_MAP_BLEND;
            this.visibilitySprite.renderable = true;
            this.visibilitySprite.x = bounds.x;
            this.visibilitySprite.y = bounds.y;
            // Directly after the world on the stage: it darkens the world and nothing drawn over it (the HUD, the overlays).
            const stage = this.app.stage;
            if (this.visibilitySprite.parent !== stage) stage.addChild(this.visibilitySprite);
            this.visibilitySprite.zIndex = this.surface.zIndex;
            if (this.surface.parent === stage) {
                const world = stage.getChildIndex(this.surface), now = stage.getChildIndex(this.visibilitySprite);
                const after = now > world ? world + 1 : world;
                if (now !== after) stage.setChildIndex(this.visibilitySprite, after);
            }
        };
        this.renderPipLightMask = (opts)=>{
            const { cx: cx, cy: cy, zoom: zoom, texW: texW, texH: texH, resolution: resolution, visibility: visibility, lights: lights } = opts;
            const darkness = visibility?.darkness;
            // No darkness in this room → no mask (the PiP renders at full brightness, same as the world).
            if (darkness === undefined || darkness >= 1.0) return undefined;
            if (!this.pipDarkness) {
                this.pipDarkness = new (0, $gwPoJ.Graphics)();
                // Soften the light edges, mirroring the main mask's blur (scaled down for the PiP zoom).
                this.pipDarkness.filters = [
                    new (0, $1avo5.filters).BlurFilter(10)
                ];
            }
            if (!this.pipMaskTexture || this.pipMaskTexture.width !== texW || this.pipMaskTexture.height !== texH || this.pipMaskTexture.baseTexture.resolution !== resolution) {
                this.pipMaskTexture?.destroy(true);
                this.pipMaskTexture = (0, $klOfb.RenderTexture).create({
                    width: texW,
                    height: texH,
                    resolution: resolution
                });
                this.pipMaskSprite = new (0, $7Bs2Z.Sprite)(this.pipMaskTexture);
            }
            const g = this.pipDarkness;
            g.clear();
            // Base dim fill over just the visible PiP region (a small margin covers the blur bleed at the
            // edges). Bounding it to the view keeps the blur-filter texture small instead of map-sized.
            const halfW = texW / zoom / 2;
            const halfH = texH / zoom / 2;
            const margin = 48;
            g.beginFill(0xffffff, darkness);
            g.drawRect(cx - halfW - margin, cy - halfH - margin, (halfW + margin) * 2, (halfH + margin) * 2);
            g.endFill();
            // Brighter "holes" at each in-view light's world position (matches prepare()'s light pass).
            lights?.iterate((light)=>{
                const { location: { x: x, y: y }, intensity: intensity, radius: radius } = light;
                if (Math.abs(x - cx) > halfW + radius || Math.abs(y - cy) > halfH + radius) return;
                g.beginFill(0xffffff, intensity);
                g.drawCircle(x, y, radius);
                g.endFill();
            });
            // Bake the world→PiP-texture framing into the graphics transform (identical to the surface
            // transform in renderWorldToTexture), so the mask lines up pixel-for-pixel with the world.
            g.position.set(texW / 2 - cx * zoom, texH / 2 - cy * zoom);
            g.scale.set(zoom);
            this.app.renderer.render(g, {
                renderTexture: this.pipMaskTexture,
                clear: true
            });
            return this.pipMaskSprite;
        };
        // Force the next frame to re-bake. The render texture is NOT destroyed: it is still bound to
        // the mask sprite, and freeing it would leave that sprite pointing at a dead texture -- the
        // "Cannot read properties of null (reading 'valid')" crash in Sprite's texture setter if any
        // early return gets between here and the next render(). It is reused in place instead, and
        // only ever destroyed when the baked region's size changes.
        this.invalidateMask = ()=>{
            this.cachedVisibilityHash = "";
            this.needsTextureUpdate = true;
        };
        // Public: force the mask to re-bake (resize, debugging).
        this.forceTextureUpdate = ()=>{
            this.invalidateMask();
        };
        // Vestigial, kept only so the shadow_* debug satellites that read it keep working; the
        // texture cache they were written to observe is gone, and so is its hit/miss distinction.
        // These and those three files should go together.
        this.getCacheStats = ()=>{
            return {
                cacheSize: this.visibilityRenderTexture ? 1 : 0,
                maxCacheSize: 1,
                lastVisibilityHash: this.cachedVisibilityHash,
                needsUpdate: this.needsTextureUpdate
            };
        };
        // NEW: Debug method to log current state
        this.debugLog = ()=>{
            const stats = this.getCacheStats();
            (0, $5UG8I.logger).debug({
                tags: [
                    "shadow",
                    "debug",
                    "cache"
                ]
            }, `[Shadow Debug] Cache: ${stats.cacheSize}/${stats.maxCacheSize}, Needs Update: ${stats.needsUpdate}, Hash: ${stats.lastVisibilityHash}`);
        };
        // NEW: Debug method to log hash calculation details
        this.debugHashCalculationLog = (state)=>{
            const { polyMap: polyMap, location: location, visibility: visibility, lights: lights, playerLocationChanged: playerLocationChanged, lightsChanged: lightsChanged, darknessChanged: darknessChanged } = state;
            const locationKey = `${location.x}-${location.y}`;
            const darknessKey = visibility?.darkness?.toString() || "1.0";
            const lightsKey = lights?.lastUpdatedTs?.toString() || "0";
            const polyMapKey = polyMap?.length?.toString() || "0";
            const changeFlags = `${playerLocationChanged ? "1" : "0"}${lightsChanged ? "1" : "0"}${darknessChanged ? "1" : "0"}`;
            (0, $5UG8I.logger).debug({
                tags: [
                    "shadow",
                    "debug",
                    "hash"
                ]
            }, `[Shadow Hash Debug] Location: ${locationKey}, Darkness: ${darknessKey}, Lights: ${lightsKey}, PolyMap: ${polyMapKey}, Changes: ${changeFlags}`);
        };
        this.app = app;
        this.surface = surface;
        this.logic = logic;
        const visibilitySurface = new (0, $gwPoJ.Graphics)();
        // A 50px blur at full resolution and the default four passes is a lot of fill for an
        // effect whose whole job is to be indistinct. Half the passes at a quarter of the
        // resolution is ~8-16x less work and, at this radius, not tellable apart -- the blur is
        // wider than the error it introduces by an order of magnitude. This runs on every rebake,
        // so it is a per-frame cost while the player walks.
        this.softLightFilters = debug ? [] : [
            $cb0ab22baf2add07$var$softBlur()
        ];
        visibilitySurface.filters = this.softLightFilters;
        visibilitySurface.scale.set((0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom);
        this.visibilitySurface = visibilitySurface;
        this.sightVeil = new (0, $gwPoJ.Graphics)();
        this.sightErase = new (0, $gwPoJ.Graphics)();
        this.sightErase.blendMode = (0, $P8XPi.BLEND_MODES).ERASE;
        for (const layer of [
            this.sightVeil,
            this.sightErase,
            this.wallErase
        ])layer.scale.set((0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom);
        if (!debug) {
            this.veilFeather = new (0, $1avo5.filters).BlurFilter((0, $abad4886bf7dabfe$export$5dea1a95d8ddcc7).feather, 2);
            // Fitted to the mask, the blur would cut the veil's overhang off before blurring it.
            this.veilFeather.autoFit = false;
        }
        this.translationComputer.noDelay = true;
    }
    /** The light map laid over the world, while there is one (it multiplies the world: LIGHT_MAP_BLEND). */ get lightMap() {
        return this.visibilitySprite?.parent ? this.visibilitySprite : undefined;
    }
    // NEW: Compute a hash of the current visibility state
    computeVisibilityHash(state) {
        const { polyMap: polyMap, location: location, visibility: visibility, lights: lights } = state;
        // Create a hash based on key factors that affect visibility.
        //
        // The location goes in at FULL precision. It used to be quantized to a 32px tile, which is
        // wrong for a mask baked in SCREEN space: prepare() positions the graphics with the camera
        // modifier taken from this exact location, so two positions inside one tile bake to
        // different places. Quantizing them to the same hash froze the mask while the world went on
        // scrolling, and every light -- the player's own and every campfire's -- slid against the
        // ground by however far the camera had moved, then snapped back on the next real bake.
        //
        // It survived locally because the OTHER half of the hash is lights.lastUpdatedTs, and the
        // lights are re-registered by entity_rendering_manager.update(), whose only callers are the
        // server-message handlers. On localhost an update lands on essentially every frame, so the
        // hash changed anyway; at 50ms it lands on ~3 frames in 4, and the rest drew a stale mask.
        // Measured on production: up to 9px of slide per snap in ordinary walking (~20 CSS px at a
        // typical canvas scale), and 50px across a burst of late frames.
        const locationKey = `${location.x}-${location.y}`;
        const darknessKey = visibility?.darkness?.toString() || "1.0";
        const lightsKey = lights?.lastUpdatedTs?.toString() || "0";
        const polyMapKey = polyMap?.length?.toString() || "0";
        const visibilityKey = visibility?.lastUpdateTs?.toString() || "0";
        return `${locationKey}-${darknessKey}-${lightsKey}-${polyMapKey}-${visibilityKey}-${this.app.stage.x}-${this.app.stage.y}-${this.surface.position.x}-${this.surface.position.y}-${this.surface.pivot.x}-${this.surface.pivot.y}`;
    }
}



var $aFPGo = parcelRequire("aFPGo");


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");
var $P8XPi = parcelRequire("P8XPi");




class $be65b55052fa66e7$export$b384c8d4ebe6bf23 {
    static{
        // Above the fog and the grass, below the windblown leaves, well under the sky.
        this.Z_INDEX = 898000;
    }
    static{
        // However many a room asks for. They are cheap, but they are also meant to be rare.
        this.MAX_BUTTERFLIES = 24;
    }
    static{
        this.DEFAULT_COUNT = 3;
    }
    static{
        // Cruising speed. A butterfly beating ten times a second and barely crossing a tile reads as
        // swimming in treacle -- the eye checks the two against each other and knows. See FLAP_REFERENCE.
        this.DEFAULT_SPEED = 58;
    }
    static{
        this.DEFAULT_ALPHA = 0.95;
    }
    static{
        this.DEFAULT_SCALE_MIN = 0.34;
    }
    static{
        this.DEFAULT_SCALE_MAX = 0.52;
    }
    static{
        // Cabbage whites and brimstones, mostly: pale colours are what stay legible against grass. The one
        // orange is the occasional fritillary, and it is the one anybody will actually notice.
        this.DEFAULT_COLORS = [
            0xfdf6e3,
            0xfff4b8,
            0xf7e7a8,
            0xffffff,
            0xe8a33d
        ];
    }
    static{
        // The travel speed a butterfly's own wingbeat is quoted against. The beat is derived from how fast
        // it is actually going, not set independently, so the two can never drift apart: a butterfly
        // sheltering from a gust slows AND beats more slowly, and a fast one beats harder. Getting this
        // wrong in either direction is immediately obvious and hard to name -- it just looks wrong.
        this.FLAP_REFERENCE = 58;
    }
    static{
        // The box they are kept in, as a half-extent in world px around the player -- the visible world
        // plus a margin, same as the leaves.
        this.HALF_W = ((0, $10da07838e6d507c$export$aa707847c2571374).viewportX + 2) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        this.HALF_H = ((0, $10da07838e6d507c$export$aa707847c2571374).viewportY + 2) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // Inside this fraction of the box they fly freely; past it they are steered back. Kept well inside
        // the edge so the turn happens off-screen and reads as a butterfly changing its mind.
        this.HOME_FRACTION = 0.72;
    }
    static{
        // A jump bigger than this is a teleport or a room change, not walking.
        // How far it will go looking for somewhere to land. Kept inside its own box, or one would set off
        // across the map towards a tuft you cannot see.
        this.PERCH_SEARCH = 5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // Close enough to have landed. Small, because the approach steps straight in and clamps to the
        // remaining distance -- there is no "close enough" jump to hide.
        this.PERCH_ARRIVE = 0.05;
    }
    static{
        // How long it sits, before the gust makes it sit longer.
        this.PERCH_DWELL_MS = [
            2200,
            7000
        ];
    }
    static{
        // ...and how long it flies before it thinks about landing again.
        this.FLIGHT_MS = [
            2500,
            9000
        ];
    }
    static{
        // The lazy open-and-close of a settled butterfly's wings, in radians/sec. A deliberate exception to
        // the beat being derived from travel: a perched one is not travelling at all, so the derived beat
        // would be zero and the wings would simply freeze wherever they stopped.
        this.PERCHED_FLAP_RATE = 2.2;
    }
    static{
        this.TELEPORT_JUMP = $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_W;
    }
    /**
     * `random` is every roll this effect makes -- the scatter, each butterfly's speed, scale, tint
     * and wingbeat, how long it flies before looking for a leaf, how long it sits, and above all the
     * heading target it re-rolls to make the path wander. It defaults to Math.random, so the game
     * reads exactly as before; it is injected so a test can hand over a SEEDED stream and assert on
     * the flight it produces. Without that the flight is unreproducible, and an assertion over one
     * butterfly's few seconds of wandering then passes or fails on the draw -- which is precisely
     * how "wanders instead of flying in a straight line" came to fail about one run in twenty-five.
     */ constructor(makeTextures, findPerch, random = Math.random){
        this.makeTextures = makeTextures;
        this.findPerch = findPerch;
        this.random = random;
        this.butterflies = [];
        this.activeCount = 0;
        this.textures = [];
        this.running = false;
        this.lastMs = 0;
        this.lastCenterX = 0;
        this.lastCenterY = 0;
        this.hasCenter = false;
        this.pick = ([min, max])=>min + this.random() * (max - min);
        this.// Exposed for tests: how many are currently flying.
        getActiveCount = ()=>this.running ? this.activeCount : 0;
        this.// Exposed for tests: how many are currently sitting on something.
        getPerchedCount = ()=>this.running ? this.butterflies.slice(0, this.activeCount).filter((b)=>b.state === "perched").length : 0;
        this./**
     * Fly them for one frame. `brightness` is the client's interpolated daylight, or undefined in a
     * room with no day cycle (which counts as day). Cheap to call every frame in any room.
     */ update = (config, center, brightness)=>{
            const resolved = this.resolve(config, brightness);
            if (!resolved || !center) {
                this.stop();
                return;
            }
            const nowMs = performance.now();
            if (!this.running) {
                this.running = true;
                this.container.visible = true;
                this.lastMs = nowMs;
                this.ensurePool(resolved.count, center.x, center.y, resolved, nowMs);
                this.scatter(center.x, center.y, resolved, nowMs);
                this.lastCenterX = center.x;
                this.lastCenterY = center.y;
                this.hasCenter = true;
                return;
            }
            this.ensurePool(resolved.count, center.x, center.y, resolved, nowMs);
            if (this.hasCenter && (Math.abs(center.x - this.lastCenterX) > $be65b55052fa66e7$export$b384c8d4ebe6bf23.TELEPORT_JUMP || Math.abs(center.y - this.lastCenterY) > $be65b55052fa66e7$export$b384c8d4ebe6bf23.TELEPORT_JUMP)) {
                this.scatter(center.x, center.y, resolved, nowMs);
                this.lastMs = nowMs;
                this.lastCenterX = center.x;
                this.lastCenterY = center.y;
                return;
            }
            this.lastCenterX = center.x;
            this.lastCenterY = center.y;
            this.hasCenter = true;
            let dt = (nowMs - this.lastMs) / 1000;
            this.lastMs = nowMs;
            if (!(dt > 0)) return;
            // Clamped for the same reason as the leaves: a tab returning from the background would
            // otherwise advance every butterfly by minutes in one step.
            dt = Math.min(dt, 0.05);
            this.step(dt, nowMs, center.x, center.y, resolved);
        };
        this.stop = ()=>{
            if (!this.running) return;
            this.running = false;
            this.container.visible = false;
            this.lastMs = 0;
            this.hasCenter = false;
        };
        this.resolve = (config, brightness)=>{
            const w = window;
            const forced = typeof w.butterflies === "boolean" ? w.butterflies : undefined;
            const enabled = forced !== undefined ? forced : !!config?.enabled;
            if (!enabled) return null;
            const num = (override, value, fallback)=>typeof override === "number" ? override : typeof value === "number" ? value : fallback;
            // Forcing them on from the console lifts the day gate too -- otherwise there is no way to look
            // at them except by waiting for the right hour.
            const dayOnly = forced === true ? false : config?.dayOnly !== false;
            const day = dayOnly ? (0, $eca6088c9a6d9651$export$45f6af437d59d9ba)(brightness) : 1;
            if (day <= 0) return null;
            // The shared wind, if this room has any. A gust is the one thing that stops a butterfly flying,
            // so its strength is read here and spent on speed below. A room with no wind is simply calm.
            const wind = (0, $3462bfbeaff010be$export$317929bda4a1dd52)(null, performance.now() / 1000);
            const gust = wind ? wind.gust : 1;
            // Sheltering: brisk in a lull, much slower at the top of a gust. Floored well above zero --
            // because the wingbeat follows the speed, a butterfly slowed to a crawl would also stop
            // flapping, which reads as one dying rather than one waiting out a gust.
            const shelter = Math.min(1, Math.max(0.45, 1.3 - gust * 0.5));
            const scaleMin = config?.scaleMin ?? $be65b55052fa66e7$export$b384c8d4ebe6bf23.DEFAULT_SCALE_MIN;
            const scaleMax = config?.scaleMax ?? $be65b55052fa66e7$export$b384c8d4ebe6bf23.DEFAULT_SCALE_MAX;
            return {
                // Fewer about as the light goes, and none once it is properly dark.
                count: Math.max(day > 0 ? 1 : 0, Math.min($be65b55052fa66e7$export$b384c8d4ebe6bf23.MAX_BUTTERFLIES, Math.round(num(w.butterflyCount, config?.count, $be65b55052fa66e7$export$b384c8d4ebe6bf23.DEFAULT_COUNT) * day))),
                speed: Math.max(1, num(w.butterflySpeed, config?.speed, $be65b55052fa66e7$export$b384c8d4ebe6bf23.DEFAULT_SPEED)) * shelter,
                // Sinking a little in the gust as well as slowing, which is what sheltering looks like.
                bobScale: shelter,
                alpha: Math.min(1, Math.max(0, num(w.butterflyAlpha, config?.alpha, $be65b55052fa66e7$export$b384c8d4ebe6bf23.DEFAULT_ALPHA))) * day,
                scaleMin: Math.max(0.05, Math.min(scaleMin, scaleMax)),
                scaleMax: Math.max(scaleMin, scaleMax),
                colors: config?.colors?.length ? config.colors : $be65b55052fa66e7$export$b384c8d4ebe6bf23.DEFAULT_COLORS
            };
        };
        this.step = (dt, nowMs, centerX, centerY, cfg)=>{
            const perching = window.butterflyPerch !== false;
            const homeW = $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_W * $be65b55052fa66e7$export$b384c8d4ebe6bf23.HOME_FRACTION;
            const homeH = $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_H * $be65b55052fa66e7$export$b384c8d4ebe6bf23.HOME_FRACTION;
            for(let i = 0; i < this.activeCount; i++){
                const b = this.butterflies[i];
                // PERCHED: sitting still, wings opening and closing lazily, until its time is up.
                if (b.state === "perched") {
                    b.flapPhase += $be65b55052fa66e7$export$b384c8d4ebe6bf23.PERCHED_FLAP_RATE * dt;
                    const sprite = b.sprite;
                    sprite.x = b.x;
                    sprite.y = b.y;
                    // Wings held mostly open and moved gently, rather than folding right down: a settled
                    // butterfly fans them, it does not beat them.
                    const fan = 0.45 + 0.55 * Math.abs(Math.cos(b.flapPhase));
                    sprite.rotation = b.heading + Math.PI / 2;
                    sprite.scale.set(b.scale * fan, b.scale);
                    sprite.alpha = b.baseAlpha * cfg.alpha;
                    if (nowMs >= b.stateUntilMs) {
                        b.state = "flying";
                        b.heading = this.random() * Math.PI * 2;
                        b.headingTarget = b.heading;
                        b.nextTurnMs = nowMs + 300;
                        b.stateUntilMs = nowMs + this.pick($be65b55052fa66e7$export$b384c8d4ebe6bf23.FLIGHT_MS);
                    }
                    continue;
                }
                // FLYING, and long enough since the last rest to think about landing. A gust makes it
                // readier to settle -- being blown about is what sends one looking for a leaf.
                if (b.state === "flying" && nowMs >= b.stateUntilMs && this.findPerch && perching) {
                    const spot = this.findPerch(b.x, b.y, $be65b55052fa66e7$export$b384c8d4ebe6bf23.PERCH_SEARCH);
                    if (spot) {
                        b.state = "approaching";
                        b.perchX = spot.x;
                        b.perchY = spot.y;
                    } else // Nowhere to land here; try again shortly rather than every frame.
                    b.stateUntilMs = nowMs + 1500;
                }
                // Pick somewhere new to be heading, every second or so. This is the wander.
                if (b.state === "flying" && nowMs >= b.nextTurnMs) {
                    b.headingTarget = b.heading + (this.random() * 2 - 1) * 1.6;
                    b.nextTurnMs = nowMs + 500 + this.random() * 1600;
                }
                // Past the inner boundary, the next decision is made for it: turn back towards the middle.
                // Steering rather than teleporting is the whole difference between milling about a meadow
                // and being blown across one.
                const outX = b.x - centerX;
                const outY = b.y - centerY;
                // Stranded well outside the box -- however it got there -- is not something to steer back
                // from, because at twenty pixels a second it would take the best part of a minute. Put it
                // back. Nothing should reach this now that the pool places what it creates; it is here so
                // that if anything ever does, it self-corrects rather than going missing.
                if (Math.abs(outX) > $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_W * 2 || Math.abs(outY) > $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_H * 2) {
                    this.place(b, centerX, centerY, cfg, nowMs);
                    continue;
                }
                if (Math.abs(outX) > homeW || Math.abs(outY) > homeH) b.headingTarget = Math.atan2(-outY, -outX) + (this.random() * 2 - 1) * 0.5;
                // APPROACHING: go straight at the spot rather than steering onto it.
                //
                // Two reasons it is handled here instead of by the heading, which was the first attempt.
                // A butterfly whose turn rate cannot keep up ORBITS the spot forever, circling something a
                // few pixels away; and arriving "close enough" and then snapping the last couple of pixels
                // is a jump of a whole body length at this size. Stepping straight in, clamped so it
                // cannot overshoot, lands exactly on the spot and cannot circle it.
                if (b.state === "approaching") {
                    const dx = b.perchX - b.x;
                    const dy = b.perchY - b.y;
                    const distance = Math.hypot(dx, dy) || 1;
                    // Ease off, but LATE and not by much. A butterfly does not glide in on a long approach;
                    // it flies at the flower at pace and drops onto it over the last few body-lengths. This
                    // holds full speed until about thirteen pixels out -- three or four of its own
                    // wingspans -- and then eases to half. An earlier, deeper ramp (from six tiles out,
                    // down to a fifth of speed) read as swimming towards the leaf.
                    //
                    // The wingbeat follows travel speed, so this is also what makes it settle rather than
                    // stop dead: the beat drops with the approach on its own.
                    const closing = Math.min(1, 0.5 + distance / (0.8 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)));
                    const travel = b.speed * cfg.speed * closing;
                    const stepLength = Math.min(distance, travel * dt);
                    b.x += dx / distance * stepLength;
                    b.y += dy / distance * stepLength;
                    b.heading = Math.atan2(dy, dx);
                    b.headingTarget = b.heading;
                    b.flapPhase += b.flapRate * (travel / $be65b55052fa66e7$export$b384c8d4ebe6bf23.FLAP_REFERENCE) * dt;
                    if (distance - stepLength <= $be65b55052fa66e7$export$b384c8d4ebe6bf23.PERCH_ARRIVE) {
                        b.x = b.perchX;
                        b.y = b.perchY;
                        b.state = "perched";
                        b.stateUntilMs = nowMs + this.pick($be65b55052fa66e7$export$b384c8d4ebe6bf23.PERCH_DWELL_MS) * (2 - cfg.bobScale);
                    }
                    this.draw(b, cfg, 0);
                    continue;
                }
                // Ease the heading towards the target so a turn is a curve, and take the SHORT way round --
                // without this a butterfly turning past due west unwinds the long way, a full circle.
                let delta = b.headingTarget - b.heading;
                while(delta > Math.PI)delta -= Math.PI * 2;
                while(delta < -Math.PI)delta += Math.PI * 2;
                b.heading += delta * Math.min(1, dt * 3.5);
                // How fast this one is actually travelling right now, after its own variation and after
                // sheltering from the wind.
                const travel = b.speed * cfg.speed;
                b.x += Math.cos(b.heading) * travel * dt;
                b.y += Math.sin(b.heading) * travel * dt;
                // The wingbeat is DERIVED from that, so distance covered per beat stays roughly constant
                // whatever the speed. Set the two independently and they disagree the moment either one
                // changes -- which is exactly how this looked first: beating hard and going nowhere.
                b.flapPhase += b.flapRate * (travel / $be65b55052fa66e7$export$b384c8d4ebe6bf23.FLAP_REFERENCE) * dt;
                this.draw(b, cfg, cfg.bobScale);
            }
        };
        this.draw = (b, cfg, bobStrength)=>{
            const sprite = b.sprite;
            // The wings fold almost shut and spring open twice per bob -- abs() of a cosine gives the
            // sharp turn at the moment they are closed, which a plain sine would round off into a pulse.
            // This is the single cue that says "butterfly" at this size.
            const wing = 0.18 + 0.82 * Math.abs(Math.cos(b.flapPhase));
            // ...and the body rises once per cycle, off the same phase.
            const lift = Math.sin(b.flapPhase) * b.bob * bobStrength;
            sprite.x = b.x;
            sprite.y = b.y + lift;
            // The art is drawn with the body along -y, so this turns the body to face the heading.
            sprite.rotation = b.heading + Math.PI / 2;
            sprite.scale.set(b.scale * wing, b.scale);
            sprite.alpha = b.baseAlpha * cfg.alpha;
        };
        this.ensurePool = (count, centerX, centerY, cfg, nowMs)=>{
            const target = Math.min(count, $be65b55052fa66e7$export$b384c8d4ebe6bf23.MAX_BUTTERFLIES);
            if (!this.textures.length && target > 0) {
                try {
                    this.textures = this.makeTextures();
                } catch (e) {
                    this.textures = [];
                }
                if (!this.textures.length) this.textures = [
                    (0, $klOfb.Texture).WHITE
                ];
            }
            while(this.butterflies.length < target){
                const sprite = new (0, $7Bs2Z.Sprite)(this.textures[this.butterflies.length % this.textures.length] ?? (0, $klOfb.Texture).WHITE);
                sprite.anchor.set(0.5);
                this.container.addChild(sprite);
                const butterfly = {
                    sprite: sprite,
                    x: 0,
                    y: 0,
                    heading: 0,
                    headingTarget: 0,
                    nextTurnMs: 0,
                    speed: 1,
                    flapPhase: 0,
                    flapRate: 1,
                    bob: 1,
                    scale: 0.4,
                    baseAlpha: 1,
                    state: "flying",
                    perchX: 0,
                    perchY: 0,
                    stateUntilMs: 0
                };
                this.butterflies.push(butterfly);
                this.place(butterfly, centerX, centerY, cfg, nowMs);
            }
            if (target === this.activeCount) return;
            for(let i = 0; i < this.butterflies.length; i++)this.butterflies[i].sprite.visible = i < target;
            this.activeCount = target;
        };
        this.scatter = (centerX, centerY, cfg, nowMs)=>{
            for(let i = 0; i < this.activeCount; i++)this.place(this.butterflies[i], centerX, centerY, cfg, nowMs);
        };
        this.place = (b, centerX, centerY, cfg, nowMs)=>{
            this.randomize(b, cfg, nowMs);
            b.x = centerX + (this.random() * 2 - 1) * $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_W * $be65b55052fa66e7$export$b384c8d4ebe6bf23.HOME_FRACTION;
            b.y = centerY + (this.random() * 2 - 1) * $be65b55052fa66e7$export$b384c8d4ebe6bf23.HALF_H * $be65b55052fa66e7$export$b384c8d4ebe6bf23.HOME_FRACTION;
            b.sprite.x = b.x;
            b.sprite.y = b.y;
        };
        this.randomize = (b, cfg, nowMs)=>{
            const rand = (min, max)=>min + this.random() * (max - min);
            b.heading = this.random() * Math.PI * 2;
            b.headingTarget = b.heading;
            b.nextTurnMs = nowMs + this.random() * 1200;
            // Always airborne to begin with, and never still believing it is mid-landing: this also runs
            // when one is re-placed after a teleport or when the pool grows, and a stale perch target
            // would send it back across the room to a tuft of grass that is no longer there.
            b.state = "flying";
            b.perchX = 0;
            b.perchY = 0;
            b.stateUntilMs = nowMs + this.pick($be65b55052fa66e7$export$b384c8d4ebe6bf23.FLIGHT_MS);
            b.speed = rand(0.7, 1.35);
            // Six to eight VISIBLE flaps a second at the reference speed, scaled from there by how fast
            // this one is actually going.
            //
            // Note the factor of pi rather than 2pi: the wings fold on abs(cos), which closes them TWICE
            // per phase cycle, so a phase rate of 2pi*f gives 2f flaps. Quoting this in cycles instead of
            // flaps is how it first ended up at 12-16 a second -- a bee's buzz, where a butterfly's flap is
            // slow and floppy and is half the reason you can tell one from the other across a field.
            b.flapRate = rand(Math.PI * 6, Math.PI * 8);
            b.bob = rand(1.1, 2.4);
            b.scale = rand(cfg.scaleMin, cfg.scaleMax);
            b.baseAlpha = rand(0.85, 1);
            b.sprite.texture = this.textures[Math.floor(this.random() * this.textures.length)] ?? (0, $klOfb.Texture).WHITE;
            b.sprite.tint = cfg.colors[Math.floor(this.random() * cfg.colors.length)];
        };
        const container = new (0, $8t5Gy.Container)();
        container.zIndex = $be65b55052fa66e7$export$b384c8d4ebe6bf23.Z_INDEX;
        container.interactiveChildren = false;
        container.visible = false;
        this.container = container;
    }
    static{
        /**
     * The butterfly art, generated once rather than shipped: a body along -y with a fore and hind wing
     * either side, drawn white so a single texture serves the whole palette by tint.
     *
     * The body runs along the sprite's Y axis so that squashing X folds the wings towards it -- get
     * that the other way round and the flap squashes the butterfly along its length instead, which
     * reads as a bug being stepped on rather than one in flight.
     */ this.buildButterflyTextures = (generate)=>{
            // [forewing radius, hindwing radius, body length]. Two shapes is enough variety at this size.
            const shapes = [
                [
                    5,
                    3.6,
                    9
                ],
                [
                    4.2,
                    3,
                    7.5
                ]
            ];
            return shapes.map(([fore, hind, body])=>{
                const g = new (0, $gwPoJ.Graphics)();
                g.beginFill(0xffffff);
                // Forewings, set slightly forward of centre, and the smaller hindwings behind them.
                g.drawEllipse(-fore * 0.75, -body * 0.18, fore, fore * 0.78);
                g.drawEllipse(fore * 0.75, -body * 0.18, fore, fore * 0.78);
                g.drawEllipse(-hind * 0.8, body * 0.25, hind, hind * 0.85);
                g.drawEllipse(hind * 0.8, body * 0.25, hind, hind * 0.85);
                g.endFill();
                // The body, darker so it survives tinting as a visible seam between the wings -- without it
                // the two halves merge into one blob the moment the wings fold.
                g.beginFill(0x6b6b6b);
                g.drawEllipse(0, 0, body * 0.11, body * 0.5);
                g.endFill();
                const texture = generate(g);
                g.destroy();
                return texture;
            });
        };
    }
    static{
        // The default texture factory, bound to a live renderer. Split out so the flight can be tested
        // without a GPU.
        this.textureFactory = (renderer)=>()=>$be65b55052fa66e7$export$b384c8d4ebe6bf23.buildButterflyTextures((g)=>renderer.generateTexture(g, {
                        resolution: 2,
                        scaleMode: (0, $P8XPi.SCALE_MODES).LINEAR
                    }));
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $P8XPi = parcelRequire("P8XPi");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");



class $aa1fa3752bebfcbe$export$14e015fa5aada1ce {
    static{
        // Under the overlay surface's own items (chat bubbles, HUD), which sit at zero.
        this.Z_INDEX = -100;
    }
    static{
        this.MAX_FIREFLIES = 40;
    }
    static{
        this.DEFAULT_COUNT = 5;
    }
    static{
        // How long one flash lasts, in seconds -- the difference between a firefly and a SPARK. The eye
        // needs long enough to find the thing, look at it, and watch it go out.
        //
        // A DURATION, not a share of the cycle. As a share it was the product of two separate random draws
        // (the share and the period), which spread it from one second to nearly three and moved it
        // whenever the cycle was retuned. How long a glow lasts and how often it comes round are two
        // different questions and are asked separately here.
        this.DEFAULT_FLASH_SECONDS = 2.5;
    }
    static{
        // A flash cannot outlast its own cycle, however it is configured.
        this.MAX_LIT_FRACTION = 0.75;
    }
    static{
        this.DEFAULT_ALPHA = 0.95;
    }
    static{
        this.DEFAULT_SCALE_MIN = 0.55;
    }
    static{
        this.DEFAULT_SCALE_MAX = 0.95;
    }
    static{
        // Yellow-green, which is what the real ones are and what reads as a living light rather than a
        // lamp. The cooler one is the odd variation.
        this.DEFAULT_COLORS = [
            0xd8ff8a,
            0xc6ff70,
            0xeaff9e,
            0xa8ff86
        ];
    }
    static{
        // How far one strays from its home point.
        this.HOVER_RADIUS = 0.85 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // ...and how quickly it gets there. Enough to look busy over a small patch.
        this.DART_SPEED = 26;
    }
    static{
        this.HALF_W = ((0, $10da07838e6d507c$export$aa707847c2571374).viewportX + 2) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        this.HALF_H = ((0, $10da07838e6d507c$export$aa707847c2571374).viewportY + 2) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // Beyond THIS it is re-homed. Deliberately outside the range it is placed in: a firefly homed near
        // the edge of the box and then hovering outward would otherwise trip the recycle and be flung to
        // the far side, every time it drifted.
        this.RECYCLE_W = $aa1fa3752bebfcbe$export$14e015fa5aada1ce.HALF_W + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        this.RECYCLE_H = $aa1fa3752bebfcbe$export$14e015fa5aada1ce.HALF_H + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        this.TELEPORT_JUMP = $aa1fa3752bebfcbe$export$14e015fa5aada1ce.HALF_W;
    }
    constructor(makeTexture){
        this.makeTexture = makeTexture;
        this.flies = [];
        this.activeCount = 0;
        this.running = false;
        this.lastMs = 0;
        this.lastCenterX = 0;
        this.lastCenterY = 0;
        this.hasCenter = false;
        this.// Exposed for tests: how many are about, and how many are lit this instant.
        getActiveCount = ()=>this.running ? this.activeCount : 0;
        this.getLitCount = ()=>this.running ? this.flies.slice(0, this.activeCount).filter((f)=>f.sprite.visible).length : 0;
        this.update = (config, center, brightness)=>{
            const resolved = this.resolve(config, brightness);
            if (!resolved || !center) {
                this.stop();
                return;
            }
            const nowMs = performance.now();
            if (!this.running) {
                this.running = true;
                this.container.visible = true;
                this.lastMs = nowMs;
                this.ensurePool(resolved.count, center.x, center.y, resolved, nowMs);
                this.scatter(center.x, center.y, resolved, nowMs);
                this.lastCenterX = center.x;
                this.lastCenterY = center.y;
                this.hasCenter = true;
                return;
            }
            this.ensurePool(resolved.count, center.x, center.y, resolved, nowMs);
            if (this.hasCenter && (Math.abs(center.x - this.lastCenterX) > $aa1fa3752bebfcbe$export$14e015fa5aada1ce.TELEPORT_JUMP || Math.abs(center.y - this.lastCenterY) > $aa1fa3752bebfcbe$export$14e015fa5aada1ce.TELEPORT_JUMP)) {
                this.scatter(center.x, center.y, resolved, nowMs);
                this.lastMs = nowMs;
                this.lastCenterX = center.x;
                this.lastCenterY = center.y;
                return;
            }
            this.lastCenterX = center.x;
            this.lastCenterY = center.y;
            this.hasCenter = true;
            let dt = (nowMs - this.lastMs) / 1000;
            this.lastMs = nowMs;
            if (!(dt > 0)) return;
            dt = Math.min(dt, 0.05);
            this.step(dt, nowMs, center.x, center.y, resolved);
        };
        this.stop = ()=>{
            if (!this.running) return;
            this.running = false;
            this.container.visible = false;
            this.lastMs = 0;
            this.hasCenter = false;
        };
        this.resolve = (config, brightness)=>{
            const w = window;
            const forced = typeof w.fireflies === "boolean" ? w.fireflies : undefined;
            const enabled = forced !== undefined ? forced : !!config?.enabled;
            if (!enabled) return null;
            const num = (override, value, fallback)=>typeof override === "number" ? override : typeof value === "number" ? value : fallback;
            // Forcing them on from the console lifts the night gate as well; there is no other way to look
            // at them in daylight.
            const nightOnly = forced === true ? false : config?.nightOnly !== false;
            const night = nightOnly ? (0, $eca6088c9a6d9651$export$92091d9bb73d8475)(brightness) : 1;
            if (night <= 0) return null;
            const scaleMin = config?.scaleMin ?? $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DEFAULT_SCALE_MIN;
            const scaleMax = config?.scaleMax ?? $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DEFAULT_SCALE_MAX;
            return {
                // More of them the darker it gets, and none at all before dusk.
                count: Math.max(night > 0 ? 1 : 0, Math.min($aa1fa3752bebfcbe$export$14e015fa5aada1ce.MAX_FIREFLIES, Math.round(num(w.fireflyCount, config?.count, $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DEFAULT_COUNT) * night))),
                flashSeconds: Math.max(0.1, num(w.fireflyFlashSeconds, config?.flashSeconds, $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DEFAULT_FLASH_SECONDS)),
                alpha: Math.min(1, Math.max(0, num(w.fireflyAlpha, config?.alpha, $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DEFAULT_ALPHA))) * night,
                scaleMin: Math.max(0.05, Math.min(scaleMin, scaleMax)),
                scaleMax: Math.max(scaleMin, scaleMax),
                colors: config?.colors?.length ? config.colors : $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DEFAULT_COLORS
            };
        };
        this.step = (dt, nowMs, centerX, centerY, cfg)=>{
            for(let i = 0; i < this.activeCount; i++){
                const f = this.flies[i];
                // Wandered off the edge of what could be on screen -- re-home it on the other side. Doing
                // this only WHILE DARK is what makes it free: a firefly between flashes is not on screen,
                // so there is nothing to see move.
                if (!f.sprite.visible && (Math.abs(f.homeX - centerX) > $aa1fa3752bebfcbe$export$14e015fa5aada1ce.RECYCLE_W || Math.abs(f.homeY - centerY) > $aa1fa3752bebfcbe$export$14e015fa5aada1ce.RECYCLE_H)) this.place(f, centerX, centerY, cfg, nowMs);
                // Somewhere new in its patch to dart to, every so often. Short hops with pauses between
                // read as busy; one long drift reads as floating away.
                if (nowMs >= f.nextDartMs) {
                    const angle = Math.random() * Math.PI * 2;
                    const reach = Math.random() * $aa1fa3752bebfcbe$export$14e015fa5aada1ce.HOVER_RADIUS;
                    f.targetX = f.homeX + Math.cos(angle) * reach;
                    f.targetY = f.homeY + Math.sin(angle) * reach * 0.7;
                    f.nextDartMs = nowMs + 260 + Math.random() * 900;
                }
                // Ease towards it, clamped so it cannot overshoot and jitter around the target.
                const dx = f.targetX - f.x;
                const dy = f.targetY - f.y;
                const distance = Math.hypot(dx, dy);
                if (distance > 0.01) {
                    const stepLength = Math.min(distance, $aa1fa3752bebfcbe$export$14e015fa5aada1ce.DART_SPEED * dt);
                    f.x += dx / distance * stepLength;
                    f.y += dy / distance * stepLength;
                }
                f.phase = (f.phase + f.cycleRate * dt) % 1;
                // THE FLASH. Lit for the opening slice of the cycle and dark for all the rest -- and dark
                // means hidden, not faint: a firefly between flashes is gone, and a dim dot hanging there
                // would give away that it never left.
                const sprite = f.sprite;
                if (f.phase < f.litFraction) {
                    const u = f.phase / f.litFraction;
                    // Rise, HOLD, fade. The hold is the point: a bare rise-and-fall curve peaks for an
                    // instant and is gone, which is what made these read as sparks however long the window
                    // was. Coming up quickly, sitting there, and fading out slowly is what a firefly does.
                    const glow = u < 0.22 ? $aa1fa3752bebfcbe$export$14e015fa5aada1ce.smooth(u / 0.22) : u > 0.55 ? $aa1fa3752bebfcbe$export$14e015fa5aada1ce.smooth((1 - u) / 0.45) : 1;
                    sprite.visible = true;
                    sprite.x = f.x;
                    sprite.y = f.y;
                    sprite.alpha = f.peakAlpha * cfg.alpha * glow;
                    // Swells very slightly as it brightens, which reads as light spilling rather than a
                    // sprite fading up.
                    sprite.scale.set(f.scale * (0.85 + 0.15 * glow));
                } else if (sprite.visible) sprite.visible = false;
            }
        };
        this.ensurePool = (count, centerX, centerY, cfg, nowMs)=>{
            const target = Math.min(count, $aa1fa3752bebfcbe$export$14e015fa5aada1ce.MAX_FIREFLIES);
            if (!this.texture && target > 0) try {
                this.texture = this.makeTexture();
            } catch (e) {
                this.texture = (0, $klOfb.Texture).WHITE;
            }
            while(this.flies.length < target){
                const sprite = new (0, $7Bs2Z.Sprite)(this.texture ?? (0, $klOfb.Texture).WHITE);
                sprite.anchor.set(0.5);
                // A glow is light, not a pale sprite.
                sprite.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
                sprite.visible = false;
                this.container.addChild(sprite);
                const fly = {
                    sprite: sprite,
                    homeX: 0,
                    homeY: 0,
                    x: 0,
                    y: 0,
                    targetX: 0,
                    targetY: 0,
                    nextDartMs: 0,
                    phase: 0,
                    cycleRate: 0.3,
                    litFraction: 0.2,
                    scale: 0.7,
                    peakAlpha: 1
                };
                this.flies.push(fly);
                // Placed as it is created, not merely constructed -- the count rises as the light goes, so
                // this runs at dusk and not only on the first frame.
                this.place(fly, centerX, centerY, cfg, nowMs);
            }
            if (target === this.activeCount) return;
            for(let i = 0; i < this.flies.length; i++)if (i >= target) this.flies[i].sprite.visible = false;
            this.activeCount = target;
        };
        this.scatter = (centerX, centerY, cfg, nowMs)=>{
            for(let i = 0; i < this.activeCount; i++)this.place(this.flies[i], centerX, centerY, cfg, nowMs);
        };
        this.place = (f, centerX, centerY, cfg, nowMs)=>{
            const rand = (min, max)=>min + Math.random() * (max - min);
            f.homeX = centerX + (Math.random() * 2 - 1) * $aa1fa3752bebfcbe$export$14e015fa5aada1ce.HALF_W;
            f.homeY = centerY + (Math.random() * 2 - 1) * $aa1fa3752bebfcbe$export$14e015fa5aada1ce.HALF_H;
            f.x = f.homeX;
            f.y = f.homeY;
            f.targetX = f.homeX;
            f.targetY = f.homeY;
            f.nextDartMs = nowMs + Math.random() * 600;
            // A random starting point in the cycle, so they do not all flash together the moment they are
            // placed. Real ones do synchronise; a whole camp doing it in step on the first frame after
            // dusk would read as a bug rather than as a phenomenon.
            f.phase = Math.random();
            // Seven to twelve seconds a cycle -- and this, not the lit fraction, is what decides how OFTEN
            // the camp flashes. Five of them on a ten-second cycle is a glow about every two seconds
            // somewhere in the trees, which is the "odd firefly" this is meant to be. On the two-to-five
            // seconds it had first, the same five read as a scattering of sparks going off constantly.
            f.cycleRate = rand(0.08, 0.14);
            // The lit share is DERIVED from the wanted duration and this one's own cycle, so the flash is
            // the length it was asked to be whatever period it happens to have drawn. The small variation
            // is on the duration, so no two are identical without any of them being the wrong length.
            const flashSeconds = cfg.flashSeconds * rand(0.85, 1.15);
            f.litFraction = Math.min($aa1fa3752bebfcbe$export$14e015fa5aada1ce.MAX_LIT_FRACTION, flashSeconds * f.cycleRate);
            f.scale = rand(cfg.scaleMin, cfg.scaleMax);
            f.peakAlpha = rand(0.8, 1);
            f.sprite.visible = false;
            f.sprite.tint = cfg.colors[Math.floor(Math.random() * cfg.colors.length)];
            // Put the sprite where the firefly is, even though it is dark and nothing will look at it
            // until it flashes. A hidden sprite left at its old position is a stale reading waiting for
            // whatever asks next -- and `step` only writes a position on the frames it is lit.
            f.sprite.x = f.x;
            f.sprite.y = f.y;
        };
        const container = new (0, $8t5Gy.Container)();
        container.zIndex = $aa1fa3752bebfcbe$export$14e015fa5aada1ce.Z_INDEX;
        container.interactiveChildren = false;
        container.visible = false;
        // The overlay surface is camera-translated but NOT zoomed, so this container carries the zoom
        // and everything inside it is in plain world coordinates.
        container.scale.set((0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom);
        this.container = container;
    }
    static{
        // Smoothstep: eases in and out instead of ramping linearly, so neither end of a flash has a corner
        // on it.
        this.smooth = (t)=>{
            const u = Math.min(1, Math.max(0, t));
            return u * u * (3 - 2 * u);
        };
    }
    static{
        /**
     * The glow, generated once: a small bright core inside a soft halo, drawn white so one texture
     * serves every tint. Stacked translucent circles rather than a blur filter -- a filter would want
     * a render target for something that is four rings of a Graphics.
     */ this.buildGlowTexture = (generate)=>{
            const g = new (0, $gwPoJ.Graphics)();
            const RINGS = 7;
            const OUTER = 9;
            for(let i = RINGS; i >= 1; i--){
                const radius = OUTER * i / RINGS;
                // Falls off faster than linear so the core stays tight and the halo stays faint; a linear
                // ramp gives a soft ball with no centre to it.
                const alpha = 0.1 * Math.pow(1 - (i - 1) / RINGS, 1.6);
                g.beginFill(0xffffff, alpha);
                g.drawCircle(0, 0, radius);
                g.endFill();
            }
            // The core itself, near solid.
            g.beginFill(0xffffff, 0.95);
            g.drawCircle(0, 0, 1.4);
            g.endFill();
            const texture = generate(g);
            g.destroy();
            return texture;
        };
    }
    static{
        this.textureFactory = (renderer)=>()=>$aa1fa3752bebfcbe$export$14e015fa5aada1ce.buildGlowTexture((g)=>renderer.generateTexture(g, {
                        resolution: 2,
                        scaleMode: (0, $P8XPi.SCALE_MODES).LINEAR
                    }));
    }
}











const $e73814e1e89e2411$var$property = (tile, name)=>tile?.properties?.find((p)=>p.name === name)?.value;
let $e73814e1e89e2411$var$parentsFor;
let $e73814e1e89e2411$var$parents;
const $e73814e1e89e2411$export$811fe2664856ba53 = (id)=>{
    if ($e73814e1e89e2411$var$parentsFor !== (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets) {
        $e73814e1e89e2411$var$parents = new Map();
        for (const [tilesetId, sheet] of Object.entries((0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets))for (const tile of sheet.tiles || []){
            const entityTileId = $e73814e1e89e2411$var$property(tile, "entityTileId");
            if (entityTileId && !$e73814e1e89e2411$var$parents.has(entityTileId)) $e73814e1e89e2411$var$parents.set(entityTileId, {
                tilesetId: tilesetId,
                tilePos: tile.id
            });
        }
        $e73814e1e89e2411$var$parentsFor = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets;
    }
    return $e73814e1e89e2411$var$parents.get(id);
};
let $e73814e1e89e2411$var$compositesFor;
let $e73814e1e89e2411$var$composites;
const $e73814e1e89e2411$export$e4b546a0a3359d33 = (id)=>{
    if ($e73814e1e89e2411$var$compositesFor !== (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets) {
        $e73814e1e89e2411$var$composites = new Map();
        for (const [tilesetId, sheet] of Object.entries((0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets))for (const tile of sheet.tiles || []){
            const composite = $e73814e1e89e2411$var$property(tile, "compositeTileIdParent");
            if (composite && !$e73814e1e89e2411$var$composites.has(composite)) $e73814e1e89e2411$var$composites.set(composite, {
                tilesetId: tilesetId,
                tilePos: tile.id
            });
        }
        $e73814e1e89e2411$var$compositesFor = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets;
    }
    return $e73814e1e89e2411$var$composites.get(id);
};
const $e73814e1e89e2411$export$8ccf9cbb1fcbef00 = (gid)=>{
    let best;
    for (const spec of Object.values((0, $2db7e29a401f47a7$export$89f24ee63398b793)))if (spec.firstgid <= gid && (!best || spec.firstgid > best.firstgid)) best = spec;
    return best && {
        tilesetId: best.tilesetId,
        tilePos: gid - best.firstgid
    };
};
let $e73814e1e89e2411$var$gidTilesFor;
let $e73814e1e89e2411$var$gidTiles;
const $e73814e1e89e2411$export$309c142e66c85455 = (gid)=>{
    if (!(gid > 0)) return undefined;
    if ($e73814e1e89e2411$var$gidTilesFor !== (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets) {
        $e73814e1e89e2411$var$gidTiles = new Map();
        $e73814e1e89e2411$var$gidTilesFor = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets;
    }
    if (!$e73814e1e89e2411$var$gidTiles.has(gid)) {
        const spec = $e73814e1e89e2411$export$8ccf9cbb1fcbef00(gid);
        const sheet = spec && (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets[spec.tilesetId];
        const tile = sheet?.tiles?.find((t)=>t.id === spec.tilePos);
        $e73814e1e89e2411$var$gidTiles.set(gid, $e73814e1e89e2411$var$property(tile, "entityTileId"));
    }
    return $e73814e1e89e2411$var$gidTiles.get(gid);
};
const $e73814e1e89e2411$export$fb1e21c4d6df7a03 = (gid)=>(0, $ff74dc2a666565c1$export$1db3e4d273a27613)($e73814e1e89e2411$export$309c142e66c85455(gid));
const $e73814e1e89e2411$export$255deb8888c7034 = (gid)=>(0, $ff74dc2a666565c1$export$3bd84e90c0698644)($e73814e1e89e2411$export$309c142e66c85455(gid));


const $b5bcf1a44b272962$export$5fb0940c35cefdf2 = [
    "meadow-grass-a",
    "meadow-grass-b",
    "meadow-grass-c",
    "meadow-grass-d",
    "meadow-grass-e",
    "meadow-grass-f"
];
// A well-mixed hash of a cell. Read from its HIGH bits: a final multiply barely stirs the low ones,
// so `hash % n` hands neighbouring cells the same variant far more often than chance.
const $b5bcf1a44b272962$var$cellHash = (x, y)=>{
    let h = Math.imul(x | 0, 0x27d4eb2d) ^ Math.imul(y | 0, 0x165667b1);
    h = Math.imul(h ^ h >>> 15, 0x85ebca6b);
    h = Math.imul(h ^ h >>> 13, 0xc2b2ae35);
    return (h ^ h >>> 16) >>> 0;
};
const $b5bcf1a44b272962$export$d44126d4955de650 = (x, y)=>{
    const id = $b5bcf1a44b272962$export$5fb0940c35cefdf2[Math.floor($b5bcf1a44b272962$var$cellHash(x, y) / 2 ** 32 * $b5bcf1a44b272962$export$5fb0940c35cefdf2.length)];
    return (0, $e73814e1e89e2411$export$811fe2664856ba53)(id) ?? {
        tilesetId: (0, $757b61c60f0c23c3$export$fae1c8fa1221db37),
        tilePos: (0, $757b61c60f0c23c3$export$10eda66a00e50d39)
    };
};
const $b5bcf1a44b272962$export$d5a4acbdfe2febc2 = [
    "meadow-tuft-a",
    "meadow-tuft-b",
    "meadow-tuft-c",
    "meadow-tuft-d",
    "meadow-tuft-e"
];
const $b5bcf1a44b272962$export$6e604cb34e4ae537 = 2.8;
// A scenery pool, resolved. Loud rather than a bare meadow: the art ships with the code that plants it.
const $b5bcf1a44b272962$var$resolved = (ids)=>ids.map((id)=>{
        const planted = (0, $e73814e1e89e2411$export$e4b546a0a3359d33)(id);
        if (!planted) throw new Error(`Meadow plant ${id} is not in the content catalog`);
        return planted;
    });
const $b5bcf1a44b272962$export$f0e076e35dd4c8dc = ()=>$b5bcf1a44b272962$var$resolved($b5bcf1a44b272962$export$d5a4acbdfe2febc2);
const $b5bcf1a44b272962$export$ea744d88539ffdc5 = [
    "dirt-sedge-a",
    "dirt-sedge-b",
    "dirt-sedge-c"
];
const $b5bcf1a44b272962$export$3f4c97a4fa121847 = [
    "dirt-herb-a",
    "dirt-herb-b",
    "dirt-herb-c"
];
const $b5bcf1a44b272962$var$LPC_DIRT_SEDGE = 218;
const $b5bcf1a44b272962$var$LPC_DIRT_HERB = 219;
const $b5bcf1a44b272962$export$6e7995ad33085d45 = (lpcTilePos, x, y)=>{
    const pool = lpcTilePos === $b5bcf1a44b272962$var$LPC_DIRT_SEDGE ? $b5bcf1a44b272962$export$ea744d88539ffdc5 : lpcTilePos === $b5bcf1a44b272962$var$LPC_DIRT_HERB ? $b5bcf1a44b272962$export$3f4c97a4fa121847 : undefined;
    if (!pool) return {
        tilesetId: (0, $757b61c60f0c23c3$export$fae1c8fa1221db37),
        tilePos: lpcTilePos
    };
    return $b5bcf1a44b272962$var$resolved([
        pool[Math.floor($b5bcf1a44b272962$var$cellHash(x + 7919, y) / 2 ** 32 * pool.length)]
    ])[0];
};
let $b5bcf1a44b272962$var$dirtGidsFor;
let $b5bcf1a44b272962$var$dirtGids;
const $b5bcf1a44b272962$export$51754a9c0a9abf8a = (gid)=>{
    if ($b5bcf1a44b272962$var$dirtGidsFor !== (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets) {
        $b5bcf1a44b272962$var$dirtGids = new Set($b5bcf1a44b272962$var$resolved([
            ...$b5bcf1a44b272962$export$ea744d88539ffdc5,
            ...$b5bcf1a44b272962$export$3f4c97a4fa121847
        ]).map((p)=>(0, $2db7e29a401f47a7$export$89f24ee63398b793)[p.tilesetId].firstgid + p.tilePos));
        $b5bcf1a44b272962$var$dirtGidsFor = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets;
    }
    return $b5bcf1a44b272962$var$dirtGids.has(gid);
};
let $b5bcf1a44b272962$var$tuftIdsFor;
let $b5bcf1a44b272962$var$tuftIds;
let $b5bcf1a44b272962$var$leansFor;
let $b5bcf1a44b272962$var$leans;
const $b5bcf1a44b272962$export$2f28c1c74a7ae684 = (textureId)=>{
    if ($b5bcf1a44b272962$var$leansFor !== (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets) {
        const specs = [
            ...$b5bcf1a44b272962$export$d5a4acbdfe2febc2,
            ...$b5bcf1a44b272962$export$ea744d88539ffdc5
        ].map((0, $e73814e1e89e2411$export$e4b546a0a3359d33)).filter(Boolean);
        $b5bcf1a44b272962$var$leans = new Map(specs.map((s)=>[
                (0, $757b61c60f0c23c3$export$b5fe4f8e2269498c)(s.tilesetId, s.tilePos),
                $b5bcf1a44b272962$export$6e604cb34e4ae537
            ]));
        $b5bcf1a44b272962$var$leansFor = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets;
    }
    return $b5bcf1a44b272962$var$leans.get(textureId);
};
const $b5bcf1a44b272962$export$bd11e616466ccd6 = ()=>{
    if ($b5bcf1a44b272962$var$tuftIdsFor !== (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets) {
        const specs = $b5bcf1a44b272962$export$d5a4acbdfe2febc2.map((0, $e73814e1e89e2411$export$e4b546a0a3359d33)).filter(Boolean);
        $b5bcf1a44b272962$var$tuftIds = new Set(specs.map((s)=>(0, $757b61c60f0c23c3$export$b5fe4f8e2269498c)(s.tilesetId, s.tilePos)));
        $b5bcf1a44b272962$var$tuftIdsFor = (0, $e5c675b7b9585b42$export$8952b416ba38edb4).mapTilesets;
    }
    return $b5bcf1a44b272962$var$tuftIds;
};




class $59052a7f89e51e65$export$7d832ea11681c35b {
    static{
        // How fast a blade oscillates, in radians/sec, before the console multiplier.
        this.FREQUENCY = 1.9;
    }
    static{
        // How far apart the crests of the travelling wave are, in world px. About six tiles: short enough
        // that a gust is visibly moving across the view, long enough that neighbours lean together.
        this.WAVELENGTH = 6 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // How much a blade's own phase is scattered off the wave front, in radians.
        this.JITTER = 0.9;
    }
    static{
        // The bend is a horizontal shear, so only the wind's horizontal component can show as a lean -- a
        // wind blowing straight up or down the screen bends grass towards the viewer, which a flat sprite
        // cannot draw. Rooms with a cross-screen wind (ember's is 22 degrees) get the full effect.
        //
        // The hinge height: the blade pivots about the bottom of its cell.
        this.HINGE = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // Beyond the viewport by this much is still updated, so a blade is already mid-lean when it scrolls
        // in rather than snapping upright to bent on its first visible frame.
        this.MARGIN = 2 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    static{
        // The wind calms after dark but never stops: the leaves settle for the night (day_gate.ts) and the
        // grass keeps a little stir, so the world does not freeze solid the moment the fog comes up.
        this.NIGHT_CALM = 0.3;
    }
    static{
        // Where the bend profile starts, as a share of the full lean, at the top of the piece sitting ON
        // the anchor row. Not zero: grass rooted in the ground still stirs low down, and a base held
        // perfectly rigid under a leaning top reads as a hinge rather than as a plant.
        this.ROOT_SHARE = 0.18;
    }
    static{
        // How far the player may move before the near set is gathered again. Half the margin, so a blade
        // cannot cross the whole margin and reach the screen before it is picked up.
        this.REGATHER = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    constructor(){
        this.blades = [];
        this.running = false;
        // The blades near enough to matter, rebuilt only when the player has actually moved somewhere new.
        // A room holds well over a thousand blades and fewer than a twentieth are ever on screen; testing
        // every one of them every frame measured at about 0.8ms a frame on a fast machine, which is real
        // money on the low-end target for an effect nobody is looking directly at.
        this.visible = [];
        this.visibleAtX = 0;
        this.visibleAtY = 0;
        this.visibleValid = false;
        /**
     * Take an interest in a sprited cell, if it is something that bends. Called for every sprited cell
     * the map renders, so it has to be cheap and it has to say no quickly.
     */ this.register = (sprite, cellX, cellY, textureId, heightAbove = 0, entityTileId)=>{
            // Known LPC art by its texture; a meadow clump or sprout by its `grass` tag, and the meadow's
            // scenery (tufts, dirt sedges: no tag to carry) by the texture its catalog cell resolves to --
            // Lab art lands in whatever authored-terrain cell was free, so no texture id is written down.
            const kind = (0, $ff74dc2a666565c1$export$84fb81d7a74c390f)(entityTileId);
            const lean = (0, $757b61c60f0c23c3$export$166f49b89327c25e)[textureId] ?? (kind === "long" ? (0, $757b61c60f0c23c3$export$b084f1e02cb68e73) : kind === "sprout" ? (0, $757b61c60f0c23c3$export$ceb64c57b30dcebb) : (0, $b5bcf1a44b272962$export$2f28c1c74a7ae684)(textureId));
            if (lean === undefined) return;
            // Where this piece's two edges sit on the plant's bend profile. `heightAbove` is the sub-tile's
            // own row above the anchor, so the profile is evaluated at the top of this piece and at the top
            // of the piece below it -- which is this one's bottom. Cumulative by construction: the joins
            // cannot come apart, however hard the wind blows.
            //
            // The ground itself never moves, so the base piece's bottom is pinned at zero.
            const profile = (h)=>lean * (h + $59052a7f89e51e65$export$7d832ea11681c35b.ROOT_SHARE) / (1 + $59052a7f89e51e65$export$7d832ea11681c35b.ROOT_SHARE);
            const leanTop = profile(heightAbove);
            const leanBottom = heightAbove === 0 ? 0 : profile(heightAbove - 1);
            const worldX = cellX * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            const worldY = cellY * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
            this.blades.push({
                sprite: sprite,
                baseX: sprite.x,
                worldX: worldX,
                worldY: worldY,
                leanTop: leanTop,
                leanBottom: leanBottom,
                // A cheap positional hash: no per-blade storage, stable across a rebuild of the same room,
                // and uncorrelated enough between neighbours to break up the wave front.
                jitter: Math.sin(cellX * 12.9898 + cellY * 78.233) * 43758.5453 % 1 * $59052a7f89e51e65$export$7d832ea11681c35b.JITTER
            });
            this.visibleValid = false;
        };
        // The map tore down every cell for a full rebuild; the blades went with them. This matters more
        // here than it looks: these sprites come from a POOL, so a stale reference is not merely dead, it
        // is a live sprite that now belongs to some other tile.
        this.clear = ()=>{
            this.blades = [];
            this.visible = [];
            this.visibleValid = false;
            this.running = false;
        };
        // Stand every blade upright, then forget them all. Their floor stopped being the active one (see
        // MapRenderingManager.handOver): its sprites are not recycled, so one left mid-lean stays bent.
        this.detachAll = ()=>{
            this.release();
            this.clear();
        };
        // Exposed for tests: how many blades are registered, and how many moved on the last frame.
        this.getBladeCount = ()=>this.blades.length;
        this.swayingCount = 0;
        /**
     * A blade of grass near (x, y) that something could land on, or null if there is none within
     * `radius`. The butterflies perch on these (see Butterflies) -- which is why this reads the FULL
     * registry rather than the near set: the near set only exists while the wind is blowing, and a
     * still room still has grass to sit on.
     *
     * The point returned is the top of the plant, not the cell it is rooted in. Long grass is two tiles
     * tall, and a butterfly sitting at its base would be down in the roots with the blades drawn over
     * the top of it.
     *
     * Reservoir sampling so it is an even pick among the candidates without building a list -- this
     * walks the room's blades, and at a few calls a second that is cheap, but allocating an array of
     * them each time would not be.
     */ this.perchNear = (x, y, radius)=>{
            let chosen;
            let seen = 0;
            for (const blade of this.blades){
                if (blade.sprite.destroyed) continue;
                if (Math.abs(blade.worldX - x) > radius || Math.abs(blade.worldY - y) > radius) continue;
                seen++;
                if (Math.random() * seen < 1) chosen = blade;
            }
            if (!chosen) return null;
            // Middle of the cell, and up near the tips rather than the roots.
            return {
                x: chosen.worldX + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) / 2,
                y: chosen.worldY - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * 0.35
            };
        };
        /**
     * Bend the grass for this frame.
     *
     * @param config the room's wind (see wind.ts -- the leaves' config IS the room's wind)
     * @param center the player's world position; the box follows them
     * @param brightness the client's interpolated daylight, or undefined in a room with no day cycle
     */ this.update = (config, center, brightness)=>{
            const w = window;
            const enabled = w.grassSway !== false;
            const wind = enabled && center ? (0, $3462bfbeaff010be$export$317929bda4a1dd52)(config, performance.now() / 1000) : null;
            if (!wind) {
                // Stand everything upright once, then stop paying anything until the wind returns. Without
                // this a room whose wind is switched off keeps its grass frozen mid-lean.
                if (this.running) this.release();
                return;
            }
            this.running = true;
            const leanScale = typeof w.grassSwayLean === "number" ? w.grassSwayLean : 1;
            const speedScale = typeof w.grassSwaySpeed === "number" ? w.grassSwaySpeed : 1;
            // Calmer after dark, in step with the leaves settling, but never quite still.
            const hour = $59052a7f89e51e65$export$7d832ea11681c35b.NIGHT_CALM + (1 - $59052a7f89e51e65$export$7d832ea11681c35b.NIGHT_CALM) * (0, $eca6088c9a6d9651$export$45f6af437d59d9ba)(brightness);
            const amplitude = wind.gust * wind.x * leanScale * hour;
            const tSeconds = performance.now() / 1000 * $59052a7f89e51e65$export$7d832ea11681c35b.FREQUENCY * speedScale;
            const waveNumber = Math.PI * 2 / $59052a7f89e51e65$export$7d832ea11681c35b.WAVELENGTH;
            const halfW = 9 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + $59052a7f89e51e65$export$7d832ea11681c35b.MARGIN;
            const halfH = 7 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) + $59052a7f89e51e65$export$7d832ea11681c35b.MARGIN;
            // Re-gather the near set only when the player has left the box it was gathered for. Walking a
            // whole room's blades every frame is the one thing about this effect that could actually cost
            // something; walking them once every few tiles costs nothing.
            if (!this.visibleValid || Math.abs(center.x - this.visibleAtX) > $59052a7f89e51e65$export$7d832ea11681c35b.REGATHER || Math.abs(center.y - this.visibleAtY) > $59052a7f89e51e65$export$7d832ea11681c35b.REGATHER) this.gather(center.x, center.y, halfW, halfH);
            let swaying = 0;
            for(let i = 0; i < this.visible.length; i++){
                const blade = this.visible[i];
                const sprite = blade.sprite;
                if (sprite.destroyed) {
                    // A pooled sprite that has been handed to something else. Drop the whole near set and
                    // rebuild it next frame rather than reasoning about which half is still good.
                    this.visibleValid = false;
                    continue;
                }
                const phase = (blade.worldX * wind.x + blade.worldY * wind.y) * waveNumber + blade.jitter;
                // Signed tip displacement in world px. The minus on the shear is what makes a positive lean
                // carry the TIP downwind: skew about the top moves the base, and sliding the sprite back by
                // the same amount lands the base where it started and hands the whole displacement to the
                // tip.
                const wave = amplitude * Math.sin(tSeconds - phase);
                const top = blade.leanTop * wave;
                const bottom = blade.leanBottom * wave;
                // The shear only has to supply the DIFFERENCE across this piece; the translation puts its
                // bottom where the piece below it left off. Together they hand the top edge `top` and the
                // bottom edge `bottom`, so neighbouring pieces meet EXACTLY.
                //
                // asin, not the small-angle shortcut. The error in `skew ~= offset / HINGE` is under a
                // hundredth of a world pixel, which sounds ignorable and is not: the world surface draws at
                // 2x, and a fraction of a pixel of disagreement between two halves of the same plant shows
                // up as a visible seam along a hard pixel-art edge. One asin per visible blade per frame is
                // cheaper than a seam.
                sprite.skew.x = Math.asin(Math.max(-1, Math.min(1, (bottom - top) / $59052a7f89e51e65$export$7d832ea11681c35b.HINGE)));
                sprite.x = blade.baseX + top;
                swaying++;
            }
            this.swayingCount = swaying;
        };
        /**
     * Collect the blades near enough to be worth moving, and straighten the ones leaving the set --
     * otherwise a blade scrolls off frozen mid-lean and is still bent when it comes back.
     *
     * This is also where destroyed sprites are pruned. Per-cell removals in the map have no hook into
     * the wind, by design: a cell that disappears should not have to know this exists.
     */ this.gather = (centerX, centerY, halfW, halfH)=>{
            for (const blade of this.visible)if (!blade.sprite.destroyed) {
                blade.sprite.skew.x = 0;
                blade.sprite.x = blade.baseX;
            }
            const near = [];
            const alive = [];
            let anyDead = false;
            for (const blade of this.blades){
                if (blade.sprite.destroyed) {
                    anyDead = true;
                    continue;
                }
                alive.push(blade);
                if (Math.abs(blade.worldX - centerX) <= halfW && Math.abs(blade.worldY - centerY) <= halfH) near.push(blade);
            }
            if (anyDead) this.blades = alive;
            this.visible = near;
            this.visibleAtX = centerX;
            this.visibleAtY = centerY;
            this.visibleValid = true;
        };
        // Put every blade back upright and forget the destroyed ones.
        this.release = ()=>{
            this.running = false;
            this.swayingCount = 0;
            this.visible = [];
            this.visibleValid = false;
            const alive = [];
            for (const blade of this.blades){
                if (blade.sprite.destroyed) continue;
                blade.sprite.skew.x = 0;
                blade.sprite.x = blade.baseX;
                alive.push(blade);
            }
            this.blades = alive;
        };
    }
}


parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $klOfb = parcelRequire("klOfb");
var $gwPoJ = parcelRequire("gwPoJ");
var $6qzqq = parcelRequire("6qzqq");



const $982124a83389a98e$export$2c880cc50e65ac44 = (provider, at)=>{
    const x = Math.floor(at.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)), y = Math.floor(at.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
    const roof = provider.resolveTileMapFromLayerId?.("sky")?.[x]?.[y];
    return !!roof && roof !== "0" || !!provider.isSkyTileAt?.(x, y) || provider.isUnderRoofAt({
        x: at.x,
        y: at.y - (0, $9667a1379a787b5e$export$5985b04c8e71b763)
    });
};
const $982124a83389a98e$var$smooth = (v)=>{
    const t = Math.max(0, Math.min(1, v));
    return t * t * (3 - 2 * t);
};
const $982124a83389a98e$export$e129bac1d25c8e8e = (config, elapsedMs)=>{
    if (config.clearing) return {
        rain: config.clearing.rain * $982124a83389a98e$var$smooth(1 - elapsedMs / 5000),
        cloud: config.clearing.cloud * $982124a83389a98e$var$smooth(1 - elapsedMs / 10000)
    };
    const age = elapsedMs - config.cloudLeadMs;
    const ramp = Math.min(5000, config.durationMs / 2);
    const rain = $982124a83389a98e$var$smooth(age / ramp) * $982124a83389a98e$var$smooth((config.durationMs - age) / ramp);
    // Chapter two starts its introductory rain immediately (cloudLeadMs=0). At the first
    // client frame elapsedMs is also zero: dividing them poisons storm wind with NaN, which
    // then reaches the tree sprites' transforms. No lead means clouds arrive as a step.
    const arrival = config.cloudLeadMs > 0 ? $982124a83389a98e$var$smooth(elapsedMs / config.cloudLeadMs) : elapsedMs >= 0 ? 1 : 0;
    const cloud = arrival * $982124a83389a98e$var$smooth((config.durationMs + 5000 - age) / 5000);
    return {
        rain: rain,
        cloud: cloud
    };
};


class $becba67b0a664921$export$95ab89985350a09a {
    static{
        this.MAX_DROPS = 240;
    }
    constructor(surface, screen, textures, thunder, stopThunder){
        this.surface = surface;
        this.screen = screen;
        this.thunder = thunder;
        this.stopThunder = stopThunder;
        this.container = new (0, $8t5Gy.Container)();
        this.sky = new (0, $8t5Gy.Container)();
        this.drops = [];
        this.flash = new (0, $7Bs2Z.Sprite)((0, $klOfb.Texture).WHITE);
        this.bolt = new (0, $gwPoJ.Graphics)();
        this.anchor = 0;
        this.lastAt = 0;
        this.debt = 0;
        this.cursor = 0;
        this.activeCount = 0;
        this.// Smoothed cloud envelope also drives vegetation during the lead-in before the first drops.
        stormWind = 0;
        this.intensity = 0;
        this.lightningAt = 0;
        this.flashAt = -Infinity;
        this.thunderAt = Infinity;
        this.probe = new (0, $6qzqq.Point)();
        this.topLeft = new (0, $6qzqq.Point)();
        this.bottomRight = new (0, $6qzqq.Point)();
        this.overlapsRoof = (sprite, provider)=>{
            const left = sprite.x - sprite.anchor.x * sprite.width;
            const top = sprite.y - sprite.anchor.y * sprite.height;
            const right = left + sprite.width, bottom = top + sprite.height;
            // Check the full texture footprint, including streak tails and expanding splashes.
            // Sampling at most one tile apart also handles textures larger than a tile.
            const columns = Math.max(1, Math.ceil(sprite.width / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)));
            const rows = Math.max(1, Math.ceil(sprite.height / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)));
            for(let column = 0; column <= columns; column++)for(let row = 0; row <= rows; row++){
                if ((0, $982124a83389a98e$export$2c880cc50e65ac44)(provider, {
                    x: left + (right - left) * column / columns,
                    y: top + (bottom - top) * row / rows
                })) return true;
            }
            return false;
        };
        this.update = (config, provider, now = performance.now())=>{
            const dt = Math.min(0.05, Math.max(0, (now - this.lastAt) / 1000));
            this.lastAt = now;
            const sceneId = provider?.twoStoreyHouse?.groundRoomId ?? provider?.roomId;
            if (sceneId !== this.roomId) {
                this.roomId = sceneId;
                this.config = undefined;
                this.intensity = 0;
                this.stormWind = 0;
                this.debt = 0;
                this.activeCount = 0;
                this.thunderAt = Infinity;
                this.flashAt = -Infinity;
                this.stopThunder();
                for (const drop of this.drops){
                    drop.active = false;
                    drop.sprite.visible = drop.splash.visible = false;
                }
            }
            if ((config ?? undefined) !== this.config) {
                const newStorm = config?.id !== this.config?.id;
                this.config = config ?? undefined;
                this.anchor = now;
                if (newStorm) {
                    this.lightningAt = now + 10000;
                    this.thunderAt = Infinity;
                }
            }
            const target = config ? (0, $982124a83389a98e$export$e129bac1d25c8e8e)(config, config.elapsedMs + now - this.anchor) : {
                rain: 0,
                cloud: 0
            };
            // Also smooth mid-storm clear commands and config removal.
            const step = 1 - Math.exp(-dt / 0.65);
            this.intensity += (target.rain - this.intensity) * step;
            this.stormWind += (target.cloud - this.stormWind) * step;
            this.container.visible = this.intensity > 0.001 || this.activeCount > 0;
            this.sky.visible = this.intensity > 0.001 || now - this.flashAt < 320;
            if (!provider || !this.container.visible && !this.sky.visible) return;
            this.probe.set(this.screen.x, this.screen.y);
            this.surface.toLocal(this.probe, undefined, this.topLeft);
            this.probe.set(this.screen.right, this.screen.bottom);
            this.surface.toLocal(this.probe, undefined, this.bottomRight);
            const left = Math.min(this.topLeft.x, this.bottomRight.x) - 64;
            const top = Math.min(this.topLeft.y, this.bottomRight.y) - 64;
            const width = Math.abs(this.bottomRight.x - this.topLeft.x) + 128;
            const height = Math.abs(this.bottomRight.y - this.topLeft.y) + 128;
            // Sky effects use screen coordinates on an unmasked layer below the HUD.
            // Ground visibility should not erase lightning flashes at night.
            const skyLeft = this.screen.x - 64, skyTop = this.screen.y - 32;
            const skyWidth = this.screen.width + 128, skyHeight = this.screen.height + 64;
            this.debt = Math.min(12, this.debt + dt * 190 * this.intensity);
            while(this.debt >= 1){
                this.debt--;
                const drop = this.drops[this.cursor++ % this.drops.length];
                if (drop.active) continue;
                const x = left + Math.random() * width, y = top + Math.random() * height;
                if (x < 0 || y < 0 || x >= provider.width() * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) || y >= provider.height() * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)) continue;
                // Coverage is independent of cutaway alpha: sheltered tiles emit no rain effects.
                if ((0, $982124a83389a98e$export$2c880cc50e65ac44)(provider, {
                    x: x,
                    y: y
                })) continue;
                drop.x = x;
                drop.y = y;
                drop.age = 0;
                drop.active = true;
                this.activeCount++;
                drop.sprite.visible = true;
                drop.splash.visible = false;
            }
            for (const drop of this.drops){
                if (!drop.active) continue;
                drop.age += dt;
                const fallSeconds = 0.42;
                if (drop.age < fallSeconds) {
                    const lift = (fallSeconds - drop.age) * 620;
                    drop.sprite.position.set(drop.x - lift * 0.18, drop.y - lift);
                    drop.sprite.alpha = 0.5 * Math.min(1, drop.age / 0.08);
                    drop.sprite.visible = !this.overlapsRoof(drop.sprite, provider);
                } else {
                    drop.sprite.visible = false;
                    const t = (drop.age - fallSeconds) / 0.22;
                    drop.splash.visible = t < 1;
                    drop.splash.position.set(drop.x, drop.y);
                    drop.splash.scale.set(0.5 + t, 0.5 + t);
                    drop.splash.alpha = Math.max(0, (1 - t) * 0.45);
                    if (drop.splash.visible) drop.splash.visible = !this.overlapsRoof(drop.splash, provider);
                    if (t >= 1) {
                        drop.active = false;
                        this.activeCount--;
                    }
                }
            }
            if (config && !config.clearing && this.intensity > 0.35 && now >= this.lightningAt) {
                this.lightningAt = now + 6500 + Math.random() * 5000;
                this.flashAt = now;
                this.thunderAt = now + 700 + Math.random() * 900;
                const x = skyLeft + skyWidth * (0.2 + Math.random() * 0.6);
                this.bolt.clear().lineStyle(2, 0xdbeaff, 0.8).moveTo(x, skyTop);
                for(let i = 1; i <= 6; i++)this.bolt.lineTo(x + (Math.random() - 0.5) * 60, skyTop + skyHeight * i / 7);
            }
            const flashAge = now - this.flashAt;
            const flash = Math.max(0, 1 - flashAge / 180) * 0.22 + (flashAge > 220 ? Math.max(0, 1 - (flashAge - 220) / 100) * 0.1 : 0);
            this.flash.position.set(skyLeft, skyTop);
            this.flash.width = skyWidth;
            this.flash.height = skyHeight;
            this.flash.alpha = flash;
            this.bolt.alpha = Math.max(0, 1 - flashAge / 180);
            if (now >= this.thunderAt) {
                this.thunderAt = Infinity;
                if (this.intensity > 0.1) this.thunder();
            }
        };
        this.container.zIndex = 1000001;
        this.sky.zIndex = 1000002;
        for(let i = 0; i < $becba67b0a664921$export$95ab89985350a09a.MAX_DROPS; i++){
            const sprite = new (0, $7Bs2Z.Sprite)(textures.drop), splash = new (0, $7Bs2Z.Sprite)(textures.splash);
            sprite.anchor.set(0.5, 1);
            splash.anchor.set(0.5);
            sprite.visible = splash.visible = false;
            this.container.addChild(sprite, splash);
            this.drops.push({
                sprite: sprite,
                splash: splash,
                x: 0,
                y: 0,
                age: 0,
                active: false
            });
        }
        this.flash.tint = 0xcbdfff;
        this.sky.addChild(this.flash, this.bolt);
        this.container.visible = this.sky.visible = false;
    }
    static{
        this.textures = (renderer)=>{
            const bake = (draw)=>{
                const g = new (0, $gwPoJ.Graphics)();
                draw(g);
                const texture = renderer.generateTexture(g);
                g.destroy();
                return texture;
            };
            return {
                drop: bake((g)=>{
                    g.lineStyle(1, 0xbdd7ef, 0.85).moveTo(0, 0).lineTo(3, 16);
                }),
                splash: bake((g)=>{
                    g.lineStyle(1, 0xc1dcf1, 0.8).drawEllipse(0, 0, 4, 1.5);
                })
            };
        };
    }
}


parcelRequire("1avo5");
var $klOfb = parcelRequire("klOfb");
var $7Bs2Z = parcelRequire("7Bs2Z");
var $P8XPi = parcelRequire("P8XPi");
var $8t5Gy = parcelRequire("8t5Gy");
var $gwPoJ = parcelRequire("gwPoJ");


class $e4907a99a87534fa$export$4a802ef66c128389 {
    static{
        this.Z_INDEX_AIR = 880000;
    }
    static{
        this.Z_INDEX_GROUND = 90;
    }
    static{
        // Hard caps. These are what make the cost independent of how much lava is on screen, which is the
        // whole performance argument -- a player who floods half the mine gets the same frame as one who
        // broke a single pocket.
        this.MAX_EMBERS = 90;
    }
    static{
        this.MAX_BUBBLES = 14;
    }
    static{
        this.MAX_EMBER_RATE = 36;
    }
    static{
        this.MAX_BUBBLE_RATE = 6;
    }
    static{
        this.DEFAULT_EMBER_RATE = 1.1;
    }
    static{
        this.DEFAULT_BUBBLE_RATE = 0.85;
    }
    static{
        this.DEFAULT_ALPHA = 0.9;
    }
    static{
        this.DEFAULT_SCALE_MIN = 0.4;
    }
    static{
        this.DEFAULT_SCALE_MAX = 0.85;
    }
    static{
        // The cooling ramp, hottest first: a spark leaves the surface near white, goes orange, and dies a
        // dull red. The colour is most of what says "this is molten" -- a spark that stays one shade reads
        // as a firefly in a bad mood.
        this.DEFAULT_EMBER_COLORS = [
            0xfff1c4,
            0xffa33c,
            0xd8431a
        ];
    }
    static{
        // Bubbles are the body of the lava rather than the gas off it, so they sit at the orange-to-red end
        // and never go bright: a white bubble reads as a splash of water catching the light.
        this.DEFAULT_BUBBLE_COLORS = [
            0xff8a2a,
            0xe8541c,
            0xff6a24
        ];
    }
    static{
        // How high a spark gets, in world px/sec at birth, and the e-folds per second that bleeds it away.
        // Sparks rise and STOP rather than rising forever: hot gas loses on buoyancy, and a dot that
        // travels a tile upward reads as a firework.
        this.RISE = 26;
    }
    static{
        this.RISE_MIN = 0.6;
    }
    static{
        this.RISE_MAX = 1.45;
    }
    static{
        this.RISE_DRAG = 1.8;
    }
    static{
        // Sideways drift, which is what stops a pool looking like a row of vertical tracers.
        this.DRIFT = 7;
    }
    static{
        this.EMBER_LIFE_MS = 1150;
    }
    static{
        this.EMBER_LIFE_JITTER = 0.45;
    }
    static{
        // Fraction of its life a spark fades in over, and the fraction after which it starts going out.
        // The long hold is what makes it a cinder rather than a twinkle.
        this.EMBER_FADE_IN = 0.12;
    }
    static{
        this.EMBER_FADE_AFTER = 0.3;
    }
    static{
        // A bubble's life: swells, holds bright for an instant, bursts. One curve, three phases.
        this.BUBBLE_LIFE_MS = 620;
    }
    static{
        this.BUBBLE_LIFE_JITTER = 0.3;
    }
    static{
        // How wide a bubble gets, and how bright. Public because they are the visual contract a test can
        // hold the swell-hold-burst curve against: nothing may be stamped onto the floor at full size and
        // full brightness the instant it is born.
        this.BUBBLE_SCALE_MIN = 1.1;
    }
    static{
        this.BUBBLE_SCALE_MAX = 2.1;
    }
    static{
        this.BUBBLE_ALPHA_PEAK = 0.62;
    }
    static{
        // When in its life it pops: it grows up to here, flashes, and is gone over what is left.
        this.BUBBLE_POP_AT = 0.72;
    }
    static{
        // The box scanned for lava, as a half-extent in rough CELLS around the player: the visible world
        // plus a margin, so a spark can be born just off screen and drift in.
        this.HALF_CELLS_X = (0, $10da07838e6d507c$export$aa707847c2571374).viewportX + 1;
    }
    static{
        this.HALF_CELLS_Y = (0, $10da07838e6d507c$export$aa707847c2571374).viewportY + 1;
    }
    static{
        // How often that box is re-walked. Four times a second: fast enough that a flood sparks almost as
        // soon as it is painted, slow enough to be unmeasurable.
        this.REFRESH_MS = 250;
    }
    static{
        // A long frame (a stall, a backgrounded tab coming back) must not burst-emit the whole backlog.
        this.MAX_FRAME_SECONDS = 0.05;
    }
    static{
        // Public because it IS the contract: the most sparks one frame may ever produce, however long that
        // frame was and however much lava is on screen.
        this.MAX_SPAWN_CATCHUP = 4;
    }
    constructor(makeTexture){
        this.makeTexture = makeTexture;
        this.embers = [];
        this.bubbles = [];
        this.emberDebt = 0;
        this.bubbleDebt = 0;
        this.cellX = [];
        this.cellY = [];
        this.cellCount = 0;
        this.lastScanMs = 0;
        this.running = false;
        this.lastMs = 0;
        this.// Exposed for tests only -- these allocate, which is why nothing in the loop calls them.
        getEmberCount = ()=>this.running ? this.embers.filter((m)=>m.sprite.visible).length : 0;
        this.getBubbleCount = ()=>this.running ? this.bubbles.filter((m)=>m.sprite.visible).length : 0;
        this.getVisibleCellCount = ()=>this.running ? this.cellCount : 0;
        this.update = (config, center, provider)=>{
            const cfg = this.resolve(config);
            if (!cfg || !center || !provider) {
                this.stop();
                return;
            }
            const nowMs = performance.now();
            if (!this.running) {
                this.running = true;
                this.airContainer.visible = true;
                this.groundContainer.visible = true;
                this.lastMs = nowMs;
                // Force the first scan: a room entered with lava already on the floor should spark on the
                // frame it appears, not a quarter second later.
                this.lastScanMs = 0;
                this.scannedRoomId = undefined;
            }
            this.scanCells(provider, center, nowMs);
            let dt = (nowMs - this.lastMs) / 1000;
            this.lastMs = nowMs;
            if (!(dt > 0)) return;
            dt = Math.min(dt, $e4907a99a87534fa$export$4a802ef66c128389.MAX_FRAME_SECONDS);
            this.spawn(dt, cfg);
            this.stepEmbers(dt, cfg);
            this.stepBubbles(dt);
        };
        this.stop = ()=>{
            if (!this.running) return;
            this.running = false;
            this.airContainer.visible = false;
            this.groundContainer.visible = false;
            this.embers.forEach((m)=>m.sprite.visible = false);
            this.bubbles.forEach((m)=>m.sprite.visible = false);
            this.cellCount = 0;
            this.emberDebt = 0;
            this.bubbleDebt = 0;
            this.lastMs = 0;
            this.scannedRoomId = undefined;
        };
        this.resolve = (config)=>{
            const w = window;
            const forced = typeof w.lavaEmbers === "boolean" ? w.lavaEmbers : undefined;
            const enabled = forced !== undefined ? forced : !!config?.enabled;
            if (!enabled) return null;
            const num = (override, value, fallback)=>typeof override === "number" ? override : typeof value === "number" ? value : fallback;
            const scaleMin = config?.scaleMin ?? $e4907a99a87534fa$export$4a802ef66c128389.DEFAULT_SCALE_MIN;
            const scaleMax = config?.scaleMax ?? $e4907a99a87534fa$export$4a802ef66c128389.DEFAULT_SCALE_MAX;
            return {
                emberRate: Math.max(0, num(w.lavaEmberRate, config?.emberRate, $e4907a99a87534fa$export$4a802ef66c128389.DEFAULT_EMBER_RATE)),
                bubbleRate: Math.max(0, num(w.lavaBubbleRate, config?.bubbleRate, $e4907a99a87534fa$export$4a802ef66c128389.DEFAULT_BUBBLE_RATE)),
                alpha: Math.min(1, Math.max(0, num(w.lavaEmberAlpha, config?.alpha, $e4907a99a87534fa$export$4a802ef66c128389.DEFAULT_ALPHA))),
                scaleMin: Math.max(0.05, Math.min(scaleMin, scaleMax)),
                scaleMax: Math.max(scaleMin, scaleMax),
                emberColors: config?.emberColors?.length ? config.emberColors : $e4907a99a87534fa$export$4a802ef66c128389.DEFAULT_EMBER_COLORS,
                bubbleColors: config?.bubbleColors?.length ? config.bubbleColors : $e4907a99a87534fa$export$4a802ef66c128389.DEFAULT_BUBBLE_COLORS
            };
        };
        this.scanCells = (provider, center, nowMs)=>{
            const roomChanged = this.scannedRoomId !== provider.roomId;
            if (!roomChanged && nowMs - this.lastScanMs < $e4907a99a87534fa$export$4a802ef66c128389.REFRESH_MS) return;
            this.lastScanMs = nowMs;
            this.scannedRoomId = provider.roomId;
            const cx = Math.floor(center.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            const cy = Math.floor(center.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243));
            const minX = Math.max(0, cx - $e4907a99a87534fa$export$4a802ef66c128389.HALF_CELLS_X);
            const maxX = Math.min(provider.width() - 1, cx + $e4907a99a87534fa$export$4a802ef66c128389.HALF_CELLS_X);
            const minY = Math.max(0, cy - $e4907a99a87534fa$export$4a802ef66c128389.HALF_CELLS_Y);
            const maxY = Math.min(provider.height() - 1, cy + $e4907a99a87534fa$export$4a802ef66c128389.HALF_CELLS_Y);
            let count = 0;
            for(let x = minX; x <= maxX; x++){
                for(let y = minY; y <= maxY; y++)if (provider.isLavaAt(x, y)) {
                    this.cellX[count] = x;
                    this.cellY[count] = y;
                    count++;
                }
            }
            this.cellCount = count;
        };
        this.spawn = (dt, cfg)=>{
            if (this.cellCount === 0) {
                // No lava on screen: let the debt go rather than banking it, or walking into a cave would
                // fire a saved-up volley on the first frame the pool came into view.
                this.emberDebt = 0;
                this.bubbleDebt = 0;
                return;
            }
            // Per CELL for sparks (a wide pool is livelier), per POOL for bubbles (a bubble is an event you
            // watch, not a density) -- and both capped, which is what pins the cost.
            const emberRate = Math.min($e4907a99a87534fa$export$4a802ef66c128389.MAX_EMBER_RATE, cfg.emberRate * this.cellCount);
            const bubbleRate = Math.min($e4907a99a87534fa$export$4a802ef66c128389.MAX_BUBBLE_RATE, cfg.bubbleRate);
            this.emberDebt = Math.min(this.emberDebt + emberRate * dt, $e4907a99a87534fa$export$4a802ef66c128389.MAX_SPAWN_CATCHUP);
            while(this.emberDebt >= 1){
                this.emberDebt -= 1;
                this.emitEmber(cfg);
            }
            this.bubbleDebt = Math.min(this.bubbleDebt + bubbleRate * dt, $e4907a99a87534fa$export$4a802ef66c128389.MAX_SPAWN_CATCHUP);
            while(this.bubbleDebt >= 1){
                this.bubbleDebt -= 1;
                this.emitBubble(cfg);
            }
        };
        this.pickPoint = ()=>{
            const i = Math.floor(Math.random() * this.cellCount);
            return {
                x: (this.cellX[i] + Math.random()) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
                y: (this.cellY[i] + Math.random()) * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243)
            };
        };
        this.emitEmber = (cfg)=>{
            const mote = this.take(this.embers, this.airContainer, $e4907a99a87534fa$export$4a802ef66c128389.MAX_EMBERS);
            if (!mote) return;
            const at = this.pickPoint();
            mote.x = at.x;
            mote.groundY = at.y;
            mote.lift = 0;
            mote.vx = $e4907a99a87534fa$var$between(-$e4907a99a87534fa$export$4a802ef66c128389.DRIFT, $e4907a99a87534fa$export$4a802ef66c128389.DRIFT);
            mote.liftV = $e4907a99a87534fa$export$4a802ef66c128389.RISE * $e4907a99a87534fa$var$between($e4907a99a87534fa$export$4a802ef66c128389.RISE_MIN, $e4907a99a87534fa$export$4a802ef66c128389.RISE_MAX);
            mote.ageMs = 0;
            mote.lifeMs = $e4907a99a87534fa$export$4a802ef66c128389.EMBER_LIFE_MS * $e4907a99a87534fa$var$between(1 - $e4907a99a87534fa$export$4a802ef66c128389.EMBER_LIFE_JITTER, 1 + $e4907a99a87534fa$export$4a802ef66c128389.EMBER_LIFE_JITTER);
            mote.scale = $e4907a99a87534fa$var$between(cfg.scaleMin, cfg.scaleMax);
            mote.peakAlpha = cfg.alpha * $e4907a99a87534fa$var$between(0.75, 1);
            mote.sprite.visible = true;
            mote.sprite.tint = cfg.emberColors[0];
            mote.sprite.alpha = 0;
            mote.sprite.scale.set(mote.scale);
            mote.sprite.x = mote.x;
            mote.sprite.y = mote.groundY;
        };
        this.emitBubble = (cfg)=>{
            const mote = this.take(this.bubbles, this.groundContainer, $e4907a99a87534fa$export$4a802ef66c128389.MAX_BUBBLES);
            if (!mote) return;
            const at = this.pickPoint();
            mote.x = at.x;
            mote.groundY = at.y;
            mote.lift = 0;
            mote.vx = 0;
            mote.liftV = 0;
            mote.ageMs = 0;
            mote.lifeMs = $e4907a99a87534fa$export$4a802ef66c128389.BUBBLE_LIFE_MS * $e4907a99a87534fa$var$between(1 - $e4907a99a87534fa$export$4a802ef66c128389.BUBBLE_LIFE_JITTER, 1 + $e4907a99a87534fa$export$4a802ef66c128389.BUBBLE_LIFE_JITTER);
            mote.scale = $e4907a99a87534fa$var$between($e4907a99a87534fa$export$4a802ef66c128389.BUBBLE_SCALE_MIN, $e4907a99a87534fa$export$4a802ef66c128389.BUBBLE_SCALE_MAX);
            mote.peakAlpha = $e4907a99a87534fa$export$4a802ef66c128389.BUBBLE_ALPHA_PEAK * cfg.alpha;
            mote.sprite.visible = true;
            // A bubble holds ONE shade for its whole life -- it is the body of the lava turning over, not
            // something cooling in the air, so there is no ramp to walk and the tint is set once here.
            mote.sprite.tint = cfg.bubbleColors[Math.floor(Math.random() * cfg.bubbleColors.length)];
            mote.sprite.alpha = 0;
            mote.sprite.scale.set(0);
            mote.sprite.x = mote.x;
            mote.sprite.y = mote.groundY;
        };
        this.take = (pool, parent, cap)=>{
            for(let i = 0; i < pool.length; i++){
                if (!pool[i].sprite.visible) return pool[i];
            }
            if (pool.length >= cap) return undefined;
            if (!this.texture) try {
                this.texture = this.makeTexture();
            } catch (e) {
                this.texture = (0, $klOfb.Texture).WHITE;
            }
            const sprite = new (0, $7Bs2Z.Sprite)(this.texture);
            sprite.anchor.set(0.5);
            // Molten rock is light, not a pale sprite -- the same choice the campfire and the fireflies make.
            sprite.blendMode = (0, $P8XPi.BLEND_MODES).ADD;
            sprite.visible = false;
            parent.addChild(sprite);
            const mote = {
                sprite: sprite,
                x: 0,
                groundY: 0,
                lift: 0,
                vx: 0,
                liftV: 0,
                ageMs: 0,
                lifeMs: 1,
                scale: 1,
                peakAlpha: 1
            };
            pool.push(mote);
            return mote;
        };
        this.stepEmbers = (dt, cfg)=>{
            const dtMs = dt * 1000;
            for(let i = 0; i < this.embers.length; i++){
                const m = this.embers[i];
                if (!m.sprite.visible) continue;
                m.ageMs += dtMs;
                const t = m.ageMs / m.lifeMs;
                if (t >= 1) {
                    m.sprite.visible = false;
                    continue;
                }
                // Rises and slows: buoyancy bleeding away, so it settles into a drift rather than climbing
                // out of the room.
                m.liftV -= m.liftV * $e4907a99a87534fa$export$4a802ef66c128389.RISE_DRAG * dt;
                m.lift += m.liftV * dt;
                m.x += m.vx * dt;
                // Fade in, hold, fade out. The hold is what makes it a cinder you can look at.
                const glow = t < $e4907a99a87534fa$export$4a802ef66c128389.EMBER_FADE_IN ? t / $e4907a99a87534fa$export$4a802ef66c128389.EMBER_FADE_IN : t > $e4907a99a87534fa$export$4a802ef66c128389.EMBER_FADE_AFTER ? 1 - (t - $e4907a99a87534fa$export$4a802ef66c128389.EMBER_FADE_AFTER) / (1 - $e4907a99a87534fa$export$4a802ef66c128389.EMBER_FADE_AFTER) : 1;
                const sprite = m.sprite;
                sprite.x = m.x;
                // Drawn at the lift, sorted nowhere in particular -- the whole container has one z (see
                // the header), so unlike FootDust there is no ground line to keep separate. The lift is
                // still tracked apart from the spawn point so a spark cannot drift out of its own cell.
                sprite.y = m.groundY - m.lift;
                sprite.alpha = m.peakAlpha * glow;
                // Cools as it goes: shrinking AND reddening, which together read as heat leaving it.
                sprite.scale.set(m.scale * (1 - 0.45 * t));
                sprite.tint = $e4907a99a87534fa$export$46f453f51c2af21d(cfg.emberColors, t);
            }
        };
        this.stepBubbles = (dt)=>{
            const dtMs = dt * 1000;
            for(let i = 0; i < this.bubbles.length; i++){
                const m = this.bubbles[i];
                if (!m.sprite.visible) continue;
                m.ageMs += dtMs;
                const t = m.ageMs / m.lifeMs;
                if (t >= 1) {
                    m.sprite.visible = false;
                    continue;
                }
                const sprite = m.sprite;
                if (t < $e4907a99a87534fa$export$4a802ef66c128389.BUBBLE_POP_AT) {
                    // Swelling. Eased, so it domes up instead of inflating linearly.
                    const u = t / $e4907a99a87534fa$export$4a802ef66c128389.BUBBLE_POP_AT;
                    const eased = u * u * (3 - 2 * u);
                    sprite.scale.set(m.scale * (0.25 + 0.75 * eased));
                    sprite.alpha = m.peakAlpha * eased;
                } else {
                    // The burst: one quick flare wider than the bubble ever got, going out as it spreads.
                    const u = (t - $e4907a99a87534fa$export$4a802ef66c128389.BUBBLE_POP_AT) / (1 - $e4907a99a87534fa$export$4a802ef66c128389.BUBBLE_POP_AT);
                    sprite.scale.set(m.scale * (1 + 0.55 * u));
                    sprite.alpha = m.peakAlpha * (1 - u) * (1 - u);
                }
            }
        };
        const air = new (0, $8t5Gy.Container)();
        air.zIndex = $e4907a99a87534fa$export$4a802ef66c128389.Z_INDEX_AIR;
        // Everything in the world surface gets hit-tested (Mouse.setWorldRoots), and a spark must never
        // swallow a click meant for the ground under it.
        air.interactiveChildren = false;
        air.visible = false;
        this.airContainer = air;
        const ground = new (0, $8t5Gy.Container)();
        ground.zIndex = $e4907a99a87534fa$export$4a802ef66c128389.Z_INDEX_GROUND;
        ground.interactiveChildren = false;
        ground.visible = false;
        this.groundContainer = ground;
    }
    static{
        /**
     * The spark, generated once: a tight bright core inside a soft halo, drawn white so one texture
     * serves every tint and both pools -- one BaseTexture means each container is one draw call.
     *
     * Stacked translucent circles rather than a blur filter, for the reason in the header. Tighter and
     * smaller than the firefly glow it is modelled on: a firefly is a lamp coming on and a spark is a
     * speck of burning rock, so the core has to survive being drawn at a third of this size.
     */ this.buildEmberTexture = (generate)=>{
            const g = new (0, $gwPoJ.Graphics)();
            const RINGS = 6;
            const OUTER = 7;
            for(let i = RINGS; i >= 1; i--){
                const radius = OUTER * i / RINGS;
                // Falls off steeply, so the halo is a suggestion and the core is the thing.
                const alpha = 0.11 * Math.pow(1 - (i - 1) / RINGS, 1.9);
                g.beginFill(0xffffff, alpha);
                g.drawCircle(0, 0, radius);
                g.endFill();
            }
            g.beginFill(0xffffff, 0.98);
            g.drawCircle(0, 0, 1.8);
            g.endFill();
            const texture = generate(g);
            g.destroy();
            return texture;
        };
    }
    static{
        this.textureFactory = (renderer)=>()=>$e4907a99a87534fa$export$4a802ef66c128389.buildEmberTexture((g)=>renderer.generateTexture(g, {
                        resolution: 2,
                        scaleMode: (0, $P8XPi.SCALE_MODES).LINEAR
                    }));
    }
}
const $e4907a99a87534fa$var$between = (min, max)=>min + Math.random() * (max - min);
const $e4907a99a87534fa$export$46f453f51c2af21d = (colors, t)=>{
    if (colors.length === 0) return 0xffffff;
    if (colors.length === 1) return colors[0];
    const u = Math.min(1, Math.max(0, t)) * (colors.length - 1);
    const i = Math.min(colors.length - 2, Math.floor(u));
    const f = u - i;
    const a = colors[i];
    const b = colors[i + 1];
    const r = (a >> 16 & 0xff) + ((b >> 16 & 0xff) - (a >> 16 & 0xff)) * f;
    const gc = (a >> 8 & 0xff) + ((b >> 8 & 0xff) - (a >> 8 & 0xff)) * f;
    const bc = (a & 0xff) + ((b & 0xff) - (a & 0xff)) * f;
    return Math.round(r) << 16 | Math.round(gc) << 8 | Math.round(bc);
};


parcelRequire("1avo5");
var $6qzqq = parcelRequire("6qzqq");
var $klOfb = parcelRequire("klOfb");
var $9Tsx3 = parcelRequire("9Tsx3");
var $8t5Gy = parcelRequire("8t5Gy");
var $P8XPi = parcelRequire("P8XPi");


// Three drifting layers of the same noise field, at different sizes and at different fractions of the
// camera. `parallax` is what sells depth: 1 is locked to the ground (the bank sits still in the world
// as you walk through it), 0 is locked to the screen (infinitely far off), and between the two a layer
// slides against the ground at its own rate. In a top-down orthographic view there is no true
// parallax for a plane above the floor -- translating the camera moves every height equally -- so a
// layer that lags the world is the whole of the illusion of height, and these three read as ground
// mist, a bank at waist height, and far haze.
//
// The sizes are set against what is actually on screen -- about 12 x 9 tiles at the world surface's 2x
// zoom -- and the noise field's own 3x3 lattice means one texture tile already holds about three
// lobes. So a 9-tile layer draws lobes of roughly three tiles, four of them across the view. Sizes
// much above the screen were the first version's mistake: a feature wider than the viewport cannot
// read as a wisp, only as an overall gradient, which is precisely what a hazy filter looks like.
const $5771f9fef21bdf34$var$LAYERS = [
    {
        size: 14 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
        parallax: 0.34
    },
    {
        size: 9 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
        parallax: 0.66
    },
    {
        size: 5 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
        parallax: 1.0
    }
];
// The noise bake. 128 is plenty: fog is low-frequency by nature and every layer stretches this across
// at least seven tiles, so the texture is magnified, never minified. Power of two because WebGL 1 only
// wraps (GL_REPEAT) power-of-two textures, and the whole design rests on wrapping.
const $5771f9fef21bdf34$var$NOISE_SIZE = 128;
// Lattice frequencies summed into each field, coarsest first, with the weights beside them. Kept few
// and coarse ON PURPOSE: pile on octaves at half weight each and the sum converges on its mean
// (it is an average of independent fields), which is exactly the flat grey a fog must not be. Three
// octaves dominated by a 3x3 lattice gives big, separable lobes with room between them.
const $5771f9fef21bdf34$var$NOISE_OCTAVES = [
    {
        freq: 3,
        weight: 1
    },
    {
        freq: 6,
        weight: 0.45
    },
    {
        freq: 12,
        weight: 0.2
    }
];
class $5771f9fef21bdf34$export$321e670ba3865065 {
    static{
        // Above tiles and entities, below the leaves (900000) and the sky surface (1000000).
        this.Z_INDEX = 890000;
    }
    static{
        // Defaults for anything a room leaves out. Deliberately faint: this is "light fog", and at night
        // it is competing with the darkness mask for the same contrast budget.
        this.DEFAULT_INTENSITY = 0.35;
    }
    static{
        this.DEFAULT_SPEED = 11;
    }
    static{
        this.DEFAULT_DIRECTION_DEG = 22;
    }
    static{
        // The silhouette threshold, and the whole difference between wisps and a veil. LOW sits ABOVE the
        // field's mean, so most of the field falls under it and is simply not there; HIGH is close enough
        // above it to keep the edges soft rather than cut out. Drop LOW towards 0 and the fog goes back to
        // being a hazy filter over everything.
        this.DEFAULT_LOW = 0.5;
    }
    static{
        this.DEFAULT_HIGH = 0.74;
    }
    static{
        // How far the warp field drags the sample, in noise-tile units. This is what curls a round blob
        // into a wisp; too much and the bank shears into streaks.
        this.DEFAULT_WARP = 0.16;
    }
    static{
        this.DEFAULT_COLOR = 0xc8d4e0;
    }
    static{
        // The quad is grown this far past the visible rectangle, so nothing shows at the edge if the
        // camera moves between the corners being read and the frame being drawn.
        this.MARGIN = (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    }
    /**
     * @param surface the world surface -- the fog goes inside it, and is also asked (via toLocal) what
     *        world rectangle is currently on screen, which is the one way to get that right through the
     *        camera's edge clamping, the 2x zoom and screen shake.
     * @param screen the renderer's screen rectangle.
     * @param bake builds the tiling noise texture; injected so the simulation can be tested headless.
     */ constructor(surface, screen, bake){
        this.surface = surface;
        this.screen = screen;
        this.bake = bake;
        this.vertices = new Float32Array(8);
        this.running = false;
        this.startMs = 0;
        this.probe = new (0, $6qzqq.Point)();
        this.topLeft = new (0, $6qzqq.Point)();
        this.bottomRight = new (0, $6qzqq.Point)();
        this.color = new Float32Array(3);
        this./**
     * Draw one frame of fog, or take it down. `brightness` is the client's interpolated daylight, or
     * undefined for a room with no day cycle (which counts as day, so no fog).
     *
     * Cheap to call every frame: a room with no fog, or any hour that is not night, costs one boolean.
     */ update = (config, brightness, sceneElevation = 0)=>{
            const resolved = this.resolve(config, brightness);
            if (!resolved) {
                this.stop();
                return;
            }
            const mesh = this.ensureMesh();
            if (!mesh) return;
            if (!this.running) {
                this.running = true;
                this.container.visible = true;
                // Time is measured from the moment the bank rolls in, not from page load, so the fog does
                // not arrive already scrolled a long way along.
                this.startMs = performance.now();
            }
            // What is on screen right now, in world coordinates, straight from the live transform. Reading
            // the camera's own modifiers instead would be wrong at the map edges, where the camera stops
            // following the player and the modifier is left undefined.
            this.probe.set(0, 0);
            this.surface.toLocal(this.probe, undefined, this.topLeft);
            this.probe.set(this.screen.width, this.screen.height);
            this.surface.toLocal(this.probe, undefined, this.bottomRight);
            const left = Math.min(this.topLeft.x, this.bottomRight.x) - $5771f9fef21bdf34$export$321e670ba3865065.MARGIN;
            const right = Math.max(this.topLeft.x, this.bottomRight.x) + $5771f9fef21bdf34$export$321e670ba3865065.MARGIN;
            const top = Math.min(this.topLeft.y, this.bottomRight.y) - $5771f9fef21bdf34$export$321e670ba3865065.MARGIN;
            const bottom = Math.max(this.topLeft.y, this.bottomRight.y) + $5771f9fef21bdf34$export$321e670ba3865065.MARGIN;
            const cameraX = (left + right) / 2;
            const cameraY = (top + bottom) / 2;
            // Camera-relative corners; the mesh transform puts them back in the world. This is the
            // precision guard -- these are hundreds of pixels, never thousands.
            this.vertices[0] = left - cameraX;
            this.vertices[1] = top - cameraY;
            this.vertices[2] = right - cameraX;
            this.vertices[3] = top - cameraY;
            this.vertices[4] = right - cameraX;
            this.vertices[5] = bottom - cameraY;
            this.vertices[6] = left - cameraX;
            this.vertices[7] = bottom - cameraY;
            this.vertexBuffer?.update(this.vertices);
            mesh.position.set(cameraX, cameraY);
            const seconds = (performance.now() - this.startMs) / 1000;
            const driftX = Math.cos(resolved.directionRad) * resolved.speed * seconds;
            const driftY = Math.sin(resolved.directionRad) * resolved.speed * seconds;
            const uniforms = mesh.shader.uniforms;
            for(let i = 0; i < $5771f9fef21bdf34$var$LAYERS.length; i++){
                const { size: size, parallax: parallax } = $5771f9fef21bdf34$var$LAYERS[i];
                const inv = 1 / size;
                // uv = (world - camera * (1 - parallax) - drift) / size, rearranged around the
                // camera-relative vertex the shader actually has: rel * inv + (camera * parallax - drift) *
                // inv. The constant half is computed HERE, in double precision, and reduced to its
                // fractional part -- dropping whole noise tiles is invisible because the texture wraps, and
                // it is what keeps a big world from quantising the fog into steps.
                const offX = (cameraX * parallax - driftX) * inv;
                const offY = ((cameraY - sceneElevation) * parallax - driftY) * inv;
                uniforms[`uInv${i}`][0] = inv;
                uniforms[`uInv${i}`][1] = inv;
                uniforms[`uOff${i}`][0] = offX - Math.floor(offX);
                uniforms[`uOff${i}`][1] = offY - Math.floor(offY);
            }
            uniforms.uIntensity = resolved.intensity;
            uniforms.uLow = resolved.low;
            uniforms.uHigh = resolved.high;
            uniforms.uWarp = resolved.warp;
            this.color[0] = (resolved.color >> 16 & 0xff) / 255;
            this.color[1] = (resolved.color >> 8 & 0xff) / 255;
            this.color[2] = (resolved.color & 0xff) / 255;
        };
        this.// Exposed for tests: the opacity the fog is currently drawing at, 0 when it is not drawing.
        getIntensity = ()=>this.running && this.mesh ? this.mesh.shader.uniforms.uIntensity : 0;
        this.stop = ()=>{
            if (!this.running) return;
            this.running = false;
            this.container.visible = false;
        };
        this.resolve = (config, brightness)=>{
            const w = window;
            const forced = typeof w.nightFog === "boolean" ? w.nightFog : undefined;
            const enabled = forced !== undefined ? forced : !!config?.enabled;
            if (!enabled) return null;
            const num = (override, value, fallback)=>typeof override === "number" ? override : typeof value === "number" ? value : fallback;
            // Forcing the fog on from the console also lifts the night gate; there is no way to look at it
            // at noon otherwise, and waiting for the hour is a four-minute round trip.
            const nightOnly = forced === true ? false : config?.nightOnly !== false;
            const night = nightOnly ? (0, $eca6088c9a6d9651$export$92091d9bb73d8475)(brightness) : 1;
            if (night <= 0) return null;
            return {
                // The hour scales the opacity and nothing else: unlike the leaves there is no count to
                // thin, so the bank simply thickens as the light goes.
                intensity: Math.min(1, Math.max(0, num(w.nightFogIntensity, config?.intensity, $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_INTENSITY))) * night,
                speed: num(w.nightFogSpeed, config?.speed, $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_SPEED),
                directionRad: num(w.nightFogDirection, config?.directionDeg, $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_DIRECTION_DEG) * Math.PI / 180,
                low: num(w.nightFogLow, config?.low, $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_LOW),
                high: num(w.nightFogHigh, config?.high, $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_HIGH),
                warp: num(w.nightFogWarp, config?.warp, $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_WARP),
                color: typeof config?.color === "number" ? config.color : $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_COLOR
            };
        };
        this.ensureMesh = ()=>{
            if (this.mesh) return this.mesh;
            let noise;
            try {
                noise = this.bake();
            } catch (e) {
                // Fog is ambience. If the bake fails there simply is no fog.
                return undefined;
            }
            this.noise = noise;
            this.vertexBuffer = new (0, $klOfb.Buffer)(this.vertices, false, false);
            const geometry = new (0, $klOfb.Geometry)().addAttribute("aVertexPosition", this.vertexBuffer, 2).addIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            const shader = (0, $klOfb.Shader).from($5771f9fef21bdf34$export$321e670ba3865065.VERTEX, $5771f9fef21bdf34$export$321e670ba3865065.FRAGMENT, {
                uNoise: noise,
                uInv0: new Float32Array(2),
                uInv1: new Float32Array(2),
                uInv2: new Float32Array(2),
                uOff0: new Float32Array(2),
                uOff1: new Float32Array(2),
                uOff2: new Float32Array(2),
                uIntensity: 0,
                uLow: $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_LOW,
                uHigh: $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_HIGH,
                uWarp: $5771f9fef21bdf34$export$321e670ba3865065.DEFAULT_WARP,
                uColor: this.color
            });
            const mesh = new (0, $9Tsx3.Mesh)(geometry, shader);
            this.mesh = mesh;
            this.container.addChild(mesh);
            return mesh;
        };
        const container = new (0, $8t5Gy.Container)();
        container.zIndex = $5771f9fef21bdf34$export$321e670ba3865065.Z_INDEX;
        container.interactiveChildren = false;
        container.visible = false;
        this.container = container;
    }
    static{
        // Vertex positions arrive camera-relative and go straight out as the varying; a vertex shader is
        // always highp, so the transform itself is safe whatever the world coordinates are.
        this.VERTEX = `
        precision highp float;

        attribute vec2 aVertexPosition;

        uniform mat3 projectionMatrix;
        uniform mat3 translationMatrix;

        varying vec2 vRel;

        void main() {
            vRel = aVertexPosition;
            gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
        }
    `;
    }
    static{
        this.FRAGMENT = `
        precision mediump float;

        varying vec2 vRel;

        uniform sampler2D uNoise;
        uniform vec2 uInv0;
        uniform vec2 uInv1;
        uniform vec2 uInv2;
        uniform vec2 uOff0;
        uniform vec2 uOff1;
        uniform vec2 uOff2;
        uniform float uIntensity;
        uniform float uLow;
        uniform float uHigh;
        uniform float uWarp;
        uniform vec3 uColor;

        void main() {
            // The coarse layer does double duty: it is both the slowest-parallaxing body of the bank
            // and the source of the warp. Its green and blue channels are two INDEPENDENT fields, so
            // the displacement is a real 2D vector -- a greyscale texture would give g == b and shear
            // everything along one diagonal.
            vec3 coarse = texture2D(uNoise, vRel * uInv0 + uOff0).rgb;
            vec2 warp = (coarse.gb - 0.5) * uWarp;

            // DOMAIN WARPING is what turns blobs into wisps: the mass is sampled at a position that has
            // itself been dragged around by a slower field, so its lobes stretch and curl the way
            // something carried on moving air does, instead of sitting there as soft circles.
            float body = texture2D(uNoise, vRel * uInv1 + uOff1 + warp).r;
            float detail = texture2D(uNoise, vRel * uInv2 + uOff2 + warp * 0.5).g;

            // Build ONE field out of the three, then cut it. Mixing the fine layer in BEFORE the
            // threshold is what makes an edge billow: the silhouette wanders at the fine layer's
            // frequency and breaks into lobes. Multiplying it in afterwards -- the obvious thing, and
            // what this did first -- only shades the inside and leaves a smooth, soapy outline.
            float field = body * 0.55 + coarse.r * 0.25 + detail * 0.2;

            // THE SILHOUETTE, and the whole difference between fog and a hazy filter. uLow sits at the
            // field's median, so half the screen falls below it and has no fog on it AT ALL -- the
            // empty gaps are what the eye reads as separate wisps. A threshold low enough to touch
            // every pixel is a grey filter, however faint it is made.
            float mass = smoothstep(uLow, uHigh, field);

            // Structure inside a wisp, so it is not a flat cut-out: lighter cores, thinner fringes.
            float density = mass * (0.6 + 0.4 * detail);

            float a = density * uIntensity;
            // Premultiplied: pixi's NORMAL blend expects the colour already multiplied by the alpha.
            gl_FragColor = vec4(uColor * a, a);
        }
    `;
    }
    static{
        /**
     * Three independent tileable value-noise fields, each in 0..1, row-major.
     *
     * Baked rather than computed per pixel in the shader: procedural fbm would cost forty-odd ALU ops a
     * pixel every frame forever, where this is a few thousand CPU operations once. It has to TILE,
     * because the whole scroll scheme rests on GL_REPEAT, so every lattice lookup wraps -- get that
     * wrong and there is a hard seam across the world every few tiles, and it only shows up there.
     *
     * Separate from bakeNoise so the fields can be checked without a GPU.
     */ this.buildNoiseField = ()=>{
            const channels = [];
            for(let c = 0; c < 3; c++){
                const field = new Float32Array($5771f9fef21bdf34$var$NOISE_SIZE * $5771f9fef21bdf34$var$NOISE_SIZE);
                for (const { freq: freq, weight: weight } of $5771f9fef21bdf34$var$NOISE_OCTAVES){
                    // The lattice this octave interpolates. Indices wrap, which is what makes it tile.
                    const lattice = new Float32Array(freq * freq);
                    for(let i = 0; i < lattice.length; i++)lattice[i] = Math.random();
                    const cell = $5771f9fef21bdf34$var$NOISE_SIZE / freq;
                    for(let y = 0; y < $5771f9fef21bdf34$var$NOISE_SIZE; y++)for(let x = 0; x < $5771f9fef21bdf34$var$NOISE_SIZE; x++){
                        const fx = x / cell;
                        const fy = y / cell;
                        const x0 = Math.floor(fx);
                        const y0 = Math.floor(fy);
                        const x1 = (x0 + 1) % freq;
                        const y1 = (y0 + 1) % freq;
                        // Smoothstep rather than linear interpolation: linear leaves the lattice
                        // visible as a grid of creases, which on a stretched fog layer is unmissable.
                        const tx = fx - x0;
                        const ty = fy - y0;
                        const sx = tx * tx * (3 - 2 * tx);
                        const sy = ty * ty * (3 - 2 * ty);
                        const wx0 = x0 % freq;
                        const wy0 = y0 % freq;
                        const a = lattice[wy0 * freq + wx0];
                        const b = lattice[wy0 * freq + x1];
                        const d = lattice[y1 * freq + wx0];
                        const e = lattice[y1 * freq + x1];
                        const top = a + (b - a) * sx;
                        const bot = d + (e - d) * sx;
                        field[y * $5771f9fef21bdf34$var$NOISE_SIZE + x] += (top + (bot - top) * sy) * weight;
                    }
                }
                // Normalise on the field's ACTUAL range rather than the weight sum. A sum of octaves never
                // reaches its theoretical extremes, so dividing by the weights leaves everything bunched in
                // the middle -- which is the flat grey this effect exists to avoid. Stretching to the real
                // min/max is free contrast, and the silhouette threshold depends on having it.
                let min = Infinity;
                let max = -Infinity;
                for(let i = 0; i < field.length; i++){
                    min = Math.min(min, field[i]);
                    max = Math.max(max, field[i]);
                }
                const span = max - min || 1;
                for(let i = 0; i < field.length; i++)field[i] = (field[i] - min) / span;
                channels.push(field);
            }
            return {
                size: $5771f9fef21bdf34$var$NOISE_SIZE,
                channels: channels
            };
        };
    }
    static{
        // Upload the three fields as the R, G and B channels of one wrapping texture -- one fetch hands the
        // shader three independent values, which is what keeps this to three texture reads a pixel.
        this.bakeNoise = ()=>{
            const { size: size, channels: channels } = $5771f9fef21bdf34$export$321e670ba3865065.buildNoiseField();
            const canvas = document.createElement("canvas");
            canvas.width = size;
            canvas.height = size;
            const context = canvas.getContext("2d");
            if (!context) throw new Error("no 2d context for the fog noise bake");
            const image = context.createImageData(size, size);
            const byte = (value)=>Math.max(0, Math.min(255, Math.round(value * 255)));
            for(let i = 0; i < channels[0].length; i++){
                image.data[i * 4] = byte(channels[0][i]);
                image.data[i * 4 + 1] = byte(channels[1][i]);
                image.data[i * 4 + 2] = byte(channels[2][i]);
                image.data[i * 4 + 3] = 255;
            }
            context.putImageData(image, 0, 0);
            const texture = (0, $klOfb.Texture).from(canvas);
            // The one non-negotiable: every layer scrolls indefinitely, so the field has to wrap. This is
            // also why NOISE_SIZE is a power of two -- WebGL 1 refuses to repeat anything else.
            texture.baseTexture.wrapMode = (0, $P8XPi.WRAP_MODES).REPEAT;
            return texture;
        };
    }
}



parcelRequire("1avo5");
var $8t5Gy = parcelRequire("8t5Gy");
var $6qzqq = parcelRequire("6qzqq");
var $klOfb = parcelRequire("klOfb");
var $9Tsx3 = parcelRequire("9Tsx3");



const $10086bf2e2b19266$export$45b569547743afeb = (map, center)=>{
    const cx = center.x / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    const cy = center.y / (0, $cb689cfa16c444ba$export$29abb25bc3a2a243);
    let trees = 0;
    let total = 0;
    for(let x = Math.max(0, Math.floor(cx - 3)); x <= Math.min(map.width() - 1, Math.ceil(cx + 3)); x++)for(let y = Math.max(0, Math.floor(cy - 3)); y <= Math.min(map.height() - 1, Math.ceil(cy + 3)); y++){
        const distanceSquared = (x + 0.5 - cx) ** 2 + (y + 0.5 - cy) ** 2;
        if (distanceSquared >= 9) continue;
        const weight = (1 - distanceSquared / 9) ** 2;
        total += weight;
        // Same entity-tile convention as the Ember minimap; saplings are not canopy.
        if ((0, $ff74dc2a666565c1$export$81d865d97cd78a4a)(map.getEntityTileAt(x, y)?.entityTile)) trees += weight;
    }
    return total > 0 ? trees / total : 0;
};
const $10086bf2e2b19266$export$f427f6edfea19f2d = (density)=>// Even the densest forest keeps half the open-ground sight radius.
    (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) * (9 - 4.5 * Math.min(1, Math.max(0, density) / 0.35));
// About 4.5 seconds to settle through 95% of a density change, in either direction.
const $10086bf2e2b19266$var$DENSITY_TRANSITION_MS = 1500;
class $10086bf2e2b19266$export$78361259babe7fe0 {
    constructor(surface, screen){
        this.surface = surface;
        this.screen = screen;
        this.container = new (0, $8t5Gy.Container)();
        this.vertices = new Float32Array(8);
        this.probe = new (0, $6qzqq.Point)();
        this.topLeft = new (0, $6qzqq.Point)();
        this.bottomRight = new (0, $6qzqq.Point)();
        this.density = 0;
        this.lastMs = 0;
        this.container.zIndex = -50;
        // Overlay children supply their own world zoom, unlike the ground surface.
        this.container.scale.set((0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom);
        this.container.interactiveChildren = false;
        this.container.visible = false;
    }
    update(enabled, map, center) {
        if (!enabled || !map || !center || window.forestVision === false) {
            this.container.visible = false;
            this.roomId = undefined;
            return;
        }
        const now = performance.now();
        const target = $10086bf2e2b19266$export$45b569547743afeb(map, center);
        if (this.roomId !== map.roomId) {
            this.density = target;
            this.roomId = map.roomId;
        } else {
            const blend = 1 - Math.exp(-Math.max(0, now - this.lastMs) / $10086bf2e2b19266$var$DENSITY_TRANSITION_MS);
            this.density += (target - this.density) * blend;
        }
        this.lastMs = now;
        if (target === 0 && this.density < 0.0001) this.density = 0;
        this.container.visible = this.density > 0;
        if (!this.container.visible) return;
        const mesh = this.ensureMesh();
        this.probe.set(0, 0);
        this.surface.toLocal(this.probe, undefined, this.topLeft);
        this.probe.set(this.screen.width, this.screen.height);
        this.surface.toLocal(this.probe, undefined, this.bottomRight);
        this.topLeft.x /= (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
        this.topLeft.y /= (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
        this.bottomRight.x /= (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
        this.bottomRight.y /= (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
        const left = Math.min(this.topLeft.x, this.bottomRight.x) - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - center.x;
        const right = Math.max(this.topLeft.x, this.bottomRight.x) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - center.x;
        const top = Math.min(this.topLeft.y, this.bottomRight.y) - (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - center.y;
        const bottom = Math.max(this.topLeft.y, this.bottomRight.y) + (0, $cb689cfa16c444ba$export$29abb25bc3a2a243) - center.y;
        this.vertices.set([
            left,
            top,
            right,
            top,
            right,
            bottom,
            left,
            bottom
        ]);
        this.buffer.update(this.vertices);
        mesh.position.set(center.x, center.y);
        mesh.shader.uniforms.uRadius = $10086bf2e2b19266$export$f427f6edfea19f2d(this.density);
        const strength = Math.min(1, this.density / 0.12);
        mesh.shader.uniforms.uStrength = strength * strength * (3 - 2 * strength);
    }
    ensureMesh() {
        if (this.mesh) return this.mesh;
        this.buffer = new (0, $klOfb.Buffer)(this.vertices, false, false);
        const geometry = new (0, $klOfb.Geometry)().addAttribute("aVertexPosition", this.buffer, 2).addIndex([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        const shader = (0, $klOfb.Shader).from(`
            precision highp float;
            attribute vec2 aVertexPosition;
            uniform mat3 projectionMatrix;
            uniform mat3 translationMatrix;
            varying vec2 vRelative;
            void main() {
                vRelative = aVertexPosition;
                gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);
            }
        `, `
            precision mediump float;
            varying vec2 vRelative;
            uniform float uRadius;
            uniform float uStrength;
            void main() {
                float darkness = smoothstep(uRadius * 0.30, uRadius, length(vRelative));
                gl_FragColor = vec4(0.0, 0.0, 0.0, darkness * uStrength);
            }
        `, {
            uRadius: 9 * (0, $cb689cfa16c444ba$export$29abb25bc3a2a243),
            uStrength: 0
        });
        this.mesh = new (0, $9Tsx3.Mesh)(geometry, shader);
        this.container.addChild(this.mesh);
        return this.mesh;
    }
}






var $5UG8I = parcelRequire("5UG8I");
class $3a1b2b5c28aeeeee$export$9b229b42dc5ba616 {
    constructor(config){
        this.frameCount = 0;
        this.lastFrameTime = 0;
        this.frameTimes = [];
        this.renderTimes = [];
        this.updateTimes = [];
        this.lastLogTime = 0;
        this.entityCount = 0;
        this.renderedEntityCount = 0;
        this.culledEntityCount = 0;
        this.startTime = 0;
        this.renderStartTime = 0;
        this.updateStartTime = 0;
        this.config = {
            enableMetrics: true,
            logInterval: 5000,
            enableMemoryTracking: false,
            enableDetailedStats: false,
            ...config
        };
    }
    /**
     * Set callbacks to get stats from other systems
     */ setStatCallbacks(callbacks) {
        this.getViewportCullingStats = callbacks.getViewportCullingStats;
        this.getSpritePoolStats = callbacks.getSpritePoolStats;
    }
    /**
     * Start timing a frame
     */ startFrame() {
        this.startTime = performance.now();
        this.frameCount++;
    }
    /**
     * Start timing render phase
     */ startRender() {
        this.renderStartTime = performance.now();
    }
    /**
     * End timing render phase
     */ endRender() {
        if (this.renderStartTime > 0) {
            const renderTime = performance.now() - this.renderStartTime;
            this.renderTimes.push(renderTime);
            // Keep only last 60 frames
            if (this.renderTimes.length > 60) this.renderTimes.shift();
        }
    }
    /**
     * Start timing update phase
     */ startUpdate() {
        this.updateStartTime = performance.now();
    }
    /**
     * End timing update phase
     */ endUpdate() {
        if (this.updateStartTime > 0) {
            const updateTime = performance.now() - this.updateStartTime;
            this.updateTimes.push(updateTime);
            // Keep only last 60 frames
            if (this.updateTimes.length > 60) this.updateTimes.shift();
        }
    }
    /**
     * End timing a frame
     */ endFrame() {
        const currentTime = performance.now();
        const frameTime = currentTime - this.startTime;
        // Clamp frame time to reasonable values (avoid division by very small numbers)
        const clampedFrameTime = Math.max(frameTime, 0.1) // Minimum 0.1ms
        ;
        this.frameTimes.push(clampedFrameTime);
        // Keep only last 60 frames for rolling average
        if (this.frameTimes.length > 60) this.frameTimes.shift();
        this.lastFrameTime = frameTime;
        // Log metrics periodically
        if (this.config.enableMetrics && currentTime - this.lastLogTime > this.config.logInterval) {
            this.logMetrics();
            this.lastLogTime = currentTime;
        }
    }
    /**
     * Update entity counts
     */ updateEntityCounts(total, rendered, culled) {
        this.entityCount = total;
        this.renderedEntityCount = rendered;
        this.culledEntityCount = culled;
    }
    /**
     * Get current performance metrics
     */ getMetrics() {
        const avgFrameTime = this.frameTimes.length > 0 ? this.frameTimes.reduce((a, b)=>a + b, 0) / this.frameTimes.length : 0;
        const avgRenderTime = this.renderTimes.length > 0 ? this.renderTimes.reduce((a, b)=>a + b, 0) / this.renderTimes.length : 0;
        const avgUpdateTime = this.updateTimes.length > 0 ? this.updateTimes.reduce((a, b)=>a + b, 0) / this.updateTimes.length : 0;
        const frameRate = avgFrameTime > 0 ? 1000 / avgFrameTime : 0;
        return {
            frameRate: Math.round(frameRate * 10) / 10,
            entityCount: this.entityCount,
            renderedEntities: this.renderedEntityCount,
            culledEntities: this.culledEntityCount,
            viewportCullingStats: this.getViewportCullingStats?.() || {},
            spritePoolStats: this.getSpritePoolStats?.() || {},
            renderTime: Math.round(avgRenderTime * 100) / 100,
            updateTime: Math.round(avgUpdateTime * 100) / 100,
            totalTime: Math.round(avgFrameTime * 100) / 100,
            memoryUsage: this.config.enableMemoryTracking ? this.getMemoryUsage() : undefined
        };
    }
    /**
     * Log performance metrics to console
     */ logMetrics() {
        const metrics = this.getMetrics();
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, "=== Performance Metrics ===");
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, `Frame Rate: ${metrics.frameRate} FPS`);
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, `Entities: ${metrics.renderedEntities}/${metrics.entityCount} rendered (${metrics.culledEntities} culled)`);
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, `Render Time: ${metrics.renderTime}ms`);
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, `Update Time: ${metrics.updateTime}ms`);
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, `Total Time: ${metrics.totalTime}ms`);
        if (this.config.enableDetailedStats) {
            (0, $5UG8I.logger).debug({
                tags: [
                    "performance",
                    "viewport"
                ]
            }, "Viewport Culling:", metrics.viewportCullingStats);
            (0, $5UG8I.logger).debug({
                tags: [
                    "performance",
                    "sprites"
                ]
            }, "Sprite Pool:", metrics.spritePoolStats);
            // Debug: Log if too many entities are being culled
            const cullRate = metrics.entityCount > 0 ? (metrics.culledEntities / metrics.entityCount * 100).toFixed(1) : "0";
            if (parseFloat(cullRate) > 80) (0, $5UG8I.logger).warn({
                tags: [
                    "performance",
                    "culling"
                ]
            }, `High cull rate: ${cullRate}% (${metrics.culledEntities}/${metrics.entityCount} entities culled)`);
        }
        if (metrics.memoryUsage !== undefined) (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "memory"
            ]
        }, `Memory Usage: ${metrics.memoryUsage}MB`);
        (0, $5UG8I.logger).info({
            tags: [
                "performance",
                "metrics"
            ]
        }, "========================");
    }
    /**
     * Get memory usage (if available)
     */ getMemoryUsage() {
        if (typeof performance !== "undefined" && "memory" in performance) {
            const memory = performance.memory;
            return Math.round(memory.usedJSHeapSize / 1024 / 1024 * 100) / 100;
        }
        return undefined;
    }
    /**
     * Reset all metrics
     */ reset() {
        this.frameCount = 0;
        this.frameTimes = [];
        this.renderTimes = [];
        this.updateTimes = [];
        this.entityCount = 0;
        this.renderedEntityCount = 0;
        this.culledEntityCount = 0;
        this.lastLogTime = 0;
    }
    /**
     * Update configuration
     */ updateConfig(newConfig) {
        this.config = {
            ...this.config,
            ...newConfig
        };
    }
    /**
     * Get current configuration
     */ getConfig() {
        return {
            ...this.config
        };
    }
    /**
     * Get performance warnings
     */ getPerformanceWarnings() {
        const warnings = [];
        const metrics = this.getMetrics();
        if (metrics.frameRate < 30) warnings.push(`Low frame rate: ${metrics.frameRate} FPS`);
        if (metrics.totalTime > 33) warnings.push(`High frame time: ${metrics.totalTime}ms`);
        if (metrics.renderedEntities > 100) warnings.push(`High entity count: ${metrics.renderedEntities} entities`);
        if (metrics.renderTime > 16) warnings.push(`High render time: ${metrics.renderTime}ms`);
        return warnings;
    }
}



parcelRequire("1avo5");
var $gwPoJ = parcelRequire("gwPoJ");
var $9Pi8W = parcelRequire("9Pi8W");
var $8t5Gy = parcelRequire("8t5Gy");


class $fb80360aca138e05$export$e8f52b15f10174 extends (0, $8t5Gy.Container) {
    constructor(){
        super();
        this.visible = false;
        this.zIndex = 10000000;
        this.interactive = this.interactiveChildren = false;
        this.pivot.set(220, 92);
        const background = new (0, $gwPoJ.Graphics)();
        background.beginFill(0x101820, 0.9);
        background.lineStyle(1, 0x68808f, 0.8);
        background.drawRoundedRect(0, 0, 220, 92, 6);
        background.endFill();
        this.label = new (0, $9Pi8W.Text)("", {
            fontFamily: "monospace",
            fontSize: 12,
            fill: 0xffffff,
            lineHeight: 18
        });
        this.label.position.set(12, 9);
        this.addChild(background, this.label);
    }
    update(width, height, playerName) {
        this.visible = (0, $a4184bfabcb7e471$export$6847f56b353cc6db)(playerName);
        if (!this.visible) return;
        if (this.displayedRise !== (0, $2751e0027a1b432f$export$de62489b685ceb) || this.displayedUplift !== (0, $2751e0027a1b432f$export$42b4af315a0c8aa1)) {
            this.displayedRise = (0, $2751e0027a1b432f$export$de62489b685ceb);
            this.displayedUplift = (0, $2751e0027a1b432f$export$42b4af315a0c8aa1);
            this.label.text = `Rise: ${0, $2751e0027a1b432f$export$de62489b685ceb}px\n- / = adjust rise\nRoof uplift: ${0, $2751e0027a1b432f$export$42b4af315a0c8aa1}px\n_ / + adjust uplift`;
        }
        if (this.parent) {
            this.scale.set(1 / this.parent.scale.x, 1 / this.parent.scale.y);
            this.position.copyFrom(this.parent.toLocal({
                x: width - 12,
                y: height - 12
            }));
        }
    }
}


class $baf9ca3dd57f31c4$export$e33484ee45c8bb13 {
    constructor(app, logic){
        this.stageContent = (0, $1f08f7b8f85adf9e$export$250bc44beae81773).stage;
        this.contentRefreshPending = false;
        this.refreshContent = ()=>{
            this.contentRefreshPending = true;
        };
        this.observationSurface = new (0, $gwPoJ.Graphics)();
        this.debugVision = false;
        this.cachedSortedEntities = null;
        this.frameTimeHistory = [];
        this.lastFrameTime = 0;
        this.targetFrameTime = 1000 / 60 // 60 FPS target
        ;
        this.maxEntitiesPerFrame = 200 // Simple limit for basic culling
        ;
        this.performanceHistory = [] // Track performance over time
        ;
        this.gui = ()=>this._gui;
        this.entity = ()=>this._entity;
        this.map = ()=>this._map;
        this.mouse = ()=>this._mouse;
        this.keyboard = ()=>this._keyboard;
        this.logic = ()=>this._logic;
        this.getApp = ()=>this.app;
        // Follow-cam driver: while the ember-roster PiP modal is open, refresh the focused entity's
        // neighborhood (the main loop culls to ~7 tiles around the player, so far focus entities would
        // otherwise be frozen) and render the world centred on it into the modal's texture.
        this.updateFollowCam = ()=>{
            const focusId = this._logic.focusEntityId;
            const followCam = this._gui.followCam;
            // Skip the render-to-texture while the PiP is open-but-hidden (subject is on-screen).
            if (!focusId || !followCam || !followCam.isOpen() || !followCam.visible) return;
            if (this.observation?.entityId === focusId && this.observation.room) {
                this.renderObservation(followCam.getTexture(), followCam.getZoom());
                return;
            }
            const focus = this._logic.getFollowCamEntity(focusId);
            if (!focus) return;
            this.renderFocusNeighborhood(focus.entityId);
            this.renderWorldToTexture(followCam.getTexture(), focus.location.x, focus.location.y, followCam.getZoom());
        };
        // Update renderables for entities near the focused entity so the PiP shows live movement even
        // when that neighborhood is off the player's screen. Bounded work: only runs while the modal
        // is open, and only touches entities the client already knows about.
        this.renderFocusNeighborhood = (focusEntityId)=>{
            const playerEntityId = this._logic.playerEntity.entityId;
            this._logic.entityManager.iterate(null, (entity)=>{
                if (entity.entityId === playerEntityId) return;
                if (this._logic.isDestroyed(entity.entityId)) return;
                if (!this._logic.isNearFocus(entity.location)) return;
                this._entity.render(entity, playerEntityId);
            });
        };
        // Render the world (`surface`) into `renderTexture`, centred on world coords (cx, cy), for the
        // follow-cam PiP. Temporarily re-aims the surface transform, then restores it before the normal
        // on-screen render in the same frame. Render square (equal x/y zoom): the PiP sprite lives in
        // the HUD, which is a child of the stage and so already inherits the stage's vertical SCALER —
        // baking SCALER in here too would double it (the vertical stretch bug).
        this.renderWorldToTexture = (renderTexture, cx, cy, zoom)=>{
            const surface = this._surface;
            if (!surface) return;
            const px = renderTexture.width / 2 - cx * zoom;
            const py = renderTexture.height / 2 - cy * zoom;
            const savedX = surface.position.x;
            const savedY = surface.position.y;
            const savedScaleX = surface.scale.x;
            const savedScaleY = surface.scale.y;
            surface.scale.set(zoom, zoom);
            surface.position.set(px, py);
            // Swap in a focus-centred darkness/light mask for this render only. The main mask
            // (this.surface.mask, set by ShadowRendering) is baked in the PLAYER's screen space, so
            // reusing it here makes lights drift across the PiP as the player walks. renderPipLightMask
            // rebakes the same lights in the PiP's framing so a light stays fixed over the world it lit.
            const savedMask = surface.mask;
            const pipMask = this.shadowRendering.renderPipLightMask({
                cx: cx,
                cy: cy,
                zoom: zoom,
                texW: renderTexture.width,
                texH: renderTexture.height,
                resolution: renderTexture.baseTexture.resolution,
                visibility: this._map.getVisibility(),
                lights: this._entity.getLights()
            });
            surface.mask = pipMask ?? null;
            $baf9ca3dd57f31c4$export$e33484ee45c8bb13._app.renderer.render(surface, {
                renderTexture: renderTexture,
                clear: true
            });
            surface.mask = savedMask;
            surface.position.set(savedX, savedY);
            surface.scale.set(savedScaleX, savedScaleY);
            // Composite the world-overlay layer (name tags, hp, and speech bubbles) on top, so the PiP
            // shows the same in-world bubbles as the main view. Overlay items are positioned at
            // world*surfaceZoom (vs the surface's raw-world children), so it takes the SAME position but
            // a scale of zoom/surfaceZoom to line up with the world underneath.
            const overlay = this._worldOverlay;
            if (overlay) {
                const oSavedX = overlay.position.x;
                const oSavedY = overlay.position.y;
                const oSavedScaleX = overlay.scale.x;
                const oSavedScaleY = overlay.scale.y;
                overlay.scale.set(zoom / (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom, zoom / (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom);
                overlay.position.set(px, py);
                // A held bubble's "Next" button is a CONTROL, and inside the PiP it would be a picture
                // of one -- unclickable, and sitting over the words the player is trying to read. Hide
                // every live one for this pass only; the main view gets them back immediately after.
                (0, $5dbaf3682d88a932$export$46264c47e2aa11a2).setHiddenForCapture(true);
                // This vignette belongs to the local player's view, not the crew follow-camera.
                const forestVisible = this._forestVision.container.visible;
                this._forestVision.container.visible = false;
                $baf9ca3dd57f31c4$export$e33484ee45c8bb13._app.renderer.render(overlay, {
                    renderTexture: renderTexture,
                    clear: false
                });
                this._forestVision.container.visible = forestVisible;
                (0, $5dbaf3682d88a932$export$46264c47e2aa11a2).setHiddenForCapture(false);
                overlay.position.set(oSavedX, oSavedY);
                overlay.scale.set(oSavedScaleX, oSavedScaleY);
            }
        };
        this.updatePlayerLocation = (entity, force)=>{
            this._map.updatePlayerLocation(entity, force);
        };
        // Get shadow performance metrics for debugging
        this.getShadowPerformanceMetrics = ()=>{
            return this.shadowPerformanceMonitor.getMetrics();
        };
        // Force shadow texture update (useful for debugging)
        this.forceShadowTextureUpdate = ()=>{
            this.shadowRendering.forceTextureUpdate();
        };
        // Debug methods for viewport culling
        this.enableTileBasedCulling = ()=>{
        // this._entity.enableTileBasedCulling()
        };
        this.getViewportDebugInfo = (playerLocation)=>{
            // return this._entity.getViewportDebugInfo(playerLocation)
            return {};
        };
        this.render = ()=>{
            (0, $a17a83e5cb2d0838$export$c68a19ffc4e6cc19)();
            this.riseDebug.update(this.app.screen.width, this.app.screen.height, this._logic.playerEntity?.name);
            if (this.contentRefreshPending) {
                this.contentRefreshPending = false;
                this._entity.refreshContent();
                this._map.rerender();
            }
            const currentTime = performance.now();
            const frameTime = currentTime - this.lastFrameTime;
            this.lastFrameTime = currentTime;
            // Track frame time history for smoothness analysis
            this.frameTimeHistory.push(frameTime);
            if (this.frameTimeHistory.length > 60) this.frameTimeHistory.shift();
            // Start performance monitoring
            this.performanceMonitor.startFrame();
            // world
            this._map.renderTileMap();
            // Start render timing
            this.performanceMonitor.startRender();
            // Optimized entity rendering with early exits and batching
            this._entity.beginFrame();
            this.renderEntitiesOptimized();
            // Fade entity tiles (trees/bushes, cave ore) the local player is standing behind, so the player
            // stays visible. Runs after entities are laid out this frame (player location is current).
            if (this._logic.playerEntity) this._map.applyOccluderFade(this._logic.playerEntity);
            // End render timing
            this.performanceMonitor.endRender();
            // Follow-cam picture-in-picture (ember roster): keep the focused entity's neighborhood
            // updated and render the world centred on it into the PiP texture.
            this.updateFollowCam();
            // Anything that was on screen last frame but nothing rendered this frame (it left the
            // culled set, or the follow-cam stopped feeding its neighborhood) has to be hidden, or it
            // stays drawn where it last was while the real entity moves on -- the "ghost" NPC.
            this._entity.endFrame();
            this._entity.updatePlayerOcclusionOutline();
            this.shadowRendering.renderVisibility({
                location: this._logic.playerEntity.location,
                polyMap: this._map.getVisibilityMap(),
                visibility: this._map.getVisibility(),
                debug: this.debugVision ? this.debugSurface : undefined,
                lights: this._entity.getLights(),
                wallArt: this._map.getWallArt
            });
            this._gui.emberMinimap.updateSight(this.shadowRendering.sightRoomId, this.shadowRendering.sightPolygon);
            // Update shadow performance monitoring
            this.shadowPerformanceMonitor.update();
            // Update GUI timer
            this._gui.updateTimer(frameTime);
            // Redraw the tether from a per-entity command wheel to its target (and close the wheel once
            // that target leaves the viewport). The wheel itself stays where it opened.
            this._gui.updateCommandWheelTether();
            // Same for the recruit role picker, which floats over its recruit.
            this._gui.updateRolePickerPosition();
            this._gui.updateNamePrompt();
            // Animate default interaction wheels and, on touch, focus the nearest interactable.
            this._entity.updateInteractionFocus(frameTime);
            // Update faction-tracking edge arrows (offscreen faction members)
            this._factionTracker.update();
            // Blow the room's leaves about (no-op, one boolean, in a room with no wind or after dark).
            // After the world is laid out, so the box is centred on where the player actually is this
            // frame. The brightness is what makes the wind die at dusk -- and it is passed as undefined
            // for a room with no day cycle (dayPhase null), which the effect reads as permanent day
            // rather than as pitch dark.
            const brightness = this._logic.scene.daylight;
            const ambience = this._logic.scene.ambience;
            this._rain.update(ambience?.rain ?? null, this._logic.tilemapMetaProvider);
            this._forestVision.update(ambience?.forestVision === true, this._logic.tilemapMetaProvider, this._logic.playerEntity?.location);
            this._windLeaves.update(ambience?.windLeaves ?? null, this._logic.playerEntity?.location, brightness);
            // ...and roll the fog in, which is the same gate read backwards: it thickens as the wind drops.
            const house = this._logic.tilemapMetaProvider?.twoStoreyHouse;
            this._nightFog.update(ambience?.nightFog ?? null, brightness, house ? (0, $2751e0027a1b432f$export$815ba2e910747d11)(house) : 0);
            // ...and bend the grass on the SAME gust that carries the leaves, so the two are one wind.
            this._map.updateTileEffects(ambience?.windLeaves ?? null, this._logic.playerEntity?.location, this._rain.stormWind, brightness);
            this._grassSway.update(ambience?.windLeaves ?? null, this._logic.playerEntity?.location, brightness);
            // ...and let the butterflies out, which read that same gust to know when to shelter.
            this._butterflies.update(ambience?.butterflies ?? null, this._logic.playerEntity?.location, brightness);
            // ...and light the fireflies, which are the butterflies' opposite number after dark.
            this._fireflies.update(ambience?.fireflies ?? null, this._logic.playerEntity?.location, brightness);
            // ...and spark the lava, which is the one ambience with no day gate at all: it takes the tile
            // provider instead, because it finds its own cells off the tile types the client already holds
            // rather than being told where the lava is.
            this._lavaEmbers.update(ambience?.lavaEmbers ?? null, this._logic.playerEntity?.location, this._logic.tilemapMetaProvider);
            // Sweep any held-interaction countdown dials (see HoldTimer). On the same surface as the
            // fireflies, and driven from here rather than from an entity message for the same reason the
            // other two are: the server speaks ten times a second and a ring has to move every frame.
            this._worldOverlay.animateHoldTimers();
            // ...and the prompt that comes before one on an injured rescue survivor, which breathes.
            this._worldOverlay.animateRescueHints();
            this._worldOverlay.animateBonecallerWarnings();
            this._worldOverlay.animateDroppedItemGlints();
            // Keep the open chat bubbles off each other and on the screen (see
            // sprites/speech_bubble_layout.ts). After the entities have moved this frame, so it lays out
            // against where the speakers are now. The screen is in the renderer's global coordinates,
            // the same space the HUDs' toGlobal reads in.
            const screen = this.app.screen;
            (0, $a77286236663d69d$export$54b23a9eafdee768).arrange(performance.now(), {
                x: screen.x,
                y: screen.y,
                w: screen.width,
                h: screen.height
            });
            this._logic.audio.updateBonecallerChant();
            // Same deal for the Ember Core's furnace: the loop's pitch and gain track the hold frame by
            // frame, and the server only restates the hold ten times a second.
            this._logic.audio.updateEmberCoreCharge();
            // End performance monitoring
            this.performanceMonitor.endFrame();
            // Adaptive frame rate limiting for smoother gameplay
            this.adaptiveFrameRateLimit();
        };
        this.renderEntitiesOptimized = ()=>{
            const playerEntityId = this._logic.playerEntity.entityId;
            let renderedCount = 0;
            const playerPos = this._logic.playerEntity.location;
            // First pass: render player entity (always highest priority)
            if (this._logic.playerEntity) {
                this._entity.render(this._logic.playerEntity, playerEntityId);
                renderedCount++;
            }
            // Check if we need to re-sort entities
            const shouldResort = this._logic.shouldResortEntities(playerPos);
            let entitiesToProcess;
            if (shouldResort) {
                entitiesToProcess = this.calculateSortedEntitiesByDistance(playerPos);
                this.cachedSortedEntities = entitiesToProcess;
            } else entitiesToProcess = this.cachedSortedEntities;
            if (!entitiesToProcess?.length) return;
            // Get adaptive entity limit based on performance (cached)
            const maxEntitiesToRender = this.getCachedEntityLimit();
            // Render entities in distance order (closest first)
            // Note: entities are already culled to 7 tiles during sorting
            for(let i = 0; i < entitiesToProcess.length; i++){
                const { entity: entity } = entitiesToProcess[i];
                // Early exit if we've rendered too many entities this frame
                if (renderedCount >= maxEntitiesToRender) {
                    // Keep visibility and position current even when animation work is deferred.
                    for(let j = i; j < entitiesToProcess.length; j++)this._entity.markDeferred(entitiesToProcess[j].entity.entityId);
                    break;
                }
                // Skip if entity is the player (already rendered)
                if (entity.entityId === playerEntityId) continue;
                // Skip if entity is destroyed
                if (this._logic.isDestroyed(entity.entityId)) continue;
                // Render the entity
                if (this._entity.render(entity, playerEntityId)) renderedCount++;
            }
            // Update performance monitor with entity counts
            this.updateEntityRenderingMetrics(renderedCount);
        };
        this.cachedEntityLimit = 200;
        this.lastEntityLimitUpdate = 0;
        this.entityLimitUpdateInterval = 1000 // Update every 1 second
        ;
        this.adaptiveFrameRateLimit = ()=>{
            if (this.frameTimeHistory.length < 10) return;
            // Calculate average frame time
            const avgFrameTime = this.frameTimeHistory.reduce((a, b)=>a + b, 0) / this.frameTimeHistory.length;
            const currentFPS = 1000 / avgFrameTime;
            // Track performance history
            this.performanceHistory.push(currentFPS);
            if (this.performanceHistory.length > 30) this.performanceHistory.shift();
            // Get total entity count for scaling decisions
            const totalEntities = this._logic.entityManager.size();
            // If we're running too fast, add a small delay for smoother gameplay
            if (currentFPS > 120) {
                const delay = Math.min(2, 1000 / 120 - avgFrameTime);
                if (delay > 0) // Use setTimeout to add a small delay without blocking
                setTimeout(()=>{}, delay);
            }
            // Temporarily disable adaptive scaling to debug performance
            // Keep entity limit at 500 for now
            this.maxEntitiesPerFrame = 500;
        };
        $baf9ca3dd57f31c4$export$e33484ee45c8bb13._app = app;
        // Also publish it on the standalone holder, which is what the low-level bakers read. See
        // renderer_app.ts for why they no longer reach through this class.
        (0, $065c5647ab3ff4dc$export$6a54bfeffaafa5f7)(app);
        this.app = app;
        this._logic = logic;
        const stage = this.app.stage;
        stage.interactive = true;
        stage.sortableChildren = true;
        const surface = new (0, $gwPoJ.Graphics)();
        surface.sortableChildren = true;
        stage.addChild(surface);
        surface.scale.set((0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom);
        this._surface = surface;
        const worldOverlaySurface = new (0, $b11c64d757fefaba$export$198fa1625abb29ee)(logic, surface);
        stage.addChild(worldOverlaySurface);
        this._worldOverlay = worldOverlaySurface;
        // WHICH LAYERS ARE THE WORLD. Button presses arrive on a document-level mousedown, which pixi
        // never hit-tests, so before this every click reached the player controller wherever it landed
        // and pressing a HUD control swung the weapon at whatever was behind it. Naming the world's
        // layers lets Mouse ask what is under the pointer and drop presses that belong to the HUD.
        //
        // Everything else on the stage is chrome: the gui container, the faction tracker, debug.
        (0, $f246f635ee3b2e66$export$7caecd373b84cec3).setWorldRoots([
            surface,
            worldOverlaySurface
        ]);
        // Map tiles advertise their own verbs; their context gesture belongs to the world surface.
        stage.on("pointerdown", (event)=>{
            if (!(0, $f246f635ee3b2e66$export$7caecd373b84cec3).isWorldPoint(event.data.global)) return;
            if (event.data.pointerType === "touch" && logic.playerController?.mobileBuildingState().active) return;
            const world = event.data.getLocalPosition(surface);
            logic.playerController?.beginTilePress((0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(world), event.data.pointerType, event.data.button, {
                x: world.x,
                y: world.y
            });
        });
        stage.on("pointerup", ()=>logic.playerController?.endTilePress());
        stage.on("pointerupoutside", ()=>logic.playerController?.cancelTilePress());
        stage.on("pointercancel", ()=>logic.playerController?.cancelTilePress());
        stage.on("pointermove", (event)=>{
            const world = event.data.getLocalPosition(surface);
            logic.playerController?.moveTilePress((0, $a80d0b17b615d6f7$export$504709cb2a8295d2)(world), world);
        });
        // This one is still needed and is NOT the same problem. A held bubble's "Next" is drawn on the
        // entity's own sprite, INSIDE the world surface, so it is a world press by every test above --
        // it has to say so itself. Read the controller lazily: it does not exist yet here.
        (0, $5dbaf3682d88a932$export$46264c47e2aa11a2).bindSuppressAttack(()=>logic.playerController?.suppressAttack());
        const minimapSurface = new (0, $0de04cf39fd0c1a1$export$549555cdc2ac3f0f)(logic);
        this._gui = new (0, $7dd73ecdd94bfe01$export$530fe131767a4087)(stage, minimapSurface, logic);
        this._gui.init();
        // Screen-space overlay for faction-tracking edge arrows (reads state from logic).
        this._factionTracker = new (0, $265fbb56155cf111$export$92880c192d1b7482)(logic, surface, app);
        stage.addChild(this._factionTracker.container);
        ////////////////////////////////////////
        const skySurface = new (0, $gwPoJ.Graphics)();
        skySurface.sortableChildren = true;
        skySurface.zIndex = 1000000;
        // The wind bending the grass (see GrassSway). Built before the map, because the map hands it
        // every sprited cell as it renders one.
        this._grassSway = new (0, $59052a7f89e51e65$export$7d832ea11681c35b)();
        this._map = new (0, $409e08612bd4cd6f$export$ac241b7c41940a17)(surface, skySurface, minimapSurface, worldOverlaySurface, logic);
        this._map.setGrassSway(this._grassSway);
        this._map.init();
        // A change of level hands the active role to the map that already drew the destination floor.
        this._map.onHandOff = (next)=>{
            this._map = next;
        };
        this._entity = new (0, $3de7f2d858d8583e$export$b797a3cc601f36f1)(surface, minimapSurface, worldOverlaySurface, logic, this, app);
        this._entity.init();
        // After construction has finished with the renderer, not in the middle of it.
        requestAnimationFrame(()=>(0, $d418365bf376d48a$export$f92e084d92dcf8bb)(app.renderer, this._entity.warmableFilters()));
        // Windblown leaves (see WindLeaves): a per-room ambience, off unless the room asks for it.
        // It goes INSIDE the world surface so the leaves parallax with the camera and inherit the
        // night-time visibility mask; its zIndex keeps them above entities but under the sky/roof.
        this._windLeaves = new (0, $02d47f540b0d58f8$export$ebaa494e10da0ea2)((0, $02d47f540b0d58f8$export$ebaa494e10da0ea2).textureFactory(app.renderer));
        surface.addChild(this._windLeaves.container);
        // Night fog (see NightFog): one shader on one quad, also inside the world surface so it
        // parallaxes and is clipped by the night visibility mask. It asks the surface itself what world
        // rectangle is on screen, which is the only way to be right at the map edges where the camera
        // stops following the player. Drawn under the leaves, so leaves stay crisp against it.
        this._nightFog = new (0, $5771f9fef21bdf34$export$321e670ba3865065)(surface, app.screen, (0, $5771f9fef21bdf34$export$321e670ba3865065).bakeNoise);
        surface.addChild(this._nightFog.container);
        // Butterflies by day (see Butterflies), the day-side counterpart to the fog. In the world
        // surface with the rest, so they parallax and are clipped by the visibility mask.
        // The perch source is the grass registry: butterflies settle on the same tufts the wind bends.
        this._butterflies = new (0, $be65b55052fa66e7$export$b384c8d4ebe6bf23)((0, $be65b55052fa66e7$export$b384c8d4ebe6bf23).textureFactory(app.renderer), (x, y, r)=>this._grassSway.perchNear(x, y, r));
        surface.addChild(this._butterflies.container);
        // Fireflies, after dark. NOT in the world surface with the others: that surface is masked by
        // the night visibility, and a firefly is a light -- the whole picture is one glowing out in the
        // dark where you cannot otherwise see. The overlay surface is camera-moved but unmasked.
        this._fireflies = new (0, $aa1fa3752bebfcbe$export$14e015fa5aada1ce)((0, $aa1fa3752bebfcbe$export$14e015fa5aada1ce).textureFactory(app.renderer));
        worldOverlaySurface.addChild(this._fireflies.container);
        // Above world art and fireflies, below entity HUDs; the forest can reach complete black.
        this._forestVision = new (0, $10086bf2e2b19266$export$78361259babe7fe0)(worldOverlaySurface, app.screen);
        worldOverlaySurface.addChild(this._forestVision.container);
        // Sparks and bubbles off the lava in an ember mine (see LavaEmbers). Two containers, both in
        // the WORLD surface: the sparks above every body, the bubbles below them, because a spark is
        // light in the air and a bubble is the floor turning over. In the world surface rather than the
        // overlay so both are clipped by the cave's visibility mask -- lava behind unbroken rock should
        // bleed at the room's darkness, not blaze through it, which is the opposite of the firefly
        // argument directly above.
        this._lavaEmbers = new (0, $e4907a99a87534fa$export$4a802ef66c128389)((0, $e4907a99a87534fa$export$4a802ef66c128389).textureFactory(app.renderer));
        surface.addChild(this._lavaEmbers.airContainer);
        surface.addChild(this._lavaEmbers.groundContainer);
        this._rain = new (0, $becba67b0a664921$export$95ab89985350a09a)(surface, app.screen, (0, $becba67b0a664921$export$95ab89985350a09a).textures(app.renderer), ()=>this._logic.audio.playWeatherThunder(), ()=>this._logic.audio.stopWeatherThunder());
        surface.addChild(this._rain.container);
        // Put lightning above the masked ground, below unmasked entity labels and the HUD.
        this._rain.sky.zIndex = surface.zIndex;
        stage.addChildAt(this._rain.sky, stage.getChildIndex(surface) + 1);
        this._mouse = new (0, $f246f635ee3b2e66$export$7caecd373b84cec3)();
        this._keyboard = new (0, $ea3f90e500565ae9$export$16e4d70cc375e707)();
        const debugSurface = new (0, $gwPoJ.Graphics)();
        this.debugSurface = debugSurface;
        debugSurface.sortableChildren = true;
        surface.addChild(skySurface);
        stage.addChild(debugSurface);
        this.riseDebug = new (0, $fb80360aca138e05$export$e8f52b15f10174)();
        stage.addChild(this.riseDebug);
        this.riseDebug.update(app.screen.width, app.screen.height, logic.playerEntity?.name);
        this.shadowRendering = new (0, $cb0ab22baf2add07$export$fe76cdfccd658eb)(app, surface, this.debugVision, logic);
        this.shadowPerformanceMonitor = new (0, $aFPGo.ShadowPerformanceMonitor)(this.shadowRendering);
        // Initialize performance monitor
        this.performanceMonitor = new (0, $3a1b2b5c28aeeeee$export$9b229b42dc5ba616)({
            enableMetrics: true,
            logInterval: 5000,
            enableMemoryTracking: true,
            enableDetailedStats: true
        });
        // Set up performance monitor callbacks
        this.performanceMonitor.setStatCallbacks({
            getViewportCullingStats: ()=>{}
        });
    }
    updateObservation(observation) {
        if (!observation?.room) {
            this.observationScene?.clear();
            this.observation = undefined;
            return;
        }
        this.observation = observation;
        this.observationScene ??= new (0, $55d4eaeb8e7150fb$export$cdeb03331aa0daa)(this.observationSurface, (root, sky)=>{
            const map = new (0, $409e08612bd4cd6f$export$ac241b7c41940a17)(root, sky, {
                update: ()=>{}
            }, new (0, $b11c64d757fefaba$export$198fa1625abb29ee)(this._logic, root, (0, $1704411fa88dc9bf$export$5f95b9c185ae9263)), this._logic, (0, $1704411fa88dc9bf$export$5f95b9c185ae9263));
            map.init();
            return map;
        }, (entity, provider)=>this._entity.renderSceneEntity(entity, provider), true, undefined, (id)=>this._logic.getEmberRole(id));
        this.observationScene.update([
            observation.room
        ]);
    }
    renderObservation(texture, zoom) {
        const scene = this.observationScene;
        const focus = scene?.getEntity(this.observation.entityId);
        if (!focus) return;
        scene.render(undefined, focus);
        const surface = this.observationSurface;
        surface.position.set(texture.width / 2 - focus.location.x * zoom, texture.height / 2 - focus.location.y * zoom);
        surface.scale.set(zoom);
        surface.mask = this.shadowRendering.renderPipLightMask({
            cx: focus.location.x,
            cy: focus.location.y,
            zoom: zoom,
            texW: texture.width,
            texH: texture.height,
            resolution: texture.baseTexture.resolution,
            visibility: this.observation.visibility,
            lights: scene.getLights()
        }) ?? null;
        try {
            this.app.renderer.render(surface, {
                renderTexture: texture,
                clear: true
            });
        } finally{
            surface.mask = null;
        }
    }
    calculateSortedEntitiesByDistance(playerPos) {
        // Use spatial indexing for O(log n) performance instead of O(n)
        return this._logic.getVisibleEntities(playerPos);
    }
    getCullingDistanceSquared() {
        // Use unified culling system from ClientGameLogic
        return this._logic.getCullingDistanceSquared();
    }
    getCachedEntityLimit() {
        const now = performance.now();
        // Only update entity limit periodically to avoid expensive metrics calls
        if (now - this.lastEntityLimitUpdate > this.entityLimitUpdateInterval) {
            this.updateCachedEntityLimit();
            this.lastEntityLimitUpdate = now;
        }
        return this.cachedEntityLimit;
    }
    updateCachedEntityLimit() {
        const metrics = this.performanceMonitor.getMetrics();
        const baseLimit = 200;
        // Adjust based on performance
        if (metrics.frameRate < 30) this.cachedEntityLimit = Math.floor(baseLimit * 0.6) // Reduce when performance is poor
        ;
        else if (metrics.frameRate > 60) this.cachedEntityLimit = Math.floor(baseLimit * 1.5) // Increase when performance is good
        ;
        else this.cachedEntityLimit = baseLimit;
    }
    updateEntityRenderingMetrics(renderedCount) {
        const totalEntities = this._logic.entityManager.size();
        const culledCount = totalEntities - renderedCount;
        this.performanceMonitor.updateEntityCounts(totalEntities, renderedCount, culledCount);
        // Debug: Log entity counts every few seconds (reduced frequency)
        if (Math.random() < 0.01) // 1% chance to log
        (0, $5UG8I.logger).debug({
            tags: [
                "rendering",
                "entities"
            ]
        }, `Entity rendering: ${renderedCount}/${totalEntities} rendered, ${culledCount} culled`);
    }
}


class $b413b66e0babaf69$export$7152e8d75caca3a3 {
    constructor(app){
        this.create = (logic)=>{
            return new (0, $baf9ca3dd57f31c4$export$e33484ee45c8bb13)(this.app, logic);
        };
        this.app = app;
    }
}



(0, $ezJmd.settings).SCALE_MODE = (0, $P8XPi.SCALE_MODES).NEAREST;
(0, $ezJmd.settings).RENDER_OPTIONS.antialias = false;
// A Graphics of more points than this is drawn on its own: its own draw call, and the batch either side of it broken.
// pixi's default (100) left the HUD's rounded panels, meters and the map's outlines all unbatched, and in Chrome every
// GL call crosses to the GPU process (~14us each): batching them cut a castle frame's calls by a quarter (484 -> ~360)
// and its draw time by ~1.7ms. A batched Graphics copies its vertices into the batch each frame, cheap at this size.
(0, $gwPoJ.GraphicsGeometry).BATCHABLE_SIZE = 4000;
// Every asset url in the client is a logical key ("assets/foo.png") that `contentAssetUrl`
// (game-common/content/catalog) resolves to the current immutable release,
// "assets/content/<revision>/foo.png". That is still relative, so it resolves against whatever
// origin served the page. That is right for a browser tab and wrong for the native shell, whose
// origin is the app bundle -- the art is not shipped inside it. Setting the loader's baseUrl once
// redirects all 50-odd call sites without touching any of them; it is "" everywhere else, and
// resource-loader leaves urls alone when it is empty. Must happen before the first
// Loader.shared.add(), which is why it sits at module top rather than inside the boot callback.
(0, $kXE1p.Loader).shared.baseUrl = (0, $a8f3c0c196817c22$export$7eca4ea16d4c8343)().assetBase;




const $d787de46f259e3a8$var$foo = setInterval(()=>{
    if (window["__GO__"]) {
        clearInterval($d787de46f259e3a8$var$foo);
        const app = new (0, $7DxQ2.Application)({
            view: document.getElementById("pixi-canvas"),
            resolution: window.devicePixelRatio || 2,
            autoDensity: true,
            backgroundColor: 0x000000
        });
        (0, $ea3f90e500565ae9$export$16e4d70cc375e707).initialize();
        (0, $f246f635ee3b2e66$export$7caecd373b84cec3).initialize(app);
        const onLoadComplete = ()=>{
            const canvasHost = document.getElementById("pixi-content");
            function resize() {
                // Measure the CSS viewport, which can settle after window.innerHeight on iOS
                // Home Screen launch. Never freeze the host to an initial inline pixel height.
                const bounds = canvasHost.getBoundingClientRect();
                const layout = (0, $167efe97b4119a5d$export$732c3502c7f18a71)(bounds.width || window.innerWidth, bounds.height || window.innerHeight, window.devicePixelRatio || 1, (0, $10da07838e6d507c$export$d0a8044dce8ff2fc)());
                const { resolution: resolution } = layout;
                // Draw at the displayed density, with a buffer budget that includes the wider view.
                app.renderer.resolution = resolution;
                // InteractionManager copies the resolution once, when it is constructed, and never
                // looks at it again. Leave it stale and every interactive widget -- and the mouse
                // position the world is aimed with -- hit-tests in the wrong place.
                const interaction = app.renderer.plugins?.interaction;
                if (interaction) interaction.resolution = resolution;
                app.renderer.resize(layout.virtualWidth, layout.virtualHeight);
                // resize() with autoDensity has just written the VIRTUAL size into the canvas
                // style; the displayed size is what belongs on screen.
                app.renderer.view.style.width = layout.cssWidth + "px";
                app.renderer.view.style.height = layout.cssHeight + "px";
                app.stage.scale.y = (0, $10da07838e6d507c$export$c6ec669adaa5980d);
                // Existing HUD and camera coordinates stay centered in the expanded canvas.
                app.stage.x = layout.stageX;
                app.stage.y = layout.stageY;
                (0, $10da07838e6d507c$export$aa707847c2571374).viewportPaddingX = layout.stageX / (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
                (0, $10da07838e6d507c$export$aa707847c2571374).viewportPaddingY = layout.stageY / (0, $10da07838e6d507c$export$c6ec669adaa5980d) / (0, $10da07838e6d507c$export$aa707847c2571374).surfaceZoom;
                (0, $0d2b5753435eae0a$export$495bff943178518d)(app.renderer.view, layout.virtualWidth, layout.virtualHeight, (0, $10da07838e6d507c$export$c6ec669adaa5980d));
            }
            resize();
            const factory = new (0, $b413b66e0babaf69$export$7152e8d75caca3a3)(app);
            const clientGameLogic = new (0, $1e46c45e333c583b$export$99cd19a42c3acc3f)(factory);
            const client = new (0, $67f7e8116a91e4e7$export$1f2bb630327ac4b6)(clientGameLogic);
            const resizeClient = ()=>{
                resize();
                clientGameLogic.invalidateViewportCache();
                window.dispatchEvent(new Event("samsara:canvas-resize"));
            };
            (0, $235fc386ca59d431$export$98b8b75b24ddd4c0)(canvasHost, resizeClient);
            window.matchMedia?.("(any-pointer: coarse)").addEventListener?.("change", resizeClient);
            // Setup viewport culling debug tools
            (parcelRequire("bW0pk")).then(({ setupViewportCullingDebug: setupViewportCullingDebug })=>{
                setupViewportCullingDebug(clientGameLogic.clientRenderer);
            });
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            const showsIntro = window["IS_ITCH"] || (0, $a8f3c0c196817c22$export$7eca4ea16d4c8343)().autoGuest || !params.accessToken && params.guest === "true";
            if (!showsIntro) requestAnimationFrame(()=>window["stopLoading"]?.());
            if (window["IS_ITCH"] || (0, $a8f3c0c196817c22$export$7eca4ea16d4c8343)().autoGuest) client.connect("", "", true);
            else {
                const { accessToken: accessToken, guest: guest } = params;
                if (accessToken) client.connect("", accessToken);
                else {
                    const isGuest = guest === "true";
                    const cachedPlayerName = isGuest ? "" : localStorage.getItem("_playerName_") || "";
                    client.connect(cachedPlayerName, "", isGuest);
                }
            }
            // ONE thrown exception out of a frame must not end the game.
            //
            // pixi's ticker re-arms its requestAnimationFrame AFTER emitting, so a listener that
            // throws stops the loop for good: the canvas holds its last frame, the socket stays up,
            // and the player is left looking at a picture. That is the "my screen froze" report, and
            // it is indistinguishable from a crash however small the thing that threw -- a widget
            // animating a panel, a sprite whose paperdoll was swapped under it, a mask on a destroyed
            // display object. Nothing drawn in a single frame is worth the whole renderer, so: keep
            // drawing, and make sure the first few failures carry a stack somebody can act on.
            //
            // The count AND the stacks go on `window` deliberately. On a device there is no console
            // to scroll back through, and even in a browser the console is no use here: this client
            // logs a couple of thousand texture warnings on load, so by the time a frame fails its
            // stack is somewhere in the middle of that and cannot be found. `__frameErrors` answers
            // "has this client been dropping frames", and `__frameErrorLog` says what it was --
            // readable over CDP, from devtools, or by a test.
            let frameErrors = 0;
            const frameErrorLog = [];
            window.__frameErrors = 0;
            window.__frameErrorLog = frameErrorLog;
            app.ticker.add(()=>{
                try {
                    client.update();
                } catch (error) {
                    frameErrors++;
                    window.__frameErrors = frameErrors;
                    // The first few only: a frame that fails tends to fail every frame, and the
                    // hundredth copy of one stack is worth less than the first copy of the next.
                    if (frameErrors <= 5) {
                        const detail = error?.stack || String(error);
                        frameErrorLog.push(detail);
                        console.error("[frame] update failed", error);
                        (0, $5UG8I.logger).error({
                            tags: [
                                "frame",
                                "error"
                            ]
                        }, `frame update failed: ${detail}`);
                    }
                }
            });
            // Expose shadow debug features to global scope for debugging
            if (typeof window !== "undefined") {
                window.__PIXI_APP__ = app;
                // What a slow frame was spent on: hitchProbe.record(20). Idle until started.
                (0, $4f4274c559724179$export$acffefb7cc72d617)(app, client);
                window.logger = (0, $5UG8I.logger);
                window.shadowDebug = {
                    getMetrics: ()=>client.getShadowPerformanceMetrics(),
                    forceUpdate: ()=>client.forceShadowTextureUpdate(),
                    logMetrics: ()=>{
                        const metrics = client.getShadowPerformanceMetrics();
                        (0, $5UG8I.logger).info({
                            tags: [
                                "shadow",
                                "performance"
                            ]
                        }, "Shadow Performance:", metrics);
                    },
                    debugLog: ()=>{
                        // Access the shadow rendering directly for debug logging
                        const renderer = client.clientGameLogic.clientRenderer;
                        if (renderer.shadowRendering) renderer.shadowRendering.debugLog();
                    },
                    enableDebugLogging: ()=>{
                        // Enable debug logging for hash calculation
                        const renderer = client.clientGameLogic.clientRenderer;
                        if (renderer.shadowRendering) {
                            renderer.shadowRendering.debugHashCalculation = true;
                            (0, $5UG8I.logger).info({
                                tags: [
                                    "shadow",
                                    "debug"
                                ]
                            }, "Shadow hash debug logging enabled");
                        }
                    },
                    disableDebugLogging: ()=>{
                        // Disable debug logging
                        const renderer = client.clientGameLogic.clientRenderer;
                        if (renderer.shadowRendering) {
                            renderer.shadowRendering.debugHashCalculation = false;
                            (0, $5UG8I.logger).info({
                                tags: [
                                    "shadow",
                                    "debug"
                                ]
                            }, "Shadow hash debug logging disabled");
                        }
                    }
                };
                (0, $5UG8I.logger).info({
                    tags: [
                        "shadow",
                        "debug"
                    ]
                }, "Shadow debug tools available at window.shadowDebug");
                (0, $5UG8I.logger).info({
                    tags: [
                        "shadow",
                        "debug"
                    ]
                }, "Shadow debug test available at window.shadowDebugTest");
                (0, $5UG8I.logger).info({
                    tags: [
                        "logger",
                        "debug"
                    ]
                }, "Logger available at window.logger for debugging");
                window.shadowDebugTest = {
                    startMonitoring: ()=>{
                        const { ShadowDebugTest: ShadowDebugTest } = (parcelRequire("f9obu"));
                        const debugTest = new ShadowDebugTest(clientGameLogic);
                        debugTest.startMonitoring();
                    },
                    testStationary: ()=>{
                        const { ShadowDebugTest: ShadowDebugTest } = (parcelRequire("f9obu"));
                        const debugTest = new ShadowDebugTest(clientGameLogic);
                        debugTest.testStationary();
                    },
                    testMovement: ()=>{
                        const { ShadowDebugTest: ShadowDebugTest } = (parcelRequire("f9obu"));
                        const debugTest = new ShadowDebugTest(clientGameLogic);
                        debugTest.testMovement();
                    }
                };
            }
        };
        $d787de46f259e3a8$var$loadAssets();
        const aggressiveLoad = false;
        (0, $kXE1p.Loader).shared.load(aggressiveLoad ? ()=>(0, $c1d8cd49591538f1$export$cd02f82db8cdb05).bulkLoad((0, $e5c675b7b9585b42$export$8952b416ba38edb4).source.preload.map((sheetId)=>`assets/${sheetId}`), onLoadComplete) : onLoadComplete);
    }
}, 1000);
const $d787de46f259e3a8$var$loadAssets = ()=>{
    //
    // fonts
    //
    const chars = {
        chars: [
            [
                "a",
                "z"
            ],
            [
                "0",
                "9"
            ],
            [
                "A",
                "Z"
            ],
            " .!?|,\":<>~!@#$%^&*()_+-=/\\'\xeb"
        ]
    };
    (0, $hnGDn.BitmapFont).from("LocationFont", {
        fill: "#00FF00",
        fontSize: 25
    }, chars);
    (0, $hnGDn.BitmapFont).from("BannerFont", {
        fill: "#FFFFFF",
        fontSize: 20
    }, chars);
    (0, $hnGDn.BitmapFont).from("ImportantFont", {
        fill: "#FFFFFF",
        fontSize: 30
    }, chars);
    (0, $hnGDn.BitmapFont).from("LogoFont", {
        fill: "#FFFFFF",
        fontSize: 40
    }, chars);
    (0, $hnGDn.BitmapFont).from("ScoreFont", {
        fill: "#FFFFFF",
        fontSize: 15,
        fontFamily: "Serif"
    }, chars);
    (0, $hnGDn.BitmapFont).from("NameFont", {
        fill: "#FFFFFF",
        fontSize: 10
    }, chars);
    (0, $hnGDn.BitmapFont).from("ChatFont", {
        fill: "#00EE00",
        fontSize: 10
    }, chars);
    (0, $hnGDn.BitmapFont).from("RedChatFont", {
        fill: "#FFA500",
        fontSize: 10
    }, chars);
    (0, $hnGDn.BitmapFont).from("SmallFont", {
        fontSize: 10
    }, chars);
    (0, $hnGDn.BitmapFont).from("SignFont", {
        fill: "#000000",
        fontSize: 10
    }, chars);
    (0, $hnGDn.BitmapFont).from("ChatBubbleFont", {
        fill: "#FFFFFF",
        fontSize: 15
    }, chars);
    (0, $hnGDn.BitmapFont).from("BlinkFont", {
        fill: "#00FF00",
        fontSize: 10,
        fontWeight: "bold"
    }, chars);
    (0, $hnGDn.BitmapFont).from("ChatHistoryFont", {
        fill: "#00FF00",
        fontSize: 10
    }, chars);
    (0, $hnGDn.BitmapFont).from("LeaderboardFont", {
        fill: "#00FF00",
        fontSize: 15
    }, chars);
    (0, $hnGDn.BitmapFont).from("LeaderboardLeaderFont", {
        fill: "#FFFFFF",
        fontSize: 15
    }, chars);
    (0, $hnGDn.BitmapFont).from("HpFont", {
        fill: "#FFFFFF",
        fontSize: 12,
        fontWeight: "bold"
    }, chars);
    (0, $hnGDn.BitmapFont).from("IdFont", {
        fill: "#00FF00",
        fontSize: 12,
        fontWeight: "bold"
    }, chars);
    (0, $hnGDn.BitmapFont).from("Normal-Green-Bold", {
        fill: "#00FF00",
        fontSize: 15,
        fontWeight: "bold"
    }, chars);
    (0, $hnGDn.BitmapFont).from("TinyFont", {
        fill: "#FFFFFF",
        fontSize: 9
    }, chars);
    //
    // audio
    //
    (0, $479d799412e4e1cb$export$153755f98d9861de).loadAssets();
    (0, $kXE1p.Loader).shared.add("hit1", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/strike1.ogg")).add("hit2", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/strike2.ogg")).add("woodhit", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/woodhit.ogg")).add("bowshot", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/shoot.ogg")).add("swordswing", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/swordswing.ogg")).add("explosion", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/explosion.mp3")).add("emp", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/emp.mp3")).add("health", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/health.mp3")).add("mana", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/mana.mp3")).add("door_open", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/door_open.ogg")).add("door_close", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/door_close.ogg")).add("clocktick", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/clocktick.mp3")).add("powerup", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/powerup.mp3")).add("map_location", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/map_location.ogg")).add("click", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/click.mp3")).add("coins", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/coin3.ogg")).add("cloth", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/cloth.ogg"))// procedurally synthesized (packages/tools/src/sfx/gen.py)
    .add("campfire_lit", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/campfire_lit.ogg")).add("campfire_fed", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/campfire_fed.ogg")).add("wheel_select", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/wheel_select.ogg")).add("item_crafted", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/item_crafted.ogg")).add("wave_starting", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/wave_starting.ogg")).add("visitor_arrives", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/visitor_arrives.ogg")).add("chapter_task_complete", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/chapter_task_complete.ogg")).add("chapter_task_stamp", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/chapter_task_stamp.ogg")).add("chapter_complete", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/chapter_complete.ogg")).add("chapter_announce", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/chapter_announce.ogg")).add("chapter_begin", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/chapter_begin.ogg")).add("bonecaller_chant", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/bonecaller_chant.ogg")).add("bonecaller_complete", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/bonecaller_complete.ogg")).add("bonecaller_spike_windup", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/bonecaller_spike_windup.ogg")).add("bonecaller_spike_impact", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/bonecaller_spike_impact.ogg")).add("bonecaller_sweep_windup", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/bonecaller_sweep_windup.ogg")).add("bonecaller_sweep_impact", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/bonecaller_sweep_impact.ogg")).add("ember_core_charge", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/ember_core_charge.ogg")).add("ember_core_ready", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/ember_core_ready.ogg")).add("ember_core_fire", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/ember_core_fire.ogg")).add("ember_core_fuse", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/ember_core_fuse.ogg")).add("ember_core_blast", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/ember_core_blast.ogg")).add("ground_rupture", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/ground_rupture.ogg")).add("build_printed", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/build_printed.ogg")).add("tree_creak", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/tree_creak.ogg")).add("tree_fall", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/tree_fall.ogg"));
    //
    // image
    //
    (0, $49ede8eb593e752a$export$c51a3547a8532e0a).forEach((sheet)=>(0, $kXE1p.Loader).shared.add(sheet.id, (0, $e5c675b7b9585b42$export$bab18279d67f8654)(`assets/${sheet.file}`)));
    (0, $kXE1p.Loader).shared.add("outer", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/joystick.png")).add("inner", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/joystick-handle.png")).add("reddit", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/reddit.png")).add("discord", (0, $e5c675b7b9585b42$export$bab18279d67f8654)("assets/discord.png"));
};


//# sourceMappingURL=client.33f319b1.js.map
